
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a5QWz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $7TttC = parcelRequire("7TttC");

var $l0ddg = parcelRequire("l0ddg");

var $8jfNV = parcelRequire("8jfNV");

var $ggwr4 = parcelRequire("ggwr4");

var $4wZ5i = parcelRequire("4wZ5i");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $eW0HJ = parcelRequire("eW0HJ");

var $aWM4F = parcelRequire("aWM4F");

var $fF4EW = parcelRequire("fF4EW");

var $d5m2U = parcelRequire("d5m2U");

var $hg4dc = parcelRequire("hg4dc");

var $6zIGl = parcelRequire("6zIGl");

var $8Uw8o = parcelRequire("8Uw8o");

var $lCPaR = parcelRequire("lCPaR");

var $d2jrf = parcelRequire("d2jrf");

var $hNvWr = parcelRequire("hNvWr");

var $iNc9K = parcelRequire("iNc9K");

var $dLES3 = parcelRequire("dLES3");

var $l5e6x = parcelRequire("l5e6x");

var $6kYtN = parcelRequire("6kYtN");

var $jJZWw = parcelRequire("jJZWw");

var $03xMg = parcelRequire("03xMg");

var $ddH6b = parcelRequire("ddH6b");

var $8m70V = parcelRequire("8m70V");

var $4Gc3h = parcelRequire("4Gc3h");

var $eniUo = parcelRequire("eniUo");

var $52f7V = parcelRequire("52f7V");

var $dHcrw = parcelRequire("dHcrw");

var $3pD3m = parcelRequire("3pD3m");

var $UogL4 = parcelRequire("UogL4");

var $5AcnF = parcelRequire("5AcnF");

var $lbXYN = parcelRequire("lbXYN");

var $kdqC7 = parcelRequire("kdqC7");

var $6tBvR = parcelRequire("6tBvR");

var $1zgsW = parcelRequire("1zgsW");

var $bxbWK = parcelRequire("bxbWK");

var $hLiMU = parcelRequire("hLiMU");

var $5PM5M = parcelRequire("5PM5M");

var $9SSMG = parcelRequire("9SSMG");

var $aCPEz = parcelRequire("aCPEz");

var $inXyb = parcelRequire("inXyb");

var $jdkFc = parcelRequire("jdkFc");

var $h7UoA = parcelRequire("h7UoA");

var $akVip = parcelRequire("akVip");

var $kBM5C = parcelRequire("kBM5C");

var $kN396 = parcelRequire("kN396");

var $a0JtR = parcelRequire("a0JtR");

var $4RIOF = parcelRequire("4RIOF");

var $hF3Re = parcelRequire("hF3Re");

var $jd6mp = parcelRequire("jd6mp");

var $eHXQV = parcelRequire("eHXQV");

var $jO72z = parcelRequire("jO72z");

var $25ylb = parcelRequire("25ylb");

var $04woM = parcelRequire("04woM");

var $8zXdM = parcelRequire("8zXdM");

var $8Z10R = parcelRequire("8Z10R");

var $lG6QY = parcelRequire("lG6QY");

var $kCVtg = parcelRequire("kCVtg");

var $43yhn = parcelRequire("43yhn");

var $7iBjq = parcelRequire("7iBjq");

var $8OGyf = parcelRequire("8OGyf");

var $3EGPi = parcelRequire("3EGPi");

var $1v9is = parcelRequire("1v9is");

var $aHLYS = parcelRequire("aHLYS");

var $7lJq4 = parcelRequire("7lJq4");

var $lCfgA = parcelRequire("lCfgA");

var $73Ve8 = parcelRequire("73Ve8");

var $eSLF5 = parcelRequire("eSLF5");

var $4bIxO = parcelRequire("4bIxO");

var $3c27b = parcelRequire("3c27b");

var $bfPAU = parcelRequire("bfPAU");

var $eaC9u = parcelRequire("eaC9u");

var $a3J7x = parcelRequire("a3J7x");

var $72p9e = parcelRequire("72p9e");

var $5WVIL = parcelRequire("5WVIL");

var $3GDsH = parcelRequire("3GDsH");

var $3STJz = parcelRequire("3STJz");

var $bw8wJ = parcelRequire("bw8wJ");

var $4ifN0 = parcelRequire("4ifN0");

var $h5a7p = parcelRequire("h5a7p");

var $968E2 = parcelRequire("968E2");

var $4JtJf = parcelRequire("4JtJf");

var $eQHTM = parcelRequire("eQHTM");

var $9RLPP = parcelRequire("9RLPP");

var $cnvYh = parcelRequire("cnvYh");

var $j4neB = parcelRequire("j4neB");

var $9joMN = parcelRequire("9joMN");

var $jeBe6 = parcelRequire("jeBe6");

var $gWkTG = parcelRequire("gWkTG");

var $eAHZf = parcelRequire("eAHZf");

var $bXRjt = parcelRequire("bXRjt");

var $fvCsr = parcelRequire("fvCsr");

var $euvlx = parcelRequire("euvlx");

var $ci6Zc = parcelRequire("ci6Zc");

var $aLxtR = parcelRequire("aLxtR");

var $8fsk0 = parcelRequire("8fsk0");

var $4h0Wd = parcelRequire("4h0Wd");

var $hO292 = parcelRequire("hO292");

var $azG5N = parcelRequire("azG5N");

var $5xpfH = parcelRequire("5xpfH");

var $gCzmC = parcelRequire("gCzmC");

var $1chIH = parcelRequire("1chIH");

var $ds9Ga = parcelRequire("ds9Ga");

var $PzGU3 = parcelRequire("PzGU3");

var $i3Ttl = parcelRequire("i3Ttl");

var $dpKhO = parcelRequire("dpKhO");

var $9z62o = parcelRequire("9z62o");

var $3iQ48 = parcelRequire("3iQ48");

var $bCreQ = parcelRequire("bCreQ");

var $iCGkd = parcelRequire("iCGkd");

var $idZsJ = parcelRequire("idZsJ");

var $bKfNN = parcelRequire("bKfNN");

var $8IBSt = parcelRequire("8IBSt");

var $6UPME = parcelRequire("6UPME");

var $geSGs = parcelRequire("geSGs");

var $aGtZ5 = parcelRequire("aGtZ5");

var $9jmDw = parcelRequire("9jmDw");

var $8wj7Q = parcelRequire("8wj7Q");

var $f46vO = parcelRequire("f46vO");

var $f2suz = parcelRequire("f2suz");

var $8OzMM = parcelRequire("8OzMM");

var $6qbZr = parcelRequire("6qbZr");

var $1CyzH = parcelRequire("1CyzH");

var $cp5Oe = parcelRequire("cp5Oe");

var $3cta3 = parcelRequire("3cta3");

var $jMnxI = parcelRequire("jMnxI");

var $1nDVq = parcelRequire("1nDVq");

var $gy40E = parcelRequire("gy40E");

var $fLPEN = parcelRequire("fLPEN");

var $4U9Ev = parcelRequire("4U9Ev");

var $3nbIj = parcelRequire("3nbIj");

var $lviux = parcelRequire("lviux");

var $bX9aB = parcelRequire("bX9aB");

var $81uv9 = parcelRequire("81uv9");

var $ifwPb = parcelRequire("ifwPb");

var $8PEgQ = parcelRequire("8PEgQ");

var $amQOz = parcelRequire("amQOz");

var $aEqP9 = parcelRequire("aEqP9");
module.exports.registerSpanErrorInstrumentation = $7TttC.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $l0ddg.getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $l0ddg.setCapturedScopesOnSpan;
module.exports.TRACING_DEFAULTS = $8jfNV.TRACING_DEFAULTS;
module.exports.startIdleSpan = $8jfNV.startIdleSpan;
module.exports.SentrySpan = $ggwr4.SentrySpan;
module.exports.SentryNonRecordingSpan = $4wZ5i.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $9BaVX.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $9BaVX.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $9BaVX.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $9BaVX.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $9BaVX.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $92XmH.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $92XmH.continueTrace;
module.exports.startInactiveSpan = $92XmH.startInactiveSpan;
module.exports.startNewTrace = $92XmH.startNewTrace;
module.exports.startSpan = $92XmH.startSpan;
module.exports.startSpanManual = $92XmH.startSpanManual;
module.exports.suppressTracing = $92XmH.suppressTracing;
module.exports.withActiveSpan = $92XmH.withActiveSpan;
module.exports.getDynamicSamplingContextFromClient = $eW0HJ.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $eW0HJ.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $eW0HJ.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $eW0HJ.spanToBaggageHeader;
module.exports.setMeasurement = $aWM4F.setMeasurement;
module.exports.timedEventsToMeasurements = $aWM4F.timedEventsToMeasurements;
module.exports.sampleSpan = $fF4EW.sampleSpan;
module.exports.logSpanEnd = $d5m2U.logSpanEnd;
module.exports.logSpanStart = $d5m2U.logSpanStart;
module.exports.captureSpan = $hg4dc.captureSpan;
module.exports.safeSetSpanJSONAttributes = $hg4dc.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $6zIGl.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $6zIGl.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $6zIGl.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $6zIGl.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $6zIGl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $6zIGl.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $6zIGl.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $6zIGl.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $6zIGl.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $6zIGl.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $6zIGl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $6zIGl.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $6zIGl.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $8Uw8o.createEventEnvelope;
module.exports.createSessionEnvelope = $8Uw8o.createSessionEnvelope;
module.exports.createSpanEnvelope = $8Uw8o.createSpanEnvelope;
module.exports.addEventProcessor = $lCPaR.addEventProcessor;
module.exports.captureCheckIn = $lCPaR.captureCheckIn;
module.exports.captureEvent = $lCPaR.captureEvent;
module.exports.captureException = $lCPaR.captureException;
module.exports.captureMessage = $lCPaR.captureMessage;
module.exports.captureSession = $lCPaR.captureSession;
module.exports.close = $lCPaR.close;
module.exports.endSession = $lCPaR.endSession;
module.exports.flush = $lCPaR.flush;
module.exports.isEnabled = $lCPaR.isEnabled;
module.exports.isInitialized = $lCPaR.isInitialized;
module.exports.lastEventId = $lCPaR.lastEventId;
module.exports.setContext = $lCPaR.setContext;
module.exports.setConversationId = $lCPaR.setConversationId;
module.exports.setExtra = $lCPaR.setExtra;
module.exports.setExtras = $lCPaR.setExtras;
module.exports.setTag = $lCPaR.setTag;
module.exports.setTags = $lCPaR.setTags;
module.exports.setUser = $lCPaR.setUser;
module.exports.startSession = $lCPaR.startSession;
module.exports.withMonitor = $lCPaR.withMonitor;
module.exports.getClient = $d2jrf.getClient;
module.exports.getCurrentScope = $d2jrf.getCurrentScope;
module.exports.getExternalPropagationContext = $d2jrf.getExternalPropagationContext;
module.exports.getGlobalScope = $d2jrf.getGlobalScope;
module.exports.getIsolationScope = $d2jrf.getIsolationScope;
module.exports.getTraceContextFromScope = $d2jrf.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $d2jrf.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $d2jrf.registerExternalPropagationContext;
module.exports.withIsolationScope = $d2jrf.withIsolationScope;
module.exports.withScope = $d2jrf.withScope;
module.exports.getDefaultCurrentScope = $hNvWr.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $hNvWr.getDefaultIsolationScope;
module.exports.setAsyncContextStrategy = $iNc9K.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $dLES3.getGlobalSingleton;
module.exports.getMainCarrier = $dLES3.getMainCarrier;
module.exports.closeSession = $l5e6x.closeSession;
module.exports.makeSession = $l5e6x.makeSession;
module.exports.updateSession = $l5e6x.updateSession;
module.exports.Scope = $6kYtN.Scope;
module.exports.notifyEventProcessors = $jJZWw.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $03xMg.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $03xMg.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $03xMg.getReportDialogEndpoint;
module.exports.Client = $ddH6b.Client;
module.exports.initAndBind = $8m70V.initAndBind;
module.exports.setCurrentClient = $8m70V.setCurrentClient;
module.exports.createTransport = $4Gc3h.createTransport;
module.exports.makeOfflineTransport = $eniUo.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $52f7V.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $52f7V.makeMultiplexedTransport;
module.exports.addIntegration = $dHcrw.addIntegration;
module.exports.defineIntegration = $dHcrw.defineIntegration;
module.exports.getIntegrationsToSetup = $dHcrw.getIntegrationsToSetup;
module.exports.installedIntegrations = $dHcrw.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $3pD3m._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $3pD3m._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $3pD3m._INTERNAL_skipAiProviderWrapping;
module.exports.envToBool = $UogL4.envToBool;
module.exports.applyScopeDataToEvent = $5AcnF.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $5AcnF.getCombinedScopeData;
module.exports.mergeScopeData = $5AcnF.mergeScopeData;
module.exports.prepareEvent = $lbXYN.prepareEvent;
module.exports.createCheckInEnvelope = $kdqC7.createCheckInEnvelope;
module.exports.hasSpansEnabled = $6tBvR.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $1zgsW.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $1zgsW.withStreamedSpan;
module.exports.isSentryRequestUrl = $bxbWK.isSentryRequestUrl;
module.exports.handleCallbackErrors = $hLiMU.handleCallbackErrors;
module.exports.fmt = $5PM5M.fmt;
module.exports.parameterize = $5PM5M.parameterize;
module.exports.handleTunnelRequest = $9SSMG.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $aCPEz.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $aCPEz.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $inXyb.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $inXyb.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $inXyb.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $inXyb.getActiveSpan;
module.exports.getRootSpan = $inXyb.getRootSpan;
module.exports.getSpanDescendants = $inXyb.getSpanDescendants;
module.exports.getStatusMessage = $inXyb.getStatusMessage;
module.exports.spanIsSampled = $inXyb.spanIsSampled;
module.exports.spanTimeInputToSeconds = $inXyb.spanTimeInputToSeconds;
module.exports.spanToJSON = $inXyb.spanToJSON;
module.exports.spanToStreamedSpanJSON = $inXyb.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $inXyb.spanToTraceContext;
module.exports.spanToTraceHeader = $inXyb.spanToTraceHeader;
module.exports.updateSpanName = $inXyb.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $jdkFc._setSpanForScope;
module.exports.parseSampleRate = $h7UoA.parseSampleRate;
module.exports.applySdkMetadata = $akVip.applySdkMetadata;
module.exports.getTraceData = $kBM5C.getTraceData;
module.exports.shouldPropagateTraceForUrl = $kN396.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $a0JtR.getTraceMetaTags;
module.exports.debounce = $4RIOF.debounce;
module.exports.derefWeakRef = $hF3Re.derefWeakRef;
module.exports.makeWeakRef = $hF3Re.makeWeakRef;
module.exports.shouldIgnoreSpan = $jd6mp.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $eHXQV.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $eHXQV.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $eHXQV.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $eHXQV.getMaxBodyByteLength;
module.exports.headersToDict = $eHXQV.headersToDict;
module.exports.httpHeadersToSpanAttributes = $eHXQV.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $eHXQV.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $eHXQV.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $eHXQV.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $jO72z.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $jO72z.DEV_ENVIRONMENT;
module.exports.addBreadcrumb = $25ylb.addBreadcrumb;
module.exports.functionToStringIntegration = $04woM.functionToStringIntegration;
module.exports.eventFiltersIntegration = $8zXdM.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $8zXdM.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $8Z10R.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $lG6QY.moduleMetadataIntegration;
module.exports.requestDataIntegration = $kCVtg.requestDataIntegration;
module.exports.captureConsoleIntegration = $43yhn.captureConsoleIntegration;
module.exports.dedupeIntegration = $7iBjq.dedupeIntegration;
module.exports.extraErrorDataIntegration = $8OGyf.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $3EGPi.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $1v9is.instrumentSupabaseClient;
module.exports.supabaseIntegration = $1v9is.supabaseIntegration;
module.exports.zodErrorsIntegration = $aHLYS.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $7lJq4.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $lCfgA.consoleIntegration;
module.exports.featureFlagsIntegration = $73Ve8.featureFlagsIntegration;
module.exports.growthbookIntegration = $eSLF5.growthbookIntegration;
module.exports.conversationIdIntegration = $4bIxO.conversationIdIntegration;
module.exports.profiler = $3c27b.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $bfPAU._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $bfPAU.instrumentFetchRequest;
module.exports.captureFeedback = $eaC9u.captureFeedback;
module.exports._INTERNAL_captureLog = $a3J7x._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $a3J7x._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $a3J7x._INTERNAL_flushLogsBuffer;
module.exports.logger = $72p9e;
module.exports.consoleLoggingIntegration = $5WVIL.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $3GDsH._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $3GDsH._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $3GDsH._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $3STJz;
module.exports.createConsolaReporter = $bw8wJ.createConsolaReporter;
module.exports.addVercelAiProcessors = $4ifN0.addVercelAiProcessors;
module.exports._INTERNAL_cleanupToolCallSpanContext = $h5a7p._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $h5a7p._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $968E2.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $4JtJf.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $eQHTM.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $9RLPP.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $cnvYh.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $j4neB.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $9joMN.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $jeBe6.createLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $gWkTG.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $eAHZf.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $eAHZf.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $eAHZf.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $bXRjt.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $fvCsr.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $euvlx.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $ci6Zc.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $aLxtR._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $aLxtR._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $aLxtR._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $aLxtR._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $aLxtR._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $8fsk0.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $4h0Wd.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $hO292.dsnFromString;
module.exports.dsnToString = $hO292.dsnToString;
module.exports.makeDsn = $hO292.makeDsn;
module.exports.SentryError = $azG5N.SentryError;
module.exports.GLOBAL_OBJ = $5xpfH.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $gCzmC.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $gCzmC.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $1chIH.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $1chIH.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $ds9Ga.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $PzGU3.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $i3Ttl.addHandler;
module.exports.maybeInstrument = $i3Ttl.maybeInstrument;
module.exports.resetInstrumentationHandlers = $i3Ttl.resetInstrumentationHandlers;
module.exports.triggerHandlers = $i3Ttl.triggerHandlers;
module.exports.isDOMError = $dpKhO.isDOMError;
module.exports.isDOMException = $dpKhO.isDOMException;
module.exports.isElement = $dpKhO.isElement;
module.exports.isError = $dpKhO.isError;
module.exports.isErrorEvent = $dpKhO.isErrorEvent;
module.exports.isEvent = $dpKhO.isEvent;
module.exports.isInstanceOf = $dpKhO.isInstanceOf;
module.exports.isParameterizedString = $dpKhO.isParameterizedString;
module.exports.isPlainObject = $dpKhO.isPlainObject;
module.exports.isPrimitive = $dpKhO.isPrimitive;
module.exports.isRegExp = $dpKhO.isRegExp;
module.exports.isString = $dpKhO.isString;
module.exports.isSyntheticEvent = $dpKhO.isSyntheticEvent;
module.exports.isThenable = $dpKhO.isThenable;
module.exports.isVueViewModel = $dpKhO.isVueViewModel;
module.exports.isBrowser = $9z62o.isBrowser;
module.exports.CONSOLE_LEVELS = $3iQ48.CONSOLE_LEVELS;
module.exports.consoleSandbox = $3iQ48.consoleSandbox;
module.exports.debug = $3iQ48.debug;
module.exports.originalConsoleMethods = $3iQ48.originalConsoleMethods;
module.exports.addContextToFrame = $bCreQ.addContextToFrame;
module.exports.addExceptionMechanism = $bCreQ.addExceptionMechanism;
module.exports.addExceptionTypeValue = $bCreQ.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $bCreQ.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $bCreQ.getEventDescription;
module.exports.isAlreadyCaptured = $bCreQ.isAlreadyCaptured;
module.exports.parseSemver = $bCreQ.parseSemver;
module.exports.uuid4 = $bCreQ.uuid4;
module.exports.normalize = $iCGkd.normalize;
module.exports.normalizeToSize = $iCGkd.normalizeToSize;
module.exports.normalizeUrlToBase = $iCGkd.normalizeUrlToBase;
module.exports.setNormalizationDepthOverrideHint = $idZsJ.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $idZsJ.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $bKfNN.addNonEnumerableProperty;
module.exports.convertToPlainObject = $bKfNN.convertToPlainObject;
module.exports.dropUndefinedKeys = $bKfNN.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $bKfNN.extractExceptionKeysForMessage;
module.exports.fill = $bKfNN.fill;
module.exports.getOriginalFunction = $bKfNN.getOriginalFunction;
module.exports.markFunctionWrapped = $bKfNN.markFunctionWrapped;
module.exports.objectify = $bKfNN.objectify;
module.exports.basename = $8IBSt.basename;
module.exports.dirname = $8IBSt.dirname;
module.exports.isAbsolute = $8IBSt.isAbsolute;
module.exports.join = $8IBSt.join;
module.exports.normalizePath = $8IBSt.normalizePath;
module.exports.relative = $8IBSt.relative;
module.exports.resolve = $8IBSt.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $6UPME.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $6UPME.makePromiseBuffer;
module.exports.severityLevelFromString = $geSGs.severityLevelFromString;
module.exports.replaceExports = $aGtZ5.replaceExports;
module.exports.UNKNOWN_FUNCTION = $9jmDw.UNKNOWN_FUNCTION;
module.exports.createStackParser = $9jmDw.createStackParser;
module.exports.getFramesFromEvent = $9jmDw.getFramesFromEvent;
module.exports.getFunctionName = $9jmDw.getFunctionName;
module.exports.stackParserFromStackParserOptions = $9jmDw.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $9jmDw.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $8wj7Q.isMatchingPattern;
module.exports.safeJoin = $8wj7Q.safeJoin;
module.exports.snipLine = $8wj7Q.snipLine;
module.exports.stringMatchesSomePattern = $8wj7Q.stringMatchesSomePattern;
module.exports.truncate = $8wj7Q.truncate;
module.exports.isNativeFunction = $f46vO.isNativeFunction;
module.exports.supportsDOMError = $f46vO.supportsDOMError;
module.exports.supportsDOMException = $f46vO.supportsDOMException;
module.exports.supportsErrorEvent = $f46vO.supportsErrorEvent;
module.exports.supportsFetch = $f46vO.supportsFetch;
module.exports.supportsHistory = $f46vO.supportsHistory;
module.exports.supportsNativeFetch = $f46vO.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $f46vO.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $f46vO.supportsReportingObserver;
module.exports.SyncPromise = $f2suz.SyncPromise;
module.exports.rejectedSyncPromise = $f2suz.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $f2suz.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $8OzMM.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $8OzMM.dateTimestampInSeconds;
module.exports.timestampInSeconds = $8OzMM.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $6qbZr.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $6qbZr.extractTraceparentData;
module.exports.generateSentryTraceHeader = $6qbZr.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $6qbZr.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $6qbZr.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $6qbZr.shouldContinueTrace;
module.exports.getSDKSource = $1CyzH.getSDKSource;
module.exports.isBrowserBundle = $1CyzH.isBrowserBundle;
module.exports.addItemToEnvelope = $cp5Oe.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $cp5Oe.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $cp5Oe.createEnvelope;
module.exports.createEventEnvelopeHeaders = $cp5Oe.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $cp5Oe.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $cp5Oe.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $cp5Oe.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $cp5Oe.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $cp5Oe.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $cp5Oe.parseEnvelope;
module.exports.serializeEnvelope = $cp5Oe.serializeEnvelope;
module.exports.createClientReportEnvelope = $3cta3.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $jMnxI.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $jMnxI.disabledUntil;
module.exports.isRateLimited = $jMnxI.isRateLimited;
module.exports.parseRetryAfterHeader = $jMnxI.parseRetryAfterHeader;
module.exports.updateRateLimits = $jMnxI.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $1nDVq.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $1nDVq.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $1nDVq.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $1nDVq.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $1nDVq.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $1nDVq.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $1nDVq.objectToBaggageHeader;
module.exports.parseBaggageHeader = $1nDVq.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $gy40E.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $gy40E.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $gy40E.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $gy40E.isURLObjectRelative;
module.exports.parseStringToURLObject = $gy40E.parseStringToURLObject;
module.exports.parseUrl = $gy40E.parseUrl;
module.exports.stripDataUrlContent = $gy40E.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $gy40E.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $fLPEN._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $fLPEN.eventFromMessage;
module.exports.eventFromUnknownInput = $fLPEN.eventFromUnknownInput;
module.exports.exceptionFromError = $fLPEN.exceptionFromError;
module.exports.parseStackFrames = $fLPEN.parseStackFrames;
module.exports.LRUMap = $4U9Ev.LRUMap;
module.exports.generateSpanId = $3nbIj.generateSpanId;
module.exports.generateTraceId = $3nbIj.generateTraceId;
module.exports.SDK_VERSION = $lviux.SDK_VERSION;
module.exports.getDebugImagesForResources = $bX9aB.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $bX9aB.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $81uv9.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $ifwPb.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $8PEgQ.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $8PEgQ.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $8PEgQ.withRandomSafeContext;
module.exports.getComponentName = $amQOz.getComponentName;
module.exports.getLocationHref = $amQOz.getLocationHref;
module.exports.htmlTreeAsString = $amQOz.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $aEqP9.instrumentLangChainEmbeddings;

});
parcelRegister("7TttC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $ds9Ga = parcelRequire("ds9Ga");

var $PzGU3 = parcelRequire("PzGU3");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");

var $9BaVX = parcelRequire("9BaVX");
let $5bf488ebab83dc08$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $5bf488ebab83dc08$var$registerSpanErrorInstrumentation() {
    if ($5bf488ebab83dc08$var$errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = $inXyb.getActiveSpan();
        const rootSpan = activeSpan && $inXyb.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = 'internal_error';
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $9BaVX.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    $5bf488ebab83dc08$var$errorsInstrumented = true;
    $ds9Ga.addGlobalErrorInstrumentationHandler(errorCallback);
    $PzGU3.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $5bf488ebab83dc08$var$registerSpanErrorInstrumentation;

});
parcelRegister("9XOi0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $01df3c6bfdc2ec68$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $01df3c6bfdc2ec68$var$DEBUG_BUILD;

});

parcelRegister("ds9Ga", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xpfH = parcelRequire("5xpfH");

var $i3Ttl = parcelRequire("i3Ttl");
let $9cb565f625acd389$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9cb565f625acd389$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = 'error';
    $i3Ttl.addHandler(type, handler);
    $i3Ttl.maybeInstrument(type, $9cb565f625acd389$var$instrumentError);
}
function $9cb565f625acd389$var$instrumentError() {
    $9cb565f625acd389$var$_oldOnErrorHandler = $5xpfH.GLOBAL_OBJ.onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    $5xpfH.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $i3Ttl.triggerHandlers('error', handlerData);
        if ($9cb565f625acd389$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $9cb565f625acd389$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $5xpfH.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $9cb565f625acd389$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("5xpfH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $40839f648c61cf5e$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $40839f648c61cf5e$var$GLOBAL_OBJ;

});

parcelRegister("i3Ttl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $9jmDw = parcelRequire("9jmDw");
// We keep the handlers globally
const $d263896d120f0ff0$var$handlers = {};
const $d263896d120f0ff0$var$instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function $d263896d120f0ff0$var$addHandler(type, handler) {
    $d263896d120f0ff0$var$handlers[type] = $d263896d120f0ff0$var$handlers[type] || [];
    $d263896d120f0ff0$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $d263896d120f0ff0$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $d263896d120f0ff0$var$resetInstrumentationHandlers() {
    Object.keys($d263896d120f0ff0$var$handlers).forEach((key)=>{
        $d263896d120f0ff0$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $d263896d120f0ff0$var$maybeInstrument(type, instrumentFn) {
    if (!$d263896d120f0ff0$var$instrumented[type]) {
        $d263896d120f0ff0$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $d263896d120f0ff0$var$triggerHandlers(type, data) {
    const typeHandlers = type && $d263896d120f0ff0$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${$9jmDw.getFunctionName(handler)}\nError:`, e);
    }
}
module.exports.addHandler = $d263896d120f0ff0$var$addHandler;
module.exports.maybeInstrument = $d263896d120f0ff0$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $d263896d120f0ff0$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $d263896d120f0ff0$var$triggerHandlers;

});
parcelRegister("3iQ48", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dLES3 = parcelRequire("dLES3");

var $9XOi0 = parcelRequire("9XOi0");

var $5xpfH = parcelRequire("5xpfH");
const $267b70ae351528de$var$CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $267b70ae351528de$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $267b70ae351528de$var$originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $267b70ae351528de$var$consoleSandbox(callback) {
    if (!('console' in $5xpfH.GLOBAL_OBJ)) return callback();
    const console = $5xpfH.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($267b70ae351528de$var$originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $267b70ae351528de$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $267b70ae351528de$var$enable() {
    $267b70ae351528de$var$_getLoggerSettings().enabled = true;
}
function $267b70ae351528de$var$disable() {
    $267b70ae351528de$var$_getLoggerSettings().enabled = false;
}
function $267b70ae351528de$var$isEnabled() {
    return $267b70ae351528de$var$_getLoggerSettings().enabled;
}
function $267b70ae351528de$var$log(...args) {
    $267b70ae351528de$var$_maybeLog('log', ...args);
}
function $267b70ae351528de$var$warn(...args) {
    $267b70ae351528de$var$_maybeLog('warn', ...args);
}
function $267b70ae351528de$var$error(...args) {
    $267b70ae351528de$var$_maybeLog('error', ...args);
}
function $267b70ae351528de$var$_maybeLog(level, ...args) {
    if (!$9XOi0.DEBUG_BUILD) return;
    if ($267b70ae351528de$var$isEnabled()) $267b70ae351528de$var$consoleSandbox(()=>{
        $5xpfH.GLOBAL_OBJ.console[level](`${$267b70ae351528de$var$PREFIX}[${level}]:`, ...args);
    });
}
function $267b70ae351528de$var$_getLoggerSettings() {
    if (!$9XOi0.DEBUG_BUILD) return {
        enabled: false
    };
    return $dLES3.getGlobalSingleton('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $267b70ae351528de$var$debug = {
    enable: /** Enable logging. */ $267b70ae351528de$var$enable,
    disable: /** Disable logging. */ $267b70ae351528de$var$disable,
    isEnabled: /** Check if logging is enabled. */ $267b70ae351528de$var$isEnabled,
    log: /** Log a message. */ $267b70ae351528de$var$log,
    warn: /** Log a warning. */ $267b70ae351528de$var$warn,
    error: /** Log an error. */ $267b70ae351528de$var$error
};
module.exports.CONSOLE_LEVELS = $267b70ae351528de$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $267b70ae351528de$var$consoleSandbox;
module.exports.debug = $267b70ae351528de$var$debug;
module.exports.originalConsoleMethods = $267b70ae351528de$var$originalConsoleMethods;

});
parcelRegister("dLES3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lviux = parcelRequire("lviux");

var $5xpfH = parcelRequire("5xpfH");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $a05f5e45633bee6a$var$getMainCarrier() {
    // This ensures a Sentry carrier exists
    $a05f5e45633bee6a$var$getSentryCarrier($5xpfH.GLOBAL_OBJ);
    return $5xpfH.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $a05f5e45633bee6a$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || $lviux.SDK_VERSION;
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[$lviux.SDK_VERSION] = __SENTRY__[$lviux.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a05f5e45633bee6a$var$getGlobalSingleton(name, creator, obj = $5xpfH.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$lviux.SDK_VERSION] = __SENTRY__[$lviux.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $a05f5e45633bee6a$var$getGlobalSingleton;
module.exports.getMainCarrier = $a05f5e45633bee6a$var$getMainCarrier;
module.exports.getSentryCarrier = $a05f5e45633bee6a$var$getSentryCarrier;

});
parcelRegister("lviux", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// This is a magic string replaced by rollup
const $fa7ad649431c29ff$var$SDK_VERSION = "10.53.1";
module.exports.SDK_VERSION = $fa7ad649431c29ff$var$SDK_VERSION;

});



parcelRegister("9jmDw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6c77728a554d0dfa$var$STACKTRACE_FRAME_LIMIT = 50;
const $6c77728a554d0dfa$var$UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $6c77728a554d0dfa$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $6c77728a554d0dfa$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $6c77728a554d0dfa$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $6c77728a554d0dfa$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($6c77728a554d0dfa$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes('Error: ')) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $6c77728a554d0dfa$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $6c77728a554d0dfa$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $6c77728a554d0dfa$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $6c77728a554d0dfa$var$createStackParser(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $6c77728a554d0dfa$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($6c77728a554d0dfa$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($6c77728a554d0dfa$var$STRIP_FRAME_REGEXP.test($6c77728a554d0dfa$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($6c77728a554d0dfa$var$STRIP_FRAME_REGEXP.test($6c77728a554d0dfa$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $6c77728a554d0dfa$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $6c77728a554d0dfa$var$getLastStackFrame(localStack).filename,
            function: frame.function || $6c77728a554d0dfa$var$UNKNOWN_FUNCTION
        }));
}
function $6c77728a554d0dfa$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $6c77728a554d0dfa$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $6c77728a554d0dfa$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $6c77728a554d0dfa$var$defaultFunctionName;
        return fn.name || $6c77728a554d0dfa$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $6c77728a554d0dfa$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $6c77728a554d0dfa$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $6c77728a554d0dfa$var$getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $6c77728a554d0dfa$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $6c77728a554d0dfa$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $6c77728a554d0dfa$var$createStackParser;
module.exports.getFramesFromEvent = $6c77728a554d0dfa$var$getFramesFromEvent;
module.exports.getFunctionName = $6c77728a554d0dfa$var$getFunctionName;
module.exports.getVueInternalName = $6c77728a554d0dfa$var$getVueInternalName;
module.exports.normalizeStackTracePath = $6c77728a554d0dfa$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $6c77728a554d0dfa$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $6c77728a554d0dfa$var$stripSentryFramesAndReverse;

});



parcelRegister("PzGU3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xpfH = parcelRequire("5xpfH");

var $i3Ttl = parcelRequire("i3Ttl");
let $09b07305788847eb$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $09b07305788847eb$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = 'unhandledrejection';
    $i3Ttl.addHandler(type, handler);
    $i3Ttl.maybeInstrument(type, $09b07305788847eb$var$instrumentUnhandledRejection);
}
function $09b07305788847eb$var$instrumentUnhandledRejection() {
    $09b07305788847eb$var$_oldOnUnhandledRejectionHandler = $5xpfH.GLOBAL_OBJ.onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    $5xpfH.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $i3Ttl.triggerHandlers('unhandledrejection', handlerData);
        if ($09b07305788847eb$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $09b07305788847eb$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $5xpfH.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $09b07305788847eb$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("inXyb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iNc9K = parcelRequire("iNc9K");

var $bcKiE = parcelRequire("bcKiE");

var $dLES3 = parcelRequire("dLES3");

var $d2jrf = parcelRequire("d2jrf");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $l0ddg = parcelRequire("l0ddg");

var $bKfNN = parcelRequire("bKfNN");

var $3nbIj = parcelRequire("3nbIj");

var $8OzMM = parcelRequire("8OzMM");

var $6qbZr = parcelRequire("6qbZr");

var $3iQ48 = parcelRequire("3iQ48");

var $jdkFc = parcelRequire("jdkFc");
// These are aligned with OpenTelemetry trace flags
const $d62891731242682b$var$TRACE_FLAG_NONE = 0x0;
const $d62891731242682b$var$TRACE_FLAG_SAMPLED = 0x1;
let $d62891731242682b$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $d62891731242682b$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $d62891731242682b$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $d62891731242682b$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $d62891731242682b$var$spanToJSON(span).parent_span_id;
    const scope = $l0ddg.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $3nbIj.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $d62891731242682b$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d62891731242682b$var$spanIsSampled(span);
    return $6qbZr.generateSentryTraceHeader(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $d62891731242682b$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d62891731242682b$var$spanIsSampled(span);
    return $6qbZr.generateTraceparentHeader(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $d62891731242682b$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d62891731242682b$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $d62891731242682b$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d62891731242682b$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $d62891731242682b$var$spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return $d62891731242682b$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d62891731242682b$var$ensureTimestampInSeconds(input.getTime());
    return $8OzMM.timestampInSeconds();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $d62891731242682b$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $d62891731242682b$var$spanToJSON(span) {
    if ($d62891731242682b$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($d62891731242682b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $d62891731242682b$var$getOtelParentSpanId(span),
            start_timestamp: $d62891731242682b$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $d62891731242682b$var$spanTimeInputToSeconds(endTime) || undefined,
            status: $d62891731242682b$var$getStatusMessage(status),
            op: attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $d62891731242682b$var$convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function $d62891731242682b$var$spanToStreamedSpanJSON(span) {
    if ($d62891731242682b$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($d62891731242682b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $d62891731242682b$var$getOtelParentSpanId(span),
            start_timestamp: $d62891731242682b$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $d62891731242682b$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $d62891731242682b$var$INTERNAL_getSegmentSpan(span),
            status: $d62891731242682b$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $d62891731242682b$var$getStreamedSpanLinks(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: '',
        end_timestamp: 0,
        status: 'ok',
        is_segment: span === $d62891731242682b$var$INTERNAL_getSegmentSpan(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function $d62891731242682b$var$getOtelParentSpanId(span) {
    return 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function $d62891731242682b$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $bcKiE.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $bcKiE.serializeAttributes(link.attributes)
            }))
    };
}
function $d62891731242682b$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $d62891731242682b$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $d62891731242682b$var$spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d62891731242682b$var$TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function $d62891731242682b$var$getStatusMessage(status) {
    if (!status || status.code === $9BaVX.SPAN_STATUS_UNSET) return undefined;
    if (status.code === $9BaVX.SPAN_STATUS_OK) return 'ok';
    return status.message || 'internal_error';
}
/**
 * Convert the various statuses to the simple ones expected by Sentry for streamed spans ('ok' is default).
 */ function $d62891731242682b$var$getSimpleStatusMessage(status) {
    return !status || status.code === $9BaVX.SPAN_STATUS_OK || status.code === $9BaVX.SPAN_STATUS_UNSET || status.message === 'cancelled' ? 'ok' : 'error';
}
const $d62891731242682b$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $d62891731242682b$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $d62891731242682b$var$addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$d62891731242682b$var$ROOT_SPAN_FIELD] || span;
    $bKfNN.addNonEnumerableProperty(childSpan, $d62891731242682b$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$d62891731242682b$var$CHILD_SPANS_FIELD]) span[$d62891731242682b$var$CHILD_SPANS_FIELD].add(childSpan);
    else $bKfNN.addNonEnumerableProperty(span, $d62891731242682b$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $d62891731242682b$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$d62891731242682b$var$CHILD_SPANS_FIELD]) span[$d62891731242682b$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $d62891731242682b$var$getSpanDescendants(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($d62891731242682b$var$spanIsSampled(span)) {
            resultSet.add(span);
            const childSpans = span[$d62891731242682b$var$CHILD_SPANS_FIELD] ? Array.from(span[$d62891731242682b$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const $d62891731242682b$var$getRootSpan = $d62891731242682b$var$INTERNAL_getSegmentSpan;
/**
 * Returns the segment span of a given span.
 */ function $d62891731242682b$var$INTERNAL_getSegmentSpan(span) {
    return span[$d62891731242682b$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $d62891731242682b$var$getActiveSpan() {
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $jdkFc._getSpanForScope($d2jrf.getCurrentScope());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $d62891731242682b$var$showSpanDropWarning() {
    if (!$d62891731242682b$var$hasShownSpanDropWarning) {
        $3iQ48.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $d62891731242682b$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $d62891731242682b$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'custom',
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $d62891731242682b$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $d62891731242682b$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $d62891731242682b$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $d62891731242682b$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $d62891731242682b$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $d62891731242682b$var$getActiveSpan;
module.exports.getRootSpan = $d62891731242682b$var$getRootSpan;
module.exports.getSimpleStatusMessage = $d62891731242682b$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $d62891731242682b$var$getSpanDescendants;
module.exports.getStatusMessage = $d62891731242682b$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $d62891731242682b$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $d62891731242682b$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $d62891731242682b$var$showSpanDropWarning;
module.exports.spanIsSampled = $d62891731242682b$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $d62891731242682b$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $d62891731242682b$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $d62891731242682b$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $d62891731242682b$var$spanToTraceContext;
module.exports.spanToTraceHeader = $d62891731242682b$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $d62891731242682b$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $d62891731242682b$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $d62891731242682b$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $d62891731242682b$var$updateSpanName;

});
parcelRegister("iNc9K", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dLES3 = parcelRequire("dLES3");

var $kUec4 = parcelRequire("kUec4");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $dae63b9296169cb8$var$setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    const registry = $dLES3.getMainCarrier();
    const sentry = $dLES3.getSentryCarrier(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $dae63b9296169cb8$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $dLES3.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return $kUec4.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $dae63b9296169cb8$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $dae63b9296169cb8$var$setAsyncContextStrategy;

});
parcelRegister("kUec4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hNvWr = parcelRequire("hNvWr");

var $6kYtN = parcelRequire("6kYtN");

var $d5IBn = parcelRequire("d5IBn");

var $dpKhO = parcelRequire("dpKhO");

var $dLES3 = parcelRequire("dLES3");
/**
 * This is an object that holds a stack of scopes.
 */ class $f3840c2c8e3f2461$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $6kYtN.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $6kYtN.Scope();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($dpKhO.isThenable(maybePromiseResult)) return $d5IBn.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $f3840c2c8e3f2461$var$getAsyncContextStack() {
    const registry = $dLES3.getMainCarrier();
    const sentry = $dLES3.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $f3840c2c8e3f2461$var$AsyncContextStack($hNvWr.getDefaultCurrentScope(), $hNvWr.getDefaultIsolationScope());
}
function $f3840c2c8e3f2461$var$withScope(callback) {
    return $f3840c2c8e3f2461$var$getAsyncContextStack().withScope(callback);
}
function $f3840c2c8e3f2461$var$withSetScope(scope, callback) {
    const stack = $f3840c2c8e3f2461$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $f3840c2c8e3f2461$var$withIsolationScope(callback) {
    return $f3840c2c8e3f2461$var$getAsyncContextStack().withScope(()=>{
        return callback($f3840c2c8e3f2461$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $f3840c2c8e3f2461$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $f3840c2c8e3f2461$var$withIsolationScope,
        withScope: $f3840c2c8e3f2461$var$withScope,
        withSetScope: $f3840c2c8e3f2461$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $f3840c2c8e3f2461$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$f3840c2c8e3f2461$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$f3840c2c8e3f2461$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $f3840c2c8e3f2461$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $f3840c2c8e3f2461$var$getStackAsyncContextStrategy;

});
parcelRegister("hNvWr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dLES3 = parcelRequire("dLES3");

var $6kYtN = parcelRequire("6kYtN");
/** Get the default current scope. */ function $cf4fca34be8337d2$var$getDefaultCurrentScope() {
    return $dLES3.getGlobalSingleton('defaultCurrentScope', ()=>new $6kYtN.Scope());
}
/** Get the default isolation scope. */ function $cf4fca34be8337d2$var$getDefaultIsolationScope() {
    return $dLES3.getGlobalSingleton('defaultIsolationScope', ()=>new $6kYtN.Scope());
}
module.exports.getDefaultCurrentScope = $cf4fca34be8337d2$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $cf4fca34be8337d2$var$getDefaultIsolationScope;

});
parcelRegister("6kYtN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $l5e6x = parcelRequire("l5e6x");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");

var $agH01 = parcelRequire("agH01");

var $bCreQ = parcelRequire("bCreQ");

var $3nbIj = parcelRequire("3nbIj");

var $8PEgQ = parcelRequire("8PEgQ");

var $jdkFc = parcelRequire("jdkFc");

var $8wj7Q = parcelRequire("8wj7Q");

var $8OzMM = parcelRequire("8OzMM");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $49d38654a3d9c7aa$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $49d38654a3d9c7aa$var$Scope {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $3nbIj.generateTraceId(),
            sampleRand: $8PEgQ.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $49d38654a3d9c7aa$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $jdkFc._setSpanForScope(newScope, $jdkFc._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) $l5e6x.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $49d38654a3d9c7aa$var$Scope ? scopeToMerge.getScopeData() : $dpKhO.isPlainObject(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        $jdkFc._setSpanForScope(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $3nbIj.generateTraceId(),
            sampleRand: $8PEgQ.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $49d38654a3d9c7aa$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $8OzMM.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $8wj7Q.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $jdkFc._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $agH01.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $bCreQ.uuid4();
        if (!this._client) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $bCreQ.uuid4();
        if (!this._client) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $bCreQ.uuid4();
        if (!this._client) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $49d38654a3d9c7aa$var$Scope;

});
parcelRegister("l5e6x", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bCreQ = parcelRequire("bCreQ");

var $8OzMM = parcelRequire("8OzMM");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $f595017752f06e30$var$makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = $8OzMM.timestampInSeconds();
    const session = {
        sid: $bCreQ.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$f595017752f06e30$var$sessionToJSON(session)
    };
    if (context) $f595017752f06e30$var$updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $f595017752f06e30$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $8OzMM.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : $bCreQ.uuid4();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $f595017752f06e30$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $f595017752f06e30$var$updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $f595017752f06e30$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $f595017752f06e30$var$closeSession;
module.exports.makeSession = $f595017752f06e30$var$makeSession;
module.exports.updateSession = $f595017752f06e30$var$updateSession;

});
parcelRegister("bCreQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bKfNN = parcelRequire("bKfNN");

var $8PEgQ = parcelRequire("8PEgQ");

var $8wj7Q = parcelRequire("8wj7Q");

var $5xpfH = parcelRequire("5xpfH");
function $87585f4fa8198a9c$var$getCrypto() {
    const gbl = $5xpfH.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $87585f4fa8198a9c$var$emptyUuid;
function $87585f4fa8198a9c$var$getRandomByte() {
    return $8PEgQ.safeMathRandom() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $87585f4fa8198a9c$var$uuid4(crypto = $87585f4fa8198a9c$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $8PEgQ.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$87585f4fa8198a9c$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $87585f4fa8198a9c$var$emptyUuid = "10000000100040008000100000000000";
    return $87585f4fa8198a9c$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($87585f4fa8198a9c$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $87585f4fa8198a9c$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $87585f4fa8198a9c$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $87585f4fa8198a9c$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $87585f4fa8198a9c$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $87585f4fa8198a9c$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $87585f4fa8198a9c$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $87585f4fa8198a9c$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $87585f4fa8198a9c$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $87585f4fa8198a9c$var$parseSemver(input) {
    const match = input.match($87585f4fa8198a9c$var$SEMVER_REGEXP) || [];
    const major = $87585f4fa8198a9c$var$_parseInt(match[1]);
    const minor = $87585f4fa8198a9c$var$_parseInt(match[2]);
    const patch = $87585f4fa8198a9c$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $87585f4fa8198a9c$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$8wj7Q.snipLine(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = $8wj7Q.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$8wj7Q.snipLine(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $87585f4fa8198a9c$var$checkOrSetAlreadyCaught(exception) {
    if ($87585f4fa8198a9c$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        $bKfNN.addNonEnumerableProperty(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $87585f4fa8198a9c$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}
module.exports.addContextToFrame = $87585f4fa8198a9c$var$addContextToFrame;
module.exports.addExceptionMechanism = $87585f4fa8198a9c$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $87585f4fa8198a9c$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $87585f4fa8198a9c$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $87585f4fa8198a9c$var$getEventDescription;
module.exports.isAlreadyCaptured = $87585f4fa8198a9c$var$isAlreadyCaptured;
module.exports.parseSemver = $87585f4fa8198a9c$var$parseSemver;
module.exports.uuid4 = $87585f4fa8198a9c$var$uuid4;

});
parcelRegister("bKfNN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $amQOz = parcelRequire("amQOz");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $88d03f92f31850be$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $88d03f92f31850be$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $88d03f92f31850be$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $88d03f92f31850be$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $88d03f92f31850be$var$addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $88d03f92f31850be$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== 'function') throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($88d03f92f31850be$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $88d03f92f31850be$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $88d03f92f31850be$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $88d03f92f31850be$var$convertToPlainObject(value) {
    if ($dpKhO.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$88d03f92f31850be$var$getOwnProperties(value)
    };
    else if ($dpKhO.isEvent(value)) {
        const newObj = {
            type: value.type,
            target: $88d03f92f31850be$var$serializeEventTarget(value.target),
            currentTarget: $88d03f92f31850be$var$serializeEventTarget(value.currentTarget),
            ...$88d03f92f31850be$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && $dpKhO.isInstanceOf(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $88d03f92f31850be$var$serializeEventTarget(target) {
    try {
        return $dpKhO.isElement(target) ? $amQOz.htmlTreeAsString(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $88d03f92f31850be$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $88d03f92f31850be$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($88d03f92f31850be$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $88d03f92f31850be$var$dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $88d03f92f31850be$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $88d03f92f31850be$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($88d03f92f31850be$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($88d03f92f31850be$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $88d03f92f31850be$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $88d03f92f31850be$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $88d03f92f31850be$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $dpKhO.isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $88d03f92f31850be$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $88d03f92f31850be$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $88d03f92f31850be$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $88d03f92f31850be$var$extractExceptionKeysForMessage;
module.exports.fill = $88d03f92f31850be$var$fill;
module.exports.getOriginalFunction = $88d03f92f31850be$var$getOriginalFunction;
module.exports.markFunctionWrapped = $88d03f92f31850be$var$markFunctionWrapped;
module.exports.objectify = $88d03f92f31850be$var$objectify;
module.exports.wrapMethod = $88d03f92f31850be$var$wrapMethod;

});
parcelRegister("amQOz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");

var $5xpfH = parcelRequire("5xpfH");
const $78c4ed5b6cae3a88$var$WINDOW = $5xpfH.GLOBAL_OBJ;
const $78c4ed5b6cae3a88$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $78c4ed5b6cae3a88$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $78c4ed5b6cae3a88$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $78c4ed5b6cae3a88$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $78c4ed5b6cae3a88$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($78c4ed5b6cae3a88$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $dpKhO.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $78c4ed5b6cae3a88$var$getLocationHref() {
    try {
        return $78c4ed5b6cae3a88$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $78c4ed5b6cae3a88$var$getComponentName(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$78c4ed5b6cae3a88$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $78c4ed5b6cae3a88$var$getComponentName;
module.exports.getLocationHref = $78c4ed5b6cae3a88$var$getLocationHref;
module.exports.htmlTreeAsString = $78c4ed5b6cae3a88$var$htmlTreeAsString;

});
parcelRegister("dpKhO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9c4183a2346e8fb6$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isError(wat) {
    switch($9c4183a2346e8fb6$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9c4183a2346e8fb6$var$isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isBuiltin(wat, className) {
    return $9c4183a2346e8fb6$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isErrorEvent(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isDOMError(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isDOMException(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isString(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isParameterizedString(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isPrimitive(wat) {
    return wat === null || $9c4183a2346e8fb6$var$isParameterizedString(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isPlainObject(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isEvent(wat) {
    return typeof Event !== 'undefined' && $9c4183a2346e8fb6$var$isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isElement(wat) {
    return typeof Element !== 'undefined' && $9c4183a2346e8fb6$var$isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isRegExp(wat) {
    return $9c4183a2346e8fb6$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9c4183a2346e8fb6$var$isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isSyntheticEvent(wat) {
    return $9c4183a2346e8fb6$var$isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $9c4183a2346e8fb6$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9c4183a2346e8fb6$var$isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $9c4183a2346e8fb6$var$isRequest(request) {
    return typeof Request !== 'undefined' && $9c4183a2346e8fb6$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $9c4183a2346e8fb6$var$isDOMError;
module.exports.isDOMException = $9c4183a2346e8fb6$var$isDOMException;
module.exports.isElement = $9c4183a2346e8fb6$var$isElement;
module.exports.isError = $9c4183a2346e8fb6$var$isError;
module.exports.isErrorEvent = $9c4183a2346e8fb6$var$isErrorEvent;
module.exports.isEvent = $9c4183a2346e8fb6$var$isEvent;
module.exports.isInstanceOf = $9c4183a2346e8fb6$var$isInstanceOf;
module.exports.isParameterizedString = $9c4183a2346e8fb6$var$isParameterizedString;
module.exports.isPlainObject = $9c4183a2346e8fb6$var$isPlainObject;
module.exports.isPrimitive = $9c4183a2346e8fb6$var$isPrimitive;
module.exports.isRegExp = $9c4183a2346e8fb6$var$isRegExp;
module.exports.isRequest = $9c4183a2346e8fb6$var$isRequest;
module.exports.isString = $9c4183a2346e8fb6$var$isString;
module.exports.isSyntheticEvent = $9c4183a2346e8fb6$var$isSyntheticEvent;
module.exports.isThenable = $9c4183a2346e8fb6$var$isThenable;
module.exports.isVueViewModel = $9c4183a2346e8fb6$var$isVueViewModel;

});



parcelRegister("8PEgQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xpfH = parcelRequire("5xpfH");
// undefined = not yet resolved, null = no runner found, function = runner found
let $66e253128e8b964d$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $66e253128e8b964d$var$withRandomSafeContext(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($66e253128e8b964d$var$RESOLVED_RUNNER !== undefined) return $66e253128e8b964d$var$RESOLVED_RUNNER ? $66e253128e8b964d$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = $5xpfH.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $66e253128e8b964d$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $66e253128e8b964d$var$RESOLVED_RUNNER(cb);
    }
    $66e253128e8b964d$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $66e253128e8b964d$var$safeMathRandom() {
    return $66e253128e8b964d$var$withRandomSafeContext(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $66e253128e8b964d$var$safeDateNow() {
    return $66e253128e8b964d$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $66e253128e8b964d$var$safeDateNow;
module.exports.safeMathRandom = $66e253128e8b964d$var$safeMathRandom;
module.exports.withRandomSafeContext = $66e253128e8b964d$var$withRandomSafeContext;

});

parcelRegister("8wj7Q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");

var $9jmDw = parcelRequire("9jmDw");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $634025cd90005852$var$truncate(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $634025cd90005852$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $634025cd90005852$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ($dpKhO.isVueViewModel(value)) output.push($9jmDw.getVueInternalName(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $634025cd90005852$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$dpKhO.isString(value)) return false;
    if ($dpKhO.isRegExp(pattern)) return pattern.test(value);
    if ($dpKhO.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === 'function') return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $634025cd90005852$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($634025cd90005852$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $634025cd90005852$var$isMatchingPattern;
module.exports.safeJoin = $634025cd90005852$var$safeJoin;
module.exports.snipLine = $634025cd90005852$var$snipLine;
module.exports.stringMatchesSomePattern = $634025cd90005852$var$stringMatchesSomePattern;
module.exports.truncate = $634025cd90005852$var$truncate;

});


parcelRegister("8OzMM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8PEgQ = parcelRequire("8PEgQ");

var $5xpfH = parcelRequire("5xpfH");
const $66aec08a0f96ab71$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $66aec08a0f96ab71$var$dateTimestampInSeconds() {
    return $8PEgQ.safeDateNow() / $66aec08a0f96ab71$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $66aec08a0f96ab71$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $5xpfH.GLOBAL_OBJ;
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $66aec08a0f96ab71$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + $8PEgQ.withRandomSafeContext(()=>performance.now())) / $66aec08a0f96ab71$var$ONE_SECOND_IN_MS;
    };
}
let $66aec08a0f96ab71$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $66aec08a0f96ab71$var$timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $66aec08a0f96ab71$var$_cachedTimestampInSeconds ?? ($66aec08a0f96ab71$var$_cachedTimestampInSeconds = $66aec08a0f96ab71$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $66aec08a0f96ab71$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $66aec08a0f96ab71$var$getBrowserTimeOrigin() {
    const { performance: performance } = $5xpfH.GLOBAL_OBJ;
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = $8PEgQ.withRandomSafeContext(()=>performance.now());
    const dateNow = $8PEgQ.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $66aec08a0f96ab71$var$browserPerformanceTimeOrigin() {
    if ($66aec08a0f96ab71$var$cachedTimeOrigin === null) $66aec08a0f96ab71$var$cachedTimeOrigin = $66aec08a0f96ab71$var$getBrowserTimeOrigin();
    return $66aec08a0f96ab71$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $66aec08a0f96ab71$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $66aec08a0f96ab71$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $66aec08a0f96ab71$var$timestampInSeconds;

});


parcelRegister("agH01", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $779cc0c9177acbca$var$merge(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $779cc0c9177acbca$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $779cc0c9177acbca$var$merge;

});

parcelRegister("3nbIj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bCreQ = parcelRequire("bCreQ");
/**
 * Generate a random, valid trace ID.
 */ function $274c9b32b84d2610$var$generateTraceId() {
    return $bCreQ.uuid4();
}
/**
 * Generate a random, valid span ID.
 */ function $274c9b32b84d2610$var$generateSpanId() {
    return $bCreQ.uuid4().substring(16);
}
module.exports.generateSpanId = $274c9b32b84d2610$var$generateSpanId;
module.exports.generateTraceId = $274c9b32b84d2610$var$generateTraceId;

});

parcelRegister("jdkFc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bKfNN = parcelRequire("bKfNN");
const $dfcf428b8c52432a$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dfcf428b8c52432a$var$_setSpanForScope(scope, span) {
    if (span) $bKfNN.addNonEnumerableProperty(scope, $dfcf428b8c52432a$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$dfcf428b8c52432a$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $dfcf428b8c52432a$var$_getSpanForScope(scope) {
    return scope[$dfcf428b8c52432a$var$SCOPE_SPAN_FIELD];
}
module.exports._getSpanForScope = $dfcf428b8c52432a$var$_getSpanForScope;
module.exports._setSpanForScope = $dfcf428b8c52432a$var$_setSpanForScope;

});



parcelRegister("d5IBn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $987e56fd5783d272$var$isActualPromise = (p)=>p instanceof Promise && !p[$987e56fd5783d272$var$kChainedCopy];
const $987e56fd5783d272$var$kChainedCopy = Symbol('chained PromiseLike');
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $987e56fd5783d272$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $987e56fd5783d272$var$isActualPromise(chained) && $987e56fd5783d272$var$isActualPromise(original) ? chained : $987e56fd5783d272$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $987e56fd5783d272$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === 'function') Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$987e56fd5783d272$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $987e56fd5783d272$var$chainAndCopyPromiseLike;

});



parcelRegister("bcKiE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");
/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $8284bae4ccb5858d$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $8284bae4ccb5858d$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $8284bae4ccb5858d$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $8284bae4ccb5858d$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $8284bae4ccb5858d$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $8284bae4ccb5858d$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function $8284bae4ccb5858d$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += $8284bae4ccb5858d$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($dpKhO.isPrimitive(val)) weight += $8284bae4ccb5858d$var$estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function $8284bae4ccb5858d$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'boolean') return 4;
    else if (typeof value === 'number') return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $8284bae4ccb5858d$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $8284bae4ccb5858d$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $8284bae4ccb5858d$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $8284bae4ccb5858d$var$isAttributeObject;
module.exports.serializeAttributes = $8284bae4ccb5858d$var$serializeAttributes;

});

parcelRegister("d2jrf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iNc9K = parcelRequire("iNc9K");

var $dLES3 = parcelRequire("dLES3");

var $6kYtN = parcelRequire("6kYtN");

var $3nbIj = parcelRequire("3nbIj");
let $97da8a5b10944d74$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $97da8a5b10944d74$var$registerExternalPropagationContext(fn) {
    $97da8a5b10944d74$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $97da8a5b10944d74$var$getExternalPropagationContext() {
    return $97da8a5b10944d74$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $97da8a5b10944d74$var$hasExternalPropagationContext() {
    return $97da8a5b10944d74$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $97da8a5b10944d74$var$getCurrentScope() {
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $97da8a5b10944d74$var$getIsolationScope() {
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $97da8a5b10944d74$var$getGlobalScope() {
    return $dLES3.getGlobalSingleton('globalScope', ()=>new $6kYtN.Scope());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $97da8a5b10944d74$var$withScope(...rest) {
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $97da8a5b10944d74$var$withIsolationScope(...rest) {
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $97da8a5b10944d74$var$getClient() {
    return $97da8a5b10944d74$var$getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $97da8a5b10944d74$var$getTraceContextFromScope(scope) {
    const externalContext = $97da8a5b10944d74$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $3nbIj.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $97da8a5b10944d74$var$getClient;
module.exports.getCurrentScope = $97da8a5b10944d74$var$getCurrentScope;
module.exports.getExternalPropagationContext = $97da8a5b10944d74$var$getExternalPropagationContext;
module.exports.getGlobalScope = $97da8a5b10944d74$var$getGlobalScope;
module.exports.getIsolationScope = $97da8a5b10944d74$var$getIsolationScope;
module.exports.getTraceContextFromScope = $97da8a5b10944d74$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $97da8a5b10944d74$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $97da8a5b10944d74$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $97da8a5b10944d74$var$withIsolationScope;
module.exports.withScope = $97da8a5b10944d74$var$withScope;

});

parcelRegister("6zIGl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/** The reason why an idle span finished. */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';
/** The release version of the application */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = 'sentry.release';
/** The environment name (e.g., "production", "staging", "development") */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = 'sentry.environment';
/** The segment name (e.g., "GET /users") */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = 'sentry.segment.name';
/** The id of the segment that this span belongs to. */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = 'sentry.segment.id';
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = 'sentry.sdk.name';
/** The version of the Sentry SDK */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = 'sentry.sdk.version';
/** The user ID */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_ID = 'user.id';
/** The user email */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = 'user.email';
/** The user IP address */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = 'user.ip_address';
/** The user username */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = 'user.name';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
const $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $4c98abe1a421e1cd$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $4c98abe1a421e1cd$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = 'gen_ai.conversation.id';
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $4c98abe1a421e1cd$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $4c98abe1a421e1cd$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $4c98abe1a421e1cd$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("9BaVX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6fd00d001bd18e05$var$SPAN_STATUS_UNSET = 0;
const $6fd00d001bd18e05$var$SPAN_STATUS_OK = 1;
const $6fd00d001bd18e05$var$SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $6fd00d001bd18e05$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $6fd00d001bd18e05$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'not_found'
            };
        case 409:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'cancelled'
            };
        default:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
                message: 'internal_error'
            };
    }
    return {
        code: $6fd00d001bd18e05$var$SPAN_STATUS_ERROR,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $6fd00d001bd18e05$var$setHttpStatus(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $6fd00d001bd18e05$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $6fd00d001bd18e05$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $6fd00d001bd18e05$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $6fd00d001bd18e05$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $6fd00d001bd18e05$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $6fd00d001bd18e05$var$setHttpStatus;

});

parcelRegister("l0ddg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bKfNN = parcelRequire("bKfNN");

var $hF3Re = parcelRequire("hF3Re");
const $f4a3d8e4070d37a4$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $f4a3d8e4070d37a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $f4a3d8e4070d37a4$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $bKfNN.addNonEnumerableProperty(span, $f4a3d8e4070d37a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $hF3Re.makeWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        $bKfNN.addNonEnumerableProperty(span, $f4a3d8e4070d37a4$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $f4a3d8e4070d37a4$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$f4a3d8e4070d37a4$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $hF3Re.derefWeakRef(spanWithScopes[$f4a3d8e4070d37a4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
module.exports.getCapturedScopesOnSpan = $f4a3d8e4070d37a4$var$getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $f4a3d8e4070d37a4$var$setCapturedScopesOnSpan;

});
parcelRegister("hF3Re", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xpfH = parcelRequire("5xpfH");
/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function $cdb94209632ef2b4$var$makeWeakRef(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = $5xpfH.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === 'function') return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function $cdb94209632ef2b4$var$derefWeakRef(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === 'object' && 'deref' in ref && typeof ref.deref === 'function') try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}
module.exports.derefWeakRef = $cdb94209632ef2b4$var$derefWeakRef;
module.exports.makeWeakRef = $cdb94209632ef2b4$var$makeWeakRef;

});


parcelRegister("6qbZr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3iQ48 = parcelRequire("3iQ48");

var $1nDVq = parcelRequire("1nDVq");

var $hO292 = parcelRequire("hO292");

var $h7UoA = parcelRequire("h7UoA");

var $3nbIj = parcelRequire("3nbIj");

var $8PEgQ = parcelRequire("8PEgQ");
// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $4ace78bece4e28f6$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $4ace78bece4e28f6$var$extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($4ace78bece4e28f6$var$TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $4ace78bece4e28f6$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $4ace78bece4e28f6$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $1nDVq.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $3nbIj.generateTraceId(),
        sampleRand: $8PEgQ.safeMathRandom()
    };
    const sampleRand = $4ace78bece4e28f6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $4ace78bece4e28f6$var$generateSentryTraceHeader(traceId = $3nbIj.generateTraceId(), spanId = $3nbIj.generateSpanId(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $4ace78bece4e28f6$var$generateTraceparentHeader(traceId = $3nbIj.generateTraceId(), spanId = $3nbIj.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $4ace78bece4e28f6$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = $h7UoA.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = $h7UoA.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? $8PEgQ.safeMathRandom() * parsedSampleRate : parsedSampleRate + $8PEgQ.safeMathRandom() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return $8PEgQ.safeMathRandom();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $4ace78bece4e28f6$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $hO292.extractOrgIdFromClient(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $3iQ48.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $3iQ48.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $4ace78bece4e28f6$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $4ace78bece4e28f6$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $4ace78bece4e28f6$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $4ace78bece4e28f6$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $4ace78bece4e28f6$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $4ace78bece4e28f6$var$shouldContinueTrace;

});
parcelRegister("1nDVq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");
const $1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
const $1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $1016e8c3dd3425e3$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $1016e8c3dd3425e3$var$baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $1016e8c3dd3425e3$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $1016e8c3dd3425e3$var$dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $1016e8c3dd3425e3$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $1016e8c3dd3425e3$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$dpKhO.isString(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $1016e8c3dd3425e3$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $1016e8c3dd3425e3$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $1016e8c3dd3425e3$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $1016e8c3dd3425e3$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $1016e8c3dd3425e3$var$MAX_BAGGAGE_STRING_LENGTH) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}
/**
 * Merge two baggage headers into one.
 * - Sentry-specific entries (keys starting with "sentry-") from the new
 *   baggage take precedence
 * - Non-Sentry entries from existing baggage take precedence
 *
 * The order of the existing baggage will be preserved, and new entries will
 * be added to the end.
 *
 * This matches the behavior of OTEL's propagation.inject() which uses
 * `baggage.setEntry()`  to overwrite existing entries with the same key.
 */ function $1016e8c3dd3425e3$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $1016e8c3dd3425e3$var$parseBaggageHeader(existing);
    const incomingEntries = $1016e8c3dd3425e3$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    // 1. All non-sentry entries from existing are kept
    // 2. All sentry- entries from the new baggage are retained
    // 3. If sentry- entries present in new, ignore from old, else keep from old.
    // 4. Non-sentry entries from new are only kept if not in existing.
    const merged = {};
    // partition incoming entries into sentry and non-sentry prefixed
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    // If new baggage contains at least one sentry- value, we remove all old
    // sentry- values otherwise, we keep old sentry- values. If we don't remove
    // old sentry- values, we end up with an inconsistent dynamic sampling
    // context propagation.
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    // Assign new sentry fields.
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    // assign new non-sentry fields not found on existing object.
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ??= value;
    return $1016e8c3dd3425e3$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $1016e8c3dd3425e3$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $1016e8c3dd3425e3$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $1016e8c3dd3425e3$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $1016e8c3dd3425e3$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $1016e8c3dd3425e3$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $1016e8c3dd3425e3$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $1016e8c3dd3425e3$var$parseBaggageHeader;

});

parcelRegister("hO292", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");
/** Regular expression used to extract org ID from a DSN host. */ const $cf68c5136f29431e$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $cf68c5136f29431e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $cf68c5136f29431e$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $cf68c5136f29431e$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $cf68c5136f29431e$var$dsnFromString(str) {
    const match = $cf68c5136f29431e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        $3iQ48.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $cf68c5136f29431e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $cf68c5136f29431e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $cf68c5136f29431e$var$validateDsn(dsn) {
    if (!$9XOi0.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $3iQ48.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $3iQ48.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$cf68c5136f29431e$var$isValidProtocol(protocol)) {
        $3iQ48.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $3iQ48.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $cf68c5136f29431e$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($cf68c5136f29431e$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $cf68c5136f29431e$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $cf68c5136f29431e$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $cf68c5136f29431e$var$makeDsn(from) {
    const components = typeof from === 'string' ? $cf68c5136f29431e$var$dsnFromString(from) : $cf68c5136f29431e$var$dsnFromComponents(from);
    if (!components || !$cf68c5136f29431e$var$validateDsn(components)) return undefined;
    return components;
}
module.exports.dsnFromString = $cf68c5136f29431e$var$dsnFromString;
module.exports.dsnToString = $cf68c5136f29431e$var$dsnToString;
module.exports.extractOrgIdFromClient = $cf68c5136f29431e$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $cf68c5136f29431e$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $cf68c5136f29431e$var$makeDsn;

});

parcelRegister("h7UoA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $c77ed617c902b37b$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}
module.exports.parseSampleRate = $c77ed617c902b37b$var$parseSampleRate;

});




parcelRegister("8jfNV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $6tBvR = parcelRequire("6tBvR");

var $jd6mp = parcelRequire("jd6mp");

var $jdkFc = parcelRequire("jdkFc");

var $inXyb = parcelRequire("inXyb");

var $8OzMM = parcelRequire("8OzMM");

var $eW0HJ = parcelRequire("eW0HJ");

var $4wZ5i = parcelRequire("4wZ5i");

var $ggwr4 = parcelRequire("ggwr4");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");
const $60cc5b7922eb4500$var$TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $60cc5b7922eb4500$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $60cc5b7922eb4500$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $60cc5b7922eb4500$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $60cc5b7922eb4500$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $60cc5b7922eb4500$var$startIdleSpan(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $60cc5b7922eb4500$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $60cc5b7922eb4500$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $60cc5b7922eb4500$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $60cc5b7922eb4500$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $d2jrf.getClient();
    if (!client || !$6tBvR.hasSpansEnabled()) {
        const span = new $4wZ5i.SentryNonRecordingSpan();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...$eW0HJ.getDynamicSamplingContextFromSpan(span)
        };
        $eW0HJ.freezeDscOnSpan(span, dsc);
        return span;
    }
    const scope = $d2jrf.getCurrentScope();
    const previousActiveSpan = $inXyb.getActiveSpan();
    const span = $60cc5b7922eb4500$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof $4wZ5i.SentryNonRecordingSpan) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $8OzMM.timestampInSeconds();
            const spanEndTimestamp = $inXyb.spanTimeInputToSeconds(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = $inXyb.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $inXyb.spanToJSON(span);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $inXyb.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && $jd6mp.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $60cc5b7922eb4500$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $60cc5b7922eb4500$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $8OzMM.timestampInSeconds();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $8OzMM.timestampInSeconds();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $jdkFc._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $inXyb.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        // Set span status to 'ok' if it hasn't been explicitly set to an error status
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === 'unknown') span.setStatus({
            code: $9BaVX.SPAN_STATUS_OK
        });
        $3iQ48.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $inXyb.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = $inXyb.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($9XOi0.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) $3iQ48.debug.log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $3iQ48.debug.log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $inXyb.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!$inXyb.spanToJSON(startedSpan).timestamp || startedSpan instanceof $ggwr4.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $inXyb.getSpanDescendants(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $9BaVX.SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            });
            _finishReason = $60cc5b7922eb4500$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $60cc5b7922eb4500$var$_startIdleSpan(options) {
    const span = $92XmH.startInactiveSpan(options);
    $jdkFc._setSpanForScope($d2jrf.getCurrentScope(), span);
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Tracing] Started span is an idle span');
    return span;
}
module.exports.TRACING_DEFAULTS = $60cc5b7922eb4500$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $60cc5b7922eb4500$var$startIdleSpan;

});
parcelRegister("6tBvR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $4b728ccbae87060e$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $d2jrf.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $4b728ccbae87060e$var$hasSpansEnabled;

});

parcelRegister("jd6mp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $8wj7Q = parcelRequire("8wj7Q");
function $dfc42a468b19e473$var$logIgnoredSpan(droppedSpan) {
    $3iQ48.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $dfc42a468b19e473$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($dfc42a468b19e473$var$isStringOrRegExp(pattern)) {
            if (span.description && $8wj7Q.isMatchingPattern(span.description, pattern)) {
                $9XOi0.DEBUG_BUILD && $dfc42a468b19e473$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $8wj7Q.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $8wj7Q.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$dfc42a468b19e473$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches`, `opMatches`, or `attrsMatch`. So in contrary to how this looks,
        // not all of op, name, and attributes actually have to match. This is the most efficient way to check
        // for all combinations of name, op, and attribute patterns.
        if (nameMatches && opMatches && attrsMatch) {
            $9XOi0.DEBUG_BUILD && $dfc42a468b19e473$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $dfc42a468b19e473$var$_matchesAttributeValue(actual, pat) {
    // String values support pattern matching
    if (typeof actual === 'string' && (typeof pat === 'string' || pat instanceof RegExp)) return $8wj7Q.isMatchingPattern(actual, pat);
    // Arrays: element-wise strict equality
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    // Primitives: strict equality
    return actual === pat;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $dfc42a468b19e473$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $dfc42a468b19e473$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}
module.exports.reparentChildSpans = $dfc42a468b19e473$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $dfc42a468b19e473$var$shouldIgnoreSpan;

});

parcelRegister("eW0HJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jO72z = parcelRequire("jO72z");

var $d2jrf = parcelRequire("d2jrf");

var $6zIGl = parcelRequire("6zIGl");

var $1nDVq = parcelRequire("1nDVq");

var $hO292 = parcelRequire("hO292");

var $6tBvR = parcelRequire("6tBvR");

var $bKfNN = parcelRequire("bKfNN");

var $inXyb = parcelRequire("inXyb");

var $l0ddg = parcelRequire("l0ddg");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $adf70752ca1f8f65$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $adf70752ca1f8f65$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $bKfNN.addNonEnumerableProperty(spanWithMaybeDsc, $adf70752ca1f8f65$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $adf70752ca1f8f65$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || $jO72z.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $hO292.extractOrgIdFromClient(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $adf70752ca1f8f65$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $adf70752ca1f8f65$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $adf70752ca1f8f65$var$getDynamicSamplingContextFromSpan(span) {
    const client = $d2jrf.getClient();
    if (!client) return {};
    const rootSpan = $inXyb.getRootSpan(span);
    const rootSpanJson = $inXyb.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$adf70752ca1f8f65$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && $1nDVq.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $adf70752ca1f8f65$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes['sentry.span.source'];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ($6tBvR.hasSpansEnabled()) {
        dsc.sampled = String($inXyb.spanIsSampled(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $l0ddg.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $adf70752ca1f8f65$var$spanToBaggageHeader(span) {
    const dsc = $adf70752ca1f8f65$var$getDynamicSamplingContextFromSpan(span);
    return $1nDVq.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $adf70752ca1f8f65$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $adf70752ca1f8f65$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $adf70752ca1f8f65$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $adf70752ca1f8f65$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $adf70752ca1f8f65$var$spanToBaggageHeader;

});
parcelRegister("jO72z", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $e6b825eb527141c0$var$DEFAULT_ENVIRONMENT = 'production';
const $e6b825eb527141c0$var$DEV_ENVIRONMENT = 'development';
module.exports.DEFAULT_ENVIRONMENT = $e6b825eb527141c0$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $e6b825eb527141c0$var$DEV_ENVIRONMENT;

});


parcelRegister("4wZ5i", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3nbIj = parcelRequire("3nbIj");

var $inXyb = parcelRequire("inXyb");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $34c988ab5770e084$var$SentryNonRecordingSpan {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3nbIj.generateTraceId();
        this._spanId = spanContext.spanId || $3nbIj.generateSpanId();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $inXyb.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
module.exports.SentryNonRecordingSpan = $34c988ab5770e084$var$SentryNonRecordingSpan;

});

parcelRegister("ggwr4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $8Uw8o = parcelRequire("8Uw8o");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $3nbIj = parcelRequire("3nbIj");

var $inXyb = parcelRequire("inXyb");

var $8OzMM = parcelRequire("8OzMM");

var $eW0HJ = parcelRequire("eW0HJ");

var $d5m2U = parcelRequire("d5m2U");

var $aWM4F = parcelRequire("aWM4F");

var $euvlx = parcelRequire("euvlx");

var $l0ddg = parcelRequire("l0ddg");
/* eslint-disable max-lines */ const $bd774cff26ad56d6$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $bd774cff26ad56d6$var$SentrySpan {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $3nbIj.generateTraceId();
        this._spanId = spanContext.spanId || $3nbIj.generateSpanId();
        this._startTime = spanContext.startTimestamp || $8OzMM.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'manual',
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $inXyb.TRACE_FLAG_SAMPLED : $inXyb.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $inXyb.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = $inXyb.spanTimeInputToSeconds(endTimestamp);
        $d5m2U.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $inXyb.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $aWM4F.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $inXyb.getRootSpan(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? $inXyb.getRootSpan(this).spanContext().spanId : undefined,
            links: $inXyb.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? '',
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $inXyb.getRootSpan(this),
            status: $inXyb.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $inXyb.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Tracing] Adding an event to span:', name);
        const time$1 = $bd774cff26ad56d6$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $8OzMM.timestampInSeconds();
        const attributes = $bd774cff26ad56d6$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $inXyb.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $d2jrf.getClient();
        if (client) {
            client.emit('spanEnd', this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit('afterSpanEnd', this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === $inXyb.getRootSpan(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $bd774cff26ad56d6$var$sendSpanEnvelope($8Uw8o.createSpanEnvelope([
                this
            ], client));
            else {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        } else if (client && $euvlx.hasSpanStreamingEnabled(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit('afterSegmentSpanEnd', this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $l0ddg.getCapturedScopesOnSpan(this).scope || $d2jrf.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$bd774cff26ad56d6$var$isFullFinishedSpan($inXyb.spanToJSON(this))) return undefined;
        if (!this._name) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $l0ddg.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = $inXyb.getSpanDescendants(this).filter((span)=>span !== this && !$bd774cff26ad56d6$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$inXyb.spanToJSON(span)).filter($bd774cff26ad56d6$var$isFullFinishedSpan);
        const source = this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith('gen_ai.')) hasGenAiSpans = true;
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: $inXyb.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $bd774cff26ad56d6$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $bd774cff26ad56d6$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $eW0HJ.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $aWM4F.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $bd774cff26ad56d6$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $bd774cff26ad56d6$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $bd774cff26ad56d6$var$isStandaloneSpan(span) {
    return span instanceof $bd774cff26ad56d6$var$SentrySpan && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $bd774cff26ad56d6$var$sendSpanEnvelope(envelope) {
    const client = $d2jrf.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $bd774cff26ad56d6$var$SentrySpan;

});
parcelRegister("8Uw8o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eW0HJ = parcelRequire("eW0HJ");

var $1zgsW = parcelRequire("1zgsW");

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");

var $jd6mp = parcelRequire("jd6mp");

var $inXyb = parcelRequire("inXyb");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $67cc7aee2aa0c2eb$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $67cc7aee2aa0c2eb$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $cp5Oe.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $hO292.dsnToString(dsn$1)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return $cp5Oe.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $67cc7aee2aa0c2eb$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $cp5Oe.getSdkMetadataForEnvelopeHeader(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $67cc7aee2aa0c2eb$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $cp5Oe.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $cp5Oe.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $67cc7aee2aa0c2eb$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = $eW0HJ.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $hO292.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $inXyb.spanToJSON(span);
        return !$jd6mp.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $inXyb.spanToJSON(span);
        const processedSpan = !$1zgsW.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $inXyb.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $inXyb.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($cp5Oe.createSpanEnvelopeItem(spanJson));
    }
    return $cp5Oe.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $67cc7aee2aa0c2eb$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $67cc7aee2aa0c2eb$var$createEventEnvelope;
module.exports.createSessionEnvelope = $67cc7aee2aa0c2eb$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $67cc7aee2aa0c2eb$var$createSpanEnvelope;

});
parcelRegister("1zgsW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bKfNN = parcelRequire("bKfNN");
/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function $1245d5198478b75e$var$withStreamedSpan(callback) {
    $bKfNN.addNonEnumerableProperty(callback, '_streamed', true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function $1245d5198478b75e$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === 'function' && '_streamed' in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $1245d5198478b75e$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $1245d5198478b75e$var$withStreamedSpan;

});

parcelRegister("cp5Oe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dLES3 = parcelRequire("dLES3");

var $hO292 = parcelRequire("hO292");

var $iCGkd = parcelRequire("iCGkd");

var $5xpfH = parcelRequire("5xpfH");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $907c536abb76309f$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $907c536abb76309f$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $907c536abb76309f$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $907c536abb76309f$var$envelopeContainsItemType(envelope, types) {
    return $907c536abb76309f$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $907c536abb76309f$var$encodeUTF8(input) {
    const carrier$1 = $dLES3.getSentryCarrier($5xpfH.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $907c536abb76309f$var$decodeUTF8(input) {
    const carrier$1 = $dLES3.getSentryCarrier($5xpfH.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $907c536abb76309f$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $907c536abb76309f$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $907c536abb76309f$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify($iCGkd.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $907c536abb76309f$var$concatBuffers(parts);
}
function $907c536abb76309f$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $907c536abb76309f$var$parseEnvelope(env) {
    let buffer = typeof env === 'string' ? $907c536abb76309f$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($907c536abb76309f$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $907c536abb76309f$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $907c536abb76309f$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === 'string' ? $907c536abb76309f$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $907c536abb76309f$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $907c536abb76309f$var$_isOverriddenType(type) {
    return type in $907c536abb76309f$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $907c536abb76309f$var$envelopeItemTypeToDataCategory(type) {
    return $907c536abb76309f$var$_isOverriddenType(type) ? $907c536abb76309f$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $907c536abb76309f$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $907c536abb76309f$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $hO292.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $907c536abb76309f$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $907c536abb76309f$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $907c536abb76309f$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $907c536abb76309f$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $907c536abb76309f$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $907c536abb76309f$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $907c536abb76309f$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $907c536abb76309f$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $907c536abb76309f$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $907c536abb76309f$var$parseEnvelope;
module.exports.serializeEnvelope = $907c536abb76309f$var$serializeEnvelope;

});
parcelRegister("iCGkd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");

var $idZsJ = parcelRequire("idZsJ");

var $bKfNN = parcelRequire("bKfNN");

var $9jmDw = parcelRequire("9jmDw");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d8ec9b7f37fed854$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $d8ec9b7f37fed854$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $d8ec9b7f37fed854$var$normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $d8ec9b7f37fed854$var$normalize(object, depth);
    if ($d8ec9b7f37fed854$var$jsonSize(normalized) > maxSize) return $d8ec9b7f37fed854$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $d8ec9b7f37fed854$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $d8ec9b7f37fed854$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $d8ec9b7f37fed854$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. Hints use internal symbols
    // (see normalizationHints.ts) so user-controlled JSON cannot spoof them.
    if ($idZsJ.hasSkipNormalizationHint(value)) return value;
    // Override remaining depth from this node (e.g. Redux / Pinia state). Set via setNormalizationDepthOverrideHint.
    const overrideDepth = $idZsJ.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== undefined ? overrideDepth : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $d8ec9b7f37fed854$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = $bKfNN.convertToPlainObject(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $d8ec9b7f37fed854$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $d8ec9b7f37fed854$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ($dpKhO.isVueViewModel(value)) return $9jmDw.getVueInternalName(value);
        // React's SyntheticEvent thingy
        if ($dpKhO.isSyntheticEvent(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${$9jmDw.getFunctionName(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $d8ec9b7f37fed854$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $d8ec9b7f37fed854$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $d8ec9b7f37fed854$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d8ec9b7f37fed854$var$jsonSize(value) {
    return $d8ec9b7f37fed854$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $d8ec9b7f37fed854$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $d8ec9b7f37fed854$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $d8ec9b7f37fed854$var$normalize;
module.exports.normalizeToSize = $d8ec9b7f37fed854$var$normalizeToSize;
module.exports.normalizeUrlToBase = $d8ec9b7f37fed854$var$normalizeUrlToBase;

});
parcelRegister("idZsJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bKfNN = parcelRequire("bKfNN");
/**
 * Internal symbols for normalization behavior. JSON and other structured user payloads cannot
 * carry these keys, so they cannot spoof SDK-only normalization hints.
 * We use Symbol.for to ensure that the symbols are the same across different modules/files.
 */ const $d4491e0b8deb92e6$var$SENTRY_SKIP_NORMALIZATION = Symbol.for('sentry.skipNormalization');
const $d4491e0b8deb92e6$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = Symbol.for('sentry.overrideNormalizationDepth');
/** Marks an object so `normalize` returns it unchanged (already-normalized SDK data). */ function $d4491e0b8deb92e6$var$setSkipNormalizationHint(obj) {
    $bKfNN.addNonEnumerableProperty(obj, $d4491e0b8deb92e6$var$SENTRY_SKIP_NORMALIZATION, true);
}
/** Overrides remaining normalization depth from this object downward (e.g. Redux / Pinia state). */ function $d4491e0b8deb92e6$var$setNormalizationDepthOverrideHint(obj, depth) {
    $bKfNN.addNonEnumerableProperty(obj, $d4491e0b8deb92e6$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
/** @internal */ function $d4491e0b8deb92e6$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$d4491e0b8deb92e6$var$SENTRY_SKIP_NORMALIZATION]);
}
/** @internal */ function $d4491e0b8deb92e6$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$d4491e0b8deb92e6$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === 'number' ? v : undefined;
}
module.exports.getNormalizationDepthOverrideHint = $d4491e0b8deb92e6$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $d4491e0b8deb92e6$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $d4491e0b8deb92e6$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $d4491e0b8deb92e6$var$setSkipNormalizationHint;

});




parcelRegister("d5m2U", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");
/**
 * Print a log message for a started span.
 */ function $986cd7dca9ebd54f$var$logSpanStart(span) {
    if (!$9XOi0.DEBUG_BUILD) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = $inXyb.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $inXyb.spanIsSampled(span);
    const rootSpan = $inXyb.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = $inXyb.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    $3iQ48.debug.log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $986cd7dca9ebd54f$var$logSpanEnd(span) {
    if (!$9XOi0.DEBUG_BUILD) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = $inXyb.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $inXyb.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    $3iQ48.debug.log(msg);
}
module.exports.logSpanEnd = $986cd7dca9ebd54f$var$logSpanEnd;
module.exports.logSpanStart = $986cd7dca9ebd54f$var$logSpanStart;

});

parcelRegister("aWM4F", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $7f849cbc8b08d3d4$var$setMeasurement(name, value, unit, activeSpan = $inXyb.getActiveSpan()) {
    const rootSpan = activeSpan && $inXyb.getRootSpan(activeSpan);
    if (rootSpan) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $7f849cbc8b08d3d4$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $7f849cbc8b08d3d4$var$setMeasurement;
module.exports.timedEventsToMeasurements = $7f849cbc8b08d3d4$var$timedEventsToMeasurements;

});

parcelRegister("euvlx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Determines if span streaming is enabled for the given client
 */ function $a8cc2ec68da37376$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === 'stream';
}
module.exports.hasSpanStreamingEnabled = $a8cc2ec68da37376$var$hasSpanStreamingEnabled;

});


parcelRegister("92XmH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iNc9K = parcelRequire("iNc9K");

var $dLES3 = parcelRequire("dLES3");

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $6zIGl = parcelRequire("6zIGl");

var $1nDVq = parcelRequire("1nDVq");

var $3iQ48 = parcelRequire("3iQ48");

var $hLiMU = parcelRequire("hLiMU");

var $6tBvR = parcelRequire("6tBvR");

var $jd6mp = parcelRequire("jd6mp");

var $euvlx = parcelRequire("euvlx");

var $h7UoA = parcelRequire("h7UoA");

var $3nbIj = parcelRequire("3nbIj");

var $8PEgQ = parcelRequire("8PEgQ");

var $jdkFc = parcelRequire("jdkFc");

var $inXyb = parcelRequire("inXyb");

var $6qbZr = parcelRequire("6qbZr");

var $eW0HJ = parcelRequire("eW0HJ");

var $d5m2U = parcelRequire("d5m2U");

var $fF4EW = parcelRequire("fF4EW");

var $4wZ5i = parcelRequire("4wZ5i");

var $ggwr4 = parcelRequire("ggwr4");

var $9BaVX = parcelRequire("9BaVX");

var $l0ddg = parcelRequire("l0ddg");
/* eslint-disable max-lines */ const $696259a55cfc6a17$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $696259a55cfc6a17$var$startSpan(options, callback) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $696259a55cfc6a17$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return $d2jrf.withScope(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $696259a55cfc6a17$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $d2jrf.getCurrentScope();
            const parentSpan = $696259a55cfc6a17$var$getParentSpan(scope, customParentSpan);
            const client = $d2jrf.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $4wZ5i.SentryNonRecordingSpan() : $696259a55cfc6a17$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent('no_parent_span', 'span');
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!$696259a55cfc6a17$var$_isIgnoredSpan(activeSpan) || !parentSpan) $jdkFc._setSpanForScope(scope, activeSpan);
            return $hLiMU.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = $inXyb.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $696259a55cfc6a17$var$startSpanManual(options, callback) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $696259a55cfc6a17$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $d2jrf.withScope(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $696259a55cfc6a17$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $d2jrf.getCurrentScope();
            const parentSpan = $696259a55cfc6a17$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $4wZ5i.SentryNonRecordingSpan() : $696259a55cfc6a17$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) $d2jrf.getClient()?.recordDroppedEvent('no_parent_span', 'span');
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!$696259a55cfc6a17$var$_isIgnoredSpan(activeSpan) || !parentSpan) $jdkFc._setSpanForScope(scope, activeSpan);
            return $hLiMU.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = $inXyb.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $696259a55cfc6a17$var$startInactiveSpan(options) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $696259a55cfc6a17$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>$d2jrf.withScope(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$696259a55cfc6a17$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $d2jrf.getCurrentScope();
        const parentSpan = $696259a55cfc6a17$var$getParentSpan(scope, customParentSpan);
        const client = $d2jrf.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent('no_parent_span', 'span');
            return new $4wZ5i.SentryNonRecordingSpan();
        }
        return $696259a55cfc6a17$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $696259a55cfc6a17$var$continueTrace = (options, callback)=>{
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $d2jrf.getClient();
    const incomingDsc = $1nDVq.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$6qbZr.shouldContinueTrace(client, incomingDsc?.org_id)) return $696259a55cfc6a17$var$startNewTrace(callback);
    return $d2jrf.withScope((scope)=>{
        const propagationContext = $6qbZr.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $jdkFc._setSpanForScope(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $696259a55cfc6a17$var$withActiveSpan(span, callback) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $d2jrf.withScope((scope)=>{
        $jdkFc._setSpanForScope(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $696259a55cfc6a17$var$suppressTracing(callback) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $d2jrf.withScope((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$696259a55cfc6a17$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$696259a55cfc6a17$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $696259a55cfc6a17$var$startNewTrace(callback) {
    const acs = $696259a55cfc6a17$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $d2jrf.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $3nbIj.generateTraceId(),
            sampleRand: $8PEgQ.safeMathRandom()
        });
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $696259a55cfc6a17$var$withActiveSpan(null, callback);
    });
}
function $696259a55cfc6a17$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!$6tBvR.hasSpansEnabled()) {
        const span = new $4wZ5i.SentryNonRecordingSpan();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...$eW0HJ.getDynamicSamplingContextFromSpan(span)
            };
            $eW0HJ.freezeDscOnSpan(span, dsc);
        }
        return span;
    }
    const client = $d2jrf.getClient();
    if ($696259a55cfc6a17$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$696259a55cfc6a17$var$_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent('ignored', 'span');
        return new $4wZ5i.SentryNonRecordingSpan({
            dropReason: 'ignored',
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = $d2jrf.getIsolationScope();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $696259a55cfc6a17$var$_startChildSpan(parentSpan, scope, spanArguments);
        $inXyb.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = $eW0HJ.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $inXyb.spanIsSampled(parentSpan);
        span = $696259a55cfc6a17$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        $eW0HJ.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $696259a55cfc6a17$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) $eW0HJ.freezeDscOnSpan(span, dsc);
    }
    $d5m2U.logSpanStart(span);
    $l0ddg.setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $696259a55cfc6a17$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $inXyb.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $696259a55cfc6a17$var$getAcs() {
    const carrier$1 = $dLES3.getMainCarrier();
    return $iNc9K.getAsyncContextStrategy(carrier$1);
}
function $696259a55cfc6a17$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = $d2jrf.getClient();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $696259a55cfc6a17$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $fF4EW.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $h7UoA.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $ggwr4.SentrySpan({
        ...spanArguments,
        attributes: {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'custom',
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', $euvlx.hasSpanStreamingEnabled(client) ? 'span' : 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $696259a55cfc6a17$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $696259a55cfc6a17$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $inXyb.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $ggwr4.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $4wZ5i.SentryNonRecordingSpan({
        traceId: traceId
    });
    $inXyb.addChildSpanToSpan(parentSpan, childSpan);
    const client = $d2jrf.getClient();
    if (!client) return childSpan;
    if ($euvlx.hasSpanStreamingEnabled(client) && childSpan instanceof $4wZ5i.SentryNonRecordingSpan) {
        if (parentSpan instanceof $4wZ5i.SentryNonRecordingSpan && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, 'span');
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = 'sample_rate';
            client.recordDroppedEvent('sample_rate', 'span');
        }
    }
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit('spanEnd', childSpan);
        client.emit('afterSpanEnd', childSpan);
    }
    return childSpan;
}
function $696259a55cfc6a17$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = $jdkFc._getSpanForScope(scope);
    if (!span) return undefined;
    const client = $d2jrf.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $inXyb.getRootSpan(span);
    return span;
}
function $696259a55cfc6a17$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $696259a55cfc6a17$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function $696259a55cfc6a17$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$euvlx.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $jd6mp.shouldIgnoreSpan({
        description: spanArguments.name || '',
        op: spanArguments.attributes?.[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $696259a55cfc6a17$var$_isIgnoredSpan(span) {
    return span instanceof $4wZ5i.SentryNonRecordingSpan && span.dropReason === 'ignored';
}
function $696259a55cfc6a17$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$696259a55cfc6a17$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $696259a55cfc6a17$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $696259a55cfc6a17$var$continueTrace;
module.exports.startInactiveSpan = $696259a55cfc6a17$var$startInactiveSpan;
module.exports.startNewTrace = $696259a55cfc6a17$var$startNewTrace;
module.exports.startSpan = $696259a55cfc6a17$var$startSpan;
module.exports.startSpanManual = $696259a55cfc6a17$var$startSpanManual;
module.exports.suppressTracing = $696259a55cfc6a17$var$suppressTracing;
module.exports.withActiveSpan = $696259a55cfc6a17$var$withActiveSpan;

});
parcelRegister("hLiMU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d5IBn = parcelRequire("d5IBn");

var $dpKhO = parcelRequire("dpKhO");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $cee566526bedc616$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $cee566526bedc616$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $cee566526bedc616$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($dpKhO.isThenable(value)) return $d5IBn.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $cee566526bedc616$var$handleCallbackErrors;

});

parcelRegister("fF4EW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $6tBvR = parcelRequire("6tBvR");

var $h7UoA = parcelRequire("h7UoA");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $b66e4c9892c5c078$var$sampleSpan(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!$6tBvR.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = $h7UoA.parseSampleRate(sampleRate);
    if (parsedSampleRate === undefined) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $b66e4c9892c5c078$var$sampleSpan;

});



parcelRegister("hg4dc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6zIGl = parcelRequire("6zIGl");

var $5AcnF = parcelRequire("5AcnF");

var $gy40E = parcelRequire("gy40E");

var $inXyb = parcelRequire("inXyb");

var $l0ddg = parcelRequire("l0ddg");

var $1zgsW = parcelRequire("1zgsW");
/**
 * Captures a span and returns a JSON representation to be enqueued for sending.
 *
 * IMPORTANT: This function converts the span to JSON immediately to avoid writing
 * to an already-ended OTel span instance (which is blocked by the OTel Span class).
 *
 * @returns the final serialized span with a reference to its segment span. This reference
 * is needed later on to compute the DSC for the span envelope.
 */ function $c90732a93e9401d9$var$captureSpan(span, client) {
    // Convert to JSON FIRST - we cannot write to an already-ended span
    const spanJSON = $inXyb.spanToStreamedSpanJSON(span);
    const segmentSpan = $inXyb.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $inXyb.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $l0ddg.getCapturedScopesOnSpan(span);
    const finalScopeData = $5AcnF.getCombinedScopeData(spanIsolationScope, spanScope);
    $c90732a93e9401d9$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    // Backfill span data from OTel semantic conventions when not explicitly set.
    // OTel-originated spans don't have sentry.op, description, etc. — the non-streamed path
    // infers these in the SentrySpanExporter, but streamed spans skip the exporter entirely.
    // Access `kind` via duck-typing — OTel span objects have this property but it's not on Sentry's Span type.
    // This must run before all hooks and beforeSendSpan so that user callbacks can see and override inferred values.
    const spanKind = span.kind;
    $c90732a93e9401d9$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) // Allow hook subscribers to mutate the segment span JSON
    // This also invokes the `processSegmentSpan` hook of all integrations
    client.emit('processSegmentSpan', spanJSON);
    // This allows hook subscribers to mutate the span JSON
    // This also invokes the `processSpan` hook of all integrations
    client.emit('processSpan', spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $1zgsW.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $c90732a93e9401d9$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    // Backfill sentry.span.source from sentry.source. Only `sentry.span.source` is respected by Sentry.
    // TODO(v11): Remove this backfill once we renamed SEMANTIC_ATTRIBUTE_SENTRY_SOURCE to sentry.span.source
    const spanNameSource = processedSpan.attributes?.[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $c90732a93e9401d9$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        'sentry.span.source': spanNameSource
    });
    return {
        ...$inXyb.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
/**
 * Safely set attributes on a span JSON.
 * If an attribute already exists, it will not be overwritten.
 */ function $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $c90732a93e9401d9$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    // avoid overwriting any previously set attributes (from users or potentially our SDK instrumentation)
    $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$6zIGl.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$6zIGl.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$6zIGl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$6zIGl.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
/**
 * Apply a user-provided beforeSendSpan callback to a span JSON.
 */ function $c90732a93e9401d9$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $inXyb.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
// OTel SpanKind values (numeric to avoid importing from @opentelemetry/api)
const $c90732a93e9401d9$var$SPAN_KIND_SERVER = 1;
const $c90732a93e9401d9$var$SPAN_KIND_CLIENT = 2;
/**
 * Infer and backfill span data from OTel semantic conventions.
 * This mirrors what the `SentrySpanExporter` does for non-streamed spans via `getSpanData`/`inferSpanData`.
 * Streamed spans skip the exporter, so we do the inference here during capture.
 *
 * Backfills: `sentry.op`, `sentry.source`, and `name` (description).
 * Uses `safeSetSpanJSONAttributes` so explicitly set attributes are never overwritten.
 */ /** Exported only for tests. */ function $c90732a93e9401d9$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes['http.request.method'] || attributes['http.method'];
    if (httpMethod) {
        $c90732a93e9401d9$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes['db.system.name'] || attributes['db.system'];
    const opIsCache = typeof attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP] === 'string' && `${attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith('cache.');
    if (dbSystem && !opIsCache) {
        $c90732a93e9401d9$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes['rpc.service']) {
        $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'rpc'
        });
        return;
    }
    if (attributes['messaging.system']) {
        $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'message'
        });
        return;
    }
    const faasTrigger = attributes['faas.trigger'];
    if (faasTrigger) $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${faasTrigger}`
    });
}
function $c90732a93e9401d9$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    // Infer op: http.client, http.server, or just http
    const opParts = [
        'http'
    ];
    if (spanKind === $c90732a93e9401d9$var$SPAN_KIND_CLIENT) opParts.push('client');
    else if (spanKind === $c90732a93e9401d9$var$SPAN_KIND_SERVER) opParts.push('server');
    if (attributes['sentry.http.prefetch']) opParts.push('prefetch');
    $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: opParts.join('.')
    });
    // If the user set a custom span name via updateSpanName(), apply it — OTel instrumentation
    // may have overwritten span.name after the user set it, so we restore from the attribute.
    const customName = attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === 'string') {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === 'custom') return;
    const httpRoute = attributes['http.route'];
    if (typeof httpRoute === 'string') {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route'
        });
    } else {
        // Infer span name from URL attributes, matching the non-streamed exporter's behavior.
        // Only overwrite the name for OTel spans (known spanKind)
        if (spanKind === $c90732a93e9401d9$var$SPAN_KIND_CLIENT || spanKind === $c90732a93e9401d9$var$SPAN_KIND_SERVER) {
            const urlPath = $c90732a93e9401d9$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url'
        });
    }
}
/**
 * Extract a URL path from span attributes for use in the span name.
 * Mirrors the logic in the non-streamed exporter's `getSanitizedUrl`.
 */ function $c90732a93e9401d9$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes['http.url'] || attributes['url.full'];
    const httpTarget = attributes['http.target'];
    const parsedUrl = typeof httpUrl === 'string' ? $gy40E.parseUrl(httpUrl) : undefined;
    const sanitizedUrl = parsedUrl ? $gy40E.getSanitizedUrlString(parsedUrl) : undefined;
    // For server spans, prefer the relative target path
    if (spanKind === $c90732a93e9401d9$var$SPAN_KIND_SERVER && typeof httpTarget === 'string') return $gy40E.stripUrlQueryAndFragment(httpTarget);
    // For client spans (and others), use the full sanitized URL
    if (sanitizedUrl) return sanitizedUrl;
    // Fall back to target if no full URL is available
    if (typeof httpTarget === 'string') return $gy40E.stripUrlQueryAndFragment(httpTarget);
    return undefined;
}
function $c90732a93e9401d9$var$inferDbSpanData(spanJSON, attributes) {
    $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db'
    });
    // If the user set a custom span name via updateSpanName(), apply it.
    const customName = attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === 'string') {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === 'custom') return;
    const statement = attributes['db.statement'];
    if (statement) {
        spanJSON.name = `${statement}`;
        $c90732a93e9401d9$var$safeSetSpanJSONAttributes(spanJSON, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'task'
        });
    }
}
module.exports.applyBeforeSendSpanCallback = $c90732a93e9401d9$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $c90732a93e9401d9$var$captureSpan;
module.exports.inferSpanDataFromOtelAttributes = $c90732a93e9401d9$var$inferSpanDataFromOtelAttributes;
module.exports.safeSetSpanJSONAttributes = $c90732a93e9401d9$var$safeSetSpanJSONAttributes;

});
parcelRegister("5AcnF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $eW0HJ = parcelRequire("eW0HJ");

var $agH01 = parcelRequire("agH01");

var $inXyb = parcelRequire("inXyb");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $4109eb15b06e7c31$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $4109eb15b06e7c31$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $4109eb15b06e7c31$var$applySpanToEvent(event, span);
    $4109eb15b06e7c31$var$applyFingerprintToEvent(event, fingerprint);
    $4109eb15b06e7c31$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $4109eb15b06e7c31$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $4109eb15b06e7c31$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, 'extra', extra);
    $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, 'tags', tags);
    $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, 'attributes', attributes);
    $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, 'user', user);
    $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, 'contexts', contexts);
    data.sdkProcessingMetadata = $agH01.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $4109eb15b06e7c31$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $agH01.merge(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $4109eb15b06e7c31$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $d2jrf.getGlobalScope().getScopeData();
    isolationScope && $4109eb15b06e7c31$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $4109eb15b06e7c31$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $4109eb15b06e7c31$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $4109eb15b06e7c31$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $4109eb15b06e7c31$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $4109eb15b06e7c31$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $inXyb.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $eW0HJ.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $inXyb.getRootSpan(span);
    const transactionName = $inXyb.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $4109eb15b06e7c31$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $4109eb15b06e7c31$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $4109eb15b06e7c31$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $4109eb15b06e7c31$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $4109eb15b06e7c31$var$mergeScopeData;

});

parcelRegister("gy40E", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6zIGl = parcelRequire("6zIGl");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $c0c2ee8000355844$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $c0c2ee8000355844$var$isURLObjectRelative(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $c0c2ee8000355844$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $c0c2ee8000355844$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $c0c2ee8000355844$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($c0c2ee8000355844$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $c0c2ee8000355844$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $c0c2ee8000355844$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $c0c2ee8000355844$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[$6zIGl.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$c0c2ee8000355844$var$isURLObjectRelative(urlObject)) {
            attributes[$6zIGl.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $c0c2ee8000355844$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $c0c2ee8000355844$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $c0c2ee8000355844$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $c0c2ee8000355844$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $c0c2ee8000355844$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $c0c2ee8000355844$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $c0c2ee8000355844$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $c0c2ee8000355844$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $c0c2ee8000355844$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $c0c2ee8000355844$var$parseStringToURLObject;
module.exports.parseUrl = $c0c2ee8000355844$var$parseUrl;
module.exports.stripDataUrlContent = $c0c2ee8000355844$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $c0c2ee8000355844$var$stripUrlQueryAndFragment;

});


parcelRegister("lCPaR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $l5e6x = parcelRequire("l5e6x");

var $92XmH = parcelRequire("92XmH");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");

var $bCreQ = parcelRequire("bCreQ");

var $lbXYN = parcelRequire("lbXYN");

var $5AcnF = parcelRequire("5AcnF");

var $8OzMM = parcelRequire("8OzMM");

var $5xpfH = parcelRequire("5xpfH");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fbe4d7b6ade84cd2$var$captureException(exception, hint) {
    return $d2jrf.getCurrentScope().captureException(exception, $lbXYN.parseEventHintOrCaptureContext(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fbe4d7b6ade84cd2$var$captureMessage(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $d2jrf.getCurrentScope().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fbe4d7b6ade84cd2$var$captureEvent(event, hint) {
    return $d2jrf.getCurrentScope().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $fbe4d7b6ade84cd2$var$setContext(name, context) {
    $d2jrf.getIsolationScope().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $fbe4d7b6ade84cd2$var$setExtras(extras) {
    $d2jrf.getIsolationScope().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $fbe4d7b6ade84cd2$var$setExtra(key, extra) {
    $d2jrf.getIsolationScope().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $fbe4d7b6ade84cd2$var$setTags(tags) {
    $d2jrf.getIsolationScope().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $fbe4d7b6ade84cd2$var$setTag(key, value) {
    $d2jrf.getIsolationScope().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $fbe4d7b6ade84cd2$var$setUser(user) {
    $d2jrf.getIsolationScope().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $fbe4d7b6ade84cd2$var$setConversationId(conversationId) {
    $d2jrf.getIsolationScope().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $fbe4d7b6ade84cd2$var$lastEventId() {
    return $d2jrf.getIsolationScope().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fbe4d7b6ade84cd2$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $d2jrf.getCurrentScope();
    const client = $d2jrf.getClient();
    if (!client) $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $bCreQ.uuid4();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fbe4d7b6ade84cd2$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $fbe4d7b6ade84cd2$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = $8OzMM.timestampInSeconds();
        function finishCheckIn(status) {
            $fbe4d7b6ade84cd2$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $8OzMM.timestampInSeconds() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ($dpKhO.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return $d2jrf.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $92XmH.startNewTrace(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fbe4d7b6ade84cd2$var$flush(timeout) {
    const client = $d2jrf.getClient();
    if (client) return client.flush(timeout);
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fbe4d7b6ade84cd2$var$close(timeout) {
    const client = $d2jrf.getClient();
    if (client) return client.close(timeout);
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fbe4d7b6ade84cd2$var$isInitialized() {
    return !!$d2jrf.getClient();
}
/** If the SDK is initialized & enabled. */ function $fbe4d7b6ade84cd2$var$isEnabled() {
    const client = $d2jrf.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $fbe4d7b6ade84cd2$var$addEventProcessor(callback) {
    $d2jrf.getIsolationScope().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fbe4d7b6ade84cd2$var$startSession(context) {
    const isolationScope = $d2jrf.getIsolationScope();
    const { user: user } = $5AcnF.getCombinedScopeData(isolationScope, $d2jrf.getCurrentScope());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = $5xpfH.GLOBAL_OBJ.navigator || {};
    const session$1 = $l5e6x.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') $l5e6x.updateSession(currentSession, {
        status: 'exited'
    });
    $fbe4d7b6ade84cd2$var$endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session$1);
    return session$1;
}
/**
 * End the session on the current isolation scope.
 */ function $fbe4d7b6ade84cd2$var$endSession() {
    const isolationScope = $d2jrf.getIsolationScope();
    const currentScope = $d2jrf.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $l5e6x.closeSession(session$1);
    $fbe4d7b6ade84cd2$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fbe4d7b6ade84cd2$var$_sendSessionUpdate() {
    const isolationScope = $d2jrf.getIsolationScope();
    const client = $d2jrf.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fbe4d7b6ade84cd2$var$captureSession(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fbe4d7b6ade84cd2$var$endSession();
        return;
    }
    // only send the update
    $fbe4d7b6ade84cd2$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $fbe4d7b6ade84cd2$var$addEventProcessor;
module.exports.captureCheckIn = $fbe4d7b6ade84cd2$var$captureCheckIn;
module.exports.captureEvent = $fbe4d7b6ade84cd2$var$captureEvent;
module.exports.captureException = $fbe4d7b6ade84cd2$var$captureException;
module.exports.captureMessage = $fbe4d7b6ade84cd2$var$captureMessage;
module.exports.captureSession = $fbe4d7b6ade84cd2$var$captureSession;
module.exports.close = $fbe4d7b6ade84cd2$var$close;
module.exports.endSession = $fbe4d7b6ade84cd2$var$endSession;
module.exports.flush = $fbe4d7b6ade84cd2$var$flush;
module.exports.isEnabled = $fbe4d7b6ade84cd2$var$isEnabled;
module.exports.isInitialized = $fbe4d7b6ade84cd2$var$isInitialized;
module.exports.lastEventId = $fbe4d7b6ade84cd2$var$lastEventId;
module.exports.setContext = $fbe4d7b6ade84cd2$var$setContext;
module.exports.setConversationId = $fbe4d7b6ade84cd2$var$setConversationId;
module.exports.setExtra = $fbe4d7b6ade84cd2$var$setExtra;
module.exports.setExtras = $fbe4d7b6ade84cd2$var$setExtras;
module.exports.setTag = $fbe4d7b6ade84cd2$var$setTag;
module.exports.setTags = $fbe4d7b6ade84cd2$var$setTags;
module.exports.setUser = $fbe4d7b6ade84cd2$var$setUser;
module.exports.startSession = $fbe4d7b6ade84cd2$var$startSession;
module.exports.withMonitor = $fbe4d7b6ade84cd2$var$withMonitor;

});
parcelRegister("lbXYN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $jO72z = parcelRequire("jO72z");

var $jJZWw = parcelRequire("jJZWw");

var $6kYtN = parcelRequire("6kYtN");

var $bX9aB = parcelRequire("bX9aB");

var $bCreQ = parcelRequire("bCreQ");

var $iCGkd = parcelRequire("iCGkd");

var $5AcnF = parcelRequire("5AcnF");

var $8wj7Q = parcelRequire("8wj7Q");

var $f2suz = parcelRequire("f2suz");

var $8OzMM = parcelRequire("8OzMM");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $f6d926b9f651e1f0$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $bCreQ.uuid4(),
        timestamp: event.timestamp || $8OzMM.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $f6d926b9f651e1f0$var$applyClientOptions(prepared, options);
    $f6d926b9f651e1f0$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $f6d926b9f651e1f0$var$applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $f6d926b9f651e1f0$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $bCreQ.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = $5AcnF.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $5AcnF.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $f2suz.resolvedSyncPromise(prepared) : $jJZWw.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $f6d926b9f651e1f0$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $f6d926b9f651e1f0$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $f6d926b9f651e1f0$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || $jO72z.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $8wj7Q.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = $8wj7Q.truncate(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $f6d926b9f651e1f0$var$applyDebugIds(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = $bX9aB.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $f6d926b9f651e1f0$var$applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $f6d926b9f651e1f0$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $f6d926b9f651e1f0$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $iCGkd.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $iCGkd.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $iCGkd.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $iCGkd.normalize(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = $iCGkd.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $iCGkd.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $iCGkd.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $f6d926b9f651e1f0$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $6kYtN.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $f6d926b9f651e1f0$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($f6d926b9f651e1f0$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($f6d926b9f651e1f0$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $f6d926b9f651e1f0$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $6kYtN.Scope || typeof hint === 'function';
}
const $f6d926b9f651e1f0$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $f6d926b9f651e1f0$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$f6d926b9f651e1f0$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $f6d926b9f651e1f0$var$applyClientOptions;
module.exports.applyDebugIds = $f6d926b9f651e1f0$var$applyDebugIds;
module.exports.applyDebugMeta = $f6d926b9f651e1f0$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $f6d926b9f651e1f0$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $f6d926b9f651e1f0$var$prepareEvent;

});
parcelRegister("jJZWw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");

var $f2suz = parcelRequire("f2suz");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $e5f244d916cdf98c$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $e5f244d916cdf98c$var$_notifyEventProcessors(event, hint, processors, index);
        return $dpKhO.isThenable(result) ? result : $f2suz.resolvedSyncPromise(result);
    } catch (error) {
        return $f2suz.rejectedSyncPromise(error);
    }
}
function $e5f244d916cdf98c$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $9XOi0.DEBUG_BUILD && result === null && $3iQ48.debug.log(`Event processor "${processor.id || '?'}" dropped event`);
    if ($dpKhO.isThenable(result)) return result.then((final)=>$e5f244d916cdf98c$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $e5f244d916cdf98c$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $e5f244d916cdf98c$var$notifyEventProcessors;

});
parcelRegister("f2suz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $02d34f0bdae1621a$var$STATE_PENDING = 0;
const $02d34f0bdae1621a$var$STATE_RESOLVED = 1;
const $02d34f0bdae1621a$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $02d34f0bdae1621a$var$resolvedSyncPromise(value) {
    return new $02d34f0bdae1621a$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $02d34f0bdae1621a$var$rejectedSyncPromise(reason) {
    return new $02d34f0bdae1621a$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $02d34f0bdae1621a$var$SyncPromise {
    constructor(executor){
        this._state = $02d34f0bdae1621a$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $02d34f0bdae1621a$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $02d34f0bdae1621a$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $02d34f0bdae1621a$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $02d34f0bdae1621a$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $02d34f0bdae1621a$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $02d34f0bdae1621a$var$STATE_PENDING) return;
            if ($dpKhO.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($02d34f0bdae1621a$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($02d34f0bdae1621a$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $02d34f0bdae1621a$var$SyncPromise;
module.exports.rejectedSyncPromise = $02d34f0bdae1621a$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $02d34f0bdae1621a$var$resolvedSyncPromise;

});


parcelRegister("bX9aB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9jmDw = parcelRequire("9jmDw");

var $5xpfH = parcelRequire("5xpfH");
let $8b3c515edae30420$var$parsedStackResults;
let $8b3c515edae30420$var$lastSentryKeysCount;
let $8b3c515edae30420$var$lastNativeKeysCount;
let $8b3c515edae30420$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $8b3c515edae30420$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $5xpfH.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $5xpfH.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($8b3c515edae30420$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $8b3c515edae30420$var$lastSentryKeysCount && nativeDebugIdKeys.length === $8b3c515edae30420$var$lastNativeKeysCount) return $8b3c515edae30420$var$cachedFilenameDebugIds;
    $8b3c515edae30420$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $8b3c515edae30420$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $8b3c515edae30420$var$cachedFilenameDebugIds = {};
    if (!$8b3c515edae30420$var$parsedStackResults) $8b3c515edae30420$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $8b3c515edae30420$var$parsedStackResults?.[key];
            if (result && $8b3c515edae30420$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $8b3c515edae30420$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($8b3c515edae30420$var$parsedStackResults) $8b3c515edae30420$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $8b3c515edae30420$var$cachedFilenameDebugIds && $8b3c515edae30420$var$parsedStackResults) {
                        $8b3c515edae30420$var$cachedFilenameDebugIds[filename] = debugId;
                        $8b3c515edae30420$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $8b3c515edae30420$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $8b3c515edae30420$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $8b3c515edae30420$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $9jmDw.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $8b3c515edae30420$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $8b3c515edae30420$var$getFilenameToDebugIdMap;

});



parcelRegister("03xMg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hO292 = parcelRequire("hO292");
const $00aa7b681fac7e00$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $00aa7b681fac7e00$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $00aa7b681fac7e00$var$_getIngestEndpoint(dsn) {
    return `${$00aa7b681fac7e00$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $00aa7b681fac7e00$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $00aa7b681fac7e00$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $00aa7b681fac7e00$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$00aa7b681fac7e00$var$_getIngestEndpoint(dsn)}?${$00aa7b681fac7e00$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $00aa7b681fac7e00$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $hO292.makeDsn(dsnLike);
    if (!dsn$1) return '';
    const endpoint = `${$00aa7b681fac7e00$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$hO292.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $00aa7b681fac7e00$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $00aa7b681fac7e00$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $00aa7b681fac7e00$var$getReportDialogEndpoint;

});

parcelRegister("ddH6b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $03xMg = parcelRequire("03xMg");

var $jO72z = parcelRequire("jO72z");

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $8Uw8o = parcelRequire("8Uw8o");

var $dHcrw = parcelRequire("dHcrw");

var $a3J7x = parcelRequire("a3J7x");

var $3GDsH = parcelRequire("3GDsH");

var $l5e6x = parcelRequire("l5e6x");

var $eW0HJ = parcelRequire("eW0HJ");

var $1zgsW = parcelRequire("1zgsW");

var $loJbJ = parcelRequire("loJbJ");

var $4Gc3h = parcelRequire("4Gc3h");

var $3cta3 = parcelRequire("3cta3");

var $3iQ48 = parcelRequire("3iQ48");

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");

var $iy0lZ = parcelRequire("iy0lZ");

var $dpKhO = parcelRequire("dpKhO");

var $agH01 = parcelRequire("agH01");

var $bCreQ = parcelRequire("bCreQ");

var $h7UoA = parcelRequire("h7UoA");

var $lbXYN = parcelRequire("lbXYN");

var $6UPME = parcelRequire("6UPME");

var $8PEgQ = parcelRequire("8PEgQ");

var $jd6mp = parcelRequire("jd6mp");

var $inXyb = parcelRequire("inXyb");

var $f2suz = parcelRequire("f2suz");

var $122mK = parcelRequire("122mK");

var $l17wC = parcelRequire("l17wC");
/* eslint-disable max-lines */ const $99fdebcaea3c1e50$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $99fdebcaea3c1e50$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $99fdebcaea3c1e50$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $99fdebcaea3c1e50$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $99fdebcaea3c1e50$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $99fdebcaea3c1e50$var$_makeInternalError(message) {
    return {
        message: message,
        [$99fdebcaea3c1e50$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $99fdebcaea3c1e50$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$99fdebcaea3c1e50$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $99fdebcaea3c1e50$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $99fdebcaea3c1e50$var$INTERNAL_ERROR_SYMBOL in error;
}
function $99fdebcaea3c1e50$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $99fdebcaea3c1e50$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $99fdebcaea3c1e50$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = $122mK.safeUnref(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $99fdebcaea3c1e50$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $99fdebcaea3c1e50$var$Client {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $6UPME.makePromiseBuffer(options.transportOptions?.bufferSize ?? $4Gc3h.DEFAULT_TRANSPORT_BUFFER_SIZE);
        if (options.dsn) this._dsn = $hO292.makeDsn(options.dsn);
        else $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = $03xMg.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $99fdebcaea3c1e50$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $99fdebcaea3c1e50$var$estimateLogSizeInBytes, $a3J7x._INTERNAL_flushLogsBuffer);
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $99fdebcaea3c1e50$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $99fdebcaea3c1e50$var$estimateMetricSizeInBytes, $3GDsH._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $bCreQ.uuid4();
        // ensure we haven't captured this very object before
        if ($bCreQ.checkOrSetAlreadyCaught(exception)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log($99fdebcaea3c1e50$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $bCreQ.uuid4(),
            ...hint
        };
        const eventMessage = $dpKhO.isParameterizedString(message) ? message : String(message);
        const isMessage = $dpKhO.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $bCreQ.uuid4();
        // ensure we haven't captured this very object before
        if (hint?.originalException && $bCreQ.checkOrSetAlreadyCaught(hint.originalException)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log($99fdebcaea3c1e50$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $99fdebcaea3c1e50$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        // After sending, we set init false to indicate it's not the first occurrence
        $l5e6x.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        // Emit `flush` unconditionally so weight-based log/metric flushers drain
        // their buffers and clear their idle timers, even when no transport is
        // configured (e.g. no DSN).
        this.emit('flush');
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $a3J7x._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        // This hook takes care of only installing if not already installed
        $dHcrw.setupIntegration(this, integration$1, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) $dHcrw.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        // Extract gen_ai spans from transaction and convert to span v2 format.
        // This mutates event.spans to remove the extracted spans.
        const genAiSpanItem = $loJbJ.extractGenAiSpansFromEvent(event, this);
        let env = $8Uw8o.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $cp5Oe.addItemToEnvelope(env, $cp5Oe.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $cp5Oe.addItemToEnvelope(env, genAiSpanItem);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $jO72z.DEFAULT_ENVIRONMENT } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn($99fdebcaea3c1e50$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn($99fdebcaea3c1e50$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = $8Uw8o.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Error while sending envelope:', reason);
            return {};
        }
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Transport disabled');
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {
    // No-op in base class - subclasses override to implement cleanup registration
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $dHcrw.setupIntegrations(this, integrations);
        $dHcrw.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session$1.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $l5e6x.updateSession(session$1, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $lbXYN.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$d2jrf.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $eW0HJ.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $d2jrf.getCurrentScope(), isolationScope = $d2jrf.getIsolationScope()) {
        if ($9XOi0.DEBUG_BUILD && $99fdebcaea3c1e50$var$isErrorEvent(event)) $3iQ48.debug.log(`Captured error event \`${$iy0lZ.getPossibleEventMessages(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($9XOi0.DEBUG_BUILD) {
                if ($99fdebcaea3c1e50$var$_isDoNotSendEventError(reason)) $3iQ48.debug.log(reason.message);
                else if ($99fdebcaea3c1e50$var$_isInternalError(reason)) $3iQ48.debug.warn(reason.message);
                else $3iQ48.debug.warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $99fdebcaea3c1e50$var$isTransactionEvent(event);
        const isError = $99fdebcaea3c1e50$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : $h7UoA.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && $8PEgQ.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return $f2suz.rejectedSyncPromise($99fdebcaea3c1e50$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $99fdebcaea3c1e50$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $99fdebcaea3c1e50$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $99fdebcaea3c1e50$var$processBeforeSend(this, options, prepared, hint);
            return $99fdebcaea3c1e50$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $99fdebcaea3c1e50$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($99fdebcaea3c1e50$var$_isDoNotSendEventError(reason) || $99fdebcaea3c1e50$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $99fdebcaea3c1e50$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $6UPME.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('No dsn provided, will not send outcomes');
            return;
        }
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Sending outcomes:', outcomes);
        const envelope = $3cta3.createClientReportEnvelope(outcomes, this._options.tunnel && $hO292.dsnToString(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $99fdebcaea3c1e50$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $99fdebcaea3c1e50$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($dpKhO.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$dpKhO.isPlainObject(event) && event !== null) throw $99fdebcaea3c1e50$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $99fdebcaea3c1e50$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$dpKhO.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $99fdebcaea3c1e50$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $99fdebcaea3c1e50$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$1zgsW.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($99fdebcaea3c1e50$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($99fdebcaea3c1e50$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan$1 || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = $l17wC.convertTransactionEventToSpanJson(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && $jd6mp.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $inXyb.showSpanDropWarning();
                else // update event with processed root span values
                processedEvent = $agH01.merge(event, $l17wC.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && $jd6mp.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $jd6mp.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $inXyb.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $99fdebcaea3c1e50$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $99fdebcaea3c1e50$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $99fdebcaea3c1e50$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $99fdebcaea3c1e50$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $99fdebcaea3c1e50$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $99fdebcaea3c1e50$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $99fdebcaea3c1e50$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $99fdebcaea3c1e50$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($dpKhO.isPrimitive(value)) weight += $99fdebcaea3c1e50$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $99fdebcaea3c1e50$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}
module.exports.Client = $99fdebcaea3c1e50$var$Client;

});
parcelRegister("dHcrw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");
const $9f88f1643d72b4bc$var$installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $9f88f1643d72b4bc$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $9f88f1643d72b4bc$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $9f88f1643d72b4bc$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $9f88f1643d72b4bc$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $9f88f1643d72b4bc$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $9f88f1643d72b4bc$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $9f88f1643d72b4bc$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$9f88f1643d72b4bc$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $9f88f1643d72b4bc$var$installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        'processSpan',
        'processSegmentSpan'
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === 'function') // The cast is needed because TS can't resolve overloads when the discriminant is a union type.
        // Both overloads have the same callback signature so this is safe.
        client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $9f88f1643d72b4bc$var$addIntegration(integration) {
    const client = $d2jrf.getClient();
    if (!client) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $9f88f1643d72b4bc$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $9f88f1643d72b4bc$var$addIntegration;
module.exports.afterSetupIntegrations = $9f88f1643d72b4bc$var$afterSetupIntegrations;
module.exports.defineIntegration = $9f88f1643d72b4bc$var$defineIntegration;
module.exports.getIntegrationsToSetup = $9f88f1643d72b4bc$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $9f88f1643d72b4bc$var$installedIntegrations;
module.exports.setupIntegration = $9f88f1643d72b4bc$var$setupIntegration;
module.exports.setupIntegrations = $9f88f1643d72b4bc$var$setupIntegrations;

});

parcelRegister("a3J7x", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bcKiE = parcelRequire("bcKiE");

var $dLES3 = parcelRequire("dLES3");

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");

var $5AcnF = parcelRequire("5AcnF");

var $jdkFc = parcelRequire("jdkFc");

var $8OzMM = parcelRequire("8OzMM");

var $b5emD = parcelRequire("b5emD");

var $lOexp = parcelRequire("lOexp");

var $8bGER = parcelRequire("8bGER");

var $BoVLp = parcelRequire("BoVLp");
const $752d2f39633afd40$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $752d2f39633afd40$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $752d2f39633afd40$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $752d2f39633afd40$var$_getBufferMap();
    const logBuffer = $752d2f39633afd40$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $752d2f39633afd40$var$MAX_LOG_BUFFER_SIZE) {
        $752d2f39633afd40$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $752d2f39633afd40$var$_INTERNAL_captureLog(beforeLog, currentScope = $d2jrf.getCurrentScope(), captureSerializedLog = $752d2f39633afd40$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $d2jrf.getClient();
    if (!client) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = $lOexp._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $5AcnF.getCombinedScopeData($d2jrf.getIsolationScope(), currentScope);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ($dpKhO.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $jdkFc._getSpanForScope(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $752d2f39633afd40$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? $3iQ48.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $8OzMM.timestampInSeconds();
    const sequenceAttr = $b5emD.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $8bGER.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: {
            ...$bcKiE.serializeAttributes(scopeAttributes),
            ...$bcKiE.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $752d2f39633afd40$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $752d2f39633afd40$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $BoVLp.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), clientOptions.sendDefaultPii);
    // Clear the log buffer after envelopes have been constructed.
    $752d2f39633afd40$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope$1);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $752d2f39633afd40$var$_INTERNAL_getLogBuffer(client) {
    return $752d2f39633afd40$var$_getBufferMap().get(client);
}
function $752d2f39633afd40$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return $dLES3.getGlobalSingleton('clientToLogBufferMap', ()=>new WeakMap());
}
module.exports._INTERNAL_captureLog = $752d2f39633afd40$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $752d2f39633afd40$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $752d2f39633afd40$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $752d2f39633afd40$var$_INTERNAL_getLogBuffer;

});
parcelRegister("b5emD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $811b4dc3a3a78fe3$var$SEQUENCE_ATTR_KEY = 'sentry.timestamp.sequence';
let $811b4dc3a3a78fe3$var$_sequenceNumber = 0;
let $811b4dc3a3a78fe3$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $811b4dc3a3a78fe3$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($811b4dc3a3a78fe3$var$_previousTimestampMs !== undefined && nowMs !== $811b4dc3a3a78fe3$var$_previousTimestampMs) $811b4dc3a3a78fe3$var$_sequenceNumber = 0;
    const value = $811b4dc3a3a78fe3$var$_sequenceNumber;
    $811b4dc3a3a78fe3$var$_sequenceNumber++;
    $811b4dc3a3a78fe3$var$_previousTimestampMs = nowMs;
    return {
        key: $811b4dc3a3a78fe3$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: 'integer'
        }
    };
}
module.exports.getSequenceAttribute = $811b4dc3a3a78fe3$var$getSequenceAttribute;

});

parcelRegister("lOexp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $eW0HJ = parcelRequire("eW0HJ");

var $inXyb = parcelRequire("inXyb");
/** Extract trace information from scope */ function $fe098b67b4ce7342$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return $d2jrf.withScope(scope, ()=>{
        const span = $inXyb.getActiveSpan();
        const traceContext = span ? $inXyb.spanToTraceContext(span) : $d2jrf.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $eW0HJ.getDynamicSamplingContextFromSpan(span) : $eW0HJ.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $fe098b67b4ce7342$var$_getTraceInfoFromScope;

});

parcelRegister("8bGER", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $5f6070d1b844bb29$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $5f6070d1b844bb29$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("BoVLp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");

var $9z62o = parcelRequire("9z62o");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 *                        Only emitted as `ingest_settings` in browser environments.
 * @returns The created log container envelope item.
 */ function $0706cb871d321825$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? 'auto' : 'never';
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            version: 2,
            ...$9z62o.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 * @returns The created envelope.
 */ function $0706cb871d321825$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $hO292.dsnToString(dsn$1);
    return $cp5Oe.createEnvelope(headers, [
        $0706cb871d321825$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $0706cb871d321825$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $0706cb871d321825$var$createLogEnvelope;

});
parcelRegister("9z62o", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $47hMw = parcelRequire("47hMw");

var $5xpfH = parcelRequire("5xpfH");
/**
 * Returns true if we are in the browser.
 */ function $6f6c10dce324c945$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!$47hMw.isNodeEnv() || $6f6c10dce324c945$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $6f6c10dce324c945$var$isElectronNodeRenderer() {
    const process = $5xpfH.GLOBAL_OBJ.process;
    return process?.type === 'renderer';
}
module.exports.isBrowser = $6f6c10dce324c945$var$isBrowser;

});
parcelRegister("47hMw", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1CyzH = parcelRequire("1CyzH");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !$1CyzH.isBrowserBundle() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, 'process');
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {
    // no-empty
    }
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("1CyzH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $12e428e81bb4f121$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $12e428e81bb4f121$var$getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}
module.exports.getSDKSource = $12e428e81bb4f121$var$getSDKSource;
module.exports.isBrowserBundle = $12e428e81bb4f121$var$isBrowserBundle;

});





parcelRegister("3GDsH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bcKiE = parcelRequire("bcKiE");

var $dLES3 = parcelRequire("dLES3");

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $5AcnF = parcelRequire("5AcnF");

var $jdkFc = parcelRequire("jdkFc");

var $8OzMM = parcelRequire("8OzMM");

var $b5emD = parcelRequire("b5emD");

var $lOexp = parcelRequire("lOexp");

var $jpMb6 = parcelRequire("jpMb6");
const $2af3e7a9e62519c0$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $2af3e7a9e62519c0$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $2af3e7a9e62519c0$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $2af3e7a9e62519c0$var$_getBufferMap();
    const metricBuffer = $2af3e7a9e62519c0$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $2af3e7a9e62519c0$var$MAX_METRIC_BUFFER_SIZE) {
        $2af3e7a9e62519c0$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $2af3e7a9e62519c0$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $2af3e7a9e62519c0$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $2af3e7a9e62519c0$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = $lOexp._getTraceInfoFromScope(client, currentScope);
    const span = $jdkFc._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = $8OzMM.timestampInSeconds();
    const sequenceAttr = $b5emD.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$bcKiE.serializeAttributes(scopeAttributes),
            ...$bcKiE.serializeAttributes(metric.attributes, 'skip-undefined'),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $2af3e7a9e62519c0$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $d2jrf.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $2af3e7a9e62519c0$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $d2jrf.getClient();
    if (!client) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = $5AcnF.getCombinedScopeData($d2jrf.getIsolationScope(), currentScope);
    const enrichedMetric = $2af3e7a9e62519c0$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $2af3e7a9e62519c0$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $2af3e7a9e62519c0$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $2af3e7a9e62519c0$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $jpMb6.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), clientOptions.sendDefaultPii);
    // Clear the metric buffer after envelopes have been constructed.
    $2af3e7a9e62519c0$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope$1);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $2af3e7a9e62519c0$var$_INTERNAL_getMetricBuffer(client) {
    return $2af3e7a9e62519c0$var$_getBufferMap().get(client);
}
function $2af3e7a9e62519c0$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return $dLES3.getGlobalSingleton('clientToMetricBufferMap', ()=>new WeakMap());
}
module.exports._INTERNAL_captureMetric = $2af3e7a9e62519c0$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $2af3e7a9e62519c0$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $2af3e7a9e62519c0$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $2af3e7a9e62519c0$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("jpMb6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");

var $9z62o = parcelRequire("9z62o");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 *                        Only emitted as `ingest_settings` in browser environments.
 * @returns The created metric container envelope item.
 */ function $e225b947f9625231$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? 'auto' : 'never';
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            version: 2,
            ...$9z62o.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 * @returns The created envelope.
 */ function $e225b947f9625231$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $hO292.dsnToString(dsn$1);
    return $cp5Oe.createEnvelope(headers, [
        $e225b947f9625231$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $e225b947f9625231$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $e225b947f9625231$var$createMetricEnvelope;

});


parcelRegister("loJbJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9z62o = parcelRequire("9z62o");

var $euvlx = parcelRequire("euvlx");

var $88qag = parcelRequire("88qag");
/**
 * Extracts gen_ai spans from a transaction event, converts them to span v2 format,
 * and returns them as a SpanContainerItem.
 *
 * Only applies to static mode (non-streaming) transactions.
 *
 * WARNING: This function mutates `event.spans` by removing the extracted gen_ai spans
 * from the array. Call this before creating the event envelope so the transaction
 * item does not include the extracted spans.
 */ function $f93ee44782aa7ec6$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== 'transaction' || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || $euvlx.hasSpanStreamingEnabled(client)) return undefined;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith('gen_ai.')) genAiSpans.push($88qag.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return undefined;
    event.spans = remainingSpans;
    const inferSetting = client.getOptions().sendDefaultPii ? 'auto' : 'never';
    return [
        {
            type: 'span',
            item_count: genAiSpans.length,
            content_type: 'application/vnd.sentry.items.span.v2+json'
        },
        {
            version: 2,
            ...$9z62o.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $f93ee44782aa7ec6$var$extractGenAiSpansFromEvent;

});
parcelRegister("88qag", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $inXyb = parcelRequire("inXyb");
/**
 * Converts a v1 SpanJSON (from a legacy transaction) to a serialized v2 StreamedSpan.
 */ function $5ec35dd73c4461fa$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || '',
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === 'ok' || span.status === 'cancelled' ? 'ok' : 'error',
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $inXyb.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $5ec35dd73c4461fa$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("4Gc3h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $cp5Oe = parcelRequire("cp5Oe");

var $6UPME = parcelRequire("6UPME");

var $jMnxI = parcelRequire("jMnxI");
const $36846ee7c5cf8fc8$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $36846ee7c5cf8fc8$var$createTransport(options, makeRequest, buffer = $6UPME.makePromiseBuffer(options.bufferSize || $36846ee7c5cf8fc8$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        $cp5Oe.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $cp5Oe.envelopeItemTypeToDataCategory(type);
            if ($jMnxI.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $cp5Oe.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ($cp5Oe.envelopeContainsItemType(filteredEnvelope, [
                'client_report'
            ])) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $cp5Oe.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $cp5Oe.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $cp5Oe.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.');
                    recordEnvelopeLoss('send_error');
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ($9XOi0.DEBUG_BUILD && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) $3iQ48.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $jMnxI.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $6UPME.SENTRY_BUFFER_FULL_ERROR) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $36846ee7c5cf8fc8$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $36846ee7c5cf8fc8$var$createTransport;

});
parcelRegister("6UPME", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $f2suz = parcelRequire("f2suz");

var $122mK = parcelRequire("122mK");
const $5090243516a4cdd3$var$SENTRY_BUFFER_FULL_ERROR = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $5090243516a4cdd3$var$makePromiseBuffer(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return $f2suz.rejectedSyncPromise($5090243516a4cdd3$var$SENTRY_BUFFER_FULL_ERROR);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return $f2suz.resolvedSyncPromise(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$122mK.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $5090243516a4cdd3$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $5090243516a4cdd3$var$makePromiseBuffer;

});
parcelRegister("122mK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $0c07d02cc7c09f0f$var$safeUnref(timer) {
    if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
    return timer;
}
module.exports.safeUnref = $0c07d02cc7c09f0f$var$safeUnref;

});


parcelRegister("jMnxI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8PEgQ = parcelRequire("8PEgQ");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $e664c3226f320137$var$DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $e664c3226f320137$var$parseRetryAfterHeader(header, now = $8PEgQ.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e664c3226f320137$var$DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $e664c3226f320137$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $e664c3226f320137$var$isRateLimited(limits, dataCategory, now = $8PEgQ.safeDateNow()) {
    return $e664c3226f320137$var$disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $e664c3226f320137$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $8PEgQ.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e664c3226f320137$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $e664c3226f320137$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $e664c3226f320137$var$disabledUntil;
module.exports.isRateLimited = $e664c3226f320137$var$isRateLimited;
module.exports.parseRetryAfterHeader = $e664c3226f320137$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $e664c3226f320137$var$updateRateLimits;

});


parcelRegister("3cta3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cp5Oe = parcelRequire("cp5Oe");

var $8OzMM = parcelRequire("8OzMM");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $25491ce278e2b969$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || $8OzMM.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $cp5Oe.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $25491ce278e2b969$var$createClientReportEnvelope;

});

parcelRegister("iy0lZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $d80bad38512d3a57$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $d80bad38512d3a57$var$getPossibleEventMessages;

});

parcelRegister("l17wC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6zIGl = parcelRequire("6zIGl");
/**
 * Converts a transaction event to a span JSON object.
 */ function $f4cf8746df9711e1$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[$6zIGl.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$6zIGl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $f4cf8746df9711e1$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$6zIGl.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$6zIGl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $f4cf8746df9711e1$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $f4cf8746df9711e1$var$convertTransactionEventToSpanJson;

});


parcelRegister("8m70V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $6155d1a2237ce327$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($9XOi0.DEBUG_BUILD) $3iQ48.debug.enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        $3iQ48.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = $d2jrf.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $6155d1a2237ce327$var$setCurrentClient(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $6155d1a2237ce327$var$setCurrentClient(client) {
    $d2jrf.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $6155d1a2237ce327$var$initAndBind;
module.exports.setCurrentClient = $6155d1a2237ce327$var$setCurrentClient;

});

parcelRegister("eniUo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $cp5Oe = parcelRequire("cp5Oe");

var $jMnxI = parcelRequire("jMnxI");

var $122mK = parcelRequire("122mK");
const $a771e186109bbad9$var$MIN_DELAY = 100; // 100 ms
const $a771e186109bbad9$var$START_DELAY = 5000; // 5 seconds
const $a771e186109bbad9$var$MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $a771e186109bbad9$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('[Offline]:', ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error('No `createStore` function was provided');
        const store = options.createStore(options);
        let retryDelay = $a771e186109bbad9$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ($cp5Oe.envelopeContainsItemType(env, [
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            flushTimer = $122mK.safeUnref(setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.shift();
                if (found) {
                    log('Attempting to send previously queued event');
                    // We should to update the sent_at timestamp to the current time.
                    found[0].sent_at = new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log('Failed to retry sending', e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $a771e186109bbad9$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            // We queue all replay envelopes to avoid multiple replay envelopes being sent at the same time. If one fails, we
            // need to retry them in order.
            if (!isRetry && $cp5Oe.envelopeContainsItemType(envelope$1, [
                'replay_event',
                'replay_recording'
            ])) {
                await store.push(envelope$1);
                flushIn($a771e186109bbad9$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error('Envelope not sent because `shouldSend` callback returned false');
                const result = await transport.send(envelope$1);
                let delay = $a771e186109bbad9$var$MIN_DELAY;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers?.['retry-after']) delay = $jMnxI.parseRetryAfterHeader(result.headers['retry-after']);
                    else if (result.headers?.['x-sentry-rate-limits']) delay = 60000; // 60 seconds
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $a771e186109bbad9$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    // If this envelope was a retry, we want to add it to the front of the queue so it's retried again first.
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log('Error sending. Event queued.', e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = $a771e186109bbad9$var$START_DELAY;
                    flushIn($a771e186109bbad9$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $a771e186109bbad9$var$MIN_DELAY;
module.exports.START_DELAY = $a771e186109bbad9$var$START_DELAY;
module.exports.makeOfflineTransport = $a771e186109bbad9$var$makeOfflineTransport;

});

parcelRegister("52f7V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $03xMg = parcelRequire("03xMg");

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");
/**
 * Key used in event.extra to provide routing information for the multiplexed transport.
 * Should contain an array of `{ dsn: string, release?: string }` objects.
 */ const $3aa8df85f95b7607$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = 'MULTIPLEXED_TRANSPORT_EXTRA_KEY';
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $3aa8df85f95b7607$var$eventFromEnvelope(env, types) {
    let event;
    $cp5Oe.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $3aa8df85f95b7607$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $3aa8df85f95b7607$var$eventFromEnvelope(envelope, [
                    'event',
                    'transaction',
                    'profile',
                    'replay_event'
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $3aa8df85f95b7607$var$overrideDsn(envelope$1, dsn) {
    return $cp5Oe.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 *
 * If no matcher is provided, the transport will look for routing information in
 * `event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY]`, which should contain
 * an array of `{ dsn: string, release?: string }` objects.
 */ function $3aa8df85f95b7607$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        // Use provided matcher or default to simple multiplexed transport behavior
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$3aa8df85f95b7607$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$3aa8df85f95b7607$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$3aa8df85f95b7607$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $hO292.dsnFromString(dsn$1);
                if (!validatedDsn) return undefined;
                const url = $03xMg.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $3aa8df85f95b7607$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    'event'
                ];
                return $3aa8df85f95b7607$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === 'string') return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            // Don't override the DSN in the header for the fallback transport. '' is falsy
            const transportsWithFallback = transports.length ? transports : [
                [
                    '',
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($3aa8df85f95b7607$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $3aa8df85f95b7607$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $3aa8df85f95b7607$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $3aa8df85f95b7607$var$makeMultiplexedTransport;

});

parcelRegister("3pD3m", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");
/**
 * Registry tracking which AI provider modules should skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 */ const $27c2000a1b9a88d6$var$SKIPPED_AI_PROVIDERS = new Set();
/**
 * Mark AI provider modules to skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 *
 * @internal
 * @param modules - Array of npm module names to skip (e.g., '@anthropic-ai/sdk', 'openai')
 *
 * @example
 * ```typescript
 * // In LangChain integration
 * _INTERNAL_skipAiProviderWrapping(['@anthropic-ai/sdk', 'openai', '@google/generative-ai']);
 * ```
 */ function $27c2000a1b9a88d6$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $27c2000a1b9a88d6$var$SKIPPED_AI_PROVIDERS.add(module);
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
/**
 * Check if an AI provider module should skip instrumentation wrapping.
 *
 * @internal
 * @param module - The npm module name (e.g., '@anthropic-ai/sdk', 'openai')
 * @returns true if wrapping should be skipped
 *
 * @example
 * ```typescript
 * // In AI provider instrumentation
 * if (_INTERNAL_shouldSkipAiProviderWrapping('@anthropic-ai/sdk')) {
 *   return Reflect.construct(Original, args); // Don't instrument
 * }
 * ```
 */ function $27c2000a1b9a88d6$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $27c2000a1b9a88d6$var$SKIPPED_AI_PROVIDERS.has(module);
}
/**
 * Clear all AI provider skip registrations.
 *
 * This is automatically called at the start of Sentry.init() to ensure a clean state
 * between different client initializations.
 *
 * @internal
 */ function $27c2000a1b9a88d6$var$_INTERNAL_clearAiProviderSkips() {
    $27c2000a1b9a88d6$var$SKIPPED_AI_PROVIDERS.clear();
    $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Cleared AI provider skip registrations');
}
module.exports._INTERNAL_clearAiProviderSkips = $27c2000a1b9a88d6$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $27c2000a1b9a88d6$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $27c2000a1b9a88d6$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("UogL4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $0a980e7428c5b50d$var$FALSY_ENV_VALUES = new Set([
    'false',
    'f',
    'n',
    'no',
    'off',
    '0'
]);
const $0a980e7428c5b50d$var$TRUTHY_ENV_VALUES = new Set([
    'true',
    't',
    'y',
    'yes',
    'on',
    '1'
]);
/**
 * A helper function which casts an ENV variable value to `true` or `false` using the constants defined above.
 * In strict mode, it may return `null` if the value doesn't match any of the predefined values.
 *
 * @param value The value of the env variable
 * @param options -- Only has `strict` key for now, which requires a strict match for `true` in TRUTHY_ENV_VALUES
 * @returns true/false if the lowercase value matches the predefined values above. If not, null in strict mode,
 *          and Boolean(value) in loose mode.
 */ function $0a980e7428c5b50d$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($0a980e7428c5b50d$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($0a980e7428c5b50d$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $0a980e7428c5b50d$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $0a980e7428c5b50d$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $0a980e7428c5b50d$var$envToBool;

});

parcelRegister("kdqC7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");
/**
 * Create envelope from check in item.
 */ function $eb79aa80eff929a6$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $hO292.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $eb79aa80eff929a6$var$createCheckInEnvelopeItem(checkIn);
    return $cp5Oe.createEnvelope(headers, [
        item
    ]);
}
function $eb79aa80eff929a6$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: 'check_in'
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $eb79aa80eff929a6$var$createCheckInEnvelope;

});

parcelRegister("bxbWK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gy40E = parcelRequire("gy40E");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $865c0b1bf54bac08$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $865c0b1bf54bac08$var$checkDsn(url, dsn) || $865c0b1bf54bac08$var$checkTunnel(url, tunnel);
}
function $865c0b1bf54bac08$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $865c0b1bf54bac08$var$removeTrailingSlash(url) === $865c0b1bf54bac08$var$removeTrailingSlash(tunnel);
}
function $865c0b1bf54bac08$var$checkDsn(url$1, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    const urlParts = $gy40E.parseStringToURLObject(url$1);
    if (!urlParts || $gy40E.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $865c0b1bf54bac08$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $865c0b1bf54bac08$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $865c0b1bf54bac08$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $865c0b1bf54bac08$var$isSentryRequestUrl;

});

parcelRegister("5PM5M", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ function $43f7054bdd434b4d$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ const $43f7054bdd434b4d$var$fmt = $43f7054bdd434b4d$var$parameterize;
module.exports.fmt = $43f7054bdd434b4d$var$fmt;
module.exports.parameterize = $43f7054bdd434b4d$var$parameterize;

});

parcelRegister("9SSMG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $03xMg = parcelRequire("03xMg");

var $3iQ48 = parcelRequire("3iQ48");

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");
/**
 * Core Sentry tunnel handler - framework agnostic.
 *
 * Validates the envelope DSN against allowed DSNs, then forwards the
 * envelope to the Sentry ingest endpoint.
 *
 * @returns A `Response` — either the upstream Sentry response on success, or an error response.
 */ async function $7323a7337138b908$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response('Tunnel not configured', {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $cp5Oe.parseEnvelope(body);
    } catch  {
        return new Response('Invalid envelope', {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response('Invalid envelope: missing header', {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response('Invalid envelope: missing DSN', {
        status: 400
    });
    // SECURITY: Validate that the envelope DSN matches one of the allowed DSNs
    // This prevents SSRF attacks where attackers send crafted envelopes
    // with malicious DSNs pointing to arbitrary hosts
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $3iQ48.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response('DSN not allowed', {
            status: 403
        });
    }
    const dsnComponents = $hO292.makeDsn(dsn$1);
    if (!dsnComponents) {
        $3iQ48.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response('Invalid DSN', {
            status: 403
        });
    }
    const sentryIngestUrl = $03xMg.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-sentry-envelope'
            },
            body: body
        });
    } catch (error) {
        $3iQ48.debug.error('Sentry tunnel: failed to forward envelope', error);
        return new Response('Failed to forward envelope to Sentry', {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $7323a7337138b908$var$handleTunnelRequest;

});

parcelRegister("aCPEz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $7bc5854a4afeb2fe$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $7bc5854a4afeb2fe$var$addAutoIpAddressToSession(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}
module.exports.addAutoIpAddressToSession = $7bc5854a4afeb2fe$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $7bc5854a4afeb2fe$var$addAutoIpAddressToUser;

});

parcelRegister("akVip", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lviux = parcelRequire("lviux");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $7868376af3173813$var$applySdkMetadata(options, name, names = [
    name
], source = 'npm') {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: $lviux.SDK_VERSION
            }));
        sdk.version = $lviux.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $7868376af3173813$var$applySdkMetadata;

});

parcelRegister("kBM5C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iNc9K = parcelRequire("iNc9K");

var $dLES3 = parcelRequire("dLES3");

var $d2jrf = parcelRequire("d2jrf");

var $lCPaR = parcelRequire("lCPaR");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");

var $eW0HJ = parcelRequire("eW0HJ");

var $1nDVq = parcelRequire("1nDVq");

var $6qbZr = parcelRequire("6qbZr");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * When an external propagation context is registered (e.g. via the OTLP integration) and there is no active
 * Sentry span, this function returns an empty object to defer outgoing request propagation to the external
 * propagator (e.g. an OpenTelemetry propagator).
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $f00c90f871e3bb50$var$getTraceData(options = {}) {
    const client = options.client || $d2jrf.getClient();
    if (!$lCPaR.isEnabled() || !client) return {};
    const carrier$1 = $dLES3.getMainCarrier();
    const acs = $iNc9K.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $d2jrf.getCurrentScope();
    const span = options.span || $inXyb.getActiveSpan();
    // When no active span and external propagation context is registered (e.g. OTLP integration),
    // return empty to let the OTel propagator handle outgoing request propagation.
    if (!span && $d2jrf.hasExternalPropagationContext()) return {};
    const sentryTrace = span ? $inXyb.spanToTraceHeader(span) : $f00c90f871e3bb50$var$scopeToTraceHeader(scope);
    const dsc = span ? $eW0HJ.getDynamicSamplingContextFromSpan(span) : $eW0HJ.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $1nDVq.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $6qbZr.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $3iQ48.debug.warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    const traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? $inXyb.spanToTraceparentHeader(span) : $f00c90f871e3bb50$var$scopeToTraceparentHeader(scope);
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $f00c90f871e3bb50$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $6qbZr.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $f00c90f871e3bb50$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $6qbZr.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $f00c90f871e3bb50$var$getTraceData;

});

parcelRegister("kN396", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $8wj7Q = parcelRequire("8wj7Q");
const $f22ad2f4615c5036$var$NOT_PROPAGATED_MESSAGE = '[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:';
/**
 * Check if a given URL should be propagated to or not.
 * If no url is defined, or no trace propagation targets are defined, this will always return `true`.
 * You can also optionally provide a decision map, to cache decisions and avoid repeated regex lookups.
 */ function $f22ad2f4615c5036$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== 'string' || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== undefined) {
        $9XOi0.DEBUG_BUILD && !cachedDecision && $3iQ48.debug.log($f22ad2f4615c5036$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $8wj7Q.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $9XOi0.DEBUG_BUILD && !decision && $3iQ48.debug.log($f22ad2f4615c5036$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $f22ad2f4615c5036$var$shouldPropagateTraceForUrl;

});

parcelRegister("a0JtR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kBM5C = parcelRequire("kBM5C");
/**
 * Returns a string of meta tags that represent the current trace data.
 *
 * You can use this to propagate a trace from your server-side rendered Html to the browser.
 * This function returns up to two meta tags, `sentry-trace` and `baggage`, depending on the
 * current trace data state.
 *
 * @example
 * Usage example:
 *
 * ```js
 * function renderHtml() {
 *   return `
 *     <head>
 *       ${getTraceMetaTags()}
 *     </head>
 *   `;
 * }
 * ```
 *
 */ function $749d2ef45e470703$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $kBM5C.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join('\n');
}
module.exports.getTraceMetaTags = $749d2ef45e470703$var$getTraceMetaTags;

});

parcelRegister("4RIOF", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $38aee036ae8ea9df$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $38aee036ae8ea9df$var$debounce;

});

parcelRegister("eHXQV", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $122mK = parcelRequire("122mK");
/* eslint-disable max-lines-per-function */ /**
 * Maximum size of incoming HTTP request bodies attached to events.
 *
 * - `'none'`: No request bodies will be attached
 * - `'small'`: Request bodies up to 1,000 bytes will be attached
 * - `'medium'`: Request bodies up to 10,000 bytes will be attached
 * - `'always'`: Request bodies will always be attached (up to 1MB hard cap)
 */ /** Hard cap on captured body size, even when `maxRequestBodySize` is `'always'`. */ const $ab53825172238ccd$var$MAX_BODY_BYTE_LENGTH = 1048576;
/** Content types that are safe to capture as text. */ const $ab53825172238ccd$var$TEXT_CONTENT_TYPES = [
    'text/',
    'application/json',
    'application/x-www-form-urlencoded',
    'application/xml',
    'application/graphql'
];
/**
 * Convert a `maxRequestBodySize` setting to a maximum byte length.
 */ function $ab53825172238ccd$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === 'small') return 1000;
    if (maxRequestBodySize === 'medium') return 10000;
    return $ab53825172238ccd$var$MAX_BODY_BYTE_LENGTH;
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ function $ab53825172238ccd$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch  {
    // just return the empty headers
    }
    return headers;
}
/**
 * Convert common request headers to a simple dictionary.
 */ function $ab53825172238ccd$var$headersToDict(reqHeaders) {
    const headers = Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === 'string') headers[key] = value;
        });
    } catch  {
    // just return the empty headers
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $ab53825172238ccd$var$winterCGRequestToRequestData(req) {
    const headers = $ab53825172238ccd$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $ab53825172238ccd$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
/**
 * Checks if the content type is textual and safe to capture.
 */ function $ab53825172238ccd$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $ab53825172238ccd$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
/**
 * Captures the body from a Web Fetch API Request and adds it to the isolation scope.
 *
 * This function clones the request to read the body without affecting the original.
 * Only textual content types are captured - binary data is skipped.
 *
 * This is used by WinterCG-compatible runtimes (Cloudflare Workers, Deno, Bun, Vercel Edge, etc.)
 * that use the Web Fetch API Request object.
 *
 * @param request - The incoming Web Fetch API Request
 * @param isolationScope - The isolation scope to add the body to
 * @param maxRequestBodySize - The maximum size of the request body to capture ('small' = 1KB, 'medium' = 10KB, 'always' = 1MB)
 */ async function $ab53825172238ccd$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get('content-type');
        if (!$ab53825172238ccd$var$isTextualContentType(contentType)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Skipping body capture for non-textual content type:', contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get('content-length');
        const maxBodySize = $ab53825172238ccd$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $ab53825172238ccd$var$MAX_BODY_BYTE_LENGTH) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Skipping body capture: body too large', length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $122mK.safeUnref(setTimeout(()=>resolve(null), 2000));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Timeout reading request body');
            return;
        }
        if (!body) return;
        // Using TextEncoder to get byte length for UTF-8 strings
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log('Captured request body:', bodyByteLength, 'bytes');
    } catch (error) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Error capturing request body:', error);
    }
}
/**
 * Convert a HTTP request object to RequestEventData to be passed as normalizedRequest.
 * Instead of allowing `PolymorphicRequest` to be passed,
 * we want to be more specific and generally require a http.IncomingMessage-like object.
 */ function $ab53825172238ccd$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    // Check for x-forwarded-host first, then fall back to host header
    const forwardedHost = typeof headers['x-forwarded-host'] === 'string' ? headers['x-forwarded-host'] : undefined;
    const host = forwardedHost || (typeof headers.host === 'string' ? headers.host : undefined);
    // Check for x-forwarded-proto first, then fall back to existing protocol detection
    const forwardedProto = typeof headers['x-forwarded-proto'] === 'string' ? headers['x-forwarded-proto'] : undefined;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? 'https' : 'http');
    const url = request.url || '';
    const absoluteUrl = $ab53825172238ccd$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    // This is non-standard, but may be sometimes set
    // It may be overwritten later by our own body handling
    const data = request.body || undefined;
    // This is non-standard, but may be set on e.g. Next.js or Express requests
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $ab53825172238ccd$var$extractQueryParamsFromUrl(url),
        headers: $ab53825172238ccd$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $ab53825172238ccd$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith('http')) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return undefined;
}
const $ab53825172238ccd$var$SENSITIVE_HEADER_SNIPPETS = [
    'auth',
    'token',
    'secret',
    'session',
    'password',
    'passwd',
    'pwd',
    'key',
    'jwt',
    'bearer',
    'sso',
    'saml',
    'csrf',
    'xsrf',
    'credentials',
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    'set-cookie',
    'cookie'
];
/**
 * Extra substrings matched only against individual Cookie / Set-Cookie **names** (not header names),
 * so we can cover common session secrets that do not match {@link SENSITIVE_HEADER_SNIPPETS}
 * (e.g. `connect.sid` does not contain `session`) without false positives on arbitrary HTTP headers.
 *
 * Cookie names are checked with the same `includes()` list as headers plus these entries; omit redundant
 * cookie-only snippets that are already implied by a header match (e.g. `oauth` → `auth`, `id_token` → `token`,
 * `next-auth` → `auth`).
 */ const $ab53825172238ccd$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    '.sid',
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    'sessid',
    // Laravel etc. "remember me" tokens
    'remember',
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    'oidc',
    'pkce',
    'nonce',
    // RFC 6265bis high-security cookie name prefixes
    '__secure-',
    '__host-',
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    'awsalb',
    'awselb',
    'akamai',
    // BaaS / IdP session cookies (names often omit "session")
    '__stripe',
    'cognito',
    'firebase',
    'supabase',
    'sb-',
    // Step-up / MFA cookies
    'mfa',
    '2fa'
];
const $ab53825172238ccd$var$PII_HEADER_SNIPPETS = [
    'x-forwarded-',
    '-user'
];
/**
 * Converts incoming HTTP request or response headers to OpenTelemetry span attributes following semantic conventions.
 * Header names are converted to the format: http.<request|response>.header.<key>
 * where <key> is the header name in lowercase with dashes converted to underscores.
 *
 * @param lifecycle - The lifecycle of the headers, either 'request' or 'response'
 *
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/http/#http-request-header
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/http/#http-response-header
 *
 * @see https://getsentry.github.io/sentry-conventions/attributes/http/#http-request-header-key
 * @see https://getsentry.github.io/sentry-conventions/attributes/http/#http-response-header-key
 */ function $ab53825172238ccd$var$httpHeadersToSpanAttributes(headers, sendDefaultPii = false, lifecycle = 'request') {
    const spanAttributes = {};
    try {
        Object.entries(headers).forEach(([key, value])=>{
            if (value == null) return;
            const lowerCasedHeaderKey = key.toLowerCase();
            const isCookieHeader = lowerCasedHeaderKey === 'cookie' || lowerCasedHeaderKey === 'set-cookie';
            if (isCookieHeader && typeof value === 'string' && value !== '') {
                // Set-Cookie: single cookie with attributes ("name=value; HttpOnly; Secure")
                // Cookie: multiple cookies separated by "; " ("cookie1=value1; cookie2=value2")
                const isSetCookie = lowerCasedHeaderKey === 'set-cookie';
                const semicolonIndex = value.indexOf(';');
                const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
                const cookies = isSetCookie ? [
                    cookieString
                ] : cookieString.split('; ');
                for (const cookie of cookies){
                    // Split only at the first '=' to preserve '=' characters in cookie values
                    const equalSignIndex = cookie.indexOf('=');
                    const cookieKey = equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie;
                    const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : '';
                    const lowerCasedCookieKey = cookieKey.toLowerCase();
                    $ab53825172238ccd$var$addSpanAttribute({
                        spanAttributes: spanAttributes,
                        headerKey: lowerCasedHeaderKey,
                        cookieKey: lowerCasedCookieKey,
                        value: cookieValue,
                        sendDefaultPii: sendDefaultPii,
                        lifecycle: lifecycle
                    });
                }
            } else $ab53825172238ccd$var$addSpanAttribute({
                spanAttributes: spanAttributes,
                headerKey: lowerCasedHeaderKey,
                value: value,
                sendDefaultPii: sendDefaultPii,
                lifecycle: lifecycle
            });
        });
    } catch  {
    // Return empty object if there's an error
    }
    return spanAttributes;
}
function $ab53825172238ccd$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, '_');
}
function $ab53825172238ccd$var$addSpanAttribute({ spanAttributes: spanAttributes, headerKey: headerKey, cookieKey: cookieKey, value: value, sendDefaultPii: sendDefaultPii, lifecycle: lifecycle }) {
    const isCookieSubKey = Boolean(cookieKey);
    const nameForSensitivity = cookieKey || headerKey;
    const headerValue = $ab53825172238ccd$var$handleHttpHeader(nameForSensitivity, value, sendDefaultPii, isCookieSubKey);
    if (headerValue == null) return;
    const normalizedKey = `http.${lifecycle}.header.${$ab53825172238ccd$var$normalizeAttributeKey(headerKey)}${cookieKey ? `.${$ab53825172238ccd$var$normalizeAttributeKey(cookieKey)}` : ''}`;
    spanAttributes[normalizedKey] = headerValue;
}
function $ab53825172238ccd$var$handleHttpHeader(lowerCasedKey, value, sendPii, isCookieSubKey = false) {
    const snippetsForSensitivity = isCookieSubKey ? [
        ...$ab53825172238ccd$var$SENSITIVE_HEADER_SNIPPETS,
        ...$ab53825172238ccd$var$SENSITIVE_COOKIE_NAME_SNIPPETS
    ] : $ab53825172238ccd$var$SENSITIVE_HEADER_SNIPPETS;
    const isSensitive = sendPii ? snippetsForSensitivity.some((snippet)=>lowerCasedKey.includes(snippet)) : [
        ...$ab53825172238ccd$var$PII_HEADER_SNIPPETS,
        ...snippetsForSensitivity
    ].some((snippet)=>lowerCasedKey.includes(snippet));
    if (isSensitive) return '[Filtered]';
    else if (Array.isArray(value)) return value.map((v)=>v != null ? String(v) : v).join(';');
    else if (typeof value === 'string') return value;
    return undefined;
}
/** Extract the query params from an URL. */ function $ab53825172238ccd$var$extractQueryParamsFromUrl(url) {
    // url is path and query string
    if (!url) return;
    try {
        // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
        // hostname as the base. Since the point here is just to grab the query string, it doesn't matter what we use.
        const queryParams = new URL(url, 'http://s.io').search.slice(1);
        return queryParams.length ? queryParams : undefined;
    } catch  {
        return undefined;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $ab53825172238ccd$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $ab53825172238ccd$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $ab53825172238ccd$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $ab53825172238ccd$var$getMaxBodyByteLength;
module.exports.headersToDict = $ab53825172238ccd$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $ab53825172238ccd$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $ab53825172238ccd$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $ab53825172238ccd$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $ab53825172238ccd$var$winterCGRequestToRequestData;

});

parcelRegister("25ylb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $3iQ48 = parcelRequire("3iQ48");

var $8OzMM = parcelRequire("8OzMM");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $1856afbe5a713177$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $1856afbe5a713177$var$addBreadcrumb(breadcrumb, hint) {
    const client = $d2jrf.getClient();
    const isolationScope = $d2jrf.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $1856afbe5a713177$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $8OzMM.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $3iQ48.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $1856afbe5a713177$var$addBreadcrumb;

});

parcelRegister("04woM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $dHcrw = parcelRequire("dHcrw");

var $bKfNN = parcelRequire("bKfNN");
let $00d98185d1546b55$var$originalFunctionToString;
const $00d98185d1546b55$var$INTEGRATION_NAME = 'FunctionToString';
const $00d98185d1546b55$var$SETUP_CLIENTS = new WeakMap();
const $00d98185d1546b55$var$_functionToStringIntegration = ()=>{
    return {
        name: $00d98185d1546b55$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $00d98185d1546b55$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $bKfNN.getOriginalFunction(this);
                    const context = $00d98185d1546b55$var$SETUP_CLIENTS.has($d2jrf.getClient()) && originalFunction !== undefined ? originalFunction : this;
                    return $00d98185d1546b55$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $00d98185d1546b55$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $00d98185d1546b55$var$functionToStringIntegration = $dHcrw.defineIntegration($00d98185d1546b55$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $00d98185d1546b55$var$functionToStringIntegration;

});

parcelRegister("8zXdM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $dHcrw = parcelRequire("dHcrw");

var $3iQ48 = parcelRequire("3iQ48");

var $iy0lZ = parcelRequire("iy0lZ");

var $bCreQ = parcelRequire("bCreQ");

var $8wj7Q = parcelRequire("8wj7Q");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $63ef87bf8a89d9c9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $63ef87bf8a89d9c9$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $63ef87bf8a89d9c9$var$eventFiltersIntegration = $dHcrw.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $63ef87bf8a89d9c9$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $63ef87bf8a89d9c9$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $63ef87bf8a89d9c9$var$_mergeOptions(options, clientOptions);
            }
            return $63ef87bf8a89d9c9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $63ef87bf8a89d9c9$var$inboundFiltersIntegration = $dHcrw.defineIntegration((options = {})=>{
    return {
        ...$63ef87bf8a89d9c9$var$eventFiltersIntegration(options),
        name: 'InboundFilters'
    };
});
function $63ef87bf8a89d9c9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $63ef87bf8a89d9c9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $63ef87bf8a89d9c9$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($63ef87bf8a89d9c9$var$_isIgnoredError(event, options.ignoreErrors)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${$bCreQ.getEventDescription(event)}`);
            return true;
        }
        if ($63ef87bf8a89d9c9$var$_isUselessError(event)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${$bCreQ.getEventDescription(event)}`);
            return true;
        }
        if ($63ef87bf8a89d9c9$var$_isDeniedUrl(event, options.denyUrls)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${$bCreQ.getEventDescription(event)}.\nUrl: ${$63ef87bf8a89d9c9$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$63ef87bf8a89d9c9$var$_isAllowedUrl(event, options.allowUrls)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${$bCreQ.getEventDescription(event)}.\nUrl: ${$63ef87bf8a89d9c9$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($63ef87bf8a89d9c9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${$bCreQ.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $63ef87bf8a89d9c9$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $iy0lZ.getPossibleEventMessages(event).some((message)=>$8wj7Q.stringMatchesSomePattern(message, ignoreErrors));
}
function $63ef87bf8a89d9c9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $8wj7Q.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $63ef87bf8a89d9c9$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $63ef87bf8a89d9c9$var$_getEventFilterUrl(event);
    return !url ? false : $8wj7Q.stringMatchesSomePattern(url, denyUrls);
}
function $63ef87bf8a89d9c9$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $63ef87bf8a89d9c9$var$_getEventFilterUrl(event);
    return !url ? true : $8wj7Q.stringMatchesSomePattern(url, allowUrls);
}
function $63ef87bf8a89d9c9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $63ef87bf8a89d9c9$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $63ef87bf8a89d9c9$var$_getLastValidUrl(frames) : null;
    } catch  {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error(`Cannot extract url for event ${$bCreQ.getEventDescription(event)}`);
        return null;
    }
}
function $63ef87bf8a89d9c9$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}
module.exports.eventFiltersIntegration = $63ef87bf8a89d9c9$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $63ef87bf8a89d9c9$var$inboundFiltersIntegration;

});

parcelRegister("8Z10R", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $8fsk0 = parcelRequire("8fsk0");

var $fLPEN = parcelRequire("fLPEN");
const $68a4ce5fb085571d$var$DEFAULT_KEY = 'cause';
const $68a4ce5fb085571d$var$DEFAULT_LIMIT = 5;
const $68a4ce5fb085571d$var$INTEGRATION_NAME = 'LinkedErrors';
const $68a4ce5fb085571d$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $68a4ce5fb085571d$var$DEFAULT_LIMIT;
    const key = options.key || $68a4ce5fb085571d$var$DEFAULT_KEY;
    return {
        name: $68a4ce5fb085571d$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            $8fsk0.applyAggregateErrorsToEvent($fLPEN.exceptionFromError, options.stackParser, key, limit, event, hint);
        }
    };
};
const $68a4ce5fb085571d$var$linkedErrorsIntegration = $dHcrw.defineIntegration($68a4ce5fb085571d$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $68a4ce5fb085571d$var$linkedErrorsIntegration;

});
parcelRegister("8fsk0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $6015b1847ca7e8aa$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$dpKhO.isInstanceOf(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $6015b1847ca7e8aa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $6015b1847ca7e8aa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ($dpKhO.isInstanceOf(error[key], Error)) {
        $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $6015b1847ca7e8aa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($6015b1847ca7e8aa$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($dpKhO.isInstanceOf(childError, Error)) {
            $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $6015b1847ca7e8aa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $6015b1847ca7e8aa$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$6015b1847ca7e8aa$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $6015b1847ca7e8aa$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $6015b1847ca7e8aa$var$applyAggregateErrorsToEvent;

});

parcelRegister("fLPEN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");

var $bCreQ = parcelRequire("bCreQ");

var $iCGkd = parcelRequire("iCGkd");

var $bKfNN = parcelRequire("bKfNN");
/**
 * Extracts stack frames from the error.stack string
 */ function $b7b350cb605cd665$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $b7b350cb605cd665$var$hasSentryFetchUrlHost(error) {
    return $dpKhO.isError(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $b7b350cb605cd665$var$_enhanceErrorWithSentryInfo(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($b7b350cb605cd665$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $b7b350cb605cd665$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $b7b350cb605cd665$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $b7b350cb605cd665$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $b7b350cb605cd665$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $b7b350cb605cd665$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = $bKfNN.extractExceptionKeysForMessage(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ($dpKhO.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $b7b350cb605cd665$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $b7b350cb605cd665$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $b7b350cb605cd665$var$getException(client, mechanism, exception, hint) {
    if ($dpKhO.isError(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ($dpKhO.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: $iCGkd.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $b7b350cb605cd665$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $b7b350cb605cd665$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $b7b350cb605cd665$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $b7b350cb605cd665$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $b7b350cb605cd665$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $bCreQ.addExceptionTypeValue(event, undefined, undefined);
    $bCreQ.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $b7b350cb605cd665$var$eventFromMessage(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $b7b350cb605cd665$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $bCreQ.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($dpKhO.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $b7b350cb605cd665$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $b7b350cb605cd665$var$eventFromMessage;
module.exports.eventFromUnknownInput = $b7b350cb605cd665$var$eventFromUnknownInput;
module.exports.exceptionFromError = $b7b350cb605cd665$var$exceptionFromError;
module.exports.parseStackFrames = $b7b350cb605cd665$var$parseStackFrames;

});


parcelRegister("lG6QY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $81uv9 = parcelRequire("81uv9");

var $cp5Oe = parcelRequire("cp5Oe");
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ const $fc82d62b6e14a91c$var$moduleMetadataIntegration = $dHcrw.defineIntegration(()=>{
    return {
        name: 'ModuleMetadata',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope$1)=>{
                $cp5Oe.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            $81uv9.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $81uv9.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $fc82d62b6e14a91c$var$moduleMetadataIntegration;

});
parcelRegister("81uv9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xpfH = parcelRequire("5xpfH");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5d7613a95fb82524$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $5d7613a95fb82524$var$parsedStacks = new Set();
/**
 * Builds a map of filenames to module metadata from the global _sentryModuleMetadata object.
 * This is useful for forwarding metadata from web workers to the main thread.
 *
 * @param parser - Stack parser to use for extracting filenames from stack traces
 * @returns A map of filename to metadata object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5d7613a95fb82524$var$getFilenameToMetadataMap(parser) {
    if (!$5xpfH.GLOBAL_OBJ._sentryModuleMetadata) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filenameMap = {};
    for (const stack of Object.keys($5xpfH.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $5xpfH.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $5d7613a95fb82524$var$ensureMetadataStacksAreParsed(parser) {
    if (!$5xpfH.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($5xpfH.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $5xpfH.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($5d7613a95fb82524$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $5d7613a95fb82524$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $5d7613a95fb82524$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5d7613a95fb82524$var$getMetadataForUrl(parser, filename) {
    $5d7613a95fb82524$var$ensureMetadataStacksAreParsed(parser);
    return $5d7613a95fb82524$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $5d7613a95fb82524$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $5d7613a95fb82524$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
/**
 * Strips metadata from stack frames.
 */ function $5d7613a95fb82524$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $5d7613a95fb82524$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $5d7613a95fb82524$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $5d7613a95fb82524$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $5d7613a95fb82524$var$stripMetadataFromStackFrames;

});


parcelRegister("kCVtg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $dHcrw = parcelRequire("dHcrw");

var $6zIGl = parcelRequire("6zIGl");

var $etyuL = parcelRequire("etyuL");

var $eHXQV = parcelRequire("eHXQV");

var $8QE0h = parcelRequire("8QE0h");

var $hg4dc = parcelRequire("hg4dc");
// TODO(v11): Change defaults based on `sendDefaultPii`
const $f043efc8ccd6a3a5$var$DEFAULT_INCLUDE = {
    cookies: true,
    data: true,
    headers: true,
    query_string: true,
    url: true
};
const $f043efc8ccd6a3a5$var$INTEGRATION_NAME = 'RequestData';
const $f043efc8ccd6a3a5$var$_requestDataIntegration = (options = {})=>{
    const include = {
        ...$f043efc8ccd6a3a5$var$DEFAULT_INCLUDE,
        ...options.include
    };
    return {
        name: $f043efc8ccd6a3a5$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const includeWithDefaultPiiApplied = {
                ...include,
                ip: include.ip ?? client.getOptions().sendDefaultPii
            };
            if (normalizedRequest) $f043efc8ccd6a3a5$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, includeWithDefaultPiiApplied);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $d2jrf.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { sendDefaultPii: sendDefaultPii } = client.getOptions();
            const includeWithDefaultPiiApplied = {
                ...include,
                ip: include.ip ?? sendDefaultPii
            };
            $f043efc8ccd6a3a5$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, includeWithDefaultPiiApplied, sendDefaultPii);
        }
    };
};
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/core`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 */ const $f043efc8ccd6a3a5$var$requestDataIntegration = $dHcrw.defineIntegration($f043efc8ccd6a3a5$var$_requestDataIntegration);
/**
 * Add already normalized request data to an event.
 * This mutates the passed in event.
 */ function $f043efc8ccd6a3a5$var$addNormalizedRequestDataToEvent(event, req, // Data that should not go into `event.request` but is somehow related to requests
additionalData, include) {
    event.request = {
        ...event.request,
        ...$f043efc8ccd6a3a5$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $8QE0h.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $f043efc8ccd6a3a5$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, sendDefaultPii) {
    const requestData = $f043efc8ccd6a3a5$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes['url.full'] = requestData.url;
    if (requestData.method) attributes['http.request.method'] = requestData.method;
    if (requestData.query_string) attributes['url.query'] = $f043efc8ccd6a3a5$var$normalizeQueryString(requestData.query_string);
    $hg4dc.safeSetSpanJSONAttributes(span, attributes);
    // Process cookies before headers so normalizedRequest.cookies takes precedence
    // over the raw cookie header (matching the processEvent path).
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join('; ');
        const cookieAttributes = $eHXQV.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, sendDefaultPii ?? false, 'request');
        $hg4dc.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $eHXQV.httpHeadersToSpanAttributes(requestData.headers, sendDefaultPii ?? false, 'request');
        $hg4dc.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === 'string' ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $hg4dc.safeSetSpanJSONAttributes(span, {
            'http.request.body.data': serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $8QE0h.getClientIPAddress(normalizedRequest.headers) || ipAddress || undefined;
        if (ip) $hg4dc.safeSetSpanJSONAttributes(span, {
            [$6zIGl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $f043efc8ccd6a3a5$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($8QE0h.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $etyuL.parseCookie(headers.cookie) : undefined);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $f043efc8ccd6a3a5$var$normalizeQueryString(queryString) {
    if (typeof queryString === 'string') return queryString || undefined;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join('&');
    return result || undefined;
}
module.exports.requestDataIntegration = $f043efc8ccd6a3a5$var$requestDataIntegration;

});
parcelRegister("etyuL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $a89e882811094116$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $a89e882811094116$var$parseCookie;

});

parcelRegister("8QE0h", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Vendored / modified from @sergiodxa/remix-utils
// https://github.com/sergiodxa/remix-utils/blob/02af80e12829a53696bfa8f3c2363975cf59f55e/src/server/get-client-ip-address.ts
// MIT License
// Copyright (c) 2021 Sergio Xalambrí
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// The headers to check, in priority order
const $671235e8ce1488b9$var$ipHeaderNames = [
    'X-Client-IP',
    'X-Forwarded-For',
    'Fly-Client-IP',
    'CF-Connecting-IP',
    'Fastly-Client-Ip',
    'True-Client-Ip',
    'X-Real-IP',
    'X-Cluster-Client-IP',
    'X-Forwarded',
    'Forwarded-For',
    'Forwarded',
    'X-Vercel-Forwarded-For'
];
/**
 * Get the IP address of the client sending a request.
 *
 * It receives a Request headers object and use it to get the
 * IP address from one of the following headers in order.
 *
 * If the IP address is valid, it will be returned. Otherwise, null will be
 * returned.
 *
 * If the header values contains more than one IP address, the first valid one
 * will be returned.
 */ function $671235e8ce1488b9$var$getClientIPAddress(headers) {
    // Build a map of lowercase header names to their values for case-insensitive lookup
    // This is needed because headers from different sources may have different casings
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    // This will end up being Array<string | string[] | undefined | null> because of the various possible values a header
    // can take
    const headerValues = $671235e8ce1488b9$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(';') : rawValue;
        if (headerName === 'Forwarded') return $671235e8ce1488b9$var$parseForwardedHeader(value);
        return value?.split(',').map((v)=>v.trim());
    });
    // Flatten the array and filter out any falsy entries
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    // Find the first value which is a valid IP address, if any
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $671235e8ce1488b9$var$isIP(ip));
    return ipAddress || null;
}
function $671235e8ce1488b9$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(';')){
        if (part.startsWith('for=')) return part.slice(4);
    }
    return null;
}
//
/**
 * Custom method instead of importing this from `net` package, as this only exists in node
 * Accepts:
 * 127.0.0.1
 * 192.168.1.1
 * 192.168.1.255
 * 255.255.255.255
 * 10.1.1.1
 * 0.0.0.0
 * 2b01:cb19:8350:ed00:d0dd:fa5b:de31:8be5
 *
 * Rejects:
 * 1.1.1.01
 * 30.168.1.255.1
 * 127.1
 * 192.168.1.256
 * -1.2.3.4
 * 1.1.1.1.
 * 3...3
 * 192.168.1.099
 */ function $671235e8ce1488b9$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $671235e8ce1488b9$var$getClientIPAddress;
module.exports.ipHeaderNames = $671235e8ce1488b9$var$ipHeaderNames;

});


parcelRegister("43yhn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $lCPaR = parcelRequire("lCPaR");

var $gCzmC = parcelRequire("gCzmC");

var $dHcrw = parcelRequire("dHcrw");

var $3iQ48 = parcelRequire("3iQ48");

var $bCreQ = parcelRequire("bCreQ");

var $geSGs = parcelRequire("geSGs");

var $8wj7Q = parcelRequire("8wj7Q");

var $5xpfH = parcelRequire("5xpfH");
const $2f42085eef0c0cda$var$INTEGRATION_NAME = 'CaptureConsole';
const $2f42085eef0c0cda$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $3iQ48.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $2f42085eef0c0cda$var$INTEGRATION_NAME,
        setup (client) {
            if (!('console' in $5xpfH.GLOBAL_OBJ)) return;
            $gCzmC.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($d2jrf.getClient() !== client || !levels.includes(level)) return;
                $2f42085eef0c0cda$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $2f42085eef0c0cda$var$captureConsoleIntegration = $dHcrw.defineIntegration($2f42085eef0c0cda$var$_captureConsoleIntegration);
function $2f42085eef0c0cda$var$consoleHandler(args, level, handled) {
    const severityLevel = $geSGs.severityLevelFromString(level);
    /*
    We create this error here already to attach a stack trace to captured messages,
    if users set `attachStackTrace` to `true` in Sentry.init.
    We do this here already because we want to minimize the number of Sentry SDK stack frames
    within the error. Technically, Client.captureMessage will also do it but this happens several
    stack frames deeper.
  */ const syntheticException = new Error();
    const captureContext = {
        level: $geSGs.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $d2jrf.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            $bCreQ.addExceptionMechanism(event, {
                handled: handled,
                type: 'auto.core.capture_console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                const message = `Assertion failed: ${$8wj7Q.safeJoin(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                scope.captureMessage(message, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $lCPaR.captureException(error, captureContext);
            return;
        }
        const message = $8wj7Q.safeJoin(args, ' ');
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $2f42085eef0c0cda$var$captureConsoleIntegration;

});
parcelRegister("gCzmC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $bKfNN = parcelRequire("bKfNN");

var $8wj7Q = parcelRequire("8wj7Q");

var $5xpfH = parcelRequire("5xpfH");

var $i3Ttl = parcelRequire("i3Ttl");
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/ban-types */ /**
 * Filter out console messages that match the given strings or regular expressions.
 * These will neither be passed to the handler, and they will also not be logged to the user, unless they have debug enabled.
 * This is a set to avoid duplicate integration setups to add the same filter multiple times.
 */ const $c19ba07e4ac231d5$var$_filter = new Set([]);
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c19ba07e4ac231d5$var$addConsoleInstrumentationHandler(handler) {
    const type = 'console';
    const removeHandler = $i3Ttl.addHandler(type, handler);
    $i3Ttl.maybeInstrument(type, $c19ba07e4ac231d5$var$instrumentConsole);
    return removeHandler;
}
/**
 * Add a filter to the console instrumentation to filter out console messages that match the given strings or regular expressions.
 * Returns a function to remove the filter.
 */ function $c19ba07e4ac231d5$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$c19ba07e4ac231d5$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$c19ba07e4ac231d5$var$_filter.delete(f);
    };
}
function $c19ba07e4ac231d5$var$instrumentConsole() {
    if (!('console' in $5xpfH.GLOBAL_OBJ)) return;
    $3iQ48.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $5xpfH.GLOBAL_OBJ.console)) return;
        $bKfNN.fill($5xpfH.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $3iQ48.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $3iQ48.originalConsoleMethods[level];
                const isFiltered = $c19ba07e4ac231d5$var$_filter.size && typeof firstArg === 'string' && $8wj7Q.stringMatchesSomePattern(firstArg, $c19ba07e4ac231d5$var$_filter);
                // Only trigger handlers for non-filtered messages
                if (!isFiltered) $i3Ttl.triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // Only log filtered messages in debug mode
                if (!isFiltered || $9XOi0.DEBUG_BUILD && $3iQ48.debug.isEnabled()) // Call original console method
                log?.apply($5xpfH.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $c19ba07e4ac231d5$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $c19ba07e4ac231d5$var$addConsoleInstrumentationHandler;

});

parcelRegister("geSGs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $bd285f37ea45073b$var$severityLevelFromString(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}
module.exports.severityLevelFromString = $bd285f37ea45073b$var$severityLevelFromString;

});


parcelRegister("7iBjq", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $dHcrw = parcelRequire("dHcrw");

var $3iQ48 = parcelRequire("3iQ48");

var $9jmDw = parcelRequire("9jmDw");
const $5507284c852e4d0e$var$INTEGRATION_NAME = 'Dedupe';
const $5507284c852e4d0e$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $5507284c852e4d0e$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($5507284c852e4d0e$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $5507284c852e4d0e$var$dedupeIntegration = $dHcrw.defineIntegration($5507284c852e4d0e$var$_dedupeIntegration);
/** only exported for tests. */ function $5507284c852e4d0e$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($5507284c852e4d0e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($5507284c852e4d0e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $5507284c852e4d0e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$5507284c852e4d0e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5507284c852e4d0e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $5507284c852e4d0e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $5507284c852e4d0e$var$_getExceptionFromEvent(previousEvent);
    const currentException = $5507284c852e4d0e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$5507284c852e4d0e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5507284c852e4d0e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $5507284c852e4d0e$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $9jmDw.getFramesFromEvent(currentEvent);
    let previousFrames = $9jmDw.getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $5507284c852e4d0e$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $5507284c852e4d0e$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $5507284c852e4d0e$var$_shouldDropEvent;
module.exports.dedupeIntegration = $5507284c852e4d0e$var$dedupeIntegration;

});

parcelRegister("8OGyf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $dHcrw = parcelRequire("dHcrw");

var $3iQ48 = parcelRequire("3iQ48");

var $dpKhO = parcelRequire("dpKhO");

var $iCGkd = parcelRequire("iCGkd");

var $idZsJ = parcelRequire("idZsJ");

var $8wj7Q = parcelRequire("8wj7Q");
const $66b4000d04ab7f4a$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $66b4000d04ab7f4a$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $66b4000d04ab7f4a$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $66b4000d04ab7f4a$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $66b4000d04ab7f4a$var$extraErrorDataIntegration = $dHcrw.defineIntegration($66b4000d04ab7f4a$var$_extraErrorDataIntegration);
function $66b4000d04ab7f4a$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$dpKhO.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $66b4000d04ab7f4a$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $iCGkd.normalize(errorData, depth);
        if ($dpKhO.isPlainObject(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            $idZsJ.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $66b4000d04ab7f4a$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $dpKhO.isError(value) || typeof value === 'string' ? maxValueLength ? $8wj7Q.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            if ($dpKhO.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $66b4000d04ab7f4a$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $dpKhO.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $66b4000d04ab7f4a$var$extraErrorDataIntegration;

});

parcelRegister("3EGPi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $8IBSt = parcelRequire("8IBSt");

var $5xpfH = parcelRequire("5xpfH");
const $2a9653efca8a3d91$var$INTEGRATION_NAME = 'RewriteFrames';
/**
 * Rewrite event frames paths.
 */ const $2a9653efca8a3d91$var$rewriteFramesIntegration = $dHcrw.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const isBrowser = 'window' in $5xpfH.GLOBAL_OBJ && !!$5xpfH.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $2a9653efca8a3d91$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $2a9653efca8a3d91$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function $2a9653efca8a3d91$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? $8IBSt.relative(root, filename) : $8IBSt.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $2a9653efca8a3d91$var$generateIteratee;
module.exports.rewriteFramesIntegration = $2a9653efca8a3d91$var$rewriteFramesIntegration;

});
parcelRegister("8IBSt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $658fd07fbf084309$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $658fd07fbf084309$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $658fd07fbf084309$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $658fd07fbf084309$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $658fd07fbf084309$var$resolve(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $658fd07fbf084309$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $658fd07fbf084309$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $658fd07fbf084309$var$relative(from, to) {
    /* eslint-disable no-param-reassign */ from = $658fd07fbf084309$var$resolve(from).slice(1);
    to = $658fd07fbf084309$var$resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $658fd07fbf084309$var$trim(from.split('/'));
    const toParts = $658fd07fbf084309$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $658fd07fbf084309$var$normalizePath(path) {
    const isPathAbsolute = $658fd07fbf084309$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $658fd07fbf084309$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $658fd07fbf084309$var$isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $658fd07fbf084309$var$join(...args) {
    return $658fd07fbf084309$var$normalizePath(args.join('/'));
}
/** JSDoc */ function $658fd07fbf084309$var$dirname(path) {
    const result = $658fd07fbf084309$var$splitPath(path);
    const root = result[0] || '';
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $658fd07fbf084309$var$basename(path, ext) {
    let f = $658fd07fbf084309$var$splitPath(path)[2] || '';
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $658fd07fbf084309$var$basename;
module.exports.dirname = $658fd07fbf084309$var$dirname;
module.exports.isAbsolute = $658fd07fbf084309$var$isAbsolute;
module.exports.join = $658fd07fbf084309$var$join;
module.exports.normalizePath = $658fd07fbf084309$var$normalizePath;
module.exports.relative = $658fd07fbf084309$var$relative;
module.exports.resolve = $658fd07fbf084309$var$resolve;

});


parcelRegister("1v9is", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $25ylb = parcelRequire("25ylb");

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $lCPaR = parcelRequire("lCPaR");

var $dHcrw = parcelRequire("dHcrw");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $bCreQ = parcelRequire("bCreQ");

var $dpKhO = parcelRequire("dpKhO");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");
// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
const $117fe5d6c57eaae9$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    'reauthenticate',
    'signInAnonymously',
    'signInWithOAuth',
    'signInWithIdToken',
    'signInWithOtp',
    'signInWithPassword',
    'signInWithSSO',
    'signOut',
    'signUp',
    'verifyOtp'
];
const $117fe5d6c57eaae9$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    'createUser',
    'deleteUser',
    'listUsers',
    'getUserById',
    'updateUserById',
    'inviteUserByEmail'
];
const $117fe5d6c57eaae9$var$FILTER_MAPPINGS = {
    eq: 'eq',
    neq: 'neq',
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    like: 'like',
    'like(all)': 'likeAllOf',
    'like(any)': 'likeAnyOf',
    ilike: 'ilike',
    'ilike(all)': 'ilikeAllOf',
    'ilike(any)': 'ilikeAnyOf',
    is: 'is',
    in: 'in',
    cs: 'contains',
    cd: 'containedBy',
    sr: 'rangeGt',
    nxl: 'rangeGte',
    sl: 'rangeLt',
    nxr: 'rangeLte',
    adj: 'rangeAdjacent',
    ov: 'overlaps',
    fts: '',
    plfts: 'plain',
    phfts: 'phrase',
    wfts: 'websearch',
    not: 'not'
};
const $117fe5d6c57eaae9$var$DB_OPERATIONS_TO_INSTRUMENT = [
    'select',
    'insert',
    'upsert',
    'update',
    'delete'
];
function $117fe5d6c57eaae9$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {
    // ignore errors here
    }
}
function $117fe5d6c57eaae9$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
/**
 * Plain-object bodies are copied into `plainBody`; array inserts (and other non-plain shapes) stay only on `rawBody`.
 * Returns a payload suitable for span attributes / breadcrumbs when the client has `sendDefaultPii` enabled.
 */ function $117fe5d6c57eaae9$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return undefined;
}
/** True when the PostgREST builder carries a mutation body (for `insert(...)`, etc. in span descriptions). */ function $117fe5d6c57eaae9$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $117fe5d6c57eaae9$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== undefined;
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function $117fe5d6c57eaae9$var$extractOperation(method, headers = {}) {
    switch(method){
        case 'GET':
            return 'select';
        case 'POST':
            if (headers['Prefer']?.includes('resolution=')) return 'upsert';
            else return 'insert';
        case 'PATCH':
            return 'update';
        case 'DELETE':
            return 'delete';
        default:
            return '<unknown-op>';
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function $117fe5d6c57eaae9$var$translateFiltersIntoMethods(key, query) {
    if (query === '' || query === '*') return 'select(*)';
    if (key === 'select') return `select(${query})`;
    if (key === 'or' || key.endsWith('.or')) return `${key}${query}`;
    const [filter, ...value] = query.split('.');
    let method;
    // Handle optional `configPart` of the filter
    if (filter?.startsWith('fts')) method = 'textSearch';
    else if (filter?.startsWith('plfts')) method = 'textSearch[plain]';
    else if (filter?.startsWith('phfts')) method = 'textSearch[phrase]';
    else if (filter?.startsWith('wfts')) method = 'textSearch[websearch]';
    else method = filter && $117fe5d6c57eaae9$var$FILTER_MAPPINGS[filter] || 'filter';
    return `${method}(${key}, ${value.join('.')})`;
}
function $117fe5d6c57eaae9$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $92XmH.startSpan({
                name: `auth ${isAdmin ? '(admin) ' : ''}${operation.name}`,
                attributes: {
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.db.supabase',
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db',
                    'db.system': 'postgresql',
                    'db.operation': `auth.${isAdmin ? 'admin.' : ''}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === 'object' && 'error' in res && res.error) {
                        span.setStatus({
                            code: $9BaVX.SPAN_STATUS_ERROR
                        });
                        $lCPaR.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.db.supabase.auth'
                            }
                        });
                    } else span.setStatus({
                        code: $9BaVX.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $9BaVX.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $lCPaR.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: 'auto.db.supabase.auth'
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $117fe5d6c57eaae9$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $117fe5d6c57eaae9$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $117fe5d6c57eaae9$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === 'function') supabaseClientInstance.auth[operation] = $117fe5d6c57eaae9$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $117fe5d6c57eaae9$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === 'function') supabaseClientInstance.auth.admin[operation] = $117fe5d6c57eaae9$var$instrumentAuthOperation(authOperation, true);
    }
    $117fe5d6c57eaae9$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $117fe5d6c57eaae9$var$instrumentSupabaseClientConstructor(SupabaseClient) {
    if ($117fe5d6c57eaae9$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $117fe5d6c57eaae9$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    $117fe5d6c57eaae9$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $117fe5d6c57eaae9$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if ($117fe5d6c57eaae9$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $117fe5d6c57eaae9$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $117fe5d6c57eaae9$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== 'string') return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split('/');
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())// It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
            // so we need to use array instead of object to collect them.
            queryItems.push($117fe5d6c57eaae9$var$translateFiltersIntoMethods(key, value));
            const body = Object.create(null);
            if ($dpKhO.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const sendDefaultPii = Boolean($d2jrf.getClient()?.getOptions().sendDefaultPii);
            const bodyPayload = $117fe5d6c57eaae9$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            const mutationPart = operation === 'select' ? '' : `${operation}${$117fe5d6c57eaae9$var$hasMutationBodyForDescription(typedThis.body, body) ? '(...) ' : ''}`;
            const queryPart = sendDefaultPii ? queryItems.join(' ') : queryItems.length > 0 ? '[redacted]' : '';
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(' ');
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                'db.table': table,
                'db.schema': typedThis.schema,
                'db.url': typedThis.url.origin,
                'db.sdk': typedThis.headers['X-Client-Info'],
                'db.system': 'postgresql',
                'db.operation': operation,
                [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.db.supabase',
                [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db'
            };
            if (queryItems.length && sendDefaultPii) attributes['db.query'] = queryItems;
            if (bodyPayload !== undefined && sendDefaultPii) attributes['db.body'] = bodyPayload;
            return $92XmH.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === 'object' && 'status' in res) $9BaVX.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && sendDefaultPii) supabaseContext.query = queryItems;
                        if (bodyPayload !== undefined && sendDefaultPii) supabaseContext.body = bodyPayload;
                        $lCPaR.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $bCreQ.addExceptionMechanism(e, {
                                    handled: false,
                                    type: 'auto.db.supabase.postgres'
                                });
                                return e;
                            });
                            scope.setContext('supabase', supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: 'supabase',
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && sendDefaultPii) data.query = queryItems;
                    if (bodyPayload !== undefined && sendDefaultPii) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $25ylb.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    // TODO: shouldn't we capture this error?
                    if (span) {
                        $9BaVX.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $117fe5d6c57eaae9$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $117fe5d6c57eaae9$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
    // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
    for (const operation of $117fe5d6c57eaae9$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($117fe5d6c57eaae9$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $117fe5d6c57eaae9$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                return rv;
            }
        });
        $117fe5d6c57eaae9$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $117fe5d6c57eaae9$var$instrumentSupabaseClient = (supabaseClient)=>{
    if (!supabaseClient) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Supabase integration was not installed because no Supabase client was provided.');
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $117fe5d6c57eaae9$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    $117fe5d6c57eaae9$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $117fe5d6c57eaae9$var$INTEGRATION_NAME = 'Supabase';
const $117fe5d6c57eaae9$var$_supabaseIntegration = (supabaseClient)=>{
    return {
        setupOnce () {
            $117fe5d6c57eaae9$var$instrumentSupabaseClient(supabaseClient);
        },
        name: $117fe5d6c57eaae9$var$INTEGRATION_NAME
    };
};
const $117fe5d6c57eaae9$var$supabaseIntegration = $dHcrw.defineIntegration((options)=>{
    return $117fe5d6c57eaae9$var$_supabaseIntegration(options.supabaseClient);
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $117fe5d6c57eaae9$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $117fe5d6c57eaae9$var$FILTER_MAPPINGS;
module.exports.extractOperation = $117fe5d6c57eaae9$var$extractOperation;
module.exports.instrumentSupabaseClient = $117fe5d6c57eaae9$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $117fe5d6c57eaae9$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $117fe5d6c57eaae9$var$translateFiltersIntoMethods;

});

parcelRegister("aHLYS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $dpKhO = parcelRequire("dpKhO");

var $8wj7Q = parcelRequire("8wj7Q");
const $7cb32385980661d4$var$DEFAULT_LIMIT = 10;
const $7cb32385980661d4$var$INTEGRATION_NAME = 'ZodErrors';
/**
 * Simplified ZodIssue type definition
 */ function $7cb32385980661d4$var$originalExceptionIsZodError(originalException) {
    return $dpKhO.isError(originalException) && originalException.name === 'ZodError' && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function $7cb32385980661d4$var$flattenIssue(issue) {
    return {
        ...issue,
        path: 'path' in issue && Array.isArray(issue.path) ? issue.path.join('.') : undefined,
        keys: 'keys' in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: 'unionErrors' in issue ? JSON.stringify(issue.unionErrors) : undefined
    };
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function $7cb32385980661d4$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === 'number') return '<array>';
        else return p;
    }).join('.');
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function $7cb32385980661d4$var$formatIssueMessage(zodError) {
    const errorKeyMap = new Set();
    for (const iss of zodError.issues){
        const issuePath = $7cb32385980661d4$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        let rootExpectedType = 'variable';
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== undefined && 'expected' in iss && typeof iss.expected === 'string') rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$8wj7Q.truncate(errorKeys.join(', '), 100)}`;
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function $7cb32385980661d4$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$7cb32385980661d4$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($7cb32385980661d4$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: 'zod_issues.json',
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $7cb32385980661d4$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                'zoderror.issues': flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return {
            ...event,
            extra: {
                ...event.extra,
                'zoderrors sentry integration parse error': {
                    message: 'an exception was thrown while processing ZodError within applyZodErrorsToEvent()',
                    error: e instanceof Error ? `${e.name}: ${e.message}\n${e.stack}` : 'unknown'
                }
            }
        };
    }
}
const $7cb32385980661d4$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $7cb32385980661d4$var$DEFAULT_LIMIT;
    return {
        name: $7cb32385980661d4$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $7cb32385980661d4$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ const $7cb32385980661d4$var$zodErrorsIntegration = $dHcrw.defineIntegration($7cb32385980661d4$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $7cb32385980661d4$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $7cb32385980661d4$var$flattenIssue;
module.exports.flattenIssuePath = $7cb32385980661d4$var$flattenIssuePath;
module.exports.formatIssueMessage = $7cb32385980661d4$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $7cb32385980661d4$var$zodErrorsIntegration;

});

parcelRegister("7lJq4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $81uv9 = parcelRequire("81uv9");

var $cp5Oe = parcelRequire("cp5Oe");

var $9jmDw = parcelRequire("9jmDw");
/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ const $559db9f1c7fff9c5$var$thirdPartyErrorFilterIntegration = $dHcrw.defineIntegration((options)=>{
    return {
        name: 'ThirdPartyErrorsFilter',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope$1)=>{
                $cp5Oe.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            $81uv9.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $81uv9.addMetadataToStackFrames(stackParser, event);
            });
        },
        processEvent (event) {
            const frameKeys = $559db9f1c7fff9c5$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames);
            if (frameKeys) {
                const arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
/**
 * Checks if a stack frame is a Sentry internal frame by strictly matching:
 * 1. The frame must be the last frame in the stack
 * 2. The filename must indicate the internal helpers file
 * 3. The context_line must contain the exact pattern "fn.apply(this, wrappedArguments)"
 * 4. The comment pattern "Attempt to invoke user-land function" must be present in pre_context
 *
 */ function $559db9f1c7fff9c5$var$isSentryInternalFrame(frame, frameIndex) {
    // Only match the last frame (index 0 in reversed stack)
    if (frameIndex !== 0 || !frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes('sentry') || !frame.filename.includes('helpers') || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($559db9f1c7fff9c5$var$SENTRY_INTERNAL_FN_APPLY) // Must have context_line with the exact fn.apply pattern
    ) return false;
    // Check pre_context array for comment pattern
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($559db9f1c7fff9c5$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $559db9f1c7fff9c5$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames) {
    const frames = $9jmDw.getFramesFromEvent(event);
    if (!frames) return undefined;
    return frames.filter((frame, index)=>{
        // Exclude frames without a filename
        if (!frame.filename) return false;
        // Exclude frames without location info, since these are likely native code or built-ins.
        // JS frames have lineno/colno, WASM frames have instruction_addr instead.
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        // Optionally ignore Sentry internal frames
        return !ignoreSentryInternalFrames || !$559db9f1c7fff9c5$var$isSentryInternalFrame(frame, index);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($559db9f1c7fff9c5$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($559db9f1c7fff9c5$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
const $559db9f1c7fff9c5$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';
const $559db9f1c7fff9c5$var$SENTRY_INTERNAL_COMMENT = 'Attempt to invoke user-land function';
const $559db9f1c7fff9c5$var$SENTRY_INTERNAL_FN_APPLY = 'fn.apply(this, wrappedArguments)';
module.exports.thirdPartyErrorFilterIntegration = $559db9f1c7fff9c5$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("lCfgA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $25ylb = parcelRequire("25ylb");

var $d2jrf = parcelRequire("d2jrf");

var $gCzmC = parcelRequire("gCzmC");

var $dHcrw = parcelRequire("dHcrw");

var $3iQ48 = parcelRequire("3iQ48");

var $geSGs = parcelRequire("geSGs");

var $8wj7Q = parcelRequire("8wj7Q");

var $5xpfH = parcelRequire("5xpfH");
const $fbc8fd33de0884ef$var$INTEGRATION_NAME = 'Console';
/**
 * Captures calls to the `console` API as breadcrumbs in Sentry.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```js
 * Sentry.init({
 *   integrations: [Sentry.consoleIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $fbc8fd33de0884ef$var$consoleIntegration = $dHcrw.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $3iQ48.CONSOLE_LEVELS);
    return {
        name: $fbc8fd33de0884ef$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $gCzmC.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($d2jrf.getClient() !== client || !levels.has(level)) return;
                $fbc8fd33de0884ef$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe = $gCzmC.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe);
            }
        }
    };
});
/**
 * Capture a console breadcrumb.
 *
 * Exported just for tests.
 */ function $fbc8fd33de0884ef$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: 'console',
        data: {
            arguments: args,
            logger: 'console'
        },
        level: $geSGs.severityLevelFromString(level),
        message: $fbc8fd33de0884ef$var$formatConsoleArgs(args)
    };
    if (level === 'assert') {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$fbc8fd33de0884ef$var$formatConsoleArgs(assertionArgs)}` : 'Assertion failed';
            breadcrumb.data.arguments = assertionArgs;
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    $25ylb.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $fbc8fd33de0884ef$var$formatConsoleArgs(values) {
    return 'util' in $5xpfH.GLOBAL_OBJ && typeof $5xpfH.GLOBAL_OBJ.util.format === 'function' ? $5xpfH.GLOBAL_OBJ.util.format(...values) : $8wj7Q.safeJoin(values, ' ');
}
module.exports.addConsoleBreadcrumb = $fbc8fd33de0884ef$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $fbc8fd33de0884ef$var$consoleIntegration;

});

parcelRegister("73Ve8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $aLxtR = parcelRequire("aLxtR");
/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $5245344c59976bcc$var$featureFlagsIntegration = $dHcrw.defineIntegration(()=>{
    return {
        name: 'FeatureFlags',
        processEvent (event, _hint, _client) {
            return $aLxtR._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $aLxtR._INTERNAL_insertFlagToScope(name, value);
            $aLxtR._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $5245344c59976bcc$var$featureFlagsIntegration;

});
parcelRegister("aLxtR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");
/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $7d6843bfd423ef1b$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
/**
 * Max number of flag evaluations to record per span.
 */ const $7d6843bfd423ef1b$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $7d6843bfd423ef1b$var$SPAN_FLAG_ATTRIBUTE_PREFIX = 'flag.evaluation.';
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $7d6843bfd423ef1b$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) // No need to add the flags context to transaction events.
    // Spans already get the flag.evaluation attributes.
    return event;
    const scope = $d2jrf.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function $7d6843bfd423ef1b$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $7d6843bfd423ef1b$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $d2jrf.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $7d6843bfd423ef1b$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function $7d6843bfd423ef1b$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== 'boolean') return;
    if (flags.length > maxSize) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function $7d6843bfd423ef1b$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $7d6843bfd423ef1b$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== 'boolean') return;
    const span = $inXyb.getActiveSpan();
    if (!span) return;
    const attributes = $inXyb.spanToJSON(span).data;
    // If the flag already exists, always update it
    if (`${$7d6843bfd423ef1b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$7d6843bfd423ef1b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    // Else, add the flag to the span if we have not reached the max number of flags
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($7d6843bfd423ef1b$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$7d6843bfd423ef1b$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $7d6843bfd423ef1b$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $7d6843bfd423ef1b$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $7d6843bfd423ef1b$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $7d6843bfd423ef1b$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $7d6843bfd423ef1b$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $7d6843bfd423ef1b$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("eSLF5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHcrw = parcelRequire("dHcrw");

var $aLxtR = parcelRequire("aLxtR");

var $bKfNN = parcelRequire("bKfNN");
/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * Only boolean results are captured at this time.
 *
 * @example
 * ```typescript
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser'; // or '@sentry/node'
 *
 * Sentry.init({
 *   dsn: 'your-dsn',
 *   integrations: [
 *     Sentry.growthbookIntegration({ growthbookClass: GrowthBook })
 *   ]
 * });
 * ```
 */ const $ad5b14769126b81e$var$growthbookIntegration = $dHcrw.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: 'GrowthBook',
        setupOnce () {
            const proto = growthbookClass.prototype;
            // Type guard and wrap isOn
            if (typeof proto.isOn === 'function') $bKfNN.fill(proto, 'isOn', $ad5b14769126b81e$var$_wrapAndCaptureBooleanResult);
            // Type guard and wrap getFeatureValue
            if (typeof proto.getFeatureValue === 'function') $bKfNN.fill(proto, 'getFeatureValue', $ad5b14769126b81e$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $aLxtR._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $ad5b14769126b81e$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === 'string' && typeof result === 'boolean') {
            $aLxtR._INTERNAL_insertFlagToScope(flagName, result);
            $aLxtR._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $ad5b14769126b81e$var$growthbookIntegration;

});

parcelRegister("4bIxO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $dHcrw = parcelRequire("dHcrw");

var $6zIGl = parcelRequire("6zIGl");

var $inXyb = parcelRequire("inXyb");
const $30cabe18e357f140$var$INTEGRATION_NAME = 'ConversationId';
const $30cabe18e357f140$var$_conversationIdIntegration = ()=>{
    return {
        name: $30cabe18e357f140$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = $d2jrf.getCurrentScope().getScopeData();
                const isolationScopeData = $d2jrf.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $inXyb.spanToJSON(span);
                    // Only apply conversation ID to gen_ai spans.
                    // We also check for Vercel AI spans (ai.operationId attribute or ai.* span name)
                    // because the Vercel AI integration sets the gen_ai.* op in its own spanStart handler
                    // which fires after this, so the op is not yet available at this point.
                    if (!op?.startsWith('gen_ai.') && !attributes['ai.operationId'] && !name?.startsWith('ai.')) return;
                    span.setAttribute($6zIGl.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $30cabe18e357f140$var$conversationIdIntegration = $dHcrw.defineIntegration($30cabe18e357f140$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $30cabe18e357f140$var$conversationIdIntegration;

});

parcelRegister("3c27b", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");
function $253422137d49cfa2$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration['_profiler'] !== 'undefined' && typeof integration['_profiler']['start'] === 'function' && typeof integration['_profiler']['stop'] === 'function';
}
/**
 * Starts the Sentry continuous profiler.
 * This mode is exclusive with the transaction profiler and will only work if the profilesSampleRate is set to a falsy value.
 * In continuous profiling mode, the profiler will keep reporting profile chunks to Sentry until it is stopped, which allows for continuous profiling of the application.
 */ function $253422137d49cfa2$var$startProfiler() {
    const client = $d2jrf.getClient();
    if (!client) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('ProfilingIntegration is not available');
        return;
    }
    if (!$253422137d49cfa2$var$isProfilingIntegrationWithProfiler(integration)) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.start();
}
/**
 * Stops the Sentry continuous profiler.
 * Calls to stop will stop the profiler and flush the currently collected profile data to Sentry.
 */ function $253422137d49cfa2$var$stopProfiler() {
    const client = $d2jrf.getClient();
    if (!client) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('ProfilingIntegration is not available');
        return;
    }
    if (!$253422137d49cfa2$var$isProfilingIntegrationWithProfiler(integration)) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.stop();
}
/**
 * Profiler namespace for controlling the profiler in 'manual' mode.
 *
 * Requires the `nodeProfilingIntegration` from the `@sentry/profiling-node` package.
 */ const $253422137d49cfa2$var$profiler = {
    startProfiler: $253422137d49cfa2$var$startProfiler,
    stopProfiler: $253422137d49cfa2$var$stopProfiler
};
module.exports.profiler = $253422137d49cfa2$var$profiler;

});

parcelRegister("bfPAU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $6zIGl = parcelRequire("6zIGl");

var $inXyb = parcelRequire("inXyb");

var $9BaVX = parcelRequire("9BaVX");

var $dpKhO = parcelRequire("dpKhO");

var $6tBvR = parcelRequire("6tBvR");

var $1nDVq = parcelRequire("1nDVq");

var $4wZ5i = parcelRequire("4wZ5i");

var $euvlx = parcelRequire("euvlx");

var $92XmH = parcelRequire("92XmH");

var $gy40E = parcelRequire("gy40E");

var $kBM5C = parcelRequire("kBM5C");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $83191dfaf2a6eda0$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $6tBvR.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            // Only end the span and call hooks if we're actually recording
            if (shouldCreateSpanResult) {
                $83191dfaf2a6eda0$var$endSpan(span, handlerData);
                $83191dfaf2a6eda0$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin: spanOrigin = 'auto.http.browser', propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $d2jrf.getClient();
    const hasParent = !!$inXyb.getActiveSpan();
    // With span streaming, we always emit http.client spans, even without a parent span
    const shouldEmitSpan = hasParent || !!client && $euvlx.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $92XmH.startInactiveSpan($83191dfaf2a6eda0$var$getSpanStartOptions(url, method, spanOrigin)) : new $4wZ5i.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent('no_parent_span', 'span');
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        // Shallow clone the options object to avoid mutating the original user-provided object
        // Examples: users re-using same options object for multiple fetch calls, frozen objects
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $83191dfaf2a6eda0$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $6tBvR.hasSpansEnabled() && shouldEmitSpan ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function $83191dfaf2a6eda0$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === 'object' && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
/**
 * Builds merged fetch headers that include `sentry-trace` and `baggage` (and optionally `traceparent`)
 * for the given request and init, without mutating the original request or options.
 * Returns `undefined` when there is no `sentry-trace` value to attach.
 *
 * @internal Exported for cross-package instrumentation (for example Cloudflare Workers fetcher bindings)
 * and unit tests
 *
 * Baggage handling:
 * 1. No previous baggage header → include Sentry baggage
 * 2. Previous baggage has no Sentry entries → merge Sentry baggage in
 * 3. Previous baggage already has Sentry entries → leave as-is (may be user-defined)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $83191dfaf2a6eda0$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $kBM5C.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ($dpKhO.isRequest(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($83191dfaf2a6eda0$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$83191dfaf2a6eda0$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($83191dfaf2a6eda0$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === 'traceparent')) newHeaders.push([
            'traceparent',
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && typeof header[1] === 'string' && $83191dfaf2a6eda0$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$83191dfaf2a6eda0$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $83191dfaf2a6eda0$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            'sentry-trace': existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $83191dfaf2a6eda0$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $9BaVX.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $9BaVX.SPAN_STATUS_ERROR,
        message: 'internal_error'
    });
    span.end();
}
function $83191dfaf2a6eda0$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== 'string') return false;
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith($1nDVq.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $83191dfaf2a6eda0$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && $dpKhO.isInstanceOf(headers, Headers);
}
/** `HeadersInit` array form: each entry is a [name, value] pair of strings. */ function $83191dfaf2a6eda0$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === 'string');
}
function $83191dfaf2a6eda0$var$getSpanStartOptions(url$1, method, spanOrigin) {
    // Data URLs need special handling because parseStringToURLObject treats them as "relative"
    // (no "://"), causing getSanitizedUrlStringFromUrlObject to return just the pathname
    // without the "data:" prefix, making later stripDataUrlContent calls ineffective.
    // So for data URLs, we strip the content first and use that directly.
    if (url$1.startsWith('data:')) {
        const sanitizedUrl = $gy40E.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl}`,
            attributes: $83191dfaf2a6eda0$var$getFetchSpanAttributes(url$1, undefined, method, spanOrigin)
        };
    }
    const parsedUrl = $gy40E.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $gy40E.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $83191dfaf2a6eda0$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $83191dfaf2a6eda0$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $gy40E.stripDataUrlContent(url$1),
        type: 'fetch',
        'http.method': method,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'http.client'
    };
    if (parsedUrl) {
        if (!$gy40E.isURLObjectRelative(parsedUrl)) {
            attributes['http.url'] = $gy40E.stripDataUrlContent(parsedUrl.href);
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $83191dfaf2a6eda0$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $83191dfaf2a6eda0$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $83191dfaf2a6eda0$var$instrumentFetchRequest;

});

parcelRegister("eaC9u", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");
/**
 * Send user feedback to Sentry.
 */ function $a50f9812fcf7828e$var$captureFeedback(params, hint = {}, scope = $d2jrf.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: 'feedback',
        level: 'info',
        tags: tags
    };
    const client = scope?.getClient() || $d2jrf.getClient();
    if (client) client.emit('beforeSendFeedback', feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $a50f9812fcf7828e$var$captureFeedback;

});

parcelRegister("72p9e", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $a3J7x = parcelRequire("a3J7x");

var $5PM5M = parcelRequire("5PM5M");
/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param scope - The scope to capture the log with.
 * @param severityNumber - The severity number of the log.
 */ function $51fc3a275fca93b3$var$captureLog(level, message, attributes, scope, severityNumber) {
    $a3J7x._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
/**
 * Additional metadata to capture the log with.
 */ /**
 * @summary Capture a log with the `trace` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function $51fc3a275fca93b3$var$trace(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('trace', message, attributes, scope);
}
/**
 * @summary Capture a log with the `debug` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function $51fc3a275fca93b3$var$debug(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('debug', message, attributes, scope);
}
/**
 * @summary Capture a log with the `info` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function $51fc3a275fca93b3$var$info(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('info', message, attributes, scope);
}
/**
 * @summary Capture a log with the `warn` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function $51fc3a275fca93b3$var$warn(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('warn', message, attributes, scope);
}
/**
 * @summary Capture a log with the `error` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function $51fc3a275fca93b3$var$error(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('error', message, attributes, scope);
}
/**
 * @summary Capture a log with the `fatal` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function $51fc3a275fca93b3$var$fatal(message, attributes, { scope: scope } = {}) {
    $51fc3a275fca93b3$var$captureLog('fatal', message, attributes, scope);
}
module.exports.fmt = $5PM5M.fmt;
module.exports.debug = $51fc3a275fca93b3$var$debug;
module.exports.error = $51fc3a275fca93b3$var$error;
module.exports.fatal = $51fc3a275fca93b3$var$fatal;
module.exports.info = $51fc3a275fca93b3$var$info;
module.exports.trace = $51fc3a275fca93b3$var$trace;
module.exports.warn = $51fc3a275fca93b3$var$warn;

});

parcelRegister("5WVIL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $9XOi0 = parcelRequire("9XOi0");

var $gCzmC = parcelRequire("gCzmC");

var $dHcrw = parcelRequire("dHcrw");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $a3J7x = parcelRequire("a3J7x");

var $6P9MC = parcelRequire("6P9MC");
const $454f24b2a085b993$var$INTEGRATION_NAME = 'ConsoleLogs';
const $454f24b2a085b993$var$DEFAULT_ATTRIBUTES = {
    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.log.console'
};
const $454f24b2a085b993$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $3iQ48.CONSOLE_LEVELS;
    return {
        name: $454f24b2a085b993$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            if (!enableLogs) {
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('`enableLogs` is not enabled, ConsoleLogs integration disabled');
                return;
            }
            const unsubscribe = $gCzmC.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($d2jrf.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === 'assert') {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$6P9MC.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : 'Assertion failed';
                        $a3J7x._INTERNAL_captureLog({
                            level: 'error',
                            message: assertionMessage,
                            attributes: $454f24b2a085b993$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === 'log';
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === 'string' && !$6P9MC.hasConsoleSubstitutions(args[0]);
                const attributes = {
                    ...$454f24b2a085b993$var$DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? $6P9MC.createConsoleTemplateAttributes(firstArg, followingArgs) : {}
                };
                $a3J7x._INTERNAL_captureLog({
                    level: isLevelLog ? 'info' : level,
                    message: $6P9MC.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires the `enableLogs` option to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   enableLogs: true,
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $454f24b2a085b993$var$consoleLoggingIntegration = $dHcrw.defineIntegration($454f24b2a085b993$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $454f24b2a085b993$var$consoleLoggingIntegration;

});
parcelRegister("6P9MC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dpKhO = parcelRequire("dpKhO");

var $iCGkd = parcelRequire("iCGkd");

var $5xpfH = parcelRequire("5xpfH");
/**
 * Formats the given values into a string.
 *
 * @param values - The values to format.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The formatted string.
 */ function $4f7f183a61ad6f15$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return 'util' in $5xpfH.GLOBAL_OBJ && typeof $5xpfH.GLOBAL_OBJ.util.format === 'function' ? $5xpfH.GLOBAL_OBJ.util.format(...values) : $4f7f183a61ad6f15$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
/**
 * Joins the given values into a string.
 *
 * @param values - The values to join.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The joined string.
 */ function $4f7f183a61ad6f15$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$dpKhO.isPrimitive(value) ? String(value) : JSON.stringify($iCGkd.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(' ');
}
/**
 * Checks if a string contains console substitution patterns like %s, %d, %i, %f, %o, %O, %c.
 *
 * @param str - The string to check
 * @returns true if the string contains console substitution patterns
 */ function $4f7f183a61ad6f15$var$hasConsoleSubstitutions(str) {
    // Match console substitution patterns: %s, %d, %i, %f, %o, %O, %c
    return /%[sdifocO]/.test(str);
}
/**
 * Creates template attributes for multiple console arguments.
 *
 * @param args - The console arguments
 * @returns An object with template and parameter attributes
 */ function $4f7f183a61ad6f15$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    // Create template with placeholders for each argument
    const template = new Array(followingArgs.length).fill('{}').join(' ');
    attributes['sentry.message.template'] = `${firstArg} ${template}`;
    // Add each argument as a parameter
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $4f7f183a61ad6f15$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $4f7f183a61ad6f15$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $4f7f183a61ad6f15$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $4f7f183a61ad6f15$var$safeJoinConsoleArgs;

});


parcelRegister("3STJz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3GDsH = parcelRequire("3GDsH");
/**
 * Options for capturing a metric.
 */ /**
 * Capture a metric with the given type, name, and value.
 *
 * @param type - The type of the metric.
 * @param name - The name of the metric.
 * @param value - The value of the metric.
 * @param options - Options for capturing the metric.
 */ function $2d41a5dcd6efe18d$var$captureMetric(type, name, value, options) {
    $3GDsH._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
/**
 * @summary Increment a counter metric.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function $2d41a5dcd6efe18d$var$count(name, value = 1, options) {
    $2d41a5dcd6efe18d$var$captureMetric('counter', name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function $2d41a5dcd6efe18d$var$gauge(name, value, options) {
    $2d41a5dcd6efe18d$var$captureMetric('gauge', name, value, options);
}
/**
 * @summary Record a value in a distribution metric.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function $2d41a5dcd6efe18d$var$distribution(name, value, options) {
    $2d41a5dcd6efe18d$var$captureMetric('distribution', name, value, options);
}
module.exports.count = $2d41a5dcd6efe18d$var$count;
module.exports.distribution = $2d41a5dcd6efe18d$var$distribution;
module.exports.gauge = $2d41a5dcd6efe18d$var$gauge;

});

parcelRegister("bw8wJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $a3J7x = parcelRequire("a3J7x");

var $6P9MC = parcelRequire("6P9MC");

var $dpKhO = parcelRequire("dpKhO");

var $iCGkd = parcelRequire("iCGkd");
/**
 * Result of extracting structured attributes from console arguments.
 */ const $86294c1fc9de6207$var$DEFAULT_CAPTURED_LEVELS = [
    'trace',
    'debug',
    'info',
    'warn',
    'error',
    'fatal'
];
/**
 * Creates a new Sentry reporter for Consola that forwards logs to Sentry. Requires the `enableLogs` option to be enabled.
 *
 * **Note: This integration supports Consola v3.x only.** The reporter interface and log object structure
 * may differ in other versions of Consola.
 *
 * @param options - Configuration options for the reporter.
 * @returns A Consola reporter that can be added to consola instances.
 *
 * @example
 * ```ts
 * import * as Sentry from '@sentry/node';
 * import { consola } from 'consola';
 *
 * Sentry.init({
 *   enableLogs: true,
 * });
 *
 * const sentryReporter = Sentry.createConsolaReporter({
 *   // Optional: filter levels to capture
 *   levels: ['error', 'warn', 'info'],
 * });
 *
 * consola.addReporter(sentryReporter);
 *
 * // Now consola logs will be captured by Sentry
 * consola.info('This will be sent to Sentry');
 * consola.error('This error will also be sent to Sentry');
 * ```
 */ function $86294c1fc9de6207$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $86294c1fc9de6207$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            // We need to exclude certain known properties from being added as additional attributes
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            // Get client - use provided client or current client
            const client = providedClient || $d2jrf.getClient();
            if (!client) return;
            // Determine the log severity level
            const logSeverityLevel = $86294c1fc9de6207$var$getLogSeverityLevel(type, level);
            // Early exit if this level should not be captured
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            const attributes = {};
            // Build attributes
            for (const [key, value] of Object.entries(rest))attributes[key] = $iCGkd.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes['sentry.origin'] = 'auto.log.consola';
            if (tag) attributes['consola.tag'] = tag;
            if (type) attributes['consola.type'] = type;
            // Only add level if it's a valid number (not null/undefined)
            if (level != null && typeof level === 'number') attributes['consola.level'] = level;
            const extractionResult = $86294c1fc9de6207$var$processExtractedAttributes($86294c1fc9de6207$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $a3J7x._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $6P9MC.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || '',
                attributes: attributes
            });
        }
    };
}
// Mapping from consola log types to Sentry log severity levels
const $86294c1fc9de6207$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: 'trace',
    fatal: 'fatal',
    error: 'error',
    warn: 'warn',
    log: 'info',
    info: 'info',
    success: 'info',
    fail: 'error',
    ready: 'info',
    start: 'info',
    box: 'info',
    debug: 'debug',
    trace: 'trace',
    verbose: 'debug',
    // Custom types that might exist
    critical: 'fatal',
    notice: 'info'
};
// Mapping from consola log levels (numbers) to Sentry log severity levels
const $86294c1fc9de6207$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: 'fatal',
    1: 'warn',
    2: 'info',
    3: 'info',
    4: 'debug',
    5: 'trace'
};
/**
 * Determines the log severity level from Consola type and level.
 *
 * @param type - The Consola log type (e.g., 'error', 'warn', 'info')
 * @param level - The Consola numeric log level (0-5) or null for some types like 'verbose'
 * @returns The corresponding Sentry log severity level
 */ function $86294c1fc9de6207$var$getLogSeverityLevel(type, level) {
    // Handle special case for verbose logs (level can be null with infinite level in Consola)
    if (type === 'verbose') return 'debug';
    // Handle silent logs - these should be at trace level
    if (type === 'silent') return 'trace';
    // First try to map by type (more specific)
    if (type) {
        const mappedLevel = $86294c1fc9de6207$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    // Fallback to level mapping (handle null level)
    if (typeof level === 'number') {
        const mappedLevel = $86294c1fc9de6207$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    // Default fallback
    return 'info';
}
/**
 * Extracts structured attributes from console arguments. If the first argument is a plain object, its properties are extracted as attributes.
 */ function $86294c1fc9de6207$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ''
    };
    // Message looks like how consola logs the message to the console (all args stringified and joined)
    const message = $6P9MC.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($dpKhO.isPlainObject(firstArg)) {
        // Remaining args start from index 2 i f we used second arg as message, otherwise from index 1
        const remainingArgsStartIndex = typeof args[1] === 'string' ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === 'string' && !$6P9MC.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : undefined,
            messageParameters: shouldAddTemplateAttr ? followingArgs : undefined
        };
    }
}
/**
 * Processes extracted attributes by normalizing them and preparing message parameter attributes if a template is present.
 */ function $86294c1fc9de6207$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $6P9MC.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith('sentry.message.parameter.') ? $iCGkd.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $iCGkd.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$iCGkd.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $86294c1fc9de6207$var$createConsolaReporter;

});

parcelRegister("4ifN0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $6zIGl = parcelRequire("6zIGl");

var $2C8Yo = parcelRequire("2C8Yo");

var $inXyb = parcelRequire("inXyb");

var $k9TjS = parcelRequire("k9TjS");

var $968E2 = parcelRequire("968E2");

var $euvlx = parcelRequire("euvlx");

var $h5a7p = parcelRequire("h5a7p");

var $cHJNr = parcelRequire("cHJNr");
/**
 * Post-process spans emitted by the Vercel AI SDK.
 * This is supposed to be used in `client.on('spanStart', ...)
 */ function $32051754a10f0d43$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $inXyb.spanToJSON(span);
    if (!name) return;
    // Tool call spans
    // https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
    if (attributes[$cHJNr.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$cHJNr.AI_TOOL_CALL_ID_ATTRIBUTE] && name === 'ai.toolCall') {
        $32051754a10f0d43$var$processToolCallSpan(span, attributes);
        return;
    }
    // V6+ Check if this is a Vercel AI span by checking if the operation ID attribute is present.
    // V5+ Check if this is a Vercel AI span by name pattern.
    if (!attributes[$cHJNr.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith('ai.')) return;
    const client = $d2jrf.getClient();
    const integration = client?.getIntegrationByName('VercelAI');
    const enableTruncation = $2C8Yo.shouldEnableTruncation(integration?.options?.enableTruncation);
    $32051754a10f0d43$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $32051754a10f0d43$var$vercelAiEventProcessor(event) {
    if (event.type === 'transaction' && event.spans) {
        // Map to accumulate token data by parent span ID
        const tokenAccumulator = new Map();
        // First pass: process all spans and accumulate token data
        for (const span of event.spans){
            $32051754a10f0d43$var$processEndedVercelAiSpan(span);
            // Accumulate token data for parent spans
            $h5a7p.accumulateTokensForParent(span, tokenAccumulator);
        }
        // Second pass: apply tool descriptions and accumulated tokens
        $h5a7p.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        // Also apply to root when it is the invoke_agent pipeline
        const trace = event.contexts?.trace;
        if (trace?.op === 'gen_ai.invoke_agent') $h5a7p.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
/**
 * Tool call structure from Vercel AI SDK
 * Note: V5/V6 use 'input' for arguments, V4 and earlier use 'args'
 */ /**
 * Normalize finish reason to match OpenTelemetry semantic conventions.
 * Valid values: "stop", "length", "content_filter", "tool_call", "error"
 *
 * Vercel AI SDK uses "tool-calls" (plural, with hyphen) which we map to "tool_call".
 */ function $32051754a10f0d43$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== 'string') return 'stop';
    // Map Vercel AI SDK finish reasons to OpenTelemetry semantic convention values
    switch(finishReason){
        case 'tool-calls':
            return 'tool_call';
        case 'stop':
        case 'length':
        case 'content_filter':
        case 'error':
            return finishReason;
        default:
            // For unknown values, return as-is (schema allows arbitrary strings)
            return finishReason;
    }
}
/**
 * Build gen_ai.output.messages from ai.response.text and/or ai.response.toolCalls
 *
 * Format follows OpenTelemetry semantic conventions:
 * [{"role": "assistant", "parts": [...], "finish_reason": "stop"}]
 *
 * Parts can be:
 * - {"type": "text", "content": "..."}
 * - {"type": "tool_call", "id": "...", "name": "...", "arguments": "..."}
 */ function $32051754a10f0d43$var$buildOutputMessages(attributes) {
    const responseText = attributes[$cHJNr.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$cHJNr.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$cHJNr.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    // Skip if neither text nor tool calls are present
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    // Add text part if present
    if (typeof responseText === 'string' && responseText.length > 0) parts.push({
        type: 'text',
        content: responseText
    });
    // Add tool call parts if present
    if (responseToolCalls != null) try {
        // Tool calls can be a string (JSON) or already parsed array
        const toolCalls = typeof responseToolCalls === 'string' ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                // V5/V6 use 'input', V4 and earlier use 'args'
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: 'tool_call',
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === 'string' ? args : JSON.stringify(args ?? {})
                });
            }
            // Only delete tool calls attribute if we successfully processed them
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete attributes[$cHJNr.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {
    // Ignore parsing errors - tool calls attribute is preserved
    }
    // Only set output messages and delete text attribute if we have parts
    if (parts.length > 0) {
        const outputMessage = {
            role: 'assistant',
            parts: parts,
            finish_reason: $32051754a10f0d43$var$normalizeFinishReason(finishReason)
        };
        attributes[$k9TjS.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        // Remove the text attribute since it's now captured in gen_ai.output.messages
        // Note: tool calls attribute is deleted above only if successfully parsed
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[$cHJNr.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
/**
 * Post-process spans emitted by the Vercel AI SDK.
 */ /**
 * Rename and normalize Vercel AI SDK attributes to OpenTelemetry semantic conventions.
 * This is the shared attribute processing logic used by both the legacy event processor
 * path (SpanJSON) and the streamed span path (StreamedSpanJSON).
 */ function $32051754a10f0d43$var$processVercelAiSpanAttributes(attributes) {
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    // Parent spans (ai.streamText, ai.streamObject, etc.) use inputTokens/outputTokens instead of promptTokens/completionTokens
    $32051754a10f0d43$var$renameAttributeKey(attributes, 'ai.usage.inputTokens', $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, 'ai.usage.outputTokens', $k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    // Embedding spans use ai.usage.tokens instead of promptTokens/completionTokens
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_USAGE_TOKENS_ATTRIBUTE, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    // AI SDK uses avgOutputTokensPerSecond, map to our expected attribute name
    $32051754a10f0d43$var$renameAttributeKey(attributes, 'ai.response.avgOutputTokensPerSecond', 'ai.response.avgCompletionTokensPerSecond');
    // Input tokens is the sum of prompt tokens and cached input tokens
    if (typeof attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === 'number' && typeof attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === 'number') attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    // Compute total tokens from input + output (embeddings may only have input tokens)
    if (typeof attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === 'number') {
        const outputTokens = typeof attributes[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === 'number' ? attributes[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    // Convert the available tools array to a JSON string
    if (attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE] = $h5a7p.convertAvailableToolsToJsonString(attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE]);
    // Rename AI SDK attributes to standardized gen_ai attributes
    // Map operation.name to OpenTelemetry semantic convention values
    if (attributes[$cHJNr.OPERATION_NAME_ATTRIBUTE]) {
        // V6+ sets ai.operationId to the bare operation (e.g. "ai.streamText") while
        // operation.name appends functionId (e.g. "ai.streamText myAgent").
        // When ai.operationId is present, use it for correct mapping.
        const rawOperationName = attributes[$cHJNr.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$cHJNr.AI_OPERATION_ID_ATTRIBUTE] : attributes[$cHJNr.OPERATION_NAME_ATTRIBUTE];
        const operationName = $968E2.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[$cHJNr.OPERATION_NAME_ATTRIBUTE];
    }
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_PROMPT_MESSAGES_ATTRIBUTE, $k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    // Build gen_ai.output.messages from response text and/or tool calls
    // Note: buildOutputMessages also removes the source attributes when output is successfully generated
    $32051754a10f0d43$var$buildOutputMessages(attributes);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_RESPONSE_OBJECT_ATTRIBUTE, 'gen_ai.response.object');
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE, 'gen_ai.request.available_tools');
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_TOOL_CALL_ARGS_ATTRIBUTE, $k9TjS.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_TOOL_CALL_RESULT_ATTRIBUTE, $k9TjS.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_SCHEMA_ATTRIBUTE, 'gen_ai.request.schema');
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_MODEL_ID_ATTRIBUTE, $k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    // Map embedding input: ai.values → gen_ai.embeddings.input
    // Vercel AI SDK JSON-stringifies each value individually, so we parse each element back.
    // Single embed gets unwrapped to a plain value; batch embedMany stays as a JSON array.
    if (Array.isArray(attributes[$cHJNr.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$cHJNr.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$k9TjS.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $32051754a10f0d43$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        // JSON-stringify any array-valued attributes so they survive v2 span serialization.
        // Can be removed once span streaming supports arrays natively.
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        // Change attributes namespaced with `ai.X` to `vercel.ai.X`
        if (key.startsWith('ai.')) $32051754a10f0d43$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $32051754a10f0d43$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== 'auto.vercelai.otel') return;
    // The Vercel AI SDK sets span status to raw error message strings.
    // Any such value should be normalized to a SpanStatusType value. We pick internal_error as it is the most generic.
    if (span.status && span.status !== 'ok') span.status = 'internal_error';
    $32051754a10f0d43$var$processVercelAiSpanAttributes(attributes);
}
function $32051754a10f0d43$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== 'auto.vercelai.otel') return;
    $32051754a10f0d43$var$processVercelAiSpanAttributes(attributes);
    // Look up tool description from the toolDescriptionMap for execute_tool spans
    if (attributes[$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP] === 'gen_ai.execute_tool' && span.parent_span_id) {
        const descriptions = $968E2.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === 'string') {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$k9TjS.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    // Clean up tool descriptions when the parent span ends
    $968E2.toolDescriptionMap.delete(span.span_id);
}
/**
 * Renames an attribute key in the provided attributes object if the old key exists.
 * This function safely handles null and undefined values.
 */ function $32051754a10f0d43$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[oldKey];
    }
}
function $32051754a10f0d43$var$processToolCallSpan(span, attributes) {
    span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.vercelai.otel');
    span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP, 'gen_ai.execute_tool');
    span.setAttribute($k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE, 'execute_tool');
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_TOOL_CALL_NAME_ATTRIBUTE, $k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $32051754a10f0d43$var$renameAttributeKey(attributes, $cHJNr.AI_TOOL_CALL_ID_ATTRIBUTE, $k9TjS.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    // Store the span context in our global map using the tool call ID.
    // This allows us to capture tool errors and link them to the correct span
    // without retaining the full Span object in memory.
    const toolCallId = attributes[$k9TjS.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === 'string') $968E2.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    // https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-type
    if (!attributes[$k9TjS.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($k9TjS.GEN_AI_TOOL_TYPE_ATTRIBUTE, 'function');
    const toolName = attributes[$k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $32051754a10f0d43$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.vercelai.otel');
    const nameWthoutAi = name.replace('ai.', '');
    span.setAttribute('ai.pipeline.name', nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$cHJNr.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === 'string') span.setAttribute('gen_ai.function_id', functionId);
    $h5a7p.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$cHJNr.AI_MODEL_ID_ATTRIBUTE] && !attributes[$k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$cHJNr.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute('ai.streaming', name.includes('stream'));
    // Set the op based on the operation name registry
    const operationName = $968E2.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith('ai.stream')) span.setAttribute($6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP, 'ai.run');
    // For invoke_agent pipeline spans, use 'invoke_agent' as the description
    // to be consistent with other AI integrations (e.g. LangGraph)
    if (operationName === 'invoke_agent') {
        if (functionId && typeof functionId === 'string') span.updateName(`invoke_agent ${functionId}`);
        else span.updateName('invoke_agent');
        return;
    }
    const modelId = attributes[$cHJNr.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    // Store tool descriptions in the toolDescriptionMap so processSpan can apply them to execute_tool spans.
    // This is only needed for span streaming (transaction path handles this separately)
    const client = $d2jrf.getClient();
    if (client && $euvlx.hasSpanStreamingEnabled(client) && attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = new Map();
        // parse tool names and descriptions from tool string array
        for (const toolStr of attributes[$cHJNr.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === 'string' ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {
        // ignore parse errors
        }
        if (descriptions.size > 0) {
            // Tool call spans are siblings of doGenerate (both children of invoke_agent),
            // so we key by the parent span ID (the invoke_agent span).
            const parentSpanId = $inXyb.spanToJSON(span).parent_span_id;
            if (parentSpanId) $968E2.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
/**
 * Add event processors to the given client to process Vercel AI spans.
 */ function $32051754a10f0d43$var$addVercelAiProcessors(client) {
    client.on('spanStart', $32051754a10f0d43$var$onVercelAiSpanStart);
    // Note: We cannot do this on `spanEnd`, because the span cannot be mutated anymore at this point
    client.addEventProcessor(Object.assign($32051754a10f0d43$var$vercelAiEventProcessor, {
        id: 'VercelAiEventProcessor'
    }));
    client.on('processSpan', (span)=>{
        $32051754a10f0d43$var$processVercelAiStreamedSpan(span);
    });
}
function $32051754a10f0d43$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$cHJNr.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        const providerMetadataObject = JSON.parse(providerMetadata);
        // Handle OpenAI metadata (v5 uses 'openai', v6 Azure Responses API uses 'azure')
        const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
        if (openaiMetadata) {
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.reasoning', openaiMetadata.reasoningTokens);
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_accepted', openaiMetadata.acceptedPredictionTokens);
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_rejected', openaiMetadata.rejectedPredictionTokens);
            if (!attributes['gen_ai.conversation.id']) $32051754a10f0d43$var$setAttributeIfDefined(attributes, 'gen_ai.conversation.id', openaiMetadata.responseId);
        }
        if (providerMetadataObject.anthropic) {
            const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
            const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
        }
        if (providerMetadataObject.bedrock?.usage) {
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.deepseek.promptCacheHitTokens);
            $32051754a10f0d43$var$setAttributeIfDefined(attributes, 'gen_ai.usage.input_tokens.cache_miss', providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch  {
    // Ignore
    }
}
/**
 * Sets an attribute only if the value is not null or undefined.
 */ function $32051754a10f0d43$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $32051754a10f0d43$var$addVercelAiProcessors;
module.exports.processVercelAiSpanAttributes = $32051754a10f0d43$var$processVercelAiSpanAttributes;

});
parcelRegister("2C8Yo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $d2jrf = parcelRequire("d2jrf");

var $euvlx = parcelRequire("euvlx");

var $dpKhO = parcelRequire("dpKhO");

var $k9TjS = parcelRequire("k9TjS");

var $8iTiS = parcelRequire("8iTiS");
/**
 * Shared utils for AI integrations (OpenAI, Anthropic, Verce.AI, etc.)
 */ /**
 * Resolves AI recording options by falling back to the client's `sendDefaultPii` setting.
 * Precedence: explicit option > sendDefaultPii > false
 */ function $1e76173a2006bcc8$var$resolveAIRecordingOptions(options) {
    const sendDefaultPii = Boolean($d2jrf.getClient()?.getOptions().sendDefaultPii);
    return {
        ...options,
        recordInputs: options?.recordInputs ?? sendDefaultPii,
        recordOutputs: options?.recordOutputs ?? sendDefaultPii
    };
}
/**
 * Resolves whether truncation should be enabled.
 * If the user explicitly set `enableTruncation`, that value is used.
 * Otherwise, truncation is disabled when span streaming is active.
 */ function $1e76173a2006bcc8$var$shouldEnableTruncation(enableTruncation) {
    const client = $d2jrf.getClient();
    return enableTruncation ?? !(client && $euvlx.hasSpanStreamingEnabled(client));
}
/**
 * Build method path from current traversal
 */ function $1e76173a2006bcc8$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param cachedInputTokens - The number of cached input tokens
 * @param cachedOutputTokens - The number of cached output tokens
 */ function $1e76173a2006bcc8$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== undefined) span.setAttributes({
        [$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== undefined) span.setAttributes({
        [$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== undefined || completionTokens !== undefined || cachedInputTokens !== undefined || cachedOutputTokens !== undefined) {
        /**
     * Total input tokens in a request is the summation of `input_tokens`,
     * `cache_creation_input_tokens`, and `cache_read_input_tokens`.
     */ const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
/**
 * Ends a streaming span by setting all accumulated response attributes and ending the span.
 * Shared across OpenAI, Anthropic, and Google GenAI streaming implementations.
 */ function $1e76173a2006bcc8$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$k9TjS.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$k9TjS.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== undefined) attrs[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== undefined) attrs[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    // Use explicit total if provided (OpenAI, Google), otherwise compute from cache tokens (Anthropic)
    if (state.totalTokens !== undefined) attrs[$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== undefined || state.completionTokens !== undefined || state.cacheCreationInputTokens !== undefined || state.cacheReadInputTokens !== undefined) attrs[$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join('');
    if (recordOutputs && state.toolCalls.length) attrs[$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
/**
 * Serialize a value to a JSON string without truncation.
 * Strings are returned as-is, arrays and objects are JSON-stringified.
 */ function $1e76173a2006bcc8$var$getJsonString(value) {
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
}
/**
 * Get the truncated JSON string for a string or array of strings.
 *
 * @param value - The string or array of strings to truncate
 * @returns The truncated JSON string
 */ function $1e76173a2006bcc8$var$getTruncatedJsonString(value) {
    if (typeof value === 'string') // Some values are already JSON strings, so we don't need to duplicate the JSON parsing
    return $8iTiS.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        // truncateGenAiMessages returns an array of strings, so we need to stringify it
        const truncatedMessages = $8iTiS.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    // value is an object, so we need to stringify it
    return JSON.stringify(value);
}
/**
 * Extract system instructions from messages array.
 * Finds the first system message and formats it according to OpenTelemetry semantic conventions.
 *
 * @param messages - Array of messages to extract system instructions from
 * @returns systemInstructions (JSON string) and filteredMessages (without system message)
 */ function $1e76173a2006bcc8$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === 'object' && 'role' in msg && msg.role === 'system');
    if (systemMessageIndex === -1) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === 'string' ? systemMessage.content : systemMessage.content !== undefined ? JSON.stringify(systemMessage.content) : undefined;
    if (!systemContent) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: 'text',
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
/**
 * Creates a wrapped version of .withResponse() that replaces the data field
 * with the instrumented result while preserving metadata (response, request_id).
 */ async function $1e76173a2006bcc8$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    // Attach catch handler to originalWithResponse immediately to prevent unhandled rejection
    // If instrumentedPromise rejects first, we still need this handled
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $lCPaR.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    // Combine instrumented result with original metadata
    if (originalWrapper && typeof originalWrapper === 'object' && 'data' in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
/**
 * Wraps a promise-like object to preserve additional methods (like .withResponse())
 * that AI SDK clients (OpenAI, Anthropic) attach to their APIPromise return values.
 *
 * Standard Promise methods (.then, .catch, .finally) are routed to the instrumented
 * promise to preserve Sentry's span instrumentation, while custom SDK methods are
 * forwarded to the original promise to maintain the SDK's API surface.
 */ function $1e76173a2006bcc8$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    // If the original result is not thenable, return the instrumented promise
    if (!$dpKhO.isThenable(originalPromiseLike)) return instrumentedPromise;
    // Create a proxy that forwards Promise methods to instrumentedPromise
    // and preserves additional methods from the original result
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            // For standard Promise methods (.then, .catch, .finally, Symbol.toStringTag),
            // use instrumentedPromise to preserve Sentry instrumentation.
            // For custom methods (like .withResponse()), use the original target.
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            // Special handling for .withResponse() to preserve instrumentation
            // .withResponse() returns { data: T, response: Response, request_id: string }
            if (prop === 'withResponse' && typeof value === 'function') return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $1e76173a2006bcc8$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === 'function' ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $1e76173a2006bcc8$var$buildMethodPath;
module.exports.endStreamSpan = $1e76173a2006bcc8$var$endStreamSpan;
module.exports.extractSystemInstructions = $1e76173a2006bcc8$var$extractSystemInstructions;
module.exports.getJsonString = $1e76173a2006bcc8$var$getJsonString;
module.exports.getTruncatedJsonString = $1e76173a2006bcc8$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $1e76173a2006bcc8$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $1e76173a2006bcc8$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $1e76173a2006bcc8$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $1e76173a2006bcc8$var$wrapPromiseWithMethods;

});
parcelRegister("k9TjS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * OpenAI Integration Telemetry Attributes
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 */ // =============================================================================
// OPENTELEMETRY SEMANTIC CONVENTIONS FOR GENAI
// =============================================================================
/**
 * The input messages sent to the model
 */ const $eacf8f36a3f10cd4$var$GEN_AI_PROMPT_ATTRIBUTE = 'gen_ai.prompt';
/**
 * The Generative AI system being used
 * For OpenAI, this should always be "openai"
 */ const $eacf8f36a3f10cd4$var$GEN_AI_SYSTEM_ATTRIBUTE = 'gen_ai.system';
/**
 * The name of the model as requested
 * Examples: "gpt-4", "gpt-3.5-turbo"
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = 'gen_ai.request.model';
/**
 * Whether streaming was enabled for the request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = 'gen_ai.request.stream';
/**
 * The temperature setting for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = 'gen_ai.request.temperature';
/**
 * The maximum number of tokens requested
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = 'gen_ai.request.max_tokens';
/**
 * The frequency penalty setting for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = 'gen_ai.request.frequency_penalty';
/**
 * The presence penalty setting for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = 'gen_ai.request.presence_penalty';
/**
 * The top_p (nucleus sampling) setting for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = 'gen_ai.request.top_p';
/**
 * The top_k setting for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = 'gen_ai.request.top_k';
/**
 * The encoding format for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = 'gen_ai.request.encoding_format';
/**
 * The dimensions for the model request
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = 'gen_ai.request.dimensions';
/**
 * Array of reasons why the model stopped generating tokens
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = 'gen_ai.response.finish_reasons';
/**
 * The name of the model that generated the response
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = 'gen_ai.response.model';
/**
 * The unique identifier for the response
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = 'gen_ai.response.id';
/**
 * The reason why the model stopped generating tokens
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = 'gen_ai.response.stop_reason';
/**
 * The number of tokens used in the prompt
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.input_tokens';
/**
 * The number of tokens used in the response
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.output_tokens';
/**
 * The total number of tokens used (input + output)
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = 'gen_ai.usage.total_tokens';
/**
 * The operation name
 */ const $eacf8f36a3f10cd4$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = 'gen_ai.operation.name';
/**
 * Original length of messages array, used to indicate truncations had occured
 */ const $eacf8f36a3f10cd4$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = 'sentry.sdk_meta.gen_ai.input.messages.original_length';
/**
 * The prompt messages
 * Only recorded when recordInputs is enabled
 */ const $eacf8f36a3f10cd4$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = 'gen_ai.input.messages';
/**
 * The model's response messages including text and tool calls
 * Only recorded when recordOutputs is enabled
 * Format: stringified array of message objects with role, parts, and finish_reason
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-output-messages
 */ const $eacf8f36a3f10cd4$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = 'gen_ai.output.messages';
/**
 * The system instructions extracted from system messages
 * Only recorded when recordInputs is enabled
 * According to OpenTelemetry spec: https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-system-instructions
 */ const $eacf8f36a3f10cd4$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = 'gen_ai.system_instructions';
/**
 * The response text
 * Only recorded when recordOutputs is enabled
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = 'gen_ai.response.text';
/**
 * The available tools from incoming request
 * Only recorded when recordInputs is enabled
 */ const $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = 'gen_ai.request.available_tools';
/**
 * Whether the response is a streaming response
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = 'gen_ai.response.streaming';
/**
 * The tool calls from the response
 * Only recorded when recordOutputs is enabled
 */ const $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'gen_ai.response.tool_calls';
/**
 * The agent name
 */ const $eacf8f36a3f10cd4$var$GEN_AI_AGENT_NAME_ATTRIBUTE = 'gen_ai.agent.name';
/**
 * The pipeline name
 */ const $eacf8f36a3f10cd4$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = 'gen_ai.pipeline.name';
/**
 * The conversation ID for linking messages across API calls
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $eacf8f36a3f10cd4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = 'gen_ai.conversation.id';
/**
 * The number of cache creation input tokens used
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_creation_input_tokens';
/**
 * The number of cache read input tokens used
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_read_input_tokens';
/**
 * The number of cache write input tokens used
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = 'gen_ai.usage.input_tokens.cache_write';
/**
 * The number of cached input tokens that were used
 */ const $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = 'gen_ai.usage.input_tokens.cached';
/**
 * The span operation name for invoking an agent
 */ const $eacf8f36a3f10cd4$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = 'gen_ai.invoke_agent';
/**
 * The embeddings input
 * Only recorded when recordInputs is enabled
 */ const $eacf8f36a3f10cd4$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = 'gen_ai.embeddings.input';
/**
 * The span operation for embeddings
 */ const $eacf8f36a3f10cd4$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = 'gen_ai.embeddings';
/**
 * The span operation name for executing a tool
 */ const $eacf8f36a3f10cd4$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = 'gen_ai.execute_tool';
/**
 * The tool name for tool call spans
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_NAME_ATTRIBUTE = 'gen_ai.tool.name';
/**
 * The tool call ID
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = 'gen_ai.tool.call.id';
/**
 * The tool type (e.g., 'function')
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = 'gen_ai.tool.type';
/**
 * The tool input/arguments
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = 'gen_ai.tool.input';
/**
 * The tool output/result
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = 'gen_ai.tool.output';
/**
 * The description of the tool being used
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-description
 */ const $eacf8f36a3f10cd4$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = 'gen_ai.tool.description';
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $eacf8f36a3f10cd4$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("8iTiS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dJ26n = parcelRequire("dJ26n");
/**
 * Default maximum size in bytes for GenAI messages.
 * Messages exceeding this limit will be truncated.
 */ const $60bae7485a5474c6$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 20000;
/**
 * Message format used by OpenAI and Anthropic APIs.
 */ /**
 * Calculate the UTF-8 byte length of a string.
 */ const $60bae7485a5474c6$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
/**
 * Calculate the UTF-8 byte length of a value's JSON representation.
 */ const $60bae7485a5474c6$var$jsonBytes = (value)=>{
    return $60bae7485a5474c6$var$utf8Bytes(JSON.stringify(value));
};
/**
 * Truncate a string to fit within maxBytes (inclusive) when encoded as UTF-8.
 * Uses binary search for efficiency with multi-byte characters.
 *
 * @param text - The string to truncate
 * @param maxBytes - Maximum byte length (inclusive, UTF-8 encoded)
 * @returns Truncated string whose UTF-8 byte length is at most maxBytes
 */ function $60bae7485a5474c6$var$truncateTextByBytes(text, maxBytes) {
    if ($60bae7485a5474c6$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = '';
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $60bae7485a5474c6$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
/**
 * Extract text content from a message item.
 * Handles plain strings and objects with a text property.
 *
 * @returns The text content
 */ function $60bae7485a5474c6$var$getItemText(item) {
    if (typeof item === 'string') return item;
    if ('text' in item && typeof item.text === 'string') return item.text;
    return '';
}
/**
 * Create a new item with updated text content while preserving the original structure.
 *
 * @param item - Original item (string or object)
 * @param text - New text content
 * @returns New item with updated text
 */ function $60bae7485a5474c6$var$withItemText(item, text) {
    if (typeof item === 'string') return text;
    return {
        ...item,
        text: text
    };
}
/**
 * Check if a message has the OpenAI/Anthropic content format.
 */ function $60bae7485a5474c6$var$isContentMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && typeof message.content === 'string';
}
/**
 * Check if a message has the OpenAI/Anthropic content array format.
 */ function $60bae7485a5474c6$var$isContentArrayMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && Array.isArray(message.content);
}
/**
 * Check if a message has the Google GenAI parts format.
 */ function $60bae7485a5474c6$var$isPartsMessage(message) {
    return message !== null && typeof message === 'object' && 'parts' in message && Array.isArray(message.parts) && message.parts.length > 0;
}
/**
 * Truncate a message with `content: string` format (OpenAI/Anthropic).
 *
 * @param message - Message with content property
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $60bae7485a5474c6$var$truncateContentMessage(message, maxBytes) {
    // Calculate overhead (message structure without content)
    const emptyMessage = {
        ...message,
        content: ''
    };
    const overhead = $60bae7485a5474c6$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $60bae7485a5474c6$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
/**
 * Extracts the array items and their key from an array-based message.
 * Returns `null` key if neither `parts` nor `content` is a valid array.
 */ function $60bae7485a5474c6$var$getArrayItems(message) {
    if ('parts' in message && Array.isArray(message.parts)) return {
        key: 'parts',
        items: message.parts
    };
    if ('content' in message && Array.isArray(message.content)) return {
        key: 'content',
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
/**
 * Truncate a message with an array-based format.
 * Handles both `parts: [...]` (Google GenAI) and `content: [...]` (OpenAI/Anthropic multimodal).
 * Keeps as many complete items as possible, only truncating the first item if needed.
 *
 * @param message - Message with parts or content array
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $60bae7485a5474c6$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $60bae7485a5474c6$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    // Calculate overhead by creating empty text items
    const emptyItems = items.map((item)=>$60bae7485a5474c6$var$withItemText(item, ''));
    const overhead = $60bae7485a5474c6$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    // Include items until we run out of space
    const includedItems = [];
    for (const item of items){
        const text = $60bae7485a5474c6$var$getItemText(item);
        const textSize = $60bae7485a5474c6$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            // Item fits: include it as-is
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            // First item doesn't fit: truncate it
            const truncated = $60bae7485a5474c6$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($60bae7485a5474c6$var$withItemText(item, truncated));
            break;
        } else break;
    }
    /* c8 ignore start
   * for type safety only, algorithm guarantees SOME text included */ if (includedItems.length <= 0) return [];
    else /* c8 ignore stop */ return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
/**
 * Truncate a single message to fit within maxBytes.
 *
 * Supports three message formats:
 * - OpenAI/Anthropic: `{ ..., content: string }`
 * - Vercel AI/OpenAI multimodal: `{ ..., content: Array<{type, text?, ...}> }`
 * - Google GenAI: `{ ..., parts: Array<string | {text: string} | non-text> }`
 *
 * @param message - The message to truncate
 * @param maxBytes - Maximum byte limit for the message
 * @returns Array containing the truncated message, or empty array if truncation fails
 */ function $60bae7485a5474c6$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    // Handle plain strings (e.g., embeddings input)
    if (typeof message === 'string') {
        const truncated = $60bae7485a5474c6$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== 'object') return [];
    if ($60bae7485a5474c6$var$isContentMessage(message)) return $60bae7485a5474c6$var$truncateContentMessage(message, maxBytes);
    if ($60bae7485a5474c6$var$isContentArrayMessage(message) || $60bae7485a5474c6$var$isPartsMessage(message)) return $60bae7485a5474c6$var$truncateArrayMessage(message, maxBytes);
    // Unknown message format: cannot truncate safely
    return [];
}
/**
 * Strip the inline media from message arrays.
 *
 * This returns a stripped message. We do NOT want to mutate the data in place,
 * because of course we still want the actual API/client to handle the media.
 */ function $60bae7485a5474c6$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = undefined;
        if (!!message && typeof message === 'object') {
            if ($60bae7485a5474c6$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $60bae7485a5474c6$var$stripInlineMediaFromMessages(message.content)
            };
            else if ('content' in message && $dJ26n.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $dJ26n.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($60bae7485a5474c6$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $60bae7485a5474c6$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($dJ26n.isContentMedia(newMessage)) newMessage = $dJ26n.stripInlineMediaFromSingleMessage(newMessage);
            else if ($dJ26n.isContentMedia(message)) newMessage = $dJ26n.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
/**
 * Truncate an array of messages to fit within a byte limit.
 *
 * Strategy:
 * - Always keeps only the last (newest) message
 * - Strips inline media from the message
 * - Truncates the message content if it exceeds the byte limit
 *
 * @param messages - Array of messages to truncate
 * @param maxBytes - Maximum total byte limit for the message
 * @returns Array containing only the last message (possibly truncated)
 *
 * @example
 * ```ts
 * const messages = [msg1, msg2, msg3, msg4]; // newest is msg4
 * const truncated = truncateMessagesByBytes(messages, 10000);
 * // Returns [msg4] (truncated if needed)
 * ```
 */ function $60bae7485a5474c6$var$truncateMessagesByBytes(messages, maxBytes) {
    // Early return for empty or invalid input
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    // The result is always a single-element array that callers wrap with
    // JSON.stringify([message]), so subtract the 2-byte array wrapper ("["  and "]")
    // to ensure the final serialized value stays under the limit.
    const effectiveMaxBytes = maxBytes - 2;
    // Always keep only the last message
    const lastMessage = messages[messages.length - 1];
    // Strip inline media from the single message
    const stripped = $60bae7485a5474c6$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    // Check if it fits
    const messageBytes = $60bae7485a5474c6$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    // Truncate the single message if needed
    return $60bae7485a5474c6$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
/**
 * Truncate GenAI messages using the default byte limit.
 *
 * Convenience wrapper around `truncateMessagesByBytes` with the default limit.
 *
 * @param messages - Array of messages to truncate
 * @returns Truncated array of messages
 */ function $60bae7485a5474c6$var$truncateGenAiMessages(messages) {
    return $60bae7485a5474c6$var$truncateMessagesByBytes(messages, $60bae7485a5474c6$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
/**
 * Truncate GenAI string input using the default byte limit.
 *
 * @param input - The string to truncate
 * @returns Truncated string
 */ function $60bae7485a5474c6$var$truncateGenAiStringInput(input) {
    return $60bae7485a5474c6$var$truncateTextByBytes(input, $60bae7485a5474c6$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $60bae7485a5474c6$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $60bae7485a5474c6$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $60bae7485a5474c6$var$truncateGenAiStringInput;

});
parcelRegister("dJ26n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Inline media content source, with a potentially very large base64
 * blob or data: uri.
 */ /**
 * Check if a content part is an OpenAI/Anthropic media source
 */ function $9fe11bb4ef385805$var$isContentMedia(part) {
    if (!part || typeof part !== 'object') return false;
    return $9fe11bb4ef385805$var$isContentMediaSource(part) || $9fe11bb4ef385805$var$hasInlineData(part) || $9fe11bb4ef385805$var$hasImageUrl(part) || $9fe11bb4ef385805$var$hasInputAudio(part) || $9fe11bb4ef385805$var$hasFileData(part) || $9fe11bb4ef385805$var$hasMediaTypeData(part) || $9fe11bb4ef385805$var$hasVercelFileData(part) || $9fe11bb4ef385805$var$hasVercelImageData(part) || $9fe11bb4ef385805$var$hasBlobOrBase64Type(part) || $9fe11bb4ef385805$var$hasB64Json(part) || $9fe11bb4ef385805$var$hasImageGenerationResult(part) || $9fe11bb4ef385805$var$hasDataUri(part);
}
function $9fe11bb4ef385805$var$hasImageUrl(part) {
    if (!('image_url' in part)) return false;
    if (typeof part.image_url === 'string') return part.image_url.startsWith('data:');
    return $9fe11bb4ef385805$var$hasNestedImageUrl(part);
}
function $9fe11bb4ef385805$var$hasNestedImageUrl(part) {
    return 'image_url' in part && !!part.image_url && typeof part.image_url === 'object' && 'url' in part.image_url && typeof part.image_url.url === 'string' && part.image_url.url.startsWith('data:');
}
function $9fe11bb4ef385805$var$isContentMediaSource(part) {
    return 'type' in part && typeof part.type === 'string' && 'source' in part && $9fe11bb4ef385805$var$isContentMedia(part.source);
}
function $9fe11bb4ef385805$var$hasInlineData(part) {
    return 'inlineData' in part && !!part.inlineData && typeof part.inlineData === 'object' && 'data' in part.inlineData && typeof part.inlineData.data === 'string';
}
function $9fe11bb4ef385805$var$hasInputAudio(part) {
    return 'type' in part && part.type === 'input_audio' && 'input_audio' in part && !!part.input_audio && typeof part.input_audio === 'object' && 'data' in part.input_audio && typeof part.input_audio.data === 'string';
}
function $9fe11bb4ef385805$var$hasFileData(part) {
    return 'type' in part && part.type === 'file' && 'file' in part && !!part.file && typeof part.file === 'object' && 'file_data' in part.file && typeof part.file.file_data === 'string';
}
function $9fe11bb4ef385805$var$hasMediaTypeData(part) {
    return 'media_type' in part && typeof part.media_type === 'string' && 'data' in part;
}
/**
 * Check for Vercel AI SDK file format: { type: "file", mediaType: "...", data: "..." }
 * Only matches base64/binary data, not HTTP/HTTPS URLs (which should be preserved).
 */ function $9fe11bb4ef385805$var$hasVercelFileData(part) {
    return 'type' in part && part.type === 'file' && 'mediaType' in part && typeof part.mediaType === 'string' && 'data' in part && typeof part.data === 'string' && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith('http://') && !part.data.startsWith('https://');
}
/**
 * Check for Vercel AI SDK image format: { type: "image", image: "base64...", mimeType?: "..." }
 * Only matches base64/data URIs, not HTTP/HTTPS URLs (which should be preserved).
 * Note: mimeType is optional in Vercel AI SDK image parts.
 */ function $9fe11bb4ef385805$var$hasVercelImageData(part) {
    return 'type' in part && part.type === 'image' && 'image' in part && typeof part.image === 'string' && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith('http://') && !part.image.startsWith('https://');
}
function $9fe11bb4ef385805$var$hasBlobOrBase64Type(part) {
    return 'type' in part && (part.type === 'blob' || part.type === 'base64');
}
function $9fe11bb4ef385805$var$hasB64Json(part) {
    return 'b64_json' in part;
}
function $9fe11bb4ef385805$var$hasImageGenerationResult(part) {
    return 'type' in part && 'result' in part && part.type === 'image_generation';
}
function $9fe11bb4ef385805$var$hasDataUri(part) {
    return 'uri' in part && typeof part.uri === 'string' && part.uri.startsWith('data:');
}
const $9fe11bb4ef385805$var$REMOVED_STRING = '[Blob substitute]';
const $9fe11bb4ef385805$var$MEDIA_FIELDS = [
    'image_url',
    'data',
    'content',
    'b64_json',
    'result',
    'uri',
    'image'
];
/**
 * Replace inline binary data in a single media content part with a placeholder.
 */ function $9fe11bb4ef385805$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($9fe11bb4ef385805$var$isContentMedia(strip.source)) strip.source = $9fe11bb4ef385805$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($9fe11bb4ef385805$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $9fe11bb4ef385805$var$REMOVED_STRING
    };
    if ($9fe11bb4ef385805$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $9fe11bb4ef385805$var$REMOVED_STRING
    };
    if ($9fe11bb4ef385805$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $9fe11bb4ef385805$var$REMOVED_STRING
    };
    if ($9fe11bb4ef385805$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $9fe11bb4ef385805$var$REMOVED_STRING
    };
    for (const field of $9fe11bb4ef385805$var$MEDIA_FIELDS)if (typeof strip[field] === 'string') strip[field] = $9fe11bb4ef385805$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $9fe11bb4ef385805$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $9fe11bb4ef385805$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("968E2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Global map to track tool call IDs to their corresponding span contexts.
// This allows us to capture tool errors and link them to the correct span
// without keeping full Span objects (and their potentially large attributes) alive.
const $69fb6141c077ed00$var$toolCallSpanContextMap = new Map();
// Used to make tool descriptions available to execute_tool spans in the span streaming path.
// Streamed spans are processed individually, so execute_tool spans cannot look up descriptions
// from their sibling doGenerate span on span end (as we do for transactions).
// Instead we store descriptions at spanStart and apply them in the processSpan hook.
// Stores parent_span_id -> Map<toolName, description>
const $69fb6141c077ed00$var$toolDescriptionMap = new Map();
/** Maps Vercel AI span names to standardized OpenTelemetry operation names. */ const $69fb6141c077ed00$var$SPAN_TO_OPERATION_NAME = new Map([
    [
        'ai.generateText',
        'invoke_agent'
    ],
    [
        'ai.streamText',
        'invoke_agent'
    ],
    [
        'ai.generateObject',
        'invoke_agent'
    ],
    [
        'ai.streamObject',
        'invoke_agent'
    ],
    [
        'ai.generateText.doGenerate',
        'generate_content'
    ],
    [
        'ai.streamText.doStream',
        'generate_content'
    ],
    [
        'ai.generateObject.doGenerate',
        'generate_content'
    ],
    [
        'ai.streamObject.doStream',
        'generate_content'
    ],
    [
        'ai.embed.doEmbed',
        'embeddings'
    ],
    [
        'ai.embedMany.doEmbed',
        'embeddings'
    ],
    [
        'ai.rerank.doRerank',
        'rerank'
    ],
    [
        'ai.toolCall',
        'execute_tool'
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $69fb6141c077ed00$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $69fb6141c077ed00$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $69fb6141c077ed00$var$toolDescriptionMap;

});

parcelRegister("h5a7p", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $968E2 = parcelRequire("968E2");

var $cHJNr = parcelRequire("cHJNr");
/**
 * Accumulates token data from a span to its parent in the token accumulator map.
 * This function extracts token usage from the current span and adds it to the
 * accumulated totals for its parent span.
 */ function $c6fac0a4bff1b4bd$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === 'number' || typeof outputTokens === 'number') {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === 'number') existing.inputTokens += inputTokens;
        if (typeof outputTokens === 'number') existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
/**
 * Applies accumulated token data to the `gen_ai.invoke_agent` span.
 * Only immediate children of the `gen_ai.invoke_agent` span are considered,
 * since aggregation will automatically occur for each parent span.
 */ function $c6fac0a4bff1b4bd$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data['gen_ai.usage.total_tokens'] = accumulated.inputTokens + accumulated.outputTokens;
}
/**
 * Builds a map of tool name -> description from all spans with available_tools.
 * This avoids O(n²) iteration and repeated JSON parsing.
 */ function $c6fac0a4bff1b4bd$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = new Map();
    for (const span of spans){
        const availableTools = span.data[$k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== 'string') continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {
        // ignore parse errors
        }
    }
    return toolDescriptions;
}
/**
 * Applies tool descriptions and accumulated tokens to spans in a single pass.
 *
 * - For `gen_ai.execute_tool` spans: looks up tool description from
 *   `gen_ai.request.available_tools` on sibling spans
 * - For `gen_ai.invoke_agent` spans: applies accumulated token data from children
 */ function $c6fac0a4bff1b4bd$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    // Build lookup map once to avoid O(n²) iteration and repeated JSON parsing
    const toolDescriptions = $c6fac0a4bff1b4bd$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === 'gen_ai.execute_tool') {
            const toolName = span.data[$k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === 'string') {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$k9TjS.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === 'gen_ai.invoke_agent') $c6fac0a4bff1b4bd$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
/**
 * Get the span context associated with a tool call ID.
 */ function $c6fac0a4bff1b4bd$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $968E2.toolCallSpanContextMap.get(toolCallId);
}
/**
 * Clean up the span mapping for a tool call ID
 */ function $c6fac0a4bff1b4bd$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $968E2.toolCallSpanContextMap.delete(toolCallId);
}
/**
 * Convert an array of tool strings to a JSON string
 */ function $c6fac0a4bff1b4bd$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === 'string') try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
/**
 * Filter out invalid entries in messages array
 * @param input - The input array to filter
 * @returns The filtered array
 */ function $c6fac0a4bff1b4bd$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === 'object' && 'role' in m && 'content' in m);
}
/**
 * Normalize the user input (stringified object with prompt, system, messages) to messages array
 */ function $c6fac0a4bff1b4bd$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === 'object') {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            // prepend top-level system instruction if present
            if (typeof system === 'string') result.push({
                role: 'system',
                content: system
            });
            // stringified messages array
            if (typeof messages === 'string') try {
                messages = JSON.parse(messages);
            } catch  {
            // ignore parse errors
            }
            // messages array format: { messages: [...] }
            if (Array.isArray(messages)) {
                result.push(...$c6fac0a4bff1b4bd$var$filterMessagesArray(messages));
                return result;
            }
            // prompt array format: { prompt: [...] }
            if (Array.isArray(prompt)) {
                result.push(...$c6fac0a4bff1b4bd$var$filterMessagesArray(prompt));
                return result;
            }
            // prompt string format: { prompt: "..." }
            if (typeof prompt === 'string') result.push({
                role: 'user',
                content: prompt
            });
            if (result.length > 0) return result;
        }
    // eslint-disable-next-line no-empty
    } catch  {}
    return [];
}
/**
 * Generate a request.messages JSON array from the prompt field in the
 * invoke_agent op
 */ function $c6fac0a4bff1b4bd$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$cHJNr.AI_PROMPT_ATTRIBUTE] === 'string' && !attributes[$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$cHJNr.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        // No messages array is present, so we need to convert the prompt to the proper messages format
        // This is the case for ai.generateText spans
        // The ai.prompt attribute is a stringified object with prompt, system, messages attributes
        // The format of these is described in the vercel docs, for instance: https://ai-sdk.dev/docs/reference/ai-sdk-core/stream-object#parameters
        const userInput = attributes[$cHJNr.AI_PROMPT_ATTRIBUTE];
        const messages = $c6fac0a4bff1b4bd$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages);
            span.setAttributes({
                [$cHJNr.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$cHJNr.AI_PROMPT_MESSAGES_ATTRIBUTE] === 'string') // In this case we already get a properly formatted messages array, this is the preferred way to get the messages
    // This is the case for ai.generateText.doGenerate spans
    try {
        const messages = JSON.parse(attributes[$cHJNr.AI_PROMPT_MESSAGES_ATTRIBUTE]);
        if (Array.isArray(messages)) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages);
            span.setAttributes({
                [$cHJNr.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    // eslint-disable-next-line no-empty
    } catch  {}
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $c6fac0a4bff1b4bd$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $c6fac0a4bff1b4bd$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $c6fac0a4bff1b4bd$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $c6fac0a4bff1b4bd$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $c6fac0a4bff1b4bd$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $c6fac0a4bff1b4bd$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $c6fac0a4bff1b4bd$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $c6fac0a4bff1b4bd$var$requestMessagesFromPrompt;

});
parcelRegister("cHJNr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * AI SDK Telemetry Attributes
 * Based on https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ // =============================================================================
// COMMON ATTRIBUTES
// =============================================================================
/**
 * Common attribute for operation name across all functions and spans
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ const $93fd066ba988d5d5$var$OPERATION_NAME_ATTRIBUTE = 'operation.name';
/**
 * Common attribute for AI operation ID across all functions and spans
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ const $93fd066ba988d5d5$var$AI_OPERATION_ID_ATTRIBUTE = 'ai.operationId';
// =============================================================================
// SHARED ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 * `streamText` function - `ai.streamText` span
 *
 * The prompt that was used when calling the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamtext-function
 */ const $93fd066ba988d5d5$var$AI_PROMPT_ATTRIBUTE = 'ai.prompt';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The JSON schema version of the schema that was passed into the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ const $93fd066ba988d5d5$var$AI_SCHEMA_ATTRIBUTE = 'ai.schema';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The object that was generated (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ const $93fd066ba988d5d5$var$AI_RESPONSE_OBJECT_ATTRIBUTE = 'ai.response.object';
/**
 * `embed` function - `ai.embed.doEmbed` span
 * `embedMany` function - `ai.embedMany` span
 *
 * The values that were passed into the function (array)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#embed-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#embedmany-function
 */ const $93fd066ba988d5d5$var$AI_VALUES_ATTRIBUTE = 'ai.values';
// =============================================================================
// GENERATETEXT FUNCTION - UNIQUE ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 *
 * The text that was generated
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $93fd066ba988d5d5$var$AI_RESPONSE_TEXT_ATTRIBUTE = 'ai.response.text';
/**
 * `generateText` function - `ai.generateText` span
 *
 * The tool calls that were made as part of the generation (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $93fd066ba988d5d5$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'ai.response.toolCalls';
/**
 * `generateText` function - `ai.generateText` span
 *
 * The reason why the generation finished
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $93fd066ba988d5d5$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = 'ai.response.finishReason';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * The messages that were passed into the provider
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $93fd066ba988d5d5$var$AI_PROMPT_MESSAGES_ATTRIBUTE = 'ai.prompt.messages';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * Array of stringified tool definitions
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $93fd066ba988d5d5$var$AI_PROMPT_TOOLS_ATTRIBUTE = 'ai.prompt.tools';
// =============================================================================
// BASIC LLM SPAN INFORMATION
// =============================================================================
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The id of the model
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_MODEL_ID_ATTRIBUTE = 'ai.model.id';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * Provider specific metadata returned with the generation response
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = 'ai.response.providerMetadata';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of cached input tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = 'ai.usage.cachedInputTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The functionId that was set through `telemetry.functionId`
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = 'ai.telemetry.functionId';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of completion tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = 'ai.usage.completionTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of prompt tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $93fd066ba988d5d5$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = 'ai.usage.promptTokens';
// =============================================================================
// BASIC EMBEDDING SPAN INFORMATION
// =============================================================================
/**
 * Basic embedding span information
 * Embedding spans
 *
 * The number of tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-embedding-span-information
 */ const $93fd066ba988d5d5$var$AI_USAGE_TOKENS_ATTRIBUTE = 'ai.usage.tokens';
// =============================================================================
// TOOL CALL SPANS
// =============================================================================
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The name of the tool
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $93fd066ba988d5d5$var$AI_TOOL_CALL_NAME_ATTRIBUTE = 'ai.toolCall.name';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The id of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $93fd066ba988d5d5$var$AI_TOOL_CALL_ID_ATTRIBUTE = 'ai.toolCall.id';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The parameters of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $93fd066ba988d5d5$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = 'ai.toolCall.args';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The result of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $93fd066ba988d5d5$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = 'ai.toolCall.result';
// =============================================================================
// PROVIDER METADATA
// =============================================================================
/**
 * OpenAI Provider Metadata
 * @see https://ai-sdk.dev/providers/ai-sdk-providers/openai
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/openai-chat-language-model.ts#L397-L416
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/responses/openai-responses-language-model.ts#L377C7-L384
 */ module.exports.AI_MODEL_ID_ATTRIBUTE = $93fd066ba988d5d5$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $93fd066ba988d5d5$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $93fd066ba988d5d5$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $93fd066ba988d5d5$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $93fd066ba988d5d5$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $93fd066ba988d5d5$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $93fd066ba988d5d5$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $93fd066ba988d5d5$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $93fd066ba988d5d5$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $93fd066ba988d5d5$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $93fd066ba988d5d5$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $93fd066ba988d5d5$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $93fd066ba988d5d5$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $93fd066ba988d5d5$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $93fd066ba988d5d5$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $93fd066ba988d5d5$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("4JtJf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $3iQ48 = parcelRequire("3iQ48");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $eQHTM = parcelRequire("eQHTM");

var $8MXT8 = parcelRequire("8MXT8");

var $1RsVE = parcelRequire("1RsVE");
/**
 * Extract available tools from request parameters
 */ function $37226cf07cc12fc6$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === 'object';
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: 'web_search_options',
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return undefined;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Failed to serialize OpenAI tools:', error);
        return undefined;
    }
}
/**
 * Extract request attributes from method arguments
 */ function $37226cf07cc12fc6$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$k9TjS.GEN_AI_SYSTEM_ATTRIBUTE]: 'openai',
        [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.openai'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        const availableTools = $37226cf07cc12fc6$var$extractAvailableTools(params);
        if (availableTools) attributes[$k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $1RsVE.extractRequestParameters(params));
    } else attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
// Extract and record AI request inputs, if present. This is intentionally separate from response attributes.
function $37226cf07cc12fc6$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    // Store embeddings input on a separate attribute and do not truncate it
    if (operationName === 'embeddings' && 'input' in params) {
        const input = params.input;
        // No input provided
        if (input == null) return;
        // Empty input string
        if (typeof input === 'string' && input.length === 0) return;
        // Empty array input
        if (Array.isArray(input) && input.length === 0) return;
        // Store strings as-is, arrays/objects as JSON
        span.setAttribute($k9TjS.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === 'string' ? input : JSON.stringify(input));
        return;
    }
    const src = 'input' in params ? params.input : 'messages' in params ? params.messages : undefined;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $37226cf07cc12fc6$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || 'unknown';
        const requestAttributes = $37226cf07cc12fc6$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || 'unknown';
        const params = args[0];
        const isStreamRequested = params && typeof params === 'object' && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult;
            const instrumentedPromise = $92XmH.startSpanManual(spanConfig, (span)=>{
                originalResult = originalMethod.apply(context, args);
                if (options.recordInputs && params) $37226cf07cc12fc6$var$addRequestAttributes(span, params, operationName, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
                // Return async processing
                return (async ()=>{
                    try {
                        const result = await originalResult;
                        return $8MXT8.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $9BaVX.SPAN_STATUS_ERROR,
                            message: 'internal_error'
                        });
                        $lCPaR.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.ai.openai.stream',
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $2C8Yo.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.openai');
        }
        // Non-streaming
        let originalResult;
        const instrumentedPromise = $92XmH.startSpan(spanConfig, (span)=>{
            // Call synchronously to capture the promise
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $37226cf07cc12fc6$var$addRequestAttributes(span, params, operationName, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $1RsVE.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $lCPaR.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: 'auto.ai.openai',
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $2C8Yo.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.openai');
    };
}
/**
 * Create a deep proxy for OpenAI client instrumentation
 */ function $37226cf07cc12fc6$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $2C8Yo.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $eQHTM.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) return $37226cf07cc12fc6$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            // which is required for accessing private class fields (e.g. #baseURL) in OpenAI SDK v5.
            return value.bind(obj);
            if (value && typeof value === 'object') return $37226cf07cc12fc6$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an OpenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 */ function $37226cf07cc12fc6$var$instrumentOpenAiClient(client, options) {
    return $37226cf07cc12fc6$var$createDeepProxy(client, '', $2C8Yo.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $37226cf07cc12fc6$var$instrumentOpenAiClient;

});
parcelRegister("eQHTM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $02ca3170fa877e04$var$OPENAI_INTEGRATION_NAME = 'OpenAI';
// https://platform.openai.com/docs/quickstart?api-mode=responses
// https://platform.openai.com/docs/quickstart?api-mode=chat
// https://platform.openai.com/docs/api-reference/conversations
const $02ca3170fa877e04$var$OPENAI_METHOD_REGISTRY = {
    'responses.create': {
        operation: 'chat'
    },
    'chat.completions.create': {
        operation: 'chat'
    },
    'embeddings.create': {
        operation: 'embeddings'
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    'conversations.create': {
        operation: 'chat'
    }
};
const $02ca3170fa877e04$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    'response.output_item.added',
    'response.function_call_arguments.delta',
    'response.function_call_arguments.done',
    'response.output_item.done'
];
const $02ca3170fa877e04$var$RESPONSE_EVENT_TYPES = [
    'response.created',
    'response.in_progress',
    'response.failed',
    'response.completed',
    'response.incomplete',
    'response.queued',
    'response.output_text.delta',
    ...$02ca3170fa877e04$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $02ca3170fa877e04$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $02ca3170fa877e04$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $02ca3170fa877e04$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $02ca3170fa877e04$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("8MXT8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $9BaVX = parcelRequire("9BaVX");

var $2C8Yo = parcelRequire("2C8Yo");

var $eQHTM = parcelRequire("eQHTM");

var $1RsVE = parcelRequire("1RsVE");
/**
 * State object used to accumulate information from a stream of OpenAI events/chunks.
 */ /**
 * Processes tool calls from a chat completion chunk delta.
 * Follows the pattern: accumulate by index, then convert to array at the end.
 *
 * @param toolCalls - Array of tool calls from the delta.
 * @param state - The current streaming state to update.
 *
 *  @see https://platform.openai.com/docs/guides/function-calling#streaming
 */ function $666142ffc6bad5a8$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === undefined || !toolCall.function) continue;
        // Initialize tool call if this is the first chunk for this index
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ''
            }
        };
        else {
            // Accumulate function arguments from subsequent chunks
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
/**
 * Processes a single OpenAI ChatCompletionChunk event, updating the streaming state.
 *
 * @param chunk - The ChatCompletionChunk event to process.
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 */ function $666142ffc6bad5a8$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        // For stream responses, the input tokens remain constant across all events in the stream.
        // Output tokens, however, are only finalized in the last event.
        // Since we can't guarantee that the last event will include usage data or even be a typed event,
        // we update the output token values on every event that includes them.
        // This ensures that output token usage is always set, even if the final event lacks it.
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            // Handle tool calls from delta
            if (choice.delta?.tool_calls) $666142ffc6bad5a8$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
/**
 * Processes a single OpenAI Responses API streaming event, updating the streaming state and span.
 *
 * @param streamEvent - The event to process (may be an error or unknown object).
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 * @param span - The span to update with error status if needed.
 */ function $666142ffc6bad5a8$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === 'object')) {
        state.eventTypes.push('unknown:non-object');
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $9BaVX.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        $lCPaR.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: 'auto.ai.openai.stream-response'
            }
        });
        return;
    }
    if (!('type' in streamEvent)) return;
    const event = streamEvent;
    if (!$eQHTM.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    // Handle output text delta
    if (recordOutputs) {
        // Handle tool call events for Responses API
        if (event.type === 'response.output_item.done' && 'item' in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === 'response.output_text.delta' && 'delta' in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ('response' in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            // For stream responses, the input tokens remain constant across all events in the stream.
            // Output tokens, however, are only finalized in the last event.
            // Since we can't guarantee that the last event will include usage data or even be a typed event,
            // we update the output token values on every event that includes them.
            // This ensures that output token usage is always set, even if the final event lacks it.
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
/**
 * Instruments a stream of OpenAI events, updating the provided span with relevant attributes and
 * optionally recording output text. This function yields each event from the input stream as it is processed.
 *
 * @template T - The type of events in the stream.
 * @param stream - The async iterable stream of events to instrument.
 * @param span - The span to add attributes to and to finish at the end of the stream.
 * @param recordOutputs - Whether to record output text fragments in the span.
 * @returns An async generator yielding each event from the input stream.
 */ async function* $666142ffc6bad5a8$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        totalTokens: undefined,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($1RsVE.isChatCompletionChunk(event)) $666142ffc6bad5a8$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($1RsVE.isResponsesApiStreamEvent(event)) $666142ffc6bad5a8$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $2C8Yo.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $666142ffc6bad5a8$var$instrumentStream;

});
parcelRegister("1RsVE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $k9TjS = parcelRequire("k9TjS");
/**
 * Check if streaming event is from the Responses API
 */ function $15b12e595a5cb24a$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === 'object' && 'type' in event && typeof event.type === 'string' && event.type.startsWith('response.');
}
/**
 * Check if streaming event is a chat completion chunk
 */ function $15b12e595a5cb24a$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === 'object' && 'object' in event && event.object === 'chat.completion.chunk';
}
/**
 * Add response attributes to a span using duck-typing.
 * Works for Chat Completions, Responses API, Embeddings, and Conversations API responses.
 */ function $15b12e595a5cb24a$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== 'object') return;
    const response = result;
    const attrs = {};
    // Response ID
    if (typeof response.id === 'string') attrs[$k9TjS.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    // Response model
    if (typeof response.model === 'string') attrs[$k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    // Conversation ID (conversation objects use id as conversation link)
    if (response.object === 'conversation' && typeof response.id === 'string') attrs[$k9TjS.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    // Token usage — supports both naming conventions (chat: prompt_tokens/completion_tokens, responses: input_tokens/output_tokens)
    if (response.usage && typeof response.usage === 'object') {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === 'number') attrs[$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === 'number') attrs[$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === 'number') attrs[$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    // Finish reasons from choices (chat completions)
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === 'string');
        if (finishReasons.length > 0) attrs[$k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            // Response text from choices
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || '';
            });
            attrs[$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            // Tool calls from choices
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    // Finish reason from status (responses API)
    if (typeof response.status === 'string') // Only set if not already set from choices
    {
        if (!attrs[$k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        // Response text from output_text (responses API)
        if (typeof response.output_text === 'string' && !attrs[$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        // Tool calls from output array (responses API)
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === 'function_call');
            if (functionCalls.length > 0) attrs[$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
/**
 * Extract conversation ID from request parameters
 * Supports both Conversations API and previous_response_id chaining
 * @see https://platform.openai.com/docs/guides/conversation-state
 */ function $15b12e595a5cb24a$var$extractConversationId(params) {
    // Conversations API: conversation parameter (e.g., "conv_...")
    if ('conversation' in params && typeof params.conversation === 'string') return params.conversation;
    // Responses chaining: previous_response_id links to parent response
    if ('previous_response_id' in params && typeof params.previous_response_id === 'string') return params.previous_response_id;
    return undefined;
}
/**
 * Extract request parameters including model settings and conversation context
 */ function $15b12e595a5cb24a$var$extractRequestParameters(params) {
    const attributes = {
        [$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? 'unknown'
    };
    if ('temperature' in params) attributes[$k9TjS.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ('top_p' in params) attributes[$k9TjS.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ('frequency_penalty' in params) attributes[$k9TjS.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ('presence_penalty' in params) attributes[$k9TjS.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ('stream' in params) attributes[$k9TjS.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ('encoding_format' in params) attributes[$k9TjS.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ('dimensions' in params) attributes[$k9TjS.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    // Capture conversation ID for linking messages across API calls
    const conversationId = $15b12e595a5cb24a$var$extractConversationId(params);
    if (conversationId) attributes[$k9TjS.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $15b12e595a5cb24a$var$addResponseAttributes;
module.exports.extractRequestParameters = $15b12e595a5cb24a$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $15b12e595a5cb24a$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $15b12e595a5cb24a$var$isResponsesApiStreamEvent;

});



parcelRegister("9RLPP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $cnvYh = parcelRequire("cnvYh");

var $32Amn = parcelRequire("32Amn");

var $hVhrH = parcelRequire("hVhrH");
/**
 * Extract request attributes from method arguments
 */ function $72ee2b4d7f037079$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$k9TjS.GEN_AI_SYSTEM_ATTRIBUTE]: 'anthropic',
        [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.anthropic'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? 'unknown';
        if ('temperature' in params) attributes[$k9TjS.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ('top_p' in params) attributes[$k9TjS.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ('stream' in params) attributes[$k9TjS.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ('top_k' in params) attributes[$k9TjS.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ('frequency_penalty' in params) attributes[$k9TjS.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ('max_tokens' in params) attributes[$k9TjS.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === 'models.retrieve' || methodPath === 'models.get') // models.retrieve(model-id) and models.get(model-id)
    attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 */ function $72ee2b4d7f037079$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $hVhrH.messagesFromParams(params);
    $hVhrH.setMessagesAttribute(span, messages, enableTruncation);
    if ('prompt' in params) span.setAttributes({
        [$k9TjS.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
/**
 * Add content attributes when recordOutputs is enabled
 */ function $72ee2b4d7f037079$var$addContentAttributes(span, response) {
    // Messages.create
    if ('content' in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join('')
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === 'tool_use' || item.type === 'server_tool_use') toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    // Completions.create
    if ('completion' in response) span.setAttributes({
        [$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    // Models.countTokens
    if ('input_tokens' in response) span.setAttributes({
        [$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
/**
 * Add basic metadata attributes from the response
 */ function $72ee2b4d7f037079$var$addMetadataAttributes(span, response) {
    if ('id' in response && 'model' in response) {
        span.setAttributes({
            [$k9TjS.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ('usage' in response && response.usage) $2C8Yo.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
/**
 * Add response attributes to spans
 */ function $72ee2b4d7f037079$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    // capture error, do not add attributes if error (they shouldn't exist)
    if ('type' in response && response.type === 'error') {
        $hVhrH.handleResponseError(span, response);
        return;
    }
    // Private response attributes that are only recorded if recordOutputs is true.
    if (recordOutputs) $72ee2b4d7f037079$var$addContentAttributes(span, response);
    // Add basic metadata attributes
    $72ee2b4d7f037079$var$addMetadataAttributes(span, response);
}
/**
 * Handle common error catching and reporting for streaming requests
 */ function $72ee2b4d7f037079$var$handleStreamingError(error, span, methodPath) {
    $lCPaR.captureException(error, {
        mechanism: {
            handled: false,
            type: 'auto.ai.anthropic',
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $9BaVX.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        span.end();
    }
    throw error;
}
/**
 * Handle streaming cases with common logic
 */ function $72ee2b4d7f037079$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    // messages.stream() always returns a sync MessageStream, even with stream: true param
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $92XmH.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $72ee2b4d7f037079$var$addPrivateRequestAttributes(span, params, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $32Amn.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $72ee2b4d7f037079$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $2C8Yo.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.anthropic');
    } else return $92XmH.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $72ee2b4d7f037079$var$addPrivateRequestAttributes(span, params, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $32Amn.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $72ee2b4d7f037079$var$handleStreamingError(error, span, methodPath);
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $72ee2b4d7f037079$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || 'unknown';
            const requestAttributes = $72ee2b4d7f037079$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
            const params = typeof args[0] === 'object' ? args[0] : undefined;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $72ee2b4d7f037079$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $92XmH.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $72ee2b4d7f037079$var$addPrivateRequestAttributes(span, params, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $72ee2b4d7f037079$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.anthropic',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $2C8Yo.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.anthropic');
        }
    });
}
/**
 * Create a deep proxy for Anthropic AI client instrumentation
 */ function $72ee2b4d7f037079$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $2C8Yo.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $cnvYh.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) return $72ee2b4d7f037079$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            return value.bind(obj);
            if (value && typeof value === 'object') return $72ee2b4d7f037079$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an Anthropic AI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends object
 * @param client - The Anthropic AI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 */ function $72ee2b4d7f037079$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $72ee2b4d7f037079$var$createDeepProxy(anthropicAiClient, '', $2C8Yo.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $72ee2b4d7f037079$var$instrumentAnthropicAiClient;

});
parcelRegister("cnvYh", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $90306ed94a47aa30$var$ANTHROPIC_AI_INTEGRATION_NAME = 'Anthropic_AI';
// https://docs.anthropic.com/en/api/messages
// https://docs.anthropic.com/en/api/models-list
const $90306ed94a47aa30$var$ANTHROPIC_METHOD_REGISTRY = {
    'messages.create': {
        operation: 'chat'
    },
    'messages.stream': {
        operation: 'chat',
        streaming: true
    },
    'messages.countTokens': {
        operation: 'chat'
    },
    'models.get': {
        operation: 'models'
    },
    'completions.create': {
        operation: 'chat'
    },
    'models.retrieve': {
        operation: 'models'
    },
    'beta.messages.create': {
        operation: 'chat'
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $90306ed94a47aa30$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $90306ed94a47aa30$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("32Amn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $9BaVX = parcelRequire("9BaVX");

var $2C8Yo = parcelRequire("2C8Yo");

var $hVhrH = parcelRequire("hVhrH");
/**
 * State object used to accumulate information from a stream of Anthropic AI events.
 */ /**
 * Checks if an event is an error event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 * @returns Whether an error occurred
 */ function $236dc35259e85f3a$var$isErrorEvent(event, span) {
    if ('type' in event && typeof event.type === 'string') // If the event is an error, set the span status and capture the error
    // These error events are not rejected by the API by default, but are sent as metadata of the response
    {
        if (event.type === 'error') {
            span.setStatus({
                code: $9BaVX.SPAN_STATUS_ERROR,
                message: $hVhrH.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $lCPaR.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: 'auto.ai.anthropic.anthropic_error'
                }
            });
            return true;
        }
    }
    return false;
}
/**
 * Processes the message metadata of an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 */ function $236dc35259e85f3a$var$handleMessageMetadata(event, state) {
    // The token counts shown in the usage field of the message_delta event are cumulative.
    // @see https://docs.anthropic.com/en/docs/build-with-claude/streaming#event-types
    if (event.type === 'message_delta' && event.usage) {
        if ('output_tokens' in event.usage && typeof event.usage.output_tokens === 'number') state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === 'number') state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === 'number') state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === 'number') state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
/**
 * Handle start of a content block (e.g., tool_use)
 */ function $236dc35259e85f3a$var$handleContentBlockStart(event, state) {
    if (event.type !== 'content_block_start' || typeof event.index !== 'number' || !event.content_block) return;
    if (event.content_block.type === 'tool_use' || event.content_block.type === 'server_tool_use') state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
/**
 * Handle deltas of a content block, including input_json_delta for tool_use
 */ function $236dc35259e85f3a$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== 'content_block_delta' || !event.delta) return;
    // Accumulate tool_use input JSON deltas only when we have an index and an active tool block
    if (typeof event.index === 'number' && 'partial_json' in event.delta && typeof event.delta.partial_json === 'string') {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    // Accumulate streamed response text regardless of index
    if (recordOutputs && typeof event.delta.text === 'string') state.responseTexts.push(event.delta.text);
}
/**
 * Handle stop of a content block; finalize tool_use entries
 */ function $236dc35259e85f3a$var$handleContentBlockStop(event, state) {
    if (event.type !== 'content_block_stop' || typeof event.index !== 'number') return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join('');
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: 'tool_use',
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.activeToolBlocks[event.index];
}
/**
 * Processes an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $236dc35259e85f3a$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === 'object')) return;
    const isError = $236dc35259e85f3a$var$isErrorEvent(event, span);
    if (isError) return;
    $236dc35259e85f3a$var$handleMessageMetadata(event, state);
    // Tool call events are sent via 3 separate events:
    // - content_block_start (start of the tool call)
    // - content_block_delta (delta aka input of the tool call)
    // - content_block_stop (end of the tool call)
    // We need to handle them all to capture the full tool call.
    $236dc35259e85f3a$var$handleContentBlockStart(event, state);
    $236dc35259e85f3a$var$handleContentBlockDelta(event, state, recordOutputs);
    $236dc35259e85f3a$var$handleContentBlockStop(event, state);
}
/**
 * Instruments an async iterable stream of Anthropic events, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each event from the input stream unchanged.
 */ async function* $236dc35259e85f3a$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $236dc35259e85f3a$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $2C8Yo.endStreamSpan(span, state, recordOutputs);
    }
}
/**
 * Instruments a MessageStream by registering event handlers and preserving the original stream API.
 */ function $236dc35259e85f3a$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on('streamEvent', (event)=>{
        $236dc35259e85f3a$var$processEvent(event, state, recordOutputs, span);
    });
    // The event fired when a message is done being streamed by the API. Corresponds to the message_stop SSE event.
    // @see https://github.com/anthropics/anthropic-sdk-typescript/blob/d3be31f5a4e6ebb4c0a2f65dbb8f381ae73a9166/helpers.md?plain=1#L42-L44
    stream.on('message', ()=>{
        $2C8Yo.endStreamSpan(span, state, recordOutputs);
    });
    stream.on('error', (error)=>{
        $lCPaR.captureException(error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.stream_error'
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $9BaVX.SPAN_STATUS_ERROR,
                message: 'internal_error'
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $236dc35259e85f3a$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $236dc35259e85f3a$var$instrumentMessageStream;

});
parcelRegister("hVhrH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $9BaVX = parcelRequire("9BaVX");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");
/**
 * Set the messages and messages original length attributes.
 * Extracts system instructions before truncation.
 */ function $d0c54ae626528a2e$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages),
        [$k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $d0c54ae626528a2e$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: 'invalid_argument',
    authentication_error: 'unauthenticated',
    permission_error: 'permission_denied',
    not_found_error: 'not_found',
    request_too_large: 'failed_precondition',
    rate_limit_error: 'resource_exhausted',
    api_error: 'internal_error',
    overloaded_error: 'unavailable'
};
/**
 * Map an Anthropic API error type to a SpanStatusType value.
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $d0c54ae626528a2e$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return 'internal_error';
    return $d0c54ae626528a2e$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || 'internal_error';
}
/**
 * Capture error information from the response
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $d0c54ae626528a2e$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $9BaVX.SPAN_STATUS_ERROR,
            message: $d0c54ae626528a2e$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $lCPaR.captureException(response.error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.anthropic_error'
            }
        });
    }
}
/**
 * Include the system prompt in the messages list, if available
 */ function $d0c54ae626528a2e$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === 'string' ? [
        {
            role: 'system',
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : undefined;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $d0c54ae626528a2e$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $d0c54ae626528a2e$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $d0c54ae626528a2e$var$messagesFromParams;
module.exports.setMessagesAttribute = $d0c54ae626528a2e$var$setMessagesAttribute;

});



parcelRegister("j4neB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $hLiMU = parcelRequire("hLiMU");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $9joMN = parcelRequire("9joMN");

var $7mqEc = parcelRequire("7mqEc");

var $9WGpl = parcelRequire("9WGpl");
/* eslint-disable max-lines */ /**
 * Extract model from parameters or chat context object
 * For chat instances, the model is available on the chat object as 'model' (older versions) or 'modelVersion' (newer versions)
 */ function $de2069f2c2184986$var$extractModel(params, context) {
    if ('model' in params && typeof params.model === 'string') return params.model;
    // Try to get model from chat context object (chat instance has model property)
    if (context && typeof context === 'object') {
        const contextObj = context;
        // Check for 'model' property (older versions, and streaming)
        if ('model' in contextObj && typeof contextObj.model === 'string') return contextObj.model;
        // Check for 'modelVersion' property (newer versions)
        if ('modelVersion' in contextObj && typeof contextObj.modelVersion === 'string') return contextObj.modelVersion;
    }
    return 'unknown';
}
/**
 * Extract generation config parameters
 */ function $de2069f2c2184986$var$extractConfigAttributes(config) {
    const attributes = {};
    if ('temperature' in config && typeof config.temperature === 'number') attributes[$k9TjS.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ('topP' in config && typeof config.topP === 'number') attributes[$k9TjS.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ('topK' in config && typeof config.topK === 'number') attributes[$k9TjS.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ('maxOutputTokens' in config && typeof config.maxOutputTokens === 'number') attributes[$k9TjS.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ('frequencyPenalty' in config && typeof config.frequencyPenalty === 'number') attributes[$k9TjS.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ('presencePenalty' in config && typeof config.presencePenalty === 'number') attributes[$k9TjS.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
/**
 * Extract request attributes from method arguments
 * Builds the base attributes for span creation including system info, model, and config
 */ function $de2069f2c2184986$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$k9TjS.GEN_AI_SYSTEM_ATTRIBUTE]: $9joMN.GOOGLE_GENAI_SYSTEM_NAME,
        [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.google_genai'
    };
    if (params) {
        attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $de2069f2c2184986$var$extractModel(params, context);
        // Extract generation config parameters
        if ('config' in params && typeof params.config === 'object' && params.config) {
            const config = params.config;
            Object.assign(attributes, $de2069f2c2184986$var$extractConfigAttributes(config));
            // Extract available tools from config
            if ('tools' in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $de2069f2c2184986$var$extractModel({}, context);
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 * Handles different parameter formats for different Google GenAI methods.
 */ function $de2069f2c2184986$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($k9TjS.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === 'string' ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    // config.systemInstruction: ContentUnion
    if ('config' in params && params.config && typeof params.config === 'object' && 'systemInstruction' in params.config && params.config.systemInstruction) messages.push(...$9WGpl.contentUnionToMessages(params.config.systemInstruction, 'system'));
    // For chats.create: history contains the conversation history
    if ('history' in params) messages.push(...$9WGpl.contentUnionToMessages(params.history, 'user'));
    // For models.generateContent: ContentListUnion
    if ('contents' in params) messages.push(...$9WGpl.contentUnionToMessages(params.contents, 'user'));
    // For chat.sendMessage: message can be PartListUnion
    if ('message' in params) messages.push(...$9WGpl.contentUnionToMessages(params.message, 'user'));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages)
        });
    }
}
/**
 * Add response attributes from the Google GenAI response
 * @see https://github.com/googleapis/js-genai/blob/v1.19.0/src/types.ts#L2313
 */ function $de2069f2c2184986$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    if (response.modelVersion) span.setAttribute($k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    // Add usage metadata if present
    if (response.usageMetadata && typeof response.usageMetadata === 'object') {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === 'number') span.setAttributes({
            [$k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === 'number') span.setAttributes({
            [$k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === 'number') span.setAttributes({
            [$k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    // Add response text if recordOutputs is enabled
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === 'string' ? part.text : '').filter((text)=>text.length > 0).join('');
            return '';
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join('')
        });
    }
    // Add tool calls if recordOutputs is enabled
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
/**
 * Instrument any async or synchronous genai method with Sentry spans
 * Handles operations like models.generateContent and chat.sendMessage and chats.create
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $de2069f2c2184986$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === 'embeddings';
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || 'unknown';
            const params = args[0];
            const requestAttributes = $de2069f2c2184986$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
            // Check if this is a streaming method
            if (instrumentedMethod.streaming) // Use startSpanManual for streaming methods to control span lifecycle
            return $92XmH.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $de2069f2c2184986$var$addPrivateRequestAttributes(span, params, isEmbeddings, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $7mqEc.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $9BaVX.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            // Single span for both sync and async operations
            return $92XmH.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $de2069f2c2184986$var$addPrivateRequestAttributes(span, params, isEmbeddings, $2C8Yo.shouldEnableTruncation(options.enableTruncation));
                return $hLiMU.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    // Only add response attributes for content-producing methods, not for embeddings
                    if (!isEmbeddings) $de2069f2c2184986$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Google GenAI client instrumentation
 * Recursively instruments methods and handles special cases like chats.create
 */ function $de2069f2c2184986$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $2C8Yo.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $9joMN.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) {
                // If an operation is specified, we need to instrument the method itself
                const wrappedMethod = instrumentedMethod.operation ? $de2069f2c2184986$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                // If a proxyResultPath is specified, we need to proxy the result of the method.
                // Note: This currently only properly handles synchronous methods. For async methods,
                // the Promise itself would be proxied instead of the resolved value. Currently we
                // don't have a case where this is needed, so I'll keep it simple for now.
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === 'object') return $de2069f2c2184986$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context
            return value.bind(t);
            if (value && typeof value === 'object') return $de2069f2c2184986$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument a Google GenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends client object
 * @param client - The Google GenAI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 *
 * @example
 * ```typescript
 * import { GoogleGenAI } from '@google/genai';
 * import { instrumentGoogleGenAIClient } from '@sentry/core';
 *
 * const genAI = new GoogleGenAI({ apiKey: process.env.GOOGLE_GENAI_API_KEY });
 * const instrumentedClient = instrumentGoogleGenAIClient(genAI);
 *
 * // Now both chats.create and sendMessage will be instrumented
 * const chat = instrumentedClient.chats.create({ model: 'gemini-1.5-pro' });
 * const response = await chat.sendMessage({ message: 'Hello' });
 * ```
 */ function $de2069f2c2184986$var$instrumentGoogleGenAIClient(client, options) {
    return $de2069f2c2184986$var$createDeepProxy(client, '', $2C8Yo.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $de2069f2c2184986$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $de2069f2c2184986$var$instrumentGoogleGenAIClient;

});
parcelRegister("9joMN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $6c791d639cd82b96$var$GOOGLE_GENAI_INTEGRATION_NAME = 'Google_GenAI';
// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
const $6c791d639cd82b96$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    'models.generateContent': {
        operation: 'generate_content'
    },
    'models.generateContentStream': {
        operation: 'generate_content',
        streaming: true
    },
    'models.embedContent': {
        operation: 'embeddings'
    },
    'chats.create': {
        proxyResultPath: 'chat'
    },
    'chat.sendMessage': {
        operation: 'chat'
    },
    'chat.sendMessageStream': {
        operation: 'chat',
        streaming: true
    }
};
// Constants for internal use
const $6c791d639cd82b96$var$GOOGLE_GENAI_SYSTEM_NAME = 'google_genai';
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $6c791d639cd82b96$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $6c791d639cd82b96$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $6c791d639cd82b96$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("7mqEc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $9BaVX = parcelRequire("9BaVX");

var $2C8Yo = parcelRequire("2C8Yo");
/**
 * State object used to accumulate information from a stream of Google GenAI events.
 */ /**
 * Checks if a response chunk contains an error
 * @param chunk - The response chunk to check
 * @param span - The span to update if error is found
 * @returns Whether an error occurred
 */ function $55bf42175069a6dd$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $9BaVX.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        $lCPaR.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: 'auto.ai.google_genai'
            }
        });
        return true;
    }
    return false;
}
/**
 * Processes response metadata from a chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 */ function $55bf42175069a6dd$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === 'string') state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === 'string') state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === 'number') state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === 'number') state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === 'number') state.totalTokens = usage.totalTokenCount;
    }
}
/**
 * Processes candidate content from a response chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 */ function $55bf42175069a6dd$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: 'function',
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
/**
 * Processes a single chunk from the Google GenAI stream
 * @param chunk - The chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $55bf42175069a6dd$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $55bf42175069a6dd$var$isErrorChunk(chunk, span)) return;
    $55bf42175069a6dd$var$handleResponseMetadata(chunk, state);
    $55bf42175069a6dd$var$handleCandidateContent(chunk, state, recordOutputs);
}
/**
 * Instruments an async iterable stream of Google GenAI response chunks, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each chunk from the input stream unchanged.
 */ async function* $55bf42175069a6dd$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $55bf42175069a6dd$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $2C8Yo.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $55bf42175069a6dd$var$instrumentStream;

});

parcelRegister("9WGpl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Copied from https://googleapis.github.io/js-genai/release_docs/index.html
/**
 *
 */ function $73da6d250e0a503c$var$contentUnionToMessages(content, role = 'user') {
    if (typeof content === 'string') return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content)=>$73da6d250e0a503c$var$contentUnionToMessages(content, role));
    if (typeof content !== 'object' || !content) return [];
    if ('role' in content && typeof content.role === 'string') return [
        content
    ];
    if ('parts' in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $73da6d250e0a503c$var$contentUnionToMessages;

});


parcelRegister("jeBe6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $gWkTG = parcelRequire("gWkTG");

var $d6VVW = parcelRequire("d6VVW");
/* eslint-disable max-lines */ /**
 * Creates a Sentry callback handler for LangChain
 * Returns a plain object that LangChain will call via duck-typing
 *
 * This is a stateful handler that tracks spans across multiple LangChain executions.
 */ function $e00c3383c2b509ba$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $2C8Yo.resolveAIRecordingOptions(options);
    const enableTruncation = $2C8Yo.shouldEnableTruncation(options.enableTruncation);
    // Internal state - single instance tracks all spans
    const spanMap = new Map();
    /**
   * Exit a span and clean up
   */ const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    /**
   * Handler for LLM Start
   * This handler will be called by LangChain's callback handler when an LLM event is detected.
   */ const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_secrets: undefined,
        lc_attributes: undefined,
        lc_aliases: undefined,
        lc_serializable_keys: undefined,
        lc_id: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_kwargs: {},
        name: 'SentryCallbackHandler',
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $d6VVW.getInvocationParams(tags);
            const attributes = $d6VVW.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $92XmH.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...$d6VVW.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $d6VVW.getInvocationParams(tags);
            const attributes = $d6VVW.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $d6VVW.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $92XmH.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...$d6VVW.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $d6VVW.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $lCPaR.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$gWkTG.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            // Skip chain spans when inside an agent context (createReactAgent).
            // The agent already creates an invoke_agent span; internal chain steps
            // (ChannelWrite, Branch, prompt, etc.) are noise.
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || 'unknown_chain';
            const attributes = {
                [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.langchain',
                'langchain.chain.name': chainName
            };
            if (recordInputs) attributes['langchain.chain.inputs'] = JSON.stringify(inputs);
            $92XmH.startSpanManual({
                name: `chain ${chainName}`,
                op: 'gen_ai.invoke_agent',
                attributes: {
                    ...attributes,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.invoke_agent'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                // Add outputs if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    'langchain.chain.outputs': JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $lCPaR.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$gWkTG.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            // Skip tool spans when inside an agent context (createReactAgent).
            // Tool spans are created by wrapToolsWithSpans with richer attributes.
            if (metadata?.__sentry_langgraph__) return;
            // runName is set to tool.name by LangChain's StructuredTool.call()
            const toolName = runName || tool.name || 'unknown_tool';
            const attributes = {
                ...$d6VVW.getAgentNameFromMetadata(metadata),
                [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gWkTG.LANGCHAIN_ORIGIN,
                [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'execute_tool',
                [$k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$k9TjS.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $92XmH.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: 'gen_ai.execute_tool',
                attributes: {
                    ...attributes,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.execute_tool'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    // LangChain tools may return ToolMessage objects — extract the content
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === 'object' && 'content' in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$k9TjS.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === 'string' ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $9BaVX.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $lCPaR.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$gWkTG.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $e00c3383c2b509ba$var$createLangChainCallbackHandler;

});
parcelRegister("gWkTG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $032ebf10040817b2$var$LANGCHAIN_INTEGRATION_NAME = 'LangChain';
const $032ebf10040817b2$var$LANGCHAIN_ORIGIN = 'auto.ai.langchain';
const $032ebf10040817b2$var$ROLE_MAP = {
    human: 'user',
    ai: 'assistant',
    assistant: 'assistant',
    system: 'system',
    function: 'function',
    tool: 'tool'
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $032ebf10040817b2$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $032ebf10040817b2$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $032ebf10040817b2$var$ROLE_MAP;

});

parcelRegister("d6VVW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $6zIGl = parcelRequire("6zIGl");

var $k9TjS = parcelRequire("k9TjS");

var $dJ26n = parcelRequire("dJ26n");

var $2C8Yo = parcelRequire("2C8Yo");

var $gWkTG = parcelRequire("gWkTG");
/**
 * Assigns an attribute only when the value is neither `undefined` nor `null`.
 *
 * We keep this tiny helper because call sites are repetitive and easy to miswrite.
 * It also preserves falsy-but-valid values like `0` and `""`.
 */ const $98b8c64f7db20d93$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
/**
 * Like `setIfDefined`, but converts the value with `Number()` and skips only when the
 * result is `NaN`. This ensures numeric 0 makes it through (unlike truthy checks).
 */ const $98b8c64f7db20d93$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
/**
 * Converts a value to a string. Avoids double-quoted JSON strings where a plain
 * string is desired, but still handles objects/arrays safely.
 */ function $98b8c64f7db20d93$var$asString(v) {
    if (typeof v === 'string') return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
/**
 * Converts message content to a string, stripping inline media (base64 images, audio, etc.)
 * from multimodal content before stringification so downstream media stripping can't miss it.
 *
 * @example
 * // String content passes through unchanged:
 * normalizeContent("Hello") // => "Hello"
 *
 * // Multimodal array content — media is replaced with "[Blob substitute]" before JSON.stringify:
 * normalizeContent([
 *   { type: "text", text: "What color?" },
 *   { type: "image_url", image_url: { url: "data:image/png;base64,iVBOR..." } }
 * ])
 * // => '[{"type":"text","text":"What color?"},{"type":"image_url","image_url":{"url":"[Blob substitute]"}}]'
 *
 * // Without this, asString() would JSON.stringify the raw array and the base64 blob
 * // would end up in span attributes, since downstream stripping only works on objects.
 */ function $98b8c64f7db20d93$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === 'object' && $dJ26n.isContentMedia(part) ? $dJ26n.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $98b8c64f7db20d93$var$asString(v);
}
/**
 * Normalizes a single role token to our canonical set.
 *
 * @param role Incoming role value (free-form, any casing)
 * @returns Canonical role: 'user' | 'assistant' | 'system' | 'function' | 'tool' | <passthrough>
 */ function $98b8c64f7db20d93$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $gWkTG.ROLE_MAP[normalized] ?? normalized;
}
/**
 * Infers a role from a LangChain message constructor name.
 *
 * Checks for substrings like "System", "Human", "AI", etc.
 */ function $98b8c64f7db20d93$var$normalizeRoleNameFromCtor(name) {
    if (name.includes('System')) return 'system';
    if (name.includes('Human')) return 'user';
    if (name.includes('AI') || name.includes('Assistant')) return 'assistant';
    if (name.includes('Function')) return 'function';
    if (name.includes('Tool')) return 'tool';
    return 'user';
}
/**
 * Returns invocation params from a LangChain `tags` object.
 *
 * LangChain often passes runtime parameters (model, temperature, etc.) via the
 * `tags.invocation_params` bag. If `tags` is an array (LangChain sometimes uses
 * string tags), we return `undefined`.
 *
 * @param tags LangChain tags (string[] or record)
 * @returns The `invocation_params` object, if present
 */ function $98b8c64f7db20d93$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return undefined;
    return tags.invocation_params;
}
/**
 * Normalizes a heterogeneous set of LangChain messages to `{ role, content }`.
 *
 * Why so many branches? LangChain messages can arrive in several shapes:
 *  - Message classes with `_getType()` (most reliable)
 *  - Classes with meaningful constructor names (e.g. `SystemMessage`)
 *  - Plain objects with `type`, or `{ role, content }`
 *  - Serialized format with `{ lc: 1, id: [...], kwargs: { content } }`
 * We preserve the prioritization to minimize behavioral drift.
 *
 * @param messages Mixed LangChain messages
 * @returns Array of normalized `{ role, content }`
 */ function $98b8c64f7db20d93$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        // 1) Prefer _getType() when present
        const maybeGetType = message._getType;
        if (typeof maybeGetType === 'function') {
            const messageType = maybeGetType.call(message);
            return {
                role: $98b8c64f7db20d93$var$normalizeMessageRole(messageType),
                content: $98b8c64f7db20d93$var$normalizeContent(message.content)
            };
        }
        // 2) Serialized LangChain format (lc: 1) - check before constructor name
        // This is more reliable than constructor.name which can be lost during serialization
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : '';
            const role = typeof messageType === 'string' ? $98b8c64f7db20d93$var$normalizeRoleNameFromCtor(messageType) : 'user';
            return {
                role: $98b8c64f7db20d93$var$normalizeMessageRole(role),
                content: $98b8c64f7db20d93$var$normalizeContent(message.kwargs?.content)
            };
        }
        // 3) Then objects with `type`
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $98b8c64f7db20d93$var$normalizeMessageRole(role),
                content: $98b8c64f7db20d93$var$normalizeContent(message.content)
            };
        }
        // 4) Then objects with `{ role, content }` - check before constructor name
        // Plain objects have constructor.name="Object" which would incorrectly default to "user"
        if (message.role) return {
            role: $98b8c64f7db20d93$var$normalizeMessageRole(String(message.role)),
            content: $98b8c64f7db20d93$var$normalizeContent(message.content)
        };
        // 5) Then try constructor name (SystemMessage / HumanMessage / ...)
        // Only use this if we haven't matched a more specific case
        const ctor = message.constructor?.name;
        if (ctor && ctor !== 'Object') return {
            role: $98b8c64f7db20d93$var$normalizeMessageRole($98b8c64f7db20d93$var$normalizeRoleNameFromCtor(ctor)),
            content: $98b8c64f7db20d93$var$normalizeContent(message.content)
        };
        // 6) Fallback: treat as user text
        return {
            role: 'user',
            content: $98b8c64f7db20d93$var$normalizeContent(message.content)
        };
    });
}
/**
 * Extracts request attributes common to both LLM and ChatModel invocations.
 *
 * Source precedence:
 * 1) `invocationParams` (highest)
 * 2) `langSmithMetadata`
 *
 * Numeric values are set even when 0 (e.g. `temperature: 0`), but skipped if `NaN`.
 */ function $98b8c64f7db20d93$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    // Get kwargs if available (from constructor type)
    const kwargs = 'kwargs' in serialized ? serialized.kwargs : undefined;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    // LangChain uses `stream`. We only set the attribute if the key actually exists
    // (some callbacks report `false` even on streamed requests, this stems from LangChain's callback handler).
    if (invocationParams && 'stream' in invocationParams) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
/**
 * Small helper to assemble boilerplate attributes shared by both request extractors.
 * Always uses 'chat' as the operation type for all LLM and chat model operations.
 */ function $98b8c64f7db20d93$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$k9TjS.GEN_AI_SYSTEM_ATTRIBUTE]: $98b8c64f7db20d93$var$asString(system ?? 'langchain'),
        [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'chat',
        [$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $98b8c64f7db20d93$var$asString(modelName),
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gWkTG.LANGCHAIN_ORIGIN,
        ...$98b8c64f7db20d93$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
/**
 * Extracts attributes for plain LLM invocations (string prompts).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain LLM operations are treated as chat operations.
 * - When `recordInputs` is true, string prompts are wrapped into `{role:"user"}`
 *   messages to align with the chat schema used elsewhere.
 */ function $98b8c64f7db20d93$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $98b8c64f7db20d93$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: 'user',
                content: p
            }));
        $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $2C8Yo.getTruncatedJsonString(messages) : $2C8Yo.getJsonString(messages));
    }
    return attrs;
}
/**
 * Extracts attributes for ChatModel invocations (array-of-arrays of messages).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain chat model operations are chat operations.
 * - We flatten LangChain's `LangChainMessage[][]` and normalize shapes into a
 *   consistent `{ role, content }` array when `recordInputs` is true.
 * - Provider system value falls back to `serialized.id?.[2]`.
 */ function $98b8c64f7db20d93$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $98b8c64f7db20d93$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $98b8c64f7db20d93$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(normalized);
        if (systemInstructions) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages));
    }
    return attrs;
}
/**
 * Extracts tool calls from generations and records them on the span attributes.
 * Prefers message.tool_calls (LangChain's normalized format). Falls back to
 * scanning message.content for Anthropic-style tool_use items in older versions
 * where tool_calls may not be populated.
 */ function $98b8c64f7db20d93$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            // Fallback for older LangChain versions: scan message.content for Anthropic-style tool_use
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === 'tool_use') toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $98b8c64f7db20d93$var$asString(toolCalls));
}
/**
 * Adds token usage attributes, supporting both OpenAI (`tokenUsage`) and Anthropic (`usage`) formats.
 * - Preserve zero values (0 tokens) by avoiding truthy checks.
 * - Compute a total for Anthropic when not explicitly provided.
 * - Include cache token metrics when present.
 */ function $98b8c64f7db20d93$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        // Compute total when not provided by the provider.
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        // Extra Anthropic cache metrics (present only when caching is enabled)
        if (anthropicUsage.cache_creation_input_tokens !== undefined) $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== undefined) $98b8c64f7db20d93$var$setNumberIfDefined(attrs, $k9TjS.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
/**
 * Extracts response-related attributes based on a `LangChainLLMResult`.
 *
 * - Records finish reasons when present on generations (e.g., OpenAI)
 * - When `recordOutputs` is true, captures textual response content and any
 *   tool calls.
 * - Also propagates model name (`model_name` or `model`), response `id`, and
 *   `stop_reason` (for providers that use it).
 */ function $98b8c64f7db20d93$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            // v1 uses generationInfo.finish_reason
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            // v0.3+ uses generation_info.finish_reason
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === 'string');
        if (finishReasons.length > 0) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $98b8c64f7db20d93$var$asString(finishReasons));
        // Tool calls metadata (names, IDs) are not PII, so capture them regardless of recordOutputs
        $98b8c64f7db20d93$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === 'string');
            if (texts.length > 0) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $98b8c64f7db20d93$var$asString(texts));
        }
    }
    $98b8c64f7db20d93$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    // Extract from v1 generations structure if available
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    // Provider model identifier: `model_name` (OpenAI-style) or `model` (others)
    // v1 stores this in message.response_metadata.model_name
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    // Response ID: v1 stores this in message.id
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    // Stop reason: v1 stores this in message.response_metadata.finish_reason
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $98b8c64f7db20d93$var$setIfDefined(attrs, $k9TjS.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $98b8c64f7db20d93$var$asString(stopReason));
    return attrs;
}
function $98b8c64f7db20d93$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    // lc_agent_name is injected by instrumentCompiledGraphInvoke (langgraph integration)
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === 'string') attrs[$k9TjS.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $98b8c64f7db20d93$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return undefined;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: 'function',
            name: tool.name ?? fn?.name ?? '',
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
module.exports.extractChatModelRequestAttributes = $98b8c64f7db20d93$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $98b8c64f7db20d93$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $98b8c64f7db20d93$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $98b8c64f7db20d93$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $98b8c64f7db20d93$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $98b8c64f7db20d93$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $98b8c64f7db20d93$var$normalizeLangChainMessages;

});


parcelRegister("eAHZf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $jeBe6 = parcelRequire("jeBe6");

var $d6VVW = parcelRequire("d6VVW");

var $bXRjt = parcelRequire("bXRjt");

var $fjnEM = parcelRequire("fjnEM");
let $a9f68c5644795614$var$_insideCreateReactAgent = false;
const $a9f68c5644795614$var$SENTRY_PATCHED = '__sentry_patched__';
/**
 * Instruments StateGraph's compile method to create spans for agent creation and invocation
 *
 * Wraps the compile() method to:
 * - Create a `gen_ai.create_agent` span when compile() is called
 * - Automatically wrap the invoke() method on the returned compiled graph with a `gen_ai.invoke_agent` span
 *
 */ function $a9f68c5644795614$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $a9f68c5644795614$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $jeBe6.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            // Skip when called from within createReactAgent to avoid duplicate instrumentation
            if ($a9f68c5644795614$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $92XmH.startSpan({
                op: 'gen_ai.create_agent',
                name: 'create_agent',
                attributes: {
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $bXRjt.LANGGRAPH_ORIGIN,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.create_agent',
                    [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'create_agent'
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    // Extract graph name
                    if (compileOptions?.name && typeof compileOptions.name === 'string') {
                        span.setAttribute($k9TjS.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    // Instrument agent invoke method on the compiled graph
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === 'function') compiledGraph.invoke = $a9f68c5644795614$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, undefined, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $9BaVX.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $a9f68c5644795614$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Instruments CompiledGraph's invoke method to create spans for agent invocation
 *
 * Creates a `gen_ai.invoke_agent` span when invoke() is called
 */ function $a9f68c5644795614$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $92XmH.startSpan({
                op: 'gen_ai.invoke_agent',
                name: 'invoke_agent',
                attributes: {
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $bXRjt.LANGGRAPH_ORIGIN,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $k9TjS.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'invoke_agent'
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === 'string') {
                        span.setAttribute($k9TjS.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($k9TjS.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    // Extract thread_id from the config (second argument)
                    // LangGraph uses config.configurable.thread_id for conversation/session linking
                    const config = args.length > 1 ? args[1] : undefined;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === 'string') span.setAttribute($k9TjS.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    // Inject callback handler and agent name into invoke config
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === 'string' ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $fjnEM.mergeSentryCallback(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    // Extract available tools from the graph instance
                    const tools = $fjnEM.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($k9TjS.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    // Parse input messages
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $d6VVW.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $2C8Yo.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($k9TjS.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $2C8Yo.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$k9TjS.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $2C8Yo.getTruncatedJsonString(filteredMessages) : $2C8Yo.getJsonString(filteredMessages),
                            [$k9TjS.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    // Call original invoke
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $fjnEM.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $9BaVX.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Instruments createReactAgent to create invoke_agent and execute_tool spans.
 */ function $a9f68c5644795614$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $a9f68c5644795614$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $2C8Yo.resolveAIRecordingOptions(options);
    const sentryHandler = $jeBe6.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $fjnEM.extractLLMFromParams(args);
            const agentName = $fjnEM.extractAgentNameFromParams(args);
            // Wrap tools with execute_tool spans (direct access gives us name, type, description)
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $fjnEM.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? undefined);
            // Suppress StateGraph.compile instrumentation inside createReactAgent
            $a9f68c5644795614$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $a9f68c5644795614$var$_insideCreateReactAgent = false;
            }
            // Wrap invoke() on the returned compiled graph
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === 'function') {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $a9f68c5644795614$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $a9f68c5644795614$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Directly instruments a StateGraph instance to add tracing spans
 *
 * This function can be used to manually instrument LangGraph StateGraph instances
 * in environments where automatic instrumentation is not available or desired.
 *
 * @param stateGraph - The StateGraph instance to instrument
 * @param options - Optional configuration for recording inputs/outputs
 *
 * @example
 * ```typescript
 * import { instrumentLangGraph } from '@sentry/cloudflare';
 * import { StateGraph } from '@langchain/langgraph';
 *
 * const graph = new StateGraph(MessagesAnnotation)
 *   .addNode('agent', mockLlm)
 *   .addEdge(START, 'agent')
 *   .addEdge('agent', END);
 *
 * instrumentLangGraph(graph, { recordInputs: true, recordOutputs: true });
 * const compiled = graph.compile({ name: 'my_agent' });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a9f68c5644795614$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $a9f68c5644795614$var$instrumentStateGraphCompile(stateGraph.compile, $2C8Yo.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $a9f68c5644795614$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $a9f68c5644795614$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $a9f68c5644795614$var$instrumentStateGraphCompile;

});
parcelRegister("bXRjt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8b5e8f4886cff366$var$LANGGRAPH_INTEGRATION_NAME = 'LangGraph';
const $8b5e8f4886cff366$var$LANGGRAPH_ORIGIN = 'auto.ai.langgraph';
module.exports.LANGGRAPH_INTEGRATION_NAME = $8b5e8f4886cff366$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $8b5e8f4886cff366$var$LANGGRAPH_ORIGIN;

});

parcelRegister("fjnEM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $9BaVX = parcelRequire("9BaVX");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $d6VVW = parcelRequire("d6VVW");

var $bXRjt = parcelRequire("bXRjt");
/**
 * Extract LLM model object from createReactAgent params
 */ function $b25afb139ead3681$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== 'object' || !arg || !('llm' in arg) || !arg.llm || typeof arg.llm !== 'object') return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== 'string' && typeof llm.model !== 'string') return null;
    return llm;
}
/**
 * Extract agent name from createReactAgent params
 */ function $b25afb139ead3681$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === 'object' && !!arg && 'name' in arg && typeof arg.name === 'string') return arg.name;
    return null;
}
/**
 * Wraps an array of LangChain tools so each invocation creates a gen_ai.execute_tool span.
 *
 * Wraps each tool's invoke() method in place. A marker prevents double-wrapping.
 */ function $b25afb139ead3681$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = '__sentry_tool_wrapped__';
    for (const tool of tools){
        if (!tool || typeof tool !== 'object') continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== 'function' || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === 'string' ? t.name : 'unknown_tool';
        const toolDescription = typeof t.description === 'string' ? t.description : undefined;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $bXRjt.LANGGRAPH_ORIGIN,
                    [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $k9TjS.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'execute_tool',
                    [$k9TjS.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$k9TjS.GEN_AI_TOOL_TYPE_ATTRIBUTE]: 'function'
                };
                // Read agent name from LangChain's propagated config metadata at call time,
                // so shared tools get the correct agent name for each invocation
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === 'string') spanAttributes[$k9TjS.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$k9TjS.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                // LangGraph ToolNode passes { name, args, id, type: "tool_call" }
                const input = args[0];
                if (typeof input === 'object' && !!input) {
                    if ('id' in input && typeof input.id === 'string') spanAttributes[$k9TjS.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = 'args' in input && typeof input.args === 'object' ? input.args : input;
                        try {
                            spanAttributes[$k9TjS.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {
                        // skip if not serializable
                        }
                    }
                }
                return $92XmH.startSpan({
                    op: $k9TjS.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            // ToolMessage objects wrap the result in .content
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === 'object' && 'content' in resultObj ? resultObj.content : result;
                            span.setAttribute($k9TjS.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === 'string' ? content : JSON.stringify(content));
                        } catch  {
                        // skip if not serializable
                        }
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $9BaVX.SPAN_STATUS_ERROR,
                            message: 'internal_error'
                        });
                        $lCPaR.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.ai.langgraph.error'
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
/**
 * Extract tool calls from messages
 */ function $b25afb139ead3681$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === 'object') {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
/**
 * Extract token usage from a message's usage_metadata or response_metadata
 * Returns token counts without setting span attributes
 */ function $b25afb139ead3681$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    // Extract from usage_metadata (newer format)
    if (msg.usage_metadata && typeof msg.usage_metadata === 'object') {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === 'number') inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === 'number') outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === 'number') totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    // Fallback: Extract from response_metadata.tokenUsage
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === 'object') {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === 'number') inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === 'number') outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === 'number') totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
/**
 * Extract model and finish reason from a message's response_metadata
 */ function $b25afb139ead3681$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === 'string') span.setAttribute($k9TjS.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === 'string') span.setAttribute($k9TjS.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
/**
 * Extract tools from compiled graph structure
 *
 * Tools are stored in: compiledGraph.builder.nodes.tools.runnable.tools
 */ function $b25afb139ead3681$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    // Extract name, description, and schema from each tool's lc_kwargs
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
/**
 * Set response attributes on the span
 */ function $b25afb139ead3681$var$setResponseAttributes(span, inputMessages, result) {
    // Extract messages from result
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    // Get new messages (delta between input and output)
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    // Extract and set tool calls from new messages BEFORE normalization
    // (normalization strips tool_calls, so we need to extract them first)
    const toolCalls = $b25afb139ead3681$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($k9TjS.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    // Normalize the new messages
    const normalizedNewMessages = $d6VVW.normalizeLangChainMessages(newMessages);
    span.setAttribute($k9TjS.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    // Accumulate token usage across all messages
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    // Extract metadata from messages
    for (const message of newMessages){
        // Accumulate token usage
        const tokens = $b25afb139ead3681$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        // Extract model metadata (last message's metadata wins for model/finish_reason)
        $b25afb139ead3681$var$extractModelMetadata(span, message);
    }
    // Set accumulated token usage on span
    if (totalInputTokens > 0) span.setAttribute($k9TjS.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($k9TjS.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($k9TjS.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
/** Merge `sentryHandler` into a langchain `callbacks` value (`BaseCallbackHandler[]` or `BaseCallbackManager`). */ function $b25afb139ead3681$var$mergeSentryCallback(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if (Array.isArray(existing)) {
        if (existing.includes(sentryHandler)) return existing;
        return [
            ...existing,
            sentryHandler
        ];
    }
    const manager = existing;
    if (typeof manager.addHandler === 'function') {
        const alreadyAdded = Array.isArray(manager.handlers) && manager.handlers.includes(sentryHandler);
        if (!alreadyAdded) manager.addHandler(sentryHandler);
    }
    return existing;
}
module.exports.extractAgentNameFromParams = $b25afb139ead3681$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $b25afb139ead3681$var$extractLLMFromParams;
module.exports.extractModelMetadata = $b25afb139ead3681$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $b25afb139ead3681$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $b25afb139ead3681$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $b25afb139ead3681$var$extractToolsFromCompiledGraph;
module.exports.mergeSentryCallback = $b25afb139ead3681$var$mergeSentryCallback;
module.exports.setResponseAttributes = $b25afb139ead3681$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $b25afb139ead3681$var$wrapToolsWithSpans;

});


parcelRegister("fvCsr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $122mK = parcelRequire("122mK");

var $eW0HJ = parcelRequire("eW0HJ");

var $cL0uH = parcelRequire("cL0uH");

var $4CS5n = parcelRequire("4CS5n");
/**
 * We must not send more than 1000 spans in one envelope.
 * Otherwise the envelope is dropped by Relay.
 */ const $b4a7952554c2f622$var$MAX_SPANS_PER_ENVELOPE = 1000;
const $b4a7952554c2f622$var$MAX_TRACE_WEIGHT_IN_BYTES = 5000000;
/**
 * A buffer for serialized streamed span JSON objects that flushes them to Sentry in Span v2 envelopes.
 * Handles per-trace timeout-based flushing, size thresholds, and graceful shutdown.
 * Also handles computation of the Dynamic Sampling Context (DSC) for the trace, if it wasn't yet
 * frozen onto the segment span.
 *
 * For this, we need the reference to the segment span instance, from
 * which we compute the DSC. Doing this in the buffer ensures that we compute the DSC as late as possible,
 * allowing span name and data updates up to this point. Worth noting here that the segment span is likely
 * still active and modifyable when child spans are added to the buffer.
 */ class $b4a7952554c2f622$var$SpanBuffer {
    /* Bucket spans by their trace id, along with accumulated size and a per-trace flush timeout */ constructor(client, options){
        this._traceBuckets = new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $b4a7952554c2f622$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $b4a7952554c2f622$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5000;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $b4a7952554c2f622$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on('flush', ()=>{
            this.drain();
        });
        this._client.on('close', ()=>{
            // No need to drain the buffer here as `Client.close()` internally already calls `Client.flush()`
            // which already invokes the `flush` hook and thus drains the buffer.
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: new Set(),
                size: 0,
                timeout: $122mK.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $4CS5n.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            // we should never get here, given we always add a span when we create a new bucket
            // and delete the bucket once we flush out the trace
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('No segment span reference found on span JSON, cannot compute DSC');
            this._removeTrace(traceId);
            return;
        }
        const dsc = $eW0HJ.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $cL0uH.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $9XOi0.DEBUG_BUILD && $3iQ48.debug.error('Error while sending streamed span envelope:', reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $b4a7952554c2f622$var$SpanBuffer;

});
parcelRegister("cL0uH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $hO292 = parcelRequire("hO292");

var $cp5Oe = parcelRequire("cp5Oe");

var $9z62o = parcelRequire("9z62o");
/**
 * Creates a span v2 span streaming envelope
 */ function $949a41f2106b42d1$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $cp5Oe.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date().toISOString(),
        ...$949a41f2106b42d1$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $hO292.dsnToString(dsn$1)
        }
    };
    const inferSetting = options.sendDefaultPii ? 'auto' : 'never';
    const spanContainer = [
        {
            type: 'span',
            item_count: serializedSpans.length,
            content_type: 'application/vnd.sentry.items.span.v2+json'
        },
        {
            version: 2,
            ...$9z62o.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $cp5Oe.createEnvelope(headers, [
        spanContainer
    ]);
}
function $949a41f2106b42d1$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $949a41f2106b42d1$var$createStreamedSpanEnvelope;

});

parcelRegister("4CS5n", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $bcKiE = parcelRequire("bcKiE");
/**
 * Estimates the serialized byte size of a {@link SerializedStreamedSpan}.
 *
 * Uses 2 bytes per character as a UTF-16 approximation, and 8 bytes per number.
 * The estimate is intentionally conservative and may be slightly lower than the
 * actual byte size on the wire.
 * We compensate for this by setting the span buffers internal limit well below the limit
 * of how large an actual span v2 envelope may be.
 */ function $35e4aa52042e208d$var$estimateSerializedSpanSizeInBytes(span) {
    /*
   * Fixed-size fields are pre-computed as a constant for performance:
   * - two timestamps (8 bytes each = 16)
   * - is_segment boolean (5 bytes, assumed false for most spans)
   * - trace_id  – always 32 hex chars (64 bytes)
   * - span_id   – always 16 hex chars (32 bytes)
   * - parent_span_id – 16 hex chars, assumed present for most spans (32 bytes)
   * - status "ok" – most common value (8 bytes)
   * = 156 bytes total base
   */ let weight = 156;
    weight += span.name.length * 2;
    weight += $bcKiE.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        // Assumption: Links are roughly equal in number of attributes
        // probably not always true but allows us to cut down on runtime
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        // Fixed size 100 due to span_id, trace_id and sampled flag (see above)
        const linkWeight = 100 + (attributes$1 ? $bcKiE.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $35e4aa52042e208d$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("ci6Zc", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $dHcrw = parcelRequire("dHcrw");

var $1zgsW = parcelRequire("1zgsW");

var $hg4dc = parcelRequire("hg4dc");

var $euvlx = parcelRequire("euvlx");

var $fvCsr = parcelRequire("fvCsr");

var $3iQ48 = parcelRequire("3iQ48");

var $inXyb = parcelRequire("inXyb");
const $8f2c95c1583c8163$var$spanStreamingIntegration = $dHcrw.defineIntegration(()=>{
    return {
        name: 'SpanStreaming',
        setup (client) {
            const initialMessage = 'SpanStreaming integration requires';
            const fallbackMsg = 'Falling back to static trace lifecycle.';
            const clientOptions = client.getOptions();
            if (!$euvlx.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = 'static';
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$1zgsW.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = 'static';
                $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $fvCsr.SpanBuffer(client);
            client.on('afterSpanEnd', (span)=>{
                if (!$inXyb.spanIsSampled(span)) return;
                buffer.add($hg4dc.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $8f2c95c1583c8163$var$spanStreamingIntegration;

});

parcelRegister("4h0Wd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $31c97a38e6a3495f$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $31c97a38e6a3495f$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("azG5N", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * An error emitted by Sentry SDKs and related utilities.
 * @deprecated This class is no longer used and will be removed in a future version. Use `Error` instead.
 */ class $7b2dd2fb0241ce62$var$SentryError extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $7b2dd2fb0241ce62$var$SentryError;

});

parcelRegister("1chIH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $d2jrf = parcelRequire("d2jrf");

var $dpKhO = parcelRequire("dpKhO");

var $bKfNN = parcelRequire("bKfNN");

var $f46vO = parcelRequire("f46vO");

var $8OzMM = parcelRequire("8OzMM");

var $5xpfH = parcelRequire("5xpfH");

var $i3Ttl = parcelRequire("i3Ttl");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0df4a8453e2f63cb$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    const removeHandler = $i3Ttl.addHandler(type, handler);
    $i3Ttl.maybeInstrument(type, ()=>$0df4a8453e2f63cb$var$instrumentFetch(undefined, skipNativeFetchCheck));
    return removeHandler;
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 * Returns a function to remove the handler.
 *
 * Only used internally
 * @hidden
 */ function $0df4a8453e2f63cb$var$addFetchEndInstrumentationHandler(handler) {
    const type = 'fetch-body-resolved';
    const removeHandler = $i3Ttl.addHandler(type, handler);
    $i3Ttl.maybeInstrument(type, ()=>$0df4a8453e2f63cb$var$instrumentFetch($0df4a8453e2f63cb$var$streamHandler));
    return removeHandler;
}
function $0df4a8453e2f63cb$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$f46vO.supportsNativeFetch()) return;
    $bKfNN.fill($5xpfH.GLOBAL_OBJ, 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $0df4a8453e2f63cb$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $8OzMM.timestampInSeconds() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $0df4a8453e2f63cb$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) $i3Ttl.triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($5xpfH.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $i3Ttl.triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: $8OzMM.timestampInSeconds() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                $i3Ttl.triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: $8OzMM.timestampInSeconds() * 1000,
                    error: error
                });
                if ($dpKhO.isError(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    $bKfNN.addNonEnumerableProperty(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = $d2jrf.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    $bKfNN.addNonEnumerableProperty(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $0df4a8453e2f63cb$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $0df4a8453e2f63cb$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $0df4a8453e2f63cb$var$resolveResponse(clonedResponseForResolving, ()=>{
        $i3Ttl.triggerHandlers('fetch-body-resolved', {
            endTimestamp: $8OzMM.timestampInSeconds() * 1000,
            response: response
        });
    });
}
function $0df4a8453e2f63cb$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $0df4a8453e2f63cb$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($0df4a8453e2f63cb$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $0df4a8453e2f63cb$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $0df4a8453e2f63cb$var$getUrlFromResource(resource),
            method: $0df4a8453e2f63cb$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : $dpKhO.isRequest(resource) && $0df4a8453e2f63cb$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $0df4a8453e2f63cb$var$getUrlFromResource(arg),
        method: $0df4a8453e2f63cb$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $0df4a8453e2f63cb$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($dpKhO.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}
module.exports.addFetchEndInstrumentationHandler = $0df4a8453e2f63cb$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $0df4a8453e2f63cb$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $0df4a8453e2f63cb$var$parseFetchArgs;

});
parcelRegister("f46vO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9XOi0 = parcelRequire("9XOi0");

var $3iQ48 = parcelRequire("3iQ48");

var $5xpfH = parcelRequire("5xpfH");
const $af7c47eb13a0ae2d$var$WINDOW = $5xpfH.GLOBAL_OBJ;
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $af7c47eb13a0ae2d$var$supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $af7c47eb13a0ae2d$var$supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $af7c47eb13a0ae2d$var$supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $af7c47eb13a0ae2d$var$supportsHistory() {
    return 'history' in $af7c47eb13a0ae2d$var$WINDOW && !!$af7c47eb13a0ae2d$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $af7c47eb13a0ae2d$var$supportsFetch = $af7c47eb13a0ae2d$var$_isFetchSupported;
function $af7c47eb13a0ae2d$var$_isFetchSupported() {
    if (!('fetch' in $af7c47eb13a0ae2d$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $af7c47eb13a0ae2d$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $af7c47eb13a0ae2d$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$af7c47eb13a0ae2d$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($af7c47eb13a0ae2d$var$isNativeFunction($af7c47eb13a0ae2d$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $af7c47eb13a0ae2d$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $af7c47eb13a0ae2d$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $9XOi0.DEBUG_BUILD && $3iQ48.debug.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $af7c47eb13a0ae2d$var$supportsReportingObserver() {
    return 'ReportingObserver' in $af7c47eb13a0ae2d$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $af7c47eb13a0ae2d$var$supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$af7c47eb13a0ae2d$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $af7c47eb13a0ae2d$var$isNativeFunction;
module.exports.supportsDOMError = $af7c47eb13a0ae2d$var$supportsDOMError;
module.exports.supportsDOMException = $af7c47eb13a0ae2d$var$supportsDOMException;
module.exports.supportsErrorEvent = $af7c47eb13a0ae2d$var$supportsErrorEvent;
module.exports.supportsFetch = $af7c47eb13a0ae2d$var$supportsFetch;
module.exports.supportsHistory = $af7c47eb13a0ae2d$var$supportsHistory;
module.exports.supportsNativeFetch = $af7c47eb13a0ae2d$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $af7c47eb13a0ae2d$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $af7c47eb13a0ae2d$var$supportsReportingObserver;

});


parcelRegister("aGtZ5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Replaces constructor functions in module exports, handling read-only properties,
 * and both default and named exports by wrapping them with the constructor.
 *
 * @param exports The module exports object to modify
 * @param exportName The name of the export to replace (e.g., 'GoogleGenAI', 'Anthropic', 'OpenAI')
 * @param wrappedConstructor The wrapped constructor function to replace the original with
 * @returns void
 */ function $7c7515dd383c4935$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== 'function') return;
    // Replace the named export - handle read-only properties
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        // If direct assignment fails, override the property descriptor
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    // Replace the default export if it points to the original constructor
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, 'default', {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $7c7515dd383c4935$var$replaceExports;

});

parcelRegister("4U9Ev", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/** A simple Least Recently Used map */ class $3923e11d11776341$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === undefined) return undefined;
        // Remove and re-insert to update the order
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $3923e11d11776341$var$LRUMap;

});

parcelRegister("ifwPb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 14+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ function $d49316f7b10a229e$var$escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports.escapeStringForRegex = $d49316f7b10a229e$var$escapeStringForRegex;

});

parcelRegister("aEqP9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $lCPaR = parcelRequire("lCPaR");

var $6zIGl = parcelRequire("6zIGl");

var $92XmH = parcelRequire("92XmH");

var $k9TjS = parcelRequire("k9TjS");

var $2C8Yo = parcelRequire("2C8Yo");

var $gWkTG = parcelRequire("gWkTG");
/**
 * Infers the AI provider system name from the embedding class instance.
 */ function $7c12727ea59cb6de$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? '';
    if (name.includes('OpenAI')) return 'openai';
    if (name.includes('Google')) return 'google_genai';
    if (name.includes('Mistral')) return 'mistralai';
    if (name.includes('Vertex')) return 'google_vertexai';
    if (name.includes('Bedrock')) return 'aws_bedrock';
    if (name.includes('Ollama')) return 'ollama';
    if (name.includes('Cloudflare')) return 'cloudflare';
    if (name.includes('Cohere')) return 'cohere';
    return 'langchain';
}
/**
 * Extracts span attributes from a LangChain embedding class instance.
 */ function $7c12727ea59cb6de$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $gWkTG.LANGCHAIN_ORIGIN,
        [$6zIGl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $k9TjS.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$k9TjS.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'embeddings',
        [$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? 'unknown'
    };
    attributes[$k9TjS.GEN_AI_SYSTEM_ATTRIBUTE] = $7c12727ea59cb6de$var$inferSystemFromInstance(embeddingsInstance);
    if ('dimensions' in embeddingsInstance) attributes[$k9TjS.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ('encodingFormat' in embeddingsInstance) attributes[$k9TjS.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
/**
 * Wraps a LangChain embedding method (embedQuery or embedDocuments) to create Sentry spans.
 *
 * Used internally by the Node.js auto-instrumentation to patch embedding class prototypes.
 */ function $7c12727ea59cb6de$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $2C8Yo.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $7c12727ea59cb6de$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$k9TjS.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || 'unknown';
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$k9TjS.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === 'string' ? input : JSON.stringify(input);
            }
            return $92XmH.startSpan({
                name: `embeddings ${modelName}`,
                op: $k9TjS.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(undefined, (error)=>{
                    $lCPaR.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langchain'
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
/**
 * Wraps a LangChain embeddings instance to create Sentry spans for `embedQuery` and `embedDocuments` calls.
 *
 * Use this in non-Node runtimes (Cloudflare, browser, etc.) where auto-instrumentation is not available.
 *
 * @example
 * ```javascript
 * import * as Sentry from '@sentry/cloudflare';
 * import { OpenAIEmbeddings } from '@langchain/openai';
 *
 * const embeddings = Sentry.instrumentLangChainEmbeddings(
 *   new OpenAIEmbeddings({ model: 'text-embedding-3-small' })
 * );
 *
 * await embeddings.embedQuery('Hello world');
 * await embeddings.embedDocuments(['doc1', 'doc2']);
 * ```
 */ function $7c12727ea59cb6de$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === 'function') embeddingsInstance.embedQuery = $7c12727ea59cb6de$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === 'function') embeddingsInstance.embedDocuments = $7c12727ea59cb6de$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $7c12727ea59cb6de$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $7c12727ea59cb6de$var$instrumentLangChainEmbeddings;

});


parcelRegister("cKjOO", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";
































module.exports = function() {
    var makeSelfResolutionError = function() {
        return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    };
    var reflectHandler = function() {
        return new Promise.PromiseInspection(this._target());
    };
    var apiRejection = function(msg) {
        return Promise.reject(new TypeError(msg));
    };
    function Proxyable() {}
    var UNDEFINED_BINDING = {};
    var util = (parcelRequire("hXEBa"));
    var getDomain;
    if (util.isNode) getDomain = function() {
        var ret = $4TZ3D.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
    else getDomain = function() {
        return null;
    };
    util.notEnumerableProp(Promise, "_getDomain", getDomain);
    var es5 = (parcelRequire("gK3jX"));
    var Async = (parcelRequire("j6mSd"));
    var async = new Async();
    es5.defineProperty(Promise, "_async", {
        value: async
    });
    var errors = (parcelRequire("2cTYx"));
    var TypeError = Promise.TypeError = errors.TypeError;
    Promise.RangeError = errors.RangeError;
    var CancellationError = Promise.CancellationError = errors.CancellationError;
    Promise.TimeoutError = errors.TimeoutError;
    Promise.OperationalError = errors.OperationalError;
    Promise.RejectionError = errors.OperationalError;
    Promise.AggregateError = errors.AggregateError;
    var INTERNAL = function() {};
    var APPLY = {};
    var NEXT_FILTER = {};
    var tryConvertToPromise = (parcelRequire("6EneY"))(Promise, INTERNAL);
    var PromiseArray = (parcelRequire("aQ62d"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
    var Context = (parcelRequire("1hNea"))(Promise);
    /*jshint unused:false*/ var createContext = Context.create;
    var debug = (parcelRequire("b3Gcj"))(Promise, Context);
    var CapturedTrace = debug.CapturedTrace;
    var PassThroughHandlerContext = (parcelRequire("kXSTn"))(Promise, tryConvertToPromise);
    var catchFilter = (parcelRequire("lH3Jl"))(NEXT_FILTER);
    var nodebackForPromise = (parcelRequire("ai1Zk"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    function check(self, executor) {
        if (typeof executor !== "function") throw new TypeError("expecting a function but got " + util.classString(executor));
        if (self.constructor !== Promise) throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    function Promise(executor) {
        this._bitField = 0;
        this._fulfillmentHandler0 = undefined;
        this._rejectionHandler0 = undefined;
        this._promise0 = undefined;
        this._receiver0 = undefined;
        if (executor !== INTERNAL) {
            check(this, executor);
            this._resolveFromExecutor(executor);
        }
        this._promiseCreated();
        this._fireEvent("promiseCreated", this);
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.caught = Promise.prototype["catch"] = function(fn) {
        var len = arguments.length;
        if (len > 1) {
            var catchInstances = new Array(len - 1), j = 0, i;
            for(i = 0; i < len - 1; ++i){
                var item = arguments[i];
                if (util.isObject(item)) catchInstances[j++] = item;
                else return apiRejection("expecting an object but got A catch statement predicate " + util.classString(item));
            }
            catchInstances.length = j;
            fn = arguments[i];
            return this.then(undefined, catchFilter(catchInstances, fn, this));
        }
        return this.then(undefined, fn);
    };
    Promise.prototype.reflect = function() {
        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
    };
    Promise.prototype.then = function(didFulfill, didReject) {
        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
            if (arguments.length > 1) msg += ", " + util.classString(didReject);
            this._warn(msg);
        }
        return this._then(didFulfill, didReject, undefined, undefined, undefined);
    };
    Promise.prototype.done = function(didFulfill, didReject) {
        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
        promise._setIsFinal();
    };
    Promise.prototype.spread = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
    };
    Promise.prototype.toJSON = function() {
        var ret = {
            isFulfilled: false,
            isRejected: false,
            fulfillmentValue: undefined,
            rejectionReason: undefined
        };
        if (this.isFulfilled()) {
            ret.fulfillmentValue = this.value();
            ret.isFulfilled = true;
        } else if (this.isRejected()) {
            ret.rejectionReason = this.reason();
            ret.isRejected = true;
        }
        return ret;
    };
    Promise.prototype.all = function() {
        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
        return new PromiseArray(this).promise();
    };
    Promise.prototype.error = function(fn) {
        return this.caught(util.originatesFromRejection, fn);
    };
    Promise.getNewLibraryCopy = module.exports;
    Promise.is = function(val) {
        return val instanceof Promise;
    };
    Promise.fromNode = Promise.fromCallback = function(fn) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
        if (result === errorObj) ret._rejectCallback(result.e, true);
        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.all = function(promises) {
        return new PromiseArray(promises).promise();
    };
    Promise.cast = function(obj) {
        var ret = tryConvertToPromise(obj);
        if (!(ret instanceof Promise)) {
            ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._setFulfilled();
            ret._rejectionHandler0 = obj;
        }
        return ret;
    };
    Promise.resolve = Promise.fulfilled = Promise.cast;
    Promise.reject = Promise.rejected = function(reason) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._rejectCallback(reason, true);
        return ret;
    };
    Promise.setScheduler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        return async.setScheduler(fn);
    };
    Promise.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
        var haveInternalData = internalData !== undefined;
        var promise = haveInternalData ? internalData : new Promise(INTERNAL);
        var target = this._target();
        var bitField = target._bitField;
        if (!haveInternalData) {
            promise._propagateFrom(this, 3);
            promise._captureStackTrace();
            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                else receiver = target === this ? undefined : this._boundTo;
            }
            this._fireEvent("promiseChained", this, promise);
        }
        var domain = getDomain();
        if (!((bitField & 50397184) === 0)) {
            var handler, value, settler = target._settlePromiseCtx;
            if ((bitField & 33554432) !== 0) {
                value = target._rejectionHandler0;
                handler = didFulfill;
            } else if ((bitField & 16777216) !== 0) {
                value = target._fulfillmentHandler0;
                handler = didReject;
                target._unsetRejectionIsUnhandled();
            } else {
                settler = target._settlePromiseLateCancellationObserver;
                value = new CancellationError("late cancellation observer");
                target._attachExtraTrace(value);
                handler = didReject;
            }
            async.invoke(settler, target, {
                handler: domain === null ? handler : typeof handler === "function" && util.domainBind(domain, handler),
                promise: promise,
                receiver: receiver,
                value: value
            });
        } else target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
        return promise;
    };
    Promise.prototype._length = function() {
        return this._bitField & 65535;
    };
    Promise.prototype._isFateSealed = function() {
        return (this._bitField & 117506048) !== 0;
    };
    Promise.prototype._isFollowing = function() {
        return (this._bitField & 67108864) === 67108864;
    };
    Promise.prototype._setLength = function(len) {
        this._bitField = this._bitField & -65536 | len & 65535;
    };
    Promise.prototype._setFulfilled = function() {
        this._bitField = this._bitField | 33554432;
        this._fireEvent("promiseFulfilled", this);
    };
    Promise.prototype._setRejected = function() {
        this._bitField = this._bitField | 16777216;
        this._fireEvent("promiseRejected", this);
    };
    Promise.prototype._setFollowing = function() {
        this._bitField = this._bitField | 67108864;
        this._fireEvent("promiseResolved", this);
    };
    Promise.prototype._setIsFinal = function() {
        this._bitField = this._bitField | 4194304;
    };
    Promise.prototype._isFinal = function() {
        return (this._bitField & 4194304) > 0;
    };
    Promise.prototype._unsetCancelled = function() {
        this._bitField = this._bitField & -65537;
    };
    Promise.prototype._setCancelled = function() {
        this._bitField = this._bitField | 65536;
        this._fireEvent("promiseCancelled", this);
    };
    Promise.prototype._setWillBeCancelled = function() {
        this._bitField = this._bitField | 8388608;
    };
    Promise.prototype._setAsyncGuaranteed = function() {
        if (async.hasCustomScheduler()) return;
        this._bitField = this._bitField | 134217728;
    };
    Promise.prototype._receiverAt = function(index) {
        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
        if (ret === UNDEFINED_BINDING) return undefined;
        else if (ret === undefined && this._isBound()) return this._boundValue();
        return ret;
    };
    Promise.prototype._promiseAt = function(index) {
        return this[index * 4 - 4 + 2];
    };
    Promise.prototype._fulfillmentHandlerAt = function(index) {
        return this[index * 4 - 4 + 0];
    };
    Promise.prototype._rejectionHandlerAt = function(index) {
        return this[index * 4 - 4 + 1];
    };
    Promise.prototype._boundValue = function() {};
    Promise.prototype._migrateCallback0 = function(follower) {
        var bitField = follower._bitField;
        var fulfill = follower._fulfillmentHandler0;
        var reject = follower._rejectionHandler0;
        var promise = follower._promise0;
        var receiver = follower._receiverAt(0);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._migrateCallbackAt = function(follower, index) {
        var fulfill = follower._fulfillmentHandlerAt(index);
        var reject = follower._rejectionHandlerAt(index);
        var promise = follower._promiseAt(index);
        var receiver = follower._receiverAt(index);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._addCallbacks = function(fulfill, reject, promise, receiver, domain) {
        var index = this._length();
        if (index >= 65531) {
            index = 0;
            this._setLength(0);
        }
        if (index === 0) {
            this._promise0 = promise;
            this._receiver0 = receiver;
            if (typeof fulfill === "function") this._fulfillmentHandler0 = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this._rejectionHandler0 = domain === null ? reject : util.domainBind(domain, reject);
        } else {
            var base = index * 4 - 4;
            this[base + 2] = promise;
            this[base + 3] = receiver;
            if (typeof fulfill === "function") this[base + 0] = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this[base + 1] = domain === null ? reject : util.domainBind(domain, reject);
        }
        this._setLength(index + 1);
        return index;
    };
    Promise.prototype._proxy = function(proxyable, arg) {
        this._addCallbacks(undefined, undefined, arg, proxyable, null);
    };
    Promise.prototype._resolveCallback = function(value, shouldBind) {
        if ((this._bitField & 117506048) !== 0) return;
        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
        var maybePromise = tryConvertToPromise(value, this);
        if (!(maybePromise instanceof Promise)) return this._fulfill(value);
        if (shouldBind) this._propagateFrom(maybePromise, 2);
        var promise = maybePromise._target();
        if (promise === this) {
            this._reject(makeSelfResolutionError());
            return;
        }
        var bitField = promise._bitField;
        if ((bitField & 50397184) === 0) {
            var len = this._length();
            if (len > 0) promise._migrateCallback0(this);
            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
            this._setFollowing();
            this._setLength(0);
            this._setFollowee(promise);
        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
        else {
            var reason = new CancellationError("late cancellation observer");
            promise._attachExtraTrace(reason);
            this._reject(reason);
        }
    };
    Promise.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
        var trace = util.ensureErrorObject(reason);
        var hasStack = trace === reason;
        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
            var message = "a promise was rejected with a non-error: " + util.classString(reason);
            this._warn(message, true);
        }
        this._attachExtraTrace(trace, synchronous ? hasStack : false);
        this._reject(reason);
    };
    Promise.prototype._resolveFromExecutor = function(executor) {
        var promise = this;
        this._captureStackTrace();
        this._pushContext();
        var synchronous = true;
        var r = this._execute(executor, function(value) {
            promise._resolveCallback(value);
        }, function(reason) {
            promise._rejectCallback(reason, synchronous);
        });
        synchronous = false;
        this._popContext();
        if (r !== undefined) promise._rejectCallback(r, true);
    };
    Promise.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
        var bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        promise._pushContext();
        var x;
        if (receiver === APPLY) {
            if (!value || typeof value.length !== "number") {
                x = errorObj;
                x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
            } else x = tryCatch(handler).apply(this._boundValue(), value);
        } else x = tryCatch(handler).call(receiver, value);
        var promiseCreated = promise._popContext();
        bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        if (x === NEXT_FILTER) promise._reject(value);
        else if (x === errorObj) promise._rejectCallback(x.e, false);
        else {
            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
            promise._resolveCallback(x);
        }
    };
    Promise.prototype._target = function() {
        var ret = this;
        while(ret._isFollowing())ret = ret._followee();
        return ret;
    };
    Promise.prototype._followee = function() {
        return this._rejectionHandler0;
    };
    Promise.prototype._setFollowee = function(promise) {
        this._rejectionHandler0 = promise;
    };
    Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
        var isPromise = promise instanceof Promise;
        var bitField = this._bitField;
        var asyncGuaranteed = (bitField & 134217728) !== 0;
        if ((bitField & 65536) !== 0) {
            if (isPromise) promise._invokeInternalOnCancel();
            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                receiver.cancelPromise = promise;
                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
            else receiver.cancel();
        } else if (typeof handler === "function") {
            if (!isPromise) handler.call(receiver, value, promise);
            else {
                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                this._settlePromiseFromHandler(handler, receiver, value, promise);
            }
        } else if (receiver instanceof Proxyable) {
            if (!receiver._isResolved()) {
                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                else receiver._promiseRejected(value, promise);
            }
        } else if (isPromise) {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            if ((bitField & 33554432) !== 0) promise._fulfill(value);
            else promise._reject(value);
        }
    };
    Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
        var handler = ctx.handler;
        var promise = ctx.promise;
        var receiver = ctx.receiver;
        var value = ctx.value;
        if (typeof handler === "function") {
            if (!(promise instanceof Promise)) handler.call(receiver, value, promise);
            else this._settlePromiseFromHandler(handler, receiver, value, promise);
        } else if (promise instanceof Promise) promise._reject(value);
    };
    Promise.prototype._settlePromiseCtx = function(ctx) {
        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
    };
    Promise.prototype._settlePromise0 = function(handler, value, bitField) {
        var promise = this._promise0;
        var receiver = this._receiverAt(0);
        this._promise0 = undefined;
        this._receiver0 = undefined;
        this._settlePromise(promise, handler, receiver, value);
    };
    Promise.prototype._clearCallbackDataAtIndex = function(index) {
        var base = index * 4 - 4;
        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
    };
    Promise.prototype._fulfill = function(value) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        if (value === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._reject(err);
        }
        this._setFulfilled();
        this._rejectionHandler0 = value;
        if ((bitField & 65535) > 0) {
            if ((bitField & 134217728) !== 0) this._settlePromises();
            else async.settlePromises(this);
        }
    };
    Promise.prototype._reject = function(reason) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        this._setRejected();
        this._fulfillmentHandler0 = reason;
        if (this._isFinal()) return async.fatalError(reason, util.isNode);
        if ((bitField & 65535) > 0) async.settlePromises(this);
        else this._ensurePossibleRejectionHandled();
    };
    Promise.prototype._fulfillPromises = function(len, value) {
        for(var i = 1; i < len; i++){
            var handler = this._fulfillmentHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, value);
        }
    };
    Promise.prototype._rejectPromises = function(len, reason) {
        for(var i = 1; i < len; i++){
            var handler = this._rejectionHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, reason);
        }
    };
    Promise.prototype._settlePromises = function() {
        var bitField = this._bitField;
        var len = bitField & 65535;
        if (len > 0) {
            if ((bitField & 16842752) !== 0) {
                var reason = this._fulfillmentHandler0;
                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                this._rejectPromises(len, reason);
            } else {
                var value = this._rejectionHandler0;
                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                this._fulfillPromises(len, value);
            }
            this._setLength(0);
        }
        this._clearCancellationData();
    };
    Promise.prototype._settledValue = function() {
        var bitField = this._bitField;
        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
    };
    function deferResolve(v) {
        this.promise._resolveCallback(v);
    }
    function deferReject(v) {
        this.promise._rejectCallback(v, false);
    }
    Promise.defer = Promise.pending = function() {
        debug.deprecated("Promise.defer", "new Promise");
        var promise = new Promise(INTERNAL);
        return {
            promise: promise,
            resolve: deferResolve,
            reject: deferReject
        };
    };
    util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
    (parcelRequire("9cIlW"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
    (parcelRequire("974rV"))(Promise, INTERNAL, tryConvertToPromise, debug);
    (parcelRequire("9AKvF"))(Promise, PromiseArray, apiRejection, debug);
    (parcelRequire("lMy0l"))(Promise);
    (parcelRequire("fxINL"))(Promise);
    (parcelRequire("6BFxN"))(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
    Promise.Promise = Promise;
    Promise.version = "3.4.7";
    (parcelRequire("37iDz"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("ifPKm"))(Promise);
    (parcelRequire("lUyBJ"))(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
    (parcelRequire("a0oFK"))(Promise, INTERNAL, debug);
    (parcelRequire("ehX3Q"))(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
    (parcelRequire("hLNAV"))(Promise);
    (parcelRequire("lFI4k"))(Promise, INTERNAL);
    (parcelRequire("12mNB"))(Promise, PromiseArray, tryConvertToPromise, apiRejection);
    (parcelRequire("ilsIA"))(Promise, INTERNAL, tryConvertToPromise, apiRejection);
    (parcelRequire("4Qilm"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("lr4sX"))(Promise, PromiseArray, debug);
    (parcelRequire("8zVAW"))(Promise, PromiseArray, apiRejection);
    (parcelRequire("5begG"))(Promise, INTERNAL);
    (parcelRequire("b7rK3"))(Promise, INTERNAL);
    (parcelRequire("fLPkU"))(Promise);
    util.toFastProperties(Promise);
    util.toFastProperties(Promise.prototype);
    function fillTypes(value) {
        var p = new Promise(INTERNAL);
        p._fulfillmentHandler0 = value;
        p._rejectionHandler0 = value;
        p._promise0 = value;
        p._receiver0 = value;
    }
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({
        a: 1
    });
    fillTypes({
        b: 2
    });
    fillTypes({
        c: 3
    });
    fillTypes(1);
    fillTypes(function() {});
    fillTypes(undefined);
    fillTypes(false);
    fillTypes(new Promise(INTERNAL));
    debug.setBounds(Async.firstLineError, util.lastLineError);
    return Promise;
};

});
parcelRegister("4TZ3D", function(module, exports) {
// shim for using process in browser
var $391ba9420d9eb0df$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391ba9420d9eb0df$var$cachedSetTimeout;
var $391ba9420d9eb0df$var$cachedClearTimeout;
function $391ba9420d9eb0df$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391ba9420d9eb0df$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391ba9420d9eb0df$var$cachedSetTimeout = setTimeout;
        else $391ba9420d9eb0df$var$cachedSetTimeout = $391ba9420d9eb0df$var$defaultSetTimout;
    } catch (e) {
        $391ba9420d9eb0df$var$cachedSetTimeout = $391ba9420d9eb0df$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391ba9420d9eb0df$var$cachedClearTimeout = clearTimeout;
        else $391ba9420d9eb0df$var$cachedClearTimeout = $391ba9420d9eb0df$var$defaultClearTimeout;
    } catch (e) {
        $391ba9420d9eb0df$var$cachedClearTimeout = $391ba9420d9eb0df$var$defaultClearTimeout;
    }
})();
function $391ba9420d9eb0df$var$runTimeout(fun) {
    if ($391ba9420d9eb0df$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391ba9420d9eb0df$var$cachedSetTimeout === $391ba9420d9eb0df$var$defaultSetTimout || !$391ba9420d9eb0df$var$cachedSetTimeout) && setTimeout) {
        $391ba9420d9eb0df$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391ba9420d9eb0df$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391ba9420d9eb0df$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391ba9420d9eb0df$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391ba9420d9eb0df$var$runClearTimeout(marker) {
    if ($391ba9420d9eb0df$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391ba9420d9eb0df$var$cachedClearTimeout === $391ba9420d9eb0df$var$defaultClearTimeout || !$391ba9420d9eb0df$var$cachedClearTimeout) && clearTimeout) {
        $391ba9420d9eb0df$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391ba9420d9eb0df$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391ba9420d9eb0df$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391ba9420d9eb0df$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391ba9420d9eb0df$var$queue = [];
var $391ba9420d9eb0df$var$draining = false;
var $391ba9420d9eb0df$var$currentQueue;
var $391ba9420d9eb0df$var$queueIndex = -1;
function $391ba9420d9eb0df$var$cleanUpNextTick() {
    if (!$391ba9420d9eb0df$var$draining || !$391ba9420d9eb0df$var$currentQueue) return;
    $391ba9420d9eb0df$var$draining = false;
    if ($391ba9420d9eb0df$var$currentQueue.length) $391ba9420d9eb0df$var$queue = $391ba9420d9eb0df$var$currentQueue.concat($391ba9420d9eb0df$var$queue);
    else $391ba9420d9eb0df$var$queueIndex = -1;
    if ($391ba9420d9eb0df$var$queue.length) $391ba9420d9eb0df$var$drainQueue();
}
function $391ba9420d9eb0df$var$drainQueue() {
    if ($391ba9420d9eb0df$var$draining) return;
    var timeout = $391ba9420d9eb0df$var$runTimeout($391ba9420d9eb0df$var$cleanUpNextTick);
    $391ba9420d9eb0df$var$draining = true;
    var len = $391ba9420d9eb0df$var$queue.length;
    while(len){
        $391ba9420d9eb0df$var$currentQueue = $391ba9420d9eb0df$var$queue;
        $391ba9420d9eb0df$var$queue = [];
        while(++$391ba9420d9eb0df$var$queueIndex < len)if ($391ba9420d9eb0df$var$currentQueue) $391ba9420d9eb0df$var$currentQueue[$391ba9420d9eb0df$var$queueIndex].run();
        $391ba9420d9eb0df$var$queueIndex = -1;
        len = $391ba9420d9eb0df$var$queue.length;
    }
    $391ba9420d9eb0df$var$currentQueue = null;
    $391ba9420d9eb0df$var$draining = false;
    $391ba9420d9eb0df$var$runClearTimeout(timeout);
}
$391ba9420d9eb0df$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391ba9420d9eb0df$var$queue.push(new $391ba9420d9eb0df$var$Item(fun, args));
    if ($391ba9420d9eb0df$var$queue.length === 1 && !$391ba9420d9eb0df$var$draining) $391ba9420d9eb0df$var$runTimeout($391ba9420d9eb0df$var$drainQueue);
};
// v8 likes predictible objects
function $391ba9420d9eb0df$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391ba9420d9eb0df$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391ba9420d9eb0df$var$process.title = 'browser';
$391ba9420d9eb0df$var$process.browser = true;
$391ba9420d9eb0df$var$process.env = {};
$391ba9420d9eb0df$var$process.argv = [];
$391ba9420d9eb0df$var$process.version = ''; // empty string to avoid regexp issues
$391ba9420d9eb0df$var$process.versions = {};
function $391ba9420d9eb0df$var$noop() {}
$391ba9420d9eb0df$var$process.on = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.addListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.once = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.off = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.removeListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.removeAllListeners = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.emit = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.prependListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.prependOnceListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.listeners = function(name) {
    return [];
};
$391ba9420d9eb0df$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391ba9420d9eb0df$var$process.cwd = function() {
    return '/';
};
$391ba9420d9eb0df$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391ba9420d9eb0df$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hXEBa", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";

var $gK3jX = parcelRequire("gK3jX");
var $d137706287f624bb$var$canEvaluate = typeof navigator == "undefined";
var $d137706287f624bb$var$errorObj = {
    e: {}
};
var $d137706287f624bb$var$tryCatchTarget;
var $d137706287f624bb$var$globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : module.exports !== undefined ? module.exports : null;
function $d137706287f624bb$var$tryCatcher() {
    try {
        var target = $d137706287f624bb$var$tryCatchTarget;
        $d137706287f624bb$var$tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        $d137706287f624bb$var$errorObj.e = e;
        return $d137706287f624bb$var$errorObj;
    }
}
function $d137706287f624bb$var$tryCatch(fn) {
    $d137706287f624bb$var$tryCatchTarget = fn;
    return $d137706287f624bb$var$tryCatcher;
}
var $d137706287f624bb$var$inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;
    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};
function $d137706287f624bb$var$isPrimitive(val) {
    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
}
function $d137706287f624bb$var$isObject(value) {
    return typeof value === "function" || typeof value === "object" && value !== null;
}
function $d137706287f624bb$var$maybeWrapAsError(maybeError) {
    if (!$d137706287f624bb$var$isPrimitive(maybeError)) return maybeError;
    return new Error($d137706287f624bb$var$safeToString(maybeError));
}
function $d137706287f624bb$var$withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for(i = 0; i < len; ++i)ret[i] = target[i];
    ret[i] = appendee;
    return ret;
}
function $d137706287f624bb$var$getDataPropertyOrDefault(obj, key, defaultValue) {
    if ($gK3jX.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
}
function $d137706287f624bb$var$notEnumerableProp(obj, name, value) {
    if ($d137706287f624bb$var$isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    $gK3jX.defineProperty(obj, name, descriptor);
    return obj;
}
function $d137706287f624bb$var$thrower(r) {
    throw r;
}
var $d137706287f624bb$var$inheritedDataKeys = function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];
    var isExcludedProto = function(val) {
        for(var i = 0; i < excludedPrototypes.length; ++i){
            if (excludedPrototypes[i] === val) return true;
        }
        return false;
    };
    if ($gK3jX.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while(obj != null && !isExcludedProto(obj)){
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for(var i = 0; i < keys.length; ++i){
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                }
                obj = $gK3jX.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];
            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
            else {
                for(var i = 0; i < excludedPrototypes.length; ++i){
                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                }
                ret.push(key);
            }
            return ret;
        };
    }
}();
var $d137706287f624bb$var$thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function $d137706287f624bb$var$isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = $gK3jX.names(fn.prototype);
            var hasMethods = $gK3jX.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods = $d137706287f624bb$var$thisAssignmentPattern.test(fn + "") && $gK3jX.names(fn).length > 0;
            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
function $d137706287f624bb$var$toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while(l--)new FakeConstructor();
    return obj;
}
var $d137706287f624bb$var$rident = /^[a-z$_][a-z$_0-9]*$/i;
function $d137706287f624bb$var$isIdentifier(str) {
    return $d137706287f624bb$var$rident.test(str);
}
function $d137706287f624bb$var$filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
    return ret;
}
function $d137706287f624bb$var$safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}
function $d137706287f624bb$var$isError(obj) {
    return obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
}
function $d137706287f624bb$var$markAsOriginatingFromRejection(e) {
    try {
        $d137706287f624bb$var$notEnumerableProp(e, "isOperational", true);
    } catch (ignore) {}
}
function $d137706287f624bb$var$originatesFromRejection(e) {
    if (e == null) return false;
    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
}
function $d137706287f624bb$var$canAttachTrace(obj) {
    return $d137706287f624bb$var$isError(obj) && $gK3jX.propertyIsWritable(obj, "stack");
}
var $d137706287f624bb$var$ensureErrorObject = function() {
    if (!("stack" in new Error())) return function(value) {
        if ($d137706287f624bb$var$canAttachTrace(value)) return value;
        try {
            throw new Error($d137706287f624bb$var$safeToString(value));
        } catch (err) {
            return err;
        }
    };
    else return function(value) {
        if ($d137706287f624bb$var$canAttachTrace(value)) return value;
        return new Error($d137706287f624bb$var$safeToString(value));
    };
}();
function $d137706287f624bb$var$classString(obj) {
    return ({}).toString.call(obj);
}
function $d137706287f624bb$var$copyDescriptors(from, to, filter) {
    var keys = $gK3jX.names(from);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        if (filter(key)) try {
            $gK3jX.defineProperty(to, key, $gK3jX.getDescriptor(from, key));
        } catch (ignore) {}
    }
}
var $d137706287f624bb$var$asArray = function(v) {
    if ($gK3jX.isArray(v)) return v;
    return null;
};
if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var $d137706287f624bb$var$ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while(!(itResult = it.next()).done)ret.push(itResult.value);
        return ret;
    };
    $d137706287f624bb$var$asArray = function(v) {
        if ($gK3jX.isArray(v)) return v;
        else if (v != null && typeof v[Symbol.iterator] === "function") return $d137706287f624bb$var$ArrayFrom(v);
        return null;
    };
}
var $d137706287f624bb$var$isNode = false;
var $d137706287f624bb$var$hasEnvVariables = false;
function $d137706287f624bb$var$env(key) {
    return $d137706287f624bb$var$hasEnvVariables ? $4TZ3D.env[key] : undefined;
}
function $d137706287f624bb$var$getNativePromise() {
    if (typeof Promise === "function") try {
        var promise = new Promise(function() {});
        if (({}).toString.call(promise) === "[object Promise]") return Promise;
    } catch (e) {}
}
function $d137706287f624bb$var$domainBind(self1, cb) {
    return self1.bind(cb);
}
var $d137706287f624bb$var$ret = {
    isClass: $d137706287f624bb$var$isClass,
    isIdentifier: $d137706287f624bb$var$isIdentifier,
    inheritedDataKeys: $d137706287f624bb$var$inheritedDataKeys,
    getDataPropertyOrDefault: $d137706287f624bb$var$getDataPropertyOrDefault,
    thrower: $d137706287f624bb$var$thrower,
    isArray: $gK3jX.isArray,
    asArray: $d137706287f624bb$var$asArray,
    notEnumerableProp: $d137706287f624bb$var$notEnumerableProp,
    isPrimitive: $d137706287f624bb$var$isPrimitive,
    isObject: $d137706287f624bb$var$isObject,
    isError: $d137706287f624bb$var$isError,
    canEvaluate: $d137706287f624bb$var$canEvaluate,
    errorObj: $d137706287f624bb$var$errorObj,
    tryCatch: $d137706287f624bb$var$tryCatch,
    inherits: $d137706287f624bb$var$inherits,
    withAppended: $d137706287f624bb$var$withAppended,
    maybeWrapAsError: $d137706287f624bb$var$maybeWrapAsError,
    toFastProperties: $d137706287f624bb$var$toFastProperties,
    filledRange: $d137706287f624bb$var$filledRange,
    toString: $d137706287f624bb$var$safeToString,
    canAttachTrace: $d137706287f624bb$var$canAttachTrace,
    ensureErrorObject: $d137706287f624bb$var$ensureErrorObject,
    originatesFromRejection: $d137706287f624bb$var$originatesFromRejection,
    markAsOriginatingFromRejection: $d137706287f624bb$var$markAsOriginatingFromRejection,
    classString: $d137706287f624bb$var$classString,
    copyDescriptors: $d137706287f624bb$var$copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
    isNode: $d137706287f624bb$var$isNode,
    hasEnvVariables: $d137706287f624bb$var$hasEnvVariables,
    env: $d137706287f624bb$var$env,
    global: $d137706287f624bb$var$globalObject,
    getNativePromise: $d137706287f624bb$var$getNativePromise,
    domainBind: $d137706287f624bb$var$domainBind
};
$d137706287f624bb$var$ret.isRecentNode = $d137706287f624bb$var$ret.isNode && function() {
    var version = $4TZ3D.versions.node.split(".").map(Number);
    return version[0] === 0 && version[1] > 10 || version[0] > 0;
}();
if ($d137706287f624bb$var$ret.isNode) $d137706287f624bb$var$ret.toFastProperties($4TZ3D);
try {
    throw new Error();
} catch (e) {
    $d137706287f624bb$var$ret.lastLineError = e;
}
module.exports = $d137706287f624bb$var$ret;

});
parcelRegister("gK3jX", function(module, exports) {
var $c30384af80716577$var$isES5 = function() {
    "use strict";
    return this === undefined;
}();
if ($c30384af80716577$var$isES5) module.exports = {
    freeze: Object.freeze,
    defineProperty: Object.defineProperty,
    getDescriptor: Object.getOwnPropertyDescriptor,
    keys: Object.keys,
    names: Object.getOwnPropertyNames,
    getPrototypeOf: Object.getPrototypeOf,
    isArray: Array.isArray,
    isES5: $c30384af80716577$var$isES5,
    propertyIsWritable: function(obj, prop) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!(!descriptor || descriptor.writable || descriptor.set);
    }
};
else {
    var $c30384af80716577$var$has = {}.hasOwnProperty;
    var $c30384af80716577$var$str = {}.toString;
    var $c30384af80716577$var$proto = {}.constructor.prototype;
    var $c30384af80716577$var$ObjectKeys = function(o) {
        var ret = [];
        for(var key in o)if ($c30384af80716577$var$has.call(o, key)) ret.push(key);
        return ret;
    };
    var $c30384af80716577$var$ObjectGetDescriptor = function(o, key) {
        return {
            value: o[key]
        };
    };
    var $c30384af80716577$var$ObjectDefineProperty = function(o, key, desc) {
        o[key] = desc.value;
        return o;
    };
    var $c30384af80716577$var$ObjectFreeze = function(obj) {
        return obj;
    };
    var $c30384af80716577$var$ObjectGetPrototypeOf = function(obj) {
        try {
            return Object(obj).constructor.prototype;
        } catch (e) {
            return $c30384af80716577$var$proto;
        }
    };
    var $c30384af80716577$var$ArrayIsArray = function(obj) {
        try {
            return $c30384af80716577$var$str.call(obj) === "[object Array]";
        } catch (e) {
            return false;
        }
    };
    module.exports = {
        isArray: $c30384af80716577$var$ArrayIsArray,
        keys: $c30384af80716577$var$ObjectKeys,
        names: $c30384af80716577$var$ObjectKeys,
        defineProperty: $c30384af80716577$var$ObjectDefineProperty,
        getDescriptor: $c30384af80716577$var$ObjectGetDescriptor,
        freeze: $c30384af80716577$var$ObjectFreeze,
        getPrototypeOf: $c30384af80716577$var$ObjectGetPrototypeOf,
        isES5: $c30384af80716577$var$isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

});


parcelRegister("j6mSd", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";
var $de80520bc0795bf4$var$firstLineError;
try {
    throw new Error();
} catch (e) {
    $de80520bc0795bf4$var$firstLineError = e;
}

var $78noU = parcelRequire("78noU");

var $7Ugrx = parcelRequire("7Ugrx");

var $hXEBa = parcelRequire("hXEBa");
function $de80520bc0795bf4$var$Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new $7Ugrx(16);
    this._normalQueue = new $7Ugrx(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function() {
        self._drainQueues();
    };
    this._schedule = $78noU;
}
$de80520bc0795bf4$var$Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};
$de80520bc0795bf4$var$Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};
$de80520bc0795bf4$var$Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};
$de80520bc0795bf4$var$Async.prototype.disableTrampolineIfNecessary = function() {
    if ($hXEBa.hasDevTools) this._trampolineEnabled = false;
};
$de80520bc0795bf4$var$Async.prototype.haveItemsQueued = function() {
    return this._isTickUsed || this._haveDrainedQueues;
};
$de80520bc0795bf4$var$Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        $4TZ3D.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
        $4TZ3D.exit(2);
    } else this.throwLater(e);
};
$de80520bc0795bf4$var$Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function() {
            throw arg;
        };
    }
    if (typeof setTimeout !== "undefined") setTimeout(function() {
        fn(arg);
    }, 0);
    else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};
function $de80520bc0795bf4$var$AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $de80520bc0795bf4$var$AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $de80520bc0795bf4$var$AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}
if (!$hXEBa.hasDevTools) {
    $de80520bc0795bf4$var$Async.prototype.invokeLater = $de80520bc0795bf4$var$AsyncInvokeLater;
    $de80520bc0795bf4$var$Async.prototype.invoke = $de80520bc0795bf4$var$AsyncInvoke;
    $de80520bc0795bf4$var$Async.prototype.settlePromises = $de80520bc0795bf4$var$AsyncSettlePromises;
} else {
    $de80520bc0795bf4$var$Async.prototype.invokeLater = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncInvokeLater.call(this, fn, receiver, arg);
        else this._schedule(function() {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 100);
        });
    };
    $de80520bc0795bf4$var$Async.prototype.invoke = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncInvoke.call(this, fn, receiver, arg);
        else this._schedule(function() {
            fn.call(receiver, arg);
        });
    };
    $de80520bc0795bf4$var$Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncSettlePromises.call(this, promise);
        else this._schedule(function() {
            promise._settlePromises();
        });
    };
}
$de80520bc0795bf4$var$Async.prototype._drainQueue = function(queue) {
    while(queue.length() > 0){
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};
$de80520bc0795bf4$var$Async.prototype._drainQueues = function() {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};
$de80520bc0795bf4$var$Async.prototype._queueTick = function() {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};
$de80520bc0795bf4$var$Async.prototype._reset = function() {
    this._isTickUsed = false;
};
module.exports = $de80520bc0795bf4$var$Async;
module.exports.firstLineError = $de80520bc0795bf4$var$firstLineError;

});
parcelRegister("78noU", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";

var $hXEBa = parcelRequire("hXEBa");
var $531b6eab24b5e2a9$var$schedule;
var $531b6eab24b5e2a9$var$noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var $531b6eab24b5e2a9$var$NativePromise = $hXEBa.getNativePromise();
if ($hXEBa.isNode && typeof MutationObserver === "undefined") {
    var $531b6eab24b5e2a9$var$GlobalSetImmediate = $parcel$global.setImmediate;
    var $531b6eab24b5e2a9$var$ProcessNextTick = $4TZ3D.nextTick;
    $531b6eab24b5e2a9$var$schedule = $hXEBa.isRecentNode ? function(fn) {
        $531b6eab24b5e2a9$var$GlobalSetImmediate.call($parcel$global, fn);
    } : function(fn) {
        $531b6eab24b5e2a9$var$ProcessNextTick.call($4TZ3D, fn);
    };
} else if (typeof $531b6eab24b5e2a9$var$NativePromise === "function" && typeof $531b6eab24b5e2a9$var$NativePromise.resolve === "function") {
    var $531b6eab24b5e2a9$var$nativePromise = $531b6eab24b5e2a9$var$NativePromise.resolve();
    $531b6eab24b5e2a9$var$schedule = function(fn) {
        $531b6eab24b5e2a9$var$nativePromise.then(fn);
    };
} else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova))) $531b6eab24b5e2a9$var$schedule = function() {
    var div = document.createElement("div");
    var opts = {
        attributes: true
    };
    var toggleScheduled = false;
    var div2 = document.createElement("div");
    var o2 = new MutationObserver(function() {
        div.classList.toggle("foo");
        toggleScheduled = false;
    });
    o2.observe(div2, opts);
    var scheduleToggle = function() {
        if (toggleScheduled) return;
        toggleScheduled = true;
        div2.classList.toggle("foo");
    };
    return function schedule(fn) {
        var o = new MutationObserver(function() {
            o.disconnect();
            fn();
        });
        o.observe(div, opts);
        scheduleToggle();
    };
}();
else if (typeof setImmediate !== "undefined") $531b6eab24b5e2a9$var$schedule = function(fn) {
    setImmediate(fn);
};
else if (typeof setTimeout !== "undefined") $531b6eab24b5e2a9$var$schedule = function(fn) {
    setTimeout(fn, 0);
};
else $531b6eab24b5e2a9$var$schedule = $531b6eab24b5e2a9$var$noAsyncScheduler;
module.exports = $531b6eab24b5e2a9$var$schedule;

});

parcelRegister("7Ugrx", function(module, exports) {
"use strict";
function $5c1a84a479439c2e$var$arrayMove(src, srcIndex, dst, dstIndex, len) {
    for(var j = 0; j < len; ++j){
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}
function $5c1a84a479439c2e$var$Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}
$5c1a84a479439c2e$var$Queue.prototype._willBeOverCapacity = function(size) {
    return this._capacity < size;
};
$5c1a84a479439c2e$var$Queue.prototype._pushOne = function(arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = this._front + length & this._capacity - 1;
    this[i] = arg;
    this._length = length + 1;
};
$5c1a84a479439c2e$var$Queue.prototype.push = function(fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[j + 0 & wrapMask] = fn;
    this[j + 1 & wrapMask] = receiver;
    this[j + 2 & wrapMask] = arg;
    this._length = length;
};
$5c1a84a479439c2e$var$Queue.prototype.shift = function() {
    var front = this._front, ret = this[front];
    this[front] = undefined;
    this._front = front + 1 & this._capacity - 1;
    this._length--;
    return ret;
};
$5c1a84a479439c2e$var$Queue.prototype.length = function() {
    return this._length;
};
$5c1a84a479439c2e$var$Queue.prototype._checkCapacity = function(size) {
    if (this._capacity < size) this._resizeTo(this._capacity << 1);
};
$5c1a84a479439c2e$var$Queue.prototype._resizeTo = function(capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = front + length & oldCapacity - 1;
    $5c1a84a479439c2e$var$arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};
module.exports = $5c1a84a479439c2e$var$Queue;

});


parcelRegister("2cTYx", function(module, exports) {
"use strict";

var $gK3jX = parcelRequire("gK3jX");
var $19b81f4cf92e709a$var$Objectfreeze = $gK3jX.freeze;

var $hXEBa = parcelRequire("hXEBa");
var $19b81f4cf92e709a$var$inherits = $hXEBa.inherits;
var $19b81f4cf92e709a$var$notEnumerableProp = $hXEBa.notEnumerableProp;
function $19b81f4cf92e709a$var$subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        else Error.call(this);
    }
    $19b81f4cf92e709a$var$inherits(SubError, Error);
    return SubError;
}
var $19b81f4cf92e709a$var$_TypeError, $19b81f4cf92e709a$var$_RangeError;
var $19b81f4cf92e709a$var$Warning = $19b81f4cf92e709a$var$subError("Warning", "warning");
var $19b81f4cf92e709a$var$CancellationError = $19b81f4cf92e709a$var$subError("CancellationError", "cancellation error");
var $19b81f4cf92e709a$var$TimeoutError = $19b81f4cf92e709a$var$subError("TimeoutError", "timeout error");
var $19b81f4cf92e709a$var$AggregateError = $19b81f4cf92e709a$var$subError("AggregateError", "aggregate error");
try {
    $19b81f4cf92e709a$var$_TypeError = TypeError;
    $19b81f4cf92e709a$var$_RangeError = RangeError;
} catch (e) {
    $19b81f4cf92e709a$var$_TypeError = $19b81f4cf92e709a$var$subError("TypeError", "type error");
    $19b81f4cf92e709a$var$_RangeError = $19b81f4cf92e709a$var$subError("RangeError", "range error");
}
var $19b81f4cf92e709a$var$methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
for(var $19b81f4cf92e709a$var$i = 0; $19b81f4cf92e709a$var$i < $19b81f4cf92e709a$var$methods.length; ++$19b81f4cf92e709a$var$i)if (typeof Array.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]] === "function") $19b81f4cf92e709a$var$AggregateError.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]] = Array.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]];
$gK3jX.defineProperty($19b81f4cf92e709a$var$AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
$19b81f4cf92e709a$var$AggregateError.prototype["isOperational"] = true;
var $19b81f4cf92e709a$var$level = 0;
$19b81f4cf92e709a$var$AggregateError.prototype.toString = function() {
    var indent = Array($19b81f4cf92e709a$var$level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    $19b81f4cf92e709a$var$level++;
    indent = Array($19b81f4cf92e709a$var$level * 4 + 1).join(" ");
    for(var i = 0; i < this.length; ++i){
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
        str = lines.join("\n");
        ret += str + "\n";
    }
    $19b81f4cf92e709a$var$level--;
    return ret;
};
function $19b81f4cf92e709a$var$OperationalError(message) {
    if (!(this instanceof $19b81f4cf92e709a$var$OperationalError)) return new $19b81f4cf92e709a$var$OperationalError(message);
    $19b81f4cf92e709a$var$notEnumerableProp(this, "name", "OperationalError");
    $19b81f4cf92e709a$var$notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;
    if (message instanceof Error) {
        $19b81f4cf92e709a$var$notEnumerableProp(this, "message", message.message);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
}
$19b81f4cf92e709a$var$inherits($19b81f4cf92e709a$var$OperationalError, Error);
var $19b81f4cf92e709a$var$errorTypes = Error["__BluebirdErrorTypes__"];
if (!$19b81f4cf92e709a$var$errorTypes) {
    $19b81f4cf92e709a$var$errorTypes = $19b81f4cf92e709a$var$Objectfreeze({
        CancellationError: $19b81f4cf92e709a$var$CancellationError,
        TimeoutError: $19b81f4cf92e709a$var$TimeoutError,
        OperationalError: $19b81f4cf92e709a$var$OperationalError,
        RejectionError: $19b81f4cf92e709a$var$OperationalError,
        AggregateError: $19b81f4cf92e709a$var$AggregateError
    });
    $gK3jX.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: $19b81f4cf92e709a$var$errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}
module.exports = {
    Error: Error,
    TypeError: $19b81f4cf92e709a$var$_TypeError,
    RangeError: $19b81f4cf92e709a$var$_RangeError,
    CancellationError: $19b81f4cf92e709a$var$errorTypes.CancellationError,
    OperationalError: $19b81f4cf92e709a$var$errorTypes.OperationalError,
    TimeoutError: $19b81f4cf92e709a$var$errorTypes.TimeoutError,
    AggregateError: $19b81f4cf92e709a$var$errorTypes.AggregateError,
    Warning: $19b81f4cf92e709a$var$Warning
};

});

parcelRegister("6EneY", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL) {
    var util = (parcelRequire("hXEBa"));
    var errorObj = util.errorObj;
    var isObject = util.isObject;
    function tryConvertToPromise(obj, context) {
        if (isObject(obj)) {
            if (obj instanceof Promise) return obj;
            var then = getThen(obj);
            if (then === errorObj) {
                if (context) context._pushContext();
                var ret = Promise.reject(then.e);
                if (context) context._popContext();
                return ret;
            } else if (typeof then === "function") {
                if (isAnyBluebirdPromise(obj)) {
                    var ret = new Promise(INTERNAL);
                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                    return ret;
                }
                return doThenable(obj, then, context);
            }
        }
        return obj;
    }
    function doGetThen(obj) {
        return obj.then;
    }
    function getThen(obj) {
        try {
            return doGetThen(obj);
        } catch (e) {
            errorObj.e = e;
            return errorObj;
        }
    }
    var hasProp = {}.hasOwnProperty;
    function isAnyBluebirdPromise(obj) {
        try {
            return hasProp.call(obj, "_promise0");
        } catch (e) {
            return false;
        }
    }
    function doThenable(x, then, context) {
        var promise = new Promise(INTERNAL);
        var ret = promise;
        if (context) context._pushContext();
        promise._captureStackTrace();
        if (context) context._popContext();
        var synchronous = true;
        var result = util.tryCatch(then).call(x, resolve, reject);
        synchronous = false;
        if (promise && result === errorObj) {
            promise._rejectCallback(result.e, true, true);
            promise = null;
        }
        function resolve(value) {
            if (!promise) return;
            promise._resolveCallback(value);
            promise = null;
        }
        function reject(reason) {
            if (!promise) return;
            promise._rejectCallback(reason, synchronous, true);
            promise = null;
        }
        return ret;
    }
    return tryConvertToPromise;
};

});

parcelRegister("aQ62d", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
    var util = (parcelRequire("hXEBa"));
    var isArray = util.isArray;
    function toResolutionValue(val) {
        switch(val){
            case -2:
                return [];
            case -3:
                return {};
        }
    }
    function PromiseArray(values) {
        var promise = this._promise = new Promise(INTERNAL);
        if (values instanceof Promise) promise._propagateFrom(values, 3);
        promise._setOnCancel(this);
        this._values = values;
        this._length = 0;
        this._totalResolved = 0;
        this._init(undefined, -2);
    }
    util.inherits(PromiseArray, Proxyable);
    PromiseArray.prototype.length = function() {
        return this._length;
    };
    PromiseArray.prototype.promise = function() {
        return this._promise;
    };
    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
        var values = tryConvertToPromise(this._values, this._promise);
        if (values instanceof Promise) {
            values = values._target();
            var bitField = values._bitField;
            this._values = values;
            if ((bitField & 50397184) === 0) {
                this._promise._setAsyncGuaranteed();
                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
            } else if ((bitField & 33554432) !== 0) values = values._value();
            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
            else return this._cancel();
        }
        values = util.asArray(values);
        if (values === null) {
            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
            this._promise._rejectCallback(err, false);
            return;
        }
        if (values.length === 0) {
            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
            else this._resolve(toResolutionValue(resolveValueIfEmpty));
            return;
        }
        this._iterate(values);
    };
    PromiseArray.prototype._iterate = function(values) {
        var len = this.getActualLength(values.length);
        this._length = len;
        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
        var result = this._promise;
        var isResolved = false;
        var bitField = null;
        for(var i = 0; i < len; ++i){
            var maybePromise = tryConvertToPromise(values[i], result);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                bitField = maybePromise._bitField;
            } else bitField = null;
            if (isResolved) {
                if (bitField !== null) maybePromise.suppressUnhandledRejections();
            } else if (bitField !== null) {
                if ((bitField & 50397184) === 0) {
                    maybePromise._proxy(this, i);
                    this._values[i] = maybePromise;
                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                else isResolved = this._promiseCancelled(i);
            } else isResolved = this._promiseFulfilled(maybePromise, i);
        }
        if (!isResolved) result._setAsyncGuaranteed();
    };
    PromiseArray.prototype._isResolved = function() {
        return this._values === null;
    };
    PromiseArray.prototype._resolve = function(value) {
        this._values = null;
        this._promise._fulfill(value);
    };
    PromiseArray.prototype._cancel = function() {
        if (this._isResolved() || !this._promise._isCancellable()) return;
        this._values = null;
        this._promise._cancel();
    };
    PromiseArray.prototype._reject = function(reason) {
        this._values = null;
        this._promise._rejectCallback(reason, false);
    };
    PromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    PromiseArray.prototype._promiseCancelled = function() {
        this._cancel();
        return true;
    };
    PromiseArray.prototype._promiseRejected = function(reason) {
        this._totalResolved++;
        this._reject(reason);
        return true;
    };
    PromiseArray.prototype._resultCancelled = function() {
        if (this._isResolved()) return;
        var values = this._values;
        this._cancel();
        if (values instanceof Promise) values.cancel();
        else {
            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise) values[i].cancel();
        }
    };
    PromiseArray.prototype.shouldCopyValues = function() {
        return true;
    };
    PromiseArray.prototype.getActualLength = function(len) {
        return len;
    };
    return PromiseArray;
};

});

parcelRegister("1hNea", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var longStackTraces = false;
    var contextStack = [];
    Promise.prototype._promiseCreated = function() {};
    Promise.prototype._pushContext = function() {};
    Promise.prototype._popContext = function() {
        return null;
    };
    Promise._peekContext = Promise.prototype._peekContext = function() {};
    function Context() {
        this._trace = new Context.CapturedTrace(peekContext());
    }
    Context.prototype._pushContext = function() {
        if (this._trace !== undefined) {
            this._trace._promiseCreated = null;
            contextStack.push(this._trace);
        }
    };
    Context.prototype._popContext = function() {
        if (this._trace !== undefined) {
            var trace = contextStack.pop();
            var ret = trace._promiseCreated;
            trace._promiseCreated = null;
            return ret;
        }
        return null;
    };
    function createContext() {
        if (longStackTraces) return new Context();
    }
    function peekContext() {
        var lastIndex = contextStack.length - 1;
        if (lastIndex >= 0) return contextStack[lastIndex];
        return undefined;
    }
    Context.CapturedTrace = null;
    Context.create = createContext;
    Context.deactivateLongStackTraces = function() {};
    Context.activateLongStackTraces = function() {
        var Promise_pushContext = Promise.prototype._pushContext;
        var Promise_popContext = Promise.prototype._popContext;
        var Promise_PeekContext = Promise._peekContext;
        var Promise_peekContext = Promise.prototype._peekContext;
        var Promise_promiseCreated = Promise.prototype._promiseCreated;
        Context.deactivateLongStackTraces = function() {
            Promise.prototype._pushContext = Promise_pushContext;
            Promise.prototype._popContext = Promise_popContext;
            Promise._peekContext = Promise_PeekContext;
            Promise.prototype._peekContext = Promise_peekContext;
            Promise.prototype._promiseCreated = Promise_promiseCreated;
            longStackTraces = false;
        };
        longStackTraces = true;
        Promise.prototype._pushContext = Context.prototype._pushContext;
        Promise.prototype._popContext = Context.prototype._popContext;
        Promise._peekContext = Promise.prototype._peekContext = peekContext;
        Promise.prototype._promiseCreated = function() {
            var ctx = this._peekContext();
            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
        };
    };
    return Context;
};

});

parcelRegister("b3Gcj", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";


module.exports = function(Promise, Context) {
    var getDomain = Promise._getDomain;
    var async = Promise._async;
    var Warning = (parcelRequire("2cTYx")).Warning;
    var util = (parcelRequire("hXEBa"));
    var canAttachTrace = util.canAttachTrace;
    var unhandledRejectionHandled;
    var possiblyUnhandledRejection;
    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
    var stackFramePattern = null;
    var formatStack = null;
    var indentStackFrames = false;
    var printWarning;
    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
    Promise.prototype.suppressUnhandledRejections = function() {
        var target = this._target();
        target._bitField = target._bitField & -1048577 | 524288;
    };
    Promise.prototype._ensurePossibleRejectionHandled = function() {
        if ((this._bitField & 524288) !== 0) return;
        this._setRejectionIsUnhandled();
        async.invokeLater(this._notifyUnhandledRejection, this, undefined);
    };
    Promise.prototype._notifyUnhandledRejectionIsHandled = function() {
        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
    };
    Promise.prototype._setReturnedNonUndefined = function() {
        this._bitField = this._bitField | 268435456;
    };
    Promise.prototype._returnedNonUndefined = function() {
        return (this._bitField & 268435456) !== 0;
    };
    Promise.prototype._notifyUnhandledRejection = function() {
        if (this._isRejectionUnhandled()) {
            var reason = this._settledValue();
            this._setUnhandledRejectionIsNotified();
            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
        }
    };
    Promise.prototype._setUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField | 262144;
    };
    Promise.prototype._unsetUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField & -262145;
    };
    Promise.prototype._isUnhandledRejectionNotified = function() {
        return (this._bitField & 262144) > 0;
    };
    Promise.prototype._setRejectionIsUnhandled = function() {
        this._bitField = this._bitField | 1048576;
    };
    Promise.prototype._unsetRejectionIsUnhandled = function() {
        this._bitField = this._bitField & -1048577;
        if (this._isUnhandledRejectionNotified()) {
            this._unsetUnhandledRejectionIsNotified();
            this._notifyUnhandledRejectionIsHandled();
        }
    };
    Promise.prototype._isRejectionUnhandled = function() {
        return (this._bitField & 1048576) > 0;
    };
    Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
        return warn(message, shouldUseOwnTrace, promise || this);
    };
    Promise.onPossiblyUnhandledRejection = function(fn) {
        var domain = getDomain();
        possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    Promise.onUnhandledRejectionHandled = function(fn) {
        var domain = getDomain();
        unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    var disableLongStackTraces = function() {};
    Promise.longStackTraces = function() {
        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        if (!config.longStackTraces && longStackTracesIsSupported()) {
            var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
            var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
            config.longStackTraces = true;
            disableLongStackTraces = function() {
                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                Promise.prototype._captureStackTrace = Promise_captureStackTrace;
                Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
                Context.deactivateLongStackTraces();
                async.enableTrampoline();
                config.longStackTraces = false;
            };
            Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
            Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
            Context.activateLongStackTraces();
            async.disableTrampolineIfNecessary();
        }
    };
    Promise.hasLongStackTraces = function() {
        return config.longStackTraces && longStackTracesIsSupported();
    };
    var fireDomEvent = function() {
        try {
            if (typeof CustomEvent === "function") {
                var event = new CustomEvent("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new CustomEvent(name.toLowerCase(), {
                        detail: event,
                        cancelable: true
                    });
                    return !util.global.dispatchEvent(domEvent);
                };
            } else if (typeof Event === "function") {
                var event = new Event("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new Event(name.toLowerCase(), {
                        cancelable: true
                    });
                    domEvent.detail = event;
                    return !util.global.dispatchEvent(domEvent);
                };
            } else {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = document.createEvent("CustomEvent");
                    domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
                    return !util.global.dispatchEvent(domEvent);
                };
            }
        } catch (e) {}
        return function() {
            return false;
        };
    }();
    var fireGlobalEvent = function() {
        if (util.isNode) return function() {
            return $4TZ3D.emit.apply($4TZ3D, arguments);
        };
        else {
            if (!util.global) return function() {
                return false;
            };
            return function(name) {
                var methodName = "on" + name.toLowerCase();
                var method = util.global[methodName];
                if (!method) return false;
                method.apply(util.global, [].slice.call(arguments, 1));
                return true;
            };
        }
    }();
    function generatePromiseLifecycleEventObject(name, promise) {
        return {
            promise: promise
        };
    }
    var eventToObjectGenerator = {
        promiseCreated: generatePromiseLifecycleEventObject,
        promiseFulfilled: generatePromiseLifecycleEventObject,
        promiseRejected: generatePromiseLifecycleEventObject,
        promiseResolved: generatePromiseLifecycleEventObject,
        promiseCancelled: generatePromiseLifecycleEventObject,
        promiseChained: function(name, promise, child) {
            return {
                promise: promise,
                child: child
            };
        },
        warning: function(name, warning) {
            return {
                warning: warning
            };
        },
        unhandledRejection: function(name, reason, promise) {
            return {
                reason: reason,
                promise: promise
            };
        },
        rejectionHandled: generatePromiseLifecycleEventObject
    };
    var activeFireEvent = function(name) {
        var globalEventFired = false;
        try {
            globalEventFired = fireGlobalEvent.apply(null, arguments);
        } catch (e) {
            async.throwLater(e);
            globalEventFired = true;
        }
        var domEventFired = false;
        try {
            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
        } catch (e) {
            async.throwLater(e);
            domEventFired = true;
        }
        return domEventFired || globalEventFired;
    };
    Promise.config = function(opts) {
        opts = Object(opts);
        if ("longStackTraces" in opts) {
            if (opts.longStackTraces) Promise.longStackTraces();
            else if (!opts.longStackTraces && Promise.hasLongStackTraces()) disableLongStackTraces();
        }
        if ("warnings" in opts) {
            var warningsOption = opts.warnings;
            config.warnings = !!warningsOption;
            wForgottenReturn = config.warnings;
            if (util.isObject(warningsOption)) {
                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
            Promise.prototype._clearCancellationData = cancellationClearCancellationData;
            Promise.prototype._propagateFrom = cancellationPropagateFrom;
            Promise.prototype._onCancel = cancellationOnCancel;
            Promise.prototype._setOnCancel = cancellationSetOnCancel;
            Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
            Promise.prototype._execute = cancellationExecute;
            propagateFromFunction = cancellationPropagateFrom;
            config.cancellation = true;
        }
        if ("monitoring" in opts) {
            if (opts.monitoring && !config.monitoring) {
                config.monitoring = true;
                Promise.prototype._fireEvent = activeFireEvent;
            } else if (!opts.monitoring && config.monitoring) {
                config.monitoring = false;
                Promise.prototype._fireEvent = defaultFireEvent;
            }
        }
        return Promise;
    };
    function defaultFireEvent() {
        return false;
    }
    Promise.prototype._fireEvent = defaultFireEvent;
    Promise.prototype._execute = function(executor, resolve, reject) {
        try {
            executor(resolve, reject);
        } catch (e) {
            return e;
        }
    };
    Promise.prototype._onCancel = function() {};
    Promise.prototype._setOnCancel = function(handler) {};
    Promise.prototype._attachCancellationCallback = function(onCancel) {};
    Promise.prototype._captureStackTrace = function() {};
    Promise.prototype._attachExtraTrace = function() {};
    Promise.prototype._clearCancellationData = function() {};
    Promise.prototype._propagateFrom = function(parent, flags) {};
    function cancellationExecute(executor, resolve, reject) {
        var promise = this;
        try {
            executor(resolve, reject, function(onCancel) {
                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                promise._attachCancellationCallback(onCancel);
            });
        } catch (e) {
            return e;
        }
    }
    function cancellationAttachCancellationCallback(onCancel) {
        if (!this._isCancellable()) return this;
        var previousOnCancel = this._onCancel();
        if (previousOnCancel !== undefined) {
            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
            else this._setOnCancel([
                previousOnCancel,
                onCancel
            ]);
        } else this._setOnCancel(onCancel);
    }
    function cancellationOnCancel() {
        return this._onCancelField;
    }
    function cancellationSetOnCancel(onCancel) {
        this._onCancelField = onCancel;
    }
    function cancellationClearCancellationData() {
        this._cancellationParent = undefined;
        this._onCancelField = undefined;
    }
    function cancellationPropagateFrom(parent, flags) {
        if ((flags & 1) !== 0) {
            this._cancellationParent = parent;
            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
        }
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    function bindingPropagateFrom(parent, flags) {
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    var propagateFromFunction = bindingPropagateFrom;
    function boundValueFunction() {
        var ret = this._boundTo;
        if (ret !== undefined) {
            if (ret instanceof Promise) {
                if (ret.isFulfilled()) return ret.value();
                else return undefined;
            }
        }
        return ret;
    }
    function longStackTracesCaptureStackTrace() {
        this._trace = new CapturedTrace(this._peekContext());
    }
    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
        if (canAttachTrace(error)) {
            var trace = this._trace;
            if (trace !== undefined) {
                if (ignoreSelf) trace = trace._parent;
            }
            if (trace !== undefined) trace.attachExtraTrace(error);
            else if (!error.__stackCleaned__) {
                var parsed = parseStackAndMessage(error);
                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                util.notEnumerableProp(error, "__stackCleaned__", true);
            }
        }
    }
    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
            if (parent !== undefined && parent._returnedNonUndefined()) return;
            if ((promise._bitField & 65535) === 0) return;
            if (name) name = name + " ";
            var handlerLine = "";
            var creatorLine = "";
            if (promiseCreated._trace) {
                var traceLines = promiseCreated._trace.stack.split("\n");
                var stack = cleanStack(traceLines);
                for(var i = stack.length - 1; i >= 0; --i){
                    var line = stack[i];
                    if (!nodeFramePattern.test(line)) {
                        var lineMatches = line.match(parseLinePattern);
                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                        break;
                    }
                }
                if (stack.length > 0) {
                    var firstUserLine = stack[0];
                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                        break;
                    }
                }
            }
            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
            promise._warn(msg, true, promiseCreated);
        }
    }
    function deprecated(name, replacement) {
        var message = name + " is deprecated and will be removed in a future version.";
        if (replacement) message += " Use " + replacement + " instead.";
        return warn(message);
    }
    function warn(message, shouldUseOwnTrace, promise) {
        if (!config.warnings) return;
        var warning = new Warning(message);
        var ctx;
        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
        else if (config.longStackTraces && (ctx = Promise._peekContext())) ctx.attachExtraTrace(warning);
        else {
            var parsed = parseStackAndMessage(warning);
            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
        }
        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
    }
    function reconstructStack(message, stacks) {
        for(var i = 0; i < stacks.length - 1; ++i){
            stacks[i].push("From previous event:");
            stacks[i] = stacks[i].join("\n");
        }
        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
        return message + "\n" + stacks.join("\n");
    }
    function removeDuplicateOrEmptyJumps(stacks) {
        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
            stacks.splice(i, 1);
            i--;
        }
    }
    function removeCommonRoots(stacks) {
        var current = stacks[0];
        for(var i = 1; i < stacks.length; ++i){
            var prev = stacks[i];
            var currentLastIndex = current.length - 1;
            var currentLastLine = current[currentLastIndex];
            var commonRootMeetPoint = -1;
            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
            for(var j = commonRootMeetPoint; j >= 0; --j){
                var line = prev[j];
                if (current[currentLastIndex] === line) {
                    current.pop();
                    currentLastIndex--;
                } else break;
            }
            current = prev;
        }
    }
    function cleanStack(stack) {
        var ret = [];
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
            var isInternalFrame = isTraceLine && shouldIgnore(line);
            if (isTraceLine && !isInternalFrame) {
                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                ret.push(line);
            }
        }
        return ret;
    }
    function stackFramesAsArray(error) {
        var stack = error.stack.replace(/\s+$/g, "").split("\n");
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
        }
        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
        return stack;
    }
    function parseStackAndMessage(error) {
        var stack = error.stack;
        var message = error.toString();
        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
            "    (No stack trace)"
        ];
        return {
            message: message,
            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
        };
    }
    function formatAndLogError(error, title, isSoft) {
        if (typeof console !== "undefined") {
            var message;
            if (util.isObject(error)) {
                var stack = error.stack;
                message = title + formatStack(stack, error);
            } else message = title + String(error);
            if (typeof printWarning === "function") printWarning(message, isSoft);
            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
        }
    }
    function fireRejectionEvent(name, localHandler, reason, promise) {
        var localEventFired = false;
        try {
            if (typeof localHandler === "function") {
                localEventFired = true;
                if (name === "rejectionHandled") localHandler(promise);
                else localHandler(reason, promise);
            }
        } catch (e) {
            async.throwLater(e);
        }
        if (name === "unhandledRejection") {
            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
        } else activeFireEvent(name, promise);
    }
    function formatNonError(obj) {
        var str;
        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
        else {
            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
            if (ruselessToString.test(str)) try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            } catch (e) {}
            if (str.length === 0) str = "(empty array)";
        }
        return "(<" + snip(str) + ">, no stack trace)";
    }
    function snip(str) {
        var maxChars = 41;
        if (str.length < maxChars) return str;
        return str.substr(0, maxChars - 3) + "...";
    }
    function longStackTracesIsSupported() {
        return typeof captureStackTrace === "function";
    }
    var shouldIgnore = function() {
        return false;
    };
    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
    function parseLineInfo(line) {
        var matches = line.match(parseLineInfoRegex);
        if (matches) return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
    function setBounds(firstLineError, lastLineError) {
        if (!longStackTracesIsSupported()) return;
        var firstStackLines = firstLineError.stack.split("\n");
        var lastStackLines = lastLineError.stack.split("\n");
        var firstIndex = -1;
        var lastIndex = -1;
        var firstFileName;
        var lastFileName;
        for(var i = 0; i < firstStackLines.length; ++i){
            var result = parseLineInfo(firstStackLines[i]);
            if (result) {
                firstFileName = result.fileName;
                firstIndex = result.line;
                break;
            }
        }
        for(var i = 0; i < lastStackLines.length; ++i){
            var result = parseLineInfo(lastStackLines[i]);
            if (result) {
                lastFileName = result.fileName;
                lastIndex = result.line;
                break;
            }
        }
        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
        shouldIgnore = function(line) {
            if (bluebirdFramePattern.test(line)) return true;
            var info = parseLineInfo(line);
            if (info) {
                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
            }
            return false;
        };
    }
    function CapturedTrace(parent) {
        this._parent = parent;
        this._promisesCreated = 0;
        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
        captureStackTrace(this, CapturedTrace);
        if (length > 32) this.uncycle();
    }
    util.inherits(CapturedTrace, Error);
    Context.CapturedTrace = CapturedTrace;
    CapturedTrace.prototype.uncycle = function() {
        var length = this._length;
        if (length < 2) return;
        var nodes = [];
        var stackToIndex = {};
        for(var i = 0, node = this; node !== undefined; ++i){
            nodes.push(node);
            node = node._parent;
        }
        length = this._length = i;
        for(var i = length - 1; i >= 0; --i){
            var stack = nodes[i].stack;
            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
        }
        for(var i = 0; i < length; ++i){
            var currentStack = nodes[i].stack;
            var index = stackToIndex[currentStack];
            if (index !== undefined && index !== i) {
                if (index > 0) {
                    nodes[index - 1]._parent = undefined;
                    nodes[index - 1]._length = 1;
                }
                nodes[i]._parent = undefined;
                nodes[i]._length = 1;
                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                if (index < length - 1) {
                    cycleEdgeNode._parent = nodes[index + 1];
                    cycleEdgeNode._parent.uncycle();
                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                } else {
                    cycleEdgeNode._parent = undefined;
                    cycleEdgeNode._length = 1;
                }
                var currentChildLength = cycleEdgeNode._length + 1;
                for(var j = i - 2; j >= 0; --j){
                    nodes[j]._length = currentChildLength;
                    currentChildLength++;
                }
                return;
            }
        }
    };
    CapturedTrace.prototype.attachExtraTrace = function(error) {
        if (error.__stackCleaned__) return;
        this.uncycle();
        var parsed = parseStackAndMessage(error);
        var message = parsed.message;
        var stacks = [
            parsed.stack
        ];
        var trace = this;
        while(trace !== undefined){
            stacks.push(cleanStack(trace.stack.split("\n")));
            trace = trace._parent;
        }
        removeCommonRoots(stacks);
        removeDuplicateOrEmptyJumps(stacks);
        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
        util.notEnumerableProp(error, "__stackCleaned__", true);
    };
    var captureStackTrace = function stackDetection() {
        var v8stackFramePattern = /^\s*at\s*/;
        var v8stackFormatter = function(stack, error) {
            if (typeof stack === "string") return stack;
            if (error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
            Error.stackTraceLimit += 6;
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            var captureStackTrace = Error.captureStackTrace;
            shouldIgnore = function(line) {
                return bluebirdFramePattern.test(line);
            };
            return function(receiver, ignoreUntil) {
                Error.stackTraceLimit += 6;
                captureStackTrace(receiver, ignoreUntil);
                Error.stackTraceLimit -= 6;
            };
        }
        var err = new Error();
        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
            stackFramePattern = /@/;
            formatStack = v8stackFormatter;
            indentStackFrames = true;
            return function captureStackTrace(o) {
                o.stack = new Error().stack;
            };
        }
        var hasStackAfterThrow;
        try {
            throw new Error();
        } catch (e) {
            hasStackAfterThrow = "stack" in e;
        }
        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            return function captureStackTrace(o) {
                Error.stackTraceLimit += 6;
                try {
                    throw new Error();
                } catch (e) {
                    o.stack = e.stack;
                }
                Error.stackTraceLimit -= 6;
            };
        }
        formatStack = function(stack, error) {
            if (typeof stack === "string") return stack;
            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        return null;
    }([]);
    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
        printWarning = function(message) {
            console.warn(message);
        };
        if (util.isNode && $4TZ3D.stderr.isTTY) printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
        };
    }
    var config = {
        warnings: warnings,
        longStackTraces: false,
        cancellation: false,
        monitoring: false
    };
    if (longStackTraces) Promise.longStackTraces();
    return {
        longStackTraces: function() {
            return config.longStackTraces;
        },
        warnings: function() {
            return config.warnings;
        },
        cancellation: function() {
            return config.cancellation;
        },
        monitoring: function() {
            return config.monitoring;
        },
        propagateFromFunction: function() {
            return propagateFromFunction;
        },
        boundValueFunction: function() {
            return boundValueFunction;
        },
        checkForgottenReturns: checkForgottenReturns,
        setBounds: setBounds,
        warn: warn,
        deprecated: deprecated,
        CapturedTrace: CapturedTrace,
        fireDomEvent: fireDomEvent,
        fireGlobalEvent: fireGlobalEvent
    };
};

});

parcelRegister("kXSTn", function(module, exports) {
"use strict";

module.exports = function(Promise, tryConvertToPromise) {
    var util = (parcelRequire("hXEBa"));
    var CancellationError = Promise.CancellationError;
    var errorObj = util.errorObj;
    function PassThroughHandlerContext(promise, type, handler) {
        this.promise = promise;
        this.type = type;
        this.handler = handler;
        this.called = false;
        this.cancelPromise = null;
    }
    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
        return this.type === 0;
    };
    function FinallyHandlerCancelReaction(finallyHandler) {
        this.finallyHandler = finallyHandler;
    }
    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
        checkCancel(this.finallyHandler);
    };
    function checkCancel(ctx, reason) {
        if (ctx.cancelPromise != null) {
            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
            else ctx.cancelPromise._cancel();
            ctx.cancelPromise = null;
            return true;
        }
        return false;
    }
    function succeed() {
        return finallyHandler.call(this, this.promise._target()._settledValue());
    }
    function fail(reason) {
        if (checkCancel(this, reason)) return;
        errorObj.e = reason;
        return errorObj;
    }
    function finallyHandler(reasonOrValue) {
        var promise = this.promise;
        var handler = this.handler;
        if (!this.called) {
            this.called = true;
            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
            if (ret !== undefined) {
                promise._setReturnedNonUndefined();
                var maybePromise = tryConvertToPromise(ret, promise);
                if (maybePromise instanceof Promise) {
                    if (this.cancelPromise != null) {
                        if (maybePromise._isCancelled()) {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            errorObj.e = reason;
                            return errorObj;
                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                    }
                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                }
            }
        }
        if (promise.isRejected()) {
            checkCancel(this);
            errorObj.e = reasonOrValue;
            return errorObj;
        } else {
            checkCancel(this);
            return reasonOrValue;
        }
    }
    Promise.prototype._passThrough = function(handler, type, success, fail) {
        if (typeof handler !== "function") return this.then();
        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
    };
    Promise.prototype.lastly = Promise.prototype["finally"] = function(handler) {
        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
    };
    Promise.prototype.tap = function(handler) {
        return this._passThrough(handler, 1, finallyHandler);
    };
    return PassThroughHandlerContext;
};

});

parcelRegister("lH3Jl", function(module, exports) {
"use strict";


module.exports = function(NEXT_FILTER) {
    var util = (parcelRequire("hXEBa"));
    var getKeys = (parcelRequire("gK3jX")).keys;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function catchFilter(instances, cb, promise) {
        return function(e) {
            var boundTo = promise._boundValue();
            predicateLoop: for(var i = 0; i < instances.length; ++i){
                var item = instances[i];
                if (item === Error || item != null && item.prototype instanceof Error) {
                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                } else if (typeof item === "function") {
                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                    if (matchesPredicate === errorObj) return matchesPredicate;
                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                } else if (util.isObject(e)) {
                    var keys = getKeys(item);
                    for(var j = 0; j < keys.length; ++j){
                        var key = keys[j];
                        if (item[key] != e[key]) continue predicateLoop;
                    }
                    return tryCatch(cb).call(boundTo, e);
                }
            }
            return NEXT_FILTER;
        };
    }
    return catchFilter;
};

});

parcelRegister("ai1Zk", function(module, exports) {
"use strict";

var $hXEBa = parcelRequire("hXEBa");
var $77dd20a0d536b2a4$var$maybeWrapAsError = $hXEBa.maybeWrapAsError;

var $2cTYx = parcelRequire("2cTYx");
var $77dd20a0d536b2a4$var$OperationalError = $2cTYx.OperationalError;

var $gK3jX = parcelRequire("gK3jX");
function $77dd20a0d536b2a4$var$isUntypedError(obj) {
    return obj instanceof Error && $gK3jX.getPrototypeOf(obj) === Error.prototype;
}
var $77dd20a0d536b2a4$var$rErrorKey = /^(?:name|message|stack|cause)$/;
function $77dd20a0d536b2a4$var$wrapAsOperationalError(obj) {
    var ret;
    if ($77dd20a0d536b2a4$var$isUntypedError(obj)) {
        ret = new $77dd20a0d536b2a4$var$OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = $gK3jX.keys(obj);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$77dd20a0d536b2a4$var$rErrorKey.test(key)) ret[key] = obj[key];
        }
        return ret;
    }
    $hXEBa.markAsOriginatingFromRejection(obj);
    return obj;
}
function $77dd20a0d536b2a4$var$nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = $77dd20a0d536b2a4$var$wrapAsOperationalError($77dd20a0d536b2a4$var$maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) promise._fulfill(value);
        else {
            var $_len = arguments.length;
            var args = new Array(Math.max($_len - 1, 0));
            for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
            promise._fulfill(args);
        }
        promise = null;
    };
}
module.exports = $77dd20a0d536b2a4$var$nodebackForPromise;

});

parcelRegister("9cIlW", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    Promise.method = function(fn) {
        if (typeof fn !== "function") throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
        return function() {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._pushContext();
            var value = tryCatch(fn).apply(this, arguments);
            var promiseCreated = ret._popContext();
            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
            ret._resolveFromSyncValue(value);
            return ret;
        };
    };
    Promise.attempt = Promise["try"] = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value;
        if (arguments.length > 1) {
            debug.deprecated("calling Promise.try with more than 1 argument");
            var arg = arguments[1];
            var ctx = arguments[2];
            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
        } else value = tryCatch(fn)();
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
    Promise.prototype._resolveFromSyncValue = function(value) {
        if (value === util.errorObj) this._rejectCallback(value.e, false);
        else this._resolveCallback(value, true);
    };
};

});

parcelRegister("974rV", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
    var calledBind = false;
    var rejectThis = function(_, e) {
        this._reject(e);
    };
    var targetRejected = function(e, context) {
        context.promiseRejectionQueued = true;
        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
    };
    var bindingResolved = function(thisArg, context) {
        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
    };
    var bindingRejected = function(e, context) {
        if (!context.promiseRejectionQueued) this._reject(e);
    };
    Promise.prototype.bind = function(thisArg) {
        if (!calledBind) {
            calledBind = true;
            Promise.prototype._propagateFrom = debug.propagateFromFunction();
            Promise.prototype._boundValue = debug.boundValueFunction();
        }
        var maybePromise = tryConvertToPromise(thisArg);
        var ret = new Promise(INTERNAL);
        ret._propagateFrom(this, 1);
        var target = this._target();
        ret._setBoundTo(maybePromise);
        if (maybePromise instanceof Promise) {
            var context = {
                promiseRejectionQueued: false,
                promise: ret,
                target: target,
                bindingPromise: maybePromise
            };
            target._then(INTERNAL, targetRejected, undefined, ret, context);
            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
            ret._setOnCancel(maybePromise);
        } else ret._resolveCallback(target);
        return ret;
    };
    Promise.prototype._setBoundTo = function(obj) {
        if (obj !== undefined) {
            this._bitField = this._bitField | 2097152;
            this._boundTo = obj;
        } else this._bitField = this._bitField & -2097153;
    };
    Promise.prototype._isBound = function() {
        return (this._bitField & 2097152) === 2097152;
    };
    Promise.bind = function(thisArg, value) {
        return Promise.resolve(value).bind(thisArg);
    };
};

});

parcelRegister("9AKvF", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, debug) {
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    Promise.prototype["break"] = Promise.prototype.cancel = function() {
        if (!debug.cancellation()) return this._warn("cancellation is disabled");
        var promise = this;
        var child = promise;
        while(promise._isCancellable()){
            if (!promise._cancelBy(child)) {
                if (child._isFollowing()) child._followee().cancel();
                else child._cancelBranched();
                break;
            }
            var parent = promise._cancellationParent;
            if (parent == null || !parent._isCancellable()) {
                if (promise._isFollowing()) promise._followee().cancel();
                else promise._cancelBranched();
                break;
            } else {
                if (promise._isFollowing()) promise._followee().cancel();
                promise._setWillBeCancelled();
                child = promise;
                promise = parent;
            }
        }
    };
    Promise.prototype._branchHasCancelled = function() {
        this._branchesRemainingToCancel--;
    };
    Promise.prototype._enoughBranchesHaveCancelled = function() {
        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
    };
    Promise.prototype._cancelBy = function(canceller) {
        if (canceller === this) {
            this._branchesRemainingToCancel = 0;
            this._invokeOnCancel();
            return true;
        } else {
            this._branchHasCancelled();
            if (this._enoughBranchesHaveCancelled()) {
                this._invokeOnCancel();
                return true;
            }
        }
        return false;
    };
    Promise.prototype._cancelBranched = function() {
        if (this._enoughBranchesHaveCancelled()) this._cancel();
    };
    Promise.prototype._cancel = function() {
        if (!this._isCancellable()) return;
        this._setCancelled();
        async.invoke(this._cancelPromises, this, undefined);
    };
    Promise.prototype._cancelPromises = function() {
        if (this._length() > 0) this._settlePromises();
    };
    Promise.prototype._unsetOnCancel = function() {
        this._onCancelField = undefined;
    };
    Promise.prototype._isCancellable = function() {
        return this.isPending() && !this._isCancelled();
    };
    Promise.prototype.isCancellable = function() {
        return this.isPending() && !this.isCancelled();
    };
    Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        else if (onCancelCallback !== undefined) {
            if (typeof onCancelCallback === "function") {
                if (!internalOnly) {
                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                    if (e === errorObj) {
                        this._attachExtraTrace(e.e);
                        async.throwLater(e.e);
                    }
                }
            } else onCancelCallback._resultCancelled(this);
        }
    };
    Promise.prototype._invokeOnCancel = function() {
        var onCancelCallback = this._onCancel();
        this._unsetOnCancel();
        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
    };
    Promise.prototype._invokeInternalOnCancel = function() {
        if (this._isCancellable()) {
            this._doInvokeOnCancel(this._onCancel(), true);
            this._unsetOnCancel();
        }
    };
    Promise.prototype._resultCancelled = function() {
        this.cancel();
    };
};

});

parcelRegister("lMy0l", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function returner() {
        return this.value;
    }
    function thrower() {
        throw this.reason;
    }
    Promise.prototype["return"] = Promise.prototype.thenReturn = function(value) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(returner, undefined, undefined, {
            value: value
        }, undefined);
    };
    Promise.prototype["throw"] = Promise.prototype.thenThrow = function(reason) {
        return this._then(thrower, undefined, undefined, {
            reason: reason
        }, undefined);
    };
    Promise.prototype.catchThrow = function(reason) {
        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
            reason: reason
        }, undefined);
        else {
            var _reason = arguments[1];
            var handler = function() {
                throw _reason;
            };
            return this.caught(reason, handler);
        }
    };
    Promise.prototype.catchReturn = function(value) {
        if (arguments.length <= 1) {
            if (value instanceof Promise) value.suppressUnhandledRejections();
            return this._then(undefined, returner, undefined, {
                value: value
            }, undefined);
        } else {
            var _value = arguments[1];
            if (_value instanceof Promise) _value.suppressUnhandledRejections();
            var handler = function() {
                return _value;
            };
            return this.caught(value, handler);
        }
    };
};

});

parcelRegister("fxINL", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function PromiseInspection(promise) {
        if (promise !== undefined) {
            promise = promise._target();
            this._bitField = promise._bitField;
            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
        } else {
            this._bitField = 0;
            this._settledValueField = undefined;
        }
    }
    PromiseInspection.prototype._settledValue = function() {
        return this._settledValueField;
    };
    var value = PromiseInspection.prototype.value = function() {
        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
        return (this._bitField & 33554432) !== 0;
    };
    var isRejected = PromiseInspection.prototype.isRejected = function() {
        return (this._bitField & 16777216) !== 0;
    };
    var isPending = PromiseInspection.prototype.isPending = function() {
        return (this._bitField & 50397184) === 0;
    };
    var isResolved = PromiseInspection.prototype.isResolved = function() {
        return (this._bitField & 50331648) !== 0;
    };
    PromiseInspection.prototype.isCancelled = function() {
        return (this._bitField & 8454144) !== 0;
    };
    Promise.prototype.__isCancelled = function() {
        return (this._bitField & 65536) === 65536;
    };
    Promise.prototype._isCancelled = function() {
        return this._target().__isCancelled();
    };
    Promise.prototype.isCancelled = function() {
        return (this._target()._bitField & 8454144) !== 0;
    };
    Promise.prototype.isPending = function() {
        return isPending.call(this._target());
    };
    Promise.prototype.isRejected = function() {
        return isRejected.call(this._target());
    };
    Promise.prototype.isFulfilled = function() {
        return isFulfilled.call(this._target());
    };
    Promise.prototype.isResolved = function() {
        return isResolved.call(this._target());
    };
    Promise.prototype.value = function() {
        return value.call(this._target());
    };
    Promise.prototype.reason = function() {
        var target = this._target();
        target._unsetRejectionIsUnhandled();
        return reason.call(target);
    };
    Promise.prototype._value = function() {
        return this._settledValue();
    };
    Promise.prototype._reason = function() {
        this._unsetRejectionIsUnhandled();
        return this._settledValue();
    };
    Promise.PromiseInspection = PromiseInspection;
};

});

parcelRegister("6BFxN", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain) {
    var util = (parcelRequire("hXEBa"));
    var canEvaluate = util.canEvaluate;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var reject;
    if (canEvaluate) {
        var thenCallback = function(i) {
            return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
        };
        var promiseSetter = function(i) {
            return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
        };
        var generateHolderClass = function(total) {
            var props = new Array(total);
            for(var i = 0; i < props.length; ++i)props[i] = "this.p" + (i + 1);
            var assignment = props.join(" = ") + " = null;";
            var cancellationCode = "var promise;\n" + props.map(function(prop) {
                return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
            }).join("\n");
            var passedArguments = props.join(", ");
            var name = "Holder$" + total;
            var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";
            code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
            return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
        };
        var holderClasses = [];
        var thenCallbacks = [];
        var promiseSetters = [];
        for(var i = 0; i < 8; ++i){
            holderClasses.push(generateHolderClass(i + 1));
            thenCallbacks.push(thenCallback(i + 1));
            promiseSetters.push(promiseSetter(i + 1));
        }
        reject = function(reason) {
            this._reject(reason);
        };
    }
    Promise.join = function() {
        var last = arguments.length - 1;
        var fn;
        if (last > 0 && typeof arguments[last] === "function") {
            fn = arguments[last];
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;
                for(var i = 0; i < last; ++i){
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        if ((bitField & 50397184) === 0) {
                            maybePromise._then(callbacks[i], reject, undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if ((bitField & 33554432) !== 0) callbacks[i].call(ret, maybePromise._value(), holder);
                        else if ((bitField & 16777216) !== 0) ret._reject(maybePromise._reason());
                        else ret._cancel();
                    } else callbacks[i].call(ret, maybePromise, holder);
                }
                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) holder.fn = util.domainBind(domain, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
        var $_len = arguments.length;
        var args = new Array($_len);
        for(var $_i = 0; $_i < $_len; ++$_i)args[$_i] = arguments[$_i];
        if (fn) args.pop();
        var ret = new PromiseArray(args).promise();
        return fn !== undefined ? ret.spread(fn) : ret;
    };
};

});

parcelRegister("37iDz", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    function MappingPromiseArray(promises, fn, limit, _filter) {
        this.constructor$(promises);
        this._promise._captureStackTrace();
        var domain = getDomain();
        this._callback = domain === null ? fn : util.domainBind(domain, fn);
        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
        this._limit = limit;
        this._inFlight = 0;
        this._queue = [];
        async.invoke(this._asyncInit, this, undefined);
    }
    util.inherits(MappingPromiseArray, PromiseArray);
    MappingPromiseArray.prototype._asyncInit = function() {
        this._init$(undefined, -2);
    };
    MappingPromiseArray.prototype._init = function() {};
    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var values = this._values;
        var length = this.length();
        var preservedValues = this._preservedValues;
        var limit = this._limit;
        if (index < 0) {
            index = index * -1 - 1;
            values[index] = value;
            if (limit >= 1) {
                this._inFlight--;
                this._drainQueue();
                if (this._isResolved()) return true;
            }
        } else {
            if (limit >= 1 && this._inFlight >= limit) {
                values[index] = value;
                this._queue.push(index);
                return false;
            }
            if (preservedValues !== null) preservedValues[index] = value;
            var promise = this._promise;
            var callback = this._callback;
            var receiver = promise._boundValue();
            promise._pushContext();
            var ret = tryCatch(callback).call(receiver, value, index, length);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
            if (ret === errorObj) {
                this._reject(ret.e);
                return true;
            }
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                if ((bitField & 50397184) === 0) {
                    if (limit >= 1) this._inFlight++;
                    values[index] = maybePromise;
                    maybePromise._proxy(this, (index + 1) * -1);
                    return false;
                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                else if ((bitField & 16777216) !== 0) {
                    this._reject(maybePromise._reason());
                    return true;
                } else {
                    this._cancel();
                    return true;
                }
            }
            values[index] = ret;
        }
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= length) {
            if (preservedValues !== null) this._filter(values, preservedValues);
            else this._resolve(values);
            return true;
        }
        return false;
    };
    MappingPromiseArray.prototype._drainQueue = function() {
        var queue = this._queue;
        var limit = this._limit;
        var values = this._values;
        while(queue.length > 0 && this._inFlight < limit){
            if (this._isResolved()) return;
            var index = queue.pop();
            this._promiseFulfilled(values[index], index);
        }
    };
    MappingPromiseArray.prototype._filter = function(booleans, values) {
        var len = values.length;
        var ret = new Array(len);
        var j = 0;
        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
        ret.length = j;
        this._resolve(ret);
    };
    MappingPromiseArray.prototype.preservedValues = function() {
        return this._preservedValues;
    };
    function map(promises, fn, options, _filter) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var limit = 0;
        if (options !== undefined) {
            if (typeof options === "object" && options !== null) {
                if (typeof options.concurrency !== "number") return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                limit = options.concurrency;
            } else return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
        }
        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
    }
    Promise.prototype.map = function(fn, options) {
        return map(this, fn, options, null);
    };
    Promise.map = function(promises, fn, options, _filter) {
        return map(promises, fn, options, _filter);
    };
};

});

parcelRegister("ifPKm", function(module, exports) {
"use strict";
var $d4a1c484b63b68a4$var$cr = Object.create;
if ($d4a1c484b63b68a4$var$cr) {
    var $d4a1c484b63b68a4$var$callerCache = $d4a1c484b63b68a4$var$cr(null);
    var $d4a1c484b63b68a4$var$getterCache = $d4a1c484b63b68a4$var$cr(null);
    $d4a1c484b63b68a4$var$callerCache[" size"] = $d4a1c484b63b68a4$var$getterCache[" size"] = 0;
}

module.exports = function(Promise) {
    var util = (parcelRequire("hXEBa"));
    var canEvaluate = util.canEvaluate;
    var isIdentifier = util.isIdentifier;
    var getMethodCaller;
    var getGetter;
    var makeMethodCaller = function(methodName) {
        return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
    };
    var makeGetter = function(propertyName) {
        return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
    };
    var getCompiled = function(name, compiler, cache) {
        var ret = cache[name];
        if (typeof ret !== "function") {
            if (!isIdentifier(name)) return null;
            ret = compiler(name);
            cache[name] = ret;
            cache[" size"]++;
            if (cache[" size"] > 512) {
                var keys = Object.keys(cache);
                for(var i = 0; i < 256; ++i)delete cache[keys[i]];
                cache[" size"] = keys.length - 256;
            }
        }
        return ret;
    };
    getMethodCaller = function(name) {
        return getCompiled(name, makeMethodCaller, $d4a1c484b63b68a4$var$callerCache);
    };
    getGetter = function(name) {
        return getCompiled(name, makeGetter, $d4a1c484b63b68a4$var$getterCache);
    };
    function ensureMethod(obj, methodName) {
        var fn;
        if (obj != null) fn = obj[methodName];
        if (typeof fn !== "function") {
            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
            throw new Promise.TypeError(message);
        }
        return fn;
    }
    function caller(obj) {
        var methodName = this.pop();
        var fn = ensureMethod(obj, methodName);
        return fn.apply(obj, this);
    }
    Promise.prototype.call = function(methodName) {
        var $_len = arguments.length;
        var args = new Array(Math.max($_len - 1, 0));
        for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) return this._then(maybeCaller, undefined, undefined, args, undefined);
        }
        args.push(methodName);
        return this._then(caller, undefined, undefined, args, undefined);
    };
    function namedGetter(obj) {
        return obj[this];
    }
    function indexedGetter(obj) {
        var index = +this;
        if (index < 0) index = Math.max(0, index + obj.length);
        return obj[index];
    }
    Promise.prototype.get = function(propertyName) {
        var isIndex = typeof propertyName === "number";
        var getter;
        if (!isIndex) {
            if (canEvaluate) {
                var maybeGetter = getGetter(propertyName);
                getter = maybeGetter !== null ? maybeGetter : namedGetter;
            } else getter = namedGetter;
        } else getter = indexedGetter;
        return this._then(getter, undefined, undefined, propertyName, undefined);
    };
};

});

parcelRegister("lUyBJ", function(module, exports) {
"use strict";



module.exports = function(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
    var util = (parcelRequire("hXEBa"));
    var TypeError = (parcelRequire("2cTYx")).TypeError;
    var inherits = (parcelRequire("hXEBa")).inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};
    function thrower(e) {
        setTimeout(function() {
            throw e;
        }, 0);
    }
    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) return maybePromise._then(iterator, thrower, null, null, null);
            }
            iterator();
        }
        iterator();
        return ret;
    }
    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }
    Disposer.prototype.data = function() {
        return this._data;
    };
    Disposer.prototype.promise = function() {
        return this._promise;
    };
    Disposer.prototype.resource = function() {
        if (this.promise().isFulfilled()) return this.promise().value();
        return NULL;
    };
    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };
    Disposer.isDisposer = function(d) {
        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
    };
    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);
    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };
    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }
    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length - 1] = null;
    }
    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for(var i = 0; i < len; ++i){
            var item = this[i];
            if (item instanceof Promise) item.cancel();
        }
    };
    Promise.using = function() {
        var len = arguments.length;
        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for(var i = 0; i < len; ++i){
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                    resources: resources,
                    index: i
                }, undefined);
            }
            resources[i] = resource;
        }
        var reflectedResources = new Array(resources.length);
        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        var resultPromise = Promise.all(reflectedResources).then(function(inspections) {
            for(var i = 0; i < inspections.length; ++i){
                var inspection = inspections[i];
                if (inspection.isRejected()) {
                    errorObj.e = inspection.error();
                    return errorObj;
                } else if (!inspection.isFulfilled()) {
                    resultPromise.cancel();
                    return;
                }
                inspections[i] = inspection.value();
            }
            promise._pushContext();
            fn = tryCatch(fn);
            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
            return ret;
        });
        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };
    Promise.prototype._setDisposable = function(disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };
    Promise.prototype._isDisposable = function() {
        return (this._bitField & 131072) > 0;
    };
    Promise.prototype._getDisposer = function() {
        return this._disposer;
    };
    Promise.prototype._unsetDisposable = function() {
        this._bitField = this._bitField & -131073;
        this._disposer = undefined;
    };
    Promise.prototype.disposer = function(fn) {
        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
        throw new TypeError();
    };
};

});

parcelRegister("a0oFK", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, debug) {
    var util = (parcelRequire("hXEBa"));
    var TimeoutError = Promise.TimeoutError;
    function HandleWrapper(handle) {
        this.handle = handle;
    }
    HandleWrapper.prototype._resultCancelled = function() {
        clearTimeout(this.handle);
    };
    var afterValue = function(value) {
        return delay(+this).thenReturn(value);
    };
    var delay = Promise.delay = function(ms, value) {
        var ret;
        var handle;
        if (value !== undefined) {
            ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
            if (debug.cancellation() && value instanceof Promise) ret._setOnCancel(value);
        } else {
            ret = new Promise(INTERNAL);
            handle = setTimeout(function() {
                ret._fulfill();
            }, +ms);
            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
            ret._captureStackTrace();
        }
        ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.prototype.delay = function(ms) {
        return delay(ms, this);
    };
    var afterTimeout = function(promise, message, parent) {
        var err;
        if (typeof message !== "string") {
            if (message instanceof Error) err = message;
            else err = new TimeoutError("operation timed out");
        } else err = new TimeoutError(message);
        util.markAsOriginatingFromRejection(err);
        promise._attachExtraTrace(err);
        promise._reject(err);
        if (parent != null) parent.cancel();
    };
    function successClear(value) {
        clearTimeout(this.handle);
        return value;
    }
    function failureClear(reason) {
        clearTimeout(this.handle);
        throw reason;
    }
    Promise.prototype.timeout = function(ms, message) {
        ms = +ms;
        var ret, parent;
        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
            if (ret.isPending()) afterTimeout(ret, message, parent);
        }, ms));
        if (debug.cancellation()) {
            parent = this.then();
            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
            ret._setOnCancel(handleWrapper);
        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
        return ret;
    };
};

});

parcelRegister("ehX3Q", function(module, exports) {
"use strict";


module.exports = function(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
    var errors = (parcelRequire("2cTYx"));
    var TypeError = errors.TypeError;
    var util = (parcelRequire("hXEBa"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var yieldHandlers = [];
    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
        for(var i = 0; i < yieldHandlers.length; ++i){
            traceParent._pushContext();
            var result = tryCatch(yieldHandlers[i])(value);
            traceParent._popContext();
            if (result === errorObj) {
                traceParent._pushContext();
                var ret = Promise.reject(errorObj.e);
                traceParent._popContext();
                return ret;
            }
            var maybePromise = tryConvertToPromise(result, traceParent);
            if (maybePromise instanceof Promise) return maybePromise;
        }
        return null;
    }
    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
        if (debug.cancellation()) {
            var internal = new Promise(INTERNAL);
            var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
            this._promise = internal.lastly(function() {
                return _finallyPromise;
            });
            internal._captureStackTrace();
            internal._setOnCancel(this);
        } else {
            var promise = this._promise = new Promise(INTERNAL);
            promise._captureStackTrace();
        }
        this._stack = stack;
        this._generatorFunction = generatorFunction;
        this._receiver = receiver;
        this._generator = undefined;
        this._yieldHandlers = typeof yieldHandler === "function" ? [
            yieldHandler
        ].concat(yieldHandlers) : yieldHandlers;
        this._yieldedPromise = null;
        this._cancellationPhase = false;
    }
    util.inherits(PromiseSpawn, Proxyable);
    PromiseSpawn.prototype._isResolved = function() {
        return this._promise === null;
    };
    PromiseSpawn.prototype._cleanup = function() {
        this._promise = this._generator = null;
        if (debug.cancellation() && this._finallyPromise !== null) {
            this._finallyPromise._fulfill();
            this._finallyPromise = null;
        }
    };
    PromiseSpawn.prototype._promiseCancelled = function() {
        if (this._isResolved()) return;
        var implementsReturn = typeof this._generator["return"] !== "undefined";
        var result;
        if (!implementsReturn) {
            var reason = new Promise.CancellationError("generator .return() sentinel");
            Promise.coroutine.returnSentinel = reason;
            this._promise._attachExtraTrace(reason);
            this._promise._pushContext();
            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
            this._promise._popContext();
        } else {
            this._promise._pushContext();
            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
            this._promise._popContext();
        }
        this._cancellationPhase = true;
        this._yieldedPromise = null;
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseFulfilled = function(value) {
        this._yieldedPromise = null;
        this._promise._pushContext();
        var result = tryCatch(this._generator.next).call(this._generator, value);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseRejected = function(reason) {
        this._yieldedPromise = null;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._resultCancelled = function() {
        if (this._yieldedPromise instanceof Promise) {
            var promise = this._yieldedPromise;
            this._yieldedPromise = null;
            promise.cancel();
        }
    };
    PromiseSpawn.prototype.promise = function() {
        return this._promise;
    };
    PromiseSpawn.prototype._run = function() {
        this._generator = this._generatorFunction.call(this._receiver);
        this._receiver = this._generatorFunction = undefined;
        this._promiseFulfilled(undefined);
    };
    PromiseSpawn.prototype._continue = function(result) {
        var promise = this._promise;
        if (result === errorObj) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._rejectCallback(result.e, false);
        }
        var value = result.value;
        if (result.done === true) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._resolveCallback(value);
        } else {
            var maybePromise = tryConvertToPromise(value, this._promise);
            if (!(maybePromise instanceof Promise)) {
                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                if (maybePromise === null) {
                    this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                    return;
                }
            }
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            if ((bitField & 50397184) === 0) {
                this._yieldedPromise = maybePromise;
                maybePromise._proxy(this, null);
            } else if ((bitField & 33554432) !== 0) Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
            else if ((bitField & 16777216) !== 0) Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
            else this._promiseCancelled();
        }
    };
    Promise.coroutine = function(generatorFunction, options) {
        if (typeof generatorFunction !== "function") throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var yieldHandler = Object(options).yieldHandler;
        var PromiseSpawn$ = PromiseSpawn;
        var stack = new Error().stack;
        return function() {
            var generator = generatorFunction.apply(this, arguments);
            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
            var ret = spawn.promise();
            spawn._generator = generator;
            spawn._promiseFulfilled(undefined);
            return ret;
        };
    };
    Promise.coroutine.addYieldHandler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        yieldHandlers.push(fn);
    };
    Promise.spawn = function(generatorFunction) {
        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var spawn = new PromiseSpawn(generatorFunction, this);
        var ret = spawn.promise();
        spawn._run(Promise.spawn);
        return ret;
    };
};

});

parcelRegister("hLNAV", function(module, exports) {
"use strict";

module.exports = function(Promise) {
    var util = (parcelRequire("hXEBa"));
    var async = Promise._async;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function spreadAdapter(val, nodeback) {
        var promise = this;
        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
            null
        ].concat(val));
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function successAdapter(val, nodeback) {
        var promise = this;
        var receiver = promise._boundValue();
        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function errorAdapter(reason, nodeback) {
        var promise = this;
        if (!reason) {
            var newReason = new Error(reason + "");
            newReason.cause = reason;
            reason = newReason;
        }
        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    Promise.prototype.asCallback = Promise.prototype.nodeify = function(nodeback, options) {
        if (typeof nodeback == "function") {
            var adapter = successAdapter;
            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
            this._then(adapter, errorAdapter, undefined, this, nodeback);
        }
        return this;
    };
};

});

parcelRegister("lFI4k", function(module, exports) {
"use strict";



module.exports = function(Promise, INTERNAL) {
    var THIS = {};
    var util = (parcelRequire("hXEBa"));
    var nodebackForPromise = (parcelRequire("ai1Zk"));
    var withAppended = util.withAppended;
    var maybeWrapAsError = util.maybeWrapAsError;
    var canEvaluate = util.canEvaluate;
    var TypeError = (parcelRequire("2cTYx")).TypeError;
    var defaultSuffix = "Async";
    var defaultPromisified = {
        __isPromisified__: true
    };
    var noCopyProps = [
        "arity",
        "length",
        "name",
        "arguments",
        "caller",
        "callee",
        "prototype",
        "__isPromisified__"
    ];
    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
    var defaultFilter = function(name) {
        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
    };
    function propsFilter(key) {
        return !noCopyPropsPattern.test(key);
    }
    function isPromisified(fn) {
        try {
            return fn.__isPromisified__ === true;
        } catch (e) {
            return false;
        }
    }
    function hasPromisified(obj, key, suffix) {
        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
        return val ? isPromisified(val) : false;
    }
    function checkValid(ret, suffix, suffixRegexp) {
        for(var i = 0; i < ret.length; i += 2){
            var key = ret[i];
            if (suffixRegexp.test(key)) {
                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                for(var j = 0; j < ret.length; j += 2){
                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                }
            }
        }
    }
    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
        var keys = util.inheritedDataKeys(obj);
        var ret = [];
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            var value = obj[key];
            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
        }
        checkValid(ret, suffix, suffixRegexp);
        return ret;
    }
    var escapeIdentRegex = function(str) {
        return str.replace(/([$])/, "\\$");
    };
    var makeNodePromisifiedEval;
    var switchCaseArgumentOrder = function(likelyArgumentCount) {
        var ret = [
            likelyArgumentCount
        ];
        var min = Math.max(0, likelyArgumentCount - 1 - 3);
        for(var i = likelyArgumentCount - 1; i >= min; --i)ret.push(i);
        for(var i = likelyArgumentCount + 1; i <= 3; ++i)ret.push(i);
        return ret;
    };
    var argumentSequence = function(argumentCount) {
        return util.filledRange(argumentCount, "_arg", "");
    };
    var parameterDeclaration = function(parameterCount) {
        return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
    };
    var parameterCount = function(fn) {
        if (typeof fn.length === "number") return Math.max(Math.min(fn.length, 1024), 0);
        return 0;
    };
    makeNodePromisifiedEval = function(callback, receiver, originalName, fn, _, multiArgs) {
        var newParameterCount = Math.max(0, parameterCount(fn) - 1);
        var argumentOrder = switchCaseArgumentOrder(newParameterCount);
        var shouldProxyThis = typeof callback === "string" || receiver === THIS;
        function generateCallForArgumentCount(count) {
            var args = argumentSequence(count).join(", ");
            var comma = count > 0 ? ", " : "";
            var ret;
            if (shouldProxyThis) ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
            else ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
            return ret.replace("{{args}}", args).replace(", ", comma);
        }
        function generateArgumentSwitchCase() {
            var ret = "";
            for(var i = 0; i < argumentOrder.length; ++i)ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
            ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
            return ret;
        }
        var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
        var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
        body = body.replace("Parameters", parameterDeclaration(newParameterCount));
        return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
    };
    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
        var defaultThis = function() {
            return this;
        }();
        var method = callback;
        if (typeof method === "string") callback = fn;
        function promisified() {
            var _receiver = receiver;
            if (receiver === THIS) _receiver = this;
            var promise = new Promise(INTERNAL);
            promise._captureStackTrace();
            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
            var fn = nodebackForPromise(promise, multiArgs);
            try {
                cb.apply(_receiver, withAppended(arguments, fn));
            } catch (e) {
                promise._rejectCallback(maybeWrapAsError(e), true, true);
            }
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
            return promise;
        }
        util.notEnumerableProp(promisified, "__isPromisified__", true);
        return promisified;
    }
    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
        for(var i = 0, len = methods.length; i < len; i += 2){
            var key = methods[i];
            var fn = methods[i + 1];
            var promisifiedKey = key + suffix;
            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
            else {
                var promisified = promisifier(fn, function() {
                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                });
                util.notEnumerableProp(promisified, "__isPromisified__", true);
                obj[promisifiedKey] = promisified;
            }
        }
        util.toFastProperties(obj);
        return obj;
    }
    function promisify(callback, receiver, multiArgs) {
        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
    }
    Promise.promisify = function(fn, options) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        if (isPromisified(fn)) return fn;
        options = Object(options);
        var receiver = options.context === undefined ? THIS : options.context;
        var multiArgs = !!options.multiArgs;
        var ret = promisify(fn, receiver, multiArgs);
        util.copyDescriptors(fn, ret, propsFilter);
        return ret;
    };
    Promise.promisifyAll = function(target, options) {
        if (typeof target !== "function" && typeof target !== "object") throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        options = Object(options);
        var multiArgs = !!options.multiArgs;
        var suffix = options.suffix;
        if (typeof suffix !== "string") suffix = defaultSuffix;
        var filter = options.filter;
        if (typeof filter !== "function") filter = defaultFilter;
        var promisifier = options.promisifier;
        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var keys = util.inheritedDataKeys(target);
        for(var i = 0; i < keys.length; ++i){
            var value = target[keys[i]];
            if (keys[i] !== "constructor" && util.isClass(value)) {
                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                promisifyAll(value, suffix, filter, promisifier, multiArgs);
            }
        }
        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
    };
};

});

parcelRegister("12mNB", function(module, exports) {
"use strict";


module.exports = function(Promise, PromiseArray, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var isObject = util.isObject;
    var es5 = (parcelRequire("gK3jX"));
    var Es6Map;
    if (typeof Map === "function") Es6Map = Map;
    var mapToEntries = function() {
        var index = 0;
        var size = 0;
        function extractEntry(value, key) {
            this[index] = value;
            this[index + size] = key;
            index++;
        }
        return function mapToEntries(map) {
            size = map.size;
            index = 0;
            var ret = new Array(map.size * 2);
            map.forEach(extractEntry, ret);
            return ret;
        };
    }();
    var entriesToMap = function(entries) {
        var ret = new Es6Map();
        var length = entries.length / 2 | 0;
        for(var i = 0; i < length; ++i){
            var key = entries[length + i];
            var value = entries[i];
            ret.set(key, value);
        }
        return ret;
    };
    function PropertiesPromiseArray(obj) {
        var isMap = false;
        var entries;
        if (Es6Map !== undefined && obj instanceof Es6Map) {
            entries = mapToEntries(obj);
            isMap = true;
        } else {
            var keys = es5.keys(obj);
            var len = keys.length;
            entries = new Array(len * 2);
            for(var i = 0; i < len; ++i){
                var key = keys[i];
                entries[i] = obj[key];
                entries[i + len] = key;
            }
        }
        this.constructor$(entries);
        this._isMap = isMap;
        this._init$(undefined, -3);
    }
    util.inherits(PropertiesPromiseArray, PromiseArray);
    PropertiesPromiseArray.prototype._init = function() {};
    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            var val;
            if (this._isMap) val = entriesToMap(this._values);
            else {
                val = {};
                var keyOffset = this.length();
                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
            }
            this._resolve(val);
            return true;
        }
        return false;
    };
    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    PropertiesPromiseArray.prototype.getActualLength = function(len) {
        return len >> 1;
    };
    function props(promises) {
        var ret;
        var castValue = tryConvertToPromise(promises);
        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        else if (castValue instanceof Promise) ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
        else ret = new PropertiesPromiseArray(castValue).promise();
        if (castValue instanceof Promise) ret._propagateFrom(castValue, 2);
        return ret;
    }
    Promise.prototype.props = function() {
        return props(this);
    };
    Promise.props = function(promises) {
        return props(promises);
    };
};

});

parcelRegister("ilsIA", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var raceLater = function(promise) {
        return promise.then(function(array) {
            return race(array, promise);
        });
    };
    function race(promises, parent) {
        var maybePromise = tryConvertToPromise(promises);
        if (maybePromise instanceof Promise) return raceLater(maybePromise);
        else {
            promises = util.asArray(promises);
            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
        }
        var ret = new Promise(INTERNAL);
        if (parent !== undefined) ret._propagateFrom(parent, 3);
        var fulfill = ret._fulfill;
        var reject = ret._reject;
        for(var i = 0, len = promises.length; i < len; ++i){
            var val = promises[i];
            if (val === undefined && !(i in promises)) continue;
            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
        }
        return ret;
    }
    Promise.race = function(promises) {
        return race(promises, undefined);
    };
    Promise.prototype.race = function() {
        return race(this, undefined);
    };
};

});

parcelRegister("4Qilm", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    function ReductionPromiseArray(promises, fn, initialValue, _each) {
        this.constructor$(promises);
        var domain = getDomain();
        this._fn = domain === null ? fn : util.domainBind(domain, fn);
        if (initialValue !== undefined) {
            initialValue = Promise.resolve(initialValue);
            initialValue._attachCancellationCallback(this);
        }
        this._initialValue = initialValue;
        this._currentCancellable = null;
        if (_each === INTERNAL) this._eachValues = Array(this._length);
        else if (_each === 0) this._eachValues = null;
        else this._eachValues = undefined;
        this._promise._captureStackTrace();
        this._init$(undefined, -5);
    }
    util.inherits(ReductionPromiseArray, PromiseArray);
    ReductionPromiseArray.prototype._gotAccum = function(accum) {
        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
    };
    ReductionPromiseArray.prototype._eachComplete = function(value) {
        if (this._eachValues !== null) this._eachValues.push(value);
        return this._eachValues;
    };
    ReductionPromiseArray.prototype._init = function() {};
    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
    };
    ReductionPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    ReductionPromiseArray.prototype._resolve = function(value) {
        this._promise._resolveCallback(value);
        this._values = null;
    };
    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
        if (sender === this._initialValue) return this._cancel();
        if (this._isResolved()) return;
        this._resultCancelled$();
        if (this._currentCancellable instanceof Promise) this._currentCancellable.cancel();
        if (this._initialValue instanceof Promise) this._initialValue.cancel();
    };
    ReductionPromiseArray.prototype._iterate = function(values) {
        this._values = values;
        var value;
        var i;
        var length = values.length;
        if (this._initialValue !== undefined) {
            value = this._initialValue;
            i = 0;
        } else {
            value = Promise.resolve(values[0]);
            i = 1;
        }
        this._currentCancellable = value;
        if (!value.isRejected()) for(; i < length; ++i){
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
        value._then(completed, completed, undefined, value, this);
    };
    Promise.prototype.reduce = function(fn, initialValue) {
        return reduce(this, fn, initialValue, null);
    };
    Promise.reduce = function(promises, fn, initialValue, _each) {
        return reduce(promises, fn, initialValue, _each);
    };
    function completed(valueOrReason, array) {
        if (this.isFulfilled()) array._resolve(valueOrReason);
        else array._reject(valueOrReason);
    }
    function reduce(promises, fn, initialValue, _each) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
        return array.promise();
    }
    function gotAccum(accum) {
        this.accum = accum;
        this.array._gotAccum(accum);
        var value = tryConvertToPromise(this.value, this.array._promise);
        if (value instanceof Promise) {
            this.array._currentCancellable = value;
            return value._then(gotValue, undefined, undefined, this, undefined);
        } else return gotValue.call(this, value);
    }
    function gotValue(value) {
        var array = this.array;
        var promise = array._promise;
        var fn = tryCatch(array._fn);
        promise._pushContext();
        var ret;
        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
        if (ret instanceof Promise) array._currentCancellable = ret;
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
        return ret;
    }
};

});

parcelRegister("lr4sX", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, debug) {
    var PromiseInspection = Promise.PromiseInspection;
    var util = (parcelRequire("hXEBa"));
    function SettledPromiseArray(values) {
        this.constructor$(values);
    }
    util.inherits(SettledPromiseArray, PromiseArray);
    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
        this._values[index] = inspection;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var ret = new PromiseInspection();
        ret._bitField = 33554432;
        ret._settledValueField = value;
        return this._promiseResolved(index, ret);
    };
    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
        var ret = new PromiseInspection();
        ret._bitField = 16777216;
        ret._settledValueField = reason;
        return this._promiseResolved(index, ret);
    };
    Promise.settle = function(promises) {
        debug.deprecated(".settle()", ".reflect()");
        return new SettledPromiseArray(promises).promise();
    };
    Promise.prototype.settle = function() {
        return Promise.settle(this);
    };
};

});

parcelRegister("8zVAW", function(module, exports) {
"use strict";



module.exports = function(Promise, PromiseArray, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var RangeError = (parcelRequire("2cTYx")).RangeError;
    var AggregateError = (parcelRequire("2cTYx")).AggregateError;
    var isArray = util.isArray;
    var CANCELLATION = {};
    function SomePromiseArray(values) {
        this.constructor$(values);
        this._howMany = 0;
        this._unwrap = false;
        this._initialized = false;
    }
    util.inherits(SomePromiseArray, PromiseArray);
    SomePromiseArray.prototype._init = function() {
        if (!this._initialized) return;
        if (this._howMany === 0) {
            this._resolve([]);
            return;
        }
        this._init$(undefined, -5);
        var isArrayResolved = isArray(this._values);
        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
    };
    SomePromiseArray.prototype.init = function() {
        this._initialized = true;
        this._init();
    };
    SomePromiseArray.prototype.setUnwrap = function() {
        this._unwrap = true;
    };
    SomePromiseArray.prototype.howMany = function() {
        return this._howMany;
    };
    SomePromiseArray.prototype.setHowMany = function(count) {
        this._howMany = count;
    };
    SomePromiseArray.prototype._promiseFulfilled = function(value) {
        this._addFulfilled(value);
        if (this._fulfilled() === this.howMany()) {
            this._values.length = this.howMany();
            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
            else this._resolve(this._values);
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._promiseRejected = function(reason) {
        this._addRejected(reason);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._promiseCancelled = function() {
        if (this._values instanceof Promise || this._values == null) return this._cancel();
        this._addRejected(CANCELLATION);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._checkOutcome = function() {
        if (this.howMany() > this._canPossiblyFulfill()) {
            var e = new AggregateError();
            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
            if (e.length > 0) this._reject(e);
            else this._cancel();
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._fulfilled = function() {
        return this._totalResolved;
    };
    SomePromiseArray.prototype._rejected = function() {
        return this._values.length - this.length();
    };
    SomePromiseArray.prototype._addRejected = function(reason) {
        this._values.push(reason);
    };
    SomePromiseArray.prototype._addFulfilled = function(value) {
        this._values[this._totalResolved++] = value;
    };
    SomePromiseArray.prototype._canPossiblyFulfill = function() {
        return this.length() - this._rejected();
    };
    SomePromiseArray.prototype._getRangeError = function(count) {
        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
        return new RangeError(message);
    };
    SomePromiseArray.prototype._resolveEmptyArray = function() {
        this._reject(this._getRangeError(0));
    };
    function some(promises, howMany) {
        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(howMany);
        ret.init();
        return promise;
    }
    Promise.some = function(promises, howMany) {
        return some(promises, howMany);
    };
    Promise.prototype.some = function(howMany) {
        return some(this, howMany);
    };
    Promise._SomePromiseArray = SomePromiseArray;
};

});

parcelRegister("5begG", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseMap = Promise.map;
    Promise.prototype.filter = function(fn, options) {
        return PromiseMap(this, fn, options, INTERNAL);
    };
    Promise.filter = function(promises, fn, options) {
        return PromiseMap(promises, fn, options, INTERNAL);
    };
};

});

parcelRegister("b7rK3", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseReduce = Promise.reduce;
    var PromiseAll = Promise.all;
    function promiseAllThis() {
        return PromiseAll(this);
    }
    function PromiseMapSeries(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
    }
    Promise.prototype.each = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
    };
    Promise.prototype.mapSeries = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
    };
    Promise.each = function(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
    };
    Promise.mapSeries = PromiseMapSeries;
};

});

parcelRegister("fLPkU", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var SomePromiseArray = Promise._SomePromiseArray;
    function any(promises) {
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(1);
        ret.setUnwrap();
        ret.init();
        return promise;
    }
    Promise.any = function(promises) {
        return any(promises);
    };
    Promise.prototype.any = function() {
        return any(this);
    };
};

});


parcelRegister("jxEQL", function(module, exports) {

$parcel$export(module.exports, "readString", function () { return $e3a0c95e2abae57e$export$dda73877cb166cd3; }, function (v) { return $e3a0c95e2abae57e$export$dda73877cb166cd3 = v; });
var $e3a0c95e2abae57e$export$dda73877cb166cd3;

var $d93yU = parcelRequire("d93yU");
parcelRequire("9jAvV");
var $bPbGS = parcelRequire("bPbGS");

var $jah0F = parcelRequire("jah0F");

var $doJbW = parcelRequire("doJbW");
var $e3a0c95e2abae57e$var$Element = $doJbW.Element;
$e3a0c95e2abae57e$export$dda73877cb166cd3 = $e3a0c95e2abae57e$var$readString;
var $e3a0c95e2abae57e$var$Node = $jah0F.Node;
function $e3a0c95e2abae57e$var$readString(xmlString, namespaceMap) {
    namespaceMap = namespaceMap || {};
    try {
        var document = $jah0F.parseFromString(xmlString, "text/xml");
    } catch (error) {
        return $d93yU.reject(error);
    }
    if (document.documentElement.tagName === "parsererror") return $d93yU.resolve(new Error(document.documentElement.textContent));
    function convertNode(node) {
        switch(node.nodeType){
            case $e3a0c95e2abae57e$var$Node.ELEMENT_NODE:
                return convertElement(node);
            case $e3a0c95e2abae57e$var$Node.TEXT_NODE:
                return $doJbW.text(node.nodeValue);
        }
    }
    function convertElement(element) {
        var convertedName = convertName(element);
        var convertedChildren = [];
        $bPbGS.default(element.childNodes, function(childNode) {
            var convertedNode = convertNode(childNode);
            if (convertedNode) convertedChildren.push(convertedNode);
        });
        var convertedAttributes = {};
        $bPbGS.default(element.attributes, function(attribute) {
            convertedAttributes[convertName(attribute)] = attribute.value;
        });
        return new $e3a0c95e2abae57e$var$Element(convertedName, convertedAttributes, convertedChildren);
    }
    function convertName(node) {
        if (node.namespaceURI) {
            var mappedPrefix = namespaceMap[node.namespaceURI];
            var prefix;
            if (mappedPrefix) prefix = mappedPrefix + ":";
            else prefix = "{" + node.namespaceURI + "}";
            return prefix + node.localName;
        } else return node.localName;
    }
    return $d93yU.resolve(convertNode(document.documentElement));
}

});
parcelRegister("d93yU", function(module, exports) {

$parcel$export(module.exports, "when", function () { return $991ee0f65a60b17a$export$a55877ca9db47377; }, function (v) { return $991ee0f65a60b17a$export$a55877ca9db47377 = v; });
$parcel$export(module.exports, "resolve", function () { return $991ee0f65a60b17a$export$f7ad0328861e2f03; }, function (v) { return $991ee0f65a60b17a$export$f7ad0328861e2f03 = v; });
$parcel$export(module.exports, "props", function () { return $991ee0f65a60b17a$export$8128bb6492cf3de7; }, function (v) { return $991ee0f65a60b17a$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "reject", function () { return $991ee0f65a60b17a$export$2800f3ceda99eb84; }, function (v) { return $991ee0f65a60b17a$export$2800f3ceda99eb84 = v; });
$parcel$export(module.exports, "mapSeries", function () { return $991ee0f65a60b17a$export$9a85c32cda85b0dd; }, function (v) { return $991ee0f65a60b17a$export$9a85c32cda85b0dd = v; });
$parcel$export(module.exports, "attempt", function () { return $991ee0f65a60b17a$export$77f9e426014f6edd; }, function (v) { return $991ee0f65a60b17a$export$77f9e426014f6edd = v; });
var $991ee0f65a60b17a$export$260e5c0943f31606;
var $991ee0f65a60b17a$export$a55877ca9db47377;
var $991ee0f65a60b17a$export$f7ad0328861e2f03;
var $991ee0f65a60b17a$export$84bf76cd7afc7469;
var $991ee0f65a60b17a$export$8128bb6492cf3de7;
var $991ee0f65a60b17a$export$2800f3ceda99eb84;
var $991ee0f65a60b17a$export$1d1d2ed6b55cf67f;
var $991ee0f65a60b17a$export$9a85c32cda85b0dd;
var $991ee0f65a60b17a$export$77f9e426014f6edd;
var $991ee0f65a60b17a$export$8429d1d5679bc81e;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");

var $991ee0f65a60b17a$var$bluebird = (parcelRequire("cKjOO"))();
$991ee0f65a60b17a$export$260e5c0943f31606 = $991ee0f65a60b17a$var$defer;
$991ee0f65a60b17a$export$a55877ca9db47377 = $991ee0f65a60b17a$var$bluebird.resolve;
$991ee0f65a60b17a$export$f7ad0328861e2f03 = $991ee0f65a60b17a$var$bluebird.resolve;
$991ee0f65a60b17a$export$84bf76cd7afc7469 = $991ee0f65a60b17a$var$bluebird.all;
$991ee0f65a60b17a$export$8128bb6492cf3de7 = $991ee0f65a60b17a$var$bluebird.props;
$991ee0f65a60b17a$export$2800f3ceda99eb84 = $991ee0f65a60b17a$var$bluebird.reject;
$991ee0f65a60b17a$export$1d1d2ed6b55cf67f = $991ee0f65a60b17a$var$bluebird.promisify;
$991ee0f65a60b17a$export$9a85c32cda85b0dd = $991ee0f65a60b17a$var$bluebird.mapSeries;
$991ee0f65a60b17a$export$77f9e426014f6edd = $991ee0f65a60b17a$var$bluebird.attempt;
$991ee0f65a60b17a$export$8429d1d5679bc81e = function(func) {
    var args = Array.prototype.slice.call(arguments, 1);
    var promisedFunc = $991ee0f65a60b17a$var$bluebird.promisify(func);
    return promisedFunc.apply(null, args);
};
$991ee0f65a60b17a$var$bluebird.prototype.fail = $991ee0f65a60b17a$var$bluebird.prototype.caught;
$991ee0f65a60b17a$var$bluebird.prototype.also = function(func) {
    return this.then(function(value) {
        var returnValue = $5yjjJ.default({}, value, func(value));
        return $991ee0f65a60b17a$var$bluebird.props(returnValue);
    });
};
function $991ee0f65a60b17a$var$defer() {
    var resolve;
    var reject;
    var promise = new $991ee0f65a60b17a$var$bluebird.Promise(function(resolveArg, rejectArg) {
        resolve = resolveArg;
        reject = rejectArg;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}

});
parcelRegister("9jAvV", function(module, exports) {
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $dxtty = parcelRequire("dxtty");

var $hMAdV = parcelRequire("hMAdV");
$parcel$exportWildcard(module.exports, $hMAdV);

});
parcelRegister("dxtty", function(module, exports) {
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("hMAdV");
var $j2rdI = parcelRequire("j2rdI");
var $hMAdV = parcelRequire("hMAdV");
// Add all of the Underscore functions to the wrapper object.
var $9db538b41c10062f$var$_ = (0, $j2rdI.default)($hMAdV);
// Legacy Node.js API.
$9db538b41c10062f$var$_._ = $9db538b41c10062f$var$_;
var // Export the Underscore API.
$9db538b41c10062f$export$2e2bcd8739ae039 = $9db538b41c10062f$var$_;

});
parcelRegister("hMAdV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("lKa0l")).VERSION; });
$parcel$export(module.exports, "restArguments", function () { return (parcelRequire("cutdK")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("dYssA")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("7WZB1")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("j3POm")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("aY7I7")).default; });
$parcel$export(module.exports, "isElement", function () { return (parcelRequire("euF0v")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("jmGFg")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("1KDWp")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("8e2WD")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("cCZdY")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("3bgcR")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("jBakT")).default; });
$parcel$export(module.exports, "isArrayBuffer", function () { return (parcelRequire("lxQta")).default; });
$parcel$export(module.exports, "isDataView", function () { return (parcelRequire("icElx")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("3rBlz")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("ciHuQ")).default; });
$parcel$export(module.exports, "isArguments", function () { return (parcelRequire("g7r4I")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("3fPql")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("5hVse")).default; });
$parcel$export(module.exports, "isTypedArray", function () { return (parcelRequire("dt9Az")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("15h2w")).default; });
$parcel$export(module.exports, "isMatch", function () { return (parcelRequire("d6SxQ")).default; });
$parcel$export(module.exports, "isEqual", function () { return (parcelRequire("8C01Z")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("4okfY")).default; });
$parcel$export(module.exports, "isWeakMap", function () { return (parcelRequire("fchA7")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("axeJL")).default; });
$parcel$export(module.exports, "isWeakSet", function () { return (parcelRequire("32ogZ")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("4LWsK")).default; });
$parcel$export(module.exports, "allKeys", function () { return (parcelRequire("jZVkW")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("gNJrf")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("6u5iL")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("loFvT")).default; });
$parcel$export(module.exports, "functions", function () { return (parcelRequire("l07og")).default; });
$parcel$export(module.exports, "methods", function () { return (parcelRequire("l07og")).default; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("5yjjJ")).default; });
$parcel$export(module.exports, "extendOwn", function () { return (parcelRequire("dlMHj")).default; });
$parcel$export(module.exports, "assign", function () { return (parcelRequire("dlMHj")).default; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("euU6m")).default; });
$parcel$export(module.exports, "create", function () { return (parcelRequire("lCMkx")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("5mG2j")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("coY6d")).default; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("bnzgB")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("jF7N8")).default; });
$parcel$export(module.exports, "mapObject", function () { return (parcelRequire("dVbMh")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("3Ft8y")).default; });
$parcel$export(module.exports, "constant", function () { return (parcelRequire("2bZSn")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("3xRL4")).default; });
$parcel$export(module.exports, "toPath", function () { return (parcelRequire("86pzb")).default; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("cVGk0")).default; });
$parcel$export(module.exports, "propertyOf", function () { return (parcelRequire("4H9Bb")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("fWh3j")).default; });
$parcel$export(module.exports, "matches", function () { return (parcelRequire("fWh3j")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("g62W6")).default; });
$parcel$export(module.exports, "random", function () { return (parcelRequire("5ImvW")).default; });
$parcel$export(module.exports, "now", function () { return (parcelRequire("ci2Hm")).default; });
$parcel$export(module.exports, "escape", function () { return (parcelRequire("cVKPu")).default; });
$parcel$export(module.exports, "unescape", function () { return (parcelRequire("fhZ4W")).default; });
$parcel$export(module.exports, "templateSettings", function () { return (parcelRequire("ibdiz")).default; });
$parcel$export(module.exports, "template", function () { return (parcelRequire("aQvus")).default; });
$parcel$export(module.exports, "result", function () { return (parcelRequire("aaIUq")).default; });
$parcel$export(module.exports, "uniqueId", function () { return (parcelRequire("ijUFs")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("1Jw0L")).default; });
$parcel$export(module.exports, "iteratee", function () { return (parcelRequire("4THUh")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("57hXU")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("87tT8")).default; });
$parcel$export(module.exports, "bindAll", function () { return (parcelRequire("aDTbd")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("iW6qG")).default; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("dMNsc")).default; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("jzlx4")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("4olrn")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("j6hEX")).default; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("boUYN")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("fEZb2")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("g6hdv")).default; });
$parcel$export(module.exports, "after", function () { return (parcelRequire("6JKsG")).default; });
$parcel$export(module.exports, "before", function () { return (parcelRequire("i0BUd")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("l46qR")).default; });
$parcel$export(module.exports, "findKey", function () { return (parcelRequire("2qFVg")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("e2Yic")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("iL92E")).default; });
$parcel$export(module.exports, "sortedIndex", function () { return (parcelRequire("ghC52")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("5YGUS")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("3fsu4")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("bss2W")).default; });
$parcel$export(module.exports, "detect", function () { return (parcelRequire("bss2W")).default; });
$parcel$export(module.exports, "findWhere", function () { return (parcelRequire("emdBE")).default; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("bPbGS")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("bPbGS")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("gfTwJ")).default; });
$parcel$export(module.exports, "collect", function () { return (parcelRequire("gfTwJ")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "foldl", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("6BBNz")).default; });
$parcel$export(module.exports, "foldr", function () { return (parcelRequire("6BBNz")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("efEt3")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("efEt3")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("8BknA")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("22GE8")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("22GE8")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("ctpBH")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("ctpBH")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "include", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("kDigY")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("gS9W9")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("9zRTj")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("fUZrG")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("2OrAw")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("jujdW")).default; });
$parcel$export(module.exports, "sample", function () { return (parcelRequire("3k55B")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("eVdJn")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("dqbTp")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("bJcvr")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("bRnHN")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("2fwpY")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("1N8dN")).default; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("iTCYf")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("3fpzD")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("jrEl1")).default; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "initial", function () { return (parcelRequire("c4yYd")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("hB3Xt")).default; });
$parcel$export(module.exports, "rest", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("ees8X")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("1TwZj")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("5jrxQ")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("iUtSI")).default; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("iUtSI")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("1XgTs")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("2ycy0")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("89CXs")).default; });
$parcel$export(module.exports, "unzip", function () { return (parcelRequire("e9qP4")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("e9qP4")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("8DaDZ")).default; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("kdGCR")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("ds2Lz")).default; });
$parcel$export(module.exports, "chunk", function () { return (parcelRequire("idngN")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("j2rdI")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("OKn95")).default; });
// Named Exports
// =============
//     Underscore.js 1.13.8
//     https://underscorejs.org
//     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $lKa0l = parcelRequire("lKa0l");

var $cutdK = parcelRequire("cutdK");

var $dYssA = parcelRequire("dYssA");

var $7WZB1 = parcelRequire("7WZB1");

var $j3POm = parcelRequire("j3POm");

var $aY7I7 = parcelRequire("aY7I7");

var $euF0v = parcelRequire("euF0v");

var $jmGFg = parcelRequire("jmGFg");

var $1KDWp = parcelRequire("1KDWp");

var $8e2WD = parcelRequire("8e2WD");

var $cCZdY = parcelRequire("cCZdY");

var $3bgcR = parcelRequire("3bgcR");

var $jBakT = parcelRequire("jBakT");

var $lxQta = parcelRequire("lxQta");

var $icElx = parcelRequire("icElx");

var $3rBlz = parcelRequire("3rBlz");

var $ciHuQ = parcelRequire("ciHuQ");

var $g7r4I = parcelRequire("g7r4I");

var $3fPql = parcelRequire("3fPql");

var $5hVse = parcelRequire("5hVse");

var $dt9Az = parcelRequire("dt9Az");

var $15h2w = parcelRequire("15h2w");

var $d6SxQ = parcelRequire("d6SxQ");

var $8C01Z = parcelRequire("8C01Z");

var $4okfY = parcelRequire("4okfY");

var $fchA7 = parcelRequire("fchA7");

var $axeJL = parcelRequire("axeJL");

var $32ogZ = parcelRequire("32ogZ");

var $4LWsK = parcelRequire("4LWsK");

var $jZVkW = parcelRequire("jZVkW");

var $gNJrf = parcelRequire("gNJrf");

var $6u5iL = parcelRequire("6u5iL");

var $loFvT = parcelRequire("loFvT");

var $l07og = parcelRequire("l07og");

var $5yjjJ = parcelRequire("5yjjJ");

var $dlMHj = parcelRequire("dlMHj");

var $euU6m = parcelRequire("euU6m");

var $lCMkx = parcelRequire("lCMkx");

var $5mG2j = parcelRequire("5mG2j");

var $coY6d = parcelRequire("coY6d");

var $bnzgB = parcelRequire("bnzgB");

var $jF7N8 = parcelRequire("jF7N8");

var $dVbMh = parcelRequire("dVbMh");

var $3Ft8y = parcelRequire("3Ft8y");

var $2bZSn = parcelRequire("2bZSn");

var $3xRL4 = parcelRequire("3xRL4");

var $86pzb = parcelRequire("86pzb");

var $cVGk0 = parcelRequire("cVGk0");

var $4H9Bb = parcelRequire("4H9Bb");

var $fWh3j = parcelRequire("fWh3j");

var $g62W6 = parcelRequire("g62W6");

var $5ImvW = parcelRequire("5ImvW");

var $ci2Hm = parcelRequire("ci2Hm");

var $cVKPu = parcelRequire("cVKPu");

var $fhZ4W = parcelRequire("fhZ4W");

var $ibdiz = parcelRequire("ibdiz");

var $aQvus = parcelRequire("aQvus");

var $aaIUq = parcelRequire("aaIUq");

var $ijUFs = parcelRequire("ijUFs");

var $1Jw0L = parcelRequire("1Jw0L");

var $4THUh = parcelRequire("4THUh");

var $57hXU = parcelRequire("57hXU");

var $87tT8 = parcelRequire("87tT8");

var $aDTbd = parcelRequire("aDTbd");

var $iW6qG = parcelRequire("iW6qG");

var $dMNsc = parcelRequire("dMNsc");

var $jzlx4 = parcelRequire("jzlx4");

var $4olrn = parcelRequire("4olrn");

var $j6hEX = parcelRequire("j6hEX");

var $boUYN = parcelRequire("boUYN");

var $fEZb2 = parcelRequire("fEZb2");

var $g6hdv = parcelRequire("g6hdv");

var $6JKsG = parcelRequire("6JKsG");

var $i0BUd = parcelRequire("i0BUd");

var $l46qR = parcelRequire("l46qR");

var $2qFVg = parcelRequire("2qFVg");

var $e2Yic = parcelRequire("e2Yic");

var $iL92E = parcelRequire("iL92E");

var $ghC52 = parcelRequire("ghC52");

var $5YGUS = parcelRequire("5YGUS");

var $3fsu4 = parcelRequire("3fsu4");

var $bss2W = parcelRequire("bss2W");

var $emdBE = parcelRequire("emdBE");

var $bPbGS = parcelRequire("bPbGS");

var $gfTwJ = parcelRequire("gfTwJ");

var $jD3Ao = parcelRequire("jD3Ao");

var $6BBNz = parcelRequire("6BBNz");

var $efEt3 = parcelRequire("efEt3");

var $8BknA = parcelRequire("8BknA");

var $22GE8 = parcelRequire("22GE8");

var $ctpBH = parcelRequire("ctpBH");

var $9z2eX = parcelRequire("9z2eX");

var $kDigY = parcelRequire("kDigY");

var $gS9W9 = parcelRequire("gS9W9");

var $9zRTj = parcelRequire("9zRTj");

var $fUZrG = parcelRequire("fUZrG");

var $2OrAw = parcelRequire("2OrAw");

var $jujdW = parcelRequire("jujdW");

var $3k55B = parcelRequire("3k55B");

var $eVdJn = parcelRequire("eVdJn");

var $dqbTp = parcelRequire("dqbTp");

var $bJcvr = parcelRequire("bJcvr");

var $bRnHN = parcelRequire("bRnHN");

var $2fwpY = parcelRequire("2fwpY");

var $1N8dN = parcelRequire("1N8dN");

var $iTCYf = parcelRequire("iTCYf");

var $3fpzD = parcelRequire("3fpzD");

var $jrEl1 = parcelRequire("jrEl1");

var $fcTdF = parcelRequire("fcTdF");

var $c4yYd = parcelRequire("c4yYd");

var $hB3Xt = parcelRequire("hB3Xt");

var $2lrEW = parcelRequire("2lrEW");

var $ees8X = parcelRequire("ees8X");

var $1TwZj = parcelRequire("1TwZj");

var $5jrxQ = parcelRequire("5jrxQ");

var $iUtSI = parcelRequire("iUtSI");

var $1XgTs = parcelRequire("1XgTs");

var $2ycy0 = parcelRequire("2ycy0");

var $89CXs = parcelRequire("89CXs");

var $e9qP4 = parcelRequire("e9qP4");

var $8DaDZ = parcelRequire("8DaDZ");

var $kdGCR = parcelRequire("kdGCR");

var $ds2Lz = parcelRequire("ds2Lz");

var $idngN = parcelRequire("idngN");

var $j2rdI = parcelRequire("j2rdI");

var $OKn95 = parcelRequire("OKn95");

});
parcelRegister("lKa0l", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $fd45a78d45b76e49$export$a4ad2735b021c132; });
$parcel$export(module.exports, "root", function () { return $fd45a78d45b76e49$export$e8e78c978b129247; });
$parcel$export(module.exports, "ArrayProto", function () { return $fd45a78d45b76e49$export$aabeece9448a227a; });
$parcel$export(module.exports, "ObjProto", function () { return $fd45a78d45b76e49$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "SymbolProto", function () { return $fd45a78d45b76e49$export$e229dcb397ceea81; });
$parcel$export(module.exports, "push", function () { return $fd45a78d45b76e49$export$4cbf152802aa238; });
$parcel$export(module.exports, "slice", function () { return $fd45a78d45b76e49$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "toString", function () { return $fd45a78d45b76e49$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $fd45a78d45b76e49$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "supportsArrayBuffer", function () { return $fd45a78d45b76e49$export$20eaf89d899ede58; });
$parcel$export(module.exports, "supportsDataView", function () { return $fd45a78d45b76e49$export$a2e478ad34dac33e; });
$parcel$export(module.exports, "nativeIsArray", function () { return $fd45a78d45b76e49$export$552cf9b635cef256; });
$parcel$export(module.exports, "nativeKeys", function () { return $fd45a78d45b76e49$export$e676cf06d7fd2114; });
$parcel$export(module.exports, "nativeCreate", function () { return $fd45a78d45b76e49$export$5b53dc95b548c58c; });
$parcel$export(module.exports, "nativeIsView", function () { return $fd45a78d45b76e49$export$35fc70fc5e80d5a7; });
$parcel$export(module.exports, "_isNaN", function () { return $fd45a78d45b76e49$export$a739ba33a90be0a1; });
$parcel$export(module.exports, "_isFinite", function () { return $fd45a78d45b76e49$export$8b48b92f6c9d5ad; });
$parcel$export(module.exports, "hasEnumBug", function () { return $fd45a78d45b76e49$export$7dcea4d27900b116; });
$parcel$export(module.exports, "nonEnumerableProps", function () { return $fd45a78d45b76e49$export$f8fa596d5e31cb19; });
$parcel$export(module.exports, "MAX_ARRAY_INDEX", function () { return $fd45a78d45b76e49$export$63b3abc5cd28bc48; });
// Current version.
var $fd45a78d45b76e49$export$a4ad2735b021c132 = '1.13.8';
var $fd45a78d45b76e49$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $fd45a78d45b76e49$export$aabeece9448a227a = Array.prototype, $fd45a78d45b76e49$export$e77bb59b5e655b3d = Object.prototype;
var $fd45a78d45b76e49$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $fd45a78d45b76e49$export$4cbf152802aa238 = $fd45a78d45b76e49$export$aabeece9448a227a.push, $fd45a78d45b76e49$export$58adb3bec8346d0f = $fd45a78d45b76e49$export$aabeece9448a227a.slice, $fd45a78d45b76e49$export$f84e8e69fd4488a5 = $fd45a78d45b76e49$export$e77bb59b5e655b3d.toString, $fd45a78d45b76e49$export$5a15a386532a5ea4 = $fd45a78d45b76e49$export$e77bb59b5e655b3d.hasOwnProperty;
var $fd45a78d45b76e49$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $fd45a78d45b76e49$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $fd45a78d45b76e49$export$552cf9b635cef256 = Array.isArray, $fd45a78d45b76e49$export$e676cf06d7fd2114 = Object.keys, $fd45a78d45b76e49$export$5b53dc95b548c58c = Object.create, $fd45a78d45b76e49$export$35fc70fc5e80d5a7 = $fd45a78d45b76e49$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $fd45a78d45b76e49$export$a739ba33a90be0a1 = isNaN, $fd45a78d45b76e49$export$8b48b92f6c9d5ad = isFinite;
var $fd45a78d45b76e49$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $fd45a78d45b76e49$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $fd45a78d45b76e49$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("cutdK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $917ef4036c6c5a35$export$2e2bcd8739ae039; });
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $917ef4036c6c5a35$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("dYssA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a01cb7f883ee65$export$2e2bcd8739ae039; });
// Is a given variable an object?
function $02a01cb7f883ee65$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("7WZB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9dbae7df9c123e$export$2e2bcd8739ae039; });
// Is a given value equal to null?
function $5c9dbae7df9c123e$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("j3POm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de067cc8b883de9a$export$2e2bcd8739ae039; });
// Is a given variable undefined?
function $de067cc8b883de9a$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("aY7I7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fc57d1fa6a647f7$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $7fc57d1fa6a647f7$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $lKa0l.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("euF0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d3ad38baef3f2d$export$2e2bcd8739ae039; });
// Is a given value a DOM element?
function $a8d3ad38baef3f2d$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("jmGFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1912aae5bd6172e$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $e1912aae5bd6172e$export$2e2bcd8739ae039 = (0, $kaO6k.default)('String');

});
parcelRegister("kaO6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eafb9ad7fb62d71d$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $eafb9ad7fb62d71d$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $lKa0l.toString).call(obj) === tag;
    };
}

});


parcelRegister("1KDWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146911c9abe54fd6$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $146911c9abe54fd6$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Number');

});

parcelRegister("8e2WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd1ea4e094f2268$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $5fd1ea4e094f2268$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Date');

});

parcelRegister("cCZdY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93188688681a4ed7$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $93188688681a4ed7$export$2e2bcd8739ae039 = (0, $kaO6k.default)('RegExp');

});

parcelRegister("3bgcR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250ef87289f29527$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $250ef87289f29527$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Error');

});

parcelRegister("jBakT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4497d8698f85f63$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $e4497d8698f85f63$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Symbol');

});

parcelRegister("lxQta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf5615e5fcf5db2$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $faf5615e5fcf5db2$export$2e2bcd8739ae039 = (0, $kaO6k.default)('ArrayBuffer');

});

parcelRegister("icElx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d408a4f40d858b2f$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $ciHuQ = parcelRequire("ciHuQ");

var $lxQta = parcelRequire("lxQta");

var $a227F = parcelRequire("a227F");
var $d408a4f40d858b2f$var$isDataView = (0, $kaO6k.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $d408a4f40d858b2f$var$alternateIsDataView(obj) {
    return obj != null && (0, $ciHuQ.default)(obj.getInt8) && (0, $lxQta.default)(obj.buffer);
}
var $d408a4f40d858b2f$export$2e2bcd8739ae039 = (0, $a227F.hasDataViewBug) ? $d408a4f40d858b2f$var$alternateIsDataView : $d408a4f40d858b2f$var$isDataView;

});
parcelRegister("ciHuQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f48e7fdff0325a3$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $lKa0l = parcelRequire("lKa0l");
var $8f48e7fdff0325a3$var$isFunction = (0, $kaO6k.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $8f48e7fdff0325a3$var$nodelist = (0, $lKa0l.root).document && (0, $lKa0l.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $8f48e7fdff0325a3$var$nodelist != 'function') $8f48e7fdff0325a3$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $8f48e7fdff0325a3$export$2e2bcd8739ae039 = $8f48e7fdff0325a3$var$isFunction;

});

parcelRegister("a227F", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", function () { return $74dbbccfad5f06a0$export$29b9ed4126fa90ab; });
$parcel$export(module.exports, "isIE11", function () { return $74dbbccfad5f06a0$export$f7bad96d83325a34; });

var $lKa0l = parcelRequire("lKa0l");

var $deY0B = parcelRequire("deY0B");
var $74dbbccfad5f06a0$export$29b9ed4126fa90ab = (0, $lKa0l.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $deY0B.default)(new DataView(new ArrayBuffer(8)))), $74dbbccfad5f06a0$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $deY0B.default)(new Map);

});
parcelRegister("deY0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a3b21a767ce281d$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $9a3b21a767ce281d$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Object');

});



parcelRegister("3rBlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2820dd0e65ff89bf$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $kaO6k = parcelRequire("kaO6k");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$2820dd0e65ff89bf$export$2e2bcd8739ae039 = (0, $lKa0l.nativeIsArray) || (0, $kaO6k.default)('Array');

});

parcelRegister("g7r4I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbc24d55df6be415$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $iFtQd = parcelRequire("iFtQd");
var $bbc24d55df6be415$var$isArguments = (0, $kaO6k.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$bbc24d55df6be415$var$isArguments(arguments)) $bbc24d55df6be415$var$isArguments = function(obj) {
        return (0, $iFtQd.default)(obj, 'callee');
    };
})();
var $bbc24d55df6be415$export$2e2bcd8739ae039 = $bbc24d55df6be415$var$isArguments;

});
parcelRegister("iFtQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9733427d810fc85$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $d9733427d810fc85$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $lKa0l.hasOwnProperty).call(obj, key);
}

});


parcelRegister("3fPql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25eaa98a301eb170$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $jBakT = parcelRequire("jBakT");
function $25eaa98a301eb170$export$2e2bcd8739ae039(obj) {
    return !(0, $jBakT.default)(obj) && (0, $lKa0l._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("5hVse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d9b1b881ae2a14d$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $1KDWp = parcelRequire("1KDWp");
function $3d9b1b881ae2a14d$export$2e2bcd8739ae039(obj) {
    return (0, $1KDWp.default)(obj) && (0, $lKa0l._isNaN)(obj);
}

});

parcelRegister("dt9Az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ce56beae01cdc5a$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $icElx = parcelRequire("icElx");

var $2bZSn = parcelRequire("2bZSn");

var $3EMBS = parcelRequire("3EMBS");
// Is a given value a typed array?
var $9ce56beae01cdc5a$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $9ce56beae01cdc5a$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $lKa0l.nativeIsView) ? (0, $lKa0l.nativeIsView)(obj) && !(0, $icElx.default)(obj) : (0, $3EMBS.default)(obj) && $9ce56beae01cdc5a$var$typedArrayPattern.test((0, $lKa0l.toString).call(obj));
}
var $9ce56beae01cdc5a$export$2e2bcd8739ae039 = (0, $lKa0l.supportsArrayBuffer) ? $9ce56beae01cdc5a$var$isTypedArray : (0, $2bZSn.default)(false);

});
parcelRegister("2bZSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $198c9b253a5a7550$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $198c9b253a5a7550$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("3EMBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a9ad0721604b89c$export$2e2bcd8739ae039; });

var $2KQXF = parcelRequire("2KQXF");

var $4irFB = parcelRequire("4irFB");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$2a9ad0721604b89c$export$2e2bcd8739ae039 = (0, $2KQXF.default)((0, $4irFB.default));

});
parcelRegister("2KQXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2018f5aa0195bc45$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $2018f5aa0195bc45$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $lKa0l.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("4irFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e4e8cb0e3d61b$export$2e2bcd8739ae039; });

var $6UQLi = parcelRequire("6UQLi");
var // Internal helper to obtain the `byteLength` property of an object.
$320e4e8cb0e3d61b$export$2e2bcd8739ae039 = (0, $6UQLi.default)('byteLength');

});
parcelRegister("6UQLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5090e671bd4d0504$export$2e2bcd8739ae039; });
// Internal helper to generate a function to obtain property `key` from `obj`.
function $5090e671bd4d0504$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("15h2w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ca379c9fa8199fb$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $3rBlz = parcelRequire("3rBlz");

var $jmGFg = parcelRequire("jmGFg");

var $g7r4I = parcelRequire("g7r4I");

var $4LWsK = parcelRequire("4LWsK");
function $0ca379c9fa8199fb$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $ikQKR.default)(obj);
    if (typeof length == 'number' && ((0, $3rBlz.default)(obj) || (0, $jmGFg.default)(obj) || (0, $g7r4I.default)(obj))) return length === 0;
    return (0, $ikQKR.default)((0, $4LWsK.default)(obj)) === 0;
}

});
parcelRegister("ikQKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59304448fb7f1b2$export$2e2bcd8739ae039; });

var $6UQLi = parcelRequire("6UQLi");
var // Internal helper to obtain the `length` property of an object.
$d59304448fb7f1b2$export$2e2bcd8739ae039 = (0, $6UQLi.default)('length');

});

parcelRegister("4LWsK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3798e6b1c8ea6498$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");

var $iFtQd = parcelRequire("iFtQd");

var $gviFy = parcelRequire("gviFy");
function $3798e6b1c8ea6498$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return [];
    if (0, $lKa0l.nativeKeys) return (0, $lKa0l.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $iFtQd.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $lKa0l.hasEnumBug) (0, $gviFy.default)(obj, keys);
    return keys;
}

});
parcelRegister("gviFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c03e05e62ea77cff$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $ciHuQ = parcelRequire("ciHuQ");

var $iFtQd = parcelRequire("iFtQd");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $c03e05e62ea77cff$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $c03e05e62ea77cff$export$2e2bcd8739ae039(obj, keys) {
    keys = $c03e05e62ea77cff$var$emulatedSet(keys);
    var nonEnumIdx = (0, $lKa0l.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $ciHuQ.default)(constructor) && constructor.prototype || (0, $lKa0l.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $iFtQd.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $lKa0l.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("d6SxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b62560df0e6e12$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $98b62560df0e6e12$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $4LWsK.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("8C01Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6451e588103ae5e6$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $lKa0l = parcelRequire("lKa0l");

var $4irFB = parcelRequire("4irFB");

var $dt9Az = parcelRequire("dt9Az");

var $ciHuQ = parcelRequire("ciHuQ");

var $a227F = parcelRequire("a227F");

var $icElx = parcelRequire("icElx");

var $4LWsK = parcelRequire("4LWsK");

var $iFtQd = parcelRequire("iFtQd");

var $3Dbqh = parcelRequire("3Dbqh");
// We use this string twice, so give it a name for minification.
var $6451e588103ae5e6$var$tagDataView = '[object DataView]';
function $6451e588103ae5e6$export$2e2bcd8739ae039(a, b) {
    var todo = [
        {
            a: a,
            b: b
        }
    ];
    // Initializing stacks of traversed objects for cycle detection.
    var aStack = [], bStack = [];
    while(todo.length){
        var frame = todo.pop();
        if (frame === true) {
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            continue;
        }
        a = frame.a;
        b = frame.b;
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) {
            if (a !== 0 || 1 / a === 1 / b) continue;
            return false;
        }
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) {
            if (b !== b) continue;
            return false;
        }
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
        // Internal recursive comparison function for `_.isEqual`.
        // Unwrap any wrapped objects.
        if (a instanceof (0, $tYVIv.default)) a = a._wrapped;
        if (b instanceof (0, $tYVIv.default)) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = (0, $lKa0l.toString).call(a);
        if (className !== (0, $lKa0l.toString).call(b)) return false;
        // Work around a bug in IE 10 - Edge 13.
        if ((0, $a227F.hasDataViewBug) && className == '[object Object]' && (0, $icElx.default)(a)) {
            if (!(0, $icElx.default)(b)) return false;
            className = $6451e588103ae5e6$var$tagDataView;
        }
        switch(className){
            // These types are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                if ('' + a === '' + b) continue;
                return false;
            case '[object Number]':
                todo.push({
                    a: +a,
                    b: +b
                });
                continue;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                if (+a === +b) continue;
                return false;
            case '[object Symbol]':
                if ((0, $lKa0l.SymbolProto).valueOf.call(a) === (0, $lKa0l.SymbolProto).valueOf.call(b)) continue;
                return false;
            case '[object ArrayBuffer]':
            case $6451e588103ae5e6$var$tagDataView:
                // Coerce to typed array so we can fall through.
                todo.push({
                    a: (0, $3Dbqh.default)(a),
                    b: (0, $3Dbqh.default)(b)
                });
                continue;
        }
        var areArrays = className === '[object Array]';
        if (!areArrays && (0, $dt9Az.default)(a)) {
            var byteLength = (0, $4irFB.default)(a);
            if (byteLength !== (0, $4irFB.default)(b)) return false;
            if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) continue;
            areArrays = true;
        }
        if (!areArrays) {
            if (typeof a != 'object' || typeof b != 'object') return false;
            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !((0, $ciHuQ.default)(aCtor) && aCtor instanceof aCtor && (0, $ciHuQ.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        var length = aStack.length;
        while(length--)// Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) {
            if (bStack[length] === b) break;
            return false;
        }
        if (length >= 0) continue;
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        todo.push(true);
        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while(length--)todo.push({
                a: a[length],
                b: b[length]
            });
        } else {
            // Deep compare objects.
            var _keys = (0, $4LWsK.default)(a), key;
            length = _keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if ((0, $4LWsK.default)(b).length !== length) return false;
            while(length--){
                // Deep compare each member
                key = _keys[length];
                if (!(0, $iFtQd.default)(b, key)) return false;
                todo.push({
                    a: a[key],
                    b: b[key]
                });
            }
        }
    }
    return true;
}

});
parcelRegister("tYVIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a1f8f5f6aa68c7$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $05a1f8f5f6aa68c7$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $05a1f8f5f6aa68c7$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $05a1f8f5f6aa68c7$export$2e2bcd8739ae039)) return new $05a1f8f5f6aa68c7$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.VERSION = (0, $lKa0l.VERSION);
// Extracts the result from a wrapped and chained object.
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.valueOf = $05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.toJSON = $05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.value;
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("3Dbqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4ddff2e0a81a69$export$2e2bcd8739ae039; });

var $4irFB = parcelRequire("4irFB");
function $2a4ddff2e0a81a69$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $4irFB.default)(bufferSource));
}

});


parcelRegister("4okfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33291ddd8a7d055e$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $33291ddd8a7d055e$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.mapMethods)) : (0, $kaO6k.default)('Map');

});
parcelRegister("aunrg", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", function () { return $7a2ee33154ac74ff$export$15230eca1f400e40; });
$parcel$export(module.exports, "weakMapMethods", function () { return $7a2ee33154ac74ff$export$2f74b890a72cf48; });
$parcel$export(module.exports, "mapMethods", function () { return $7a2ee33154ac74ff$export$de9acb94190bb764; });
$parcel$export(module.exports, "setMethods", function () { return $7a2ee33154ac74ff$export$60e14a5e2a057f78; });

var $ikQKR = parcelRequire("ikQKR");

var $ciHuQ = parcelRequire("ciHuQ");

var $jZVkW = parcelRequire("jZVkW");
function $7a2ee33154ac74ff$export$15230eca1f400e40(methods) {
    var length = (0, $ikQKR.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $jZVkW.default)(obj);
        if ((0, $ikQKR.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $ciHuQ.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $7a2ee33154ac74ff$export$2f74b890a72cf48 || !(0, $ciHuQ.default)(obj[$7a2ee33154ac74ff$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $7a2ee33154ac74ff$var$forEachName = 'forEach', $7a2ee33154ac74ff$var$hasName = 'has', $7a2ee33154ac74ff$var$commonInit = [
    'clear',
    'delete'
], $7a2ee33154ac74ff$var$mapTail = [
    'get',
    $7a2ee33154ac74ff$var$hasName,
    'set'
];
var $7a2ee33154ac74ff$export$de9acb94190bb764 = $7a2ee33154ac74ff$var$commonInit.concat($7a2ee33154ac74ff$var$forEachName, $7a2ee33154ac74ff$var$mapTail), $7a2ee33154ac74ff$export$2f74b890a72cf48 = $7a2ee33154ac74ff$var$commonInit.concat($7a2ee33154ac74ff$var$mapTail), $7a2ee33154ac74ff$export$60e14a5e2a057f78 = [
    'add'
].concat($7a2ee33154ac74ff$var$commonInit, $7a2ee33154ac74ff$var$forEachName, $7a2ee33154ac74ff$var$hasName);

});
parcelRegister("jZVkW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f030bc7ef3ef30$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");

var $gviFy = parcelRequire("gviFy");
function $e8f030bc7ef3ef30$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $lKa0l.hasEnumBug) (0, $gviFy.default)(obj, keys);
    return keys;
}

});



parcelRegister("fchA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1059d5068e79eb4$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $b1059d5068e79eb4$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.weakMapMethods)) : (0, $kaO6k.default)('WeakMap');

});

parcelRegister("axeJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab86af64a0a33ee$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $7ab86af64a0a33ee$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.setMethods)) : (0, $kaO6k.default)('Set');

});

parcelRegister("32ogZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $236463227a08cef1$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $236463227a08cef1$export$2e2bcd8739ae039 = (0, $kaO6k.default)('WeakSet');

});

parcelRegister("gNJrf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b47810725b204d$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $c3b47810725b204d$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $4LWsK.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("6u5iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b89a83258ce913c$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $4b89a83258ce913c$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $4LWsK.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("loFvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f93c0a8ce98119b4$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $f93c0a8ce98119b4$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $4LWsK.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("l07og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f49f549e92d6c158$export$2e2bcd8739ae039; });

var $ciHuQ = parcelRequire("ciHuQ");
function $f49f549e92d6c158$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $ciHuQ.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("5yjjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40af1cbfa1b864a6$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $jZVkW = parcelRequire("jZVkW");
var // Extend a given object with all the properties in passed-in object(s).
$40af1cbfa1b864a6$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $jZVkW.default));

});
parcelRegister("82Out", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db5acfbcc83b687$export$2e2bcd8739ae039; });
// An internal function for creating assigner functions.
function $5db5acfbcc83b687$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("dlMHj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8302d5d30fe52c$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $4LWsK = parcelRequire("4LWsK");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$9b8302d5d30fe52c$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $4LWsK.default));

});

parcelRegister("euU6m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8df62a94007042d$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $jZVkW = parcelRequire("jZVkW");
var // Fill in a given object with default properties.
$a8df62a94007042d$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $jZVkW.default), true);

});

parcelRegister("lCMkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbe2a2f3394297f2$export$2e2bcd8739ae039; });

var $k4rnP = parcelRequire("k4rnP");

var $dlMHj = parcelRequire("dlMHj");
function $fbe2a2f3394297f2$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $k4rnP.default)(prototype);
    if (props) (0, $dlMHj.default)(result, props);
    return result;
}

});
parcelRegister("k4rnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9c96c21cac81316$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");
// Create a naked function reference for surrogate-prototype-swapping.
function $e9c96c21cac81316$var$ctor() {
    return function() {};
}
function $e9c96c21cac81316$export$2e2bcd8739ae039(prototype) {
    if (!(0, $dYssA.default)(prototype)) return {};
    if (0, $lKa0l.nativeCreate) return (0, $lKa0l.nativeCreate)(prototype);
    var Ctor = $e9c96c21cac81316$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("5mG2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e7f9d584d5115e1$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $3rBlz = parcelRequire("3rBlz");

var $5yjjJ = parcelRequire("5yjjJ");
function $3e7f9d584d5115e1$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return obj;
    return (0, $3rBlz.default)(obj) ? obj.slice() : (0, $5yjjJ.default)({}, obj);
}

});

parcelRegister("coY6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9076585c945d0835$export$2e2bcd8739ae039; });
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $9076585c945d0835$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("bnzgB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848d32eefb02b4da$export$2e2bcd8739ae039; });

var $fXtgO = parcelRequire("fXtgO");

var $5SQJQ = parcelRequire("5SQJQ");

var $j3POm = parcelRequire("j3POm");
function $848d32eefb02b4da$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $5SQJQ.default)(object, (0, $fXtgO.default)(path));
    return (0, $j3POm.default)(value) ? defaultValue : value;
}

});
parcelRegister("fXtgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e3122a3d4873c0$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
parcelRequire("86pzb");
function $b9e3122a3d4873c0$export$2e2bcd8739ae039(path) {
    return (0, $tYVIv.default).toPath(path);
}

});
parcelRegister("86pzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e62b73e5d1c15e5$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $3rBlz = parcelRequire("3rBlz");
function $5e62b73e5d1c15e5$export$2e2bcd8739ae039(path) {
    return (0, $3rBlz.default)(path) ? path : [
        path
    ];
}
(0, $tYVIv.default).toPath = $5e62b73e5d1c15e5$export$2e2bcd8739ae039;

});


parcelRegister("5SQJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $448ae7a87e4a2152$export$2e2bcd8739ae039; });
// Internal function to obtain a nested property in `obj` along `path`.
function $448ae7a87e4a2152$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("jF7N8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e507e3e584dfdee5$export$2e2bcd8739ae039; });

var $iFtQd = parcelRequire("iFtQd");

var $fXtgO = parcelRequire("fXtgO");
function $e507e3e584dfdee5$export$2e2bcd8739ae039(obj, path) {
    path = (0, $fXtgO.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $iFtQd.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("dVbMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a229bc0ceff8ccb9$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $4LWsK = parcelRequire("4LWsK");
function $a229bc0ceff8ccb9$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context);
    var _keys = (0, $4LWsK.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("2N7PR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20863c513f4c5f03$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $9HxXt = parcelRequire("9HxXt");

var $4THUh = parcelRequire("4THUh");
function $20863c513f4c5f03$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $tYVIv.default).iteratee !== (0, $4THUh.default)) return (0, $tYVIv.default).iteratee(value, context);
    return (0, $9HxXt.default)(value, context, argCount);
}

});
parcelRegister("9HxXt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7102789920b8b530$export$2e2bcd8739ae039; });

var $3Ft8y = parcelRequire("3Ft8y");

var $ciHuQ = parcelRequire("ciHuQ");

var $dYssA = parcelRequire("dYssA");

var $3rBlz = parcelRequire("3rBlz");

var $fWh3j = parcelRequire("fWh3j");

var $cVGk0 = parcelRequire("cVGk0");

var $8Vo92 = parcelRequire("8Vo92");
function $7102789920b8b530$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $3Ft8y.default;
    if ((0, $ciHuQ.default)(value)) return (0, $8Vo92.default)(value, context, argCount);
    if ((0, $dYssA.default)(value) && !(0, $3rBlz.default)(value)) return (0, $fWh3j.default)(value);
    return (0, $cVGk0.default)(value);
}

});
parcelRegister("3Ft8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2abbcd6b24db8ed7$export$2e2bcd8739ae039; });
// Keep the identity function around for default iteratees.
function $2abbcd6b24db8ed7$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("fWh3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a980078a789e7a$export$2e2bcd8739ae039; });

var $dlMHj = parcelRequire("dlMHj");

var $d6SxQ = parcelRequire("d6SxQ");
function $b9a980078a789e7a$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $dlMHj.default)({}, attrs);
    return function(obj) {
        return (0, $d6SxQ.default)(obj, attrs);
    };
}

});

parcelRegister("cVGk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969ba31d7768ba70$export$2e2bcd8739ae039; });

var $5SQJQ = parcelRequire("5SQJQ");

var $fXtgO = parcelRequire("fXtgO");
function $969ba31d7768ba70$export$2e2bcd8739ae039(path) {
    path = (0, $fXtgO.default)(path);
    return function(obj) {
        return (0, $5SQJQ.default)(obj, path);
    };
}

});

parcelRegister("8Vo92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f6604087000f2e$export$2e2bcd8739ae039; });
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $67f6604087000f2e$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("4THUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390e5b75b413a44b$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $9HxXt = parcelRequire("9HxXt");
function $390e5b75b413a44b$export$2e2bcd8739ae039(value, context) {
    return (0, $9HxXt.default)(value, context, Infinity);
}
(0, $tYVIv.default).iteratee = $390e5b75b413a44b$export$2e2bcd8739ae039;

});



parcelRegister("3xRL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $294e276a23aba8c2$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $294e276a23aba8c2$export$2e2bcd8739ae039() {}

});

parcelRegister("4H9Bb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b29fb0b1fbdaa0$export$2e2bcd8739ae039; });

var $3xRL4 = parcelRequire("3xRL4");

var $bnzgB = parcelRequire("bnzgB");
function $36b29fb0b1fbdaa0$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $3xRL4.default;
    return function(path) {
        return (0, $bnzgB.default)(obj, path);
    };
}

});

parcelRegister("g62W6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb7f7bea14a9552b$export$2e2bcd8739ae039; });

var $8Vo92 = parcelRequire("8Vo92");
function $bb7f7bea14a9552b$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $8Vo92.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("5ImvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $429286a346d684d4$export$2e2bcd8739ae039; });
// Return a random integer between `min` and `max` (inclusive).
function $429286a346d684d4$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("ci2Hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f29424f9db62903$export$2e2bcd8739ae039; });
// A (possibly faster) way to get the current timestamp as an integer.
var $8f29424f9db62903$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("cVKPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969f2246596dae7c$export$2e2bcd8739ae039; });

var $d73jR = parcelRequire("d73jR");

var $3smh0 = parcelRequire("3smh0");
var // Function for escaping strings to HTML interpolation.
$969f2246596dae7c$export$2e2bcd8739ae039 = (0, $d73jR.default)((0, $3smh0.default));

});
parcelRegister("d73jR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98be80f16f262867$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $98be80f16f262867$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $4LWsK.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("3smh0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $284543a3600ee326$export$2e2bcd8739ae039; });
// Internal list of HTML entities for escaping.
var $284543a3600ee326$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("fhZ4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b217d27aa643e094$export$2e2bcd8739ae039; });

var $d73jR = parcelRequire("d73jR");

var $6v6ZH = parcelRequire("6v6ZH");
var // Function for unescaping strings from HTML interpolation.
$b217d27aa643e094$export$2e2bcd8739ae039 = (0, $d73jR.default)((0, $6v6ZH.default));

});
parcelRegister("6v6ZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bbb1032ca93487c$export$2e2bcd8739ae039; });

var $loFvT = parcelRequire("loFvT");

var $3smh0 = parcelRequire("3smh0");
var // Internal list of HTML entities for unescaping.
$4bbb1032ca93487c$export$2e2bcd8739ae039 = (0, $loFvT.default)((0, $3smh0.default));

});


parcelRegister("ibdiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c391de4c9cbc35$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$d3c391de4c9cbc35$export$2e2bcd8739ae039 = (0, $tYVIv.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("aQvus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5730070b8474ce$export$2e2bcd8739ae039; });

var $euU6m = parcelRequire("euU6m");

var $tYVIv = parcelRequire("tYVIv");
parcelRequire("ibdiz");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $7e5730070b8474ce$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $7e5730070b8474ce$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $7e5730070b8474ce$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $7e5730070b8474ce$var$escapeChar(match) {
    return '\\' + $7e5730070b8474ce$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $7e5730070b8474ce$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $7e5730070b8474ce$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $euU6m.default)({}, settings, (0, $tYVIv.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $7e5730070b8474ce$var$noMatch).source,
        (settings.interpolate || $7e5730070b8474ce$var$noMatch).source,
        (settings.evaluate || $7e5730070b8474ce$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($7e5730070b8474ce$var$escapeRegExp, $7e5730070b8474ce$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$7e5730070b8474ce$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $tYVIv.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("aaIUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $767dac910fcf452d$export$2e2bcd8739ae039; });

var $ciHuQ = parcelRequire("ciHuQ");

var $fXtgO = parcelRequire("fXtgO");
function $767dac910fcf452d$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $fXtgO.default)(path);
    var length = path.length;
    if (!length) return (0, $ciHuQ.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $ciHuQ.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("ijUFs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d565f55da980c913$export$2e2bcd8739ae039; });
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $d565f55da980c913$var$idCounter = 0;
function $d565f55da980c913$export$2e2bcd8739ae039(prefix) {
    var id = ++$d565f55da980c913$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("1Jw0L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1432d3315f35cb6a$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
function $1432d3315f35cb6a$export$2e2bcd8739ae039(obj) {
    var instance = (0, $tYVIv.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("57hXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b9b8ab4b7a036a7$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $48OGH = parcelRequire("48OGH");

var $tYVIv = parcelRequire("tYVIv");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $3b9b8ab4b7a036a7$var$partial = (0, $cutdK.default)(function(func, boundArgs) {
    var placeholder = $3b9b8ab4b7a036a7$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $48OGH.default)(func, bound, this, this, args);
    };
    return bound;
});
$3b9b8ab4b7a036a7$var$partial.placeholder = (0, $tYVIv.default);
var $3b9b8ab4b7a036a7$export$2e2bcd8739ae039 = $3b9b8ab4b7a036a7$var$partial;

});
parcelRegister("48OGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $303f3a4ed1eb9c24$export$2e2bcd8739ae039; });

var $k4rnP = parcelRequire("k4rnP");

var $dYssA = parcelRequire("dYssA");
function $303f3a4ed1eb9c24$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $k4rnP.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $dYssA.default)(result)) return result;
    return self;
}

});


parcelRegister("87tT8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e96295e607d4716$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $48OGH = parcelRequire("48OGH");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$5e96295e607d4716$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(func, context, args) {
    if (!(0, $ciHuQ.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $cutdK.default)(function(callArgs) {
        return (0, $48OGH.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("aDTbd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bf8597fef205af3$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $llkFL = parcelRequire("llkFL");

var $87tT8 = parcelRequire("87tT8");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$7bf8597fef205af3$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    keys = (0, $llkFL.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $87tT8.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("llkFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89b984ecde65903$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $7oRXK = parcelRequire("7oRXK");

var $3rBlz = parcelRequire("3rBlz");

var $g7r4I = parcelRequire("g7r4I");
function $f89b984ecde65903$export$2e2bcd8739ae039(input, depth, strict) {
    if (!depth && depth !== 0) depth = Infinity;
    var output = [], idx = 0, i = 0, length = (0, $ikQKR.default)(input) || 0, stack = [];
    while(true){
        if (i >= length) {
            if (!stack.length) break;
            var frame = stack.pop();
            i = frame.i;
            input = frame.v;
            length = (0, $ikQKR.default)(input);
            continue;
        }
        var value = input[i++];
        if (stack.length >= depth) output[idx++] = value;
        else if ((0, $7oRXK.default)(value) && ((0, $3rBlz.default)(value) || (0, $g7r4I.default)(value))) {
            // Flatten current level of array or arguments object.
            stack.push({
                i: i,
                v: input
            });
            i = 0;
            input = value;
            length = (0, $ikQKR.default)(input);
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("7oRXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5634a22be85944be$export$2e2bcd8739ae039; });

var $2KQXF = parcelRequire("2KQXF");

var $ikQKR = parcelRequire("ikQKR");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$5634a22be85944be$export$2e2bcd8739ae039 = (0, $2KQXF.default)((0, $ikQKR.default));

});



parcelRegister("iW6qG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc92a182cf94c73b$export$2e2bcd8739ae039; });

var $iFtQd = parcelRequire("iFtQd");
function $dc92a182cf94c73b$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $iFtQd.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("dMNsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0961e886d0178b8$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$a0961e886d0178b8$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("jzlx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3f1fd16961c6151$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");

var $dMNsc = parcelRequire("dMNsc");

var $tYVIv = parcelRequire("tYVIv");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$e3f1fd16961c6151$export$2e2bcd8739ae039 = (0, $57hXU.default)((0, $dMNsc.default), (0, $tYVIv.default), 1);

});

parcelRegister("4olrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $332a08fc537f22e3$export$2e2bcd8739ae039; });

var $ci2Hm = parcelRequire("ci2Hm");
function $332a08fc537f22e3$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $ci2Hm.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $ci2Hm.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("j6hEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de7c46b238e5fb62$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ci2Hm = parcelRequire("ci2Hm");
function $de7c46b238e5fb62$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $ci2Hm.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $cutdK.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $ci2Hm.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("boUYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84ce2291500747a9$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");
function $84ce2291500747a9$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $57hXU.default)(wrapper, func);
}

});

parcelRegister("fEZb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b66a0bea00e88a59$export$2e2bcd8739ae039; });
// Returns a negated version of the passed-in predicate.
function $b66a0bea00e88a59$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("g6hdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8a8fcc4668ce1e$export$2e2bcd8739ae039; });
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $bb8a8fcc4668ce1e$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("6JKsG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e7afc604bb82c24$export$2e2bcd8739ae039; });
// Returns a function that will only be executed on and after the Nth call.
function $4e7afc604bb82c24$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("i0BUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1c5a15f9953a5c5$export$2e2bcd8739ae039; });
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $d1c5a15f9953a5c5$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("l46qR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55ef6052a3bde1f$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");

var $i0BUd = parcelRequire("i0BUd");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$f55ef6052a3bde1f$export$2e2bcd8739ae039 = (0, $57hXU.default)((0, $i0BUd.default), 2);

});

parcelRegister("2qFVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4e87734d199eee$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $4LWsK = parcelRequire("4LWsK");
function $1c4e87734d199eee$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = (0, $4LWsK.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("e2Yic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3a0056b8b01c8db$export$2e2bcd8739ae039; });

var $flkTB = parcelRequire("flkTB");
var // Returns the first index on an array-like that passes a truth test.
$a3a0056b8b01c8db$export$2e2bcd8739ae039 = (0, $flkTB.default)(1);

});
parcelRegister("flkTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b906a9d38b81d5$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");
function $b2b906a9d38b81d5$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $2N7PR.default)(predicate, context);
        var length = (0, $ikQKR.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("iL92E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da83a14fa8ec9fff$export$2e2bcd8739ae039; });

var $flkTB = parcelRequire("flkTB");
var // Returns the last index on an array-like that passes a truth test.
$da83a14fa8ec9fff$export$2e2bcd8739ae039 = (0, $flkTB.default)(-1);

});

parcelRegister("ghC52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdabc5cbdaf555d8$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");
function $bdabc5cbdaf555d8$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $ikQKR.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("5YGUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45a3d8aa6e700ce3$export$2e2bcd8739ae039; });

var $ghC52 = parcelRequire("ghC52");

var $e2Yic = parcelRequire("e2Yic");

var $f4Gob = parcelRequire("f4Gob");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$45a3d8aa6e700ce3$export$2e2bcd8739ae039 = (0, $f4Gob.default)(1, (0, $e2Yic.default), (0, $ghC52.default));

});
parcelRegister("f4Gob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af981c4fd97a8462$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $lKa0l = parcelRequire("lKa0l");

var $5hVse = parcelRequire("5hVse");
function $af981c4fd97a8462$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $ikQKR.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $lKa0l.slice).call(array, i, length), (0, $5hVse.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("3fsu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d8de2992580312$export$2e2bcd8739ae039; });

var $iL92E = parcelRequire("iL92E");

var $f4Gob = parcelRequire("f4Gob");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$25d8de2992580312$export$2e2bcd8739ae039 = (0, $f4Gob.default)(-1, (0, $iL92E.default));

});

parcelRegister("bss2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857810acf45a661d$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $e2Yic = parcelRequire("e2Yic");

var $2qFVg = parcelRequire("2qFVg");
function $857810acf45a661d$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $7oRXK.default)(obj) ? (0, $e2Yic.default) : (0, $2qFVg.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("emdBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a73dacaa05ccfdbb$export$2e2bcd8739ae039; });

var $bss2W = parcelRequire("bss2W");

var $fWh3j = parcelRequire("fWh3j");
function $a73dacaa05ccfdbb$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $bss2W.default)(obj, (0, $fWh3j.default)(attrs));
}

});

parcelRegister("bPbGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89bd869dab881381$export$2e2bcd8739ae039; });

var $8Vo92 = parcelRequire("8Vo92");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $89bd869dab881381$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $8Vo92.default)(iteratee, context);
    var i, length;
    if ((0, $7oRXK.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $4LWsK.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("gfTwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd591e90477af54a$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $bd591e90477af54a$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("jD3Ao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03b012567460dd15$export$2e2bcd8739ae039; });

var $KgPOi = parcelRequire("KgPOi");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$03b012567460dd15$export$2e2bcd8739ae039 = (0, $KgPOi.default)(1);

});
parcelRegister("KgPOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08b15b00d08a85fd$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");

var $8Vo92 = parcelRequire("8Vo92");
function $08b15b00d08a85fd$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $8Vo92.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("6BBNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf384cb4103366f$export$2e2bcd8739ae039; });

var $KgPOi = parcelRequire("KgPOi");
var // The right-associative version of reduce, also known as `foldr`.
$4cf384cb4103366f$export$2e2bcd8739ae039 = (0, $KgPOi.default)(-1);

});

parcelRegister("efEt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a601db6defdca403$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $a601db6defdca403$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $2N7PR.default)(predicate, context);
    (0, $bPbGS.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("8BknA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6431965fb9a38135$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");

var $fEZb2 = parcelRequire("fEZb2");

var $2N7PR = parcelRequire("2N7PR");
function $6431965fb9a38135$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $efEt3.default)(obj, (0, $fEZb2.default)((0, $2N7PR.default)(predicate)), context);
}

});

parcelRegister("22GE8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ccd959cd154dde$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $17ccd959cd154dde$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("ctpBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $914c0e7c15408708$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $914c0e7c15408708$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("9z2eX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f691ed4dc02b231$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $5YGUS = parcelRequire("5YGUS");
function $6f691ed4dc02b231$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $7oRXK.default)(obj)) obj = (0, $gNJrf.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $5YGUS.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("kDigY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0559fbd1d840c88$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $gfTwJ = parcelRequire("gfTwJ");

var $5SQJQ = parcelRequire("5SQJQ");

var $fXtgO = parcelRequire("fXtgO");
var // Invoke a method (with arguments) on every item in a collection.
$f0559fbd1d840c88$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $ciHuQ.default)(path)) func = path;
    else {
        path = (0, $fXtgO.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $gfTwJ.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $5SQJQ.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("gS9W9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48965be961a0b5e$export$2e2bcd8739ae039; });

var $gfTwJ = parcelRequire("gfTwJ");

var $cVGk0 = parcelRequire("cVGk0");
function $c48965be961a0b5e$export$2e2bcd8739ae039(obj, key) {
    return (0, $gfTwJ.default)(obj, (0, $cVGk0.default)(key));
}

});

parcelRegister("9zRTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f912f9beed8a45b$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");

var $fWh3j = parcelRequire("fWh3j");
function $6f912f9beed8a45b$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $efEt3.default)(obj, (0, $fWh3j.default)(attrs));
}

});

parcelRegister("fUZrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b96bbfc8df9255ae$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $b96bbfc8df9255ae$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $7oRXK.default)(obj) ? obj : (0, $gNJrf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("2OrAw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c5a6b2bb99f83f$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $20c5a6b2bb99f83f$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $7oRXK.default)(obj) ? obj : (0, $gNJrf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("jujdW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ffbb203f30980c$export$2e2bcd8739ae039; });

var $3k55B = parcelRequire("3k55B");
function $e2ffbb203f30980c$export$2e2bcd8739ae039(obj) {
    return (0, $3k55B.default)(obj, Infinity);
}

});
parcelRegister("3k55B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b72ff9def6829e$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $ikQKR = parcelRequire("ikQKR");

var $5ImvW = parcelRequire("5ImvW");

var $1N8dN = parcelRequire("1N8dN");
function $26b72ff9def6829e$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $7oRXK.default)(obj)) obj = (0, $gNJrf.default)(obj);
        return obj[(0, $5ImvW.default)(obj.length - 1)];
    }
    var sample = (0, $1N8dN.default)(obj);
    var length = (0, $ikQKR.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $5ImvW.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("1N8dN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e0beac4b981966$export$2e2bcd8739ae039; });

var $3rBlz = parcelRequire("3rBlz");

var $lKa0l = parcelRequire("lKa0l");

var $jmGFg = parcelRequire("jmGFg");

var $7oRXK = parcelRequire("7oRXK");

var $gfTwJ = parcelRequire("gfTwJ");

var $3Ft8y = parcelRequire("3Ft8y");

var $gNJrf = parcelRequire("gNJrf");
// Safely create a real, live array from anything iterable.
var $14e0beac4b981966$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $14e0beac4b981966$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $3rBlz.default)(obj)) return (0, $lKa0l.slice).call(obj);
    if ((0, $jmGFg.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($14e0beac4b981966$var$reStrSymbol);
    if ((0, $7oRXK.default)(obj)) return (0, $gfTwJ.default)(obj, (0, $3Ft8y.default));
    return (0, $gNJrf.default)(obj);
}

});



parcelRegister("eVdJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02cdb1b6867de149$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $gS9W9 = parcelRequire("gS9W9");

var $gfTwJ = parcelRequire("gfTwJ");
function $02cdb1b6867de149$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $2N7PR.default)(iteratee, context);
    return (0, $gS9W9.default)((0, $gfTwJ.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("dqbTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c56edb3465e8721$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");

var $iFtQd = parcelRequire("iFtQd");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$9c56edb3465e8721$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    if ((0, $iFtQd.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("5DPc6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b84e5cd8af26ee$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $41b84e5cd8af26ee$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("bJcvr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889d99270c0c4253$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$889d99270c0c4253$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("bRnHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a270854b2c89792$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");

var $iFtQd = parcelRequire("iFtQd");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$8a270854b2c89792$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    if ((0, $iFtQd.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("2fwpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3620ff2b2d0061$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$1a3620ff2b2d0061$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("iTCYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1b97d2613cc98e$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $dc1b97d2613cc98e$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $7oRXK.default)(obj) ? obj.length : (0, $4LWsK.default)(obj).length;
}

});

parcelRegister("3fpzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d69c3d18b9086f$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $8Vo92 = parcelRequire("8Vo92");

var $jZVkW = parcelRequire("jZVkW");

var $cHHKf = parcelRequire("cHHKf");

var $llkFL = parcelRequire("llkFL");
var // Return a copy of the object only containing the allowed properties.
$25d69c3d18b9086f$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $ciHuQ.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $8Vo92.default)(iteratee, keys[1]);
        keys = (0, $jZVkW.default)(obj);
    } else {
        iteratee = (0, $cHHKf.default);
        keys = (0, $llkFL.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("cHHKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93fb6f09932fc0de$export$2e2bcd8739ae039; });
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $93fb6f09932fc0de$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("jrEl1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e27fd4376120ac63$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $fEZb2 = parcelRequire("fEZb2");

var $gfTwJ = parcelRequire("gfTwJ");

var $llkFL = parcelRequire("llkFL");

var $9z2eX = parcelRequire("9z2eX");

var $3fpzD = parcelRequire("3fpzD");
var // Return a copy of the object without the disallowed properties.
$e27fd4376120ac63$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $ciHuQ.default)(iteratee)) {
        iteratee = (0, $fEZb2.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $gfTwJ.default)((0, $llkFL.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $9z2eX.default)(keys, key);
        };
    }
    return (0, $3fpzD.default)(obj, iteratee, context);
});

});

parcelRegister("fcTdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b122cf7206c4600f$export$2e2bcd8739ae039; });

var $c4yYd = parcelRequire("c4yYd");
function $b122cf7206c4600f$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $c4yYd.default)(array, array.length - n);
}

});
parcelRegister("c4yYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca0fc1d9d26540f$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $8ca0fc1d9d26540f$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $lKa0l.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("hB3Xt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccf8f6656096fc9e$export$2e2bcd8739ae039; });

var $2lrEW = parcelRequire("2lrEW");
function $ccf8f6656096fc9e$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $2lrEW.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("2lrEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b52ff80b70daaf3$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $1b52ff80b70daaf3$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $lKa0l.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("ees8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5c83433fdfe3e44$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");
function $a5c83433fdfe3e44$export$2e2bcd8739ae039(array) {
    return (0, $efEt3.default)(array, Boolean);
}

});

parcelRegister("1TwZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161484322f084ce0$export$2e2bcd8739ae039; });

var $llkFL = parcelRequire("llkFL");
function $161484322f084ce0$export$2e2bcd8739ae039(array, depth) {
    return (0, $llkFL.default)(array, depth, false);
}

});

parcelRegister("5jrxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de417f0ce666c4e$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $89CXs = parcelRequire("89CXs");
var // Return a version of the array that does not contain the specified value(s).
$3de417f0ce666c4e$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(array, otherArrays) {
    return (0, $89CXs.default)(array, otherArrays);
});

});
parcelRegister("89CXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5efd623734a14e6b$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $llkFL = parcelRequire("llkFL");

var $efEt3 = parcelRequire("efEt3");

var $9z2eX = parcelRequire("9z2eX");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$5efd623734a14e6b$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(array, rest) {
    rest = (0, $llkFL.default)(rest, true, true);
    return (0, $efEt3.default)(array, function(value) {
        return !(0, $9z2eX.default)(rest, value);
    });
});

});


parcelRegister("iUtSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc44a2cf659b8de9$export$2e2bcd8739ae039; });

var $aY7I7 = parcelRequire("aY7I7");

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");

var $9z2eX = parcelRequire("9z2eX");
function $dc44a2cf659b8de9$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $aY7I7.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $2N7PR.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $ikQKR.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $9z2eX.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $9z2eX.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("1XgTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16c867d0c8d96094$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $iUtSI = parcelRequire("iUtSI");

var $llkFL = parcelRequire("llkFL");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$16c867d0c8d96094$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(arrays) {
    return (0, $iUtSI.default)((0, $llkFL.default)(arrays, true, true));
});

});

parcelRegister("2ycy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1db87d6b6cafdd1f$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $9z2eX = parcelRequire("9z2eX");
function $1db87d6b6cafdd1f$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $ikQKR.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $9z2eX.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $9z2eX.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("e9qP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d6b663e257bc5d$export$2e2bcd8739ae039; });

var $fUZrG = parcelRequire("fUZrG");

var $ikQKR = parcelRequire("ikQKR");

var $gS9W9 = parcelRequire("gS9W9");
function $a4d6b663e257bc5d$export$2e2bcd8739ae039(array) {
    var length = array && (0, $fUZrG.default)(array, (0, $ikQKR.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $gS9W9.default)(array, index);
    return result;
}

});

parcelRegister("8DaDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $648a38f2341332c5$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $e9qP4 = parcelRequire("e9qP4");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$648a38f2341332c5$export$2e2bcd8739ae039 = (0, $cutdK.default)((0, $e9qP4.default));

});

parcelRegister("kdGCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb861621d01e2e0e$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");
function $eb861621d01e2e0e$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $ikQKR.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("ds2Lz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb00938f165cd06$export$2e2bcd8739ae039; });
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $9cb00938f165cd06$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("idngN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d42b7dcf53b1de61$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $d42b7dcf53b1de61$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $lKa0l.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("j2rdI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc3519bb2fc2ff8$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $bPbGS = parcelRequire("bPbGS");

var $l07og = parcelRequire("l07og");

var $lKa0l = parcelRequire("lKa0l");

var $cYBQd = parcelRequire("cYBQd");
function $ddc3519bb2fc2ff8$export$2e2bcd8739ae039(obj) {
    (0, $bPbGS.default)((0, $l07og.default)(obj), function(name) {
        var func = (0, $tYVIv.default)[name] = obj[name];
        (0, $tYVIv.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $lKa0l.push).apply(args, arguments);
            return (0, $cYBQd.default)(this, func.apply((0, $tYVIv.default), args));
        };
    });
    return 0, $tYVIv.default;
}

});
parcelRegister("cYBQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9728711803967dc4$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
function $9728711803967dc4$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $tYVIv.default)(obj).chain() : obj;
}

});


parcelRegister("OKn95", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0988a433cdc9bbe6$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $bPbGS = parcelRequire("bPbGS");

var $lKa0l = parcelRequire("lKa0l");

var $cYBQd = parcelRequire("cYBQd");
// Add all mutator `Array` functions to the wrapper.
(0, $bPbGS.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $lKa0l.ArrayProto)[name];
    (0, $tYVIv.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $cYBQd.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $bPbGS.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $lKa0l.ArrayProto)[name];
    (0, $tYVIv.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $cYBQd.default)(this, obj);
    };
});
var $0988a433cdc9bbe6$export$2e2bcd8739ae039 = (0, $tYVIv.default);

});





parcelRegister("jah0F", function(module, exports) {

$parcel$export(module.exports, "parseFromString", function () { return $df3c2546698cd37a$export$26cfb4a895d40b24; }, function (v) { return $df3c2546698cd37a$export$26cfb4a895d40b24 = v; });
$parcel$export(module.exports, "Node", function () { return $df3c2546698cd37a$export$85c928794f8d04d4; }, function (v) { return $df3c2546698cd37a$export$85c928794f8d04d4 = v; });
var $df3c2546698cd37a$export$26cfb4a895d40b24;
var $df3c2546698cd37a$export$85c928794f8d04d4;

var $7cu9k = parcelRequire("7cu9k");

var $6aORb = parcelRequire("6aORb");
function $df3c2546698cd37a$var$parseFromString(string) {
    var error = null;
    var domParser = new $7cu9k.DOMParser({
        errorHandler: function(level, message) {
            error = {
                level: level,
                message: message
            };
        }
    });
    var document = domParser.parseFromString(string);
    if (error === null) return document;
    else throw new Error(error.level + ": " + error.message);
}
$df3c2546698cd37a$export$26cfb4a895d40b24 = $df3c2546698cd37a$var$parseFromString;
$df3c2546698cd37a$export$85c928794f8d04d4 = $6aORb.Node;

});
parcelRegister("7cu9k", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $53e10a6f388afa3b$export$1059c6e7d2ce5669; }, function (v) { return $53e10a6f388afa3b$export$1059c6e7d2ce5669 = v; });
var $53e10a6f388afa3b$export$455426655eab1d48;
var $53e10a6f388afa3b$export$64f0bed4ae6f0f24;
var $53e10a6f388afa3b$export$1059c6e7d2ce5669;

var $6aORb = parcelRequire("6aORb");
$53e10a6f388afa3b$export$455426655eab1d48 = $6aORb.DOMImplementation;
$53e10a6f388afa3b$export$64f0bed4ae6f0f24 = $6aORb.XMLSerializer;

$53e10a6f388afa3b$export$1059c6e7d2ce5669 = (parcelRequire("dQ0RX")).DOMParser;

});
parcelRegister("6aORb", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", function () { return $47eb2057f4163810$export$455426655eab1d48; }, function (v) { return $47eb2057f4163810$export$455426655eab1d48 = v; });
$parcel$export(module.exports, "Node", function () { return $47eb2057f4163810$export$85c928794f8d04d4; }, function (v) { return $47eb2057f4163810$export$85c928794f8d04d4 = v; });
$parcel$export(module.exports, "XMLSerializer", function () { return $47eb2057f4163810$export$64f0bed4ae6f0f24; }, function (v) { return $47eb2057f4163810$export$64f0bed4ae6f0f24 = v; });
//if(typeof require == 'function'){
var $47eb2057f4163810$export$d1d99cf900472499;
var $47eb2057f4163810$export$fe58bcf938607f6a;
var $47eb2057f4163810$export$455426655eab1d48;
var $47eb2057f4163810$export$db77ccec0bb4ccac;
var $47eb2057f4163810$export$85c928794f8d04d4;
var $47eb2057f4163810$export$79b41aa5d56abdff;
var $47eb2057f4163810$export$5118471ee5d5453b;
var $47eb2057f4163810$export$64f0bed4ae6f0f24;

var $aeRet = parcelRequire("aeRet");
var $47eb2057f4163810$var$find = $aeRet.find;
var $47eb2057f4163810$var$NAMESPACE = $aeRet.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $47eb2057f4163810$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $47eb2057f4163810$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($47eb2057f4163810$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $47eb2057f4163810$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $47eb2057f4163810$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $47eb2057f4163810$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($47eb2057f4163810$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $47eb2057f4163810$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $47eb2057f4163810$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $47eb2057f4163810$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $47eb2057f4163810$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $47eb2057f4163810$var$NodeType = {};
var $47eb2057f4163810$var$ELEMENT_NODE = $47eb2057f4163810$var$NodeType.ELEMENT_NODE = 1;
var $47eb2057f4163810$var$ATTRIBUTE_NODE = $47eb2057f4163810$var$NodeType.ATTRIBUTE_NODE = 2;
var $47eb2057f4163810$var$TEXT_NODE = $47eb2057f4163810$var$NodeType.TEXT_NODE = 3;
var $47eb2057f4163810$var$CDATA_SECTION_NODE = $47eb2057f4163810$var$NodeType.CDATA_SECTION_NODE = 4;
var $47eb2057f4163810$var$ENTITY_REFERENCE_NODE = $47eb2057f4163810$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $47eb2057f4163810$var$ENTITY_NODE = $47eb2057f4163810$var$NodeType.ENTITY_NODE = 6;
var $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE = $47eb2057f4163810$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $47eb2057f4163810$var$COMMENT_NODE = $47eb2057f4163810$var$NodeType.COMMENT_NODE = 8;
var $47eb2057f4163810$var$DOCUMENT_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_NODE = 9;
var $47eb2057f4163810$var$DOCUMENT_TYPE_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $47eb2057f4163810$var$NOTATION_NODE = $47eb2057f4163810$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $47eb2057f4163810$var$ExceptionCode = {};
var $47eb2057f4163810$var$ExceptionMessage = {};
var $47eb2057f4163810$var$INDEX_SIZE_ERR = $47eb2057f4163810$var$ExceptionCode.INDEX_SIZE_ERR = ($47eb2057f4163810$var$ExceptionMessage[1] = "Index size error", 1);
var $47eb2057f4163810$var$DOMSTRING_SIZE_ERR = $47eb2057f4163810$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($47eb2057f4163810$var$ExceptionMessage[2] = "DOMString size error", 2);
var $47eb2057f4163810$var$HIERARCHY_REQUEST_ERR = $47eb2057f4163810$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($47eb2057f4163810$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $47eb2057f4163810$var$WRONG_DOCUMENT_ERR = $47eb2057f4163810$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($47eb2057f4163810$var$ExceptionMessage[4] = "Wrong document", 4);
var $47eb2057f4163810$var$INVALID_CHARACTER_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_CHARACTER_ERR = ($47eb2057f4163810$var$ExceptionMessage[5] = "Invalid character", 5);
var $47eb2057f4163810$var$NO_DATA_ALLOWED_ERR = $47eb2057f4163810$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($47eb2057f4163810$var$ExceptionMessage[6] = "No data allowed", 6);
var $47eb2057f4163810$var$NO_MODIFICATION_ALLOWED_ERR = $47eb2057f4163810$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($47eb2057f4163810$var$ExceptionMessage[7] = "No modification allowed", 7);
var $47eb2057f4163810$var$NOT_FOUND_ERR = $47eb2057f4163810$var$ExceptionCode.NOT_FOUND_ERR = ($47eb2057f4163810$var$ExceptionMessage[8] = "Not found", 8);
var $47eb2057f4163810$var$NOT_SUPPORTED_ERR = $47eb2057f4163810$var$ExceptionCode.NOT_SUPPORTED_ERR = ($47eb2057f4163810$var$ExceptionMessage[9] = "Not supported", 9);
var $47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR = $47eb2057f4163810$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($47eb2057f4163810$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $47eb2057f4163810$var$INVALID_STATE_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_STATE_ERR = ($47eb2057f4163810$var$ExceptionMessage[11] = "Invalid state", 11);
var $47eb2057f4163810$var$SYNTAX_ERR = $47eb2057f4163810$var$ExceptionCode.SYNTAX_ERR = ($47eb2057f4163810$var$ExceptionMessage[12] = "Syntax error", 12);
var $47eb2057f4163810$var$INVALID_MODIFICATION_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($47eb2057f4163810$var$ExceptionMessage[13] = "Invalid modification", 13);
var $47eb2057f4163810$var$NAMESPACE_ERR = $47eb2057f4163810$var$ExceptionCode.NAMESPACE_ERR = ($47eb2057f4163810$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $47eb2057f4163810$var$INVALID_ACCESS_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_ACCESS_ERR = ($47eb2057f4163810$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $47eb2057f4163810$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $47eb2057f4163810$var$ExceptionMessage[code]);
        this.message = $47eb2057f4163810$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $47eb2057f4163810$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$47eb2057f4163810$var$DOMException.prototype = Error.prototype;
$47eb2057f4163810$var$copy($47eb2057f4163810$var$ExceptionCode, $47eb2057f4163810$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $47eb2057f4163810$var$NodeList() {}
$47eb2057f4163810$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter, options) {
        var requireWellFormed = !!options && !!options.requireWellFormed;
        for(var buf = [], i = 0; i < this.length; i++)$47eb2057f4163810$var$serializeToString(this[i], buf, isHTML, nodeFilter, null, requireWellFormed);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $47eb2057f4163810$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $47eb2057f4163810$var$_updateLiveList(this);
}
function $47eb2057f4163810$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $47eb2057f4163810$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $47eb2057f4163810$var$copy(ls, list);
        list._inc = inc;
    }
}
$47eb2057f4163810$var$LiveNodeList.prototype.item = function(i) {
    $47eb2057f4163810$var$_updateLiveList(this);
    return this[i] || null;
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$LiveNodeList, $47eb2057f4163810$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $47eb2057f4163810$var$NamedNodeMap() {}
function $47eb2057f4163810$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $47eb2057f4163810$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$47eb2057f4163810$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $47eb2057f4163810$var$_onRemoveAttribute(doc, el, oldAttr);
            $47eb2057f4163810$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $47eb2057f4163810$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $47eb2057f4163810$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $47eb2057f4163810$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$47eb2057f4163810$var$NamedNodeMap.prototype = {
    length: 0,
    item: $47eb2057f4163810$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $47eb2057f4163810$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $47eb2057f4163810$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $47eb2057f4163810$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $47eb2057f4163810$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $47eb2057f4163810$var$DOMImplementation() {}
$47eb2057f4163810$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $47eb2057f4163810$var$Document();
        doc.implementation = this;
        doc.childNodes = new $47eb2057f4163810$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This implementation differs from the specification:__
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * Note: `internalSubset` can only be introduced via a direct property write to `node.internalSubset` after creation.
	 * Creation-time validation of `publicId`, `systemId` is not enforced.
	 * The serializer-level check covers all mutation vectors, including direct property writes.
	 * `internalSubset` is only serialized as `[ ... ]` when both `publicId` and `systemId` are
	 * absent (empty or `'.'`) — if either external identifier is present, `internalSubset` is
	 * silently omitted from the serialized output.
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * The external subset public identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true` (via the 4th-parameter options object),
	 * throws `DOMException` with code `INVALID_STATE_ERR` if the value is non-empty and does
	 * not match the XML `PubidLiteral` production (W3C DOM Parsing §3.2.1.3; XML 1.0 [12]).
	 * @param {string} [systemId]
	 * The external subset system identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true`, throws `DOMException` with code
	 * `INVALID_STATE_ERR` if the value is non-empty and does not match the XML `SystemLiteral`
	 * production (W3C DOM Parsing §3.2.1.3; XML 1.0 [11]).
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $47eb2057f4163810$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $47eb2057f4163810$var$Node() {}
$47eb2057f4163810$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $47eb2057f4163810$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $47eb2057f4163810$var$_insertBefore(this, newChild, oldChild, $47eb2057f4163810$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $47eb2057f4163810$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $47eb2057f4163810$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    /**
	 * Puts the specified node and all of its subtree into a "normalized" form. In a normalized
	 * subtree, no text nodes in the subtree are empty and there are no adjacent text nodes.
	 *
	 * Specifically, this method merges any adjacent text nodes (i.e., nodes for which `nodeType`
	 * is `TEXT_NODE`) into a single node with the combined data. It also removes any empty text
	 * nodes.
	 *
	 * This method iteratively traverses all child nodes to normalize all descendant nodes within
	 * the subtree.
	 *
	 * @throws {DOMException}
	 * May throw a DOMException if operations within removeChild or appendData (which are
	 * potentially invoked in this method) do not meet their specific constraints.
	 * @see {@link Node.removeChild}
	 * @see {@link CharacterData.appendData}
	 * @see ../docs/walk-dom.md.
	 */ normalize: function() {
        $47eb2057f4163810$var$walkDOM(this, null, {
            enter: function(node) {
                // Merge adjacent text children of node before walkDOM schedules them.
                // walkDOM reads lastChild/previousSibling after enter returns, so the
                // surviving post-merge children are what it descends into.
                var child = node.firstChild;
                while(child){
                    var next = child.nextSibling;
                    if (next !== null && next.nodeType === $47eb2057f4163810$var$TEXT_NODE && child.nodeType === $47eb2057f4163810$var$TEXT_NODE) {
                        node.removeChild(next);
                        child.appendData(next.data);
                    // Do not advance child: re-check new nextSibling for another text run
                    } else child = next;
                }
                return true; // descend into surviving children
            }
        });
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $47eb2057f4163810$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $47eb2057f4163810$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $47eb2057f4163810$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$47eb2057f4163810$var$copy($47eb2057f4163810$var$NodeType, $47eb2057f4163810$var$Node);
$47eb2057f4163810$var$copy($47eb2057f4163810$var$NodeType, $47eb2057f4163810$var$Node.prototype);
/**
 * @param {Node} node
 * Root of the subtree to visit.
 * @param {function(Node): boolean} callback
 * Called for each node in depth-first pre-order. Return a truthy value to stop traversal early.
 * @return {boolean} `true` if traversal was aborted by the callback, `false` otherwise.
 */ function $47eb2057f4163810$var$_visitNode(node, callback) {
    return $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(n) {
            return callback(n) ? $47eb2057f4163810$var$walkDOM.STOP : true;
        }
    }) === $47eb2057f4163810$var$walkDOM.STOP;
}
/**
 * Depth-first pre/post-order DOM tree walker.
 *
 * Visits every node in the subtree rooted at `node`. For each node:
 *
 * 1. Calls `callbacks.enter(node, context)` before descending into the node's children. The
 * return value becomes the `context` passed to each child's `enter` call and to the matching
 * `exit` call.
 * 2. If `enter` returns `null` or `undefined`, the node's children are skipped;
 * sibling traversal continues normally.
 * 3. If `enter` returns `walkDOM.STOP`, the entire traversal is aborted immediately — no
 * further `enter` or `exit` calls are made.
 * 4. `lastChild` and `previousSibling` are read **after** `enter` returns, so `enter` may
 * safely modify the node's own child list before the walker descends. Modifying siblings of
 * the current node or any other part of the tree produces unpredictable results: nodes already
 * queued on the stack are visited regardless of DOM changes, and newly inserted nodes outside
 * the current child list are never visited.
 * 5. Calls `callbacks.exit(node, context)` (if provided) after all of a node's children have
 * been visited, passing the same `context` that `enter`
 * returned for that node.
 *
 * This implementation uses an explicit stack and does not recurse — it is safe on arbitrarily
 * deep trees.
 *
 * @param {Node} node
 * Root of the subtree to walk.
 * @param {*} context
 * Initial context value passed to the root node's `enter`.
 * @param {{ enter: function(Node, *): *, exit?: function(Node, *): void }} callbacks
 * @returns {void | walkDOM.STOP}
 * @see ../docs/walk-dom.md.
 */ function $47eb2057f4163810$var$walkDOM(node, context, callbacks) {
    // Each stack frame is {node, context, phase}:
    //   walkDOM.ENTER — call enter, then push children
    //   walkDOM.EXIT  — call exit
    var stack = [
        {
            node: node,
            context: context,
            phase: $47eb2057f4163810$var$walkDOM.ENTER
        }
    ];
    while(stack.length > 0){
        var frame = stack.pop();
        if (frame.phase === $47eb2057f4163810$var$walkDOM.ENTER) {
            var childContext = callbacks.enter(frame.node, frame.context);
            if (childContext === $47eb2057f4163810$var$walkDOM.STOP) return $47eb2057f4163810$var$walkDOM.STOP;
            // Push exit frame before children so it fires after all children are processed (Last In First Out)
            stack.push({
                node: frame.node,
                context: childContext,
                phase: $47eb2057f4163810$var$walkDOM.EXIT
            });
            if (childContext === null || childContext === undefined) continue; // skip children
            // lastChild is read after enter returns, so enter may modify the child list.
            var child = frame.node.lastChild;
            // Traverse from lastChild backwards so that pushing onto the stack
            // naturally yields firstChild on top (processed first).
            while(child){
                stack.push({
                    node: child,
                    context: childContext,
                    phase: $47eb2057f4163810$var$walkDOM.ENTER
                });
                child = child.previousSibling;
            }
        } else // frame.phase === walkDOM.EXIT
        if (callbacks.exit) callbacks.exit(frame.node, frame.context);
    }
}
/**
 * Sentinel value returned from a `walkDOM` `enter` callback to abort the entire traversal
 * immediately.
 *
 * @type {symbol}
 */ $47eb2057f4163810$var$walkDOM.STOP = Symbol('walkDOM.STOP');
/**
 * Phase constant for a stack frame that has not yet been visited.
 * The `enter` callback is called and children are scheduled.
 *
 * @type {number}
 */ $47eb2057f4163810$var$walkDOM.ENTER = 0;
/**
 * Phase constant for a stack frame whose subtree has been fully visited.
 * The `exit` callback is called.
 *
 * @type {number}
 */ $47eb2057f4163810$var$walkDOM.EXIT = 1;
function $47eb2057f4163810$var$Document() {
    this.ownerDocument = this;
}
function $47eb2057f4163810$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $47eb2057f4163810$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $47eb2057f4163810$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $47eb2057f4163810$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $47eb2057f4163810$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $47eb2057f4163810$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $47eb2057f4163810$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$hasInsertableNodeType(node) {
    return node && ($47eb2057f4163810$var$isElementNode(node) || $47eb2057f4163810$var$isTextNode(node) || $47eb2057f4163810$var$isDocTypeNode(node) || node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.COMMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isDocTypeNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isElementNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isTextNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode) || $47eb2057f4163810$var$isDocTypeNode(child)) return false;
    var docTypeNode = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $47eb2057f4163810$var$isElementNode(node) && node !== child;
    }
    if ($47eb2057f4163810$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$47eb2057f4163810$var$hasValidParentNodeType(parent)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$47eb2057f4163810$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $47eb2057f4163810$var$isDocTypeNode(node) && parent.nodeType !== $47eb2057f4163810$var$Node.DOCUMENT_NODE) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($47eb2057f4163810$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $47eb2057f4163810$var$find(nodeChildNodes, $47eb2057f4163810$var$isTextNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$47eb2057f4163810$var$isElementInsertionPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($47eb2057f4163810$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$47eb2057f4163810$var$isElementInsertionPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($47eb2057f4163810$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($47eb2057f4163810$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $47eb2057f4163810$var$find(nodeChildNodes, $47eb2057f4163810$var$isTextNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$47eb2057f4163810$var$isElementReplacementPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($47eb2057f4163810$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$47eb2057f4163810$var$isElementReplacementPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($47eb2057f4163810$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $47eb2057f4163810$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($47eb2057f4163810$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $47eb2057f4163810$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $47eb2057f4163810$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $47eb2057f4163810$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $47eb2057f4163810$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $47eb2057f4163810$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $47eb2057f4163810$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $47eb2057f4163810$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $47eb2057f4163810$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $47eb2057f4163810$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$47eb2057f4163810$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $47eb2057f4163810$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $47eb2057f4163810$var$_insertBefore(this, newChild, refChild);
        $47eb2057f4163810$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $47eb2057f4163810$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $47eb2057f4163810$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $47eb2057f4163810$var$_insertBefore(this, newChild, oldChild, $47eb2057f4163810$var$assertPreReplacementValidityInDocument);
        $47eb2057f4163810$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($47eb2057f4163810$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $47eb2057f4163810$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $47eb2057f4163810$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $47eb2057f4163810$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $47eb2057f4163810$var$toOrderedSet(classNames);
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $47eb2057f4163810$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $47eb2057f4163810$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($47eb2057f4163810$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $47eb2057f4163810$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        var attrs = node.attributes = new $47eb2057f4163810$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $47eb2057f4163810$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $47eb2057f4163810$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $47eb2057f4163810$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a new CDATASection node whose data is `data`.
	 *
	 * __This implementation differs from the specification:__
	 * - calling this method on an HTML document does not throw `NotSupportedError`.
	 *
	 * @param {string} data
	 * @returns {CDATASection}
	 * @throws DOMException with code `INVALID_CHARACTER_ERR` if `data` contains `"]]>"`.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createCDATASection
	 * @see https://dom.spec.whatwg.org/#dom-document-createcdatasection
	 */ createCDATASection: function(data) {
        if (data.indexOf(']]>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_CHARACTER_ERR, 'data contains "]]>"');
        var node = new $47eb2057f4163810$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a ProcessingInstruction node whose target is target and data is data.
	 *
	 * __This implementation differs from the specification:__
	 * - it does not do any input validation on the arguments and doesn't throw "InvalidCharacterError".
	 *
	 * Note: When the resulting document is serialized with `requireWellFormed: true`, the
	 * serializer throws with code `INVALID_STATE_ERR` if `.data` contains `?>` (W3C DOM Parsing
	 * §3.2.1.7). Without that option the data is emitted verbatim.
	 *
	 * @param {string} target
	 * @param {string} data
	 * @returns {ProcessingInstruction}
	 * @see https://developer.mozilla.org/docs/Web/API/Document/createProcessingInstruction
	 * @see https://dom.spec.whatwg.org/#dom-document-createprocessinginstruction
	 * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.7
	 */ createProcessingInstruction: function(target, data) {
        var node = new $47eb2057f4163810$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $47eb2057f4163810$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $47eb2057f4163810$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $47eb2057f4163810$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $47eb2057f4163810$var$NamedNodeMap();
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $47eb2057f4163810$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Document, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Element() {
    this._nsMap = {};
}
$47eb2057f4163810$var$Element.prototype = {
    nodeType: $47eb2057f4163810$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $47eb2057f4163810$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            $47eb2057f4163810$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $47eb2057f4163810$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            $47eb2057f4163810$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$47eb2057f4163810$var$Document.prototype.getElementsByTagName = $47eb2057f4163810$var$Element.prototype.getElementsByTagName;
$47eb2057f4163810$var$Document.prototype.getElementsByTagNameNS = $47eb2057f4163810$var$Element.prototype.getElementsByTagNameNS;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Element, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Attr() {}
$47eb2057f4163810$var$Attr.prototype.nodeType = $47eb2057f4163810$var$ATTRIBUTE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Attr, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$CharacterData() {}
$47eb2057f4163810$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($47eb2057f4163810$var$ExceptionMessage[$47eb2057f4163810$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$CharacterData, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Text() {}
$47eb2057f4163810$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $47eb2057f4163810$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Text, $47eb2057f4163810$var$CharacterData);
function $47eb2057f4163810$var$Comment() {}
$47eb2057f4163810$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $47eb2057f4163810$var$COMMENT_NODE
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Comment, $47eb2057f4163810$var$CharacterData);
function $47eb2057f4163810$var$CDATASection() {}
$47eb2057f4163810$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $47eb2057f4163810$var$CDATA_SECTION_NODE
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$CDATASection, $47eb2057f4163810$var$CharacterData);
/**
 * Represents a DocumentType node (the `<!DOCTYPE ...>` declaration).
 *
 * `publicId`, `systemId`, and `internalSubset` are plain own-property assignments.
 * xmldom does not enforce the `readonly` constraint declared by the WHATWG DOM spec —
 * direct property writes succeed silently. Values are serialized verbatim when
 * `requireWellFormed` is false (the default). When the serializer is invoked with
 * `requireWellFormed: true` (via the 4th-parameter options object), it validates each
 * field and throws `DOMException` with code `INVALID_STATE_ERR` on invalid values.
 *
 * @class
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentType MDN
 */ function $47eb2057f4163810$var$DocumentType() {}
$47eb2057f4163810$var$DocumentType.prototype.nodeType = $47eb2057f4163810$var$DOCUMENT_TYPE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$DocumentType, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Notation() {}
$47eb2057f4163810$var$Notation.prototype.nodeType = $47eb2057f4163810$var$NOTATION_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Notation, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Entity() {}
$47eb2057f4163810$var$Entity.prototype.nodeType = $47eb2057f4163810$var$ENTITY_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Entity, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$EntityReference() {}
$47eb2057f4163810$var$EntityReference.prototype.nodeType = $47eb2057f4163810$var$ENTITY_REFERENCE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$EntityReference, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$DocumentFragment() {}
$47eb2057f4163810$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$47eb2057f4163810$var$DocumentFragment.prototype.nodeType = $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$DocumentFragment, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$ProcessingInstruction() {}
$47eb2057f4163810$var$ProcessingInstruction.prototype.nodeType = $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$ProcessingInstruction, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$XMLSerializer() {}
/**
 * Returns the result of serializing `node` to XML.
 *
 * When `options.requireWellFormed` is `true`, the serializer throws for content that would
 * produce ill-formed XML.
 *
 * __This implementation differs from the specification:__
 * - CDATASection nodes whose data contains `]]>` are serialized by splitting the section
 *   at each `]]>` occurrence (following W3C DOM Level 3 Core `split-cdata-sections`
 *   default behaviour) unless `requireWellFormed` is `true`.
 * - when `requireWellFormed` is `true`, `DOMException` with code `INVALID_STATE_ERR`
 *   is only thrown to prevent injection vectors, not for all the spec mandated checks.
 *
 * @param {Node} node
 * @param {boolean} [isHtml]
 * @param {function} [nodeFilter]
 * @param {Object} [options]
 * @param {boolean} [options.requireWellFormed=false]
 * When `true`, throws for content that would produce ill-formed XML.
 * @returns {string}
 * @throws {DOMException}
 * With code `INVALID_STATE_ERR` when `requireWellFormed` is `true` and:
 * - a CDATASection node's data contains `"]]>"`,
 * - a Comment node's data contains `"-->"` (bare `"--"` does not throw on this branch),
 * - a ProcessingInstruction's data contains `"?>"`,
 * - a DocumentType's `publicId` is non-empty and does not match the XML `PubidLiteral`
 *   production,
 * - a DocumentType's `systemId` is non-empty and does not match the XML `SystemLiteral`
 *   production, or
 * - a DocumentType's `internalSubset` contains `"]>"`.
 * Note: xmldom does not enforce `readonly` on DocumentType fields — direct property
 * writes succeed and are covered by the serializer-level checks above.
 * @see https://html.spec.whatwg.org/#dom-xmlserializer-serializetostring
 * @see https://w3c.github.io/DOM-Parsing/#xml-serialization
 * @see https://github.com/w3c/DOM-Parsing/issues/84
 */ $47eb2057f4163810$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter, options) {
    return $47eb2057f4163810$var$nodeSerializeToString.call(node, isHtml, nodeFilter, options);
};
$47eb2057f4163810$var$Node.prototype.toString = $47eb2057f4163810$var$nodeSerializeToString;
function $47eb2057f4163810$var$nodeSerializeToString(isHtml, nodeFilter, options) {
    var requireWellFormed = !!options && !!options.requireWellFormed;
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $47eb2057f4163810$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces, requireWellFormed);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $47eb2057f4163810$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $47eb2057f4163810$var$NAMESPACE.XML || uri === $47eb2057f4163810$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $47eb2057f4163810$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $47eb2057f4163810$var$_xmlEncoder), '"');
}
function $47eb2057f4163810$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces, requireWellFormed) {
    if (!visibleNamespaces) visibleNamespaces = [];
    $47eb2057f4163810$var$walkDOM(node, {
        ns: visibleNamespaces,
        isHTML: isHTML
    }, {
        enter: function(n, ctx) {
            var ns = ctx.ns;
            var html = ctx.isHTML;
            if (nodeFilter) {
                n = nodeFilter(n);
                if (n) {
                    if (typeof n == 'string') {
                        buf.push(n);
                        return null;
                    }
                } else return null;
            }
            switch(n.nodeType){
                case $47eb2057f4163810$var$ELEMENT_NODE:
                    var attrs = n.attributes;
                    var len = attrs.length;
                    var nodeName = n.tagName;
                    html = $47eb2057f4163810$var$NAMESPACE.isHTML(n.namespaceURI) || html;
                    var prefixedNodeName = nodeName;
                    if (!html && !n.prefix && n.namespaceURI) {
                        var defaultNS;
                        // lookup current default ns from `xmlns` attribute
                        for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                            defaultNS = attrs.item(ai).value;
                            break;
                        }
                        if (!defaultNS) // lookup current default ns in visibleNamespaces
                        for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.prefix === '' && nsEntry.namespace === n.namespaceURI) {
                                defaultNS = nsEntry.namespace;
                                break;
                            }
                        }
                        if (defaultNS !== n.namespaceURI) for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.namespace === n.namespaceURI) {
                                if (nsEntry.prefix) prefixedNodeName = nsEntry.prefix + ':' + nodeName;
                                break;
                            }
                        }
                    }
                    buf.push('<', prefixedNodeName);
                    // Build a fresh namespace snapshot for this element's children.
                    // The slice prevents sibling elements from inheriting each other's declarations.
                    var childNs = ns.slice();
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if (attr.prefix == 'xmlns') childNs.push({
                            prefix: attr.localName,
                            namespace: attr.value
                        });
                        else if (attr.nodeName == 'xmlns') childNs.push({
                            prefix: '',
                            namespace: attr.value
                        });
                    }
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if ($47eb2057f4163810$var$needNamespaceDefine(attr, html, childNs)) {
                            var attrPrefix = attr.prefix || '';
                            var uri = attr.namespaceURI;
                            $47eb2057f4163810$var$addSerializedAttribute(buf, attrPrefix ? 'xmlns:' + attrPrefix : 'xmlns', uri);
                            childNs.push({
                                prefix: attrPrefix,
                                namespace: uri
                            });
                        }
                        // Apply nodeFilter and serialize the attribute.
                        var filteredAttr = nodeFilter ? nodeFilter(attr) : attr;
                        if (filteredAttr) {
                            if (typeof filteredAttr === 'string') buf.push(filteredAttr);
                            else $47eb2057f4163810$var$addSerializedAttribute(buf, filteredAttr.name, filteredAttr.value);
                        }
                    }
                    // add namespace for current node
                    if (nodeName === prefixedNodeName && $47eb2057f4163810$var$needNamespaceDefine(n, html, childNs)) {
                        var nodePrefix = n.prefix || '';
                        var uri = n.namespaceURI;
                        $47eb2057f4163810$var$addSerializedAttribute(buf, nodePrefix ? 'xmlns:' + nodePrefix : 'xmlns', uri);
                        childNs.push({
                            prefix: nodePrefix,
                            namespace: uri
                        });
                    }
                    var child = n.firstChild;
                    if (child || html && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                        buf.push('>');
                        if (html && /^script$/i.test(nodeName)) {
                            // Inline serialization for <script> children; return null to skip walkDOM descent.
                            while(child){
                                if (child.data) buf.push(child.data);
                                else $47eb2057f4163810$var$serializeToString(child, buf, html, nodeFilter, childNs.slice(), requireWellFormed);
                                child = child.nextSibling;
                            }
                            buf.push('</', nodeName, '>');
                            return null;
                        }
                        // Return child context; walkDOM descends and exit emits the closing tag.
                        return {
                            ns: childNs,
                            isHTML: html,
                            tag: prefixedNodeName
                        };
                    } else {
                        buf.push('/>');
                        return null;
                    }
                case $47eb2057f4163810$var$DOCUMENT_NODE:
                case $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE:
                    // Descend into children; exit is a no-op (tag is null).
                    return {
                        ns: ns.slice(),
                        isHTML: html,
                        tag: null
                    };
                case $47eb2057f4163810$var$ATTRIBUTE_NODE:
                    $47eb2057f4163810$var$addSerializedAttribute(buf, n.name, n.value);
                    return null;
                case $47eb2057f4163810$var$TEXT_NODE:
                    /**
					 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
					 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
					 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
					 * `&amp;` and `&lt;` respectively.
					 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
					 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
					 * when that string is not marking the end of a CDATA section.
					 *
					 * In the content of elements, character data is any string of characters
					 * which does not contain the start-delimiter of any markup
					 * and does not include the CDATA-section-close delimiter, `]]>`.
					 *
					 * @see https://www.w3.org/TR/xml/#NT-CharData
					 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
					 */ buf.push(n.data.replace(/[<&>]/g, $47eb2057f4163810$var$_xmlEncoder));
                    return null;
                case $47eb2057f4163810$var$CDATA_SECTION_NODE:
                    if (requireWellFormed && n.data.indexOf(']]>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The CDATASection data contains "]]>"');
                    buf.push('<![CDATA[', n.data.replace(/]]>/g, ']]]]><![CDATA[>'), ']]>');
                    return null;
                case $47eb2057f4163810$var$COMMENT_NODE:
                    if (requireWellFormed && n.data.indexOf('-->') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The comment node data contains "-->"');
                    buf.push('<!--', n.data, '-->');
                    return null;
                case $47eb2057f4163810$var$DOCUMENT_TYPE_NODE:
                    if (requireWellFormed) {
                        if (n.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(n.publicId)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType publicId is not a valid PubidLiteral');
                        if (n.systemId && !/^("[^"]*"|'[^']*')$/.test(n.systemId)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType systemId is not a valid SystemLiteral');
                        if (n.internalSubset && n.internalSubset.indexOf(']>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType internalSubset contains "]>"');
                    }
                    var pubid = n.publicId;
                    var sysid = n.systemId;
                    buf.push('<!DOCTYPE ', n.name);
                    if (pubid) {
                        buf.push(' PUBLIC ', pubid);
                        if (sysid && sysid != '.') buf.push(' ', sysid);
                        buf.push('>');
                    } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
                    else {
                        var sub = n.internalSubset;
                        if (sub) buf.push(' [', sub, ']');
                        buf.push('>');
                    }
                    return null;
                case $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE:
                    if (requireWellFormed && n.data.indexOf('?>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The ProcessingInstruction data contains "?>"');
                    buf.push('<?', n.target, ' ', n.data, '?>');
                    return null;
                case $47eb2057f4163810$var$ENTITY_REFERENCE_NODE:
                    buf.push('&', n.nodeName, ';');
                    return null;
                //case ENTITY_NODE:
                //case NOTATION_NODE:
                default:
                    buf.push('??', n.nodeName);
                    return null;
            }
        },
        exit: function(n, childCtx) {
            if (childCtx && childCtx.tag) buf.push('</', childCtx.tag, '>');
        }
    });
}
/**
 * Imports a node from a different document into `doc`, creating a new copy.
 * Delegates to {@link walkDOM} for traversal. Each node in the subtree is shallow-cloned,
 * stamped with `doc` as its `ownerDocument`, and detached (`parentNode` set to `null`).
 * Children are imported recursively when `deep` is `true`; for {@link Attr} nodes `deep` is
 * always forced to `true`
 * because an attribute's value lives in a child text node.
 *
 * @param {Document} doc
 * The document that will own the imported node.
 * @param {Node} node
 * The node to import.
 * @param {boolean} deep
 * If `true`, descendants are imported recursively.
 * @returns {Node}
 * The newly imported node, now owned by `doc`.
 */ function $47eb2057f4163810$var$importNode(doc, node, deep) {
    var destRoot;
    $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // Shallow-clone the node and stamp it into the target document.
            var destNode = srcNode.cloneNode(false);
            destNode.ownerDocument = doc;
            destNode.parentNode = null;
            // capture as the root of the imported subtree or attach to parent.
            if (destParent === null) destRoot = destNode;
            else destParent.appendChild(destNode);
            // ATTRIBUTE_NODE must always be imported deeply: its value lives in a child text node.
            var shouldDeep = srcNode.nodeType === $47eb2057f4163810$var$ATTRIBUTE_NODE || deep;
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $47eb2057f4163810$var$cloneNode(doc, node, deep) {
    var destRoot;
    $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // 1. Create a blank node of the same type and copy all scalar own properties.
            var destNode = new srcNode.constructor();
            for(var n in srcNode)if (Object.prototype.hasOwnProperty.call(srcNode, n)) {
                var v = srcNode[n];
                if (typeof v != 'object') {
                    if (v != destNode[n]) destNode[n] = v;
                }
            }
            if (srcNode.childNodes) destNode.childNodes = new $47eb2057f4163810$var$NodeList();
            destNode.ownerDocument = doc;
            // 2. Handle node-type-specific setup.
            //    Attributes are not DOM children, so they are cloned inline here
            //    rather than by walkDOM descent.
            //    ATTRIBUTE_NODE forces deep=true so its own children are walked.
            var shouldDeep = deep;
            switch(destNode.nodeType){
                case $47eb2057f4163810$var$ELEMENT_NODE:
                    var attrs = srcNode.attributes;
                    var attrs2 = destNode.attributes = new $47eb2057f4163810$var$NamedNodeMap();
                    var len = attrs.length;
                    attrs2._ownerElement = destNode;
                    for(var i = 0; i < len; i++)destNode.setAttributeNode($47eb2057f4163810$var$cloneNode(doc, attrs.item(i), true));
                    break;
                case $47eb2057f4163810$var$ATTRIBUTE_NODE:
                    shouldDeep = true;
            }
            // 3. Attach to parent, or capture as the root of the cloned subtree.
            if (destParent !== null) destParent.appendChild(destNode);
            else destRoot = destNode;
            // 4. Return destNode as the context for children (causes walkDOM to descend),
            //    or null to skip children (shallow clone).
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
function $47eb2057f4163810$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($47eb2057f4163810$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $47eb2057f4163810$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        /**
		 * The text content of this node and its descendants.
		 *
		 * Setting `textContent` on an element or document fragment replaces all child nodes with a
		 * single text node; on other nodes it sets `data`, `value`, and `nodeValue` directly.
		 *
		 * @type {string | null}
		 * @see {@link https://dom.spec.whatwg.org/#dom-node-textcontent}
		 */ Object.defineProperty($47eb2057f4163810$var$Node.prototype, 'textContent', {
            get: function() {
                if (this.nodeType === $47eb2057f4163810$var$ELEMENT_NODE || this.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
                    var buf = [];
                    $47eb2057f4163810$var$walkDOM(this, null, {
                        enter: function(n) {
                            if (n.nodeType === $47eb2057f4163810$var$ELEMENT_NODE || n.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) return true; // enter children
                            if (n.nodeType === $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE || n.nodeType === $47eb2057f4163810$var$COMMENT_NODE) return null; // excluded from text content
                            buf.push(n.nodeValue);
                        }
                    });
                    return buf.join('');
                }
                return this.nodeValue;
            },
            set: function(data) {
                switch(this.nodeType){
                    case $47eb2057f4163810$var$ELEMENT_NODE:
                    case $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        $47eb2057f4163810$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$47eb2057f4163810$export$d1d99cf900472499 = $47eb2057f4163810$var$DocumentType;
$47eb2057f4163810$export$fe58bcf938607f6a = $47eb2057f4163810$var$DOMException;
$47eb2057f4163810$export$455426655eab1d48 = $47eb2057f4163810$var$DOMImplementation;
$47eb2057f4163810$export$db77ccec0bb4ccac = $47eb2057f4163810$var$Element;
$47eb2057f4163810$export$85c928794f8d04d4 = $47eb2057f4163810$var$Node;
$47eb2057f4163810$export$79b41aa5d56abdff = $47eb2057f4163810$var$NodeList;
$47eb2057f4163810$export$5118471ee5d5453b = $47eb2057f4163810$var$walkDOM;
$47eb2057f4163810$export$64f0bed4ae6f0f24 = $47eb2057f4163810$var$XMLSerializer; //}

});
parcelRegister("aeRet", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $774481049d9a42bd$export$71aa6c912b956294; }, function (v) { return $774481049d9a42bd$export$71aa6c912b956294 = v; });
$parcel$export(module.exports, "freeze", function () { return $774481049d9a42bd$export$792f3d81ea979f55; }, function (v) { return $774481049d9a42bd$export$792f3d81ea979f55 = v; });
$parcel$export(module.exports, "NAMESPACE", function () { return $774481049d9a42bd$export$6aad947bda0f3f46; }, function (v) { return $774481049d9a42bd$export$6aad947bda0f3f46 = v; });
var $774481049d9a42bd$export$e6e34fd1f2686227;
var $774481049d9a42bd$export$71aa6c912b956294;
var $774481049d9a42bd$export$792f3d81ea979f55;
var $774481049d9a42bd$export$c6cb9dd1e3ada1aa;
var $774481049d9a42bd$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $774481049d9a42bd$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $774481049d9a42bd$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $774481049d9a42bd$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $774481049d9a42bd$var$MIME_TYPE = $774481049d9a42bd$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $774481049d9a42bd$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $774481049d9a42bd$var$NAMESPACE = $774481049d9a42bd$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $774481049d9a42bd$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$774481049d9a42bd$export$e6e34fd1f2686227 = $774481049d9a42bd$var$assign;
$774481049d9a42bd$export$71aa6c912b956294 = $774481049d9a42bd$var$find;
$774481049d9a42bd$export$792f3d81ea979f55 = $774481049d9a42bd$var$freeze;
$774481049d9a42bd$export$c6cb9dd1e3ada1aa = $774481049d9a42bd$var$MIME_TYPE;
$774481049d9a42bd$export$6aad947bda0f3f46 = $774481049d9a42bd$var$NAMESPACE;

});


parcelRegister("dQ0RX", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $a130ce54fd9772f1$export$1059c6e7d2ce5669; }, function (v) { return $a130ce54fd9772f1$export$1059c6e7d2ce5669 = v; });
var $a130ce54fd9772f1$export$181392475aa39887;
var $a130ce54fd9772f1$export$ba13e0e2f19e61a1;
var $a130ce54fd9772f1$export$1059c6e7d2ce5669;

var $aeRet = parcelRequire("aeRet");

var $6aORb = parcelRequire("6aORb");

var $3vNAZ = parcelRequire("3vNAZ");

var $lejlD = parcelRequire("lejlD");
var $a130ce54fd9772f1$var$DOMImplementation = $6aORb.DOMImplementation;
var $a130ce54fd9772f1$var$NAMESPACE = $aeRet.NAMESPACE;
var $a130ce54fd9772f1$var$ParseError = $lejlD.ParseError;
var $a130ce54fd9772f1$var$XMLReader = $lejlD.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $a130ce54fd9772f1$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $a130ce54fd9772f1$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$a130ce54fd9772f1$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $a130ce54fd9772f1$var$XMLReader();
    var domBuilder = options.domBuilder || new $a130ce54fd9772f1$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $3vNAZ.HTML_ENTITIES : $3vNAZ.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $a130ce54fd9772f1$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $a130ce54fd9772f1$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $a130ce54fd9772f1$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $a130ce54fd9772f1$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $a130ce54fd9772f1$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $a130ce54fd9772f1$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $a130ce54fd9772f1$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $a130ce54fd9772f1$var$DOMHandler() {
    this.cdata = false;
}
function $a130ce54fd9772f1$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $a130ce54fd9772f1$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $a130ce54fd9772f1$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $a130ce54fd9772f1$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $a130ce54fd9772f1$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $a130ce54fd9772f1$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $a130ce54fd9772f1$var$position(this.locator, ins);
        $a130ce54fd9772f1$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $a130ce54fd9772f1$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $a130ce54fd9772f1$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $a130ce54fd9772f1$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $a130ce54fd9772f1$var$position(this.locator, comm);
        $a130ce54fd9772f1$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $a130ce54fd9772f1$var$position(this.locator, dt);
            $a130ce54fd9772f1$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $a130ce54fd9772f1$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $a130ce54fd9772f1$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $a130ce54fd9772f1$var$ParseError(error, this.locator);
    }
};
function $a130ce54fd9772f1$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $a130ce54fd9772f1$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $a130ce54fd9772f1$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $a130ce54fd9772f1$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$a130ce54fd9772f1$export$181392475aa39887 = $a130ce54fd9772f1$var$DOMHandler;
$a130ce54fd9772f1$export$ba13e0e2f19e61a1 = $a130ce54fd9772f1$var$normalizeLineEndings;
$a130ce54fd9772f1$export$1059c6e7d2ce5669 = $a130ce54fd9772f1$var$DOMParser;

});
parcelRegister("3vNAZ", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", function () { return $28eabcfdb4821410$export$91f0e5ff03dc84f; }, function (v) { return $28eabcfdb4821410$export$91f0e5ff03dc84f = v; });
$parcel$export(module.exports, "HTML_ENTITIES", function () { return $28eabcfdb4821410$export$b7e4d4631df36afa; }, function (v) { return $28eabcfdb4821410$export$b7e4d4631df36afa = v; });
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $28eabcfdb4821410$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $28eabcfdb4821410$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $28eabcfdb4821410$export$79451380caed3f98;
'use strict';

var $aeRet = parcelRequire("aeRet");
var $28eabcfdb4821410$require$freeze = $aeRet.freeze;
$28eabcfdb4821410$export$91f0e5ff03dc84f = $28eabcfdb4821410$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$28eabcfdb4821410$export$b7e4d4631df36afa = $28eabcfdb4821410$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$28eabcfdb4821410$export$79451380caed3f98 = $28eabcfdb4821410$export$b7e4d4631df36afa;

});

parcelRegister("lejlD", function(module, exports) {

$parcel$export(module.exports, "XMLReader", function () { return $f749e9e42fd6b8a6$export$ccbc9f9f018333e9; }, function (v) { return $f749e9e42fd6b8a6$export$ccbc9f9f018333e9 = v; });
$parcel$export(module.exports, "ParseError", function () { return $f749e9e42fd6b8a6$export$f9c837a54db411d; }, function (v) { return $f749e9e42fd6b8a6$export$f9c837a54db411d = v; });
var $f749e9e42fd6b8a6$export$ccbc9f9f018333e9;
var $f749e9e42fd6b8a6$export$f9c837a54db411d;

var $aeRet = parcelRequire("aeRet");
var $f749e9e42fd6b8a6$require$NAMESPACE = $aeRet.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $f749e9e42fd6b8a6$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $f749e9e42fd6b8a6$var$nameChar = new RegExp("[\\-\\.0-9" + $f749e9e42fd6b8a6$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $f749e9e42fd6b8a6$var$tagNamePattern = new RegExp('^' + $f749e9e42fd6b8a6$var$nameStartChar.source + $f749e9e42fd6b8a6$var$nameChar.source + '*(?:\:' + $f749e9e42fd6b8a6$var$nameStartChar.source + $f749e9e42fd6b8a6$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $f749e9e42fd6b8a6$var$S_TAG = 0; //tag name offerring
var $f749e9e42fd6b8a6$var$S_ATTR = 1; //attr name offerring
var $f749e9e42fd6b8a6$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $f749e9e42fd6b8a6$var$S_EQ = 3; //=space?
var $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $f749e9e42fd6b8a6$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $f749e9e42fd6b8a6$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $f749e9e42fd6b8a6$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $f749e9e42fd6b8a6$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $f749e9e42fd6b8a6$var$ParseError);
}
$f749e9e42fd6b8a6$var$ParseError.prototype = new Error();
$f749e9e42fd6b8a6$var$ParseError.prototype.name = $f749e9e42fd6b8a6$var$ParseError.name;
function $f749e9e42fd6b8a6$var$XMLReader() {}
$f749e9e42fd6b8a6$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $f749e9e42fd6b8a6$var$_copy(defaultNSMap, defaultNSMap = {});
        $f749e9e42fd6b8a6$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $f749e9e42fd6b8a6$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $f749e9e42fd6b8a6$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $f749e9e42fd6b8a6$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $f749e9e42fd6b8a6$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $f749e9e42fd6b8a6$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $f749e9e42fd6b8a6$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $f749e9e42fd6b8a6$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $f749e9e42fd6b8a6$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($f749e9e42fd6b8a6$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $f749e9e42fd6b8a6$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $f749e9e42fd6b8a6$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $f749e9e42fd6b8a6$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $f749e9e42fd6b8a6$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $f749e9e42fd6b8a6$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $f749e9e42fd6b8a6$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $f749e9e42fd6b8a6$var$S_EQ;
                } else if (s === $f749e9e42fd6b8a6$var$S_ATTR_SPACE) s = $f749e9e42fd6b8a6$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $f749e9e42fd6b8a6$var$S_EQ || s === $f749e9e42fd6b8a6$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $f749e9e42fd6b8a6$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $f749e9e42fd6b8a6$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $f749e9e42fd6b8a6$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        s = $f749e9e42fd6b8a6$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $f749e9e42fd6b8a6$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        break; //normal
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        if (s === $f749e9e42fd6b8a6$var$S_ATTR_SPACE) value = attrName;
                        if (s == $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$f749e9e42fd6b8a6$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $f749e9e42fd6b8a6$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $f749e9e42fd6b8a6$var$S_TAG_SPACE;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $f749e9e42fd6b8a6$var$S_ATTR_SPACE;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                        s = $f749e9e42fd6b8a6$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$f749e9e42fd6b8a6$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $f749e9e42fd6b8a6$var$S_ATTR;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                        s = $f749e9e42fd6b8a6$var$S_ATTR;
                        start = p;
                        break;
                    case $f749e9e42fd6b8a6$var$S_EQ:
                        s = $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $f749e9e42fd6b8a6$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $f749e9e42fd6b8a6$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $f749e9e42fd6b8a6$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $f749e9e42fd6b8a6$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $f749e9e42fd6b8a6$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $f749e9e42fd6b8a6$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $f749e9e42fd6b8a6$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $f749e9e42fd6b8a6$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $f749e9e42fd6b8a6$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $f749e9e42fd6b8a6$var$ElementAttributes() {
    this.attributeNames = {};
}
$f749e9e42fd6b8a6$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$f749e9e42fd6b8a6$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$f749e9e42fd6b8a6$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $f749e9e42fd6b8a6$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$f749e9e42fd6b8a6$export$ccbc9f9f018333e9 = $f749e9e42fd6b8a6$var$XMLReader;
$f749e9e42fd6b8a6$export$f9c837a54db411d = $f749e9e42fd6b8a6$var$ParseError;

});




parcelRegister("doJbW", function(module, exports) {

$parcel$export(module.exports, "Element", function () { return $9c10925a27a67aa2$export$db77ccec0bb4ccac; }, function (v) { return $9c10925a27a67aa2$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "element", function () { return $9c10925a27a67aa2$export$8454457683f90105; }, function (v) { return $9c10925a27a67aa2$export$8454457683f90105 = v; });
$parcel$export(module.exports, "text", function () { return $9c10925a27a67aa2$export$6f093cfa640b7166; }, function (v) { return $9c10925a27a67aa2$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "emptyElement", function () { return $9c10925a27a67aa2$export$ae6de35c16b306df; }, function (v) { return $9c10925a27a67aa2$export$ae6de35c16b306df = v; });
var $9c10925a27a67aa2$export$db77ccec0bb4ccac;
var $9c10925a27a67aa2$export$8454457683f90105;
var $9c10925a27a67aa2$export$6f093cfa640b7166;
var $9c10925a27a67aa2$export$ae6de35c16b306df;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $efEt3 = parcelRequire("efEt3");
var $bss2W = parcelRequire("bss2W");
var $1TwZj = parcelRequire("1TwZj");
$9c10925a27a67aa2$export$db77ccec0bb4ccac = $9c10925a27a67aa2$var$Element;
$9c10925a27a67aa2$export$8454457683f90105 = function(name, attributes, children) {
    return new $9c10925a27a67aa2$var$Element(name, attributes, children);
};
$9c10925a27a67aa2$export$6f093cfa640b7166 = function(value) {
    return {
        type: "text",
        value: value
    };
};
var $9c10925a27a67aa2$var$emptyElement = $9c10925a27a67aa2$export$ae6de35c16b306df = {
    first: function() {
        return null;
    },
    firstOrEmpty: function() {
        return $9c10925a27a67aa2$var$emptyElement;
    },
    attributes: {},
    children: []
};
function $9c10925a27a67aa2$var$Element(name, attributes, children) {
    this.type = "element";
    this.name = name;
    this.attributes = attributes || {};
    this.children = children || [];
}
$9c10925a27a67aa2$var$Element.prototype.first = function(name) {
    return $bss2W.default(this.children, function(child) {
        return child.name === name;
    });
};
$9c10925a27a67aa2$var$Element.prototype.firstOrEmpty = function(name) {
    return this.first(name) || $9c10925a27a67aa2$var$emptyElement;
};
$9c10925a27a67aa2$var$Element.prototype.getElementsByTagName = function(name) {
    var elements = $efEt3.default(this.children, function(child) {
        return child.name === name;
    });
    return $9c10925a27a67aa2$var$toElementList(elements);
};
$9c10925a27a67aa2$var$Element.prototype.text = function() {
    if (this.children.length === 0) return "";
    else if (this.children.length !== 1 || this.children[0].type !== "text") throw new Error("Not implemented");
    return this.children[0].value;
};
var $9c10925a27a67aa2$var$elementListPrototype = {
    getElementsByTagName: function(name) {
        return $9c10925a27a67aa2$var$toElementList($1TwZj.default(this.map(function(element) {
            return element.getElementsByTagName(name);
        }, true)));
    }
};
function $9c10925a27a67aa2$var$toElementList(array) {
    return $5yjjJ.default(array, $9c10925a27a67aa2$var$elementListPrototype);
}

});


parcelRegister("42JRH", function(module, exports) {

$parcel$export(module.exports, "writeString", function () { return $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1; }, function (v) { return $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1 = v; });
var $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1;
parcelRequire("9jAvV");
var $bPbGS = parcelRequire("bPbGS");
var $loFvT = parcelRequire("loFvT");

var $lwIqU = parcelRequire("lwIqU");
$2f1aed2feaf91759$export$48a3ce3d8cfe0ce1 = $2f1aed2feaf91759$var$writeString;
function $2f1aed2feaf91759$var$writeString(root, namespaces) {
    var uriToPrefix = $loFvT.default(namespaces);
    var nodeWriters = {
        element: writeElement,
        text: $2f1aed2feaf91759$var$writeTextNode
    };
    function writeNode(builder, node) {
        return nodeWriters[node.type](builder, node);
    }
    function writeElement(builder, element) {
        var elementBuilder = builder.element(mapElementName(element.name), element.attributes);
        element.children.forEach(function(child) {
            writeNode(elementBuilder, child);
        });
    }
    function mapElementName(name) {
        var longFormMatch = /^\{(.*)\}(.*)$/.exec(name);
        if (longFormMatch) {
            var prefix = uriToPrefix[longFormMatch[1]];
            return prefix + (prefix === "" ? "" : ":") + longFormMatch[2];
        } else return name;
    }
    function writeDocument(root) {
        var builder = $lwIqU.create(mapElementName(root.name), {
            version: '1.0',
            encoding: 'UTF-8',
            standalone: true
        });
        $bPbGS.default(namespaces, function(uri, prefix) {
            var key = "xmlns" + (prefix === "" ? "" : ":" + prefix);
            builder.attribute(key, uri);
        });
        root.children.forEach(function(child) {
            writeNode(builder, child);
        });
        return builder.end();
    }
    return writeDocument(root);
}
function $2f1aed2feaf91759$var$writeTextNode(builder, node) {
    builder.text(node.value);
}

});
parcelRegister("lwIqU", function(module, exports) {





// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
    ref = (parcelRequire("lHgzn")), assign = ref.assign, isFunction = ref.isFunction;
    XMLDocument = (parcelRequire("lxI7F"));
    XMLDocumentCB = (parcelRequire("fJ5z4"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    XMLStreamWriter = (parcelRequire("9ZWoi"));
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        doc = new XMLDocument(options);
        root = doc.element(name);
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.doctype(options);
        }
        return root;
    };
    module.exports.begin = function(options, onData, onEnd) {
        var ref1;
        if (isFunction(options)) {
            ref1 = [
                options,
                onData
            ], onData = ref1[0], onEnd = ref1[1];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
}).call(module.exports);

});
parcelRegister("lHgzn", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, slice = [].slice, hasProp = {}.hasOwnProperty;
    assign = function() {
        var i, key, len, source, sources, target;
        target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === '[object Function]';
    };
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === 'function' || ref === 'object');
    };
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === '[object Array]';
    };
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(module.exports);

});

parcelRegister("lxI7F", function(module, exports) {




// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isPlainObject = (parcelRequire("lHgzn")).isPlainObject;
    XMLNode = (parcelRequire("4iKOt"));
    XMLStringifier = (parcelRequire("7epDt"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    module.exports = XMLDocument = function(superClass) {
        extend(XMLDocument, superClass);
        function XMLDocument(options) {
            XMLDocument.__super__.constructor.call(this, null);
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter();
            this.options = options;
            this.stringify = new XMLStringifier(options);
            this.isDocument = true;
        }
        XMLDocument.prototype.end = function(writer) {
            var writerOptions;
            if (!writer) writer = this.options.writer;
            else if (isPlainObject(writer)) {
                writerOptions = writer;
                writer = this.options.writer.set(writerOptions);
            }
            return writer.document(this);
        };
        XMLDocument.prototype.toString = function(options) {
            return this.options.writer.set(options).document(this);
        };
        return XMLDocument;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("4iKOt", function(module, exports) {










// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty, getValue = ref.getValue;
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    module.exports = XMLNode = function() {
        function XMLNode(parent) {
            this.parent = parent;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            this.children = [];
            if (!XMLElement) {
                XMLElement = (parcelRequire("75p21"));
                XMLCData = (parcelRequire("fR48K"));
                XMLComment = (parcelRequire("hoAyy"));
                XMLDeclaration = (parcelRequire("hIqqu"));
                XMLDocType = (parcelRequire("8SEjQ"));
                XMLRaw = (parcelRequire("eM366"));
                XMLText = (parcelRequire("cVqM2"));
                XMLProcessingInstruction = (parcelRequire("fDRfY"));
                XMLDummy = (parcelRequire("5k1kJ"));
            }
        }
        XMLNode.prototype.element = function(name, attributes, text) {
            var childNode, item, j, k, key, lastChild, len, len1, ref1, ref2, val;
            lastChild = null;
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            if (name != null) name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                item = name[j];
                lastChild = this.element(item);
            }
            else if (isFunction(name)) lastChild = this.element(name.apply());
            else if (isObject(name)) for(key in name){
                if (!hasProp.call(name, key)) continue;
                val = name[key];
                if (isFunction(val)) val = val.apply();
                if (isObject(val) && isEmpty(val)) val = null;
                if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                    item = val[k];
                    childNode = {};
                    childNode[key] = item;
                    lastChild = this.element(childNode);
                }
                else if (isObject(val)) {
                    lastChild = this.element(key);
                    lastChild.element(val);
                } else lastChild = this.element(key, val);
            }
            else if (this.options.skipNullNodes && text === null) lastChild = this.dummy();
            else {
                if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                else lastChild = this.node(name, attributes, text);
            }
            if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
            return lastChild;
        };
        XMLNode.prototype.insertBefore = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.insertAfter = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.remove = function() {
            var i, ref1;
            if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
            i = this.parent.children.indexOf(this);
            [].splice.apply(this.parent.children, [
                i,
                i - i + 1
            ].concat(ref1 = [])), ref1;
            return this.parent;
        };
        XMLNode.prototype.node = function(name, attributes, text) {
            var child, ref1;
            if (name != null) name = getValue(name);
            attributes || (attributes = {});
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref1 = [
                attributes,
                text
            ], text = ref1[0], attributes = ref1[1];
            child = new XMLElement(this, name, attributes);
            if (text != null) child.text(text);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.text = function(value) {
            var child;
            child = new XMLText(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.cdata = function(value) {
            var child;
            child = new XMLCData(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.comment = function(value) {
            var child;
            child = new XMLComment(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.commentBefore = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.commentAfter = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.raw = function(value) {
            var child;
            child = new XMLRaw(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.dummy = function() {
            var child;
            child = new XMLDummy(this);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.instruction = function(target, value) {
            var insTarget, insValue, instruction, j, len;
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                insTarget = target[j];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                instruction = new XMLProcessingInstruction(this, target, value);
                this.children.push(instruction);
            }
            return this;
        };
        XMLNode.prototype.instructionBefore = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.instructionAfter = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.declaration = function(version, encoding, standalone) {
            var doc, xmldec;
            doc = this.document();
            xmldec = new XMLDeclaration(doc, version, encoding, standalone);
            if (doc.children[0] instanceof XMLDeclaration) doc.children[0] = xmldec;
            else doc.children.unshift(xmldec);
            return doc.root() || doc;
        };
        XMLNode.prototype.doctype = function(pubID, sysID) {
            var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
            doc = this.document();
            doctype = new XMLDocType(doc, pubID, sysID);
            ref1 = doc.children;
            for(i = j = 0, len = ref1.length; j < len; i = ++j){
                child = ref1[i];
                if (child instanceof XMLDocType) {
                    doc.children[i] = doctype;
                    return doctype;
                }
            }
            ref2 = doc.children;
            for(i = k = 0, len1 = ref2.length; k < len1; i = ++k){
                child = ref2[i];
                if (child.isRoot) {
                    doc.children.splice(i, 0, doctype);
                    return doctype;
                }
            }
            doc.children.push(doctype);
            return doctype;
        };
        XMLNode.prototype.up = function() {
            if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
            return this.parent;
        };
        XMLNode.prototype.root = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node.rootObject;
                else if (node.isRoot) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.document = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.end = function(options) {
            return this.document().end(options);
        };
        XMLNode.prototype.prev = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i > 0 && this.parent.children[i - 1].isDummy)i = i - 1;
            if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
            return this.parent.children[i - 1];
        };
        XMLNode.prototype.next = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i < this.parent.children.length - 1 && this.parent.children[i + 1].isDummy)i = i + 1;
            if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
            return this.parent.children[i + 1];
        };
        XMLNode.prototype.importDocument = function(doc) {
            var clonedRoot;
            clonedRoot = doc.root().clone();
            clonedRoot.parent = this;
            clonedRoot.isRoot = false;
            this.children.push(clonedRoot);
            return this;
        };
        XMLNode.prototype.debugInfo = function(name) {
            var ref1, ref2;
            name = name || this.name;
            if (name == null && !((ref1 = this.parent) != null ? ref1.name : void 0)) return "";
            else if (name == null) return "parent: <" + this.parent.name + ">";
            else if (!((ref2 = this.parent) != null ? ref2.name : void 0)) return "node: <" + name + ">";
            else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
        };
        XMLNode.prototype.ele = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.doc = function() {
            return this.document();
        };
        XMLNode.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLNode.prototype.dtd = function(pubID, sysID) {
            return this.doctype(pubID, sysID);
        };
        XMLNode.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.t = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLNode.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.u = function() {
            return this.up();
        };
        XMLNode.prototype.importXMLBuilder = function(doc) {
            return this.importDocument(doc);
        };
        return XMLNode;
    }();
}).call(module.exports);

});
parcelRegister("75p21", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLElement, XMLNode, getValue, isFunction, isObject, ref, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;
    XMLNode = (parcelRequire("4iKOt"));
    XMLAttribute = (parcelRequire("4THOq"));
    module.exports = XMLElement = function(superClass) {
        extend(XMLElement, superClass);
        function XMLElement(parent, name, attributes) {
            XMLElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing element name. " + this.debugInfo());
            this.name = this.stringify.eleName(name);
            this.attributes = {};
            if (attributes != null) this.attribute(attributes);
            if (parent.isDocument) {
                this.isRoot = true;
                this.documentObject = parent;
                parent.rootObject = this;
            }
        }
        XMLElement.prototype.clone = function() {
            var att, attName, clonedSelf, ref1;
            clonedSelf = Object.create(this);
            if (clonedSelf.isRoot) clonedSelf.documentObject = null;
            clonedSelf.attributes = {};
            ref1 = this.attributes;
            for(attName in ref1){
                if (!hasProp.call(ref1, attName)) continue;
                att = ref1[attName];
                clonedSelf.attributes[attName] = att.clone();
            }
            clonedSelf.children = [];
            this.children.forEach(function(child) {
                var clonedChild;
                clonedChild = child.clone();
                clonedChild.parent = clonedSelf;
                return clonedSelf.children.push(clonedChild);
            });
            return clonedSelf;
        };
        XMLElement.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLElement.prototype.removeAttribute = function(name) {
            var attName, i, len;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
            name = getValue(name);
            if (Array.isArray(name)) for(i = 0, len = name.length; i < len; i++){
                attName = name[i];
                delete this.attributes[attName];
            }
            else delete this.attributes[name];
            return this;
        };
        XMLElement.prototype.toString = function(options) {
            return this.options.writer.set(options).element(this);
        };
        XMLElement.prototype.att = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.a = function(name, value) {
            return this.attribute(name, value);
        };
        return XMLElement;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("4THOq", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute;
    module.exports = XMLAttribute = function() {
        function XMLAttribute(parent, name, value) {
            this.options = parent.options;
            this.stringify = parent.stringify;
            this.parent = parent;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing attribute value. " + this.debugInfo(name));
            this.name = this.stringify.attName(name);
            this.value = this.stringify.attValue(value);
        }
        XMLAttribute.prototype.clone = function() {
            return Object.create(this);
        };
        XMLAttribute.prototype.toString = function(options) {
            return this.options.writer.set(options).attribute(this);
        };
        XMLAttribute.prototype.debugInfo = function(name) {
            name = name || this.name;
            if (name == null) return "parent: <" + this.parent.name + ">";
            else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
        };
        return XMLAttribute;
    }();
}).call(module.exports);

});


parcelRegister("fR48K", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLCData = function(superClass) {
        extend(XMLCData, superClass);
        function XMLCData(parent, text) {
            XMLCData.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.text = this.stringify.cdata(text);
        }
        XMLCData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCData.prototype.toString = function(options) {
            return this.options.writer.set(options).cdata(this);
        };
        return XMLCData;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("hoAyy", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLComment, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLComment = function(superClass) {
        extend(XMLComment, superClass);
        function XMLComment(parent, text) {
            XMLComment.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.text = this.stringify.comment(text);
        }
        XMLComment.prototype.clone = function() {
            return Object.create(this);
        };
        XMLComment.prototype.toString = function(options) {
            return this.options.writer.set(options).comment(this);
        };
        return XMLComment;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("hIqqu", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDeclaration, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDeclaration = function(superClass) {
        extend(XMLDeclaration, superClass);
        function XMLDeclaration(parent, version, encoding, standalone) {
            var ref;
            XMLDeclaration.__super__.constructor.call(this, parent);
            if (isObject(version)) ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
            if (!version) version = '1.0';
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        XMLDeclaration.prototype.toString = function(options) {
            return this.options.writer.set(options).declaration(this);
        };
        return XMLDeclaration;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("8SEjQ", function(module, exports) {






// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    module.exports = XMLDocType = function(superClass) {
        extend(XMLDocType, superClass);
        function XMLDocType(parent, pubID, sysID) {
            var ref, ref1;
            XMLDocType.__super__.constructor.call(this, parent);
            this.name = "!DOCTYPE";
            this.documentObject = parent;
            if (isObject(pubID)) ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
            if (sysID == null) ref1 = [
                pubID,
                sysID
            ], sysID = ref1[0], pubID = ref1[1];
            if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
            if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
        }
        XMLDocType.prototype.element = function(name, value) {
            var child;
            child = new XMLDTDElement(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var child;
            child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.entity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, false, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.pEntity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, true, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.notation = function(name, value) {
            var child;
            child = new XMLDTDNotation(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.toString = function(options) {
            return this.options.writer.set(options).docType(this);
        };
        XMLDocType.prototype.ele = function(name, value) {
            return this.element(name, value);
        };
        XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        };
        XMLDocType.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocType.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocType.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        XMLDocType.prototype.up = function() {
            return this.root() || this.documentObject;
        };
        return XMLDocType;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("2p5ir", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDAttList = function(superClass) {
        extend(XMLDTDAttList, superClass);
        function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            XMLDTDAttList.__super__.constructor.call(this, parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf('#') !== 0) defaultValueType = '#' + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.eleName(elementName);
            this.attributeName = this.stringify.attName(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        XMLDTDAttList.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdAttList(this);
        };
        return XMLDTDAttList;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("1skwc", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDEntity, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDEntity = function(superClass) {
        extend(XMLDTDEntity, superClass);
        function XMLDTDEntity(parent, pe, name, value) {
            XMLDTDEntity.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
            this.pe = !!pe;
            this.name = this.stringify.eleName(name);
            if (!isObject(value)) this.value = this.stringify.dtdEntityValue(value);
            else {
                if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
            }
        }
        XMLDTDEntity.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdEntity(this);
        };
        return XMLDTDEntity;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7tdGF", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDElement, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDElement = function(superClass) {
        extend(XMLDTDElement, superClass);
        function XMLDTDElement(parent, name, value) {
            XMLDTDElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = '(#PCDATA)';
            if (Array.isArray(value)) value = '(' + value.join(',') + ')';
            this.name = this.stringify.eleName(name);
            this.value = this.stringify.dtdElementValue(value);
        }
        XMLDTDElement.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdElement(this);
        };
        return XMLDTDElement;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7o9kV", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDNotation, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDNotation = function(superClass) {
        extend(XMLDTDNotation, superClass);
        function XMLDTDNotation(parent, name, value) {
            XMLDTDNotation.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
            if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
            this.name = this.stringify.eleName(name);
            if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
            if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        XMLDTDNotation.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdNotation(this);
        };
        return XMLDTDNotation;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("eM366", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLRaw, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLRaw = function(superClass) {
        extend(XMLRaw, superClass);
        function XMLRaw(parent, text) {
            XMLRaw.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.value = this.stringify.raw(text);
        }
        XMLRaw.prototype.clone = function() {
            return Object.create(this);
        };
        XMLRaw.prototype.toString = function(options) {
            return this.options.writer.set(options).raw(this);
        };
        return XMLRaw;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("cVqM2", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLText, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLText = function(superClass) {
        extend(XMLText, superClass);
        function XMLText(parent, text) {
            XMLText.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing element text. " + this.debugInfo());
            this.value = this.stringify.eleText(text);
        }
        XMLText.prototype.clone = function() {
            return Object.create(this);
        };
        XMLText.prototype.toString = function(options) {
            return this.options.writer.set(options).text(this);
        };
        return XMLText;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("fDRfY", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLProcessingInstruction, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLProcessingInstruction = function(superClass) {
        extend(XMLProcessingInstruction, superClass);
        function XMLProcessingInstruction(parent, target, value) {
            XMLProcessingInstruction.__super__.constructor.call(this, parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.target = this.stringify.insTarget(target);
            if (value) this.value = this.stringify.insValue(value);
        }
        XMLProcessingInstruction.prototype.clone = function() {
            return Object.create(this);
        };
        XMLProcessingInstruction.prototype.toString = function(options) {
            return this.options.writer.set(options).processingInstruction(this);
        };
        return XMLProcessingInstruction;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("5k1kJ", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDummy, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDummy = function(superClass) {
        extend(XMLDummy, superClass);
        function XMLDummy(parent) {
            XMLDummy.__super__.constructor.call(this, parent);
            this.isDummy = true;
        }
        XMLDummy.prototype.clone = function() {
            return Object.create(this);
        };
        XMLDummy.prototype.toString = function(options) {
            return '';
        };
        return XMLDummy;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("7epDt", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringifier, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = function() {
        function XMLStringifier(options) {
            this.assertLegalChar = bind(this.assertLegalChar, this);
            var key, ref, value;
            options || (options = {});
            this.noDoubleEncoding = options.noDoubleEncoding;
            ref = options.stringify || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
        }
        XMLStringifier.prototype.eleName = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.eleText = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(this.elEscape(val));
        };
        XMLStringifier.prototype.cdata = function(val) {
            val = '' + val || '';
            val = val.replace(']]>', ']]]]><![CDATA[>');
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.comment = function(val) {
            val = '' + val || '';
            if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.raw = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.attName = function(val) {
            return val = '' + val || '';
        };
        XMLStringifier.prototype.attValue = function(val) {
            val = '' + val || '';
            return this.attEscape(val);
        };
        XMLStringifier.prototype.insTarget = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.insValue = function(val) {
            val = '' + val || '';
            if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlVersion = function(val) {
            val = '' + val || '';
            if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlEncoding = function(val) {
            val = '' + val || '';
            if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlStandalone = function(val) {
            if (val) return "yes";
            else return "no";
        };
        XMLStringifier.prototype.dtdPubID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdSysID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdElementValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttType = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttDefault = function(val) {
            if (val != null) return '' + val || '';
            else return val;
        };
        XMLStringifier.prototype.dtdEntityValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdNData = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.convertAttKey = '@';
        XMLStringifier.prototype.convertPIKey = '?';
        XMLStringifier.prototype.convertTextKey = '#text';
        XMLStringifier.prototype.convertCDataKey = '#cdata';
        XMLStringifier.prototype.convertCommentKey = '#comment';
        XMLStringifier.prototype.convertRawKey = '#raw';
        XMLStringifier.prototype.assertLegalChar = function(str) {
            var res;
            res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
            if (res) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            return str;
        };
        XMLStringifier.prototype.elEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
        };
        XMLStringifier.prototype.attEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
        };
        return XMLStringifier;
    }();
}).call(module.exports);

});

parcelRegister("hvQ8s", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLElement = (parcelRequire("75p21"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDummy = (parcelRequire("5k1kJ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLWriterBase = (parcelRequire("3pyEP"));
    module.exports = XMLStringWriter = function(superClass) {
        extend(XMLStringWriter, superClass);
        function XMLStringWriter(options) {
            XMLStringWriter.__super__.constructor.call(this, options);
        }
        XMLStringWriter.prototype.document = function(doc) {
            var child, i, len, r, ref;
            this.textispresent = false;
            r = '';
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                if (child instanceof XMLDummy) continue;
                r += (function() {
                    switch(false){
                        case !(child instanceof XMLDeclaration):
                            return this.declaration(child);
                        case !(child instanceof XMLDocType):
                            return this.docType(child);
                        case !(child instanceof XMLComment):
                            return this.comment(child);
                        case !(child instanceof XMLProcessingInstruction):
                            return this.processingInstruction(child);
                        default:
                            return this.element(child, 0);
                    }
                }).call(this);
            }
            if (this.pretty && r.slice(-this.newline.length) === this.newline) r = r.slice(0, -this.newline.length);
            return r;
        };
        XMLStringWriter.prototype.attribute = function(att) {
            return ' ' + att.name + '="' + att.value + '"';
        };
        XMLStringWriter.prototype.cdata = function(node, level) {
            return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
        };
        XMLStringWriter.prototype.comment = function(node, level) {
            return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
        };
        XMLStringWriter.prototype.declaration = function(node, level) {
            var r;
            r = this.space(level);
            r += '<?xml version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            r += this.spacebeforeslash + '?>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.docType = function(node, level) {
            var child, i, len, r, ref;
            level || (level = 0);
            r = this.space(level);
            r += '<!DOCTYPE ' + node.root().name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            if (node.children.length > 0) {
                r += ' [';
                r += this.newline;
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLDTDAttList):
                                return this.dtdAttList(child, level + 1);
                            case !(child instanceof XMLDTDElement):
                                return this.dtdElement(child, level + 1);
                            case !(child instanceof XMLDTDEntity):
                                return this.dtdEntity(child, level + 1);
                            case !(child instanceof XMLDTDNotation):
                                return this.dtdNotation(child, level + 1);
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            default:
                                throw new Error("Unknown DTD node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                r += ']';
            }
            r += this.spacebeforeslash + '>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.element = function(node, level) {
            var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
            level || (level = 0);
            textispresentwasset = false;
            if (this.textispresent) {
                this.newline = '';
                this.pretty = false;
            } else {
                this.newline = this.newlinedefault;
                this.pretty = this.prettydefault;
            }
            space = this.space(level);
            r = '';
            r += space + '<' + node.name;
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                r += this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) r += '></' + node.name + '>' + this.newline;
                else r += this.spacebeforeslash + '/>' + this.newline;
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                r += '>';
                r += node.children[0].value;
                r += '</' + node.name + '>' + this.newline;
            } else {
                if (this.dontprettytextnodes) {
                    ref1 = node.children;
                    for(i = 0, len = ref1.length; i < len; i++){
                        child = ref1[i];
                        if (child.value != null) {
                            this.textispresent++;
                            textispresentwasset = true;
                            break;
                        }
                    }
                }
                if (this.textispresent) {
                    this.newline = '';
                    this.pretty = false;
                    space = this.space(level);
                }
                r += '>' + this.newline;
                ref2 = node.children;
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLElement):
                                return this.element(child, level + 1);
                            case !(child instanceof XMLRaw):
                                return this.raw(child, level + 1);
                            case !(child instanceof XMLText):
                                return this.text(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            case !(child instanceof XMLDummy):
                                return '';
                            default:
                                throw new Error("Unknown XML node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                if (textispresentwasset) this.textispresent--;
                if (!this.textispresent) {
                    this.newline = this.newlinedefault;
                    this.pretty = this.prettydefault;
                }
                r += space + '</' + node.name + '>' + this.newline;
            }
            return r;
        };
        XMLStringWriter.prototype.processingInstruction = function(node, level) {
            var r;
            r = this.space(level) + '<?' + node.target;
            if (node.value) r += ' ' + node.value;
            r += this.spacebeforeslash + '?>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.raw = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.text = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.dtdAttList = function(node, level) {
            var r;
            r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
            if (node.defaultValueType !== '#DEFAULT') r += ' ' + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdElement = function(node, level) {
            return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
        };
        XMLStringWriter.prototype.dtdEntity = function(node, level) {
            var r;
            r = this.space(level) + '<!ENTITY';
            if (node.pe) r += ' %';
            r += ' ' + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += ' NDATA ' + node.nData;
            }
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdNotation = function(node, level) {
            var r;
            r = this.space(level) + '<!NOTATION ' + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.openNode = function(node, level) {
            var att, name, r, ref;
            level || (level = 0);
            if (node instanceof XMLElement) {
                r = this.space(level) + '<' + node.name;
                ref = node.attributes;
                for(name in ref){
                    if (!hasProp.call(ref, name)) continue;
                    att = ref[name];
                    r += this.attribute(att);
                }
                r += (node.children ? '>' : '/>') + this.newline;
                return r;
            } else {
                r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                r += (node.children ? ' [' : '>') + this.newline;
                return r;
            }
        };
        XMLStringWriter.prototype.closeNode = function(node, level) {
            level || (level = 0);
            switch(false){
                case !(node instanceof XMLElement):
                    return this.space(level) + '</' + node.name + '>' + this.newline;
                case !(node instanceof XMLDocType):
                    return this.space(level) + ']>' + this.newline;
            }
        };
        return XMLStringWriter;
    }(XMLWriterBase);
}).call(module.exports);

});
parcelRegister("3pyEP", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLWriterBase, hasProp = {}.hasOwnProperty;
    module.exports = XMLWriterBase = function() {
        function XMLWriterBase(options) {
            var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
            options || (options = {});
            this.pretty = options.pretty || false;
            this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
            if (this.pretty) {
                this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
                this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
                this.offset = (ref3 = options.offset) != null ? ref3 : 0;
                this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref6 = options.writer || {};
            for(key in ref6){
                if (!hasProp.call(ref6, key)) continue;
                value = ref6[key];
                this[key] = value;
            }
        }
        XMLWriterBase.prototype.set = function(options) {
            var key, ref, value;
            options || (options = {});
            if ("pretty" in options) this.pretty = options.pretty;
            if ("allowEmpty" in options) this.allowEmpty = options.allowEmpty;
            if (this.pretty) {
                this.indent = "indent" in options ? options.indent : '  ';
                this.newline = "newline" in options ? options.newline : '\n';
                this.offset = "offset" in options ? options.offset : 0;
                this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
            return this;
        };
        XMLWriterBase.prototype.space = function(level) {
            var indent;
            if (this.pretty) {
                indent = (level || 0) + this.offset + 1;
                if (indent > 0) return new Array(indent).join(this.indent);
                else return '';
            } else return '';
        };
        return XMLWriterBase;
    }();
}).call(module.exports);

});



parcelRegister("fJ5z4", function(module, exports) {
















// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;
    XMLElement = (parcelRequire("75p21"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLAttribute = (parcelRequire("4THOq"));
    XMLStringifier = (parcelRequire("7epDt"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    module.exports = XMLDocumentCB = function() {
        function XMLDocumentCB(options, onData, onEnd) {
            var writerOptions;
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter(options);
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter(writerOptions);
            }
            this.options = options;
            this.writer = options.writer;
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        XMLDocumentCB.prototype.node = function(name, attributes, text) {
            var ref1, ref2;
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        };
        XMLDocumentCB.prototype.element = function(name, attributes, text) {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.dtdElement.apply(this, arguments);
            else return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLDocumentCB.prototype.text = function(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.cdata = function(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.comment = function(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.raw = function(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.instruction = function(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        };
        XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        };
        XMLDocumentCB.prototype.dtdElement = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.entity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.pEntity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.notation = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.up = function() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        };
        XMLDocumentCB.prototype.end = function() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        };
        XMLDocumentCB.prototype.openCurrent = function() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        };
        XMLDocumentCB.prototype.openNode = function(node) {
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) this.root = node;
                this.onData(this.writer.openNode(node, this.currentLevel), this.currentLevel);
                return node.isOpen = true;
            }
        };
        XMLDocumentCB.prototype.closeNode = function(node) {
            if (!node.isClosed) {
                this.onData(this.writer.closeNode(node, this.currentLevel), this.currentLevel);
                return node.isClosed = true;
            }
        };
        XMLDocumentCB.prototype.onData = function(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        };
        XMLDocumentCB.prototype.onEnd = function() {
            this.documentCompleted = true;
            return this.onEndCallback();
        };
        XMLDocumentCB.prototype.debugInfo = function(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        };
        XMLDocumentCB.prototype.ele = function() {
            return this.element.apply(this, arguments);
        };
        XMLDocumentCB.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        };
        XMLDocumentCB.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLDocumentCB.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.t = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLDocumentCB.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.att = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.a = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocumentCB.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocumentCB.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        return XMLDocumentCB;
    }();
}).call(module.exports);

});

parcelRegister("9ZWoi", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLElement = (parcelRequire("75p21"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDummy = (parcelRequire("5k1kJ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLWriterBase = (parcelRequire("3pyEP"));
    module.exports = XMLStreamWriter = function(superClass) {
        extend(XMLStreamWriter, superClass);
        function XMLStreamWriter(stream, options) {
            XMLStreamWriter.__super__.constructor.call(this, options);
            this.stream = stream;
        }
        XMLStreamWriter.prototype.document = function(doc) {
            var child, i, j, len, len1, ref, ref1, results;
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                child.isLastRootNode = false;
            }
            doc.children[doc.children.length - 1].isLastRootNode = true;
            ref1 = doc.children;
            results = [];
            for(j = 0, len1 = ref1.length; j < len1; j++){
                child = ref1[j];
                if (child instanceof XMLDummy) continue;
                switch(false){
                    case !(child instanceof XMLDeclaration):
                        results.push(this.declaration(child));
                        break;
                    case !(child instanceof XMLDocType):
                        results.push(this.docType(child));
                        break;
                    case !(child instanceof XMLComment):
                        results.push(this.comment(child));
                        break;
                    case !(child instanceof XMLProcessingInstruction):
                        results.push(this.processingInstruction(child));
                        break;
                    default:
                        results.push(this.element(child));
                }
            }
            return results;
        };
        XMLStreamWriter.prototype.attribute = function(att) {
            return this.stream.write(' ' + att.name + '="' + att.value + '"');
        };
        XMLStreamWriter.prototype.cdata = function(node, level) {
            return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
        };
        XMLStreamWriter.prototype.comment = function(node, level) {
            return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
        };
        XMLStreamWriter.prototype.declaration = function(node, level) {
            this.stream.write(this.space(level));
            this.stream.write('<?xml version="' + node.version + '"');
            if (node.encoding != null) this.stream.write(' encoding="' + node.encoding + '"');
            if (node.standalone != null) this.stream.write(' standalone="' + node.standalone + '"');
            this.stream.write(this.spacebeforeslash + '?>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.docType = function(node, level) {
            var child, i, len, ref;
            level || (level = 0);
            this.stream.write(this.space(level));
            this.stream.write('<!DOCTYPE ' + node.root().name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            if (node.children.length > 0) {
                this.stream.write(' [');
                this.stream.write(this.endline(node));
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    switch(false){
                        case !(child instanceof XMLDTDAttList):
                            this.dtdAttList(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDElement):
                            this.dtdElement(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDEntity):
                            this.dtdEntity(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDNotation):
                            this.dtdNotation(child, level + 1);
                            break;
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        default:
                            throw new Error("Unknown DTD node type: " + child.constructor.name);
                    }
                }
                this.stream.write(']');
            }
            this.stream.write(this.spacebeforeslash + '>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.element = function(node, level) {
            var att, child, i, len, name, ref, ref1, space;
            level || (level = 0);
            space = this.space(level);
            this.stream.write(space + '<' + node.name);
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) this.stream.write('></' + node.name + '>');
                else this.stream.write(this.spacebeforeslash + '/>');
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                this.stream.write('>');
                this.stream.write(node.children[0].value);
                this.stream.write('</' + node.name + '>');
            } else {
                this.stream.write('>' + this.newline);
                ref1 = node.children;
                for(i = 0, len = ref1.length; i < len; i++){
                    child = ref1[i];
                    switch(false){
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLElement):
                            this.element(child, level + 1);
                            break;
                        case !(child instanceof XMLRaw):
                            this.raw(child, level + 1);
                            break;
                        case !(child instanceof XMLText):
                            this.text(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        case !(child instanceof XMLDummy):
                            '';
                            break;
                        default:
                            throw new Error("Unknown XML node type: " + child.constructor.name);
                    }
                }
                this.stream.write(space + '</' + node.name + '>');
            }
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.processingInstruction = function(node, level) {
            this.stream.write(this.space(level) + '<?' + node.target);
            if (node.value) this.stream.write(' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
        };
        XMLStreamWriter.prototype.raw = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.text = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdAttList = function(node, level) {
            this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
            if (node.defaultValueType !== '#DEFAULT') this.stream.write(' ' + node.defaultValueType);
            if (node.defaultValue) this.stream.write(' "' + node.defaultValue + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdElement = function(node, level) {
            this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdEntity = function(node, level) {
            this.stream.write(this.space(level) + '<!ENTITY');
            if (node.pe) this.stream.write(' %');
            this.stream.write(' ' + node.name);
            if (node.value) this.stream.write(' "' + node.value + '"');
            else {
                if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
                else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
                if (node.nData) this.stream.write(' NDATA ' + node.nData);
            }
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdNotation = function(node, level) {
            this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.pubID) this.stream.write(' PUBLIC "' + node.pubID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.endline = function(node) {
            if (!node.isLastRootNode) return this.newline;
            else return '';
        };
        return XMLStreamWriter;
    }(XMLWriterBase);
}).call(module.exports);

});



parcelRegister("jKsvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e6086d8520c6d42a$var$dingbats = [
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "33",
        "Unicode hex": "21"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "8704",
        "Unicode hex": "2200"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "35",
        "Unicode hex": "23"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "8707",
        "Unicode hex": "2203"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "37",
        "Unicode hex": "25"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "38",
        "Unicode hex": "26"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "8717",
        "Unicode hex": "220D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "40",
        "Unicode hex": "28"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "41",
        "Unicode hex": "29"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "42",
        "Unicode hex": "2A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "43",
        "Unicode hex": "2B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "44",
        "Unicode hex": "2C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "8722",
        "Unicode hex": "2212"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "46",
        "Unicode hex": "2E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "47",
        "Unicode hex": "2F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "48",
        "Unicode hex": "30"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "49",
        "Unicode hex": "31"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "50",
        "Unicode hex": "32"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "51",
        "Unicode hex": "33"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "52",
        "Unicode hex": "34"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "53",
        "Unicode hex": "35"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "54",
        "Unicode hex": "36"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "55",
        "Unicode hex": "37"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "56",
        "Unicode hex": "38"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "57",
        "Unicode hex": "39"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "58",
        "Unicode hex": "3A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "59",
        "Unicode hex": "3B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "60",
        "Unicode hex": "3C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "61",
        "Unicode hex": "3D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "62",
        "Unicode hex": "3E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "63",
        "Unicode hex": "3F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "8773",
        "Unicode hex": "2245"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "913",
        "Unicode hex": "391"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "914",
        "Unicode hex": "392"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "935",
        "Unicode hex": "3A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "916",
        "Unicode hex": "394"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "917",
        "Unicode hex": "395"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "934",
        "Unicode hex": "3A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "915",
        "Unicode hex": "393"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "919",
        "Unicode hex": "397"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "921",
        "Unicode hex": "399"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "977",
        "Unicode hex": "3D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "922",
        "Unicode hex": "39A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "923",
        "Unicode hex": "39B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "924",
        "Unicode hex": "39C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "925",
        "Unicode hex": "39D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "927",
        "Unicode hex": "39F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "928",
        "Unicode hex": "3A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "920",
        "Unicode hex": "398"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "929",
        "Unicode hex": "3A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "931",
        "Unicode hex": "3A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "932",
        "Unicode hex": "3A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "933",
        "Unicode hex": "3A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "962",
        "Unicode hex": "3C2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "937",
        "Unicode hex": "3A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "926",
        "Unicode hex": "39E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "936",
        "Unicode hex": "3A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "918",
        "Unicode hex": "396"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "91",
        "Unicode hex": "5B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "8756",
        "Unicode hex": "2234"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "93",
        "Unicode hex": "5D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "8869",
        "Unicode hex": "22A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "95",
        "Unicode hex": "5F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "8254",
        "Unicode hex": "203E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "945",
        "Unicode hex": "3B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "946",
        "Unicode hex": "3B2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "967",
        "Unicode hex": "3C7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "948",
        "Unicode hex": "3B4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "949",
        "Unicode hex": "3B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "966",
        "Unicode hex": "3C6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "947",
        "Unicode hex": "3B3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "951",
        "Unicode hex": "3B7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "953",
        "Unicode hex": "3B9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "981",
        "Unicode hex": "3D5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "954",
        "Unicode hex": "3BA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "955",
        "Unicode hex": "3BB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "956",
        "Unicode hex": "3BC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "957",
        "Unicode hex": "3BD"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "959",
        "Unicode hex": "3BF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "960",
        "Unicode hex": "3C0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "952",
        "Unicode hex": "3B8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "961",
        "Unicode hex": "3C1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "963",
        "Unicode hex": "3C3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "964",
        "Unicode hex": "3C4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "965",
        "Unicode hex": "3C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "982",
        "Unicode hex": "3D6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "969",
        "Unicode hex": "3C9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "958",
        "Unicode hex": "3BE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "968",
        "Unicode hex": "3C8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "950",
        "Unicode hex": "3B6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "123",
        "Unicode hex": "7B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "124",
        "Unicode hex": "7C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "125",
        "Unicode hex": "7D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "126",
        "Unicode hex": "7E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "8364",
        "Unicode hex": "20AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "978",
        "Unicode hex": "3D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "8242",
        "Unicode hex": "2032"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "8804",
        "Unicode hex": "2264"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "8260",
        "Unicode hex": "2044"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "8734",
        "Unicode hex": "221E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "402",
        "Unicode hex": "192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9827",
        "Unicode hex": "2663"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9830",
        "Unicode hex": "2666"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "9829",
        "Unicode hex": "2665"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "9824",
        "Unicode hex": "2660"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "8596",
        "Unicode hex": "2194"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "8592",
        "Unicode hex": "2190"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "8593",
        "Unicode hex": "2191"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "8594",
        "Unicode hex": "2192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "8595",
        "Unicode hex": "2193"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "176",
        "Unicode hex": "B0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "177",
        "Unicode hex": "B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "8243",
        "Unicode hex": "2033"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "8805",
        "Unicode hex": "2265"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "215",
        "Unicode hex": "D7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "8733",
        "Unicode hex": "221D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "8706",
        "Unicode hex": "2202"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "247",
        "Unicode hex": "F7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "8800",
        "Unicode hex": "2260"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "8801",
        "Unicode hex": "2261"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "8776",
        "Unicode hex": "2248"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "8230",
        "Unicode hex": "2026"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "9135",
        "Unicode hex": "23AF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "8629",
        "Unicode hex": "21B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "8501",
        "Unicode hex": "2135"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "8465",
        "Unicode hex": "2111"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "8476",
        "Unicode hex": "211C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "8472",
        "Unicode hex": "2118"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "8855",
        "Unicode hex": "2297"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "8853",
        "Unicode hex": "2295"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "8709",
        "Unicode hex": "2205"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "8745",
        "Unicode hex": "2229"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "8746",
        "Unicode hex": "222A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "8835",
        "Unicode hex": "2283"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "8839",
        "Unicode hex": "2287"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "8836",
        "Unicode hex": "2284"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "8834",
        "Unicode hex": "2282"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "8838",
        "Unicode hex": "2286"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "8712",
        "Unicode hex": "2208"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "8713",
        "Unicode hex": "2209"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "8736",
        "Unicode hex": "2220"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "8711",
        "Unicode hex": "2207"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "8719",
        "Unicode hex": "220F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8730",
        "Unicode hex": "221A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "172",
        "Unicode hex": "AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "8743",
        "Unicode hex": "2227"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "8744",
        "Unicode hex": "2228"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "8660",
        "Unicode hex": "21D4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "8656",
        "Unicode hex": "21D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "8657",
        "Unicode hex": "21D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "8658",
        "Unicode hex": "21D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "8659",
        "Unicode hex": "21D3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "12296",
        "Unicode hex": "3008"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "8721",
        "Unicode hex": "2211"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "9115",
        "Unicode hex": "239B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "9116",
        "Unicode hex": "239C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9117",
        "Unicode hex": "239D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9121",
        "Unicode hex": "23A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "9122",
        "Unicode hex": "23A2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "9123",
        "Unicode hex": "23A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "9127",
        "Unicode hex": "23A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "9128",
        "Unicode hex": "23A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "9129",
        "Unicode hex": "23A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "9130",
        "Unicode hex": "23AA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "63743",
        "Unicode hex": "F8FF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "12297",
        "Unicode hex": "3009"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8747",
        "Unicode hex": "222B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "8992",
        "Unicode hex": "2320"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "9134",
        "Unicode hex": "23AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "8993",
        "Unicode hex": "2321"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "9118",
        "Unicode hex": "239E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "9119",
        "Unicode hex": "239F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "9120",
        "Unicode hex": "23A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "9124",
        "Unicode hex": "23A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "9125",
        "Unicode hex": "23A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "9126",
        "Unicode hex": "23A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "9131",
        "Unicode hex": "23AB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "9132",
        "Unicode hex": "23AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "9133",
        "Unicode hex": "23AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128375",
        "Unicode hex": "1F577"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128376",
        "Unicode hex": "1F578"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128370",
        "Unicode hex": "1F572"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128374",
        "Unicode hex": "1F576"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "127942",
        "Unicode hex": "1F3C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "127894",
        "Unicode hex": "1F396"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128391",
        "Unicode hex": "1F587"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128488",
        "Unicode hex": "1F5E8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128489",
        "Unicode hex": "1F5E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128496",
        "Unicode hex": "1F5F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128497",
        "Unicode hex": "1F5F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "127798",
        "Unicode hex": "1F336"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "127895",
        "Unicode hex": "1F397"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128638",
        "Unicode hex": "1F67E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128636",
        "Unicode hex": "1F67C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128469",
        "Unicode hex": "1F5D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128470",
        "Unicode hex": "1F5D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128471",
        "Unicode hex": "1F5D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "9204",
        "Unicode hex": "23F4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "9205",
        "Unicode hex": "23F5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "9206",
        "Unicode hex": "23F6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "9207",
        "Unicode hex": "23F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "9194",
        "Unicode hex": "23EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "9193",
        "Unicode hex": "23E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "9198",
        "Unicode hex": "23EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "9197",
        "Unicode hex": "23ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "9208",
        "Unicode hex": "23F8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "9209",
        "Unicode hex": "23F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "9210",
        "Unicode hex": "23FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128474",
        "Unicode hex": "1F5DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128499",
        "Unicode hex": "1F5F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128736",
        "Unicode hex": "1F6E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "127959",
        "Unicode hex": "1F3D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "127960",
        "Unicode hex": "1F3D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "127961",
        "Unicode hex": "1F3D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "127962",
        "Unicode hex": "1F3DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "127964",
        "Unicode hex": "1F3DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "127981",
        "Unicode hex": "1F3ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "127963",
        "Unicode hex": "1F3DB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "127968",
        "Unicode hex": "1F3E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "127958",
        "Unicode hex": "1F3D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "127965",
        "Unicode hex": "1F3DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128739",
        "Unicode hex": "1F6E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128269",
        "Unicode hex": "1F50D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "127956",
        "Unicode hex": "1F3D4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128065",
        "Unicode hex": "1F441"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128066",
        "Unicode hex": "1F442"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127966",
        "Unicode hex": "1F3DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "127957",
        "Unicode hex": "1F3D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "128740",
        "Unicode hex": "1F6E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127967",
        "Unicode hex": "1F3DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "128755",
        "Unicode hex": "1F6F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128364",
        "Unicode hex": "1F56C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "128363",
        "Unicode hex": "1F56B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128360",
        "Unicode hex": "1F568"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "128264",
        "Unicode hex": "1F508"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "127892",
        "Unicode hex": "1F394"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "127893",
        "Unicode hex": "1F395"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128492",
        "Unicode hex": "1F5EC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128637",
        "Unicode hex": "1F67D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "128493",
        "Unicode hex": "1F5ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128490",
        "Unicode hex": "1F5EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128491",
        "Unicode hex": "1F5EB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "11156",
        "Unicode hex": "2B94"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "10004",
        "Unicode hex": "2714"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128690",
        "Unicode hex": "1F6B2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "11036",
        "Unicode hex": "2B1C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128737",
        "Unicode hex": "1F6E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128230",
        "Unicode hex": "1F4E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128753",
        "Unicode hex": "1F6F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "11035",
        "Unicode hex": "2B1B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128657",
        "Unicode hex": "1F691"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "128712",
        "Unicode hex": "1F6C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128745",
        "Unicode hex": "1F6E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128752",
        "Unicode hex": "1F6F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "128968",
        "Unicode hex": "1F7C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128372",
        "Unicode hex": "1F574"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "11044",
        "Unicode hex": "2B24"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128741",
        "Unicode hex": "1F6E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128660",
        "Unicode hex": "1F694"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "128472",
        "Unicode hex": "1F5D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "128473",
        "Unicode hex": "1F5D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "10067",
        "Unicode hex": "2753"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "128754",
        "Unicode hex": "1F6F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "128647",
        "Unicode hex": "1F687"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "128653",
        "Unicode hex": "1F68D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9971",
        "Unicode hex": "26F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "8854",
        "Unicode hex": "2296"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "128685",
        "Unicode hex": "1F6AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "128494",
        "Unicode hex": "1F5EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128495",
        "Unicode hex": "1F5EF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128498",
        "Unicode hex": "1F5F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128697",
        "Unicode hex": "1F6B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "128698",
        "Unicode hex": "1F6BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "128713",
        "Unicode hex": "1F6C9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "128714",
        "Unicode hex": "1F6CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "128700",
        "Unicode hex": "1F6BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "128125",
        "Unicode hex": "1F47D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "127947",
        "Unicode hex": "1F3CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "9975",
        "Unicode hex": "26F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "127938",
        "Unicode hex": "1F3C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "127948",
        "Unicode hex": "1F3CC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "127946",
        "Unicode hex": "1F3CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127940",
        "Unicode hex": "1F3C4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "127949",
        "Unicode hex": "1F3CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "127950",
        "Unicode hex": "1F3CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128664",
        "Unicode hex": "1F698"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128480",
        "Unicode hex": "1F5E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128738",
        "Unicode hex": "1F6E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128176",
        "Unicode hex": "1F4B0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "127991",
        "Unicode hex": "1F3F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128179",
        "Unicode hex": "1F4B3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128106",
        "Unicode hex": "1F46A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "128481",
        "Unicode hex": "1F5E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128482",
        "Unicode hex": "1F5E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128483",
        "Unicode hex": "1F5E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128388",
        "Unicode hex": "1F584"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128389",
        "Unicode hex": "1F585"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128390",
        "Unicode hex": "1F586"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128441",
        "Unicode hex": "1F5B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "128442",
        "Unicode hex": "1F5BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128443",
        "Unicode hex": "1F5BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128373",
        "Unicode hex": "1F575"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "128368",
        "Unicode hex": "1F570"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128445",
        "Unicode hex": "1F5BD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128446",
        "Unicode hex": "1F5BE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128466",
        "Unicode hex": "1F5D2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128467",
        "Unicode hex": "1F5D3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128218",
        "Unicode hex": "1F4DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128478",
        "Unicode hex": "1F5DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128479",
        "Unicode hex": "1F5DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128451",
        "Unicode hex": "1F5C3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128450",
        "Unicode hex": "1F5C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128444",
        "Unicode hex": "1F5BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "127917",
        "Unicode hex": "1F3AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "127900",
        "Unicode hex": "1F39C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "127896",
        "Unicode hex": "1F398"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "127897",
        "Unicode hex": "1F399"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "127911",
        "Unicode hex": "1F3A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128191",
        "Unicode hex": "1F4BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "127902",
        "Unicode hex": "1F39E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128247",
        "Unicode hex": "1F4F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "127903",
        "Unicode hex": "1F39F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "127916",
        "Unicode hex": "1F3AC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128253",
        "Unicode hex": "1F4FD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128249",
        "Unicode hex": "1F4F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128254",
        "Unicode hex": "1F4FE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128251",
        "Unicode hex": "1F4FB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "127898",
        "Unicode hex": "1F39A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "127899",
        "Unicode hex": "1F39B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128250",
        "Unicode hex": "1F4FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128187",
        "Unicode hex": "1F4BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128421",
        "Unicode hex": "1F5A5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128422",
        "Unicode hex": "1F5A6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128423",
        "Unicode hex": "1F5A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "128377",
        "Unicode hex": "1F579"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "127918",
        "Unicode hex": "1F3AE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "128379",
        "Unicode hex": "1F57B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128380",
        "Unicode hex": "1F57C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128223",
        "Unicode hex": "1F4DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128385",
        "Unicode hex": "1F581"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128384",
        "Unicode hex": "1F580"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128424",
        "Unicode hex": "1F5A8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128425",
        "Unicode hex": "1F5A9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128447",
        "Unicode hex": "1F5BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128426",
        "Unicode hex": "1F5AA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128476",
        "Unicode hex": "1F5DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128274",
        "Unicode hex": "1F512"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128275",
        "Unicode hex": "1F513"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128477",
        "Unicode hex": "1F5DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128229",
        "Unicode hex": "1F4E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128228",
        "Unicode hex": "1F4E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128371",
        "Unicode hex": "1F573"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "127779",
        "Unicode hex": "1F323"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "127780",
        "Unicode hex": "1F324"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "127781",
        "Unicode hex": "1F325"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "127782",
        "Unicode hex": "1F326"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "9729",
        "Unicode hex": "2601"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "127784",
        "Unicode hex": "1F328"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "127783",
        "Unicode hex": "1F327"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "127785",
        "Unicode hex": "1F329"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "127786",
        "Unicode hex": "1F32A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "127788",
        "Unicode hex": "1F32C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "127787",
        "Unicode hex": "1F32B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "127772",
        "Unicode hex": "1F31C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "127777",
        "Unicode hex": "1F321"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128715",
        "Unicode hex": "1F6CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128719",
        "Unicode hex": "1F6CF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "127869",
        "Unicode hex": "1F37D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "127864",
        "Unicode hex": "1F378"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128718",
        "Unicode hex": "1F6CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128717",
        "Unicode hex": "1F6CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9413",
        "Unicode hex": "24C5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9855",
        "Unicode hex": "267F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128710",
        "Unicode hex": "1F6C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "128392",
        "Unicode hex": "1F588"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "127891",
        "Unicode hex": "1F393"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128484",
        "Unicode hex": "1F5E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128485",
        "Unicode hex": "1F5E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128486",
        "Unicode hex": "1F5E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "128487",
        "Unicode hex": "1F5E7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128746",
        "Unicode hex": "1F6EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128063",
        "Unicode hex": "1F43F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "128038",
        "Unicode hex": "1F426"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128031",
        "Unicode hex": "1F41F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128021",
        "Unicode hex": "1F415"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "128008",
        "Unicode hex": "1F408"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "128620",
        "Unicode hex": "1F66C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "128622",
        "Unicode hex": "1F66E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "128621",
        "Unicode hex": "1F66D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "128623",
        "Unicode hex": "1F66F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128506",
        "Unicode hex": "1F5FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "127757",
        "Unicode hex": "1F30D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "127759",
        "Unicode hex": "1F30F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "127758",
        "Unicode hex": "1F30E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "255",
        "Dingbat hex": "FF",
        "Unicode dec": "128330",
        "Unicode hex": "1F54A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128393",
        "Unicode hex": "1F589"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "9986",
        "Unicode hex": "2702"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "9985",
        "Unicode hex": "2701"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128083",
        "Unicode hex": "1F453"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "128365",
        "Unicode hex": "1F56D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128367",
        "Unicode hex": "1F56F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128383",
        "Unicode hex": "1F57F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "9990",
        "Unicode hex": "2706"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128386",
        "Unicode hex": "1F582"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128234",
        "Unicode hex": "1F4EA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128235",
        "Unicode hex": "1F4EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128236",
        "Unicode hex": "1F4EC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128237",
        "Unicode hex": "1F4ED"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128448",
        "Unicode hex": "1F5C0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128449",
        "Unicode hex": "1F5C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128462",
        "Unicode hex": "1F5CE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128463",
        "Unicode hex": "1F5CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128464",
        "Unicode hex": "1F5D0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128452",
        "Unicode hex": "1F5C4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "8987",
        "Unicode hex": "231B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128430",
        "Unicode hex": "1F5AE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128432",
        "Unicode hex": "1F5B0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128434",
        "Unicode hex": "1F5B2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128435",
        "Unicode hex": "1F5B3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128436",
        "Unicode hex": "1F5B4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128427",
        "Unicode hex": "1F5AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128428",
        "Unicode hex": "1F5AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "9991",
        "Unicode hex": "2707"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "9997",
        "Unicode hex": "270D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128398",
        "Unicode hex": "1F58E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "9996",
        "Unicode hex": "270C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128399",
        "Unicode hex": "1F58F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128077",
        "Unicode hex": "1F44D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128078",
        "Unicode hex": "1F44E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "9756",
        "Unicode hex": "261C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "9758",
        "Unicode hex": "261E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "9757",
        "Unicode hex": "261D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "9759",
        "Unicode hex": "261F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128400",
        "Unicode hex": "1F590"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "9786",
        "Unicode hex": "263A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128528",
        "Unicode hex": "1F610"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "9785",
        "Unicode hex": "2639"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128163",
        "Unicode hex": "1F4A3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128369",
        "Unicode hex": "1F571"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "127987",
        "Unicode hex": "1F3F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127985",
        "Unicode hex": "1F3F1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "9992",
        "Unicode hex": "2708"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9788",
        "Unicode hex": "263C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127778",
        "Unicode hex": "1F322"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "10052",
        "Unicode hex": "2744"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128326",
        "Unicode hex": "1F546"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "10014",
        "Unicode hex": "271E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128328",
        "Unicode hex": "1F548"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10016",
        "Unicode hex": "2720"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "10017",
        "Unicode hex": "2721"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "9770",
        "Unicode hex": "262A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "9775",
        "Unicode hex": "262F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128329",
        "Unicode hex": "1F549"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "9784",
        "Unicode hex": "2638"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "9800",
        "Unicode hex": "2648"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "9801",
        "Unicode hex": "2649"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "9802",
        "Unicode hex": "264A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "9803",
        "Unicode hex": "264B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "9804",
        "Unicode hex": "264C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "9805",
        "Unicode hex": "264D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "9806",
        "Unicode hex": "264E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "9807",
        "Unicode hex": "264F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "9808",
        "Unicode hex": "2650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "9809",
        "Unicode hex": "2651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "9810",
        "Unicode hex": "2652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9811",
        "Unicode hex": "2653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128624",
        "Unicode hex": "1F670"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128629",
        "Unicode hex": "1F675"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9899",
        "Unicode hex": "26AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128318",
        "Unicode hex": "1F53E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9724",
        "Unicode hex": "25FC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128911",
        "Unicode hex": "1F78F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128912",
        "Unicode hex": "1F790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "10065",
        "Unicode hex": "2751"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "10066",
        "Unicode hex": "2752"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "128927",
        "Unicode hex": "1F79F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "10731",
        "Unicode hex": "29EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9670",
        "Unicode hex": "25C6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10070",
        "Unicode hex": "2756"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "8999",
        "Unicode hex": "2327"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "11193",
        "Unicode hex": "2BB9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "8984",
        "Unicode hex": "2318"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "127989",
        "Unicode hex": "1F3F5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "127990",
        "Unicode hex": "1F3F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128630",
        "Unicode hex": "1F676"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128631",
        "Unicode hex": "1F677"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "127",
        "Dingbat hex": "7F",
        "Unicode dec": "9647",
        "Unicode hex": "25AF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "127243",
        "Unicode hex": "1F10B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "10112",
        "Unicode hex": "2780"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "10113",
        "Unicode hex": "2781"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "10114",
        "Unicode hex": "2782"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "10115",
        "Unicode hex": "2783"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10116",
        "Unicode hex": "2784"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "10117",
        "Unicode hex": "2785"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "10118",
        "Unicode hex": "2786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "10119",
        "Unicode hex": "2787"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "10120",
        "Unicode hex": "2788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "10121",
        "Unicode hex": "2789"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127244",
        "Unicode hex": "1F10C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "10122",
        "Unicode hex": "278A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "10123",
        "Unicode hex": "278B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "10124",
        "Unicode hex": "278C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "10125",
        "Unicode hex": "278D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "10126",
        "Unicode hex": "278E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "10127",
        "Unicode hex": "278F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "10128",
        "Unicode hex": "2790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "10129",
        "Unicode hex": "2791"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "10130",
        "Unicode hex": "2792"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "10131",
        "Unicode hex": "2793"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128610",
        "Unicode hex": "1F662"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128608",
        "Unicode hex": "1F660"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "128609",
        "Unicode hex": "1F661"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128611",
        "Unicode hex": "1F663"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128606",
        "Unicode hex": "1F65E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128604",
        "Unicode hex": "1F65C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128605",
        "Unicode hex": "1F65D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128607",
        "Unicode hex": "1F65F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "8729",
        "Unicode hex": "2219"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "11037",
        "Unicode hex": "2B1D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "11096",
        "Unicode hex": "2B58"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128902",
        "Unicode hex": "1F786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128904",
        "Unicode hex": "1F788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128906",
        "Unicode hex": "1F78A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128907",
        "Unicode hex": "1F78B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128319",
        "Unicode hex": "1F53F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9642",
        "Unicode hex": "25AA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128910",
        "Unicode hex": "1F78E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128961",
        "Unicode hex": "1F7C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128965",
        "Unicode hex": "1F7C5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "9733",
        "Unicode hex": "2605"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128971",
        "Unicode hex": "1F7CB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128975",
        "Unicode hex": "1F7CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "128979",
        "Unicode hex": "1F7D3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "128977",
        "Unicode hex": "1F7D1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "11216",
        "Unicode hex": "2BD0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "8982",
        "Unicode hex": "2316"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "11214",
        "Unicode hex": "2BCE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "11215",
        "Unicode hex": "2BCF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "11217",
        "Unicode hex": "2BD1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "10026",
        "Unicode hex": "272A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "10032",
        "Unicode hex": "2730"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "128336",
        "Unicode hex": "1F550"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128337",
        "Unicode hex": "1F551"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128338",
        "Unicode hex": "1F552"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128339",
        "Unicode hex": "1F553"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128340",
        "Unicode hex": "1F554"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "128341",
        "Unicode hex": "1F555"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "128342",
        "Unicode hex": "1F556"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128343",
        "Unicode hex": "1F557"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128344",
        "Unicode hex": "1F558"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128345",
        "Unicode hex": "1F559"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128346",
        "Unicode hex": "1F55A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128347",
        "Unicode hex": "1F55B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11184",
        "Unicode hex": "2BB0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11185",
        "Unicode hex": "2BB1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11186",
        "Unicode hex": "2BB2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "11187",
        "Unicode hex": "2BB3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "11188",
        "Unicode hex": "2BB4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "11189",
        "Unicode hex": "2BB5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11190",
        "Unicode hex": "2BB6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11191",
        "Unicode hex": "2BB7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128618",
        "Unicode hex": "1F66A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128619",
        "Unicode hex": "1F66B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128597",
        "Unicode hex": "1F655"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128596",
        "Unicode hex": "1F654"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128599",
        "Unicode hex": "1F657"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128598",
        "Unicode hex": "1F656"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128592",
        "Unicode hex": "1F650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128593",
        "Unicode hex": "1F651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128594",
        "Unicode hex": "1F652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128595",
        "Unicode hex": "1F653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "9003",
        "Unicode hex": "232B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8998",
        "Unicode hex": "2326"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "11160",
        "Unicode hex": "2B98"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "11162",
        "Unicode hex": "2B9A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "11161",
        "Unicode hex": "2B99"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "11163",
        "Unicode hex": "2B9B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "11144",
        "Unicode hex": "2B88"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "11146",
        "Unicode hex": "2B8A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "11145",
        "Unicode hex": "2B89"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "11147",
        "Unicode hex": "2B8B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129128",
        "Unicode hex": "1F868"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129130",
        "Unicode hex": "1F86A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129129",
        "Unicode hex": "1F869"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129131",
        "Unicode hex": "1F86B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129132",
        "Unicode hex": "1F86C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129133",
        "Unicode hex": "1F86D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129135",
        "Unicode hex": "1F86F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129134",
        "Unicode hex": "1F86E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129144",
        "Unicode hex": "1F878"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129146",
        "Unicode hex": "1F87A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129145",
        "Unicode hex": "1F879"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129147",
        "Unicode hex": "1F87B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129148",
        "Unicode hex": "1F87C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129149",
        "Unicode hex": "1F87D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129151",
        "Unicode hex": "1F87F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129150",
        "Unicode hex": "1F87E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "8678",
        "Unicode hex": "21E6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "8680",
        "Unicode hex": "21E8"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "8679",
        "Unicode hex": "21E7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8681",
        "Unicode hex": "21E9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "11012",
        "Unicode hex": "2B04"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "8691",
        "Unicode hex": "21F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "11009",
        "Unicode hex": "2B01"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11008",
        "Unicode hex": "2B00"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11011",
        "Unicode hex": "2B03"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "11010",
        "Unicode hex": "2B02"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "129196",
        "Unicode hex": "1F8AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "129197",
        "Unicode hex": "1F8AD"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128502",
        "Unicode hex": "1F5F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "10003",
        "Unicode hex": "2713"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "128503",
        "Unicode hex": "1F5F7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "128505",
        "Unicode hex": "1F5F9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128394",
        "Unicode hex": "1F58A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128395",
        "Unicode hex": "1F58B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128396",
        "Unicode hex": "1F58C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128397",
        "Unicode hex": "1F58D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "9988",
        "Unicode hex": "2704"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "9984",
        "Unicode hex": "2700"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128382",
        "Unicode hex": "1F57E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128381",
        "Unicode hex": "1F57D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128453",
        "Unicode hex": "1F5C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128454",
        "Unicode hex": "1F5C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128455",
        "Unicode hex": "1F5C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128456",
        "Unicode hex": "1F5C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128457",
        "Unicode hex": "1F5C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128458",
        "Unicode hex": "1F5CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128459",
        "Unicode hex": "1F5CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128460",
        "Unicode hex": "1F5CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128461",
        "Unicode hex": "1F5CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128465",
        "Unicode hex": "1F5D1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128468",
        "Unicode hex": "1F5D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128437",
        "Unicode hex": "1F5B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "128438",
        "Unicode hex": "1F5B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128439",
        "Unicode hex": "1F5B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128440",
        "Unicode hex": "1F5B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128429",
        "Unicode hex": "1F5AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128431",
        "Unicode hex": "1F5AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128433",
        "Unicode hex": "1F5B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128402",
        "Unicode hex": "1F592"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128403",
        "Unicode hex": "1F593"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128408",
        "Unicode hex": "1F598"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128409",
        "Unicode hex": "1F599"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128410",
        "Unicode hex": "1F59A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "128411",
        "Unicode hex": "1F59B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128072",
        "Unicode hex": "1F448"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128073",
        "Unicode hex": "1F449"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128412",
        "Unicode hex": "1F59C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "128413",
        "Unicode hex": "1F59D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "128414",
        "Unicode hex": "1F59E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "128415",
        "Unicode hex": "1F59F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "128416",
        "Unicode hex": "1F5A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128417",
        "Unicode hex": "1F5A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "128070",
        "Unicode hex": "1F446"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128071",
        "Unicode hex": "1F447"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128418",
        "Unicode hex": "1F5A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128419",
        "Unicode hex": "1F5A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128401",
        "Unicode hex": "1F591"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128500",
        "Unicode hex": "1F5F4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "128504",
        "Unicode hex": "1F5F8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "128501",
        "Unicode hex": "1F5F5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9745",
        "Unicode hex": "2611"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "11197",
        "Unicode hex": "2BBD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "9746",
        "Unicode hex": "2612"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "11198",
        "Unicode hex": "2BBE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "11199",
        "Unicode hex": "2BBF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128711",
        "Unicode hex": "1F6C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "128625",
        "Unicode hex": "1F671"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "128628",
        "Unicode hex": "1F674"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128626",
        "Unicode hex": "1F672"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128627",
        "Unicode hex": "1F673"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "8253",
        "Unicode hex": "203D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128633",
        "Unicode hex": "1F679"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128634",
        "Unicode hex": "1F67A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "128635",
        "Unicode hex": "1F67B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "128614",
        "Unicode hex": "1F666"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128612",
        "Unicode hex": "1F664"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "128613",
        "Unicode hex": "1F665"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128615",
        "Unicode hex": "1F667"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128602",
        "Unicode hex": "1F65A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128600",
        "Unicode hex": "1F658"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "128601",
        "Unicode hex": "1F659"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128603",
        "Unicode hex": "1F65B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9450",
        "Unicode hex": "24EA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "9312",
        "Unicode hex": "2460"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "9313",
        "Unicode hex": "2461"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9314",
        "Unicode hex": "2462"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "9315",
        "Unicode hex": "2463"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9316",
        "Unicode hex": "2464"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "9317",
        "Unicode hex": "2465"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9318",
        "Unicode hex": "2466"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9319",
        "Unicode hex": "2467"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9320",
        "Unicode hex": "2468"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9321",
        "Unicode hex": "2469"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9471",
        "Unicode hex": "24FF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "10102",
        "Unicode hex": "2776"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10103",
        "Unicode hex": "2777"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "10104",
        "Unicode hex": "2778"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10105",
        "Unicode hex": "2779"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "10106",
        "Unicode hex": "277A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "10107",
        "Unicode hex": "277B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "10108",
        "Unicode hex": "277C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "10109",
        "Unicode hex": "277D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "10110",
        "Unicode hex": "277E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "10111",
        "Unicode hex": "277F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "9737",
        "Unicode hex": "2609"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "127765",
        "Unicode hex": "1F315"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "9789",
        "Unicode hex": "263D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "9790",
        "Unicode hex": "263E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11839",
        "Unicode hex": "2E3F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10013",
        "Unicode hex": "271D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "128327",
        "Unicode hex": "1F547"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "128348",
        "Unicode hex": "1F55C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "128349",
        "Unicode hex": "1F55D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "128350",
        "Unicode hex": "1F55E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "128351",
        "Unicode hex": "1F55F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "128352",
        "Unicode hex": "1F560"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "128353",
        "Unicode hex": "1F561"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "128354",
        "Unicode hex": "1F562"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128355",
        "Unicode hex": "1F563"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128356",
        "Unicode hex": "1F564"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128357",
        "Unicode hex": "1F565"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128358",
        "Unicode hex": "1F566"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "128359",
        "Unicode hex": "1F567"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128616",
        "Unicode hex": "1F668"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128617",
        "Unicode hex": "1F669"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128900",
        "Unicode hex": "1F784"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "10625",
        "Unicode hex": "2981"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "9679",
        "Unicode hex": "25CF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "9675",
        "Unicode hex": "25CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128901",
        "Unicode hex": "1F785"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128903",
        "Unicode hex": "1F787"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128905",
        "Unicode hex": "1F789"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "8857",
        "Unicode hex": "2299"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "10687",
        "Unicode hex": "29BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128908",
        "Unicode hex": "1F78C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128909",
        "Unicode hex": "1F78D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "9726",
        "Unicode hex": "25FE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "9632",
        "Unicode hex": "25A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "9633",
        "Unicode hex": "25A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128913",
        "Unicode hex": "1F791"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128914",
        "Unicode hex": "1F792"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128915",
        "Unicode hex": "1F793"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128916",
        "Unicode hex": "1F794"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9635",
        "Unicode hex": "25A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128917",
        "Unicode hex": "1F795"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128918",
        "Unicode hex": "1F796"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128919",
        "Unicode hex": "1F797"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128920",
        "Unicode hex": "1F798"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "11045",
        "Unicode hex": "2B25"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "9671",
        "Unicode hex": "25C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "128922",
        "Unicode hex": "1F79A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "9672",
        "Unicode hex": "25C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "128923",
        "Unicode hex": "1F79B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128924",
        "Unicode hex": "1F79C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "128925",
        "Unicode hex": "1F79D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128926",
        "Unicode hex": "1F79E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "11050",
        "Unicode hex": "2B2A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "11047",
        "Unicode hex": "2B27"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128928",
        "Unicode hex": "1F7A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "9686",
        "Unicode hex": "25D6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "9687",
        "Unicode hex": "25D7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "11210",
        "Unicode hex": "2BCA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "11211",
        "Unicode hex": "2BCB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "11200",
        "Unicode hex": "2BC0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "11201",
        "Unicode hex": "2BC1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "11039",
        "Unicode hex": "2B1F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "11202",
        "Unicode hex": "2BC2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "11043",
        "Unicode hex": "2B23"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11042",
        "Unicode hex": "2B22"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11203",
        "Unicode hex": "2BC3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11204",
        "Unicode hex": "2BC4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128929",
        "Unicode hex": "1F7A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128930",
        "Unicode hex": "1F7A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128931",
        "Unicode hex": "1F7A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128932",
        "Unicode hex": "1F7A4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128933",
        "Unicode hex": "1F7A5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128934",
        "Unicode hex": "1F7A6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128935",
        "Unicode hex": "1F7A7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128936",
        "Unicode hex": "1F7A8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128937",
        "Unicode hex": "1F7A9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128938",
        "Unicode hex": "1F7AA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128939",
        "Unicode hex": "1F7AB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128940",
        "Unicode hex": "1F7AC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128941",
        "Unicode hex": "1F7AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128942",
        "Unicode hex": "1F7AE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128943",
        "Unicode hex": "1F7AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "128944",
        "Unicode hex": "1F7B0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "128945",
        "Unicode hex": "1F7B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "128946",
        "Unicode hex": "1F7B2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "128947",
        "Unicode hex": "1F7B3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "128948",
        "Unicode hex": "1F7B4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "128949",
        "Unicode hex": "1F7B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "128950",
        "Unicode hex": "1F7B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "128951",
        "Unicode hex": "1F7B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "128952",
        "Unicode hex": "1F7B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "128953",
        "Unicode hex": "1F7B9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "128954",
        "Unicode hex": "1F7BA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "128955",
        "Unicode hex": "1F7BB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "128956",
        "Unicode hex": "1F7BC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128957",
        "Unicode hex": "1F7BD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128958",
        "Unicode hex": "1F7BE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "128959",
        "Unicode hex": "1F7BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "128960",
        "Unicode hex": "1F7C0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128962",
        "Unicode hex": "1F7C2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128964",
        "Unicode hex": "1F7C4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "128966",
        "Unicode hex": "1F7C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "128969",
        "Unicode hex": "1F7C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128970",
        "Unicode hex": "1F7CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "10038",
        "Unicode hex": "2736"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "128972",
        "Unicode hex": "1F7CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128974",
        "Unicode hex": "1F7CE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128976",
        "Unicode hex": "1F7D0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128978",
        "Unicode hex": "1F7D2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "10041",
        "Unicode hex": "2739"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128963",
        "Unicode hex": "1F7C3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128967",
        "Unicode hex": "1F7C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128973",
        "Unicode hex": "1F7CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128980",
        "Unicode hex": "1F7D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11212",
        "Unicode hex": "2BCC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11213",
        "Unicode hex": "2BCD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "8251",
        "Unicode hex": "203B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "8258",
        "Unicode hex": "2042"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "11104",
        "Unicode hex": "2B60"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "11106",
        "Unicode hex": "2B62"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "11105",
        "Unicode hex": "2B61"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "11107",
        "Unicode hex": "2B63"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "11110",
        "Unicode hex": "2B66"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "11111",
        "Unicode hex": "2B67"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "11113",
        "Unicode hex": "2B69"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "11112",
        "Unicode hex": "2B68"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "11120",
        "Unicode hex": "2B70"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "11122",
        "Unicode hex": "2B72"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "11121",
        "Unicode hex": "2B71"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "11123",
        "Unicode hex": "2B73"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "11126",
        "Unicode hex": "2B76"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "11128",
        "Unicode hex": "2B78"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "11131",
        "Unicode hex": "2B7B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "11133",
        "Unicode hex": "2B7D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "11108",
        "Unicode hex": "2B64"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "11109",
        "Unicode hex": "2B65"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "11114",
        "Unicode hex": "2B6A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "11116",
        "Unicode hex": "2B6C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "11115",
        "Unicode hex": "2B6B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "11117",
        "Unicode hex": "2B6D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "11085",
        "Unicode hex": "2B4D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "11168",
        "Unicode hex": "2BA0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "11169",
        "Unicode hex": "2BA1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "11170",
        "Unicode hex": "2BA2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "11171",
        "Unicode hex": "2BA3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "11172",
        "Unicode hex": "2BA4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "11173",
        "Unicode hex": "2BA5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "11174",
        "Unicode hex": "2BA6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "11175",
        "Unicode hex": "2BA7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "11152",
        "Unicode hex": "2B90"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "11153",
        "Unicode hex": "2B91"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "11154",
        "Unicode hex": "2B92"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "11155",
        "Unicode hex": "2B93"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "11136",
        "Unicode hex": "2B80"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "11139",
        "Unicode hex": "2B83"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "11134",
        "Unicode hex": "2B7E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "11135",
        "Unicode hex": "2B7F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "11140",
        "Unicode hex": "2B84"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "11142",
        "Unicode hex": "2B86"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "11141",
        "Unicode hex": "2B85"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "11143",
        "Unicode hex": "2B87"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "11151",
        "Unicode hex": "2B8F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "11149",
        "Unicode hex": "2B8D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "11150",
        "Unicode hex": "2B8E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "11148",
        "Unicode hex": "2B8C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "11118",
        "Unicode hex": "2B6E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "11119",
        "Unicode hex": "2B6F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9099",
        "Unicode hex": "238B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "8996",
        "Unicode hex": "2324"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "8963",
        "Unicode hex": "2303"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "8997",
        "Unicode hex": "2325"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "9251",
        "Unicode hex": "2423"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "9085",
        "Unicode hex": "237D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "8682",
        "Unicode hex": "21EA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "11192",
        "Unicode hex": "2BB8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "129184",
        "Unicode hex": "1F8A0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "129185",
        "Unicode hex": "1F8A1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "129186",
        "Unicode hex": "1F8A2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "129187",
        "Unicode hex": "1F8A3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "129188",
        "Unicode hex": "1F8A4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "129189",
        "Unicode hex": "1F8A5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "129190",
        "Unicode hex": "1F8A6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "129191",
        "Unicode hex": "1F8A7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "129192",
        "Unicode hex": "1F8A8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "129193",
        "Unicode hex": "1F8A9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "129194",
        "Unicode hex": "1F8AA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "129195",
        "Unicode hex": "1F8AB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "129104",
        "Unicode hex": "1F850"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "129106",
        "Unicode hex": "1F852"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "129105",
        "Unicode hex": "1F851"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "129107",
        "Unicode hex": "1F853"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "129108",
        "Unicode hex": "1F854"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "129109",
        "Unicode hex": "1F855"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "129111",
        "Unicode hex": "1F857"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "129110",
        "Unicode hex": "1F856"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "129112",
        "Unicode hex": "1F858"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "129113",
        "Unicode hex": "1F859"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9650",
        "Unicode hex": "25B2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9660",
        "Unicode hex": "25BC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9651",
        "Unicode hex": "25B3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9661",
        "Unicode hex": "25BD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9664",
        "Unicode hex": "25C0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9654",
        "Unicode hex": "25B6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "9665",
        "Unicode hex": "25C1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9655",
        "Unicode hex": "25B7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "9699",
        "Unicode hex": "25E3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "9698",
        "Unicode hex": "25E2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "9700",
        "Unicode hex": "25E4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "9701",
        "Unicode hex": "25E5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "128896",
        "Unicode hex": "1F780"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128898",
        "Unicode hex": "1F782"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128897",
        "Unicode hex": "1F781"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128899",
        "Unicode hex": "1F783"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "11205",
        "Unicode hex": "2BC5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "11206",
        "Unicode hex": "2BC6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "11207",
        "Unicode hex": "2BC7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11208",
        "Unicode hex": "2BC8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "11164",
        "Unicode hex": "2B9C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "11166",
        "Unicode hex": "2B9E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "11165",
        "Unicode hex": "2B9D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "11167",
        "Unicode hex": "2B9F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "129040",
        "Unicode hex": "1F810"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "129042",
        "Unicode hex": "1F812"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "129041",
        "Unicode hex": "1F811"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "129043",
        "Unicode hex": "1F813"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "129044",
        "Unicode hex": "1F814"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "129046",
        "Unicode hex": "1F816"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "129045",
        "Unicode hex": "1F815"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "129047",
        "Unicode hex": "1F817"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "129048",
        "Unicode hex": "1F818"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "129050",
        "Unicode hex": "1F81A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "129049",
        "Unicode hex": "1F819"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "129051",
        "Unicode hex": "1F81B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "129052",
        "Unicode hex": "1F81C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "129054",
        "Unicode hex": "1F81E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "129053",
        "Unicode hex": "1F81D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "129055",
        "Unicode hex": "1F81F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "129024",
        "Unicode hex": "1F800"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "129026",
        "Unicode hex": "1F802"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "129025",
        "Unicode hex": "1F801"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "129027",
        "Unicode hex": "1F803"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "129028",
        "Unicode hex": "1F804"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "129030",
        "Unicode hex": "1F806"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "129029",
        "Unicode hex": "1F805"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "129031",
        "Unicode hex": "1F807"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "129032",
        "Unicode hex": "1F808"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "129034",
        "Unicode hex": "1F80A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "129033",
        "Unicode hex": "1F809"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "129035",
        "Unicode hex": "1F80B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "129056",
        "Unicode hex": "1F820"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "129058",
        "Unicode hex": "1F822"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "129060",
        "Unicode hex": "1F824"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "129062",
        "Unicode hex": "1F826"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "129064",
        "Unicode hex": "1F828"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "129066",
        "Unicode hex": "1F82A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "129068",
        "Unicode hex": "1F82C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "129180",
        "Unicode hex": "1F89C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "129181",
        "Unicode hex": "1F89D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "129182",
        "Unicode hex": "1F89E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "129183",
        "Unicode hex": "1F89F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "129070",
        "Unicode hex": "1F82E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "129072",
        "Unicode hex": "1F830"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "129074",
        "Unicode hex": "1F832"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "129076",
        "Unicode hex": "1F834"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "129078",
        "Unicode hex": "1F836"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "129080",
        "Unicode hex": "1F838"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "129082",
        "Unicode hex": "1F83A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "129081",
        "Unicode hex": "1F839"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "129083",
        "Unicode hex": "1F83B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "129176",
        "Unicode hex": "1F898"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "129178",
        "Unicode hex": "1F89A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "129177",
        "Unicode hex": "1F899"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "129179",
        "Unicode hex": "1F89B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "129084",
        "Unicode hex": "1F83C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "129086",
        "Unicode hex": "1F83E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "129085",
        "Unicode hex": "1F83D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "129087",
        "Unicode hex": "1F83F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "129088",
        "Unicode hex": "1F840"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "129090",
        "Unicode hex": "1F842"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "129089",
        "Unicode hex": "1F841"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "129091",
        "Unicode hex": "1F843"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "129092",
        "Unicode hex": "1F844"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "129094",
        "Unicode hex": "1F846"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "129093",
        "Unicode hex": "1F845"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "129095",
        "Unicode hex": "1F847"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11176",
        "Unicode hex": "2BA8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11177",
        "Unicode hex": "2BA9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "11178",
        "Unicode hex": "2BAA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "11179",
        "Unicode hex": "2BAB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "11180",
        "Unicode hex": "2BAC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "11181",
        "Unicode hex": "2BAD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "11182",
        "Unicode hex": "2BAE"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "11183",
        "Unicode hex": "2BAF"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "129120",
        "Unicode hex": "1F860"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "129122",
        "Unicode hex": "1F862"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "129121",
        "Unicode hex": "1F861"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "129123",
        "Unicode hex": "1F863"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "129124",
        "Unicode hex": "1F864"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "129125",
        "Unicode hex": "1F865"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "129127",
        "Unicode hex": "1F867"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "129126",
        "Unicode hex": "1F866"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "129136",
        "Unicode hex": "1F870"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "129138",
        "Unicode hex": "1F872"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "129137",
        "Unicode hex": "1F871"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "129139",
        "Unicode hex": "1F873"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "129140",
        "Unicode hex": "1F874"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "129141",
        "Unicode hex": "1F875"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129143",
        "Unicode hex": "1F877"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129142",
        "Unicode hex": "1F876"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129152",
        "Unicode hex": "1F880"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129154",
        "Unicode hex": "1F882"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129153",
        "Unicode hex": "1F881"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129155",
        "Unicode hex": "1F883"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129156",
        "Unicode hex": "1F884"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129157",
        "Unicode hex": "1F885"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129159",
        "Unicode hex": "1F887"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129158",
        "Unicode hex": "1F886"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129168",
        "Unicode hex": "1F890"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129170",
        "Unicode hex": "1F892"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129169",
        "Unicode hex": "1F891"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129171",
        "Unicode hex": "1F893"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129172",
        "Unicode hex": "1F894"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129174",
        "Unicode hex": "1F896"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "129173",
        "Unicode hex": "1F895"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "129175",
        "Unicode hex": "1F897"
    }
];
module.exports.default = $e6086d8520c6d42a$var$dingbats;

});

parcelRegister("kUMgi", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $f39e79698ee33a3c$export$9c206ddddb32a9b; }, function (v) { return $f39e79698ee33a3c$export$9c206ddddb32a9b = v; });
$parcel$export(module.exports, "run", function () { return $f39e79698ee33a3c$export$889ea624f2cb2c57; }, function (v) { return $f39e79698ee33a3c$export$889ea624f2cb2c57 = v; });
$parcel$export(module.exports, "_elements", function () { return $f39e79698ee33a3c$export$297bfd0191b750db; }, function (v) { return $f39e79698ee33a3c$export$297bfd0191b750db = v; });
$parcel$export(module.exports, "_elementsOfType", function () { return $f39e79698ee33a3c$export$e7e1b0baa764e14f; }, function (v) { return $f39e79698ee33a3c$export$e7e1b0baa764e14f = v; });
$parcel$export(module.exports, "getDescendantsOfType", function () { return $f39e79698ee33a3c$export$a892993bbae48540; }, function (v) { return $f39e79698ee33a3c$export$a892993bbae48540 = v; });
$parcel$export(module.exports, "getDescendants", function () { return $f39e79698ee33a3c$export$d607bcb6675e3e03; }, function (v) { return $f39e79698ee33a3c$export$d607bcb6675e3e03 = v; });
var $f39e79698ee33a3c$export$9c206ddddb32a9b;
var $f39e79698ee33a3c$export$889ea624f2cb2c57;
var $f39e79698ee33a3c$export$297bfd0191b750db;
var $f39e79698ee33a3c$export$e7e1b0baa764e14f;
var $f39e79698ee33a3c$export$a892993bbae48540;
var $f39e79698ee33a3c$export$d607bcb6675e3e03;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $gfTwJ = parcelRequire("gfTwJ");
$f39e79698ee33a3c$export$9c206ddddb32a9b = $f39e79698ee33a3c$var$paragraph;
$f39e79698ee33a3c$export$889ea624f2cb2c57 = $f39e79698ee33a3c$var$run;
$f39e79698ee33a3c$export$297bfd0191b750db = $f39e79698ee33a3c$var$elements;
$f39e79698ee33a3c$export$e7e1b0baa764e14f = $f39e79698ee33a3c$var$elementsOfType;
$f39e79698ee33a3c$export$a892993bbae48540 = $f39e79698ee33a3c$var$getDescendantsOfType;
$f39e79698ee33a3c$export$d607bcb6675e3e03 = $f39e79698ee33a3c$var$getDescendants;
function $f39e79698ee33a3c$var$paragraph(transform) {
    return $f39e79698ee33a3c$var$elementsOfType("paragraph", transform);
}
function $f39e79698ee33a3c$var$run(transform) {
    return $f39e79698ee33a3c$var$elementsOfType("run", transform);
}
function $f39e79698ee33a3c$var$elementsOfType(elementType, transform) {
    return $f39e79698ee33a3c$var$elements(function(element) {
        if (element.type === elementType) return transform(element);
        else return element;
    });
}
function $f39e79698ee33a3c$var$elements(transform) {
    return function transformElement(element) {
        if (element.children) {
            var children = $gfTwJ.default(element.children, transformElement);
            element = $5yjjJ.default(element, {
                children: children
            });
        }
        return transform(element);
    };
}
function $f39e79698ee33a3c$var$getDescendantsOfType(element, type) {
    return $f39e79698ee33a3c$var$getDescendants(element).filter(function(descendant) {
        return descendant.type === type;
    });
}
function $f39e79698ee33a3c$var$getDescendants(element) {
    var descendants = [];
    $f39e79698ee33a3c$var$visitDescendants(element, function(descendant) {
        descendants.push(descendant);
    });
    return descendants;
}
function $f39e79698ee33a3c$var$visitDescendants(element, visit) {
    if (element.children) element.children.forEach(function(child) {
        $f39e79698ee33a3c$var$visitDescendants(child, visit);
        visit(child);
    });
}

});

parcelRegister("3OjMG", function(module, exports) {
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");
var $gfTwJ = parcelRequire("gfTwJ");

var $cLuIA = parcelRequire("cLuIA");
function $2c65635a21c9a7c6$var$simplify(nodes) {
    return $2c65635a21c9a7c6$var$collapse($2c65635a21c9a7c6$var$removeEmpty(nodes));
}
function $2c65635a21c9a7c6$var$collapse(nodes) {
    var children = [];
    nodes.map($2c65635a21c9a7c6$var$collapseNode).forEach(function(child) {
        $2c65635a21c9a7c6$var$appendChild(children, child);
    });
    return children;
}
function $2c65635a21c9a7c6$var$collapseNode(node) {
    return $2c65635a21c9a7c6$var$collapsers[node.type](node);
}
var $2c65635a21c9a7c6$var$collapsers = {
    element: $2c65635a21c9a7c6$var$collapseElement,
    text: $2c65635a21c9a7c6$var$identity,
    forceWrite: $2c65635a21c9a7c6$var$identity
};
function $2c65635a21c9a7c6$var$collapseElement(node) {
    return $cLuIA.elementWithTag(node.tag, $2c65635a21c9a7c6$var$collapse(node.children));
}
function $2c65635a21c9a7c6$var$identity(value) {
    return value;
}
function $2c65635a21c9a7c6$var$appendChild(children, child) {
    var lastChild = children[children.length - 1];
    if (child.type === "element" && !child.tag.fresh && lastChild && lastChild.type === "element" && child.tag.matchesElement(lastChild.tag)) {
        if (child.tag.separator) $2c65635a21c9a7c6$var$appendChild(lastChild.children, $cLuIA.text(child.tag.separator));
        child.children.forEach(function(grandChild) {
            // Mutation is fine since simplifying elements create a copy of the children.
            $2c65635a21c9a7c6$var$appendChild(lastChild.children, grandChild);
        });
    } else children.push(child);
}
function $2c65635a21c9a7c6$var$removeEmpty(nodes) {
    return $2c65635a21c9a7c6$var$flatMap(nodes, function(node) {
        return $2c65635a21c9a7c6$var$emptiers[node.type](node);
    });
}
function $2c65635a21c9a7c6$var$flatMap(values, func) {
    return $1TwZj.default($gfTwJ.default(values, func), true);
}
var $2c65635a21c9a7c6$var$emptiers = {
    element: $2c65635a21c9a7c6$var$elementEmptier,
    text: $2c65635a21c9a7c6$var$textEmptier,
    forceWrite: $2c65635a21c9a7c6$var$neverEmpty
};
function $2c65635a21c9a7c6$var$neverEmpty(node) {
    return [
        node
    ];
}
function $2c65635a21c9a7c6$var$elementEmptier(element) {
    var children = $2c65635a21c9a7c6$var$removeEmpty(element.children);
    if (children.length === 0 && !$cLuIA.isVoidElement(element)) return [];
    else return [
        $cLuIA.elementWithTag(element.tag, children)
    ];
}
function $2c65635a21c9a7c6$var$textEmptier(node) {
    if (node.value.length === 0) return [];
    else return [
        node
    ];
}
module.exports = $2c65635a21c9a7c6$var$simplify;

});
parcelRegister("cLuIA", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $94b1b3d026189e52$export$930fc3b604aa2e41; }, function (v) { return $94b1b3d026189e52$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $94b1b3d026189e52$export$288e963e20e7093f; }, function (v) { return $94b1b3d026189e52$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $94b1b3d026189e52$export$dca5772e3b681cdf; }, function (v) { return $94b1b3d026189e52$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $94b1b3d026189e52$export$6f093cfa640b7166; }, function (v) { return $94b1b3d026189e52$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $94b1b3d026189e52$export$a98c45d6a360f787; }, function (v) { return $94b1b3d026189e52$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "isVoidElement", function () { return $94b1b3d026189e52$export$ce7b605508b1d8cd; }, function (v) { return $94b1b3d026189e52$export$ce7b605508b1d8cd = v; });
var $94b1b3d026189e52$export$930fc3b604aa2e41;
var $94b1b3d026189e52$export$288e963e20e7093f;
var $94b1b3d026189e52$export$dca5772e3b681cdf;
var $94b1b3d026189e52$export$6f093cfa640b7166;
var $94b1b3d026189e52$export$a98c45d6a360f787;
var $94b1b3d026189e52$export$ce7b605508b1d8cd;

var $hEvL6 = parcelRequire("hEvL6");
function $94b1b3d026189e52$var$nonFreshElement(tagName, attributes, children) {
    return $94b1b3d026189e52$var$elementWithTag($hEvL6.element(tagName, attributes, {
        fresh: false
    }), children);
}
function $94b1b3d026189e52$var$freshElement(tagName, attributes, children) {
    var tag = $hEvL6.element(tagName, attributes, {
        fresh: true
    });
    return $94b1b3d026189e52$var$elementWithTag(tag, children);
}
function $94b1b3d026189e52$var$elementWithTag(tag, children) {
    return {
        type: "element",
        tag: tag,
        children: children || []
    };
}
function $94b1b3d026189e52$var$text(value) {
    return {
        type: "text",
        value: value
    };
}
var $94b1b3d026189e52$var$forceWrite = {
    type: "forceWrite"
};
$94b1b3d026189e52$export$930fc3b604aa2e41 = $94b1b3d026189e52$var$freshElement;
$94b1b3d026189e52$export$288e963e20e7093f = $94b1b3d026189e52$var$nonFreshElement;
$94b1b3d026189e52$export$dca5772e3b681cdf = $94b1b3d026189e52$var$elementWithTag;
$94b1b3d026189e52$export$6f093cfa640b7166 = $94b1b3d026189e52$var$text;
$94b1b3d026189e52$export$a98c45d6a360f787 = $94b1b3d026189e52$var$forceWrite;
var $94b1b3d026189e52$var$voidTagNames = {
    "br": true,
    "hr": true,
    "img": true,
    "input": true
};
function $94b1b3d026189e52$var$isVoidElement(node) {
    return node.children.length === 0 && $94b1b3d026189e52$var$voidTagNames[node.tag.tagName];
}
$94b1b3d026189e52$export$ce7b605508b1d8cd = $94b1b3d026189e52$var$isVoidElement;

});
parcelRegister("hEvL6", function(module, exports) {

$parcel$export(module.exports, "topLevelElement", function () { return $cd9eceb8237fc342$export$3f0e324b0c23f49b; }, function (v) { return $cd9eceb8237fc342$export$3f0e324b0c23f49b = v; });
$parcel$export(module.exports, "elements", function () { return $cd9eceb8237fc342$export$7a5d735b2ab6389d; }, function (v) { return $cd9eceb8237fc342$export$7a5d735b2ab6389d = v; });
$parcel$export(module.exports, "element", function () { return $cd9eceb8237fc342$export$8454457683f90105; }, function (v) { return $cd9eceb8237fc342$export$8454457683f90105 = v; });
$parcel$export(module.exports, "empty", function () { return $cd9eceb8237fc342$export$6e22c362a0406a2c; }, function (v) { return $cd9eceb8237fc342$export$6e22c362a0406a2c = v; });
$parcel$export(module.exports, "ignore", function () { return $cd9eceb8237fc342$export$738b109e247a462c; }, function (v) { return $cd9eceb8237fc342$export$738b109e247a462c = v; });
var $cd9eceb8237fc342$export$3f0e324b0c23f49b;
var $cd9eceb8237fc342$export$7a5d735b2ab6389d;
var $cd9eceb8237fc342$export$8454457683f90105;
var $cd9eceb8237fc342$export$6e22c362a0406a2c;
var $cd9eceb8237fc342$export$738b109e247a462c;
parcelRequire("9jAvV");
var $3rBlz = parcelRequire("3rBlz");
var $8C01Z = parcelRequire("8C01Z");
var $jmGFg = parcelRequire("jmGFg");

var $8eobO = parcelRequire("8eobO");
$cd9eceb8237fc342$export$3f0e324b0c23f49b = $cd9eceb8237fc342$var$topLevelElement;
$cd9eceb8237fc342$export$7a5d735b2ab6389d = $cd9eceb8237fc342$var$elements;
$cd9eceb8237fc342$export$8454457683f90105 = $cd9eceb8237fc342$var$element;
function $cd9eceb8237fc342$var$topLevelElement(tagName, attributes) {
    return $cd9eceb8237fc342$var$elements([
        $cd9eceb8237fc342$var$element(tagName, attributes, {
            fresh: true
        })
    ]);
}
function $cd9eceb8237fc342$var$elements(elementStyles) {
    return new $cd9eceb8237fc342$var$HtmlPath(elementStyles.map(function(elementStyle) {
        if ($jmGFg.default(elementStyle)) return $cd9eceb8237fc342$var$element(elementStyle);
        else return elementStyle;
    }));
}
function $cd9eceb8237fc342$var$HtmlPath(elements) {
    this._elements = elements;
}
$cd9eceb8237fc342$var$HtmlPath.prototype.wrap = function wrap(children) {
    var result = children();
    for(var index = this._elements.length - 1; index >= 0; index--)result = this._elements[index].wrapNodes(result);
    return result;
};
function $cd9eceb8237fc342$var$element(tagName, attributes, options) {
    options = options || {};
    return new $cd9eceb8237fc342$var$Element(tagName, attributes, options);
}
function $cd9eceb8237fc342$var$Element(tagName, attributes, options) {
    var tagNames = {};
    if ($3rBlz.default(tagName)) {
        tagName.forEach(function(tagName) {
            tagNames[tagName] = true;
        });
        tagName = tagName[0];
    } else tagNames[tagName] = true;
    this.tagName = tagName;
    this.tagNames = tagNames;
    this.attributes = attributes || {};
    this.fresh = options.fresh;
    this.separator = options.separator;
}
$cd9eceb8237fc342$var$Element.prototype.matchesElement = function(element) {
    return this.tagNames[element.tagName] && $8C01Z.default(this.attributes || {}, element.attributes || {});
};
$cd9eceb8237fc342$var$Element.prototype.wrap = function wrap(generateNodes) {
    return this.wrapNodes(generateNodes());
};
$cd9eceb8237fc342$var$Element.prototype.wrapNodes = function wrapNodes(nodes) {
    return [
        $8eobO.elementWithTag(this, nodes)
    ];
};
$cd9eceb8237fc342$export$6e22c362a0406a2c = $cd9eceb8237fc342$var$elements([]);
$cd9eceb8237fc342$export$738b109e247a462c = {
    wrap: function() {
        return [];
    }
};

});
parcelRegister("8eobO", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $5fe26518616359bb$export$930fc3b604aa2e41; }, function (v) { return $5fe26518616359bb$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $5fe26518616359bb$export$288e963e20e7093f; }, function (v) { return $5fe26518616359bb$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $5fe26518616359bb$export$dca5772e3b681cdf; }, function (v) { return $5fe26518616359bb$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $5fe26518616359bb$export$6f093cfa640b7166; }, function (v) { return $5fe26518616359bb$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $5fe26518616359bb$export$a98c45d6a360f787; }, function (v) { return $5fe26518616359bb$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "simplify", function () { return $5fe26518616359bb$export$798b53621063651; }, function (v) { return $5fe26518616359bb$export$798b53621063651 = v; });
$parcel$export(module.exports, "write", function () { return $5fe26518616359bb$export$68d8715fc104d294; }, function (v) { return $5fe26518616359bb$export$68d8715fc104d294 = v; });
var $5fe26518616359bb$export$930fc3b604aa2e41;
var $5fe26518616359bb$export$288e963e20e7093f;
var $5fe26518616359bb$export$dca5772e3b681cdf;
var $5fe26518616359bb$export$6f093cfa640b7166;
var $5fe26518616359bb$export$a98c45d6a360f787;
var $5fe26518616359bb$export$798b53621063651;
var $5fe26518616359bb$export$68d8715fc104d294;

var $cLuIA = parcelRequire("cLuIA");
$5fe26518616359bb$export$930fc3b604aa2e41 = $cLuIA.freshElement;
$5fe26518616359bb$export$288e963e20e7093f = $cLuIA.nonFreshElement;
$5fe26518616359bb$export$dca5772e3b681cdf = $cLuIA.elementWithTag;
$5fe26518616359bb$export$6f093cfa640b7166 = $cLuIA.text;
$5fe26518616359bb$export$a98c45d6a360f787 = $cLuIA.forceWrite;

$5fe26518616359bb$export$798b53621063651 = (parcelRequire("3OjMG"));
function $5fe26518616359bb$var$write(writer, nodes) {
    nodes.forEach(function(node) {
        $5fe26518616359bb$var$writeNode(writer, node);
    });
}
function $5fe26518616359bb$var$writeNode(writer, node) {
    $5fe26518616359bb$var$toStrings[node.type](writer, node);
}
var $5fe26518616359bb$var$toStrings = {
    element: $5fe26518616359bb$var$generateElementString,
    text: $5fe26518616359bb$var$generateTextString,
    forceWrite: function() {}
};
function $5fe26518616359bb$var$generateElementString(writer, node) {
    if ($cLuIA.isVoidElement(node)) writer.selfClosing(node.tag.tagName, node.tag.attributes);
    else {
        writer.open(node.tag.tagName, node.tag.attributes);
        $5fe26518616359bb$var$write(writer, node.children);
        writer.close(node.tag.tagName);
    }
}
function $5fe26518616359bb$var$generateTextString(writer, node) {
    writer.text(node.value);
}
$5fe26518616359bb$export$68d8715fc104d294 = $5fe26518616359bb$var$write;

});




parcelRegister("gOpjt", function(module, exports) {

$parcel$export(module.exports, "imgElement", function () { return $c3d4f3817c09ab04$export$447d08562cb82152; }, function (v) { return $c3d4f3817c09ab04$export$447d08562cb82152 = v; });
$parcel$export(module.exports, "inline", function () { return $c3d4f3817c09ab04$export$18c8ad048e32c7d5; }, function (v) { return $c3d4f3817c09ab04$export$18c8ad048e32c7d5 = v; });
$parcel$export(module.exports, "dataUri", function () { return $c3d4f3817c09ab04$export$bc36deb06467538e; }, function (v) { return $c3d4f3817c09ab04$export$bc36deb06467538e = v; });
var $c3d4f3817c09ab04$export$447d08562cb82152;
// Undocumented, but retained for backwards-compatibility with 0.3.x
var $c3d4f3817c09ab04$export$18c8ad048e32c7d5;
var $c3d4f3817c09ab04$export$bc36deb06467538e;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");

var $d93yU = parcelRequire("d93yU");

var $8eobO = parcelRequire("8eobO");
$c3d4f3817c09ab04$export$447d08562cb82152 = $c3d4f3817c09ab04$var$imgElement;
function $c3d4f3817c09ab04$var$imgElement(func) {
    return function(element, messages) {
        return $d93yU.when(func(element)).then(function(result) {
            var attributes = {};
            if (element.altText) attributes.alt = element.altText;
            $5yjjJ.default(attributes, result);
            return [
                $8eobO.freshElement("img", attributes)
            ];
        });
    };
}
$c3d4f3817c09ab04$export$18c8ad048e32c7d5 = $c3d4f3817c09ab04$export$447d08562cb82152;
$c3d4f3817c09ab04$export$bc36deb06467538e = $c3d4f3817c09ab04$var$imgElement(function(element) {
    return element.readAsBase64String().then(function(imageBuffer) {
        return {
            src: "data:" + element.contentType + ";base64," + imageBuffer
        };
    });
});

});

parcelRegister("17glP", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $0d0320de2171a013$export$7acfa6ed01010e37; }, function (v) { return $0d0320de2171a013$export$7acfa6ed01010e37 = v; });
var $0d0320de2171a013$export$7acfa6ed01010e37;

var $3e5bH = parcelRequire("3e5bH");
$0d0320de2171a013$export$7acfa6ed01010e37 = function(options) {
    var parseTokens = function(parser, tokens) {
        return parser(new $3e5bH(tokens));
    };
    return {
        parseTokens: parseTokens
    };
};

});
parcelRegister("3e5bH", function(module, exports) {
var $2596b40f6501a16a$var$TokenIterator = module.exports = function(tokens, startIndex) {
    this._tokens = tokens;
    this._startIndex = startIndex || 0;
};
$2596b40f6501a16a$var$TokenIterator.prototype.head = function() {
    return this._tokens[this._startIndex];
};
$2596b40f6501a16a$var$TokenIterator.prototype.tail = function(startIndex) {
    return new $2596b40f6501a16a$var$TokenIterator(this._tokens, this._startIndex + 1);
};
$2596b40f6501a16a$var$TokenIterator.prototype.toArray = function() {
    return this._tokens.slice(this._startIndex);
};
$2596b40f6501a16a$var$TokenIterator.prototype.end = function() {
    return this._tokens[this._tokens.length - 1];
};
// TODO: doesn't need to be a method, can be a separate function,
// which simplifies implementation of the TokenIterator interface
$2596b40f6501a16a$var$TokenIterator.prototype.to = function(end) {
    var start = this.head().source;
    var endToken = end.head() || end.end();
    return start.to(endToken.source);
};

});


parcelRegister("moeVv", function(module, exports) {

$parcel$export(module.exports, "token", function () { return $0434dbb2acc97ec2$export$9e1725a4cfeada27; }, function (v) { return $0434dbb2acc97ec2$export$9e1725a4cfeada27 = v; });
$parcel$export(module.exports, "tokenOfType", function () { return $0434dbb2acc97ec2$export$41696449d44bc99f; }, function (v) { return $0434dbb2acc97ec2$export$41696449d44bc99f = v; });
$parcel$export(module.exports, "firstOf", function () { return $0434dbb2acc97ec2$export$320dfad4854fb566; }, function (v) { return $0434dbb2acc97ec2$export$320dfad4854fb566 = v; });
$parcel$export(module.exports, "then", function () { return $0434dbb2acc97ec2$export$ff2899a39f81dcfa; }, function (v) { return $0434dbb2acc97ec2$export$ff2899a39f81dcfa = v; });
$parcel$export(module.exports, "sequence", function () { return $0434dbb2acc97ec2$export$49bb65c2ea163039; }, function (v) { return $0434dbb2acc97ec2$export$49bb65c2ea163039 = v; });
$parcel$export(module.exports, "optional", function () { return $0434dbb2acc97ec2$export$516e28dec6a4b6d4; }, function (v) { return $0434dbb2acc97ec2$export$516e28dec6a4b6d4 = v; });
$parcel$export(module.exports, "zeroOrMoreWithSeparator", function () { return $0434dbb2acc97ec2$export$3efe17da37330ee1; }, function (v) { return $0434dbb2acc97ec2$export$3efe17da37330ee1 = v; });
$parcel$export(module.exports, "oneOrMoreWithSeparator", function () { return $0434dbb2acc97ec2$export$e4021a525ad1b87a; }, function (v) { return $0434dbb2acc97ec2$export$e4021a525ad1b87a = v; });
$parcel$export(module.exports, "zeroOrMore", function () { return $0434dbb2acc97ec2$export$d72c500c373b4da6; }, function (v) { return $0434dbb2acc97ec2$export$d72c500c373b4da6 = v; });
$parcel$export(module.exports, "oneOrMore", function () { return $0434dbb2acc97ec2$export$c207d1ebdac09916; }, function (v) { return $0434dbb2acc97ec2$export$c207d1ebdac09916 = v; });
$parcel$export(module.exports, "leftAssociative", function () { return $0434dbb2acc97ec2$export$ae4cf6488905ca50; }, function (v) { return $0434dbb2acc97ec2$export$ae4cf6488905ca50 = v; });
$parcel$export(module.exports, "nonConsuming", function () { return $0434dbb2acc97ec2$export$e85d6b145bf6c7b6; }, function (v) { return $0434dbb2acc97ec2$export$e85d6b145bf6c7b6 = v; });
var $0434dbb2acc97ec2$export$9e1725a4cfeada27;
var $0434dbb2acc97ec2$export$41696449d44bc99f;
var $0434dbb2acc97ec2$export$320dfad4854fb566;
var $0434dbb2acc97ec2$export$ff2899a39f81dcfa;
var $0434dbb2acc97ec2$export$49bb65c2ea163039;
var $0434dbb2acc97ec2$export$516e28dec6a4b6d4;
var $0434dbb2acc97ec2$export$3efe17da37330ee1;
var $0434dbb2acc97ec2$export$e4021a525ad1b87a;
var $0434dbb2acc97ec2$export$d72c500c373b4da6;
var $0434dbb2acc97ec2$export$c207d1ebdac09916;
var $0434dbb2acc97ec2$export$ae4cf6488905ca50;
var $0434dbb2acc97ec2$export$e85d6b145bf6c7b6;
parcelRequire("9jAvV");
var $5mG2j = parcelRequire("5mG2j");
var $bss2W = parcelRequire("bss2W");
var $jD3Ao = parcelRequire("jD3Ao");
var $3rBlz = parcelRequire("3rBlz");

var $2xu0n = parcelRequire("2xu0n");

var $cB0qU = parcelRequire("cB0qU");

var $5wxOh = parcelRequire("5wxOh");

var $e9ZHS = parcelRequire("e9ZHS");
$0434dbb2acc97ec2$export$9e1725a4cfeada27 = function(tokenType, value) {
    var matchValue = value !== undefined;
    return function(input) {
        var token = input.head();
        if (token && token.name === tokenType && (!matchValue || token.value === value)) return $cB0qU.success(token.value, input.tail(), token.source);
        else {
            var expected = $0434dbb2acc97ec2$var$describeToken({
                name: tokenType,
                value: value
            });
            return $0434dbb2acc97ec2$var$describeTokenMismatch(input, expected);
        }
    };
};
$0434dbb2acc97ec2$export$41696449d44bc99f = function(tokenType) {
    return $0434dbb2acc97ec2$export$9e1725a4cfeada27(tokenType);
};
$0434dbb2acc97ec2$export$320dfad4854fb566 = function(name, parsers) {
    if (!$3rBlz.default(parsers)) parsers = Array.prototype.slice.call(arguments, 1);
    return function(input) {
        return $e9ZHS.fromArray(parsers).map(function(parser) {
            return parser(input);
        }).filter(function(result) {
            return result.isSuccess() || result.isError();
        }).first() || $0434dbb2acc97ec2$var$describeTokenMismatch(input, name);
    };
};
$0434dbb2acc97ec2$export$ff2899a39f81dcfa = function(parser, func) {
    return function(input) {
        var result = parser(input);
        if (!result.map) console.log(result);
        return result.map(func);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039 = function() {
    var parsers = Array.prototype.slice.call(arguments, 0);
    var rule = function(input) {
        var result = $jD3Ao.default(parsers, function(memo, parser) {
            var result = memo.result;
            var hasCut = memo.hasCut;
            if (!result.isSuccess()) return {
                result: result,
                hasCut: hasCut
            };
            var subResult = parser(result.remaining());
            if (subResult.isCut()) return {
                result: result,
                hasCut: true
            };
            else if (subResult.isSuccess()) {
                var values;
                if (parser.isCaptured) values = result.value().withValue(parser, subResult.value());
                else values = result.value();
                var remaining = subResult.remaining();
                var source = input.to(remaining);
                return {
                    result: $cB0qU.success(values, remaining, source),
                    hasCut: hasCut
                };
            } else if (hasCut) return {
                result: $cB0qU.error(subResult.errors(), subResult.remaining()),
                hasCut: hasCut
            };
            else return {
                result: subResult,
                hasCut: hasCut
            };
        }, {
            result: $cB0qU.success(new $0434dbb2acc97ec2$var$SequenceValues(), input),
            hasCut: false
        }).result;
        var source = input.to(result.remaining());
        return result.map(function(values) {
            return values.withValue($0434dbb2acc97ec2$export$49bb65c2ea163039.source, source);
        });
    };
    rule.head = function() {
        var firstCapture = $bss2W.default(parsers, isCapturedRule);
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(rule, $0434dbb2acc97ec2$export$49bb65c2ea163039.extract(firstCapture));
    };
    rule.map = function(func) {
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(rule, function(result) {
            return func.apply(this, result.toArray());
        });
    };
    function isCapturedRule(subRule) {
        return subRule.isCaptured;
    }
    return rule;
};
var $0434dbb2acc97ec2$var$SequenceValues = function(values, valuesArray) {
    this._values = values || {};
    this._valuesArray = valuesArray || [];
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.withValue = function(rule, value) {
    if (rule.captureName && rule.captureName in this._values) throw new Error("Cannot add second value for capture \"" + rule.captureName + "\"");
    else {
        var newValues = $5mG2j.default(this._values);
        newValues[rule.captureName] = value;
        var newValuesArray = this._valuesArray.concat([
            value
        ]);
        return new $0434dbb2acc97ec2$var$SequenceValues(newValues, newValuesArray);
    }
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.get = function(rule) {
    if (rule.captureName in this._values) return this._values[rule.captureName];
    else throw new Error("No value for capture \"" + rule.captureName + "\"");
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.toArray = function() {
    return this._valuesArray;
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.capture = function(rule, name) {
    var captureRule = function() {
        return rule.apply(this, arguments);
    };
    captureRule.captureName = name;
    captureRule.isCaptured = true;
    return captureRule;
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.extract = function(rule) {
    return function(result) {
        return result.get(rule);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.applyValues = function(func) {
    // TODO: check captureName doesn't conflict with source or other captures
    var rules = Array.prototype.slice.call(arguments, 1);
    return function(result) {
        var values = rules.map(function(rule) {
            return result.get(rule);
        });
        return func.apply(this, values);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.source = {
    captureName: "\u2603source\u2603"
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.cut = function() {
    return function(input) {
        return $cB0qU.cut(input);
    };
};
$0434dbb2acc97ec2$export$516e28dec6a4b6d4 = function(rule) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) return result.map($2xu0n.some);
        else if (result.isFailure()) return $cB0qU.success($2xu0n.none, input);
        else return result;
    };
};
$0434dbb2acc97ec2$export$3efe17da37330ee1 = function(rule, separator) {
    return $0434dbb2acc97ec2$var$repeatedWithSeparator(rule, separator, false);
};
$0434dbb2acc97ec2$export$e4021a525ad1b87a = function(rule, separator) {
    return $0434dbb2acc97ec2$var$repeatedWithSeparator(rule, separator, true);
};
var $0434dbb2acc97ec2$var$zeroOrMore = $0434dbb2acc97ec2$export$d72c500c373b4da6 = function(rule) {
    return function(input) {
        var values = [];
        var result;
        while((result = rule(input)) && result.isSuccess()){
            input = result.remaining();
            values.push(result.value());
        }
        if (result.isError()) return result;
        else return $cB0qU.success(values, input);
    };
};
$0434dbb2acc97ec2$export$c207d1ebdac09916 = function(rule) {
    return $0434dbb2acc97ec2$export$e4021a525ad1b87a(rule, $0434dbb2acc97ec2$var$noOpRule);
};
function $0434dbb2acc97ec2$var$noOpRule(input) {
    return $cB0qU.success(null, input);
}
var $0434dbb2acc97ec2$var$repeatedWithSeparator = function(rule, separator, isOneOrMore) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) {
            var mainRule = $0434dbb2acc97ec2$export$49bb65c2ea163039.capture(rule, "main");
            var remainingRule = $0434dbb2acc97ec2$var$zeroOrMore($0434dbb2acc97ec2$export$ff2899a39f81dcfa($0434dbb2acc97ec2$export$49bb65c2ea163039(separator, mainRule), $0434dbb2acc97ec2$export$49bb65c2ea163039.extract(mainRule)));
            var remainingResult = remainingRule(result.remaining());
            return $cB0qU.success([
                result.value()
            ].concat(remainingResult.value()), remainingResult.remaining());
        } else if (isOneOrMore || result.isError()) return result;
        else return $cB0qU.success([], input);
    };
};
$0434dbb2acc97ec2$export$ae4cf6488905ca50 = function(leftRule, rightRule, func) {
    var rights;
    if (func) rights = [
        {
            func: func,
            rule: rightRule
        }
    ];
    else rights = rightRule;
    rights = rights.map(function(right) {
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(right.rule, function(rightValue) {
            return function(leftValue, source) {
                return right.func(leftValue, rightValue, source);
            };
        });
    });
    var repeatedRule = $0434dbb2acc97ec2$export$320dfad4854fb566.apply(null, [
        "rules"
    ].concat(rights));
    return function(input) {
        var start = input;
        var leftResult = leftRule(input);
        if (!leftResult.isSuccess()) return leftResult;
        var repeatedResult = repeatedRule(leftResult.remaining());
        while(repeatedResult.isSuccess()){
            var remaining = repeatedResult.remaining();
            var source = start.to(repeatedResult.remaining());
            var right = repeatedResult.value();
            leftResult = $cB0qU.success(right(leftResult.value(), source), remaining, source);
            repeatedResult = repeatedRule(leftResult.remaining());
        }
        if (repeatedResult.isError()) return repeatedResult;
        return leftResult;
    };
};
$0434dbb2acc97ec2$export$ae4cf6488905ca50.firstOf = function() {
    return Array.prototype.slice.call(arguments, 0);
};
$0434dbb2acc97ec2$export$e85d6b145bf6c7b6 = function(rule) {
    return function(input) {
        return rule(input).changeRemaining(input);
    };
};
var $0434dbb2acc97ec2$var$describeToken = function(token) {
    if (token.value) return token.name + " \"" + token.value + "\"";
    else return token.name;
};
function $0434dbb2acc97ec2$var$describeTokenMismatch(input, expected) {
    var error;
    var token = input.head();
    if (token) error = $5wxOh.error({
        expected: expected,
        actual: $0434dbb2acc97ec2$var$describeToken(token),
        location: token.source
    });
    else error = $5wxOh.error({
        expected: expected,
        actual: "end of tokens"
    });
    return $cB0qU.failure([
        error
    ], input);
}

});
parcelRegister("2xu0n", function(module, exports) {

$parcel$export(module.exports, "none", function () { return $1d95f032bda6d6ff$export$f883a24d5edde77c; }, function (v) { return $1d95f032bda6d6ff$export$f883a24d5edde77c = v; });
$parcel$export(module.exports, "some", function () { return $1d95f032bda6d6ff$export$ad14ef4001db2bcd; }, function (v) { return $1d95f032bda6d6ff$export$ad14ef4001db2bcd = v; });
var $1d95f032bda6d6ff$export$f883a24d5edde77c;
var $1d95f032bda6d6ff$export$ad14ef4001db2bcd;
var $1d95f032bda6d6ff$export$707cacfe2982dfac;
var $1d95f032bda6d6ff$export$b601f49376b4621a;
$1d95f032bda6d6ff$export$f883a24d5edde77c = Object.create({
    value: function() {
        throw new Error('Called value on none');
    },
    isNone: function() {
        return true;
    },
    isSome: function() {
        return false;
    },
    map: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    flatMap: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    filter: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    toArray: function() {
        return [];
    },
    orElse: $1d95f032bda6d6ff$var$callOrReturn,
    valueOrElse: $1d95f032bda6d6ff$var$callOrReturn
});
function $1d95f032bda6d6ff$var$callOrReturn(value) {
    if (typeof value == "function") return value();
    else return value;
}
$1d95f032bda6d6ff$export$ad14ef4001db2bcd = function(value) {
    return new $1d95f032bda6d6ff$var$Some(value);
};
var $1d95f032bda6d6ff$var$Some = function(value) {
    this._value = value;
};
$1d95f032bda6d6ff$var$Some.prototype.value = function() {
    return this._value;
};
$1d95f032bda6d6ff$var$Some.prototype.isNone = function() {
    return false;
};
$1d95f032bda6d6ff$var$Some.prototype.isSome = function() {
    return true;
};
$1d95f032bda6d6ff$var$Some.prototype.map = function(func) {
    return new $1d95f032bda6d6ff$var$Some(func(this._value));
};
$1d95f032bda6d6ff$var$Some.prototype.flatMap = function(func) {
    return func(this._value);
};
$1d95f032bda6d6ff$var$Some.prototype.filter = function(predicate) {
    return predicate(this._value) ? this : $1d95f032bda6d6ff$export$f883a24d5edde77c;
};
$1d95f032bda6d6ff$var$Some.prototype.toArray = function() {
    return [
        this._value
    ];
};
$1d95f032bda6d6ff$var$Some.prototype.orElse = function(value) {
    return this;
};
$1d95f032bda6d6ff$var$Some.prototype.valueOrElse = function(value) {
    return this._value;
};
$1d95f032bda6d6ff$export$707cacfe2982dfac = function(value) {
    return value === $1d95f032bda6d6ff$export$f883a24d5edde77c || value instanceof $1d95f032bda6d6ff$var$Some;
};
$1d95f032bda6d6ff$export$b601f49376b4621a = function(value) {
    if (value == null) return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    return new $1d95f032bda6d6ff$var$Some(value);
};

});

parcelRegister("cB0qU", function(module, exports) {
module.exports = {
    failure: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $92b946be1245388d$var$Result({
            status: "failure",
            remaining: remaining,
            errors: errors
        });
    },
    error: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $92b946be1245388d$var$Result({
            status: "error",
            remaining: remaining,
            errors: errors
        });
    },
    success: function(value, remaining, source) {
        return new $92b946be1245388d$var$Result({
            status: "success",
            value: value,
            source: source,
            remaining: remaining,
            errors: []
        });
    },
    cut: function(remaining) {
        return new $92b946be1245388d$var$Result({
            status: "cut",
            remaining: remaining,
            errors: []
        });
    }
};
var $92b946be1245388d$var$Result = function(options) {
    this._value = options.value;
    this._status = options.status;
    this._hasValue = options.value !== undefined;
    this._remaining = options.remaining;
    this._source = options.source;
    this._errors = options.errors;
};
$92b946be1245388d$var$Result.prototype.map = function(func) {
    if (this._hasValue) return new $92b946be1245388d$var$Result({
        value: func(this._value, this._source),
        status: this._status,
        remaining: this._remaining,
        source: this._source,
        errors: this._errors
    });
    else return this;
};
$92b946be1245388d$var$Result.prototype.changeRemaining = function(remaining) {
    return new $92b946be1245388d$var$Result({
        value: this._value,
        status: this._status,
        remaining: remaining,
        source: this._source,
        errors: this._errors
    });
};
$92b946be1245388d$var$Result.prototype.isSuccess = function() {
    return this._status === "success" || this._status === "cut";
};
$92b946be1245388d$var$Result.prototype.isFailure = function() {
    return this._status === "failure";
};
$92b946be1245388d$var$Result.prototype.isError = function() {
    return this._status === "error";
};
$92b946be1245388d$var$Result.prototype.isCut = function() {
    return this._status === "cut";
};
$92b946be1245388d$var$Result.prototype.value = function() {
    return this._value;
};
$92b946be1245388d$var$Result.prototype.remaining = function() {
    return this._remaining;
};
$92b946be1245388d$var$Result.prototype.source = function() {
    return this._source;
};
$92b946be1245388d$var$Result.prototype.errors = function() {
    return this._errors;
};

});

parcelRegister("5wxOh", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $405a2adc4a0971cc$export$a3bc9b8ed74fc; }, function (v) { return $405a2adc4a0971cc$export$a3bc9b8ed74fc = v; });
var $405a2adc4a0971cc$export$a3bc9b8ed74fc;
$405a2adc4a0971cc$export$a3bc9b8ed74fc = function(options) {
    return new $405a2adc4a0971cc$var$Error(options);
};
var $405a2adc4a0971cc$var$Error = function(options) {
    this.expected = options.expected;
    this.actual = options.actual;
    this._location = options.location;
};
$405a2adc4a0971cc$var$Error.prototype.describe = function() {
    var locationDescription = this._location ? this._location.describe() + ":\n" : "";
    return locationDescription + "Expected " + this.expected + "\nbut got " + this.actual;
};
$405a2adc4a0971cc$var$Error.prototype.lineNumber = function() {
    return this._location.lineNumber();
};
$405a2adc4a0971cc$var$Error.prototype.characterNumber = function() {
    return this._location.characterNumber();
};

});

parcelRegister("e9ZHS", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $a4f1c59fb4692d8c$export$571d59b505e6bb4e; }, function (v) { return $a4f1c59fb4692d8c$export$571d59b505e6bb4e = v; });
var $a4f1c59fb4692d8c$export$571d59b505e6bb4e;
var $a4f1c59fb4692d8c$var$fromArray = $a4f1c59fb4692d8c$export$571d59b505e6bb4e = function(array) {
    var index = 0;
    var hasNext = function() {
        return index < array.length;
    };
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: hasNext,
        next: function() {
            if (!hasNext()) throw new Error("No more elements");
            else return array[index++];
        }
    });
};
var $a4f1c59fb4692d8c$var$LazyIterator = function(iterator) {
    this._iterator = iterator;
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.map = function(func) {
    var iterator = this._iterator;
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: function() {
            return iterator.hasNext();
        },
        next: function() {
            return func(iterator.next());
        }
    });
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.filter = function(condition) {
    var iterator = this._iterator;
    var moved = false;
    var hasNext = false;
    var next;
    var moveIfNecessary = function() {
        if (moved) return;
        moved = true;
        hasNext = false;
        while(iterator.hasNext() && !hasNext){
            next = iterator.next();
            hasNext = condition(next);
        }
    };
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: function() {
            moveIfNecessary();
            return hasNext;
        },
        next: function() {
            moveIfNecessary();
            var toReturn = next;
            moved = false;
            return toReturn;
        }
    });
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.first = function() {
    var iterator = this._iterator;
    if (this._iterator.hasNext()) return iterator.next();
    else return null;
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.toArray = function() {
    var result = [];
    while(this._iterator.hasNext())result.push(this._iterator.next());
    return result;
};

});


parcelRegister("8kl1m", function(module, exports) {
var $61007f4a0360e997$var$StringSource = module.exports = function(string, description) {
    var self = {
        asString: function() {
            return string;
        },
        range: function(startIndex, endIndex) {
            return new $61007f4a0360e997$var$StringSourceRange(string, description, startIndex, endIndex);
        }
    };
    return self;
};
var $61007f4a0360e997$var$StringSourceRange = function(string, description, startIndex, endIndex) {
    this._string = string;
    this._description = description;
    this._startIndex = startIndex;
    this._endIndex = endIndex;
};
$61007f4a0360e997$var$StringSourceRange.prototype.to = function(otherRange) {
    // TODO: Assert that tokens are the same across both iterators
    return new $61007f4a0360e997$var$StringSourceRange(this._string, this._description, this._startIndex, otherRange._endIndex);
};
$61007f4a0360e997$var$StringSourceRange.prototype.describe = function() {
    var position = this._position();
    var description = this._description ? this._description + "\n" : "";
    return description + "Line number: " + position.lineNumber + "\nCharacter number: " + position.characterNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype.lineNumber = function() {
    return this._position().lineNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype.characterNumber = function() {
    return this._position().characterNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype._position = function() {
    var self = this;
    var index = 0;
    var nextNewLine = function() {
        return self._string.indexOf("\n", index);
    };
    var lineNumber = 1;
    while(nextNewLine() !== -1 && nextNewLine() < this._startIndex){
        index = nextNewLine() + 1;
        lineNumber += 1;
    }
    var characterNumber = this._startIndex - index + 1;
    return {
        lineNumber: lineNumber,
        characterNumber: characterNumber
    };
};

});

parcelRegister("7f4pG", function(module, exports) {
module.exports = function(name, value, source) {
    this.name = name;
    this.value = value;
    if (source) this.source = source;
};

});

parcelRegister("fqgYr", function(module, exports) {

$parcel$export(module.exports, "parser", function () { return $b3a6735bfe1f7f08$export$8f49e4af10703ce3; }, function (v) { return $b3a6735bfe1f7f08$export$8f49e4af10703ce3 = v; });
$parcel$export(module.exports, "infix", function () { return $b3a6735bfe1f7f08$export$556631376a476def; }, function (v) { return $b3a6735bfe1f7f08$export$556631376a476def = v; });
var $b3a6735bfe1f7f08$export$8f49e4af10703ce3;
var $b3a6735bfe1f7f08$export$556631376a476def;

var $moeVv = parcelRequire("moeVv");

var $cB0qU = parcelRequire("cB0qU");
$b3a6735bfe1f7f08$export$8f49e4af10703ce3 = function(name, prefixRules, infixRuleBuilders) {
    var self = {
        rule: rule,
        leftAssociative: leftAssociative,
        rightAssociative: rightAssociative
    };
    var infixRules = new $b3a6735bfe1f7f08$var$InfixRules(infixRuleBuilders.map(createInfixRule));
    var prefixRule = $moeVv.firstOf(name, prefixRules);
    function createInfixRule(infixRuleBuilder) {
        return {
            name: infixRuleBuilder.name,
            rule: $b3a6735bfe1f7f08$var$lazyRule(infixRuleBuilder.ruleBuilder.bind(null, self))
        };
    }
    function rule() {
        return createRule(infixRules);
    }
    function leftAssociative(name) {
        return createRule(infixRules.untilExclusive(name));
    }
    function rightAssociative(name) {
        return createRule(infixRules.untilInclusive(name));
    }
    function createRule(infixRules) {
        return apply.bind(null, infixRules);
    }
    function apply(infixRules, tokens) {
        var leftResult = prefixRule(tokens);
        if (leftResult.isSuccess()) return infixRules.apply(leftResult);
        else return leftResult;
    }
    return self;
};
function $b3a6735bfe1f7f08$var$InfixRules(infixRules) {
    function untilExclusive(name) {
        return new $b3a6735bfe1f7f08$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name)));
    }
    function untilInclusive(name) {
        return new $b3a6735bfe1f7f08$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name) + 1));
    }
    function ruleNames() {
        return infixRules.map(function(rule) {
            return rule.name;
        });
    }
    function apply(leftResult) {
        var currentResult;
        var source;
        while(true){
            currentResult = applyToTokens(leftResult.remaining());
            if (currentResult.isSuccess()) {
                source = leftResult.source().to(currentResult.source());
                leftResult = $cB0qU.success(currentResult.value()(leftResult.value(), source), currentResult.remaining(), source);
            } else if (currentResult.isFailure()) return leftResult;
            else return currentResult;
        }
    }
    function applyToTokens(tokens) {
        return $moeVv.firstOf("infix", infixRules.map(function(infix) {
            return infix.rule;
        }))(tokens);
    }
    return {
        apply: apply,
        untilExclusive: untilExclusive,
        untilInclusive: untilInclusive
    };
}
$b3a6735bfe1f7f08$export$556631376a476def = function(name, ruleBuilder) {
    function map(func) {
        return $b3a6735bfe1f7f08$export$556631376a476def(name, function(parser) {
            var rule = ruleBuilder(parser);
            return function(tokens) {
                var result = rule(tokens);
                return result.map(function(right) {
                    return function(left, source) {
                        return func(left, right, source);
                    };
                });
            };
        });
    }
    return {
        name: name,
        ruleBuilder: ruleBuilder,
        map: map
    };
};
// TODO: move into a sensible place and remove duplication
var $b3a6735bfe1f7f08$var$lazyRule = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};

});

parcelRegister("FZqT4", function(module, exports) {

$parcel$export(module.exports, "RegexTokeniser", function () { return $07e37bb2a56f8d7d$export$74d15b5d79bf9ea; }, function (v) { return $07e37bb2a56f8d7d$export$74d15b5d79bf9ea = v; });
var $07e37bb2a56f8d7d$export$74d15b5d79bf9ea;

var $7f4pG = parcelRequire("7f4pG");

var $8kl1m = parcelRequire("8kl1m");
$07e37bb2a56f8d7d$export$74d15b5d79bf9ea = $07e37bb2a56f8d7d$var$RegexTokeniser;
function $07e37bb2a56f8d7d$var$RegexTokeniser(rules) {
    rules = rules.map(function(rule) {
        return {
            name: rule.name,
            regex: new RegExp(rule.regex.source, "g")
        };
    });
    function tokenise(input, description) {
        var source = new $8kl1m(input, description);
        var index = 0;
        var tokens = [];
        while(index < input.length){
            var result = readNextToken(input, index, source);
            index = result.endIndex;
            tokens.push(result.token);
        }
        tokens.push(endToken(input, source));
        return tokens;
    }
    function readNextToken(string, startIndex, source) {
        for(var i = 0; i < rules.length; i++){
            var regex = rules[i].regex;
            regex.lastIndex = startIndex;
            var result = regex.exec(string);
            if (result) {
                var endIndex = startIndex + result[0].length;
                if (result.index === startIndex && endIndex > startIndex) {
                    var value = result[1];
                    var token = new $7f4pG(rules[i].name, value, source.range(startIndex, endIndex));
                    return {
                        token: token,
                        endIndex: endIndex
                    };
                }
            }
        }
        var endIndex = startIndex + 1;
        var token = new $7f4pG("unrecognisedCharacter", string.substring(startIndex, endIndex), source.range(startIndex, endIndex));
        return {
            token: token,
            endIndex: endIndex
        };
    }
    function endToken(input, source) {
        return new $7f4pG("end", null, source.range(input.length, input.length));
    }
    return {
        tokenise: tokenise
    };
}

});

parcelRegister("1OnEJ", function(module, exports) {

$parcel$export(module.exports, "element", function () { return $151ccf859b683093$export$8454457683f90105; }, function (v) { return $151ccf859b683093$export$8454457683f90105 = v; });
var $151ccf859b683093$export$8454457683f90105;

var $hEvL6 = parcelRequire("hEvL6");

var $8eobO = parcelRequire("8eobO");
$151ccf859b683093$export$8454457683f90105 = $151ccf859b683093$var$element;
function $151ccf859b683093$var$element(name) {
    return function(html) {
        return $8eobO.elementWithTag($hEvL6.element(name), [
            html
        ]);
    };
}

});

var $8543c47da0beab14$exports = {};
$parcel$extendImportMap({
    "94LWX": "80400b51b55b12a65f902045f6b4a24ac47953e5/pdf.worker.min.8f8a5ecf.js",
    "hW73M": "cda.8f0fae79.xsl"
});

/* global CONFIGURATION, setupNewRelic */ var $6cb5f8bff4d365d9$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$6cb5f8bff4d365d9$exports = (parcelRequire("a5QWz"));




/**
 * This function creates an exception from a JavaScript Error
 */ function $baf0df795659509d$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $baf0df795659509d$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $baf0df795659509d$export$2e9ae379995d99e3(ex),
        value: $baf0df795659509d$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $baf0df795659509d$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6cb5f8bff4d365d9$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $baf0df795659509d$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $6cb5f8bff4d365d9$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $baf0df795659509d$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $6cb5f8bff4d365d9$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $baf0df795659509d$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $baf0df795659509d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $baf0df795659509d$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $baf0df795659509d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $baf0df795659509d$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $baf0df795659509d$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $baf0df795659509d$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $baf0df795659509d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $baf0df795659509d$var$getSkipFirstStackStringLines(ex) {
    if (ex && $baf0df795659509d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $baf0df795659509d$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $baf0df795659509d$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $baf0df795659509d$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $baf0df795659509d$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $baf0df795659509d$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($baf0df795659509d$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $6cb5f8bff4d365d9$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $6cb5f8bff4d365d9$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $baf0df795659509d$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $baf0df795659509d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6cb5f8bff4d365d9$exports.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $6cb5f8bff4d365d9$exports.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $baf0df795659509d$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $6cb5f8bff4d365d9$exports.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $baf0df795659509d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $6cb5f8bff4d365d9$exports.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $baf0df795659509d$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $6cb5f8bff4d365d9$exports.isDOMError)(exception) || (0, $6cb5f8bff4d365d9$exports.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $baf0df795659509d$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $6cb5f8bff4d365d9$exports.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $6cb5f8bff4d365d9$exports.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $6cb5f8bff4d365d9$exports.isError)(exception)) // we have a real Error object, do nothing
    return $baf0df795659509d$var$eventFromError(stackParser, exception);
    if ((0, $6cb5f8bff4d365d9$exports.isPlainObject)(exception) || (0, $6cb5f8bff4d365d9$exports.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $baf0df795659509d$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $6cb5f8bff4d365d9$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $baf0df795659509d$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6cb5f8bff4d365d9$exports.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $6cb5f8bff4d365d9$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $baf0df795659509d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $6cb5f8bff4d365d9$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $6cb5f8bff4d365d9$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $baf0df795659509d$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $6cb5f8bff4d365d9$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $6cb5f8bff4d365d9$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $6cb5f8bff4d365d9$exports.isEvent)(exception)) {
        const className = $baf0df795659509d$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $baf0df795659509d$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $baf0df795659509d$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



const $c8759183c6206ea8$export$56d8a8a25bd48b81 = (0, $6cb5f8bff4d365d9$exports.GLOBAL_OBJ);
let $c8759183c6206ea8$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $c8759183c6206ea8$export$b79738ab10c590b2() {
    return $c8759183c6206ea8$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $c8759183c6206ea8$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $c8759183c6206ea8$var$ignoreOnError++;
    setTimeout(()=>{
        $c8759183c6206ea8$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $c8759183c6206ea8$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $6cb5f8bff4d365d9$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$c8759183c6206ea8$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $c8759183c6206ea8$export$1265a142ff5ba165();
            (0, $6cb5f8bff4d365d9$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $6cb5f8bff4d365d9$exports.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $6cb5f8bff4d365d9$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $6cb5f8bff4d365d9$exports.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $6cb5f8bff4d365d9$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $6cb5f8bff4d365d9$exports.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $c8759183c6206ea8$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $6cb5f8bff4d365d9$exports.getLocationHref)();
    const { referrer: referrer } = $c8759183c6206ea8$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $c8759183c6206ea8$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $03c621aa5227985a$export$1df9218a526d318d extends (0, $6cb5f8bff4d365d9$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $03c621aa5227985a$export$4e107b20a7f977(options);
        const sdkSource = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $6cb5f8bff4d365d9$exports.getSDKSource)();
        (0, $6cb5f8bff4d365d9$exports.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $6cb5f8bff4d365d9$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $6cb5f8bff4d365d9$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $6cb5f8bff4d365d9$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $baf0df795659509d$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $baf0df795659509d$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $03c621aa5227985a$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6d193f2c2b007873$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $4726de1158d3534e$export$31499a9cd224b78c = "10.53.1";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $517c5b29f882562f$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b9fc213467403976$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $b9fc213467403976$export$c8bfa33e4e8ae492((0, $517c5b29f882562f$export$f1a6cdb1459e81d1));
    return 0, $517c5b29f882562f$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $b9fc213467403976$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $4726de1158d3534e$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $b9fc213467403976$export$7e223ec222791509(name, creator, obj = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}




const $6ed5aee3203eab87$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $6ed5aee3203eab87$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $6ed5aee3203eab87$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $6ed5aee3203eab87$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $517c5b29f882562f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6ed5aee3203eab87$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6ed5aee3203eab87$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6ed5aee3203eab87$var$enable() {
    $6ed5aee3203eab87$var$_getLoggerSettings().enabled = true;
}
function $6ed5aee3203eab87$var$disable() {
    $6ed5aee3203eab87$var$_getLoggerSettings().enabled = false;
}
function $6ed5aee3203eab87$var$isEnabled() {
    return $6ed5aee3203eab87$var$_getLoggerSettings().enabled;
}
function $6ed5aee3203eab87$var$log(...args) {
    $6ed5aee3203eab87$var$_maybeLog('log', ...args);
}
function $6ed5aee3203eab87$var$warn(...args) {
    $6ed5aee3203eab87$var$_maybeLog('warn', ...args);
}
function $6ed5aee3203eab87$var$error(...args) {
    $6ed5aee3203eab87$var$_maybeLog('error', ...args);
}
function $6ed5aee3203eab87$var$_maybeLog(level, ...args) {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return;
    if ($6ed5aee3203eab87$var$isEnabled()) $6ed5aee3203eab87$export$cda52e2a8927a2ca(()=>{
        (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console[level](`${$6ed5aee3203eab87$var$PREFIX}[${level}]:`, ...args);
    });
}
function $6ed5aee3203eab87$var$_getLoggerSettings() {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $b9fc213467403976$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $6ed5aee3203eab87$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $6ed5aee3203eab87$var$enable,
    disable: /** Disable logging. */ $6ed5aee3203eab87$var$disable,
    isEnabled: /** Check if logging is enabled. */ $6ed5aee3203eab87$var$isEnabled,
    log: /** Log a message. */ $6ed5aee3203eab87$var$log,
    warn: /** Log a warning. */ $6ed5aee3203eab87$var$warn,
    error: /** Log an error. */ $6ed5aee3203eab87$var$error
};


const $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT = 50;
const $d64dedd9c6b2e07c$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d64dedd9c6b2e07c$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes('Error: ')) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d64dedd9c6b2e07c$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d64dedd9c6b2e07c$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d64dedd9c6b2e07c$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d64dedd9c6b2e07c$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d64dedd9c6b2e07c$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d64dedd9c6b2e07c$export$27c7e15d453fc0ac
        }));
}
function $d64dedd9c6b2e07c$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d64dedd9c6b2e07c$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d64dedd9c6b2e07c$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d64dedd9c6b2e07c$var$defaultFunctionName;
        return fn.name || $d64dedd9c6b2e07c$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d64dedd9c6b2e07c$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $d64dedd9c6b2e07c$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $d64dedd9c6b2e07c$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $d64dedd9c6b2e07c$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


// We keep the handlers globally
const $192fdbc9fd342c1a$var$handlers = {};
const $192fdbc9fd342c1a$var$instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function $192fdbc9fd342c1a$export$a4e09611e30da72e(type, handler) {
    $192fdbc9fd342c1a$var$handlers[type] = $192fdbc9fd342c1a$var$handlers[type] || [];
    $192fdbc9fd342c1a$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $192fdbc9fd342c1a$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $192fdbc9fd342c1a$export$b17eab759a1cb5fe() {
    Object.keys($192fdbc9fd342c1a$var$handlers).forEach((key)=>{
        $192fdbc9fd342c1a$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $192fdbc9fd342c1a$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$192fdbc9fd342c1a$var$instrumented[type]) {
        $192fdbc9fd342c1a$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $192fdbc9fd342c1a$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $192fdbc9fd342c1a$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


// eslint-disable-next-line @typescript-eslint/unbound-method
const $d1f309ce92d0a600$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$e6127cc7fe7395c3(wat) {
    switch($d1f309ce92d0a600$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $d1f309ce92d0a600$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$var$isBuiltin(wat, className) {
    return $d1f309ce92d0a600$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$9f9636d330b71954(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$ef9e2056653f0c8e(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$12e869b2a583f783(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$844ec244b1367d54(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$c3825b437cbdea5c(wat) {
    return wat === null || $d1f309ce92d0a600$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$53b83ca8eaab0383(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$49841c62b9eff15(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $d1f309ce92d0a600$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$bc2894c7158efbac(wat) {
    return $d1f309ce92d0a600$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $d1f309ce92d0a600$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $d1f309ce92d0a600$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(request, Request);
}



const $c765cb3edc177c69$var$WINDOW = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
const $c765cb3edc177c69$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c765cb3edc177c69$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $c765cb3edc177c69$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $c765cb3edc177c69$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c765cb3edc177c69$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($c765cb3edc177c69$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $c765cb3edc177c69$export$1cfafeee2987818b() {
    try {
        return $c765cb3edc177c69$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $c765cb3edc177c69$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$c765cb3edc177c69$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}




/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $10696cb2974e7335$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $10696cb2974e7335$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $10696cb2974e7335$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $10696cb2974e7335$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== 'function') throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($10696cb2974e7335$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $10696cb2974e7335$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $10696cb2974e7335$export$62ff257738bf57f5(value) {
    if ((0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$10696cb2974e7335$var$getOwnProperties(value)
    };
    else if ((0, $d1f309ce92d0a600$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $10696cb2974e7335$var$serializeEventTarget(value.target),
            currentTarget: $10696cb2974e7335$var$serializeEventTarget(value.currentTarget),
            ...$10696cb2974e7335$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $d1f309ce92d0a600$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $10696cb2974e7335$var$serializeEventTarget(target) {
    try {
        return (0, $d1f309ce92d0a600$export$45a5e7f76e0caa8d)(target) ? (0, $c765cb3edc177c69$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $10696cb2974e7335$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $10696cb2974e7335$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($10696cb2974e7335$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $10696cb2974e7335$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $10696cb2974e7335$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $10696cb2974e7335$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($10696cb2974e7335$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($10696cb2974e7335$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $10696cb2974e7335$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $10696cb2974e7335$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $10696cb2974e7335$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



// undefined = not yet resolved, null = no runner found, function = runner found
let $11bebf6401bbfdb9$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $11bebf6401bbfdb9$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($11bebf6401bbfdb9$var$RESOLVED_RUNNER !== undefined) return $11bebf6401bbfdb9$var$RESOLVED_RUNNER ? $11bebf6401bbfdb9$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $11bebf6401bbfdb9$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $11bebf6401bbfdb9$var$RESOLVED_RUNNER(cb);
    }
    $11bebf6401bbfdb9$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $11bebf6401bbfdb9$export$9869d72de32a3917() {
    return $11bebf6401bbfdb9$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $11bebf6401bbfdb9$export$65b1bada40c91b34() {
    return $11bebf6401bbfdb9$export$ff239213cb80e2da(()=>Date.now());
}




/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $5b085f0f99265e84$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $5b085f0f99265e84$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $5b085f0f99265e84$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $d1f309ce92d0a600$export$7916fad0ebc23f48)(value)) output.push((0, $d64dedd9c6b2e07c$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $5b085f0f99265e84$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $d1f309ce92d0a600$export$844ec244b1367d54)(value)) return false;
    if ((0, $d1f309ce92d0a600$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $d1f309ce92d0a600$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === 'function') return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $5b085f0f99265e84$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($5b085f0f99265e84$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $76366c1ad7fe29b9$var$getCrypto() {
    const gbl = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $76366c1ad7fe29b9$var$emptyUuid;
function $76366c1ad7fe29b9$var$getRandomByte() {
    return (0, $11bebf6401bbfdb9$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $76366c1ad7fe29b9$export$19f53698e68b2496(crypto = $76366c1ad7fe29b9$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$76366c1ad7fe29b9$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $76366c1ad7fe29b9$var$emptyUuid = "10000000100040008000100000000000";
    return $76366c1ad7fe29b9$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($76366c1ad7fe29b9$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $76366c1ad7fe29b9$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $76366c1ad7fe29b9$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $76366c1ad7fe29b9$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $76366c1ad7fe29b9$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $76366c1ad7fe29b9$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $76366c1ad7fe29b9$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $76366c1ad7fe29b9$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $76366c1ad7fe29b9$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $76366c1ad7fe29b9$export$d364f2020ab30578(input) {
    const match = input.match($76366c1ad7fe29b9$var$SEMVER_REGEXP) || [];
    const major = $76366c1ad7fe29b9$var$_parseInt(match[1]);
    const minor = $76366c1ad7fe29b9$var$_parseInt(match[2]);
    const patch = $76366c1ad7fe29b9$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $76366c1ad7fe29b9$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $5b085f0f99265e84$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $5b085f0f99265e84$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $5b085f0f99265e84$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $76366c1ad7fe29b9$export$6de4ffac6a2f1098(exception) {
    if ($76366c1ad7fe29b9$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $76366c1ad7fe29b9$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $0a7a9faa9b397042$export$56d8a8a25bd48b81 = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);


const $06b149b84ddb8746$var$DEBOUNCE_DURATION = 1000;
let $06b149b84ddb8746$var$debounceTimerID;
let $06b149b84ddb8746$var$lastCapturedEventType;
let $06b149b84ddb8746$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $06b149b84ddb8746$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $06b149b84ddb8746$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $06b149b84ddb8746$export$3014bbf0af0e1d4a() {
    if (!(0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $192fdbc9fd342c1a$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $06b149b84ddb8746$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $06b149b84ddb8746$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $06b149b84ddb8746$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $06b149b84ddb8746$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $06b149b84ddb8746$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $06b149b84ddb8746$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $06b149b84ddb8746$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $06b149b84ddb8746$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($06b149b84ddb8746$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(target, '_sentryId', (0, $76366c1ad7fe29b9$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$06b149b84ddb8746$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $06b149b84ddb8746$var$lastCapturedEventType = event.type;
            $06b149b84ddb8746$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($06b149b84ddb8746$var$debounceTimerID);
        $06b149b84ddb8746$var$debounceTimerID = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).setTimeout(()=>{
            $06b149b84ddb8746$var$lastCapturedEventTargetId = undefined;
            $06b149b84ddb8746$var$lastCapturedEventType = undefined;
        }, $06b149b84ddb8746$var$DEBOUNCE_DURATION);
    };
}
function $06b149b84ddb8746$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




const $f00e028ff406ea6f$var$WINDOW = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$67fc34576016d6ec() {
    return 'history' in $f00e028ff406ea6f$var$WINDOW && !!$f00e028ff406ea6f$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $f00e028ff406ea6f$export$edf3cb81fd7d2a3e = $f00e028ff406ea6f$var$_isFetchSupported;
function $f00e028ff406ea6f$var$_isFetchSupported() {
    if (!('fetch' in $f00e028ff406ea6f$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f00e028ff406ea6f$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $f00e028ff406ea6f$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$f00e028ff406ea6f$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($f00e028ff406ea6f$export$d5f608b368e73f38($f00e028ff406ea6f$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $f00e028ff406ea6f$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $f00e028ff406ea6f$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$531055a6c684a70a() {
    return 'ReportingObserver' in $f00e028ff406ea6f$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $f00e028ff406ea6f$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$f00e028ff406ea6f$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}



let $b56cbd5d18686f38$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b56cbd5d18686f38$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $b56cbd5d18686f38$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $b56cbd5d18686f38$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $b56cbd5d18686f38$var$lastHref;
        $b56cbd5d18686f38$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $f00e028ff406ea6f$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $b56cbd5d18686f38$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $b56cbd5d18686f38$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $b56cbd5d18686f38$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $b56cbd5d18686f38$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $27fab3c4acc6cd95$export$7740643b9eeaf0c4() {
    return (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)() / $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $27fab3c4acc6cd95$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $27fab3c4acc6cd95$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>performance.now())) / $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS;
    };
}
let $27fab3c4acc6cd95$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $27fab3c4acc6cd95$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $27fab3c4acc6cd95$var$_cachedTimestampInSeconds ?? ($27fab3c4acc6cd95$var$_cachedTimestampInSeconds = $27fab3c4acc6cd95$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $27fab3c4acc6cd95$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $27fab3c4acc6cd95$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $27fab3c4acc6cd95$export$baf075a948ffc0bf() {
    if ($27fab3c4acc6cd95$var$cachedTimeOrigin === null) $27fab3c4acc6cd95$var$cachedTimeOrigin = $27fab3c4acc6cd95$var$getBrowserTimeOrigin();
    return $27fab3c4acc6cd95$var$cachedTimeOrigin;
}



const $0b882197debcbce5$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0b882197debcbce5$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $0b882197debcbce5$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0b882197debcbce5$export$c67d533bf77cbf54() {
    if (!(0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $d1f309ce92d0a600$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0b882197debcbce5$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(header) && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $0b882197debcbce5$var$parseXhrUrlArg(url) {
    if ((0, $d1f309ce92d0a600$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ac5edc7981a81b87$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $fef7c5073f0eda77$var$INTEGRATION_NAME = 'Breadcrumbs';
const $fef7c5073f0eda77$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $fef7c5073f0eda77$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $6cb5f8bff4d365d9$exports.addConsoleInstrumentationHandler)($fef7c5073f0eda77$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $06b149b84ddb8746$export$5aeffd3db2cf9df7)($fef7c5073f0eda77$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0b882197debcbce5$export$26ace48dd54c9aea)($fef7c5073f0eda77$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $6cb5f8bff4d365d9$exports.addFetchInstrumentationHandler)($fef7c5073f0eda77$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $b56cbd5d18686f38$export$3f18c56c58114e75)($fef7c5073f0eda77$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $fef7c5073f0eda77$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $fef7c5073f0eda77$export$c079d904b326663a = (0, $6cb5f8bff4d365d9$exports.defineIntegration)($fef7c5073f0eda77$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $fef7c5073f0eda77$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $6cb5f8bff4d365d9$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $fef7c5073f0eda77$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6cb5f8bff4d365d9$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $fef7c5073f0eda77$var$_isEvent(event) ? event.target : event;
            target = (0, $6cb5f8bff4d365d9$exports.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $6cb5f8bff4d365d9$exports.getComponentName)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $fef7c5073f0eda77$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $6cb5f8bff4d365d9$exports.severityLevelFromString)(handlerData.level),
            message: (0, $6cb5f8bff4d365d9$exports.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6cb5f8bff4d365d9$exports.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $fef7c5073f0eda77$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0b882197debcbce5$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $6cb5f8bff4d365d9$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $fef7c5073f0eda77$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: handlerData.fetchData,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $6cb5f8bff4d365d9$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $fef7c5073f0eda77$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $6cb5f8bff4d365d9$exports.parseUrl)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $6cb5f8bff4d365d9$exports.parseUrl)(from) : undefined;
        const parsedTo = (0, $6cb5f8bff4d365d9$exports.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $6cb5f8bff4d365d9$exports.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $fef7c5073f0eda77$var$_isEvent(event) {
    return !!event && !!event.target;
}




// Using a comma-separated string and split for smaller bundle size vs an array literal
const $08a052590b704c62$var$DEFAULT_EVENT_TARGET = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
const $08a052590b704c62$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $08a052590b704c62$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $08a052590b704c62$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $6cb5f8bff4d365d9$exports.fill)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'setTimeout', $08a052590b704c62$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $6cb5f8bff4d365d9$exports.fill)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'setInterval', $08a052590b704c62$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $6cb5f8bff4d365d9$exports.fill)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'requestAnimationFrame', $08a052590b704c62$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $c8759183c6206ea8$export$56d8a8a25bd48b81)) (0, $6cb5f8bff4d365d9$exports.fill)(XMLHttpRequest.prototype, 'send', $08a052590b704c62$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $08a052590b704c62$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$08a052590b704c62$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $08a052590b704c62$export$59bfe9f1c76150e = (0, $6cb5f8bff4d365d9$exports.defineIntegration)($08a052590b704c62$var$_browserApiErrorsIntegration);
function $08a052590b704c62$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $c8759183c6206ea8$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $6cb5f8bff4d365d9$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $08a052590b704c62$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $c8759183c6206ea8$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $6cb5f8bff4d365d9$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $08a052590b704c62$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $6cb5f8bff4d365d9$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $6cb5f8bff4d365d9$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $6cb5f8bff4d365d9$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6cb5f8bff4d365d9$exports.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $c8759183c6206ea8$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $08a052590b704c62$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $6cb5f8bff4d365d9$exports.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($08a052590b704c62$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $c8759183c6206ea8$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $6cb5f8bff4d365d9$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $08a052590b704c62$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $c8759183c6206ea8$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $6cb5f8bff4d365d9$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $6cb5f8bff4d365d9$exports.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $08a052590b704c62$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $08a052590b704c62$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $1a88b5716a17d60e$export$1baa7880e357371c = (0, $6cb5f8bff4d365d9$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? 'route';
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6cb5f8bff4d365d9$exports.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $6cb5f8bff4d365d9$exports.startSession)({
                ignoreDuration: true
            });
            (0, $6cb5f8bff4d365d9$exports.captureSession)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $6cb5f8bff4d365d9$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $6cb5f8bff4d365d9$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === 'route') // We want to create a session for every navigation as well
            (0, $b56cbd5d18686f38$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $6cb5f8bff4d365d9$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $6cb5f8bff4d365d9$exports.captureSession)();
                }
            });
        }
    };
});




const $add40bb2a655743a$var$INTEGRATION_NAME = 'CultureContext';
const $add40bb2a655743a$var$_cultureContextIntegration = ()=>{
    return {
        name: $add40bb2a655743a$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $add40bb2a655743a$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $add40bb2a655743a$var$getCultureContext();
            if (culture) (0, $6cb5f8bff4d365d9$exports.safeSetSpanJSONAttributes)(span, {
                'culture.locale': culture.locale,
                'culture.timezone': culture.timezone,
                'culture.calendar': culture.calendar
            });
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $add40bb2a655743a$export$ec5976aacdc85985 = (0, $6cb5f8bff4d365d9$exports.defineIntegration)($add40bb2a655743a$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $add40bb2a655743a$var$getCultureContext() {
    try {
        const intl = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}






const $fb4c596e227627d1$var$INTEGRATION_NAME = 'GlobalHandlers';
const $fb4c596e227627d1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $fb4c596e227627d1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $fb4c596e227627d1$var$_installGlobalOnErrorHandler(client);
                $fb4c596e227627d1$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $fb4c596e227627d1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $fb4c596e227627d1$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $fb4c596e227627d1$export$66acc70e8cf2b71a = (0, $6cb5f8bff4d365d9$exports.defineIntegration)($fb4c596e227627d1$var$_globalHandlersIntegration);
function $fb4c596e227627d1$var$_installGlobalOnErrorHandler(client) {
    (0, $6cb5f8bff4d365d9$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fb4c596e227627d1$var$getOptions();
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client || (0, $c8759183c6206ea8$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $fb4c596e227627d1$var$_enhanceEventWithInitialFrame((0, $baf0df795659509d$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $6cb5f8bff4d365d9$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $fb4c596e227627d1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $6cb5f8bff4d365d9$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fb4c596e227627d1$var$getOptions();
        if ((0, $6cb5f8bff4d365d9$exports.getClient)() !== client || (0, $c8759183c6206ea8$export$b79738ab10c590b2)()) return;
        const error = $fb4c596e227627d1$export$b2cc40fa8241780(e);
        const event = (0, $6cb5f8bff4d365d9$exports.isPrimitive)(error) ? $fb4c596e227627d1$export$1353b5b36844a9ed(error) : (0, $baf0df795659509d$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $6cb5f8bff4d365d9$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $fb4c596e227627d1$export$b2cc40fa8241780(error) {
    if ((0, $6cb5f8bff4d365d9$exports.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $fb4c596e227627d1$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $fb4c596e227627d1$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $fb4c596e227627d1$var$getFilenameFromUrl(url) ?? (0, $6cb5f8bff4d365d9$exports.getLocationHref)(),
        function: (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $fb4c596e227627d1$var$globalHandlerLog(type) {
    (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6cb5f8bff4d365d9$exports.debug).log(`Global Handler attached: ${type}`);
}
function $fb4c596e227627d1$var$getOptions() {
    const client = (0, $6cb5f8bff4d365d9$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $fb4c596e227627d1$var$getFilenameFromUrl(url) {
    if (!(0, $6cb5f8bff4d365d9$exports.isString)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $6cb5f8bff4d365d9$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $ec81f0d0cf410d60$export$1378794447170364 = (0, $6cb5f8bff4d365d9$exports.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).navigator && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).location && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $c8759183c6206ea8$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            // if none of the information we want exists, don't bother
            if (!(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).navigator && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).location && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $c8759183c6206ea8$export$a3c4a8453e8936f0)();
            (0, $6cb5f8bff4d365d9$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                'url.full': reqData.url || undefined,
                'http.request.header.user_agent': reqData.headers['User-Agent'],
                'http.request.header.referer': reqData.headers['Referer']
            });
        }
    };
});




const $f88781cccdf014d1$var$DEFAULT_KEY = 'cause';
const $f88781cccdf014d1$var$DEFAULT_LIMIT = 5;
const $f88781cccdf014d1$var$INTEGRATION_NAME = 'LinkedErrors';
const $f88781cccdf014d1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f88781cccdf014d1$var$DEFAULT_LIMIT;
    const key = options.key || $f88781cccdf014d1$var$DEFAULT_KEY;
    return {
        name: $f88781cccdf014d1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $6cb5f8bff4d365d9$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $baf0df795659509d$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $f88781cccdf014d1$export$ebabb00eb7f3a395 = (0, $6cb5f8bff4d365d9$exports.defineIntegration)($f88781cccdf014d1$var$_linkedErrorsIntegration);




const $77d49fe04195e473$var$OPERA10_PRIORITY = 10;
const $77d49fe04195e473$var$OPERA11_PRIORITY = 20;
const $77d49fe04195e473$var$CHROME_PRIORITY = 30;
const $77d49fe04195e473$var$WINJS_PRIORITY = 40;
const $77d49fe04195e473$var$GECKO_PRIORITY = 50;
function $77d49fe04195e473$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $77d49fe04195e473$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $77d49fe04195e473$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $77d49fe04195e473$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $77d49fe04195e473$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $77d49fe04195e473$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($77d49fe04195e473$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $77d49fe04195e473$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $77d49fe04195e473$var$createFrame(filename, (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $77d49fe04195e473$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $77d49fe04195e473$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $77d49fe04195e473$var$extractSafariExtensionDetails(parts[1] || (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION), parts[2]);
        return $77d49fe04195e473$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $77d49fe04195e473$export$263a749fff749872 = [
    $77d49fe04195e473$var$CHROME_PRIORITY,
    $77d49fe04195e473$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $77d49fe04195e473$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $77d49fe04195e473$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $77d49fe04195e473$var$gecko = (line)=>{
    const parts = $77d49fe04195e473$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $77d49fe04195e473$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION);
        [func, filename] = $77d49fe04195e473$var$extractSafariExtensionDetails(func, filename);
        return $77d49fe04195e473$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $77d49fe04195e473$export$cdba47a5dd2804d = [
    $77d49fe04195e473$var$GECKO_PRIORITY,
    $77d49fe04195e473$var$gecko
];
const $77d49fe04195e473$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $77d49fe04195e473$var$winjs = (line)=>{
    const parts = $77d49fe04195e473$var$winjsRegex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[2], parts[1] || (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $77d49fe04195e473$export$179460296da408e8 = [
    $77d49fe04195e473$var$WINJS_PRIORITY,
    $77d49fe04195e473$var$winjs
];
const $77d49fe04195e473$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $77d49fe04195e473$var$opera10 = (line)=>{
    const parts = $77d49fe04195e473$var$opera10Regex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[2], parts[3] || (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $77d49fe04195e473$export$f892b52c880ffc7a = [
    $77d49fe04195e473$var$OPERA10_PRIORITY,
    $77d49fe04195e473$var$opera10
];
const $77d49fe04195e473$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $77d49fe04195e473$var$opera11 = (line)=>{
    const parts = $77d49fe04195e473$var$opera11Regex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[5], parts[3] || parts[4] || (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $77d49fe04195e473$export$af11af13f09fb0dc = [
    $77d49fe04195e473$var$OPERA11_PRIORITY,
    $77d49fe04195e473$var$opera11
];
const $77d49fe04195e473$export$7197c0fe6554c079 = [
    $77d49fe04195e473$export$263a749fff749872,
    $77d49fe04195e473$export$cdba47a5dd2804d
];
const $77d49fe04195e473$export$2b2b997d81bf3907 = (0, $6cb5f8bff4d365d9$exports.createStackParser)(...$77d49fe04195e473$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $77d49fe04195e473$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $6cb5f8bff4d365d9$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $aab55252de974fce$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $1549552c21546300$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $1549552c21546300$export$e464f4a514ac28a8(name) {
    const cached = $1549552c21546300$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $f00e028ff406ea6f$export$d5f608b368e73f38)(impl)) return $1549552c21546300$var$cachedImplementations[name] = impl.bind((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81));
    const document = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $aab55252de974fce$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $1549552c21546300$var$cachedImplementations[name] = impl.bind((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $1549552c21546300$export$8aa36702e8c8978(name) {
    $1549552c21546300$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $1549552c21546300$export$e7aa7bc5c1b3cfb3(...rest) {
    return $1549552c21546300$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $1549552c21546300$export$831dc9f2ab0a617b(...rest) {
    return $1549552c21546300$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $18805ea082ebd8ff$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $18805ea082ebd8ff$export$b2311068c46d7cc8(options, nativeFetch = (0, $1549552c21546300$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $1549552c21546300$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $6cb5f8bff4d365d9$exports.createTransport)(options, makeRequest, (0, $6cb5f8bff4d365d9$exports.makePromiseBuffer)(options.bufferSize || $18805ea082ebd8ff$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $611f0577f01590dc$export$dc236a86065879fc() {
    if ($611f0577f01590dc$var$_isEmbeddedBrowserExtension()) {
        if (0, $ac5edc7981a81b87$export$16a28057038b10ef) (0, $6cb5f8bff4d365d9$exports.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $611f0577f01590dc$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $6cb5f8bff4d365d9$exports.getLocationHref)();
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81) === (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $776bdb0abf297828$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $6cb5f8bff4d365d9$exports.inboundFiltersIntegration)(),
        (0, $6cb5f8bff4d365d9$exports.functionToStringIntegration)(),
        (0, $6cb5f8bff4d365d9$exports.conversationIdIntegration)(),
        (0, $08a052590b704c62$export$59bfe9f1c76150e)(),
        (0, $fef7c5073f0eda77$export$c079d904b326663a)(),
        (0, $fb4c596e227627d1$export$66acc70e8cf2b71a)(),
        (0, $f88781cccdf014d1$export$ebabb00eb7f3a395)(),
        (0, $6cb5f8bff4d365d9$exports.dedupeIntegration)(),
        (0, $ec81f0d0cf410d60$export$1378794447170364)(),
        (0, $add40bb2a655743a$export$ec5976aacdc85985)(),
        (0, $1a88b5716a17d60e$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $776bdb0abf297828$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $611f0577f01590dc$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $776bdb0abf297828$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $6cb5f8bff4d365d9$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $77d49fe04195e473$export$2b2b997d81bf3907)),
        integrations: (0, $6cb5f8bff4d365d9$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $18805ea082ebd8ff$export$b2311068c46d7cc8)
    };
    return (0, $6cb5f8bff4d365d9$exports.initAndBind)((0, $03c621aa5227985a$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $776bdb0abf297828$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $776bdb0abf297828$export$4e4d8b287d028b6b(callback) {
    callback();
}


// Development: Parcel compiles Elm via @parcel/transformer-elm
var $b9e750d20bbc1f0f$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(r, t, e, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(r, t, e, u, a, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, u, a, i, c, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, c) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, c) : n(r)(t)(e)(u)(a)(i)(c);
    }
    function A8(n, r, t, e, u, a, i, c, o) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, c, o) : n(r)(t)(e)(u)(a)(i)(c)(o);
    }
    function A9(n, r, t, e, u, a, i, c, o, f) {
        return 9 === n.a ? n.f(r, t, e, u, a, i, c, o, f) : n(r)(t)(e)(u)(a)(i)(c)(o)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, b(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = c(n, r, 0, e); u && (t = e.pop()); u = c(t.a, t.b, 0, e));
        return u;
    }
    function c(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return e.push(b(n, r)), !0;
        for(var u in 0 > n.$ && (n = Ot(n), r = Ot(r)), n)if (!c(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var o = F2(i), f = F2(function(n, r) {
        return !i(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        return 1 > s(n, r);
    }), d = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? Wt : t ? Jt : Gt;
    });
    function b(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function v(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function m(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var p = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = g(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = g(n.a, r);
        return t;
    }
    var h = {
        $: 0
    };
    function g(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var w = F2(g);
    function x(n) {
        for(var r = h, t = n.length; t--;)r = g(n[t], r);
        return r;
    }
    function k(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var y = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return x(e);
    }), _ = F2(function(n, r) {
        return x(k(r).sort(function(r, t) {
            return s(n(r), n(t));
        }));
    }), A = F2(function(n, r) {
        return x(k(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === Gt ? 0 : e === Wt ? -1 : 1;
        }));
    }), C = F2(function(n, r) {
        return n + r;
    }), B = F2(function(n, r) {
        return n * r;
    }), E = F2(Math.pow), D = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), q = Math.ceil, F = Math.floor, P = Math.round, z = Math.log, j = isNaN, S = F2(function(n, r) {
        return n + r;
    }), L = F2(function(n, r) {
        return n + r;
    }), M = F2(function(n, r) {
        for(var t = r.length, e = Array(t), u = 0; t > u;){
            var a = r.charCodeAt(u);
            55296 > a || a > 56319 ? (e[u] = n(r[u]), u++) : (e[u] = n(r[u] + r[u + 1]), u += 2);
        }
        return e.join("");
    }), N = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), H = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), T = F2(function(n, r) {
        return r.split(n);
    }), I = F2(function(n, r) {
        return r.join(n);
    }), R = F3(function(n, r, t) {
        return t.slice(n, r);
    }), Z = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), V = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), U = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), Y = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), Q = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return h;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return x(u);
    });
    function O(n) {
        return n + "";
    }
    function G(n) {
        return {
            $: 2,
            b: n
        };
    }
    var J = G(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? te(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : te(n);
    }), W = G(function(n) {
        return "boolean" == typeof n ? te(n) : pn("a BOOL", n);
    }), K = G(function(n) {
        return "number" == typeof n ? te(n) : pn("a FLOAT", n);
    }), X = G(function(n) {
        return te(n);
    }), nn = G(function(n) {
        return "string" == typeof n ? te(n) : n instanceof String ? te(n + "") : pn("a STRING", n);
    }), rn = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), tn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function en(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var un = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), an = F2(function(n, r) {
        return en(n, [
            r
        ]);
    }), cn = F3(function(n, r, t) {
        return en(n, [
            r,
            t
        ]);
    }), on = F4(function(n, r, t, e) {
        return en(n, [
            r,
            t,
            e
        ]);
    }), fn = F6(function(n, r, t, e, u, a) {
        return en(n, [
            r,
            t,
            e,
            u,
            a
        ]);
    }), sn = F2(function(n, r) {
        try {
            return dn(n, JSON.parse(r));
        } catch (n) {
            return Kt(A2(Xt, "This is not valid JSON! " + n.message, r));
        }
    }), ln = F2(function(n, r) {
        return dn(n, r);
    });
    function dn(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? te(n.c) : pn("null", r);
            case 3:
                return vn(r) ? bn(n.b, r, x) : pn("a LIST", r);
            case 4:
                return vn(r) ? bn(n.b, r, mn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = dn(n.b, r[t]);
                return Xe(e) ? e : Kt(A2(ne, t, e.a));
            case 7:
                var u = n.e;
                return vn(r) ? r.length > u ? (e = dn(n.b, r[u]), Xe(e) ? e : Kt(A2(re, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || vn(r)) return pn("an OBJECT", r);
                var a = h;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = dn(n.b, r[i]), !Xe(e)) return Kt(A2(ne, i, e.a));
                    a = g(b(i, e.a), a);
                }
                return te(Ae(a));
            case 9:
                for(var c = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (e = dn(o[f], r), !Xe(e)) return e;
                    c = c(e.a);
                }
                return te(c);
            case 10:
                return e = dn(n.b, r), Xe(e) ? dn(n.h(e.a), r) : e;
            case 11:
                for(var s = h, l = n.g; l.b; l = l.b){
                    if (e = dn(l.a, r), Xe(e)) return e;
                    s = g(e.a, s);
                }
                return Kt(ee(Ae(s)));
            case 1:
                return Kt(A2(Xt, n.a, r));
            case 0:
                return te(n.a);
        }
    }
    function bn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = dn(n, r[a]);
            if (!Xe(i)) return Kt(A2(re, a, i.a));
            u[a] = i.a;
        }
        return te(t(u));
    }
    function vn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function mn(n) {
        return A2(Ke, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return Kt(A2(Xt, "Expecting " + n, r));
    }
    function $n(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return $n(n.b, r.b);
            case 6:
                return n.d === r.d && $n(n.b, r.b);
            case 7:
                return n.e === r.e && $n(n.b, r.b);
            case 9:
                return n.f === r.f && hn(n.g, r.g);
            case 10:
                return n.h === r.h && $n(n.b, r.b);
            case 11:
                return hn(n.g, r.g);
        }
    }
    function hn(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!$n(n[e], r[e])) return !1;
        return !0;
    }
    var gn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function wn(n) {
        return n;
    }
    var xn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function kn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function yn(n) {
        return {
            $: 1,
            a: n
        };
    }
    function _n(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var An = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Bn = 0;
    function En(n) {
        var r = {
            $: 0,
            e: Bn++,
            f: n,
            g: null,
            h: []
        };
        return jn(r), r;
    }
    function Dn(n) {
        return _n(function(r) {
            r(kn(En(n)));
        });
    }
    function qn(n, r) {
        n.h.push(r), jn(n);
    }
    var Fn = F2(function(n, r) {
        return _n(function(t) {
            qn(n, r), t(kn(0));
        });
    }), Pn = !1, zn = [];
    function jn(n) {
        if (zn.push(n), !Pn) {
            for(Pn = !0; n = zn.shift();)Sn(n);
            Pn = !1;
        }
    }
    function Sn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, jn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Ln(n) {
        return _n(function(r) {
            var t = setTimeout(function() {
                r(kn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Mn = {};
    function Nn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Hn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(An, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(u, t, c, n) : a && i ? A4(e, t, c.i, c.j, n) : A3(e, t, a ? c.i : c.j, n);
                }
            });
        }
        return t.h = En(A2(An, c, n.b));
    }
    var Tn = F2(function(n, r) {
        return _n(function(t) {
            n.g(r), t(kn(0));
        });
    }), In = F2(function(n, r) {
        return A2(Fn, n.h, {
            $: 0,
            a: r
        });
    });
    function Rn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Zn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Vn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), Un = [], Yn = !1;
    function Qn(n, r, t) {
        if (Un.push({
            p: n,
            q: r,
            r: t
        }), !Yn) {
            Yn = !0;
            for(var e; e = Un.shift();)On(e.p, e.q, e.r);
            Yn = !1;
        }
    }
    function On(n, r, t) {
        var e = {};
        for(var u in Gn(!0, r, e, null), Gn(!1, t, e, null), n)qn(n[u], {
            $: "fx",
            a: e[u] || {
                i: h,
                j: h
            }
        });
    }
    function Gn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Mn[r].e : Mn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: h,
                        j: h
                    }, n ? t.i = g(r, t.i) : t.j = g(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Gn(n, i.a, t, e);
                return;
            case 3:
                return void Gn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Jn(n) {
        Mn[n] && a(3);
    }
    function Wn(n, r) {
        return Jn(n), Mn[n] = {
            e: Kn,
            u: r,
            a: Xn
        }, Rn(n);
    }
    var Kn = F2(function(n, r) {
        return r;
    });
    function Xn(n) {
        var r = [], t = Mn[n].u, e = Ln(0);
        return Mn[n].b = e, Mn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = t(u.a), c = 0; a.length > c; c++)a[c](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function nr(n, r) {
        return Jn(n), Mn[n] = {
            f: rr,
            u: r,
            a: tr
        }, Rn(n);
    }
    var rr = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function tr(n, r) {
        var t = h, e = Mn[n].u, u = kn(null);
        return Mn[n].b = u, Mn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(ln, e, n);
                Xe(u) || a(4);
                for(var i = u.a, c = t; c.b; c = c.b)r(c.a(i));
            }
        };
    }
    var er = "undefined" != typeof document ? document : {};
    function ur(n, r) {
        n.appendChild(r);
    }
    function ar(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ir = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: _r(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), cr = ir(void 0), or = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: _r(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0), fr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), sr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), vr = /^script$/i, mr = /^(on|formAction$)/i, pr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i, $r = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function hr(n) {
        return vr.test(n) ? "p" : n;
    }
    function gr(n) {
        return $r.test(n) ? "" : n;
    }
    var wr, xr = F2(function(n, r) {
        return "a0" === r.$ ? A2(sr, r.n, function(n, r) {
            var t = au(r);
            return {
                $: r.$,
                a: t ? A3(eu, 3 > t ? kr : yr, uu(n), r.a) : A2(tu, n, r.a)
            };
        }(n, r.o)) : r;
    }), kr = F2(function(n, r) {
        return b(n(r.a), r.b);
    }), yr = F2(function(n, r) {
        return {
            sE: n(r.sE),
            wP: r.wP,
            uY: r.uY
        };
    });
    function _r(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Ar(i, u, a) : i[u] = a;
            } else "className" === u ? Ar(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Ar(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Cr(n, r) {
        var t = n.$;
        if (5 === t) return Cr(n.k || (n.k = n.m()), r);
        if (0 === t) return er.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Cr(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Br(i = n.h(n.g), r, n.d), i;
        var i = n.f ? er.createElementNS(n.f, n.c) : er.createElement(n.c);
        Br(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)ur(i, Cr(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function Br(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Er(n, u) : "a0" === e ? Fr(n, r, u) : "a3" === e ? Dr(n, u) : "a4" === e ? qr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Er(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Dr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function qr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Fr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Pr(r, a), n.addEventListener(u, i, wr && {
                    passive: 2 > au(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                wr = !0;
            }
        }));
    } catch (n) {}
    function Pr(n, r) {
        function t(r) {
            var e = t.q, u = dn(e.a, r);
            if (Xe(u)) {
                for(var a, i = au(e), c = u.a, o = i ? 3 > i ? c.a : c.sE : c, f = 1 == i ? c.b : 3 == i && c.wP, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.uY) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var l = a.length; l--;)o = a[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function zr(n, r) {
        return n.$ == r.$ && $n(n.a, r.a);
    }
    function jr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Sr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void jr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Sr(n.k, r.k, s, 0), void (s.length > 0 && jr(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, b = !1, v = n.k; 4 === v.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var m = r.k; 4 === m.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        m.j
                    ] : d.push(m.j), m = m.k;
                    return b && l.length !== d.length ? void jr(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || jr(t, 2, e, d), void Sr(v, m, t, e + 1));
                case 0:
                    return void (n.a !== r.a && jr(t, 3, e, r.a));
                case 1:
                    return void Lr(n, r, t, e, Nr);
                case 2:
                    return void Lr(n, r, t, e, Hr);
                case 3:
                    if (n.h !== r.h) return void jr(t, 0, e, r);
                    var p = Mr(n.d, r.d);
                    p && jr(t, 4, e, p);
                    var $ = r.i(n.g, r.g);
                    return void ($ && jr(t, 5, e, $));
            }
        }
    }
    function Lr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Mr(n.d, r.d);
            a && jr(t, 4, e, a), u(n, r, t, e);
        } else jr(t, 0, e, r);
    }
    function Mr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && zr(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = Mr(n[u], r[u] || {}, u);
            c && ((e = e || {})[u] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Nr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, c = a.length;
        i > c ? jr(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && jr(t, 7, e, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            Sr(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Hr(n, r, t, e) {
        for(var u = [], a = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, l = 0, d = 0, b = e; f > l && s > d;){
            var v = (C = c[l]).a, m = (B = o[d]).a, p = C.b, $ = B.b, h = void 0, g = void 0;
            if (v !== m) {
                var w = c[l + 1], x = o[d + 1];
                if (w) {
                    var k = w.a, y = w.b;
                    g = m === k;
                }
                if (x) {
                    var _ = x.a, A = x.b;
                    h = v === _;
                }
                if (h && g) Sr(p, A, u, ++b), Ir(a, u, v, $, d, i), b += p.b || 0, Rr(a, u, v, y, ++b), b += y.b || 0, l += 2, d += 2;
                else if (h) b++, Ir(a, u, m, $, d, i), Sr(p, A, u, b), b += p.b || 0, l += 1, d += 2;
                else if (g) Rr(a, u, v, p, ++b), b += p.b || 0, Sr(y, $, u, ++b), b += y.b || 0, l += 2, d += 1;
                else {
                    if (!w || k !== _) break;
                    Rr(a, u, v, p, ++b), Ir(a, u, m, $, d, i), b += p.b || 0, Sr(y, A, u, ++b), b += y.b || 0, l += 2, d += 2;
                }
            } else Sr(p, $, u, ++b), b += p.b || 0, l++, d++;
        }
        for(; f > l;){
            var C;
            b++, Rr(a, u, (C = c[l]).a, p = C.b, b), b += p.b || 0, l++;
        }
        for(; s > d;){
            var B, E = E || [];
            Ir(a, u, (B = o[d]).a, B.b, void 0, E), d++;
        }
        (u.length > 0 || i.length > 0 || E) && jr(t, 8, e, {
            w: u,
            x: i,
            y: E
        });
    }
    var Tr = "_elmW6BL";
    function Ir(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return Sr(i.z, e, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Ir(n, r, t + Tr, e, u, a);
    }
    function Rr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Sr(e, a.z, i, u), void jr(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Rr(n, r, t + Tr, e, u);
        } else {
            var c = jr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: c
            };
        }
    }
    function Zr(n, r, t, e) {
        Vr(n, r, t, 0, 0, r.b, e);
    }
    function Vr(n, r, t, e, u, a, i) {
        for(var c = t[e], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) Zr(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Vr(n, r, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Vr(n, r, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Vr(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, m = n.childNodes, p = 0; v.length > p; p++){
            u++;
            var $ = 1 === d ? v[p] : v[p].b, h = u + ($.b || 0);
            if (!(u > o || o > h || (c = t[e = Vr(m[p], $, t, e, u, h, i)]) && (o = c.r) <= a)) return e;
            u = h;
        }
        return e;
    }
    function Ur(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Yr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Yr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Cr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Br(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Ur(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Cr(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = Ur(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = er.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                ur(t, 2 === u.c ? u.s : Cr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Ur(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : Cr(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && ur(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Qr(n) {
        if (3 === n.nodeType) return ar(n.textContent);
        if (1 !== n.nodeType) return ar("");
        for(var r = h, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = g(A2(br, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = h, c = n.childNodes;
        for(e = c.length; e--;)i = g(Qr(c[e]), i);
        return A3(cr, a, r, i);
    }
    var Or = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var c = A2(ln, n, r ? r.flags : void 0);
            Xe(c) || a(2);
            var o = {}, f = t(c.a), s = f.a, l = i(b, s), d = function(n, r) {
                var t;
                for(var e in Mn){
                    var u = Mn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Hn(u, r);
                }
                return t;
            }(o, b);
            function b(n, r) {
                var t = A2(e, n, s);
                l(s = t.a, r), Qn(o, t.b, u(s));
            }
            return Qn(o, f.b, u(s)), d ? {
                ports: d
            } : {};
        }(r, e, n.Ar, n.En, n.DZ, function(r, t) {
            var u = n.Et, a = e.node, i = Qr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Gr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Gr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Sr(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Zr(n, r, t, e), Ur(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Gr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Jr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Wr = "undefined" != typeof document ? document : Jr, Kr = "undefined" != typeof window ? window : Jr, Xr = F3(function(n, r, t) {
        return Dn(_n(function() {
            function e(n) {
                En(t(n));
            }
            return n.addEventListener(r, e, wr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), nt = F2(function(n, r) {
        var t = dn(n, r);
        return Xe(t) ? Vt(t.a) : Ut;
    });
    function rt(n, r) {
        return _n(function(t) {
            Gr(function() {
                var e = document.getElementById(n);
                t(e ? kn(r(e)) : yn(cu(n)));
            });
        });
    }
    function tt(n) {
        return _n(function(r) {
            Gr(function() {
                r(kn(n()));
            });
        });
    }
    var et = F2(function(n, r) {
        return rt(r, function(r) {
            return r[n](), 0;
        });
    });
    function ut() {
        var n = Wr.body, r = Wr.documentElement;
        return {
            ce: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
            q6: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
        };
    }
    var at = F2(function(n, r) {
        return tt(function() {
            return Kr.scroll(n, r), 0;
        });
    }), it = F3(function(n, r, t) {
        return rt(n, function(n) {
            return n.scrollLeft = r, n.scrollTop = t, 0;
        });
    }), ct = F2(function(n, r) {
        return _n(function() {
            var t = setInterval(function() {
                En(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ot = F2(function(n, r) {
        var t = "g";
        n.Bg && (t += "m"), n.yL && (t += "i");
        try {
            return Vt(RegExp(r, t));
        } catch (n) {
            return Ut;
        }
    }), ft = F2(function(n, r) {
        return null !== r.match(n);
    }), st = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, c = r.lastIndex, o = -1; a++ < n && (e = r.exec(i)) && o != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var l = e[f];
                s[--f] = l ? Vt(l) : Ut;
            }
            u.push(A4(Gb, e[0], e.index, a, x(s))), o = r.lastIndex;
        }
        return r.lastIndex = c, x(u);
    }), lt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? Vt(i) : Ut;
            }
            return t(A4(Gb, r, arguments[arguments.length - 2], u, x(a)));
        });
    }), dt = 1 / 0, bt = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, c = 0; i && a > c;){
            var o = u.charCodeAt(r);
            i = n[c++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[c++] === u[r++] : 1));
        }
        return v(i ? r : -1, t, e);
    }), vt = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), mt = F3(function(n, r, t) {
        return t.charCodeAt(r) === n;
    }), pt = F2(function(n, r) {
        for(; r.length > n; n++){
            var t = r.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), $t = F3(function(n, r, t) {
        for(var e = 0; t.length > r; r++){
            var u = t.charCodeAt(r) - 48;
            if (0 > u || u >= n) break;
            e = n * e + u;
        }
        return b(r, e);
    }), ht = F2(function(n, r) {
        for(var t = 0; r.length > n; n++){
            var e = r.charCodeAt(n);
            if (48 > e || e > 57) {
                if (65 > e || e > 70) {
                    if (97 > e || e > 102) break;
                    t = 16 * t + e - 87;
                } else t = 16 * t + e - 55;
            } else t = 16 * t + e - 48;
        }
        return b(n, t);
    }), gt = F5(function(n, r, t, e, u) {
        for(var a = u.indexOf(n, r), i = 0 > a ? u.length : a + n.length; i > r;){
            var c = u.charCodeAt(r++);
            10 === c ? (e = 1, t++) : (e++, 55296 == (63488 & c) && r++);
        }
        return v(a, t, e);
    });
    function wt(n) {
        return n.byteLength;
    }
    var xt = F3(function(n, r, t) {
        return n.setInt8(r, t), r + 1;
    }), kt = F4(function(n, r, t, e) {
        return n.setInt16(r, t, e), r + 2;
    }), yt = F4(function(n, r, t, e) {
        return n.setInt32(r, t, e), r + 4;
    }), _t = F3(function(n, r, t) {
        return n.setUint8(r, t), r + 1;
    }), At = F4(function(n, r, t, e) {
        return n.setUint16(r, t, e), r + 2;
    }), Ct = F4(function(n, r, t, e) {
        return n.setUint32(r, t, e), r + 4;
    }), Bt = F4(function(n, r, t, e) {
        return n.setFloat32(r, t, e), r + 4;
    }), Et = F4(function(n, r, t, e) {
        return n.setFloat64(r, t, e), r + 8;
    }), Dt = F3(function(n, r, t) {
        for(var e = 0, u = t.byteLength, a = u - 4; a >= e; e += 4)n.setUint32(r + e, t.getUint32(e));
        for(; u > e; e++)n.setUint8(r + e, t.getUint8(e));
        return r + u;
    }), qt = F3(function(n, r, t) {
        for(var e = 0; t.length > e; e++){
            var u = t.charCodeAt(e);
            r += 128 > u ? (n.setUint8(r, u), 1) : 2048 > u ? (n.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++e) - 56320 + 65536, n.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), Ft = F2(function(n, r) {
        try {
            return Vt(A2(n, r, 0).b);
        } catch (n) {
            return Ut;
        }
    }), Pt = F2(function(n, r) {
        return b(r + 1, n.getUint8(r));
    }), zt = F3(function(n, r, t) {
        return b(t + 2, r.getUint16(t, n));
    }), jt = F3(function(n, r, t) {
        return b(t + 4, r.getUint32(t, n));
    }), St = F3(function(n, r, t) {
        for(var e = "", u = t + n; u > t;){
            var a = r.getUint8(t++);
            e += 128 > a ? String.fromCharCode(a) : 192 == (224 & a) ? String.fromCharCode((31 & a) << 6 | 63 & r.getUint8(t++)) : 224 == (240 & a) ? String.fromCharCode((15 & a) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) : (a = ((7 & a) << 18 | (63 & r.getUint8(t++)) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) - 65536, String.fromCharCode(Math.floor(a / 1024) + 55296, a % 1024 + 56320));
        }
        return b(t, e);
    }), Lt = F3(function(n, r, t) {
        return _n(function(e) {
            function u(n) {
                e(r(t.zQ.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(Sy);
            }), a.addEventListener("timeout", function() {
                u(Ny);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? jy : Py, function(n) {
                        return {
                            xs: n.responseURL,
                            DT: n.status,
                            DU: n.statusText,
                            hC: Mt(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.zQ.b, a));
            }), Hy(t.Eh) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || En(A2(Ty, n, b(t, My({
                        Dm: e.loaded,
                        DG: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || En(A2(Ty, n, b(t, Ly({
                        CT: e.loaded,
                        DG: e.lengthComputable ? Vt(e.total) : Ut
                    }))));
                });
            }(n, a, t.Eh.a);
            try {
                a.open(t.Be, t.xs, !0);
            } catch (n) {
                return u(zy(t.xs));
            }
            return function(n, r) {
                for(var t = r.hC; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.D8.a || 0, n.responseType = r.zQ.d, n.withCredentials = r.yf;
            }(a, t), t.gN.a && a.setRequestHeader("Content-Type", t.gN.a), a.send(t.gN.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function Mt(n) {
        if (!n) return da;
        for(var r = da, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                r = A3(sa, i, function(n) {
                    return Vt(Hy(n) ? c + ", " + n.a : c);
                }, r);
            }
        }
        return r;
    }
    var Nt = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Ht = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    });
    function Tt(n) {
        return new DataView(n);
    }
    var It, Rt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    G(function(n) {
        return "undefined" != typeof File && n instanceof File ? te(n) : pn("a FILE", n);
    });
    var Zt = F3(function(n, r, t) {
        return _n(function() {
            var e = new Blob([
                t
            ], {
                type: r
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, n);
            else {
                var u = It || (It = document.createElement("a")), a = URL.createObjectURL(e);
                u.href = a, u.download = n, function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var r = document.createEvent("MouseEvents");
                        r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
                    }
                }(u), URL.revokeObjectURL(a);
            }
        });
    });
    var Vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ut = {
        $: 1
    }, Yt = w, Qt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Qt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Ot = function(n) {
        return A3(Qt, F3(function(n, r, t) {
            return A2(Yt, b(n, r), t);
        }), h, n);
    }, Gt = 1, Jt = 2, Wt = 0, Kt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ne = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), re = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), te = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ee = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ue = C, ae = Z, ie = p, ce = gn, oe = O, fe = F2(function(n, r) {
        return A2(I, n, k(r));
    }), se = F2(function(n, r) {
        return x(A2(T, n, r));
    }), le = function(n) {
        return A2(fe, "\n    ", A2(se, "\n", n));
    }, de = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), be = function(n) {
        return A3(de, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, ve = y, me = l, pe = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(Yt, r, t);
            n = e, r = u, t = a;
        }
    }), $e = F2(function(n, r) {
        return A3(pe, n, r, h);
    }), he = F2(function(n, r) {
        return A3(ve, n, A2($e, 0, be(r) - 1), r);
    }), ge = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, we = function(n) {
        var r = ge(n);
        return r >= 97 && 122 >= r;
    }, xe = function(n) {
        var r = ge(n);
        return 90 >= r && r >= 65;
    }, ke = function(n) {
        return we(n) || xe(n);
    }, ye = function(n) {
        var r = ge(n);
        return 57 >= r && r >= 48;
    }, _e = function(n) {
        return we(n) || xe(n) || ye(n);
    }, Ae = function(n) {
        return A3(de, Yt, h, n);
    }, Ce = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? Ut : Vt(55296 > r || r > 56319 ? b(n[0], n.slice(1)) : b(n[0] + n[1], n.slice(2)));
    }, Be = F2(function(n, r) {
        return "\n\n(" + oe(n + 1) + ") " + le(Ee(r));
    }), Ee = function(n) {
        return A2(De, n, h);
    }, De = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n = Ce(t);
                    if (1 === n.$) return !1;
                    var r = n.a, e = r.b;
                    return ke(r.a) && A2(ae, _e, e);
                }();
                n = e, r = A2(Yt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + oe(n.a) + "]";
                n = e, r = A2(Yt, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = (r.b ? "The Json.Decode.oneOf at json" + A2(fe, "", Ae(r)) : "Json.Decode.oneOf") + " failed in the following " + oe(be(i)) + " ways:";
                        return A2(fe, "\n\n", A2(Yt, c, A2(he, Be, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(fe, "", Ae(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (c = r.b ? "Problem with the value at json" + A2(fe, "", Ae(r)) + ":\n\n    " : "Problem with the given value:\n\n") + le(A2(ce, 4, f)) + "\n\n" + o;
        }
    }), qe = 32, Fe = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Pe = [], ze = q, je = F2(function(n, r) {
        return z(r) / z(n);
    }), Se = ze(A2(je, 2, qe)), Le = A4(Fe, 0, Se, Pe, Pe), Me = t, Ne = function(n) {
        return {
            $: 1,
            a: n
        };
    }, He = F2(function(n, r) {
        return n(r);
    }), Te = F2(function(n, r) {
        return r(n);
    }), Ie = o, Re = F, Ze = function(n) {
        return n.length;
    }, Ve = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), Ue = B, Ye = e, Qe = F2(function(n, r) {
        for(;;){
            var t = A2(Ye, qe, n), e = t.b, u = A2(Yt, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Ae(u);
            n = e, r = u;
        }
    }), Oe = function(n) {
        return n.a;
    }, Ge = F2(function(n, r) {
        for(;;){
            var t = ze(r / qe);
            if (1 === t) return A2(Ye, qe, n).a;
            n = A2(Qe, n, h), r = t;
        }
    }), Je = F2(function(n, r) {
        if (r.D) {
            var t = r.D * qe, e = Re(A2(je, qe, t - 1)), u = n ? Ae(r.L) : r.L, a = A2(Ge, u, r.D);
            return A4(Fe, Ze(r.H) + t, A2(Ve, 5, e * Se), a, r.H);
        }
        return A4(Fe, Ze(r.H), Se, Pe, r.H);
    }), We = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Je, !1, {
                L: e,
                D: t / qe | 0,
                H: u
            });
            var a = Ne(A3(Me, qe, r, n));
            r -= qe, e = A2(Yt, a, e);
        }
    }), Ke = F2(function(n, r) {
        if (n > 0) {
            var t = n % qe;
            return A5(We, r, n - t - qe, n, h, A3(Me, t, n - t, r));
        }
        return Le;
    }), Xe = function(n) {
        return !n.$;
    }, nu = un, ru = F3(function(n, r, t) {
        return r(n(t));
    }), tu = an, eu = cn, uu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, au = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, iu = function(n) {
        return n;
    }, cu = iu, ou = F6(function(n, r, t, e, u, a) {
        return {
            z6: a,
            Ai: r,
            Cq: e,
            uI: t,
            u6: n,
            iF: u
        };
    }), fu = V, su = function(n) {
        return n.length;
    }, lu = R, du = F2(function(n, r) {
        return 1 > n ? r : A3(lu, n, su(r), r);
    }), bu = Q, vu = function(n) {
        return "" === n;
    }, mu = F2(function(n, r) {
        return 1 > n ? "" : A3(lu, 0, n, r);
    }), pu = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Ut;
            r = 10 * r + a - 48;
        }
        return u == e ? Ut : Vt(45 == t ? -r : r);
    }, $u = F5(function(n, r, t, e, u) {
        if (vu(u) || A2(fu, "@", u)) return Ut;
        var a = A2(bu, ":", u);
        if (a.b) {
            if (a.b.b) return Ut;
            var i = a.a, c = pu(A2(du, i + 1, u));
            if (1 === c.$) return Ut;
            var o = c;
            return Vt(A6(ou, n, A2(mu, i, u), o, r, t, e));
        }
        return Vt(A6(ou, n, u, Ut, r, t, e));
    }), hu = F4(function(n, r, t, e) {
        if (vu(e)) return Ut;
        var u = A2(bu, "/", e);
        if (u.b) {
            var a = u.a;
            return A5($u, n, A2(du, a, e), r, t, A2(mu, a, e));
        }
        return A5($u, n, "/", r, t, e);
    }), gu = F3(function(n, r, t) {
        if (vu(t)) return Ut;
        var e = A2(bu, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(hu, n, Vt(A2(du, u + 1, t)), r, A2(mu, u, t));
        }
        return A4(hu, n, Ut, r, t);
    }), wu = F2(function(n, r) {
        if (vu(r)) return Ut;
        var t = A2(bu, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(gu, n, Vt(A2(du, e + 1, r)), A2(mu, e, r));
        }
        return A3(gu, n, Ut, r);
    }), xu = U, ku = function(n) {
        return A2(xu, "http://", n) ? A2(wu, 0, A2(du, 7, n)) : A2(xu, "https://", n) ? A2(wu, 1, A2(du, 8, n)) : Ut;
    }, yu = function() {
        for(;;);
    }, _u = kn, Au = _u(0), Cu = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(de, n, r, Ae(s)) : A4(Cu, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Bu = F3(function(n, r, t) {
        return A4(Cu, n, r, 0, t);
    }), Eu = F2(function(n, r) {
        return A3(Bu, F2(function(r, t) {
            return A2(Yt, n(r), t);
        }), h, r);
    }), Du = An, qu = F2(function(n, r) {
        return A2(Du, function(r) {
            return _u(n(r));
        }, r);
    }), Fu = F3(function(n, r, t) {
        return A2(Du, function(r) {
            return A2(Du, function(t) {
                return _u(A2(n, r, t));
            }, t);
        }, r);
    }), Pu = function(n) {
        return A3(Bu, Fu(Yt), _u(h), n);
    }, zu = Tn, ju = F2(function(n, r) {
        var t = r;
        return Dn(A2(Du, zu(n), t));
    });
    Mn.Task = Nn(Au, F3(function(n, r) {
        return A2(qu, function() {
            return 0;
        }, Pu(A2(Eu, ju(n), r)));
    }), F3(function() {
        return _u(0);
    }), F2(function(n, r) {
        return A2(qu, n, r);
    }));
    var Su, Lu, Mu = Rn("Task"), Nu = F2(function(n, r) {
        return Mu(A2(qu, n, r));
    }), Hu = Or, Tu = rn, Iu = F3(function(n, r, t) {
        return {
            eV: t,
            a6: r,
            Dr: n
        };
    }), Ru = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vu = Zn, Uu = {
        $: 2
    }, Yu = F5(function(n, r, t, e, u) {
        return {
            cy: e,
            Ck: t,
            cd: r,
            xz: u,
            cZ: n
        };
    }), Qu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Yt, n.a, Qu(n.b)) : h;
    }, Ou = F2(function(n, r) {
        return Vt(1 === r.$ ? x([
            n
        ]) : A2(Yt, n, r.a));
    }), Gu = function(n) {
        try {
            return Vt(decodeURIComponent(n));
        } catch (n) {
            return Ut;
        }
    }, Ju = d, Wu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Ut;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Ju, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Vt(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Ku = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Xu = {
        $: -2
    }, na = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Ku, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Ku, 0, e.b, e.c, A5(Ku, 1, a.b, a.c, a.d, a.e), A5(Ku, 1, r, t, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Ku, n, c, o, A5(Ku, 0, r, t, e, f), s) : A5(Ku, 0, r, t, A5(Ku, 1, e.b, e.c, e.d, i = e.e), A5(Ku, 1, c, o, f, s));
    }), ra = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Ku, 0, n, r, Xu, Xu);
        var e = t.a, u = t.b, a = t.c, i = t.d, c = t.e;
        switch(A2(Ju, n, u)){
            case 0:
                return A5(na, e, u, a, A3(ra, n, r, i), c);
            case 1:
                return A5(Ku, e, u, r, i, c);
            default:
                return A5(na, e, u, a, i, A3(ra, n, r, c));
        }
    }), ta = F3(function(n, r, t) {
        var e = A3(ra, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Ku, 1, e.b, e.c, e.d, e.e);
    }), ea = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, c = t.c, e = t.d, s = t.e, A5(Ku, 1, n.b, n.c, A5(Ku, 0, r.b, r.c, r.d, r.e), A5(Ku, 0, i, c, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, c = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(Ku, 0, e.b, e.c, A5(Ku, 1, n.b, n.c, A5(Ku, 0, u.b, u.c, u.d, u.e), o), A5(Ku, 1, i, c, f, s));
        }
        return n;
    }, ua = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, d = t.e, A5(Ku, 1, e = n.b, u = n.c, A5(Ku, 0, r.b, r.c, r.d, c = r.e), A5(Ku, 0, f, s, l, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, l = o.d, d = o.e;
            return A5(Ku, 0, a.b, a.c, A5(Ku, 1, i.b, i.c, i.d, i.e), A5(Ku, 1, e, u, c, A5(Ku, 0, f, s, l, d)));
        }
        return n;
    }, aa = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return ua(r);
                        break n;
                    }
                    return ua(r);
                }
                break n;
            }
            return r;
        }
        return A5(Ku, t, a.b, a.c, a.d, A5(Ku, 0, e, u, a.e, i));
    }), ia = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = ea(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(na, c.a, c.b, c.c, ia(c.d), o);
                    }
                    return Xu;
                }
                return A5(Ku, r, t, e, ia(u), i);
            }
            return A5(Ku, r, t, e, ia(u), i);
        }
        return Xu;
    }, ca = F2(function(n, r) {
        if (-2 === r.$) return Xu;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > s(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var o = ea(r);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(na, o.a, o.b, o.c, A2(ca, n, o.d), f);
                    }
                    return Xu;
                }
                return A5(Ku, t, e, u, A2(ca, n, a), i);
            }
            return A5(Ku, t, e, u, A2(ca, n, a), i);
        }
        return A2(oa, n, A7(aa, n, r, t, e, u, a, i));
    }), oa = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, c = r.e;
            if (i(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(na, t, o.b, o.c, a, ia(c)) : Xu;
            }
            return A5(na, t, e, u, a, A2(ca, n, c));
        }
        return Xu;
    }), fa = F2(function(n, r) {
        var t = A2(ca, n, r);
        return -1 !== t.$ || t.a ? t : A5(Ku, 1, t.b, t.c, t.d, t.e);
    }), sa = F3(function(n, r, t) {
        var e = r(A2(Wu, n, t));
        return e.$ ? A2(fa, n, t) : A3(ta, n, e.a, t);
    }), la = F2(function(n, r) {
        var t = A2(se, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = Gu(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = Gu(e);
            return 1 === i.$ ? r : A3(sa, a, Ou(i.a), r);
        }
        return r;
    }), da = Xu, ba = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.cd;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Vt(r.xz);
                    }
                    return Vt(r.xz);
                }
                return Ut;
            }
        }(n(A5(Yu, h, function(n) {
            var r = A2(se, "/", n);
            return Qu(r.b && "" === r.a ? r.b : r);
        }(r.Cq), 1 === (t = r.iF).$ ? da : A3(Bu, la, da, A2(se, "&", t.a)), r.z6, iu)));
    }), va = function(n) {
        return {
            $: 78,
            a: n
        };
    }, ma = function(n) {
        return {
            $: 79,
            a: n
        };
    }, pa = function(n) {
        return {
            $: 80,
            a: n
        };
    }, $a = {
        $: 12
    }, ha = function(n) {
        return {
            $: 91,
            a: n
        };
    }, ga = function(n) {
        return {
            $: 92,
            a: n
        };
    }, wa = {
        $: 13
    }, xa = {
        $: 60
    }, ka = {
        $: 14
    }, ya = {
        $: 15
    }, _a = {
        $: 16
    }, Aa = {
        $: 17
    }, Ca = {
        $: 18
    }, Ba = function(n) {
        return {
            $: 72,
            a: n
        };
    }, Ea = {
        $: 19
    }, Da = function(n) {
        return {
            $: 73,
            a: n
        };
    }, qa = function(n) {
        return {
            $: 81,
            a: n
        };
    }, Fa = {
        $: 20
    }, Pa = function(n) {
        return {
            $: 74,
            a: n
        };
    }, za = function(n) {
        return {
            $: 82,
            a: n
        };
    }, ja = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Sa = {
        $: 21
    }, La = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Ma = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Na = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Ha = {
        $: 22
    }, Ta = {
        $: 61
    }, Ia = {
        $: 23
    }, Ra = function(n) {
        return {
            $: 76,
            a: n
        };
    }, Za = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Va = {
        $: 24
    }, Ua = function(n) {
        return {
            $: 77,
            a: n
        };
    }, Ya = function(n) {
        return {
            $: 87,
            a: n
        };
    }, Qa = function(n) {
        return {
            $: 88,
            a: n
        };
    }, Oa = {
        $: 25
    }, Ga = {
        $: 26
    }, Ja = function(n) {
        return {
            $: 56,
            a: n
        };
    }, Wa = {
        $: 6
    }, Ka = function(n) {
        return {
            $: 62,
            a: n
        };
    }, Xa = function(n) {
        return {
            $: 57,
            a: n
        };
    }, ni = function(n) {
        return {
            $: 89,
            a: n
        };
    }, ri = function(n) {
        return {
            $: 90,
            a: n
        };
    }, ti = {
        $: 27
    }, ei = {
        $: 7
    }, ui = function(n) {
        return {
            $: 58,
            a: n
        };
    }, ai = {
        $: 8
    }, ii = {
        $: 1
    }, ci = {
        $: 9
    }, oi = {
        $: 28
    }, fi = {
        $: 29
    }, si = {
        $: 30
    }, li = {
        $: 3
    }, di = function(n) {
        return {
            $: 63,
            a: n
        };
    }, bi = function(n) {
        return {
            $: 64,
            a: n
        };
    }, vi = function(n) {
        return {
            $: 65,
            a: n
        };
    }, mi = function(n) {
        return {
            $: 66,
            a: n
        };
    }, pi = function(n) {
        return {
            $: 67,
            a: n
        };
    }, $i = function(n) {
        return {
            $: 68,
            a: n
        };
    }, hi = function(n) {
        return {
            $: 69,
            a: n
        };
    }, gi = function(n) {
        return {
            $: 70,
            a: n
        };
    }, wi = function(n) {
        return {
            $: 71,
            a: n
        };
    }, xi = function(n) {
        return {
            $: 59,
            a: n
        };
    }, ki = {
        $: 10
    }, yi = {
        $: 31
    }, _i = {
        $: 32
    }, Ai = {
        $: 33
    }, Ci = {
        $: 34
    }, Bi = {
        $: 35
    }, Ei = {
        $: 36
    }, Di = {
        $: 37
    }, qi = {
        $: 38
    }, Fi = {
        $: 39
    }, Pi = {
        $: 40
    }, zi = {
        $: 41
    }, ji = {
        $: 42
    }, Si = {
        $: 43
    }, Li = {
        $: 44
    }, Mi = {
        $: 45
    }, Ni = {
        $: 46
    }, Hi = {
        $: 47
    }, Ti = {
        $: 48
    }, Ii = {
        $: 49
    }, Ri = {
        $: 50
    }, Zi = {
        $: 51
    }, Vi = {
        $: 52
    }, Ui = {
        $: 53
    }, Yi = {
        $: 54
    }, Qi = {
        $: 11
    }, Oi = {
        $: 55
    }, Gi = {
        $: 4
    }, Ji = {
        $: 0
    }, Wi = {
        $: 5
    }, Ki = F2(function(n, r) {
        return A5(Yu, r.cZ, r.cd, r.Ck, r.cy, n(r.xz));
    }), Xi = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.cZ, u = r.cd, a = r.Ck, i = r.cy;
            return A2(Eu, Ki(r.xz), t(A5(Yu, e, u, a, i, n)));
        };
    }), nc = F2(function(n, r) {
        return r.b ? A3(Bu, Yt, r, n) : n;
    }), rc = function(n) {
        return A3(Bu, nc, h, n);
    }, tc = F2(function(n, r) {
        return rc(A2(Eu, n, r));
    }), ec = function(n) {
        return function(r) {
            var t = r.cZ, e = r.cd, u = r.Ck, a = r.cy, c = r.xz;
            if (e.b) {
                var o = e.a, f = e.b;
                return i(o, n) ? x([
                    A5(Yu, A2(Yt, o, t), f, u, a, c)
                ]) : h;
            }
            return h;
        };
    }, uc = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(tc, e, t(n));
        };
    }), ac = F2(function(n, r) {
        return function(n) {
            var t = n.cZ, e = n.cd, u = n.Ck, a = n.cy, i = n.xz;
            if (e.b) {
                var c = e.a, o = e.b, f = r(c);
                if (f.$) return h;
                var s = f.a;
                return x([
                    A5(Yu, A2(Yt, c, t), o, u, a, i(s))
                ]);
            }
            return h;
        };
    }), ic = A2(ac, "STRING", Vt), cc = function(n) {
        return x([
            n
        ]);
    }, oc = (Su = x([
        A2(Xi, Ji, cc),
        A2(Xi, ii, ec("enroll-thanks")),
        A2(Xi, Uu, ec("not-found")),
        A2(Xi, li, ec("patient-documents")),
        A2(Xi, Gi, ec("thanks")),
        A2(Xi, Wi, ec("waitlist")),
        A2(Xi, Wa, ec("account")),
        A2(Xi, ei, ec("booking")),
        A2(Xi, ai, ec("checkout")),
        A2(Xi, ci, ec("enroll")),
        A2(Xi, ki, ec("signup")),
        A2(Xi, Qi, ec("style-guide")),
        A2(Xi, $a, A2(uc, ec("account"), ec("booking"))),
        A2(Xi, wa, A2(uc, ec("account"), ec("cart"))),
        A2(Xi, ka, A2(uc, ec("account"), ec("chat"))),
        A2(Xi, ya, A2(uc, ec("account"), ec("documents"))),
        A2(Xi, _a, A2(uc, ec("account"), ec("explore-services"))),
        A2(Xi, Aa, A2(uc, ec("account"), ec("forbidden"))),
        A2(Xi, Ca, A2(uc, ec("account"), ec("health-information"))),
        A2(Xi, Ea, A2(uc, ec("account"), ec("invoices"))),
        A2(Xi, Fa, A2(uc, ec("account"), ec("members"))),
        A2(Xi, Sa, A2(uc, ec("account"), ec("memberships"))),
        A2(Xi, Ha, A2(uc, ec("account"), ec("messaging"))),
        A2(Xi, Ia, A2(uc, ec("account"), ec("not-found"))),
        A2(Xi, Va, A2(uc, ec("account"), ec("payment-sources"))),
        A2(Xi, Oa, A2(uc, ec("account"), ec("practitioner-location"))),
        A2(Xi, Ga, A2(uc, ec("account"), ec("session-expired"))),
        A2(Xi, ti, A2(uc, ec("booking"), ec("empty"))),
        A2(Xi, oi, A2(uc, ec("login"), ec("request"))),
        A2(Xi, fi, A2(uc, ec("login"), ec("select-patient"))),
        A2(Xi, si, A2(uc, ec("login"), ec("verify-code"))),
        A2(Xi, yi, A2(uc, ec("style-guide"), ec("activity-indicator"))),
        A2(Xi, _i, A2(uc, ec("style-guide"), ec("address-input"))),
        A2(Xi, Ai, A2(uc, ec("style-guide"), ec("alerts"))),
        A2(Xi, Ci, A2(uc, ec("style-guide"), ec("api-select"))),
        A2(Xi, Bi, A2(uc, ec("style-guide"), ec("button"))),
        A2(Xi, Ei, A2(uc, ec("style-guide"), ec("card-example"))),
        A2(Xi, Di, A2(uc, ec("style-guide"), ec("cart-icon"))),
        A2(Xi, qi, A2(uc, ec("style-guide"), ec("checkbox"))),
        A2(Xi, Fi, A2(uc, ec("style-guide"), ec("filter-example"))),
        A2(Xi, Pi, A2(uc, ec("style-guide"), ec("form-example"))),
        A2(Xi, zi, A2(uc, ec("style-guide"), ec("grid"))),
        A2(Xi, ji, A2(uc, ec("style-guide"), ec("input"))),
        A2(Xi, Si, A2(uc, ec("style-guide"), ec("insurance-info"))),
        A2(Xi, Li, A2(uc, ec("style-guide"), ec("modal"))),
        A2(Xi, Mi, A2(uc, ec("style-guide"), ec("multi-form"))),
        A2(Xi, Ni, A2(uc, ec("style-guide"), ec("phone-input"))),
        A2(Xi, Hi, A2(uc, ec("style-guide"), ec("radio"))),
        A2(Xi, Ti, A2(uc, ec("style-guide"), ec("searchable-select"))),
        A2(Xi, Ii, A2(uc, ec("style-guide"), ec("select"))),
        A2(Xi, Ri, A2(uc, ec("style-guide"), ec("table"))),
        A2(Xi, Zi, A2(uc, ec("style-guide"), ec("tabs"))),
        A2(Xi, Vi, A2(uc, ec("style-guide"), ec("tag"))),
        A2(Xi, Ui, A2(uc, ec("style-guide"), ec("toggle"))),
        A2(Xi, Yi, A2(uc, ec("style-guide"), ec("tooltip"))),
        A2(Xi, Oi, A2(uc, ec("style-guide"), ec("typography"))),
        A2(Xi, Ja, A2(Xi, function(n) {
            return {
                xd: n
            };
        }, A2(uc, ec("account"), ic))),
        A2(Xi, Xa, A2(Xi, function(n) {
            return {
                xd: n
            };
        }, A2(uc, ec("bills"), ic))),
        A2(Xi, ui, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("checkout"), ic))),
        A2(Xi, xi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), ic))),
        A2(Xi, xa, A2(uc, ec("account"), A2(uc, ec("cart"), ec("confirm-pay")))),
        A2(Xi, Ta, A2(uc, ec("account"), A2(uc, ec("messaging"), ec("chat")))),
        A2(Xi, Ka, A2(Xi, function(n) {
            return {
                bc: n
            };
        }, A2(uc, ec("appointments"), A2(uc, ic, ec("cancellation-policy"))))),
        A2(Xi, di, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("additional-details"))))),
        A2(Xi, bi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("confirmation"))))),
        A2(Xi, vi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("contacts"))))),
        A2(Xi, mi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("custom-details"))))),
        A2(Xi, pi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("location"))))),
        A2(Xi, $i, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("members"))))),
        A2(Xi, hi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("membership"))))),
        A2(Xi, gi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("provider"))))),
        A2(Xi, wi, A2(Xi, function(n) {
            return {
                wy: n
            };
        }, A2(uc, ec("signup"), A2(uc, ic, ec("thanks"))))),
        A2(Xi, Ba, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("health-information"), ic)))),
        A2(Xi, Da, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("invoices"), ic)))),
        A2(Xi, Pa, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("members"), ic)))),
        A2(Xi, La, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("memberships"), ic)))),
        A2(Xi, Ra, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("packages"), ic)))),
        A2(Xi, Ua, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("payment-sources"), ic)))),
        A2(Xi, va, A2(Xi, function(n) {
            return {
                bc: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("appointments"), A2(uc, ic, ec("cancel")))))),
        A2(Xi, ma, A2(Xi, function(n) {
            return {
                bc: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("appointments"), A2(uc, ic, ec("cancel-appointment")))))),
        A2(Xi, pa, A2(Xi, function(n) {
            return {
                bc: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("appointments"), A2(uc, ic, ec("reschedule")))))),
        A2(Xi, qa, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("invoices"), A2(uc, ic, ec("payment")))))),
        A2(Xi, za, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("members"), A2(uc, ic, ec("edit")))))),
        A2(Xi, ja, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("members"), A2(uc, ic, ec("emergency-contact")))))),
        A2(Xi, Ma, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("memberships"), A2(uc, ic, ec("add-member")))))),
        A2(Xi, Na, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("memberships"), A2(uc, ic, ec("renew")))))),
        A2(Xi, Za, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("packages"), A2(uc, ic, ec("checkout")))))),
        A2(Xi, Ya, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("payment-sources"), A2(uc, ic, ec("edit")))))),
        A2(Xi, Qa, A2(Xi, function(n) {
            return {
                rh: n
            };
        }, A2(uc, ec("account"), A2(uc, ec("plans"), A2(uc, ic, ec("checkout")))))),
        A2(Xi, ni, A2(Xi, F2(function(n, r) {
            return {
                mH: n,
                nd: r
            };
        }), A2(uc, ec("booking"), A2(uc, ic, A2(uc, ec("location"), A2(uc, ic, ec("date"))))))),
        A2(Xi, ri, A2(Xi, F2(function(n, r) {
            return {
                mH: n,
                nd: r
            };
        }), A2(uc, ec("booking"), A2(uc, ic, A2(uc, ec("location"), A2(uc, ic, ec("enter-info"))))))),
        A2(Xi, ha, A2(Xi, F2(function(n, r) {
            return {
                mH: n,
                nd: r
            };
        }), A2(uc, ec("account"), A2(uc, ec("booking"), A2(uc, ic, A2(uc, ec("location"), A2(uc, ic, ec("date")))))))),
        A2(Xi, ga, A2(Xi, F2(function(n, r) {
            return {
                mH: n,
                nd: r
            };
        }), A2(uc, ec("account"), A2(uc, ec("booking"), A2(uc, ic, A2(uc, ec("location"), A2(uc, ic, ec("enter-info"))))))))
    ]), function(n) {
        return A2(tc, function(r) {
            return r(n);
        }, Su);
    }), fc = ba(oc), sc = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), lc = A2(ru, fc, sc(Uu)), dc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bc = {
        $: 0
    }, vc = {
        $: 0
    }, mc = function(n) {
        return {
            $: 13,
            a: n
        };
    }, pc = F3(function(n, r, t) {
        return n(r(t));
    }), $c = Cn, hc = F2(function(n, r) {
        return Mu(A2($c, A2(pc, A2(pc, _u, n), Kt), A2(Du, A2(pc, A2(pc, _u, n), te), r)));
    }), gc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wc = F4(function(n, r, t, e) {
        return gc({
            i: e,
            bb: r,
            aG: !0,
            bK: t,
            hT: 0,
            bA: n
        });
    }), xc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kc = F4(function(n, r, t, e) {
        return xc({
            i: e,
            bb: r,
            aG: !0,
            bK: t,
            bA: n
        });
    }), yc = F4(function(n, r, t, e) {
        return xc({
            i: e,
            bb: r,
            aG: !0,
            bK: t,
            bA: n
        });
    }), _c = F4(function(n, r, t, e) {
        return xc({
            i: e,
            bb: r,
            aG: !0,
            bK: t,
            bA: n
        });
    }), Ac = F4(function(n, r, t, e) {
        return xc({
            i: e,
            bb: r,
            aG: !1,
            bK: t,
            bA: n
        });
    }), Cc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bc = F2(function(n, r) {
        return {
            oP: r,
            aL: n
        };
    }), Ec = F2(function(n, r) {
        return {
            lD: n,
            lS: r
        };
    }), Dc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), qc = Dc, Fc = 2037, Pc = F5(function(n, r, t, e, u) {
        return {
            bN: u,
            o0: t,
            tb: r,
            D7: e,
            xQ: n
        };
    }), zc = function(n) {
        return n.b;
    }, jc = D, Sc = F2(function(n, r) {
        var t = A2(jc, 7, function(n) {
            return A2(jc, 7, n) || 7;
        }(r) + 7 - function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                default:
                    return 7;
            }
        }(n));
        return r - t;
    }), Lc = F2(function(n, r) {
        var t = A2(Sc, n, r);
        return i(r, t) ? r : t + 7;
    }), Mc = f, Nc = function(n) {
        return !A2(jc, 4, n) && !!A2(jc, 100, n) || !A2(jc, 400, n);
    }, Hc = F2(function(n, r) {
        var t = Nc(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), Tc = function(n) {
        var r = n - 1;
        return 365 * r + ((r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0));
    }, Ic = F3(function(n, r, t) {
        return Tc(n) + A2(Hc, n, r) + t;
    }), Rc = F2(function(n, r) {
        return A3(Bu, F2(function(r, t) {
            return n(r) ? A2(Yt, r, t) : t;
        }), h, r);
    }), Zc = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Nc(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Vc = F2(function(n, r) {
        return Tc(n) + A2(Hc, n, r) + A2(Zc, n, r);
    }), Uc = function(n) {
        return 1440 * (n - 719163);
    }, Yc = _, Qc = F2(function(n, r) {
        var t = r.cc, e = r.Db;
        switch(n){
            case 0:
                return 0;
            case 1:
                return 0 - t;
            default:
                return 0 - (t + e);
        }
    }), Oc = F2(function(n, r) {
        var t, e;
        return e = (t = r).D7, Uc(A3(Ic, t.xQ, t.tb, t.o0)) + e + A2(Qc, r.bN, n);
    }), Gc = F5(function(n, r, t, e, u) {
        var a = A2(tc, function(n) {
            return A2(Yc, function(n) {
                return n.wH;
            }, A2(Eu, function(r) {
                return {
                    bN: r.bN,
                    Db: r.Db,
                    wH: Uc(function() {
                        var t = r.o0;
                        switch(t.$){
                            case 0:
                                return A3(Ic, n, r.tb, t.a);
                            case 1:
                                return A2(Lc, t.a, A3(Ic, n, r.tb, t.b));
                            case 2:
                                return A2(Sc, t.a, A3(Ic, n, r.tb, t.b));
                            default:
                                return A2(Sc, t.a, A2(Vc, n, r.tb));
                        }
                    }()) + r.D7
                };
            }, A2(Rc, function(r) {
                return 1 > s(r.qQ, n) && 1 > s(n, r.w6);
            }, u)));
        }, A2($e, r.xQ - 1, t.xQ)), i = {
            Db: 0,
            cc: e
        }, c = {
            ic: e,
            wH: A2(Oc, n, r)
        }, o = A3(de, F2(function(r, u) {
            var a = u.a, i = u.b, o = {
                Db: r.Db,
                cc: e
            };
            return 1 > s(r.wH + A2(Qc, r.bN, n), c.wH) ? b(o, x([
                {
                    ic: e + r.Db,
                    wH: c.wH
                }
            ])) : 0 > s(r.wH + A2(Qc, r.bN, a), A2(Oc, a, t)) ? b(o, A2(Yt, {
                ic: e + r.Db,
                wH: r.wH + A2(Qc, r.bN, a)
            }, i)) : b(a, i);
        }), b(i, x([
            c
        ])), a), f = o.a;
        return b(Ae(o.b), f);
    }), Jc = F4(function(n, r, t, e) {
        var u = e.lD, a = e.lS;
        if (a.$) return A5(Gc, n, r, t, u, a.a);
        var i = a.a;
        return b(x([
            {
                ic: u + i,
                wH: A2(Oc, n, r)
            }
        ]), {
            Db: i,
            cc: u
        });
    }), Wc = F4(function(n, r, t, e) {
        for(;;){
            if (!e.b) return Ae(t);
            var u = e.a, a = e.b, c = n(u), o = i(r, c) ? t : A2(Yt, u, t);
            r = c, t = o, e = a;
        }
    }), Kc = F3(function(n, r, t) {
        var e = A3(de, F2(function(n, r) {
            var t = n.b, e = r.b;
            return b(t, A2(Yt, v(r.a, n.a, t), e));
        }), b(n, h), t.aL), u = e.b;
        return Ae(A2(Yt, v(e.a, t.oP, r), u));
    }), Xc = F3(function(n, r, t) {
        var e, u, a = (e = t.aL).b ? e.a.a : t.oP, i = {
            Db: (u = a.lS, u.$ ? 0 : u.a),
            cc: a.lD
        }, c = A4(Wc, function(n) {
            return n.ic;
        }, i.cc + i.Db, h, A3(de, F2(function(n, r) {
            var t = r.b, e = A4(Jc, r.a, n.a, n.c, n.b);
            return b(e.b, $(t, e.a));
        }), b(i, h), A3(Kc, A5(Pc, n, 0, 1, 0, 0), A5(Pc, r + 1, 0, 1, 0, 0), t)).b), o = function(n) {
            for(;;){
                var r = n.a, t = n.b;
                if (!t.b) return b(r, h);
                var e = t.a, u = t.b;
                if (e.wH > 0) return b(r, t);
                n = b(e.ic, u);
            }
        }(b(i.cc + i.Db, c)), f = o.a;
        return b(Ae(o.b), f);
    }), no = function(n) {
        var r = A3(Xc, 1970, Fc, n);
        return A2(qc, r.b, r.a);
    }, ro = function(n) {
        return -n;
    }, to = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eo = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uo = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ao = F7(function(n, r, t, e, u, a, i) {
        return {
            bN: a,
            o0: e,
            qQ: n,
            tb: t,
            Db: i,
            D7: u,
            w6: r
        };
    }), io = x([
        A7(ao, 1967, 2006, 9, eo(6), 120, 2, 0),
        A7(ao, 1967, 1973, 3, eo(6), 120, 2, 60),
        A7(ao, 1974, 1974, 0, to(6), 120, 2, 60),
        A7(ao, 1975, 1975, 1, eo(6), 120, 2, 60),
        A7(ao, 1976, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1987, 2006, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2007, Fc, 2, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2007, Fc, 10, A2(uo, 6, 1), 120, 2, 0)
    ]), co = function() {
        return no(A2(Bc, h, A2(Ec, -480, Cc(io))));
    }, oo = co(), fo = {
        $: 0
    }, so = yn, lo = _n(function(n) {
        try {
            var r = function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(Intl.DateTimeFormat().resolvedOptions().timeZone);
        } catch (n) {
            r = function(n) {
                return {
                    $: 1,
                    a: n
                };
            }((new Date).getTimezoneOffset());
        }
        n(kn(r));
    }), bo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vo = function() {
        return no(A2(Bc, h, A2(Ec, 0, bo(0))));
    }, mo = function() {
        return no(A2(Bc, h, A2(Ec, 180, bo(0))));
    }, po = mo, $o = x([
        A7(ao, 1971, 1971, 3, to(25), 1380, 1, 60),
        A7(ao, 1971, 1971, 8, to(26), 1380, 1, 0),
        A7(ao, 1977, 1977, 4, to(6), 0, 2, 60),
        A7(ao, 1977, 1977, 9, to(21), 0, 2, 0),
        A7(ao, 1978, 1978, 2, to(24), 60, 2, 60),
        A7(ao, 1978, 1978, 8, to(22), 180, 2, 0),
        A7(ao, 1980, 1980, 3, to(25), 0, 2, 60),
        A7(ao, 1980, 1980, 9, to(31), 120, 2, 0)
    ]), ho = mo, go = vo, wo = function() {
        return no(A2(Bc, h, A2(Ec, 60, bo(0))));
    }, xo = wo, ko = vo, yo = function() {
        return no(A2(Bc, h, A2(Ec, 120, bo(0))));
    }, _o = yo, Ao = wo, Co = yo, Bo = x([
        A7(ao, 1959, 1981, 4, to(1), 60, 2, 60),
        A7(ao, 1966, 1994, 9, to(1), 180, 2, 0),
        A7(ao, 1982, 1982, 6, to(25), 60, 2, 60),
        A7(ao, 1983, 1983, 6, to(12), 60, 2, 60),
        A7(ao, 1984, 1988, 4, to(1), 60, 2, 60),
        A7(ao, 1989, 1989, 4, to(6), 60, 2, 60),
        A7(ao, 1990, 1994, 4, to(1), 60, 2, 60),
        A7(ao, 1995, 2010, 3, eo(4), 0, 1, 60),
        A7(ao, 1995, 2005, 8, eo(3), 1440, 2, 0),
        A7(ao, 2006, 2006, 8, to(21), 1440, 2, 0),
        A7(ao, 2007, 2007, 8, A2(uo, 3, 1), 1440, 2, 0),
        A7(ao, 2008, 2008, 7, eo(3), 1440, 2, 0),
        A7(ao, 2009, 2009, 7, to(20), 1440, 2, 0),
        A7(ao, 2010, 2010, 7, to(10), 1440, 2, 0),
        A7(ao, 2010, 2010, 8, to(9), 1440, 2, 60),
        A7(ao, 2010, 2010, 8, eo(3), 1440, 2, 0),
        A7(ao, 2014, 2014, 4, to(15), 1440, 2, 60),
        A7(ao, 2014, 2014, 5, to(26), 1440, 2, 0),
        A7(ao, 2014, 2014, 6, to(31), 1440, 2, 60),
        A7(ao, 2014, 2014, 8, eo(3), 1440, 2, 0)
    ]), Eo = x([
        A7(ao, 1974, 1974, 5, to(24), 0, 2, 60),
        A7(ao, 1974, 1974, 8, to(1), 0, 2, 0),
        A7(ao, 1976, 1977, 4, to(1), 0, 2, 60),
        A7(ao, 1976, 1976, 7, to(1), 0, 2, 0),
        A7(ao, 1977, 1977, 8, to(28), 0, 2, 0),
        A7(ao, 1978, 1978, 5, to(1), 0, 2, 60),
        A7(ao, 1978, 1978, 7, to(4), 0, 2, 0),
        A7(ao, 2008, 2008, 5, to(1), 0, 2, 60),
        A7(ao, 2008, 2008, 8, to(1), 0, 2, 0),
        A7(ao, 2009, 2009, 5, to(1), 0, 2, 60),
        A7(ao, 2009, 2009, 7, to(21), 0, 2, 0),
        A7(ao, 2010, 2010, 4, to(2), 0, 2, 60),
        A7(ao, 2010, 2010, 7, to(8), 0, 2, 0),
        A7(ao, 2011, 2011, 3, to(3), 0, 2, 60),
        A7(ao, 2011, 2011, 6, to(31), 0, 2, 0),
        A7(ao, 2012, 2013, 3, eo(6), 120, 2, 60),
        A7(ao, 2012, 2012, 6, to(20), 180, 2, 0),
        A7(ao, 2012, 2012, 7, to(20), 120, 2, 60),
        A7(ao, 2012, 2012, 8, to(30), 180, 2, 0),
        A7(ao, 2013, 2013, 6, to(7), 180, 2, 0),
        A7(ao, 2013, 2013, 7, to(10), 120, 2, 60),
        A7(ao, 2013, 2018, 9, eo(6), 180, 2, 0),
        A7(ao, 2014, 2018, 2, eo(6), 120, 2, 60),
        A7(ao, 2014, 2014, 5, to(28), 180, 2, 0),
        A7(ao, 2014, 2014, 7, to(2), 120, 2, 60),
        A7(ao, 2015, 2015, 5, to(14), 180, 2, 0),
        A7(ao, 2015, 2015, 6, to(19), 120, 2, 60),
        A7(ao, 2016, 2016, 5, to(5), 180, 2, 0),
        A7(ao, 2016, 2016, 6, to(10), 120, 2, 60),
        A7(ao, 2017, 2017, 4, to(21), 180, 2, 0),
        A7(ao, 2017, 2017, 6, to(2), 120, 2, 60),
        A7(ao, 2018, 2018, 4, to(13), 180, 2, 0),
        A7(ao, 2018, 2018, 5, to(17), 120, 2, 60),
        A7(ao, 2019, 2019, 4, to(5), 180, 2, -60),
        A7(ao, 2019, 2019, 5, to(9), 120, 2, 0),
        A7(ao, 2020, 2020, 3, to(19), 180, 2, -60),
        A7(ao, 2020, 2020, 4, to(31), 120, 2, 0),
        A7(ao, 2021, 2021, 3, to(11), 180, 2, -60),
        A7(ao, 2021, 2021, 4, to(16), 120, 2, 0),
        A7(ao, 2022, 2022, 2, to(27), 180, 2, -60),
        A7(ao, 2022, 2022, 4, to(8), 120, 2, 0),
        A7(ao, 2023, 2023, 2, to(19), 180, 2, -60),
        A7(ao, 2023, 2023, 3, to(30), 120, 2, 0),
        A7(ao, 2024, 2024, 2, to(10), 180, 2, -60),
        A7(ao, 2024, 2024, 3, to(14), 120, 2, 0),
        A7(ao, 2025, 2025, 1, to(23), 180, 2, -60),
        A7(ao, 2025, 2025, 3, to(6), 120, 2, 0),
        A7(ao, 2026, 2026, 1, to(15), 180, 2, -60),
        A7(ao, 2026, 2026, 2, to(22), 120, 2, 0),
        A7(ao, 2027, 2027, 1, to(7), 180, 2, -60),
        A7(ao, 2027, 2027, 2, to(14), 120, 2, 0),
        A7(ao, 2028, 2028, 0, to(23), 180, 2, -60),
        A7(ao, 2028, 2028, 2, to(5), 120, 2, 0),
        A7(ao, 2029, 2029, 0, to(14), 180, 2, -60),
        A7(ao, 2029, 2029, 1, to(18), 120, 2, 0),
        A7(ao, 2029, 2029, 11, to(30), 180, 2, -60),
        A7(ao, 2030, 2030, 1, to(10), 120, 2, 0),
        A7(ao, 2030, 2030, 11, to(22), 180, 2, -60),
        A7(ao, 2031, 2031, 1, to(2), 120, 2, 0),
        A7(ao, 2031, 2031, 11, to(14), 180, 2, -60),
        A7(ao, 2032, 2032, 0, to(18), 120, 2, 0),
        A7(ao, 2032, 2032, 10, to(28), 180, 2, -60),
        A7(ao, 2033, 2033, 0, to(9), 120, 2, 0),
        A7(ao, 2033, 2033, 10, to(20), 180, 2, -60),
        A7(ao, 2033, 2033, 11, to(25), 120, 2, 0),
        A7(ao, 2034, 2034, 10, to(5), 180, 2, -60),
        A7(ao, 2034, 2034, 11, to(17), 120, 2, 0),
        A7(ao, 2035, 2035, 9, to(28), 180, 2, -60),
        A7(ao, 2035, 2035, 11, to(9), 120, 2, 0),
        A7(ao, 2036, 2036, 9, to(19), 180, 2, -60),
        A7(ao, 2036, 2036, 10, to(23), 120, 2, 0),
        A7(ao, 2037, 2037, 9, to(4), 180, 2, -60),
        A7(ao, 2037, 2037, 10, to(15), 120, 2, 0)
    ]), Do = x([
        A7(ao, 1977, 1980, 3, A2(uo, 6, 1), 60, 0, 60),
        A7(ao, 1977, 1977, 8, eo(6), 60, 0, 0),
        A7(ao, 1978, 1978, 9, to(1), 60, 0, 0),
        A7(ao, 1979, 1995, 8, eo(6), 60, 0, 0),
        A7(ao, 1981, Fc, 2, eo(6), 60, 0, 60),
        A7(ao, 1996, Fc, 9, eo(6), 60, 0, 0)
    ]), qo = x([
        A7(ao, 1974, 1974, 5, to(24), 0, 2, 60),
        A7(ao, 1974, 1974, 8, to(1), 0, 2, 0),
        A7(ao, 1976, 1977, 4, to(1), 0, 2, 60),
        A7(ao, 1976, 1976, 7, to(1), 0, 2, 0),
        A7(ao, 1977, 1977, 8, to(28), 0, 2, 0),
        A7(ao, 1978, 1978, 5, to(1), 0, 2, 60),
        A7(ao, 1978, 1978, 7, to(4), 0, 2, 0)
    ]), Fo = vo, Po = vo, zo = mo, jo = mo, So = wo, Lo = vo, Mo = yo, No = yo, Ho = function() {
        return no(A2(Bc, h, A2(Ec, 120, bo(0))));
    }, To = x([
        A7(ao, 1970, 1970, 4, to(1), 0, 2, 60),
        A7(ao, 1970, 1985, 9, to(15), 0, 2, 0),
        A7(ao, 1971, 1971, 3, to(30), 0, 2, 60),
        A7(ao, 1972, 1985, 3, eo(6), 0, 2, 60)
    ]), Io = mo, Ro = yo, Zo = wo, Vo = wo, Uo = vo, Yo = wo, Qo = yo, Oo = yo, Go = wo, Jo = Ho, Wo = Ho, Ko = mo, Xo = wo, nf = vo, rf = vo, tf = wo, ef = x([
        A7(ao, 1982, 1984, 3, to(1), 0, 2, 60),
        A7(ao, 1982, 1985, 9, to(1), 0, 2, 0),
        A7(ao, 1985, 1985, 3, to(6), 0, 2, 60),
        A7(ao, 1986, 1986, 3, to(4), 0, 2, 60),
        A7(ao, 1986, 1986, 9, to(3), 0, 2, 0),
        A7(ao, 1987, 1989, 3, to(1), 0, 2, 60),
        A7(ao, 1987, 1989, 9, to(1), 0, 2, 0),
        A7(ao, 1997, 1997, 3, to(4), 0, 2, 60),
        A7(ao, 1997, 1997, 9, to(4), 0, 2, 0),
        A7(ao, 2013, 2013, 2, eo(4), 60, 2, 60),
        A7(ao, 2013, 2013, 9, eo(4), 120, 2, 0)
    ]), uf = x([
        A7(ao, 1977, 1977, 3, to(30), 0, 1, 60),
        A7(ao, 1977, 1977, 8, to(24), 0, 1, 0),
        A7(ao, 1978, 1978, 4, to(1), 0, 1, 60),
        A7(ao, 1978, 1978, 9, to(1), 0, 1, 0),
        A7(ao, 1988, 1988, 5, to(1), 0, 1, 60),
        A7(ao, 1988, 1990, 8, eo(6), 0, 1, 0),
        A7(ao, 1989, 1989, 2, to(26), 0, 1, 60),
        A7(ao, 1990, 1990, 4, to(1), 0, 1, 60),
        A7(ao, 2005, 2005, 4, to(1), 0, 1, 60),
        A7(ao, 2005, 2005, 8, to(30), 60, 1, 0),
        A7(ao, 2006, 2008, 2, eo(6), 120, 1, 60),
        A7(ao, 2006, 2008, 9, eo(6), 120, 1, 0)
    ]), af = x([
        A7(ao, 1994, 1994, 2, to(21), 0, 2, -60),
        A7(ao, 1994, 2017, 8, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 1995, 2017, 3, A2(uo, 6, 1), 120, 2, -60)
    ]), cf = function() {
        return no(A2(Bc, h, A2(Ec, -240, bo(0))));
    }, of = cf, ff = cf, sf = x([
        A7(ao, 1985, 1985, 10, to(2), 0, 2, 60),
        A7(ao, 1986, 1986, 2, to(15), 0, 2, 0),
        A7(ao, 1986, 1986, 9, to(25), 0, 2, 60),
        A7(ao, 1987, 1987, 1, to(14), 0, 2, 0),
        A7(ao, 1987, 1987, 9, to(25), 0, 2, 60),
        A7(ao, 1988, 1988, 1, to(7), 0, 2, 0),
        A7(ao, 1988, 1988, 9, to(16), 0, 2, 60),
        A7(ao, 1989, 1989, 0, to(29), 0, 2, 0),
        A7(ao, 1989, 1989, 9, to(15), 0, 2, 60),
        A7(ao, 1990, 1990, 1, to(11), 0, 2, 0),
        A7(ao, 1990, 1990, 9, to(21), 0, 2, 60),
        A7(ao, 1991, 1991, 1, to(17), 0, 2, 0),
        A7(ao, 1991, 1991, 9, to(20), 0, 2, 60),
        A7(ao, 1992, 1992, 1, to(9), 0, 2, 0),
        A7(ao, 1992, 1992, 9, to(25), 0, 2, 60),
        A7(ao, 1993, 1993, 0, to(31), 0, 2, 0),
        A7(ao, 1993, 1995, 9, A2(uo, 6, 11), 0, 2, 60),
        A7(ao, 1994, 1995, 1, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 1996, 1996, 1, to(11), 0, 2, 0),
        A7(ao, 1996, 1996, 9, to(6), 0, 2, 60),
        A7(ao, 1997, 1997, 1, to(16), 0, 2, 0),
        A7(ao, 1997, 1997, 9, to(6), 0, 2, 60),
        A7(ao, 1998, 1998, 2, to(1), 0, 2, 0),
        A7(ao, 1998, 1998, 9, to(11), 0, 2, 60),
        A7(ao, 1999, 1999, 1, to(21), 0, 2, 0),
        A7(ao, 1999, 1999, 9, to(3), 0, 2, 60),
        A7(ao, 2e3, 2e3, 1, to(27), 0, 2, 0),
        A7(ao, 2e3, 2001, 9, A2(uo, 6, 8), 0, 2, 60),
        A7(ao, 2001, 2006, 1, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 2002, 2002, 10, to(3), 0, 2, 60),
        A7(ao, 2003, 2003, 9, to(19), 0, 2, 60),
        A7(ao, 2004, 2004, 10, to(2), 0, 2, 60),
        A7(ao, 2005, 2005, 9, to(16), 0, 2, 60),
        A7(ao, 2006, 2006, 10, to(5), 0, 2, 60),
        A7(ao, 2007, 2007, 1, to(25), 0, 2, 0),
        A7(ao, 2007, 2007, 9, A2(uo, 6, 8), 0, 2, 60),
        A7(ao, 2008, 2017, 9, A2(uo, 6, 15), 0, 2, 60),
        A7(ao, 2008, 2011, 1, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 2012, 2012, 1, A2(uo, 6, 22), 0, 2, 0),
        A7(ao, 2013, 2014, 1, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 2015, 2015, 1, A2(uo, 6, 22), 0, 2, 0),
        A7(ao, 2016, 2019, 1, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 2018, 2018, 10, A2(uo, 6, 1), 0, 2, 60)
    ]), lf = x([
        A7(ao, 1968, 1969, 3, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1974, 1974, 0, to(23), 0, 2, 60),
        A7(ao, 1974, 1974, 4, to(1), 0, 2, 0),
        A7(ao, 1988, 1988, 11, to(1), 0, 2, 60),
        A7(ao, 1989, 1993, 2, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1989, 1992, 9, A2(uo, 6, 15), 0, 2, 60),
        A7(ao, 1999, 1999, 9, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 2e3, 2e3, 2, to(3), 0, 2, 0),
        A7(ao, 2007, 2007, 11, to(30), 0, 2, 60),
        A7(ao, 2008, 2009, 2, A2(uo, 6, 15), 0, 2, 0),
        A7(ao, 2008, 2008, 9, A2(uo, 6, 15), 0, 2, 60)
    ]), df = x([
        A7(ao, 2008, 2009, 2, A2(uo, 6, 8), 0, 2, 0),
        A7(ao, 2007, 2008, 9, A2(uo, 6, 8), 0, 2, 60)
    ]), bf = function() {
        return no(A2(Bc, h, A2(Ec, -240, bo(0))));
    }, vf = bf, mf = x([
        A7(ao, 1975, 1988, 9, to(1), 0, 2, 60),
        A7(ao, 1975, 1978, 2, to(1), 0, 2, 0),
        A7(ao, 1979, 1991, 3, to(1), 0, 2, 0),
        A7(ao, 1989, 1989, 9, to(22), 0, 2, 60),
        A7(ao, 1990, 1990, 9, to(1), 0, 2, 60),
        A7(ao, 1991, 1991, 9, to(6), 0, 2, 60),
        A7(ao, 1992, 1992, 2, to(1), 0, 2, 0),
        A7(ao, 1992, 1992, 9, to(5), 0, 2, 60),
        A7(ao, 1993, 1993, 2, to(31), 0, 2, 0),
        A7(ao, 1993, 1995, 9, to(1), 0, 2, 60),
        A7(ao, 1994, 1995, 1, eo(6), 0, 2, 0),
        A7(ao, 1996, 1996, 2, to(1), 0, 2, 0),
        A7(ao, 1996, 2001, 9, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1997, 1997, 1, eo(6), 0, 2, 0),
        A7(ao, 1998, 2001, 2, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 2002, 2004, 3, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 2002, 2003, 8, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 2004, 2009, 9, A2(uo, 6, 15), 0, 2, 60),
        A7(ao, 2005, 2009, 2, A2(uo, 6, 8), 0, 2, 0),
        A7(ao, 2010, Fc, 9, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 2010, 2012, 3, A2(uo, 6, 8), 0, 2, 0),
        A7(ao, 2013, Fc, 2, A2(uo, 6, 22), 0, 2, 0)
    ]), pf = x([
        A7(ao, 1996, 2e3, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 1996, 2e3, 9, eo(6), 120, 2, 0),
        A7(ao, 2001, 2001, 4, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2001, 2001, 8, eo(6), 120, 2, 0),
        A7(ao, 2002, Fc, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2002, Fc, 9, eo(6), 120, 2, 0)
    ]), $f = x([
        A7(ao, 1977, 1977, 5, to(12), 120, 2, 60),
        A7(ao, 1977, 1978, 9, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 1978, 1980, 3, A2(uo, 6, 15), 120, 2, 60),
        A7(ao, 1979, 1979, 8, to(30), 120, 2, 0),
        A7(ao, 1980, 1980, 8, to(25), 120, 2, 0)
    ]), hf = x([
        A7(ao, 1973, 1973, 11, to(5), 0, 2, 60),
        A7(ao, 1974, 1974, 1, to(9), 0, 2, 0),
        A7(ao, 1982, 1982, 11, to(18), 0, 2, 60),
        A7(ao, 1983, 1983, 1, to(12), 0, 2, 0)
    ]), gf = x([
        A7(ao, 1974, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1974, 2006, 9, eo(6), 120, 2, 0),
        A7(ao, 1987, 2006, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2007, Fc, 2, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2007, Fc, 10, A2(uo, 6, 1), 120, 2, 0)
    ]), wf = x([
        A7(ao, 1992, 1992, 4, to(3), 0, 2, 60),
        A7(ao, 1993, 1993, 3, to(4), 0, 2, 0)
    ]), xf = x([
        A7(ao, 1980, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1980, 2006, 9, eo(6), 120, 2, 0),
        A7(ao, 1987, 2006, 3, A2(uo, 6, 1), 120, 2, 60)
    ]), kf = function() {
        return no(A2(Bc, h, A2(Ec, -300, bo(0))));
    }, yf = kf, _f = x([
        A7(ao, 1979, 1980, 1, eo(6), 0, 2, 60),
        A7(ao, 1979, 1980, 5, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1991, 1992, 0, A2(uo, 5, 15), 0, 2, 60),
        A7(ao, 1991, 1991, 6, to(1), 0, 2, 0),
        A7(ao, 1992, 1992, 2, to(15), 0, 2, 0)
    ]), Af = x([
        A7(ao, 1946, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1962, 2006, 9, eo(6), 120, 2, 0)
    ]), Cf = cf, Bf = x([
        A7(ao, 1972, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1972, 2006, 9, eo(6), 120, 2, 0)
    ]), Ef = x([
        A7(ao, 1987, 1988, 4, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1987, 1988, 8, eo(6), 0, 2, 0)
    ]), Df = x([
        A7(ao, 1962, 1973, 3, eo(6), 120, 2, 60),
        A7(ao, 1962, 1973, 9, eo(6), 120, 2, 0)
    ]), qf = x([
        A7(ao, 1951, 1986, 3, eo(6), 120, 2, 60),
        A7(ao, 1960, 1986, 9, eo(6), 120, 2, 0),
        A7(ao, 1987, 1987, 3, A2(uo, 6, 1), 1, 2, 60),
        A7(ao, 1987, 2006, 9, eo(6), 1, 2, 0),
        A7(ao, 1988, 1988, 3, A2(uo, 6, 1), 1, 2, 120),
        A7(ao, 1989, 2006, 3, A2(uo, 6, 1), 1, 2, 60),
        A7(ao, 2007, 2011, 2, A2(uo, 6, 8), 1, 2, 60),
        A7(ao, 2007, 2010, 10, A2(uo, 6, 1), 1, 2, 0)
    ]), Ff = cf, Pf = cf, zf = x([
        A7(ao, 1973, 1973, 10, to(25), 0, 2, 60),
        A7(ao, 1974, 1974, 1, to(24), 0, 2, 0),
        A7(ao, 1983, 1983, 4, to(21), 0, 2, 60),
        A7(ao, 1983, 1983, 8, to(22), 0, 2, 0),
        A7(ao, 1991, 1991, 2, to(23), 0, 2, 60),
        A7(ao, 1991, 1991, 8, to(7), 0, 2, 0),
        A7(ao, 2006, 2006, 3, to(30), 0, 2, 60),
        A7(ao, 2006, 2006, 9, to(1), 0, 2, 0)
    ]), jf = x([
        A7(ao, 1992, 1992, 10, to(28), 0, 2, 60),
        A7(ao, 1993, 1993, 1, to(5), 0, 2, 0)
    ]), Sf = x([
        A7(ao, 1969, 1977, 3, eo(6), 0, 2, 60),
        A7(ao, 1969, 1971, 9, eo(6), 0, 2, 0),
        A7(ao, 1972, 1974, 9, to(8), 0, 2, 0),
        A7(ao, 1975, 1977, 9, eo(6), 0, 2, 0),
        A7(ao, 1978, 1978, 4, to(7), 0, 2, 60),
        A7(ao, 1978, 1990, 9, A2(uo, 6, 8), 0, 2, 0),
        A7(ao, 1979, 1980, 2, A2(uo, 6, 15), 0, 2, 60),
        A7(ao, 1981, 1985, 4, A2(uo, 6, 5), 0, 2, 60),
        A7(ao, 1986, 1989, 2, A2(uo, 6, 14), 0, 2, 60),
        A7(ao, 1990, 1997, 3, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1991, 1995, 9, A2(uo, 6, 8), 0, 1, 0),
        A7(ao, 1996, 1996, 9, to(6), 0, 1, 0),
        A7(ao, 1997, 1997, 9, to(12), 0, 1, 0),
        A7(ao, 1998, 1999, 2, eo(6), 0, 1, 60),
        A7(ao, 1998, 2003, 9, eo(6), 0, 1, 0),
        A7(ao, 2e3, 2003, 3, A2(uo, 6, 1), 0, 1, 60),
        A7(ao, 2004, 2004, 2, eo(6), 0, 1, 60),
        A7(ao, 2006, 2010, 9, eo(6), 0, 1, 0),
        A7(ao, 2007, 2007, 2, A2(uo, 6, 8), 0, 1, 60),
        A7(ao, 2008, 2008, 2, A2(uo, 6, 15), 0, 1, 60),
        A7(ao, 2009, 2010, 2, A2(uo, 6, 8), 0, 1, 60),
        A7(ao, 2011, 2011, 2, A2(uo, 6, 15), 0, 1, 60),
        A7(ao, 2011, 2011, 10, to(13), 0, 1, 0),
        A7(ao, 2012, 2012, 3, to(1), 0, 1, 60),
        A7(ao, 2012, Fc, 10, A2(uo, 6, 1), 0, 1, 0),
        A7(ao, 2013, Fc, 2, A2(uo, 6, 8), 0, 1, 60)
    ]), Lf = bf, Mf = x([
        A7(ao, 1986, 1987, 0, to(1), 0, 2, 60),
        A7(ao, 1986, 1987, 3, to(1), 0, 2, 0),
        A7(ao, 1990, 1990, 0, to(1), 0, 2, 60),
        A7(ao, 1990, 1990, 3, to(1), 0, 2, 0),
        A7(ao, 1994, 1994, 0, to(1), 0, 2, 60),
        A7(ao, 1994, 1994, 3, to(1), 0, 2, 0)
    ]), Nf = bf, Hf = x([
        A7(ao, 1979, 1980, 2, A2(uo, 6, 16), 0, 2, 60),
        A7(ao, 1979, 1980, 5, A2(uo, 0, 23), 0, 2, 0),
        A7(ao, 2005, 2005, 3, to(10), 0, 2, 60),
        A7(ao, 2005, 2005, 9, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 2006, 2006, 3, to(30), 120, 2, 60),
        A7(ao, 2006, 2006, 9, A2(uo, 6, 1), 60, 2, 0)
    ]), Tf = cf, If = x([
        A7(ao, 1946, 1972, 3, eo(6), 120, 2, 60),
        A7(ao, 1957, 1972, 9, eo(6), 120, 2, 0),
        A7(ao, 1993, 2006, 3, A2(uo, 6, 1), 1, 2, 60),
        A7(ao, 1993, 2006, 9, eo(6), 1, 2, 0)
    ]), Rf = x([
        A7(ao, 1970, 1970, 3, to(25), 0, 2, 60),
        A7(ao, 1970, 1970, 5, to(14), 0, 2, 0),
        A7(ao, 1972, 1972, 3, to(23), 0, 2, 60),
        A7(ao, 1972, 1972, 6, to(16), 0, 2, 0),
        A7(ao, 1974, 1974, 0, to(13), 0, 2, 90),
        A7(ao, 1974, 1974, 2, to(10), 0, 2, 30),
        A7(ao, 1974, 1974, 8, to(1), 0, 2, 0),
        A7(ao, 1974, 1974, 11, to(22), 0, 2, 60),
        A7(ao, 1975, 1975, 2, to(30), 0, 2, 0),
        A7(ao, 1976, 1976, 11, to(19), 0, 2, 60),
        A7(ao, 1977, 1977, 2, to(6), 0, 2, 0),
        A7(ao, 1977, 1977, 11, to(4), 0, 2, 60),
        A7(ao, 1978, 1979, 2, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1978, 1978, 11, to(17), 0, 2, 60),
        A7(ao, 1979, 1979, 3, to(29), 0, 2, 60),
        A7(ao, 1980, 1980, 2, to(16), 0, 2, 0),
        A7(ao, 1987, 1987, 11, to(14), 0, 2, 60),
        A7(ao, 1988, 1988, 1, to(28), 0, 2, 0),
        A7(ao, 1988, 1988, 11, to(11), 0, 2, 60),
        A7(ao, 1989, 1989, 2, to(5), 0, 2, 0),
        A7(ao, 1989, 1989, 9, to(29), 0, 2, 60),
        A7(ao, 1990, 1990, 1, to(25), 0, 2, 0),
        A7(ao, 1990, 1991, 9, A2(uo, 6, 21), 0, 2, 60),
        A7(ao, 1991, 1992, 2, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1992, 1992, 9, to(18), 0, 2, 60),
        A7(ao, 1993, 1993, 1, to(28), 0, 2, 0),
        A7(ao, 2004, 2004, 8, to(19), 0, 2, 60),
        A7(ao, 2005, 2005, 2, to(27), 120, 2, 0),
        A7(ao, 2005, 2005, 9, to(9), 120, 2, 60),
        A7(ao, 2006, 2015, 2, A2(uo, 6, 8), 120, 2, 0),
        A7(ao, 2006, 2014, 9, A2(uo, 6, 1), 120, 2, 60)
    ]), Zf = cf, Vf = x([
        A7(ao, 1964, 1975, 9, eo(6), 120, 2, 0),
        A7(ao, 1964, 1975, 3, eo(6), 120, 2, 60)
    ]), Uf = x([
        A7(ao, 1983, 1983, 4, to(8), 0, 2, 60),
        A7(ao, 1984, 1987, 3, eo(6), 0, 2, 60),
        A7(ao, 1983, 1987, 9, eo(6), 0, 2, 0),
        A7(ao, 1988, 1997, 3, A2(uo, 6, 1), 60, 1, 60),
        A7(ao, 1988, 1997, 9, eo(6), 60, 1, 0),
        A7(ao, 2005, 2006, 3, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 2005, 2006, 9, eo(6), 0, 2, 0),
        A7(ao, 2012, 2015, 2, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2012, 2015, 10, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 2017, Fc, 2, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2017, Fc, 10, A2(uo, 6, 1), 120, 2, 0)
    ]), Yf = x([
        A7(ao, 1969, 1969, 2, to(30), 180, 0, 0),
        A7(ao, 1969, 1969, 10, to(23), 240, 0, 60),
        A7(ao, 1970, 1970, 2, to(29), 180, 0, 0),
        A7(ao, 1971, 1971, 2, to(14), 180, 0, 0),
        A7(ao, 1970, 1972, 9, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 1972, 1986, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 1973, 1973, 8, to(30), 240, 0, 60),
        A7(ao, 1974, 1987, 9, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 1987, 1987, 3, to(12), 180, 0, 0),
        A7(ao, 1988, 1990, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 1988, 1989, 9, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 1990, 1990, 8, to(16), 240, 0, 60),
        A7(ao, 1991, 1996, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 1991, 1997, 9, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 1997, 1997, 2, to(30), 180, 0, 0),
        A7(ao, 1998, 1998, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 1998, 1998, 8, to(27), 240, 0, 60),
        A7(ao, 1999, 1999, 3, to(4), 180, 0, 0),
        A7(ao, 1999, 2010, 9, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 2e3, 2007, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 2008, 2008, 2, to(30), 180, 0, 0),
        A7(ao, 2009, 2009, 2, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 2010, 2010, 3, A2(uo, 6, 1), 180, 0, 0),
        A7(ao, 2011, 2011, 4, A2(uo, 6, 2), 180, 0, 0),
        A7(ao, 2011, 2011, 7, A2(uo, 6, 16), 240, 0, 60),
        A7(ao, 2012, 2014, 3, A2(uo, 6, 23), 180, 0, 0),
        A7(ao, 2012, 2014, 8, A2(uo, 6, 2), 240, 0, 60),
        A7(ao, 2016, 2018, 4, A2(uo, 6, 9), 180, 0, 0),
        A7(ao, 2016, 2018, 7, A2(uo, 6, 9), 240, 0, 60),
        A7(ao, 2019, Fc, 3, A2(uo, 6, 2), 180, 0, 0),
        A7(ao, 2019, Fc, 8, A2(uo, 6, 2), 240, 0, 60)
    ]), Qf = x([
        A7(ao, 1969, 1973, 9, eo(6), 0, 2, 30),
        A7(ao, 1970, 1970, 1, to(21), 0, 2, 0),
        A7(ao, 1971, 1971, 0, to(20), 0, 2, 0),
        A7(ao, 1972, 1974, 0, to(21), 0, 2, 0)
    ]), Of = x([
        A7(ao, 1977, 1980, 3, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 1977, 1977, 8, eo(6), 120, 1, 0),
        A7(ao, 1978, 1978, 9, to(1), 120, 1, 0),
        A7(ao, 1979, 1995, 8, eo(6), 120, 1, 0),
        A7(ao, 1981, Fc, 2, eo(6), 120, 1, 60),
        A7(ao, 1996, Fc, 9, eo(6), 120, 1, 0)
    ]), Gf = cf, Jf = cf, Wf = cf, Kf = cf, Xf = cf, ns = x([
        A7(ao, 1987, 1988, 4, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1987, 1988, 8, eo(6), 0, 2, 0),
        A7(ao, 2006, 2006, 4, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 2006, 2006, 7, A2(uo, 0, 1), 0, 2, 0)
    ]), rs = x([
        A7(ao, 1991, 1992, 2, eo(6), 120, 2, 60),
        A7(ao, 1991, 1992, 8, eo(6), 120, 2, 0),
        A7(ao, 1993, 2006, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 1993, 2006, 9, eo(6), 120, 2, 0),
        A7(ao, 2007, Fc, 2, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2007, Fc, 10, A2(uo, 6, 1), 120, 2, 0)
    ]), ts = x([
        A7(ao, 1950, 1973, 3, eo(6), 120, 2, 60),
        A7(ao, 1957, 1973, 9, eo(6), 120, 2, 0)
    ]), es = cf, us = x([
        A7(ao, 1966, 1986, 3, eo(6), 120, 1, 60),
        A7(ao, 1966, 2005, 9, eo(6), 120, 1, 0),
        A7(ao, 1987, 2005, 3, A2(uo, 6, 1), 120, 1, 60)
    ]), as = x([
        A7(ao, 1968, 1985, 9, eo(6), 120, 1, 60),
        A7(ao, 1969, 1971, 2, A2(uo, 6, 8), 120, 1, 0),
        A7(ao, 1972, 1972, 1, eo(6), 120, 1, 0),
        A7(ao, 1973, 1981, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1982, 1983, 2, eo(6), 120, 1, 0),
        A7(ao, 1984, 1986, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1986, 1986, 9, A2(uo, 6, 15), 120, 1, 60),
        A7(ao, 1987, 1990, 2, A2(uo, 6, 15), 120, 1, 0),
        A7(ao, 1987, 1987, 9, A2(uo, 6, 22), 120, 1, 60),
        A7(ao, 1988, 1990, 9, eo(6), 120, 1, 60),
        A7(ao, 1991, 1999, 9, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 1991, 2005, 2, eo(6), 120, 1, 0),
        A7(ao, 2e3, 2e3, 7, eo(6), 120, 1, 60),
        A7(ao, 2001, Fc, 9, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 2006, 2006, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2007, 2007, 2, eo(6), 120, 1, 0),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 1, 0)
    ]), is = x([
        A7(ao, 1974, 1974, 10, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 1975, 1975, 1, eo(6), 120, 1, 0),
        A7(ao, 1975, 1988, 9, eo(6), 120, 1, 60),
        A7(ao, 1976, 1989, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1989, 1989, 9, A2(uo, 6, 8), 120, 1, 60),
        A7(ao, 1990, 2006, 9, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 1990, 2007, 2, A2(uo, 6, 15), 120, 1, 0),
        A7(ao, 2007, Fc, 8, eo(6), 120, 1, 60),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 1, 0)
    ]), cs = function() {
        return no(A2(Bc, h, A2(Ec, 720, Cc(is))));
    }, os = cs, fs = x([
        A7(ao, 2005, Fc, 2, eo(6), 60, 0, 120),
        A7(ao, 2004, Fc, 9, eo(6), 60, 0, 0)
    ]), ss = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, bo(0)), A5(Pc, 1980, 0, 1, 0, 2))
        ]), A2(Ec, 60, Cc(Do))));
    }, ls = ss, ds = function() {
        return no(A2(Bc, h, A2(Ec, 180, bo(0))));
    }, bs = ds, vs = x([
        A7(ao, 1981, 1984, 3, to(1), 0, 2, 60),
        A7(ao, 1981, 1983, 9, to(1), 0, 2, 0),
        A7(ao, 1984, 1995, 8, eo(6), 120, 1, 0),
        A7(ao, 1985, 2010, 2, eo(6), 120, 1, 60),
        A7(ao, 1996, 2010, 9, eo(6), 120, 1, 0)
    ]), ms = x([
        A7(ao, 1973, 1973, 5, to(6), 0, 2, 60),
        A7(ao, 1973, 1975, 9, to(1), 0, 2, 0),
        A7(ao, 1974, 1977, 4, to(1), 0, 2, 60),
        A7(ao, 1976, 1976, 10, to(1), 0, 2, 0),
        A7(ao, 1977, 1977, 9, to(1), 0, 2, 0),
        A7(ao, 1978, 1978, 3, to(30), 0, 2, 60),
        A7(ao, 1978, 1978, 8, to(30), 0, 2, 0),
        A7(ao, 1985, 1985, 3, to(1), 0, 2, 60),
        A7(ao, 1985, 1985, 9, to(1), 0, 2, 0),
        A7(ao, 1986, 1988, 3, A2(uo, 4, 1), 0, 2, 60),
        A7(ao, 1986, 1990, 9, A2(uo, 4, 1), 0, 2, 0),
        A7(ao, 1989, 1989, 4, to(8), 0, 2, 60),
        A7(ao, 1990, 1990, 3, to(27), 0, 2, 60),
        A7(ao, 1991, 1991, 3, to(17), 0, 2, 60),
        A7(ao, 1991, 1991, 8, to(27), 0, 2, 0),
        A7(ao, 1992, 1992, 3, to(10), 0, 2, 60),
        A7(ao, 1992, 1993, 9, A2(uo, 4, 1), 0, 2, 0),
        A7(ao, 1993, 1998, 3, A2(uo, 4, 1), 0, 2, 60),
        A7(ao, 1994, 1994, 8, A2(uo, 4, 15), 0, 2, 0),
        A7(ao, 1995, 1998, 8, A2(uo, 4, 15), 0, 1, 0),
        A7(ao, 1999, 1999, 6, to(1), 0, 1, 60),
        A7(ao, 1999, 2002, 8, eo(4), 0, 1, 0),
        A7(ao, 2e3, 2001, 2, eo(3), 0, 1, 60),
        A7(ao, 2002, 2012, 2, eo(3), 1440, 2, 60),
        A7(ao, 2003, 2003, 9, to(24), 0, 1, 0),
        A7(ao, 2004, 2004, 9, to(15), 0, 1, 0),
        A7(ao, 2005, 2005, 8, eo(4), 0, 1, 0),
        A7(ao, 2006, 2011, 9, eo(4), 0, 1, 0),
        A7(ao, 2013, 2013, 11, to(20), 0, 2, 0),
        A7(ao, 2014, Fc, 2, eo(3), 1440, 2, 60),
        A7(ao, 2014, Fc, 9, eo(4), 0, 1, 0)
    ]), ps = x([
        A7(ao, 1981, 1984, 3, to(1), 0, 2, 60),
        A7(ao, 1981, 1983, 9, to(1), 0, 2, 0),
        A7(ao, 1984, 1995, 8, eo(6), 120, 1, 0),
        A7(ao, 1985, 2010, 2, eo(6), 120, 1, 60),
        A7(ao, 1996, 2010, 9, eo(6), 120, 1, 0)
    ]), $s = x([
        A7(ao, 1982, 1982, 4, to(1), 0, 2, 60),
        A7(ao, 1982, 1984, 9, to(1), 0, 2, 0),
        A7(ao, 1983, 1983, 2, to(31), 0, 2, 60),
        A7(ao, 1984, 1985, 3, to(1), 0, 2, 60),
        A7(ao, 1985, 1990, 8, eo(6), 60, 1, 0),
        A7(ao, 1986, 1990, 2, eo(6), 60, 1, 60),
        A7(ao, 1991, 2007, 3, to(1), 180, 1, 60),
        A7(ao, 1991, 2007, 9, to(1), 180, 1, 0)
    ]), hs = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 240, bo(0)), A5(Pc, 1972, 5, 1, 0, 2))
        ]), A2(Ec, 180, bo(0))));
    }, gs = hs, ws = x([
        A7(ao, 1997, 2015, 2, eo(6), 240, 2, 60),
        A7(ao, 1997, 2015, 9, eo(6), 300, 2, 0)
    ]), xs = x([
        A7(ao, 1981, Fc, 2, eo(6), 60, 0, 60),
        A7(ao, 1979, 1995, 8, eo(6), 60, 0, 0),
        A7(ao, 1996, Fc, 9, eo(6), 60, 0, 0)
    ]), ks = function() {
        return no(A2(Bc, h, A2(Ec, 420, bo(0))));
    }, ys = x([
        A7(ao, 1972, 1972, 5, to(22), 0, 2, 60),
        A7(ao, 1972, 1977, 9, to(1), 0, 2, 0),
        A7(ao, 1973, 1977, 4, to(1), 0, 2, 60),
        A7(ao, 1978, 1978, 3, to(30), 0, 2, 60),
        A7(ao, 1978, 1978, 8, to(30), 0, 2, 0),
        A7(ao, 1984, 1987, 4, to(1), 0, 2, 60),
        A7(ao, 1984, 1991, 9, to(16), 0, 2, 0),
        A7(ao, 1988, 1988, 5, to(1), 0, 2, 60),
        A7(ao, 1989, 1989, 4, to(10), 0, 2, 60),
        A7(ao, 1990, 1992, 4, to(1), 0, 2, 60),
        A7(ao, 1992, 1992, 9, to(4), 0, 2, 0),
        A7(ao, 1993, Fc, 2, eo(6), 0, 2, 60),
        A7(ao, 1993, 1998, 8, eo(6), 0, 2, 0),
        A7(ao, 1999, Fc, 9, eo(6), 0, 2, 0)
    ]), _s = x([
        A7(ao, 1992, 1996, 3, A2(uo, 6, 7), 0, 1, 60),
        A7(ao, 1992, 1996, 8, eo(6), 0, 2, 0),
        A7(ao, 1997, 2005, 2, eo(6), 150, 2, 60),
        A7(ao, 1997, 2004, 9, eo(6), 150, 2, 0)
    ]), As = x([
        A7(ao, 1983, 1984, 3, to(1), 0, 2, 60),
        A7(ao, 1983, 1983, 9, to(1), 0, 2, 0),
        A7(ao, 1985, 1998, 2, eo(6), 0, 2, 60),
        A7(ao, 1984, 1998, 8, eo(6), 0, 2, 0),
        A7(ao, 2001, 2001, 3, eo(5), 120, 2, 60),
        A7(ao, 2001, 2006, 8, eo(5), 120, 2, 0),
        A7(ao, 2002, 2006, 2, eo(5), 120, 2, 60),
        A7(ao, 2015, 2016, 2, eo(5), 120, 2, 60),
        A7(ao, 2015, 2016, 8, eo(5), 0, 2, 0)
    ]), Cs = x([
        A7(ao, 1966, 1976, 9, to(1), 120, 2, 0),
        A7(ao, 1967, 1978, 4, to(1), 120, 2, 60),
        A7(ao, 1977, 1978, 8, to(1), 120, 2, 0),
        A7(ao, 1983, 1984, 3, to(9), 120, 2, 60),
        A7(ao, 1983, 1984, 9, to(1), 120, 2, 0),
        A7(ao, 1986, 1986, 1, to(16), 120, 2, 60),
        A7(ao, 1986, 1986, 9, to(9), 120, 2, 0),
        A7(ao, 1987, 1987, 2, to(1), 120, 2, 60),
        A7(ao, 1987, 1988, 9, to(31), 120, 2, 0),
        A7(ao, 1988, 1988, 2, to(15), 120, 2, 60),
        A7(ao, 1989, 1989, 2, to(31), 120, 2, 60),
        A7(ao, 1989, 1989, 9, to(1), 120, 2, 0),
        A7(ao, 1990, 1990, 3, to(1), 120, 2, 60),
        A7(ao, 1990, 1990, 8, to(30), 120, 2, 0),
        A7(ao, 1991, 1991, 3, to(1), 0, 2, 60),
        A7(ao, 1991, 1992, 9, to(1), 0, 2, 0),
        A7(ao, 1992, 1992, 3, to(8), 0, 2, 60),
        A7(ao, 1993, 1993, 2, to(26), 0, 2, 60),
        A7(ao, 1993, 1993, 8, to(25), 0, 2, 0),
        A7(ao, 1994, 1996, 3, to(1), 0, 2, 60),
        A7(ao, 1994, 2005, 9, to(1), 0, 2, 0),
        A7(ao, 1997, 1998, 2, eo(0), 0, 2, 60),
        A7(ao, 1999, 2006, 3, to(1), 0, 2, 60),
        A7(ao, 2006, 2006, 8, to(22), 0, 2, 0),
        A7(ao, 2007, 2007, 2, eo(4), 0, 2, 60),
        A7(ao, 2007, 2007, 10, A2(uo, 4, 1), 0, 2, 0),
        A7(ao, 2008, 2008, 3, A2(uo, 4, 1), 0, 2, 60),
        A7(ao, 2008, 2008, 10, to(1), 0, 2, 0),
        A7(ao, 2009, 2009, 2, eo(4), 0, 2, 60),
        A7(ao, 2010, 2011, 3, A2(uo, 4, 1), 0, 2, 60),
        A7(ao, 2012, Fc, 2, eo(4), 0, 2, 60),
        A7(ao, 2009, Fc, 9, eo(4), 0, 2, 0)
    ]), Bs = x([
        A7(ao, 2009, 2009, 5, to(19), 1380, 2, 60),
        A7(ao, 2009, 2009, 11, to(31), 1440, 2, 0)
    ]), Es = function() {
        return no(A2(Bc, h, A2(Ec, 240, bo(0))));
    }, Ds = x([
        A7(ao, 1975, 1975, 3, to(13), 0, 2, 60),
        A7(ao, 1975, 1975, 9, to(12), 0, 2, 0),
        A7(ao, 1976, 1976, 4, to(15), 0, 2, 60),
        A7(ao, 1976, 1976, 9, to(11), 0, 2, 0),
        A7(ao, 1977, 1980, 3, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1977, 1977, 8, to(25), 0, 2, 0),
        A7(ao, 1978, 1978, 9, to(2), 0, 2, 0),
        A7(ao, 1979, 1997, 8, eo(6), 0, 2, 0),
        A7(ao, 1981, 1998, 2, eo(6), 0, 2, 60)
    ]), qs = x([
        A7(ao, 1999, 2005, 3, A2(uo, 4, 15), 0, 2, 60),
        A7(ao, 1999, 2003, 9, A2(uo, 4, 15), 0, 2, 0),
        A7(ao, 2004, 2004, 9, to(1), 60, 2, 0),
        A7(ao, 2005, 2005, 9, to(4), 120, 2, 0),
        A7(ao, 2006, 2007, 3, to(1), 0, 2, 60),
        A7(ao, 2006, 2006, 8, to(22), 0, 2, 0),
        A7(ao, 2007, 2007, 8, to(13), 120, 2, 0),
        A7(ao, 2008, 2009, 2, eo(4), 0, 2, 60),
        A7(ao, 2008, 2008, 8, to(1), 0, 2, 0),
        A7(ao, 2009, 2009, 8, to(4), 60, 2, 0),
        A7(ao, 2010, 2010, 2, to(26), 0, 2, 60),
        A7(ao, 2010, 2010, 7, to(11), 0, 2, 0),
        A7(ao, 2011, 2011, 3, to(1), 1, 2, 60),
        A7(ao, 2011, 2011, 7, to(1), 0, 2, 0),
        A7(ao, 2011, 2011, 7, to(30), 0, 2, 60),
        A7(ao, 2011, 2011, 8, to(30), 0, 2, 0),
        A7(ao, 2012, 2014, 2, eo(3), 1440, 2, 60),
        A7(ao, 2012, 2012, 8, to(21), 60, 2, 0),
        A7(ao, 2013, 2013, 8, to(27), 0, 2, 0),
        A7(ao, 2014, 2014, 9, to(24), 0, 2, 0),
        A7(ao, 2015, 2015, 2, to(28), 0, 2, 60),
        A7(ao, 2015, 2015, 9, to(23), 60, 2, 0),
        A7(ao, 2016, 2018, 2, A2(uo, 5, 24), 60, 2, 60),
        A7(ao, 2016, 2018, 9, A2(uo, 5, 24), 60, 2, 0),
        A7(ao, 2019, 2019, 2, to(29), 0, 2, 60),
        A7(ao, 2019, 2019, 9, A2(uo, 5, 24), 0, 2, 0),
        A7(ao, 2020, Fc, 2, A2(uo, 5, 24), 0, 2, 60),
        A7(ao, 2020, Fc, 9, A2(uo, 5, 24), 60, 2, 0)
    ]), Fs = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ps = x([
        A7(ao, 1974, 1974, 6, to(7), 0, 2, 60),
        A7(ao, 1974, 1974, 9, to(13), 0, 2, 0),
        A7(ao, 1975, 1975, 3, to(20), 0, 2, 60),
        A7(ao, 1975, 1975, 7, to(31), 0, 2, 0),
        A7(ao, 1980, 1980, 7, to(2), 0, 2, 60),
        A7(ao, 1980, 1980, 8, to(13), 60, 2, 0),
        A7(ao, 1984, 1984, 4, to(5), 0, 2, 60),
        A7(ao, 1984, 1984, 7, to(25), 60, 2, 0),
        A7(ao, 1985, 1985, 3, to(14), 0, 2, 60),
        A7(ao, 1985, 1985, 8, to(15), 0, 2, 0),
        A7(ao, 1986, 1986, 4, to(18), 0, 2, 60),
        A7(ao, 1986, 1986, 8, to(7), 0, 2, 0),
        A7(ao, 1987, 1987, 3, to(15), 0, 2, 60),
        A7(ao, 1987, 1987, 8, to(13), 0, 2, 0),
        A7(ao, 1988, 1988, 3, to(10), 0, 2, 60),
        A7(ao, 1988, 1988, 8, to(4), 0, 2, 0),
        A7(ao, 1989, 1989, 3, to(30), 0, 2, 60),
        A7(ao, 1989, 1989, 8, to(3), 0, 2, 0),
        A7(ao, 1990, 1990, 2, to(25), 0, 2, 60),
        A7(ao, 1990, 1990, 7, to(26), 0, 2, 0),
        A7(ao, 1991, 1991, 2, to(24), 0, 2, 60),
        A7(ao, 1991, 1991, 8, to(1), 0, 2, 0),
        A7(ao, 1992, 1992, 2, to(29), 0, 2, 60),
        A7(ao, 1992, 1992, 8, to(6), 0, 2, 0),
        A7(ao, 1993, 1993, 3, to(2), 0, 2, 60),
        A7(ao, 1993, 1993, 8, to(5), 0, 2, 0),
        A7(ao, 1994, 1994, 3, to(1), 0, 2, 60),
        A7(ao, 1994, 1994, 7, to(28), 0, 2, 0),
        A7(ao, 1995, 1995, 2, to(31), 0, 2, 60),
        A7(ao, 1995, 1995, 8, to(3), 0, 2, 0),
        A7(ao, 1996, 1996, 2, to(15), 0, 2, 60),
        A7(ao, 1996, 1996, 8, to(16), 0, 2, 0),
        A7(ao, 1997, 1997, 2, to(21), 0, 2, 60),
        A7(ao, 1997, 1997, 8, to(14), 0, 2, 0),
        A7(ao, 1998, 1998, 2, to(20), 0, 2, 60),
        A7(ao, 1998, 1998, 8, to(6), 0, 2, 0),
        A7(ao, 1999, 1999, 3, to(2), 120, 2, 60),
        A7(ao, 1999, 1999, 8, to(3), 120, 2, 0),
        A7(ao, 2e3, 2e3, 3, to(14), 120, 2, 60),
        A7(ao, 2e3, 2e3, 9, to(6), 60, 2, 0),
        A7(ao, 2001, 2001, 3, to(9), 60, 2, 60),
        A7(ao, 2001, 2001, 8, to(24), 60, 2, 0),
        A7(ao, 2002, 2002, 2, to(29), 60, 2, 60),
        A7(ao, 2002, 2002, 9, to(7), 60, 2, 0),
        A7(ao, 2003, 2003, 2, to(28), 60, 2, 60),
        A7(ao, 2003, 2003, 9, to(3), 60, 2, 0),
        A7(ao, 2004, 2004, 3, to(7), 60, 2, 60),
        A7(ao, 2004, 2004, 8, to(22), 60, 2, 0),
        A7(ao, 2005, 2012, 3, A2(Fs, 4, 1), 120, 2, 60),
        A7(ao, 2005, 2005, 9, to(9), 120, 2, 0),
        A7(ao, 2006, 2006, 9, to(1), 120, 2, 0),
        A7(ao, 2007, 2007, 8, to(16), 120, 2, 0),
        A7(ao, 2008, 2008, 9, to(5), 120, 2, 0),
        A7(ao, 2009, 2009, 8, to(27), 120, 2, 0),
        A7(ao, 2010, 2010, 8, to(12), 120, 2, 0),
        A7(ao, 2011, 2011, 9, to(2), 120, 2, 0),
        A7(ao, 2012, 2012, 8, to(23), 120, 2, 0),
        A7(ao, 2013, Fc, 2, A2(uo, 4, 23), 120, 2, 60),
        A7(ao, 2013, Fc, 9, eo(6), 120, 2, 0)
    ]), zs = x([
        A7(ao, 1965, 1976, 3, A2(uo, 6, 16), 210, 2, 60),
        A7(ao, 1965, 1976, 9, A2(uo, 6, 16), 210, 2, 0),
        A7(ao, 1973, 1973, 11, to(30), 210, 2, 60),
        A7(ao, 1979, 1979, 4, to(13), 210, 2, 60),
        A7(ao, 1979, 1979, 9, to(21), 210, 2, 0)
    ]), js = x([
        A7(ao, 1973, 1973, 5, to(3), 60, 2, 60),
        A7(ao, 1973, 1976, 9, A2(uo, 6, 31), 120, 2, 0),
        A7(ao, 1974, 1974, 2, to(31), 120, 2, 60),
        A7(ao, 1975, 1975, 2, to(22), 120, 2, 60),
        A7(ao, 1976, 1976, 2, to(21), 120, 2, 60),
        A7(ao, 1977, 1978, 3, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 1977, 1978, 9, A2(uo, 6, 15), 120, 2, 0),
        A7(ao, 1978, 1978, 5, to(29), 0, 2, 0),
        A7(ao, 1983, 1983, 6, to(31), 120, 2, 60),
        A7(ao, 1983, 1983, 9, to(2), 120, 2, 0),
        A7(ao, 1985, 1985, 3, to(20), 60, 1, 60),
        A7(ao, 1985, 1985, 8, to(28), 60, 1, 0),
        A7(ao, 1986, 1993, 2, eo(6), 60, 1, 60),
        A7(ao, 1986, 1995, 8, eo(6), 60, 1, 0),
        A7(ao, 1994, 1994, 2, to(20), 60, 1, 60),
        A7(ao, 1995, 2006, 2, eo(6), 60, 1, 60),
        A7(ao, 1996, 2006, 9, eo(6), 60, 1, 0)
    ]), Ss = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 120, Cc(js)), A5(Pc, 1978, 5, 29, 0, 2)),
            b(A2(Ec, 180, Cc(js)), A5(Pc, 1984, 10, 1, 120, 2)),
            b(A2(Ec, 120, Cc(js)), A5(Pc, 2007, 0, 1, 0, 2)),
            b(A2(Ec, 120, Cc(Do)), A5(Pc, 2011, 2, 27, 60, 0)),
            b(A2(Ec, 120, bo(0)), A5(Pc, 2011, 2, 28, 60, 0)),
            b(A2(Ec, 120, Cc(Do)), A5(Pc, 2014, 2, 30, 60, 0)),
            b(A2(Ec, 120, bo(0)), A5(Pc, 2014, 2, 31, 60, 0)),
            b(A2(Ec, 120, Cc(Do)), A5(Pc, 2015, 9, 25, 60, 0)),
            b(A2(Ec, 120, bo(60)), A5(Pc, 2015, 10, 8, 60, 0)),
            b(A2(Ec, 120, Cc(Do)), A5(Pc, 2016, 8, 7, 0, 2))
        ]), A2(Ec, 180, bo(0))));
    }, Ls = Ss, Ms = x([
        A7(ao, 2002, 2002, 3, A2(uo, 6, 2), 0, 2, 60),
        A7(ao, 2002, 2002, 9, A2(uo, 6, 2), 0, 2, 0),
        A7(ao, 2008, 2008, 5, to(1), 0, 2, 60),
        A7(ao, 2008, 2009, 10, to(1), 0, 2, 0),
        A7(ao, 2009, 2009, 3, to(15), 0, 2, 60)
    ]), Ns = ds, Hs = x([
        A7(ao, 1965, 1973, 3, A2(uo, 6, 16), 210, 2, 60),
        A7(ao, 1967, 1976, 9, A2(uo, 6, 16), 210, 2, 0),
        A7(ao, 1973, 1973, 11, to(30), 210, 2, 60),
        A7(ao, 1975, 1976, 3, A2(uo, 6, 16), 210, 2, 60),
        A7(ao, 1979, 1979, 4, to(13), 210, 2, 60),
        A7(ao, 1979, 1979, 9, A2(uo, 6, 16), 210, 2, 0)
    ]), Ts = x([
        A7(ao, 1978, 1978, 2, to(22), 0, 2, 60),
        A7(ao, 1978, 1978, 8, to(21), 0, 2, 0)
    ]), Is = Es, Rs = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 120, Cc(Ds)), A5(Pc, 1998, 8, 1, 0, 2))
        ]), A2(Ec, 120, Cc(xs))));
    }, Zs = ks, Vs = x([
        A7(ao, 1987, 1988, 4, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 1987, 1988, 9, A2(uo, 6, 8), 180, 2, 0)
    ]), Us = x([
        A7(ao, 1986, 1986, 4, to(4), 120, 2, 60),
        A7(ao, 1986, 1991, 8, A2(uo, 6, 11), 120, 2, 0),
        A7(ao, 1987, 1991, 3, A2(uo, 6, 11), 120, 2, 60)
    ]), Ys = x([
        A7(ao, 1974, 1975, 3, to(1), 0, 2, 60),
        A7(ao, 1974, 1975, 9, to(1), 0, 2, 0),
        A7(ao, 1979, 1979, 6, to(1), 0, 2, 60),
        A7(ao, 1979, 1979, 9, to(1), 0, 2, 0)
    ]), Qs = x([
        A7(ao, 1981, Fc, 2, eo(6), 0, 2, 60),
        A7(ao, 1979, 1995, 8, eo(6), 0, 2, 0),
        A7(ao, 1996, Fc, 9, eo(6), 0, 2, 0)
    ]), Os = x([
        A7(ao, 1978, 1980, 2, to(20), 1440, 2, 60),
        A7(ao, 1978, 1978, 9, to(20), 1440, 2, 0),
        A7(ao, 1979, 1979, 8, to(18), 1440, 2, 0),
        A7(ao, 1980, 1980, 8, to(22), 1440, 2, 0),
        A7(ao, 1991, 1991, 4, to(2), 1440, 2, 60),
        A7(ao, 1992, 1995, 2, to(21), 1440, 2, 60),
        A7(ao, 1991, 1995, 8, to(21), 1440, 2, 0),
        A7(ao, 1996, 1996, 2, to(20), 1440, 2, 60),
        A7(ao, 1996, 1996, 8, to(20), 1440, 2, 0),
        A7(ao, 1997, 1999, 2, to(21), 1440, 2, 60),
        A7(ao, 1997, 1999, 8, to(21), 1440, 2, 0),
        A7(ao, 2e3, 2e3, 2, to(20), 1440, 2, 60),
        A7(ao, 2e3, 2e3, 8, to(20), 1440, 2, 0),
        A7(ao, 2001, 2003, 2, to(21), 1440, 2, 60),
        A7(ao, 2001, 2003, 8, to(21), 1440, 2, 0),
        A7(ao, 2004, 2004, 2, to(20), 1440, 2, 60),
        A7(ao, 2004, 2004, 8, to(20), 1440, 2, 0),
        A7(ao, 2005, 2005, 2, to(21), 1440, 2, 60),
        A7(ao, 2005, 2005, 8, to(21), 1440, 2, 0),
        A7(ao, 2008, 2008, 2, to(20), 1440, 2, 60),
        A7(ao, 2008, 2008, 8, to(20), 1440, 2, 0),
        A7(ao, 2009, 2011, 2, to(21), 1440, 2, 60),
        A7(ao, 2009, 2011, 8, to(21), 1440, 2, 0),
        A7(ao, 2012, 2012, 2, to(20), 1440, 2, 60),
        A7(ao, 2012, 2012, 8, to(20), 1440, 2, 0),
        A7(ao, 2013, 2015, 2, to(21), 1440, 2, 60),
        A7(ao, 2013, 2015, 8, to(21), 1440, 2, 0),
        A7(ao, 2016, 2016, 2, to(20), 1440, 2, 60),
        A7(ao, 2016, 2016, 8, to(20), 1440, 2, 0),
        A7(ao, 2017, 2019, 2, to(21), 1440, 2, 60),
        A7(ao, 2017, 2019, 8, to(21), 1440, 2, 0),
        A7(ao, 2020, 2020, 2, to(20), 1440, 2, 60),
        A7(ao, 2020, 2020, 8, to(20), 1440, 2, 0),
        A7(ao, 2021, 2023, 2, to(21), 1440, 2, 60),
        A7(ao, 2021, 2023, 8, to(21), 1440, 2, 0),
        A7(ao, 2024, 2024, 2, to(20), 1440, 2, 60),
        A7(ao, 2024, 2024, 8, to(20), 1440, 2, 0),
        A7(ao, 2025, 2027, 2, to(21), 1440, 2, 60),
        A7(ao, 2025, 2027, 8, to(21), 1440, 2, 0),
        A7(ao, 2028, 2029, 2, to(20), 1440, 2, 60),
        A7(ao, 2028, 2029, 8, to(20), 1440, 2, 0),
        A7(ao, 2030, 2031, 2, to(21), 1440, 2, 60),
        A7(ao, 2030, 2031, 8, to(21), 1440, 2, 0),
        A7(ao, 2032, 2033, 2, to(20), 1440, 2, 60),
        A7(ao, 2032, 2033, 8, to(20), 1440, 2, 0),
        A7(ao, 2034, 2035, 2, to(21), 1440, 2, 60),
        A7(ao, 2034, 2035, 8, to(21), 1440, 2, 0),
        A7(ao, 2036, 2037, 2, to(20), 1440, 2, 60),
        A7(ao, 2036, 2037, 8, to(20), 1440, 2, 0)
    ]), Gs = ks, Js = x([
        A7(ao, 2011, 2011, 2, eo(6), 120, 1, 60),
        A7(ao, 2011, 2011, 9, eo(6), 120, 1, 0)
    ]), Ws = x([
        A7(ao, 1977, 1977, 2, to(27), 0, 1, 60),
        A7(ao, 1977, 1977, 8, to(25), 0, 1, 0),
        A7(ao, 1978, 1979, 3, A2(uo, 6, 1), 0, 1, 60),
        A7(ao, 1978, 1978, 9, to(1), 0, 1, 0),
        A7(ao, 1979, 1982, 8, eo(6), 60, 1, 0),
        A7(ao, 1980, 1980, 2, eo(6), 0, 1, 60),
        A7(ao, 1981, 1982, 2, eo(6), 60, 1, 60),
        A7(ao, 1983, 1983, 2, eo(6), 120, 1, 60)
    ]), Ks = x([
        A7(ao, 1977, 1980, 3, A2(uo, 6, 1), 60, 1, 60),
        A7(ao, 1977, 1977, 8, eo(6), 60, 1, 0),
        A7(ao, 1978, 1978, 9, to(1), 60, 1, 0),
        A7(ao, 1979, 1995, 8, eo(6), 60, 1, 0),
        A7(ao, 1981, Fc, 2, eo(6), 60, 1, 60),
        A7(ao, 1996, Fc, 9, eo(6), 60, 1, 0)
    ]), Xs = vo, nl = x([
        A7(ao, 1983, 1983, 8, eo(6), 0, 2, 60),
        A7(ao, 1984, 1985, 3, eo(6), 0, 2, 0),
        A7(ao, 1984, 1984, 8, to(16), 0, 2, 60),
        A7(ao, 1985, 2e3, 8, A2(uo, 6, 9), 0, 2, 60),
        A7(ao, 1986, 2e3, 3, A2(uo, 6, 16), 0, 2, 0),
        A7(ao, 2001, 2010, 3, A2(uo, 6, 15), 120, 2, 0),
        A7(ao, 2001, 2010, 8, A2(uo, 6, 1), 120, 2, 60)
    ]), rl = x([
        A7(ao, 1971, 1985, 9, eo(6), 120, 1, 60),
        A7(ao, 1986, 1986, 9, to(19), 120, 1, 60),
        A7(ao, 1987, 2007, 9, eo(6), 120, 1, 60),
        A7(ao, 1972, 1972, 1, to(27), 120, 1, 0),
        A7(ao, 1973, 1985, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1986, 1990, 2, A2(uo, 6, 15), 120, 1, 0),
        A7(ao, 1991, 1991, 2, to(3), 120, 1, 0),
        A7(ao, 1992, 1992, 2, to(22), 120, 1, 0),
        A7(ao, 1993, 1993, 2, to(7), 120, 1, 0),
        A7(ao, 1994, 1994, 2, to(20), 120, 1, 0),
        A7(ao, 1995, 2005, 2, eo(6), 120, 1, 0),
        A7(ao, 2006, 2006, 3, to(2), 120, 1, 0),
        A7(ao, 2007, 2007, 2, eo(6), 120, 1, 0),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2008, Fc, 9, A2(uo, 6, 1), 120, 1, 60)
    ]), tl = x([
        A7(ao, 1971, 1971, 9, eo(6), 120, 1, 60),
        A7(ao, 1972, 1972, 1, eo(6), 120, 1, 0),
        A7(ao, 1989, 1991, 9, eo(6), 120, 1, 60),
        A7(ao, 1990, 1992, 2, A2(uo, 6, 1), 120, 1, 0)
    ]), el = x([
        A7(ao, 1971, 1985, 9, eo(6), 120, 1, 60),
        A7(ao, 1972, 1972, 1, to(27), 120, 1, 0),
        A7(ao, 1973, 1981, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1982, 1982, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1983, 1985, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1986, 1989, 2, A2(uo, 6, 15), 120, 1, 0),
        A7(ao, 1986, 1986, 9, to(19), 120, 1, 60),
        A7(ao, 1987, 1999, 9, eo(6), 120, 1, 60),
        A7(ao, 1990, 1995, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1996, 2005, 2, eo(6), 120, 1, 0),
        A7(ao, 2e3, 2e3, 7, eo(6), 120, 1, 60),
        A7(ao, 2001, 2007, 9, eo(6), 120, 1, 60),
        A7(ao, 2006, 2006, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2007, 2007, 2, eo(6), 120, 1, 0),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2008, Fc, 9, A2(uo, 6, 1), 120, 1, 60)
    ]), ul = x([
        A7(ao, 1974, 1974, 9, eo(6), 120, 1, 60),
        A7(ao, 1975, 1975, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1983, 1983, 9, eo(6), 120, 1, 60),
        A7(ao, 1984, 1984, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1991, 1991, 10, to(17), 120, 1, 60),
        A7(ao, 1992, 1992, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2006, 2006, 11, to(3), 120, 1, 60),
        A7(ao, 2007, 2009, 2, eo(6), 120, 1, 0),
        A7(ao, 2007, 2008, 9, eo(6), 120, 1, 60)
    ]), al = x([
        A7(ao, 1992, 1993, 9, eo(6), 120, 1, 60),
        A7(ao, 1993, 1994, 2, A2(uo, 6, 1), 120, 1, 0)
    ]), il = x([
        A7(ao, 1981, 1984, 9, eo(6), 120, 2, 60),
        A7(ao, 1982, 1985, 2, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 1985, 1985, 9, eo(6), 120, 2, 30),
        A7(ao, 1986, 1989, 2, A2(uo, 6, 15), 120, 2, 0),
        A7(ao, 1986, 1986, 9, to(19), 120, 2, 30),
        A7(ao, 1987, 1999, 9, eo(6), 120, 2, 30),
        A7(ao, 1990, 1995, 2, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 1996, 2005, 2, eo(6), 120, 2, 0),
        A7(ao, 2e3, 2e3, 7, eo(6), 120, 2, 30),
        A7(ao, 2001, 2007, 9, eo(6), 120, 2, 30),
        A7(ao, 2006, 2006, 3, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 2007, 2007, 2, eo(6), 120, 2, 0),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 2008, Fc, 9, A2(uo, 6, 1), 120, 2, 30)
    ]), cl = x([
        A7(ao, 1971, 1985, 9, eo(6), 120, 1, 60),
        A7(ao, 1972, 1972, 1, eo(6), 120, 1, 0),
        A7(ao, 1973, 1985, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1986, 1990, 2, A2(uo, 6, 15), 120, 1, 0),
        A7(ao, 1986, 1987, 9, A2(uo, 6, 15), 120, 1, 60),
        A7(ao, 1988, 1999, 9, eo(6), 120, 1, 60),
        A7(ao, 1991, 1994, 2, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 1995, 2005, 2, eo(6), 120, 1, 0),
        A7(ao, 2e3, 2e3, 7, eo(6), 120, 1, 60),
        A7(ao, 2001, 2007, 9, eo(6), 120, 1, 60),
        A7(ao, 2006, 2006, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2007, 2007, 2, eo(6), 120, 1, 0),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 120, 1, 0),
        A7(ao, 2008, Fc, 9, A2(uo, 6, 1), 120, 1, 60)
    ]), ol = x([
        A7(ao, 1975, 1975, 3, to(12), 0, 1, 60),
        A7(ao, 1975, 1975, 10, to(26), 0, 1, 0),
        A7(ao, 1976, 1976, 3, to(11), 120, 1, 60),
        A7(ao, 1976, 1976, 9, to(10), 120, 1, 0),
        A7(ao, 1977, 1978, 3, A2(uo, 6, 1), 120, 1, 60),
        A7(ao, 1977, 1977, 8, to(26), 120, 1, 0),
        A7(ao, 1978, 1978, 8, to(24), 240, 2, 0),
        A7(ao, 1979, 1979, 3, to(1), 540, 2, 60),
        A7(ao, 1979, 1979, 8, to(29), 120, 2, 0),
        A7(ao, 1980, 1980, 3, to(1), 0, 2, 60),
        A7(ao, 1980, 1980, 8, to(28), 0, 2, 0)
    ]), fl = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, bo(0)), A5(Pc, 1982, 10, 27, 0, 2))
        ]), A2(Ec, 60, Cc(Do))));
    }, sl = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, bo(0)), A5(Pc, 1979, 0, 1, 0, 2))
        ]), A2(Ec, 60, Cc(Do))));
    }, ll = sl, dl = x([
        A7(ao, 1977, 1980, 3, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1977, 1977, 8, eo(6), 0, 2, 0),
        A7(ao, 1978, 1978, 9, to(1), 0, 2, 0),
        A7(ao, 1979, 1995, 8, eo(6), 0, 2, 0),
        A7(ao, 1981, Fc, 2, eo(6), 0, 2, 60),
        A7(ao, 1996, Fc, 9, eo(6), 0, 2, 0)
    ]), bl = x([
        A7(ao, 1979, 1979, 4, to(27), 0, 2, 60),
        A7(ao, 1979, 1979, 8, eo(6), 0, 2, 0),
        A7(ao, 1980, 1980, 3, to(5), 1380, 2, 60),
        A7(ao, 1980, 1980, 8, eo(6), 60, 2, 0),
        A7(ao, 1991, 1993, 2, eo(6), 0, 1, 60),
        A7(ao, 1991, 1993, 8, eo(6), 0, 1, 0)
    ]), vl = x([
        A7(ao, 1980, 1980, 3, to(6), 0, 2, 60),
        A7(ao, 1980, 1980, 8, to(28), 60, 2, 0),
        A7(ao, 1981, 1983, 2, eo(6), 0, 2, 60),
        A7(ao, 1981, 1983, 8, eo(6), 60, 2, 0)
    ]), ml = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, bo(0)), A5(Pc, 1981, 0, 1, 0, 2))
        ]), A2(Ec, 60, Cc(Do))));
    }, pl = ml, $l = x([
        A7(ao, 1997, Fc, 2, eo(6), 120, 2, 60),
        A7(ao, 1997, Fc, 9, eo(6), 180, 2, 0)
    ]), hl = x([
        A7(ao, 1971, 1971, 9, to(31), 120, 0, -60),
        A7(ao, 1972, 1980, 2, A2(uo, 6, 16), 120, 0, 0),
        A7(ao, 1972, 1980, 9, A2(uo, 6, 23), 120, 0, -60),
        A7(ao, 1981, Fc, 2, eo(6), 60, 0, 0),
        A7(ao, 1981, 1989, 9, A2(uo, 6, 23), 60, 0, -60),
        A7(ao, 1990, 1995, 9, A2(uo, 6, 22), 60, 0, -60),
        A7(ao, 1996, Fc, 9, eo(6), 60, 0, -60)
    ]), gl = x([
        A7(ao, 1972, 1980, 2, A2(uo, 6, 16), 120, 1, 60),
        A7(ao, 1972, 1980, 9, A2(uo, 6, 23), 120, 1, 0),
        A7(ao, 1981, 1995, 2, eo(6), 60, 0, 60),
        A7(ao, 1981, 1989, 9, A2(uo, 6, 23), 60, 0, 0),
        A7(ao, 1990, 1995, 9, A2(uo, 6, 22), 60, 0, 0)
    ]), wl = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, bo(0)), A5(Pc, 1971, 9, 31, 120, 0)),
            b(A2(Ec, 0, Cc(gl)), A5(Pc, 1996, 0, 1, 0, 2))
        ]), A2(Ec, 0, Cc(Do))));
    }, xl = wl, kl = x([
        A7(ao, 1981, 1982, 2, eo(6), 120, 2, 60),
        A7(ao, 1981, 1982, 8, eo(6), 180, 2, 0)
    ]), yl = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 120, Cc(kl)), A5(Pc, 1983, 0, 1, 0, 2))
        ]), A2(Ec, 120, Cc(Do))));
    }, _l = wl, Al = wl, Cl = fl, Bl = x([
        A7(ao, 1974, 1975, 3, A2(uo, 5, 12), 1380, 2, 60),
        A7(ao, 1974, 1975, 9, A2(uo, 6, 1), 60, 2, 0),
        A7(ao, 1976, 1976, 2, to(27), 1380, 2, 60),
        A7(ao, 1976, 1977, 8, eo(6), 60, 2, 0),
        A7(ao, 1977, 1977, 3, to(2), 1380, 2, 60),
        A7(ao, 1978, 1978, 3, to(2), 120, 1, 60),
        A7(ao, 1978, 1978, 9, to(1), 120, 1, 0)
    ]), El = x([
        A7(ao, 1967, 1969, 8, A2(uo, 6, 22), 0, 1, 0),
        A7(ao, 1969, 1969, 5, to(1), 0, 1, 60),
        A7(ao, 1970, 1970, 4, to(31), 0, 1, 60),
        A7(ao, 1970, 1970, 8, eo(6), 0, 1, 0),
        A7(ao, 1971, 1972, 4, A2(uo, 6, 22), 0, 1, 60),
        A7(ao, 1971, 1971, 8, eo(6), 0, 1, 0),
        A7(ao, 1972, 1972, 9, to(1), 0, 1, 0),
        A7(ao, 1973, 1973, 5, to(3), 0, 1, 60),
        A7(ao, 1973, 1974, 8, eo(6), 0, 1, 0),
        A7(ao, 1974, 1974, 4, to(26), 0, 1, 60),
        A7(ao, 1975, 1975, 5, to(1), 0, 1, 60),
        A7(ao, 1975, 1977, 8, eo(6), 0, 1, 0),
        A7(ao, 1976, 1976, 4, to(30), 0, 1, 60),
        A7(ao, 1977, 1979, 4, A2(uo, 6, 22), 0, 1, 60),
        A7(ao, 1978, 1978, 9, to(1), 0, 1, 0),
        A7(ao, 1979, 1979, 8, to(30), 0, 1, 0)
    ]), Dl = x([
        A7(ao, 1973, 1973, 2, to(31), 0, 1, 60),
        A7(ao, 1973, 1973, 8, to(29), 0, 1, 0),
        A7(ao, 1974, 1974, 3, to(21), 0, 1, 60),
        A7(ao, 1974, 1974, 8, to(16), 0, 1, 0),
        A7(ao, 1975, 1979, 3, A2(uo, 6, 15), 120, 2, 60),
        A7(ao, 1975, 1980, 8, A2(uo, 6, 15), 120, 2, 0),
        A7(ao, 1980, 1980, 2, to(31), 120, 2, 60)
    ]), ql = yl, Fl = x([
        A7(ao, 1976, 1976, 2, to(28), 60, 2, 60),
        A7(ao, 1976, 1976, 8, to(26), 60, 2, 0)
    ]), Pl = Rs, zl = fl, jl = x([
        A7(ao, 1989, 1996, 2, eo(6), 120, 1, 60),
        A7(ao, 1989, 1996, 8, eo(6), 120, 1, 0)
    ]), Sl = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 60, Cc(El)), A5(Pc, 1980, 0, 1, 0, 2))
        ]), A2(Ec, 60, Cc(Do))));
    }, Ll = Sl, Ml = fl, Nl = fl, Hl = x([
        A7(ao, 1979, 1979, 2, to(31), 1380, 2, 60),
        A7(ao, 1979, 1979, 9, to(1), 60, 2, 0),
        A7(ao, 1980, 1982, 3, A2(uo, 5, 1), 1380, 2, 60),
        A7(ao, 1980, 1980, 8, to(29), 60, 2, 0),
        A7(ao, 1981, 1981, 8, to(27), 120, 2, 0)
    ]), Tl = x([
        A7(ao, 1974, 1974, 4, to(4), 0, 2, 60),
        A7(ao, 1974, 1974, 9, to(2), 0, 2, 0),
        A7(ao, 1975, 1975, 4, to(1), 0, 2, 60),
        A7(ao, 1975, 1975, 9, to(2), 0, 2, 0),
        A7(ao, 1976, 1976, 4, to(2), 0, 2, 60),
        A7(ao, 1976, 1976, 9, to(3), 0, 2, 0),
        A7(ao, 1977, 1977, 4, to(8), 0, 2, 60),
        A7(ao, 1977, 1977, 9, to(2), 0, 2, 0),
        A7(ao, 1978, 1978, 4, to(6), 0, 2, 60),
        A7(ao, 1978, 1978, 9, to(1), 0, 2, 0),
        A7(ao, 1979, 1979, 4, to(5), 0, 2, 60),
        A7(ao, 1979, 1979, 8, to(30), 0, 2, 0),
        A7(ao, 1980, 1980, 4, to(3), 0, 2, 60),
        A7(ao, 1980, 1980, 9, to(4), 0, 2, 0),
        A7(ao, 1981, 1981, 3, to(26), 0, 2, 60),
        A7(ao, 1981, 1981, 8, to(27), 0, 2, 0),
        A7(ao, 1982, 1982, 4, to(2), 0, 2, 60),
        A7(ao, 1982, 1982, 9, to(3), 0, 2, 0),
        A7(ao, 1983, 1983, 3, to(18), 0, 2, 60),
        A7(ao, 1983, 1983, 9, to(1), 0, 2, 0),
        A7(ao, 1984, 1984, 3, to(1), 0, 2, 60)
    ]), Il = ml, Rl = Sl, Zl = x([
        A7(ao, 1980, 1980, 3, to(6), 0, 2, 60),
        A7(ao, 1980, 1980, 8, to(28), 0, 2, 0)
    ]), Vl = fl, Ul = function(n) {
        return A3(de, F2(function(n, r) {
            return A3(ta, n.a, n.b, r);
        }), da, n);
    }, Yl = mo, Ql = mo, Ol = x([
        A7(ao, 1982, 1982, 9, to(10), 0, 2, 60),
        A7(ao, 1983, 1983, 2, to(21), 0, 2, 0),
        A7(ao, 2008, 2008, 9, eo(6), 120, 2, 60),
        A7(ao, 2009, 2009, 2, eo(6), 120, 2, 0)
    ]), Gl = mo, Jl = x([
        A7(ao, 2010, 2010, 8, eo(6), 0, 2, 60),
        A7(ao, 2011, 2011, 3, A2(uo, 5, 1), 240, 2, 0),
        A7(ao, 2011, 2011, 8, eo(5), 180, 2, 60),
        A7(ao, 2012, Fc, 3, A2(uo, 6, 1), 240, 2, 0),
        A7(ao, 2012, Fc, 8, eo(6), 180, 2, 60)
    ]), Wl = x([
        A7(ao, 1974, 1974, 10, A2(uo, 6, 1), 165, 1, 60),
        A7(ao, 1975, 1975, 1, eo(6), 165, 1, 0),
        A7(ao, 1975, 1988, 9, eo(6), 165, 1, 60),
        A7(ao, 1976, 1989, 2, A2(uo, 6, 1), 165, 1, 0),
        A7(ao, 1989, 1989, 9, A2(uo, 6, 8), 165, 1, 60),
        A7(ao, 1990, 2006, 9, A2(uo, 6, 1), 165, 1, 60),
        A7(ao, 1990, 2007, 2, A2(uo, 6, 15), 165, 1, 0),
        A7(ao, 2007, Fc, 8, eo(6), 165, 1, 60),
        A7(ao, 2008, Fc, 3, A2(uo, 6, 1), 165, 1, 0)
    ]), Kl = x([
        A7(ao, 1983, 1983, 8, to(25), 0, 2, 60),
        A7(ao, 1984, 1991, 2, A2(uo, 6, 23), 0, 2, 0),
        A7(ao, 1984, 1984, 9, to(23), 0, 2, 60),
        A7(ao, 1985, 1991, 8, A2(uo, 6, 23), 0, 2, 60),
        A7(ao, 1992, 1993, 0, A2(uo, 6, 23), 0, 2, 0),
        A7(ao, 1992, 1992, 9, A2(uo, 6, 23), 0, 2, 60)
    ]), Xl = x([
        A7(ao, 1998, 1999, 10, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 1999, 2e3, 1, eo(6), 180, 2, 0),
        A7(ao, 2009, 2009, 10, to(29), 120, 2, 60),
        A7(ao, 2010, 2010, 2, eo(6), 180, 2, 0),
        A7(ao, 2010, 2013, 9, A2(uo, 6, 21), 120, 2, 60),
        A7(ao, 2011, 2011, 2, A2(uo, 6, 1), 180, 2, 0),
        A7(ao, 2012, 2013, 0, A2(uo, 6, 18), 180, 2, 0),
        A7(ao, 2014, 2014, 0, A2(uo, 6, 18), 120, 2, 0),
        A7(ao, 2014, 2018, 10, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2015, Fc, 0, A2(uo, 6, 12), 180, 2, 0),
        A7(ao, 2019, 2019, 10, A2(uo, 6, 8), 120, 2, 60),
        A7(ao, 2020, 2020, 11, to(20), 120, 2, 60),
        A7(ao, 2021, Fc, 10, A2(uo, 6, 8), 120, 2, 60)
    ]), nd = x([
        A7(ao, 1969, 1969, 0, to(26), 1, 2, 0),
        A7(ao, 1969, 1969, 5, to(22), 120, 2, 60),
        A7(ao, 1969, 1969, 7, to(31), 120, 2, 0),
        A7(ao, 1970, 1971, 3, eo(6), 120, 2, 60),
        A7(ao, 1970, 1971, 8, A2(uo, 6, 1), 120, 2, 0),
        A7(ao, 1973, 1973, 11, to(16), 120, 2, 60),
        A7(ao, 1974, 1974, 1, to(24), 120, 2, 0),
        A7(ao, 1976, 1976, 4, to(26), 120, 2, 60),
        A7(ao, 1976, 1976, 7, to(22), 121, 2, 0),
        A7(ao, 1977, 1977, 3, to(24), 120, 2, 60),
        A7(ao, 1977, 1977, 7, to(28), 120, 2, 0)
    ]), rd = function() {
        return no(A2(Bc, x([
            b(A2(Ec, 600, Cc(nd)), A5(Pc, 2e3, 11, 23, 0, 2))
        ]), A2(Ec, 600, bo(0))));
    }, td = function() {
        return no(A2(Bc, h, A2(Ec, -660, bo(0))));
    }, ed = td, ud = x([
        A7(ao, 1977, 1978, 11, A2(uo, 6, 1), 0, 2, 60),
        A7(ao, 1978, 1979, 1, to(27), 0, 2, 0),
        A7(ao, 1996, 1996, 11, to(1), 120, 1, 60),
        A7(ao, 1997, 1997, 2, to(2), 120, 1, 0)
    ]), ad = x([
        A7(ao, 1978, 1978, 10, to(12), 0, 2, 30),
        A7(ao, 1979, 1991, 2, A2(uo, 6, 1), 0, 2, 0),
        A7(ao, 1979, 1990, 9, eo(6), 0, 2, 30)
    ]), id = rd, cd = x([
        A7(ao, 1999, 1999, 9, to(7), 120, 1, 60),
        A7(ao, 2e3, 2e3, 2, to(19), 120, 1, 0),
        A7(ao, 2e3, 2001, 10, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2001, 2002, 0, eo(6), 120, 2, 0),
        A7(ao, 2016, 2016, 10, A2(uo, 6, 1), 120, 2, 60),
        A7(ao, 2017, 2017, 0, A2(uo, 6, 15), 180, 2, 0)
    ]), od = Ul(x([
        b("Africa/Abidjan", vo),
        b("Africa/Accra", function() {
            return no(A2(Bc, h, A2(Ec, 0, bo(0))));
        }),
        b("Africa/Addis_Ababa", po),
        b("Africa/Algiers", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, Cc($o)), A5(Pc, 1977, 9, 21, 0, 2)),
                b(A2(Ec, 60, Cc($o)), A5(Pc, 1979, 9, 26, 0, 2)),
                b(A2(Ec, 0, Cc($o)), A5(Pc, 1981, 4, 1, 0, 2))
            ]), A2(Ec, 60, bo(0))));
        }),
        b("Africa/Asmara", ho),
        b("Africa/Bamako", go),
        b("Africa/Bangui", xo),
        b("Africa/Banjul", ko),
        b("Africa/Bissau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -60, bo(0)), A5(Pc, 1975, 0, 1, 0, 2))
            ]), A2(Ec, 0, bo(0))));
        }),
        b("Africa/Blantyre", _o),
        b("Africa/Brazzaville", Ao),
        b("Africa/Bujumbura", Co),
        b("Africa/Cairo", function() {
            return no(A2(Bc, h, A2(Ec, 120, Cc(Bo))));
        }),
        b("Africa/Casablanca", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, Cc(Eo)), A5(Pc, 1984, 2, 16, 0, 2)),
                b(A2(Ec, 60, bo(0)), A5(Pc, 1986, 0, 1, 0, 2)),
                b(A2(Ec, 0, Cc(Eo)), A5(Pc, 2018, 9, 28, 180, 2))
            ]), A2(Ec, 60, Cc(Eo))));
        }),
        b("Africa/Ceuta", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, Cc(qo)), A5(Pc, 1984, 2, 16, 0, 2)),
                b(A2(Ec, 60, bo(0)), A5(Pc, 1986, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Africa/Conakry", Fo),
        b("Africa/Dakar", Po),
        b("Africa/Dar_es_Salaam", zo),
        b("Africa/Djibouti", jo),
        b("Africa/Douala", So),
        b("Africa/El_Aaiun", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -60, bo(0)), A5(Pc, 1976, 3, 14, 0, 2)),
                b(A2(Ec, 0, Cc(Eo)), A5(Pc, 2018, 9, 28, 180, 2))
            ]), A2(Ec, 60, Cc(Eo))));
        }),
        b("Africa/Freetown", Lo),
        b("Africa/Gaborone", Mo),
        b("Africa/Harare", No),
        b("Africa/Johannesburg", Ho),
        b("Africa/Juba", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(To)), A5(Pc, 2e3, 0, 15, 720, 2))
            ]), A2(Ec, 180, bo(0))));
        }),
        b("Africa/Kampala", Io),
        b("Africa/Khartoum", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(To)), A5(Pc, 2e3, 0, 15, 720, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2017, 10, 1, 0, 2))
            ]), A2(Ec, 120, bo(0))));
        }),
        b("Africa/Kigali", Ro),
        b("Africa/Kinshasa", Zo),
        b("Africa/Lagos", wo),
        b("Africa/Libreville", Vo),
        b("Africa/Lome", Uo),
        b("Africa/Luanda", Yo),
        b("Africa/Lubumbashi", Qo),
        b("Africa/Lusaka", Oo),
        b("Africa/Malabo", Go),
        b("Africa/Maputo", yo),
        b("Africa/Maseru", Jo),
        b("Africa/Mbabane", Wo),
        b("Africa/Mogadishu", Ko),
        b("Africa/Monrovia", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -45, bo(0)), A5(Pc, 1972, 0, 7, 0, 2))
            ]), A2(Ec, 0, bo(0))));
        }),
        b("Africa/Nairobi", mo),
        b("Africa/Ndjamena", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1979, 9, 14, 0, 2)),
                b(A2(Ec, 60, bo(60)), A5(Pc, 1980, 2, 8, 0, 2))
            ]), A2(Ec, 60, bo(0))));
        }),
        b("Africa/Niamey", Xo),
        b("Africa/Nouakchott", nf),
        b("Africa/Ouagadougou", rf),
        b("Africa/Porto-Novo", tf),
        b("Africa/Sao_Tome", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, bo(0)), A5(Pc, 2018, 0, 1, 60, 2)),
                b(A2(Ec, 60, bo(0)), A5(Pc, 2019, 0, 1, 120, 2))
            ]), A2(Ec, 0, bo(0))));
        }),
        b("Africa/Tripoli", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, bo(0)), A5(Pc, 1982, 0, 1, 0, 2)),
                b(A2(Ec, 60, Cc(ef)), A5(Pc, 1990, 4, 4, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 1996, 8, 30, 0, 2)),
                b(A2(Ec, 60, Cc(ef)), A5(Pc, 1997, 9, 4, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2012, 10, 10, 120, 2)),
                b(A2(Ec, 60, Cc(ef)), A5(Pc, 2013, 9, 25, 120, 2))
            ]), A2(Ec, 120, bo(0))));
        }),
        b("Africa/Tunis", function() {
            return no(A2(Bc, h, A2(Ec, 60, Cc(uf))));
        }),
        b("Africa/Windhoek", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, bo(0)), A5(Pc, 1990, 2, 21, 0, 2))
            ]), A2(Ec, 120, Cc(af))));
        }),
        b("America/Adak", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -660, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -600, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -600, Cc(io))));
        }),
        b("America/Anchorage", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -600, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/Anguilla", of),
        b("America/Antigua", ff),
        b("America/Araguaina", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1990, 8, 17, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1995, 8, 14, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2003, 8, 24, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2012, 9, 21, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2013, 8, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Buenos_Aires", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2))
            ]), A2(Ec, -180, Cc(lf))));
        }),
        b("America/Argentina/Catamarca", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 3, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 5, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 5, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Cordoba", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 3, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2))
            ]), A2(Ec, -180, Cc(lf))));
        }),
        b("America/Argentina/Jujuy", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1990, 2, 4, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1990, 9, 28, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 1991, 2, 17, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 6, 0, 2)),
                b(A2(Ec, -180, bo(60)), A5(Pc, 1992, 0, 1, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/La_Rioja", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 4, 7, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 5, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 5, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Mendoza", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1990, 2, 4, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1990, 9, 15, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 1991, 2, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 15, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 1992, 2, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1992, 9, 18, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 4, 23, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 8, 26, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Rio_Gallegos", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 5, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 5, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Salta", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 3, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/San_Juan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 4, 7, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 4, 31, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 6, 25, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/San_Luis", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1990, 0, 1, 0, 2)),
                b(A2(Ec, -180, bo(60)), A5(Pc, 1990, 2, 14, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1990, 9, 15, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 1991, 2, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 5, 1, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 4, 31, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 6, 25, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 0, 21, 0, 2)),
                b(A2(Ec, -240, Cc(df)), A5(Pc, 2009, 9, 11, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Argentina/Tucuman", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1991, 2, 3, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1991, 9, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 5, 1, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 5, 13, 0, 2))
            ]), A2(Ec, -180, Cc(lf))));
        }),
        b("America/Argentina/Ushuaia", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1999, 9, 3, 0, 2)),
                b(A2(Ec, -240, Cc(lf)), A5(Pc, 2e3, 2, 3, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2004, 4, 30, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 5, 20, 0, 2)),
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 2008, 9, 18, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Aruba", vf),
        b("America/Asuncion", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 1972, 9, 1, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1974, 3, 1, 0, 2))
            ]), A2(Ec, -240, Cc(mf))));
        }),
        b("America/Atikokan", function() {
            return no(A2(Bc, h, A2(Ec, -300, bo(0))));
        }),
        b("America/Bahia", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2003, 8, 24, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2011, 9, 16, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2012, 9, 21, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Bahia_Banderas", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, bo(0)), A5(Pc, 1970, 0, 1, 0, 2)),
                b(A2(Ec, -420, Cc(pf)), A5(Pc, 2010, 3, 4, 120, 2))
            ]), A2(Ec, -360, Cc(pf))));
        }),
        b("America/Barbados", function() {
            return no(A2(Bc, h, A2(Ec, -240, Cc($f))));
        }),
        b("America/Belem", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Belize", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(hf))));
        }),
        b("America/Blanc-Sablon", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(gf)), A5(Pc, 1970, 0, 1, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Boa_Vista", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1999, 8, 30, 0, 2)),
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 2e3, 9, 15, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Bogota", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(wf))));
        }),
        b("America/Boise", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(io)), A5(Pc, 1974, 0, 1, 0, 2)),
                b(A2(Ec, -420, bo(0)), A5(Pc, 1974, 1, 3, 120, 2))
            ]), A2(Ec, -420, Cc(io))));
        }),
        b("America/Cambridge_Bay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(xf)), A5(Pc, 1999, 9, 31, 120, 2)),
                b(A2(Ec, -360, Cc(gf)), A5(Pc, 2e3, 9, 29, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2e3, 10, 5, 0, 2)),
                b(A2(Ec, -360, bo(0)), A5(Pc, 2001, 3, 1, 180, 2))
            ]), A2(Ec, -420, Cc(gf))));
        }),
        b("America/Campo_Grande", function() {
            return no(A2(Bc, h, A2(Ec, -240, Cc(sf))));
        }),
        b("America/Cancun", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1981, 11, 23, 0, 2)),
                b(A2(Ec, -300, Cc(pf)), A5(Pc, 1998, 7, 2, 120, 2)),
                b(A2(Ec, -360, Cc(pf)), A5(Pc, 2015, 1, 1, 120, 2))
            ]), A2(Ec, -300, bo(0))));
        }),
        b("America/Caracas", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 2007, 11, 9, 180, 2)),
                b(A2(Ec, -270, bo(0)), A5(Pc, 2016, 4, 1, 150, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Cayenne", function() {
            return no(A2(Bc, h, A2(Ec, -180, bo(0))));
        }),
        b("America/Cayman", yf),
        b("America/Chicago", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(io))));
        }),
        b("America/Chihuahua", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, -360, Cc(pf)), A5(Pc, 1998, 0, 1, 0, 2)),
                b(A2(Ec, -360, bo(0)), A5(Pc, 1998, 3, 5, 180, 2))
            ]), A2(Ec, -420, Cc(pf))));
        }),
        b("America/Costa_Rica", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(_f))));
        }),
        b("America/Creston", function() {
            return no(A2(Bc, h, A2(Ec, -420, bo(0))));
        }),
        b("America/Cuiaba", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 2003, 8, 24, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2004, 9, 1, 0, 2))
            ]), A2(Ec, -240, Cc(sf))));
        }),
        b("America/Curacao", bf),
        b("America/Danmarkshavn", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, bo(0)), A5(Pc, 1980, 3, 6, 120, 2)),
                b(A2(Ec, -180, Cc(Do)), A5(Pc, 1996, 0, 1, 0, 2))
            ]), A2(Ec, 0, bo(0))));
        }),
        b("America/Dawson", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -540, Cc(xf)), A5(Pc, 1973, 9, 28, 0, 2)),
                b(A2(Ec, -480, Cc(xf)), A5(Pc, 1980, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(gf)), A5(Pc, 2020, 10, 1, 0, 2))
            ]), A2(Ec, -420, bo(0))));
        }),
        b("America/Dawson_Creek", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(Af)), A5(Pc, 1972, 7, 30, 120, 2))
            ]), A2(Ec, -420, bo(0))));
        }),
        b("America/Denver", function() {
            return no(A2(Bc, h, A2(Ec, -420, Cc(io))));
        }),
        b("America/Detroit", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, bo(0)), A5(Pc, 1973, 0, 1, 0, 2)),
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1975, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1975, 3, 27, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Dominica", Cf),
        b("America/Edmonton", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(Bf)), A5(Pc, 1987, 0, 1, 0, 2))
            ]), A2(Ec, -420, Cc(gf))));
        }),
        b("America/Eirunepe", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1993, 8, 28, 0, 2)),
                b(A2(Ec, -300, Cc(sf)), A5(Pc, 1994, 8, 22, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2008, 5, 24, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2013, 10, 10, 0, 2))
            ]), A2(Ec, -300, bo(0))));
        }),
        b("America/El_Salvador", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(Ef))));
        }),
        b("America/Fort_Nelson", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(Af)), A5(Pc, 1987, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(gf)), A5(Pc, 2015, 2, 8, 120, 2))
            ]), A2(Ec, -420, bo(0))));
        }),
        b("America/Fortaleza", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1990, 8, 17, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1999, 8, 30, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2e3, 9, 22, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2001, 8, 13, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2002, 9, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Glace_Bay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 1972, 0, 1, 0, 2)),
                b(A2(Ec, -240, Cc(Df)), A5(Pc, 1974, 0, 1, 0, 2))
            ]), A2(Ec, -240, Cc(gf))));
        }),
        b("America/Goose_Bay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(qf)), A5(Pc, 2011, 10, 1, 0, 2))
            ]), A2(Ec, -240, Cc(gf))));
        }),
        b("America/Grand_Turk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, bo(0)), A5(Pc, 1979, 0, 1, 0, 2)),
                b(A2(Ec, -300, Cc(io)), A5(Pc, 2015, 10, 1, 120, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2018, 2, 11, 180, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Grenada", Ff),
        b("America/Guadeloupe", Pf),
        b("America/Guatemala", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(zf))));
        }),
        b("America/Guayaquil", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(jf))));
        }),
        b("America/Guyana", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -225, bo(0)), A5(Pc, 1975, 6, 31, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1991, 0, 1, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Halifax", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(Df)), A5(Pc, 1974, 0, 1, 0, 2))
            ]), A2(Ec, -240, Cc(gf))));
        }),
        b("America/Havana", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(Sf))));
        }),
        b("America/Hermosillo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, bo(0)), A5(Pc, 1970, 0, 1, 0, 2)),
                b(A2(Ec, -420, Cc(pf)), A5(Pc, 1999, 0, 1, 0, 2))
            ]), A2(Ec, -420, bo(0))));
        }),
        b("America/Indiana/Indianapolis", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Indiana/Knox", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(io)), A5(Pc, 1991, 9, 27, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 3, 2, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/Indiana/Marengo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1974, 0, 6, 120, 2)),
                b(A2(Ec, -360, bo(60)), A5(Pc, 1974, 9, 27, 120, 2)),
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1976, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Indiana/Petersburg", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(io)), A5(Pc, 1977, 9, 30, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 3, 2, 120, 2)),
                b(A2(Ec, -360, Cc(io)), A5(Pc, 2007, 10, 4, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Indiana/Tell_City", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 3, 2, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/Indiana/Vevay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1973, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Indiana/Vincennes", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 3, 2, 120, 2)),
                b(A2(Ec, -360, Cc(io)), A5(Pc, 2007, 10, 4, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Indiana/Winamac", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2006, 3, 2, 120, 2)),
                b(A2(Ec, -360, Cc(io)), A5(Pc, 2007, 2, 11, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Inuvik", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(xf)), A5(Pc, 1979, 3, 29, 120, 2)),
                b(A2(Ec, -420, Cc(xf)), A5(Pc, 1980, 0, 1, 0, 2))
            ]), A2(Ec, -420, Cc(gf))));
        }),
        b("America/Iqaluit", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(xf)), A5(Pc, 1999, 9, 31, 120, 2)),
                b(A2(Ec, -360, Cc(gf)), A5(Pc, 2e3, 9, 29, 120, 2))
            ]), A2(Ec, -300, Cc(gf))));
        }),
        b("America/Jamaica", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, bo(0)), A5(Pc, 1974, 0, 1, 0, 2)),
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1984, 0, 1, 0, 2))
            ]), A2(Ec, -300, bo(0))));
        }),
        b("America/Juneau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(io)), A5(Pc, 1980, 3, 27, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1980, 9, 26, 120, 2)),
                b(A2(Ec, -480, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/Kentucky/Louisville", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(io)), A5(Pc, 1974, 0, 6, 120, 2)),
                b(A2(Ec, -360, bo(60)), A5(Pc, 1974, 9, 27, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Kentucky/Monticello", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(io)), A5(Pc, 2e3, 9, 29, 120, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/Kralendijk", Lf),
        b("America/La_Paz", function() {
            return no(A2(Bc, h, A2(Ec, -240, bo(0))));
        }),
        b("America/Lima", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(Mf))));
        }),
        b("America/Los_Angeles", co),
        b("America/Lower_Princes", Nf),
        b("America/Maceio", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1990, 8, 17, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1995, 9, 13, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1996, 8, 4, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1999, 8, 30, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2e3, 9, 22, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2001, 8, 13, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2002, 9, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Managua", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1973, 4, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1975, 1, 16, 0, 2)),
                b(A2(Ec, -360, Cc(Hf)), A5(Pc, 1992, 0, 1, 240, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1992, 8, 24, 0, 2)),
                b(A2(Ec, -360, bo(0)), A5(Pc, 1993, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1997, 0, 1, 0, 2))
            ]), A2(Ec, -360, Cc(Hf))));
        }),
        b("America/Manaus", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 1993, 8, 28, 0, 2)),
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 1994, 8, 22, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Marigot", Tf),
        b("America/Martinique", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 1980, 3, 6, 0, 2)),
                b(A2(Ec, -240, bo(60)), A5(Pc, 1980, 8, 28, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Matamoros", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1988, 0, 1, 0, 2)),
                b(A2(Ec, -360, Cc(io)), A5(Pc, 1989, 0, 1, 0, 2)),
                b(A2(Ec, -360, Cc(pf)), A5(Pc, 2010, 0, 1, 0, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/Mazatlan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, bo(0)), A5(Pc, 1970, 0, 1, 0, 2))
            ]), A2(Ec, -420, Cc(pf))));
        }),
        b("America/Menominee", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, bo(0)), A5(Pc, 1973, 3, 29, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/Merida", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1981, 11, 23, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1982, 11, 2, 0, 2))
            ]), A2(Ec, -360, Cc(pf))));
        }),
        b("America/Metlakatla", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -480, bo(0)), A5(Pc, 2015, 10, 1, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 2018, 10, 4, 120, 2)),
                b(A2(Ec, -480, bo(0)), A5(Pc, 2019, 0, 20, 120, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/Mexico_City", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(pf)), A5(Pc, 2001, 8, 30, 120, 2)),
                b(A2(Ec, -360, bo(0)), A5(Pc, 2002, 1, 20, 0, 2))
            ]), A2(Ec, -360, Cc(pf))));
        }),
        b("America/Miquelon", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 1980, 4, 1, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1987, 0, 1, 0, 2))
            ]), A2(Ec, -180, Cc(gf))));
        }),
        b("America/Moncton", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(If)), A5(Pc, 1973, 0, 1, 0, 2)),
                b(A2(Ec, -240, Cc(gf)), A5(Pc, 1993, 0, 1, 0, 2)),
                b(A2(Ec, -240, Cc(If)), A5(Pc, 2007, 0, 1, 0, 2))
            ]), A2(Ec, -240, Cc(gf))));
        }),
        b("America/Monterrey", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1988, 0, 1, 0, 2)),
                b(A2(Ec, -360, Cc(io)), A5(Pc, 1989, 0, 1, 0, 2))
            ]), A2(Ec, -360, Cc(pf))));
        }),
        b("America/Montevideo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(Rf)), A5(Pc, 1970, 0, 1, 0, 2)),
                b(A2(Ec, -180, Cc(Rf)), A5(Pc, 1974, 0, 1, 0, 2)),
                b(A2(Ec, -180, Cc(Rf)), A5(Pc, 1974, 2, 10, 0, 2)),
                b(A2(Ec, -180, Cc(Rf)), A5(Pc, 1974, 11, 22, 0, 2))
            ]), A2(Ec, -180, Cc(Rf))));
        }),
        b("America/Montserrat", Zf),
        b("America/Nassau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(Vf)), A5(Pc, 1976, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(io))));
        }),
        b("America/New_York", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(io))));
        }),
        b("America/Nipigon", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(gf))));
        }),
        b("America/Nome", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -660, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/Noronha", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -120, Cc(sf)), A5(Pc, 1990, 8, 17, 0, 2)),
                b(A2(Ec, -120, bo(0)), A5(Pc, 1999, 8, 30, 0, 2)),
                b(A2(Ec, -120, Cc(sf)), A5(Pc, 2e3, 9, 15, 0, 2)),
                b(A2(Ec, -120, bo(0)), A5(Pc, 2001, 8, 13, 0, 2)),
                b(A2(Ec, -120, Cc(sf)), A5(Pc, 2002, 9, 1, 0, 2))
            ]), A2(Ec, -120, bo(0))));
        }),
        b("America/North_Dakota/Beulah", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(io)), A5(Pc, 2010, 10, 7, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/North_Dakota/Center", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(io)), A5(Pc, 1992, 9, 25, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/North_Dakota/New_Salem", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(io)), A5(Pc, 2003, 9, 26, 120, 2))
            ]), A2(Ec, -360, Cc(io))));
        }),
        b("America/Nuuk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, bo(0)), A5(Pc, 1980, 3, 6, 120, 2))
            ]), A2(Ec, -180, Cc(Do))));
        }),
        b("America/Ojinaga", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, bo(0)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, -360, Cc(pf)), A5(Pc, 1998, 0, 1, 0, 2)),
                b(A2(Ec, -360, bo(0)), A5(Pc, 1998, 3, 5, 180, 2)),
                b(A2(Ec, -420, Cc(pf)), A5(Pc, 2010, 0, 1, 0, 2))
            ]), A2(Ec, -420, Cc(io))));
        }),
        b("America/Panama", kf),
        b("America/Pangnirtung", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(xf)), A5(Pc, 1995, 3, 2, 120, 2)),
                b(A2(Ec, -300, Cc(gf)), A5(Pc, 1999, 9, 31, 120, 2)),
                b(A2(Ec, -360, Cc(gf)), A5(Pc, 2e3, 9, 29, 120, 2))
            ]), A2(Ec, -300, Cc(gf))));
        }),
        b("America/Paramaribo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -210, bo(0)), A5(Pc, 1984, 9, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Phoenix", function() {
            return no(A2(Bc, h, A2(Ec, -420, bo(0))));
        }),
        b("America/Port-au-Prince", function() {
            return no(A2(Bc, h, A2(Ec, -300, Cc(Uf))));
        }),
        b("America/Port_of_Spain", cf),
        b("America/Porto_Velho", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Puerto_Rico", function() {
            return no(A2(Bc, h, A2(Ec, -240, bo(0))));
        }),
        b("America/Punta_Arenas", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(Yf)), A5(Pc, 2016, 11, 4, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Rainy_River", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(gf))));
        }),
        b("America/Rankin_Inlet", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(xf)), A5(Pc, 2e3, 9, 29, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2001, 3, 1, 180, 2))
            ]), A2(Ec, -360, Cc(gf))));
        }),
        b("America/Recife", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 1990, 8, 17, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 1999, 8, 30, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2e3, 9, 15, 0, 2)),
                b(A2(Ec, -180, bo(0)), A5(Pc, 2001, 8, 13, 0, 2)),
                b(A2(Ec, -180, Cc(sf)), A5(Pc, 2002, 9, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Regina", function() {
            return no(A2(Bc, h, A2(Ec, -360, bo(0))));
        }),
        b("America/Resolute", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(xf)), A5(Pc, 2e3, 9, 29, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2001, 3, 1, 180, 2)),
                b(A2(Ec, -360, Cc(gf)), A5(Pc, 2006, 9, 29, 120, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2007, 2, 11, 180, 2))
            ]), A2(Ec, -360, Cc(gf))));
        }),
        b("America/Rio_Branco", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 2008, 5, 24, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2013, 10, 10, 0, 2))
            ]), A2(Ec, -300, bo(0))));
        }),
        b("America/Santarem", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(sf)), A5(Pc, 1988, 8, 12, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2008, 5, 24, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("America/Santiago", function() {
            return no(A2(Bc, h, A2(Ec, -240, Cc(Yf))));
        }),
        b("America/Santo_Domingo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(Qf)), A5(Pc, 1974, 9, 27, 0, 2)),
                b(A2(Ec, -240, bo(0)), A5(Pc, 2e3, 9, 29, 120, 2)),
                b(A2(Ec, -300, Cc(io)), A5(Pc, 2e3, 11, 3, 60, 2))
            ]), A2(Ec, -240, bo(0))));
        }),
        b("America/Sao_Paulo", function() {
            return no(A2(Bc, h, A2(Ec, -180, Cc(sf))));
        }),
        b("America/Scoresbysund", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -120, bo(0)), A5(Pc, 1980, 3, 6, 120, 2)),
                b(A2(Ec, -120, Cc(Of)), A5(Pc, 1981, 2, 29, 0, 2))
            ]), A2(Ec, -60, Cc(Do))));
        }),
        b("America/Sitka", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(io)), A5(Pc, 1983, 9, 30, 120, 2)),
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/St_Barthelemy", Gf),
        b("America/St_Johns", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -210, Cc(qf)), A5(Pc, 2011, 10, 1, 0, 2))
            ]), A2(Ec, -210, Cc(gf))));
        }),
        b("America/St_Kitts", Jf),
        b("America/St_Lucia", Wf),
        b("America/St_Thomas", Kf),
        b("America/St_Vincent", Xf),
        b("America/Swift_Current", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, bo(0)), A5(Pc, 1972, 3, 30, 120, 2))
            ]), A2(Ec, -360, bo(0))));
        }),
        b("America/Tegucigalpa", function() {
            return no(A2(Bc, h, A2(Ec, -360, Cc(ns))));
        }),
        b("America/Thule", function() {
            return no(A2(Bc, h, A2(Ec, -240, Cc(rs))));
        }),
        b("America/Thunder_Bay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(gf)), A5(Pc, 1970, 0, 1, 0, 2)),
                b(A2(Ec, -300, Cc(ts)), A5(Pc, 1973, 0, 1, 0, 2)),
                b(A2(Ec, -300, bo(0)), A5(Pc, 1974, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(gf))));
        }),
        b("America/Tijuana", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, bo(0)), A5(Pc, 1976, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(io)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(pf)), A5(Pc, 2001, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(io)), A5(Pc, 2002, 1, 20, 0, 2)),
                b(A2(Ec, -480, Cc(pf)), A5(Pc, 2010, 0, 1, 0, 2))
            ]), A2(Ec, -480, Cc(io))));
        }),
        b("America/Toronto", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, Cc(ts)), A5(Pc, 1974, 0, 1, 0, 2))
            ]), A2(Ec, -300, Cc(gf))));
        }),
        b("America/Tortola", es),
        b("America/Vancouver", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(Af)), A5(Pc, 1987, 0, 1, 0, 2))
            ]), A2(Ec, -480, Cc(gf))));
        }),
        b("America/Whitehorse", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -480, Cc(xf)), A5(Pc, 1980, 0, 1, 0, 2)),
                b(A2(Ec, -480, Cc(gf)), A5(Pc, 2020, 10, 1, 0, 2))
            ]), A2(Ec, -420, bo(0))));
        }),
        b("America/Winnipeg", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -360, Cc(us)), A5(Pc, 2006, 0, 1, 0, 2))
            ]), A2(Ec, -360, Cc(gf))));
        }),
        b("America/Yakutat", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -540, Cc(io)), A5(Pc, 1983, 10, 30, 0, 2))
            ]), A2(Ec, -540, Cc(io))));
        }),
        b("America/Yellowknife", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(xf)), A5(Pc, 1980, 0, 1, 0, 2))
            ]), A2(Ec, -420, Cc(gf))));
        }),
        b("Antarctica/Casey", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 480, bo(0)), A5(Pc, 2009, 9, 18, 120, 2)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2010, 2, 5, 120, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2011, 9, 28, 120, 2)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2012, 1, 21, 1020, 0)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2016, 9, 22, 0, 2)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2018, 2, 11, 240, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2018, 9, 7, 240, 2)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2019, 2, 17, 180, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2019, 9, 4, 180, 2)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2020, 2, 8, 180, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2020, 9, 4, 1, 2))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Antarctica/Davis", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, bo(0)), A5(Pc, 2009, 9, 18, 120, 2)),
                b(A2(Ec, 300, bo(0)), A5(Pc, 2010, 2, 10, 1200, 0)),
                b(A2(Ec, 420, bo(0)), A5(Pc, 2011, 9, 28, 120, 2)),
                b(A2(Ec, 300, bo(0)), A5(Pc, 2012, 1, 21, 1200, 0))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Antarctica/DumontDUrville", function() {
            return no(A2(Bc, h, A2(Ec, 600, bo(0))));
        }),
        b("Antarctica/Macquarie", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, Cc(as)), A5(Pc, 2010, 0, 1, 0, 2)),
                b(A2(Ec, 600, bo(60)), A5(Pc, 2011, 0, 1, 0, 2))
            ]), A2(Ec, 600, Cc(as))));
        }),
        b("Antarctica/Mawson", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, bo(0)), A5(Pc, 2009, 9, 18, 120, 2))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Antarctica/McMurdo", os),
        b("Antarctica/Palmer", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -180, Cc(lf)), A5(Pc, 1982, 4, 1, 0, 2)),
                b(A2(Ec, -240, Cc(Yf)), A5(Pc, 2016, 11, 4, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("Antarctica/Rothera", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, bo(0)), A5(Pc, 1976, 11, 1, 0, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("Antarctica/Syowa", function() {
            return no(A2(Bc, h, A2(Ec, 180, bo(0))));
        }),
        b("Antarctica/Troll", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, bo(0)), A5(Pc, 2005, 1, 12, 0, 2))
            ]), A2(Ec, 0, Cc(fs))));
        }),
        b("Antarctica/Vostok", function() {
            return no(A2(Bc, h, A2(Ec, 360, bo(0))));
        }),
        b("Arctic/Longyearbyen", ls),
        b("Asia/Aden", bs),
        b("Asia/Almaty", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Asia/Amman", function() {
            return no(A2(Bc, h, A2(Ec, 120, Cc(ms))));
        }),
        b("Asia/Anadyr", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 780, Cc(ps)), A5(Pc, 1982, 3, 1, 0, 1)),
                b(A2(Ec, 720, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 720, Cc(ps)), A5(Pc, 2010, 2, 28, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1))
            ]), A2(Ec, 720, bo(0))));
        }),
        b("Asia/Aqtau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1994, 8, 25, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Aqtobe", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Ashgabat", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 2)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 2))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Atyrau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1999, 2, 28, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Baghdad", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, bo(0)), A5(Pc, 1982, 4, 1, 0, 2))
            ]), A2(Ec, 180, Cc($s))));
        }),
        b("Asia/Bahrain", gs),
        b("Asia/Baku", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 180, Cc(vs)), A5(Pc, 1992, 8, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, 240, Cc(xs)), A5(Pc, 1997, 0, 1, 0, 2))
            ]), A2(Ec, 240, Cc(ws))));
        }),
        b("Asia/Bangkok", ks),
        b("Asia/Barnaul", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1995, 4, 28, 0, 2)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 420, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2016, 2, 27, 120, 1))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Beirut", function() {
            return no(A2(Bc, h, A2(Ec, 120, Cc(ys))));
        }),
        b("Asia/Bishkek", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 7, 31, 120, 2)),
                b(A2(Ec, 300, Cc(_s)), A5(Pc, 2005, 7, 12, 0, 2))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Asia/Brunei", function() {
            return no(A2(Bc, h, A2(Ec, 480, bo(0))));
        }),
        b("Asia/Chita", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 480, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 600, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2016, 2, 27, 120, 2))
            ]), A2(Ec, 540, bo(0))));
        }),
        b("Asia/Choibalsan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, bo(0)), A5(Pc, 1978, 0, 1, 0, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 1983, 3, 1, 0, 2)),
                b(A2(Ec, 540, Cc(As)), A5(Pc, 2008, 2, 31, 0, 2))
            ]), A2(Ec, 480, Cc(As))));
        }),
        b("Asia/Colombo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 330, bo(0)), A5(Pc, 1996, 4, 25, 0, 2)),
                b(A2(Ec, 390, bo(0)), A5(Pc, 1996, 9, 26, 30, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2006, 3, 15, 30, 2))
            ]), A2(Ec, 330, bo(0))));
        }),
        b("Asia/Damascus", function() {
            return no(A2(Bc, h, A2(Ec, 120, Cc(Cs))));
        }),
        b("Asia/Dhaka", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, bo(0)), A5(Pc, 2009, 0, 1, 0, 2))
            ]), A2(Ec, 360, Cc(Bs))));
        }),
        b("Asia/Dili", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, bo(0)), A5(Pc, 1976, 4, 3, 0, 2)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2e3, 8, 17, 0, 2))
            ]), A2(Ec, 540, bo(0))));
        }),
        b("Asia/Dubai", Es),
        b("Asia/Dushanbe", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1991, 8, 9, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Famagusta", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(Ds)), A5(Pc, 1998, 8, 1, 0, 2)),
                b(A2(Ec, 120, Cc(xs)), A5(Pc, 2016, 8, 8, 0, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2017, 9, 29, 60, 0))
            ]), A2(Ec, 120, Cc(xs))));
        }),
        b("Asia/Gaza", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(Ps)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(ms)), A5(Pc, 1999, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(qs)), A5(Pc, 2008, 7, 29, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2008, 8, 1, 0, 2)),
                b(A2(Ec, 120, Cc(qs)), A5(Pc, 2010, 0, 1, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2010, 2, 27, 1, 2)),
                b(A2(Ec, 120, Cc(qs)), A5(Pc, 2011, 7, 1, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2012, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(qs))));
        }),
        b("Asia/Hebron", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(Ps)), A5(Pc, 1996, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(ms)), A5(Pc, 1999, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(qs))));
        }),
        b("Asia/Ho_Chi_Minh", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 480, bo(0)), A5(Pc, 1975, 5, 13, 0, 2))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Hong_Kong", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(zs))));
        }),
        b("Asia/Hovd", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, bo(0)), A5(Pc, 1978, 0, 1, 0, 2))
            ]), A2(Ec, 420, Cc(As))));
        }),
        b("Asia/Irkutsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 480, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 480, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 540, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 480, bo(0))));
        }),
        b("Asia/Istanbul", Ls),
        b("Asia/Jakarta", function() {
            return no(A2(Bc, h, A2(Ec, 420, bo(0))));
        }),
        b("Asia/Jayapura", function() {
            return no(A2(Bc, h, A2(Ec, 540, bo(0))));
        }),
        b("Asia/Jerusalem", function() {
            return no(A2(Bc, h, A2(Ec, 120, Cc(Ps))));
        }),
        b("Asia/Kabul", function() {
            return no(A2(Bc, h, A2(Ec, 270, bo(0))));
        }),
        b("Asia/Kamchatka", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 720, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 720, Cc(ps)), A5(Pc, 2010, 2, 28, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1))
            ]), A2(Ec, 720, bo(0))));
        }),
        b("Asia/Karachi", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1971, 2, 26, 0, 2))
            ]), A2(Ec, 300, Cc(Ms))));
        }),
        b("Asia/Kathmandu", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 330, bo(0)), A5(Pc, 1986, 0, 1, 0, 2))
            ]), A2(Ec, 345, bo(0))));
        }),
        b("Asia/Khandyga", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 480, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 2004, 0, 1, 0, 2)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2011, 8, 13, 0, 1)),
                b(A2(Ec, 600, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 540, bo(0))));
        }),
        b("Asia/Kolkata", function() {
            return no(A2(Bc, h, A2(Ec, 330, bo(0))));
        }),
        b("Asia/Krasnoyarsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 480, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Kuala_Lumpur", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 450, bo(0)), A5(Pc, 1982, 0, 1, 0, 2))
            ]), A2(Ec, 480, bo(0))));
        }),
        b("Asia/Kuching", function() {
            return no(A2(Bc, h, A2(Ec, 480, bo(0))));
        }),
        b("Asia/Kuwait", Ns),
        b("Asia/Macau", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(Hs))));
        }),
        b("Asia/Magadan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 720, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 600, bo(0)), A5(Pc, 2016, 3, 24, 120, 1))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Asia/Makassar", function() {
            return no(A2(Bc, h, A2(Ec, 480, bo(0))));
        }),
        b("Asia/Manila", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(Ts))));
        }),
        b("Asia/Muscat", Is),
        b("Asia/Nicosia", Rs),
        b("Asia/Novokuznetsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 2010, 2, 28, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Novosibirsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1993, 4, 23, 0, 2)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 420, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2016, 6, 24, 120, 1))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Omsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 300, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 420, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Asia/Oral", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Phnom_Penh", Zs),
        b("Asia/Pontianak", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 480, bo(0)), A5(Pc, 1988, 0, 1, 0, 2))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Pyongyang", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, bo(0)), A5(Pc, 2015, 7, 15, 0, 2)),
                b(A2(Ec, 510, bo(0)), A5(Pc, 2018, 4, 4, 1410, 2))
            ]), A2(Ec, 540, bo(0))));
        }),
        b("Asia/Qatar", hs),
        b("Asia/Qostanay", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Asia/Qyzylorda", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1991, 8, 29, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 2004, 9, 31, 120, 1)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2018, 11, 21, 0, 2))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Riyadh", ds),
        b("Asia/Sakhalin", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1997, 2, 30, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 600, bo(0)), A5(Pc, 2016, 2, 27, 120, 1))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Asia/Samarkand", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 300, bo(60)), A5(Pc, 1981, 9, 1, 0, 2)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 1982, 3, 1, 0, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1992, 0, 1, 0, 2))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Seoul", function() {
            return no(A2(Bc, h, A2(Ec, 540, Cc(Vs))));
        }),
        b("Asia/Shanghai", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(Us))));
        }),
        b("Asia/Singapore", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 450, bo(0)), A5(Pc, 1982, 0, 1, 0, 2))
            ]), A2(Ec, 480, bo(0))));
        }),
        b("Asia/Srednekolymsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 720, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Asia/Taipei", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(Ys))));
        }),
        b("Asia/Tashkent", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 360, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 2)),
                b(A2(Ec, 300, Cc(vs)), A5(Pc, 1992, 0, 1, 0, 2))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Tbilisi", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 180, Cc(vs)), A5(Pc, 1992, 0, 1, 0, 2)),
                b(A2(Ec, 180, Cc(Qs)), A5(Pc, 1994, 8, 25, 0, 2)),
                b(A2(Ec, 240, Cc(Qs)), A5(Pc, 1996, 9, 27, 0, 2)),
                b(A2(Ec, 240, bo(60)), A5(Pc, 1997, 2, 30, 0, 2)),
                b(A2(Ec, 240, Cc(Qs)), A5(Pc, 2004, 5, 27, 0, 2)),
                b(A2(Ec, 180, Cc(vs)), A5(Pc, 2005, 2, 27, 120, 2))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Asia/Tehran", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 210, bo(0)), A5(Pc, 1977, 10, 1, 0, 2)),
                b(A2(Ec, 240, Cc(Os)), A5(Pc, 1979, 0, 1, 0, 2))
            ]), A2(Ec, 210, Cc(Os))));
        }),
        b("Asia/Thimphu", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 330, bo(0)), A5(Pc, 1987, 9, 1, 0, 2))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Asia/Tokyo", function() {
            return no(A2(Bc, h, A2(Ec, 540, bo(0))));
        }),
        b("Asia/Tomsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 420, Cc(ps)), A5(Pc, 2002, 4, 1, 180, 2)),
                b(A2(Ec, 360, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 420, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2016, 4, 29, 120, 1))
            ]), A2(Ec, 420, bo(0))));
        }),
        b("Asia/Ulaanbaatar", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 420, bo(0)), A5(Pc, 1978, 0, 1, 0, 2))
            ]), A2(Ec, 480, Cc(As))));
        }),
        b("Asia/Urumqi", function() {
            return no(A2(Bc, h, A2(Ec, 360, bo(0))));
        }),
        b("Asia/Ust-Nera", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 1981, 3, 1, 0, 2)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 660, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 720, bo(0)), A5(Pc, 2011, 8, 13, 0, 1)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 600, bo(0))));
        }),
        b("Asia/Vientiane", Gs),
        b("Asia/Vladivostok", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 600, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 600, bo(0))));
        }),
        b("Asia/Yakutsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 480, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 540, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 600, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 540, bo(0))));
        }),
        b("Asia/Yangon", function() {
            return no(A2(Bc, h, A2(Ec, 390, bo(0))));
        }),
        b("Asia/Yekaterinburg", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 300, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 360, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 300, bo(0))));
        }),
        b("Asia/Yerevan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 180, Cc(vs)), A5(Pc, 1995, 8, 24, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1997, 0, 1, 0, 2)),
                b(A2(Ec, 240, Cc(vs)), A5(Pc, 2011, 0, 1, 0, 2))
            ]), A2(Ec, 240, Cc(Js))));
        }),
        b("Atlantic/Azores", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -60, Cc(Ws)), A5(Pc, 1983, 8, 25, 60, 1)),
                b(A2(Ec, -60, Cc(Ks)), A5(Pc, 1992, 8, 27, 60, 1)),
                b(A2(Ec, 0, Cc(Do)), A5(Pc, 1993, 2, 28, 60, 0))
            ]), A2(Ec, -60, Cc(Do))));
        }),
        b("Atlantic/Bermuda", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, bo(0)), A5(Pc, 1974, 3, 28, 120, 2)),
                b(A2(Ec, -240, Cc(gf)), A5(Pc, 1976, 0, 1, 0, 2))
            ]), A2(Ec, -240, Cc(io))));
        }),
        b("Atlantic/Canary", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, bo(0)), A5(Pc, 1980, 3, 6, 0, 1)),
                b(A2(Ec, 0, bo(60)), A5(Pc, 1980, 8, 28, 60, 0))
            ]), A2(Ec, 0, Cc(Do))));
        }),
        b("Atlantic/Cape_Verde", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -120, bo(0)), A5(Pc, 1975, 10, 25, 120, 2))
            ]), A2(Ec, -60, bo(0))));
        }),
        b("Atlantic/Faroe", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, bo(0)), A5(Pc, 1981, 0, 1, 0, 2))
            ]), A2(Ec, 0, Cc(Do))));
        }),
        b("Atlantic/Madeira", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 0, Cc(Ws)), A5(Pc, 1983, 8, 25, 60, 1))
            ]), A2(Ec, 0, Cc(Do))));
        }),
        b("Atlantic/Reykjavik", function() {
            return no(A2(Bc, h, A2(Ec, 0, bo(0))));
        }),
        b("Atlantic/South_Georgia", function() {
            return no(A2(Bc, h, A2(Ec, -120, bo(0))));
        }),
        b("Atlantic/St_Helena", Xs),
        b("Atlantic/Stanley", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -240, Cc(nl)), A5(Pc, 1983, 4, 1, 0, 2)),
                b(A2(Ec, -180, Cc(nl)), A5(Pc, 1985, 8, 15, 0, 2)),
                b(A2(Ec, -240, Cc(nl)), A5(Pc, 2010, 8, 5, 120, 2))
            ]), A2(Ec, -180, bo(0))));
        }),
        b("Australia/Adelaide", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 570, bo(0)), A5(Pc, 1971, 0, 1, 0, 2))
            ]), A2(Ec, 570, Cc(rl))));
        }),
        b("Australia/Brisbane", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1971, 0, 1, 0, 2))
            ]), A2(Ec, 600, Cc(tl))));
        }),
        b("Australia/Broken_Hill", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 570, bo(0)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, 570, Cc(el)), A5(Pc, 2e3, 0, 1, 0, 2))
            ]), A2(Ec, 570, Cc(rl))));
        }),
        b("Australia/Currie", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1971, 6, 1, 0, 2))
            ]), A2(Ec, 600, Cc(as))));
        }),
        b("Australia/Darwin", function() {
            return no(A2(Bc, h, A2(Ec, 570, bo(0))));
        }),
        b("Australia/Eucla", function() {
            return no(A2(Bc, h, A2(Ec, 525, Cc(ul))));
        }),
        b("Australia/Hobart", function() {
            return no(A2(Bc, h, A2(Ec, 600, Cc(as))));
        }),
        b("Australia/Lindeman", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1971, 0, 1, 0, 2)),
                b(A2(Ec, 600, Cc(tl)), A5(Pc, 1992, 6, 1, 0, 2))
            ]), A2(Ec, 600, Cc(al))));
        }),
        b("Australia/Lord_Howe", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1981, 2, 1, 0, 2)),
                b(A2(Ec, 630, Cc(il)), A5(Pc, 1985, 6, 1, 0, 2))
            ]), A2(Ec, 630, Cc(il))));
        }),
        b("Australia/Melbourne", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1971, 0, 1, 0, 2))
            ]), A2(Ec, 600, Cc(cl))));
        }),
        b("Australia/Perth", function() {
            return no(A2(Bc, h, A2(Ec, 480, Cc(ul))));
        }),
        b("Australia/Sydney", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 1971, 0, 1, 0, 2))
            ]), A2(Ec, 600, Cc(el))));
        }),
        b("Europe/Amsterdam", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1977, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Andorra", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1985, 2, 31, 120, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Astrakhan", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2016, 2, 27, 120, 1))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Europe/Athens", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(ol)), A5(Pc, 1981, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Belgrade", fl),
        b("Europe/Berlin", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1980, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Bratislava", ll),
        b("Europe/Brussels", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1977, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Bucharest", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, Cc(bl)), A5(Pc, 1981, 2, 29, 120, 1)),
                b(A2(Ec, 120, Cc(Of)), A5(Pc, 1991, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(bl)), A5(Pc, 1994, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1997, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Budapest", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(vl)), A5(Pc, 1984, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Busingen", pl),
        b("Europe/Chisinau", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1990, 4, 6, 120, 2)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 1992, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1997, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc($l))));
        }),
        b("Europe/Copenhagen", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1980, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Dublin", function() {
            return no(A2(Bc, h, A2(Ec, 60, Cc(hl))));
        }),
        b("Europe/Gibraltar", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1982, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Guernsey", xl),
        b("Europe/Helsinki", yl),
        b("Europe/Isle_of_Man", _l),
        b("Europe/Istanbul", Ss),
        b("Europe/Jersey", Al),
        b("Europe/Kaliningrad", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 120, bo(0))));
        }),
        b("Europe/Kiev", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1990, 6, 1, 120, 2)),
                b(A2(Ec, 120, bo(60)), A5(Pc, 1991, 8, 29, 180, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1995, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Kirov", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 180, bo(0))));
        }),
        b("Europe/Lisbon", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1976, 8, 26, 60, 2)),
                b(A2(Ec, 0, Cc(Ws)), A5(Pc, 1983, 8, 25, 60, 1)),
                b(A2(Ec, 0, Cc(Ks)), A5(Pc, 1992, 8, 27, 60, 1)),
                b(A2(Ec, 60, Cc(Do)), A5(Pc, 1996, 2, 31, 60, 0))
            ]), A2(Ec, 0, Cc(Do))));
        }),
        b("Europe/Ljubljana", Cl),
        b("Europe/London", wl),
        b("Europe/Luxembourg", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1977, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Madrid", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(Bl)), A5(Pc, 1979, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Malta", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(El)), A5(Pc, 1973, 2, 31, 0, 2)),
                b(A2(Ec, 60, Cc(Dl)), A5(Pc, 1981, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Mariehamn", ql),
        b("Europe/Minsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1990, 0, 1, 0, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1))
            ]), A2(Ec, 180, bo(0))));
        }),
        b("Europe/Monaco", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(Fl)), A5(Pc, 1977, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Moscow", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 180, bo(0))));
        }),
        b("Europe/Nicosia", Pl),
        b("Europe/Oslo", ss),
        b("Europe/Paris", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(Fl)), A5(Pc, 1977, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Podgorica", zl),
        b("Europe/Prague", sl),
        b("Europe/Riga", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 120, bo(60)), A5(Pc, 1989, 8, 24, 120, 1)),
                b(A2(Ec, 120, Cc(jl)), A5(Pc, 1997, 0, 21, 0, 2)),
                b(A2(Ec, 120, Cc(Do)), A5(Pc, 2e3, 1, 29, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2001, 0, 2, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Rome", Sl),
        b("Europe/Samara", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 1991, 8, 29, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 1991, 9, 20, 180, 2)),
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 2010, 2, 28, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Europe/San_Marino", Ll),
        b("Europe/Sarajevo", Ml),
        b("Europe/Saratov", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1988, 2, 27, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2016, 11, 4, 120, 1))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Europe/Simferopol", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1990, 0, 1, 0, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 1990, 6, 1, 120, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 1992, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1994, 4, 1, 0, 2)),
                b(A2(Ec, 180, Cc(dl)), A5(Pc, 1996, 2, 31, 0, 1)),
                b(A2(Ec, 180, bo(60)), A5(Pc, 1996, 9, 27, 180, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1997, 0, 1, 0, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 1997, 2, 30, 60, 0)),
                b(A2(Ec, 120, Cc(Do)), A5(Pc, 2014, 2, 30, 120, 2)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1))
            ]), A2(Ec, 180, bo(0))));
        }),
        b("Europe/Skopje", Nl),
        b("Europe/Sofia", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 120, bo(0)), A5(Pc, 1979, 2, 31, 1380, 2)),
                b(A2(Ec, 120, Cc(Hl)), A5(Pc, 1982, 8, 26, 180, 2)),
                b(A2(Ec, 120, Cc(Of)), A5(Pc, 1991, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1997, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Stockholm", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1980, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Tallinn", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 120, bo(60)), A5(Pc, 1989, 8, 24, 120, 1)),
                b(A2(Ec, 120, Cc(Of)), A5(Pc, 1998, 8, 22, 0, 2)),
                b(A2(Ec, 120, Cc(Do)), A5(Pc, 1999, 9, 31, 240, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2002, 1, 21, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Tirane", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(Tl)), A5(Pc, 1984, 6, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Ulyanovsk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 1992, 0, 19, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2016, 2, 27, 120, 1))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Europe/Uzhgorod", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1990, 0, 1, 0, 2)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 1990, 6, 1, 120, 2)),
                b(A2(Ec, 60, bo(0)), A5(Pc, 1991, 2, 31, 180, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 1992, 0, 1, 0, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1995, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Vaduz", Il),
        b("Europe/Vatican", Rl),
        b("Europe/Vienna", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, Cc(Zl)), A5(Pc, 1981, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Vilnius", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1989, 2, 26, 120, 1)),
                b(A2(Ec, 120, Cc(ps)), A5(Pc, 1991, 8, 29, 120, 1)),
                b(A2(Ec, 120, Cc(Of)), A5(Pc, 1998, 0, 1, 0, 2)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 1998, 2, 29, 60, 0)),
                b(A2(Ec, 60, Cc(Do)), A5(Pc, 1999, 9, 31, 60, 0)),
                b(A2(Ec, 120, bo(0)), A5(Pc, 2003, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Volgograd", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 240, Cc(ps)), A5(Pc, 1988, 2, 27, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 1992, 2, 29, 120, 1)),
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 2011, 2, 27, 120, 1)),
                b(A2(Ec, 240, bo(0)), A5(Pc, 2014, 9, 26, 120, 1)),
                b(A2(Ec, 180, bo(0)), A5(Pc, 2018, 9, 28, 120, 1))
            ]), A2(Ec, 240, bo(0))));
        }),
        b("Europe/Warsaw", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 60, bo(0)), A5(Pc, 1977, 0, 1, 0, 2)),
                b(A2(Ec, 60, Cc(Ks)), A5(Pc, 1988, 0, 1, 0, 2))
            ]), A2(Ec, 60, Cc(Do))));
        }),
        b("Europe/Zagreb", Vl),
        b("Europe/Zaporozhye", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 180, Cc(ps)), A5(Pc, 1991, 2, 31, 120, 2)),
                b(A2(Ec, 120, Cc(dl)), A5(Pc, 1995, 0, 1, 0, 2))
            ]), A2(Ec, 120, Cc(Do))));
        }),
        b("Europe/Zurich", ml),
        b("Indian/Antananarivo", Yl),
        b("Indian/Chagos", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 300, bo(0)), A5(Pc, 1996, 0, 1, 0, 2))
            ]), A2(Ec, 360, bo(0))));
        }),
        b("Indian/Christmas", function() {
            return no(A2(Bc, h, A2(Ec, 420, bo(0))));
        }),
        b("Indian/Cocos", function() {
            return no(A2(Bc, h, A2(Ec, 390, bo(0))));
        }),
        b("Indian/Comoro", Ql),
        b("Indian/Kerguelen", function() {
            return no(A2(Bc, h, A2(Ec, 300, bo(0))));
        }),
        b("Indian/Mahe", function() {
            return no(A2(Bc, h, A2(Ec, 240, bo(0))));
        }),
        b("Indian/Maldives", function() {
            return no(A2(Bc, h, A2(Ec, 300, bo(0))));
        }),
        b("Indian/Mauritius", function() {
            return no(A2(Bc, h, A2(Ec, 240, Cc(Ol))));
        }),
        b("Indian/Mayotte", Gl),
        b("Indian/Reunion", function() {
            return no(A2(Bc, h, A2(Ec, 240, bo(0))));
        }),
        b("Pacific/Apia", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -660, Cc(Jl)), A5(Pc, 2011, 11, 29, 1440, 2))
            ]), A2(Ec, 780, Cc(Jl))));
        }),
        b("Pacific/Auckland", cs),
        b("Pacific/Bougainville", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 600, bo(0)), A5(Pc, 2014, 11, 28, 120, 2))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Pacific/Chatham", function() {
            return no(A2(Bc, h, A2(Ec, 765, Cc(Wl))));
        }),
        b("Pacific/Chuuk", function() {
            return no(A2(Bc, h, A2(Ec, 600, bo(0))));
        }),
        b("Pacific/Easter", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -420, Cc(Yf)), A5(Pc, 1982, 2, 14, 180, 0))
            ]), A2(Ec, -360, Cc(Yf))));
        }),
        b("Pacific/Efate", function() {
            return no(A2(Bc, h, A2(Ec, 660, Cc(Kl))));
        }),
        b("Pacific/Enderbury", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -720, bo(0)), A5(Pc, 1979, 9, 1, 0, 2)),
                b(A2(Ec, -660, bo(0)), A5(Pc, 1994, 11, 31, 0, 2))
            ]), A2(Ec, 780, bo(0))));
        }),
        b("Pacific/Fakaofo", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -660, bo(0)), A5(Pc, 2011, 11, 30, 0, 2))
            ]), A2(Ec, 780, bo(0))));
        }),
        b("Pacific/Fiji", function() {
            return no(A2(Bc, h, A2(Ec, 720, Cc(Xl))));
        }),
        b("Pacific/Funafuti", function() {
            return no(A2(Bc, h, A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Galapagos", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -300, bo(0)), A5(Pc, 1986, 0, 1, 0, 2))
            ]), A2(Ec, -360, Cc(jf))));
        }),
        b("Pacific/Gambier", function() {
            return no(A2(Bc, h, A2(Ec, -540, bo(0))));
        }),
        b("Pacific/Guadalcanal", function() {
            return no(A2(Bc, h, A2(Ec, 660, bo(0))));
        }),
        b("Pacific/Guam", rd),
        b("Pacific/Honolulu", function() {
            return no(A2(Bc, h, A2(Ec, -600, bo(0))));
        }),
        b("Pacific/Kiritimati", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -640, bo(0)), A5(Pc, 1979, 9, 1, 0, 2)),
                b(A2(Ec, -600, bo(0)), A5(Pc, 1994, 11, 31, 0, 2))
            ]), A2(Ec, 840, bo(0))));
        }),
        b("Pacific/Kosrae", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 720, bo(0)), A5(Pc, 1999, 0, 1, 0, 2))
            ]), A2(Ec, 660, bo(0))));
        }),
        b("Pacific/Kwajalein", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -720, bo(0)), A5(Pc, 1993, 7, 20, 1440, 2))
            ]), A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Majuro", function() {
            return no(A2(Bc, h, A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Marquesas", function() {
            return no(A2(Bc, h, A2(Ec, -570, bo(0))));
        }),
        b("Pacific/Midway", ed),
        b("Pacific/Nauru", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 690, bo(0)), A5(Pc, 1979, 1, 10, 120, 2))
            ]), A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Niue", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -690, bo(0)), A5(Pc, 1978, 9, 1, 0, 2))
            ]), A2(Ec, -660, bo(0))));
        }),
        b("Pacific/Norfolk", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 690, bo(0)), A5(Pc, 1974, 9, 27, 120, 1)),
                b(A2(Ec, 690, bo(60)), A5(Pc, 1975, 2, 2, 120, 1)),
                b(A2(Ec, 690, bo(0)), A5(Pc, 2015, 9, 4, 120, 1)),
                b(A2(Ec, 660, bo(0)), A5(Pc, 2019, 6, 1, 0, 2))
            ]), A2(Ec, 660, Cc(el))));
        }),
        b("Pacific/Noumea", function() {
            return no(A2(Bc, h, A2(Ec, 660, Cc(ud))));
        }),
        b("Pacific/Pago_Pago", td),
        b("Pacific/Palau", function() {
            return no(A2(Bc, h, A2(Ec, 540, bo(0))));
        }),
        b("Pacific/Pitcairn", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -510, bo(0)), A5(Pc, 1998, 3, 27, 0, 2))
            ]), A2(Ec, -480, bo(0))));
        }),
        b("Pacific/Pohnpei", function() {
            return no(A2(Bc, h, A2(Ec, 660, bo(0))));
        }),
        b("Pacific/Port_Moresby", function() {
            return no(A2(Bc, h, A2(Ec, 600, bo(0))));
        }),
        b("Pacific/Rarotonga", function() {
            return no(A2(Bc, x([
                b(A2(Ec, -630, bo(0)), A5(Pc, 1978, 10, 12, 0, 2))
            ]), A2(Ec, -600, Cc(ad))));
        }),
        b("Pacific/Saipan", id),
        b("Pacific/Tahiti", function() {
            return no(A2(Bc, h, A2(Ec, -600, bo(0))));
        }),
        b("Pacific/Tarawa", function() {
            return no(A2(Bc, h, A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Tongatapu", function() {
            return no(A2(Bc, x([
                b(A2(Ec, 780, bo(0)), A5(Pc, 1999, 0, 1, 0, 2))
            ]), A2(Ec, 780, Cc(cd))));
        }),
        b("Pacific/Wake", function() {
            return no(A2(Bc, h, A2(Ec, 720, bo(0))));
        }),
        b("Pacific/Wallis", function() {
            return no(A2(Bc, h, A2(Ec, 720, bo(0))));
        })
    ])), fd = A2(Du, function(n) {
        if (n.$) return so(fo);
        var r = n.a, t = A2(Wu, r, od);
        return t.$ ? so({
            $: 1,
            a: r
        }) : _u(b(r, (0, t.a)(0)));
    }, lo), sd = ar, ld = sd, dd = function(n) {
        var r = n.Eb;
        return {
            g4: Ie,
            rh: n.rh,
            $7: function(n) {
                return A2(ru, r(n), ld);
            },
            kK: n.Ed,
            aP: !1
        };
    }, bd = function(n) {
        return n.ti;
    }, vd = function(n) {
        return n.wp;
    }, md = function(n) {
        return n.gI.w5;
    }, pd = function(n) {
        return n.Y.w5;
    }, $d = function(n) {
        return n.dg.w5;
    }, hd = function(n) {
        return n.hD.pX;
    }, gd = function(n) {
        return n.hD.qe;
    }, wd = function(n) {
        return n.hD.w5;
    }, xd = function(n) {
        return n.g.ya;
    }, kd = function(n) {
        return n.g.mA;
    }, yd = function(n) {
        return n.g.nA;
    }, _d = function(n) {
        return n.g.oF;
    }, Ad = function(n) {
        return n.g.oG;
    }, Cd = function(n) {
        return n.g.oH;
    }, Bd = function(n) {
        return n.g.y6;
    }, Ed = function(n) {
        return n.g.oI;
    }, Dd = function(n) {
        return n.g.oJ;
    }, qd = function(n) {
        return n.g.zw;
    }, Fd = function(n) {
        return n.g.pD;
    }, Pd = function(n) {
        return n.g.pE;
    }, zd = function(n) {
        return n.g.pF;
    }, jd = function(n) {
        return n.g.rA;
    }, Sd = function(n) {
        return n.g.dr;
    }, Ld = function(n) {
        return n.g.tA;
    }, Md = function(n) {
        return n.g.Cj;
    }, Nd = function(n) {
        return n.g.uf;
    }, Hd = function(n) {
        return n.g.uq;
    }, Td = function(n) {
        return n.g.ur;
    }, Id = function(n) {
        return n.g.uG;
    }, Rd = function(n) {
        return n.g.wV;
    }, Zd = function(n) {
        return n.g.D$;
    }, Vd = function(n) {
        return n.g.w5;
    }, Ud = function(n) {
        return n.g.Ee;
    }, Yd = function(n) {
        return n.g.xg;
    }, Qd = function(n) {
        return n.g.xj;
    }, Od = function(n) {
        return n.g.xU;
    }, Gd = function(n) {
        return n.g.EE;
    }, Jd = {
        l1: function(n) {
            return n.A8.l1;
        },
        l2: function(n) {
            return n.A8.l2;
        },
        l3: function(n) {
            return n.A8.l3;
        },
        l4: function(n) {
            return n.A8.l4;
        },
        l6: function(n) {
            return n.A8.l6;
        },
        l7: function(n) {
            return n.A8.l7;
        },
        l8: function(n) {
            return n.A8.l8;
        },
        mg: function(n) {
            return n.A8.mg;
        },
        zn: function(n) {
            return n.A8.zn;
        },
        pM: function(n) {
            return n.A8.pM;
        },
        pU: function(n) {
            return n.A8.pU;
        },
        q0: function(n) {
            return n.A8.q0;
        },
        q1: function(n) {
            return n.A8.q1;
        },
        q2: function(n) {
            return n.A8.q2;
        },
        q3: function(n) {
            return n.A8.q3;
        },
        rl: function(n) {
            return n.A8.rl;
        },
        rm: function(n) {
            return n.A8.rm;
        },
        dr: function(n) {
            return n.A8.dr;
        },
        sj: function(n) {
            return n.A8.sj;
        },
        A_: function(n) {
            return n.A8.A_;
        },
        tt: function(n) {
            return n.A8.tt;
        },
        w5: function(n) {
            return n.A8.w5;
        },
        EE: function(n) {
            return n.A8.EE;
        }
    }, Wd = {
        ot: function(n) {
            return n.aa.ot;
        },
        oP: function(n) {
            return n.aa.oP;
        },
        oU: function(n) {
            return n.aa.oU;
        },
        p1: function(n) {
            return n.aa.p1;
        },
        p2: function(n) {
            return n.aa.p2;
        },
        is: function(n) {
            return n.aa.is;
        },
        vF: function(n) {
            return n.aa.vF;
        },
        iU: function(n) {
            return n.aa.iU;
        },
        w5: function(n) {
            return n.aa.w5;
        },
        Ea: function(n) {
            return n.aa.Ea;
        },
        EE: function(n) {
            return n.aa.EE;
        },
        x_: function(n) {
            return n.aa.x_;
        }
    }, Kd = function(n) {
        return n.J.x8;
    }, Xd = function(n) {
        return n.J.yV;
    }, nb = function(n) {
        return n.J.qo;
    }, rb = function(n) {
        return n.J.zX;
    }, tb = function(n) {
        return n.J.zY;
    }, eb = function(n) {
        return n.J.qp;
    }, ub = function(n) {
        return n.J.zZ;
    }, ab = function(n) {
        return n.J.to;
    }, ib = function(n) {
        return n.J.tp;
    }, cb = function(n) {
        return n.J.tq;
    }, ob = function(n) {
        return n.J.tr;
    }, fb = function(n) {
        return n.J.ts;
    }, sb = function(n) {
        return n.J.w5;
    }, lb = function(n) {
        return n.Cw.l1;
    }, db = function(n) {
        return n.Cw.l9;
    }, bb = function(n) {
        return n.Cw.gT;
    }, vb = function(n) {
        return n.Cw.oD;
    }, mb = function(n) {
        return n.Cw.pw;
    }, pb = function(n) {
        return n.Cw.pN;
    }, $b = function(n) {
        return n.Cw.hr;
    }, hb = function(n) {
        return n.Cw.hs;
    }, gb = function(n) {
        return n.Cw.rD;
    }, wb = function(n) {
        return n.Cw.dr;
    }, xb = function(n) {
        return n.Cw.si;
    }, kb = function(n) {
        return n.Cw.ug;
    }, yb = function(n) {
        return n.Cw.Db;
    }, _b = function(n) {
        return n.Cw.w5;
    }, Ab = function(n) {
        return n.Cw.xe;
    }, Cb = function(n) {
        return n.Cw.jQ;
    }, Bb = function(n) {
        return n.Cw.EE;
    }, Eb = function(n) {
        return n.Cw.x0;
    }, Db = function(n) {
        return n.Cw.x2;
    }, qb = function(n) {
        return n.lk.v7;
    }, Fb = function(n) {
        return n.lk.w5;
    }, Pb = function(n) {
        switch(n){
            case 0:
                return Vd;
            case 1:
                return Jd.w5;
            case 2:
                return Wd.w5;
            case 3:
                return _b;
            case 4:
                return pd;
            case 5:
                return $d;
            case 6:
                return Fb;
            case 7:
                return wd;
            case 8:
                return sb;
            default:
                return md;
        }
    }, zb = F3(function(n, r, t) {
        return r(t.$ ? n ? bd : vd : Pb(t.a));
    }), jb = function(n) {
        return n.$ ? "LogOut" : function(n) {
            switch(n){
                case 0:
                    return "Invoices";
                case 1:
                    return "Members";
                case 2:
                    return "Memberships";
                case 3:
                    return "PaymentSources";
                case 4:
                    return "Documents";
                case 5:
                    return "ExploreServices";
                case 6:
                    return "ProviderLocation";
                case 7:
                    return "HealthInformation";
                case 8:
                    return "Chat";
                default:
                    return "Booking";
            }
        }(n.a);
    }, Sb = function(n) {
        return {
            b$: !1,
            dH: dd({
                rh: "profile-menu",
                Eb: zb(n),
                Ed: A2(ru, jb, Vt)
            })
        };
    }, Lb = Sb(!1), Mb = function(n) {
        return n.p4;
    }, Nb = function(n) {
        return n.wC;
    }, Hb = function(n) {
        return n ? Nb : Mb;
    }, Tb = function(n) {
        return n ? "es" : "en";
    }, Ib = function(n) {
        return {
            rh: n,
            AL: 0,
            fC: dd({
                rh: n + "-preferred-language-select",
                Eb: function(n) {
                    return A2(ru, Hb, n);
                },
                Ed: function(n) {
                    return Vt(Tb(n));
                }
            })
        };
    }, Rb = S, Zb = function(n) {
        return A2(Rb, n, "");
    }, Vb = F3(function(n, r, t) {
        return n > 0 ? A3(Vb, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), Ub = F2(function(n, r) {
        return A3(Vb, n, r, "");
    }), Yb = F3(function(n, r, t) {
        return $(A2(Ub, n - su(t), Zb(r)), t);
    }), Qb = F2(function(n, r) {
        var t = function() {
            switch(r){
                case 1:
                    return "1st";
                case 21:
                    return "21st";
                case 2:
                    return "2nd";
                case 22:
                    return "22nd";
                case 3:
                    return "3rd";
                case 23:
                    return "23rd";
                case 31:
                    return "31st";
                default:
                    return oe(r) + "th";
            }
        }();
        return n ? A3(Yb, 4, " ", t) : t;
    }), Ob = {
        z4: {
            oY: "%-m/%-d/%Y",
            zg: "%-m/%-d/%Y %-I:%M %p",
            hx: 6,
            AU: "%A, %B %d, %Y",
            AV: "%-I:%M:%S %p",
            D7: "%-I:%M %p"
        },
        aw: {
            o1: function(n) {
                switch(n){
                    case 0:
                        return "Monday";
                    case 1:
                        return "Tuesday";
                    case 2:
                        return "Wednesday";
                    case 3:
                        return "Thursday";
                    case 4:
                        return "Friday";
                    case 5:
                        return "Saturday";
                    default:
                        return "Sunday";
                }
            },
            o2: Qb,
            o3: function(n) {
                switch(n){
                    case 0:
                        return "Mon";
                    case 1:
                        return "Tue";
                    case 2:
                        return "Wed";
                    case 3:
                        return "Thu";
                    case 4:
                        return "Fri";
                    case 5:
                        return "Sat";
                    default:
                        return "Sun";
                }
            },
            tc: function(n) {
                switch(n){
                    case 0:
                        return "January";
                    case 1:
                        return "February";
                    case 2:
                        return "March";
                    case 3:
                        return "April";
                    case 4:
                        return "May";
                    case 5:
                        return "June";
                    case 6:
                        return "July";
                    case 7:
                        return "August";
                    case 8:
                        return "September";
                    case 9:
                        return "October";
                    case 10:
                        return "November";
                    default:
                        return "December";
                }
            },
            td: function(n) {
                switch(n){
                    case 0:
                        return "Jan";
                    case 1:
                        return "Feb";
                    case 2:
                        return "Mar";
                    case 3:
                        return "Apr";
                    case 4:
                        return "May";
                    case 5:
                        return "Jun";
                    case 6:
                        return "Jul";
                    case 7:
                        return "Aug";
                    case 8:
                        return "Sep";
                    case 9:
                        return "Oct";
                    case 10:
                        return "Nov";
                    default:
                        return "Dec";
                }
            },
            xm: function(n) {
                return n ? "PM" : "AM";
            }
        }
    }, Gb = F4(function(n, r, t, e) {
        return {
            kE: r,
            kP: n,
            tA: t,
            DY: e
        };
    }), Jb = ot, Wb = function(n) {
        return A2(Jb, {
            yL: !1,
            Bg: !1
        }, n);
    }, Kb = /.^/, Xb = A2(sc, Kb, Wb("%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)")), nv = F2(function(n, r) {
        return r.$ ? Ut : n(r.a);
    }), rv = function(n) {
        return n.b ? Vt(n.a) : Ut;
    }, tv = function(n) {
        return A2(jc, 12, n) ? A2(jc, 12, n) : 12;
    }, ev = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, uv = function(n) {
        return A2(pc, A2(Yb, 2, n), oe);
    }, av = F2(function(n, r) {
        return A2(pc, A2(Yb, n, r), oe);
    }), iv = F2(function(n, r) {
        return 1 > n ? "" : A3(lu, -n, su(r), r);
    }), cv = F2(function(n, r) {
        return Re(n / r);
    }), ov = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > s(e.wH, r)) return r + e.ic;
            t = u;
        }
    }), fv = F2(function(n, r) {
        var t = n.b;
        return A3(ov, n.a, A2(cv, r, 6e4), t);
    }), sv = function(n) {
        var r = A2(cv, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, c = i + (10 > i ? 3 : -9);
        return {
            o0: a - ((153 * i + 2) / 5 | 0) + 1,
            tb: c,
            xQ: u + 400 * t + (c > 2 ? 0 : 1)
        };
    }, lv = F2(function(n, r) {
        return sv(A2(fv, n, r)).o0;
    }), dv = F2(function(n, r) {
        return A2(jc, 24, A2(cv, A2(fv, n, r), 60));
    }), bv = F2(function(n, r) {
        return A2(jc, 1e3, r);
    }), vv = F2(function(n, r) {
        return A2(jc, 60, A2(fv, n, r));
    }), mv = F2(function(n, r) {
        switch(sv(A2(fv, n, r)).tb){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), pv = F2(function(n, r) {
        return A2(jc, 60, A2(cv, r, 1e3));
    }), $v = function(n) {
        return n.toUpperCase();
    }, hv = F2(function(n, r) {
        switch(A2(jc, 7, A2(cv, A2(fv, n, r), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), gv = F2(function(n, r) {
        return sv(A2(fv, n, r)).xQ;
    }), wv = F2(function(n, r) {
        return 12 > A2(dv, n, r) ? 0 : 1;
    }), xv = F4(function(n, r, t, e) {
        var u = A2(sc, " ", function(n) {
            return A2(nv, iu, n);
        }(rv(e.DY)));
        switch(u){
            case "Y":
                return A3(av, 4, "0", A2(gv, r, t));
            case "y":
                return A2(iv, 2, A3(av, 2, "0", A2(gv, r, t)));
            case "m":
                return A2(uv, "0", ev(A2(mv, r, t)));
            case "_m":
                return A2(uv, " ", ev(A2(mv, r, t)));
            case "-m":
                return oe(ev(A2(mv, r, t)));
            case "B":
                return n.aw.tc(A2(mv, r, t));
            case "^B":
                return $v(n.aw.tc(A2(mv, r, t)));
            case "b":
                return n.aw.td(A2(mv, r, t));
            case "^b":
                return $v(n.aw.td(A2(mv, r, t)));
            case "d":
                return A2(uv, "0", A2(lv, r, t));
            case "-d":
                return oe(A2(lv, r, t));
            case "-@d":
                return A2(n.aw.o2, !1, A2(lv, r, t));
            case "e":
                return A2(uv, " ", A2(lv, r, t));
            case "@e":
                return A2(n.aw.o2, !0, A2(lv, r, t));
            case "A":
                return n.aw.o1(A2(hv, r, t));
            case "^A":
                return $v(n.aw.o1(A2(hv, r, t)));
            case "a":
                return n.aw.o3(A2(hv, r, t));
            case "^a":
                return $v(n.aw.o3(A2(hv, r, t)));
            case "H":
                return A2(uv, "0", A2(dv, r, t));
            case "-H":
                return oe(A2(dv, r, t));
            case "k":
                return A2(uv, " ", A2(dv, r, t));
            case "I":
                return A2(uv, "0", tv(A2(dv, r, t)));
            case "-I":
                return oe(tv(A2(dv, r, t)));
            case "l":
                return A2(uv, " ", tv(A2(dv, r, t)));
            case "p":
                return $v(n.aw.xm(A2(wv, r, t)));
            case "P":
                return n.aw.xm(A2(wv, r, t));
            case "M":
                return A2(uv, "0", A2(vv, r, t));
            case "S":
                return A2(uv, "0", A2(pv, r, t));
            case "L":
                return A3(av, 3, "0", A2(bv, r, t));
            case "%":
                return u;
            default:
                return "";
        }
    }), kv = lt(dt), yv = F4(function(n, r, t, e) {
        return A3(kv, Xb, A3(xv, n, t, e), r);
    }), _v = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Av = function(n) {
        return !A2(jc, 4, n) && !!A2(jc, 100, n) || !A2(jc, 400, n);
    }, Cv = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return Av(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Bv = function(n) {
        switch(A2(Ve, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, Ev = F3(function(n, r, t) {
        for(;;){
            var e = A2(Cv, n, r), u = _v(r);
            if (u >= 12 || 0 >= s(t, e)) return {
                o0: t,
                tb: r,
                xQ: n
            };
            r = Bv(u + 1), t -= e;
        }
    }), Dv = F2(function(n, r) {
        return Re(n / r);
    }), qv = function(n) {
        var r = n - 1;
        return 365 * r + (A2(Dv, r, 4) - A2(Dv, r, 100) + A2(Dv, r, 400));
    }, Fv = F2(function(n, r) {
        return b(A2(Dv, n, r), A2(jc, r, n));
    }), Pv = function(n) {
        var r = A2(Fv, n, 146097), t = r.a, e = A2(Fv, r.b, 36524), u = e.a, a = A2(Fv, e.b, 1461), i = a.a, c = A2(Fv, a.b, 365);
        return 400 * t + 100 * u + 4 * i + c.a + (c.b ? 1 : 0);
    }, zv = function(n) {
        var r = n, t = Pv(r);
        return {
            k5: r - qv(t),
            xQ: t
        };
    }, jv = function(n) {
        var r = zv(n);
        return A3(Ev, r.xQ, 0, r.k5);
    }, Sv = function(n) {
        var r = jv(n);
        return 12 * (r.xQ - 1) + (_v(r.tb) - 1) + r.o0 / 100;
    }, Lv = F3(function(n, r, t) {
        var e = r, u = t;
        switch(n){
            case 0:
                return (Sv(u) - Sv(e) | 0) / 12 | 0;
            case 1:
                return Sv(u) - Sv(e) | 0;
            case 2:
                return (u - e) / 7 | 0;
            default:
                return u - e;
        }
    }), Mv = A2(ru, jv, function(n) {
        return n.o0;
    }), Nv = A2(ru, jv, function(n) {
        return n.tb;
    }), Hv = A2(ru, Nv, _v), Tv = A2(ru, zv, function(n) {
        return n.k5;
    }), Iv = function(n) {
        return 0 > n ? -n : n;
    }, Rv = F2(function(n, r) {
        return $(0 > r ? "-" : "", A3(Yb, n, "0", oe(Iv(r))));
    }), Zv = function(n) {
        return (_v(n) + 2) / 3 | 0;
    }, Vv = A2(ru, Nv, Zv), Uv = function(n) {
        return A2(jc, 7, n) || 7;
    }, Yv = function(n) {
        var r = qv(n) + 4;
        return r - Uv(r);
    }, Qv = function(n) {
        switch(A2(Ve, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, Ov = function(n) {
        var r = n, t = Uv(r), e = Pv(r + (4 - t));
        return {
            xJ: 1 + ((r - (Yv(e) + 1)) / 7 | 0),
            xK: e,
            Ex: Qv(t)
        };
    }, Gv = A2(ru, Ov, function(n) {
        return n.xJ;
    }), Jv = A2(ru, Ov, function(n) {
        return n.xK;
    }), Wv = A2(ru, Uv, Qv), Kv = F2(function(n, r) {
        return 0 > s(n, r) ? n : r;
    }), Xv = function(n) {
        return $(oe(n), function(n) {
            var r = A2(jc, 100, n);
            switch(A2(Kv, 20 > r ? r : A2(jc, 10, r), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(n));
    }, nm = F4(function(n, r, t, e) {
        switch(r){
            case "y":
                return 2 === t ? A2(iv, 2, A3(Yb, 2, "0", oe(Pv(e)))) : A2(Rv, t, Pv(e));
            case "Y":
                return 2 === t ? A2(iv, 2, A3(Yb, 2, "0", oe(Jv(e)))) : A2(Rv, t, Jv(e));
            case "Q":
                switch(t){
                    case 1:
                    case 2:
                    case 5:
                        return oe(Vv(e));
                    case 3:
                        return "Q" + oe(Vv(e));
                    case 4:
                        return Xv(Vv(e));
                    default:
                        return "";
                }
            case "M":
                switch(t){
                    case 1:
                        return oe(Hv(e));
                    case 2:
                        return A3(Yb, 2, "0", oe(Hv(e)));
                    case 3:
                        return n.h5(Nv(e));
                    case 4:
                        return n.tc(Nv(e));
                    case 5:
                        return A2(mu, 1, n.h5(Nv(e)));
                    default:
                        return "";
                }
            case "w":
                switch(t){
                    case 1:
                        return oe(Gv(e));
                    case 2:
                        return A3(Yb, 2, "0", oe(Gv(e)));
                    default:
                        return "";
                }
            case "d":
                switch(t){
                    case 1:
                        return oe(Mv(e));
                    case 2:
                        return A3(Yb, 2, "0", oe(Mv(e)));
                    case 3:
                        return n.kk(Mv(e));
                    default:
                        return "";
                }
            case "D":
                switch(t){
                    case 1:
                        return oe(Tv(e));
                    case 2:
                        return A3(Yb, 2, "0", oe(Tv(e)));
                    case 3:
                        return A3(Yb, 3, "0", oe(Tv(e)));
                    default:
                        return "";
                }
            case "E":
                switch(t){
                    case 1:
                    case 2:
                    case 3:
                        return n.c0(Wv(e));
                    case 4:
                        return n.lO(Wv(e));
                    case 5:
                        return A2(mu, 1, n.c0(Wv(e)));
                    case 6:
                        return A2(mu, 2, n.c0(Wv(e)));
                    default:
                        return "";
                }
            case "e":
                switch(t){
                    case 1:
                    case 2:
                        return oe(Uv(e));
                    default:
                        return A4(nm, n, "E", t, e);
                }
            default:
                return "";
        }
    }), rm = F3(function(n, r, t) {
        return A3(de, F2(function(r, e) {
            return $(r.$ ? r.a : A4(nm, n, r.a, r.b, t), e);
        }), "", r);
    }), tm = function(n) {
        return {
            $: 1,
            a: n
        };
    }, em = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), um = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), am = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(em, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var c = i.a;
                return A2(em, u || c, i.b);
            }
            return c = i.a, A3(um, u || c, i.b, i.c);
        };
    }), im = am, cm = F2(function(n) {
        return n;
    }), om = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(em, t.a, t.b);
            var a = t.a, i = t.b, c = u(t.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(em, a || o, c.b);
            }
            o = c.a;
            var f = c.c;
            return A3(um, a || o, A2(n, i, c.b), f);
        };
    }), fm = F2(function(n, r) {
        return A3(om, cm, n, r);
    }), sm = fm, lm = function(n) {
        return function(r) {
            return A3(um, !1, n, r);
        };
    }, dm = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), bm = function(n) {
        return A2(dm, n, {
            $: 0,
            a: n
        });
    }, vm = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), mm = F4(function(n, r, t, e) {
        return {
            nQ: r,
            y2: e,
            u$: t,
            vZ: n
        };
    }), pm = {
        $: 0
    }, $m = F2(function(n, r) {
        return A2(vm, pm, A4(mm, n.vZ, n.nQ, r, n.e));
    }), hm = bt, gm = function(n) {
        return !n;
    }, wm = function(n) {
        var r = n.a, t = n.b, e = !vu(r);
        return function(n) {
            var u = A5(hm, r, n.ic, n.vZ, n.nQ, n.d), a = u.a, c = u.b, o = u.c;
            return i(a, -1) ? A2(em, !1, A2($m, n, t)) : A3(um, e, 0, {
                nQ: o,
                e: n.e,
                m: n.m,
                ic: a,
                vZ: c,
                d: n.d
            });
        };
    }, xm = function(n) {
        return wm(bm(n));
    }, km = A2(sm, lm(tm("'")), xm("''")), ym = {
        $: 11
    }, _m = vt, Am = F2(function(n, r) {
        return function(t) {
            var e = A3(_m, n, t.ic, t.d);
            return i(e, -1) ? A2(em, !1, A2($m, t, r)) : i(e, -2) ? A3(um, !0, 0, {
                nQ: 1,
                e: t.e,
                m: t.m,
                ic: t.ic + 1,
                vZ: t.vZ + 1,
                d: t.d
            }) : A3(um, !0, 0, {
                nQ: t.nQ + 1,
                e: t.e,
                m: t.m,
                ic: e,
                vZ: t.vZ,
                d: t.d
            });
        };
    }), Cm = function(n) {
        return A2(Am, n, ym);
    }, Bm = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Em = F5(function(n, r, t, e, u) {
        for(;;){
            var a = A3(_m, n, r, u.d);
            if (i(a, -1)) return A3(um, 0 > s(u.ic, r), 0, {
                nQ: e,
                e: u.e,
                m: u.m,
                ic: r,
                vZ: t,
                d: u.d
            });
            i(a, -2) ? (r += 1, t += 1, e = 1) : (r = a, e += 1);
        }
    }), Dm = function(n) {
        return function(r) {
            return A5(Em, n, r.ic, r.vZ, r.nQ, r);
        };
    }, qm = Dm, Fm = function(n) {
        return A3(um, !1, n.ic, n);
    }, Pm = F2(function(n, r) {
        return A3(om, He, n, r);
    }), zm = Pm, jm = function(n) {
        var r;
        return r = {
            $: 12,
            a: n
        }, function(n) {
            return A2(em, !1, A2($m, n, r));
        };
    }, Sm = H, Lm = function(n) {
        return A3(Sm, Yt, h, n);
    }, Mm = function(n) {
        var r = Lm(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return A2(zm, A2(zm, lm(F2(function(n, r) {
                return A2(Bm, t, r - n + 1);
            })), A2(sm, Fm, qm(Ie(t)))), Fm);
        }
        return jm("expected exactly one char");
    }, Nm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(em, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(um, e.a, A2(n, A3(lu, r.ic, a.ic, r.d), u), a);
        };
    }), Hm = function(n) {
        return A2(Nm, cm, n);
    }, Tm = A2(im, Mm, Hm(Cm(ke))), Im = A2(de, F2(function(n, r) {
        var t = b(n, r);
        if (1 === t.a.$ && t.b.b && 1 === t.b.a.$) {
            var e = t.b, u = e.b;
            return A2(Yt, tm($(t.a.a, e.a.a)), u);
        }
        return A2(Yt, n, r);
    }), h), Rm = function(n) {
        return "'" !== n && !ke(n);
    }, Zm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(em, e.a, e.b);
            var u = e.c;
            return A3(um, e.a, n(e.b), u);
        };
    }), Vm = Zm, Um = A2(Vm, tm, Hm(A2(sm, A2(sm, lm(0), Cm(Rm)), qm(Rm)))), Ym = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Qm = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(Ym, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(em, !1, r);
        }
    }), Om = function(n) {
        return function(r) {
            return A3(Qm, r, pm, n);
        };
    }, Gm = (Lu = {
        $: 10
    }, function(n) {
        return i(su(n.d), n.ic) ? A3(um, !1, 0, n) : A2(em, !1, A2($m, n, Lu));
    }), Jm = function(n) {
        return Om(x([
            A2(im, function(r) {
                return Jm($(n, r));
            }, Hm(A2(sm, A2(sm, lm(0), Cm(Mc("'"))), qm(Mc("'"))))),
            A2(im, function() {
                return Jm(n + "'");
            }, xm("''")),
            lm(n)
        ]));
    }, Wm = A2(zm, A2(sm, lm(tm), Cm(Ie("'"))), A2(sm, Jm(""), Om(x([
        Cm(Ie("'")),
        Gm
    ])))), Km = function(n) {
        var r;
        return Om(x([
            A2(im, function(r) {
                return Km(A2(Yt, r, n));
            }, Om(x([
                Tm,
                Um,
                km,
                Wm
            ]))),
            (r = function() {
                return lm(Im(n));
            }, function(n) {
                return r(0)(n);
            })
        ]));
    }, Xm = F3(function(n, r, t) {
        return {
            nQ: r,
            u$: t,
            vZ: n
        };
    }), np = function(n) {
        return A3(Xm, n.vZ, n.nQ, n.u$);
    }, rp = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(Yt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(rp, e, r);
                continue n;
        }
    }), tp = F2(function(n, r) {
        var t = n({
            nQ: 1,
            e: h,
            m: 1,
            ic: 0,
            vZ: 1,
            d: r
        });
        return t.$ ? Kt(A2(rp, t.b, h)) : te(t.b);
    }), ep = F2(function(n, r) {
        var t = A2(tp, n, r);
        return t.$ ? Kt(A2(Eu, np, t.a)) : te(t.a);
    }), up = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), ap = F2(function(n, r) {
        var t, e = Ae(A2(up, x([
            tm(t = r)
        ]), A2(ep, Km(h), t)));
        return A2(rm, n, e);
    }), ip = function(n) {
        switch(n){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, cp = function(n) {
        switch(n){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, op = {
        kk: Xv,
        tc: ip,
        h5: A2(ru, ip, mu(3)),
        lO: cp,
        c0: A2(ru, cp, mu(3))
    }, fp = function(n) {
        return A2(ap, op, n);
    }, sp = F3(function(n, r, t) {
        return 0 > s(t, n) ? n : s(t, r) > 0 ? r : t;
    }), lp = F2(function(n, r) {
        var t = Av(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), dp = F3(function(n, r, t) {
        return qv(n) + A2(lp, n, r) + A3(sp, 1, A2(Cv, n, r), t);
    }), bp = F2(function(n, r) {
        return A3(dp, A2(gv, n, r), A2(mv, n, r), A2(lv, n, r));
    }), vp = F3(function(n, r, t) {
        var e = A2(bp, n, t), u = A2(bp, n, r), a = A3(Lv, 0, e, u), i = A3(Lv, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4(yv, Ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(fp, "EEEE", e) : A4(yv, Ob, "%l:%M %p", n, t);
    }), mp = F3(function(n, r, t) {
        var e = A2(bp, n, t), u = A2(bp, n, r), a = A3(Lv, 0, e, u), i = A3(Lv, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4(yv, Ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(fp, "EEEE", e) : "Today";
    }), pp = F3(function(n, r, t) {
        var e, u, a = n.EA, i = oe;
        return e = function() {
            switch(t.$){
                case 0:
                    return 1 === (n = t.a) ? "less than 1 second" : "less than " + i(n) + " seconds";
                case 1:
                    return "half a minute";
                case 2:
                    return 1 === (n = t.a) ? "less than a minute" : "less than " + i(n) + " minutes";
                case 3:
                    return 1 === (n = t.a) ? "1 minute" : i(n) + " minutes";
                case 4:
                    return 1 === (n = t.a) ? "about 1 hour" : "about " + i(n) + " hours";
                case 5:
                    return 1 === (n = t.a) ? "1 day" : i(n) + " days";
                case 6:
                    return 1 === (n = t.a) ? "about 1 month" : "about " + i(n) + " months";
                case 7:
                    return 1 === (n = t.a) ? "1 month" : i(n) + " months";
                case 8:
                    return 1 === (n = t.a) ? "about 1 year" : "about " + i(n) + " years";
                case 9:
                    return 1 === (n = t.a) ? "over 1 year" : "over " + i(n) + " years";
                default:
                    var n;
                    return 1 === (n = t.a) ? "almost 1 year" : "almost " + i(n) + " years";
            }
        }(), (u = b(a, r)).a ? u.b ? "in " + e : e + " ago" : e;
    }), $p = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, wp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, xp = 43200, kp = P, yp = {
        $: 1
    }, _p = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ap = F3(function(n, r, t) {
        var e = Iv(t - r) / 1e3 | 0, u = kp(e / 60);
        return n && 2 > u ? function(n) {
            return 5 > n ? _p(5) : 10 > n ? _p(10) : 20 > n ? _p(20) : 40 > n ? yp : 60 > n ? hp(1) : wp(1);
        }(e) : u ? 2 > u || 45 > u ? wp(u) : 90 > u ? $p(1) : 0 > s(u, 1440) ? function(n) {
            var r = kp(n / 60);
            return $p(r);
        }(u) : 0 > s(u, 2520) ? gp(1) : 0 > s(u, xp) ? function(n) {
            var r = kp(n / 1440);
            return gp(r);
        }(u) : 0 > s(u, 86400) ? function(n) {
            return {
                $: 6,
                a: kp(n / xp)
            };
        }(u) : function(n) {
            var r = n / xp | 0;
            if (12 > r) return function(n) {
                return {
                    $: 7,
                    a: kp(n / xp)
                };
            }(n);
            var t = Re(r / 12), e = A2(jc, 12, r);
            return 3 > e ? {
                $: 8,
                a: t
            } : 9 > e ? function(n) {
                return {
                    $: 9,
                    a: n
                };
            }(t) : function(n) {
                return {
                    $: 10,
                    a: n
                };
            }(t + 1);
        }(u) : hp(1);
    }), Cp = F4(function(n, r, t, e) {
        var u = t, a = e, i = A3(Ap, !0, u, a);
        return A3(r, n, 2 === A2(Ju, a, u) ? 0 : 1, i);
    }), Bp = F2(function(n, r) {
        return A4(Cp, {
            EA: !0
        }, pp, n, r);
    }), Ep = F4(function(n, r, t, e) {
        var u = function() {
            switch(t){
                case 0:
                    return "%m/%d/%Y";
                case 1:
                    return "%B %-d, %Y";
                case 4:
                    return "%l:%M %p";
                case 5:
                    return "%l:%M:%S %p";
                case 6:
                    return A2(Bp, e, r);
                case 2:
                    return A3(vp, n, r, e);
                default:
                    return A3(mp, n, r, e);
            }
        }();
        return A4(yv, Ob, u, n, e);
    }), Dp = F2(function(n, r) {
        return A2(Ep, n, r);
    }), qp = {
        ch: h,
        e9: 0
    }, Fp = F2(function(n, r) {
        return r.$ ? Ut : Vt(n(r.a));
    }), Pp = Vu(h), zp = {
        $: 1
    }, jp = Ln, Sp = A2(hc, function() {
        return zp;
    }, jp(1e4)), Lp = Vn, Mp = iu, Np = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Hp = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Yt, e.a, t);
    }), Tp = F2(function(n, r) {
        return A3(Bu, Hp(n), h, r);
    }), Ip = F3(function(n, r, t) {
        var e = t.b;
        return b(n(t.a), r(e));
    }), Rp = function(n) {
        var r = A2(ru, Np(1), rv), t = function(n) {
            return A2(Fp, function(t) {
                return b(t, A2(sc, "", r(n)));
            }, rv(n));
        }, e = A2(ru, Gu, sc(""));
        return Ul(A2(Eu, A2(Ip, e, e), A2(Tp, t, A2(Eu, se("="), A2(se, "&", n)))));
    }, Zp = function(n) {
        return Rp(A2(sc, "", n));
    }, Vp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Up = F2(function(n, r) {
        return r.$ ? Kt(r.a) : n(r.a);
    }), Yp = sn, Qp = {
        $: 2
    }, Op = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gp = function(n) {
        return A2(fe, "", n);
    }, Jp = function(n) {
        switch(A2(jc, 4, su(n))){
            case 0:
                return te(n);
            case 2:
                return te(Gp(x([
                    n,
                    "=="
                ])));
            case 3:
                return te(Gp(x([
                    n,
                    "="
                ])));
            default:
                return Kt(Op("Wrong length"));
        }
    }, Wp = F2(function(n, r) {
        return r.$ ? Kt(n) : te(r.a);
    }), Kp = F2(function(n, r) {
        return r.$ ? Kt(r.a) : te(n(r.a));
    }), Xp = F3(function(n, r, t) {
        if (1 === r.$) return Kt(r.a);
        var e = r.a;
        return 1 === t.$ ? Kt(t.a) : te(A2(n, e, t.a));
    }), n$ = F2(function(n, r) {
        return r.$ ? Kt(n(r.a)) : te(r.a);
    }), r$ = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return wt(n.a);
        }
    }, t$ = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A3(xt, r, t, n.a);
            case 1:
                return A4(kt, r, t, n.b, !n.a);
            case 2:
                return A4(yt, r, t, n.b, !n.a);
            case 3:
                return A3(_t, r, t, n.a);
            case 4:
                return A4(At, r, t, n.b, !n.a);
            case 5:
                return A4(Ct, r, t, n.b, !n.a);
            case 6:
                return A4(Bt, r, t, n.b, !n.a);
            case 7:
                return A4(Et, r, t, n.b, !n.a);
            case 8:
                return A3(e$, n.b, r, t);
            case 9:
                return A3(qt, r, t, n.b);
            default:
                return A3(Dt, r, t, n.a);
        }
    }), e$ = F3(function(n, r, t) {
        for(;;){
            if (!n.b) return t;
            var e = n.b, u = r, a = A3(t$, n.a, r, t);
            n = e, r = u, t = a;
        }
    }), u$ = F2(function(n, r) {
        return A2(Ft, n, r);
    }), a$ = function(n) {
        var r = new DataView(new ArrayBuffer(r$(n)));
        return t$(n)(r)(0), r;
    }, i$ = function(n) {
        if (_e(n)) return !0;
        switch(n){
            case "+":
            case "/":
                return !0;
            default:
                return !1;
        }
    }, c$ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), o$ = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.b;
            n += r$(r.a), r = t;
        }
    }), f$ = function(n) {
        return A2(c$, A2(o$, 0, n), n);
    }, s$ = function(n) {
        var r = ge(n);
        if (r >= 65 && 90 >= r) return r - 65;
        if (r >= 97 && 122 >= r) return r - 97 + 26;
        if (r >= 48 && 57 >= r) return r - 48 + 26 + 26;
        switch(n){
            case "+":
                return 62;
            case "/":
                return 63;
            default:
                return -1;
        }
    }, l$ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), d$ = l$, b$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, v$ = F4(function(n, r, t, e) {
        if (i$(n) && i$(r)) {
            var u = s$(r), a = s$(n);
            if ("=" === e) {
                if ("=" === t) return Vt(b$((c = a << 18 | u << 12) >> 16));
                if (i$(t)) {
                    var i = s$(t);
                    return Vt(A2(d$, 1, (c = a << 18 | u << 12 | i << 6) >> 8));
                }
                return Ut;
            }
            if (i$(t) && i$(e)) {
                var c, o = s$(e), f = c = a << 18 | u << 12 | (i = s$(t)) << 6 | o;
                return Vt(f$(x([
                    A2(d$, 1, c >> 8),
                    b$(f)
                ])));
            }
            return Ut;
        }
        return Ut;
    }), m$ = F2(function(n, r) {
        n: for(;;){
            var t = Lm(A2(mu, 4, n));
            r: for(;;){
                if (t.b) {
                    if (t.b.b) {
                        if (t.b.b.b) {
                            if (t.b.b.b.b) {
                                if (t.b.b.b.b.b) break r;
                                var e = t.b, u = e.b, a = A4(v$, t.a, e.a, u.a, u.b.a);
                                if (a.$) return Ut;
                                var i = a.a;
                                n = A2(du, 4, n), r = A2(Yt, i, r);
                                continue n;
                            }
                            var c = t.b, o = A4(v$, t.a, c.a, c.b.a, "=");
                            return 1 === o.$ ? Ut : Vt(A2(Yt, i = o.a, r));
                        }
                        var f = A4(v$, t.a, t.b.a, "=", "=");
                        return 1 === f.$ ? Ut : Vt(A2(Yt, i = f.a, r));
                    }
                    break r;
                }
                return Vt(r);
            }
            return Ut;
        }
    }), p$ = wt, $$ = function(n) {
        var r = A2(Fp, a$, function(n) {
            return A2(Fp, A2(ru, Ae, f$), A2(m$, n, h));
        }(n));
        if (1 === r.$) return Ut;
        var t, e = r.a;
        return A2(u$, (t = p$(e), St(t)), e);
    }, h$ = M, g$ = h$(function(n) {
        switch(n){
            case "-":
                return "+";
            case "_":
                return "/";
            default:
                return n;
        }
    }), w$ = X, x$ = F2(function(n, r) {
        return A2(Up, A2(ru, Yp(n), n$(Vp)), A2(Kp, zc, function(n) {
            var r = F2(function(n, r) {
                return A2(n$, n, A2(Kp, function() {
                    return r;
                }, A2(Yp, w$, r)));
            }), t = A2(ru, g$, A2(ru, se("."), Eu(Jp)))(n);
            n: for(;;){
                if (t.b && t.b.b && t.b.b.b && !t.b.b.b.b) {
                    if (t.a.$) {
                        if (1 === t.b.a.$) break n;
                        return Kt(t.a.a);
                    }
                    if (t.b.a.$) break n;
                    var e = t.a.a, u = t.b.a.a, a = A2(Up, r(function() {
                        return Qp;
                    }), A2(Wp, Qp, $$(e))), i = A2(Up, r(Vp), A2(Wp, Op("Invalid UTF-16"), $$(u)));
                    return A3(Xp, F2(function(n, r) {
                        return b(n, r);
                    }), a, i);
                }
                return Kt(Op("Token has invalid shape"));
            }
            return Kt(t.b.a.a);
        }(r)));
    }), k$ = ft, y$ = F2(function(n, r) {
        var t = Wb(n);
        return 1 !== t.$ && A2(k$, t.a, r);
    }), _$ = function(n) {
        return A2(y$, "^[\\w-]*\\.[\\w-]*\\.[\\w-]*$", n);
    }, A$ = function(n) {
        return A2(fu, "full_access", n) ? 0 : 1;
    }, C$ = nn, B$ = function(n) {
        return n.$ ? Ut : Vt(n.a);
    }, E$ = function(n) {
        if (n.$) return 1;
        var r = n.a;
        return _$(r) ? A2(sc, 1, A2(Fp, A$, B$(A2(x$, A2(Tu, "scope", C$), r)))) : 1;
    }, D$ = function(n) {
        return !E$(n);
    }, q$ = K, F$ = J, P$ = function(n) {
        return {
            $: 11,
            g: n
        };
    }, z$ = function(n) {
        var r = P$(x([
            F$,
            A2(tu, kp, q$)
        ]));
        return A2(Kp, function(n) {
            return 1e3 * n;
        }, A2(x$, A2(Tu, "exp", r), n));
    }, j$ = F2(function(n, r) {
        return A2(Kp, function(r) {
            return s(n, r) > 0;
        }, z$(r));
    }), S$ = F2(function(n, r) {
        return !!n.$ || A2(sc, !0, B$(A2(j$, r, n.a)));
    }), L$ = function(n) {
        return Vt({
            $: 4,
            a: n
        });
    }, M$ = {
        $: 3
    }, N$ = F2(function(n, r) {
        return 1 === n.$ ? r : n;
    }), H$ = function(n) {
        return A2(sc, M$, A2(nv, L$, A2(N$, A2(Wu, "account_token", n), A2(Wu, "exchange_token", n))));
    }, T$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, I$ = function(n) {
        return Vt(T$(n));
    }, R$ = F3(function(n, r, t) {
        var e = A2(nv, I$, r);
        if (e.$) return H$(n);
        var u = e.a;
        return D$(u) && !A2(S$, u, t) ? u : H$(n);
    }), Z$ = F2(function(n, r) {
        return m(r, {
            AL: n
        });
    }), V$ = F2(function(n, r) {
        var t = function(n) {
            switch(A2(mu, 2, n)){
                case "es":
                    return Vt(1);
                case "en":
                    return Vt(0);
                default:
                    return Ut;
            }
        }(A2(sc, n.AL, A2(Wu, "language", Zp(r.iF)))), e = Zp(r.iF), u = Mp(n.bj), a = A3(R$, e, n.i, u), i = function(n) {
            return b({
                oT: A2(sc, "", n),
                h9: !1
            }, A2(sc, Pp, A2(Fp, cm(Sp), n)));
        }(n.CZ), c = i.a, o = i.b;
        return b({
            f0: bc,
            x5: n.x5,
            x6: Ut,
            ch: qp,
            gF: A4(wc, n.ym + "/api", n.bb, n.bK, a),
            ej: vc,
            aW: h,
            yR: !1,
            yY: {
                yG: A4(kc, n.zE, n.zF, n.bK, a),
                J: A4(yc, n.zG, n.zH, n.bK, a),
                fb: A4(_c, n.zI, n.zJ, n.bK, a),
                CP: A4(Ac, n.zE, n.zF, n.bK, a)
            },
            bM: !1,
            bj: u,
            hg: !1,
            eI: !1,
            hv: A4(yc, n.zG, n.zH, n.bK, a),
            kA: 0,
            Ag: n.Ag,
            cB: A2(Z$, A2(sc, 0, t), Ib("language-select")),
            hU: Ut,
            dw: Lb,
            fc: bc,
            t6: vc,
            ud: vc,
            dB: vc,
            uN: vc,
            CZ: c,
            fL: vc,
            DF: vc,
            dZ: h,
            d_: Ut,
            jK: A2(Dp, oo, u),
            fS: oo,
            d3: Ut,
            xs: r,
            Eq: t,
            an: vc
        }, Vu(x([
            A2(hc, dc, fd),
            A2(Lp, mc, o)
        ])));
    }), U$ = function(n) {
        return {
            $: 79,
            a: n
        };
    }, Y$ = function(n) {
        return {
            $: 79,
            a: n
        };
    }, Q$ = function(n) {
        return {
            $: 78,
            a: n
        };
    }, O$ = function(n) {
        return {
            $: 78,
            a: n
        };
    }, G$ = function(n) {
        return {
            $: 80,
            a: n
        };
    }, J$ = function(n) {
        return {
            $: 80,
            a: n
        };
    }, W$ = function(n) {
        return {
            $: 91,
            a: n
        };
    }, K$ = function(n) {
        return {
            $: 91,
            a: n
        };
    }, X$ = function(n) {
        return {
            $: 92,
            a: n
        };
    }, nh = function(n) {
        return {
            $: 92,
            a: n
        };
    }, rh = function(n) {
        return {
            $: 12,
            a: n
        };
    }, th = function(n) {
        return {
            $: 12,
            a: n
        };
    }, eh = function(n) {
        return {
            $: 60,
            a: n
        };
    }, uh = function(n) {
        return {
            $: 60,
            a: n
        };
    }, ah = function(n) {
        return {
            $: 13,
            a: n
        };
    }, ih = function(n) {
        return {
            $: 13,
            a: n
        };
    }, ch = function(n) {
        return {
            $: 14,
            a: n
        };
    }, oh = function(n) {
        return {
            $: 14,
            a: n
        };
    }, fh = function(n) {
        return {
            $: 15,
            a: n
        };
    }, sh = function(n) {
        return {
            $: 15,
            a: n
        };
    }, lh = function(n) {
        return {
            $: 16,
            a: n
        };
    }, dh = function(n) {
        return {
            $: 16,
            a: n
        };
    }, bh = function(n) {
        return {
            $: 17,
            a: n
        };
    }, vh = function(n) {
        return {
            $: 17,
            a: n
        };
    }, mh = function(n) {
        return {
            $: 72,
            a: n
        };
    }, ph = function(n) {
        return {
            $: 72,
            a: n
        };
    }, $h = function(n) {
        return {
            $: 18,
            a: n
        };
    }, hh = function(n) {
        return {
            $: 18,
            a: n
        };
    }, gh = function(n) {
        return {
            $: 73,
            a: n
        };
    }, wh = function(n) {
        return {
            $: 73,
            a: n
        };
    }, xh = function(n) {
        return {
            $: 81,
            a: n
        };
    }, kh = function(n) {
        return {
            $: 81,
            a: n
        };
    }, yh = function(n) {
        return {
            $: 19,
            a: n
        };
    }, _h = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Ah = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Ch = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Bh = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Eh = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Dh = function(n) {
        return {
            $: 74,
            a: n
        };
    }, qh = function(n) {
        return {
            $: 74,
            a: n
        };
    }, Fh = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 20,
            a: n
        };
    }, zh = function(n) {
        return {
            $: 84,
            a: n
        };
    }, jh = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Sh = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Lh = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Mh = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Nh = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Hh = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Th = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Ih = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Rh = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Zh = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Vh = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Uh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Yh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Qh = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Oh = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Gh = function(n) {
        return {
            $: 76,
            a: n
        };
    }, Jh = function(n) {
        return {
            $: 76,
            a: n
        };
    }, Wh = function(n) {
        return {
            $: 87,
            a: n
        };
    }, Kh = function(n) {
        return {
            $: 87,
            a: n
        };
    }, Xh = function(n) {
        return {
            $: 77,
            a: n
        };
    }, ng = function(n) {
        return {
            $: 77,
            a: n
        };
    }, rg = function(n) {
        return {
            $: 24,
            a: n
        };
    }, tg = function(n) {
        return {
            $: 24,
            a: n
        };
    }, eg = function(n) {
        return {
            $: 88,
            a: n
        };
    }, ug = function(n) {
        return {
            $: 88,
            a: n
        };
    }, ag = function(n) {
        return {
            $: 25,
            a: n
        };
    }, ig = function(n) {
        return {
            $: 25,
            a: n
        };
    }, cg = function(n) {
        return {
            $: 26,
            a: n
        };
    }, og = function(n) {
        return {
            $: 26,
            a: n
        };
    }, fg = function(n) {
        return {
            $: 56,
            a: n
        };
    }, sg = function(n) {
        return {
            $: 56,
            a: n
        };
    }, lg = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dg = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bg = function(n) {
        return {
            $: 62,
            a: n
        };
    }, vg = function(n) {
        return {
            $: 62,
            a: n
        };
    }, mg = function(n) {
        return {
            $: 57,
            a: n
        };
    }, pg = function(n) {
        return {
            $: 57,
            a: n
        };
    }, $g = function(n) {
        return {
            $: 89,
            a: n
        };
    }, hg = function(n) {
        return {
            $: 89,
            a: n
        };
    }, gg = function(n) {
        return {
            $: 90,
            a: n
        };
    }, wg = function(n) {
        return {
            $: 90,
            a: n
        };
    }, xg = function(n) {
        return {
            $: 27,
            a: n
        };
    }, kg = function(n) {
        return {
            $: 27,
            a: n
        };
    }, yg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _g = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ag = function(n) {
        return {
            $: 58,
            a: n
        };
    }, Cg = function(n) {
        return {
            $: 58,
            a: n
        };
    }, Bg = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Eg = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Dg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fg = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Pg = function(n) {
        return {
            $: 9,
            a: n
        };
    }, zg = function(n) {
        return {
            $: 28,
            a: n
        };
    }, jg = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Sg = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Lg = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Mg = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Ng = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Hg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Tg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ig = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Rg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Zg = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Vg = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Ug = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Yg = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Qg = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Og = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Gg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, Jg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, Wg = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Kg = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Xg = function(n) {
        return {
            $: 68,
            a: n
        };
    }, nw = function(n) {
        return {
            $: 68,
            a: n
        };
    }, rw = function(n) {
        return {
            $: 69,
            a: n
        };
    }, tw = function(n) {
        return {
            $: 69,
            a: n
        };
    }, ew = function(n) {
        return {
            $: 70,
            a: n
        };
    }, uw = function(n) {
        return {
            $: 70,
            a: n
        };
    }, aw = function(n) {
        return {
            $: 71,
            a: n
        };
    }, iw = function(n) {
        return {
            $: 71,
            a: n
        };
    }, cw = function(n) {
        return {
            $: 59,
            a: n
        };
    }, ow = function(n) {
        return {
            $: 59,
            a: n
        };
    }, fw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, sw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, lw = function(n) {
        return {
            $: 31,
            a: n
        };
    }, dw = function(n) {
        return {
            $: 31,
            a: n
        };
    }, bw = function(n) {
        return {
            $: 32,
            a: n
        };
    }, vw = function(n) {
        return {
            $: 32,
            a: n
        };
    }, mw = function(n) {
        return {
            $: 33,
            a: n
        };
    }, pw = function(n) {
        return {
            $: 33,
            a: n
        };
    }, $w = function(n) {
        return {
            $: 34,
            a: n
        };
    }, hw = function(n) {
        return {
            $: 34,
            a: n
        };
    }, gw = function(n) {
        return {
            $: 35,
            a: n
        };
    }, ww = function(n) {
        return {
            $: 35,
            a: n
        };
    }, xw = function(n) {
        return {
            $: 36,
            a: n
        };
    }, kw = function(n) {
        return {
            $: 36,
            a: n
        };
    }, yw = function(n) {
        return {
            $: 37,
            a: n
        };
    }, _w = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Aw = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Cw = function(n) {
        return {
            $: 38,
            a: n
        };
    }, Bw = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Ew = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Dw = function(n) {
        return {
            $: 40,
            a: n
        };
    }, qw = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Fw = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Pw = function(n) {
        return {
            $: 41,
            a: n
        };
    }, zw = function(n) {
        return {
            $: 42,
            a: n
        };
    }, jw = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Sw = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Lw = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Mw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, Nw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, Hw = function(n) {
        return {
            $: 45,
            a: n
        };
    }, Tw = function(n) {
        return {
            $: 45,
            a: n
        };
    }, Iw = function(n) {
        return {
            $: 46,
            a: n
        };
    }, Rw = function(n) {
        return {
            $: 46,
            a: n
        };
    }, Zw = function(n) {
        return {
            $: 47,
            a: n
        };
    }, Vw = function(n) {
        return {
            $: 47,
            a: n
        };
    }, Uw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, Yw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, Qw = function(n) {
        return {
            $: 49,
            a: n
        };
    }, Ow = function(n) {
        return {
            $: 49,
            a: n
        };
    }, Gw = function(n) {
        return {
            $: 50,
            a: n
        };
    }, Jw = function(n) {
        return {
            $: 50,
            a: n
        };
    }, Ww = function(n) {
        return {
            $: 51,
            a: n
        };
    }, Kw = function(n) {
        return {
            $: 51,
            a: n
        };
    }, Xw = function(n) {
        return {
            $: 52,
            a: n
        };
    }, nx = function(n) {
        return {
            $: 52,
            a: n
        };
    }, rx = function(n) {
        return {
            $: 53,
            a: n
        };
    }, tx = function(n) {
        return {
            $: 53,
            a: n
        };
    }, ex = function(n) {
        return {
            $: 54,
            a: n
        };
    }, ux = function(n) {
        return {
            $: 54,
            a: n
        };
    }, ax = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ix = function(n) {
        return {
            $: 11,
            a: n
        };
    }, cx = function(n) {
        return {
            $: 55,
            a: n
        };
    }, ox = function(n) {
        return {
            $: 55,
            a: n
        };
    }, fx = function(n) {
        return {
            $: 4,
            a: n
        };
    }, sx = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bx = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vx = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mx = {
        $: 2
    }, px = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $x = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hx = function(n) {
        return 4 === n.$;
    }, gx = function(n) {
        return hx(n.a.i);
    }, wx = F2(function(n, r) {
        return v(r.a, r.b, n);
    }), xx = function(n) {
        return n.b.pP;
    }, kx = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), yx = null, _x = function(n) {
        return A3(de, F2(function(n, r) {
            return A3(xn, n.a, n.b, r);
        }), {}, n);
    }, Ax = wn, Cx = Wn("fullStoryPortInit", function(n) {
        return _x(x([
            b("email", function(n) {
                return A3(kx, yx, Ax, n);
            }(n.pP)),
            b("id", Ax(n.rh)),
            b("name", Ax(n.tg))
        ]));
    }), Bx = function(n) {
        return function(n) {
            return n.rh;
        }(n.a);
    }, Ex = function(n) {
        return function(n) {
            return n.tg;
        }(n.a);
    }, Dx = function(n) {
        return function(n) {
            return Cx({
                pP: xx(n),
                rh: Bx(n),
                tg: Ex(n)
            });
        }(n);
    }, qx = F2(function(n, r) {
        var t = r.b;
        return b(n(r.a), t);
    }), Fx = F2(function(n, r) {
        var t = r.b, e = r.c;
        return v(n(r.a), t, e);
    }), Px = Zn, zx = Px(h), jx = iu, Sx = "Date", Lx = "doctor", Mx = "Select", Nx = "Location", Hx = "Your membership has been renewed", Tx = "Provider", Ix = "Start date", Rx = jx({
        lZ: F2(function(n, r) {
            return "Using a credit card will cost " + n + " an additional " + r + " in processing fees for your membership. Please consider using a bank account instead.";
        }),
        l_: function(n) {
            return "Using a credit card will cost " + n + " additional processing fees. Please consider using a bank account instead.";
        },
        mc: function(n) {
            return "Added " + n;
        },
        mh: "Additional Details",
        mi: "Additional details for primary member",
        j_: {
            pP: "Email me details",
            hn: "Enroll now"
        },
        mk: {
            mX: "Billing Address",
            m4: "Billing address is the same",
            nK: "City",
            y4: "Country",
            r1: "Address Line 1",
            AO: "Street address, P. O. box, company name, c/o",
            r2: "Address Line 2",
            AP: "Apartment, suite, unit, building, floor, etc.",
            sg: "Mailing Address",
            sh: "Mailing address is the same",
            tg: "Address",
            C7: "Use primary member's address",
            wN: "State (abbv.)",
            DR: "Please use a 2 letter abbreviation.",
            DS: "[See USPS Abreviations] (https://pe.usps.com/text/pub28/28apb.htm)",
            x0: "ZIP code",
            x1: "We do not have coverage in your area",
            EF: "Please enter a valid US zip code."
        },
        ms: F2(function(n, r) {
            return "Minimum age for range for this plan is from " + n + " to " + r + " years old.";
        }),
        j4: "Amount",
        yk: F2(function(n, r) {
            return n + " and " + r;
        }),
        gI: {
            w5: "Appointments"
        },
        mK: "At least one dependent must be added to the plan.",
        mL: "At least one member must be added to the plan.",
        mO: function(n) {
            return "authored by " + n;
        },
        mT: "Bank Account",
        yz: {
            mC: "Annually",
            tf: "Monthly",
            vj: "Quarterly",
            v9: "Semi-Annually"
        },
        gS: {
            ng: "Broker",
            rQ: "Who is your broker?",
            CB: "Select"
        },
        nh: "Cancel",
        N: {
            mV: "before appointment",
            N: "Cancel Appointment",
            ni: "Cancellation Contact",
            nk: "Cancellation Policy",
            oi: "Contact us at",
            re: "hours",
            ri: 'If you wish to reschedule your appointment, simply click the "Reschedule" button to book a new time.',
            ta: "Minimum Cancellation Notice",
            vR: "Reschedule",
            vS: "Reschedule Appointment",
            w7: "to cancel your appointment.",
            w8: "To cancel your appointment, contact us at",
            xV: "Your appointment has been cancelled"
        },
        bd: {
            yF: "End Membership",
            yH: "Cancellation Reason",
            Ba: "Ending Membership for:",
            C$: "Remove Member",
            C0: "Member has been removed from the membership",
            C2: "Please enter a cancellation reason.",
            Da: "We're sorry to see you go!",
            D_: "Membership has been cancelled"
        },
        gT: "Card",
        ns: {
            w5: "Confirm and Pay"
        },
        be: {
            zC: "(Due Today)",
            pW: "Your cart is empty",
            AJ: "Item actions",
            Bc: "Membership Fee",
            Ca: "One-Time",
            Cc: "One-Time Registration Fee",
            CU: "Recurring",
            Em: "\u2014"
        },
        nt: function(n) {
            return "Recurring (starting " + n + ")";
        },
        c6: {
            oo: "Continue to Payment",
            pV: "Add a membership or package to get started with your purchase.",
            pY: "Your cart is empty",
            dg: "Explore Services",
            w5: "Your Cart"
        },
        ap: {
            zd: "MMMM d, y",
            zx: "Due Annually",
            zy: "Due Quarterly",
            zz: "Due Monthly",
            zA: "Due Semi-Annually",
            zB: "Due Today",
            Bj: "Next Bill Date: { $date }",
            iD: "Pricing Breakdown",
            CY: "Registration Fees",
            DO: "Starting { $date }",
            lE: "Starting Today"
        },
        kb: {
            Dz: "Show less",
            DB: "Show more"
        },
        yT: {
            w5: "Checkout"
        },
        nE: function(n) {
            return "This plan does not allow children over the age of " + n + " to enroll.";
        },
        cm: {
            qB: "Chosen First Name",
            AB: "Chosen name is different?",
            rS: "Chosen Last Name",
            s2: "Chosen Middle Name",
            wY: "Chosen Suffix",
            w5: "Chosen Title"
        },
        nM: "Close menu",
        nP: {
            rr: "Code format is invalid."
        },
        oa: "Confirm",
        y_: {
            l5: "Add Later",
            nv: "Change Your Payment Method",
            oK: "Credit or Debit card",
            oL: "Credit/debit card or bank",
            wd: "Setup options"
        },
        oe: "Please contact the practice if you have any questions",
        of: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        og: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        oh: F2(function(n, r) {
            return "Please contact the practice at " + n + " or " + r + " if you have any questions.";
        }),
        ol: "Continue to next step",
        om: function(n) {
            return "Continue to " + n + " page";
        },
        on: "Continue",
        ov: function(n) {
            return "Contract renews On #" + n;
        },
        ox: function(n) {
            return "Contract Terminates On " + n;
        },
        ki: {
            gI: "Appointments",
            xM: "Welcome back,"
        },
        oY: Sx,
        bk: Sx + " of Birth",
        pf: function(n) {
            return "Ending this membership will stop recurring charges for the selected patient(s), and remove access to membership benefits effective " + n + ".";
        },
        hj: {
            q$: "Have a discount code?",
            Ax: "This is not a valid discount code.",
            rQ: "Discount code"
        },
        eB: {
            yl: "Any distance",
            rQ: "Distance",
            Bm: "No Filter",
            CB: "Filter by distance"
        },
        po: "Date of birth cannot be in the future.",
        pp: Lx,
        pq: Mx + " " + Lx,
        ps: function(n) {
            return n + " accepted!";
        },
        R: {
            x3: "Accept",
            zj: "No Thanks",
            kn: "Type your first name and last name",
            zl: "Member e-signature",
            Ay: "Please type either name exactly as it appears above.",
            Az: "Please type your name exactly as it appears above.",
            A6: "Member Name",
            kR: "Name",
            Bi: "New Member name",
            CK: "Primary Member Name",
            CL: "Type the first and last name of either member",
            CM: "New or Primary Member e-signature",
            C5: "Please sign this document.",
            ws: "E-signature",
            xq: "Signature does not match signee name."
        },
        pu: {
            zw: "Due",
            Cj: "Paid",
            Ev: "Void"
        },
        Y: {
            w5: "Agreements"
        },
        px: "Download",
        bo: {
            ye: "All Time",
            y8: "Current Year",
            za: "Custom",
            p$: "End Date",
            Ap: "In Progress",
            Aq: "Your file is being processed and may take a few seconds.",
            AM: "Last Year",
            DN: "Start Date"
        },
        pz: "DPC Practice",
        cs: {
            rQ: "DPC Practice",
            AR: "Loading DPC practices...",
            Cd: "DPC Practice's name",
            Ce: "Your DPC Practice's name",
            CB: "Start typing to find your DPC Practice",
            EE: "No DPC practices found"
        },
        pC: function(n) {
            return "Due on " + n;
        },
        pH: "Membership patients can't be duplicated in the same membership.",
        pL: "Edit",
        pP: "Email",
        aI: {
            pP: "Email",
            qB: "First Name",
            rS: "Last Name",
            tg: "Full Name",
            uw: "Phone",
            vB: "Relationship",
            C3: "Please enter phone or email.",
            C4: "Please enter at least first name, last name or relationship.",
            DH: "Use primary member as emergency contact",
            w5: "Emergency Contact"
        },
        a_: {
            yU: "Child",
            z8: "Grandparent",
            Ab: "Guardian",
            Bm: "None",
            Cd: "Other",
            Cl: "Parent",
            fC: "Select a relationship",
            DE: "Sibling",
            DM: "Spouse"
        },
        p4: "English",
        eG: {
            m3: "Billing Frequency",
            CJ: "Primary",
            w5: "Enrolled Members",
            EE: "No patients to show"
        },
        p8: function(n) {
            return "ended on " + n;
        },
        p9: function(n) {
            return "ending on " + n;
        },
        qa: function(n) {
            return "Enrolled on " + n;
        },
        qb: {
            pm: "Do not enroll me",
            p6: "Enroll me",
            tg: "Enrollment Status",
            Bt: "Paying for someone else and don\u2019t want to be enrolled as a patient? Select \u201CDo not enroll me\u201D."
        },
        qf: F2(function(n, r) {
            return n + ": " + r;
        }),
        qg: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        qn: F2(function(n, r) {
            return "Expires " + n + "/" + r;
        }),
        dg: {
            w5: "Explore Services"
        },
        C: {
            ma: "Add to Cart",
            md: "has been added to your cart!",
            mt: "All",
            m5: "Billing",
            yO: "Change Member",
            n8: "Configure Membership Details",
            n9: "Configure Package Details",
            oc: "Contact practice for pricing",
            hn: "Enroll",
            dg: "Explore Services",
            A4: "Member",
            A7: "Yourself",
            dt: "Membership Start Date",
            aa: "Memberships",
            ij: "Packages",
            CR: "Purchase",
            xE: "View Cart",
            EE: "No additional services are available right now"
        },
        qF: "for",
        eJ: {
            nL: "click here",
            q7: "You do not have authorization to view this page. Please use the link in your email, or",
            q8: "to go to your patient portal homepage.",
            w5: "Authorization Required"
        },
        dj: {
            zf: "Date Sent",
            o_: "Date Submitted",
            Bo: "# of Questions",
            Do: "Sent to",
            wO: "Status"
        },
        qH: {
            rk: "Please complete the form questions."
        },
        qV: {
            z_: "Female",
            rQ: "Gender",
            AY: "Male",
            Cd: "Other"
        },
        qW: {
            rQ: "Gender Identity",
            AZ: "Man",
            Bl: "Non-binary",
            Bn: "Not Listed",
            CB: "Select",
            Ei: "Trans Man",
            Ej: "Trans Woman",
            EB: "Woman"
        },
        hD: {
            pX: "No data has been shared by the practice.",
            qe: "There was an error loading your health information",
            w5: "Health"
        },
        q4: "Healthcare Insurance",
        ax: {
            np: "Insurance carrier",
            yJ: "Start typing to find your carrier",
            nr: "Carrier's name",
            yK: "Pick an item",
            Z: "Existing coverage",
            zO: "Do you have either insurance or an insurance alternative?",
            q_: "Group ID",
            rc: "High deductible",
            Af: "Are you on a high-deductible plan?",
            su: "Member ID",
            De: "Search to filter..."
        },
        rq: function(n) {
            return "Please enter a valid " + n + ".";
        },
        rt: function(n) {
            return "A valid " + n + " phone is required.";
        },
        rw: function(n) {
            return "Invoice " + n;
        },
        rx: function(n) {
            return "Due Date: " + n;
        },
        eP: {
            ui: "Payment",
            wz: "Payment Source",
            jD: "Pay Invoice",
            w5: "Pay Invoice"
        },
        g: {
            ya: "additional fees",
            mA: "Amount Due",
            nA: "Charges",
            oF: "Credit",
            oG: "Credit Card Fee",
            oH: "To avoid transaction fees, consider using a bank account (ACH) or debit.",
            y6: "Using a credit card will incur transaction fees.",
            oI: "Credit Card Fees",
            oJ: "Credit Card Fees Paid",
            zw: "Due",
            pD: "due to the",
            pE: "due to your membership",
            pF: "due to your package",
            rA: "Invoice Total",
            dr: "There was an error loading your invoices",
            tA: "Invoice Number",
            Cj: "Paid",
            uf: "Pay Invoice",
            uq: "Payment Total",
            ur: "Payments",
            uG: "+ tax",
            wV: "Subtotal",
            D$: "Tax",
            w5: "Invoices",
            Ee: "Total",
            xg: "Total Due",
            xj: "Transferred to Credit",
            xU: "You saved",
            EE: "No invoices to show"
        },
        rK: "Item",
        hW: {
            rQ: "How did you hear about us?",
            rX: "Lead source",
            CB: "Select"
        },
        rZ: "Learn more",
        kL: Nx,
        bZ: {
            yl: "Any location",
            pe: "Select location where you'd like to meet your provider.",
            Ax: "Location is invalid, please select a different option.",
            rQ: "Location",
            CB: "Filter by location",
            vJ: "Location is required.",
            fC: "Select"
        },
        r8: function(n) {
            return "+ " + n + " other";
        },
        h_: {
            g2: "code",
            qG: "Sign into your patient portal",
            sf: "magic-link"
        },
        r9: function(n) {
            return "We don't like passwords any more than you do. Enter your email and we will send you a " + n + " to log in instantly.";
        },
        sa: "Enter your email to get a login code",
        sb: function(n) {
            return "Send " + n;
        },
        sl: function(n) {
            return "Maximum age for this plan is " + n + " years old.";
        },
        ss: function(n) {
            return "Age " + n;
        },
        st: "Dependent",
        sx: "Primary",
        A8: {
            l1: "Add members",
            l2: "Add another member",
            l3: "Demographics",
            l4: "Add Emergency Contact",
            l6: "Add Member",
            l7: "+ Add New Member",
            l8: "Member created successfully!",
            mg: "Are you adding members?",
            zn: "Please contact the practice to change these patient details.",
            pM: "Edit Emergency Contact",
            pU: "Emergency Contact",
            q0: "Health Insurance",
            q1: "Insurance",
            q2: "Group ID",
            q3: "Member ID",
            rl: "Member Information",
            rm: "Edit Member Information",
            dr: "There was an error loading members",
            sj: "Manage Member",
            A_: "Manage Members",
            tt: "No dependents are allowed on this membership",
            w5: "Members",
            EE: "No members to show"
        },
        sy: function(n) {
            return "This membership allows " + n + " dependents";
        },
        sA: function(n) {
            return "Your membership is ending on " + n;
        },
        e5: {
            hh: "Default",
            rQ: "Payment Method",
            jQ: "Payment method updated successfully",
            xr: "Any upcoming payments for this membership will be charged to the new payment method."
        },
        sC: Hx,
        sD: function(n) {
            return Hx + " till " + n;
        },
        dt: {
            rQ: "Membership start date"
        },
        aa: {
            ot: "Contract Period",
            oP: "Current Memberships",
            oU: "Current",
            p1: "Ended Memberships",
            p2: "Ended",
            is: "Pending Memberships",
            vF: "Renew Membership",
            iU: "View Membership Details",
            w5: "Memberships",
            Ea: "Memberships & Packages",
            EE: "No Memberships to Show",
            x_: "No Items To Display"
        },
        J: {
            x8: "Add Recipients",
            nB: "Chat for conversation",
            nC: "This is where the chat messages would appear.",
            yV: "Click to load providers",
            qo: "Failed to load conversations",
            zX: "Failed to load file",
            zY: "Failed to load image",
            qp: "Failed to load messages.",
            zZ: "Failed to load providers.",
            to: "No conversation selected",
            tp: "See conversations on the left, or start a new message.",
            tq: "No conversations",
            tr: "No messages yet",
            ts: "See conversations on the left or start a new message.",
            w5: "Chat",
            xn: "Type a message..."
        },
        sF: "Pause",
        sG: "Play",
        sH: function(n) {
            return "Preview " + n;
        },
        sI: "Tap to expand",
        sJ: "Cannot preview this file",
        sK: "Loading CSV",
        sL: function(n) {
            return "CSV preview: " + n;
        },
        sM: "Loading document",
        sN: "Loading Word document",
        sO: function(n) {
            return "Document preview: " + n;
        },
        sP: "Loading PDF",
        sQ: "Loading PDF preview",
        sR: function(n) {
            return "Column " + n;
        },
        sS: "Loading spreadsheet",
        sT: "No rows to display.",
        sU: "To view this file, please download it and open it with the appropriate application on your device.",
        sV: "This workbook has no sheets to display.",
        sW: "Loading Excel workbook",
        sX: F2(function(n, r) {
            return "Excel preview: " + n + " \u2014 " + r;
        }),
        sY: function(n) {
            return "Excel preview: " + n;
        },
        sZ: "Loading XML",
        s_: "Loading XML",
        s$: function(n) {
            return "XML preview: " + n;
        },
        s0: function(n) {
            return n + " joined conversation";
        },
        s1: function(n) {
            return n + " was removed from conversation";
        },
        s3: function(n) {
            return n + " miles away";
        },
        s5: function(n) {
            return "Minimum age for this plan is " + n + " years old.";
        },
        cF: {
            qB: "First Name",
            rS: "Last Name",
            s2: "Middle Name",
            wY: "Suffix",
            w5: "Title",
            D9: "Select"
        },
        th: "Cart",
        ti: "Logout",
        tj: "Next Bill",
        tl: "Next Step",
        tm: "No",
        tn: function(n) {
            return "At least one patient on the membership must be " + n + " years old.";
        },
        tw: {
            aH: "Document",
            pK: "Prescription",
            qr: "Fax",
            kB: "form",
            rj: "Prescription",
            rP: "Lab Results",
            tu: "Note",
            xH: "Vitals"
        },
        tE: function(n) {
            return "of " + n + " due";
        },
        tH: function(n) {
            return "on " + n;
        },
        tP: "Open menu",
        Cd: "Other",
        aB: {
            n7: "Complete Purchase",
            hl: "Done",
            zB: "Due Today",
            A4: "Member",
            ia: "No payment methods available",
            dz: "Payment Method",
            iD: "Pricing Breakdown",
            vf: "Purchase completed successfully",
            jF: "You're all set! The package is available immediately.",
            dY: "Purchase Successful!",
            w5: "Review & Pay"
        },
        tW: function(n) {
            return "Expires on " + n;
        },
        tX: function(n) {
            return n + " utilized";
        },
        ij: {
            iU: "View Package Details"
        },
        t6: "Patient",
        dz: "Payment method",
        cH: {
            yi: "American Express is not accepted.",
            qU: "Future expiration date",
            rs: "Please enter a valid payment method holder name.",
            rQ: "Payment Source",
            C5: "Please add a payment method.",
            Db: "Save Payment Method"
        },
        uk: function(n) {
            return n + " is not configured to accept payments.";
        },
        bx: {
            yB: "Blocked",
            y$: "Confirmed",
            zR: "Expiring",
            zW: "Failed",
            Ax: "Invalid",
            Bh: "New",
            u3: "Processing",
            Ew: "Warning"
        },
        um: function(n) {
            return n + " is now the default source";
        },
        un: function(n) {
            return n + " was successfully removed.";
        },
        Cw: {
            l1: "+ Add Payment Method",
            l9: "Add a Payment Method",
            gT: "Card",
            oD: "Your payment source was successfully created",
            pw: "Don't Save Payment Source",
            pN: "Edit Payment Source",
            hr: "Expiration Month",
            hs: "Expiration Year",
            rD: "Selected as Default",
            dr: "There Was an Error Loading Your Sources",
            si: "Make Default",
            ug: "Use This Payment Source to Pay Past Due Invoices",
            Db: "Save Payment Method",
            w5: "Payment Sources",
            xe: "Link Already Used",
            jQ: "Your payment information has successfully been updated",
            EE: "No Sources to Show",
            x0: "Zip",
            x2: "Zip Code"
        },
        up: "Payment terms",
        ur: {
            uj: "Payment failed!",
            uo: "Payment successful!"
        },
        fh: {
            Bt: "On behalf of the new member:",
            tF: "Terms and Conditions:",
            Bu: "On behalf of each member in this membership:",
            is: "Not Accepted"
        },
        us: "Required for: All enrollees",
        ut: function(n) {
            return "Required for: " + n;
        },
        fi: {
            mC: "/year",
            tf: "/month",
            vj: "/quarter",
            v9: "/6 months"
        },
        uw: "Phone",
        cI: {
            l1: "Add another phone number",
            Ah: "Home",
            rQ: "Phone Number",
            Bf: "Mobile",
            Bp: "Office",
            C_: "Remove phone"
        },
        uC: "Plan",
        G: {
            mB: "Annual",
            m6: "Billing Schedule",
            n6: "Complete Enrollment",
            hl: "Done",
            zB: "Due Today",
            qc: "Enrollment completed successfully",
            A4: "Member",
            dt: "Membership Start Date",
            tf: "Monthly",
            ia: "No payment methods available",
            tN: "One time registration fee",
            dz: "Payment Method",
            CU: "Recurring",
            wM: "Starts Today",
            jF: "You'll receive a confirmation email shortly with all the details.",
            dY: "You are Enrolled!",
            w5: "Review & Pay"
        },
        uF: "Please",
        uO: function(n) {
            return "Practice does not accept members under age " + n;
        },
        uU: "Preferred Language",
        ab: {
            zc: "Date Filled",
            kj: "Date Prescribed",
            kl: "# days of treatment",
            kB: "Form",
            qP: "Frequency",
            kH: "Instructions",
            A3: "Medication",
            lh: "Prescriber",
            li: "Price",
            vg: "Qty",
            CX: "Refills",
            ls: "Route of Administration",
            lF: "Strength",
            lN: "Use by Date"
        },
        u5: {
            Ac: "He/Him/His",
            rQ: "Pronouns",
            Bn: "Not Listed",
            CB: "Select",
            Ds: "She/Her/Hers",
            D5: "They/Them/Theirs"
        },
        u7: Tx,
        u8: Mx + " " + Tx + " and " + Nx,
        u9: Tx + " is invalid, please select a different option.",
        lk: {
            v7: "Practitioner and location selected!",
            w5: "Select Provider & Location"
        },
        vb: Tx + " is required.",
        vc: {
            Dd: "Search by name"
        },
        vd: Mx + " " + Tx,
        ve: "Provider selected!",
        CR: function(n) {
            return "Purchase " + n;
        },
        vh: "Qty",
        fr: {
            kr: "Due Now",
            qA: "First Bill",
            Cb: "One time registration fee",
            CU: "Recurring",
            CV: "Recurring Bills",
            Dg: "Second Bill",
            Ef: "Total Bill"
        },
        lm: {
            rQ: "Rate & Schedule",
            CB: "Select"
        },
        ft: {
            yk: "and",
            AN: "This site is protected by reCAPTCHA and the Google",
            CN: "Privacy Policy",
            D1: "Terms of service"
        },
        vq: ".",
        vB: {
            yd: "Adult",
            yU: "Child",
            rQ: "Member Type",
            tU: "Owner"
        },
        C_: "Remove",
        vE: "Removing",
        vK: "Please describe.",
        vL: function(n) {
            return "Please enter " + n + ".";
        },
        vM: function(n) {
            return "Please select " + n + ".";
        },
        v$: {
            y9: "Currently viewing sandbox data."
        },
        Db: "Save",
        v4: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account on a recurring basis as set forth in your membership agreement or as displayed to you during the signup process. You understand you can contact " + n + " to revoke this authorization at any time.";
        },
        v5: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account for this service as displayed to you.";
        },
        dM: {
            yZ: "security and compliance",
            z7: "frameworks",
            Cf: "Our",
            CC: "platform",
            D0: "uses state-of-the-art data encryption technology and is regularly audited against comprehensive"
        },
        fC: Mx,
        lx: {
            pe: "Your session expired, please sign in again.",
            w5: "Session Expired"
        },
        we: {
            z_: "Female",
            Aw: "Intersex",
            rQ: "Sex",
            AY: "Male",
            CB: "Select"
        },
        wl: "Login",
        wm: function(n) {
            return "By clicking " + n + ", I hereby acknowledge that I meet the age";
        },
        wn: "requirements",
        wo: "allowing this platform to collect the information I have provided.",
        wp: "Sign Out",
        wq: function(n) {
            return "Don't have a membership with " + n + " ?";
        },
        wr: "Sign up today",
        ww: F2(function(n, r) {
            return "Sign up with " + n + " through " + r;
        }),
        wx: function(n) {
            return "Sign up with " + n;
        },
        wC: "Spanish",
        wG: "SSN",
        DN: Ix,
        wJ: function(n) {
            return Ix + " cannot be prior to " + n + ".";
        },
        ba: {
            x9: "Additional Details",
            y_: "Confirmation",
            y0: "Contact",
            zb: "Custom Details",
            kL: "Location",
            A8: "Members",
            A9: "Demographics",
            Bb: "Membership",
            u7: "Provider"
        },
        wQ: "Please enter a valid payment method or account holder name.",
        wR: function(n) {
            return n;
        },
        cW: {
            yT: "You will receive a purchase confirmation if you authorized us to send you emails. If you have any further questions, please reach out to us directly.",
            pS: "Failed to send email!",
            pT: "Email sent!",
            CR: "Thank you for your purchase!",
            w5: "Thank You",
            Ey: "We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed."
        },
        jL: {
            zu: "Does not use tobacco",
            w5: "Tobacco Use",
            xy: "Uses tobacco"
        },
        xf: "There are too many dependents on this membership.",
        xp: "An error occurred, please try again.",
        cY: {
            kw: "Patient cannot be verified",
            vT: "Resend code",
            jD: "Sign In",
            D_: "Patient verified",
            w5: "Enter your code",
            xW: "Your code"
        },
        xA: "It may take a few seconds to arrive, and will be valid for 15 minutes.",
        xB: function(n) {
            return "Enter the code we just sent to " + n;
        },
        xC: function(n) {
            return "An email with a code has been sent to " + n + ". Please enter the code within 15 minutes.";
        },
        xG: function(n) {
            return "Go to " + n + " Website";
        },
        aT: {
            nb: "BMI (English)",
            pg: "Diastolic (mmHg)",
            q6: "Height (in)",
            CQ: "Pulse (bpm)",
            vW: "Respiratory Rate (bpm)",
            wE: "SpO2 (%)",
            wZ: "Systolic (mmHg)",
            w2: "Temp (\xb0F)",
            xL: "Weight (lbs)",
            Ez: "When"
        },
        q: {
            me: "You've been added to the waitlist!",
            mf: "We'll notify you when a spot opens up with",
            mS: "Full - Join Waitlist",
            pQ: "Email",
            pR: "jane@example.com",
            p5: "# People to Enroll",
            qC: "First Name",
            qD: "Jane",
            ru: "Complete your signup below to join",
            rv: "You've been invited off the waitlist!",
            AK: "Join Waitlist",
            rM: "Joining",
            rN: "waitlist...",
            rT: "Last Name",
            rU: "Doe",
            t_: "Join the Waitlist",
            ux: "Phone",
            va: "Provider",
            v6: "Select a provider",
            wS: "Something went wrong. Please try again.",
            wX: "We'll contact you when a spot opens up with",
            dY: "You're on the waitlist!"
        },
        xN: function(n) {
            return "Welcome to " + n;
        },
        xT: "Yes",
        xX: "Your contact details",
        xY: "Your Email"
    }), Zx = "Fecha", Vx = "doctor", Ux = "Seleccionar", Yx = "location", Qx = "Su membres\xeda ha sido renovada", Ox = "proveedor", Gx = "Fecha de inicio", Jx = jx({
        lZ: F2(function(n, r) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " un " + r + " adicional en tarifas de procesamiento para su membres\xeda. Por favor, considere usar una cuenta bancaria en su lugar.";
        }),
        l_: function(n) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " gastos de procesamiento adicionales. Por favor, considere usar una cuenta bancaria en su lugar.";
        },
        mc: function(n) {
            return "Agregado " + n;
        },
        mh: "Datos adicionales",
        mi: "Datos adicionales para el miembro principal",
        j_: {
            pP: "Env\xedame los detalles por correo electr\xf3nico",
            hn: "Inscr\xedbete ahora"
        },
        mk: {
            mX: "Direcci\xf3n de facturaci\xf3n",
            m4: "Misma direcci\xf3n de facturaci\xf3n",
            nK: "Ciudad",
            y4: "Pa\xeds",
            r1: "Direcci\xf3n",
            AO: "Calle, apartado postal, nombre de empresa, a/c",
            r2: "Direcci\xf3n complementaria",
            AP: "Apartamento, suite, unidad, edificio, piso, etc.",
            sg: "Direcci\xf3n Postal",
            sh: "Misma direcci\xf3n postal",
            tg: "Direcci\xf3n",
            C7: "Usar la direcci\xf3n del miembro principal",
            wN: "Estado (abrev.)",
            DR: "Por favor use la abreviatura de dos letras.",
            DS: "[Abreviaturas de USPS] (https://pe.usps.com/text/pub28/28apb.htm)",
            x0: "C\xf3digo Postal",
            x1: "No tenemos cobertura en su \xe1rea",
            EF: "Por favor, ingrese un c\xf3digo postal v\xe1lido de EE.UU."
        },
        ms: F2(function(n, r) {
            return "El rango de edad para este plan es de " + n + " a " + r + " a\xf1os.";
        }),
        j4: "Monto",
        yk: F2(function(n, r) {
            return n + " y " + r;
        }),
        gI: {
            w5: "Citas"
        },
        mK: "Se debe agregar al menos un dependiente al plan.",
        mL: "Se debe agregar al menos un miembro al plan.",
        mO: function(n) {
            return "escrito por " + n;
        },
        mT: "Cuenta Bancaria",
        yz: {
            mC: "Anual",
            tf: "Mensual",
            vj: "Trimestral",
            v9: "Semestral"
        },
        gS: {
            ng: "Agente comercial",
            rQ: "Qui\xe9n es tu agente comercial?",
            CB: "Seleccionar"
        },
        nh: "Cancelar",
        N: {
            mV: "antes de la cita",
            N: "Cancelar la Cita",
            ni: "Contacto para Cancelaciones",
            nk: "Pol\xedtica de Cancelaci\xf3n",
            oi: "Cont\xe1ctenos al",
            re: "horas",
            ri: "Si desea reprogramar su cita, haga click en el bot\xf3n Reprogramar para reservar un nuevo horario.",
            ta: "Plazo M\xednimo de Cancelaci\xf3n",
            vR: "Reprogramar",
            vS: "Reprogramar Cita",
            w7: "para cancelar su cita.",
            w8: "Para cancelar su cita, cont\xe1ctenos al",
            xV: "Su cita ha sido cancelada"
        },
        bd: {
            yF: "Cancelar la membres\xeda",
            yH: "Motivo de la cancelaci\xf3n",
            Ba: "Cancelando la membres\xeda para:",
            C$: "Remover Miembro",
            C0: "El miembro ha sido removido de la membres\xeda",
            C2: "Por favor ingrese una raz\xf3n de cancelaci\xf3n.",
            Da: "\xa1Lamentamos que se vaya!",
            D_: "La membres\xeda ha sido cancelada"
        },
        gT: "Tarjeta",
        ns: {
            w5: "Confirmar y Pagar"
        },
        be: {
            zC: "(A Pagar Hoy)",
            pW: "Tu carrito est\xe1 vac\xedo",
            AJ: "Acciones del art\xedculo",
            Bc: "Cuota de Membres\xeda",
            Ca: "Pago \xdanico",
            Cc: "Cuota de Inscripci\xf3n \xdanica",
            CU: "Recurrente",
            Em: "\u2014"
        },
        nt: function(n) {
            return "Recurrente (desde el " + n + ")";
        },
        c6: {
            oo: "Continuar al Pago",
            pV: "Agrega una membres\xeda o paquete para comenzar tu compra.",
            pY: "Tu carrito est\xe1 vac\xedo",
            dg: "Explorar Servicios",
            w5: "Tu Carrito"
        },
        ap: {
            zd: "dd/MM/yyyy",
            zx: "A Pagar Anualmente",
            zy: "A Pagar Trimestralmente",
            zz: "A Pagar Mensualmente",
            zA: "A Pagar Semestralmente",
            zB: "A Pagar Hoy",
            Bj: "Pr\xf3ximo cobro: { $date }",
            iD: "Desglose de Precios",
            CY: "Cargos de Inscripci\xf3n",
            DO: "A partir del { $date }",
            lE: "A partir de hoy"
        },
        kb: {
            Dz: "Ver menos",
            DB: "Ver m\xe1s"
        },
        yT: {
            w5: "Checkout"
        },
        nE: function(n) {
            return "Este plan no permite ni\xf1os de mas de " + n + " a\xf1os.";
        },
        cm: {
            qB: "Nombre Elegido",
            AB: "Nombre elegido es distinto?",
            rS: "Apellido Elegido",
            s2: "Segundo Nombre Elegido",
            wY: "Sufijo Elegido",
            w5: "T\xedtulo Elegido"
        },
        nM: "Cerrar men\xfa",
        nP: {
            rr: "El formato del c\xf3digo es inv\xe1lido."
        },
        oa: "Confirmar",
        y_: {
            l5: "Agregar luego",
            nv: "Cambia tu m\xe9todo de pago",
            oK: "Tarjeta de Cr\xe9dito o D\xe9bito",
            oL: "Tarjeta de Cr\xe9dito o D\xe9bito o Cuenta Bancaria",
            wd: "Opciones"
        },
        oe: "Por favor, contacte a la pr\xe1ctica si tiene alguna pregunta.",
        of: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        og: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        oh: F2(function(n, r) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " o al " + r + " si tiene alguna pregunta.";
        }),
        ol: "Continuar al siguiente paso",
        om: function(n) {
            return "Continuar a " + n;
        },
        on: "Continuar",
        ov: function(n) {
            return "Contrato Renueva en #" + n;
        },
        ox: function(n) {
            return "Contrato Termina en " + n;
        },
        ki: {
            gI: "Citas",
            xM: "Bienvenido/a de nuevo,"
        },
        oY: Zx,
        bk: Zx + " de nacimiento",
        pf: function(n) {
            return "La cancelaci\xf3n de esta membres\xeda detendr\xe1 los cargos recurrentes para los pacientes seleccionados y eliminar\xe1 el acceso a las ventajas de la membres\xeda a partir de " + n + ".";
        },
        hj: {
            q$: "\xbfTienes un c\xf3digo de descuento?",
            Ax: "Este no es un c\xf3digo de descuento v\xe1lido.",
            rQ: "C\xf3digo de descuento"
        },
        eB: {
            yl: "Cualquier distancia",
            rQ: "Distancia",
            Bm: "Sin filtro",
            CB: "Filtrar por distancia"
        },
        po: "Fecha de nacimiento no puede ser en el futuro.",
        pp: Vx,
        pq: Ux + " " + Vx,
        ps: function(n) {
            return n + " aceptado!";
        },
        R: {
            x3: "Aceptar",
            zj: "No, gracias",
            kn: "Escribe tu nombre y apellido",
            zl: "Firma electr\xf3nica del miembro",
            Ay: "Por favor, escribe cualquiera de los nombres exactamente como aparece arriba.",
            Az: "Por favor, escribe tu nombre exactamente como aparece arriba.",
            A6: "Nombre del Miembro",
            kR: "Nombre",
            Bi: "Nombre del Nuevo Miembro",
            CK: "Nombre del Miembro Principal",
            CL: "Escribe el nombre y apellido de cualquier miembro",
            CM: "Firma electr\xf3nica del nuevo o miembro principal",
            C5: "Por favor, firme este documento.",
            ws: "Firma electr\xf3nica",
            xq: "La firma no coincide con el nombre del firmante."
        },
        pu: {
            zw: "Pendiente",
            Cj: "Pagado",
            Ev: "Anulado"
        },
        Y: {
            w5: "Documentos"
        },
        px: "Descargar",
        bo: {
            ye: "Desde el inicio",
            y8: "A\xf1o actual",
            za: "Personalizado",
            p$: "Fecha de Fin",
            Ap: "En Progreso",
            Aq: "Su archivo est\xe1 siendo procesado y puede tardar unos segundos.",
            AM: "A\xf1o pasado",
            DN: "Fecha de Inicio"
        },
        pz: "Pr\xe1ctica DPC",
        cs: {
            rQ: "Pr\xe1ctica DPC",
            AR: "Cargando pr\xe1cticas DPC...",
            Cd: "Nombre de la Pr\xe1ctica DPC",
            Ce: "El nombre de tu Pr\xe1ctica DPC",
            CB: "Empieza a escribir para encontrar tu Pr\xe1ctica DPC",
            EE: "No se encontraron pr\xe1cticas DPC"
        },
        pC: function(n) {
            return "Vence el " + n;
        },
        pH: "Los pacientes de la membres\xeda no pueden duplicarse en la misma membres\xeda.",
        pL: "Editar",
        pP: "Email",
        aI: {
            pP: "Correo Electr\xf3nico",
            qB: "Nombre",
            rS: "Apellido",
            tg: "Nombre Completo",
            uw: "Tel\xe9fono",
            vB: "Relaci\xf3n",
            C3: "Por favor ingrese tel\xe9fono o correo electr\xf3nico.",
            C4: "Por favor, ingrese al menos nombre, apellido o relaci\xf3n.",
            DH: "Usar miembro principal como contacto de emergencia",
            w5: "Contacto de emergencia"
        },
        a_: {
            yU: "Hijo/Hija",
            z8: "Abuelo/Abuela",
            Ab: "Tutor/Tutora",
            Bm: "Ninguno",
            Cd: "Otro",
            Cl: "Padre/Madre",
            fC: "Selecciona una relaci\xf3n",
            DE: "Hermano/Hermana",
            DM: "C\xf3nyuge"
        },
        p4: "Ingl\xe9s",
        eG: {
            m3: "Frecuencia de Facturaci\xf3n",
            CJ: "Principal",
            w5: "Miembros inscritos",
            EE: "No hay pacientes inscritos"
        },
        p8: function(n) {
            return "termin\xf3 el " + n;
        },
        p9: function(n) {
            return "termina el " + n;
        },
        qa: function(n) {
            return "Inscrito el " + n;
        },
        qb: {
            pm: "No me inscriba",
            p6: "Inscr\xedbame",
            tg: "Estado de Inscripci\xf3n",
            Bt: "\xbfEst\xe1 pagando por otra persona y no desea inscribirse como paciente? Seleccione \u201CNo me inscriba\u201D."
        },
        qf: F2(function(n, r) {
            return n + ": " + r;
        }),
        qg: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        qn: F2(function(n, r) {
            return "Expira " + n + "/" + r;
        }),
        dg: {
            w5: "Explorar Servicios"
        },
        C: {
            ma: "Agregar al carrito",
            md: "ha sido agregado a tu carrito!",
            mt: "Todos",
            m5: "Facturaci\xf3n",
            yO: "Cambiar Miembro",
            n8: "Configurar detalles de la membres\xeda",
            n9: "Configurar detalles del paquete",
            oc: "Contacte a la pr\xe1ctica para obtener precios",
            hn: "Inscribirse",
            dg: "Explorar servicios",
            A4: "Miembro",
            A7: "T\xfa mismo",
            dt: "Fecha de Inicio de Membres\xeda",
            aa: "Membres\xedas",
            ij: "Paquetes",
            CR: "Comprar",
            xE: "Ver Carrito",
            EE: "No hay servicios adicionales disponibles en este momento"
        },
        qF: "para",
        eJ: {
            nL: "haz clic aqu\xed",
            q7: "No tienes autorizaci\xf3n para ver esta p\xe1gina. Por favor, usa el enlace en tu correo electr\xf3nico, o",
            q8: "para ir a la p\xe1gina principal de tu portal de pacientes.",
            w5: "Autorizaci\xf3n Requerida"
        },
        dj: {
            zf: "Fecha de Env\xedo",
            o_: "Fecha de Env\xedo",
            Bo: "# de Preguntas",
            Do: "Enviado a",
            wO: "Estado"
        },
        qH: {
            rk: "Por favor, complete las preguntas del formulario."
        },
        qV: {
            z_: "Femenino",
            rQ: "G\xe9nero",
            AY: "Masculino",
            Cd: "Otro"
        },
        qW: {
            rQ: "Identidad de g\xe9nero",
            AZ: "Hombre",
            Bl: "No binario",
            Bn: "No listado",
            CB: "Seleccionar",
            Ei: "Hombre trans",
            Ej: "Mujer trans",
            EB: "Mujer"
        },
        hD: {
            pX: "No se ha compartido informaci\xf3n de la pr\xe1ctica.",
            qe: "Hubo un error al cargar su informaci\xf3n de salud.",
            w5: "Salud"
        },
        q4: "Cobertura de salud",
        ax: {
            np: "Aseguradora",
            yJ: "Comience a escribir para encontrar su aseguradora",
            nr: "Nombre de aseguradora",
            yK: "Elija una opci\xf3n",
            Z: "Cobertura existente",
            zO: "\xbfTiene seguro o una alternativa de seguro?",
            q_: "ID de grupo",
            rc: "Deducible alto",
            Af: "\xbfEst\xe1 en un plan con deducible alto?",
            su: "ID de miembro",
            De: "Busque para filtrar..."
        },
        rq: function(n) {
            return "Por favor, ingrese " + n + " v\xe1lido.";
        },
        rt: function(n) {
            return "Se requiere un t\xe9lefono " + n + " v\xe1lido.";
        },
        rw: function(n) {
            return "Factura " + n;
        },
        rx: function(n) {
            return "Fecha de Vencimiento: " + n;
        },
        eP: {
            ui: "Pago",
            wz: "Fuente de Pago",
            jD: "Pagar Factura",
            w5: "Pagar Factura"
        },
        g: {
            ya: "cargos adiconales",
            mA: "Monto a Pagar",
            nA: "Cargos",
            oF: "Cr\xe9dito",
            oG: "Cargo por tarjeta",
            oH: "Para evitar cargos por transacci\xf3n, considere usar una cuenta bancaria (ACH) o d\xe9bito.",
            y6: "Usar una tarjeta de cr\xe9dito implicar\xe1 cargos por transacci\xf3n.",
            oI: "Cargos por tarjeta",
            oJ: "Cargos pagados por tarjeta",
            zw: "A pagar",
            pD: "gracias a",
            pE: "gracias a tu membres\xeda",
            pF: "gracias a tu paquete",
            rA: "Total de la Factura",
            dr: "Hubo un error al cargar sus facturas",
            tA: "N\xfamero de Factura",
            Cj: "Pagado",
            uf: "Pagar Factura",
            uq: "Total a Pagar",
            ur: "Pagos",
            uG: "+ impuestos",
            wV: "Subtotal",
            D$: "Impuesto",
            w5: "Facturas",
            Ee: "Total",
            xg: "Total a Pagar",
            xj: "Transferido a Cr\xe9dito",
            xU: "Has ahorrado",
            EE: "No hay facturas para mostrar"
        },
        rK: "Art\xedculo",
        hW: {
            rQ: "C\xf3mo escuchaste sobre nosotros?",
            rX: "Fuente de contacto",
            CB: "Seleccionar"
        },
        rZ: "Saber m\xe1s",
        kL: Yx,
        bZ: {
            yl: "Cualquier ubicaci\xf3n",
            pe: "Selecciona la ubicaci\xf3n donde te gustar\xeda reunirte con tu proveedor",
            Ax: "La ubicaci\xf3n es inv\xe1lida, seleccione una opci\xf3n diferente.",
            rQ: "Ubicaci\xf3n",
            CB: "Filtrar por ubicaci\xf3n",
            vJ: "Ubicaci\xf3n es requerida.",
            fC: "Seleccionar"
        },
        r8: function(n) {
            return "+ " + n + " otros";
        },
        h_: {
            g2: "c\xf3digo",
            qG: "Iniciar sesi\xf3n en su portal del paciente",
            sf: "enlace m\xe1gico"
        },
        r9: function(n) {
            return "No nos gustan las contrase\xf1as m\xe1s que a ti. Ingresa tu correo electr\xf3nico y te enviaremos un " + n + " para iniciar sesi\xf3n al instante.";
        },
        sa: "Ingresa tu correo electr\xf3nico para obtener un c\xf3digo de inicio de sesi\xf3n",
        sb: function(n) {
            return "Enviar " + n;
        },
        sl: function(n) {
            return "La edad m\xe1xima para este plan es de " + n + " a\xf1os.";
        },
        ss: function(n) {
            return "Edad " + n;
        },
        st: "Dependiente",
        sx: "Miembro principal",
        A8: {
            l1: "Agregar miembros",
            l2: "Agregar otro miembro",
            l3: "Demograf\xeda",
            l4: "Agregar Contacto de Emergencia",
            l6: "Agregar Miembro",
            l7: "+ Agregar Nuevo Miembro",
            l8: "\xa1Miembro creado exitosamente!",
            mg: "Agregando miembros?",
            zn: "Por favor, contacte a la cl\xednica para cambiar estos detalles del paciente.",
            pM: "Editar Contacto de Emergencia",
            pU: "Contacto de Emergencia",
            q0: "Seguro M\xe9dico",
            q1: "Seguro",
            q2: "N\xfamero de Grupo",
            q3: "N\xfamero de Miembro",
            rl: "Informaci\xf3n de Miembro",
            rm: "Editar Informaci\xf3n de Miembro",
            dr: "Hubo un error cargando miembros",
            sj: "Gestionar Miembro",
            A_: "Gestionar Miembros",
            tt: "No se permiten m\xe1s miembros dependientes para esta membres\xeda",
            w5: "Miembros",
            EE: "No hay miembros para mostrar"
        },
        sy: function(n) {
            return "Se permiten " + n + " miembros dependientes para esta membres\xeda";
        },
        sA: function(n) {
            return "Su membres\xeda finaliza el " + n;
        },
        e5: {
            hh: "Predeterminado",
            rQ: "M\xe9todo de Pago",
            jQ: "M\xe9todo de pago actualizado exitosamente",
            xr: "Cualquier pago pendiente de esta membres\xeda se cobrar\xe1 al nuevo m\xe9todo de pago."
        },
        sC: Qx,
        sD: function(n) {
            return Qx + " hasta " + n;
        },
        dt: {
            rQ: "Fecha de inicio de la membres\xeda"
        },
        aa: {
            ot: "Per\xedodo de contrato",
            oP: "Membres\xedas Actuales",
            oU: "Actual",
            p1: "Membres\xedas Finalizadas",
            p2: "Finalizada",
            is: "Membres\xedas Pendientes",
            vF: "Renueva la Membres\xeda",
            iU: "Ver Detalles de la Membres\xeda",
            w5: "Membres\xedas",
            Ea: "Membres\xedas y paquetes",
            EE: "No Hay Membres\xedas Para Mostrar",
            x_: "No hay elementos para mostrar"
        },
        J: {
            x8: "Agregar Destinatarios",
            nB: "Chat para conversaci\xf3n",
            nC: "Aqu\xed es donde aparecer\xedan los mensajes del chat.",
            yV: "Haga clic para cargar proveedores",
            qo: "Error al cargar conversaciones",
            zX: "Error al cargar archivo",
            zY: "Error al cargar imagen",
            qp: "Error al cargar mensajes.",
            zZ: "Error al cargar proveedores.",
            to: "Ninguna conversaci\xf3n seleccionada",
            tp: "Vea las conversaciones a la izquierda, o inicie un nuevo mensaje.",
            tq: "Sin conversaciones",
            tr: "A\xfan no hay mensajes",
            ts: "Vea las conversaciones a la izquierda o inicie un nuevo mensaje.",
            w5: "Chat",
            xn: "Escribir un mensaje..."
        },
        sF: "Pausa",
        sG: "Reproducir",
        sH: function(n) {
            return "Vista previa de " + n;
        },
        sI: "Toca para ampliar",
        sJ: "No se puede previsualizar este archivo",
        sK: "Cargando CSV",
        sL: function(n) {
            return "Vista previa de CSV: " + n;
        },
        sM: "Cargando documento",
        sN: "Cargando documento de Word",
        sO: function(n) {
            return "Vista previa del documento: " + n;
        },
        sP: "Cargando PDF",
        sQ: "Cargando vista previa del PDF",
        sR: function(n) {
            return "Columna " + n;
        },
        sS: "Cargando hoja de c\xe1lculo",
        sT: "No hay filas para mostrar.",
        sU: "Para ver este archivo, desc\xe1rgalo y \xe1brelo con la aplicaci\xf3n adecuada en tu dispositivo.",
        sV: "Este libro no tiene hojas para mostrar.",
        sW: "Cargando libro de Excel",
        sX: F2(function(n, r) {
            return "Vista previa de Excel: " + n + " \u2014 " + r;
        }),
        sY: function(n) {
            return "Vista previa de Excel: " + n;
        },
        sZ: "Cargando XML",
        s_: "Cargando XML",
        s$: function(n) {
            return "Vista previa XML: " + n;
        },
        s0: function(n) {
            return n + " se uni\xf3 a la conversaci\xf3n";
        },
        s1: function(n) {
            return n + " fue eliminado de la conversaci\xf3n";
        },
        s3: function(n) {
            return "a " + n + "  millas";
        },
        s5: function(n) {
            return "La edad m\xednima para este plan es de " + n + " a\xf1os.";
        },
        cF: {
            qB: "Nombre",
            rS: "Apellido",
            s2: "Segundo Nombre",
            wY: "Sufijo",
            w5: "T\xedtulo",
            D9: "Seleccionar"
        },
        th: "Carrito",
        ti: "Cerrar sesi\xf3n",
        tj: "Pr\xf3xima factura",
        tl: "Siguiente paso",
        tm: "No",
        tn: function(n) {
            return "Al menos un miembro de la membres\xeda debe tener " + n + " a\xf1os o m\xe1s.";
        },
        tw: {
            aH: "Documento",
            pK: "Prescripci\xf3n",
            qr: "Fax",
            kB: "Formulario",
            rj: "Prescripci\xf3n",
            rP: "Resultados de Laboratorio",
            tu: "Nota",
            xH: "Signos Vitales"
        },
        tE: function(n) {
            return "de " + n + " pendiente";
        },
        tH: function(n) {
            return "el " + n;
        },
        tP: "Abrir men\xfa",
        Cd: "Otro",
        aB: {
            n7: "Completar Compra",
            hl: "Finalizar",
            zB: "Total a Pagar Hoy",
            A4: "Miembro",
            ia: "No hay m\xe9todos de pago disponibles",
            dz: "M\xe9todo de Pago",
            iD: "Desglose de Precios",
            vf: "Compra completada exitosamente",
            jF: "\xa1Todo listo! El paquete est\xe1 disponible de inmediato.",
            dY: "\xa1Compra realizada con \xe9xito!",
            w5: "Revisar y Pagar"
        },
        tW: function(n) {
            return "Expira el " + n;
        },
        tX: function(n) {
            return n + " utilizados";
        },
        ij: {
            iU: "Ver Detalles del Paquete"
        },
        t6: "Paciente",
        dz: "M\xe9todo de pago",
        cH: {
            yi: "American Express no es aceptado.",
            qU: "Fecha de vencimiento futura",
            rs: "Por favor, ingrese un nombre v\xe1lido para el titular del m\xe9todo de pago.",
            rQ: "Fuente de pago",
            C5: "Por favor, agregue un m\xe9todo de pago.",
            Db: "Guardar m\xe9todo de pago"
        },
        uk: function(n) {
            return n + " no tiene pagos configurados.";
        },
        bx: {
            yB: "Bloqueado",
            y$: "Confirmado",
            zR: "A punto de expirar",
            zW: "Fallido",
            Ax: "Inv\xe1lido",
            Bh: "Nuevo",
            u3: "Procesando",
            Ew: "Advertencia"
        },
        um: function(n) {
            return n + " es ahora la fuente predeterminada";
        },
        un: function(n) {
            return n + " fue eliminado exitosamente.";
        },
        Cw: {
            l1: "+ Agregar M\xe9todo de Pago",
            l9: "Agrega un M\xe9todo de Pago",
            gT: "Tarjeta",
            oD: "Su fuente de pago se ha creado con \xe9xito",
            pw: "No guardar fuente de pago",
            pN: "Editar Fuente de Pago",
            hr: "Mes de Expiraci\xf3n",
            hs: "A\xf1o de Expiraci\xf3n",
            rD: "Predeterminado",
            dr: "Hubo un Error Cargando Tus Fuentes de Pago",
            si: "Hacer predeterminado",
            ug: "Usa esta fuente de pago para pagar facturas vencidas",
            Db: "Guardar M\xe9todo de Pago",
            w5: "Fuentes de pago",
            xe: "Enlace ya utilizado",
            jQ: "Su informaci\xf3n de pago se ha actualizado con \xe9xito",
            EE: "No Hay Fuentes de Pago Para Mostrar",
            x0: "C\xf3digo Postal",
            x2: "12345"
        },
        up: "T\xe9rminos de pago",
        ur: {
            uj: "Pago fallido!",
            uo: "Pago exitoso!"
        },
        fh: {
            Bt: "En nombre del nuevo miembro:",
            tF: "Condiciones generales:",
            Bu: "En nombre de cada miembro de la membres\xeda:",
            is: "No aceptados"
        },
        us: "Requerido para: todos los inscritos",
        ut: function(n) {
            return "Requerido para: " + n;
        },
        fi: {
            mC: "/a\xf1o",
            tf: "/mes",
            vj: "/trimestre",
            v9: "/6 meses"
        },
        uw: "Tel\xe9fono",
        cI: {
            l1: "Agregar otro n\xfamero de tel\xe9fono",
            Ah: "Casa",
            rQ: "N\xfamero de tel\xe9fono",
            Bf: "Movil",
            Bp: "Oficina",
            C_: "Borrar n\xfamero de tel\xe9fono"
        },
        uC: "Plan",
        G: {
            mB: "Anual",
            m6: "Frecuencia de Facturaci\xf3n",
            n6: "Completar Inscripci\xf3n",
            hl: "Finalizar",
            zB: "Total a Pagar Hoy",
            qc: "Inscripci\xf3n completada exitosamente",
            A4: "Miembro",
            dt: "Fecha de Inicio de Membres\xeda",
            tf: "Mensual",
            ia: "No hay m\xe9todos de pago disponibles",
            tN: "Tarifa \xfanica de registro",
            dz: "M\xe9todo de Pago",
            CU: "Recurrente",
            wM: "Comienza Hoy",
            jF: "Recibir\xe1 un correo electr\xf3nico de confirmaci\xf3n en breve con todos los detalles.",
            dY: "\xa1Est\xe1 inscrito!",
            w5: "Revisar y Pagar"
        },
        uF: "Por favor",
        uO: function(n) {
            return "La pr\xe1ctica no acepta miembros menores a " + n;
        },
        uU: "Idioma preferido",
        ab: {
            zc: "Fecha de Dispensaci\xf3n",
            kj: "Fecha de Prescripci\xf3n",
            kl: "# d\xedas de tratamiento",
            kB: "Forma",
            qP: "Frecuencia",
            kH: "Instrucciones",
            A3: "Medicaci\xf3n",
            lh: "Prescriptor",
            li: "Precio",
            vg: "Cant.",
            CX: "Repeticiones",
            ls: "V\xeda de Administraci\xf3n",
            lF: "Concentraci\xf3n",
            lN: "Fecha de Uso"
        },
        u5: {
            Ac: "\xc9l",
            rQ: "Pronombres",
            Bn: "No listado",
            CB: "Seleccionar",
            Ds: "Ella",
            D5: "Ellos"
        },
        u7: Ox,
        u8: Ux + " " + Ox + " y " + Yx,
        u9: Ox + " inv\xe1lido, por favor seleccione una opci\xf3n v\xe1lida.",
        lk: {
            v7: "Proveedor y ubicaci\xf3n seleccionados!",
            w5: "Seleccionar Proveedor y Ubicaci\xf3n"
        },
        vb: Ox + " es requerido.",
        vc: {
            Dd: "Buscar por nombre"
        },
        vd: Ux + " " + Ox,
        ve: "Proveedor seleccionado!",
        CR: function(n) {
            return "Compra " + n;
        },
        vh: "Cant.",
        fr: {
            kr: "Cobro inmediato",
            qA: "Primera Factura",
            Cb: "Tarifa \xfanica de registro",
            CU: "Recurrente",
            CV: "Facturas Recurrentes",
            Dg: "Segunda Factura",
            Ef: "Factura Total"
        },
        lm: {
            rQ: "Tarifa y per\xedodo de pago",
            CB: "Seleccionar"
        },
        ft: {
            yk: "y los",
            AN: "Este sitio est\xe1 protegido por reCAPTCHA y se aplican la",
            CN: "Pol\xedtica de Privacidad",
            D1: "T\xe9rminos de Servicio"
        },
        vq: " de Google.",
        vB: {
            yd: "Adulto/a",
            yU: "Hijo/a",
            rQ: "Relaci\xf3n con usted",
            tU: "Titular"
        },
        C_: "Eliminar",
        vE: "Eliminando",
        vK: "Por favor, describa.",
        vL: function(n) {
            return "Por favor, ingrese " + n + ".";
        },
        vM: function(n) {
            return "Por favor, seleccione " + n + ".";
        },
        v$: {
            y9: "Actualmente viendo datos de sandbox."
        },
        Db: "Guardar",
        v4: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta de forma recurrente como se establece en su acuerdo de membres\xeda o como se le muestra durante el proceso de registro. Usted comprende que puede comunicarse con " + n + " para revocar esta autorizaci\xf3n en cualquier momento.";
        },
        v5: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta este servicio tal y como se le muestra.";
        },
        dM: {
            yZ: "marcos integrales",
            z7: "de seguridad y cumplimiento",
            Cf: "Nuestra",
            CC: "plataforma",
            D0: "utiliza tecnolog\xeda de cifrado de datos de \xfaltima generaci\xf3n y se audita peri\xf3dicamente seg\xfan"
        },
        fC: Ux,
        lx: {
            pe: "Tu sesi\xf3n expir\xf3, por favor inicia sesi\xf3n nuevamente.",
            w5: "Sesi\xf3n Expirada"
        },
        we: {
            z_: "Femenino",
            Aw: "Intersexual",
            rQ: "Sexo",
            AY: "Masculino",
            CB: "Seleccionar"
        },
        wl: "Iniciar sesi\xf3n",
        wm: function(n) {
            return "Al hacer clic en " + n + ", reconozco que cumplo con los";
        },
        wn: "requisitos",
        wo: "que permiten a esta plataforma recopilar la informaci\xf3n que he proporcionado.",
        wp: "Cerrar sesi\xf3n",
        wq: function(n) {
            return "\xbfNo tienes una membres\xeda con " + n + "?";
        },
        wr: "Reg\xedstrate hoy",
        ww: F2(function(n, r) {
            return "Reg\xedstrate con " + n + " a trav\xe9s de " + r;
        }),
        wx: function(n) {
            return "Reg\xedstrate con " + n;
        },
        wC: "Espa\xf1ol",
        wG: "SSN",
        DN: Gx,
        wJ: function(n) {
            return Gx + " no puede ser anterior a " + n + ".";
        },
        ba: {
            x9: "datos adicionales",
            y_: "confirmaci\xf3n",
            y0: "contacto",
            zb: "detalles personalizados",
            kL: "ubicaci\xf3n",
            A8: "miembros",
            A9: "Demograf\xeda",
            Bb: "membres\xeda",
            u7: "proveedor"
        },
        wQ: "Por favor, ingresa un m\xe9todo de pago o nombre del titular de la cuenta v\xe1lido.",
        wR: function(n) {
            return n;
        },
        cW: {
            yT: "Recibir\xe1s una confirmaci\xf3n de compra si nos autorizaste a enviarte correos electr\xf3nicos. Si tienes alguna otra pregunta, por favor cont\xe1ctanos directamente.",
            pS: "\xa1Error al enviar el correo!",
            pT: "\xa1Correo enviado!",
            CR: "\xa1Gracias por tu compra!",
            w5: "Gracias",
            Ey: "\xa1Estamos encantados de tenerte como nuevo miembro! Espera recibir una factura una vez que se confirme tu membres\xeda."
        },
        jL: {
            zu: "No usa tabaco",
            w5: "Uso de Tabaco",
            xy: "Usa tabaco"
        },
        xf: "Hay demasiados dependientes en esta membres\xeda.",
        xp: "Ocurri\xf3 un error, por favor int\xe9ntalo de nuevo.",
        cY: {
            kw: "El paciente no puede ser verificado",
            vT: "Reenviar c\xf3digo",
            jD: "Iniciar sesi\xf3n",
            D_: "Paciente verificado",
            w5: "Ingresa tu c\xf3digo",
            xW: "Tu c\xf3digo"
        },
        xA: "Puede tardar unos segundos en llegar y ser\xe1 v\xe1lido por 15 minutos.",
        xB: function(n) {
            return "Ingresa el c\xf3digo que acabamos de enviar a " + n;
        },
        xC: function(n) {
            return "Se ha enviado un correo electr\xf3nico con un c\xf3digo a " + n + ". Por favor, ingresa el c\xf3digo dentro de los pr\xf3ximos 15 minutos.";
        },
        xG: function(n) {
            return "Ir al sitio web de " + n;
        },
        aT: {
            nb: "IMC (Ingl\xe9s)",
            pg: "Diast\xf3lica (mmHg)",
            q6: "Altura (pulg)",
            CQ: "Pulso (ppm)",
            vW: "Frecuencia Respiratoria (ppm)",
            wE: "SpO2 (%)",
            wZ: "Sist\xf3lica (mmHg)",
            w2: "Temp (\xb0F)",
            xL: "Peso (libras)",
            Ez: "Cu\xe1ndo"
        },
        q: {
            me: "\xa1Te has unido a la lista de espera!",
            mf: "Te notificaremos cuando haya un lugar disponible con",
            mS: "Lleno - Unirse a lista de espera",
            pQ: "Correo electr\xf3nico",
            pR: "maria@ejemplo.com",
            p5: "# Personas a inscribir",
            qC: "Nombre",
            qD: "Mar\xeda",
            ru: "Completa tu registro a continuaci\xf3n para unirte a",
            rv: "\xa1Has sido invitado de la lista de espera!",
            AK: "Unirse a la lista de espera",
            rM: "Uni\xe9ndose a la",
            rN: "lista de espera...",
            rT: "Apellido",
            rU: "Garc\xeda",
            t_: "\xdanete a la lista de espera",
            ux: "Tel\xe9fono",
            va: "Proveedor",
            v6: "Selecciona un proveedor",
            wS: "Algo sali\xf3 mal. Por favor, int\xe9ntalo de nuevo.",
            wX: "Te contactaremos cuando haya un lugar disponible con",
            dY: "\xa1Est\xe1s en la lista de espera!"
        },
        xN: function(n) {
            return "Bienvenido a " + n;
        },
        xT: "Si",
        xX: "Tus datos de contacto",
        xY: "Tu Email"
    }), Wx = F2(function(n, r) {
        return r(n ? Jx : Rx);
    }), Kx = F2(function(n, r) {
        return A2(dr, n, Ax(r));
    }), Xx = Kx("className"), nk = cr("div"), rk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tk = rk(3), ek = xr, uk = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(Eu, ek(yu), r);
        }
        switch(n.a){
            case 0:
                return x([
                    Xx("spinner--xs")
                ]);
            case 1:
                return x([
                    Xx("spinner--sm")
                ]);
            case 3:
                return x([
                    Xx("spinner--lg")
                ]);
            default:
                return h;
        }
    }, ak = cr("span"), ik = function(n) {
        return A2(ak, A2(Yt, Xx("spinner"), A2(tc, uk, n)), x([
            A2(ak, x([
                Xx("spinner__dot")
            ]), h),
            A2(ak, x([
                Xx("spinner__dot")
            ]), h),
            A2(ak, x([
                Xx("spinner__dot")
            ]), h),
            A2(ak, x([
                Xx("spinner__dot")
            ]), h)
        ]));
    }, ck = x([
        A2(nk, x([
            Xx("flex justify-center")
        ]), x([
            ik(x([
                tk
            ]))
        ]))
    ]), ok = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fk = cr("h2"), sk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lk = sk(3), dk = function(n) {
        switch(n){
            case 4:
                return "text-2xl sm:text-4xl";
            case 3:
                return "text-l";
            case 2:
                return "text-base";
            case 1:
                return "text-sm";
            default:
                return "text-xs";
        }
    }, bk = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "sm:";
            case 2:
                return "md:";
            case 3:
                return "lg:";
            default:
                return "xl:";
        }
    }, vk = F2(function(n, r) {
        return x([
            Xx($(bk(n), dk(r)))
        ]);
    }), mk = function(n) {
        switch(n){
            case 0:
                return "start";
            case 1:
                return "center";
            case 2:
                return "end";
            default:
                return "between";
        }
    }, pk = function(n) {
        switch(n.$){
            case 0:
                var r = function(n) {
                    return "text-" + n;
                };
                switch(n.a){
                    case 0:
                        return r("left");
                    case 1:
                        return r("center");
                    case 2:
                        return r("right");
                    default:
                        return r("between");
                }
            case 2:
                return "justify-" + mk(n.a);
            case 1:
                return "items-" + mk(n.a);
            default:
                return "self-" + mk(n.a);
        }
    }, $k = function(n) {
        return x([
            Xx(pk(n))
        ]);
    }, hk = function(n) {
        var r = n.a, t = function(n) {
            if (1 === n.$) return "0";
            switch(n.a){
                case 0:
                    return "1";
                case 1:
                    return "2";
                case 2:
                    return "4";
                case 3:
                    return "8";
                default:
                    return "12";
            }
        }(n.b), e = function(n) {
            switch(n.$){
                case 0:
                    switch(n.a){
                        case 0:
                            return "t";
                        case 1:
                            return "r";
                        case 3:
                            return "b";
                        default:
                            return "l";
                    }
                case 2:
                    return "x";
                case 1:
                    return "y";
                default:
                    return "";
            }
        }(r);
        return A2(fe, "-", x([
            "m" + e,
            t
        ]));
    }, gk = function(n) {
        return x([
            Xx(hk(n))
        ]);
    }, wk = F2(function(n, r) {
        return x([
            Xx($(bk(n), pk(r)))
        ]);
    }), xk = F2(function(n, r) {
        return x([
            Xx($(bk(n), hk(r)))
        ]);
    }), kk = function(n) {
        switch(n){
            case 0:
                return "font-thin";
            case 1:
                return "font-normal";
            case 2:
                return "font-medium";
            case 3:
                return "font-semibold";
            case 4:
                return "font-bold";
            default:
                return "font-extrabold";
        }
    }, yk = function(n) {
        n: for(;;)switch(n.$){
            case 9:
                var r = n.a;
                if (r.a) {
                    n = r.b;
                    continue n;
                }
                return h;
            case 1:
                switch(n.a){
                    case 2:
                        return x([
                            Xx("text-danger")
                        ]);
                    case 0:
                        return x([
                            Xx("text-success")
                        ]);
                    case 3:
                        return x([
                            Xx("text-warning")
                        ]);
                    case 1:
                        return x([
                            Xx("text-support")
                        ]);
                    case 4:
                        return x([
                            Xx("text-primary")
                        ]);
                    case 5:
                        return x([
                            Xx("text-primary-500")
                        ]);
                    default:
                        return x([
                            Xx("text-light-gray")
                        ]);
                }
            case 0:
                return x([
                    Xx(dk(n.a))
                ]);
            case 2:
                return x([
                    Xx(kk(n.a))
                ]);
            case 4:
                return x(n.a ? [
                    Xx("line-through")
                ] : [
                    Xx("underline")
                ]);
            case 5:
                return gk(n.a);
            case 6:
                return A2(xk, n.a, n.b);
            case 7:
                return $($k(t = n.a), t.$ ? x([
                    Xx("flex")
                ]) : h);
            case 8:
                var t;
                return A2(wk, n.a, t = n.b);
            case 3:
                return n.a;
            default:
                return A2(vk, n.a, n.b);
        }
    }, _k = function(n) {
        return A2(Eu, ek(yu), rc(A2(Eu, yk, n)));
    }, Ak = F2(function(n, r) {
        return A2(fk, _k(A2(Yt, lk, A2(Yt, ok(x([
            Xx("text-primary-300")
        ])), n))), r);
    }), Ck = fr, Bk = cr("p"), Ek = F2(function(n, r) {
        return A2(Bk, _k(n), A2(Eu, Ck(yu), r));
    }), Dk = A2(cr("hr"), x([
        Xx("horizontal-rule")
    ]), h), qk = A2(nk, x([
        Xx("panel w-full")
    ]), x([
        A2(Ak, h, x([
            ld("Page Not Found")
        ])),
        Dk,
        A2(Ek, h, x([
            A2(Ek, h, x([
                ld("This page doesn't exist anymore. Please check your URL for typos.")
            ])),
            A2(Ek, h, x([
                ld("Feel free to contact us to let us know about any broken links.")
            ]))
        ]))
    ])), Fk = function(n) {
        return {
            Ar: F2(function(r, t) {
                var e = b(r.dB, gx(r.gF));
                switch(e.a.$){
                    case 3:
                        return e.b ? v($x(t), Pp, h) : A2(Fx, px, A2(wx, h, A3(n.Ar, e.a.a, r, t)));
                    case 1:
                    case 0:
                        return v($x(t), Pp, h);
                    default:
                        return v(mx, Pp, h);
                }
            }),
            AQ: F2(function(r, t) {
                var e = b(r.dB, t);
                n: for(; !e.b.$;)switch(e.a.$){
                    case 3:
                        var u = e.a.a, a = e.b.a;
                        if (gx(r.gF)) return b($x(a), Pp);
                        var c = A3(n.Ar, u, r, a), o = c.b;
                        return b(px(c.a), Vu(x([
                            o,
                            Dx(u)
                        ])));
                    case 2:
                        return b(mx, Pp);
                    default:
                        break n;
                }
                if (1 === t.$) {
                    var f = t.a;
                    return A2(qx, px, A2(n.AQ, r, m(f, {
                        kA: i(r.kA, f.kA) ? f.kA : r.kA
                    })));
                }
                return b(t, Pp);
            }),
            Db: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Db, r.a, t) : t;
            }),
            DZ: function(r) {
                return 1 === r.$ ? n.DZ(r.a) : zx;
            },
            En: F2(function(r, t) {
                return 1 === t.$ ? A2(Fx, px, A2(n.En, r, t.a)) : v(t, Pp, h);
            }),
            Et: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.Et, Wx(t.kA), t);
                    case 2:
                        return {
                            gN: x([
                                qk
                            ]),
                            w5: "404"
                        };
                    default:
                        return {
                            gN: ck,
                            w5: "Loading..."
                        };
                }
            }
        };
    }, Pk = eu(Te), zk = F3(function(n, r, t) {
        return {
            mG: r,
            rh: n,
            rB: t
        };
    }), jk = W, Sk = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lk = A2(nu, function(n) {
        switch(n){
            case "in_person":
                return uu(0);
            case "virtual":
                return uu(1);
            default:
                return Sk("Invalid meeting type");
        }
    }, C$), Mk = F5(function(n, r, t, e, u) {
        return {
            mk: t,
            my: u,
            rh: n,
            tg: r,
            xb: e
        };
    }), Nk = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Hk = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Tk = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ik = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2(em, !1, t.b) : A3(um, !1, t.b, t.c);
        };
    }, Rk = function(n) {
        return function(r) {
            return A3(um, !0, n, r);
        };
    }, Zk = Nm, Vk = A2(Zk, F2(function(n) {
        return A2(sc, 0, pu(n));
    }), Cm(ye)), Uk = A2(Zk, F2(function(n) {
        return A2(sc, 0, pu(n));
    }), A2(sm, A2(sm, lm(0), Cm(ye)), Cm(ye))), Yk = A2(Zk, F2(function(n) {
        return A2(sc, 0, pu(n));
    }), A2(sm, A2(sm, A2(sm, lm(0), Cm(ye)), Cm(ye)), Cm(ye))), Qk = Om(x([
        A2(zm, A2(sm, lm(iu), xm("-")), Om(x([
            Ik(A2(im, Rk, A2(Vm, Hk, Yk))),
            A2(zm, A2(zm, lm(Nk), Uk), Om(x([
                A2(zm, A2(sm, lm(iu), xm("-")), Uk),
                lm(1)
            ]))),
            A2(zm, A2(zm, A2(sm, lm(Tk), xm("W")), Uk), Om(x([
                A2(zm, A2(sm, lm(iu), xm("-")), Vk),
                lm(1)
            ])))
        ]))),
        Ik(A2(im, Rk, A2(zm, A2(zm, lm(Nk), Uk), Om(x([
            Uk,
            lm(1)
        ]))))),
        A2(Vm, Hk, Yk),
        A2(zm, A2(zm, A2(sm, lm(Tk), xm("W")), Uk), Om(x([
            Vk,
            lm(1)
        ]))),
        lm(Hk(1))
    ])), Ok = F3(function(n, r, t) {
        return 1 > s(n, t) && 1 > s(t, r);
    }), Gk = F3(function(n, r, t) {
        return A3(Ok, 1, 12, r) && A3(Ok, 1, A2(Cv, n, Bv(r)), t) ? te(qv(n) + A2(lp, n, Bv(r)) + t) : Kt("Invalid calendar date (" + oe(n) + ", " + oe(r) + ", " + oe(t) + ")");
    }), Jk = F2(function(n, r) {
        return A3(Ok, 1, 365, r) || 366 === r && Av(n) ? te(qv(n) + r) : Kt("Invalid ordinal date (" + oe(n) + ", " + oe(r) + ")");
    }), Wk = function(n) {
        return qv(n) + 1;
    }, Kk = F3(function(n, r, t) {
        var e, u;
        return A3(Ok, 1, 7, t) && (A3(Ok, 1, 52, r) || 53 === r && (4 === (u = Uv(Wk(e = n))) || 3 === u && Av(e))) ? te(Yv(n) + 7 * (r - 1) + t) : Kt("Invalid week date (" + oe(n) + ", " + oe(r) + ", " + oe(t) + ")");
    }), Xk = function(n) {
        var r = n.a, t = n.b;
        switch(t.$){
            case 0:
                return A3(Gk, r, t.a, t.b);
            case 1:
                return A3(Kk, r, t.a, t.b);
            default:
                return A2(Jk, r, t.a);
        }
    }, ny = A2(Zk, F2(function(n) {
        return A2(sc, 0, pu(n));
    }), A2(sm, A2(sm, A2(sm, A2(sm, A2(sm, lm(0), Om(x([
        Cm(function(n) {
            return "-" === n;
        }),
        lm(0)
    ]))), Cm(ye)), Cm(ye)), Cm(ye)), Cm(ye))), ry = F2(function(n, r) {
        return b(n, r);
    }), ty = function(n) {
        return n.$ ? jm(n.a) : lm(n.a);
    }, ey = A2(im, A2(ru, Xk, ty), A2(zm, A2(zm, lm(ry), ny), Qk)), uy = A2(ru, ep(A2(zm, lm(iu), A2(sm, ey, A2(im, ty, Om(x([
        A2(Vm, te, Gm),
        A2(Vm, cm(Kt("Expected a date only, not a date and time")), Cm(Ie("T"))),
        lm(Kt("Expected a date only"))
    ])))))), n$(A2(ru, rv, A2(ru, Fp(function(n) {
        var r = n.u$;
        return 12 === r.$ ? r.a : "Expected a date in ISO 8601 format";
    }), sc(""))))), ay = A2(nu, A2(ru, uy, function(n) {
        return n.$ ? Sk(n.a) : uu(n.a);
    }), C$), iy = function(n) {
        return P$(x([
            A2(tu, Vt, n),
            uu(Ut)
        ]));
    }, cy = ln, oy = function(n) {
        return {
            $: 5,
            c: n
        };
    }, fy = F3(function(n, r, t) {
        return A2(nu, function(e) {
            var u = A2(cy, n, e);
            if (u.$) return uu(t);
            var a = u.a, i = A2(cy, P$(x([
                r,
                oy(t)
            ])), a);
            return i.$ ? Sk(Ee(i.a)) : uu(i.a);
        }, w$);
    }), sy = F4(function(n, r, t, e) {
        return A2(Pk, A3(fy, A2(Tu, n, w$), r, t), e);
    }), ly = F3(function(n, r, t) {
        return A2(Pk, A2(Tu, n, r), t);
    }), dy = A4(sy, "allow_online_booking", iy(jk), Ut, A4(sy, "today", iy(ay), Ut, A4(sy, "address", iy(C$), Ut, A3(ly, "name", C$, A3(ly, "id", C$, uu(Mk)))))), by = A2(Pk, dy, uu(iu)), vy = function(n) {
        return {
            $: 3,
            b: n
        };
    }, my = A4(sy, "contact_info_for_cancellation", iy(C$), Ut, A4(sy, "latest_cancellation_notice_time_amount", iy(F$), Ut, A4(sy, "latest_cancellation_notice_time_format", iy(C$), Ut, A4(sy, "cancellation_policy", iy(C$), Ut, A4(sy, "booking_locations", iy(vy(by)), Ut, A3(ly, "allow_instant_book", jk, A3(ly, "allow_non_member_to_book", jk, A3(ly, "meeting_type", Lk, A3(ly, "duration", F$, A3(ly, "name", C$, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    mv: a,
                                                    mx: u,
                                                    ne: i,
                                                    nk: c,
                                                    od: s,
                                                    pI: t,
                                                    rh: n,
                                                    rV: f,
                                                    rW: o,
                                                    sr: e,
                                                    tg: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), py = A2(Pk, my, uu(iu)), $y = A3(ly, "is_cancellable", jk, A3(ly, "appointment_type", iy(py), A3(ly, "id", C$, uu(zk)))), hy = A2(Pk, $y, uu(iu)), gy = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), wy = {
        $: 1
    }, xy = {
        $: 8
    }, ky = {
        $: 4
    }, yy = {
        $: 3
    }, _y = {
        $: 9
    }, Ay = {
        $: 2
    }, Cy = {
        $: 0
    }, By = F2(function(n, r) {
        return A3(Bu, Tu, r, n);
    }), Ey = F3(function(n, r, t) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t
        };
    }), Dy = F3(function(n, r, t) {
        return A2(fe, r, A2(se, n, t));
    }), qy = function(n) {
        switch(n.$){
            case 0:
                return Ee(n);
            case 1:
                var r = n.b;
                return oe(n.a) + " -> " + qy(r);
            case 2:
                return A2(fe, "\n", A2(Eu, qy, n.a));
            default:
                var t = n.a;
                return t + "\n" + A3(Dy, t, "", A3(Dy, "  ", "", A3(Dy, "\n", "", A3(Dy, "Problem with the given value:", "", Ee(n)))));
        }
    }, Fy = F3(function(n, r, t) {
        return Kt(A3(Ey, qy(t), n, r));
    }), Py = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), zy = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jy = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Sy = {
        $: 2
    }, Ly = function(n) {
        return {
            $: 1,
            a: n
        };
    }, My = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ny = {
        $: 1
    }, Hy = function(n) {
        return !n.$;
    }, Ty = In, Iy = F2(function(n, r) {
        return A3(Nt, "", iu, A2(ru, r, n));
    }), Ry = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Zy = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Vy = function(n) {
        if (n.$) return Ry(n.a);
        var r = n.a;
        return A2(Zy, r.a, r.b);
    }, Uy = F3(function(n, r, t) {
        return A2(Iy, A2(ru, Vy, r), function(r) {
            switch(r.$){
                case 0:
                    return Kt(wy);
                case 1:
                    return Kt(Ay);
                case 2:
                    return Kt(yy);
                case 3:
                    var e = r.b;
                    switch((i = r.a).DT){
                        case 401:
                            return Kt(Cy);
                        case 403:
                            return Kt(xy);
                        case 404:
                            return Kt(_y);
                        case 500:
                        case 504:
                            return function(n) {
                                var r = A2(Yp, A2(By, x([
                                    "message"
                                ]), C$), n);
                                return Kt({
                                    $: 7,
                                    a: B$(r)
                                });
                            }(e);
                        case 502:
                            return Kt(ky);
                        default:
                            var u = P$(x([
                                A2(By, x([
                                    "error"
                                ]), iy(C$)),
                                A2(By, x([
                                    "message"
                                ]), iy(C$))
                            ])), a = A2(Yp, u, e);
                            return a.$ ? A3(Fy, n, i, a.a) : Kt(A2(gy, i.DT, A2(sc, "", a.a)));
                    }
                default:
                    var i = r.a, c = vu(e = r.b) ? "{}" : e, o = A2(Yp, t, c);
                    return o.$ ? A3(Fy, n, i, o.a) : te(b(o.a, i.hC));
            }
        });
    }), Yy = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Qy = Yy, Oy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gy = F2(function(n, r) {
        return {
            vH: n,
            wT: r
        };
    }), Jy = _u(A2(Gy, da, h)), Wy = function(n) {
        return _n(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(kn(0));
        });
    }, Ky = Dn, Xy = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(Du, function(r) {
                        var e = a.Eh;
                        return A3(Xy, n, u, 1 === e.$ ? t : A3(ta, e.a, r, t));
                    }, Ky(A3(Lt, n, zu(n), a)));
                }
                var i = e.a, c = A2(Wu, i, t);
                if (1 === c.$) {
                    r = u;
                    continue n;
                }
                return A2(Du, function() {
                    return A3(Xy, n, u, A2(fa, i, t));
                }, Wy(c.a));
            }
            return _u(t);
        }
    }), n_ = F4(function(n, r, t, e) {
        return A2(Du, function(n) {
            return _u(A2(Gy, n, t));
        }, A3(Xy, n, r, e.vH));
    }), r_ = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? Vt(A2(zu, n, u(t))) : Ut;
    }), t_ = F3(function(n, r, t) {
        return A2(Du, function() {
            return _u(t);
        }, Pu(A2(Tp, A3(r_, n, r.a, r.b), t.wT)));
    }), e_ = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Oy({
                yf: t.yf,
                gN: t.gN,
                zQ: A2(Ht, n, t.zQ),
                hC: t.hC,
                Be: t.Be,
                D8: t.D8,
                Eh: t.Eh,
                xs: t.xs
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), u_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    Mn.Http = Nn(Jy, n_, t_, e_, F2(function(n, r) {
        return A2(u_, r.a, A2(ru, r.b, n));
    }));
    var a_, i_, c_ = Rn("Http"), o_ = (Rn("Http"), function(n) {
        return c_(Oy({
            yf: !1,
            gN: n.gN,
            zQ: n.zQ,
            hC: n.hC,
            Be: n.Be,
            D8: n.D8,
            Eh: n.Eh,
            xs: n.xs
        }));
    }), f_ = {
        $: 0
    }, s_ = function(n) {
        return A2(Rt, "application/json", A2(ce, 0, n));
    }, l_ = F4(function(n, r, t, e) {
        for(;;){
            var u = A2(r(n), t, e), a = u.a, i = u.b;
            if (i.$) return b(a, i.a);
            n = i.a, e = a;
        }
    }), d_ = F2(function(n, r) {
        return A2(l_, n, r);
    }), b_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, v_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, m_ = 63, p_ = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, $_ = function(n) {
        if (25 >= n) return p_(65 + n);
        if (51 >= n) return p_(n - 26 + 97);
        if (61 >= n) return p_(n - 52 + 48);
        switch(n){
            case 62:
                return "+";
            case 63:
                return "/";
            default:
                return "\0";
        }
    }, h_ = F2(function(n, r) {
        var t = $_(n & m_), e = $_(n >>> 6 & m_), u = $_(n >>> 12 & m_), a = $_(n >>> 18);
        switch(r){
            case 0:
                return A2(Rb, a, A2(Rb, u, A2(Rb, e, Zb(t))));
            case 1:
                return A2(Rb, a, A2(Rb, u, A2(Rb, e, "=")));
            case 2:
                return A2(Rb, a, A2(Rb, u, "=="));
            default:
                return "";
        }
    }), g_ = F4(function(n, r, t, e) {
        var u = $_(t >>> 6 & m_), a = $_(t >>> 12 & m_), i = $_(t >>> 18), c = $_(t & m_), o = $_(n & m_), f = $_(n >>> 6 & m_), s = $_(n >>> 12 & m_), l = $_(n >>> 18), d = $_(r & m_), b = $_(r >>> 6 & m_), v = $_(r >>> 12 & m_), m = $_(r >>> 18);
        return A2(Rb, i, A2(Rb, a, A2(Rb, u, A2(Rb, c, A2(Rb, m, A2(Rb, v, A2(Rb, b, A2(Rb, d, A2(Rb, l, A2(Rb, s, A2(Rb, f, A2(Rb, o, e))))))))))));
    }), w_ = F5(function(n, r, t, e, u) {
        return A4(g_, (65535 & r) << 8 | t >>> 24, (255 & n) << 16 | r >>> 16, n >>> 8, A4(g_, (255 & e) << 16 | u, e >>> 8, 16777215 & t, ""));
    }), x_ = F6(function(n, r, t, e, u, a) {
        var i = r, c = t, o = e, f = u, s = a;
        return F2(function(r, t) {
            var e = A2(i, r, t), u = e.b, a = A2(c, r, e.a), l = a.b, d = A2(o, r, a.a), v = d.b, m = A2(f, r, d.a), p = m.b, $ = A2(s, r, m.a);
            return b($.a, A5(n, u, l, v, p, $.b));
        });
    }), k_ = zt(!1), y_ = jt(!1), __ = A6(x_, w_, y_, y_, y_, y_, k_), A_ = F2(function(n, r) {
        var t = r;
        return F2(function(r, e) {
            var u = A2(t, r, e);
            return b(u.a, n(u.b));
        });
    }), C_ = F3(function(n, r, t) {
        var e = r, u = t;
        return F2(function(r, t) {
            var a = A2(e, r, t), i = a.b, c = A2(u, r, a.a);
            return b(c.a, A2(n, i, c.b));
        });
    }), B_ = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return F2(function(r, t) {
            var e = A2(u, r, t), c = e.b, o = A2(a, r, e.a), f = o.b, s = A2(i, r, o.a);
            return b(s.a, A3(n, c, f, s.b));
        });
    }), E_ = Pt, D_ = function(n) {
        var r, t, e = n.iH, u = n.DX;
        return 18 > e ? 3 > e ? e ? 2 === e ? (t = F2(function(n, r) {
            return b_($(u, A2(h_, n << 16 | r << 8, 1)));
        }), A3(C_, t, E_, E_)) : A2(A_, function(n) {
            return b_($(u, A2(h_, n << 16, 2)));
        }, E_) : (r = b_(u), F2(function(n, t) {
            return b(t, r);
        })) : A4(B_, t = F3(function(n, r, t) {
            return v_({
                iH: e - 3,
                DX: $(u, A2(h_, n << 16 | r << 8 | t, 0))
            });
        }), E_, E_, E_) : A2(A_, function(n) {
            return v_({
                iH: e - 18,
                DX: $(u, n)
            });
        }, __);
    }, q_ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), F_ = function(n) {
        var r, t, e;
        return r = a$(A2(q_, function(n) {
            for(var r = 0, t = 0; n.length > t; t++){
                var e = n.charCodeAt(t);
                r += 128 > e ? 1 : 2048 > e ? 2 : 55296 > e || e > 56319 ? 3 : (t++, 4);
            }
            return r;
        }(e = n), e)), A2(u$, (t = p$(r), A2(d_, {
            iH: t,
            DX: ""
        }, D_)), r);
    }, P_ = function(n) {
        switch(n.$){
            case 0:
            case 4:
                return Vt(n.a);
            default:
                return Ut;
        }
    }, z_ = function(n) {
        return n.a.i;
    }, j_ = function(n) {
        return n.a.bb;
    }, S_ = Fp(ry("Hint-Version")), L_ = function(n) {
        return n.a.aG;
    }, M_ = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(M_, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), N_ = F2(function(n, r) {
        return A3(M_, ta, r, n);
    }), H_ = F2(function(n, r) {
        return A2(N_, r.hC, function(n) {
            var r;
            return Ul(A2(Tp, iu, x([
                L_(n) ? (r = z_(n), A2(Fp, function(n) {
                    return b("Authorization", n);
                }, function(n) {
                    return A2(Fp, function(n) {
                        return _$(n) ? "Bearer " + n : "Basic " + A2(sc, "", F_(A3(Dy, '"', "", n) + ":"));
                    }, P_(n));
                }(r))) : Ut,
                S_(j_(n)),
                n.$ ? Ut : Vt(b("Hint-Lang", Tb(n.a.hT)))
            ])));
        }(n));
    }), T_ = function(n) {
        return n.a.bA;
    }, I_ = function(n) {
        return n.a + "=" + n.b;
    }, R_ = function(n) {
        return n.b ? "?" + A2(fe, "&", A2(Eu, I_, n)) : "";
    }, Z_ = F3(function(n, r, t) {
        return n + "/" + (A2(fe, "/", r) + R_(t));
    }), V_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), U_ = function(n) {
        return encodeURIComponent(n);
    }, Y_ = F2(function(n, r) {
        return A2(V_, U_(n), U_(r));
    }), Q_ = Y_("_b"), O_ = F2(function(n, r) {
        return $(r.iF, function(n) {
            return x([
                Q_(n.bK)
            ]);
        }(n));
    }), G_ = F2(function(n, r) {
        var t = r.w6;
        if (n.$) return e = n.a, A3(Z_, T_(n), t, A2(O_, e, r));
        var e = n.a;
        return A3(Z_, T_(n), t, A2(O_, e, r));
    }), J_ = F5(function(n, r, t, e, u) {
        var a, i = A2(H_, r, u);
        return o_({
            gN: (a = u, A2(sc, f_, A2(Fp, s_, a.gN))),
            zQ: A3(Uy, i, e, t),
            hC: A2(Eu, function(n) {
                return A2(Qy, n.a, n.b);
            }, Ot(i)),
            Be: n,
            D8: Ut,
            Eh: Ut,
            xs: A2(G_, r, u)
        });
    }), W_ = J_("get"), K_ = function(n) {
        return x([
            "v1",
            "public",
            n
        ]);
    }, X_ = F2(function(n, r) {
        return $(r, n);
    }), nA = F2(function(n, r) {
        return A2(X_, x([
            "appointments",
            r
        ]), K_(n));
    }), rA = function(n) {
        return {
            gN: Ut,
            hC: Ul(x([
                b("Accept", "application/json, text/plain, */*")
            ])),
            iF: h,
            w6: n
        };
    }, tA = F4(function(n, r, t, e) {
        return A4(W_, n, hy, e, rA(A2(nA, r, t)));
    }), eA = Y, uA = function(n) {
        var r = A2(se, ".", n);
        return be(r) > 2 ? rv(r) : Ut;
    }, aA = function(n) {
        var r = A2(Wu, "subdomain", Zp(n));
        return r.$ ? A2(Wu, "practice", Zp(n)) : Vt(r.a);
    }, iA = F3(function(n, r, t) {
        var e, u, a = {
            gH: vc,
            bc: t.Ck.bc,
            kd: r.yY.CP,
            kA: r.kA,
            t6: Ut,
            dB: n,
            xs: t
        }, i = A2(sc, Pp, A2(Fp, function(n) {
            return A4(tA, a.kd, n, a.bc, iu);
        }, A2(N$, A2(eA, ".hint.com", e = (u = t.CS).Ai) ? uA(e) : Ut, aA(u.iF))));
        return b(a, i);
    }), cA = F2(function(n, r) {
        return b(r, Pp);
    }), oA = F2(function(n, r) {
        return r;
    }), fA = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), sA = {
        $: 20
    }, lA = {
        $: 17
    }, dA = {
        $: 16
    }, bA = {
        $: 14
    }, vA = function(n) {
        return n.xp;
    }, mA = vA, pA = function(n) {
        return function() {
            return n;
        };
    }, $A = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hA = function(n) {
        return A2($A, 1, n);
    }, gA = function(n) {
        var r = function() {
            switch(n.$){
                case 7:
                    return A2(sc, mA, A2(Fp, pA, r = n.a));
                case 5:
                    var r = n.b;
                    return 500 > n.a ? pA(r) : mA;
                case 6:
                    return pA(n.a);
                default:
                    return mA;
            }
        }();
        return hA(r);
    }, wA = {
        $: 4
    }, xA = F2(function(n, r) {
        return n ? function(n) {
            if (2 !== n.$) return h;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return x([
                        A3(fA, r.a, r.b, r.c)
                    ]);
                case 9:
                    return x([
                        wA
                    ]);
                default:
                    var t = n.a;
                    return x(4 === t.$ ? [
                        sA,
                        gA(t)
                    ] : [
                        gA(t)
                    ]);
            }
        }(r) : function(n) {
            if (2 !== n.$) return h;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return x([
                        A3(fA, r.a, r.b, r.c),
                        dA
                    ]);
                case 0:
                    return x([
                        bA
                    ]);
                case 8:
                    return x([
                        lA
                    ]);
                case 9:
                    return x([
                        dA
                    ]);
                default:
                    var t = n.a;
                    return x(4 === t.$ ? [
                        sA,
                        gA(t)
                    ] : [
                        gA(t)
                    ]);
            }
        }(r);
    }), kA = Wn("pushUrl", Ax), yA = L, _A = function(n) {
        var r = function() {
            switch(n.$){
                case 0:
                    return h;
                case 1:
                    return x([
                        "enroll-thanks"
                    ]);
                case 2:
                    return x([
                        "not-found"
                    ]);
                case 3:
                    return x([
                        "patient-documents"
                    ]);
                case 4:
                    return x([
                        "thanks"
                    ]);
                case 5:
                    return x([
                        "waitlist"
                    ]);
                case 6:
                    return x([
                        "account"
                    ]);
                case 7:
                    return x([
                        "booking"
                    ]);
                case 8:
                    return x([
                        "checkout"
                    ]);
                case 9:
                    return x([
                        "enroll"
                    ]);
                case 10:
                    return x([
                        "signup"
                    ]);
                case 11:
                    return x([
                        "style-guide"
                    ]);
                case 12:
                    return x([
                        "account",
                        "booking"
                    ]);
                case 13:
                    return x([
                        "account",
                        "cart"
                    ]);
                case 14:
                    return x([
                        "account",
                        "chat"
                    ]);
                case 15:
                    return x([
                        "account",
                        "documents"
                    ]);
                case 16:
                    return x([
                        "account",
                        "explore-services"
                    ]);
                case 17:
                    return x([
                        "account",
                        "forbidden"
                    ]);
                case 18:
                    return x([
                        "account",
                        "health-information"
                    ]);
                case 19:
                    return x([
                        "account",
                        "invoices"
                    ]);
                case 20:
                    return x([
                        "account",
                        "members"
                    ]);
                case 21:
                    return x([
                        "account",
                        "memberships"
                    ]);
                case 22:
                    return x([
                        "account",
                        "messaging"
                    ]);
                case 23:
                    return x([
                        "account",
                        "not-found"
                    ]);
                case 24:
                    return x([
                        "account",
                        "payment-sources"
                    ]);
                case 25:
                    return x([
                        "account",
                        "practitioner-location"
                    ]);
                case 26:
                    return x([
                        "account",
                        "session-expired"
                    ]);
                case 27:
                    return x([
                        "booking",
                        "empty"
                    ]);
                case 28:
                    return x([
                        "login",
                        "request"
                    ]);
                case 29:
                    return x([
                        "login",
                        "select-patient"
                    ]);
                case 30:
                    return x([
                        "login",
                        "verify-code"
                    ]);
                case 31:
                    return x([
                        "style-guide",
                        "activity-indicator"
                    ]);
                case 32:
                    return x([
                        "style-guide",
                        "address-input"
                    ]);
                case 33:
                    return x([
                        "style-guide",
                        "alerts"
                    ]);
                case 34:
                    return x([
                        "style-guide",
                        "api-select"
                    ]);
                case 35:
                    return x([
                        "style-guide",
                        "button"
                    ]);
                case 36:
                    return x([
                        "style-guide",
                        "card-example"
                    ]);
                case 37:
                    return x([
                        "style-guide",
                        "cart-icon"
                    ]);
                case 38:
                    return x([
                        "style-guide",
                        "checkbox"
                    ]);
                case 39:
                    return x([
                        "style-guide",
                        "filter-example"
                    ]);
                case 40:
                    return x([
                        "style-guide",
                        "form-example"
                    ]);
                case 41:
                    return x([
                        "style-guide",
                        "grid"
                    ]);
                case 42:
                    return x([
                        "style-guide",
                        "input"
                    ]);
                case 43:
                    return x([
                        "style-guide",
                        "insurance-info"
                    ]);
                case 44:
                    return x([
                        "style-guide",
                        "modal"
                    ]);
                case 45:
                    return x([
                        "style-guide",
                        "multi-form"
                    ]);
                case 46:
                    return x([
                        "style-guide",
                        "phone-input"
                    ]);
                case 47:
                    return x([
                        "style-guide",
                        "radio"
                    ]);
                case 48:
                    return x([
                        "style-guide",
                        "searchable-select"
                    ]);
                case 49:
                    return x([
                        "style-guide",
                        "select"
                    ]);
                case 50:
                    return x([
                        "style-guide",
                        "table"
                    ]);
                case 51:
                    return x([
                        "style-guide",
                        "tabs"
                    ]);
                case 52:
                    return x([
                        "style-guide",
                        "tag"
                    ]);
                case 53:
                    return x([
                        "style-guide",
                        "toggle"
                    ]);
                case 54:
                    return x([
                        "style-guide",
                        "tooltip"
                    ]);
                case 55:
                    return x([
                        "style-guide",
                        "typography"
                    ]);
                case 56:
                    return x([
                        "account",
                        n.a.xd
                    ]);
                case 57:
                    return x([
                        "bills",
                        n.a.xd
                    ]);
                case 58:
                    return x([
                        "checkout",
                        n.a.wy
                    ]);
                case 59:
                    return x([
                        "signup",
                        n.a.wy
                    ]);
                case 60:
                    return x([
                        "account",
                        "cart",
                        "confirm-pay"
                    ]);
                case 61:
                    return x([
                        "account",
                        "messaging",
                        "chat"
                    ]);
                case 62:
                    return x([
                        "appointments",
                        n.a.bc,
                        "cancellation-policy"
                    ]);
                case 63:
                    return x([
                        "signup",
                        n.a.wy,
                        "additional-details"
                    ]);
                case 64:
                    return x([
                        "signup",
                        n.a.wy,
                        "confirmation"
                    ]);
                case 65:
                    return x([
                        "signup",
                        n.a.wy,
                        "contacts"
                    ]);
                case 66:
                    return x([
                        "signup",
                        n.a.wy,
                        "custom-details"
                    ]);
                case 67:
                    return x([
                        "signup",
                        n.a.wy,
                        "location"
                    ]);
                case 68:
                    return x([
                        "signup",
                        n.a.wy,
                        "members"
                    ]);
                case 69:
                    return x([
                        "signup",
                        n.a.wy,
                        "membership"
                    ]);
                case 70:
                    return x([
                        "signup",
                        n.a.wy,
                        "provider"
                    ]);
                case 71:
                    return x([
                        "signup",
                        n.a.wy,
                        "thanks"
                    ]);
                case 72:
                    return x([
                        "account",
                        "health-information",
                        n.a.rh
                    ]);
                case 73:
                    return x([
                        "account",
                        "invoices",
                        n.a.rh
                    ]);
                case 74:
                    return x([
                        "account",
                        "members",
                        n.a.rh
                    ]);
                case 75:
                    return x([
                        "account",
                        "memberships",
                        n.a.rh
                    ]);
                case 76:
                    return x([
                        "account",
                        "packages",
                        n.a.rh
                    ]);
                case 77:
                    return x([
                        "account",
                        "payment-sources",
                        n.a.rh
                    ]);
                case 78:
                    return x([
                        "account",
                        "appointments",
                        n.a.bc,
                        "cancel"
                    ]);
                case 79:
                    return x([
                        "account",
                        "appointments",
                        n.a.bc,
                        "cancel-appointment"
                    ]);
                case 80:
                    return x([
                        "account",
                        "appointments",
                        n.a.bc,
                        "reschedule"
                    ]);
                case 81:
                    return x([
                        "account",
                        "invoices",
                        n.a.rh,
                        "payment"
                    ]);
                case 82:
                    return x([
                        "account",
                        "members",
                        n.a.rh,
                        "edit"
                    ]);
                case 83:
                    return x([
                        "account",
                        "members",
                        n.a.rh,
                        "emergency-contact"
                    ]);
                case 84:
                    return x([
                        "account",
                        "memberships",
                        n.a.rh,
                        "add-member"
                    ]);
                case 85:
                    return x([
                        "account",
                        "memberships",
                        n.a.rh,
                        "renew"
                    ]);
                case 86:
                    return x([
                        "account",
                        "packages",
                        n.a.rh,
                        "checkout"
                    ]);
                case 87:
                    return x([
                        "account",
                        "payment-sources",
                        n.a.rh,
                        "edit"
                    ]);
                case 88:
                    return x([
                        "account",
                        "plans",
                        n.a.rh,
                        "checkout"
                    ]);
                case 89:
                    return x([
                        "booking",
                        n.a.mH,
                        "location",
                        n.a.nd,
                        "date"
                    ]);
                case 90:
                    return x([
                        "booking",
                        n.a.mH,
                        "location",
                        n.a.nd,
                        "enter-info"
                    ]);
                case 91:
                    return x([
                        "account",
                        "booking",
                        n.a.mH,
                        "location",
                        n.a.nd,
                        "date"
                    ]);
                default:
                    return x([
                        "account",
                        "booking",
                        n.a.mH,
                        "location",
                        n.a.nd,
                        "enter-info"
                    ]);
            }
        }();
        return A2(yA, "/", A2(fe, "/", r));
    }, AA = F2(function(n, r) {
        var t = R_(A2(Eu, function(n) {
            return A2(Y_, n.a, n.b);
        }, Ot(n)));
        return kA($(_A(r), t));
    }), CA = F2(function(n, r) {
        var t = n;
        if (3 === t.$) {
            var e = t.a;
            return v(m(r, {
                gH: t
            }), A2(AA, r.xs.iF, e.rB ? ma({
                bc: r.bc
            }) : Ka({
                bc: r.bc
            })), h);
        }
        return v(m(r, {
            gH: vc
        }), Pp, A2(xA, 0, t));
    }), BA = function(n) {
        return n.N.mV;
    }, EA = function(n) {
        return n.N.N;
    }, DA = function(n) {
        return n.N.ni;
    }, qA = function(n) {
        return n.N.nk;
    }, FA = function(n) {
        return n.N.oi;
    }, PA = function(n) {
        return n.N.re;
    }, zA = function(n) {
        return n.N.ri;
    }, jA = function(n) {
        return n.N.ta;
    }, SA = function(n) {
        return n.N.vS;
    }, LA = function(n) {
        return n.N.w7;
    }, MA = function(n) {
        return n.N.w8;
    }, NA = function(n) {
        return n.N.xV;
    }, HA = F2(function(n) {
        return {
            gN: h,
            w5: n(EA)
        };
    }), TA = Fk({
        Ar: iA,
        AQ: cA,
        Db: oA,
        DZ: function() {
            return zx;
        },
        En: CA,
        Et: HA
    }), IA = function(n) {
        return 1 === n.a.i.$;
    }, RA = function(n) {
        return !n.a.i.$;
    }, ZA = function(n) {
        var r = function(n) {
            var r, t = Ot(A2(sc, da, A2(Fp, Rp, n.CS.iF))), e = (r = n.CS.iF).$ ? n.CS.Cq : n.CS.Cq + "?" + r.a;
            return A2(AA, Ul(A2(Yt, b("redirectTo", e), t)), oi);
        }, t = function(n) {
            return RA(n) && !IA(n);
        }, e = Fk(n);
        return m(e, {
            Ar: F2(function(n, u) {
                var a = b(n.dB, gx(n.gF));
                return 3 !== a.a.$ || a.b || t(n.gF) ? A2(e.Ar, n, u) : v($x(u), r(u), h);
            }),
            AQ: F2(function(n, u) {
                var a = b(n.dB, u);
                if (3 !== a.a.$ || a.b.$) return A2(e.AQ, n, u);
                var i = a.b.a;
                return gx(n.gF) || 2 === n.gF.a.i.$ || t(n.gF) ? A2(e.AQ, n, u) : b($x(i), r(i));
            })
        });
    }, VA = function(n) {
        return {
            $: 0,
            a: n
        };
    }, UA = x([
        "v1",
        "member"
    ]), YA = function(n) {
        return A2(X_, x([
            n
        ]), UA);
    }, QA = F2(function(n, r) {
        return A2(X_, x([
            "appointments",
            r
        ]), YA(n));
    }), OA = F2(function(n, r) {
        return A2(X_, x([
            "cancel"
        ]), A2(QA, n, r));
    }), GA = F5(function(n, r, t, e, u) {
        return {
            mG: t,
            nc: e,
            rh: n,
            u7: u,
            wK: r
        };
    }), JA = F2(function(n, r) {
        return {
            tg: n,
            xw: r
        };
    }), WA = A3(ly, "user_id", C$, A3(ly, "name", C$, uu(JA))), KA = A2(Pk, WA, uu(iu)), XA = A3(ly, "provider", KA, A3(ly, "booking_location", iy(by), A3(ly, "appointment_type", iy(py), A3(ly, "start_display", iy(C$), A3(ly, "id", C$, uu(GA)))))), nC = A2(Pk, XA, uu(iu)), rC = F4(function(n, r, t, e) {
        return A4(W_, n, nC, e, rA(A2(OA, r, t)));
    }), tC = function(n) {
        if (n.$) return Ut;
        var r = n.a;
        return _$(r) ? B$(A2(x$, A2(Tu, "sub", C$), r)) : Ut;
    }, eC = function(n) {
        return tC(z_(n));
    }, uC = function(n) {
        return 3 === n.$ ? Vt(n.a) : Ut;
    }, aC = F3(function(n, r, t) {
        var e, u = {
            gH: vc,
            bc: t.Ck.bc,
            c8: r.yY.yG,
            kA: r.kA,
            t6: uC(r.t6),
            dB: n,
            xs: t
        };
        return b(u, (e = eC(u.c8)).$ ? Pp : A4(rC, u.c8, e.a, u.bc, VA));
    }), iC = F2(function(n, r) {
        return b(r, Pp);
    }), cC = F2(function(n, r) {
        return r;
    }), oC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fC = function(n) {
        return n.my;
    }, sC = function(n) {
        return n.mG;
    }, lC = function(n) {
        return n.nc;
    }, dC = J_("put"), bC = F4(function(n, r, t, e) {
        return A4(dC, n, nC, e, rA(A2(OA, r, t)));
    }), vC = function(n) {
        return n.rh;
    }, mC = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        return v(m(r, {
                            gH: t
                        }), Pp, h);
                    case 2:
                        if (8 === t.a.$) return v(m(r, {
                            gH: vc
                        }), A2(AA, r.xs.iF, Ka({
                            bc: r.bc
                        })), h);
                        break n;
                    default:
                        break n;
                }
                return v(m(r, {
                    gH: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                return v(r, (c = eC(r.c8)).$ ? Pp : A4(bC, r.c8, c.a, r.bc, oC), h);
            default:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        var e = t.a, u = sC(e), a = (i = b(A2(sc, !1, A2(nv, fC, lC(e))), u)).a && !i.b.$ ? Ul(x([
                            b("appointment-type", vC(i.b.a))
                        ])) : da;
                        return v(m(r, {
                            gH: t
                        }), A2(AA, a, pa({
                            bc: r.bc
                        })), h);
                    case 2:
                        if (8 === t.a.$) return v(m(r, {
                            gH: vc
                        }), A2(AA, r.xs.iF, Ka({
                            bc: r.bc
                        })), h);
                        break n;
                    default:
                        break n;
                }
                return v(m(r, {
                    gH: vc
                }), Pp, A2(xA, 0, t));
        }
        var i, c;
    }), pC = {
        $: 1
    }, $C = function(n) {
        return n.mk;
    }, hC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gC = function(n) {
        return hC(n);
    }, wC = function(n) {
        return n.pI;
    }, xC = cr("h1"), kC = sk(4), yC = F2(function(n, r) {
        return A2(xC, _k(A2(Yt, kC, n)), r);
    }), _C = function(n) {
        return n.sr;
    }, AC = function(n) {
        return n.tg;
    }, CC = function(n) {
        return n.tg;
    }, BC = function(n) {
        return n.tg;
    }, EC = function(n) {
        return {
            $: 4,
            a: n
        };
    }, DC = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qC = DC(0), FC = function(n) {
        return n.wK;
    }, PC = cr("button"), zC = F2(function(n, r) {
        return A2(br, function(n) {
            return mr.test(n) ? "data-" + n : n;
        }(n), gr(r));
    }), jC = zC, SC = function(n) {
        return Xx(A2(fe, " ", A2(Eu, Oe, A2(Rc, zc, n))));
    }, LC = wn, MC = F2(function(n, r) {
        return A2(dr, n, LC(r));
    }), NC = MC("disabled"), HC = sr, TC = F2(function(n, r) {
        return A2(HC, n, {
            $: 0,
            a: r
        });
    }), IC = function(n) {
        return A2(TC, "click", uu(n));
    }, RC = A2(Tu, "keyCode", F$), ZC = function(n) {
        return A2(TC, "keydown", A2(tu, n, RC));
    }, VC = function(n) {
        var r;
        return P$(x([
            A2(nu, function(r) {
                return i(r, n) ? uu(!0) : Sk("continue");
            }, A2(Tu, "id", C$)),
            (r = function() {
                return A2(Tu, "parentNode", VC(n));
            }, A2(nu, r, uu(0))),
            uu(!1)
        ]));
    }, UC = F2(function(n, r) {
        return A2(nu, function(r) {
            return r ? Sk("blurred inside") : uu(n);
        }, A2(Tu, "relatedTarget", VC(r)));
    }), YC = F2(function(n, r) {
        return A2(TC, "blur", A2(UC, n, r));
    }), QC = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return x([
                            Xx("button--primary")
                        ]);
                    case 1:
                        return x([
                            Xx("button--secondary")
                        ]);
                    case 2:
                        return x([
                            Xx("button--tonal")
                        ]);
                    case 7:
                        return x([
                            Xx("button--danger--filled")
                        ]);
                    case 8:
                        return x([
                            Xx("button--danger--outline")
                        ]);
                    case 3:
                        return x([
                            Xx("button--profile")
                        ]);
                    case 4:
                        return x([
                            Xx("button--link")
                        ]);
                    case 5:
                        return x([
                            Xx("button--round")
                        ]);
                    default:
                        return x([
                            Xx("button--none")
                        ]);
                }
            case 1:
                return x([
                    NC(n.a)
                ]);
            case 2:
                var r = n.a;
                return A2(Eu, ek(yu), r);
            case 3:
                return x([
                    SC(x([
                        b("button--loading", n.a)
                    ]))
                ]);
            case 4:
                return x([
                    IC(n.a)
                ]);
            case 5:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
            case 6:
                return x([
                    SC(x([
                        b("button--nowrap", n.a)
                    ]))
                ]);
            case 7:
                return x([
                    A2(YC, n.a, n.b)
                ]);
            case 8:
                return x([
                    ZC(n.a)
                ]);
            case 9:
                return x([
                    Xx(bk(n.a) + "hidden")
                ]);
            default:
                var t = A2(fe, " ", A2(Eu, yA(bk(n.a)), x([
                    "pointer-events-none",
                    "pointer-none"
                ])));
                return x([
                    Xx(A2(fe, " ", x([
                        "cursor-auto pointer-events-auto",
                        t
                    ])))
                ]);
        }
    }, OC = F2(function(n, r) {
        return A2(PC, A2(Yt, Xx("button"), function(n) {
            return rc(A2(Eu, QC, n));
        }(n)), $(r, x([
            A2(ak, x([
                Xx("button__spinner")
            ]), h)
        ])));
    }), GC = function(n) {
        return n.nk;
    }, JC = function(n) {
        return n.od;
    }, WC = function(n) {
        return n.rV;
    }, KC = function(n) {
        return n.rW;
    }, XC = function(n) {
        return n.trim();
    }, nB = function(n) {
        return vu(XC(n));
    }, rB = function(n) {
        return {
            $: 7,
            a: n
        };
    }, tB = ld(""), eB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uB = eB(5), aB = Zb("\xa0"), iB = A2(ak, h, x([
        ld(aB)
    ])), cB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, oB = cB(0), fB = cr("a"), sB = F2(function(n, r) {
        var t = b(n, r);
        if (!t.b.b) return "";
        if (!t.a.b) {
            var e = t.b;
            return f = e.b, (u = e.a).$ ? "" : $(Zb(u.a), A2(sB, n, f));
        }
        var u, a = t.a, i = a.a, c = a.b, o = t.b, f = o.b;
        switch((u = o.a).$){
            case 2:
                return A2(sc, "", A2(Fp, function(n) {
                    return $(oe(n), A2(sB, c, f));
                }, pu(Zb(i))));
            case 1:
                return $(Zb(i), A2(sB, c, f));
            default:
                return $(Zb(u.a), A2(sB, n, f));
        }
    }), lB = F2(function(n, r) {
        var t = n;
        return vu(r) ? "" : A2(sB, Lm(r), t);
    }), dB = {
        $: 1
    }, bB = {
        $: 2
    }, vB = F2(function(n, r) {
        var t = n.j5;
        return i(r, n.ko) ? bB : i(r, t) ? dB : {
            $: 0,
            a: r
        };
    }), mB = F2(function(n, r) {
        return A2(Eu, vB(n), Lm(r));
    }), pB = F2(function(n, r) {
        return A2(mB, n, r);
    }), $B = pB({
        j5: "*",
        ko: "#"
    }), hB = "(###) ###-####", gB = $B(hB), wB = function(n) {
        return A2(lB, gB, n);
    }, xB = F2(function(n, r) {
        return n ? r : wB(r);
    }), kB = N, yB = function(n) {
        var r;
        return A2(Kx, "href", pr.test(r = n) ? "" : r);
    }, _B = function(n) {
        var r = A2(kB, ye, n);
        return A2(fB, x([
            yB("tel:" + r)
        ]), x([
            A2(ak, x([
                Xx("hover:underline cursor-pointer text-info-300")
            ]), x([
                ld(A2(xB, 0, r))
            ]))
        ]));
    }, AB = F2(function(n, r) {
        if (r.$) return tB;
        var t = r.a;
        return A2(nk, h, x([
            A2(Ek, x([
                uB,
                rB(oB)
            ]), x([
                ld(n(DA))
            ])),
            A2(Ek, x([
                rB(oB)
            ]), x([
                ld(n(MA)),
                iB,
                _B(t)
            ]))
        ]));
    }), CB = F2(function(n) {
        return n(PA);
    }), BB = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return tB;
        var u = e.a.a, a = e.b.a;
        return A2(nk, h, x([
            A2(Ek, x([
                uB,
                rB(oB)
            ]), x([
                ld(n(jA))
            ])),
            A2(Ek, x([
                rB(oB)
            ]), x([
                ld(oe(u)),
                iB,
                ld(A2(CB, n, a)),
                iB,
                ld(n(BA))
            ]))
        ]));
    }), EB = F2(function(n, r) {
        return A2(nk, h, x([
            A2(Ek, x([
                uB,
                rB(oB)
            ]), x([
                ld(n(qA))
            ])),
            A2(Ek, x([
                rB(oB)
            ]), x([
                ld(r)
            ]))
        ]));
    }), DB = cB(1), qB = function(n) {
        return n.b.uw;
    }, FB = function(n) {
        var r = qB(n);
        return r.$ ? tB : _B(r.a);
    }, PB = F2(function(n, r) {
        return A2(nk, h, x([
            A2(Ek, x([
                rB(DB)
            ]), x([
                ld(n(FA)),
                iB,
                FB(r),
                iB,
                ld(n(LA))
            ]))
        ]));
    }), zB = F6(function(n, r, t, e, u, a) {
        if (r.$) return A2(PB, n, a);
        var i = r.a;
        return nB(i) ? A2(PB, n, a) : A2(nk, x([
            Xx("flex flex-col gap-4")
        ]), x([
            A2(EB, n, i),
            A3(BB, n, t, e),
            A2(AB, n, u)
        ]));
    }), jB = F3(function(n, r, t) {
        return A6(zB, n, GC(r), WC(r), KC(r), JC(r), t);
    }), SB = F2(function(n, r) {
        if (r.$) return Ut;
        var t = r.a;
        return Vt(A2(nk, x([
            Xx("font-extrabold")
        ]), x([
            ld(t)
        ])));
    }), LB = F2(function(n, r) {
        return A2(nk, _k(n), r);
    }), MB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, NB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HB = NB(1), TB = br("class"), IB = F2(function(n, r) {
        return A2(ir, n, hr(r));
    }), RB = IB("http://www.w3.org/2000/svg"), ZB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 17 16"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M11.8333 14.6673V12.6673H9.83333V11.334H11.8333V9.33398H13.1667V11.334H15.1667V12.6673H13.1667V14.6673H11.8333ZM3.83333 13.334C3.46667 13.334 3.15278 13.2034 2.89167 12.9423C2.63056 12.6812 2.5 12.3673 2.5 12.0007V4.00065C2.5 3.63398 2.63056 3.3201 2.89167 3.05898C3.15278 2.79787 3.46667 2.66732 3.83333 2.66732H4.5V1.33398H5.83333V2.66732H9.83333V1.33398H11.1667V2.66732H11.8333C12.2 2.66732 12.5139 2.79787 12.775 3.05898C13.0361 3.3201 13.1667 3.63398 13.1667 4.00065V8.06732C12.9444 8.03398 12.7222 8.01732 12.5 8.01732C12.2778 8.01732 12.0556 8.03398 11.8333 8.06732V6.66732H3.83333V12.0007H8.5C8.5 12.2229 8.51667 12.4451 8.55 12.6673C8.58333 12.8895 8.64444 13.1118 8.73333 13.334H3.83333ZM3.83333 5.33398H11.8333V4.00065H3.83333V5.33398Z")
            ]), h)
        ]));
    }, VB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "24"),
            A2(zC, "height", "24"),
            A2(zC, "viewBox", "0 0 24 24"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "g", x([
                A2(zC, "id", "icon/navigation/cancel_24px")
            ]), x([
                A3(RB, "path", x([
                    A2(zC, "id", "icon/navigation/cancel_24px_2"),
                    A2(zC, "fill-rule", "evenodd"),
                    A2(zC, "clip-rule", "evenodd"),
                    A2(zC, "d", "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z")
                ]), h)
            ]))
        ]));
    }, UB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "16"),
            A2(zC, "height", "16"),
            A2(zC, "viewBox", "0 0 16 16"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M14.7597 2.67373C14.4519 2.39656 13.9777 2.42142 13.7005 2.72924L5.29636 12.063L2.31029 8.74663C2.03313 8.43881 1.55891 8.41395 1.25109 8.69112C0.943267 8.96828 0.918414 9.4425 1.19558 9.75032L4.72872 13.6743C4.92781 13.8954 5.22858 13.9705 5.49632 13.8925C5.63593 13.8575 5.76699 13.782 5.87054 13.667L14.8152 3.73293C15.0924 3.42511 15.0675 2.95089 14.7597 2.67373Z")
            ]), h)
        ]));
    }, YB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 64 64")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M27.5663 46.5663L49.8913 24.2413L45.458 19.808L27.5663 37.6997L18.5413 28.6747L14.108 33.108L27.5663 46.5663ZM31.9997 63.6663C27.6191 63.6663 23.5025 62.8351 19.6497 61.1726C15.7969 59.5101 12.4455 57.2538 9.59551 54.4038C6.74551 51.5538 4.48926 48.2025 2.82676 44.3497C1.16426 40.4969 0.333008 36.3802 0.333008 31.9997C0.333008 27.6191 1.16426 23.5025 2.82676 19.6497C4.48926 15.7969 6.74551 12.4455 9.59551 9.59551C12.4455 6.74551 15.7969 4.48926 19.6497 2.82676C23.5025 1.16426 27.6191 0.333008 31.9997 0.333008C36.3802 0.333008 40.4969 1.16426 44.3497 2.82676C48.2025 4.48926 51.5538 6.74551 54.4038 9.59551C57.2538 12.4455 59.5101 15.7969 61.1726 19.6497C62.8351 23.5025 63.6663 27.6191 63.6663 31.9997C63.6663 36.3802 62.8351 40.4969 61.1726 44.3497C59.5101 48.2025 57.2538 51.5538 54.4038 54.4038C51.5538 57.2538 48.2025 59.5101 44.3497 61.1726C40.4969 62.8351 36.3802 63.6663 31.9997 63.6663ZM31.9997 57.333C39.0719 57.333 45.0622 54.8788 49.9705 49.9705C54.8788 45.0622 57.333 39.0719 57.333 31.9997C57.333 24.9275 54.8788 18.9372 49.9705 14.0288C45.0622 9.12051 39.0719 6.66634 31.9997 6.66634C24.9275 6.66634 18.9372 9.12051 14.0288 14.0288C9.12051 18.9372 6.66634 24.9275 6.66634 31.9997C6.66634 39.0719 9.12051 45.0622 14.0288 49.9705C18.9372 54.8788 24.9275 57.333 31.9997 57.333Z")
            ]), h)
        ]));
    }, QB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 21 18"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H10V14H2V4L10 9L18 4V9H20V2C20 0.9 19.1 0 18 0ZM10 7L2 2H18L10 7ZM15.34 18L11.8 14.46L13.21 13.05L15.33 15.17L19.57 10.93L21 12.34L15.34 18Z"),
                A2(zC, "fill", "#43749F")
            ]), h)
        ]));
    }, OB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0h24v24H0V0z"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z")
            ]), h)
        ]));
    }, GB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 13 16"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M1.21875 16C0.89375 16 0.609375 15.88 0.365625 15.64C0.121875 15.4 0 15.12 0 14.8V1.2C0 0.88 0.121875 0.6 0.365625 0.36C0.609375 0.12 0.89375 0 1.21875 0H8.55156L13 4.38V14.8C13 15.12 12.8781 15.4 12.6344 15.64C12.3906 15.88 12.1062 16 11.7812 16H1.21875ZM7.94219 4.92V1.2H1.21875V14.8H11.7812V4.92H7.94219Z")
            ]), h)
        ]));
    }, JB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "g", h, x([
                A3(RB, "path", x([
                    A2(zC, "d", "M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z")
                ]), h)
            ]))
        ]));
    }, WB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0h24v24H0z"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z")
            ]), h)
        ]));
    }, KB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "29"),
            A2(zC, "height", "16"),
            A2(zC, "viewBox", "0 0 29 16"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M21.0955 2.68835C21.5944 2.21659 21.5944 1.42258 21.0955 0.950811C20.6345 0.514858 19.9133 0.514858 19.4523 0.950811L13.3676 6.70512C12.8687 7.17688 12.8687 7.97089 13.3676 8.44266C13.8286 8.87861 14.5498 8.87861 15.0108 8.44266L21.0955 2.68835ZM28.0716 0.947913C27.6086 0.513167 26.8871 0.51444 26.4257 0.950816L14.6514 12.0857C14.392 12.3311 13.9862 12.3313 13.7265 12.0863L9.85215 8.4311C9.39079 7.99583 8.66991 7.99626 8.20907 8.43208C7.70993 8.90411 7.70993 9.69858 8.20907 10.1706L13.6305 15.2977C13.944 15.5941 14.4344 15.5941 14.7479 15.2977L28.0747 2.69452C28.5765 2.21993 28.5751 1.42073 28.0716 0.947913ZM1.23207 8.43004C0.728769 8.90266 0.72736 9.70153 1.22899 10.1759L6.38152 15.0487C6.84272 15.4848 7.56428 15.4848 8.02548 15.0487C8.52426 14.577 8.52462 13.7832 8.02626 13.311L2.87809 8.43368C2.41694 7.99679 1.69514 7.9952 1.23207 8.43004Z"),
                A2(zC, "fill", "#2F88E7")
            ]), h)
        ]));
    }, XB = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 16 17"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M8 12.675L3.175 7.85L4.25 6.775L7.25 9.775V0.5H8.75V9.775L11.75 6.775L12.825 7.85L8 12.675ZM1.5 16.5C1.1 16.5 0.75 16.35 0.45 16.05C0.15 15.75 0 15.4 0 15V11.425H1.5V15H14.5V11.425H16V15C16 15.4 15.85 15.75 15.55 16.05C15.25 16.35 14.9 16.5 14.5 16.5H1.5Z")
            ]), h)
        ]));
    }, nE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "mask", x([
                A2(zC, "id", "mask0_641_312"),
                A2(zC, "style", "mask-type:alpha"),
                A2(zC, "maskUnits", "userSpaceOnUse"),
                A2(zC, "x", "0"),
                A2(zC, "y", "0"),
                A2(zC, "width", "48"),
                A2(zC, "height", "48")
            ]), x([
                A3(RB, "rect", x([
                    A2(zC, "width", "48"),
                    A2(zC, "height", "48"),
                    A2(zC, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(RB, "g", x([
                A2(zC, "mask", "url(#mask0_641_312)")
            ]), x([
                A3(RB, "path", x([
                    A2(zC, "d", "M26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5Z"),
                    A2(zC, "fill", "white")
                ]), h),
                A3(RB, "path", x([
                    A2(zC, "d", "M24 42C23.4 42 22.825 41.8917 22.275 41.675C21.725 41.4583 21.2333 41.1333 20.8 40.7L7.4 27.25C6.23333 26.0833 5.375 24.75 4.825 23.25C4.275 21.75 4 20.1833 4 18.55C4 15.1167 5.11667 12.1667 7.35 9.7C9.58333 7.23333 12.3667 6 15.7 6C17.3 6 18.8083 6.31667 20.225 6.95C21.6417 7.58333 22.9 8.46667 24 9.6C25.0667 8.46667 26.3083 7.58333 27.725 6.95C29.1417 6.31667 30.65 6 32.25 6C35.5833 6 38.375 7.23333 40.625 9.7C42.875 12.1667 44 15.1 44 18.5C44 20.1333 43.7167 21.7 43.15 23.2C42.5833 24.7 41.7333 26.0333 40.6 27.2L27.15 40.7C26.7167 41.1333 26.2333 41.4583 25.7 41.675C25.1667 41.8917 24.6 42 24 42ZM26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5ZM26.45 21.35L23.4 30.45C23.301 30.75 23.1152 31 22.8425 31.2C22.5698 31.4 22.2723 31.5 21.95 31.5C21.6833 31.5 21.45 31.4333 21.25 31.3C21.05 31.1667 20.8833 31 20.75 30.8L17.2 25.5H9.9L22.95 38.55C23.1167 38.7167 23.28 38.8333 23.44 38.9C23.6 38.9667 23.7867 39 24 39C24.2133 39 24.4 38.9667 24.56 38.9C24.72 38.8333 24.8833 38.7167 25.05 38.55L38.05 25.5H30C29.7333 25.5 29.5 25.4333 29.3 25.3C29.1 25.1667 28.9167 25 28.75 24.8L26.45 21.35Z"),
                    A2(zC, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, rE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "height", "24px"),
            A2(zC, "viewBox", "0 -960 960 960"),
            A2(zC, "width", "24px"),
            A2(zC, "fill", "#1f1f1f")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z")
            ]), h)
        ]));
    }, tE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "mask", x([
                A2(zC, "id", "mask0_641_316"),
                A2(zC, "style", "mask-type:alpha"),
                A2(zC, "maskUnits", "userSpaceOnUse"),
                A2(zC, "x", "0"),
                A2(zC, "y", "0"),
                A2(zC, "width", "48"),
                A2(zC, "height", "48")
            ]), x([
                A3(RB, "rect", x([
                    A2(zC, "width", "48"),
                    A2(zC, "height", "48"),
                    A2(zC, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(RB, "g", x([
                A2(zC, "mask", "url(#mask0_641_316)")
            ]), x([
                A3(RB, "rect", x([
                    A2(zC, "x", "8"),
                    A2(zC, "y", "17"),
                    A2(zC, "width", "32"),
                    A2(zC, "height", "25"),
                    A2(zC, "fill", "white")
                ]), h),
                A3(RB, "path", x([
                    A2(zC, "d", "M29.841 37C28.4803 37 27.3333 36.5303 26.4 35.591C25.4667 34.6513 25 33.5013 25 32.141C25 30.7803 25.4697 29.6333 26.409 28.7C27.3487 27.7667 28.4987 27.3 29.859 27.3C31.2197 27.3 32.3667 27.7697 33.3 28.709C34.2333 29.6487 34.7 30.7987 34.7 32.159C34.7 33.5197 34.2303 34.6667 33.291 35.6C32.3513 36.5333 31.2013 37 29.841 37ZM9 44C8.2 44 7.5 43.7 6.9 43.1C6.3 42.5 6 41.8 6 41V10C6 9.2 6.3 8.5 6.9 7.9C7.5 7.3 8.2 7 9 7H12.25V4H15.5V7H32.5V4H35.75V7H39C39.8 7 40.5 7.3 41.1 7.9C41.7 8.5 42 9.2 42 10V41C42 41.8 41.7 42.5 41.1 43.1C40.5 43.7 39.8 44 39 44H9ZM9 41H39V19.5H9V41ZM9 16.5H39V10H9V16.5Z"),
                    A2(zC, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, eE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "24"),
            A2(zC, "height", "24"),
            A2(zC, "viewBox", "0 0 24 24"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3422 19.2938 19.2914C18.3469 20.2383 17.243 20.9836 16.0148 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875ZM12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 15C11.482 15 11.0625 14.5805 11.0625 14.0625V5.41406C11.0625 4.89609 11.482 4.47656 12 4.47656C12.518 4.47656 12.9375 4.89609 12.9375 5.41406V14.0625C12.9375 14.5805 12.518 15 12 15ZM10.9453 17.5547C10.9453 16.9722 11.4175 16.5 12 16.5C12.5825 16.5 13.0547 16.9722 13.0547 17.5547C13.0547 18.1372 12.5825 18.6094 12 18.6094C11.4175 18.6094 10.9453 18.1372 10.9453 17.5547Z"),
                A2(zC, "fill", "#FAAD14")
            ]), h)
        ]));
    }, uE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "15"),
            A2(zC, "height", "17"),
            A2(zC, "viewBox", "0 0 15 17"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M9.4 2L9.16 0.8C9.07 0.34 8.66 0 8.18 0H1C0.45 0 0 0.45 0 1V16C0 16.55 0.45 17 1 17C1.55 17 2 16.55 2 16V10H7.6L7.84 11.2C7.93 11.67 8.34 12 8.82 12H14C14.55 12 15 11.55 15 11V3C15 2.45 14.55 2 14 2H9.4Z"),
                A2(zC, "fill", "black")
            ]), h)
        ]));
    }, aE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 14 14"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M13.7031 4.42188L13 5.125L10.875 3L11.5938 2.29688C11.7812 2.09896 12.013 2 12.2891 2C12.5651 2 12.8021 2.09896 13 2.29688L13.7031 3C13.901 3.19792 14 3.4349 14 3.71094C14 3.98698 13.901 4.22396 13.7031 4.42188ZM10.2656 3.60938L12.3906 5.73438L7.96875 10.1562L7.07812 11H5V8.92188L5.84375 8.03125L10.2656 3.60938ZM10.9688 5.73438L10.2656 5.03125L6.01562 9.26562L6.73438 9.98438L10.9688 5.73438ZM3 9H4V8H3V9ZM3 7H6V6H3V7ZM7 4H3V5H7V4ZM3 11H4V10H3V11ZM11 13H1V1H8V4L10.5 1.5L9 0H1C0.71875 0 0.481771 0.0963545 0.289062 0.289062C0.0963542 0.481771 0 0.71875 0 1V13C0 13.2812 0.0963542 13.5182 0.289062 13.7109C0.481771 13.9036 0.71875 14 1 14H11C11.2812 14 11.5182 13.9036 11.7109 13.7109C11.9036 13.5182 12 13.2812 12 13V7.53125L11 8.53125V13Z")
            ]), h)
        ]));
    }, iE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "mask", x([
                A2(zC, "id", "mask0_641_308"),
                A2(zC, "style", "mask-type:alpha"),
                A2(zC, "maskUnits", "userSpaceOnUse"),
                A2(zC, "x", "0"),
                A2(zC, "y", "0"),
                A2(zC, "width", "48"),
                A2(zC, "height", "48")
            ]), x([
                A3(RB, "rect", x([
                    A2(zC, "width", "48"),
                    A2(zC, "height", "48"),
                    A2(zC, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(RB, "g", x([
                A2(zC, "mask", "url(#mask0_641_308)")
            ]), x([
                A3(RB, "path", x([
                    A2(zC, "d", "M6 6H32V24H11L6 29V6Z"),
                    A2(zC, "fill", "white")
                ]), h),
                A3(RB, "path", x([
                    A2(zC, "d", "M44 43.95L36.05 36H15C14.175 36 13.4688 35.7062 12.8815 35.1185C12.2938 34.5312 12 33.825 12 33V29H34C34.825 29 35.5313 28.7062 36.119 28.1185C36.7063 27.5312 37 26.825 37 26V12H41C41.825 12 42.5313 12.2937 43.119 12.881C43.7063 13.4687 44 14.175 44 15V43.95ZM7 26.75L10.75 23H31V7H7V26.75ZM4 34V7C4 6.175 4.29383 5.46867 4.8815 4.881C5.46883 4.29367 6.175 4 7 4H31C31.825 4 32.5313 4.29367 33.119 4.881C33.7063 5.46867 34 6.175 34 7V23C34 23.825 33.7063 24.5312 33.119 25.1185C32.5313 25.7062 31.825 26 31 26H12L4 34Z"),
                    A2(zC, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, cE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "height", "24px"),
            A2(zC, "viewBox", "0 -960 960 960"),
            A2(zC, "width", "24px"),
            A2(zC, "fill", "#1f1f1f")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z")
            ]), h)
        ]));
    }, oE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0h24v24H0z"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z")
            ]), h)
        ]));
    }, fE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 16 16"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M3.16942 16C2.5668 16 2.05458 15.7851 1.63275 15.3553C1.21092 14.9254 1 14.4035 1 13.7895V11.1579H3.62397V1C3.62397 0.447715 4.07168 0 4.62397 0H15C15.5523 0 16 0.447715 16 1V13.7895C16 14.4035 15.7891 14.9254 15.3673 15.3553C14.9454 15.7851 14.4332 16 13.8306 16H3.16942ZM13.8306 14.7368C14.1061 14.7368 14.3299 14.6491 14.5021 14.4737C14.6742 14.2982 14.7603 14.0702 14.7603 13.7895V1.26316H4.86364V11.1579H12.9008V13.7895C12.9008 14.0702 12.9869 14.2982 13.1591 14.4737C13.3313 14.6491 13.5551 14.7368 13.8306 14.7368ZM5.95868 4.58947V3.32632H10.9174V4.58947H5.95868ZM5.95868 7.41053V6.14737H10.9174V7.41053H5.95868ZM12.8388 4.58947C12.6736 4.58947 12.5289 4.52632 12.405 4.4C12.281 4.27368 12.219 4.12632 12.219 3.9579C12.219 3.78947 12.281 3.64211 12.405 3.51579C12.5289 3.38947 12.6736 3.32632 12.8388 3.32632C13.0041 3.32632 13.1488 3.38947 13.2727 3.51579C13.3967 3.64211 13.4587 3.78947 13.4587 3.9579C13.4587 4.12632 13.3967 4.27368 13.2727 4.4C13.1488 4.52632 13.0041 4.58947 12.8388 4.58947ZM12.8388 7.30526C12.6736 7.30526 12.5289 7.24211 12.405 7.11579C12.281 6.98947 12.219 6.8421 12.219 6.67368C12.219 6.50526 12.281 6.3579 12.405 6.23158C12.5289 6.10526 12.6736 6.04211 12.8388 6.04211C13.0041 6.04211 13.1488 6.10526 13.2727 6.23158C13.3967 6.3579 13.4587 6.50526 13.4587 6.67368C13.4587 6.8421 13.3967 6.98947 13.2727 7.11579C13.1488 7.24211 13.0041 7.30526 12.8388 7.30526ZM3.14876 14.7368H11.6612V12.4211H2.23967V13.7895C2.23967 14.0702 2.32679 14.2982 2.50103 14.4737C2.67528 14.6491 2.89118 14.7368 3.14876 14.7368Z")
            ]), h)
        ]));
    }, sE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 16 16"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M0.142327 15.1333C0.393436 15.7111 0.816832 16 1.41251 16H14.5875C15.1832 16 15.6066 15.7111 15.8577 15.1333C16.1088 14.5556 16.0276 14.0296 15.6141 13.5556L10.3099 7.33333V1.33333H11.4221C11.6039 1.33333 11.7563 1.27037 11.8792 1.14444C12.0022 1.01852 12.0637 0.860555 12.0637 0.670555C12.0637 0.48057 12.0022 0.321311 11.8792 0.192778C11.7563 0.064259 11.6039 0 11.4221 0H4.57793C4.39613 0 4.24374 0.062963 4.12076 0.188889C3.99778 0.314815 3.93629 0.472778 3.93629 0.662778C3.93629 0.852763 3.99778 1.01202 4.12076 1.14056C4.24374 1.26907 4.39613 1.33333 4.57793 1.33333H5.6901V7.33333L0.385893 13.5556C-0.0276069 14.0296 -0.108796 14.5556 0.142327 15.1333ZM4.55571 10.6667H11.4443L9.02662 7.82222V1.33333H6.97338V7.82222L4.55571 10.6667Z")
            ]), h)
        ]));
    }, lE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 24 24"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z")
            ]), h)
        ]));
    }, dE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0h24v24H0z"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z")
            ]), h)
        ]));
    }, bE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "version", "1.1"),
            A2(zC, "id", "Layer_1"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "x", "0px"),
            A2(zC, "y", "0px"),
            A2(zC, "viewBox", "0 -15 512 540"),
            A2(zC, "style", "enable-background:new 0 -15 512 540;"),
            A2(zC, "xml:space", "preserve")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M87.084,192c-0.456-5.272-0.688-10.6-0.688-16C86.404,78.8,162.34,0,256.004,0s169.6,78.8,169.6,176\r\n\tc0,5.392-0.232,10.728-0.688,16h0.688c0,96.184-169.6,320-169.6,320s-169.6-223.288-169.6-320H87.084z M256.004,224\r\n\tc36.392,1.024,66.744-27.608,67.84-64c-1.096-36.392-31.448-65.024-67.84-64c-36.392-1.024-66.744,27.608-67.84,64\r\n\tC189.26,196.392,219.612,225.024,256.004,224z")
            ]), h)
        ]));
    }, vE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M24 16c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 4c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 12c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"),
                A2(zC, "fill", "currentColor")
            ]), h)
        ]));
    }, mE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 13 16"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M11.9167 1.06667H8.37891C8.18707 0.744444 7.92752 0.486111 7.60026 0.291666C7.273 0.0972214 6.90625 0 6.5 0C6.09375 0 5.727 0.0972214 5.39974 0.291666C5.07248 0.486111 4.81293 0.744444 4.62109 1.06667H1.08333C0.778646 1.06667 0.521918 1.16944 0.313151 1.375C0.104384 1.58055 0 1.83333 0 2.13333V14.9333C0 15.2333 0.104384 15.4861 0.313151 15.6917C0.521918 15.8972 0.778646 16 1.08333 16H11.9167C12.2214 16 12.4781 15.8972 12.6868 15.6917C12.8956 15.4861 13 15.2333 13 14.9333V2.13333C13 1.83333 12.8956 1.58055 12.6868 1.375C12.4781 1.16944 12.2214 1.06667 11.9167 1.06667ZM6.5 1.06667C6.80469 1.06667 7.06141 1.16944 7.27018 1.375C7.47895 1.58055 7.58333 1.83333 7.58333 2.13333H5.41667C5.41667 1.83333 5.52105 1.58055 5.72982 1.375C5.93858 1.16944 6.19531 1.06667 6.5 1.06667ZM11.9167 14.9333H1.08333V2.13333H3.25V4.26667H9.75V2.13333H11.9167V14.9333ZM10.8333 7.46667H2.16667V6.4H10.8333V7.46667ZM10.8333 9.6H2.16667V8.53333H10.8333V9.6ZM10.8333 11.7333H2.16667V10.6667H10.8333V11.7333ZM10.8333 13.8667H2.16667V12.8H10.8333V13.8667Z")
            ]), h)
        ]));
    }, pE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 10 18"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M10 13.095C10 14.4625 9.51136 15.6218 8.53409 16.5731C7.55682 17.5244 6.37879 18 5 18C3.62121 18 2.44318 17.5312 1.46591 16.5938C0.488636 15.6562 0 14.505 0 13.14L0 3.465C0 2.51212 0.34503 1.6964 1.03509 1.01783C1.72517 0.339277 2.55471 0 3.52373 0C4.49276 0 5.32197 0.339277 6.01136 1.01783C6.70076 1.6964 7.04545 2.51212 7.04545 3.465L7.04545 12.3525C7.04545 12.9258 6.84742 13.4104 6.45134 13.8062C6.05527 14.2021 5.57042 14.4 4.9968 14.4C4.42317 14.4 3.93939 14.1937 3.54545 13.7812C3.15152 13.3687 2.95455 12.8775 2.95455 12.3075L2.95455 3.465H3.86364L3.86364 12.33C3.86364 12.645 3.97216 12.9187 4.18921 13.1512C4.40624 13.3837 4.67517 13.5 4.99602 13.5C5.31686 13.5 5.58712 13.3875 5.80682 13.1625C6.02652 12.9375 6.13636 12.6675 6.13636 12.3525L6.13636 3.465C6.13636 2.7468 5.88417 2.13975 5.3798 1.64385C4.87543 1.14795 4.25801 0.9 3.52752 0.9C2.79705 0.9 2.17803 1.14795 1.67045 1.64385C1.16288 2.13975 0.909091 2.7468 0.909091 3.465L0.909091 13.185C0.909091 14.28 1.30966 15.2062 2.1108 15.9637C2.91193 16.7212 3.875 17.1 5 17.1C6.13636 17.1 7.10227 16.7137 7.89773 15.9412C8.69318 15.1687 9.09091 14.2275 9.09091 13.1175L9.09091 3.465H10L10 13.095Z")
            ]), h)
        ]));
    }, $E = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 16 16")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M6 0H0V16H6V0ZM16 0H10V16H16V0Z")
            ]), h)
        ]));
    }, hE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M24 23.95C21.65 23.95 19.6375 23.1125 17.9625 21.4375C16.2875 19.7625 15.45 17.75 15.45 15.4C15.45 13.05 16.2875 11.0375 17.9625 9.3625C19.6375 7.6875 21.65 6.85 24 6.85C26.35 6.85 28.3625 7.6875 30.0375 9.3625C31.7125 11.0375 32.55 13.05 32.55 15.4C32.55 17.75 31.7125 19.7625 30.0375 21.4375C28.3625 23.1125 26.35 23.95 24 23.95ZM7 41.15V35.95C7 34.6833 7.32083 33.5708 7.9625 32.6125C8.60417 31.6542 9.45 30.9333 10.5 30.45C12.8333 29.4167 15.1083 28.6417 17.325 28.125C19.5417 27.6083 21.7667 27.35 24 27.35C26.2333 27.35 28.4542 27.6125 30.6625 28.1375C32.8708 28.6625 35.1417 29.4333 37.475 30.45C38.5583 30.9333 39.4167 31.6542 40.05 32.6125C40.6833 33.5708 41 34.6833 41 35.95V41.15H7ZM10 38.15H38V35.95C38 35.4167 37.8458 34.9 37.5375 34.4C37.2292 33.9 36.8333 33.5333 36.35 33.3C34.1833 32.3 32.0833 31.5708 30.05 31.1125C28.0167 30.6542 26.0167 30.4 24 30.35C21.9833 30.3 19.9833 30.55 18 31.1125C16.0167 31.675 13.9167 32.4 11.7 33.3C11.2167 33.5333 10.8125 33.9 10.4875 34.4C10.1625 34.9 10 35.4167 10 35.95V38.15ZM24 20.95C25.5333 20.95 26.8333 20.4167 27.9 19.35C28.9667 18.2833 29.5 16.9833 29.5 15.45C29.5 13.9167 28.9667 12.6125 27.9 11.5375C26.8333 10.4625 25.5333 9.925 24 9.925C22.4667 9.925 21.1625 10.4625 20.0875 11.5375C19.0125 12.6125 18.475 13.9167 18.475 15.45C18.475 16.9833 19.0125 18.2833 20.0875 19.35C21.1625 20.4167 22.4667 20.95 24 20.95Z"),
                A2(zC, "fill", "currentColor")
            ]), h)
        ]));
    }, gE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 14 16")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0L14 8L0 16V0Z")
            ]), h)
        ]));
    }, wE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 16 13"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M11.424 8.39394V6.77273C11.424 6.69192 11.3973 6.62626 11.344 6.57576C11.2907 6.52525 11.2213 6.5 11.136 6.5H9.136V4.60606C9.136 4.52525 9.10933 4.4596 9.056 4.40909C9.00267 4.35859 8.93867 4.33333 8.864 4.33333H7.136C7.06133 4.33333 6.99733 4.35859 6.944 4.40909C6.89067 4.4596 6.864 4.52525 6.864 4.60606V6.5H4.864C4.77867 6.5 4.70933 6.52525 4.656 6.57576C4.60267 6.62626 4.576 6.69192 4.576 6.77273V8.39394C4.576 8.47475 4.60267 8.5404 4.656 8.59091C4.70933 8.64141 4.77867 8.66667 4.864 8.66667H6.864V10.5606C6.864 10.6414 6.89067 10.7071 6.944 10.7576C6.99733 10.8081 7.06133 10.8333 7.136 10.8333H8.864C8.93867 10.8333 9.00267 10.8081 9.056 10.7576C9.10933 10.7071 9.136 10.6414 9.136 10.5606V8.66667H11.136C11.2213 8.66667 11.2907 8.64141 11.344 8.59091C11.3973 8.5404 11.424 8.47475 11.424 8.39394ZM5.712 2.16667H10.288V1.09091H5.712V2.16667ZM2.288 2.16667V13H2C1.456 13 0.986667 12.8131 0.592 12.4394C0.197333 12.0657 0 11.6212 0 11.1061V4.06061C0 3.54545 0.197333 3.10101 0.592 2.72727C0.986667 2.35353 1.456 2.16667 2 2.16667H2.288ZM12.864 2.16667V13H3.136V2.16667H4.576V0.818181C4.576 0.59596 4.656 0.40404 4.816 0.242424C4.976 0.0808077 5.17867 0 5.424 0H10.576C10.8107 0 11.0133 0.0808077 11.184 0.242424C11.3547 0.40404 11.4347 0.59596 11.424 0.818181V2.16667H12.864ZM16 4.06061V11.1061C16 11.6212 15.8027 12.0657 15.408 12.4394C15.0133 12.8131 14.544 13 14 13H13.712V2.16667H14C14.544 2.16667 15.0133 2.35353 15.408 2.72727C15.8027 3.10101 16 3.54545 16 4.06061Z")
            ]), h)
        ]));
    }, xE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 0 24 24")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 0h24v24H0V0z"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "circle", x([
                A2(zC, "cx", "12"),
                A2(zC, "cy", "19"),
                A2(zC, "r", "2")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M10 3h4v12h-4z")
            ]), h)
        ]));
    }, kE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 24 24"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "circle", x([
                A2(zC, "cx", "12"),
                A2(zC, "cy", "12"),
                A2(zC, "r", "9"),
                A2(zC, "stroke", "currentColor"),
                A2(zC, "stroke-width", "2"),
                A2(zC, "fill", "none")
            ]), h),
            A3(RB, "circle", x([
                A2(zC, "cx", "12"),
                A2(zC, "cy", "12"),
                A2(zC, "r", "5")
            ]), h)
        ]));
    }, yE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 48 48"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "mask", x([
                A2(zC, "id", "mask0_641_320"),
                A2(zC, "style", "mask-type:alpha"),
                A2(zC, "maskUnits", "userSpaceOnUse"),
                A2(zC, "x", "0"),
                A2(zC, "y", "0"),
                A2(zC, "width", "48"),
                A2(zC, "height", "48")
            ]), x([
                A3(RB, "rect", x([
                    A2(zC, "width", "48"),
                    A2(zC, "height", "48"),
                    A2(zC, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(RB, "g", x([
                A2(zC, "mask", "url(#mask0_641_320)")
            ]), x([
                A3(RB, "path", x([
                    A2(zC, "d", "M36.9265 41.334C37.6001 41.334 38.1475 41.1235 38.5685 40.7025C38.9895 40.2815 39.2 39.7342 39.2 39.0605V9H15V32.7453H34.653V39.0605C34.653 39.7342 34.8635 40.2815 35.2846 40.7025C35.7056 41.1235 36.2529 41.334 36.9265 41.334Z"),
                    A2(zC, "fill", "white")
                ]), h),
                A3(RB, "path", x([
                    A2(zC, "d", "M11.1001 44C9.64176 44 8.40226 43.4895 7.3816 42.4685C6.3606 41.4478 5.8501 40.2083 5.8501 38.75V32.5H12.2001V4L15.1901 7L18.1801 4L21.1701 7L24.1601 4L27.1501 7L30.1501 4L33.1501 7L36.1501 4L39.1501 7L42.1501 4V38.75C42.1501 40.2083 41.6398 41.4478 40.6191 42.4685C39.5981 43.4895 38.3584 44 36.9001 44H11.1001ZM36.9001 41C37.5668 41 38.1084 40.7917 38.5251 40.375C38.9418 39.9583 39.1501 39.4167 39.1501 38.75V9H15.2001V32.5H34.6501V38.75C34.6501 39.4167 34.8584 39.9583 35.2751 40.375C35.6918 40.7917 36.2334 41 36.9001 41ZM17.8501 16.9V13.9H29.8501V16.9H17.8501ZM17.8501 23.6V20.6H29.8501V23.6H17.8501ZM34.5001 16.9C34.1001 16.9 33.7501 16.75 33.4501 16.45C33.1501 16.15 33.0001 15.8 33.0001 15.4C33.0001 15 33.1501 14.65 33.4501 14.35C33.7501 14.05 34.1001 13.9 34.5001 13.9C34.9001 13.9 35.2501 14.05 35.5501 14.35C35.8501 14.65 36.0001 15 36.0001 15.4C36.0001 15.8 35.8501 16.15 35.5501 16.45C35.2501 16.75 34.9001 16.9 34.5001 16.9ZM34.5001 23.35C34.1001 23.35 33.7501 23.2 33.4501 22.9C33.1501 22.6 33.0001 22.25 33.0001 21.85C33.0001 21.45 33.1501 21.1 33.4501 20.8C33.7501 20.5 34.1001 20.35 34.5001 20.35C34.9001 20.35 35.2501 20.5 35.5501 20.8C35.8501 21.1 36.0001 21.45 36.0001 21.85C36.0001 22.25 35.8501 22.6 35.5501 22.9C35.2501 23.2 34.9001 23.35 34.5001 23.35ZM11.0501 41H31.6501V35.5H8.8501V38.75C8.8501 39.4167 9.06093 39.9583 9.4826 40.375C9.90426 40.7917 10.4268 41 11.0501 41Z"),
                    A2(zC, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, _E = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 24 24"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z")
            ]), h)
        ]));
    }, AE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "fill-rule", "evenodd"),
                A2(zC, "clip-rule", "evenodd"),
                A2(zC, "d", "M5.60222 9.97513C3.15606 9.97513 1.17354 7.9902 1.17354 5.54106C1.17354 3.09193 3.15606 1.10699 5.60222 1.10699C8.04837 1.10699 10.0309 3.09193 10.0309 5.54106C10.0309 7.9902 8.04837 9.97513 5.60222 9.97513ZM9.88751 9.05021C10.6746 8.08719 11.1452 6.85569 11.1383 5.51335C11.1227 2.43721 8.62637 -0.0257772 5.55397 0.000203667C2.53347 0.0261845 0.0890486 2.47532 0.0665592 5.50122C0.0440698 8.57909 2.50406 11.0733 5.57992 11.0854C6.91718 11.0906 8.14371 10.6212 9.10384 9.83656V9.83483L13.1035 13.8376C13.3197 14.0541 13.6692 14.0541 13.8854 13.8376C14.1017 13.6211 14.1017 13.2712 13.8854 13.0547L9.88751 9.05021Z"),
                A2(zC, "fill", "#C4DCF8")
            ]), h)
        ]));
    }, CE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "xmlns", "http://www.w3.org/2000/svg"),
            A2(zC, "viewBox", "0 -960 960 960")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M280-80q-33 0-56.5-23.5T200-160q0-33 23.5-56.5T280-240q33 0 56.5 23.5T360-160q0 33-23.5 56.5T280-80Zm400 0q-33 0-56.5-23.5T600-160q0-33 23.5-56.5T680-240q33 0 56.5 23.5T760-160q0 33-23.5 56.5T680-80ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z")
            ]), h)
        ]));
    }, BE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 12 12"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z"),
                A2(zC, "fill", "currentColor")
            ]), h)
        ]));
    }, EE = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "viewBox", "0 0 16 13"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M11.424 7.57621H14.16C14.128 7.61661 14.096 7.64691 14.064 7.66711C14.032 7.68731 14.0053 7.70751 13.984 7.72771L13.952 7.77316L8.4 12.8485C8.29333 12.9495 8.16 13 8 13C7.84 13 7.70667 12.9495 7.6 12.8485L2.032 7.75801C2 7.73781 1.94133 7.67721 1.856 7.57621H5.136C5.27467 7.57621 5.39733 7.54086 5.504 7.47016C5.61067 7.39946 5.67467 7.3035 5.696 7.1823L6.32 4.80371L8.016 10.4396C8.05867 10.5507 8.128 10.6416 8.224 10.7123C8.32 10.783 8.43733 10.8234 8.576 10.8335C8.69333 10.8335 8.80533 10.7931 8.912 10.7123C9.01867 10.6315 9.088 10.5406 9.12 10.4396L10.416 6.33389L10.928 7.28835C11.0347 7.48026 11.2 7.57621 11.424 7.57621ZM16 3.97045C16 4.77846 15.696 5.62183 15.088 6.50054H11.792L10.8 4.63706C10.7467 4.53606 10.6667 4.46031 10.56 4.40981C10.4533 4.3593 10.3467 4.33405 10.24 4.33405C9.97333 4.36436 9.808 4.49566 9.744 4.72796L8.592 8.36402L6.848 2.56147C6.80533 2.45037 6.73067 2.35442 6.624 2.27362C6.51733 2.19282 6.4 2.15747 6.272 2.16757C6.144 2.17767 6.032 2.21807 5.936 2.28877C5.84 2.35947 5.77067 2.45542 5.728 2.57662L4.704 6.50054H0.928C0.309333 5.62183 0 4.77846 0 3.97045C0 2.72813 0.378667 1.75851 1.136 1.0616C1.89333 0.364688 2.93867 0.0111818 4.272 0.00108147C4.63467 0.00108147 5.008 0.0616827 5.392 0.182884C5.776 0.304087 6.13333 0.470739 6.464 0.682843C6.79467 0.894947 7.08267 1.08685 7.328 1.25855C7.57333 1.43026 7.79733 1.62216 8 1.83426C8.21333 1.63226 8.43733 1.44036 8.672 1.25855C8.90667 1.07675 9.19467 0.884847 9.536 0.682843C9.87733 0.48084 10.2347 0.314187 10.608 0.182884C10.9813 0.0515823 11.3547 -0.0090189 11.728 0.00108147C13.0613 0.00108147 14.1067 0.354588 14.864 1.0616C15.6213 1.76861 16 2.73823 16 3.97045Z")
            ]), h)
        ]));
    }, DE = function(n) {
        switch(n){
            case 1:
                return WB;
            case 0:
                return dE;
            case 2:
                return OB;
            case 3:
                return xE;
            case 4:
                return oE;
            case 5:
                return lE;
            case 6:
                return _E;
            case 7:
                return VB;
            case 8:
                return YB;
            case 9:
                return eE;
            case 10:
                return bE;
            case 11:
                return QB;
            case 12:
                return uE;
            case 13:
                return UB;
            case 14:
                return KB;
            case 15:
                return AE;
            case 16:
                return XB;
            case 17:
                return fE;
            case 18:
                return pE;
            case 19:
                return GB;
            case 20:
                return JB;
            case 21:
                return mE;
            case 22:
                return EE;
            case 23:
                return sE;
            case 24:
                return wE;
            case 25:
                return aE;
            case 26:
                return kE;
            case 27:
                return ZB;
            case 28:
                return BE;
            case 29:
                return rE;
            case 30:
                return cE;
            case 31:
                return iE;
            case 32:
                return tE;
            case 33:
                return nE;
            case 34:
                return yE;
            case 35:
                return gE;
            case 36:
                return $E;
            case 37:
                return hE;
            case 38:
                return CE;
            default:
                return vE;
        }
    }, qE = function(n) {
        switch(n){
            case 0:
                return "icon--xs";
            case 1:
                return "icon--sm";
            case 2:
                return "icon--md";
            case 3:
                return "icon--lg";
            default:
                return "icon--xl";
        }
    }, FE = function(n) {
        switch(n.$){
            case 1:
                return x([
                    TB(hk(n.a))
                ]);
            case 0:
                return x([
                    TB(qE(n.a))
                ]);
            case 2:
                return x([
                    TB(n.a)
                ]);
            default:
                return x([
                    TB("icon--square")
                ]);
        }
    }, PE = F2(function(n, r) {
        var t = A2(tc, FE, n);
        return A2(DE, r, A2(Yt, TB("icon"), t));
    }), zE = function(n) {
        return x([
            A2(PE, x([
                HB,
                MB("fill-none stroke-[32px] stroke-current")
            ]), 10),
            ld(n)
        ]);
    }, jE = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), SE = F2(function(n, r) {
        return A2(jE, function(r) {
            return i(r, n);
        }, r);
    }), LE = function(n) {
        return n ? "Virtual" : "In-person";
    }, ME = function(n) {
        var r = x([
            1
        ]);
        return A2(SE, n, r) ? x([
            A2(ak, x([
                Xx("mx-2")
            ]), x([
                ld("\u2022")
            ])),
            ld(LE(n))
        ]) : h;
    }, NE = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return Ut;
        var u, a = e.a.a, i = e.b.a;
        return Vt(A2(nk, h, x([
            A2(LB, x([
                uB
            ]), x([
                ld(a.j7)
            ])),
            A2(nk, x([
                Xx("flex items-center")
            ]), A2(Yt, A2(ak, h, x([
                ld((u = a.j6, A2(fe, " ", x([
                    oe(u),
                    " minutes"
                ]))))
            ])), ME(a.sr))),
            A2(nk, x([
                Xx("flex items-center gap-1")
            ]), zE(i.kO)),
            function() {
                var n = i.kM;
                if (n.$) return tB;
                var r = n.a;
                return A2(nk, x([
                    Xx("ml-5")
                ]), x([
                    ld(r)
                ]));
            }()
        ])));
    }), HE = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(Yt, n, A2(Yt, r, t));
            });
            return A2(Yt, t, A3(Bu, u, h, e));
        }
        return h;
    }), TE = function(n) {
        return !n.b;
    }, IE = function(n) {
        return n.pn;
    }, RE = function(n) {
        return n;
    }, ZE = function(n) {
        return n.tg;
    }, VE = Xx("fs-mask"), UE = x([
        VE,
        A2(jC, "data-recording-sensitive", "")
    ]), YE = function(n) {
        return A2(ak, UE, n);
    }, QE = function(n) {
        return YE(x([
            ld(n)
        ]));
    }, OE = F2(function(n, r) {
        return A2(Fp, function(n) {
            var r;
            return A2(nk, x([
                Xx("font-extrabold")
            ]), x([
                ld("Book for "),
                QE(ZE(n)),
                QE((r = IE(n), r.$ ? "" : Gp(x([
                    " (",
                    A2(fp, "MM/dd/yyyy", r.a),
                    ")"
                ]))))
            ]));
        }, r);
    }), GE = F2(function(n, r) {
        if (r.$) return Ut;
        var t = r.a;
        return Vt(A2(nk, x([
            Xx("font-extrabold")
        ]), x([
            ld(t)
        ])));
    }), JE = F2(function(n, r) {
        var t, e = r.mF, u = r.r7, a = r.fq, i = r.eg;
        return t = A2(Tp, iu, x([
            A2(OE, n, r.t6),
            A3(NE, n, e, u),
            A2(GE, n, a),
            A2(SB, n, i)
        ])), TE(t) ? tB : A2(nk, x([
            Xx("flex flex-col border border-info-200 bg-info-100 rounded p-4")
        ]), A2(HE, Dk, t));
    }), WE = F4(function(n, r, t, e) {
        var u = b(r, t);
        if (3 !== u.a.$ || u.b.$) return A2(nk, h, ck);
        var a = u.a.a, i = u.b.a, c = function(n) {
            return n.u7;
        }(a), o = lC(a), f = b(sC(a), o);
        if (f.a.$ || f.b.$) return A2(nk, h, ck);
        var s = f.a.a, l = f.b.a;
        return A2(nk, h, x([
            A2(nk, x([
                Xx("text-center mb-8")
            ]), x([
                A2(yC, h, x([
                    ld(n(EA))
                ]))
            ])),
            A2(nk, x([
                Xx("mb-6")
            ]), x([
                A2(JE, !1, {
                    eg: FC(a),
                    mF: Vt({
                        j6: wC(s),
                        j7: AC(s),
                        sr: _C(s)
                    }),
                    r7: Vt({
                        kM: $C(l),
                        kO: CC(l)
                    }),
                    t6: Vt(i),
                    fq: Vt(BC(c))
                })
            ])),
            A2(nk, x([
                Xx("flex w-full mb-6")
            ]), x([
                A2(OC, x([
                    qC,
                    gC(x([
                        Xx("ml-auto mr-auto")
                    ])),
                    EC(pC)
                ]), x([
                    ld(n(EA))
                ]))
            ])),
            A3(jB, n, s, e)
        ]));
    }), KE = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel w-full")
                ]), x([
                    A4(WE, n, r.gH, r.t6, r.dB)
                ]))
            ]),
            w5: n(EA)
        };
    }), XE = ZA({
        Ar: aC,
        AQ: iC,
        Db: cC,
        DZ: function() {
            return zx;
        },
        En: mC,
        Et: KE
    }), nD = F3(function(n, r, t) {
        return b({
            bc: t.Ck.bc,
            kA: r.kA,
            dB: n,
            xs: t
        }, Pp);
    }), rD = F2(function(n, r) {
        return b(r, Pp);
    }), tD = F2(function(n, r) {
        return r;
    }), eD = function(n) {
        return A2(Wu, "appointment-type", n);
    }, uD = F2(function(n, r) {
        var t, e = (t = eD(r.xs.iF)).$ ? da : Ul(x([
            b("appointment-type", t.a)
        ]));
        return v(r, A2(AA, e, $a), h);
    }), aD = F2(function(n) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel w-full")
                ]), x([
                    A2(nk, x([
                        Xx("text-center mb-8")
                    ]), x([
                        A2(yC, h, x([
                            ld(n(NA))
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("mb-6")
                    ]), x([
                        ld(n(zA))
                    ])),
                    A2(nk, x([
                        Xx("flex w-full mb-6")
                    ]), x([
                        A2(OC, x([
                            qC,
                            gC(x([
                                Xx("ml-auto mr-auto")
                            ])),
                            EC(0)
                        ]), x([
                            ld("Reschedule")
                        ]))
                    ]))
                ]))
            ]),
            w5: n(SA)
        };
    }), iD = ZA({
        Ar: nD,
        AQ: rD,
        Db: tD,
        DZ: function() {
            return zx;
        },
        En: uD,
        Et: aD
    }), cD = F2(function(n, r) {
        return A2(SE, n, r.b.qt);
    }), oD = function(n) {
        return function(n) {
            return A2(cD, "clinical_calendar_migration", n);
        }(n) || function(n) {
            return A2(cD, "new_calendar", n);
        }(n);
    }, fD = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sD = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lD = A3(ly, "appointment_types", vy(py), uu(function(n) {
        return {
            mI: n
        };
    })), dD = A2(ru, uu, Pk), bD = A2(dD, 0, A2(Pk, lD, uu(sD))), vD = x([
        "v1",
        "booking"
    ]), mD = A2(X_, x([
        "appointment-types"
    ]), vD), pD = mD, $D = F2(function(n, r) {
        return A4(W_, n, bD, r, rA(pD));
    }), hD = {
        $: 0
    }, gD = function(n) {
        return n.bZ.yl;
    }, wD = function(n) {
        return n.bZ.pe;
    }, xD = function(n) {
        return n.bZ.Ax;
    }, kD = function(n) {
        return n.bZ.rQ;
    }, yD = function(n) {
        return n.bZ.CB;
    }, _D = function(n) {
        return n.bZ.vJ;
    }, AD = function(n) {
        return n.bZ.fC;
    }, CD = F2(function(n, r) {
        return r.$ ? r.a.tg : n(gD);
    }), BD = {
        fC: dd({
            rh: "booking-location-filter",
            Eb: CD,
            Ed: function(n) {
                return n.$ ? Vt(n.a.rh) : Ut;
            }
        }),
        dR: hD
    }, ED = A2(AA, da, Uu), DD = F3(function(n, r, t) {
        var e = {
            ej: vc,
            c8: r.yY.yG,
            kA: r.kA,
            kN: BD,
            t6: uC(r.t6),
            dB: n,
            xs: t
        }, u = oD(n) ? function(n) {
            return A2($D, n.c8, fD);
        }(e) : ED;
        return b(e, u);
    }), qD = F2(function(n, r) {
        return b(r, Pp);
    }), FD = F2(function(n, r) {
        return m(r, {
            x6: Vt(9)
        });
    }), PD = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zD = function(n) {
        return n.a.mI;
    }, jD = F2(function(n, r) {
        if (n.$) return r;
        var t = n.a;
        return A2(Rc, function(n) {
            return i(vC(n), t);
        }, r);
    }), SD = function(n) {
        return n.rh;
    }, LD = {
        $: 2
    }, MD = {
        $: 1
    }, ND = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HD = function(n) {
        return m(n, {
            aP: !1
        });
    }, TD = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ID = et("focus"), RD = function(n) {
        return A2(hc, TD(n), ID(n));
    }, ZD = F2(function(n, r) {
        switch(n.$){
            case 3:
                return v(r, 1 === (e = b(n.b, i(n.a, r.rh + "-item-active"))).a.$ && e.b ? RD(r.rh + "-item") : Pp, Ut);
            case 0:
                return v(m(r, {
                    aP: !r.aP
                }), RD(r.rh + "-input"), Vt(MD));
            case 1:
            case 5:
                return v(HD(r), Pp, Vt(LD));
            case 2:
                switch(n.a){
                    case 27:
                    case 38:
                        return v(HD(r), Pp, Ut);
                    case 40:
                        return v(function(n) {
                            return m(n, {
                                aP: !0
                            });
                        }(r), RD(r.rh + "-item-active"), Ut);
                    default:
                        return v(r, Pp, Ut);
                }
            case 6:
                var t = n.a;
                switch(n.b){
                    case 27:
                        return v(HD(r), RD(r.rh + "-input"), Ut);
                    case 13:
                        return v(HD(r), RD(r.rh + "-input"), Vt(ND(t)));
                    default:
                        return v(r, Pp, Ut);
                }
            default:
                return t = n.a, v(HD(r), RD(r.rh + "-input"), Vt(ND(t)));
        }
        var e;
    }), VD = F2(function(n, r) {
        var t = A2(ZD, n, r.fC), e = t.b, u = t.c;
        return b(m(r, {
            fC: t.a,
            dR: u.$ || u.a.$ || u.a.a.$ ? r.dR : u.a.a.a
        }), A2(Lp, iu, e));
    }), UD = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    ej: t
                });
                if (3 === t.$) {
                    var u = t.a, a = A2(jD, eD(e.xs.iF), zD(u));
                    return v(e, TE(a) ? A2(AA, da, ti) : Pp, h);
                }
                return v(e, Pp, A2(xA, 0, t));
            case 1:
                var i = n.a, c = i.b;
                return v(r, A2(AA, r.xs.iF, ha({
                    mH: vC(i.a),
                    nd: SD(c)
                })), h);
            default:
                var o = A2(VD, n.a, r.kN), f = o.b;
                return v(m(r, {
                    kN: o.a
                }), A2(Lp, PD, f), h);
        }
    }), YD = F4(function(n, r, t, e) {
        var u = t.$ ? "Please contact" : t.a + ", please contact", a = function() {
            var n = b(r, e);
            if (n.a.$) return ld(n.b.$ ? "" : u = n.b.a);
            if (n.b.$) return t = n.a.a, A2(ak, h, x([
                ld("at "),
                A2(fB, x([
                    yB("tel:" + t)
                ]), x([
                    A2(ak, x([
                        Xx("hover:underline cursor-pointer text-info-300")
                    ]), x([
                        ld(A2(xB, 0, t))
                    ]))
                ])),
                ld(".")
            ]));
            var t = n.a.a, u = n.b.a;
            return A2(ak, h, x([
                ld("at "),
                A2(fB, x([
                    yB("tel:" + t)
                ]), x([
                    A2(ak, x([
                        Xx("hover:underline cursor-pointer text-info-300")
                    ]), x([
                        ld(A2(xB, 0, t))
                    ]))
                ])),
                ld(" " + u)
            ]));
        }();
        return A2(ak, h, x([
            ld(u),
            ld(" "),
            ld(n),
            ld(" "),
            a
        ]));
    }), QD = function(n) {
        return A2(nk, x([
            Xx("flex flex-col")
        ]), x([
            A2(nk, h, x([
                ld("Can't find a service that suits your needs?")
            ])),
            A2(nk, h, x([
                A4(YD, Ex(n), qB(n), Ut, Ut)
            ]))
        ]));
    }, OD = function(n) {
        return {
            $: 1,
            a: n
        };
    }, GD = function(n) {
        return n.mx;
    }, JD = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? b(A2(Yt, r, e), u) : b(e, A2(Yt, r, u));
        });
        return A3(Bu, t, b(h, h), r);
    }), WD = function(n) {
        return n.ne;
    }, KD = function(n) {
        return A2(sc, h, A2(Fp, Eu(function(r) {
            return b(n, r);
        }), WD(n)));
    }, XD = F2(function(n, r) {
        var t = function(n) {
            var r = n.dR;
            return r.$ ? Vt(r.a.rh) : Ut;
        }(n);
        if (t.$) return r;
        var e = t.a;
        return A2(Rc, function(n) {
            return i(SD(n.b), e);
        }, r);
    }), nq = F2(function(n, r) {
        return A2(Ju, AC(n), AC(r));
    }), rq = F2(function(n, r) {
        return A2(Ju, CC(n), CC(r));
    }), tq = F2(function(n, r) {
        var t = n.a, e = r.a, u = A2(rq, n.b, r.b);
        return 1 === u ? A2(nq, t, e) : u;
    }), eq = A, uq = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), aq = sk(2), iq = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cq = iq(1), oq = function(n) {
        return !GD(n);
    }, fq = sk(1), sq = function(n) {
        return oq(n) ? A2(LB, x([
            fq,
            rB(cq),
            ok(x([
                Xx("text-secondary")
            ]))
        ]), x([
            A2(nk, x([
                Xx("px-3 py-1")
            ]), x([
                ld("Member-only")
            ]))
        ])) : tB;
    }, lq = F2(function(n, r) {
        var t = _C(n);
        return A2(nk, x([
            Xx("flex flex-row cursor-pointer border border-info-200 rounded px-4 py-2 text-primary-500 gap-1 justify-between"),
            IC(A2(uq, n, r))
        ]), x([
            A2(nk, x([
                Xx("flex flex-col gap-1")
            ]), x([
                A2(LB, x([
                    uB,
                    aq,
                    ok(x([
                        Xx("text-black")
                    ]))
                ]), x([
                    ld(AC(n))
                ])),
                A2(nk, x([
                    Xx("flex items-center")
                ]), A2(Yt, A2(ak, h, x([
                    ld(oe(wC(n)) + " minutes")
                ])), ME(t))),
                A2(nk, x([
                    Xx("flex items-center gap-1")
                ]), zE(CC(r)))
            ])),
            sq(n)
        ]));
    }), dq = F2(function(n, r) {
        return A2(nk, x([
            Xx("flex flex-col gap-4")
        ]), A2(Eu, function(n) {
            return A2(lq, n.a, n.b);
        }, A2(eq, tq, A2(XD, n, A2(tc, KD, r)))));
    }), bq = eB(4), vq = {
        $: 4
    }, mq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pq = mq({
        $: 0
    }), $q = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hq = F2(function(n, r) {
        return A2($q, n, r);
    }), gq = function(n) {
        return {
            $: 1,
            a: {
                rh: SD(n),
                tg: CC(n)
            }
        };
    }, wq = function(n) {
        return A2(Yt, A2(hq, h, hD), A2(Yt, pq, A2(Eu, A2(ru, gq, hq(h)), n)));
    }, xq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kq = function(n) {
        return A2(sc, h, WD(n));
    }, yq = da, _q = F2(function(n, r) {
        return A3(ta, n, 0, r);
    }), Aq = F2(function(n, r) {
        return !A2(Wu, n, r).$;
    }), Cq = F2(function(n, r) {
        return A2(Aq, n, r);
    }), Bq = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return Ae(e);
            var u = t.a, a = t.b, i = n(u);
            A2(Cq, i, r) ? t = a : (r = A2(_q, i, r), t = a, e = A2(Yt, u, e));
        }
    }), Eq = F2(function(n, r) {
        return A4(Bq, n, yq, r, h);
    }), Dq = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qq = {
        $: 1
    }, Fq = {
        $: 0
    }, Pq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zq = {
        $: 5
    }, jq = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Sq = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Lq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mq = F3(function(n, r, t) {
        return n ? $(t, x([
            r
        ])) : t;
    }), Nq = A2(ak, x([
        Xx("select__arrow")
    ]), h), Hq = Kx("id"), Tq = cr("label"), Iq = Kx("value"), Rq = F2(function(n, r) {
        return n.$ ? r : A2(Yt, Iq(n.a), r);
    }), Zq = cr("input"), Vq = Kx("type"), Uq = function(n) {
        return x([
            Xx("select__item__input"),
            Vq("radio"),
            NC(n.zn)
        ]);
    }, Yq = Kx("name"), Qq = function(n) {
        return A2(TC, "mousedown", uu(n));
    }, Oq = {
        zn: !1,
        hQ: Ut
    }, Gq = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), Jq = F2(function(n, r) {
        var t = n.Ed, e = n.Eb, u = n.iQ, a = n.Dj, c = n.Bv, o = n.BW, f = n.BM, s = r.a, l = r.b, d = t(l), v = A3(de, Gq, Oq, s), m = v.zn ? h : x([
            Qq(o(Vt(l)))
        ]), p = A2(sc, A2(sc, "", d), v.hQ), g = A2(sc, !1, A2(Fp, function(n) {
            return i(t(n), t(l));
        }, u)), w = $(a, g ? "-item-active" : "-item"), k = A2(Rq, d, x([
            ZC(f(Vt(l))),
            A2(YC, c, a),
            Hq(w),
            Yq(a)
        ]));
        return b(p, A2(Tq, A2(Yt, Xx("select__item"), A2(Yt, A2(jC, "role", "option"), A2(Yt, SC(x([
            b("select__item--active", g),
            b("select__item--disabled", v.zn)
        ])), m))), x([
            A2(Zq, $(Uq(v), k), h),
            A2(ak, h, x([
                A2(Ck, yu, e(l))
            ]))
        ])));
    }), Wq = F2(function(n, r) {
        if (1 === r.$) {
            var t = r.a;
            if (t.$) {
                var e = t.a;
                return b("0", A2(Tq, x([
                    Xx("select__item select__item--disabled")
                ]), x([
                    ld(e)
                ])));
            }
            return b("0", A2(Tq, x([
                Xx("select__item--divider")
            ]), h));
        }
        return A2(Jq, n, b(r.a, r.b));
    }), Kq = function(n) {
        return or(hr(n));
    }, Xq = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), nF = F2(function(n, r) {
        return A2(Xq, n, r);
    }), rF = {
        $: 0
    }, tF = {
        j8: h,
        hi: 1,
        zn: !1,
        eK: !1,
        Ax: !1,
        hO: !0,
        it: !1,
        CB: "Pick an item",
        dW: rF,
        xz: Ut
    }, eF = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    zn: n.a
                });
            case 0:
                return m(r, {
                    xz: n.a
                });
            case 1:
                return m(r, {
                    CB: n.a
                });
            case 3:
                return m(r, {
                    Ax: n.a
                });
            case 5:
                return m(r, {
                    it: n.a
                });
            case 4:
                return m(r, {
                    eK: !0
                });
            case 6:
                return m(r, {
                    dW: n.a
                });
            case 7:
                return m(r, {
                    hO: n.a
                });
            default:
                return m(r, {
                    hi: n.a
                });
        }
    }), uF = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aF = function(n) {
        return 1 !== n.$;
    }, iF = DC(3), cF = DC(5), oF = DC(1), fF = function(n) {
        var r = i(n.dW, rF), t = aF(n.xz), e = i(n.dW, Lq(1)) ? x([
            cF,
            iF
        ]) : x([
            oF
        ]);
        return A2(Yt, gC($(n.j8, x([
            SC(x([
                b("select--invalid", n.Ax),
                b("select__input", r),
                b("select__input--selected", t && r)
            ]))
        ]))), A2(Yt, uF(n.zn), e));
    }, sF = F4(function(n, r, t, e) {
        var u, a, c = A3(de, eF, tF, r), o = A2(sc, ld(c.CB), A2(Fp, e.$7(n), c.xz)), f = {
            Bv: zq,
            BM: Sq,
            BW: jq,
            Dj: e.rh,
            iQ: c.xz,
            Eb: e.$7(n),
            Ed: e.kK
        }, s = i(c.dW, Lq(1));
        return A2(nk, $(c.it ? UE : h, x([
            Xx("select"),
            SC(x([
                b("select--open", e.aP),
                b("w-full", c.eK)
            ])),
            Hq(e.rh)
        ])), x([
            A2(OC, A2(Yt, gC(x([
                SC(x([
                    b("w-full", !s)
                ])),
                Hq(e.rh + "-input")
            ])), A2(Yt, EC(Fq), A2(Yt, A2(nF, qq, e.rh), A2(Yt, (a = Pq, {
                $: 8,
                a: a
            }), A2(Yt, gC(x([
                Vq("button")
            ])), fF(c)))))), A3(Mq, !s, Nq, x([
                A2(Ck, yu, o)
            ]))),
            !c.zn && e.aP ? A3(Kq, "div", x([
                Xx("select__items"),
                SC(x([
                    b("select__items--nowrap", !c.hO)
                ])),
                (u = c.hi, Xx(function() {
                    switch(u){
                        case 2:
                            return "select__items--right";
                        case 0:
                            return "select__items--top";
                        default:
                            return "";
                    }
                }()))
            ]), A2(Eu, Wq(f), t)) : tB
        ]));
    }), lF = F3(function(n, r, t) {
        var e = function(n) {
            return A2(eq, rq, A2(Eq, SD, A2(tc, kq, n)));
        }(r);
        return be(e) > 1 ? A2(nk, x([
            Xx("flex flex-col gap-2")
        ]), x([
            A2(Ek, x([
                bq
            ]), x([
                ld(n(kD))
            ])),
            A2(Ck, iu, A4(sF, n, x([
                Dq(Vt(t.dR)),
                vq,
                xq(n(yD))
            ]), wq(e), t.fC))
        ])) : tB;
    }), dF = F4(function(n, r, t, e) {
        var u = A2(jD, eD(r.iF), zD(e)), a = A2(JD, GD, u), i = a.a, c = a.b;
        return x([
            A2(Ck, PD, A3(lF, n, u, t)),
            A2(Ck, OD, A2(dq, t, c)),
            A2(Ck, OD, A2(dq, t, i))
        ]);
    }), bF = function(n) {
        return n.a.sr;
    }, vF = function(n) {
        return n.a.tg;
    }, mF = function(n) {
        var r;
        return {
            j6: (r = n, r.a.pI),
            j7: vF(n),
            sr: bF(n)
        };
    }, pF = function(n) {
        return {
            kM: $C(n),
            kO: CC(n)
        };
    }, $F = F2(function(n, r) {
        var t = r.t6, e = r.nc, u = r.fq;
        return A2(JE, n, {
            eg: r.eg,
            mF: A2(Fp, mF, r.yn),
            r7: A2(Fp, pF, e),
            t6: t,
            fq: u
        });
    }), hF = F2(function(n, r) {
        var t = r.ej;
        if (3 === t.$) {
            var e = t.a;
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), A2(Yt, A2($F, !1, {
                eg: Ut,
                yn: Ut,
                nc: Ut,
                t6: r.t6,
                fq: Ut
            }), $(A4(dF, n, r.xs, r.kN, e), x([
                QD(r.dB)
            ]))));
        }
        return A2(nk, h, ck);
    }), gF = function(n) {
        return n.mv;
    }, wF = F2(function(n, r) {
        for(;;){
            if (!r.b) return Ut;
            var t = r.a, e = r.b;
            if (n(t)) return Vt(t);
            r = e;
        }
    }), xF = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kF = xF(1), yF = eB(1), _F = function(n) {
        var r;
        return r = function(n) {
            return n ? "Book an appointment" : "Request an appointment";
        }(n), A2(yC, x([
            rB(kF),
            yF
        ]), x([
            ld(r)
        ]));
    }, AF = F2(function(n, r) {
        if (3 === r.$) {
            var t = r.a, e = eD(n.iF);
            if (e.$) return _F(!0);
            var u = e.a, a = A2(wF, function(n) {
                return i(vC(n), u);
            }, zD(t));
            return _F(!!a.$ || gF(a.a));
        }
        return _F(!0);
    }), CF = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("flex flex-col gap-4")
                ]), x([
                    A2(AF, r.xs, r.ej),
                    A2(hF, n, r)
                ]))
            ]),
            w5: "Booking"
        };
    }), BF = ZA({
        Ar: DD,
        AQ: qD,
        Db: FD,
        DZ: function() {
            return zx;
        },
        En: UD,
        Et: CF
    }), EF = function(n) {
        return {
            $: 4,
            a: n
        };
    }, DF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qF = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), FF = A4(sy, "redirect_button_text", iy(C$), Ut, A4(sy, "redirect_url", iy(C$), Ut, A4(sy, "notes_custom_question", iy(C$), Ut, A4(sy, "notes_required", jk, !1, A3(ly, "allow_instant_book", jk, A3(ly, "require_provider_selection", jk, A3(ly, "booking_location", by, A3(ly, "meeting_type", Lk, A3(ly, "duration", F$, A3(ly, "name", C$, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    mv: i,
                                                    nc: u,
                                                    pI: t,
                                                    rh: n,
                                                    sr: e,
                                                    tg: r,
                                                    tx: o,
                                                    ty: c,
                                                    vs: s,
                                                    vt: f,
                                                    vI: a
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), PF = A2(dD, 0, A2(Pk, FF, uu(qF))), zF = F2(function(n, r) {
        return A2(X_, x([
            n,
            "location",
            r
        ]), mD);
    }), jF = F2(function(n, r) {
        return A2(zF, n, r);
    }), SF = F4(function(n, r, t, e) {
        return A4(W_, n, PF, e, rA(A2(jF, r, t)));
    }), LF = F3(function(n, r, t) {
        return A4(SF, n, r, t, DF);
    }), MF = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HF = A3(dp, 1992, 4, 31), TF = _n(function(n) {
        n(kn(A2(qc, -(new Date).getTimezoneOffset(), h)));
    }), IF = (a_ = Mp, _n(function(n) {
        n(kn(a_(Date.now())));
    })), RF = A3(Fu, bp, TF, IF), ZF = b({
        bU: Vt(HF),
        fj: 0,
        xb: HF
    }, A2(Nu, NF, RF)), VF = b({
        mG: Ut,
        cj: Ut,
        bQ: ZF.a,
        am: Ut,
        aS: Ut
    }, A2(Lp, MF, ZF.b)), UF = function(n) {
        return n.uP;
    }, YF = function(n) {
        return A2(nv, UF, uC(n));
    }, QF = F3(function(n, r, t) {
        var e = VF.a, u = VF.b, a = {
            ci: vc,
            mH: t.Ck.mH,
            bH: vc,
            ck: Ut,
            nd: t.Ck.nd,
            c8: r.yY.yG,
            kA: r.kA,
            t6: uC(r.t6),
            iq: YF(r.ud),
            dB: n,
            ae: e,
            xs: t
        }, i = oD(n) ? A3(LF, a.c8, a.mH, a.nd) : ED;
        return b(a, Vu(x([
            i,
            A2(Lp, EF, u)
        ])));
    }), OF = F2(function(n, r) {
        return b(m(r, {
            iq: YF(n.ud)
        }), Pp);
    }), GF = F2(function(n, r) {
        return m(r, {
            x6: Vt(9)
        });
    }), JF = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WF = function(n) {
        return {
            $: 3,
            a: n
        };
    }, KF = nr("gotItemPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return uu({
                    x7: t,
                    eS: r,
                    xz: n
                });
            }, A2(Tu, "action", C$));
        }, A2(Tu, "itemType", C$));
    }, A2(Tu, "value", P$(x([
        oy(Ut),
        A2(tu, Vt, C$)
    ]))))), XF = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), nP = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), rP = function(n) {
        switch(n){
            case "OnlineEnrollment":
                return 0;
            case "PageAbandoned":
                return 1;
            case "Booking":
                return 4;
            default:
                return 2;
        }
    }, tP = F2(function(n, r) {
        var t = r.xz, e = r.eS, u = r.x7;
        switch(u){
            case "set":
                return n(te({
                    $: 0,
                    a: rP(e)
                }));
            case "get":
                return n(te(A2(XF, rP(e), t)));
            case "remove":
                return n(te(A2(nP, rP(e), !1)));
            case "removeAndRedirect":
                return n(te(A2(nP, rP(e), !0)));
            default:
                return n(Kt("Action " + u + " not supported"));
        }
    }), eP = function(n) {
        return KF(tP(n));
    }, uP = nr("removedItemPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return uu({
                    x7: t,
                    eS: r,
                    xz: n
                });
            }, A2(Tu, "action", C$));
        }, A2(Tu, "itemType", C$));
    }, A2(Tu, "value", P$(x([
        oy(Ut),
        A2(tu, Vt, C$)
    ]))))), aP = function(n) {
        return uP(tP(n));
    }, iP = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), cP = {
        $: 1
    }, oP = "bookingForm", fP = {
        ef: Ut,
        eg: Ut,
        eh: Ut,
        pn: Ut,
        pP: Ut,
        qB: Ut,
        rS: Ut,
        fb: Ut,
        uw: Ut,
        fp: Ut,
        fq: Ut
    }, sP = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), lP = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), dP = F3(function(n, r, t) {
        return {
            mQ: r,
            o$: n,
            xx: t
        };
    }), bP = F2(function(n, r) {
        return {
            oY: n,
            w4: r
        };
    }), vP = F5(function(n, r, t, e, u) {
        return {
            p0: e,
            wg: u,
            wH: n,
            wL: t,
            xw: r
        };
    }), mP = A3(ly, "short_tz_display_text", C$, A3(ly, "end_display_text", C$, A3(ly, "start_display_text", C$, A3(ly, "user_id", C$, A3(ly, "start", C$, uu(vP)))))), pP = A2(Pk, mP, uu(iu)), $P = A3(ly, "time_slots", vy(pP), A3(ly, "date", ay, uu(bP))), hP = A2(Pk, $P, uu(iu)), gP = A3(ly, "users", vy(KA), A3(ly, "availabilities_date", ay, A3(ly, "availabilities", vy(hP), uu(dP)))), wP = A2(dD, 0, A2(Pk, gP, uu(lP))), xP = {
        DN: Ut
    }, kP = function(n) {
        var r, t = n(xP);
        return rc(x([
            (r = t.DN, r.$ ? h : x([
                A2(Y_, "startDate", r.a)
            ]))
        ]));
    }, yP = F2(function(n, r) {
        return A2(X_, x([
            "availability"
        ]), A2(zF, n, r));
    }), _P = F2(function(n, r) {
        return m(r, {
            iF: $(r.iF, n)
        });
    }), AP = F5(function(n, r, t, e, u) {
        return A4(W_, n, wP, u, A2(_P, kP(r), rA(A2(yP, t, e))));
    }), CP = F5(function(n, r, t, e, u) {
        return A5(AP, n, function(n) {
            return m(n, {
                DN: Vt(e)
            });
        }, r, t, sP(u));
    }), BP = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(BC(n), r);
        }, n);
    }), EP = function(n) {
        var r = Pv(n), t = Nv(n);
        return A3(dp, r, t, 1);
    }, DP = function(n) {
        return n.ef;
    }, qP = function(n) {
        return n.a.nc;
    }, FP = fp("yyyy-MM-dd"), PP = F2(function(n, r) {
        return {
            bU: r,
            fj: 0,
            xb: n
        };
    }), zP = function(n) {
        return A2(fp, "yyyy-MM-dd", n);
    }, jP = function(n) {
        return n.xb;
    }, SP = F2(function(n, r) {
        var t = r.mG;
        if (t.$) return Ut;
        var e = jP(qP(t.a)), u = A2(Fp, zP, e), a = A2(N$, A2(Fp, FP, A2(Fp, EP, A2(nv, B$, A2(Fp, uy, A2(nv, DP, n))))), u);
        if (a.$) return Ut;
        var i = a.a, c = b(e, uy(i));
        return c.a.$ || c.b.$ ? Ut : Vt(b(m(r, {
            bQ: A2(PP, c.a.a, Vt(c.b.a))
        }), i));
    }), LP = function(n) {
        return 1 === n.$;
    }, MP = function(n) {
        return n.tg;
    }, NP = Wn("getItemPort", function(n) {
        return _x(x([
            b("action", Ax(n.x7)),
            b("itemType", Ax(n.eS)),
            b("key", Ax(n.hQ)),
            b("value", Ax(n.xz))
        ]));
    }), HP = function(n) {
        switch(n){
            case 0:
                return "OnlineEnrollment";
            case 1:
                return "PageAbandoned";
            case 2:
                return "Practice";
            case 3:
                return "Language";
            default:
                return "Booking";
        }
    }, TP = Wn("removeItemPort", function(n) {
        return _x(x([
            b("action", Ax(n.x7)),
            b("itemType", Ax(n.eS)),
            b("key", Ax(n.hQ)),
            b("value", Ax(n.xz))
        ]));
    }), IP = Wn("setItemPort", function(n) {
        return _x(x([
            b("action", Ax(n.x7)),
            b("itemType", Ax(n.eS)),
            b("key", Ax(n.hQ)),
            b("value", Ax(n.xz))
        ]));
    }), RP = function(n) {
        switch(n.$){
            case 0:
                var r = n.b, t = n.c;
                return IP({
                    x7: "set",
                    eS: HP(n.a),
                    hQ: r,
                    xz: t
                });
            case 1:
                return r = n.b, NP({
                    x7: "get",
                    eS: HP(n.a),
                    hQ: r,
                    xz: ""
                });
            case 2:
                return r = n.b, TP({
                    x7: "remove",
                    eS: HP(n.a),
                    hQ: r,
                    xz: ""
                });
            default:
                return r = n.b, TP({
                    x7: "removeAndRedirect",
                    eS: HP(n.a),
                    hQ: r,
                    xz: ""
                });
        }
    }, ZP = function(n) {
        return n.a.vI;
    }, VP = function(n) {
        return n.am;
    }, UP = function(n) {
        return n.aS;
    }, YP = function(n) {
        return n.wg;
    }, QP = function(n) {
        return n.wL;
    }, OP = F2(function(n, r) {
        return m(r, {
            eg: n
        });
    }), GP = F2(function(n, r) {
        return A2(OP, Vt(n), r);
    }), JP = F3(function(n, r, t) {
        var e, u = A2(fe, " ", x([
            QP(n),
            "-",
            (e = n, e.p0),
            YP(n)
        ])), a = A2(fe, ", ", x([
            A2(fp, "MMMM d, y", r),
            u
        ]));
        return A2(GP, a, t);
    }), WP = function(n) {
        return n.eh;
    }, KP = function(n) {
        return n.fp;
    }, XP = function(n) {
        return n.oY;
    }, nz = function(n) {
        return n.a.o$;
    }, rz = function(n) {
        return n.w4;
    }, tz = function(n) {
        return A2(tc, function(n) {
            return A2(Eu, function(r) {
                return b(XP(n), r);
            }, rz(n));
        }, nz(n));
    }, ez = function(n) {
        return n.xw;
    }, uz = function(n) {
        return n.xw;
    }, az = F2(function(n, r) {
        return A2(Rc, function(r) {
            return i(ez(r.b), uz(n));
        }, tz(r));
    }), iz = function(n) {
        return A2(sc, !0, A2(Fp, ZP, n));
    }, cz = function(n) {
        return n.a.xx;
    }, oz = function(n) {
        var r = n.cj;
        if (r.$) return n;
        var t = r.a, e = b(iz(n.mG), n.aS);
        if (e.a && !e.b.$) return m(n, {
            am: A2(Fp, Oe, rv(A2(az, e.b.a, t)))
        });
        var u = rv(tz(t));
        if (u.$) return m(n, {
            am: Ut,
            aS: Ut
        });
        var a = u.a, c = a.a, o = a.b, f = A2(wF, function(n) {
            return i(uz(n), ez(o));
        }, cz(t));
        return m(n, {
            am: Vt(c),
            aS: f
        });
    }, fz = function(n) {
        return n.wH;
    }, sz = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a.$ || e.b.$) return t;
        var u = e.a.a, a = e.b.a, c = A2(Rc, function(n) {
            var r = n.b;
            return i(n.a, u) && i(fz(r), a);
        }, t);
        return TE(c) ? t : c;
    }), lz = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(uz(n), ez(r));
        }, n);
    }), dz = F2(function(n, r) {
        return b(A2(nv, lz(n), A2(Fp, zc, r)), A2(Fp, Oe, r));
    }), bz = F4(function(n, r, t, e) {
        var u = e.cj;
        if (u.$) return e;
        var a = u.a, c = tz(a), o = A3(sz, r, n, c), f = function() {
            if (iz(e.mG)) {
                var n = cz(a), r = function() {
                    if (t.$) return rv(o);
                    var n = t.a;
                    return A2(N$, A2(wF, function(r) {
                        return i(ez(r.b), n);
                    }, o), rv(o));
                }();
                return A2(dz, n, r);
            }
            var u = A2(Fp, Oe, rv(o));
            return b(Ut, u);
        }();
        return m(e, {
            am: f.b,
            aS: f.a
        });
    }), vz = F6(function(n, r, t, e, u, a) {
        var i = e.a.mQ, c = jP(qP(t)), o = c.$ ? a.bQ : A2(PP, c.a, Vt(i)), f = m(a, {
            cj: Vt(e),
            bQ: o
        });
        if (n) {
            var s = A2(nv, KP, r);
            return A4(bz, A2(nv, WP, r), A2(nv, B$, A2(Fp, uy, A2(nv, DP, r))), A2(N$, s, u), f);
        }
        return oz(f);
    }), mz = F2(function(n, r) {
        return m(r, {
            ef: n
        });
    }), pz = F2(function(n, r) {
        return A2(mz, Vt(n), r);
    }), $z = F2(function(n, r) {
        return m(r, {
            eh: n
        });
    }), hz = F2(function(n, r) {
        return A2($z, Vt(n), r);
    }), gz = F3(function(n, r, t) {
        return A2(pz, zP(r), A2(hz, n, t));
    }), wz = F2(function(n, r) {
        return m(r, {
            fp: n
        });
    }), xz = F2(function(n, r) {
        return A2(wz, Vt(n), r);
    }), kz = F2(function(n, r) {
        return m(r, {
            fq: n
        });
    }), yz = F2(function(n, r) {
        return A2(kz, Vt(n), r);
    }), _z = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a && !e.b.$) {
            var u = e.b.a;
            return A2(yz, BC(u), A2(xz, uz(u), t));
        }
        return t;
    }), Az = "appointment_date", Cz = "appointment_display", Bz = "appointment_start", Ez = "email", Dz = F2(function(n, r) {
        return A2(Fp, function(r) {
            return b(n, Ax(r));
        }, r);
    }), qz = "first_name", Fz = "last_name", Pz = "notes", zz = "phone", jz = "provider_id", Sz = "provider_name", Lz = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Mz = function(n) {
        var r;
        return r = function(n) {
            var r;
            return A2(ce, 2, _x(A2(Tp, iu, x([
                A2(Dz, jz, (r = n).fp),
                A2(Dz, Sz, r.fq),
                A2(Dz, Az, r.ef),
                A2(Dz, Bz, r.eh),
                A2(Dz, Cz, r.eg),
                A2(Dz, qz, r.qB),
                A2(Dz, Fz, r.rS),
                A2(Dz, "dob", r.pn),
                A2(Dz, Ez, r.pP),
                A2(Dz, zz, r.uw),
                A2(Dz, Pz, r.fb)
            ]))));
        }(n), RP(A3(Lz, 4, oP, r));
    }, Nz = A4(sy, Pz, iy(C$), Ut, A4(sy, zz, iy(C$), Ut, A4(sy, Ez, iy(C$), Ut, A4(sy, "dob", iy(C$), Ut, A4(sy, Fz, iy(C$), Ut, A4(sy, qz, iy(C$), Ut, A4(sy, Cz, iy(C$), Ut, A4(sy, Bz, iy(C$), Ut, A4(sy, Az, iy(C$), Ut, A4(sy, Sz, iy(C$), Ut, A4(sy, jz, iy(C$), Ut, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    ef: t,
                                                    eg: u,
                                                    eh: e,
                                                    pn: c,
                                                    pP: o,
                                                    qB: a,
                                                    rS: i,
                                                    fb: s,
                                                    uw: f,
                                                    fp: n,
                                                    fq: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Hz = A2(Pk, Nz, uu(iu)), Tz = function(n) {
        var r = A2(Yp, Hz, n);
        return r.$ ? Ut : Vt(r.a);
    }, Iz = {
        ka: function(n) {
            return ld(n);
        },
        nu: {
            $: 0
        },
        ev: "calendar-datepicker--",
        kf: h,
        zh: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        zD: Ut,
        hx: 6,
        AC: cm(!1),
        kX: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        xR: oe
    }, Rz = function(n) {
        switch(n){
            case 0:
                return "M";
            case 1:
            case 3:
                return "T";
            case 2:
                return "W";
            case 4:
                return "F";
            default:
                return "S";
        }
    }, Zz = function(n) {
        return A2(sc, h, A2(Fp, nz, n.cj));
    }, Vz = F3(function(n, r, t) {
        if (n) {
            if (r.$) return h;
            var e = r.a;
            return A2(Rc, function(n) {
                return i(ez(n), uz(e));
            }, t);
        }
        return t;
    }), Uz = F2(function(n, r) {
        return rv(A2(Rc, function(r) {
            return i(XP(r), n);
        }, r));
    }), Yz = F2(function(n, r) {
        var t = Zz(n), e = b(n.mG, TE(t));
        if (e.a.$ || e.b) return !0;
        var u = e.a.a, a = A2(Uz, r, t);
        if (a.$) return !0;
        var i = rz(a.a), c = A3(Vz, iz(Vt(u)), n.aS, i);
        return TE(c);
    }), Qz = function(n) {
        return m(Iz, {
            zh: Rz,
            zD: A2(nv, jP, A2(Fp, qP, n.mG)),
            AC: Yz(n)
        });
    }, Oz = {
        $: 0
    }, Gz = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return b(m(e, {
                    bU: Vt(u = r.a),
                    xb: u
                }), Oz);
            case 1:
                return b(m(e, {
                    bU: Vt(u = r.a)
                }), {
                    $: 2,
                    a: u
                });
            default:
                var u = r.a;
                return b(m(e, {
                    bU: Ut
                }), function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u));
        }
    }), Jz = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = m(r, {
                    aS: Vt(n.a)
                });
                return v(aF(r.am) ? t : oz(t), Pp, Ut);
            case 1:
                var e = n.a, u = A3(Gz, Qz(r), e, r.bQ), a = u.b, i = m(r, {
                    bQ: u.a
                });
                switch(a.$){
                    case 1:
                        return v(m(i, {
                            am: Vt(a.a)
                        }), Pp, Ut);
                    case 2:
                        var c = a.a;
                        return v(m(i, {
                            am: Ut
                        }), Pp, Vt({
                            $: 0,
                            a: c
                        }));
                    default:
                        return v(i, Pp, Ut);
                }
            default:
                return v(r, Pp, Vt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(n.a)));
        }
    }), Wz = F2(function(n, r) {
        return m(r, {
            mG: Vt(n)
        });
    }), Kz = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bH: t,
                    ae: A2(Wz, i = t.a, r.ae)
                }), RP(A2(iP, 4, oP)), h) : v(m(r, {
                    bH: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = n.a, u = n.b, a = b(r.bH, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = cz(c), f = ZP(i), s = m(r, {
                        ci: u
                    });
                    if (f && TE(o)) return v(s, A2(AA, da, ti), h);
                    var l = A2(Fp, uz, A2(nv, BP(o), A2(Fp, MP, r.iq)));
                    return v(m(s, {
                        ae: g = A6(vz, e, r.ck, i, c, l, r.ae)
                    }), Pp, h);
                }
                return v(m(r, {
                    ci: vc
                }), Pp, A2(xA, 0, u));
            case 2:
                if ((k = n.a).$) return v(m(r, {
                    ck: Ut
                }), Pp, h);
                if (1 === (y = k.a).$ && 4 === y.a) {
                    var d = A2(nv, Tz, y.b), p = A2(SP, d, r.ae);
                    if (p.$) return v(r, Pp, h);
                    var $ = p.a, g = $.a, w = A5(CP, r.c8, r.mH, r.nd, $.b, !0);
                    return v(m(r, {
                        ck: d,
                        ae: g
                    }), w, h);
                }
                return v(r, Pp, h);
            case 3:
                var k, y;
                return (k = n.a).$ ? v(r, Pp, h) : 2 === (y = k.a).$ && 4 === y.a ? v(m(r, {
                    ck: Ut
                }), Pp, h) : v(r, Pp, h);
            default:
                var _ = A2(Jz, n.a, r.ae), A = _.b, C = _.c, B = m(r, {
                    ae: g = _.a
                }), E = A2(Lp, EF, A);
                if (C.$) return v(B, E, h);
                var D = C.a;
                if (D.$) {
                    var q = D.a, F = b(B.bH, VP(r.ae));
                    if (3 !== F.a.$ || F.b.$) return v(B, E, h);
                    i = F.a.a;
                    var P = F.b.a, z = UP(r.ae);
                    if ((f = ZP(i)) && LP(z)) return v(B, E, h);
                    var j = A3(JP, q, P, A3(_z, f, z, A3(gz, fz(q), P, A2(sc, fP, B.ck)))), S = B.xs.iF;
                    return v(B, Vu(x([
                        Mz(j),
                        A2(AA, S, ga({
                            mH: r.mH,
                            nd: r.nd
                        }))
                    ])), h);
                }
                var L = EP(D.a);
                return v(m(B, {
                    ci: cP
                }), Vu(x([
                    E,
                    A5(CP, r.c8, r.mH, r.nd, zP(L), !1)
                ])), h);
        }
    }), Xz = function(n) {
        return A2(nk, x([
            Xx("my-4")
        ]), x([
            QD(n)
        ]));
    }, nj = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rj = F3(function(n, r, t) {
        var e = t;
        switch(n){
            case 0:
                return A3(rj, 1, 12 * r, e);
            case 1:
                var u = jv(e), a = 12 * (u.xQ - 1) + (_v(u.tb) - 1) + r, i = Bv(A2(jc, 12, a) + 1), c = A2(Dv, a, 12) + 1;
                return qv(c) + A2(lp, c, i) + A2(Kv, u.o0, A2(Cv, c, i));
            case 2:
                return e + 7 * r;
            default:
                return e + r;
        }
    }), tj = F2(function(n, r) {
        return r.$ ? n : r;
    }), ej = NB(2), uj = F2(function(n, r) {
        return Xx($(n.ev, r));
    }), aj = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, ij = F2(function(n, r) {
        return A2(jc, 7, Uv(r) + 7 - aj(n));
    }), cj = F2(function(n, r) {
        return qv(n) + A2(lp, n, r) + 1;
    }), oj = F2(function(n, r) {
        var t, e = r;
        switch(n){
            case 0:
                return Wk(Pv(r));
            case 1:
                return A2(cj, Pv(r), (t = Vv(r), Bv(3 * t - 2)));
            case 2:
                return A2(cj, Pv(r), Nv(r));
            case 3:
            case 4:
                return e - A2(ij, 0, r);
            case 5:
                return e - A2(ij, 1, r);
            case 6:
                return e - A2(ij, 2, r);
            case 7:
                return e - A2(ij, 3, r);
            case 8:
                return e - A2(ij, 4, r);
            case 9:
                return e - A2(ij, 5, r);
            case 10:
                return e - A2(ij, 6, r);
            default:
                return r;
        }
    }), fj = function(n) {
        switch(n){
            case 0:
                return b(1, 0);
            case 1:
                return b(3, 1);
            case 2:
                return b(1, 1);
            case 11:
                return b(1, 3);
            default:
                return b(1, 2);
        }
    }, sj = F2(function(n, r) {
        var t = A2(oj, n, r);
        if (i(r, t)) return r;
        var e = fj(n);
        return A3(rj, e.b, e.a, t);
    }), lj = F5(function(n, r, t, e, u) {
        for(;;){
            if (s(u, t) >= 0) return Ae(e);
            var a = A3(rj, n, r, u);
            e = A2(Yt, u, e), u = a;
        }
    }), dj = F4(function(n, r, t, e) {
        var u = t, a = e, i = fj(n), c = i.a, o = i.b, f = A2(sj, n, u);
        return 0 > s(f, a) ? A5(lj, o, A2(Ve, 1, r) * c, a, h, f) : h;
    }), bj = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(oj, t, A3(dp, Pv(n), Nv(n), 1)), u = A3(dp, Pv(n), Nv(n), 1);
        return {
            oQ: A4(dj, 11, 1, e, A2(sj, t, A3(rj, 1, 1, u))),
            oS: n
        };
    }), vj = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Yt, t, n), r -= 1;
        }
    }), mj = F2(function(n, r) {
        return A3(vj, h, n, r);
    }), pj = function(n) {
        return A2(br, "tabIndex", oe(n));
    }, $j = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Yt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), hj = F2(function(n, r) {
        return Ae(A3($j, n, r, h));
    }), gj = F3(function(n, r, t) {
        if (r > 0) {
            var e = b(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return x([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return x([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var c = e.b, o = c.b, f = o.b, s = f.b, l = s.b;
                                return A2(Yt, c.a, A2(Yt, o.a, A2(Yt, f.a, A2(Yt, s.a, n > 1e3 ? A2(hj, r - 4, l) : A3(gj, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return x([
                e.b.a
            ]);
        }
        return h;
    }), wj = F2(function(n, r) {
        return A3(gj, 0, n, r);
    }), xj = F2(function(n, r) {
        var t = n.ev;
        return SC(A2(Eu, function(n) {
            var r = n.b;
            return b($(t, n.a), r);
        }, r));
    }), kj = F5(function(n, r, t, e, u) {
        var a, i = n.AC(u), c = i ? h : x([
            IC((a = u, {
                $: 2,
                a: a
            }))
        ]), o = xj(n);
        return A2(nk, A2(Yt, o(x([
            b("day", !0),
            b("disabled", i),
            b("picked", r(u)),
            b("today", e(u)),
            b("other-month", t(u))
        ])), c), x([
            n.ka(oe(Mv(u)))
        ]));
    }), yj = F3(function(n, r, t) {
        var e, u, a = t.bU, c = t.xb, o = function(r) {
            return A2(sc, !1, A2(Fp, function(n) {
                return i(n, r);
            }, n));
        }, f = function(n) {
            return i(n, c);
        }, s = aj(r.hx) - 1, l = uj(r), d = A2(sc, c, A2(tj, n, a)), b = function(n) {
            return !i(Nv(d), Nv(n));
        }, v = F3(function(n, r, t) {
            if (r) return tB;
            var e = function() {
                switch(n){
                    case "prev":
                    default:
                        return 5;
                    case "next":
                        return 6;
                }
            }();
            return A2(PC, x([
                l(n),
                IC(t),
                pj(-1),
                Vq("button")
            ]), x([
                A2(PE, x([
                    ej,
                    MB("fill-primary-300"),
                    HB
                ]), e)
            ]));
        }), m = A2(bj, d, r.hx), p = m.oS, $ = m.oQ, g = A2(Eu, A4(kj, r, o, b, f), rc((e = $, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return Ae(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Yt, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = h, f = A2(Yt, Ae(A2(Yt, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, h, h)))), w = function() {
            var n = r.zD;
            if (n.$) return !1;
            var t = n.a;
            return i(Nv(t), Nv(p)) && i(Pv(t), Pv(p));
        }();
        return A2(nk, x([
            l("picker")
        ]), x([
            A2(nk, x([
                l("picker-header")
            ]), x([
                A2(nk, x([
                    l("month-container")
                ]), x([
                    ld(r.kX(Nv(p)) + " " + oe(Pv(p)))
                ])),
                A2(nk, x([
                    l("arrows-container")
                ]), x([
                    A3(v, "prev", w, nj(A3(rj, 1, -1, d))),
                    A3(v, "next", !1, nj(A3(rj, 1, 1, d)))
                ]))
            ])),
            A2(nk, x([
                l("calendar-grid")
            ]), rc(x([
                A2(Eu, function(n) {
                    return A2(nk, x([
                        l("dow")
                    ]), x([
                        ld(r.zh(n))
                    ]));
                }, A2(wj, 7, A2(Np, s, rc(A2(mj, 2, x([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ])))))),
                g
            ])))
        ]));
    }), _j = F3(function(n, r, t) {
        var e = t, u = A2(Yt, b(r.ev + "container", !0), r.kf);
        return A2(nk, x([
            SC(u)
        ]), x([
            A3(yj, n, r, e)
        ]));
    }), Aj = F2(function(n, r) {
        var t;
        return A2(nk, x([
            Xx("grid gap-4")
        ]), x([
            A2(nk, x([
                Xx("font-extrabold")
            ]), x([
                ld("Select a date & time")
            ])),
            A2(nk, x([
                Xx("justify-items-left")
            ]), x([
                A2(Ck, MF, A3(_j, n, Qz(r), r.bQ))
            ])),
            A2(nk, x([
                Xx("font-extrabold")
            ]), x([
                ld((t = n, A2(sc, "", A2(Fp, fp("EEEE, MMMM d"), t))))
            ]))
        ]));
    }), Cj = F2(function(n, r) {
        return !n.$ && i(uz(n.a), uz(r));
    }), Bj = F2(function(n, r) {
        return A2(Ju, BC(n), BC(r));
    }), Ej = F2(function(n, r) {
        var t, e = n ? "text-info-300 fill-info-300" : "text-info-200 fill-transparent";
        return A2(nk, x([
            Xx("flex items-center border border-info-200 rounded p-4 cursor-pointer gap-4"),
            IC((t = r, {
                $: 0,
                a: t
            })),
            SC(x([
                b("bg-info-100 text-info-300", n)
            ]))
        ]), x([
            A2(PE, x([
                MB(e)
            ]), 26),
            ld(BC(r))
        ]));
    }), Dj = function(n) {
        var r = A2(sc, h, A2(Fp, cz, n.cj));
        return iz(n.mG) && be(r) > 1 ? A2(nk, x([
            Xx("flex flex-col gap-2")
        ]), A2(Yt, A2(nk, x([
            Xx("mb-2 font-extrabold")
        ]), x([
            ld("Select a provider")
        ])), A2(Eu, function(r) {
            return A2(Ej, A2(Cj, n.aS, r), r);
        }, A2(eq, Bj, r)))) : tB;
    }, qj = F2(function(n, r) {
        return n.$ ? h : A2(sc, h, A2(Fp, rz, A2(Uz, n.a, r)));
    }), Fj = function(n) {
        var r;
        return A2(nk, x([
            Xx("border border-info-200 hover:border-primary-300 hover:text-primary-300 rounded p-4 cursor-pointer text-center"),
            IC((r = n, {
                $: 2,
                a: r
            }))
        ]), x([
            ld(A2(fe, " ", x([
                QP(n),
                YP(n)
            ])))
        ]));
    }, Pj = function(n) {
        var r = A2(qj, n.am, Zz(n)), t = A3(Vz, iz(n.mG), n.aS, r);
        return A2(nk, x([
            Xx("flex flex-col gap-2")
        ]), TE(r) ? x([
            ld("There are no available appointment times for the current month.")
        ]) : TE(t) ? x(n.am.$ ? [
            ld("Select a day to display available appointment times.")
        ] : [
            ld("There are no available appointment times for the selected day.")
        ]) : A2(Eu, Fj, t));
    }, zj = F2(function(n, r) {
        return A2(nk, x([
            Xx("flex flex-col gap-4")
        ]), x([
            Dj(r),
            A2(Aj, r.am, r),
            Pj(r),
            Xz(n)
        ]));
    }), jj = function(n) {
        return 3 === n.ci.$ ? A2(Ck, EF, A2(zj, n.dB, n.ae)) : A2(nk, h, ck);
    }, Sj = function(n) {
        var r, t = n.bH;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.ci).$ ? cz(r.a) : h, a = ZP(e) && 1 === be(u) ? A2(Fp, BC, UP(n.ae)) : Ut, i = qP(e);
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), x([
                A2($F, !1, {
                    eg: Ut,
                    yn: Vt(e),
                    nc: Vt(i),
                    t6: n.t6,
                    fq: a
                }),
                jj(n)
            ]));
        }
        return A2(nk, h, ck);
    }, Lj = function(n) {
        return n.a.mv;
    }, Mj = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("flex flex-col gap-4")
                ]), x([
                    (t = r.bH, 3 === t.$ ? _F(Lj(t.a)) : tB),
                    Sj(r)
                ]))
            ]),
            w5: "Booking"
        };
    }), Nj = ZA({
        Ar: QF,
        AQ: OF,
        Db: GF,
        DZ: function() {
            return Px(x([
                eP(JF),
                aP(WF)
            ]));
        },
        En: Kz,
        Et: Mj
    }), Hj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tj = function(n) {
        return 3 === n.a.i.$;
    }, Ij = function(n) {
        return n.rd;
    }, Rj = {
        $: 9
    }, Zj = {
        $: 0
    }, Vj = F6(function(n, r, t, e, u, a) {
        return {
            rh: r,
            CA: n,
            iu: u,
            iw: t,
            Dl: a,
            dQ: e
        };
    }), Uj = F2(function(n, r) {
        return r ? "Int'l" : "US";
    }), Yj = function(n) {
        return Vt(n ? "International" : "US");
    }, Qj = function(n) {
        return n.Cd;
    }, Oj = function(n) {
        return n.cI.l1;
    }, Gj = function(n) {
        return n.cI.Ah;
    }, Jj = function(n) {
        return n.cI.rQ;
    }, Wj = function(n) {
        return n.cI.Bf;
    }, Kj = function(n) {
        return n.cI.Bp;
    }, Xj = function(n) {
        return n.cI.C_;
    }, nS = function(n) {
        switch(n.$){
            case 0:
                return Wj;
            case 1:
                return Gj;
            case 2:
                return Kj;
            default:
                return Qj;
        }
    }, rS = function(n) {
        switch(n.$){
            case 0:
                return Vt("mobile");
            case 1:
                return Vt("home");
            case 2:
                return Vt("office");
            default:
                return Vt(n.a);
        }
    }, tS = F2(function(n, r) {
        var t = dd({
            rh: n + "-type",
            Eb: F2(function(n, r) {
                return n(nS(r));
            }),
            Ed: rS
        }), e = dd({
            rh: n + "-region" + n,
            Eb: Uj,
            Ed: Yj
        });
        return A6(Vj, r.CA, n, t, r.iv, e, r.hN ? 0 : 1);
    }), eS = function(n) {
        return {
            bk: n,
            pP: "",
            qB: "",
            rS: "",
            fb: "",
            uw: A2(tS, "enter-info-phone", {
                hN: !0,
                CA: "",
                iv: Zj
            })
        };
    }, uS = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), aS = function(n) {
        return A2(uS, 0, n);
    }, iS = function(n) {
        return {
            oY: Ut,
            cn: "",
            bm: aS("/"),
            eH: h,
            rh: n,
            dn: !1,
            vJ: !1,
            c$: !1
        };
    }, cS = "modal-scroll-content", oS = Wn("setupElementScroll", Ax), fS = F2(function(n, r) {
        var t = oS(cS);
        return b({
            By: r,
            fx: Ut,
            iM: n,
            bG: 1
        }, t);
    }), sS = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), lS = function(n) {
        return A2(sS, n, h);
    }, dS = {
        dn: !1,
        c$: !1
    }, bS = F2(function(n, r) {
        return b(r(n), dS);
    }), vS = F2(function(n, r) {
        return {
            wN: Ul(A2(Eu, function(n) {
                return A2(bS, n, r);
            }, n)),
            d0: r
        };
    }), mS = x([
        0,
        1,
        2,
        3,
        4,
        5
    ]), pS = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Date of Birth";
            case 3:
                return "Email";
            case 4:
                return "Phone";
            default:
                return "Notes";
        }
    }, $S = F2(function(n, r) {
        return m(r, {
            vJ: n
        });
    }), hS = F6(function(n, r, t, e, u, a) {
        var i = A2($S, !0, iS("dob"));
        return {
            eb: !1,
            gF: n,
            g8: t,
            cv: !1,
            ai: A2(fS, 0, Rj).a,
            aJ: e,
            kB: lS(eS(i)),
            hA: a,
            hL: u,
            ty: !1,
            CD: r,
            x: A2(vS, mS, pS)
        };
    }), gS = F3(function(n, r, t) {
        var e = Bx(n), u = A2(bp, r.fS, r.bj), a = !Tj(r.gF), i = A2(sc, !1, A2(Fp, Ij, uC(r.t6))), c = {
            mH: t.Ck.mH,
            bH: vc,
            ck: Ut,
            nd: t.Ck.nd,
            c8: r.yY.yG,
            g6: r.gF,
            kA: r.kA,
            t6: uC(r.t6),
            aQ: A6(hS, r.gF, e, u, !0, a, i),
            dB: n,
            lH: vc,
            xs: t
        };
        return b(c, oD(n) ? A4(SF, c.c8, c.mH, c.nd, Hj) : ED);
    }), wS = F2(function(n, r) {
        return b(r, Pp);
    }), xS = F2(function(n, r) {
        return m(r, {
            x6: Vt(9)
        });
    }), kS = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yS = function(n) {
        return {
            $: 3,
            a: n
        };
    }, _S = Vn, AS = function(n) {
        return {
            $: 11,
            a: n
        };
    }, CS = nr("onElementScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return uu({
                            mJ: u,
                            mM: e,
                            yX: t,
                            Dc: r,
                            v2: n
                        });
                    }, A2(Tu, "atBottom", jk));
                }, A2(Tu, "atTop", jk));
            }, A2(Tu, "clientHeight", q$));
        }, A2(Tu, "scrollHeight", q$));
    }, A2(Tu, "scrollTop", q$))), BS = function() {
        return Px(x([
            CS(iu)
        ]));
    }, ES = function() {
        return A2(_S, AS, BS());
    }, DS = function(n) {
        return {
            $: 4,
            a: n
        };
    }, qS = function(n) {
        return {
            $: 2,
            a: n
        };
    }, FS = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), PS = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), zS = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Ut;
        var r = +n;
        return r == r ? Vt(r) : Ut;
    }, jS = A2(im, function(n) {
        if (su(n) > 9) return jm("Expected at most 9 digits, but got " + oe(su(n)));
        var r = zS("0." + n);
        return r.$ ? jm('Invalid float: "' + n + '"') : lm(kp(1e3 * r.a));
    }, Hm(qm(ye))), SS = F6(function(n, r, t, e, u, a) {
        return Mp(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), LS = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MS = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NS = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(em, n || a, u.b);
            var a = u.a, i = u.b, c = u.c;
            if (i.$) return A3(um, n || a, i.a, c);
            n = n || a, r = i.a, e = c;
        }
    }), HS = F2(function(n, r) {
        return function(t) {
            return A4(NS, !1, n, r, t);
        };
    }), TS = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, IS = F2(function(n, r) {
        return A2(HS, n, function(n) {
            return A2(Vm, TS, r(n));
        });
    }), RS = function(n) {
        return A2(IS, "", function(r) {
            if (i(su(r), n)) {
                var t = pu(r);
                return t.$ ? jm('Invalid integer: "' + r + '"') : A2(Vm, LS, lm(t.a));
            }
            return A2(Vm, function(n) {
                return MS(A2(yA, r, n));
            }, Hm(Cm(ye)));
        });
    }, ZS = wm, VS = function(n) {
        return ZS(A2(dm, n, {
            $: 8,
            a: n
        }));
    }, US = function(n) {
        return jm("Invalid day: " + oe(n));
    }, YS = function(n) {
        return !(A2(jc, 4, n) || !A2(jc, 100, n) && A2(jc, 400, n));
    }, QS = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, OS = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return US(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !YS(r) ? e - 1 : e) + (QS(r) - QS(1970)));
            return lm(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? US(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !YS(r) ? US(e) : u(26784e5);
            case 3:
                return e > 31 ? US(e) : u(50976e5);
            case 4:
                return e > 30 ? US(e) : u(7776e6);
            case 5:
                return e > 31 ? US(e) : u(10368e6);
            case 6:
                return e > 30 ? US(e) : u(130464e5);
            case 7:
                return e > 31 ? US(e) : u(156384e5);
            case 8:
                return e > 31 ? US(e) : u(183168e5);
            case 9:
                return e > 30 ? US(e) : u(209952e5);
            case 10:
                return e > 31 ? US(e) : u(235872e5);
            case 11:
                return e > 30 ? US(e) : u(262656e5);
            case 12:
                return e > 31 ? US(e) : u(288576e5);
            default:
                return jm('Invalid month: "' + oe(t) + '"');
        }
    }, GS = A2(im, OS, A2(zm, A2(zm, A2(zm, lm(F3(function(n, r, t) {
        return v(n, r, t);
    })), RS(4)), Om(x([
        A2(zm, A2(sm, lm(iu), VS("-")), RS(2)),
        RS(2)
    ]))), Om(x([
        A2(zm, A2(sm, lm(iu), VS("-")), RS(2)),
        RS(2)
    ])))), JS = (i_ = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(zm, lm(iu), Om(x([
        A2(Vm, function() {
            return 0;
        }, VS("Z")),
        A2(zm, A2(zm, A2(zm, lm(i_), Om(x([
            A2(Vm, function() {
                return 1;
            }, VS("+")),
            A2(Vm, function() {
                return -1;
            }, VS("-"))
        ]))), RS(2)), Om(x([
            A2(zm, A2(sm, lm(iu), VS(":")), RS(2)),
            RS(2),
            lm(0)
        ]))),
        A2(sm, lm(0), Gm)
    ])))), WS = A2(im, function(n) {
        return Om(x([
            A2(zm, A2(zm, A2(zm, A2(zm, A2(zm, A2(sm, lm(SS(n)), VS("T")), RS(2)), Om(x([
                A2(zm, A2(sm, lm(iu), VS(":")), RS(2)),
                RS(2)
            ]))), Om(x([
                A2(zm, A2(sm, lm(iu), VS(":")), RS(2)),
                RS(2)
            ]))), Om(x([
                A2(zm, A2(sm, lm(iu), VS(".")), jS),
                lm(0)
            ]))), A2(sm, JS, Gm)),
            A2(sm, lm(A6(SS, n, 0, 0, 0, 0, 0)), Gm)
        ]));
    }, GS), KS = A2(nu, function(n) {
        var r = A2(ep, WS, n);
        return r.$ ? Sk("Expecting an ISO-8601 formatted date+time string") : uu(r.a);
    }, C$), XS = function(n) {
        switch(n){
            case "accepted":
                return uu(0);
            case "not_accepted":
                return uu(1);
            case "accepted_and_outdated":
                return uu(2);
            default:
                return Sk("Unsupported patient document status: " + n);
        }
    }, nL = function(n) {
        switch(n){
            case "click_box":
                return uu(0);
            case "type_name":
                return uu(1);
            default:
                return Sk("Unsupported patient document acceptance type: " + n);
        }
    }, rL = A3(ly, "name", A2(tu, RE, C$), uu(function(n) {
        return {
            tg: n
        };
    })), tL = A2(Pk, rL, uu(iu)), eL = F5(function(n, r, t, e, u) {
        return {
            ok: r,
            pv: t,
            rh: n,
            r4: e,
            xD: u
        };
    }), uL = function(n) {
        switch(n){
            case "text":
                return uu(0);
            case "file":
                return uu(1);
            case "link":
                return uu(2);
            default:
                return Sk("Unsupported document version type: " + n);
        }
    }, aL = function(n) {
        return P$(x([
            oy(Ut),
            A2(tu, Vt, n)
        ]));
    }, iL = A3(ly, "version_number", F$, A3(ly, "link_url", aL(C$), A3(ly, "document_version_type", A2(nu, uL, C$), A3(ly, "content", iy(C$), A3(ly, "id", C$, uu(eL)))))), cL = A2(Pk, A2(tu, iu, iL), uu(iu)), oL = A3(ly, "signed_document_version", iy(cL), A3(ly, "current_document_version", cL, A3(ly, "signed_at", iy(KS), A3(ly, "signee", tL, A3(ly, "status", A2(nu, XS, C$), A3(ly, "required", jk, A3(ly, "name", C$, A3(ly, "document_type", C$, A3(ly, "active", jk, A3(ly, "acceptance_type", A2(nu, nL, C$), A3(ly, "acceptance_text", C$, A3(ly, "document_id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        lT: r,
                                                        lU: t,
                                                        l0: e,
                                                        oR: s,
                                                        pt: n,
                                                        zt: u,
                                                        tg: a,
                                                        vJ: i,
                                                        wt: f,
                                                        wu: l,
                                                        wv: o,
                                                        wO: c
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), fL = A2(dD, 0, A2(Pk, oL, uu(PS))), sL = x([
        "member"
    ]), lL = function(n) {
        return A2(X_, x([
            "practices",
            n
        ]), sL);
    }, dL = function(n) {
        return A2(X_, x([
            "patient_documents"
        ]), lL(n));
    }, bL = J_("post"), vL = F2(function(n, r) {
        return m(r, {
            gN: Vt(n)
        });
    }), mL = F5(function(n, r, t, e, u) {
        var a = _x(x([
            b("document", e)
        ]));
        return A4(bL, n, fL, u, A2(vL, a, rA(A2(X_, x([
            t,
            "accept"
        ]), dL(r)))));
    }), pL = function(n) {
        return n.eg;
    }, $L = F2(function(n, r) {
        if (n) {
            var t = KP(r), e = KP(r);
            return LP(e) || LP(t);
        }
        return !1;
    }), hL = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2($L, n, t) || function(n) {
            var r = WP(n), t = pL(n), e = DP(n);
            return LP(e) || LP(t) || LP(r);
        }(t);
    }), gL = F3(function(n, r, t) {
        return {
            qZ: n,
            sq: t,
            tT: r
        };
    }), wL = A3(ly, "meet_url", C$, A3(ly, "outlook_link", C$, A3(ly, "google_link", C$, uu(gL)))), xL = A2(Pk, wL, uu(iu)), kL = function(n) {
        return n.fb;
    }, yL = F2(function(n, r) {
        return A2(sc, yx, A2(Fp, n, r));
    }), _L = F2(function(n, r) {
        return x([
            b("provider_id", A2(yL, Ax, KP(r))),
            b("booking_location_id", Ax(n)),
            b("date", A2(yL, Ax, WP(r))),
            b("notes", A2(yL, Ax, kL(r)))
        ]);
    }), AL = F3(function(n, r, t) {
        return _x(A2(Yt, b("patient_id", Ax(n)), A2(_L, r, t)));
    }), CL = F6(function(n, r, t, e, u, a) {
        return A4(bL, n, xL, a, A2(vL, A3(AL, r, e, u), rA(function(n) {
            return A2(X_, x([
                n
            ]), mD);
        }(t))));
    }), BL = function(n) {
        return n.a.rh;
    }, EL = function(n) {
        return n.rh;
    }, DL = function(n) {
        return n.pn;
    }, qL = function(n) {
        return n.pP;
    }, FL = function(n) {
        return n.a;
    }, PL = function(n) {
        return n.qB;
    }, zL = function(n) {
        return n.rS;
    }, jL = function(n) {
        return n.uw;
    }, SL = function(n) {
        var r = Zb(n.b);
        return A2(fe, r, x([
            "MM",
            "dd",
            "yyyy"
        ]));
    }, LL = function(n) {
        return $v(SL(n));
    }, ML = function(n) {
        var r = n.b;
        return $B(A2(h$, function(n) {
            return i(n, r) ? n : "#";
        }, LL(A2(uS, n.a, r))));
    }, NL = F2(function(n, r) {
        return A2(fp, SL(n), r);
    }), HL = F2(function(n, r) {
        n: for(;;){
            var t = b(n, r);
            r: for(;;){
                if (!t.a.b) {
                    if (t.b.b) return "";
                    break r;
                }
                if (!t.b.b) break r;
                var e = t.a, u = e.a, a = e.b, c = t.b, o = c.a, f = c.b;
                switch(o.$){
                    case 2:
                        return A2(sc, "", A2(Fp, function(n) {
                            return $(oe(n), A2(HL, a, f));
                        }, pu(Zb(u))));
                    case 1:
                        return $(Zb(u), A2(HL, a, f));
                    default:
                        if (i(o.a, u)) {
                            n = a, r = f;
                            continue n;
                        }
                        return "";
                }
            }
            return "";
        }
    }), TL = F2(function(n, r) {
        var t = n;
        return vu(r) ? "" : A2(HL, Lm(r), t);
    }), IL = F2(function(n, r) {
        var t = function() {
            if (n.$) return "";
            var t = n.a;
            return A2(TL, ML(r.bm), A2(NL, r.bm, t));
        }();
        return m(r, {
            oY: n,
            cn: t
        });
    }), RL = F2(function(n, r) {
        var t = A2(sc, "", kL(n)), e = m(FL(r.kB), {
            fb: t
        });
        if (r.aJ) return e;
        var u = A2(sc, "", jL(n)), a = A2(nv, B$, A2(Fp, uy, DL(n))), i = A2(IL, a, e.bk), c = A2(sc, "", zL(n)), o = A2(sc, "", PL(n));
        return m(e, {
            bk: i,
            pP: A2(sc, "", qL(n)),
            qB: o,
            rS: c,
            uw: A2(tS, "enter-info-phone", {
                hN: !0,
                CA: u,
                iv: Zj
            })
        });
    }), ZL = F2(function(n, r) {
        return n.$ ? r : m(r, {
            kB: lS(A2(RL, n.a, r))
        });
    }), VL = function(n) {
        return n.a.ty;
    }, UL = F7(function(n, r, t, e, u, a, i) {
        var c = A2($S, !0, iS("dob"));
        return {
            eb: !1,
            gF: n,
            g8: t,
            cv: !1,
            ai: A2(fS, 0, Rj).a,
            aJ: e,
            kB: lS(eS(c)),
            hA: a,
            hL: u,
            ty: VL(i),
            CD: r,
            x: A2(vS, mS, pS)
        };
    }), YL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QL = function(n) {
        return {
            $: 0,
            a: n
        };
    }, OL = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), GL = function(n) {
        return {
            $: 4,
            a: n
        };
    }, JL = function(n) {
        return {
            $: 4,
            a: n
        };
    }, WL = function(n) {
        return m(n, {
            bG: 1
        });
    }, KL = function(n) {
        return n.oY;
    }, XL = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    qB: n.a
                });
            case 1:
                return m(r, {
                    rS: n.a
                });
            case 2:
                return m(r, {
                    bk: n.a
                });
            case 3:
                return m(r, {
                    pP: n.a
                });
            case 4:
                return m(r, {
                    uw: n.a
                });
            default:
                return m(r, {
                    fb: n.a
                });
        }
    }), nM = function(n) {
        return function(r) {
            return A3(de, F2(function(n, t) {
                return $(t, n(r));
            }), h, n);
        };
    }, rM = F2(function(n, r) {
        return function(t) {
            var e;
            return e = r(t), A2(n, e, t);
        };
    }), tM = function(n) {
        return n.bk;
    }, eM = function(n) {
        return b(1, n);
    }, uM = F2(function(n, r) {
        return r.vL(n);
    }), aM = function(n) {
        return n.bk.oY.$ ? x([
            b(2, eM(A2(rM, uM, tM)))
        ]) : h;
    }, iM = function(n) {
        return n.pP;
    }, cM = F2(function(n, r) {
        return r.rq(n);
    }), oM = A2(ru, Wb, sc(Kb)), fM = function(n) {
        return A2(k$, oM("^\\s*$"), n);
    }, sM = A2(sc, Kb, A2(Jb, {
        yL: !0,
        Bg: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")), lM = function(n) {
        return A2(k$, sM, n);
    }, dM = function(n) {
        return b(0, n);
    }, bM = function(n) {
        var r = n.pP;
        return fM(r) ? x([
            b(3, eM(A2(rM, uM, iM)))
        ]) : lM(r) ? h : x([
            b(3, dM(A2(rM, cM, iM)))
        ]);
    }, vM = function(n) {
        return n.cF.qB;
    }, mM = function(n) {
        return n.cF.rS;
    }, pM = function(n) {
        return n.cF.s2;
    }, $M = function(n) {
        return n.cF.wY;
    }, hM = function(n) {
        return n.cF.w5;
    }, gM = function(n) {
        return n.cF.D9;
    }, wM = function(n) {
        return fM(n.qB) ? x([
            b(0, eM(A2(rM, uM, vM)))
        ]) : h;
    }, xM = function(n) {
        return fM(n.rS) ? x([
            b(1, eM(A2(rM, uM, mM)))
        ]) : h;
    }, kM = F2(function(n, r) {
        return n && fM(r.fb) ? x([
            b(5, eM(pA("The above field is required")))
        ]) : h;
    }), yM = F2(function(n, r) {
        if (r) return !1;
        var t = wB(n);
        return su(t) > 0 && !i(su(hB), su(t));
    }), _M = function(n) {
        var r = n.uw;
        return fM(r.CA) || A2(yM, r.CA, r.Dl) ? x([
            b(4, eM(A2(rM, uM, Jj)))
        ]) : h;
    }, AM = F2(function(n, r) {
        return nM(n ? r ? x([
            kM(r)
        ]) : h : x(r ? [
            wM,
            xM,
            aM,
            bM,
            _M,
            kM(r)
        ] : [
            wM,
            xM,
            aM,
            bM,
            _M
        ]));
    }), CM = F2(function(n, r) {
        var t = n(r);
        return t.b ? Kt(t) : te(r);
    }), BM = F2(function(n, r) {
        var t = r.a, e = A2(CM, n, t);
        if (e.$) return Kt(A2(sS, t, e.a));
        var u = e.a;
        return te(b(A2(sS, t, h), u));
    }), EM = function(n) {
        var r = A2(BM, A2(AM, n.aJ, n.ty), n.kB);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, DM = function(n) {
        return EM(n).b;
    }, qM = F2(function(n, r) {
        var t = r.wN, e = A2(Wu, (0, r.d0)(n), t);
        return !e.$ && e.a.dn;
    }), FM = F3(function(n, r, t) {
        var e, u = t.d0(r);
        return m(t, {
            wN: (e = A2(Wu, u, t.wN), e.$ ? t.wN : A3(ta, u, {
                dn: e.a.dn,
                c$: n
            }, t.wN))
        });
    }), PM = F2(function(n, r) {
        return {
            dn: n,
            c$: r
        };
    }), zM = F2(function(n, r) {
        if (-2 === r.$) return Xu;
        var t = r.b, e = r.d, u = r.e;
        return A5(Ku, r.a, t, A2(n, t, r.c), A2(zM, n, e), A2(zM, n, u));
    }), jM = function(n) {
        return m(n, {
            wN: A2(zM, cm(function() {
                return A2(PM, !0, !0);
            }), n.wN)
        });
    }, SM = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: EM(r).a,
            x: t
        });
    }), LM = function(n) {
        switch(n.$){
            case 0:
                return Vt(0);
            case 1:
                return Vt(1);
            case 2:
                return Vt(2);
            case 3:
                return Vt(3);
            case 4:
                return Vt(4);
            default:
                return Vt(5);
        }
    }, MM = F2(function(n, r) {
        var t = LM(n);
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(SM, !1, r), {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), NM = function(n) {
        return m(n, {
            bG: 0
        });
    }, HM = function(n) {
        return n.CA;
    }, TM = {
        $: 2
    }, IM = {
        $: 1
    }, RM = F3(function(n, r, t) {
        for(;;){
            var e = A2(Ye, qe, n), u = e.a, a = e.b;
            if (0 > s(Ze(u), qe)) return A2(Je, !0, {
                L: r,
                D: t,
                H: u
            });
            n = a, r = A2(Yt, Ne(u), r), t += 1;
        }
    }), ZM = 4294967295 >>> 32 - Se, VM = u, UM = F3(function(n, r, t) {
        for(;;){
            var e = A2(VM, ZM & r >>> n, t);
            if (e.$) return A2(VM, ZM & r, e.a);
            n -= Se, t = e.a;
        }
    }), YM = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || s(n, t) > -1 ? Ut : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? Vt(A2(VM, ZM & n, a)) : Vt(A3(UM, e, n, u));
    }), QM = x([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]), OM = function(n) {
        var r;
        return A2(YM, n - 1, (r = QM).b ? A3(RM, r, h, 0) : Le);
    }, GM = F3(function(n, r, t) {
        return {
            o0: r,
            tb: n,
            xQ: t
        };
    }), JM = F2(function(n, r) {
        return i(su(r), n) ? lm(r) : jm("Date part is invalid.");
    }), WM = function(n) {
        return A2(im, JM(n), Hm(qm(ye)));
    }, KM = F2(function(n, r) {
        var t, e = (t = Zb(n.b), A2(zm, A2(zm, A2(zm, lm(GM), A2(sm, WM(2), VS(t))), A2(sm, WM(2), VS(t))), A2(sm, WM(4), Gm))), u = A2(ep, e, r);
        if (u.$) return Kt("Invalid Date");
        var a = u.a;
        return function(n) {
            var r = n.te, t = n.o4, e = pu(n.xS), u = A2(nv, OM, pu(r)), a = v(pu(t), u, e);
            return a.a.$ || a.b.$ || a.c.$ ? Kt("Invalid Date") : te(A3(dp, a.c.a, a.b.a, a.a.a));
        }({
            o4: a.o0,
            te: a.tb,
            xS: a.xQ
        });
    }), XM = function(n) {
        return n.oY;
    }, nN = function(n) {
        return eM(A2(rM, uM, n));
    }, rN = function(n) {
        return dM(A2(rM, cM, n));
    }, tN = function(n) {
        return n.oY.$ && n.vJ ? fM(n.cn) ? x([
            nN(XM)
        ]) : x([
            rN(XM)
        ]) : h;
    }, eN = F2(function(n, r) {
        return m(r, {
            eH: tN(r),
            dn: r.dn || n,
            c$: r.c$ || n
        });
    }), uN = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = B$(A2(KM, r.bm, A2(lB, ML(r.bm), t))), u = function(n) {
                    return n.c$ ? A2(eN, !0, n) : m(n, {
                        dn: !0
                    });
                }(m(r, {
                    oY: e,
                    cn: t
                })), a = A2(sc, "", A2(Fp, FP, e)), c = i(a, A2(sc, "", A2(Fp, FP, r.oY))) ? Ut : Vt({
                    $: 0,
                    a: a
                });
                return v(u, Pp, c);
            case 1:
                return v(u = r.dn ? A2(eN, !0, r) : r, Pp, Vt(TM));
            default:
                return v(r, Pp, Vt(IM));
        }
    }), aN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cN = su(A2(kB, function(n) {
        return "#" === n;
    }, hB)), oN = F2(function(n, r) {
        return !r && s(su(n), cN) > 0 ? A2(mu, cN, n) : n;
    }), fN = Zj, sN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    CA: n.a
                }), Pp);
            case 1:
                var t = A2(ZD, n.a, r.iw), e = t.b;
                return b(m(r, {
                    iw: i = t.a,
                    dQ: c = (u = t.c).$ || u.a.$ ? r.dQ : A2(sc, fN, u.a.a)
                }), A2(Lp, iN, e));
            case 2:
                var u, a = A2(ZD, n.a, r.iu), i = a.a, c = (e = a.b, (u = a.c).$ || u.a.$ ? r.Dl : A2(sc, 0, u.a.a));
                return b(m(r, {
                    CA: A2(oN, r.CA, r.Dl),
                    iu: i,
                    Dl: c
                }), A2(Lp, aN, e));
            default:
                return b(r, Pp);
        }
    }), lN = F2(function(n, r) {
        return b(m(r, {
            fx: Vt(n)
        }), Pp);
    }), dN = F3(function(n, r, t) {
        var e = t.b;
        return A2(sS, A2(n, r, t.a), e);
    }), bN = F2(function(n, r) {
        var t = r.wN, e = A2(Wu, (0, r.d0)(n), t);
        return !e.$ && e.a.c$;
    }), vN = F3(function(n, r, t) {
        var e, u = t.d0(r);
        return m(t, {
            wN: (e = A2(Wu, u, t.wN), e.$ ? t.wN : A3(ta, u, {
                dn: n,
                c$: e.a.c$
            }, t.wN))
        });
    }), mN = F2(function(n, r) {
        var t = LM(n);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: EM(r).a
        }) : a;
    }), pN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(c = A2(mN, t = n.a, m(r, {
                    kB: A3(dN, XL, t, r.kB)
                })), Pp, Ut);
            case 1:
                var t;
                return v(A2(MM, t = n.a, r), Pp, Ut);
            case 2:
                return v(r, Pp, Ut);
            case 3:
                var e = n.a, u = FL(r.kB), a = A2(uN, e, u.bk), i = a.c, c = m(r, {
                    kB: A3(dN, XL, (w = a.a, {
                        $: 2,
                        a: w
                    }), r.kB)
                });
                return v($ = i.$ || 2 !== i.a.$ ? c : A2(SM, !1, c), Pp, Ut);
            case 4:
                var o = n.a, f = FL(r.kB), s = A2(sN, o, f.uw), l = s.a, d = s.b, b = (c = m(r, {
                    kB: A3(dN, XL, GL(l), r.kB)
                }), GL(l)), p = function() {
                    switch(o.$){
                        case 0:
                            return A2(Nu, iu, _u(QL(b)));
                        case 3:
                            return A2(Nu, iu, _u(YL(b)));
                        default:
                            return Pp;
                    }
                }();
                return v(c, Vu(x([
                    A2(Lp, JL, d),
                    p
                ])), Ut);
            case 5:
                var $ = A2(SM, !0, r);
                return i = function() {
                    if (DM($)) {
                        var n = FL(r.kB), t = {
                            pn: Ut,
                            pP: Ut,
                            qB: Ut,
                            rS: Ut,
                            fb: Vt(n.fb),
                            uw: Ut
                        }, e = function() {
                            if (r.aJ) return t;
                            var n = FL(r.kB), e = n.qB, u = n.rS, a = n.pP, i = n.uw, c = KL(n.bk), o = HM(i);
                            return m(t, {
                                pn: c,
                                pP: Vt(a),
                                qB: Vt(e),
                                rS: Vt(u),
                                uw: Vt(o)
                            });
                        }();
                        return Vt(A2(OL, e, r.cv));
                    }
                    return Ut;
                }(), v(r, Pp, i);
            case 6:
                return v(m(r, {
                    eb: n.a
                }), Pp, Ut);
            case 7:
                return v(m(r, {
                    cv: n.a
                }), Pp, Ut);
            case 8:
                return v(m(r, {
                    ai: NM(r.ai)
                }), Pp, Ut);
            case 9:
                return v(m(r, {
                    ai: WL(r.ai)
                }), Pp, Ut);
            case 10:
                return v(m(r, {
                    cv: !0,
                    ai: WL(r.ai)
                }), Pp, Ut);
            default:
                var h = A2(lN, n.a, r.ai), g = h.b;
                return v(m(r, {
                    ai: h.a
                }), A2(Lp, AS, g), Ut);
        }
        var w;
    }), $N = F2(function(n, r) {
        return m(r, {
            pn: n
        });
    }), hN = F2(function(n, r) {
        return m(r, {
            pP: n
        });
    }), gN = F2(function(n, r) {
        return m(r, {
            qB: n
        });
    }), wN = F2(function(n, r) {
        return m(r, {
            rS: n
        });
    }), xN = F2(function(n, r) {
        return m(r, {
            fb: n
        });
    }), kN = F2(function(n, r) {
        return m(r, {
            uw: n
        });
    }), yN = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    bH: t
                });
                return 3 === t.$ ? v(e, RP(A2(iP, 4, oP)), h) : v(r, Pp, A2(xA, 0, t));
            case 1:
                var u = n.a;
                if (u.$) return v(m(r, {
                    ck: Ut
                }), Pp, h);
                var a = u.a;
                if (1 === a.$ && 4 === a.a) {
                    var i = a.b, c = r.bH;
                    if (3 === c.$) {
                        var o = ZP(B = c.a), f = A2(nv, Tz, i), s = A2(ZL, f, A7(UL, r.g6, Bx(r.dB), r.aQ.g8, r.aQ.aJ, r.aQ.hL, r.aQ.hA, B)), l = function() {
                            if (A2(hL, o, f)) {
                                var n = SD(qP(B)), t = BL(B);
                                return A2(AA, r.xs.iF, ni({
                                    mH: t,
                                    nd: n
                                }));
                            }
                            return Pp;
                        }();
                        return v(m(r, {
                            ck: f,
                            aQ: s
                        }), l, h);
                    }
                    return v(r, Pp, h);
                }
                return v(r, Pp, h);
            case 3:
                var d = A2(pN, n.a, r.aQ), p = d.b, $ = d.c, g = (e = m(r, {
                    aQ: s = d.a
                }), A2(Lp, yS, p));
                if ($.$) return v(e, g, h);
                var w = $.a, k = w.a, y = w.b, _ = Vt(A2(xN, k.fb, A2(kN, k.uw, A2(hN, k.pP, A2($N, A2(Fp, zP, k.pn), A2(wN, k.rS, A2(gN, k.qB, A2(sc, fP, r.ck)))))))), A = v(_, r.bH, r.t6);
                if (A.a.$ || 3 !== A.b.$ || A.c.$) return v(e, g, h);
                var C = A.a.a, B = A.b.a, E = A.c.a, D = function() {
                    if (y) {
                        var n = _x(x([
                            b("signature", Ax("")),
                            b("acceptance_type", Ax("checkbox")),
                            b("accepted", LC(!0))
                        ]));
                        return A5(mL, r.g6, Bx(r.dB), "ephi_waiver", n, DS);
                    }
                    return Pp;
                }(), q = SD(qP(B)), F = BL(B), P = A6(CL, r.c8, EL(E), F, q, C, qS);
                return v(m(r, {
                    ck: _,
                    lH: cP
                }), Vu(x([
                    g,
                    Mz(C),
                    P,
                    D
                ])), h);
            case 2:
                var z = n.a;
                switch(e = m(r, {
                    lH: z
                }), z.$){
                    case 3:
                        return v(e, RP(A2(FS, 4, oP)), h);
                    case 2:
                        var j = z.a;
                        return v(e, Pp, 5 === j.$ && 400 === j.a ? h : x([
                            A2($A, 1, vA)
                        ]));
                    default:
                        return v(e, Pp, h);
                }
            default:
                return v(r, Pp, h);
        }
    }), _N = function(n) {
        return {
            $: 6,
            a: n
        };
    }, AN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CN = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), BN = A2(CN, AN(3), Vt(2)), EN = F2(function(n, r) {
        return b(n, r);
    }), DN = function(n) {
        return n.qZ;
    }, qN = function(n) {
        return n.tT;
    }, FN = function(n) {
        switch(n.$){
            case 0:
                return n.a;
            case 4:
                return gk(n.a);
            case 5:
                return A2(xk, r = n.a, n.b);
            case 6:
                return $k(n.a);
            case 7:
                return A2(wk, r = n.a, n.b);
            case 2:
                return x([
                    Xx("md:flex-1")
                ]);
            case 3:
                return x([
                    Xx("md:w-auto")
                ]);
            case 1:
                var r = n.a, t = n.b, e = "w-" + (12 === t ? "full" : oe(t) + "/12");
                return x([
                    Xx($(bk(r), e))
                ]);
            case 8:
                return x([
                    Xx("card")
                ]);
            case 11:
                return x([
                    Xx("card list-row")
                ]);
            case 9:
                return x([
                    Xx("card--success")
                ]);
            case 10:
                return x([
                    Xx("card--warning")
                ]);
            default:
                return x([
                    Xx("bg-primary-100")
                ]);
        }
    }, PN = function(n) {
        var r = n.a, t = n.b;
        return A2(nk, A2(Yt, Xx("column"), function(n) {
            return A2(Eu, ek(yu), A2(tc, FN, n));
        }(r)), t);
    }, zN = F2(function(n, r) {
        return A2(nk, A2(Yt, Xx("row"), function(n) {
            return A2(Eu, ek(yu), A2(tc, FN, n));
        }(n)), A2(Eu, PN, r));
    }), jN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, SN = {
        $: 4
    }, LN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MN = {
        $: 1
    }, NN = br("rel"), HN = Kx("target"), TN = function(n) {
        switch(n.$){
            case 0:
                return x([
                    yB(n.a)
                ]);
            case 1:
                return x([
                    HN("_blank"),
                    NN("noopener")
                ]);
            case 2:
                return x([
                    Xx("text-current")
                ]);
            case 3:
                return x([
                    Xx(n.a)
                ]);
            case 4:
                return x([
                    Xx("button button--secondary")
                ]);
            case 5:
                return x([
                    Xx("button button--primary text-white hover:text-white")
                ]);
            case 6:
                return x([
                    Xx("button button--profile")
                ]);
            case 7:
                return x([
                    Xx("button--round")
                ]);
            case 8:
                return x([
                    Xx("link--mobile-hidden")
                ]);
            case 9:
                return x([
                    pj(0)
                ]);
            case 10:
                return x([
                    Xx("w-full")
                ]);
            case 11:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
            default:
                return x([
                    IC(n.a)
                ]);
        }
    }, IN = F2(function(n, r) {
        var t = A2(tc, TN, n);
        return A2(fB, A2(Yt, Xx("link"), t), A2(Eu, Ck(yu), r));
    }), RN = F2(function(n, r) {
        return vu(n) ? tB : A2(IN, x([
            SN,
            LN(n),
            MN
        ]), x([
            A2(PE, x([
                HB,
                MB("text-primary-500")
            ]), 27),
            A2(ak, h, x([
                ld(r)
            ]))
        ]));
    }), ZN = F4(function(n, r, t, e) {
        return $(A3(lu, 0, r, e), $(n, A3(lu, t, su(e), e)));
    }), VN = F2(function(n, r) {
        var t = A2(sc, !0, A2(Fp, vu, A2(nv, function(n) {
            return n.iF;
        }, ku(n))));
        return $(n, A4(ZN, t ? "?" : "&", 0, 1, R_(r)));
    }), UN = function(n) {
        return A2(Y_, n.a, n.b);
    }, YN = function(n) {
        return A2(Eu, UN, Ot(n));
    }, QN = F2(function(n, r) {
        return A2(VN, r, YN(n));
    }), ON = {
        $: 5
    }, GN = F3(function(n, r, t) {
        return A2(IN, x([
            ON,
            LN(A2(QN, n, r)),
            MN
        ]), x([
            ld(t)
        ]));
    }), JN = F3(function(n, r, t) {
        var e = A2(Fp, function(n) {
            return A2(xu, "http://", n) || A2(xu, "https://", n) ? n : "https://" + n;
        }, t.a.vt), u = t.a.vs, a = function() {
            var r = b(e, u);
            if (r.a.$ || r.b.$) return h;
            var t = r.a.a, a = r.b.a;
            return x([
                A2(EN, x([
                    _N(DB),
                    jN(BN)
                ]), x([
                    A3(GN, n, t, a)
                ]))
            ]);
        }(), i = Lj(t) ? x([
            A2(EN, x([
                _N(DB),
                jN(BN)
            ]), x([
                A2(RN, DN(r), "Add to Google Calendar")
            ])),
            A2(EN, x([
                _N(DB),
                jN(BN)
            ]), x([
                A2(RN, qN(r), "Add to Outlook Calendar")
            ]))
        ]) : h;
        return A2(zN, h, $(a, i));
    }), WN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, KN = function(n) {
        return WN(n);
    }, XN = cr("h3"), nH = eB(2), rH = F2(function(n, r) {
        return A2(XN, _k(A2(Yt, aq, A2(Yt, nH, n))), r);
    }), tH = function(n) {
        var r = vF(n);
        return A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Appointment")
                ])),
                A2(Ek, h, x([
                    ld(r)
                ]))
            ]))
        ]));
    }, eH = function(n) {
        var r = A2(sc, "", pL(n));
        return A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Date & Time")
                ])),
                A2(Ek, h, x([
                    ld(r)
                ]))
            ]))
        ]));
    }, uH = {
        $: 2
    }, aH = A2(CN, uH, Ut), iH = NB(3), cH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oH = A2(zN, x([
        KN(x([
            Xx("mt-6")
        ]))
    ]), x([
        A2(EN, x([
            _N(DB)
        ]), x([
            A2(PE, x([
                iH,
                MB("fill-primary-300 scale-[2.66]"),
                cH(aH)
            ]), 8)
        ]))
    ])), fH = F2(function(n, r) {
        var t = n.sq;
        if (vu(t)) {
            var e = A2(sc, "", $C(qP(r)));
            return A2(Ek, h, x([
                ld(e)
            ]));
        }
        return A2(IN, x([
            LN(t),
            MN
        ]), x([
            ld(t)
        ]));
    }), sH = F2(function(n, r) {
        return A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Location")
                ])),
                A2(fH, n, r)
            ]))
        ]));
    }), lH = function(n) {
        var r = A2(sc, "", kL(n));
        return vu(r) ? tB : A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Notes")
                ])),
                A2(Ek, h, x([
                    ld(r)
                ]))
            ]))
        ]));
    }, dH = function(n) {
        return n.fq;
    }, bH = F2(function(n, r) {
        var t = n ? A2(sc, "", dH(r)) : "A provider with availability will be assigned";
        return A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Provider")
                ])),
                A2(Ek, h, x([
                    ld(t)
                ]))
            ]))
        ]));
    }), vH = function(n) {
        return Lj(n) ? "An email with appointment details has been sent to you." : "You\u2019ll receive an email when your appointment is confirmed.";
    }, mH = function(n) {
        return Lj(n) ? "Your appointment is confirmed." : "Your request was submitted.";
    }, pH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $H = pH(1), hH = function(n) {
        return A2(zN, x([
            KN(x([
                Xx("flex flex-col gap-4 mb-1")
            ]))
        ]), x([
            A2(EN, x([
                _N(DB)
            ]), x([
                A2(Ek, x([
                    lk
                ]), x([
                    ld(mH(n))
                ]))
            ])),
            A2(EN, h, x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(vH(n))
                ]))
            ]))
        ]));
    }, gH = function(n) {
        if (n.$) return tB;
        var r = ZE(n.a);
        return A2(zN, h, x([
            A2(EN, x([
                KN(x([
                    Xx("flex flex-col gap-2")
                ]))
            ]), x([
                A2(rH, h, x([
                    ld("Member")
                ])),
                A2(Ek, h, x([
                    QE(r)
                ]))
            ]))
        ]));
    }, wH = F5(function(n, r, t, e, u) {
        var a = ZP(n);
        return A2(nk, x([
            Xx("flex flex-col gap-4")
        ]), x([
            oH,
            hH(n),
            gH(e),
            eH(r),
            A2(sH, t, n),
            tH(n),
            A2(bH, a, r),
            lH(r),
            A3(JN, u, t, n)
        ]));
    }), xH = F2(function(n, r) {
        return A2(xu, n, _A(r));
    }), kH = function(n) {
        return A2(xH, "/booking", n);
    }, yH = F2(function(n, r) {
        return $(A2(fe, "/", n), R_(r));
    }), _H = function(n) {
        return {
            $: 5,
            a: n
        };
    }, AH = F3(function(n, r, t) {
        var e = lc(r), u = SD(qP(n)), a = BL(n), i = kH(e) ? ni({
            mH: a,
            nd: u
        }) : ha({
            mH: a,
            nd: u
        }), c = A2(yH, x([
            _A(i)
        ]), YN(t));
        return A2(nk, x([
            Xx("booking-appointment-not-available")
        ]), x([
            A2(nk, x([
                Xx("relative bg-white rounded top-1/4 mx-8 p-5 opacity-100")
            ]), x([
                A2(zN, x([
                    _N(DB)
                ]), x([
                    A2(EN, h, x([
                        A2(yC, h, x([
                            ld("Time slot unavailable")
                        ])),
                        A2(Ek, x([
                            aq,
                            _H(BN)
                        ]), x([
                            ld("The selected time slot is no longer available. Please choose a different time or check for the latest availability and try again.")
                        ])),
                        A2(IN, x([
                            SN,
                            LN(c)
                        ]), x([
                            ld("Select time")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), CH = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(AH, t, r.CS, r.iF) : tB;
    }), BH = function(n) {
        return 1 === n.$;
    }, EH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, DH = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qH = function(n) {
        return {
            $: 8,
            a: n
        };
    }, FH = F2(function(n, r) {
        var t = r.b;
        return i(n, r.a) ? Vt(t) : Ut;
    }), PH = F2(function(n, r) {
        var t = r.b;
        return A2(Tp, FH(n), t);
    }), zH = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), jH = "patient-details-form", SH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LH = function(n) {
        return {
            $: 6,
            a: n
        };
    }, MH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HH = A2(ru, NH, MH), TH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, IH = function(n) {
        return {
            $: 4,
            a: n
        };
    }, RH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZH = function(n) {
        return {
            $: 7,
            a: n
        };
    }, VH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, UH = function(n) {
        return {
            $: 11,
            a: n
        };
    }, YH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QH = F2(function(n, r) {
        return !TE(A2(PH, n, r));
    }), OH = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), GH = function(n) {
        return {
            $: 5,
            a: n
        };
    }, JH = Kx("htmlFor"), WH = F2(function(n, r) {
        return A2(Tq, _k(A2(Yt, nH, n)), A2(Eu, Ck(yu), r));
    }), KH = F3(function(n, r, t) {
        if (n.$) return tB;
        var e = n.a, u = e.$ ? QE(e.a) : ld(e.a), a = t.$ ? h : x([
            JH(t.a)
        ]);
        return A2(WH, x([
            ok(A2(Yt, Xx("form-group__label"), A2(Yt, SC(x([
                b("form-group__label--required", r)
            ])), a)))
        ]), x([
            u
        ]));
    }), XH = F2(function(n, r) {
        var t = function(n) {
            var r = {
                ew: h,
                pe: Ut,
                hy: Ut,
                rQ: Ut,
                vJ: !1
            };
            return A3(de, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            pe: Vt(n.a)
                        });
                    case 1:
                        return m(r, {
                            rQ: Vt(n.a)
                        });
                    case 2:
                        return m(r, {
                            vJ: n.a
                        });
                    case 3:
                        return m(r, {
                            ew: $(r.ew, x([
                                "h-full"
                            ]))
                        });
                    default:
                        return m(r, {
                            hy: Vt(n.a)
                        });
                }
            }), r, n);
        }(n), e = A2(fe, " ", t.ew);
        return A2(nk, x([
            Xx("form-group"),
            Xx(e)
        ]), A2(Yt, A2(nk, x([
            Xx("flex justify-between"),
            SC(x([
                b("mb-2 md:mb-3", aF(t.rQ))
            ]))
        ]), x([
            A3(KH, t.rQ, t.vJ, t.hy)
        ])), A2(Yt, function(n) {
            if (n.$) return tB;
            var r = n.a;
            return A2(Ek, x([
                $H,
                ok(x([
                    Xx("-mt-1 mb-2 md:mb-3")
                ]))
            ]), x([
                ld(r)
            ]));
        }(t.pe), r)));
    }), nT = x([
        A2(jC, "data-gramm_editor", "false"),
        A2(jC, "data-gramm", "false"),
        A2(jC, "data-enable-grammarly", "false")
    ]), rT = {
        j8: nT,
        eH: h,
        Ax: !1,
        lQ: h
    }, tT = x([
        VE,
        A2(jC, "data-recording-ignore", "mask")
    ]), eT = function(n) {
        return A2(TC, "blur", uu(n));
    }, uT = function(n) {
        return A2(TC, "focus", uu(n));
    }, aT = function(n) {
        return b(n, !0);
    }, iT = F2(function(n, r) {
        return A2(HC, n, {
            $: 1,
            a: r
        });
    }), cT = A2(By, x([
        "target",
        "value"
    ]), C$), oT = function(n) {
        return A2(iT, "input", A2(tu, aT, A2(tu, n, cT)));
    }, fT = Kx("placeholder"), sT = function(n) {
        switch(n){
            case 0:
                return "resize-none";
            case 1:
                return "resize-x";
            case 2:
                return "resize-y";
            default:
                return "resize";
        }
    }, lT = function(n) {
        return A2(br, "rows", oe(n));
    }, dT = lr, bT = dT, vT = cr("textarea"), mT = function(n) {
        var r = function(n) {
            return A3(de, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            j8: A2(Yt, Hq(n.a), r.j8)
                        });
                    case 1:
                        return m(r, {
                            j8: A2(Yt, lT(n.a), r.j8)
                        });
                    case 2:
                        return m(r, {
                            j8: A2(Yt, oT(n.a), r.j8)
                        });
                    case 3:
                        return m(r, {
                            j8: A2(Yt, eT(n.a), r.j8)
                        });
                    case 4:
                        return m(r, {
                            j8: A2(Yt, uT(n.a), r.j8)
                        });
                    case 5:
                        return m(r, {
                            j8: A2(Yt, Iq(n.a), r.j8)
                        });
                    case 6:
                        return m(r, {
                            j8: A2(Yt, SC(x([
                                b("feedback-errored", t = n.a)
                            ])), r.j8),
                            Ax: t
                        });
                    case 7:
                        return m(r, {
                            j8: A2(Yt, fT(n.a), r.j8)
                        });
                    case 8:
                        return m(r, {
                            j8: A2(Yt, NC(t = n.a), A2(Yt, SC(x([
                                b("disabled", t)
                            ])), r.j8))
                        });
                    case 9:
                        return m(r, {
                            j8: A2(Yt, A2(jC, "data-test", n.a), r.j8)
                        });
                    case 10:
                        return m(r, {
                            j8: A2(Yt, A2(bT, "min-height", n.a), r.j8)
                        });
                    case 11:
                        return m(r, {
                            j8: A2(Yt, Xx(sT(n.a)), r.j8)
                        });
                    default:
                        var t;
                        return m(r, {
                            j8: $((t = n.a) ? tT : h, r.j8)
                        });
                }
            }), rT, n);
        }(n);
        return A2(nk, r.lQ, x([
            A2(vT, A2(Yt, Xx("textarea"), r.j8), h)
        ]));
    }, pT = cr("ul"), $T = F2(function(n, r) {
        return n(r.b);
    }), hT = cr("li"), gT = A2(zm, A2(sm, lm(iu), qm(function(n) {
        return "[" !== n;
    })), A2(sm, Hm(qm(function(n) {
        return ")" !== n;
    })), VS(")"))), wT = F2(function(n, r) {
        return {
            D2: n,
            xs: r
        };
    }), xT = Dm(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), kT = xT, yT = A2(zm, A2(zm, A2(sm, A2(sm, lm(wT), VS("[")), kT), A2(sm, A2(sm, A2(sm, Hm(qm(function(n) {
        return "]" !== n;
    })), VS("]")), kT), VS("("))), A2(sm, Hm(qm(function(n) {
        return ")" !== n;
    })), VS(")"))), _T = F5(function(n, r, t, e, u) {
        var a = e + su(t), i = A2(iv, su(n) - a, n), c = e > 0 ? $(r, x([
            ld(A2(mu, e, n))
        ])) : r;
        return b(i, $(c, x([
            A2(IN, x([
                LN(u.xs),
                MN
            ]), x([
                ld(u.D2)
            ]))
        ])));
    }), AT = F2(function(n, r) {
        return A2(sc, $(r, x([
            ld(n)
        ])), A2(Fp, function(t) {
            var e = A5(_T, n, r, t.a, t.b, t.c);
            return A2(AT, e.a, e.b);
        }, function(n) {
            var r = A2(ep, gT, n);
            if (r.$) return Ut;
            var t = r.a + ")", e = A2(ep, yT, t);
            if (e.$) return Ut;
            var u = e.a;
            return A2(nv, function(n) {
                return Vt(v(t, n, u));
            }, rv(A2(bu, t, n)));
        }(n)));
    }), CT = function(n) {
        return A2(AT, n, h);
    }, BT = F2(function(n, r) {
        return A2(hT, h, CT(A2($T, n, r)));
    }), ET = F2(function(n, r) {
        return TE(r) ? tB : A2(pT, x([
            Xx("form-error")
        ]), A2(Eu, BT(n), r));
    }), DT = F4(function(n, r, t, e) {
        var u = VL(n), a = n.a.tx, i = A2(sc, "Additional Notes", a), c = a.$ ? "Anything else you want to share to help prepare our meeting." : "", o = FL(e.kB).fb;
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(i),
                    VH(u)
                ]), x([
                    A2(LB, h, x([
                        mT(x([
                            SH(A2(fe, "-", x([
                                jH,
                                "additional-notes"
                            ]))),
                            GH(o),
                            RH(A2(pc, QL, DH)),
                            qH(r),
                            TH(YL(DH(o))),
                            IH(EH(DH(o))),
                            UH(0),
                            YH(3),
                            {
                                $: 12,
                                a: true
                            },
                            ZH(c),
                            LH(u && A3(OH, e.kB, e.x, 5))
                        ]))
                    ])),
                    u ? A2(ET, t, A3(zH, e.kB, e.x, 5)) : tB
                ]))
            ]))
        ]));
    }), qT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, FT = function(n) {
        return {
            $: 2,
            a: n
        };
    }, PT = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jT = MC("checked"), ST = A2(By, x([
        "target",
        "checked"
    ]), jk), LT = function(n) {
        switch(n.$){
            case 0:
                return x([
                    jT(n.a)
                ]);
            case 2:
                return x([
                    NC(n.a)
                ]);
            case 1:
                return x([
                    (r = n.a, A2(TC, "change", A2(tu, r, ST)))
                ]);
            case 3:
                return x([
                    SC(x([
                        b("checkbox__input--indeterminate", n.a)
                    ]))
                ]);
            case 5:
                return x([
                    SC(x([
                        b("checkbox__input--invalid", n.a)
                    ]))
                ]);
            case 6:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
            default:
                return h;
        }
        var r;
    }, MT = function(n) {
        switch(n.$){
            case 0:
            case 1:
            default:
                return h;
            case 2:
                return x([
                    SC(x([
                        b("checkbox--disabled", n.a)
                    ]))
                ]);
            case 3:
                return x([
                    SC(x([
                        b("checkbox--ideterminate", n.a)
                    ]))
                ]);
            case 5:
                return x([
                    SC(x([
                        b("checkbox--invalid", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(Eu, ek(yu), r);
            case 6:
                return x([
                    A2(jC, "data-test", "label-" + n.a)
                ]);
        }
    }, NT = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 1:
            case 3:
            case 5:
                return h;
            case 4:
                var r = n.a;
                return A2(Eu, ek(yu), r);
            case 6:
                return x([
                    A2(jC, "data-test", "text-" + n.a)
                ]);
            default:
                return x([
                    SC(x([
                        b("checkbox__text--required", n.a)
                    ]))
                ]);
        }
    }, HT = F2(function(n, r) {
        return A2(Tq, A2(Yt, Xx("checkbox"), A2(tc, MT, n)), x([
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(nk, h, x([
                    A2(Zq, A2(Yt, Vq("checkbox"), A2(Yt, Xx("checkbox__input"), A2(tc, LT, n))), h),
                    A2(ak, x([
                        Xx("checkbox__icon")
                    ]), h)
                ])),
                A2(nk, A2(Yt, Xx("checkbox__text flex-grow"), A2(tc, NT, n)), r)
            ]))
        ]));
    }), TT = F4(function(n, r, t, e) {
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, x([
                    VH(!1)
                ]), x([
                    A2(LB, h, x([
                        A2(HT, x([
                            zT(e.eb),
                            PT(qT),
                            {
                                $: 7,
                                a: false
                            },
                            FT(r)
                        ]), x([
                            ld("By checking this box, you agree to receive SMS notifications about appointment confirmations, cancellations and reminders from " + Ex(n) + " Powered by Hint. Message frequency varies. Message & data rates may apply. You can reply STOP to opt out at any time. Text HELP for help. View our "),
                            A2(fB, x([
                                yB("https://www.hint.com/privacy"),
                                HN("_blank")
                            ]), x([
                                ld("Privacy Policy")
                            ])),
                            ld(" and "),
                            A2(fB, x([
                                yB("https://www.hint.com/terms-feb-2025"),
                                HN("_blank")
                            ]), x([
                                ld("Terms and Conditions")
                            ])),
                            ld(".")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), IT = function(n) {
        return {
            $: 3,
            a: n
        };
    }, RT = iu, ZT = {
        $: 1
    }, VT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, UT = {
        $: 2
    }, YT = function(n) {
        return {
            $: 3,
            a: n
        };
    }, QT = function(n) {
        return n.c$ ? tN(n) : h;
    }, OT = function(n) {
        return !TE(n.eH);
    }, GT = function(n) {
        return {
            $: 5,
            a: n
        };
    }, JT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, WT = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), KT = WT, XT = function(n) {
        return {
            $: 11,
            a: n
        };
    }, nI = function(n) {
        return {
            $: 17,
            a: n
        };
    }, rI = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), tI = rI, eI = {
        zn: !1
    }, uI = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), aI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, iI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cI = MC("autofocus"), oI = F2(function(n, r) {
        return vu(r) ? Iq("") : Iq(A2(lB, n, r));
    }), fI = F2(function(n, r) {
        return 1 > n ? r : A3(lu, 0, -n, r);
    }), sI = F3(function(n, r, t) {
        if (vu(t)) return "";
        if (vu(r)) return A2(TL, n, A2(lB, n, t));
        if (s(A2(lB, n, r), t) > 0) {
            var e = A2(TL, n, t);
            return s(r, e) > 0 ? e : A2(fI, 1, r);
        }
        return A2(TL, n, t);
    }), lI = F3(function(n, r, t) {
        return oT(A2(ru, A2(sI, n, r), t));
    }), dI = function(n) {
        switch(n.$){
            case 0:
                return x([
                    fT(n.a)
                ]);
            case 1:
                return x([
                    oT(e = n.a)
                ]);
            case 11:
                return x([
                    eT(e = n.a)
                ]);
            case 12:
                return x([
                    IC(e = n.a)
                ]);
            case 13:
                return x([
                    ZC(e = n.a)
                ]);
            case 2:
                return x([
                    Iq(n.a)
                ]);
            case 8:
                return x([
                    A2(oI, t = n.a, n.b)
                ]);
            case 9:
                return x([
                    A3(lI, t = n.a, n.b, e = n.c)
                ]);
            case 10:
                var r = n.a, t = n.b, e = n.c;
                return x([
                    oT(function(n) {
                        var u = r(n);
                        return vu(u) ? e("") : e(A2(TL, t, A2(lB, t, u)));
                    })
                ]);
            case 3:
                return x([
                    NC(n.a)
                ]);
            case 4:
                return x([
                    Vq((i = n.a, i ? "tel" : "password"))
                ]);
            case 5:
                return x([
                    A2(jC, "inputmode", (a = n.a, a ? "email" : "numeric"))
                ]);
            case 6:
                return x([
                    SC(x([
                        b("input--invalid", n.a)
                    ]))
                ]);
            case 7:
                return tT;
            case 14:
                return x([
                    Hq(n.a)
                ]);
            case 15:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
            case 16:
                return x([
                    cI(n.a)
                ]);
            case 17:
                return x([
                    uT(e = n.a)
                ]);
            case 18:
                return x([
                    Xx("input-with-icon")
                ]);
            case 19:
                return x([
                    (u = n.a, A2(Kx, "autocomplete", u ? "on" : "off"))
                ]);
            case 20:
                return x([
                    A2(jC, "autocomplete", n.a)
                ]);
            default:
                return x([
                    Yq(n.a)
                ]);
        }
        var u, a, i;
    }, bI = function(n) {
        return A2(Zq, A2(Yt, Xx("input"), A2(Yt, Vq("text"), A2(tc, dI, n))), h);
    }, vI = function(n) {
        var r = rv(A2(Tp, function(n) {
            return 18 === n.$ ? Vt(n.a) : Ut;
        }, n));
        if (r.$) return bI(n);
        var t = r.a;
        return A2(nk, h, x([
            bI(n),
            A2(PE, x([
                MB("input-icon")
            ]), t)
        ]));
    }, mI = F3(function(n, r, t) {
        var e = A3(de, uI, eI, r);
        return A2(nk, x([
            Xx("date-input"),
            Hq(t.rh)
        ]), x([
            vI(x([
                A2(KT, ML(t.bm), t.cn),
                A3(tI, ML(t.bm), t.cn, VT),
                iI(LL(t.bm)),
                JT(t.c$ && OT(t)),
                YT(e.zn),
                aI(!0),
                XT(ZT),
                nI(UT),
                GT(0)
            ])),
            A2(ET, n, QT(t))
        ]));
    }), pI = F3(function(n, r, t) {
        if (t.aJ) return tB;
        var e = FL(t.kB), u = A3(zH, t.kB, t.x, 2);
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(r(tM)),
                    VH(!0)
                ]), x([
                    A2(nk, x([
                        Xx("enter-info-date-of-birth"),
                        SC(x([
                            b("field--invalid", !TE(u))
                        ]))
                    ]), x([
                        A2(Ck, IT, A3(mI, r, x([
                            RT(n)
                        ]), e.bk))
                    ])),
                    A2(ET, r, u)
                ]))
            ]))
        ]));
    }), $I = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hI = function(n) {
        return {
            $: 14,
            a: n
        };
    }, gI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wI = function(n) {
        switch(n){
            case 0:
                return jH + "-first-name";
            case 1:
                return jH + "-last-name";
            case 2:
                return jH + "-dob";
            case 3:
                return jH + "-email";
            case 4:
                return jH + "-phone";
            default:
                return jH + "-notes";
        }
    }, xI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kI = F3(function(n, r, t) {
        if (t.aJ) return tB;
        var e = FL(t.kB).pP;
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(r(iM)),
                    VH(!0)
                ]), x([
                    vI(x([
                        hI(wI(3)),
                        xI(e),
                        gI(A2(pc, QL, $I)),
                        JT(A3(OH, t.kB, t.x, 3)),
                        YT(n),
                        aI(!0),
                        XT(YL($I(e))),
                        nI(EH($I(e))),
                        GT(1)
                    ])),
                    A2(ET, r, A3(zH, t.kB, t.x, 3))
                ]))
            ]))
        ]));
    }), yI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _I = {
        $: 8
    }, AI = function(n) {
        return n.rZ;
    }, CI = F4(function(n, r, t, e) {
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, h, x([
                    A2(nk, x([
                        Xx("flex items-start gap-2")
                    ]), x([
                        A2(HT, x([
                            zT(e.cv),
                            PT(yI),
                            FT(r)
                        ]), x([
                            ld("I authorize " + Ex(n) + " to send email or text which may include unencrypted protected health information. "),
                            A2(ak, x([
                                IC(_I),
                                Xx("cursor-pointer underline text-primary hover:text-primary-400")
                            ]), x([
                                ld(t(AI))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), BI = {
        $: 10
    }, EI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, DI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FI = F2(function(n, r) {
        return A2(ak, _k(n), A2(Eu, Ck(yu), r));
    }), PI = function(n) {
        return A2(jE, function(n) {
            return 3 === n.$;
        }, n);
    }, zI = DC(6), jI = {
        $: 3
    }, SI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, LI = SI(1), MI = LB(x([
        rB(LI),
        rB(kF)
    ])), NI = F2(function(n, r) {
        switch(r.$){
            case 4:
                return Vt(A2(OC, x([
                    zI,
                    gC(x([
                        Xx("modal__close-full-viewport pointer-events-auto border-0 bg-transparent text-white shadow-none"),
                        Vq("button"),
                        A2(jC, "aria-label", "Close")
                    ])),
                    EC(n.By)
                ]), x([
                    MI(x([
                        A2(Ck, yu, A2(PE, x([
                            iH,
                            jI,
                            MB("text-white")
                        ]), 2))
                    ]))
                ])));
            case 0:
                var t = r.a;
                return Vt(A2(LB, x([
                    ok(x([
                        Xx("modal__body modal__body--full-viewport")
                    ])),
                    rB(oB)
                ]), t));
            default:
                return Ut;
        }
    }), HI = F3(function(n, r, t) {
        return A2(LB, x([
            ok(x([
                Xx(1 === n.$ ? "modal-wrap" : "modal-wrap " + n.a)
            ]))
        ]), x([
            A2(PC, x([
                Vq("button"),
                Xx("modal__backdrop-dismiss"),
                IC(r.By)
            ]), h),
            A2(LB, x([
                ok(x([
                    Xx("modal__full-viewport-foreground")
                ]))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("modal__full-viewport-inner")
                    ]))
                ]), A2(Tp, NI(r), t))
            ]))
        ]));
    }), TI = F2(function(n) {
        return "scroll-shadow-" + n;
    }), II = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("scroll-shadow"),
            SC(x([
                b(A2(TI, n, t), r)
            ]))
        ]), h);
    }), RI = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? tB : A3(II, "bottom", !t.a.a.mJ, r);
    }), ZI = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? tB : A3(II, "top", !t.a.a.mM, r);
    }), VI = F2(function(n, r) {
        switch(r.$){
            case 4:
                return Vt(A2(OC, x([
                    zI,
                    gC(x([
                        Xx("absolute top-4 right-6 z-10 h-8 w-8 cursor-pointer rounded-full border-0 bg-white p-0 shadow"),
                        Vq("button"),
                        A2(jC, "aria-label", "Close")
                    ])),
                    EC(n.By)
                ]), x([
                    MI(x([
                        A2(Ck, yu, A2(PE, x([
                            HB
                        ]), 2))
                    ]))
                ])));
            case 1:
                var t = r.a;
                return Vt(A2(nk, x([
                    Xx("modal__header flex flex-col")
                ]), x([
                    A2(nk, x([
                        Xx("flex flex-row w-full")
                    ]), x([
                        A2(nk, x([
                            Xx("w-full")
                        ]), t),
                        (e = n.By, A2(nk, x([
                            Xx("cursor-pointer"),
                            IC(e)
                        ]), x([
                            A2(PE, h, 2)
                        ])))
                    ])),
                    A2(nk, x([
                        Xx("modal__section-divider flex w-full px-8 mt-6 sm:mt-8 border-b border-primary-200 h-1px")
                    ]), h)
                ])));
            case 0:
                return t = r.a, Vt(A2(nk, x([
                    Xx("scroll-container")
                ]), x([
                    A2(ZI, n.fx, n.iM),
                    A2(nk, x([
                        Xx("modal__body"),
                        Hq(cS)
                    ]), t),
                    A2(RI, n.fx, n.iM)
                ])));
            case 2:
                return t = r.a, Vt(A2(nk, x([
                    Xx("modal__footer")
                ]), x([
                    A2(nk, x([
                        Xx("flex flex-col w-full")
                    ]), x([
                        A2(nk, x([
                            Xx("modal__section-divider flex w-full px-8 mb-6 sm:mb-8 border-b border-primary-200 h-1px")
                        ]), h),
                        A2(nk, x([
                            Xx("w-full")
                        ]), t)
                    ]))
                ])));
            default:
                return Ut;
        }
        var e;
    }), UI = F5(function(n, r, t, e, u) {
        var a = 1 === e.$ ? "modal__content" : "modal__content " + e.a, i = A2(LB, x([
            ok(x([
                Xx(u ? a + " pointer-events-auto" : a)
            ]))
        ]), A2(Tp, VI(n), r));
        return A2(LB, x([
            ok(x([
                SC(x([
                    b("modal-wrap", !0),
                    b("modal--bottom-sheet", t)
                ]))
            ]))
        ]), x(u ? [
            A2(PC, x([
                Vq("button"),
                Xx("modal__backdrop-dismiss"),
                IC(n.By)
            ]), h),
            A2(LB, x([
                ok(x([
                    Xx("modal__standard-dismiss-foreground")
                ]))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("modal pointer-events-none")
                    ]))
                ]), x([
                    i
                ]))
            ]))
        ] : [
            A2(LB, x([
                ok(x([
                    Xx("modal")
                ]))
            ]), x([
                i
            ]))
        ]));
    }), YI = F3(function(n, r, t) {
        return t.bG ? tB : 1 === n ? A3(HI, Ut, t, r) : A5(UI, t, r, PI(r), Ut, !1);
    }), QI = F2(function(n, r) {
        return A3(YI, 0, n, r);
    }), OI = F2(function(n, r) {
        return A2(QI, x([
            qI(x([
                A2(FI, x([
                    aq,
                    $H
                ]), x([
                    ld("ePHI Waiver")
                ]))
            ])),
            EI(x([
                A2(nk, x([
                    Xx("flex flex-col gap-4")
                ]), x([
                    A2(Ek, h, x([
                        ld("Providing us with authorization to email and text you will allow "),
                        ld(Ex(n)),
                        ld(" to exchange information with you more efficiently and will benefit you as a member. At the same time, we recognize that email and text messaging are not a completely secure means of communication.")
                    ])),
                    A2(Ek, h, x([
                        ld("You are not required to authorize the use of email and text messages and a decision to not authorize electronic communication will not affect your health care in any way.")
                    ])),
                    A2(Ek, h, x([
                        ld("We have taken considerable effort to protect the personal health information of our members, and recommend that all members provide us with this authorization so that we can more efficiently communicate with them.")
                    ]))
                ]))
            ])),
            DI(x([
                A2(OC, x([
                    oF,
                    EC(Rj)
                ]), x([
                    ld("No Thanks")
                ])),
                A2(OC, x([
                    qC,
                    EC(BI)
                ]), x([
                    ld("Accept")
                ]))
            ]))
        ]), r.ai);
    }), GI = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), JI = function(n) {
        return A2(GI, 0, n);
    }, WI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, KI = F3(function(n, r, t) {
        var e = FL(t.kB).qB;
        return A2(XH, x([
            HH(r(vM)),
            VH(!0)
        ]), x([
            A2(LB, h, x([
                vI(x([
                    hI(wI(0)),
                    xI(e),
                    gI(A2(pc, QL, WI)),
                    JT(A3(OH, t.kB, t.x, 0)),
                    YT(n),
                    XT(YL(WI(e))),
                    nI(EH(WI(e))),
                    aI(!0)
                ]))
            ])),
            A2(ET, r, A3(zH, t.kB, t.x, 0))
        ]));
    }), XI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nR = F3(function(n, r, t) {
        var e = FL(t.kB).rS;
        return A2(XH, x([
            HH(r(mM)),
            VH(!0)
        ]), x([
            A2(LB, h, x([
                vI(x([
                    hI(wI(1)),
                    xI(e),
                    gI(A2(pc, QL, XI)),
                    JT(A3(OH, t.kB, t.x, 1)),
                    YT(n),
                    XT(YL(XI(e))),
                    nI(EH(XI(e))),
                    aI(!0)
                ]))
            ])),
            A2(ET, r, A3(zH, t.kB, t.x, 1))
        ]));
    }), rR = F3(function(n, r, t) {
        return t.aJ ? tB : A2(zN, h, x([
            A2(EN, x([
                JI(6)
            ]), x([
                A3(KI, n, r, t)
            ])),
            A2(EN, x([
                JI(6)
            ]), x([
                A3(nR, n, r, t)
            ]))
        ]));
    }), tR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uR = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iR = A2(CN, AN(3), Ut), cR = A2(CN, AN(3), Vt(1)), oR = F2(function(n, r) {
        return n ? r : tB;
    }), fR = {
        zn: !1,
        dm: !1,
        hH: !1,
        Ax: !1
    }, sR = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zn: n.a
                });
            case 1:
                return m(r, {
                    Ax: n.a
                });
            case 2:
                return m(r, {
                    dm: n.a
                });
            default:
                return m(r, {
                    hH: n.a
                });
        }
    }), lR = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), dR = lR, bR = function(n) {
        return A2(GI, 1, n);
    }, vR = {
        $: 3
    }, mR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pR = {
        $: 4
    }, $R = function(n) {
        return {
            $: 20,
            a: n
        };
    }, hR = function(n) {
        return {
            $: 21,
            a: n
        };
    }, gR = F3(function(n, r, t) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t
        };
    }), wR = gR, xR = A3(Dy, "#", "_", hB), kR = function(n) {
        var r = A2(kB, ye, n);
        return su(r) >= 11 && A2(xu, "1", r) ? A2(du, 1, r) : r;
    }, yR = function(n) {
        return {
            $: 15,
            a: n
        };
    }, _R = F5(function(n, r, t, e, u) {
        return vI(x(r ? [
            hI(u),
            xI(n),
            gI(mR),
            YT(t),
            JT(e),
            XT(vR),
            yR(u),
            aI(!0),
            hR("tel"),
            $R("tel"),
            nI(pR)
        ] : [
            hI(u),
            A2(KT, gB, n),
            iI(xR),
            A3(wR, kR, gB, mR),
            YT(t),
            JT(e),
            XT(vR),
            yR(u),
            aI(!0),
            nI(pR),
            GT(0),
            hR("tel-national"),
            $R("tel-national")
        ]));
    }), AR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CR = x([
        0,
        1
    ]), BR = F4(function(n, r, t, e) {
        return A2(Ck, aN, A4(sF, n, x([
            Dq(Vt(r)),
            AR(e)
        ]), A2(Eu, function(n) {
            return A2(hq, h, n);
        }, CR), t));
    }), ER = {
        $: 1
    }, DR = {
        $: 2
    }, qR = x([
        Zj,
        ER,
        DR
    ]), FR = F4(function(n, r, t, e) {
        return A2(Ck, iN, A4(sF, n, x([
            Dq(Vt(r)),
            xq("<Phone Type>"),
            AR(e)
        ]), A2(Eu, function(n) {
            return A2(hq, h, n);
        }, qR), t));
    }), PR = F3(function(n, r, t) {
        var e = A3(de, sR, fR, r), u = e.dm ? 0 : 2, a = e.dm ? 0 : 3;
        return A2(nk, x([
            Xx("phone-input"),
            Hq(t.rh)
        ]), x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12),
                    bR(12 - u - a),
                    jN(cR),
                    A2(dR, 1, iR)
                ]), x([
                    A5(_R, t.CA, t.Dl, e.zn, e.Ax, t.rh)
                ])),
                A2(EN, x([
                    JI(12),
                    bR(u)
                ]), x([
                    A2(oR, !e.dm, A4(BR, n, t.Dl, t.iu, e.zn))
                ])),
                A2(EN, x([
                    JI(12),
                    bR(a)
                ]), x([
                    A2(oR, !e.hH, A4(FR, n, t.dQ, t.iw, e.zn))
                ]))
            ]))
        ]));
    }), zR = F3(function(n, r, t) {
        if (t.aJ) return tB;
        var e = FL(t.kB).uw;
        return A2(zN, h, x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(r(Jj)),
                    VH(!0)
                ]), x([
                    A2(nk, x([
                        Xx("mx-1")
                    ]), x([
                        A2(Ck, JL, A3(PR, r, x([
                            aR(A3(OH, t.kB, t.x, 4)),
                            eR(!0),
                            uR(!0),
                            tR(n)
                        ]), e))
                    ])),
                    A2(ET, r, A3(zH, t.kB, t.x, 4))
                ]))
            ]))
        ]));
    }), jR = {
        $: 5
    }, SR = F4(function(n, r, t, e) {
        var u = !DM(e), a = Lj(n) ? "Confirm" : "Request";
        return A2(zN, h, x([
            A2(EN, x([
                _N(DB)
            ]), x([
                A2(OC, x([
                    qC,
                    EC(jR),
                    uF(u || r)
                ]), x([
                    ld(a)
                ]))
            ]))
        ]));
    }), LR = F5(function(n, r, t, e, u) {
        return A2(nk, h, x([
            A2(OI, r, u),
            A2(nk, x([
                Xx("booking-enter-info-form")
            ]), x([
                u.aJ ? tB : A2(nk, x([
                    Xx("text-base font-extrabold mb-4")
                ]), x([
                    ld("Attendee information")
                ])),
                A2(nk, x([
                    Xx("ml-1")
                ]), x([
                    A3(rR, t, e, u),
                    A3(pI, t, e, u),
                    A3(kI, t, e, u),
                    A3(zR, t, e, u),
                    A4(TT, r, t, e, u),
                    u.hL && !u.hA ? A4(CI, r, t, e, u) : tB,
                    A4(DT, n, t, e, u),
                    A4(SR, n, t, e, u)
                ]))
            ]))
        ]));
    }), MR = F2(function(n, r) {
        var t = r.bH;
        if (3 === t.$) {
            var e = t.a, u = A2(nv, dH, r.ck), a = A2(nv, pL, r.ck), i = BH(r.lH), c = qP(e);
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), x([
                A2($F, i, {
                    eg: a,
                    yn: Vt(e),
                    nc: Vt(c),
                    t6: r.t6,
                    fq: u
                }),
                A2(Ck, yS, A5(LR, e, r.dB, i, n, r.aQ))
            ]));
        }
        return A2(nk, h, ck);
    }), NR = F2(function(n, r) {
        return {
            gN: x([
                function() {
                    var t, e, u = r.lH;
                    if (3 === u.$) {
                        var a = u.a, i = b(r.bH, r.ck);
                        if (3 !== i.a.$ || i.b.$) return tB;
                        var c = i.a.a, o = i.b.a;
                        return A2(nk, x([
                            Xx("mt-12")
                        ]), x([
                            A5(wH, c, o, a, r.t6, r.xs.iF)
                        ]));
                    }
                    return A2(nk, x([
                        Xx("flex flex-col gap-4")
                    ]), 3 === (e = r.bH).$ ? x([
                        A3(CH, r.lH, r.xs, e.a),
                        (t = r.bH, 3 === t.$ ? _F(Lj(t.a)) : tB),
                        A2(MR, n, r)
                    ]) : ck);
                }()
            ]),
            w5: "Booking"
        };
    }), HR = ZA({
        Ar: gS,
        AQ: wS,
        Db: xS,
        DZ: function() {
            return Px(x([
                eP(kS),
                A2(_S, yS, ES())
            ]));
        },
        En: yN,
        Et: NR
    }), TR = function(n) {
        return {
            $: 4,
            a: n
        };
    }, IR = function(n) {
        return {
            $: 5,
            a: n
        };
    }, RR = {
        pG: 0,
        vr: h
    }, ZR = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), VR = F8(function(n, r, t, e, u, a, i, c) {
        return {
            mr: t,
            pn: e,
            rh: n,
            rH: c,
            rO: u,
            kV: i,
            tg: r,
            xy: a
        };
    }), UR = A3(ly, "name", C$, A3(ly, "id", C$, uu(F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    })))), YR = A2(Pk, UR, uu(iu)), QR = A3(ly, "requires_location_selection", jk, A3(ly, "requires_practitioner_selection", jk, uu(F2(function(n, r) {
        return {
            vN: r,
            vQ: n
        };
    })))), OR = A2(Pk, QR, uu(iu)), GR = A3(ly, "member_type", A2(nu, function(n) {
        return uu(!n.$ && "Primary Member" === n.a);
    }, iy(C$)), A3(ly, "meta", OR, A3(ly, "uses_tobacco", iy(jk), A4(sy, "known_practice", iy(YR), Ut, A3(ly, "dob", iy(ay), A3(ly, "age", iy(F$), A3(ly, "name", A2(tu, RE, C$), A3(ly, "id", C$, uu(VR))))))))), JR = A2(dD, 0, A2(Pk, GR, uu(ZR))), WR = F3(function(n, r, t) {
        return A4(W_, n, vy(JR), t, rA(function(n) {
            return A2(X_, x([
                "patients"
            ]), lL(n));
        }(r)));
    }), KR = F2(function(n, r) {
        return {
            rL: n,
            Eg: r
        };
    }), XR = function(n) {
        switch(n){
            case "month":
                return Vt(0);
            case "quarter":
                return Vt(1);
            case "semi_annual":
                return Vt(2);
            case "annual":
                return Vt(3);
            default:
                return Ut;
        }
    }, nZ = function(n) {
        var r = XR(n);
        return r.$ ? Sk("Unsupported period name: " + n) : uu(r.a);
    }, rZ = A2(nu, nZ, C$), tZ = A2(nu, function(n) {
        switch(n){
            case "plan":
                return uu(0);
            case "package":
                return uu(1);
            default:
                return Sk("Unknown catalog type: " + n);
        }
    }, C$), eZ = A2(tu, iu, A4(sy, "billing_period", aL(rZ), Ut, A3(ly, "price_in_cents", F$, A3(ly, "tax_in_cents", F$, A3(ly, "registration_fee_in_cents", F$, A3(ly, "recurring_amount_in_cents", F$, A4(sy, "start_date", aL(C$), Ut, A4(sy, "period_in_months", aL(F$), Ut, A4(sy, "owner", aL(C$), Ut, A3(ly, "type", tZ, A3(ly, "name", A2(tu, sc(""), aL(C$)), A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    yz: s,
                                                    eS: t,
                                                    tg: r,
                                                    tU: e,
                                                    Cz: u,
                                                    lj: f,
                                                    ln: i,
                                                    lp: c,
                                                    fM: n,
                                                    DN: a,
                                                    lI: o
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), uZ = F2(function(n, r) {
        return {
            pG: n,
            vr: r
        };
    }), aZ = F3(function(n, r, t) {
        return {
            yj: r,
            yz: n,
            DQ: t
        };
    }), iZ = A2(nu, nZ, C$), cZ = A4(sy, "starts_on", aL(C$), Ut, A3(ly, "amount_in_cents", F$, A3(ly, "billing_period", iZ, uu(aZ)))), oZ = A4(sy, "recurring_groups", vy(cZ), h, A3(ly, "due_today_in_cents", F$, uu(uZ))), fZ = A3(ly, "totals", oZ, A3(ly, "items", vy(eZ), uu(KR))), sZ = F3(function(n, r, t) {
        return A4(W_, n, fZ, t, rA(A2(X_, x([
            "cart"
        ]), lL(r))));
    }), lZ = F3(function(n, r) {
        return b({
            gF: r.gF,
            aW: r.aW,
            ks: !1,
            qi: yq,
            kA: r.kA,
            A8: vc,
            dB: n,
            Eg: RR
        }, Vu(x([
            A3(sZ, r.gF, Bx(n), TR),
            A3(WR, r.gF, Bx(n), IR)
        ])));
    }), dZ = F2(function(n, r) {
        return b(m(r, {
            aW: n.aW
        }), Pp);
    }), bZ = F2(function(n, r) {
        return m(r, {
            x6: Ut
        });
    }), vZ = function(n) {
        return {
            $: 23,
            a: n
        };
    }, mZ = F2(function(n, r) {
        return A2(fa, n, r);
    }), pZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(r, A2(AA, da, _a), h);
            case 1:
                return v(r, A2(AA, da, xa), h);
            case 2:
                return v(m(r, {
                    ks: !r.ks
                }), Pp, h);
            case 3:
                var t = n.a;
                return v(m(r, {
                    qi: A2(A2(Cq, t, r.qi) ? mZ : _q, t, r.qi)
                }), Pp, h);
            case 4:
                if (3 === (u = n.a).$) {
                    var e = u.a;
                    return v(m(r, {
                        aW: e.rL,
                        Eg: e.Eg
                    }), Pp, x([
                        vZ(e.rL)
                    ]));
                }
                return v(r, Pp, h);
            default:
                var u;
                return v(m(r, {
                    A8: u = n.a
                }), Pp, h);
        }
    }), $Z = {
        $: 0
    }, hZ = function(n) {
        return n.c6.oo;
    }, gZ = function(n) {
        return n.c6.pV;
    }, wZ = function(n) {
        return n.c6.pY;
    }, xZ = function(n) {
        return n.c6.dg;
    }, kZ = function(n) {
        return n.c6.w5;
    }, yZ = {
        $: 1
    }, _Z = {
        $: 2
    }, AZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, CZ = hC(x([
        Xx("w-full")
    ])), BZ = function(n) {
        return A2(OC, x([
            qC,
            CZ,
            EC(n.tG),
            uF(n.oN)
        ]), x([
            ld(n.oO)
        ]));
    }, EZ = sk(0), DZ = function(n) {
        var r = x(n.kc ? [
            Xx("flex justify-between items-center cursor-pointer py-1"),
            IC(n.k2)
        ] : [
            Xx("flex justify-between items-center py-1")
        ]), t = x(n.rH ? [
            nH
        ] : [
            $H
        ]), e = n.kx ? "transform rotate-90" : "";
        return A2(nk, h, x([
            A2(nk, r, x([
                A2(nk, x([
                    Xx("flex flex-col")
                ]), x([
                    A2(Ek, t, x([
                        ld(n.rQ)
                    ])),
                    function() {
                        var r = n.lG;
                        if (r.$) return ld("");
                        var t = r.a;
                        return A2(FI, x([
                            $H,
                            EZ
                        ]), x([
                            ld(t)
                        ]));
                    }()
                ])),
                A2(nk, x([
                    Xx("flex items-center gap-2")
                ]), x([
                    n.j4,
                    A2(PE, x([
                        HB,
                        MB(e)
                    ]), 6)
                ]))
            ]))
        ]));
    }, qZ = function(n) {
        return n.ap.zd;
    }, FZ = function(n) {
        return n.ap.zx;
    }, PZ = function(n) {
        return n.ap.zy;
    }, zZ = function(n) {
        return n.ap.zz;
    }, jZ = function(n) {
        return n.ap.zA;
    }, SZ = function(n) {
        return n.ap.zB;
    }, LZ = function(n) {
        return n.ap.Bj;
    }, MZ = function(n) {
        return n.ap.CY;
    }, NZ = function(n) {
        return n.ap.DO;
    }, HZ = function(n) {
        return n.ap.lE;
    }, TZ = F2(function(n, r) {
        if (1 === r.$) return Ut;
        var t = uy(r.a);
        if (t.$) return Ut;
        var e = t.a;
        return Vt(A3(Dy, "{ $date }", A2(fp, n(qZ), e), n(LZ)));
    }), IZ = function(n) {
        return n.yz;
    }, RZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZZ = F5(function(n, r, t, e, u) {
        return {
            zi: t,
            rp: r,
            tR: n,
            iC: e,
            wY: u
        };
    }), VZ = function(n) {
        return x([
            n
        ]);
    }, UZ = F2(function(n, r) {
        var t = su(r), e = 0 > s(t, n) ? Iv(n - t) : 0;
        return $(r, A2(Ub, e, "0"));
    }), YZ = function(n) {
        return "0" !== A2(iv, 1, n) ? n : YZ(A2(fI, 1, n));
    }, QZ = F2(function(n, r) {
        var t = n.zi;
        switch(t.$){
            case 1:
                return YZ(r);
            case 2:
                return r;
            default:
                return A2(UZ, t.a, r);
        }
    }), OZ = O, GZ = F2(function(n, r) {
        var t = A2(jE, function(n) {
            return "0" !== n && "." !== n;
        }, Lm(r));
        return $(n && t ? "-" : "", r);
    }), JZ = function(n) {
        var r = n.a, t = n.b;
        if ("9" === r) {
            var e = Ce(t);
            return 1 === e.$ ? "01" : A2(Rb, "0", JZ(e.a));
        }
        var u = ge(r);
        return u >= 48 && 57 > u ? A2(Rb, p_(u + 1), t) : "0";
    }, WZ = j, KZ = F3(function(n, r, t) {
        return $(t, A2(Ub, n - su(t), Zb(r)));
    }), XZ = function(n) {
        for(var r = n.length, t = Array(r), e = 0; r > e;){
            var u = n.charCodeAt(e);
            55296 > u || u > 56319 ? (t[r - e] = n[e], e++) : (t[r - e] = n[e + 1], t[r - ++e] = n[e - 1], e++);
        }
        return t.join("");
    }, nV = function(n) {
        var r = A2(se, ".", n);
        return r.b ? b(r.a, r.b.b ? r.b.a : "0") : b("0", "0");
    }, rV = F3(function(n, r, t) {
        if ((e = t) === 1 / 0 || e === -1 / 0 || WZ(t)) return OZ(t);
        var e, u = 0 > t, a = nV(function(n) {
            var r = A2(se, "e", OZ(Iv(n)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b.a, u = A2(sc, 0, pu(A2(xu, "+", e) ? A2(du, 1, e) : e)), a = nV(t), i = $(a.a, a.b), c = 0 > u ? A2(sc, "0", A2(Fp, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Fp, qx(Zb), Ce($(A2(Ub, Iv(u), "0"), i))))) : A3(KZ, u + 1, "0", i);
                    return $(0 > n ? "-" : "", c);
                }
                return $(0 > n ? "-" : "", t = r.a);
            }
            return "";
        }(Iv(t))), i = a.a, c = a.b, o = su(i) + r, f = $(A2(Ub, 1 - o, "0"), A3(KZ, o, "0", $(i, c))), l = su(f), d = A2(Ve, 1, o), b = A2(n, u, A3(lu, d, l, f)), v = A3(lu, 0, d, f), m = b ? XZ(A2(sc, "1", A2(Fp, JZ, Ce(XZ(v))))) : v, p = su(m), h = "0" === m ? m : r > 0 ? 0 > s(r, su(c)) ? A3(lu, 0, p - r, m) + "." + A3(lu, p - r, p, m) : $(i + ".", A3(KZ, r, "0", c)) : $(m, A2(Ub, Iv(r), "0"));
        return A2(GZ, u, h);
    })(F2(function(n, r) {
        var t, e = Ce(r);
        return 1 !== e.$ && ("5" === e.a.a ? "" !== e.a.b || !n : (t = ge(e.a.a)) > 53 && n || t >= 53 && !n);
    })), tV = function(n) {
        return n.b ? Vt(n.b) : Ut;
    }, eV = F2(function(n, r) {
        var t, e = function() {
            var r = n.zi;
            switch(r.$){
                case 1:
                default:
                    return rV(r.a);
                case 0:
                    return OZ;
            }
        }(), u = A2(se, ".", e(r)), a = (t = tV(u)).$ ? "" : A2(sc, "", rv(t.a));
        return b(A2(sc, "", rv(u)), a);
    }), uV = F2(function(n, r) {
        var t, e = A2(eV, n, r), u = function(n) {
            var r = function(n) {
                return su(n) > 3 ? A2(Yt, A2(iv, 3, n), r(A2(fI, 3, n))) : x([
                    n
                ]);
            };
            return Ae(r(n));
        }(A2(kB, ye, e.a)), a = A5(ZZ, r, u, A2(QZ, n, e.b), "", "");
        switch(A2(ae, function(n) {
            return "0" === n;
        }, Gp(A2(nc, (t = a).rp, VZ(t.zi)))) ? 1 : 0 > t.tR ? 2 : 0){
            case 2:
                return m(a, {
                    iC: n.h7,
                    wY: n.kY
                });
            case 0:
                return m(a, {
                    iC: n.uJ,
                    wY: n.uK
                });
            default:
                return m(a, {
                    iC: n.xZ,
                    wY: n.x$
                });
        }
    }), aV = F2(function(n, r) {
        return "" === r ? "" : $(n.cp, r);
    }), iV = F2(function(n, r) {
        var t = aV(n), e = A2(fe, n.cX, r.rp), u = t(r.zi);
        return Gp(x([
            r.iC,
            e,
            u,
            r.wY
        ]));
    }), cV = F2(function(n, r) {
        return A2(iV, n, A2(uV, n, r));
    }), oV = m({
        cp: ".",
        zi: {
            $: 0,
            a: 0
        },
        h7: "\u2212",
        kY: "",
        uJ: "",
        uK: "",
        cX: "",
        xZ: "",
        x$: ""
    }, {
        zi: RZ(2),
        cX: ","
    }), fV = F3(function(n, r, t) {
        var e = Iv(t), u = r ? "$" : "", a = 0 > t ? "-" : "", i = n ? m(oV, {
            zi: RZ(0)
        }) : oV;
        return $(a, $(u, A2(cV, i, e)));
    }), sV = F3(function(n, r, t) {
        return A3(fV, n, r, .01 * t);
    }), lV = function(n) {
        return A3(sV, !1, !0, n);
    }, dV = F4(function(n, r, t, e) {
        return A2(nk, x([
            Xx("flex flex-col")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between text-sm items-baseline")
            ]), x([
                A2(FI, x([
                    $H
                ]), x([
                    ld(n)
                ])),
                A2(nk, x([
                    Xx("flex items-baseline gap-1")
                ]), x([
                    A2(FI, x([
                        $H
                    ]), x([
                        ld(lV(r))
                    ])),
                    vu(t) ? ld("") : A2(FI, x([
                        $H,
                        EZ
                    ]), x([
                        ld(t)
                    ]))
                ]))
            ])),
            A2(FI, x([
                $H,
                EZ
            ]), x([
                ld(e)
            ]))
        ]));
    }), bV = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("flex justify-between text-sm items-baseline")
        ]), x([
            A2(FI, x([
                $H
            ]), x([
                ld(n)
            ])),
            A2(nk, x([
                Xx("flex items-baseline gap-1")
            ]), x([
                A2(FI, x([
                    $H
                ]), x([
                    ld(lV(r))
                ])),
                vu(t) ? ld("") : A2(FI, x([
                    $H,
                    EZ
                ]), x([
                    ld(t)
                ]))
            ]))
        ]));
    }), vV = function(n) {
        return A3(de, _q, yq, n);
    }, mV = function(n) {
        return n.DN;
    }, pV = F2(function(n, r) {
        var t = IZ(r);
        if (t.$) return !1;
        var e = t.a, u = b(A2(nv, function(n) {
            return n.DQ;
        }, rv(A2(Rc, function(n) {
            return i(n.yz, e);
        }, n.Eg.vr))), mV(r));
        return !u.a.$ && !u.b.$ && s(u.b.a, u.a.a) > -1;
    }), $V = F3(function(n, r, t) {
        if (A2(pV, r, t)) {
            var e = mV(t);
            if (e.$) return n(HZ);
            var u = uy(e.a);
            if (u.$) return n(HZ);
            var a = u.a;
            return A3(Dy, "{ $date }", A2(fp, n(qZ), a), n(NZ));
        }
        return n(HZ);
    }), hV = function(n) {
        return n.eS;
    }, gV = function(n) {
        return n.fi.mC;
    }, wV = function(n) {
        return n.fi.tf;
    }, xV = function(n) {
        return n.fi.vj;
    }, kV = function(n) {
        return n.fi.v9;
    }, yV = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return wV;
                case 1:
                    return xV;
                case 2:
                    return kV;
                default:
                    return gV;
            }
        }());
    }), _V = function(n) {
        return n.tg;
    }, AV = function(n) {
        return n.ln;
    }, CV = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var t = r.d;
            n = A2(CV, n + 1, r.e), r = t;
        }
    }), BV = F2(function(n, r) {
        var t, e = A2(yV, n.xl, r.yz), u = A2(Rc, function(n) {
            return i(IZ(n), Vt(r.yz));
        }, A2(Rc, function(n) {
            return AV(n) > 0;
        }, A2(Rc, function(n) {
            return !hV(n);
        }, n.rL))), a = (t = vV(A2(Tp, mV, u)), A2(CV, 0, t) > 1), c = A2(Eu, function(r) {
            return a ? A4(dV, _V(r), AV(r), e, A3($V, n.xl, n, r)) : A3(bV, _V(r), AV(r), e);
        }, u);
        return A2(nk, x([
            Xx("pl-3 border-l border-primary-200 mt-1 mb-2 flex flex-col gap-1")
        ]), c);
    }), EV = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 3;
            case 2:
                return 6;
            default:
                return 12;
        }
    }, DV = F2(function(n, r) {
        switch(EV(r)){
            case 3:
                return n(PZ);
            case 6:
                return n(jZ);
            case 12:
                return n(FZ);
            default:
                return n(zZ);
        }
    }), qV = function(n) {
        switch(n){
            case 0:
                return "month";
            case 1:
                return "quarter";
            case 2:
                return "semi_annual";
            default:
                return "annual";
        }
    }, FV = iq(2), PV = iq(0), zV = NB(0), jV = {
        $: 4,
        a: 1
    }, SV = eB(0), LV = F2(function(n, r) {
        return A2(nk, x([
            Xx("tooltip")
        ]), x([
            A2(ak, x([
                Xx("tooltip__text")
            ]), x([
                ld(n)
            ])),
            r
        ]));
    }), MV = F7(function(n, r, t, e, u, a, i) {
        var c = t ? Ak : Ek, o = a ? x([
            jV
        ]) : h, f = t && a ? x([
            Xx("text-primary-500")
        ]) : h, s = i ? A2(nk, h, x([
            A2(LV, n(Bd), A2(nk, h, x([
                ld(" + " + n(xd)),
                A2(PE, x([
                    zV
                ]), 4)
            ])))
        ])) : tB;
        return A2(nk, A2(Yt, Xx("flex "), $k(u)), function() {
            var t, u = (t = A2(se, ".", A3(sV, !1, !1, r))).b && t.b.b && !t.b.b.b ? Vt(b(t.a, t.b.a)) : Ut;
            if (u.$) return x([
                tB
            ]);
            var a = u.a, i = a.a, l = a.b;
            return x([
                A2(c, x([
                    rB(PV),
                    ok(A2(Yt, Xx("quote-info__rate--sign"), f)),
                    SV
                ]), x([
                    ld("$")
                ])),
                A2(c, A2(Yt, ok(A2(Yt, Xx("quote-info__rate--dollars"), f)), A2(Yt, SV, o)), x([
                    ld(i)
                ])),
                A2(c, x([
                    rB(PV),
                    ok(A2(Yt, Xx("quote-info__rate--cents"), f)),
                    SV
                ]), x([
                    ld("." + l)
                ])),
                function() {
                    if (e.$) return tB;
                    var r = e.a;
                    return A2(Ek, x([
                        rB(FV),
                        ok(x([
                            Xx("quote-info__rate--period")
                        ])),
                        SV
                    ]), x([
                        ld(A2(yV, n, r)),
                        s
                    ]));
                }()
            ]);
        }());
    }), NV = F2(function(n, r) {
        var t = A2(TZ, n.xl, r.DQ), e = qV(r.yz), u = A2(Cq, e, n.qi), a = A2(nk, x([
            Xx("quote-info__rate--muted")
        ]), x([
            A2(Ck, yu, A7(MV, n.xl, r.yj, !0, Vt(r.yz), kF, !1, !1))
        ]));
        return A2(nk, h, x([
            DZ({
                j4: a,
                kc: !0,
                kx: u,
                rH: !1,
                rQ: A2(DV, n.xl, r.yz),
                k2: n.tM(e),
                lG: t,
                xl: n.xl
            }),
            u ? A2(BV, n, r) : ld("")
        ]));
    }), HV = function(n) {
        return A2(Eu, function(r) {
            return A2(NV, n, r);
        }, n.Eg.vr);
    }, TV = function(n) {
        return A3(de, ue, 0, n);
    }, IV = F2(function(n, r) {
        return A2(nk, x([
            Xx("flex justify-between text-sm")
        ]), x([
            A2(FI, x([
                $H
            ]), x([
                ld(n)
            ])),
            A2(FI, x([
                $H
            ]), x([
                ld(lV(r))
            ]))
        ]));
    }), RV = function(n) {
        return n.lp;
    }, ZV = function(n) {
        return n.lI;
    }, VV = function(n) {
        return n.lj;
    }, UV = F2(function(n, r) {
        if (hV(r)) {
            var t = VV(r);
            return t > 0 ? Vt(A2(IV, _V(r), t)) : Ut;
        }
        if (A2(pV, n, r)) return Ut;
        var e = AV(r);
        return e > 0 ? Vt(A2(IV, _V(r), e)) : Ut;
    }), YV = function(n) {
        var r = TV(A2(Eu, ZV, n.rL)), t = r > 0 ? x([
            A2(IV, n.xl(Zd), r)
        ]) : h, e = TV(A2(Eu, RV, n.rL)), u = $(e > 0 ? x([
            A2(IV, n.xl(MZ), e)
        ]) : h, $(A2(Tp, UV(n), n.rL), t));
        return A2(nk, x([
            Xx("pl-3 border-l border-primary-200 mt-1 mb-2 flex flex-col gap-1")
        ]), u);
    }, QV = function(n) {
        return A2(nk, h, x([
            DZ({
                j4: A2(Ck, yu, A7(MV, n.xl, n.Eg.pG, !1, Ut, kF, !1, !1)),
                kc: !0,
                kx: n.ks,
                rH: !0,
                rQ: n.xl(SZ),
                k2: n.tK,
                lG: Ut,
                xl: n.xl
            }),
            n.ks ? YV(n) : ld("")
        ]));
    }, OV = function(n) {
        return A2(nk, x([
            Xx("flex flex-col gap-3")
        ]), $(function(n) {
            var r = TV(A2(Eu, function(n) {
                return n.yj;
            }, n.Eg.vr)), t = n.Eg.pG;
            return t || r ? t ? r ? i(t, r) && 1 === be(n.Eg.vr) ? HV(n) : A2(Yt, QV(n), HV(n)) : x([
                QV(n)
            ]) : HV(n) : h;
        }(n), x([
            BZ(n)
        ])));
    }, GV = function(n) {
        var r = n.AX, t = n.zm;
        return A2(nk, x([
            Xx("flex w-full")
        ]), x([
            A2(nk, x([
                Xx("flex-1")
            ]), r),
            A2(nk, x([
                Xx("hidden md:block")
            ]), x([
                t
            ]))
        ]));
    }, JV = function(n) {
        return A2(nk, x([
            Xx("md:hidden mt-auto")
        ]), x([
            n
        ]));
    }, WV = function(n) {
        return n.be.zC;
    }, KV = function(n) {
        return n.be.AJ;
    }, XV = function(n) {
        return n.be.Bc;
    }, nU = function(n) {
        return n.be.Ca;
    }, rU = function(n) {
        return n.be.Cc;
    }, tU = function(n) {
        return n.be.CU;
    }, eU = function(n) {
        return n.be.Em;
    }, uU = function(n) {
        return n.a.rh;
    }, aU = function(n) {
        return n.a.tg;
    }, iU = F3(function(n, r, t) {
        var e = n(eU);
        return 3 === r.$ ? A2(sc, e, A2(Wu, t, Ul(A2(Eu, function(n) {
            return b(uU(n), aU(n));
        }, r.a)))) : e;
    }), cU = F2(function(n, r) {
        return A2(nk, x([
            Xx("cart-item-card" + (n.ke ? " cart-item-card--compact" : ""))
        ]), r);
    }), oU = function(n) {
        return A2(PC, x([
            Vq("button"),
            Xx("cart-item-card__actions-button"),
            A2(jC, "aria-label", n.xl(KV))
        ]), x([
            A2(PE, x([
                HB
            ]), 39)
        ]));
    }, fU = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("cart-item-card__header")
        ]), x([
            A2(nk, x([
                Xx("cart-item-card__heading")
            ]), x([
                A2(Ek, h, x([
                    ld(r)
                ])),
                function() {
                    if (t.$) return ld("");
                    var n = t.a;
                    return A2(FI, x([
                        $H
                    ]), x([
                        ld(n)
                    ]));
                }()
            ])),
            oU(n)
        ]));
    }), sU = F3(function(n, r, t) {
        var e = r.$ ? n.xl(eU) : n.sw(r.a);
        return A2(nk, x([
            Xx("cart-item-card__member-section")
        ]), A2(Yt, function(n) {
            return A2(nk, x([
                Xx("cart-item-card__member-row")
            ]), x([
                A2(PE, x([
                    HB,
                    MB("text-primary-500")
                ]), 37),
                A2(FI, h, x([
                    ld(n)
                ]))
            ]));
        }(e), t));
    }), lU = F2(function(n, r) {
        return r.nt(n);
    }), dU = F2(function(n, r) {
        return A2(Fp, fp(n(qZ)), B$(uy(r)));
    }), bU = F2(function(n, r) {
        return A2(sc, n.xl(tU), A2(Fp, A2(ru, lU, n.xl), A2(nv, dU(n.xl), r)));
    }), vU = function(n) {
        return n.tU;
    }, mU = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("cart-item-card__price-row")
        ]), x([
            A2(FI, x([
                $H
            ]), x([
                ld(n)
            ])),
            function() {
                if (t.$) return A2(FI, h, x([
                    ld(lV(r))
                ]));
                var n = t.a;
                return A2(nk, x([
                    Xx("cart-item-card__suffix-group")
                ]), x([
                    A2(FI, h, x([
                        ld(lV(r))
                    ])),
                    A2(FI, x([
                        $H,
                        EZ
                    ]), x([
                        ld(n)
                    ]))
                ]));
            }()
        ]));
    }), pU = F2(function(n, r) {
        var t = A2(bU, n, mV(r)), e = RV(r) > 0 ? x([
            A3(mU, n.xl(rU) + " " + n.xl(WV), RV(r), Ut)
        ]) : h, u = A2(Fp, yV(n.xl), IZ(r)), a = A3(mU, n.xl(XV), AV(r), u);
        return A2(cU, {
            ke: !1
        }, x([
            A3(fU, n, _V(r), Vt(t)),
            A3(sU, n, vU(r), A2(Yt, a, e))
        ]));
    }), $U = F2(function(n, r) {
        return A2(cU, {
            ke: !0
        }, x([
            A3(fU, n, _V(r), Ut),
            A3(sU, n, vU(r), x([
                A3(mU, n.xl(nU), VV(r), Ut)
            ]))
        ]));
    }), hU = F2(function(n, r) {
        return A2(1 === hV(r) ? $U : pU, n, r);
    }), gU = F2(function(n, r) {
        var t = {
            sw: A2(iU, n, r.A8),
            xl: n
        };
        return A2(nk, x([
            Xx("flex flex-col gap-3 mb-4 md:mb-0")
        ]), A2(Eu, hU(t), r.aW));
    }), wU = F2(function(n, r) {
        var t = {
            oN: TE(r.aW),
            oO: n(hZ),
            ks: r.ks,
            qi: r.qi,
            rL: r.aW,
            tG: yZ,
            tK: _Z,
            tM: AZ,
            Eg: r.Eg,
            xl: n
        };
        return x([
            GV({
                zm: A2(nk, x([
                    Xx("sidebar-wrap")
                ]), x([
                    OV(t)
                ])),
                AX: x([
                    A2(gU, n, r)
                ])
            }),
            JV(A2(nk, x([
                Xx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
            ]), x([
                OV(t)
            ])))
        ]);
    }), xU = function(n) {
        return A2(nk, x([
            Xx("flex flex-col"),
            A2(bT, "min-height", "calc(100vh - 12rem)")
        ]), x([
            A2(nk, x([
                Xx("panel flex-1 flex flex-col")
            ]), n)
        ]));
    }, kU = function(n) {
        var r = n.w5, t = n.By;
        return A2(nk, x([
            Xx("flex justify-between items-center mb-4")
        ]), x([
            A2(yC, h, x([
                ld(r)
            ])),
            A2(nk, x([
                Xx("cursor-pointer"),
                IC(t)
            ]), x([
                A2(Ck, yu, A2(PE, x([
                    ej
                ]), 2))
            ]))
        ]));
    }, yU = function(n) {
        return A2(nk, x([
            Xx("flex flex-col items-center justify-center flex-1 gap-4 py-12")
        ]), x([
            A2(Ck, yu, A2(PE, x([
                MB("size-18 text-primary-500")
            ]), 38)),
            A2(nk, x([
                Xx("text-center")
            ]), x([
                A2(Ak, h, x([
                    ld(n(wZ))
                ])),
                A2(Ek, x([
                    rB(DB),
                    $H
                ]), x([
                    ld(n(gZ))
                ]))
            ])),
            A2(OC, x([
                qC,
                EC($Z)
            ]), x([
                ld(n(xZ))
            ]))
        ]));
    }, _U = F2(function(n, r) {
        return {
            gN: x([
                xU(A2(Yt, kU({
                    By: $Z,
                    w5: n(kZ)
                }), TE(r.aW) ? x([
                    yU(n)
                ]) : A2(wU, n, r)))
            ]),
            w5: n(kZ)
        };
    }), AU = ZA({
        Ar: lZ,
        AQ: dZ,
        Db: bZ,
        DZ: function() {
            return zx;
        },
        En: pZ,
        Et: _U
    }), CU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BU = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), EU = function(n) {
        return {
            $: 3,
            a: n
        };
    }, DU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, qU = function(n) {
        return m(n, {
            hE: !0
        });
    }, FU = {
        $: 0
    }, PU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zU = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jU = A2(zU, 1, h), SU = F3(function(n, r, t) {
        return b({
            gF: r,
            g8: Ut,
            hb: Ut,
            ar: FU,
            Y: jU,
            hE: !1,
            rC: n,
            h8: !1,
            iy: da,
            CD: t,
            iJ: !1,
            w5: Ut
        }, A2(Nu, PU, RF));
    }), LU = A2(dD, 0, A2(Pk, oL, uu(PS))), MU = F3(function(n, r, t) {
        return A4(W_, n, vy(LU), t, rA(dL(r)));
    }), NU = F3(function(n, r, t) {
        return TE(r) ? t : $(t, x([
            A2(Y_, n, A2(fe, ",", r))
        ]));
    }), HU = F3(function(n, r, t) {
        return r.$ ? t : $(t, x([
            A2(Y_, n, r.a)
        ]));
    }), TU = F3(function(n, r, t) {
        return A3(NU, "locations", t, A3(HU, "plan_id", r, x([
            A2(Y_, "owner_id", n)
        ])));
    }), IU = F7(function(n, r, t, e, u, a, i) {
        return {
            lT: r,
            lU: t,
            oR: e,
            rh: n,
            tg: u,
            t6: a,
            vJ: i
        };
    }), RU = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), ZU = A3(ly, "name", A2(tu, RE, C$), A3(ly, "id", C$, uu(RU))), VU = A2(Pk, ZU, uu(iu)), UU = A3(ly, "required", jk, A3(ly, "patient", VU, A3(ly, "name", C$, A3(ly, "current_document_version", cL, A3(ly, "acceptance_type", A2(nu, nL, C$), A3(ly, "acceptance_text", C$, A3(ly, "id", C$, uu(IU)))))))), YU = A2(Pk, UU, uu(iu)), QU = F4(function(n, r, t, e) {
        return A4(W_, n, vy(YU), e, A2(_P, t, rA(function(n) {
            return A2(X_, x([
                "documents"
            ]), lL(n));
        }(r))));
    }), OU = F7(function(n, r, t, e, u, a, i) {
        var c = a ? A3(HU, "only_signup", Vt("true"), A3(TU, e, t, u)) : A3(TU, e, t, u);
        return A4(QU, n, r, c, i);
    }), GU = function(n) {
        var r = n.t6;
        return 3 === r.$ ? Vt(EL(r.a)) : Ut;
    }, JU = function(n) {
        return n.fh.Bt;
    }, WU = function(n) {
        return n.fh.tF;
    }, KU = function(n) {
        return n.fh.Bu;
    }, XU = function(n) {
        return n.fh.is;
    }, nY = function(n) {
        return n.fM;
    }, rY = F2(function(n, r) {
        return m(r, {
            hb: Vt(n),
            iJ: !0
        });
    }), tY = F3(function(n, r) {
        var t = Bx(n), e = A2(Rc, function(n) {
            return !hV(n);
        }, r.aW), u = GU(r), a = Ul(A2(Eu, function(n) {
            return b(nY(n), cP);
        }, e)), i = A2(qx, qU, A2(qx, rY(KU), A3(SU, !0, r.gF, t))), c = i.a, o = i.b, f = function() {
            if (u.$) return v(h, Pp, vc);
            var n = u.a;
            return v(A2(Eu, function(e) {
                return A7(OU, r.gF, t, Vt(nY(e)), n, h, !0, BU(nY(e)));
            }, e), A3(MU, r.gF, t, EU), cP);
        }(), s = f.a, l = f.b;
        return b({
            gF: r.gF,
            aW: r.aW,
            dd: a,
            kA: r.kA,
            ff: f.c,
            Cr: u,
            aD: c,
            dB: n,
            cS: !1
        }, Vu(A2(Yt, A3(sZ, r.gF, t, CU), A2(Yt, A2(Lp, DU, o), A2(Yt, l, s)))));
    }), eY = F2(function(n, r) {
        return b(m(r, {
            aW: n.aW
        }), Pp);
    }), uY = F2(function(n, r) {
        return m(r, {
            x6: Ut
        });
    }), aY = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), iY = function(n) {
        return {
            $: 5,
            a: n
        };
    }, cY = function(n) {
        return "Enter" === n ? 0 : "Escape" === n ? 1 : 2;
    }, oY = A2(nu, function(n) {
        return "Enter" === n || "Escape" === n ? uu(cY(n)) : Sk("nothing");
    }, A2(Tu, "key", C$)), fY = function(n) {
        return A2(tu, n, oY);
    }, sY = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), lY = F2(function(n, r) {
        return {
            uA: r,
            wT: n
        };
    }), dY = _u(A2(lY, h, da)), bY = function(n) {
        return b($(n.a ? "w_" : "d_", n.b), n);
    }, vY = F6(function(n, r, t, e, u, a) {
        var i = A3(M_, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var o = i.a, f = o.a, l = o.b, d = i.b;
                    if (0 > s(f, e)) {
                        a = b(d, A3(n, f, l, c));
                        continue n;
                    }
                    return s(f, e) > 0 ? b(i, A3(t, e, u, c)) : b(d, A4(r, f, l, u, c));
                }
                return b(i, A3(t, e, u, c));
            }
        }), b(Ot(e), a), u), c = i.a, o = i.b;
        return A3(de, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), o, c);
    }), mY = F2(function(n, r) {
        return {
            hq: r,
            hQ: n
        };
    }), pY = F3(function(n, r, t) {
        return A2(qu, function(n) {
            return b(r, n);
        }, A3(Xr, t.a ? Kr : Wr, t.b, function(t) {
            return A2(Ty, n, A2(mY, r, t));
        }));
    }), $Y = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return v(e.a, e.b, A2(Yt, A3(pY, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return v(A2(Yt, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return v(e.a, A3(ta, n, r, e.b), u);
        }), i = A2(Eu, bY, r), c = A6(vY, u, a, e, t.uA, Ul(i), v(h, da, h)), o = c.b, f = c.c;
        return A2(Du, function(n) {
            return _u(A2(lY, i, A2(N_, o, Ul(n))));
        }, A2(Du, function() {
            return Pu(f);
        }, Pu(A2(Eu, Wy, c.a))));
    }), hY = F3(function(n, r, t) {
        var e = r.hQ, u = r.hq, a = A2(Tp, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(nt, r, u) : Ut;
        }, t.wT);
        return A2(Du, function() {
            return _u(t);
        }, Pu(A2(Eu, zu(n), a)));
    });
    Mn["Browser.Events"] = Nn(dY, $Y, hY, 0, F2(function(n, r) {
        return A3(sY, r.a, r.b, A2(tu, n, r.c));
    }));
    var gY, wY = Rn("Browser.Events"), xY = F3(function(n, r, t) {
        return wY(A3(sY, n, r, t));
    }), kY = A2(xY, 0, "keydown"), yY = function(n) {
        var r = n.ar;
        if (r.$) {
            var t = r.b;
            return Px(x([
                kY(fY(aY(b(t.a, t.b)))),
                A2(_S, iY, BS())
            ]));
        }
        return zx;
    }, _Y = F2(function(n, r) {
        return A2(zU, r.a, A2(Rc, n, r.b));
    }), AY = function(n) {
        return 1 === n.c1 || !n.aH.eQ;
    }, CY = function(n) {
        return be(n.b);
    }, BY = function(n) {
        return !CY(A2(_Y, function(n) {
            return !AY(n.b);
        }, n.Y));
    }, EY = function(n) {
        var r = n.a;
        return !!r.l0 && !!r.wO;
    }, DY = function(n) {
        return A2(Rc, EY, n);
    }, qY = function(n) {
        return n.rh;
    }, FY = function(n) {
        return n.aH.pt;
    }, PY = F2(function(n, r) {
        var t = r.a;
        return A2(zU, t + 1, $(r.b, x([
            b(t, n)
        ])));
    }), zY = function(n) {
        return A3(de, F2(function(n, r) {
            return A2(PY, n, r);
        }), jU, n);
    }, jY = function(n) {
        return n.a.lU;
    }, SY = function(n) {
        return n.a.oR;
    }, LY = function(n) {
        return n.a.pt;
    }, MY = function(n) {
        return {
            lU: n.lU,
            la: n.la,
            dU: ""
        };
    }, NY = F3(function(n, r, t) {
        return {
            c1: 0,
            gF: n,
            bl: Ut,
            aH: t,
            cr: Ut,
            kB: lS(MY(t)),
            eU: Ut,
            CD: r
        };
    }), HY = function(n) {
        return n.a.vJ;
    }, TY = function(n) {
        return n.a.tg;
    }, IY = function(n) {
        return function(n) {
            return n.tg;
        }(n.a.wv);
    }, RY = F3(function(n, r, t) {
        var e, u = {
            lT: (e = t, e.a.lT),
            lU: jY(t),
            pt: LY(t),
            eD: SY(t),
            eQ: HY(t),
            tg: TY(t),
            la: IY(t)
        };
        return A3(NY, n, r, u);
    }), ZY = function(n) {
        return n.lU;
    }, VY = function(n) {
        return n.oR;
    }, UY = function(n) {
        return n.tg;
    }, YY = function(n) {
        return n.tg;
    }, QY = function(n) {
        return n.vJ;
    }, OY = F3(function(n, r, t) {
        var e, u = UY(t.t6), a = {
            lT: (e = t, e.lT),
            lU: ZY(t),
            pt: qY(t),
            eD: VY(t),
            eQ: QY(t),
            tg: YY(t),
            la: u
        };
        return A3(NY, n, r, a);
    }), GY = F3(function(n, r, t) {
        var e = A2(Eu, A2(OY, t.gF, t.CD), n), u = A2(Eu, FY, e);
        return m(t, {
            Y: zY($(e, A2(Rc, function(n) {
                return !A2(SE, FY(n), u);
            }, A2(Eu, A2(RY, t.gF, t.CD), r))))
        });
    }), JY = F2(function(n, r) {
        return m(r, {
            iy: n
        });
    }), WY = F4(function(n, r, t, e) {
        var u = 3 === t.$ ? DY(t.a) : h, a = Ul(A2(Eu, function(n) {
            return b(nY(n), _V(n));
        }, A2(Rc, function(n) {
            return !hV(n);
        }, n))), c = A2(tc, function(n) {
            var r = n.b;
            if (3 === r.$) {
                var t = r.a, e = A2(sc, "", A2(Wu, n.a, a));
                return A2(Eu, function(n) {
                    return b(n, e);
                }, t);
            }
            return h;
        }, Ot(r));
        return A2(JY, A3(de, F2(function(n, r) {
            var t = n.b, e = qY(n.a), u = A2(sc, h, A2(Wu, e, r));
            return vu(t) || A2(SE, t, u) ? r : A3(ta, e, $(u, x([
                t
            ])), r);
        }), da, c), A3(GY, A3(de, F2(function(n, r) {
            var t = n.a;
            return A2(jE, function(n) {
                return i(qY(n), qY(t));
            }, r) ? r : $(r, x([
                t
            ]));
        }), h, c), u, e));
    }), KY = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XY = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), nQ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), rQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tQ = {
        $: 1
    }, eQ = function(n) {
        return A2(fe, "-", x([
            "document-input",
            FY(n)
        ]));
    }, uQ = Wn("scrollIdToBottom", Ax), aQ = F3(function(n, r, t) {
        return A2(Eu, function(t) {
            return n(t) ? r(t) : t;
        }, t);
    }), iQ = F3(function(n, r, t) {
        return A3(aQ, n, cm(r), t);
    }), cQ = F3(function(n, r, t) {
        var e = t.b;
        return A2(zU, t.a, A3(iQ, function(n) {
            return i(r, n.a);
        }, b(r, n), e));
    }), oQ = {
        $: 0
    }, fQ = {
        $: 1
    }, sQ = {
        $: 2
    }, lQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dQ = function(n) {
        return i(n.eU, Vt(fQ));
    }, bQ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vQ = function(n) {
        return n.pv;
    }, mQ = function(n) {
        return n.rh;
    }, pQ = function(n) {
        return n.r4;
    }, $Q = Wn("openInNewWindow", Ax), hQ = function(n) {
        if (2 === n.$ && 6 === n.a.$) {
            var r = n.a;
            return x([
                A3(fA, r.a, r.b, r.c)
            ]);
        }
        return h;
    }, gQ = function(n) {
        return 1 === n.$ ? xc(m(n.a, {
            aG: !1
        })) : gc(m(n.a, {
            aG: !1
        }));
    }, wQ = F2(function(n, r) {
        return A2(X_, x([
            "documents",
            r
        ]), lL(n));
    }), xQ = F3(function(n, r, t) {
        return A2(X_, x([
            "document_versions",
            t
        ]), A2(wQ, n, r));
    }), kQ = A2(Tu, "url", C$), yQ = F5(function(n, r, t, e, u) {
        return A4(W_, gQ(n), kQ, u, rA(A2(X_, x([
            "signed_file_url"
        ]), A3(xQ, r, t, e))));
    }), _Q = F2(function(n, r) {
        if (n.$) return v(r, function() {
            switch(vQ(r.eD)){
                case 0:
                    return Pp;
                case 2:
                    return $Q(A2(sc, "", pQ(r.eD)));
                default:
                    return A5(yQ, r.gF, r.CD, r.k9, mQ(r.eD), bQ(!0));
            }
        }(), Ut);
        var t, e = n.a, u = n.b, a = uC(u);
        return v(m(r, {
            iY: u
        }), (t = b(e, a)).a && !t.b.$ ? $Q(t.b.a) : Pp, function() {
            if (2 === u.$) {
                var n = u.a;
                return Vt($(hQ(u), x([
                    gA(n)
                ])));
            }
            return Ut;
        }());
    }), AQ = F2(function(n, r) {
        return m(r, {
            dU: n
        });
    }), CQ = F2(function(n, r) {
        return A3(dN, AQ, n, r);
    }), BQ = function(n) {
        return n.R.x3;
    }, EQ = function(n) {
        return n.R.zj;
    }, DQ = function(n) {
        return n.R.kn;
    }, qQ = function(n) {
        return n.R.zl;
    }, FQ = function(n) {
        return n.R.Ay;
    }, PQ = function(n) {
        return n.R.Az;
    }, zQ = function(n) {
        return n.R.A6;
    }, jQ = function(n) {
        return n.R.kR;
    }, SQ = function(n) {
        return n.R.Bi;
    }, LQ = function(n) {
        return n.R.CK;
    }, MQ = function(n) {
        return n.R.CL;
    }, NQ = function(n) {
        return n.R.CM;
    }, HQ = function(n) {
        return n.R.C5;
    }, TQ = function(n) {
        return n.R.ws;
    }, IQ = function(n) {
        return n.R.xq;
    }, RQ = function(n) {
        return n.$ ? PQ : FQ;
    }, ZQ = function(n) {
        return 1 === n;
    }, VQ = function(n) {
        return XC(A3(kv, oM("\\s\\s+"), cm(" "), n));
    }, UQ = function(n) {
        return n.toLowerCase();
    }, YQ = F2(function(n, r) {
        var t = r;
        return i(UQ(VQ(n)), UQ(VQ(t)));
    }), QQ = F2(function(n, r) {
        return !r.$ && A2(YQ, n, r.a);
    }), OQ = F2(function(n, r) {
        return A2(YQ, n, r);
    }), GQ = F2(function(n, r) {
        var t = r.la, e = r.dU;
        if (ZQ(r.lU)) {
            var u = e;
            return !(A2(OQ, u, t) || A2(QQ, u, n));
        }
        return !1;
    }), JQ = F2(function(n, r) {
        return A2(GQ, n, r) ? x([
            b(0, dM(RQ(n)))
        ]) : h;
    }), WQ = F2(function(n, r) {
        var t = A2(BM, function(n) {
            return nM(x([
                JQ(n)
            ]));
        }(n), r);
        return t.$ ? b(t.a, !1) : b(t.a.a, !0);
    }), KQ = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = (l = A2(CQ, n.a, r.kB), dQ(r) ? A2(WQ, r.bl, l).a : l);
                return v(m(r, {
                    kB: t
                }), Pp, Ut);
            case 1:
                var e = A2(WQ, r.bl, r.kB), u = (t = e.a, e.b ? b(1, oQ) : b(0, fQ)), a = u.b;
                return v(m(r, {
                    c1: u.a,
                    kB: t,
                    eU: Vt(a)
                }), Pp, Vt(a));
            case 2:
                return v(m(r, {
                    c1: 0,
                    kB: A2(CQ, "", r.kB),
                    eU: Vt(sQ)
                }), Pp, Vt(sQ));
            default:
                var i = n.a, c = r.cr;
                if (c.$) return v(r, Pp, Ut);
                var o = A2(_Q, i, c.a), f = o.b, s = o.c;
                return v(m(r, {
                    cr: Vt(o.a)
                }), A2(Lp, lQ, f), A2(nv, function(n) {
                    return Vt(function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(n));
                }, s));
        }
        var l;
    }), XQ = F3(function(n, r, t) {
        var e = r.a, u = A2(KQ, t, r.b), a = u.a, i = u.b, c = u.c, o = A2(fS, 0, rQ(b(e, a))), f = o.b, s = m(n, {
            ar: A2(nQ, o.a, b(e, a)),
            Y: A3(cQ, a, e, n.Y)
        });
        if (c.$) return v(s, Vu(x([
            uQ(eQ(a)),
            A2(Lp, XY(b(e, a)), i)
        ])), Ut);
        switch(c.a.$){
            case 0:
                return v(m(s, {
                    ar: FU
                }), Vu(x([
                    f,
                    A2(Lp, XY(b(e, a)), i)
                ])), Vt(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(b(e, a))));
            case 2:
                return v(m(s, {
                    ar: FU
                }), Pp, Vt(KY(b(e, a))));
            case 1:
                return v(s, Vu(x([
                    uQ(eQ(a)),
                    A2(Lp, XY(b(e, a)), i)
                ])), Vt(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(b(e, a))));
            default:
                var l = c.a.a;
                return v(s, Vu(x([
                    uQ(eQ(a)),
                    A2(Lp, XY(b(e, a)), i)
                ])), Vt(function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(l)));
        }
    }), nO = F5(function(n, r, t, e, u) {
        return b({
            gF: n,
            eD: u,
            k9: t,
            $9: e,
            CD: r,
            iY: vc
        }, 1 === vQ(u) ? A5(yQ, n, r, t, mQ(u), bQ(!1)) : Pp);
    }), rO = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = t.a, u = t.b;
                return v(m(r, {
                    ar: FU
                }), Pp, Vt(KY(b(e, u))));
            case 1:
                var a = n.a, i = (e = a.a, function(n) {
                    var r = A5(nO, n.gF, n.CD, n.aH.pt, n.aH.tg, n.aH.eD), t = r.b;
                    return b(m(n, {
                        cr: Vt(r.a)
                    }), A2(Lp, lQ, t));
                }(u = a.b)), c = i.a, o = i.b, f = A2(fS, 0, rQ(b(e, c))), s = f.b;
                return v(m(r, {
                    ar: A2(nQ, f.a, b(e, c))
                }), Vu(x([
                    s,
                    A2(Lp, XY(b(e, c)), o)
                ])), Vt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(b(e, u))));
            case 5:
                var l = n.a, d = r.ar;
                if (d.$) {
                    var p = d.b, $ = (e = p.a, u = p.b, A2(lN, l, d.a)), h = $.b;
                    return v(m(r, {
                        ar: A2(nQ, $.a, b(e, u))
                    }), A2(Lp, iY, h), Ut);
                }
                return v(r, Pp, Ut);
            case 3:
                var g = n.a;
                switch(e = g.a, u = g.b, n.b){
                    case 0:
                        return A3(XQ, r, b(e, u), tQ);
                    case 1:
                        return v(m(r, {
                            ar: FU
                        }), Pp, Vt(KY(b(e, u))));
                    default:
                        return v(r, Pp, Ut);
                }
            case 2:
                var w = n.a;
                return l = n.b, A3(XQ, r, b(e = w.a, u = w.b), l);
            default:
                return v(m(r, {
                    g8: Vt(n.a)
                }), Pp, Ut);
        }
    }), tO = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(r, A2(AA, da, _a), h);
            case 5:
                return v(m(r, {
                    cS: !BY(r.aD)
                }), Pp, h);
            case 1:
                if (3 === (u = n.a).$) {
                    var t = u.a;
                    return v(m(r, {
                        aW: t.rL
                    }), Pp, x([
                        vZ(t.rL)
                    ]));
                }
                return v(r, Pp, A2(xA, 0, u));
            case 2:
                var e = A3(ta, n.a, u = n.b, r.dd);
                return v(m(r, {
                    dd: e,
                    aD: i = A4(WY, r.aW, e, r.ff, r.aD)
                }), Pp, A2(xA, 0, u));
            case 3:
                var u;
                return v(m(r, {
                    ff: u = n.a,
                    aD: i = A4(WY, r.aW, r.dd, u, r.aD)
                }), Pp, A2(xA, 0, u));
            default:
                var a = A2(rO, n.a, r.aD), i = a.a, c = a.b, o = a.c;
                return v(m(r, {
                    aD: i,
                    cS: o.$ || o.a.$ ? r.cS : r.cS && !BY(i)
                }), A2(Lp, DU, c), h);
        }
    }), eO = {
        $: 0
    }, uO = function(n) {
        return n.ns.w5;
    }, aO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cO = function(n) {
        return TE(n.b);
    }, oO = function(n) {
        return cO(n.Y);
    }, fO = A2(CN, AN(3), Vt(3)), sO = F2(function(n, r) {
        return A2(Eu, n, r.b);
    }), lO = {
        zn: !1,
        ik: !1,
        iX: !1
    }, dO = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    zn: n.a
                });
            case 2:
                return m(r, {
                    iX: n.a
                });
            default:
                return m(r, {
                    ik: !0
                });
        }
    }), bO = pH(2), vO = A2(CN, AN(2), Vt(0)), mO = F3(function(n, r, t) {
        var e = t ? x([
            A2(FI, x([
                bO,
                _H(vO)
            ]), x([
                ld("*")
            ]))
        ]) : h;
        return A2(WH, x([
            $H,
            fq,
            ok(x([
                Xx("block mb-4")
            ]))
        ]), A2(Yt, ld(n(r)), e));
    }), pO = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), $O = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, hO = function(n) {
        return 1 === n.c1;
    }, gO = function(n) {
        return n.aH.eQ;
    }, wO = DC(4), xO = function(n) {
        return n.us;
    }, kO = F2(function(n, r) {
        return r.ut(n);
    }), yO = function(n) {
        return ld(n.aH.tg);
    }, _O = F4(function(n, r, t, e) {
        var u, a, i = e.a, c = e.b, o = A2(sc, h, A2(Wu, FY(c), t)), f = TE(o) ? xO : kO(A2(fe, ", ", o)), s = A2(Ek, x([
            fq,
            $H,
            ok(x([
                Xx("ml-6")
            ])),
            _H(cR)
        ]), x([
            ld(n(f))
        ]));
        return A2(nk, x([
            Xx("px-1"),
            Hq((a = i, "pending-document-" + oe(a)))
        ]), x([
            A2(zN, x([
                KN(x([
                    Xx("mb-2 md:mb-3")
                ]))
            ]), x([
                A2(EN, h, x([
                    A2(HT, x([
                        zT(hO(c)),
                        PT(pO(b(i, c))),
                        $O(r.iX && !AY(c)),
                        FT(r.zn)
                    ]), x([
                        (u = c, ld(u.aH.lT)),
                        A2(ak, x([
                            Xx("pl-2"),
                            SC(x([
                                b("-mr-1", gO(c))
                            ]))
                        ]), x([
                            A2(OC, x([
                                wO,
                                EC(A2(pO, b(i, c), !0)),
                                uF(r.zn)
                            ]), x([
                                yO(c)
                            ]))
                        ])),
                        A2(ak, x([
                            Xx("form-group__label ml-1"),
                            SC(x([
                                b("form-group__label--required", gO(c))
                            ]))
                        ]), h)
                    ])),
                    s
                ]))
            ]))
        ]));
    }), AO = F2(function(n, r) {
        var t = b(n, r);
        return t.a ? WU : t.b ? JU : KU;
    }), CO = F3(function(n, r, t) {
        var e = A3(de, dO, lO, r), u = t.w5, a = t.Y, i = t.h8, c = t.rC, o = A2(sO, A3(_O, n, e, t.iy), a), f = t.hE ? o : A2(Yt, Dk, o), s = function() {
            if (u.$) return tB;
            var r = u.a;
            return A2(Ak, x([
                _H(fO)
            ]), x([
                ld(n(r))
            ]));
        }(), l = function() {
            var r = t.hb;
            if (r.$) {
                var e = x([
                    HH(n(A2(AO, c, i)))
                ]);
                return x([
                    s,
                    A2(XH, e, x([
                        A2(nk, x([
                            Xx("-mt-2 md:-mt-3")
                        ]), f)
                    ]))
                ]);
            }
            return x([
                s,
                A3(mO, n, r.a, t.iJ),
                A2(nk, h, f)
            ]);
        }();
        return A2(zN, x([
            KN(x([
                SC(x([
                    b("panel", e.ik)
                ]))
            ]))
        ]), x([
            A2(EN, h, l)
        ]));
    }), BO = {
        $: 2
    }, EO = function(n) {
        return A2(OC, x([
            oF,
            EC(BO)
        ]), x([
            ld(n(EQ))
        ]));
    }, DO = function(n) {
        return A2(OC, x([
            qC,
            EC(tQ)
        ]), x([
            ld(n(BQ))
        ]));
    }, qO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FO = A2(CN, AN(3), Vt(0)), PO = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), zO = function(n) {
        return A2(sm, Cm(n), qm(n));
    }, jO = function(n) {
        return " " === n || "\t" === n || "\n" === n || "\r" === n || "\f" === n || "\xa0" === n;
    }, SO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, LO = gt, MO = F4(function(n, r, t, e) {
        return A2(vm, pm, A4(mm, n, r, t, e));
    }), NO = function(n) {
        return function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                var e = A5(LO, r, n.ic, n.vZ, n.nQ, n.d), u = e.a, a = e.b, c = e.c;
                return i(u, -1) ? A2(em, !1, A4(MO, a, c, t, n.e)) : A3(um, 0 > s(n.ic, u), 0, {
                    nQ: c,
                    e: n.e,
                    m: n.m,
                    ic: u,
                    vZ: a,
                    d: n.d
                });
            };
        }(bm(n));
    }, HO = A2(zm, A2(sm, A2(sm, lm(iu), xm("<!")), xm("--")), A2(sm, Hm(NO("--\x3e")), xm("--\x3e"))), TO = A2(Vm, SO, HO), IO = x([
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "param",
        "source",
        "track",
        "wbr"
    ]), RO = function(n) {
        return A2(IS, h, function(r) {
            return Om(x([
                A2(Vm, function(n) {
                    return MS(A2(Yt, n, r));
                }, n),
                lm(LS(Ae(r)))
            ]));
        });
    }, ZO = A2(Vm, UQ, Hm(zO(function(n) {
        return !jO(n) && '"' !== n && "'" !== n && ">" !== n && "/" !== n && "=" !== n;
    }))), VO = Cm(Ie(";")), UO = Ul(x([
        b("Aacute", "\xc1"),
        b("aacute", "\xe1"),
        b("Abreve", "\u0102"),
        b("abreve", "\u0103"),
        b("ac", "\u223E"),
        b("acd", "\u223F"),
        b("acE", "\u223E\u0333"),
        b("Acirc", "\xc2"),
        b("acirc", "\xe2"),
        b("acute", "\xb4"),
        b("Acy", "\u0410"),
        b("acy", "\u0430"),
        b("AElig", "\xc6"),
        b("aelig", "\xe6"),
        b("af", "\u2061"),
        b("Afr", "\uD835\uDD04"),
        b("afr", "\uD835\uDD1E"),
        b("Agrave", "\xc0"),
        b("agrave", "\xe0"),
        b("alefsym", "\u2135"),
        b("aleph", "\u2135"),
        b("Alpha", "\u0391"),
        b("alpha", "\u03B1"),
        b("Amacr", "\u0100"),
        b("amacr", "\u0101"),
        b("amalg", "\u2A3F"),
        b("amp", "&"),
        b("AMP", "&"),
        b("andand", "\u2A55"),
        b("And", "\u2A53"),
        b("and", "\u2227"),
        b("andd", "\u2A5C"),
        b("andslope", "\u2A58"),
        b("andv", "\u2A5A"),
        b("ang", "\u2220"),
        b("ange", "\u29A4"),
        b("angle", "\u2220"),
        b("angmsdaa", "\u29A8"),
        b("angmsdab", "\u29A9"),
        b("angmsdac", "\u29AA"),
        b("angmsdad", "\u29AB"),
        b("angmsdae", "\u29AC"),
        b("angmsdaf", "\u29AD"),
        b("angmsdag", "\u29AE"),
        b("angmsdah", "\u29AF"),
        b("angmsd", "\u2221"),
        b("angrt", "\u221F"),
        b("angrtvb", "\u22BE"),
        b("angrtvbd", "\u299D"),
        b("angsph", "\u2222"),
        b("angst", "\xc5"),
        b("angzarr", "\u237C"),
        b("Aogon", "\u0104"),
        b("aogon", "\u0105"),
        b("Aopf", "\uD835\uDD38"),
        b("aopf", "\uD835\uDD52"),
        b("apacir", "\u2A6F"),
        b("ap", "\u2248"),
        b("apE", "\u2A70"),
        b("ape", "\u224A"),
        b("apid", "\u224B"),
        b("apos", "'"),
        b("ApplyFunction", "\u2061"),
        b("approx", "\u2248"),
        b("approxeq", "\u224A"),
        b("Aring", "\xc5"),
        b("aring", "\xe5"),
        b("Ascr", "\uD835\uDC9C"),
        b("ascr", "\uD835\uDCB6"),
        b("Assign", "\u2254"),
        b("ast", "*"),
        b("asymp", "\u2248"),
        b("asympeq", "\u224D"),
        b("Atilde", "\xc3"),
        b("atilde", "\xe3"),
        b("Auml", "\xc4"),
        b("auml", "\xe4"),
        b("awconint", "\u2233"),
        b("awint", "\u2A11"),
        b("backcong", "\u224C"),
        b("backepsilon", "\u03F6"),
        b("backprime", "\u2035"),
        b("backsim", "\u223D"),
        b("backsimeq", "\u22CD"),
        b("Backslash", "\u2216"),
        b("Barv", "\u2AE7"),
        b("barvee", "\u22BD"),
        b("barwed", "\u2305"),
        b("Barwed", "\u2306"),
        b("barwedge", "\u2305"),
        b("bbrk", "\u23B5"),
        b("bbrktbrk", "\u23B6"),
        b("bcong", "\u224C"),
        b("Bcy", "\u0411"),
        b("bcy", "\u0431"),
        b("bdquo", "\u201E"),
        b("becaus", "\u2235"),
        b("because", "\u2235"),
        b("Because", "\u2235"),
        b("bemptyv", "\u29B0"),
        b("bepsi", "\u03F6"),
        b("bernou", "\u212C"),
        b("Bernoullis", "\u212C"),
        b("Beta", "\u0392"),
        b("beta", "\u03B2"),
        b("beth", "\u2136"),
        b("between", "\u226C"),
        b("Bfr", "\uD835\uDD05"),
        b("bfr", "\uD835\uDD1F"),
        b("bigcap", "\u22C2"),
        b("bigcirc", "\u25EF"),
        b("bigcup", "\u22C3"),
        b("bigodot", "\u2A00"),
        b("bigoplus", "\u2A01"),
        b("bigotimes", "\u2A02"),
        b("bigsqcup", "\u2A06"),
        b("bigstar", "\u2605"),
        b("bigtriangledown", "\u25BD"),
        b("bigtriangleup", "\u25B3"),
        b("biguplus", "\u2A04"),
        b("bigvee", "\u22C1"),
        b("bigwedge", "\u22C0"),
        b("bkarow", "\u290D"),
        b("blacklozenge", "\u29EB"),
        b("blacksquare", "\u25AA"),
        b("blacktriangle", "\u25B4"),
        b("blacktriangledown", "\u25BE"),
        b("blacktriangleleft", "\u25C2"),
        b("blacktriangleright", "\u25B8"),
        b("blank", "\u2423"),
        b("blk12", "\u2592"),
        b("blk14", "\u2591"),
        b("blk34", "\u2593"),
        b("block", "\u2588"),
        b("bne", "=\u20E5"),
        b("bnequiv", "\u2261\u20E5"),
        b("bNot", "\u2AED"),
        b("bnot", "\u2310"),
        b("Bopf", "\uD835\uDD39"),
        b("bopf", "\uD835\uDD53"),
        b("bot", "\u22A5"),
        b("bottom", "\u22A5"),
        b("bowtie", "\u22C8"),
        b("boxbox", "\u29C9"),
        b("boxdl", "\u2510"),
        b("boxdL", "\u2555"),
        b("boxDl", "\u2556"),
        b("boxDL", "\u2557"),
        b("boxdr", "\u250C"),
        b("boxdR", "\u2552"),
        b("boxDr", "\u2553"),
        b("boxDR", "\u2554"),
        b("boxh", "\u2500"),
        b("boxH", "\u2550"),
        b("boxhd", "\u252C"),
        b("boxHd", "\u2564"),
        b("boxhD", "\u2565"),
        b("boxHD", "\u2566"),
        b("boxhu", "\u2534"),
        b("boxHu", "\u2567"),
        b("boxhU", "\u2568"),
        b("boxHU", "\u2569"),
        b("boxminus", "\u229F"),
        b("boxplus", "\u229E"),
        b("boxtimes", "\u22A0"),
        b("boxul", "\u2518"),
        b("boxuL", "\u255B"),
        b("boxUl", "\u255C"),
        b("boxUL", "\u255D"),
        b("boxur", "\u2514"),
        b("boxuR", "\u2558"),
        b("boxUr", "\u2559"),
        b("boxUR", "\u255A"),
        b("boxv", "\u2502"),
        b("boxV", "\u2551"),
        b("boxvh", "\u253C"),
        b("boxvH", "\u256A"),
        b("boxVh", "\u256B"),
        b("boxVH", "\u256C"),
        b("boxvl", "\u2524"),
        b("boxvL", "\u2561"),
        b("boxVl", "\u2562"),
        b("boxVL", "\u2563"),
        b("boxvr", "\u251C"),
        b("boxvR", "\u255E"),
        b("boxVr", "\u255F"),
        b("boxVR", "\u2560"),
        b("bprime", "\u2035"),
        b("breve", "\u02D8"),
        b("Breve", "\u02D8"),
        b("brvbar", "\xa6"),
        b("bscr", "\uD835\uDCB7"),
        b("Bscr", "\u212C"),
        b("bsemi", "\u204F"),
        b("bsim", "\u223D"),
        b("bsime", "\u22CD"),
        b("bsolb", "\u29C5"),
        b("bsol", "\\"),
        b("bsolhsub", "\u27C8"),
        b("bull", "\u2022"),
        b("bullet", "\u2022"),
        b("bump", "\u224E"),
        b("bumpE", "\u2AAE"),
        b("bumpe", "\u224F"),
        b("Bumpeq", "\u224E"),
        b("bumpeq", "\u224F"),
        b("Cacute", "\u0106"),
        b("cacute", "\u0107"),
        b("capand", "\u2A44"),
        b("capbrcup", "\u2A49"),
        b("capcap", "\u2A4B"),
        b("cap", "\u2229"),
        b("Cap", "\u22D2"),
        b("capcup", "\u2A47"),
        b("capdot", "\u2A40"),
        b("CapitalDifferentialD", "\u2145"),
        b("caps", "\u2229\uFE00"),
        b("caret", "\u2041"),
        b("caron", "\u02C7"),
        b("Cayleys", "\u212D"),
        b("ccaps", "\u2A4D"),
        b("Ccaron", "\u010C"),
        b("ccaron", "\u010D"),
        b("Ccedil", "\xc7"),
        b("ccedil", "\xe7"),
        b("Ccirc", "\u0108"),
        b("ccirc", "\u0109"),
        b("Cconint", "\u2230"),
        b("ccups", "\u2A4C"),
        b("ccupssm", "\u2A50"),
        b("Cdot", "\u010A"),
        b("cdot", "\u010B"),
        b("cedil", "\xb8"),
        b("Cedilla", "\xb8"),
        b("cemptyv", "\u29B2"),
        b("cent", "\xa2"),
        b("centerdot", "\xb7"),
        b("CenterDot", "\xb7"),
        b("cfr", "\uD835\uDD20"),
        b("Cfr", "\u212D"),
        b("CHcy", "\u0427"),
        b("chcy", "\u0447"),
        b("check", "\u2713"),
        b("checkmark", "\u2713"),
        b("Chi", "\u03A7"),
        b("chi", "\u03C7"),
        b("circ", "\u02C6"),
        b("circeq", "\u2257"),
        b("circlearrowleft", "\u21BA"),
        b("circlearrowright", "\u21BB"),
        b("circledast", "\u229B"),
        b("circledcirc", "\u229A"),
        b("circleddash", "\u229D"),
        b("CircleDot", "\u2299"),
        b("circledR", "\xae"),
        b("circledS", "\u24C8"),
        b("CircleMinus", "\u2296"),
        b("CirclePlus", "\u2295"),
        b("CircleTimes", "\u2297"),
        b("cir", "\u25CB"),
        b("cirE", "\u29C3"),
        b("cire", "\u2257"),
        b("cirfnint", "\u2A10"),
        b("cirmid", "\u2AEF"),
        b("cirscir", "\u29C2"),
        b("ClockwiseContourIntegral", "\u2232"),
        b("CloseCurlyDoubleQuote", "\u201D"),
        b("CloseCurlyQuote", "\u2019"),
        b("clubs", "\u2663"),
        b("clubsuit", "\u2663"),
        b("colon", ":"),
        b("Colon", "\u2237"),
        b("Colone", "\u2A74"),
        b("colone", "\u2254"),
        b("coloneq", "\u2254"),
        b("comma", ","),
        b("commat", "@"),
        b("comp", "\u2201"),
        b("compfn", "\u2218"),
        b("complement", "\u2201"),
        b("complexes", "\u2102"),
        b("cong", "\u2245"),
        b("congdot", "\u2A6D"),
        b("Congruent", "\u2261"),
        b("conint", "\u222E"),
        b("Conint", "\u222F"),
        b("ContourIntegral", "\u222E"),
        b("copf", "\uD835\uDD54"),
        b("Copf", "\u2102"),
        b("coprod", "\u2210"),
        b("Coproduct", "\u2210"),
        b("copy", "\xa9"),
        b("COPY", "\xa9"),
        b("copysr", "\u2117"),
        b("CounterClockwiseContourIntegral", "\u2233"),
        b("crarr", "\u21B5"),
        b("cross", "\u2717"),
        b("Cross", "\u2A2F"),
        b("Cscr", "\uD835\uDC9E"),
        b("cscr", "\uD835\uDCB8"),
        b("csub", "\u2ACF"),
        b("csube", "\u2AD1"),
        b("csup", "\u2AD0"),
        b("csupe", "\u2AD2"),
        b("ctdot", "\u22EF"),
        b("cudarrl", "\u2938"),
        b("cudarrr", "\u2935"),
        b("cuepr", "\u22DE"),
        b("cuesc", "\u22DF"),
        b("cularr", "\u21B6"),
        b("cularrp", "\u293D"),
        b("cupbrcap", "\u2A48"),
        b("cupcap", "\u2A46"),
        b("CupCap", "\u224D"),
        b("cup", "\u222A"),
        b("Cup", "\u22D3"),
        b("cupcup", "\u2A4A"),
        b("cupdot", "\u228D"),
        b("cupor", "\u2A45"),
        b("cups", "\u222A\uFE00"),
        b("curarr", "\u21B7"),
        b("curarrm", "\u293C"),
        b("curlyeqprec", "\u22DE"),
        b("curlyeqsucc", "\u22DF"),
        b("curlyvee", "\u22CE"),
        b("curlywedge", "\u22CF"),
        b("curren", "\xa4"),
        b("curvearrowleft", "\u21B6"),
        b("curvearrowright", "\u21B7"),
        b("cuvee", "\u22CE"),
        b("cuwed", "\u22CF"),
        b("cwconint", "\u2232"),
        b("cwint", "\u2231"),
        b("cylcty", "\u232D"),
        b("dagger", "\u2020"),
        b("Dagger", "\u2021"),
        b("daleth", "\u2138"),
        b("darr", "\u2193"),
        b("Darr", "\u21A1"),
        b("dArr", "\u21D3"),
        b("dash", "\u2010"),
        b("Dashv", "\u2AE4"),
        b("dashv", "\u22A3"),
        b("dbkarow", "\u290F"),
        b("dblac", "\u02DD"),
        b("Dcaron", "\u010E"),
        b("dcaron", "\u010F"),
        b("Dcy", "\u0414"),
        b("dcy", "\u0434"),
        b("ddagger", "\u2021"),
        b("ddarr", "\u21CA"),
        b("DD", "\u2145"),
        b("dd", "\u2146"),
        b("DDotrahd", "\u2911"),
        b("ddotseq", "\u2A77"),
        b("deg", "\xb0"),
        b("Del", "\u2207"),
        b("Delta", "\u0394"),
        b("delta", "\u03B4"),
        b("demptyv", "\u29B1"),
        b("dfisht", "\u297F"),
        b("Dfr", "\uD835\uDD07"),
        b("dfr", "\uD835\uDD21"),
        b("dHar", "\u2965"),
        b("dharl", "\u21C3"),
        b("dharr", "\u21C2"),
        b("DiacriticalAcute", "\xb4"),
        b("DiacriticalDot", "\u02D9"),
        b("DiacriticalDoubleAcute", "\u02DD"),
        b("DiacriticalGrave", "`"),
        b("DiacriticalTilde", "\u02DC"),
        b("diam", "\u22C4"),
        b("diamond", "\u22C4"),
        b("Diamond", "\u22C4"),
        b("diamondsuit", "\u2666"),
        b("diams", "\u2666"),
        b("die", "\xa8"),
        b("DifferentialD", "\u2146"),
        b("digamma", "\u03DD"),
        b("disin", "\u22F2"),
        b("div", "\xf7"),
        b("divide", "\xf7"),
        b("divideontimes", "\u22C7"),
        b("divonx", "\u22C7"),
        b("DJcy", "\u0402"),
        b("djcy", "\u0452"),
        b("dlcorn", "\u231E"),
        b("dlcrop", "\u230D"),
        b("dollar", "$"),
        b("Dopf", "\uD835\uDD3B"),
        b("dopf", "\uD835\uDD55"),
        b("Dot", "\xa8"),
        b("dot", "\u02D9"),
        b("DotDot", "\u20DC"),
        b("doteq", "\u2250"),
        b("doteqdot", "\u2251"),
        b("DotEqual", "\u2250"),
        b("dotminus", "\u2238"),
        b("dotplus", "\u2214"),
        b("dotsquare", "\u22A1"),
        b("doublebarwedge", "\u2306"),
        b("DoubleContourIntegral", "\u222F"),
        b("DoubleDot", "\xa8"),
        b("DoubleDownArrow", "\u21D3"),
        b("DoubleLeftArrow", "\u21D0"),
        b("DoubleLeftRightArrow", "\u21D4"),
        b("DoubleLeftTee", "\u2AE4"),
        b("DoubleLongLeftArrow", "\u27F8"),
        b("DoubleLongLeftRightArrow", "\u27FA"),
        b("DoubleLongRightArrow", "\u27F9"),
        b("DoubleRightArrow", "\u21D2"),
        b("DoubleRightTee", "\u22A8"),
        b("DoubleUpArrow", "\u21D1"),
        b("DoubleUpDownArrow", "\u21D5"),
        b("DoubleVerticalBar", "\u2225"),
        b("DownArrowBar", "\u2913"),
        b("downarrow", "\u2193"),
        b("DownArrow", "\u2193"),
        b("Downarrow", "\u21D3"),
        b("DownArrowUpArrow", "\u21F5"),
        b("DownBreve", "\u0311"),
        b("downdownarrows", "\u21CA"),
        b("downharpoonleft", "\u21C3"),
        b("downharpoonright", "\u21C2"),
        b("DownLeftRightVector", "\u2950"),
        b("DownLeftTeeVector", "\u295E"),
        b("DownLeftVectorBar", "\u2956"),
        b("DownLeftVector", "\u21BD"),
        b("DownRightTeeVector", "\u295F"),
        b("DownRightVectorBar", "\u2957"),
        b("DownRightVector", "\u21C1"),
        b("DownTeeArrow", "\u21A7"),
        b("DownTee", "\u22A4"),
        b("drbkarow", "\u2910"),
        b("drcorn", "\u231F"),
        b("drcrop", "\u230C"),
        b("Dscr", "\uD835\uDC9F"),
        b("dscr", "\uD835\uDCB9"),
        b("DScy", "\u0405"),
        b("dscy", "\u0455"),
        b("dsol", "\u29F6"),
        b("Dstrok", "\u0110"),
        b("dstrok", "\u0111"),
        b("dtdot", "\u22F1"),
        b("dtri", "\u25BF"),
        b("dtrif", "\u25BE"),
        b("duarr", "\u21F5"),
        b("duhar", "\u296F"),
        b("dwangle", "\u29A6"),
        b("DZcy", "\u040F"),
        b("dzcy", "\u045F"),
        b("dzigrarr", "\u27FF"),
        b("Eacute", "\xc9"),
        b("eacute", "\xe9"),
        b("easter", "\u2A6E"),
        b("Ecaron", "\u011A"),
        b("ecaron", "\u011B"),
        b("Ecirc", "\xca"),
        b("ecirc", "\xea"),
        b("ecir", "\u2256"),
        b("ecolon", "\u2255"),
        b("Ecy", "\u042D"),
        b("ecy", "\u044D"),
        b("eDDot", "\u2A77"),
        b("Edot", "\u0116"),
        b("edot", "\u0117"),
        b("eDot", "\u2251"),
        b("ee", "\u2147"),
        b("efDot", "\u2252"),
        b("Efr", "\uD835\uDD08"),
        b("efr", "\uD835\uDD22"),
        b("eg", "\u2A9A"),
        b("Egrave", "\xc8"),
        b("egrave", "\xe8"),
        b("egs", "\u2A96"),
        b("egsdot", "\u2A98"),
        b("el", "\u2A99"),
        b("Element", "\u2208"),
        b("elinters", "\u23E7"),
        b("ell", "\u2113"),
        b("els", "\u2A95"),
        b("elsdot", "\u2A97"),
        b("Emacr", "\u0112"),
        b("emacr", "\u0113"),
        b("empty", "\u2205"),
        b("emptyset", "\u2205"),
        b("EmptySmallSquare", "\u25FB"),
        b("emptyv", "\u2205"),
        b("EmptyVerySmallSquare", "\u25AB"),
        b("emsp13", "\u2004"),
        b("emsp14", "\u2005"),
        b("emsp", "\u2003"),
        b("ENG", "\u014A"),
        b("eng", "\u014B"),
        b("ensp", "\u2002"),
        b("Eogon", "\u0118"),
        b("eogon", "\u0119"),
        b("Eopf", "\uD835\uDD3C"),
        b("eopf", "\uD835\uDD56"),
        b("epar", "\u22D5"),
        b("eparsl", "\u29E3"),
        b("eplus", "\u2A71"),
        b("epsi", "\u03B5"),
        b("Epsilon", "\u0395"),
        b("epsilon", "\u03B5"),
        b("epsiv", "\u03F5"),
        b("eqcirc", "\u2256"),
        b("eqcolon", "\u2255"),
        b("eqsim", "\u2242"),
        b("eqslantgtr", "\u2A96"),
        b("eqslantless", "\u2A95"),
        b("Equal", "\u2A75"),
        b("equals", "="),
        b("EqualTilde", "\u2242"),
        b("equest", "\u225F"),
        b("Equilibrium", "\u21CC"),
        b("equiv", "\u2261"),
        b("equivDD", "\u2A78"),
        b("eqvparsl", "\u29E5"),
        b("erarr", "\u2971"),
        b("erDot", "\u2253"),
        b("escr", "\u212F"),
        b("Escr", "\u2130"),
        b("esdot", "\u2250"),
        b("Esim", "\u2A73"),
        b("esim", "\u2242"),
        b("Eta", "\u0397"),
        b("eta", "\u03B7"),
        b("ETH", "\xd0"),
        b("eth", "\xf0"),
        b("Euml", "\xcb"),
        b("euml", "\xeb"),
        b("euro", "\u20AC"),
        b("excl", "!"),
        b("exist", "\u2203"),
        b("Exists", "\u2203"),
        b("expectation", "\u2130"),
        b("exponentiale", "\u2147"),
        b("ExponentialE", "\u2147"),
        b("fallingdotseq", "\u2252"),
        b("Fcy", "\u0424"),
        b("fcy", "\u0444"),
        b("female", "\u2640"),
        b("ffilig", "\uFB03"),
        b("fflig", "\uFB00"),
        b("ffllig", "\uFB04"),
        b("Ffr", "\uD835\uDD09"),
        b("ffr", "\uD835\uDD23"),
        b("filig", "\uFB01"),
        b("FilledSmallSquare", "\u25FC"),
        b("FilledVerySmallSquare", "\u25AA"),
        b("fjlig", "fj"),
        b("flat", "\u266D"),
        b("fllig", "\uFB02"),
        b("fltns", "\u25B1"),
        b("fnof", "\u0192"),
        b("Fopf", "\uD835\uDD3D"),
        b("fopf", "\uD835\uDD57"),
        b("forall", "\u2200"),
        b("ForAll", "\u2200"),
        b("fork", "\u22D4"),
        b("forkv", "\u2AD9"),
        b("Fouriertrf", "\u2131"),
        b("fpartint", "\u2A0D"),
        b("frac12", "\xbd"),
        b("frac13", "\u2153"),
        b("frac14", "\xbc"),
        b("frac15", "\u2155"),
        b("frac16", "\u2159"),
        b("frac18", "\u215B"),
        b("frac23", "\u2154"),
        b("frac25", "\u2156"),
        b("frac34", "\xbe"),
        b("frac35", "\u2157"),
        b("frac38", "\u215C"),
        b("frac45", "\u2158"),
        b("frac56", "\u215A"),
        b("frac58", "\u215D"),
        b("frac78", "\u215E"),
        b("frasl", "\u2044"),
        b("frown", "\u2322"),
        b("fscr", "\uD835\uDCBB"),
        b("Fscr", "\u2131"),
        b("gacute", "\u01F5"),
        b("Gamma", "\u0393"),
        b("gamma", "\u03B3"),
        b("Gammad", "\u03DC"),
        b("gammad", "\u03DD"),
        b("gap", "\u2A86"),
        b("Gbreve", "\u011E"),
        b("gbreve", "\u011F"),
        b("Gcedil", "\u0122"),
        b("Gcirc", "\u011C"),
        b("gcirc", "\u011D"),
        b("Gcy", "\u0413"),
        b("gcy", "\u0433"),
        b("Gdot", "\u0120"),
        b("gdot", "\u0121"),
        b("ge", "\u2265"),
        b("gE", "\u2267"),
        b("gEl", "\u2A8C"),
        b("gel", "\u22DB"),
        b("geq", "\u2265"),
        b("geqq", "\u2267"),
        b("geqslant", "\u2A7E"),
        b("gescc", "\u2AA9"),
        b("ges", "\u2A7E"),
        b("gesdot", "\u2A80"),
        b("gesdoto", "\u2A82"),
        b("gesdotol", "\u2A84"),
        b("gesl", "\u22DB\uFE00"),
        b("gesles", "\u2A94"),
        b("Gfr", "\uD835\uDD0A"),
        b("gfr", "\uD835\uDD24"),
        b("gg", "\u226B"),
        b("Gg", "\u22D9"),
        b("ggg", "\u22D9"),
        b("gimel", "\u2137"),
        b("GJcy", "\u0403"),
        b("gjcy", "\u0453"),
        b("gla", "\u2AA5"),
        b("gl", "\u2277"),
        b("glE", "\u2A92"),
        b("glj", "\u2AA4"),
        b("gnap", "\u2A8A"),
        b("gnapprox", "\u2A8A"),
        b("gne", "\u2A88"),
        b("gnE", "\u2269"),
        b("gneq", "\u2A88"),
        b("gneqq", "\u2269"),
        b("gnsim", "\u22E7"),
        b("Gopf", "\uD835\uDD3E"),
        b("gopf", "\uD835\uDD58"),
        b("grave", "`"),
        b("GreaterEqual", "\u2265"),
        b("GreaterEqualLess", "\u22DB"),
        b("GreaterFullEqual", "\u2267"),
        b("GreaterGreater", "\u2AA2"),
        b("GreaterLess", "\u2277"),
        b("GreaterSlantEqual", "\u2A7E"),
        b("GreaterTilde", "\u2273"),
        b("Gscr", "\uD835\uDCA2"),
        b("gscr", "\u210A"),
        b("gsim", "\u2273"),
        b("gsime", "\u2A8E"),
        b("gsiml", "\u2A90"),
        b("gtcc", "\u2AA7"),
        b("gtcir", "\u2A7A"),
        b("gt", ">"),
        b("GT", ">"),
        b("Gt", "\u226B"),
        b("gtdot", "\u22D7"),
        b("gtlPar", "\u2995"),
        b("gtquest", "\u2A7C"),
        b("gtrapprox", "\u2A86"),
        b("gtrarr", "\u2978"),
        b("gtrdot", "\u22D7"),
        b("gtreqless", "\u22DB"),
        b("gtreqqless", "\u2A8C"),
        b("gtrless", "\u2277"),
        b("gtrsim", "\u2273"),
        b("gvertneqq", "\u2269\uFE00"),
        b("gvnE", "\u2269\uFE00"),
        b("Hacek", "\u02C7"),
        b("hairsp", "\u200A"),
        b("half", "\xbd"),
        b("hamilt", "\u210B"),
        b("HARDcy", "\u042A"),
        b("hardcy", "\u044A"),
        b("harrcir", "\u2948"),
        b("harr", "\u2194"),
        b("hArr", "\u21D4"),
        b("harrw", "\u21AD"),
        b("Hat", "^"),
        b("hbar", "\u210F"),
        b("Hcirc", "\u0124"),
        b("hcirc", "\u0125"),
        b("hearts", "\u2665"),
        b("heartsuit", "\u2665"),
        b("hellip", "\u2026"),
        b("hercon", "\u22B9"),
        b("hfr", "\uD835\uDD25"),
        b("Hfr", "\u210C"),
        b("HilbertSpace", "\u210B"),
        b("hksearow", "\u2925"),
        b("hkswarow", "\u2926"),
        b("hoarr", "\u21FF"),
        b("homtht", "\u223B"),
        b("hookleftarrow", "\u21A9"),
        b("hookrightarrow", "\u21AA"),
        b("hopf", "\uD835\uDD59"),
        b("Hopf", "\u210D"),
        b("horbar", "\u2015"),
        b("HorizontalLine", "\u2500"),
        b("hscr", "\uD835\uDCBD"),
        b("Hscr", "\u210B"),
        b("hslash", "\u210F"),
        b("Hstrok", "\u0126"),
        b("hstrok", "\u0127"),
        b("HumpDownHump", "\u224E"),
        b("HumpEqual", "\u224F"),
        b("hybull", "\u2043"),
        b("hyphen", "\u2010"),
        b("Iacute", "\xcd"),
        b("iacute", "\xed"),
        b("ic", "\u2063"),
        b("Icirc", "\xce"),
        b("icirc", "\xee"),
        b("Icy", "\u0418"),
        b("icy", "\u0438"),
        b("Idot", "\u0130"),
        b("IEcy", "\u0415"),
        b("iecy", "\u0435"),
        b("iexcl", "\xa1"),
        b("iff", "\u21D4"),
        b("ifr", "\uD835\uDD26"),
        b("Ifr", "\u2111"),
        b("Igrave", "\xcc"),
        b("igrave", "\xec"),
        b("ii", "\u2148"),
        b("iiiint", "\u2A0C"),
        b("iiint", "\u222D"),
        b("iinfin", "\u29DC"),
        b("iiota", "\u2129"),
        b("IJlig", "\u0132"),
        b("ijlig", "\u0133"),
        b("Imacr", "\u012A"),
        b("imacr", "\u012B"),
        b("image", "\u2111"),
        b("ImaginaryI", "\u2148"),
        b("imagline", "\u2110"),
        b("imagpart", "\u2111"),
        b("imath", "\u0131"),
        b("Im", "\u2111"),
        b("imof", "\u22B7"),
        b("imped", "\u01B5"),
        b("Implies", "\u21D2"),
        b("incare", "\u2105"),
        b("in", "\u2208"),
        b("infin", "\u221E"),
        b("infintie", "\u29DD"),
        b("inodot", "\u0131"),
        b("intcal", "\u22BA"),
        b("int", "\u222B"),
        b("Int", "\u222C"),
        b("integers", "\u2124"),
        b("Integral", "\u222B"),
        b("intercal", "\u22BA"),
        b("Intersection", "\u22C2"),
        b("intlarhk", "\u2A17"),
        b("intprod", "\u2A3C"),
        b("InvisibleComma", "\u2063"),
        b("InvisibleTimes", "\u2062"),
        b("IOcy", "\u0401"),
        b("iocy", "\u0451"),
        b("Iogon", "\u012E"),
        b("iogon", "\u012F"),
        b("Iopf", "\uD835\uDD40"),
        b("iopf", "\uD835\uDD5A"),
        b("Iota", "\u0399"),
        b("iota", "\u03B9"),
        b("iprod", "\u2A3C"),
        b("iquest", "\xbf"),
        b("iscr", "\uD835\uDCBE"),
        b("Iscr", "\u2110"),
        b("isin", "\u2208"),
        b("isindot", "\u22F5"),
        b("isinE", "\u22F9"),
        b("isins", "\u22F4"),
        b("isinsv", "\u22F3"),
        b("isinv", "\u2208"),
        b("it", "\u2062"),
        b("Itilde", "\u0128"),
        b("itilde", "\u0129"),
        b("Iukcy", "\u0406"),
        b("iukcy", "\u0456"),
        b("Iuml", "\xcf"),
        b("iuml", "\xef"),
        b("Jcirc", "\u0134"),
        b("jcirc", "\u0135"),
        b("Jcy", "\u0419"),
        b("jcy", "\u0439"),
        b("Jfr", "\uD835\uDD0D"),
        b("jfr", "\uD835\uDD27"),
        b("jmath", "\u0237"),
        b("Jopf", "\uD835\uDD41"),
        b("jopf", "\uD835\uDD5B"),
        b("Jscr", "\uD835\uDCA5"),
        b("jscr", "\uD835\uDCBF"),
        b("Jsercy", "\u0408"),
        b("jsercy", "\u0458"),
        b("Jukcy", "\u0404"),
        b("jukcy", "\u0454"),
        b("Kappa", "\u039A"),
        b("kappa", "\u03BA"),
        b("kappav", "\u03F0"),
        b("Kcedil", "\u0136"),
        b("kcedil", "\u0137"),
        b("Kcy", "\u041A"),
        b("kcy", "\u043A"),
        b("Kfr", "\uD835\uDD0E"),
        b("kfr", "\uD835\uDD28"),
        b("kgreen", "\u0138"),
        b("KHcy", "\u0425"),
        b("khcy", "\u0445"),
        b("KJcy", "\u040C"),
        b("kjcy", "\u045C"),
        b("Kopf", "\uD835\uDD42"),
        b("kopf", "\uD835\uDD5C"),
        b("Kscr", "\uD835\uDCA6"),
        b("kscr", "\uD835\uDCC0"),
        b("lAarr", "\u21DA"),
        b("Lacute", "\u0139"),
        b("lacute", "\u013A"),
        b("laemptyv", "\u29B4"),
        b("lagran", "\u2112"),
        b("Lambda", "\u039B"),
        b("lambda", "\u03BB"),
        b("lang", "\u27E8"),
        b("Lang", "\u27EA"),
        b("langd", "\u2991"),
        b("langle", "\u27E8"),
        b("lap", "\u2A85"),
        b("Laplacetrf", "\u2112"),
        b("laquo", "\xab"),
        b("larrb", "\u21E4"),
        b("larrbfs", "\u291F"),
        b("larr", "\u2190"),
        b("Larr", "\u219E"),
        b("lArr", "\u21D0"),
        b("larrfs", "\u291D"),
        b("larrhk", "\u21A9"),
        b("larrlp", "\u21AB"),
        b("larrpl", "\u2939"),
        b("larrsim", "\u2973"),
        b("larrtl", "\u21A2"),
        b("latail", "\u2919"),
        b("lAtail", "\u291B"),
        b("lat", "\u2AAB"),
        b("late", "\u2AAD"),
        b("lates", "\u2AAD\uFE00"),
        b("lbarr", "\u290C"),
        b("lBarr", "\u290E"),
        b("lbbrk", "\u2772"),
        b("lbrace", "{"),
        b("lbrack", "["),
        b("lbrke", "\u298B"),
        b("lbrksld", "\u298F"),
        b("lbrkslu", "\u298D"),
        b("Lcaron", "\u013D"),
        b("lcaron", "\u013E"),
        b("Lcedil", "\u013B"),
        b("lcedil", "\u013C"),
        b("lceil", "\u2308"),
        b("lcub", "{"),
        b("Lcy", "\u041B"),
        b("lcy", "\u043B"),
        b("ldca", "\u2936"),
        b("ldquo", "\u201C"),
        b("ldquor", "\u201E"),
        b("ldrdhar", "\u2967"),
        b("ldrushar", "\u294B"),
        b("ldsh", "\u21B2"),
        b("le", "\u2264"),
        b("lE", "\u2266"),
        b("LeftAngleBracket", "\u27E8"),
        b("LeftArrowBar", "\u21E4"),
        b("leftarrow", "\u2190"),
        b("LeftArrow", "\u2190"),
        b("Leftarrow", "\u21D0"),
        b("LeftArrowRightArrow", "\u21C6"),
        b("leftarrowtail", "\u21A2"),
        b("LeftCeiling", "\u2308"),
        b("LeftDoubleBracket", "\u27E6"),
        b("LeftDownTeeVector", "\u2961"),
        b("LeftDownVectorBar", "\u2959"),
        b("LeftDownVector", "\u21C3"),
        b("LeftFloor", "\u230A"),
        b("leftharpoondown", "\u21BD"),
        b("leftharpoonup", "\u21BC"),
        b("leftleftarrows", "\u21C7"),
        b("leftrightarrow", "\u2194"),
        b("LeftRightArrow", "\u2194"),
        b("Leftrightarrow", "\u21D4"),
        b("leftrightarrows", "\u21C6"),
        b("leftrightharpoons", "\u21CB"),
        b("leftrightsquigarrow", "\u21AD"),
        b("LeftRightVector", "\u294E"),
        b("LeftTeeArrow", "\u21A4"),
        b("LeftTee", "\u22A3"),
        b("LeftTeeVector", "\u295A"),
        b("leftthreetimes", "\u22CB"),
        b("LeftTriangleBar", "\u29CF"),
        b("LeftTriangle", "\u22B2"),
        b("LeftTriangleEqual", "\u22B4"),
        b("LeftUpDownVector", "\u2951"),
        b("LeftUpTeeVector", "\u2960"),
        b("LeftUpVectorBar", "\u2958"),
        b("LeftUpVector", "\u21BF"),
        b("LeftVectorBar", "\u2952"),
        b("LeftVector", "\u21BC"),
        b("lEg", "\u2A8B"),
        b("leg", "\u22DA"),
        b("leq", "\u2264"),
        b("leqq", "\u2266"),
        b("leqslant", "\u2A7D"),
        b("lescc", "\u2AA8"),
        b("les", "\u2A7D"),
        b("lesdot", "\u2A7F"),
        b("lesdoto", "\u2A81"),
        b("lesdotor", "\u2A83"),
        b("lesg", "\u22DA\uFE00"),
        b("lesges", "\u2A93"),
        b("lessapprox", "\u2A85"),
        b("lessdot", "\u22D6"),
        b("lesseqgtr", "\u22DA"),
        b("lesseqqgtr", "\u2A8B"),
        b("LessEqualGreater", "\u22DA"),
        b("LessFullEqual", "\u2266"),
        b("LessGreater", "\u2276"),
        b("lessgtr", "\u2276"),
        b("LessLess", "\u2AA1"),
        b("lesssim", "\u2272"),
        b("LessSlantEqual", "\u2A7D"),
        b("LessTilde", "\u2272"),
        b("lfisht", "\u297C"),
        b("lfloor", "\u230A"),
        b("Lfr", "\uD835\uDD0F"),
        b("lfr", "\uD835\uDD29"),
        b("lg", "\u2276"),
        b("lgE", "\u2A91"),
        b("lHar", "\u2962"),
        b("lhard", "\u21BD"),
        b("lharu", "\u21BC"),
        b("lharul", "\u296A"),
        b("lhblk", "\u2584"),
        b("LJcy", "\u0409"),
        b("ljcy", "\u0459"),
        b("llarr", "\u21C7"),
        b("ll", "\u226A"),
        b("Ll", "\u22D8"),
        b("llcorner", "\u231E"),
        b("Lleftarrow", "\u21DA"),
        b("llhard", "\u296B"),
        b("lltri", "\u25FA"),
        b("Lmidot", "\u013F"),
        b("lmidot", "\u0140"),
        b("lmoustache", "\u23B0"),
        b("lmoust", "\u23B0"),
        b("lnap", "\u2A89"),
        b("lnapprox", "\u2A89"),
        b("lne", "\u2A87"),
        b("lnE", "\u2268"),
        b("lneq", "\u2A87"),
        b("lneqq", "\u2268"),
        b("lnsim", "\u22E6"),
        b("loang", "\u27EC"),
        b("loarr", "\u21FD"),
        b("lobrk", "\u27E6"),
        b("longleftarrow", "\u27F5"),
        b("LongLeftArrow", "\u27F5"),
        b("Longleftarrow", "\u27F8"),
        b("longleftrightarrow", "\u27F7"),
        b("LongLeftRightArrow", "\u27F7"),
        b("Longleftrightarrow", "\u27FA"),
        b("longmapsto", "\u27FC"),
        b("longrightarrow", "\u27F6"),
        b("LongRightArrow", "\u27F6"),
        b("Longrightarrow", "\u27F9"),
        b("looparrowleft", "\u21AB"),
        b("looparrowright", "\u21AC"),
        b("lopar", "\u2985"),
        b("Lopf", "\uD835\uDD43"),
        b("lopf", "\uD835\uDD5D"),
        b("loplus", "\u2A2D"),
        b("lotimes", "\u2A34"),
        b("lowast", "\u2217"),
        b("lowbar", "_"),
        b("LowerLeftArrow", "\u2199"),
        b("LowerRightArrow", "\u2198"),
        b("loz", "\u25CA"),
        b("lozenge", "\u25CA"),
        b("lozf", "\u29EB"),
        b("lpar", "("),
        b("lparlt", "\u2993"),
        b("lrarr", "\u21C6"),
        b("lrcorner", "\u231F"),
        b("lrhar", "\u21CB"),
        b("lrhard", "\u296D"),
        b("lrm", "\u200E"),
        b("lrtri", "\u22BF"),
        b("lsaquo", "\u2039"),
        b("lscr", "\uD835\uDCC1"),
        b("Lscr", "\u2112"),
        b("lsh", "\u21B0"),
        b("Lsh", "\u21B0"),
        b("lsim", "\u2272"),
        b("lsime", "\u2A8D"),
        b("lsimg", "\u2A8F"),
        b("lsqb", "["),
        b("lsquo", "\u2018"),
        b("lsquor", "\u201A"),
        b("Lstrok", "\u0141"),
        b("lstrok", "\u0142"),
        b("ltcc", "\u2AA6"),
        b("ltcir", "\u2A79"),
        b("lt", "<"),
        b("LT", "<"),
        b("Lt", "\u226A"),
        b("ltdot", "\u22D6"),
        b("lthree", "\u22CB"),
        b("ltimes", "\u22C9"),
        b("ltlarr", "\u2976"),
        b("ltquest", "\u2A7B"),
        b("ltri", "\u25C3"),
        b("ltrie", "\u22B4"),
        b("ltrif", "\u25C2"),
        b("ltrPar", "\u2996"),
        b("lurdshar", "\u294A"),
        b("luruhar", "\u2966"),
        b("lvertneqq", "\u2268\uFE00"),
        b("lvnE", "\u2268\uFE00"),
        b("macr", "\xaf"),
        b("male", "\u2642"),
        b("malt", "\u2720"),
        b("maltese", "\u2720"),
        b("Map", "\u2905"),
        b("map", "\u21A6"),
        b("mapsto", "\u21A6"),
        b("mapstodown", "\u21A7"),
        b("mapstoleft", "\u21A4"),
        b("mapstoup", "\u21A5"),
        b("marker", "\u25AE"),
        b("mcomma", "\u2A29"),
        b("Mcy", "\u041C"),
        b("mcy", "\u043C"),
        b("mdash", "\u2014"),
        b("mDDot", "\u223A"),
        b("measuredangle", "\u2221"),
        b("MediumSpace", "\u205F"),
        b("Mellintrf", "\u2133"),
        b("Mfr", "\uD835\uDD10"),
        b("mfr", "\uD835\uDD2A"),
        b("mho", "\u2127"),
        b("micro", "\xb5"),
        b("midast", "*"),
        b("midcir", "\u2AF0"),
        b("mid", "\u2223"),
        b("middot", "\xb7"),
        b("minusb", "\u229F"),
        b("minus", "\u2212"),
        b("minusd", "\u2238"),
        b("minusdu", "\u2A2A"),
        b("MinusPlus", "\u2213"),
        b("mlcp", "\u2ADB"),
        b("mldr", "\u2026"),
        b("mnplus", "\u2213"),
        b("models", "\u22A7"),
        b("Mopf", "\uD835\uDD44"),
        b("mopf", "\uD835\uDD5E"),
        b("mp", "\u2213"),
        b("mscr", "\uD835\uDCC2"),
        b("Mscr", "\u2133"),
        b("mstpos", "\u223E"),
        b("Mu", "\u039C"),
        b("mu", "\u03BC"),
        b("multimap", "\u22B8"),
        b("mumap", "\u22B8"),
        b("nabla", "\u2207"),
        b("Nacute", "\u0143"),
        b("nacute", "\u0144"),
        b("nang", "\u2220\u20D2"),
        b("nap", "\u2249"),
        b("napE", "\u2A70\u0338"),
        b("napid", "\u224B\u0338"),
        b("napos", "\u0149"),
        b("napprox", "\u2249"),
        b("natural", "\u266E"),
        b("naturals", "\u2115"),
        b("natur", "\u266E"),
        b("nbsp", "\xa0"),
        b("nbump", "\u224E\u0338"),
        b("nbumpe", "\u224F\u0338"),
        b("ncap", "\u2A43"),
        b("Ncaron", "\u0147"),
        b("ncaron", "\u0148"),
        b("Ncedil", "\u0145"),
        b("ncedil", "\u0146"),
        b("ncong", "\u2247"),
        b("ncongdot", "\u2A6D\u0338"),
        b("ncup", "\u2A42"),
        b("Ncy", "\u041D"),
        b("ncy", "\u043D"),
        b("ndash", "\u2013"),
        b("nearhk", "\u2924"),
        b("nearr", "\u2197"),
        b("neArr", "\u21D7"),
        b("nearrow", "\u2197"),
        b("ne", "\u2260"),
        b("nedot", "\u2250\u0338"),
        b("NegativeMediumSpace", "\u200B"),
        b("NegativeThickSpace", "\u200B"),
        b("NegativeThinSpace", "\u200B"),
        b("NegativeVeryThinSpace", "\u200B"),
        b("nequiv", "\u2262"),
        b("nesear", "\u2928"),
        b("nesim", "\u2242\u0338"),
        b("NestedGreaterGreater", "\u226B"),
        b("NestedLessLess", "\u226A"),
        b("NewLine", "\n"),
        b("nexist", "\u2204"),
        b("nexists", "\u2204"),
        b("Nfr", "\uD835\uDD11"),
        b("nfr", "\uD835\uDD2B"),
        b("ngE", "\u2267\u0338"),
        b("nge", "\u2271"),
        b("ngeq", "\u2271"),
        b("ngeqq", "\u2267\u0338"),
        b("ngeqslant", "\u2A7E\u0338"),
        b("nges", "\u2A7E\u0338"),
        b("nGg", "\u22D9\u0338"),
        b("ngsim", "\u2275"),
        b("nGt", "\u226B\u20D2"),
        b("ngt", "\u226F"),
        b("ngtr", "\u226F"),
        b("nGtv", "\u226B\u0338"),
        b("nharr", "\u21AE"),
        b("nhArr", "\u21CE"),
        b("nhpar", "\u2AF2"),
        b("ni", "\u220B"),
        b("nis", "\u22FC"),
        b("nisd", "\u22FA"),
        b("niv", "\u220B"),
        b("NJcy", "\u040A"),
        b("njcy", "\u045A"),
        b("nlarr", "\u219A"),
        b("nlArr", "\u21CD"),
        b("nldr", "\u2025"),
        b("nlE", "\u2266\u0338"),
        b("nle", "\u2270"),
        b("nleftarrow", "\u219A"),
        b("nLeftarrow", "\u21CD"),
        b("nleftrightarrow", "\u21AE"),
        b("nLeftrightarrow", "\u21CE"),
        b("nleq", "\u2270"),
        b("nleqq", "\u2266\u0338"),
        b("nleqslant", "\u2A7D\u0338"),
        b("nles", "\u2A7D\u0338"),
        b("nless", "\u226E"),
        b("nLl", "\u22D8\u0338"),
        b("nlsim", "\u2274"),
        b("nLt", "\u226A\u20D2"),
        b("nlt", "\u226E"),
        b("nltri", "\u22EA"),
        b("nltrie", "\u22EC"),
        b("nLtv", "\u226A\u0338"),
        b("nmid", "\u2224"),
        b("NoBreak", "\u2060"),
        b("NonBreakingSpace", "\xa0"),
        b("nopf", "\uD835\uDD5F"),
        b("Nopf", "\u2115"),
        b("Not", "\u2AEC"),
        b("not", "\xac"),
        b("NotCongruent", "\u2262"),
        b("NotCupCap", "\u226D"),
        b("NotDoubleVerticalBar", "\u2226"),
        b("NotElement", "\u2209"),
        b("NotEqual", "\u2260"),
        b("NotEqualTilde", "\u2242\u0338"),
        b("NotExists", "\u2204"),
        b("NotGreater", "\u226F"),
        b("NotGreaterEqual", "\u2271"),
        b("NotGreaterFullEqual", "\u2267\u0338"),
        b("NotGreaterGreater", "\u226B\u0338"),
        b("NotGreaterLess", "\u2279"),
        b("NotGreaterSlantEqual", "\u2A7E\u0338"),
        b("NotGreaterTilde", "\u2275"),
        b("NotHumpDownHump", "\u224E\u0338"),
        b("NotHumpEqual", "\u224F\u0338"),
        b("notin", "\u2209"),
        b("notindot", "\u22F5\u0338"),
        b("notinE", "\u22F9\u0338"),
        b("notinva", "\u2209"),
        b("notinvb", "\u22F7"),
        b("notinvc", "\u22F6"),
        b("NotLeftTriangleBar", "\u29CF\u0338"),
        b("NotLeftTriangle", "\u22EA"),
        b("NotLeftTriangleEqual", "\u22EC"),
        b("NotLess", "\u226E"),
        b("NotLessEqual", "\u2270"),
        b("NotLessGreater", "\u2278"),
        b("NotLessLess", "\u226A\u0338"),
        b("NotLessSlantEqual", "\u2A7D\u0338"),
        b("NotLessTilde", "\u2274"),
        b("NotNestedGreaterGreater", "\u2AA2\u0338"),
        b("NotNestedLessLess", "\u2AA1\u0338"),
        b("notni", "\u220C"),
        b("notniva", "\u220C"),
        b("notnivb", "\u22FE"),
        b("notnivc", "\u22FD"),
        b("NotPrecedes", "\u2280"),
        b("NotPrecedesEqual", "\u2AAF\u0338"),
        b("NotPrecedesSlantEqual", "\u22E0"),
        b("NotReverseElement", "\u220C"),
        b("NotRightTriangleBar", "\u29D0\u0338"),
        b("NotRightTriangle", "\u22EB"),
        b("NotRightTriangleEqual", "\u22ED"),
        b("NotSquareSubset", "\u228F\u0338"),
        b("NotSquareSubsetEqual", "\u22E2"),
        b("NotSquareSuperset", "\u2290\u0338"),
        b("NotSquareSupersetEqual", "\u22E3"),
        b("NotSubset", "\u2282\u20D2"),
        b("NotSubsetEqual", "\u2288"),
        b("NotSucceeds", "\u2281"),
        b("NotSucceedsEqual", "\u2AB0\u0338"),
        b("NotSucceedsSlantEqual", "\u22E1"),
        b("NotSucceedsTilde", "\u227F\u0338"),
        b("NotSuperset", "\u2283\u20D2"),
        b("NotSupersetEqual", "\u2289"),
        b("NotTilde", "\u2241"),
        b("NotTildeEqual", "\u2244"),
        b("NotTildeFullEqual", "\u2247"),
        b("NotTildeTilde", "\u2249"),
        b("NotVerticalBar", "\u2224"),
        b("nparallel", "\u2226"),
        b("npar", "\u2226"),
        b("nparsl", "\u2AFD\u20E5"),
        b("npart", "\u2202\u0338"),
        b("npolint", "\u2A14"),
        b("npr", "\u2280"),
        b("nprcue", "\u22E0"),
        b("nprec", "\u2280"),
        b("npreceq", "\u2AAF\u0338"),
        b("npre", "\u2AAF\u0338"),
        b("nrarrc", "\u2933\u0338"),
        b("nrarr", "\u219B"),
        b("nrArr", "\u21CF"),
        b("nrarrw", "\u219D\u0338"),
        b("nrightarrow", "\u219B"),
        b("nRightarrow", "\u21CF"),
        b("nrtri", "\u22EB"),
        b("nrtrie", "\u22ED"),
        b("nsc", "\u2281"),
        b("nsccue", "\u22E1"),
        b("nsce", "\u2AB0\u0338"),
        b("Nscr", "\uD835\uDCA9"),
        b("nscr", "\uD835\uDCC3"),
        b("nshortmid", "\u2224"),
        b("nshortparallel", "\u2226"),
        b("nsim", "\u2241"),
        b("nsime", "\u2244"),
        b("nsimeq", "\u2244"),
        b("nsmid", "\u2224"),
        b("nspar", "\u2226"),
        b("nsqsube", "\u22E2"),
        b("nsqsupe", "\u22E3"),
        b("nsub", "\u2284"),
        b("nsubE", "\u2AC5\u0338"),
        b("nsube", "\u2288"),
        b("nsubset", "\u2282\u20D2"),
        b("nsubseteq", "\u2288"),
        b("nsubseteqq", "\u2AC5\u0338"),
        b("nsucc", "\u2281"),
        b("nsucceq", "\u2AB0\u0338"),
        b("nsup", "\u2285"),
        b("nsupE", "\u2AC6\u0338"),
        b("nsupe", "\u2289"),
        b("nsupset", "\u2283\u20D2"),
        b("nsupseteq", "\u2289"),
        b("nsupseteqq", "\u2AC6\u0338"),
        b("ntgl", "\u2279"),
        b("Ntilde", "\xd1"),
        b("ntilde", "\xf1"),
        b("ntlg", "\u2278"),
        b("ntriangleleft", "\u22EA"),
        b("ntrianglelefteq", "\u22EC"),
        b("ntriangleright", "\u22EB"),
        b("ntrianglerighteq", "\u22ED"),
        b("Nu", "\u039D"),
        b("nu", "\u03BD"),
        b("num", "#"),
        b("numero", "\u2116"),
        b("numsp", "\u2007"),
        b("nvap", "\u224D\u20D2"),
        b("nvdash", "\u22AC"),
        b("nvDash", "\u22AD"),
        b("nVdash", "\u22AE"),
        b("nVDash", "\u22AF"),
        b("nvge", "\u2265\u20D2"),
        b("nvgt", ">\u20D2"),
        b("nvHarr", "\u2904"),
        b("nvinfin", "\u29DE"),
        b("nvlArr", "\u2902"),
        b("nvle", "\u2264\u20D2"),
        b("nvlt", "<\u20D2"),
        b("nvltrie", "\u22B4\u20D2"),
        b("nvrArr", "\u2903"),
        b("nvrtrie", "\u22B5\u20D2"),
        b("nvsim", "\u223C\u20D2"),
        b("nwarhk", "\u2923"),
        b("nwarr", "\u2196"),
        b("nwArr", "\u21D6"),
        b("nwarrow", "\u2196"),
        b("nwnear", "\u2927"),
        b("Oacute", "\xd3"),
        b("oacute", "\xf3"),
        b("oast", "\u229B"),
        b("Ocirc", "\xd4"),
        b("ocirc", "\xf4"),
        b("ocir", "\u229A"),
        b("Ocy", "\u041E"),
        b("ocy", "\u043E"),
        b("odash", "\u229D"),
        b("Odblac", "\u0150"),
        b("odblac", "\u0151"),
        b("odiv", "\u2A38"),
        b("odot", "\u2299"),
        b("odsold", "\u29BC"),
        b("OElig", "\u0152"),
        b("oelig", "\u0153"),
        b("ofcir", "\u29BF"),
        b("Ofr", "\uD835\uDD12"),
        b("ofr", "\uD835\uDD2C"),
        b("ogon", "\u02DB"),
        b("Ograve", "\xd2"),
        b("ograve", "\xf2"),
        b("ogt", "\u29C1"),
        b("ohbar", "\u29B5"),
        b("ohm", "\u03A9"),
        b("oint", "\u222E"),
        b("olarr", "\u21BA"),
        b("olcir", "\u29BE"),
        b("olcross", "\u29BB"),
        b("oline", "\u203E"),
        b("olt", "\u29C0"),
        b("Omacr", "\u014C"),
        b("omacr", "\u014D"),
        b("Omega", "\u03A9"),
        b("omega", "\u03C9"),
        b("Omicron", "\u039F"),
        b("omicron", "\u03BF"),
        b("omid", "\u29B6"),
        b("ominus", "\u2296"),
        b("Oopf", "\uD835\uDD46"),
        b("oopf", "\uD835\uDD60"),
        b("opar", "\u29B7"),
        b("OpenCurlyDoubleQuote", "\u201C"),
        b("OpenCurlyQuote", "\u2018"),
        b("operp", "\u29B9"),
        b("oplus", "\u2295"),
        b("orarr", "\u21BB"),
        b("Or", "\u2A54"),
        b("or", "\u2228"),
        b("ord", "\u2A5D"),
        b("order", "\u2134"),
        b("orderof", "\u2134"),
        b("ordf", "\xaa"),
        b("ordm", "\xba"),
        b("origof", "\u22B6"),
        b("oror", "\u2A56"),
        b("orslope", "\u2A57"),
        b("orv", "\u2A5B"),
        b("oS", "\u24C8"),
        b("Oscr", "\uD835\uDCAA"),
        b("oscr", "\u2134"),
        b("Oslash", "\xd8"),
        b("oslash", "\xf8"),
        b("osol", "\u2298"),
        b("Otilde", "\xd5"),
        b("otilde", "\xf5"),
        b("otimesas", "\u2A36"),
        b("Otimes", "\u2A37"),
        b("otimes", "\u2297"),
        b("Ouml", "\xd6"),
        b("ouml", "\xf6"),
        b("ovbar", "\u233D"),
        b("OverBar", "\u203E"),
        b("OverBrace", "\u23DE"),
        b("OverBracket", "\u23B4"),
        b("OverParenthesis", "\u23DC"),
        b("para", "\xb6"),
        b("parallel", "\u2225"),
        b("par", "\u2225"),
        b("parsim", "\u2AF3"),
        b("parsl", "\u2AFD"),
        b("part", "\u2202"),
        b("PartialD", "\u2202"),
        b("Pcy", "\u041F"),
        b("pcy", "\u043F"),
        b("percnt", "%"),
        b("period", "."),
        b("permil", "\u2030"),
        b("perp", "\u22A5"),
        b("pertenk", "\u2031"),
        b("Pfr", "\uD835\uDD13"),
        b("pfr", "\uD835\uDD2D"),
        b("Phi", "\u03A6"),
        b("phi", "\u03C6"),
        b("phiv", "\u03D5"),
        b("phmmat", "\u2133"),
        b("phone", "\u260E"),
        b("Pi", "\u03A0"),
        b("pi", "\u03C0"),
        b("pitchfork", "\u22D4"),
        b("piv", "\u03D6"),
        b("planck", "\u210F"),
        b("planckh", "\u210E"),
        b("plankv", "\u210F"),
        b("plusacir", "\u2A23"),
        b("plusb", "\u229E"),
        b("pluscir", "\u2A22"),
        b("plus", "+"),
        b("plusdo", "\u2214"),
        b("plusdu", "\u2A25"),
        b("pluse", "\u2A72"),
        b("PlusMinus", "\xb1"),
        b("plusmn", "\xb1"),
        b("plussim", "\u2A26"),
        b("plustwo", "\u2A27"),
        b("pm", "\xb1"),
        b("Poincareplane", "\u210C"),
        b("pointint", "\u2A15"),
        b("popf", "\uD835\uDD61"),
        b("Popf", "\u2119"),
        b("pound", "\xa3"),
        b("prap", "\u2AB7"),
        b("Pr", "\u2ABB"),
        b("pr", "\u227A"),
        b("prcue", "\u227C"),
        b("precapprox", "\u2AB7"),
        b("prec", "\u227A"),
        b("preccurlyeq", "\u227C"),
        b("Precedes", "\u227A"),
        b("PrecedesEqual", "\u2AAF"),
        b("PrecedesSlantEqual", "\u227C"),
        b("PrecedesTilde", "\u227E"),
        b("preceq", "\u2AAF"),
        b("precnapprox", "\u2AB9"),
        b("precneqq", "\u2AB5"),
        b("precnsim", "\u22E8"),
        b("pre", "\u2AAF"),
        b("prE", "\u2AB3"),
        b("precsim", "\u227E"),
        b("prime", "\u2032"),
        b("Prime", "\u2033"),
        b("primes", "\u2119"),
        b("prnap", "\u2AB9"),
        b("prnE", "\u2AB5"),
        b("prnsim", "\u22E8"),
        b("prod", "\u220F"),
        b("Product", "\u220F"),
        b("profalar", "\u232E"),
        b("profline", "\u2312"),
        b("profsurf", "\u2313"),
        b("prop", "\u221D"),
        b("Proportional", "\u221D"),
        b("Proportion", "\u2237"),
        b("propto", "\u221D"),
        b("prsim", "\u227E"),
        b("prurel", "\u22B0"),
        b("Pscr", "\uD835\uDCAB"),
        b("pscr", "\uD835\uDCC5"),
        b("Psi", "\u03A8"),
        b("psi", "\u03C8"),
        b("puncsp", "\u2008"),
        b("Qfr", "\uD835\uDD14"),
        b("qfr", "\uD835\uDD2E"),
        b("qint", "\u2A0C"),
        b("qopf", "\uD835\uDD62"),
        b("Qopf", "\u211A"),
        b("qprime", "\u2057"),
        b("Qscr", "\uD835\uDCAC"),
        b("qscr", "\uD835\uDCC6"),
        b("quaternions", "\u210D"),
        b("quatint", "\u2A16"),
        b("quest", "?"),
        b("questeq", "\u225F"),
        b("quot", '"'),
        b("QUOT", '"'),
        b("rAarr", "\u21DB"),
        b("race", "\u223D\u0331"),
        b("Racute", "\u0154"),
        b("racute", "\u0155"),
        b("radic", "\u221A"),
        b("raemptyv", "\u29B3"),
        b("rang", "\u27E9"),
        b("Rang", "\u27EB"),
        b("rangd", "\u2992"),
        b("range", "\u29A5"),
        b("rangle", "\u27E9"),
        b("raquo", "\xbb"),
        b("rarrap", "\u2975"),
        b("rarrb", "\u21E5"),
        b("rarrbfs", "\u2920"),
        b("rarrc", "\u2933"),
        b("rarr", "\u2192"),
        b("Rarr", "\u21A0"),
        b("rArr", "\u21D2"),
        b("rarrfs", "\u291E"),
        b("rarrhk", "\u21AA"),
        b("rarrlp", "\u21AC"),
        b("rarrpl", "\u2945"),
        b("rarrsim", "\u2974"),
        b("Rarrtl", "\u2916"),
        b("rarrtl", "\u21A3"),
        b("rarrw", "\u219D"),
        b("ratail", "\u291A"),
        b("rAtail", "\u291C"),
        b("ratio", "\u2236"),
        b("rationals", "\u211A"),
        b("rbarr", "\u290D"),
        b("rBarr", "\u290F"),
        b("RBarr", "\u2910"),
        b("rbbrk", "\u2773"),
        b("rbrace", "}"),
        b("rbrack", "]"),
        b("rbrke", "\u298C"),
        b("rbrksld", "\u298E"),
        b("rbrkslu", "\u2990"),
        b("Rcaron", "\u0158"),
        b("rcaron", "\u0159"),
        b("Rcedil", "\u0156"),
        b("rcedil", "\u0157"),
        b("rceil", "\u2309"),
        b("rcub", "}"),
        b("Rcy", "\u0420"),
        b("rcy", "\u0440"),
        b("rdca", "\u2937"),
        b("rdldhar", "\u2969"),
        b("rdquo", "\u201D"),
        b("rdquor", "\u201D"),
        b("rdsh", "\u21B3"),
        b("real", "\u211C"),
        b("realine", "\u211B"),
        b("realpart", "\u211C"),
        b("reals", "\u211D"),
        b("Re", "\u211C"),
        b("rect", "\u25AD"),
        b("reg", "\xae"),
        b("REG", "\xae"),
        b("ReverseElement", "\u220B"),
        b("ReverseEquilibrium", "\u21CB"),
        b("ReverseUpEquilibrium", "\u296F"),
        b("rfisht", "\u297D"),
        b("rfloor", "\u230B"),
        b("rfr", "\uD835\uDD2F"),
        b("Rfr", "\u211C"),
        b("rHar", "\u2964"),
        b("rhard", "\u21C1"),
        b("rharu", "\u21C0"),
        b("rharul", "\u296C"),
        b("Rho", "\u03A1"),
        b("rho", "\u03C1"),
        b("rhov", "\u03F1"),
        b("RightAngleBracket", "\u27E9"),
        b("RightArrowBar", "\u21E5"),
        b("rightarrow", "\u2192"),
        b("RightArrow", "\u2192"),
        b("Rightarrow", "\u21D2"),
        b("RightArrowLeftArrow", "\u21C4"),
        b("rightarrowtail", "\u21A3"),
        b("RightCeiling", "\u2309"),
        b("RightDoubleBracket", "\u27E7"),
        b("RightDownTeeVector", "\u295D"),
        b("RightDownVectorBar", "\u2955"),
        b("RightDownVector", "\u21C2"),
        b("RightFloor", "\u230B"),
        b("rightharpoondown", "\u21C1"),
        b("rightharpoonup", "\u21C0"),
        b("rightleftarrows", "\u21C4"),
        b("rightleftharpoons", "\u21CC"),
        b("rightrightarrows", "\u21C9"),
        b("rightsquigarrow", "\u219D"),
        b("RightTeeArrow", "\u21A6"),
        b("RightTee", "\u22A2"),
        b("RightTeeVector", "\u295B"),
        b("rightthreetimes", "\u22CC"),
        b("RightTriangleBar", "\u29D0"),
        b("RightTriangle", "\u22B3"),
        b("RightTriangleEqual", "\u22B5"),
        b("RightUpDownVector", "\u294F"),
        b("RightUpTeeVector", "\u295C"),
        b("RightUpVectorBar", "\u2954"),
        b("RightUpVector", "\u21BE"),
        b("RightVectorBar", "\u2953"),
        b("RightVector", "\u21C0"),
        b("ring", "\u02DA"),
        b("risingdotseq", "\u2253"),
        b("rlarr", "\u21C4"),
        b("rlhar", "\u21CC"),
        b("rlm", "\u200F"),
        b("rmoustache", "\u23B1"),
        b("rmoust", "\u23B1"),
        b("rnmid", "\u2AEE"),
        b("roang", "\u27ED"),
        b("roarr", "\u21FE"),
        b("robrk", "\u27E7"),
        b("ropar", "\u2986"),
        b("ropf", "\uD835\uDD63"),
        b("Ropf", "\u211D"),
        b("roplus", "\u2A2E"),
        b("rotimes", "\u2A35"),
        b("RoundImplies", "\u2970"),
        b("rpar", ")"),
        b("rpargt", "\u2994"),
        b("rppolint", "\u2A12"),
        b("rrarr", "\u21C9"),
        b("Rrightarrow", "\u21DB"),
        b("rsaquo", "\u203A"),
        b("rscr", "\uD835\uDCC7"),
        b("Rscr", "\u211B"),
        b("rsh", "\u21B1"),
        b("Rsh", "\u21B1"),
        b("rsqb", "]"),
        b("rsquo", "\u2019"),
        b("rsquor", "\u2019"),
        b("rthree", "\u22CC"),
        b("rtimes", "\u22CA"),
        b("rtri", "\u25B9"),
        b("rtrie", "\u22B5"),
        b("rtrif", "\u25B8"),
        b("rtriltri", "\u29CE"),
        b("RuleDelayed", "\u29F4"),
        b("ruluhar", "\u2968"),
        b("rx", "\u211E"),
        b("Sacute", "\u015A"),
        b("sacute", "\u015B"),
        b("sbquo", "\u201A"),
        b("scap", "\u2AB8"),
        b("Scaron", "\u0160"),
        b("scaron", "\u0161"),
        b("Sc", "\u2ABC"),
        b("sc", "\u227B"),
        b("sccue", "\u227D"),
        b("sce", "\u2AB0"),
        b("scE", "\u2AB4"),
        b("Scedil", "\u015E"),
        b("scedil", "\u015F"),
        b("Scirc", "\u015C"),
        b("scirc", "\u015D"),
        b("scnap", "\u2ABA"),
        b("scnE", "\u2AB6"),
        b("scnsim", "\u22E9"),
        b("scpolint", "\u2A13"),
        b("scsim", "\u227F"),
        b("Scy", "\u0421"),
        b("scy", "\u0441"),
        b("sdotb", "\u22A1"),
        b("sdot", "\u22C5"),
        b("sdote", "\u2A66"),
        b("searhk", "\u2925"),
        b("searr", "\u2198"),
        b("seArr", "\u21D8"),
        b("searrow", "\u2198"),
        b("sect", "\xa7"),
        b("semi", ";"),
        b("seswar", "\u2929"),
        b("setminus", "\u2216"),
        b("setmn", "\u2216"),
        b("sext", "\u2736"),
        b("Sfr", "\uD835\uDD16"),
        b("sfr", "\uD835\uDD30"),
        b("sfrown", "\u2322"),
        b("sharp", "\u266F"),
        b("SHCHcy", "\u0429"),
        b("shchcy", "\u0449"),
        b("SHcy", "\u0428"),
        b("shcy", "\u0448"),
        b("ShortDownArrow", "\u2193"),
        b("ShortLeftArrow", "\u2190"),
        b("shortmid", "\u2223"),
        b("shortparallel", "\u2225"),
        b("ShortRightArrow", "\u2192"),
        b("ShortUpArrow", "\u2191"),
        b("shy", "\xad"),
        b("Sigma", "\u03A3"),
        b("sigma", "\u03C3"),
        b("sigmaf", "\u03C2"),
        b("sigmav", "\u03C2"),
        b("sim", "\u223C"),
        b("simdot", "\u2A6A"),
        b("sime", "\u2243"),
        b("simeq", "\u2243"),
        b("simg", "\u2A9E"),
        b("simgE", "\u2AA0"),
        b("siml", "\u2A9D"),
        b("simlE", "\u2A9F"),
        b("simne", "\u2246"),
        b("simplus", "\u2A24"),
        b("simrarr", "\u2972"),
        b("slarr", "\u2190"),
        b("SmallCircle", "\u2218"),
        b("smallsetminus", "\u2216"),
        b("smashp", "\u2A33"),
        b("smeparsl", "\u29E4"),
        b("smid", "\u2223"),
        b("smile", "\u2323"),
        b("smt", "\u2AAA"),
        b("smte", "\u2AAC"),
        b("smtes", "\u2AAC\uFE00"),
        b("SOFTcy", "\u042C"),
        b("softcy", "\u044C"),
        b("solbar", "\u233F"),
        b("solb", "\u29C4"),
        b("sol", "/"),
        b("Sopf", "\uD835\uDD4A"),
        b("sopf", "\uD835\uDD64"),
        b("spades", "\u2660"),
        b("spadesuit", "\u2660"),
        b("spar", "\u2225"),
        b("sqcap", "\u2293"),
        b("sqcaps", "\u2293\uFE00"),
        b("sqcup", "\u2294"),
        b("sqcups", "\u2294\uFE00"),
        b("Sqrt", "\u221A"),
        b("sqsub", "\u228F"),
        b("sqsube", "\u2291"),
        b("sqsubset", "\u228F"),
        b("sqsubseteq", "\u2291"),
        b("sqsup", "\u2290"),
        b("sqsupe", "\u2292"),
        b("sqsupset", "\u2290"),
        b("sqsupseteq", "\u2292"),
        b("square", "\u25A1"),
        b("Square", "\u25A1"),
        b("SquareIntersection", "\u2293"),
        b("SquareSubset", "\u228F"),
        b("SquareSubsetEqual", "\u2291"),
        b("SquareSuperset", "\u2290"),
        b("SquareSupersetEqual", "\u2292"),
        b("SquareUnion", "\u2294"),
        b("squarf", "\u25AA"),
        b("squ", "\u25A1"),
        b("squf", "\u25AA"),
        b("srarr", "\u2192"),
        b("Sscr", "\uD835\uDCAE"),
        b("sscr", "\uD835\uDCC8"),
        b("ssetmn", "\u2216"),
        b("ssmile", "\u2323"),
        b("sstarf", "\u22C6"),
        b("Star", "\u22C6"),
        b("star", "\u2606"),
        b("starf", "\u2605"),
        b("straightepsilon", "\u03F5"),
        b("straightphi", "\u03D5"),
        b("strns", "\xaf"),
        b("sub", "\u2282"),
        b("Sub", "\u22D0"),
        b("subdot", "\u2ABD"),
        b("subE", "\u2AC5"),
        b("sube", "\u2286"),
        b("subedot", "\u2AC3"),
        b("submult", "\u2AC1"),
        b("subnE", "\u2ACB"),
        b("subne", "\u228A"),
        b("subplus", "\u2ABF"),
        b("subrarr", "\u2979"),
        b("subset", "\u2282"),
        b("Subset", "\u22D0"),
        b("subseteq", "\u2286"),
        b("subseteqq", "\u2AC5"),
        b("SubsetEqual", "\u2286"),
        b("subsetneq", "\u228A"),
        b("subsetneqq", "\u2ACB"),
        b("subsim", "\u2AC7"),
        b("subsub", "\u2AD5"),
        b("subsup", "\u2AD3"),
        b("succapprox", "\u2AB8"),
        b("succ", "\u227B"),
        b("succcurlyeq", "\u227D"),
        b("Succeeds", "\u227B"),
        b("SucceedsEqual", "\u2AB0"),
        b("SucceedsSlantEqual", "\u227D"),
        b("SucceedsTilde", "\u227F"),
        b("succeq", "\u2AB0"),
        b("succnapprox", "\u2ABA"),
        b("succneqq", "\u2AB6"),
        b("succnsim", "\u22E9"),
        b("succsim", "\u227F"),
        b("SuchThat", "\u220B"),
        b("sum", "\u2211"),
        b("Sum", "\u2211"),
        b("sung", "\u266A"),
        b("sup1", "\xb9"),
        b("sup2", "\xb2"),
        b("sup3", "\xb3"),
        b("sup", "\u2283"),
        b("Sup", "\u22D1"),
        b("supdot", "\u2ABE"),
        b("supdsub", "\u2AD8"),
        b("supE", "\u2AC6"),
        b("supe", "\u2287"),
        b("supedot", "\u2AC4"),
        b("Superset", "\u2283"),
        b("SupersetEqual", "\u2287"),
        b("suphsol", "\u27C9"),
        b("suphsub", "\u2AD7"),
        b("suplarr", "\u297B"),
        b("supmult", "\u2AC2"),
        b("supnE", "\u2ACC"),
        b("supne", "\u228B"),
        b("supplus", "\u2AC0"),
        b("supset", "\u2283"),
        b("Supset", "\u22D1"),
        b("supseteq", "\u2287"),
        b("supseteqq", "\u2AC6"),
        b("supsetneq", "\u228B"),
        b("supsetneqq", "\u2ACC"),
        b("supsim", "\u2AC8"),
        b("supsub", "\u2AD4"),
        b("supsup", "\u2AD6"),
        b("swarhk", "\u2926"),
        b("swarr", "\u2199"),
        b("swArr", "\u21D9"),
        b("swarrow", "\u2199"),
        b("swnwar", "\u292A"),
        b("szlig", "\xdf"),
        b("Tab", "\t"),
        b("target", "\u2316"),
        b("Tau", "\u03A4"),
        b("tau", "\u03C4"),
        b("tbrk", "\u23B4"),
        b("Tcaron", "\u0164"),
        b("tcaron", "\u0165"),
        b("Tcedil", "\u0162"),
        b("tcedil", "\u0163"),
        b("Tcy", "\u0422"),
        b("tcy", "\u0442"),
        b("tdot", "\u20DB"),
        b("telrec", "\u2315"),
        b("Tfr", "\uD835\uDD17"),
        b("tfr", "\uD835\uDD31"),
        b("there4", "\u2234"),
        b("therefore", "\u2234"),
        b("Therefore", "\u2234"),
        b("Theta", "\u0398"),
        b("theta", "\u03B8"),
        b("thetasym", "\u03D1"),
        b("thetav", "\u03D1"),
        b("thickapprox", "\u2248"),
        b("thicksim", "\u223C"),
        b("ThickSpace", "\u205F\u200A"),
        b("ThinSpace", "\u2009"),
        b("thinsp", "\u2009"),
        b("thkap", "\u2248"),
        b("thksim", "\u223C"),
        b("THORN", "\xde"),
        b("thorn", "\xfe"),
        b("tilde", "\u02DC"),
        b("Tilde", "\u223C"),
        b("TildeEqual", "\u2243"),
        b("TildeFullEqual", "\u2245"),
        b("TildeTilde", "\u2248"),
        b("timesbar", "\u2A31"),
        b("timesb", "\u22A0"),
        b("times", "\xd7"),
        b("timesd", "\u2A30"),
        b("tint", "\u222D"),
        b("toea", "\u2928"),
        b("topbot", "\u2336"),
        b("topcir", "\u2AF1"),
        b("top", "\u22A4"),
        b("Topf", "\uD835\uDD4B"),
        b("topf", "\uD835\uDD65"),
        b("topfork", "\u2ADA"),
        b("tosa", "\u2929"),
        b("tprime", "\u2034"),
        b("trade", "\u2122"),
        b("TRADE", "\u2122"),
        b("triangle", "\u25B5"),
        b("triangledown", "\u25BF"),
        b("triangleleft", "\u25C3"),
        b("trianglelefteq", "\u22B4"),
        b("triangleq", "\u225C"),
        b("triangleright", "\u25B9"),
        b("trianglerighteq", "\u22B5"),
        b("tridot", "\u25EC"),
        b("trie", "\u225C"),
        b("triminus", "\u2A3A"),
        b("TripleDot", "\u20DB"),
        b("triplus", "\u2A39"),
        b("trisb", "\u29CD"),
        b("tritime", "\u2A3B"),
        b("trpezium", "\u23E2"),
        b("Tscr", "\uD835\uDCAF"),
        b("tscr", "\uD835\uDCC9"),
        b("TScy", "\u0426"),
        b("tscy", "\u0446"),
        b("TSHcy", "\u040B"),
        b("tshcy", "\u045B"),
        b("Tstrok", "\u0166"),
        b("tstrok", "\u0167"),
        b("twixt", "\u226C"),
        b("twoheadleftarrow", "\u219E"),
        b("twoheadrightarrow", "\u21A0"),
        b("Uacute", "\xda"),
        b("uacute", "\xfa"),
        b("uarr", "\u2191"),
        b("Uarr", "\u219F"),
        b("uArr", "\u21D1"),
        b("Uarrocir", "\u2949"),
        b("Ubrcy", "\u040E"),
        b("ubrcy", "\u045E"),
        b("Ubreve", "\u016C"),
        b("ubreve", "\u016D"),
        b("Ucirc", "\xdb"),
        b("ucirc", "\xfb"),
        b("Ucy", "\u0423"),
        b("ucy", "\u0443"),
        b("udarr", "\u21C5"),
        b("Udblac", "\u0170"),
        b("udblac", "\u0171"),
        b("udhar", "\u296E"),
        b("ufisht", "\u297E"),
        b("Ufr", "\uD835\uDD18"),
        b("ufr", "\uD835\uDD32"),
        b("Ugrave", "\xd9"),
        b("ugrave", "\xf9"),
        b("uHar", "\u2963"),
        b("uharl", "\u21BF"),
        b("uharr", "\u21BE"),
        b("uhblk", "\u2580"),
        b("ulcorn", "\u231C"),
        b("ulcorner", "\u231C"),
        b("ulcrop", "\u230F"),
        b("ultri", "\u25F8"),
        b("Umacr", "\u016A"),
        b("umacr", "\u016B"),
        b("uml", "\xa8"),
        b("UnderBar", "_"),
        b("UnderBrace", "\u23DF"),
        b("UnderBracket", "\u23B5"),
        b("UnderParenthesis", "\u23DD"),
        b("Union", "\u22C3"),
        b("UnionPlus", "\u228E"),
        b("Uogon", "\u0172"),
        b("uogon", "\u0173"),
        b("Uopf", "\uD835\uDD4C"),
        b("uopf", "\uD835\uDD66"),
        b("UpArrowBar", "\u2912"),
        b("uparrow", "\u2191"),
        b("UpArrow", "\u2191"),
        b("Uparrow", "\u21D1"),
        b("UpArrowDownArrow", "\u21C5"),
        b("updownarrow", "\u2195"),
        b("UpDownArrow", "\u2195"),
        b("Updownarrow", "\u21D5"),
        b("UpEquilibrium", "\u296E"),
        b("upharpoonleft", "\u21BF"),
        b("upharpoonright", "\u21BE"),
        b("uplus", "\u228E"),
        b("UpperLeftArrow", "\u2196"),
        b("UpperRightArrow", "\u2197"),
        b("upsi", "\u03C5"),
        b("Upsi", "\u03D2"),
        b("upsih", "\u03D2"),
        b("Upsilon", "\u03A5"),
        b("upsilon", "\u03C5"),
        b("UpTeeArrow", "\u21A5"),
        b("UpTee", "\u22A5"),
        b("upuparrows", "\u21C8"),
        b("urcorn", "\u231D"),
        b("urcorner", "\u231D"),
        b("urcrop", "\u230E"),
        b("Uring", "\u016E"),
        b("uring", "\u016F"),
        b("urtri", "\u25F9"),
        b("Uscr", "\uD835\uDCB0"),
        b("uscr", "\uD835\uDCCA"),
        b("utdot", "\u22F0"),
        b("Utilde", "\u0168"),
        b("utilde", "\u0169"),
        b("utri", "\u25B5"),
        b("utrif", "\u25B4"),
        b("uuarr", "\u21C8"),
        b("Uuml", "\xdc"),
        b("uuml", "\xfc"),
        b("uwangle", "\u29A7"),
        b("vangrt", "\u299C"),
        b("varepsilon", "\u03F5"),
        b("varkappa", "\u03F0"),
        b("varnothing", "\u2205"),
        b("varphi", "\u03D5"),
        b("varpi", "\u03D6"),
        b("varpropto", "\u221D"),
        b("varr", "\u2195"),
        b("vArr", "\u21D5"),
        b("varrho", "\u03F1"),
        b("varsigma", "\u03C2"),
        b("varsubsetneq", "\u228A\uFE00"),
        b("varsubsetneqq", "\u2ACB\uFE00"),
        b("varsupsetneq", "\u228B\uFE00"),
        b("varsupsetneqq", "\u2ACC\uFE00"),
        b("vartheta", "\u03D1"),
        b("vartriangleleft", "\u22B2"),
        b("vartriangleright", "\u22B3"),
        b("vBar", "\u2AE8"),
        b("Vbar", "\u2AEB"),
        b("vBarv", "\u2AE9"),
        b("Vcy", "\u0412"),
        b("vcy", "\u0432"),
        b("vdash", "\u22A2"),
        b("vDash", "\u22A8"),
        b("Vdash", "\u22A9"),
        b("VDash", "\u22AB"),
        b("Vdashl", "\u2AE6"),
        b("veebar", "\u22BB"),
        b("vee", "\u2228"),
        b("Vee", "\u22C1"),
        b("veeeq", "\u225A"),
        b("vellip", "\u22EE"),
        b("verbar", "|"),
        b("Verbar", "\u2016"),
        b("vert", "|"),
        b("Vert", "\u2016"),
        b("VerticalBar", "\u2223"),
        b("VerticalLine", "|"),
        b("VerticalSeparator", "\u2758"),
        b("VerticalTilde", "\u2240"),
        b("VeryThinSpace", "\u200A"),
        b("Vfr", "\uD835\uDD19"),
        b("vfr", "\uD835\uDD33"),
        b("vltri", "\u22B2"),
        b("vnsub", "\u2282\u20D2"),
        b("vnsup", "\u2283\u20D2"),
        b("Vopf", "\uD835\uDD4D"),
        b("vopf", "\uD835\uDD67"),
        b("vprop", "\u221D"),
        b("vrtri", "\u22B3"),
        b("Vscr", "\uD835\uDCB1"),
        b("vscr", "\uD835\uDCCB"),
        b("vsubnE", "\u2ACB\uFE00"),
        b("vsubne", "\u228A\uFE00"),
        b("vsupnE", "\u2ACC\uFE00"),
        b("vsupne", "\u228B\uFE00"),
        b("Vvdash", "\u22AA"),
        b("vzigzag", "\u299A"),
        b("Wcirc", "\u0174"),
        b("wcirc", "\u0175"),
        b("wedbar", "\u2A5F"),
        b("wedge", "\u2227"),
        b("Wedge", "\u22C0"),
        b("wedgeq", "\u2259"),
        b("weierp", "\u2118"),
        b("Wfr", "\uD835\uDD1A"),
        b("wfr", "\uD835\uDD34"),
        b("Wopf", "\uD835\uDD4E"),
        b("wopf", "\uD835\uDD68"),
        b("wp", "\u2118"),
        b("wr", "\u2240"),
        b("wreath", "\u2240"),
        b("Wscr", "\uD835\uDCB2"),
        b("wscr", "\uD835\uDCCC"),
        b("xcap", "\u22C2"),
        b("xcirc", "\u25EF"),
        b("xcup", "\u22C3"),
        b("xdtri", "\u25BD"),
        b("Xfr", "\uD835\uDD1B"),
        b("xfr", "\uD835\uDD35"),
        b("xharr", "\u27F7"),
        b("xhArr", "\u27FA"),
        b("Xi", "\u039E"),
        b("xi", "\u03BE"),
        b("xlarr", "\u27F5"),
        b("xlArr", "\u27F8"),
        b("xmap", "\u27FC"),
        b("xnis", "\u22FB"),
        b("xodot", "\u2A00"),
        b("Xopf", "\uD835\uDD4F"),
        b("xopf", "\uD835\uDD69"),
        b("xoplus", "\u2A01"),
        b("xotime", "\u2A02"),
        b("xrarr", "\u27F6"),
        b("xrArr", "\u27F9"),
        b("Xscr", "\uD835\uDCB3"),
        b("xscr", "\uD835\uDCCD"),
        b("xsqcup", "\u2A06"),
        b("xuplus", "\u2A04"),
        b("xutri", "\u25B3"),
        b("xvee", "\u22C1"),
        b("xwedge", "\u22C0"),
        b("Yacute", "\xdd"),
        b("yacute", "\xfd"),
        b("YAcy", "\u042F"),
        b("yacy", "\u044F"),
        b("Ycirc", "\u0176"),
        b("ycirc", "\u0177"),
        b("Ycy", "\u042B"),
        b("ycy", "\u044B"),
        b("yen", "\xa5"),
        b("Yfr", "\uD835\uDD1C"),
        b("yfr", "\uD835\uDD36"),
        b("YIcy", "\u0407"),
        b("yicy", "\u0457"),
        b("Yopf", "\uD835\uDD50"),
        b("yopf", "\uD835\uDD6A"),
        b("Yscr", "\uD835\uDCB4"),
        b("yscr", "\uD835\uDCCE"),
        b("YUcy", "\u042E"),
        b("yucy", "\u044E"),
        b("yuml", "\xff"),
        b("Yuml", "\u0178"),
        b("Zacute", "\u0179"),
        b("zacute", "\u017A"),
        b("Zcaron", "\u017D"),
        b("zcaron", "\u017E"),
        b("Zcy", "\u0417"),
        b("zcy", "\u0437"),
        b("Zdot", "\u017B"),
        b("zdot", "\u017C"),
        b("zeetrf", "\u2128"),
        b("ZeroWidthSpace", "\u200B"),
        b("Zeta", "\u0396"),
        b("zeta", "\u03B6"),
        b("zfr", "\uD835\uDD37"),
        b("Zfr", "\u2128"),
        b("ZHcy", "\u0416"),
        b("zhcy", "\u0436"),
        b("zigrarr", "\u21DD"),
        b("zopf", "\uD835\uDD6B"),
        b("Zopf", "\u2124"),
        b("Zscr", "\uD835\uDCB5"),
        b("zscr", "\uD835\uDCCF"),
        b("zwj", "\u200D"),
        b("zwnj", "\u200C")
    ])), YO = A2(Vm, function(n) {
        return A2(sc, "&" + n + ";", A2(Wu, n, UO));
    }, Hm(zO(ke))), QO = E, OO = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return te(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = i = u, t = c = t;
                    continue n;
                case "1":
                    var a = n - 1, i = u, c = t + A2(QO, 16, n);
                    n = a, r = i, t = c;
                    continue n;
                case "2":
                    a = n - 1, i = u, c = t + 2 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "3":
                    a = n - 1, i = u, c = t + 3 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "4":
                    a = n - 1, i = u, c = t + 4 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "5":
                    a = n - 1, i = u, c = t + 5 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "6":
                    a = n - 1, i = u, c = t + 6 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "7":
                    a = n - 1, i = u, c = t + 7 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "8":
                    a = n - 1, i = u, c = t + 8 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "9":
                    a = n - 1, i = u, c = t + 9 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "a":
                    a = n - 1, i = u, c = t + 10 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "b":
                    a = n - 1, i = u, c = t + 11 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "c":
                    a = n - 1, i = u, c = t + 12 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "d":
                    a = n - 1, i = u, c = t + 13 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "e":
                    a = n - 1, i = u, c = t + 14 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                case "f":
                    a = n - 1, i = u, c = t + 15 * A2(QO, 16, n), n = a, r = i, t = c;
                    continue n;
                default:
                    return Kt(Zb(e) + " is not a valid hexadecimal character.");
            }
        }
    }), GO = A2(im, function(n) {
        var r = function(n) {
            if (vu(n)) return Kt("Empty strings are not valid hexadecimal strings.");
            var r = function() {
                if (A2(xu, "-", n)) {
                    var r = A2(sc, h, tV(Lm(n)));
                    return A2(Kp, ro, A3(OO, be(r) - 1, r, 0));
                }
                return A3(OO, su(n) - 1, Lm(n), 0);
            }();
            return A2(n$, function(r) {
                return A2(fe, " ", x([
                    '"' + n + '"',
                    "is not a valid hexadecimal string because",
                    r
                ]));
            }, r);
        }(UQ(n));
        return r.$ ? jm(r.a) : lm(r.a);
    }, Hm(zO(function(n) {
        var r = ge(n);
        return r >= 48 && 57 >= r || r >= 65 && 70 >= r || r >= 97 && 102 >= r;
    }))), JO = {
        $: 1
    }, WO = $t, KO = ht, XO = F2(function(n, r) {
        return {
            nQ: r.nQ + (n - r.ic),
            e: r.e,
            m: r.m,
            ic: n,
            vZ: r.vZ,
            d: r.d
        };
    }), nG = pt, rG = mt, tG = F2(function(n, r) {
        if (A3(rG, 101, n, r) || A3(rG, 69, n, r)) {
            var t = n + 1, e = A3(rG, 43, t, r) || A3(rG, 45, t, r) ? t + 1 : t, u = A2(nG, e, r);
            return i(e, u) ? -u : u;
        }
        return n;
    }), eG = F2(function(n, r) {
        return A2(tG, A3(rG, 46, n, r) ? A2(nG, n + 1, r) : n, r);
    }), uG = F5(function(n, r, t, e, u) {
        var a = e.a, c = e.b;
        if (1 === r.$) return A2(em, !0, A2($m, u, r.a));
        var o = r.a;
        return i(t, a) ? A2(em, 0 > s(u.ic, t), A2($m, u, n)) : A3(um, !0, o(c), A2(XO, a, u));
    }), aG = F6(function(n, r, t, e, u, a) {
        var c = u.a, o = A2(eG, c, a.d);
        if (0 > o) return A2(em, !0, A4(MO, a.vZ, a.nQ - (o + a.ic), n, a.e));
        if (i(a.ic, o)) return A2(em, !1, A2($m, a, r));
        if (i(c, o)) return A5(uG, n, t, a.ic, u, a);
        if (1 === e.$) return A2(em, !0, A2($m, a, n));
        var f = e.a, s = zS(A3(lu, a.ic, o, a.d));
        return 1 === s.$ ? A2(em, !0, A2($m, a, n)) : A3(um, !0, f(s.a), A2(XO, o, a));
    }), iG = A2(F2(function(n, r) {
        var t;
        return t = {
            m9: Kt(r),
            qk: n,
            qE: Kt(r),
            ra: Kt(r),
            ro: te(iu),
            Ax: r,
            tD: Kt(r)
        }, function(n) {
            if (A3(rG, 48, n.ic, n.d)) {
                var r = n.ic + 1, e = r + 1;
                return A3(rG, 120, r, n.d) ? A5(uG, t.Ax, t.ra, e, A2(KO, e, n.d), n) : A3(rG, 111, r, n.d) ? A5(uG, t.Ax, t.tD, e, A3(WO, 8, e, n.d), n) : A3(rG, 98, r, n.d) ? A5(uG, t.Ax, t.m9, e, A3(WO, 2, e, n.d), n) : A6(aG, t.Ax, t.qk, t.ro, t.qE, b(r, 0), n);
            }
            return A6(aG, t.Ax, t.qk, t.ro, t.qE, A3(WO, 10, n.ic, n.d), n);
        };
    }), JO, JO), cG = (gY = Om(x([
        A2(zm, A2(sm, lm(iu), Cm(function(n) {
            return "x" === n || "X" === n;
        })), GO),
        A2(zm, A2(sm, lm(iu), qm(Ie("0"))), iG)
    ])), A2(zm, A2(sm, lm(iu), Cm(Ie("#"))), A2(Vm, A2(ru, p_, Zb), gY))), oG = A2(zm, A2(sm, lm(iu), Cm(Ie("&"))), Om(x([
        A2(sm, Ik(YO), VO),
        A2(sm, Ik(cG), VO),
        lm("&")
    ]))), fG = function(n) {
        return A2(zm, A2(sm, lm(iu), Cm(Ie(n))), A2(sm, A2(Vm, fe(""), RO(Om(x([
            Hm(zO(function(r) {
                return !i(r, n) && "&" !== r;
            })),
            oG
        ])))), Cm(Ie(n))));
    }, sG = F2(function(n, r) {
        return A2(IS, h, function(t) {
            return Om(x([
                A2(Vm, function(n) {
                    return MS(A2(Yt, n, t));
                }, r),
                TE(t) ? jm("expecting at least one " + n) : lm(LS(Ae(t)))
            ]));
        });
    }), lG = A2(Vm, fe(""), A2(sG, "attribute value", Om(x([
        Hm(zO(function(n) {
            return !jO(n) && '"' !== n && "'" !== n && "=" !== n && "<" !== n && ">" !== n && "`" !== n && "&" !== n;
        })),
        oG
    ])))), dG = Om(x([
        A2(zm, A2(sm, A2(sm, lm(iu), Cm(Ie("="))), qm(jO)), Om(x([
            lG,
            fG('"'),
            fG("'")
        ]))),
        lm("")
    ])), bG = A2(zm, A2(zm, lm(ry), A2(sm, ZO, qm(jO))), A2(sm, dG, qm(jO))), vG = RO(bG), mG = A2(Vm, UQ, Hm(A2(sm, Cm(_e), qm(function(n) {
        return _e(n) || "-" === n;
    })))), pG = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $G = A2(Vm, A2(ru, fe(""), pG), A2(sG, "text element", Om(x([
        Hm(zO(function(n) {
            return "<" !== n && "&" !== n;
        })),
        oG
    ]))));
    function hG() {
        return Om(x([
            $G,
            TO,
            gG()
        ]));
    }
    function gG() {
        return A2(im, function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                return A2(SE, n, IO);
            }(r) ? A2(sm, A2(sm, lm(A3(PO, r, t, h)), Om(x([
                Cm(Ie("/")),
                lm(0)
            ]))), Cm(Ie(">"))) : A2(zm, A2(sm, lm(A2(PO, r, t)), Cm(Ie(">"))), A2(sm, RO(Ik(hG())), function(n) {
                var r = A2(im, function(r) {
                    return i(UQ(r), n) ? lm(0) : jm("closing tag does not match opening tag: " + n);
                }, Hm(zO(function(n) {
                    return !jO(n) && ">" !== n;
                })));
                return A2(sm, A2(sm, A2(sm, A2(sm, Cm(Ie("<")), Cm(Ie("/"))), r), qm(jO)), Cm(Ie(">")));
            }(r)));
        }, A2(zm, A2(zm, A2(sm, lm(ry), Cm(Ie("<"))), A2(sm, mG, qm(jO))), vG));
    }
    var wG = hG();
    hG = function() {
        return wG;
    };
    var xG = gG();
    gG = function() {
        return xG;
    };
    var kG = function(n) {
        return vu(n) ? te(h) : A2(ep, A2(sG, "node", wG), n);
    }, yG = function(n) {
        return cr(hr(n));
    }, _G = function(n) {
        return A2(jC, n.a, n.b);
    }, AG = function(n) {
        return A2(Eu, CG, n);
    }, CG = function(n) {
        switch(n.$){
            case 1:
                var r = n.c;
                return A3(yG, n.a, A2(Eu, _G, n.b), AG(r));
            case 0:
                return ld(n.a);
            default:
                return ld("");
        }
    }, BG = function(n) {
        var r = kG(n);
        return r.$ ? h : AG(r.a);
    }, EG = {
        $: 1
    }, DG = cr("em"), qG = function(n) {
        return n ? "embed-responsive--large" : "embed-responsive--small";
    }, FG = cr("iframe"), PG = F2(function(n, r) {
        return A2(dr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && $r.test(n) ? "" : n;
        }(r));
    }), zG = function(n) {
        return A2(Kx, "src", gr(n));
    }, jG = Kx("title"), SG = F4(function(n, r, t, e) {
        return A2(nk, h, x([
            function() {
                if (t.$) return A2(nk, x([
                    Xx("flex justify-center my-12")
                ]), x([
                    ik(h)
                ]));
                var u = t.a, a = e ? "https://docs.google.com/gview?url=" + U_(u) + "&embedded=true" : u;
                return A2(nk, x([
                    Xx("embed-responsive"),
                    Xx(qG(n))
                ]), x([
                    A2(FG, x([
                        zG(a),
                        jG(r),
                        A2(jC, "sandbox", "allow-scripts allow-same-origin"),
                        A2(PG, "frameborder", Ax("0")),
                        A2(PG, "allowfullscreen", Ax("false")),
                        Xx("embed-responsive__item mb-2")
                    ]), h)
                ]));
            }(),
            A2(DG, h, x([
                ld("If you do not see the document above, please click "),
                A2(OC, x([
                    wO,
                    EC(EG)
                ]), x([
                    ld("here")
                ]))
            ]))
        ]));
    }), LG = F2(function(n, r) {
        switch(vQ(r.eD)){
            case 0:
                return A2(nk, h, A2(Eu, Ck(yu), BG(A2(sc, "", r.eD.ok))));
            case 2:
                return A4(SG, n, r.$9, pQ(r.eD), !1);
            default:
                return A4(SG, n, r.$9, uC(r.iY), !0);
        }
    }), MG = F2(function(n, r) {
        if (r.$) return tB;
        var t = r.a;
        return A2(zN, x([
            jN(iR),
            KN(x([
                Xx("-mx-1")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(n(XM))
                ]), x([
                    ld(A2(NL, aS("/"), t))
                ]))
            ]))
        ]));
    }), NG = F3(function(n, r, t) {
        return A2(zN, x([
            KN(x([
                Xx("-mx-1 mb-6 md:mb-8")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(n(r))
                ]), x([
                    QE(t)
                ]))
            ]))
        ]));
    }), HG = F3(function(n, r, t) {
        var e = b(t, n);
        return e.a.$ ? tB : A3(NG, r, e.b ? jQ : SQ, e.a.a);
    }), TG = F4(function(n, r, t, e) {
        var u, a = (u = b(t, n)).a.$ ? u.b ? jQ : zQ : u.b ? jQ : LQ;
        return A3(NG, r, a, e);
    }), IG = F3(function(n, r, t) {
        var e = A2(PH, 0, t);
        return TE(e) ? A2(pT, x([
            Xx("mt-2 md:mt-3 text-sm text-info-400")
        ]), x([
            ld(n(RQ(r)))
        ])) : A2(ET, n, e);
    }), RG = F4(function(n, r, t, e) {
        var u, a = (u = b(e.bl, n)).a.$ ? b(u.b ? TQ : qQ, DQ) : u.b ? b(TQ, DQ) : b(NQ, MQ), i = a.a, c = a.b, o = FL(e.kB), f = o.la, s = o.dU;
        if (ZQ(o.lU)) return A2(nk, x([
            Hq(eQ(e))
        ]), x([
            (l = e.cr, l.$ ? tB : A2(Ck, lQ, A2(LG, 0, l.a))),
            A2(nk, x([
                A2(bT, "margin-left", "-1.5rem"),
                A2(bT, "margin-right", "-1.5rem")
            ]), x([
                Dk
            ])),
            A2(zN, x([
                jN(FO),
                KN(x([
                    Xx("mt-5")
                ]))
            ]), x([
                A2(EN, h, x([
                    A3(HG, n, r, e.bl),
                    A4(TG, n, r, e.bl, f),
                    A2(zN, x([
                        KN(x([
                            Xx("-mx-1 mb-6 md:mb-8")
                        ]))
                    ]), x([
                        A2(EN, h, x([
                            A2(XH, x([
                                HH(r(i)),
                                VH(!0)
                            ]), x([
                                vI(x([
                                    xI(s),
                                    gI(A2(pc, qO, iu)),
                                    aI(!0),
                                    iI(r(c)),
                                    JT(A2(QH, 0, e.kB))
                                ])),
                                A3(IG, r, e.bl, e.kB)
                            ]))
                        ]))
                    ])),
                    A2(MG, r, t)
                ]))
            ]))
        ]));
        var l, d = e.cr;
        return d.$ ? tB : A2(Ck, lQ, A2(LG, 0, d.a));
    }), ZG = F4(function(n, r, t, e) {
        if (1 === e.$) {
            var u = e.a, a = e.b, i = a.a, c = a.b;
            return A2(QI, x([
                qI(x([
                    A2(FI, x([
                        aq,
                        $H
                    ]), x([
                        A2(Ck, yu, yO(c))
                    ]))
                ])),
                EI(x([
                    A2(Ck, XY(b(i, c)), A4(RG, n, r, t, c))
                ])),
                DI(x([
                    A2(Ck, XY(b(i, c)), EO(r)),
                    A2(Ck, XY(b(i, c)), DO(r))
                ]))
            ]), NM(u));
        }
        return tB;
    }), VG = F3(function(n, r, t) {
        return oO(t) ? tB : A2(nk, h, x([
            A4(ZG, t.rC, n, t.g8, t.ar),
            A3(CO, n, r, t)
        ]));
    }), UG = F2(function(n, r) {
        return A2(Ck, DU, A3(VG, Wx(r.kA), x([
            iO(r.cS),
            aO(n)
        ]), r.aD));
    }), YG = {
        $: 5
    }, QG = F3(function(n, r, t) {
        var e = r || !BY(t.aD);
        return A2(nk, x([
            Xx("mt-auto pt-6")
        ]), x([
            A2(OC, x([
                qC,
                CZ,
                EC(YG),
                uF(e)
            ]), x([
                ld(n)
            ]))
        ]));
    }), OG = F2(function(n, r) {
        var t, e = n(uO), u = function(n) {
            switch(n.$){
                case 3:
                case 0:
                    return !1;
                default:
                    return !0;
            }
        }, a = A2(jE, u, (t = r.dd, A3(Qt, F3(function(n, r, t) {
            return A2(Yt, r, t);
        }), h, t))) || u(r.ff);
        return {
            gN: x([
                xU(x([
                    kU({
                        By: eO,
                        w5: e
                    }),
                    A2(UG, a, r),
                    A3(QG, e, a, r)
                ]))
            ]),
            w5: e
        };
    }), GG = ZA({
        Ar: tY,
        AQ: eY,
        Db: uY,
        DZ: function(n) {
            return A2(_S, DU, yY(n.aD));
        },
        En: tO,
        Et: OG
    }), JG = function(n) {
        return {
            $: 8,
            a: n
        };
    }, WG = tt(function() {
        return {
            v1: ut(),
            jT: {
                xP: Kr.pageXOffset,
                lR: Kr.pageYOffset,
                ce: Wr.documentElement.clientWidth,
                q6: Wr.documentElement.clientHeight
            }
        };
    }), KG = function(n) {
        return n.sv;
    }, XG = function(n) {
        return A2(cD, "member_messaging", n);
    }, nJ = F3(function(n, r, t) {
        var e, u = {
            gD: !1,
            X: Ut,
            j: r.yY.J,
            Q: vc,
            da: 0,
            bj: r.bj,
            kA: r.kA,
            bt: !1,
            bw: Ut,
            t6: r.t6,
            dB: n,
            a9: Ut,
            fS: r.fS,
            xs: t,
            d7: 0
        }, a = 3 === (e = r.uN).$ ? KG(e.a) : XG(n);
        return b(u, Vu(x([
            a ? Pp : A2(AA, t.iF, Wa),
            A2(Nu, function(n) {
                return JG(kp(n.jT.ce));
            }, WG)
        ])));
    }), rJ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), tJ = function(n) {
        return tC(z_(n));
    }, eJ = F2(function(n, r) {
        return {
            Ck: n,
            iF: A2(sc, da, A2(Fp, Rp, r.iF)),
            CS: r
        };
    }), uJ = F4(function(n, r, t, e) {
        return {
            qd: r,
            hY: t,
            ic: e,
            Ee: n
        };
    }), aJ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), iJ = F8(function(n, r, t, e, u, a, i, c) {
        return {
            oz: n,
            y5: i,
            AA: a,
            rJ: u,
            rR: r,
            t1: t,
            Cp: e,
            Eo: c
        };
    }), cJ = A3(ly, "sentAt", KS, A3(ly, "snippet", C$, A3(ly, "id", C$, uu(F3(function(n, r, t) {
        return {
            rh: n,
            Dn: t,
            DI: r
        };
    }))))), oJ = F6(function(n, r, t, e, u, a) {
        return {
            y1: t,
            zp: r,
            rh: n,
            Cr: e,
            CA: a,
            xw: u
        };
    }), fJ = A4(sy, "phoneNumber", iy(C$), Ut, A4(sy, "userId", iy(C$), Ut, A4(sy, "patientId", iy(C$), Ut, A4(sy, "contactId", iy(C$), Ut, A4(sy, "displayName", iy(C$), Ut, A3(ly, "id", C$, uu(oJ))))))), sJ = A3(ly, "updatedAt", KS, A3(ly, "createdAt", KS, A3(ly, "isArchived", jk, A3(ly, "isUnread", jk, A3(ly, "participantsCount", F$, A3(ly, "participants", vy(fJ), A4(sy, "lastMessage", iy(cJ), Ut, A3(ly, "ident", C$, uu(iJ))))))))), lJ = A2(dD, 0, A2(Pk, sJ, uu(aJ))), dJ = A3(ly, "offset", F$, A3(ly, "limit", F$, A3(ly, "entities", vy(lJ), A3(ly, "total", F$, uu(uJ))))), bJ = F2(function(n, r) {
        return A2(V_, U_(n), oe(r));
    }), vJ = {
        hY: Vt(10),
        ic: 0,
        lC: Ut
    }, mJ = F2(function(n, r) {
        return A3(Yb, n, "0", oe(r));
    }), pJ = A2(Dc, 0, h), $J = function(n) {
        var r;
        return A2(mJ, 4, A2(gv, pJ, r = n)) + "-" + A2(mJ, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(mv, pJ, r))) + "-" + A2(mJ, 2, A2(lv, pJ, r)) + "T" + A2(mJ, 2, A2(dv, pJ, r)) + ":" + A2(mJ, 2, A2(vv, pJ, r)) + ":" + A2(mJ, 2, A2(pv, pJ, r)) + "." + A2(mJ, 3, A2(bv, pJ, r)) + "Z";
    }, hJ = F4(function(n, r, t, e) {
        return A4(W_, n, dJ, e, A2(_P, function(n) {
            var r, t, e = n(vJ), u = (r = e.lC).$ ? h : x([
                A2(Y_, "timestamp", $J(r.a))
            ]), a = (t = e.hY).$ ? h : x([
                A2(bJ, "limit", t.a)
            ]);
            return A2(Yt, A2(bJ, "offset", e.ic), $(a, u));
        }(t), rA(function(n) {
            return A2(X_, x([
                "conversations"
            ]), YA(n));
        }(r))));
    }), gJ = F2(function(n, r) {
        var t, e, u = m(r, {
            X: A2(Fp, function(r) {
                return m(r, {
                    ha: n.t6
                });
            }, r.X),
            j: n.yY.J,
            t6: n.t6,
            xs: A2(eJ, 0, n.xs)
        }), a = 3 === (t = n.uN).$ ? KG(t.a) : XG(r.dB), i = a ? Pp : A2(AA, r.xs.iF, Wa);
        if (a) {
            if (0 === u.Q.$) {
                var c = (e = tJ(n.yY.J)).$ ? Pp : A4(hJ, n.yY.J, e.a, function(n) {
                    return m(n, {
                        hY: Vt(10),
                        ic: 0
                    });
                }, rJ(0));
                return b(m(u, {
                    Q: cP
                }), c);
            }
            return b(u, Pp);
        }
        return b(u, i);
    }), wJ = F2(function(n, r) {
        return m(r, {
            x6: Vt(8)
        });
    }), xJ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kJ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yJ = function(n) {
        return {
            $: 9,
            a: n
        };
    }, _J = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AJ = F2(function(n, r) {
        return {
            u2: r,
            w_: n
        };
    }), CJ = _u(A2(AJ, da, da)), BJ = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(Wu, t, r);
        return A3(ta, t, 1 === u.$ ? x([
            e
        ]) : A2(Yt, e, u.a), r);
    }), EJ = ct, DJ = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = Ky(A2(EJ, e, A2(Ty, n, e)));
            return A2(Du, function(r) {
                return A3(DJ, n, u, A3(ta, e, r, t));
            }, a);
        }
        return _u(t);
    });
    Mn.Time = Nn(CJ, F3(function(n, r, t) {
        var e = t.u2, u = F3(function(n, r, t) {
            var e = t.c;
            return v(t.a, t.b, A2(Du, function() {
                return e;
            }, Wy(r)));
        }), a = A3(de, BJ, da, r), i = A6(vY, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return v(A2(Yt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return v(e.a, A3(ta, n, t, e.b), u);
        }), u, a, e, v(h, da, _u(0))), c = i.a, o = i.b;
        return A2(Du, function(n) {
            return _u(A2(AJ, a, n));
        }, A2(Du, function() {
            return A3(DJ, n, c, o);
        }, i.c));
    }), F3(function(n, r, t) {
        var e = A2(Wu, r, t.w_);
        if (1 === e.$) return _u(t);
        var u = e.a;
        return A2(Du, function() {
            return _u(t);
        }, A2(Du, function(r) {
            return Pu(A2(Eu, function(t) {
                return A2(zu, n, t(r));
            }, u));
        }, IF));
    }), 0, F2(function(n, r) {
        return A2(_J, r.a, A2(pc, n, r.b));
    }));
    var qJ, FJ, PJ, zJ, jJ, SJ, LJ, MJ, NJ, HJ, TJ = Rn("Time"), IJ = F2(function(n, r) {
        return TJ(A2(_J, n, r));
    }), RJ = function(n) {
        return A3(xY, 1, "resize", A2(Tu, "target", A3(eu, n, A2(Tu, "innerWidth", F$), A2(Tu, "innerHeight", F$))));
    }, ZJ = nr("onScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return uu({
                            yX: u,
                            oj: e,
                            Dc: t,
                            xP: r,
                            lR: n
                        });
                    }, A2(Tu, "clientHeight", q$));
                }, A2(Tu, "containerId", C$));
            }, A2(Tu, "scrollHeight", q$));
        }, A2(Tu, "x", q$));
    }, A2(Tu, "y", q$))), VJ = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), UJ = function(n) {
        return {
            $: 29,
            a: n
        };
    }, YJ = function(n) {
        return {
            $: 30,
            a: n
        };
    }, QJ = function(n) {
        return {
            $: 31,
            a: n
        };
    }, OJ = function(n) {
        return {
            $: 24,
            a: n
        };
    }, GJ = function(n) {
        return {
            $: 18,
            a: n
        };
    }, JJ = {
        $: 2
    }, WJ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, KJ = function(n) {
        return {
            $: 21,
            a: n
        };
    }, XJ = function(n) {
        return {
            $: 27,
            a: n
        };
    }, nW = function(n) {
        return {
            $: 15,
            a: n
        };
    }, rW = nr("fileUploadResult", w$), tW = F5(function(n, r, t, e, u) {
        return {
            kw: u,
            qx: n,
            qy: t,
            qz: e,
            D_: r
        };
    }), eW = fn, uW = A6(eW, tW, A2(Tu, "fileIndex", F$), A2(Tu, "success", jk), A2(Tu, "filePath", C$), A2(Tu, "filename", C$), iy(A2(Tu, "error", C$))), aW = nr("heicPreviewResult", w$), iW = F3(function(n, r, t) {
        return {
            tg: n,
            DG: r,
            xo: t
        };
    }), cW = on, oW = A4(cW, iW, A2(Tu, "name", C$), A2(Tu, "size", F$), A2(Tu, "type", C$)), fW = function(n) {
        var r = A2(cy, vy(oW), n);
        return r.$ ? h : r.a;
    }, sW = nr("onFileSelectedPort", w$), lW = nr("previewLayoutSized", w$), dW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, pW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, $W = nr("docxPreviewHtmlResult", w$), hW = function(n) {
        return !n.bG;
    }, gW = x([
        "pdf",
        "csv",
        "xlsx",
        "docx",
        "xml",
        "ics"
    ]), wW = function(n) {
        var r;
        return r = UQ(n), A2(xu, ".", r) ? A2(du, 1, r) : r;
    }, xW = function(n) {
        return b(UQ(A2(sc, "", rv(Ae(A2(se, ".", n.af))))), function(n) {
            return wW(n.zT);
        }(n));
    }, kW = function(n) {
        var r = xW(n), t = r.b, e = wW(r.a);
        return function(n) {
            var r, t = A2(se, ".", n);
            return be(t) > 1 && !(r = rv(Ae(t))).$ && "" !== r.a;
        }(n.af) && "" !== e || A2(SE, e, gW) ? e : t;
    }, yW = function(n) {
        return "docx" === kW(n);
    }, _W = function(n) {
        return yW(n.c) && !n.h;
    }, AW = function(n) {
        return hW(n.b) && _W(n) ? $W(A2(ru, iu, pW)) : zx;
    }, CW = function(n) {
        return "pdf" === kW(n);
    }, BW = A2(nu, function(n) {
        switch(n){
            case "error":
                return A3(eu, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }({
                        kw: r,
                        tg: n
                    });
                }), A2(Tu, "name", C$), A2(Tu, "error", C$));
            case "loaded":
                return A3(eu, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }({
                        tg: n,
                        Ci: r
                    });
                }), A2(Tu, "name", C$), A2(Tu, "pageCount", F$));
            default:
                return Sk("unknown websocketmsg type: " + n);
        }
    }, A2(Tu, "msg", C$)), EW = nr("receivePdfMsg", w$), DW = function(n) {
        var r;
        return EW((r = n, function(n) {
            return r(A2(cy, BW, n));
        }));
    }, qW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, PW = function(n) {
        return "csv" === kW(n);
    }, zW = function(n) {
        return "xlsx" === kW(n);
    }, jW = nr("spreadsheetPreviewResult", w$), SW = function(n) {
        return hW(n.b) && function(n) {
            return (PW(n.c) || zW(n.c)) && !n.h;
        }(n) ? jW(A2(ru, qW, FW)) : zx;
    }, LW = function(n) {
        return n.di > 0 && 1024 > n.di;
    }, MW = function(n) {
        return {
            $: 7,
            a: n
        };
    }, NW = function(n) {
        return "xml" === kW(n);
    }, HW = nr("xmlPreviewResult", w$), TW = function(n) {
        return hW(n.b) && NW(n.c) && !n.h ? HW(A2(ru, iu, MW)) : zx;
    }, IW = nr("onElementMeasured", A2(nu, function(n) {
        return A2(nu, function(r) {
            return A2(nu, function(t) {
                return A2(nu, function(e) {
                    return A2(nu, function(u) {
                        return uu({
                            yX: u,
                            bT: e,
                            zN: t,
                            r3: r,
                            Dc: n
                        });
                    }, A2(Tu, "clientHeight", q$));
                }, A2(Tu, "elementId", C$));
            }, A2(Tu, "exceedsMaxLines", jk));
        }, A2(Tu, "lineHeight", q$));
    }, A2(Tu, "scrollHeight", q$))), RW = IW(iu), ZW = {
        $: 3
    }, VW = nr("onDropdownEscapeKeyPressed", C$), UW = function(n) {
        return VW(cm(n));
    }, YW = nr("onDropdownOutsideClick", C$), QW = function(n) {
        var r;
        return n.bD ? Px(x([
            (r = ZW, YW(cm(r))),
            UW(ZW)
        ])) : zx;
    }, OW = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), GW = {
        $: 4
    }, JW = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), WW = "conversation", KW = F2(function(n, r) {
        var t = function() {
            if (n.$) return A2(fa, WW, r);
            var t = n.a;
            return vu(t) ? A2(fa, WW, r) : A3(ta, WW, t, r);
        }();
        return i(t, r) ? Pp : A2(AA, t, ka);
    }), XW = function(n) {
        return n.a.oz;
    }, nK = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rK = F2(function(n, r) {
        return b(Vu(A2(Eu, function(r) {
            switch(r.$){
                case 21:
                    var t = 3 === (e = n.t6).$ ? Vt(EL(e.a)) : Ut;
                    return t.$ ? Pp : A4(hJ, n.j, t.a, function(n) {
                        return m(n, {
                            hY: Vt(10),
                            ic: 0
                        });
                    }, rJ(0));
                case 22:
                    return A2(Nu, nK, _u(r.a));
                default:
                    return Pp;
            }
            var e;
        }, r)), h);
    }), tK = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eK = F2(function(n, r) {
        return {
            tg: r,
            xw: n
        };
    }), uK = A3(eu, eK, A2(Tu, "userId", C$), A2(Tu, "name", C$)), aK = F3(function(n, r, t) {
        return A4(W_, n, A2(Tu, "users", vy(uK)), t, rA(A2(X_, x([
            "practice-users"
        ]), YA(r))));
    }), iK = {
        CE: vc,
        v8: h,
        bD: !1
    }, cK = {
        br: h,
        e1: !1
    }, oK = F8(function(n, r, t, e, u, a, i, c) {
        var o = m(iK, {
            CE: cP
        }), f = tC(z_(t));
        return b({
            ed: !0,
            I: da,
            aV: da,
            j: t,
            c9: vc,
            oz: "",
            g7: t,
            da: 0,
            ha: i,
            bj: a,
            di: 0,
            kA: r,
            dl: !1,
            eO: !0,
            T: "",
            bs: !1,
            bt: !1,
            cz: !0,
            bu: !1,
            cA: !1,
            bY: !1,
            ay: !1,
            bv: !1,
            bw: Ut,
            dq: Ut,
            kU: "",
            aN: vc,
            by: Ut,
            dB: n,
            dE: Ut,
            bB: o,
            cN: cK,
            V: h,
            cR: !1,
            fS: u,
            d2: Vt(0),
            d5: h,
            xs: e,
            fY: c
        }, f.$ ? A2(Nu, function(n) {
            return QJ(kp(n.jT.ce));
        }, WG) : Vu(x([
            A3(aK, t, f.a, A2(ru, tK, nW)),
            A2(Nu, function(n) {
                return QJ(kp(n.jT.ce));
            }, WG)
        ])));
    }), fK = F2(function(n, r) {
        return {
            rh: n,
            rJ: r
        };
    }), sK = A3(eu, fK, A2(Tu, "id", C$), A2(Tu, "isUnread", jk)), lK = F4(function(n, r, t, e) {
        return A4(dC, n, sK, e, rA(A2(X_, x([
            "conversations",
            t,
            "mark-as-read"
        ]), YA(r))));
    }), dK = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bK = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vK = {
        $: 11
    }, mK = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            y5: c,
            Al: r,
            AA: i,
            rJ: a,
            rR: t,
            t1: u,
            Cp: e,
            CD: n,
            Eo: o
        };
    }), pK = F3(function(n, r, t) {
        return {
            rh: n,
            Dn: t,
            DI: r
        };
    }), $K = A3(ly, "sentAt", KS, A3(ly, "snippet", C$, A3(ly, "id", C$, uu(pK)))), hK = A4(sy, "phoneNumber", iy(C$), Ut, A4(sy, "userId", iy(C$), Ut, A4(sy, "patientId", iy(C$), Ut, A4(sy, "contactId", iy(C$), Ut, A4(sy, "displayName", iy(C$), Ut, A3(ly, "id", C$, uu(F6(function(n, r, t, e, u, a) {
        return {
            y1: t,
            zp: r,
            rh: n,
            Cr: e,
            CA: a,
            xw: u
        };
    })))))))), gK = A3(ly, "updatedAt", KS, A3(ly, "createdAt", KS, A3(ly, "isArchived", jk, A3(ly, "isUnread", jk, A3(ly, "participants", vy(hK), A3(ly, "participantsCount", F$, A4(sy, "lastMessage", iy($K), Ut, A3(ly, "ident", C$, A3(ly, "practiceId", C$, uu(mK)))))))))), wK = F2(function(n, r) {
        return A2(X_, x([
            "conversations",
            r
        ]), YA(n));
    }), xK = F4(function(n, r, t, e) {
        return A4(W_, n, gK, e, rA(A2(wK, r, t)));
    }), kK = F4(function(n, r, t, e) {
        return {
            qd: r,
            hY: t,
            ic: e,
            Ee: n
        };
    }), yK = F2(function(n, r) {
        return {
            x7: r,
            Cn: n
        };
    }), _K = A2(nu, function(n) {
        switch(n){
            case "ADDED":
                return uu(0);
            case "REMOVED":
                return uu(1);
            default:
                return Sk("Unknown participantHistory.action: " + n);
        }
    }, C$), AK = A3(ly, "action", _K, A3(ly, "participant", hK, uu(yK))), CK = A4(sy, "participantHistory", aL(AK), Ut, A4(sy, "deletedAt", iy(KS), Ut, A3(ly, "updatedAt", KS, A3(ly, "createdAt", KS, A3(ly, "sentAt", KS, A3(ly, "author", hK, A4(sy, "files", vy(C$), h, A4(sy, "richText", iy(C$), Ut, A4(sy, "text", iy(C$), Ut, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                yt: u,
                                                y5: i,
                                                zk: o,
                                                z2: e,
                                                rh: n,
                                                Co: f,
                                                C8: t,
                                                Dn: a,
                                                D2: r,
                                                Eo: c
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), BK = A3(ly, "offset", F$, A3(ly, "limit", F$, A3(ly, "entities", vy(CK), A3(ly, "total", F$, uu(kK))))), EK = F3(function(n, r, t) {
        var e = t.$ ? h : x([
            A2(Y_, "timestamp", $J(t.a))
        ]), u = r.$ ? h : x([
            A2(bJ, "limit", r.a)
        ]);
        return A2(Yt, A2(bJ, "offset", n), $(u, e));
    }), DK = F2(function(n, r) {
        return A2(X_, x([
            "conversations",
            r,
            "messages"
        ]), YA(n));
    }), qK = F7(function(n, r, t, e, u, a, i) {
        return A4(W_, n, BK, i, A2(_P, A3(EK, e, u, a), rA(A2(DK, r, t))));
    }), FK = function(n) {
        return tC(z_(n));
    }, PK = F9(function(n, r, t, e, u, a, i, c, o) {
        var f, s;
        return b({
            ed: !1,
            I: da,
            aV: da,
            j: t,
            c9: cP,
            oz: u,
            g7: t,
            da: 0,
            ha: c,
            bj: i,
            di: 0,
            kA: r,
            dl: !1,
            eO: !1,
            T: "",
            bs: !1,
            bt: !1,
            cz: !1,
            bu: !1,
            cA: !1,
            bY: !1,
            ay: !1,
            bv: !1,
            bw: Ut,
            dq: Ut,
            kU: "",
            aN: cP,
            by: Ut,
            dB: n,
            dE: Ut,
            bB: iK,
            cN: cK,
            V: h,
            cR: !1,
            fS: a,
            d2: Ut,
            d5: h,
            xs: e,
            fY: o
        }, Vu(x([
            (s = FK(t), s.$ ? Pp : A4(xK, t, s.a, u, dK)),
            (f = FK(t), f.$ ? Pp : A7(qK, t, f.a, u, 0, Vt(10), Ut, bK)),
            A2(Nu, function() {
                return vK;
            }, _u(0)),
            A2(Nu, function(n) {
                return QJ(kp(n.jT.ce));
            }, WG)
        ])));
    }), zK = F2(function(n, r) {
        var t = 0 > s(r.d7, 1024) ? 0 : 1, e = A9(PK, r.dB, r.kA, r.j, r.xs, n, r.fS, r.bj, r.t6, t), u = e.b;
        return v(m(r, {
            X: Vt(e.a),
            a9: Vt(n)
        }), Vu(x([
            A2(Lp, xJ, u),
            A2(Nu, nK, _u(n))
        ])), h);
    }), jK = Wn("setupScrollDetection", function(n) {
        return _x(x([
            b("containerId", Ax(n.oj))
        ]));
    }), SK = function(n) {
        return {
            $: 25,
            a: n
        };
    }, LK = {
        $: 26
    }, MK = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), NK = function(n) {
        return {
            $: 1,
            a: n
        };
    }, HK = function(n) {
        return {
            $: 22,
            a: n
        };
    }, TK = function(n) {
        return {
            $: 16,
            a: n
        };
    }, IK = function(n) {
        return {
            $: 23,
            a: n
        };
    }, RK = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), ZK = {
        $: 21
    }, VK = {
        $: 9
    }, UK = function(n) {
        return {
            $: 8,
            a: n
        };
    }, YK = {
        $: 12
    }, QK = function(n) {
        return {
            $: 7,
            a: n
        };
    }, OK = {
        $: 10
    }, GK = A2(fe, ",", x([
        ".jpeg",
        ".jpg",
        ".gif",
        ".png",
        ".mp4",
        ".mp3",
        ".oga",
        ".weba",
        ".mpeg",
        ".webm",
        ".bmp",
        ".tif",
        ".tiff",
        ".csv",
        ".ics",
        ".pdf",
        ".heic"
    ])), JK = Wn("autoResize", Ax), WK = function(n) {
        return _x(x([
            b("userId", Ax(n.xw))
        ]));
    }, KK = F2(function(n, r) {
        return A3(de, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), XK = F4(function(n, r, t, e) {
        return A4(bL, n, gK, e, A2(vL, function(n) {
            return _x(x([
                b("participants", A2(KK, WK, n.t1))
            ]));
        }(t), rA(function(n) {
            return A2(X_, x([
                "conversations"
            ]), YA(n));
        }(r))));
    }), nX = function(n) {
        return {
            $: 6,
            a: n
        };
    }, rX = function(n) {
        return A2(Nu, nX, _u(n));
    }, tX = {
        ku: {
            q6: 0,
            ce: 0,
            xP: 0,
            lR: 0
        },
        v1: {
            q6: 0,
            ce: 0
        },
        jT: {
            q6: 0,
            ce: 0,
            xP: 0,
            lR: 0
        }
    }, eX = function(n) {
        return rt(n, function(n) {
            var r = n.getBoundingClientRect(), t = Kr.pageXOffset, e = Kr.pageYOffset;
            return {
                v1: ut(),
                jT: {
                    xP: t,
                    lR: e,
                    ce: Wr.documentElement.clientWidth,
                    q6: Wr.documentElement.clientHeight
                },
                ku: {
                    xP: t + r.left,
                    lR: e + r.top,
                    ce: r.width,
                    q6: r.height
                }
            };
        });
    }, uX = A3(eu, F2(function(n, r) {
        return {
            so: r,
            iI: n
        };
    }), A2(Tu, "requestId", C$), A2(Tu, "url", aL(C$))), aX = {
        $: 6
    }, iX = {
        $: 0
    }, cX = {
        $: 0
    }, oX = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fX = {
        $: 0
    }, sX = {
        $: 0
    }, lX = function(n) {
        var r = rv(Ae(A2(se, ".", n)));
        return 1 === r.$ ? "" : "." + r.a;
    }, dX = function(n) {
        var r, t = function(n) {
            var r = A2(se, "_", n);
            if (r.b) {
                var t = r.a, e = r.b;
                return A2(ae, ye, t) && su(t) >= 13 ? A2(fe, "_", e) : n;
            }
            return n;
        }(A2(sc, r = n, rv(Ae(A2(se, "/", r))))), e = lX(t);
        if (A2(fu, "__keenhp-file__", t)) return A2(sc, t, rv(A2(se, "__keenhp-file__", t)));
        var u = A2(fu, ".", t) ? A2(fe, ".", Ae(A2(Np, 1, Ae(A2(se, ".", t))))) : t, a = A2(se, "_", u), i = function() {
            var n = Ae(a);
            if (n.b && n.b.b) {
                var r = n.a, t = n.b, e = t.b;
                return A2(ae, ye, t.a) && A2(ae, ye, r) ? Ae(e) : a;
            }
            return a;
        }();
        return $(A2(fe, "_", i), e);
    }, bX = F2(function(n, r) {
        return {
            zp: r,
            zT: lX(r),
            af: n
        };
    }), vX = x([
        "wav",
        "mp3",
        "weba",
        "oga",
        "ogg",
        "m4a",
        "aac",
        "flac",
        "opus"
    ]), mX = x([
        "jpeg",
        "jpg",
        "gif",
        "png",
        "bmp",
        "webp",
        "tif",
        "tiff"
    ]), pX = x([
        "mp4",
        "webm",
        "mpeg",
        "mpg",
        "ogv"
    ]), $X = function(n) {
        var r, t = (r = UQ(n), A2(xu, ".", r) ? A2(du, 1, r) : r);
        return A2(SE, t, mX) || "heic" === t ? 0 : A2(SE, t, pX) ? 1 : A2(SE, t, vX) ? 2 : A2(SE, t, gW) ? 3 : 4;
    }, hX = function(n) {
        var r = xW(n), t = r.a, e = $X(r.b), u = $X(t);
        return 4 !== u ? u : e;
    }, gX = F2(function(n, r) {
        return A2(X_, x([
            "conversations",
            r,
            "files"
        ]), YA(n));
    }), wX = A3(ly, "fileUrl", C$, uu(iu)), xX = F5(function(n, r, t, e, u) {
        return A4(W_, n, wX, u, A2(_P, x([
            A2(Y_, "filename", e)
        ]), rA(A2(gX, r, t))));
    }), kX = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, yX = F6(function(n, r, t, e, u, a) {
        var i, c, o = a.$ ? (c = lX(i = u), {
            zp: dX(i),
            zT: c,
            af: i
        }) : A2(bX, u, a.a), f = hX(o), s = kX(f) ? cP : vc, l = kX(f) ? A5(xX, n, r, t, o.af, A2(ru, oX, dW)) : Pp, d = A2(fS, 0, dW(aX));
        return b({
            c: o,
            k: e,
            l: {
                bj: 0,
                pI: 0,
                bX: !1,
                cE: !1,
                cb: 0
            },
            yW: n,
            oz: t,
            di: 0,
            f: {
                bq: !1,
                aK: Ut,
                K: Ut,
                F: Ut
            },
            ak: !1,
            Cr: r,
            b5: {
                q6: Ut,
                ce: Ut
            },
            b: d.a,
            u: iX,
            B: cX,
            p: fX,
            h: !1,
            n: Ut,
            v: sX,
            r: 0,
            w: 0,
            cU: s,
            y: {
                bR: 0,
                K: Ut,
                F: Ut,
                b2: !1,
                dF: !1,
                fn: !1
            }
        }, Vu(x([
            l,
            d.b
        ])));
    }), _X = F7(function(n, r, t, e, u, a, i) {
        var c = A2(Eu, function(e) {
            var u, c = (u = rv(A2(bu, "_", e))).$ ? e : A2(du, u.a + 1, e), o = A6(yX, n, r, t, e, c, A2(nv, function(n) {
                return vu(n) ? Ut : Vt(n);
            }, A2(Wu, c, a))), f = o.b;
            return v(e, o.a, A2(Lp, i(e), f));
        }, A2(Rc, function(n) {
            return !A2(Aq, n, u);
        }, A2(tc, function(n) {
            return A2(Eu, function(r) {
                return n.rh + "_" + r;
            }, n.z2);
        }, e))), o = A2(Eu, function(n) {
            return n.c;
        }, c);
        return b(A3(de, F2(function(n, r) {
            return A3(ta, n.a, n.b, r);
        }), u, c), o);
    }), AX = function(n) {
        return rt(n, function(n) {
            return {
                v1: {
                    ce: n.scrollWidth,
                    q6: n.scrollHeight
                },
                jT: {
                    xP: n.scrollLeft,
                    lR: n.scrollTop,
                    ce: n.clientWidth,
                    q6: n.clientHeight
                }
            };
        });
    }, CX = it, BX = A2(hc, function() {
        return JJ;
    }, A2(Du, function(n) {
        return A3(CX, "messages-container", 0, n.v1.q6);
    }, AX("messages-container"))), EX = wn, DX = Wn("measureElement", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT)),
            b("maxLines", EX(n.A$))
        ]));
    }), qX = DX({
        bT: "participant-header-text",
        A$: 2
    }), FX = Wn("openFileDialogPort", Ax), PX = A4(cW, F3(function(n, r, t) {
        return {
            q6: t,
            iI: n,
            ce: r
        };
    }), A2(Tu, "requestId", C$), A2(Tu, "width", q$), A2(Tu, "height", q$)), zX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jX = F2(function(n, r) {
        return A2(Nu, function() {
            return r;
        }, jp(n));
    }), SX = F3(function(n, r, t) {
        var e = t, u = m(e, {
            br: A2(Yt, r, e.br)
        }), a = function() {
            var r = n.DW;
            switch(r.$){
                case 0:
                    var t = r.a;
                    return e.e1 ? Pp : A2(jX, t, zX(Ut));
                case 1:
                    t = r.a;
                    var a = r.b;
                    return e.e1 ? Pp : A2(jX, t, zX(Vt(a)));
                default:
                    return A2(jX, a = r.a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(function(n) {
                        return be(n.br);
                    }(u)));
            }
        }();
        return b(u, A2(Lp, n.Ek, a));
    }), LX = function(n) {
        return {
            $: 7,
            a: n
        };
    }, MX = function(n) {
        return {
            $: 3,
            a: n
        };
    }, NX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, HX = function(n) {
        var r = A2(qu, function() {
            return 0;
        }, eX(n));
        return A2(hc, A2(ru, NX, MX), A2($c, function() {
            return A2(Du, function() {
                return r;
            }, jp(64));
        }, A2($c, function() {
            return A2(Du, function() {
                return r;
            }, jp(32));
        }, A2($c, function() {
            return A2(Du, function() {
                return r;
            }, jp(16));
        }, r))));
    }, TX = h$(function(n) {
        return _e(n) ? n : "_";
    }), IX = function(n) {
        return "fp-audio-" + TX(n);
    }, RX = Wn("mediaPlay", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT))
        ]));
    }), ZX = wn, VX = Wn("mediaSetCurrentTime", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT)),
            b("seconds", ZX(n.Dh))
        ]));
    }), UX = Wn("mediaTogglePlayPause", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT))
        ]));
    }), YX = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r.l.cE ? b(r, UX({
                    bT: IX(r.k)
                })) : b(m(r, {
                    l: m(u = r.l, {
                        cE: !0
                    })
                }), HX(IX(r.k)));
            case 1:
                return b(r, n.a.$ ? Pp : RX({
                    bT: IX(r.k)
                }));
            case 2:
                return b(m(r, {
                    l: m(u = r.l, {
                        bX: !0
                    })
                }), Pp);
            case 3:
                return b(m(r, {
                    l: m(u = r.l, {
                        bX: !1
                    })
                }), Pp);
            case 4:
                return b(m(r, {
                    l: m(u = r.l, {
                        bj: n.a,
                        pI: t = n.b
                    })
                }), Pp);
            case 5:
                var t;
                return b(m(r, {
                    l: m(u = r.l, {
                        pI: t = n.a,
                        cb: t > 0 ? 0 : u.cb
                    })
                }), Pp);
            case 9:
                return 1 > (u = r.l).cb ? b(m(r, {
                    l: m(u, {
                        cb: u.cb + 1
                    })
                }), A5(xX, r.yW, r.Cr, r.oz, r.c.af, A2(ru, oX, dW))) : b(m(r, {
                    ak: !0
                }), Pp);
            case 6:
                return b(m(r, {
                    l: m(u = r.l, {
                        bj: 0,
                        bX: !1
                    })
                }), Pp);
            case 7:
                var e = A2(Ve, 0, A2(Kv, 1, n.a)) * (a = (u = r.l).pI);
                return a > 0 ? b(m(r, {
                    l: m(u, {
                        bj: e
                    })
                }), VX({
                    bT: IX(r.k),
                    Dh: e
                })) : b(r, Pp);
            default:
                var u, a;
                n = LX(((a = (u = r.l).pI) > 0 ? u.bj / a : 0) + n.a);
                continue n;
        }
    }), QX = {
        $: 1
    }, OX = {
        $: 1
    }, GX = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), JX = function(n) {
        return {
            $: 3,
            a: n
        };
    }, WX = function(n) {
        return {
            $: 4,
            a: n
        };
    }, KX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XX = {
        $: 4
    }, n1 = {
        $: 2
    }, r1 = {
        $: 1
    }, t1 = {
        $: 1
    }, e1 = {
        $: 1
    }, u1 = F3(function(n, r, t) {
        var e;
        return A2(Nu, yu, A3(Zt, n, r, (e = t, new Uint8Array(e.buffer, e.byteOffset, e.byteLength))));
    }), a1 = Wn("convertDocxFromUrl", function(n) {
        return _x(x([
            b("requestId", Ax(n.iI)),
            b("url", Ax(n.xs))
        ]));
    }), i1 = Wn("convertHeicFromUrl", function(n) {
        return _x(x([
            b("requestId", Ax(n.iI)),
            b("url", Ax(n.xs))
        ]));
    }), c1 = Wn("clearDocxMount", Ax), o1 = function(n) {
        return "fp-docx-lightbox-" + TX(n.k);
    }, f1 = function(n) {
        return yW(n.c) ? c1(o1(n)) : Pp;
    }, s1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, l1 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, d1 = {
        $: 2
    }, b1 = {
        $: 1
    }, v1 = F2(function(n, r) {
        return A3(Nt, "arraybuffer", Tt, A2(ru, r, n));
    }), m1 = function(n) {
        return o_({
            gN: f_,
            zQ: n.zQ,
            hC: h,
            Be: "GET",
            D8: Ut,
            Eh: Ut,
            xs: n.xs
        });
    }, p1 = F2(function(n, r) {
        return m1({
            zQ: A2(v1, r, function(n) {
                switch(n.$){
                    case 0:
                        return Kt(l1(n.a));
                    case 1:
                        return Kt(b1);
                    case 2:
                        return Kt(d1);
                    case 3:
                        return Kt(s1(n.a.DT));
                    default:
                        return te(n.b);
                }
            }),
            xs: n
        });
    }), $1 = function(n) {
        var r = xW(n);
        return "heic" === r.a || "heic" === r.b;
    }, h1 = function(n) {
        return "fp-pdf-lightbox-" + TX(n.k);
    }, g1 = "0.1.4", w1 = F2(function(n, r) {
        return n(function(n) {
            switch(n.$){
                case 0:
                    var r = n.a;
                    return _x(x([
                        b("cmd", Ax("openurl")),
                        b("name", Ax(r.tg)),
                        b("url", Ax(r.xs)),
                        b("version", Ax(g1))
                    ]));
                case 1:
                    return r = n.a, _x(x([
                        b("cmd", Ax("openstring")),
                        b("name", Ax(r.tg)),
                        b("string", Ax(r.DX)),
                        b("version", Ax(g1))
                    ]));
                default:
                    return r = n.a, _x(x([
                        b("cmd", Ax("close")),
                        b("name", Ax(r.tg))
                    ]));
            }
        }(r));
    }), x1 = Wn("sendPdfCommand", iu), k1 = function(n) {
        return A2(w1, x1, function(n) {
            return {
                $: 2,
                a: n
            };
        }({
            tg: n
        }));
    }, y1 = function(n) {
        return CW(n.c) ? k1(h1(n)) : Pp;
    }, _1 = Wn("requestSpreadsheetPreview", function(n) {
        return _x(x([
            b("kind", Ax(n.hR)),
            b("requestId", Ax(n.iI)),
            b("url", Ax(n.xs))
        ]));
    }), A1 = Wn("requestXmlPreview", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT)),
            b("requestId", Ax(n.iI)),
            b("url", Ax(n.xs))
        ]));
    }), C1 = Wn("revokePreviewObjectUrl", Ax), B1 = function(n) {
        if (n.$) return Pp;
        var r = n.a;
        return A2(xu, "blob:", r) ? C1(r) : Pp;
    }, E1 = F2(function(n, r) {
        return A2(w1, x1, function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            tg: n,
            xs: r
        }));
    }), D1 = Wn("clearXmlMount", Ax), q1 = function(n) {
        return "fp-xml-lightbox-" + TX(n.k);
    }, F1 = function(n) {
        return NW(n.c) ? D1(q1(n)) : Pp;
    }, P1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = function(n) {
                    var r = n.y;
                    return m(n, {
                        f: m(n.f, {
                            K: Ut,
                            F: Ut
                        }),
                        b5: {
                            q6: Ut,
                            ce: Ut
                        },
                        y: m(r, {
                            K: Ut,
                            F: Ut
                        })
                    });
                }(m(r, {
                    l: {
                        bj: 0,
                        pI: 0,
                        bX: !1,
                        cE: !1,
                        cb: 0
                    },
                    f: {
                        bq: !1,
                        aK: Ut,
                        K: r.f.K,
                        F: r.f.F
                    },
                    ak: !1,
                    b: WL(r.b),
                    u: iX,
                    B: cX,
                    p: fX,
                    h: !1,
                    n: Ut,
                    v: sX,
                    r: 0,
                    w: 0,
                    cU: t,
                    y: {
                        bR: 0,
                        K: Ut,
                        F: Ut,
                        b2: !1,
                        dF: !1,
                        fn: !1
                    }
                }));
                if (3 === t.$) {
                    var u = t.a, a = B1(r.f.aK), i = $1(r.c), c = !(f = hX(r.c)) && !i || 1 === f ? A2(Nu, function() {
                        return NK(t1);
                    }, jp(50)) : Pp, o = i ? b(m(e, {
                        f: m(e.f, {
                            bq: !0,
                            aK: Ut,
                            K: Ut,
                            F: Ut
                        })
                    }), Vu(x([
                        a,
                        i1({
                            iI: r.k,
                            xs: u
                        })
                    ]))) : b(e, a);
                    return b(o.a, Vu(x([
                        o.b,
                        c
                    ])));
                }
                return b(e, B1(r.f.aK));
            case 1:
                var f, s = m(r, {
                    di: n.a
                });
                switch(f = hX(s.c)){
                    case 0:
                        return $1(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !1,
                            v: sX,
                            r: 0,
                            w: 0
                        }), Pp) : b(m(s, {
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !1,
                            v: sX,
                            r: 0,
                            w: 0
                        }), A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW)));
                    case 3:
                        return yW(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: OX,
                            p: fX,
                            h: !1,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 0
                        }), Vu(x([
                            f1(s),
                            y1(s),
                            A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW))
                        ]))) : CW(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: r1,
                            h: !1,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 0
                        }), Vu(x([
                            y1(s),
                            A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW))
                        ]))) : PW(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: QX,
                            B: cX,
                            p: fX,
                            h: !1,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 0
                        }), Vu(x([
                            f1(s),
                            y1(s),
                            A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW))
                        ]))) : zW(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !1,
                            n: Ut,
                            v: e1,
                            r: 0,
                            w: 0
                        }), Vu(x([
                            f1(s),
                            y1(s),
                            A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW))
                        ]))) : NW(s.c) ? b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !1,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 1
                        }), Vu(x([
                            f1(s),
                            y1(s),
                            A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, KX, dW))
                        ]))) : b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !0,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 0
                        }), A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, JX, dW)));
                    default:
                        return b(m(s, {
                            b: NM(s.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            h: !0,
                            n: Ut,
                            v: sX,
                            r: 0,
                            w: 0
                        }), A5(xX, s.yW, s.Cr, s.oz, s.c.af, A2(ru, JX, dW)));
                }
            case 3:
                return b(3 === (t = n.a).$ ? m(r, {
                    cU: A2(Zy, u = t.a, t.b)
                }) : r, Pp);
            case 2:
                switch((t = n.a).$){
                    case 3:
                        if (u = t.a, $1(r.c)) return b(r, Pp);
                        if (yW(r.c)) return b(m(r, {
                            n: Vt(u)
                        }), a1({
                            iI: r.k,
                            xs: u
                        }));
                        if (CW(r.c)) {
                            var l = LW(r) ? n1 : XX, d = h1(r), v = LW(r) ? Vu(x([
                                k1(d),
                                A2(E1, d, u)
                            ])) : k1(d);
                            return b(m(r, {
                                b: NM(r.b),
                                p: l,
                                h: !1,
                                n: Vt(u)
                            }), v);
                        }
                        return PW(r.c) ? b(m(r, {
                            b: NM(r.b),
                            h: !1,
                            n: Vt(u)
                        }), _1({
                            hR: "csv",
                            iI: r.k,
                            xs: u
                        })) : zW(r.c) ? b(m(r, {
                            b: NM(r.b),
                            h: !1,
                            n: Vt(u)
                        }), _1({
                            hR: "xlsx",
                            iI: r.k,
                            xs: u
                        })) : NW(r.c) ? b(m(r, {
                            b: NM(r.b),
                            h: !1,
                            n: Vt(u)
                        }), A1({
                            bT: q1(r),
                            iI: r.k,
                            xs: u
                        })) : b(m(r, {
                            b: NM(r.b),
                            h: !1,
                            n: Vt(u)
                        }), Pp);
                    case 2:
                        return b(m(r, {
                            b: WL(r.b),
                            u: iX,
                            B: cX,
                            p: fX,
                            v: sX,
                            r: 0,
                            w: 0
                        }), Vu(x([
                            f1(r),
                            y1(r),
                            F1(r)
                        ])));
                    default:
                        return b(r, Pp);
                }
            case 6:
                return b(m(r, {
                    b: WL(r.b),
                    u: iX,
                    B: cX,
                    p: fX,
                    h: !1,
                    n: Ut,
                    v: sX,
                    r: 0,
                    w: 0
                }), Vu(x([
                    f1(r),
                    y1(r),
                    F1(r)
                ])));
            case 7:
                return b(r, A5(xX, r.yW, r.Cr, r.oz, r.c.af, A2(ru, WX, dW)));
            case 4:
                return 3 === (t = n.a).$ ? (u = t.a, b(m(r, {
                    b: WL(r.b),
                    u: iX,
                    B: cX,
                    p: fX,
                    h: !1,
                    n: Ut,
                    v: sX,
                    r: 0,
                    w: 0,
                    cU: vc
                }), Vu(x([
                    A2(p1, u, A2(ru, GX({
                        zp: r.c.zp,
                        qq: u
                    }), dW)),
                    f1(r),
                    y1(r),
                    F1(r)
                ])))) : b(r, Pp);
            case 5:
                var p = n.a, $ = n.b;
                return b(r, $.$ ? $Q(p.qq) : A3(u1, p.zp, "application/octet-stream", $.a));
            case 8:
                var h = A2(lN, n.a, r.b), g = h.b;
                return b(m(r, {
                    b: h.a
                }), A2(Lp, A2(pc, dW, mW), g));
            case 10:
                var w = r.f;
                return b(m(r, {
                    f: m(w, {
                        aK: Ut
                    }),
                    ak: !0,
                    b: WL(r.b),
                    u: iX,
                    B: cX,
                    p: fX,
                    h: !1,
                    n: Ut,
                    v: sX,
                    r: 0,
                    w: 0
                }), Vu(x([
                    B1(w.aK),
                    f1(r),
                    y1(r),
                    F1(r)
                ])));
            case 9:
                return b(m(r, {
                    di: k = n.a
                }), Pp);
            default:
                var k = n.a;
                return b(m(r, {
                    b5: m(r.b5, {
                        q6: Vt(n.b),
                        ce: Vt(k)
                    })
                }), Pp);
        }
    }), z1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, j1 = Wn("mountDocxHtml", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT)),
            b("html", Ax(n.rf))
        ]));
    }), S1 = F2(function(n, r) {
        return j1({
            bT: o1(n),
            rf: r
        });
    }), L1 = {
        $: 3
    }, M1 = function(n) {
        return b(m(n, {
            b: WL(n.b),
            u: iX,
            B: L1,
            p: fX,
            n: Ut,
            v: sX,
            r: 0,
            w: 0
        }), Vu(x([
            f1(n),
            y1(n),
            F1(n)
        ])));
    }, N1 = A4(cW, F3(function(n, r, t) {
        return {
            rf: t,
            k0: r,
            iI: n
        };
    }), A2(Tu, "requestId", C$), A2(Tu, "ok", jk), A2(Tu, "html", aL(C$))), H1 = F2(function(n, r) {
        var t = A2(cy, N1, n);
        if (t.$) return M1(r);
        var e = t.a.k0, u = t.a.rf;
        if (i(t.a.iI, r.k) && hW(r.b)) {
            if (e) {
                if (u.$) return M1(r);
                var a = u.a;
                return vu(a) ? M1(r) : b(m(r, {
                    B: z1(a)
                }), A2(S1, r, a));
            }
            return M1(r);
        }
        return b(r, Pp);
    }), T1 = {
        $: 2
    }, I1 = Wn("observePreviewLayout", function(n) {
        return _x(x([
            b("elementId", Ax(n.bT)),
            b("requestId", Ax(n.iI))
        ]));
    }), R1 = function(n) {
        return "fp-box-" + TX(n);
    }, Z1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return $1(r.c) ? t.$ ? b(m(r, {
                    f: m(r.f, {
                        bq: !1
                    }),
                    ak: !0
                }), Pp) : b(m(r, {
                    f: m(r.f, {
                        bq: !1,
                        aK: Vt(t.a)
                    }),
                    ak: !1
                }), A2(Nu, function() {
                    return NK(t1);
                }, jp(50))) : b(r, Pp);
            case 1:
                return b(r, A2(Nu, function() {
                    return NK(T1);
                }, jp(50)));
            case 2:
                return b(r, I1({
                    bT: R1(r.k),
                    iI: r.k
                }));
            default:
                var e = n.a;
                return b(m(r, {
                    f: m(r.f, {
                        K: Vt(n.b),
                        F: Vt(e)
                    })
                }), Pp);
        }
    }), V1 = {
        $: 5
    }, U1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Y1 = function(n) {
        return b(m(n, {
            b: WL(n.b),
            u: iX,
            p: fX,
            n: Ut,
            v: sX,
            r: 0,
            w: 0
        }), Vu(x([
            y1(n),
            F1(n)
        ])));
    }, Q1 = F2(function(n, r) {
        if (n.$) return CW(r.c) && hW(r.b) ? b(m(r, {
            p: V1
        }), Pp) : b(r, Pp);
        var t = n.a;
        if (t.$) return Y1(r);
        if (1 === t.a.$) {
            var e = t.a.a.Ci;
            return i(t.a.a.tg, h1(r)) && hW(r.b) && CW(r.c) ? b(m(r, {
                p: U1(e)
            }), Pp) : b(r, Pp);
        }
        return Y1(r);
    }), O1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, G1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, J1 = {
        $: 3
    }, W1 = {
        $: 3
    }, K1 = function(n) {
        return b(m(n, {
            b: WL(n.b),
            u: J1,
            B: cX,
            p: fX,
            n: Ut,
            v: W1,
            r: 0,
            w: 3
        }), Vu(x([
            f1(n),
            y1(n),
            F1(n)
        ])));
    }, X1 = F5(function(n, r, t, e, u) {
        return {
            z9: e,
            hR: t,
            k0: r,
            iI: n,
            Du: u
        };
    }), n0 = A3(eu, F2(function(n, r) {
        return {
            hC: n,
            iL: r
        };
    }), A2(Tu, "headers", vy(C$)), A2(Tu, "rows", vy(vy(C$)))), r0 = A4(cW, F3(function(n, r, t) {
        return {
            hC: r,
            tg: n,
            iL: t
        };
    }), A2(Tu, "name", C$), A2(Tu, "headers", vy(C$)), A2(Tu, "rows", vy(vy(C$)))), t0 = A6(eW, X1, A2(Tu, "requestId", C$), A2(Tu, "ok", jk), A2(Tu, "kind", C$), iy(A2(Tu, "grid", n0)), iy(A2(Tu, "sheets", vy(r0)))), e0 = F2(function(n, r) {
        if (n.$) return b(m(r, {
            r: n.a
        }), Pp);
        var t = A2(cy, t0, n.a);
        if (t.$) return K1(r);
        var e = t.a;
        if (i(e.iI, r.k) && hW(r.b)) {
            if (e.k0) {
                if ("csv" === e.hR) {
                    var u = e.z9;
                    return u.$ ? K1(r) : b(m(r, {
                        u: O1(u.a)
                    }), Pp);
                }
                if ("xlsx" === e.hR) {
                    var a = e.Du;
                    return a.$ ? K1(r) : b(m(r, {
                        v: G1(a.a),
                        r: 0
                    }), Pp);
                }
                return K1(r);
            }
            return K1(r);
        }
        return b(r, Pp);
    }), u0 = function(n) {
        return "fp-video-" + TX(n);
    }, a0 = Wn("videoSeekPreview", function(n) {
        return _x(x([
            b("videoElementId", Ax(n.Er))
        ]));
    }), i0 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    y: m(t = r.y, {
                        b2: !t.b2
                    })
                }), UX({
                    bT: u0(r.k)
                }));
            case 1:
                return 1 > (t = r.y).bR ? b(m(r, {
                    y: m(t, {
                        bR: t.bR + 1
                    })
                }), A5(xX, r.yW, r.Cr, r.oz, r.c.af, A2(ru, oX, dW))) : b(m(r, {
                    ak: !0
                }), Pp);
            case 2:
                return (t = r.y).b2 || t.fn ? b(m(r, {
                    y: m(t, {
                        bR: 0,
                        dF: !0
                    })
                }), Pp) : b(m(r, {
                    y: m(t, {
                        bR: 0,
                        dF: !0,
                        fn: !0
                    })
                }), a0({
                    Er: u0(r.k)
                }));
            default:
                var t, e = n.a;
                return b(m(r, {
                    y: m(t = r.y, {
                        K: Vt(n.b),
                        F: Vt(e)
                    })
                }), Pp);
        }
    }), c0 = F2(function(n, r) {
        return {
            k0: r,
            iI: n
        };
    }), o0 = A3(eu, c0, A2(Tu, "requestId", C$), A2(Tu, "ok", jk)), f0 = F2(function(n, r) {
        var t = A2(cy, o0, n);
        if (t.$) return K1(r);
        var e = t.a;
        return i(e.iI, r.k) && hW(r.b) ? e.k0 ? b(m(r, {
            w: 2
        }), Pp) : K1(r) : b(r, Pp);
    }), s0 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(P1, n.a, r);
            case 1:
                return A2(Z1, n.a, r);
            case 2:
                return A2(i0, n.a, r);
            case 3:
                return A2(YX, n.a, r);
            case 4:
                return A2(H1, n.a, r);
            case 5:
                return A2(Q1, n.a, r);
            case 6:
                return A2(e0, n.a, r);
            default:
                return A2(f0, n.a, r);
        }
    }), l0 = F3(function(n, r, t) {
        var e = A2(Wu, r, n.I);
        if (e.$) return v(n, Pp, h);
        var u = A2(s0, t, e.a), a = u.b;
        return v(m(n, {
            I: A3(ta, r, u.a, n.I)
        }), A2(Lp, VJ(r), a), h);
    }), d0 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, b0 = {
        DW: d0(200),
        Ek: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, v0 = F2(function(n, r) {
        return A2(X_, x([
            "conversations",
            r,
            "messages"
        ]), YA(n));
    }), m0 = F2(function(n, r) {
        return {
            rh: n,
            Dn: r
        };
    }), p0 = A3(ly, "sentAt", KS, A3(ly, "id", C$, uu(m0))), $0 = F5(function(n, r, t, e, u) {
        return A4(bL, n, p0, u, A2(vL, function(n) {
            var r, t = x([
                b("files", A2(KK, Ax, n.z2))
            ]), e = (r = n.D2).$ ? t : A2(Yt, b("text", Ax(r.a)), t);
            return _x(e);
        }(e), rA(A2(v0, r, t))));
    }), h0 = F3(function(n, r) {
        return b(h, n(r));
    }), g0 = F2(function(n, r) {
        return b({
            rE: !!r.rF && r.rE,
            rF: !0,
            wi: n.zN
        }, Pp);
    }), w0 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    CE: n.a
                }), Pp);
            case 1:
                return b(m(r, {
                    bD: !r.bD
                }), Pp);
            case 2:
                var t = n.a;
                return b(m(r, {
                    v8: A2(SE, t, r.v8) ? A2(Rc, function(n) {
                        return !i(n, t);
                    }, r.v8) : A2(Yt, t, r.v8)
                }), Pp);
            default:
                return b(m(r, {
                    bD: !1
                }), Pp);
        }
    }), x0 = F4(function(n, r, t, e) {
        var u = e;
        switch(t.$){
            case 0:
                return b(u, Pp);
            case 1:
                var a = t.a, i = u.br;
                if (i.b) {
                    var c = i.a, o = i.b, f = function() {
                        if (a.$) return Pp;
                        var n = a.a;
                        return A2(jX, n, zX(Vt(n)));
                    }(), l = A2(r, c, o), d = l.b;
                    return b(m(u, {
                        br: l.a,
                        e1: !0
                    }), Vu(x([
                        d,
                        A2(Lp, n.Ek, f)
                    ])));
                }
                return b(m(u, {
                    e1: !1
                }), Pp);
            default:
                var v = t.a, p = b(1 > s(be(u.br), v), u.br);
                if (p.a && p.b.b) {
                    var $ = p.b, h = A2(r, c = $.a, o = $.b), g = h.b;
                    return b(m(u, {
                        br: h.a
                    }), g);
                }
                return b(u, Pp);
        }
    }), k0 = Wn("uploadFileToApi", function(n) {
        return _x(x([
            b("request", function(n) {
                return _x(x([
                    b("authToken", Ax(n.ys)),
                    b("conversationId", Ax(n.oz)),
                    b("fileIndex", EX(n.qx)),
                    b("patientId", Ax(n.Cr))
                ]));
            }(n.C1)),
            b("url", Ax(n.xs))
        ]));
    }), y0 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    c9: t,
                    oz: 3 === t.$ ? t.a.Al : r.oz
                }), qX, h);
            case 3:
            case 2:
                return v(r, Pp, h);
            case 1:
                if (3 === (fn = n.a).$) {
                    var e = fn.a, u = e.ic ? r.d2 : Vt(e.Ee), a = function() {
                        if (e.ic) {
                            var n = r.aN;
                            if (3 === n.$) {
                                var t = m(e, {
                                    qd: $(e.qd, n.a.qd),
                                    Ee: e.Ee
                                });
                                return A2(Zy, t, da);
                            }
                            return fn;
                        }
                        return fn;
                    }(), c = e.ic ? A2(Nu, function() {
                        return VK;
                    }, _u(0)) : Vu(x([
                        A2(Nu, function() {
                            return vK;
                        }, _u(0)),
                        BX,
                        qX
                    ])), o = e.ic + e.hY, f = 3 === a.$ ? be(a.a.qd) : 0, l = function() {
                        if (u.$) return 0 > s(be(e.qd), e.hY);
                        var n = u.a;
                        return s(f, n) > -1 || s(o, n) > -1;
                    }(), d = (Dn = FK(r.j)).$ ? b(r.I, h) : A7(_X, r.j, Dn.a, r.oz, e.qd, r.I, r.aV, VJ), p = d.b;
                    return v(m(r, {
                        ed: l,
                        I: d.a,
                        da: o,
                        dl: !1,
                        eO: !0,
                        bt: !1,
                        bw: e.ic ? r.bw : Vt(r.bj),
                        dq: Vt(e.ic),
                        aN: a,
                        d2: u
                    }), Vu(A2(Yt, c, p)), h);
                }
                return v(m(r, {
                    dl: !0,
                    bt: !1,
                    dq: Ut,
                    aN: fn
                }), Pp, h);
            case 4:
                if ("messages-container" === n.a.oj) {
                    var g = OZ(n.a.lR), w = A3(SX, b0, g, r.cN), k = w.b;
                    return v(m(r, {
                        cN: w.a
                    }), k, h);
                }
                return v(r, Pp, h);
            case 5:
                var y = n.a, _ = A4(x0, b0, h0(rX), y, r.cN);
                return k = _.b, v(m(r, {
                    cN: _.a
                }), k, h);
            case 6:
                var A = A2(sc, 0, zS(g = n.a)), C = r.da, B = 100 > A, E = !(En = r.dq).$ && i(En.a, C), D = !(Bn = r.d2).$ && s(C, Bn.a) > -1;
                return !B || r.bt || r.ed || r.dl || D || E || !r.eO ? v(r, Pp, h) : v(m(r, {
                    bt: !0
                }), A2(hc, A2(ru, up(tX), QK), eX("messages-content")), h);
            case 7:
                return C = r.da, v(m(r, {
                    bY: !0,
                    dE: Vt(n.a.ku.q6)
                }), (Cn = FK(r.j)).$ ? Pp : A7(qK, r.j, Cn.a, r.oz, C, Vt(10), Ut, bK), h);
            case 9:
                return v(r, A2(hc, A2(ru, up(tX), UK), eX("messages-content")), h);
            case 8:
                var q = n.a, F = r.dE;
                if (F.$) return v(m(r, {
                    bY: !1
                }), Pp, h);
                var P = q.ku.q6 - F.a;
                return v(m(r, {
                    dE: Ut
                }), A2(hc, function() {
                    return OK;
                }, A3(CX, "messages-container", 0, P)), h);
            case 10:
                return v(m(r, {
                    bY: !1
                }), Pp, h);
            case 11:
                return v(r, A2(hc, function(n) {
                    return n.$ ? vK : YK;
                }, eX("messages-container")), h);
            case 12:
                return v(r, jK({
                    oj: "messages-container"
                }), h);
            case 13:
                return v(m(r, {
                    T: n.a
                }), JK("chat-input-textarea"), h);
            case 14:
                var z = !vu(XC(r.T)), j = !TE(r.V);
                if (z || j) {
                    if (j) return v(m(r, {
                        ay: !0,
                        bv: !0
                    }), A2(Nu, IK, _u(r.V)), h);
                    if (r.cz && !TE(r.bB.v8)) {
                        var S = {
                            z2: h,
                            D2: vu(XC(r.T)) ? Ut : Vt(r.T)
                        };
                        return v(m(r, {
                            T: "",
                            bs: !0,
                            by: Vt(S),
                            V: h
                        }), Vu(x([
                            A2(Nu, function() {
                                return LK;
                            }, _u(0)),
                            JK("chat-input-textarea")
                        ])), h);
                    }
                    var L = FK(r.j);
                    if (L.$) return v(r, Pp, h);
                    var M = L.a;
                    return S = {
                        z2: h,
                        D2: vu(XC(r.T)) ? Ut : Vt(r.T)
                    }, v(m(r, {
                        T: "",
                        ay: !0,
                        V: h
                    }), Vu(x([
                        A5($0, r.j, M, r.oz, S, TK),
                        JK("chat-input-textarea")
                    ])), h);
                }
                return v(r, Pp, h);
            case 16:
                return 3 === (tn = n.a).$ ? v(m(r, {
                    bs: !1,
                    ay: !1
                }), (An = FK(r.j)).$ ? Pp : A7(qK, r.j, An.a, r.oz, 0, Vt(10), Ut, bK), x([
                    ZK
                ])) : v(m(r, {
                    ay: !1
                }), Pp, h);
            case 17:
                return v(r, FX(GK), h);
            case 18:
                return v(m(r, {
                    V: $(r.V, n.a)
                }), Pp, h);
            case 19:
                var N = n.a;
                return v(m(r, {
                    V: A2(Eu, zc, A2(Rc, function(n) {
                        return !i(n.a, N);
                    }, A2(he, F2(function(n, r) {
                        return b(n, r);
                    }), r.V)))
                }), Pp, h);
            case 15:
                var H = A2(w0, n.a, r.bB), T = H.b;
                return v(m(r, {
                    bB: H.a
                }), A2(Lp, nW, T), h);
            case 20:
                return v(m(r, {
                    bu: !r.bu
                }), Pp, h);
            case 21:
                var I = A2(g0, n.a, {
                    rE: r.bu,
                    rF: r.cA,
                    wi: r.cR
                }).a;
                return v(m(r, {
                    bu: I.rE,
                    cA: I.rF,
                    cR: I.wi
                }), Pp, h);
            case 23:
                var R = n.a, Z = v(FK(r.j), P_(z_(r.j)), Vt(T_(r.j)));
                if (Z.a.$ || Z.b.$ || Z.c.$) return v(m(r, {
                    ay: !1,
                    bv: !1
                }), Pp, h);
                M = Z.a.a;
                var V = Z.b.a, U = Z.c.a, Y = A2(he, F2(function(n) {
                    return k0({
                        C1: {
                            ys: V,
                            oz: r.oz,
                            qx: n,
                            Cr: M
                        },
                        xs: U + "/v1/member/" + M + "/conversations/" + r.oz + "/files"
                    });
                }), R);
                return v(r, Vu(Y), h);
            case 24:
                if ((tn = n.a).D_) {
                    var Q = $(r.d5, x([
                        tn.qy
                    ])), O = vu(tn.qz) ? A2(nv, function(n) {
                        return vu(n) ? Ut : Vt(n);
                    }, A2(Fp, function(n) {
                        return n.tg;
                    }, rv(A2(Np, tn.qx, r.V)))) : Vt(tn.qz), G = O.$ ? r.aV : A3(ta, tn.qy, O.a, r.aV);
                    if (s(be(Q), be(r.V)) > -1) {
                        var J = FK(r.j);
                        return J.$ ? v(m(r, {
                            aV: G,
                            ay: !1,
                            bv: !1
                        }), Pp, h) : (M = J.a, S = {
                            z2: Q,
                            D2: vu(XC(r.T)) ? Ut : Vt(r.T)
                        }, v(m(r, {
                            aV: G,
                            T: "",
                            bv: !1,
                            V: h,
                            d5: h
                        }), A5($0, r.j, M, r.oz, S, TK), h));
                    }
                    return v(m(r, {
                        aV: G,
                        d5: Q
                    }), Pp, h);
                }
                return v(m(r, {
                    ay: !1,
                    bv: !1
                }), Pp, h);
            case 22:
                return A3(l0, r, n.a, n.b);
            case 29:
                var W = A2(cy, uX, n.a);
                return W.$ ? v(r, Pp, h) : A3(l0, r, W.a.iI, NK(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(W.a.so)));
            case 30:
                var K = A2(cy, PX, n.a);
                return K.$ ? v(r, Pp, h) : A3(l0, r, K.a.iI, dW(A2(RK, K.a.ce, K.a.q6)));
            case 31:
                var X = n.a, nn = A2(zM, F2(function(n, r) {
                    return A2(s0, dW(function(n) {
                        return {
                            $: 9,
                            a: n
                        };
                    }(X)), r).a;
                }), r.I);
                return v(m(r, {
                    I: nn,
                    di: X
                }), Pp, h);
            case 26:
                var rn = FK(r.j);
                return rn.$ ? v(m(r, {
                    bs: !1,
                    by: Ut
                }), Pp, h) : v(r, A4(XK, r.j, M = rn.a, S = {
                    t1: A2(Eu, function(n) {
                        return {
                            xw: n
                        };
                    }, r.bB.v8)
                }, SK), h);
            case 25:
                var tn;
                if (3 === (tn = n.a).$) {
                    var en = tn.a, un = r.by;
                    if (un.$) return v(m(r, {
                        bs: !1,
                        by: Ut
                    }), Pp, h);
                    var an = un.a;
                    return v(m(r, {
                        c9: A2(Zy, en, da),
                        oz: en.Al,
                        cz: !1,
                        ay: !0,
                        by: Ut
                    }), (_n = FK(r.j)).$ ? Pp : A5($0, r.j, _n.a, en.Al, an, TK), h);
                }
                return v(m(r, {
                    bs: !1,
                    by: Ut
                }), Pp, h);
            case 27:
                var cn = n.a;
                if (3 === r.aN.$) {
                    var on = function() {
                        if (vu(r.oz)) return Pp;
                        var n = FK(r.j);
                        return n.$ ? Pp : A7(qK, r.j, n.a, r.oz, 0, Ut, r.bw, function(n) {
                            return A2(MK, n, h);
                        });
                    }();
                    return v(m(r, {
                        bj: cn
                    }), on, h);
                }
                return v(r, Pp, h);
            default:
                var fn;
                if (3 === (fn = n.a).$) {
                    var sn = fn.a, ln = $(n.b, sn.qd), dn = be(ln);
                    if (s(sn.Ee, dn) > 0 && i(be(sn.qd), 20)) return C = dn, on = (yn = FK(r.j)).$ ? Pp : A7(qK, r.j, yn.a, r.oz, C, Ut, r.bw, function(n) {
                        return A2(MK, n, ln);
                    }), v(r, on, h);
                    var bn = m(sn, {
                        qd: ln
                    }), vn = r.aN;
                    if (3 === vn.$) {
                        var mn = vn.a, pn = vV(A2(Eu, function(n) {
                            return n.rh;
                        }, bn.qd)), $n = $(bn.qd, A2(Rc, function(n) {
                            return !A2(Cq, n.rh, pn);
                        }, mn.qd)), hn = (a = A2(Zy, m(bn, {
                            qd: $n,
                            Ee: bn.Ee
                        }), da), vV(A2(Eu, function(n) {
                            return n.rh;
                        }, mn.qd))), gn = A2(Rc, function(n) {
                            return !A2(Cq, n.rh, hn);
                        }, bn.qd), wn = TE(gn) || vu(r.oz) ? h : x([
                            HK(r.oz)
                        ]), xn = (kn = FK(r.j)).$ ? b(r.I, h) : A7(_X, r.j, kn.a, r.oz, gn, r.I, r.aV, VJ);
                        return p = xn.b, v(m(r, {
                            I: xn.a,
                            bw: Vt(r.bj),
                            aN: a
                        }), Vu(A2(Yt, A2(Nu, function() {
                            return vK;
                        }, _u(0)), p)), wn);
                    }
                    return v(m(r, {
                        bw: Vt(r.bj)
                    }), A2(Nu, function() {
                        return vK;
                    }, _u(0)), h);
                }
                return v(r, Pp, h);
        }
        var kn, yn, _n, An, Cn, Bn, En, Dn;
    }), _0 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === (T = n.b).$) {
                    var e = T.a;
                    if (t) {
                        var u = r.Q;
                        if (3 === u.$) {
                            var a = be((Q = u.a).qd) + be(e.qd), c = m(Q, {
                                qd: $(Q.qd, e.qd)
                            }), o = A2(Zy, c, da), f = s(a, e.Ee) > -1;
                            return v(m(r, {
                                gD: f,
                                Q: o,
                                da: r.da + 10,
                                bt: !1
                            }), Pp, h);
                        }
                        return v(m(r, {
                            Q: T,
                            da: 10
                        }), jK({
                            oj: "conversation-list-container"
                        }), h);
                    }
                    var l = function(n) {
                        var r = A2(nv, function(n) {
                            return vu(n) ? Ut : Vt(n);
                        }, A2(Wu, WW, n.xs.iF));
                        if (1 === r.$) return v(n, Pp, h);
                        var t = r.a;
                        return !i(n.X, Ut) || i(n.a9, Vt(t)) ? v(n, Pp, h) : A2(zK, t, n);
                    }(m(r, {
                        Q: T,
                        da: 10,
                        bw: Vt(r.bj)
                    })), d = l.b, p = l.c;
                    return v(l.a, Vu(x([
                        jK({
                            oj: "conversation-list-container"
                        }),
                        d
                    ])), p);
                }
                return v(t ? m(r, {
                    bt: !1
                }) : r, Pp, A2(xA, 0, T));
            case 1:
                var g = A2(KW, Vt(S = n.a), r.xs.iF), w = A2(zK, S, r), k = w.c;
                return v(w.a, Vu(x([
                    w.b,
                    g
                ])), k);
            case 2:
                var y = n.a;
                if (3 === y.$) return g = A2(KW, Ut, r.xs.iF), v(m(r, {
                    X: Ut,
                    a9: Ut
                }), g, h);
                var _ = r.X;
                if (_.$) return v(r, Pp, h);
                var A = A2(y0, y, M = _.a), C = A.a, B = A.b, E = A2(rK, r, k = A.c), D = E.a, q = E.b, F = 1 === r.a9.$ ? !M.cz || C.cz || vu(C.oz) ? b(m(r, {
                    X: Vt(C)
                }), Pp) : b(m(r, {
                    X: Vt(C),
                    a9: Vt(C.oz)
                }), A2(KW, Vt(C.oz), r.xs.iF)) : b(m(r, {
                    X: Vt(C)
                }), Pp), P = F.b;
                return v(F.a, Vu(x([
                    A2(Lp, xJ, B),
                    D,
                    P
                ])), q);
            case 3:
                return "conversation-list-container" !== n.a.oj || .8 >= n.a.lR / (n.a.Dc - n.a.yX) || r.bt || r.gD ? v(r, Pp, h) : v(m(r, {
                    bt: !0
                }), A2(Nu, function() {
                    return GW;
                }, _u(0)), h);
            case 4:
                var z = 3 === (K = r.t6).$ ? Vt(EL(K.a)) : Ut, j = z.$ ? Pp : A4(hJ, r.j, z.a, function(n) {
                    return m(n, {
                        hY: Vt(10),
                        ic: r.da
                    });
                }, rJ(r.da));
                return v(r, j, h);
            case 5:
                var S = n.a;
                return j = (W = tJ(r.j)).$ ? Pp : A4(lK, r.j, W.a, S, JW(S)), v(r, j, h);
            case 6:
                if (3 === n.b.$) {
                    var L = function() {
                        var n = b(tJ(r.j), r.Q);
                        if (n.a.$ || 3 !== n.b.$) return Pp;
                        var t = n.a.a, e = be(n.b.a.qd);
                        return A4(hJ, r.j, t, function(n) {
                            return m(n, {
                                hY: Vt(e),
                                ic: 0
                            });
                        }, rJ(0));
                    }();
                    return v(r, L, h);
                }
                return v(r, Pp, h);
            case 7:
                var M, N = A8(oK, r.dB, r.kA, r.j, r.xs, r.fS, r.bj, r.t6, 1024 > r.d7 ? 0 : 1);
                return B = N.b, v(m(r, {
                    X: Vt(M = N.a),
                    a9: Ut
                }), A2(Lp, xJ, B), h);
            case 8:
                return v(m(r, {
                    d7: n.a
                }), Pp, h);
            case 9:
                var H = n.a;
                return 3 === r.Q.$ ? (j = function() {
                    var n = r.t6;
                    if (3 === n.$) {
                        var t = n.a, e = r.bw;
                        if (e.$) return A4(hJ, r.j, EL(t), function(n) {
                            return m(n, {
                                hY: Ut,
                                ic: 0,
                                lC: Ut
                            });
                        }, function(n) {
                            return A2(OW, n, h);
                        });
                        var u = e.a;
                        return A4(hJ, r.j, EL(t), function(n) {
                            return m(n, {
                                hY: Ut,
                                ic: 0,
                                lC: Vt(u)
                            });
                        }, function(n) {
                            return A2(OW, n, h);
                        });
                    }
                    return Pp;
                }(), v(m(r, {
                    bj: H
                }), j, h)) : v(r, Pp, h);
            default:
                var T;
                if (3 === (T = n.a).$) {
                    var I = T.a, R = $(n.b, I.qd), Z = be(R);
                    if (s(I.Ee, Z) > 0 && i(be(I.qd), 10)) {
                        var V = Z;
                        return j = function() {
                            var n = r.t6;
                            if (3 === n.$) {
                                var t = n.a, e = r.bw;
                                if (e.$) return A4(hJ, r.j, EL(t), function(n) {
                                    return m(n, {
                                        hY: Ut,
                                        ic: V,
                                        lC: Ut
                                    });
                                }, function(n) {
                                    return A2(OW, n, R);
                                });
                                var u = e.a;
                                return A4(hJ, r.j, EL(t), function(n) {
                                    return m(n, {
                                        hY: Ut,
                                        ic: V,
                                        lC: Vt(u)
                                    });
                                }, function(n) {
                                    return A2(OW, n, R);
                                });
                            }
                            return Pp;
                        }(), v(r, j, h);
                    }
                    var U = m(I, {
                        qd: R
                    }), Y = r.Q;
                    if (3 === Y.$) {
                        var Q, O = Y.a, G = vV(A2(Eu, XW, U.qd)), J = m(U, {
                            qd: $(U.qd, Q = A2(Rc, function(n) {
                                return !A2(Cq, XW(n), G);
                            }, O.qd))
                        });
                        return v(m(r, {
                            Q: A2(Zy, J, da),
                            bw: Vt(r.bj)
                        }), jK({
                            oj: "conversation-list-container"
                        }), h);
                    }
                    return v(m(r, {
                        Q: A2(Zy, U, da),
                        bw: Vt(r.bj)
                    }), jK({
                        oj: "conversation-list-container"
                    }), h);
                }
                return v(r, Pp, h);
        }
        var W, K;
    }), A0 = function(n) {
        return n.qd;
    }, C0 = F2(function() {
        return ld("");
    }), B0 = {
        $: 3
    }, E0 = {
        $: 20
    }, D0 = {
        $: 17
    }, q0 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, F0 = function(n) {
        return {
            $: 19,
            a: n
        };
    }, P0 = {
        $: 14
    }, z0 = F2(function(n, r) {
        return {
            zn: r.ay || r.bv || r.bs,
            T: r.T,
            Br: D0,
            BI: JJ,
            BK: q0,
            BZ: F0,
            B1: P0,
            CB: "",
            V: r.V
        };
    }), j0 = function(n) {
        var r = n.ha;
        return 3 === r.$ ? Vt(EL(r.a)) : FK(n.j);
    }, S0 = F2(function(n, r) {
        return {
            I: r.I,
            yW: r.g7,
            di: r.di,
            Bs: VJ,
            xl: n
        };
    }), L0 = function(n) {
        var r = n.c9;
        return 3 === r.$ ? r.a.t1 : h;
    }, M0 = F2(function(n, r) {
        return A2(HC, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), N0 = F2(function(n, r) {
        return A2(nu, function(t) {
            return "Enter" === t ? A2(tu, function(t) {
                return t ? {
                    sE: r,
                    uY: !1,
                    wP: !1
                } : {
                    sE: n,
                    uY: !0,
                    wP: !1
                };
            }, A2(Tu, "shiftKey", jk)) : Sk("not enter key");
        }, A2(Tu, "key", C$));
    }), H0 = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "19"),
            A2(zC, "height", "16"),
            A2(zC, "viewBox", "0 0 19 16"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "path", x([
                A2(zC, "d", "M0 16V0L19 8L0 16ZM2 13L13.85 8L2 3V6.5L8 8L2 9.5V13Z"),
                A2(zC, "fill", "currentColor")
            ]), h)
        ]));
    }, T0 = F3(function(n, r, t) {
        var e;
        return A2(nk, x([
            Xx("flex items-center justify-between bg-gray-100 rounded-lg p-2")
        ]), x([
            A2(nk, x([
                Xx("flex items-center space-x-2")
            ]), x([
                GB(x([
                    TB("w-4 h-4 text-gray-600")
                ])),
                A2(nk, h, x([
                    A2(nk, x([
                        Xx("text-sm font-medium text-gray-900")
                    ]), x([
                        ld(t.tg)
                    ])),
                    A2(nk, x([
                        Xx("text-xs text-gray-500")
                    ]), x([
                        ld((e = t.DG, 1024 > e ? oe(e) + " B" : 0 > s(e, 1048576) ? OZ(e / 1024) + " KB" : OZ(e / 1048576) + " MB"))
                    ]))
                ]))
            ])),
            A2(OC, x([
                zI,
                gC(x([
                    Xx("text-gray-400 hover:text-gray-600")
                ])),
                EC(n(r))
            ]), x([
                OB(x([
                    TB("w-4 h-4")
                ]))
            ]))
        ]));
    }), I0 = function(n) {
        var r, t = "" === XC(n.T), e = !TE(n.V), u = TE(n.V) ? ld("") : A2(nk, x([
            Xx("mb-2 px-2 space-y-2")
        ]), A2(he, T0(n.BZ), n.V)), a = !t || e, i = a ? "text-primary-300" : "text-primary-200";
        return A2(nk, x([
            Xx("bg-white px-4 py-3")
        ]), x([
            u,
            A2(nk, x([
                Xx("flex items-center space-x-2")
            ]), x([
                A2(OC, x([
                    zI,
                    gC(x([
                        Xx("text-primary-300 flex-shrink-0")
                    ])),
                    EC(n.Br)
                ]), x([
                    (r = x([
                        TB("w-4 h-4")
                    ]), A3(RB, "svg", $(x([
                        A2(zC, "width", "19"),
                        A2(zC, "height", "19"),
                        A2(zC, "viewBox", "0 0 19 19"),
                        A2(zC, "fill", "none"),
                        A2(zC, "xmlns", "http://www.w3.org/2000/svg")
                    ]), r), x([
                        A3(RB, "path", x([
                            A2(zC, "d", "M8.01995 18.0449V10.0249H0V8.01995H8.01995V0H10.0249V8.01995H18.0449V10.0249H10.0249V18.0449H8.01995Z"),
                            A2(zC, "fill", "#006CD1")
                        ]), h)
                    ])))
                ])),
                A2(vT, x([
                    Hq("chat-input-textarea"),
                    Xx("flex-1 rounded-lg py-2 px-4 text-md bg-chat-gray resize-none overflow-y-auto min-h-0"),
                    fT(n.CB),
                    Iq(n.T),
                    NC(n.zn),
                    lT(1),
                    oT(n.BK),
                    A2(M0, "keydown", A2(N0, n.B1, n.BI))
                ]), h),
                A2(OC, x([
                    uF(!a),
                    zI,
                    gC(x([
                        Xx(i + " flex-shrink-0")
                    ])),
                    EC(n.B1)
                ]), x([
                    H0(x([
                        TB("w-4 h-4")
                    ]))
                ]))
            ]))
        ]));
    }, R0 = SI(0), Z0 = xF(3), V0 = pH(4), U0 = function(n) {
        return n.kb.Dz;
    }, Y0 = function(n) {
        return n.kb.DB;
    }, Q0 = F2(function(n, r) {
        if (r.$) return n;
        var t = r.a;
        return A2(Rc, function(n) {
            return !i(n.Cr, Vt(t));
        }, n);
    }), O0 = eB(3), G0 = function(n) {
        var r = n.rE ? "w-full max-w-md" : "w-full max-w-md overflow-hidden", t = SC(x([
            b("text-primary-600", !0),
            b("leading-relaxed", !0),
            b("overflow-hidden", !n.rE && n.wi)
        ])), e = !n.rE && n.wi ? x([
            A2(bT, "display", "-webkit-box"),
            A2(bT, "-webkit-line-clamp", "2"),
            A2(bT, "-webkit-box-orient", "vertical"),
            A2(bT, "overflow", "hidden"),
            A2(bT, "word-break", "break-word"),
            A2(bT, "white-space", "normal")
        ]) : h, u = A2(Q0, n.t1, n.y7), a = A2(Eu, A2(ru, function(n) {
            return n.zp;
        }, sc("Unknown")), u), i = a.b ? a.b.b ? A2(fe, ", ", a) + " " : a.a : "", c = h;
        return A2(LB, x([
            rB(kF),
            rB(LI),
            ok(x([
                Xx("flex-1 flex-col px-4")
            ]))
        ]), x([
            A2(nk, A2(Yt, Xx(r), c), x([
                A2(LB, x([
                    aq,
                    O0,
                    V0,
                    rB(DB),
                    ok(A2(Yt, t, A2(Yt, Hq("participant-header-text"), e)))
                ]), x([
                    ld(i)
                ]))
            ])),
            n.wi && n.rF ? A2(LB, x([
                rB(DB),
                ok(x([
                    Xx("mt-1")
                ]))
            ]), x([
                A2(PC, x([
                    Xx("text-xs text-primary-400 bg-transparent"),
                    IC(n.B3)
                ]), x([
                    ld(n.xl(n.rE ? U0 : Y0))
                ]))
            ])) : ld("")
        ]));
    }, J0 = {
        $: 1
    }, W0 = function(n) {
        return "border border-primary-200 rounded px-2 py-2 cursor-pointer " + (TE(n.v8) ? "bg-white" : "bg-info-300");
    }, K0 = F3(function(n, r, t) {
        return TE(r) ? n(Kd) : A2(fe, ", ", A2(Eu, function(n) {
            return n.tg;
        }, A2(Rc, function(n) {
            return A2(SE, n.xw, r);
        }, t)));
    }), X0 = function(n) {
        return TE(n.v8) ? "text-primary-500" : "text-white";
    }, n2 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, r2 = F2(function(n, r) {
        var t = A2(SE, r.xw, n);
        return A2(nk, A2(Yt, Xx("flex space-x-2 p-2 hover:bg-gray-50 cursor-pointer rounded"), $($k(LI), x([
            IC(n2(r.xw))
        ]))), x([
            A2(Zq, x([
                Xx("rounded border border-gray-300"),
                Vq("checkbox"),
                jT(t)
            ]), h),
            A2(Ek, x([
                fq
            ]), x([
                ld(r.tg)
            ]))
        ]));
    }), t2 = F2(function(n, r) {
        return A2(LB, x([
            ok(x([
                Xx("absolute top-full left-0 right-0 bg-white border border-primary-200 rounded mt-1 shadow-lg z-10 max-h-60 overflow-y-auto")
            ]))
        ]), x([
            function() {
                var t = r.CE;
                switch(t.$){
                    case 1:
                        return ld("");
                    case 3:
                        var e = t.a;
                        return A2(LB, x([
                            ok(x([
                                Xx("p-2")
                            ]))
                        ]), A2(Eu, r2(r.v8), e));
                    case 2:
                        return A2(LB, x([
                            ok(x([
                                Xx("flex py-4")
                            ])),
                            ok($k(kF))
                        ]), x([
                            A2(Ek, x([
                                fq,
                                bO,
                                ok(x([
                                    Xx("text-danger-400")
                                ]))
                            ]), x([
                                ld(n(ub))
                            ]))
                        ]));
                    default:
                        return A2(LB, x([
                            ok(x([
                                Xx("flex py-4")
                            ])),
                            ok($k(kF))
                        ]), x([
                            A2(Ek, x([
                                fq,
                                ok(x([
                                    Xx("text-primary-300")
                                ]))
                            ]), x([
                                ld(n(Xd))
                            ]))
                        ]));
                }
            }()
        ]));
    }), e2 = F2(function(n, r) {
        var t, e;
        return A2(LB, x([
            ok(x([
                Xx("flex-1 relative dropdown" + (r.bD ? " dropdown--open" : ""))
            ]))
        ]), x([
            A2(nk, x([
                Xx(W0(r) + " dropdown-toggle"),
                IC(J0)
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("flex max-w-full space-x-1")
                    ])),
                    ok($k(LI)),
                    ok($k(Z0))
                ]), x([
                    A2(Ek, x([
                        fq,
                        ok(x([
                            Xx(X0(r) + " truncate w-0 flex-1")
                        ]))
                    ]), x([
                        ld(A3(K0, n, r.v8, (e = r.CE, 3 === e.$ ? e.a : h)))
                    ])),
                    A2(LB, x([
                        ok(x([
                            Xx(X0(r))
                        ]))
                    ]), x([
                        ld((t = r.bD, t ? "\u25B2" : "\u25BC"))
                    ]))
                ]))
            ])),
            r.bD ? A2(t2, n, r) : ld("")
        ]));
    }), u2 = F2(function(n, r) {
        return n.cz ? A2(LB, x([
            ok(x([
                Xx("bg-white border-b border-primary-200 px-4 py-3 flex relative")
            ])),
            ok($k(LI)),
            ok($k(Z0))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex-1 mr-2")
                ]))
            ]), x([
                A2(Ck, n.BY, A2(e2, n.xl, n.CO))
            ])),
            function() {
                var r = n.Bz;
                if (r.$) return A2(LB, x([
                    V0,
                    ok(x([
                        Xx("cursor-pointer")
                    ]))
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 2)
                ]));
                var t = r.a;
                return A2(nk, x([
                    Xx("text-primary-300 cursor-pointer"),
                    IC(t)
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 2)
                ]));
            }()
        ])) : A2(LB, x([
            ok(x([
                Xx("bg-white border-b border-primary-200 py-3 flex min-h-[60px] flex-shrink-0")
            ])),
            ok($k(R0)),
            ok($k(Z0))
        ]), x([
            G0({
                y7: n.y7,
                rE: n.bu,
                rF: n.cA,
                B3: n.B4,
                t1: n.t1,
                wi: n.cR,
                xl: n.xl
            }),
            function() {
                var t = b(n.Bz, r);
                if (t.a.$) return A2(LB, x(t.b ? [
                    V0,
                    ok(x([
                        Xx("cursor-pointer")
                    ]))
                ] : [
                    V0,
                    kC,
                    ok(x([
                        Xx("cursor-pointer px-4")
                    ]))
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 2)
                ]));
                if (t.b) {
                    var e = t.a.a;
                    return A2(nk, x([
                        Xx("text-primary-300 text-xl cursor-pointer px-4"),
                        IC(e)
                    ]), x([
                        A2(PE, x([
                            iH
                        ]), 2)
                    ]));
                }
                return e = t.a.a, A2(nk, x([
                    Xx("text-primary-300 cursor-pointer"),
                    IC(e)
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 2)
                ]));
            }()
        ]));
    }), a2 = F2(function(n, r) {
        return A2(Ju, n, r);
    }), i2 = F3(function(n, r, t) {
        return A2(A2(Dp, n, r), 3, t);
    }), c2 = F3(function(n, r, t) {
        var e = A2(Yc, function(n) {
            return n.Dn;
        }, t);
        return Ae(A3(de, F2(function(t, e) {
            if (e.b) {
                var u = 1 !== A2(a2, A2(bp, n, e.a.sE.Dn), A2(bp, n, t.Dn));
                return A2(Yt, {
                    sE: t,
                    Dp: u ? A3(i2, n, r, t.Dn) : "",
                    Dx: u
                }, e);
            }
            return x([
                {
                    sE: t,
                    Dp: A3(i2, n, r, t.Dn),
                    Dx: !0
                }
            ]);
        }), h, e));
    }), o2 = F2(function(n, r) {
        var t = A2(Yc, function(n) {
            return n.Dn;
        }, r);
        return function(r) {
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b, u = A3(de, F2(function(r, t) {
                        var e = t.a, u = t.b, a = i(e.sE.yt.rh, r.sE.yt.rh), c = A2(bp, n, e.sE.Dn), o = i(r.sE.Co, Ut) && i(e.sE.Co, Ut) && a && 1 === A2(a2, c, A2(bp, n, r.sE.Dn)) ? e : m(e, {
                            Dw: !0
                        });
                        return b(r, A2(Yt, o, u));
                    }), b(t, h), e), a = u.b, c = m(u.a, {
                        Dw: !0
                    });
                    return Ae(A2(Yt, c, a));
                }
                return x([
                    m(r.a, {
                        Dw: !0
                    })
                ]);
            }
            return h;
        }(Ae(A3(de, F2(function(r, t) {
            if (t.b) {
                var e = t.a, u = t.b, a = i(e.sE.yt.rh, r.yt.rh), c = A2(bp, n, e.sE.Dn), o = !i(r.Co, Ut) || !i(e.sE.Co, Ut);
                return A2(Yt, {
                    yv: r.yt.zp,
                    sE: r,
                    Dv: o || !a || !(1 === A2(a2, c, A2(bp, n, r.Dn))),
                    Dw: !1
                }, A2(Yt, e, u));
            }
            return x([
                {
                    yv: r.yt.zp,
                    sE: r,
                    Dv: !0,
                    Dw: !1
                }
            ]);
        }), h, t)));
    }), f2 = F2(function(n, r) {
        if (n.$) return !1;
        var t = r.yt.Cr;
        return !t.$ && i(t.a, n.a);
    }), s2 = F2(function(n, r) {
        return r.s0(n);
    }), l2 = F2(function(n, r) {
        return r.s1(n);
    }), d2 = pH(6), b2 = function(n) {
        return A2(nk, A2(Yt, Xx("flex py-4"), $($k(LI), $k(kF))), x([
            A2(LB, x([
                fq,
                d2
            ]), x([
                ld(n)
            ]))
        ]));
    }, v2 = F2(function(n, r) {
        var t = r.Cn.zp;
        if (1 === t.$) return h;
        var e = t.a, u = n(r.x7 ? l2(e) : s2(e));
        return x([
            b2(u)
        ]);
    }), m2 = xF(2), p2 = xF(0), $2 = F2(function(n, r) {
        var t = r ? b(m2, "") : b(p2, "ml-12"), e = t.a;
        return A2(nk, A2(Yt, Xx("flex my-1 " + t.b), $k(e)), x([
            A2(LB, x([
                EZ,
                d2
            ]), x([
                ld(n)
            ]))
        ]));
    }), h2 = function(n) {
        return n ? "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-none rounded-bl-[0.7em]" : "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-[0.7em] rounded-bl-none";
    }, g2 = F3(function(n, r, t) {
        return A2(A2(Dp, n, r), 4, t);
    }), w2 = {
        $: 2
    }, x2 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, k2 = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return A2(IN, x(n ? [
                LN(t.Aj),
                MN
            ] : [
                LN(t.Aj),
                MN,
                w2,
                x2("hover:text-white focus:text-white")
            ]), x([
                ld(t.pj)
            ]));
        }
        return A2(ak, h, x([
            ld(r.a)
        ]));
    }), y2 = st(dt), _2 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, C2 = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = function(n) {
                return {
                    $: 1,
                    a: n
                };
            }({
                pj: e.kP,
                Aj: (f = e.kP, A2(xu, "http://", f) || A2(xu, "https://", f) ? f : "https://" + f)
            }), i = A3(lu, t, e.kE, n), c = vu(i) ? x([
                a
            ]) : x([
                _2(i),
                a
            ]), o = e.kE + su(e.kP);
            return $(c, A3(C2, n, u, o));
        }
        var f, s = A2(du, t, n);
        return vu(s) ? h : x([
            _2(s)
        ]);
    }), B2 = A2(sc, Kb, Wb("(?:https?://)?(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&/=]*)|https?://[^\\s]+")), E2 = F2(function(n, r) {
        var t, e = A3(C2, t = r, A2(y2, B2, t), 0);
        return A2(Eu, k2(n), e);
    }), D2 = F2(function(n, r) {
        return 1 === r.$ ? "" : "overflow-hidden " + h2(n);
    }), q2 = {
        $: 0,
        a: 2
    }, P2 = {
        j8: h,
        ix: 0
    }, z2 = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return m(r, {
                j8: $(r.j8, A2(Eu, ek(yu), t))
            });
        }
        return m(r, {
            ix: n.a
        });
    }), j2 = F2(function(n, r) {
        var t = A3(de, z2, P2, n), e = function() {
            switch(t.ix){
                case 0:
                case 1:
                    return "bg-gray-100";
                default:
                    return "bg-red-50";
            }
        }();
        return A2(nk, A2(Yt, Xx("flex items-center space-x-2 p-2 rounded-lg " + e), t.j8), r);
    }), S2 = {
        $: 9
    }, L2 = {
        $: 6
    }, M2 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, N2 = {
        $: 3
    }, H2 = {
        $: 2
    }, T2 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, I2 = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), R2 = {
        $: 0
    }, Z2 = {
        $: 7
    }, V2 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), U2 = {
        $: 10
    }, Y2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Q2 = {
        $: 1
    }, O2 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, G2 = {
        $: 1
    }, J2 = {
        $: 2
    }, W2 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), K2 = {
        $: 0
    }, X2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, n3 = dX, r3 = F2(function(n, r) {
        var t = n.f.aK;
        return t.$ ? $1(n.c) ? "" : r : t.a;
    }), t3 = F4(function(n, r, t, e) {
        if (n > 0 && r > 0 && t > 0) {
            var u = function(n) {
                return s(n, 1024) > -1 ? 400 : 320;
            }(e), a = r / n * t;
            return s(a, u) > 0 || 0 > s(a, 120);
        }
        return !1;
    }), e3 = F4(function(n, r, t, e) {
        var u = v(n, r, t);
        return !!(u.a.$ || u.b.$ || u.c.$) || A4(t3, u.a.a, u.b.a, u.c.a, e);
    }), u3 = F2(function(n, r) {
        return A4(e3, r.f.F, r.f.K, r.b5.ce, n);
    }), a3 = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Ut : Vt(A2(n, r.a, t.a));
    }), i3 = F4(function(n, r, t, e) {
        var u = v(n, r, t);
        if (u.a.$ || u.b.$ || u.c.$) return !1;
        var a = u.a.a, i = u.b.a, c = u.c.a;
        return a > 0 && i > 0 && c > 0 && A4(t3, a, i, c, e);
    }), c3 = F2(function(n, r) {
        return $1(n.c) ? A2(r3, n, r) : A2(sc, r, n.n);
    }), o3 = F2(function(n, r) {
        return A4(e3, r.y.F, r.y.K, r.b5.ce, n);
    }), f3 = SI(2), s3 = F2(function(n, r) {
        return r.sH(n);
    }), l3 = iq(0), d3 = iq(2), b3 = cr("audio"), v3 = function(n) {
        if (WZ(n) || 0 >= n) return "0:00";
        var r = Re(n), t = A2(jc, 60, r);
        return oe(r / 60 | 0) + ":" + A3(Yb, 2, "0", oe(t));
    }, m3 = function(n) {
        return n.sF;
    }, p3 = function(n) {
        return n.sG;
    }, $3 = ok(x([
        Xx("text-white")
    ])), h3 = rk(0), g3 = function(n) {
        var r, t = n.BB ? "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-white/25 pointer-events-none" : "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-divider pointer-events-none", e = x(n.BB ? [
            EZ,
            ok(x([
                Xx("shrink-0 tabular-nums text-white/70")
            ]))
        ] : [
            EZ,
            d2,
            ok(x([
                Xx("shrink-0 tabular-nums")
            ]))
        ]), u = n.pI > 0 && !WZ(n.bj) ? A3(sp, 0, 100, n.bj / A2(Ve, n.pI, 1) * 100) : 0, a = n.pI > 0, i = A3(eu, F2(function(r, t) {
            return n.B$(r / A2(Ve, t, 1));
        }), A2(Tu, "offsetX", q$), A2(By, x([
            "currentTarget",
            "clientWidth"
        ]), q$)), c = n.xl(n.bX ? m3 : p3), o = n.BB ? "relative flex w-full flex-col gap-3 bg-white/10 py-2 px-1" : "relative flex w-full flex-col gap-3 bg-white py-2", f = x(n.BB ? [
            fq,
            nH,
            $3,
            ok(x([
                Xx("truncate")
            ]))
        ] : [
            fq,
            nH,
            ok(x([
                Xx("truncate text-primary-600")
            ]))
        ]), s = x(n.BB ? [
            EZ,
            ok(x([
                Xx("text-white/70")
            ]))
        ] : [
            EZ,
            ok(x([
                Xx("text-gray-500")
            ]))
        ]), l = A2(nu, function(r) {
            switch(r){
                case "ArrowLeft":
                    return uu(n.B_(-0.05));
                case "ArrowRight":
                    return uu(n.B_(.05));
                case "Home":
                    return uu(n.B$(0));
                case "End":
                    return uu(n.B$(1));
                case " ":
                case "Enter":
                    return uu(n.B$(n.bj / A2(Ve, n.pI, 1)));
                default:
                    return Sk("ignore");
            }
        }, A2(Tu, "key", C$)), d = n.yr && !a, v = (r = "h-full min-h-0 rounded-full transition-all duration-100 pointer-events-none", n.BB ? r + " bg-white" : r + " bg-primary"), m = d;
        return A2(LB, x([
            ok(x([
                Xx(o),
                A2(jC, "aria-busy", m ? "true" : "false")
            ]))
        ]), x([
            A2(LB, x([
                ok(A2(Yt, Xx("flex gap-3 px-1"), $k(LI)))
            ]), x([
                A2(LB, x([
                    ok(A2(Yt, Xx("relative flex h-10 w-10 shrink-0"), $($k(LI), $k(kF))))
                ]), x([
                    A2(OC, x([
                        qC,
                        cF,
                        EC(n.tL),
                        uF(d),
                        gC(A2(Yt, Vq("button"), A2(Yt, A2(jC, "aria-label", c), A2(Yt, Xx("h-10 w-10 min-h-0 min-w-0 shrink-0 !p-0"), $($k(LI), $k(kF))))))
                    ]), x([
                        d ? ld("") : A2(PE, x([
                            HB,
                            jI,
                            MB("fill-white size-4")
                        ]), n.bX ? 36 : 35)
                    ])),
                    d ? A2(ak, A2(Yt, Xx("pointer-events-none absolute inset-0 flex [&_.spinner__dot]:bg-white"), A2(Yt, A2(jC, "aria-hidden", "true"), $($k(LI), $k(kF)))), x([
                        ik(x([
                            h3
                        ]))
                    ])) : ld("")
                ])),
                A2(LB, x([
                    ok(x([
                        Xx("flex min-w-0 flex-1 flex-col")
                    ]))
                ]), x([
                    A2(FI, f, x([
                        ld(n.kz)
                    ])),
                    A2(FI, s, x([
                        ld(v3(n.pI))
                    ]))
                ]))
            ])),
            A2(LB, x([
                ok(A2(Yt, Xx("flex w-full gap-2 px-1"), $k(LI)))
            ]), x([
                A2(FI, e, x([
                    ld(v3(n.bj))
                ])),
                A2(nk, x([
                    Xx("min-w-0 flex-1 rounded-sm py-1 outline-none"),
                    SC(x([
                        b("cursor-pointer focus-visible:ring-2 focus-visible:ring-primary-200 focus-visible:ring-offset-2", a),
                        b("pointer-events-none opacity-50", !a)
                    ])),
                    pj(a ? 0 : -1),
                    A2(jC, "role", "slider"),
                    A2(jC, "aria-valuemin", "0"),
                    A2(jC, "aria-valuemax", "100"),
                    A2(jC, "aria-valuenow", oe(kp(u))),
                    A2(TC, "click", i),
                    A2(TC, "keydown", l)
                ]), x([
                    A2(LB, x([
                        ok(x([
                            Xx(t)
                        ]))
                    ]), x([
                        A2(LB, x([
                            ok(x([
                                Xx(v),
                                A2(bT, "width", OZ(u) + "%")
                            ]))
                        ]), h)
                    ]))
                ])),
                A2(FI, e, x([
                    ld(v3(n.pI))
                ]))
            ])),
            n.yr ? A2(b3, x([
                Hq(n.yq),
                zG(n.cU),
                A2(jC, "preload", "none"),
                Xx("pointer-events-none absolute left-0 top-0 h-px w-px overflow-hidden border-0 p-0 opacity-0"),
                A2(TC, "play", uu(n.BX)),
                A2(TC, "pause", uu(n.BU)),
                A2(TC, "ended", uu(n.BH)),
                A2(TC, "error", uu(n.tI)),
                A2(TC, "timeupdate", A3(eu, n.B2, A2(By, x([
                    "target",
                    "currentTime"
                ]), q$), A2(By, x([
                    "target",
                    "duration"
                ]), q$))),
                A2(TC, "loadedmetadata", A2(tu, n.BP, A2(By, x([
                    "target",
                    "duration"
                ]), q$)))
            ]), h) : ld("")
        ]));
    }, w3 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, x3 = Kx("alt"), k3 = cr("img"), y3 = function(n) {
        return n.sI;
    }, _3 = function(n) {
        var r, t = (r = n.A0).$ ? h : x([
            A2(jC, "aria-label", r.a)
        ]), e = n.Ch ? "pointer-events-none absolute inset-0 z-[5] min-h-0 min-w-full animate-opacity-pulse bg-black/30" : "block w-full min-w-full max-w-full animate-opacity-pulse bg-chat-gray", u = A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
            e,
            n.zV
        ])));
        return A2(LB, x([
            ok(A2(Yt, A2(jC, "role", "status"), A2(Yt, Xx(u), A2(Yt, A2(jC, "aria-busy", n.yp ? "true" : "false"), t))))
        ]), h);
    }, C3 = function(n) {
        var r = 1 !== n.CF.$ && n.DC, t = 1 !== n.CF.$ && n.Dy, e = A3(eu, n.tJ, A2(By, x([
            "target",
            "naturalWidth"
        ]), q$), A2(By, x([
            "target",
            "naturalHeight"
        ]), q$)), u = function() {
            var r = n.CF;
            if (1 === r.$) return b("object-contain", "");
            var t = r.a.tB;
            return b(t ? "object-cover" : "object-contain", t ? "" : r.a.AE ? "object-right" : "object-left");
        }(), a = u.a, i = u.b;
        return A2(LB, x([
            ok(x([
                Xx("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden")
            ]))
        ]), x([
            n.bq ? _3({
                yp: !0,
                zV: "",
                A0: Ut,
                Ch: !0
            }) : A2(k3, x([
                zG(n.zq),
                x3(n.kz),
                Xx(A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
                    "h-full w-full min-h-0 min-w-0",
                    a,
                    i
                ])))),
                A2(TC, "error", uu(n.BJ)),
                A2(TC, "load", e)
            ]), h),
            t && !n.bq ? _3({
                yp: !0,
                zV: "",
                A0: Ut,
                Ch: !0
            }) : ld(""),
            !r || n.bq || t ? ld("") : A2(LB, x([
                ok(x([
                    Xx("pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent")
                ]))
            ]), h),
            !r || n.bq || t ? ld("") : A2(LB, x([
                ok(A2(Yt, Xx("pointer-events-none absolute inset-x-0 bottom-2 flex"), $k(kF)))
            ]), x([
                A2(LB, x([
                    EZ,
                    nH,
                    ok(x([
                        Xx("rounded-full bg-black/40 px-3 py-1 text-white backdrop-blur-sm")
                    ]))
                ]), x([
                    ld(n.xl(y3))
                ]))
            ]))
        ]));
    }, B3 = cr("video"), E3 = function(n) {
        var r = n.Es ? "h-full min-h-0 w-full object-cover" : "max-h-full min-h-0 w-full object-contain", t = n.AI ? ld("") : A2(PC, rc(x([
            x([
                Vq("button"),
                Xx("absolute inset-0 z-10 flex cursor-pointer border-none bg-black/30 p-0"),
                IC(n.tL)
            ]),
            $k(LI),
            $k(kF)
        ])), x([
            A2(LB, x([
                ok(A2(Yt, Xx("pointer-events-none flex h-12 w-12 shrink-0 rounded-full bg-white p-0 shadow-md ring-1 ring-white"), $($k(LI), $k(kF))))
            ]), x([
                A2(PE, x([
                    iH,
                    MB("ml-0.5 fill-gray-800")
                ]), 35)
            ]))
        ])), e = A3(eu, n.B9, A2(By, x([
            "target",
            "videoWidth"
        ]), q$), A2(By, x([
            "target",
            "videoHeight"
        ]), q$)), u = n.AI ? h : x([
            A2(jC, "muted", "")
        ]), a = n.AI ? x([
            A2(jC, "controls", "")
        ]) : h;
        return A2(LB, x([
            ok(x([
                Xx("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden"),
                SC(x([
                    b("cursor-pointer", !n.AI)
                ]))
            ]))
        ]), x([
            A2(B3, rc(x([
                x([
                    Hq(n.Er),
                    zG(n.cU),
                    Xx("block min-h-0 w-full flex-1 " + r),
                    A2(jC, "playsinline", ""),
                    A2(jC, "preload", "metadata"),
                    A2(TC, "loadedmetadata", e),
                    A2(TC, "loadeddata", uu(n.BO)),
                    A2(TC, "error", uu(n.B8))
                ]),
                u,
                a
            ])), h),
            n.DD ? _3({
                yp: !0,
                zV: "",
                A0: Ut,
                Ch: !0
            }) : ld(""),
            t
        ]));
    }, D3 = function(n) {
        var r = n.Dr, t = $($k(LI), $k(oB)), e = r.AE ? "flex w-full cursor-pointer gap-3 border border-gray-200 bg-white px-3 py-2" : "flex w-full cursor-pointer gap-3 border border-white/30 bg-white/10 px-3 py-2 text-white", u = n3(r.z0), a = $($k(r.AE ? f3 : R0), $k(oB)), i = r.yx, c = r.ak && kX(i) ? 4 : i, o = 3 === c || 4 === c, f = !c || 1 === c, s = function() {
            switch(c){
                case 0:
                    return function(n) {
                        var r = function() {
                            var r = n.pk;
                            if (r.$) return h;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? x([
                                A2(bT, "aspect-ratio", OZ(e) + " / " + OZ(u))
                            ]) : h;
                        }();
                        return A2(LB, x([
                            ok(rc(x([
                                x([
                                    Hq(n.uZ),
                                    Xx("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-chat-gray min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                r
                            ])))
                        ]), x([
                            A2(LB, x([
                                ok(x([
                                    Xx("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), x([
                                C3({
                                    zq: n.zq,
                                    kz: n.kz,
                                    bq: n.bq,
                                    BJ: n.BJ,
                                    tJ: n.tJ,
                                    CF: w3({
                                        AE: n.AE,
                                        tB: n.tB
                                    }),
                                    Dy: n.Dy,
                                    DC: n.DC,
                                    xl: n.xl
                                })
                            ]))
                        ]));
                    }({
                        pk: n.f.pk,
                        zq: n.f.zq,
                        kz: u,
                        bq: n.f.bq,
                        AE: r.AE,
                        tB: n.f.tB,
                        BJ: r.BQ,
                        tJ: n.f.BS,
                        uZ: r.A2,
                        Dy: n.f.wk,
                        DC: n.f.DC,
                        xl: r.xl
                    });
                case 1:
                    return function(n) {
                        var r = function() {
                            var r = n.pk;
                            if (r.$) return h;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? x([
                                A2(bT, "aspect-ratio", OZ(e) + " / " + OZ(u))
                            ]) : h;
                        }();
                        return A2(LB, x([
                            ok(rc(x([
                                x([
                                    Hq(n.uZ),
                                    Xx("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-gray-100 min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                r
                            ])))
                        ]), x([
                            A2(LB, x([
                                ok(x([
                                    Xx("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), x([
                                E3({
                                    AI: n.AI,
                                    BO: n.BO,
                                    tL: n.tL,
                                    B8: n.B8,
                                    B9: n.B9,
                                    DD: n.DD,
                                    cU: n.cU,
                                    Er: n.Er,
                                    Es: n.Es
                                })
                            ]))
                        ]));
                    }({
                        pk: n.y.pk,
                        AI: n.y.b2,
                        BO: n.y.BO,
                        tL: n.y.tL,
                        B8: n.y.tI,
                        B9: n.y.tJ,
                        uZ: r.A2,
                        DD: n.y.wk,
                        cU: r.cU,
                        Er: n.y.CG,
                        Es: n.y.tB
                    });
                case 2:
                    return function(n) {
                        var r = $k(n.AE ? d3 : l3);
                        return A2(LB, x([
                            ok(A2(Yt, Xx("flex w-full min-w-0 max-w-full flex-col"), r))
                        ]), x([
                            g3({
                                yq: n.yq,
                                yr: n.yr,
                                bj: n.bj,
                                pI: n.pI,
                                kz: n.kz,
                                bX: n.bX,
                                BB: n.BB,
                                tI: n.tI,
                                BH: n.BH,
                                BP: n.BP,
                                BU: n.BU,
                                BX: n.BX,
                                B_: n.B_,
                                B$: n.B$,
                                B2: n.B2,
                                tL: n.tL,
                                cU: n.cU,
                                xl: n.xl
                            })
                        ]));
                    }({
                        yq: n.l.bT,
                        yr: n.l.cE,
                        bj: n.l.bj,
                        pI: n.l.pI,
                        kz: u,
                        AE: r.AE,
                        bX: n.l.bX,
                        BB: !1,
                        tI: n.l.tI,
                        BH: n.l.BH,
                        BP: n.l.BP,
                        BU: n.l.BU,
                        BX: n.l.BX,
                        B_: n.l.B_,
                        B$: n.l.B$,
                        B2: n.l.B2,
                        tL: n.l.tL,
                        cU: r.cU,
                        xl: r.xl
                    });
                default:
                    return function(n) {
                        return A2(LB, x([
                            ok(A2(Yt, Xx("flex w-full min-w-0 gap-3 text-primary-600"), $k(LI)))
                        ]), x([
                            A2(LB, x([
                                ok(A2(Yt, Xx("flex h-12 w-12 shrink-0 rounded-lg bg-primary-100"), $($k(LI), $k(kF))))
                            ]), x([
                                A2(PE, x([
                                    iH,
                                    jI,
                                    MB("fill-primary-300")
                                ]), 20)
                            ])),
                            A2(LB, x([
                                ok(A2(Yt, Xx("flex min-w-0 flex-1 flex-col"), $($k(R0), $k(kF))))
                            ]), x([
                                A2(FI, x([
                                    fq,
                                    nH,
                                    ok(x([
                                        Xx("w-full truncate text-primary-600")
                                    ])),
                                    ok($k(oB))
                                ]), x([
                                    ld(n.kz)
                                ]))
                            ]))
                        ]));
                    }({
                        kz: u
                    });
            }
        }(), l = f || 2 === c ? a : t, d = f ? "relative flex w-full min-w-[240px] max-w-full flex-col cursor-pointer overflow-hidden border-none bg-transparent p-0" : 2 === c ? "flex w-full min-w-[240px] max-w-full flex-col cursor-pointer bg-white px-3 py-2" : o ? "flex w-full min-w-[240px] max-w-full cursor-pointer gap-3 bg-white px-3 py-3 text-primary-600" : e, b = A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
            d,
            r.ED
        ]))), v = r.xl(s3(u));
        return 1 === c || 2 === c ? A2(LB, x([
            ok(A2(Yt, Xx(b), l))
        ]), x([
            s
        ])) : A2(PC, A2(Yt, Vq("button"), A2(Yt, Xx(b), A2(Yt, IC(r.BT(r.di)), A2(Yt, A2(jC, "aria-label", v), l)))), x([
            s
        ]));
    }, q3 = {
        $: 4
    }, P3 = function(n) {
        return n.nh;
    }, z3 = function(n) {
        return n.px;
    }, j3 = function(n) {
        return n.sJ;
    }, S3 = function(n) {
        return n.sU;
    }, L3 = pH(7), M3 = F3(function(n, r, t) {
        var e;
        return t.bG ? tB : A5(UI, t, r, PI(r), (e = XC(n), vu(e) ? Ut : Vt(e)), !0);
    }), N3 = F3(function(n, r, t) {
        return t.bG ? tB : A3(HI, Vt(n), t, r);
    }), H3 = {
        $: 1
    }, T3 = function(n) {
        return n.sK;
    }, I3 = F2(function(n, r) {
        return r.sL(n);
    }), R3 = function(n) {
        return n.sS;
    }, Z3 = F2(function(n, r) {
        return b(n, r);
    }), V3 = F2(function(n, r) {
        return b(n, r);
    }), U3 = F2(function(n, r) {
        return r.sR(n);
    }), Y3 = function(n) {
        return n.sT;
    }, Q3 = F3(function(n, r, t) {
        var e, u, a = (u = (e = A2(Eu, be, t)).b ? Vt(A3(de, Ve, e.a, e.b)) : Ut).$ ? 0 : u.a, i = A2(Ve, A2(Ve, be(r), a), 0);
        if (i) {
            var c = function(n) {
                var r = A2(wj, i, n);
                return $(r, A2(mj, i - be(r), ""));
            }, o = A2(wj, i, $(r, A2(mj, i, "")));
            return {
                hC: A2(he, F2(function(r, t) {
                    var e = XC(t);
                    return vu(e) ? n(r + 1) : e;
                }), o),
                iL: A2(Eu, c, t)
            };
        }
        return {
            hC: h,
            iL: h
        };
    }), O3 = F2(function(n, r) {
        return b(n, r);
    }), G3 = cr("caption"), J3 = cr("table"), W3 = cr("tbody"), K3 = cr("thead"), X3 = cr("tr"), n9 = function(n) {
        return n.$ ? $k(n.a) : n.a;
    }, r9 = function(n) {
        return A2(Eu, ek(yu), A2(tc, n9, n));
    }, t9 = cr("th"), e9 = function(n) {
        var r = n.a, t = n.b;
        return A2(t9, A2(Yt, Xx("c-table__header"), r9(r)), x([
            ld(t)
        ]));
    }, u9 = cr("td"), a9 = function(n) {
        var r = n.a, t = n.b;
        return A2(u9, A2(Yt, Xx("c-table__cell"), r9(r)), t);
    }, i9 = function(n) {
        var r = n.a, t = n.b;
        return A2(X3, A2(Yt, Xx("c-table__row"), r9(r)), A2(Eu, a9, t));
    }, c9 = F3(function(n, r, t) {
        return A2(J3, x([
            Xx("c-table")
        ]), $(function() {
            if (n.$) return h;
            var r = n.a;
            return x([
                A2(G3, x([
                    Xx("sr-only")
                ]), x([
                    ld(r)
                ]))
            ]);
        }(), x([
            A2(K3, h, x([
                A2(X3, h, A2(Eu, e9, r))
            ])),
            A2(W3, h, A2(Eu, i9, t))
        ])));
    }), o9 = F3(function(n, r, t) {
        var e = A3(Q3, function(r) {
            return n(U3(oe(r)));
        }, t.hC, t.iL), u = A2(LB, x([
            ok(x([
                Xx("flex min-h-0 min-w-0 flex-1 items-center justify-center px-3 py-4 text-xs text-primary-500 sm:px-4 sm:py-8 sm:text-sm")
            ]))
        ]), x([
            ld(n(Y3))
        ]));
        return TE(e.hC) && TE(e.iL) ? u : A2(LB, x([
            ok(A2(Yt, Xx("flex min-h-0 min-w-0 flex-1 flex-col bg-white"), $k(oB)))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("relative max-h-full min-h-0 min-w-0 flex-1 overflow-auto")
                ]))
            ]), x([
                A3(c9, r, A2(Eu, function(n) {
                    return A2(V3, h, n);
                }, e.hC), A2(Eu, function(n) {
                    return A2(O3, h, A2(Eu, function(n) {
                        return A2(Z3, h, x([
                            ld(n)
                        ]));
                    }, n));
                }, e.iL))
            ]))
        ]));
    }), f9 = F3(function(n, r, t) {
        return n ? x([
            A2(jC, "aria-busy", "true"),
            A2(jC, "aria-label", r(t))
        ]) : h;
    }), s9 = function(n) {
        return A2(LB, x([
            ok(A2(Yt, Xx(n.Cg), A3(f9, n.DA, n.xl, n.AS)))
        ]), x([
            n.ok,
            n.DA ? _3({
                yp: !0,
                zV: "",
                A0: Vt(n.xl(n.AT)),
                Ch: !0
            }) : ld("")
        ]));
    }, l9 = function(n) {
        return n.sM;
    }, d9 = function(n) {
        return n.sN;
    }, b9 = F2(function(n, r) {
        return r.sO(n);
    }), v9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, m9 = function(n) {
        return n.sP;
    }, p9 = function(n) {
        return n.sQ;
    }, $9 = function(n) {
        switch(n.$){
            case 0:
                return x([
                    A2(jC, "scale", OZ(n.a))
                ]);
            case 1:
                return x([
                    A2(jC, "width", oe(n.a))
                ]);
            case 2:
                return x([
                    A2(jC, "height", oe(r = n.a))
                ]);
            default:
                var r = n.b;
                return x([
                    A2(jC, "width", oe(n.a)),
                    A2(jC, "height", oe(r))
                ]);
        }
    }, h9 = function(n) {
        switch(n.$){
            case 0:
                return "Scale" + OZ(n.a);
            case 1:
                return "Width" + oe(n.a);
            case 2:
                return "Height" + oe(r = n.a);
            default:
                var r = n.b;
                return "WidthHeight" + oe(n.a) + "," + oe(r);
        }
    }, g9 = F3(function(n, r, t) {
        return A3(Kq, "span", h, x([
            b($(n, $(oe(r), h9(t))), A3(yG, "pdf-element", $(x([
                A2(jC, "name", n),
                A2(jC, "page", oe(r))
            ]), $9(t)), h))
        ]));
    }), w9 = function(n) {
        return A2(Ek, x([
            fq,
            L3,
            ok(x([
                Xx("leading-5")
            ]))
        ]), x([
            ld(n.xl(S3))
        ]));
    }, x9 = function(n) {
        return n.sV;
    }, k9 = function(n) {
        return n.sW;
    }, y9 = F3(function(n, r, t) {
        return A2(t.sX, n, r);
    }), _9 = F2(function(n, r) {
        return r.sY(n);
    }), C9 = F2(function(n, r) {
        return 1 > n ? 0 : A2(Kv, A2(Ve, 0, r), n - 1);
    }), B9 = function(n) {
        return n.sZ;
    }, E9 = function(n) {
        return n.s_;
    }, D9 = F2(function(n, r) {
        return r.s$(n);
    }), q9 = function(n) {
        var r = A2(LB, x([
            ok(x([
                Xx("flex min-h-0 min-w-0 max-w-full flex-1 flex-col")
            ]))
        ]), x([
            w9({
                xl: n.xl
            })
        ]));
        switch(UQ(n.zs.zT)){
            case "docx":
                return function(n) {
                    if (3 === n.ok.$) return ld("");
                    var r, t = function(n) {
                        switch(n.$){
                            case 2:
                                return vu(n.a);
                            case 1:
                            case 0:
                                return !0;
                            default:
                                return !1;
                        }
                    }(n.ok), e = 2 === (r = n.ok).$ ? vu(r.a) ? ld("") : A2(LB, x([
                        ok(x([
                            Hq(n.dv),
                            Xx("document-container"),
                            A2(jC, "aria-label", n.xl(b9(n.kz)))
                        ]))
                    ]), h) : ld("");
                    return s9({
                        ok: A2(LB, x([
                            ok(A2(Yt, Xx("min-h-0 flex-1"), $k(oB)))
                        ]), x([
                            e
                        ])),
                        AS: l9,
                        AT: d9,
                        Cg: "pg-viewer-wrapper relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col overflow-y-auto overflow-x-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                        DA: t,
                        xl: n.xl
                    });
                }({
                    ok: n.zs.eE,
                    kz: n.kz,
                    dv: n.zs.dv,
                    xl: n.xl
                });
            case "pdf":
                var t = n.zs.fg;
                return t.$ ? r : function(n) {
                    if (n.Cx.$) {
                        var r = i(n.CI, Ut) || function(n) {
                            switch(n.Cx.$){
                                case 0:
                                case 3:
                                case 5:
                                    return !1;
                                default:
                                    return !0;
                            }
                        }(n), t = function() {
                            var r = b(n.CI, n.Cx);
                            if (r.a.$ || 3 !== r.b.$) return A2(LB, x([
                                ok(x([
                                    Xx("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), h);
                            var t = r.b.a;
                            return 1 > t || 1 > n.Cy ? ld("") : A2(LB, x([
                                ok(x([
                                    Xx("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), A2(Eu, function(r) {
                                return A2(LB, x([
                                    ok(x([
                                        Xx(A2(fe, " ", x([
                                            "flex w-full justify-center border-b border-primary-200 py-3",
                                            i(r, t) ? "last:border-b-0 last:pb-6" : ""
                                        ])))
                                    ]))
                                ]), x([
                                    A3(g9, n.zr, r, v9(n.Cy))
                                ]));
                            }, A2($e, 1, t)));
                        }(), e = function() {
                            var r = n.CI;
                            if (r.$) return ld("");
                            var t = r.a, e = i(n.Cx, V1) ? "" : "opacity-0";
                            return A2(LB, x([
                                ok(x([
                                    Xx("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), x([
                                A2(FG, x([
                                    zG(t + "#zoom=FitH"),
                                    Xx("h-full min-h-0 w-full min-w-0 flex-1 border-0 " + e),
                                    A2(TC, "load", uu(n.BD)),
                                    A2(TC, "error", uu(n.BC))
                                ]), h)
                            ]));
                        }();
                        return s9({
                            ok: A2(LB, x([
                                ok(x([
                                    Xx("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), x([
                                n.Ep ? t : e
                            ])),
                            AS: p9,
                            AT: m9,
                            Cg: "file-viewer-pdf-lightbox relative flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                            DA: r,
                            xl: n.xl
                        });
                    }
                    return ld("");
                }(t.a);
            case "csv":
                var e = n.zs.eA;
                if (e.$) return r;
                var u = e.a;
                return function(n) {
                    switch(n.ok.$){
                        case 3:
                        case 0:
                            return ld("");
                        default:
                            var r = function() {
                                var r = n.ok;
                                if (2 === r.$) {
                                    var t = r.a;
                                    return A3(o9, n.xl, Vt(n.xl(I3(n.kz))), t);
                                }
                                return ld("");
                            }(), t = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.ok);
                            return s9({
                                ok: A2(LB, x([
                                    ok(x([
                                        Xx("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), x([
                                    r
                                ])),
                                AS: R3,
                                AT: T3,
                                Cg: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                DA: t,
                                xl: n.xl
                            });
                    }
                }({
                    ok: u.ok,
                    kz: u.kz,
                    xl: n.xl
                });
            case "xlsx":
                var a = n.zs.fZ;
                if (a.$) return r;
                var c = a.a;
                return function(n) {
                    switch(n.ok.$){
                        case 3:
                        case 0:
                            return ld("");
                        default:
                            var r = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.ok), t = function() {
                                var r = n.ok;
                                if (2 === r.$) {
                                    var t = r.a, e = A2(C9, be(t), n.Dt), u = be(t) > 1 ? A2(LB, x([
                                        ok(x([
                                            Xx("sheet-names flex w-full flex-col items-start gap-1 px-3 pt-2 sm:flex-row sm:flex-wrap sm:items-start")
                                        ]))
                                    ]), A2(he, F2(function(r, t) {
                                        return A2(OC, x([
                                            zI,
                                            EC(n.B0(r)),
                                            gC(x([
                                                Xx("w-full justify-start text-left !ml-0 rounded-none sm:w-auto"),
                                                SC(x([
                                                    b("font-semibold", i(r, e)),
                                                    b("opacity-80 hover:bg-gray-50 hover:opacity-100", !i(r, e))
                                                ]))
                                            ]))
                                        ]), x([
                                            ld(t.tg)
                                        ]));
                                    }), t)) : ld(""), a = TE(t) ? A2(LB, x([
                                        ok(x([
                                            Xx("flex items-center justify-center px-4 py-8 text-sm text-primary-500")
                                        ]))
                                    ]), x([
                                        ld(n.xl(x9))
                                    ])) : ld(""), c = rv(A2(Np, e, t));
                                    return v(u, a, function() {
                                        if (c.$) return ld("");
                                        var r = c.a, t = {
                                            hC: r.hC,
                                            iL: r.iL
                                        }, e = vu(XC(r.tg)) ? n.xl(_9(n.kz)) : n.xl(A2(y9, n.kz, r.tg));
                                        return A3(o9, n.xl, Vt(e), t);
                                    }());
                                }
                                return v(ld(""), ld(""), ld(""));
                            }(), e = t.a, u = t.b, a = t.c;
                            return s9({
                                ok: A2(LB, x([
                                    ok(x([
                                        Xx("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), x([
                                    e,
                                    u,
                                    A2(LB, x([
                                        ok(x([
                                            Xx("min-h-0 min-w-0 w-full flex-1")
                                        ]))
                                    ]), x([
                                        a
                                    ]))
                                ])),
                                AS: R3,
                                AT: k9,
                                Cg: A2(fe, " ", x([
                                    "spreadsheet-viewer relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg shadow-2xl pointer-events-auto",
                                    r ? "" : "bg-white"
                                ])),
                                DA: r,
                                xl: n.xl
                            });
                    }
                }({
                    ok: c.ok,
                    kz: c.kz,
                    B0: c.B0,
                    Dt: c.Dt,
                    xl: n.xl
                });
            case "xml":
                var o = n.zs.f_;
                if (o.$) return r;
                var f = o.a;
                return function(n) {
                    switch(n.ok){
                        case 3:
                        case 0:
                            return ld("");
                        default:
                            var r = function(n) {
                                switch(n){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.ok), t = n.xl(D9(n.kz)), e = rc(x([
                                x([
                                    SC(x([
                                        b("xml-preview min-h-0 w-full flex-1 overflow-auto p-3 text-sm text-primary-dark", !0),
                                        b("bg-white", !r),
                                        b("px-4 py-8", r)
                                    ])),
                                    Hq(n.dv)
                                ]),
                                r ? h : x([
                                    A2(jC, "aria-label", t)
                                ])
                            ]));
                            return s9({
                                ok: A2(LB, x([
                                    ok(x([
                                        Xx("flex min-h-0 min-w-0 w-full flex-1 flex-col")
                                    ])),
                                    rB(oB)
                                ]), x([
                                    A2(LB, x([
                                        ok(e)
                                    ]), h)
                                ])),
                                AS: E9,
                                AT: B9,
                                Cg: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                DA: r,
                                xl: n.xl
                            });
                    }
                }({
                    ok: f.ok,
                    kz: f.kz,
                    dv: f.dv,
                    xl: n.xl
                });
            default:
                return r;
        }
    }, P9 = function(n) {
        switch(n.yM){
            case 0:
                return C3({
                    zq: n.Am,
                    kz: n.kz,
                    bq: n.bq,
                    BJ: n.BJ,
                    tJ: n.tJ,
                    CF: H3,
                    Dy: !1,
                    DC: !1,
                    xl: n.xl
                });
            case 3:
                var r = n.zs;
                return r.$ ? w9({
                    xl: n.xl
                }) : q9({
                    zs: r.a,
                    kz: n.kz,
                    xl: n.xl
                });
            default:
                return w9({
                    xl: n.xl
                });
        }
    }, z9 = function(n) {
        if (n.h) return function(n) {
            return A3(M3, "modal__content--file-viewer-unsupported", x([
                qI(x([
                    A2(LB, x([
                        bq,
                        aq,
                        ok(x([
                            Xx("text-black pr-2 leading-6")
                        ]))
                    ]), x([
                        ld(n.xl(j3))
                    ]))
                ])),
                EI(x([
                    A2(Ek, x([
                        fq,
                        L3,
                        ok(x([
                            Xx("leading-5")
                        ]))
                    ]), x([
                        ld(n.xl(S3))
                    ]))
                ])),
                DI(x([
                    A2(LB, x([
                        ok(x([
                            Xx("flex w-full flex-wrap gap-3 sm:flex-nowrap")
                        ])),
                        rB(m2)
                    ]), x([
                        A2(OC, x([
                            oF,
                            EC(n.By)
                        ]), x([
                            ld(n.xl(P3))
                        ])),
                        A2(OC, x([
                            qC,
                            EC(n.BF)
                        ]), x([
                            ld(n.xl(z3))
                        ]))
                    ]))
                ]))
            ]), n.e7);
        }({
            e7: n.e7,
            By: n.By,
            BF: n.BG,
            xl: n.xl
        });
        var r, t = 3 === (r = b(n.yM, n.zs)).a && !r.b.$;
        return A2(t ? N3("modal-wrap--file-viewer") : YI(1), x([
            q3,
            EI(x([
                A2(LB, x([
                    ok(x([
                        Xx(t ? "p-5 sm:p-8 md:p-12 flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-stretch justify-start overflow-hidden pointer-events-none" : "flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-center justify-center pointer-events-none")
                    ]))
                ]), x([
                    P9({
                        yM: n.yM,
                        zs: n.zs,
                        kz: n.CH,
                        bq: n.bq,
                        Am: n.An,
                        BJ: n.BJ,
                        tJ: n.tJ,
                        xl: n.xl
                    })
                ]))
            ]))
        ]), n.e7);
    }, j9 = F6(function(n, r, t, e, u, a) {
        var c = A2(o3, e, a), o = n3(a.c.af), f = $1(a.c), s = A4(i3, a.f.F, a.f.K, a.b5.ce, e), l = !a.ak && f && (a.f.bq || i(a.f.aK, Ut)), d = A2(u3, e, a), b = a.di > 0 ? a.di : e, v = A2(Ve, 1, b - 32), m = b > 0 && 1024 > b, p = hX(a.c), $ = !p && !a.ak && !l && i(a.f.F, Ut), g = 1 === p && !a.ak && !a.y.dF;
        return A2(LB, h, x([
            D3({
                l: {
                    bj: a.l.bj,
                    pI: a.l.pI,
                    bT: IX(a.k),
                    bX: a.l.bX,
                    cE: a.l.cE,
                    tI: MX(S2),
                    BH: MX(L2),
                    BP: A2(pc, MX, M2),
                    BU: MX(N2),
                    BX: MX(H2),
                    B_: A2(pc, MX, T2),
                    B$: A2(pc, MX, LX),
                    B2: F2(function(n, r) {
                        return MX(A2(I2, n, r));
                    }),
                    tL: MX(R2)
                },
                f: {
                    pk: A3(a3, ry, a.f.F, a.f.K),
                    zq: A2(r3, a, u),
                    bq: l,
                    tB: d,
                    BS: F2(function(n, r) {
                        return NK(A2(V2, n, r));
                    }),
                    wk: $,
                    DC: s && !p
                },
                Dr: {
                    k: a.k,
                    yx: p,
                    z0: a.c.af,
                    di: e,
                    AE: r,
                    ak: a.ak,
                    A2: R1(a.k),
                    BQ: dW(U2),
                    BT: A2(pc, dW, Y2),
                    cU: u,
                    xl: n,
                    ED: A2(D2, r, t)
                },
                y: {
                    pk: A3(a3, ry, a.y.F, a.y.K),
                    tB: c,
                    tI: O2(G2),
                    BO: O2(J2),
                    tJ: F2(function(n, r) {
                        return O2(A2(W2, n, r));
                    }),
                    tL: O2(K2),
                    b2: a.y.b2,
                    CG: u0(a.k),
                    wk: g
                }
            }),
            z9({
                yM: p,
                zs: _W(a) ? Vt({
                    eA: Ut,
                    eE: a.B,
                    zT: kW(a.c),
                    dv: o1(a),
                    fg: Ut,
                    fZ: Ut,
                    f_: Ut
                }) : CW(a.c) && !a.h ? Vt({
                    eA: Ut,
                    eE: cX,
                    zT: kW(a.c),
                    dv: "",
                    fg: Vt({
                        zr: h1(a),
                        BC: dW(U2),
                        BD: vW(Q2),
                        Cx: a.p,
                        Cy: v,
                        CI: a.n,
                        xl: n,
                        Ep: m
                    }),
                    fZ: Ut,
                    f_: Ut
                }) : PW(a.c) && !a.h ? Vt({
                    eA: Vt({
                        ok: a.u,
                        kz: o
                    }),
                    eE: cX,
                    zT: kW(a.c),
                    dv: "",
                    fg: Ut,
                    fZ: Ut,
                    f_: Ut
                }) : zW(a.c) && !a.h ? Vt({
                    eA: Ut,
                    eE: cX,
                    zT: kW(a.c),
                    dv: "",
                    fg: Ut,
                    fZ: Vt({
                        ok: a.v,
                        kz: o,
                        B0: A2(pc, FW, X2),
                        Dt: a.r
                    }),
                    f_: Ut
                }) : NW(a.c) && !a.h ? Vt({
                    eA: Ut,
                    eE: cX,
                    zT: kW(a.c),
                    dv: "",
                    fg: Ut,
                    fZ: Ut,
                    f_: Vt({
                        ok: a.w,
                        kz: o,
                        dv: q1(a)
                    })
                }) : Ut,
                bq: l,
                An: A2(c3, a, u),
                e7: a.b,
                By: dW(aX),
                BG: dW(Z2),
                BJ: dW(U2),
                tJ: F2(function(n, r) {
                    return NK(A2(V2, n, r));
                }),
                CH: o,
                h: a.h,
                xl: n
            })
        ]));
    }), S9 = F5(function(n, r, t, e, u) {
        var a = u.cU;
        switch(a.$){
            case 3:
                return A6(j9, n, r, t, e, a.a, u);
            case 0:
                return A6(j9, n, r, t, e, "", u);
            case 1:
                return A2(nk, x([
                    Xx(A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
                        "h-24 w-full min-w-[240px] max-w-xs animate-opacity-pulse bg-chat-gray",
                        A2(D2, r, t)
                    ])))),
                    A2(jC, "role", "status")
                ]), h);
            default:
                var i = hX(u.c);
                return A2(nk, x([
                    Xx(A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
                        "w-full",
                        A2(D2, r, t)
                    ]))))
                ]), x([
                    A2(j2, x([
                        q2
                    ]), x([
                        A2(PE, x([
                            HB,
                            MB("text-red-600")
                        ]), 9),
                        A2(FI, x([
                            fq,
                            bO
                        ]), x([
                            ld(n(i ? rb : tb))
                        ]))
                    ]))
                ]));
        }
    }), L9 = F5(function(n, r, t, e, u) {
        var a = t + "_" + u, i = A2(Wu, a, n.I);
        if (i.$) return ld("");
        var c = i.a;
        return A2(Ck, n.Bs(a), A5(S9, n.xl, r, e, n.di, c));
    }), M9 = F5(function(n, r, t, e, u) {
        var a;
        return TE(u.z2) ? ld("") : A2(nk, x([
            Xx(A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
                "w-full min-w-0 max-w-message-attachments",
                "bg-transparent",
                "space-y-2",
                r ? "ml-auto" : "",
                t && !e ? "mt-2" : ""
            ]))))
        ]), (a = be(u.z2), A2(he, F2(function(t, e) {
            return A5(L9, n, r, u.rh, Vt({
                kE: t,
                Ee: a
            }), e);
        }), u.z2)));
    }), N9 = F6(function(n, r, t, e, u, a) {
        var i, c = a.$ ? "" : "ml-12", o = A2(f2, e, u), f = o ? m2 : p2, s = function() {
            var n = u.D2;
            if (1 === n.$) return ld("");
            var r = n.a;
            return vu(XC(r)) ? ld("") : A2(LB, x([
                aq,
                ok(x([
                    Xx("whitespace-pre-line")
                ]))
            ]), A2(E2, o, r));
        }(), l = o ? "bg-info-200 text-primary-600 " : "bg-primary-500 text-white ", d = o ? m2 : p2, b = A2(nk, A2(Yt, Xx("flex opacity-70 mb-2 " + c), $k(d)), x([
            A2(LB, x([
                EZ,
                d2
            ]), x([
                ld(A3(g2, r, t, u.Dn))
            ]))
        ])), v = 1 !== (i = u.D2).$ && !vu(XC(i.a)), m = !TE(u.z2), p = a.$ ? "flex mb-1" : "flex mb-1 items-end space-x-2", h = "w-fit max-w-lg flex flex-col overflow-hidden p-2 " + $(l, h2(o)), g = function() {
            if (v && m) {
                var r = "flex w-full " + (o ? "justify-end" : "justify-start");
                return A2(nk, x([
                    Xx(A2(fe, " ", A2(Rc, A2(pc, gm, vu), x([
                        "flex w-full min-w-0 max-w-lg flex-col gap-4",
                        o ? "ml-auto" : ""
                    ]))))
                ]), x([
                    A2(nk, x([
                        Xx(r)
                    ]), x([
                        A2(nk, x([
                            Xx(h)
                        ]), x([
                            s
                        ]))
                    ])),
                    A2(nk, x([
                        Xx(r)
                    ]), x([
                        A5(M9, n, o, !1, !0, u)
                    ]))
                ]));
            }
            return A2(nk, x([
                Xx(m ? "flex w-full min-w-0 max-w-lg flex-col bg-transparent p-0" : h)
            ]), x([
                s,
                A5(M9, n, o, v, !1, u)
            ]));
        }();
        return A2(nk, x([
            Xx("flex flex-col")
        ]), x([
            A2(nk, A2(Yt, Xx(p), $k(f)), x(a.$ ? [
                g
            ] : [
                a.a,
                g
            ])),
            b
        ]));
    }), H9 = F5(function(n, r, t, e, u) {
        return A6(N9, n, r, t, e, u, Ut);
    }), T9 = function(n) {
        return x(n.trim().split(/\s+/g));
    }, I9 = function(n) {
        var r, t = A2(sc, "text-primary-600", n.D3), e = (r = n.yC).$ ? "" : "border " + r.a, u = A2(fe, " ", x([
            "w-10 h-10 rounded-full flex",
            A2(sc, "bg-info-200", n.yw),
            e
        ])), a = $($k(LI), $k(kF));
        return A2(nk, A2(Yt, Xx(u), a), x([
            n.AF ? A2(PE, x([
                MB("text-white")
            ]), 30) : A2(LB, x([
                fq,
                nH,
                ok(x([
                    Xx(t)
                ]))
            ]), x([
                ld(n.As)
            ]))
        ]));
    }, R9 = F2(function(n, r) {
        var t = !A2(f2, n, r.sE) && r.Dw, e = function(n) {
            if (n.$) return "?";
            var r, t = n.a;
            return r = A2(fe, "", A2(Eu, A2(ru, mu(1), $v), A2(wj, 2, T9(t)))), vu(r) ? "?" : r;
        }(r.sE.yt.zp);
        return A2(nk, x([
            Xx("flex-shrink-0 w-10 flex items-end")
        ]), x([
            t ? I9({
                yw: Vt("bg-light-divider"),
                yC: Vt("border-light-divider"),
                As: e,
                AF: !1,
                D3: Vt("text-gray-600")
            }) : A2(nk, x([
                Xx("w-10 h-10")
            ]), h)
        ]));
    }), Z9 = F5(function(n, r, t, e, u) {
        var a = A2(f2, e, u.sE) ? Ut : Vt(A2(R9, e, u));
        return A6(N9, n, r, t, e, u.sE, a);
    }), V9 = F6(function(n, r, t, e, u, a) {
        var c = a.Dx ? x([
            b2(a.Dp)
        ]) : h, o = a.sE, f = o.Co;
        if (f.$) {
            var s = rv(A2(Rc, function(n) {
                return i(n.sE.rh, o.rh);
            }, u)), l = function() {
                if (s.$) return x([
                    A5(H9, n, r, t, e, o)
                ]);
                var u = s.a, a = x([
                    A5(Z9, n, r, t, e, u)
                ]);
                return $(u.Dv && !A2(f2, e, u.sE) ? x([
                    A2($2, A2(sc, "", u.yv), A2(f2, e, u.sE))
                ]) : h, a);
            }();
            return $(c, l);
        }
        return $(c, A2(v2, n.xl, f.a));
    }), U9 = F5(function(n, r, t, e, u) {
        var a = A3(c2, r, t, u.qd), i = A2(o2, r, u.qd);
        return A2(nk, x([
            Hq("messages-content"),
            Xx("flex flex-col")
        ]), A2(tc, A5(V9, n, r, t, e, i), a));
    }), Y9 = function(n) {
        var r = "relative flex-1 overflow-y-auto bg-chat-gray p-4 space-y-4 min-h-0";
        return A2(LB, x([
            ok(x([
                Xx(n.bY ? r + " overflow-hidden invisible pointer-events-none " : r),
                Hq("messages-container")
            ]))
        ]), x([
            function() {
                var r = n.aN;
                switch(r.$){
                    case 1:
                    default:
                        return ld("");
                    case 3:
                        return A5(U9, n.Bd, n.fS, n.bj, n.y7, r.a);
                    case 2:
                        return A2(LB, x([
                            ok(x([
                                Xx("flex justify-center py-2")
                            ]))
                        ]), x([
                            A2(Ek, x([
                                fq,
                                bO
                            ]), x([
                                ld(n.xl(eb))
                            ]))
                        ]));
                }
            }()
        ]));
    }, Q9 = function(n) {
        var r = "relative flex-1 overflow-y-auto bg-chat-gray p-4 space-y-4 min-h-0";
        return A2(LB, x([
            ok(x([
                Xx(n.bY ? r + " overflow-hidden invisible pointer-events-none " : r),
                Hq("messages-container")
            ]))
        ]), x([
            function() {
                var r = n.aN;
                switch(r.$){
                    case 1:
                    default:
                        return ld("");
                    case 3:
                        return A5(U9, n.Bd, n.fS, n.bj, n.y7, r.a);
                    case 2:
                        return A2(LB, x([
                            ok(x([
                                Xx("flex py-2")
                            ])),
                            ok($k(kF))
                        ]), x([
                            A2(Ek, x([
                                fq,
                                bO
                            ]), x([
                                ld(n.xl(eb))
                            ]))
                        ]));
                }
            }()
        ]));
    }, O9 = F4(function(n, r, t, e) {
        var u;
        return (u = {
            yS: A2(z0, n, r),
            y7: j0(r),
            bj: r.bj,
            bt: r.bt,
            cz: r.cz,
            bu: r.bu,
            cA: r.cA,
            bY: r.bY,
            Bd: A2(S0, n, r),
            aN: r.aN,
            Bz: t,
            BY: nW,
            B4: E0,
            t1: L0(r),
            CO: r.bB,
            cR: r.cR,
            fS: r.fS,
            xl: n,
            fY: e
        }).fY ? function(n) {
            return A2(LB, x([
                ok(x([
                    Xx("h-full bg-divider flex flex-col")
                ]))
            ]), x([
                A2(u2, n, !0),
                Y9(n),
                I0(n.yS)
            ]));
        }(u) : function(n) {
            var r = !i(n.Bz, Ut);
            return A2(LB, x([
                ok(x([
                    Xx("w-full h-full flex flex-col relative")
                ]))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("flex-shrink-0 z-10 bg-white")
                    ]))
                ]), x([
                    A2(u2, n, r)
                ])),
                Q9(n),
                A2(LB, x([
                    ok(x([
                        Xx("flex-shrink-0 z-10 bg-white border-t border-primary-200")
                    ]))
                ]), x([
                    I0(n.yS)
                ]))
            ]));
        }(u);
    }), G9 = F2(function(n, r) {
        return A2(LB, x([
            ok(x([
                Xx("h-full bg-white flex flex-col")
            ]))
        ]), x([
            A4(O9, n, r, Vt(B0), r.fY)
        ]));
    }), J9 = pH(5), W9 = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("flex p-8")
            ])),
            ok($k(LI)),
            ok($k(kF))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("space-y-2")
                ])),
                ok($k(DB))
            ]), x([
                A2(Ek, x([
                    aq,
                    O0
                ]), x([
                    ld(n(ob))
                ])),
                A2(Ek, x([
                    fq,
                    J9
                ]), x([
                    ld(n(fb))
                ]))
            ]))
        ]));
    }, K9 = F2(function(n, r) {
        return A2(EN, x([
            JI(8)
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("bg-white rounded-md h-[60vh] min-h-96 overflow-hidden")
                ]))
            ]), x([
                function() {
                    var t = v(r.Q, r.a9, r.X);
                    if (3 === t.a.$) {
                        if (t.b.$) return t.c.$ ? (u = A0(t.a.a), TE(u) ? A2(LB, x([
                            ok(x([
                                Xx("h-full flex")
                            ])),
                            ok($k(LI)),
                            ok($k(kF))
                        ]), x([
                            W9(n)
                        ])) : function(n) {
                            return A2(LB, x([
                                ok(x([
                                    Xx("flex h-full p-8")
                                ])),
                                ok($k(LI)),
                                ok($k(kF))
                            ]), x([
                                A2(LB, x([
                                    ok(x([
                                        Xx("space-y-2")
                                    ])),
                                    ok($k(DB))
                                ]), x([
                                    A2(Ek, x([
                                        aq,
                                        O0
                                    ]), x([
                                        ld(n(ab))
                                    ])),
                                    A2(Ek, x([
                                        fq,
                                        J9
                                    ]), x([
                                        ld(n(ib))
                                    ]))
                                ]))
                            ]));
                        }(n)) : A2(Ck, xJ, A2(G9, n, t.c.a));
                        if (t.c.$) {
                            var e = t.b.a, u = A0(t.a.a);
                            return TE(u) ? W9(n) : A2(C0, n, e);
                        }
                        return A2(Ck, xJ, A2(G9, n, t.c.a));
                    }
                    return A2(LB, x([
                        ok(x([
                            Xx("h-full flex")
                        ])),
                        ok($k(LI)),
                        ok($k(kF))
                    ]), x([
                        W9(n)
                    ]));
                }()
            ]))
        ]));
    }), X9 = {
        $: 7
    }, n6 = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("px-2 pb-8 flex w-full")
            ])),
            ok($k(LI)),
            ok($k(Z0))
        ]), x([
            A2(LB, h, h),
            A2(yC, x([
                lk
            ]), x([
                ld(n(sb))
            ])),
            A2(nk, x([
                Xx("text-primary-300 cursor-pointer"),
                IC(X9)
            ]), x([
                A2(LB, x([
                    V0
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 29)
                ]))
            ]))
        ]));
    }, r6 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, t6 = F3(function(n, r, t) {
        return A2(A2(Dp, n, r), 2, t);
    }), e6 = F4(function(n, r, t, e) {
        var u = e.a.t1, a = e.a.rR, i = a.$ ? "" : a.a.DI, c = a.$ ? "" : A3(t6, n, r, a.a.Dn), o = function(n) {
            return n.a.rJ;
        }(e), f = 3 === t.$ ? Vt(EL(t.a)) : Ut, s = A2(Q0, u, f), l = A2(fe, ", ", A2(Tp, iu, A2(Eu, function(n) {
            return n.zp;
        }, s))), d = be(s) > 1, b = XW(e), v = function() {
            if (d) return "";
            var n = rv(s);
            if (n.$) return "?";
            var r = n.a.zp;
            return r.$ ? "?" : A2(mu, 1, r.a);
        }();
        return A2(nk, x([
            Xx("p-4 cursor-pointer bg-white md:bg-transparent"),
            IC(r6(b))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex space-x-3")
                ])),
                ok($k(LI))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("flex space-x-2")
                    ])),
                    ok($k(LI))
                ]), x([
                    A2(LB, x([
                        ok(x([
                            Xx("w-3 flex-shrink-0")
                        ]))
                    ]), x([
                        o ? A2(LB, x([
                            ok(x([
                                Xx("w-3 h-3 bg-primary-300 rounded-full")
                            ]))
                        ]), h) : ld("")
                    ])),
                    I9({
                        yw: Ut,
                        yC: Ut,
                        As: v,
                        AF: d,
                        D3: Ut
                    })
                ])),
                A2(LB, x([
                    ok(x([
                        Xx("flex-1 min-w-0")
                    ]))
                ]), x([
                    A2(LB, x([
                        ok(x([
                            Xx("flex mb-1")
                        ])),
                        ok($k(Z0)),
                        ok($k(LI))
                    ]), x([
                        A2(LB, x([
                            fq,
                            O0,
                            ok(x([
                                Xx("truncate")
                            ]))
                        ]), x([
                            ld(l)
                        ])),
                        A2(LB, x([
                            EZ,
                            d2,
                            ok(x([
                                Xx("ml-2 flex-shrink-0")
                            ]))
                        ]), x([
                            ld(c)
                        ]))
                    ])),
                    A2(LB, x([
                        fq,
                        d2,
                        ok(x([
                            Xx("line-clamp-2")
                        ]))
                    ]), x([
                        ld(i)
                    ]))
                ]))
            ]))
        ]));
    }), u6 = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("text-center p-8")
            ]))
        ]), x([
            A2(Ek, x([
                aq,
                O0,
                ok(x([
                    Xx("mb-2")
                ]))
            ]), x([
                ld(n(cb))
            ]))
        ]));
    }, a6 = function(n) {
        return x([
            A2(Ak, x([
                _H(fO)
            ]), x([
                ld(n)
            ]))
        ]);
    }, i6 = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("flex py-8")
            ])),
            ok($k(kF))
        ]), a6(n(nb)));
    }, c6 = F3(function(n, r, t) {
        var e = t.Q;
        switch(e.$){
            case 1:
                return ld("");
            case 3:
                var u = A0(e.a);
                return TE(u) ? A2(LB, x([
                    ok(x([
                        Xx("h-full flex flex-col bg-white")
                    ])),
                    ok($k(LI)),
                    ok($k(kF))
                ]), x([
                    u6(n)
                ])) : A2(LB, A2(Yt, ok(x([
                    Xx("h-full overflow-y-auto")
                ])), r ? x([
                    ok(x([
                        Hq("conversation-list-container")
                    ]))
                ]) : h), A2(Eu, A3(e6, t.fS, t.bj, t.t6), u));
            case 2:
                return A2(LB, x([
                    ok(x([
                        Xx("h-full flex flex-col")
                    ])),
                    ok($k(LI)),
                    ok($k(kF))
                ]), x([
                    i6(n)
                ]));
            default:
                return A2(LB, x([
                    ok(x([
                        Xx("h-full flex flex-col")
                    ])),
                    ok($k(LI)),
                    ok($k(kF))
                ]), x([
                    ld("")
                ]));
        }
    }), o6 = F2(function(n, r) {
        return A2(EN, x([
            JI(4)
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("bg-white rounded-md h-[60vh] min-h-96 overflow-y-auto")
                ]))
            ]), x([
                A3(c6, n, !0, r)
            ]))
        ]));
    }), f6 = F2(function(n, r) {
        return A2(LB, x([
            ok(x([
                Xx("flex flex-col max-h-[calc(100vh-12rem)] w-full")
            ]))
        ]), x([
            n6(n),
            A2(LB, x([
                ok(x([
                    Xx("w-full flex-1 flex")
                ]))
            ]), x([
                A2(zN, x([
                    KN(x([
                        Xx("w-full")
                    ]))
                ]), x([
                    A2(o6, n, r),
                    A2(K9, n, r)
                ]))
            ]))
        ]));
    }), s6 = F2(function(n, r) {
        return A2(LB, x([
            ok(x([
                Xx("fixed inset-0 z-50 bg-divider flex flex-col overflow-hidden")
            ]))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex-1 min-h-0")
                ]))
            ]), x([
                A2(Ck, xJ, A2(G9, n, r))
            ]))
        ]));
    }), l6 = F2(function() {
        return ld("");
    }), d6 = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("px-4 pb-4 flex")
            ])),
            ok($k(LI)),
            ok($k(Z0))
        ]), x([
            A2(LB, x([
                ok(h)
            ]), h),
            A2(yC, x([
                lk
            ]), x([
                ld(n(sb))
            ])),
            A2(nk, x([
                Xx("text-primary-300 cursor-pointer"),
                IC(X9)
            ]), x([
                A2(LB, x([
                    V0
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 29)
                ]))
            ]))
        ]));
    }, b6 = F2(function(n, r) {
        var t;
        return 3 === (t = r.Q).$ && TE(A0(t.a)) ? A2(LB, x([
            ok(x([
                Xx("w-full h-screen flex flex-col")
            ]))
        ]), x([
            d6(n),
            A2(LB, x([
                ok(x([
                    Xx("flex-1 flex bg-white")
                ])),
                ok($k(LI)),
                ok($k(kF))
            ]), x([
                u6(n)
            ]))
        ])) : A2(LB, x([
            ok(x([
                Xx("w-full h-full flex flex-col")
            ]))
        ]), x([
            d6(n),
            A2(LB, x([
                ok(x([
                    Xx("max-h-[calc(100vh-12rem)] min-h-96 overflow-y-auto"),
                    Hq("conversation-list-container")
                ]))
            ]), x([
                A3(c6, n, !1, r)
            ]))
        ]));
    }), v6 = F2(function(n, r) {
        var t;
        return A2(LB, h, x([
            (t = b(r.a9, r.X), 1 === t.a.$ ? 1 === t.b.$ ? A2(b6, n, r) : A2(s6, n, t.b.a) : t.b.$ ? A2(l6, n, t.a.a) : A2(s6, n, t.b.a))
        ]));
    }), m6 = F2(function(n, r) {
        var t = 1024 > r.d7;
        return {
            gN: x([
                A2(LB, x([
                    ok(x([
                        Xx("bg-gray-100 w-full")
                    ]))
                ]), x([
                    A2(t ? v6 : f6, n, r)
                ]))
            ]),
            w5: n(sb)
        };
    }), p6 = ZA({
        Ar: nJ,
        AQ: gJ,
        Db: wJ,
        DZ: function(n) {
            var r, t = RJ(F2(function(n) {
                return JG(n);
            })), e = A2(IJ, 1e4, yJ), u = ZJ(kJ), a = (r = n.X).$ ? zx : A2(_S, xJ, function(n) {
                var r, t = A2(IJ, 1e4, XJ), e = Px(A2(Eu, function(n) {
                    var r = n.b;
                    return A2(_S, VJ(n.a), function(n) {
                        return Px(x([
                            A2(_S, A2(pc, dW, mW), BS()),
                            AW(n),
                            SW(n),
                            TW(n),
                            hW(n.b) && CW(n.c) && !n.h && LW(n) ? DW(A2(ru, bW, vW)) : zx
                        ]));
                    }(r));
                }, Ot(n.I)));
                return Px(x([
                    ZJ(WJ),
                    (r = GJ, sW(A2(ru, fW, r))),
                    A2(_S, KJ, RW),
                    rW(A2(ru, cy(uW), A2(ru, Kp(OJ), up(JJ)))),
                    A2(_S, nW, QW(n.bB)),
                    aW(UJ),
                    lW(YJ),
                    RJ(F2(function(n) {
                        return QJ(n);
                    })),
                    t,
                    e
                ]));
            }(r.a));
            return Px(x([
                u,
                a,
                t,
                e
            ]));
        },
        En: _0,
        Et: m6
    }), $6 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, h6 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, g6 = {
        $: 0
    }, w6 = F3(function(n, r, t) {
        return {
            gF: n,
            aC: g6,
            ff: h,
            CD: t,
            jK: r
        };
    }), x6 = F2(function(n, r) {
        return m(r, {
            w5: Vt(n)
        });
    }), k6 = F4(function(n, r, t, e) {
        return {
            x4: A3(w6, r.gF, r.jK, Bx(n)),
            gF: r.gF,
            hd: 0,
            kA: r.kA,
            aD: A2(x6, XU, e),
            dB: n,
            jK: r.jK,
            xs: t
        };
    }), y6 = F3(function(n, r, t) {
        var e = A3(SU, !1, r.gF, Bx(n)), u = e.b;
        return b(A4(k6, n, r, t, e.a), Vu(x([
            A3(MU, r.gF, Bx(n), $6),
            A2(Lp, h6, u)
        ])));
    }), _6 = F2(function(n, r) {
        return b(r, Pp);
    }), C6 = F2(function(n, r) {
        return m(r, {
            x6: Vt(4)
        });
    }), B6 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, E6 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D6 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, q6 = A2(nu, function(n) {
        return "Escape" === n ? uu(cY(n)) : Sk("nothing");
    }, A2(Tu, "key", C$)), P6 = function(n) {
        return A2(tu, n, q6);
    }, z6 = function(n) {
        return n.aC.$ ? Px(x([
            kY(P6(E6)),
            A2(_S, D6, BS())
        ])) : zx;
    }, j6 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, S6 = function(n) {
        return n.xD;
    }, L6 = F2(function(n, r) {
        var t = r.aH.eD, e = FL(r.kB), u = x([
            b("signature", Ax(e.dU)),
            b("version_number", EX(S6(t)))
        ]);
        return _x(n ? A2(Yt, b("id", Ax(FY(r))), u) : u);
    }), M6 = F3(function(n, r, t) {
        var e = Bx(t), u = FY(r);
        return A5(mL, n, e, u, A2(L6, !1, r), j6);
    }), N6 = F2(function(n, r) {
        return r.ps(n);
    }), H6 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, T6 = {
        $: 0
    }, I6 = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), R6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    aC: g6
                }), Pp, Ut);
            case 1:
                var t = TY(d = n.a), e = LY(d), u = d.a.wu, a = A2(fS, 0, T6), i = a.a, c = a.b, o = u.$ ? b(Ut, Pp) : A2(qx, Vt, A5(nO, r.gF, r.CD, e, t, u.a)), f = o.b;
                return v(m(r, {
                    aC: A3(I6, i, d, k = o.a)
                }), Vu(x([
                    c,
                    A2(Lp, H6, f)
                ])), Ut);
            case 2:
                return v(1 === n.a ? m(r, {
                    aC: g6
                }) : r, Pp, Ut);
            case 4:
                var s = n.a, l = r.aC;
                if (l.$) {
                    i = l.a;
                    var d = l.b, p = l.c;
                    if (p.$) return v(r, Pp, Ut);
                    var $ = A2(_Q, s, k = p.a), h = $.b, g = $.c;
                    return v(m(r, {
                        aC: A3(I6, i, d, Vt($.a))
                    }), A2(Lp, H6, h), A2(nv, function(n) {
                        return Vt(n);
                    }, g));
                }
                return v(r, Pp, Ut);
            default:
                s = n.a;
                var w = r.aC;
                if (w.$) {
                    d = w.b;
                    var k = w.c, y = A2(lN, s, i = w.a);
                    return c = y.b, v(m(r, {
                        aC: A3(I6, y.a, d, k)
                    }), A2(Lp, D6, c), Ut);
                }
                return v(r, Pp, Ut);
        }
    }), Z6 = function(n) {
        return 1 !== n.a.wO;
    }, V6 = F4(function(n, r, t, e) {
        return {
            gF: n,
            aC: g6,
            ff: r,
            CD: e,
            jK: t
        };
    }), U6 = F2(function(n, r) {
        return m(r, {
            Y: zY(A2(Eu, A2(RY, r.gF, r.CD), n))
        });
    }), Y6 = F2(function(n, r) {
        var t = A2(U6, DY(n), r.aD), e = A4(V6, r.gF, function(n) {
            return A2(Rc, Z6, n);
        }(n), r.jK, Bx(r.dB));
        return m(r, {
            x4: e,
            hd: 1,
            aD: t
        });
    }), Q6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(A2(Y6, t.a, r), Pp, h) : v(r, Pp, A2(xA, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return v(r, A3(MU, r.gF, Bx(r.dB), $6), x([
                        A2($A, 3, N6(TY(u)))
                    ]));
                }
                return v(r, Pp, A2(xA, 0, e));
            case 2:
                var a = A2(rO, n.a, r.aD), i = a.a, c = (s = a.c).$ || s.a.$ ? A2(Lp, h6, a.b) : A3(M6, r.gF, s.a.a.b, r.dB);
                return v(m(r, {
                    aD: i
                }), c, h);
            default:
                var o = A2(R6, n.a, r.x4), f = o.b, s = o.c;
                return v(m(r, {
                    x4: o.a
                }), A2(Lp, B6, f), A2(sc, h, A2(Fp, function(n) {
                    return n;
                }, s)));
        }
    }), O6 = function(n) {
        return TE(n.ff);
    }, G6 = {
        $: 0
    }, J6 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, W6 = function(n) {
        return n.a.wt;
    }, K6 = F2(function(n, r) {
        var t = W6(r);
        return t.$ ? " " : A2(n, 1, t.a);
    }), X6 = F2(function(n, r) {
        var t = W6(r);
        return t.$ ? " " : A2(n, 4, t.a);
    }), n4 = F2(function(n, r) {
        return A2(zN, h, x([
            A2(EN, h, x([
                ld("Accepted "),
                A2(OC, x([
                    wO,
                    EC(J6(r))
                ]), x([
                    ld(TY(r))
                ])),
                ld(" on " + A2(K6, n, r) + " at " + A2(X6, n, r))
            ]))
        ]));
    }), r4 = F3(function(n, r, t) {
        return A2(zN, x([
            KN(x([
                Xx("panel")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(Ak, x([
                    _H(fO)
                ]), x([
                    ld(n)
                ])),
                A2(XH, h, A2(Eu, n4(t), r))
            ]))
        ]));
    }), t4 = function(n) {
        if (1 === n.$) {
            var r = n.a, t = n.c, e = TY(n.b);
            if (t.$) return tB;
            var u = t.a;
            return A2(QI, x([
                qI(x([
                    A2(FI, x([
                        aq,
                        $H
                    ]), x([
                        ld(e)
                    ]))
                ])),
                EI(x([
                    A2(Ck, H6, A2(LG, 1, u))
                ])),
                DI(h)
            ]), NM(r));
        }
        return tB;
    }, e4 = F2(function(n, r) {
        return O6(r) ? tB : A2(nk, h, x([
            t4(r.aC),
            A3(r4, n, r.ff, r.jK)
        ]));
    }), u4 = F3(function(n, r, t) {
        var e = oO(r) ? "All Agreements Accepted" : "Already Accepted";
        return x([
            A2(Ck, h6, A3(VG, n, x([
                G6
            ]), r)),
            A2(Ck, B6, A2(e4, e, t))
        ]);
    }), a4 = F4(function(n, r, t, e) {
        return oO(t) && O6(e) ? x([
            A2(zN, x([
                KN(x([
                    Xx("panel")
                ]))
            ]), x([
                A2(EN, h, x([
                    A2(Ak, x([
                        _H(fO)
                    ]), x([
                        ld(Ex(r) + " Agreements")
                    ])),
                    ld("You do not have any accepted or pending Agreement")
                ]))
            ]))
        ]) : A3(u4, n, t, e);
    }), i4 = F2(function(n, r) {
        return {
            gN: r.hd ? A4(a4, n, r.dB, r.aD, r.x4) : ck,
            w5: Ex(r.dB)
        };
    }), c4 = ZA({
        Ar: y6,
        AQ: _6,
        Db: C6,
        DZ: function(n) {
            return Px(x([
                A2(_S, h6, yY(n.aD)),
                A2(_S, B6, z6(n.x4))
            ]));
        },
        En: Q6,
        Et: i4
    }), o4 = {
        $: 12
    }, f4 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, s4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, l4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, d4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, b4 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, v4 = F2(function(n, r) {
        return m(r, {
            g4: n
        });
    }), m4 = function(n) {
        return {
            g4: Ie,
            rh: n.rh,
            $7: n.Eb,
            kK: n.Ed,
            aP: !1
        };
    }, p4 = {
        rE: !1,
        fD: A2(v4, F2(function(n, r) {
            return i(uU(n), uU(r));
        }), m4({
            rh: "member-selector",
            Eb: F2(function(n, r) {
                return QE(aU(r));
            }),
            Ed: function(n) {
                return Vt(uU(n));
            }
        }))
    }, $4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, h4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, g4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w4 = F2(function(n, r) {
        return Vu(x([
            A2(hc, $4, eX(n + "-" + r)),
            A2(hc, h4, eX(n)),
            A2(hc, g4, AX(n))
        ]));
    }), x4 = F2(function(n, r) {
        return b({
            c2: r,
            rh: n,
            h6: 0,
            jG: 0,
            jH: 0,
            jN: 0,
            jO: 0
        }, A2(w4, n, r));
    }), k4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, y4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, C4 = A3(dp, 1992, 4, 31), B4 = b({
        bU: Vt(C4),
        bV: !1,
        aM: Ut,
        aP: !1,
        fj: 0,
        xb: C4
    }, A2(Nu, _4, RF)), E4 = function(n) {
        var r = B4.b;
        return b({
            g8: Ut,
            oY: Ut,
            bQ: B4.a,
            km: !1,
            rh: n,
            AC: cm(!0)
        }, Vu(x([
            A2(Lp, k4, r),
            A2(Nu, y4, RF)
        ])));
    }, D4 = function(n) {
        return A2(X_, x([
            "catalog"
        ]), lL(n));
    }, q4 = F7(function(n, r, t, e, u, a, i) {
        return {
            rD: t,
            uv: n,
            Cz: r,
            li: i,
            ln: e,
            lp: u,
            lM: a
        };
    }), P4 = A4(sy, "price", aL(F$), Ut, A3(ly, "total_in_cents", F$, A4(sy, "registration_fee_in_cents", aL(F$), Ut, A4(sy, "recurring_amount_in_cents", aL(F$), Ut, A3(ly, "is_default", jk, A3(ly, "period_in_months", F$, A3(ly, "period", A2(nu, nZ, C$), uu(q4)))))))), z4 = P$(x([
        vy(P4),
        oy(h)
    ])), j4 = aL(A2(nu, nZ, C$)), S4 = A2(nu, function(n) {
        switch(n){
            case "plan":
                return uu(0);
            case "package":
                return uu(1);
            default:
                return Sk("Unknown catalog type: " + n);
        }
    }, C$), L4 = A2(tu, iu, A3(ly, "total_in_cents", F$, A3(ly, "tax_in_cents", F$, A4(sy, "available_billing_periods", z4, h, A4(sy, "expiration_copy", aL(C$), Ut, A4(sy, "billing_period", j4, Ut, A4(sy, "recurring_amount_in_cents", aL(F$), Ut, A4(sy, "registration_fee_in_cents", aL(F$), Ut, A4(sy, "default_period_in_months", aL(F$), Ut, A3(ly, "price", aL(F$), A4(sy, "thumbnail_image_url", aL(C$), Ut, A4(sy, "cover_image_url", aL(C$), Ut, A4(sy, "description", aL(C$), Ut, A4(sy, "name", aL(C$), Ut, A3(ly, "type", S4, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return {
                                                                    mR: d,
                                                                    yz: s,
                                                                    oC: u,
                                                                    o9: c,
                                                                    pe: e,
                                                                    ql: l,
                                                                    rh: n,
                                                                    tg: t,
                                                                    li: i,
                                                                    ln: f,
                                                                    lp: o,
                                                                    lI: b,
                                                                    w3: a,
                                                                    lM: v,
                                                                    xo: r
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))), M4 = F3(function(n, r, t) {
        return A4(W_, n, vy(L4), t, rA(D4(r)));
    }), N4 = function(n) {
        switch(n){
            case 0:
                return "all";
            case 1:
                return "memberships";
            default:
                return "packages";
        }
    }, H4 = F3(function(n, r) {
        var t = A2(x4, "explore-services-tabs", N4(0)), e = t.a, u = t.b, a = A2(fS, 0, o4), i = a.a, c = a.b, o = E4("configure-start-date"), f = o.b, s = m(o.a, {
            km: !0
        });
        return b({
            d9: 0,
            gF: r.gF,
            aW: r.aW,
            bf: cP,
            co: s,
            kA: r.kA,
            dp: Ut,
            ds: p4,
            A8: cP,
            e7: i,
            dA: Ut,
            dB: n,
            W: Ut,
            d_: e,
            Eu: GU(r)
        }, Vu(x([
            A3(M4, r.gF, Bx(n), l4),
            A3(WR, r.gF, Bx(n), d4),
            A3(sZ, r.gF, Bx(n), s4),
            A2(Lp, b4, u),
            c,
            A2(Lp, f4, f)
        ])));
    }), T4 = F2(function(n, r) {
        return b(m(r, {
            aW: n.aW,
            Eu: GU(n)
        }), Pp);
    }), I4 = F2(function(n, r) {
        return m(r, {
            x6: Vt(5)
        });
    }), R4 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Z4 = function(n) {
        return n.bG ? zx : kY(P6(function() {
            return n.By;
        }));
    }, V4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, U4 = {
        $: 9
    }, Y4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Q4 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, O4 = {
        $: 0
    }, G4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, J4 = F2(function(n, r) {
        return A2(Fp, function(n) {
            return A2(Nu, iu, _u(G4(n)));
        }, A2(wF, function(r) {
            return i((0, r.b.d$)(r.a), n);
        }, r));
    }), W4 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), K4 = W4, X4 = F2(function(n, r) {
        return TE(r) ? Pp : A2(sc, Pp, A2(Fp, Lp(b4), A2(J4, N4(n), x([
            A2(K4, 0, {
                d$: N4,
                d1: function() {
                    return ld("");
                }
            }),
            A2(K4, 1, {
                d$: N4,
                d1: function() {
                    return ld("");
                }
            }),
            A2(K4, 2, {
                d$: N4,
                d1: function() {
                    return ld("");
                }
            })
        ]))));
    }), n8 = function(n) {
        return n.a.rH;
    }, r8 = function(n) {
        return uC(n.A8);
    }, t8 = F2(function(n, r) {
        return 1 === r.$ ? n(0) : r;
    }), e8 = function(n) {
        return A2(nv, function(r) {
            var t = function() {
                var t = n.Eu;
                if (t.$) return Ut;
                var e = t.a;
                return rv(A2(Rc, function(n) {
                    return i(uU(n), e);
                }, r));
            }();
            return A2(t8, function() {
                return rv(r);
            }, A2(t8, function() {
                return rv(A2(Rc, n8, r));
            }, t));
        }, r8(n));
    }, u8 = function(n) {
        return n.mR;
    }, a8 = function(n) {
        return A2(Fp, function(n) {
            return n.uv;
        }, rv(A2(Rc, function(n) {
            return n.rD;
        }, u8(n))));
    }, i8 = function(n) {
        return n.rh;
    }, c8 = F2(function(n, r) {
        return !A2(a2, r, n);
    }), o8 = function(n) {
        return n.tg;
    }, f8 = function(n) {
        return A2(cD, "self_buy_2", n);
    }, s8 = function(n) {
        return n.xo;
    }, l8 = {
        $: 1
    }, d8 = F2(function(n, r) {
        return i(n.oY, r) ? Ut : Vt(function(n) {
            return {
                $: 0,
                a: n
            };
        }(r));
    }), b8 = {
        $: 0
    }, v8 = b8, m8 = MC("required"), p8 = {
        ka: function(n) {
            return ld(n);
        },
        nu: v8,
        ev: "elm-datepicker--",
        kf: h,
        ze: fp("yyyy-MM-dd"),
        zh: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        hx: 6,
        At: x([
            m8(!1)
        ]),
        Au: h,
        kF: Ut,
        kG: Ut,
        AC: cm(!1),
        kX: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        Cm: uy,
        CB: "Please pick a date...",
        xR: oe
    }, $8 = function(n) {
        switch(n){
            case 0:
                return "Mon";
            case 1:
                return "Tue";
            case 2:
                return "Wed";
            case 3:
                return "Thu";
            case 4:
                return "Fri";
            case 5:
                return "Sat";
            default:
                return "Sun";
        }
    }, h8 = function(n) {
        var r = A2(lB, ML(aS("/")), n), t = A2(KM, aS("/"), n);
        return t.$ ? A2(KM, aS("/"), r) : te(t.a);
    }, g8 = function(n) {
        return m(p8, {
            ze: fp("MM/dd/yyyy"),
            zh: $8,
            At: x([
                m8(!0)
            ]),
            Au: x([
                b("input", !0)
            ]),
            AC: n,
            Cm: h8,
            CB: "mm/dd/yyyy"
        });
    }, w8 = {
        $: 1
    }, x8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, k8 = {
        $: 0
    }, y8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, _8 = F3(function(n, r, t) {
        var e = t, u = e.bV;
        switch(r.$){
            case 0:
                return b(m(e, {
                    bU: Vt(i = r.a),
                    xb: i
                }), k8);
            case 1:
                return b(m(e, {
                    bU: Vt(i = r.a)
                }), k8);
            case 10:
                var a = r.b;
                return b(m(e, {
                    bU: Vt(i = r.a),
                    fj: a
                }), k8);
            case 9:
                return b(m(e, {
                    fj: a = r.a
                }), k8);
            case 2:
                var i = r.a;
                return b(m(e, {
                    bU: Ut,
                    aM: Ut,
                    aP: !1
                }), y8(i));
            case 3:
                var c = r.a, o = n.Cm(c);
                return o.$ ? b(m(e, {
                    aM: Vt(c),
                    aP: !0
                }), k8) : b(m(e, {
                    bU: Vt(i = o.a),
                    aM: Vt(c),
                    aP: !0
                }), y8(i));
            case 4:
                if (u) return b(e, k8);
                var f = function() {
                    var r = e.aM;
                    if (1 === r.$) return x8(w8);
                    if ("" === r.a) return x8(w8);
                    var t = n.Cm(r.a);
                    if (t.$) return x8(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(t.a));
                    var u = t.a;
                    return n.AC(u) ? x8(function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(u)) : y8(u);
                }();
                return b(m(e, {
                    bU: 2 === f.$ ? Vt(f.a) : e.bU,
                    aM: 2 === f.$ ? Ut : e.aM
                }), f);
            case 5:
                return b(m(e, {
                    bV: !1,
                    aP: !0
                }), k8);
            case 6:
                return b(m(e, {
                    aP: u
                }), k8);
            case 7:
                return b(m(e, {
                    bV: !0
                }), k8);
            case 8:
                return b(m(e, {
                    bV: !1
                }), k8);
            default:
                return b(27 === r.a ? m(e, {
                    aP: !1
                }) : e, k8);
        }
    }), C8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    g8: Vt(t)
                });
                return r.km ? v(m(e, {
                    oY: Vt(t)
                }), Pp, Vt(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(t))) : v(e, Pp, Ut);
            case 1:
                var u = n.a, a = A3(_8, g8(r.AC), u, r.bQ), i = a.a, c = a.b, o = function() {
                    switch(c.$){
                        case 2:
                            return Vt(c.a);
                        case 1:
                            return 2 === c.a.$ ? Vt(c.a.a) : Ut;
                        default:
                            return r.oY;
                    }
                }();
                return v(m(r, {
                    oY: o,
                    bQ: i
                }), Pp, A2(d8, r, o));
            case 2:
                return v(r, Pp, Vt(l8));
            default:
                return v(r, Pp, Ut);
        }
    }), B8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, E8 = F2(function(n, r) {
        var t = r;
        if (n.$) {
            var e = A2(ZD, n.a, t.fD), u = e.a, a = e.b, i = e.c;
            if (i.$ || i.a.$ || i.a.a.$) return v(m(t, {
                fD: u
            }), A2(Lp, B8, a), Ut);
            var c = i.a.a.a;
            return v(m(t, {
                rE: !1,
                fD: u
            }), A2(Lp, B8, a), Vt(c));
        }
        return v(m(t, {
            rE: !0
        }), Pp, Ut);
    }), D8 = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return v((e = n.a).$ ? r : m(t, {
                    jH: e.a.jT.xP
                }), Pp, Ut);
            case 1:
                return v((e = n.a).$ ? r : m(t, {
                    jG: (u = e.a.ku).xP
                }), Pp, Ut);
            case 0:
                var e, u;
                return (e = n.a).$ ? v(r, Pp, Ut) : v(m(t, {
                    jN: (u = e.a.ku).xP,
                    jO: u.ce
                }), Pp, Vt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(t.c2)));
            case 3:
                var a = n.a, i = a.a, c = a.b.d$;
                return v(m(t, {
                    c2: c(i)
                }), A2(w4, t.rh, c(i)), Vt(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(i)));
            default:
                return v(r, Pp, Ut);
        }
    }), q8 = F3(function(n, r, t) {
        return t.$ ? h : x([
            b(n, r(t.a))
        ]);
    }), P8 = function(n) {
        var r = n;
        return _x(A2(Yt, b("id", Ax(r.fM)), A2(Yt, b("type", Ax(r.eS ? "package" : "plan")), A2(Yt, b("name", Ax(r.tg)), $(A3(q8, "owner", Ax, r.tU), $(A3(q8, "period_in_months", EX, r.Cz), A3(q8, "start_date", Ax, r.DN)))))));
    }, z8 = F4(function(n, r, t, e) {
        var u = _x(x([
            b("items", A2(KK, P8, t))
        ]));
        return A4(dC, n, fZ, e, A2(vL, u, rA(A2(X_, x([
            "cart"
        ]), lL(r)))));
    }), j8 = F2(function(n, r) {
        return m(r, {
            oY: Vt(n)
        });
    }), S8 = F2(function(n, r) {
        return m(r, {
            AC: n
        });
    }), L8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch((e = n.a).$){
                    case 3:
                        var t = e.a;
                        return v(m(r, {
                            bf: e
                        }), A2(X4, r.d9, t), h);
                    case 2:
                        switch(e.a.$){
                            case 9:
                            case 6:
                                return v(m(r, {
                                    bf: e
                                }), Pp, h);
                            default:
                                return v(m(r, {
                                    bf: e
                                }), Pp, A2(xA, 0, e));
                        }
                    default:
                        return v(m(r, {
                            bf: e
                        }), Pp, h);
                }
            case 1:
                var e = n.a, u = function() {
                    if (2 !== e.$) return h;
                    switch(e.a.$){
                        case 9:
                        case 6:
                            return h;
                        default:
                            return A2(xA, 0, e);
                    }
                }();
                return v(function(n) {
                    var r = n.W;
                    if (r.$ || 1 !== r.a.b.$) return n;
                    var t = r.a, e = t.b.a;
                    return 1 === e.cP.$ ? m(n, {
                        W: Vt(b(t.a, V4(m(e, {
                            cP: e8(n)
                        }))))
                    }) : n;
                }(m(r, {
                    A8: e
                })), Pp, u);
            case 2:
                return 3 === (e = n.a).$ ? v(m(r, {
                    aW: (a = e.a).rL
                }), Pp, x([
                    vZ(a.rL)
                ])) : v(r, Pp, h);
            case 3:
                var a;
                return 3 === (e = n.a).$ ? v(m(r, {
                    aW: (a = e.a).rL,
                    dp: r.dA,
                    dA: Ut
                }), A2(Nu, function() {
                    return U4;
                }, jp(5e3)), x([
                    vZ(a.rL)
                ])) : v(m(r, {
                    dA: Ut
                }), Pp, A2(xA, 0, e));
            case 4:
                var i = A2(D8, n.a, r.d_), c = i.a, o = i.b, f = i.c;
                return v(m(r, f.$ || f.a.$ ? {
                    d_: c
                } : {
                    d9: f.a.a,
                    d_: c
                }), A2(Lp, b4, o), h);
            case 5:
                var s = n.a;
                return v(m(r, {
                    e7: NM(r.e7),
                    W: Vt(b(s, O4))
                }), Pp, h);
            case 6:
                if (s = n.a, f8(r.dB)) {
                    var l = {
                        cP: e8(r),
                        fG: a8(s)
                    }, d = E4("configure-start-date"), p = d.b, g = m(d.a, {
                        km: !0
                    });
                    return v(m(r, {
                        co: g,
                        ds: p4,
                        W: Vt(b(s, V4(l)))
                    }), A2(Lp, f4, p), h);
                }
                var w = s8(s);
                return v(m(r, {
                    e7: WL(r.e7),
                    W: Ut
                }), A2(AA, da, 1 === w ? Za({
                    rh: i8(s)
                }) : Qa({
                    rh: i8(s)
                })), h);
            case 7:
                var k = n.a, y = r.W;
                if (y.$ || 1 !== y.a.b.$) return v(r, Pp, h);
                var _ = y.a;
                return v(m(r, {
                    W: Vt(b(s = _.a, V4(m(B = _.b.a, {
                        fG: Vt(k)
                    }))))
                }), Pp, h);
            case 8:
                var A = r.W;
                if (A.$ || 1 !== A.a.b.$) return v(r, Pp, h);
                var C = A.a, B = C.b.a, E = A2(sc, "", o8(s = C.a)), D = (I = {
                    eS: s8(s),
                    tg: E,
                    tU: A2(Fp, uU, B.cP),
                    Cz: A2(Fp, EV, B.fG),
                    fM: i8(s),
                    DN: s8(s) ? Ut : A2(Fp, FP, r.co.oY)
                }, {
                    yz: Ut,
                    eS: I.eS,
                    tg: I.tg,
                    tU: I.tU,
                    Cz: I.Cz,
                    lj: 0,
                    ln: 0,
                    lp: 0,
                    fM: I.fM,
                    DN: I.DN,
                    lI: 0
                });
                return v(m(r, {
                    e7: WL(r.e7),
                    dA: Vt(E),
                    W: Ut
                }), A4(z8, r.gF, Bx(r.dB), $(r.aW, x([
                    D
                ])), Y4), h);
            case 9:
                return v(m(r, {
                    dp: Ut
                }), Pp, h);
            case 10:
                return v(m(r, {
                    dp: Ut
                }), A2(AA, da, wa), h);
            case 11:
                var q = A2(E8, n.a, r.ds), F = q.b, P = q.c, z = m(r, {
                    ds: q.a
                });
                return v(function() {
                    var n = b(P, r.W);
                    if (n.a.$ || n.b.$ || 1 !== n.b.a.b.$) return z;
                    var t = n.b.a;
                    return m(z, {
                        W: Vt(b(t.a, V4(m(t.b.a, {
                            cP: Vt(n.a.a)
                        }))))
                    });
                }(), A2(Lp, Q4, F), h);
            case 12:
                return v(m(r, {
                    e7: WL(r.e7),
                    W: Ut
                }), Pp, h);
            case 13:
                var j = A2(lN, n.a, r.e7), S = j.b;
                return v(m(r, {
                    e7: j.a
                }), A2(Lp, R4, S), h);
            case 14:
                return v(r, Pp, h);
            default:
                var L = A2(C8, n.a, r.co), M = L.a, N = L.b, H = L.c, T = function() {
                    if (H.$ || 2 !== H.a.$) return M;
                    var n = H.a.a;
                    return A2(S8, c8(n), A2(j8, n, M));
                }();
                return v(m(r, {
                    co: T
                }), A2(Lp, f4, N), h);
        }
        var I;
    }), M8 = function(n) {
        var r = n.bf;
        if (3 === r.$) {
            var t = r.a;
            return A2(jE, function(n) {
                return !s8(n);
            }, t) && A2(jE, function(n) {
                return 1 === s8(n);
            }, t);
        }
        return !1;
    }, N8 = {
        $: 10
    }, H8 = {
        ma: function(n) {
            return n.C.ma;
        },
        md: function(n) {
            return n.C.md;
        },
        mt: function(n) {
            return n.C.mt;
        },
        m5: function(n) {
            return n.C.m5;
        },
        yO: function(n) {
            return n.C.yO;
        },
        n8: function(n) {
            return n.C.n8;
        },
        n9: function(n) {
            return n.C.n9;
        },
        oc: function(n) {
            return n.C.oc;
        },
        hn: function(n) {
            return n.C.hn;
        },
        dg: function(n) {
            return n.C.dg;
        },
        A4: function(n) {
            return n.C.A4;
        },
        A7: function(n) {
            return n.C.A7;
        },
        dt: function(n) {
            return n.C.dt;
        },
        aa: function(n) {
            return n.C.aa;
        },
        ij: function(n) {
            return n.C.ij;
        },
        CR: function(n) {
            return n.C.CR;
        },
        xE: function(n) {
            return n.C.xE;
        },
        EE: function(n) {
            return n.C.EE;
        }
    }, T8 = F2(function(n, r) {
        var t = r.dp;
        if (t.$) return tB;
        var e = t.a;
        return A2(nk, x([
            Xx("cart-banner")
        ]), x([
            A2(ak, h, x([
                ld(e + " " + n(H8.md))
            ])),
            A2(PC, x([
                Xx("cart-banner__action"),
                IC(N8)
            ]), x([
                ld(n(H8.xE))
            ]))
        ]));
    }), I8 = function(n) {
        return n.pe;
    }, R8 = function(n) {
        return n.w3;
    }, Z8 = function(n) {
        return i(R8(n), Ut) && i(I8(n), Ut);
    }, V8 = function(n) {
        return Z8(n) ? "catalog-grid__item catalog-grid__item--compact" : "catalog-grid__item";
    }, U8 = F2(function(n, r) {
        switch(n){
            case 0:
                return r;
            case 1:
                return A2(Rc, function(n) {
                    return !s8(n);
                }, r);
            default:
                return A2(Rc, function(n) {
                    return 1 === s8(n);
                }, r);
        }
    }), Y8 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Q8 = function(n) {
        return n.o9;
    }, O8 = function(n) {
        switch(n){
            case 1:
                return Vt(0);
            case 3:
                return Vt(1);
            case 6:
                return Vt(2);
            case 12:
                return Vt(3);
            default:
                return Ut;
        }
    }, G8 = F2(function(n, r) {
        return A2(sc, n(wV), A2(Fp, yV(n), A2(nv, O8, r)));
    }), J8 = function(n) {
        return n.li;
    }, W8 = F2(function(n, r) {
        var t = J8(r);
        if (t.$) return n(H8.oc);
        var e = A3(sV, !1, !0, t.a);
        return s8(r) ? e : $(e, A2(G8, n, Q8(r)));
    }), K8 = cr("strong"), X8 = F2(function(n, r) {
        return A2(K8, _k(n), A2(Eu, Ck(yu), r));
    }), n5 = F2(function(n, r) {
        var t, e = function() {
            var n = o8(r);
            if (n.$) return tB;
            var t = n.a;
            return A2(X8, x([
                ok(x([
                    Xx("block text-current")
                ]))
            ]), x([
                ld(t)
            ]));
        }(), u = function() {
            var n = I8(r);
            if (n.$) return tB;
            var t = n.a;
            return A2(nk, x([
                Xx("catalog-card__description rich-text")
            ]), A2(Eu, Ck(yu), BG(t)));
        }(), a = !i(R8(r), Ut), c = Z8(r) ? " catalog-card--compact" : "", o = a ? "" : " catalog-card--no-image";
        return A2(nk, x([
            IC(Y8(r)),
            Xx("catalog-card block rounded-lg border border-primary-200 bg-white p-4 hover:bg-gray-50 sm:p-0 sm:overflow-hidden cursor-pointer h-full" + (o + c))
        ]), x([
            A2(nk, x([
                Xx("catalog-card__content flex gap-4 items-start sm:flex-col sm:gap-0")
            ]), x([
                (t = R8(r), t.$ ? tB : A2(k3, x([
                    zG(t.a),
                    x3(""),
                    Xx("w-24 h-24 object-cover rounded flex-shrink-0 order-1 sm:order-none sm:w-full sm:h-32 sm:rounded-none")
                ]), h)),
                A2(nk, x([
                    Xx("catalog-card__body flex-1 min-w-0 sm:p-4 order-0 sm:order-none")
                ]), x([
                    e,
                    A2(FI, x([
                        fq,
                        $H,
                        yF,
                        ok(x([
                            Xx("block mt-1")
                        ]))
                    ]), x([
                        ld(A2(W8, n, r))
                    ])),
                    u
                ])),
                A2(Ck, yu, A2(PE, x([
                    ej,
                    MB("flex-shrink-0 text-gray-400 self-center order-2 sm:hidden")
                ]), 6))
            ]))
        ]));
    }), r5 = function(n) {
        return x([
            A2(Ek, x([
                _H(cR),
                $H
            ]), x([
                ld(n)
            ]))
        ]);
    }, t5 = F2(function(n, r) {
        var t = r.bf;
        switch(t.$){
            case 1:
                return A2(nk, h, ck);
            case 3:
                var e = A2(U8, r.d9, t.a);
                return TE(e) ? A2(nk, x([
                    Xx("py-12 text-center")
                ]), r5(n(H8.EE))) : A2(pT, x([
                    Xx("catalog-grid")
                ]), A2(Eu, function(r) {
                    return A2(hT, x([
                        Xx(V8(r))
                    ]), x([
                        A2(n5, n, r)
                    ]));
                }, e));
            default:
                return tB;
        }
    }), e5 = {
        $: 8
    }, u5 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, a5 = F2(function(n, r) {
        return n(s8(r) ? H8.CR : H8.hn);
    }), i5 = {
        $: 3
    }, c5 = F2(function(n, r) {
        return n(s8(r) ? H8.n9 : H8.n8);
    }), o5 = {
        $: 0
    }, f5 = DC(2), s5 = F2(function(n, r) {
        if (n.$) return n8(r);
        var t = n.a;
        return i(uU(r), t);
    }), l5 = function(n) {
        return n.st;
    }, d5 = F3(function(n, r, t) {
        var e = A2(s5, r, t) ? H8.A7 : l5;
        return A2(FI, x([
            EZ,
            J9,
            yF,
            ok(x([
                Xx("block")
            ]))
        ]), x([
            ld(n(e))
        ]));
    }), b5 = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, v5 = F2(function(n, r) {
        return A2(nk, h, x([
            A2(FI, x([
                fq,
                J9,
                yF,
                ok(x([
                    Xx("block mb-2")
                ]))
            ]), x([
                ld(n.xl(H8.A4))
            ])),
            A2(Ck, B8, A4(sF, n.xl, x([
                Dq(n.iQ),
                vq,
                b5(!0)
            ]), A2(Eu, hq(h), n.A8), r))
        ]));
    }), m5 = F2(function(n, r) {
        return r.rE ? A2(v5, n, r.fD) : function(n) {
            var r = be(n.A8) > 1, t = n.iQ;
            if (1 === t.$) return ld("");
            var e = t.a;
            return A2(nk, x([
                Xx("flex items-center justify-between gap-2")
            ]), x([
                A2(nk, x([
                    Xx("flex items-center gap-2 min-w-0")
                ]), x([
                    A2(Ck, yu, A2(PE, x([
                        ej,
                        MB("flex-shrink-0 text-primary-500")
                    ]), 37)),
                    A2(nk, x([
                        Xx("min-w-0")
                    ]), x([
                        A2(FI, x([
                            fq,
                            O0,
                            ok(x([
                                Xx("block text-current truncate")
                            ]))
                        ]), x([
                            QE(aU(e))
                        ])),
                        A3(d5, n.xl, n.Eu, e)
                    ]))
                ])),
                r ? A2(OC, x([
                    f5,
                    EC(o5)
                ]), x([
                    ld(n.xl(H8.yO))
                ])) : ld("")
            ]));
        }(n);
    }), p5 = F2(function(n, r) {
        return $(A3(sV, !1, !0, A2(sc, r.lM, r.ln)), A2(yV, n, r.uv));
    }), $5 = {
        $: 4
    }, h5 = cr("fieldset"), g5 = function(n) {
        return 2 === n.$ ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(Ie(n.a)) : n;
    }, w5 = {
        gX: Ut,
        il: Ut,
        xz: Ut
    }, x5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, k5 = F2(function(n, r) {
        return function(n) {
            var r = n.gX;
            if (r.$) {
                var t = b(n.xz, n.il);
                return t.a.$ || t.b.$ ? h : x([
                    x5((0, t.b.a)(t.a.a))
                ]);
            }
            return x([
                x5(r.a)
            ]);
        }(A3(de, F2(function(n, r) {
            switch(n.$){
                case 2:
                    return m(r, {
                        xz: Vt(n.a)
                    });
                case 3:
                    return m(r, {
                        gX: Vt(n.a)
                    });
                case 6:
                    return m(r, {
                        il: Vt(n.a)
                    });
                default:
                    return r;
            }
        }), r, n));
    }), y5 = function(n) {
        switch(n.$){
            case 2:
                return x([
                    Iq(n.a)
                ]);
            case 0:
                return x([
                    NC(n.a)
                ]);
            case 1:
                return x([
                    oT(n.a)
                ]);
            case 3:
                return x([
                    jT(n.a)
                ]);
            case 4:
            case 7:
            case 6:
            case 5:
            default:
                return h;
            case 8:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
        }
    }, _5 = function(n) {
        switch(n.$){
            case 2:
            case 1:
            case 6:
            default:
                return h;
            case 0:
                return x([
                    SC(x([
                        b("radio--disabled", n.a)
                    ]))
                ]);
            case 3:
                return x([
                    SC(x([
                        b("radio--checked", n.a)
                    ]))
                ]);
            case 7:
                var r = n.a;
                return A2(Eu, ek(yu), r);
            case 4:
                return x([
                    Xx("radio--card")
                ]);
            case 5:
                return x([
                    Xx("radio--icon-hidden")
                ]);
            case 8:
                return x([
                    A2(jC, "data-test", n.a)
                ]);
        }
    }, C5 = F2(function(n, r) {
        var t = A2(k5, n, w5);
        return A2(Tq, A2(Yt, Xx("flex items-center radio"), A2(tc, _5, $(t, n))), x([
            A2(Zq, A2(Yt, Vq("radio"), A2(Yt, Xx("radio__input"), A2(tc, y5, $(n, t)))), h),
            A2(ak, x([
                Xx("radio__icon flex-none")
            ]), h),
            A2(nk, x([
                Xx("radio__text flex-auto")
            ]), A2(Eu, Ck(yu), r))
        ]));
    }), B5 = F2(function(n, r) {
        var t = A2(Eu, g5, A2(Rc, function(n) {
            return 9 !== n.$;
        }, n)), e = A2(jE, function(n) {
            return 9 === n.$;
        }, n);
        return A2(h5, x([
            SC(x([
                b("radio-group", !0),
                b("radio-group--spaced", e),
                b("radio-group--cards-" + oe(be(r)), e)
            ]))
        ]), A2(Eu, function(n) {
            var r = n.b;
            return A2(C5, $(n.a, t), r);
        }, r));
    }), E5 = F2(function(n, r) {
        return b(n, r);
    }), D5 = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, q5 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, P5 = {
        $: 14
    }, z5 = function(n) {
        return A2(sc, P5, A2(Fp, q5, XR(n)));
    }, j5 = {
        $: 9
    }, S5 = function(n) {
        return n.yz.mC;
    }, L5 = function(n) {
        return n.yz.tf;
    }, M5 = function(n) {
        return n.yz.vj;
    }, N5 = function(n) {
        return n.yz.v9;
    }, H5 = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return L5;
                case 1:
                    return M5;
                case 2:
                    return N5;
                default:
                    return S5;
            }
        }());
    }), T5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, I5 = F3(function(n, r, t) {
        var e = u8(r);
        if (e.b) {
            var u = e;
            return A2(nk, h, x([
                A2(FI, x([
                    fq,
                    J9,
                    yF,
                    ok(x([
                        Xx("block mb-2")
                    ]))
                ]), x([
                    ld(n(H8.m5))
                ])),
                A2(B5, x([
                    T5(A2(sc, "", A2(Fp, qV, t.fG))),
                    D5(z5),
                    j5
                ]), A2(Eu, function(r) {
                    return A2(E5, x([
                        $5,
                        T5(qV(r.uv))
                    ]), x([
                        A2(X8, x([
                            ok(x([
                                Xx("block text-current")
                            ]))
                        ]), x([
                            ld(A2(H5, n, r.uv))
                        ])),
                        A2(FI, x([
                            fq,
                            yF,
                            ok(x([
                                Xx("block mt-1")
                            ]))
                        ]), x([
                            ld(A2(p5, n, r))
                        ]))
                    ]));
                }, u))
            ]));
        }
        return tB;
    }), R5 = {
        $: 3
    }, Z5 = {
        $: 2
    }, V5 = {
        zn: !1
    }, U5 = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), Y5 = {
        $: 6
    }, Q5 = {
        $: 5
    }, O5 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, G5 = {
        $: 4
    }, J5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, W5 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, K5 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, X5 = {
        $: 7
    }, n7 = {
        $: 8
    }, r7 = F2(function(n, r) {
        var t = pu(r);
        return t.$ ? n : A3(dp, t.a, Nv(n), Mv(n));
    }), t7 = F2(function(n, r) {
        return r.$ ? n : r;
    }), e7 = F2(function(n, r) {
        return Xx($(n.ev, r));
    }), u7 = F2(function(n, r) {
        var t = A2(wj, n, r);
        return t.b ? A2(Yt, t, A2(u7, n, A2(Np, n, r))) : h;
    }), a7 = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), i7 = F2(function(n, r) {
        var t = n.ev;
        return SC(A2(Eu, function(n) {
            var r = n.b;
            return b($(t, n.a), r);
        }, r));
    }), c7 = F3(function(n, r, t) {
        var e = Pv(n), u = Mv(n);
        return A2(u9, x([
            A2(i7, r, x([
                b("day", !0)
            ])),
            IC(A2(a7, A3(dp, e, t, u), 0))
        ]), x([
            r.ka(r.kX(t))
        ]));
    }), o7 = F2(function(n, r) {
        var t = x([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ]);
        return A2(Eu, function(t) {
            return A2(X3, h, A2(Eu, A2(c7, n, r), t));
        }, A2(u7, 3, t));
    }), f7 = cr("option"), s7 = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(oj, t, A3(dp, Pv(n), Nv(n), 1)), u = A3(dp, Pv(n), Nv(n), 1);
        return {
            oQ: A4(dj, 11, 1, e, A2(sj, t, A3(rj, 1, 1, u))),
            oS: n
        };
    }), l7 = MC("selected"), d7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, b7 = F5(function(n, r, t, e, u) {
        var a = n.AC(u), i = a ? h : x([
            IC(d7(u))
        ]), c = i7(n);
        return A2(u9, A2(Yt, c(x([
            b("day", !0),
            b("disabled", a),
            b("picked", r(u)),
            b("today", e(u)),
            b("other-month", t(u))
        ])), i), x([
            n.ka(oe(Mv(u)))
        ]));
    }), v7 = F3(function(n, r, t) {
        var e = Nv(n), u = Mv(n);
        return A2(u9, x([
            A2(i7, r, x([
                b("day", !0)
            ])),
            IC(A2(a7, A3(dp, t, e, u), 1))
        ]), x([
            r.ka(r.xR(t))
        ]));
    }), m7 = F2(function(n, r) {
        var t = Pv(n);
        return A2(Eu, function(t) {
            return A2(X3, h, A2(Eu, A2(v7, n, r), t));
        }, A2(u7, 3, A2($e, t - 1, t + 10)));
    }), p7 = F2(function(n, r) {
        var t = n.oS, e = n.xb;
        switch(r.$){
            case 1:
                var u = r.a;
                return A2($e, Pv(t) - u, Pv(t) + u);
            case 2:
                return A2($e, r.a, r.b);
            case 3:
                return A2($e, a = r.a, Pv(e));
            case 4:
                var a = r.a;
                return A2($e, Pv(e), a);
            default:
                return h;
        }
    }), $7 = function(n) {
        return !i(n, b8);
    }, h7 = F3(function(n, r, t) {
        var e, u, a, c = t.bU, o = t.xb, f = t.fj, s = function(r) {
            return A2(sc, !1, A2(Fp, function(n) {
                return i(n, r);
            }, n));
        }, l = function(n) {
            return i(n, o);
        }, d = aj(r.hx) - 1, v = e7(r), m = A2(sc, o, A2(t7, n, c)), p = function(n) {
            return !i(Nv(m), Nv(n));
        }, $ = F2(function(n, r) {
            return A2(PC, x([
                v(n),
                IC(r),
                pj(-1),
                Vq("button")
            ]), h);
        }), g = A2(s7, m, r.hx), w = g.oS, k = A2(Eu, function(n) {
            return A2(X3, x([
                v("row")
            ]), A2(Eu, A4(b7, r, s, p, l), n));
        }, (e = g.oQ, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return Ae(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Yt, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = h, f = A2(Yt, Ae(A2(Yt, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, h, h))), y = function(n) {
            return i(Pv(w), n);
        }, _ = F2(function(n, r) {
            return b(oe(n), A2(f7, x([
                Iq(oe(r)),
                l7(y(r))
            ]), x([
                ld(oe(r))
            ])));
        }), A = function() {
            var n = function(n) {
                return A2($e, Pv(w), n);
            }, t = function(n) {
                return A2($e, n, Pv(w));
            }, e = r.nu;
            switch(e.$){
                case 3:
                    return b(n(e.a - 1), t(Pv(o) + 1));
                case 4:
                    var u = e.a;
                    return b(n(Pv(o) - 1), t(u + 1));
                case 2:
                    return u = e.b, b(n(e.a - 1), t(u + 1));
                default:
                    return b(h, h);
            }
        }(), C = A.a, B = A.b, E = A3(Kq, "select", x([
            (a = A2(ru, r7(m), W5), A2(TC, "change", A2(tu, a, cT))),
            v("year-menu")
        ]), A2(he, _, rc(x([
            C,
            A2(p7, {
                oS: w,
                xb: o
            }, r.nu),
            B
        ]))));
        return A2(nk, x([
            v("picker"),
            A2(iT, "mousedown", uu(b(X5, !0))),
            A2(iT, "mouseup", uu(b(n7, !0)))
        ]), function() {
            switch(f){
                case 0:
                    return x([
                        A2(nk, x([
                            v("picker-header")
                        ]), x([
                            A2(nk, x([
                                v("prev-container")
                            ]), x([
                                A2($, "prev", W5(A3(rj, 1, -1, m)))
                            ])),
                            A2(nk, x([
                                v("month-container")
                            ]), x([
                                A2(PC, x([
                                    v("month"),
                                    Vq("button"),
                                    IC(K5(1))
                                ]), x([
                                    ld(r.kX(Nv(w)))
                                ])),
                                A2(PC, x([
                                    v("year"),
                                    Vq("button"),
                                    IC(K5(2))
                                ]), x([
                                    $7(r.nu) ? A3(Kq, "span", h, x([
                                        b(oe(Pv(w)), E)
                                    ])) : ld(r.xR(Pv(w)))
                                ]))
                            ])),
                            A2(nk, x([
                                v("next-container")
                            ]), x([
                                A2($, "next", W5(A3(rj, 1, 1, m)))
                            ]))
                        ])),
                        A2(J3, x([
                            v("table")
                        ]), x([
                            A2(K3, x([
                                v("weekdays")
                            ]), x([
                                A2(X3, h, A2(Eu, function(n) {
                                    return A2(u9, x([
                                        v("dow")
                                    ]), x([
                                        ld(r.zh(n))
                                    ]));
                                }, A2(wj, 7, A2(Np, d, rc(A2(mj, 2, x([
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ])))))))
                            ])),
                            A2(W3, x([
                                v("days")
                            ]), k)
                        ]))
                    ]);
                case 1:
                    return x([
                        A2(nk, x([
                            v("picker-header")
                        ]), x([
                            A2(nk, x([
                                v("prev-container")
                            ]), x([
                                A2($, "prev", W5(A3(rj, 0, -1, m)))
                            ])),
                            A2(nk, x([
                                v("month-container")
                            ]), x([
                                A2(PC, x([
                                    v("year"),
                                    Vq("button"),
                                    IC(K5(2))
                                ]), x([
                                    $7(r.nu) ? A3(Kq, "span", h, x([
                                        b(oe(Pv(w)), E)
                                    ])) : ld(r.xR(Pv(w)))
                                ]))
                            ])),
                            A2(nk, x([
                                v("next-container")
                            ]), x([
                                A2($, "next", W5(A3(rj, 0, 1, m)))
                            ]))
                        ])),
                        A2(J3, x([
                            v("table")
                        ]), x([
                            A2(W3, x([
                                v("months")
                            ]), A2(o7, m, r))
                        ]))
                    ]);
                default:
                    return x([
                        A2(nk, x([
                            v("picker-header")
                        ]), x([
                            A2(nk, x([
                                v("prev-container")
                            ]), x([
                                A2($, "prev", W5(A3(rj, 0, -12, m)))
                            ])),
                            A2(nk, x([
                                v("month-container")
                            ]), x([
                                A2(ak, x([
                                    v("year")
                                ]), x([
                                    $7(r.nu) ? A3(Kq, "span", h, x([
                                        b(oe(Pv(w)), E)
                                    ])) : ld(r.xR(Pv(w)))
                                ]))
                            ])),
                            A2(nk, x([
                                v("next-container")
                            ]), x([
                                A2($, "next", W5(A3(rj, 0, 12, m)))
                            ]))
                        ])),
                        A2(J3, x([
                            v("table")
                        ]), x([
                            A2(W3, x([
                                v("years")
                            ]), A2(m7, m, r))
                        ]))
                    ]);
            }
        }());
    }), g7 = F3(function(n, r, t) {
        var e, u = t, a = A3(ru, VZ, Tp(iu), A2(Fp, Hq, r.kF)), i = A2(Yt, b(r.ev + "input", !0), r.Au), c = (e = x([
            fT(r.CB),
            Iq(A2(sc, A2(sc, "", A2(Fp, r.ze, n)), u.aM))
        ]), A2(Zq, $(x([
            SC(i),
            Yq(A2(sc, "", r.kG)),
            Vq("text"),
            A2(TC, "change", uu(G5)),
            oT(J5),
            eT(Y5),
            IC(Q5),
            uT(Q5),
            A2(TC, "keydown", A2(tu, O5, RC))
        ]), $(r.At, $(a, e))), h)), o = A2(Yt, b(r.ev + "container", !0), r.kf);
        return A2(nk, x([
            SC(o)
        ]), x([
            c,
            u.aP ? A3(h7, n, r, u) : ld("")
        ]));
    }), w7 = F2(function(n, r) {
        return A3(de, U5, V5, n).zn ? function(n) {
            var r = g8(n.AC), t = function() {
                var r = n.oY;
                if (r.$) return "";
                var t = r.a;
                return A2(NL, aS("/"), t);
            }();
            return A2(nk, h, x([
                vI(x([
                    xI(t),
                    YT(!0),
                    iI(r.CB)
                ]))
            ]));
        }(r) : A2(nk, x([
            IC(Z5),
            Hq(r.rh),
            pj(0),
            A2(YC, R5, r.rh)
        ]), x([
            A2(Ck, k4, A3(g7, r.oY, g8(r.AC), r.bQ))
        ]));
    }), x7 = F2(function(n, r) {
        return A2(FI, x([
            fq,
            J9,
            yF,
            ok(x([
                Xx("block mb-2")
            ]))
        ]), x([
            ld(n(r))
        ]));
    }), k7 = F2(function(n, r) {
        return A2(nk, h, x([
            A2(x7, n, H8.dt),
            A2(nk, x([
                Xx("input-group")
            ]), x([
                A2(ak, x([
                    Xx("input-addon"),
                    A2(bT, "border-right-width", "1px")
                ]), x([
                    A2(Ck, yu, A2(PE, x([
                        HB
                    ]), 27))
                ])),
                A2(nk, x([
                    Xx("flex-1")
                ]), x([
                    A2(Ck, f4, A2(w7, h, r))
                ]))
            ]))
        ]));
    }), y7 = F5(function(n, r, t, e, u) {
        return x([
            A2(X8, x([
                ok(x([
                    Xx("block text-current")
                ]))
            ]), x([
                ld(A2(c5, n, r))
            ])),
            A2(FI, x([
                fq,
                J9,
                yF,
                ok(x([
                    Xx("block mt-1")
                ]))
            ]), x([
                ld(A2(sc, "", o8(r)))
            ])),
            A2(nk, x([
                Xx("mt-6 pb-80")
            ]), x([
                function() {
                    var r = r8(u);
                    if (r.$) return tB;
                    var t = r.a;
                    return A2(nk, x([
                        Xx("mb-6")
                    ]), x([
                        A2(Ck, Q4, A2(m5, {
                            A8: t,
                            iQ: e.cP,
                            xl: n,
                            Eu: u.Eu
                        }, u.ds))
                    ]));
                }(),
                s8(r) ? tB : A2(k7, n, t),
                A2(nk, x([
                    Xx("mt-6")
                ]), x([
                    A3(I5, n, r, e)
                ]))
            ]))
        ]);
    }), _7 = function(n) {
        var r = b(s8(n), function(n) {
            return n.ql;
        }(n));
        if (1 !== r.a || r.b.$) return tB;
        var t = r.b.a;
        return A2(FI, x([
            fq,
            $H,
            yF,
            ok(x([
                Xx("block mt-1")
            ]))
        ]), x([
            ld(t)
        ]));
    }, C7 = F2(function(n, r) {
        var t, e = J8(r).$ ? fq : lk;
        return x([
            A2(nk, x([
                Xx("-mx-8 -mt-8 mb-4 relative")
            ]), x([
                (t = function(n) {
                    return n.oC;
                }(r), t.$ ? tB : A2(k3, x([
                    zG(t.a),
                    x3(""),
                    Xx("w-full object-cover rounded-t-md")
                ]), h))
            ])),
            function() {
                var n = o8(r);
                if (n.$) return tB;
                var t = n.a;
                return A2(X8, x([
                    ok(x([
                        Xx("block text-current")
                    ]))
                ]), x([
                    ld(t)
                ]));
            }(),
            A2(FI, x([
                e,
                J9,
                yF,
                ok(x([
                    Xx("block mt-1")
                ]))
            ]), x([
                ld(A2(W8, n, r))
            ])),
            _7(r),
            function() {
                var n = I8(r);
                if (n.$) return tB;
                var t = n.a;
                return A2(nk, x([
                    Xx("mt-4 text-sm rich-text")
                ]), A2(Eu, Ck(yu), BG(t)));
            }()
        ]);
    }), B7 = F2(function(n, r) {
        var t = r.W;
        if (t.$) return tB;
        if (t.a.b.$) {
            var e = t.a;
            return A2(QI, x([
                i5,
                q3,
                EI(A5(y7, n, u = e.a, r.co, e.b.a, r)),
                DI(x([
                    A2(OC, x([
                        qC,
                        CZ,
                        EC(e5)
                    ]), x([
                        ld(n(H8.ma))
                    ]))
                ]))
            ]), r.e7);
        }
        var u = t.a.a, a = f8(r.dB) ? n(H8.ma) : A2(a5, n, u), i = !aF(J8(u));
        return A2(QI, x([
            i5,
            q3,
            EI(A2(C7, n, u)),
            DI(x([
                A2(OC, x([
                    qC,
                    CZ,
                    EC(u5(u)),
                    uF(i)
                ]), x([
                    ld(a)
                ]))
            ]))
        ]), r.e7);
    }), E7 = F2(function(n, r) {
        switch(r){
            case 0:
                return n(H8.mt);
            case 1:
                return n(H8.aa);
            default:
                return n(H8.ij);
        }
    }), D7 = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Ut;
            var e = t.b;
            if (r(t.a)) return Vt(n);
            n += 1, t = e;
        }
    }), q7 = D7(0), P7 = {
        $: 4
    }, z7 = F5(function(n, r, t, e, u) {
        var a, c = u.a, o = u.b.d1, f = n + "-" + (0, u.b.d$)(c), l = 1 !== (a = b(t, 0 > s(e, r))).a || a.b ? G4(u) : P7;
        return (i(e, r) ? PC(x([
            Hq(f),
            Xx("tabs__item tabs__item--active")
        ])) : PC(x([
            IC(l),
            Hq(f),
            Xx("tabs__item"),
            SC(x([
                b("tabs__item--previous", !i(l, P7))
            ]))
        ])))(x([
            A2(Ck, yu, o(c))
        ]));
    }), j7 = F2(function(n, r) {
        var t = n.rh, e = n.jO, u = n.c2, a = n.h6, c = "translateX(" + OZ(n.jN - n.jG + n.jH) + "px) scaleX(" + OZ(e) + ")", o = A2(sc, -1, A2(q7, function(n) {
            return i((0, n.b.d$)(n.a), u);
        }, r));
        return A2(nk, x([
            Hq(t),
            Xx("tabs"),
            SC(x([
                b("tabs--interactive", !a)
            ]))
        ]), A2(Yt, A2(ak, x([
            A2(bT, "transform", c),
            Xx("tabs__underline")
        ]), h), A2(he, A3(z7, t, o, a), r)));
    }), S7 = F2(function(n, r) {
        var t = x([
            A2(K4, 0, {
                d$: N4,
                d1: function(r) {
                    return ld(A2(E7, n, r));
                }
            }),
            A2(K4, 1, {
                d$: N4,
                d1: function(r) {
                    return ld(A2(E7, n, r));
                }
            }),
            A2(K4, 2, {
                d$: N4,
                d1: function(r) {
                    return ld(A2(E7, n, r));
                }
            })
        ]);
        return A2(Ck, b4, A2(j7, r.d_, t));
    }), L7 = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), M8(r) ? x([
                    A2(S7, n, r),
                    A2(T8, n, r),
                    A2(t5, n, r)
                ]) : x([
                    A2(t5, n, r)
                ])),
                A2(B7, n, r)
            ]),
            w5: n($d)
        };
    }), M7 = ZA({
        Ar: H4,
        AQ: T4,
        Db: I4,
        DZ: function(n) {
            return Px(x([
                A2(_S, R4, BS()),
                Z4(n.e7)
            ]));
        },
        En: L8,
        Et: L7
    }), N7 = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            dB: n,
            xs: t.CS
        }, Pp);
    }), H7 = F2(function(n, r) {
        return b(r, Pp);
    }), T7 = F2(function(n, r) {
        return r;
    }), I7 = F2(function(n, r) {
        return v(r, Pp, h);
    }), R7 = cr("br"), Z7 = function(n) {
        return n.eJ.nL;
    }, V7 = function(n) {
        return n.eJ.q7;
    }, U7 = function(n) {
        return n.eJ.q8;
    }, Y7 = function(n) {
        return n.eJ.w5;
    }, Q7 = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), x([
                    A2(LB, x([
                        lk,
                        rB(DB)
                    ]), x([
                        ld(n(Y7))
                    ])),
                    A2(R7, h, h),
                    A2(ak, h, x([
                        ld(n(V7))
                    ])),
                    ld(" "),
                    A2(ak, x([
                        Xx("text-support")
                    ]), x([
                        A2(fB, x([
                            Xx("link"),
                            yB(_A(Wa))
                        ]), x([
                            ld(n(Z7))
                        ]))
                    ])),
                    ld(" "),
                    A2(ak, h, x([
                        ld(n(U7))
                    ])),
                    A2(ak, h, x([
                        A4(YD, Ex(r.dB), qB(r.dB), Vt("If you believe you received this message in error"), Ut)
                    ]))
                ]))
            ]),
            w5: n(Y7)
        };
    }), O7 = Fk({
        Ar: N7,
        AQ: H7,
        Db: T7,
        DZ: function() {
            return zx;
        },
        En: I7,
        Et: Q7
    }), G7 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, J7 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), W7 = F6(function(n, r, t, e, u, a) {
        return {
            yt: e,
            qh: t,
            qw: a,
            tv: n,
            tw: r,
            D2: u
        };
    }), K7 = function(n) {
        switch(n){
            case "DOCUMENT":
                return uu(0);
            case "NOTE":
                return uu(1);
            case "VITALS":
                return uu(2);
            case "LAB":
                return uu(3);
            case "RX":
                return uu(4);
            case "RX_VERADIGM":
            case "RX_DOSESPOT":
                return uu(5);
            case "FORM":
                return uu(6);
            case "FAX":
                return uu(7);
            default:
                return Sk("Unsupported clinical note type: " + n);
        }
    }, X7 = A3(ly, "fileCount", F$, A3(ly, "text", C$, A3(ly, "author", iy(C$), A3(ly, "eventTimestamp", iy(KS), A3(ly, "noteType", A2(nu, K7, C$), A3(ly, "noteId", C$, uu(W7))))))), nnn = A2(dD, 0, A2(Pk, X7, uu(J7))), rnn = {
        g9: 1,
        hP: 10,
        lL: 0
    }, tnn = {
        k7: rnn
    }, enn = function(n) {
        return n.hP;
    }, unn = function(n) {
        return (n.g9 - 1) * n.hP;
    }, ann = function(n) {
        return Ul(x([
            b("offset", oe(unn(n))),
            b("limit", oe(enn(n)))
        ]));
    }, inn = A2(ru, ann, YN), cnn = F4(function(n, r, t, e) {
        return A4(W_, n, vy(nnn), e, A2(_P, function(n) {
            var r = n(tnn);
            return rc(x([
                inn(r.k7)
            ]));
        }(t), rA(function(n) {
            return A2(X_, x([
                "notes"
            ]), YA(n));
        }(r))));
    }), onn = A2(AA, da, Aa), fnn = function(n) {
        var r = tC(z_(n.g$));
        return r.$ ? onn : A4(cnn, n.g$, r.a, function(r) {
            return m(r, {
                k7: n.k7
            });
        }, G7);
    }, snn = F3(function(n, r) {
        var t = {
            ex: vc,
            g$: r.yY.fb,
            kA: r.kA,
            k7: rnn,
            jK: r.jK
        };
        return b(t, fnn(t));
    }), lnn = F2(function(n, r) {
        return b(r, Pp);
    }), dnn = F2(function(n, r) {
        return m(r, {
            x6: Vt(7)
        });
    }), bnn = F2(function(n, r) {
        return m(r, {
            g9: n
        });
    }), vnn = F2(function(n, r) {
        return m(r, {
            lL: n
        });
    }), mnn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    ex: t,
                    k7: A2(vnn, A2(sc, 0, A2(nv, pu, A2(Wu, "x-total-count", t.b))), r.k7)
                }), Pp, h) : v(m(r, {
                    ex: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = m(r, {
                    k7: A2(bnn, n.a, r.k7)
                });
                return v(e, fnn(e), h);
            default:
                return v(r, A2(AA, da, Ba({
                    rh: n.a
                })), h);
        }
    }), pnn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $nn = F2(function(n, r) {
        return r.mO(n);
    }), hnn = function(n) {
        return fM(n) ? Ut : Vt(n);
    }, gnn = F4(function(n, r, t, e) {
        var u = A2(Fp, r(0), t);
        return hnn(A2(fe, " - ", A2(Tp, iu, x([
            u,
            A2(Fp, n, A2(Fp, function(n) {
                return $nn(n);
            }, e))
        ]))));
    }), wnn = function(n) {
        var r = x([
            HB,
            jI
        ]);
        switch(n){
            case 0:
            default:
                return A2(PE, r, 19);
            case 1:
                return A2(PE, r, 21);
            case 2:
                return A2(PE, r, 22);
            case 3:
                return A2(PE, r, 23);
            case 4:
            case 5:
                return A2(PE, r, 24);
            case 6:
                return A2(PE, r, 25);
        }
    }, xnn = function(n) {
        return n.a.tv;
    }, knn = function(n) {
        return n.a.tw;
    }, ynn = function(n) {
        return n.tw.aH;
    }, _nn = function(n) {
        return n.tw.pK;
    }, Ann = function(n) {
        return n.tw.qr;
    }, Cnn = function(n) {
        return n.tw.kB;
    }, Bnn = function(n) {
        return n.tw.rj;
    }, Enn = function(n) {
        return n.tw.rP;
    }, Dnn = function(n) {
        return n.tw.tu;
    }, qnn = function(n) {
        return n.tw.xH;
    }, Fnn = function(n) {
        switch(n){
            case 0:
                return ynn;
            case 1:
                return Dnn;
            case 2:
                return qnn;
            case 3:
                return Enn;
            case 4:
                return Bnn;
            case 5:
                return _nn;
            case 6:
                return Cnn;
            default:
                return Ann;
        }
    }, Pnn = function(n) {
        return n.a.D2;
    }, znn = F3(function(n, r, t) {
        return 1 === t ? "1 " + n : oe(t) + " " + r;
    }), jnn = F2(function(n, r) {
        var t = function() {
            switch(n){
                case "child":
                    return "children";
                case "category":
                    return "categories";
                default:
                    return n + "s";
            }
        }();
        return A3(znn, n, t, r);
    }), Snn = A2(CN, AN(0), Vt(0)), Lnn = function(n) {
        var r = n.a.qw;
        return r > 0 ? A2(nk, x([
            Xx("flex flex-row")
        ]), x([
            A2(PE, x([
                HB,
                cH(Snn),
                MB("text-primary-500")
            ]), 18),
            A2(ak, x([
                Xx("ml-0.5")
            ]), x([
                ld(A2(jnn, "attachment", r))
            ]))
        ])) : tB;
    }, Mnn = F3(function(n, r, t) {
        var e = A4(gnn, n, r, t.a.qh, t.a.yt);
        return A2(nk, x([
            IC(pnn(xnn(t))),
            Xx("flex flex-row space-x-2 cursor-pointer w-full")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col mt-1")
            ]), x([
                wnn(knn(t))
            ])),
            A2(nk, x([
                Xx("flex flex-col grow gap-1 text-nowrap truncate")
            ]), x([
                A2(nk, x([
                    Xx("flex flex-row")
                ]), x([
                    A2(Ek, x([
                        bq
                    ]), x([
                        ld(n(Fnn(knn(t))))
                    ]))
                ])),
                function() {
                    if (e.$) return tB;
                    var n = e.a;
                    return A2(nk, x([
                        Xx("flex flex-row text-primary-500")
                    ]), x([
                        ld(n)
                    ]));
                }(),
                A2(nk, x([
                    Xx("flex flex-row")
                ]), x([
                    ld(Pnn(t))
                ])),
                Lnn(t)
            ])),
            A2(nk, x([
                Xx("flex flex-col justify-center text-primary-300 shrink-0")
            ]), x([
                A2(PE, x([
                    HB
                ]), 6)
            ]))
        ]));
    }), Nnn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("invoices-list")
        ]), A2(HE, Dk, A2(Eu, A2(Mnn, n, r), t)));
    }), Hnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tnn = {
        $: 7
    }, Inn = {
        g9: 1,
        hF: !1,
        hG: !1,
        hP: 0,
        AR: !1,
        b1: Ut,
        DG: 0,
        lL: 0
    }, Rnn = rk(1), Znn = F3(function(n, r, t) {
        var e = r.$ ? h : x([
            IC((0, r.a)(t))
        ]);
        return A2(ak, A2(Yt, Xx("clickable"), e), x([
            ld(n)
        ]));
    }), Vnn = F3(function(n, r, t) {
        return A2(hT, x([
            SC(x([
                b("active", i(n, t))
            ]))
        ]), x([
            A3(Znn, oe(t), r, t)
        ]));
    }), Unn = F2(function(n, r) {
        var t = r;
        return function(n) {
            var r = function(n) {
                return A3(de, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return m(r, {
                                lL: n.a
                            });
                        case 1:
                            return m(r, {
                                hP: n.a
                            });
                        case 2:
                            return m(r, {
                                hG: !0
                            });
                        case 3:
                            return m(r, {
                                g9: n.a
                            });
                        case 4:
                            return m(r, {
                                b1: Vt(n.a)
                            });
                        case 5:
                            return m(r, {
                                DG: n.a
                            });
                        case 6:
                            return m(r, {
                                AR: n.a
                            });
                        default:
                            return m(r, {
                                hF: !0
                            });
                    }
                }), Inn, n);
            }(n), t = !(1 > s(r.lL, r.hP) && r.hG || r.hF), e = ze(r.lL / r.hP), u = (r.g9 - 1) * r.hP, a = A2(Kv, r.g9 + 2, e), c = u + 1, o = A2(Ve, r.g9 - 2, 1), f = A2($e, o, a), l = c - 1 + (s(r.hP * r.g9, r.lL) > 0 ? r.lL - r.hP * (r.g9 - 1) : r.hP);
            return A2(nk, x([
                Xx("text-center")
            ]), r.AR ? x([
                ik(x([
                    Rnn
                ]))
            ]) : rc(x([
                t && s(r.lL, r.hP) > 0 ? x([
                    A2(nk, x([
                        Xx("pull-right")
                    ]), x([
                        ld("Showing " + oe(c) + " to " + oe(l) + " of " + oe(r.lL))
                    ]))
                ]) : h,
                r.lL && s(r.lL, r.hP) > 0 ? x([
                    A2(pT, x([
                        Xx("pagination"),
                        Xx("")
                    ]), rc(x([
                        x([
                            A2(hT, x([
                                SC(x([
                                    b("disabled", 1 === r.g9)
                                ]))
                            ]), x([
                                A3(Znn, "<", r.b1, r.g9 - 1)
                            ]))
                        ]),
                        o > 1 ? x([
                            A2(hT, h, x([
                                A3(Znn, "...", r.b1, o - 1)
                            ]))
                        ]) : h,
                        A2(Eu, A2(Vnn, r.g9, r.b1), f),
                        0 > s(a, e) ? x([
                            A2(hT, h, x([
                                A3(Znn, "...", r.b1, a + 1)
                            ]))
                        ]) : h,
                        x([
                            A2(hT, x([
                                SC(x([
                                    b("disabled", i(r.g9, e))
                                ]))
                            ]), x([
                                A3(Znn, ">", r.b1, r.g9 + 1)
                            ]))
                        ])
                    ])))
                ]) : h
            ])));
        }(A2(Yt, function(n) {
            return {
                $: 0,
                a: n
            };
        }(t.lL), A2(Yt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.hP), A2(Yt, function(n) {
            return {
                $: 3,
                a: n
            };
        }(t.g9), A2(Yt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(iu), n)))));
    }), Ynn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), function() {
                    var t, e = r.ex;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return x([
                                A2(nk, h, TE(u) ? r5(n(hd)) : x([
                                    A3(Nnn, n, r.jK, u),
                                    (t = r.k7, A2(Ck, Hnn, A2(Unn, x([
                                        Tnn
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return a6(n(gd));
                        default:
                            return ck;
                    }
                }())
            ]),
            w5: n(Pb(7))
        };
    }), Qnn = ZA({
        Ar: snn,
        AQ: lnn,
        Db: dnn,
        DZ: function() {
            return zx;
        },
        En: mnn,
        Et: Ynn
    }), Onn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Gnn = F2(function(n, r) {
        return A2(X_, x([
            r
        ]), function(n) {
            return A2(X_, x([
                "notes"
            ]), YA(n));
        }(n));
    }), Jnn = F7(function(n, r, t, e, u, a, i) {
        return {
            yt: u,
            oX: i,
            qh: e,
            z2: a,
            tv: n,
            tw: r,
            wO: t
        };
    }), Wnn = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), Knn = A3(ly, "name", C$, A3(ly, "id", C$, uu(Wnn))), Xnn = A2(Pk, Knn, uu(iu)), nrn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rrn = A3(ly, "formattedText", C$, uu(function(n) {
        return {
            qN: n
        };
    })), trn = A2(Pk, rrn, uu(iu)), ern = A2(Pk, A2(tu, nrn, trn), uu(iu)), urn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, arn = A3(ly, "text", iy(C$), A3(ly, "address", iy(C$), A3(ly, "location", iy(C$), A3(ly, "daysOfTreatment", iy(F$), A3(ly, "numberOfRefills", iy(F$), A3(ly, "quantityPrescribed", iy(F$), A3(ly, "instructions", iy(C$), A3(ly, "medicationName", iy(C$), A3(ly, "prescriber", iy(C$), A3(ly, "useByDate", iy(KS), A3(ly, "datePrescribed", iy(KS), A3(ly, "routeOfAdministration", iy(C$), A3(ly, "form", iy(C$), A3(ly, "strength", iy(C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                mk: d,
                                                                kj: e,
                                                                kl: s,
                                                                kB: r,
                                                                kH: c,
                                                                kL: l,
                                                                kQ: i,
                                                                k$: f,
                                                                lh: a,
                                                                ll: o,
                                                                ls: t,
                                                                lF: n,
                                                                D2: b,
                                                                lN: u
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), irn = A2(Pk, arn, uu(iu)), crn = A2(Pk, A2(tu, urn, irn), uu(iu)), orn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, frn = A3(ly, "formattedText", C$, uu(function(n) {
        return {
            qN: n
        };
    })), srn = A2(Pk, frn, uu(iu)), lrn = A2(Pk, A2(tu, orn, srn), uu(iu)), drn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, brn = F4(function(n, r, t, e) {
        return {
            oE: r,
            qK: n,
            lH: e,
            w6: t
        };
    }), vrn = F2(function(n, r) {
        return {
            o_: n,
            vl: r
        };
    }), mrn = A3(ly, "questionCount", F$, A3(ly, "dateSubmitted", iy(KS), uu(vrn))), prn = A3(ly, "submissionData", mrn, A3(ly, "to", C$, A3(ly, "created", iy(KS), A3(ly, "formName", C$, uu(brn))))), $rn = A2(Pk, prn, uu(iu)), hrn = A2(Pk, A2(tu, drn, $rn), uu(iu)), grn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wrn = F2(function(n, r) {
        return {
            l$: n,
            tQ: r
        };
    }), xrn = F3(function(n, r, t) {
        return {
            yP: t,
            pj: n,
            CW: r
        };
    }), krn = A4(sy, "chargeId", iy(C$), Ut, A4(sy, "reference", iy(C$), Ut, A3(ly, "display", iy(C$), uu(xrn)))), yrn = A3(ly, "orderedFrom", iy(C$), A3(ly, "actions", vy(krn), uu(wrn))), _rn = A2(Pk, yrn, uu(iu)), Arn = A2(Pk, A2(tu, grn, _rn), uu(iu)), Crn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Brn = A3(ly, "formattedText", C$, uu(function(n) {
        return {
            qN: n
        };
    })), Ern = A2(Pk, Brn, uu(iu)), Drn = A2(Pk, A2(tu, Crn, Ern), uu(iu)), qrn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Frn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            oZ: r,
            kl: c,
            qP: n,
            kH: u,
            kQ: e,
            k$: i,
            u_: t,
            ll: a
        };
    }), Prn = A3(ly, "daysOfTreatment", iy(F$), A3(ly, "numberOfRefills", iy(F$), A3(ly, "quantityPrescribed", iy(F$), A3(ly, "instructions", iy(C$), A3(ly, "medicationName", iy(C$), A3(ly, "priceForPatient", iy(q$), A3(ly, "dateFulfilled", iy(ay), A3(ly, "frequency", iy(C$), uu(Frn))))))))), zrn = A2(Pk, Prn, uu(iu)), jrn = A2(Pk, A2(tu, qrn, zrn), uu(iu)), Srn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lrn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            nb: c,
            pg: t,
            q5: e,
            q6: o,
            vW: u,
            wE: a,
            wZ: r,
            w2: n,
            xL: i
        };
    }), Mrn = A3(ly, "height", iy(q$), A3(ly, "bmi", iy(q$), A3(ly, "weight", iy(q$), A3(ly, "spo2", iy(q$), A3(ly, "respiratoryRate", iy(q$), A3(ly, "heartRate", iy(q$), A3(ly, "diastolic", iy(q$), A3(ly, "systolic", iy(q$), A3(ly, "temp", iy(q$), uu(Lrn)))))))))), Nrn = A2(Pk, Mrn, uu(iu)), Hrn = A2(Pk, A2(tu, Srn, Nrn), uu(iu)), Trn = P$(x([
        Hrn,
        Drn,
        ern,
        hrn,
        Arn,
        jrn,
        crn,
        lrn
    ])), Irn = A3(ly, "data", Trn, A3(ly, "files", vy(Xnn), A3(ly, "author", iy(C$), A3(ly, "eventTimestamp", iy(KS), A3(ly, "status", C$, A3(ly, "noteType", A2(nu, K7, C$), A3(ly, "noteId", C$, uu(Jnn)))))))), Rrn = A2(Pk, Irn, uu(iu)), Zrn = F4(function(n, r, t, e) {
        return A4(W_, n, Rrn, e, rA(A2(Gnn, r, t)));
    }), Vrn = F3(function(n, r, t) {
        var e = {
            g$: r.yY.fb,
            kA: r.kA,
            rh: t.Ck.rh,
            e_: Ut,
            tu: vc,
            dB: n,
            jK: r.jK,
            xs: t
        };
        return b(e, function(n) {
            var r = tC(z_(n.g$));
            if (r.$) return Pp;
            var t = r.a;
            return A4(Zrn, n.g$, t, n.rh, Onn(t));
        }(e));
    }), Urn = F2(function(n, r) {
        return b(r, Pp);
    }), Yrn = F2(function(n, r) {
        return m(r, {
            x6: Vt(7)
        });
    }), Qrn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Orn = F3(function(n, r, t) {
        return {
            rh: n,
            tg: r,
            xs: t
        };
    }), Grn = A3(ly, "url", C$, A3(ly, "name", C$, A3(ly, "id", C$, uu(Orn)))), Jrn = A2(Pk, Grn, uu(iu)), Wrn = F3(function(n, r, t) {
        return A2(X_, x([
            t
        ]), A2(X_, x([
            "file"
        ]), A2(Gnn, n, r)));
    }), Krn = F5(function(n, r, t, e, u) {
        return A4(W_, n, Jrn, u, rA(A3(Wrn, r, t, e)));
    }), Xrn = "Patient Portal", ntn = F3(function(n, r, t) {
        return A3(M_, F3(function(t, e, u) {
            return A3(xn, n(t), r(e), u);
        }), {}, t);
    }), rtn = F2(function(n, r) {
        return _x(x([
            b("type", Ax(n)),
            b("payload", r)
        ]));
    }), ttn = F2(function(n, r) {
        return A2(rtn, n, A3(ntn, iu, Ax, Ul(r)));
    }), etn = Wn("fullStoryPortLogEvent", iu), utn = F2(function(n, r) {
        return etn(A2(ttn, n, r));
    }), atn = function(n) {
        return b(n.a, n.b);
    }, itn = F2(function(n, r) {
        return A2(utn, n, A2(Eu, atn, r));
    }), ctn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), otn = F2(function(n, r) {
        return A2(ctn, n, r);
    }), ftn = function(n) {
        return A2(otn, "Patient ID", n);
    }, stn = function(n) {
        return A2(otn, "User Flow", n);
    }, ltn = F3(function(n, r, t) {
        return A2(itn, "Clinical Data Opened", x([
            stn(Xrn),
            ftn(n),
            A2(otn, "interaction ID", r),
            A2(otn, "interaction type", t)
        ]));
    }), dtn = function(n) {
        return n.tw;
    }, btn = Wn("printWindow", function() {
        return yx;
    }), vtn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.b;
                if (3 === t.$) {
                    var e = A3(ltn, n.a, r.rh, A2(Wx, 0, Fnn(dtn(t.a))));
                    return v(m(r, {
                        tu: t
                    }), Vu(x([
                        e
                    ])), h);
                }
                return v(m(r, {
                    tu: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var u = n.a, a = tC(z_(r.g$)), i = a.$ ? Pp : A5(Krn, r.g$, a.a, r.rh, u, Qrn);
                return v(m(r, {
                    e_: Vt(u)
                }), i, h);
            case 2:
                var c = n.a, o = m(r, {
                    e_: Ut
                });
                return 3 === c.$ ? v(o, $Q(c.a.xs), h) : v(o, Pp, A2(xA, 0, c));
            default:
                return v(r, 3 === r.tu.$ ? btn(0) : Pp, h);
        }
    }), mtn = function(n) {
        return n.qh;
    }, ptn = function(n) {
        return n.z2;
    }, $tn = {
        $: 3
    }, htn = function(n) {
        return A2(ak, x([
            Xx("text-support")
        ]), x([
            A2(IN, x([
                w2,
                LN(_A(Ca))
            ]), x([
                ld(n(Pb(7)))
            ]))
        ]));
    }, gtn = function(n) {
        return D$(n.a.i);
    }, wtn = function(n) {
        return !gtn(n);
    }, xtn = F3(function(n, r, t) {
        return wtn(r) ? tB : A2(nk, x([
            Xx("note-breadcrumbs")
        ]), x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    _N(oB),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), x([
                    htn(n),
                    A2(ak, x([
                        Xx("mx-3 text-support")
                    ]), x([
                        ld("/")
                    ])),
                    ld(n(Fnn(dtn(t)))),
                    A2(ak, x([
                        Xx("text-primary-300 ml-auto text-right")
                    ]), x([
                        A2(nk, x([
                            Xx("cursor-pointer"),
                            IC($tn)
                        ]), x([
                            A2(PE, h, 16)
                        ]))
                    ]))
                ]))
            ])),
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, h, x([
                    Dk
                ]))
            ]))
        ]));
    }), ktn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ytn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _tn = A2(CN, AN(1), Vt(1)), Atn = F2(function(n, r) {
        var t, e = r.rh, u = A2(Fp, function(n) {
            return i(n, e);
        }, n), a = !u.$ && u.a ? ik(x([
            h3,
            ytn(x([
                Xx("mr-3")
            ]))
        ])) : A2(PE, x([
            cH(_tn)
        ]), 19);
        return A2(nk, x([
            Xx("file-button")
        ]), x([
            A2(OC, x([
                EC(ktn(e)),
                uF(aF(u))
            ]), x([
                A2(ak, h, x([
                    a,
                    ld((t = r, t.tg))
                ]))
            ]))
        ]));
    }), Ctn = F2(function(n, r) {
        return TE(r) ? tB : A2(zN, x([
            jN(iR)
        ]), x([
            A2(EN, h, x([
                A2(nk, x([
                    Xx("clinical-note-files")
                ]), A2(Eu, Atn(n), r))
            ]))
        ]));
    }), Btn = F3(function(n, r, t) {
        var e = A4(gnn, n, r, mtn(t), t.yt);
        if (e.$) return tB;
        var u = e.a;
        return A2(nk, x([
            Xx("flex flex-row text-sm text-primary-500 mb-4")
        ]), x([
            ld(u)
        ]));
    }), Etn = function(n) {
        return n.dj.zf;
    }, Dtn = function(n) {
        return n.dj.o_;
    }, qtn = function(n) {
        return n.dj.Bo;
    }, Ftn = function(n) {
        return n.dj.Do;
    }, Ptn = function(n) {
        return n.dj.wO;
    }, ztn = function(n) {
        return n.qK;
    }, jtn = F2(function(n, r) {
        return b(n, r);
    }), Stn = function(n) {
        return n.lH.vl;
    }, Ltn = function(n) {
        return n.w6;
    }, Mtn = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(X3, x([
            Xx("data-display__row")
        ]), x([
            A2(u9, x([
                Xx("data-display__label")
            ]), x([
                ld(n(t))
            ])),
            A2(u9, x([
                Xx("data-display__value")
            ]), x([
                ld(A2(sc, "no data", e))
            ]))
        ]));
    }), Ntn = F2(function(n, r) {
        return A2(nk, x([
            Xx("data-display")
        ]), x([
            A2(J3, x([
                Xx("data-display__table")
            ]), x([
                A2(W3, h, A2(Eu, Mtn(n), r))
            ]))
        ]));
    }), Htn = F2(function(n, r) {
        return A2(Fp, function(r) {
            return A2(fe, " ", x([
                A2(n, 1, r),
                A2(n, 4, r),
                "(" + A2(n, 6, r) + ")"
            ]));
        }, r);
    }), Ttn = F4(function(n, r, t, e) {
        var u = "FULFILLED" === t || "ADDENDED" === t ? "Completed" : "Pending Submission", a = A2(Htn, r, e.lH.o_), i = A2(Htn, r, e.oE);
        return A2(nk, x([
            Xx("w-full md:w-1/2")
        ]), x([
            A2(nk, x([
                Xx("mb-4")
            ]), x([
                ld(ztn(e))
            ])),
            A2(Ntn, n, x([
                A2(jtn, Ptn, Vt(u)),
                A2(jtn, Etn, i),
                A2(jtn, Ftn, Vt(Ltn(e))),
                A2(jtn, Dtn, a),
                A2(jtn, qtn, Vt(oe(Stn(e))))
            ]))
        ]));
    }), Itn = function(n) {
        return A2(Tp, iu, A2(Eu, function(n) {
            return n.pj;
        }, n.l$));
    }, Rtn = function(n) {
        if (n.$) return tB;
        var r = n.a;
        return A2(nk, x([
            Xx("mb-4")
        ]), x([
            ld("Lab Facility: " + r)
        ]));
    }, Ztn = function(n) {
        return n.mk;
    }, Vtn = F2(function(n, r) {
        return A2(nk, h, x([
            ld(A2(fe, ": ", x([
                n,
                A2(sc, "no data", r)
            ])))
        ]));
    }), Utn = function(n) {
        return n.kj;
    }, Ytn = function(n) {
        return n.kl;
    }, Qtn = function(n) {
        return n.kB;
    }, Otn = function(n) {
        return n.kH;
    }, Gtn = function(n) {
        return n.k$;
    }, Jtn = function(n) {
        return n.lh;
    }, Wtn = function(n) {
        return n.ab.zc;
    }, Ktn = function(n) {
        return n.ab.kj;
    }, Xtn = function(n) {
        return n.ab.kl;
    }, nen = function(n) {
        return n.ab.kB;
    }, ren = function(n) {
        return n.ab.qP;
    }, ten = function(n) {
        return n.ab.kH;
    }, een = function(n) {
        return n.ab.A3;
    }, uen = function(n) {
        return n.ab.lh;
    }, aen = function(n) {
        return n.ab.li;
    }, ien = function(n) {
        return n.ab.vg;
    }, cen = function(n) {
        return n.ab.CX;
    }, oen = function(n) {
        return n.ab.ls;
    }, fen = function(n) {
        return n.ab.lF;
    }, sen = function(n) {
        return n.ab.lN;
    }, len = function(n) {
        return n.ll;
    }, den = function(n) {
        return n.ls;
    }, ben = function(n) {
        return n.lF;
    }, ven = function(n) {
        return n.D2;
    }, men = function(n) {
        return n.lN;
    }, pen = F3(function(n, r, t) {
        var e, u;
        return A2(jE, iu, x([
            aF((u = t).lF),
            aF(u.kB),
            aF(u.ls),
            aF(u.kj),
            aF(u.lN),
            aF(u.lh),
            aF(u.kQ),
            aF(u.kH),
            aF(u.ll),
            aF(u.k$),
            aF(u.kl),
            aF(u.kL),
            aF(u.mk)
        ])) ? A2(Ntn, n, x([
            A2(jtn, een, (e = t, e.kQ)),
            A2(jtn, fen, ben(t)),
            A2(jtn, nen, Qtn(t)),
            A2(jtn, ten, Otn(t)),
            A2(jtn, ien, A2(Fp, oe, len(t))),
            A2(jtn, oen, den(t)),
            A2(jtn, cen, A2(Fp, oe, Gtn(t))),
            A2(jtn, Xtn, A2(Fp, oe, Ytn(t))),
            A2(jtn, Ktn, A2(Fp, r(0), Utn(t))),
            A2(jtn, sen, A2(Fp, r(0), men(t))),
            A2(jtn, uen, Jtn(t))
        ])) : A2(nk, h, x([
            ld(A2(sc, "Prescription details are missing.", ven(t)))
        ]));
    }), $en = F3(function(n, r, t) {
        var e;
        return A2(nk, x([
            Xx("w-full md:w-1/2")
        ]), x([
            A2(nk, x([
                Xx("mb-4")
            ]), x([
                A2(Vtn, "Location", (e = t, e.kL)),
                A2(Vtn, "Address", Ztn(t))
            ])),
            A3(pen, n, r, t)
        ]));
    }), hen = function(n) {
        return n.b.mk;
    }, gen = function(n) {
        return n.nK;
    }, wen = A2(ak, h, x([
        ld("," + aB)
    ])), xen = function(n) {
        return fM(n);
    }, ken = function(n) {
        return n.r1;
    }, yen = function(n) {
        return n.r2;
    }, _en = function(n) {
        return n.wN;
    }, Aen = function(n) {
        return n.x0;
    }, Cen = function(n) {
        var r, t = QE(Aen(n)), e = vu(_en(n)) ? Ut : Vt(A2(ak, h, x([
            ld(_en(n))
        ]))), u = xen(yen(n)) ? Ut : Vt(QE(yen(n))), a = xen(ken(n)) ? Ut : Vt(QE(ken(n))), i = vu(gen(n)) ? Ut : Vt(A2(ak, h, x([
            ld(gen(n))
        ]))), c = A2(HE, wen, A2(Tp, iu, x([
            a,
            u,
            i,
            e
        ])));
        return $(c, x([
            (r = b(TE(c), xen(Aen(n)))).a || r.b ? tB : iB,
            t
        ]));
    }, Ben = function(n) {
        var r = hen(n);
        if (r.$) return tB;
        var t = r.a;
        return A2(nk, h, x([
            A2(ak, h, x([
                ld("Address: ")
            ])),
            A2(ak, h, Cen(t))
        ]));
    }, Een = function(n) {
        return A2(nk, h, x([
            ld("Location: " + Ex(n))
        ]));
    }, Den = function(n) {
        return n.oZ;
    }, qen = function(n) {
        return n.kl;
    }, Fen = function(n) {
        return n.qP;
    }, Pen = function(n) {
        return n.kH;
    }, zen = function(n) {
        return n.k$;
    }, jen = function(n) {
        return n.u_;
    }, Sen = function(n) {
        return n.ll;
    }, Len = F2(function(n, r) {
        var t;
        return A2(Ntn, n, x([
            A2(jtn, een, (t = r, t.kQ)),
            A2(jtn, ten, Pen(r)),
            A2(jtn, ren, Fen(r)),
            A2(jtn, Xtn, A2(Fp, oe, qen(r))),
            A2(jtn, ien, A2(Fp, oe, Sen(r))),
            A2(jtn, cen, A2(Fp, oe, zen(r))),
            A2(jtn, Wtn, A2(Fp, NL(aS("/")), Den(r))),
            A2(jtn, aen, A2(Fp, A2(fV, !1, !0), jen(r)))
        ]));
    }), Men = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("w-full md:w-1/2")
        ]), x([
            A2(nk, x([
                Xx("mb-4")
            ]), x([
                Een(r),
                Ben(r)
            ])),
            A2(Len, n, t)
        ]));
    }), Nen = function(n) {
        return n.nb;
    }, Hen = function(n) {
        return n.pg;
    }, Ten = function(n) {
        return n.q5;
    }, Ien = function(n) {
        return n.q6;
    }, Ren = function(n) {
        return n.vW;
    }, Zen = function(n) {
        return n.wE;
    }, Ven = function(n) {
        return n.w2;
    }, Uen = function(n) {
        return n.aT.nb;
    }, Yen = function(n) {
        return n.aT.pg;
    }, Qen = function(n) {
        return n.aT.q6;
    }, Oen = function(n) {
        return n.aT.CQ;
    }, Gen = function(n) {
        return n.aT.vW;
    }, Jen = function(n) {
        return n.aT.wE;
    }, Wen = function(n) {
        return n.aT.wZ;
    }, Ken = function(n) {
        return n.aT.w2;
    }, Xen = function(n) {
        return n.aT.xL;
    }, nun = function(n) {
        return n.aT.Ez;
    }, run = function(n) {
        return n.xL;
    }, tun = F4(function(n, r, t, e) {
        var u, a = A2(Fp, function(n) {
            return A2(fe, ", ", x([
                A2(r, 0, n),
                A2(r, 5, n)
            ]));
        }, t);
        return A2(nk, x([
            Xx("w-full md:w-1/2")
        ]), x([
            A2(Ntn, n, x([
                A2(jtn, nun, a),
                A2(jtn, Wen, A2(Fp, OZ, (u = e, u.wZ))),
                A2(jtn, Yen, A2(Fp, OZ, Hen(e))),
                A2(jtn, Oen, A2(Fp, OZ, Ten(e))),
                A2(jtn, Jen, A2(Fp, OZ, Zen(e))),
                A2(jtn, Ken, A2(Fp, OZ, Ven(e))),
                A2(jtn, Gen, A2(Fp, OZ, Ren(e))),
                A2(jtn, Qen, A2(Fp, OZ, Ien(e))),
                A2(jtn, Xen, A2(Fp, OZ, run(e))),
                A2(jtn, Uen, A2(Fp, OZ, Nen(e)))
            ]))
        ]));
    }), eun = F4(function(n, r, t, e) {
        var u = function(n) {
            return n.oX;
        }(e);
        switch(u.$){
            case 0:
                var a = u.a;
                return A4(tun, n, t, mtn(e), a);
            case 1:
                return function(n) {
                    var r = kG(n.qN);
                    if (r.$) return tB;
                    var t = r.a;
                    return A2(nk, x([
                        Xx("formatted-text-data")
                    ]), AG(t));
                }(u.a);
            case 2:
                return function(n) {
                    var r = kG(n.qN);
                    if (r.$) return tB;
                    var t = r.a;
                    return A2(nk, x([
                        Xx("formatted-text-data")
                    ]), AG(t));
                }(u.a);
            case 3:
                var i = u.a;
                return A4(Ttn, n, t, function(n) {
                    return n.wO;
                }(e), i);
            case 4:
                return function(n) {
                    var r, t;
                    return A2(nk, x([
                        Xx("w-full md:w-1/2")
                    ]), x([
                        Rtn((t = n, t.tQ)),
                        (r = Itn(n), A2(nk, h, x([
                            ld("Ordered tests:"),
                            A2(nk, x([
                                Xx("ml-4")
                            ]), x([
                                A2(pT, x([
                                    Xx("list-disc ml-2")
                                ]), A2(Eu, function(n) {
                                    return A2(hT, h, x([
                                        ld(n)
                                    ]));
                                }, r))
                            ]))
                        ])))
                    ]));
                }(u.a);
            case 5:
                return A3(Men, n, r, u.a);
            case 6:
                return A3($en, n, t, u.a);
            default:
                return function(n) {
                    var r = kG(n.qN);
                    if (r.$) return tB;
                    var t = r.a;
                    return A2(nk, x([
                        Xx("formatted-text-data")
                    ]), AG(t));
                }(u.a);
        }
    }), uun = F4(function(n, r, t, e) {
        return A2(nk, h, x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, h, x([
                    A2(Ck, yu, A3(Btn, n, t, e)),
                    A2(Ck, yu, A4(eun, n, r, t, e))
                ]))
            ]))
        ]));
    }), aun = F2(function(n, r) {
        var t = function() {
            var t = r.tu;
            if (3 === t.$) {
                var e = t.a, u = Vt(n(Fnn(dtn(e)))), a = A2(Fp, r.jK(0), mtn(e));
                return A2(fe, "_", A2(Tp, iu, x([
                    u,
                    a
                ])));
            }
            return n(Pb(7));
        }();
        return {
            gN: x([
                A2(nk, h, x([
                    A2(nk, x([
                        Xx("panel clinical-note")
                    ]), function() {
                        var t = r.tu;
                        if (3 === t.$) {
                            var e = t.a;
                            return x([
                                A3(xtn, n, r.g$, e),
                                A4(uun, n, r.dB, r.jK, e),
                                A2(Ctn, r.e_, ptn(e))
                            ]);
                        }
                        return ck;
                    }())
                ]))
            ]),
            w5: t
        };
    }), iun = ZA({
        Ar: Vrn,
        AQ: Urn,
        Db: Yrn,
        DZ: function() {
            return zx;
        },
        En: vtn,
        Et: aun
    }), cun = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oun = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fun = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), sun = F5(function(n, r, t, e, u) {
        return {
            oY: r,
            pu: t,
            pA: u,
            pB: e,
            rh: n
        };
    }), lun = function(n) {
        switch(n){
            case "paid":
                return uu(0);
            case "void":
                return uu(1);
            case "due":
                return uu(2);
            default:
                return Sk("Unsupported document status: " + n);
        }
    }, dun = A3(ly, "due_date", ay, A3(ly, "due_in_cents", F$, A3(ly, "document_status", A2(nu, lun, C$), A3(ly, "date", ay, A3(ly, "id", C$, uu(sun)))))), bun = A2(dD, 0, A2(Pk, dun, uu(fun))), vun = {
        k7: rnn
    }, mun = F4(function(n, r, t, e) {
        return A4(W_, n, vy(bun), e, A2(_P, function(n) {
            var r = n(vun);
            return rc(x([
                inn(r.k7)
            ]));
        }(t), rA(function(n) {
            return A2(X_, x([
                "customer_invoices"
            ]), lL(n));
        }(r))));
    }), pun = function(n) {
        var r = function(r) {
            return m(r, {
                k7: n.k7
            });
        };
        return A4(mun, n.gF, Bx(n.dB), r, oun);
    }, $un = function(n) {
        return {
            $: 8,
            a: n
        };
    }, hun = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gun = {
        $: 3
    }, wun = function(n) {
        return {
            $: 7,
            a: n
        };
    }, xun = function(n) {
        return n.bo.ye;
    }, kun = function(n) {
        return n.bo.y8;
    }, yun = function(n) {
        return n.bo.za;
    }, _un = function(n) {
        return n.bo.p$;
    }, Aun = function(n) {
        return n.bo.Ap;
    }, Cun = function(n) {
        return n.bo.Aq;
    }, Bun = function(n) {
        return n.bo.AM;
    }, Eun = function(n) {
        return n.bo.DN;
    }, Dun = function(n) {
        switch(n){
            case 0:
                return xun;
            case 1:
                return kun;
            case 2:
                return Bun;
            default:
                return yun;
        }
    }, qun = function(n) {
        switch(n){
            case 0:
                return Vt("all_time");
            case 1:
                return Vt("current_year");
            case 2:
                return Vt("last_year");
            default:
                return Vt("custom");
        }
    }, Fun = F4(function(n, r, t, e) {
        var u = E4("statement-start-date"), a = u.a, i = u.b, c = A2(S8, cm(!1), a), o = A2(fS, 0, gun), f = o.a, s = o.b, l = E4("statement-end-date"), d = l.a, v = l.b, m = A2(S8, cm(!1), d);
        return b({
            gF: t,
            g8: Ut,
            cu: m,
            hu: vc,
            hM: !1,
            t6: r,
            dB: n,
            ac: f,
            fF: Ut,
            cV: c,
            fN: dd({
                rh: "statement-download",
                Eb: function(n) {
                    return A2(pc, n, Dun);
                },
                Ed: qun
            }),
            xs: e
        }, Vu(x([
            A2(Nu, hun, RF),
            s,
            A2(Lp, wun, i),
            A2(Lp, $un, v)
        ])));
    }), Pun = F3(function(n, r, t) {
        var e = A4(Fun, n, r.t6, r.gF, t), u = e.b, a = {
            gF: r.gF,
            de: e.a,
            kA: r.kA,
            g: vc,
            k7: rnn,
            t6: r.t6,
            dB: n
        };
        return b(a, Vu(x([
            pun(a),
            A2(Lp, cun, u)
        ])));
    }), zun = F2(function(n, r) {
        return b(r, Pp);
    }), jun = F2(function(n, r) {
        return m(r, {
            x6: Vt(0)
        });
    }), Sun = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lun = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mun = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nun = {
        $: 6
    }, Hun = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tun = function(n) {
        return Ax(FP(n));
    }, Iun = function(n) {
        return A2(X_, x([
            "files"
        ]), lL(n));
    }, Run = F6(function(n, r, t, e, u, a) {
        return {
            zT: n,
            z1: r,
            u3: a,
            xd: e,
            xo: u,
            xs: t
        };
    }), Zun = A2(nu, function(n) {
        return uu(n);
    }, C$), Vun = A3(ly, "processing", jk, A3(ly, "type", C$, A3(ly, "token", Zun, A3(ly, "url", aL(C$), A3(ly, "file_name", C$, A3(ly, "extension", C$, uu(Run))))))), Uun = A2(Pk, A2(tu, iu, Vun), uu(iu)), Yun = F4(function(n, r, t, e) {
        return A4(bL, n, Uun, e, A2(vL, function(n) {
            return _x(x([
                b("type", Ax("account_statement")),
                b("options", _x(x([
                    b("date", _x(function() {
                        var r = n.oY;
                        if (r.$) return h;
                        var t = r.a.AW;
                        return x([
                            b("gte", Tun(r.a.Aa)),
                            b("lte", Tun(t))
                        ]);
                    }()))
                ])))
            ]));
        }(t), rA(Iun(r))));
    }), Qun = F2(function(n, r) {
        return A2(X_, x([
            r
        ]), Iun(n));
    }), Oun = F4(function(n, r, t, e) {
        return A4(dC, n, Uun, e, rA(A2(X_, x([
            "generate"
        ]), A2(Qun, r, t))));
    }), Gun = function(n) {
        return n.u3;
    }, Jun = function(n) {
        return A2(otn, "fromState", n);
    }, Wun = F3(function(n, r, t) {
        var e = A2(sc, "", A2(Fp, EL, uC(n))), u = A2(sc, Uu, fc(r.CS));
        return A2(itn, "Data Export Complete", x([
            Jun(_A(u)),
            A2(otn, "Format", "PDF"),
            A2(otn, "Scope", A2(Wx, 0, Dun(t))),
            ftn(e)
        ]));
    }), Kun = F2(function(n, r) {
        var t = function(n) {
            return A3(dp, n, 11, 31);
        }, e = function(n) {
            return A3(dp, n, 0, 1);
        }, u = Pv(r);
        switch(n){
            case 0:
            default:
                return {
                    oY: Ut,
                    xo: 0
                };
            case 1:
                return {
                    oY: Vt({
                        Aa: e(u),
                        AW: t(u)
                    }),
                    xo: 0
                };
            case 2:
                return {
                    oY: Vt({
                        Aa: e(u - 1),
                        AW: t(u - 1)
                    }),
                    xo: 0
                };
        }
    }), Xun = function(n) {
        return n.xd;
    }, nan = function(n) {
        return n.xs;
    }, ran = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(ZD, n.a, r.fN), e = t.a, u = t.b, a = t.c, i = function() {
                    var n = b(a, r.g8);
                    if (n.a.$ || n.a.a.$ || n.a.a.a.$ || n.b.$) return b(r.fF, h);
                    var t = n.a.a.a.a, e = n.b.a;
                    return b(Vt(t), 3 === t ? h : x([
                        A4(Yun, r.gF, Bx(r.dB), A2(Kun, t, e), Lun),
                        A3(Wun, r.t6, r.xs, t)
                    ]));
                }(), c = i.b;
                return b(m(r, {
                    fF: i.a,
                    fN: e
                }), Vu(A2(Yt, A2(Lp, Hun, u), c)));
            case 1:
                return b(m(r, {
                    g8: Vt(n.a)
                }), Pp);
            case 2:
                var o = n.a, f = function() {
                    if (3 === o.$) {
                        var n = o.a;
                        return b(A4(Oun, r.gF, Bx(r.dB), Xun(n), Mun), NM(r.ac));
                    }
                    return b(Pp, r.ac);
                }(), s = f.a;
                return b(m(r, {
                    hu: o,
                    ac: f.b
                }), s);
            case 3:
                return b(m(r, {
                    ac: WL(r.ac)
                }), Pp);
            case 4:
                var l = A2(lN, n.a, r.ac), d = l.b;
                return b(m(r, {
                    ac: l.a
                }), A2(Lp, Sun, d));
            case 5:
                var p = n.a, $ = function() {
                    if (3 === p.$) {
                        var n = p.a;
                        return Gun(n) ? v(r.ac, !0, A2(Nu, cm(Nun), jp(2e3))) : v(WL(r.ac), !1, A2(sc, Pp, A2(Fp, $Q, nan(n))));
                    }
                    return v(r.ac, !1, Pp);
                }();
                return d = $.c, b(m(r, {
                    hM: $.b,
                    ac: $.a
                }), d);
            case 6:
                var g = function() {
                    var n = r.hu;
                    if (3 === n.$) {
                        var t = n.a;
                        return A4(Oun, r.gF, Bx(r.dB), Xun(t), Mun);
                    }
                    return Pp;
                }();
                return b(r, g);
            case 7:
                var w = A2(C8, n.a, r.cV);
                return g = w.b, b(m(r, {
                    cV: w.a
                }), A2(Lp, wun, g));
            case 8:
                var k = A2(C8, n.a, r.cu);
                return g = k.b, b(m(r, {
                    cu: k.a
                }), A2(Lp, $un, g));
            default:
                return c = function() {
                    var n = b(r.cV.oY, r.cu.oY);
                    if (n.a.$ || n.b.$) return h;
                    var t = n.a.a, e = n.b.a;
                    return x([
                        A4(Yun, r.gF, Bx(r.dB), {
                            oY: Vt({
                                Aa: t,
                                AW: e
                            }),
                            xo: 0
                        }, Lun),
                        A3(Wun, r.t6, r.xs, 3)
                    ]);
                }(), b(m(r, {
                    hM: !0
                }), Vu(c));
        }
    }), tan = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    g: t,
                    k7: A2(vnn, A2(sc, 0, A2(nv, pu, A2(Wu, "x-total-count", t.b))), r.k7)
                }), Pp, h) : v(m(r, {
                    g: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = m(r, {
                    k7: A2(bnn, n.a, r.k7)
                });
                return v(e, pun(e), h);
            case 2:
                var u = A2(ran, n.a, r.de), a = u.b;
                return v(m(r, {
                    de: u.a
                }), A2(Lp, cun, a), h);
            default:
                return v(r, A2(AA, da, Da({
                    rh: n.a
                })), h);
        }
    }), ean = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uan = function(n) {
        return n.a.oY;
    }, aan = function(n) {
        return A2(NL, aS("/"), n);
    }, ian = function(n) {
        return n.a.pu;
    }, can = function(n) {
        return n.a.pA;
    }, oan = function(n) {
        return n.a.pB;
    }, fan = F2(function(n, r) {
        return r.rw(n);
    }), san = F2(function(n, r) {
        return r.rx(n);
    }), lan = A2(CN, AN(1), Vt(0)), dan = function(n) {
        return n.pu.zw;
    }, ban = function(n) {
        return n.pu.Cj;
    }, van = function(n) {
        return n.pu.Ev;
    }, man = function(n) {
        switch(n){
            case 0:
                return x([
                    Xx("tag--success")
                ]);
            case 1:
                return x([
                    Xx("tag--info")
                ]);
            case 3:
                return x([
                    Xx("tag--warning")
                ]);
            case 2:
                return x([
                    Xx("tag--danger")
                ]);
            case 4:
                return x([
                    Xx("tag--primary")
                ]);
            case 5:
                return x([
                    Xx("tag--primary-500")
                ]);
            default:
                return x([
                    Xx("tag--light-gray")
                ]);
        }
    }, pan = F2(function(n, r) {
        return A2(ak, A2(Yt, Xx("tag"), function(n) {
            return rc(A2(Eu, man, n));
        }(n)), r);
    }), $an = F2(function(n, r) {
        var t, e;
        return e = (t = function() {
            switch(r){
                case 2:
                    return b(2, dan);
                case 1:
                    return b(1, van);
                default:
                    return b(0, ban);
            }
        }()).b, A2(pan, x([
            t.a
        ]), x([
            ld(n(e))
        ]));
    }), han = F2(function(n, r) {
        var t, e;
        return A2(nk, x([
            IC(ean((e = r, e.a.rh))),
            Xx("flex flex-row space-x-2 cursor-pointer")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col mt-2")
            ]), x([
                A2(PE, x([
                    HB
                ]), 17)
            ])),
            A2(nk, x([
                Xx("flex flex-col grow")
            ]), x([
                A2(nk, x([
                    Xx("flex flex-row items-center")
                ]), x([
                    A2(FI, x([
                        bq,
                        _H(_tn)
                    ]), x([
                        ld(n(fan(aan(uan(r)))))
                    ])),
                    A2(Ck, yu, A2($an, n, ian(r)))
                ])),
                A2(nk, x([
                    Xx("flex flex-row text-primary-500")
                ]), x([
                    A2(FI, h, x([
                        ld(n(san(aan(can(r)))))
                    ]))
                ])),
                A2(nk, x([
                    Xx("flex flex-row mt-1")
                ]), x([
                    A2(FI, x([
                        _H(lan)
                    ]), x([
                        ld((t = n(kd), t + ":"))
                    ])),
                    A2(FI, x([
                        bq
                    ]), x([
                        ld(lV(oan(r)))
                    ]))
                ]))
            ])),
            A2(nk, x([
                Xx("flex flex-col justify-center text-primary-300")
            ]), x([
                A2(PE, x([
                    HB
                ]), 6)
            ]))
        ]));
    }), gan = F2(function(n, r) {
        return A2(nk, x([
            Xx("invoices-list")
        ]), A2(HE, Dk, A2(Eu, han(n), r)));
    }), wan = {
        $: 9
    }, xan = function(n) {
        return {
            $: 6,
            a: n
        };
    }, kan = xan(Lq(0)), yan = A2(CN, AN(0), Vt(2)), _an = F2(function(n, r) {
        return A2(QI, x([
            qI(x([
                ld(n(Aun))
            ])),
            EI(x([
                A2(ak, h, x([
                    ld(n(Cun))
                ])),
                A2(nk, x([
                    Xx("flex justify-center my-12")
                ]), x([
                    ik(x([
                        Rnn
                    ]))
                ]))
            ]))
        ]), r);
    }), Aan = F2(function(n, r) {
        var t, e = A2(Eu, function(n) {
            return A2(hq, h, n);
        }, x([
            0,
            1,
            2,
            3
        ])), u = (t = r.fF).$ || 3 !== t.a ? h : x([
            A2(nk, gk(yan), x([
                A2(XH, x([
                    HH(n(Eun))
                ]), x([
                    A2(Ck, wun, A2(w7, h, r.cV))
                ]))
            ])),
            A2(nk, gk(yan), x([
                A2(XH, x([
                    HH(n(_un))
                ]), x([
                    A2(Ck, $un, A2(w7, h, r.cu))
                ]))
            ])),
            A2(nk, gk(yan), x([
                A2(OC, x([
                    qC,
                    EC(wan),
                    uF(i(r.cV.oY, Ut) || i(r.cu.oY, Ut))
                ]), x([
                    ld(n(z3))
                ]))
            ]))
        ]);
        return A2(Yt, A2(Ck, Hun, A4(sF, n, x([
            kan,
            xq(n(z3))
        ]), e, r.fN)), $(u, x([
            A2(_an, n, r.ac)
        ])));
    }), Can = F2(function(n, r) {
        return A2(Ck, cun, A2(zN, h, x([
            A2(EN, x([
                JI(4)
            ]), A2(Aan, n, r))
        ])));
    }), Ban = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ean = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), function() {
                    var t, e = r.g;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return x([
                                A2(nk, h, TE(u) ? r5(n(Gd)) : x([
                                    A2(Can, n, r.de),
                                    A2(gan, n, u),
                                    (t = r.k7, A2(Ck, Ban, A2(Unn, x([
                                        Tnn
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return a6(n(Sd));
                        default:
                            return ck;
                    }
                }())
            ]),
            w5: n(Vd)
        };
    }), Dan = ZA({
        Ar: Pun,
        AQ: zun,
        Db: jun,
        DZ: function() {
            return A2(_S, cun, Px(x([
                A2(_S, Sun, BS())
            ])));
        },
        En: tan,
        Et: Ean
    }), qan = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Fan = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pan = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zan = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            mU: t,
            y5: i,
            hh: c,
            qj: r,
            rh: n,
            hV: e,
            dx: o,
            DL: a,
            wO: u
        };
    }), jan = function(n) {
        switch(n){
            case "processing":
                return uu(0);
            case "invalid":
                return uu(1);
            case "new_payment_source":
                return uu(2);
            case "confirmed":
                return uu(3);
            case "expiring":
                return uu(4);
            case "warning":
                return uu(5);
            case "failed":
                return uu(6);
            case "blocked":
                return uu(7);
            default:
                return Sk("Unsupported Payment Method status: " + n);
        }
    }, San = A4(sy, "one_time_use", iy(jk), Ut, A3(ly, "default", jk, A3(ly, "created_at", KS, A3(ly, "type", C$, A3(ly, "status", A2(nu, jan, C$), A3(ly, "last_four", iy(C$), A3(ly, "bank_name", iy(C$), A3(ly, "expected_to_succeed", jk, A3(ly, "id", C$, uu(zan)))))))))), Lan = A2(Pk, A2(tu, Pan, San), uu(iu)), Man = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nan = A4(sy, "one_time_use", iy(jk), Ut, A3(ly, "funding", iy(C$), A3(ly, "zip", iy(C$), A3(ly, "default", jk, A3(ly, "exp_year", iy(F$), A3(ly, "exp_month", iy(F$), A3(ly, "created_at", KS, A3(ly, "type", C$, A3(ly, "status", A2(nu, jan, C$), A3(ly, "last_four", iy(C$), A3(ly, "card_type", iy(C$), A3(ly, "expected_to_succeed", jk, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            no: t,
                                                            y5: i,
                                                            hh: f,
                                                            hr: c,
                                                            hs: o,
                                                            qj: r,
                                                            qT: l,
                                                            rh: n,
                                                            hV: e,
                                                            dx: d,
                                                            DL: a,
                                                            wO: u,
                                                            x0: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Han = A2(Pk, A2(tu, Man, Nan), uu(iu)), Tan = P$(x([
        Han,
        Lan
    ])), Ian = function(n) {
        return A2(X_, x([
            "payment_sources"
        ]), lL(n));
    }, Ran = F3(function(n, r, t) {
        return A4(W_, n, vy(Tan), t, rA(Ian(r)));
    }), Zan = function(n) {
        return A3(Ran, n.gF, Bx(n.dB), Fan);
    }, Van = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Uan = F6(function(n, r, t, e, u, a) {
        return {
            nK: t,
            qR: a,
            r1: n,
            r2: r,
            wN: e,
            x0: u
        };
    }), Yan = A4(sy, "full_address", C$, "", A3(ly, "zip", A2(tu, RE, C$), A3(ly, "state", C$, A3(ly, "city", C$, A3(ly, "line2", P$(x([
        A2(tu, RE, C$),
        uu("")
    ])), A3(ly, "line1", A2(tu, RE, C$), uu(Uan))))))), Qan = A2(Pk, Yan, uu(iu)), Oan = F7(function(n, r, t, e, u, a, i) {
        return {
            mk: r,
            pl: i,
            qS: t,
            rh: u,
            tg: e,
            CA: n,
            xF: a
        };
    }), Gan = A3(ly, "distance", iy(q$), A3(ly, "virtual", jk, A3(ly, "id", C$, A3(ly, "name", C$, A3(ly, "full_name", C$, A3(ly, "address", iy(Qan), A3(ly, "phone_number", iy(C$), uu(Oan)))))))), Jan = A2(Pk, Gan, uu(iu)), Wan = F4(function(n, r, t, e) {
        return {
            pc: t,
            tg: n,
            CA: r,
            wA: e
        };
    }), Kan = A3(ly, "sources", vy(Tan), A3(ly, "default_source", iy(Tan), A3(ly, "phone_number", iy(A2(tu, RE, C$)), A3(ly, "name", A2(tu, RE, C$), uu(Wan))))), Xan = A2(Pk, Kan, uu(iu)), nin = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rin = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), tin = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), ein = A3(ly, "name", C$, A3(ly, "id", C$, uu(tin))), uin = A2(Pk, ein, uu(iu)), ain = A3(ly, "code", iy(C$), A3(ly, "code_type", iy(C$), A3(ly, "practitioner", iy(uin), A3(ly, "patient", iy(VU), A3(ly, "quantity", F$, A3(ly, "end_date", iy(ay), A3(ly, "date", ay, A3(ly, "taxable", jk, A3(ly, "discount_in_cents", iy(F$), A3(ly, "subtotal_in_cents", F$, A3(ly, "description", iy(A2(tu, RE, C$)), A3(ly, "name", A2(tu, RE, C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        nN: s,
                                                        nO: l,
                                                        oY: a,
                                                        pe: r,
                                                        pi: e,
                                                        p$: i,
                                                        tg: n,
                                                        t6: o,
                                                        uP: f,
                                                        vg: c,
                                                        wW: t,
                                                        w1: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), iin = A2(dD, 0, A2(Pk, ain, uu(rin))), cin = A3(ly, "rate_charge", iin, uu(function(n) {
        return {
            vn: n
        };
    })), oin = F3(function(n, r, t) {
        return {
            yj: r,
            pe: t,
            tg: n
        };
    }), fin = A3(ly, "description", iy(A2(tu, RE, C$)), A3(ly, "amount_in_cents", F$, A3(ly, "name", A2(tu, RE, C$), uu(oin)))), sin = A2(Pk, A2(tu, iu, cin), A2(Pk, fin, uu(nin))), lin = F3(function(n, r, t) {
        return {
            yj: t,
            DK: r,
            DL: n
        };
    }), din = A3(ly, "amount_in_cents", F$, A4(sy, "source_name", iy(C$), Ut, A3(ly, "source_type", C$, uu(lin)))), bin = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vin = F2(function(n, r) {
        return {
            tg: r,
            vm: n
        };
    }), min = A3(ly, "name", C$, A3(ly, "rate", q$, uu(vin))), pin = A2(dD, 0, A2(Pk, min, uu(bin))), $in = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hin = F5(function(n, r, t, e, u) {
        return {
            yj: t,
            mN: r,
            oY: n,
            wz: e,
            wO: u
        };
    }), gin = function(n) {
        return {
            $: 1,
            a: n
        };
    }, win = F2(function(n, r) {
        return {
            zU: r,
            tg: n
        };
    }), xin = A3(ly, "external", jk, A3(ly, "name", C$, uu(win))), kin = A2(Pk, A2(tu, gin, xin), uu(iu)), yin = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _in = F2(function(n, r) {
        return {
            hV: r,
            tg: n
        };
    }), Ain = A3(ly, "last_four", iy(C$), A3(ly, "name", C$, uu(_in))), Cin = A2(Pk, A2(tu, yin, Ain), uu(iu)), Bin = P$(x([
        Cin,
        kin
    ])), Ein = A3(ly, "status", C$, A3(ly, "source", Bin, A3(ly, "amount_in_cents", F$, A3(ly, "attempted_in_cents", F$, A3(ly, "date", ay, uu(hin)))))), Din = A3(ly, "refunded_in_cents", F$, uu(function(n) {
        return {
            vx: n
        };
    })), qin = A2(Pk, A2(tu, iu, Din), A2(Pk, Ein, uu($in))), Fin = A3(ly, "payments", vy(qin), A3(ly, "tax_profile", iy(pin), A3(ly, "charge_group", iy(sin), A3(ly, "charges", vy(iin), A3(ly, "billing_address", iy(Qan), A3(ly, "location", iy(Jan), A3(ly, "owner", Xan, A3(ly, "secure_pdf_printable_token", iy(Zun), A3(ly, "secure_pdf_inline_token", iy(Zun), A4(sy, "savings_items", vy(din), h, A3(ly, "discount_savings_in_cents", F$, A3(ly, "due_in_cents", F$, A4(sy, "passthrough_fees_in_cents", F$, 0, A3(ly, "paid_in_cents", F$, A3(ly, "credit_in_cents", F$, A3(ly, "transferred_to_credit_in_cents", F$, A3(ly, "subtotal_in_cents", F$, A3(ly, "tax_in_cents", F$, A3(ly, "revision_number", F$, A3(ly, "invoice_number", F$, A3(ly, "total_in_cents", F$, A3(ly, "document_status", A2(nu, lun, C$), A3(ly, "date", ay, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(x) {
                                                                                            return function(k) {
                                                                                                return function(y) {
                                                                                                    return {
                                                                                                        mY: g,
                                                                                                        nx: x,
                                                                                                        nA: w,
                                                                                                        oM: f,
                                                                                                        oY: r,
                                                                                                        zo: b,
                                                                                                        pu: t,
                                                                                                        pB: d,
                                                                                                        rh: n,
                                                                                                        rz: u,
                                                                                                        kL: h,
                                                                                                        tU: $,
                                                                                                        t$: s,
                                                                                                        t5: l,
                                                                                                        ur: y,
                                                                                                        vY: a,
                                                                                                        v0: v,
                                                                                                        v3: m,
                                                                                                        Di: p,
                                                                                                        wW: c,
                                                                                                        lI: i,
                                                                                                        w0: k,
                                                                                                        lM: e,
                                                                                                        xk: o
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))), Pin = A2(dD, 0, A2(Pk, Fin, uu(Van))), zin = F2(function(n, r) {
        return A2(X_, x([
            "customer_invoices",
            r
        ]), lL(n));
    }), jin = F4(function(n, r, t, e) {
        return A4(W_, n, Pin, e, rA(A2(zin, r, t)));
    }), Sin = F3(function(n, r, t) {
        var e = {
            gF: r.gF,
            yR: r.yR,
            dc: vc,
            dh: Ut,
            kA: r.kA,
            rh: t.Ck.rh,
            fe: vc,
            t6: r.ud,
            dB: n,
            wA: vc,
            xs: t
        };
        return b(e, Vu(x([
            A4(jin, r.gF, Bx(n), t.Ck.rh, qan),
            Zan(e)
        ])));
    }), Lin = function(n) {
        return n.pc;
    }, Min = function(n) {
        return n.a.pB;
    }, Nin = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hin = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Tin = F2(function(n, r) {
        return {
            t2: n,
            lM: r
        };
    }), Iin = A3(ly, "total_in_cents", F$, A3(ly, "passthrough_fees_in_cents", F$, uu(Tin))), Rin = A2(Pk, Iin, uu(iu)), Zin = uu({}), Vin = A2(Pk, Zin, A2(Pk, Rin, uu(Hin))), Uin = F3(function(n, r, t) {
        return A2(X_, x([
            "payment_methods",
            r,
            "passthroughs",
            oe(t)
        ]), lL(n));
    }), Yin = F5(function(n, r, t, e, u) {
        return A4(W_, n, Vin, u, rA(A3(Uin, r, t, e)));
    }), Qin = function(n) {
        return n.a.rh;
    }, Oin = function(n) {
        return !n.$;
    }, Gin = function(n) {
        return A2(sc, !1, A2(Fp, Oin, n));
    }, Jin = F3(function(n, r, t) {
        var e = n.dB, u = n.gF;
        if (n.yR && Gin(t)) {
            var a = A2(Fp, Qin, t);
            if (a.$) return Pp;
            var i = a.a;
            return A5(Yin, u, Bx(e), i, r, Nin);
        }
        return Pp;
    }), Win = function(n) {
        return n.a.tU;
    }, Kin = F2(function(n, r) {
        var t = m(r, {
            yR: n.yR,
            t6: n.ud
        }), e = b(r.dc, n.ud);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a;
            return b(t, A3(Jin, t, Min(u), Lin(Win(u))));
        }
        return b(t, Pp);
    }), Xin = F2(function(n, r) {
        return m(r, {
            x6: Vt(0)
        });
    }), ncn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rcn = F3(function(n, r, t) {
        return {
            yW: n,
            CD: r,
            xd: t
        };
    }), tcn = {
        $: 2
    }, ecn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ucn = F2(function(n, r) {
        switch(r.$){
            case 0:
            default:
                return v(n, function(n) {
                    return A4(Oun, n.yW, n.CD, n.xd, ecn);
                }(n), h);
            case 1:
                var t = r.a;
                if (3 === t.$) {
                    var e = t.a;
                    return Gun(e) ? v(n, A2(Nu, function() {
                        return tcn;
                    }, jp(2e3)), h) : v(n, A2(sc, Pp, A2(Fp, $Q, nan(e))), h);
                }
                return v(n, Pp, A2(xA, 0, t));
        }
    }), acn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = A2(nv, function(n) {
                        return Vt(A3(rcn, r.gF, Bx(r.dB), n));
                    }, t.a.a.v3);
                    return v(m(r, {
                        dc: t,
                        dh: e
                    }), Pp, A2(xA, 0, t));
                }
                return v(m(r, {
                    dc: t
                }), Pp, A2(xA, 0, t));
            case 1:
                var u = n.a, a = r.dh;
                if (a.$) return v(r, Pp, h);
                var i = A2(ucn, e = a.a, u), c = i.b, o = i.c;
                return v(m(r, {
                    dh: Vt(i.a)
                }), A2(Lp, ncn, c), o);
            case 2:
                var f = n.a;
                return 3 === f.$ ? v(m(r, {
                    wA: f
                }), Pp, h) : v(m(r, {
                    wA: vc
                }), Pp, A2(xA, 0, f));
            default:
                return v(m(r, {
                    fe: n.a
                }), Pp, h);
        }
    }), icn = {
        $: 10
    }, ccn = function(n) {
        return n.a.oY;
    }, ocn = function(n) {
        return A2(NL, aS("/"), n);
    }, fcn = function(n) {
        return A2(ak, x([
            Xx("text-support")
        ]), x([
            A2(IN, x([
                w2,
                LN(_A(Ea))
            ]), x([
                ld(n(Vd))
            ]))
        ]));
    }, scn = {
        $: 0
    }, lcn = F3(function(n, r, t) {
        var e, u = r.gF, a = r.dh.$ ? tB : A2(Ck, ncn, (e = x([
            A2(PE, h, 16)
        ]), A2(OC, x([
            wO,
            gC(x([
                Xx("mr-3")
            ])),
            EC(scn)
        ]), e))), i = wtn(u) ? h : x([
            fcn(n),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld(ocn(ccn(t)))
        ]);
        return A2(nk, h, x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    _N(oB),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), $(i, x([
                    A2(ak, x([
                        Xx("text-primary-300 grow text-right")
                    ]), x([
                        a
                    ]))
                ])))
            ])),
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, h, x([
                    Dk
                ]))
            ]))
        ]));
    }), dcn = function(n) {
        return n.a.pu;
    }, bcn = A2(CN, uH, Vt(0)), vcn = function(n) {
        return n.a.vY;
    }, mcn = function(n) {
        return "#" + oe(n.a.rz) + (vcn(n) ? "(rev. " + oe(vcn(n)) + ")" : "");
    }, pcn = function(n) {
        return n.tg;
    }, $cn = function(n) {
        return A2(cD, "passthrough_credit_card_fees", n);
    }, hcn = function(n) {
        return function(n) {
            return n.lM;
        }(n.a);
    }, gcn = function(n) {
        return 3 === n.$ ? hcn(n.a) : 0;
    }, wcn = function(n) {
        return n.a.ur;
    }, xcn = function(n) {
        return n.a.v0;
    }, kcn = function(n) {
        return A2(GI, 2, n);
    }, ycn = cB(2), _cn = A2(CN, AN(0), Vt(3)), Acn = A2(CN, AN(0), Ut), Ccn = F2(function(n, r) {
        return YE(x([
            ld(n(r))
        ]));
    }), Bcn = function(n) {
        var r, t, e, u = (r = Aen(n), t = function(n) {
            var r = _en(n), t = gen(n), e = b(fM(t), fM(r));
            return e.a && e.b ? "" : A2(fe, ", ", A2(Rc, function(n) {
                return !fM(n);
            }, x([
                t,
                r
            ])));
        }(n), (e = b(fM(t), xen(r))).a && e.b ? Ut : Vt(x([
            ld(t),
            QE(r),
            A2(R7, h, h)
        ]))), a = xen(yen(n)) ? Ut : Vt(x([
            QE(yen(n)),
            A2(R7, h, h)
        ])), i = xen(ken(n)) ? Ut : Vt(x([
            QE(ken(n)),
            A2(R7, h, h)
        ]));
        return A3(Bu, ie, h, A2(Tp, iu, x([
            i,
            a,
            u
        ])));
    }, Ecn = function(n) {
        var r = function(n) {
            return n.CA;
        }(Win(n)), t = function(n) {
            return n.a.mY;
        }(n), e = b(t, r);
        return e.a.$ ? e.b.$ ? h : x([
            A2(Ccn, wB, e.b.a)
        ]) : rc(x([
            Bcn(e.a.a),
            A2(sc, h, A2(Fp, A2(ru, Ccn(wB), VZ), r))
        ]));
    }, Dcn = function(n) {
        return n.mk;
    }, qcn = function(n) {
        return n.CA;
    }, Fcn = function(n) {
        return A2(sc, h, A2(Fp, A2(ru, ld, VZ), A2(Fp, wB, n)));
    }, Pcn = F2(function(n, r) {
        var t, e = r.a.kL;
        return A2(Ek, h, (t = b(A2(nv, Dcn, e), hen(n))).a.$ ? t.b.$ ? h : rc(x([
            Bcn(t.b.a),
            Fcn(qB(n))
        ])) : rc(x([
            Bcn(t.a.a),
            Fcn(A2(nv, qcn, e))
        ])));
    }), zcn = function(n) {
        return n.a.nx;
    }, jcn = function(n) {
        return n.a.yj;
    }, Scn = function(n) {
        return n.a.oY;
    }, Lcn = function(n) {
        return n.a.p$;
    }, Mcn = function(n) {
        return n.rh;
    }, Ncn = function(n) {
        return n.a.t6;
    }, Hcn = function(n) {
        return n.a.vg;
    }, Tcn = function(n) {
        return n.a.w1;
    }, Icn = F2(function(n, r) {
        var t = r.b.vn, e = r.a.tg;
        return rc(x([
            x([
                ld("Charge group")
            ]),
            function() {
                var n = Ncn(t);
                if (n.$) return h;
                var r = n.a;
                return x([
                    A2(nk, h, x([
                        QE(UY(r)),
                        ld("(" + Mcn(r) + ")")
                    ]))
                ]);
            }(),
            x([
                A2(nk, h, x([
                    ld(ocn(Scn(t)))
                ]))
            ]),
            x([
                ld(A2(sc, "", A2(Fp, ocn, Lcn(t))))
            ]),
            Hcn(t) > 1 ? x([
                A2(nk, h, x([
                    ld(oe(Hcn(t)) + " x "),
                    QE(e)
                ]))
            ]) : x([
                A2(nk, h, x([
                    QE(e)
                ]))
            ]),
            function() {
                var n = function(n) {
                    return n.a.pe;
                }(r);
                if (n.$) return h;
                var t = n.a;
                return xen(t) ? h : x([
                    A2(nk, h, x([
                        ld("Note: "),
                        QE(t)
                    ]))
                ]);
            }(),
            x([
                A2(nk, h, x([
                    ld(lV(jcn(r))),
                    Tcn(t) ? ld(n(Id)) : tB
                ]))
            ])
        ]));
    }), Rcn = F2(function(n, r) {
        var t = zcn(r);
        return t.$ ? tB : A2(nk, h, A2(Icn, n, t.a));
    }), Zcn = function(n) {
        return n.j4;
    }, Vcn = function(n) {
        return n.a.nA;
    }, Ucn = function(n) {
        return n.tg;
    }, Ycn = function(n) {
        return n.a.wW;
    }, Qcn = function(n) {
        var r, t = function() {
            var r = b(n.a.pi, Ycn(n));
            if (r.a.$) return 0;
            var t = r.a.a;
            return t > 0 ? t + r.b : 0;
        }(), e = Tcn(n), u = lV(Ycn(n)), a = oe(Hcn(n)), i = A2(Fp, Ucn, n.a.uP), c = function(n) {
            var r = function() {
                var r = b(function(n) {
                    return n.a.nN;
                }(n), function(n) {
                    return n.a.nO;
                }(n));
                if (r.a.$ || r.b.$) return "";
                var t = r.b.a;
                return " (" + $v(r.a.a) + ": " + t + ")";
            }();
            return $(n.a.tg, r);
        }(n), o = A2(Fp, UY, Ncn(n)), f = A2(sc, tB, A2(Fp, QE, o)), s = (r = b(i, o)).a.$ || r.b.$ ? "" : " with " + r.a.a, l = A2(sc, tB, A2(Fp, QE, function(n) {
            return n.a.pe;
        }(n))), d = function(n) {
            var r = Lcn(n);
            if (r.$) return ocn(Scn(n));
            var t = r.a;
            return ocn(Scn(n)) + " - " + ocn(t);
        }(n);
        return {
            oY: d,
            pe: l,
            tg: c,
            la: f,
            dC: i,
            lg: s,
            vg: a,
            wV: u,
            w1: e,
            fV: t
        };
    }, Ocn = function(n) {
        return n.rK;
    }, Gcn = function(n) {
        return n.t6;
    }, Jcn = function(n) {
        return n.vh;
    }, Wcn = function(n) {
        return {
            $: 1,
            a: n
        };
    }(ycn), Kcn = F2(function(n, r) {
        return A3(c9, Ut, n, r);
    }), Xcn = function(n) {
        return n.fV > 0 ? A2(Ek, x([
            jV,
            $H
        ]), x([
            ld(lV(n.fV))
        ])) : tB;
    }, non = F2(function(n, r) {
        return A2(O3, h, x([
            A2(Z3, h, x([
                A2(ak, h, x([
                    A2(X8, h, x([
                        r.la
                    ])),
                    A2(FI, h, x([
                        ld(r.lg)
                    ]))
                ]))
            ])),
            A2(Z3, h, x([
                ld(r.oY)
            ])),
            A2(Z3, h, x([
                QE(r.tg),
                A2(Ek, h, x([
                    r.pe
                ]))
            ])),
            A2(Z3, h, x([
                ld(r.vg)
            ])),
            A2(Z3, x([
                Wcn
            ]), x([
                A2(ak, x([
                    Xx("inline-flex items-center gap-2")
                ]), x([
                    Xcn(r),
                    ld(r.wV)
                ])),
                r.w1 ? ld(n(Id)) : tB
            ]))
        ]));
    }), ron = {
        $: 11
    }, ton = F2(function(n, r) {
        return r.tH(n);
    }), eon = F2(function(n, r) {
        var t = r.fV > 0, e = t ? 12 : 3, u = t ? 12 : 9;
        return A2(zN, x([
            ron,
            JI(12)
        ]), x([
            A2(EN, x([
                JI(u)
            ]), x([
                A2(X8, h, x([
                    r.la
                ])),
                A2(Ek, h, x([
                    QE(r.tg)
                ])),
                A2(Ek, x([
                    $H
                ]), x([
                    ld(r.vg + " x " + r.wV + " "),
                    ld(n(ton(r.oY)))
                ]))
            ])),
            A2(EN, x([
                KN(x([
                    Xx("mb-8 invoice-row-price")
                ])),
                JI(e),
                _N(ycn)
            ]), x([
                A2(ak, x([
                    Xx("inline-flex items-center gap-1")
                ]), x([
                    Xcn(r),
                    A2(X8, h, x([
                        ld(r.wV)
                    ]))
                ])),
                r.w1 ? A2(Ek, x([
                    $H
                ]), x([
                    ld(n(Id))
                ])) : tB
            ]))
        ]));
    }), uon = F2(function(n, r) {
        return A2(zN, x([
            jN(iR)
        ]), x([
            A2(EN, h, x([
                A2(Ek, x([
                    $H,
                    _H(BN),
                    rB(oB)
                ]), x([
                    ld(n(yd)),
                    ld(":")
                ])),
                A2(nk, x([
                    Xx("hidden sm:block")
                ]), x([
                    A2(zN, h, x([
                        A2(EN, x([
                            JI(12)
                        ]), x([
                            A2(Kcn, x([
                                A2(V3, h, n(Gcn)),
                                A2(V3, h, n(XM)),
                                A2(V3, h, n(Ocn)),
                                A2(V3, h, n(Jcn)),
                                A2(V3, x([
                                    Wcn
                                ]), n(Zcn))
                            ]), A2(Eu, non(n), A2(Eu, Qcn, Vcn(r))))
                        ]))
                    ]))
                ])),
                A2(nk, x([
                    Xx("sm:hidden mb-4")
                ]), A2(Eu, eon(n), A2(Eu, Qcn, Vcn(r))))
            ]))
        ]));
    }), aon = function(n) {
        return n.b.lV;
    }, ion = function(n) {
        return n.b.lX;
    }, con = F3(function(n, r, t) {
        var e = be(t) > 0 || aon(r) || ion(r);
        return Min(n) > 0 && e;
    }), oon = function(n) {
        return n.a.rh;
    }, fon = F5(function(n, r, t, e, u) {
        var a = _A(qa({
            rh: oon(t)
        })), i = A2(nc, x([
            ON,
            LN(a)
        ]), u);
        return A3(con, t, r, e) ? A2(IN, i, x([
            ld(n(Nd))
        ])) : tB;
    }), son = {
        $: 2
    }, lon = function(n) {
        return n.a.yj;
    }, don = function(n) {
        return n.a.oY;
    }, bon = iu, von = A2(CN, AN(1), Vt(2)), mon = function(n) {
        return n.a.tg;
    }, pon = function(n) {
        return A2(X8, h, function() {
            var r = function(n) {
                return n.$ ? Ut : n.a.hV;
            }(n);
            if (r.$) return x([
                ld(mon(n))
            ]);
            var t = r.a;
            return x([
                ld(mon(n) + " *" + t)
            ]);
        }());
    }, $on = F2(function(n, r) {
        var t = r.a.wz, e = r.b.vx > 0, u = e ? 12 : 8, a = function(n) {
            return n.a.mN;
        }(r), i = e ? 12 : 4;
        return bon(x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12),
                    bR(2)
                ]), x([
                    pon(t)
                ])),
                A2(EN, x([
                    JI(u),
                    bR(7)
                ]), x([
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(n(ton(ocn(don(r)))))
                    ]))
                ])),
                A2(EN, x([
                    JI(i),
                    bR(3),
                    _N(ycn),
                    KN(x([
                        Xx("invoice-row-price")
                    ]))
                ]), x([
                    e ? A2(FI, x([
                        jV,
                        _H(von)
                    ]), x([
                        ld(lV(a))
                    ])) : tB,
                    ld(lV(lon(r)))
                ]))
            ]))
        ]));
    }), hon = function(n) {
        return {
            $: 4,
            a: n
        };
    }, gon = function(n) {
        return "w-1/" + oe(n);
    }, won = function(n) {
        switch(n.$){
            case 0:
                return x([
                    Xx(gon(r = n.a))
                ]);
            case 1:
                var r = n.b;
                return x([
                    Xx($(bk(n.a), gon(r)))
                ]);
            default:
                return h;
        }
    }, xon = function(n) {
        switch(n.$){
            case 2:
                return x([
                    Xx("list--bordered")
                ]);
            case 3:
                return x([
                    Xx("list--bulleted")
                ]);
            case 4:
                return gk(n.a);
            default:
                return h;
        }
    }, kon = F2(function(n, r) {
        var t = r;
        return A2(hT, A2(Yt, Xx("list__item"), n), t);
    }), yon = F2(function(n, r) {
        var t = A2(tc, xon, n), e = A2(tc, won, n);
        return A2(pT, A2(Yt, Xx("list"), t), A2(Eu, kon(e), r));
    }), _on = F2(function(n, r) {
        return TE(r) ? tB : A2(nk, h, x([
            A2(Ek, x([
                $H,
                _H(BN),
                rB(oB)
            ]), x([
                ld(n(Td)),
                ld(":")
            ])),
            A2(yon, x([
                son,
                hon(fO)
            ]), A2(Eu, $on(n), r))
        ]));
    }), Aon = F2(function(n, r) {
        var t = lV(r.yj), e = n(Od) + " " + t, u = function() {
            var t = b(r.DL, r.DK);
            n: for(;;)if (t.b.$) switch(t.a){
                case "package":
                    return e + " " + n(zd);
                case "membership":
                    return e + " " + n(Pd);
                default:
                    break n;
            }
            else switch(t.a){
                case "package":
                    var u = t.b.a;
                    return e + " " + n(Fd) + " " + u;
                case "membership":
                    return u = t.b.a, e + " " + n(Fd) + " " + u;
                default:
                    break n;
            }
            return e;
        }();
        return A2(zN, x([
            KN(x([
                Xx("mx-3")
            ]))
        ]), x([
            A2(EN, x([
                JI(12),
                _N(ycn)
            ]), x([
                A2(ak, x([
                    Xx("ribbon")
                ]), x([
                    ld(u)
                ]))
            ]))
        ]));
    }), Con = function(n) {
        return n.a.oM;
    }, Bon = function(n) {
        return b(A2(Yt, WN(x([
            Xx("column--offset")
        ])), n), h);
    }, Eon = function(n) {
        return n.a.t$;
    }, Don = function(n) {
        return n.a.t5;
    }, qon = function(n) {
        return function(n) {
            return n.t2;
        }(n.a);
    }, Fon = function(n) {
        return n.a.wW;
    }, Pon = function(n) {
        return n.a.lI;
    }, zon = function(n) {
        return n.a.tg;
    }, jon = function(n) {
        return n.a.w0;
    }, Son = function(n) {
        return n.$ ? "" : OZ(n.a.a.vm) + "%";
    }, Lon = function(n) {
        return n.a.lM;
    }, Mon = function(n) {
        return n.a.xk;
    }, Non = F3(function(n, r, t) {
        return A2(zN, x([
            jN(cR)
        ]), x([
            A2(EN, x([
                JI(8)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n)
                ]))
            ])),
            A2(EN, x([
                JI(4),
                _N(ycn)
            ]), x(t ? [
                A2(X8, x([
                    aq
                ]), x([
                    ld(lV(r))
                ]))
            ] : [
                A2(Ek, h, x([
                    ld(lV(r))
                ]))
            ]))
        ]));
    }), Hon = F3(function(n, r, t) {
        return r > 0 ? A3(Non, n, r, t) : tB;
    }), Ton = F2(function(n, r) {
        return A2(zN, x([
            jN(cR)
        ]), x([
            A2(EN, x([
                JI(6)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n)
                ]))
            ])),
            A2(EN, x([
                JI(6),
                _N(ycn)
            ]), x([
                A2(X8, x([
                    lk
                ]), x([
                    ld(lV(r))
                ]))
            ]))
        ]));
    }), Ion = F5(function(n, r, t, e, u) {
        var a, i, c = Lin(Win(r)), o = e && Gin(c) && Min(r) > 0;
        return $cn(t) ? A2(zN, x([
            KN(x([
                Xx("mx-3")
            ]))
        ]), x([
            Bon(x([
                JI(3),
                bR(7),
                kcn(6)
            ])),
            A2(EN, x([
                JI(9),
                bR(5),
                kcn(6)
            ]), x([
                Pon(r) > 0 ? A3(Non, $v(n(Rd)), Fon(r), !1) : tB,
                A3(Hon, $v(n(Zd)) + " (" + $v((i = jon(r), A2(sc, "", A2(Fp, zon, i)))) + " " + Son(jon(r)) + ")", Pon(r), !1),
                A3(Hon, $v(n(jd)), Lon(r), !0),
                A3(Hon, $v(n(Qd)), Mon(r), !1),
                Con(r) > 0 || Eon(r) > 0 ? Dk : tB,
                Con(r) > 0 ? A3(Non, $v(n(_d)), -1 * Con(r), !1) : tB,
                Eon(r) > 0 ? A3(Non, $v(n(Md)), -1 * Eon(r), !1) : tB,
                Don(r) > 0 ? A3(Non, $v(n(Dd)), -1 * Don(r), !1) : tB,
                Dk,
                o ? A3(Hon, $v(n(Ad)), (a = u, 3 === a.$ ? qon(a.a) : 0), !1) : tB,
                A2(Ton, $v(n(qd)), o ? gcn(u) : Min(r))
            ]))
        ])) : A2(zN, x([
            KN(x([
                Xx("mx-3")
            ]))
        ]), x([
            Bon(x([
                JI(3),
                bR(7),
                kcn(8)
            ])),
            A2(EN, x([
                JI(9),
                bR(5),
                kcn(4),
                _N(ycn)
            ]), x([
                Pon(r) > 0 ? A3(Non, n(Rd), Fon(r), !1) : tB,
                A3(Hon, Son(jon(r)) + " " + n(Zd), Pon(r), !1),
                A3(Hon, n(Ud) + ":", Lon(r), !0),
                A3(Hon, n(Qd), Mon(r), !1),
                A3(Hon, n(_d), Con(r), !1),
                A3(Hon, n(Md), Eon(r), !1),
                Dk,
                A3(Non, n(qd) + ":", Min(r), !1)
            ]))
        ]));
    }), Ron = F4(function(n, r, t, e) {
        var u, a, i, c = r.dB, o = r.yR, f = r.fe;
        return A2(nk, x([
            Xx("text-left")
        ]), x([
            A2(zN, x([
                _N(LI),
                _N(kF),
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(6),
                    kcn(4),
                    _N(LI),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), x([
                    A2(rH, x([
                        ok(x([
                            Xx("text-primary-300 sm:text-xl")
                        ])),
                        rB(LI)
                    ]), x([
                        ld(ocn(ccn(t)))
                    ])),
                    A2(ak, h, x([
                        A2(Ck, yu, A2($an, n, dcn(t)))
                    ]))
                ])),
                A2(EN, x([
                    JI(6),
                    kcn(8),
                    _N(ycn)
                ]), x([
                    A5(fon, n, c, t, e, h)
                ]))
            ])),
            A2(zN, x([
                jN(_cn),
                jN(FO),
                A2(dR, 2, BN)
            ]), x([
                A2(EN, x([
                    kcn(4)
                ]), x([
                    A2(X8, h, x([
                        ld(Ex(c))
                    ])),
                    A2(Pcn, c, t)
                ])),
                A2(EN, x([
                    KN(x([
                        Xx("hidden md:block")
                    ])),
                    kcn(4)
                ]), x([
                    A2(X8, h, x([
                        QE(pcn(Win(t)))
                    ])),
                    A2(nk, h, Ecn(t))
                ])),
                A2(EN, x([
                    kcn(4),
                    jN(bcn),
                    A2(dR, 2, aH)
                ]), x([
                    A2(zN, x([
                        jN(cR),
                        jN(yan),
                        A2(dR, 2, Acn)
                    ]), x([
                        A2(EN, x([
                            JI(6)
                        ]), x([
                            A2(Ek, x([
                                $H
                            ]), x([
                                ld(n(Ld)),
                                ld(": ")
                            ]))
                        ])),
                        A2(EN, x([
                            JI(6)
                        ]), x([
                            A2(Ek, x([
                                rB(ycn)
                            ]), x([
                                ld(mcn(t))
                            ]))
                        ]))
                    ])),
                    A2(zN, x([
                        jN(cR)
                    ]), x([
                        A2(EN, x([
                            JI(6)
                        ]), x([
                            A2(Ek, x([
                                $H
                            ]), x([
                                ld(n(Yd)),
                                ld(": ")
                            ]))
                        ])),
                        (u = Lin(Win(t)), a = o && Gin(u), i = b($cn(c), a), A2(EN, x([
                            JI(6)
                        ]), x(i.a && i.b ? [
                            A2(Ek, x([
                                rB(ycn)
                            ]), x([
                                ld(lV(gcn(f)))
                            ]))
                        ] : [
                            A2(Ek, x([
                                rB(ycn)
                            ]), x([
                                ld(lV(Min(t)))
                            ]))
                        ])))
                    ]))
                ]))
            ])),
            A2(_on, n, wcn(t)),
            A2(uon, n, t),
            A2(Rcn, n, t),
            A5(Ion, n, t, c, o, f),
            A2(nk, x([
                Xx("flex flex-col gap-2")
            ]), A2(Eu, Aon(n), xcn(t)))
        ]));
    }), Zon = F3(function(n, r, t) {
        var e, u = 3 === (e = r.wA).$ ? e.a : h;
        return x([
            A2(nk, x([
                Xx("panel")
            ]), x([
                A3(lcn, n, r, t),
                A4(Ron, n, r, t, u),
                A2(nk, x([
                    Xx("md:hidden")
                ]), x([
                    A5(fon, n, r.dB, t, u, x([
                        icn
                    ]))
                ]))
            ]))
        ]);
    }), Von = function(n) {
        return A2(IN, x([
            LN("mailto:" + n),
            w2
        ]), x([
            ld(n)
        ]));
    }, Uon = function(n) {
        return A2(IN, x([
            LN("tel:" + n),
            w2
        ]), x([
            ld(n)
        ]));
    }, Yon = function(n) {
        var r = b(qB(n), xx(n));
        if (r.a.$) return r.b.$ ? h : (e = r.b.a, x([
            ld(" at "),
            Von(e)
        ]));
        if (r.b.$) return t = r.a.a, x([
            ld(" at "),
            Uon(t)
        ]);
        var t = r.a.a, e = r.b.a;
        return x([
            ld(" at "),
            Uon(t),
            ld(" or "),
            Von(e)
        ]);
    }, Qon = function(n) {
        return A2(nk, x([
            Xx("panel")
        ]), x([
            A2(Ak, x([
                _H(fO)
            ]), x([
                ld("There was an error loading your bill")
            ])),
            A2(Ek, x([
                $H
            ]), rc(x([
                x([
                    ld("Please contact " + Ex(n))
                ]),
                Yon(n),
                x([
                    ld("to request an updated bill.")
                ])
            ])))
        ]));
    }, Oon = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, h, function() {
                    var t = b(r.dc, r.t6);
                    n: for(;;)switch(t.a.$){
                        case 3:
                            if (3 === t.b.$) return A3(Zon, n, r, t.a.a);
                            break n;
                        case 2:
                            return x([
                                A2(Ck, yu, Qon(r.dB))
                            ]);
                        default:
                            break n;
                    }
                    return ck;
                }())
            ]),
            w5: Ex(r.dB)
        };
    }), Gon = ZA({
        Ar: Sin,
        AQ: Kin,
        Db: Xin,
        DZ: function() {
            return zx;
        },
        En: acn,
        Et: Oon
    }), Jon = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Won = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Kon = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Xon = {
        $: 0
    }, nfn = {
        gU: ""
    }, rfn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tfn = F3(function(n, r, t) {
        return {
            yh: t,
            Cs: r,
            Dq: n
        };
    }), efn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ufn = P$(x([
        A2(nu, function(n) {
            switch(n){
                case "stripe":
                    return A2(tu, efn, A2(By, x([
                        "stripe_client_secret"
                    ]), C$));
                case "rainforest":
                    return A2(tu, rfn, A4(cW, tfn, A2(By, x([
                        "session_key"
                    ]), C$), A2(By, x([
                        "payment_method_config_id"
                    ]), C$), A2(By, x([
                        "allowed_methods"
                    ]), C$)));
                default:
                    return Sk("Unsupported processor " + n);
            }
        }, A2(By, x([
            "payment_processor"
        ]), C$)),
        A2(tu, efn, A2(By, x([
            "stripe_client_secret"
        ]), C$))
    ])), afn = F3(function(n, r, t) {
        return A4(bL, n, ufn, t, rA(A2(X_, x([
            "setup"
        ]), function(n) {
            return A2(X_, x([
                "payment_methods"
            ]), lL(n));
        }(r))));
    }), ifn = F6(function(n, r, t, e, u, a) {
        var i = A3(afn, a, Bx(t), Kon);
        return b({
            cl: !1,
            yR: e,
            ky: u,
            kA: r,
            kB: lS(nfn),
            rC: n,
            dB: t,
            s: Xon,
            dP: 1,
            jW: !1
        }, i);
    }), cfn = function(n) {
        var r = n.ud;
        return 3 === r.$ && function(n) {
            return n.mP;
        }(r.a);
    }, ofn = function(n) {
        return OZ(n / 100);
    }, ffn = F2(function(n, r) {
        var t;
        return {
            j4: (t = n, A2(Fp, ofn, t)),
            fa: !1,
            u1: !1,
            wz: r
        };
    }), sfn = function(n) {
        return n.mT;
    }, lfn = function(n) {
        return n.gT;
    }, dfn = F2(function(n, r) {
        return A2(sc, "", A2(Fp, function(r) {
            var t = r.b;
            return A2(Rb, n(r.a), t);
        }, Ce(r)));
    }), bfn = function(n) {
        return n.toUpperCase();
    }, vfn = function(n) {
        return A2(dfn, bfn, n);
    }, mfn = F2(function(n, r) {
        var t = r;
        if (t.$) {
            var e = t.a;
            return A2(sc, n(sfn), e.mU) + " * " + A2(sc, "", e.hV);
        }
        var u = t.a;
        return vfn(A2(sc, n(lfn), u.no)) + " *" + A2(sc, "", u.hV);
    }), pfn = function(n) {
        return n.a.wO;
    }, $fn = function(n) {
        return n.bx.yB;
    }, hfn = function(n) {
        return n.bx.y$;
    }, gfn = function(n) {
        return n.bx.zR;
    }, wfn = function(n) {
        return n.bx.zW;
    }, xfn = function(n) {
        return n.bx.Ax;
    }, kfn = function(n) {
        return n.bx.Bh;
    }, yfn = function(n) {
        return n.bx.u3;
    }, _fn = function(n) {
        return n.bx.Ew;
    }, Afn = F2(function(n, r) {
        var t, e;
        return e = (t = function() {
            switch(r){
                case 1:
                    return b(2, xfn);
                case 6:
                    return b(2, wfn);
                case 5:
                    return b(3, _fn);
                case 4:
                    return b(3, gfn);
                case 0:
                    return b(1, yfn);
                case 2:
                    return b(1, kfn);
                case 3:
                    return b(0, hfn);
                default:
                    return b(2, $fn);
            }
        }()).b, A2(pan, x([
            t.a
        ]), x([
            ld(n(e))
        ]));
    }), Cfn = F2(function(n, r) {
        if (r.$) return A2(ak, x([
            Xx("inline-block my-1")
        ]), x([
            ld(n(lb))
        ]));
        var t = r.a;
        return A2(ak, h, x([
            A2(ak, h, x([
                ld(A2(mfn, n, t))
            ])),
            A2(Afn, n, pfn(t))
        ]));
    }), Bfn = function(n) {
        return n.$ ? Ut : Vt(Qin(n.a));
    }, Efn = F3(function(n, r, t) {
        var e, u = lS(A2(ffn, Ut, Ut)), a = b((e = A6(ifn, !1, r.kA, n, r.yR, Ut, r.gF)).a, A2(Lp, Won, e.b)), i = a.b;
        return b({
            gF: r.gF,
            c3: h,
            yR: r.yR,
            dc: vc,
            kA: r.kA,
            rh: t.Ck.rh,
            b0: vc,
            a3: a.a,
            fe: vc,
            t6: r.ud,
            io: cfn(r),
            ui: vc,
            t: u,
            Cv: m4({
                rh: "payment-source-select",
                Eb: Cfn,
                Ed: Bfn
            }),
            dB: n,
            wV: 0,
            xs: t
        }, Vu(x([
            A4(jin, r.gF, Bx(n), t.Ck.rh, Jon),
            i
        ])));
    }), Dfn = F2(function(n, r) {
        return b(m(r, {
            yR: n.yR,
            io: cfn(n)
        }), Pp);
    }), qfn = F2(function(n, r) {
        return m(r, {
            x6: Vt(0)
        });
    }), Ffn = nr("stripePortOnSetupIntentChange", C$), Pfn = F3(function(n, r, t) {
        return {
            kw: t,
            dz: r,
            fI: n
        };
    }), zfn = F2(function(n, r) {
        return {
            gT: r,
            rh: n
        };
    }), jfn = F4(function(n, r, t, e) {
        return {
            no: r,
            hr: t,
            hs: e,
            hV: n
        };
    }), Sfn = A3(ly, "exp_year", F$, A3(ly, "exp_month", F$, A3(ly, "brand", C$, A3(ly, "last4", C$, uu(jfn))))), Lfn = A4(sy, "card", aL(Sfn), Ut, A3(ly, "payment_method", C$, uu(zfn))), Mfn = A3(ly, "error", iy(C$), A3(ly, "setup_intent", aL(Lfn), A3(ly, "selector", C$, uu(Pfn)))), Nfn = F2(function(n, r) {
        var t = A2(cy, Mfn, r);
        if (t.$) return n(Kt(qy(t.a)));
        var e = t.a, u = e.dz;
        if (1 === u.$) {
            var a = e.kw;
            return n(Kt(1 === a.$ ? "" : a.a));
        }
        return n(te(u.a));
    }), Hfn = nr("stripePortOnSetupIntentConfirmed", w$), Tfn = Px(x([
        (FJ = function(n) {
            return {
                $: 1,
                a: n
            };
        }, Hfn(Nfn(FJ))),
        (qJ = function(n) {
            return {
                $: 2,
                a: n
            };
        }, Ffn(qJ))
    ])), Ifn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rfn = {
        $: 1
    }, Zfn = {
        $: 5
    }, Vfn = function(n) {
        var r = n;
        return A2(Fp, kp, A2(Fp, Ue(100), zS(r)));
    }, Ufn = function(n) {
        return A2(sc, 0, Vfn(A2(sc, "0", n.j4)));
    }, Yfn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Qfn = function(n) {
        return !n.$ && !n.a.$ && Oin(n.a.a);
    }, Ofn = F3(function(n, r, t) {
        var e, u = b(n.yR, Qfn(t));
        if (u.a && u.b) {
            var a = (e = t).$ || e.a.$ ? Ut : Vt(Qin(e.a.a));
            if (a.$) return Pp;
            var i = a.a;
            return A5(Yin, n.gF, Bx(n.dB), i, r, Yfn);
        }
        return Pp;
    }), Gfn = F2(function(n, r) {
        var t = Vfn(r);
        if (t.$) return !1;
        var e = t.a, u = b(n.s4, n.sk);
        if (u.a.$) return !!u.b.$ || 1 > s(e, a = u.b.a);
        if (u.b.$) return s(e, u.a.a) > -1;
        var a = u.b.a;
        return !(0 > s(e, u.a.a) || s(e, a) > 0);
    }), Jfn = F2(function(n, r) {
        return r.$ ? !n.yg : !A2(Gfn, {
            sk: n.sk,
            s4: n.s4
        }, r.a);
    }), Wfn = nM(x([
        function(n) {
            var r = n.j4;
            return A2(Jfn, {
                yg: !0,
                sk: Ut,
                s4: Vt(50)
            }, r) ? x([
                b(0, dM(A2(rM, cM, Zcn)))
            ]) : h;
        }
    ])), Kfn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (t.$) return m(r, {
                    j4: t
                });
                var e = t.a, u = A2(Gfn, {
                    sk: Ut,
                    s4: Vt(0)
                }, e), a = b(Vfn(e), u);
                n: for(; !a.a.$;){
                    if (a.a.a) {
                        if (a.b) return m(r, {
                            j4: Vt(e)
                        });
                        break n;
                    }
                    return m(r, {
                        j4: Vt(e)
                    });
                }
                return r;
            case 1:
                return m(r, {
                    wz: n.a
                });
            case 2:
                var i = n.a;
                return m(r, {
                    fa: i,
                    u1: !i && r.u1
                });
            default:
                return m(r, {
                    u1: n.a
                });
        }
    }), Xfn = function(n) {
        return n.ur.uj;
    }, nsn = F2(function(n, r) {
        switch(r.$){
            case 2:
                return v(m(n, {
                    b0: vc,
                    a3: n.a3,
                    ui: vc
                }), Pp, h);
            case 3:
                var t = r.a, e = A2(Fp, Ifn, Vt(t)), u = $(n.c3, x([
                    t
                ])), a = Ufn(FL(n.t)), i = A3(Ofn, n, a, e), c = lS(A2(ffn, Vt(a), e));
                return v(m(n, {
                    c3: u,
                    b0: r,
                    ui: vc,
                    t: c
                }), i, h);
            default:
                return v(m(n, {
                    b0: r
                }), Pp, A2(xA, 0, r));
        }
    }), rsn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, tsn = {
        $: 0
    }, esn = A2(Nu, iu, _u(tsn)), usn = A2(dD, 0, A2(Pk, Ein, uu($in))), asn = F7(function(n, r, t, e, u, a, i) {
        var c, o = _x(x([
            b("payment", _x(x([
                b("amount_in_cents", EX(e)),
                b("source", _x(x([
                    b("id", Ax(Qin(u))),
                    b("type", Ax((c = u, c.a.DL)))
                ])))
            ]))),
            b("process_outstanding", LC(a))
        ]));
        return A4(bL, n, usn, i, A2(vL, o, rA(A2(X_, x([
            "payments"
        ]), A2(zin, r, t)))));
    }), isn = F4(function(n, r, t, e) {
        var u = e.wz, a = e.u1, i = A2(sc, 0, Vfn(A2(sc, "0", e.j4)));
        return u.$ ? Pp : u.a.$ ? A2(Lp, Won, esn) : A7(asn, n, r, t, i, u.a.a, a, rsn);
    }), csn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, osn = F5(function(n, r, t, e, u) {
        return _x(x([
            b(n.$ ? "rainforest_id" : "stripe_id", Ax(n.a)),
            b("shared", LC(!0)),
            b("one_time_use", LC(r)),
            b("replaces_payment_method_id", A2(yL, Ax, e)),
            b("process_outstanding", LC(t)),
            b("set_as_default", LC(u))
        ]));
    }), fsn = A2(X_, x([
        "payment_methods"
    ]), sL), ssn = F4(function(n, r, t, e) {
        var u = _x(x([
            b("payment_method", A5(osn, r, t.dx, t.u1, t.vG, t.wb))
        ]));
        return A4(bL, n, Tan, e, A2(vL, u, rA(fsn)));
    }), lsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dsn = {
        $: 3
    }, bsn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vsn = {
        $: 2
    }, msn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, psn = {
        $: 0
    }, $sn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hsn = function(n) {
        return v(n, Pp, Ut);
    }, gsn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            nl: e,
            nm: t,
            nn: r,
            r5: c,
            k4: a,
            uL: u,
            fI: n,
            wc: i
        };
    }), wsn = F2(function(n, r) {
        return {
            pZ: r,
            vA: n
        };
    }), xsn = Wn("stripePortBuildAndMountElementWithSetupIntent", function(n) {
        return _x(x([
            b("cardCvcSelector", Ax(n.nl)),
            b("cardExpirySelector", Ax(n.nm)),
            b("cardNumberSelector", Ax(n.nn)),
            b("locale", Ax(n.r5)),
            b("options", function(n) {
                return _x(x([
                    b("encourageAch", LC(n.pZ)),
                    b("rejectAmex", LC(n.vA))
                ]));
            }(n.k4)),
            b("postalCodeSelector", Ax(n.uL)),
            b("selector", Ax(n.fI)),
            b("setupIntentSecret", Ax(n.wc))
        ]));
    }), ksn = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = A8(gsn, r, t, e, u, a, A2(wsn, i, c), o, Tb(n));
        return xsn(f);
    }), ysn = "card-element", _sn = F4(function(n, r, t, e) {
        return A9(ksn, n, "#" + ysn, "#card-number", "#card-expiry", "#card-cvc", "#postal-code", r, t, e);
    }), Asn = Wn("stripePortConfirmSetupIntent", function(n) {
        return _x(x([
            b("options", function(n) {
                return _x(x([
                    b("billingOptions", function(n) {
                        return A3(kx, yx, function(n) {
                            return _x(x([
                                b("name", Ax(n.tg))
                            ]));
                        }, n);
                    }(n.yy))
                ]));
            }(n.k4)),
            b("selector", Ax(n.fI))
        ]));
    }), Csn = F2(function(n, r) {
        return Asn({
            k4: r,
            fI: n
        });
    }), Bsn = Wn("rainforestSubmitPaymentMethod", function() {
        return yx;
    }), Esn = Bsn(0), Dsn = function(n) {
        return n.b.pZ;
    }, qsn = function(n) {
        return n.cH.yi;
    }, Fsn = function(n) {
        return n.cH.qU;
    }, Psn = function(n) {
        return n.cH.rQ;
    }, zsn = function(n) {
        return n.cH.C5;
    }, jsn = function(n) {
        return n.cH.Db;
    }, Ssn = F3(function(n, r, t) {
        var e = v(n, r, t.gU);
        return 2 === e.a.$ && e.b && "AMERICAN_EXPRESS" === e.c ? x([
            b(0, dM(qsn))
        ]) : h;
    }), Lsn = F2(function(n) {
        return 2 === n.$ ? n.a.eR ? h : x([
            b(0, dM(zsn))
        ]) : h;
    }), Msn = F2(function(n, r) {
        return nM(x([
            A2(Ssn, n, r),
            Lsn(n)
        ]));
    }), Nsn = function(n) {
        return !n.b.lW;
    }, Hsn = function(n) {
        return n.wQ;
    }, Tsn = F2(function(n, r) {
        return m(r, {
            gU: n
        });
    }), Isn = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                var e = Vt(bsn(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(n.a)));
                return v(t, Pp, e);
            case 1:
                return v(m(t, {
                    s: msn(m(r, {
                        eR: n.a
                    }))
                }), Pp, Ut);
            case 2:
                return v(m(t, {
                    s: msn(m(r, {
                        AG: !1
                    }))
                }), Pp, Ut);
            case 3:
                return v(m(t, {
                    dP: "ACH" === n.a ? 0 : 1
                }), Pp, Ut);
            default:
                return v(m(t, {
                    kB: A3(dN, Tsn, n.a, t.kB)
                }), Pp, Ut);
        }
    }), Rsn = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = e.$ ? msn({
                        yh: e.a.yh,
                        AG: !0,
                        eR: !1,
                        Cs: e.a.Cs,
                        Dq: e.a.Dq
                    }) : A2($sn, e.a, psn), a = function() {
                        if (e.$) return Pp;
                        var n = e.a;
                        return A4(_sn, r.kA, Nsn(r.dB), Dsn(r.dB), n);
                    }();
                    return v(m(r, {
                        s: u
                    }), a, Ut);
                }
                return hsn(m(r, {
                    s: dsn
                }));
            case 4:
                var i = r.s;
                return 2 === i.$ ? A3(Isn, n.a, i.a, r) : hsn(r);
            case 2:
                return 1 === r.s.$ ? v(m(r, {
                    dP: "us_bank_account" === n.a ? 0 : 1
                }), Pp, Ut) : hsn(r);
            case 0:
                u = 1 === (p = r.s).$ ? A2($sn, p.a, psn) : r.s;
                var c = A2(BM, A2(Msn, r.s, Nsn(r.dB)), r.kB);
                return c.$ ? v(m(r, {
                    cl: !1,
                    kB: c.a,
                    s: u
                }), Pp, Ut) : v(m(r, {
                    cl: !0,
                    kB: c.a.a,
                    s: u
                }), function(n) {
                    switch(n.s.$){
                        case 1:
                            return A2(Csn, "#" + ysn, {
                                yy: Ut
                            });
                        case 2:
                            return Esn;
                        default:
                            return Pp;
                    }
                }(r), Vt(vsn));
            default:
                var o = n.a, f = r.s;
                if (1 === f.$) {
                    var s = f.a;
                    if (o.$) {
                        var l = o.a, d = A2(fu, "billing_details[name]", l) ? Hsn : pA(A3(Dy, "postal code", "ZIP code", l));
                        return b = vu(l) ? Ut : Vt(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(d)), v(m(r, {
                            cl: !1,
                            s: A2($sn, s, lsn(d))
                        }), Pp, b);
                    }
                    var b = Vt(bsn(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(o.a.rh)));
                    return v(m(r, {
                        s: A2($sn, s, psn)
                    }), Pp, b);
                }
                return hsn(r);
        }
        var p;
    }), Zsn = F2(function(n, r) {
        var t = A2(Rsn, r, n.a3), e = t.b, u = t.c, a = m(n, {
            a3: t.a
        }), i = x([
            A2(Lp, Won, e)
        ]);
        n: for(; !u.$;)switch(u.a.$){
            case 1:
                var c = u.a.a, o = FL(n.t), f = o.fa, s = o.u1, l = f ? "Payment Method Added" : "Default Payment Method Changed", d = f ? "True" : "False";
                return v(m(a, {
                    b0: cP
                }), Vu(A2(Yt, A4(ssn, n.gF, c, {
                    dx: f,
                    u1: s,
                    vG: Ut,
                    wb: !f
                }, csn), $(i, x([
                    A2(itn, l, x([
                        A2(otn, "One-Time Payment Method", d)
                    ]))
                ])))), h);
            case 0:
                var b = u.a.a;
                return v(m(a, {
                    b0: vc,
                    ui: vc
                }), Vu(i), x([
                    hA(b)
                ]));
            default:
                break n;
        }
        return v(a, Vu(i), h);
    }), Vsn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = Min(e), a = Lin(Win(e)), c = A2(Fp, Ifn, a), o = A3(Ofn, r, u, c), f = lS(A2(ffn, Vt(u), c)), s = function(n) {
                        return A2(Rc, function(n) {
                            var r;
                            return !A2(sc, !1, (r = n, r.a.dx));
                        }, Win(n).wA);
                    }(e);
                    return v(m(r, {
                        c3: s,
                        dc: t,
                        t: f,
                        wV: u
                    }), o, h);
                }
                return v(m(r, {
                    dc: t
                }), Pp, A2(xA, 0, t));
            case 2:
                return v(m(r, {
                    t: A3(dN, Kfn, n.a, r.t)
                }), Pp, h);
            case 4:
                var l = A2(ZD, n.a, r.Cv), d = l.a, p = l.c, g = function() {
                    if (p.$ || p.a.$) return b(r.t, Pp);
                    var n = p.a.a, t = aon(r.dB) && !i(n, Vt(Rfn)) ? Pp : A2(Nu, iu, _u(Zfn)), e = Ufn(FL(r.t)), u = A3(Ofn, r, e, n);
                    return b(A3(dN, Kfn, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n), r.t), Vu(x([
                        t,
                        u
                    ])));
                }(), w = g.b;
                return v(m(r, {
                    t: g.a,
                    Cv: d
                }), w, h);
            case 5:
                var k = A6(ifn, !1, r.kA, r.dB, r.yR, Ut, r.gF), y = k.b;
                return v(m(r, {
                    a3: k.a
                }), A2(Lp, Won, y), h);
            case 6:
                return A2(Zsn, r, n.a);
            case 7:
                return A2(nsn, r, n.a);
            case 1:
                var _ = A2(BM, Wfn, r.t);
                if (_.$) return v(m(r, {
                    t: _.a
                }), Pp, h);
                var A = _.a, C = A.b;
                return v(m(r, {
                    ui: cP,
                    t: A.a
                }), A4(isn, r.gF, Bx(r.dB), r.rh, C), h);
            case 3:
                var B = n.a, E = function() {
                    var n = b(r.dc, B);
                    if (3 === n.a.$ && 3 === n.b.$) {
                        var t = n.a.a, e = n.b.a;
                        return b(Vu(x([
                            A2(itn, "Invoice Paid", h),
                            A2(AA, da, Da({
                                rh: oon(t)
                            }))
                        ])), "failed" === e.a.wO ? x([
                            A2($A, 1, Xfn)
                        ]) : h);
                    }
                    return b(Pp, h);
                }(), D = E.a, q = E.b;
                return v(m(r, {
                    ui: B
                }), D, $(q, A2(xA, 0, B)));
            case 8:
                return v(m(r, {
                    fe: n.a
                }), Pp, h);
            default:
                var F = Ufn(FL(r.t)), P = (o = A3(Ofn, r, F, FL(r.t).wz), A2(BM, Wfn, r.t));
                return v(m(r, P.$ ? {
                    t: P.a,
                    wV: F
                } : {
                    t: P.a.a,
                    wV: F
                }), o, h);
        }
    }), Usn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), Ysn = Usn, Qsn = function(n) {
        return n.eP.ui;
    }, Osn = function(n) {
        return n.eP.wz;
    }, Gsn = function(n) {
        return n.eP.jD;
    }, Jsn = function(n) {
        return n.eP.w5;
    }, Wsn = function(n) {
        return _A(Da({
            rh: oon(n)
        }));
    }, Ksn = function(n) {
        return A2(IN, x([
            LN(_A(Ea))
        ]), x([
            ld(n(Vd))
        ]));
    }, Xsn = F3(function(n, r, t) {
        return wtn(r) ? tB : A2(zN, x([
            _N(LI),
            jN(iR)
        ]), x([
            A2(EN, x([
                kcn(8),
                A2(Ysn, 2, oB)
            ]), x([
                Ksn(n),
                ld(" / "),
                A2(IN, x([
                    LN(Wsn(t))
                ]), x([
                    ld(A2(NL, aS("/"), ccn(t)))
                ])),
                ld(" / "),
                ld(n(Jsn)),
                Dk
            ]))
        ]));
    }), nln = {
        $: 1
    }, rln = function(n) {
        switch(n.$){
            case 0:
                return "Unauthorized";
            case 1:
                return "BadUrl";
            case 2:
                return "Timeout";
            case 3:
                return "Network";
            case 4:
                return "Server Error";
            case 7:
                return A2(sc, "Internal Server Error", n.a);
            case 5:
                return n.b;
            case 8:
                return "Forbidden";
            case 9:
                return "Not Found";
            default:
                return "Decoder error! " + n.a;
        }
    }, tln = function(n) {
        return 3 === n.$;
    }, eln = function(n) {
        var r = n.s;
        switch(r.$){
            case 3:
                return !1;
            case 2:
                return r.a.eR;
            default:
                return !0;
        }
    }, uln = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aln = F2(function(n, r) {
        return r.v4(n);
    }), iln = F2(function(n, r) {
        return r.v5(n);
    }), cln = F3(function(n, r, t) {
        return A2(Ek, x([
            fq,
            $H
        ]), x([
            ld(r(n ? iln(t) : aln(t)))
        ]));
    }), oln = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fln = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sln = F3(function(n, r, t) {
        return A2(zN, x([
            jN(aH)
        ]), x([
            A2(EN, h, x([
                A2(HT, x([
                    zT(r),
                    PT(A2(pc, fln, oln)),
                    FT(t)
                ]), x([
                    ld(n(mb))
                ]))
            ]))
        ]));
    }), lln = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dln = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bln = {
        $: 2
    }, vln = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mln = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pln = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $ln = pH(3), hln = F3(function(n, r, t) {
        var e = b(r, t);
        return e.a && e.b ? A2(zN, x([
            KN(x([
                Xx("ach-text-fade-in")
            ]))
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("hidden sm:block")
                    ]))
                ]), x([
                    A2(Ek, x([
                        $ln,
                        fq
                    ]), x([
                        ld(n(Cd))
                    ]))
                ])),
                A2(LB, x([
                    ok(x([
                        Xx("block sm:hidden")
                    ]))
                ]), x([
                    A2(Ek, x([
                        $ln,
                        fq
                    ]), x([
                        ld(n(Cd))
                    ]))
                ]))
            ]))
        ])) : tB;
    }), gln = F3(function(n, r, t) {
        return A2(t.lZ, n, r);
    }), wln = F2(function(n, r) {
        return r.l_(n);
    }), xln = F3(function(n, r, t) {
        var e = v(t, r, n);
        return !!e.a && !(e.b && !e.c);
    }), kln = F7(function(n, r, t, e, u, a, i) {
        var c, o, f = (o = b(u, n), r(o.a.$ ? o.b ? wln(e) : A2(gln, e, "2%") : o.b ? wln(e) : (c = lV(o.a.a), A2(gln, e, c))));
        return A3(xln, i, a, t) ? A2(zN, x([
            KN(x([
                Xx(a ? "ach-text-fade-in" : "")
            ]))
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(Ek, x([
                    $ln,
                    fq
                ]), x([
                    ld(f)
                ]))
            ]))
        ])) : tB;
    }), yln = F7(function(n, r, t, e, u, a, i) {
        return n ? A3(hln, t, e, i) : A7(kln, r, t, e, u, a, !0, i);
    }), _ln = MC("hidden"), Aln = F2(function(n, r) {
        return r.uk(n);
    }), Cln = tn, Bln = A2(By, x([
        "detail"
    ]), A2(Cln, 0, A2(By, x([
        "data",
        "payment_method_id"
    ]), C$))), Eln = A2(By, x([
        "detail"
    ]), A2(Cln, 0, C$)), Dln = A2(By, x([
        "detail"
    ]), A2(Cln, 0, C$)), qln = F2(function(n, r) {
        var t = n.Bq, e = n.BL, u = n.B7, a = n.BN, i = n.BR, c = n.Bx;
        return A3(yG, "rainforest-payment", x([
            A2(jC, "session-key", r.Dq),
            A2(jC, "payment-method-config-id", r.Cs),
            A2(jC, "allowed-methods", r.yh),
            r.Ae ? A2(jC, "hide-card-brand-logos", "true") : SC(h),
            A2(jC, "hide-button", ""),
            A2(TC, "approved", A2(tu, t, Bln)),
            A2(TC, "valid", uu(u)),
            A2(TC, "invalid", uu(e)),
            A2(TC, "loaded", uu(a)),
            A2(TC, "method-updated", A2(tu, i, Dln)),
            A2(TC, "card-brand-updated", A2(tu, c, Eln)),
            Xx("mb-4")
        ]), h);
    }), Fln = F4(function(n, r, t, e) {
        return r ? A2(zN, h, x([
            A2(EN, x([
                JI(5)
            ]), x([
                A2(OC, x([
                    qC,
                    EC(tsn),
                    uln(t),
                    uF(t || !e)
                ]), x([
                    ld(n(jsn))
                ]))
            ]))
        ])) : tB;
    }), Pln = function(n) {
        var r = Wx(n.kA), t = function() {
            var r = n.s;
            switch(r.$){
                case 0:
                    return !0;
                case 1:
                default:
                    return !1;
                case 2:
                    return r.a.AG;
            }
        }(), e = eln(n), u = Dsn(n.dB), a = n.yR;
        return x([
            A2(nk, h, x([
                A2(nk, x([
                    _ln(t),
                    Xx("stripe-card")
                ]), x([
                    tB,
                    function() {
                        var t = n.s;
                        switch(t.$){
                            case 3:
                                return A2(nk, x([
                                    Xx("mt-4 mb-4")
                                ]), x([
                                    A2(Ek, x([
                                        bO
                                    ]), x([
                                        ld(r(Aln(Ex(n.dB))))
                                    ]))
                                ]));
                            case 2:
                                var e = t.a, u = e.Dq, a = e.Cs, i = e.yh;
                                return A2(nk, h, x([
                                    A2(qln, {
                                        Bq: A2(ru, lln, mln),
                                        Bx: A2(ru, dln, mln),
                                        BL: mln(pln(!1)),
                                        BN: mln(bln),
                                        BR: A2(ru, vln, mln),
                                        B7: mln(pln(!0))
                                    }, {
                                        yh: i,
                                        Ae: Nsn(n.dB),
                                        Cs: a,
                                        Dq: u
                                    }),
                                    A2(ET, r, A2(PH, 0, n.kB))
                                ]));
                            default:
                                return A2(nk, x([
                                    Hq(ysn),
                                    Xx("mb-4")
                                ]), h);
                        }
                    }(),
                    A2(nk, x([
                        _ln(t)
                    ]), x([
                        A7(yln, a, n.rC, r, u, Ex(n.dB), n.ky, n.dP)
                    ])),
                    A4(Fln, r, n.jW, n.cl, e)
                ])),
                t ? A2(nk, x([
                    Xx("flex justify-center my-12")
                ]), x([
                    ik(x([
                        tk
                    ]))
                ])) : tB
            ]))
        ]);
    }, zln = function(n) {
        return A2(zN, x([
            jN(aH),
            jN(iR)
        ]), x([
            A2(EN, x([
                jN(iR)
            ]), A2(Eu, Ck(Won), Pln(n)))
        ]));
    }, jln = function(n) {
        var r = b(h, x([
            zln(n)
        ]));
        return A2(XH, r.a, r.b);
    }, Sln = F2(function(n, r) {
        return r.tE(n);
    }), Lln = {
        $: 9
    }, Mln = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nln = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Hln = function(n) {
        return A2(ak, x([
            Xx("input-addon")
        ]), n);
    }, Tln = function(n) {
        return A2(nk, x([
            Xx("input-group")
        ]), n);
    }, Iln = {
        eH: h,
        _: h,
        Ax: !1,
        iA: Ut,
        iC: !0,
        xz: Ut
    }, Rln = iu, Zln = function(n) {
        return nB(n) ? Ut : Vt(n);
    }, Vln = function(n) {
        return A2(ru, Zln, A2(ru, Fp(Rln), n));
    }, Uln = function(n) {
        return n;
    }, Yln = function(n) {
        var r, t = function(n) {
            return A3(de, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            _: A2(Yt, gI(Vln(n.a)), r._)
                        });
                    case 9:
                        return m(r, {
                            _: A2(Yt, XT(n.a), r._)
                        });
                    case 1:
                        var t = n.a;
                        return m(r, {
                            _: A2(Yt, xI((e = t, A2(sc, "", A2(Fp, Uln, e)))), r._),
                            xz: t
                        });
                    case 2:
                        return m(r, {
                            Ax: n.a
                        });
                    case 3:
                        return m(r, {
                            eH: n.a
                        });
                    case 4:
                        return m(r, {
                            _: A2(Yt, iI(n.a), r._)
                        });
                    case 5:
                        return m(r, {
                            _: A2(Yt, YT(n.a), r._)
                        });
                    case 6:
                        return m(r, {
                            iA: Vt(n.a)
                        });
                    case 7:
                        return m(r, {
                            iC: !1
                        });
                    default:
                        return m(r, {
                            _: A2(Yt, yR(n.a), r._)
                        });
                }
                var e;
            }), Iln, n);
        }(n), e = t.iC ? Hln(x([
            ld("$")
        ])) : tB;
        return Tln(A2(Yt, e, A2(Yt, vI(A2(Yt, JT(t.Ax), t._)), (r = t.iA).$ ? h : x([
            Hln(x([
                ld(r.a)
            ]))
        ]))));
    }, Qln = F2(function(n, r) {
        var t, e, u, a = FL(r);
        return x([
            Yln(x([
                (u = a.j4, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u)),
                (e = A2(pc, fln, Mln), function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(e)),
                (t = A2(QH, 0, r), function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(t)),
                Nln(Lln)
            ])),
            A2(ET, n, A2(PH, 0, r))
        ]);
    }), Oln = F5(function(n, r, t, e, u) {
        var a, i = !((a = b(t, u)).a.$ || !a.b) && qon(a.a.a) > 0;
        return A2(XH, x([
            HH(n(Qsn)),
            VH(!0)
        ]), rc(x([
            zcn(r).$ ? A2(Qln, n, e) : function(n) {
                return x([
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(lV(Min(n)))
                    ]))
                ]);
            }(r),
            x([
                A2(Ek, x([
                    $H,
                    _H(yan)
                ]), x([
                    ld(n(Sln(lV(Min(r))))),
                    ld(" "),
                    i ? ld("(+ " + UQ(n(Ed)) + " )") : tB
                ]))
            ])
        ])));
    }), Gln = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Jln = function(n) {
        return n.fC;
    }, Wln = F5(function(n, r, t, e, u) {
        var a = A2(Eu, function(n) {
            return A2(hq, h, Ifn(n));
        }, t), i = aon(r) || ion(r) ? TE(a) ? x([
            A2(hq, h, Rfn)
        ]) : A2(Yt, A2(hq, h, Rfn), A2(Yt, pq, a)) : a;
        return A2(XH, x([
            HH(n(Osn))
        ]), x([
            A2(Ck, Gln, A4(sF, n, x([
                Dq(e),
                xq(n(Jln)),
                vq
            ]), i, u))
        ]));
    }), Kln = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Xln = F5(function(n, r, t, e, u) {
        return u && r ? A2(zN, x([
            jN(aH)
        ]), x([
            A2(EN, h, x([
                A2(HT, x([
                    zT(t),
                    PT(A2(pc, fln, Kln)),
                    FT(e)
                ]), x([
                    ld(n(kb))
                ]))
            ]))
        ])) : tB;
    }), ndn = {
        $: 9
    }, rdn = function(n) {
        return n.dM.yZ;
    }, tdn = function(n) {
        return n.dM.z7;
    }, edn = function(n) {
        return n.dM.Cf;
    }, udn = function(n) {
        return n.dM.CC;
    }, adn = function(n) {
        return n.dM.D0;
    }, idn = function(n) {
        return A2(zN, x([
            KN(x([
                Xx("px-1")
            ])),
            jN(yan)
        ]), x([
            A2(EN, x([
                kcn(9),
                bR(8)
            ]), x([
                A2(Ek, x([
                    fq,
                    $H
                ]), x([
                    ld(n(edn)),
                    ld(" "),
                    A2(IN, x([
                        LN("http://www.hint.com"),
                        MN,
                        ndn,
                        w2
                    ]), x([
                        ld(n(udn))
                    ])),
                    ld(" "),
                    ld(n(adn)),
                    ld(" "),
                    A2(IN, x([
                        LN("http://www.hint.com/security"),
                        MN,
                        ndn,
                        w2
                    ]), x([
                        ld(n(rdn))
                    ])),
                    ld(" "),
                    ld(n(tdn))
                ]))
            ])),
            A2(EN, x([
                kcn(3),
                bR(4),
                A2(Ysn, 1, ycn),
                jN(yan),
                A2(dR, 1, Acn)
            ]), x([
                A2(k3, x([
                    Xx("inline"),
                    zG("https://cdn2.hubspot.net/hubfs/2562809/production-app/pci_dss_compliant.png")
                ]), h),
                A2(k3, x([
                    Xx("inline ml-6"),
                    zG("https://cdn2.hubspot.net/hubfs/2562809/production-app/hipaa_compliant.png")
                ]), h)
            ]))
        ]));
    }, cdn = F3(function(n, r, t) {
        return A2(zN, x([
            jN(cR)
        ]), x([
            A2(EN, x([
                JI(6)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n)
                ]))
            ])),
            A2(EN, x([
                JI(6),
                _N(ycn)
            ]), x(t ? [
                A2(X8, x([
                    aq
                ]), x([
                    ld(lV(r))
                ]))
            ] : [
                A2(Ek, h, x([
                    ld(lV(r))
                ]))
            ]))
        ]));
    }), odn = F3(function(n, r, t) {
        return A2(nk, h, x([
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(DB)
                ]), x([
                    A2(WH, x([
                        _H(cR),
                        yF,
                        lk
                    ]), x([
                        ld(n(Hd))
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A3(cdn, $v(n(Rd)), t, !1),
                    qon(r) > 0 ? A3(cdn, $v(n(Ad)), qon(r), !1) : tB,
                    Dk,
                    A3(cdn, $v(n(Ud)), hcn(r), !0)
                ]))
            ]))
        ]));
    }), fdn = F4(function(n, r, t, e) {
        var u, a, c = e.dB, o = e.t, f = e.ui, s = e.Cv, l = e.a3, d = e.b0, v = e.io, m = e.wV, p = e.c3, $ = e.yR && Qfn(FL(o).wz), g = !(a = FL(o).wz).$ && 1 === a.a.$, w = FL(o), k = w.wz, y = w.fa, _ = w.u1, A = n(k.$ || 1 !== k.a.$ ? Gsn : lb);
        return x([
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A2(Ak, x([
                        _H(cR)
                    ]), x([
                        ld(n(Jsn))
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A5(Wln, n, c, p, k, s)
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A5(Oln, n, r, t, o, $)
                ]))
            ])),
            (u = b($, t), u.a && !u.b.$ ? A3(odn, n, u.b.a, m) : A2(zN, h, h)),
            k.$ || 1 !== k.a.$ ? tB : A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A3(sln, n, y, tln(d)),
                    A5(Xln, n, v, _, tln(d), !y),
                    jln(l),
                    Dk,
                    A3(cln, !1, n, Ex(c))
                ]))
            ])),
            idn(n),
            Dk,
            A2(zN, h, x([
                A2(EN, x([
                    JI(12),
                    _N(oB)
                ]), x([
                    A2(IN, x([
                        SN,
                        LN(Wsn(r))
                    ]), x([
                        ld(n(P3))
                    ])),
                    A2(OC, x([
                        qC,
                        uF(i(f, cP) || !m),
                        uln(i(f, cP)),
                        EC(nln),
                        uF(g && !eln(l))
                    ]), x([
                        ld(A)
                    ]))
                ]))
            ])),
            function() {
                if (2 === f.$) {
                    var n = f.a;
                    return A2(ak, x([
                        A2(bT, "color", "red")
                    ]), x([
                        ld(rln(n))
                    ]));
                }
                return tB;
            }()
        ]);
    }), sdn = F4(function(n, r, t, e) {
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), A4(fdn, n, r, t, e))
        ]));
    }), ldn = F4(function(n, r, t, e) {
        return x([
            A2(nk, x([
                Xx("panel")
            ]), x([
                A3(Xsn, n, r.gF, t),
                A4(sdn, Wx(r.kA), t, e, r)
            ]))
        ]);
    }), ddn = F2(function(n, r) {
        return {
            gN: function() {
                var t = r.dc;
                switch(t.$){
                    case 3:
                        var e = t.a, u = r.fe;
                        switch(u.$){
                            case 3:
                                return A4(ldn, n, r, e, Vt(u.a));
                            case 2:
                                return x([
                                    A2(Ck, yu, Qon(r.dB))
                                ]);
                            default:
                                return A4(ldn, n, r, e, Ut);
                        }
                    case 2:
                        return x([
                            A2(Ck, yu, Qon(r.dB))
                        ]);
                    default:
                        return ck;
                }
            }(),
            w5: "Account.Invoices.Payments.Create"
        };
    }), bdn = ZA({
        Ar: Efn,
        AQ: Dfn,
        Db: qfn,
        DZ: function() {
            return Px(x([
                A2(_S, Won, Tfn),
                zx
            ]));
        },
        En: Vsn,
        Et: ddn
    }), vdn = {
        $: 0
    }, mdn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pdn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $dn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hdn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            op: a,
            p3: u,
            qb: r,
            rh: n,
            tk: i,
            Cz: t,
            uE: e,
            wF: c
        };
    }), gdn = function(n) {
        switch(n){
            case "active":
                return uu(2);
            case "inactive":
                return uu(3);
            case "unconfirmed":
                return uu(0);
            case "pending":
                return uu(1);
            default:
                return Sk("Unsupported membership enrollment status: " + n);
        }
    }, wdn = function(n) {
        var r = O8(n);
        return r.$ ? Sk("Unsupported period code: " + oe(n)) : uu(r.a);
    }, xdn = F2(function(n, r) {
        return {
            yj: n,
            oY: r
        };
    }), kdn = A3(ly, "date", ay, A3(ly, "amount_in_cents", F$, uu(xdn))), ydn = A2(Pk, kdn, uu(iu)), _dn = A3(ly, "sponsored", jk, A3(ly, "next_future_unpaid_bill", ydn, A3(ly, "contract_auto_renew", jk, A3(ly, "ending_contract_end_date", iy(KS), A3(ly, "plan_name", C$, A3(ly, "period_in_months", A2(nu, wdn, F$), A3(ly, "enrollment_status", A2(nu, gdn, C$), A3(ly, "id", C$, uu(hdn))))))))), Adn = A2(dD, 0, A2(Pk, _dn, uu($dn))), Cdn = F3(function(n, r, t) {
        return A4(W_, n, vy(Adn), t, rA(function(n) {
            return A2(X_, x([
                "memberships"
            ]), lL(n));
        }(r)));
    }), Bdn = F3(function(n, r) {
        return b({
            gF: r.gF,
            kA: r.kA,
            az: vdn,
            aa: h,
            lb: vc,
            dB: n
        }, Vu(x([
            A3(WR, r.gF, Bx(n), pdn),
            A3(Cdn, r.gF, Bx(n), mdn)
        ])));
    }), Edn = F2(function(n, r) {
        return b(r, Pp);
    }), Ddn = F2(function(n, r) {
        return m(r, {
            x6: Vt(1)
        });
    }), qdn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Fdn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Pdn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), zdn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jdn = {
        $: 3
    }, Sdn = function(n) {
        return n.a.qb;
    }, Ldn = F2(function(n, r) {
        return A2(Rc, function(r) {
            return A2(SE, Sdn(r), n);
        }, r);
    }), Mdn = function(n) {
        return n.a.rh;
    }, Ndn = function(n) {
        return A2(AA, da, Ma({
            rh: Mdn(n)
        }));
    }, Hdn = function(n) {
        return n.a.uE;
    }, Tdn = F2(function(n, r) {
        return $(Hdn(r), 1 === Sdn(r) ? " (Pending)" : "");
    }), Idn = function(n) {
        return n.a.wF;
    }, Rdn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    lb: t
                }), Pp, h) : v(m(r, {
                    lb: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return v(m(r, {
                        aa: A2(Rc, function(n) {
                            return !Idn(n);
                        }, A2(Ldn, x([
                            2,
                            1
                        ]), u))
                    }), Pp, h);
                }
                return v(r, Pp, A2(xA, 0, e));
            case 2:
                var a = rv(r.aa);
                if (a.$) return v(r, Pp, h);
                var i = a.a, c = function() {
                    if (1 === be(r.aa)) return b(r, Ndn(i));
                    var n = dd({
                        rh: "membership-select",
                        Eb: Tdn,
                        Ed: function(n) {
                            return Vt(Hdn(n));
                        }
                    }), t = A2(fS, 0, jdn), e = t.b, u = A3(Pdn, t.a, n, Vt(i));
                    return b(m(r, {
                        az: u
                    }), e);
                }();
                return v(c.a, c.b, h);
            case 3:
                return v(m(r, {
                    az: vdn
                }), Pp, h);
            case 4:
                var o = r.az;
                if (1 === o.$) {
                    var f = o.b, s = o.c, l = A2(lN, n.a, $ = o.a), d = l.b;
                    return v(m(r, {
                        az: A3(Pdn, l.a, f, s)
                    }), A2(Lp, Fdn, d), h);
                }
                return v(r, Pp, h);
            case 5:
                return v(1 === n.a ? m(r, {
                    az: vdn
                }) : r, Pp, h);
            case 6:
                var p = r.az;
                if (p.$) {
                    var $ = p.a, g = (s = p.c, A2(ZD, n.a, f = p.b)), w = g.a, k = g.b;
                    return v(A2(sc, r, A2(Fp, function(n) {
                        return m(r, n.$ ? {
                            az: A3(Pdn, $, w, s)
                        } : {
                            az: A3(Pdn, $, w, n.a)
                        });
                    }, g.c)), A2(Lp, zdn, k), h);
                }
                return v(r, Pp, h);
            default:
                return v(r, Ndn(s = n.a), h);
        }
    }), Zdn = {
        $: 2
    }, Vdn = F3(function(n, r, t) {
        return !TE(t) && function(n) {
            return A2(cD, "self_serve_add_member", n);
        }(r) ? A2(nk, x([
            Xx("mt-8")
        ]), x([
            A2(OC, x([
                oF,
                EC(Zdn)
            ]), x([
                ld(n(Jd.l7))
            ]))
        ])) : tB;
    }), Udn = function(n) {
        return n.a.mr;
    }, Ydn = F2(function(n, r) {
        return r.ss(n);
    }), Qdn = function(n) {
        return n.sx;
    }, Odn = F2(function(n, r) {
        return A2(IN, x([
            LN(_A(Pa({
                rh: r
            })))
        ]), x([
            ld(n(Jd.sj))
        ]));
    }), Gdn = F2(function(n, r) {
        var t = n8(r) ? Vt(n(Qdn)) : Ut, e = A2(Fp, A2(ru, oe, A2(ru, Ydn, n)), Udn(r)), u = A2(fe, ", ", A2(Tp, iu, x([
            t,
            e
        ])));
        return A2(zN, x([
            ron,
            JI(12)
        ]), x([
            A2(EN, x([
                KN(x([
                    Xx("flex justify-between items-center")
                ]))
            ]), x([
                A2(nk, x([
                    Xx("grid text-left ml-2")
                ]), x([
                    A2(X8, x([
                        ok(x([
                            Xx("mb-1")
                        ]))
                    ]), x([
                        QE(aU(r))
                    ])),
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(u)
                    ]))
                ])),
                A2(nk, h, x([
                    A2(Odn, n, uU(r))
                ]))
            ]))
        ]));
    }), Jdn = F2(function(n, r) {
        return A2(Eu, Gdn(n), r);
    }), Wdn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Kdn = function(n) {
        return n.oa;
    }, Xdn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, nbn = F4(function(n, r, t, e) {
        return A2(nk, h, x([
            A2(Ek, x([
                $H,
                _H(fO)
            ]), x([
                ld("You\u2019re about to add a new member to one of your membership plans. Please, select the membership plan\n                that you want to update.")
            ])),
            A2(nk, x([
                Xx("mb-12")
            ]), x([
                A2(XH, x([
                    HH("Membership"),
                    VH(!0)
                ]), x([
                    A2(Ck, zdn, A4(sF, n, x([
                        Dq(e),
                        xq("Select membership")
                    ]), A2(Eu, function(n) {
                        return A2(hq, h, n);
                    }, r), t))
                ]))
            ])),
            Dk,
            A2(nk, x([
                Xx("mt-4"),
                A2(bT, "text-align", "right")
            ]), x([
                A2(OC, x([
                    oF,
                    Xdn(!0),
                    EC(jdn)
                ]), x([
                    ld(n(P3))
                ])),
                function() {
                    if (e.$) return tB;
                    var r = e.a;
                    return A2(OC, x([
                        qC,
                        Xdn(!0),
                        EC(Wdn(r))
                    ]), x([
                        ld(n(Kdn))
                    ]));
                }()
            ]))
        ]));
    }), rbn = A2(Ek, h, x([
        ld("Select Membership Plan")
    ])), tbn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = t.c, i = x([
                qI(x([
                    rbn
                ])),
                EI(x([
                    A4(nbn, n, r, u, a)
                ]))
            ]);
            return A2(QI, i, NM(e));
        }
        return tB;
    }), ebn = F5(function(n, r, t, e, u) {
        return A2(Yt, A3(tbn, n, e, u), $(A2(Jdn, n, r), x([
            A3(Vdn, n, t, e)
        ])));
    }), ubn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), function() {
                    var t = r.lb;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return TE(e) ? r5(n(Jd.EE)) : A5(ebn, n, e, r.dB, r.aa, r.az);
                        case 2:
                            return a6(n(Jd.dr));
                        default:
                            return ck;
                    }
                }())
            ]),
            w5: n(Jd.w5)
        };
    }), abn = ZA({
        Ar: Bdn,
        AQ: Edn,
        Db: Ddn,
        DZ: function(n) {
            return n.az.$ ? Px(x([
                kY(fY(qdn)),
                A2(_S, Fdn, BS())
            ])) : zx;
        },
        En: Rdn,
        Et: ubn
    }), ibn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cbn = A2(nu, function(n) {
        switch(n){
            case "en":
                return uu(0);
            case "es":
                return uu(1);
            default:
                return Sk("Invalid language");
        }
    }, C$), obn = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(r){
            case "female":
                return uu(Vt(0));
            case "male":
                return uu(Vt(1));
            case "other":
                return uu(Vt(2));
            case "":
                return uu(Ut);
            default:
                return Sk("Unsupported Gender: " + r);
        }
    }, fbn = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(r){
            case "man":
                return uu(Vt(0));
            case "woman":
                return uu(Vt(1));
            case "non-binary":
                return uu(Vt(2));
            case "trans man":
                return uu(Vt(3));
            case "trans woman":
                return uu(Vt(4));
            case "not listed":
                return uu(Vt(5));
            case "":
                return uu(Ut);
            default:
                return Sk("Unsupported Gender identity: " + r);
        }
    }, sbn = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(r){
            case "He/Him/His":
                return uu(Vt(0));
            case "She/Her/Hers":
                return uu(Vt(1));
            case "They/Them/Theirs":
                return uu(Vt(2));
            case "Other":
                return uu(Vt(3));
            case "":
                return uu(Ut);
            default:
                return Sk("Unsupported Pronouns: " + r);
        }
    }, lbn = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(r){
            case "female":
                return uu(Vt(0));
            case "male":
                return uu(Vt(1));
            case "intersex":
                return uu(Vt(2));
            case "":
                return uu(Ut);
            default:
                return Sk("Unsupported Sex: " + r);
        }
    }, dbn = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(XC(r)){
            case "Ms.":
            case "Ms":
                return uu(Vt(0));
            case "Mrs.":
            case "Mrs":
                return uu(Vt(1));
            case "Miss.":
            case "Miss":
                return uu(Vt(2));
            case "Mr.":
            case "Mr":
                return uu(Vt(3));
            case "Dr.":
            case "Dr":
                return uu(Vt(4));
            case "Mx.":
            case "Mx":
                return uu(Vt(5));
            case "":
                return uu(Ut);
            default:
                return Sk("Unsupported Title: " + r);
        }
    }, bbn = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), vbn = A2(Pk, bbn, uu(iu)), mbn = F7(function(n, r, t, e, u, a, i) {
        return {
            pP: e,
            qB: u,
            rh: n,
            rS: a,
            tg: r,
            uw: i,
            vB: t
        };
    }), pbn = F3(function(n, r, t) {
        return {
            hN: t,
            CA: n,
            iv: r
        };
    }), $bn = A2(nu, function(n) {
        switch(n){
            case "mobile":
                return uu(Zj);
            case "home":
                return uu(ER);
            case "office":
                return uu(DR);
            default:
                return uu(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n));
        }
    }, C$), hbn = A3(ly, "us_formattable", jk, A3(ly, "type", $bn, A3(ly, "number", C$, uu(pbn)))), gbn = A2(Pk, A2(tu, iu, hbn), uu(iu)), wbn = A3(ly, "phone", aL(gbn), A3(ly, "last_name", aL(C$), A3(ly, "first_name", aL(C$), A3(ly, "email", aL(C$), A3(ly, "relationship", aL(C$), A3(ly, "name", C$, A3(ly, "id", C$, uu(mbn)))))))), xbn = A2(Pk, wbn, uu(iu)), kbn = F6(function(n, r, t, e, u, a) {
        return {
            nq: u,
            q_: r,
            rc: e,
            rh: n,
            su: t,
            uh: a
        };
    }), ybn = F2(function(n, r) {
        return {
            q1: r,
            tg: n
        };
    }), _bn = F4(function(n, r, t, e) {
        return {
            nU: r,
            nV: e,
            nZ: t,
            rh: n
        };
    }), Abn = A3(ly, "collect_high_deductible", jk, A3(ly, "collect_member_id", jk, A3(ly, "collect_group_id", jk, A3(ly, "id", C$, uu(_bn))))), Cbn = A2(Pk, Abn, uu(iu)), Bbn = A3(ly, "carrier", Cbn, A3(ly, "name", C$, uu(ybn))), Ebn = A2(Pk, Bbn, uu(iu)), Dbn = A3(ly, "payer_name", iy(C$), A3(ly, "carrier_alias", iy(Ebn), A3(ly, "high_deductible", iy(jk), A3(ly, "member_id", iy(C$), A3(ly, "group_id", iy(C$), A3(ly, "id", C$, uu(kbn))))))), qbn = A2(Pk, Dbn, uu(iu)), Fbn = function(n) {
        return A2(nv, function(n) {
            return vu(n) ? Ut : Vt(n);
        }, n);
    }, Pbn = F2(function(n, r) {
        return {
            pl: r,
            rh: n
        };
    }), zbn = A3(ly, "distance", iy(q$), A3(ly, "id", C$, uu(Pbn))), jbn = A2(Pk, zbn, uu(iu)), Sbn = A3(ly, "status", C$, A3(ly, "panel_size", F$, A3(ly, "max_patient_age", aL(F$), A3(ly, "min_patient_age", aL(F$), A3(ly, "education", aL(vy(C$)), A3(ly, "specialties", vy(C$), A3(ly, "locations", vy(jbn), A3(ly, "photo", A2(tu, Fbn, aL(C$)), A3(ly, "bio", aL(C$), A3(ly, "name", C$, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    na: t,
                                                    pO: i,
                                                    rh: n,
                                                    hZ: u,
                                                    sm: o,
                                                    s7: c,
                                                    tg: r,
                                                    t0: f,
                                                    uz: e,
                                                    wD: a,
                                                    wO: s
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), Lbn = A2(Pk, Sbn, uu(iu)), Mbn = A3(ly, "number", C$, uu(function(n) {
        return {
            tA: n
        };
    })), Nbn = A2(Pk, A2(tu, iu, Mbn), uu(iu)), Hbn = A3(ly, "should_charge_credit_card_fees", jk, A3(ly, "emergency_contact", iy(xbn), A3(ly, "autopay", jk, A3(ly, "preferred_language", cbn, A3(ly, "location", iy(Jan), A3(ly, "practitioner", iy(Lbn), A3(ly, "company", iy(vbn), A3(ly, "title", A2(nu, dbn, iy(C$)), A3(ly, "ssn", iy(Nbn), A3(ly, "sex", A2(nu, lbn, iy(C$)), A3(ly, "pronoun_other", iy(C$), A3(ly, "pronouns", A2(nu, sbn, iy(C$)), A3(ly, "phones", iy(vy(gbn)), A3(ly, "name", A2(tu, RE, C$), A3(ly, "middle_name", iy(C$), A3(ly, "suffix", iy(C$), A3(ly, "last_name", C$, A3(ly, "id", C$, A3(ly, "health_insurance", iy(qbn), A3(ly, "gender_identity", A2(nu, fbn, iy(C$)), A3(ly, "gender", A2(nu, obn, iy(C$)), A3(ly, "first_name", C$, A3(ly, "email", iy(C$), A3(ly, "dob", iy(ay), A3(ly, "chosen_suffix", iy(C$), A3(ly, "chosen_title", A2(nu, dbn, iy(C$)), A3(ly, "chosen_middle_name", iy(C$), A3(ly, "chosen_last_name", iy(C$), A3(ly, "chosen_first_name", iy(C$), A3(ly, "address_zip", iy(C$), A3(ly, "address_state", iy(C$), A3(ly, "address_line2", iy(C$), A3(ly, "address_line1", iy(C$), A3(ly, "address_country", iy(C$), A3(ly, "address_city", iy(C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(x) {
                                                                                            return function(k) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(A) {
                                                                                                            return function(C) {
                                                                                                                return function(B) {
                                                                                                                    return function(E) {
                                                                                                                        return function(D) {
                                                                                                                            return function(q) {
                                                                                                                                return function(F) {
                                                                                                                                    return function(P) {
                                                                                                                                        return function(z) {
                                                                                                                                            return function(j) {
                                                                                                                                                return {
                                                                                                                                                    ml: n,
                                                                                                                                                    mm: r,
                                                                                                                                                    mn: t,
                                                                                                                                                    mo: e,
                                                                                                                                                    mp: u,
                                                                                                                                                    mq: a,
                                                                                                                                                    mP: P,
                                                                                                                                                    nF: i,
                                                                                                                                                    nG: c,
                                                                                                                                                    nH: o,
                                                                                                                                                    nI: s,
                                                                                                                                                    nJ: f,
                                                                                                                                                    n4: E,
                                                                                                                                                    pn: l,
                                                                                                                                                    pP: d,
                                                                                                                                                    qB: b,
                                                                                                                                                    qV: v,
                                                                                                                                                    qW: m,
                                                                                                                                                    q0: p,
                                                                                                                                                    rh: $,
                                                                                                                                                    rS: h,
                                                                                                                                                    kL: q,
                                                                                                                                                    s2: w,
                                                                                                                                                    tg: x,
                                                                                                                                                    uy: k,
                                                                                                                                                    uP: D,
                                                                                                                                                    uU: F,
                                                                                                                                                    u4: _,
                                                                                                                                                    u5: y,
                                                                                                                                                    we: A,
                                                                                                                                                    wh: j,
                                                                                                                                                    wG: C,
                                                                                                                                                    wY: g,
                                                                                                                                                    w5: B,
                                                                                                                                                    xv: z
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))))))), Tbn = A2(Pk, Hbn, uu(iu)), Ibn = F2(function(n, r) {
        return A2(X_, x([
            "patients",
            r
        ]), lL(n));
    }), Rbn = F4(function(n, r, t, e) {
        return A4(W_, n, Tbn, e, rA(A2(Ibn, r, t)));
    }), Zbn = F3(function(n, r, t) {
        var e = t.Ck;
        return b({
            gF: r.gF,
            kA: r.kA,
            t6: Ut,
            dB: n,
            bz: Ut
        }, A4(Rbn, r.gF, Bx(n), e.rh, ibn));
    }), Vbn = F2(function(n, r) {
        return b(r, Pp);
    }), Ubn = F2(function(n, r) {
        return m(r, {
            x6: Vt(1),
            gF: n.gF
        });
    }), Ybn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Qbn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Obn = {
        $: 1
    }, Gbn = function(n) {
        var r = A2(fS, 0, Obn);
        return b({
            e7: r.a,
            uP: n
        }, r.b);
    }, Jbn = F2(function(n, r) {
        return b(r.a, n(r.b));
    }), Wbn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kbn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(lN, n.a, r.e7), e = t.b;
                return v(m(r, {
                    e7: t.a
                }), A2(Lp, Wbn, e), 0);
            case 1:
                return v(r, Pp, 1);
            default:
                return v(r, Pp, 2);
        }
    }), Xbn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    t6: uC(t)
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = A2(sc, b(Ut, Pp), A2(Fp, A2(ru, Gbn, A2(ru, qx(Vt), Jbn(Lp(Qbn)))), A2(nv, UF, r.t6))), u = e.b;
                return v(m(r, {
                    bz: e.a
                }), u, h);
            case 2:
                var a = n.a, i = r.bz;
                if (i.$) return v(r, Pp, h);
                var c = A2(Kbn, a, i.a), o = c.a, f = c.b, s = c.c ? b(Ut, Pp) : b(Vt(o), f), l = s.b;
                return v(m(r, {
                    bz: s.a
                }), A2(Lp, Qbn, l), h);
            default:
                return v(1 === n.a ? m(r, {
                    bz: Ut
                }) : r, Pp, h);
        }
    }), nvn = function(n) {
        return n.tg;
    }, rvn = F2(function(n, r) {
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Fa))
                ]), x([
                    ld(n(Jd.w5))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            r
        ]));
    }), tvn = function(n) {
        return n;
    }, evn = A2(ru, tvn, function(n) {
        return n.pP;
    }), uvn = function(n) {
        return n.xv;
    }, avn = function(n) {
        return n.rh;
    }, ivn = A2(ru, tvn, function(n) {
        return n.tg;
    }), cvn = A2(ru, tvn, function(n) {
        return n.uw;
    }), ovn = function(n) {
        return {
            hN: n.hN,
            CA: n.CA,
            iv: n.iv
        };
    }, fvn = A2(ru, tvn, function(n) {
        return n.vB;
    }), svn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between items-center")
            ]), x([
                A2(Ek, x([
                    _H(BN),
                    aq,
                    bq
                ]), x([
                    ld(n(Jd.pU))
                ])),
                A2(FI, x([
                    _H(BN),
                    aq
                ]), x([
                    A2(IN, x([
                        LN(_A(ja({
                            rh: avn(r)
                        })))
                    ]), x([
                        ld(n(1 === uvn(r).$ ? Jd.l4 : Jd.pM))
                    ]))
                ]))
            ])),
            function() {
                var n = uvn(r);
                if (n.$) return ld("");
                var t, e, u, a, i, c = n.a;
                return A2(zN, x([
                    ron,
                    JI(12)
                ]), x([
                    A2(EN, x([
                        JI(12)
                    ]), x([
                        (i = ivn(c), "" === i ? ld("") : A2(nk, h, x([
                            ld(i)
                        ]))),
                        (a = fvn(c), 1 === a.$ ? ld("") : A2(nk, h, x([
                            ld(a.a)
                        ]))),
                        A2(R7, h, h),
                        (u = evn(c), 1 === u.$ ? ld("") : A2(nk, h, x([
                            ld(u.a)
                        ]))),
                        (e = cvn(c), 1 === e.$ ? ld("") : A2(nk, h, x([
                            ld((t = ovn(e.a), A2(xB, t.hN ? 0 : 1, t.CA)))
                        ])))
                    ]))
                ]));
            }()
        ]));
    }), lvn = function(n) {
        return n.tg;
    }, dvn = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), bvn = dvn, vvn = function(n) {
        return n.pl;
    }, mvn = F2(function(n, r) {
        return r.s3(n);
    }), pvn = F2(function(n, r) {
        return n(mvn(A2(rV, 100 > r ? 1 : 0, r)));
    }), $vn = F3(function(n, r, t) {
        var e = x(r ? [
            aq
        ] : [
            fq,
            A2(bvn, 1, 2)
        ]), u = vvn(t);
        if (u.$) return tB;
        var a = u.a;
        return A2(nk, x([
            Xx("flex items-center")
        ]), x([
            A2(ak, x([
                Xx("mr-1 -mt-1")
            ]), x([
                A2(PE, x([
                    HB,
                    MB("fill-gray")
                ]), 10)
            ])),
            A2(Ek, A2(Yt, $H, e), x([
                ld(A2(pvn, n, a))
            ]))
        ]));
    }), hvn = function(n) {
        return A2(fe, ", ", A2(se, ",", n.qR));
    }, gvn = F2(function(n, r) {
        return n.$ ? r : A2(Yt, n.a, r);
    }), wvn = A2(Bu, gvn, h), xvn = function(n) {
        var r = wvn(x([
            A2(Fp, wB, qcn(n)),
            A2(Fp, hvn, Dcn(n))
        ]));
        return A2(nk, x([
            Xx("flex flex-col flex-grow")
        ]), A2(Eu, function(n) {
            return A2(nk, x([
                Xx("signup__subtitle")
            ]), x([
                A2(FI, x([
                    fq,
                    A2(bvn, 1, 2),
                    $H
                ]), x([
                    ld(n)
                ]))
            ]));
        }, r));
    }, kvn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("flex flex-row w-full")
            ]), x([
                A2(Ek, x([
                    O0,
                    fq,
                    A2(bvn, 1, 2)
                ]), x([
                    ld(lvn(r))
                ])),
                A3($vn, n, !1, r)
            ])),
            xvn(r)
        ]);
    }), yvn = F2(function(n, r) {
        var t = function(n) {
            return n.kL;
        }(r);
        if (t.$) return tB;
        var e = t.a;
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(Ek, x([
                _H(BN),
                aq,
                bq
            ]), x([
                ld("Location")
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), A2(kvn, n, e))
            ]))
        ]));
    }), _vn = function(n) {
        return {
            yb: n.mn,
            yc: n.mo,
            nK: n.ml,
            y4: n.mm,
            wN: n.mp,
            x0: n.mq
        };
    }, Avn = function(n) {
        return n.pn;
    }, Cvn = function(n) {
        return n.pP;
    }, Bvn = function(n) {
        return n.q_;
    }, Evn = function(n) {
        return n.q0;
    }, Dvn = function(n) {
        return n.nq;
    }, qvn = function(n) {
        return n.su;
    }, Fvn = function(n) {
        return n.tg;
    }, Pvn = function(n) {
        return n.uh;
    }, zvn = F2(function(n, r) {
        var t = Evn(r);
        if (1 === t.$) return h;
        var e, u = t.a, a = (e = Dvn(u)).$ ? Pvn(u) : Vt(Fvn(e.a));
        return x([
            A2(Fp, function(r) {
                return n(Jd.q1) + ": " + r;
            }, a),
            A2(Fp, function(r) {
                return n(Jd.q2) + ": " + r;
            }, Bvn(u)),
            A2(Fp, function(r) {
                return n(Jd.q3) + ": " + r;
            }, qvn(u))
        ]);
    }), jvn = F2(function(n, r) {
        switch(r){
            case 0:
                return "Ms.";
            case 1:
                return "Mrs.";
            case 2:
                return "Miss";
            case 3:
                return "Mr.";
            case 4:
                return "Dr.";
            default:
                return "Mx.";
        }
    }), Svn = function(n) {
        return n.w5;
    }, Lvn = F2(function(n, r) {
        return hnn(A2(fe, " ", wvn(x([
            A2(Fp, jvn(n), Svn(r)),
            Vt(nvn(r))
        ]))));
    }), Mvn = function(n) {
        return n.uy;
    }, Nvn = function(n) {
        return n.qW;
    }, Hvn = function(n) {
        return 3 === n;
    }, Tvn = {
        rQ: function(n) {
            return n.qW.rQ;
        },
        AZ: function(n) {
            return n.qW.AZ;
        },
        Bl: function(n) {
            return n.qW.Bl;
        },
        Bn: function(n) {
            return n.qW.Bn;
        },
        CB: function(n) {
            return n.qW.CB;
        },
        Ei: function(n) {
            return n.qW.Ei;
        },
        Ej: function(n) {
            return n.qW.Ej;
        },
        EB: function(n) {
            return n.qW.EB;
        }
    }, Ivn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.AZ;
                    };
                case 1:
                    return function(n) {
                        return n.EB;
                    };
                case 2:
                    return function(n) {
                        return n.Bl;
                    };
                case 3:
                    return function(n) {
                        return n.Ei;
                    };
                case 4:
                    return function(n) {
                        return n.Ej;
                    };
                default:
                    return function(n) {
                        return n.Bn;
                    };
            }
        })()(Tvn));
    }), Rvn = {
        Ac: function(n) {
            return n.u5.Ac;
        },
        rQ: function(n) {
            return n.u5.rQ;
        },
        Bn: function(n) {
            return n.u5.Bn;
        },
        CB: function(n) {
            return n.u5.CB;
        },
        Ds: function(n) {
            return n.u5.Ds;
        },
        D5: function(n) {
            return n.u5.D5;
        }
    }, Zvn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.Ac;
                    };
                case 1:
                    return function(n) {
                        return n.Ds;
                    };
                case 2:
                    return function(n) {
                        return n.D5;
                    };
                default:
                    return function(n) {
                        return n.Bn;
                    };
            }
        })()(Rvn));
    }), Vvn = {
        z_: function(n) {
            return n.we.z_;
        },
        Aw: function(n) {
            return n.we.Aw;
        },
        rQ: function(n) {
            return n.we.rQ;
        },
        AY: function(n) {
            return n.we.AY;
        },
        CB: function(n) {
            return n.we.CB;
        }
    }, Uvn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.z_;
                    };
                case 1:
                    return function(n) {
                        return n.AY;
                    };
                default:
                    return function(n) {
                        return n.Aw;
                    };
            }
        })()(Vvn));
    }), Yvn = function(n) {
        return n.u5;
    }, Qvn = function(n) {
        return n.we;
    }, Ovn = F2(function(n, r) {
        return hnn(A2(fe, ", ", wvn(x([
            A2(Fp, Uvn(n), Qvn(r)),
            A2(Fp, Ivn(n), Nvn(r)),
            A2(nv, function(t) {
                return Hvn(t) ? r.u4 : Vt(A2(Zvn, n, t));
            }, Yvn(r))
        ]))));
    }), Gvn = F2(function(n, r) {
        var t = A2(zvn, n, r), e = A2(Yt, A2(Lvn, n, r), A2(Yt, A2(Fp, NL(aS("/")), Avn(r)), A2(Yt, A2(Ovn, Wx(0), r), A2(Eu, A2(ru, ovn, A2(ru, function(n) {
            return n.CA;
        }, A2(ru, wB, Vt))), A2(sc, h, Mvn(r)))))), u = _vn(r), a = x([
            u.yb,
            u.yc,
            hnn(A2(fe, ", ", wvn(x([
                u.nK,
                u.wN,
                u.x0,
                u.y4
            ]))))
        ]), i = A2(Rc, A2(pc, gm, TE), A2(Eu, wvn, x([
            e,
            x([
                Cvn(r)
            ]),
            a,
            t
        ])));
        return A2(nk, A2(Yt, Xx("flex flex-col flex-grow"), UE), A2(Eu, function(n) {
            return A2(nk, x([
                Xx("mb-3")
            ]), A2(Eu, function(n) {
                return A2(nk, x([
                    Xx("mt-1")
                ]), x([
                    A2(FI, x([
                        fq,
                        A2(bvn, 1, 2)
                    ]), x([
                        ld(n)
                    ]))
                ]));
            }, n));
        }, i));
    }), Jvn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between items-center")
            ]), x([
                A2(Ek, x([
                    _H(BN),
                    aq,
                    bq
                ]), x([
                    ld(n(Jd.rl))
                ])),
                A2(FI, x([
                    _H(BN),
                    aq
                ]), x([
                    A2(IN, x([
                        LN(_A(za({
                            rh: avn(r)
                        })))
                    ]), x([
                        ld(n(Jd.rm))
                    ]))
                ]))
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(Gvn, n, r)
                ]))
            ]))
        ]));
    }), Wvn = function(n) {
        return n.u7;
    }, Kvn = {
        $: 1
    }, Xvn = function(n) {
        return n.na;
    }, nmn = function(n) {
        var r;
        return A2(sc, tB, A2(Fp, function(n) {
            return A2(nk, x([
                Xx("signup__subtitle text-ellipsis")
            ]), x([
                A2(FI, x([
                    fq,
                    A2(bvn, 1, 2)
                ]), x([
                    ld(n)
                ]))
            ]));
        }, (r = Xvn(n), A2(nv, hnn, r))));
    }, rmn = function(n) {
        return A3(RB, "svg", $(x([
            A2(zC, "width", "109"),
            A2(zC, "height", "109"),
            A2(zC, "viewBox", "0 0 109 109"),
            A2(zC, "fill", "none"),
            A2(zC, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), x([
            A3(RB, "rect", x([
                A2(zC, "x", "1.25"),
                A2(zC, "y", "1.25"),
                A2(zC, "width", "106.5"),
                A2(zC, "height", "106.5"),
                A2(zC, "rx", "1.75"),
                A2(zC, "fill", "#F1F6FC"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.5")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M17.3269 97C17.3269 77.8506 32.8506 62.3269 52 62.3269H58C77.1494 62.3269 92.6731 77.8506 92.6731 97V107.673H17.3269V97Z"),
                A2(zC, "fill", "#F1F6FC"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h),
            A3(RB, "circle", x([
                A2(zC, "cx", "38.5"),
                A2(zC, "cy", "87.5"),
                A2(zC, "r", "6.17308"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M59.2251 90.388L56.3816 87.6739L60.3789 83.4861C62.5996 81.1596 68.4627 77.8636 74.1497 83.2918C79.8366 88.7201 76.807 94.4243 74.5813 96.5979L70.2161 101.171L67.7833 98.8893"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M74.5 84.2308C76.5641 83.3461 80.3385 79.1885 82.4615 73.1731"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M34.6924 84.2308C32.6283 83.3461 28.8539 79.1885 26.7308 73.1731"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h),
            A3(RB, "mask", x([
                A2(zC, "id", "path-7-inside-1"),
                A2(zC, "fill", "white")
            ]), x([
                A3(RB, "path", x([
                    A2(zC, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z")
                ]), h)
            ])),
            A3(RB, "path", x([
                A2(zC, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z"),
                A2(zC, "fill", "#F1F6FC")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M72.3462 44.0226C72.3462 50.8382 70.8285 58.0833 67.808 63.5249C64.8092 68.9275 60.5583 72.2285 55 72.2285V77.5362C63.1173 77.5362 68.8665 72.5545 72.4487 66.1009C76.0093 59.6863 77.6538 51.5015 77.6538 44.0226H72.3462ZM55 72.2285C49.4417 72.2285 45.1908 68.9275 42.192 63.5249C39.1715 58.0833 37.6538 50.8382 37.6538 44.0226H32.3462C32.3462 51.5015 33.9907 59.6863 37.5513 66.1009C41.1335 72.5545 46.8827 77.5362 55 77.5362V72.2285ZM37.6538 44.0226C37.6538 37.4578 39.7137 32.9822 42.7179 30.1364C45.7514 27.263 50.0436 25.7715 55 25.7715V20.4638C49.004 20.4638 43.2963 22.2776 39.0678 26.283C34.8101 30.3162 32.3462 36.293 32.3462 44.0226H37.6538ZM55 25.7715C59.9564 25.7715 64.2486 27.263 67.2821 30.1364C70.2863 32.9822 72.3462 37.4578 72.3462 44.0226H77.6538C77.6538 36.293 75.1899 30.3162 70.9322 26.283C66.7037 22.2776 60.996 20.4638 55 20.4638V25.7715Z"),
                A2(zC, "fill", "#C4DCF8"),
                A2(zC, "mask", "url(#path-7-inside-1)")
            ]), h),
            A3(RB, "path", x([
                A2(zC, "d", "M72.4707 46.0588C65.4119 46.0588 62.4707 39 61.8825 35.4706C62.0785 39 57.2942 46.0588 36.5883 46.0588"),
                A2(zC, "stroke", "#C4DCF8"),
                A2(zC, "stroke-width", "2.65385")
            ]), h)
        ]));
    }, tmn = function() {
        return rmn;
    }, emn = function(n) {
        switch(n.$){
            case 0:
                return x([
                    TB(hk(n.a))
                ]);
            case 1:
                return x([
                    A2(bT, "width", oe(n.a))
                ]);
            default:
                return x([
                    A2(bT, "height", oe(n.a))
                ]);
        }
    }, umn = F2(function(n, r) {
        var t = A2(tc, emn, n);
        return A2(tmn, r, A2(Yt, TB("inline-block"), t));
    }), amn = F2(function(n, r) {
        var t = n ? x([
            b("image-portrait--modal", n)
        ]) : h, e = "flex items-center justify-center overflow-hidden image-portrait", u = function(n) {
            return n.uz;
        }(r);
        if (u.$) {
            var a = A2(umn, h, 0);
            return A2(nk, h, x([
                A2(nk, x([
                    Xx(e),
                    SC(t)
                ]), x([
                    a
                ]))
            ]));
        }
        var i = u.a;
        return A2(nk, x([
            Xx(e),
            SC(t)
        ]), x([
            A2(k3, x([
                zG(i)
            ]), h)
        ]));
    }), imn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("flex flex-col mr-4")
            ]), x([
                A2(amn, !1, r)
            ])),
            A2(nk, x([
                Xx("flex flex-col flex-grow")
            ]), x([
                A2(Ek, x([
                    O0,
                    fq,
                    A2(bvn, 1, 2)
                ]), x([
                    ld(MP(r))
                ])),
                nmn(r)
            ])),
            A2(nk, x([
                Xx("flex flex-col justify-center ml-4 mr-2")
            ]), x([
                A2(OC, x([
                    oF,
                    EC(Kvn),
                    Xdn(!0)
                ]), x([
                    ld(n(AI))
                ]))
            ]))
        ]);
    }), cmn = F2(function(n, r) {
        var t = UF(r);
        if (t.$) return tB;
        var e, u, a = t.a;
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(Ek, x([
                _H(BN),
                aq,
                bq
            ]), x([
                ld((e = n(Wvn), u = A2(kv, oM("\\w+"), A2(ru, function(n) {
                    return n.kP;
                }, vfn)), A3(kv, oM("^([a-z])|\\s+([a-z])"), A2(ru, function(n) {
                    return n.kP;
                }, u), e)))
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(nk, x([
                        Xx("flex flex-row w-full")
                    ]), A2(imn, n, a))
                ]))
            ]))
        ]));
    }), omn = F2(function(n, r) {
        var t = QE(nvn(r));
        return A2(nk, x([
            Xx("text-left")
        ]), x([
            A2(rvn, n, t),
            Dk,
            A2(Ak, x([
                ok(x([
                    Xx("mt-8 mb-8")
                ]))
            ]), x([
                t
            ])),
            A2(Jvn, n, r),
            A2(svn, n, r),
            A2(cmn, n, r),
            A2(yvn, n, r)
        ]));
    }), fmn = A2(CN, AN(0), Vt(1)), smn = F2(function(n, r) {
        return TE(r) ? tB : A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(X8, x([
                aq
            ]), x([
                ld(n)
            ])),
            A2(Ek, x([
                $H,
                aq,
                _H(fmn)
            ]), x([
                ld(A2(fe, ", ", r))
            ]))
        ]));
    }), lmn = F3(function(n, r, t) {
        var e = TE(t) && TE(r) ? 12 : 7;
        return A2(zN, x([
            KN(x([
                Xx("row--tweak")
            ])),
            jN(iR)
        ]), x([
            A2(EN, x([
                JI(12),
                bR(e),
                jN(BN),
                A2(dR, 1, iR)
            ]), x([
                function() {
                    if (n.$) return tB;
                    var r = n.a;
                    return A2(nk, x([
                        Xx("sm:pr-2")
                    ]), x([
                        ld(r)
                    ]));
                }()
            ])),
            A2(EN, x([
                JI(12),
                bR(5)
            ]), x([
                A2(smn, "Specialties", t),
                A2(smn, "Education", r)
            ]))
        ]));
    }), dmn = {
        $: 2
    }, bmn = function(n) {
        return n.pq;
    }, vmn = function(n) {
        return A2(OC, x([
            oF,
            CZ,
            EC(dmn)
        ]), x([
            ld(n(bmn))
        ]));
    }, mmn = function(n) {
        return n.qS;
    }, pmn = function(n) {
        return n.sm;
    }, $mn = function(n) {
        return n.s7;
    }, hmn = F3(function(n, r, t) {
        var e = n.$ ? "" : "from " + oe(n.a) + " ", u = r.$ ? "" : "to " + oe(r.a);
        return vu(e) && vu(u) ? "" : (t ? "Only treats" : "Treats") + " ages " + (e + u);
    }), gmn = F3(function(n, r, t) {
        var e = r.kL;
        return A2(nk, x([
            Xx("flex flex-col sm:flex-row w-full")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col mr-4")
            ]), x([
                A2(amn, !0, t)
            ])),
            A2(nk, x([
                Xx("flex flex-col")
            ]), x([
                A2(nk, x([
                    Xx("mt-4 sm:mt-0")
                ]), x([
                    A2(FI, x([
                        lk
                    ]), x([
                        ld(MP(t))
                    ]))
                ])),
                A2(Ek, x([
                    aq
                ]), x([
                    ld(A3(hmn, $mn(t), pmn(t), !1))
                ])),
                function() {
                    if (e.$) return tB;
                    var n = e.a;
                    return A2(nk, x([
                        Xx("mt-1 sm:mt-0")
                    ]), x([
                        A2(Ek, x([
                            $H,
                            aq
                        ]), x([
                            ld(mmn(n))
                        ]))
                    ]));
                }(),
                A2(nk, x([
                    Xx("mt-1")
                ]), VZ(A2(sc, tB, A2(Fp, A2($vn, n, !0), e))))
            ]))
        ]));
    }), wmn = F3(function(n, r, t) {
        var e, u = t.uP, a = t.e7, i = function(n) {
            return n.wD;
        }(u), c = function(n) {
            return A2(sc, h, n.pO);
        }(u), o = Xvn(u), f = A2(Tp, iu, x([
            Vt(qI(x([
                A3(gmn, n, r, u)
            ]))),
            (e = v(o, TE(c), TE(i)), 1 === e.a.$ && e.b && e.c ? Ut : Vt(EI(x([
                A3(lmn, o, c, i)
            ])))),
            r.xO ? Vt(DI(x([
                vmn(n)
            ]))) : Ut
        ]));
        return A2(QI, f, NM(a));
    }), xmn = F2(function(n, r) {
        return A2(Ck, Qbn, A2(sc, tB, A2(Fp, A2(wmn, n, {
            kL: Ut,
            xO: !1
        }), r)));
    }), kmn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(xmn, n, r.bz),
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.t6, t.$ ? ck : x([
                    A2(omn, n, t.a)
                ])))
            ]),
            w5: n(Jd.w5)
        };
    }), ymn = ZA({
        Ar: Zbn,
        AQ: Vbn,
        Db: Ubn,
        DZ: function() {
            return kY(fY(Ybn));
        },
        En: Xbn,
        Et: kmn
    }), _mn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Amn = function(n) {
        switch(n){
            case "no":
                return uu(0);
            case "yes":
                return uu(1);
            case "optional":
                return uu(2);
            case "require":
                return uu(3);
            case "default":
                return uu(4);
            default:
                return Sk("Unsupported collection option: " + n);
        }
    }, Cmn = F2(function(n, r) {
        return {
            qJ: r,
            rh: n
        };
    }), Bmn = F6(function(n, r, t, e, u, a) {
        return {
            pe: e,
            q9: u,
            rh: n,
            eS: t,
            vJ: a,
            w5: r
        };
    }), Emn = function(n) {
        switch(n){
            case "string":
                return uu(0);
            case "multiple_strings":
                return uu(1);
            case "boolean":
                return uu(2);
            default:
                return Sk("Unsupported item type: " + n);
        }
    }, Dmn = A3(ly, "required", jk, A3(ly, "help_text", iy(C$), A3(ly, "description", iy(C$), A3(ly, "item_type", A2(nu, Emn, C$), A3(ly, "title", C$, A3(ly, "id", C$, uu(Bmn))))))), qmn = A2(Pk, Dmn, uu(iu)), Fmn = A3(ly, "form_items", vy(qmn), A3(ly, "id", C$, uu(Cmn))), Pmn = A2(Pk, Fmn, uu(iu)), zmn = A3(ly, "allowed_zip_codes_on_signup", vy(C$), A3(ly, "restrict_zip_codes_on_signup", jk, A3(ly, "forms", vy(Pmn), A3(ly, "collect_tobacco_use", jk, A3(ly, "post_signup_button_label", iy(C$), A3(ly, "show_post_signup_footer_button", jk, A3(ly, "post_signup_message", iy(C$), A3(ly, "post_signup_redirect_url", iy(C$), A3(ly, "collect_address_on_signup", A2(nu, Amn, C$), A3(ly, "collect_ssn_on_signup", A2(nu, Amn, C$), A3(ly, "collect_location_on_signup", A2(nu, Amn, C$), A3(ly, "collect_practitioner_on_signup", A2(nu, Amn, C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        mz: l,
                                                        nR: e,
                                                        nY: r,
                                                        n$: n,
                                                        n1: t,
                                                        n3: o,
                                                        qO: f,
                                                        ld: c,
                                                        le: a,
                                                        lf: u,
                                                        vX: s,
                                                        lA: i
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), jmn = A2(Pk, zmn, uu(iu)), Smn = F3(function(n, r, t) {
        return A4(W_, gQ(n), jmn, t, rA(function(n) {
            return A2(X_, x([
                "signup_setting"
            ]), lL(n));
        }(r)));
    }), Lmn = F2(function(n, r) {
        return A3(Smn, n, Bx(r), _mn);
    }), Mmn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nmn = function(n) {
        return n.b.o8;
    }, Hmn = {
        z_: function(n) {
            return n.qV.z_;
        },
        rQ: function(n) {
            return n.qV.rQ;
        },
        AY: function(n) {
            return n.qV.AY;
        },
        Cd: function(n) {
            return n.qV.Cd;
        }
    }, Tmn = {
        yb: "",
        yc: "",
        nK: "",
        y4: "United States",
        wN: "",
        x0: ""
    }, Imn = {
        $: 0
    }, Rmn = x([
        0,
        1,
        2,
        3,
        4
    ]), Zmn = function(n) {
        switch(n){
            case 0:
                return "Address Line 1";
            case 1:
                return "City";
            case 2:
                return "State";
            case 3:
                return "Zip";
            default:
                return "Country";
        }
    }, Vmn = F2(function(n, r) {
        return {
            cg: cK,
            ct: Imn,
            kB: lS(r),
            rh: n,
            vJ: !1,
            iR: Ut,
            b9: !1,
            bE: h,
            x: A2(vS, Rmn, Zmn)
        };
    }), Umn = function(n) {
        return A2(Vmn, n, Tmn);
    }, Ymn = F2(function(n, r) {
        return r.$ ? n(Qj) : Fvn(r.a);
    }), Qmn = function(n) {
        return n.q1;
    }, Omn = function(n) {
        return n.rh;
    }, Gmn = function(n) {
        return Vt(n.$ ? "other" : Omn(Qmn(n.a)));
    }, Jmn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wmn = {
        hY: 10,
        tg: Ut
    }, Kmn = A2(X_, x([
        "health_insurance_carrier_aliases"
    ]), sL), Xmn = F3(function(n, r, t) {
        return A4(W_, gQ(n), vy(Ebn), t, A2(_P, function(n) {
            var r, t = n(Wmn);
            return $((r = t.tg).$ ? h : x([
                A2(Y_, "name", r.a)
            ]), x([
                A2(bJ, "limit", t.hY)
            ]));
        }(r), rA(Kmn)));
    }), npn = F2(function(n, r) {
        return A3(Xmn, n, function(n) {
            return m(n, {
                tg: r
            });
        }, Jmn);
    }), rpn = function(n) {
        return {
            ah: Ut,
            bL: "",
            Z: n,
            bW: "",
            rc: !0,
            b_: "",
            h3: !1
        };
    }, tpn = function(n) {
        return {
            hf: cK,
            rh: n.rh,
            $7: n.Eb,
            kK: n.Ed,
            aP: !1,
            D2: ""
        };
    }, epn = x([
        0,
        1,
        2,
        3
    ]), upn = function(n) {
        switch(n){
            case 0:
                return "Carrier";
            case 1:
                return "CarrierAliasOther";
            case 2:
                return "GroupID";
            default:
                return "MemberID";
        }
    }, apn = F2(function(n, r) {
        return b({
            gF: n,
            eo: tpn({
                rh: "carrier-select",
                Eb: Ymn,
                Ed: Gmn
            }),
            ep: cP,
            kB: lS(rpn(r)),
            fz: !1,
            x: A2(vS, epn, upn)
        }, A2(npn, n, Ut));
    }), ipn = function(n) {
        return A2(tS, n, {
            hN: !0,
            CA: "",
            iv: fN
        });
    }, cpn = function(n) {
        return n.a;
    }, opn = F2(function(n, r) {
        var t = r.$ ? 1 : cpn(r.a);
        return n + "-phone-" + oe(t);
    }), fpn = function(n) {
        return n.rh;
    }, spn = function(n) {
        var r = ipn(A2(opn, n, Ut));
        return {
            rh: n,
            uy: A2(PY, r, jU),
            vJ: !1,
            dL: Ut,
            M: A2(vS, x([
                r
            ]), fpn)
        };
    }, lpn = {
        we: Ut
    }, dpn = x([
        0
    ]), bpn = function() {
        return "Sex";
    }, vpn = function(n) {
        return Vt(UQ(A2(Uvn, Wx(0), n)));
    }, mpn = function(n) {
        return {
            kB: lS(lpn),
            rh: n,
            vJ: !1,
            fJ: dd({
                rh: n + "-select",
                Eb: Uvn,
                Ed: vpn
            }),
            x: A2(vS, dpn, bpn)
        };
    }, ppn = {
        w5: Ut
    }, $pn = x([
        0
    ]), hpn = function() {
        return "Title";
    }, gpn = function(n) {
        return Vt(A2(jvn, Wx(0), n));
    }, wpn = function(n) {
        return {
            kB: lS(ppn),
            rh: n,
            vJ: !1,
            fU: dd({
                rh: n + "-select",
                Eb: jvn,
                Ed: gpn
            }),
            x: A2(vS, $pn, hpn)
        };
    }, xpn = {
        dy: "",
        fF: Ut
    }, kpn = x([
        0,
        1
    ]), ypn = function(n) {
        return n ? "FieldOther" : "Field";
    }, _pn = function(n) {
        var r = n.Eb, t = n.Ed, e = n.rh, u = n.AH;
        return {
            z$: n.z$,
            kB: lS(xpn),
            rh: e,
            AH: u,
            vJ: !1,
            lu: r,
            fW: dd({
                rh: e + "-select",
                Eb: r,
                Ed: t
            }),
            x: A2(vS, kpn, ypn)
        };
    }, Apn = function(n) {
        return 2 === n;
    }, Cpn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.z_;
                    };
                case 1:
                    return function(n) {
                        return n.AY;
                    };
                default:
                    return function(n) {
                        return n.Cd;
                    };
            }
        })()(Hmn));
    }), Bpn = function(n) {
        return Vt(function() {
            switch(n){
                case 0:
                    return "female";
                case 1:
                    return "male";
                default:
                    return "other";
            }
        }());
    }, Epn = F2(function(n, r) {
        return _pn({
            z$: r,
            rh: n,
            AH: Apn,
            Eb: Cpn,
            Ed: Bpn
        });
    }), Dpn = function(n) {
        return 5 === n;
    }, qpn = function(n) {
        return Vt(UQ(function() {
            switch(n){
                case 0:
                    return "Man";
                case 1:
                    return "Woman";
                case 2:
                    return "Non-binary";
                case 3:
                    return "Trans Man";
                case 4:
                    return "Trans Woman";
                default:
                    return "Not Listed";
            }
        }()));
    }, Fpn = F2(function(n, r) {
        return _pn({
            z$: r,
            rh: n,
            AH: Dpn,
            Eb: Ivn,
            Ed: qpn
        });
    }), Ppn = function(n) {
        switch(n){
            case 0:
                return Vt("He/Him/His");
            case 1:
                return Vt("She/Her/Hers");
            case 2:
                return Vt("They/Them/Theirs");
            default:
                return Vt("Not Listed");
        }
    }, zpn = F2(function(n, r) {
        return _pn({
            z$: r,
            rh: n,
            AH: Hvn,
            Eb: Zvn,
            Ed: Ppn
        });
    }), jpn = function(n) {
        return n.b.vP;
    }, Spn = F2(function(n, r) {
        return m(r, {
            dL: Vt(n)
        });
    }), Lpn = F2(function(n, r) {
        return jpn(n) ? A2(Spn, Zj, r) : r;
    }), Mpn = F2(function(n, r) {
        return m(r, {
            vJ: n
        });
    }), Npn = F2(function(n, r) {
        return m(r, {
            vJ: n
        });
    }), Hpn = F2(function(n, r) {
        var t = A2(apn, n, !1), e = t.a, u = t.b;
        return b({
            mk: A2(Mpn, !1, Umn("main-address")),
            nF: "",
            nG: "",
            nH: "",
            nI: "",
            nJ: wpn("chosen-title"),
            bk: iS("dob"),
            pP: "",
            qB: "",
            qV: A2(Epn, "gender", Hmn.rQ),
            qW: A2(Fpn, "gender-identity", Tvn.rQ),
            aj: !1,
            a1: e,
            rS: "",
            s2: "",
            uy: A2(Lpn, r, A2(Npn, !0, spn("phones"))),
            uU: A2(Z$, Nmn(r), Ib("preferred-language")),
            u5: A2(zpn, "pronouns", Rvn.rQ),
            we: mpn("sex"),
            wG: "",
            wY: "",
            w5: wpn("title")
        }, A2(Lp, Mmn, u));
    }), Tpn = x([
        0,
        2
    ]), Ipn = function(n) {
        switch(n){
            case 0:
                return "Email";
            case 1:
                return "Phone";
            default:
                return "Address";
        }
    }, Rpn = F3(function(n, r, t) {
        var e = t.Ck, u = A2(Hpn, r.gF, n), a = u.b, i = lS(u.a);
        return b({
            gF: r.gF,
            kA: r.kA,
            kB: i,
            t6: Ut,
            Cr: e.rh,
            dB: n,
            fL: Ut,
            x: A2(vS, Tpn, Ipn)
        }, Vu(x([
            A2(Lmn, r.gF, n),
            a
        ])));
    }), Zpn = F2(function(n, r) {
        return b(r, Pp);
    }), Vpn = F2(function(n, r) {
        return m(r, {
            x6: Vt(1),
            gF: n.gF
        });
    }), Upn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ypn = nr("googlePlacesAddressDetails", A2(nu, function(n) {
        return A2(nu, function(r) {
            return uu({
                mk: r,
                rh: n
            });
        }, A2(Tu, "address", C$));
    }, A2(Tu, "id", C$))), Qpn = nr("googlePlacesAddressSuggestions", A2(nu, function(n) {
        return A2(nu, function(r) {
            return uu({
                rh: r,
                bE: n
            });
        }, A2(Tu, "id", C$));
    }, A2(Tu, "suggestions", w$))), Opn = Px(x([
        (zJ = function(n) {
            return {
                $: 3,
                a: n
            };
        }, Qpn(zJ)),
        (PJ = function(n) {
            return {
                $: 4,
                a: n
            };
        }, Ypn(PJ))
    ])), Gpn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jpn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Wpn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Kpn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xpn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, n$n = function(n) {
        return n.nR;
    }, r$n = function(n) {
        return 3 === n;
    }, t$n = function(n) {
        return r$n(n$n(n));
    }, e$n = function(n) {
        return n.nF;
    }, u$n = function(n) {
        return n.nG;
    }, a$n = function(n) {
        return n.nH;
    }, i$n = function(n) {
        return n.nI;
    }, c$n = function(n) {
        return n.nJ;
    }, o$n = function(n) {
        return n.qB;
    }, f$n = function(n) {
        return n.qV;
    }, s$n = function(n) {
        return {
            yb: A2(sc, "", n.yb),
            yc: A2(sc, "", n.yc),
            nK: A2(sc, "", n.nK),
            y4: A2(sc, "United States", n.y4),
            wN: A2(sc, "", n.wN),
            x0: A2(sc, "", n.x0)
        };
    }, l$n = F2(function(n, r) {
        return {
            cg: cK,
            ct: Imn,
            kB: lS(s$n(r)),
            rh: n,
            vJ: !1,
            iR: Ut,
            b9: !1,
            bE: h,
            x: A2(vS, Rmn, Zmn)
        };
    }), d$n = function(n) {
        var r = n.nG;
        return fM(n.nF) && fM(r);
    }, b$n = function(n) {
        return n.rS;
    }, v$n = function(n) {
        return n.s2;
    }, m$n = function(n) {
        return n.tA;
    }, p$n = function(n) {
        return n.uU;
    }, $$n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, h$n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Z: n.a
                });
            case 1:
                return m(r, {
                    ah: n.a
                });
            case 2:
                return m(r, {
                    bL: n.a
                });
            case 3:
                return m(r, {
                    bW: n.a
                });
            case 4:
                return m(r, {
                    b_: n.a
                });
            default:
                return m(r, {
                    rc: n.a
                });
        }
    }), g$n = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, h$n, $$n(n), r.kB)
        });
    }), w$n = function(n) {
        return n.wG;
    }, x$n = function(n) {
        return n.wY;
    }, k$n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, y$n = {
        $: 1
    }, _$n = function(n) {
        return n.rc;
    }, A$n = F2(function(n, r) {
        var t, e, u, a;
        return m(r, {
            kB: lS((t = n, e = Pvn(t), u = Dvn(t), a = u.$ ? b(Vt(y$n), e) : b(A2(Fp, function(n) {
                return k$n(n);
            }, u), Ut), {
                ah: a.a,
                bL: A2(sc, "", a.b),
                Z: !0,
                bW: A2(sc, "", Bvn(t)),
                rc: A2(sc, !1, _$n(t)),
                b_: A2(sc, "", qvn(t)),
                h3: LP(u)
            }))
        });
    }), C$n = F3(function(n, r, t) {
        return m(t, {
            wN: A3(ta, r(n), dS, t.wN)
        });
    }), B$n = F2(function(n, r) {
        var t = A2(opn, r.rh, Vt(r.uy)), e = n.$ ? ipn(t) : A2(tS, t, n.a);
        return b(t, m(r, {
            uy: A2(PY, e, r.uy),
            M: A3(C$n, e, fpn, r.M)
        }));
    }), E$n = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.a;
            n = n.b, r = A2(B$n, Vt(t), r).b;
        }
    }), D$n = function(n) {
        return rv(n.b);
    }, q$n = function(n) {
        return A2(nv, function(n) {
            return Vt(n.b);
        }, D$n(n));
    }, F$n = F2(function(n, r) {
        return A2(zU, r.a, A2(Rc, function(r) {
            return !i(r.a, n);
        }, r.b));
    }), P$n = F3(function(n, r, t) {
        return m(t, {
            wN: A2(fa, r(n), t.wN)
        });
    }), z$n = F3(function(n, r, t) {
        var e = A3(P$n, t, fpn, n.M);
        return m(n, {
            uy: A2(F$n, r, n.uy),
            M: e
        });
    }), j$n = F2(function(n, r) {
        if (TE(n)) return r;
        var t = A2(E$n, n, r);
        if (CY(t.uy) > 1) {
            var e = q$n(t.uy);
            return e.$ ? t : A3(z$n, t, 1, e.a);
        }
        return t;
    }), S$n = F2(function(n, r) {
        return n.$ ? r : A2(j$n, A2(Eu, ovn, n.a), r);
    }), L$n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, M$n = F2(function(n, r) {
        return m(r, n.$ ? {
            dy: n.a
        } : {
            fF: n.a
        });
    }), N$n = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, M$n, L$n(Vt(n)), r.kB)
        });
    }), H$n = F2(function(n, r) {
        return n.$ ? r : A2(N$n, n.a, r);
    }), T$n = F2(function(n, r) {
        return m(r, {
            we: n
        });
    }), I$n = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, T$n, Vt(n), r.kB)
        });
    }), R$n = F2(function(n, r) {
        return n.$ ? r : A2(I$n, n.a, r);
    }), Z$n = F2(function(n, r) {
        return m(r, {
            w5: n
        });
    }), V$n = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, Z$n, Vt(n), r.kB)
        });
    }), U$n = F2(function(n, r) {
        return n.$ ? r : A2(V$n, n.a, r);
    }), Y$n = F4(function(n, r, t, e) {
        var u, a = A2(Lpn, r, A2(S$n, Mvn(n), A2(Npn, !0, spn("phones")))), i = (u = Evn(n)).$ ? A2(g$n, !1, e.a1) : A2(A$n, u.a, A2(g$n, !0, e.a1)), c = A2(sc, "", u$n(n)), o = A2(sc, "", e$n(n));
        return {
            mk: A2(Mpn, t$n(t), A2(l$n, "main-address", _vn(n))),
            nF: o,
            nG: c,
            nH: A2(sc, "", a$n(n)),
            nI: A2(sc, "", i$n(n)),
            nJ: A2(U$n, c$n(n), wpn("chosen-title")),
            bk: A2(IL, Avn(n), iS("date-of-birth")),
            pP: A2(sc, "", Cvn(n)),
            qB: o$n(n),
            qV: A2(H$n, f$n(n), A2(Epn, "gender", Hmn.rQ)),
            qW: A2(H$n, Nvn(n), A2(Fpn, "gender-identity", Tvn.rQ)),
            aj: !d$n({
                nF: o,
                nG: c
            }),
            a1: i,
            rS: b$n(n),
            s2: A2(sc, "", v$n(n)),
            uy: a,
            uU: A2(Z$, p$n(n), Ib("preferred-language")),
            u5: A2(H$n, Yvn(n), A2(zpn, "pronouns", Rvn.rQ)),
            we: A2(R$n, Qvn(n), mpn("sex")),
            wG: A2(sc, "", A2(Fp, m$n, w$n(n))),
            wY: A2(sc, "", x$n(n)),
            w5: A2(U$n, Svn(n), wpn("title"))
        };
    }), Q$n = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    pP: n.a
                });
            case 2:
                return m(r, {
                    uy: n.a
                });
            case 0:
                return m(r, {
                    mk: n.a
                });
            default:
                return m(r, {
                    a1: n.a
                });
        }
    }), O$n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, G$n = function(n) {
        return fM(n) ? yx : Ax(XC(n));
    }, J$n = function(n) {
        var r = FL(n.kB);
        return x([
            b("address_city", G$n(r.nK)),
            b("address_country", G$n(r.y4)),
            b("address_line1", G$n(r.yb)),
            b("address_line2", G$n(r.yc)),
            b("address_state", G$n(r.wN)),
            b("address_zip", G$n(r.x0))
        ]);
    }, W$n = function(n) {
        switch(n.$){
            case 0:
                return Ax("mobile");
            case 1:
                return Ax("home");
            case 2:
                return Ax("office");
            default:
                return Ax(n.a);
        }
    }, K$n = function(n) {
        return fM(n.CA) ? yx : _x(x([
            b("number", G$n(n.CA)),
            b("type", W$n(n.dQ)),
            b("us_formattable", LC(!n.Dl))
        ]));
    }, X$n = F2(function(n, r) {
        return A2(KK, n, r.b);
    }), nhn = function(n) {
        return A2(X$n, function(n) {
            return K$n(n.b);
        }, n);
    }, rhn = function(n) {
        var r = FL(n.kB), t = r.bL;
        return r.Z ? A2(Fp, function(n) {
            return n.$ ? t : Fvn(n.a);
        }, r.ah) : Ut;
    }, thn = function(n) {
        return fM(n) ? yx : Ax(n);
    }, ehn = function(n) {
        return FL(n.kB).bW;
    }, uhn = function(n) {
        return FL(n.kB).Z;
    }, ahn = function(n) {
        return FL(n.kB).rc;
    }, ihn = function(n) {
        return FL(n.kB).b_;
    }, chn = F5(function(n, r, t, e, u) {
        return A4(dC, n, Tbn, u, A2(vL, _x(x([
            e
        ])), rA(A2(Ibn, r, t))));
    }), ohn = function(n) {
        var r, t, e = Bx(n.dB), u = (r = n.t6).$ ? "" : avn(r.a), a = (t = FL(n.kB), b("patient", _x(function(n) {
            var r, t, e, u;
            return A2(Yt, b("email", Ax(n.pP)), A2(Yt, b("phones", nhn(n.uy.uy)), $(uhn(r = n.a1) ? x([
                b("health_insurance_payer_name", thn(A2(sc, "", rhn(r)))),
                b("health_insurance_carrier", A2(sc, yx, A2(Fp, function(n) {
                    return _x(x([
                        b("id", Ax(n))
                    ]));
                }, (t = r, e = FL(t.kB), u = e.ah, e.Z ? u.$ || u.a.$ ? Ut : Vt(Omn(Qmn(u.a.a))) : Ut)))),
                b("health_insurance_member_id", thn(ihn(r))),
                b("health_insurance_group_id", thn(ehn(r))),
                b("health_insurance_high_deductible", LC(ahn(r)))
            ]) : x([
                b("health_insurance_payer_name", yx),
                b("health_insurance_carrier", yx),
                b("health_insurance_member_id", yx),
                b("health_insurance_group_id", yx),
                b("health_insurance_high_deductible", yx)
            ]), J$n(n.mk))));
        }(t))));
        return A5(chn, n.gF, e, u, a, O$n);
    }, fhn = F2(function(n, r) {
        return {
            mk: n,
            rh: r
        };
    }), shn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lhn = function(n) {
        return m(n, {
            b9: !1
        });
    }, dhn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, bhn = function(n) {
        return A2(Nu, dhn, _u(n));
    }, vhn = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 6,
                a: n
            };
        }
    }, mhn = F3(function(n, r, t) {
        return {
            pe: n,
            uB: r,
            El: t
        };
    }), phn = A3(ly, "types", vy(C$), A3(ly, "place_id", C$, A3(ly, "description", C$, uu(mhn)))), $hn = vy(phn), hhn = F5(function(n, r, t, e, u) {
        return {
            j$: n,
            z5: r,
            tg: t,
            uB: e,
            El: u
        };
    }), ghn = F3(function(n, r, t) {
        return {
            se: n,
            wf: r,
            El: t
        };
    }), whn = x([
        b("street_address", 0),
        b("route", 1),
        b("intersection", 2),
        b("political", 3),
        b("country", 4),
        b("administrative_area_level_1", 5),
        b("administrative_area_level_2", 6),
        b("administrative_area_level_3", 7),
        b("administrative_area_level_4", 8),
        b("administrative_area_level_5", 9),
        b("colloquial_area", 10),
        b("locality", 11),
        b("sublocality", 12),
        b("sublocality_level_1", 13),
        b("sublocality_level_2", 14),
        b("sublocality_level_3", 15),
        b("sublocality_level_4", 16),
        b("sublocality_level_5", 17),
        b("neighborhood", 18),
        b("premise", 19),
        b("subpremise", 20),
        b("postal_code", 21),
        b("natural_feature", 22),
        b("airport", 23),
        b("park", 24),
        b("post_box", 25),
        b("street_number", 26),
        b("floor", 27),
        b("room", 28),
        b("establishment", 29),
        b("point_of_interest", 30),
        b("parking", 31),
        b("postal_town", 32),
        b("bus_station", 33),
        b("train_station", 34),
        b("transit_station", 35),
        b("postal_code_suffix", 36)
    ]), xhn = Ul(whn), khn = function(n) {
        return A2(sc, 37, A2(Wu, n, xhn));
    }, yhn = A2(pc, uu, khn), _hn = A2(nu, yhn, C$), Ahn = vy(_hn), Chn = A3(ly, "types", Ahn, A3(ly, "short_name", C$, A3(ly, "long_name", C$, uu(ghn)))), Bhn = A3(ly, "types", vy(C$), A3(ly, "place_id", C$, A3(ly, "name", C$, A3(ly, "formatted_address", C$, A3(ly, "address_components", vy(Chn), uu(hhn)))))), Ehn = function(n) {
        switch(n.$){
            case 0:
                return Zmn(0);
            case 1:
                return "Address Line 2";
            case 2:
                return Zmn(1);
            case 3:
                return Zmn(2);
            case 4:
                return Zmn(3);
            default:
                return Zmn(4);
        }
    }, Dhn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yb: n.a
                });
            case 1:
                return m(r, {
                    yc: n.a
                });
            case 2:
                return m(r, {
                    nK: n.a
                });
            case 3:
                return m(r, {
                    wN: n.a
                });
            case 4:
                return m(r, {
                    x0: n.a
                });
            default:
                return m(r, {
                    y4: n.a
                });
        }
    }), qhn = function(n) {
        return m(n, {
            b9: !0
        });
    }, Fhn = Wn("googlePlacesPredictAddress", function(n) {
        return _x(x([
            b("address", Ax(n.mk)),
            b("id", Ax(n.rh))
        ]));
    }), Phn = F2(function(n, r) {
        return {
            rh: r,
            uB: n
        };
    }), zhn = function(n) {
        return n.uB;
    }, jhn = Wn("googlePlacesPredictionDetails", function(n) {
        return _x(x([
            b("id", Ax(n.rh)),
            b("placeId", Ax(n.uB))
        ]));
    }), Shn = F2(function(n, r) {
        var t, e = r.$ ? Pp : (t = A2(Phn, zhn(r.a), n.rh), jhn(t));
        return b(m(n, {
            b9: !1
        }), e);
    }), Lhn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mhn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nhn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hhn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Thn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ihn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Rhn = F2(function(n, r) {
        return A2(Fp, function(n) {
            return n.se;
        }, rv(A2(Rc, function(n) {
            return A2(SE, r, n.El);
        }, n.j$)));
    }), Zhn = F2(function(n, r) {
        return fM(r) ? n : r;
    }), Vhn = F2(function(n, r) {
        return A2(Fp, function(n) {
            return n.wf;
        }, rv(A2(Rc, function(n) {
            return A2(SE, r, n.El);
        }, n.j$)));
    }), Uhn = F2(function(n, r) {
        return A3(dN, Dhn, Hhn(function(n) {
            return A2(sc, "", A2(Rhn, n, 4));
        }(n)), A3(dN, Dhn, Ihn(function(n) {
            return A2(sc, "", A2(Rhn, n, 21));
        }(n)), A3(dN, Dhn, Thn(function(n) {
            return A2(sc, "", A2(Vhn, n, 5));
        }(n)), A3(dN, Dhn, Nhn(function(n) {
            return A2(Zhn, A2(sc, "", A2(Rhn, n, 12)), A2(sc, "", A2(Rhn, n, 11)));
        }(n)), A3(dN, Dhn, Mhn(""), A3(dN, Dhn, Lhn(n.tg), r))))));
    }), Yhn = function(n) {
        return n.mk.mX;
    }, Qhn = function(n) {
        return n.mk.m4;
    }, Ohn = function(n) {
        return n.mk.nK;
    }, Ghn = function(n) {
        return n.mk.y4;
    }, Jhn = function(n) {
        return n.mk.r1;
    }, Whn = function(n) {
        return n.mk.AO;
    }, Khn = function(n) {
        return n.mk.r2;
    }, Xhn = function(n) {
        return n.mk.AP;
    }, ngn = function(n) {
        return n.mk.sg;
    }, rgn = function(n) {
        return n.mk.sh;
    }, tgn = function(n) {
        return n.mk.tg;
    }, egn = function(n) {
        return n.mk.C7;
    }, ugn = function(n) {
        return n.mk.wN;
    }, agn = function(n) {
        return n.mk.DR;
    }, ign = function(n) {
        return n.mk.DS;
    }, cgn = function(n) {
        return n.mk.x0;
    }, ogn = function(n) {
        return n.mk.x1;
    }, fgn = function(n) {
        return n.mk.EF;
    }, sgn = F2(function(n, r) {
        return n && fM(r.yb) ? x([
            b(0, eM(A2(rM, uM, tgn)))
        ]) : h;
    }), lgn = F2(function(n, r) {
        return n && fM(r.nK) ? x([
            b(1, eM(A2(rM, uM, Ohn)))
        ]) : h;
    }), dgn = F2(function(n, r) {
        return n && fM(r.y4) ? x([
            b(4, eM(A2(rM, uM, Ghn)))
        ]) : h;
    }), bgn = function(n) {
        return 2 === su(n) ? lm(n) : jm("State abbreviation is invalid.");
    }, vgn = A2(sm, A2(sm, lm(!0), A2(im, bgn, Hm(qm(ke)))), Gm), mgn = F2(function(n, r) {
        var t = r.wN;
        return fM(t) ? n ? x([
            b(2, eM(A2(rM, uM, ugn)))
        ]) : h : function(n) {
            return !A2(ep, vgn, n).$;
        }(t) ? h : x([
            b(2, dM(agn)),
            b(2, dM(ign))
        ]);
    }), pgn = F2(function(n, r) {
        return i(su(r), n) ? lm(r) : jm("ZIP code is invalid.");
    }), $gn = function(n) {
        return A2(im, pgn(n), Hm(qm(ye)));
    }, hgn = A2(sm, A2(sm, A2(sm, A2(sm, lm(!0), $gn(5)), VS("-")), $gn(4)), Gm), ggn = A2(sm, A2(sm, lm(!0), $gn(5)), Gm), wgn = function(n) {
        return !A2(ep, ggn, n).$ || !A2(ep, hgn, n).$;
    }, xgn = F2(function(n, r) {
        return TE(r) || A2(SE, A2(mu, 5, n), r);
    }), kgn = F2(function(n, r) {
        return !vu(n) && wgn(n) && !A2(xgn, n, r);
    }), ygn = F3(function(n, r, t) {
        var e = t.x0;
        return fM(e) ? r ? x([
            b(3, eM(A2(rM, uM, cgn)))
        ]) : h : wgn(e) ? n.$ && A2(kgn, e, n.a) ? x([
            b(3, dM(ogn))
        ]) : h : x([
            b(3, dM(fgn))
        ]);
    }), _gn = F2(function(n, r) {
        return nM(x([
            sgn(n),
            lgn(n),
            mgn(n),
            A2(ygn, r, n),
            dgn(n)
        ]));
    }), Agn = function(n) {
        var r = A2(BM, A2(_gn, n.vJ, n.ct), n.kB);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Cgn = function(n) {
        switch(n.$){
            case 0:
                return Vt(0);
            case 1:
                return Ut;
            case 2:
                return Vt(1);
            case 3:
                return Vt(2);
            case 4:
                return Vt(3);
            default:
                return Vt(4);
        }
    }, Bgn = F2(function(n, r) {
        var t = Cgn(n);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: Agn(r).a
        }) : a;
    }), Egn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: Agn(r).a,
            x: t
        });
    }), Dgn = F2(function(n, r) {
        var t = Cgn(n);
        if (t.$) return r;
        var e = t.a;
        if (A2(qM, e, r.x)) {
            var u = A3(FM, !0, e, r.x);
            return m(r, {
                kB: Agn(r).a,
                x: u
            });
        }
        return r;
    }), qgn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(Bgn, p = n.a, m(r, {
                    kB: A3(dN, Dhn, p, r.kB)
                })), e = Vt(shn(Ehn(p))), u = function() {
                    switch(p.$){
                        case 0:
                            var n = p.a, r = fM(n) ? b(!1, h) : b(!0, t.bE), e = r.a, u = r.b, a = A3(SX, vhn, n, t.cg), i = a.b;
                            return b(m(t, {
                                cg: a.a,
                                b9: e,
                                bE: u
                            }), i);
                        case 4:
                            return b(A2(Dgn, p, t), Pp);
                        default:
                            return b(t, Pp);
                    }
                }();
                return v(o = u.a, x = u.b, e);
            case 2:
                return v(qhn(r), Pp, Ut);
            case 4:
                var a = n.a.mk;
                if (i(n.a.rh, r.rh)) {
                    if ((f = A2(Yp, Bhn, a)).$) return v(r, Pp, Ut);
                    var c = f.a, o = A2(Egn, !0, m(r, {
                        kB: A2(Uhn, c, r.kB)
                    }));
                    return v(m(o, {
                        iR: Vt(c)
                    }), Pp, Ut);
                }
                return v(r, Pp, Ut);
            case 3:
                var f, s = n.a.bE;
                return i(n.a.rh, r.rh) ? v(m(r, (f = A2(cy, $hn, s)).$ ? {
                    bE: h
                } : {
                    bE: f.a
                }), Pp, Ut) : v(r, Pp, Ut);
            case 1:
                var l = n.a;
                return v(o = function() {
                    switch(l){
                        case 27:
                        case 38:
                        case 13:
                            return lhn(r);
                        case 40:
                            return qhn(r);
                        default:
                            return r;
                    }
                }(), Pp, Ut);
            case 5:
                var d = A2(Shn, r, n.a);
                return v(o = d.a, x = d.b, Vt(shn("Address")));
            case 8:
                var p = n.a, $ = (o = lhn(r), Vt(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(Ehn(p))));
                return v(4 === p.$ ? A2(Dgn, p, o) : o, Pp, $);
            case 9:
                return v(r, Pp, Vt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(Ehn(p = n.a))));
            case 6:
                var g = n.a, w = A4(x0, vhn, h0(bhn), g, r.cg), x = w.b;
                return v(m(r, {
                    cg: w.a
                }), x, Ut);
            default:
                return v(r, Fhn(A2(fhn, n.a, r.rh)), Ut);
        }
    }), Fgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Pgn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zgn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sgn = function(n) {
        switch(n.$){
            case 0:
                return "Existing Coverage";
            case 1:
                return "Carrier";
            case 2:
                return "Carrier Alias Other";
            case 3:
                return "Group ID";
            case 4:
                return "Member ID";
            default:
                return "High Deductible";
        }
    }, Lgn = function(n) {
        return n.ax.np;
    }, Mgn = function(n) {
        return n.ax.yJ;
    }, Ngn = function(n) {
        return n.ax.nr;
    }, Hgn = function(n) {
        return n.ax.yK;
    }, Tgn = function(n) {
        return n.ax.Z;
    }, Ign = function(n) {
        return n.ax.zO;
    }, Rgn = function(n) {
        return n.ax.q_;
    }, Zgn = function(n) {
        return n.ax.rc;
    }, Vgn = function(n) {
        return n.ax.Af;
    }, Ugn = function(n) {
        return n.ax.su;
    }, Ygn = function(n) {
        return n.ax.De;
    }, Qgn = function(n) {
        return A2(nv, function(n) {
            return n.$ ? Ut : Vt(Qmn(n.a));
        }, n);
    }, Ogn = function(n) {
        return n.nU;
    }, Ggn = function(n) {
        return n.nZ;
    }, Jgn = nM(x([
        function(n) {
            var r = n.h3;
            return n.Z && LP(n.ah) && !r ? x([
                b(0, nN(Lgn))
            ]) : h;
        },
        function(n) {
            var r = n.bW, t = n.Z, e = Qgn(n.ah);
            if (e.$) return t && vu(r) ? x([
                b(2, nN(Rgn))
            ]) : h;
            var u = e.a;
            return t && vu(r) && Ogn(u) ? x([
                b(2, nN(Rgn))
            ]) : h;
        },
        function(n) {
            var r = n.b_, t = n.Z, e = Qgn(n.ah);
            if (e.$) return t && vu(r) ? x([
                b(3, nN(Ugn))
            ]) : h;
            var u = e.a;
            return t && vu(r) && Ggn(u) ? x([
                b(3, nN(Ugn))
            ]) : h;
        },
        function(n) {
            var r = n.bL, t = n.Z;
            return Qgn(n.ah).$ && t && vu(r) ? x([
                b(1, nN(Ngn))
            ]) : h;
        }
    ])), Wgn = function(n) {
        var r = A2(BM, Jgn, n);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Kgn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = Wgn(r.kB), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), Xgn = function(n) {
        switch(n.$){
            case 0:
            default:
                return Ut;
            case 1:
                return Vt(0);
            case 2:
                return Vt(1);
            case 3:
                return Vt(2);
            case 4:
                return Vt(3);
        }
    }, nwn = F2(function(n, r) {
        var t = Xgn(n);
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(Kgn, !1, r).a, {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), rwn = function(n) {
        return function(n) {
            return A2(SE, UQ(n), x([
                "true",
                "t"
            ]));
        }(n) ? Vt(!0) : function(n) {
            return A2(SE, UQ(n), x([
                "false",
                "f"
            ]));
        }(n) ? Vt(!1) : Ut;
    }, twn = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 8,
                a: n
            };
        }
    }, ewn = function(n) {
        if (vu(n.D2)) return v(n, Pp, Ut);
        var r = A3(SX, twn, "", n.hf), t = r.b;
        return v(m(n, {
            hf: r.a,
            aP: !1,
            D2: ""
        }), t, Ut);
    }, uwn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, awn = function(n) {
        return A2(Nu, uwn, _u(n));
    }, iwn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), cwn = function(n) {
        return A2(hc, iwn(n), ID(n));
    }, own = F2(function(n, r) {
        var t = ewn(r), e = t.b;
        return v(m(t.a, {
            D2: A2(sc, "", A2(Fp, r.$7(Wx(0)), n))
        }), Vu(x([
            e,
            cwn(r.rh + "-input")
        ])), Vt(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }), fwn = F2(function(n, r) {
        switch(n.$){
            case 3:
                return v(r, 1 === (w = b(n.b, i(n.a, r.rh + "-item-active"))).a.$ && w.b ? cwn(r.rh + "-item") : Pp, Ut);
            case 0:
                return v(m(r, {
                    aP: !r.aP
                }), Pp, Ut);
            case 1:
            case 5:
                return ewn(r);
            case 2:
                switch(t = n.a){
                    case 27:
                    case 38:
                        return ewn(r);
                    case 40:
                        return v(function(n) {
                            return m(n, {
                                aP: !0
                            });
                        }(r), cwn(r.rh + "-item-active"), Ut);
                    default:
                        return v(r, Pp, Ut);
                }
            case 6:
                var t, e = n.a;
                switch(t = n.b){
                    case 27:
                        var u = ewn(r), a = u.c;
                        return v(u.a, Vu(x([
                            u.b,
                            cwn(r.rh + "-input")
                        ])), a);
                    case 13:
                        return A2(own, e, r);
                    default:
                        var c = p_(t);
                        return _e(c) ? v(m(r, {
                            D2: Zb((h = c, h.toLowerCase()))
                        }), cwn(r.rh + "-input"), Ut) : v(r, Pp, Ut);
                }
            case 4:
                return A2(own, e = n.a, r);
            case 7:
                var o = n.b, f = (g = b(n.a, r.aP)).a.$ || g.b ? o : s(su(g.a.a), su(o)) > 0 ? "" : A2(iv, 1, o), l = A3(SX, twn, f, r.hf), d = l.b;
                return v(m(r, {
                    hf: l.a,
                    aP: !0,
                    D2: f
                }), d, Ut);
            case 8:
                var p = n.a, $ = A4(x0, twn, h0(awn), p, r.hf);
                return d = $.b, v(m(r, {
                    hf: $.a
                }), d, Ut);
            default:
                return v(r, Pp, Vt(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(o = n.a)));
        }
        var h, g, w;
    }), swn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = rwn(n.a);
                if (t.$) return v(r, Pp, h);
                var e = $$n(t.a);
                return v(m(r, {
                    kB: A3(dN, h$n, e, r.kB)
                }), Pp, x([
                    zgn(Sgn(e))
                ]));
            case 1:
                var u = A2(fwn, n.a, r.eo), a = u.a, i = u.b, c = u.c, o = function() {
                    if (c.$) return v(r, Pp, h);
                    if (c.a.$) {
                        var n = c.a.a;
                        return v(m(r, {
                            fz: !0
                        }), A2(npn, r.gF, Vt(n)), h);
                    }
                    var t = function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(c.a.a);
                    return v(A2(Kgn, !1, m(r, {
                        kB: A3(dN, h$n, t, r.kB)
                    })).a, Pp, x([
                        zgn(Sgn(t))
                    ]));
                }(), f = o.b, s = o.c;
                return v(m(o.a, {
                    eo: a
                }), Vu(x([
                    A2(Lp, Fgn, i),
                    f
                ])), s);
            case 2:
                return v(m(r, {
                    ep: n.a,
                    fz: !1
                }), Pp, h);
            case 3:
                var l = A3(dN, h$n, w = n.a, r.kB), d = (c = zgn(Sgn(w)), Xgn(w));
                if (d.$) return v(m(r, {
                    kB: l
                }), Pp, x([
                    c
                ]));
                var b = d.a, p = A3(vN, !0, b, r.x), $ = A2(bN, b, p) ? Wgn(l).a : l;
                return v(m(r, {
                    kB: $,
                    x: p
                }), Pp, x([
                    c
                ]));
            case 4:
                var g = rwn(n.a);
                return g.$ ? v(r, Pp, h) : (e = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(g.a), v(m(r, {
                    kB: A3(dN, h$n, e, r.kB)
                }), Pp, x([
                    zgn(Sgn(e))
                ])));
            case 6:
                return v(A2(nwn, w = n.a, r), Pp, x([
                    Pgn(Sgn(w))
                ]));
            default:
                var w;
                return v(r, Pp, x([
                    jgn(Sgn(w = n.a))
                ]));
        }
    }), lwn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dwn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bwn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), vwn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), mwn = function(n) {
        return n.rh;
    }, pwn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), $wn = F4(function(n, r, t, e) {
        var u = A2(sN, e, t), a = u.a, i = u.b;
        return b(m(n, {
            uy: A3(cQ, a, r, n.uy),
            M: A3(vN, !0, t, n.M)
        }), A2(Lp, A2(pwn, r, a), i));
    }), hwn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.c, u = mwn(f = n.b), a = function() {
                    switch(e.$){
                        case 0:
                            return b(A4($wn, r, t, f, e), function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(u));
                        case 1:
                            return b(A4($wn, r, t, f, e), function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(u));
                        case 2:
                            return b(A4($wn, r, t, f, e), function(n) {
                                return {
                                    $: 2,
                                    a: n
                                };
                            }(u));
                        case 3:
                            return b(b(r, A2(Nu, iu, _u(A2(bwn, t, f)))), lwn(u));
                        default:
                            return b(b(r, A2(Nu, iu, _u(A2(vwn, t, f)))), dwn(u));
                    }
                }(), i = a.a;
                return v(i.a, i.b, Vt(o = a.b));
            case 1:
                var c = function(n) {
                    return A2(B$n, Ut, n);
                }(r);
                return v(c.b, Pp, Vt(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(c.a)));
            case 2:
                return t = n.a, u = mwn(f = n.b), v(A3(z$n, r, t, f), Pp, Vt(function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(u)));
            case 3:
                var o = Vt(lwn(mwn(f = n.b)));
                return v(A2(qM, f, r.M) ? m(r, {
                    M: A3(FM, !0, f, r.M)
                }) : r, Pp, o);
            default:
                var f;
                return v(r, Pp, Vt(dwn(mwn(f = n.b))));
        }
    }), gwn = F2(function(n, r) {
        return A2(Fp, function(n) {
            return b(Zmn(r), n);
        }, rv(A2(PH, r, n.kB)));
    }), wwn = function(n) {
        return A2(Tp, function(r) {
            return A2(gwn, n, r);
        }, Rmn);
    }, xwn = function(n) {
        return A2(Eu, function(n) {
            return b(2, n.b);
        }, wwn(n.mk));
    }, kwn = F2(function(n, r) {
        var t = r.pP;
        return fM(t) && n ? x([
            b(0, eM(A2(rM, uM, iM)))
        ]) : fM(t) || lM(t) ? h : x([
            b(0, dM(A2(rM, uM, iM)))
        ]);
    }), ywn = F2(function(n, r) {
        return !A2(jE, A2(pc, gm, n), r);
    }), _wn = F2(function(n, r) {
        var t = q$n(n);
        return !t.$ && i(t.a, r);
    }), Awn = F2(function(n, r) {
        return fM(r.CA) && n.vJ && A2(_wn, n.uy, r) ? x([
            nN(Jj)
        ]) : A2(yM, r.CA, r.Dl) ? x([
            rN(Jj)
        ]) : h;
    }), Cwn = F2(function(n, r) {
        return be(A2(Awn, n, r)) > 0;
    }), Bwn = F2(function(n, r) {
        return !A2(Cwn, n, r.b);
    }), Ewn = F2(function(n, r) {
        return !cO(A2(_Y, function(r) {
            return i(r.b.dQ, n);
        }, r));
    }), Dwn = F2(function(n, r) {
        return r.rt(n);
    }), qwn = function(n) {
        return A2(rM, Dwn, nS(n));
    }, Fwn = F2(function(n, r) {
        if (n.$) return h;
        var t = n.a;
        return A2(Ewn, t, r) ? h : x([
            eM(qwn(t))
        ]);
    }), Pwn = function(n) {
        return A2(_Y, Bwn(n), A2(_Y, function(n) {
            return !fM(HM(n.b));
        }, n.uy));
    }, zwn = function(n) {
        return n.vJ || aF(n.dL) ? cO(n.uy) ? x([
            nN(Jj)
        ]) : A2(Fwn, n.dL, Pwn(n)) : h;
    }, jwn = function(n) {
        var r = A2(Yt, function(n) {
            return TE(zwn(n));
        }(n), A2(sO, Bwn(n), n.uy));
        return A2(ywn, iu, r);
    }, Swn = function(n) {
        return jwn(n.uy) ? h : x([
            b(1, eM(A2(rM, uM, iM)))
        ]);
    }, Lwn = function(n) {
        return n.b.vO;
    }, Mwn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, Q$n, Gpn(A2(Egn, n, t.mk)), r);
    }), Nwn = F2(function(n, r) {
        return m(r, {
            M: n ? jM(r.M) : r.M
        });
    }), Hwn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, Q$n, Kpn(A2(Nwn, n, t.uy)), r);
    }), Twn = F2(function(n, r) {
        var t = A2(Mwn, n, A2(Hwn, n, r.kB)), e = FL(t), u = A2(Kgn, n, e.a1), a = u.b, i = A3(dN, Q$n, Wpn(u.a), t), c = A2(BM, function(n) {
            var r = Lwn(n.dB);
            return nM(x([
                kwn(r),
                xwn,
                Swn
            ]));
        }(r), i);
        return c.$ ? b(c.a, !1) : b(c.a.a, a);
    }), Iwn = F2(function(n, r) {
        var t = function(n) {
            switch(n.$){
                case 1:
                    return Vt(0);
                case 2:
                    return Vt(1);
                case 0:
                    return Vt(2);
                default:
                    return Ut;
            }
        }(n);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: A2(Twn, !1, r).a
        }) : a;
    }), Rwn = F2(function(n, r) {
        return A2(Iwn, n, m(r, {
            kB: A3(dN, Q$n, n, r.kB)
        }));
    }), Zwn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = A2(Twn, n, r), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), Vwn = F2(function(n, r) {
        switch(n.$){
            case 17:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = Bx(r.dB);
                    return v(d = m(r, {
                        fL: Vt(e)
                    }), A4(Rbn, r.gF, u, r.Cr, Jpn), h);
                }
                return v(r, Pp, A2(xA, 0, t));
            case 16:
                var a = n.a, i = b(a, r.fL);
                if (3 !== i.a.$ || i.b.$) return v(r, Pp, A2(xA, 0, a));
                var c = i.a.a, o = (e = i.b.a, FL(r.kB));
                return v(d = m(r, {
                    kB: lS(A4(Y$n, c, r.dB, e, o)),
                    t6: Vt(c)
                }), Pp, h);
            case 15:
                return v(A2(Rwn, n.a, r), Pp, h);
            case 12:
                var f = A2(Zwn, !0, r);
                return v(d = f.a, f.b ? ohn(d) : Pp, h);
            case 13:
                return v(r, A2(AA, da, Fa), h);
            case 14:
                var s = n.a;
                return 3 === s.$ ? v(m(r, {
                    t6: Vt(c = s.a)
                }), A2(AA, da, Fa), h) : v(r, Pp, A2(xA, 0, s));
            case 11:
                var l = n.a;
                if (A2(qM, l, r.x)) {
                    var d, p = A3(FM, !0, l, r.x);
                    return v(m(d = A2(Zwn, !1, r).a, {
                        x: p
                    }), Pp, h);
                }
                return v(r, Pp, h);
            case 6:
                var $ = n.a, g = FL(r.kB), w = A2(hwn, $, g.uy), x = w.b;
                return v(m(r, {
                    kB: A3(dN, Q$n, Kpn(w.a), r.kB)
                }), A2(Lp, Xpn, x), h);
            case 0:
                var k = n.a, y = FL(r.kB), _ = A2(qgn, k, y.mk), A = _.b;
                return v(m(r, {
                    kB: A3(dN, Q$n, Gpn(_.a), r.kB)
                }), A2(Lp, Upn, A), h);
            case 5:
                k = n.a;
                var C = FL(r.kB), B = A2(swn, k, C.a1), E = B.b;
                return v(m(r, {
                    kB: A3(dN, Q$n, Wpn(B.a), r.kB)
                }), A2(Lp, Mmn, E), h);
            default:
                return v(r, Pp, h);
        }
    }), Uwn = {
        $: 12
    }, Ywn = {
        $: 13
    }, Qwn = function(n) {
        return n.Db;
    }, Own = F2(function(n, r) {
        var t = QE(nvn(r));
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Fa))
                ]), x([
                    ld(n(Jd.w5))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Pa({
                        rh: avn(r)
                    })))
                ]), x([
                    t
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld(n(Jd.rm))
        ]));
    }), Gwn = iu, Jwn = function(n) {
        return !n;
    }, Wwn = {
        $: 2
    }, Kwn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xwn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, nxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rxn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, txn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, exn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uxn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), axn = function(n) {
        return function(n) {
            return {
                $: 12,
                a: n
            };
        }(n);
    }, ixn = function(n) {
        return function(n) {
            return {
                $: 13,
                a: n
            };
        }(n);
    }, cxn = {
        zn: !1
    }, oxn = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), fxn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), sxn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-address";
            case 1:
                return n + "-city";
            case 2:
                return n + "-state";
            case 3:
                return n + "-zip";
            default:
                return n + "-country";
        }
    }), lxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dxn = F3(function(n, r, t) {
        return t + ", please contact " + n + (r.$ ? "." : " or " + r.a + ".");
    }), bxn = A2(CN, AN(2), Ut), vxn = function(n) {
        return n ? 4 : 7;
    }, mxn = {
        ek: 0,
        By: Ut
    }, pxn = F2(function(n, r) {
        return m(r, n.$ ? {
            By: Vt(n.a)
        } : {
            ek: n.a
        });
    }), $xn = function(n) {
        return "[" + n + "](mailto:" + n + ")";
    }, hxn = F2(function(n, r) {
        for(;;){
            var t = rv(n);
            if (t.$) return r;
            var e = t.a, u = A3(Dy, e, $xn(e), r), a = tV(n);
            if (a.$) return u;
            n = a.a, r = u;
        }
    }), gxn = function(n) {
        if (n.$) return tB;
        var r = n.a;
        return A2(OC, x([
            zI,
            gC(x([
                Xx("flex message-box__close")
            ])),
            EC(r)
        ]), x([
            A2(PE, x([
                iH
            ]), 2)
        ]));
    }, wxn = F3(function(n, r, t) {
        var e, u = A2(sc, x([
            tB
        ]), A2(Fp, function(n) {
            var r, t;
            return CT((t = A2(Rc, lM, T9(r = n)), A2(hxn, A4(Bq, iu, yq, t, h), r)));
        }, r)), a = A3(de, pxn, mxn, n);
        return A2(LB, x([
            ok(x([
                Xx("message-box w-full flex mb-4 " + (e = a.ek, e ? "message-box--info" : "message-box--error"))
            ]))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex")
                ]))
            ]), x([
                A2(PE, x([
                    iH,
                    cH(bxn),
                    cH(von)
                ]), vxn(a.ek))
            ])),
            A2(LB, x([
                ok(x([
                    Xx("flex flex-shrink flex-col")
                ]))
            ]), x([
                A2(Ek, x([
                    ok(x([
                        Xx("message-box__title")
                    ]))
                ]), u),
                A2(LB, x([
                    ok(x([
                        Xx("message-box__content")
                    ])),
                    $H
                ]), x([
                    t
                ]))
            ])),
            gxn(a.By)
        ]));
    }), xxn = F3(function(n, r, t) {
        if (t.$) {
            var e = t.b, u = t.c;
            if (A2(kgn, r, t.a)) {
                var a = n(ogn), i = x([
                    lxn(0)
                ]), c = A3(dxn, e, u, "We're sorry but we do not have coverage in your area yet. To get more information");
                return A2(LB, x([
                    _H(yan)
                ]), x([
                    A3(wxn, i, Vt(a), A2(LB, h, x([
                        ld(c)
                    ])))
                ]));
            }
            return tB;
        }
        return tB;
    }), kxn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, yxn = function(n) {
        return b(zhn(n), A2(Tq, $(UE, x([
            Xx("select__item"),
            A2(jC, "role", "option"),
            Qq(kxn(Vt(n)))
        ])), x([
            A2(PE, x([
                HB,
                MB("fill-gray")
            ]), 10),
            ld(n.pe)
        ])));
    }, _xn = F2(function(n, r) {
        return A2(oR, n && !TE(r), A3(Kq, "div", x([
            Xx("select__items")
        ]), A2(Eu, yxn, r)));
    }), Axn = F3(function(n, r, t) {
        var e = A3(de, oxn, cxn, r), u = FL(t.kB), a = u.yb, i = u.yc, c = u.nK, o = u.wN, f = u.x0, s = u.y4;
        return A2(LB, x([
            ok(x([
                Xx("address-input"),
                Hq(t.rh)
            ]))
        ]), x([
            A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ]))
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(Jhn)),
                        VH(t.vJ),
                        exn(n(Whn))
                    ]), x([
                        A2(LB, x([
                            ok(x([
                                Xx("select")
                            ]))
                        ]), x([
                            vI(x([
                                hI(A2(sxn, t.rh, 0)),
                                xI(a),
                                txn(!1),
                                gI(A2(pc, nxn, Lhn)),
                                axn(Wwn),
                                JT(A3(fxn, t.kB, t.x, 0)),
                                YT(e.zn),
                                XT(Xwn(Lhn(a))),
                                nI(rxn(Lhn(a))),
                                ixn(Kwn),
                                aI(!0)
                            ])),
                            A2(_xn, t.b9, t.bE)
                        ])),
                        A2(ET, n, A3(uxn, t.kB, t.x, 0))
                    ]))
                ]))
            ])),
            A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ]))
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(Khn)),
                        exn(n(Xhn))
                    ]), x([
                        vI(x([
                            xI(i),
                            gI(A2(pc, nxn, Mhn)),
                            YT(e.zn),
                            aI(!0),
                            XT(Xwn(Mhn(i))),
                            nI(rxn(Mhn(i)))
                        ]))
                    ]))
                ]))
            ])),
            A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ])),
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(4),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), x([
                    A2(XH, x([
                        HH(n(Ohn)),
                        VH(t.vJ)
                    ]), h)
                ])),
                A2(EN, x([
                    JI(4),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), x([
                    A2(XH, x([
                        HH(n(ugn)),
                        VH(t.vJ)
                    ]), h)
                ])),
                A2(EN, x([
                    JI(4),
                    KN(x([
                        Xx("flex")
                    ]))
                ]), x([
                    A2(XH, x([
                        HH(n(cgn)),
                        VH(t.vJ)
                    ]), h)
                ]))
            ])),
            A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ]))
            ]), x([
                A2(EN, x([
                    JI(4)
                ]), x([
                    vI(x([
                        hI(A2(sxn, t.rh, 1)),
                        xI(c),
                        gI(A2(pc, nxn, Nhn)),
                        JT(A3(fxn, t.kB, t.x, 1)),
                        YT(e.zn),
                        aI(!0),
                        XT(Xwn(Nhn(c))),
                        nI(rxn(Nhn(c)))
                    ]))
                ])),
                A2(EN, x([
                    JI(4)
                ]), x([
                    vI(x([
                        hI(A2(sxn, t.rh, 2)),
                        xI(o),
                        gI(A2(pc, nxn, Thn)),
                        JT(A3(fxn, t.kB, t.x, 2)),
                        YT(e.zn),
                        aI(!0),
                        XT(Xwn(Thn(o))),
                        nI(rxn(Thn(o)))
                    ]))
                ])),
                A2(EN, x([
                    JI(4)
                ]), x([
                    vI(x([
                        hI(A2(sxn, t.rh, 3)),
                        xI(f),
                        gI(A2(pc, nxn, Ihn)),
                        JT(A3(fxn, t.kB, t.x, 3)),
                        YT(e.zn),
                        aI(!0),
                        XT(Xwn(Ihn(f))),
                        nI(rxn(Ihn(f)))
                    ]))
                ])),
                A2(EN, x([
                    JI(4)
                ]), x([
                    A2(ET, n, A3(uxn, t.kB, t.x, 1))
                ])),
                A2(EN, x([
                    JI(4)
                ]), x([
                    A2(ET, n, A3(uxn, t.kB, t.x, 2))
                ])),
                A2(EN, x([
                    JI(4)
                ]), x([
                    A2(ET, n, A3(uxn, t.kB, t.x, 3))
                ]))
            ])),
            A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ])),
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(Ghn)),
                        VH(t.vJ)
                    ]), x([
                        vI(x([
                            hI(A2(sxn, t.rh, 4)),
                            xI(s),
                            gI(A2(pc, nxn, Hhn)),
                            JT(A3(fxn, t.kB, t.x, 4)),
                            YT(e.zn),
                            aI(!0),
                            XT(Xwn(Hhn(s))),
                            nI(rxn(Hhn(s)))
                        ])),
                        A2(ET, n, A3(uxn, t.kB, t.x, 4)),
                        A3(xxn, n, f, t.ct)
                    ]))
                ]))
            ]))
        ]));
    }), Cxn = F3(function(n, r, t) {
        var e = FL(t.kB).mk, u = t.fL;
        return u.$ || Jwn(n$n(u.a)) ? tB : A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(Ck, Upn, A3(Axn, n, x([
                Gwn(r)
            ]), e))
        ]));
    }), Bxn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Exn = function(n) {
        return n.cm.qB;
    }, Dxn = function(n) {
        return n.cm.AB;
    }, qxn = function(n) {
        return n.cm.rS;
    }, Fxn = function(n) {
        return n.cm.s2;
    }, Pxn = function(n) {
        return n.cm.wY;
    }, zxn = function(n) {
        return n.cm.w5;
    }, jxn = iu, Sxn = Jd.zn, Lxn = {
        $: 3
    }, Mxn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), Nxn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hxn = x([
        0,
        1,
        2,
        3,
        4,
        5
    ]), Txn = {
        zn: !1
    }, Ixn = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), Rxn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), Zxn = F3(function(n, r, t) {
        var e = A3(de, Ixn, Txn, r), u = FL(t.kB).w5;
        return A2(nk, x([
            Xx("title-input"),
            Hq(t.rh)
        ]), x([
            A2(nk, x([
                Xx("select")
            ]), x([
                A2(Ck, iu, A4(sF, n, x([
                    Dq(u),
                    xq(n(gM)),
                    vq,
                    AR(e.zn),
                    Nxn(A3(Rxn, t.kB, t.x, 0))
                ]), A2(Eu, function(n) {
                    return A2(hq, h, n);
                }, Hxn), t.fU))
            ])),
            A2(ET, n, A3(Mxn, t.kB, t.x, 0))
        ]));
    }), Vxn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.aj, a = e.nJ, i = e.nF, c = e.nH, o = e.nG, f = e.nI;
        return A2(nk, h, x([
            A2(zN, x([
                jN(BN)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(LV, n(Sxn), A2(HT, x([
                        zT(u),
                        FT(r)
                    ]), x([
                        ld(n(Dxn))
                    ])))
                ]))
            ])),
            A2(oR, u, A2(zN, h, x([
                A2(EN, x([
                    bR(2),
                    KN(x([
                        Xx("mb-4 sm:mb-0")
                    ]))
                ]), x([
                    A2(XH, x([
                        HH(n(zxn)),
                        Lxn
                    ]), x([
                        A2(LV, n(Sxn), A2(Ck, Bxn, A3(Zxn, n, x([
                            jxn(r)
                        ]), a)))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(Exn)),
                        Lxn
                    ]), x([
                        A2(LV, n(Sxn), vI(x([
                            xI(i),
                            YT(r),
                            aI(!0)
                        ])))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Fxn)),
                        Lxn
                    ]), x([
                        A2(LV, n(Sxn), vI(x([
                            xI(c),
                            YT(r),
                            aI(!0)
                        ])))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(qxn)),
                        Lxn
                    ]), x([
                        A2(LV, n(Sxn), vI(x([
                            xI(o),
                            YT(r),
                            aI(!0)
                        ])))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Pxn)),
                        Lxn
                    ]), x([
                        A2(LV, n(Sxn), vI(x([
                            xI(f),
                            YT(r),
                            aI(!0)
                        ])))
                    ]))
                ]))
            ])))
        ]));
    }), Uxn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Yxn = F3(function(n, r, t) {
        var e = FL(t.kB).bk;
        return A2(nk, h, x([
            A2(zN, h, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(tM))
                    ]), x([
                        A2(LV, n(Sxn), A2(Ck, Uxn, A3(mI, n, x([
                            RT(r)
                        ]), e)))
                    ]))
                ]))
            ]))
        ]));
    }), Qxn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Oxn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Gxn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Jxn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), Wxn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), Kxn = F3(function(n, r, t) {
        var e = FL(t.kB).pP;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(iM)),
                    VH(Lwn(t.dB))
                ]), x([
                    vI(x([
                        hI("Email"),
                        xI(e),
                        gI(A2(pc, Gxn, Qxn)),
                        JT(A3(Wxn, t.kB, t.x, 0)),
                        YT(r),
                        XT(Oxn(0)),
                        aI(!0)
                    ])),
                    A2(ET, n, A3(Jxn, t.kB, t.x, 0))
                ]))
            ]))
        ]));
    }), Xxn = function(n) {
        return n.b.xi;
    }, nkn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rkn = iu, tkn = x([
        0,
        1,
        2
    ]), ekn = {
        $: 2
    }, ukn = {
        $: 3
    }, akn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ikn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ckn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), okn = F2(function(n, r) {
        return !r.$ && n(r.a);
    }), fkn = {
        zn: !1,
        CB: Jln
    }, skn = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), lkn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), dkn = F4(function(n, r, t, e) {
        var u = A3(de, skn, fkn, r), a = A2(Eu, function(n) {
            return A2(hq, h, n);
        }, t), i = FL(e.kB), c = i.fF, o = i.dy;
        return A2(nk, x([
            Xx("gender-input"),
            Hq(e.rh)
        ]), x([
            A2(nk, x([
                Xx("select"),
                SC(x([
                    b("mb-4", A2(okn, e.AH, c))
                ]))
            ]), x([
                A2(Ck, ikn, A4(sF, n, x([
                    Dq(c),
                    xq(n(u.CB)),
                    vq,
                    AR(u.zn),
                    Nxn(A3(lkn, e.kB, e.x, 0)),
                    b5(!0)
                ]), a, e.fW)),
                A2(ET, n, A3(ckn, e.kB, e.x, 0))
            ])),
            A2(oR, A2(okn, e.AH, c), A2(nk, h, x([
                vI(x([
                    xI(o),
                    gI(akn),
                    JT(A3(lkn, e.kB, e.x, 1)),
                    YT(u.zn),
                    XT(ekn),
                    nI(ukn),
                    aI(!0)
                ])),
                A2(ET, n, A3(ckn, e.kB, e.x, 1))
            ])))
        ]));
    }), bkn = F3(function(n, r, t) {
        var e = FL(t.kB).qV;
        return A2(zN, x([
            jN(iR)
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Hmn.rQ))
                ]), x([
                    A2(Ck, nkn, A4(dkn, n, x([
                        rkn(r)
                    ]), tkn, e))
                ]))
            ]))
        ]));
    }), vkn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mkn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pkn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, $kn = iu, hkn = x([
        1,
        0,
        2,
        3,
        4,
        5
    ]), gkn = x([
        1,
        0,
        2,
        3
    ]), wkn = x([
        0,
        1,
        2
    ]), xkn = {
        zn: !1
    }, kkn = F2(function(n, r) {
        return m(r, {
            zn: n
        });
    }), ykn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), _kn = F3(function(n, r, t) {
        var e = A3(de, kkn, xkn, r), u = FL(t.kB).we;
        return A2(nk, x([
            Xx("select")
        ]), x([
            A2(Ck, iu, A4(sF, n, x([
                Dq(u),
                xq(n(Jln)),
                vq,
                AR(e.zn),
                Nxn(A3(ykn, t.kB, t.x, 0)),
                b5(!0)
            ]), A2(Eu, function(n) {
                return A2(hq, h, n);
            }, wkn), t.fJ))
        ]));
    }), Akn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), Ckn = F2(function(n, r) {
        return A2(ET, n, A3(Akn, r.kB, r.x, 0));
    }), Bkn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.we, a = e.qW, i = e.u5;
        return A2(zN, x([
            jN(iR)
        ]), x([
            A2(EN, x([
                JI(4)
            ]), x([
                A2(XH, x([
                    HH(n(Vvn.rQ))
                ]), x([
                    A2(LV, n(Sxn), A2(Ck, pkn, A3(_kn, n, x([
                        $kn(r)
                    ]), u)))
                ])),
                A2(Ckn, n, u)
            ])),
            A2(EN, x([
                JI(4)
            ]), x([
                A2(XH, x([
                    HH(n(Tvn.rQ))
                ]), x([
                    A2(LV, n(Sxn), A2(Ck, vkn, A4(dkn, n, x([
                        rkn(r)
                    ]), hkn, a)))
                ]))
            ])),
            A2(EN, x([
                JI(4)
            ]), x([
                A2(XH, x([
                    HH(n(Rvn.rQ))
                ]), x([
                    A2(LV, n(Sxn), A2(Ck, mkn, A4(dkn, n, x([
                        rkn(r)
                    ]), gkn, i)))
                ]))
            ]))
        ]));
    }), Ekn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            Xxn(t.dB) ? A3(Bkn, n, r, t) : A3(bkn, n, r, t)
        ]));
    }), Dkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qkn = function(n) {
        return x5(n);
    }, Fkn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, Pkn = function(n) {
        return n.tm;
    }, zkn = function(n) {
        return n ? "True" : "False";
    }, jkn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Skn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lkn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mkn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nkn = A2(pc, mq, Mkn), Hkn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), Tkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ikn = {
        $: 1
    }, Rkn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), Zkn = {
        $: 0
    }, Vkn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ukn = {
        $: 5
    }, Ykn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qkn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Okn = A2(ak, x([
        Xx("select__arrow")
    ]), h), Gkn = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(FI, x([
                bq
            ]), x([
                ld(r)
            ]));
        }
        return A2(FI, h, x([
            ld(r = n.a)
        ]));
    }, Jkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wkn = F4(function(n, r, t, e) {
        if (r.b) {
            var u = r.a, a = r.b;
            return A2(Yt, Jkn(A3(lu, n, u, e)), A2(Yt, function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A3(lu, u, u + t, e)), A4(Wkn, u + t, a, t, e)));
        }
        return x([
            Jkn(A3(lu, n, su(e), e))
        ]);
    }), Kkn = F3(function(n, r, t) {
        return A2(ak, h, A2(Eu, Gkn, A4(Wkn, 0, r, su(n), t)));
    }), Xkn = F2(function(n, r) {
        var t = A2(bu, UQ(n), UQ(r));
        return A3(Kkn, n, t, r);
    }), nyn = F3(function(n, r, t) {
        return A2(Xkn, n, r(t));
    }), ryn = {
        zn: !1,
        eK: !1,
        Ax: !1,
        AR: !1,
        CB: "Pick an item",
        xz: Ut
    }, tyn = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    zn: n.a
                });
            case 0:
                return m(r, {
                    xz: n.a
                });
            case 1:
                return m(r, {
                    CB: n.a
                });
            case 3:
                return m(r, {
                    Ax: n.a
                });
            case 4:
                return m(r, {
                    AR: n.a
                });
            default:
                return m(r, {
                    eK: !0
                });
        }
    }), eyn = function(n) {
        return x([
            NC(n.zn),
            SC(x([
                b("select--invalid", n.Ax),
                b("w-full", n.eK)
            ]))
        ]);
    }, uyn = F4(function(n, r, t, e) {
        var u, a = A3(de, tyn, ryn, r), i = A2(Fp, e.$7(n), a.xz), c = {
            Bv: Ukn,
            BM: Qkn,
            BW: Ykn,
            Dj: e.rh,
            iQ: a.xz,
            Eb: A2(nyn, e.D2, e.$7(n)),
            Ed: e.kK
        };
        return A2(nk, x([
            Xx("select select--searchable"),
            SC(x([
                b("select--open", e.aP),
                b("select--loading", a.AR),
                b("w-full", a.eK)
            ])),
            Hq(e.rh)
        ]), x([
            A2(Zq, A2(Yt, Xx("select__input"), A2(Yt, IC(Zkn), A2(Yt, A2(YC, Ikn, e.rh), A2(Yt, ZC(Vkn), A2(Yt, Hq(e.rh + "-input"), A2(Yt, fT(A2(sc, a.CB, i)), A2(Yt, Iq((u = b(a.xz, e.aP), u.a.$ || u.b ? e.D2 : A2(e.$7, n, u.a.a))), A2(Yt, oT(Rkn(i)), eyn(a))))))))), h),
            a.AR ? A2(ak, x([
                Xx("select__spinner")
            ]), h) : Okn,
            !a.zn && e.aP ? A3(Kq, "div", x([
                Xx("select__items")
            ]), A2(Eu, Wq(c), t)) : tB
        ]));
    }), ayn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iyn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, cyn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, oyn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fyn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), syn = F2(function(n, r) {
        var t = FL(r.kB).bL;
        return A2(zN, x([
            KN(x([
                Xx("-mx-1")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(n(Ngn)),
                    VH(!0)
                ]), x([
                    vI(x([
                        xI(t),
                        gI(A2(pc, oyn, ayn)),
                        JT(A3(Hkn, r.kB, r.x, 1)),
                        XT(iyn(ayn(t))),
                        nI(cyn(ayn(t)))
                    ]))
                ])),
                A2(ET, n, A3(fyn, r.kB, r.x, 1))
            ]))
        ]));
    }), lyn = F2(function(n, r) {
        return A3(fyn, n.kB, n.x, r);
    }), dyn = F2(function(n, r) {
        var t, e = FL(r.kB).ah, u = function() {
            var t = r.ep;
            if (3 === t.$) {
                var u = t.a, a = A2(Yt, Tkn(e), A2(Yt, jkn(A3(Hkn, r.kB, r.x, 0)), A2(Yt, Lkn(n(Hgn)), r.fz ? x([
                    Skn(!0)
                ]) : h))), i = $(A2(Eu, function(n) {
                    return A2(hq, h, k$n(n));
                }, u), x([
                    A2(hq, h, y$n)
                ])), c = n(Ygn);
                return b(a, $(i, x([
                    Nkn(c)
                ])));
            }
            return b(x([
                Lkn("Loading carriers..."),
                Skn(!0)
            ]), h);
        }(), a = u.a, i = u.b;
        return A2(nk, h, x([
            A2(XH, x([
                HH(n(Lgn)),
                VH(!0),
                HH(n(Mgn))
            ]), x([
                A2(zN, x([
                    KN(x([
                        Xx("-mx-1")
                    ]))
                ]), x([
                    A2(EN, h, x([
                        A2(Ck, Fgn, A4(uyn, n, a, i, r.eo)),
                        A2(ET, n, A2(lyn, r, 0))
                    ]))
                ]))
            ])),
            A2(oR, (t = e, !t.$ && !!t.a.$), A2(syn, n, r))
        ]));
    }), byn = function(n) {
        return n.nV;
    }, vyn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, myn = F3(function(n, r, t) {
        var e = FL(t.kB).bW;
        return A2(zN, x([
            KN(x([
                Xx("-mx-1")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(n(Rgn)),
                    VH(!0)
                ]), x([
                    vI(x([
                        xI(e),
                        iI("321555 --- 000"),
                        gI(A2(pc, oyn, vyn)),
                        JT(A3(Hkn, t.kB, t.x, 2)),
                        YT(r),
                        nI(cyn(vyn(e))),
                        XT(iyn(vyn(e)))
                    ]))
                ])),
                A2(ET, n, A2(lyn, t, 2))
            ]))
        ]));
    }), pyn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, $yn = function(n) {
        return n.xT;
    }, hyn = F3(function(n, r, t) {
        var e = FL(t.kB).rc;
        return A2(nk, h, x([
            A2(XH, x([
                HH(n(Zgn)),
                VH(!0),
                exn(n(Vgn))
            ]), x([
                A2(zN, x([
                    KN(x([
                        Xx("-mx-1")
                    ]))
                ]), x([
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(e),
                            D5(pyn),
                            T5(zkn(!0)),
                            Fkn(r)
                        ]), x([
                            ld(n($yn))
                        ]))
                    ])),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(!e),
                            D5(pyn),
                            T5(zkn(!1)),
                            Fkn(r)
                        ]), x([
                            ld(n(Pkn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), gyn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wyn = F3(function(n, r, t) {
        var e = FL(t.kB).b_;
        return A2(zN, x([
            KN(x([
                Xx("-mx-1")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(XH, x([
                    HH(n(Ugn)),
                    VH(!0)
                ]), x([
                    vI(x([
                        xI(e),
                        iI("EXF000099900"),
                        gI(A2(pc, oyn, gyn)),
                        JT(A3(Hkn, t.kB, t.x, 3)),
                        YT(r),
                        nI(cyn(gyn(e))),
                        XT(iyn(gyn(e)))
                    ]))
                ])),
                A2(ET, n, A2(lyn, t, 3))
            ]))
        ]));
    }), xyn = F3(function(n, r, t) {
        var e = FL(t.kB).ah, u = Qgn(e), a = function() {
            var n = b(e, u);
            n: for(; !n.a.$;){
                if (1 === n.a.a.$) return v(!0, !0, !0);
                if (n.b.$) break n;
                var r = n.b.a;
                return v(Ogn(r), Ggn(r), byn(r));
            }
            return v(!1, !1, !1);
        }(), i = a.b, c = a.c;
        return A2(nk, h, x([
            A2(oR, a.a, A3(myn, n, r, t)),
            A2(oR, i, A3(wyn, n, r, t)),
            A2(oR, c, A3(hyn, n, r, t))
        ]));
    }), kyn = F3(function(n, r, t) {
        return A2(nk, h, 3 === t.ep.$ ? x([
            A2(dyn, n, t),
            A3(xyn, n, r, t)
        ]) : ck);
    }), yyn = F3(function(n, r, t) {
        var e = FL(t.kB).Z;
        return A2(nk, h, x([
            A2(XH, x([
                HH(n(Tgn)),
                VH(!0),
                exn(n(Ign))
            ]), x([
                A2(zN, x([
                    KN(x([
                        Xx("-mx-1")
                    ]))
                ]), x([
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(e),
                            D5(Dkn),
                            T5(zkn(!0)),
                            Fkn(r)
                        ]), x([
                            ld(n($yn))
                        ]))
                    ])),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(!e),
                            D5(Dkn),
                            T5(zkn(!1)),
                            Fkn(r)
                        ]), x([
                            ld(n(Pkn))
                        ]))
                    ]))
                ]))
            ])),
            A2(oR, e, A3(kyn, n, r, t))
        ]));
    }), _yn = F3(function(n, r, t) {
        return A2(nk, h, x([
            A3(yyn, n, r, t)
        ]));
    }), Ayn = F3(function(n, r, t) {
        var e = FL(t.kB).a1;
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(Ek, x([
                _H(BN),
                aq,
                bq
            ]), x([
                ld(n(Jd.q0))
            ])),
            A2(Ck, Mmn, A3(_yn, n, r, e))
        ]));
    }), Cyn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Byn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.w5, a = e.qB, i = e.s2, c = e.rS, o = e.wY;
        return A2(zN, h, x([
            A2(EN, x([
                bR(2),
                KN(x([
                    Xx("mb-4 sm:mb-0")
                ]))
            ]), x([
                A2(XH, x([
                    HH(n(hM))
                ]), x([
                    A2(LV, n(Sxn), A2(Ck, Cyn, A3(Zxn, n, x([
                        jxn(r)
                    ]), u)))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(vM))
                ]), x([
                    A2(LV, n(Sxn), vI(x([
                        xI(a),
                        YT(r),
                        aI(!0)
                    ])))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n(pM))
                ]), x([
                    A2(LV, n(Sxn), vI(x([
                        xI(i),
                        YT(r),
                        aI(!0)
                    ])))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(mM))
                ]), x([
                    A2(LV, n(Sxn), vI(x([
                        xI(c),
                        YT(r),
                        aI(!0)
                    ])))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n($M)),
                    Lxn
                ]), x([
                    A2(LV, n(Sxn), vI(x([
                        xI(o),
                        YT(r),
                        aI(!0)
                    ])))
                ]))
            ]))
        ]));
    }), Eyn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dyn = {
        $: 1
    }, qyn = F2(function(n, r) {
        var t = A2(jE, iu, A2(sO, function(n) {
            return A2(bN, n.b, r.M);
        }, r.uy)), e = t ? zwn(r) : h;
        if (t && be(e) > 0) return A2(nk, x([
            Xx("mb-4 -mt-2 md:-mt-3")
        ]), x([
            A2(ET, n, e)
        ]));
        var u = b(t, r.dL);
        if (u.a || u.b.$) return tB;
        var a = u.b.a;
        return A2(nk, x([
            Xx("mb-4 -mt-2 md:-mt-3")
        ]), x([
            A2(Ek, x([
                $H,
                fq
            ]), x([
                ld(n(qwn(a)))
            ]))
        ]));
    }), Fyn = {
        zn: !1,
        jb: !1
    }, Pyn = F2(function(n, r) {
        return m(r, n.$ ? {
            jb: n.a
        } : {
            zn: n.a
        });
    }), zyn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), jyn = F2(function(n, r) {
        return A2(bN, r, n.M) ? A2(Awn, n, r) : h;
    }), Syn = F2(function(n, r) {
        return A2(bN, r, n.M) && A2(Cwn, n, r);
    }), Lyn = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return b(a.rh, A2(nk, x([
            Xx("flex flex-col mb-4")
        ]), x([
            A2(Ck, A2(pwn, u, a), A3(PR, n, x([
                tR(r),
                aR(A2(Syn, t, a))
            ]), a)),
            A2(nk, x([
                Xx("-mx-1")
            ]), x([
                A2(ET, n, A2(jyn, t, a))
            ])),
            A2(oR, !A2(_wn, t.uy, a), A2(OC, x([
                zI,
                gC(x([
                    Xx("text-primary-300 text-left p-0")
                ])),
                EC(A2(zyn, u, a))
            ]), x([
                ld("- "),
                ld(n(Xj))
            ])))
        ])));
    }), Myn = F3(function(n, r, t) {
        var e = A3(de, Pyn, Fyn, r);
        return A2(nk, x([
            Xx("phones-input"),
            Hq(t.rh)
        ]), x([
            A3(Kq, "div", h, A2(sO, A3(Lyn, n, e.zn, t), t.uy)),
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(qyn, n, t)
                ]))
            ])),
            e.jb ? tB : A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(OC, x([
                        oF,
                        uF(e.zn),
                        uln(e.zn),
                        EC(Dyn)
                    ]), x([
                        A2(ak, h, x([
                            ld(n(Oj))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), Nyn = F3(function(n, r, t) {
        var e = FL(t.kB).uy;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Jj)),
                    VH(e.vJ)
                ]), x([
                    A2(nk, x([
                        Xx("mx-1")
                    ]), x([
                        A2(Ck, Xpn, A3(Myn, n, x([
                            Eyn(r)
                        ]), e))
                    ]))
                ]))
            ]))
        ]));
    }), Hyn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Tyn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Iyn = function(n) {
        return n.uU;
    }, Ryn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Zyn = Ryn(0), Vyn = F3(function(n, r, t) {
        var e = A3(de, F2(function(n, r) {
            return m(r, n.$ ? {
                lK: !0
            } : {
                zn: n.a
            });
        }), {
            zn: !1,
            lK: !1
        }, r);
        return A2(nk, x([
            Hq(t.rh)
        ]), x([
            A2(Ck, iu, A4(sF, n, A2(Yt, Dq(Vt(t.AL)), A2(Yt, vq, A2(Yt, AR(e.zn), e.lK ? x([
                Zyn
            ]) : h))), A2(Eu, hq(h), x([
                0,
                1
            ])), t.fC))
        ]));
    }), Uyn = F3(function(n, r, t) {
        var e = FL(t.kB).uU;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Iyn))
                ]), x([
                    A2(Ck, Hyn, A3(Vyn, n, x([
                        Tyn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), Yyn = function(n) {
        return fM(n) ? "" : "***-**-" + A2(iv, 4, n);
    }, Qyn = function(n) {
        return n.wG;
    }, Oyn = F3(function(n, r, t) {
        var e = FL(t.kB).wG;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Qyn))
                ]), x([
                    A2(LV, n(Sxn), vI(x([
                        xI(Yyn(e)),
                        YT(r)
                    ])))
                ]))
            ]))
        ]));
    }), Gyn = F3(function(n, r, t) {
        return A2(nk, h, x([
            A3(Byn, n, !0, t),
            A3(Vxn, n, !0, t),
            A3(Yxn, n, !0, t),
            A3(Ekn, n, !0, t),
            A3(Uyn, n, !0, t),
            A3(Oyn, n, !0, t),
            A3(Kxn, n, r, t),
            A3(Nyn, n, r, t),
            A3(Cxn, n, r, t),
            A3(Ayn, n, r, t)
        ]));
    }), Jyn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("text-left")
        ]), x([
            A2(Own, n, t),
            Dk,
            A2(Ak, x([
                ok(x([
                    Xx("mt-8 mb-8")
                ]))
            ]), x([
                ld(n(Jd.rm))
            ])),
            A3(Gyn, n, !1, r),
            A2(nk, h, x([
                A2(zN, h, x([
                    A2(EN, x([
                        JI(12),
                        bR(2),
                        KN(x([
                            Xx("mt-1")
                        ]))
                    ]), x([
                        A2(OC, x([
                            qC,
                            CZ,
                            EC(Uwn)
                        ]), x([
                            ld(n(Qwn))
                        ]))
                    ])),
                    A2(EN, x([
                        JI(12),
                        bR(2),
                        KN(x([
                            Xx("mt-1")
                        ]))
                    ]), x([
                        A2(OC, x([
                            oF,
                            CZ,
                            EC(Ywn)
                        ]), x([
                            ld(n(P3))
                        ]))
                    ])),
                    Bon(x([
                        JI(12),
                        bR(8)
                    ]))
                ]))
            ]))
        ]));
    }), Wyn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.t6, t.$ ? ck : x([
                    A3(Jyn, n, r, t.a)
                ])))
            ]),
            w5: n(Jd.w5)
        };
    }), Kyn = ZA({
        Ar: Rpn,
        AQ: Zpn,
        Db: Vpn,
        DZ: function() {
            return Px(x([
                A2(_S, Upn, Opn)
            ]));
        },
        En: Vwn,
        Et: Wyn
    }), Xyn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, n_n = F3(function(n, r, t) {
        var e = t.Ck;
        return b({
            gF: r.gF,
            kA: r.kA,
            kB: Ut,
            t6: Ut,
            dB: n,
            bz: Ut
        }, A4(Rbn, r.gF, Bx(n), e.rh, Xyn));
    }), r_n = F2(function(n, r) {
        return b(r, Pp);
    }), t_n = F2(function(n, r) {
        return r;
    }), e_n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, u_n = function(n) {
        return {
            pU: n
        };
    }, a_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, i_n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), c_n = {
        yU: function(n) {
            return n.a_.yU;
        },
        z8: function(n) {
            return n.a_.z8;
        },
        Ab: function(n) {
            return n.a_.Ab;
        },
        Bm: function(n) {
            return n.a_.Bm;
        },
        Cd: function(n) {
            return n.a_.Cd;
        },
        Cl: function(n) {
            return n.a_.Cl;
        },
        fC: function(n) {
            return n.a_.fC;
        },
        DE: function(n) {
            return n.a_.DE;
        },
        DM: function(n) {
            return n.a_.DM;
        }
    }, o_n = function(n) {
        switch(n.$){
            case 0:
                return "spouse";
            case 1:
                return "parent";
            case 2:
                return "child";
            case 3:
                return "sibling";
            case 4:
                return "grandparent";
            case 5:
                return "guardian";
            default:
                return "other";
        }
    }, f_n = function(n) {
        return dd({
            rh: "emergency_contact-" + n + "relationship",
            Eb: F2(function(n, r) {
                return n(function(n) {
                    return (function() {
                        if (1 === n.$) return function(n) {
                            return n.Bm;
                        };
                        switch(n.a.$){
                            case 0:
                                return function(n) {
                                    return n.DM;
                                };
                            case 1:
                                return function(n) {
                                    return n.Cl;
                                };
                            case 2:
                                return function(n) {
                                    return n.yU;
                                };
                            case 3:
                                return function(n) {
                                    return n.DE;
                                };
                            case 4:
                                return function(n) {
                                    return n.z8;
                                };
                            case 5:
                                return function(n) {
                                    return n.Ab;
                                };
                            default:
                                return function(n) {
                                    return n.Cd;
                                };
                        }
                    })()(c_n);
                }(r));
            }),
            Ed: Fp(o_n)
        });
    }, s_n = function(n) {
        var r = ipn(n);
        return A2(i_n, n, a_n(lS({
            pP: "",
            qB: "",
            rS: "",
            tg: "",
            uw: r,
            vB: Ut,
            dJ: f_n(n)
        })));
    }, l_n = A2(ru, tvn, function(n) {
        return n.qB;
    }), d_n = A2(ru, tvn, function(n) {
        return n.rS;
    }), b_n = {
        $: 2
    }, v_n = {
        $: 4
    }, m_n = {
        $: 5
    }, p_n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $_n = {
        $: 1
    }, h_n = {
        $: 3
    }, g_n = {
        $: 0
    }, w_n = function(n) {
        switch(n){
            case "spouse":
                return g_n;
            case "parent":
                return $_n;
            case "child":
                return b_n;
            case "sibling":
                return h_n;
            case "grandparent":
                return v_n;
            case "guardian":
                return m_n;
            default:
                return p_n(n);
        }
    }, x_n = F2(function(n, r) {
        if (r.$) return s_n(n);
        var t, e = r.a;
        return A2(i_n, n, a_n(lS({
            pP: A2(sc, "", evn(e)),
            qB: A2(sc, "", l_n(e)),
            rS: A2(sc, "", d_n(e)),
            tg: ivn(e),
            uw: (t = cvn(e), t.$ ? ipn(n) : A2(tS, n, ovn(t.a))),
            vB: A2(Fp, w_n, fvn(e)),
            dJ: f_n(n)
        })));
    }), k_n = {
        $: 1
    }, y_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, __n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, A_n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, C_n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(ry, m(r, {
                    qB: n.a
                }), Pp);
            case 1:
                return A2(ry, m(r, {
                    rS: n.a
                }), Pp);
            case 2:
                var t = A2(ZD, n.a, r.dJ), e = t.b, u = t.c;
                return A2(ry, m(r, {
                    vB: u.$ || u.a.$ || u.a.a.$ ? r.vB : u.a.a.a,
                    dJ: t.a
                }), A2(Lp, A2(ru, A_n, y_n), e));
            case 3:
                return b(m(r, {
                    vB: Vt(p_n(n.a))
                }), Pp);
            case 4:
                return A2(ry, m(r, {
                    pP: n.a
                }), Pp);
            default:
                var a = A2(sN, n.a, r.uw), i = a.b;
                return b(m(r, {
                    uw: a.a
                }), A2(Lp, A2(pc, y_n, __n), i));
        }
    }), B_n = F3(function(n, r, t) {
        var e = t.b, u = A2(n, r, t.a), a = u.b;
        return b(A2(sS, u.a, e), a);
    }), E_n = F2(function(n, r) {
        var t = r.a, e = r.b;
        if (1 === n.$) return b(n.a ? A2(i_n, t, k_n) : s_n(t), Pp);
        var u = n.a;
        if (e.$) return b(A2(i_n, t, e), Pp);
        var a = e.a;
        return A2(qx, A2(ru, a_n, i_n(t)), A3(B_n, C_n, u, a));
    }), D_n = F2(function(n, r) {
        return m(r, {
            pU: n
        });
    }), q_n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, F_n = function(n) {
        var r = n.b;
        if (1 === r.$) return b("use_primary_member_as_emergency_contact", LC(!0));
        var t, e, u = function(n) {
            return A2(sc, yx, A2(Fp, Ax, vu(n) ? Ut : Vt(n)));
        }, a = FL(r.a);
        return b("emergency_contact", _x(x([
            b("first_name", u(a.qB)),
            b("last_name", u(a.rS)),
            b("relationship", A2(sc, yx, A2(Fp, A2(ru, o_n, Ax), a.vB))),
            b("relationship_other", (e = a.vB, e.$ || 6 !== e.a.$ ? yx : Ax(e.a.a))),
            b("email", A2(sc, yx, A2(Fp, Ax, (t = a.pP, vu(t) ? Ut : Vt(t))))),
            b("phone", K$n(a.uw))
        ])));
    }, P_n = F4(function(n, r, t, e) {
        var u = Bx(r), a = FL(e), i = b("patient", _x(VZ(F_n(a.pU))));
        return A5(chn, n, u, t, i, q_n);
    }), z_n = function(n) {
        var r = n.b;
        if (1 === r.$) return h;
        var t = r.a;
        return rc(A2(Eu, function(n) {
            return A2(PH, n, t);
        }, x([
            1,
            0,
            2,
            3
        ])));
    }, j_n = nM(x([
        function(n) {
            var r = n.pU;
            return A2(Eu, ry(0), z_n(r));
        }
    ])), S_n = function(n) {
        return n.aI.pP;
    }, L_n = function(n) {
        return n.aI.qB;
    }, M_n = function(n) {
        return n.aI.rS;
    }, N_n = function(n) {
        return n.aI.uw;
    }, H_n = function(n) {
        return n.aI.vB;
    }, T_n = function(n) {
        return n.aI.C3;
    }, I_n = function(n) {
        return n.aI.C4;
    }, R_n = function(n) {
        return n.aI.DH;
    }, Z_n = function(n) {
        return n.aI.w5;
    }, V_n = F2(function(n, r) {
        return function(t) {
            return n(t) ? h : x([
                r
            ]);
        };
    }), U_n = nM(x([
        function(n) {
            var r, t = n.pP, e = n.uw, u = 1 === n.vB.$, a = A2(ywn, vu, x([
                n.qB,
                n.rS
            ])), i = "" === (r = b(HM(e), t)).a && "" === r.b, c = b(a && u, i);
            return c.a ? c.b ? h : x([
                b(3, eM(I_n))
            ]) : c.b ? x([
                b(2, eM(T_n))
            ]) : h;
        },
        function(n) {
            var r = n.uw;
            return A2(Eu, ry(0), function(n) {
                return A2(yM, n.CA, n.Dl) ? x([
                    rN(Jj)
                ]) : h;
            }(r));
        },
        function(n) {
            var r = n.pP;
            return vu(r) || lM(r) ? h : x([
                b(1, dM(A2(rM, cM, iM)))
            ]);
        },
        A2(V_n, function(n) {
            var r = n.vB;
            return !(!r.$ && 6 === r.a.$ && "" === r.a.a);
        }, b(4, eM(A2(rM, uM, H_n))))
    ])), Y_n = function(n) {
        var r = n.b;
        return A2(i_n, n.a, 1 === r.$ ? r : a_n(function(n) {
            var r = A2(BM, U_n, n);
            return r.$ ? b(r.a, !1) : b(r.a.a, !0);
        }(r.a).a));
    }, Q_n = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = b(r.t6, r.kB);
                if (t.a.$ || t.b.$) return v(r, Pp, h);
                var e = t.a.a, u = function(n) {
                    var r = A2(BM, j_n, function(n) {
                        var r = FL(n), t = Y_n(r.pU);
                        return A3(dN, D_n, t, n);
                    }(n));
                    return r.$ ? b(!1, r.a) : b(!0, r.a.a);
                }(l = t.b.a), a = u.a, i = u.b;
                return v(m(r, {
                    kB: Vt(i)
                }), a ? A4(P_n, r.gF, r.dB, avn(e), i) : Pp, h);
            case 0:
                var c = n.a;
                return e = uC(c), v(m(r, {
                    kB: A2(Fp, lS, A2(Fp, u_n, A2(Fp, x_n("emergency-contact-input"), A2(Fp, uvn, e)))),
                    t6: e
                }), Pp, A2(xA, 0, c));
            case 2:
                var o = n.a;
                return 3 === o.$ ? v(m(r, {
                    t6: Vt(e = o.a)
                }), A2(AA, da, Pa({
                    rh: avn(e)
                })), h) : v(r, Pp, A2(xA, 0, o));
            default:
                var f = n.a, s = r.kB;
                if (s.$) return v(r, Pp, h);
                var l, d = FL(l = s.a), p = A2(E_n, f, d.pU), $ = p.b;
                return v(m(r, {
                    kB: Vt(A3(dN, D_n, p.a, l))
                }), A2(Lp, e_n, $), h);
        }
    }), O_n = {
        $: 3
    }, G_n = cr("form"), J_n = function(n) {
        return b(n, !0);
    }, W_n = F2(function(n, r) {
        return A2(HC, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r));
    }), K_n = function(n) {
        return A2(W_n, "submit", A2(tu, J_n, uu(n)));
    }, X_n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nAn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rAn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tAn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eAn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uAn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aAn = F3(function(n, r, t) {
        var e = t.b, u = x([
            Ut,
            Vt(g_n),
            Vt($_n),
            Vt(b_n),
            Vt(v_n),
            Vt(h_n),
            Vt(m_n),
            Vt(p_n(""))
        ]), a = A3(de, F2(function(n, r) {
            return m(r, n.$ ? {
                vJ: n.a
            } : {
                zn: n.a
            });
        }), {
            zn: !1,
            vJ: !1
        }, r);
        return A2(nk, h, x([
            function() {
                if (1 === e.$) return ld("");
                var r = e.a, t = FL(r);
                return A2(nk, h, x([
                    Dk,
                    A2(zN, x([
                        jN(iR)
                    ]), x([
                        A2(EN, h, x([
                            A2(rH, x([
                                _H(BN),
                                V0
                            ]), x([
                                ld(n(Z_n))
                            ]))
                        ]))
                    ])),
                    A2(zN, h, x([
                        A2(EN, x([
                            kcn(4)
                        ]), x([
                            A2(XH, x([
                                HH(n(L_n))
                            ]), x([
                                vI(x([
                                    gI(A2(pc, y_n, rAn)),
                                    xI(t.qB),
                                    YT(a.zn)
                                ]))
                            ]))
                        ])),
                        A2(EN, x([
                            kcn(4)
                        ]), x([
                            A2(XH, x([
                                HH(n(M_n))
                            ]), x([
                                vI(x([
                                    gI(A2(pc, y_n, tAn)),
                                    xI(t.rS),
                                    YT(a.zn)
                                ]))
                            ]))
                        ])),
                        A2(EN, x([
                            kcn(4)
                        ]), x([
                            A2(XH, x([
                                HH(n(H_n)),
                                Lxn
                            ]), x([
                                A2(Ck, A2(pc, y_n, A_n), A4(sF, n, x([
                                    Dq(Vt(t.vB))
                                ]), A2(Eu, function(n) {
                                    return A2(hq, h, n);
                                }, u), t.dJ))
                            ]))
                        ])),
                        A2(EN, x([
                            kcn(12)
                        ]), x([
                            A2(ET, n, A2(PH, 3, r))
                        ]))
                    ])),
                    function() {
                        var e = t.vB;
                        if (e.$ || 6 !== e.a.$) return ld("");
                        var u = e.a.a;
                        return A2(zN, h, x([
                            A2(EN, x([
                                kcn(12)
                            ]), x([
                                vI(x([
                                    iI(n(H_n)),
                                    gI(A2(pc, y_n, eAn)),
                                    xI(u),
                                    JT(A2(QH, 4, r))
                                ])),
                                A2(ET, n, A2(PH, 4, r))
                            ]))
                        ]));
                    }(),
                    A2(zN, h, x([
                        A2(EN, x([
                            kcn(12)
                        ]), x([
                            A2(XH, x([
                                HH(n(N_n))
                            ]), x([
                                A2(Ck, A2(pc, y_n, __n), A3(PR, n, x([
                                    tR(a.zn),
                                    aR(A2(QH, 0, r) || A2(QH, 2, r))
                                ]), t.uw))
                            ])),
                            A2(ET, n, A2(PH, 0, r))
                        ]))
                    ])),
                    A2(zN, h, x([
                        A2(EN, x([
                            kcn(12)
                        ]), x([
                            A2(XH, x([
                                HH(n(S_n))
                            ]), x([
                                vI(x([
                                    aI(!0),
                                    xI(t.pP),
                                    gI(A2(pc, y_n, nAn)),
                                    JT(A2(QH, 2, r) || A2(QH, 1, r)),
                                    YT(a.zn)
                                ]))
                            ])),
                            A2(ET, n, A2(PH, 1, r))
                        ])),
                        A2(EN, x([
                            kcn(12)
                        ]), x([
                            A2(ET, n, A2(PH, 2, r))
                        ]))
                    ]))
                ]));
            }(),
            a.vJ ? ld("") : A2(zN, h, x([
                A2(EN, h, x([
                    A2(HT, x([
                        PT(uAn),
                        zT(1 === e.$)
                    ]), x([
                        ld(n(R_n))
                    ]))
                ]))
            ]))
        ]));
    }), iAn = F2(function(n, r) {
        var t = QE(nvn(r)), e = avn(r);
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Fa))
                ]), x([
                    ld(n(Jd.w5))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            A2(fB, x([
                Xx("link text-current"),
                yB(_A(Pa({
                    rh: e
                })))
            ]), x([
                t
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            A2(ak, h, x([
                ld(n(Jd.pU))
            ]))
        ]));
    }), cAn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("text-left")
        ]), x([
            A2(iAn, n, r),
            function() {
                if (t.$) return ld("");
                var e = FL(t.a).pU;
                return A2(G_n, x([
                    K_n(O_n)
                ]), x([
                    A2(Ck, e_n, A3(aAn, n, x([
                        X_n(!0)
                    ]), e)),
                    A2(nk, h, x([
                        A2(OC, x([
                            qC
                        ]), x([
                            ld(n(Qwn))
                        ])),
                        A2(IN, x([
                            LN(_A(Pa({
                                rh: avn(r)
                            }))),
                            SN
                        ]), x([
                            ld(n(P3))
                        ]))
                    ]))
                ]));
            }()
        ]));
    }), oAn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.t6, t.$ ? ck : x([
                    A3(cAn, n, t.a, r.kB)
                ])))
            ]),
            w5: n(Jd.w5)
        };
    }), fAn = ZA({
        Ar: n_n,
        AQ: r_n,
        Db: t_n,
        DZ: function() {
            return zx;
        },
        En: Q_n,
        Et: oAn
    }), sAn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lAn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dAn = F6(function(n, r, t, e, u, a) {
        return {
            qm: a,
            rh: n,
            tZ: r,
            uV: e,
            lj: u,
            wO: t
        };
    }), bAn = F5(function(n, r, t, e, u) {
        return {
            ny: r,
            ob: u,
            rh: n,
            tS: t,
            vC: e
        };
    }), vAn = F4(function(n, r, t, e) {
        return {
            yQ: t,
            ry: e,
            tC: n,
            vg: r
        };
    }), mAn = A2(tu, iu, A3(ly, "invoice_id", aL(C$), A3(ly, "charge_item_name", C$, A3(ly, "quantity", F$, A3(ly, "occurred_at", ay, uu(vAn)))))), pAn = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), $An = A3(ly, "name", C$, A3(ly, "id", C$, uu(pAn))), hAn = A2(Pk, $An, uu(iu)), gAn = A2(tu, iu, A3(ly, "consumption_events", vy(mAn), A3(ly, "remaining_quantity", F$, A3(ly, "original_quantity", F$, A3(ly, "charge_item", hAn, A3(ly, "id", C$, uu(bAn))))))), wAn = A2(tu, iu, A4(sy, "expires_at", aL(ay), Ut, A3(ly, "price_in_cents", aL(q$), A3(ly, "prepaid_charges", vy(gAn), A3(ly, "status", C$, A3(ly, "package_name", C$, A3(ly, "id", C$, uu(dAn)))))))), xAn = vy(wAn), kAn = F3(function(n, r, t) {
        return A4(W_, n, xAn, t, rA(function(n) {
            return A2(X_, x([
                "patient_packages"
            ]), lL(n));
        }(r)));
    }), yAn = F2(function(n, r) {
        return A2(wF, function(r) {
            return i(n, r.g2);
        }, r);
    }), _An = F2(function(n, r) {
        var t;
        return !A2(yAn, n, (t = r, t.b.qs)).$;
    }), AAn = function(n) {
        return A2(_An, 1, n);
    }, CAn = F3(function(n, r, t) {
        var e = A2(Wu, "renewedMembershipId", t.iF), u = AAn(n), a = u ? A3(kAn, r.gF, Bx(n), lAn) : Pp;
        return b({
            gF: r.gF,
            kA: r.kA,
            aa: vc,
            ij: u ? cP : vc,
            t6: r.t6,
            dB: n,
            lq: e,
            jK: r.jK
        }, Vu(x([
            A3(Cdn, r.gF, Bx(n), sAn),
            a
        ])));
    }), BAn = F2(function(n, r) {
        return b(r, Pp);
    }), EAn = F2(function(n, r) {
        return m(r, {
            x6: Vt(2)
        });
    }), DAn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            switch(t.$){
                case 3:
                    return v(m(r, {
                        ij: t
                    }), Pp, h);
                case 2:
                    return v(m(r, {
                        ij: vc
                    }), Pp, A2(xA, 0, t));
                default:
                    return v(r, Pp, h);
            }
        } else {
            var e = n.a;
            switch(e.$){
                case 3:
                    return v(m(r, {
                        aa: e
                    }), Pp, h);
                case 2:
                    return v(m(r, {
                        aa: vc
                    }), Pp, A2(xA, 0, e));
                default:
                    return v(r, Pp, h);
            }
        }
    }), qAn = function(n) {
        return n.wO;
    }, FAn = function(n) {
        return n.yj;
    }, PAn = {
        $: 8
    }, zAn = function(n) {
        return n.a.p3;
    }, jAn = F2(function(n, r) {
        return r.sA(n);
    }), SAn = function(n) {
        return n.uF;
    }, LAn = {
        $: 10
    }, MAn = F3(function(n, r, t) {
        return A2(zN, x([
            LAn
        ]), x([
            A2(EN, x([
                JI(1)
            ]), x([
                A2(Ek, x([
                    rB(DB)
                ]), x([
                    A2(PE, x([
                        iH
                    ]), 9)
                ]))
            ])),
            A2(EN, x([
                JI(11)
            ]), x([
                ld(n(jAn(t))),
                A2(Ek, x([
                    fq,
                    ok(x([
                        Xx("mt-1")
                    ]))
                ]), x([
                    A2(FI, x([
                        fq,
                        $H
                    ]), x([
                        ld(n(SAn))
                    ])),
                    ld(" "),
                    A2(IN, x([
                        LN(_A(Na({
                            rh: r
                        })))
                    ]), x([
                        ld(n(Wd.vF))
                    ]))
                ]))
            ]))
        ]));
    }), NAn = function(n) {
        return n.sC;
    }, HAn = F2(function(n, r) {
        return r.sD(n);
    }), TAn = {
        $: 9
    }, IAn = F2(function(n, r) {
        var t = vu(r) ? NAn : HAn(r);
        return A2(zN, x([
            TAn
        ]), x([
            A2(EN, x([
                JI(1)
            ]), x([
                A2(Ek, x([
                    rB(DB)
                ]), x([
                    A2(PE, x([
                        iH,
                        MB("fill-success-300")
                    ]), 8)
                ]))
            ])),
            A2(EN, x([
                JI(11)
            ]), x([
                A2(Ek, x([
                    fq,
                    $H,
                    ok(x([
                        Xx("mt-1")
                    ]))
                ]), x([
                    ld(n(t))
                ]))
            ]))
        ]));
    }), RAn = F5(function(n, r, t, e, u) {
        var a = UQ(A2(H5, n, u.a.Cz)), c = lV(FAn(u.a.tk)), o = Hdn(u), f = Idn(u) ? tB : ld(c + "/" + a), s = Mdn(u), l = !t.$ && i(t.a, s);
        return A2(zN, x([
            PAn,
            JI(12),
            KN(x([
                Xx("card")
            ]))
        ]), x([
            A2(EN, x([
                KN(x([
                    Xx("flex justify-between items-center")
                ]))
            ]), x([
                A2(nk, x([
                    Xx("text-left ml-2")
                ]), x([
                    A2(FI, x([
                        ok(x([
                            Xx("mr-3")
                        ]))
                    ]), x([
                        A2(X8, h, x([
                            ld(o)
                        ]))
                    ])),
                    A2(FI, x([
                        fq,
                        $H
                    ]), x([
                        f
                    ]))
                ])),
                A2(nk, x([
                    Xx("text-right")
                ]), x([
                    A2(IN, x([
                        LN(_A(La({
                            rh: s
                        })))
                    ]), x([
                        ld(n(Wd.iU))
                    ]))
                ]))
            ])),
            A2(EN, h, x([
                function() {
                    if (e) {
                        var t = b(zAn(u), function(n) {
                            return n.a.op;
                        }(u));
                        return t.a.$ || t.b ? tB : A3(MAn, n, s, A2(r, 0, t.a.a));
                    }
                    return tB;
                }()
            ])),
            A2(EN, h, x([
                function() {
                    if (l) {
                        var t = zAn(u);
                        return A2(IAn, n, t.$ ? "" : A2(r, 0, t.a));
                    }
                    return tB;
                }()
            ]))
        ]));
    }), ZAn = F2(function(n, r) {
        return r.tW(n);
    }), VAn = function(n) {
        return n.ij.iU;
    }, UAn = function(n) {
        return n.ny;
    }, YAn = function(n) {
        return n.tg;
    }, QAn = function(n) {
        return n.tS;
    }, OAn = function(n) {
        return n.vC;
    }, GAn = function(n) {
        var r = OAn(n), t = QAn(n), e = YAn(UAn(n));
        return A2(nk, x([
            Xx("text-support")
        ]), x([
            ld(oe(t) + " " + e + " "),
            A2(K8, h, x([
                ld("(" + oe(r) + " remaining)")
            ]))
        ]));
    }, JAn = F2(function(n, r) {
        var t = r.tZ, e = r.rh, u = function() {
            var t = function(n) {
                return n.qm;
            }(r);
            return t.$ ? "" : n(ZAn(A2(fp, "MM/dd/yyyy", t.a)));
        }(), a = function(n) {
            return n.uV;
        }(r);
        return A2(zN, x([
            PAn,
            JI(12),
            KN(x([
                Xx("card")
            ]))
        ]), x([
            A2(EN, x([
                KN(x([
                    Xx("text-left")
                ]))
            ]), x([
                A2(nk, x([
                    Xx("flex justify-between items-center")
                ]), x([
                    A2(nk, h, x([
                        A2(X8, h, x([
                            ld(t)
                        ])),
                        ld(" "),
                        A2(FI, x([
                            fq,
                            $H,
                            yF
                        ]), x([
                            ld(u)
                        ]))
                    ])),
                    A2(IN, x([
                        LN(_A(Ra({
                            rh: e
                        })))
                    ]), x([
                        ld(n(VAn))
                    ]))
                ])),
                TE(a) ? tB : A2(nk, x([
                    Xx("mt-4 space-y-4")
                ]), A2(Eu, GAn, a))
            ]))
        ]));
    }), WAn = F2(function(n, r) {
        return TE(r) ? tB : A2(nk, x([
            Xx("mt-4 space-y-4")
        ]), A2(Eu, JAn(n), r));
    }), KAn = F6(function(n, r, t, e, u, a) {
        var i = function(n) {
            return A2(Ldn, x([
                1
            ]), n);
        }(t), c = AAn(r), o = c ? Wd.p2 : Wd.p1, f = function(n) {
            return A2(Ldn, x([
                3
            ]), n);
        }(t), s = c ? Wd.oU : Wd.oP, l = c && 3 === e.$ ? e.a : h, d = A2(Rc, function(n) {
            return "ended" === qAn(n);
        }, l), b = A2(Rc, function(n) {
            return "active" === qAn(n);
        }, l), v = function(n) {
            return A2(Ldn, x([
                2
            ]), n);
        }(t);
        return x([
            A2(nk, x([
                Xx("space-y-6")
            ]), x([
                TE(i) ? tB : A2(nk, h, x([
                    A2(Ak, h, x([
                        ld(n(Wd.is))
                    ])),
                    A2(nk, x([
                        Xx("mt-4")
                    ]), A2(Eu, A4(RAn, n, u, a, !0), i))
                ])),
                TE(v) && TE(b) ? tB : A2(nk, h, x([
                    A2(Ak, h, x([
                        ld(n(s))
                    ])),
                    A2(nk, x([
                        Xx("mt-4")
                    ]), A2(Eu, A4(RAn, n, u, a, !0), v)),
                    A2(WAn, n, b)
                ])),
                TE(f) && TE(d) ? tB : A2(nk, h, x([
                    A2(Ak, h, x([
                        ld(n(o))
                    ])),
                    A2(nk, x([
                        Xx("mt-4")
                    ]), A2(Eu, A4(RAn, n, u, a, !1), f)),
                    A2(WAn, n, d)
                ]))
            ]))
        ]);
    }), XAn = F2(function(n, r) {
        var t = AAn(r.dB), e = n(t ? Wd.Ea : Wd.w5), u = n(t ? Wd.x_ : Wd.EE);
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), function() {
                    var t, e = r.aa;
                    if (3 === e.$) {
                        var a = e.a;
                        return TE(a) && (3 !== (t = r.ij).$ || TE(t.a)) ? r5(u) : A6(KAn, n, r.dB, a, r.ij, r.jK, r.lq);
                    }
                    return ck;
                }())
            ]),
            w5: e
        };
    }), nCn = ZA({
        Ar: CAn,
        AQ: BAn,
        Db: EAn,
        DZ: function() {
            return zx;
        },
        En: DAn,
        Et: XAn
    }), rCn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, tCn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, eCn = F2(function(n, r) {
        return {
            nj: n,
            ul: r
        };
    }), uCn = F2(function(n, r) {
        return {
            kt: n,
            xz: r
        };
    }), aCn = A3(ly, "value", aL(ay), A3(ly, "editable", jk, uu(uCn))), iCn = A3(ly, "editable", jk, uu(function(n) {
        return {
            kt: n
        };
    })), cCn = A3(ly, "payment_source", iCn, A3(ly, "cancellation_date", aCn, uu(eCn))), oCn = A2(Pk, cCn, uu(iu)), fCn = F6(function(n, r, t, e, u, a) {
        return {
            p7: t,
            qb: e,
            rh: n,
            t6: u,
            vB: a,
            DN: r
        };
    }), sCn = function(n) {
        switch(n){
            case "owner":
                return uu(0);
            case "spouse":
                return uu(1);
            case "child":
                return uu(2);
            case "other":
                return uu(3);
            default:
                return Sk("Unsupported relationship: " + n);
        }
    }, lCn = A3(ly, "relationship", A2(nu, sCn, C$), A3(ly, "patient", JR, A3(ly, "enrollment_status", C$, A3(ly, "effective_end_date", iy(ay), A3(ly, "start_date", iy(ay), A3(ly, "id", C$, uu(fCn))))))), dCn = A2(Pk, lCn, uu(iu)), bCn = A4(sy, "source", aL(Tan), Ut, A3(ly, "meta", oCn, A3(ly, "tobacco_surcharge_enabled", jk, A3(ly, "owner", JR, A3(ly, "dpc_discount", jk, A3(ly, "sponsored", jk, A3(ly, "billed_through_date", iy(ay), A3(ly, "children_age_limit", iy(F$), A3(ly, "maximum_age", iy(F$), A3(ly, "minimum_age", iy(F$), A3(ly, "plan_name", C$, A3(ly, "plan_id", C$, A3(ly, "membership_patients", vy(dCn), A3(ly, "is_cancellable", jk, A3(ly, "enrollment_status", A2(nu, gdn, C$), A3(ly, "period_in_months", A2(nu, wdn, F$), A3(ly, "contract_period_in_months", iy(ay), A3(ly, "contract_end_date", iy(ay), A3(ly, "contract_start_date", iy(ay), A3(ly, "next_future_unpaid_bill", ydn, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return {
                                                                                            mW: v,
                                                                                            nD: b,
                                                                                            oq: e,
                                                                                            ou: u,
                                                                                            ow: t,
                                                                                            py: p,
                                                                                            qb: i,
                                                                                            rh: n,
                                                                                            rB: c,
                                                                                            sn: d,
                                                                                            sB: o,
                                                                                            kV: g,
                                                                                            s9: l,
                                                                                            tk: r,
                                                                                            tU: $,
                                                                                            Cz: a,
                                                                                            uD: f,
                                                                                            uE: s,
                                                                                            wz: w,
                                                                                            wF: m,
                                                                                            w9: h
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))), vCn = A2(Pk, bCn, uu(iu)), mCn = F2(function(n, r) {
        return A2(X_, x([
            "memberships",
            r
        ]), lL(n));
    }), pCn = F4(function(n, r, t, e) {
        return A4(W_, n, vCn, e, rA(A2(mCn, r, t)));
    }), $Cn = function(n) {
        return A4(pCn, n.gF, n.CD, n.h2, tCn);
    }, hCn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, gCn = function(n) {
        return A3(Ran, n.gF, n.CD, hCn);
    }, wCn = {
        e2: !1
    }, xCn = function(n) {
        return n.a.hh;
    }, kCn = function(n) {
        return n.e5.hh;
    }, yCn = function(n) {
        return n.e5.rQ;
    }, _Cn = function(n) {
        return n.e5.jQ;
    }, ACn = function(n) {
        return n.e5.xr;
    }, CCn = F2(function(n, r) {
        return A2(ak, h, x([
            ld(A2(mfn, n, r)),
            A2(Afn, n, pfn(r)),
            xCn(r) ? A2(pan, x([
                1
            ]), x([
                ld(n(kCn))
            ])) : ld("")
        ]));
    }), BCn = m4({
        rh: "payment-source-select",
        Eb: CCn,
        Ed: function(n) {
            return Vt(Qin(n));
        }
    }), ECn = F3(function(n, r, t) {
        var e = t.Ck, u = Bx(n), a = {
            gF: r.gF,
            c5: Ut,
            g8: Ut,
            kA: r.kA,
            e4: wCn,
            Bb: Ut,
            h2: e.rh,
            Cr: GU(r),
            Cv: BCn,
            Cw: vc,
            dB: n,
            CD: u,
            d4: !1
        };
        return b(a, Vu(x([
            A2(Nu, rCn, IF),
            $Cn(a),
            gCn(a)
        ])));
    }), DCn = F2(function(n, r) {
        return b(r, Pp);
    }), qCn = F2(function(n, r) {
        return m(r, {
            x6: Vt(2)
        });
    }), FCn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, PCn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zCn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jCn = function(n) {
        return n.rh;
    }, SCn = {
        $: 0
    }, LCn = {
        yI: ""
    }, MCn = function(n) {
        return n.sB;
    }, NCn = x([
        0
    ]), HCn = function() {
        return "Cancellation Reason";
    }, TCn = F3(function(n, r, t) {
        var e = LCn, u = A2(fS, 0, SCn), a = u.a, i = u.b;
        return b({
            en: vc,
            kB: lS(e),
            Bb: n,
            kT: t,
            sB: MCn(n),
            e7: a,
            dB: r,
            x: A2(vS, NCn, HCn)
        }, i);
    }), ICn = F2(function(n, r) {
        return b(n.$ ? r : m(r, {
            e2: n.a
        }), Pp);
    }), RCn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZCn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, VCn = {
        $: 1
    }, UCn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, YCn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, QCn = {
        $: 0
    }, OCn = F5(function(n, r, t, e, u) {
        var a = _x(x([
            b("membership", _x(x([
                b("end_date", A2(yL, Tun, e.p$)),
                b("cancellation_reason_other", Ax(e.yI)),
                b("ended_by", Ax("Patient"))
            ])))
        ]));
        return A4(bL, n, vCn, u, A2(vL, a, rA(A2(X_, x([
            "cancel"
        ]), A2(mCn, r, t)))));
    }), GCn = F3(function(n, r, t) {
        return A2(X_, x([
            "members",
            t
        ]), A2(X_, x([
            "memberships",
            r
        ]), lL(n)));
    }), JCn = F6(function(n, r, t, e, u, a) {
        var i = _x(x([
            b("member", _x(x([
                b("end_date", A2(yL, Tun, u.p$)),
                b("cancellation_reason_other", Ax(u.yI))
            ])))
        ]));
        return A4(bL, n, dCn, a, A2(vL, i, rA(A2(X_, x([
            "cancel"
        ]), A3(GCn, r, t, e)))));
    }), WCn = function(n) {
        return n.bd.yF;
    }, KCn = function(n) {
        return n.bd.yH;
    }, XCn = function(n) {
        return n.bd.Ba;
    }, nBn = function(n) {
        return n.bd.C$;
    }, rBn = function(n) {
        return n.bd.C0;
    }, tBn = function(n) {
        return n.bd.C2;
    }, eBn = function(n) {
        return n.bd.Da;
    }, uBn = function(n) {
        return n.bd.D_;
    }, aBn = F2(function(n, r) {
        return m(r, {
            yI: n
        });
    }), iBn = nM(x([
        function(n) {
            return fM(n.yI) ? x([
                b(0, dM(tBn))
            ]) : h;
        }
    ])), cBn = function(n) {
        return n.kV;
    }, oBn = function(n) {
        return n.nj.xz;
    }, fBn = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return {
                    g1: Pp,
                    hq: VCn,
                    h4: m(e, {
                        e7: WL(e.e7)
                    }),
                    ig: h
                };
            case 1:
                return {
                    g1: Pp,
                    hq: QCn,
                    h4: m(e, {
                        kB: i = A3(dN, aBn, r.a, e.kB)
                    }),
                    ig: h
                };
            case 2:
                var u = A2(BM, iBn, e.kB);
                if (u.$) return {
                    g1: Pp,
                    hq: QCn,
                    h4: m(e, {
                        kB: i = u.a
                    }),
                    ig: h
                };
                var a = u.a, i = a.a, c = {
                    yI: a.b.yI,
                    p$: oBn(cBn(e.Bb))
                }, o = function() {
                    var r = e.kT;
                    if (r.$) return A5(OCn, n, Bx(e.dB), jCn(e.Bb), c, YCn);
                    var t = r.a;
                    return A6(JCn, n, Bx(e.dB), jCn(e.Bb), function(n) {
                        return n.rh;
                    }(t), c, UCn);
                }();
                return {
                    g1: o,
                    hq: QCn,
                    h4: m(e, {
                        en: cP,
                        kB: i
                    }),
                    ig: h
                };
            case 3:
                if (3 === (s = r.a).$) {
                    var f = s.a;
                    return {
                        g1: Pp,
                        hq: RCn(f),
                        h4: m(e, {
                            Bb: f
                        }),
                        ig: x([
                            A2($A, 3, uBn)
                        ])
                    };
                }
                return {
                    g1: Pp,
                    hq: QCn,
                    h4: m(e, {
                        en: vc
                    }),
                    ig: A2(xA, 0, s)
                };
            default:
                var s;
                if (3 === (s = r.a).$) {
                    var l = s.a;
                    return {
                        g1: Pp,
                        hq: ZCn(l),
                        h4: m(e, {
                            kT: Vt(l)
                        }),
                        ig: x([
                            A2($A, 3, rBn)
                        ])
                    };
                }
                return {
                    g1: Pp,
                    hq: QCn,
                    h4: m(e, {
                        en: vc
                    }),
                    ig: A2(xA, 0, s)
                };
        }
    }), sBn = F5(function(n, r, t, e, u) {
        var a = _x(x([
            b("membership", _x(x([
                b("payment_source", _x(x([
                    b("id", Ax(e))
                ])))
            ])))
        ]));
        return A4(dC, n, vCn, u, A2(vL, a, rA(A2(mCn, r, t))));
    }), lBn = F2(function(n, r) {
        switch(n.$){
            case 1:
                return 3 === (A = n.a).$ ? v(m(r, {
                    Bb: Vt(A.a)
                }), Pp, h) : v(r, Pp, A2(xA, 0, A));
            case 2:
                return v(m(r, {
                    g8: Vt(A2(bp, pJ, n.a))
                }), Pp, h);
            case 3:
                var t = (C = r.Bb).$ ? Pp : A2(AA, da, Ma({
                    rh: jCn(C.a)
                }));
                return v(r, t, h);
            case 4:
                var e = n.a, u = A2(sc, b(Ut, Pp), A2(Fp, function(n) {
                    return A2(Jbn, Lp(FCn), A2(qx, Vt, A3(TCn, n, r.dB, e)));
                }, r.Bb)), a = u.b;
                return v(m(r, {
                    c5: u.a
                }), a, h);
            case 5:
                var i = n.a, c = r.c5;
                if (c.$) return v(r, Pp, h);
                var o = A3(fBn, r.gF, i, c.a), f = function() {
                    switch(o.hq.$){
                        case 0:
                            return v(Vt(o.h4), o.g1, h);
                        case 2:
                            return v(Vt(o.h4), A2(AA, da, Sa), o.ig);
                        default:
                            return v(Ut, o.g1, o.ig);
                    }
                }(), s = f.a, l = f.b, d = f.c;
                return t = 3 === o.hq.$ ? Vu(x([
                    A2(Lp, FCn, l),
                    $Cn(r)
                ])) : A2(Lp, FCn, l), v(m(r, {
                    c5: s
                }), t, d);
            case 0:
                var p = n.a;
                if (1 === p.$) {
                    var $ = A2(lBn, zCn(Vt(e = p.a)), r);
                    return v($.a, $.b, h);
                }
                return v(m(r, {
                    e4: A2(ICn, p, r.e4).a
                }), Pp, h);
            case 6:
                var g = n.a;
                return v(m(r, 3 === g.$ ? {
                    Cw: A2(Zy, g.a, da)
                } : {
                    Cw: g
                }), Pp, h);
            case 7:
                var w = A2(ZD, n.a, r.Cv), k = w.a, y = w.c, _ = function() {
                    if (y.$ || y.a.$ || y.a.a.$) return b(m(r, {
                        Cv: k
                    }), Pp);
                    var n = y.a.a.a;
                    return b(m(r, {
                        Cv: k,
                        d4: !0
                    }), A5(sBn, r.gF, r.CD, r.h2, Qin(n), PCn));
                }();
                return v(_.a, t = _.b, h);
            default:
                var A;
                return 3 === (A = n.a).$ ? v(m(r, {
                    Bb: Vt(A.a),
                    d4: !1
                }), Pp, x([
                    A2($A, 3, _Cn)
                ])) : v(m(r, {
                    d4: !1
                }), Pp, A2(xA, 0, A));
        }
        var C;
    }), dBn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bBn = function(n) {
        return n.oY;
    }, vBn = function(n) {
        return n.tk;
    }, mBn = function(n) {
        return n.Cz;
    }, pBn = function(n) {
        return n.uE;
    }, $Bn = function(n) {
        return A2(NL, aS("/"), n);
    }, hBn = F2(function(n, r) {
        return A2(nk, x([
            Xx("text-left")
        ]), x([
            A2(X8, x([
                ok(x([
                    Xx("mb-5")
                ]))
            ]), x([
                ld(n(Wd.ot))
            ])),
            A2(Ek, x([
                $H,
                ok(x([
                    Xx("mt-1 mb-8 mr-2")
                ]))
            ]), x([
                ld(r.kg)
            ]))
        ]));
    }), gBn = F2(function(n, r) {
        var t;
        return (t = r, t.ou).$ ? tB : A2(hBn, n, function(n) {
            var r, t;
            return {
                kg: $((r = n.ow).$ ? "" : $Bn(r.a), (t = function(n) {
                    return n.oq;
                }(n)).$ ? "" : " - " + $Bn(t.a))
            };
        }(r));
    }), wBn = function(n) {
        return n.wF;
    }, xBn = function(n) {
        return A2(de, F2(function(r, t) {
            return n(r) ? t + 1 : t;
        }), 0);
    }, kBn = function(n) {
        return n.eG.m3;
    }, yBn = function(n) {
        return n.eG.CJ;
    }, _Bn = function(n) {
        return n.eG.w5;
    }, ABn = function(n) {
        return n.eG.EE;
    }, CBn = function(n) {
        return n.p7;
    }, BBn = function(n) {
        return A2(NL, aS("/"), n);
    }, EBn = F2(function(n, r) {
        return r.p8(n);
    }), DBn = F2(function(n, r) {
        return r.p9(n);
    }), qBn = F2(function(n, r) {
        return r.qa(n);
    }), FBn = F2(function(n, r) {
        return !A2(a2, r, n);
    }), PBn = F5(function(n, r, t, e, u) {
        var a = b(t, e);
        if (a.a.$) return a.b.$ ? "" : BBn(c = a.b.a);
        if (a.b.$) return A2(fe, ", ", x([
            n(qBn(BBn(i = a.a.a))),
            u
        ]));
        var i = a.a.a, c = a.b.a, o = r.$ ? EBn(BBn(c)) : A2(FBn, c, r.a) ? DBn(BBn(c)) : EBn(BBn(c));
        return A2(fe, ", ", x([
            n(qBn(BBn(i))),
            n(o),
            u
        ]));
    }), zBn = function(n) {
        return n.t6;
    }, jBn = F3(function(n, r, t) {
        var e = t.DN, u = zBn(t), a = QE(aU(u)), i = n8(u) ? A2(pan, x([
            1
        ]), x([
            ld(n(yBn))
        ])) : tB, c = t.qb, o = CBn(t), f = A5(PBn, n, r, e, o, c), s = function() {
            var r = Udn(u);
            return r.$ ? "" : n(Ydn(oe(r.a)));
        }();
        return {
            mr: s,
            kv: f,
            p7: o,
            qb: c,
            kS: i,
            kT: t,
            la: a
        };
    }), SBn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LBn = F3(function(n, r, t) {
        return t ? A2(OC, x([
            oF,
            EC(SBn(!0)),
            uF(r)
        ]), x([
            ld(n(Jd.A_))
        ])) : tB;
    }), MBn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NBn = F4(function(n, r, t, e) {
        return r && i(e.p7, Ut) ? A2(nk, x([
            Xx("grid text-right mr-2")
        ]), x([
            A2(OC, x([
                wO,
                EC(MBn(e.kT)),
                gC(x([
                    Xx("text-right")
                ])),
                uF(t)
            ]), x([
                A2(PE, h, 7),
                A2(FI, h, x([
                    ld(n(nBn))
                ]))
            ]))
        ])) : tB;
    }), HBn = F4(function(n, r, t, e) {
        return A2(zN, x([
            ron,
            JI(12)
        ]), x([
            A2(EN, x([
                JI(8),
                KN(x([
                    Xx("flex justify-between items-center")
                ]))
            ]), x([
                A2(nk, x([
                    Xx("text-left ml-2")
                ]), x([
                    A2(nk, x([
                        Xx("flex items-center")
                    ]), x([
                        A2(X8, x([
                            ok(x([
                                Xx("mr-1")
                            ]))
                        ]), x([
                            e.la
                        ])),
                        e.kS
                    ])),
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(e.kv)
                    ]))
                ]))
            ])),
            Bon(x([
                JI(1)
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(nk, x([
                    Xx("grid text-right mr-2")
                ]), x([
                    ld(e.mr)
                ])),
                A4(NBn, n, r, t, e)
            ]))
        ]));
    }), TBn = F5(function(n, r, t, e, u) {
        return A2(nk, x([
            Xx("mb-5")
        ]), A2(Yt, A2(nk, x([
            Xx("flex justify-between items-center mb-4")
        ]), x([
            A2(Ek, h, x([
                A2(X8, h, x([
                    ld(t(_Bn))
                ]))
            ])),
            A3(LBn, t, r.e2, n)
        ])), TE(e) ? r5(t(ABn)) : A2(Eu, A3(HBn, t, r.e2, 1 === A2(xBn, function(n) {
            return i(n, Ut);
        }, A2(Eu, CBn, e))), A2(Eu, A2(jBn, t, u), e))));
    }), IBn = F2(function(n, r) {
        return r.pC(n);
    }), RBn = function(n) {
        return n.tj;
    }, ZBn = F3(function(n, r, t) {
        var e = lV(t);
        if (r.$) return tB;
        var u, a = r.a;
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(Ek, x([
                _H(BN)
            ]), x([
                A2(X8, h, x([
                    ld(n(RBn))
                ]))
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(6),
                    KN(x([
                        Xx("flex justify-between items-center")
                    ]))
                ]), x([
                    A2(nk, x([
                        Xx("text-left ml-2")
                    ]), x([
                        A2(Ek, x([
                            ok(x([
                                Xx("mb-1 mr-2")
                            ]))
                        ]), x([
                            ld(n(IBn((u = a, A2(NL, aS("/"), u)))))
                        ]))
                    ]))
                ])),
                Bon(x([
                    JI(3)
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("grid text-right mr-2")
                    ]), x([
                        A2(Ek, h, x([
                            ld(e)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), VBn = {
        $: 3
    }, UBn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mb-4")
        ]), x([
            r ? A2(OC, x([
                oF,
                EC(VBn)
            ]), x([
                ld(n(Jd.l7))
            ])) : tB
        ]));
    }), YBn = F3(function(n, r, t) {
        return wBn(t) ? tB : A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(Ek, x([
                _H(cR)
            ]), x([
                A2(X8, h, x([
                    ld(n(kBn))
                ]))
            ])),
            A2(Ek, x([
                $H
            ]), x([
                ld(r)
            ]))
        ]));
    }), QBn = F2(function(n, r) {
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Sa))
                ]), x([
                    ld(n(Wd.Ea))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld(r)
        ]));
    }), OBn = {
        $: 2
    }, GBn = DC(7), JBn = function(n) {
        return n.oe;
    }, WBn = F2(function(n, r) {
        return r.of(n);
    }), KBn = F2(function(n, r) {
        return r.og(n);
    }), XBn = F3(function(n, r, t) {
        return A2(t.oh, n, r);
    }), nEn = function(n) {
        var r = b(A2(Fp, xB(0), qB(n)), A2(Fp, $xn, xx(n)));
        return r.a.$ ? r.b.$ ? JBn : WBn(r.b.a) : r.b.$ ? KBn(r.a.a) : A2(XBn, r.a.a, r.b.a);
    }, rEn = function(n) {
        if (1 === n.$) return "today";
        var r = n.a;
        return A2(NL, aS("/"), r);
    }, tEn = F2(function(n, r) {
        return r.pf(n);
    }), eEn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uEn = F3(function(n, r, t) {
        return A2(bN, t, r) || A2(QH, t, n);
    }), aEn = F3(function(n, r, t) {
        return A3(uEn, n, r, t) ? A2(PH, t, n) : h;
    }), iEn = F3(function(n, r, t) {
        var e = r, u = FL(e.kB).yI;
        return A2(XH, x([
            HH(n(KCn)),
            VH(!0)
        ]), x([
            mT(x([
                SH("cancel-membership-form-cancellation-reason"),
                UH(0),
                GH(u),
                RH(A2(pc, eEn, iu)),
                LH(t),
                YH(3)
            ])),
            A2(ET, n, A3(aEn, e.kB, e.x, 0))
        ]));
    }), cEn = {
        $: 3
    }, oEn = function(n) {
        return x([
            QE(aU(zBn(n)))
        ]);
    }, fEn = F3(function(n, r, t) {
        var e, u, a = (e = r.kT).$ ? r.sB : x([
            e.a
        ]);
        return x([
            A2(nk, x([
                Xx("section")
            ]), x([
                A2(Ek, h, x([
                    ld(n(eBn))
                ])),
                iB,
                A2(Ek, h, x([
                    ld(n(tEn(rEn(oBn(cBn(r.Bb))))))
                ])),
                iB,
                A2(Ek, h, x([
                    ld(n(nEn(r.dB)))
                ])),
                iB,
                A2(nk, h, x([
                    A2(Ek, x([
                        bq
                    ]), x([
                        ld(n(XCn))
                    ]))
                ])),
                iB,
                A2(nk, h, x([
                    (u = a, A2(yon, x([
                        cEn
                    ]), A2(Eu, A2(pc, bon, oEn), u)))
                ])),
                iB,
                A3(iEn, n, r, t)
            ]))
        ]);
    }), sEn = F2(function(n, r) {
        var t = r, e = n(A2(sc, WCn, A2(Fp, function() {
            return nBn;
        }, t.kT))), u = A2(QH, 0, t.kB);
        return A2(QI, x([
            qI(x([
                A2(FI, x([
                    lk
                ]), x([
                    ld(e)
                ]))
            ])),
            EI(A3(fEn, n, t, u)),
            DI(x([
                A2(OC, x([
                    GBn,
                    EC(OBn)
                ]), x([
                    ld(e)
                ]))
            ]))
        ]), NM(t.e7));
    }), lEn = F2(function(n, r) {
        return A2(Ck, FCn, A2(sc, tB, A2(Fp, sEn(n), r)));
    }), dEn = DC(8), bEn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mt-4 mb-4")
        ]), x([
            r ? A2(OC, x([
                dEn,
                EC(zCn(Ut))
            ]), x([
                ld(n(WCn))
            ])) : A2(nk, h, h)
        ]));
    }), vEn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, mEn = function(n) {
        return n.qb;
    }, pEn = function(n) {
        return n.wz;
    }, $En = F3(function(n, r, t) {
        if (wBn(r) || !function(n) {
            return function(n) {
                return n.ul.kt;
            }(n.kV);
        }(r)) return tB;
        var e = 3 === mEn(r), u = t.d4 || e, a = t.Cw;
        if (3 === a.$) {
            var i = a.a;
            return A2(nk, x([
                Xx("mb-4")
            ]), x([
                A2(Ek, x([
                    _H(cR)
                ]), x([
                    A2(X8, h, x([
                        ld(n(yCn))
                    ]))
                ])),
                A2(Ck, vEn, A4(sF, n, x([
                    Dq(pEn(r)),
                    xq(n(Jln)),
                    vq,
                    AR(u)
                ]), A2(Eu, function(n) {
                    return A2(hq, h, n);
                }, i), t.Cv)),
                A2(Ek, x([
                    $ln,
                    fq,
                    _H(fmn)
                ]), x([
                    ld(n(ACn))
                ]))
            ]));
        }
        return tB;
    }), hEn = F3(function(n, r, t) {
        var e = t.dB.b.sz, u = bBn(vBn(r)), a = FAn(vBn(r)), i = pBn(r), c = MCn(r), o = r.rB && !wBn(r) && e, f = t.e4, s = f.e2, l = A2(H5, n, mBn(r));
        return A2(nk, x([
            Xx("text-left mb-5")
        ]), x([
            A2(QBn, n, i),
            Dk,
            A2(Ak, x([
                ok(x([
                    Xx("mt-8 mb-8")
                ]))
            ]), x([
                ld(i)
            ])),
            A2(gBn, n, r),
            A2(Ck, dBn, A5(TBn, o, f, n, c, t.g8)),
            A2(UBn, n, s),
            wBn(r) ? tB : A3(ZBn, n, Vt(u), a),
            A3(YBn, n, l, r),
            A3($En, n, r, t),
            A2(bEn, n, s),
            A2(lEn, n, t.c5)
        ]));
    }), gEn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.Bb, t.$ ? ck : x([
                    A3(hEn, n, t.a, r)
                ])))
            ]),
            w5: n(Wd.w5)
        };
    }), wEn = ZA({
        Ar: ECn,
        AQ: DCn,
        Db: qCn,
        DZ: function() {
            return zx;
        },
        En: lBn,
        Et: gEn
    }), xEn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, kEn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, yEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _En = function(n) {
        return {
            $: 4,
            a: n
        };
    }, AEn = function() {
        return "Forms";
    }, CEn = {
        cx: h,
        x: A2(vS, x([
            0
        ]), AEn)
    }, BEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, EEn = {
        tg: Ut
    }, DEn = A2(X_, x([
        "known_practices"
    ]), sL), qEn = F3(function(n, r, t) {
        return A4(W_, gQ(n), vy(YR), t, A2(_P, function(n) {
            var r = n(EEn).tg;
            return r.$ ? h : x([
                A2(Y_, "name", r.a)
            ]);
        }(r), rA(DEn)));
    }), FEn = F2(function(n, r) {
        return A3(qEn, n, function(n) {
            return m(n, {
                tg: r
            });
        }, BEn);
    }), PEn = {
        bS: Ut
    }, zEn = function(n) {
        return n.tg;
    }, jEn = F2(function(n, r) {
        return r.$ ? n(Qj) : zEn(r.a);
    }), SEn = function(n) {
        return n.rh;
    }, LEn = function(n) {
        return Vt(n.$ ? "Other" : SEn(n.a));
    }, MEn = "known-practices", NEn = x([
        1,
        0
    ]), HEn = function(n) {
        return 1 === n ? "DpcPractice" : "DpcPracticeOther";
    }, TEn = function(n) {
        return b({
            gF: n.gF,
            kw: 0,
            kB: lS(PEn),
            eT: tpn({
                rh: MEn + "-select",
                Eb: jEn,
                Ed: LEn
            }),
            hS: vc,
            fA: !1,
            x: A2(vS, NEn, HEn)
        }, A2(FEn, n.gF, Ut));
    }, IEn = {
        j0: !1,
        mz: h,
        nR: 0,
        n1: 0,
        he: !0,
        lc: !1,
        iT: !1
    }, REn = function(n) {
        return !n;
    }, ZEn = function(n) {
        return n.vB;
    }, VEn = function(n) {
        return n.xu;
    }, UEn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-first-name";
            case 1:
                return n + "-last-name";
            case 2:
                return n + "-relationship";
            case 3:
                return n + "-chosen-first-name";
            case 4:
                return n + "-chosen-last-name";
            case 5:
                return n + "-dob";
            case 6:
                return n + "-ssn";
            case 7:
                return n + "-email";
            case 8:
                return n + "-phones";
            case 9:
                return n + "-address";
            case 10:
                return n + "-gender";
            case 11:
                return n + "-gender-identity";
            case 12:
                return n + "-pronouns";
            case 13:
                return n + "-title";
            case 14:
                return n + "-chosen-title";
            case 15:
                return n + "-sex";
            default:
                return n + "-emergency-contact";
        }
    }), YEn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), QEn = F4(function(n, r, t, e) {
        return TE(n) ? e : m(e, {
            ct: A3(YEn, n, r, t)
        });
    }), OEn = F4(function(n, r, t, e) {
        return A4(QEn, t.mz, Ex(r), xx(r), A2(Mpn, t.j0, A2(sc, Umn(A2(UEn, n, 9)), A2(Fp, l$n(A2(UEn, n, 9)), function(n) {
            return A2(nv, function(n) {
                var r;
                return VEn(n) && !REn(ZEn(n)) ? Ut : Vt({
                    yb: (r = n).mn,
                    yc: r.mo,
                    nK: r.ml,
                    y4: r.mm,
                    wN: r.mp,
                    x0: r.mq
                });
            }, n);
        }(e)))));
    }), GEn = function(n) {
        return n.nF;
    }, JEn = function(n) {
        return A2(sc, "", A2(nv, GEn, n));
    }, WEn = function(n) {
        return n.nG;
    }, KEn = function(n) {
        return A2(sc, "", A2(nv, WEn, n));
    }, XEn = function(n) {
        return n.nH;
    }, nDn = function(n) {
        return A2(sc, "", A2(nv, XEn, n));
    }, rDn = A2(ru, nv(function(n) {
        return n.nI;
    }), sc("")), tDn = function(n) {
        return n.nJ;
    }, eDn = F2(function(n, r) {
        var t = !vu(A2(sc, "", A2(nv, WEn, r)));
        return b(A2(U$n, A2(nv, tDn, r), wpn(A2(UEn, n, 14))), t);
    }), uDn = function(n) {
        return n.pn;
    }, aDn = F3(function(n, r, t) {
        return A2(IL, A2(nv, uDn, t), A2($S, r.he, iS(A2(UEn, n, 5))));
    }), iDn = function(n) {
        return n.pP;
    }, cDn = function(n) {
        return A2(sc, "", A2(nv, iDn, n));
    }, oDn = function(n) {
        return A2(i_n, n, k_n);
    }, fDn = F2(function(n, r) {
        if (r.$) return oDn(n);
        var t = r.a, e = REn(ZEn(t)), u = t.pU;
        return u.$ ? e ? s_n(n) : oDn(n) : t.xv ? oDn(n) : A2(x_n, n, u);
    }), sDn = function(n) {
        return n.qB;
    }, lDn = function(n) {
        return A2(sc, "", A2(Fp, sDn, n));
    }, dDn = function(n) {
        return n.qW;
    }, bDn = function(n) {
        return n.qX;
    }, vDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mDn = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, M$n, vDn(n), r.kB)
        });
    }), pDn = F2(function(n, r) {
        return A2(mDn, A2(sc, "", A2(nv, bDn, r)), A2(H$n, A2(nv, dDn, r), A2(Fpn, A2(UEn, n, 11), Tvn.rQ)));
    }), $Dn = function(n) {
        return n.qV;
    }, hDn = function(n) {
        return n.qY;
    }, gDn = F2(function(n, r) {
        return m(r, {
            vJ: n
        });
    }), wDn = F3(function(n, r, t) {
        return A2(mDn, A2(sc, "", A2(nv, hDn, t)), A2(H$n, A2(nv, $Dn, t), A2(gDn, r.iT, A2(Epn, A2(UEn, n, 10), Hmn.rQ))));
    }), xDn = function(n) {
        return n.rS;
    }, kDn = function(n) {
        return A2(sc, "", A2(Fp, xDn, n));
    }, yDn = function(n) {
        return n.s2;
    }, _Dn = function(n) {
        return A2(sc, "", A2(nv, yDn, n));
    }, ADn = function(n) {
        return n.uy;
    }, CDn = F4(function(n, r, t, e) {
        var u = jpn(r), a = A2(nv, ADn, e);
        return (u ? Spn(Zj) : iu)(A2(S$n, a, A2(Npn, t.lc, spn(A2(UEn, n, 8)))));
    }), BDn = F2(function(n, r) {
        var t;
        return t = Ib(n), r.$ ? t : A2(Z$, r.a.uU, t);
    }), EDn = function(n) {
        return n.u4;
    }, DDn = function(n) {
        return n.u5;
    }, qDn = F2(function(n, r) {
        var t = A2(nv, DDn, r);
        return A2(mDn, A2(sc, "", A2(nv, EDn, r)), A2(H$n, t, A2(zpn, A2(UEn, n, 12), Rvn.rQ)));
    }), FDn = function(n) {
        return A2(Fp, ZEn, n);
    }, PDn = function(n) {
        return n.we;
    }, zDn = F2(function(n, r) {
        return m(r, {
            vJ: n
        });
    }), jDn = F3(function(n, r, t) {
        return A2(R$n, A2(nv, PDn, t), A2(zDn, r.iT, mpn(A2(UEn, n, 15))));
    }), SDn = function(n) {
        return n.wG;
    }, LDn = function(n) {
        return A2(sc, "", A2(nv, SDn, n));
    }, MDn = A2(ru, nv(function(n) {
        return n.wY;
    }), sc("")), NDn = function(n) {
        return n.w5;
    }, HDn = F2(function(n, r) {
        return A2(U$n, A2(nv, NDn, r), wpn(A2(UEn, n, 13)));
    }), TDn = function(n) {
        return A2(sc, !0, A2(Fp, VEn, n));
    }, IDn = F4(function(n, r, t, e) {
        var u = A2(eDn, n, e), a = u.a, i = u.b;
        return {
            mk: A4(OEn, n, r, t, e),
            nF: JEn(e),
            nG: KEn(e),
            nH: nDn(e),
            nI: rDn(e),
            nJ: a,
            bk: A3(aDn, n, t, e),
            pP: cDn(e),
            pU: A2(fDn, n, e),
            qB: lDn(e),
            qV: A3(wDn, n, t, e),
            qW: A2(pDn, n, e),
            aj: i,
            rS: kDn(e),
            s2: _Dn(e),
            uy: A4(CDn, n, r, t, e),
            uU: A2(BDn, n, e),
            u5: A2(qDn, n, e),
            vB: FDn(e),
            we: A3(jDn, n, t, e),
            wG: LDn(e),
            wY: MDn(e),
            w5: A2(HDn, n, e),
            xu: TDn(e)
        };
    }), RDn = x([
        13,
        0,
        1,
        2,
        14,
        3,
        4,
        5,
        15,
        10,
        11,
        12,
        6,
        7,
        8,
        9
    ]), ZDn = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Relationship";
            case 3:
                return "Chosen First Name";
            case 4:
                return "Chosen Last Name";
            case 5:
                return "Date Of Birth";
            case 6:
                return "SSN";
            case 7:
                return "Email";
            case 8:
                return "Phone";
            case 9:
                return "Address";
            case 10:
                return "Gender";
            case 11:
                return "Gender Identity";
            case 12:
                return "Pronouns";
            case 13:
                return "Title";
            case 14:
                return "Chosen Title";
            case 15:
                return "Sex";
            default:
                return "Emergency Contact";
        }
    }, VDn = F3(function(n, r, t) {
        var e = t(IEn);
        return {
            nD: Ut,
            a$: e,
            kB: lS(A4(IDn, n, r, e, Ut)),
            rh: n,
            dB: r,
            dI: cK,
            x: A2(vS, RDn, ZDn)
        };
    }), UDn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, YDn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QDn = {
        $: 1
    }, ODn = {
        $: 2
    }, GDn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, JDn = function(n) {
        return r$n(n);
    }, WDn = function(n) {
        return 2 === n;
    }, KDn = function(n) {
        var r = n;
        return WDn(r) || r$n(r);
    }, XDn = function(n) {
        return n.eB.yl;
    }, nqn = function(n) {
        return n.eB.Bm;
    }, rqn = function(n) {
        return n.eB.CB;
    }, tqn = F2(function(n, r) {
        if (1 === r.$) return n(rqn);
        var t = r.a;
        switch(t.$){
            case 0:
                return "< " + oe(t.a) + " mi";
            case 1:
                return n(XDn);
            default:
                return n(nqn);
        }
    }), eqn = dd({
        rh: "filter-select",
        Eb: tqn,
        Ed: function(n) {
            return Vt(function() {
                if (1 === n.$) return "Filter by distance";
                var r = n.a;
                switch(r.$){
                    case 0:
                        return "< " + oe(r.a) + " mi";
                    case 1:
                        return "Any distance";
                    default:
                        return "No Filter";
                }
            }());
        }
    }), uqn = {
        av: Ut,
        fD: eqn,
        x0: ""
    }, aqn = F3(function(n, r, t) {
        return 1 === t.$ ? r(t.a) : n(t.a);
    }), iqn = F2(function(n, r) {
        return 1 === r.$ ? Vt(n(r.a)) : Ut;
    }), cqn = dd({
        rh: "locations-select",
        Eb: function(n) {
            return A2(aqn, n, function(n) {
                return n.tg;
            });
        },
        Ed: iqn(function(n) {
            return n.rh;
        })
    }), oqn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fqn = yD, sqn = oqn(fqn), lqn = function(n) {
        return {
            kq: uqn,
            eM: !1,
            eN: !1,
            kL: sqn,
            e0: cqn,
            dB: n,
            dC: ""
        };
    }, dqn = {
        $: 0
    }, bqn = function(n) {
        return n.rh;
    }, vqn = function(n) {
        var r = hvn(n);
        return fM(r) ? Ut : Vt(r);
    }, mqn = function(n) {
        return n.xF;
    }, pqn = F2(function(n, r) {
        var t = mqn(r) ? " (Virtual Location)" : "", e = lvn(r), u = A2(nv, vqn, Dcn(r));
        return u.$ ? $(e, t) : e + " (" + u.a + ")" + t;
    }), $qn = dd({
        rh: "practitioner-locations-select",
        Eb: pqn,
        Ed: function(n) {
            return Vt(bqn(n));
        }
    }), hqn = F3(function(n, r, t) {
        return {
            j3: t,
            dB: n,
            bz: dqn,
            fl: $qn,
            xt: r
        };
    }), gqn = function(n) {
        return n.lv;
    }, wqn = function(n) {
        return n.$ ? Ut : Vt(n.a);
    }, xqn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kqn = {
        $: 0
    }, yqn = function(n) {
        return A2(sc, kqn, A2(Fp, function(r) {
            return A2(xqn, r, n.x0);
        }, n.av));
    }, _qn = F4(function(n, r, t, e) {
        var u = function() {
            var n = yqn(t.kq);
            if (1 === n.$) {
                var r = n.a, e = n.b;
                return fM(e) ? b(Ut, Ut) : b(wqn(r), Vt(e));
            }
            return b(Ut, Ut);
        }();
        return m(e, {
            kq: u.a,
            hY: n,
            ic: 0,
            lB: r,
            x0: u.b
        });
    }), Aqn = function(n) {
        return n.lw;
    }, Cqn = {
        hY: 250,
        lB: Ut,
        x0: Ut
    }, Bqn = function(n) {
        return A2(X_, x([
            "locations"
        ]), lL(n));
    }, Eqn = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(Jan), e, A2(_P, function(n) {
            var r, t, e = n(Cqn);
            return rc(x([
                (t = e.lB, t.$ ? h : x([
                    A2(Y_, "signup_page", t.a)
                ])),
                x([
                    A2(bJ, "limit", e.hY)
                ]),
                (r = e.x0, r.$ ? h : x([
                    A2(Y_, "zip", r.a)
                ]))
            ]));
        }(t), rA(Bqn(r))));
    }), Dqn = function(n) {
        return A2(ce, 0, LC(n));
    }, qqn = F2(function(n, r) {
        return _x(x([
            b("zip", Ax(n)),
            b("distance", A2(sc, yx, A2(Fp, EX, r)))
        ]));
    }), Fqn = {
        jX: Ut,
        jY: Ut,
        kq: Ut,
        hY: 10,
        kN: Ut,
        tg: Ut,
        ic: 0,
        k7: rnn,
        lB: Ut,
        lP: Ut,
        x0: Ut
    }, Pqn = function(n) {
        return A2(X_, x([
            "practitioners"
        ]), lL(n));
    }, zqn = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(Lbn), e, A2(_P, function(n) {
            var r, t, e, u, a, i, c, o = n(Fqn);
            return $((i = o.tg).$ ? h : x([
                A2(Y_, "name", i.a)
            ]), $((a = o.lB).$ ? h : x([
                A2(Y_, "signup_page", a.a)
            ]), $((u = o.jX).$ ? h : x([
                A2(Y_, "accepts_enrollments_from_employer", Dqn(u.a))
            ]), $((e = o.jY).$ ? h : x([
                A2(Y_, "accepts_enrollments_from_retail", Dqn(e.a))
            ]), $((c = b(o.x0, o.kq)).a.$ ? h : x(c.b.$ ? [
                A2(Y_, "near", A2(ce, 0, A2(qqn, c.a.a, Ut)))
            ] : [
                A2(Y_, "near", A2(ce, 0, A2(qqn, c.a.a, Vt(c.b.a))))
            ]), $((t = o.kN).$ ? h : x([
                A2(Y_, "location", t.a)
            ]), $(!(r = o.lP).$ && r.a ? x([
                A2(Y_, "with_waitlist", "true")
            ]) : h, x([
                A2(bJ, "offset", o.ic),
                A2(bJ, "limit", o.hY)
            ]))))))));
        }(t), rA(Pqn(r))));
    }), jqn = F3(function(n, r, t) {
        return m(t, {
            lB: n,
            x0: r
        });
    }), Sqn = {
        O: 0,
        P: 0,
        bp: Ut,
        hw: Ut,
        lv: Ut,
        lw: Ut
    }, Lqn = function(n) {
        return WDn(n);
    }, Mqn = F2(function(n, r) {
        return m(r, {
            kq: n
        });
    }), Nqn = F2(function(n, r) {
        return m(r, {
            eM: !n
        });
    }), Hqn = F2(function(n, r) {
        return m(r, {
            eN: !n
        });
    }), Tqn = {
        $: 1
    }, Iqn = F2(function(n, r) {
        return m(r, {
            av: Vt(Tqn),
            x0: n
        });
    }), Rqn = F4(function(n, r, t, e) {
        var u, a = rnn, i = e(Sqn), c = ((u = i.hw).$ ? iu : Iqn(u.a))(uqn), o = enn(a), f = b(A4(Eqn, n, Bx(t), A2(jqn, i.bp, i.hw), UDn), cP), s = f.a, l = f.b, d = KDn(i.P) ? v(GDn(A3(hqn, t, !0, Lqn(i.P))), !0, JDn(i.O)) : JDn(i.O) ? v(QDn, !1, !1) : v(ODn, !1, !1), m = d.a, p = A2(Hqn, d.b, A2(Nqn, d.c, A2(Mqn, c, lqn(t)))), $ = KDn(i.P) ? b(A4(zqn, n, Bx(t), A3(_qn, o, i.bp, p), YDn), cP) : b(Pp, vc), g = $.a;
        return b({
            gF: n,
            O: i.O,
            P: i.P,
            eH: h,
            av: p,
            bp: i.bp,
            hZ: l,
            k7: a,
            dB: t,
            cJ: $.b,
            lv: gqn(i),
            lw: Aqn(i),
            fI: m,
            xl: r
        }, x([
            g,
            s
        ]));
    }), Zqn = {
        xy: !1
    }, Vqn = "member-input", Uqn = F3(function(n, r, t) {
        var e, u = Bx(n), a = A4(Rqn, r.gF, Wx(r.kA), n, iu).a, i = TEn(r), c = i.a, o = i.b, f = A3(SU, !1, r.gF, Bx(n)), s = f.a, l = f.b;
        return b({
            gF: r.gF,
            g8: Ut,
            kh: Ut,
            bP: lS(CEn),
            Y: cP,
            aZ: (e = s, m(e, {
                h8: !0
            })),
            as: c,
            eH: h,
            kA: r.kA,
            hB: !1,
            hJ: !1,
            hK: Ut,
            U: A3(VDn, Vqn, n, iu),
            Bb: Ut,
            dB: n,
            aE: a,
            u3: !1,
            fr: Ut,
            fL: Ut,
            bF: Zqn,
            xl: Wx(r.kA),
            xs: t
        }, Vu(x([
            A4(pCn, r.gF, u, t.Ck.rh, yEn),
            A2(Nu, _En, IF),
            A2(Lp, kEn, o),
            A2(Lp, xEn, l)
        ])));
    }), Yqn = F2(function(n, r) {
        return b(r, Pp);
    }), Qqn = F2(function(n, r) {
        return m(r, {
            x6: Vt(2)
        });
    }), Oqn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gqn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jqn = Px(x([
        A2(_S, Gqn, Opn)
    ])), Wqn = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), Kqn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Xqn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, nFn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, rFn = F3(function(n, r, t) {
        return {
            rh: n,
            kE: r,
            rQ: t
        };
    }), tFn = function(n) {
        return q7(Ie(n));
    }, eFn = function(n) {
        return n.qO;
    }, uFn = function(n) {
        return !TE(eFn(n));
    }, aFn = function(n) {
        return n.rG;
    }, iFn = function(n) {
        return aFn(n.a);
    }, cFn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return iFn(n) && t.py;
    }), oFn = function(n) {
        return n.n3;
    }, fFn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return oFn(n) && t.w9;
    }), sFn = F3(function(n, r, t) {
        return A2(cFn, n, r) || A2(fFn, t, r) || uFn(t);
    }), lFn = F3(function(n, r, t) {
        return A3(sFn, n, r, t) ? Vt(1) : Ut;
    }), dFn = function(n) {
        return n.nY;
    }, bFn = function(n) {
        return n.n$;
    }, vFn = function(n) {
        return function(n) {
            return WDn(bFn(n));
        }(n) || function(n) {
            return r$n(bFn(n));
        }(n);
    }, mFn = function(n) {
        return vFn(n) || function(n) {
            return r$n(dFn(n));
        }(n) ? Vt(2) : Ut;
    }, pFn = F3(function(n, r, t) {
        if (n.$) return h;
        var e = n.a;
        return A2(Tp, iu, x([
            Vt(0),
            A3(lFn, r, t, e),
            mFn(e),
            Vt(3)
        ]));
    }), $Fn = F4(function(n, r, t, e) {
        return A2(sc, -1, A2(tFn, e, A3(pFn, n, r, t)));
    }), hFn = F2(function(n, r) {
        if (n.$) return "";
        var t = n.a;
        switch(r){
            case 0:
                return "Member Information";
            case 1:
                return "Custom Details";
            case 2:
                return vFn(t) ? "Provider" : "Location";
            default:
                return "Confirmation";
        }
    }), gFn = F4(function(n, r, t, e) {
        return A3(rFn, e, A4($Fn, n, r, t, e), A2(hFn, n, e));
    }), wFn = F3(function(n, r, t) {
        return A2(Eu, A3(gFn, n, r, t), A3(pFn, n, r, t));
    }), xFn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, kFn = F5(function(n, r, t, e, u) {
        var a = A2(sc, h, A2(Fp, function(n) {
            return x([
                n
            ]);
        }, u));
        return A7(OU, n, r, Vt(t), e, a, !1, xFn);
    }), yFn = function(n) {
        var r, t, e = FL(n.kB);
        return !e.aj || (t = (r = {
            nF: e.nF,
            nG: e.nG
        }).nG, fM(r.nF) && fM(t)) ? A2(fe, " ", x([
            e.qB,
            e.s2,
            e.rS
        ])) : A2(fe, " ", x([
            e.nF,
            e.nH,
            e.nG
        ]));
    }, _Fn = function(n) {
        var r = FL(n.kB).bk;
        return !fM(yFn(n)) && aF(KL(r));
    }, AFn = {
        $: 0
    }, CFn = F2(function(n, r) {
        if (A2(a2, r, n)) return Ut;
        var t = Pv(n) - Pv(r);
        return Vt(2 === A2(a2, A3(rj, 0, t, r), n) ? t - 1 : t);
    }), BFn = F2(function(n, r) {
        var t = A2(CFn, n, r);
        return t.$ ? AFn : function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.a);
    }), EFn = function(n) {
        var r = FL(n.kB);
        return KL(r.bk);
    }, DFn = F2(function(n, r) {
        return A2(Fp, BFn(n), EFn(r));
    }), qFn = function(n) {
        return 1 === n.$ ? Vt(n.a) : Ut;
    }, FFn = F2(function(n, r) {
        return r.nE(n);
    }), PFn = function(n) {
        return 2 === n;
    }, zFn = function(n) {
        return A2(sc, !1, A2(Fp, PFn, n));
    }, jFn = function(n) {
        var r = FL(n.kB);
        return zFn(r.vB);
    }, SFn = F2(function(n, r) {
        return function(t) {
            return A2(fe, Zb(n), A2(Eu, function(n) {
                return n(t);
            }, r));
        };
    }), LFn = F2(function(n, r) {
        return n.$ ? r : A2(SFn, " ", x([
            r,
            nEn(n.a)
        ]));
    }), MFn = F3(function(n, r, t) {
        return jFn(t) ? A2(nv, function(r) {
            return s(r, n) > 0 ? Vt(A2(LFn, Vt(t.dB), FFn(oe(n)))) : Ut;
        }, A2(nv, qFn, A2(DFn, r, t))) : Ut;
    }), NFn = function(n) {
        return n.po;
    }, HFn = function(n) {
        return !n.$;
    }, TFn = F2(function(n, r) {
        return A2(nv, function(n) {
            return n ? Vt(NFn) : Ut;
        }, A2(Fp, HFn, A2(DFn, n, r)));
    }), IFn = F2(function(n, r) {
        return r.sl(n);
    }), RFn = function(n) {
        return IFn(oe(n));
    }, ZFn = F3(function(n, r, t) {
        return A2(nv, function(r) {
            return s(r, n) > 0 ? Vt(A2(LFn, Vt(t.dB), RFn(n))) : Ut;
        }, A2(nv, qFn, A2(DFn, r, t)));
    }), VFn = F2(function(n, r) {
        return r.s5(n);
    }), UFn = function(n) {
        return VFn(oe(n));
    }, YFn = F3(function(n, r, t) {
        return A2(nv, function(r) {
            return 0 > s(r, n) ? Vt(A2(LFn, Vt(t.dB), UFn(n))) : Ut;
        }, A2(nv, qFn, A2(DFn, r, t)));
    }), QFn = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a.$ || e.b.$) return h;
        var u = e.a.a, a = e.b.a, i = A2(nv, function(n) {
            return A3(YFn, n, u, t);
        }, function(n) {
            return n.s9;
        }(a)), c = A2(nv, function(n) {
            return A3(ZFn, n, u, t);
        }, function(n) {
            return n.sn;
        }(a)), o = A2(TFn, u, t), f = A2(nv, function(n) {
            return A3(MFn, n, u, t);
        }, function(n) {
            return n.nD;
        }(a));
        return A2(Tp, iu, x([
            o,
            i,
            c,
            f
        ]));
    }), OFn = F3(function(n, r, t) {
        var e = A3(QFn, n, r, t);
        return _Fn(t) && TE(e);
    }), GFn = function(n) {
        switch(n){
            case 0:
                return G$n("owner");
            case 1:
                return G$n("spouse");
            case 2:
                return G$n("child");
            default:
                return G$n("other");
        }
    }, JFn = function(n) {
        return n.$ ? yx : G$n(n.a);
    }, WFn = function(n) {
        return JFn(A2(Fp, zP, n));
    }, KFn = F4(function(n, r, t, e) {
        var u = e.$ ? h : x([
            b("uses_tobacco", LC(e.a))
        ]);
        return A2(Yt, b("name", G$n(n)), A2(Yt, b("dob", WFn(r)), A2(Yt, b("relationship", GFn(t)), u)));
    }), XFn = function(n) {
        return n.xy;
    }, nPn = F5(function(n, r, t, e, u) {
        if (A3(OFn, n, r, t)) {
            var a = A2(fFn, u, r) ? Vt(XFn(e)) : Ut, i = jFn(t) ? 2 : 1, c = yFn(t), o = EFn(t);
            return Vt(A4(KFn, c, o, i, a));
        }
        return Ut;
    }), rPn = F3(function(n, r, t) {
        var e = aU(zBn(t)), u = zBn(t).a.pn;
        if (!fM(e) && aF(u)) {
            var a = A2(fFn, n, Vt(r)) ? zBn(t).a.xy : Ut, i = function(n) {
                return n.vB;
            }(t);
            return Vt(A4(KFn, e, u, i, a));
        }
        return Ut;
    }), tPn = function(n) {
        return n.uD;
    }, ePn = F6(function(n, r, t, e, u, a) {
        return {
            yj: u,
            gG: a,
            g2: r,
            pJ: t,
            rh: n,
            uu: e
        };
    }), uPn = F5(function(n, r, t, e, u) {
        return {
            gG: e,
            g2: r,
            ph: u,
            pI: t,
            rh: n
        };
    }), aPn = {
        $: 0
    }, iPn = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? t.b.$ ? Sk("Either percent_off or amount_off_in_cents is required") : uu(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : uu(function(n) {
            return {
                $: 0,
                a: n
            };
        }(t.a.a));
    }), cPn = {
        $: 1
    }, oPn = function(n) {
        return uu(n > 1 ? function(n) {
            return {
                $: 2,
                a: n
            };
        }(n) : cPn);
    }, fPn = A2(nu, function(n) {
        return A3(ly, "percent_off", A2(iPn, n.uu, n.yj), A2(dD, n.gG, A2(dD, n.pJ, A2(dD, n.g2, A2(dD, n.rh, uu(uPn))))));
    }, A3(ly, "apply_to_each_patient", jk, A3(ly, "amount_off_in_cents", iy(F$), A3(ly, "percent_off", iy(q$), A4(sy, "duration_in_months", A2(nu, oPn, F$), aPn, A3(ly, "code", C$, A3(ly, "id", C$, uu(ePn)))))))), sPn = A2(Pk, fPn, uu(iu)), lPn = F3(function(n, r, t) {
        return {
            mr: t,
            tg: n,
            vo: r
        };
    }), dPn = A3(ly, "age", F$, A3(ly, "rate_in_cents", F$, A3(ly, "name", A2(tu, RE, C$), uu(lPn)))), bPn = A2(Pk, A2(tu, iu, dPn), uu(iu)), vPn = A3(ly, "mce", jk, A3(ly, "contract_final_billing_end_date", iy(ay), A3(ly, "coupon", iy(sPn), A3(ly, "start_date", ay, A3(ly, "coupon_discount_in_cents", iy(F$), A3(ly, "recurring_amount_in_cents", F$, A3(ly, "ongoing_amount_in_cents", F$, A3(ly, "registration_fee_in_cents", F$, A3(ly, "billing_period", A2(nu, nZ, C$), A3(ly, "members", vy(bPn), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                yz: r,
                                                os: o,
                                                oA: c,
                                                oB: a,
                                                sp: f,
                                                A8: n,
                                                k3: e,
                                                ln: u,
                                                lp: t,
                                                DN: i
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), mPn = A2(Pk, vPn, uu(iu)), pPn = F4(function(n, r, t, e) {
        return A4(bL, gQ(n), mPn, e, A2(vL, _x(x([
            b("quote", t)
        ])), rA(function(n) {
            return A2(X_, x([
                "quotes"
            ]), lL(n));
        }(r))));
    }), $Pn = F8(function(n, r, t, e, u, a, i, c) {
        var o, f = b(aF(t), e);
        if (f.a && !f.b.$) {
            var s = f.b.a, l = b("plan", (o = Vt(tPn(s))).$ ? yx : _x(x([
                b("id", Ax(o.a))
            ]))), d = A2(Eu, A2(rPn, i, s), MCn(s)), v = b("period_in_months", EX(EV(mBn(s)))), m = A2(Tp, iu, $(d, x([
                A5(nPn, t, e, u, a, i)
            ]))), p = x([
                l,
                v,
                b("members", A2(KK, function(n) {
                    return _x(n);
                }, m))
            ]);
            return A4(pPn, n, Bx(r), _x(p), c);
        }
        return Pp;
    }), hPn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gPn = function(n) {
        return n.rh;
    }, wPn = F2(function(n, r) {
        return {
            ag: r,
            S: h,
            rh: n
        };
    }), xPn = function(n) {
        return A2(Eu, function(n) {
            var r = gPn(n);
            return A2(wPn, "input-" + r, n);
        }, n);
    }, kPn = F2(function(n, r) {
        var t = m(r, {
            x: A3(vN, !0, 0, r.x)
        });
        return m(t, {
            cx: n
        });
    }), yPn = F2(function(n, r) {
        return 0 > n ? Ut : rv(A2(Np, n, r));
    }), _Pn = function(n) {
        return n.tU;
    }, APn = function(n) {
        return n.rh;
    }, CPn = F2(function(n, r) {
        var t;
        return A2(itn, "Dependent Added", x([
            stn(Xrn),
            (t = n, A2(otn, "Membership ID", t)),
            ftn(r)
        ]));
    }), BPn = function(n) {
        return n.n1;
    }, EPn = F2(function(n, r) {
        var t;
        return m(r, {
            mz: (t = n, t.vX ? t.mz : h),
            nR: n$n(n),
            n1: BPn(n)
        });
    }), DPn = function(n) {
        return A2(AA, da, La({
            rh: jCn(n)
        }));
    }, qPn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, FPn = A3(ly, "use_primary_member_as_emergency_contact", jk, A3(ly, "emergency_contact", iy(xbn), A3(ly, "use_primary_address", jk, A3(ly, "title", A2(nu, dbn, iy(C$)), A3(ly, "ssn", iy(C$), A3(ly, "sex", A2(nu, lbn, iy(C$)), A3(ly, "relationship", A2(nu, sCn, C$), A3(ly, "pronoun_other", iy(C$), A3(ly, "pronouns", A2(nu, sbn, iy(C$)), A3(ly, "phones", iy(vy(gbn)), A3(ly, "suffix", iy(C$), A3(ly, "middle_name", iy(C$), A3(ly, "last_name", C$, A3(ly, "preferred_language", cbn, A3(ly, "gender_other", iy(C$), A3(ly, "gender_identity_other", iy(C$), A3(ly, "gender_identity", A2(nu, fbn, iy(C$)), A3(ly, "gender", A2(nu, obn, iy(C$)), A3(ly, "first_name", C$, A3(ly, "email", iy(C$), A3(ly, "dob", iy(ay), A3(ly, "chosen_suffix", iy(C$), A3(ly, "chosen_title", A2(nu, dbn, iy(C$)), A3(ly, "chosen_middle_name", iy(C$), A3(ly, "chosen_last_name", iy(C$), A3(ly, "chosen_first_name", iy(C$), A3(ly, "address_zip", iy(C$), A3(ly, "address_state", iy(C$), A3(ly, "address_line2", iy(C$), A3(ly, "address_line1", iy(C$), A3(ly, "address_country", iy(C$), A3(ly, "address_city", iy(C$), A3(ly, "patient_id", iy(C$), A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(x) {
                                                                                            return function(k) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(A) {
                                                                                                            return function(C) {
                                                                                                                return function(B) {
                                                                                                                    return function(E) {
                                                                                                                        return function(D) {
                                                                                                                            return function(q) {
                                                                                                                                return function(F) {
                                                                                                                                    return function(P) {
                                                                                                                                        return function(z) {
                                                                                                                                            return {
                                                                                                                                                ml: t,
                                                                                                                                                mm: e,
                                                                                                                                                mn: u,
                                                                                                                                                mo: a,
                                                                                                                                                mp: i,
                                                                                                                                                mq: c,
                                                                                                                                                nF: o,
                                                                                                                                                nG: f,
                                                                                                                                                nH: s,
                                                                                                                                                nI: d,
                                                                                                                                                nJ: l,
                                                                                                                                                pn: b,
                                                                                                                                                pP: v,
                                                                                                                                                pU: P,
                                                                                                                                                qB: m,
                                                                                                                                                qV: p,
                                                                                                                                                qW: $,
                                                                                                                                                qX: h,
                                                                                                                                                qY: g,
                                                                                                                                                rh: n,
                                                                                                                                                rS: x,
                                                                                                                                                s2: k,
                                                                                                                                                Cr: r,
                                                                                                                                                uy: _,
                                                                                                                                                uU: w,
                                                                                                                                                u4: C,
                                                                                                                                                u5: A,
                                                                                                                                                vB: B,
                                                                                                                                                we: E,
                                                                                                                                                wG: D,
                                                                                                                                                wY: y,
                                                                                                                                                w5: q,
                                                                                                                                                xu: F,
                                                                                                                                                xv: z
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))))), PPn = A2(Pk, FPn, uu(iu)), zPn = function(n) {
        return _x(n);
    }, jPn = F2(function(n, r) {
        return A2(X_, x([
            "memberships",
            r,
            "members"
        ]), lL(n));
    }), SPn = F5(function(n, r, t, e, u) {
        return A4(bL, n, PPn, u, A2(vL, function(n) {
            return _x(x([
                b("member", zPn(n))
            ]));
        }(e), rA(A2(jPn, r, t))));
    }), LPn = F2(function(n, r) {
        var t, e, u = FL(r.kB);
        return b(n, (t = u.w5).$ ? yx : (e = t.a, G$n(A2(jvn, Wx(0), e))));
    }), MPn = cD("multi_language"), NPn = F3(function(n, r, t) {
        return MPn(n) ? A2(Yt, b("preferred_language", Ax(Tb(r.AL))), t) : t;
    }), HPn = F2(function(n, r) {
        var t;
        return x([
            b("gender", (t = n, t.$ ? yx : function(n) {
                switch(n){
                    case 0:
                        return G$n("female");
                    case 1:
                        return G$n("male");
                    default:
                        return G$n("other");
                }
            }(t.a))),
            b("gender_other", G$n(r))
        ]);
    }), TPn = function(n) {
        var r = FL(n.kB);
        return b(r.fF, r.dy);
    }, IPn = F2(function(n, r) {
        var t;
        return x([
            b("gender_identity", (t = n, t.$ ? yx : function(n) {
                switch(n){
                    case 0:
                        return G$n("man");
                    case 1:
                        return G$n("woman");
                    case 2:
                        return G$n("non-binary");
                    case 3:
                        return G$n("trans man");
                    case 4:
                        return G$n("trans woman");
                    default:
                        return G$n("not listed");
                }
            }(t.a))),
            b("gender_identity_other", G$n(r))
        ]);
    }), RPn = F2(function(n, r) {
        var t;
        return x([
            b("pronouns", (t = n, t.$ ? yx : function(n) {
                switch(n){
                    case 0:
                        return G$n("He/Him/His");
                    case 1:
                        return G$n("She/Her/Hers");
                    case 2:
                        return G$n("They/Them/Theirs");
                    default:
                        return G$n("other");
                }
            }(t.a))),
            b("pronoun_other", G$n(r))
        ]);
    }), ZPn = function(n) {
        return Jwn(n);
    }, VPn = F3(function(n, r, t) {
        var e = G$n(r.wG);
        return ZPn(n) || i(e, yx) ? t : A2(Yt, b("ssn", _x(x([
            b("number", e)
        ]))), t);
    }), UPn = function(n) {
        return nhn(Pwn(n));
    }, YPn = sc(1), QPn = function(n) {
        var r = FL(n.kB), t = A2(Yt, A2(LPn, "title", r.w5), A2(Yt, b("first_name", G$n(r.qB)), A2(Yt, b("middle_name", G$n(r.s2)), A2(Yt, b("last_name", G$n(r.rS)), A2(Yt, b("suffix", G$n(r.wY)), A2(Yt, b("email", G$n(r.pP)), A2(Yt, b("dob", WFn(KL(r.bk))), A2(Yt, b("relationship", GFn(YPn(r.vB))), A2(Yt, b("use_primary_address", LC(r.xu)), A2(Yt, b("phones", UPn(r.uy)), A2(Yt, F_n(r.pU), A2(Yt, function(n) {
            var r, t = FL(n.kB);
            return b("sex", (r = t.we).$ ? yx : function(n) {
                switch(n){
                    case 0:
                        return G$n("female");
                    case 1:
                        return G$n("male");
                    default:
                        return G$n("intersex");
                }
            }(r.a));
        }(r.we), $(function(n) {
            var r = TPn(n);
            return A2(HPn, r.a, r.b);
        }(r.qV), $(function(n) {
            var r = TPn(n);
            return A2(IPn, r.a, r.b);
        }(r.qW), $(function(n) {
            var r = TPn(n);
            return A2(RPn, r.a, r.b);
        }(r.u5), $(J$n(r.mk), function(n) {
            return x(n.aj ? [
                A2(LPn, "chosen_title", n.w5),
                b("chosen_first_name", G$n(n.nF)),
                b("chosen_middle_name", G$n(n.nH)),
                b("chosen_last_name", G$n(n.nG)),
                b("chosen_suffix", G$n(n.nI))
            ] : [
                b("chosen_title", yx),
                b("chosen_first_name", yx),
                b("chosen_middle_name", yx),
                b("chosen_last_name", yx),
                b("chosen_suffix", yx)
            ]);
        }(r)))))))))))))))));
        return A3(NPn, n.dB, r.uU, A3(VPn, n.a$.n1, r, t));
    }, OPn = function(n) {
        return A2(X$n, function(n) {
            return A2(L6, !0, n.b);
        }, A2(_Y, function(n) {
            return hO(n.b);
        }, n.Y));
    }, GPn = F2(function(n, r) {
        return A2(Yt, b("accepted_documents", OPn(n)), r);
    }), JPn = function(n) {
        return b("name", A2(sc, yx, A2(Fp, function(n) {
            return G$n(n);
        }, n)));
    }, WPn = F2(function(n, r) {
        var t, e = A2(Fp, zEn, n), u = e.$ ? r : Vt(e.a);
        return b("known_practice", _x(x([
            (t = A2(Fp, SEn, n), b("id", A2(sc, yx, A2(Fp, function(n) {
                return G$n(n);
            }, t)))),
            JPn(u)
        ])));
    }), KPn = function(n) {
        return FL(n.kB).bS;
    }, XPn = function(n) {
        var r = KPn(n);
        if (r.$) return b("known_practice", yx);
        var t = r.a;
        return t.$ ? A2(WPn, Ut, Vt(t.a)) : A2(WPn, Vt(t.a), Ut);
    }, nzn = F2(function(n, r) {
        return KPn(n).$ ? r : A2(Yt, XPn(n), r);
    }), rzn = function(n) {
        var r = n.b;
        return _x(x([
            b("form_item", _x(x([
                b("id", G$n(n.a))
            ]))),
            b("answer", Ax(r))
        ]));
    }, tzn = function(n) {
        return UQ(zkn(n));
    }, ezn = function(n) {
        var r = function() {
            var r = n.mD;
            switch(r.$){
                case 0:
                    return x([
                        tzn(r.a)
                    ]);
                case 1:
                    return x([
                        r.a
                    ]);
                default:
                    return r.a;
            }
        }();
        return A2(Eu, function(r) {
            return b(n.dk, r);
        }, r);
    }, uzn = function(n) {
        var r, t, e;
        return _x(x([
            (e = n.ag, b("form", _x(x([
                b("id", G$n(gPn(e)))
            ])))),
            (r = n.S, t = rc(A2(Eu, ezn, r)), b("form_response_items", A2(KK, rzn, t)))
        ]));
    }, azn = F2(function(n, r) {
        var t = n.fL;
        if (t.$) return r;
        if (uFn(t.a)) {
            var e = FL(n.bP);
            return A2(Yt, b("form_responses", A2(KK, uzn, e.cx)), r);
        }
        return r;
    }), izn = F2(function(n, r) {
        return n.$ ? r : A2(Yt, b("location", _x(x([
            b("id", G$n(bqn(n.a)))
        ]))), r);
    }), czn = function(n) {
        return n.rh;
    }, ozn = F2(function(n, r) {
        return n.$ ? r : A2(Yt, b("practitioner", _x(x([
            b("id", G$n(czn(n.a)))
        ]))), r);
    }), fzn = F4(function(n, r, t, e) {
        return r.$ ? e : A2(fFn, r.a, t) ? A2(Yt, b("uses_tobacco", LC(n)), e) : e;
    }), szn = function(n) {
        var r = b(n.hZ, n.lv);
        if (3 !== r.a.$ || r.b.$) return Ut;
        var t = r.b.a;
        return A2(wF, function(n) {
            return i(bqn(n), t);
        }, r.a.a);
    }, lzn = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(czn(n), r);
        }, n);
    }), dzn = function(n) {
        var r = b(n.cJ, n.lw);
        return 3 !== r.a.$ || r.b.$ ? Ut : A2(lzn, r.a.a, r.b.a);
    }, bzn = Wn("scrollTopAndIntoView", Ax), vzn = F2(function(n, r) {
        return m(r, {
            O: dFn(n),
            P: bFn(n)
        });
    }), mzn = "add-member-top", pzn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $zn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hzn = F2(function(n, r) {
        return m(r, {
            bS: n
        });
    }), gzn = function(n) {
        return n.cs.rQ;
    }, wzn = function(n) {
        return n.cs.AR;
    }, xzn = function(n) {
        return n.cs.Cd;
    }, kzn = function(n) {
        return n.cs.Ce;
    }, yzn = function(n) {
        return n.cs.CB;
    }, _zn = function(n) {
        return n.cs.EE;
    }, Azn = nM(x([
        function(n) {
            var r = n.bS;
            if (r.$) return h;
            var t = r.a;
            return t.$ && vu(t.a) ? x([
                b(0, eM(A2(rM, uM, xzn)))
            ]) : h;
        }
    ])), Czn = function(n) {
        var r = A2(BM, Azn, n);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Bzn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = Czn(r.kB), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), Ezn = function() {
        return Vt(1);
    }, Dzn = F2(function(n, r) {
        var t = Ezn();
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(Bzn, !1, r).a, {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), qzn = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(fwn, n.a, r.eT), e = t.b, u = t.c, a = m(r, {
                    eT: t.a
                }), i = function() {
                    if (u.$) return v(a, Pp, Ut);
                    if (u.a.$) {
                        var n = u.a.a;
                        return v(m(a, {
                            fA: !0
                        }), A2(FEn, a.gF, Vt(n)), Ut);
                    }
                    return v(A2(Bzn, !1, m(a, {
                        kw: 0,
                        kB: A3(dN, hzn, u.a.a, a.kB)
                    })).a, Pp, Ut);
                }(), c = i.b, o = i.c;
                return v(i.a, Vu(x([
                    A2(Lp, pzn, e),
                    c
                ])), o);
            case 0:
                var f = n.a, s = m(r, {
                    hS: f,
                    fA: !1
                });
                switch(f.$){
                    case 2:
                        return v(s, Pp, Vt(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(gA(f.a))));
                    case 3:
                        return v(s, Pp, Ut);
                    default:
                        return v(r, Pp, Ut);
                }
            case 3:
                return v(A2(Dzn, n.a, r), Pp, Vt({
                    $: 2,
                    a: "DPC Practice Option"
                }));
            case 2:
                return v(r, Pp, Vt({
                    $: 1,
                    a: "DPC Practice Option"
                }));
            default:
                var l = n.a, d = FL(r.kB).bS;
                if (d.$) return v(r, Pp, Ut);
                if (d.a.$) {
                    var b = Vt($zn(l)), p = A3(dN, hzn, b, r.kB), $ = Ezn();
                    if ($.$) return v(m(r, {
                        kB: p
                    }), Pp, Ut);
                    var h = $.a, g = A3(vN, !0, h, r.x);
                    return v(m(r, {
                        kB: A2(bN, h, g) ? Czn(p).a : p,
                        x: g
                    }), Pp, Ut);
                }
                return v(r, Pp, Ut);
        }
    }), Fzn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pzn = function(n) {
        return n.rh;
    }, zzn = F2(function(n, r) {
        return i(Pzn(n), r.dk);
    }), jzn = F2(function(n, r) {
        return rv(A2(Rc, zzn(r), n));
    }), Szn = F4(function(n, r, t, e) {
        return A2(jzn, e, r).$ ? A2(Yt, {
            mD: t,
            kC: n,
            dk: Pzn(r),
            kD: Ut
        }, e) : A3(aQ, zzn(r), function(n) {
            return m(n, {
                mD: t
            });
        }, e);
    }), Lzn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(jzn, t, r);
            if (n.$) return x([
                ""
            ]);
            var e = n.a.mD;
            return 2 === e.$ ? $(e.a, x([
                ""
            ])) : x([
                ""
            ]);
        }();
        return A4(Szn, n, r, Fzn(e), t);
    }), Mzn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(jzn, t, r);
            if (n.$) return x([
                ""
            ]);
            var e = n.a.mD;
            if (2 === e.$) {
                var u = e.a;
                return A2(wj, be(u) - 1, u);
            }
            return x([
                ""
            ]);
        }();
        return A4(Szn, n, r, Fzn(e), t);
    }), Nzn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hzn = F4(function(n, r, t, e) {
        return A4(Szn, n, r, Nzn(t), e);
    }), Tzn = F3(function(n, r, t) {
        if (0 > n) return t;
        var e = A2(Np, n, t);
        if (e.b) {
            var u = e.b;
            return $(A2(wj, n, t), A2(Yt, r(e.a), u));
        }
        return t;
    }), Izn = F5(function(n, r, t, e, u) {
        var a = function() {
            var n = A2(jzn, u, r);
            if (n.$) return x([
                t
            ]);
            var a = n.a.mD;
            return 2 === a.$ ? A3(Tzn, e, function() {
                return t;
            }, a.a) : x([
                t
            ]);
        }();
        return A4(Szn, n, r, Fzn(a), u);
    }), Rzn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zzn = F4(function(n, r, t, e) {
        return A4(Szn, n, r, Rzn(t), e);
    }), Vzn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b;
                return v(m(r, {
                    S: A4(Zzn, gPn(r.ag), t, e, r.S)
                }), Pp, Vt(0));
            case 1:
                t = n.a;
                var u = n.b;
                return e = n.c, v(m(r, {
                    S: A5(Izn, gPn(r.ag), t, e, u, r.S)
                }), Pp, Vt(0));
            case 5:
                return t = n.a, v(m(r, {
                    S: A3(Lzn, gPn(r.ag), t, r.S)
                }), Pp, Vt(0));
            case 6:
                return t = n.a, v(m(r, {
                    S: A3(Mzn, gPn(r.ag), t, r.S)
                }), Pp, Vt(0));
            case 2:
                return v(r, Pp, Vt(2));
            case 3:
                return v(r, Pp, Vt(1));
            default:
                return t = n.a, e = n.b, v(m(r, {
                    S: A4(Hzn, gPn(r.ag), t, e, r.S)
                }), Pp, Vt(0));
        }
    }), Uzn = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Yzn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qzn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ozn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Gzn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Jzn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Wzn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Kzn = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Xzn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, njn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tjn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, ejn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ujn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ajn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ijn = function(n) {
        return {
            $: 20,
            a: n
        };
    }, cjn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, ojn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, fjn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, sjn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ljn = {
        $: 3
    }, djn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, bjn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, vjn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mjn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, pjn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, $jn = function(n) {
        return A2(Nu, pjn, _u(n));
    }, hjn = function(n) {
        switch(n.$){
            case 0:
                return "Title";
            case 1:
                return ZDn(0);
            case 2:
                return "Middle Name";
            case 3:
                return ZDn(1);
            case 4:
                return "Suffix";
            case 5:
                return "Has Chosen Name";
            case 6:
                return "Chosen Title";
            case 7:
                return ZDn(3);
            case 8:
                return "Chosen Middle Name";
            case 9:
                return ZDn(4);
            case 10:
                return "Chosen Suffix";
            case 11:
                return ZDn(5);
            case 12:
                return "Relationship";
            case 13:
                return ZDn(15);
            case 14:
                return ZDn(10);
            case 15:
                return ZDn(11);
            case 16:
                return ZDn(12);
            case 17:
                return "Preferred Language";
            case 18:
                return ZDn(6);
            case 19:
                return ZDn(7);
            case 20:
                return ZDn(8);
            case 21:
                return "Use Primary Address";
            case 22:
                return ZDn(9);
            default:
                return ZDn(16);
        }
    }, gjn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    w5: n.a
                });
            case 1:
                return m(r, {
                    qB: n.a
                });
            case 2:
                return m(r, {
                    s2: n.a
                });
            case 3:
                return m(r, {
                    rS: n.a
                });
            case 4:
                return m(r, {
                    wY: n.a
                });
            case 5:
                return m(r, {
                    aj: n.a
                });
            case 6:
                return m(r, {
                    nJ: n.a
                });
            case 7:
                return m(r, {
                    nF: n.a
                });
            case 8:
                return m(r, {
                    nH: n.a
                });
            case 9:
                return m(r, {
                    nG: n.a
                });
            case 10:
                return m(r, {
                    nI: n.a
                });
            case 11:
                return m(r, {
                    bk: n.a
                });
            case 12:
                return m(r, {
                    vB: Vt(n.a)
                });
            case 13:
                return m(r, {
                    we: n.a
                });
            case 14:
                return m(r, {
                    qV: n.a
                });
            case 15:
                return m(r, {
                    qW: n.a
                });
            case 16:
                return m(r, {
                    u5: n.a
                });
            case 17:
                return m(r, {
                    uU: n.a
                });
            case 18:
                return m(r, {
                    wG: n.a
                });
            case 19:
                return m(r, {
                    pP: n.a
                });
            case 20:
                return m(r, {
                    uy: n.a
                });
            case 21:
                return m(r, {
                    xu: n.a
                });
            case 22:
                return m(r, {
                    mk: n.a
                });
            default:
                return m(r, {
                    pU: n.a
                });
        }
    }), wjn = F3(function(n, r, t) {
        return A2(t.qf, n, r);
    }), xjn = F2(function(n, r) {
        return b(r.a, A2(rM, n, r.b));
    }), kjn = function(n) {
        return A2(sc, !1, A2(Fp, REn, n));
    }, yjn = function(n) {
        var r = n.mk, t = n.xu;
        return kjn(n.vB) || t ? h : A2(Eu, function(n) {
            var r = n.a;
            return b(9, A2(xjn, function(n) {
                return A2(wjn, r, n);
            }, n.b));
        }, wwn(r));
    }, _jn = function(n) {
        return n.aj && fM(n.nF) ? x([
            b(3, eM(A2(rM, uM, Exn)))
        ]) : h;
    }, Ajn = function(n) {
        return n.aj && fM(n.nG) ? x([
            b(4, eM(A2(rM, uM, qxn)))
        ]) : h;
    }, Cjn = function(n) {
        return A2(Tp, function(r) {
            return rv(A2(PH, r, n.kB));
        }, $pn);
    }, Bjn = function(n) {
        var r;
        return kjn(n.vB) || !n.aj ? h : rc(x([
            (r = n, r.aj ? A2(Eu, function(n) {
                return b(14, n);
            }, Cjn(r.nJ)) : h),
            _jn(n),
            Ajn(n)
        ]));
    }, Ejn = function(n) {
        return n.eH;
    }, Djn = function(n) {
        return A2(Eu, function(n) {
            return b(5, n);
        }, Ejn(n.bk));
    }, qjn = F2(function(n, r) {
        var t = r.pP, e = !kjn(r.vB);
        return e && fM(t) && n ? x([
            b(7, eM(A2(rM, uM, iM)))
        ]) : !e || fM(t) || lM(t) ? h : x([
            b(7, dM(A2(rM, cM, iM)))
        ]);
    }), Fjn = function(n) {
        var r = n.pU;
        return A2(Eu, ry(16), z_n(r));
    }, Pjn = function(n) {
        return A2(Tp, function(r) {
            return rv(A2(PH, r, n.kB));
        }, kpn);
    }, zjn = function(n) {
        return A2(Eu, function(n) {
            return b(12, n);
        }, Pjn(n.u5));
    }, jjn = function(n) {
        var r;
        return A2(Eu, function(n) {
            return b(15, n);
        }, (r = n.we, A2(Tp, function(n) {
            return rv(A2(PH, n, r.kB));
        }, dpn)));
    }, Sjn = F2(function(n, r) {
        var t;
        return n ? rc(x([
            jjn(r),
            (t = r, A2(Eu, function(n) {
                return b(11, n);
            }, Pjn(t.qW))),
            zjn(r)
        ])) : function(n) {
            return A2(Eu, function(n) {
                return b(10, n);
            }, Pjn(n.qV));
        }(r);
    }), Ljn = function(n) {
        return fM(n.rS) ? x([
            b(1, eM(A2(rM, uM, mM)))
        ]) : h;
    }, Mjn = function(n) {
        var r, t;
        return kjn(n.vB) ? h : rc(x([
            (t = n, A2(Eu, function(n) {
                return b(14, n);
            }, Cjn(t.w5))),
            (r = n, fM(r.qB) ? x([
                b(0, eM(A2(rM, uM, vM)))
            ]) : h),
            Ljn(n)
        ]));
    }, Njn = F4(function(n, r, t, e) {
        return A3(e.qg, n, r, t);
    }), Hjn = F2(function(n, r) {
        return A2(tFn, r, A2(Eu, zc, n.b));
    }), Tjn = function(n) {
        return n.uw;
    }, Ijn = F2(function(n, r) {
        var t = 1 + A2(sc, 0, A2(Hjn, n.uy, r));
        return A2(Eu, function(r) {
            return CY(n.uy) > 1 ? A2(xjn, function(n) {
                return A2(rM, function(r) {
                    return A3(Njn, r, oe(t), n);
                }, Tjn);
            }, r) : r;
        }, A2(Awn, n, r));
    }), Rjn = function(n) {
        return $(zwn(n), rc(A2(sO, function(r) {
            return A2(Ijn, n, r.b);
        }, n.uy)));
    }, Zjn = function(n) {
        var r = n.uy;
        return kjn(n.vB) ? h : A2(Eu, function(n) {
            return b(8, n);
        }, Rjn(r));
    }, Vjn = function(n) {
        return n.vB.yd;
    }, Ujn = function(n) {
        return n.vB.yU;
    }, Yjn = function(n) {
        return n.vB.rQ;
    }, Qjn = function(n) {
        return n.vB.tU;
    }, Ojn = function(n) {
        var r = n.vB;
        return 1 === r.$ ? x([
            b(2, eM(A2(rM, uM, Yjn)))
        ]) : (REn(r.a), h);
    }, Gjn = $B("###-##-####"), Jjn = A2(Eu, function(n) {
        return A2(lB, Gjn, n);
    }, x([
        "219099999",
        "078051120",
        "123456789"
    ])), Wjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kjn = {
        $: 0
    }, Xjn = F3(function(n, r, t) {
        return {
            z3: n,
            Df: r,
            D6: t
        };
    }), nSn = F2(function(n, r) {
        return s(r, n.s4) > -1 && 1 > s(r, n.sk);
    }), rSn = F2(function(n, r) {
        return r.$ ? A2(nSn, r.a, n) : function(n) {
            return !(!n || 666 === n || n >= 900 && 999 >= n);
        }(n);
    }), tSn = F3(function(n, r, t) {
        if (i(su(t), n)) {
            var e = pu(t);
            return e.$ ? jm("Ssn part is not an integer.") : A2(rSn, e.a, r) ? lm(t) : jm("Ssn part is invalid.");
        }
        return jm("Ssn part is invalid.");
    }), eSn = F2(function(n, r) {
        return A2(im, A2(tSn, n, r), Hm(qm(ye)));
    }), uSn = A2(zm, A2(zm, A2(zm, lm(Xjn), A2(sm, A2(eSn, 3, Kjn), VS("-"))), A2(sm, A2(eSn, 2, Wjn({
        sk: 99,
        s4: 1
    })), VS("-"))), A2(sm, A2(eSn, 4, Wjn({
        sk: 9999,
        s4: 1
    })), Gm)), aSn = F2(function(n, r) {
        var t, e = r.wG;
        return fM(e) ? r$n(n) ? x([
            b(6, eM(A2(rM, uM, Qyn)))
        ]) : h : !A2(ep, uSn, t = A2(lB, Gjn, e)).$ && !A2(SE, t, Jjn) || Jwn(n) ? h : x([
            b(6, dM(A2(rM, cM, Qyn)))
        ]);
    }), iSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, Uzn(A2(Egn, n, t.mk)), r);
    }), cSn = F2(function(n, r) {
        return r.vM(n);
    }), oSn = F2(function(n, r) {
        return r.w5.$ && n ? x([
            b(0, eM(A2(rM, cSn, hM)))
        ]) : h;
    }), fSn = function(n) {
        var r = A2(BM, nM(x([
            oSn(n.vJ)
        ])), n.kB);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, sSn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: fSn(r).a,
            x: t
        });
    }), lSn = F2(function(n, r) {
        var t = FL(r);
        return t.aj ? A3(dN, gjn, Ozn(A2(sSn, n, t.nJ)), r) : r;
    }), dSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, Jzn(A2(eN, n, t.bk)), r);
    }), bSn = F2(function(n, r) {
        var t = FL(r), e = Y_n(t.pU);
        return A3(dN, gjn, Kzn(e), r);
    }), vSn = function(n) {
        return n.vK;
    }, mSn = F2(function(n, r) {
        var t = r.fF, e = r.dy;
        return t.$ ? h : n(t.a) && fM(e) ? x([
            b(1, eM(vSn))
        ]) : h;
    }), pSn = F3(function(n, r, t) {
        return t.fF.$ && n ? x([
            b(0, eM(A2(rM, cSn, r)))
        ]) : h;
    }), $Sn = F3(function(n, r, t) {
        return nM(x([
            A2(pSn, r, t),
            mSn(n)
        ]));
    }), hSn = function(n) {
        var r = A2(BM, A3($Sn, n.AH, n.vJ, n.z$), n.kB);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, gSn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: hSn(r).a,
            x: t
        });
    }), wSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, tjn(A2(gSn, n, t.qV)), r);
    }), xSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, ejn(A2(gSn, n, t.qW)), r);
    }), kSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, fjn(A2(gSn, n, t.u5)), r);
    }), ySn = F2(function(n, r) {
        return r.we.$ && n ? x([
            b(0, eM(A2(rM, cSn, Vvn.rQ)))
        ]) : h;
    }), _Sn = function(n) {
        var r = A2(BM, nM(x([
            ySn(n.vJ)
        ])), n.kB);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, ASn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: _Sn(r).a,
            x: t
        });
    }), CSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, djn(A2(ASn, n, t.we)), r);
    }), BSn = F3(function(n, r, t) {
        return r ? A2(kSn, n, A2(xSn, n, A2(CSn, n, t))) : A2(wSn, n, t);
    }), ESn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, ijn(A2(Nwn, n, t.uy)), r);
    }), DSn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, gjn, vjn(A2(sSn, n, t.w5)), r);
    }), qSn = F2(function(n, r) {
        var t = Xxn(r.dB), e = A2(bSn, n, A2(dSn, n, A2(iSn, n, A2(ESn, n, A3(BSn, n, t, A2(lSn, n, A2(DSn, n, r.kB))))))), u = A2(BM, function(n) {
            var r = Xxn(n.dB), t = Lwn(n.dB);
            return nM(x([
                Mjn,
                Ojn,
                Bjn,
                Djn,
                Sjn(r),
                aSn(n.a$.n1),
                qjn(t),
                Zjn,
                yjn,
                Fjn
            ]));
        }(r), e);
        return u.$ ? b(u.a, !1) : b(u.a.a, !0);
    }), FSn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            kB: A2(qSn, n, r).a,
            x: t
        });
    }), PSn = function(n) {
        switch(n.$){
            case 0:
                return Vt(13);
            case 1:
                return Vt(0);
            case 2:
            case 4:
            case 5:
            case 8:
            case 10:
            case 17:
            case 21:
                return Ut;
            case 3:
                return Vt(1);
            case 6:
                return Vt(14);
            case 7:
                return Vt(3);
            case 9:
                return Vt(4);
            case 11:
                return Vt(5);
            case 12:
                return Vt(2);
            case 13:
                return Vt(15);
            case 14:
                return Vt(10);
            case 15:
                return Vt(11);
            case 16:
                return Vt(12);
            case 18:
                return Vt(6);
            case 19:
                return Vt(7);
            case 20:
                return Vt(8);
            case 22:
                return Vt(9);
            default:
                return Vt(16);
        }
    }, zSn = F2(function(n, r) {
        var t = PSn(n);
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(FSn, !1, r), {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), jSn = {
        DW: d0(1500),
        Ek: function(n) {
            return {
                $: 16,
                a: n
            };
        }
    }, SSn = {
        $: 2
    }, LSn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MSn = {
        $: 1
    }, NSn = F2(function(n, r) {
        var t = A2(ZD, n, r.fC), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return b(r.AL, Ut);
            switch(a.a.$){
                case 0:
                    var n = a.a.a;
                    return b(A2(sc, r.AL, n), A2(Fp, LSn, n));
                case 1:
                    return b(r.AL, Vt(MSn));
                default:
                    return b(r.AL, Vt(SSn));
            }
        }(), c = i.b;
        return v(m(r, {
            AL: i.a,
            fC: e
        }), A2(Lp, iu, u), c);
    }), HSn = {
        $: 2
    }, TSn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ISn = {
        $: 1
    }, RSn = function(n) {
        var r = FL(n.kB).fF;
        return A2(sc, "", A2(Fp, n.lu(Wx(0)), r));
    }, ZSn = function(n) {
        var r = A3(vN, !0, 0, n.x), t = m(n, {
            x: r
        });
        return A2(bN, 0, r) ? m(t, {
            kB: hSn(n).a
        }) : t;
    }, VSn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(ZD, n.a, r.fW), e = t.a, u = t.b, a = t.c, i = A2(sc, b(r, Ut), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = A3(dN, M$n, L$n(n.a), r.kB), e = ZSn(m(r, {
                                kB: t
                            }));
                            return b(e, Vt(TSn(RSn(e))));
                        case 1:
                            return b(r, Vt(ISn));
                        default:
                            return b(r, Vt(HSn));
                    }
                }, a)), c = i.b;
                return v(m(i.a, {
                    fW: e
                }), A2(Lp, ikn, u), c);
            case 1:
                var o = vDn(n.a);
                return v(f = ZSn(m(r, {
                    kB: A3(dN, M$n, o, r.kB)
                })), Pp, Vt(TSn(RSn(f))));
            case 2:
                var f;
                return v(f = function() {
                    if (A2(qM, 0, r.x)) {
                        var n = A3(FM, !0, 0, r.x), t = hSn(r);
                        return m(r, {
                            kB: t.a,
                            x: n
                        });
                    }
                    return r;
                }(), Pp, Vt(HSn));
            default:
                return v(r, Pp, Vt(ISn));
        }
    }), USn = {
        $: 2
    }, YSn = {
        $: 1
    }, QSn = F2(function(n, r) {
        var t = Vt(0);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: _Sn(r).a
        }) : a;
    }), OSn = F2(function(n, r) {
        var t = A2(ZD, n, r.fJ), e = t.a, u = t.b, a = t.c, i = A2(sc, b(r, Ut), A2(Fp, function(n) {
            switch(n.$){
                case 0:
                    var t = n.a;
                    return b(A2(QSn, t, m(r, {
                        kB: A3(dN, T$n, t, r.kB)
                    })), A2(nv, function(n) {
                        return Vt(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(sc, "", vpn(n))));
                    }, t));
                case 1:
                    return b(r, Vt(YSn));
                default:
                    return b(r, Vt(USn));
            }
        }, a)), c = i.b;
        return v(m(i.a, {
            fJ: e
        }), A2(Lp, iu, u), c);
    }), GSn = {
        $: 2
    }, JSn = {
        $: 1
    }, WSn = F2(function(n, r) {
        var t = Vt(0);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: fSn(r).a
        }) : a;
    }), KSn = F2(function(n, r) {
        var t = n, e = FL(r.kB).w5, u = A2(ZD, t, r.fU), a = u.a, i = u.b, c = u.c, o = function() {
            if (c.$) return b(e, Ut);
            switch(c.a.$){
                case 0:
                    var n = c.a.a, r = A2(Fp, function(n) {
                        return function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(jvn, Wx(0), n));
                    }, n);
                    return b(n, r);
                case 1:
                    return b(e, Vt(JSn));
                default:
                    return b(e, Vt(GSn));
            }
        }(), f = o.a, s = o.b;
        return v(A2(WSn, f, m(r, {
            kB: A3(dN, Z$n, f, r.kB),
            fU: a
        })), A2(Lp, iu, i), s);
    }), XSn = F2(function(n, r) {
        var t = PSn(n);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: A2(qSn, !1, r).a
        }) : a;
    }), nLn = F2(function(n, r) {
        return A2(XSn, n, m(r, {
            kB: A3(dN, gjn, n, r.kB)
        }));
    }), rLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(A2(nLn, t = n.a, r), A2(Nu, iu, _u(njn(t))), Vt(Qzn(hjn(t))));
            case 15:
                var t = function(n) {
                    return {
                        $: 21,
                        a: n
                    };
                }(n.a);
                return v(m(r, {
                    kB: A3(dN, gjn, t, r.kB)
                }), Pp, Vt(Qzn(hjn(t))));
            case 1:
                var e = n.a, u = FL(r.kB), a = A2(qgn, e, u.mk), i = a.b, c = a.c, o = Uzn(a.a), f = A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a;
                            return b(Vt(Qzn(hjn(o) + ": " + t)), r);
                        case 1:
                            return t = n.a, b(Vt(rjn(hjn(o) + ": " + t)), r);
                        default:
                            return t = n.a, b(Vt(Yzn(hjn(o) + ": " + t)), A2(zSn, o, r));
                    }
                }, c)), s = f.a;
                return v(m(f.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, Gqn, i), s);
            case 2:
                return t = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(n.a), v(m(r, {
                    kB: A3(dN, gjn, t, r.kB)
                }), Pp, Vt(Qzn(hjn(t))));
            case 5:
                if (function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                        case 3:
                        case 7:
                        case 8:
                        case 9:
                        case 11:
                        case 12:
                            return !0;
                        default:
                            return !1;
                    }
                }(t = n.a)) {
                    var l = A3(SX, jSn, t, r.dI), d = l.b;
                    return v(m(r, {
                        dI: l.a
                    }), d, Ut);
                }
                return v(r, Pp, Ut);
            case 3:
                return v(A2(zSn, t = n.a, r), Pp, Vt(Yzn(hjn(t))));
            case 4:
                return v(r, Pp, Vt(rjn(hjn(t = n.a))));
            case 6:
                var p = n.a, $ = FL(r.kB), h = A2(KSn, p, $.w5), g = h.b, w = h.c, k = (o = vjn(h.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, w)));
                return s = k.a, v(m(k.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, mjn, g), s);
            case 7:
                var y = n.a, _ = FL(r.kB), A = A2(KSn, y, _.nJ), C = A.b, B = A.c, E = (o = Ozn(A.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, B)));
                return s = E.a, v(m(E.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, Gzn, C), s);
            case 8:
                var D = n.a, q = FL(r.kB), F = A2(uN, D, q.bk), P = F.b, z = F.c, j = (o = Jzn(F.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, z)));
                return s = j.a, v(m(j.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), Vu(x([
                    A2(Lp, Wzn, P),
                    A2(Nu, iu, _u(njn(o)))
                ])), s);
            case 9:
                var S = n.a, L = FL(r.kB), M = A2(OSn, S, L.we), N = M.b, H = M.c, T = (o = djn(M.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, H)));
                return s = T.a, v(m(T.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, bjn, N), s);
            case 10:
                var I = n.a, R = FL(r.kB), Z = A2(VSn, I, R.qV), V = Z.b, U = Z.c, Y = (o = tjn(Z.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, U)));
                return s = Y.a, v(m(Y.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, ajn, V), s);
            case 11:
                var Q = n.a, O = FL(r.kB), G = A2(VSn, Q, O.qW), J = G.b, W = G.c, K = (o = ejn(G.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, W)));
                return s = K.a, v(m(K.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, ujn, J), s);
            case 12:
                var X = n.a, nn = FL(r.kB), rn = A2(VSn, X, nn.u5), tn = rn.b, en = rn.c, un = (o = fjn(rn.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, en)));
                return s = un.a, v(m(un.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, sjn, tn), s);
            case 13:
                var an = n.a, cn = FL(r.kB), on = A2(NSn, an, cn.uU), fn = on.b, sn = on.c, ln = (o = function(n) {
                    return {
                        $: 17,
                        a: n
                    };
                }(on.a), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Vt(Qzn(hjn(o))), r);
                        case 1:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                    }
                }, sn)));
                return s = ln.a, v(m(ln.b, {
                    kB: A3(dN, gjn, o, r.kB)
                }), A2(Lp, ojn, fn), s);
            case 14:
                var dn = n.a, bn = FL(r.kB), vn = A2(hwn, dn, bn.uy), mn = vn.a, pn = vn.b, $n = vn.c, hn = (o = ijn(mn), A2(sc, b(Ut, r), A2(Fp, function(n) {
                    switch(n.$){
                        case 3:
                            return b(Vt(Yzn(hjn(o))), A2(zSn, o, r));
                        case 4:
                            return b(Vt(rjn(hjn(o))), r);
                        default:
                            return b(Vt(Qzn(hjn(o))), r);
                    }
                }, $n)));
                return s = hn.a, v(m(hn.b, {
                    kB: A3(dN, gjn, ijn(mn), r.kB)
                }), A2(Lp, cjn, pn), s);
            case 16:
                var gn = n.a, wn = A4(x0, jSn, h0($jn), gn, r.dI);
                return d = wn.b, v(m(r, {
                    dI: wn.a
                }), d, Ut);
            case 17:
                return v(r, Pp, Vt(ljn));
            default:
                var xn = n.a, kn = FL(r.kB), yn = A2(E_n, xn, kn.pU), _n = yn.b;
                return v(m(r, {
                    kB: A3(dN, gjn, Kzn(yn.a), r.kB)
                }), A2(Lp, Xzn, _n), Ut);
        }
    }), tLn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, eLn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uLn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, aLn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iLn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cLn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oLn = function(n) {
        var r = n.hZ;
        return 3 === r.$ ? r.a : h;
    }, fLn = function(n) {
        return n.eN ? Ut : Vt(n.dC);
    }, sLn = function(n) {
        var r = n.kL;
        return 1 === r.$ ? Vt(r.a.rh) : Ut;
    }, lLn = F2(function(n, r) {
        var t = n.bp, e = unn(n.k7), u = enn(n.k7), a = n.av, i = sLn(a), c = fLn(a), o = function() {
            var n = yqn(a.kq);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return fM(t) ? b(Ut, Ut) : b(wqn(r), Vt(t));
            }
            return b(Ut, Ut);
        }();
        return m(r, {
            kq: o.a,
            hY: u,
            kN: i,
            tg: c,
            ic: e,
            lB: t,
            x0: o.b
        });
    }), dLn = function(n) {
        var r = lLn(n);
        return A4(zqn, n.gF, Bx(n.dB), r, YDn);
    }, bLn = F2(function(n, r) {
        var t = b(vvn(n), vvn(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(Ju, t.a.a, t.b.a);
    }), vLn = F2(function(n, r) {
        return A2(sc, !0, A2(Fp, function(n) {
            return !!n.$ || s(n.a, r) > 0;
        }, n.av));
    }), mLn = F2(function(n, r) {
        var t = vvn(r);
        return !!t.$ || A2(vLn, n, t.a);
    }), pLn = F2(function(n, r) {
        return A2(eq, bLn, A2(Rc, mLn(n.kq), r));
    }), $Ln = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(bqn(n), r);
        }, n);
    }), hLn = function(n) {
        var r = n.kL;
        return r.$ ? Vt(r.a.rh) : Ut;
    }, gLn = function(n) {
        var r = b(n.hZ, r$n(n.O));
        if (3 === r.a.$ && r.b) {
            var t = r.a.a, e = hLn(n.av);
            return e.$ ? A2(pLn, n.av, t) : A2(Tp, iu, x([
                A2($Ln, t, e.a)
            ]));
        }
        return h;
    }, wLn = function(n) {
        return n.rh;
    }, xLn = F2(function(n, r) {
        return A2(Rc, function(r) {
            return aF(A2(wF, function(n) {
                return i(wLn(n), bqn(r));
            }, n));
        }, r);
    }), kLn = function(n) {
        return n.hZ;
    }, yLn = F2(function(n, r) {
        return A2(sc, r, A2(nv, function(n) {
            return TE(n) ? Ut : Vt(A2(xLn, n, r));
        }, A2(Fp, function(n) {
            return kLn(n.uP);
        }, n)));
    }), _Ln = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ALn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, CLn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), BLn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ELn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), DLn = function(n) {
        return m(n, {
            av: Ut
        });
    }, qLn = function(n) {
        return !!n.$ || 2 === n.a.$;
    }, FLn = function(n) {
        return !qLn(n.av);
    }, PLn = gD, zLn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), jLn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, SLn = F2(function(n, r) {
        return !i(n, r);
    }), LLn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return r.av.$ ? v(r, Pp, Ut) : v(m(r, {
                x0: t
            }), Pp, Vt(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(t)));
        }
        var e = A2(ZD, n.a, r.fD), u = e.b, a = e.c, i = m(r, {
            fD: e.a
        }), c = function() {
            if (a.$ || a.a.$ || a.a.a.$) return b(i, Ut);
            var n = a.a.a.a, r = A2(SLn, i.av, n), t = qLn(n) ? Ut : n, e = m(i, {
                av: t
            });
            return b(e, Vt(A2(zLn, yqn(e), r)));
        }(), o = c.b;
        return v(c.a, A2(Lp, jLn, u), o);
    }), MLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    dC: t
                }), Pp, Vt(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(t)));
            case 1:
                var e = A2(LLn, n.a, r.kq), u = e.b, a = e.c, c = m(r, {
                    kq: e.a
                }), o = function() {
                    if (a.$) return b(c, Ut);
                    if (a.a.$) {
                        var n = a.a.a;
                        return b(c, Vt(A2(ELn, n, wgn(n))));
                    }
                    var t = a.a, e = t.a, u = t.b, o = function() {
                        var n = r.kL;
                        if (1 === n.$) return !0;
                        var t = n.a, e = Wx(0);
                        return i(e(PLn), e(t));
                    }();
                    return b(m(c, {
                        kL: sqn
                    }), Vt(A2(_Ln, e, u || o)));
                }(), f = o.b;
                return v(o.a, A2(Lp, ALn, u), f);
            default:
                var s = A2(ZD, n.a, r.e0), l = s.b, d = s.c, p = m(r, {
                    e0: s.a
                }), $ = function() {
                    if (d.$ || d.a.$ || d.a.a.$) return b(p, Ut);
                    var n = d.a.a.a, t = FLn(r.kq);
                    return b(m(p, {
                        kq: DLn(r.kq),
                        kL: n
                    }), Vt(A2(CLn, n, t)));
                }(), h = $.b;
                return v($.a, A2(Lp, BLn, l), h);
        }
    }), NLn = function(n) {
        return b(Pp, Vt(n));
    }, HLn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, TLn = {
        $: 1
    }, ILn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), RLn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZLn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = Vt(t.$ ? TLn : ZLn(t.a));
                return v(m(r, {
                    bz: dqn
                }), Pp, e);
            case 1:
                var u = Gbn((c = n.a).uP), a = u.b;
                return v(m(r, {
                    bz: A2(ILn, u.a, c)
                }), A2(Lp, RLn, a), Ut);
            case 2:
                a = n.a;
                var i = r.bz;
                if (1 === i.$) {
                    var c = i.b, o = A2(Kbn, a, i.a), f = o.a, s = o.b, l = o.c, d = function() {
                        switch(l){
                            case 1:
                                return b(dqn, Ut);
                            case 2:
                                return b(dqn, Vt(ZLn(c)));
                            default:
                                return b(A2(ILn, f, c), Ut);
                        }
                    }(), p = d.b;
                    return v(m(r, {
                        bz: d.a
                    }), A2(Lp, RLn, s), p);
                }
                return v(r, Pp, Ut);
            case 3:
                var $ = A2(ZD, n.a, r.fl), h = $.a, g = $.b, w = $.c;
                return e = w.$ || w.a.$ ? Ut : A2(Fp, function(n) {
                    return function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(n);
                }, w.a.a), v(m(r, {
                    fl: h
                }), A2(Lp, HLn, g), e);
            case 4:
                return v(1 === n.a ? m(r, {
                    bz: dqn
                }) : r, Pp, Ut);
            default:
                return v(r, Pp, Vt(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n.a)));
        }
    }), ULn = function(n) {
        var r = Bx(n.dB), t = n.av, e = function() {
            var n = yqn(t.kq);
            if (1 === n.$) {
                var r = n.b;
                return fM(r) ? Ut : Vt(r);
            }
            return Ut;
        }();
        return A4(Eqn, n.gF, r, A2(jqn, n.bp, e), UDn);
    }, YLn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    cJ: t
                });
                switch(t.$){
                    case 3:
                        var u = t.a, a = A2(sc, 0, A2(nv, pu, A2(Wu, "x-total-count", t.b))), i = r$n(r.P) && 1 === be(u) && LP(r.lw) ? A2(Fp, czn, rv(u)) : r.lw;
                        return v(m(r, {
                            k7: A2(vnn, a, r.k7),
                            cJ: t,
                            lw: i
                        }), Pp, Ut);
                    case 2:
                        return v(e, Pp, Vt(tLn(gA(t.a))));
                    default:
                        return v(e, Pp, Ut);
                }
            case 1:
                return v(C = m(r, {
                    k7: A2(bnn, f = n.a, r.k7)
                }), dLn(C), Ut);
            case 2:
                var c = n.a;
                switch(e = m(r, {
                    hZ: c
                }), c.$){
                    case 3:
                        var o = c.a;
                        return v(m(e, {
                            lv: JDn(r.O) && 1 === be(o) && LP(r.lv) ? A2(Fp, bqn, rv(o)) : r.lv
                        }), Pp, Ut);
                    case 2:
                        return v(e, Pp, Vt(tLn(gA(c.a))));
                    default:
                        return v(e, Pp, Ut);
                }
            case 3:
                var f = n.a, s = r.fI;
                if (s.$) return v(r, Pp, Ut);
                var l = A2(VLn, f, s.a), d = l.b, p = l.c, $ = m(r, {
                    eH: h,
                    fI: GDn(l.a)
                }), g = function() {
                    if (p.$) return b($, Ut);
                    switch(p.a.$){
                        case 0:
                            var n = p.a.a, t = function() {
                                if (r$n(r.O)) {
                                    var t = hLn(r.av);
                                    if (t.$) {
                                        var e = A2(yLn, Vt(n), gLn(r));
                                        return 1 === be(e) ? rv(e) : Ut;
                                    }
                                    var u = t.a;
                                    return A2($Ln, oLn(r), u);
                                }
                                return Ut;
                            }();
                            return b(m($, {
                                eH: h,
                                lv: A2(Fp, bqn, t),
                                lw: Vt(czn(n.uP))
                            }), Vt(A2(cLn, n.uP, t)));
                        case 1:
                            return t = function() {
                                if (r$n(r.O)) {
                                    var n = gLn(r);
                                    return 1 === be(n) ? rv(n) : Ut;
                                }
                                return Ut;
                            }(), b(m($, {
                                eH: h,
                                lv: A2(Fp, bqn, t),
                                lw: Ut
                            }), Vt(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(t)));
                        case 2:
                            return b(m($, {
                                eH: h,
                                lv: Vt(bqn(t = p.a.a))
                            }), Vt(aLn(t)));
                        default:
                            return b($, Ut);
                    }
                }(), w = g.b;
                return v(g.a, A2(Lp, iLn, d), w);
            case 5:
                var k = NLn(f = n.a), y = k.a, _ = k.b, A = function() {
                    if (_.$) return b(r.lv, Ut);
                    var n = _.a;
                    return b(Vt(bqn(n)), Vt(aLn(n)));
                }();
                return w = A.b, v(m(r, {
                    eH: h,
                    lv: A.a
                }), A2(Lp, uLn, y), w);
            default:
                var C, B = A2(MLn, f = n.a, r.av), E = B.b, D = B.c, q = m(r, {
                    av: B.a
                }), F = function() {
                    if (D.$) return b(q, Pp);
                    var n = D.a;
                    switch(n.$){
                        case 1:
                        default:
                            return b(r = m(q, {
                                k7: rnn
                            }), dLn(r));
                        case 2:
                            return n.b ? b(r = m(q, {
                                k7: rnn
                            }), dLn(r)) : b(q, Pp);
                        case 3:
                            var r;
                            return n.b ? b(r = m(q, {
                                k7: rnn
                            }), Vu(x([
                                dLn(r),
                                ULn(r)
                            ]))) : b(q, Pp);
                    }
                }(), P = F.b;
                return v(C = F.a, Vu(x([
                    A2(Lp, eLn, E),
                    P
                ])), Ut);
        }
    }), QLn = F2(function(n, r) {
        var t = n;
        return v(m(r, {
            xy: t
        }), Pp, Vt(t));
    }), OLn = Wn("scrollIdIntoView", Ax), GLn = F2(function(n, r) {
        return be(A2(PH, r, n)) > 0;
    }), JLn = F2(function(n, r) {
        return Vt(A2(UEn, n, r));
    }), WLn = function(n) {
        var r = A2(qSn, !1, n);
        if (r.b) return Ut;
        var t = r.a;
        return A2(nv, JLn(n.rh), rv(A2(Rc, GLn(t), RDn)));
    }, KLn = function(n) {
        return A2(qSn, !1, n).b;
    }, XLn = F3(function(n, r, t) {
        return A2(t.yk, n, r);
    }), nMn = F2(function(n, r) {
        return FLn(n) ? A2(Rc, function(r) {
            var t = A2(nv, vvn, r.kL);
            return !!t.$ || A2(vLn, n, t.a);
        }, r) : r;
    }), rMn = F2(function(n, r) {
        return A2(Ju, MP(n.uP), MP(r.uP));
    }), tMn = function(n) {
        return n.t0;
    }, eMn = function(n) {
        return n.wO;
    }, uMn = F2(function(n, r) {
        var t = function(n) {
            return "full_waitlisting" === n ? 1 : 0;
        }, e = A2(Ju, t(eMn(n.uP)), t(eMn(r.uP)));
        if (1 === e) {
            var u = A2(Ju, tMn(n.uP), tMn(r.uP));
            return 1 === u ? A2(rMn, n, r) : u;
        }
        return e;
    }), aMn = F3(function(n, r, t) {
        var e = kLn(t), u = TE(e) ? A2(Eu, bqn, r) : A2(Eu, wLn, e);
        return aF(A2(wF, function(r) {
            return i(r, n);
        }, u));
    }), iMn = F3(function(n, r, t) {
        if (1 === r.$) {
            var e = r.a;
            return A2(eq, uMn, A2(Rc, function(r) {
                return A3(aMn, e.rh, n, r.uP);
            }, t));
        }
        return t;
    }), cMn = F2(function(n, r) {
        return A2(fu, UQ(n), UQ(r));
    }), oMn = F2(function(n, r) {
        return fM(n) ? r : A2(Rc, function(r) {
            return A2(cMn, n, MP(r));
        }, r);
    }), fMn = F2(function(n, r) {
        return TE(n) ? r : A2(Rc, function(r) {
            var t = kLn(r);
            return 0 >= be(t) || !TE(A2(xLn, t, n));
        }, r);
    }), sMn = F2(function(n, r) {
        return rv(A2(eq, bLn, A2(Rc, function(t) {
            return A3(aMn, bqn(t), n, r);
        }, n)));
    }), lMn = F3(function(n, r, t) {
        return {
            kL: function() {
                if (FLn(n.kq)) return A2(sMn, r, t);
                var e = n.kL;
                if (1 === e.$) {
                    var u = e.a;
                    return A2(wF, function(n) {
                        return i(bqn(n), u.rh);
                    }, r);
                }
                return Ut;
            }(),
            uP: t
        };
    }), dMn = F3(function(n, r, t) {
        return A3(iMn, r, n.kL, A2(nMn, n.kq, A2(Eu, A2(lMn, n, r), A2(oMn, n.dC, A2(fMn, r, t)))));
    }), bMn = function(n) {
        var r, t = n.cJ;
        if (3 === t.$) {
            var e = t.a, u = n.P;
            if (WDn(u) || r$n(u)) {
                var a = 3 === (r = n.hZ).$ ? r.a : h;
                return A3(dMn, n.av, a, e);
            }
            return h;
        }
        return h;
    }, vMn = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(czn(n.uP), r);
        }, n);
    }), mMn = F2(function(n, r) {
        switch(r.rh){
            case 0:
                return function(n) {
                    var r, t = A2(FSn, !0, n.U), e = m(n, {
                        eH: A3(QFn, n.g8, n.Bb, n.U),
                        hB: !0,
                        U: t
                    });
                    return KLn(t) && TE(e.eH) ? v(e, Pp, !0) : v(e, (r = WLn(t)).$ ? Pp : OLn(r.a), !1);
                }(n);
            case 1:
                return function(n) {
                    var r = A2(cFn, n.dB, n.Bb) ? A2(Bzn, !0, n.as) : b(n.as, !0), t = r.b;
                    return v(m(n, {
                        as: r.a
                    }), Pp, t);
                }(n);
            case 2:
                return function(n) {
                    var r = function(n) {
                        var r, t, e = m(n, {
                            lv: (r = v(Lqn(n.P), LP(n.lw), hLn(n.av))).a && r.b && !r.c.$ ? Vt(r.c.a) : n.lv
                        }), u = (t = b(function(n) {
                            if (KDn(n.P)) {
                                var r = n.lw;
                                if (r.$) return Lqn(n.P);
                                var t = r.a;
                                return aF(A2(vMn, bMn(n), t));
                            }
                            return !0;
                        }(e), function(n) {
                            if (JDn(n.O)) {
                                var r = n.lv;
                                if (r.$) return !1;
                                var t = r.a;
                                return aF(A2($Ln, gLn(n), t));
                            }
                            return !0;
                        }(e)), t.a ? t.b ? h : x([
                            A2(rM, uM, kD)
                        ]) : x(t.b ? [
                            A2(rM, uM, Wvn)
                        ] : [
                            A2(rM, function(n) {
                                return A2(rM, function(r) {
                                    return A2(rM, uM, A2(XLn, n, r));
                                }, kD);
                            }, Wvn)
                        ]));
                        return b(m(e, {
                            eH: u
                        }), u);
                    }(n.aE), t = r.b;
                    return v(m(n, {
                        eH: t,
                        aE: r.a
                    }), Pp, TE(t));
                }(n);
            default:
                return function(n) {
                    return v(m(n, {
                        hJ: !0
                    }), Pp, BY(n.aZ));
                }(n);
        }
    }), pMn = F2(function(n, r) {
        return A2(zU, r.a, A2(Eu, function(r) {
            return b(r.a, n(r.b));
        }, r.b));
    }), $Mn = F2(function(n, r) {
        return m(r, {
            bl: Vt(n)
        });
    }), hMn = F2(function(n, r) {
        var t = n;
        return m(r, {
            Y: A2(pMn, function(n) {
                return A2($Mn, t, n);
            }, r.Y)
        });
    }), gMn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wMn = F2(function(n, r) {
        var t = Vt(gMn(r));
        return m(n, {
            kB: A3(dN, hzn, t, n.kB)
        });
    }), xMn = F2(function(n, r) {
        return m(r, {
            Y: zY(A2(Eu, A2(OY, r.gF, r.CD), n))
        });
    }), kMn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a;
                    if (function(n) {
                        return (function(n) {
                            return 2 === mEn(n);
                        }(n) || function(n) {
                            return 1 === mEn(n);
                        }(n)) && !wBn(n);
                    }(e)) {
                        var u = (tn = function(n) {
                            return _Pn(n).a.rO;
                        }(e), tn.$ ? r.as : A2(wMn, r.as, tn.a));
                        return v(l = m(r, {
                            as: u,
                            Bb: Vt(e)
                        }), function(n) {
                            return A3(Smn, n.gF, Bx(n.dB), hPn);
                        }(l), h);
                    }
                    return v(r, DPn(e), h);
                }
                return v(r, Pp, A2(xA, 0, t));
            case 1:
                var a = n.a;
                if (3 === a.$) {
                    var c = function(n) {
                        return {
                            cx: xPn(n),
                            x: A2(vS, x([
                                0
                            ]), AEn)
                        };
                    }(eFn(M = a.a)), o = A4(Rqn, r.gF, Wx(r.kA), r.dB, vzn(M)), f = o.a, s = o.b, l = m(r, {
                        kh: Vt(A4(gFn, Vt(M), r.dB, r.Bb, 0)),
                        bP: lS(c),
                        U: A3(VDn, Vqn, r.dB, EPn(M)),
                        aE: f,
                        fL: Vt(M),
                        bF: Zqn
                    }), d = A8($Pn, l.gF, l.dB, l.g8, l.Bb, l.U, l.bF, M, Kqn);
                    return v(l, Vu($(A2(Eu, Lp(Xqn), s), x([
                        d
                    ]))), h);
                }
                return v(r, Pp, A2(xA, 0, a));
            case 2:
                var p = A2(rLn, n.a, r.U), g = p.a, w = p.b, k = (X = b(r.hB, p.c)).a && !X.b.$ && 3 === X.b.a.$ ? A3(QFn, r.g8, r.Bb, r.U) : r.eH;
                return v(l = m(r, {
                    eH: k,
                    U: g
                }), A2(Lp, Oqn, w), h);
            case 9:
                var y = A2(YLn, n.a, r.aE), _ = y.b;
                return v(m(r, {
                    aE: y.a
                }), A2(Lp, Xqn, _), h);
            case 3:
                var A = (rn = r.Bb).$ ? Pp : DPn(rn.a);
                return v(r, A, h);
            case 4:
                return v(l = m(r, {
                    g8: Vt(A2(bp, pJ, n.a))
                }), Pp, h);
            case 5:
                var C = n.a;
                if (3 === C.$) {
                    var B = C.a, E = x([
                        A2($A, 3, Jd.l8)
                    ]), D = A2(sc, "", B.Cr), q = A2(AA, da, (nn = r.Bb).$ ? Sa : La({
                        rh: jCn(nn.a)
                    }));
                    return v(r, Vu(x([
                        q,
                        A2(CPn, A2(sc, "", A2(Fp, jCn, r.Bb)), D)
                    ])), E);
                }
                return v(m(r, {
                    u3: !1
                }), Pp, A2(xA, 0, C));
            case 6:
                var F = n.a;
                return 3 === F.$ ? v(m(r, {
                    hK: Vt(F.a)
                }), Pp, h) : v(r, Pp, A2(xA, 0, F));
            case 7:
                var P = A2(yPn, n.a.kE, A3(wFn, r.fL, r.dB, r.Bb));
                return v(P.$ ? r : m(r, {
                    kh: Vt(P.a),
                    eH: h
                }), Pp, h);
            case 8:
                var z = function(n) {
                    var r = n.kh;
                    return r.$ ? v(n, Pp, !1) : A2(mMn, n, r.a);
                }(r), j = z.a, S = z.b, L = v(z.c, j.fL, j.kh);
                if (!L.a || L.b.$ || L.c.$) return v(j, S, h);
                var M = L.b.a, N = L.c.a.kE + 1;
                if (i(N, be(A3(pFn, j.fL, j.dB, j.Bb)))) return function(n) {
                    var r = n.Bb;
                    if (r.$) return v(n, Pp, h);
                    var t = r.a, e = Bx(n.dB), u = jCn(t), a = A2(azn, n, A2(GPn, n.aZ, A4(fzn, XFn(n.bF), n.fL, n.Bb, A2(nzn, n.as, A2(ozn, dzn(n.aE), A2(izn, szn(n.aE), QPn(n.U)))))));
                    return v(m(n, {
                        u3: !0
                    }), A5(SPn, n.gF, e, u, a, qPn), h);
                }(j);
                var H = A2(yPn, N, A3(wFn, j.fL, j.dB, j.Bb));
                if (H.$) return v(j, Pp, h);
                var T = H.a, I = (l = m(j, {
                    kh: Vt(T),
                    eH: h
                }), function() {
                    var n = b(T.rh, r.Bb);
                    if (3 !== n.a || n.b.$) return Pp;
                    var t = n.b.a, e = uU(_Pn(t)), u = A2(Fp, bqn, szn(r.aE));
                    return A5(kFn, l.gF, Bx(l.dB), tPn(t), e, u);
                }());
                return v(l, Vu(x([
                    bzn(mzn),
                    A8($Pn, l.gF, l.dB, l.g8, l.Bb, l.U, l.bF, M, Kqn),
                    I
                ])), h);
            case 10:
                var R = A2(qzn, n.a, r.as);
                return _ = R.b, v(m(r, {
                    as: R.a
                }), A2(Lp, kEn, _), h);
            case 11:
                var Z = A2(QLn, n.a, r.bF);
                return _ = Z.b, v(m(r, {
                    bF: Z.a
                }), A2(Lp, nFn, _), h);
            case 12:
                var V = n.a;
                if (l = m(r, {
                    Y: V
                }), 3 === V.$) {
                    var U = V.a;
                    return v(m(l, {
                        aZ: A2(hMn, yFn(r.U), A2(xMn, U, l.aZ))
                    }), Pp, h);
                }
                return v(l, Pp, A2(xA, 0, V));
            case 13:
                var Y = A2(rO, n.a, r.aZ);
                return I = Y.b, v(m(r, {
                    aZ: Y.a
                }), A2(Lp, xEn, I), h);
            default:
                var Q = n.a, O = n.b, G = FL(r.bP).cx, J = A2(Vzn, O, Q), W = J.a, K = J.b;
                return v(l = m(r, {
                    bP: A3(dN, kPn, A3(aQ, function(n) {
                        return i(APn(n), APn(W));
                    }, function() {
                        return W;
                    }, G), r.bP)
                }), A2(Lp, Wqn(W), K), h);
        }
        var X, nn, rn, tn;
    }), yMn = F2(function(n, r) {
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link"),
                    yB(_A(Sa))
                ]), x([
                    ld(n(Wd.Ea))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(La({
                        rh: jCn(r)
                    })))
                ]), x([
                    ld(pBn(r))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld(n(Jd.l6))
        ]));
    }), _Mn = {
        $: 3
    }, AMn = {
        $: 8
    }, CMn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mx-1 mt-8")
        ]), x([
            A2(Ck, xEn, A3(VG, n, x([
                aO(r.u3),
                iO(r.hJ)
            ]), r.aZ))
        ]));
    }), BMn = function(n) {
        return n.yz;
    }, EMn = function(n) {
        return n.k3;
    }, DMn = A2(CN, AN(1), Vt(4)), qMn = F2(function(n, r) {
        if (r.$) return tB;
        var t = r.a, e = Vt(BMn(t)), u = EMn(t);
        return A2(nk, A2(Yt, Xx("flex flex-col"), gk(DMn)), x([
            A2(Ek, x([
                nH,
                _H(cR)
            ]), x([
                ld("Current recurring bill")
            ])),
            A7(MV, n, u, !0, e, p2, !0, !1)
        ]));
    }), FMn = F5(function(n, r, t, e, u) {
        var a = b(r, A3(OFn, t, e, u));
        if (!a.a.$ && a.b) {
            var i = a.a.a, c = Vt(BMn(i)), o = EMn(i);
            return A2(nk, A2(Yt, Xx("flex flex-col"), gk(DMn)), x([
                A2(Ek, x([
                    nH,
                    _H(cR)
                ]), x([
                    ld("New recurring bill")
                ])),
                A7(MV, n, o, !1, c, p2, !1, !1)
            ]));
        }
        return tB;
    }), PMn = function(n) {
        return n.mW;
    }, zMn = function(n) {
        var r = A2(nv, PMn, n);
        if (r.$) return tB;
        var t = r.a;
        return A2(LV, "Please contact the practice to start this patient sooner", A2(nk, A2(Yt, Xx("flex flex-col"), gk(DMn)), x([
            A2(Ek, x([
                nH,
                _H(cR)
            ]), x([
                ld("Start Date")
            ])),
            ld(A2(NL, aS("/"), t))
        ])));
    }, jMn = F2(function(n, r) {
        return A2(nk, A2(Yt, Xx("flex"), gk(yan)), x([
            A2(qMn, n, r.hK),
            A5(FMn, n, r.fr, r.g8, r.Bb, r.U),
            zMn(r.Bb)
        ]));
    }), SMn = F2(function(n, r) {
        return A2(nk, h, 3 === r.Y.$ ? x([
            A2(Ck, yu, A2(jMn, n, r)),
            A2(CMn, n, r),
            A2(nk, x([
                Xx("text-right mt-6")
            ]), x([
                A2(OC, x([
                    oF,
                    Xdn(!0),
                    EC(_Mn),
                    uF(r.u3)
                ]), x([
                    ld(n(P3))
                ])),
                A2(OC, x([
                    qC,
                    Xdn(!0),
                    EC(AMn),
                    uF(r.u3)
                ]), x([
                    ld(n(Jd.l6))
                ]))
            ]))
        ]) : ck);
    }), LMn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MMn = function(n) {
        return n.qJ;
    }, NMn = {
        zn: !1,
        iX: !1
    }, HMn = F2(function(n, r) {
        return m(r, n.$ ? {
            iX: n.a
        } : {
            zn: n.a
        });
    }), TMn = function(n) {
        return n.vJ;
    }, IMn = function(n) {
        return n.eS;
    }, RMn = function(n) {
        return A2(sc, h, A2(nv, function(n) {
            return 2 === n.$ ? Vt(n.a) : Ut;
        }, n));
    }, ZMn = function(n) {
        return n.w5;
    }, VMn = function(n) {
        return eM(uM(ZMn(n)));
    }, UMn = function(n) {
        return A2(sc, "", A2(nv, function(n) {
            return 1 === n.$ ? Vt(n.a) : Ut;
        }, n));
    }, YMn = F2(function(n, r) {
        if (!TMn(r)) return Ut;
        var t = A2(jzn, n, r);
        switch(IMn(r)){
            case 2:
                return Ut;
            case 0:
                return t.$ || vu(UMn(Vt(t.a.mD))) ? Vt(VMn(r)) : Ut;
            default:
                if (t.$) return Vt(VMn(r));
                var e = RMn(Vt(t.a.mD)), u = A2(ywn, function(n) {
                    return fM(n);
                }, e);
                return TE(e) || u ? Vt(VMn(r)) : Ut;
        }
    }), QMn = function(n) {
        var r = function(n) {
            return n.pe;
        }(n);
        if (r.$) return tB;
        var t = r.a;
        return A2(Ek, x([
            _H(cR)
        ]), x([
            ld(t)
        ]));
    }, OMn = function(n) {
        var r = function(n) {
            return n.q9;
        }(n);
        if (r.$) return tB;
        var t = r.a;
        return A2(Ek, x([
            fq,
            $H,
            _H(fmn)
        ]), x([
            ld(t)
        ]));
    }, GMn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), JMn = F3(function(n, r, t) {
        var e = function(n) {
            return A2(sc, !1, A2(nv, function(n) {
                return n.$ ? Ut : Vt(n.a);
            }, n));
        }(r);
        return A2(zN, x([
            jN(iR),
            KN(x([
                Xx("row--tweak")
            ]))
        ]), x([
            A2(EN, x([
                JI(6),
                jN(bxn)
            ]), x([
                A2(C5, x([
                    $5,
                    D5(A2(pc, GMn(t), cm(!1))),
                    qkn(!e),
                    T5(tzn(!e)),
                    Fkn(n)
                ]), x([
                    ld("No")
                ]))
            ])),
            A2(EN, x([
                JI(6)
            ]), x([
                A2(C5, x([
                    $5,
                    D5(A2(pc, GMn(t), cm(!0))),
                    qkn(e),
                    T5(tzn(e)),
                    Fkn(n)
                ]), x([
                    ld("Yes")
                ]))
            ]))
        ]));
    }), WMn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, KMn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, XMn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rNn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), tNn = F4(function(n, r, t, e) {
        var u = Pzn(e) + "-" + oe(t);
        return A2(nk, x([
            Xx("mb-2 sm:mb-3")
        ]), x([
            vI(x([
                hI(u),
                xI(r),
                gI(A2(rNn, e, t)),
                YT(n),
                XT(XMn(e)),
                nI(nNn(e))
            ]))
        ]));
    }), eNn = F3(function(n, r, t) {
        var e = RMn(r);
        return A2(nk, h, $(A2(he, F2(function(r, e) {
            return A4(tNn, n, e, r, t);
        }), e), x([
            A2(OC, x([
                qC,
                EC(WMn(t))
            ]), x([
                ld("Add condition")
            ])),
            A2(OC, x([
                oF,
                EC(KMn(t))
            ]), x([
                ld("Remove condition")
            ]))
        ])));
    }), uNn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), aNn = F3(function(n, r, t) {
        return vI(x([
            hI(Pzn(t)),
            xI(UMn(r)),
            gI(uNn(t)),
            YT(n),
            XT(XMn(t)),
            nI(nNn(t))
        ]));
    }), iNn = F3(function(n, r, t) {
        var e = A2(Fp, function(n) {
            return n.mD;
        }, rv(A2(Rc, function(n) {
            return i(n.dk, Pzn(t));
        }, r)));
        switch(IMn(t)){
            case 2:
                return A3(JMn, n, e, t);
            case 0:
                return A3(aNn, n, e, t);
            default:
                return A3(eNn, n, e, t);
        }
    }), cNn = F5(function(n, r, t, e, u) {
        var a, i = (a = b(t, A2(YMn, e, u))).a && !a.b.$ ? x([
            a.b.a
        ]) : h;
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(XH, x([
                HH(ZMn(u)),
                VH(TMn(u))
            ]), x([
                QMn(u),
                A3(iNn, r, e, u),
                OMn(u),
                A2(ET, n, i)
            ]))
        ]));
    }), oNn = F3(function(n, r, t) {
        var e = A3(de, HMn, NMn, r);
        return A2(nk, x([
            Hq(gPn(t.ag)),
            Xx("form-input w-full mb-4 md:mb-6")
        ]), x([
            A2(nk, h, A2(Eu, A4(cNn, n, e.zn, e.iX, t.S), MMn(t.ag)))
        ]));
    }), fNn = F3(function(n, r, t) {
        return b(APn(t), A2(Ck, Wqn(t), A3(oNn, n, x([
            LMn(r)
        ]), t)));
    }), sNn = F2(function(n, r) {
        var t = r.fL;
        if (t.$) return tB;
        if (uFn(t.a)) {
            var e = FL(r.bP), u = e.cx, a = A2(bN, 0, e.x);
            return A3(Kq, "div", x([
                Hq("custom-forms"),
                Xx("mt-6")
            ]), A2(Eu, A2(fNn, n, a), u));
        }
        return tB;
    }), lNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dNn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bNn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, vNn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), mNn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), pNn = F2(function(n, r) {
        var t = FL(r.kB).bS;
        if (t.$) return tB;
        var e = t.a;
        if (e.$) {
            var u = e.a;
            return A2(zN, x([
                KN(x([
                    Xx("-mx-1")
                ]))
            ]), x([
                A2(EN, h, x([
                    A2(XH, x([
                        HH(n(kzn))
                    ]), x([
                        vI(x([
                            xI(u),
                            gI(bNn),
                            JT(A3(mNn, r.kB, r.x, 0)),
                            XT(lNn(t)),
                            nI(dNn(t))
                        ]))
                    ])),
                    A2(ET, n, A3(vNn, r.kB, r.x, 0))
                ]))
            ]));
        }
        return tB;
    }), $Nn = F2(function(n, r) {
        return A3(vNn, n.kB, n.x, r);
    }), hNn = F2(function(n, r) {
        var t = function() {
            var t = r.hS;
            if (3 === t.$) {
                var e = $(A2(Eu, function(n) {
                    return A2(hq, h, gMn(n));
                }, t.a), x([
                    A2(hq, h, $zn(""))
                ])), u = n(yzn), a = A2(Yt, Tkn(KPn(r)), A2(Yt, jkn(A3(mNn, r.kB, r.x, 1)), A2(Yt, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(!1), A2(Yt, Lkn(u), r.fA ? x([
                    Skn(!0)
                ]) : h)))), i = TE(e) ? n(_zn) : u;
                return b(a, $(e, x([
                    Nkn(i)
                ])));
            }
            return b(x([
                Lkn(n(wzn)),
                Skn(!0)
            ]), h);
        }(), e = t.a, u = t.b;
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(Ck, pzn, A4(uyn, n, e, u, r.eT)),
            A2(ET, n, A2($Nn, r, 1))
        ]));
    }), gNn = F2(function(n, r) {
        var t, e = FL(r.kB).bS;
        return A2(nk, x([
            Hq(MEn)
        ]), x([
            A2(XH, x([
                HH(n(gzn))
            ]), x([
                A2(Ek, x([
                    _H(cR),
                    $H
                ]), x([
                    ld(n(yzn))
                ])),
                A2(hNn, n, r),
                A2(oR, (t = e, !t.$ && !!t.a.$), A2(pNn, n, r))
            ]))
        ]));
    }), wNn = F2(function(n, r) {
        return A2(cFn, r.dB, r.Bb) ? A2(nk, x([
            Xx("mt-6")
        ]), x([
            A2(Ck, kEn, A2(gNn, n, r.as))
        ])) : tB;
    }), xNn = function(n) {
        return n.tl;
    }, kNn = F2(function(n, r) {
        return A2(nk, x([
            Xx("text-right mt-6")
        ]), x([
            A2(OC, x([
                oF,
                Xdn(!0),
                EC(_Mn),
                uF(r.u3)
            ]), x([
                ld(n(P3))
            ])),
            A2(OC, x([
                qC,
                Xdn(!0),
                EC(AMn),
                uF(r.u3)
            ]), x([
                ld(n(xNn))
            ]))
        ]));
    }), yNn = function(n) {
        return n.jL.zu;
    }, _Nn = function(n) {
        return n.jL.w5;
    }, ANn = function(n) {
        return n.jL.xy;
    }, CNn = F3(function(n, r, t) {
        return A2(nk, x([
            Hq("tobacco-use")
        ]), x([
            A2(XH, x([
                HH(n(_Nn)),
                VH(!0)
            ]), x([
                A2(zN, x([
                    jN(iR),
                    KN(x([
                        Xx("row--tweak")
                    ]))
                ]), x([
                    A2(EN, x([
                        JI(6),
                        jN(bxn)
                    ]), x([
                        A2(C5, x([
                            $5,
                            D5(A2(pc, iu, cm(!1))),
                            qkn(!t.xy),
                            T5(tzn(!t.xy)),
                            Fkn(r)
                        ]), x([
                            ld(n(yNn))
                        ]))
                    ])),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            D5(A2(pc, iu, cm(!0))),
                            qkn(t.xy),
                            T5(tzn(t.xy)),
                            Fkn(r)
                        ]), x([
                            ld(n(ANn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), BNn = F2(function(n, r) {
        var t = r.fL;
        return t.$ ? tB : oFn(t.a) ? A2(nk, h, x([
            A2(nk, h, x([
                A2(Ck, nFn, A3(CNn, n, r.u3, r.bF))
            ]))
        ])) : tB;
    }), ENn = F2(function(n, r) {
        return A2(nk, x([
            Xx("custom-details")
        ]), x([
            A2(wNn, n, r),
            A2(BNn, n, r),
            A2(sNn, n, r),
            A2(kNn, n, r)
        ]));
    }), DNn = F2(function(n, r) {
        return TE(r.eH) ? tB : A2(nk, gk(yan), x([
            A2(ET, n, A2(Eu, function(n) {
                return eM(n);
            }, r.eH))
        ]));
    }), qNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FNn = {
        zn: !1,
        vv: !1
    }, PNn = F2(function(n, r) {
        return m(r, n.$ ? {
            vv: n.a
        } : {
            zn: n.a
        });
    }), zNn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, jNn = function(n) {
        return !Jwn(n);
    }, SNn = F3(function(n, r, t) {
        var e = FL(t.kB);
        if (kjn(e.vB) || !jNn(t.a$.nR)) return tB;
        var u = FL(t.kB), a = u.mk, i = u.xu;
        return A2(nk, h, x([
            A2(zN, x([
                jN(iR)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(HT, x([
                        zT(i),
                        PT(zNn),
                        FT(r)
                    ]), x([
                        ld(n(egn))
                    ]))
                ]))
            ])),
            A2(oR, !i, A2(nk, x([
                Xx("mt-4")
            ]), x([
                A2(Ck, Gqn, A3(Axn, n, x([
                    Gwn(r)
                ]), a))
            ])))
        ]));
    }), LNn = F4(function(n, r, t, e) {
        var u = FL(e.kB).bk;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(tM)),
                    VH(e.a$.he)
                ]), x([
                    A2(Ck, Wzn, A3(mI, n, x([
                        RT(r || t)
                    ]), u))
                ]))
            ]))
        ]));
    }), MNn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, NNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HNn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, TNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, INn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, RNn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), ZNn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), VNn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.pP, a = e.vB;
        return kjn(a) ? tB : A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH("Email"),
                    VH(kjn(a) || Lwn(t.dB)),
                    INn(A2(UEn, t.rh, 7))
                ]), x([
                    vI(x([
                        hI(A2(UEn, t.rh, 7)),
                        xI(u),
                        iI("me@example.com"),
                        gI(A2(pc, TNn, MNn)),
                        JT(A3(RNn, t.kB, t.x, 7)),
                        YT(r),
                        aI(!0),
                        hR("email"),
                        $R("email"),
                        XT(NNn(MNn(u))),
                        nI(HNn(MNn(u))),
                        GT(1)
                    ])),
                    A2(ET, n, A3(ZNn, t.kB, t.x, 7))
                ]))
            ]))
        ]));
    }), UNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YNn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.pU, a = kjn(e.vB);
        return A2(Ck, Xzn, A3(aAn, n, x([
            UNn(r),
            X_n(a)
        ]), u));
    }), QNn = function(n) {
        return n.vJ;
    }, ONn = F3(function(n, r, t) {
        var e = FL(t.kB).qV;
        return x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Hmn.rQ)),
                    VH(QNn(e))
                ]), x([
                    A2(Ck, ajn, A4(dkn, n, x([
                        rkn(r)
                    ]), tkn, e))
                ]))
            ]))
        ]);
    }), GNn = function(n) {
        return n.vJ;
    }, JNn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.we, a = e.qW, i = e.u5;
        return x([
            A2(EN, x([
                JI(12),
                jN(BN),
                kcn(4),
                A2(dR, 2, iR)
            ]), x([
                A2(XH, x([
                    HH(n(Vvn.rQ)),
                    VH(GNn(u))
                ]), x([
                    A2(Ck, bjn, A3(_kn, n, x([
                        $kn(r)
                    ]), u))
                ])),
                A2(Ckn, n, u)
            ])),
            A2(EN, x([
                JI(12),
                jN(BN),
                kcn(4),
                A2(dR, 2, iR)
            ]), x([
                A2(XH, x([
                    HH(n(Tvn.rQ)),
                    VH(QNn(a))
                ]), x([
                    A2(Ck, ujn, A4(dkn, n, x([
                        rkn(r)
                    ]), hkn, a))
                ]))
            ])),
            A2(EN, x([
                JI(12),
                kcn(4)
            ]), x([
                A2(XH, x([
                    HH(n(Rvn.rQ)),
                    VH(QNn(i))
                ]), x([
                    A2(Ck, sjn, A4(dkn, n, x([
                        rkn(r)
                    ]), gkn, i))
                ]))
            ]))
        ]);
    }), WNn = F3(function(n, r, t) {
        return A2(zN, h, Xxn(t.dB) ? A3(JNn, n, r, t) : A3(ONn, n, r, t));
    }), KNn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rHn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tHn = function(n) {
        return n.vJ;
    }, eHn = F4(function(n, r, t, e) {
        var u = FL(e.kB);
        return A2(zN, h, x([
            A2(EN, x([
                bR(2),
                jN(BN),
                A2(dR, 1, iR)
            ]), x([
                A2(XH, x([
                    HH(n(hM)),
                    VH(tHn(u.w5)),
                    Lxn
                ]), x([
                    A2(Ck, mjn, A3(Zxn, n, x([
                        jxn(r)
                    ]), u.w5))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(vM)),
                    VH(!0),
                    Lxn,
                    INn(A2(UEn, e.rh, 0))
                ]), x([
                    vI(x([
                        hI(A2(UEn, e.rh, 0)),
                        xI(u.qB),
                        iI("First"),
                        gI(A2(pc, TNn, KNn)),
                        JT(A3(RNn, e.kB, e.x, 0)),
                        YT(r || t),
                        yR("additional-first-name"),
                        aI(!0),
                        hR("given-name"),
                        $R("given-name"),
                        XT(NNn(KNn(u.qB))),
                        nI(HNn(KNn(u.qB)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n(pM)),
                    Lxn,
                    INn(e.rh + "-middle-name")
                ]), x([
                    vI(x([
                        hI(e.rh + "-middle-name"),
                        xI(u.s2),
                        iI("Middle"),
                        gI(A2(pc, TNn, nHn)),
                        YT(r),
                        yR("additional-middle-name"),
                        hR("additional-name"),
                        $R("additional-name"),
                        aI(!0),
                        XT(NNn(nHn(u.s2))),
                        nI(HNn(nHn(u.s2)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(mM)),
                    VH(!0),
                    Lxn,
                    INn(A2(UEn, e.rh, 1))
                ]), x([
                    vI(x([
                        hI(A2(UEn, e.rh, 1)),
                        xI(u.rS),
                        iI("Last"),
                        gI(A2(pc, TNn, XNn)),
                        JT(A3(RNn, e.kB, e.x, 1)),
                        YT(r || t),
                        yR("additional-last-name"),
                        aI(!0),
                        hR("family-name"),
                        $R("family-name"),
                        XT(NNn(XNn(u.rS))),
                        nI(HNn(XNn(u.rS)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n($M)),
                    Lxn,
                    INn(e.rh + "-suffix")
                ]), x([
                    vI(x([
                        hI(e.rh + "-suffix"),
                        xI(u.wY),
                        gI(A2(pc, TNn, rHn)),
                        YT(r),
                        yR("additional-suffix-name"),
                        hR("honorific-suffix"),
                        $R("honorific-suffix"),
                        aI(!0),
                        XT(NNn(rHn(u.wY))),
                        nI(HNn(rHn(u.wY)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                bR(2)
            ]), h),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(ET, n, A3(ZNn, e.kB, e.x, 0))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), h),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(ET, n, A3(ZNn, e.kB, e.x, 1))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), h)
        ]));
    }), uHn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, aHn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, iHn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, cHn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, oHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fHn = F3(function(n, r, t) {
        var e = FL(t.kB), u = e.aj, a = e.nJ, i = e.nF, c = e.nH, o = e.nG, f = e.nI;
        return A2(nk, h, x([
            A2(zN, x([
                jN(BN)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(HT, x([
                        zT(u),
                        PT(oHn),
                        FT(r)
                    ]), x([
                        ld(n(Dxn))
                    ]))
                ]))
            ])),
            A2(oR, u, A2(zN, h, x([
                A2(EN, x([
                    bR(2),
                    jN(BN),
                    A2(dR, 2, iR)
                ]), x([
                    A2(XH, x([
                        HH(n(zxn)),
                        VH(tHn(a)),
                        Lxn
                    ]), x([
                        A2(Ck, Gzn, A3(Zxn, n, x([
                            jxn(r)
                        ]), a))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(Exn)),
                        VH(!0),
                        Lxn,
                        INn(A2(UEn, t.rh, 3))
                    ]), x([
                        vI(x([
                            hI(A2(UEn, t.rh, 3)),
                            xI(i),
                            iI("First"),
                            gI(A2(pc, TNn, uHn)),
                            JT(A3(RNn, t.kB, t.x, 3)),
                            YT(r),
                            yR("choosen-first-name"),
                            aI(!0),
                            hR("given-name"),
                            $R("given-name"),
                            XT(NNn(uHn(i))),
                            nI(HNn(uHn(i)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Fxn)),
                        Lxn,
                        INn(t.rh + "-chosen-middle-name")
                    ]), x([
                        vI(x([
                            hI(t.rh + "-chosen-middle-name"),
                            xI(c),
                            iI("Middle"),
                            gI(A2(pc, TNn, iHn)),
                            YT(r),
                            yR("choosen-middle-name"),
                            aI(!0),
                            hR("additional-name"),
                            $R("additional-name"),
                            XT(NNn(iHn(c))),
                            nI(HNn(iHn(c)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(qxn)),
                        VH(!0),
                        Lxn,
                        INn(A2(UEn, t.rh, 4))
                    ]), x([
                        vI(x([
                            hI(A2(UEn, t.rh, 4)),
                            xI(o),
                            iI("Last"),
                            gI(A2(pc, TNn, aHn)),
                            JT(A3(RNn, t.kB, t.x, 4)),
                            YT(r),
                            yR("choosen-last-name"),
                            aI(!0),
                            hR("family-name"),
                            $R("family-name"),
                            XT(NNn(aHn(o))),
                            nI(HNn(aHn(o)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Pxn)),
                        Lxn,
                        INn(t.rh + "-chosen-suffix")
                    ]), x([
                        vI(x([
                            hI(t.rh + "-chosen-suffix"),
                            xI(f),
                            gI(A2(pc, TNn, cHn)),
                            YT(r),
                            yR("choosen-suffix"),
                            hR("honorific-suffix"),
                            $R("honorific-suffix"),
                            aI(!0),
                            XT(NNn(cHn(f))),
                            nI(HNn(cHn(f)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(12),
                    bR(3)
                ]), h),
                A2(EN, x([
                    JI(4),
                    bR(3)
                ]), x([
                    A2(ET, n, A3(ZNn, t.kB, t.x, 3))
                ])),
                A2(EN, x([
                    JI(4),
                    bR(3)
                ]), h),
                A2(EN, x([
                    JI(4),
                    bR(3)
                ]), x([
                    A2(ET, n, A3(ZNn, t.kB, t.x, 4))
                ]))
            ])))
        ]));
    }), sHn = F4(function(n, r, t, e) {
        return A2(nk, h, x([
            A4(eHn, n, r, t, e),
            A3(fHn, n, r, e)
        ]));
    }), lHn = F4(function(n, r, t, e) {
        var u = FL(e.kB);
        return kjn(u.vB) ? tB : A4(sHn, n, r, t, e);
    }), dHn = F3(function(n, r, t) {
        var e = jNn(t.a$.nR) ? h : x([
            jN(iR)
        ]), u = jpn(t.dB), a = FL(t.kB), i = a.uy;
        return kjn(a.vB) ? tB : A2(zN, e, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Jj)),
                    VH(i.vJ || u)
                ]), x([
                    A2(nk, x([
                        Xx("mx-1")
                    ]), x([
                        A2(Ck, cjn, A3(Myn, n, x([
                            Eyn(r)
                        ]), i))
                    ]))
                ]))
            ]))
        ]));
    }), bHn = F3(function(n, r, t) {
        if (MPn(t.dB)) {
            var e = FL(t.kB);
            return A2(zN, h, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(Iyn))
                    ]), x([
                        A2(Ck, ojn, A3(Vyn, n, x([
                            Tyn(r)
                        ]), e.uU))
                    ]))
                ]))
            ]));
        }
        return tB;
    }), vHn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, mHn = F2(function(n, r) {
        switch(r){
            case 0:
                return n(Qjn);
            case 1:
                return n(Vjn);
            case 2:
                return n(Ujn);
            default:
                return n(Qj);
        }
    }), pHn = function(n) {
        return 1 === n;
    }, $Hn = function(n) {
        switch(n){
            case 0:
                return "owner";
            case 1:
                return "spouse";
            case 2:
                return "child";
            default:
                return "other";
        }
    }, hHn = F3(function(n, r, t) {
        var e, u = FL(t.kB).vB;
        return kjn(u) ? tB : A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Yjn)),
                    VH(!0)
                ]), x([
                    A2(zN, x([
                        jN(iR),
                        KN(x([
                            Xx("row--tweak")
                        ]))
                    ]), x([
                        A2(EN, x([
                            JI(6),
                            jN(bxn)
                        ]), x([
                            A2(C5, x([
                                $5,
                                D5(A2(pc, A2(pc, TNn, vHn), cm(1))),
                                qkn((e = u, A2(sc, !1, A2(Fp, pHn, e)))),
                                T5($Hn(1)),
                                Fkn(r)
                            ]), x([
                                ld(A2(mHn, n, 1))
                            ]))
                        ])),
                        A2(EN, x([
                            JI(6)
                        ]), x([
                            A2(C5, x([
                                $5,
                                D5(A2(pc, A2(pc, TNn, vHn), cm(2))),
                                qkn(zFn(u)),
                                T5($Hn(2)),
                                Fkn(r)
                            ]), x([
                                ld(A2(mHn, n, 2))
                            ]))
                        ]))
                    ])),
                    A2(ET, n, A3(ZNn, t.kB, t.x, 2))
                ]))
            ]))
        ]));
    }), gHn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, wHn = $B("###-##-####"), xHn = F3(function(n, r, t) {
        if (ZPn(t.a$.n1)) return tB;
        var e, u = FL(t.kB).wG;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH("SSN"),
                    VH((e = t.a$.n1, r$n(e)))
                ]), x([
                    vI(x([
                        hI(A2(UEn, t.rh, 6)),
                        A2(KT, wHn, u),
                        A3(tI, wHn, u, A2(pc, TNn, gHn)),
                        iI("123-12-1234"),
                        JT(A3(RNn, t.kB, t.x, 6)),
                        YT(r),
                        XT(NNn(gHn(u))),
                        nI(HNn(gHn(u))),
                        aI(!0),
                        GT(0)
                    ])),
                    A2(ET, n, A3(ZNn, t.kB, t.x, 6))
                ]))
            ]))
        ]));
    }), kHn = F3(function(n, r, t) {
        var e = A3(de, PNn, FNn, r), u = e.zn, a = e.vv;
        return A2(nk, x([
            Xx("member-input w-full space-y-6")
        ]), x([
            A4(lHn, n, u, a, t),
            A4(LNn, n, u, a, t),
            A3(hHn, n, u, t),
            A3(WNn, n, u, t),
            A3(bHn, n, u, t),
            A3(xHn, n, u, t),
            A3(VNn, n, u, t),
            A3(dHn, n, u, t),
            A3(SNn, n, u, t),
            A3(YNn, n, u, t)
        ]));
    }), yHn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mx-1")
        ]), x([
            A2(Ck, Oqn, A3(kHn, n, x([
                qNn(r.u3)
            ]), r.U))
        ]));
    }), _Hn = F2(function(n, r) {
        return A2(nk, h, x([
            A2(yHn, n, r),
            A2(DNn, n, r),
            A2(kNn, n, r)
        ]));
    }), AHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BHn = function(n) {
        var r = KDn(n.P) && !tln(n.cJ), t = JDn(n.O) && !tln(n.hZ);
        return !(r || t);
    }, EHn = F2(function(n, r) {
        return {
            kL: r,
            uP: n
        };
    }), DHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, FHn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, PHn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jHn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, SHn = {
        zn: !1,
        kp: !1,
        Ax: !1,
        im: Ut
    }, LHn = F2(function(n, r) {
        return m(r, n.$ ? {
            im: n.a
        } : {
            zn: n.a
        });
    }), MHn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, NHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HHn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, THn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, IHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, RHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ZHn = {
        zn: !1,
        hZ: h,
        xz: Ut
    }, VHn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zn: n.a
                });
            case 1:
                return m(r, {
                    xz: n.a
                });
            default:
                return m(r, {
                    hZ: n.a
                });
        }
    }), UHn = function(n) {
        var r, t, e, u, a = (t = Aen(n), e = gen(n) + ", " + _en(n), u = (r = b(vu(e), xen(t))).a || r.b ? tB : iB, A2(nk, h, x([
            A2(ak, h, x([
                ld(e)
            ])),
            u,
            QE(t)
        ]))), i = xen(yen(n)) ? tB : A2(nk, h, x([
            QE(yen(n))
        ])), c = xen(ken(n)) ? tB : A2(nk, h, x([
            QE(ken(n))
        ]));
        return x([
            A2(nk, h, x([
                c,
                i,
                a
            ]))
        ]);
    }, YHn = function(n) {
        if (mqn(n)) return A2(nk, x([
            Xx("radio-card__row signup__subtitle")
        ]), x([
            A2(Ek, x([
                $H,
                fq,
                A2(bvn, 1, 2)
            ]), x([
                ld("Virtual Location")
            ]))
        ]));
        var r = Dcn(n);
        if (r.$) return tB;
        var t = r.a;
        return A2(nk, x([
            Xx("radio-card__row signup__subtitle")
        ]), x([
            A2(Ek, x([
                $H,
                fq,
                A2(bvn, 1, 2)
            ]), x([
                A2(nk, x([
                    Xx("lg:hidden")
                ]), UHn(t)),
                A2(nk, x([
                    Xx("hidden lg:flex")
                ]), x([
                    ld(hvn(t))
                ]))
            ]))
        ]));
    }, QHn = F2(function(n, r) {
        var t = vvn(r);
        if (t.$) return tB;
        var e = t.a;
        return A2(nk, x([
            Xx("flex items-center")
        ]), x([
            A2(PE, x([
                HB,
                MB("fill-gray")
            ]), 10),
            A2(Ek, x([
                $H,
                yF
            ]), x([
                ld(A2(pvn, n, e))
            ]))
        ]));
    }), OHn = F2(function(n, r) {
        return A2(nk, x([
            Xx("radio-card__row")
        ]), x([
            A2(nk, x([
                Xx("lg:flex")
            ]), x([
                A2(Ek, x([
                    O0,
                    fq,
                    A2(bvn, 1, 2)
                ]), x([
                    ld(lvn(r))
                ])),
                A2(nk, x([
                    Xx("lg:ml-2")
                ]), x([
                    A2(QHn, n, r)
                ]))
            ]))
        ]));
    }), GHn = F3(function(n, r, t) {
        var e, u = !(e = r.xz).$ && i(bqn(e.a), bqn(t));
        return A2(nk, x([
            Xx("radio-card"),
            SC(x([
                b("radio-card--selected", u),
                b("radio-card--disabled", r.zn)
            ])),
            IC(t)
        ]), x([
            A2(nk, x([
                Xx("radio-card__radio")
            ]), x([
                A2(C5, x([
                    qkn(u),
                    D5(A2(pc, iu, cm(t))),
                    Fkn(r.zn)
                ]), h)
            ])),
            A2(nk, x([
                Xx("radio-card__content")
            ]), x([
                A2(OHn, n, t),
                YHn(t)
            ]))
        ]));
    }), JHn = F2(function(n, r) {
        var t = A3(de, VHn, ZHn, r);
        return A2(nk, h, A2(Eu, A2(GHn, n, t), t.hZ));
    }), WHn = {
        zn: !1,
        kp: !1,
        hI: !1,
        Ax: !1,
        hZ: h,
        im: Ut,
        cJ: h,
        dO: Ut,
        lv: Ut,
        cQ: Ut
    }, KHn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zn: n.a
                });
            case 1:
                return m(r, {
                    cQ: n.a
                });
            case 2:
                return m(r, {
                    cJ: n.a
                });
            case 3:
                return m(r, {
                    dO: n.a
                });
            case 4:
                return m(r, {
                    lv: n.a
                });
            case 5:
                return m(r, {
                    hZ: n.a
                });
            case 6:
                return m(r, {
                    Ax: n.a
                });
            case 7:
                return m(r, {
                    kp: n.a
                });
            case 8:
                return m(r, {
                    im: n.a
                });
            default:
                return m(r, {
                    hI: n.a
                });
        }
    }), XHn = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;){
            if (t.a.$) {
                if (1 === t.b.$) return !0;
                break n;
            }
            if (t.b.$) break n;
            var e = t.b.a;
            return i(czn(t.a.a.uP), czn(e.uP));
        }
        return !1;
    }), nTn = function(n) {
        n: for(;;){
            if (n.b) {
                if (1 === n.a.$) {
                    n = n.b;
                    continue n;
                }
                return Vt(n.a.a);
            }
            return Ut;
        }
    }, rTn = F2(function(n, r) {
        return A2(nv, rv, A2(Fp, function(r) {
            return A2(Rc, function(n) {
                return i(bqn(n), r);
            }, n);
        }, A2(Fp, wLn, rv(r.uP.hZ))));
    }), tTn = F4(function(n, r, t, e) {
        return nTn(x([
            n ? r : Ut,
            e.kL,
            rv(t),
            A2(rTn, t, e)
        ]));
    }), eTn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = A2(yLn, Vt(u), r.hZ), i = A2(XHn, r.cQ, Vt(u));
            return A2(Ck, RLn, A3(wmn, n, {
                kL: A4(tTn, i, r.dO, a, u),
                xO: !0
            }, e));
        }
        return tB;
    }), uTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aTn = function(n) {
        var r = n.$ ? "no-preference" : czn(n.a);
        return A2(fe, "-", x([
            "practitioner-card",
            r
        ]));
    }, iTn = F2(function(n, r) {
        var t = b(n, r);
        if (t.a.$ || t.b.$) return !1;
        var e, u, a = t.a.a, i = t.b.a, c = !(u = $mn(a)).$ && 0 > s(i, u.a), o = !(e = pmn(a)).$ && s(i, e.a) > 0;
        return c || o;
    }), cTn = F4(function(n, r, t, e) {
        var u = A2(Eu, function(n) {
            return A2(hq, h, n);
        }, A2(yLn, e, r.hZ));
        return be(u) > 1 ? A2(nk, x([
            Xx("card card--selected card--slide-down flex -mt-4 mb-4 py-6 rounded-t-none border-t-0")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col flex-grow ml-8 mr-2")
            ]), x([
                A2(XH, x([
                    HH(n(kD)),
                    VH(!0),
                    exn(n(wD))
                ]), x([
                    A2(Ck, HLn, A4(sF, n, x([
                        Dq(r.dO),
                        xq(n(AD)),
                        AR(r.zn),
                        Nxn(r.Ax)
                    ]), u, t))
                ]))
            ]))
        ])) : tB;
    }), oTn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, fTn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sTn = F2(function(n, r) {
        return r.r8(n);
    }), lTn = F2(function(n, r) {
        return r > 1 ? A2(nk, x([
            Xx("tag tag--subdued tag--small")
        ]), x([
            A2(Ek, x([
                $H,
                fq,
                A2(bvn, 1, 2)
            ]), x([
                ld(n(sTn(oe(r - 1))))
            ]))
        ])) : tB;
    }), dTn = F5(function(n, r, t, e, u) {
        return A2(sc, tB, A2(Fp, function(e) {
            return A2(nk, x([
                Xx("radio-card__row signup__subtitle")
            ]), x([
                A2(nk, x([
                    Xx("flex")
                ]), x([
                    A2(nk, x([
                        Xx("flex flex-grow")
                    ]), x([
                        A2(Ek, x([
                            $H,
                            fq,
                            A2(bvn, 1, 2)
                        ]), x([
                            ld(A2(pqn, n, e))
                        ]))
                    ])),
                    A2(nk, x([
                        SC(x([
                            b("hidden", r)
                        ]))
                    ]), x([
                        A2(lTn, n, be(t))
                    ]))
                ]))
            ]));
        }, nTn(x([
            e,
            u.kL,
            A2(rTn, t, u)
        ]))));
    }), bTn = function(n) {
        return n.pl;
    }, vTn = F2(function(n, r) {
        var t = b(bTn(n), bTn(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(Ju, t.a.a, t.b.a);
    }), mTn = F2(function(n, r) {
        if (r.$) return function(n) {
            return A2(sc, Ut, A2(Fp, bTn, rv(A2(eq, vTn, kLn(n)))));
        }(n);
        var t = r.a;
        return A2(sc, Ut, A2(Fp, bTn, rv(A2(Rc, function(n) {
            return i(wLn(n), t);
        }, kLn(n)))));
    }), pTn = F4(function(n, r, t, e) {
        var u = x(r ? [
            aq
        ] : [
            fq,
            A2(bvn, 1, 2)
        ]), a = A2(mTn, e, t);
        if (a.$) return tB;
        var i = a.a;
        return A2(nk, x([
            Xx("flex items-center")
        ]), x([
            A2(ak, x([
                Xx("mr-1 -mt-1")
            ]), x([
                A2(PE, x([
                    HB,
                    MB("fill-gray")
                ]), 10)
            ])),
            A2(Ek, A2(Yt, $H, u), x([
                ld(A2(pvn, n, i))
            ]))
        ]));
    }), $Tn = F5(function(n, r, t, e, u) {
        var a = A2(Fp, function(n) {
            return n.uP;
        }, e), i = A2(sc, "No preference", A2(Fp, MP, a)), c = A2(Fp, A3(pTn, n, !1, r ? t.lv : Ut), a);
        return A2(nk, h, x([
            A2(nk, x([
                Xx("radio-card__row")
            ]), x([
                A2(nk, x([
                    Xx("lg:flex")
                ]), x([
                    A2(Ek, x([
                        O0,
                        fq,
                        A2(bvn, 1, 2)
                    ]), x([
                        ld(i)
                    ])),
                    A2(nk, x([
                        Xx("lg:ml-2")
                    ]), x([
                        A2(sc, tB, c)
                    ]))
                ]))
            ])),
            function() {
                var n = b(a, u);
                if (!n.a.$ && n.b) {
                    var r = n.a.a;
                    return A2(Ek, x([
                        $H,
                        fq
                    ]), x([
                        ld(A3(hmn, $mn(r), pmn(r), !0))
                    ]));
                }
                return tB;
            }()
        ]));
    }), hTn = F5(function(n, r, t, e, u) {
        return A2(nk, x([
            IC(u)
        ]), x([
            A5($Tn, n, r, t, e, !1),
            A2(nk, x([
                Xx("radio-card__row signup__subtitle")
            ]), x([
                A2(Ek, x([
                    $H,
                    fq,
                    A2(bvn, 1, 2)
                ]), x([
                    ld("No provider will be assigned at this time")
                ]))
            ]))
        ]));
    }), gTn = function(n) {
        return n.q.me;
    }, wTn = function(n) {
        return n.q.mf;
    }, xTn = function(n) {
        return n.q.pQ;
    }, kTn = function(n) {
        return n.q.pR;
    }, yTn = function(n) {
        return n.q.p5;
    }, _Tn = function(n) {
        return n.q.qC;
    }, ATn = function(n) {
        return n.q.qD;
    }, CTn = function(n) {
        return n.q.ru;
    }, BTn = function(n) {
        return n.q.rv;
    }, ETn = function(n) {
        return n.q.AK;
    }, DTn = function(n) {
        return n.q.rM;
    }, qTn = function(n) {
        return n.q.rN;
    }, FTn = function(n) {
        return n.q.rT;
    }, PTn = function(n) {
        return n.q.rU;
    }, zTn = function(n) {
        return n.q.t_;
    }, jTn = function(n) {
        return n.q.ux;
    }, STn = function(n) {
        return n.q.va;
    }, LTn = function(n) {
        return n.q.v6;
    }, MTn = function(n) {
        return n.q.wS;
    }, NTn = function(n) {
        return n.q.wX;
    }, HTn = function(n) {
        return n.q.dY;
    }, TTn = F7(function(n, r, t, e, u, a, i) {
        var c = uTn(a);
        if (a.$) return A5(hTn, n, t, r, a, c);
        var o = a.a;
        return A2(nk, x([
            Xx("flex flex-row w-full")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col mr-4"),
                IC(c)
            ]), x([
                A2(amn, !1, o.uP)
            ])),
            A2(nk, x([
                Xx("flex flex-col flex-grow"),
                IC(c)
            ]), x([
                A5($Tn, n, t, r, a, i),
                nmn(o.uP),
                A5(dTn, n, t, e, u, o)
            ])),
            i ? tB : A2(nk, x([
                Xx("flex flex-col justify-center ml-4 mr-2 gap-2")
            ]), A2(Yt, A2(OC, x([
                oF,
                EC(fTn(o)),
                Xdn(!0)
            ]), x([
                ld(n(AI))
            ])), r.hI || "full_waitlisting" !== eMn(o.uP) ? h : x([
                A2(OC, x([
                    qC,
                    EC(oTn(o.uP)),
                    Xdn(!0)
                ]), x([
                    ld(n(ETn))
                ]))
            ])))
        ]));
    }), ITn = F7(function(n, r, t, e, u, a, i) {
        var c = uTn(a);
        if (a.$) return A5(hTn, n, t, r, a, c);
        var o = a.a;
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex flex-row mb-6"),
                IC(c)
            ]), x([
                A2(nk, x([
                    Xx("flex flex-shrink-0 mr-4")
                ]), x([
                    A2(amn, !1, o.uP)
                ])),
                A2(nk, x([
                    Xx("flex flex-col flex-grow")
                ]), x([
                    A5($Tn, n, t, r, a, i)
                ]))
            ])),
            A2(nk, x([
                Xx("mb-4")
            ]), x([
                Dk
            ])),
            A2(nk, x([
                Xx("flex flex-col pr-2"),
                IC(c)
            ]), x([
                nmn(o.uP),
                A5(dTn, n, t, e, u, o)
            ])),
            A2(nk, x([
                Xx("mt-4")
            ]), x([
                A2(OC, x([
                    oF,
                    EC(fTn(o))
                ]), x([
                    ld(n(AI))
                ]))
            ]))
        ]));
    }), RTn = F7(function(n, r, t, e, u, a, i) {
        return A2(nk, x([
            Xx("radio-card__content")
        ]), x([
            A2(nk, x([
                Xx("lg:hidden")
            ]), x([
                A7(ITn, n, r, t, e, u, a, i)
            ])),
            A2(nk, x([
                Xx("hidden lg:flex")
            ]), x([
                A7(TTn, n, r, t, e, u, a, i)
            ]))
        ]));
    }), ZTn = F4(function(n, r, t, e) {
        var u = t.fl, a = A2(Fp, function(n) {
            return n.uP;
        }, e), i = A2(yLn, e, r.hZ), c = A2(XHn, r.cQ, e), o = be(i) > 1 && c, f = A2(nv, A3(tTn, c, r.dO, i), e), s = A2(iTn, a, r.im);
        return A2(nk, x([
            Hq(aTn(a))
        ]), x([
            A2(nk, x([
                Xx("radio-card"),
                SC(x([
                    b("radio-card--selected", c),
                    b("radio-card--disabled", r.zn || s),
                    b("radio-card--top", o)
                ]))
            ]), x([
                A2(nk, x([
                    Xx("radio-card__radio")
                ]), x([
                    A2(C5, x([
                        qkn(c),
                        D5(A2(pc, uTn, cm(e))),
                        Fkn(r.zn || s)
                    ]), h)
                ])),
                A7(RTn, n, r, c, i, f, e, s)
            ])),
            o && !s ? A4(cTn, n, r, u, e) : tB
        ]));
    }), VTn = F3(function(n, r, t) {
        var e = function() {
            var n = b(r.kp, r.cQ);
            if (n.a && !n.b.$) {
                var t = n.b.a;
                return b(A2(Rc, function(n) {
                    return !i(czn(n.uP), czn(t.uP));
                }, r.cJ), x([
                    r.cQ
                ]));
            }
            return b(r.cJ, h);
        }(), u = e.a, a = e.b, c = $(t.j3 ? x([
            Ut
        ]) : h, A2(Eu, function(n) {
            return Vt(n);
        }, u));
        return A2(Eu, A3(ZTn, n, r, t), $(a, c));
    }), UTn = F3(function(n, r, t) {
        var e = A3(de, KHn, WHn, r);
        return A2(nk, h, A2(Yt, A3(eTn, n, e, t.bz), A3(VTn, n, e, t)));
    }), YTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QTn = {
        $: 12
    }, OTn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, GTn = function(n) {
        return n.vc.Dd;
    }, JTn = {
        $: 2
    }, WTn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, KTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XTn = x([
        KTn(1),
        KTn(5),
        KTn(10),
        KTn(20)
    ]), nIn = A2(Yt, A2(hq, h, Vt({
        $: 2
    })), A2(Yt, A2(hq, h, Vt(Tqn)), A2(Yt, pq, A2(Eu, function(n) {
        return A2(hq, h, Vt(n));
    }, XTn)))), rIn = F4(function(n, r, t, e) {
        return A2(zN, x([
            jN(iR),
            KN(x([
                Xx("row--tweak")
            ]))
        ]), x([
            A2(EN, x([
                bR(6)
            ]), x([
                A2(Ck, jLn, A4(sF, n, x([
                    Dq(Vt(e.av)),
                    vq,
                    xq("Filter by distance"),
                    AR(t)
                ]), nIn, e.fD))
            ])),
            A2(EN, x([
                bR(6)
            ]), x([
                function() {
                    if (e.av.$) return tB;
                    var n = r || !wgn(e.x0);
                    return A2(nk, x([
                        Xx("sm:mt-0 mt-2")
                    ]), x([
                        Tln(x([
                            Hln(x([
                                ld("ZIP:")
                            ])),
                            vI(x([
                                xI(e.x0),
                                gI(WTn),
                                JT(n)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), tIn = F4(function(n, r, t, e) {
        var u = A2(Yt, A2(hq, h, oqn(PLn)), A2(Yt, pq, A2(Eu, hq(h), A2(Eu, function(n) {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }({
                rh: bqn(n),
                tg: lvn(n)
            });
        }, r))));
        return A2(Ck, BLn, A4(sF, n, x([
            Dq(Vt(t)),
            vq,
            xq(n(fqn))
        ]), u, e));
    }), eIn = F4(function(n, r, t, e) {
        var u = e.e0, a = e.kL, i = e.kq, c = e.dC, o = e.eM, f = e.eN, s = be(t) > 1, l = !o && s, d = l || s ? BN : iR, v = l ? 8 : 12;
        return A2(zN, x([
            PAn,
            QTn,
            KN(x([
                Xx("mx-0")
            ]))
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JTn
                    ]), x([
                        A2(zN, x([
                            jN(d),
                            KN(x([
                                SC(x([
                                    b("hidden", f)
                                ]))
                            ]))
                        ]), x([
                            A2(EN, x([
                                JI(12)
                            ]), x([
                                vI(x([
                                    iI(n(GTn)),
                                    xI(c),
                                    gI(YTn),
                                    OTn(15)
                                ]))
                            ]))
                        ])),
                        A2(zN, x([
                            jN(iR)
                        ]), x([
                            A2(EN, x([
                                kcn(4),
                                jN(BN),
                                A2(dR, 2, iR),
                                KN(x([
                                    SC(x([
                                        b("hidden", !l)
                                    ]))
                                ]))
                            ]), x([
                                A4(tIn, n, t, a, u)
                            ])),
                            A2(EN, x([
                                kcn(v),
                                KN(x([
                                    SC(x([
                                        b("hidden", !s)
                                    ]))
                                ]))
                            ]), x([
                                A2(Ck, ALn, A4(rIn, n, !1, r, i))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), uIn = F4(function(n, r, t, e) {
        return A2(Ck, eLn, A4(eIn, n, r, t, e));
    }), aIn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iIn = F3(function(n, r, t) {
        if (BHn(t)) {
            var e = bMn(t), u = dzn(t), a = A3(de, LHn, SHn, r), i = gLn(t), c = szn(t), o = a.zn || !BHn(t);
            return A2(nk, h, x([
                A4(uIn, n, o, oLn(t), t.av),
                function() {
                    var r, f = t.fI;
                    switch(f.$){
                        case 0:
                            var s = f.a;
                            if (TE(e) && !Lqn(t.P)) return A2(Ek, h, x([
                                ld("No providers found")
                            ]));
                            var l = A2(Fp, function(n) {
                                return A2(EHn, n, Ut);
                            }, u);
                            return A2(nk, h, x([
                                A2(Ck, iLn, A3(UTn, n, x([
                                    qHn(o),
                                    IHn(l),
                                    NHn(e),
                                    HHn(c),
                                    THn(t.lv),
                                    jHn(i),
                                    PHn(a.Ax || !TE(t.eH)),
                                    FHn(a.kp),
                                    MHn(a.im)
                                ]), s)),
                                (r = t.k7, A2(Ck, aIn, A2(Unn, h, r)))
                            ]));
                        case 1:
                            return TE(i) && JDn(t.O) ? A2(Ek, h, x([
                                ld("No locations found")
                            ])) : A2(Ck, uLn, A2(JHn, n, x([
                                DHn(o),
                                zHn(i),
                                RHn(c)
                            ])));
                        default:
                            return tB;
                    }
                }()
            ]));
        }
        return A2(nk, h, ck);
    }), cIn = F2(function(n, r) {
        var t = A2(nv, qFn, A2(nv, function(n) {
            return A2(DFn, n, r.U);
        }, r.g8));
        return BHn(r.aE) ? A2(nk, x([
            Xx("mt-6")
        ]), x([
            A2(Ck, Xqn, A3(iIn, n, x([
                AHn(r.u3),
                CHn(t)
            ]), r.aE)),
            A2(DNn, n, r),
            A2(kNn, n, r)
        ])) : A2(nk, h, ck);
    }), oIn = F2(function(n, r) {
        var t = A2(Fp, function(n) {
            return n.rh;
        }, r.kh);
        if (t.$) return A2(nk, h, ck);
        switch(t.a){
            case 0:
                return A2(_Hn, n, r);
            case 1:
                return A2(ENn, n, r);
            case 2:
                return A2(cIn, n, r);
            default:
                return A2(SMn, n, r);
        }
    }), fIn = function(n) {
        var r = n.kh;
        if (r.$) return tB;
        var t = r.a;
        return A2(Ak, x([
            _H(fO),
            _H(_cn)
        ]), x([
            ld(A2(hFn, n.fL, t.rh))
        ]));
    }, sIn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, lIn = F3(function(n, r, t) {
        return {
            zn: t,
            kE: r,
            rQ: n
        };
    }), dIn = F3(function(n, r, t) {
        return A2(Eu, function(n) {
            return A3(lIn, n.rQ, n.kE, !1);
        }, A3(wFn, n, r, t));
    }), bIn = F3(function(n, r, t) {
        var e = n.aX, u = n.a5, a = oe(t.kE + 1), c = t.zn ? {
            eu: A2(ak, x([
                Xx("stepper__circle")
            ]), x([
                ld(a)
            ])),
            fO: "disabled",
            fP: ld(t.rQ)
        } : i(t.kE, e) ? {
            eu: A2(ak, x([
                Xx("stepper__circle")
            ]), x([
                ld(a)
            ])),
            fO: "current",
            fP: ld(t.rQ)
        } : 0 > s(t.kE, e) ? {
            eu: A2(fB, x([
                Xx("stepper__circle"),
                r
            ]), x([
                A2(PE, h, 13)
            ])),
            fO: "previous",
            fP: A2(fB, x([
                r
            ]), x([
                ld(t.rQ)
            ]))
        } : {
            eu: A2(ak, x([
                Xx("stepper__circle")
            ]), x([
                ld(a)
            ])),
            fO: "next",
            fP: ld(t.rQ)
        };
        return A2(nk, x([
            Xx("stepper__step stepper__step--" + c.fO)
        ]), x([
            c.eu,
            A2(ak, x([
                Xx("stepper__text")
            ]), x([
                c.fP
            ])),
            A2(oR, 0 > s(t.kE + 1, u), A2(ak, x([
                Xx("stepper__line")
            ]), x([
                Dk
            ])))
        ]));
    }), vIn = F3(function(n, r, t) {
        return A3(bIn, {
            aX: n.aX,
            a5: n.a5
        }, IC(r(t)), t);
    }), mIn = F2(function(n, r) {
        var t = n.A1, e = n.DV;
        if (TE(e)) return tB;
        if (t.$) return tB;
        var u = t.a;
        return A2(nk, x([
            Xx("stepper")
        ]), A2(Eu, A2(vIn, {
            aX: u,
            a5: be(e)
        }, r), e));
    }), pIn = F4(function(n, r, t, e) {
        return n.$ ? tB : A2(mIn, {
            A1: Vt(n.a.kE),
            DV: A3(dIn, r, t, e)
        }, sIn);
    }), $In = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("text-left"),
            Hq(mzn)
        ]), x([
            A2(yMn, n, t),
            Dk,
            A4(pIn, r.kh, r.fL, r.dB, r.Bb),
            A2(Ck, yu, fIn(r)),
            A2(oIn, n, r)
        ]));
    }), hIn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.Bb, t.$ ? ck : x([
                    A3($In, n, r, t.a)
                ])))
            ]),
            w5: n(Jd.w5)
        };
    }), gIn = ZA({
        Ar: Uqn,
        AQ: Yqn,
        Db: Qqn,
        DZ: function(n) {
            return Px(x([
                A2(_S, Oqn, Jqn),
                A2(_S, xEn, yY(n.aZ))
            ]));
        },
        En: kMn,
        Et: hIn
    }), wIn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xIn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kIn = F5(function(n, r, t, e, u) {
        return {
            oq: n,
            qA: t,
            sB: e,
            tk: u,
            uC: r
        };
    }), yIn = A3(ly, "name", C$, uu(function(n) {
        return {
            tg: n
        };
    })), _In = A2(Pk, yIn, uu(iu)), AIn = A3(ly, "next_future_unpaid_bill", ydn, A3(ly, "membership_patients", vy(dCn), A3(ly, "first_bill", ydn, A3(ly, "plan", _In, A3(ly, "contract_end_date", iy(ay), uu(kIn)))))), CIn = A2(Pk, AIn, uu(iu)), BIn = F2(function(n, r) {
        return A2(X_, x([
            "contracts",
            r
        ]), lL(n));
    }), EIn = F4(function(n, r, t, e) {
        return A4(W_, n, CIn, e, rA(A2(BIn, r, t)));
    }), DIn = F3(function(n, r, t) {
        return b({
            gF: r.gF,
            ez: vc,
            g8: Ut,
            kA: r.kA,
            e4: wCn,
            dB: n,
            xd: t.Ck.rh,
            xs: t
        }, Vu(x([
            A2(Nu, xIn, IF),
            A4(EIn, r.gF, Bx(n), t.Ck.rh, wIn)
        ])));
    }), qIn = F2(function(n, r) {
        return b(r, Pp);
    }), FIn = F2(function(n, r) {
        return m(r, {
            x6: Vt(2),
            gF: n.gF
        });
    }), PIn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zIn = F4(function(n, r, t, e) {
        return A4(bL, n, CIn, e, rA(A2(X_, x([
            "renew"
        ]), A2(BIn, r, t))));
    }), jIn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 2 === t.$ && 5 === t.a.$ && 400 === t.a.a ? v(r, A2(AA, da, Sa), h) : v(m(r, {
                    ez: t
                }), Pp, A2(xA, 0, t));
            case 1:
                return v(r, 3 === r.ez.$ ? A4(zIn, r.gF, Bx(r.dB), r.xd, PIn) : Pp, h);
            case 2:
                var e = n.a, u = Ul(x([
                    b("renewedMembershipId", r.xd)
                ]));
                return v(r, A2(AA, u, Sa), A2(xA, 0, e));
            case 3:
                return v(m(r, {
                    g8: Vt(A2(bp, pJ, n.a))
                }), Pp, h);
            default:
                return v(r, Pp, h);
        }
    }), SIn = {
        $: 1
    }, LIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, MIn = function(n) {
        return n.oq;
    }, NIn = function(n) {
        return A2(NL, aS("/"), n);
    }, HIn = function(n) {
        return n.tg;
    }, TIn = function(n) {
        return n.uC;
    }, IIn = function(n) {
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Sa))
                ]), x([
                    ld(n(Wd.Ea))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld("Renew membership")
        ]));
    }, RIn = F3(function(n, r, t) {
        var e = bBn(t.tk), u = t.sB, a = FAn(function(n) {
            return n.qA;
        }(t));
        return A2(nk, x([
            Xx("text-left mb-5")
        ]), x([
            IIn(r),
            Dk,
            A2(Ak, x([
                _H(fO)
            ]), x([
                ld("Renew your membership")
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(Ek, x([
                        _H(FO)
                    ]), x([
                        A2(X8, h, x([
                            ld("Plan Name")
                        ]))
                    ])),
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(HIn(TIn(t)))
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(Ek, x([
                        _H(FO)
                    ]), x([
                        A2(X8, h, x([
                            ld("Membership ending")
                        ]))
                    ])),
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(A2(sc, "N/A", A2(Fp, NIn, MIn(t))))
                    ]))
                ]))
            ])),
            A2(Ck, LIn, A5(TBn, !1, n.e4, r, u, n.g8)),
            A3(ZBn, r, Vt(e), a),
            A2(OC, x([
                qC,
                EC(SIn)
            ]), x([
                ld(r(Wd.vF))
            ]))
        ]));
    }), ZIn = F2(function(n, r) {
        return {
            gN: function() {
                var t = r.ez;
                if (3 === t.$) {
                    var e = t.a;
                    return x([
                        A2(nk, x([
                            Xx("panel")
                        ]), x([
                            A3(RIn, r, n, e)
                        ]))
                    ]);
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), VIn = ZA({
        Ar: DIn,
        AQ: qIn,
        Db: FIn,
        DZ: function() {
            return zx;
        },
        En: jIn,
        Et: ZIn
    }), UIn = F3(function(n, r, t) {
        var e, u = 3 === (e = r.uN).$ ? KG(e.a) : XG(n);
        return A2(AA, t.iF, u ? ka : Wa);
    }), YIn = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            t6: r.t6,
            dB: n,
            xs: t.CS
        }, A3(UIn, n, r, t));
    }), QIn = F2(function(n, r) {
        return b(r, Pp);
    }), OIn = F2(function(n, r) {
        return r;
    }), GIn = F2(function(n, r) {
        return v(r, Pp, h);
    }), JIn = F2(function(n, r) {
        return {
            gN: ck,
            w5: Ex(r.dB)
        };
    }), WIn = ZA({
        Ar: YIn,
        AQ: QIn,
        Db: OIn,
        DZ: function() {
            return zx;
        },
        En: GIn,
        Et: JIn
    }), KIn = F3(function(n, r, t) {
        var e, u = 3 === (e = r.uN).$ ? KG(e.a) : XG(n);
        return A2(AA, t.iF, u ? ka : Wa);
    }), XIn = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            t6: r.t6,
            dB: n,
            xs: t.CS
        }, A3(KIn, n, r, t));
    }), nRn = F2(function(n, r) {
        return b(r, Pp);
    }), rRn = F2(function(n, r) {
        return r;
    }), tRn = F2(function(n, r) {
        return v(r, Pp, h);
    }), eRn = F2(function(n, r) {
        return {
            gN: ck,
            w5: Ex(r.dB)
        };
    }), uRn = ZA({
        Ar: XIn,
        AQ: nRn,
        Db: rRn,
        DZ: function() {
            return zx;
        },
        En: tRn,
        Et: eRn
    }), aRn = function(n) {
        return b(n, Pp);
    }, iRn = function(n) {
        return {
            Ar: F2(function(n, r) {
                return v(r, Pp, h);
            }),
            AQ: cm(A2(ru, iu, aRn)),
            Db: cm(iu),
            DZ: function() {
                return zx;
            },
            En: F2(function(n, r) {
                return v(r, Pp, h);
            }),
            Et: n.Et
        };
    }, cRn = iRn({
        Et: function() {
            return {
                gN: x([
                    A2(nk, x([
                        Xx("panel")
                    ]), x([
                        A2(Ak, x([
                            _H(fO)
                        ]), x([
                            ld("Page Not Found")
                        ])),
                        A2(ak, x([
                            Xx("text-support")
                        ]), x([
                            A2(fB, x([
                                Xx("link"),
                                yB(_A(Wa))
                            ]), x([
                                ld("Click here")
                            ]))
                        ])),
                        A2(ak, h, x([
                            ld(" to go to your member portal home page.")
                        ]))
                    ]))
                ]),
                w5: "404"
            };
        }
    }), oRn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fRn = F5(function(n, r, t, e, u) {
        return {
            qm: u,
            tZ: n,
            t6: t,
            uV: e,
            wO: r
        };
    }), sRn = A2(tu, iu, A3(ly, "name", C$, uu(function(n) {
        return {
            tg: n
        };
    }))), lRn = A2(tu, iu, A4(sy, "expires_at", aL(ay), Ut, A3(ly, "prepaid_charges", vy(gAn), A3(ly, "patient", sRn, A3(ly, "status", C$, A3(ly, "package_name", C$, uu(fRn))))))), dRn = F2(function(n, r) {
        return A2(X_, x([
            "patient_packages",
            r
        ]), lL(n));
    }), bRn = F4(function(n, r, t, e) {
        return A4(W_, n, lRn, e, rA(A2(dRn, r, t)));
    }), vRn = F3(function(n, r, t) {
        var e = t.Ck, u = Bx(n), a = {
            gF: r.gF,
            cw: yq,
            kA: r.kA,
            k6: e.rh,
            ip: Ut,
            dB: n,
            CD: u
        };
        return b(a, function(n) {
            return A4(bRn, n.gF, n.CD, n.k6, oRn);
        }(a));
    }), mRn = F2(function(n, r) {
        return b(r, Pp);
    }), pRn = F2(function(n, r) {
        return m(r, {
            x6: Vt(2)
        });
    }), $Rn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return v(m(r, {
                cw: A2(A2(Cq, t, r.cw) ? mZ : _q, t, r.cw)
            }), Pp, h);
        }
        var e = n.a;
        return 3 === e.$ ? v(m(r, {
            ip: Vt(e.a)
        }), Pp, h) : v(r, Pp, A2(xA, 0, e));
    }), hRn = F2(function(n, r) {
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-support")
            ]), x([
                A2(fB, x([
                    Xx("link text-current"),
                    yB(_A(Sa))
                ]), x([
                    ld(n(Wd.Ea))
                ]))
            ])),
            A2(ak, x([
                Xx("mx-3 text-support")
            ]), x([
                ld("/")
            ])),
            ld(r)
        ]));
    }), gRn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wRn = F2(function(n, r) {
        return r.tX(n);
    }), xRn = F3(function(n, r, t) {
        var e = oe(t.vg), u = "  " + n(wRn(e)), a = t.ry, i = A2(fp, "MM/dd/yyyy", function(n) {
            return n.tC;
        }(t));
        return A2(nk, x([
            Xx("text-support mt-2"),
            A2(bT, "display", "flex"),
            A2(bT, "align-items", "flex-start")
        ]), x([
            A2(nk, x([
                A2(bT, "display", "flex"),
                A2(bT, "flex-direction", "column"),
                A2(bT, "align-items", "center"),
                A2(bT, "margin-right", "10px"),
                A2(bT, "padding-top", "6px")
            ]), x([
                A2(nk, x([
                    A2(bT, "width", "6px"),
                    A2(bT, "height", "6px"),
                    A2(bT, "border-radius", "50%"),
                    A2(bT, "background-color", "currentColor"),
                    A2(bT, "opacity", "0.4"),
                    A2(bT, "flex-shrink", "0")
                ]), h),
                r ? A2(nk, x([
                    A2(bT, "width", "1px"),
                    A2(bT, "flex", "1"),
                    A2(bT, "background-color", "currentColor"),
                    A2(bT, "opacity", "0.3"),
                    A2(bT, "margin-bottom", "-30px")
                ]), h) : tB
            ])),
            A2(ak, h, x([
                a.$ ? ld(i) : A2(fB, x([
                    yB(_A(Da({
                        rh: a.a
                    }))),
                    Xx("link"),
                    A2(bT, "text-decoration", "underline")
                ]), x([
                    ld(i)
                ])),
                ld(u)
            ]))
        ]));
    }), kRn = F2(function(n, r) {
        var t = be(r), e = A2(he, F2(function(n, r) {
            return b(n, r);
        }), r);
        return A2(nk, x([
            A2(bT, "padding-left", "16px")
        ]), A2(Eu, function(r) {
            var e = r.b;
            return A3(xRn, n, 0 > s(r.a, t - 1), e);
        }, e));
    }), yRn = F3(function(n, r, t) {
        var e = OAn(t), u = QAn(t), a = YAn(UAn(t)), i = t.ob, c = !TE(i), o = t.rh, f = A2(Cq, o, r);
        return A2(nk, h, x([
            A2(nk, x([
                Xx("text-support")
            ]), x([
                ld(oe(u) + " " + a + " "),
                c ? A2(ak, x([
                    IC(gRn(o)),
                    A2(jC, "role", "button"),
                    pj(0),
                    A2(jC, "aria-expanded", f ? "true" : "false"),
                    A2(bT, "cursor", "pointer"),
                    Xx("link text-primary"),
                    A2(bT, "text-decoration", "none")
                ]), x([
                    A2(K8, h, x([
                        ld("(" + oe(e) + " remaining)")
                    ])),
                    f ? A2(ak, x([
                        Xx("text-support"),
                        A2(bT, "font-size", "30px"),
                        A2(bT, "margin-left", "4px"),
                        A2(bT, "display", "inline-flex"),
                        A2(bT, "align-items", "center"),
                        A2(bT, "vertical-align", "middle")
                    ]), x([
                        ld("\u25B4")
                    ])) : tB
                ])) : A2(K8, h, x([
                    ld("(" + oe(e) + " remaining)")
                ]))
            ])),
            f && c ? A2(kRn, n, i) : tB
        ]));
    }), _Rn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(Ek, x([
                ok(x([
                    Xx("mb-4")
                ]))
            ]), x([
                A2(X8, h, x([
                    ld("Includes")
                ]))
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(nk, x([
                        Xx("space-y-4")
                    ]), A2(Eu, A2(yRn, n, r), t))
                ]))
            ]))
        ]));
    }), ARn = F4(function(n, r, t, e) {
        var u = r.tg, a = $(t.$ ? "" : n(ZAn(A2(fp, "MM/dd/yyyy", t.a))) + ", ", function(n) {
            var r = Ce(n);
            if (r.$) return n;
            var t = r.a, e = t.b;
            return $(Zb(bfn(t.a)), e);
        }(e));
        return A2(nk, x([
            Xx("mb-5")
        ]), x([
            A2(Ek, x([
                ok(x([
                    Xx("mb-4")
                ]))
            ]), x([
                A2(X8, h, x([
                    ld("Patient")
                ]))
            ])),
            A2(zN, x([
                ron,
                JI(12)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(X8, h, x([
                        ld(u)
                    ])),
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(a)
                    ]))
                ]))
            ]))
        ]));
    }), CRn = F3(function(n, r, t) {
        var e = t.wO, u = t.t6, a = function(n) {
            return n.uV;
        }(t), i = function(n) {
            return n.tZ;
        }(t), c = function(n) {
            return n.qm;
        }(t);
        return A2(nk, x([
            Xx("text-left mb-5")
        ]), x([
            A2(hRn, n, i),
            Dk,
            A2(Ak, x([
                ok(x([
                    Xx("mt-8 mb-8")
                ]))
            ]), x([
                ld(i)
            ])),
            A4(ARn, n, u, c, e),
            TE(a) ? tB : A3(_Rn, n, r.cw, a)
        ]));
    }), BRn = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), (t = r.ip, t.$ ? ck : x([
                    A3(CRn, n, r, t.a)
                ])))
            ]),
            w5: n(Wd.Ea)
        };
    }), ERn = ZA({
        Ar: vRn,
        AQ: mRn,
        Db: pRn,
        DZ: function() {
            return zx;
        },
        En: $Rn,
        Et: BRn
    }), DRn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qRn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FRn = F4(function(n, r, t, e) {
        return A4(W_, n, L4, e, rA(A2(X_, x([
            t
        ]), D4(r))));
    }), PRn = F2(function(n, r) {
        if (r.$) return A2(ak, x([
            Xx("inline-block my-1")
        ]), x([
            ld(n(lb))
        ]));
        var t = r.a;
        return A2(ak, h, x([
            ld(A2(mfn, n, t)),
            A2(Afn, n, pfn(t)),
            xCn(t) ? A2(pan, x([
                1
            ]), x([
                ld(n(kCn))
            ])) : ld("")
        ]));
    }), zRn = function(n) {
        return m4({
            rh: n,
            Eb: PRn,
            Ed: function(n) {
                return n.$ ? Ut : Vt(Qin(n.a));
            }
        });
    }, jRn = F3(function(n, r, t) {
        var e = t.Ck, u = Bx(n), a = function() {
            var n = r.t6;
            if (3 === n.$) {
                var t = n.a;
                return b(Vt(EL(t)), ZE(t));
            }
            return b(Ut, "");
        }();
        return b({
            gF: r.gF,
            eq: Ut,
            yR: r.yR,
            bh: !1,
            gY: !1,
            kA: r.kA,
            kJ: e.rh,
            b0: vc,
            a3: Ut,
            fe: vc,
            Cr: a.a,
            la: a.b,
            Cv: zRn("checkout-payment-source-select"),
            Cw: cP,
            dB: n,
            CD: u,
            dG: !1,
            Dk: Ut
        }, Vu(x([
            A4(FRn, r.gF, u, e.rh, DRn),
            A3(Ran, r.gF, u, qRn)
        ])));
    }), SRn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, LRn = A2(ru, Fp(Oin), sc(!1)), MRn = F3(function(n, r, t) {
        return n && LRn(t) && r > 0;
    }), NRn = function(n) {
        var r = n.gF, t = n.CD, e = n.DJ, u = n.yj, a = n.Ec;
        if (A3(MRn, n.yR, u, e)) {
            var i = A2(Fp, Qin, e);
            return i.$ ? Pp : A5(Yin, r, t, i.a, u, a);
        }
        return Pp;
    }, HRn = function(n) {
        return n.lM;
    }, TRn = function(n) {
        return A2(sc, 0, A2(Fp, HRn, n.eq));
    }, IRn = F2(function(n, r) {
        return NRn({
            yj: TRn(n),
            gF: n.gF,
            yR: n.yR,
            CD: Bx(n.dB),
            DJ: r,
            Ec: SRn
        });
    }), RRn = F2(function(n, r) {
        var t = !i(n.yR, r.yR), e = m(r, {
            yR: n.yR,
            fe: t ? vc : r.fe
        });
        return b(e, t ? A2(IRn, e, r.Dk) : Pp);
    }), ZRn = F2(function(n, r) {
        return m(r, {
            x6: Ut
        });
    }), VRn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, URn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YRn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, QRn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ORn = uu(0), GRn = F4(function(n, r, t, e) {
        return A4(bL, n, ORn, e, A2(vL, t, rA(A2(X_, x([
            "cart",
            "checkout"
        ]), lL(r)))));
    }), JRn = function(n) {
        if (n.$) {
            var r = n.a;
            return _x(x([
                b("id", Ax(r.rh)),
                b("type", Ax("plan")),
                b("owner", Ax(r.tU)),
                b("members", A2(KK, Ax, r.A8)),
                b("period_in_months", EX(r.Cz)),
                b("start_date", Ax(r.DN)),
                b("accepted_documents", r.x4)
            ]));
        }
        var t = n.a;
        return _x(x([
            b("id", Ax(t.rh)),
            b("type", Ax("package")),
            b("owner", Ax(t.tU))
        ]));
    }, WRn = F4(function(n, r, t, e) {
        var u = _x(x([
            b("cart", A2(KK, JRn, t.rL)),
            b("payment_method", Ax(t.Ct))
        ]));
        return A4(GRn, n, r, u, e);
    }), KRn = F2(function(n, r) {
        return 1 === r.$ ? n : r;
    }), XRn = function(n) {
        return A2(KRn, rv(n), rv(A2(Rc, xCn, n)));
    }, nZn = F3(function(n, r, t) {
        var e = A2(ZD, n, r), u = e.a, a = e.c;
        return a.$ || a.a.$ || a.a.a.$ ? v(u, t, !1) : a.a.a.a.$ ? v(u, Ut, !0) : v(u, Vt(a.a.a.a.a), !1);
    }), rZn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (E = n.a).$ ? v(l = m(r, {
                    eq: Vt(E.a)
                }), A2(IRn, l, l.Dk), h) : v(r, Pp, A2(xA, 0, E));
            case 1:
                if (3 === (E = n.a).$) {
                    var t = XRn(E.a);
                    return v(l = m(r, {
                        Cw: E,
                        Dk: t
                    }), A2(IRn, l, t), h);
                }
                return v(m(r, {
                    Cw: E
                }), Pp, A2(xA, 0, E));
            case 2:
                return v(m(r, {
                    fe: n.a
                }), Pp, h);
            case 3:
                var e = A3(nZn, n.a, r.Cv, r.Dk), u = e.a, a = e.b, c = e.c, o = !i(A2(Fp, Qin, a), A2(Fp, Qin, r.Dk)), f = function() {
                    if (c) {
                        var n = A6(ifn, !1, r.kA, r.dB, r.yR, Ut, r.gF), t = n.b;
                        return b(Vt(n.a), A2(Lp, VRn, t));
                    }
                    return b(o ? Ut : r.a3, Pp);
                }(), s = f.b, l = m(r, {
                    b0: vc,
                    a3: f.a,
                    Cv: u,
                    Dk: a
                });
                return c ? v(l, s, h) : o ? v(m(l, {
                    fe: vc
                }), A2(IRn, l, a), h) : v(l, Pp, h);
            case 4:
                var d = n.a, p = r.a3;
                if (1 === p.$) return v(r, Pp, h);
                var g = A2(Rsn, d, p.a), w = g.b, k = g.c, y = m(r, {
                    a3: Vt(g.a)
                }), _ = x([
                    A2(Lp, VRn, w)
                ]);
                n: for(; !k.$;)switch(k.a.$){
                    case 1:
                        var A = k.a.a, C = 3 !== (S = r.Cw).$ || !TE(S.a);
                        return v(m(y, {
                            b0: cP
                        }), Vu(A2(Yt, A4(ssn, r.gF, A, {
                            dx: !1,
                            u1: !1,
                            vG: Ut,
                            wb: !C
                        }, QRn), _)), h);
                    case 0:
                        var B = k.a.a;
                        return v(m(y, {
                            b0: vc
                        }), Vu(_), x([
                            hA(B)
                        ]));
                    default:
                        break n;
                }
                return v(y, Vu(_), h);
            case 5:
                var E;
                if (3 === (E = n.a).$) {
                    var D = E.a, q = function() {
                        var n = r.Cw;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(Zy, $(n.a, x([
                                D
                            ])), t);
                        }
                        return n;
                    }();
                    return v(l = m(r, {
                        b0: E,
                        a3: Ut,
                        fe: vc,
                        Cw: q,
                        Dk: Vt(D)
                    }), A2(IRn, l, Vt(D)), h);
                }
                return v(m(r, {
                    b0: E
                }), Pp, A2(xA, 0, E));
            case 6:
                return v(m(r, {
                    b0: vc,
                    a3: Ut
                }), Pp, h);
            case 7:
                return v(r, 1 === r.a3.$ ? Pp : A2(Lp, VRn, esn), h);
            case 8:
                var F = b(r.Cr, r.Dk);
                if (F.a.$ || F.b.$) return v(r, Pp, h);
                var P = F.a.a, z = F.b.a;
                return v(m(r, {
                    bh: !0
                }), A4(WRn, r.gF, r.CD, {
                    rL: x([
                        URn({
                            rh: r.kJ,
                            tU: P
                        })
                    ]),
                    Ct: Qin(z)
                }, YRn), h);
            case 9:
                var j = n.a;
                return 3 === j.$ ? v(m(r, {
                    bh: !1,
                    gY: !0
                }), Pp, h) : v(m(r, {
                    bh: !1
                }), Pp, A2(xA, 0, j));
            case 10:
                return v(m(r, {
                    dG: !r.dG
                }), Pp, h);
            default:
                return v(r, A2(AA, da, _a), h);
        }
        var S;
    }), tZn = {
        $: 11
    }, eZn = function(n) {
        return n.aB.n7;
    }, uZn = function(n) {
        return n.aB.hl;
    }, aZn = function(n) {
        return n.aB.zB;
    }, iZn = function(n) {
        return n.aB.A4;
    }, cZn = function(n) {
        return n.aB.ia;
    }, oZn = function(n) {
        return n.aB.dz;
    }, fZn = function(n) {
        return n.aB.iD;
    }, sZn = function(n) {
        return n.aB.jF;
    }, lZn = function(n) {
        return n.aB.dY;
    }, dZn = function(n) {
        return n.aB.w5;
    }, bZn = function(n) {
        return A2(nk, x([
            Xx("flex flex-col items-center justify-center px-6"),
            A2(bT, "min-height", "calc(100vh - 12rem)")
        ]), x([
            A2(nk, x([
                Xx("flex flex-col items-center")
            ]), x([
                A2(PE, x([
                    iH,
                    MB("fill-primary-300 scale-[2.66]"),
                    cH(aH)
                ]), 8),
                A2(nk, x([
                    Xx("mt-14")
                ]), x([
                    A2(yC, x([
                        SV,
                        rB(DB),
                        _H(cR)
                    ]), x([
                        ld(n.w5)
                    ])),
                    A2(nk, x([
                        Xx("max-w-[14rem] mx-auto")
                    ]), x([
                        A2(Ek, x([
                            $H,
                            rB(DB)
                        ]), x([
                            ld(n.gN)
                        ]))
                    ]))
                ]))
            ])),
            A2(nk, x([
                Xx("w-64 mt-16 [&_.button]:py-3")
            ]), x([
                A2(OC, x([
                    qC,
                    CZ,
                    EC(n.BE)
                ]), x([
                    ld(n.yE)
                ]))
            ]))
        ]));
    }, vZn = {
        $: 6
    }, mZn = {
        $: 12
    }, pZn = {
        $: 7
    }, $Zn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hZn = {
        $: 1
    }, gZn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wZn = {
        $: 8
    }, xZn = function(n) {
        return n.lI;
    }, kZn = function(n) {
        var r = A2(sc, 0, A2(Fp, qon, n));
        return r > 0 ? A2(nk, h, x([
            A2(Ek, x([
                $H
            ]), x([
                A2(nk, x([
                    Xx("flex justify-between w-full")
                ]), x([
                    A2(nk, x([
                        Xx("flex")
                    ]), x([
                        ld("Credit card fee")
                    ])),
                    A2(nk, x([
                        Xx("flex")
                    ]), x([
                        ld(lV(r))
                    ]))
                ]))
            ]))
        ])) : tB;
    }, yZn = {
        $: 10
    }, _Zn = F2(function(n, r) {
        return A2(nk, x([
            Xx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), x([
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(Ek, h, x([
                    ld(n)
                ]))
            ])),
            A2(nk, h, x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(lV(r))
                ]))
            ]))
        ]));
    }), AZn = F3(function(n, r, t) {
        var e = r.dG ? "text-gray-400 transform rotate-90" : "text-gray-400";
        return A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between items-center cursor-pointer py-2"),
                IC(yZn)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n(fZn))
                ])),
                A2(Ck, yu, A2(PE, x([
                    HB,
                    MB(e)
                ]), 6))
            ])),
            r.dG ? A2(nk, x([
                Xx("mt-2")
            ]), x([
                A2(Ck, yu, A2(_Zn, A2(sc, "", o8(t)), A2(sc, 0, J8(t))))
            ])) : tB
        ]));
    }), CZn = F2(function(n, r) {
        return r > 0 ? A2(nk, h, x([
            A2(Ek, x([
                $H
            ]), x([
                A2(nk, x([
                    Xx("flex justify-between w-full")
                ]), x([
                    A2(nk, x([
                        Xx("flex")
                    ]), x([
                        ld(n(Zd))
                    ])),
                    A2(nk, x([
                        Xx("flex")
                    ]), x([
                        ld(lV(r))
                    ]))
                ]))
            ]))
        ])) : tB;
    }), BZn = F3(function(n, r, t) {
        var e = uC(r.fe), u = HRn(t), a = A2(sc, u, A2(Fp, hcn, e)), c = !i(r.Dk, Ut) && !r.bh;
        return A2(nk, x([
            Xx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between items-center mb-2")
            ]), x([
                A2(Ek, x([
                    O0
                ]), x([
                    ld(n(aZn))
                ])),
                A2(Ck, yu, A7(MV, n, a, !1, Ut, kF, !1, !1))
            ])),
            Dk,
            A2(Ck, yu, A2(CZn, n, xZn(t))),
            A2(Ck, yu, kZn(e)),
            A3(AZn, n, r, t),
            A2(OC, x([
                qC,
                CZ,
                EC(wZn),
                uF(!c),
                uln(r.bh)
            ]), x([
                ld(n(eZn))
            ]))
        ]));
    }), EZn = F2(function(n, r) {
        return A2(nk, x([
            Xx("mb-6 mt-4")
        ]), x([
            A2(Ek, x([
                _H(cR)
            ]), x([
                A2(X8, h, x([
                    ld(n)
                ]))
            ])),
            A2(Ek, x([
                $H
            ]), x([
                ld(r)
            ]))
        ]));
    }), DZn = function(n) {
        var r, t = n.Cw;
        switch(t.$){
            case 3:
                var e = t.a;
                return A2(nk, x([
                    Xx("mb-6")
                ]), x([
                    A2(Ek, x([
                        _H(cR)
                    ]), x([
                        A2(X8, h, x([
                            ld(n.Cu)
                        ])),
                        A2(ak, x([
                            Xx("text-danger")
                        ]), x([
                            ld(" *")
                        ]))
                    ])),
                    A2(Ck, n.BV, A4(sF, n.xl, x([
                        Dq(n.Dk),
                        xq(n.xl(Jln)),
                        vq
                    ]), (r = A2(Eu, function(n) {
                        return A2(hq, h, $Zn(n));
                    }, e), TE(r) ? x([
                        A2(hq, h, hZn)
                    ]) : A2(Yt, A2(hq, h, hZn), A2(Yt, pq, r))), n.Cv))
                ]));
            case 1:
                return A2(nk, x([
                    Xx("mb-6")
                ]), ck);
            default:
                return A2(nk, x([
                    Xx("mb-6")
                ]), x([
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld(n.Bk)
                    ]))
                ]));
        }
    }, qZn = function(n) {
        return A2(nk, h, x([
            A2(EZn, n.A5, n.la),
            DZn(n)
        ]));
    }, FZn = function(n) {
        var r = n.xl, t = n.AD, e = n.AG, u = n.Bw, a = n.BA;
        return A2(nk, x([
            Xx("flex gap-2 mt-4")
        ]), x([
            A2(OC, x([
                oF,
                EC(u)
            ]), x([
                ld(r(P3))
            ])),
            A2(OC, x([
                qC,
                EC(a),
                uF(!t),
                uln(e)
            ]), x([
                ld(r(lb))
            ]))
        ]));
    }, PZn = F3(function(n, r, t) {
        var e = uC(r.fe), u = HRn(t), a = A2(sc, u, A2(Fp, hcn, e)), c = !i(r.Dk, Ut) && !r.bh;
        return A2(nk, x([
            Xx("sidebar-wrap")
        ]), x([
            A2(nk, x([
                Xx("flex justify-between items-center mb-2")
            ]), x([
                A2(Ek, x([
                    O0
                ]), x([
                    ld(n(aZn))
                ])),
                A2(Ck, yu, A7(MV, n, a, !1, Ut, kF, !1, !1))
            ])),
            A2(Ck, yu, A2(CZn, n, xZn(t))),
            A2(Ck, yu, kZn(e)),
            A3(AZn, n, r, t),
            A2(OC, x([
                qC,
                CZ,
                EC(wZn),
                uF(!c),
                uln(r.bh)
            ]), x([
                ld(n(eZn))
            ]))
        ]));
    }), zZn = F3(function(n, r, t) {
        return xU(x([
            kU({
                By: mZn,
                w5: n(dZn)
            }),
            Dk,
            GV({
                zm: A3(PZn, n, r, t),
                AX: x([
                    qZn({
                        A5: n(iZn),
                        Bk: n(cZn),
                        BV: gZn,
                        la: r.la,
                        Cu: n(oZn),
                        Cv: r.Cv,
                        Cw: r.Cw,
                        Dk: i(r.a3, Ut) ? A2(Fp, $Zn, r.Dk) : Vt(hZn),
                        xl: n
                    }),
                    function() {
                        var t = r.a3;
                        if (t.$) return tB;
                        var e = t.a, u = 1 === r.b0.$;
                        return A2(nk, x([
                            Xx("mb-6")
                        ]), $(A2(Eu, Ck(VRn), Pln(e)), x([
                            FZn({
                                AD: eln(e),
                                AG: u,
                                Bw: vZn,
                                BA: pZn,
                                xl: n
                            })
                        ])));
                    }()
                ])
            }),
            JV(A3(BZn, n, r, t))
        ]));
    }), jZn = F2(function(n, r) {
        return {
            gN: x([
                function() {
                    if (r.gY) return bZn({
                        gN: n(sZn),
                        yE: n(uZn),
                        BE: tZn,
                        w5: n(lZn)
                    });
                    var t = r.eq;
                    return t.$ ? A2(nk, x([
                        Xx("panel")
                    ]), ck) : A3(zZn, n, r, t.a);
                }()
            ]),
            w5: n(dZn)
        };
    }), SZn = ZA({
        Ar: jRn,
        AQ: RRn,
        Db: ZRn,
        DZ: function(n) {
            return n.a3.$ ? zx : A2(_S, VRn, Tfn);
        },
        En: rZn,
        Et: jZn
    }), LZn = {
        $: 0
    }, MZn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NZn = function(n) {
        return A3(Ran, n.gF, Bx(n.dB), MZn);
    }, HZn = F3(function(n, r) {
        var t = {
            cf: LZn,
            gF: r.gF,
            kA: r.kA,
            dB: n,
            wA: vc,
            jK: r.jK
        };
        return b(t, NZn(t));
    }), TZn = F2(function(n, r) {
        return b(r, Pp);
    }), IZn = F2(function(n, r) {
        return m(r, {
            x6: Vt(3)
        });
    }), RZn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ZZn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VZn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, UZn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), YZn = F4(function(n, r, t, e) {
        return A4(dC, n, ORn, e, rA(A2(X_, x([
            Qin(t),
            "default"
        ]), Ian(r))));
    }), QZn = F2(function(n, r) {
        return r.um(n);
    }), OZn = F2(function(n, r) {
        return r.un(n);
    }), GZn = J_("delete"), JZn = F4(function(n, r, t, e) {
        return A4(GZn, n, ORn, e, rA(A2(X_, x([
            Qin(t)
        ]), Ian(r))));
    }), WZn = F6(function(n, r, t, e, u, a) {
        return 3 === e.$ ? v(m(n, {
            wA: cP
        }), Vu(x([
            NZn(n),
            A2(itn, a, h)
        ])), x([
            A2($A, 3, u(A2(mfn, r, t)))
        ])) : v(n, Pp, A2(xA, 0, e));
    }), KZn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    cf: LZn,
                    wA: t
                }), Pp, h) : v(m(r, {
                    cf: LZn,
                    wA: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                return v(m(r, {
                    cf: VZn(Qin(e = n.a))
                }), A4(JZn, r.gF, Bx(r.dB), e, UZn(e)), h);
            case 2:
                var e = n.a, u = n.b;
                return A6(WZn, r, Wx(r.kA), e, u, OZn, "Payment Method Removed");
            case 3:
                return v(m(r, {
                    cf: ZZn(Qin(e = n.a))
                }), A4(YZn, r.gF, Bx(r.dB), e, RZn(e)), h);
            default:
                return e = n.a, u = n.b, A6(WZn, r, Wx(r.kA), e, u, QZn, "Default Payment Method Changed");
        }
    }), XZn = function(n) {
        return function(n) {
            return {
                $: 11,
                a: n
            };
        }(n);
    }, nVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rVn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tVn = function(n) {
        return n.C_;
    }, eVn = function(n) {
        return n.pL;
    }, uVn = function(n) {
        return _A(Ua({
            rh: Qin(n) + "/edit"
        }));
    }, aVn = F2(function(n, r) {
        return Oin(r) ? A2(ak, x([
            Xx("button button--link ml-4 mr-4")
        ]), x([
            A2(IN, x([
                LN(uVn(r)),
                XZn("editPaymentMethod")
            ]), x([
                ld(n(eVn))
            ]))
        ])) : tB;
    }), iVn = F3(function(n, r, t) {
        return xCn(t) ? A2(nk, x([
            Xx("float-right mt-3 ml-0 md:ml-8")
        ]), x([
            A2(ak, h, x([
                A2(PE, x([
                    HB
                ]), 12),
                A2(FI, x([
                    fq
                ]), x([
                    ld(n(gb))
                ]))
            ])),
            A2(aVn, n, t)
        ])) : A2(nk, x([
            Xx("float-right mt-3")
        ]), x([
            A2(OC, x([
                wO,
                EC(nVn(t)),
                gC(x([
                    Xx("ml-0 mr-4 md:ml-6")
                ])),
                uln(i(r, ZZn(Qin(t)))),
                uF(!i(r, LZn))
            ]), x([
                ld(n(xb))
            ])),
            A2(aVn, n, t),
            A2(OC, x([
                wO,
                EC(rVn(t)),
                uln(i(r, VZn(Qin(t)))),
                uF(!i(r, LZn))
            ]), x([
                ld(n(tVn))
            ]))
        ]));
    }), cVn = F2(function(n, r) {
        return r.mc(n);
    }), oVn = F3(function(n, r, t) {
        return A2(t.qn, n, r);
    }), fVn = F2(function(n, r) {
        return A2(Fp, function(t) {
            var e = t.a, u = t.b;
            return A2(FI, 4 === pfn(r) ? x([
                bO
            ]) : h, A3(ru, ld, VZ, n(A2(oVn, oe(e), oe(u)))));
        }, function(n) {
            if (n.$) return Ut;
            var r = n.a;
            return A3(a3, ry, r.hr, r.hs);
        }(r));
    }), sVn = function(n) {
        return n.$ ? Ut : n.a.x0;
    }, lVn = F2(function(n, r) {
        return A2(Fp, function(r) {
            return ld(n(Eb) + " " + r);
        }, sVn(r));
    }), dVn = F3(function(n, r, t) {
        var e;
        return A2(nk, h, x([
            A2(nk, x([
                Xx("text-left")
            ]), x([
                A2(FI, h, x([
                    ld(A2(mfn, n, t))
                ])),
                A2(Ck, yu, A2(Afn, n, pfn(t)))
            ])),
            A2(nk, x([
                Xx("text-left")
            ]), A2(HE, ld(", "), A2(Tp, iu, x([
                Vt(ld(n(cVn(A2(r, 0, (e = t, e.a.y5)))))),
                A2(fVn, n, t),
                A2(lVn, n, t)
            ]))))
        ]));
    }), bVn = F4(function(n, r, t, e) {
        return A2(zN, x([
            PAn,
            jN(iR)
        ]), x([
            A2(EN, x([
                JI(12),
                bR(7)
            ]), x([
                A3(dVn, n, r, e)
            ])),
            Bon(x([
                JI(12),
                bR(1)
            ])),
            A2(EN, x([
                JI(12),
                bR(4)
            ]), x([
                A3(iVn, n, t, e)
            ]))
        ]));
    }), vVn = F4(function(n, r, t, e) {
        return A2(Eu, A3(bVn, n, r, t), e);
    }), mVn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), function() {
                    var t = r.wA;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return x([
                                A2(zN, h, x([
                                    A2(EN, x([
                                        JI(12)
                                    ]), TE(e) ? r5(n(Bb)) : A4(vVn, n, r.jK, r.cf, e))
                                ])),
                                A2(zN, h, x([
                                    A2(EN, x([
                                        JI(12),
                                        bR(4)
                                    ]), x([
                                        A2(IN, x([
                                            LN(_A(Ua({
                                                rh: "new"
                                            }))),
                                            XZn("addPaymentMethod"),
                                            SN,
                                            icn
                                        ]), x([
                                            ld(n(lb))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        case 2:
                            return a6(n(wb));
                        default:
                            return ck;
                    }
                }())
            ]),
            w5: n(_b)
        };
    }), pVn = ZA({
        Ar: HZn,
        AQ: TZn,
        Db: IZn,
        DZ: function() {
            return zx;
        },
        En: KZn,
        Et: mVn
    }), $Vn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hVn = F3(function(n, r, t) {
        var e = t.CS, u = A2(Wu, "replaces_payment_method", t.iF), a = A6(ifn, !1, r.kA, n, r.yR, Ut, r.gF), i = b(a.a, A2(Lp, $Vn, a.b)), c = i.a, o = i.b;
        return b({
            gF: r.gF,
            yR: r.yR,
            kA: r.kA,
            aA: vc,
            t7: r.ud,
            io: cfn(r),
            cH: c,
            dB: n,
            u1: !1,
            vG: u,
            xs: e
        }, o);
    }), gVn = F2(function(n, r) {
        return b(m(r, {
            yR: n.yR,
            io: cfn(n)
        }), Pp);
    }), wVn = F2(function(n, r) {
        return m(r, {
            x6: Vt(3)
        });
    }), xVn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kVn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                switch(t.$){
                    case 2:
                        var e = A6(ifn, !1, r.kA, r.dB, r.yR, Ut, r.gF), u = e.b;
                        return v(m(r, {
                            aA: t,
                            cH: e.a
                        }), A2(Lp, $Vn, u), A2(xA, 0, t));
                    case 3:
                        var a = t.a;
                        return v(m(r, {
                            aA: t
                        }), Vu(x([
                            A2(AA, da, Va),
                            A2(itn, "Payment Method Added", h),
                            xCn(a) ? A2(itn, "Default Payment Method Changed", h) : Pp
                        ])), x([
                            A2($A, 3, vb)
                        ]));
                    default:
                        return v(m(r, {
                            aA: t
                        }), Pp, A2(xA, 0, t));
                }
            case 2:
                var i = A2(Rsn, n.a, r.cH), c = i.b, o = i.c, f = m(r, {
                    cH: i.a
                }), s = x([
                    A2(Lp, $Vn, c)
                ]);
                n: for(; !o.$;)switch(o.a.$){
                    case 1:
                        var l = o.a.a;
                        return v(m(f, {
                            aA: cP
                        }), Vu(A2(Yt, A4(ssn, r.gF, l, {
                            dx: !1,
                            u1: r.u1,
                            vG: r.vG,
                            wb: !0
                        }, xVn), s)), h);
                    case 0:
                        var d = o.a.a;
                        return v(m(f, {
                            aA: vc
                        }), Vu(s), x([
                            hA(d)
                        ]));
                    default:
                        break n;
                }
                return v(f, Vu(s), h);
            case 1:
                return v(m(r, {
                    aA: cP
                }), A2(Lp, $Vn, esn), h);
            default:
                return v(m(r, {
                    u1: n.a
                }), Pp, h);
        }
    }), yVn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("panel")
            ]), x([
                A2(Ak, x([
                    _H(fO)
                ]), x([
                    ld(n(Ab))
                ])),
                A2(Ek, x([
                    $H
                ]), x([
                    A4(YD, Ex(r), qB(r), Vt("This link is invalid, you may have already used it. If you need to update your payment information again"), Vt("to request a new link."))
                ]))
            ]))
        ]);
    }), _Vn = pH(0), AVn = function(n) {
        return A2(GI, 3, n);
    }, CVn = {
        $: 1
    }, BVn = F2(function(n, r) {
        return A2(OC, x([
            qC,
            CZ,
            uln(i(r.aA, cP)),
            uF(i(r.aA, cP) || !eln(r.cH)),
            EC(CVn)
        ]), x([
            ld(n(yb))
        ]));
    }), EVn = F3(function(n, r, t) {
        return A2(nk, h, x([
            A3(cln, n, r, t),
            idn(r)
        ]));
    }), DVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qVn = F4(function(n, r, t, e) {
        return r ? A2(zN, x([
            jN(aH)
        ]), x([
            A2(EN, h, x([
                A2(HT, x([
                    zT(t),
                    PT(DVn),
                    FT(e)
                ]), x([
                    ld(n(kb))
                ]))
            ]))
        ])) : tB;
    }), FVn = F2(function(n, r) {
        return x([
            A2(nk, h, x([
                A2(Ak, x([
                    _H(fO)
                ]), x([
                    ld(n(db))
                ]))
            ])),
            A2(zN, x([
                jN(yan),
                jN(iR)
            ]), x([
                A2(EN, x([
                    jN(iR)
                ]), A2(Eu, Ck($Vn), Pln(r.cH)))
            ])),
            A4(qVn, n, r.io, r.u1, i(r.aA, cP)),
            Dk,
            A3(EVn, !1, n, Ex(r.dB)),
            Dk,
            A2(zN, x([
                jN(yan),
                jN(iR)
            ]), x([
                Bon(x([
                    JI(0),
                    kcn(3),
                    AVn(4)
                ])),
                A2(EN, x([
                    kcn(6),
                    AVn(4)
                ]), x([
                    A2(BVn, n, r)
                ]))
            ]))
        ]);
    }), PVn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("panel panel-success")
            ]), 3 === r.aA.$ ? x([
                A2(zN, x([
                    _N(DB)
                ]), x([
                    A2(EN, x([
                        JI(12)
                    ]), x([
                        A2(rH, x([
                            _Vn
                        ]), x([
                            ld(n(Cb))
                        ]))
                    ]))
                ]))
            ]) : A2(FVn, n, r))
        ]);
    }), zVn = F2(function(n, r) {
        return {
            gN: RA(r.gF) ? A2(PVn, n, r) : A2(yVn, n, r.dB),
            w5: Ex(r.dB)
        };
    }), jVn = ZA({
        Ar: hVn,
        AQ: gVn,
        Db: wVn,
        DZ: function() {
            return Px(x([
                A2(_S, $Vn, Tfn),
                zx
            ]));
        },
        En: kVn,
        Et: zVn
    }), SVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, LVn = {
        $: 0
    }, MVn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, NVn = {
        hr: Ut,
        hs: Ut,
        x0: ""
    }, HVn = function(n) {
        return A2(X_, x([
            "cards"
        ]), lL(n));
    }, TVn = F4(function(n, r, t, e) {
        return A4(W_, n, Tan, e, rA(A2(X_, x([
            t
        ]), HVn(r))));
    }), IVn = function(n) {
        return A2(sc, "", A2(yPn, 2, A2(Rc, function(n) {
            return "" !== n;
        }, A2(se, "/", n.Cq))));
    }, RVn = x([
        0,
        1
    ]), ZVn = function(n) {
        return n ? "ExpDate" : "Zip";
    }, VVn = F3(function(n, r, t) {
        var e = t.CS;
        return b({
            gF: r.gF,
            gT: vc,
            g8: Ut,
            kA: r.kA,
            kB: lS(NVn),
            e8: dd({
                rh: "month",
                Eb: F2(function(n, r) {
                    return r;
                }),
                Ed: function(n) {
                    return Vt(n);
                }
            }),
            aA: vc,
            dB: n,
            wO: LVn,
            xs: e,
            x: A2(vS, RVn, ZVn),
            f$: dd({
                rh: "year",
                Eb: F2(function(n, r) {
                    return oe(r);
                }),
                Ed: function(n) {
                    return Vt(oe(n));
                }
            })
        }, Vu(x([
            A2(Nu, MVn, RF),
            A4(TVn, r.gF, Bx(n), IVn(e), SVn)
        ])));
    }), UVn = F2(function(n, r) {
        return b(r, Pp);
    }), YVn = F2(function(n, r) {
        return m(r, {
            x6: Vt(3)
        });
    }), QVn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, OVn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, GVn = {
        $: 1
    }, JVn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, WVn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, KVn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), XVn = F5(function(n, r, t, e, u) {
        return A4(dC, n, ORn, u, A2(vL, function(n) {
            return _x(x([
                b("card", _x(x([
                    b("exp_month", A2(yL, EX, n.hr)),
                    b("exp_year", A2(yL, EX, n.hs)),
                    b("zip", A2(yL, Ax, n.x0))
                ])))
            ]));
        }(e), rA(A2(X_, x([
            t
        ]), HVn(r)))));
    }), nUn = F4(function(n, r, t, e) {
        var u = FL(n.kB), a = {
            hr: u.hr,
            hs: u.hs,
            x0: Vt(u.x0)
        };
        return A5(XVn, n.gF, r, IVn(t), a, KVn(e));
    }), rUn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    x0: n.a
                });
            case 1:
                return m(r, {
                    hr: pu(n.a)
                });
            default:
                return m(r, {
                    hs: pu(n.a)
                });
        }
    }), tUn = F2(function(n, r) {
        var t = b(1, eM(A2(rM, uM, Fsn))), e = b(r.hs, r.hr);
        if (e.a.$ || e.b.$) return x([
            t
        ]);
        var u = e.a.a, a = e.b.a, c = A2(sc, 0, A2(Fp, Pv, n)), o = A2(sc, 0, A2(Fp, Hv, n));
        return i(c, u) && 0 > s(a, o) ? x([
            t
        ]) : h;
    }), eUn = function(n) {
        var r = n.x0;
        return fM(r) ? x([
            b(0, eM(A2(rM, uM, cgn)))
        ]) : wgn(r) ? h : x([
            b(0, dM(fgn))
        ]);
    }, uUn = F2(function(n, r) {
        var t = n.kB, e = A2(sc, "", sVn(r)), u = FL(t), a = function(n) {
            return n.$ ? Ut : n.a.hs;
        }(r), i = function(n) {
            return n.$ ? Ut : n.a.hr;
        }(r);
        return m(u, {
            hr: i,
            hs: a,
            x0: e
        });
    }), aUn = F2(function(n, r) {
        return A2(sS, n, r.b);
    }), iUn = F3(function(n, r, t) {
        switch(r.$){
            case 3:
                return v(m(n, {
                    gT: cP
                }), A2(AA, da, Va), x([
                    A2($A, 3, t)
                ]));
            case 2:
                return v(m(n, {
                    wO: OVn(rln(r.a))
                }), Pp, A2(xA, 0, r));
            default:
                return v(n, Pp, A2(xA, 0, r));
        }
    }), cUn = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a, e = Pv(t);
                return v(m(r, {
                    g8: Vt(t),
                    kB: A3(dN, rUn, QVn(oe(e)), r.kB)
                }), Pp, h);
            case 3:
                switch((k = n.a).$){
                    case 3:
                        return v(m(r, {
                            gT: k,
                            kB: s = A2(aUn, A2(uUn, r, k.a), r.kB),
                            wO: GVn
                        }), Pp, h);
                    case 2:
                        return v(m(r, {
                            gT: vc,
                            wO: OVn(rln(g = k.a))
                        }), Pp, A2(xA, 0, k));
                    default:
                        return v(m(r, {
                            gT: vc
                        }), Pp, A2(xA, 0, k));
                }
            case 0:
                var u = n.a, a = FL(r.kB).hr, i = A2(ZD, u, r.e8), c = i.a, o = i.b, f = (l = i.c).$ || l.a.$ ? oe(A2(sc, 1, a)) : A2(sc, "1", l.a.a), s = A3(dN, rUn, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(f), r.kB);
                return v(m(r, {
                    kB: s,
                    e8: c
                }), A2(Lp, JVn, o), h);
            case 1:
                u = n.a;
                var l, d = FL(r.kB).hs, b = A2(ZD, u, r.f$);
                return c = b.a, o = b.b, v(m(r, {
                    kB: s = A3(dN, rUn, QVn(oe(A2(sc, 0, f = (l = b.c).$ || l.a.$ ? d : l.a.a))), r.kB),
                    f$: c
                }), A2(Lp, WVn, o), h);
            case 2:
                var p = n.a, $ = r.wO;
                switch($.$){
                    case 1:
                        return v(m(r, {
                            kB: A3(dN, rUn, p, r.kB)
                        }), Pp, h);
                    case 2:
                        var g = $.a;
                        return v(m(r, {
                            kB: A3(dN, rUn, p, r.kB),
                            wO: OVn(g)
                        }), Pp, h);
                    default:
                        return v(r, Pp, h);
                }
            case 5:
                var w = n.a;
                if (3 === w.$) {
                    var k = w.a, y = nM(x([
                        tUn(r.g8),
                        eUn
                    ])), _ = A2(BM, y, r.kB);
                    return _.$ ? v(m(r, {
                        kB: _.a
                    }), Pp, h) : v(r, A4(nUn, r, Bx(r.dB), r.xs, k), h);
                }
                return v(r, Pp, h);
            default:
                return A3(iUn, r, n.b, Cb);
        }
    }), oUn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("panel")
            ]), x([
                A2(Ak, x([
                    _H(fO)
                ]), x([
                    ld(n(Ab))
                ])),
                A2(Ek, x([
                    $H
                ]), x([
                    A4(YD, Ex(r), qB(r), Vt("This link is invalid, you may have already used it. If you need to update your payment information again"), Vt("to request a new link."))
                ]))
            ]))
        ]);
    }), fUn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lUn = F2(function(n, r) {
        return !TE(A2(PH, r, n.kB));
    }), dUn = x([
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ]), bUn = function(n) {
        return A2(IN, x([
            SN,
            icn,
            LN(_A(Va))
        ]), x([
            ld(n(P3))
        ]));
    }, vUn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, mUn = F2(function(n, r) {
        return A2(OC, x([
            qC,
            CZ,
            uln(i(r.aA, cP)),
            uF(i(r.aA, cP)),
            EC(vUn(r.gT))
        ]), x([
            ld(n(Qwn))
        ]));
    }), pUn = function(n) {
        var r = n.g8, t = function() {
            if (r.$) return h;
            var n = Pv(r.a);
            return A2($e, n, n + 10);
        }();
        return A2(Eu, function(n) {
            return A2(hq, h, n);
        }, t);
    }, $Un = F2(function(n, r) {
        var t = FL(r.kB), e = t.x0, u = t.hr, a = t.hs;
        return x([
            A2(nk, h, x([
                A2(Ak, x([
                    _H(fO)
                ]), x([
                    ld(n(pb))
                ]))
            ])),
            A2(nk, h, x([
                function() {
                    var t = r.gT;
                    if (3 === t.$) {
                        var i = t.a;
                        return A2(nk, h, x([
                            A2(zN, h, x([
                                A2(EN, x([
                                    JI(12)
                                ]), x([
                                    A2(XH, x([
                                        HH(n(bb))
                                    ]), x([
                                        ld(A2(mfn, n, i))
                                    ]))
                                ]))
                            ])),
                            A2(zN, h, x([
                                A2(EN, x([
                                    kcn(6)
                                ]), x([
                                    A2(XH, x([
                                        HH(n($b)),
                                        VH(!0)
                                    ]), x([
                                        A2(Ck, JVn, A4(sF, n, x([
                                            Dq(A2(Fp, oe, u))
                                        ]), A2(Eu, function(n) {
                                            return A2(hq, h, n);
                                        }, dUn), r.e8))
                                    ])),
                                    A2(ET, n, A2(PH, 1, r.kB))
                                ])),
                                A2(EN, x([
                                    kcn(6)
                                ]), x([
                                    A2(XH, x([
                                        HH(n(hb)),
                                        VH(!0)
                                    ]), x([
                                        A2(Ck, WVn, A4(sF, n, x([
                                            Dq(a)
                                        ]), pUn(r), r.f$))
                                    ]))
                                ]))
                            ])),
                            A2(zN, h, x([
                                A2(EN, x([
                                    JI(12)
                                ]), x([
                                    A2(XH, x([
                                        HH(n(Eb)),
                                        VH(!0)
                                    ]), x([
                                        vI(x([
                                            xI(e),
                                            iI(n(Db)),
                                            gI(A2(pc, fUn, sUn)),
                                            JT(A2(lUn, r, 0)),
                                            yR("zipCode")
                                        ])),
                                        A2(ET, n, A2(PH, 0, r.kB))
                                    ]))
                                ]))
                            ])),
                            A2(zN, x([
                                jN(yan),
                                jN(iR)
                            ]), x([
                                A2(EN, x([
                                    bR(2)
                                ]), x([
                                    A2(mUn, n, r)
                                ])),
                                A2(EN, x([
                                    bR(2)
                                ]), x([
                                    bUn(n)
                                ]))
                            ]))
                        ]));
                    }
                    return tB;
                }()
            ]))
        ]);
    }), hUn = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("panel panel-success")
            ]), 3 === r.aA.$ ? x([
                A2(zN, x([
                    _N(DB)
                ]), x([
                    A2(EN, x([
                        JI(12)
                    ]), x([
                        A2(rH, x([
                            _Vn
                        ]), x([
                            ld(n(Cb))
                        ]))
                    ]))
                ]))
            ]) : A2($Un, n, r))
        ]);
    }), gUn = F2(function(n, r) {
        return {
            gN: RA(r.gF) ? A2(hUn, n, r) : A2(oUn, n, r.dB),
            w5: n(pb)
        };
    }), wUn = ZA({
        Ar: VVn,
        AQ: UVn,
        Db: YVn,
        DZ: function() {
            return zx;
        },
        En: cUn,
        Et: gUn
    }), xUn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yUn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _Un = function(n) {
        return {
            $: 3,
            a: n
        };
    }, AUn = F3(function(n, r, t) {
        var e = t.Ck, u = FP(A2(bp, r.fS, r.bj)), a = Bx(n), i = function() {
            var n = r.t6;
            if (3 === n.$) {
                var t = n.a;
                return b(Vt(EL(t)), ZE(t));
            }
            return b(Ut, "");
        }(), c = i.a, o = i.b, f = function() {
            if (c.$) return Pp;
            var n = c.a;
            return A7(OU, r.gF, a, Vt(e.rh), n, h, !1, yUn);
        }(), s = A2(qx, x6(pd), A3(SU, !0, r.gF, a)), l = s.b;
        return b({
            gF: r.gF,
            eq: Ut,
            yR: r.yR,
            bh: !1,
            gY: !1,
            hk: cP,
            aZ: s.a,
            kA: r.kA,
            b0: vc,
            a3: Ut,
            fe: vc,
            Cr: c,
            la: o,
            Cv: zRn("plan-checkout-payment-source-select"),
            Cw: cP,
            uD: e.rh,
            dB: n,
            Dk: Ut,
            cS: !1,
            lJ: u
        }, Vu(x([
            A4(FRn, r.gF, a, e.rh, kUn),
            f,
            A2(Lp, xUn, l),
            A3(Ran, r.gF, a, _Un)
        ])));
    }), CUn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BUn = function(n) {
        return n.ln;
    }, EUn = function(n) {
        return n.lp;
    }, DUn = function(n) {
        var r = n.eq;
        if (r.$) return 0;
        var t = r.a;
        return A2(sc, 0, EUn(t)) + A2(sc, 0, A2(KRn, J8(t), BUn(t))) + xZn(t);
    }, qUn = F2(function(n, r) {
        return NRn({
            yj: DUn(n),
            gF: n.gF,
            yR: n.yR,
            CD: Bx(n.dB),
            DJ: r,
            Ec: CUn
        });
    }), FUn = F2(function(n, r) {
        var t = !i(n.yR, r.yR), e = m(r, {
            yR: n.yR,
            fe: t ? vc : r.fe
        });
        return b(e, t ? A2(qUn, e, r.Dk) : Pp);
    }), PUn = F2(function(n, r) {
        return m(r, {
            x6: Ut
        });
    }), zUn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jUn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, SUn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, LUn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MUn = function(n) {
        return n.yz;
    }, NUn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (z = n.a).$ ? v(k = m(r, {
                    eq: Vt(M = z.a)
                }), A2(qUn, k, k.Dk), h) : v(r, Pp, A2(xA, 0, z));
            case 1:
                return 3 === (z = n.a).$ ? v(m(r, {
                    hk: z,
                    aZ: e = A2(xMn, z.a, r.aZ)
                }), Pp, h) : v(m(r, {
                    hk: z
                }), Pp, A2(xA, 0, z));
            case 2:
                var t = A2(rO, y = n.a, r.aZ), e = t.a, u = t.b, a = t.c, c = a.$ || a.a.$ ? r.cS : r.cS && !BY(e);
                return v(m(r, {
                    aZ: e,
                    cS: c
                }), A2(Lp, xUn, u), h);
            case 3:
                if (3 === (z = n.a).$) {
                    var o = XRn(z.a);
                    return v(k = m(r, {
                        Cw: z,
                        Dk: o
                    }), A2(qUn, k, o), h);
                }
                return v(m(r, {
                    Cw: z
                }), Pp, A2(xA, 0, z));
            case 4:
                return v(m(r, {
                    fe: n.a
                }), Pp, h);
            case 5:
                var f = A3(nZn, n.a, r.Cv, r.Dk), s = f.a, l = f.b, d = f.c, p = !i(A2(Fp, Qin, l), A2(Fp, Qin, r.Dk)), g = function() {
                    if (d) {
                        var n = A6(ifn, !1, r.kA, r.dB, r.yR, Ut, r.gF), t = n.b;
                        return b(Vt(n.a), A2(Lp, zUn, t));
                    }
                    return b(p ? Ut : r.a3, Pp);
                }(), w = g.b, k = m(r, {
                    b0: vc,
                    a3: g.a,
                    Cv: s,
                    Dk: l
                });
                return d ? v(k, w, h) : p ? v(m(k, {
                    fe: vc
                }), A2(qUn, k, l), h) : v(k, Pp, h);
            case 6:
                var y = n.a, _ = r.a3;
                if (1 === _.$) return v(r, Pp, h);
                var A = A2(Rsn, y, _.a), C = A.b, B = A.c, E = m(r, {
                    a3: Vt(A.a)
                }), D = x([
                    A2(Lp, zUn, C)
                ]);
                n: for(; !B.$;)switch(B.a.$){
                    case 1:
                        var q = B.a.a, F = 3 !== (R = r.Cw).$ || !TE(R.a);
                        return v(m(E, {
                            b0: cP
                        }), Vu(A2(Yt, A4(ssn, r.gF, q, {
                            dx: !1,
                            u1: !1,
                            vG: Ut,
                            wb: !F
                        }, SUn), D)), h);
                    case 0:
                        var P = B.a.a;
                        return v(m(E, {
                            b0: vc
                        }), Vu(D), x([
                            hA(P)
                        ]));
                    default:
                        break n;
                }
                return v(E, Vu(D), h);
            case 7:
                var z;
                if (3 === (z = n.a).$) {
                    var j = z.a, S = function() {
                        var n = r.Cw;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(Zy, $(n.a, x([
                                j
                            ])), t);
                        }
                        return n;
                    }();
                    return v(k = m(r, {
                        b0: z,
                        a3: Ut,
                        fe: vc,
                        Cw: S,
                        Dk: Vt(j)
                    }), A2(qUn, k, Vt(j)), h);
                }
                return v(m(r, {
                    b0: z
                }), Pp, A2(xA, 0, z));
            case 8:
                return v(m(r, {
                    b0: vc,
                    a3: Ut
                }), Pp, h);
            case 9:
                return v(r, 1 === r.a3.$ ? Pp : A2(Lp, zUn, esn), h);
            case 10:
                if (BY(r.aZ)) {
                    var L = v(r.Cr, r.Dk, r.eq);
                    if (L.a.$ || L.b.$ || L.c.$) return v(r, Pp, h);
                    var M, N = L.a.a, H = L.b.a, T = A2(sc, 1, A2(KRn, Q8(M = L.c.a), A2(Fp, EV, MUn(M))));
                    return v(m(r, {
                        bh: !0,
                        cS: !1
                    }), A4(WRn, r.gF, Bx(r.dB), {
                        rL: x([
                            LUn({
                                x4: OPn(r.aZ),
                                rh: r.uD,
                                A8: x([
                                    N
                                ]),
                                tU: N,
                                Cz: T,
                                DN: r.lJ
                            })
                        ]),
                        Ct: Qin(H)
                    }, jUn), h);
                }
                return v(m(r, {
                    cS: !0
                }), Pp, h);
            case 11:
                var I = n.a;
                return 3 === I.$ ? v(m(r, {
                    bh: !1,
                    gY: !0
                }), Pp, h) : v(m(r, {
                    bh: !1
                }), Pp, A2(xA, 0, I));
            default:
                return v(r, A2(AA, da, _a), h);
        }
        var R;
    }), HUn = {
        $: 12
    }, TUn = function(n) {
        return n.G.n6;
    }, IUn = function(n) {
        return n.G.hl;
    }, RUn = function(n) {
        return n.G.zB;
    }, ZUn = function(n) {
        return n.G.A4;
    }, VUn = function(n) {
        return n.G.dt;
    }, UUn = function(n) {
        return n.G.ia;
    }, YUn = function(n) {
        return n.G.tN;
    }, QUn = function(n) {
        return n.G.dz;
    }, OUn = function(n) {
        return n.G.CU;
    }, GUn = function(n) {
        return n.G.wM;
    }, JUn = function(n) {
        return n.G.jF;
    }, WUn = function(n) {
        return n.G.dY;
    }, KUn = function(n) {
        return n.G.w5;
    }, XUn = {
        $: 8
    }, nYn = {
        $: 13
    }, rYn = {
        $: 9
    }, tYn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, eYn = F2(function(n, r) {
        return A2(Ck, xUn, A3(VG, n, x([
            iO(r.cS),
            aO(r.bh)
        ]), r.aZ));
    }), uYn = {
        $: 10
    }, aYn = F2(function(n, r) {
        var t = r.eq;
        if (t.$) return tB;
        var e = t.a, u = xZn(e), a = A2(sc, 0, EUn(e)), i = A2(sc, 0, A2(KRn, J8(e), BUn(e))), c = A2(KRn, A2(nv, O8, Q8(e)), MUn(e)), o = uC(r.fe), f = A2(sc, a + i + u, A2(Fp, hcn, o));
        return A2(LB, x([
            _H(BN)
        ]), x([
            a > 0 ? A2(LB, x([
                _H(cR),
                rB(Z0),
                rB(LI)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n(YUn))
                ])),
                A2(Ck, yu, A7(MV, n, a, !1, Ut, kF, !1, !1))
            ])) : tB,
            A2(LB, x([
                _H(cR),
                rB(Z0),
                rB(LI)
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(n(OUn))
                ])),
                A2(Ck, yu, A7(MV, n, i, !1, c, kF, !1, !1))
            ])),
            A2(Ck, yu, A2(CZn, n, u)),
            A2(Ck, yu, kZn(o)),
            Dk,
            A2(LB, x([
                _H(BN),
                rB(Z0),
                rB(LI)
            ]), x([
                A2(Ek, x([
                    O0
                ]), x([
                    ld(n(RUn))
                ])),
                A2(Ck, yu, A7(MV, n, f, !1, Ut, kF, !1, !1))
            ]))
        ]));
    }), iYn = F2(function(n, r) {
        var t = !i(r.Dk, Ut) && BY(r.aZ) && !r.bh;
        return A2(nk, x([
            Xx("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), x([
            A2(aYn, n, r),
            A2(OC, x([
                qC,
                CZ,
                EC(uYn),
                uF(!t),
                uln(r.bh)
            ]), x([
                ld(n(TUn))
            ]))
        ]));
    }), cYn = F2(function(n, r) {
        var t = !i(r.Dk, Ut) && BY(r.aZ) && !r.bh;
        return A2(nk, x([
            Xx("sidebar-wrap")
        ]), x([
            A2(aYn, n, r),
            A2(OC, x([
                qC,
                CZ,
                EC(uYn),
                uF(!t),
                uln(r.bh)
            ]), x([
                ld(n(TUn))
            ]))
        ]));
    }), oYn = function(n) {
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(Ek, x([
                _H(cR)
            ]), x([
                A2(X8, h, x([
                    ld(n(VUn))
                ]))
            ])),
            A2(Ek, x([
                $H
            ]), x([
                ld(n(GUn))
            ]))
        ]));
    }, fYn = F2(function(n, r) {
        return xU(x([
            kU({
                By: nYn,
                w5: n(KUn)
            }),
            Dk,
            GV({
                zm: A2(cYn, n, r),
                AX: x([
                    qZn({
                        A5: n(ZUn),
                        Bk: n(UUn),
                        BV: tYn,
                        la: r.la,
                        Cu: n(QUn),
                        Cv: r.Cv,
                        Cw: r.Cw,
                        Dk: i(r.a3, Ut) ? A2(Fp, $Zn, r.Dk) : Vt(hZn),
                        xl: n
                    }),
                    function() {
                        var t = r.a3;
                        if (t.$) return tB;
                        var e = t.a, u = 1 === r.b0.$;
                        return A2(nk, x([
                            Xx("mb-6")
                        ]), $(A2(Eu, Ck(zUn), Pln(e)), x([
                            FZn({
                                AD: eln(e),
                                AG: u,
                                Bw: XUn,
                                BA: rYn,
                                xl: n
                            })
                        ])));
                    }(),
                    oYn(n),
                    A2(eYn, n, r)
                ])
            }),
            JV(A2(iYn, n, r))
        ]));
    }), sYn = F2(function(n, r) {
        return {
            gN: x([
                r.gY ? bZn({
                    gN: n(JUn),
                    yE: n(IUn),
                    BE: HUn,
                    w5: n(WUn)
                }) : r.eq.$ ? A2(nk, x([
                    Xx("panel")
                ]), ck) : A2(fYn, n, r)
            ]),
            w5: n(KUn)
        };
    }), lYn = ZA({
        Ar: AUn,
        AQ: FUn,
        Db: PUn,
        DZ: function(n) {
            var r = n.a3.$ ? zx : A2(_S, zUn, Tfn);
            return Px(x([
                A2(_S, xUn, yY(n.aZ)),
                r
            ]));
        },
        En: NUn,
        Et: sYn
    }), dYn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, bYn = F3(function(n, r) {
        var t = {
            gF: r.gF,
            g8: A2(bp, r.fS, r.bj),
            db: 0,
            kA: r.kA,
            ic: 0,
            t6: Ut,
            k8: r.t6,
            ir: Ut,
            lb: h,
            dB: n,
            fu: "content-container",
            fw: !1,
            fC: Ut,
            fH: Ut,
            fL: vc,
            jc: Ut,
            jK: r.jK
        };
        return b(t, function(n) {
            return A3(WR, n.gF, Bx(n.dB), dYn);
        }(t));
    }), vYn = F2(function(n, r) {
        return b(r, Pp);
    }), mYn = F2(function(n, r) {
        return m(r, {
            x6: Vt(6)
        });
    }), pYn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), $Yn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hYn = nr("onWindowScroll", A2(nu, function(n) {
        return A2(nu, function(r) {
            return uu({
                xP: r,
                lR: n
            });
        }, A2(Tu, "x", q$));
    }, A2(Tu, "y", q$))), gYn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wYn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xYn = function(n) {
        return n.vN;
    }, kYn = function(n) {
        return n.vQ;
    }, yYn = function(n) {
        var r = n.a.kV;
        return kYn(r) || xYn(r);
    }, _Yn = F2(function(n, r) {
        var t, e = n.k8;
        if (3 === e.$) {
            var u = e.a;
            return kYn(t = u.kV) || xYn(t) ? Vt(EL(u)) : function(n) {
                return A2(Fp, uU, rv(A2(Rc, yYn, n)));
            }(r);
        }
        return Ut;
    }), AYn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, CYn = F2(function(n, r) {
        return A4(Rbn, n.gF, Bx(n.dB), r, AYn);
    }), BYn = F2(function(n, r) {
        return A2(Fp, uU, A2(yPn, n, r));
    }), EYn = function(n) {
        return n8(n);
    }, DYn = function(n) {
        var r = b(A2(BYn, n.db, n.lb), function(n) {
            return A2(Fp, uU, rv(A2(Rc, EYn, n.lb)));
        }(n));
        return r.a.$ ? r.b.$ ? "" : r.b.a : r.b.$ ? r.a.a : r.b.a;
    }, qYn = F2(function(n, r) {
        var t = A2(Rc, yYn, n.lb), e = be(t);
        return 1 === r.hq ? b(e > 1 && !i(n.db + 1, e) ? A2(CYn, n, A2(sc, "", A2(BYn, n.db + 1, t))) : A2(AA, da, Pa({
            rh: DYn(n)
        })), x([
            A2($A, 3, qb)
        ])) : b(Pp, r.ig);
    }), FYn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, PYn = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), zYn = A2(Pk, PYn, uu(iu)), jYn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            n5: o,
            rh: n,
            rC: c,
            rI: i,
            r_: a,
            r$: e,
            r0: u,
            wy: r,
            xs: t
        };
    }), SYn = A3(ly, "company_name", iy(C$), A3(ly, "is_checkout_page", jk, A3(ly, "is_retail_page", jk, A3(ly, "limit_available_location_groups", jk, A3(ly, "limit_available_practitioners", jk, A3(ly, "limit_available_locations", jk, A3(ly, "url", iy(C$), A3(ly, "slug", C$, A3(ly, "id", C$, uu(jYn)))))))))), LYn = A2(tu, iu, SYn), MYn = A3(ly, "prepay_first_payment_on_signup", jk, A3(ly, "dependent_limit", iy(F$), A3(ly, "collect_rate_schedule_on_signup", jk, A3(ly, "collect_start_date_on_signup", jk, A3(ly, "allow_coupons", jk, A3(ly, "accepts_new_signup", jk, A3(ly, "default_location", iy(zYn), A3(ly, "default_practitioner", iy(uin), A3(ly, "allowed_zip_codes_on_signup", vy(C$), A3(ly, "restrict_zip_codes_on_signup", jk, A3(ly, "collect_tobacco_use", jk, A3(ly, "allows_payer_on_behalf_on_signup", A2(nu, Amn, C$), A3(ly, "signup_page", LYn, A3(ly, "post_signup_button_label", iy(C$), A3(ly, "show_post_signup_footer_button", jk, A3(ly, "post_signup_message", iy(C$), A3(ly, "post_signup_redirect_url", iy(C$), A3(ly, "redirects_post_signup", jk, A3(ly, "min_enroll_age", iy(F$), A3(ly, "collect_ssn_on_signup", A2(nu, Amn, C$), A3(ly, "collect_broker_on_signup", A2(nu, Amn, C$), A3(ly, "collect_lead_source_on_signup", A2(nu, Amn, C$), A3(ly, "collect_payment_source_on_signup", A2(nu, Amn, C$), A3(ly, "collect_insurance_on_signup", A2(nu, Amn, C$), A3(ly, "collect_location_on_signup", A2(nu, Amn, C$), A3(ly, "collect_practitioner_on_signup", A2(nu, Amn, C$), A3(ly, "collect_address_on_signup", A2(nu, Amn, C$), A3(ly, "collect_billing_address_on_signup", A2(nu, Amn, C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(x) {
                                                                                            return function(k) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(A) {
                                                                                                            return function(C) {
                                                                                                                return function(B) {
                                                                                                                    return {
                                                                                                                        lY: k,
                                                                                                                        mu: y,
                                                                                                                        mw: p,
                                                                                                                        mz: g,
                                                                                                                        nR: r,
                                                                                                                        nS: n,
                                                                                                                        nT: c,
                                                                                                                        nW: u,
                                                                                                                        nX: i,
                                                                                                                        nY: e,
                                                                                                                        n_: a,
                                                                                                                        n$: t,
                                                                                                                        n0: A,
                                                                                                                        n1: o,
                                                                                                                        n2: _,
                                                                                                                        n3: $,
                                                                                                                        o6: x,
                                                                                                                        pa: w,
                                                                                                                        pd: C,
                                                                                                                        s6: f,
                                                                                                                        ld: v,
                                                                                                                        le: d,
                                                                                                                        lf: l,
                                                                                                                        uW: B,
                                                                                                                        vu: s,
                                                                                                                        vX: h,
                                                                                                                        lA: b,
                                                                                                                        lB: m
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))), NYn = A2(Pk, MYn, uu(iu)), HYn = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), NYn, t, A2(_P, function(n) {
            return vu(n) ? h : x([
                A2(Y_, "signup_page_id", n)
            ]);
        }(r), rA(e)));
    }), TYn = F4(function(n, r, t, e) {
        return A4(HYn, n, t, e, A2(X_, x([
            "signup_page_setting"
        ]), lL(r)));
    }), IYn = F5(function(n, r, t, e, u) {
        return A4(HYn, n, e, u, A2(X_, x([
            "signup_setting"
        ]), A2(X_, x([
            "companies",
            t
        ]), lL(r))));
    }), RYn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), ZYn = F3(function(n, r, t) {
        return {
            rh: n,
            kE: r,
            rQ: t
        };
    }), VYn = function(n) {
        return A2(sc, "", Vt(aU(n)));
    }, UYn = F2(function(n, r) {
        return A2(sc, "", A2(yPn, n, function(n) {
            return A2(Eu, VYn, n);
        }(r)));
    }), YYn = function(n) {
        return A2(Eu, uU, n);
    }, QYn = F2(function(n, r) {
        return A2(sc, -1, A2(tFn, n, r));
    }), OYn = F2(function(n, r) {
        var t = A2(QYn, r, YYn(n));
        return A3(ZYn, r, t, A2(UYn, t, n));
    }), GYn = F2(function(n, r) {
        return {
            kh: A2(OYn, n, r),
            lb: n
        };
    }), JYn = F5(function(n, r, t, e, u) {
        return b({
            gF: u,
            t6: t,
            dB: e,
            fw: !1,
            lv: r,
            lw: n
        }, Pp);
    }), WYn = function(n) {
        return n.nY;
    }, KYn = function(n) {
        return n.n$;
    }, XYn = function(n) {
        return n.rh;
    }, nQn = function(n) {
        return n.lB;
    }, rQn = F3(function(n, r, t) {
        return m(t, {
            O: WYn(r),
            P: KYn(r),
            bp: Vt(XYn(nQn(r))),
            hw: n.ir
        });
    }), tQn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eQn = function(n) {
        return _x(x([
            b("id", Ax(n))
        ]));
    }, uQn = function(n) {
        var r, t = Bx(n.dB), e = (r = n.t6).$ ? "" : avn(r.a), u = x([
            b("practitioner", A2(yL, eQn, n.lw)),
            b("location", A2(yL, eQn, n.lv))
        ]), a = b("patient", _x(u));
        return A5(chn, n.gF, t, e, a, tQn);
    }, aQn = F2(function(n, r) {
        if (1 === n.$) return {
            g1: uQn(r),
            hq: 0,
            h4: m(r, {
                fw: !0
            }),
            ig: h
        };
        var t = n.a;
        return 3 === t.$ ? {
            g1: Pp,
            hq: 1,
            h4: m(r, {
                t6: Vt(t.a),
                fw: !1
            }),
            ig: h
        } : {
            g1: Pp,
            hq: 0,
            h4: m(r, {
                fw: !1
            }),
            ig: A2(xA, 0, t)
        };
    }), iQn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.fC;
                if (e.$) return v(r, Pp, h);
                var u = A2(YLn, t, e.a), a = u.a, c = u.b, o = A5(JYn, a.lw, a.lv, r.t6, r.dB, r.gF), f = o.b;
                return v(m(r, {
                    fw: (l = o.a).fw,
                    fC: Vt(a),
                    fH: Vt(l)
                }), Vu(x([
                    A2(Lp, gYn, c),
                    A2(Lp, wYn, f)
                ])), h);
            case 3:
                return v(r, A2(Nu, iu, _u(wYn(t = n.a))), h);
            case 4:
                t = n.a;
                var s = r.fH;
                if (s.$) return v(r, Pp, h);
                var l, d = A2(aQn, t, l = s.a), p = A2(qYn, r, d), $ = p.a, g = p.b;
                return v(m(r, {
                    fw: d.h4.fw,
                    fH: Vt(d.h4)
                }), Vu(x([
                    $,
                    A2(Lp, wYn, d.g1)
                ])), g);
            case 1:
                var w = n.a;
                if (3 === w.$) {
                    var k = w.a, y = A2(Rc, yYn, r.lb), _ = function() {
                        if (be(y) > 1) {
                            var n = A2(GYn, y, avn(k));
                            return m(r, {
                                db: n.kh.kE,
                                t6: Vt(k),
                                jc: Vt(n)
                            });
                        }
                        var t = _vn(k).x0;
                        return m(r, {
                            t6: Vt(k),
                            ir: t
                        });
                    }();
                    return v(_, function(n) {
                        var r = n.t6;
                        if (r.$) return Pp;
                        var t = function(n) {
                            return n.n4;
                        }(r.a);
                        if (t.$) return A4(TYn, n.gF, Bx(n.dB), "", FYn);
                        var e = t.a;
                        return A5(IYn, n.gF, Bx(n.dB), function(n) {
                            return n.rh;
                        }(e), "", FYn);
                    }(_), h);
                }
                return v(r, Pp, A2(xA, 0, w));
            case 2:
                var A = n.a;
                if (3 === A.$) {
                    var C = A.a, B = (L = r.fC).$ ? A4(Rqn, r.gF, Wx(r.kA), r.dB, A2(rQn, r, C)) : b(L.a, h), E = B.b;
                    return v(m(r, {
                        fC: Vt(B.a),
                        fL: A
                    }), Vu(A2(Eu, Lp(gYn), E)), h);
                }
                return v(r, Pp, A2(xA, 0, A));
            case 5:
                var D = n.a;
                if (3 === D.$) {
                    var q = D.a, F = (S = A2(_Yn, r, q)).$ ? A2(AA, da, Wa) : A2(CYn, r, S.a);
                    return v(m(r, {
                        lb: q
                    }), F, h);
                }
                return v(m(r, {
                    lb: h
                }), Pp, A2(xA, 0, D));
            case 6:
            case 7:
                return v(r, function(n) {
                    return A2(hc, RYn(n), eX(n));
                }(r.fu), h);
            default:
                var P = n.a, z = n.b;
                if (z.$) return v(r, Pp, h);
                var j = z.a;
                return i(P, r.fu) ? v(m(r, {
                    ic: A2(Ve, 0, 24 - (j.ku.lR - j.jT.lR))
                }), Pp, h) : v(r, Pp, h);
        }
        var S, L;
    }), cQn = F2(function(n, r) {
        return A3(bIn, {
            aX: n.aX,
            a5: n.a5
        }, Xx("label"), r);
    }), oQn = F2(function(n, r) {
        if (TE(r)) return tB;
        if (n.$) return tB;
        var t = n.a;
        return A2(nk, x([
            Xx("provider-selection-stepper")
        ]), A2(Eu, function(n) {
            return A2(cQn, {
                aX: t,
                a5: be(r)
            }, n);
        }, r));
    }), fQn = function(n) {
        return A2(oQn, Vt(n.kh.kE), A2(Eu, function(n) {
            return A3(lIn, n.rQ, n.kE, !1);
        }, function(n) {
            return A2(Eu, OYn(n), YYn(n));
        }(n.lb)));
    }, sQn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, lQn = {
        $: 1
    }, dQn = F3(function(n, r, t) {
        return x([
            A2(Ek, x([
                rB(DB),
                _H(cR)
            ]), x([
                t
            ])),
            A2(OC, x([
                qC,
                CZ,
                uln(n),
                uF(!r),
                EC(sQn(lQn))
            ]), x([
                ld("Save")
            ]))
        ]);
    }), bQn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("hidden md:block sidebar-wrap"),
            A2(bT, "margin-top", OZ(n.ic) + "px"),
            Hq("sidebar-element")
        ]), A3(dQn, n.fw, r, t));
    }), vQn = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("md:hidden sidebar-mobile")
        ]), x([
            A2(nk, x([
                Xx("sidebar-wrap")
            ]), A3(dQn, n.fw, r, t))
        ]));
    }), mQn = F2(function(n, r) {
        return {
            gN: function() {
                var t = r.fC;
                if (t.$) return x([
                    tB
                ]);
                var e = t.a;
                if (BHn(e)) {
                    var u = function(n) {
                        return !n.lw.$;
                    }(e), a = function() {
                        var n = r.t6;
                        if (n.$) return tB;
                        var t = n.a;
                        return A2(nk, h, x([
                            ld("Are you done selecting provider & location for "),
                            QE(nvn(t)),
                            ld("?")
                        ]));
                    }(), i = function(n) {
                        return A2(nv, qFn, A2(Fp, BFn(n.g8), A2(nv, Avn, n.t6)));
                    }(r);
                    return x([
                        A2(zN, x([
                            jN(iR)
                        ]), x([
                            A2(EN, x([
                                JI(12),
                                bR(8)
                            ]), x([
                                A2(nk, x([
                                    Hq("content-container"),
                                    Xx("panel")
                                ]), x([
                                    function() {
                                        var n = r.jc;
                                        if (n.$) return tB;
                                        var t = n.a;
                                        return A2(nk, x([
                                            Xx("mb-6")
                                        ]), x([
                                            fQn(t)
                                        ]));
                                    }(),
                                    A2(Ck, gYn, A3(iIn, n, x([
                                        CHn(i)
                                    ]), e))
                                ]))
                            ])),
                            A2(EN, x([
                                bR(4),
                                KN(x([
                                    Xx("hidden md:block")
                                ]))
                            ]), x([
                                A3(bQn, r, u, a)
                            ]))
                        ])),
                        A3(vQn, r, u, a)
                    ]);
                }
                return x([
                    A2(nk, h, ck)
                ]);
            }(),
            w5: "Select Provider & Location"
        };
    }), pQn = ZA({
        Ar: bYn,
        AQ: vYn,
        Db: mYn,
        DZ: function() {
            return Px(x([
                hYn($Yn),
                RJ(pYn)
            ]));
        },
        En: iQn,
        Et: mQn
    }), $Qn = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            dB: n,
            xs: t.CS
        }, Pp);
    }), hQn = F2(function(n, r) {
        return b(r, Pp);
    }), gQn = F2(function(n, r) {
        return r;
    }), wQn = F2(function(n, r) {
        return v(r, Pp, h);
    }), xQn = function(n) {
        return n.lx.pe;
    }, kQn = function(n) {
        return n.lx.w5;
    }, yQn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel")
                ]), x([
                    A2(LB, x([
                        lk,
                        rB(DB)
                    ]), x([
                        ld("Session expired")
                    ])),
                    A2(R7, h, h),
                    A2(ak, h, x([
                        ld("The link you used expired after 30 days and is no longer valid. ")
                    ])),
                    A2(ak, h, x([
                        ld("For continued access to this data, please sign in to our ")
                    ])),
                    A2(ak, x([
                        Xx("text-support")
                    ]), x([
                        A2(fB, x([
                            Xx("link"),
                            yB(_A(oi))
                        ]), x([
                            ld("patient portal")
                        ]))
                    ])),
                    A2(ak, h, x([
                        A4(YD, Ex(r.dB), qB(r.dB), Vt(". If you have any questions or concerns"), Ut)
                    ]))
                ]))
            ]),
            w5: n(kQn)
        };
    }), _Qn = Fk({
        Ar: $Qn,
        AQ: hQn,
        Db: gQn,
        DZ: function() {
            return zx;
        },
        En: wQn,
        Et: yQn
    }), AQn = F2(function(n, r) {
        return {
            vk: r,
            C9: n
        };
    }), CQn = function(n) {
        return {
            Ar: F2(function(r, t) {
                var e = n.Ar(t);
                return v(e, A2(AA, e.vk, e.C9), h);
            }),
            AQ: cm(A2(ru, iu, aRn)),
            Db: cm(iu),
            DZ: function() {
                return zx;
            },
            En: F2(function(n, r) {
                return v(r, Pp, h);
            }),
            Et: function() {
                return {
                    gN: ck,
                    w5: "Loading..."
                };
            }
        };
    }, BQn = CQn({
        Ar: function(n) {
            var r = Ua({
                rh: n.Ck.xd
            });
            return A2(AQn, r, da);
        }
    }), EQn = function(n) {
        return A2(cD, "joint_product", n);
    }, DQn = function(n) {
        return A2(cD, "patient_portal_polish", n);
    }, qQn = F3(function(n, r, t) {
        var e = function(n) {
            return EQn(n) && XG(n) && DQn(n);
        }(n);
        return b({
            kA: r.kA,
            t6: r.t6,
            ud: r.ud,
            dB: n,
            lz: e,
            xs: t.CS
        }, e ? Pp : function(n) {
            return A2(AA, da, n.bM ? Ca : Ea);
        }(r));
    }), FQn = F2(function(n, r) {
        return b(m(r, {
            t6: n.t6,
            ud: n.ud
        }), Pp);
    }), PQn = F2(function(n, r) {
        return m(r, {
            x6: Ut
        });
    }), zQn = F2(function(n, r) {
        return v(r, Pp, h);
    }), jQn = function(n) {
        return n.ki.gI;
    }, SQn = function(n) {
        return n.ki.xM;
    }, LQn = F2(function(n, r) {
        return A2(nk, x([
            Xx("dashboard__hero")
        ]), x([
            A2(LB, x([
                aq,
                L3
            ]), x([
                ld(n(SQn))
            ])),
            A2(LB, x([
                lk
            ]), x([
                ld(r)
            ]))
        ]));
    }), MQn = NB(4), NQn = F3(function(n, r, t) {
        return A2(fB, x([
            Xx("dashboard__widget"),
            yB(n)
        ]), x([
            A2(nk, x([
                Xx("dashboard__widget-icon")
            ]), x([
                A2(PE, x([
                    MQn
                ]), r)
            ])),
            A2(LB, x([
                bq,
                aq
            ]), x([
                ld(t)
            ]))
        ]));
    }), HQn = function(n) {
        return A2(nk, x([
            Xx("dashboard__grid")
        ]), x([
            A3(NQn, _A(Ha), 31, n(sb)),
            A3(NQn, _A($a), 32, n(jQn)),
            A3(NQn, _A(Ca), 33, n(wd)),
            A3(NQn, _A(Ea), 34, n(Vd))
        ]));
    }, TQn = F2(function(n, r) {
        var t, e = 3 === (t = r.ud).$ ? o$n(t.a) : "";
        return x([
            A2(nk, x([
                Xx("dashboard")
            ]), x([
                A2(LQn, n, e),
                HQn(n)
            ]))
        ]);
    }), IQn = F2(function(n, r) {
        return r.lz ? {
            gN: A2(TQn, n, r),
            w5: Ex(r.dB)
        } : {
            gN: ck,
            w5: Ex(r.dB)
        };
    }), RQn = ZA({
        Ar: qQn,
        AQ: FQn,
        Db: PQn,
        DZ: function() {
            return zx;
        },
        En: zQn,
        Et: IQn
    }), ZQn = F3(function(n, r, t) {
        var e = Bx(n), u = {
            gH: vc,
            bc: t.Ck.bc,
            kd: r.yY.CP,
            kA: r.kA,
            dB: n,
            xs: t
        };
        return b(u, A4(tA, u.kd, e, u.bc, iu));
    }), VQn = F2(function(n, r) {
        return b(r, Pp);
    }), UQn = F2(function(n, r) {
        return r;
    }), YQn = F2(function(n, r) {
        var t = n;
        return 3 === t.$ ? v(m(r, {
            gH: t
        }), Pp, h) : v(m(r, {
            gH: vc
        }), Pp, A2(xA, 0, t));
    }), QQn = function(n) {
        return n.mG;
    }, OQn = F3(function(n, r, t) {
        return A2(sc, tB, A2(Fp, function(r) {
            return A6(zB, n, GC(r), WC(r), KC(r), JC(r), t);
        }, A2(nv, QQn, uC(r))));
    }), GQn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("panel w-full")
                ]), x([
                    A2(nk, x([
                        Xx("text-center mb-6")
                    ]), x([
                        A2(yC, h, x([
                            ld(n(qA))
                        ]))
                    ])),
                    A3(OQn, n, r.gH, r.dB)
                ]))
            ]),
            w5: n(qA)
        };
    }), JQn = Fk({
        Ar: ZQn,
        AQ: VQn,
        Db: UQn,
        DZ: function() {
            return zx;
        },
        En: YQn,
        Et: GQn
    }), WQn = CQn({
        Ar: function(n) {
            var r = Da({
                rh: n.Ck.xd
            });
            return A2(AQn, r, n.iF);
        }
    }), KQn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, XQn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nOn = function(n) {
        return A2(X_, x([
            "appointment-types"
        ]), function(n) {
            return A2(X_, x([
                "booking"
            ]), K_(n));
        }(n));
    }, rOn = F3(function(n, r, t) {
        return A2(X_, x([
            r,
            "location",
            t
        ]), nOn(n));
    }), tOn = F3(function(n, r, t) {
        return A3(rOn, n, r, t);
    }), eOn = F5(function(n, r, t, e, u) {
        return A4(W_, n, PF, u, rA(A3(tOn, r, t, e)));
    }), uOn = F4(function(n, r, t, e) {
        return A5(eOn, n, r, t, e, XQn);
    }), aOn = F3(function(n, r, t) {
        var e = Bx(n), u = VF.b, a = {
            ci: vc,
            mH: t.Ck.mH,
            bH: vc,
            ck: Ut,
            nd: t.Ck.nd,
            kd: r.yY.CP,
            kA: r.kA,
            dB: n,
            ae: VF.a,
            xs: t
        }, i = oD(n) ? A4(uOn, a.kd, e, a.mH, a.nd) : ED;
        return b(a, Vu(x([
            i,
            A2(Lp, KQn, u)
        ])));
    }), iOn = F2(function(n, r) {
        return b(r, Pp);
    }), cOn = F2(function(n, r) {
        return r;
    }), oOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fOn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sOn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), lOn = F3(function(n, r, t) {
        return A2(X_, x([
            "availability"
        ]), A3(rOn, n, r, t));
    }), dOn = F6(function(n, r, t, e, u, a) {
        return A4(W_, n, wP, a, A2(_P, kP(r), rA(A3(lOn, t, e, u))));
    }), bOn = F6(function(n, r, t, e, u, a) {
        return A6(dOn, n, function(n) {
            return m(n, {
                DN: Vt(u)
            });
        }, r, t, e, sOn(a));
    }), vOn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bH: t,
                    ae: A2(Wz, i = t.a, r.ae)
                }), RP(A2(iP, 4, oP)), h) : v(m(r, {
                    bH: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = n.a, u = n.b, a = b(r.bH, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = cz(c), f = ZP(i), s = m(r, {
                        ci: u
                    });
                    return f && TE(o) ? v(s, A2(AA, da, ti), h) : v(m(s, {
                        ae: $ = A6(vz, e, r.ck, i, c, Ut, r.ae)
                    }), Pp, h);
                }
                return v(m(r, {
                    ci: vc
                }), Pp, A2(xA, 0, u));
            case 2:
                if ((y = n.a).$) return v(m(r, {
                    ck: Ut
                }), Pp, h);
                if (1 === (_ = y.a).$ && 4 === _.a) {
                    var l = A2(nv, Tz, _.b), d = A2(SP, l, r.ae);
                    if (d.$) return v(r, Pp, h);
                    var p = d.a, $ = p.a, g = p.b, w = Bx(r.dB), k = A6(bOn, r.kd, w, r.mH, r.nd, g, !0);
                    return v(m(r, {
                        ck: l,
                        ae: $
                    }), k, h);
                }
                return v(r, Pp, h);
            case 3:
                var y, _;
                return (y = n.a).$ ? v(r, Pp, h) : 2 === (_ = y.a).$ && 4 === _.a ? v(m(r, {
                    ck: Ut
                }), Pp, h) : v(r, Pp, h);
            default:
                var A = A2(Jz, n.a, r.ae), C = A.b, B = A.c, E = m(r, {
                    ae: $ = A.a
                }), D = A2(Lp, KQn, C);
                if (B.$) return v(E, D, h);
                var q = B.a;
                if (q.$) {
                    var F = q.a, P = b(E.bH, VP(r.ae));
                    if (3 !== P.a.$ || P.b.$) return v(E, D, h);
                    i = P.a.a;
                    var z = P.b.a, j = UP(r.ae);
                    if ((f = ZP(i)) && LP(j)) return v(E, D, h);
                    var S = A3(JP, F, z, A3(_z, f, j, A3(gz, fz(F), z, A2(sc, fP, E.ck)))), L = E.xs.iF;
                    return v(E, Vu(x([
                        Mz(S),
                        A2(AA, L, ri({
                            mH: r.mH,
                            nd: r.nd
                        }))
                    ])), h);
                }
                var M = EP(q.a);
                return w = Bx(r.dB), v(m(E, {
                    ci: cP
                }), Vu(x([
                    D,
                    A6(bOn, r.kd, w, r.mH, r.nd, zP(M), !1)
                ])), h);
        }
    }), mOn = function(n) {
        return 3 === n.ci.$ ? A2(Ck, KQn, A2(zj, n.dB, n.ae)) : A2(nk, h, ck);
    }, pOn = function(n) {
        var r, t = n.bH;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.ci).$ ? cz(r.a) : h, a = ZP(e) && 1 === be(u) ? A2(Fp, BC, UP(n.ae)) : Ut, i = qP(e);
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), x([
                A2($F, !1, {
                    eg: Ut,
                    yn: Vt(e),
                    nc: Vt(i),
                    t6: Ut,
                    fq: a
                }),
                mOn(n)
            ]));
        }
        return A2(nk, h, ck);
    }, $On = F2(function(n, r) {
        var t;
        return {
            gN: x([
                A2(nk, x([
                    Xx("flex flex-col gap-4")
                ]), x([
                    (t = r.bH, 3 === t.$ ? _F(Lj(t.a)) : tB),
                    pOn(r)
                ]))
            ]),
            w5: "Booking"
        };
    }), hOn = Fk({
        Ar: aOn,
        AQ: iOn,
        Db: cOn,
        DZ: function() {
            return Px(x([
                eP(oOn),
                aP(fOn)
            ]));
        },
        En: vOn,
        Et: $On
    }), gOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wOn = F3(function(n, r, t) {
        var e = Bx(n), u = Bx(n), a = A2(bp, r.fS, r.bj), i = !Tj(r.gF), c = {
            mH: t.Ck.mH,
            bH: vc,
            ck: Ut,
            nd: t.Ck.nd,
            kd: r.yY.CP,
            g6: r.gF,
            kA: r.kA,
            aQ: A6(hS, r.gF, u, a, !1, i, !1),
            dB: n,
            lH: vc,
            xs: t
        };
        return b(c, oD(n) ? A5(eOn, c.kd, e, c.mH, c.nd, gOn) : ED);
    }), xOn = F2(function(n, r) {
        return b(r, Pp);
    }), kOn = F2(function(n, r) {
        return r;
    }), yOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _On = function(n) {
        return {
            $: 3,
            a: n
        };
    }, AOn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, COn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BOn = F2(function(n, r) {
        if (n) {
            var t = KP(r), e = KP(r);
            return LP(e) || LP(t);
        }
        return !1;
    }), EOn = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2(BOn, n, t) || function(n) {
            var r = WP(n), t = pL(n), e = DP(n);
            return LP(e) || LP(t) || LP(r);
        }(t);
    }), DOn = F2(function(n, r) {
        return _x($(A2(_L, n, r), x([
            b("first_name", A2(yL, Ax, PL(r))),
            b("last_name", A2(yL, Ax, zL(r))),
            b("dob", A2(yL, Ax, DL(r))),
            b("email", A2(yL, Ax, qL(r))),
            b("phone", A2(yL, Ax, jL(r)))
        ])));
    }), qOn = F2(function(n, r) {
        return A2(X_, x([
            r
        ]), nOn(n));
    }), FOn = F6(function(n, r, t, e, u, a) {
        return A4(bL, n, xL, a, A2(vL, A2(DOn, e, u), rA(A2(qOn, r, t))));
    }), POn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bH: t
                }), RP(A2(iP, 4, oP)), h) : v(m(r, {
                    bH: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var e = n.a;
                if (e.$) return v(m(r, {
                    ck: Ut
                }), Pp, h);
                var u = e.a;
                if (1 === u.$ && 4 === u.a) {
                    var a = u.b, i = r.bH;
                    if (3 === i.$) {
                        var c = ZP(B = i.a), o = A2(nv, Tz, a), f = A2(ZL, o, A7(UL, r.g6, Bx(r.dB), r.aQ.g8, r.aQ.aJ, r.aQ.hL, r.aQ.hA, B)), s = function() {
                            if (A2(EOn, c, o)) {
                                var n = SD(qP(B)), t = BL(B);
                                return A2(AA, r.xs.iF, ni({
                                    mH: t,
                                    nd: n
                                }));
                            }
                            return Pp;
                        }();
                        return v(m(r, {
                            ck: o,
                            aQ: f
                        }), s, h);
                    }
                    return v(r, Pp, h);
                }
                return v(r, Pp, h);
            case 3:
                var l = A2(pN, n.a, r.aQ), d = l.b, p = l.c, $ = m(r, {
                    aQ: f = l.a
                }), g = A2(Lp, _On, d);
                if (p.$) return v($, g, h);
                var w = p.a, k = w.a, y = w.b, _ = Vt(A2(xN, k.fb, A2(kN, k.uw, A2(hN, k.pP, A2($N, A2(Fp, zP, k.pn), A2(wN, k.rS, A2(gN, k.qB, A2(sc, fP, r.ck)))))))), A = b(_, r.bH);
                if (A.a.$ || 3 !== A.b.$) return v($, g, h);
                var C = A.a.a, B = A.b.a, E = Bx(r.dB), D = function() {
                    if (y) {
                        var n = _x(x([
                            b("signature", Ax("")),
                            b("acceptance_type", Ax("checkbox")),
                            b("accepted", LC(!0))
                        ]));
                        return A5(mL, r.g6, E, "ephi_waiver", n, AOn);
                    }
                    return Pp;
                }(), q = SD(qP(B)), F = BL(B), P = A6(FOn, r.kd, E, F, q, C, COn);
                return v(m(r, {
                    ck: _,
                    lH: cP
                }), Vu(x([
                    g,
                    Mz(C),
                    P,
                    D
                ])), h);
            case 2:
                var z = n.a;
                switch($ = m(r, {
                    lH: z
                }), z.$){
                    case 3:
                        return v($, RP(A2(FS, 4, oP)), h);
                    case 2:
                        var j = z.a;
                        return v($, Pp, 5 === j.$ && 400 === j.a ? h : x([
                            A2($A, 1, vA)
                        ]));
                    default:
                        return v($, Pp, h);
                }
            default:
                return v(r, Pp, h);
        }
    }), zOn = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(AH, t, r.CS, r.iF) : tB;
    }), jOn = F2(function(n, r) {
        var t = r.bH;
        if (3 === t.$) {
            var e = t.a, u = A2(nv, dH, r.ck), a = A2(nv, pL, r.ck), i = BH(r.lH), c = qP(e);
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), x([
                A2($F, i, {
                    eg: a,
                    yn: Vt(e),
                    nc: Vt(c),
                    t6: Ut,
                    fq: u
                }),
                A2(Ck, _On, A5(LR, e, r.dB, i, n, r.aQ))
            ]));
        }
        return A2(nk, h, ck);
    }), SOn = F2(function(n, r) {
        return {
            gN: x([
                function() {
                    var t, e, u = r.lH;
                    if (3 === u.$) {
                        var a = u.a, i = b(r.bH, r.ck);
                        if (3 !== i.a.$ || i.b.$) return tB;
                        var c = i.a.a, o = i.b.a;
                        return A2(nk, x([
                            Xx("mt-12")
                        ]), x([
                            A5(wH, c, o, a, Ut, r.xs.iF)
                        ]));
                    }
                    return A2(nk, x([
                        Xx("flex flex-col gap-4")
                    ]), 3 === (e = r.bH).$ ? x([
                        A3(zOn, r.lH, r.xs, e.a),
                        (t = r.bH, 3 === t.$ ? _F(Lj(t.a)) : tB),
                        A2(jOn, n, r)
                    ]) : ck);
                }()
            ]),
            w5: "Booking"
        };
    }), LOn = Fk({
        Ar: wOn,
        AQ: xOn,
        Db: kOn,
        DZ: function() {
            return Px(x([
                eP(yOn),
                A2(_S, _On, ES())
            ]));
        },
        En: POn,
        Et: SOn
    }), MOn = F3(function(n, r, t) {
        var e = oD(n) ? Pp : ED;
        return b({
            kA: r.kA,
            dB: n,
            xs: t
        }, e);
    }), NOn = F2(function(n, r) {
        return b(r, Pp);
    }), HOn = F2(function(n, r) {
        return r;
    }), TOn = F2(function(n, r) {
        return v(r, Pp, h);
    }), IOn = function(n) {
        return A4(YD, Ex(n), qB(n), Vt("For new patients"), Vt("for information on how to sign up."));
    }, ROn = F2(function(n, r) {
        var t = r.dB;
        return {
            gN: x([
                A2(nk, h, x([
                    A2(yC, x([
                        rB(kF),
                        yF
                    ]), x([
                        ld("Book an appointment")
                    ])),
                    A2(LB, x([
                        rB(kF),
                        _H(yan)
                    ]), x([
                        IOn(t)
                    ]))
                ]))
            ]),
            w5: "Booking"
        };
    }), ZOn = Fk({
        Ar: MOn,
        AQ: NOn,
        Db: HOn,
        DZ: function() {
            return zx;
        },
        En: TOn,
        Et: ROn
    }), VOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, UOn = F3(function(n, r, t) {
        return A4(W_, n, bD, t, rA(function(n) {
            return nOn(n);
        }(r)));
    }), YOn = F2(function(n, r) {
        return A3(UOn, n.kd, r, VOn);
    }), QOn = F3(function(n, r, t) {
        var e = {
            ej: vc,
            kd: r.yY.CP,
            kA: r.kA,
            kN: BD,
            dB: n,
            xs: t
        };
        return b(e, oD(n) ? A2(YOn, e, Bx(n)) : ED);
    }), OOn = F2(function(n, r) {
        return b(r, Pp);
    }), GOn = F2(function(n, r) {
        return r;
    }), JOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WOn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = A2(jD, eD(r.xs.iF), zD(e)), a = TE(u) ? A2(AA, da, ti) : Pp;
                    return v(m(r, {
                        ej: t
                    }), a, h);
                }
                return v(m(r, {
                    ej: vc
                }), Pp, A2(xA, 0, t));
            case 1:
                var i = n.a, c = i.a, o = i.b, f = r.xs.iF;
                return oq(c) ? v(r, A2(AA, f, ha({
                    mH: vC(c),
                    nd: SD(o)
                })), h) : v(r, A2(AA, f, ni({
                    mH: vC(c),
                    nd: SD(o)
                })), h);
            default:
                var s = A2(VD, n.a, r.kN), l = s.b;
                return v(m(r, {
                    kN: s.a
                }), A2(Lp, JOn, l), h);
        }
    }), KOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XOn = F4(function(n, r, t, e) {
        var u, a = r.CS, i = A2(jD, eD(r.iF), zD(e)), c = A2(JD, GD, i), o = c.a, f = c.b;
        return A2(Yt, A2(Ck, JOn, A3(lF, n, i, t)), A2(Yt, A2(Ck, KOn, A2(dq, t, f)), TE(o) ? h : x([
            A2(nk, x([
                Xx("flex flex-col gap-2")
            ]), x([
                (u = a, kH(lc(u)) ? A2(Ek, x([
                    bq
                ]), x([
                    ld("Continue as guest")
                ])) : tB),
                A2(Ck, KOn, A2(dq, t, o))
            ]))
        ])));
    }), nGn = F2(function(n, r) {
        var t = r.ej;
        if (3 === t.$) {
            var e = t.a;
            return A2(nk, x([
                Xx("flex flex-col gap-4")
            ]), $(A4(XOn, n, r.xs, r.kN, e), x([
                QD(r.dB)
            ])));
        }
        return A2(nk, h, ck);
    }), rGn = F2(function(n, r) {
        if (3 === r.$) {
            var t = r.a, e = eD(n.iF);
            if (e.$) return _F(!0);
            var u = e.a, a = A2(wF, function(n) {
                return i(vC(n), u);
            }, zD(t));
            return _F(!!a.$ || gF(a.a));
        }
        return _F(!0);
    }), tGn = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("flex flex-col gap-4")
                ]), x([
                    A2(rGn, r.xs, r.ej),
                    A2(nGn, n, r)
                ]))
            ]),
            w5: "Booking"
        };
    }), eGn = Fk({
        Ar: QOn,
        AQ: OOn,
        Db: GOn,
        DZ: function() {
            return zx;
        },
        En: WOn,
        Et: tGn
    }), uGn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aGn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iGn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cGn = {
        $: 2
    }, oGn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fGn = function(n) {
        return n.lY;
    }, sGn = Wn("fullStoryPortIdentifySignup", Ax), lGn = function(n) {
        return function(n) {
            return sGn(n);
        }(n);
    }, dGn = F2(function(n, r) {
        if (n.$) return tB;
        var t = n.a, e = A2(IN, x([
            MN,
            LN("mailto:" + t)
        ]), x([
            ld(t)
        ]));
        return r.$ ? e : A2(FI, h, x([
            ld(" or "),
            e
        ]));
    }), bGn = function(n) {
        if (n.$) return tB;
        var r = n.a;
        return A2(IN, x([
            MN,
            LN("tel:" + r)
        ]), x([
            ld(wB(r))
        ]));
    }, vGn = function(n) {
        return A2(nk, x([
            Xx("panel w-full")
        ]), x([
            A2(Ak, h, x([
                ld("The practice is not currently accepting new members")
            ])),
            Dk,
            A2(Ek, h, x([
                ld("Please contact us and let us know the plan you would like to sign up for at "),
                bGn(qB(n)),
                A2(dGn, xx(n), qB(n))
            ]))
        ]));
    }, mGn = function(n) {
        return {
            Ar: F2(function(r, t) {
                var e = v(r.dB, r.fL, r.fc);
                n: for(;;)switch(e.a.$){
                    case 2:
                        return v(cGn, Pp, h);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                if (!e.c.$) {
                                    var u = e.a.a;
                                    return fGn(a = e.b.a) ? v(aGn(t), Pp, h) : v(iGn(u), Pp, h);
                                }
                                var a;
                                if (u = e.a.a, !fGn(a = e.b.a)) return v(iGn(u), Pp, h);
                                switch(r.DF.$){
                                    case 3:
                                        return A2(Fx, uGn, A2(wx, h, A4(n.Ar, u, a, r, t)));
                                    case 2:
                                        return v(oGn(u), Pp, h);
                                    default:
                                        return v(aGn(t), Pp, h);
                                }
                            case 2:
                                return v(oGn(u = e.a.a), Pp, h);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return v(aGn(t), Pp, h);
            }),
            AQ: F2(function(r, t) {
                var e = v(r.dB, r.fL, t);
                n: for(; !e.c.$;)switch(e.a.$){
                    case 2:
                        return b(cGn, Pp);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                var u = e.b.a, a = e.c.a, c = A4(n.Ar, d = e.a.a, u, r, a), o = c.a, f = c.b;
                                if (fGn(u)) {
                                    var s = b(r.fc, r.DF);
                                    r: for(;;)switch(s.b.$){
                                        case 3:
                                            switch(s.a.$){
                                                case 2:
                                                    var l = s.a.a;
                                                    return b(uGn(o), Vu(x([
                                                        f,
                                                        lGn(l)
                                                    ])));
                                                case 1:
                                                    return b(uGn(o), Vu(x([
                                                        f,
                                                        Dx(d)
                                                    ])));
                                                default:
                                                    break r;
                                            }
                                        case 2:
                                            return b(oGn(d), Pp);
                                        default:
                                            break r;
                                    }
                                    return b(aGn(a), Pp);
                                }
                                return b(iGn(d), Pp);
                            case 2:
                                var d;
                                return b(oGn(d = e.a.a), Pp);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                if (1 === t.$) {
                    var p = t.a;
                    return A2(qx, uGn, A2(n.AQ, r, m(p, {
                        kA: i(r.kA, p.kA) ? p.kA : r.kA
                    })));
                }
                return b(t, Pp);
            }),
            Db: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Db, r.a, t) : t;
            }),
            DZ: function(r) {
                return 1 === r.$ ? n.DZ(r.a) : zx;
            },
            En: F2(function(r, t) {
                return 1 === t.$ ? A2(Fx, uGn, A2(n.En, r, t.a)) : v(t, Pp, h);
            }),
            Et: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.Et, Wx(t.kA), t);
                    case 2:
                        return {
                            gN: x([
                                qk
                            ]),
                            w5: "404"
                        };
                    case 3:
                        return {
                            gN: x([
                                (e = r.a, A2(nk, x([
                                    Xx("panel w-full")
                                ]), x([
                                    A2(Ak, h, x([
                                        ld("We can't find the signup page you were looking for")
                                    ])),
                                    Dk,
                                    A2(Ek, h, x([
                                        ld("Please contact us and let us know the plan you would like to sign up for at "),
                                        bGn(qB(e)),
                                        A2(dGn, xx(e), qB(e))
                                    ]))
                                ])))
                            ]),
                            w5: "404"
                        };
                    case 4:
                        return {
                            gN: x([
                                vGn(r.a)
                            ]),
                            w5: "404"
                        };
                    default:
                        return {
                            gN: ck,
                            w5: "Loading..."
                        };
                }
                var e;
            }
        };
    }, pGn = F4(function(n, r, t, e) {
        return {
            kA: e,
            dB: n,
            lB: r,
            xs: t
        };
    }), $Gn = function(n) {
        return n.l0;
    }, hGn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gGn = function(n) {
        return A2(he, F2(function(n, r) {
            return A2(hGn, r, n);
        }), n);
    }, wGn = function(n) {
        return gGn(A2(Rc, function(n) {
            return $Gn(n);
        }, n));
    }, xGn = function(n) {
        return n.wy;
    }, kGn = F2(function(n, r) {
        var t = n, e = xGn(r);
        switch(t.tg){
            case 0:
                return vi({
                    wy: e
                });
            case 1:
                return di({
                    wy: e
                });
            case 2:
                return $i({
                    wy: e
                });
            case 3:
                return hi({
                    wy: e
                });
            case 4:
                return mi({
                    wy: e
                });
            case 5:
                return pi({
                    wy: e
                });
            case 6:
                return gi({
                    wy: e
                });
            default:
                return bi({
                    wy: e
                });
        }
    }), yGn = F3(function(n, r, t) {
        var e = rv(wGn(r));
        return e.$ ? ED : A2(AA, t, A2(kGn, e.a.a, n));
    }), _Gn = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.DF).$ ? u.a : h, i = nQn(r);
        return b(A4(pGn, n, i, e, t.kA), A3(yGn, i, a, e.iF));
    }), AGn = F2(function(n, r) {
        return b(r, Pp);
    }), CGn = F2(function(n, r) {
        return r;
    }), BGn = F2(function(n, r) {
        return v(r, Pp, h);
    }), EGn = F2(function(n, r) {
        var t = r.dB;
        return {
            gN: x([
                tB
            ]),
            w5: Ex(t)
        };
    }), DGn = mGn({
        Ar: _Gn,
        AQ: AGn,
        Db: CGn,
        DZ: function() {
            return zx;
        },
        En: BGn,
        Et: EGn
    }), qGn = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            dB: n,
            fL: cP,
            xs: t
        }, A2(AA, t.iF, ki));
    }), FGn = F2(function(n, r) {
        return b(r, Pp);
    }), PGn = F2(function(n, r) {
        return r;
    }), zGn = F2(function(n, r) {
        return v(r, Pp, h);
    }), jGn = function(n) {
        return n.yT.w5;
    }, SGn = F2(function(n) {
        return {
            gN: x([
                tB
            ]),
            w5: n(jGn)
        };
    }), LGn = Fk({
        Ar: qGn,
        AQ: FGn,
        Db: PGn,
        DZ: function() {
            return zx;
        },
        En: zGn,
        Et: SGn
    }), MGn = F3(function(n, r, t) {
        var e = A2(Wu, "company", t.iF), u = function() {
            if (e.$) return b(A2(AA, t.iF, ki), t);
            var n = e.a, r = A2(fa, "company", t.iF);
            return b(A2(AA, r, xi({
                wy: UQ(n)
            })), m(t, {
                iF: r
            }));
        }();
        return b({
            kA: r.kA,
            dB: n,
            fL: cP,
            xs: u.b
        }, u.a);
    }), NGn = F2(function(n, r) {
        return b(r, Pp);
    }), HGn = F2(function(n, r) {
        return r;
    }), TGn = F2(function(n, r) {
        return v(r, Pp, h);
    }), IGn = F2(function() {
        return {
            gN: x([
                tB
            ]),
            w5: "Enroll"
        };
    }), RGn = Fk({
        Ar: MGn,
        AQ: NGn,
        Db: HGn,
        DZ: function() {
            return zx;
        },
        En: TGn,
        Et: IGn
    }), ZGn = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            dB: n,
            fL: cP,
            xs: t
        }, A2(AA, t.iF, Gi));
    }), VGn = F2(function(n, r) {
        return b(r, Pp);
    }), UGn = F2(function(n, r) {
        return r;
    }), YGn = F2(function(n, r) {
        return v(r, Pp, h);
    }), QGn = function(n) {
        return n.cW.pS;
    }, OGn = function(n) {
        return n.cW.pT;
    }, GGn = function(n) {
        return n.cW.CR;
    }, JGn = function(n) {
        return n.cW.w5;
    }, WGn = F2(function(n) {
        return {
            gN: x([
                tB
            ]),
            w5: n(JGn)
        };
    }), KGn = Fk({
        Ar: ZGn,
        AQ: VGn,
        Db: UGn,
        DZ: function() {
            return zx;
        },
        En: YGn,
        Et: WGn
    }), XGn = Wn("initializeRecaptchaPort", function() {
        return yx;
    }), nJn = function(n) {
        return A2(itn, n, h);
    }, rJn = Wn("removeTokenPort", function(n) {
        return _x(x([
            b("key", Ax(n.hQ))
        ]));
    }), tJn = rJn({
        hQ: "accountToken"
    }), eJn = x([
        0
    ]), uJn = function() {
        return "Email";
    }, aJn = F3(function(n, r, t) {
        var e, u, a = A2(Wu, "patient", t.iF), i = A2(Wu, "email", t.iF), c = aF(i) ? "automatic" : "manual", o = nJn("Authentication - Email Prompted"), f = (e = b(RA(r.gF), aF(i))).a ? wtn(r.gF) ? b(tJn, !1) : b(A2(AA, da, Wa), !1) : b(Pp, !!e.b), s = f.a, l = f.b;
        return b({
            gE: c,
            gF: r.gF,
            z: lS((u = A2(sc, "", i), {
                pP: u
            })),
            hm: l,
            kA: r.kA,
            Cr: a,
            dB: n,
            u3: l,
            iS: !1,
            xs: t,
            x: A2(vS, eJn, uJn)
        }, Vu(x([
            s,
            o,
            XGn(0)
        ])));
    }), iJn = F2(function(n, r) {
        return b(r, Pp);
    }), cJn = F2(function(n, r) {
        return r;
    }), oJn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fJn = {
        $: 1
    }, sJn = nr("gotRecaptchaInitializedPort", C$), lJn = F2(function(n) {
        return n;
    }), dJn = function(n) {
        return sJn(lJn(n));
    }, bJn = nr("gotRecaptchaTokenPort", A2(nu, function(n) {
        return A2(nu, function(r) {
            return uu({
                lr: r,
                xd: n
            });
        }, A2(Tu, "result", C$));
    }, A2(Tu, "token", C$))), vJn = F2(function(n, r) {
        var t = r.xd;
        switch(r.lr){
            case "ok":
                return n(te(t));
            case "recaptcha-not-defined":
                return n(Kt(0));
            default:
                return n(Kt(1));
        }
    }), mJn = function(n) {
        return bJn(vJn(n));
    }, pJn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $Jn = {
        $: 0
    }, hJn = function(n) {
        for(;;){
            var r = Ce(n);
            if (r.$) return !0;
            var t = r.a;
            if (" " !== (e = t.a) && "\n" !== e && "\t" !== e && "\r" !== e) return !1;
            n = t.b;
        }
        var e;
    }, gJn = nM(x([
        function(n) {
            var r = A3(Dy, " ", "", n.pP);
            return hJn(r) || lM(r) ? h : x([
                b(0, eM(A2(rM, uM, iM)))
            ]);
        }
    ])), wJn = Wn("getRecaptchaTokenPort", Ax), xJn = function(n) {
        return wJn(function(n) {
            return n ? "selfserve" : "signup";
        }(n));
    }, kJn = F2(function(n, r) {
        return A2(ctn, n, function(n) {
            return n ? "True" : "False";
        }(r));
    }), yJn = F3(function(n, r, t) {
        return A2(itn, r, A2(Yt, A2(kJn, "input_valid", n), t));
    }), _Jn = F2(function(n, r) {
        return A3(yJn, r, "Authentication - Email Submitted", x([
            A2(otn, "method", n)
        ]));
    }), AJn = function(n) {
        var r = A2(BM, gJn, n.z);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, CJn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            z: AJn(r).a,
            x: t
        });
    }), BJn = function() {
        return Vt(0);
    }, EJn = F2(function(n, r) {
        var t = BJn();
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(CJn, !1, r), {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), DJn = A2(Tu, "salt", C$), qJn = F5(function(n, r, t, e, u) {
        var a = _x(x([
            b("email", Ax(r)),
            b("practice_id", Ax(t)),
            b("google_recaptcha_token", A2(yL, Ax, e))
        ]));
        return A4(bL, gQ(n), DJn, u, A2(vL, a, rA(A2(X_, x([
            "auth",
            "request_code"
        ]), lL(t)))));
    }), FJn = F2(function(n, r) {
        return m(r, {
            pP: n
        });
    }), PJn = F2(function(n, r) {
        var t = BJn();
        return t.$ ? r : m(r, {
            x: A3(vN, !0, t.a, r.x)
        });
    }), zJn = F2(function(n, r) {
        return A2(PJn, n, m(r, {
            z: A3(dN, FJn, n, r.z)
        }));
    }), jJn = F2(function(n, r) {
        switch(n.$){
            case 5:
                return v(A2(zJn, n.a, r), Pp, h);
            case 0:
                return v(m(r, {
                    u3: !0
                }), xJn(1), h);
            case 4:
                var t = FL(r.z);
                return v(A2(EJn, t.pP, r), Pp, h);
            case 1:
                var e = r.hm ? A2(Nu, iu, _u($Jn)) : Pp;
                return v(m(r, {
                    hm: !1
                }), e, h);
            case 2:
                var u = B$(n.a), a = FL(r.z), i = (e = A5(qJn, r.gF, a.pP, Bx(r.dB), u, pJn), A2(BM, gJn, r.z));
                return i.$ ? v(m(r, {
                    z: i.a,
                    u3: !1
                }), Pp, h) : v(m(r, {
                    z: i.a.a
                }), e, h);
            default:
                var c = n.a, o = m(r, {
                    u3: !1
                });
                if (3 === c.$) {
                    var f = c.a, s = (p = A2(Wu, "redirectTo", r.xs.iF)).$ ? h : x([
                        b("redirectTo", p.a)
                    ]), l = $(x([
                        b("email", FL(r.z).pP),
                        b("salt", f)
                    ]), (d = r.Cr).$ ? s : $(s, x([
                        b("patient", d.a)
                    ])));
                    return v(o, Vu(x([
                        A2(AA, Ul(l), si),
                        A2(_Jn, r.gE, !0)
                    ])), h);
                }
                return v(o, A2(_Jn, r.gE, !1), A2(xA, 0, c));
        }
        var d, p;
    }), SJn = function(n) {
        return n.oW;
    }, LJn = function(n) {
        return SJn(n.a);
    }, MJn = function(n) {
        var r = A2(sc, "", LJn(n));
        return A2(k3, x([
            zG(r),
            x3(Ex(n)),
            Xx("mx-auto w-3/12 mb-10")
        ]), h);
    }, NJn = function(n) {
        return n.h_.g2;
    }, HJn = function(n) {
        return n.h_.qG;
    }, TJn = F2(function(n, r) {
        return r.r9(n);
    }), IJn = function(n) {
        return A2(zN, x([
            KN(x([
                Xx("email-result")
            ]))
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(nk, x([
                    Xx("email-result__logo")
                ]), x([
                    A2(FI, x([
                        $H
                    ]), x([
                        A2(PE, x([
                            iH
                        ]), 11)
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(12)
            ]), x([
                A2(R7, h, h),
                A2(Ek, x([
                    lk,
                    rB(DB),
                    nH
                ]), x([
                    ld("Check your email")
                ])),
                A2(R7, h, h),
                A2(Ek, x([
                    $H,
                    rB(DB)
                ]), x([
                    ld("We sent an email to you at " + n + ". It has a magic link that will grant you access. If you don't see it, check your spam folder.")
                ]))
            ]))
        ]));
    }, RJn = {
        $: 4
    }, ZJn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, VJn = "https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule", UJn = F2(function(n, r) {
        return r.sb(n);
    }), YJn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), QJn = F2(function(n, r) {
        return r.wm(n);
    }), OJn = function(n) {
        return n.wn;
    }, GJn = function(n) {
        return n.wo;
    }, JJn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), WJn = function(n) {
        return n.xY;
    }, KJn = F2(function(n, r) {
        var t = A3(YJn, r.z, r.x, 0), e = NJn, u = FL(r.z).pP;
        return A2(G_n, x([
            K_n($Jn)
        ]), x([
            A2(XH, x([
                HH(n(WJn)),
                VH(!0)
            ]), x([
                vI(x([
                    iI("e.g. name@example.com"),
                    gI(A2(pc, ZJn, iu)),
                    JT(t),
                    xI(u),
                    XT(RJn)
                ])),
                A2(ET, n, A3(JJn, r.z, r.x, 0))
            ])),
            A2(R7, h, h),
            A2(OC, x([
                qC,
                CZ,
                uF(t || r.u3),
                uln(r.u3)
            ]), x([
                ld(n(A2(rM, UJn, e)))
            ])),
            A2(R7, h, h),
            A2(R7, h, h),
            A2(Ek, x([
                fq,
                rB(DB)
            ]), x([
                A2(ak, h, x([
                    ld(n(A2(rM, QJn, A2(rM, UJn, e)))),
                    ld(" ")
                ])),
                A2(IN, x([
                    LN(VJn),
                    MN
                ]), x([
                    ld(n(OJn))
                ])),
                A2(ak, h, x([
                    ld(" "),
                    ld(n(GJn))
                ]))
            ]))
        ]));
    }), XJn = F2(function(n, r) {
        var t = x([
            lxn(1)
        ]), e = xQn;
        return IA(r) ? A3(wxn, t, Ut, ld(n(e))) : tB;
    }), nWn = F2(function(n, r) {
        var t = NJn, e = FL(r.z).pP;
        return A2(zN, x([
            KN(x([
                Xx("panel")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(yC, x([
                    _H(FO),
                    rB(DB)
                ]), x([
                    ld(n(HJn))
                ])),
                A2(Ek, x([
                    rB(DB)
                ]), x([
                    ld(n(A2(rM, TJn, t)))
                ])),
                A2(R7, h, h),
                A2(XJn, n, r.gF),
                r.iS ? IJn(e) : A2(KJn, n, r)
            ]))
        ]));
    }), rWn = F2(function(n, r) {
        return {
            gN: x([
                A2(zN, h, x([
                    Bon(x([
                        kcn(2),
                        bR(0)
                    ])),
                    A2(EN, x([
                        kcn(8),
                        bR(12)
                    ]), x([
                        MJn(r.dB),
                        A2(nWn, n, r)
                    ]))
                ]))
            ]),
            w5: Ex(r.dB)
        };
    }), tWn = function(n) {
        var r, t = Ex(n);
        return A2(nk, x([
            Xx("mx-auto mb-6 flex items-center justify-center border border-primary-600 rounded p-6 w-8/12 sm:w-5/12")
        ]), x([
            (r = LJn(n), r.$ ? ld(t) : A2(k3, x([
                zG(r.a),
                x3(t),
                Xx("max-w-full")
            ]), h))
        ]));
    }, eWn = function(n) {
        return n.sa;
    }, uWn = F2(function(n, r) {
        var t = A3(YJn, r.z, r.x, 0), e = NJn, u = FL(r.z).pP;
        return A2(G_n, x([
            K_n($Jn)
        ]), x([
            A2(Ek, x([
                nH,
                rB(DB)
            ]), x([
                ld(n(eWn))
            ])),
            A2(R7, h, h),
            A2(Tq, h, x([
                A2(ak, x([
                    Xx("sr-only")
                ]), x([
                    ld(n(WJn))
                ])),
                vI(x([
                    iI("name@example.com"),
                    gI(A2(pc, ZJn, iu)),
                    JT(t),
                    xI(u),
                    XT(RJn)
                ]))
            ])),
            A2(ET, n, A3(JJn, r.z, r.x, 0)),
            A2(nk, x([
                Xx("mt-4")
            ]), x([
                A2(OC, x([
                    qC,
                    CZ,
                    uF(t || r.u3),
                    uln(r.u3)
                ]), x([
                    ld(n(A2(rM, UJn, e)))
                ]))
            ])),
            A2(R7, h, h),
            A2(R7, h, h),
            A2(Ek, x([
                fq,
                $H,
                rB(DB)
            ]), x([
                A2(ak, h, x([
                    ld(n(A2(rM, QJn, A2(rM, UJn, e)))),
                    ld(" ")
                ])),
                A2(IN, x([
                    LN(VJn),
                    MN
                ]), x([
                    ld(n(OJn))
                ])),
                A2(ak, h, x([
                    ld(" "),
                    ld(n(GJn))
                ]))
            ]))
        ]));
    }), aWn = F2(function(n, r) {
        var t = FL(r.z).pP;
        return A2(nk, h, x([
            A2(yC, x([
                _H(FO),
                rB(DB)
            ]), x([
                ld(Ex(r.dB))
            ])),
            A2(XJn, n, r.gF),
            r.iS ? IJn(t) : A2(uWn, n, r)
        ]));
    }), iWn = F2(function(n, r) {
        return {
            gN: x([
                A2(zN, x([
                    KN(x([
                        Xx("px-4 sm:px-0")
                    ]))
                ]), x([
                    Bon(x([
                        kcn(2),
                        bR(0)
                    ])),
                    A2(EN, x([
                        kcn(8),
                        bR(12)
                    ]), x([
                        tWn(r.dB),
                        A2(aWn, n, r)
                    ]))
                ]))
            ]),
            w5: Ex(r.dB)
        };
    }), cWn = F2(function(n, r) {
        return DQn(r.dB) ? A2(iWn, n, r) : A2(rWn, n, r);
    }), oWn = Fk({
        Ar: aJn,
        AQ: iJn,
        Db: cJn,
        DZ: function() {
            return Px(x([
                mJn(oJn),
                dJn(fJn)
            ]));
        },
        En: jJn,
        Et: cWn
    }), fWn = function() {
        return "DateOfBirth";
    }, sWn = F3(function(n, r, t) {
        var e = lS({
            bk: iS("dob")
        });
        return b({
            gF: r.gF,
            hd: 0,
            cq: 0,
            kA: r.kA,
            kB: e,
            t6: vc,
            dB: n,
            xs: t.CS,
            x: A2(vS, x([
                0
            ]), fWn),
            jR: !1
        }, nJn("Authentication - DOB Requested"));
    }), lWn = F2(function(n, r) {
        return b(r, Pp);
    }), dWn = F2(function(n, r) {
        return m(r, {
            gF: n.gF,
            t6: n.t6
        });
    }), bWn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, vWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mWn = F2(function(n, r) {
        return m(r, {
            bk: n
        });
    }), pWn = F2(function(n, r) {
        return A2(ctn, n, oe(r));
    }), $Wn = F2(function(n, r) {
        return A3(yJn, r, "Authentication - DOB Submitted", x([
            A2(pWn, "attempts", n)
        ]));
    }), hWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gWn = F2(function(n, r) {
        return b(n, WFn(r.oY));
    }), wWn = function(n) {
        return uu(T$(n));
    }, xWn = A2(nu, wWn, A2(Tu, "token", C$)), kWn = F4(function(n, r, t, e) {
        var u = _x(x([
            t
        ]));
        return A4(bL, n, xWn, e, A2(vL, u, rA(A2(X_, x([
            "auth",
            "switch_patient"
        ]), lL(r)))));
    }), yWn = F2(function(n, r) {
        return b(r.a, n);
    }), _Wn = nM(x([
        function(n) {
            var r = rv(Ejn(n.bk));
            if (r.$) return h;
            var t, e = r.a;
            return x([
                b(0, (t = A2(rM, uM, tM), A2(yWn, t, e)))
            ]);
        }
    ])), AWn = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, mWn, A2(eN, n, t.bk), r);
    }), CWn = F2(function(n, r) {
        var t = A2(BM, _Wn, A2(AWn, n, r.kB));
        return t.$ ? b(t.a, !1) : b(t.a.a, !0);
    }), BWn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = A2(CWn, n, r), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), EWn = function(n) {
        return n.cY.kw;
    }, DWn = function(n) {
        return n.cY.vT;
    }, qWn = function(n) {
        return n.cY.jD;
    }, FWn = function(n) {
        return n.cY.D_;
    }, PWn = function(n) {
        return n.cY.w5;
    }, zWn = function(n) {
        return n.cY.xW;
    }, jWn = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(BWn, !0, r), e = t.a;
                return t.b ? v(m(e, {
                    cq: r.cq + 1
                }), function(n) {
                    var r = Bx(n.dB), t = FL(n.kB);
                    return A4(kWn, n.gF, r, A2(gWn, "dob", t.bk), hWn);
                }(e), h) : v(e, Pp, h);
            case 0:
                var u = n.a;
                switch(u.$){
                    case 3:
                        var a = u.a;
                        return v(m(r, {
                            hd: 3,
                            jR: !0
                        }), A2($Wn, r.cq, !0), x([
                            A2($A, 3, FWn),
                            bWn(a)
                        ]));
                    case 2:
                        return u.a.$ ? v(m(r, {
                            hd: 2
                        }), A2($Wn, r.cq, !1), A2(Yt, A2($A, 1, EWn), A2(xA, 0, u))) : v(m(r, {
                            hd: 1
                        }), A2($Wn, r.cq, !1), h);
                    default:
                        return v(r, Pp, h);
                }
            default:
                var i = n.a, c = FL(r.kB), o = A2(uN, i, c.bk), f = o.b;
                return v(m(r, {
                    kB: A3(dN, mWn, o.a, r.kB)
                }), A2(Lp, vWn, f), h);
        }
    }), SWn = {
        $: 1
    }, LWn = F2(function(n, r) {
        return A2(sc, "", r) + "Please contact " + n + " for more information";
    }), MWn = A3(wxn, x([
        lxn(0)
    ]), Vt("No matching date of birth found."), tB), NWn = F3(function(n, r, t) {
        var e = FL(t.kB).bk;
        return A2(zN, h, x([
            A2(EN, x([
                kcn(12)
            ]), x([
                A2(XH, x([
                    HH("Date of birth"),
                    VH(!0)
                ]), x([
                    A2(Ck, vWn, A3(mI, n, x([
                        RT(r)
                    ]), e))
                ])),
                A2(R7, h, h),
                function() {
                    var n;
                    switch(t.hd){
                        case 1:
                            return MWn;
                        case 2:
                            return n = t.dB, A3(wxn, x([
                                lxn(0)
                            ]), Vt(A2(LWn, Ex(n), Ut)), tB);
                        default:
                            return A2(nk, h, h);
                    }
                }(),
                A2(R7, h, h),
                A2(OC, x([
                    qC,
                    CZ,
                    uF(r),
                    EC(SWn)
                ]), x([
                    ld("Sign in")
                ])),
                A2(R7, h, h),
                A2(R7, h, h)
            ]))
        ]));
    }), HWn = A2(zN, x([
        KN(h)
    ]), x([
        A2(EN, x([
            JI(12)
        ]), x([
            A2(nk, x([
                Xx("text-center")
            ]), x([
                ik(x([
                    Rnn
                ]))
            ]))
        ]))
    ])), TWn = F2(function(n, r) {
        return A2(zN, x([
            KN(x([
                Xx("panel")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(yC, x([
                    _H(FO),
                    rB(DB)
                ]), x([
                    ld("Provide date of birth")
                ])),
                A2(Ek, x([
                    rB(DB)
                ]), x([
                    ld("To ensure you access the correct account, please provide the date of birth as your email is linked to multiple members.")
                ])),
                A2(R7, h, h),
                r.jR ? HWn : A3(NWn, n, !1, r)
            ]))
        ]));
    }), IWn = F2(function(n, r) {
        return {
            gN: x([
                A2(zN, h, x([
                    Bon(x([
                        kcn(2),
                        bR(0)
                    ])),
                    A2(EN, x([
                        kcn(8),
                        bR(12)
                    ]), x([
                        MJn(r.dB),
                        A2(TWn, n, r)
                    ]))
                ]))
            ]),
            w5: "Provide date of birth"
        };
    }), RWn = Fk({
        Ar: sWn,
        AQ: lWn,
        Db: dWn,
        DZ: function() {
            return zx;
        },
        En: jWn,
        Et: IWn
    }), ZWn = {
        g2: ""
    }, VWn = Wn("replaceUrl", Ax), UWn = x([
        0
    ]), YWn = function() {
        return "Code";
    }, QWn = F3(function(n, r, t) {
        var e, u = A2(Wu, "salt", t.iF), a = A2(Wu, "patient", t.iF), i = (e = b(RA(r.gF), LP(u))).a ? A2(AA, da, Wa) : e.b ? A2(AA, da, oi) : VWn(A2(yH, x([
            t.CS.Cq
        ]), h)), c = nJn("Authentication - Code Prompted");
        return b({
            gF: r.gF,
            g2: "",
            E: lS(ZWn),
            ey: 0,
            bO: 0,
            pP: A2(Wu, "email", t.iF),
            kA: r.kA,
            Cr: a,
            dB: n,
            u3: !1,
            lo: A2(Wu, "redirectTo", t.iF),
            fv: u,
            b7: Ut,
            dT: !1,
            xs: t,
            x: A2(vS, UWn, YWn)
        }, Vu(x([
            i,
            c
        ])));
    }), OWn = F2(function(n, r) {
        return b(r, Pp);
    }), GWn = F2(function(n, r) {
        return r;
    }), JWn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, WWn = function(n) {
        return {
            aN: n,
            w5: Ut
        };
    }, KWn = F2(function(n, r) {
        return A3(yJn, r, "Authentication - Code Submitted", x([
            A2(pWn, "attempts", n)
        ]));
    }), XWn = function(n) {
        return n.nP.rr;
    }, nKn = nM(x([
        function(n) {
            var r = n.g2;
            return 1 === pu(r).$ || 6 !== su(r) ? x([
                b(0, eM(XWn))
            ]) : h;
        }
    ])), rKn = function(n) {
        var r = A2(BM, nKn, n.E);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, tKn = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x;
        return m(r, {
            E: rKn(r).a,
            x: t
        });
    }), eKn = function() {
        return Vt(0);
    }, uKn = F2(function(n, r) {
        var t = eKn();
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(A2(tKn, !1, r), {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), aKn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iKn = F2(function(n, r) {
        var t = n.pP;
        return t.$ ? Pp : A5(qJn, n.gF, t.a, Bx(n.dB), r, aKn);
    }), cKn = F2(function(n, r) {
        return LP(r) && function(n) {
            if (n.$) return !1;
            var r = n.a;
            if (_$(r)) {
                var t = vy(C$);
                return A2(sc, !1, A2(Fp, function(n) {
                    return n > 1;
                }, B$(A2(Kp, function(n) {
                    return be(n);
                }, A2(x$, A2(Tu, "patients", t), r)))));
            }
            return !1;
        }(n);
    }), oKn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fKn = F8(function(n, r, t, e, u, a, i, c) {
        var o = _x(x([
            b("email", Ax(r)),
            b("code", Ax(e)),
            b("salt", Ax(t)),
            b("practice_id", Ax(u)),
            b("google_recaptcha_token", A2(yL, Ax, a)),
            b("patient_id", A2(yL, Ax, i))
        ]));
        return A4(bL, gQ(n), xWn, c, A2(vL, o, rA(A2(X_, x([
            "auth"
        ]), lL(u)))));
    }), sKn = F2(function(n, r) {
        var t = FL(n.E).g2, e = b(n.pP, n.fv);
        return e.a.$ || e.b.$ ? Pp : A8(fKn, n.gF, e.a.a, e.b.a, t, Bx(n.dB), r, n.Cr, oKn);
    }), lKn = function(n) {
        var r = A2(BM, nKn, n.E);
        return r.$ ? v(m(n, {
            E: r.a,
            u3: !1,
            x: jM(n.x)
        }), Pp, h) : v(m(n, {
            E: r.a.a,
            bO: n.bO + 1,
            u3: !0,
            b7: Ut
        }), A2(sKn, n, Ut), h);
    }, dKn = F2(function(n, r) {
        return m(r, {
            g2: n
        });
    }), bKn = F2(function(n, r) {
        var t = eKn();
        return t.$ ? r : m(r, {
            x: A3(vN, !0, t.a, r.x)
        });
    }), vKn = F2(function(n, r) {
        return A2(bKn, n, m(r, {
            E: A3(dN, dKn, n, r.E)
        }));
    }), mKn = F2(function(n, r) {
        switch(n.$){
            case 6:
                var t = FL((a = A2(vKn, n.a, r)).E).g2;
                return DQn(r.dB) && 6 === su(t) && !r.u3 ? lKn(a) : v(a, Pp, h);
            case 0:
                return lKn(r);
            case 5:
                var e = FL(r.E);
                return v(A2(uKn, t = e.g2, r), Pp, h);
            case 1:
                return v(m(r, {
                    g2: "",
                    E: lS(ZWn),
                    ey: r.ey + 1,
                    bO: 0,
                    u3: !0,
                    b7: Ut
                }), A2(iKn, r, Ut), h);
            case 2:
                var u = n.a, a = m(r, {
                    u3: !1
                });
                n: for(;;)switch(u.$){
                    case 3:
                        var i = u.a, c = function() {
                            if (A2(cKn, i, r.Cr)) {
                                var n = (t = r.lo).$ ? da : Ul(x([
                                    b("redirectTo", t.a)
                                ]));
                                return b(A2(AA, n, fi), x([
                                    JWn(i)
                                ]));
                            }
                            var t;
                            return b(Pp, x([
                                bWn(i)
                            ]));
                        }(), o = c.b;
                        return v(r, Vu(x([
                            c.a,
                            A2(KWn, r.bO, !0)
                        ])), o);
                    case 2:
                        if (5 === u.a.$) {
                            var f = u.a.b;
                            return v(m(a, {
                                b7: su(f) > 0 ? Vt(WWn(x([
                                    pA(f)
                                ]))) : Ut
                            }), A2(KWn, r.bO, !1), h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(a, A2(KWn, r.bO, !1), A2(xA, 0, u));
            case 3:
                var s = n.a;
                return a = m(r, {
                    u3: !1,
                    b7: Ut,
                    dT: !0
                }), 3 === s.$ ? v(m(a, {
                    fv: Vt(s.a)
                }), A2(itn, "Authentication - Code Resent", x([
                    A2(pWn, "quantity", r.ey)
                ])), h) : v(a, Pp, A2(xA, 0, s));
            default:
                return v(m(r, {
                    dT: !1
                }), Pp, h);
        }
    }), pKn = {
        $: 1
    }, $Kn = F2(function(n, r) {
        return r.xC(n);
    }), hKn = {
        $: 5
    }, gKn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, wKn = {
        $: 0
    }, xKn = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, kKn = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), yKn = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), _Kn = function(n) {
        return n.aN;
    }, AKn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), CKn = AKn, BKn = F2(function(n, r) {
        return be(r) ? A2(yon, x([
            A2(CKn, 2, 1),
            A2(CKn, 3, 1)
        ]), A2(Eu, function(r) {
            return bon(CT(n(r)));
        }, r)) : tB;
    }), EKn = function(n) {
        return n.w5;
    }, DKn = F2(function(n, r) {
        var t = x([
            lxn(0)
        ]);
        if (r.$) return tB;
        var e = r.a;
        return A3(wxn, t, EKn(e), A2(BKn, n, _Kn(e)));
    }), qKn = F2(function(n, r) {
        var t = A3(kKn, r.E, r.x, 0), e = FL(r.E).g2;
        return A2(G_n, x([
            K_n(wKn)
        ]), x([
            A2(XH, x([
                HH(n(zWn)),
                VH(!0)
            ]), x([
                vI(x([
                    iI("e.g. 123456"),
                    gI(A2(pc, gKn, iu)),
                    JT(t),
                    XT(hKn),
                    xI(e),
                    xKn(1),
                    $R("one-time-code")
                ])),
                A2(ET, n, A3(yKn, r.E, r.x, 0))
            ])),
            A2(R7, h, h),
            A2(OC, x([
                qC,
                CZ,
                uF(t || r.u3)
            ]), x([
                ld(n(qWn))
            ])),
            A2(R7, h, h),
            A2(R7, h, h),
            A2(DKn, n, r.b7),
            A2(Ek, x([
                fq,
                rB(DB)
            ]), x([
                A2(ak, h, x([
                    ld(n(A2(rM, QJn, qWn))),
                    ld(" ")
                ])),
                A2(IN, x([
                    LN("https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule"),
                    MN
                ]), x([
                    ld(n(OJn))
                ])),
                A2(ak, h, x([
                    ld(" "),
                    ld(n(GJn))
                ]))
            ]))
        ]));
    }), FKn = {
        $: 4
    }, PKn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zKn = F2(function(n, r) {
        var t = Vt("Code has been resent"), e = x([
            lxn(1),
            PKn(FKn)
        ]);
        return n ? A3(wxn, e, t, A4(YD, Ex(r), qB(r), Vt("If we have an account matching your email address, you will receive an email with the code. If you do not receive an email"), Ut)) : tB;
    }), jKn = F2(function(n, r) {
        return A2(zN, x([
            KN(x([
                Xx("panel")
            ]))
        ]), x([
            A2(EN, h, x([
                A2(yC, x([
                    _H(FO),
                    rB(DB)
                ]), x([
                    ld(n(PWn))
                ])),
                A2(Ek, x([
                    rB(DB)
                ]), x([
                    ld(n($Kn(A2(sc, "", r.pP))))
                ])),
                A2(LB, x([
                    rB(DB),
                    _H(fmn)
                ]), x([
                    A2(OC, x([
                        wO,
                        EC(pKn)
                    ]), x([
                        ld(n(DWn))
                    ]))
                ])),
                A2(R7, h, h),
                A2(zKn, r.dT, r.dB),
                A2(R7, h, h),
                A2(qKn, n, r)
            ]))
        ]));
    }), SKn = F2(function(n, r) {
        return x([
            A2(zN, h, x([
                Bon(x([
                    kcn(2),
                    bR(0)
                ])),
                A2(EN, x([
                    kcn(8),
                    bR(12)
                ]), x([
                    MJn(r.dB),
                    A2(jKn, n, r)
                ]))
            ]))
        ]);
    }), LKn = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, MKn = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, NKn = function(n) {
        return n.xA;
    }, HKn = F2(function(n, r) {
        return r.xB(n);
    }), TKn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    eY: n.a
                });
            case 1:
                return m(r, {
                    id: Vt(n.a)
                });
            case 2:
                return m(r, {
                    xz: n.a
                });
            case 3:
                return m(r, {
                    zn: n.a
                });
            default:
                return m(r, {
                    ei: n.a
                });
        }
    }), IKn = {
        ei: "",
        zn: !1,
        eY: 6,
        id: Ut,
        xz: ""
    }, RKn = F2(function(n, r) {
        var t = i(su(n), r), e = A3(lu, r, r + 1, n), u = !vu(e);
        return A2(nk, x([
            SC(x([
                b("code-input__box", !0),
                b("code-input__box--active", t),
                b("code-input__box--empty", !t && !u),
                b("code-input__box--filled", u && !t)
            ]))
        ]), x([
            ld(e)
        ]));
    }), ZKn = function(n) {
        var r, t, e = A3(de, TKn, IKn, n), u = (r = e.id).$ ? h : x([
            oT(r.a)
        ]), a = vu(e.ei) ? h : x([
            A2(jC, "aria-label", e.ei)
        ]), i = rc(x([
            x([
                Xx("code-input__field"),
                Vq("tel"),
                (t = e.eY, A2(br, "maxlength", oe(t))),
                A2(jC, "autocomplete", "one-time-code"),
                A2(jC, "inputmode", "numeric"),
                Iq(e.xz),
                NC(e.zn),
                cI(!0)
            ]),
            a,
            u
        ]));
        return A2(nk, x([
            Xx("code-input")
        ]), x([
            A2(Zq, i, h),
            A2(nk, x([
                Xx("code-input__boxes")
            ]), A2(Eu, RKn(e.xz), A2($e, 0, e.eY - 1)))
        ]));
    }, VKn = F2(function(n, r) {
        var t, e, u = A2(sc, "", r.pP), a = FL(r.E).g2;
        return A2(G_n, x([
            K_n(wKn)
        ]), x([
            A2(Ek, x([
                bq,
                _H(cR),
                rB(DB)
            ]), x([
                ld(n(HKn(u)))
            ])),
            A2(Ek, h, x([
                ld(n(NKn))
            ])),
            A2(nk, x([
                Xx("mt-8")
            ]), x([
                ZKn(x([
                    {
                        $: 0,
                        a: 6
                    },
                    (e = a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(e)),
                    MKn(A2(pc, gKn, iu)),
                    (t = r.u3, function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(t)),
                    LKn(n(zWn))
                ]))
            ])),
            A2(DKn, n, r.b7),
            A2(zKn, r.dT, r.dB),
            A2(nk, x([
                Xx("mt-4")
            ]), x([
                A2(OC, x([
                    wO,
                    EC(pKn),
                    uF(r.u3)
                ]), x([
                    ld(n(DWn))
                ]))
            ])),
            A2(ET, n, A3(yKn, r.E, r.x, 0))
        ]));
    }), UKn = F2(function(n, r) {
        return x([
            A2(zN, x([
                KN(x([
                    Xx("px-4 sm:px-0")
                ]))
            ]), x([
                Bon(x([
                    kcn(3),
                    bR(0)
                ])),
                A2(EN, x([
                    kcn(6),
                    bR(12)
                ]), x([
                    tWn(r.dB),
                    A2(yC, x([
                        _H(FO),
                        rB(DB)
                    ]), x([
                        ld(Ex(r.dB))
                    ])),
                    A2(VKn, n, r)
                ]))
            ]))
        ]);
    }), YKn = F2(function(n, r) {
        var t;
        return {
            gN: (t = b(r.pP, r.fv), t.a.$ || t.b.$ ? ck : DQn(r.dB) ? A2(UKn, n, r) : A2(SKn, n, r)),
            w5: Ex(r.dB)
        };
    }), QKn = Fk({
        Ar: QWn,
        AQ: OWn,
        Db: GWn,
        DZ: function() {
            return zx;
        },
        En: mKn,
        Et: YKn
    }), OKn = iRn({
        Et: function() {
            return {
                gN: x([
                    qk
                ]),
                w5: "404"
            };
        }
    }), GKn = CQn({
        Ar: function(n) {
            return A2(AQn, ya, n.iF);
        }
    }), JKn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WKn = function(n) {
        return 2 === n.$ ? Vt(n.a) : Ut;
    }, KKn = function(n) {
        return WKn(n.f0);
    }, XKn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, nXn = function(n) {
        return n.nR;
    }, rXn = function(n) {
        return r$n(nXn(n));
    }, tXn = function(n) {
        return n.vX ? n.mz : h;
    }, eXn = function(n) {
        return n.nS;
    }, uXn = function(n) {
        return r$n(eXn(n));
    }, aXn = function(n) {
        switch(n){
            case 0:
                return "Mailing Address";
            case 1:
                return "Billing Address";
            case 2:
                return "Addresses Are The Same";
            case 3:
                return "Insurance";
            default:
                return "Enrollment Status";
        }
    }, iXn = function(n) {
        return "field-" + aXn(n);
    }, cXn = F3(function(n, r, t) {
        return A4(QEn, tXn(r), Ex(n), xx(n), t ? A2(Mpn, uXn(r), Umn(iXn(1))) : A2(Mpn, rXn(r), Umn(iXn(0))));
    }), oXn = F4(function(n, r, t, e) {
        var u = A2(apn, n, r), a = u.a, i = u.b;
        return b({
            mk: A3(cXn, t, e, 0),
            aU: !0,
            mY: A3(cXn, t, e, 1),
            p6: !0,
            a1: a
        }, x([
            A2(Lp, XKn, i)
        ]));
    }), fXn = A3(ly, "billing_address_zip", iy(C$), A3(ly, "billing_address_state", iy(C$), A3(ly, "billing_address_line2", iy(C$), A3(ly, "billing_address_line1", iy(C$), A3(ly, "billing_address_country", iy(C$), A3(ly, "billing_address_city", iy(C$), A3(ly, "owner_pays_on_behalf", iy(jk), A3(ly, "health_insurance", iy(qbn), A3(ly, "address_zip", iy(C$), A3(ly, "address_state", iy(C$), A3(ly, "address_line2", iy(C$), A3(ly, "address_line1", iy(C$), A3(ly, "address_country", iy(C$), A3(ly, "address_city", iy(C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                ml: n,
                                                                mm: r,
                                                                mn: t,
                                                                mo: e,
                                                                mp: u,
                                                                mq: a,
                                                                mZ: o,
                                                                m_: f,
                                                                m$: s,
                                                                m0: l,
                                                                m1: d,
                                                                m2: b,
                                                                q0: i,
                                                                tV: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), sXn = A2(Pk, fXn, uu(iu)), lXn = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "additional_details"
        ]), lL(n));
    }), dXn = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), sXn, e, rA(A2(lXn, r, t)));
    }), bXn = function(n) {
        return WKn(n.fc);
    }, vXn = x([
        0,
        1,
        3,
        4
    ]), mXn = F4(function(n, r, t, e) {
        var u = A4(oXn, t.gF, !1, n, r), a = u.a, i = u.b, c = function() {
            var r = b(bXn(t), t.DF);
            if (3 === r.b.$) {
                if (r.a.$) return v(i, vc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return v(A2(Yt, A4(dXn, t.gF, Bx(n), e, JKn), i), cP, u);
            }
            return v(i, vc, h);
        }(), o = c.a, f = c.b, s = c.c;
        return b({
            f0: KKn(t),
            x9: Ut,
            gF: t.gF,
            gM: cK,
            hg: t.hg,
            kA: t.kA,
            kB: lS(a),
            fc: t.fc,
            ie: f,
            dB: n,
            u3: !1,
            cM: f,
            cN: cK,
            iZ: Ut,
            lB: nQn(r),
            fL: r,
            DF: s,
            xs: e,
            x: A2(vS, vXn, aXn)
        }, Vu(o));
    }), pXn = F2(function(n, r) {
        return b(r, Pp);
    }), $Xn = F2(function(n, r) {
        return r;
    }), hXn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), gXn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, wXn = nr("onUrlChange", C$), xXn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kXn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yXn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _Xn = {
        $: 8
    }, AXn = {
        $: 7
    }, CXn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BXn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, EXn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, DXn = {
        $: 15
    }, qXn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, FXn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, PXn = function(n) {
        return n.mw;
    }, zXn = F2(function(n, r) {
        return A2(PH, r, n);
    }), jXn = F2(function(n, r) {
        return A2(Eu, function(n) {
            return b(r, n);
        }, A2(zXn, n, r));
    }), SXn = function(n) {
        return A2(otn, "Error Description", n);
    }, LXn = function(n) {
        return A2(otn, "Error Name", n);
    }, MXn = function(n) {
        return A2(otn, "Field Name", n);
    }, NXn = function(n) {
        return n.a ? "required" : "validation";
    }, HXn = function(n) {
        return A2(sc, " ", A2(Fp, NXn, n));
    }, TXn = F2(function(n, r) {
        var t = r.qv, e = r.eH;
        return A2(itn, "Form Field Errored", x([
            stn(n),
            MXn(t),
            LXn(HXn(rv(e))),
            SXn(A2(fe, ", ", A2(Eu, $T(Wx(0)), e)))
        ]));
    }), IXn = "Member Signup 2.0", RXn = function(n) {
        return A2(TXn, IXn, n);
    }, ZXn = F2(function(n, r) {
        var t = rv(A2(bu, n, r));
        if (t.$) return b("", r);
        var e = t.a;
        return b(A2(mu, e, r), A2(iv, su(r) - e - su(n), r));
    }), VXn = F2(function(n, r) {
        var t = A2(ZXn, ": ", r), e = t.a, u = t.b;
        return su(e) > 0 ? b($(aXn(n), $(": ", e)), u) : b(aXn(n), r);
    }), UXn = function(n) {
        return A2(Eu, function(n) {
            var r = n.a, t = n.b, e = A2($T, Wx(0), t), u = function() {
                switch(r){
                    case 0:
                    case 1:
                        return A2(VXn, 0, e);
                    default:
                        return b(aXn(r), e);
                }
            }().a;
            return RXn({
                eH: x([
                    t
                ]),
                qv: u
            });
        }, function(n) {
            return rc(A2(Eu, jXn(n), vXn));
        }(n));
    }, YXn = {
        DW: d0(100),
        Ek: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, QXn = function(n) {
        return n.nW;
    }, OXn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, GXn = function(n) {
        return A2(Nu, OXn, _u(n));
    }, JXn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, WXn = function(n) {
        return A2(Nu, JXn, _u(n));
    }, KXn = function(n) {
        return function(n) {
            return n.o5;
        }(n.fK);
    }, XXn = function(n) {
        return !Jwn(eXn(n));
    }, n1n = function(n) {
        return function(n) {
            return WDn(nXn(n));
        }(n) && uXn(n) ? 1 : function(n) {
            return !Jwn(nXn(n));
        }(n) ? XXn(n) ? 0 : 2 : XXn(n) ? 3 : 4;
    }, r1n = F2(function(n, r) {
        switch(n1n(n)){
            case 0:
            case 2:
                return !0;
            case 1:
                return !r.aU;
            default:
                return !1;
        }
    }), t1n = F2(function(n, r) {
        return A2(r1n, n, r) ? A2(Eu, function(n) {
            var r = n.b;
            return b(0, A2(xjn, wjn(n.a), r));
        }, wwn(r.mk)) : h;
    }), e1n = F2(function(n, r) {
        switch(n1n(n)){
            case 0:
                return !r.aU;
            case 1:
            case 3:
                return !0;
            default:
                return !1;
        }
    }), u1n = F2(function(n, r) {
        return A2(e1n, n, r) ? A2(Eu, function(n) {
            var r = n.b;
            return b(1, A2(xjn, wjn(n.a), r));
        }, wwn(r.mY)) : h;
    }), a1n = function(n) {
        return !Jwn(QXn(n));
    }, i1n = F2(function(n, r) {
        return A2(Fp, function(n) {
            return b(upn(r), n);
        }, rv(A2(PH, r, n.kB)));
    }), c1n = F2(function(n, r) {
        var t, e = r.a1;
        return a1n(n) ? A2(Eu, function(n) {
            var r = n.b;
            return b(3, A2(xjn, wjn(n.a), r));
        }, (t = e, A2(Tp, function(n) {
            return A2(i1n, t, n);
        }, epn))) : h;
    }), o1n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    mk: n.a
                });
            case 1:
                return m(r, {
                    mY: n.a
                });
            case 2:
                return m(r, {
                    aU: n.a
                });
            case 3:
                return m(r, {
                    a1: n.a
                });
            default:
                return m(r, {
                    p6: n.a
                });
        }
    }), f1n = F3(function(n, r, t) {
        if (A2(r1n, n, FL(t))) {
            var e = FL(t);
            return A3(dN, o1n, xXn(A2(Egn, r, e.mk)), t);
        }
        return t;
    }), s1n = F3(function(n, r, t) {
        if (A2(e1n, n, FL(t))) {
            var e = FL(t);
            return A3(dN, o1n, yXn(A2(Egn, r, e.mY)), t);
        }
        return t;
    }), l1n = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, o1n, EXn(A2(Kgn, n, t.a1).a), r);
    }), d1n = F3(function(n, r, t) {
        var e = A2(l1n, r, A3(s1n, n, r, A3(f1n, n, r, t))), u = A2(BM, function(n) {
            return nM(x([
                t1n(n),
                u1n(n),
                c1n(n)
            ]));
        }(n), e);
        return u.$ ? b(u.a, !1) : b(u.a.a, !0);
    }), b1n = F2(function(n, r) {
        return !TE(A2(zXn, n, r));
    }), v1n = F2(function(n, r) {
        var t = A3(d1n, n, !1, r);
        return t.b ? Ut : A2(nv, function(n) {
            return Vt(iXn(n));
        }, rv(A2(Rc, b1n(t.a), vXn)));
    }), m1n = F2(function(n, r) {
        var t = FL(n.kB), e = FL(r.kB);
        return i(e.nK, t.nK) && i(e.y4, t.y4) && i(e.yb, t.yb) && i(e.yc, t.yc) && i(e.wN, t.wN) && i(e.x0, t.x0);
    }), p1n = F6(function(n, r, t, e, u, a) {
        var i, c, o = A4(QEn, tXn(e), Ex(t), xx(t), A2(Mpn, uXn(e), A2(l$n, iXn(1), {
            yb: (c = a).m$,
            yc: c.m0,
            nK: c.mZ,
            y4: c.m_,
            wN: c.m1,
            x0: c.m2
        }))), f = A4(QEn, tXn(e), Ex(t), xx(t), A2(Mpn, rXn(e), A2(l$n, iXn(0), function(n) {
            return {
                yb: n.mn,
                yc: n.mo,
                nK: n.ml,
                y4: n.mm,
                wN: n.mp,
                x0: n.mq
            };
        }(a)))), s = FL(u).a1, l = (i = function(n) {
            return n.q0;
        }(a), i.$ ? A2(g$n, n, s) : A2(A$n, i.a, s));
        return {
            mk: f,
            aU: A2(m1n, o, f),
            mY: o,
            p6: r,
            a1: l
        };
    }), $1n = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            m7: o,
            rh: n,
            hZ: c,
            A8: a,
            tU: i,
            tV: e,
            vv: u,
            fK: t,
            i$: r
        };
    }), h1n = F5(function(n, r, t, e, u) {
        return {
            eS: e,
            tg: n,
            tY: u,
            lj: r,
            vi: t
        };
    }), g1n = F3(function(n, r, t) {
        return {
            yQ: t,
            lj: r,
            vg: n
        };
    }), w1n = A3(ly, "charge_item", A2(Tu, "name", C$), A3(ly, "price_in_cents", F$, A3(ly, "quantity", F$, uu(g1n)))), x1n = A4(sy, "package_items", vy(w1n), h, A4(sy, "item_type", C$, "", A4(sy, "quantity_in_stock", iy(F$), Ut, A3(ly, "price_in_cents", F$, A3(ly, "name", C$, uu(h1n)))))), k1n = A2(Pk, x1n, uu(iu)), y1n = F6(function(n, r, t, e, u, a) {
        return {
            mr: a,
            pn: r,
            rh: n,
            tg: t,
            vB: e,
            xy: u
        };
    }), _1n = A3(ly, "age", iy(F$), A3(ly, "uses_tobacco", jk, A3(ly, "relationship", A2(nu, sCn, C$), A3(ly, "name", C$, A3(ly, "dob", iy(ay), A3(ly, "id", C$, uu(y1n))))))), A1n = A2(Pk, _1n, uu(iu)), C1n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, B1n = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? t.b.$ ? Sk("Either Plan or Charge item is required.") : uu(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : uu(C1n(t.a.a));
    }), E1n = function(n) {
        if (n.$) return uu(Ut);
        var r = n.a;
        switch(r){
            case "terminate":
                return uu(Vt(0));
            case "auto-renew":
                return uu(Vt(1));
            default:
                return Sk("Unsupported Contract type: " + r);
        }
    }, D1n = A4(sy, "description", iy(C$), Ut, A3(ly, "registration_fee_name", C$, A3(ly, "tobacco_surcharge_type", iy(C$), A3(ly, "dpc_discount", jk, A3(ly, "contract_type", A2(nu, E1n, iy(C$)), A3(ly, "contract_period_in_months", iy(A2(nu, wdn, F$)), A3(ly, "contract_expires", jk, A3(ly, "bills_at_end_of_period", jk, A3(ly, "children_age_limit", iy(F$), A3(ly, "maximum_age", iy(F$), A3(ly, "minimum_age", iy(F$), A3(ly, "name", C$, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            m8: a,
                                                            nD: u,
                                                            or: i,
                                                            ou: c,
                                                            oy: o,
                                                            pe: d,
                                                            py: f,
                                                            rh: n,
                                                            sn: e,
                                                            s9: t,
                                                            tg: r,
                                                            vy: l,
                                                            xa: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), q1n = A2(Pk, D1n, uu(iu)), F1n = F2(function(n, r) {
        return {
            o5: r,
            rh: n
        };
    }), P1n = A3(ly, "debug", jk, A3(ly, "id", C$, uu(F1n))), z1n = A2(Pk, P1n, uu(iu)), j1n = F3(function(n, r, t) {
        return {
            l0: r,
            tg: n,
            xc: t
        };
    }), S1n = function(n) {
        switch(n){
            case "owner_info":
                return uu(0);
            case "additional_details":
                return uu(1);
            case "members":
                return uu(2);
            case "plan":
                return uu(3);
            case "custom_details":
                return uu(4);
            case "location":
                return uu(5);
            case "practitioner":
                return uu(6);
            case "confirmation":
                return uu(7);
            default:
                return Sk("Unsupported Signup step name: " + n);
        }
    }, L1n = A3(ly, "toggleable", jk, A3(ly, "active", jk, A3(ly, "name", A2(nu, S1n, C$), uu(j1n)))), M1n = A2(Pk, L1n, uu(iu)), N1n = A2(nu, function(n) {
        return A2(Pk, A2(B1n, n.uC, n.ny), A2(dD, n.hZ, A2(dD, n.tU, A2(dD, n.A8, A2(dD, n.vv, A2(dD, n.tV, A2(dD, n.fK, A2(dD, n.i$, A2(dD, n.rh, uu($1n))))))))));
    }, A3(ly, "charge_item", iy(k1n), A3(ly, "locations", vy(zYn), A3(ly, "owner", VU, A3(ly, "members", vy(A1n), A3(ly, "referred", jk, A3(ly, "owner_pays_on_behalf", jk, A3(ly, "signup_attempt", z1n, A3(ly, "plan", iy(q1n), A3(ly, "signup_step", M1n, A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                ny: f,
                                                rh: n,
                                                hZ: o,
                                                A8: i,
                                                tU: c,
                                                tV: u,
                                                uC: t,
                                                vv: a,
                                                fK: e,
                                                i$: r
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), H1n = A2(Pk, N1n, uu(iu)), T1n = F2(function(n, r) {
        return A2(X_, x([
            "signup_pages",
            r
        ]), lL(n));
    }), I1n = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments"
        ]), A2(T1n, n, r));
    }), R1n = F5(function(n, r, t, e, u) {
        return A4(W_, gQ(n), H1n, u, rA(A2(X_, x([
            e,
            "step"
        ]), A2(I1n, r, t))));
    }), Z1n = function(n) {
        return 4 === n;
    }, V1n = F3(function(n, r, t) {
        var e = wGn(r);
        return A2(wF, function(r) {
            return i(A2(kGn, r.a, n), t);
        }, e);
    }), U1n = F4(function(n, r, t, e) {
        var u = b(A3(V1n, n, r, t), A3(V1n, n, r, e));
        return !u.a.$ && !u.b.$ && 0 > s(u.b.a.b, u.a.a.b);
    }), Y1n = function(n) {
        return 1 === n;
    }, Q1n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, O1n = F2(function(n, r) {
        var t = A2(Egn, !1, r);
        return A2(nv, function(n) {
            return rv(A2(PH, n, t.kB));
        }, rv(A2(Rc, function(r) {
            return i(Zmn(r), n);
        }, Rmn)));
    }), G1n = F2(function(n, r) {
        var t = A2(Kgn, !1, r).a;
        return A2(nv, function(n) {
            return rv(A2(PH, n, t.kB));
        }, rv(A2(Rc, function(r) {
            return i(upn(r), n);
        }, epn)));
    }), J1n = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
                return A2(O1n, n, r.a);
            case 2:
            default:
                return Ut;
            case 3:
                return A2(G1n, n, r.a);
        }
    }), W1n = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 4;
        }
    }, K1n = function(n) {
        return aXn(W1n(n));
    }, X1n = F2(function(n, r) {
        return rv(A2(zXn, n.kB, W1n(r)));
    }), n0n = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = A3(d1n, r.fL, n, r.kB), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), r0n = F3(function(n, r, t) {
        var e = lc(n.xs.CS), u = A2(n0n, !1, n).a, a = function() {
            if (t.$) return b(K1n(r), A2(X1n, u, r));
            var n = t.a;
            return b(K1n(r) + ": " + n, A2(J1n, n, r));
        }(), i = a.a;
        return Q1n(Vt({
            eH: A2(sc, h, A2(Fp, VZ, a.b)),
            qv: i,
            C9: e
        }));
    }), t0n = F2(function(n, r) {
        return A2(ctn, n, function(n) {
            return n ? "Yes" : "No";
        }(r));
    }), e0n = function(n) {
        return A2(t0n, "Existing Coverage", n);
    }, u0n = function(n) {
        return n.rC;
    }, a0n = function(n) {
        return n.rI;
    }, i0n = function(n) {
        return A2(otn, "Signup Flow", a0n(n) ? u0n(n) ? "Checkout" : "Retail" : "Employee");
    }, c0n = function(n) {
        return n.mu;
    }, o0n = function(n) {
        return n.nT;
    }, f0n = function(n) {
        return n.nX;
    }, s0n = F2(function(n, r) {
        return A2(ctn, n, function(n) {
            switch(n){
                case 0:
                    return "No";
                case 1:
                    return "Yes";
                case 2:
                    return "Optional";
                case 3:
                    return "Require";
                default:
                    return "Default";
            }
        }(r));
    }), l0n = function(n) {
        return n.n_;
    }, d0n = function(n) {
        return n.n0;
    }, b0n = function(n) {
        return n.n1;
    }, v0n = function(n) {
        return n.n2;
    }, m0n = function(n) {
        return n.n3;
    }, p0n = function(n) {
        return n.rh;
    }, $0n = function(n) {
        return A2(nv, function(n) {
            return Vt(p0n(n));
        }, n.o6);
    }, h0n = function(n) {
        return n.rh;
    }, g0n = function(n) {
        return A2(nv, function(n) {
            return Vt(h0n(n));
        }, n.pa);
    }, w0n = function(n) {
        return n.pd;
    }, x0n = function(n) {
        return n.s6;
    }, k0n = function(n) {
        return A2(nv, hnn, n.lf);
    }, y0n = function(n) {
        return n.vu;
    }, _0n = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return "Collect Billing Address";
                case 1:
                    return "Collect Address";
                case 2:
                    return "Collect Practitioner";
                case 3:
                    return "Collect Location";
                case 4:
                    return "Collect Insurance";
                case 5:
                    return "Collect Payment Source";
                case 6:
                    return "Collect Lead Source";
                case 7:
                    return "Collect Broker";
                case 8:
                    return "Collect SSN";
                case 9:
                    return "Minimum Enroll Age";
                case 10:
                    return "Redirects Post Signup";
                case 11:
                    return "Post Signup Redirect Url";
                case 12:
                    return "Post Signup Message";
                case 13:
                    return "Show Post Signup Footer Button";
                case 14:
                    return "Signup Page";
                case 15:
                    return "Allow Non-Member Payer";
                case 16:
                    return "Collect Tobacco Use";
                case 17:
                    return "Restrict Zip Codes";
                case 18:
                    return "Allowed Zip Codes";
                case 19:
                    return "Default Practitioner";
                case 20:
                    return "Default Location";
                case 21:
                    return "Accepts New Signup";
                case 22:
                    return "Allow Coupons";
                case 23:
                    return "Collect Start Date";
                case 24:
                    return "Collect Rate Schedule";
                default:
                    return "Dependent Limit";
            }
        }(r);
        switch(r){
            case 0:
                return A2(s0n, t, eXn(n));
            case 1:
                return A2(s0n, t, nXn(n));
            case 2:
                return A2(s0n, t, KYn(n));
            case 3:
                return A2(s0n, t, WYn(n));
            case 4:
                return A2(s0n, t, QXn(n));
            case 5:
                return A2(s0n, t, l0n(n));
            case 6:
                return A2(s0n, t, f0n(n));
            case 7:
                return A2(s0n, t, o0n(n));
            case 8:
                return A2(s0n, t, b0n(n));
            case 9:
                return A2(otn, t, A2(sc, "", A2(Fp, oe, x0n(n))));
            case 10:
                return A2(kJn, t, y0n(n));
            case 11:
                return A2(otn, t, A2(sc, "", k0n(n)));
            case 12:
                return A2(otn, t, A2(sc, "", A2(nv, hnn, n.le)));
            case 13:
                return A2(kJn, t, n.lA);
            case 14:
                return A2(otn, t, XYn(nQn(n)));
            case 15:
                return A2(s0n, t, PXn(n));
            case 16:
                return A2(kJn, t, m0n(n));
            case 17:
                return A2(kJn, t, function(n) {
                    return n.vX;
                }(n));
            case 18:
                return A2(otn, t, A2(fe, ", ", tXn(n)));
            case 19:
                return A2(otn, t, A2(sc, "", g0n(n)));
            case 20:
                return A2(otn, t, A2(sc, "", $0n(n)));
            case 21:
                return A2(kJn, t, fGn(n));
            case 22:
                return A2(kJn, t, c0n(n));
            case 23:
                return A2(kJn, t, v0n(n));
            case 24:
                return A2(kJn, t, d0n(n));
            default:
                return A2(otn, t, A2(sc, "", A2(Fp, oe, w0n(n))));
        }
    }), A0n = x([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
    ]), C0n = function(n) {
        return A2(Eu, _0n(n), A0n);
    }, B0n = function(n) {
        return n.tg;
    }, E0n = function(n) {
        return n.a;
    }, D0n = function(n) {
        return A2(pWn, "Step Count", be(n));
    }, q0n = function(n) {
        return n.b;
    }, F0n = function(n) {
        return A2(otn, "Step Index", A2(sc, "", A2(Fp, oe, A2(Fp, function(n) {
            return n + 1;
        }, A2(Fp, q0n, n)))));
    }, P0n = {
        x9: function(n) {
            return n.ba.x9;
        },
        y_: function(n) {
            return n.ba.y_;
        },
        y0: function(n) {
            return n.ba.y0;
        },
        zb: function(n) {
            return n.ba.zb;
        },
        kL: function(n) {
            return n.ba.kL;
        },
        A8: function(n) {
            return n.ba.A8;
        },
        A9: function(n) {
            return n.ba.A9;
        },
        Bb: function(n) {
            return n.ba.Bb;
        },
        u7: function(n) {
            return n.ba.u7;
        }
    }, z0n = F3(function(n, r, t) {
        return r((function() {
            switch(t){
                case 0:
                    return function(n) {
                        return n.y0;
                    };
                case 1:
                    return function(n) {
                        return n.x9;
                    };
                case 2:
                    return n ? function(n) {
                        return n.A9;
                    } : function(n) {
                        return n.A8;
                    };
                case 3:
                    return function(n) {
                        return n.Bb;
                    };
                case 4:
                    return function(n) {
                        return n.zb;
                    };
                case 5:
                    return function(n) {
                        return n.kL;
                    };
                case 6:
                    return function(n) {
                        return n.u7;
                    };
                default:
                    return function(n) {
                        return n.y_;
                    };
            }
        })()(P0n));
    }), j0n = F3(function(n, r, t) {
        return A3(z0n, n, r, t.tg);
    }), S0n = function(n) {
        var r = A2(fe, ", ", A2(Eu, A2(j0n, !1, Wx(0)), A2(Eu, E0n, n)));
        return A2(otn, "Steps", r);
    }, L0n = function(n) {
        return n.xc;
    }, M0n = function(n) {
        return gGn(A2(Rc, function(n) {
            return $Gn(n) || L0n(n);
        }, n));
    }, N0n = F2(function(n, r) {
        var t, e, u = M0n(r), a = A2(wF, function(r) {
            return i(n, B0n(E0n(r)));
        }, u);
        return x([
            (t = a, e = A2(sc, "", A2(Fp, A2(j0n, !1, Wx(0)), A2(Fp, E0n, t))), A2(otn, "Step Name", e)),
            F0n(a),
            D0n(u),
            S0n(u)
        ]);
    }), H0n = F4(function(n, r, t, e) {
        return A2(itn, "Signup Page Completed", A2(Yt, i0n(nQn(t)), $(A2(N0n, n, r), $(C0n(t), e))));
    }), T0n = F3(function(n, r, t) {
        return A4(H0n, 1, n, r, x([
            e0n(t.Z),
            A2(otn, "Insurance Carrier", t.Av)
        ]));
    }), I0n = F4(function(n, r, t, e) {
        return A2(itn, "Signup Page Loaded", A2(Yt, i0n(nQn(t)), $(A2(N0n, n, r), $(C0n(t), e))));
    }), R0n = F3(function(n, r, t) {
        return A4(I0n, 1, n, r, x([
            e0n(t.Z)
        ]));
    }), Z0n = function(n) {
        return A2(otn, "toState", n);
    }, V0n = function(n) {
        return A2(itn, "Signup Step Resumed", x([
            stn(IXn),
            Z0n(n)
        ]));
    }, U0n = F2(function(n, r) {
        return A2(itn, "Signup Step Repeated", x([
            stn(IXn),
            Z0n(_A(r)),
            Jun(_A(n))
        ]));
    }), Y0n = F2(function(n, r) {
        return A2(sc, n, r.tV);
    }), Q0n = F3(function(n, r, t) {
        return A2(X_, x([
            "attempts",
            t
        ]), A2(X_, x([
            "signup_pages",
            r
        ]), lL(n)));
    }), O0n = F6(function(n, r, t, e, u, a) {
        return A4(dC, gQ(n), z1n, a, A2(vL, function(n) {
            return _x(x([
                b("attempt", _x(x([
                    b("zip_ineligible", LC(n))
                ])))
            ]));
        }(u), rA(A3(Q0n, r, t, e))));
    }), G0n = F2(function(n, r) {
        var t = wGn(n);
        return A2(wF, function(n) {
            return i(n.a, r);
        }, t);
    }), J0n = F3(function(n, r, t) {
        return A2(nv, function(r) {
            var e = E0n(r), u = b(A2(G0n, n, e), A2(G0n, n, t));
            return u.a.$ || u.b.$ ? Ut : Vt(u.b.a.b - u.a.a.b);
        }, r);
    }), W0n = F3(function(n, r, t) {
        return A3(V1n, n, r, lc(t));
    }), K0n = F4(function(n, r, t, e) {
        var u = A3(J0n, r, A3(W0n, n, r, e), t);
        return !u.$ && u.a >= 0;
    }), X0n = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 7,
                a: n
            };
        }
    }, n2n = function(n) {
        return n.i$;
    }, r2n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, t2n = function(n) {
        return n.$ ? yx : _x(x([
            b("id", Ax(Omn(n.a)))
        ]));
    }, e2n = F2(function(n, r) {
        var t = A2(nv, function(n) {
            return n.$ ? Ut : Vt(n.a);
        }, n), e = A2(Fp, Qmn, t);
        return b("carrier_alias", r ? t.$ ? yx : _x(x([
            b("name", Ax(Fvn(t.a))),
            b("carrier", t2n(e))
        ])) : yx);
    }), u2n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return yx;
            if (1 === t.a.$) return G$n(n);
            var e = Qmn(t.a.a);
            return Ogn(e) ? G$n(n) : yx;
        }
        return yx;
    }), a2n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return yx;
            if (1 === t.a.$) return LC(n);
            var e = Qmn(t.a.a);
            return byn(e) ? LC(n) : yx;
        }
        return yx;
    }), i2n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return yx;
            if (1 === t.a.$) return G$n(n);
            var e = Qmn(t.a.a);
            return Ggn(e) ? G$n(n) : yx;
        }
        return yx;
    }), c2n = F3(function(n, r, t) {
        return r ? t.$ ? yx : G$n(1 === t.a.$ ? n : Fvn(t.a.a)) : yx;
    }), o2n = function(n) {
        var r = n.ah, t = n.Z, e = n.b_, u = n.bL;
        return _x(x([
            b("group_id", A3(u2n, n.bW, t, r)),
            b("member_id", A3(i2n, e, t, r)),
            b("high_deductible", A3(a2n, n.rc, t, r)),
            A2(e2n, r, t),
            b("payer_name", A3(c2n, u, t, r))
        ]));
    }, f2n = x([
        b("address_city", yx),
        b("address_country", yx),
        b("address_line1", yx),
        b("address_line2", yx),
        b("address_state", yx),
        b("address_zip", yx)
    ]), s2n = F2(function(n, r) {
        return (fM(n) ? iu : Eu(function(r) {
            var t = r.a, e = r.b;
            return b(A2(fe, "_", x([
                XC(n),
                t
            ])), e);
        }))(r);
    }), l2n = F2(function(n, r) {
        return A2(s2n, n, J$n(r));
    }), d2n = function(n) {
        return Agn(n).b;
    }, b2n = F2(function(n, r) {
        var t = function() {
            switch(n1n(n)){
                case 0:
                    var t = r.aU ? r.mk : r.mY;
                    return v(Vt(r.mk), Vt(t), r.aU || d2n(r.mY));
                case 1:
                    return v(Vt(r.aU ? r.mY : r.mk), Vt(r.mY), !0);
                case 2:
                    return v(Vt(r.mk), Ut, !1);
                case 3:
                    return v(Ut, Vt(r.mY), d2n(r.mY));
                default:
                    return v(Ut, Ut, !1);
            }
        }(), e = t.a, u = t.b, a = t.c, i = A2(sc, A2(s2n, "billing", f2n), A2(Fp, l2n("billing"), u)), c = A2(sc, f2n, A2(Fp, J$n, e));
        return $(function(n) {
            var r = FL(n.kB);
            return x([
                b("health_insurance", o2n(r)),
                b("existing_coverage", LC(r.Z))
            ]);
        }(r.a1), $(c, $(i, x([
            b("uses_billing_address", LC(a)),
            b("owner_pays_on_behalf", LC(!r.p6))
        ]))));
    }), v2n = F5(function(n, r, t, e, u) {
        return A4(dC, gQ(n), sXn, u, A2(vL, function(n) {
            return _x(x([
                b("online_enrollment", _x(n))
            ]));
        }(e), rA(A2(lXn, r, t))));
    }), m2n = F2(function(n, r) {
        switch(n.$){
            case 9:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (nn = r.f0).$ ? Pp : V0n(nn.a), i = function() {
                        var n = r.x9;
                        if (n.$) return r.kB;
                        var t, e = n.a, a = A4(K0n, r.lB, r.DF, n2n(u), r.xs.CS), i = !((t = b(a, !Jwn(QXn(r.fL)))).a || !t.b), c = PXn(r.fL), o = FL(r.kB), f = a ? o.p6 : !r$n(c) && !Z1n(c);
                        return lS(A6(p1n, i, f, r.dB, r.fL, r.kB, e));
                    }(), c = KXn(u), o = x(c ? [
                        AXn,
                        FXn(n2n(u)),
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]), f = FL(i), s = A3(R0n, e.DF, e.fL, {
                        Z: uhn(M = f.a1)
                    });
                    return v(m(e, {
                        f0: Ut,
                        hg: c,
                        kB: i,
                        iZ: Vt((X = u, function(n) {
                            return n.rh;
                        }(X.fK)))
                    }), Vu(x([
                        a,
                        s
                    ])), o);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 2:
                var l = n.a;
                n: for(;;)switch(l.$){
                    case 2:
                        if (9 === l.a.$) return v(m(r, {
                            cM: vc
                        }), Pp, A2(xA, 1, l));
                        break n;
                    case 3:
                        var d = l.a, p = function() {
                            var n = r.fc;
                            if (2 === n.$) {
                                var t = n.a;
                                return A5(R1n, r.gF, Bx(r.dB), xGn(r.lB), t, BXn);
                            }
                            return Pp;
                        }(), $ = PXn(r.fL), g = !(r$n($) || (Y1n($) ? A2(Y0n, !1, d) : Z1n($) && A2(Y0n, !0, d)));
                        return i = A3(dN, o1n, CXn(g), r.kB), v(m(r, {
                            x9: Vt(d),
                            kB: i,
                            cM: l
                        }), p, h);
                    default:
                        break n;
                }
                return v(m(r, {
                    cM: l
                }), Pp, A2(xA, 1, l));
            case 0:
                var w = A2(n0n, !0, r);
                if (e = w.a, w.b) return v(m(e, {
                    u3: !0
                }), function(n) {
                    var r = Bx(n.dB), t = FL(n.kB), e = n.fc;
                    return 2 === e.$ ? A5(v2n, n.gF, r, e.a, A2(b2n, n.fL, t), r2n) : Pp;
                }(e), h);
                var k = A2(v1n, e.fL, e.kB);
                if (k.$) return v(e, Vu(UXn(e.kB)), h);
                var y = A3(SX, X0n, k.a, e.cN), _ = y.b;
                return v(m(e, {
                    cN: y.a
                }), Vu(A2(Yt, _, UXn(e.kB))), h);
            case 1:
                if (l = n.a, e = m(r, {
                    u3: !1
                }), 3 === l.$) {
                    var A = FL(e.kB), C = A3(T0n, e.DF, e.fL, {
                        Z: uhn(M = A.a1),
                        Av: A2(sc, "", rhn(M))
                    });
                    return v(e, C, x([
                        DXn
                    ]));
                }
                return v(e, Pp, A2(xA, 1, l));
            case 3:
                var B = n.a, E = n.b, D = FL(r.kB), q = B ? D.mY : D.mk, F = A2(qgn, E, q), P = F.a, z = F.b, j = F.c, S = B ? yXn(P) : xXn(P), L = (e = m(r, {
                    kB: A3(dN, o1n, S, r.kB)
                }), A2(sc, b(h, Pp), A2(Fp, function(n) {
                    switch(n.$){
                        case 1:
                            return b(x([
                                A3(r0n, e, S, Vt(n.a))
                            ]), Pp);
                        case 2:
                            if ("Zip" === n.a) {
                                var t = r.iZ;
                                if (t.$) return b(h, Pp);
                                var u = t.a;
                                return b(h, A6(O0n, r.gF, Bx(r.dB), xGn(r.lB), u, function(n) {
                                    var r = n.ct;
                                    if (r.$) {
                                        var t = r.a, e = function(n) {
                                            return FL(n.kB).x0;
                                        }(n);
                                        return A2(kgn, e, t);
                                    }
                                    return !1;
                                }(q), qXn));
                            }
                            return b(h, Pp);
                        default:
                            return b(h, Pp);
                    }
                }, j)));
                return o = L.a, _ = L.b, v(e, Vu(x([
                    A2(Lp, hXn(B), z),
                    _
                ])), o);
            case 4:
                E = n.a;
                var M, N = FL(r.kB), H = A2(swn, E, M = N.a1), T = H.b, I = H.c, R = EXn(H.a);
                return e = m(r, {
                    kB: A3(dN, o1n, R, r.kB)
                }), o = A2(Eu, function(n) {
                    return A3(r0n, e, R, Vt(n.a));
                }, I), v(e, A2(Lp, XKn, T), o);
            case 5:
                var Z = n.a, V = A4(x0, YXn, h0(GXn), Z, r.gM), U = V.b;
                return v(m(r, {
                    gM: V.a
                }), U, h);
            case 6:
                var Y = n.a;
                if (A2(qM, Y, r.x)) {
                    var Q = A3(FM, !0, Y, r.x);
                    return v(m(e = A2(n0n, !1, r).a, {
                        x: Q
                    }), Pp, h);
                }
                return v(r, Pp, h);
            case 7:
                Z = n.a;
                var O = A4(x0, X0n, h0(WXn), Z, r.cN);
                return U = O.b, v(m(r, {
                    cN: O.a
                }), U, h);
            case 8:
                return v(r, OLn(n.a), h);
            case 10:
                var G = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), J = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, J, G) ? A2(U0n, J, G) : Pp, h);
            case 11:
                return v(r, Pp, h);
            case 12:
                var W = rwn(n.a);
                if (W.$) return v(r, Pp, h);
                var K = CXn(W.a);
                return v(m(r, {
                    kB: i = A3(dN, o1n, K, r.kB)
                }), Pp, h);
            default:
                return v(m(r, {
                    kB: A3(dN, o1n, kXn(n.a), r.kB)
                }), Pp, h);
        }
        var X, nn;
    }), p2n = {
        $: 0
    }, $2n = function(n) {
        return n.mh;
    }, h2n = function(n) {
        return n.mi;
    }, g2n = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), w2n = g2n, x2n = A2(CN, AN(3), Vt(4)), k2n = function(n) {
        return n.ol;
    }, y2n = F2(function(n, r) {
        return r.om(n);
    }), _2n = function(n) {
        return n.on;
    }, A2n = F3(function(n, r, t) {
        var e = wGn(A2(Rc, function(n) {
            return $Gn(n);
        }, r));
        return A2(nv, function(n) {
            return A2(yPn, n.b + 1, e);
        }, A3(W0n, n, r, t));
    }), C2n = rM(F2(function(n) {
        return vfn(n);
    })), B2n = F4(function(n, r, t, e) {
        var u = u0n(r);
        return n(function() {
            var a = b(A3(A2n, r, t, e), u);
            if (a.b) return C2n(_2n);
            if (a.a.$) return k2n;
            var i = E0n(a.a.a);
            return C2n(y2n(A3(j0n, u, n, i)));
        }());
    }), E2n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), D2n = E2n, q2n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, F2n = function(n) {
        return function(n) {
            return {
                $: 6,
                a: n
            };
        }(n);
    }, P2n = F5(function(n, r, t, e, u) {
        var a = FL(t), i = a.mk, c = a.mY, o = a.aU, f = !aF(u) || !o, s = e ? b(c, n(Yhn)) : b(i, n(ngn)), l = s.a, d = s.b;
        return A2(nk, x([
            Xx("mb-6")
        ]), x([
            function() {
                if (u.$) return tB;
                var n = u.a;
                return A2(nk, x([
                    Xx("mt-2 sm:mt-3")
                ]), x([
                    A2(HT, x([
                        zT(o),
                        PT(q2n),
                        FT(r),
                        F2n("addresses-are-the-same-checkbox")
                    ]), x([
                        ld(n)
                    ]))
                ]));
            }(),
            A2(oR, f, A2(Ak, x([
                _H(yan),
                _H(BN)
            ]), x([
                ld(d)
            ]))),
            A2(oR, f, A2(Ck, hXn(e), A3(Axn, n, x([
                Gwn(r)
            ]), l)))
        ]));
    }), z2n = F4(function(n, r, t, e) {
        var u = function() {
            switch(n1n(e)){
                case 0:
                    return b(A5(P2n, n, r, t, 0, Ut), A5(P2n, n, r, t, 1, A3(ru, n, Vt, Qhn)));
                case 1:
                    return b(A5(P2n, n, r, t, 1, Ut), A5(P2n, n, r, t, 0, A3(ru, n, Vt, rgn)));
                case 2:
                    return b(A5(P2n, n, r, t, 0, Ut), tB);
                case 3:
                    return b(A5(P2n, n, r, t, 1, Ut), tB);
                default:
                    return b(tB, tB);
            }
        }(), a = u.a, i = u.b;
        return A2(nk, x([
            Xx("addresses")
        ]), x([
            a,
            i
        ]));
    }), j2n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, S2n = function(n) {
        return n.qb.pm;
    }, L2n = function(n) {
        return n.qb.p6;
    }, M2n = function(n) {
        return n.qb.tg;
    }, N2n = function(n) {
        return n.qb.Bt;
    }, H2n = F5(function(n, r, t, e, u) {
        var a = FL(t).p6, i = b(Y1n(e) || Z1n(e), tln(u));
        return i.a && i.b ? A2(nk, h, x([
            A2(XH, x([
                HH(n(M2n)),
                VH(!0),
                exn(n(N2n))
            ]), x([
                A2(zN, x([
                    KN(x([
                        Xx("-mx-1")
                    ]))
                ]), x([
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(a),
                            D5(j2n),
                            T5(zkn(!0)),
                            Fkn(r)
                        ]), x([
                            ld(n(L2n))
                        ]))
                    ])),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            qkn(!a),
                            D5(j2n),
                            T5(zkn(!1)),
                            Fkn(r)
                        ]), x([
                            ld(n(S2n))
                        ]))
                    ]))
                ]))
            ]))
        ])) : tB;
    }), T2n = function(n) {
        return n.q4;
    }, I2n = F4(function(n, r, t, e) {
        var u = FL(t).a1;
        return a1n(e) ? A2(nk, x([
            Xx("mb-6")
        ]), x([
            A2(Ak, x([
                _H(BN)
            ]), x([
                ld(n(T2n))
            ])),
            A2(Ck, XKn, A3(_yn, n, r, u))
        ])) : tB;
    }), R2n = function(n) {
        var r = n.u3, t = n.kB, e = n.fL, u = Wx(n.kA);
        return A2(nk, x([
            Xx("mx-1 sm:mx-0")
        ]), x([
            A4(z2n, u, r, t, e),
            A4(I2n, u, r, t, e),
            A5(H2n, u, r, t, PXn(e), n.cM)
        ]));
    }, Z2n = A2(CN, AN(2), Vt(1)), V2n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, U2n = F4(function(n, r, t, e) {
        return A2(OC, x([
            qC,
            uF(t || r),
            uln(r),
            EC(e),
            CZ,
            V2n("next-step-button"),
            gC(x([
                Vq("button")
            ]))
        ]), x([
            A2(ak, h, x([
                ld(n),
                A2(PE, x([
                    zV,
                    cH(Z2n)
                ]), 6)
            ]))
        ]));
    }), Y2n = F2(function(n, r) {
        var t = A4(B2n, n, r.lB, r.DF, r.xs.CS);
        return x([
            A2(nk, x([
                Xx("flex justify-center w-full")
            ]), x([
                A2(nk, x([
                    Xx("flex-col w-full sm:w-4/5 lg:w-3/5")
                ]), x([
                    A2(yC, x([
                        SV,
                        _H(fO),
                        A2(D2n, 1, x2n),
                        rB(oB),
                        A2(w2n, 1, DB)
                    ]), x([
                        u0n(r.lB) ? ld(n(C2n($2n))) : ld(n(C2n(h2n)))
                    ])),
                    R2n(r),
                    A4(U2n, t, r.u3, !1, p2n)
                ]))
            ]))
        ]);
    }), Q2n = F2(function(n, r) {
        var t;
        return {
            gN: (t = b(r.cM, r.ie), 2 === t.a.$ ? A2(Y2n, n, r) : 1 === t.b.$ ? ck : A2(Y2n, n, r)),
            w5: Ex(r.dB)
        };
    }), O2n = mGn({
        Ar: mXn,
        AQ: pXn,
        Db: $Xn,
        DZ: function() {
            return Px(x([
                A2(_S, hXn(0), Opn),
                A2(_S, hXn(1), Opn),
                wXn(gXn)
            ]));
        },
        En: m2n,
        Et: Q2n
    }), G2n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, J2n = {
        $: 10
    }, W2n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, K2n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, X2n = function(n) {
        return {
            $: 23,
            a: n
        };
    }, n3n = "content-container", r3n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, t3n = function(n) {
        var r = l0n(n);
        return !Jwn(r);
    }, e3n = function(n) {
        return m(n, {
            jW: !0
        });
    }, u3n = F6(function(n, r, t, e, u, a) {
        var i = A6(ifn, n, r, t, u, Ut, a), c = i.b, o = e3n(i.a);
        return t3n(e) ? b(Vt(o), A2(Lp, r3n, c)) : b(Ut, Pp);
    }), a3n = F2(function(n, r) {
        return A2(Wu, n, r);
    }), i3n = function(n) {
        return A2(a3n, "coupon", n);
    }, c3n = F4(function(n, r, t, e) {
        return {
            aq: b(A2(sc, "", e), !0),
            Y: t,
            al: r,
            b4: Ut,
            DN: n
        };
    }), o3n = F2(function(n, r) {
        return A2(X_, x([
            "payment_source"
        ]), A2(X_, x([
            r
        ]), A2(X_, x([
            "online_enrollments"
        ]), lL(n))));
    }), f3n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), Tan, e, rA(A2(o3n, r, t)));
    }), s3n = E4("date-picker-input"), l3n = F3(function(n, r, t) {
        return {
            ic: 0,
            aF: !0,
            vz: t,
            fu: r,
            xl: n
        };
    }), d3n = function(n) {
        return n.ou;
    }, b3n = F2(function(n, r) {
        return n + " - " + lV(r);
    }), v3n = F3(function(n, r, t) {
        var e = t, u = A2(b3n, A2(H5, r, e.Cz), e.k3), a = n.$ ? u : i(n.a, e.Cz) ? A2(b3n, "All upfront", e.k3) : u, c = A2(b3n, A2(H5, r, e.o9), e.vp);
        return i(e.Cz, e.o9) ? a : a + " (Equal to " + c + ")";
    }), m3n = function(n) {
        var r = n;
        return A2(H5, Wx(0), r.Cz);
    }, p3n = function(n) {
        return dd({
            rh: "rate-schedule-select",
            Eb: v3n(A2(nv, d3n, n)),
            Ed: function(n) {
                return Vt(m3n(n));
            }
        });
    }, $3n = function(n) {
        return A2(cD, "custom_registration_fee_name", n);
    }, h3n = x([
        3,
        0,
        2,
        1,
        4
    ]), g3n = function(n) {
        switch(n){
            case 0:
                return "Prepay Option";
            case 1:
                return "Start Date";
            case 2:
                return "Discount Code";
            case 3:
                return "Payment Source";
            default:
                return "Documents";
        }
    }, w3n = F4(function(n, r, t, e) {
        var u = nQn(r), a = u0n(u), i = i3n(e.iF), c = aF(i), o = c ? A2(Nu, iu, _u(J2n)) : Pp, f = A6(u3n, a, t.kA, n, r, t.yR, t.gF), s = f.a, l = f.b, d = A3(SU, a, t.gF, Bx(n)), v = d.a, m = d.b, p = function() {
            var r = b(bXn(t), t.DF);
            if (3 === r.b.$) {
                if (r.a.$) return b(h, a = r.b.a);
                var e = r.a.a, a = r.b.a;
                return b(x([
                    A5(R1n, t.gF, Bx(n), xGn(u), e, K2n),
                    A2(Lp, W2n, m),
                    l,
                    o,
                    A4(f3n, t.gF, Bx(n), e, X2n)
                ]), a);
            }
            return b(h, h);
        }(), $ = p.a, g = p.b, w = s3n.b, k = s3n.a;
        return b({
            f0: KKn(t),
            gF: t.gF,
            m7: Ut,
            yR: t.yR,
            oA: vc,
            g8: Ut,
            hg: t.hg,
            Y: cP,
            kA: t.kA,
            kB: lS(A4(c3n, k, s, v, i)),
            hz: Ut,
            A8: vc,
            tO: cP,
            fc: t.fc,
            aO: cP,
            fe: vc,
            dz: cP,
            dB: n,
            cK: p3n(Ut),
            u3: !1,
            aR: !1,
            fr: Ut,
            b8: Ut,
            iW: c,
            dS: !1,
            cT: A3(l3n, Wx(t.kA), n3n, $3n(n)),
            lB: u,
            fL: r,
            DF: g,
            xs: e,
            x: A2(vS, h3n, g3n)
        }, Vu(A2(Yt, A2(Lp, G2n, w), $)));
    }), x3n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, k3n = F2(function(n, r) {
        if (i(r.kA, n)) return b(r, Pp);
        var t = r.s;
        if (1 === t.$) {
            var e = t.a;
            return b(m(r, {
                kA: n
            }), A4(_sn, n, Nsn(r.dB), Dsn(r.dB), e));
        }
        return b(r, Pp);
    }), y3n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    b4: n.a
                });
            case 1:
                return m(r, {
                    DN: n.a
                });
            case 2:
                return m(r, {
                    aq: b(n.b, n.a)
                });
            case 3:
                return m(r, {
                    Y: n.a
                });
            default:
                return m(r, {
                    al: n.a
                });
        }
    }), _3n = F2(function(n, r) {
        return m(r, {
            kB: A3(dN, y3n, n, r.kB)
        });
    }), A3n = F2(function(n, r) {
        var t = A2(bp, n.fS, n.bj), e = FL(r.kB).al, u = function() {
            if (e.$) return b(Ut, Pp);
            var r = e.a;
            return A2(Jbn, Lp(r3n), A2(qx, Vt, A2(k3n, n.kA, r)));
        }(), a = u.b;
        return b(A2(_3n, x3n(u.a), m(r, {
            yR: n.yR,
            g8: Vt(t)
        })), a);
    }), C3n = F2(function(n, r) {
        return r;
    }), B3n = function(n) {
        return {
            $: 19,
            a: n
        };
    }, E3n = function(n) {
        return {
            $: 18,
            a: n
        };
    }, D3n = function(n) {
        return {
            $: 20,
            a: n
        };
    }, q3n = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), F3n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, P3n = function() {
        return Px(x([
            hYn(F3n),
            RJ(q3n)
        ]));
    }, z3n = {
        $: 0
    }, j3n = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), S3n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, L3n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, M3n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, N3n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, H3n = {
        $: 3
    }, T3n = function(n) {
        return {
            $: 17,
            a: n
        };
    }, I3n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, R3n = function(n) {
        return n.m7;
    }, Z3n = function(n) {
        return n.lp;
    }, V3n = function(n) {
        if (n.$) return Ut;
        var r = n.a, t = EV(BMn(r));
        if (t > 0) {
            var e = Z3n(r), u = 12 * EMn(r) / t | 0;
            return Vt(kp(.02 * (u + e)));
        }
        return Ut;
    }, U3n = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Y3n = F2(function(n, r) {
        return A2(X_, x([
            "payment_methods"
        ]), A2(X_, x([
            r
        ]), A2(X_, x([
            "online_enrollments"
        ]), lL(n))));
    }), Q3n = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), Tan, u, A2(vL, e, rA(A2(Y3n, r, t))));
    }), O3n = F5(function(n, r, t, e, u) {
        return b("payment_method", A5(osn, n, r, t, e, u));
    }), G3n = F5(function(n, r, t, e, u) {
        var a = _x(x([
            A5(O3n, e, !1, !1, Ut, !0)
        ]));
        return A5(Q3n, n, r, t, a, u);
    }), J3n = F4(function(n, r, t, e) {
        if (2 === t.$) {
            var u = t.a;
            return A5(G3n, n, Bx(r), u, e, U3n);
        }
        return Pp;
    }), W3n = F2(function(n, r) {
        return function(t) {
            return n(t) ? x([
                r
            ]) : h;
        };
    }), K3n = F2(function(n, r) {
        return A2(W3n, function(r) {
            return i(n(r), Ut);
        }, r);
    }), X3n = function(n) {
        return n.lm.rQ;
    }, n9n = function(n) {
        return n.lm.CB;
    }, r9n = function(n) {
        return n.hj.q$;
    }, t9n = function(n) {
        return n.hj.Ax;
    }, e9n = function(n) {
        return n.hj.rQ;
    }, u9n = function(n) {
        return n.aq.b ? h : x([
            b(2, dM(t9n))
        ]);
    }, a9n = function(n) {
        return dQ(n) ? dM(IQ) : dM(HQ);
    }, i9n = function(n) {
        return A2(_Y, function(n) {
            return !AY(n.b);
        }, n.Y);
    }, c9n = function(n) {
        return A2(sO, function(n) {
            return b(4, a9n(n.b));
        }, i9n(n.Y));
    }, o9n = function(n) {
        var r, t = n.s;
        if (1 === t.$) {
            var e = t.b;
            return 1 === e.$ ? (r = x([
                e.a
            ]), A2(Eu, dM, r)) : h;
        }
        return h;
    }, f9n = F2(function(n, r) {
        var t = b(n, r.al);
        if (3 === t.a.$) return h;
        if (t.b.$) return h;
        var e = rv(o9n(t.b.a));
        return x(e.$ ? [
            b(3, eM(zsn))
        ] : [
            b(3, e.a)
        ]);
    }), s9n = F2(function(n, r) {
        return !A2(a2, r, n);
    }), l9n = function(n) {
        return n.DN;
    }, d9n = F2(function(n, r) {
        return r.wJ(n);
    }), b9n = F2(function(n, r) {
        var t = r.DN.oY;
        if (t.$) return x([
            b(1, eM(A2(rM, uM, l9n)))
        ]);
        var e = t.a;
        if (n.$) return h;
        var u = n.a, a = A2(NL, aS("/"), u);
        return A2(s9n, u, e) ? x([
            b(1, dM(d9n(a)))
        ]) : h;
    }), v9n = F4(function(n, r, t, e) {
        var u = u0n(r) ? h : x([
            b9n(t),
            u9n,
            A2(K3n, function(n) {
                return n.b4;
            }, b(0, eM(A2(rM, uM, X3n))))
        ]);
        return nM(A3(Mq, !n, c9n, A3(Mq, !n, f9n(e), u)));
    }), m9n = function(n) {
        return n.s8;
    }, p9n = F5(function(n, r, t, e, u) {
        var a = 3 === t.$ ? Vt(m9n(t.a)) : Ut, i = A2(BM, A4(v9n, n, r, a, e), u);
        return i.$ ? b(i.a, !1) : b(i.a.a, !0);
    }), $9n = function(n) {
        switch(n.$){
            case 0:
                return Vt(0);
            case 1:
                return Vt(1);
            case 2:
                return Vt(2);
            case 3:
                return Vt(4);
            default:
                return Vt(3);
        }
    }, h9n = F2(function(n, r) {
        var t = $9n(n);
        if (t.$) return r;
        var e = t.a, u = A3(vN, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(bN, e, u) ? m(a, {
            kB: A5(p9n, !1, r.lB, r.aO, r.dz, r.kB).a
        }) : a;
    }), g9n = function(n) {
        switch(n.$){
            case 0:
                return g3n(0);
            case 1:
                return g3n(1);
            case 2:
                return g3n(2);
            case 3:
                return g3n(4);
            default:
                return g3n(3);
        }
    }, w9n = F3(function(n, r, t) {
        var e = A2(fe, ": ", x([
            g9n(r),
            t
        ])), u = FL(n.kB).Y, a = A2(nv, iu, A2(Fp, function(r) {
            return A2(bN, r, n.x) ? q$n(A2(_Y, function(n) {
                return i(FY(n.b), t);
            }, i9n(u))) : Ut;
        }, $9n(r))), c = q$n(A2(_Y, function(n) {
            return i(FY(n.b), t);
        }, function(n) {
            return A2(_Y, function(n) {
                return dQ(n.b);
            }, n.Y);
        }(u)));
        return b(e, A2(Fp, a9n, A2(N$, a, c)));
    }), x9n = F3(function(n, r, t) {
        var e = lc(n);
        return Q1n(Vt({
            eH: A2(sc, h, A2(Fp, VZ, t)),
            qv: r,
            C9: e
        }));
    }), k9n = function(n) {
        var r = A5(p9n, !1, n.lB, n.aO, n.dz, n.kB), t = r.b;
        return b(m(n, {
            kB: r.a
        }), t);
    }, y9n = F3(function(n, r, t) {
        var e = k9n(n).a, u = A3(w9n, n, r, t);
        return A3(x9n, e.xs.CS, u.a, u.b);
    }), _9n = function(n) {
        return {
            $: 25,
            a: n
        };
    }, A9n = F4(function(n, r, t, e) {
        return A2(X_, x([
            "passthroughs",
            oe(e)
        ]), A2(X_, x([
            "payment_sources",
            t
        ]), A2(X_, x([
            "online_enrollments",
            r
        ]), lL(n))));
    }), C9n = F6(function(n, r, t, e, u, a) {
        return A4(W_, gQ(n), Vin, a, rA(A4(A9n, r, t, e, u)));
    }), B9n = function(n) {
        return n.rh;
    }, E9n = function(n) {
        return n.lj;
    }, D9n = function(n) {
        return n.ln;
    }, q9n = function(n) {
        var r = function() {
            var r = b(n.fr, n.m7);
            if (r.a.$) return r.b.$ || 1 !== r.b.a.$ ? Ut : Vt(E9n(r.b.a.a));
            var t = r.a.a;
            return Vt(D9n(t) + Z3n(t));
        }(), t = v(n.tO, n.dz, r);
        if (3 !== t.a.$ || 3 !== t.b.$ || t.c.$) return Pp;
        var e = t.a.a, u = t.b.a, a = t.c.a;
        return n.yR && Oin(u) ? A6(C9n, n.gF, Bx(n.dB), B9n(e), Qin(u), a, _9n) : Pp;
    }, F9n = function(n) {
        return A3(Dy, "-", "_", UQ(m3n(n)));
    }, P9n = F4(function(n, r, t, e) {
        var u = A2(a3n, n, r);
        if (u.$) return Ut;
        var a = u.a;
        return rv(A2(Rc, function(n) {
            return i(e(n), a);
        }, t));
    }), z9n = F2(function(n, r) {
        return A4(P9n, "billing_period", r, n, F9n);
    }), j9n = function(n) {
        return n.uX;
    }, S9n = F3(function(n, r, t) {
        var e = j9n(r), u = A2(N$, A2(z9n, e, t), rv(j9n(r))), a = m9n(r), i = n.DN;
        return m(n, {
            b4: u,
            DN: A2(S8, s9n(a), A2(j8, a, i))
        });
    }), L9n = F2(function(n, r) {
        return m(n, {
            Y: A2(xMn, r, n.Y)
        });
    }), M9n = F2(function(n, r) {
        return A2(X_, x([
            "coupons",
            r
        ]), lL(n));
    }), N9n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), sPn, e, rA(A2(M9n, r, t)));
    }), H9n = F3(function(n, r, t) {
        return A2(VN, t, YN(A2(fa, "practice", r.$ ? n : A3(ta, "hint_membership_id", r.a.rh, n))));
    }), T9n = F2(function(n, r) {
        return n.$ ? r : A3(ta, "referred_token", n.a.vw, r);
    }), I9n = function(n) {
        return A2(Nu, yu, _n(function() {
            try {
                Kr.location = n;
            } catch (n) {
                er.location.reload(!1);
            }
        }));
    }, R9n = F4(function(n, r, t, e) {
        if (y0n(r)) {
            var u = k0n(r);
            return u.$ ? ED : I9n(A3(H9n, e.iF, n, u.a));
        }
        var a = xGn(t);
        return A2(AA, A2(T9n, n, e.iF), wi({
            wy: a
        }));
    }), Z9n = F2(function(n, r) {
        return A2(itn, "Form Submission Errored", x([
            stn(n),
            SXn(r)
        ]));
    }), V9n = function(n) {
        return A2(Z9n, IXn, n);
    }, U9n = F2(function(n, r) {
        return v(m(r, {
            b8: TE(n) ? Ut : Vt(WWn(n))
        }), V9n(A2(fe, ", ", A2(Eu, Wx(0), n))), h);
    }), Y9n = F2(function(n, r) {
        return A2(PH, r, n);
    }), Q9n = F2(function(n, r) {
        return rv(A2(bN, r, n.x) ? A2(Y9n, n.kB, r) : h);
    }), O9n = F2(function(n, r) {
        return A2(nv, Q9n(n), $9n(r));
    }), G9n = F2(function(n, r) {
        return A2(fe, ": ", A2(Yt, g9n(r), n));
    }), J9n = F3(function(n, r, t) {
        var e = A2(G9n, t, r), u = k9n(n).a;
        return A3(x9n, u.xs.CS, e, A2(O9n, u, r));
    }), W9n = (jJ = IXn, A2(itn, "Form Submission Completed", x([
        stn(jJ)
    ]))), K9n = F2(function(n, r) {
        var t = A2(Q9n, r, n);
        if (t.$) return h;
        var e = t.a;
        return x([
            b(g3n(n), e)
        ]);
    }), X9n = "discount-code", n6n = "pending-documents", r6n = "payment-source", t6n = "start-date", e6n = F2(function(n, r) {
        return TE(A2(PH, r, n.kB)) ? Ut : Vt(function() {
            switch(r){
                case 0:
                    return "rate-schedule";
                case 1:
                    return t6n;
                case 2:
                    return X9n;
                case 3:
                    return r6n;
                default:
                    return n6n;
            }
        }());
    }), u6n = function(n) {
        var r = function(n) {
            var r = A2(Tp, e6n(n), h3n), t = rv(r);
            return t.$ ? Pp : OLn(t.a);
        }(n);
        return Vu(A2(Yt, r, function(n) {
            var r = k9n(n).a;
            return A2(Eu, function(n) {
                var r = n.a;
                return RXn({
                    eH: x([
                        n.b
                    ]),
                    qv: r
                });
            }, rc(A2(Eu, function(n) {
                switch(n){
                    case 3:
                        return function(n) {
                            var r = FL(n.kB).al;
                            return r.$ ? h : A2(Eu, function(n) {
                                return b("Payment Method", n);
                            }, o9n(r.a));
                        }(r);
                    case 4:
                        return function(n) {
                            var r = FL(n.kB).Y, t = L3n(r);
                            return A2(Tp, function(n) {
                                var r = n.a;
                                return A2(Fp, function(n) {
                                    return b(r, n);
                                }, n.b);
                            }, A2(sO, function(r) {
                                return A3(w9n, n, t, FY(r.b));
                            }, i9n(r)));
                        }(r);
                    default:
                        return A2(K9n, n, r);
                }
            }, h3n)));
        }(n)));
    }, a6n = function(n) {
        return A2(fu, "dob", n) ? "All Membership members must have date of birth" : n;
    }, i6n = F2(function(n, r) {
        return 4 === r.$ ? r.a.$ ? b(g9n(r), Ut) : b("Payment", A2(O9n, n, r)) : b(g9n(r), Ut);
    }), c6n = F2(function(n, r) {
        var t = k9n(n).a, e = A2(i6n, n, r);
        return A3(x9n, t.xs.CS, e.a, e.b);
    }), o6n = function(n) {
        return n.$ ? Ut : Vt(n.a);
    }, f6n = function(n) {
        return n.rh;
    }, s6n = function(n) {
        return n.$ ? Ut : Vt(f6n(n.a));
    }, l6n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, d6n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, b6n = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "confirm"
        ]), lL(n));
    }), v6n = F2(function(n, r) {
        return {
            rh: n,
            vw: r
        };
    }), m6n = A3(ly, "referred_token", C$, A3(ly, "id", C$, uu(v6n))), p6n = A2(Pk, m6n, uu(iu)), $6n = function(n) {
        return _x(x([
            b("online_enrollment", n)
        ]));
    }, h6n = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), p6n, u, A2(vL, $6n(e), rA(A2(b6n, r, t))));
    }), g6n = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), ORn, u, A2(vL, $6n(e), rA(A2(X_, x([
            "checkout"
        ]), A2(b6n, r, t)))));
    }), w6n = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), ORn, u, A2(vL, $6n(e), rA(A2(X_, x([
            "sponsor"
        ]), A2(b6n, r, t)))));
    }), x6n = F3(function(n, r, t) {
        return c0n(n) ? A2(Yt, b("coupon_code", G$n(r)), t) : t;
    }), k6n = function(n) {
        return b("period_in_months", n.$ ? yx : EX(EV(n.a.Cz)));
    }, y6n = function(n) {
        var r = n.oY;
        return b("start_date", r.$ ? yx : G$n(zP(r.a)));
    }, _6n = F2(function(n, r) {
        return {
            rh: n,
            tz: r
        };
    }), A6n = Hm(NO("_")), C6n = function(n) {
        return 1 === n || 2 === n || 3 === n ? lm(n) : jm("Notification number is invalid.");
    }, B6n = A2(im, C6n, iG), E6n = A2(zm, A2(zm, lm(_6n), A2(sm, A6n, VS("_"))), A2(sm, B6n, Gm)), D6n = function(n) {
        var r = Bx(n.dB), t = a0n(n.lB), e = u0n(n.lB), u = b("google_recaptcha_token", JFn(n.hz)), a = function(n) {
            if (n.$) return b("follow_up_attempt", yx);
            var r = n.a;
            return b("follow_up_attempt", _x(x([
                b("id", Ax(r.rh)),
                b("notification_number", EX(r.tz))
            ])));
        }(function(n) {
            if (n.$) return Kt("Param missing");
            var r = A2(ep, E6n, n.a);
            return r.$ ? Kt("Invalid FollowUp param") : te(r.a);
        }(A2(a3n, "link_source", n.xs.iF))), i = FL(n.kB), c = i.DN, o = i.b4, f = i.aq, s = b("accepted_documents", OPn(i.Y)), l = k6n(o), d = y6n(c), v = t ? A3(x6n, n.fL, f.a, x([
            d,
            l,
            s,
            a,
            u
        ])) : x([
            s,
            u
        ]), m = b(n.fc, n.u3);
        if (2 === m.a.$ && m.b) {
            var p = m.a.a;
            return e ? A5(g6n, n.gF, r, p, _x(v), l6n) : t ? A5(h6n, n.gF, r, p, _x(v), d6n) : A5(w6n, n.gF, r, p, _x(v), l6n);
        }
        return Pp;
    }, q6n = F4(function(n, r, t, e) {
        return A4(GZn, gQ(n), ORn, e, rA(A2(o3n, r, t)));
    }), F6n = F3(function(n, r, t) {
        return {
            s8: n,
            uX: t,
            wI: r
        };
    }), P6n = F4(function(n, r, t, e) {
        return {
            o9: e,
            k3: n,
            Cz: t,
            vp: r
        };
    }), z6n = A3(ly, "default_period_in_months", A2(nu, wdn, F$), A3(ly, "period_in_months", A2(nu, wdn, F$), A3(ly, "rate_in_cents_per_default_period", F$, A3(ly, "ongoing_amount_in_cents", F$, uu(P6n))))), j6n = A2(Pk, z6n, uu(iu)), S6n = A3(ly, "prepay_options", vy(j6n), A3(ly, "start_date_editable", jk, A3(ly, "min_start_date", ay, uu(F6n)))), L6n = A2(Pk, S6n, uu(iu)), M6n = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "setting"
        ]), lL(n));
    }), N6n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), L6n, e, rA(A2(M6n, r, t)));
    }), H6n = function(n) {
        return A2(Eu, pA, A2(Eu, XC, A2(se, ",", n)));
    }, T6n = function(n) {
        return m(n, {
            wN: A2(zM, function() {
                return function(n) {
                    return A2(PM, n.dn, !0);
                };
            }, n.wN)
        });
    }, I6n = F2(function(n, r) {
        var t = $9n(n);
        if (t.$) return r;
        var e = t.a;
        return A2(qM, e, r.x) ? m(k9n(r).a, {
            x: A3(FM, !0, e, r.x)
        }) : r;
    }), R6n = function(n) {
        return m(n, {
            cl: !1
        });
    }, Z6n = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), V6n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    aF: n.a
                }), Pp, Ut);
            case 1:
                return v(r, Pp, Vt(0));
            case 2:
                return v(r, Pp, Vt(1));
            case 3:
            case 4:
                return v(r, function(n) {
                    return A2(hc, Z6n(n), eX(n));
                }(r.fu), Ut);
            default:
                var t = n.a, e = n.b;
                if (e.$) return v(r, Pp, Ut);
                var u = e.a;
                return i(t, r.fu) ? v(m(r, {
                    ic: A2(Ve, 0, 24 - (u.ku.lR - u.jT.lR))
                }), Pp, Ut) : v(r, Pp, Ut);
        }
    }), U6n = F2(function(n, r) {
        var t = FL(r.kB), e = A2(j3n, n, t.aq.a);
        return A2(I6n, e, A2(h9n, e, A2(_3n, e, r)));
    }), Y6n = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Q6n = function(n) {
        return a0n(n) && !u0n(n);
    }, O6n = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "members",
            "min"
        ]), lL(n));
    }), G6n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(A1n), e, rA(A2(O6n, r, t)));
    }), J6n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, W6n = function(n) {
        return b("plan", n.$ ? yx : eQn(f6n(n.a)));
    }, K6n = F3(function(n, r, t) {
        var e = A2(wF, function(r) {
            return i(r.a, n);
        }, t);
        return e.$ ? b(n, r) : e.a;
    }), X6n = F3(function(n, r, t) {
        var e = n;
        return _x(A2(Yt, A3(K6n, "name", G$n(e.tg), r), A2(Yt, A3(K6n, "dob", WFn(e.pn), r), A2(Yt, A3(K6n, "relationship", GFn(e.vB), r), A2(Yt, A3(K6n, "uses_tobacco", LC(e.xy), r), t)))));
    }), n4n = function(n) {
        return n.vB;
    }, r4n = function(n) {
        var r = n;
        return r.tV ? A2(Rc, function(n) {
            return !REn(n4n(n));
        }, r.A8) : r.A8;
    }, t4n = F2(function(n, r) {
        var t = r.m7;
        if (t.$) return Pp;
        var e = W6n(t.a), u = FL(r.kB), a = u.DN, i = u.aq, c = k6n(u.b4), o = y6n(a), f = b("members", A2(KK, function(n) {
            return A3(X6n, n, h, x([
                o
            ]));
        }, r4n(n))), s = A3(x6n, r.fL, i.a, x([
            o,
            c,
            e,
            f
        ])), l = _x(s);
        return function(n) {
            var r = A5(p9n, !0, n.lB, n.aO, n.dz, n.kB), t = r.b;
            return b(m(n, {
                kB: r.a
            }), t);
        }(r).b ? A4(pPn, r.gF, Bx(r.dB), l, J6n) : Pp;
    }), e4n = function(n) {
        var r = n.tO;
        if (3 === r.$) {
            var t = r.a;
            return Q6n(n.lB) ? A2(t4n, t, n) : n.A8.$ ? Pp : A4(G6n, n.gF, Bx(n.dB), B9n(t), Y6n);
        }
        return Pp;
    }, u4n = F2(function(n, r) {
        switch(n.$){
            case 14:
                var t = n.a, e = m(r, {
                    tO: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (Zn = e.f0).$ ? Pp : V0n(Zn.a), i = KXn(u), c = x(i ? [
                        FXn(n2n(u)),
                        AXn,
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]), o = A7(OU, r.gF, Bx(e.dB), s6n(R3n(u)), Mcn(u.tU), A2(Eu, p0n, u.hZ), !0, M3n), f = R3n(u), s = u0n(r.lB) ? b(Pp, vc) : b(A4(N6n, r.gF, Bx(r.dB), B9n(u), N3n), cP), l = s.a, d = s.b;
                    return v(g = m(e, {
                        f0: Ut,
                        m7: Vt(f),
                        hg: i,
                        aO: d,
                        cK: p3n(o6n(f))
                    }), Vu(x([
                        l,
                        a,
                        o,
                        A4(I0n, 7, g.DF, g.fL, h),
                        q9n(g)
                    ])), c);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 19:
                var p = n.a, g = p.$ ? r : m(r, {
                    hz: Vt(p.a)
                });
                return r.hg ? v(g, A4(R9n, Ut, r.fL, r.lB, r.xs), x([
                    H3n
                ])) : v(g, D6n(g), h);
            case 0:
                if (r.hg) return v(r, A4(R9n, Ut, r.fL, r.lB, r.xs), x([
                    H3n
                ]));
                var w = FL(r.kB), k = x3n(zn = w.al);
                if (g = function(n) {
                    return m(n, {
                        x: T6n(n.x)
                    });
                }(A2(I6n, k, A2(h9n, k, A2(_3n, k, m(r, {
                    u3: !0,
                    b8: Ut,
                    dS: !0
                }))))), 1 === zn.$) {
                    var y = k9n(g), _ = y.a;
                    return (rn = y.b) ? v(_, xJn(0), h) : v(m(_, {
                        u3: !1
                    }), u6n(_), h);
                }
                if (tln(r.dz)) {
                    var A = k9n(g);
                    return _ = A.a, (rn = A.b) ? v(_, xJn(0), h) : v(Ln = m(_, {
                        u3: !1
                    }), u6n(Ln), h);
                }
                return v(g, A2(Lp, r3n, esn), h);
            case 1:
                var C = n.a;
                g = m(r, {
                    u3: !1,
                    aR: !1,
                    dS: !1
                });
                n: for(;;)switch(C.$){
                    case 3:
                        var B = C.a, E = x([
                            Q1n(Ut),
                            H3n
                        ]);
                        return v(g, Vu(x([
                            A4(R9n, Vt(B), r.fL, r.lB, r.xs),
                            W9n,
                            A4(H0n, 7, r.DF, r.fL, h)
                        ])), E);
                    case 2:
                        if (5 === C.a.$) return A2(U9n, H6n(Tn = C.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Pp, A2(xA, 1, C));
            case 2:
                C = n.a, g = m(r, {
                    u3: !1,
                    aR: !1,
                    dS: !1
                });
                n: for(;;)switch(C.$){
                    case 3:
                        return c = x([
                            Q1n(Ut),
                            H3n
                        ]), v(g, Vu(x([
                            A4(R9n, Ut, r.fL, r.lB, r.xs),
                            W9n
                        ])), c);
                    case 2:
                        if (5 === C.a.$) return A2(U9n, H6n(Tn = C.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Pp, A2(xA, 1, C));
            case 3:
                var D = n.a, q = (g = m(r, {
                    Y: D
                }), FL(g.kB));
                return 3 === D.$ ? v(m(g, {
                    kB: lS(A2(L9n, q, D.a))
                }), Pp, h) : v(g, Pp, A2(xA, 1, D));
            case 4:
                var F = n.a;
                n: for(;;)switch(F.$){
                    case 3:
                        g = m(r, {
                            fr: Vt(F.a)
                        });
                        var P = q9n(g);
                        return v(g, P, h);
                    case 2:
                        if (5 === F.a.$) {
                            var z = Vt(WWn(x([
                                pA(a6n(Tn = F.a.b))
                            ])));
                            return v(m(r, {
                                b8: z
                            }), V9n(Tn), A2(xA, 1, F));
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, F));
            case 5:
                var j = n.a, S = m(r, {
                    aO: j
                }), L = Q1n(Ut);
                return 3 === j.$ ? (d = j.a, 2 === r.fc.$ ? (q = FL(S.kB), v(g = m(S, {
                    kB: lS(A3(S9n, q, d, S.xs.iF))
                }), e4n(g), h)) : v(S, Pp, h)) : v(S, Pp, A2(Yt, L, A2(xA, 1, j)));
            case 6:
                return v(A2(h9n, on = n.a, A2(_3n, on, r)), Pp, h);
            case 8:
                var M = A2(ZD, n.a, r.cK), N = M.a, H = M.b, T = M.c;
                if (T.$ || T.a.$) return v(m(r, {
                    cK: N
                }), A2(Lp, I3n, H), h);
                var I = T.a.a, R = 1 === (Rn = A2(Fp, m3n, I)).$ ? h : x([
                    Rn.a
                ]), Z = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(I), V = (g = A2(I6n, Z, A2(h9n, Z, A2(_3n, Z, m(r, {
                    cK: N
                })))), A3(J9n, g, Z, R));
                return v(g, Vu(x([
                    A2(Lp, I3n, H),
                    e4n(g)
                ])), x([
                    V
                ]));
            case 7:
                var U = n.a, Y = FL(r.kB).DN, Q = A2(C8, U, Y), O = Q.a, G = Q.c, J = A2(Lp, G2n, Q.b), W = function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(function() {
                    if (G.$ || 2 !== G.a.$) return O;
                    var n = G.a.a;
                    return A2(S8, s9n(n), A2(j8, n, O));
                }()), K = (g = A2(_3n, W, r), function() {
                    n: for(; !G.$;)switch(G.a.$){
                        case 0:
                            return v(A2(I6n, W, A2(h9n, W, g)), h, e4n(g));
                        case 1:
                            return v(g, x([
                                A3(J9n, g, W, h)
                            ]), Pp);
                        default:
                            break n;
                    }
                    var n = aF(Y.oY) ? h : x([
                        A3(J9n, g, W, h)
                    ]);
                    return v(g, n, Pp);
                }());
                return E = K.b, v(_ = K.a, Vu(x([
                    J,
                    K.c
                ])), E);
            case 9:
                g = m(r, {
                    iW: !0
                });
                var X = FL(r.kB);
                return v(g, Pp, x([
                    A3(J9n, r, on = A2(j3n, (un = X.aq).b, un.a), x([
                        "Show"
                    ]))
                ]));
            case 10:
                var nn = (un = FL(r.kB).aq).a, rn = un.b, tn = (g = (fM(nn) ? U6n(!0) : U6n(rn))(m(r, {
                    oA: vc
                })), fM(nn) ? e4n(g) : A4(N9n, r.gF, Bx(r.dB), nn, S3n));
                return v(g, tn, x([
                    A3(J9n, g, on = A2(j3n, un.b, un.a), h)
                ]));
            case 11:
                var en = FL(r.kB);
                return v(r, Pp, x([
                    A3(J9n, r, on = A2(j3n, (un = en.aq).b, un.a), h)
                ]));
            case 12:
                var un, an = n.a, cn = (g = m(r, {
                    oA: an
                }), FL(r.kB)), on = A2(j3n, (un = cn.aq).b, un.a);
                switch(an.$){
                    case 3:
                        return v(fn = A2(U6n, !0, g), e4n(fn), x([
                            A3(J9n, fn, on, h)
                        ]));
                    case 2:
                        switch(an.a.$){
                            case 5:
                                return v(fn = A2(U6n, !1, g), Pp, x([
                                    A3(J9n, fn, on, h)
                                ]));
                            case 9:
                                var fn;
                                return v(fn = A2(U6n, !1, g), Pp, x([
                                    A3(J9n, fn, on, h)
                                ]));
                            default:
                                return v(m(r, {
                                    oA: vc
                                }), Pp, A2(xA, 1, an));
                        }
                    default:
                        return v(g, Pp, A2(xA, 1, an));
                }
            case 13:
                var sn = n.a, ln = FL(r.kB), dn = A2(rO, sn, ln.Y), bn = (o = dn.b, dn.c), vn = L3n(dn.a), mn = A2(sc, b(g = A2(_3n, vn, r), h), A2(Fp, function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                            return b(g, x([
                                A3(y9n, g, vn, FY(r = n.a.b))
                            ]));
                        case 0:
                            var r = n.a.b, t = A2(I6n, vn, A2(h9n, vn, g));
                            return b(t, x([
                                A3(y9n, t, vn, FY(r))
                            ]));
                        case 3:
                            return b(g, h);
                        default:
                            return b(g, n.a);
                    }
                }, bn));
                return E = mn.b, v(_ = mn.a, wn = A2(sc, A2(Lp, W2n, o), A2(Fp, function(n) {
                    if (3 === n.$) {
                        var r = A3(w9n, g, vn, FY(n.a.b)), t = r.a;
                        return Vu(x([
                            RXn({
                                eH: A2(sc, h, A2(Fp, VZ, r.b)),
                                qv: t
                            }),
                            A2(Lp, W2n, o)
                        ]));
                    }
                    return A2(Lp, W2n, o);
                }, bn)), E);
            case 15:
                if (sn = n.a, (zn = FL(r.kB).al).$) return v(r, Pp, h);
                var pn = A2(Rsn, sn, zn.a), $n = pn.b, hn = pn.c, gn = (k = x3n(Vt(pn.a)), A2(_3n, k, r)), wn = x([
                    A2(Lp, r3n, $n)
                ]);
                if (hn.$) return v(g = A2(h9n, k, gn), Vu(wn), x([
                    A2(c6n, g, k)
                ]));
                switch(hn.a.$){
                    case 2:
                        return v(m(gn, {
                            aR: !0
                        }), Vu(wn), h);
                    case 1:
                        return v(gn, Vu(A2(Yt, A4(J3n, r.gF, r.dB, r.fc, hn.a.a), wn)), x([
                            A2(c6n, gn, k)
                        ]));
                    default:
                        return g = A2(U9n, x([
                            hn.a.a
                        ]), A2(I6n, k, A2(h9n, k, m(gn, {
                            u3: !1,
                            aR: !1
                        }))));
                }
            case 16:
                var xn = n.a, kn = function() {
                    if (xn) return v(Ut, Pp, "Skip Payment");
                    var n = u0n(r.lB), t = A6(ifn, n, r.kA, r.dB, r.yR, V3n(r.fr), r.gF), e = t.b, u = e3n(t.a), a = A2(Lp, r3n, e);
                    return v(Vt(u), a, "Payment Method");
                }(), yn = ($n = kn.b, kn.c);
                return k = x3n(kn.a), v(g = A2(_3n, k, r), $n, x([
                    A3(J9n, g, k, x([
                        yn
                    ]))
                ]));
            case 17:
                var _n = n.a;
                g = m(r, {
                    fe: vc,
                    dz: vc,
                    aR: !1
                });
                n: for(;;)switch(_n.$){
                    case 3:
                        var An = u0n(r.lB), Cn = A6(u3n, An, r.kA, r.dB, r.fL, r.yR, r.gF);
                        return tn = Cn.b, k = x3n(zn = Cn.a), v(gn = A2(_3n, k, g), tn, A2(xA, 1, _n));
                    case 2:
                        if (5 === _n.a.$) return A2(U9n, H6n(Tn = _n.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Pp, A2(xA, 1, _n));
            case 18:
                var Bn = A2(V6n, sn = n.a, r.cT), En = Bn.a, Dn = Bn.b, qn = Bn.c;
                return tn = qn.$ || qn.a ? Pp : A2(Nu, iu, _u(z3n)), v(m(r, {
                    cT: En
                }), Vu(x([
                    A2(Lp, E3n, Dn),
                    tn
                ])), h);
            case 20:
                var Fn = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), Pn = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, Pn, Fn) ? A2(U0n, Pn, Fn) : Pp, h);
            case 21:
                g = m(r, {
                    dz: _n = n.a
                });
                n: for(;;)switch(_n.$){
                    case 3:
                        P = q9n(g);
                        var zn, jn = FL(r.kB), Sn = (k = x3n(A2(nv, function(n) {
                            return Vt(R6n(n));
                        }, zn = jn.al)), k9n(A2(_3n, k, g)));
                        if (_ = Sn.a, (rn = Sn.b) && r.u3) return v(m(_, {
                            b8: Ut
                        }), Vu(x([
                            xJn(0),
                            P
                        ])), h);
                        var Ln = m(g, {
                            u3: !1,
                            aR: !1
                        });
                        return v(m(Ln, {
                            b8: Ut
                        }), P, h);
                    case 2:
                        if (5 === _n.a.$) return A2(U9n, H6n(Tn = _n.a.b), m(g, {
                            u3: !1,
                            aR: !1
                        }));
                        break n;
                    default:
                        break n;
                }
                return v(m(g, {
                    u3: !1,
                    aR: !1
                }), Pp, A2(xA, 1, _n));
            case 22:
                var Mn = b(r.dz, r.fc);
                if (3 === Mn.a.$ && 2 === Mn.b.$) {
                    var Nn = Mn.b.a;
                    return v(m(r, {
                        aR: !0
                    }), A4(q6n, r.gF, Bx(r.dB), Nn, T3n), h);
                }
                return v(r, Pp, h);
            case 23:
                switch((_n = n.a).$){
                    case 3:
                        var Hn = function() {
                            var n = u0n(r.lB), t = A6(ifn, n, r.kA, r.dB, r.yR, V3n(r.fr), r.gF), e = t.b, u = e3n(t.a);
                            return b(Vt(u), A2(Lp, r3n, e));
                        }();
                        return $n = Hn.b, v(g = A2(_3n, x3n(Hn.a), m(r, {
                            dz: _n
                        })), Vu(x([
                            $n,
                            q9n(g)
                        ])), h);
                    case 2:
                        switch(_n.a.$){
                            case 9:
                                return v(m(r, {
                                    dz: vc
                                }), Pp, h);
                            case 5:
                                var Tn = _n.a.b;
                                return g = m(r, {
                                    dz: vc
                                }), A2(U9n, H6n(Tn), g);
                            default:
                                var In = _n.a;
                                return v(m(r, {
                                    dz: vc
                                }), Pp, $(hQ(_n), x([
                                    gA(In)
                                ])));
                        }
                    default:
                        return v(m(r, {
                            dz: vc
                        }), Pp, A2(xA, 1, _n));
                }
            case 24:
                return v(m(r, {
                    A8: n.a
                }), Pp, h);
            default:
                return v(m(r, {
                    fe: n.a
                }), Pp, h);
        }
        var Rn, Zn;
    }), a4n = F2(function(n, r) {
        var t = FL(r.kB).Y;
        return A2(nk, x([
            Hq(n6n),
            Xx("mx-1")
        ]), x([
            A2(Ck, W2n, A3(VG, n, x([
                aO(r.u3),
                iO(r.dS)
            ]), t))
        ]));
    }), i4n = F4(function(n, r, t, e) {
        return t3n(e) ? A2(nk, h, x([
            Dk,
            A3(EVn, n, r, Ex(t))
        ])) : tB;
    }), c4n = F2(function(n, r) {
        if (3 === r.$) {
            var t = A2(sc, "", A2(Fp, function(n) {
                return " (" + UQ(n) + ")";
            }, (e = r.a).$ ? Ut : e.a.qT));
            return $(n(Psn), t);
        }
        var e;
        return n(Psn);
    }), o4n = function(n) {
        return n.dz;
    }, f4n = function(n) {
        return n.y_.l5;
    }, s4n = function(n) {
        return n.y_.nv;
    }, l4n = function(n) {
        return n.y_.oK;
    }, d4n = function(n) {
        return n.y_.oL;
    }, b4n = function(n) {
        return n.y_.wd;
    }, v4n = function(n) {
        var r = l0n(n);
        return WDn(r);
    }, m4n = function(n) {
        return {
            $: 16,
            a: n
        };
    }, p4n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $4n = F5(function(n, r, t, e, u) {
        if (t) return A2(C5, x([
            $5,
            T5("skip"),
            qkn(LP(r)),
            D5(cm(m4n(1))),
            Fkn(e),
            p4n(x([
                Xx("h-full")
            ]))
        ]), x([
            ld(n(f4n))
        ]));
        var a = n(u ? d4n : l4n);
        return A2(C5, x([
            $5,
            T5("card"),
            qkn(aF(r)),
            D5(cm(m4n(0))),
            Fkn(e),
            p4n(x([
                Xx("h-full")
            ]))
        ]), x([
            ld(a)
        ]));
    }), h4n = F6(function(n, r, t, e, u, a) {
        return A2(zN, x([
            KN(x([
                Xx("px-1")
            ]))
        ]), A2(Eu, function(e) {
            return A2(EN, x([
                kcn(r),
                KN(x([
                    Xx("column--topSpaceMd")
                ]))
            ]), x([
                A5($4n, n, t, e, u, a)
            ]));
        }, e));
    }), g4n = F7(function(n, r, t, e, u, a, i) {
        var c, o = v4n(t) && !u0n(e), f = (c = b(aon(u) || ion(u), o)).a && c.b ? b(x([
            0,
            1
        ]), 4) : b(h, 12), s = f.a, l = f.b;
        if (!be(s)) return tB;
        switch(r.$){
            case 3:
            case 1:
                return tB;
            default:
                var d = aon(u);
                return A2(XH, x([
                    HH(n(b4n))
                ]), x([
                    A6(h4n, n, l, a, s, i, d)
                ]));
        }
    }), w4n = {
        $: 22
    }, x4n = F3(function(n, r, t) {
        return A2(zN, x([
            KN(x([
                Xx("px-1")
            ]))
        ]), x([
            A2(EN, x([
                JI(6)
            ]), x([
                A2(FI, x([
                    bq
                ]), x([
                    ld(A2(mfn, n, r))
                ]))
            ])),
            A2(EN, x([
                JI(6),
                _N(ycn)
            ]), x([
                A2(oR, !t, A2(OC, x([
                    wO,
                    EC(w4n)
                ]), x([
                    ld(n(s4n))
                ])))
            ]))
        ]));
    }), k4n = F4(function(n, r, t, e) {
        switch(t.$){
            case 3:
                return A3(x4n, n, t.a, e);
            case 1:
                return A2(nk, h, ck);
            default:
                return function(n) {
                    var r = FL(n).al;
                    return A2(nk, x([
                        Hq(r6n)
                    ]), function() {
                        if (r.$) return h;
                        var n = r.a;
                        return A2(Eu, Ck(r3n), Pln(n));
                    }());
                }(r);
        }
    }), y4n = F2(function(n, r) {
        if (t3n(r.fL)) {
            var t = FL(r.kB).al;
            return A2(nk, h, x([
                A2(Ak, x([
                    _H(BN)
                ]), x([
                    ld(n(o4n))
                ])),
                A7(g4n, n, r.dz, r.fL, r.lB, r.dB, t, r.u3),
                t.$ ? tB : A2(Ek, x([
                    _H(cR)
                ]), x([
                    A2(X8, h, x([
                        ld(A2(c4n, n, r.dz))
                    ]))
                ])),
                A4(k4n, n, r.kB, r.dz, r.u3)
            ]));
        }
        return tB;
    }), _4n = function(n) {
        return n.up;
    }, A4n = {
        $: 9
    }, C4n = {
        $: 11
    }, B4n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, E4n = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), D4n = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), q4n = function(n) {
        return n.ph;
    }, F4n = function(n) {
        return n.pI;
    }, P4n = function(n) {
        return function(n) {
            var r = q4n(n);
            return r.$ ? lV(r.a) : OZ(r.a) + "%";
        }(n) + " off " + (function(n) {
            var r = F4n(n);
            switch(r.$){
                case 0:
                    return "for unlimited time";
                case 1:
                    return "for one month";
                default:
                    return "for " + oe(r.a) + " months";
            }
        }(n) + function(n) {
            var r = b(q4n(n), function(n) {
                return n.gG;
            }(n));
            return 1 === r.a.$ && r.b ? " on each member" : "";
        }(n));
    }, z4n = function(n) {
        if (3 === n.$) {
            var r = n.a;
            return A2(FI, x([
                $H,
                fq
            ]), x([
                ld(P4n(r))
            ]));
        }
        return ld("");
    }, j4n = F2(function(n, r) {
        var t, e = FL(r.kB).aq, u = e.a, a = e.b;
        return A2(nk, x([
            Xx("mb-4 md:mb-6"),
            Hq(X9n)
        ]), x([
            A2(XH, x([
                HH(n(e9n))
            ]), x([
                vI(x([
                    xI(u),
                    gI(A2(pc, B4n, j3n(a))),
                    JT(A3(D4n, r.kB, r.x, 2)),
                    YT(r.u3 || (t = r.xs, aF(i3n(t.iF)))),
                    XT(J2n),
                    nI(C4n)
                ])),
                A2(ET, n, A3(E4n, r.kB, r.x, 2)),
                z4n(r.oA)
            ]))
        ]));
    }), S4n = F2(function(n, r) {
        return c0n(r.fL) ? r.iW ? A2(j4n, n, r) : A2(nk, x([
            Xx("mb-4 md:mb-6 -mt-2 md:-mt-4")
        ]), x([
            A2(OC, x([
                wO,
                EC(A4n)
            ]), x([
                ld(n(r9n))
            ]))
        ])) : tB;
    }), L4n = F2(function(n, r) {
        if (3 === n.$) {
            var t = j9n(n.a);
            return aF(A2(z9n, t, r));
        }
        return !1;
    }), M4n = F2(function(n, r) {
        var t, e = 3 === (t = r.aO).$ ? j9n(t.a) : h, u = d0n(r.fL), a = FL(r.kB).b4;
        return TE(e) || !u ? tB : A2(nk, x([
            Xx("mb-4 md:mb-6")
        ]), x([
            A2(XH, x([
                HH(n(X3n)),
                VH(!0)
            ]), x([
                A2(Ck, I3n, A4(sF, n, x([
                    Dq(a),
                    xq(n(n9n)),
                    vq,
                    AR(r.u3 || A2(L4n, r.aO, r.xs.iF)),
                    Nxn(A3(D4n, r.kB, r.x, 0))
                ]), A2(Eu, function(n) {
                    return A2(hq, h, n);
                }, e), r.cK))
            ])),
            A2(ET, n, A3(E4n, r.kB, r.x, 0))
        ]));
    }), N4n = iu, H4n = function(n) {
        return n.dt.rQ;
    }, T4n = F2(function(n, r) {
        return r.ov(n);
    }), I4n = F2(function(n, r) {
        return r.ox(n);
    }), R4n = F3(function(n, r, t) {
        var e = A2(NL, aS("/"), t);
        return function(n) {
            return 1 === n;
        }(r) ? A2(FI, x([
            $H,
            fq
        ]), x([
            ld(n(T4n(e)))
        ])) : A2(FI, x([
            $H,
            fq
        ]), x([
            ld(n(I4n(e)))
        ]));
    }), Z4n = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return tB;
        var u = e.a.a, a = e.b.a, i = v(function(n) {
            return n.or;
        }(u), function(n) {
            return n.oy;
        }(u), function(n) {
            return n.os;
        }(a));
        return !i.a || i.b.$ || i.c.$ ? tB : A3(R4n, n, i.b.a, i.c.a);
    }), V4n = F3(function(n, r, t) {
        var e = FL(t.kB).DN;
        return A2(nk, x([
            Xx("mb-4 md:mb-6"),
            Hq(t6n)
        ]), x([
            A2(XH, x([
                HH(n(H4n)),
                VH(!0)
            ]), x([
                A2(Ck, G2n, A2(w7, x([
                    N4n(r)
                ]), e)),
                A3(Z4n, n, A2(nv, o6n, t.m7), t.fr),
                A2(ET, n, A3(E4n, t.kB, t.x, 1))
            ]))
        ]));
    }), U4n = F2(function(n, r) {
        if (v0n(r.fL)) {
            var t = r.aO;
            return 3 === t.$ ? A3(V4n, n, r.u3 || !function(n) {
                return n.wI;
            }(t.a), r) : tB;
        }
        return tB;
    }), Y4n = F2(function(n, r) {
        var t;
        return d0n(t = r.fL) || c0n(t) || v0n(t) ? A2(zN, x([
            KN(x([
                Xx("px-1"),
                Xx("-my-1")
            ]))
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(Ak, x([
                    _H(BN)
                ]), x([
                    ld(n(_4n))
                ])),
                A2(M4n, n, r),
                A2(S4n, n, r),
                A2(U4n, n, r)
            ]))
        ])) : tB;
    }), Q4n = F2(function(n, r) {
        var t = u0n(r.lB);
        return A2(nk, x([
            Hq(n3n)
        ]), x([
            A2(y4n, n, r),
            A2(Y4n, n, r),
            A2(a4n, n, r),
            A4(i4n, t, n, r.dB, r.fL)
        ]));
    }), O4n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 12,
                a: n
            };
        }(n), r);
    }), G4n = function(n) {
        var r = n.dz;
        if (3 === r.$) {
            var t = b(Oin(r.a), uC(n.fe));
            return !t.a || !t.b.$;
        }
        return !1;
    }, J4n = function(n) {
        return n.tg;
    }, W4n = function(n) {
        return A2(Eu, function(n) {
            return function(n) {
                var r;
                return {
                    mr: (r = n, r.mr),
                    kI: REn(n4n(n)),
                    tg: J4n(n)
                };
            }(n);
        }, n);
    }, K4n = function(n) {
        return 3 === n.$ ? n.a : h;
    }, X4n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 10,
                a: n
            };
        }(n), r);
    }), n8n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(n), r);
    }), r8n = F2(function(n, r) {
        return n.$ ? r : A2(Yt, function(n) {
            return {
                $: 6,
                a: n
            };
        }(n.a), r);
    }), t8n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, e8n = F2(function(n, r) {
        return A2(Yt, t8n(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)), r);
    }), u8n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 11,
                a: n
            };
        }(n), r);
    }), a8n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 0,
                a: n
            };
        }(n), r);
    }), i8n = F2(function(n, r) {
        return n.$ ? r : A2(Yt, function(n) {
            return {
                $: 9,
                a: n
            };
        }(n.a), r);
    }), c8n = F2(function(n, r) {
        return n.$ ? r : A2(Yt, t8n(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a)), r);
    }), o8n = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 7,
                a: n
            };
        }(n), r);
    }), f8n = F2(function(n, r) {
        var t, e = (t = v(r.fe, r.yR, function(n) {
            var r, t = 3 === (r = n.dz).$ && Oin(r.a), e = FL(n.kB).al, u = !e.$ && function(n) {
                return 1 === n.dP;
            }(e.a);
            return u || t;
        }(r)), !(3 !== t.a.$ || !t.b || !t.c) && qon(t.a.a) > 0);
        return A2(O4n, function(n) {
            return n.uW;
        }(r.fL), A2(u8n, uC(r.fe), A3(He, X4n, e, (a0n(r.lB) ? c8n(r.fr) : e8n(W4n(K4n(r.A8))))(A2(n8n, r.u3 || function(n) {
            if (n.yR) {
                if (t = l0n(n.fL), Jwn(t)) return !1;
                if (v4n(n.fL)) {
                    var r = FL(n.kB);
                    return !!aF(r.al) && !G4n(n);
                }
                return !G4n(n);
            }
            var t;
            return !1;
        }(r), A2(o8n, !0, A2(r8n, r.b8, A2(i8n, r.m7, A2(a8n, n(Kdn), h)))))))));
    }), s8n = {
        m7: Ut,
        c4: Ut,
        g3: !1,
        g5: {
            $: 2
        },
        zn: !1,
        kw: Ut,
        AR: !1,
        Bf: !1,
        fe: Ut,
        iE: "Continue to next step",
        iN: Ut,
        iV: !1,
        jS: !1
    }, l8n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    iE: n.a
                });
            case 1:
                return m(r, {
                    zn: n.a
                });
            case 2:
                return m(r, {
                    AR: n.a
                });
            case 3:
                return m(r, {
                    c4: Vt(n.a)
                });
            case 4:
                return m(r, {
                    iN: Vt(n.a)
                });
            case 9:
                return m(r, {
                    m7: Vt(n.a)
                });
            case 5:
                return m(r, {
                    g5: n.a
                });
            case 6:
                return m(r, {
                    kw: Vt(n.a)
                });
            case 7:
                return m(r, {
                    jS: n.a
                });
            case 8:
                return m(r, {
                    Bf: n.a
                });
            case 10:
                return m(r, {
                    iV: n.a
                });
            case 11:
                return m(r, {
                    fe: n.a
                });
            default:
                return m(r, {
                    g3: n.a
                });
        }
    }), d8n = {
        $: 1
    }, b8n = {
        $: 2
    }, v8n = F4(function(n, r, t, e) {
        return A2(OC, x([
            oF,
            uF(t || r),
            uln(r),
            EC(e),
            gC(x([
                Xx("w-full mb-2")
            ]))
        ]), x([
            A2(ak, h, x([
                ld(n)
            ]))
        ]));
    }), m8n = function(n) {
        var r;
        return A2(nk, h, x([
            function() {
                var r = n.c4;
                if (r.$) return tB;
                var t = r.a;
                return A2(Ek, x([
                    $H,
                    rB(DB),
                    _H(BN)
                ]), x([
                    ld(t)
                ]));
            }(),
            (r = n.iN, r.$ ? tB : A2(nk, h, x([
                A4(v8n, r.a, n.AR, n.zn, b8n)
            ]))),
            A2(nk, h, x([
                A4(U2n, n.iE, n.AR, n.zn, d8n)
            ]))
        ]));
    }, p8n = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), $8n = function(n) {
        return n.tg;
    }, h8n = F3(function(n, r, t) {
        var e = E9n(t), u = A2(sc, 0, A2(Fp, qon, r)), a = e + u;
        return A2(nk, x([
            Xx("quote-info")
        ]), x([
            A2(nk, x([
                Xx("w-full text-center")
            ]), x([
                A2(nk, x([
                    Xx("hidden md:inline-flex md:flex-col")
                ]), x([
                    A2(Ck, yu, A7(MV, n, a, !1, Ut, p2, !1, !1)),
                    u > 0 ? A2(nk, x([
                        Xx("quote-info__bill")
                    ]), x([
                        A2(Ek, x([
                            nH,
                            rB(kF)
                        ]), x([
                            ld("Total amount")
                        ]))
                    ])) : tB
                ])),
                Dk
            ])),
            A2(Ck, yu, A2(_Zn, $8n(t), e)),
            A2(oR, aF(r), Dk),
            A2(Ck, yu, kZn(r))
        ]));
    }), g8n = function(n) {
        return n.tg;
    }, w8n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, x8n = function(n) {
        return n.aF ? "collapser-closed" : "collapser-open";
    }, k8n = function(n) {
        var r = n.kI ? "primary" : "dependent", t = A2(fe, ", ", A2(Tp, iu, x([
            A2(Fp, function(n) {
                return oe(n) + " y/o";
            }, n.mr),
            Vt(r)
        ])));
        return A2(nk, x([
            Xx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), x([
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(Ek, h, x([
                    ld(n.tg)
                ]))
            ])),
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(t)
                ]))
            ]))
        ]));
    }, y8n = function(n) {
        return A2(nk, x([
            Xx("mt-2 md:mt-6")
        ]), A2(Eu, k8n, n));
    }, _8n = function(n) {
        return su(n) > 0 ? A2(Ek, x([
            O0,
            _H(iR),
            _H(Acn),
            A2(D2n, 2, BN),
            A2(D2n, 2, yan),
            rB(DB)
        ]), x([
            ld(n)
        ])) : tB;
    }, A8n = F3(function(n, r, t) {
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex w-full")
            ]), x([
                A2(nk, x([
                    Xx("flex-grow")
                ]), x([
                    _8n(g8n(n))
                ])),
                A2(nk, x([
                    Xx("flex-shrink flex -mt-1"),
                    SC(x([
                        b("mb-2", !t.aF)
                    ]))
                ]), x([
                    A2(nk, x([
                        Xx("collapser")
                    ]), x([
                        A2(nk, x([
                            Xx(x8n(t))
                        ]), x([
                            A2(OC, x([
                                zI,
                                EC(w8n(!t.aF))
                            ]), x([
                                A2(PE, h, 6)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(Ck, yu, A2(oR, !t.aF, A2(nk, h, x([
                y8n(r)
            ]))))
        ]));
    }), C8n = F5(function(n, r, t, e, u) {
        var a = be(r) > 0;
        return e ? A2(nk, x([
            Xx("quote-info")
        ]), x([
            A2(oR, a, A3(A8n, n, r, u)),
            A2(oR, aF(t) && !u.aF, Dk)
        ])) : A2(Ck, yu, A2(nk, x([
            Xx("quote-info")
        ]), x([
            A2(oR, a, _8n(g8n(n))),
            A2(oR, a, Dk),
            y8n(r),
            A2(oR, a && aF(t), Dk)
        ])));
    }), B8n = function(n) {
        return n.vy;
    }, E8n = function(n) {
        return n.A8;
    }, D8n = function(n) {
        return n.tg;
    }, q8n = F2(function(n, r) {
        var t;
        return A2(nk, x([
            Xx("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), x([
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(Ek, h, x([
                    QE(D8n(r))
                ]))
            ])),
            A2(oR, !n, A2(nk, x([
                Xx("flex")
            ]), x([
                A2(Ek, x([
                    $H
                ]), x([
                    ld(lV((t = r, t.vo)))
                ]))
            ])))
        ]));
    }), F8n = function(n) {
        var r = E8n(n), t = n.sp;
        return A2(nk, x([
            Xx("mt-2 md:mt-6")
        ]), A2(Eu, q8n(t), r));
    }, P8n = function(n) {
        return n.fr.kr;
    }, z8n = function(n) {
        return n.fr.qA;
    }, j8n = function(n) {
        return n.fr.Cb;
    }, S8n = function(n) {
        return n.fr.CU;
    }, L8n = function(n) {
        return n.fr.CV;
    }, M8n = function(n) {
        return n.fr.Dg;
    }, N8n = function(n) {
        return n.fr.Ef;
    }, H8n = F3(function(n, r, t) {
        if (Z3n(r) > 0) {
            var e = "Registration Fee" === t ? n(j8n) : t;
            return A2(nk, h, x([
                A2(Ek, x([
                    $H
                ]), x([
                    A2(nk, x([
                        Xx("flex justify-between w-full")
                    ]), x([
                        A2(nk, x([
                            Xx("flex pr-8")
                        ]), x([
                            ld(e)
                        ])),
                        A2(nk, x([
                            Xx("flex")
                        ]), x([
                            ld(lV(Z3n(r)))
                        ]))
                    ]))
                ]))
            ]));
        }
        return tB;
    }), T8n = F4(function(n, r, t, e) {
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex w-full")
            ]), x([
                A2(nk, x([
                    Xx("flex-grow")
                ]), x([
                    A2(Ek, x([
                        $H
                    ]), x([
                        ld("Pricing Breakdown")
                    ]))
                ])),
                A2(nk, x([
                    Xx("flex-shrink flex -mt-1"),
                    SC(x([
                        b("mb-2", !e.aF)
                    ]))
                ]), x([
                    A2(nk, x([
                        Xx("collapser")
                    ]), x([
                        A2(nk, x([
                            Xx(x8n(e))
                        ]), x([
                            A2(OC, x([
                                zI,
                                EC(w8n(!e.aF))
                            ]), x([
                                A2(PE, h, 6)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(Ck, yu, A2(oR, !e.aF, A2(nk, h, x([
                F8n(r),
                A2(nk, x([
                    Xx("mb-2")
                ]), h),
                A3(H8n, n, r, B8n(t))
            ]))))
        ]));
    }), I8n = function(n) {
        return "with " + lV(n) + " discount";
    }, R8n = F2(function(n, r) {
        var t = q4n(n);
        return t.$ ? A2(Fp, I8n, r) : Vt("with " + OZ(t.a) + "% discount");
    }), Z8n = F4(function(n, r, t, e) {
        var u = b(t, F4n(n));
        if (!u.a) return A2(R8n, n, e);
        switch(u.b.$){
            case 1:
                return Ut;
            case 0:
                return A2(R8n, n, e);
            default:
                return s(u.b.a, EV(r)) > 0 ? A2(R8n, n, e) : Ut;
        }
    }), V8n = F2(function(n, r) {
        var t = function(n) {
            return n.oA;
        }(n);
        if (t.$) return tB;
        var e = t.a, u = function(n) {
            return n.oB;
        }(n), a = BMn(n), i = A4(Z8n, e, a, r, u);
        if (i.$) return tB;
        var c = i.a;
        return A2(FI, x([
            $H,
            EZ,
            ok(x([
                Xx("badge")
            ]))
        ]), x([
            ld(c)
        ]));
    }), U8n = F4(function(n, r, t, e) {
        var u = Vt(BMn(t)), a = EMn(t);
        return A2(nk, x([
            Xx("w-full text-center")
        ]), x([
            A2(nk, x([
                Xx("hidden md:inline-flex md:flex-col")
            ]), x([
                A7(MV, n, a, e, u, kF, !1, !1),
                A2(V8n, t, !0),
                _8n(r)
            ])),
            Dk,
            A2(nk, x([
                Xx("md:hidden")
            ]), x([
                A2(nk, x([
                    Xx("flex justify-between")
                ]), x([
                    _8n(r),
                    A2(V8n, t, !0),
                    A2(nk, h, x([
                        A7(MV, n, a, e, u, kF, !1, !1)
                    ]))
                ])),
                Dk
            ]))
        ]));
    }), Y8n = F2(function(n, r) {
        var t = d3n(n);
        return !t.$ && i(t.a, BMn(r));
    }), Q8n = function(n) {
        return n.m8;
    }, O8n = function(n) {
        return n.DN;
    }, G8n = F2(function(n, r) {
        if (Q8n(r)) {
            var t = EV(BMn(n));
            return {
                yj: EMn(n),
                oY: A3(rj, 1, t, O8n(n))
            };
        }
        return {
            yj: EMn(n) + Z3n(n),
            oY: O8n(n)
        };
    }), J8n = F2(function(n, r) {
        var t = EV(BMn(n)), e = A3(rj, 1, t, O8n(n));
        return Q8n(r) ? {
            yj: D9n(n),
            oY: A3(rj, 1, t, e)
        } : {
            yj: D9n(n),
            oY: e
        };
    }), W8n = F2(function(n, r) {
        var t = A2(J8n, r, n);
        return i(A2(G8n, r, n).yj, t.yj);
    }), K8n = F2(function(n, r) {
        var t = A2(J8n, r, n), e = A2(G8n, r, n);
        return A2(W8n, n, r) ? A2(Y8n, n, r) ? b(Vt(e), Ut) : b(Ut, Vt(t)) : b(Vt(e), Vt(t));
    }), X8n = F2(function(n, r) {
        var t = b(Q8n(r), Z3n(n) > 0);
        if (t.a && t.b) {
            var e = {
                yj: Z3n(n),
                oY: O8n(n)
            };
            return Vt(e);
        }
        return Ut;
    }), n5n = F3(function(n, r, t) {
        return 1 === A2(X8n, t, r).$ ? A2(Y8n, r, t) ? b(Vt(n(N8n)), Ut) : b(Vt(n(z8n)), Vt(n(L8n))) : b(Vt(n(M8n)), Vt(n(S8n)));
    }), r5n = F2(function(n, r) {
        var t = A2(J8n, r, n), e = A2(G8n, r, n);
        return A2(W8n, n, r) && !A2(Y8n, n, r) ? e.oY : t.oY;
    }), t5n = function(n) {
        return A2(NL, aS("/"), n);
    }, e5n = F6(function(n, r, t, e, u, a) {
        var i = b(r, t);
        if (i.a.$ || i.b.$) return tB;
        var c = i.a.a, o = i.b.a, f = a ? n(P8n) : t5n(c.oY), s = A2(sc, c.yj, A2(Fp, hcn, u));
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex-auto hidden md:block text-center")
            ]), x([
                A7(MV, n, s, !1, Ut, kF, !1, !1),
                A2(nk, x([
                    Xx("quote-info__bill")
                ]), x([
                    A2(Ek, x([
                        nH,
                        rB(kF)
                    ]), x([
                        ld(o)
                    ])),
                    A2(FI, x([
                        $H,
                        rB(kF)
                    ]), x([
                        ld(f)
                    ]))
                ])),
                A2(V8n, e, !1)
            ])),
            A2(nk, x([
                Xx("md:hidden")
            ]), x([
                A2(nk, x([
                    Xx("flex")
                ]), x([
                    A2(nk, x([
                        Xx("flex quote-info__bill")
                    ]), x([
                        A2(Ek, x([
                            nH,
                            rB(cq),
                            fq
                        ]), x([
                            ld(o)
                        ])),
                        A2(FI, x([
                            $H,
                            rB(cq),
                            _H(Z2n)
                        ]), x([
                            ld(f)
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("ml-auto")
                    ]), x([
                        A7(MV, n, s, !1, Ut, kF, !1, !1)
                    ]))
                ])),
                A2(V8n, e, !1),
                Dk
            ]))
        ]));
    }), u5n = F7(function(n, r, t, e, u, a, i) {
        var c = b(r, t);
        if (c.a.$ || c.b.$) return tB;
        var o = c.a.a, f = c.b.a, s = i ? n(P8n) : t5n(e);
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex-auto hidden md:block text-center")
            ]), x([
                A2(nk, x([
                    Xx("flex justify-center")
                ]), x([
                    A7(MV, n, o.yj, !0, Vt(BMn(u)), kF, !1, a)
                ])),
                A2(nk, x([
                    Xx("quote-info__bill")
                ]), x([
                    A2(Ek, x([
                        nH,
                        rB(kF)
                    ]), x([
                        ld(f)
                    ])),
                    A2(FI, x([
                        $H,
                        rB(kF)
                    ]), x([
                        ld(s)
                    ]))
                ])),
                A2(V8n, u, !0)
            ])),
            A2(nk, x([
                Xx("md:hidden")
            ]), x([
                A2(nk, x([
                    Xx("flex")
                ]), x([
                    A2(nk, x([
                        Xx("flex quote-info__bill")
                    ]), x([
                        A2(Ek, x([
                            nH,
                            rB(cq),
                            fq
                        ]), x([
                            ld(f)
                        ])),
                        A2(FI, x([
                            $H,
                            rB(cq),
                            _H(Z2n)
                        ]), x([
                            ld(s)
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("ml-auto")
                    ]), x([
                        A7(MV, n, o.yj, !0, Vt(BMn(u)), kF, !1, a)
                    ]))
                ])),
                A2(V8n, u, !0),
                Dk
            ]))
        ]));
    }), a5n = F3(function(n, r, t) {
        if (r.$) return tB;
        var e = r.a, u = t ? n(P8n) : t5n(e.oY);
        return A2(nk, h, x([
            A2(nk, x([
                Xx("flex-auto hidden md:block text-center")
            ]), x([
                A7(MV, n, e.yj, !1, Ut, kF, !1, !1),
                A2(nk, x([
                    Xx("quote-info__bill")
                ]), x([
                    A2(Ek, x([
                        nH,
                        rB(kF)
                    ]), x([
                        ld("First bill")
                    ])),
                    A2(FI, x([
                        $H,
                        rB(kF)
                    ]), x([
                        ld(u)
                    ]))
                ]))
            ])),
            A2(nk, x([
                Xx("md:hidden")
            ]), x([
                A2(nk, x([
                    Xx("flex")
                ]), x([
                    A2(nk, x([
                        Xx("flex quote-info__bill")
                    ]), x([
                        A2(Ek, x([
                            nH,
                            rB(cq),
                            fq
                        ]), x([
                            ld("First bill")
                        ])),
                        A2(FI, x([
                            $H,
                            rB(cq),
                            _H(Z2n)
                        ]), x([
                            ld(u)
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("ml-auto")
                    ]), x([
                        A7(MV, n, e.yj, !1, Ut, kF, !1, !1)
                    ]))
                ])),
                Dk
            ]))
        ]));
    }), i5n = F6(function(n, r, t, e, u, a) {
        var i, c = A2(r5n, r, t), o = A2(X8n, t, r), f = A3(n5n, n, r, t), s = f.a, l = f.b, d = A2(K8n, r, t), v = d.a, m = d.b, p = !!(i = b(v, a)).a.$ && !!i.b;
        return A2(nk, x([
            Xx("w-full")
        ]), x([
            A2(nk, x([
                Xx("hidden md:block")
            ]), x([
                A2(nk, x([
                    Xx("flex justify-evenly space-x-4")
                ]), x([
                    A3(a5n, n, o, a),
                    A6(e5n, n, v, s, t, e, a),
                    A7(u5n, n, m, l, c, t, u, p)
                ])),
                _8n(g8n(r)),
                Dk
            ])),
            A2(nk, x([
                Xx("md:hidden")
            ]), x([
                A3(a5n, n, o, a),
                A6(e5n, n, v, s, t, e, a),
                A7(u5n, n, m, l, c, t, u, p),
                _8n(g8n(r))
            ]))
        ]));
    }), c5n = F3(function(n, r, t) {
        return A3(p8n, tB, function(e) {
            var u = b(e, r.g5);
            if (u.a.$) return A3(h8n, n, r.fe, u.a.a);
            switch(u.b.$){
                case 0:
                    var a = u.a.a, i = u.b.a;
                    return (function(n) {
                        return function(r) {
                            return function(t) {
                                return function(e) {
                                    return function(u) {
                                        return function(a) {
                                            return function(i) {
                                                return function(c) {
                                                    return function(o) {
                                                        return function(f) {
                                                            return i ? A2(nk, x([
                                                                Xx("quote-info")
                                                            ]), x([
                                                                A2(Ck, yu, a ? A6(i5n, n, r, t, u, c, o) : A4(U8n, n, g8n(r), t, !0)),
                                                                A4(T8n, n, t, r, f),
                                                                A2(oR, aF(e) && !f.aF, Dk)
                                                            ])) : A2(Ck, yu, A2(nk, x([
                                                                Xx("quote-info")
                                                            ]), x([
                                                                a ? A6(i5n, n, r, t, u, c, o) : A4(U8n, n, g8n(r), t, !0),
                                                                F8n(t),
                                                                A2(oR, Z3n(t) > 0, Dk),
                                                                A3(H8n, n, t, B8n(r)),
                                                                kZn(u),
                                                                A2(oR, aF(e), Dk)
                                                            ])));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    })(n)(a)(i)(r.c4)(r.fe)(r.jS)(r.Bf)(r.iV)(r.g3)(t);
                case 1:
                    return A5(C8n, a = u.a.a, u.b.a, r.c4, r.Bf, t);
                default:
                    return tB;
            }
        }, r.m7);
    }), o5n = F2(function(n, r) {
        var t = x([
            lxn(0)
        ]);
        if (r.$) return tB;
        var e = r.a;
        return A3(wxn, t, EKn(e), A2(BKn, n, _Kn(e)));
    }), f5n = F2(function(n, r) {
        return A2(nk, x([
            Xx("md:hidden sidebar-mobile")
        ]), x([
            A2(nk, x([
                Xx("sidebar-wrap")
            ]), r)
        ]));
    }), s5n = F2(function(n, r) {
        return A2(nk, x([
            Xx("sidebar-wrap"),
            A2(bT, "margin-top", OZ(n.ic) + "px"),
            Hq("sidebar-element")
        ]), r);
    }), l5n = F3(function(n, r, t) {
        var e = A3(de, l8n, s8n, r);
        return (e.Bf ? f5n(t) : s5n(t))(x([
            A3(c5n, n, e, t),
            A2(o5n, n, e.kw),
            m8n(e)
        ]));
    }), d5n = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, E3n, A3(l5n, n, A2(f8n, n, r), r.cT))
        ]));
    }), b5n = function(n) {
        return A2(Yt, function(n) {
            return {
                $: 8,
                a: n
            };
        }(!0), n);
    }, v5n = F2(function(n, r) {
        return A2(Ck, E3n, A3(l5n, n, b5n(A2(f8n, n, r)), r.cT));
    }), m5n = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(fO),
                    A2(D2n, 1, x2n),
                    rB(oB)
                ]), x([
                    ld(n(Kdn))
                ])),
                A2(nk, x([
                    Xx("flex w-full")
                ]), x([
                    A2(Q4n, n, r),
                    A2(d5n, n, r)
                ])),
                A2(v5n, n, r)
            ]))
        ]);
    }), p5n = function(n) {
        return A2(nk, x([
            Xx("panel w-full")
        ]), x([
            A2(Ak, h, x([
                ld("There was a problem!")
            ])),
            Dk,
            A2(Ek, h, x([
                ld("An error has been registered. Please contact us to complete enrollment at "),
                bGn(qB(n)),
                A2(dGn, xx(n), qB(n)),
                ld(". Or try again tomorrow.")
            ]))
        ]));
    }, $5n = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.aO, r.tO);
                n: for(;;){
                    r: for(;;)switch(t.a.$){
                        case 1:
                            return ck;
                        case 2:
                            if (1 === t.b.$) break n;
                            break r;
                        default:
                            switch(t.b.$){
                                case 1:
                                    break n;
                                case 2:
                                    return x([
                                        p5n(r.dB)
                                    ]);
                                default:
                                    return A2(m5n, n, r);
                            }
                    }
                    return x([
                        p5n(r.dB)
                    ]);
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), h5n = mGn({
        Ar: w3n,
        AQ: A3n,
        Db: C3n,
        DZ: function(n) {
            var r = FL(n.kB).Y;
            return Px(x([
                A2(_S, r3n, Tfn),
                A2(_S, W2n, yY(r)),
                A2(_S, E3n, P3n()),
                mJn(B3n),
                wXn(D3n)
            ]));
        },
        En: u4n,
        Et: $5n
    }), g5n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, w5n = function(n) {
        return {
            $: 26,
            a: n
        };
    }, x5n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, k5n = function(n) {
        return {
            $: 27,
            a: n
        };
    }, y5n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _5n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, A5n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, C5n = F2(function(n, r) {
        return function(n) {
            return n.a.tg;
        }(r);
    }), B5n = function(n) {
        return Vt(A2(C5n, Wx(0), n));
    }, E5n = F2(function(n, r) {
        return jpn(n) ? A2(Spn, Zj, r) : r;
    }), D5n = function(n) {
        switch(n){
            case 0:
                return "field-first-name";
            case 1:
                return "field-last-name";
            case 2:
                return "field-chosen-first-name";
            case 3:
                return "field-chosen-last-name";
            case 4:
                return "field-email";
            case 5:
                return "field-phone";
            case 6:
                return "field-lead-source";
            case 7:
                return "field-lead-source-other";
            default:
                return "field-broker";
        }
    }, q5n = function(n) {
        return {
            ng: Ut,
            nF: "",
            nG: "",
            nH: "",
            nI: "",
            nJ: wpn("chosen-title"),
            pP: "",
            qB: "",
            aj: !1,
            rS: "",
            rX: Ut,
            rY: "",
            s2: "",
            uy: A2(E5n, n, A2(Npn, !0, spn(D5n(5)))),
            wY: "",
            w5: wpn("title")
        };
    }, F5n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), P5n = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), z5n = A3(ly, "name", C$, A3(ly, "id", C$, uu(P5n))), j5n = A2(dD, 0, A2(Pk, z5n, uu(F5n))), S5n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), L5n = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), M5n = A3(ly, "name", C$, A3(ly, "id", C$, uu(L5n))), N5n = A2(dD, 0, A2(Pk, M5n, uu(S5n))), H5n = A3(ly, "debug", jk, A3(ly, "referred", jk, A3(ly, "broker", iy(j5n), A3(ly, "lead_source", iy(N5n), A3(ly, "title", A2(nu, dbn, iy(C$)), A3(ly, "phones", iy(vy(gbn)), A3(ly, "lead_source_other", iy(C$), A3(ly, "middle_name", iy(C$), A3(ly, "suffix", iy(C$), A3(ly, "last_name", C$, A3(ly, "first_name", C$, A3(ly, "email", iy(C$), A3(ly, "chosen_suffix", iy(C$), A3(ly, "chosen_title", A2(nu, dbn, iy(C$)), A3(ly, "chosen_middle_name", iy(C$), A3(ly, "chosen_last_name", iy(C$), A3(ly, "chosen_first_name", iy(C$), A3(ly, "id", C$, uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return {
                                                                                ng: m,
                                                                                nF: r,
                                                                                nG: t,
                                                                                nH: e,
                                                                                nI: a,
                                                                                nJ: u,
                                                                                o5: $,
                                                                                pP: i,
                                                                                qB: c,
                                                                                rh: n,
                                                                                rS: o,
                                                                                rX: v,
                                                                                rY: l,
                                                                                s2: s,
                                                                                uy: d,
                                                                                vv: p,
                                                                                wY: f,
                                                                                w5: b
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), T5n = A2(Pk, H5n, uu(iu)), I5n = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments"
        ]), A2(T1n, n, r));
    }), R5n = F5(function(n, r, t, e, u) {
        var a = _x(x([
            b("referred_token", Ax(e))
        ]));
        return A4(bL, gQ(n), T5n, u, A2(vL, a, rA(A2(X_, x([
            "from_referred_token"
        ]), A2(I5n, r, t)))));
    }), Z5n = F5(function(n, r, t, e, u) {
        return A4(W_, gQ(n), T5n, u, rA(A2(X_, x([
            e
        ]), A2(I5n, r, t))));
    }), V5n = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), U5n = A2(Pk, V5n, uu(iu)), Y5n = F2(function(n, r) {
        return A2(X_, x([
            "new"
        ]), A2(X_, x([
            "online_enrollments"
        ]), A2(T1n, n, r)));
    }), Q5n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), U5n, e, rA(A2(Y5n, r, t)));
    }), O5n = function(n) {
        return n.a.tg;
    }, G5n = F2(function(n, r) {
        return O5n(r);
    }), J5n = function(n) {
        return Vt(A2(G5n, Wx(0), n));
    }, W5n = F3(function(n, r, t) {
        return A4(W_, gQ(n), vy(j5n), t, rA(function(n) {
            return A2(X_, x([
                "brokers"
            ]), lL(n));
        }(r)));
    }), K5n = F3(function(n, r, t) {
        return A4(W_, gQ(n), vy(N5n), t, rA(function(n) {
            return A2(X_, x([
                "lead_sources"
            ]), lL(n));
        }(r)));
    }), X5n = A2(itn, "Member Onboarding: Start", x([
        stn(IXn)
    ])), n7n = F2(function(n, r) {
        return A2(X_, x([
            "signup_pages",
            r,
            "charge_item"
        ]), lL(n));
    }), r7n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), k1n, e, rA(A2(n7n, r, t)));
    }), t7n = F6(function(n, r, t, e, u, a) {
        return {
            pP: t,
            qB: n,
            rS: r,
            tO: a,
            uw: e,
            uP: u
        };
    }), e7n = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), u7n = A2(Pk, e7n, uu(iu)), a7n = A3(ly, "online_enrollment", aL(u7n), A3(ly, "practitioner", uin, A3(ly, "phone", C$, A3(ly, "email", C$, A3(ly, "last_name", C$, A3(ly, "first_name", C$, uu(t7n))))))), i7n = A2(Pk, a7n, uu(iu)), c7n = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), i7n, e, rA(A2(X_, x([
            "waitlist_tokens",
            t
        ]), lL(r))));
    }), o7n = x([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]), f7n = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Chosen First Name";
            case 3:
                return "Chosen Last Name";
            case 4:
                return "Email";
            case 5:
                return "Phone";
            case 6:
                return "Lead Source";
            case 7:
                return "Lead Source Other";
            default:
                return "Broker";
        }
    }, s7n = function(n) {
        return A2(a3n, "waitlist_token", n);
    }, l7n = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.DF).$ ? u.a : h, i = nQn(r), c = u0n(i) ? A4(r7n, t.gF, Bx(n), xGn(i), w5n) : Pp, o = function() {
            var r = bXn(t);
            if (r.$) {
                var u = A2(a3n, "token", e.iF);
                if (u.$) {
                    var a = function() {
                        var r = s7n(e.iF);
                        if (r.$) return Pp;
                        var u = r.a;
                        return A4(c7n, t.gF, Bx(n), u, k5n);
                    }();
                    return v(Vu(x([
                        A4(Q5n, t.gF, Bx(n), xGn(i), A5n),
                        X5n,
                        a
                    ])), vc, cP);
                }
                var c = u.a;
                return v(Vu(x([
                    A5(R5n, t.gF, Bx(n), xGn(i), c, y5n),
                    X5n
                ])), cP, vc);
            }
            var o = r.a;
            return v(A5(Z5n, t.gF, Bx(n), xGn(i), o, _5n), cP, vc);
        }(), f = o.a, s = o.b, l = o.c;
        return b({
            f0: KKn(t),
            gF: t.gF,
            gM: cK,
            el: dd({
                rh: "broker-select",
                Eb: C5n,
                Ed: B5n
            }),
            bJ: vc,
            c7: cK,
            ny: Ut,
            hg: t.hg,
            kA: t.kA,
            kB: lS(q5n(n)),
            hz: Ut,
            eW: dd({
                rh: "lead-source-select",
                Eb: G5n,
                Ed: J5n
            }),
            eX: vc,
            cG: l,
            fc: t.fc,
            dB: n,
            u3: !1,
            fo: !1,
            vv: !1,
            cM: s,
            cN: cK,
            lB: i,
            fL: r,
            DF: a,
            xs: e,
            x: A2(vS, o7n, f7n)
        }, Vu(x([
            f,
            A4(I0n, 0, a, r, h),
            A3(K5n, t.gF, Bx(n), x5n),
            A3(W5n, t.gF, Bx(n), g5n),
            c
        ])));
    }), d7n = F2(function(n, r) {
        return b(r, Pp);
    }), b7n = F2(function(n, r) {
        return r;
    }), v7n = function(n) {
        return {
            $: 25,
            a: n
        };
    }, m7n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, p7n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, $7n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, h7n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, g7n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w7n = function(n) {
        return {
            $: 16,
            a: n
        };
    }, x7n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, k7n = function(n) {
        return {
            $: 17,
            a: n
        };
    }, y7n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _7n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, A7n = function(n) {
        return {
            $: 11,
            a: n
        };
    }, C7n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, B7n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, E7n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, D7n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, q7n = function(n) {
        return {
            $: 18,
            a: n
        };
    }, F7n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, P7n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, z7n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, j7n = F2(function(n, r) {
        return rv(A2(PH, r, n));
    }), S7n = F2(function(n, r) {
        return A2(nv, function(n) {
            return Vt(b(r, n));
        }, A2(j7n, n, r));
    }), L7n = function(n) {
        return A2(Eu, function(n) {
            var r = n.a;
            return RXn({
                eH: x([
                    n.b
                ]),
                qv: f7n(r)
            });
        }, function(n) {
            return A2(Tp, S7n(n), o7n);
        }(n));
    }, M7n = {
        DW: d0(100),
        Ek: function(n) {
            return {
                $: 19,
                a: n
            };
        }
    }, N7n = function(n) {
        return n.a.rh;
    }, H7n = F2(function(n, r) {
        return A4(P9n, "broker", r, n, N7n);
    }), T7n = {
        DW: d0(1500),
        Ek: function(n) {
            return {
                $: 23,
                a: n
            };
        }
    }, I7n = function(n) {
        return {
            $: 20,
            a: n
        };
    }, R7n = function(n) {
        return A2(Nu, I7n, _u(n));
    }, Z7n = function(n) {
        return {
            $: 24,
            a: n
        };
    }, V7n = function(n) {
        return A2(Nu, Z7n, _u(n));
    }, U7n = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Y7n = function(n) {
        return A2(Nu, U7n, _u(n));
    }, Q7n = function(n) {
        return n.a.rh;
    }, O7n = function(n) {
        return A2(nv, function(n) {
            return vu(n) ? Ut : Vt(n);
        }, A2(a3n, "lead", n));
    }, G7n = F2(function(n, r) {
        var t = O7n(r);
        return b("lead_source", t.$ ? n.$ ? yx : _x(x([
            b("id", G$n(Q7n(n.a)))
        ])) : _x(x([
            b("id", G$n(t.a))
        ])));
    }), J7n = F3(function(n, r, t) {
        var e;
        return A2(Yt, A2(LPn, "title", n.w5), A2(Yt, b("first_name", G$n(n.qB)), A2(Yt, b("middle_name", G$n(n.s2)), A2(Yt, b("last_name", G$n(n.rS)), A2(Yt, b("suffix", G$n(n.wY)), A2(Yt, b("email", G$n(n.pP)), A2(Yt, b("phones", UPn(n.uy)), A2(Yt, b("lead_source_other", G$n(n.rY)), A2(Yt, b("google_recaptcha_token", JFn(r)), A2(Yt, A2(G7n, n.rX, t), A2(Yt, b("broker", (e = n.ng).$ ? yx : _x(x([
            b("id", G$n(N7n(e.a)))
        ]))), function(n) {
            return x(n.aj ? [
                A2(LPn, "chosen_title", n.w5),
                b("chosen_first_name", G$n(n.nF)),
                b("chosen_middle_name", G$n(n.nH)),
                b("chosen_last_name", G$n(n.nG)),
                b("chosen_suffix", G$n(n.nI))
            ] : [
                b("chosen_title", yx),
                b("chosen_first_name", yx),
                b("chosen_middle_name", yx),
                b("chosen_last_name", yx),
                b("chosen_suffix", yx)
            ]);
        }(n))))))))))));
    }), W7n = function(n) {
        return n.gS.ng;
    }, K7n = function(n) {
        return n.gS.rQ;
    }, X7n = function(n) {
        return n.gS.CB;
    }, nnr = function(n) {
        return 3 === n.$ ? n.a : h;
    }, rnr = function(n) {
        return TE(nnr(n));
    }, tnr = function(n) {
        return eM(A2(rM, cSn, n));
    }, enr = F3(function(n, r, t) {
        var e = t.ng;
        return r$n(o0n(n)) && i(e, Ut) && !rnr(r) ? x([
            b(8, tnr(W7n))
        ]) : h;
    }), unr = F2(function(n, r) {
        return A2(enr, n, r);
    }), anr = function(n) {
        return n.aj && vu(n.nF) ? x([
            b(2, nN(Exn))
        ]) : h;
    }, inr = function(n) {
        return n.aj && vu(n.nG) ? x([
            b(3, nN(qxn))
        ]) : h;
    }, cnr = function(n) {
        return rc(x([
            anr(n),
            inr(n)
        ]));
    }, onr = F2(function(n, r) {
        for(;;){
            if (!n.b) return h;
            var t = n.b, e = (0, n.a)(r);
            if (e.b) return e;
            n = t;
        }
    }), fnr = F2(function(n, r) {
        return A2(W3n, function(r) {
            return hJn(n(r));
        }, r);
    }), snr = F2(function(n, r) {
        return function(t) {
            var e = n(t);
            return lM(e) ? h : x([
                r(e)
            ]);
        };
    }), lnr = (SJ = x([
        A2(fnr, function(n) {
            return n.pP;
        }, b(4, nN(iM))),
        A2(snr, function(n) {
            return n.pP;
        }, function() {
            return b(4, rN(iM));
        })
    ]), function(n) {
        return A2(onr, SJ, n);
    }), dnr = A2(fnr, function(n) {
        return n.qB;
    }, b(0, eM(A2(rM, cSn, vM)))), bnr = A2(fnr, function(n) {
        return n.rS;
    }, b(1, eM(A2(rM, uM, mM)))), vnr = function(n) {
        return !n.$ && "Other" === O5n(n.a);
    }, mnr = function(n) {
        return n.hW.rQ;
    }, pnr = function(n) {
        return n.hW.rX;
    }, $nr = function(n) {
        return n.hW.CB;
    }, hnr = F2(function(n, r) {
        var t = r.rX, e = r.rY;
        return !Jwn(f0n(n)) && vnr(t) && fM(e) ? x([
            b(7, nN(pnr))
        ]) : h;
    }), gnr = function(n) {
        return hnr(n);
    }, wnr = F3(function(n, r, t) {
        var e, u = t.rX, a = 1 === (e = b(O7n(r), u)).a.$ && 1 === e.b.$;
        return r$n(f0n(n)) && a ? x([
            b(6, tnr(pnr))
        ]) : h;
    }), xnr = F2(function(n, r) {
        return A2(wnr, n, r);
    }), knr = function(n) {
        return A2(Eu, function(n) {
            return b(5, n);
        }, Rjn(n.uy));
    }, ynr = F3(function(n, r, t) {
        return nM(x([
            dnr,
            bnr,
            cnr,
            lnr,
            knr,
            A2(unr, n, r),
            A2(xnr, n, t),
            gnr(n)
        ]));
    }), _nr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    w5: n.a
                });
            case 1:
                return m(r, {
                    qB: n.a
                });
            case 2:
                return m(r, {
                    s2: n.a
                });
            case 3:
                return m(r, {
                    rS: n.a
                });
            case 4:
                return m(r, {
                    wY: n.a
                });
            case 5:
                return m(r, {
                    aj: n.a
                });
            case 6:
                return m(r, {
                    nJ: n.a
                });
            case 7:
                return m(r, {
                    nF: n.a
                });
            case 8:
                return m(r, {
                    nH: n.a
                });
            case 9:
                return m(r, {
                    nG: n.a
                });
            case 10:
                return m(r, {
                    nI: n.a
                });
            case 11:
                return m(r, {
                    pP: n.a
                });
            case 12:
                return m(r, {
                    uy: n.a
                });
            case 13:
                return m(r, {
                    rX: n.a
                });
            case 14:
                return m(r, {
                    rY: n.a
                });
            default:
                return m(r, {
                    ng: n.a
                });
        }
    }), Anr = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, _nr, $7n(A2(sSn, n, t.nJ)), r);
    }), Cnr = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, _nr, D7n(A2(Nwn, n, t.uy)), r);
    }), Bnr = F2(function(n, r) {
        var t = FL(r);
        return A3(dN, _nr, F7n(A2(sSn, n, t.w5)), r);
    }), Enr = F5(function(n, r, t, e, u) {
        var a = A2(Cnr, n, A2(Anr, n, A2(Bnr, n, u))), i = A2(BM, A3(ynr, r, t, e), a);
        return i.$ ? b(i.a, !1) : b(i.a.a, !0);
    }), Dnr = F2(function(n, r) {
        return aF(A2(j7n, n, r));
    }), qnr = F4(function(n, r, t, e) {
        var u = A5(Enr, !1, n, r, t, e);
        return u.b ? Ut : A2(nv, function(n) {
            return Vt(D5n(n));
        }, rv(A2(Rc, Dnr(u.a), o7n)));
    }), Fnr = function(n) {
        return n.qB;
    }, Pnr = function(n) {
        return n.nF;
    }, znr = function(n) {
        return n.nG;
    }, jnr = function(n) {
        return n.nH;
    }, Snr = function(n) {
        return n.nI;
    }, Lnr = function(n) {
        return n.pP;
    }, Mnr = function(n) {
        return n.qB;
    }, Nnr = function(n) {
        return n.rS;
    }, Hnr = function(n) {
        return n.s2;
    }, Tnr = function(n) {
        return n.wY;
    }, Inr = F3(function(n, r, t) {
        var e, u = 1 !== (e = znr(r)).$ && !vu(e.a), a = A2(U$n, function(n) {
            return n.w5;
        }(r), wpn("title")), i = A2(E5n, n, A2(S$n, function(n) {
            return n.uy;
        }(r), A2(Npn, !0, spn(D5n(5))))), c = A2(U$n, function(n) {
            return n.nJ;
        }(r), wpn("chosen-title")), o = FL(t), f = o.rX, s = o.rY, l = o.ng, d = l.$ ? function(n) {
            return n.ng;
        }(r) : l, v = f.$ ? b(function(n) {
            return n.rX;
        }(r), A2(sc, "", function(n) {
            return n.rY;
        }(r))) : b(f, s), m = v.a, p = v.b;
        return {
            ng: d,
            nF: A2(sc, "", Pnr(r)),
            nG: A2(sc, "", znr(r)),
            nH: A2(sc, "", jnr(r)),
            nI: A2(sc, "", Snr(r)),
            nJ: c,
            pP: A2(sc, "", Lnr(r)),
            qB: Mnr(r),
            aj: u,
            rS: Nnr(r),
            rX: m,
            rY: p,
            s2: A2(sc, "", Hnr(r)),
            uy: i,
            wY: A2(sc, "", Tnr(r)),
            w5: a
        };
    }), Rnr = function(n) {
        return n.rh;
    }, Znr = function(n) {
        return n.rh;
    }, Vnr = function(n) {
        return n.rh;
    }, Unr = F2(function(n, r) {
        var t = n ? jM(r.x) : r.x, e = A5(Enr, n, r.fL, r.bJ, r.xs.iF, r.kB), u = e.b;
        return b(m(r, {
            kB: e.a,
            x: t
        }), u);
    }), Ynr = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 4:
            case 5:
            case 6:
            case 8:
            case 10:
                return Ut;
            case 1:
                return Vt(0);
            case 3:
                return Vt(1);
            case 7:
                return Vt(2);
            case 9:
                return Vt(3);
            case 11:
                return Vt(4);
            case 12:
                return Vt(5);
            case 13:
                return Vt(6);
            case 14:
                return Vt(7);
            default:
                return Vt(8);
        }
    }, Qnr = F2(function(n, r) {
        var t = lc(n.xs.CS), e = function(n) {
            switch(n.$){
                case 0:
                    return "Title";
                case 1:
                    return f7n(0);
                case 2:
                    return "Middle Name";
                case 3:
                    return f7n(1);
                case 4:
                    return "Suffix";
                case 5:
                    return "Has Chosen Name";
                case 6:
                    return "Chosen Title";
                case 7:
                    return f7n(2);
                case 8:
                    return "Chosen Middle Name";
                case 9:
                    return f7n(3);
                case 10:
                    return "Chosen Suffix";
                case 11:
                    return f7n(4);
                case 12:
                    return f7n(5);
                case 13:
                    return f7n(6);
                case 14:
                    return f7n(7);
                default:
                    return f7n(8);
            }
        }(r), u = A2(Unr, !1, n).a, a = A2(nv, function(n) {
            return A2(j7n, u.kB, n);
        }, A2(nv, Ynr, Vt(r)));
        return Q1n(Vt({
            eH: A2(sc, h, A2(Fp, VZ, a)),
            qv: e,
            C9: t
        }));
    }), Onr = function(n) {
        return n.rS;
    }, Gnr = function(n) {
        return n.tO;
    }, Jnr = function(n) {
        return n.vv;
    }, Wnr = A2(Nu, yu, _n(function() {
        er.location.reload(false);
    })), Knr = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 21,
                a: n
            };
        }
    }, Xnr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nrr = function(n) {
        return _x(x([
            b("online_enrollment", _x(n))
        ]));
    }, rrr = F6(function(n, r, t, e, u, a) {
        return A4(bL, gQ(n), T5n, a, A2(vL, nrr(u), rA(A2(X_, x([
            "confirm"
        ]), A2(X_, x([
            e
        ]), A2(I5n, r, t))))));
    }), trr = function(n) {
        var r, t = 2 === (r = b(n.fc, n.cG)).a.$ ? Vt(r.a.a) : 3 === r.b.$ ? Vt(Vnr(r.b.a)) : Ut;
        if (t.$) return Pp;
        var e = t.a, u = xGn(n.lB), a = Bx(n.dB), i = FL(n.kB);
        return A6(rrr, n.gF, a, u, e, A3(J7n, i, n.hz, n.xs.iF), Xnr);
    }, err = F6(function(n, r, t, e, u, a) {
        return A4(dC, gQ(n), T5n, a, A2(vL, nrr(u), rA(A2(X_, x([
            e
        ]), A2(I5n, r, t)))));
    }), urr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, arr = F4(function(n, r, t, e) {
        return A4(bL, gQ(n), T5n, e, rA(A2(X_, x([
            "create_debug"
        ]), A2(I5n, r, t))));
    }), irr = F2(function(n, r) {
        return 2 === n.$ && i(n.a, "hintos") ? b(m(r, {
            hg: !0,
            u3: !0
        }), A4(arr, r.gF, Bx(r.dB), xGn(r.lB), urr)) : b(r, Pp);
    }), crr = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (9 === t.a.$) return v(m(r, {
                            cM: vc
                        }), Pp, A2(xA, 1, t));
                        break n;
                    case 3:
                        var e = t.a, u = (Fn = r.f0).$ ? Pp : V0n(Fn.a), a = e.o5, i = x(a ? [
                            AXn,
                            _Xn
                        ] : [
                            _Xn
                        ]);
                        return v(m(r, {
                            f0: Ut,
                            hg: a,
                            kB: lS(A3(Inr, r.dB, e, r.kB)),
                            vv: Jnr(e),
                            cM: t
                        }), u, i);
                    default:
                        break n;
                }
                return v(m(r, {
                    cM: t
                }), Pp, A2(xA, 1, t));
            case 5:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (t.a.$) break n;
                        return v(m(r, {
                            cG: cP,
                            cM: vc
                        }), A4(Q5n, r.gF, Bx(r.dB), xGn(r.lB), A5n), A2(xA, 1, t));
                    case 3:
                        var c = Rnr(e = t.a);
                        return v(m(r, {
                            kB: lS(A3(Inr, r.dB, e, r.kB)),
                            fc: g7n(c),
                            vv: Jnr(e),
                            cM: t
                        }), lGn(c), x([
                            z7n(c)
                        ]));
                    default:
                        break n;
                }
                return v(m(r, {
                    cM: t
                }), Pp, A2(xA, 1, t));
            case 0:
                return v(m(r, {
                    kB: A3(dN, _nr, gn = n.a, r.kB)
                }), A2(Nu, iu, _u(x7n(gn))), h);
            case 25:
                var o = n.a;
                return v(w = o.$ ? r : m(r, {
                    hz: Vt(o.a)
                }), Vu(x([
                    trr(w),
                    A4(H0n, 0, w.DF, w.fL, h)
                ])), h);
            case 26:
                var f = n.a;
                return v(3 === f.$ ? m(r, {
                    ny: Vt(f.a)
                }) : r, Pp, h);
            case 27:
                var s = n.a;
                if (3 === s.$) {
                    var l = s.a, d = A2(Fp, Znr, Gnr(l));
                    if (d.$) {
                        var p = m(An = FL(r.kB), {
                            pP: (Dn = l, Dn.pP),
                            qB: Fnr(l),
                            rS: Onr(l)
                        });
                        return v(m(r, {
                            kB: lS(p)
                        }), Pp, h);
                    }
                    var $ = d.a;
                    return v(m(r, {
                        fc: g7n($),
                        cM: cP
                    }), A5(Z5n, r.gF, Bx(r.dB), xGn(r.lB), $, _5n), x([
                        z7n($)
                    ]));
                }
                return v(r, Pp, h);
            case 1:
                var g = A2(Unr, !0, r), w = g.a;
                if (g.b) return v(m(w, {
                    u3: !0
                }), xJn(0), h);
                var k = A4(qnr, w.fL, w.bJ, w.xs.iF, w.kB);
                if (k.$) return v(w, Vu(L7n(w.kB)), h);
                var y = A3(SX, Knr, k.a, w.cN), _ = y.b, A = m(w, {
                    cN: y.a
                });
                return v(A, Vu(A2(Yt, _, L7n(A.kB))), h);
            case 2:
                t = n.a, w = m(r, {
                    u3: !1
                });
                n: for(;;)switch(t.$){
                    case 3:
                        return v(w, Pp, x([
                            B7n(Rnr(t.a))
                        ]));
                    case 2:
                        if (9 === t.a.$) return v(w, Wnr, A2(xA, 1, t));
                        break n;
                    default:
                        break n;
                }
                return v(w, Pp, A2(xA, 1, t));
            case 3:
                if (t = n.a, w = m(r, {
                    fo: !1
                }), 3 === t.$) {
                    var C = function() {
                        var n = b(w.cG, w.fc);
                        if (3 === n.a.$ && 1 === n.b.$) {
                            var r = Vnr(n.a.a);
                            return b(m(w, {
                                fc: g7n(r)
                            }), x([
                                z7n(r)
                            ]));
                        }
                        return b(w, h);
                    }();
                    return v(C.a, Pp, j = C.b);
                }
                return v(w, Pp, A2(xA, 1, t));
            case 6:
                return 3 === (t = n.a).$ ? (c = Rnr(e = t.a), v(m(r, {
                    kB: lS(A3(Inr, r.dB, e, r.kB)),
                    fc: g7n(c),
                    u3: !1,
                    vv: Jnr(e),
                    cM: t
                }), Pp, x([
                    B7n(c),
                    AXn
                ]))) : v(m(r, {
                    cM: t
                }), Pp, A2(xA, 1, t));
            case 18:
                var B = n.a, E = FL(r.kB), D = A2(hwn, B, E.uy), q = D.b, F = D.c, P = D7n(D.a), z = (w = m(r, {
                    kB: A3(dN, _nr, P, r.kB)
                }), A2(sc, b(Pp, h), A2(Fp, function(n) {
                    switch(n.$){
                        case 3:
                            return b(A2(Nu, iu, _u(w7n(P))), x([
                                A2(Qnr, w, P)
                            ]));
                        case 4:
                            return b(A2(Nu, iu, _u(k7n(P))), x([
                                A2(Qnr, w, P)
                            ]));
                        default:
                            return b(A2(Nu, iu, _u(x7n(P))), h);
                    }
                }, F))), j = (_ = z.a, z.b);
                return v(w, Vu(x([
                    A2(Lp, q7n, q),
                    _
                ])), j);
            case 8:
                var S = n.a, L = FL(r.kB), M = A2(KSn, S, L.w5), N = M.b, H = M.c, T = F7n(M.a);
                return _ = function() {
                    if (H.$) return Pp;
                    switch(H.a.$){
                        case 0:
                            return A2(Nu, iu, _u(x7n(T)));
                        case 1:
                            return A2(Nu, iu, _u(k7n(T)));
                        default:
                            return A2(Nu, iu, _u(w7n(T)));
                    }
                }(), v(w = m(r, {
                    kB: A3(dN, _nr, T, r.kB)
                }), Vu(x([
                    A2(Lp, P7n, N),
                    _
                ])), x([
                    A2(Qnr, w, T)
                ]));
            case 9:
                return v(m(r, {
                    kB: A3(dN, _nr, y7n(n.a), r.kB)
                }), Pp, h);
            case 10:
                var I = n.a, R = FL(r.kB), Z = A2(KSn, I, R.nJ), V = Z.b, U = Z.c, Y = $7n(Z.a);
                return _ = function() {
                    if (U.$) return Pp;
                    switch(U.a.$){
                        case 0:
                            return A2(Nu, iu, _u(x7n(Y)));
                        case 1:
                            return A2(Nu, iu, _u(k7n(Y)));
                        default:
                            return A2(Nu, iu, _u(w7n(Y)));
                    }
                }(), v(w = m(r, {
                    kB: A3(dN, _nr, Y, r.kB)
                }), Vu(x([
                    A2(Lp, h7n, V),
                    _
                ])), x([
                    A2(Qnr, w, Y)
                ]));
            case 11:
                var Q = A2(ZD, n.a, r.eW), O = Q.a, G = Q.b, J = Q.c, W = FL(r.kB).rX, K = A2(sc, v(r, Pp, h), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = _7n(n.a), e = A3(dN, _nr, C7n(""), A3(dN, _nr, t, r.kB)), u = m(r, {
                                kB: e
                            });
                            return v(u, A2(Nu, iu, _u(x7n(t))), x([
                                A2(Qnr, u, t)
                            ]));
                        case 1:
                            return t = _7n(W), v(r, A2(Nu, iu, _u(k7n(t))), x([
                                A2(Qnr, r, t)
                            ]));
                        default:
                            return t = _7n(W), v(r, A2(Nu, iu, _u(w7n(t))), x([
                                A2(Qnr, r, t)
                            ]));
                    }
                }, J));
                return _ = K.b, j = K.c, v(m(w = K.a, {
                    eW: O
                }), Vu(x([
                    A2(Lp, A7n, G),
                    _
                ])), j);
            case 12:
                var X = A2(ZD, n.a, r.el), nn = (O = X.a, G = X.b, J = X.c, FL(r.kB).ng), rn = A2(sc, v(r, Pp, h), A2(Fp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = m7n(n.a), e = m(r, {
                                kB: A3(dN, _nr, t, r.kB)
                            });
                            return v(e, A2(Nu, iu, _u(x7n(t))), x([
                                A2(Qnr, e, t)
                            ]));
                        case 1:
                            return t = m7n(nn), v(r, A2(Nu, iu, _u(k7n(t))), x([
                                A2(Qnr, r, t)
                            ]));
                        default:
                            return t = m7n(nn), v(r, A2(Nu, iu, _u(w7n(t))), x([
                                A2(Qnr, r, t)
                            ]));
                    }
                }, J));
                return _ = rn.b, j = rn.c, v(m(w = rn.a, {
                    el: O
                }), Vu(x([
                    A2(Lp, p7n, G),
                    _
                ])), j);
            case 13:
                var tn = n.a;
                return v(m(r, {
                    eX: tn
                }), Pp, A2(xA, 1, tn));
            case 14:
                var en = n.a, un = 3 === en.$ ? A2(H7n, en.a, r.xs.iF) : Ut, an = un.$ ? r.kB : A3(dN, _nr, m7n(un), r.kB);
                return v(m(r, {
                    bJ: en,
                    kB: an
                }), Pp, A2(xA, 1, en));
            case 15:
                var cn = A3(SX, T7n, gn = n.a, r.c7), on = cn.b, fn = m(r, {
                    c7: cn.a
                });
                return v(w = (qn = Ynr(gn)).$ ? fn : m(fn, {
                    x: A3(vN, !0, qn.a, fn.x)
                }), on, h);
            case 16:
                var sn = A3(SX, M7n, gn = n.a, r.gM), ln = (_ = sn.b, A2(irr, gn, m(r, {
                    gM: sn.a
                })));
                return v(w = ln.a, Vu(x([
                    ln.b,
                    _
                ])), x([
                    A2(Qnr, r, gn)
                ]));
            case 17:
                return v(r, Pp, x([
                    A2(Qnr, r, gn = n.a)
                ]));
            case 19:
                var dn = n.a, bn = A4(x0, M7n, h0(R7n), dn, r.gM);
                return on = bn.b, v(m(r, {
                    gM: bn.a
                }), on, h);
            case 20:
                var vn = Ynr(gn = n.a);
                if (vn.$) return v(r, Pp, h);
                var mn = vn.a;
                if (A2(qM, mn, r.x)) {
                    var pn = A3(FM, !0, mn, r.x);
                    return v(m(w = A2(Unr, !1, r).a, {
                        x: pn
                    }), Pp, h);
                }
                return v(r, Pp, h);
            case 21:
                dn = n.a;
                var $n = A4(x0, Knr, h0(Y7n), dn, r.cN);
                return on = $n.b, v(m(r, {
                    cN: $n.a
                }), on, h);
            case 22:
                return v(r, OLn(n.a), h);
            case 23:
                dn = n.a;
                var hn = A4(x0, T7n, h0(V7n), dn, r.c7);
                return on = hn.b, v(m(r, {
                    c7: hn.a
                }), on, h);
            case 24:
                var gn = n.a, wn = function() {
                    var n = b(r.fc, r.cG);
                    n: for(;;)switch(n.a.$){
                        case 2:
                            return n.a.a;
                        case 1:
                            if (3 === n.b.$) return Vnr(n.b.a);
                            break n;
                        default:
                            break n;
                    }
                    return "";
                }(), xn = !vu(wn) && function(n) {
                    var r = FL(n), t = !A2(CM, lnr, r).$, e = !A2(CM, dnr, r).$, u = !A2(CM, bnr, r).$, a = !cO(Pwn(r.uy));
                    return e && u && (a || t);
                }(r.kB) && !r.u3, kn = b(xn, r.fo);
                if (kn.a) {
                    if (kn.b) return v(r, A2(Nu, iu, _u(x7n(gn))), h);
                    var yn = xGn(r.lB), _n = Bx(r.dB), An = FL(r.kB), Cn = A3(J7n, An, r.hz, r.xs.iF);
                    return v(m(r, {
                        fo: !0
                    }), A6(err, r.gF, _n, yn, wn, Cn, E7n), h);
                }
                return v(r, Pp, h);
            default:
                var Bn = n.a;
                if (3 === Bn.$) {
                    var En = Bn.a;
                    return v(m(r, {
                        cG: Bn
                    }), lGn(Vnr(En)), h);
                }
                return v(r, Pp, A2(xA, 1, Bn));
        }
        var Dn, qn, Fn;
    }), orr = function(n) {
        return n.vi;
    }, frr = function(n) {
        return u0n(n.lB) && A2(sc, !1, A3(a3, me, A2(nv, orr, n.ny), Vt(0)));
    }, srr = function(n) {
        if (u0n(n.lB)) {
            var r = n.ny;
            if (1 === r.$) return tB;
            var t = r.a;
            return A2(nk, x([
                Xx("checkout-item-wrap")
            ]), A2(Yt, A2(nk, x([
                Xx("flex justify-between")
            ]), x([
                A2(FI, x([
                    rB(R0),
                    lk,
                    bq
                ]), x([
                    ld($8n(t))
                ])),
                A2(FI, x([
                    rB(f3),
                    lk
                ]), x([
                    ld(lV(E9n(t)))
                ]))
            ])), function(n) {
                if ("package" === n.eS) {
                    var r = A2(fe, ", ", A2(Eu, function(n) {
                        return oe(n.vg) + " " + n.yQ;
                    }, function(n) {
                        return n.tY;
                    }(n)));
                    return x([
                        A2(nk, x([
                            Xx("package-item")
                        ]), x([
                            A2(FI, x([
                                rB(R0)
                            ]), x([
                                ld("Includes: " + r)
                            ]))
                        ]))
                    ]);
                }
                return h;
            }(t)));
        }
        return tB;
    }, lrr = {
        $: 1
    }, drr = MC("noValidate"), brr = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), vrr = F2(function(n, r) {
        return 3 === n.$ && aF(A2(H7n, n.a, r));
    }), mrr = F2(function(n, r) {
        if (Jwn(o0n(r.fL)) || rnr(r.bJ) || A2(vrr, r.bJ, r.xs.iF)) return tB;
        var t, e = FL(r.kB).ng;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(K7n)),
                    VH((t = r.fL, r$n(o0n(t))))
                ]), x([
                    A2(Ck, p7n, A4(sF, n, x([
                        Dq(e),
                        xq(n(X7n)),
                        AR(r.u3)
                    ]), A2(Eu, function(n) {
                        return A2(hq, h, n);
                    }, nnr(r.bJ)), r.el))
                ])),
                A2(ET, n, A3(brr, r.kB, r.x, 8))
            ]))
        ]));
    }), prr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $rr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hrr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, grr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, wrr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xrr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, krr = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), yrr = F4(function(n, r, t, e) {
        var u = FL(t), a = u.aj, i = u.nJ, c = u.nF, o = u.nH, f = u.nG, s = u.nI;
        return A2(nk, x([
            Xx("mb-5 md:mb-6")
        ]), x([
            A2(zN, x([
                jN(BN)
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(HT, x([
                        zT(a),
                        PT(xrr),
                        FT(r),
                        F2n("chosen-name-checkbox")
                    ]), x([
                        ld(n(Dxn))
                    ]))
                ]))
            ])),
            A2(oR, a, A2(zN, h, x([
                A2(EN, x([
                    bR(2),
                    KN(x([
                        Xx("mb-4 sm:mb-0")
                    ]))
                ]), x([
                    A2(XH, x([
                        HH(n(zxn)),
                        VH(tHn(i)),
                        Lxn
                    ]), x([
                        A2(Ck, h7n, A3(Zxn, n, x([
                            jxn(r)
                        ]), i))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(Exn)),
                        VH(!0),
                        Lxn,
                        INn(D5n(2))
                    ]), x([
                        vI(x([
                            hI(D5n(2)),
                            xI(c),
                            gI(A2(pc, wrr, prr)),
                            JT(A3(krr, t, e, 2)),
                            YT(r),
                            yR("choosen-first-name"),
                            aI(!0),
                            hR("given-name"),
                            $R("given-name"),
                            XT(w7n(prr(c))),
                            nI(k7n(prr(c)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Fxn)),
                        Lxn,
                        INn("field-chosen-middle-name")
                    ]), x([
                        vI(x([
                            hI("field-chosen-middle-name"),
                            xI(o),
                            gI(A2(pc, wrr, hrr)),
                            YT(r),
                            yR("choosen-middle-name"),
                            aI(!0),
                            hR("additional-name"),
                            $R("additional-name"),
                            XT(w7n(hrr(o))),
                            nI(k7n(hrr(o)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(XH, x([
                        HH(n(qxn)),
                        VH(!0),
                        Lxn,
                        INn(D5n(3))
                    ]), x([
                        vI(x([
                            hI(D5n(3)),
                            xI(f),
                            gI(A2(pc, wrr, $rr)),
                            JT(A3(krr, t, e, 3)),
                            YT(r),
                            yR("choosen-last-name"),
                            aI(!0),
                            hR("family-name"),
                            $R("family-name"),
                            XT(w7n($rr(f))),
                            nI(k7n($rr(f)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), x([
                    A2(XH, x([
                        HH(n(Pxn)),
                        Lxn,
                        INn("field-chosen-suffix")
                    ]), x([
                        vI(x([
                            hI("field-chosen-suffix"),
                            xI(s),
                            gI(A2(pc, wrr, grr)),
                            YT(r),
                            yR("chosen-suffix"),
                            aI(!0),
                            hR("honorific-suffix"),
                            $R("honorific-suffix"),
                            XT(w7n(grr(s))),
                            nI(k7n(grr(s)))
                        ]))
                    ]))
                ])),
                A2(EN, x([
                    bR(3)
                ]), h),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(ET, n, A3(brr, t, e, 2))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), h),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(ET, n, A3(brr, t, e, 3))
                ])),
                A2(EN, x([
                    JI(3),
                    bR(2)
                ]), h)
            ])))
        ]));
    }), _rr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Arr = F4(function(n, r, t, e) {
        var u = FL(t).pP;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH("Email"),
                    VH(!0),
                    INn(D5n(4))
                ]), x([
                    vI(x([
                        hI(D5n(4)),
                        xI(u),
                        iI("me@example.com"),
                        gI(A2(pc, wrr, _rr)),
                        JT(A3(krr, t, e, 4)),
                        YT(r),
                        yR("email"),
                        aI(!0),
                        hR("email"),
                        $R("email"),
                        XT(w7n(_rr(u))),
                        nI(k7n(_rr(u))),
                        GT(1)
                    ])),
                    A2(ET, n, A3(brr, t, e, 4))
                ]))
            ]))
        ]));
    }), Crr = function(n) {
        return 3 === n.$ ? n.a : h;
    }, Brr = F2(function(n, r) {
        var t = FL(r.kB), e = t.rX, u = t.rY, a = vnr(e);
        if (Jwn(f0n(r.fL)) || TE(Crr(r.eX)) || aF(O7n(r.xs.iF))) return tB;
        var i, c = a ? x([
            jN(BN)
        ]) : h;
        return A2(nk, h, x([
            A2(zN, c, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(XH, x([
                        HH(n(mnr)),
                        VH((i = r.fL, r$n(f0n(i))))
                    ]), x([
                        A2(Ck, A7n, A4(sF, n, x([
                            Dq(e),
                            xq(n($nr)),
                            AR(r.u3)
                        ]), A2(Eu, function(n) {
                            return A2(hq, h, n);
                        }, Crr(r.eX)), r.eW))
                    ])),
                    A2(ET, n, A3(brr, r.kB, r.x, 6))
                ]))
            ])),
            A2(oR, a, A2(zN, h, x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    vI(x([
                        hI(D5n(7)),
                        xI(u),
                        gI(A2(pc, wrr, C7n)),
                        JT(A3(krr, r.kB, r.x, 7)),
                        YT(r.u3),
                        aI(!0),
                        XT(w7n(C7n(u))),
                        nI(k7n(C7n(u)))
                    ])),
                    A2(ET, n, A3(brr, r.kB, r.x, 7))
                ]))
            ])))
        ]));
    }), Err = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Drr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qrr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Frr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Prr = F5(function(n, r, t, e, u) {
        var a = FL(e), i = a.w5, c = a.qB, o = a.s2, f = a.rS, s = a.wY;
        return A2(zN, x([
            KN(x([
                Xx("mb-3 md:mb-4")
            ]))
        ]), x([
            A2(EN, x([
                bR(2),
                KN(x([
                    Xx("mb-4 sm:mb-0")
                ]))
            ]), x([
                A2(XH, x([
                    HH(n(hM)),
                    VH(tHn(i)),
                    Lxn
                ]), x([
                    A2(Ck, P7n, A3(Zxn, n, x([
                        jxn(r)
                    ]), i))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(vM)),
                    VH(!0),
                    Lxn,
                    INn(D5n(0))
                ]), x([
                    vI(x([
                        hI(D5n(0)),
                        xI(c),
                        gI(A2(pc, wrr, Err)),
                        JT(A3(krr, e, u, 0)),
                        YT(r || t),
                        yR("first-name"),
                        aI(!0),
                        {
                            $: 16,
                            a: !0
                        },
                        hR("given-name"),
                        $R("given-name"),
                        XT(w7n(Err(c))),
                        nI(k7n(Err(c)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n(pM)),
                    Lxn,
                    INn("field-middle-name")
                ]), x([
                    vI(x([
                        hI("field-middle-name"),
                        xI(o),
                        gI(A2(pc, wrr, qrr)),
                        YT(r),
                        yR("middle-name"),
                        aI(!0),
                        hR("additional-name"),
                        $R("additional-name"),
                        XT(w7n(qrr(o))),
                        nI(k7n(qrr(o)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(XH, x([
                    HH(n(mM)),
                    VH(!0),
                    Lxn,
                    INn(D5n(1))
                ]), x([
                    vI(x([
                        hI(D5n(1)),
                        xI(f),
                        gI(A2(pc, wrr, Drr)),
                        JT(A3(krr, e, u, 1)),
                        YT(r || t),
                        yR("last-name"),
                        aI(!0),
                        hR("family-name"),
                        $R("family-name"),
                        XT(w7n(Drr(f))),
                        nI(k7n(Drr(f)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), x([
                A2(XH, x([
                    HH(n($M)),
                    Lxn,
                    INn("field-suffix")
                ]), x([
                    vI(x([
                        hI("field-suffix"),
                        xI(s),
                        gI(A2(pc, wrr, Frr)),
                        YT(r || t),
                        yR("suffix"),
                        aI(!0),
                        hR("honorific-suffix"),
                        $R("honorific-suffix"),
                        XT(w7n(Frr(s))),
                        nI(k7n(Frr(s)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                bR(2)
            ]), h),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(ET, n, A3(brr, e, u, 0))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), h),
            A2(EN, x([
                JI(3)
            ]), x([
                A2(ET, n, A3(brr, e, u, 1))
            ])),
            A2(EN, x([
                JI(3),
                bR(2)
            ]), h)
        ]));
    }), zrr = F3(function(n, r, t) {
        var e = FL(t).uy;
        return A2(zN, h, x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(XH, x([
                    HH(n(Jj)),
                    VH(e.vJ)
                ]), x([
                    A2(Ck, q7n, A3(Myn, n, x([
                        Eyn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), jrr = F2(function(n, r) {
        var t = A4(B2n, n, r.lB, r.DF, r.xs.CS), e = 2 !== r.fc.$;
        return A2(G_n, x([
            Xx("mx-1"),
            drr(!0),
            K_n(lrr)
        ]), x([
            A5(Prr, n, r.u3, r.vv, r.kB, r.x),
            A4(yrr, n, r.u3, r.kB, r.x),
            A4(Arr, n, r.u3, r.kB, r.x),
            A3(zrr, n, r.u3, r.kB),
            A2(Brr, n, r),
            A2(mrr, n, r),
            A4(U2n, t, r.u3, e, lrr)
        ]));
    }), Srr = function(n) {
        return n.xX;
    }, Lrr = F2(function(n, r) {
        return u0n(r.lB) ? A2(Ak, x([
            _H(_cn),
            _H(BN)
        ]), x([
            ld(n(Srr))
        ])) : tB;
    }), Mrr = F2(function(n, r) {
        return r.CR(n);
    }), Nrr = F3(function(n, r, t) {
        return A2(t.ww, n, r);
    }), Hrr = F2(function(n, r) {
        return r.wx(n);
    }), Trr = F2(function(n, r) {
        if (u0n(r.lB)) {
            var t = r.ny;
            return 1 === t.$ ? tB : ld(n(Mrr($8n(t.a))));
        }
        return ld(n(function() {
            var n = function(n) {
                return n.n5;
            }(r.lB);
            if (n.$) return Hrr(Ex(r.dB));
            var t = n.a;
            return A2(Nrr, Ex(r.dB), t);
        }()));
    }), Irr = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("flex justify-center w-full")
            ]), x([
                A2(nk, x([
                    Xx("flex-col w-full md:w-4/5 lg:w-3/5")
                ]), x([
                    A2(yC, x([
                        SV,
                        _H(fO),
                        A2(D2n, 1, x2n),
                        rB(oB),
                        A2(w2n, 1, DB)
                    ]), x([
                        A2(Trr, n, r)
                    ])),
                    srr(r),
                    A2(Lrr, n, r),
                    A2(jrr, n, r)
                ]))
            ]))
        ]);
    }), Rrr = F2(function(n, r) {
        return {
            gN: function() {
                var t;
                switch(r.cM.$){
                    case 1:
                        return ck;
                    case 2:
                        return x([
                            p5n(r.dB)
                        ]);
                    default:
                        return frr(r) ? x([
                            (t = r.dB, A2(nk, x([
                                Xx("panel w-full signup-out-of-stock-error")
                            ]), x([
                                A2(Ak, h, x([
                                    ld("This item is not currently available for sale")
                                ])),
                                Dk,
                                A2(Ek, h, x([
                                    ld("Please contact us and let us know the item you would like to purchase at "),
                                    bGn(qB(t)),
                                    A2(dGn, xx(t), qB(t))
                                ]))
                            ])))
                        ]) : A2(Irr, n, r);
                }
            }(),
            w5: frr(r) ? "Out of Stock" : Ex(r.dB)
        };
    }), Zrr = mGn({
        Ar: l7n,
        AQ: d7n,
        Db: b7n,
        DZ: function() {
            return mJn(v7n);
        },
        En: crr,
        Et: Rrr
    }), Vrr = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Urr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Yrr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Qrr = "custom-details-container", Orr = x([
        0,
        1
    ]), Grr = function(n) {
        return n ? "Uses Tobacco" : "Forms";
    }, Jrr = {
        mr: Ut,
        cx: h,
        su: Ut,
        tg: Ut,
        xy: !1,
        x: A2(vS, Orr, Grr)
    }, Wrr = F4(function(n, r, t, e) {
        var u = nQn(r), a = bXn(t), i = function() {
            var r = i3n(e.iF);
            if (r.$) return Pp;
            var u = r.a;
            return A4(N9n, t.gF, Bx(n), u, Vrr);
        }(), c = TEn(t), o = c.a, f = c.b, s = function() {
            var r = b(a, t.DF);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, vc, c = r.b.a);
                var e = r.a.a, c = r.b.a;
                return v(x([
                    A5(R1n, t.gF, Bx(n), xGn(u), e, Yrr),
                    i,
                    A2(Lp, Urr, f)
                ]), cP, c);
            }
            return v(h, vc, h);
        }(), l = s.a, d = s.b, m = s.c;
        return b({
            f0: KKn(t),
            gF: t.gF,
            m7: Ut,
            oA: Ut,
            hf: cK,
            hg: t.hg,
            as: o,
            kA: t.kA,
            kB: lS(Jrr),
            A8: cP,
            fc: a,
            ie: cP,
            dB: n,
            u3: !1,
            fr: Ut,
            fs: Ut,
            cM: d,
            cT: A3(l3n, Wx(t.kA), Qrr, $3n(n)),
            lB: u,
            ca: vc,
            fL: r,
            DF: m,
            bF: Zqn,
            xs: e
        }, Vu(l));
    }), Krr = F2(function(n, r) {
        return b(r, Pp);
    }), Xrr = F2(function(n, r) {
        return r;
    }), ntr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, rtr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ttr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, etr = nr("onTabSelected", C$), utr = {
        $: 10
    }, atr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, itr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ctr = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), otr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ftr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, str = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), ltr = {
        $: 0
    }, dtr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, btr = function(n) {
        return {
            $: 15,
            a: n
        };
    }, vtr = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 4,
                a: n
            };
        }
    }, mtr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ptr = function(n) {
        return A2(Nu, mtr, _u(n));
    }, $tr = function(n) {
        return n.rh;
    }, htr = F2(function(n, r) {
        var t = n.cM;
        return 3 === t.$ ? rv(A2(Rc, function(n) {
            return i($tr(n), r);
        }, t.a)) : Ut;
    }), gtr = function(n) {
        var r = b(iFn(n.dB), A2(nv, o6n, n.m7));
        return !(!r.a || r.b.$) && function(n) {
            return n.py;
        }(r.b.a);
    }, wtr = function(n) {
        return n.rO;
    }, xtr = function(n) {
        var r = n.ca;
        return 3 === r.$ && !TE(r.a);
    }, ktr = function(n) {
        return function(n) {
            return n.rh;
        }(n.kB);
    }, ytr = function(n) {
        return n.qM;
    }, _tr = F2(function(n, r) {
        return rv(A2(Rc, function(n) {
            return i(ktr(n), gPn(r));
        }, ytr(n)));
    }), Atr = function(n) {
        return function(n) {
            return n.rh;
        }(n.qI);
    }, Ctr = function(n) {
        return n.qL;
    }, Btr = F2(function(n, r) {
        return A2(Rc, function(r) {
            return i(Atr(r), Pzn(n));
        }, Ctr(r));
    }), Etr = F3(function(n, r, t) {
        var e = A2(sc, h, A2(Fp, Btr(t), A2(_tr, n, r)));
        return TMn(t) && TE(e);
    }), Dtr = F2(function(n, r) {
        return A2(Rc, A2(Etr, n, r), MMn(r));
    }), qtr = F2(function(n, r) {
        var t = n.ca;
        if (3 === t.$) {
            var e = t.a;
            return xtr(n) && !TE(rc(A2(Eu, Dtr(r), e)));
        }
        return !1;
    }), Ftr = F2(function(n, r) {
        return A2(q7, function(n) {
            return i($tr(n), r);
        }, n);
    }), Ptr = F2(function(n, r) {
        return 3 === n.$ && i(A2(Ftr, n.a, r), Vt(0));
    }), ztr = function(n) {
        return n.tV;
    }, jtr = function(n) {
        var r = n.ie;
        return 3 === r.$ && ztr(r.a);
    }, Str = F2(function(n, r) {
        if (jtr(n) && A2(Ptr, n.cM, $tr(r))) return !1;
        var t = wtr(r);
        return gtr(n) && function(n) {
            return LP(n);
        }(t) || A2(qtr, n, r);
    }), Ltr = F2(function(n, r) {
        return rv(A2(Rc, Str(n), r));
    }), Mtr = function(n) {
        return n.mr;
    }, Ntr = function(n) {
        return n.mD;
    }, Htr = function(n) {
        return n.nf;
    }, Ttr = function(n) {
        return n.rh;
    }, Itr = F2(function(n, r) {
        return A2(Eu, function(t) {
            var e = A2(Fp, Ttr, r), u = Pzn(t), a = A2(Rc, function(n) {
                return i(Atr(n), u);
            }, A2(sc, h, A2(Fp, Ctr, r))), c = gPn(n);
            return {
                mD: function() {
                    var n;
                    switch(IMn(t)){
                        case 2:
                            return n = A2(sc, !1, A2(nv, Htr, rv(a))), Nzn(n);
                        case 0:
                            return function(n) {
                                return Rzn(n);
                            }(A2(sc, "", A2(nv, Ntr, rv(a))));
                        default:
                            return Fzn(A2(Tp, Ntr, a));
                    }
                }(),
                kC: c,
                dk: u,
                kD: e
            };
        }, MMn(n));
    }), Rtr = F2(function(n, r) {
        var t = rv(A2(Rc, function(n) {
            return i(ktr(n), gPn(r.ag));
        }, n));
        return m(r, {
            S: A2(Itr, r.ag, t)
        });
    }), Ztr = F2(function(n, r) {
        return A2(Eu, function(n) {
            var t = "input-" + gPn(n);
            return A2(Rtr, ytr(r), A2(wPn, t, n));
        }, n);
    }), Vtr = function(n) {
        return n.tg;
    }, Utr = function(n) {
        return n.xy;
    }, Ytr = F2(function(n, r) {
        return {
            mr: Mtr(r),
            cx: A2(Ztr, n, r),
            su: Vt($tr(r)),
            tg: Vtr(r),
            xy: Utr(r),
            x: A2(vS, Orr, Grr)
        };
    }), Qtr = F2(function(n, r) {
        return A2(sc, Jrr, A2(Fp, Ytr(n), r));
    }), Otr = function(n) {
        return n.$ ? 1 : 0;
    }, Gtr = F2(function(n, r) {
        var t = Otr(n), e = m(r, {
            x: A3(vN, !0, t, r.x)
        });
        return m(e, n.$ ? {
            xy: n.a
        } : {
            cx: n.a
        });
    }), Jtr = F2(function(n, r) {
        var t = rv(Ae(n));
        return !t.$ && i($tr(t.a), r);
    }), Wtr = F3(function(n, r, t) {
        return A2(nv, function(t) {
            return A2(yPn, t + r, n);
        }, A2(Ftr, n, t));
    }), Ktr = F2(function(n, r) {
        return A3(Wtr, n, 1, r);
    }), Xtr = F2(function(n, r) {
        var t = A2(htr, r, n);
        if (t.$) return v(r, Pp, h);
        var e, u = t.a, a = 3 === (e = r.ca).$ ? e.a : h;
        return v(m(r, {
            kB: lS(A2(Ytr, a, u))
        }), bzn($tr(u)), h);
    }), ner = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), rer = F3(function(n, r, t) {
        return A2(Eu, function(n) {
            return b(t, n);
        }, A3(ner, n, r, t));
    }), ter = function(n) {
        var r = FL(n);
        return rc(A2(Eu, A2(rer, n, r.x), Orr));
    }, eer = F3(function(n, r, t) {
        return A2(nv, function(n) {
            return Vt(A2(fe, ": ", x([
                n ? "Dependent " + oe(n) : "Owner",
                r
            ])));
        }, A2(Ftr, t, n));
    }), uer = F2(function(n, r) {
        var t = FL(n.kB), e = b(n.cM, t.su);
        if (3 !== e.a.$ || e.b.$) return h;
        var u = e.a.a;
        return A2(sc, h, A2(Fp, function(r) {
            var t = lc(n.xs.CS), e = A2(Fp, zc, rv(ter(n.kB)));
            return x([
                Q1n(Vt({
                    eH: A2(sc, h, A2(Fp, VZ, e)),
                    qv: r,
                    C9: t
                }))
            ]);
        }, A3(eer, e.b.a, function(n) {
            return Grr(Otr(n));
        }(r), u)));
    }), aer = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "forms"
        ]), lL(n));
    }), ier = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(Pmn), e, rA(A2(aer, r, t)));
    }), cer = F6(function(n, r, t, e, u, a) {
        return {
            mr: t,
            qM: u,
            rh: n,
            rO: e,
            tg: r,
            xy: a
        };
    }), oer = F3(function(n, r, t) {
        return {
            kB: r,
            qL: t,
            rh: n
        };
    }), fer = F3(function(n, r, t) {
        return {
            mD: r,
            nf: t,
            qI: n
        };
    }), ser = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), ler = A2(Pk, ser, uu(iu)), der = A3(ly, "boolean_answer", iy(jk), A3(ly, "answer", iy(C$), A3(ly, "form_item", ler, uu(fer)))), ber = A2(Pk, der, uu(iu)), ver = A3(ly, "id", C$, uu(function(n) {
        return {
            rh: n
        };
    })), mer = A2(Pk, ver, uu(iu)), per = A3(ly, "form_response_items", vy(ber), A3(ly, "form", mer, A3(ly, "id", C$, uu(oer)))), $er = A2(Pk, per, uu(iu)), her = A3(ly, "uses_tobacco", jk, A3(ly, "form_responses", vy($er), A3(ly, "known_practice", iy(YR), A3(ly, "age", iy(F$), A3(ly, "name", iy(C$), A3(ly, "id", C$, uu(cer))))))), ger = A2(Pk, her, uu(iu)), wer = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "custom_details"
        ]), lL(n));
    }), xer = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(ger), e, rA(A2(wer, r, t)));
    }), ker = F2(function(n, r) {
        return {
            ok: r,
            rh: n
        };
    }), yer = function(n) {
        return A2(sc, tB, A2(Fp, function(n) {
            return A2(FI, x([
                ok(x([
                    Xx("tabs-member-age")
                ]))
            ]), x([
                ld(" (" + oe(n) + "y/o)")
            ]));
        }, n));
    }, _er = function(n) {
        return A2(sc, tB, A2(Fp, function(n) {
            return A2(FI, x([
                ok(x([
                    Xx("tabs-member-name")
                ]))
            ]), x([
                ld(n)
            ]));
        }, n));
    }, Aer = F2(function(n, r) {
        return A2(nk, h, x([
            _er(n),
            yer(r)
        ]));
    }), Cer = F3(function(n, r, t) {
        return A2(K4, A2(ker, n, A2(Aer, r, t)), {
            d$: function(n) {
                return n.rh;
            },
            d1: function(n) {
                return n.ok;
            }
        });
    }), Ber = function(n) {
        return A3(Cer, $tr(n), Vtr(n), Mtr(n));
    }, Eer = function(n) {
        var r = A2(nv, o6n, n.m7);
        if (r.$) return !1;
        var t = r.a;
        return m0n(n.fL) && aF(function(n) {
            return n.xa;
        }(t));
    }, Der = function(n) {
        if (xtr(n)) {
            var r = FL(n.kB);
            return x([
                b("form_responses", A2(KK, uzn, r.cx))
            ]);
        }
        return h;
    }, qer = function(n) {
        return gtr(n) ? x([
            XPn(n.as)
        ]) : h;
    }, Fer = function(n) {
        if (Eer(n)) {
            var r = XFn(n.bF);
            return x([
                b("uses_tobacco", LC(r))
            ]);
        }
        return h;
    }, Per = function(n) {
        return rc(x([
            qer(n),
            Der(n),
            Fer(n)
        ]));
    }, zer = "custom-forms", jer = function(n) {
        return OLn(n ? "tobacco-use" : zer);
    }, Ser = F6(function(n, r, t, e, u, a) {
        return A4(dC, gQ(n), ger, a, A2(vL, function(n) {
            return _x(x([
                b("member", _x(n))
            ]));
        }(u), rA(A2(X_, x([
            e
        ]), A2(wer, r, t)))));
    }), Ler = function(n) {
        return n.qH.rk;
    }, Mer = F2(function(n, r) {
        var t = A2(ywn, function(n) {
            return function(n) {
                return TE(function(n) {
                    return A2(Tp, YMn(n.S), MMn(n.ag));
                }(n));
            }(n);
        }, r.cx);
        return xtr(n) && !t ? x([
            b(0, eM(Ler))
        ]) : h;
    }), Ner = F2(function(n, r) {
        if (gtr(r)) {
            var t = A2(Bzn, n, r.as);
            return b(t.a, t.b);
        }
        return b(r.as, !0);
    }), Her = F2(function(n, r) {
        var t = FL(r.kB), e = function() {
            if (n) {
                var e = m(t, {
                    x: n ? jM(t.x) : t.x
                });
                return m(r, {
                    kB: A2(aUn, e, r.kB)
                });
            }
            return r;
        }(), u = function(n) {
            var r = A2(BM, function(n) {
                return nM(x([
                    Mer(n)
                ]));
            }(n), n.kB);
            return r.$ ? b(r.a, !1) : b(r.a.a, !0);
        }(e), a = u.a, i = u.b, c = A2(Ner, n, r), o = c.b;
        return b(m(e, {
            as: c.a,
            kB: a
        }), i && o);
    }), Ter = F5(function(n, r, t, e, u) {
        if (jtr(u) && A2(Ptr, u.cM, r)) return v(!1, u, x([
            A2(Nu, iu, _u(ftr(e)))
        ]));
        if (c = FL(u.kB).x, A2(jE, function(n) {
            return A2(qM, n, c);
        }, Orr) || LP(e)) {
            var a = A2(Her, !0, u), i = a.a;
            return a.b ? v(!1, m(i, {
                u3: !0
            }), x([
                A6(Ser, i.gF, Bx(i.dB), n, r, Per(i), t(e))
            ])) : v(!0, i, A2(Yt, A2(sc, Pp, A2(Fp, jer, function(n) {
                return A2(Fp, Oe, rv(ter(n)));
            }(i.kB))), function(n) {
                var r = b(FL(n.kB).su, n.cM);
                if (r.a.$ || 3 !== r.b.$) return h;
                var t = r.a.a, e = r.b.a;
                return A2(Eu, function(n) {
                    var r = n.b, u = A3(eer, t, Grr(n.a), e);
                    if (u.$) return Pp;
                    var a = u.a;
                    return RXn({
                        eH: x([
                            r
                        ]),
                        qv: a
                    });
                }, ter(n.kB));
            }(i)));
        }
        var c;
        return v(!1, u, x([
            A2(Nu, iu, _u(ftr(e)))
        ]));
    }), Ier = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Rer = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Zer = function(n) {
        return A2(a3n, "billing_period", n);
    }, Ver = function(n) {
        return n.g2;
    }, Uer = F3(function(n, r, t) {
        return t.$ ? h : x([
            b(n, r(t.a))
        ]);
    }), Yer = function(n) {
        var r = A2(Yt, b("members", n.zK), A2(sc, h, A2(Fp, function(n) {
            return x([
                W6n(n)
            ]);
        }, n.m7))), t = A2(nv, function(n) {
            var r = A2(Yp, function(n) {
                switch(n){
                    case "monthly":
                        return uu(0);
                    case "quarterly":
                        return uu(1);
                    case "semi_annually":
                        return uu(2);
                    case "annually":
                        return uu(3);
                    default:
                        return Sk("Unsupported period name: " + n);
                }
            }(n), "{}");
            return r.$ ? Ut : Vt(r.a);
        }, n.yA), e = $(A3(Uer, "coupon_code", function(n) {
            return G$n(Ver(n));
        }, n.oA), A3(Uer, "period_in_months", function(n) {
            return EX(EV(n));
        }, t));
        return _x($(r, e));
    }, Qer = function(n) {
        var r = n;
        return _x(x([
            b("name", G$n(r.tg)),
            b("dob", WFn(r.pn)),
            b("relationship", GFn(r.vB)),
            b("uses_tobacco", LC(r.xy))
        ]));
    }, Oer = function(n) {
        return n.rh;
    }, Ger = F3(function(n, r, t) {
        var e = XFn(t.bF), u = FL(t.kB).su;
        if (i(Vt(Oer(n)), u)) return A3(X6n, n, x([
            b("uses_tobacco", LC(e))
        ]), h);
        var a = A2(wF, function(r) {
            return i($tr(r), Oer(n));
        }, r);
        return a.$ ? Qer(n) : A3(X6n, n, x([
            b("uses_tobacco", LC(Utr(a.a)))
        ]), h);
    }), Jer = F2(function(n, r) {
        var t = v(r.cM, r.m7, Q6n(r.lB));
        if (3 === t.a.$ && !t.b.$ && t.c) {
            var e = t.a.a, u = t.b.a, a = A2(KK, function(n) {
                return A3(Ger, n, e, r);
            }, r4n(n)), i = Yer({
                yA: Zer(r.xs.iF),
                m7: Vt(u),
                oA: r.oA,
                zK: a
            });
            return A4(pPn, r.gF, Bx(r.dB), i, Rer);
        }
        return Pp;
    }), Wer = function(n) {
        var r = n.ie;
        if (3 === r.$) {
            var t = r.a;
            return a0n(n.lB) ? A2(Jer, t, n) : A4(G6n, n.gF, Bx(n.dB), B9n(t), Ier);
        }
        return Pp;
    }, Ker = F2(function(n, r) {
        return m(n, {
            xy: r
        });
    }), Xer = F2(function(n, r) {
        switch(n.$){
            case 7:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (hn = r.f0).$ ? Pp : V0n(hn.a), c = Bx(r.dB), o = B9n(u), f = KXn(u), s = x(f ? [
                        FXn(n2n(u)),
                        AXn,
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]);
                    return v(m(e, {
                        f0: Ut,
                        m7: Vt(R3n(u)),
                        hg: f
                    }), Vu(x([
                        A4(xer, r.gF, c, o, atr),
                        A4(ier, r.gF, c, o, otr),
                        a
                    ])), s);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 3:
                if (e = m(r, {
                    cM: A = n.a
                }), 3 === A.$) {
                    var l = A.a, d = A2(Ker, r.bF, function(n) {
                        var r = b(Eer(n), n.cM);
                        if (r.a && 3 === r.b.$) {
                            var t = rv(r.b.a);
                            return !t.$ && Utr(t.a);
                        }
                        return !1;
                    }(e)), p = function(n) {
                        var r = b(gtr(n), n.cM);
                        return r.a && 3 === r.b.$ ? A2(nv, wtr, rv(r.b.a)) : Ut;
                    }(e), $ = p.$ ? r.as : A2(wMn, r.as, p.a), g = 3 === ($n = r.ie).$ && A4(K0n, r.lB, r.DF, n2n($n.a), r.xs.CS), w = 3 === (pn = e.ca).$ ? pn.a : h, k = g ? A2(N$, A2(Ltr, e, l), function(n) {
                        return rv(Ae(n));
                    }(l)) : rv(l), y = be(l) > 1 ? x([
                        A3(str, A2(Eu, Ber, l), A2(sc, "", A2(Fp, $tr, k)), !0)
                    ]) : h;
                    return v(m(e, {
                        as: $,
                        kB: lS(A2(Qtr, w, k)),
                        bF: d
                    }), Vu(x([
                        Wer(e),
                        A4(I0n, 4, e.DF, e.fL, h)
                    ])), y);
                }
                return v(r, Pp, A2(xA, 1, A));
            case 1:
                var _ = n.a, A = n.b;
                if (e = m(r, {
                    u3: !1
                }), 3 === A.$) {
                    var C = A.a, B = function() {
                        var n = r.cM;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(Zy, A2(Eu, function(n) {
                                return i($tr(n), $tr(C)) ? C : n;
                            }, n.a), t);
                        }
                        return r.cM;
                    }();
                    return v(m(e, {
                        cM: B
                    }), A2(Nu, iu, _u(ftr(_))), h);
                }
                return v(e, Pp, A2(xA, 1, A));
            case 0:
                var E = FL(r.kB), D = b(r.fc, E.su);
                if (D.a.$ || D.b.$) return v(r, Pp, h);
                var q = A5(Ter, o = D.a.a, Y = D.b.a, itr, Ut, r);
                return v(O = q.b, Vu(G = q.c), h);
            case 4:
                var F = n.a, P = A4(x0, vtr, h0(ptr), F, r.hf), z = P.b;
                return v(m(r, {
                    hf: P.a
                }), z, h);
            case 5:
                return v(r, OLn(n.a), h);
            case 6:
                var j = n.a;
                n: for(;;)switch(j.$){
                    case 3:
                        return v(m(r, {
                            fr: Vt(j.a),
                            fs: Ut
                        }), Pp, h);
                    case 2:
                        if (5 === j.a.$) {
                            var S = Vt(WWn(x([
                                pA(a6n(j.a.b))
                            ])));
                            return v(m(r, {
                                fs: S
                            }), Pp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, j));
            case 8:
                var L = A2(V6n, n.a, r.cT), M = L.a, N = L.b, H = L.c, T = H.$ || H.a ? Pp : A2(Nu, iu, _u(ltr));
                return v(m(r, {
                    cT: M
                }), Vu(x([
                    A2(Lp, ntr, N),
                    T
                ])), h);
            case 9:
                var I = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), R = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, R, I) ? A2(U0n, R, I) : Pp, x([
                    utr
                ]));
            case 10:
                var Z = n.a, V = FL(r.kB), U = b(r.fc, V.su);
                if (U.a.$ || U.b.$) return v(r, Pp, h);
                var Y, Q = A5(Ter, o = U.a.a, Y = U.b.a, itr, Vt(Z), r), O = Q.b, G = Q.c;
                return y = Q.a ? x([
                    dtr(Y)
                ]) : h, v(O, Vu(G), y);
            case 11:
                var J = n.a;
                if (e = m(r, {
                    ca: J
                }), 3 === J.$) {
                    var W = J.a, K = FL(r.kB);
                    return v(m(e, {
                        kB: lS(A2(Qtr, W, k = A2(htr, r, A2(sc, "", K.su))))
                    }), Pp, h);
                }
                return v(r, Pp, A2(xA, 1, J));
            case 12:
                var X = n.a, nn = n.b, rn = FL(r.kB).cx, tn = A2(Vzn, nn, X), en = tn.a, un = tn.b, an = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A3(aQ, function(n) {
                    return i(APn(n), APn(en));
                }, function() {
                    return en;
                }, rn));
                return v(e = m(r, {
                    kB: A3(dN, Gtr, an, r.kB)
                }), A2(Lp, ctr(en), un), A2(uer, e, an));
            case 2:
                var cn = n.a;
                return cn.$ ? function(n) {
                    var r = v(FL(n.kB).su, n.cM, n.ca);
                    if (r.a.$ || 3 !== r.b.$ || 3 !== r.c.$) return v(n, Pp, h);
                    var t = r.a.a, e = r.b.a, u = r.c.a;
                    if (A2(Jtr, e, t)) return v(n, A4(H0n, 4, n.DF, n.fL, h), x([
                        DXn
                    ]));
                    var a = A2(Ktr, e, t);
                    if (a.$) return v(n, Pp, h);
                    var i = a.a;
                    return v(m(n, {
                        kB: lS(A2(Ytr, u, i))
                    }), bzn($tr(i)), x([
                        dtr($tr(i))
                    ]));
                }(r) : A2(Xtr, cn.a, r);
            case 13:
                var on = n.a;
                return 3 === on.$ ? v(e = m(r, {
                    oA: Vt(on.a)
                }), Wer(e), h) : v(r, Pp, A2(xA, 1, on));
            case 14:
                var fn = A2(qzn, n.a, r.as), sn = fn.b;
                return v(m(r, {
                    as: fn.a
                }), A2(Lp, Urr, sn), h);
            case 15:
                var ln = A2(QLn, n.a, r.bF), dn = (sn = ln.b, ln.c), bn = (e = m(r, {
                    bF: ln.a
                }), function() {
                    if (dn.$) return b(Pp, h);
                    var n = dn.a;
                    return b(Wer(e), A2(uer, e, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }()), vn = bn.a, mn = bn.b;
                return v(e, Vu(x([
                    A2(Lp, btr, sn),
                    vn
                ])), mn);
            default:
                return v(m(r, {
                    A8: n.a
                }), Pp, h);
        }
        var pn, $n, hn;
    }), nur = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rur = F4(function(n, r, t, e) {
        return b(APn(e), A2(Ck, ctr(e), A3(oNn, n, x([
            nur(r),
            LMn(t)
        ]), e)));
    }), tur = F3(function(n, r, t) {
        if (xtr(t)) {
            var e = FL(t.kB), u = e.cx, a = A2(bN, 0, e.x);
            return A3(Kq, "div", x([
                Hq(zer)
            ]), A2(Eu, A3(rur, n, r, a), u));
        }
        return tB;
    }), eur = F2(function(n, r) {
        return gtr(r) ? A2(nk, h, x([
            A2(Ck, Urr, A2(gNn, n, r.as))
        ])) : tB;
    }), uur = F3(function(n, r, t) {
        return Eer(t) ? A2(nk, h, x([
            A2(nk, h, x([
                A2(Ck, btr, A3(CNn, n, r, t.bF))
            ]))
        ])) : tB;
    }), aur = F3(function(n, r, t) {
        if (jtr(t) && function(n) {
            var r = FL(n.kB).su;
            return !r.$ && A2(Ptr, n.cM, r.a);
        }(t)) {
            var e = FL(t.kB).tg;
            return A2(Ek, h, x([
                ld("No details need to be completed" + (e.$ ? "" : " for " + e.a) + ".")
            ]));
        }
        return A2(nk, x([
            Xx("custom-details")
        ]), x([
            A2(eur, n, t),
            A3(tur, n, r, t),
            A3(uur, n, r, t)
        ]));
    }), iur = F3(function(n, r, t) {
        return A2(nk, x([
            Hq(Qrr),
            Xx("flex-grow")
        ]), x([
            A3(aur, n, r, t)
        ]));
    }), cur = F5(function(n, r, t, e, u) {
        return r ? A4(B2n, n, t, e, u) : "Update next member";
    }), our = F3(function(n, r, t) {
        var e = b(FL(r.kB).su, r.cM);
        if (e.a.$ || 3 !== e.b.$) return t;
        var u = e.a.a, a = A2(sc, !1, A2(Fp, function(n) {
            return i($tr(n), u);
        }, rv(Ae(e.b.a))));
        return A2(a8n, A5(cur, n, a, r.lB, r.DF, r.xs.CS), t);
    }), fur = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 2,
                a: n
            };
        }(n), r);
    }), sur = F2(function(n, r) {
        return (Q6n(r.lB) ? c8n(r.fr) : e8n(W4n(K4n(r.A8))))(A2(r8n, r.fs, A2(i8n, r.m7, A2(n8n, r.u3, A2(fur, r.u3, A3(our, n, r, h))))));
    }), lur = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, ntr, A3(l5n, n, A2(sur, n, r), r.cT))
        ]));
    }), dur = F2(function(n, r) {
        return A2(Ck, ntr, A3(l5n, n, b5n(A2(sur, n, r)), r.cT));
    }), bur = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(fO),
                    A2(D2n, 1, x2n),
                    rB(oB)
                ]), x([
                    ld("Custom details")
                ])),
                A2(nk, x([
                    Xx("flex flex-grow w-full")
                ]), x([
                    A3(iur, n, r.u3, r),
                    A2(lur, n, r)
                ])),
                A2(dur, n, r)
            ]))
        ]);
    }), vur = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.cM, r.ie);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return x([
                                                p5n(r.dB)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(bur, n, r);
                                    }
                            }
                            return x([
                                p5n(r.dB)
                            ]);
                        }
                        return ck;
                    }
                    return ck;
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), mur = mGn({
        Ar: Wrr,
        AQ: Krr,
        Db: Xrr,
        DZ: function() {
            return Px(x([
                A2(_S, ntr, P3n()),
                wXn(ttr),
                etr(rtr)
            ]));
        },
        En: Xer,
        Et: vur
    }), pur = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $ur = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hur = function(n) {
        return {
            $: 11,
            a: n
        };
    }, gur = function(n) {
        return {
            $: 9,
            a: n
        };
    }, wur = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xur = "content-container", kur = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), Jan, e, rA(A2(X_, x([
            t
        ]), Bqn(r))));
    }), yur = function(n) {
        return n.r$;
    }, _ur = function(n) {
        return A2(a3n, "location", n);
    }, Aur = F3(function(n, r, t) {
        return m(t, {
            lB: A2(Fp, XYn, n),
            x0: r
        });
    }), Cur = F2(function(n, r) {
        return A2(Nu, function() {
            return r(A2(Zy, n, da));
        }, jp(500));
    }), Bur = F2(function(n, r) {
        return A2(Cur, n, r);
    }), Eur = {
        mr: Ut,
        rh: "mock-ident",
        kL: Ut,
        tg: Vt("John Doe"),
        uP: Ut,
        x0: Vt("94103")
    }, Dur = F4(function(n, r, t, e) {
        var u = nQn(r), a = yur(u) ? Vt(u) : Ut, i = bXn(t), c = function() {
            var r = i3n(e.iF);
            if (r.$) return Pp;
            var u = r.a;
            return A4(N9n, t.gF, Bx(n), u, pur);
        }(), o = function() {
            var r = _ur(e.iF);
            if (r.$) return b(Pp, vc);
            var u = r.a;
            return vu(u) ? b(Pp, vc) : b(A4(kur, t.gF, Bx(n), u, hur), cP);
        }(), f = o.a, s = o.b, l = function() {
            var r, e = v(i, t.hg, t.DF);
            n: for(;;){
                if (e.b) {
                    if (3 === e.c.$) return s = e.c.a, v(x([
                        f,
                        (r = wur, A2(Bur, x([
                            Eur
                        ]), r)),
                        c
                    ]), cP, s);
                    break n;
                }
                if (e.a.$ || 3 !== e.c.$) break n;
                var o = e.a.a, s = e.c.a;
                return v(x([
                    A5(R1n, t.gF, Bx(n), xGn(u), o, $ur),
                    f,
                    A4(Eqn, t.gF, Bx(n), A2(Aur, a, Ut), gur),
                    c
                ]), cP, s);
            }
            return v(h, vc, h);
        }(), d = l.a, m = l.b, p = l.c;
        return b({
            f0: KKn(t),
            ao: Ut,
            gF: t.gF,
            m7: Ut,
            oA: Ut,
            hg: t.hg,
            bn: !1,
            kq: uqn,
            kw: Ut,
            kA: t.kA,
            cC: s,
            hZ: m,
            a2: h,
            e3: m,
            A8: m,
            fc: i,
            ie: m,
            dB: n,
            u3: !1,
            fr: Ut,
            fs: Ut,
            dO: Ut,
            cT: A3(l3n, Wx(t.kA), xur, $3n(n)),
            lB: u,
            fL: r,
            DF: p,
            xs: e
        }, Vu(d));
    }), qur = F2(function(n, r) {
        return b(r, Pp);
    }), Fur = F2(function(n, r) {
        return r;
    }), Pur = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zur = function(n) {
        return {
            $: 6,
            a: n
        };
    }, jur = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Sur = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Lur = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Mur = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Nur = {
        $: 0
    }, Hur = function(n) {
        return m(n, {
            kw: Ut
        });
    }, Tur = F2(function(n, r) {
        var t = n.cC;
        return 3 === t.$ ? x([
            t.a
        ]) : r;
    }), Iur = function(n) {
        var r = n.hZ;
        if (3 === r.$) {
            var t = r.a;
            return A2(eq, bLn, A2(Rc, mLn(n.kq), A2(Tur, n, t)));
        }
        return h;
    }, Rur = F2(function(n, r) {
        return aF(A2(wF, function(r) {
            return i(bqn(r), bqn(n));
        }, r));
    }), Zur = F2(function(n, r) {
        return A2(Rur, r, Iur(n));
    }), Vur = F2(function(n, r) {
        return m(r, {
            pl: n
        });
    }), Uur = function(n) {
        return A2(Eu, function(n) {
            return A2(Vur, Ut, n);
        }, n);
    }, Yur = F2(function(n, r) {
        var t = r.$ ? yx : G$n(r.a);
        return b(n, _x(x([
            b("id", t)
        ])));
    }), Qur = function(n) {
        return A2(Yur, "location", A2(Fp, bqn, n));
    }, Our = function(n) {
        return n.rh;
    }, Gur = F2(function(n, r) {
        return i(Vt(r), rv(Ae(n)));
    }), Jur = function(n) {
        return n.kL;
    }, Wur = function(n) {
        return A2(otn, "Filtering by Distance", A2(sc, "", A2(Fp, function(n) {
            return A2(fe, " from zip ", x([
                n.a,
                n.b
            ]));
        }, n)));
    }, Kur = F2(function(n, r) {
        return function(r) {
            if (1 === r.$) {
                var t = r.b;
                return Vt(b(A2(tqn, n, Vt(r.a)), t));
            }
            return Ut;
        }(yqn(r));
    }), Xur = F4(function(n, r, t, e) {
        return A2(itn, "Member Preference Saved", A2(Yt, function(n) {
            return A2(otn, "Member ID", n);
        }(n), $(A2(N0n, r, t), e)));
    }), nar = function(n) {
        return A2(otn, "Location", A2(sc, "", A2(Fp, lvn, n)));
    }, rar = F3(function(n, r, t) {
        return A4(Xur, Our(n), 5, r, x([
            nar(Jur(n)),
            Wur(A2(Kur, Wx(0), t))
        ]));
    }), tar = F2(function(n, r) {
        return A2(q7, function(n) {
            return i(n, r);
        }, n);
    }), ear = F3(function(n, r, t) {
        return A2(nv, function(t) {
            return A2(yPn, t + r, n);
        }, A2(tar, n, t));
    }), uar = F2(function(n, r) {
        return A3(ear, n, 1, r);
    }), aar = F2(function(n, r) {
        var t = b(n, Jur(r));
        if (3 !== t.a.$ || t.b.$) return !0;
        var e = t.b.a;
        return LP(A2(wF, function(n) {
            return i(bqn(n), bqn(e));
        }, t.a.a));
    }), iar = F6(function(n, r, t, e, u, a) {
        return {
            mr: t,
            rh: n,
            kL: u,
            tg: r,
            uP: a,
            x0: e
        };
    }), car = A3(ly, "practitioner", iy(Lbn), A3(ly, "location", iy(Jan), A3(ly, "zip", iy(C$), A3(ly, "age", iy(F$), A3(ly, "name", iy(C$), A3(ly, "id", C$, uu(iar))))))), oar = A2(Pk, car, uu(iu)), far = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "member_providers"
        ]), lL(n));
    }), sar = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(oar), e, rA(A2(far, r, t)));
    }), lar = F2(function(n, r) {
        return A2(wF, function(n) {
            return i(bqn(n), r);
        }, n);
    }), dar = F2(function(n, r) {
        return A2(nv, lar(n), r);
    }), bar = "Location", mar = xD, par = function(n) {
        var r = n.ao;
        if (r.$) return v(n, Pp, h);
        var t = r.a, e = A2(sc, bar, A2(Fp, function(n) {
            return A2(fe, ": ", x([
                n ? "Dependent " + oe(n) : "Owner",
                bar
            ]));
        }, A2(q7, function(n) {
            return i(n, t);
        }, n.a2)));
        return v(m(n, {
            kw: Vt(mar)
        }), RXn({
            eH: x([
                eM(mar)
            ]),
            qv: e
        }), h);
    }, $ar = function(n) {
        return n.mr;
    }, har = function(n) {
        return n.tg;
    }, gar = function(n) {
        return A3(Cer, Our(n), har(n), $ar(n));
    }, war = F2(function(n, r) {
        return 1 === n.$ ? r(0) : n;
    }), xar = F2(function(n, r) {
        return A3(ear, n, -1, r);
    }), kar = F6(function(n, r, t, e, u, a) {
        return A4(dC, gQ(n), oar, a, A2(vL, u, rA(A2(X_, x([
            e
        ]), A2(far, r, t)))));
    }), yar = F2(function(n, r) {
        var t = rv(A2(Rc, function(n) {
            return i(wLn(n), bqn(r));
        }, n));
        return t.$ ? r : A2(Vur, bTn(t.a), r);
    }), _ar = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Aar = {
        hY: 250,
        lB: Ut,
        x0: Ut
    }, Car = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(jbn), e, A2(_P, function(n) {
            var r, t, e = n(Aar);
            return rc(x([
                (t = e.lB, t.$ ? h : x([
                    A2(Y_, "signup_page", t.a)
                ])),
                x([
                    A2(bJ, "limit", e.hY)
                ]),
                (r = e.x0, r.$ ? h : x([
                    A2(Y_, "zip", r.a)
                ]))
            ]));
        }(t), rA(function(n) {
            return A2(X_, x([
                "location_distances"
            ]), lL(n));
        }(r))));
    }), Bar = function(n) {
        var r, t = 1 === (r = yqn(n.kq)).$ ? Vt(r.b) : Ut, e = Bx(n.dB), u = yur(n.lB) ? Vt(n.lB) : Ut;
        return b(n, A4(Car, n.gF, e, A2(Aur, u, t), _ar));
    }, Ear = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Dar = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qar = function(n) {
        var r = b(n.ie, n.m7);
        if (3 !== r.a.$ || r.b.$) return Pp;
        var t = r.a.a, e = r.b.a, u = A2(KK, function(n) {
            return Qer(n);
        }, r4n(t)), a = Yer({
            yA: Zer(n.xs.iF),
            m7: Vt(e),
            oA: n.oA,
            zK: u
        });
        return Q6n(n.lB) ? A4(pPn, n.gF, Bx(n.dB), a, Dar) : A4(G6n, n.gF, Bx(n.dB), B9n(t), Ear);
    }, Far = function(n) {
        return n.x0;
    }, Par = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (ln = r.f0).$ ? Pp : V0n(ln.a), c = x([
                        FXn(n2n(u)),
                        _Xn
                    ]), o = m(e, {
                        f0: Ut,
                        m7: Vt(R3n(u))
                    });
                    return v(o, Vu(x([
                        a,
                        qar(o)
                    ])), c);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 0:
                var f = v(r.ao, r.fc, r.hg);
                if (f.c) return v(r, Pp, x([
                    DXn
                ]));
                if (f.a.$ || f.b.$) return v(r, Pp, h);
                var s = f.a.a, l = f.b.a, d = r.dO;
                return d.$ ? par(r) : A2(Zur, r, F = d.a) ? v(e = Hur(m(r, {
                    bn: !1,
                    u3: !0
                })), A6(kar, r.gF, Bx(e.dB), l, Our(s), _x(x([
                    Qur(Vt(F))
                ])), Mur), h) : par(r);
            case 2:
                var p = A2(V6n, n.a, r.cT), $ = p.a, g = p.b, w = p.c, k = w.$ || w.a ? Pp : A2(Nu, iu, _u(Nur));
                return v(m(r, {
                    cT: $
                }), Vu(x([
                    A2(Lp, Pur, g),
                    k
                ])), h);
            case 3:
                var y = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), _ = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, _, y) ? A2(U0n, _, y) : Pp, x([
                    utr
                ]));
            case 4:
                var A = n.a, C = m(r, {
                    e3: A
                });
                if (3 === A.$) {
                    var B = A.a, E = A2(sc, "", A2(nv, Far, rv(B))), D = vu(E) ? r.kq : A2(Iqn, E, uqn), q = A2(KRn, rv(Ae(B)), rv(A2(Rc, aar(r.hZ), B))), F = C.cC.$ ? uC(C.cC) : A2(KRn, C.dO, A2(nv, Jur, A2(nv, function(n) {
                        return A2(aar, r.hZ, n) ? A2(xar, B, n) : Vt(n);
                    }, q))), P = be(B) > 1 ? x([
                        A3(str, A2(Eu, gar, B), A2(sc, "", A2(Fp, Our, q)), !0)
                    ]) : h, z = m(C, {
                        ao: q,
                        bn: 3 === (sn = r.ie).$ && A4(K0n, r.lB, r.DF, n2n(sn.a), r.xs.CS),
                        kq: D,
                        a2: B,
                        dO: F
                    }), j = Bar(z);
                    return v(Z = j.a, Vu(x([
                        j.b,
                        A4(I0n, 5, Z.DF, Z.fL, h)
                    ])), P);
                }
                return v(C, Pp, A2(xA, 1, A));
            case 5:
                var S = n.a;
                n: for(;;)switch(S.$){
                    case 3:
                        return v(m(r, {
                            fr: Vt(S.a),
                            fs: Ut
                        }), Pp, h);
                    case 2:
                        if (5 === S.a.$) {
                            var L = Vt(WWn(x([
                                pA(a6n(S.a.b))
                            ])));
                            return v(m(r, {
                                fs: L
                            }), Pp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, S));
            case 6:
                var M = n.a;
                return be(r.a2) > 0 ? (s = rv(A2(Rc, function(n) {
                    return i(Our(n), M);
                }, r.a2)), v(m(r, {
                    ao: s,
                    bn: aF(F = A2(nv, Jur, s)),
                    kw: Ut,
                    dO: F
                }), Pp, h)) : v(r, Pp, h);
            case 7:
                var N = NLn(n.a), H = N.a, T = N.b, I = T.$ ? b(r.dO, r.bn) : b(Vt(T.a), !1);
                return v(m(r, {
                    bn: I.b,
                    kw: Ut,
                    dO: F = I.a
                }), A2(Lp, Lur, H), h);
            case 8:
                var R = n.a;
                if (e = m(r, {
                    u3: !1
                }), 3 === R.$) {
                    var Z, V = R.a, U = A2(Eu, function(n) {
                        return i(Our(n), Our(V)) ? V : n;
                    }, e.a2), Y = function(n) {
                        var r = n.ao;
                        if (r.$) return v(n, Pp, h);
                        var t = r.a;
                        if (A2(Gur, n.a2, t)) return v(n, Vu(x([
                            A4(H0n, 5, n.DF, n.fL, h),
                            A3(rar, t, n.DF, n.kq)
                        ])), x([
                            DXn
                        ]));
                        var e = A2(uar, n.a2, t);
                        if (e.$) return v(n, Pp, h);
                        var u = e.a, a = A2(N$, Jur(u), Jur(t));
                        return v(m(n, {
                            ao: Vt(u),
                            bn: aF(a),
                            dO: a
                        }), Vu(x([
                            bzn(Our(u)),
                            A3(rar, t, n.DF, n.kq)
                        ])), x([
                            dtr(Our(u))
                        ]));
                    }(m(e, {
                        ao: Vt(V),
                        a2: U
                    }));
                    return v(Z = Y.a, Y.b, Y.c);
                }
                return v(e, Pp, A2(xA, 1, R));
            case 9:
                var Q = n.a;
                if (e = m(r, {
                    hZ: Q
                }), 3 === Q.$) {
                    var O = Q.a, G = (F = A2(war, r.dO, function() {
                        return A2(dar, O, $0n(r.fL));
                    }), function() {
                        var n = r.fc;
                        if (n.$) return Pp;
                        var t = n.a;
                        return A4(sar, r.gF, Bx(r.dB), t, wur);
                    }());
                    return v(m(e, {
                        dO: F
                    }), G, h);
                }
                return v(e, Pp, A2(xA, 1, Q));
            case 10:
                var J = n.a, W = b(r.hZ, J);
                n: for(;;)switch(W.b.$){
                    case 3:
                        if (3 === W.a.$) {
                            var K = W.a, X = (O = K.a, K.b), nn = A2(Eu, yar(W.b.a), O);
                            return v(m(r, {
                                hZ: A2(Zy, nn, X)
                            }), Pp, A2(xA, 1, J));
                        }
                        break n;
                    case 2:
                        if (9 === W.b.a.$) return v(r, Pp, h);
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, J));
            case 11:
                var rn = n.a;
                return e = m(r, {
                    cC: rn
                }), 3 === rn.$ ? v(m(e, {
                    dO: Vt(rn.a)
                }), Pp, h) : v(e, Pp, A2(xA, 1, rn));
            case 12:
                var tn = A2(LLn, n.a, r.kq), en = tn.a, un = tn.b, an = tn.c, cn = m(r, {
                    kq: en
                }), on = function() {
                    if (an.$) return b(cn, Pp);
                    if (an.a.$) {
                        var n = wgn(an.a.a) ? Bar(cn) : b(cn, Pp);
                        return b(n.a, n.b);
                    }
                    var r = an.a.b ? FLn(en) ? Bar(cn) : b(function(n) {
                        var r = n.hZ;
                        if (3 === r.$) {
                            var t = r.b;
                            return m(n, {
                                hZ: A2(Zy, Uur(r.a), t)
                            });
                        }
                        return n;
                    }(cn), Pp) : b(cn, Pp), t = r.b;
                    return b(function(n) {
                        var r = n.dO;
                        return r.$ ? n : A2(Zur, n, r.a) ? Hur(n) : n;
                    }(r.a), t);
                }();
                return k = on.b, v(e = on.a, Vu(x([
                    A2(Lp, Sur, un),
                    k
                ])), h);
            case 13:
                var fn = n.a;
                return 3 === fn.$ ? v(e = m(r, {
                    oA: Vt(fn.a)
                }), qar(e), h) : v(r, Pp, A2(xA, 1, fn));
            default:
                return v(m(r, {
                    A8: n.a
                }), Pp, h);
        }
        var sn, ln;
    }), zar = function(n) {
        return A2(Rc, function(n) {
            return aF(vvn(n));
        }, n);
    }, jar = F2(function(n, r) {
        var t = yqn(r);
        if (1 === t.$) {
            var e = t.b;
            return TE(zar(n)) && wgn(e);
        }
        return !1;
    }), Sar = F2(function(n, r) {
        var t = b(r.cC, r.hZ);
        if (t.a.$ || 3 !== t.b.$) return tB;
        var e = A2(jar, t.b.a, r.kq);
        return A2(zN, x([
            PAn,
            QTn,
            jN(aH)
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(Ck, Sur, A4(rIn, n, e, r.u3, r.kq))
            ]))
        ]));
    }), Lar = function(n) {
        if (n.$) return tB;
        var r = n.a;
        return A2(nk, x([
            Xx("form-error mb-3 mt-0")
        ]), x([
            ld(r)
        ]));
    }, Mar = F2(function(n, r) {
        var t = b(A2(nv, Jur, n.ao), n.bn);
        if (!t.a.$ && t.b) {
            var e = t.a.a, u = A2(Rur, e, r) ? h : x([
                e
            ]);
            return A2(Yt, e, A2(Rc, function(n) {
                return !i(bqn(n), bqn(e));
            }, $(u, r)));
        }
        return r;
    }), Nar = F2(function(n, r) {
        var t = A2(Mar, r, Iur(r));
        return A2(nk, x([
            Xx("mb-8")
        ]), x([
            TE(t) ? A2(Ek, h, x([
                ld("No locations found")
            ])) : A2(Ck, Lur, A2(JHn, n, x([
                DHn(r.u3),
                zHn(t),
                RHn(r.dO)
            ])))
        ]));
    }), Har = F2(function(n, r) {
        return A2(nk, x([
            Hq(xur)
        ]), x([
            A2(Sar, n, r),
            Lar(A2(Fp, n, r.kw)),
            A2(Nar, n, r)
        ]));
    }), Tar = F3(function(n, r, t) {
        var e = b(r.e3, r.ao);
        return 3 !== e.a.$ || e.b.$ ? t : A2(a8n, A5(cur, n, A2(Gur, e.a.a, e.b.a), r.lB, r.DF, r.xs.CS), t);
    }), Iar = F2(function(n, r) {
        return (function() {
            if (Q6n(r.lB)) return c8n(r.fr);
            var n, t = 3 === (n = r.A8).$ ? n.a : h;
            return e8n(W4n(t));
        })()(A2(r8n, r.fs, A2(i8n, r.m7, A2(n8n, r.u3, A2(fur, r.u3, A3(Tar, n, r, h))))));
    }), Rar = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, Pur, A3(l5n, n, A2(Iar, n, r), r.cT))
        ]));
    }), Zar = F2(function(n, r) {
        return A2(Ck, Pur, A3(l5n, n, b5n(A2(Iar, n, r)), r.cT));
    }), Var = F2(function(n, r) {
        var t, e;
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(x2n),
                    rB(oB)
                ]), (t = r.ao, e = "Select location", A2(sc, x([
                    ld(e)
                ]), A2(Fp, function(n) {
                    return x([
                        ld(e + " for "),
                        QE(n)
                    ]);
                }, A2(nv, har, t))))),
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JI(12),
                        bR(8)
                    ]), x([
                        A2(Har, n, r)
                    ])),
                    A2(EN, x([
                        bR(4),
                        KN(x([
                            Xx("hidden md:block")
                        ]))
                    ]), x([
                        A2(Rar, n, r)
                    ]))
                ])),
                A2(Zar, n, r)
            ]))
        ]);
    }), Uar = F2(function(n, r) {
        return {
            gN: function() {
                var t = v(r.ie, r.hZ, r.e3);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;){
                                u: for(;;)switch(t.a.$){
                                    case 1:
                                        return ck;
                                    case 0:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break t;
                                    case 2:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break e;
                                    default:
                                        switch(t.b.$){
                                            case 1:
                                                break n;
                                            case 2:
                                                if (1 === t.c.$) break r;
                                                break u;
                                            default:
                                                switch(t.c.$){
                                                    case 1:
                                                        break r;
                                                    case 2:
                                                        return x([
                                                            p5n(r.dB)
                                                        ]);
                                                    default:
                                                        return A2(Var, n, r);
                                                }
                                        }
                                }
                                return x([
                                    p5n(r.dB)
                                ]);
                            }
                            return x([
                                p5n(r.dB)
                            ]);
                        }
                        return ck;
                    }
                    return ck;
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), Yar = mGn({
        Ar: Dur,
        AQ: qur,
        Db: Fur,
        DZ: function() {
            return Px(x([
                A2(_S, Pur, P3n()),
                wXn(jur),
                etr(zur)
            ]));
        },
        En: Par,
        Et: Uar
    }), Qar = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Oar = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Gar = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Jar = F3(function(n, r, t) {
        return m(t, {
            mz: tXn(n),
            nR: nXn(n),
            n1: b0n(n),
            he: !0,
            lc: r,
            iT: !0
        });
    }), War = F2(function(n, r) {
        return m(r, {
            nD: n
        });
    }), Kar = F5(function(n, r, t, e, u) {
        return A2(War, u, A3(VDn, n, r, A2(Jar, t, e)));
    }), Xar = "members-container", nir = function(n) {
        return "member-" + oe(n);
    }, rir = function(n) {
        var r = n.$ ? 1 : cpn(n.a);
        return nir(r);
    }, tir = F2(function(n, r) {
        var t = FL(r.kB);
        return m(r, {
            kB: lS(m(t, {
                uU: A2(Z$, n, t.uU)
            }))
        });
    }), eir = F4(function(n, r, t, e) {
        var u, a, i, c, o = nQn(r), f = A2(tir, A2(sc, Nmn(n), t.Eq), (u = A5(Kar, rir(Ut), n, r, !0, Ut), a = FL(u.kB), i = lS(m(a, {
            vB: Vt(0)
        })), m(u, {
            kB: i
        }))), s = Bx(n), l = (c = i3n(e.iF)).$ ? Pp : A4(N9n, t.gF, s, c.a, Qar), d = function() {
            var n = b(bXn(t), t.DF);
            if (3 === n.b.$) {
                if (n.a.$) return e = n.b.a, v(x([
                    l
                ]), vc, e);
                var r = n.a.a, e = n.b.a;
                return v(x([
                    A5(R1n, t.gF, s, xGn(o), r, Oar),
                    l
                ]), cP, e);
            }
            return v(x([
                l
            ]), vc, h);
        }(), p = d.a, $ = d.b, g = d.c;
        return b({
            f0: KKn(t),
            gF: t.gF,
            m7: Ut,
            oA: Ut,
            g8: Ut,
            hf: cK,
            hg: t.hg,
            kA: t.kA,
            A8: A2(PY, {
                o: h,
                bi: !1,
                dn: !0,
                cD: Ut,
                h4: f,
                vE: !1,
                a8: yFn(f)
            }, jU),
            e6: x0n(r),
            fc: t.fc,
            ie: cP,
            ii: Ut,
            fd: h,
            dB: n,
            u3: !1,
            fr: Ut,
            fs: Ut,
            vv: !1,
            cM: $,
            cT: A3(l3n, Wx(t.kA), Xar, $3n(n)),
            lB: o,
            fL: r,
            DF: g,
            xs: e
        }, Vu(A2(Yt, A2(Nu, Gar, IF), p)));
    }), uir = F2(function(n, r) {
        var t = n.kA;
        return i(t, r.kA) ? b(r, Pp) : b(m(r, {
            kA: t
        }), Pp);
    }), air = F2(function(n, r) {
        return r;
    }), iir = function(n) {
        return {
            $: 16,
            a: n
        };
    }, cir = function(n) {
        return {
            $: 17,
            a: n
        };
    }, oir = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), fir = function(n) {
        return A2(_S, oir(n.a), Jqn);
    }, sir = {
        $: 3
    }, lir = {
        $: 0
    }, dir = function(n) {
        return {
            $: 10,
            a: n
        };
    }, bir = function(n) {
        return KLn(n.h4) && TE(n.o);
    }, vir = F2(function(n, r) {
        return m(r, {
            bi: n
        });
    }), mir = function(n) {
        return A2(pMn, function(n) {
            return bir(n) ? A2(vir, !0, n) : n;
        }, n);
    }, pir = function(n) {
        return A2(pMn, function(n) {
            return bir(n) ? n : A2(vir, !1, n);
        }, n);
    }, $ir = function(n) {
        return q$n(A2(_Y, function(n) {
            var r = n.b;
            return !TE(r.o) || !bir(r);
        }, n));
    }, hir = function(n) {
        return !$ir(n).$;
    }, gir = function(n) {
        var r = FL(n.kB);
        return r.aj ? r.nG : r.rS;
    }, wir = F2(function(n, r) {
        var t = FL(r.kB);
        return m(r, {
            kB: lS(m(t, {
                rS: n
            }))
        });
    }), xir = F5(function(n, r, t, e, u) {
        return (function() {
            if (r.$) return iu;
            var n = r.a, t = FL(n.h4.kB).uU.AL, e = gir(n.h4);
            return A2(ru, wir(e), tir(t));
        })()(A5(Kar, n, t, e, !1, u));
    }), kir = F5(function(n, r, t, e, u) {
        return {
            o: h,
            bi: !1,
            dn: !0,
            cD: Ut,
            h4: A5(xir, n, r, t, e, u),
            vE: !1,
            a8: ""
        };
    }), yir = F4(function(n, r, t, e) {
        if (hir(e)) return b(pir(e), !1);
        var u = rir(Vt(e));
        return b(A2(PY, A5(kir, u, q$n(e), n, r, t), mir(e)), !0);
    }), _ir = F3(function(n, r, t) {
        return A2(nv, function(n) {
            return Vt(A2(fe, ": ", x([
                n ? "Dependent " + oe(n) : "Owner",
                r
            ])));
        }, A2(Hjn, t, n));
    }), Air = F2(function(n, r) {
        var t = b(A3(_ir, n, "Date Of Birth", r), be(n.o) > 0);
        if (!t.a.$ && t.b) {
            var e = t.a.a;
            return RXn({
                eH: A2(Eu, dM, n.o),
                qv: e
            });
        }
        return Pp;
    }), Cir = function(n) {
        return A2(sO, function(r) {
            return A2(Air, r.b, n);
        }, n);
    }, Bir = F2(function(n, r) {
        return r.wR(n);
    }), Eir = F2(function(n, r) {
        if (9 === n) {
            var t = A2($T, Wx(0), r), e = A2(ZXn, ": ", t), u = e.a, a = e.b, i = su(u) > 0 ? b($(ZDn(n), $(": ", u)), a) : b(ZDn(n), t);
            return b(i.a, A2(yWn, Bir(i.b), r));
        }
        return b(ZDn(n), r);
    }), Dir = function(n) {
        return A2(Eu, function(r) {
            var t = r.c, e = A3(_ir, r.a, r.b, n);
            if (e.$) return Pp;
            var u = e.a;
            return RXn({
                eH: x([
                    t
                ]),
                qv: u
            });
        }, function(n) {
            return rc(A2(sO, function(n) {
                var r, t = n.b;
                return A2(Eu, function(n) {
                    return v(t, n.a, n.b);
                }, (r = A2(FSn, !1, t.h4), rc(A2(Eu, function(n) {
                    return A2(Eu, Eir(n), A2(PH, n, r.kB));
                }, RDn))));
            }, n));
        }(n));
    }, qir = function(n) {
        return n.nD;
    }, Fir = F6(function(n, r, t, e, u, a) {
        var i = b(t, tln(e));
        if (3 === i.a.$ && i.b) {
            var c = n2n(i.a.a);
            return A4(K0n, n, r, c, u.CS) ? mir(a) : a;
        }
        return a;
    }), Pir = {
        DW: d0(300),
        Ek: function(n) {
            return {
                $: 11,
                a: n
            };
        }
    }, zir = function(n) {
        return {
            $: 12,
            a: n
        };
    }, jir = function(n) {
        return A2(Nu, zir, _u(n));
    }, Sir = function(n) {
        return n.rh;
    }, Lir = function(n) {
        return Sir(n.h4) + "-age-errors";
    }, Mir = function(n) {
        return Vt(A2(sc, Lir(n), WLn(n.h4)));
    }, Nir = function(n) {
        var r = function(n) {
            return A2(nv, Mir, $ir(n));
        }(n);
        return r.$ ? Pp : OLn(r.a);
    }, Hir = F2(function(n, r) {
        var t = rv(A2(Rc, function(r) {
            return i(n, r.a);
        }, r.b));
        return t.$ ? Ut : Vt(t.a.b);
    }), Tir = function(n) {
        return n.rh;
    }, Iir = F2(function(n, r) {
        return m(r, {
            kB: lS(A4(IDn, r.rh, r.dB, r.a$, Vt(n)))
        });
    }), Rir = F5(function(n, r, t, e, u) {
        var a = REn(ZEn(u)), i = A2(War, e, A2(Iir, u, A5(Kar, nir(n + 1), r, t, a, e)));
        return {
            o: h,
            bi: !1,
            dn: !1,
            cD: Vt(Tir(u)),
            h4: i,
            vE: !1,
            a8: yFn(i)
        };
    }), Zir = F4(function(n, r, t, e) {
        return zY(A2(he, F2(function(n, u) {
            return A5(Rir, n, r, t, e, u);
        }), n));
    }), Vir = function(n) {
        return i(ZDn(5), n);
    }, Uir = function(n) {
        var r = FL(n.kB);
        return kjn(r.vB);
    }, Yir = F3(function(n, r, t) {
        var e, u = A2(FSn, !1, t);
        return A2(sc, h, A2(Fp, function(n) {
            var e = b(n, r);
            if (9 !== e.a || e.b.$) return A2(PH, n, u.kB);
            var a = e.b.a, i = FL(t.kB), c = A2(O1n, a, i.mk);
            return c.$ ? h : x([
                c.a
            ]);
        }, (e = n, rv(A2(Rc, function(n) {
            return i(ZDn(n), e);
        }, RDn)))));
    }), Qir = F3(function(n, r, t) {
        var e = A2(ZXn, ": ", t), u = e.a, a = e.b, i = su(u) > 0 ? b(u, Vt(a)) : b(a, Ut), c = i.a, o = i.b;
        return A2(sc, h, A2(Fp, function(e) {
            var u, a = lc(n.xs.CS), i = (u = b(Vir(t), TE(r.o))).a && !u.b ? A2(Eu, dM, r.o) : A3(Yir, c, o, r.h4);
            return x([
                Q1n(Vt({
                    eH: i,
                    qv: e,
                    C9: a
                }))
            ]);
        }, A3(_ir, r, t, n.A8)));
    }), Oir = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "members"
        ]), lL(n));
    }), Gir = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(PPn), e, rA(A2(Oir, r, t)));
    }), Jir = F2(function(n, r) {
        return A2(nv, Hjn(n), A2(Hir, r, n));
    }), Wir = F2(function(n, r) {
        var t, e = A2(Jir, n, r);
        return e.$ ? Pp : (t = oe(e.a), A2(itn, "Dependent Removed", x([
            stn(IXn),
            ftn(t)
        ])));
    }), Kir = {
        $: 1
    }, Xir = F2(function(n, r) {
        return !function(n) {
            var r = function(n) {
                return q$n(A2(_Y, function(n) {
                    return n.b.dn;
                }, n));
            }(n);
            return !r.$;
        }(n) && r ? A2(Nu, iu, _u(Kir)) : Pp;
    }), ncr = F2(function(n, r) {
        var t = b(n, tln(r));
        return !(3 !== t.a.$ || !t.b) && ztr(t.a.a);
    }), rcr = function(n) {
        var r = FL(n.kB);
        return r.aj ? r.nF : r.qB;
    }, tcr = F2(function(n, r) {
        var t = UQ(gir(n)), e = UQ(rcr(n)), u = EFn(n), a = UQ(gir(r)), c = UQ(rcr(r)), o = EFn(r);
        return i(c, e) && i(a, t) && i(o, u);
    }), ecr = F2(function(n, r) {
        var t = r.b;
        return A2(SE, !0, A2(sO, function(n) {
            var r = n.b;
            return !i(r, t) && A2(tcr, r.h4, t.h4);
        }, n));
    }), ucr = function(n) {
        return n.mK;
    }, acr = function(n) {
        return n.mL;
    }, icr = function(n) {
        return n.pH;
    }, ccr = function(n) {
        return CY(A2(_Y, function(n) {
            return !Uir(n.b.h4);
        }, n));
    }, ocr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return s(ccr(r), t) > 0;
    }), fcr = function(n) {
        return n.xf;
    }, scr = F5(function(n, r, t, e, u) {
        return cO(u) && r ? x([
            A2(ncr, t, e) ? ucr : acr
        ]) : A2(ocr, n, u) ? x([
            fcr
        ]) : function(n) {
            return A2(SE, !0, A2(sO, ecr(n), n));
        }(u) ? x([
            icr
        ]) : h;
    }), lcr = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), dcr = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), bcr = function(n) {
        return _x(x([
            b("member", zPn(n))
        ]));
    }, vcr = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), PPn, u, A2(vL, bcr(e), rA(A2(Oir, r, t))));
    }), mcr = F6(function(n, r, t, e, u, a) {
        return A4(dC, gQ(n), PPn, a, A2(vL, bcr(u), rA(A2(X_, x([
            e
        ]), A2(Oir, r, t)))));
    }), pcr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, i = QPn(a.h4);
        if (bir(a) && a.dn) {
            var c = a.cD;
            return c.$ ? A5(vcr, n, t, r, i, lcr(u)) : A6(mcr, n, t, r, c.a, i, dcr(u));
        }
        return Pp;
    }), $cr = function(n) {
        var r = n.fc;
        return 2 === r.$ ? Vu(A2(sO, A3(pcr, n.gF, r.a, Bx(n.dB)), n.A8)) : Pp;
    }, hcr = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), gcr = F5(function(n, r, t, e, u) {
        return A4(GZn, gQ(n), ORn, u, rA(A2(X_, x([
            e
        ]), A2(Oir, r, t))));
    }), wcr = F5(function(n, r, t, e, u) {
        if (2 === e.$) {
            var a = e.a;
            return A5(gcr, n, Bx(u), a, t, hcr(r));
        }
        return Pp;
    }), xcr = function(n) {
        return m(n, {
            dn: !1
        });
    }, kcr = F2(function(n, r) {
        return m(r, {
            vE: n
        });
    }), ycr = function(n) {
        var r = rv(n);
        return r.$ ? h : x([
            A2($A, 1, r.a)
        ]);
    }, _cr = F3(function(n, r, t) {
        return A2(zU, t.a, A2(Eu, function(t) {
            var e = t.a, u = t.b;
            return b(e, i(e, r) ? n(u) : u);
        }, t.b));
    }), Acr = F2(function(n, r) {
        return m(r, {
            cD: Vt(n)
        });
    }), Ccr = function(n) {
        return m(n, {
            a8: yFn(n.h4)
        });
    }, Bcr = F2(function(n, r) {
        return A2(sc, !1, A2(Fp, $Gn, A2(wF, function(r) {
            return i(B0n(r), n);
        }, r)));
    }), Ecr = function(n) {
        return A2(Bcr, 3, n);
    }, Dcr = F3(function(n, r, t) {
        if (n.$) return t;
        var e = A3(MFn, n.a, r, t.h4);
        return e.$ ? t : m(t, {
            o: A2(Yt, e.a, t.o)
        });
    }), qcr = F2(function(n, r) {
        return r.tn(n);
    }), Fcr = function(n) {
        return qcr(oe(n));
    }, Pcr = F3(function(n, r, t) {
        if (n.$) return !0;
        var e = n.a;
        return !cO(A2(_Y, function(n) {
            var t = n.b, u = A3(YFn, e, r, t.h4);
            return KLn(t.h4) && LP(u);
        }, t));
    }), zcr = F3(function(n, r, t) {
        var e = b(n, A3(Pcr, n, r, t));
        if (e.a.$ || e.b) return t;
        var u = e.a.a;
        return A2(pMn, function(n) {
            return KLn(n.h4) ? m(n, {
                o: $(n.o, x([
                    Fcr(u)
                ]))
            }) : n;
        }, t);
    }), jcr = F2(function(n, r) {
        var t = A2(TFn, n, r.h4);
        return t.$ ? r : m(r, {
            o: $(r.o, x([
                t.a
            ]))
        });
    }), Scr = function(n) {
        return n.sn;
    }, Lcr = function(n) {
        return n.s9;
    }, Mcr = F3(function(n, r, t) {
        return m(t, {
            o: $(t.o, A2(sc, h, A2(Fp, function(n) {
                return A2(Yt, n, t.o);
            }, A2(nv, function(n) {
                return A3(ZFn, n, r, t.h4);
            }, n))))
        });
    }), Ncr = F3(function(n, r, t) {
        return m(t, {
            o: A2(sc, h, A2(Fp, function(n) {
                return A2(Yt, n, t.o);
            }, A2(nv, function(n) {
                return A3(YFn, n, r, t.h4);
            }, n)))
        });
    }), Hcr = F3(function(n, r, t) {
        return Vt(A3(Mcr, Scr(t), r, A3(Ncr, Lcr(t), r, n)));
    }), Tcr = F3(function(n, r, t) {
        return n.$ ? t : A2(sc, t, A3(Hcr, t, r, n.a));
    }), Icr = F6(function(n, r, t, e, u, a) {
        var i = A2(pMn, function(n) {
            return m(n, {
                o: h
            });
        }, a);
        if (r.$) return i;
        var c = r.a;
        return A3(zcr, t, c, A2(pMn, A2(Dcr, e, c), (Ecr(n) ? iu : pMn(A2(Tcr, u, c)))(A2(pMn, jcr(c), i))));
    }), Rcr = F4(function(n, r, t, e) {
        var u = (function() {
            var r = b(n, xen(t.a8));
            if (r.a.$ || r.a.a.$ || r.b) return iu;
            if (Vir(r.a.a.a)) {
                var u = A2(nv, o6n, e.m7);
                return A5(Icr, e.DF, e.g8, e.e6, A2(nv, qir, u), u);
            }
            return iu;
        })()(A3(cQ, t, r, e.A8));
        return m(e, {
            A8: u
        });
    }), Zcr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Vcr = F4(function(n, r, t, e) {
        var u = Ecr(n) ? x([
            A2(nv, function(n) {
                return A3(YFn, n, r, e.h4);
            }, Lcr(t)),
            A2(nv, function(n) {
                return A3(ZFn, n, r, e.h4);
            }, Scr(t)),
            A2(nv, function(n) {
                return A3(MFn, n, r, e.h4);
            }, qir(t))
        ]) : h;
        return A2(Tp, iu, A2(Yt, A2(TFn, r, e.h4), u));
    }), Ucr = function(n) {
        return Q6n(n.lB) ? function(n) {
            var r = v(i(CY(n.A8), CY(A2(_Y, function(n) {
                return _Fn(n.b.h4);
            }, n.A8))), n.m7, Q6n(n.lB));
            if (r.a && !r.b.$ && r.c) {
                var t = r.b.a, e = o6n(t), u = function() {
                    var r = b(n.g8, e);
                    if (r.a.$ || r.b.$) return n.A8;
                    var t = r.a.a, u = r.b.a;
                    return A2(_Y, function(r) {
                        return TE(A4(Vcr, n.DF, t, u, r.b));
                    }, n.A8);
                }(), a = A2(X$n, function(n) {
                    return _x(function(n) {
                        var r = FL(n.kB);
                        return x([
                            b("name", G$n(yFn(n))),
                            b("dob", WFn(KL(r.bk))),
                            b("relationship", GFn(YPn(r.vB)))
                        ]);
                    }(n.b.h4));
                }, u), c = Yer({
                    yA: Zer(n.xs.iF),
                    m7: Vt(t),
                    oA: n.oA,
                    zK: a
                });
                return A4(pPn, n.gF, Bx(n.dB), c, Zcr);
            }
            return Pp;
        }(n) : Pp;
    }, Ycr = function(n) {
        var r = A2(FSn, !0, n.h4);
        return m(n, {
            h4: r,
            a8: KLn(r) ? yFn(r) : n.a8
        });
    }, Qcr = F2(function(n, r) {
        switch(n.$){
            case 15:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (fn = r.f0).$ ? Pp : V0n(fn.a), c = u.vv, o = Bx(r.dB), f = B9n(u), s = KXn(u), l = x(s ? [
                        FXn(n2n(u)),
                        AXn,
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]);
                    return v(m(e, {
                        f0: Ut,
                        m7: Vt(R3n(u)),
                        hg: s,
                        vv: c
                    }), Vu(x([
                        A4(Gir, r.gF, o, f, dir),
                        a
                    ])), l);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 10:
                var d = n.a;
                if (3 === d.$) {
                    var p = A4(Zir, d.a, r.dB, r.fL, N = A2(nv, qir, A2(nv, o6n, r.m7))), g = r$n(PXn(r.fL)) || A2(ncr, r.ie, d), w = function() {
                        if (g) {
                            var n = A2(Fp, function(n) {
                                return b(n.a, A2(vir, !0, n.b));
                            }, D$n(A2(_Y, function(n) {
                                return Uir(n.b.h4);
                            }, p)));
                            return b(n, function(t) {
                                if (cO(t)) {
                                    var e = A2(Fp, function(n) {
                                        return n.b;
                                    }, n), u = rir(Vt(p));
                                    return A2(PY, A5(kir, u, e, r.dB, r.fL, N), t);
                                }
                                return A6(Fir, r.lB, r.DF, r.ie, d, r.xs, t);
                            }(A2(_Y, function(n) {
                                return !Uir(n.b.h4);
                            }, p)));
                        }
                        return b(Ut, A6(Fir, r.lB, r.DF, r.ie, d, r.xs, p));
                    }();
                    return v(e = m(r, {
                        A8: w.b,
                        ii: w.a,
                        cM: d
                    }), Vu(x([
                        Ucr(e),
                        A4(I0n, 2, e.DF, e.fL, h)
                    ])), h);
                }
                return v(m(r, {
                    cM: d
                }), Pp, A2(xA, 1, d));
            case 9:
                var k = n.a, y = n.b;
                if (e = m(r, {
                    u3: !1
                }), 3 === y.$) {
                    var _ = A3(_cr, xcr, k, A3(_cr, Ccr, k, mir(r.A8)));
                    return v(m(e, {
                        A8: _
                    }), Vu(x([
                        A2(Xir, _, r.u3)
                    ])), h);
                }
                return v(e, Pp, A2(xA, 1, y));
            case 8:
                k = n.a;
                var A = n.b;
                if (3 === A.$) {
                    var C = Tir(A.a);
                    return _ = A3(_cr, xcr, k, A3(_cr, Ccr, k, A3(_cr, Acr(C), k, mir(r.A8)))), v(m(r, {
                        A8: _
                    }), A2(Xir, _, r.u3), h);
                }
                return v(m(r, {
                    u3: !1
                }), Pp, A2(xA, 1, A));
            case 0:
                var B = A2(nv, o6n, r.m7), E = (_ = mir(pir(A6(Icr, r.DF, r.g8, r.e6, N = A2(nv, qir, A2(nv, o6n, r.m7)), B, A2(pMn, Ycr, r.A8)))), A5(scr, w0n(r.fL), a0n(r.lB), r.ie, r.cM, _));
                return e = m(r, {
                    A8: _,
                    fd: E
                }), hir(_) || !TE(E) ? v(e, Vu(A2(nc, Cir(_), A2(Yt, Nir(_), Dir(_)))), ycr(E)) : v(m(e, {
                    u3: !0
                }), Vu(x([
                    $cr(e),
                    A2(Xir, _, !0)
                ])), ycr(E));
            case 1:
                return v(m(r, {
                    u3: !1
                }), A4(H0n, 2, r.DF, r.fL, h), x([
                    DXn
                ]));
            case 2:
                var D = n.b, q = A2(Hir, k = n.a, r.A8);
                if (q.$) return v(r, Pp, h);
                var F = A2(rLn, D, (G = q.a).h4), P = F.a, z = F.b, j = F.c, S = A2(sc, Pp, A2(Fp, function(n) {
                    return 2 === n.$ && Vir(n.a) ? A2(Air, G, r.A8) : Pp;
                }, j)), L = m(G, {
                    dn: !0,
                    h4: P
                }), M = (e = A4(Rcr, j, k, L, r), function() {
                    if (i(j, Vt(ljn))) return Ucr(e);
                    if (j.$) return Pp;
                    var n = j.a;
                    return 2 === n.$ && Vir(n.a) ? Ucr(e) : Pp;
                }());
                return l = A2(sc, h, A2(Fp, function(n) {
                    return 1 === n.$ ? A3(Qir, e, L, n.a) : h;
                }, j)), v(e, Vu(x([
                    A2(Lp, oir(k), z),
                    S,
                    M
                ])), l);
            case 3:
                var N, H = A4(yir, r.dB, r.fL, N = A2(nv, qir, B = A2(nv, o6n, r.m7)), A6(Icr, r.DF, r.g8, r.e6, N, B, A2(pMn, Ycr, r.A8))), T = (_ = H.a, H.b), I = (E = A5(scr, w0n(r.fL), a0n(r.lB), r.ie, r.cM, _), e = m(r, {
                    A8: _,
                    fd: E
                }), b(T, A2(Fp, function(n) {
                    return Sir(n.h4);
                }, A2(nv, function(n) {
                    return Vt(n.b);
                }, rv(Ae(_.b))))));
                if (I.a && !I.b.$) {
                    var R = A3(SX, Pir, I.b.a, e.hf), Z = R.b, V = m(e, {
                        hf: R.a
                    });
                    return v(V, Vu(x([
                        Z,
                        $cr(V),
                        (cn = CY(_) - 1, on = oe(cn), A2(itn, "Dependent Added", x([
                            stn(IXn),
                            ftn(on)
                        ]))),
                        Ucr(V)
                    ])), ycr(E));
                }
                return v(e, Vu(A2(nc, Cir(_), A2(Yt, Nir(_), $(Dir(_), x([
                    Ucr(e)
                ]))))), ycr(E));
            case 11:
                var U = n.a, Y = A4(x0, Pir, h0(jir), U, r.hf);
                return Z = Y.b, v(m(r, {
                    hf: Y.a
                }), Z, h);
            case 12:
                return v(r, OLn(n.a), h);
            case 4:
                k = n.a;
                var Q = n.b;
                return v(e = m(r, {
                    A8: A3(_cr, kcr(!0), k, r.A8)
                }), Vu(x([
                    A2(Wir, r.A8, k),
                    A5(wcr, r.gF, k, Q, r.fc, r.dB)
                ])), h);
            case 5:
                k = n.a;
                var O = n.b;
                return 3 === O.$ ? v(e = m(r, {
                    A8: A2(F$n, k, r.A8)
                }), Ucr(e), h) : v(m(r, {
                    A8: A3(_cr, kcr(!1), k, r.A8)
                }), Pp, A2(xA, 1, O));
            case 6:
                return v(m(r, {
                    A8: A2(F$n, k = n.a, r.A8)
                }), A2(Wir, r.A8, k), h);
            case 7:
                var G;
                return k = n.a, v(e = m(r, {
                    A8: A3(_cr, vir(!(G = n.b).bi), k, mir(r.A8))
                }), $cr(e), h);
            case 13:
                return v(m(r, {
                    g8: Vt(A2(bp, pJ, n.a))
                }), Pp, h);
            case 14:
                var J = n.a;
                n: for(;;)switch(J.$){
                    case 3:
                        return v(m(r, {
                            fr: Vt(J.a),
                            fs: Ut
                        }), Pp, h);
                    case 2:
                        if (5 === J.a.$) {
                            var W = Vt(WWn(x([
                                pA(a6n(J.a.b))
                            ])));
                            return v(m(r, {
                                fs: W
                            }), Pp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, J));
            case 16:
                var K = A2(V6n, D = n.a, r.cT), X = K.a, nn = K.b, rn = K.c, tn = rn.$ ? Pp : A2(Nu, iu, _u(rn.a ? sir : lir));
                return v(m(r, {
                    cT: X
                }), Vu(x([
                    A2(Lp, iir, nn),
                    tn
                ])), h);
            case 17:
                var en = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), un = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, un, en) ? A2(U0n, un, en) : Pp, h);
            default:
                var an = n.a;
                return 3 === an.$ ? v(e = m(r, {
                    oA: Vt(an.a)
                }), Ucr(e), h) : v(r, Pp, A2(xA, 1, an));
        }
        var cn, on, fn;
    }), Ocr = F2(function(n, r) {
        var t = r.b;
        return A2(zU, r.a + 1, A2(Yt, b(n.a, n.b), t));
    }), Gcr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jcr = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), Wcr = function(n) {
        return n.bi ? "collapser-closed" : "collapser-open";
    }, Kcr = F2(function(n, r) {
        return n ? pA(" ") : Uir(r) ? Qdn : l5;
    }), Xcr = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), nor = function(n) {
        return n.vE;
    }, ror = F3(function(n, r, t) {
        var e, u = t.a, a = t.b, i = (e = a.cD).$ ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(u) : A2(Xcr, u, e.a);
        return A2(nk, x([
            Xx("member-wrap--remove")
        ]), x(a.vE ? [
            A2(OC, x([
                wO,
                uF(!0),
                uln(!0)
            ]), x([
                ld(n(nor))
            ]))
        ] : [
            A2(OC, x([
                gC(x([
                    Xx("w-8 text-primary-500")
                ])),
                uF(r),
                EC(i)
            ]), x([
                A2(PE, x([
                    cH(Z2n)
                ]), 7)
            ])),
            A2(OC, x([
                wO,
                uF(r),
                EC(i),
                gC(x([
                    Xx("ml-2 hidden md:inline-block")
                ]))
            ]), x([
                ld(n(tVn))
            ]))
        ]));
    }), tor = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = A2(Eu, dM, c.o);
        return A2(nk, x([
            Xx("member-title")
        ]), x([
            A2(nk, x([
                Xx("flex")
            ]), x([
                A2(nk, x([
                    Xx("flex flex-grow items-center flex-wrap md:flex-nowrap")
                ]), x([
                    A2(nk, x([
                        Xx("flex w-full md:w-auto")
                    ]), x([
                        A2(ak, x([
                            Xx("member-label")
                        ]), x([
                            A2(Ak, h, x([
                                ld(r(A2(Kcr, n, c.h4)))
                            ]))
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("flex flex-grow-0 md:flex-grow")
                    ]), x([
                        A2(oR, !xen(c.a8), A2(ak, x([
                            Xx("member-name md:ml-4")
                        ]), x([
                            QE(c.a8)
                        ])))
                    ]))
                ])),
                A2(nk, x([
                    Xx("flex items-center")
                ]), x([
                    A2(nk, x([
                        Xx("flex")
                    ]), x([
                        A2(oR, !Uir(c.h4) && !u, A3(ror, r, e, b(i, c)))
                    ])),
                    A2(oR, !t, A2(nk, x([
                        Xx("flex")
                    ]), x([
                        A2(nk, x([
                            Xx("collapser")
                        ]), x([
                            A2(nk, x([
                                Xx(Wcr(c))
                            ]), x([
                                A2(OC, x([
                                    zI,
                                    uF(e || !bir(c) && !c.bi),
                                    EC(A2(Jcr, i, c))
                                ]), x([
                                    A2(PE, h, 6)
                                ]))
                            ]))
                        ]))
                    ])))
                ]))
            ])),
            A2(nk, x([
                Hq(Lir(c))
            ]), x([
                A2(ET, r, o)
            ]))
        ]));
    }), eor = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = t && Uir(c.h4);
        return b(c.h4.rh, A2(nk, x([
            Xx("member-wrap"),
            Hq(c.h4.rh)
        ]), x([
            A6(tor, n, r, o, e, u, b(i, c)),
            A2(oR, !c.bi, A2(nk, h, x([
                Dk,
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JI(12),
                        KN(x([
                            Xx("p-3")
                        ]))
                    ]), x([
                        A2(Ck, oir(i), A3(kHn, r, x([
                            qNn(e),
                            Gcr(u)
                        ]), c.h4))
                    ]))
                ]))
            ])))
        ])));
    }), uor = F2(function(n, r) {
        var t, e = (t = r.ii).$ ? r.A8 : A2(Ocr, t.a, r.A8), u = u0n(r.lB);
        return A2(nk, x([
            Hq(Xar)
        ]), x([
            A3(Kq, "div", h, A2(sO, A5(eor, u, n, A2(ncr, r.ie, r.cM), r.u3, r.vv), e))
        ]));
    }), aor = F2(function(n, r) {
        return TE(r) ? tB : A2(nk, x([
            Xx("mt-4")
        ]), x([
            A2(ET, n, A2(Eu, function(n) {
                return eM(n);
            }, r))
        ]));
    }), ior = F2(function(n, r) {
        return A2(nk, x([
            Xx("flex-grow")
        ]), x([
            A2(uor, n, r),
            A2(aor, n, r.fd)
        ]));
    }), cor = F2(function(n, r) {
        return r.sy(n);
    }), oor = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 3,
                a: n
            };
        }(n), r);
    }), sor = F3(function(n, r, t) {
        if (u0n(nQn(r))) return t;
        var e = function() {
            var n = w0n(r);
            if (n.$) return Jd.mg;
            var t = n.a;
            return t > 0 ? cor(oe(t)) : Jd.tt;
        }();
        return A2(oor, n(e), t);
    }), lor = F2(function(n, r) {
        if (n.$) return !0;
        var t = n.a;
        return 0 > s(ccr(r), t);
    }), dor = F2(function(n, r) {
        return A2(Yt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(n), r);
    }), bor = F5(function(n, r, t, e, u) {
        return (e || !A2(lor, r, t) ? iu : dor(n(Jd.l2)))(u);
    }), vor = F2(function(n, r) {
        var t = A2(Bcr, 3, r.DF);
        return (a0n(r.lB) && !t ? c8n(r.fr) : e8n(h))(A2(r8n, r.fs, A2(i8n, r.m7, A5(bor, n, w0n(r.fL), r.A8, r.vv, A3(sor, n, r.fL, A2(n8n, r.u3, A2(fur, r.u3, A2(a8n, A4(B2n, n, r.lB, r.DF, r.xs.CS), h))))))));
    }), mor = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, iir, A3(l5n, n, A2(vor, n, r), r.cT))
        ]));
    }), por = F2(function(n, r) {
        return A2(Ck, iir, A3(l5n, n, b5n(A2(vor, n, r)), r.cT));
    }), $or = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(fO),
                    A2(D2n, 1, x2n),
                    rB(oB)
                ]), x([
                    u0n(r.lB) ? ld(n(Jd.l3)) : ld(n(Jd.l1))
                ])),
                A2(nk, x([
                    Xx("flex flex-grow w-full")
                ]), x([
                    A2(ior, n, r),
                    A2(mor, n, r)
                ])),
                A2(por, n, r)
            ]))
        ]);
    }), hor = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.cM, r.ie);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return x([
                                                p5n(r.dB)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2($or, n, r);
                                    }
                            }
                            return x([
                                p5n(r.dB)
                            ]);
                        }
                        return ck;
                    }
                    return ck;
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), gor = mGn({
        Ar: eir,
        AQ: uir,
        Db: air,
        DZ: function(n) {
            return Px(A2(Yt, A2(_S, iir, P3n()), A2(Yt, wXn(cir), A2(sO, fir, n.A8))));
        },
        En: Qcr,
        Et: hor
    }), wor = function(n) {
        return {
            $: 9,
            a: n
        };
    }, xor = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kor = function(n) {
        return {
            $: 6,
            a: n
        };
    }, yor = "content-container", _or = F4(function(n, r, t, e) {
        var u = nQn(r), a = function() {
            var r = i3n(e.iF);
            if (r.$) return Pp;
            var u = r.a;
            return A4(N9n, t.gF, Bx(n), u, wor);
        }(), i = function() {
            var r = b(bXn(t), t.DF);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, vc, i = r.b.a);
                var e = r.a.a, i = r.b.a;
                return v(x([
                    A5(R1n, t.gF, Bx(n), xGn(u), e, xor),
                    a
                ]), cP, i);
            }
            return v(h, vc, h);
        }(), c = i.a, o = i.b, f = i.c;
        return b({
            f0: KKn(t),
            gF: t.gF,
            oA: Ut,
            g8: Ut,
            hg: t.hg,
            ht: yq,
            kA: t.kA,
            A8: o,
            fc: t.fc,
            ie: o,
            ih: yq,
            ad: h,
            dB: n,
            u3: !1,
            fs: Ut,
            bC: Ut,
            cT: A3(l3n, Wx(t.kA), yor, $3n(n)),
            lB: u,
            i_: cP,
            fL: r,
            DF: f,
            xs: e
        }, Vu(A2(Yt, A2(Nu, kor, IF), c)));
    }), Aor = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Cor = A3(ly, "plan", iy(q1n), uu(function(n) {
        return {
            uC: n
        };
    })), Bor = A2(Pk, Cor, uu(iu)), Eor = F2(function(n, r) {
        return A2(X_, x([
            "signup_page_plans"
        ]), A2(T1n, n, r));
    }), Dor = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(Bor), e, rA(A2(Eor, r, t)));
    }), qor = F2(function(n, r) {
        return i(r.gF, n.gF) ? b(r, Pp) : b(m(r, {
            gF: n.gF,
            kA: n.kA,
            i_: cP
        }), A4(Dor, n.gF, Bx(r.dB), xGn(r.lB), Aor));
    }), For = F2(function(n, r) {
        return r;
    }), Por = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zor = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jor = {
        $: 0
    }, Sor = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Lor = F2(function(n, r) {
        return {
            uC: n,
            fr: r
        };
    }), Mor = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nor = function(n) {
        return n.mr;
    }, Hor = F2(function(n, r) {
        var t = A2(JD, function(r) {
            return 0 > s(Nor(r), n);
        }, E8n(r)), e = t.a;
        return be(t.b) > 0 ? h : e;
    }), Tor = F2(function(n, r) {
        var t, e, u = !(t = Lcr(r)).$ && 0 > s(n, t.a), a = !(e = Scr(r)).$ && s(n, e.a) > 0;
        return !(u || a);
    }), Ior = function(n) {
        return A2(sc, h, A2(Fp, function(r) {
            return A2(Rc, function(r) {
                return !A2(Tor, Nor(r), n.uC);
            }, E8n(r));
        }, n.fr));
    }, Ror = F2(function(n, r) {
        var t, e = !TE(Ior(r));
        return !(t = b(n, r.fr)).a.$ && !t.b.$ && !TE(A2(Hor, t.a.a, t.b.a)) || e;
    }), Zor = F2(function(n, r) {
        var t = x0n(n);
        return A2(ywn, Ror(t), r);
    }), Vor = function(n) {
        return be(A2(Rc, function(n) {
            return LP(n.fr);
        }, n));
    }, Uor = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Yor = function(n) {
        var r = "plan-description-" + n;
        return A2(hc, Uor(n), AX(r));
    }, Qor = function(n) {
        return n.uC;
    }, Oor = F2(function(n, r) {
        return A2(Ror, n, r) ? Ut : Vt(r);
    }), Gor = function(n) {
        var r = x0n(n.fL), t = function() {
            var t = n.ie;
            if (3 === t.$) {
                var e = t.a, u = n2n(e), a = s6n(R3n(e));
                return A4(K0n, n.lB, n.DF, u, n.xs.CS) ? A2(nv, Oor(r), rv(A2(Rc, function(n) {
                    return i(f6n(n.uC), A2(sc, "", a));
                }, n.ad))) : Ut;
            }
            return Ut;
        }(), e = rv(A2(Tp, Oor(r), n.ad));
        return m(n, {
            bC: nTn(x([
                t,
                e
            ]))
        });
    }, Jor = F2(function(n, r) {
        var t = r.qv, e = r.zM, u = r.zL;
        return A2(itn, "Form Field Errored", x([
            stn(n),
            MXn(t),
            LXn(e),
            SXn(u)
        ]));
    }), Wor = (LJ = {
        zL: "One or more members violate the age validation for every plan option.",
        zM: "Signup Disqualified",
        qv: "Invalid Plan Options"
    }, A2(Jor, IXn, LJ)), Kor = F2(function(n, r) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "plan"
        ]), lL(n));
    }), Xor = F5(function(n, r, t, e, u) {
        return A4(dC, gQ(n), q1n, u, A2(vL, function(n) {
            var r;
            return _x(x([
                (r = Vt(n), b("plan", r.$ ? yx : _x(x([
                    b("id", Ax(r.a))
                ]))))
            ]));
        }(e), rA(A2(Kor, r, t))));
    }), nfr = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), rfr = F3(function(n, r, t) {
        return A2(Eu, function(t) {
            return i(f6n(t.uC), f6n(n)) ? A2(Lor, t.uC, Vt(r)) : t;
        }, t);
    }), tfr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, efr = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ufr = F4(function(n, r, t, e) {
        var u, a = _x((u = e, A2(Yt, b("plan", eQn(f6n(t))), u)));
        return A4(pPn, n, r, a, efr(t));
    }), afr = function(n) {
        var r, t = n.ie;
        if (3 === t.$) {
            var e = t.a;
            if (a0n(n.lB)) {
                var u = Bx(n.dB), a = A2(KK, function(n) {
                    return Qer(n);
                }, r4n(e)), i = (r = A3(Uer, "coupon_code", function(n) {
                    return G$n(Ver(n));
                }, n.oA), A2(Yt, b("members", a), r));
                return Vu(A2(Eu, function(r) {
                    return A4(ufr, n.gF, u, r.uC, i);
                }, n.ad));
            }
            return A4(G6n, n.gF, Bx(n.dB), B9n(e), tfr);
        }
        return Pp;
    }, ifr = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (T = r.f0).$ ? Pp : V0n(T.a), i = KXn(u), c = x(i ? [
                        FXn(n2n(u)),
                        AXn,
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]);
                    return v(m(e, {
                        f0: Ut,
                        hg: i
                    }), Vu(x([
                        a,
                        A4(Dor, r.gF, Bx(r.dB), xGn(r.lB), Aor)
                    ])), c);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 8:
                var o = n.a;
                if (e = m(r, {
                    i_: o
                }), 3 === o.$) {
                    var f = m(e, {
                        ad: A2(Eu, function(n) {
                            return A2(Lor, n, Ut);
                        }, wvn(A2(Eu, function(n) {
                            return n.uC;
                        }, o.a)))
                    });
                    return v(f, afr(f), h);
                }
                return v(e, Pp, A2(xA, 1, o));
            case 0:
                var l = r.ie;
                if (3 === l.$) {
                    u = l.a;
                    var d = r.bC;
                    if (d.$) return v(r, Pp, x([
                        A2($A, 1, A2(rM, cSn, Qor))
                    ]));
                    var p = d.a, $ = Bx(r.dB), g = f6n(p.uC), w = B9n(u);
                    return v(m(r, {
                        u3: !0
                    }), A5(Xor, r.gF, $, w, g, Sor), h);
                }
                return v(r, Pp, h);
            case 7:
                var k = n.a;
                return e = m(r, {
                    u3: !1
                }), 3 === k.$ ? v(e, A4(H0n, 3, r.DF, r.fL, h), x([
                    DXn
                ])) : v(e, Pp, A2(xA, 1, k));
            case 2:
                var y = A2(V6n, n.a, r.cT), _ = y.a, A = y.b, C = y.c, B = C.$ || C.a ? Pp : A2(Nu, iu, _u(jor));
                return v(m(r, {
                    cT: _
                }), Vu(x([
                    A2(Lp, Por, A),
                    B
                ])), h);
            case 3:
                var E = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), D = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, D, E) ? A2(U0n, D, E) : Pp, h);
            case 4:
                var q = n.a, F = n.b;
                n: for(;;)switch(F.$){
                    case 3:
                        var P = m(r, {
                            ad: A3(rfr, q, F.a, r.ad),
                            fs: Ut
                        }), z = function() {
                            if (!Vor(P.ad)) {
                                var n = Vu(A2(Eu, Lp(Mor), A2(Eu, Yor, A2(Eu, function(n) {
                                    return f6n(n.uC);
                                }, P.ad))));
                                return v(Gor(P), Vu(x([
                                    A4(I0n, 3, P.DF, P.fL, h),
                                    n
                                ])), A2(Zor, P.fL, P.ad) ? Wor : Pp);
                            }
                            return v(P, Pp, Pp);
                        }();
                        return v(z.a, Vu(x([
                            z.c,
                            z.b
                        ])), h);
                    case 2:
                        if (5 === F.a.$) {
                            var j = Vt(WWn(x([
                                pA(a6n(F.a.b))
                            ])));
                            return v(m(r, {
                                fs: j
                            }), Pp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, F));
            case 5:
                var S = function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                            return b(Pp, Vt(function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(n.a)));
                        case 2:
                            return b(Pp, Vt(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r = n.a)));
                        case 3:
                            var r = n.a, t = n.b;
                            if (t.$) return b(Pp, Ut);
                            var e = t.a, u = s(e.v1.q6, e.jT.q6 + 1) > 0;
                            return b(Pp, Vt(A2(nfr, r, u)));
                        default:
                            return b(Pp, Ut);
                    }
                }(n.a), L = S.a, M = S.b, N = function() {
                    if (M.$) return b(r, Pp);
                    switch(M.a.$){
                        case 0:
                            return b(m(r, {
                                bC: Vt(M.a.a)
                            }), Pp);
                        case 1:
                            return b(m(r, {
                                ht: A2(A2(Cq, n = M.a.a, r.ht) ? mZ : _q, n, r.ht)
                            }), Pp);
                        default:
                            var n, t = M.a, e = t.b, u = A2(e ? _q : mZ, n = t.a, r.ih);
                            return b(m(r, {
                                ht: e ? r.ht : A2(_q, n, r.ht),
                                ih: u
                            }), Pp);
                    }
                }();
                return B = N.b, v(e = N.a, Vu(x([
                    A2(Lp, Mor, L),
                    B
                ])), h);
            case 6:
                return v(m(r, {
                    g8: Vt(A2(bp, pJ, n.a))
                }), Pp, h);
            case 9:
                var H = n.a;
                return 3 === H.$ ? v(e = m(r, {
                    oA: Vt(H.a)
                }), afr(e), h) : v(r, Pp, A2(xA, 1, H));
            default:
                return v(m(r, {
                    A8: n.a
                }), Pp, h);
        }
        var T;
    }), cfr = function(n) {
        var r = A2(Tp, iu, A2(Eu, hnn, A2(se, "=", n)));
        return r.b && r.b.b && !r.b.b.b ? Vt(A2(Y_, r.a, r.b.a)) : Ut;
    }, ofr = function(n) {
        var r = n.iF;
        return r.$ ? h : A2(Tp, cfr, A2(se, "&", r.a));
    }, ffr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, sfr = {
        zn: !1,
        ht: yq,
        e6: Ut,
        ih: yq,
        iz: h,
        dB: Ut,
        jP: Ut,
        xz: Ut
    }, lfr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    zn: n.a
                });
            case 1:
                return m(r, {
                    iz: n.a
                });
            case 2:
                return m(r, {
                    xz: n.a
                });
            case 3:
                return m(r, {
                    e6: Vt(n.a)
                });
            case 4:
                return m(r, {
                    jP: Vt(n.a)
                });
            case 5:
                return m(r, {
                    dB: Vt(n.a)
                });
            case 6:
                return m(r, {
                    ht: n.a
                });
            default:
                return m(r, {
                    ih: n.a
                });
        }
    }), dfr = {
        $: 4
    }, bfr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vfr = function(n) {
        return n.pe;
    }, mfr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pfr = F4(function(n, r, t, e) {
        var u = A2(Cq, n, r), a = !u, i = A2(Cq, n, t), c = "plan-description-" + n;
        if (e.$) return tB;
        var o = e.a;
        return A2(nk, x([
            Xx("plan-quote__description-wrapper")
        ]), x([
            A2(nk, x([
                Hq(c),
                Xx("plan-quote__description rich-text"),
                SC(x([
                    b("plan-quote__description--collapsed", a)
                ]))
            ]), A2(Eu, Ck(yu), BG(o))),
            i ? A2(Tq, x([
                Xx("plan-quote__description-toggle"),
                IC(mfr(n))
            ]), x([
                A2(ak, x([
                    Xx("plan-quote__description-toggle-text")
                ]), x(u ? [
                    ld("See Less "),
                    A2(PE, x([
                        HB,
                        MB("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--up")
                    ]), 6)
                ] : [
                    ld("See More "),
                    A2(PE, x([
                        HB,
                        MB("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--down")
                    ]), 6)
                ]))
            ])) : tB
        ]));
    }), $fr = F2(function(n, r) {
        var t = n.$ ? tB : A2(IN, x([
            LN(n.a)
        ]), x([
            ld("Update added members")
        ]));
        return A2(nk, h, x([
            A2(FI, x([
                $H,
                ok(x([
                    Xx("message-box__content mr-1")
                ]))
            ]), x([
                QE(D8n(r)),
                ld(" cannot be enrolled.")
            ])),
            t
        ]));
    }), hfr = F2(function(n, r) {
        return r.uO(n);
    }), gfr = F3(function(n, r, t) {
        var e = A2(Hor, r, t);
        return be(e) > 0 ? Vt(b(hfr(oe(r)), A2(nk, h, A2(Eu, function(r) {
            return A2($fr, n, r);
        }, e)))) : Ut;
    }), wfr = F3(function(n, r, t) {
        return A2(t.ms, n, r);
    }), xfr = F2(function(n, r) {
        return A2(wfr, oe(n), oe(r));
    }), kfr = F3(function(n, r, t) {
        var e = b(A2(nv, function(n) {
            return 1 > n ? Ut : Vt(n);
        }, r), t);
        return e.a.$ ? e.b.$ ? Ut : Vt(A2(LFn, n, RFn(e.b.a))) : Vt(A2(LFn, n, e.b.$ ? UFn(e.a.a) : A2(xfr, e.a.a, e.b.a)));
    }), yfr = F3(function(n, r, t) {
        var e = Ior(t);
        return be(e) > 0 ? A2(Fp, function(n) {
            return b(n, A2(nk, h, A2(Eu, function(n) {
                return A2($fr, r, n);
            }, e)));
        }, A3(kfr, n, Lcr(t.uC), Scr(t.uC))) : Ut;
    }), _fr = F5(function(n, r, t, e, u) {
        var a, i = x([
            lxn(0)
        ]), c = A3(yfr, r, e, u), o = (a = b(t, u.fr)).a.$ || a.b.$ ? Ut : A3(gfr, e, a.a.a, a.b.a), f = A2(N$, o, c);
        if (f.$) return tB;
        var s = f.a, l = s.a, d = s.b;
        return A2(nk, x([
            Xx("radio-card__row")
        ]), x([
            A2(Ck, yu, A3(wxn, i, Vt(n(l)), d))
        ]));
    }), Afr = F2(function(n, r) {
        var t = r.fr;
        if (t.$) return tB;
        var e = t.a, u = Vt(BMn(e)), a = EMn(e);
        return A2(nk, x([
            Xx("plan-quote__amount")
        ]), x([
            A2(Ck, yu, A7(MV, n, a, !1, u, kF, !1, !1))
        ]));
    }), Cfr = F3(function(n, r, t) {
        var e, u = !A2(Ror, r.e6, t), a = !(e = r.xz).$ && i(f6n(e.a.uC), f6n(t.uC)), c = u ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(t) : dfr;
        return A2(nk, x([
            Xx("radio-card plan-quote"),
            SC(x([
                b("radio-card--selected", a),
                b("radio-card--disabled", !u)
            ])),
            IC(c)
        ]), x([
            A2(nk, x([
                Xx("radio-card__radio")
            ]), x([
                A2(C5, x([
                    qkn(a),
                    D5(A2(pc, bfr, cm(t))),
                    Fkn(r.zn || !u)
                ]), h)
            ])),
            A2(nk, x([
                Xx("radio-card__content")
            ]), x([
                A2(nk, x([
                    Xx("radio-card__row")
                ]), x([
                    A2(nk, x([
                        Xx("plan-quote__name")
                    ]), x([
                        A2(FI, x([
                            nH
                        ]), x([
                            ld(g8n(t.uC))
                        ]))
                    ])),
                    A2(Afr, n, t)
                ])),
                A4(pfr, f6n(t.uC), r.ht, r.ih, vfr(t.uC)),
                A5(_fr, n, r.dB, r.e6, r.jP, t)
            ]))
        ]));
    }), Bfr = F2(function(n, r) {
        var t = A3(de, lfr, sfr, r);
        return A2(nk, x([
            Xx("mb-4")
        ]), A2(Eu, A2(Cfr, n, t), t.iz));
    }), Efr = F2(function(n, r) {
        var t, e = A2(yH, x([
            _A($i({
                wy: xGn(r.lB)
            }))
        ]), ofr(r.xs.CS)), u = A2(Yt, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r.ad), A2(Yt, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r.bC), A2(Yt, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r.u3), A2(Yt, function(n) {
            return {
                $: 4,
                a: n
            };
        }(e), A2(Yt, function(n) {
            return {
                $: 5,
                a: n
            };
        }(r.dB), A2(Yt, function(n) {
            return {
                $: 6,
                a: n
            };
        }(r.ht), A2(Yt, function(n) {
            return {
                $: 7,
                a: n
            };
        }(r.ih), (t = x0n(r.fL)).$ ? h : x([
            ffr(t.a)
        ]))))))));
        return A2(nk, x([
            Xx("flex flex-col flex-grow w-full"),
            Hq(yor)
        ]), x([
            A2(Ck, Mor, A2(Bfr, n, u))
        ]));
    }), Dfr = function(n) {
        return C1n(n);
    }, qfr = F2(function(n, r) {
        var t = a0n(r.lB) && (1 >= be(r.ad) || aF(r.bC)), e = A2(Fp, Dfr, A2(Fp, function(n) {
            return n.uC;
        }, r.bC));
        return (t ? c8n(A2(nv, function(n) {
            return n.fr;
        }, r.bC)) : e8n(W4n(K4n(r.A8))))(A2(r8n, r.fs, A2(i8n, e, A2(n8n, r.u3, A2(fur, r.u3, A2(a8n, A4(B2n, n, r.lB, r.DF, r.xs.CS), h))))));
    }), Ffr = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, Por, A3(l5n, n, A2(qfr, n, r), r.cT))
        ]));
    }), Pfr = F2(function(n, r) {
        return A2(Ck, Por, A3(l5n, n, b5n(A2(qfr, n, r)), r.cT));
    }), zfr = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(x2n),
                    rB(oB)
                ]), x([
                    ld("Select your membership")
                ])),
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JI(12),
                        bR(8)
                    ]), x([
                        A2(Efr, n, r)
                    ])),
                    A2(EN, x([
                        bR(4),
                        KN(x([
                            Xx("hidden md:block")
                        ]))
                    ]), x([
                        A2(Ffr, n, r)
                    ]))
                ])),
                A2(Pfr, n, r)
            ]))
        ]);
    }), jfr = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.ie, Vor(r.ad));
                switch(t.a.$){
                    case 1:
                    default:
                        return ck;
                    case 2:
                        return x([
                            p5n(r.dB)
                        ]);
                    case 3:
                        return t.b ? r.fs.$ ? A2(zfr, n, r) : ck : A2(zfr, n, r);
                }
            }(),
            w5: Ex(r.dB)
        };
    }), Sfr = mGn({
        Ar: _or,
        AQ: qor,
        Db: For,
        DZ: function() {
            return Px(x([
                A2(_S, Por, P3n()),
                wXn(zor)
            ]));
        },
        En: ifr,
        Et: jfr
    }), Lfr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Mfr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Nfr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Hfr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Tfr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ifr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Rfr = function(n) {
        return WDn(KYn(n));
    }, Zfr = F2(function(n, r) {
        return Rfr(n) && !r.$;
    }), Vfr = "content-container", Ufr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yfr = function(n) {
        return n.r_;
    }, Qfr = F2(function(n, r) {
        var t = n.lB, e = function(n) {
            return n.r0;
        }(t) || Yfr(t) || yur(t) ? Vt(XYn(t)) : Ut, u = unn(n.k7), a = enn(n.k7), i = n.A, c = sLn(i), o = fLn(i), f = function() {
            var n = yqn(i.kq);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return fM(t) ? b(Ut, Ut) : b(wqn(r), Vt(t));
            }
            return b(Ut, Ut);
        }(), s = f.a, l = f.b, d = a0n(t) ? b(Ut, Vt(!0)) : b(Vt(!0), Ut);
        return m(r, {
            jX: d.a,
            jY: d.b,
            kq: s,
            hY: a,
            kN: c,
            tg: o,
            ic: u,
            lB: e,
            x0: l
        });
    }), Ofr = function(n) {
        var r = Qfr(n);
        return A4(zqn, n.gF, Bx(n.dB), r, Ufr);
    }, Gfr = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), Lbn, e, rA(A2(X_, x([
            t
        ]), Pqn(r))));
    }), Jfr = F3(function(n, r, t) {
        return m(t, {
            lB: A2(Fp, XYn, n),
            x0: r
        });
    }), Wfr = function(n) {
        return A2(a3n, "practitioner", n);
    }, Kfr = F4(function(n, r, t, e) {
        var u = s7n(e.iF), a = function() {
            if (u.$) return Pp;
            var r = u.a;
            return A4(c7n, t.gF, Bx(n), r, Ifr);
        }(), c = nQn(r), o = rnn, f = bXn(t), s = A4(Eqn, t.gF, Bx(n), A2(Jfr, Vt(c), Ut), Hfr), l = function() {
            var r = i3n(e.iF);
            if (r.$) return Pp;
            var u = r.a;
            return A4(N9n, t.gF, Bx(n), u, Lfr);
        }(), d = function() {
            if (i(u, Ut)) {
                var r = Wfr(e.iF);
                if (r.$) return b(Pp, vc);
                var a = r.a;
                return vu(a) ? b(Pp, vc) : b(A4(Gfr, t.gF, Bx(n), a, Tfr), cP);
            }
            return b(Pp, cP);
        }(), m = d.a, p = d.b, g = function() {
            var r = _ur(e.iF);
            if (r.$) return b(Pp, vc);
            var u = r.a;
            return vu(u) ? b(Pp, vc) : b(A4(kur, t.gF, Bx(n), u, Nfr), cP);
        }(), w = g.b, k = x([
            m,
            g.a,
            l,
            a
        ]), y = function() {
            var r = b(f, t.DF);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, vc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return v(A2(Yt, A5(R1n, t.gF, Bx(n), xGn(c), e, Mfr), k), cP, u);
            }
            return v(h, vc, h);
        }(), _ = y.a, A = y.b, C = y.c, B = {
            f0: KKn(t),
            ao: Ut,
            gF: t.gF,
            m7: Ut,
            oA: Ut,
            hg: t.hg,
            aY: !1,
            kw: Ut,
            A: A2(Nqn, i(w, vc) && r$n(WYn(r)), lqn(n)),
            kA: t.kA,
            cC: w,
            hZ: A,
            a2: h,
            e3: A,
            A8: A,
            fc: f,
            ie: A,
            k7: o,
            dB: n,
            a7: p,
            dD: A3(hqn, n, !0, A2(Zfr, r, p)),
            cJ: A,
            uR: 0,
            u3: !1,
            fr: Ut,
            fs: Ut,
            dO: Ut,
            lv: Ut,
            cQ: Ut,
            cT: A3(l3n, Wx(t.kA), Vfr, $3n(n)),
            lB: c,
            fL: r,
            DF: C,
            xs: e,
            c_: Ut,
            jV: !1,
            d8: !1,
            xI: u
        };
        return b(B, Vu(A2(Yt, Ofr(B), $(_, x([
            s
        ])))));
    }), Xfr = F2(function(n, r) {
        return b(r, Pp);
    }), nsr = F2(function(n, r) {
        return r;
    }), rsr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, tsr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, esr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, usr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, asr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, isr = function(n) {
        return n.bz.$ ? Px(x([
            kY(fY(asr)),
            A2(_S, RLn, Px(x([
                A2(_S, Wbn, BS())
            ])))
        ])) : zx;
    }, csr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, osr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, fsr = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ssr = {
        $: 10
    }, lsr = function(n) {
        return A2(Yur, "practitioner", A2(Fp, czn, n));
    }, dsr = F2(function(n, r) {
        return _x(x([
            lsr(n),
            Qur(r)
        ]));
    }), bsr = F2(function(n, r) {
        return function(n) {
            return r$n(WYn(n));
        }(n) || tln(r);
    }), vsr = F4(function(n, r, t, e) {
        if (A2(bsr, n, t)) {
            var u = b(A2(nv, function(n) {
                return A2(wF, function(r) {
                    return i(bqn(r), n);
                }, e);
            }, sLn(r)), t);
            return 3 === u.b.$ ? x([
                u.b.a
            ]) : u.a.$ ? e : x([
                u.a.a
            ]);
        }
        return h;
    }), msr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return aF(A2(wF, function(n) {
            return i(bqn(n), bqn(t));
        }, r));
    }), psr = F2(function(n, r) {
        return A2(msr, r, A4(vsr, n.fL, n.A, n.cC, K4n(n.hZ)));
    }), $sr = function(n) {
        return n.uP;
    }, hsr = F2(function(n, r) {
        var t = A2(xLn, kLn(n), r);
        return TE(t) ? r : t;
    }), gsr = F2(function(n, r) {
        var t = b(n.cC, n.hZ);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(Rc, function(n) {
                return aF(A2(wF, function(n) {
                    return i(bqn(e), bqn(n));
                }, A2(hsr, n, u)));
            }, r);
        }
        return r;
    }), wsr = F2(function(n, r) {
        var t = n.a7;
        return 3 === t.$ ? x([
            t.a
        ]) : r;
    }), xsr = F2(function(n, r) {
        var t, e = 3 === (t = n.hZ).$ ? t.a : h;
        return A3(dMn, n.A, e, A2(gsr, n, A2(wsr, n, r)));
    }), ksr = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return aF(A2(wF, function(n) {
            return i(czn(n), czn(t));
        }, r));
    }), ysr = F2(function(n, r) {
        return A2(ksr, r, A2(Eu, function(n) {
            return n.uP;
        }, A2(xsr, n, K4n(n.cJ))));
    }), _sr = function(n) {
        return n.u9;
    }, Asr = function(n) {
        return n.vb;
    }, Csr = F2(function(n, r) {
        return i(Vt(r), rv(Ae(n)));
    }), Bsr = F2(function(n, r) {
        return A2(Kur, n, r.kq);
    }), Esr = function(n) {
        if (n.eM) return Ut;
        var r = n.kL;
        return 1 === r.$ ? Vt(r.a.tg) : Ut;
    }, Dsr = F3(function(n, r, t) {
        var e, u, a, i;
        return A4(Xur, Our(n), 6, r, A2(Yt, (i = $sr(n), A2(otn, "Practitioner", A2(sc, "No Preference", A2(Fp, MP, i)))), A2(Yt, nar(Jur(n)), x([
            (a = fLn(e = t), A2(otn, "Filtering by Name", A2(sc, "", a))),
            (u = Esr(e), A2(otn, "Filtering by Location", A2(sc, "", u))),
            Wur(A2(Bsr, Wx(0), e))
        ]))));
    }), qsr = F2(function(n, r) {
        return A2(q7, function(n) {
            return i(n, r);
        }, n);
    }), Fsr = F3(function(n, r, t) {
        return A2(nv, function(t) {
            return A2(yPn, t + r, n);
        }, A2(qsr, n, t));
    }), Psr = F2(function(n, r) {
        return A3(Fsr, n, 1, r);
    }), zsr = F6(function(n, r, t, e, u, a) {
        if (3 === n.$) {
            var c = n.a, o = $sr(a);
            if (o.$) {
                if (3 === e.$) {
                    var f = e.a;
                    return !A4(K0n, nQn(r), t, n2n(f), u.CS) || r$n(KYn(r));
                }
                return !0;
            }
            var s = o.a;
            return LP(A2(wF, function(n) {
                return i(czn(n), czn(s));
            }, c));
        }
        return !0;
    }), jsr = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Ssr = F2(function(n, r) {
        var t = n.fc;
        if (t.$) return Pp;
        var e = t.a, u = _x(x([
            b("online_enrollment_id", Ax(e)),
            b("practitioner_id", Ax(czn(r)))
        ]));
        return A4(bL, gQ(n.gF), w$, jsr, A2(vL, u, rA(A2(X_, x([
            "signup_pages",
            xGn(n.lB),
            "online_enrollments",
            e,
            "join_waitlist"
        ]), lL(Bx(n.dB))))));
    }), Lsr = F3(function(n, r, t) {
        if (n.$) return Pp;
        var e = n.a, u = Wx(0), a = A2(fu, "provider", u(e)) ? "Provider" : "Location", c = A2(sc, a, A2(Fp, function(n) {
            return A2(fe, ": ", x([
                n ? "Dependent " + oe(n) : "Owner",
                a
            ]));
        }, A2(q7, function(n) {
            return i(n, r);
        }, t)));
        return RXn({
            eH: x([
                eM(e)
            ]),
            qv: c
        });
    }), Msr = function(n) {
        return A3(Cer, Our(n), har(n), $ar(n));
    }, Nsr = function(n) {
        return n.uP;
    }, Hsr = F2(function(n, r) {
        return A2(nv, function(n) {
            return A2(wF, function(r) {
                return i(czn(r), n);
            }, r);
        }, n);
    }), Tsr = F2(function(n, r) {
        return A3(Fsr, n, -1, r);
    }), Isr = F3(function(n, r, t) {
        return A2(bsr, n, r) && 1 === be(t) ? rv(t) : Ut;
    }), Rsr = function(n) {
        var r, t = Bx(n.dB), e = yur(n.lB) || Yfr(n.lB) ? Vt(n.lB) : Ut, u = 1 === (r = yqn(n.A.kq)).$ ? Vt(r.b) : Ut;
        return A4(Eqn, n.gF, t, A2(Jfr, e, u), Hfr);
    }, Zsr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Vsr = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Usr = function(n) {
        var r = b(n.ie, n.m7);
        if (3 !== r.a.$ || r.b.$) return Pp;
        var t = r.a.a, e = r.b.a, u = A2(KK, function(n) {
            return Qer(n);
        }, r4n(t)), a = Yer({
            yA: Zer(n.xs.iF),
            m7: Vt(e),
            oA: n.oA,
            zK: u
        });
        return Q6n(n.lB) ? A4(pPn, n.gF, Bx(n.dB), a, Vsr) : A4(G6n, n.gF, Bx(n.dB), B9n(t), Zsr);
    }, Ysr = F2(function(n, r) {
        switch(n.$){
            case 5:
                var t = n.a, e = m(r, {
                    ie: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (_n = r.f0).$ ? Pp : V0n(_n.a), c = KXn(u), o = m(e, {
                        f0: Ut,
                        m7: Vt(R3n(u)),
                        hg: c
                    }), f = x(c ? [
                        FXn(n2n(u)),
                        AXn,
                        _Xn
                    ] : [
                        FXn(n2n(u)),
                        _Xn
                    ]);
                    return v(o, Vu(x([
                        a,
                        Usr(o)
                    ])), f);
                }
                return v(e, Pp, A2(xA, 1, t));
            case 0:
                var s = n.a;
                if (3 === s.$) {
                    var l = A2(sc, 0, A2(nv, pu, A2(Wu, "x-total-count", s.b))), d = A2(war, r.cQ, function() {
                        return A2(Hsr, g0n(r.fL), K4n(s));
                    }), p = A2(vnn, l, r.k7), $ = function() {
                        var n = b(r.fc, r.cJ);
                        if (n.a.$ || 1 !== n.b.$) return Pp;
                        var t = n.a.a;
                        return A4(sar, r.gF, Bx(r.dB), t, osr);
                    }();
                    return v(m(r, {
                        k7: p,
                        cJ: s,
                        cQ: d
                    }), $, h);
                }
                return v(r, Pp, A2(xA, 1, s));
            case 1:
                return v(e = m(r, {
                    k7: p = A2(bnn, n.a, r.k7)
                }), Ofr(e), h);
            case 2:
                var g = n.a;
                return e = m(r, {
                    a7: g
                }), 3 === g.$ ? v(m(e, {
                    cQ: Vt(g.a)
                }), Pp, h) : v(e, Pp, A2(xA, 1, g));
            case 3:
                var w = n.a;
                if (e = m(r, {
                    hZ: w
                }), 3 === w.$) {
                    var k = zar(w.a);
                    return v(m(e, {
                        dO: J = A2(war, r.dO, function() {
                            return A2(dar, k, $0n(r.fL));
                        }),
                        lv: A2(Fp, bqn, J)
                    }), Pp, h);
                }
                return v(e, Pp, A2(xA, 1, w));
            case 4:
                var y = n.a;
                if (e = m(r, {
                    cC: y
                }), 3 === y.$) {
                    var _ = y.a;
                    return v(m(e, {
                        dO: Vt(_),
                        lv: Vt(bqn(_))
                    }), Pp, h);
                }
                return v(e, Pp, A2(xA, 1, y));
            case 6:
                var A = A2(V6n, n.a, r.cT), C = A.a, B = A.b, E = A.c, D = E.$ || E.a ? Pp : A2(Nu, iu, _u(ssr));
                return v(m(r, {
                    cT: C
                }), Vu(x([
                    A2(Lp, tsr, B),
                    D
                ])), h);
            case 10:
                var q = b(r.ao, r.fc);
                if (q.a.$ || q.b.$) return v(r, Pp, h);
                var F = q.a.a, P = q.b.a, z = 3 === (yn = r.hZ).$ ? m(r, {
                    dO: A2(N$, r.dO, A3(Isr, r.fL, r.cC, A4(vsr, r.fL, r.A, r.cC, yn.a)))
                }) : r, j = function(n) {
                    var r = A2(nv, $sr, n.ao), t = function() {
                        var t = v(r, n.cQ, n.cJ);
                        if (t.a.$ || t.b.$ || 3 !== t.c.$) return !1;
                        var e = t.b.a, u = t.c.a;
                        return i(czn(t.a.a), czn(e)) && A2(ksr, r, u);
                    }(), e = LP(n.cQ) ? Rfr(n.fL) ? Ut : Vt(Asr) : A2(ysr, n, n.cQ) || t || tln(n.a7) && tln(n.cC) ? Ut : Vt(_sr), u = A2(nv, Jur, n.ao), a = function() {
                        var r = v(u, n.dO, n.hZ);
                        if (r.a.$ || r.b.$ || 3 !== r.c.$) return !1;
                        var t = r.b.a, e = r.c.a;
                        return i(bqn(r.a.a), bqn(t)) && A2(msr, u, e);
                    }(), c = A2(bsr, n.fL, n.cC) ? LP(n.dO) ? Vt(_D) : A2(psr, n, n.dO) || a ? Ut : Vt(xD) : Ut;
                    return A2(N$, e, c);
                }(z);
                if (LP(j)) return v(e = m(z, {
                    aY: !1,
                    kw: j,
                    u3: !0
                }), A6(kar, r.gF, Bx(e.dB), P, Our(F), A2(dsr, e.cQ, e.dO), csr), h);
                var S = OLn(A2(sc, Vfr, Vt(aTn(r.cQ))));
                return v(m(r, {
                    kw: j
                }), Vu(x([
                    S,
                    A3(Lsr, j, F, r.a2)
                ])), h);
            case 11:
                var L = n.a;
                if (e = m(r, {
                    u3: !1
                }), 3 === L.$) {
                    var M = L.a, N = A2(Eu, function(n) {
                        return i(Our(n), Our(M)) ? M : n;
                    }, e.a2), H = function(n) {
                        var r = n.ao;
                        if (r.$) return v(n, Pp, h);
                        var t = r.a;
                        if (A2(Csr, n.a2, t)) return v(n, Vu(x([
                            A4(H0n, 6, n.DF, n.fL, h),
                            A3(Dsr, t, n.DF, n.A)
                        ])), x([
                            DXn
                        ]));
                        var e = A2(Psr, n.a2, t);
                        if (e.$) return v(n, Pp, h);
                        var u = e.a, a = function() {
                            var r = n.ie;
                            if (3 === r.$) {
                                var e = A4(K0n, n.lB, n.DF, n2n(r.a), n.xs.CS);
                                return b(e && Rfr(n.fL) ? $sr(u) : A2(N$, $sr(u), $sr(t)), A2(bsr, n.fL, n.cC) ? e ? Jur(u) : A2(N$, Jur(u), Jur(t)) : Ut);
                            }
                            return b(Ut, Ut);
                        }(), i = a.a, c = a.b;
                        return v(m(n, {
                            ao: Vt(u),
                            aY: aF($sr(u)),
                            dO: c,
                            lv: A2(Fp, bqn, c),
                            cQ: i
                        }), Vu(x([
                            bzn(Our(u)),
                            A3(Dsr, t, n.DF, n.A)
                        ])), x([
                            dtr(Our(u))
                        ]));
                    }(m(e, {
                        ao: Vt(M),
                        a2: N
                    }));
                    return v(cn = H.a, H.b, f = H.c);
                }
                return v(e, Pp, A2(xA, 1, L));
            case 7:
                var T = A2(sc, Uu, A2(nv, function(n) {
                    return fc(n);
                }, ku(n.a))), I = A2(sc, Uu, fc(r.xs.CS));
                return v(r, A4(U1n, r.lB, r.DF, I, T) ? A2(U0n, I, T) : Pp, x([
                    utr
                ]));
            case 8:
                var R = n.a, Z = m(r, {
                    e3: R
                });
                if (3 === R.$) {
                    var V = R.a, U = A2(nv, Far, rv(V)), Y = A5(zsr, r.cJ, r.fL, r.DF, r.ie, r.xs), Q = yur(r.lB) || Yfr(r.lB) ? Vt(r.lB) : Ut, O = (xn = v(r.cC, r.a7, U)).a.$ || xn.b.$ || xn.c.$ ? r.A : A2(Mqn, A2(Iqn, xn.c.a, uqn), r.A), G = A2(KRn, rv(Ae(V)), rv(A2(Rc, Y, V))), J = A2(bsr, r.fL, r.cC) ? Z.cC.$ ? uC(Z.cC) : A2(KRn, Z.dO, A2(nv, Jur, A2(nv, function(n) {
                        return Y(n) ? A2(Tsr, V, n) : Vt(n);
                    }, G))) : Ut, W = (d = Z.a7.$ ? uC(Z.a7) : A2(KRn, Z.cQ, A2(nv, $sr, A2(nv, function(n) {
                        return Y(n) ? A2(Tsr, V, n) : Vt(n);
                    }, G))), A4(Eqn, r.gF, Bx(r.dB), A2(Jfr, Q, U), Hfr)), K = be(V) > 1 ? x([
                        A3(str, A2(Eu, Msr, V), A2(sc, "", A2(Fp, Our, G)), !0)
                    ]) : h, X = m(Z, {
                        ao: G,
                        aY: 3 === (kn = r.ie).$ && A4(K0n, r.lB, r.DF, n2n(kn.a), r.xs.CS),
                        A: O,
                        a2: V,
                        dO: J,
                        lv: A2(Fp, bqn, J),
                        cQ: d
                    }), nn = Ofr(X);
                    return v(X, Vu(x([
                        A4(I0n, 6, X.DF, X.fL, h),
                        W,
                        nn
                    ])), K);
                }
                return v(Z, Pp, A2(xA, 1, R));
            case 9:
                var rn = n.a;
                return be(r.a2) > 0 ? (F = rv(A2(Rc, function(n) {
                    return i(Our(n), rn);
                }, r.a2)), J = A2(bsr, r.fL, r.cC) ? A2(nv, Jur, F) : Ut, v(m(r, {
                    ao: F,
                    aY: aF(d = A2(nv, $sr, F)),
                    kw: Ut,
                    dO: J,
                    lv: A2(Fp, bqn, J),
                    cQ: d
                }), Pp, h)) : v(r, Pp, h);
            case 12:
                var tn = A2(VLn, n.a, r.dD), en = tn.b, un = tn.c, an = m(r, {
                    kw: Ut,
                    dD: tn.a
                }), cn = function() {
                    if (un.$) return an;
                    switch(un.a.$){
                        case 0:
                            var n = un.a.a, t = function() {
                                var t = b(r.hZ, A2(bsr, r.fL, r.cC));
                                if (3 === t.a.$ && t.b) {
                                    var e = t.a.a, u = A2(yLn, Vt(n), A4(vsr, r.fL, r.A, r.cC, e)), a = FLn(r.A.kq) ? n.kL : Ut;
                                    return A2(N$, a, A3(Isr, r.fL, r.cC, u));
                                }
                                return Ut;
                            }();
                            return m(an, {
                                aY: !1,
                                dO: t,
                                lv: A2(Fp, bqn, t),
                                cQ: Vt(n.uP)
                            });
                        case 1:
                            return t = 3 === (u = b(r.hZ, A2(bsr, r.fL, r.cC))).a.$ && u.b ? A3(Isr, r.fL, r.cC, A4(vsr, r.fL, r.A, r.cC, u.a.a)) : Ut, m(an, {
                                aY: !1,
                                dO: t,
                                lv: A2(Fp, bqn, t),
                                cQ: Ut
                            });
                        case 2:
                            var e = un.a.a;
                            return m(an, {
                                dO: Vt(e),
                                lv: Vt(bqn(e))
                            });
                        default:
                            return m(an, {
                                d8: !0
                            });
                    }
                    var u;
                }(), on = un.$ || 3 !== un.a.$ ? Pp : A2(Ssr, cn, un.a.a);
                return v(cn, Vu(x([
                    A2(Lp, rsr, en),
                    on
                ])), h);
            case 13:
                var fn = n.a;
                n: for(;;)switch(fn.$){
                    case 3:
                        return v(m(r, {
                            fr: Vt(fn.a),
                            fs: Ut
                        }), Pp, A2(xA, 1, fn));
                    case 2:
                        if (5 === fn.a.$) {
                            var sn = Vt(WWn(x([
                                pA(a6n(fn.a.b))
                            ])));
                            return v(m(r, {
                                fs: sn
                            }), Pp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Pp, A2(xA, 1, fn));
            case 14:
                var ln = n.a;
                return 3 === ln.$ ? v(e = m(r, {
                    oA: Vt(ln.a)
                }), Usr(e), h) : v(r, Pp, A2(xA, 1, ln));
            case 15:
                var dn = A2(MLn, n.a, r.A), bn = dn.b, vn = dn.c, mn = m(r, {
                    A: dn.a
                }), pn = function() {
                    if (vn.$) return b(mn, Pp);
                    var n = vn.a, r = m(mn, {
                        aY: !1
                    });
                    switch(n.$){
                        case 1:
                            var t = n.b, e = m(r, {
                                k7: rnn
                            });
                            return b(t ? function(n) {
                                var r = n.hZ;
                                if (3 === r.$) {
                                    var t = r.b;
                                    return m(n, {
                                        hZ: A2(Zy, Uur(r.a), t)
                                    });
                                }
                                return n;
                            }(r) : r, Ofr(e));
                        case 2:
                            return (t = n.b) ? b(e = m(r, {
                                k7: rnn
                            }), Ofr(e)) : b(r, Pp);
                        case 3:
                            return n.b ? b(e = m(r, {
                                k7: rnn
                            }), Vu(x([
                                Ofr(e),
                                Rsr(e)
                            ]))) : b(r, Pp);
                        default:
                            return b(e = m(r, {
                                k7: rnn
                            }), Ofr(e));
                    }
                }();
                return D = pn.b, v(e = pn.a, Vu(x([
                    A2(Lp, fsr, bn),
                    D
                ])), h);
            case 16:
                return v(m(r, {
                    A8: n.a
                }), Pp, h);
            case 17:
                return v(m(r, 3 === ($n = n.a).$ ? {
                    jV: !0,
                    d8: !1
                } : {
                    d8: !1
                }), Pp, h);
            default:
                var $n;
                if (3 === ($n = n.a).$) {
                    var hn = $n.a, gn = A2(Fp, Znr, Gnr(hn));
                    if (gn.$) return v(m(r, {
                        c_: Vt(hn)
                    }), A4(Gfr, r.gF, Bx(r.dB), h0n(Nsr(hn)), Tfr), h);
                    var wn = gn.a;
                    return v(m(r, {
                        c_: Vt(hn)
                    }), Vu(x([
                        A4(Gfr, r.gF, Bx(r.dB), h0n(Nsr(hn)), Tfr),
                        A5(R1n, r.gF, Bx(r.dB), xGn(r.lB), wn, Mfr)
                    ])), x([
                        z7n(wn)
                    ]));
                }
                return v(m(r, {
                    a7: vc
                }), Pp, h);
        }
        var xn, kn, yn, _n;
    }), Qsr = function(n) {
        return n.qF;
    }, Osr = function(n) {
        return n.u8;
    }, Gsr = function(n) {
        return n.vd;
    }, Jsr = F3(function(n, r, t) {
        var e = r$n(WYn(r)) ? n(Osr) : n(Gsr);
        return A2(sc, x([
            ld(e)
        ]), A2(Fp, function(r) {
            return x([
                ld(e + " " + n(Qsr) + " "),
                QE(r)
            ]);
        }, A2(nv, har, t)));
    }), Wsr = F2(function(n, r) {
        if (r.$) return tB;
        var t = r.a;
        return A2(nk, x([
            Xx("form-error mb-3 mt-0")
        ]), x([
            ld(n(t))
        ]));
    }), Ksr = F2(function(n, r) {
        var t = r.u3, e = r.cC, u = r.A;
        if (r.a7.$) return tB;
        var a = function() {
            var n = r.hZ;
            if (3 === n.$) {
                var t = n.a;
                return 3 === e.$ ? x([
                    e.a
                ]) : t;
            }
            return h;
        }();
        return A2(Ck, fsr, A4(eIn, n, t, a, u));
    }), Xsr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, nlr = F4(function(n, r, t, e) {
        var u = A2(Fp, A2(lMn, e.A, t), e.cQ), a = A2(xsr, e, r), c = A4(vsr, e.fL, e.A, e.cC, t), o = TE(c) ? Ut : e.dO;
        return A2(nk, x([
            Xx("mb-8")
        ]), x([
            TE(a) && !Rfr(e.fL) ? A2(Ek, h, x([
                ld("No providers found")
            ])) : A2(Ck, rsr, A3(UTn, n, x([
                qHn(e.u3),
                IHn(u),
                NHn(a),
                HHn(o),
                THn(e.lv),
                jHn(c),
                PHn(aF(e.kw)),
                FHn(e.aY),
                MHn(A2(nv, $ar, e.ao)),
                Xsr(!i(e.c_, Ut))
            ]), e.dD))
        ]));
    }), rlr = function(n) {
        var r = Wx(n.kA), t = A2(sc, "this provider", A2(Fp, MP, n.cQ)), e = n.c_;
        if (e.$) return n.d8 ? A2(nk, x([
            Xx("bg-blue-50 border border-blue-200 text-blue-800 rounded-md p-4 mb-4")
        ]), x([
            A2(Ek, h, x([
                ld(r(DTn) + " " + t + " " + r(qTn))
            ]))
        ])) : n.jV ? A2(nk, x([
            Xx("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), x([
            A2(Ek, x([
                O0
            ]), x([
                ld(r(gTn))
            ])),
            A2(Ek, h, x([
                ld(r(wTn) + " " + t + ".")
            ]))
        ])) : tB;
        var u = e.a;
        return A2(nk, x([
            Xx("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), x([
            A2(Ek, x([
                O0
            ]), x([
                ld(r(BTn))
            ])),
            A2(Ek, h, x([
                ld(r(CTn) + " " + Ucn(Nsr(u)) + ".")
            ]))
        ]));
    }, tlr = F2(function(n, r) {
        var t = b(r.cJ, r.hZ);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(nk, x([
                Hq(Vfr)
            ]), x([
                A2(Ksr, n, r),
                A2(Wsr, n, r.kw),
                rlr(r),
                A4(nlr, n, e, u, r)
            ]));
        }
        return A2(nk, h, ck);
    }), elr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ulr = F3(function(n, r, t) {
        var e = b(r.e3, r.ao);
        return 3 !== e.a.$ || e.b.$ ? t : A2(a8n, A5(cur, n, A2(Csr, e.a.a, e.b.a), r.lB, r.DF, r.xs.CS), t);
    }), alr = F2(function(n, r) {
        return (function() {
            if (Q6n(r.lB)) return c8n(r.fr);
            var n, t = 3 === (n = r.A8).$ ? n.a : h;
            return e8n(W4n(t));
        })()(A2(r8n, r.fs, A2(i8n, r.m7, A2(n8n, r.u3 || function(n) {
            return !!i(n.c_, Ut) && A2(sc, !1, A2(Fp, function(n) {
                return "full_waitlisting" === eMn(n);
            }, n.cQ));
        }(r), A2(fur, r.u3, A3(ulr, n, r, h))))));
    }), ilr = F2(function(n, r) {
        return A2(nk, x([
            Xx("hidden md:block")
        ]), x([
            A2(Ck, tsr, A3(l5n, n, A2(alr, n, r), r.cT))
        ]));
    }), clr = F2(function(n, r) {
        return A2(Ck, tsr, A3(l5n, n, b5n(A2(alr, n, r)), r.cT));
    }), olr = F2(function(n, r) {
        var t;
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(yC, x([
                    SV,
                    _H(x2n),
                    rB(oB)
                ]), A3(Jsr, n, r.fL, r.ao)),
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JI(12),
                        bR(8)
                    ]), x([
                        A2(tlr, n, r),
                        (t = r.k7, A2(Ck, elr, A2(Unn, h, t)))
                    ])),
                    A2(EN, x([
                        bR(4),
                        KN(x([
                            Xx("hidden md:block")
                        ]))
                    ]), x([
                        A2(ilr, n, r)
                    ]))
                ])),
                A2(clr, n, r)
            ]))
        ]);
    }), flr = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.cJ, r.ie);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return x([
                                                p5n(r.dB)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(olr, n, r);
                                    }
                            }
                            return x([
                                p5n(r.dB)
                            ]);
                        }
                        return ck;
                    }
                    return ck;
                }
                return ck;
            }(),
            w5: Ex(r.dB)
        };
    }), slr = mGn({
        Ar: Kfr,
        AQ: Xfr,
        Db: nsr,
        DZ: function(n) {
            return Px(x([
                A2(_S, tsr, P3n()),
                wXn(usr),
                etr(esr),
                A2(_S, rsr, isr(n.dD))
            ]));
        },
        En: Ysr,
        Et: flr
    }), llr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, dlr = F2(function(n, r) {
        return {
            fk: r,
            dB: n,
            u3: !1
        };
    }), blr = F6(function(n, r, t, e, u, a) {
        return {
            mj: a,
            pe: t,
            rh: n,
            tg: r,
            wU: u,
            w5: e
        };
    }), vlr = F6(function(n, r, t, e, u, a) {
        return {
            jZ: a,
            rh: n,
            tg: r,
            wj: t,
            w$: e,
            xs: u
        };
    }), mlr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, plr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $lr = F6(function(n, r, t, e, u, a) {
        return {
            oW: u,
            o7: a,
            rh: n,
            rG: t,
            tg: r,
            v_: e
        };
    }), hlr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), glr = A3(ly, "url", C$, uu(function(n) {
        return {
            xs: n
        };
    })), wlr = A2(dD, 0, A2(Pk, glr, uu(hlr))), xlr = A3(ly, "default_mce_signup_page", iy(wlr), A3(ly, "custom_logo_url", iy(C$), A3(ly, "sandbox", jk, A3(ly, "is_mce", jk, A3(ly, "name", C$, A3(ly, "id", C$, uu($lr))))))), klr = A2(Pk, xlr, uu(iu)), ylr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _lr = A3(ly, "logo_url", iy(C$), uu(function(n) {
        return {
            sd: n
        };
    })), Alr = A2(dD, 0, A2(Pk, _lr, uu(ylr))), Clr = P$(x([
        A2(tu, plr, klr),
        A2(tu, mlr, Alr)
    ])), Blr = A2(Pk, Clr, uu(iu)), Elr = A3(ly, "addable", Blr, A3(ly, "url", iy(C$), A3(ly, "tagline", iy(C$), A3(ly, "show_email_button", jk, A3(ly, "name", C$, A3(ly, "id", C$, uu(vlr))))))), Dlr = A2(Pk, Elr, uu(iu)), qlr = A3(ly, "addons", vy(Dlr), A3(ly, "subtitle", C$, A3(ly, "title", C$, A3(ly, "description", C$, A3(ly, "name", C$, A3(ly, "id", C$, uu(blr))))))), Flr = A2(Pk, qlr, uu(iu)), Plr = F2(function(n, r) {
        return A2(X_, x([
            "addon_categories"
        ]), A2(T1n, n, r));
    }), zlr = F4(function(n, r, t, e) {
        return A4(W_, gQ(n), vy(Flr), e, rA(A2(Plr, r, t)));
    }), jlr = F4(function(n, r, t, e) {
        var u, a, i = nQn(r);
        return b({
            ea: cP,
            gF: t.gF,
            kA: t.kA,
            fc: t.fc,
            dB: n,
            u3: !1,
            vw: (a = e.iF, A2(a3n, "referred_token", a)),
            cO: Ut,
            lB: i,
            fL: r,
            fR: A2(dlr, n, (u = r, {
                ld: u.ld,
                le: u.le,
                lf: u.lf,
                lA: u.lA
            })),
            xs: e
        }, A4(zlr, t.gF, Bx(n), xGn(i), llr));
    }), Slr = F2(function(n, r) {
        return b(r, Pp);
    }), Llr = F2(function(n, r) {
        return r;
    }), Mlr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Nlr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Hlr = F2(function(n, r) {
        return $(function(n) {
            return A2(fu, "authorization is required", n) ? "Email cannot be sent because you did not accept the ePHI waiver. Please contact practice at " : "Email cannot be sent. Please contact practice at ";
        }(r), $(function(n) {
            var r = qB(n);
            return r.$ ? "" : wB(r.a);
        }(n), function(n) {
            var r = xx(n);
            if (r.$) return "";
            var t = r.a;
            return qB(n).$ ? t : " or " + t;
        }(n)));
    }), Tlr = function(n) {
        return n.o7;
    }, Ilr = F3(function(n, r, t) {
        return A2(X_, x([
            "online_enrollments",
            r,
            "addons",
            t,
            "notify"
        ]), lL(n));
    }), Rlr = F5(function(n, r, t, e, u) {
        return A4(bL, gQ(n), ORn, u, rA(A3(Ilr, r, t, e)));
    }), Zlr = A2($A, 1, QGn), Vlr = A2($A, 3, OGn), Ulr = function(n) {
        return A2(nv, hnn, n.b.xs);
    }, Ylr = F2(function(n, r) {
        if (r.$) {
            var t = Ulr(n);
            return t.$ ? ED : I9n(t.a);
        }
        return I9n(r.a);
    }), Qlr = F2(function(n, r) {
        return A2(Ylr, n, r.lf);
    }), Olr = F2(function(n, r) {
        return b(m(r, {
            u3: !0
        }), A2(Qlr, r.dB, r.fk));
    }), Glr = function(n) {
        return n.a.xs;
    }, Jlr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = (a = n.a).xs, e = a.jZ, u = function(n) {
                    return !n.$ && aFn(n.a);
                }(e) && LP(t) ? A2(Fp, function(n) {
                    var t = r.vw;
                    return t.$ ? n : A2(VN, n, x([
                        A2(Y_, "token", t.a)
                    ]));
                }, A2(Fp, Glr, A2(nv, Tlr, function(n) {
                    return n.$ ? Ut : Vt(n.a);
                }(e)))) : t;
                return v(r, u.$ ? Pp : I9n(u.a), h);
            case 1:
                var a = n.a, i = function() {
                    var n = r.fc;
                    if (2 === n.$) {
                        var t = n.a;
                        return A5(Rlr, r.gF, Bx(r.dB), t, function(n) {
                            return n.rh;
                        }(a), Mlr);
                    }
                    return Pp;
                }();
                return v(r, i, h);
            case 2:
                var c = n.a;
                switch(c.$){
                    case 3:
                        return v(r, Pp, x([
                            Vlr
                        ]));
                    case 2:
                        return v(r, Pp, x(5 === c.a.$ ? [
                            A2($A, 1, pA(A2(Hlr, r.dB, c.a.b)))
                        ] : [
                            Zlr
                        ]));
                    default:
                        return v(r, Pp, A2(xA, 1, c));
                }
            case 3:
                return v(m(r, {
                    cO: Vt(n.a)
                }), Pp, h);
            case 4:
                return v(r, Pp, h);
            case 5:
                var o = A2(Olr, n.a, r.fR);
                return i = o.b, v(m(r, {
                    fR: o.a
                }), A2(Lp, Nlr, i), h);
            default:
                var f = n.a, s = m(r, {
                    ea: f
                });
                return 3 === f.$ ? v(m(s, {
                    cO: rv(f.a)
                }), Pp, h) : v(s, Pp, A2(xA, 1, f));
        }
    }), Wlr = function(n) {
        return n.cW.yT;
    }, Klr = function(n) {
        return n.cW.Ey;
    }, Xlr = F2(function(n, r) {
        return A2(Zhn, n, A2(sc, n, r));
    }), ndr = F3(function(n, r, t) {
        return A2(Xlr, n(t ? Wlr : Klr), r.le);
    }), rdr = F3(function(n, r, t) {
        var e;
        return e = A3(ndr, n, r, t), A2(Ek, x([
            rB(DB),
            _H(fO)
        ]), x([
            ld(e)
        ]));
    }), tdr = F2(function(n, r) {
        return r.xG(n);
    }), edr = F3(function(n, r, t) {
        return A2(Xlr, n(function(n) {
            return tdr(Ex(n));
        }(r)), t.ld);
    }), udr = F2(function(n, r) {
        return A2(OC, x([
            qC,
            uF(r),
            uln(r),
            EC(0)
        ]), x([
            A2(ak, h, x([
                ld(n)
            ]))
        ]));
    }), adr = F4(function(n, r, t, e) {
        return A2(oR, t.lA, A2(udr, A3(edr, n, r, t), e));
    }), idr = F2(function(n, r) {
        return r.xN(n);
    }), cdr = F3(function(n, r, t) {
        return A2(nk, h, x([
            A2(yC, x([
                SV,
                _H(cR),
                _H(_cn),
                rB(DB)
            ]), x([
                ld(n(idr(Ex(r))))
            ])),
            A2(oR, t, A2(Ak, x([
                _H(cR),
                rB(DB)
            ]), x([
                ld(n(GGn))
            ])))
        ]));
    }), odr = F3(function(n, r, t) {
        var e = !t.$ && u0n(t.a);
        return A2(zN, h, x([
            Bon(x([
                kcn(2),
                bR(1),
                JI(0)
            ])),
            A2(EN, x([
                _N(DB),
                kcn(8),
                bR(10),
                JI(12)
            ]), x([
                A2(nk, x([
                    Xx("white-circle")
                ]), x([
                    A2(PE, h, 14)
                ])),
                A3(cdr, n, r.dB, e),
                A3(rdr, n, r.fk, e),
                A4(adr, n, r.dB, r.fk, r.u3)
            ]))
        ]));
    }), fdr = {
        $: 4
    }, sdr = function(n) {
        return n.pe;
    }, ldr = F2(function(n, r) {
        var t, e = !n.$ && i(n.a, r), u = e ? fdr : function(n) {
            return {
                $: 3,
                a: n
            };
        }(r);
        return A2(nk, x([
            Xx("addon-category"),
            SC(x([
                b("addon-category--selected", e)
            ])),
            IC(u)
        ]), x([
            A2(Ek, x([
                _H(FO),
                nH
            ]), x([
                ld((t = r, t.tg))
            ])),
            A2(Ek, x([
                fq
            ]), x([
                ld(sdr(r))
            ]))
        ]));
    }), ddr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return be(t) > 1 ? A2(nk, x([
                Xx("flex flex-col relative")
            ]), A2(Eu, ldr(r), t)) : tB;
        }
        return tB;
    }), bdr = function(n) {
        return n.tg;
    }, vdr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mdr = function(n) {
        return n.j_.pP;
    }, pdr = function(n) {
        return n.j_.hn;
    }, $dr = F3(function(n, r, t) {
        return t.wj ? A2(nk, h, x([
            A2(OC, x([
                wO,
                uF(r),
                EC(vdr(t)),
                gC(x([
                    Xx("mt-3")
                ]))
            ]), x([
                ld(n(mdr))
            ]))
        ])) : tB;
    }), hdr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gdr = F3(function(n, r, t) {
        return A2(OC, x([
            oF,
            uF(r),
            EC(hdr(t))
        ]), x([
            ld(n(pdr))
        ]));
    }), wdr = F3(function(n, r, t) {
        var e, u = A2(sc, "", t.w$);
        return A2(nk, x([
            Xx("addon-category__addon")
        ]), x([
            A2(zN, x([
                jN(iR),
                _N(LI)
            ]), x([
                A2(EN, x([
                    JI(3),
                    KN(x([
                        Xx("pr-8")
                    ]))
                ]), x([
                    A2(k3, x([
                        Xx("inline"),
                        zG((e = t, function(n) {
                            var r = n;
                            if (r.$) {
                                var t = function(n) {
                                    return n.a.sd;
                                }(r.a);
                                return t.$ ? "" : t.a;
                            }
                            var e = SJn(r.a);
                            return e.$ ? "" : e.a;
                        }(e.jZ)))
                    ]), h)
                ])),
                A2(EN, x([
                    JI(5)
                ]), x([
                    A2(Ek, x([
                        _H(FO),
                        O0
                    ]), x([
                        ld(bdr(t))
                    ])),
                    A2(Ek, x([
                        fq,
                        $H
                    ]), x([
                        ld(u)
                    ]))
                ])),
                A2(EN, x([
                    JI(4),
                    KN(x([
                        Xx("pl-8 flex flex-col items-center")
                    ]))
                ]), x([
                    A3(gdr, n, r, t),
                    A3($dr, n, r, t)
                ]))
            ]))
        ]));
    }), xdr = F2(function(n, r) {
        var t = r.cO;
        if (t.$) return tB;
        var e = function(n) {
            return n.mj;
        }(t.a);
        return A2(nk, x([
            Xx("flex w-full flex-col")
        ]), A2(Eu, A2(wdr, n, r.u3), e));
    }), kdr = function(n) {
        return n.wU;
    }, ydr = function(n) {
        var r;
        return A2(nk, h, x([
            A2(Ak, x([
                SV,
                _H(FO),
                rB(DB)
            ]), x([
                ld((r = n, r.w5))
            ])),
            A2(Ek, x([
                ok(x([
                    Xx("addon-category__description")
                ])),
                SV,
                $H,
                _H(fO),
                rB(DB)
            ]), x([
                ld(kdr(n))
            ]))
        ]));
    }, _dr = F2(function(n, r) {
        var t = r.cO;
        if (t.$) return tB;
        var e = t.a;
        return A2(nk, x([
            Xx("addons-container")
        ]), x([
            ydr(e),
            A2(nk, x([
                Xx("flex w-full")
            ]), x([
                A2(ddr, r.ea, r.cO),
                A2(xdr, n, r)
            ]))
        ]));
    }), Adr = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(Ck, Nlr, A3(odr, n, r.fR, Vt(r.lB))),
                A2(_dr, n, r)
            ]))
        ]);
    }), Cdr = F2(function(n, r) {
        return {
            gN: 1 === r.ea.$ ? ck : A2(Adr, n, r),
            w5: n(JGn)
        };
    }), Bdr = mGn({
        Ar: jlr,
        AQ: Slr,
        Db: Llr,
        DZ: function() {
            return zx;
        },
        En: Jlr,
        Et: Cdr
    }), Edr = F4(function(n, r, t, e) {
        return {
            kA: e,
            dB: n,
            lB: r,
            xs: t
        };
    }), Ddr = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.DF).$ ? u.a : h, i = nQn(r);
        return b(A4(Edr, n, i, e, t.kA), A3(yGn, i, a, e.iF));
    }), qdr = F2(function(n, r) {
        return b(r, Pp);
    }), Fdr = F2(function(n, r) {
        return r;
    }), Pdr = F2(function(n, r) {
        return v(r, Pp, h);
    }), zdr = F2(function(n, r) {
        var t = r.dB;
        return {
            gN: x([
                tB
            ]),
            w5: Ex(t)
        };
    }), jdr = mGn({
        Ar: Ddr,
        AQ: qdr,
        Db: Fdr,
        DZ: function() {
            return zx;
        },
        En: Pdr,
        Et: zdr
    }), Sdr = F4(function(n, r, t, e) {
        return {
            kA: e,
            dB: n,
            lB: r,
            xs: t
        };
    }), Ldr = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.DF).$ ? u.a : h, i = nQn(r);
        return b(A4(Sdr, n, i, e, t.kA), A3(yGn, i, a, e.iF));
    }), Mdr = F2(function(n, r) {
        return b(r, Pp);
    }), Ndr = F2(function(n, r) {
        return r;
    }), Hdr = F2(function(n, r) {
        return v(r, Pp, h);
    }), Tdr = F2(function() {
        return {
            gN: x([
                tB
            ]),
            w5: "Signup"
        };
    }), Idr = mGn({
        Ar: Ldr,
        AQ: Mdr,
        Db: Ndr,
        DZ: function() {
            return zx;
        },
        En: Hdr,
        Et: Tdr
    }), Rdr = x([
        A2(nk, h, x([
            ik(x([
                Rnn,
                ytn(x([
                    Xx("mr-8")
                ]))
            ])),
            ik(x([
                ytn(x([
                    Xx("mr-8")
                ]))
            ])),
            ik(x([
                tk,
                ytn(x([
                    Xx("mr-8")
                ]))
            ]))
        ]))
    ]), Zdr = iRn({
        Et: function() {
            return {
                gN: Rdr,
                w5: "Spinner"
            };
        }
    }), Vdr = function(n) {
        return {
            Ar: F2(function(r, t) {
                var e = n.Ar(t);
                return v(e.a, e.b, h);
            }),
            AQ: cm(A2(ru, iu, aRn)),
            Db: cm(iu),
            DZ: n.DZ,
            En: F2(function(r, t) {
                var e = A2(n.En, r, t);
                return v(e.a, e.b, h);
            }),
            Et: n.Et
        };
    }, Udr = F2(function(n, r) {
        var t = A2(qgn, n, r.mk), e = t.b;
        return b(m(r, {
            mk: t.a
        }), A2(Lp, iu, e));
    }), Ydr = Vdr({
        Ar: function() {
            return b({
                mk: Umn("main-address")
            }, Pp);
        },
        DZ: function() {
            return Px(x([
                A2(_S, iu, Opn)
            ]));
        },
        En: Udr,
        Et: function(n) {
            var r, t;
            return {
                gN: (r = n, t = r.mk, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Address Input")
                        ])),
                        A2(Ck, iu, A3(Axn, Wx(0), h, t))
                    ]))
                ])),
                w5: "Address Input"
            };
        }
    }), Qdr = F2(function() {
        return v({}, Pp, h);
    }), Odr = F2(function(n, r) {
        return b(r, Pp);
    }), Gdr = F2(function(n, r) {
        return r;
    }), Jdr = F2(function(n, r) {
        return v(r, Pp, x([
            A2($A, n.a, pA(n.b))
        ]));
    }), Wdr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Kdr = x([
        A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(OC, x([
                qC,
                EC(A2(Wdr, 0, "Lots of info"))
            ]), x([
                ld("Info")
            ]))
        ])),
        A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(OC, x([
                oF,
                EC(A2(Wdr, 3, "Wohoo"))
            ]), x([
                ld("Success")
            ]))
        ])),
        A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(OC, x([
                oF,
                EC(A2(Wdr, 1, "Oopsie Daisy!"))
            ]), x([
                ld("Error")
            ]))
        ])),
        A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(OC, x([
                oF,
                EC(A2(Wdr, 2, "Halt!"))
            ]), x([
                ld("Warning")
            ]))
        ]))
    ]), Xdr = {
        Ar: Qdr,
        AQ: Odr,
        Db: Gdr,
        DZ: function() {
            return zx;
        },
        En: Jdr,
        Et: function() {
            return {
                gN: Kdr,
                w5: "Alerts"
            };
        }
    }, nbr = {
        $: 2
    }, rbr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), tbr = x([
        A2(rbr, {
            rh: "pct-FDrfQFrCr9Ev-1",
            tg: "Affiliate Doctor"
        }, 0),
        A2(rbr, {
            rh: "pct-B3cB7yLItKyF",
            tg: "Alek Rabiner2"
        }, 0),
        A2(rbr, {
            rh: "pct-Y94f3tsrFmA2-1",
            tg: "Allison Gapinski, FNP-C"
        }, 0),
        A2(rbr, {
            rh: "pct-pL6TRfjALmTV-1",
            tg: "Amanda Hayes, FNP-C"
        }, 0),
        A2(rbr, {
            rh: "pct-KhfOqVFSKPWi-1",
            tg: "Amanda Thompson, FNP-C"
        }, 0),
        A2(rbr, {
            rh: "pct-rg3CPavMEcR4-1",
            tg: "Anais Lauren K. Joines, FNP-C"
        }, 0),
        A2(rbr, {
            rh: "pct-mR0b2TFfodQQ-1",
            tg: "Ayesha Nasir, MD"
        }, 0),
        A2(rbr, {
            rh: "pct-raXYk919T8Nf",
            tg: "Bailee Aff Demo"
        }, 0),
        A2(rbr, {
            rh: "pct-gkfcJ545oFdG-1",
            tg: "Beena Patel, DO"
        }, 0),
        A2(rbr, {
            rh: "pct-byZhy2hrTf7k-1",
            tg: "Beth Bethany"
        }, 0),
        A2(rbr, {
            rh: "pct-3wEr5WuC6CoW-1",
            tg: "Daniel McKearney, PA-C"
        }, 0),
        A2(rbr, {
            rh: "pct-zVBTNmQYmXyZ-1",
            tg: "Dr Ashley Doctor"
        }, 0),
        A2(rbr, {
            rh: "pct-rtJiHD8xo3c7",
            tg: "Dr Bart II"
        }, 0),
        A2(rbr, {
            rh: "pct-2PREw4FNWDRR",
            tg: "Dr Lisa Affiliate at DPC"
        }, 0),
        A2(rbr, {
            rh: "pct-j89hrSCDZAgt-1",
            tg: "Dr Lovely Affiliate"
        }, 0),
        A2(rbr, {
            rh: "pct-0e6lXqNGgVeI-1",
            tg: "Dr Maicol"
        }, 0),
        A2(rbr, {
            rh: "pct-RRo6HPhQI1H8",
            tg: "Dr Nina Affiliate at Nina's Affiliate"
        }, 0),
        A2(rbr, {
            rh: "pct-RFA6H9L7QaE3",
            tg: "Dr Nina Doc"
        }, 0),
        A2(rbr, {
            rh: "pct-G81Otf86rzCw-1",
            tg: "Dr Nina Mae"
        }, 0),
        A2(rbr, {
            rh: "pct-hB2EvKS9u9T3",
            tg: "Dr Steve at DPC"
        }, 0),
        A2(rbr, {
            rh: "pct-M9DdDRA6Xak5-1",
            tg: "Dr Tasha"
        }, 0),
        A2(rbr, {
            rh: "pct-IDkC9B4DBojo",
            tg: "Dr Unlinked to Affiliate For Now"
        }, 0),
        A2(rbr, {
            rh: "pct-4H0vTuTD9qT2",
            tg: "Dr. Aaron Cho"
        }, 0),
        A2(rbr, {
            rh: "pct-ad0cH9Cu7p51-1",
            tg: "Dr. Brave"
        }, 0)
    ]), ebr = function(n) {
        return n.a.tg;
    }, ubr = {
        hY: 10,
        tg: Ut
    }, abr = F2(function(n, r) {
        var t = n(ubr);
        return A2(Nu, function() {
            var n, e;
            return r((n = t.tg, e = function() {
                if (n.$) return tbr;
                var r = n.a;
                return A2(Rc, function(n) {
                    return A2(fu, UQ(r), UQ(ebr(n)));
                }, tbr);
            }(), A2(Zy, e, da)));
        }, jp(500));
    }), ibr = F3(function(n, r, t) {
        return A2(abr, function(r) {
            return m(r, {
                hY: n,
                tg: t
            });
        }, r);
    }), cbr = function(n) {
        return n.a.rh;
    }, obr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fbr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return t(e.a);
        }
    }), sbr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return Vt(t(e.a));
        }
    }), lbr = {
        j1: "All",
        j2: Vt(""),
        hY: 10,
        kZ: "None",
        k_: Ut
    }, dbr = F2(function(n, r) {
        var t = n.rh, e = n.qu, u = n.Ed, a = n.Eb, i = r(lbr), c = A2(e, i.hY, obr);
        return b({
            hc: cP,
            k4: i,
            lt: c,
            fy: !1,
            fC: tpn({
                rh: t,
                Eb: function() {
                    return A3(fbr, i.j1, i.kZ, a);
                },
                Ed: A3(sbr, i.j2, i.k_, u)
            }),
            iQ: Vt(nbr)
        }, c(Ut));
    }), bbr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vbr = F2(function(n, r) {
        if (n.$) return v(m(r, {
            hc: n.a,
            fy: !1
        }), Pp, Ut);
        var t = A2(fwn, n.a, r.fC), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return v(r, Pp, Ut);
            if (a.a.$) {
                var n = a.a.a;
                return v(m(r, {
                    fy: !0
                }), r.lt(Vt(n)), Ut);
            }
            var t = a.a.a;
            return v(m(r, {
                iQ: t
            }), Pp, Vt(A2(sc, nbr, t)));
        }(), c = i.b, o = i.c;
        return v(m(i.a, {
            fC: e
        }), Vu(x([
            A2(Lp, bbr, u),
            c
        ])), o);
    }), mbr = F2(function(n, r) {
        var t = A2(vbr, n, r.ee), e = t.a, u = t.b, a = t.c, i = a.$ ? r : m(r, {
            cQ: a.a
        });
        return b(m(i, {
            ee: e
        }), A2(Lp, iu, u));
    }), pbr = {
        $: 1
    }, $br = F3(function(n, r, t) {
        if (TE(n)) return x([
            Nkn("No results found")
        ]);
        var e = function(n) {
            return A2(sc, Ut, A2(Fp, pu, A2(Wu, "x-total-count", n)));
        }(r);
        if (e.$) return h;
        var u = e.a;
        return s(u, t) > 0 ? x([
            Nkn("Search for " + oe(u - t) + " more results")
        ]) : h;
    }), hbr = F2(function(n, r) {
        var t = function() {
            var n = r.hc;
            if (3 === n.$) {
                var t = n.a, e = n.b, u = A2(Yt, Tkn(r.iQ), r.fy ? x([
                    Skn(!0)
                ]) : h), a = A2(Eu, function(n) {
                    return A2(hq, h, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, t), i = $(A2(Eu, function(n) {
                    return A2(hq, h, n);
                }, x([
                    pbr,
                    nbr
                ])), x([
                    pq
                ]));
                return b(u, $(i, $(a, A3($br, t, e, r.k4.hY))));
            }
            return b(x([
                Lkn("Loading..."),
                Skn(!0)
            ]), h);
        }();
        return A2(Ck, bbr, A4(uyn, n, t.a, t.b, r.fC));
    }), gbr = function(n) {
        return x([
            A2(nk, x([
                Xx("section")
            ]), x([
                A2(Ak, x([
                    ok(x([
                        Xx("underline mb-2")
                    ]))
                ]), x([
                    ld("Api Select")
                ])),
                A2(nk, x([
                    Xx("mt-4")
                ]), x([
                    A2(Ck, iu, A2(hbr, Wx(0), n.ee))
                ])),
                A2(nk, x([
                    Xx("mt-4")
                ]), x([
                    A2(XH, x([
                        HH("Selected")
                    ]), x([
                        A2(Ek, x([
                            $H
                        ]), x([
                            function() {
                                var r = n.cQ;
                                switch(r.$){
                                    case 0:
                                        return ld(ebr(r.a));
                                    case 1:
                                        return ld("All");
                                    default:
                                        return ld("None");
                                }
                            }()
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }, wbr = Vdr({
        Ar: function() {
            var n = A2(dbr, {
                qu: ibr,
                rh: "practitioners",
                Eb: ebr,
                Ed: cbr
            }, function(n) {
                return m(n, {
                    j1: "All Practitioners",
                    hY: 5
                });
            });
            return b({
                ee: n.a,
                cQ: nbr
            }, A2(Lp, iu, n.b));
        },
        DZ: function() {
            return zx;
        },
        En: mbr,
        Et: function(n) {
            return {
                gN: gbr(n),
                w5: "Api Select"
            };
        }
    }), xbr = function(n) {
        return {
            Ar: F2(function(r, t) {
                return v(n.Ar(t), Pp, h);
            }),
            AQ: cm(A2(ru, iu, aRn)),
            Db: cm(iu),
            DZ: function() {
                return zx;
            },
            En: F2(function(r, t) {
                return v(A2(n.En, r, t), Pp, h);
            }),
            Et: n.Et
        };
    }, kbr = F2(function(n, r) {
        return m(r, {
            em: !r.em
        });
    }), ybr = xbr({
        Ar: function() {
            return {
                em: !1
            };
        },
        En: kbr,
        Et: function(n) {
            var r, t;
            return {
                gN: (r = n, t = r.em, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Buttons")
                        ])),
                        A2(nk, h, x([
                            A2(OC, x([
                                qC
                            ]), x([
                                ld("Primary")
                            ])),
                            A2(OC, x([
                                oF
                            ]), x([
                                ld("Secondary")
                            ])),
                            A2(OC, x([
                                f5
                            ]), x([
                                ld("Tonal")
                            ])),
                            A2(OC, x([
                                wO
                            ]), x([
                                ld("This is a link")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), x([
                            A2(OC, x([
                                qC,
                                uF(!0)
                            ]), x([
                                ld("Primary Disabled")
                            ])),
                            A2(OC, x([
                                oF,
                                uF(!0)
                            ]), x([
                                ld("Secondary Disabled")
                            ])),
                            A2(OC, x([
                                f5,
                                uF(!0)
                            ]), x([
                                ld("Tonal Disabled")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), x([
                            A2(OC, x([
                                qC,
                                uln(t),
                                EC(0)
                            ]), x([
                                ld("Primary Loading")
                            ])),
                            A2(OC, x([
                                oF,
                                uln(t),
                                EC(0)
                            ]), x([
                                ld("Secondary Loading")
                            ])),
                            A2(OC, x([
                                f5,
                                uln(t),
                                EC(0)
                            ]), x([
                                ld("Tonal Loading")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), x([
                            A2(OC, x([
                                qC
                            ]), x([
                                A2(PE, h, 1),
                                A2(ak, h, x([
                                    ld("with Icon")
                                ]))
                            ])),
                            A2(OC, x([
                                qC
                            ]), x([
                                A2(ak, h, x([
                                    ld("with Icon")
                                ])),
                                A2(PE, h, 0)
                            ])),
                            A2(OC, x([
                                qC
                            ]), x([
                                A2(ak, h, x([
                                    ld("Play icon")
                                ])),
                                A2(PE, h, 35)
                            ]))
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("section mt-4")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Links")
                        ])),
                        A2(nk, h, x([
                            A2(IN, h, x([
                                ld("Regular link")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), x([
                            A2(IN, x([
                                SN
                            ]), x([
                                ld("Link in disguise")
                            ]))
                        ]))
                    ]))
                ])),
                w5: "Button"
            };
        }
    }), _br = F2(function(n, r) {
        return r;
    }), Abr = x([
        "Unlimited telemedicine 24/7",
        "Unrushed visits",
        "Wholesale pricing on supplies",
        "And more"
    ]), Cbr = function(n) {
        return x([
            A2(PE, x([
                cH(von)
            ]), 1),
            ld(n)
        ]);
    }, Bbr = x([
        A2(zN, x([
            PAn
        ]), x([
            A2(EN, x([
                JI(12)
            ]), x([
                A2(zN, x([
                    _N(LI),
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        kcn(8)
                    ]), x([
                        A2(rH, h, x([
                            ld("Virtual DPC")
                        ])),
                        A2(Ek, x([
                            $H
                        ]), x([
                            ld("Basic plan that enables direct primary care for its members")
                        ]))
                    ])),
                    A2(EN, x([
                        kcn(4),
                        A2(Ysn, 2, ycn)
                    ]), x([
                        A2(FI, x([
                            lk
                        ]), x([
                            ld("$30")
                        ])),
                        A2(FI, x([
                            $H
                        ]), x([
                            ld("/m")
                        ]))
                    ]))
                ])),
                Dk,
                A2(yon, x([
                    A2(CKn, 2, 2),
                    A2(CKn, 3, 3)
                ]), A2(Eu, A2(pc, bon, Cbr), Abr))
            ]))
        ]))
    ]), Ebr = xbr({
        Ar: function() {
            return {};
        },
        En: _br,
        Et: function() {
            return {
                gN: Bbr,
                w5: "Card Example"
            };
        }
    }), Dbr = function(n) {
        return n.th;
    }, qbr = function(n) {
        return n > 0 ? A2(ak, x([
            Xx("cart-icon__count")
        ]), x([
            ld(oe(n))
        ])) : tB;
    }, Fbr = function(n) {
        var r = n.xl, t = n.y3, e = n.Aj;
        return A2(fB, x([
            Xx("cart-icon"),
            yB(e),
            A2(jC, "aria-label", r(Dbr))
        ]), x([
            A2(PE, x([
                iH,
                jI,
                MB("cart-icon__icon")
            ]), 38),
            qbr(t)
        ]));
    }, Pbr = F3(function(n, r, t) {
        return A2(nk, x([
            Xx("flex flex-col items-center gap-2")
        ]), x([
            Fbr({
                y3: t,
                Aj: "#",
                xl: n
            }),
            A2(Ek, h, x([
                ld(r)
            ]))
        ]));
    }), zbr = (MJ = Wx(0), x([
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Cart Icon")
            ])),
            A2(nk, x([
                Xx("flex items-center gap-8")
            ]), x([
                A3(Pbr, MJ, "Empty cart", 0),
                A3(Pbr, MJ, "Single item", 1),
                A3(Pbr, MJ, "Few items", 2),
                A3(Pbr, MJ, "Many items", 99)
            ]))
        ]))
    ])), jbr = iRn({
        Et: function() {
            return {
                gN: zbr,
                w5: "Cart Icon"
            };
        }
    }), Sbr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    gV: t = n.a
                });
            case 1:
                return m(r, {
                    gW: t = n.a
                });
            case 2:
                return m(r, {
                    er: t = n.a
                });
            case 3:
                return m(r, {
                    es: t = n.a
                });
            case 4:
                return m(r, {
                    et: t = n.a
                });
            default:
                var t;
                return m(r, {
                    er: t = n.a,
                    es: t,
                    et: t
                });
        }
    }), Lbr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mbr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nbr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hbr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Tbr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ibr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Rbr = xbr({
        Ar: function() {
            return {
                gV: !1,
                gW: !0,
                er: !1,
                es: !1,
                et: !1
            };
        },
        En: Sbr,
        Et: function(n) {
            var r, t, e, u, a, c, o, f, s;
            return {
                gN: x([
                    (r = n, e = r.gV, u = r.gW, a = r.er, c = r.es, o = r.et, f = !(i(a, c) && i(c, o)), s = a && c && o, A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Checkboxes")
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(HT, x([
                                zT(e),
                                PT(Lbr)
                            ]), x([
                                ld("Checkbox")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(HT, x([
                                zT(u),
                                PT(Mbr)
                            ]), x([
                                A2(Bk, h, x([
                                    ld("Checkbox")
                                ])),
                                A2(Bk, h, x([
                                    ld("With multiple lines")
                                ]))
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(HT, x([
                                zT(!1),
                                FT(!0)
                            ]), x([
                                ld("Disabled Checkbox")
                            ])),
                            A2(HT, x([
                                zT(!0),
                                FT(!0)
                            ]), x([
                                ld("Disabled Checkbox")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(HT, x([
                                zT(!1),
                                $O(!0)
                            ]), x([
                                ld("Invalid Checkbox")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(HT, x([
                                zT(s),
                                (t = f, function(n) {
                                    return {
                                        $: 3,
                                        a: n
                                    };
                                }(t)),
                                PT(Ibr)
                            ]), x([
                                ld("Check All")
                            ])),
                            A2(HT, x([
                                zT(a),
                                PT(Nbr)
                            ]), x([
                                ld("A")
                            ])),
                            A2(HT, x([
                                zT(c),
                                PT(Hbr)
                            ]), x([
                                ld("B")
                            ])),
                            A2(HT, x([
                                zT(o),
                                PT(Tbr)
                            ]), x([
                                ld("C")
                            ]))
                        ]))
                    ])))
                ]),
                w5: "Checkbox"
            };
        }
    }), Zbr = {
        $: 0
    }, Vbr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ubr = F2(function(n, r) {
        return {
            rh: n,
            tg: r
        };
    }), Ybr = x([
        A2(Ubr, "loc-1234", "Tatooine"),
        A2(Ubr, "loc-2345", "Kashyyyk"),
        A2(Ubr, "loc-3456", "Mandalore")
    ]), Qbr = function(n) {
        return A2(Nu, function() {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A2(Rc, function(r) {
                return A2(fu, n, r.tg);
            }, Ybr)));
        }, jp(3e3));
    }, Obr = F2(function(n, r) {
        return 1 === r.$ ? n(r.a) : r.a;
    }), Gbr = F2(function(n, r) {
        return 1 === r.$ ? Vt(n(r.a)) : r.b;
    }), Jbr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Wbr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Kbr = F2(function(n, r) {
        switch(n.$){
            case 1:
                return b(m(r, {
                    e$: n.a
                }), Pp);
            case 0:
                return b(m(r, {
                    jU: n.a
                }), Pp);
            case 3:
                var t = A2(ZD, n.a, r.eC), e = t.b;
                return b(m(r, {
                    eC: a = t.a,
                    dN: (i = t.c).$ || i.a.$ || i.a.a.$ ? r.dN : i.a.a.a
                }), A2(Lp, Jbr, e));
            default:
                var u = A2(fwn, n.a, r.e0), a = u.a, i = (e = u.b, u.c), c = function() {
                    n: for(; !i.$;){
                        if (i.a.$) {
                            var n = i.a.a;
                            return b(m(r, {
                                e$: Zbr
                            }), Qbr(n));
                        }
                        if (i.a.a.$) break n;
                        return b(m(r, {
                            dO: i.a.a.a
                        }), Pp);
                    }
                    return b(r, Pp);
                }(), o = c.b;
                return b(m(c.a, {
                    e0: a
                }), Vu(x([
                    o,
                    A2(Lp, Wbr, e)
                ])));
        }
    }), Xbr = F3(function(n, r, t) {
        return 1 === t.$ ? x([
            A2(r, n, t.a)
        ]) : 1 === t.b.$ ? h : x([
            A2(Y_, n, t.b.a)
        ]);
    }), nvr = function(n) {
        var r = n.dN, t = n.dO;
        return R_(A2(nc, A3(Xbr, "location", F2(function(n, r) {
            return A2(Y_, n, r.rh);
        }), t), A3(Xbr, "distance", bJ, r)));
    }, rvr = {
        $: 3
    }, tvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, evr = x([
        5,
        10,
        20
    ]), uvr = F2(function(n, r) {
        var t = A2(Eu, hq(h), A2(Yt, A2(Vbr, "Any Distance", Ut), A2(Eu, tvr, evr)));
        return x([
            A2(Ck, Jbr, A4(sF, Wx(0), x([
                Dq(Vt(n)),
                vq,
                xq("Any Distance")
            ]), t, r))
        ]);
    }), avr = {
        $: 5
    }, ivr = F3(function(n, r, t) {
        var e, u = 1 === (e = n).$ ? Vt(e.a) : Ut, a = A2(sc, !0, A2(Fp, cm(!1), u)), i = function() {
            if (1 === u.$) return h;
            var n = u.a;
            return A2(Eu, hq(h), A2(Yt, A2(Vbr, "Any Location", Ut), A2(Eu, tvr, n)));
        }();
        return x([
            A2(Ck, Wbr, A4(uyn, Wx(0), x([
                Tkn(Vt(r)),
                Skn(a),
                avr,
                Lkn("Any Location")
            ]), i, t))
        ]);
    }), cvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ovr = {
        $: 5
    }, fvr = function(n) {
        return n ? "map" : "list";
    }, svr = function(n) {
        return x([
            A2(B5, x([
                T5(fvr(n))
            ]), x([
                A2(E5, x([
                    $5,
                    ovr,
                    D5(A2(pc, cvr, cm(0))),
                    T5(fvr(0))
                ]), x([
                    ld("List")
                ])),
                A2(E5, x([
                    $5,
                    ovr,
                    D5(A2(pc, cvr, cm(1))),
                    T5(fvr(1))
                ]), x([
                    ld("Map")
                ]))
            ]))
        ]);
    }, lvr = function(n) {
        var r = n.e$, t = n.e0, e = n.dO, u = n.jU, a = n.dN, i = n.eC;
        return x([
            A2(zN, x([
                PAn,
                QTn
            ]), x([
                A2(EN, x([
                    JI(12)
                ]), x([
                    A2(zN, x([
                        jN(iR)
                    ]), x([
                        A2(EN, x([
                            JTn
                        ]), x([
                            A2(zN, x([
                                jN(BN)
                            ]), x([
                                A2(EN, x([
                                    JI(12)
                                ]), x([
                                    vI(x([
                                        iI("Search by name")
                                    ]))
                                ]))
                            ])),
                            A2(zN, x([
                                jN(iR)
                            ]), x([
                                A2(EN, x([
                                    kcn(4)
                                ]), A3(ivr, r, e, t)),
                                A2(EN, x([
                                    kcn(4)
                                ]), x([
                                    vI(h)
                                ])),
                                A2(EN, x([
                                    kcn(4)
                                ]), A2(uvr, a, i))
                            ]))
                        ])),
                        A2(EN, x([
                            rvr
                        ]), x([
                            A2(zN, x([
                                jN(BN)
                            ]), x([
                                A2(EN, h, svr(u))
                            ])),
                            A2(zN, x([
                                jN(iR)
                            ]), x([
                                A2(EN, h, x([
                                    vI(h)
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            ld("Query: " + nvr(n))
        ]);
    }, dvr = Vdr({
        Ar: function() {
            return b({
                eC: dd({
                    rh: "distances-select",
                    Eb: function() {
                        return Obr(function(n) {
                            return oe(n) + " miles";
                        });
                    },
                    Ed: Gbr(oe)
                }),
                e$: Zbr,
                e0: tpn({
                    rh: "locations-select",
                    Eb: function() {
                        return Obr(function(n) {
                            return n.tg;
                        });
                    },
                    Ed: Gbr(function(n) {
                        return n.rh;
                    })
                }),
                dN: A2(Vbr, "Distance", Ut),
                dO: A2(Vbr, "Location", Ut),
                jU: 0
            }, Qbr(""));
        },
        DZ: function() {
            return zx;
        },
        En: Kbr,
        Et: function(n) {
            return {
                gN: lvr(n),
                w5: "Filters"
            };
        }
    }), bvr = {
        mr: Ut,
        qB: "",
        qV: 1,
        rS: "",
        uw: A2(tS, "cool-phone", {
            hN: !0,
            CA: "6668675309",
            iv: DR
        }),
        jL: !1
    }, vvr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mvr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    qB: n.a
                });
            case 3:
                return m(r, {
                    rS: n.a
                });
            case 0:
                return m(r, {
                    qV: n.a
                });
            case 1:
                return m(r, {
                    mr: n.a
                });
            default:
                return m(r, {
                    uw: n.a
                });
        }
    }), pvr = nM(x([
        A2(fnr, function(n) {
            return n.qB;
        }, b(0, nN(vM))),
        A2(fnr, function(n) {
            return n.rS;
        }, b(1, nN(mM))),
        function() {
            return h;
        },
        function(n) {
            var r = n.uw;
            return A2(yM, r.CA, r.Dl) || vu(r.CA), h;
        }
    ])), $vr = {
        $: 2
    }, hvr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    kB: A3(dN, mvr, n.a, r.kB)
                }), Pp);
            case 1:
                var t = A2(BM, pvr, r.kB);
                return t.$ ? b(m(r, {
                    kB: t.a
                }), Pp) : b(m(r, {
                    kB: t.a.a,
                    u3: !0
                }), A2(Nu, function() {
                    return $vr;
                }, jp(3e3)));
            case 2:
                return b(m(r, {
                    u3: !1
                }), Pp);
            default:
                var e = n.a, u = FL(r.kB), a = A2(sN, e, u.uw), i = a.b, c = A3(dN, mvr, function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(a.a), r.kB);
                return b(m(r, {
                    kB: c
                }), A2(Lp, vvr, i));
        }
    }), gvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wvr = {
        $: 1
    }, xvr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _vr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Avr = function(n) {
        return n ? "female" : "male";
    }, Cvr = F2(function(n, r) {
        var t = pu(r);
        return 1 === t.$ ? "" === r ? Ut : n : Vt(t.a);
    }), Bvr = F2(function(n, r) {
        var t, e = Wx(0), u = FL(r), a = u.qB, i = u.rS, c = u.mr, o = u.qV, f = u.uw;
        return A2(nk, h, x([
            A2(zN, h, x([
                A2(EN, x([
                    JI(6)
                ]), x([
                    A2(XH, x([
                        HH("First Name"),
                        VH(!0)
                    ]), x([
                        vI(x([
                            xI(a),
                            iI("Jane"),
                            gI(A2(pc, kvr, xvr)),
                            JT(A2(QH, 0, r))
                        ])),
                        A2(ET, e, A2(PH, 0, r))
                    ]))
                ])),
                A2(EN, x([
                    JI(6)
                ]), x([
                    A2(XH, x([
                        HH("Last Name"),
                        VH(!0)
                    ]), x([
                        vI(x([
                            xI(i),
                            iI("Doe"),
                            gI(A2(pc, kvr, _vr)),
                            JT(A2(QH, 1, r))
                        ])),
                        A2(ET, e, A2(PH, 1, r))
                    ]))
                ]))
            ])),
            A2(XH, x([
                HH("Gender"),
                VH(!0)
            ]), x([
                A2(zN, h, x([
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            D5(A2(pc, A2(pc, kvr, yvr), cm(0))),
                            qkn(!o),
                            T5(Avr(0))
                        ]), x([
                            ld("Male")
                        ]))
                    ])),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(C5, x([
                            $5,
                            D5(A2(pc, A2(pc, kvr, yvr), cm(1))),
                            qkn(1 === o),
                            T5(Avr(1))
                        ]), x([
                            ld("Female")
                        ]))
                    ]))
                ]))
            ])),
            A2(XH, x([
                HH("Age")
            ]), x([
                A2(zN, h, x([
                    A2(EN, x([
                        JI(12)
                    ]), x([
                        vI(x([
                            xI((t = c, A2(sc, "", A2(Fp, oe, t)))),
                            iI("e.g 30"),
                            gI(A2(pc, A2(pc, kvr, gvr), Cvr(c))),
                            JT(A2(QH, 2, r))
                        ])),
                        A2(ET, e, A2(PH, 2, r))
                    ]))
                ]))
            ])),
            A2(XH, x([
                HH("Phone Number"),
                VH(!0)
            ]), x([
                A2(zN, h, x([
                    A2(EN, x([
                        JI(12)
                    ]), x([
                        A2(Ck, vvr, A3(PR, e, x([
                            aR(A2(QH, 3, r))
                        ]), f)),
                        A2(ET, e, A2(PH, 3, r))
                    ]))
                ]))
            ])),
            A2(XH, x([
                HH("Tobacco use"),
                exn("Do you currently use, or have used tobacco products in the last twelve months?")
            ]), x([
                A2(zN, h, h)
            ])),
            A2(OC, x([
                qC,
                uF(n),
                uln(n),
                EC(wvr)
            ]), x([
                ld("Submit")
            ]))
        ]));
    }), Evr = Vdr({
        Ar: function() {
            return b({
                kB: lS(bvr),
                u3: !1
            }, Pp);
        },
        DZ: function() {
            return zx;
        },
        En: hvr,
        Et: function(n) {
            return {
                gN: x([
                    A2(Bvr, n.u3, n.kB)
                ]),
                w5: "Form Example"
            };
        }
    }), Dvr = x([
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Grid")
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-100 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-400 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    kcn(6)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 6")
                    ]))
                ])),
                A2(EN, x([
                    JI(6),
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    JI(6),
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    kcn(2),
                    JI(4)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 2")
                    ]))
                ])),
                A2(EN, x([
                    kcn(2),
                    JI(4)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 2")
                    ]))
                ])),
                A2(EN, x([
                    kcn(2),
                    JI(4)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 2")
                    ]))
                ])),
                A2(EN, x([
                    kcn(6)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 6")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    JI(6)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Row.noGutter Col 6")
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Row.noGutter Col 3")
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Row.noGutter Col 3")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                Bon(x([
                    JI(6)
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                Bon(x([
                    JI(3)
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    JI(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                Bon(x([
                    JI(3)
                ]))
            ]))
        ]))
    ]), qvr = iRn({
        Et: function() {
            return {
                gN: Dvr,
                w5: "Grid"
            };
        }
    }), Fvr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    gK: n.a
                });
            case 1:
                return m(r, {
                    iO: n.a
                });
            default:
                return m(r, {
                    iK: n.a
                });
        }
    }), Pvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zvr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Svr = xbr({
        Ar: function() {
            return {
                gK: "Some initial text",
                iK: "",
                iO: ""
            };
        },
        En: Fvr,
        Et: function(n) {
            var r, t, e, u;
            return {
                gN: (r = n, t = r.gK, e = r.iO, u = r.iK, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Inputs")
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            vI(x([
                                xI(t),
                                gI(Pvr)
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            vI(x([
                                iI("Disabled"),
                                YT(!0)
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            vI(x([
                                iI("Secret"),
                                xKn(0),
                                gI(jvr),
                                xI(e)
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            vI(x([
                                iI("This is required"),
                                xI(u),
                                JT(vu(u)),
                                gI(zvr)
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            Tln(x([
                                Hln(x([
                                    ld("$")
                                ])),
                                vI(x([
                                    xI("1.000,00")
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                w5: "Input"
            };
        }
    }), Lvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mvr = F2(function(n) {
        var r = A2(apn, n.gF, !0);
        return v({
            ax: r.a
        }, A2(Lp, Lvr, r.b), h);
    }), Nvr = F2(function(n, r) {
        return b(r, Pp);
    }), Hvr = F2(function(n, r) {
        return r;
    }), Tvr = F2(function(n, r) {
        if (n.$) {
            var t = A2(Kgn, !0, r.ax), e = (u = t.a, x(t.b ? [
                A2($A, 3, pA("Insurance info is valid!"))
            ] : [
                A2($A, 1, pA("Insurance info is invalid!"))
            ]));
            return v(m(r, {
                ax: u
            }), Pp, e);
        }
        var u, a = A2(swn, n.a, r.ax), i = a.b;
        return v(m(r, {
            ax: u = a.a
        }), A2(Lp, Lvr, i), h);
    }), Ivr = {
        $: 1
    }, Rvr = {
        Ar: Mvr,
        AQ: Nvr,
        Db: Hvr,
        DZ: function() {
            return zx;
        },
        En: Tvr,
        Et: function(n) {
            var r, t;
            return {
                gN: (r = n, t = r.ax, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Phone Input")
                        ])),
                        A2(Ck, Lvr, A3(_yn, Wx(0), !1, t)),
                        A2(OC, x([
                            qC,
                            EC(Ivr),
                            gC(x([
                                Xx("mt-6")
                            ]))
                        ]), x([
                            A2(ak, h, x([
                                ld("Validate")
                            ]))
                        ]))
                    ]))
                ])),
                w5: "Phone Input"
            };
        }
    }, Zvr = {
        $: 3
    }, Vvr = {
        $: 2
    }, Uvr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Yvr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Qvr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return b(m(r, {
                    e7: WL(r.e7),
                    du: !1
                }), Pp);
            case 3:
                return b(m(r, {
                    a0: WL(r.a0)
                }), Pp);
            case 0:
                return b(m(r, {
                    e7: NM(r.e7),
                    du: !1
                }), Pp);
            case 1:
                return b(m(r, {
                    a0: NM(r.a0)
                }), Pp);
            case 4:
                return b(m(r, {
                    e7: WL(r.e7),
                    du: !0
                }), Pp);
            case 5:
                var t = A2(lN, n.a, r.e7), e = t.b;
                return b(m(r, {
                    e7: t.a
                }), A2(Lp, Yvr, e));
            default:
                var u = A2(lN, n.a, r.a0);
                return e = u.b, b(m(r, {
                    a0: u.a
                }), A2(Lp, Uvr, e));
        }
    }), Ovr = {
        $: 0
    }, Gvr = {
        $: 1
    }, Jvr = {
        $: 4
    }, Wvr = x([
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Modal Content!")
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ]))
            ])),
            A2(zN, h, x([
                A2(EN, x([
                    kcn(6)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 6")
                    ]))
                ])),
                A2(EN, x([
                    JI(6),
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-300 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ])),
                A2(EN, x([
                    JI(6),
                    kcn(3)
                ]), x([
                    A2(nk, x([
                        Xx("bg-primary-200 h-12 flex items-center justify-center")
                    ]), x([
                        ld("Col 3")
                    ]))
                ]))
            ]))
        ]))
    ]), Kvr = function(n) {
        return A2(nk, h, n.du ? x([
            A2(yC, h, x([
                ld("Modal Submitted")
            ]))
        ]) : h);
    }, Xvr = function(n) {
        return x([
            A2(nk, x([
                Xx("section")
            ]), x([
                A2(Ak, x([
                    ok(x([
                        Xx("underline mb-2")
                    ]))
                ]), x([
                    ld("Modal")
                ])),
                A2(nk, x([
                    Xx("mt-4 flex flex-wrap gap-3")
                ]), x([
                    A2(OC, x([
                        qC,
                        EC(Ovr)
                    ]), x([
                        ld("Show Modal")
                    ])),
                    A2(OC, x([
                        qC,
                        EC(Gvr)
                    ]), x([
                        ld("Show full-viewport modal")
                    ]))
                ])),
                A2(QI, x([
                    qI(x([
                        ld("This is a Title for the Modal")
                    ])),
                    EI(Wvr),
                    DI(x([
                        A2(OC, x([
                            oF,
                            EC(Vvr)
                        ]), x([
                            ld("Cancel")
                        ])),
                        A2(OC, x([
                            qC,
                            EC(Jvr)
                        ]), x([
                            ld("Submit")
                        ]))
                    ]))
                ]), n.e7),
                A3(YI, 1, x([
                    q3,
                    EI(x([
                        A2(nk, x([
                            Xx("flex h-full min-h-0 w-full flex-1 items-center justify-center rounded-md bg-primary-100")
                        ]), x([
                            ld("Content fills available space (e.g. image preview).")
                        ]))
                    ]))
                ]), n.a0),
                Kvr(n)
            ]))
        ]);
    }, nmr = Vdr({
        Ar: function() {
            var n = A2(fS, 0, Vvr), r = n.a, t = n.b, e = A2(fS, 0, Zvr);
            return b({
                a0: e.a,
                e7: r,
                du: !1
            }, Vu(x([
                t,
                e.b
            ])));
        },
        DZ: function() {
            return Px(x([
                A2(_S, Yvr, BS()),
                A2(_S, Uvr, BS())
            ]));
        },
        En: Qvr,
        Et: function(n) {
            return {
                gN: Xvr(n),
                w5: "StyleGuide.Modal"
            };
        }
    }), rmr = {
        tg: "",
        lj: 0,
        vg: Vt(1)
    }, tmr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    tg: n.a
                });
            case 1:
                return m(r, {
                    lj: n.a
                });
            default:
                return m(r, {
                    vg: n.a
                });
        }
    }), emr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return b(m(r, {
                    bg: A3(_cr, tmr(n.b), t, r.bg)
                }), Pp);
            case 1:
                return b(m(r, {
                    bg: A2(PY, rmr, r.bg)
                }), Pp);
            default:
                return b(m(r, {
                    bg: A2(F$n, t = n.a, r.bg)
                }), Pp);
        }
    }), umr = {
        $: 1
    }, amr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), imr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cmr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, omr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fmr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, smr = F2(function(n, r) {
        return A2(sc, n, pu(r));
    }), lmr = F2(function(n, r) {
        var t = pu(r);
        return 1 === t.$ ? "" === r ? Ut : n : Vt(t.a);
    }), dmr = function(n) {
        var r, t = n.a, e = n.b.tg, u = n.b.lj, a = n.b.vg;
        return b(oe(t), A2(zN, h, x([
            A2(EN, x([
                kcn(6)
            ]), x([
                A2(XH, x([
                    HH("Item")
                ]), x([
                    vI(x([
                        xI(e),
                        gI(A2(pc, amr(t), imr))
                    ]))
                ]))
            ])),
            A2(EN, x([
                kcn(3),
                JI(6)
            ]), x([
                A2(XH, x([
                    HH("Quantiy")
                ]), x([
                    vI(x([
                        xI((r = a, A2(sc, "", A2(Fp, oe, r)))),
                        gI(A2(pc, A2(pc, amr(t), omr), lmr(a)))
                    ]))
                ]))
            ])),
            A2(EN, x([
                kcn(3),
                JI(6)
            ]), x([
                A2(XH, x([
                    HH("Price")
                ]), x([
                    vI(x([
                        xI(oe(u)),
                        gI(A2(pc, A2(pc, amr(t), cmr), smr(u)))
                    ])),
                    A2(OC, x([
                        wO,
                        EC(fmr(t))
                    ]), x([
                        ld("Remove")
                    ]))
                ]))
            ]))
        ])));
    }, bmr = Vdr({
        Ar: function() {
            return b({
                bg: A2(PY, rmr, jU)
            }, Pp);
        },
        DZ: function() {
            return zx;
        },
        En: emr,
        Et: function(n) {
            return {
                gN: x([
                    A2(nk, h, x([
                        A3(Kq, "div", h, A2(sO, dmr, n.bg)),
                        A2(OC, x([
                            qC,
                            EC(umr)
                        ]), x([
                            ld("Add charge")
                        ]))
                    ]))
                ]),
                w5: "MultiForm"
            };
        }
    }), vmr = F2(function(n, r) {
        var t = A2(sN, n, r.uw), e = t.b;
        return b(m(r, {
            uw: t.a
        }), A2(Lp, iu, e));
    }), mmr = Vdr({
        Ar: function() {
            return b({
                uw: ipn("cool-phone")
            }, Pp);
        },
        DZ: function() {
            return zx;
        },
        En: vmr,
        Et: function(n) {
            var r, t;
            return {
                gN: (r = n, t = r.uw, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Phone Input")
                        ])),
                        A2(Ck, iu, A3(PR, Wx(0), h, t))
                    ]))
                ])),
                w5: "Phone Input"
            };
        }
    }), pmr = F2(function(n, r) {
        return m(r, n.$ ? {
            $8: n.a
        } : {
            iG: n.a
        });
    }), $mr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hmr = x([
        0,
        1,
        2
    ]), gmr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, wmr = function(n) {
        switch(n){
            case 0:
                return "Kripton";
            case 1:
                return "Gotham";
            default:
                return "Central City";
        }
    }, xmr = function(n) {
        switch(n){
            case 0:
                return "kripton";
            case 1:
                return "gotham";
            default:
                return "central-city";
        }
    }, kmr = F2(function(n, r) {
        return A2(C5, x([
            $5,
            D5(A2(pc, gmr, cm(r))),
            qkn(i(n, r)),
            T5(xmr(r)),
            p4n(x([
                Xx("mr-2")
            ]))
        ]), x([
            A3(pc, ld, wmr, r)
        ]));
    }), ymr = xbr({
        Ar: function() {
            return {
                $8: 1,
                iG: "batman"
            };
        },
        En: pmr,
        Et: function(n) {
            var r, t, e;
            return {
                gN: (r = n, t = r.iG, e = r.$8, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Radio Buttons")
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(C5, x([
                                T5("batman"),
                                qkn("batman" === t),
                                D5($mr)
                            ]), x([
                                ld("Batman")
                            ])),
                            A2(C5, x([
                                T5("flash"),
                                qkn("flash" === t),
                                D5($mr)
                            ]), x([
                                ld("The Flash")
                            ])),
                            A2(C5, x([
                                T5("superman"),
                                qkn("superman" === t),
                                D5($mr),
                                Fkn(!0)
                            ]), x([
                                ld("Superman")
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(C5, x([
                                $5,
                                T5("batman"),
                                qkn("batman" === t),
                                D5($mr),
                                p4n(x([
                                    Xx("mr-2")
                                ]))
                            ]), x([
                                ld("Batman")
                            ])),
                            A2(C5, x([
                                $5,
                                T5("flash"),
                                qkn("flash" === t),
                                D5($mr),
                                p4n(x([
                                    Xx("mr-2")
                                ]))
                            ]), x([
                                ld("The Flash")
                            ])),
                            A2(C5, x([
                                $5,
                                T5("superman"),
                                qkn("superman" === t),
                                D5($mr),
                                p4n(x([
                                    Xx("mr-2")
                                ])),
                                Fkn(!0)
                            ]), x([
                                ld("Superman")
                            ]))
                        ])),
                        A2(nk, h, x([
                            A2(B5, x([
                                T5(t),
                                D5($mr)
                            ]), x([
                                A2(E5, x([
                                    $5,
                                    T5("batman")
                                ]), x([
                                    ld("Batman")
                                ])),
                                A2(E5, x([
                                    $5,
                                    T5("flash")
                                ]), x([
                                    ld("The Flash")
                                ])),
                                A2(E5, x([
                                    $5,
                                    T5("superman"),
                                    Fkn(!0)
                                ]), x([
                                    ld("Superman")
                                ]))
                            ]))
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), x([
                            A2(B5, x([
                                T5(t),
                                D5($mr),
                                j5
                            ]), x([
                                A2(E5, x([
                                    $5,
                                    T5("batman")
                                ]), x([
                                    ld("Batman")
                                ])),
                                A2(E5, x([
                                    $5,
                                    T5("flash")
                                ]), x([
                                    ld("The Flash")
                                ])),
                                A2(E5, x([
                                    $5,
                                    T5("superman")
                                ]), x([
                                    ld("Superman")
                                ])),
                                A2(E5, x([
                                    $5,
                                    T5("wonder-woman")
                                ]), x([
                                    ld("Wonder Woman")
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("section mt-4")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("With an elm type")
                        ])),
                        A2(nk, x([
                            Xx("mt-4")
                        ]), A2(Eu, kmr(e), hmr))
                    ]))
                ])),
                w5: "Radio"
            };
        }
    }), _mr = {
        $: 2
    }, Amr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Cmr = F2(function(n, r) {
        return A4(zqn, n, "dpc-network", function(n) {
            return m(n, {
                tg: r
            });
        }, Amr);
    }), Bmr = function(n) {
        switch(n.$){
            case 1:
                return "All Practitioners";
            case 2:
                return "None";
            default:
                return MP(n.a);
        }
    }, Emr = function(n) {
        switch(n.$){
            case 1:
                return Vt("");
            case 2:
                return Ut;
            default:
                return Vt(czn(n.a));
        }
    }, Dmr = F2(function(n) {
        return v({
            gF: n.gF,
            uP: Vt(_mr),
            uQ: "",
            cJ: cP,
            fm: tpn({
                rh: "practitioners",
                Eb: function() {
                    return Bmr;
                },
                Ed: Emr
            }),
            fB: !1
        }, A2(Cmr, n.gF, Ut), h);
    }), qmr = F2(function(n, r) {
        return b(r, Pp);
    }), Fmr = F2(function(n, r) {
        return r;
    }), Pmr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zmr = F2(function(n, r) {
        if (n.$) return v(m(r, {
            cJ: n.a,
            fB: !1
        }), Pp, h);
        var t = A2(fwn, n.a, r.fm), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return b(r, Pp);
            if (a.a.$) {
                var n = a.a.a;
                return b(m(r, {
                    fB: !0
                }), A2(Cmr, r.gF, Vt(n)));
            }
            return b(m(r, {
                uP: a.a.a
            }), Pp);
        }(), c = i.b;
        return v(m(i.a, {
            fm: e
        }), Vu(x([
            A2(Lp, Pmr, u),
            c
        ])), h);
    }), jmr = {
        $: 1
    }, Smr = F4(function(n, r, t, e) {
        var u = function() {
            if (3 === n.$) {
                var e = A2(Eu, function(n) {
                    return A2(hq, h, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, n.a), u = A2(Yt, Tkn(t), r ? x([
                    Skn(!0)
                ]) : h), a = TE(e) ? "No providers found" : "Search to filter...", i = $(A2(Eu, function(n) {
                    return A2(hq, h, n);
                }, x([
                    jmr,
                    _mr
                ])), x([
                    pq
                ]));
                return b(u, $(i, $(e, x([
                    Nkn(a)
                ]))));
            }
            return b(x([
                Lkn("Loading practitioners..."),
                Skn(!0)
            ]), h);
        }(), a = u.a, i = u.b;
        return A2(nk, x([
            Xx("mb-4")
        ]), x([
            A2(Ck, Pmr, A4(uyn, Wx(0), a, i, e))
        ]));
    }), Lmr = function(n) {
        return x([
            A2(nk, x([
                Xx("section")
            ]), x([
                A2(Ak, x([
                    ok(x([
                        Xx("underline mb-2")
                    ]))
                ]), x([
                    ld("Searchable Select")
                ])),
                A2(nk, x([
                    Xx("mt-4")
                ]), x([
                    A4(Smr, n.cJ, n.fB, n.uP, n.fm)
                ]))
            ]))
        ]);
    }, Mmr = {
        Ar: Dmr,
        AQ: qmr,
        Db: Fmr,
        DZ: function() {
            return zx;
        },
        En: zmr,
        Et: function(n) {
            return {
                gN: Lmr(n),
                w5: "SearchableSelect"
            };
        }
    }, Nmr = function(n) {
        switch(n.$){
            case 0:
                return n.a.tg;
            case 1:
                return "All :)";
            default:
                return "None :(";
        }
    }, Hmr = function(n) {
        switch(n.$){
            case 0:
                return Vt(n.a.rh);
            case 1:
                return Vt("");
            default:
                return Ut;
        }
    }, Tmr = F2(function(n, r) {
        var t = A2(ZD, n, r.eL), e = t.b, u = t.c;
        return b(m(r, {
            eL: t.a,
            fE: u.$ || u.a.$ ? r.fE : u.a.a
        }), A2(Lp, iu, e));
    }), Imr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rmr = x([
        {
            $: 1
        },
        {
            $: 2
        },
        Imr({
            rh: "1",
            tg: "Batman"
        }),
        Imr({
            rh: "spidey",
            tg: "Spiderman"
        }),
        Imr({
            rh: "drstrange",
            tg: "Dr Strange"
        }),
        Imr({
            rh: "2",
            tg: "The Flash"
        })
    ]), Zmr = function(n) {
        return x([
            A2(nk, x([
                Xx("section")
            ]), x([
                A2(Ak, x([
                    ok(x([
                        Xx("underline mb-2")
                    ]))
                ]), x([
                    ld("Select")
                ])),
                A2(nk, x([
                    Xx("mt-4")
                ]), x([
                    A2(Ck, iu, A4(sF, Wx(0), x([
                        Dq(n.fE),
                        xq("Pick your favorite hero")
                    ]), A2(Eu, function(n) {
                        return A2(hq, h, n);
                    }, Rmr), n.eL))
                ]))
            ]))
        ]);
    }, Vmr = Vdr({
        Ar: function() {
            return b({
                eL: dd({
                    rh: "heroes",
                    Eb: function() {
                        return Nmr;
                    },
                    Ed: Hmr
                }),
                fE: Ut
            }, Pp);
        },
        DZ: function() {
            return zx;
        },
        En: Tmr,
        Et: function(n) {
            return {
                gN: Zmr(n),
                w5: "Select"
            };
        }
    }), Umr = x([
        A2(Kcn, x([
            A2(V3, h, "First Name"),
            A2(V3, h, "Last Name"),
            A2(V3, h, "Gender")
        ]), x([
            A2(O3, h, x([
                A2(Z3, h, x([
                    A2(WH, h, x([
                        ld("Jhon")
                    ]))
                ])),
                A2(Z3, h, x([
                    ld("Doe")
                ])),
                A2(Z3, h, x([
                    ld("Male")
                ]))
            ])),
            A2(O3, h, x([
                A2(Z3, h, x([
                    A2(WH, h, x([
                        ld("Jane")
                    ]))
                ])),
                A2(Z3, h, x([
                    ld("Doe")
                ])),
                A2(Z3, h, x([
                    ld("Female")
                ]))
            ]))
        ])),
        A3(c9, Vt("Example roster for screen readers"), x([
            A2(V3, h, "Role"),
            A2(V3, h, "Name")
        ]), x([
            A2(O3, h, x([
                A2(Z3, h, x([
                    ld("Admin")
                ])),
                A2(Z3, h, x([
                    ld("Alex")
                ]))
            ]))
        ]))
    ]), Ymr = iRn({
        Et: function() {
            return {
                gN: Umr,
                w5: "Table"
            };
        }
    }), Qmr = F2(function(n, r) {
        var t = A2(D8, n, r.d_), e = t.b;
        return b(m(r, {
            d_: t.a
        }), A2(Lp, iu, e));
    }), Omr = F3(function(n, r, t) {
        var e = r.c2;
        return A2(sc, ld("Tab NotFound"), A2(Fp, function(r) {
            return n(r.a);
        }, rv(A2(Rc, function(n) {
            return i((0, n.b.d$)(n.a), e);
        }, t))));
    }), Gmr = function(n) {
        var r = n.tg, t = n.mr;
        return A2(nk, h, x([
            A2(ak, x([
                Xx("text-current"),
                Xx("mr-2")
            ]), x([
                ld(r)
            ])),
            A2(ak, x([
                Xx("text-black")
            ]), x([
                ld("(" + oe(t) + " y/o)")
            ]))
        ]));
    }, Jmr = function(n) {
        return A2(K4, n, {
            d$: function(n) {
                return n.rh;
            },
            d1: Gmr
        });
    }, Wmr = x([
        {
            mr: 30,
            rh: "pat-1",
            tg: "Brandon"
        },
        {
            mr: 31,
            rh: "pat-2",
            tg: "Jessy"
        },
        {
            mr: 10,
            rh: "pat-3",
            tg: "Philip"
        },
        {
            mr: 7,
            rh: "pat-4",
            tg: "Sofia"
        }
    ]), Kmr = function(n) {
        var r = n.tg, t = n.mr;
        return A2(nk, h, x([
            A2(nk, h, x([
                ld("id: " + n.rh)
            ])),
            A2(nk, h, x([
                ld("name: " + r)
            ])),
            A2(nk, h, x([
                ld("age: " + oe(t))
            ]))
        ]));
    }, Xmr = Vdr({
        Ar: function() {
            var n = A2(x4, "tabs", "pat-1");
            return b({
                d_: n.a
            }, A2(Lp, iu, n.b));
        },
        DZ: function() {
            return zx;
        },
        En: Qmr,
        Et: function(n) {
            var r, t, e;
            return {
                gN: (r = n, t = r.d_, e = A2(Eu, Jmr, Wmr), x([
                    A2(Ck, iu, A2(j7, t, e)),
                    A3(Omr, Kmr, t, e)
                ])),
                w5: "Tabs"
            };
        }
    }), npr = x([
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Tags")
            ])),
            A2(nk, h, x([
                A2(pan, h, x([
                    ld("Default Tag")
                ])),
                A2(pan, x([
                    0
                ]), x([
                    ld("Success Tag")
                ])),
                A2(pan, x([
                    1
                ]), x([
                    ld("Info Tag")
                ])),
                A2(pan, x([
                    3
                ]), x([
                    ld("Warning Tag")
                ])),
                A2(pan, x([
                    2
                ]), x([
                    ld("Danger Tag")
                ]))
            ]))
        ]))
    ]), rpr = iRn({
        Et: function() {
            return {
                gN: npr,
                w5: "Tag"
            };
        }
    }), tpr = F2(function(n, r) {
        return m(r, {
            jM: n
        });
    }), epr = {
        $: 3
    }, upr = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, apr = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, ipr = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, cpr = function(n) {
        switch(n.$){
            case 1:
                return x([
                    Iq(n.a)
                ]);
            case 0:
                return x([
                    oT(n.a)
                ]);
            case 2:
                return x([
                    jT(n.a)
                ]);
            default:
                return h;
        }
    }, opr = function(n) {
        return rc(A2(Eu, cpr, n));
    }, fpr = function(n) {
        switch(n.$){
            case 1:
            case 0:
                return h;
            case 2:
                return x([
                    SC(x([
                        b("toggle--checked", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(Eu, ek(yu), r);
            default:
                return x([
                    Xx("toggle--card")
                ]);
        }
    }, spr = F2(function(n, r) {
        return A2(Tq, A2(Yt, Xx("toggle"), function(n) {
            return rc(A2(Eu, fpr, n));
        }(n)), x([
            A2(Zq, A2(Yt, Vq("radio"), A2(Yt, Xx("toggle__input"), opr(n))), h),
            A2(nk, x([
                Xx("toggle__text")
            ]), A2(Eu, Ck(yu), r))
        ]));
    }), lpr = xbr({
        Ar: function() {
            return {
                jM: "yes"
            };
        },
        En: tpr,
        Et: function(n) {
            var r, t;
            return {
                gN: (r = n, t = r.jM, x([
                    A2(nk, x([
                        Xx("section")
                    ]), x([
                        A2(Ak, x([
                            ok(x([
                                Xx("underline mb-2")
                            ]))
                        ]), x([
                            ld("Yes No Toggle")
                        ])),
                        A2(nk, x([
                            Xx("mb-4")
                        ]), x([
                            A2(spr, x([
                                epr,
                                ipr("yes"),
                                upr("yes" === t),
                                apr(iu)
                            ]), x([
                                ld("Yes")
                            ])),
                            A2(spr, x([
                                epr,
                                ipr("no"),
                                upr("no" === t),
                                apr(iu)
                            ]), x([
                                ld("No")
                            ]))
                        ]))
                    ]))
                ])),
                w5: "Toggle"
            };
        }
    }), dpr = A2(zN, h, x([
        A2(EN, x([
            JI(3)
        ]), x([
            A2(XH, x([
                HH("First Name")
            ]), x([
                A2(LV, "Showing over disabled input!", vI(x([
                    xI("Hover me!"),
                    YT(!0)
                ])))
            ]))
        ]))
    ])), bpr = A2(zN, h, x([
        A2(EN, x([
            JI(3)
        ]), x([
            A2(XH, x([
                HH("First Name")
            ]), x([
                A2(LV, "Showing over input!", vI(x([
                    xI("Hover me!")
                ])))
            ]))
        ]))
    ])), vpr = A2(LV, "Showing over text!", A2(ak, h, x([
        ld("Hover me!")
    ]))), mpr = A2(nk, x([
        Xx("flex flex-col space-y-6")
    ]), x([
        vpr,
        bpr,
        dpr
    ])), ppr = iRn({
        Et: function() {
            return {
                gN: x([
                    mpr
                ]),
                w5: "StyleGuide.Tooltip"
            };
        }
    }), $pr = iRn({
        Et: function() {
            return {
                gN: x([
                    ld("Homepage")
                ]),
                w5: "Homepage"
            };
        }
    }), hpr = x([
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Titles")
            ])),
            A2(nk, h, x([
                A2(yC, h, x([
                    ld("Huge Title")
                ])),
                A2(Ak, h, x([
                    ld("Big Title")
                ])),
                A2(rH, h, x([
                    ld("Base Title")
                ]))
            ]))
        ])),
        A2(nk, x([
            Xx("section")
        ]), x([
            A2(Ak, x([
                ok(x([
                    Xx("underline mb-2")
                ]))
            ]), x([
                ld("Type")
            ])),
            A2(nk, x([
                Xx("mt-4")
            ]), x([
                A2(Ek, h, x([
                    ld("Normal text")
                ])),
                A2(Ek, x([
                    $H
                ]), x([
                    ld("Support text")
                ])),
                A2(Ek, x([
                    bO
                ]), x([
                    ld("Danger text")
                ])),
                A2(Ek, x([
                    _Vn
                ]), x([
                    ld("Success text")
                ])),
                A2(Ek, x([
                    $ln
                ]), x([
                    ld("Warning text")
                ])),
                A2(Ek, x([
                    d2
                ]), x([
                    ld("Light gray text")
                ])),
                A2(Ek, x([
                    kC
                ]), x([
                    ld("Huge text")
                ])),
                A2(Ek, x([
                    lk
                ]), x([
                    ld("Big text")
                ])),
                A2(Ek, x([
                    aq
                ]), x([
                    ld("Medium text")
                ])),
                A2(Ek, x([
                    fq
                ]), x([
                    ld("Small text")
                ])),
                A2(Ek, x([
                    EZ
                ]), x([
                    ld("Extra small text")
                ]))
            ]))
        ]))
    ]), gpr = iRn({
        Et: function() {
            return {
                gN: hpr,
                w5: "Typography"
            };
        }
    }), wpr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xpr = F3(function(n, r, t) {
        return b({
            kA: r.kA,
            dB: n,
            fL: cP,
            fR: Ut,
            xs: t
        }, A3(Smn, r.gF, Bx(n), wpr));
    }), kpr = F2(function(n, r) {
        return b(r, Pp);
    }), ypr = F2(function(n, r) {
        return r;
    }), _pr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Apr = F2(function(n, r) {
        if (n.$) {
            var t = n.a, e = r.fR;
            if (e.$) return v(r, Pp, h);
            var u = A2(Olr, t, e.a), a = u.b;
            return v(m(r, {
                fR: Vt(u.a)
            }), A2(Lp, _pr, a), h);
        }
        var i, c = n.a, o = m(r, {
            fL: c
        });
        switch(c.$){
            case 2:
                return v(o, Pp, x([
                    gA(c.a)
                ]));
            case 3:
                return v(m(o, {
                    fR: Vt(A2(dlr, r.dB, (i = c.a, {
                        ld: i.ld,
                        le: i.le,
                        lf: i.lf,
                        lA: i.lA
                    })))
                }), Pp, h);
            default:
                return v(o, Pp, h);
        }
    }), Cpr = F2(function(n, r) {
        return x([
            A2(nk, x([
                Xx("signup__body--contents")
            ]), x([
                A2(Ck, _pr, A3(odr, n, r, Ut))
            ]))
        ]);
    }), Bpr = F2(function(n, r) {
        return {
            gN: function() {
                var t = b(r.fL, r.fR);
                n: for(;;)switch(t.a.$){
                    case 3:
                        if (t.b.$) break n;
                        return A2(Cpr, n, t.b.a);
                    case 2:
                        return x([
                            p5n(r.dB)
                        ]);
                    default:
                        break n;
                }
                return ck;
            }(),
            w5: n(JGn)
        };
    }), Epr = Fk({
        Ar: xpr,
        AQ: kpr,
        Db: ypr,
        DZ: function() {
            return zx;
        },
        En: Apr,
        Et: Bpr
    }), Dpr = Wn("fullStoryPortStopCapturing", function() {
        return yx;
    }), qpr = Dpr(0), Fpr = qpr, Ppr = F2(function() {
        return v({}, Fpr, h);
    }), zpr = F2(function(n, r) {
        return b(r, Pp);
    }), jpr = F2(function(n, r) {
        return r;
    }), Spr = F2(function(n, r) {
        return v(r, Pp, h);
    }), Lpr = {
        Ar: Ppr,
        AQ: zpr,
        Db: jpr,
        DZ: function() {
            return zx;
        },
        En: Spr,
        Et: function() {
            return {
                gN: x([
                    ld("Homepage")
                ]),
                w5: "Homepage"
            };
        }
    }, Mpr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Npr = {
        pP: "",
        eF: 1,
        qB: "",
        rS: ""
    }, Hpr = function(n) {
        switch(n){
            case 0:
                return "firstName";
            case 1:
                return "lastName";
            case 2:
                return "email";
            default:
                return "provider";
        }
    }, Tpr = F3(function(n, r, t) {
        var e = A2(Wu, "practitioner", t.iF);
        return b({
            gF: r.gF,
            kA: r.kA,
            kB: lS(Npr),
            uy: spn("waitlist-phone"),
            dB: n,
            a7: !i(e, Ut),
            cJ: cP,
            b6: !1,
            cQ: e,
            wS: Ut,
            jE: !1,
            dX: !1,
            x: A2(vS, x([
                0,
                1,
                2,
                3
            ]), Hpr)
        }, A4(zqn, r.gF, Bx(n), function(n) {
            return m(n, {
                hY: 100,
                lP: Vt(!0)
            });
        }, Mpr));
    }), Ipr = F2(function(n, r) {
        return b(r, Pp);
    }), Rpr = F2(function(n, r) {
        return r;
    }), Zpr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Vpr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    qB: n.a
                });
            case 1:
                return m(r, {
                    rS: n.a
                });
            case 2:
                return m(r, {
                    pP: n.a
                });
            default:
                return m(r, {
                    eF: A2(sc, 1, pu(n.a))
                });
        }
    }), Upr = nM(x([
        A2(fnr, function(n) {
            return n.qB;
        }, b(0, eM(uM("First Name")))),
        A2(fnr, function(n) {
            return n.rS;
        }, b(1, eM(uM("Last Name"))))
    ])), Ypr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qpr = F2(function(n, r) {
        var t = FL(n.kB), e = _x(x([
            b("waitlist_entry", _x(rc(x([
                x([
                    b("practitioner_id", Ax(r)),
                    b("first_name", Ax(t.qB)),
                    b("last_name", Ax(t.rS)),
                    b("enroll_count", EX(t.eF))
                ]),
                vu(t.pP) ? h : x([
                    b("email", Ax(t.pP))
                ]),
                x([
                    b("phone", UPn(n.uy))
                ])
            ]))))
        ]));
        return A4(bL, gQ(n.gF), w$, Ypr, A2(vL, e, rA(A2(X_, x([
            "waitlist_entries"
        ]), lL(Bx(n.dB))))));
    }), Opr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = F2(function(n, r) {
                    return A2(jE, function(r) {
                        return i(czn(r), n);
                    }, r);
                }), u = function() {
                    if (r.a7) {
                        var n = b(r.cQ, t);
                        if (n.a.$ || 3 !== n.b.$) return b(r.cQ, !1);
                        var u = n.a.a;
                        return A2(e, u, n.b.a) ? b(Vt(u), !1) : b(Ut, !0);
                    }
                    return b(3 === t.$ && t.a.b && !t.a.b.b ? Vt(czn(t.a.a)) : r.cQ, !1);
                }();
                return v(m(r, {
                    a7: r.a7 && !u.b,
                    cJ: t,
                    cQ: u.a
                }), Pp, h);
            case 1:
                var a = n.a;
                return v(m(r, {
                    b6: !1,
                    cQ: vu(a) ? Ut : Vt(a)
                }), Pp, h);
            case 2:
                return v(m(r, {
                    kB: A3(dN, Vpr, c = n.a, r.kB)
                }), Pp, h);
            case 3:
                var c, o = function(n) {
                    switch(n.$){
                        case 0:
                            return 0;
                        case 1:
                            return 1;
                        default:
                            return 2;
                    }
                }(c = n.a), f = A3(FM, !0, o, r.x), s = (A = A2(BM, Upr, A3(dN, Vpr, c, r.kB))).$ ? A.a : A.a.a;
                return v(m(r, {
                    kB: s,
                    x: f
                }), Pp, h);
            case 4:
                var l = A2(hwn, n.a, r.uy), d = l.b;
                return v(m(r, {
                    uy: l.a
                }), A2(Lp, Zpr, d), h);
            case 5:
                var p = A2(Nwn, !0, r.uy), $ = A2(BM, Upr, r.kB), g = jwn(p), w = i(r.cQ, Ut) && !r.a7, x = T6n(r.x), k = $.$ ? $.a : $.a.a;
                if (!$.$ && !w && g) {
                    var y = r.cQ;
                    if (y.$) return v(m(r, {
                        kB: k,
                        uy: p,
                        b6: !0,
                        x: x
                    }), Pp, h);
                    var _ = y.a;
                    return v(m(r, {
                        kB: k,
                        uy: p,
                        b6: !1,
                        wS: Ut,
                        dX: !0,
                        x: x
                    }), A2(Qpr, r, _), h);
                }
                return v(m(r, {
                    kB: k,
                    uy: p,
                    b6: w,
                    x: x
                }), Pp, h);
            default:
                return v(m(r, 3 === (t = n.a).$ ? {
                    jE: !0,
                    dX: !1
                } : {
                    wS: Vt(A2(Wx, r.kA, MTn)),
                    dX: !1
                }), Pp, h);
        }
        var A;
    }), Gpr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jpr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Wpr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Kpr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xpr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, n$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, r$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, t$r = {
        $: 5
    }, e$r = cr("select"), u$r = F3(function(n, r, t) {
        return A2(bN, t, r) && A2(QH, t, n);
    }), a$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, i$r = F3(function(n, r, t) {
        return A2(bN, t, r) ? A2(PH, t, n) : h;
    }), c$r = F2(function(n, r) {
        var t, e = 3 === (t = r.cJ).$ ? t.a : h, u = FL(r.kB);
        return A2(nk, h, x([
            function() {
                var n = r.wS;
                if (n.$) return tB;
                var t = n.a;
                return A2(nk, x([
                    Xx("message-box message-box--error mb-4")
                ]), x([
                    ld(t)
                ]));
            }(),
            r.a7 || TE(e) ? tB : A2(nk, h, x([
                A2(XH, x([
                    HH(n(STn)),
                    VH(!0)
                ]), x([
                    A2(e$r, x([
                        Xx(r.b6 ? "input input--invalid" : "input"),
                        oT(r$r)
                    ]), A2(Yt, A2(f7, x([
                        Iq("")
                    ]), x([
                        ld(n(LTn))
                    ])), A2(Eu, function(n) {
                        return A2(f7, x([
                            Iq(czn(n)),
                            l7(i(r.cQ, Vt(czn(n))))
                        ]), x([
                            ld(MP(n))
                        ]));
                    }, e)))
                ])),
                r.b6 ? A2(ET, n, x([
                    eM(cSn("Provider"))
                ])) : tB
            ])),
            A2(XH, x([
                HH(n(_Tn)),
                VH(!0)
            ]), x([
                vI(x([
                    xI(u.qB),
                    gI(A2(pc, Xpr, Kpr)),
                    XT(Wpr(Kpr(u.qB))),
                    JT(A3(u$r, r.kB, r.x, 0)),
                    iI(n(ATn))
                ])),
                A2(ET, n, A3(i$r, r.kB, r.x, 0))
            ])),
            A2(XH, x([
                HH(n(FTn)),
                VH(!0)
            ]), x([
                vI(x([
                    xI(u.rS),
                    gI(A2(pc, Xpr, n$r)),
                    XT(Wpr(n$r(u.rS))),
                    JT(A3(u$r, r.kB, r.x, 1)),
                    iI(n(PTn))
                ])),
                A2(ET, n, A3(i$r, r.kB, r.x, 1))
            ])),
            A2(XH, x([
                HH(n(xTn))
            ]), x([
                vI(x([
                    xI(u.pP),
                    gI(A2(pc, Xpr, Gpr)),
                    XT(Wpr(Gpr(u.pP))),
                    iI(n(kTn))
                ]))
            ])),
            A2(XH, x([
                HH(n(jTn))
            ]), x([
                A2(Ck, Zpr, A3(Myn, n, x([
                    a$r(!0)
                ]), r.uy))
            ])),
            A2(XH, x([
                HH(n(yTn))
            ]), x([
                vI(x([
                    xI(oe(u.eF)),
                    GT(0),
                    gI(A2(pc, Xpr, Jpr))
                ]))
            ])),
            A2(nk, x([
                Xx("mt-6 flex justify-center")
            ]), x([
                A2(OC, x([
                    qC,
                    uln(r.dX),
                    EC(t$r)
                ]), x([
                    ld(n(ETn))
                ]))
            ]))
        ]));
    }), o$r = function(n) {
        var r = function() {
            var r = b(n.cQ, n.cJ);
            if (r.a.$ || 3 !== r.b.$) return Ex(n.dB);
            var t = r.a.a, e = r.b.a;
            return A2(sc, Ex(n.dB), A2(Fp, MP, rv(A2(Rc, function(n) {
                return i(czn(n), t);
            }, e))));
        }();
        return A2(nk, x([
            Xx("text-center py-8")
        ]), x([
            A2(Ak, x([
                _H(fO)
            ]), x([
                ld(A2(Wx, n.kA, HTn))
            ])),
            A2(Ek, h, x([
                ld(A2(Wx, n.kA, NTn) + " " + r + ".")
            ]))
        ]));
    }, f$r = F2(function(n, r) {
        return {
            gN: x([
                A2(nk, x([
                    Xx("signup__body bg-white")
                ]), x([
                    A2(nk, x([
                        Xx("signup__page-border")
                    ]), h),
                    A2(nk, x([
                        Xx("signup__page-center")
                    ]), x([
                        A2(nk, x([
                            Xx("flex-col w-full")
                        ]), x([
                            A2(yC, x([
                                SV,
                                _H(fO),
                                A2(D2n, 1, x2n),
                                rB(oB),
                                A2(w2n, 1, DB)
                            ]), x([
                                ld(n(zTn) + " \u2014 " + Ex(r.dB))
                            ])),
                            r.jE ? o$r(r) : A2(c$r, n, r)
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("signup__page-border")
                    ]), h)
                ]))
            ]),
            w5: n(zTn) + " \u2014 " + Ex(r.dB)
        };
    }), s$r = Fk({
        Ar: Tpr,
        AQ: Ipr,
        Db: Rpr,
        DZ: function() {
            return zx;
        },
        En: Opr,
        Et: f$r
    }), l$r = F2(function(n, r) {
        return {
            gN: A2(Eu, Ck(n), r.gN),
            w5: r.w5
        };
    }), d$r = F3(function(n, r, t) {
        var e = t.b, u = t.c;
        return v(n(t.a), r(e), u);
    }), b$r = F3(function(n, r, t) {
        var e = F2(function(e, u) {
            return A3(d$r, n, Lp(r), A2(t.En, e, u));
        }), u = F2(function(e, u) {
            return A3(Ip, n, Lp(r), A2(t.AQ, u, e));
        }), a = F2(function(e, u) {
            return A3(d$r, n, Lp(r), A2(t.Ar, u, A2(eJ, e, u.xs)));
        });
        return {
            a: function(n) {
                return {
                    AQ: function() {
                        return u(n);
                    },
                    Db: function() {
                        return t.Db(n);
                    },
                    DZ: function() {
                        return A2(_S, r, t.DZ(n));
                    },
                    Et: function() {
                        return A2(l$r, r, t.Et(n));
                    }
                };
            },
            Ar: a,
            En: e
        };
    }), v$r = {
        f1: A3(b$r, Q$, O$, TA),
        f2: A3(b$r, U$, Y$, XE),
        f3: A3(b$r, G$, J$, iD),
        f4: A3(b$r, rh, th, BF),
        f5: A3(b$r, W$, K$, Nj),
        f6: A3(b$r, X$, nh, HR),
        f7: A3(b$r, ah, ih, AU),
        f8: A3(b$r, eh, uh, GG),
        f9: A3(b$r, ch, oh, p6),
        ga: A3(b$r, fh, sh, c4),
        gb: A3(b$r, lh, dh, M7),
        gc: A3(b$r, bh, vh, O7),
        gd: A3(b$r, $h, hh, Qnn),
        ge: A3(b$r, mh, ph, iun),
        gf: A3(b$r, yh, _h, Dan),
        gg: A3(b$r, gh, wh, Gon),
        gh: A3(b$r, xh, kh, bdn),
        gi: A3(b$r, Fh, Ph, abn),
        gj: A3(b$r, Dh, qh, ymn),
        gk: A3(b$r, Ah, Ch, Kyn),
        gl: A3(b$r, Bh, Eh, fAn),
        gm: A3(b$r, Hh, Th, nCn),
        gn: A3(b$r, Sh, Lh, wEn),
        go: A3(b$r, zh, jh, gIn),
        gp: A3(b$r, Mh, Nh, VIn),
        gq: A3(b$r, Zh, Vh, WIn),
        gr: A3(b$r, Ih, Rh, uRn),
        gs: A3(b$r, Uh, Yh, cRn),
        gt: A3(b$r, Gh, Jh, ERn),
        gu: A3(b$r, Qh, Oh, SZn),
        gv: A3(b$r, rg, tg, pVn),
        gw: A3(b$r, Xh, ng, jVn),
        gx: A3(b$r, Wh, Kh, wUn),
        gy: A3(b$r, eg, ug, lYn),
        gz: A3(b$r, ag, ig, pQn),
        gA: A3(b$r, cg, og, _Qn),
        gB: A3(b$r, fg, sg, BQn),
        gC: A3(b$r, lg, dg, RQn),
        gJ: A3(b$r, bg, vg, JQn),
        gL: A3(b$r, mg, pg, WQn),
        gO: A3(b$r, $g, hg, hOn),
        gP: A3(b$r, gg, wg, LOn),
        gQ: A3(b$r, xg, kg, ZOn),
        gR: A3(b$r, yg, _g, eGn),
        gZ: A3(b$r, Ag, Cg, DGn),
        g_: A3(b$r, Bg, Eg, LGn),
        ho: A3(b$r, Dg, qg, KGn),
        hp: A3(b$r, Fg, Pg, RGn),
        h$: A3(b$r, zg, jg, oWn),
        h0: A3(b$r, Sg, Lg, RWn),
        h1: A3(b$r, Mg, Ng, QKn),
        ib: A3(b$r, Hg, Tg, OKn),
        ff: A3(b$r, Ig, Rg, GKn),
        i0: A3(b$r, Zg, Vg, O2n),
        i1: A3(b$r, Ug, Yg, h5n),
        i2: A3(b$r, Qg, Og, Zrr),
        i3: A3(b$r, Gg, Jg, mur),
        i4: A3(b$r, Wg, Kg, Yar),
        i5: A3(b$r, Xg, nw, gor),
        i6: A3(b$r, rw, tw, Sfr),
        i7: A3(b$r, ew, uw, slr),
        i8: A3(b$r, aw, iw, Bdr),
        i9: A3(b$r, cw, ow, jdr),
        ja: A3(b$r, fw, sw, Idr),
        jd: A3(b$r, lw, dw, Zdr),
        je: A3(b$r, bw, vw, Ydr),
        jf: A3(b$r, mw, pw, Xdr),
        jg: A3(b$r, $w, hw, wbr),
        jh: A3(b$r, gw, ww, ybr),
        ji: A3(b$r, xw, kw, Ebr),
        jj: A3(b$r, yw, _w, jbr),
        jk: A3(b$r, Aw, Cw, Rbr),
        jl: A3(b$r, Bw, Ew, dvr),
        jm: A3(b$r, Dw, qw, Evr),
        jn: A3(b$r, Fw, Pw, qvr),
        jo: A3(b$r, zw, jw, Svr),
        jp: A3(b$r, Sw, Lw, Rvr),
        jq: A3(b$r, Mw, Nw, nmr),
        jr: A3(b$r, Hw, Tw, bmr),
        js: A3(b$r, Iw, Rw, mmr),
        jt: A3(b$r, Zw, Vw, ymr),
        ju: A3(b$r, Uw, Yw, Mmr),
        jv: A3(b$r, Qw, Ow, Vmr),
        jw: A3(b$r, Gw, Jw, Ymr),
        jx: A3(b$r, Ww, Kw, Xmr),
        jy: A3(b$r, Xw, nx, rpr),
        jz: A3(b$r, rx, tx, lpr),
        jA: A3(b$r, ex, ux, ppr),
        jB: A3(b$r, ax, ix, $pr),
        jC: A3(b$r, cx, ox, gpr),
        jJ: A3(b$r, fx, sx, Epr),
        lK: A3(b$r, lx, dx, Lpr),
        q: A3(b$r, bx, vx, s$r)
    }, m$r = function(n) {
        switch(n.$){
            case 0:
                return v$r.lK.Ar(0);
            case 1:
                return v$r.ho.Ar(0);
            case 2:
                return v$r.ib.Ar(0);
            case 3:
                return v$r.ff.Ar(0);
            case 4:
                return v$r.jJ.Ar(0);
            case 5:
                return v$r.q.Ar(0);
            case 6:
                return v$r.gC.Ar(0);
            case 7:
                return v$r.gR.Ar(0);
            case 8:
                return v$r.g_.Ar(0);
            case 9:
                return v$r.hp.Ar(0);
            case 10:
                return v$r.ja.Ar(0);
            case 11:
                return v$r.jB.Ar(0);
            case 12:
                return v$r.f4.Ar(0);
            case 13:
                return v$r.f7.Ar(0);
            case 14:
                return v$r.f9.Ar(0);
            case 15:
                return v$r.ga.Ar(0);
            case 16:
                return v$r.gb.Ar(0);
            case 17:
                return v$r.gc.Ar(0);
            case 18:
                return v$r.gd.Ar(0);
            case 19:
                return v$r.gf.Ar(0);
            case 20:
                return v$r.gi.Ar(0);
            case 21:
                return v$r.gm.Ar(0);
            case 22:
                return v$r.gq.Ar(0);
            case 23:
                return v$r.gs.Ar(0);
            case 24:
                return v$r.gv.Ar(0);
            case 25:
                return v$r.gz.Ar(0);
            case 26:
                return v$r.gA.Ar(0);
            case 27:
                return v$r.gQ.Ar(0);
            case 28:
                return v$r.h$.Ar(0);
            case 29:
                return v$r.h0.Ar(0);
            case 30:
                return v$r.h1.Ar(0);
            case 31:
                return v$r.jd.Ar(0);
            case 32:
                return v$r.je.Ar(0);
            case 33:
                return v$r.jf.Ar(0);
            case 34:
                return v$r.jg.Ar(0);
            case 35:
                return v$r.jh.Ar(0);
            case 36:
                return v$r.ji.Ar(0);
            case 37:
                return v$r.jj.Ar(0);
            case 38:
                return v$r.jk.Ar(0);
            case 39:
                return v$r.jl.Ar(0);
            case 40:
                return v$r.jm.Ar(0);
            case 41:
                return v$r.jn.Ar(0);
            case 42:
                return v$r.jo.Ar(0);
            case 43:
                return v$r.jp.Ar(0);
            case 44:
                return v$r.jq.Ar(0);
            case 45:
                return v$r.jr.Ar(0);
            case 46:
                return v$r.js.Ar(0);
            case 47:
                return v$r.jt.Ar(0);
            case 48:
                return v$r.ju.Ar(0);
            case 49:
                return v$r.jv.Ar(0);
            case 50:
                return v$r.jw.Ar(0);
            case 51:
                return v$r.jx.Ar(0);
            case 52:
                return v$r.jy.Ar(0);
            case 53:
                return v$r.jz.Ar(0);
            case 54:
                return v$r.jA.Ar(0);
            case 55:
                return v$r.jC.Ar(0);
            case 56:
                return v$r.gB.Ar(n.a);
            case 57:
                return v$r.gL.Ar(n.a);
            case 58:
                return v$r.gZ.Ar(n.a);
            case 59:
                return v$r.i9.Ar(n.a);
            case 60:
                return v$r.f8.Ar(0);
            case 61:
                return v$r.gr.Ar(0);
            case 62:
                return v$r.gJ.Ar(n.a);
            case 63:
                return v$r.i0.Ar(n.a);
            case 64:
                return v$r.i1.Ar(n.a);
            case 65:
                return v$r.i2.Ar(n.a);
            case 66:
                return v$r.i3.Ar(n.a);
            case 67:
                return v$r.i4.Ar(n.a);
            case 68:
                return v$r.i5.Ar(n.a);
            case 69:
                return v$r.i6.Ar(n.a);
            case 70:
                return v$r.i7.Ar(n.a);
            case 71:
                return v$r.i8.Ar(n.a);
            case 72:
                return v$r.ge.Ar(n.a);
            case 73:
                return v$r.gg.Ar(n.a);
            case 74:
                return v$r.gj.Ar(n.a);
            case 75:
                return v$r.gn.Ar(n.a);
            case 76:
                return v$r.gt.Ar(n.a);
            case 77:
                return v$r.gw.Ar(n.a);
            case 78:
                return v$r.f1.Ar(n.a);
            case 79:
                return v$r.f2.Ar(n.a);
            case 80:
                return v$r.f3.Ar(n.a);
            case 81:
                return v$r.gh.Ar(n.a);
            case 82:
                return v$r.gk.Ar(n.a);
            case 83:
                return v$r.gl.Ar(n.a);
            case 84:
                return v$r.go.Ar(n.a);
            case 85:
                return v$r.gp.Ar(n.a);
            case 86:
                return v$r.gu.Ar(n.a);
            case 87:
                return v$r.gx.Ar(n.a);
            case 88:
                return v$r.gy.Ar(n.a);
            case 89:
                return v$r.gO.Ar(n.a);
            case 90:
                return v$r.gP.Ar(n.a);
            case 91:
                return v$r.f5.Ar(n.a);
            default:
                return v$r.f6.Ar(n.a);
        }
    }, p$r = function(n) {
        return A2(xH, "/account/messaging", n) || A2(xH, "/account/chat", n);
    }, $$r = function(n) {
        return A2(xH, "/account", n);
    }, h$r = function(n) {
        return A2(xH, "/login", n);
    }, g$r = function(n) {
        return A2(xH, "/appointments", n);
    }, w$r = function(n) {
        return A2(xH, "/signup", n) || A2(xH, "/enroll", n) || A2(xH, "/checkout", n);
    }, x$r = function(n) {
        return function(n) {
            return A2(xH, "/style-guide", n);
        }(n) ? 1 : w$r(n) ? 0 : h$r(n) ? 2 : kH(n) || function(n) {
            return A2(xH, "/account/booking", n);
        }(n) ? 4 : g$r(n) || function(n) {
            return A2(xH, "/account/appointments", n);
        }(n) ? 5 : p$r(n) ? 6 : $$r(n) ? 3 : 7;
    }, k$r = function(n) {
        return x$r(n);
    }, y$r = Wn("sentryPortCaptureErrorMessage", function(n) {
        var r = n.b;
        return A2(KK, iu, x([
            Ax(n.a),
            r
        ]));
    }), _$r = F2(function(n, r) {
        return y$r(b(n, A3(ntn, iu, iu, r)));
    }), A$r = A6(ou, 0, "localhost", Ut, "", Ut, Ut), C$r = function(n) {
        var r = ku(n);
        return r.$ ? b(A$r, A2(_$r, "Url.fromString Failed: " + n, da)) : b(r.a, Pp);
    }, B$r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, E$r = {
        $: 29
    }, D$r = function(n) {
        return {
            $: 18,
            a: n
        };
    }, q$r = function(n) {
        return {
            $: 22,
            a: n
        };
    }, F$r = function(n) {
        return {
            $: 24,
            a: n
        };
    }, P$r = function(n) {
        return {
            $: 4,
            a: n
        };
    }, z$r = function(n) {
        return {
            $: 5,
            a: n
        };
    }, j$r = function(n) {
        return {
            $: 8,
            a: n
        };
    }, S$r = {
        $: 23
    }, L$r = function(n) {
        return {
            $: 28,
            a: n
        };
    }, M$r = nr("accountTokenRemovedPort", oy(0)), N$r = M$r, H$r = nr("idleUser", jk), T$r = nr("onBeforeUnload", jk), I$r = function(n) {
        switch(n.$){
            case 0:
                return v$r.lK.a(n.a);
            case 1:
                return v$r.ho.a(n.a);
            case 2:
                return v$r.ib.a(n.a);
            case 3:
                return v$r.ff.a(n.a);
            case 4:
                return v$r.jJ.a(n.a);
            case 5:
                return v$r.q.a(n.a);
            case 6:
                return v$r.gC.a(n.a);
            case 7:
                return v$r.gR.a(n.a);
            case 8:
                return v$r.g_.a(n.a);
            case 9:
                return v$r.hp.a(n.a);
            case 10:
                return v$r.ja.a(n.a);
            case 11:
                return v$r.jB.a(n.a);
            case 12:
                return v$r.f4.a(n.a);
            case 13:
                return v$r.f7.a(n.a);
            case 14:
                return v$r.f9.a(n.a);
            case 15:
                return v$r.ga.a(n.a);
            case 16:
                return v$r.gb.a(n.a);
            case 17:
                return v$r.gc.a(n.a);
            case 18:
                return v$r.gd.a(n.a);
            case 19:
                return v$r.gf.a(n.a);
            case 20:
                return v$r.gi.a(n.a);
            case 21:
                return v$r.gm.a(n.a);
            case 22:
                return v$r.gq.a(n.a);
            case 23:
                return v$r.gs.a(n.a);
            case 24:
                return v$r.gv.a(n.a);
            case 25:
                return v$r.gz.a(n.a);
            case 26:
                return v$r.gA.a(n.a);
            case 27:
                return v$r.gQ.a(n.a);
            case 28:
                return v$r.h$.a(n.a);
            case 29:
                return v$r.h0.a(n.a);
            case 30:
                return v$r.h1.a(n.a);
            case 31:
                return v$r.jd.a(n.a);
            case 32:
                return v$r.je.a(n.a);
            case 33:
                return v$r.jf.a(n.a);
            case 34:
                return v$r.jg.a(n.a);
            case 35:
                return v$r.jh.a(n.a);
            case 36:
                return v$r.ji.a(n.a);
            case 37:
                return v$r.jj.a(n.a);
            case 38:
                return v$r.jk.a(n.a);
            case 39:
                return v$r.jl.a(n.a);
            case 40:
                return v$r.jm.a(n.a);
            case 41:
                return v$r.jn.a(n.a);
            case 42:
                return v$r.jo.a(n.a);
            case 43:
                return v$r.jp.a(n.a);
            case 44:
                return v$r.jq.a(n.a);
            case 45:
                return v$r.jr.a(n.a);
            case 46:
                return v$r.js.a(n.a);
            case 47:
                return v$r.jt.a(n.a);
            case 48:
                return v$r.ju.a(n.a);
            case 49:
                return v$r.jv.a(n.a);
            case 50:
                return v$r.jw.a(n.a);
            case 51:
                return v$r.jx.a(n.a);
            case 52:
                return v$r.jy.a(n.a);
            case 53:
                return v$r.jz.a(n.a);
            case 54:
                return v$r.jA.a(n.a);
            case 55:
                return v$r.jC.a(n.a);
            case 56:
                return v$r.gB.a(n.a);
            case 57:
                return v$r.gL.a(n.a);
            case 58:
                return v$r.gZ.a(n.a);
            case 59:
                return v$r.i9.a(n.a);
            case 60:
                return v$r.f8.a(n.a);
            case 61:
                return v$r.gr.a(n.a);
            case 62:
                return v$r.gJ.a(n.a);
            case 63:
                return v$r.i0.a(n.a);
            case 64:
                return v$r.i1.a(n.a);
            case 65:
                return v$r.i2.a(n.a);
            case 66:
                return v$r.i3.a(n.a);
            case 67:
                return v$r.i4.a(n.a);
            case 68:
                return v$r.i5.a(n.a);
            case 69:
                return v$r.i6.a(n.a);
            case 70:
                return v$r.i7.a(n.a);
            case 71:
                return v$r.i8.a(n.a);
            case 72:
                return v$r.ge.a(n.a);
            case 73:
                return v$r.gg.a(n.a);
            case 74:
                return v$r.gj.a(n.a);
            case 75:
                return v$r.gn.a(n.a);
            case 76:
                return v$r.gt.a(n.a);
            case 77:
                return v$r.gw.a(n.a);
            case 78:
                return v$r.f1.a(n.a);
            case 79:
                return v$r.f2.a(n.a);
            case 80:
                return v$r.f3.a(n.a);
            case 81:
                return v$r.gh.a(n.a);
            case 82:
                return v$r.gk.a(n.a);
            case 83:
                return v$r.gl.a(n.a);
            case 84:
                return v$r.go.a(n.a);
            case 85:
                return v$r.gp.a(n.a);
            case 86:
                return v$r.gu.a(n.a);
            case 87:
                return v$r.gx.a(n.a);
            case 88:
                return v$r.gy.a(n.a);
            case 89:
                return v$r.gO.a(n.a);
            case 90:
                return v$r.gP.a(n.a);
            case 91:
                return v$r.f5.a(n.a);
            default:
                return v$r.f6.a(n.a);
        }
    }, R$r = function(n) {
        return I$r(n).DZ(0);
    }, Z$r = function(n) {
        return A2(nk, h, n.gN);
    }, V$r = {
        $: 1
    }, U$r = function(n) {
        return I$r(n).AQ(0);
    }, Y$r = function(n) {
        return I$r(n).Db(0);
    }, Q$r = at, O$r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, G$r = {
        $: 1
    }, J$r = function(n) {
        return {
            $: 21,
            a: n
        };
    }, W$r = function(n) {
        return {
            $: 17,
            a: n
        };
    }, K$r = function(n) {
        return {
            $: 25,
            a: n
        };
    }, X$r = function(n) {
        return {
            $: 30,
            a: n
        };
    }, nhr = function(n) {
        return {
            $: 19,
            a: n
        };
    }, rhr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), thr = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), ehr = Wn("fullStoryPortIdentifyPatientPortal", iu), uhr = F2(function(n, r) {
        return ehr(_x(x([
            b("scope", A2(sc, yx, A2(Fp, Ax, n))),
            b("userId", A2(sc, yx, A2(Fp, Ax, r)))
        ])));
    }), ahr = F2(function(n, r) {
        return A2(uhr, n, r);
    }), ihr = F2(function(n, r) {
        return A2(ahr, n, r);
    }), chr = F2(function(n, r) {
        return r.$ ? r : gc(m(r.a, {
            hT: n
        }));
    }), ohr = iu, fhr = function(n) {
        var r = n.a, t = n.b, e = r.dB;
        if (3 === e.$) {
            var u = MPn(e.a) ? A2(sc, r.kA, A2(Fp, ohr, r.Eq)) : r.kA;
            return b(m(r, {
                gF: A2(chr, u, r.gF),
                kA: u,
                cB: A2(Z$, u, r.cB)
            }), t);
        }
        return b(r, t);
    }, shr = function(n) {
        return n.b.nz;
    }, lhr = F2(function(n, r) {
        return !!A2(a2, r, n);
    }), dhr = F3(function(n, r, t) {
        switch(n.$){
            case 3:
                return n.a.wh;
            case 0:
                if (shr(r)) {
                    var e = r.b.t4, u = function(n) {
                        return n.b.t3;
                    }(r), a = b(e, u);
                    return a.a && !a.b.$ ? A2(lhr, a.b.a, t) : shr(r);
                }
                return !1;
            default:
                return !1;
        }
    }), bhr = F4(function(n, r, t, e) {
        return 3 === n.$ && A3(dhr, r, n.a, A2(bp, t, e));
    }), vhr = function(n) {
        return 1 === n.$ ? xc(m(n.a, {
            i: M$
        })) : gc(m(n.a, {
            i: M$
        }));
    }, mhr = function(n) {
        return E$(n.a.i) ? "limited_access" : "full_access";
    }, phr = function(n) {
        return A2(cD, "member_clinical_data_share", n);
    }, $hr = F3(function(n, r, t) {
        var e = _x(x([
            b("statusCode", EX(t.DT)),
            b("headers", A3(ntn, iu, Ax, t.hC))
        ])), u = _x(x([
            b("url", Ax(t.xs)),
            b("headers", A3(ntn, iu, Ax, r))
        ])), a = Ul(x([
            b("request", u),
            b("response", e)
        ]));
        return A2(_$r, "Decoder Failed: " + n, a);
    }), hhr = F3(function(n, r, t) {
        return A4(GZn, n, ORn, t, rA(A2(X_, x([
            "auth"
        ]), lL(r))));
    }), ghr = F4(function(n, r, t, e) {
        var u = _x(x([
            b("google_recaptcha_token", A2(yL, Ax, t))
        ]));
        return A4(bL, n, xWn, e, A2(vL, u, rA(A2(X_, x([
            "auth",
            "exchange_token"
        ]), lL(r)))));
    }), whr = Wn("fetchCustomJsFile", Ax), xhr = function(n) {
        return A2(sc, "", A2(yPn, 1, A2(Rc, function(n) {
            return "" !== n;
        }, A2(se, "/", n.Cq))));
    }, khr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a, e = xhr(r), u = Bx(t);
            return Vt(r.Ai + "-" + u + "-" + e);
        }
        return Ut;
    }), yhr = function(n) {
        var r = A2(khr, n.dB, n.xs);
        return r.$ ? Pp : RP(A2(iP, 0, r.a));
    }, _hr = "pageAbandoned", Ahr = RP(A2(iP, 1, _hr)), Chr = function(n) {
        var r, t = n.dB;
        if (3 === t.$) {
            var e = (r = function(n) {
                return n.b.oV;
            }(t.a), r.$ ? Pp : whr(r.a));
            return w$r(lc(n.xs)) ? b(n, Vu(x([
                Ahr,
                yhr(n),
                e
            ]))) : b(n, e);
        }
        return b(n, Pp);
    }, Bhr = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), Ehr = F5(function(n, r, t, e, u) {
        return {
            pn: u,
            rd: r,
            rh: n,
            kV: t,
            tg: e
        };
    }), Dhr = A3(ly, "dob", iy(ay), A3(ly, "name", C$, A3(ly, "meta", OR, A3(ly, "hipaa_authorization_accepted", jk, A3(ly, "id", C$, uu(Ehr)))))), qhr = A2(Pk, Dhr, uu(iu)), Fhr = A2(X_, x([
        "account"
    ]), sL), Phr = F2(function(n, r) {
        return A4(W_, n, qhr, r, rA(Fhr));
    }), zhr = F2(function(n, r) {
        var t = RA(n), e = lc(r);
        return t && ($$r(e) || h$r(e)) ? A2(Phr, n, Bhr(n)) : Pp;
    }), jhr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Shr = F3(function(n, r, t) {
        var e = b(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.b.a;
            return A4(Rbn, n, Bx(e.a.a), EL(u), jhr);
        }
        return Pp;
    }), Lhr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mhr = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Nhr = F2(function(n, r) {
        var t = r.x5;
        return t.$ ? uA(n.Ai) : Vt(t.a);
    }), Hhr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Thr = F2(function(n, r) {
        return {
            g2: n,
            DP: r
        };
    }), Ihr = function(n) {
        switch(n){
            case "patient_portal":
                return uu(0);
            case "packages":
                return uu(1);
            default:
                return uu(2);
        }
    }, Rhr = function(n) {
        switch(n){
            case "startup":
                return uu(0);
            case "growth":
                return uu(1);
            case "enterprise":
                return uu(2);
            case "call_us":
                return uu(3);
            default:
                return uu(4);
        }
    }, Zhr = A3(ly, "starting_tier", A2(nu, Rhr, C$), A3(ly, "code", A2(nu, Ihr, C$), uu(Thr))), Vhr = A2(Pk, A2(tu, iu, Zhr), uu(iu)), Uhr = A3(ly, "passthrough_fees_cutoff_enabled", jk, A3(ly, "passthrough_fees_cutoff_date", aL(ay), A3(ly, "membership_cancellation_enabled", jk, A3(ly, "charge_patients_credit_card_fees", jk, A3(ly, "default_patients_preferred_language", cbn, A3(ly, "features", vy(C$), A3(ly, "feature_gates", vy(Vhr), A3(ly, "address", iy(Qan), A3(ly, "phone", iy(C$), A3(ly, "custom_javascript", iy(C$), A3(ly, "encourage_ach", jk, A3(ly, "accepts_cards", jk, A3(ly, "accepts_ach", jk, A3(ly, "accepts_amex", jk, A3(ly, "requires_patient_mobile", jk, A3(ly, "requires_patient_email", jk, A3(ly, "trans_inclusivity", jk, A3(ly, "default_signup_page", iy(wlr), A3(ly, "email", iy(C$), A3(ly, "url", iy(C$), uu(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return {
                                                                                        lV: c,
                                                                                        lW: i,
                                                                                        lX: o,
                                                                                        mk: d,
                                                                                        nz: p,
                                                                                        oV: s,
                                                                                        o8: m,
                                                                                        pb: t,
                                                                                        pP: r,
                                                                                        pZ: f,
                                                                                        qs: b,
                                                                                        qt: v,
                                                                                        sz: $,
                                                                                        t3: h,
                                                                                        t4: g,
                                                                                        uw: l,
                                                                                        vO: u,
                                                                                        vP: a,
                                                                                        xi: e,
                                                                                        xs: n
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))), Yhr = A2(Pk, Uhr, A2(Pk, klr, uu(Hhr))), Qhr = F3(function(n, r, t) {
        return A4(W_, gQ(n), Yhr, t, rA(lL(r)));
    }), Ohr = F7(function(n, r, t, e, u, a, i) {
        return {
            yD: n,
            rb: i,
            t8: a,
            t9: e,
            ua: u,
            ub: t,
            uc: r
        };
    }), Ghr = A3(ly, "hide_powered_by_hint", jk, A3(ly, "patient_facing_favicon_apple_url", aL(C$), A3(ly, "patient_facing_favicon_png_url", aL(C$), A3(ly, "patient_facing_favicon_ico_url", aL(C$), A3(ly, "patient_facing_logo_alt_text", C$, A3(ly, "patient_facing_logo_url", aL(C$), A3(ly, "brand_name", C$, uu(Ohr)))))))), Jhr = A2(Pk, Ghr, uu(iu)), Whr = F3(function(n, r, t) {
        return A4(W_, gQ(n), Jhr, t, rA(function(n) {
            return A2(X_, x([
                "whitelabel_settings"
            ]), lL(n));
        }(r)));
    }), Khr = F2(function(n, r) {
        var t = aA(n.iF);
        if (t.$) {
            var e = A2(Nhr, n, r);
            if (e.$) return b(m(r, {
                dB: Ry(wy)
            }), Pp);
            var u = e.a;
            return b(m(r, {
                dB: cP
            }), Vu(x([
                A3(Qhr, r.gF, u, Lhr),
                A3(Whr, r.gF, u, Mhr)
            ])));
        }
        var a = t.a;
        return b(m(r, {
            dB: cP
        }), Vu(x([
            A3(Qhr, r.gF, a, Lhr),
            RP(A3(Lz, 2, "accountPracticeId", a)),
            A3(Whr, r.gF, a, Mhr)
        ])));
    }), Xhr = function(n) {
        return {
            $: 27,
            a: n
        };
    }, ngr = A2(tu, iu, A3(ly, "memberMessagingEnabled", jk, uu(function(n) {
        return {
            sv: n
        };
    }))), rgr = F3(function(n, r, t) {
        return A4(W_, n, ngr, t, rA(A2(X_, x([
            "practice-conversations-settings"
        ]), YA(r))));
    }), tgr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, egr = Wn("start", function() {
        return yx;
    }), ugr = function(n) {
        var r = n.dB;
        if (3 === r.$) {
            var t = r.a, e = egr(0);
            if (w$r(lc(n.xs))) {
                var u = xhr(n.xs), a = A2(sc, "", A2(Wu, "company", Zp(n.xs.iF)));
                return vu(a) ? Vu(x([
                    A4(TYn, n.gF, Bx(t), u, tgr),
                    e
                ])) : Vu(x([
                    A5(IYn, n.gF, Bx(t), a, u, tgr),
                    e
                ]));
            }
            return e;
        }
        return Pp;
    }, agr = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), igr = F2(function(n, r) {
        return A2(X_, x([
            "signup_steps"
        ]), A2(T1n, n, r));
    }), cgr = F7(function(n, r, t, e, u, a, i) {
        var c = vu(u) ? h : x([
            A2(Y_, "practitioner_id", u)
        ]), o = $(vu(e) ? h : x([
            A2(Y_, "online_enrollment_id", e)
        ]), $(c, vu(a) ? h : x([
            A2(Y_, "location_id", a)
        ])));
        return A4(W_, gQ(n), vy(M1n), i, A2(_P, o, rA(A2(igr, r, t))));
    }), ogr = F2(function(n, r) {
        var t, e, u, a, i = r.dB;
        if (3 === i.$) {
            var c = i.a, o = 2 === (a = r.fc).$ ? a.a : "", f = 3 === (u = r.fL).$ ? xGn(nQn(u.a)) : "", s = (e = Wfr(Zp(r.xs.iF))).$ ? "" : e.a, l = (t = _ur(Zp(r.xs.iF))).$ ? "" : t.a, d = b(w$r(lc(r.xs)), vu(f));
            return b(r, d.a ? d.b ? ED : A7(cgr, r.gF, Bx(c), f, o, s, l, agr(n)) : Pp);
        }
        return b(r, Pp);
    }), fgr = F3(function(n, r, t) {
        return A2(nv, function(r) {
            return Vt(A2(kGn, r.a, n));
        }, A3(A2n, n, r, t));
    }), sgr = F4(function(n, r, t, e) {
        var u = A3(fgr, n, r, t);
        return u.$ ? ED : A2(AA, e, u.a);
    }), lgr = {
        $: 1
    }, dgr = {
        $: 2
    }, bgr = function(n) {
        var r = hx(z_(n)) ? dgr : lgr;
        return 1 === n.$ ? xc(m(n.a, {
            i: r
        })) : gc(m(n.a, {
            i: r
        }));
    }, vgr = F2(function(n, r) {
        return A2(itn, n, x([
            A2(otn, "scope", r)
        ]));
    }), mgr = A2(AA, da, Ga), pgr = function(n) {
        return A2(AA, A2(sc, da, n), oi);
    }, $gr = function(n) {
        return pgr(Vt(A3(ta, "redirectTo", n.Cq, A2(sc, da, A2(Fp, Rp, n.iF)))));
    }, hgr = Vu(x([
        tJn,
        A2(Nu, iu, _u(E$r))
    ])), ggr = F2(function(n, r) {
        var t = r || !Tj(n.gF) && !gtn(n.gF) ? mgr : $gr(n.xs), e = A2(vgr, "Authentication - Session Not Valid", mhr(n.gF));
        return b(m(n, {
            gF: bgr(n.gF),
            yY: {
                yG: bgr(n.yY.yG),
                J: bgr(n.yY.J),
                fb: bgr(n.yY.fb),
                CP: bgr(n.yY.CP)
            },
            d3: Vt(n.xs)
        }), Vu(x([
            t,
            hgr,
            e
        ])));
    }), wgr = F2(function(n, r) {
        return 1 === r.$ ? xc(m(r.a, {
            i: n
        })) : gc(m(r.a, {
            i: n
        }));
    }), xgr = function(n) {
        if (n.$) return Ut;
        var r = n.a;
        return _$(r) ? B$(z$(r)) : Ut;
    }, kgr = {
        $: 15
    }, ygr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, _gr = F3(function(n, r, t) {
        return A4(bL, n, xWn, t, rA(A2(X_, x([
            "auth",
            "refresh"
        ]), lL(r))));
    }), Agr = F2(function(n, r) {
        return 3 === r.$ ? A3(_gr, n, Bx(r.a), ygr) : Pp;
    }), Cgr = F4(function(n, r, t, e) {
        var u = 12e4, a = b(n, r);
        if (a.a.$ || a.b.$) return Pp;
        var i = a.a.a, c = a.b.a;
        return s(c - i, u) > 0 ? A2(Nu, function() {
            return kgr;
        }, jp(c - i - u)) : A2(Agr, t, e);
    }), Bgr = Wn("setTokenPort", function(n) {
        return _x(x([
            b("key", Ax(n.hQ)),
            b("value", Ax(n.xz))
        ]));
    }), Egr = function(n) {
        return Bgr({
            hQ: "accountToken",
            xz: n
        });
    }, Dgr = function(n) {
        return A2(sc, Pp, A2(Fp, Egr, P_(z_(n))));
    }, qgr = F2(function(n, r) {
        var t = A2(wgr, n, r.hv), e = {
            yG: A2(wgr, n, r.yY.yG),
            J: A2(wgr, n, r.yY.J),
            fb: A2(wgr, n, r.yY.fb),
            CP: r.yY.CP
        }, u = A2(chr, A2(sc, 0, r.Eq), A2(wgr, n, r.gF)), a = function(n) {
            if (n.$) return Ut;
            var r = n.a;
            if (_$(r)) {
                var t = P$(x([
                    F$,
                    A2(tu, kp, q$)
                ]));
                return B$(A2(Kp, function(n) {
                    return 1e3 * n;
                }, A2(x$, A2(Tu, "iat", t), r)));
            }
            return Ut;
        }(n), i = xgr(n);
        return b(m(r, {
            gF: u,
            yY: e,
            hv: t
        }), Vu(x([
            Dgr(u),
            A4(Cgr, a, i, r.gF, r.dB)
        ])));
    }), Fgr = F2(function(n, r) {
        switch(r.$){
            case 3:
                var t = A2(qgr, r.a, n);
                return b(t.a, t.b);
            case 2:
                return r.a.$ ? b(m(n, {
                    t6: vc
                }), Pp) : A2(ggr, n, !1);
            default:
                return b(n, Pp);
        }
    }), Pgr = F2(function(n, r) {
        return 3 === n.$ ? KG(n.a) : XG(r);
    }), zgr = function(n) {
        return {
            $: 26,
            a: n
        };
    }, jgr = F2(function(n) {
        var r = b(n.ej, n.dB);
        if (r.a.$ || 3 !== r.b.$) return Pp;
        var t = r.b.a;
        return EQn(t) && oD(t) ? A3(UOn, n.yY.CP, Bx(t), zgr) : Pp;
    }), Sgr = F2(function(n, r) {
        if (p$r(r)) {
            var t = n.dB;
            return 3 === t.$ ? A2(Pgr, n.uN, t.a) ? A2(jgr, n, r) : A2(AA, da, Wa) : A2(jgr, n, r);
        }
        return $$r(r) ? A2(jgr, n, r) : Pp;
    }), Lgr = function(n) {
        return Sb(DQn(n));
    }, Mgr = Wn("rainforestPortLoad", Ax), Ngr = A2(ru, function(n) {
        return n ? "sandbox" : "production";
    }, Mgr), Hgr = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                    return "top";
                case 1:
                    return "enroll-thanks";
                case 2:
                    return "not-found";
                case 3:
                    return "patient-documents";
                case 4:
                    return "thanks";
                case 5:
                    return "waitlist";
                case 6:
                    return "account.top";
                case 7:
                    return "booking.top";
                case 8:
                    return "checkout.top";
                case 9:
                    return "enroll.top";
                case 10:
                    return "signup.top";
                case 11:
                    return "style-guide.top";
                case 12:
                    return "account.booking";
                case 13:
                    return "account.cart";
                case 14:
                    return "account.chat";
                case 15:
                    return "account.documents";
                case 16:
                    return "account.explore-services";
                case 17:
                    return "account.forbidden";
                case 18:
                    return "account.health-information";
                case 19:
                    return "account.invoices";
                case 20:
                    return "account.members";
                case 21:
                    return "account.memberships";
                case 22:
                    return "account.messaging";
                case 23:
                    return "account.not-found";
                case 24:
                    return "account.payment-sources";
                case 25:
                    return "account.practitioner-location";
                case 26:
                    return "account.session-expired";
                case 27:
                    return "booking.empty";
                case 28:
                    return "login.request";
                case 29:
                    return "login.select-patient";
                case 30:
                    return "login.verify-code";
                case 31:
                    return "style-guide.activity-indicator";
                case 32:
                    return "style-guide.address-input";
                case 33:
                    return "style-guide.alerts";
                case 34:
                    return "style-guide.api-select";
                case 35:
                    return "style-guide.button";
                case 36:
                    return "style-guide.card-example";
                case 37:
                    return "style-guide.cart-icon";
                case 38:
                    return "style-guide.checkbox";
                case 39:
                    return "style-guide.filter-example";
                case 40:
                    return "style-guide.form-example";
                case 41:
                    return "style-guide.grid";
                case 42:
                    return "style-guide.input";
                case 43:
                    return "style-guide.insurance-info";
                case 44:
                    return "style-guide.modal";
                case 45:
                    return "style-guide.multi-form";
                case 46:
                    return "style-guide.phone-input";
                case 47:
                    return "style-guide.radio";
                case 48:
                    return "style-guide.searchable-select";
                case 49:
                    return "style-guide.select";
                case 50:
                    return "style-guide.table";
                case 51:
                    return "style-guide.tabs";
                case 52:
                    return "style-guide.tag";
                case 53:
                    return "style-guide.toggle";
                case 54:
                    return "style-guide.tooltip";
                case 55:
                    return "style-guide.typography";
                case 56:
                    return "account.token_-string";
                case 57:
                    return "bills.token_-string";
                case 58:
                    return "checkout.slug_-string.top";
                case 59:
                    return "signup.slug_-string.top";
                case 60:
                    return "account.cart.confirm-pay";
                case 61:
                    return "account.messaging.chat";
                case 62:
                    return "appointments.appointment-id_-string.cancellation-policy";
                case 63:
                    return "signup.slug_-string.additional-details";
                case 64:
                    return "signup.slug_-string.confirmation";
                case 65:
                    return "signup.slug_-string.contacts";
                case 66:
                    return "signup.slug_-string.custom-details";
                case 67:
                    return "signup.slug_-string.location";
                case 68:
                    return "signup.slug_-string.members";
                case 69:
                    return "signup.slug_-string.membership";
                case 70:
                    return "signup.slug_-string.provider";
                case 71:
                    return "signup.slug_-string.thanks";
                case 72:
                    return "account.health-information.id_-string";
                case 73:
                    return "account.invoices.id_-string";
                case 74:
                    return "account.members.id_-string";
                case 75:
                    return "account.memberships.id_-string";
                case 76:
                    return "account.packages.id_-string";
                case 77:
                    return "account.payment-sources.id_-string";
                case 78:
                    return "account.appointments.appointment-id_-string.cancel";
                case 79:
                    return "account.appointments.appointment-id_-string.cancel-appointment";
                case 80:
                    return "account.appointments.appointment-id_-string.reschedule";
                case 81:
                    return "account.invoices.id_-string.payment";
                case 82:
                    return "account.members.id_-string.edit";
                case 83:
                    return "account.members.id_-string.emergency-contact";
                case 84:
                    return "account.memberships.id_-string.add-member";
                case 85:
                    return "account.memberships.id_-string.renew";
                case 86:
                    return "account.packages.id_-string.checkout";
                case 87:
                    return "account.payment-sources.id_-string.edit";
                case 88:
                    return "account.plans.id_-string.checkout";
                case 89:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                case 90:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
                case 91:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                default:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
            }
        }(n);
    }, Tgr = F2(function(n, r) {
        var t = r.qv, e = r.eH, u = r.wN;
        return A2(itn, "Final Form Field Visited", x([
            stn(n),
            MXn(t),
            LXn(HXn(rv(e))),
            SXn(A2(fe, ", ", A2(Eu, $T(Wx(0)), e))),
            Z0n(u)
        ]));
    }), Igr = function(n) {
        var r = n.C9, t = n.qv, e = n.eH;
        return A2(Tgr, function(n) {
            switch(x$r(n)){
                case 1:
                    return "Style Guide";
                case 0:
                    return IXn;
                case 2:
                    return "Login";
                case 4:
                    return "Booking";
                case 5:
                    return "Appointments";
                case 3:
                    return Xrn;
                case 6:
                    return "Chat";
                default:
                    return "App";
            }
        }(r), {
            eH: e,
            qv: t,
            wN: Hgr(r)
        });
    }, Rgr = F3(function(n, r, t) {
        var e = b(r, t);
        return 3 === e.a.$ && 3 === e.b.$ ? h$r(lc(n)) ? A2(AA, da, Wa) : A2(AA, A2(sc, da, A2(Fp, Rp, n.iF)), lc(n)) : Pp;
    }), Zgr = F3(function(n, r, t) {
        var e = rv(wGn(r));
        return !e.$ && i(t, A2(kGn, e.a.a, n));
    }), Vgr = F3(function(n, r, t) {
        var e = b(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a, a = e.b.a, i = fc(n);
            if (i.$) return Pp;
            var c = i.a, o = nQn(u);
            return A3(Zgr, o, a, c) ? Pp : A3(yGn, o, a, Zp(n.iF));
        }
        return Pp;
    }), Ugr = function(n) {
        return function(n) {
            return n.v_;
        }(n.a);
    }, Ygr = Wn("setFaviconPort", function(n) {
        return _x(x([
            b("appleUrl", Ax(n.mE)),
            b("icoUrl", Ax(n.rg)),
            b("pngUrl", Ax(n.uH))
        ]));
    }), Qgr = function(n) {
        var r = A2(sc, "", n.ua), t = A2(sc, "", n.t9), e = A2(sc, "", function(n) {
            return n.t8;
        }(n));
        return Ygr({
            mE: e,
            rg: t,
            uH: r
        });
    }, Ogr = Wn("setTheme", Ax), Ggr = Wn("tabSelected", Ax), Jgr = {
        $: 18
    }, Wgr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Kgr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xgr = function(n) {
        switch(n){
            case 0:
            case 6:
                return Ea;
            case 1:
                return Fa;
            case 2:
                return Sa;
            case 3:
                return Va;
            case 4:
                return ya;
            case 5:
                return _a;
            case 7:
                return Ca;
            case 8:
                return ka;
            default:
                return $a;
        }
    }, nwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(ZD, n.a, r.dH), e = t.a, u = t.b, a = t.c, i = function() {
                    if (a.$ || a.a.$) return b(Pp, h);
                    var n = a.a.a;
                    return n.$ ? b(Pp, h) : 1 === n.a.$ ? b(Pp, x([
                        Jgr
                    ])) : b(A2(AA, da, Xgr(n.a.a)), h);
                }(), c = i.a, o = i.b;
                return v(m(r, {
                    dH: e
                }), Vu(x([
                    A2(Lp, Kgr, u),
                    c
                ])), o);
            case 1:
                return v(r, Pp, x([
                    Jgr
                ]));
            case 2:
                return v(r, pgr(Ut), h);
            case 3:
                return v(m(r, {
                    b$: !0
                }), A2(hc, Wgr, ID("sidebar-polish-close")), h);
            case 4:
                return v(m(r, {
                    b$: !1
                }), A2(hc, Wgr, ID("sidebar-polish-open")), h);
            default:
                return v(r, Pp, h);
        }
    }), rwr = F3(function(n, r, t) {
        var e = {
            g0: !1,
            rh: n.e9 + 1,
            hX: r,
            sE: t
        };
        return b(m(n, {
            ch: A2(Yt, e, n.ch),
            e9: n.e9 + 1
        }), e);
    }), twr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ewr = F2(function(n, r) {
        return m(n, {
            ch: A2(Eu, function(n) {
                return i(n.rh, r.rh) ? m(n, {
                    g0: !0
                }) : n;
            }, n.ch)
        });
    }), uwr = F2(function(n, r) {
        return m(n, {
            ch: A2(Rc, function(n) {
                return !i(n.rh, r.rh);
            }, n.ch)
        });
    }), awr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(A2(ewr, r, t = n.a), function(n) {
                    return A2(Nu, function() {
                        return function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n);
                    }, jp(300));
                }(t));
            case 2:
                var t;
                return b(A2(uwr, r, t = n.a), Pp);
            default:
                var e = A3(rwr, r, n.a, n.b);
                return b(e.a, function(n) {
                    return A2(Nu, function() {
                        return twr(n);
                    }, jp(5e3));
                }(e.b));
        }
    }), iwr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cwr = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Kt(l1(r.a));
            case 1:
                return Kt(b1);
            case 2:
                return Kt(d1);
            case 3:
                return Kt(s1(r.a.DT));
            default:
                return A2(n$, iwr, n(r.b));
        }
    }), owr = m1({
        zQ: (NJ = function(n) {
            return {
                $: 0,
                a: n
            };
        }, A2(Iy, NJ, cwr(te))),
        xs: "/RELEASE"
    }), fwr = A2(sc, Kb, Wb("[a-f0-9]{40}")), swr = F2(function(n, r) {
        var t = r;
        return A2(qx, iu, function() {
            if (n.$) return b(t, Vu(x([
                owr,
                t.h9 ? Pp : Sp
            ])));
            if (n.a.$) return b(t, Pp);
            var r = n.a.a;
            return A2(k$, fwr, r) ? b(m(t, {
                h9: !i(XC(r), t.oT)
            }), Pp) : b(t, A2(_$r, "Fetching RELEASE Failed", da));
        }());
    }), lwr = {
        $: 14
    }, dwr = function(n) {
        return gGn(n);
    }, bwr = function(n) {
        return A2(nv, function(r) {
            var t = r.a, e = r.b;
            return $Gn(t) ? Vt(A2(hGn, t, e)) : A2(nv, bwr, tV(n));
        }, rv(n));
    }, vwr = F2(function(n, r) {
        var t = dwr(n);
        return A2(wF, function(n) {
            return i(n.a, r);
        }, t);
    }), mwr = F5(function(n, r, t, e, u) {
        if (A2(sc, !1, A2(Fp, function(n) {
            return $Gn(n.a);
        }, A3(W0n, n, r, e)))) return Pp;
        var a = A2(vwr, r, t);
        if (a.$) return A3(yGn, n, r, u);
        var i = bwr(Ae(A2(wj, a.a.b + 1, dwr(r))));
        return i.$ ? A3(yGn, n, r, u) : A2(AA, u, A2(kGn, i.a.a, n));
    }), pwr = A2(AA, da, Ia), $wr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hwr = F2(function(n, r) {
        return A2($wr, n, r);
    }), gwr = F2(function(n, r) {
        return A2(nv, function(t) {
            var e = m(r, {
                fc: g7n(n)
            });
            return Vt(b(e, RP(A3(Lz, 0, t, n))));
        }, A2(khr, r.dB, r.xs));
    }), wwr = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return b(t, Vu(x([
                    e,
                    A3($hr, n.a, n.b, n.c)
                ])));
            case 1:
                var u = n.a, a = n.b, i = Wx(t.kA), c = A2(awr, A2(hwr, u, i(a)), t.ch), o = c.b;
                return b(m(t, {
                    ch: c.a
                }), Vu(x([
                    e,
                    A2(Lp, O$r, o)
                ])));
            case 2:
                var f = A2(gwr, n.a, t);
                if (f.$) return b(t, e);
                var s = f.a, l = s.b, d = A2(ogr, !0, T = s.a);
                return b(d.a, Vu(x([
                    e,
                    d.b,
                    l
                ])));
            case 3:
                var v = A2(khr, t.dB, t.xs);
                return b(t, v.$ ? e : Vu(x([
                    e,
                    RP(A2(FS, 0, v.a))
                ])));
            case 4:
                var p = A2(khr, t.dB, t.xs);
                return b(t, Vu(x(p.$ ? [
                    e,
                    A3(Vgr, t.xs, t.fL, t.DF)
                ] : [
                    e,
                    RP(A2(rhr, 0, p.a))
                ])));
            case 5:
                var $ = n.a, g = b(t.fL, t.DF);
                if (3 === g.a.$ && 3 === g.b.$) {
                    var w = g.b.a, k = nQn(g.a.a), y = Zp(t.xs.iF);
                    return b(t, Vu(x([
                        e,
                        A5(mwr, k, w, $, t.xs, y)
                    ])));
                }
                return b(t, e);
            case 6:
                return b(m(t, {
                    hU: n.a
                }), e);
            case 7:
                return b(m(t, {
                    hg: !0
                }), e);
            case 8:
                return b(m(t, {
                    f0: G$r
                }), e);
            case 9:
                var _ = n.a, A = n.b, C = n.c;
                if (TE(_)) return b(t, e);
                var B = A2(x4, "tabs", A), E = B.a, D = B.b, q = C ? function(n) {
                    return m(n, {
                        h6: 1
                    });
                }(E) : E;
                return b(m(t, {
                    dZ: _,
                    d_: Vt(q)
                }), Vu(x([
                    e,
                    A2(Lp, thr(!0), D)
                ])));
            case 10:
                return b(m(t, {
                    dZ: h,
                    d_: Ut
                }), e);
            case 11:
                var F = n.a, P = function() {
                    var n = b(t.d_, A2(J4, F, t.dZ));
                    if (n.a.$ || n.b.$) return Pp;
                    var r = n.b.a;
                    return A2(Lp, thr(!1), r);
                }();
                return b(t, Vu(x([
                    e,
                    P
                ])));
            case 15:
                if (3 === t.fL.$) {
                    var z = A2(ogr, !0, t);
                    return b(T = z.a, Vu(x([
                        e,
                        z.b
                    ])));
                }
                return b(t, e);
            case 12:
                var j = A2(gwr, n.a, t);
                if (j.$) return b(t, e);
                var S = j.a;
                return b(T = S.a, Vu(x([
                    e,
                    l = S.b
                ])));
            case 13:
                var L = n.a, M = A2(ihr, Vt(mhr(t.gF)), tC(L)), N = A2(vgr, "Authentication - Sign In Complete", mhr(t.gF)), H = A2(qgr, L, t), T = H.a, I = H.b, R = function() {
                    var n = A2(Wu, "redirectTo", Zp(t.xs.iF));
                    if (n.$) return T;
                    var r = function(n) {
                        var r = A2(se, "?", n);
                        if (r.b && r.b.b && !r.b.b.b) {
                            var t = r.a, e = A2(fa, "patient", A2(fa, "email", Rp(r.b.a)));
                            return b(t, -2 === e.$ ? Ut : Vt(A2(fe, "&", A2(Eu, function(n) {
                                return n.a + "=" + n.b;
                            }, Ot(e)))));
                        }
                        return b(n, Ut);
                    }(n.a);
                    return m(T, {
                        d3: Vt({
                            z6: Ut,
                            Ai: t.xs.Ai,
                            Cq: r.a,
                            uI: t.xs.uI,
                            u6: t.xs.u6,
                            iF: r.b
                        })
                    });
                }();
                return b(R, Vu(x([
                    I,
                    e,
                    A2(zhr, R.gF, t.xs),
                    M,
                    N
                ])));
            case 16:
                return b(t, pwr);
            case 14:
                return A2(ggr, t, !1);
            case 17:
                return b(m(t, {
                    gF: bgr(t.gF),
                    yY: {
                        yG: bgr(t.yY.yG),
                        J: bgr(t.yY.J),
                        fb: bgr(t.yY.fb),
                        CP: bgr(t.yY.CP)
                    }
                }), onn);
            case 18:
                return b(t, A2(Nu, iu, _u(lwr)));
            case 19:
                return b(m(t, {
                    gF: A2(wgr, L = n.a, t.gF),
                    yY: {
                        yG: A2(wgr, L, t.yY.yG),
                        J: A2(wgr, L, t.yY.J),
                        fb: A2(wgr, L, t.yY.fb),
                        CP: A2(wgr, L, t.yY.CP)
                    }
                }), Pp);
            case 21:
            case 22:
                return b(t, Pp);
            case 20:
                return b(t, A2(_$r, "Bad Gateway error", da));
            default:
                return b(m(t, {
                    aW: n.a
                }), e);
        }
    }), xwr = F2(function(n, r) {
        return A3(de, wwr, b(r, Pp), n);
    }), kwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (6 === t.a.$) {
                            var e = t.a, u = e.a, a = e.b, c = e.c;
                            return b(m(r, {
                                dB: t
                            }), A3($hr, u, a, c));
                        }
                        break n;
                    case 3:
                        var o = t.a, f = i(r.Ag, Vt("production")) && !Ugr(o) ? 0 : 1, s = EQn(o) && phr(o), l = m(r, {
                            yR: A4(bhr, t, r.ud, r.fS, r.bj),
                            bM: s,
                            dw: Lgr(o),
                            dB: t
                        }), d = gx(r.gF) ? XGn(0) : A2(zhr, r.gF, r.xs);
                        return fhr(b(l, Vu(x([
                            ugr(l),
                            A2(Nu, W$r, IF),
                            d,
                            Ngr(f)
                        ]))));
                    default:
                        break n;
                }
                return b(r, Pp);
            case 1:
                var p = A2(awr, n.a, r.ch), $ = p.b;
                return b(m(r, {
                    ch: p.a
                }), A2(Lp, O$r, $));
            case 3:
                return b(r, Ogr(n.a));
            case 2:
                var h = n.a;
                return A2(Khr, r.xs, function() {
                    if (h.$) return r;
                    var n = h.a.b;
                    return m(r, {
                        jK: A2(Dp, n, r.bj),
                        fS: n
                    });
                }());
            case 10:
                var g = n.a;
                l = m(r, {
                    fL: g
                });
                n: for(;;)switch(g.$){
                    case 2:
                        if (6 === g.a.$) {
                            var w = g.a;
                            return b(l, A3($hr, u = w.a, a = w.b, c = w.c));
                        }
                        break n;
                    case 3:
                        return Chr(l);
                    default:
                        break n;
                }
                return b(l, Pp);
            case 11:
                var k = n.a, y = n.b;
                switch(l = m(r, {
                    DF: y
                }), y.$){
                    case 3:
                        var _ = y.a;
                        return d = function() {
                            var n = v(r.fc, k, r.fL);
                            n: for(;;){
                                if (2 === n.a.$) {
                                    if (n.b) {
                                        if (3 === n.c.$) return A4(sgr, nQn(n.c.a), _, r.xs, Zp(r.xs.iF));
                                        break n;
                                    }
                                    return Pp;
                                }
                                break n;
                            }
                            return A3(Vgr, l.xs, l.fL, y);
                        }(), b(l, d);
                    case 2:
                        if (6 === y.a.$) {
                            var A = y.a;
                            return b(l, A3($hr, u = A.a, a = A.b, c = A.c));
                        }
                        var C = function() {
                            var n = r.fL;
                            if (3 === n.$) {
                                var t = nQn(n.a).xs;
                                if (t.$) return b(l, Pp);
                                var e = t.a;
                                return b(m(l, {
                                    DF: cP
                                }), I9n(e));
                            }
                            return b(l, Pp);
                        }();
                        return b(C.a, C.b);
                    default:
                        return b(l, Pp);
                }
            case 4:
                if ((h = n.a).$) return b(m(r, {
                    f0: G$r,
                    fc: G$r
                }), A3(Vgr, r.xs, r.fL, r.DF));
                var B = h.a;
                n: for(; 1 === B.$;)switch(B.a){
                    case 0:
                        return l = m(r, (E = B.b).$ ? {
                            fc: G$r
                        } : {
                            fc: g7n(E.a)
                        }), A2(ogr, !1, l);
                    case 1:
                        var E = B.b, D = RP(A2(FS, 1, _hr));
                        return b(m(r, E.$ ? {
                            f0: G$r
                        } : {
                            f0: g7n(E.a)
                        }), D);
                    default:
                        break n;
                }
                return b(r, Pp);
            case 5:
                if ((h = n.a).$) return b(r, Pp);
                if (2 !== (B = h.a).$ || B.a) return b(r, Pp);
                var q = B.b;
                return b(l = m(r, {
                    fc: G$r
                }), q ? A3(Vgr, l.xs, l.fL, l.DF) : Pp);
            case 6:
                var F = n.a, P = n.b;
                n: for(;;){
                    if (2 !== P.$) {
                        var z = (qn = r.d3).$ ? r.xs : qn.a, j = 3 === P.$ ? Vt(EL(P.a)) : Ut;
                        return b(m(r, {
                            t6: P
                        }), Vu(x([
                            Dgr(F),
                            A3(Rgr, z, P, r.dB),
                            A3(Shr, F, r.dB, P),
                            (En = r.yY.J, Dn = eC(En), Dn.$ ? Pp : A3(rgr, En, Dn.a, Xhr)),
                            A2(ihr, Vt(mhr(F)), j)
                        ])));
                    }
                    switch(P.a.$){
                        case 6:
                            var S = P.a;
                            return u = S.a, a = S.b, c = S.c, b(m(r, {
                                t6: vc
                            }), Vu(x([
                                A3($hr, u, a, c),
                                hgr
                            ])));
                        case 0:
                            return A2(ggr, m(r, {
                                t6: vc
                            }), !1);
                        case 5:
                            if (409 === P.a.a) return d = $$r(lc(r.xs)) ? Vu(x([
                                Dgr(F),
                                pgr(A2(Fp, Rp, r.xs.iF))
                            ])) : Pp, b(m(r, {
                                t6: vc,
                                d3: Vt(r.xs)
                            }), d);
                            break n;
                        default:
                            break n;
                    }
                }
                return b(m(r, {
                    t6: vc
                }), Pp);
            case 7:
                var L = n.a;
                return fhr(b(m(r, {
                    yR: A4(bhr, r.dB, L, r.fS, r.bj),
                    ud: L,
                    Eq: 3 === L.$ ? Vt(p$n(L.a)) : Ut
                }), Pp));
            case 27:
                var M = n.a, N = function() {
                    var n = b(M, lc(r.xs));
                    if (3 === n.a.$) {
                        var t = n.a.a;
                        return p$r(n.b) && !KG(t) ? A2(AA, da, Wa) : Pp;
                    }
                    return Pp;
                }();
                return b(l = m(r, {
                    uN: M
                }), N);
            case 8:
                var H = (Bn = lc(r.xs), RP(A3(Lz, 1, _hr, _A(Bn))));
                return b(r, Vu(x([
                    A2(sc, Pp, A2(Fp, Igr, r.hU)),
                    H
                ])));
            case 9:
                var T = (Cn = A2(khr, r.dB, r.xs)).$ ? Pp : RP(A2(rhr, 0, Cn.a));
                return b(m(r, {
                    hg: !1
                }), T);
            case 12:
                var I = n.a, R = n.b, Z = r.d_;
                if (Z.$) return b(r, Pp);
                var V = A2(D8, R, Z.a), U = V.a, Y = V.b, Q = V.c, O = Q.$ ? Pp : Q.a.$ ? bzn(Q.a.a) : I ? Ggr(Q.a.a.rh) : Pp;
                return b(m(r, {
                    d_: Vt(U)
                }), Vu(x([
                    A2(Lp, thr(I), Y),
                    O
                ])));
            case 13:
                var G = A2(swr, n.a, r.CZ), J = G.b;
                return b(m(r, {
                    CZ: G.a
                }), A2(Lp, mc, J));
            case 14:
                var W = 3 === (An = r.dB).$ ? A3(hhr, r.gF, Bx(An.a), X$r) : Pp;
                return b(m(r, {
                    gF: A2(chr, A2(sc, 0, r.Eq), vhr(r.gF)),
                    yY: {
                        yG: vhr(r.yY.yG),
                        J: vhr(r.yY.J),
                        fb: vhr(r.yY.fb),
                        CP: vhr(r.yY.CP)
                    }
                }), Vu(x([
                    W,
                    hgr,
                    pgr(Ut)
                ])));
            case 17:
                var K = n.a, X = xgr(z_(r.gF)), nn = w$r(lc(r.xs)) ? Pp : A4(Cgr, Vt(K), X, r.gF, r.dB);
                return b(r, nn);
            case 15:
                return b(r, A2(Agr, r.gF, r.dB));
            case 16:
                var rn = n.a, tn = A2(vgr, "Authentication - Session Refreshed", mhr(r.gF)), en = A2(Fgr, r, rn);
                return b(l = en.a, Vu(x([
                    d = en.b,
                    tn
                ])));
            case 21:
                var un = A2(Fgr, r, rn = n.a);
                return d = un.b, b(m(l = un.a, {
                    eI: !1
                }), Vu(x([
                    d,
                    A2(zhr, l.gF, r.xs)
                ])));
            case 19:
                var an = A2(nwr, n.a, r.dw), cn = an.a, on = an.b, fn = A2(xwr, an.c, r), sn = fn.b;
                return b(m(l = fn.a, {
                    dw: cn
                }), Vu(x([
                    A2(Lp, nhr, on),
                    sn
                ])));
            case 20:
                var ln = n.a;
                n: for(;;)switch(ln.$){
                    case 3:
                        var dn = ln.a;
                        return b(m(r, {
                            an: ln
                        }), Qgr(dn));
                    case 2:
                        if (6 === ln.a.$) {
                            var bn = ln.a;
                            return u = bn.a, a = bn.b, c = bn.c, b(m(r, {
                                an: ln
                            }), A3($hr, u, a, c));
                        }
                        break n;
                    default:
                        break n;
                }
                return b(m(r, {
                    an: ln
                }), Pp);
            case 24:
                return $$r(lc(r.xs)) ? A2(ggr, r, !0) : b(r, Pp);
            case 18:
                return b(m(r, {
                    bj: K = n.a,
                    jK: A2(Dp, r.fS, K)
                }), Pp);
            case 25:
                var vn = A2(NSn, n.a, r.cB), mn = vn.a, pn = vn.b, $n = vn.c, hn = function() {
                    if ($n.$ || $n.a.$) return b(r, Pp);
                    var n = $n.a.a;
                    return b(m(r, {
                        gF: A2(chr, n, r.gF),
                        kA: ohr(n),
                        Eq: Vt(n)
                    }), RP(A3(Lz, 3, "hint-language", Tb(n))));
                }(), gn = hn.b;
                return b(m(hn.a, {
                    cB: mn
                }), Vu(x([
                    gn,
                    A2(Lp, K$r, pn)
                ])));
            case 26:
                return b(m(r, {
                    ej: n.a
                }), Pp);
            case 28:
                var wn = (_n = z = n.a, A3(ru, Fp(lc), sc(Uu), ku(_n)));
                return b(r, A2(Sgr, r, wn));
            case 29:
                var xn = lc(r.xs);
                return d = h$r(xn) || function(n) {
                    return i(n, Ga) || i(n, Aa) || i(n, Ia);
                }(xn) ? Pp : $gr(r.xs), b(m(r, {
                    gF: vhr(r.gF),
                    yY: {
                        yG: vhr(r.yY.yG),
                        J: vhr(r.yY.J),
                        fb: vhr(r.yY.fb),
                        CP: vhr(r.yY.CP)
                    }
                }), d);
            case 30:
                return b(r, Pp);
            case 22:
                if (h = n.a, gx(r.gF) && !r.eI) {
                    if (h.$) return b(r, Pp);
                    var kn = h.a, yn = r.dB;
                    return 3 === yn.$ ? (o = yn.a, b(m(r, {
                        eI: !0
                    }), A4(ghr, r.gF, Bx(o), Vt(kn), J$r))) : b(r, Pp);
                }
                return b(r, Pp);
            default:
                return gx(r.gF) ? b(r, xJn(1)) : b(r, Pp);
        }
        var _n, An, Cn, Bn, En, Dn, qn;
    }), ywr = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;)switch(t.a.$){
            case 0:
                if (t.b.$) break n;
                return A2(v$r.lK.En, t.a.a, t.b.a);
            case 1:
                if (1 === t.b.$) return A2(v$r.ho.En, t.a.a, t.b.a);
                break n;
            case 2:
                if (2 === t.b.$) return A2(v$r.ib.En, t.a.a, t.b.a);
                break n;
            case 3:
                if (3 === t.b.$) return A2(v$r.ff.En, t.a.a, t.b.a);
                break n;
            case 4:
                if (4 === t.b.$) return A2(v$r.jJ.En, t.a.a, t.b.a);
                break n;
            case 5:
                if (5 === t.b.$) return A2(v$r.q.En, t.a.a, t.b.a);
                break n;
            case 6:
                if (6 === t.b.$) return A2(v$r.gC.En, t.a.a, t.b.a);
                break n;
            case 7:
                if (7 === t.b.$) return A2(v$r.gR.En, t.a.a, t.b.a);
                break n;
            case 8:
                if (8 === t.b.$) return A2(v$r.g_.En, t.a.a, t.b.a);
                break n;
            case 9:
                if (9 === t.b.$) return A2(v$r.hp.En, t.a.a, t.b.a);
                break n;
            case 10:
                if (10 === t.b.$) return A2(v$r.ja.En, t.a.a, t.b.a);
                break n;
            case 11:
                if (11 === t.b.$) return A2(v$r.jB.En, t.a.a, t.b.a);
                break n;
            case 12:
                if (12 === t.b.$) return A2(v$r.f4.En, t.a.a, t.b.a);
                break n;
            case 13:
                if (13 === t.b.$) return A2(v$r.f7.En, t.a.a, t.b.a);
                break n;
            case 14:
                if (14 === t.b.$) return A2(v$r.f9.En, t.a.a, t.b.a);
                break n;
            case 15:
                if (15 === t.b.$) return A2(v$r.ga.En, t.a.a, t.b.a);
                break n;
            case 16:
                if (16 === t.b.$) return A2(v$r.gb.En, t.a.a, t.b.a);
                break n;
            case 17:
                if (17 === t.b.$) return A2(v$r.gc.En, t.a.a, t.b.a);
                break n;
            case 18:
                if (18 === t.b.$) return A2(v$r.gd.En, t.a.a, t.b.a);
                break n;
            case 19:
                if (19 === t.b.$) return A2(v$r.gf.En, t.a.a, t.b.a);
                break n;
            case 20:
                if (20 === t.b.$) return A2(v$r.gi.En, t.a.a, t.b.a);
                break n;
            case 21:
                if (21 === t.b.$) return A2(v$r.gm.En, t.a.a, t.b.a);
                break n;
            case 22:
                if (22 === t.b.$) return A2(v$r.gq.En, t.a.a, t.b.a);
                break n;
            case 23:
                if (23 === t.b.$) return A2(v$r.gs.En, t.a.a, t.b.a);
                break n;
            case 24:
                if (24 === t.b.$) return A2(v$r.gv.En, t.a.a, t.b.a);
                break n;
            case 25:
                if (25 === t.b.$) return A2(v$r.gz.En, t.a.a, t.b.a);
                break n;
            case 26:
                if (26 === t.b.$) return A2(v$r.gA.En, t.a.a, t.b.a);
                break n;
            case 27:
                if (27 === t.b.$) return A2(v$r.gQ.En, t.a.a, t.b.a);
                break n;
            case 28:
                if (28 === t.b.$) return A2(v$r.h$.En, t.a.a, t.b.a);
                break n;
            case 29:
                if (29 === t.b.$) return A2(v$r.h0.En, t.a.a, t.b.a);
                break n;
            case 30:
                if (30 === t.b.$) return A2(v$r.h1.En, t.a.a, t.b.a);
                break n;
            case 31:
                if (31 === t.b.$) return A2(v$r.jd.En, t.a.a, t.b.a);
                break n;
            case 32:
                if (32 === t.b.$) return A2(v$r.je.En, t.a.a, t.b.a);
                break n;
            case 33:
                if (33 === t.b.$) return A2(v$r.jf.En, t.a.a, t.b.a);
                break n;
            case 34:
                if (34 === t.b.$) return A2(v$r.jg.En, t.a.a, t.b.a);
                break n;
            case 35:
                if (35 === t.b.$) return A2(v$r.jh.En, t.a.a, t.b.a);
                break n;
            case 36:
                if (36 === t.b.$) return A2(v$r.ji.En, t.a.a, t.b.a);
                break n;
            case 37:
                if (37 === t.b.$) return A2(v$r.jj.En, t.a.a, t.b.a);
                break n;
            case 38:
                if (38 === t.b.$) return A2(v$r.jk.En, t.a.a, t.b.a);
                break n;
            case 39:
                if (39 === t.b.$) return A2(v$r.jl.En, t.a.a, t.b.a);
                break n;
            case 40:
                if (40 === t.b.$) return A2(v$r.jm.En, t.a.a, t.b.a);
                break n;
            case 41:
                if (41 === t.b.$) return A2(v$r.jn.En, t.a.a, t.b.a);
                break n;
            case 42:
                if (42 === t.b.$) return A2(v$r.jo.En, t.a.a, t.b.a);
                break n;
            case 43:
                if (43 === t.b.$) return A2(v$r.jp.En, t.a.a, t.b.a);
                break n;
            case 44:
                if (44 === t.b.$) return A2(v$r.jq.En, t.a.a, t.b.a);
                break n;
            case 45:
                if (45 === t.b.$) return A2(v$r.jr.En, t.a.a, t.b.a);
                break n;
            case 46:
                if (46 === t.b.$) return A2(v$r.js.En, t.a.a, t.b.a);
                break n;
            case 47:
                if (47 === t.b.$) return A2(v$r.jt.En, t.a.a, t.b.a);
                break n;
            case 48:
                if (48 === t.b.$) return A2(v$r.ju.En, t.a.a, t.b.a);
                break n;
            case 49:
                if (49 === t.b.$) return A2(v$r.jv.En, t.a.a, t.b.a);
                break n;
            case 50:
                if (50 === t.b.$) return A2(v$r.jw.En, t.a.a, t.b.a);
                break n;
            case 51:
                if (51 === t.b.$) return A2(v$r.jx.En, t.a.a, t.b.a);
                break n;
            case 52:
                if (52 === t.b.$) return A2(v$r.jy.En, t.a.a, t.b.a);
                break n;
            case 53:
                if (53 === t.b.$) return A2(v$r.jz.En, t.a.a, t.b.a);
                break n;
            case 54:
                if (54 === t.b.$) return A2(v$r.jA.En, t.a.a, t.b.a);
                break n;
            case 55:
                if (55 === t.b.$) return A2(v$r.jC.En, t.a.a, t.b.a);
                break n;
            case 56:
                if (56 === t.b.$) return A2(v$r.gB.En, t.a.a, t.b.a);
                break n;
            case 57:
                if (57 === t.b.$) return A2(v$r.gL.En, t.a.a, t.b.a);
                break n;
            case 58:
                if (58 === t.b.$) return A2(v$r.gZ.En, t.a.a, t.b.a);
                break n;
            case 59:
                if (59 === t.b.$) return A2(v$r.i9.En, t.a.a, t.b.a);
                break n;
            case 60:
                if (60 === t.b.$) return A2(v$r.f8.En, t.a.a, t.b.a);
                break n;
            case 61:
                if (61 === t.b.$) return A2(v$r.gr.En, t.a.a, t.b.a);
                break n;
            case 62:
                if (62 === t.b.$) return A2(v$r.gJ.En, t.a.a, t.b.a);
                break n;
            case 63:
                if (63 === t.b.$) return A2(v$r.i0.En, t.a.a, t.b.a);
                break n;
            case 64:
                if (64 === t.b.$) return A2(v$r.i1.En, t.a.a, t.b.a);
                break n;
            case 65:
                if (65 === t.b.$) return A2(v$r.i2.En, t.a.a, t.b.a);
                break n;
            case 66:
                if (66 === t.b.$) return A2(v$r.i3.En, t.a.a, t.b.a);
                break n;
            case 67:
                if (67 === t.b.$) return A2(v$r.i4.En, t.a.a, t.b.a);
                break n;
            case 68:
                if (68 === t.b.$) return A2(v$r.i5.En, t.a.a, t.b.a);
                break n;
            case 69:
                if (69 === t.b.$) return A2(v$r.i6.En, t.a.a, t.b.a);
                break n;
            case 70:
                if (70 === t.b.$) return A2(v$r.i7.En, t.a.a, t.b.a);
                break n;
            case 71:
                if (71 === t.b.$) return A2(v$r.i8.En, t.a.a, t.b.a);
                break n;
            case 72:
                if (72 === t.b.$) return A2(v$r.ge.En, t.a.a, t.b.a);
                break n;
            case 73:
                if (73 === t.b.$) return A2(v$r.gg.En, t.a.a, t.b.a);
                break n;
            case 74:
                if (74 === t.b.$) return A2(v$r.gj.En, t.a.a, t.b.a);
                break n;
            case 75:
                if (75 === t.b.$) return A2(v$r.gn.En, t.a.a, t.b.a);
                break n;
            case 76:
                if (76 === t.b.$) return A2(v$r.gt.En, t.a.a, t.b.a);
                break n;
            case 77:
                if (77 === t.b.$) return A2(v$r.gw.En, t.a.a, t.b.a);
                break n;
            case 78:
                if (78 === t.b.$) return A2(v$r.f1.En, t.a.a, t.b.a);
                break n;
            case 79:
                if (79 === t.b.$) return A2(v$r.f2.En, t.a.a, t.b.a);
                break n;
            case 80:
                if (80 === t.b.$) return A2(v$r.f3.En, t.a.a, t.b.a);
                break n;
            case 81:
                if (81 === t.b.$) return A2(v$r.gh.En, t.a.a, t.b.a);
                break n;
            case 82:
                if (82 === t.b.$) return A2(v$r.gk.En, t.a.a, t.b.a);
                break n;
            case 83:
                if (83 === t.b.$) return A2(v$r.gl.En, t.a.a, t.b.a);
                break n;
            case 84:
                if (84 === t.b.$) return A2(v$r.go.En, t.a.a, t.b.a);
                break n;
            case 85:
                if (85 === t.b.$) return A2(v$r.gp.En, t.a.a, t.b.a);
                break n;
            case 86:
                if (86 === t.b.$) return A2(v$r.gu.En, t.a.a, t.b.a);
                break n;
            case 87:
                if (87 === t.b.$) return A2(v$r.gx.En, t.a.a, t.b.a);
                break n;
            case 88:
                if (88 === t.b.$) return A2(v$r.gy.En, t.a.a, t.b.a);
                break n;
            case 89:
                if (89 === t.b.$) return A2(v$r.gO.En, t.a.a, t.b.a);
                break n;
            case 90:
                if (90 === t.b.$) return A2(v$r.gP.En, t.a.a, t.b.a);
                break n;
            case 91:
                if (91 === t.b.$) return A2(v$r.f5.En, t.a.a, t.b.a);
                break n;
            default:
                if (92 === t.b.$) return A2(v$r.f6.En, t.a.a, t.b.a);
                break n;
        }
        return v(r, Pp, h);
    }), _wr = Wn("updateTitle", Ax), Awr = F2(function(n, r) {
        var t;
        return b(m(r, {
            xs: n
        }), Vu(x([
            (t = r.CZ, t.h9 ? Wnr : Pp)
        ])));
    }), Cwr = function(n) {
        return I$r(n).Et(0);
    }, Bwr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.Dr, u = lc(e.xs), a = C$r(t), c = a.a, o = a.b, f = A2(Awr, c, e), s = f.a, l = f.b, d = lc(c), p = i(d, u), $ = function() {
                    if (p) return v(A2(U$r, r.a6, s), r.eV, Pp);
                    var n = A2(m$r, d, s);
                    return v(b(n.a, n.b), k$r(d), A2(Nu, function() {
                        return V$r;
                    }, A2(Q$r, 0, 0)));
                }(), h = $.a, g = h.b, w = $.b, k = $.c, y = Cwr(C = h.a).w5;
                return b(m(r, {
                    eV: w,
                    a6: C,
                    Dr: A2(Y$r, C, s)
                }), Vu(x([
                    A2(Lp, Zu, l),
                    A2(Lp, Ru, g),
                    o,
                    _wr(y),
                    k
                ])));
            case 2:
                var _ = A2(kwr, n.a, r.Dr), A = (l = _.b, A2(U$r, r.a6, s = _.a));
                return g = A.b, b(m(r, {
                    a6: C = A.a,
                    Dr: s
                }), Vu(x([
                    A2(Lp, Zu, l),
                    A2(Lp, Ru, g)
                ])));
            case 3:
                var C, B = A2(ywr, n.a, r.a6), E = (g = B.b, A2(xwr, B.c, A2(Y$r, C = B.a, r.Dr)));
                return s = E.a, l = E.b, y = Cwr(C).w5, b(m(r, {
                    a6: C,
                    Dr: s
                }), Vu(x([
                    A2(Lp, Ru, g),
                    A2(Lp, Zu, l),
                    _wr(y)
                ])));
            default:
                return b(r, Pp);
        }
    }), Ewr = function(n) {
        switch(n){
            case 0:
                return "alert--info";
            case 1:
                return "alert--error";
            case 2:
                return "alert--warning";
            default:
                return "alert--success";
        }
    }, Dwr = function(n) {
        switch(n){
            case 0:
                return 4;
            case 1:
            case 2:
                return 3;
            default:
                return 1;
        }
    }, qwr = function(n) {
        return b(oe(n.rh), A2(nk, x([
            Xx("alert"),
            Xx(Ewr(n.hX)),
            SC(x([
                b("alert--closing", n.g0)
            ]))
        ]), x([
            A2(nk, h, x([
                A2(ak, x([
                    Xx("mr-3")
                ]), x([
                    A2(PE, h, Dwr(n.hX))
                ])),
                ld(n.sE)
            ])),
            A2(PC, x([
                IC(twr(n))
            ]), x([
                A2(PE, h, 2)
            ]))
        ])));
    }, Fwr = function(n) {
        var r;
        return A2(Ck, O$r, (r = n, A3(Kq, "div", x([
            Xx("alerts-wrapper")
        ]), A2(Eu, qwr, r.ch))));
    }, Pwr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zwr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), jwr = zwr, Swr = {
        $: 6
    }, Lwr = function(n) {
        var r = A2(Rc, function(n) {
            return !i(n, Swr);
        }, n);
        return r.b ? r.b.b ? function(n) {
            return {
                $: 4,
                a: n
            };
        }(r) : r.a : Swr;
    }, Mwr = function(n) {
        return n.rb;
    }, Nwr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hwr = Nwr, Twr = function(n) {
        return Nwr(A2(nk, x([
            Xx("footer-language-portal min-w-0")
        ]), x([
            n
        ])));
    }, Iwr = function(n) {
        return n.v$.y9;
    }, Rwr = F2(function(n, r) {
        return 3 === r.$ && Ugr(r.a) ? A2(nk, x([
            Xx("sandbox-alert")
        ]), x([
            ld(n(Iwr))
        ])) : ld("");
    }), Zwr = A2(de, F2(function(n, r) {
        return m(r, {
            jI: n
        });
    }), {
        jI: 0
    }), Vwr = F2(function(n, r) {
        var t = "https://www.hint.com/?utm_campaign=" + r + "&utm_source=" + n + "&utm_medium=application";
        return A2(nk, h, x([
            A2(k3, x([
                zG("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"),
                Xx("icon -mt-1")
            ]), h),
            A2(FI, x([
                $H,
                fq
            ]), x([
                ld("Powered by "),
                A2(IN, x([
                    w2,
                    LN(t),
                    MN
                ]), x([
                    ld("Hint")
                ]))
            ]))
        ]));
    }), Uwr = A2(FI, x([
        $H,
        fq
    ]), x([
        A2(IN, x([
            w2,
            LN("https://www.hint.com/privacy"),
            MN
        ]), x([
            ld("Privacy Policy")
        ]))
    ])), Ywr = F2(function(n, r) {
        return function(t) {
            return $(r(t), Zb(n));
        };
    }), Qwr = F2(function(n, r) {
        return function(t) {
            return $(Zb(n), r(t));
        };
    }), Owr = function(n) {
        return n.ft.yk;
    }, Gwr = function(n) {
        return n.ft.AN;
    }, Jwr = function(n) {
        return n.ft.CN;
    }, Wwr = function(n) {
        return n.ft.D1;
    }, Kwr = function(n) {
        return n.vq;
    }, Xwr = F2(function(n, r) {
        return r.wq(n);
    }), nxr = function(n) {
        return n.wr;
    }, rxr = function(n) {
        var r = function(n) {
            return n.b.pb;
        }(n);
        return r.$ ? "" : Glr(r.a);
    }, txr = F2(function(n, r) {
        return A2(Ek, x([
            fq,
            rB(DB),
            $H
        ]), x([
            A2(ak, h, x([
                ld(n(Xwr(Ex(r)))),
                ld(" ")
            ])),
            A2(IN, x([
                LN(rxr(r)),
                MN,
                w2
            ]), x([
                ld(n(nxr))
            ]))
        ]));
    }), exr = F2(function(n, r) {
        switch(r.$){
            case 0:
                return function(n) {
                    return A2(nk, h, VZ(A2(Ek, x([
                        $H,
                        fq
                    ]), x([
                        A2(FI, h, x([
                            ld(n(A2(Ywr, " ", Gwr)))
                        ])),
                        A2(FI, h, x([
                            A2(IN, x([
                                w2,
                                LN("https://policies.google.com/privacy"),
                                MN
                            ]), x([
                                ld(n(Jwr))
                            ]))
                        ])),
                        A2(FI, h, x([
                            ld(n(A2(Ywr, " ", A2(Qwr, " ", Owr))))
                        ])),
                        A2(FI, x([
                            ok(x([
                                Xx("inline-block")
                            ]))
                        ]), x([
                            A2(IN, x([
                                w2,
                                LN("https://policies.google.com/terms"),
                                MN
                            ]), x([
                                ld(n(Wwr))
                            ]))
                        ])),
                        A2(FI, h, x([
                            ld(n(Kwr))
                        ]))
                    ]))));
                }(n);
            case 1:
                return A2(Vwr, r.a, r.b);
            case 2:
                return A2(txr, n, r.a);
            case 3:
                return r.a;
            case 4:
                var t = r.a;
                return A2(nk, x([
                    Xx("flex items-center justify-between space-x-4")
                ]), A2(Eu, exr(n), t));
            case 5:
                return Uwr;
            default:
                return ld("");
        }
    }), uxr = F3(function(n, r, t) {
        var e = Zwr(r);
        return A2(nk, x([
            Xx("footer"),
            Xx(1 === e.jI ? "text-center items-center" : "text-left")
        ]), A2(Eu, exr(n), t));
    }), axr = {
        $: 7
    }, ixr = F2(function(n, r) {
        var t = b(n, r);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.b.a;
            return DQn(t.a.a) || TE(zD(e)) ? tB : A2(nk, x([
                Xx("fixed right-6 bottom-24 md:bottom-8")
            ]), x([
                A2(IN, x([
                    LN(_A($a)),
                    ON,
                    axr
                ]), x([
                    A2(PE, x([
                        MQn
                    ]), 27)
                ]))
            ]));
        }
        return tB;
    }), cxr = cr("header"), oxr = F3(function(n, r, t) {
        return 3 === n.$ ? A2(cxr, x([
            Xx(1 === t ? "header header--app h-24" : "header h-24")
        ]), x([
            A2(nk, x([
                Xx("header__container app-container app-account-container justify-between")
            ]), x([
                r
            ]))
        ])) : tB;
    }), fxr = F4(function(n, r, t, e) {
        var u = b(n, r);
        if (1 === u.a.$) {
            if (u.b.$) return A2(nk, x([
                Xx("header__logo")
            ]), x([
                ld(t)
            ]));
            var a = u.b.a;
            return A2(nk, x([
                Xx("header__logo")
            ]), x([
                A2(k3, x([
                    zG(a),
                    x3(e)
                ]), h)
            ]));
        }
        return u.b.$ ? A2(fB, x([
            yB(u.a.a),
            Xx("header__logo")
        ]), x([
            ld(t)
        ])) : (a = u.b.a, A2(fB, x([
            yB(u.a.a),
            Xx("header__logo")
        ]), x([
            A2(k3, x([
                zG(a),
                x3(e)
            ]), h)
        ])));
    }), sxr = function(n) {
        return n.ub;
    }, lxr = function(n) {
        return n.uc;
    }, dxr = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;){
            r: for(;;)switch(t.a.$){
                case 3:
                    switch(t.b.$){
                        case 3:
                            var e = t.a.a, u = t.b.a;
                            return A4(fxr, Ulr(e), lxr(u), Ex(e), sxr(u));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return ik(x([
                        Rnn
                    ]));
                default:
                    if (1 === t.b.$) break n;
                    break r;
            }
            return A4(fxr, Vt("http://www.hint.com"), Vt("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return ik(x([
            Rnn
        ]));
    }), bxr = F2(function(n, r) {
        return A2(cxr, x([
            Xx("header")
        ]), x([
            A2(nk, x([
                Xx("header__container app-container")
            ]), x([
                A2(dxr, n, r)
            ]))
        ]));
    }), vxr = F5(function(n, r, t, e, u) {
        var a = 3 === r.$ ? Bx(r.a) : "", i = 3 === t.$ && Mwr(t.a);
        return x([
            A2(nk, x([
                Xx("layout layout--app")
            ]), x([
                A2(Rwr, n, r),
                A2(bxr, r, t),
                A2(nk, x([
                    Xx("main main--app")
                ]), x([
                    A2(nk, x([
                        Xx("app-container my-8")
                    ]), u)
                ])),
                A3(uxr, n, x([
                    1
                ]), x([
                    i ? Swr : A2(jwr, a, "member_app_portal")
                ]))
            ]))
        ]);
    }), mxr = {
        $: 5
    }, pxr = F5(function(n, r, t, e, u) {
        var a = lc(t);
        return g$r(a) ? A2(cxr, x([
            Xx("header bg-primary-100 border-b-0")
        ]), x([
            A2(nk, x([
                Xx("header__container app-container md:px-12")
            ]), x([
                A2(zN, x([
                    jN(iR)
                ]), x([
                    A2(EN, x([
                        JI(3)
                    ]), h),
                    A2(EN, x([
                        JI(6)
                    ]), x([
                        A2(nk, x([
                            Xx("flex justify-center")
                        ]), x([
                            A2(dxr, n, r)
                        ]))
                    ]))
                ]))
            ]))
        ])) : A2(cxr, x([
            Xx(1 === u ? "header header--app h-24 flex justify-center" : "header flex justify-center")
        ]), x([
            A2(nk, x([
                Xx("booking-navbar")
            ]), x([
                e
            ]))
        ]));
    }), $xr = F8(function(n, r, t, e, u, a, i, c) {
        var o = 3 === t.$ ? Bx(t.a) : "", f = 3 === e.$ && Mwr(e.a);
        return x([
            A2(nk, x([
                Xx("layout")
            ]), x([
                A2(Rwr, n, t),
                A5(pxr, t, e, u, i, c),
                A2(nk, x([
                    Xx("main main--app")
                ]), x([
                    A2(nk, x([
                        Xx("app-container my-4 md:my-8 px-6 md:px-12")
                    ]), a)
                ])),
                A3(uxr, n, x([
                    1
                ]), x([
                    Lwr(x([
                        f ? Swr : A2(jwr, o, "member_app_portal"),
                        f ? Swr : mxr,
                        1 === c ? Twr(r) : Hwr(r)
                    ]))
                ]))
            ]))
        ]);
    }), hxr = F2(function(n, r) {
        return TE(A2(Rc, function(n) {
            return A2(xu, Gp(x([
                n,
                "="
            ])), r);
        }, n));
    }), gxr = F2(function(n, r) {
        return A2(Tp, cfr, A2(Rc, hxr(n), A2(se, "&", r)));
    }), wxr = function(n) {
        return kH(lc(n));
    }, xxr = function(n) {
        switch(n.$){
            case 90:
                return ga({
                    mH: n.a.mH,
                    nd: n.a.nd
                });
            case 89:
                return ha({
                    mH: n.a.mH,
                    nd: n.a.nd
                });
            default:
                return $a;
        }
    }, kxr = F5(function(n, r, t, e, u) {
        var a = lc(t);
        if (kH(a)) {
            var i = A2(sc, h, A2(Fp, gxr(x([
                "practice"
            ])), t.iF));
            return A2(cxr, x([
                Xx("header bg-primary-100 border-b-0")
            ]), x([
                A2(nk, x([
                    Xx("header__container app-container md:px-12")
                ]), x([
                    A2(zN, x([
                        jN(iR)
                    ]), x([
                        A2(EN, x([
                            JI(3)
                        ]), h),
                        A2(EN, x([
                            JI(6)
                        ]), x([
                            A2(nk, x([
                                Xx("flex justify-center")
                            ]), x([
                                A2(dxr, n, r)
                            ]))
                        ])),
                        A2(EN, x([
                            JI(3)
                        ]), x([
                            A2(nk, x([
                                Xx("flex justify-end items-center h-full mr-1"),
                                SC(x([
                                    b("hidden", !wxr(t))
                                ]))
                            ]), x([
                                A2(IN, x([
                                    LN(A2(yH, x([
                                        _A(xxr(a))
                                    ]), i)),
                                    ON
                                ]), x([
                                    ld("Sign In")
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]));
        }
        return A2(cxr, x([
            Xx(1 === u ? "header header--app h-24 flex justify-center" : "header flex justify-center")
        ]), x([
            A2(nk, x([
                Xx("booking-navbar")
            ]), x([
                e
            ]))
        ]));
    }), yxr = F8(function(n, r, t, e, u, a, i, c) {
        var o = 3 === t.$ ? Bx(t.a) : "", f = 3 === e.$ && Mwr(e.a);
        return x([
            A2(nk, x([
                Xx("layout")
            ]), x([
                A2(Rwr, n, t),
                A5(kxr, t, e, u, i, c),
                A2(nk, x([
                    Xx("main main--app")
                ]), x([
                    A2(nk, x([
                        Xx("app-container my-4 md:my-8 px-6 md:px-12")
                    ]), a)
                ])),
                A3(uxr, n, x([
                    1
                ]), x([
                    Lwr(x([
                        f ? Swr : A2(jwr, o, "member_app_portal"),
                        f ? Swr : mxr,
                        1 === c ? Twr(r) : Hwr(r)
                    ]))
                ]))
            ]))
        ]);
    }), _xr = {
        $: 0
    }, Axr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Cxr = F6(function(n, r, t, e, u, a) {
        var i, c = 1 === a ? "layout bg-white" : "layout layout--app", o = 3 === t.$ && Mwr(t.a);
        return x([
            A2(nk, x([
                Xx(c)
            ]), x([
                A2(Rwr, n, u),
                A2(nk, x([
                    Xx("main main--app")
                ]), x([
                    A2(nk, x([
                        Xx("app-container my-8")
                    ]), e)
                ])),
                A3(uxr, n, x([
                    1
                ]), x([
                    1 === a ? Swr : 3 === u.$ ? Axr(u.a) : Swr,
                    _xr,
                    Lwr(x([
                        (i = b(u, o), 3 !== i.a.$ || i.b ? Swr : A2(jwr, Bx(i.a.a), "member_app_portal")),
                        1 === a ? Twr(r) : Hwr(r)
                    ]))
                ]))
            ]))
        ]);
    }), Bxr = F2(function(n, r) {
        return A2(LB, x([
            ok(x([
                Xx(1 === r ? "header header--app h-24" : "header h-24")
            ]))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("header__container app-container app-account-container")
                ])),
                ok($k(Z0))
            ]), x([
                n
            ]))
        ]));
    }), Exr = F7(function(n, r, t, e, u, a, i) {
        var c = 3 === r.$ ? Bx(r.a) : "", o = 3 === t.$ && Mwr(t.a);
        return x([
            A2(LB, x([
                ok(x([
                    Xx("layout layout--app")
                ]))
            ]), x([
                A2(Rwr, n, r),
                A2(Bxr, a, i),
                A2(LB, x([
                    ok(x([
                        Xx("main main--app")
                    ]))
                ]), x([
                    A2(LB, x([
                        ok(x([
                            Xx("app-container app-account-container md:my-8 mt-4")
                        ]))
                    ]), u)
                ])),
                A2(LB, x([
                    ok(x([
                        Xx("hidden md:block")
                    ]))
                ]), x([
                    A3(uxr, n, x([
                        1
                    ]), x([
                        o ? Swr : A2(jwr, c, "member_app_portal")
                    ]))
                ]))
            ]))
        ]);
    }), Dxr = F3(function(n, r, t) {
        var e = M0n(r);
        return A2(wF, function(r) {
            return i(A2(kGn, r.a, n), t);
        }, e);
    }), qxr = F3(function(n, r, t) {
        return A3(Dxr, n, r, lc(t));
    }), Fxr = F3(function(n, r, t) {
        return A2(Fp, function(n) {
            return n.b;
        }, A3(qxr, n, r, t));
    }), Pxr = function(n) {
        return A2(nk, x([
            Xx("signup__body")
        ]), x([
            A2(nk, x([
                Xx("signup__page-border")
            ]), h),
            A2(nk, x([
                Xx("signup__page-center")
            ]), n),
            A2(nk, x([
                Xx("signup__page-border")
            ]), h)
        ]));
    }, zxr = F5(function(n, r, t, e, u) {
        var a = v(t, e, u);
        if (3 === a.a.$ && 3 === a.b.$ && 3 === a.c.$) {
            var i = a.c.a, c = Bx(a.a.a), o = Mwr(i);
            return A2(nk, h, x([
                A3(uxr, n, x([
                    1
                ]), x([
                    Lwr(x([
                        o ? Swr : A2(jwr, c, "member_app_signup"),
                        o ? Swr : mxr,
                        Hwr(r)
                    ])),
                    _xr
                ]))
            ]));
        }
        return tB;
    }), jxr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Sxr = F2(function(n, r) {
        return A2(jxr, n, r);
    }), Lxr = F4(function(n, r, t, e) {
        var u = q0n(e), a = E0n(e), i = A2(yH, x([
            _A(A2(kGn, a, r))
        ]), t), c = u0n(r), o = L0n(a) && !$Gn(a);
        return A2(Sxr, {
            zn: o,
            kE: u,
            rQ: A3(j0n, c, n, a)
        }, i);
    }), Mxr = F3(function(n, r, t) {
        return A3(bIn, {
            aX: n.aX,
            a5: n.a5
        }, yB(r), t);
    }), Nxr = F2(function(n, r) {
        if (TE(r)) return tB;
        if (n.$) return tB;
        var t = n.a;
        return A2(nk, x([
            Xx("stepper")
        ]), A2(Eu, function(n) {
            var e = n.a, u = n.b;
            return A3(Mxr, {
                aX: t,
                a5: be(r)
            }, u, e);
        }, r));
    }), Hxr = F5(function(n, r, t, e, u) {
        var a = M0n(t), i = b(be(a) > 0, aF(e));
        if (i.a && i.b) {
            var c = nQn(r);
            return A2(Nxr, e, A2(Eu, A3(Lxr, n, c, u), a));
        }
        return tB;
    }), Txr = F8(function(n, r, t, e, u, a, i, c) {
        if (3 === e.$) {
            var o = e.a;
            return A2(cxr, x([
                Xx("header")
            ]), x([
                A2(nk, x([
                    Xx("header__container")
                ]), x([
                    A2(nk, x([
                        Xx("signup__page-border")
                    ]), h),
                    A2(nk, x([
                        Xx("signup__page-center")
                    ]), x([
                        A2(nk, x([
                            Xx("flex items-center flex-wrap w-full")
                        ]), x([
                            A2(nk, x([
                                Xx("flex flex-shrink-0 mr-2 md:mr-8")
                            ]), x([
                                A2(dxr, r, t)
                            ])),
                            A2(nk, x([
                                Xx("flex justify-self-end overflow-hidden")
                            ]), x([
                                A5(Hxr, n, o, u, a, ofr(i))
                            ]))
                        ]))
                    ])),
                    A2(nk, x([
                        Xx("signup__page-border")
                    ]), h)
                ])),
                function() {
                    if (c.$) return tB;
                    var n = c.a;
                    return A2(nk, x([
                        Xx("header__container header__container--shaded")
                    ]), x([
                        A2(nk, x([
                            Xx("signup__page-border")
                        ]), h),
                        A2(nk, x([
                            Xx("signup__page-center")
                        ]), x([
                            n
                        ])),
                        A2(nk, x([
                            Xx("signup__page-border")
                        ]), h)
                    ]));
                }()
            ]));
        }
        return tB;
    }), Ixr = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = TE(a) ? Ut : 3 === u.$ ? A3(Fxr, nQn(u.a), a, i) : Ut;
        return x([
            A2(nk, x([
                Xx("layout"),
                SC(x([
                    b("signup--thanks", LP(f))
                ]))
            ]), x([
                A2(Rwr, n, t),
                A8(Txr, n, t, e, u, a, f, i, c),
                A2(nk, x([
                    Xx("main main--signup")
                ]), x([
                    Pxr(o)
                ])),
                A5(zxr, n, r, t, u, e)
            ]))
        ]);
    }), Rxr = function(n) {
        return A2(GI, 4, n);
    }, Zxr = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + oe(n.a);
    }), Vxr = F3(function(n, r, t) {
        return 1 === r.$ ? t : $(t, $(n, r.a));
    }), Uxr = function(n) {
        return A3(Vxr, "#", n.z6, A3(Vxr, "?", n.iF, $(A2(Zxr, n.uI, $(n.u6 ? "https://" : "http://", n.Ai)), n.Cq)));
    }, Yxr = function(n) {
        return A2(nk, x([
            Xx("flex items-center")
        ]), x([
            A2(Zq, x([
                Xx("input-color"),
                oT(n),
                Vq("color")
            ]), h)
        ]));
    }, Qxr = function(n) {
        return A2(cxr, x([
            Xx("header")
        ]), x([
            A2(nk, x([
                Xx("header__container justify-between px-6")
            ]), x([
                A2(fB, x([
                    yB(_A(Oi))
                ]), x([
                    ld("Hint Legos")
                ])),
                Yxr(n)
            ]))
        ]));
    }, Oxr = F2(function(n, r) {
        var t = r.b, e = _A(r.a);
        return A2(fB, x([
            Xx("menu__item"),
            SC(x([
                b("menu__item--active", A2(fu, e, n))
            ])),
            yB(e)
        ]), x([
            ld(t)
        ]));
    }), Gxr = F3(function(n, r, t) {
        var e = n.D4;
        return x([
            A2(nk, x([
                Xx("layout")
            ]), x([
                Qxr(e),
                A2(nk, x([
                    Xx("main")
                ]), x([
                    A2(zN, x([
                        KN(x([
                            Xx("mx-0")
                        ]))
                    ]), x([
                        A2(EN, x([
                            JI(12),
                            bR(4),
                            kcn(3),
                            Rxr(2)
                        ]), x([
                            A2(nk, x([
                                Xx("menu")
                            ]), A2(Eu, Oxr(Uxr(r)), x([
                                b(Oi, "Typography"),
                                b(zi, "Grid"),
                                b(Bi, "Button"),
                                b(qi, "Checkbox"),
                                b(Hi, "Radio"),
                                b(Ii, "Select"),
                                b(Ti, "Searchable Select"),
                                b(ji, "Input"),
                                b(Vi, "Tag"),
                                b(Di, "Cart Icon"),
                                b(Ai, "Alerts"),
                                b(Yi, "Tooltip"),
                                b(Ri, "Table"),
                                b(Zi, "Tabs"),
                                b(yi, "Activity Indicator"),
                                b(Li, "Modal"),
                                b(Ci, "Api Select"),
                                b(Pi, "Form Example"),
                                b(Ei, "Card Example"),
                                b(Fi, "Filter Example"),
                                b(Ni, "Phone Input"),
                                b(_i, "Address Input"),
                                b(Si, "Insurance Info")
                            ])))
                        ])),
                        A2(EN, x([
                            JI(12),
                            bR(8),
                            kcn(9),
                            Rxr(10)
                        ]), x([
                            A2(nk, x([
                                Xx("pt-2 px-6")
                            ]), t)
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }), Jxr = {
        $: 9
    }, Wxr = {
        $: 1
    }, Kxr = F3(function(n, r, t) {
        var e = b(n, r);
        n: for(;;){
            r: for(;;)switch(e.a.$){
                case 3:
                    switch(e.b.$){
                        case 3:
                            var u = e.a.a, a = e.b.a;
                            return A4(fxr, t, lxr(a), Ex(u), sxr(a));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return ik(x([
                        Rnn
                    ]));
                default:
                    if (1 === e.b.$) break n;
                    break r;
            }
            return A4(fxr, t, Vt("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return ik(x([
            Rnn
        ]));
    }), Xxr = {
        $: 2
    }, nkr = function(n) {
        return n.wl;
    }, rkr = function(n) {
        return A2(LB, x([
            ok(x([
                Xx("column")
            ])),
            ok($k(ycn))
        ]), x([
            A2(OC, x([
                oF,
                EC(Xxr)
            ]), x([
                ld(n(nkr))
            ]))
        ]));
    }, tkr = {
        $: 1
    }, ekr = F3(function(n, r, t) {
        return r ? A2(fB, x([
            yB(""),
            Xx("account-menu__item"),
            IC(tkr)
        ]), x([
            ld(n(t ? bd : vd))
        ])) : tB;
    }), ukr = function(n) {
        return b(Xgr(n), n);
    }, akr = function(n) {
        return A2(cD, "self_buy", n);
    }, ikr = function(n) {
        var r = aon(n) || ion(n) ? x([
            0,
            1,
            2,
            3,
            4
        ]) : x([
            0,
            1,
            2,
            4
        ]);
        return A3(Mq, akr(n), 5, r);
    }, ckr = F3(function(n, r, t) {
        var e, u;
        return A2(Eu, ukr, (e = ikr(t), u = n ? A2(Yt, 7, e) : e, r ? A2(Yt, 8, u) : u));
    }), okr = F2(function(n, r) {
        return 2 === r ? AAn(n) ? Wd.Ea : Wd.w5 : Pb(r);
    }), fkr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(fB, x([
            Xx("account-menu__item"),
            SC(x([
                b("account-menu__item--active", i(t, Vt(a)))
            ])),
            yB(_A(u))
        ]), x([
            ld(n(A2(okr, r, a)))
        ]));
    }), skr = F5(function(n, r, t, e, u) {
        return A2(Eu, A3(fkr, n, u, e), A3(ckr, r, t, u));
    }), lkr = F2(function(n, r) {
        var t = r.bM, e = r.sv, u = r.iP, a = r.dK, i = r.dB;
        return A2(LB, x([
            ok(x([
                Xx("sidebar")
            ]))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("sidebar__burger"),
                    pj(0)
                ]))
            ]), h),
            A2(FI, h, h),
            A2(FI, h, h),
            A2(FI, h, h),
            A2(LB, x([
                ok(x([
                    Xx("sidebar__links")
                ]))
            ]), A2(nc, A5(skr, n, t, e, u, i), x([
                A3(ekr, n, a, !1)
            ])))
        ]));
    }), dkr = {
        $: 1
    }, bkr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vkr = F2(function(n, r) {
        var t = A2(sc, n, r);
        return su(t) > 0 ? Vt($v(A2(mu, 1, t))) : Ut;
    }), mkr = function(n) {
        return A2(fe, "", A2(Tp, iu, x([
            A2(vkr, o$n(n), e$n(n)),
            A2(vkr, b$n(n), u$n(n))
        ])));
    }, pkr = function(n) {
        return function(n) {
            return {
                $: 7,
                a: n
            };
        }(n);
    }, $kr = xan(Lq(1)), hkr = function(n) {
        return function(n) {
            return {
                $: 9,
                a: n
            };
        }(n);
    }, gkr = function(n) {
        return function(n) {
            return {
                $: 10,
                a: n
            };
        }(n);
    }, wkr = Ryn(2), xkr = F3(function(n, r, t) {
        if (r.bM) {
            var e = x([
                bkr(1),
                bkr(2)
            ]), u = aon(r.dB) || ion(r.dB), a = A2(Eu, function(n) {
                return A2(hq, h, n);
            }, A3(Mq, r.dK, dkr, A3(Mq, r.sv, bkr(8), A3(Mq, akr(r.dB), bkr(5), $(A3(Mq, u, bkr(3), e), x([
                bkr(4)
            ]))))));
            return x([
                A2(LB, x([
                    ok(x([
                        Xx("hidden md:inline-flex")
                    ]))
                ]), x([
                    A2(Ck, Kgr, A4(sF, n, x([
                        $kr,
                        xq(mkr(r.t6)),
                        wkr,
                        pkr(!1)
                    ]), a, t.dH))
                ])),
                A2(Ck, yu, A2(OC, x([
                    cF,
                    iF,
                    hkr(2),
                    gkr(2)
                ]), x([
                    ld(mkr(r.t6))
                ])))
            ]);
        }
        return x([
            tB
        ]);
    }), kkr = F3(function(n, r, t) {
        return n ? A2(Eu, ukr, x([
            7,
            0
        ])) : A3(ckr, !1, r, t);
    }), ykr = F5(function(n, r, t, e, u) {
        return A2(Eu, A3(fkr, n, u, e), A3(kkr, r, t, u));
    }), _kr = F3(function(n, r, t) {
        return A2(LB, x([
            ok(x([
                Xx("flex w-full gap-4")
            ])),
            ok($k(LI)),
            ok(r.bM ? $k(kF) : h)
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex")
                ]))
            ]), x([
                A2(Ck, yu, r.iB)
            ])),
            A2(LB, x([
                ok(x([
                    Xx("flex-grow hidden md:flex h-full gap-4")
                ])),
                ok($k(kF))
            ]), A3(Mq, !r.bM, A3(ekr, n, r.dK, !1), A5(ykr, n, r.bM, r.sv, r.iP, r.dB))),
            A2(LB, x([
                ok(x([
                    Xx("flex absolute left-6 md:relative md:left-0")
                ]))
            ]), A3(xkr, n, r, t))
        ]));
    }), Akr = F4(function(n, r, t, e) {
        var u, a = aon(e) || ion(e);
        return A3(Mq, t, dkr, A3(Mq, akr(e), bkr(5), (u = A3(Mq, a, bkr(3), $(A3(Mq, r, bkr(9), n ? x([
            bkr(8)
        ]) : h), x([
            bkr(7),
            bkr(0),
            bkr(1),
            bkr(2)
        ]))), $(u, x([
            bkr(4)
        ])))));
    }), Ckr = F3(function(n, r, t) {
        if (r.bM) {
            var e = A2(Eu, function(n) {
                return A2(hq, h, n);
            }, A4(Akr, r.sv, r.j9, r.dK, r.dB));
            return x([
                A2(LB, x([
                    ok(x([
                        Xx("hidden md:inline-flex")
                    ]))
                ]), x([
                    A2(Ck, Kgr, A4(sF, n, x([
                        $kr,
                        xq(mkr(r.t6)),
                        wkr,
                        pkr(!1)
                    ]), e, t.dH))
                ])),
                A2(Ck, yu, A2(OC, x([
                    cF,
                    iF,
                    hkr(2),
                    gkr(2),
                    gC(x([
                        Xx("navbar-app__avatar")
                    ]))
                ]), x([
                    ld(mkr(r.t6))
                ])))
            ]);
        }
        return x([
            tB
        ]);
    }), Bkr = {
        $: 4
    }, Ekr = {
        $: 3
    }, Dkr = function(n) {
        return n.nM;
    }, qkr = function(n) {
        return n.tP;
    }, Fkr = F4(function(n, r, t, e) {
        var u = r ? x([
            8
        ]) : h, a = t ? $(u, x([
            9
        ])) : u, i = n ? $(a, x([
            7
        ])) : a;
        return A2(Eu, ukr, $(i, ikr(e)));
    }), Pkr = F2(function(n, r) {
        return r ? A2(fB, x([
            yB(""),
            Xx("sidebar__link sidebar__link--logout"),
            IC(tkr)
        ]), x([
            ld(n(bd))
        ])) : tB;
    }), zkr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(fB, x([
            Xx("sidebar__link"),
            SC(x([
                b("sidebar__link--active", i(t, Vt(a)))
            ])),
            yB(_A(u)),
            IC(Bkr)
        ]), x([
            ld(n(A2(okr, r, a)))
        ]));
    }), jkr = F3(function(n, r, t) {
        var e = r.iP, u = r.dK, a = r.dB, i = A4(Fkr, r.bM, r.sv, r.j9, a), c = A2(Eu, A3(zkr, n, a, e), i), o = A2(Pkr, n, u);
        return A2(LB, x([
            ok(x([
                Xx("sidebar sidebar--polish")
            ]))
        ]), x([
            A2(PC, x([
                Vq("button"),
                Hq("sidebar-polish-open"),
                Xx("sidebar__polish-open"),
                IC(Ekr),
                A2(jC, "aria-label", n(qkr)),
                A2(jC, "aria-expanded", t.b$ ? "true" : "false")
            ]), x([
                A2(ak, x([
                    Xx("sidebar__polish-dehaze")
                ]), x([
                    A2(ak, x([
                        Xx("sidebar__polish-dehaze-bar")
                    ]), h),
                    A2(ak, x([
                        Xx("sidebar__polish-dehaze-bar")
                    ]), h),
                    A2(ak, x([
                        Xx("sidebar__polish-dehaze-bar")
                    ]), h)
                ]))
            ])),
            A2(nk, A2(Yt, SC(x([
                b("sidebar__polish-layer", !0),
                b("sidebar__polish-layer--is-open", t.b$)
            ])), A2(Yt, A2(jC, "aria-hidden", t.b$ ? "false" : "true"), x(t.b$ ? [
                A2(TC, "keydown", P6(cm(Bkr)))
            ] : [
                A2(jC, "inert", "")
            ]))), x([
                A2(nk, x([
                    Xx("sidebar__polish-scrim"),
                    IC(Bkr)
                ]), h),
                A2(nk, x([
                    Xx("sidebar__polish-panel"),
                    A2(jC, "role", "dialog"),
                    A2(jC, "aria-modal", "true")
                ]), x([
                    A2(PC, x([
                        Vq("button"),
                        Hq("sidebar-polish-close"),
                        Xx("sidebar__polish-close"),
                        IC(Bkr),
                        A2(jC, "aria-label", n(Dkr))
                    ]), x([
                        A2(PE, x([
                            ej
                        ]), 2)
                    ])),
                    A2(nk, x([
                        Xx("sidebar__polish-links")
                    ]), A2(nc, c, x([
                        o
                    ])))
                ]))
            ]))
        ]));
    }), Skr = F3(function(n, r, t) {
        return A2(LB, x([
            ok(x([
                Xx("navbar-app__top")
            ])),
            ok($k(LI))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("navbar-app__start")
                ]))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("navbar-app__burger")
                    ]))
                ]), x([
                    A3(jkr, n, r, t)
                ]))
            ])),
            A2(LB, x([
                ok(x([
                    Xx("navbar-app__logo min-w-0")
                ]))
            ]), x([
                A2(Ck, yu, r.iB)
            ])),
            A2(LB, x([
                ok(x([
                    Xx("navbar-app__end")
                ]))
            ]), x([
                A2(LB, x([
                    ok(x([
                        Xx("navbar-app__profile")
                    ]))
                ]), A3(Ckr, n, r, t))
            ]))
        ]));
    }), Lkr = F3(function(n, r, t) {
        return r.sc ? A2(LB, x([
            ok(x([
                Xx("flex w-full items-center justify-between gap-4")
            ]))
        ]), x([
            A2(LB, x([
                ok(x([
                    Xx("flex")
                ]))
            ]), x([
                A2(Ck, yu, r.iB)
            ])),
            rkr(n)
        ])) : r.ue ? A2(LB, x([
            ok(x([
                Xx("navbar-app w-full")
            ]))
        ]), x([
            A3(Skr, n, r, t)
        ])) : A2(LB, x([
            ok(x([
                Xx("flex w-full")
            ]))
        ]), x([
            A3(_kr, n, r, t),
            A2(lkr, n, r)
        ]));
    }), Mkr = F2(function(n, r) {
        var t, e = b(r.dB, r.ud);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a, a = e.b.a, i = wtn(r.gF) || !A2(_An, 0, u), c = EQn(u) && XG(u) && DQn(u), o = i ? Ut : Vt(_A(c ? Wa : r.bM ? Ca : Ea)), f = 3 === (t = r.ej).$ && !TE(zD(t.a));
            return A2(Ck, n, A2(Ck, nhr, A3(Lkr, Wx(r.kA), {
                j9: f,
                bM: r.bM,
                sc: i,
                sv: A2(Pgr, r.uN, u),
                t6: a,
                ue: DQn(u),
                dB: u,
                iB: A3(Kxr, r.dB, r.an, o),
                dK: !0,
                iP: r.x6
            }, r.dw)));
        }
        return tB;
    }), Nkr = F2(function(n, r) {
        return A2(Fp, function(t) {
            return A2(Ck, n, A2(Ck, thr(!0), A2(j7, t, r.dZ)));
        }, r.d_);
    }), Hkr = F4(function(n, r, t, e) {
        var u, a, i = Wx(t.kA), c = 3 === (u = t.dB).$ && DQn(u.a) ? 1 : 0, o = A2(Ck, n, function(n) {
            var r = n.dB, t = n.kA, e = n.cB;
            return 3 === r.$ && MPn(r.a) ? A2(LB, x([
                ok(x([
                    Xx("w-40 flex")
                ])),
                ok($k(LI))
            ]), x([
                A2(FI, x([
                    V0,
                    ok(x([
                        Xx("mr-2")
                    ]))
                ]), x([
                    A2(PE, x([
                        HB
                    ]), 28)
                ])),
                A2(ak, x([
                    Xx("flex-1")
                ]), x([
                    A2(Ck, K$r, A3(Vyn, Wx(t), x([
                        Wxr
                    ]), e))
                ]))
            ])) : tB;
        }(t));
        switch(r){
            case 0:
                var f = A2(Nkr, n, t), s = 3 === (a = t.DF).$ ? a.a : h;
                return A2(Yt, A2(Ck, n, t.hg ? A2(LB, x([
                    ok(x([
                        Xx("debug__box")
                    ]))
                ]), x([
                    A2(LB, x([
                        ok(x([
                            Xx("alert alert--success")
                        ]))
                    ]), x([
                        A2(FI, x([
                            ok(x([
                                Xx("debug__text")
                            ]))
                        ]), x([
                            ld("Debug mode")
                        ])),
                        A2(OC, x([
                            EC(Jxr)
                        ]), x([
                            A2(PE, h, 2)
                        ]))
                    ]))
                ])) : tB), A9(Ixr, i, o, t.dB, t.an, t.fL, s, t.xs, f, e));
            case 1:
                return A3(Gxr, {
                    D4: A2(pc, n, Pwr)
                }, t.xs, e);
            case 4:
                return A8(yxr, i, o, t.dB, t.an, t.xs, e, l = A2(Mkr, n, t), c);
            case 5:
                return A8($xr, i, o, t.dB, t.an, t.xs, e, l = A2(Mkr, n, t), c);
            case 3:
                var l = A2(Mkr, n, t);
                return (function(n) {
                    return function(r) {
                        return function(t) {
                            return function(e) {
                                return function(u) {
                                    return function(a) {
                                        return function(i) {
                                            return function(c) {
                                                return function(o) {
                                                    return function(f) {
                                                        return function(s) {
                                                            var l, d = !(l = b(a, t)).a.$ && 5 === l.a.a && 3 === l.b.$ && f8(l.b.a), v = 3 === t.$ ? Bx(t.a) : "", m = a.$ ? "" : 2 === a.a ? 3 === t.$ && AAn(t.a) ? n(Wd.Ea) : n(Wd.w5) : n(Pb(a.a)), p = 3 === e.$ && Mwr(e.a), $ = a.$ || 7 !== a.a ? "" : "layout--healthInformation", g = d ? A2(nk, x([
                                                                Xx("absolute right-0 top-1/2 -translate-y-1/2")
                                                            ]), x([
                                                                Fbr({
                                                                    y3: c,
                                                                    Aj: _A(wa),
                                                                    xl: n
                                                                })
                                                            ])) : tB;
                                                            return x([
                                                                A2(nk, x([
                                                                    Xx(A2(fe, " ", x([
                                                                        "layout layout--app",
                                                                        $
                                                                    ])))
                                                                ]), x([
                                                                    A2(Rwr, n, t),
                                                                    A3(oxr, t, f, s),
                                                                    A2(nk, x([
                                                                        Xx("main main--app")
                                                                    ]), x([
                                                                        A2(nk, x([
                                                                            Xx(1 === s ? "app-container app-account-container mt-0 px-4 md:my-8 md:mt-8 md:px-0" : "app-container app-account-container md:my-8 mt-4")
                                                                        ]), x(1 === s ? [
                                                                            A2(nk, x([
                                                                                Xx("relative account-page__title-band py-4 text-center md:py-6")
                                                                            ]), 3 === u.$ ? x([
                                                                                A2(yC, x([
                                                                                    ok(x([
                                                                                        Xx("text-2xl")
                                                                                    ]))
                                                                                ]), x([
                                                                                    ld(m)
                                                                                ])),
                                                                                g
                                                                            ]) : h),
                                                                            A2(nk, x([
                                                                                Xx("account-page__content rounded bg-white p-4 shadow-sm md:p-8")
                                                                            ]), o)
                                                                        ] : 3 === u.$ ? [
                                                                            A2(nk, x([
                                                                                Xx("relative text-center mb-6")
                                                                            ]), x([
                                                                                A2(yC, h, x([
                                                                                    ld(m)
                                                                                ])),
                                                                                g
                                                                            ])),
                                                                            A2(nk, h, o)
                                                                        ] : [
                                                                            A2(nk, x([
                                                                                Xx("text-center")
                                                                            ]), o)
                                                                        ])),
                                                                        A2(ixr, t, i)
                                                                    ])),
                                                                    A3(uxr, n, x([
                                                                        1
                                                                    ]), x([
                                                                        Lwr(x([
                                                                            p ? Swr : A2(jwr, v, "member_app_portal"),
                                                                            1 === s ? Twr(r) : Hwr(r)
                                                                        ]))
                                                                    ]))
                                                                ]))
                                                            ]);
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                })(i)(o)(t.dB)(t.an)(t.t6)(t.x6)(t.ej)(be(t.aW))(e)(l)(c);
            case 6:
                return A7(Exr, i, t.dB, t.an, t.t6, e, l = A2(Mkr, n, t), c);
            case 7:
                return A5(vxr, i, t.dB, t.an, t.xs, e);
            default:
                return A6(Cxr, i, o, t.an, e, t.dB, c);
        }
    }), Tkr = F2(function(n, r) {
        var t = n.a6, e = n.eV, u = n.Ec;
        return {
            gN: $(A2(Yt, A2(Ck, u, Fwr(r.ch)), A4(Hkr, u, e, r, t.gN)), h),
            w5: t.w5
        };
    });
    HJ = {
        Main: {
            init: Hu({
                Ar: function(n) {
                    var r = C$r(n.r6), t = r.a, e = r.b, u = A2(V$, n, t), a = u.a, i = u.b, c = lc(t), o = A2(m$r, c, a), f = o.a, s = o.b, l = k$r(c);
                    return b(A3(Iu, a, f, l), Vu(x([
                        A2(Lp, Zu, i),
                        A2(Lp, Ru, s),
                        e
                    ])));
                },
                DZ: function(n) {
                    return Px(x([
                        wXn(B$r),
                        A2(_S, Zu, Px(x([
                            eP(P$r),
                            T$r(j$r),
                            aP(z$r),
                            N$r(function() {
                                return E$r;
                            }),
                            H$r(F$r),
                            A2(IJ, 1e3, D$r),
                            wXn(L$r),
                            mJn(q$r),
                            dJn(S$r)
                        ]))),
                        A2(_S, Ru, R$r(n.a6))
                    ]));
                },
                En: Bwr,
                Et: A2(ru, function(n) {
                    return A2(Tkr, {
                        eV: n.eV,
                        a6: A2(l$r, Ru, Cwr(n.a6)),
                        Ec: Zu
                    }, n.Dr);
                }, Z$r)
            })(A2(nu, function(n) {
                return A2(nu, function(r) {
                    return A2(nu, function(t) {
                        return A2(nu, function(e) {
                            return A2(nu, function(u) {
                                return A2(nu, function(a) {
                                    return A2(nu, function(i) {
                                        return A2(nu, function(c) {
                                            return A2(nu, function(o) {
                                                return A2(nu, function(f) {
                                                    return A2(nu, function(s) {
                                                        return A2(nu, function(l) {
                                                            return A2(nu, function(d) {
                                                                return A2(nu, function(b) {
                                                                    return A2(nu, function(v) {
                                                                        return A2(nu, function(m) {
                                                                            return uu({
                                                                                x5: m,
                                                                                i: v,
                                                                                ym: b,
                                                                                bb: d,
                                                                                bK: l,
                                                                                bj: s,
                                                                                zE: f,
                                                                                zF: o,
                                                                                zG: c,
                                                                                zH: i,
                                                                                zI: a,
                                                                                zJ: u,
                                                                                Ag: e,
                                                                                AL: t,
                                                                                r6: r,
                                                                                CZ: n
                                                                            });
                                                                        }, A2(Tu, "accountPracticeId", P$(x([
                                                                            oy(Ut),
                                                                            A2(tu, Vt, C$)
                                                                        ]))));
                                                                    }, A2(Tu, "accountToken", P$(x([
                                                                        oy(Ut),
                                                                        A2(tu, Vt, C$)
                                                                    ]))));
                                                                }, A2(Tu, "apiUrl", C$));
                                                            }, A2(Tu, "apiVersion", P$(x([
                                                                oy(Ut),
                                                                A2(tu, Vt, C$)
                                                            ]))));
                                                        }, A2(Tu, "bustCacheRandom", C$));
                                                    }, A2(Tu, "currentTime", F$));
                                                }, A2(Tu, "emrCalendarsUrl", C$));
                                            }, A2(Tu, "emrCalendarsVersion", P$(x([
                                                oy(Ut),
                                                A2(tu, Vt, C$)
                                            ]))));
                                        }, A2(Tu, "emrMessagingUrl", C$));
                                    }, A2(Tu, "emrMessagingVersion", P$(x([
                                        oy(Ut),
                                        A2(tu, Vt, C$)
                                    ]))));
                                }, A2(Tu, "emrNotesUrl", C$));
                            }, A2(Tu, "emrNotesVersion", P$(x([
                                oy(Ut),
                                A2(tu, Vt, C$)
                            ]))));
                        }, A2(Tu, "hintEnv", P$(x([
                            oy(Ut),
                            A2(tu, Vt, C$)
                        ]))));
                    }, A2(Tu, "language", C$));
                }, A2(Tu, "locationHref", C$));
            }, A2(Tu, "release", P$(x([
                oy(Ut),
                A2(tu, Vt, C$)
            ])))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, HJ) : n.Elm = HJ;
}($b9e750d20bbc1f0f$exports);




/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /**
 * pdfjsVersion = 5.7.284
 * pdfjsBuild = 7e5b36c2d
 */ /******/ // The require scope
/******/ 
var $4TZ3D = parcelRequire("4TZ3D");
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $13b630ad92b827c2$export$a143d493d941bafc;
var $13b630ad92b827c2$export$e4cf37d7f6fb9e0a;
var $13b630ad92b827c2$export$f99ded8fe4b79145;
var $13b630ad92b827c2$export$599f31c3813fae4d;
'use strict';
var $441c3b20dbacff63$export$a48f0734ac7c2329;
var $441c3b20dbacff63$export$d622b2ad8d90c771;
var $441c3b20dbacff63$export$6100ba28696e12de;
'use strict';
$441c3b20dbacff63$export$a48f0734ac7c2329 = $441c3b20dbacff63$var$byteLength;
$441c3b20dbacff63$export$d622b2ad8d90c771 = $441c3b20dbacff63$var$toByteArray;
$441c3b20dbacff63$export$6100ba28696e12de = $441c3b20dbacff63$var$fromByteArray;
var $441c3b20dbacff63$var$lookup = [];
var $441c3b20dbacff63$var$revLookup = [];
var $441c3b20dbacff63$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $441c3b20dbacff63$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $441c3b20dbacff63$var$i = 0, $441c3b20dbacff63$var$len = $441c3b20dbacff63$var$code.length; $441c3b20dbacff63$var$i < $441c3b20dbacff63$var$len; ++$441c3b20dbacff63$var$i){
    $441c3b20dbacff63$var$lookup[$441c3b20dbacff63$var$i] = $441c3b20dbacff63$var$code[$441c3b20dbacff63$var$i];
    $441c3b20dbacff63$var$revLookup[$441c3b20dbacff63$var$code.charCodeAt($441c3b20dbacff63$var$i)] = $441c3b20dbacff63$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$441c3b20dbacff63$var$revLookup['-'.charCodeAt(0)] = 62;
$441c3b20dbacff63$var$revLookup['_'.charCodeAt(0)] = 63;
function $441c3b20dbacff63$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $441c3b20dbacff63$var$byteLength(b64) {
    var lens = $441c3b20dbacff63$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $441c3b20dbacff63$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $441c3b20dbacff63$var$toByteArray(b64) {
    var tmp;
    var lens = $441c3b20dbacff63$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $441c3b20dbacff63$var$Arr($441c3b20dbacff63$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 18 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 2 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 10 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $441c3b20dbacff63$var$tripletToBase64(num) {
    return $441c3b20dbacff63$var$lookup[num >> 18 & 0x3F] + $441c3b20dbacff63$var$lookup[num >> 12 & 0x3F] + $441c3b20dbacff63$var$lookup[num >> 6 & 0x3F] + $441c3b20dbacff63$var$lookup[num & 0x3F];
}
function $441c3b20dbacff63$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($441c3b20dbacff63$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $441c3b20dbacff63$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($441c3b20dbacff63$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($441c3b20dbacff63$var$lookup[tmp >> 2] + $441c3b20dbacff63$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($441c3b20dbacff63$var$lookup[tmp >> 10] + $441c3b20dbacff63$var$lookup[tmp >> 4 & 0x3F] + $441c3b20dbacff63$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $973b14a6d4579a4e$export$aafa59e2e03f2942;
var $973b14a6d4579a4e$export$68d8715fc104d294;
$973b14a6d4579a4e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$973b14a6d4579a4e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $13b630ad92b827c2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$13b630ad92b827c2$export$a143d493d941bafc = $13b630ad92b827c2$var$Buffer;
$13b630ad92b827c2$export$e4cf37d7f6fb9e0a = $13b630ad92b827c2$var$SlowBuffer;
$13b630ad92b827c2$export$f99ded8fe4b79145 = 50;
var $13b630ad92b827c2$var$K_MAX_LENGTH = 0x7fffffff;
$13b630ad92b827c2$export$599f31c3813fae4d = $13b630ad92b827c2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $13b630ad92b827c2$var$Buffer.TYPED_ARRAY_SUPPORT = $13b630ad92b827c2$var$typedArraySupport();
if (!$13b630ad92b827c2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $13b630ad92b827c2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($13b630ad92b827c2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$13b630ad92b827c2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($13b630ad92b827c2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$13b630ad92b827c2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $13b630ad92b827c2$var$createBuffer(length) {
    if (length > $13b630ad92b827c2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $13b630ad92b827c2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $13b630ad92b827c2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $13b630ad92b827c2$var$allocUnsafe(arg);
    }
    return $13b630ad92b827c2$var$from(arg, encodingOrOffset, length);
}
$13b630ad92b827c2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $13b630ad92b827c2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $13b630ad92b827c2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $13b630ad92b827c2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($13b630ad92b827c2$var$isInstance(value, ArrayBuffer) || value && $13b630ad92b827c2$var$isInstance(value.buffer, ArrayBuffer)) return $13b630ad92b827c2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($13b630ad92b827c2$var$isInstance(value, SharedArrayBuffer) || value && $13b630ad92b827c2$var$isInstance(value.buffer, SharedArrayBuffer))) return $13b630ad92b827c2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $13b630ad92b827c2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $13b630ad92b827c2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $13b630ad92b827c2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $13b630ad92b827c2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $13b630ad92b827c2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($13b630ad92b827c2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($13b630ad92b827c2$var$Buffer, Uint8Array);
function $13b630ad92b827c2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $13b630ad92b827c2$var$alloc(size, fill, encoding) {
    $13b630ad92b827c2$var$assertSize(size);
    if (size <= 0) return $13b630ad92b827c2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $13b630ad92b827c2$var$createBuffer(size).fill(fill, encoding) : $13b630ad92b827c2$var$createBuffer(size).fill(fill);
    return $13b630ad92b827c2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $13b630ad92b827c2$var$Buffer.alloc = function(size, fill, encoding) {
    return $13b630ad92b827c2$var$alloc(size, fill, encoding);
};
function $13b630ad92b827c2$var$allocUnsafe(size) {
    $13b630ad92b827c2$var$assertSize(size);
    return $13b630ad92b827c2$var$createBuffer(size < 0 ? 0 : $13b630ad92b827c2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $13b630ad92b827c2$var$Buffer.allocUnsafe = function(size) {
    return $13b630ad92b827c2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $13b630ad92b827c2$var$Buffer.allocUnsafeSlow = function(size) {
    return $13b630ad92b827c2$var$allocUnsafe(size);
};
function $13b630ad92b827c2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$13b630ad92b827c2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $13b630ad92b827c2$var$byteLength(string, encoding) | 0;
    var buf = $13b630ad92b827c2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $13b630ad92b827c2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $13b630ad92b827c2$var$checked(array.length) | 0;
    var buf = $13b630ad92b827c2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $13b630ad92b827c2$var$fromArrayView(arrayView) {
    if ($13b630ad92b827c2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $13b630ad92b827c2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $13b630ad92b827c2$var$fromArrayLike(arrayView);
}
function $13b630ad92b827c2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $13b630ad92b827c2$var$Buffer.prototype);
    return buf;
}
function $13b630ad92b827c2$var$fromObject(obj) {
    if ($13b630ad92b827c2$var$Buffer.isBuffer(obj)) {
        var len = $13b630ad92b827c2$var$checked(obj.length) | 0;
        var buf = $13b630ad92b827c2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $13b630ad92b827c2$var$numberIsNaN(obj.length)) return $13b630ad92b827c2$var$createBuffer(0);
        return $13b630ad92b827c2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $13b630ad92b827c2$var$fromArrayLike(obj.data);
}
function $13b630ad92b827c2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $13b630ad92b827c2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $13b630ad92b827c2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $13b630ad92b827c2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $13b630ad92b827c2$var$Buffer.alloc(+length);
}
$13b630ad92b827c2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $13b630ad92b827c2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$13b630ad92b827c2$var$Buffer.compare = function compare(a, b) {
    if ($13b630ad92b827c2$var$isInstance(a, Uint8Array)) a = $13b630ad92b827c2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($13b630ad92b827c2$var$isInstance(b, Uint8Array)) b = $13b630ad92b827c2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(a) || !$13b630ad92b827c2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$13b630ad92b827c2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$13b630ad92b827c2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $13b630ad92b827c2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $13b630ad92b827c2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($13b630ad92b827c2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $13b630ad92b827c2$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$13b630ad92b827c2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $13b630ad92b827c2$var$byteLength(string, encoding) {
    if ($13b630ad92b827c2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $13b630ad92b827c2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $13b630ad92b827c2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $13b630ad92b827c2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$13b630ad92b827c2$var$Buffer.byteLength = $13b630ad92b827c2$var$byteLength;
function $13b630ad92b827c2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $13b630ad92b827c2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $13b630ad92b827c2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $13b630ad92b827c2$var$latin1Slice(this, start, end);
        case 'base64':
            return $13b630ad92b827c2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $13b630ad92b827c2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$13b630ad92b827c2$var$Buffer.prototype._isBuffer = true;
function $13b630ad92b827c2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$13b630ad92b827c2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$13b630ad92b827c2$var$swap(this, i, i + 1);
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $13b630ad92b827c2$var$swap(this, i, i + 3);
        $13b630ad92b827c2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $13b630ad92b827c2$var$swap(this, i, i + 7);
        $13b630ad92b827c2$var$swap(this, i + 1, i + 6);
        $13b630ad92b827c2$var$swap(this, i + 2, i + 5);
        $13b630ad92b827c2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $13b630ad92b827c2$var$utf8Slice(this, 0, length);
    return $13b630ad92b827c2$var$slowToString.apply(this, arguments);
};
$13b630ad92b827c2$var$Buffer.prototype.toLocaleString = $13b630ad92b827c2$var$Buffer.prototype.toString;
$13b630ad92b827c2$var$Buffer.prototype.equals = function equals(b) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $13b630ad92b827c2$var$Buffer.compare(this, b) === 0;
};
$13b630ad92b827c2$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $13b630ad92b827c2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($13b630ad92b827c2$var$customInspectSymbol) $13b630ad92b827c2$var$Buffer.prototype[$13b630ad92b827c2$var$customInspectSymbol] = $13b630ad92b827c2$var$Buffer.prototype.inspect;
$13b630ad92b827c2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($13b630ad92b827c2$var$isInstance(target, Uint8Array)) target = $13b630ad92b827c2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $13b630ad92b827c2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($13b630ad92b827c2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $13b630ad92b827c2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($13b630ad92b827c2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $13b630ad92b827c2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $13b630ad92b827c2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $13b630ad92b827c2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$13b630ad92b827c2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$13b630ad92b827c2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $13b630ad92b827c2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$13b630ad92b827c2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $13b630ad92b827c2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $13b630ad92b827c2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($13b630ad92b827c2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $13b630ad92b827c2$var$utf8Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $13b630ad92b827c2$var$asciiWrite(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$asciiToBytes(string), buf, offset, length);
}
function $13b630ad92b827c2$var$base64Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$base64ToBytes(string), buf, offset, length);
}
function $13b630ad92b827c2$var$ucs2Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$13b630ad92b827c2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $13b630ad92b827c2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $13b630ad92b827c2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $13b630ad92b827c2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $13b630ad92b827c2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$13b630ad92b827c2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $13b630ad92b827c2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $441c3b20dbacff63$export$6100ba28696e12de(buf);
    else return $441c3b20dbacff63$export$6100ba28696e12de(buf.slice(start, end));
}
function $13b630ad92b827c2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $13b630ad92b827c2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $13b630ad92b827c2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $13b630ad92b827c2$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $13b630ad92b827c2$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $13b630ad92b827c2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $13b630ad92b827c2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $13b630ad92b827c2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$13b630ad92b827c2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $13b630ad92b827c2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $13b630ad92b827c2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$13b630ad92b827c2$var$Buffer.prototype.readUintLE = $13b630ad92b827c2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readUintBE = $13b630ad92b827c2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint8 = $13b630ad92b827c2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$13b630ad92b827c2$var$Buffer.prototype.readUint16LE = $13b630ad92b827c2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint16BE = $13b630ad92b827c2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$13b630ad92b827c2$var$Buffer.prototype.readUint32LE = $13b630ad92b827c2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint32BE = $13b630ad92b827c2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$13b630ad92b827c2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$13b630ad92b827c2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$13b630ad92b827c2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$13b630ad92b827c2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 8, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$13b630ad92b827c2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 8, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $13b630ad92b827c2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$13b630ad92b827c2$var$Buffer.prototype.writeUintLE = $13b630ad92b827c2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUintBE = $13b630ad92b827c2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint8 = $13b630ad92b827c2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint16LE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint16BE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint32LE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint32BE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $13b630ad92b827c2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $973b14a6d4579a4e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$13b630ad92b827c2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeFloat(this, value, offset, true, noAssert);
};
$13b630ad92b827c2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeFloat(this, value, offset, false, noAssert);
};
function $13b630ad92b827c2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $973b14a6d4579a4e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$13b630ad92b827c2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeDouble(this, value, offset, true, noAssert);
};
$13b630ad92b827c2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$13b630ad92b827c2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$13b630ad92b827c2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$13b630ad92b827c2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $13b630ad92b827c2$var$Buffer.isBuffer(val) ? val : $13b630ad92b827c2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $13b630ad92b827c2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $13b630ad92b827c2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($13b630ad92b827c2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $13b630ad92b827c2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $13b630ad92b827c2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $13b630ad92b827c2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $13b630ad92b827c2$var$base64ToBytes(str) {
    return $441c3b20dbacff63$export$d622b2ad8d90c771($13b630ad92b827c2$var$base64clean(str));
}
function $13b630ad92b827c2$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $13b630ad92b827c2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $13b630ad92b827c2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $13b630ad92b827c2$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $b3a01b20dd2ade98$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
var $b3a01b20dd2ade98$var$__webpack_require__ = {};
/******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $b3a01b20dd2ade98$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($b3a01b20dd2ade98$var$__webpack_require__.o(definition, key) && !$b3a01b20dd2ade98$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $b3a01b20dd2ade98$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
const $b3a01b20dd2ade98$var$isNodeJS = false;
const $b3a01b20dd2ade98$var$BBOX_INIT = [
    Infinity,
    Infinity,
    -Infinity,
    -Infinity
];
const $b3a01b20dd2ade98$var$F32_BBOX_INIT = new Float32Array($b3a01b20dd2ade98$var$BBOX_INIT);
const $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $b3a01b20dd2ade98$var$LINE_FACTOR = 1.35;
const $b3a01b20dd2ade98$var$LINE_DESCENT_FACTOR = 0.35;
const $b3a01b20dd2ade98$var$BASELINE_FACTOR = $b3a01b20dd2ade98$var$LINE_DESCENT_FACTOR / $b3a01b20dd2ade98$var$LINE_FACTOR;
const $b3a01b20dd2ade98$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
const $b3a01b20dd2ade98$export$5a7af0c07e33392e = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $b3a01b20dd2ade98$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $b3a01b20dd2ade98$export$72ea3bfdd9a725bf = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102
};
const $b3a01b20dd2ade98$export$cf3df2a6ecc26692 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    INK_COLOR_AND_OPACITY: 24,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41
};
const $b3a01b20dd2ade98$export$bb99a5b8411e07d8 = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $b3a01b20dd2ade98$var$MeshFigureType = {
    TRIANGLES: 1,
    LATTICE: 2,
    PATCH: 3
};
const $b3a01b20dd2ade98$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $b3a01b20dd2ade98$export$b890e9c15247e0b3 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $b3a01b20dd2ade98$export$f50c3066a53a6f2c = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $b3a01b20dd2ade98$var$AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
const $b3a01b20dd2ade98$var$AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
const $b3a01b20dd2ade98$var$AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
const $b3a01b20dd2ade98$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $b3a01b20dd2ade98$var$AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
const $b3a01b20dd2ade98$var$DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
const $b3a01b20dd2ade98$var$PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
const $b3a01b20dd2ade98$export$b18df09d23c244c4 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
const $b3a01b20dd2ade98$var$DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    quadraticCurveTo: 3,
    closePath: 4
};
const $b3a01b20dd2ade98$export$5e72215208e4d9ad = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $b3a01b20dd2ade98$var$verbosity = $b3a01b20dd2ade98$export$b18df09d23c244c4.WARNINGS;
function $b3a01b20dd2ade98$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $b3a01b20dd2ade98$var$verbosity = level;
}
function $b3a01b20dd2ade98$var$getVerbosityLevel() {
    return $b3a01b20dd2ade98$var$verbosity;
}
function $b3a01b20dd2ade98$var$info(msg) {
    if ($b3a01b20dd2ade98$var$verbosity >= $b3a01b20dd2ade98$export$b18df09d23c244c4.INFOS) console.info(`Info: ${msg}`);
}
function $b3a01b20dd2ade98$var$warn(msg) {
    if ($b3a01b20dd2ade98$var$verbosity >= $b3a01b20dd2ade98$export$b18df09d23c244c4.WARNINGS) console.warn(`Warning: ${msg}`);
}
function $b3a01b20dd2ade98$var$unreachable(msg) {
    throw new Error(msg);
}
function $b3a01b20dd2ade98$var$assert(cond, msg) {
    if (!cond) $b3a01b20dd2ade98$var$unreachable(msg);
}
function $b3a01b20dd2ade98$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $b3a01b20dd2ade98$export$e076b47f5805ca0b(url, baseUrl = null, options = null) {
    if (!url) return null;
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            const dots = url.match(/\./g);
            if (dots?.length >= 2) url = `http://${url}`;
        }
        if (options.tryConvertEncoding) try {
            url = $b3a01b20dd2ade98$var$stringToUTF8String(url);
        } catch  {}
    }
    const absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return $b3a01b20dd2ade98$var$_isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function $b3a01b20dd2ade98$export$e1e4297c21ab9d13(url, hash, allowRel = false) {
    const res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && $b3a01b20dd2ade98$export$e076b47f5805ca0b(url, "http://example.com")) return url.split("#", 1)[0] + `${hash ? `#${hash}` : ""}`;
    return "";
}
function $b3a01b20dd2ade98$var$stripPath(str) {
    return str.substring(str.lastIndexOf("/") + 1);
}
function $b3a01b20dd2ade98$export$b8972b998723d602(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $b3a01b20dd2ade98$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $b3a01b20dd2ade98$var$PasswordException extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $b3a01b20dd2ade98$var$UnknownErrorException extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1 extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $b3a01b20dd2ade98$export$ea8e9c34f66e603 extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, status, missing){
        super(msg, "ResponseException");
        this.status = status;
        this.missing = missing;
    }
}
class $b3a01b20dd2ade98$var$FormatError extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $b3a01b20dd2ade98$export$d0e978393d193d1a extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $b3a01b20dd2ade98$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $b3a01b20dd2ade98$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $b3a01b20dd2ade98$var$stringToBytes(str) {
    if (typeof str !== "string") $b3a01b20dd2ade98$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $b3a01b20dd2ade98$var$objectSize(obj) {
    return Object.keys(obj).length;
}
function $b3a01b20dd2ade98$var$isLittleEndian() {
    const buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
class $b3a01b20dd2ade98$export$5fb8891d35c36978 {
    static get isLittleEndian() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isLittleEndian", $b3a01b20dd2ade98$var$isLittleEndian());
    }
    static get isOffscreenCanvasSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get isImageDecoderSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
    }
    static get isFloat16ArraySupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFloat16ArraySupported", typeof Float16Array !== "undefined");
    }
    static get isSanitizerSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isSanitizerSupported", typeof Sanitizer !== "undefined");
    }
    static get platform() {
        const { platform: platform, userAgent: userAgent } = navigator;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "platform", {
            isAndroid: userAgent.includes("Android"),
            isLinux: platform.includes("Linux"),
            isMac: platform.includes("Mac"),
            isWindows: platform.includes("Win"),
            isFirefox: userAgent.includes("Firefox")
        });
    }
    static get isCSSRoundSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
    }
    static get isAlphaColorInputSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isAlphaColorInputSupported", (()=>{
            if (typeof document === "undefined") return false;
            const input = document.createElement("input");
            input.type = "color";
            input.setAttribute("alpha", "");
            input.value = "#ff000080";
            return input.value !== "#ff0000";
        })());
    }
}
class $b3a01b20dd2ade98$export$f8f26dd395d7e1bd {
    static get hexNums() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "hexNums", Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0")));
    }
    static makeHexColor(r, g, b) {
        return `#${this.hexNums[r]}${this.hexNums[g]}${this.hexNums[b]}`;
    }
    static domMatrixToTransform(dm) {
        return [
            dm.a,
            dm.b,
            dm.c,
            dm.d,
            dm.e,
            dm.f
        ];
    }
    static scaleMinMax(transform, minMax) {
        let temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        } else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static multiplyByDOMMatrix(m, md) {
        return [
            m[0] * md.a + m[2] * md.b,
            m[1] * md.a + m[3] * md.b,
            m[0] * md.c + m[2] * md.d,
            m[1] * md.c + m[3] * md.d,
            m[0] * md.e + m[2] * md.f + m[4],
            m[1] * md.e + m[3] * md.f + m[5]
        ];
    }
    static applyTransform(p, m, pos = 0) {
        const p0 = p[pos];
        const p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    }
    static applyTransformToBezier(p, transform, pos = 0) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        for(let i = 0; i < 6; i += 2){
            const pI = p[pos + i];
            const pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    }
    static applyInverseTransform(p, m) {
        const p0 = p[0];
        const p1 = p[1];
        const d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    }
    static axialAlignedBoundingBox(rect, transform, output) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        const r0 = rect[0];
        const r1 = rect[1];
        const r2 = rect[2];
        const r3 = rect[3];
        let a0 = m0 * r0 + m4;
        let a2 = a0;
        let a1 = m0 * r2 + m4;
        let a3 = a1;
        let b0 = m3 * r1 + m5;
        let b2 = b0;
        let b1 = m3 * r3 + m5;
        let b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            const m1r0 = m1 * r0;
            const m1r2 = m1 * r2;
            const m2r1 = m2 * r1;
            const m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(matrix, output) {
        const m0 = matrix[0];
        const m1 = matrix[1];
        const m2 = matrix[2];
        const m3 = matrix[3];
        const a = m0 ** 2 + m1 ** 2;
        const b = m0 * m2 + m1 * m3;
        const c = m2 ** 2 + m3 ** 2;
        const first = (a + c) / 2;
        const second = Math.sqrt(first ** 2 - (a * c - b ** 2));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static pointBoundingBox(x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static rectBoundingBox(x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    }
}
const $b3a01b20dd2ade98$var$PDFStringTranslateTable = /* unused pure expression or super */ null;
function $b3a01b20dd2ade98$var$stringToPDFString(str, keepEscapeSequence = false) {
    if (str[0] >= "\xEF") {
        let encoding;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
        if (encoding) try {
            const decoder = new TextDecoder(encoding, {
                fatal: true
            });
            const buffer = $b3a01b20dd2ade98$var$stringToBytes(str);
            const decoded = decoder.decode(buffer);
            if (keepEscapeSequence || !decoded.includes("\x1b")) return decoded;
            return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`stringToPDFString: "${ex}".`);
        }
    }
    const strBuf = [];
    for(let i = 0, ii = str.length; i < ii; i++){
        const charCode = str.charCodeAt(i);
        if (!keepEscapeSequence && charCode === 0x1b) {
            while(++i < ii && str.charCodeAt(i) !== 0x1b);
            continue;
        }
        const code = $b3a01b20dd2ade98$var$PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function $b3a01b20dd2ade98$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $b3a01b20dd2ade98$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $b3a01b20dd2ade98$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b3a01b20dd2ade98$var$getModificationDate(date = new Date()) {
    if (!(date instanceof Date)) date = new Date(date);
    const buffer = [
        date.getUTCFullYear().toString(),
        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
        date.getUTCDate().toString().padStart(2, "0"),
        date.getUTCHours().toString().padStart(2, "0"),
        date.getUTCMinutes().toString().padStart(2, "0"),
        date.getUTCSeconds().toString().padStart(2, "0")
    ];
    return buffer.join("");
}
let $b3a01b20dd2ade98$var$NormalizeRegex = null;
let $b3a01b20dd2ade98$var$NormalizationMap = null;
function $b3a01b20dd2ade98$export$1fa1e6b1a06bd7fa(str) {
    if (!$b3a01b20dd2ade98$var$NormalizeRegex) {
        $b3a01b20dd2ade98$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $b3a01b20dd2ade98$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($b3a01b20dd2ade98$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $b3a01b20dd2ade98$var$NormalizationMap.get(p2));
}
function $b3a01b20dd2ade98$export$75f13a91ebdf8eb3() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return $b3a01b20dd2ade98$var$bytesToString(buf);
}
const $b3a01b20dd2ade98$var$AnnotationPrefix = "pdfjs_internal_id_";
function $b3a01b20dd2ade98$var$_isValidExplicitDest(validRef, validName, dest) {
    if (!Array.isArray(dest) || dest.length < 2) return false;
    const [page, zoom, ...args] = dest;
    if (!validRef(page) && !Number.isInteger(page)) return false;
    if (!validName(zoom)) return false;
    const argsLen = args.length;
    let allowNull = true;
    switch(zoom.name){
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) return false;
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) return false;
            break;
        case "FitR":
            if (argsLen !== 4) return false;
            allowNull = false;
            break;
        default:
            return false;
    }
    for (const arg of args){
        if (typeof arg === "number" || allowNull && arg === null) continue;
        return false;
    }
    return true;
}
const $b3a01b20dd2ade98$export$be9af9a47496243a = ()=>[];
const $b3a01b20dd2ade98$export$b41394a5437791c8 = ()=>new Map();
const $b3a01b20dd2ade98$export$5b3b706fb9845c88 = ()=>Object.create(null);
function $b3a01b20dd2ade98$export$b8106b171181a554(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
class $b3a01b20dd2ade98$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$b3a01b20dd2ade98$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
class $b3a01b20dd2ade98$export$f6af20c312d4b9a2 {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (Object.hasOwn(option.attributes, "selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $b3a01b20dd2ade98$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $b3a01b20dd2ade98$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
}
const $b3a01b20dd2ade98$var$SVG_NS = "http://www.w3.org/2000/svg";
class $b3a01b20dd2ade98$export$6ef3b6b69e65342c {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
async function $b3a01b20dd2ade98$export$8134c072fddab6a5(url, type = "text") {
    if ($b3a01b20dd2ade98$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "blob":
                return response.blob();
            case "bytes":
                return response.bytes();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type === "bytes" ? "arraybuffer" : type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "bytes":
                        resolve(new Uint8Array(request.response));
                        return;
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $b3a01b20dd2ade98$var$PageViewport {
    constructor({ viewBox: viewBox, userUnit: userUnit, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const dims = this.viewBox;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "rawDims", {
            pageWidth: dims[2] - dims[0],
            pageHeight: dims[3] - dims[1],
            pageX: dims[0],
            pageY: dims[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $b3a01b20dd2ade98$var$PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        const p = [
            x,
            y
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(p, this.transform);
        return p;
    }
    convertToViewportRectangle(rect) {
        const topLeft = [
            rect[0],
            rect[1]
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(topLeft, this.transform);
        const bottomRight = [
            rect[2],
            rect[3]
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(bottomRight, this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        const p = [
            x,
            y
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyInverseTransform(p, this.transform);
        return p;
    }
}
class $b3a01b20dd2ade98$export$245847d31c09154f extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $b3a01b20dd2ade98$export$f67aae4532d8295b(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $b3a01b20dd2ade98$export$61b52d3570d24719(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $b3a01b20dd2ade98$export$b1c11df0696253ae(url) {
    [url] = url.split(/[#?]/, 1);
    return $b3a01b20dd2ade98$var$stripPath(url);
}
function $b3a01b20dd2ade98$export$9de51790aa4bc73a(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($b3a01b20dd2ade98$export$f67aae4532d8295b(url)) {
        $b3a01b20dd2ade98$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const getURL = (urlString)=>{
        try {
            return new URL(urlString);
        } catch  {
            try {
                return new URL(decodeURIComponent(urlString));
            } catch  {
                try {
                    return new URL(urlString, "https://foo.bar");
                } catch  {
                    try {
                        return new URL(decodeURIComponent(urlString), "https://foo.bar");
                    } catch  {
                        return null;
                    }
                }
            }
        }
    };
    const newURL = getURL(url);
    if (!newURL) return defaultFilename;
    const decode = (name)=>{
        try {
            let decoded = decodeURIComponent(name);
            if (decoded.includes("/")) {
                decoded = $b3a01b20dd2ade98$var$stripPath(decoded);
                if (/^\.pdf$/i.test(decoded)) return name;
            }
            return decoded;
        } catch  {
            return name;
        }
    };
    const pdfRegex = /\.pdf$/i;
    const filename = $b3a01b20dd2ade98$var$stripPath(newURL.pathname);
    if (pdfRegex.test(filename)) return decode(filename);
    if (newURL.searchParams.size > 0) {
        const getLast = (iterator)=>[
                ...iterator
            ].findLast((v)=>pdfRegex.test(v));
        const name = getLast(newURL.searchParams.values()) ?? getLast(newURL.searchParams.keys());
        if (name) return decode(name);
    }
    if (newURL.hash) {
        const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        const hashFilename = reFilename.exec(newURL.hash);
        if (hashFilename) return decode(hashFilename[0]);
    }
    return defaultFilename;
}
class $b3a01b20dd2ade98$var$StatTimer {
    #started = new Map();
    times = [];
    time(name) {
        if (this.#started.has(name)) $b3a01b20dd2ade98$var$warn(`Timer is already running for ${name}`);
        this.#started.set(name, Date.now());
    }
    timeEnd(name) {
        if (!this.#started.has(name)) $b3a01b20dd2ade98$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.#started.get(name),
            end: Date.now()
        });
        this.#started.delete(name);
    }
    toString() {
        const longest = Math.max(...this.times.map((t)=>t.name.length));
        return this.times.map((t)=>`${t.name.padEnd(longest)} ${t.end - t.start}ms\n`).join("");
    }
}
function $b3a01b20dd2ade98$var$isValidFetchUrl(url, baseUrl) {
    const res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return /https?:/.test(res?.protocol ?? "");
}
function $b3a01b20dd2ade98$export$455b7811f904cadc(e) {
    e.preventDefault();
}
function $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $b3a01b20dd2ade98$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
class $b3a01b20dd2ade98$export$66cbc314498fffc {
    static #regex;
    static toDateObject(input) {
        if (input instanceof Date) return input;
        if (!input || typeof input !== "string") return null;
        this.#regex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = this.#regex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $b3a01b20dd2ade98$export$dd5d6edf3fc80aae(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
    const { width: width, height: height } = xfaPage.attributes.style;
    const viewBox = [
        0,
        0,
        parseInt(width, 10),
        parseInt(height, 10)
    ];
    return new $b3a01b20dd2ade98$var$PageViewport({
        viewBox: viewBox,
        userUnit: 1,
        scale: scale,
        rotation: rotation
    });
}
function $b3a01b20dd2ade98$export$c24a0a5c5129b2e1(color) {
    if (color.startsWith("#")) {
        const hex = color.slice(1);
        return [
            parseInt(hex.slice(0, 2), 16),
            parseInt(hex.slice(2, 4), 16),
            parseInt(hex.slice(4, 6), 16),
            hex.length >= 8 ? parseInt(hex.slice(6, 8), 16) / 255 : 1
        ];
    }
    if (color.startsWith("rgb(")) {
        const [r, g, b] = color.slice(4, -1).split(",").map((x)=>parseInt(x, 10));
        return [
            r,
            g,
            b,
            1
        ];
    }
    if (color.startsWith("rgba(")) {
        const parts = color.slice(5, -1).split(",");
        return [
            parseInt(parts[0], 10),
            parseInt(parts[1], 10),
            parseInt(parts[2], 10),
            parseFloat(parts[3])
        ];
    }
    const m = color.match(/^color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+|none))?\)$/);
    if (m) return [
        Math.round(parseFloat(m[1]) * 255),
        Math.round(parseFloat(m[2]) * 255),
        Math.round(parseFloat(m[3]) * 255),
        m[4] !== undefined && m[4] !== "none" ? parseFloat(m[4]) : 1
    ];
    return null;
}
function $b3a01b20dd2ade98$export$2a2e9b507863ddda(color) {
    const rgba = $b3a01b20dd2ade98$export$c24a0a5c5129b2e1(color);
    if (!rgba) {
        $b3a01b20dd2ade98$var$warn(`Not a valid color format: "${color}"`);
        return [
            0,
            0,
            0
        ];
    }
    return rgba.slice(0, 3);
}
function $b3a01b20dd2ade98$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $b3a01b20dd2ade98$export$2a2e9b507863ddda(computedColor));
    }
    span.remove();
}
function $b3a01b20dd2ade98$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $b3a01b20dd2ade98$export$af0a15a86e590226(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $b3a01b20dd2ade98$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const useRound = $b3a01b20dd2ade98$export$5fb8891d35c36978.isCSSRoundSupported;
        const w = `var(--total-scale-factor) * ${pageWidth}px`, h = `var(--total-scale-factor) * ${pageHeight}px`;
        const widthStr = useRound ? `round(down, ${w}, var(--scale-round-x))` : `calc(${w})`, heightStr = useRound ? `round(down, ${h}, var(--scale-round-y))` : `calc(${h})`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $b3a01b20dd2ade98$export$f16a99f63bccd50b {
    constructor(){
        const { pixelRatio: pixelRatio } = $b3a01b20dd2ade98$export$f16a99f63bccd50b;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    get scaled() {
        return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
        return this.sx === this.sy;
    }
    limitCanvas(width, height, maxPixels, maxDim, capAreaFactor = -1) {
        let maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        maxPixels = $b3a01b20dd2ade98$export$f16a99f63bccd50b.capPixels(maxPixels, capAreaFactor);
        if (maxPixels > 0) maxAreaScale = Math.sqrt(maxPixels / (width * height));
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        const maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    }
    static get pixelRatio() {
        return globalThis.devicePixelRatio || 1;
    }
    static capPixels(maxPixels, capAreaFactor) {
        if (capAreaFactor >= 0) {
            const winPixels = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + capAreaFactor / 100));
            return maxPixels > 0 ? Math.min(maxPixels, winPixels) : winPixels;
        }
        return maxPixels;
    }
}
const $b3a01b20dd2ade98$export$3234c88e9de64a88 = [
    "image/apng",
    "image/avif",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "image/x-icon"
];
class $b3a01b20dd2ade98$var$ColorScheme {
    static get isDarkMode() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isDarkMode", !!window?.matchMedia?.("(prefers-color-scheme: dark)").matches);
    }
}
class $b3a01b20dd2ade98$export$cec677744f6a5015 {
    static get commentForegroundColor() {
        const element = document.createElement("span");
        element.classList.add("comment", "sidebar");
        const { style: style } = element;
        style.width = style.height = "0";
        style.display = "none";
        style.color = "var(--comment-fg-color)";
        document.body.append(element);
        const { color: color } = window.getComputedStyle(element);
        element.remove();
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "commentForegroundColor", $b3a01b20dd2ade98$export$2a2e9b507863ddda(color));
    }
}
function $b3a01b20dd2ade98$export$f8d1472813e87bf9(color, opacity) {
    opacity = $b3a01b20dd2ade98$export$b8106b171181a554(opacity ?? 1, 0, 1);
    const white = 255 * (1 - opacity);
    return color.map((c)=>Math.round(c * opacity + white));
}
function $b3a01b20dd2ade98$var$RGBToHSL(rgb, output) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) output[0] = output[1] = 0;
    else {
        const d = max - min;
        output[1] = l < 0.5 ? d / (max + min) : d / (2 - max - min);
        switch(max){
            case r:
                output[0] = ((g - b) / d + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                output[0] = ((b - r) / d + 2) * 60;
                break;
            case b:
                output[0] = ((r - g) / d + 4) * 60;
                break;
        }
    }
    output[2] = l;
}
function $b3a01b20dd2ade98$var$HSLToRGB(hsl, output) {
    const h = hsl[0];
    const s = hsl[1];
    const l = hsl[2];
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    switch(Math.floor(h / 60)){
        case 0:
            output[0] = c + m;
            output[1] = x + m;
            output[2] = m;
            break;
        case 1:
            output[0] = x + m;
            output[1] = c + m;
            output[2] = m;
            break;
        case 2:
            output[0] = m;
            output[1] = c + m;
            output[2] = x + m;
            break;
        case 3:
            output[0] = m;
            output[1] = x + m;
            output[2] = c + m;
            break;
        case 4:
            output[0] = x + m;
            output[1] = m;
            output[2] = c + m;
            break;
        case 5:
        case 6:
            output[0] = c + m;
            output[1] = m;
            output[2] = x + m;
            break;
    }
}
function $b3a01b20dd2ade98$var$computeLuminance(x) {
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
}
function $b3a01b20dd2ade98$var$contrastRatio(hsl1, hsl2, output) {
    $b3a01b20dd2ade98$var$HSLToRGB(hsl1, output);
    output.map($b3a01b20dd2ade98$var$computeLuminance);
    const lum1 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    $b3a01b20dd2ade98$var$HSLToRGB(hsl2, output);
    output.map($b3a01b20dd2ade98$var$computeLuminance);
    const lum2 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    return lum1 > lum2 ? (lum1 + 0.05) / (lum2 + 0.05) : (lum2 + 0.05) / (lum1 + 0.05);
}
const $b3a01b20dd2ade98$var$contrastCache = new Map();
function $b3a01b20dd2ade98$export$7a96203b1fdebe8d(baseColor, fixedColor) {
    const key = baseColor[0] + baseColor[1] * 0x100 + baseColor[2] * 0x10000 + fixedColor[0] * 0x1000000 + fixedColor[1] * 0x100000000 + fixedColor[2] * 0x10000000000;
    let cachedValue = $b3a01b20dd2ade98$var$contrastCache.get(key);
    if (cachedValue) return cachedValue;
    const array = new Float32Array(9);
    const output = array.subarray(0, 3);
    const baseHSL = array.subarray(3, 6);
    $b3a01b20dd2ade98$var$RGBToHSL(baseColor, baseHSL);
    const fixedHSL = array.subarray(6, 9);
    $b3a01b20dd2ade98$var$RGBToHSL(fixedColor, fixedHSL);
    const isFixedColorDark = fixedHSL[2] < 0.5;
    const minContrast = isFixedColorDark ? 12 : 4.5;
    baseHSL[2] = isFixedColorDark ? Math.sqrt(baseHSL[2]) : 1 - Math.sqrt(1 - baseHSL[2]);
    if ($b3a01b20dd2ade98$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) {
        let start, end;
        if (isFixedColorDark) {
            start = baseHSL[2];
            end = 1;
        } else {
            start = 0;
            end = baseHSL[2];
        }
        const PRECISION = 0.005;
        while(end - start > PRECISION){
            const mid = baseHSL[2] = (start + end) / 2;
            if (isFixedColorDark === $b3a01b20dd2ade98$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) start = mid;
            else end = mid;
        }
        baseHSL[2] = isFixedColorDark ? end : start;
    }
    $b3a01b20dd2ade98$var$HSLToRGB(baseHSL, output);
    cachedValue = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(Math.round(output[0] * 255), Math.round(output[1] * 255), Math.round(output[2] * 255));
    $b3a01b20dd2ade98$var$contrastCache.set(key, cachedValue);
    return cachedValue;
}
function $b3a01b20dd2ade98$export$611c480766035c4({ html: html, dir: dir, className: className }, container) {
    const fragment = document.createDocumentFragment();
    if (typeof html === "string") {
        const p = document.createElement("p");
        p.dir = dir || "auto";
        const lines = html.split(/(?:\r\n?|\n)/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        fragment.append(p);
    } else $b3a01b20dd2ade98$export$f6af20c312d4b9a2.render({
        xfaHtml: html,
        div: fragment,
        intent: "richText"
    });
    fragment.firstElementChild.classList.add("richText", className);
    container.append(fragment);
}
function $b3a01b20dd2ade98$var$makePathFromDrawOPS(data) {
    const path = new Path2D();
    if (!data) return path;
    for(let i = 0, ii = data.length; i < ii;)switch(data[i++]){
        case $b3a01b20dd2ade98$var$DrawOPS.moveTo:
            path.moveTo(data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.lineTo:
            path.lineTo(data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.curveTo:
            path.bezierCurveTo(data[i++], data[i++], data[i++], data[i++], data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.quadraticCurveTo:
            path.quadraticCurveTo(data[i++], data[i++], data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.closePath:
            path.closePath();
            break;
        default:
            $b3a01b20dd2ade98$var$warn(`Unrecognized drawing path operator: ${data[i - 1]}`);
            break;
    }
    return path;
}
class $b3a01b20dd2ade98$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    #altText = null;
    #comment = null;
    #commentButtonDivider = null;
    #signatureDescriptionButton = null;
    static #l10nRemove = null;
    constructor(editor){
        this.#editor = editor;
        $b3a01b20dd2ade98$var$EditorToolbar.#l10nRemove ||= Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        });
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            editToolbar.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            editToolbar.addEventListener("pointerdown", $b3a01b20dd2ade98$var$EditorToolbar.#pointerDown, {
                signal: signal
            });
        }
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        return editToolbar;
    }
    get div() {
        return this.#toolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return false;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        return true;
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
        this.#altText?.shown();
        this.#comment?.shown();
    }
    addDeleteButton() {
        const { editorType: editorType, _uiManager: _uiManager } = this.#editor;
        const button = document.createElement("button");
        button.classList.add("basic", "deleteButton");
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$EditorToolbar.#l10nRemove[editorType]);
        if (this.#addListenersToElement(button)) button.addEventListener("click", (e)=>{
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    async addAltText(altText) {
        const button = await altText.render();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
        this.#altText = altText;
    }
    addComment(comment, beforeElement = null) {
        if (this.#comment) return;
        const button = comment.renderForToolbar();
        if (!button) return;
        this.#addListenersToElement(button);
        const divider = this.#commentButtonDivider = this.#divider;
        if (!beforeElement) this.#buttons.append(button, divider);
        else {
            this.#buttons.insertBefore(button, beforeElement);
            this.#buttons.insertBefore(divider, beforeElement);
        }
        this.#comment = comment;
        comment.toolbar = this;
    }
    addColorPicker(colorPicker) {
        if (this.#colorPicker) return;
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    async addEditSignatureButton(signatureManager) {
        const button = this.#signatureDescriptionButton = await signatureManager.renderEditButton(this.#editor);
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    removeButton(name) {
        switch(name){
            case "comment":
                this.#comment?.removeToolbarCommentButton();
                this.#comment = null;
                this.#commentButtonDivider?.remove();
                this.#commentButtonDivider = null;
                break;
        }
    }
    async addButton(name, tool) {
        switch(name){
            case "colorPicker":
                if (tool) this.addColorPicker(tool);
                break;
            case "altText":
                if (tool) await this.addAltText(tool);
                break;
            case "editSignature":
                if (tool) await this.addEditSignatureButton(tool);
                break;
            case "delete":
                this.addDeleteButton();
                break;
            case "comment":
                if (tool) this.addComment(tool);
                break;
        }
    }
    async addButtonBefore(name, tool, beforeSelector) {
        if (!tool && name === "comment") return;
        const beforeElement = this.#buttons.querySelector(beforeSelector);
        if (!beforeElement) return;
        if (name === "comment") this.addComment(tool, beforeElement);
    }
    updateEditSignatureButton(description) {
        if (this.#signatureDescriptionButton) this.#signatureDescriptionButton.title = description;
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $b3a01b20dd2ade98$var$FloatingToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) editToolbar.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        if (this.#uiManager.hasCommentManager()) this.#makeButton("commentButton", `pdfjs-comment-floating-button`, "pdfjs-comment-floating-button-label", ()=>{
            this.#uiManager.commentSelection("floating_button");
        });
        this.#makeButton("highlightButton", `pdfjs-highlight-floating-button1`, "pdfjs-highlight-floating-button-label", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        });
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #makeButton(buttonClass, l10nId, labelL10nId, clickHandler) {
        const button = document.createElement("button");
        button.classList.add("basic", buttonClass);
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", l10nId);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", labelL10nId);
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            button.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            button.addEventListener("click", clickHandler, {
                signal: signal
            });
        }
        this.#buttons.append(button);
    }
}
function $b3a01b20dd2ade98$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
class $b3a01b20dd2ade98$var$CurrentPointers {
    static #pointerId = NaN;
    static #pointerIds = null;
    static #moveTimestamp = NaN;
    static #pointerType = null;
    static initializeAndAddPointerId(pointerId) {
        ($b3a01b20dd2ade98$var$CurrentPointers.#pointerIds ||= new Set()).add(pointerId);
    }
    static setPointer(pointerType, pointerId) {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerId ||= pointerId;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerType ??= pointerType;
    }
    static setTimeStamp(timeStamp) {
        $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp = timeStamp;
    }
    static isSamePointerId(pointerId) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerId === pointerId;
    }
    static isSamePointerIdOrRemove(pointerId) {
        if ($b3a01b20dd2ade98$var$CurrentPointers.#pointerId === pointerId) return true;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds?.delete(pointerId);
        return false;
    }
    static isSamePointerType(pointerType) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerType === pointerType;
    }
    static isInitializedAndDifferentPointerType(pointerType) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerType !== null && !$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerType(pointerType);
    }
    static isSameTimeStamp(timeStamp) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp === timeStamp;
    }
    static isUsingMultiplePointers() {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds?.size >= 1;
    }
    static clearPointerType() {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerType = null;
    }
    static clearPointerIds() {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerId = NaN;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds = null;
    }
    static clearTimeStamp() {
        $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp = NaN;
    }
}
class $b3a01b20dd2ade98$var$IdManager {
    #id = 0;
    get id() {
        return `${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $b3a01b20dd2ade98$var$ImageManager {
    #baseId = $b3a01b20dd2ade98$export$75f13a91ebdf8eb3();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $b3a01b20dd2ade98$export$8134c072fddab6a5(rawData, "blob");
            } else if (rawData instanceof File) image = data.file = rawData;
            else if (rawData instanceof Blob) image = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $b3a01b20dd2ade98$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            $b3a01b20dd2ade98$var$warn(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromBlob(id, blobPromise) {
        const blob = await blobPromise;
        return this.#get(id, blob);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        if (data.blobPromise) {
            const { blobPromise: blobPromise } = data;
            delete data.blobPromise;
            return this.getFromBlob(data.id, blobPromise);
        }
        return this.getFromUrl(data.url);
    }
    getFromCanvas(id, canvas) {
        this.#cache ||= new Map();
        let data = this.#cache.get(id);
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        const ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: `image_${this.#baseId}_${this.#id++}`,
            refCounter: 1,
            isSvg: false
        };
        this.#cache.set(id, data);
        this.#cache.set(data.id, data);
        return data;
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        const { bitmap: bitmap } = data;
        if (!data.url && !data.file) {
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            const ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        bitmap.close?.();
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $b3a01b20dd2ade98$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    cleanType(type) {
        if (this.#position === -1) return;
        for(let i = this.#position; i >= 0; i--)if (this.#commands[i].type !== type) {
            this.#commands.splice(i + 1, this.#position - i);
            this.#position = i;
            return;
        }
        this.#commands.length = 0;
        this.#position = -1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $b3a01b20dd2ade98$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(event);
    }
}
class $b3a01b20dd2ade98$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $b3a01b20dd2ade98$var$getColorValues(colors);
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $b3a01b20dd2ade98$export$2a2e9b507863ddda(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $b3a01b20dd2ade98$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...rgb);
    }
}
class $b3a01b20dd2ade98$export$26cb16552a82cf63 {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditableAnnotations = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #savedAllLayers = null;
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $b3a01b20dd2ade98$var$CommandManager();
    #commentManager = null;
    #copyPasteAC = null;
    #currentDrawingSession = null;
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    _editorUndoBar = null;
    #enableHighlightFloatingButton = false;
    #enableUpdatedAddImage = false;
    #enableNewAltTextWhenAddingImage = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #focusManagerAC = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #floatingToolbar = null;
    #idManager = new $b3a01b20dd2ade98$var$IdManager();
    #isEnabled = false;
    #isPointerDown = false;
    #isWaiting = false;
    #keyboardManagerAC = null;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #missingCanvases = null;
    #mlManager = null;
    #mode = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #signatureManager = null;
    #pageColors = null;
    #showAllStates = null;
    #pdfDocument = null;
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    #viewerAlert = null;
    #updateModeCapability = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$export$26cb16552a82cf63.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, viewerAlert, altTextManager, commentManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom){
        const signal = this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#viewerAlert = viewerAlert;
        this.#altTextManager = altTextManager;
        this.#commentManager = commentManager;
        this.#signatureManager = signatureManager;
        this.#pdfDocument = pdfDocument;
        this._eventBus = eventBus;
        eventBus._on("editingaction", this.onEditingAction.bind(this), {
            signal: signal
        });
        eventBus._on("pagechanging", this.onPageChanging.bind(this), {
            signal: signal
        });
        eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
            signal: signal
        });
        eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
            signal: signal
        });
        eventBus._on("setpreference", this.onSetPreference.bind(this), {
            signal: signal
        });
        eventBus._on("switchannotationeditorparams", (evt)=>this.updateParams(evt.type, evt.value), {
            signal: signal
        });
        window.addEventListener("pointerdown", ()=>{
            this.#isPointerDown = true;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("pointerup", ()=>{
            this.#isPointerDown = false;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("beforeunload", this.#beforeUnload.bind(this), {
            capture: true,
            signal: signal
        });
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#enableUpdatedAddImage = enableUpdatedAddImage;
        this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
        commentManager?.setSidebarUiManager(this);
    }
    destroy() {
        this.#updateModeCapability?.resolve();
        this.#updateModeCapability = null;
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#missingCanvases?.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#commentManager?.destroy();
        this.#signatureManager?.destroy();
        this.#floatingToolbar?.hide();
        this.#floatingToolbar = null;
        this.#mainHighlightColorPicker?.destroy();
        this.#mainHighlightColorPicker = null;
        this.#allEditableAnnotations = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
        this._editorUndoBar?.destroy();
        this.#pdfDocument = null;
    }
    combinedSignal(ac) {
        return AbortSignal.any([
            this._signal,
            ac.signal
        ]);
    }
    get mlManager() {
        return this.#mlManager;
    }
    get useNewAltTextFlow() {
        return this.#enableUpdatedAddImage;
    }
    get useNewAltTextWhenAddingImage() {
        return this.#enableNewAltTextWhenAddingImage;
    }
    get hcmFilter() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "direction", getComputedStyle(this.#container).direction);
    }
    get _highlightColors() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>{
            pair = pair.split("=").map((x)=>x.trim());
            pair[1] = pair[1].toUpperCase();
            return pair;
        })) : null);
    }
    get highlightColors() {
        const { _highlightColors: _highlightColors } = this;
        if (!_highlightColors) return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColors", null);
        const map = new Map();
        const hasHCM = !!this.#pageColors;
        for (const [name, color] of _highlightColors){
            const isNameForHCM = name.endsWith("_HCM");
            if (hasHCM && isNameForHCM) {
                map.set(name.replace("_HCM", ""), color);
                continue;
            }
            if (!hasHCM && !isNameForHCM) map.set(name, color);
        }
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColors", map);
    }
    get highlightColorNames() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    getNonHCMColor(color) {
        if (!this._highlightColors) return color;
        const colorName = this.highlightColorNames.get(color);
        return this._highlightColors.get(colorName) || color;
    }
    getNonHCMColorName(color) {
        return this.highlightColorNames.get(color) || color;
    }
    setCurrentDrawingSession(layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        } else this.disableUserSelect(false);
        this.#currentDrawingSession = layer;
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor, firstTime = false) {
        this.#altTextManager?.editAltText(this, editor, firstTime);
    }
    hasCommentManager() {
        return !!this.#commentManager;
    }
    editComment(editor, posX, posY, options) {
        this.#commentManager?.showDialog(this, editor, posX, posY, options);
    }
    selectComment(pageIndex, uid) {
        const layer = this.#allLayers.get(pageIndex);
        const editor = layer?.getEditorByUID(uid);
        editor?.toggleComment(true, true);
    }
    updateComment(editor) {
        this.#commentManager?.updateComment(editor.getData());
    }
    updatePopupColor(editor) {
        this.#commentManager?.updatePopupColor(editor);
    }
    removeComment(editor) {
        this.#commentManager?.removeComments([
            editor.uid
        ]);
    }
    deleteComment(editor, savedData) {
        const undo = ()=>{
            editor.comment = savedData;
        };
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, "comment");
            this.toggleComment(null);
            editor.comment = null;
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    toggleComment(editor, isSelected, visibility) {
        this.#commentManager?.toggleCommentPopup(editor, isSelected, visibility);
    }
    makeCommentColor(color, opacity) {
        return color && this.#commentManager?.makeCommentColor(color, opacity) || null;
    }
    getCommentDialogElement() {
        return this.#commentManager?.dialogElement || null;
    }
    async waitForEditorsRendered(pageNumber) {
        if (this.#allLayers.has(pageNumber - 1)) return;
        const { resolve: resolve, promise: promise } = Promise.withResolvers();
        const onEditorsRendered = (evt)=>{
            if (evt.pageNumber === pageNumber) {
                this._eventBus._off("editorsrendered", onEditorsRendered);
                resolve();
            }
        };
        this._eventBus.on("editorsrendered", onEditorsRendered);
        await promise;
    }
    getSignature(editor) {
        this.#signatureManager?.getSignature({
            uiManager: this,
            editor: editor
        });
    }
    get signatureManager() {
        return this.#signatureManager;
    }
    switchToMode(mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    }
    setPreference(name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    }
    onSetPreference({ name: name, value: value }) {
        switch(name){
            case "enableNewAltTextWhenAddingImage":
                this.#enableNewAltTextWhenAddingImage = value;
                break;
        }
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    deletePage(id) {
        for (const editor of this.getEditors(id))editor.remove();
        this.#allLayers.delete(id);
        if (this.#currentPageIndex === id) this.#currentPageIndex = 0;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
        this.#currentDrawingSession?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    #getLayerForTextLayer(textLayer) {
        const { currentLayer: currentLayer } = this;
        if (currentLayer.hasTextLayer(textLayer)) return currentLayer;
        for (const layer of this.#allLayers.values()){
            if (layer.hasTextLayer(textLayer)) return layer;
        }
        return null;
    }
    highlightSelection(methodOfCreation = "", comment = false) {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        const layer = this.#getLayerForTextLayer(textLayer);
        const isNoneMode = this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
        const callback = ()=>{
            const editor = layer?.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) this.showAllEditors("highlight", true, true);
            if (comment) editor?.editComment();
        };
        if (isNoneMode) {
            this.switchToMode($b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT, callback);
            return;
        }
        callback();
    }
    commentSelection(methodOfCreation = "") {
        this.highlightSelection(methodOfCreation, true);
    }
    #beforeUnload(e) {
        this.commitOrRemove();
        this.currentLayer?.endDrawingSession(false);
    }
    #displayFloatingToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#floatingToolbar ||= new $b3a01b20dd2ade98$var$FloatingToolbar(this);
        this.#floatingToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    getAndRemoveDataFromAnnotationStorage(annotationId) {
        if (!this.#annotationStorage) return null;
        const key = `${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${annotationId}`;
        const storedValue = this.#annotationStorage.getRawValue(key);
        if (storedValue) this.#annotationStorage.remove(key);
        return storedValue;
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    a11yAlert(messageId, args = null) {
        const viewerAlert = this.#viewerAlert;
        if (!viewerAlert) return;
        viewerAlert.setAttribute("data-l10n-id", messageId);
        if (args) viewerAlert.setAttribute("data-l10n-args", JSON.stringify(args));
        else viewerAlert.removeAttribute("data-l10n-args");
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#floatingToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT && this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) return;
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const activeLayer = this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT ? this.#getLayerForTextLayer(textLayer) : null;
            activeLayer?.toggleDrawing();
            if (this.#isPointerDown) {
                const ac = new AbortController();
                const signal = this.combinedSignal(ac);
                const pointerup = (e)=>{
                    if (e.type === "pointerup" && e.button !== 0) return;
                    ac.abort();
                    activeLayer?.toggleDrawing(true);
                    if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
                };
                window.addEventListener("pointerup", pointerup, {
                    signal: signal
                });
                window.addEventListener("blur", pointerup, {
                    signal: signal
                });
            } else {
                activeLayer?.toggleDrawing(true);
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayFloatingToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        if (this.#focusManagerAC) return;
        this.#focusManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#focusManagerAC);
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }
    #removeFocusManager() {
        this.#focusManagerAC?.abort();
        this.#focusManagerAC = null;
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        if (this.#keyboardManagerAC) return;
        this.#keyboardManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#keyboardManagerAC);
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        this.#keyboardManagerAC?.abort();
        this.#keyboardManagerAC = null;
    }
    #addCopyPasteListeners() {
        if (this.#copyPasteAC) return;
        this.#copyPasteAC = new AbortController();
        const signal = this.combinedSignal(this.#copyPasteAC);
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        this.#copyPasteAC?.abort();
        this.#copyPasteAC = null;
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.setEditingState(true);
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.setEditingState(false);
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    async paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = await layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE && !this.isEditorHandlingKeyboard) $b3a01b20dd2ade98$export$26cb16552a82cf63._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
            case "commentSelection":
                this.commentSelection("context_menu");
                break;
        }
    }
    updatePageIndex(oldPageIndex, newPageIndex) {
        for (const editor of this.getEditors(oldPageIndex))editor.pageIndex = newPageIndex;
        const layer = this.#savedAllLayers.get(oldPageIndex);
        if (layer) {
            layer.pageIndex = newPageIndex;
            this.#allLayers.set(newPageIndex, layer);
            if (this.#isEnabled) layer.enable();
            else layer.disable();
        }
    }
    startUpdatePages() {
        this.#savedAllLayers = new Map(this.#allLayers);
        this.#allLayers.clear();
    }
    endUpdatePages() {
        this.#savedAllLayers = null;
    }
    clonePage(pageIndex, newPageIndex) {
        for (const editor of this.getEditors(pageIndex)){
            const serialized = editor.serialize(editor.mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT);
            if (!serialized) continue;
            serialized.pageIndex = newPageIndex;
            serialized.id = this.getId();
            serialized.isClone = true;
            delete serialized.popupRef;
            this.#annotationStorage.setValue(serialized.id, serialized);
        }
    }
    findClonesForPage(layer) {
        const promises = [];
        const { pageIndex: pageIndex } = layer;
        for (const [id, editor] of this.#annotationStorage)if (editor.pageIndex === pageIndex && editor.isClone) {
            this.#annotationStorage.remove(id);
            promises.push(layer.deserialize(editor).then((deserializedEditor)=>{
                if (deserializedEditor) {
                    deserializedEditor.isClone = true;
                    layer.addOrRebuild(deserializedEditor);
                }
            }));
        }
        return Promise.all(promises);
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("editingstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    async updateMode(mode, editId = null, isFromUser = false, isFromKeyboard = false, mustEnterInEditMode = false, editComment = false) {
        if (this.#mode === mode) return;
        if (this.#updateModeCapability) {
            await this.#updateModeCapability.promise;
            if (!this.#updateModeCapability) return;
        }
        this.#updateModeCapability = Promise.withResolvers();
        this.#currentDrawingSession?.commitOrRemove();
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) this.#commentManager?.hideSidebar();
        this.#commentManager?.destroyPopup();
        this.#mode = mode;
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            for (const editor of this.#allEditors.values())editor.hideStandaloneCommentButton();
            this._editorUndoBar?.hide();
            this.toggleComment(null);
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())editor.addStandaloneCommentButton();
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE) await this.#signatureManager?.loadSignatures();
        if (isFromUser) $b3a01b20dd2ade98$var$CurrentPointers.clearPointerType();
        this.setEditingState(true);
        await this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) {
            this.#allEditableAnnotations ||= await this.#pdfDocument.getAnnotationsByType(new Set(this.#editorTypes.map((editorClass)=>editorClass._editorType)));
            const elementIds = new Set();
            const allComments = [];
            for (const editor of this.#allEditors.values()){
                const { annotationElementId: annotationElementId, hasComment: hasComment, deleted: deleted } = editor;
                if (annotationElementId) elementIds.add(annotationElementId);
                if (hasComment && !deleted) allComments.push(editor.getData());
            }
            for (const annotation of this.#allEditableAnnotations){
                const { id: id, popupRef: popupRef, contentsObj: contentsObj } = annotation;
                if (popupRef && contentsObj?.str && !elementIds.has(id) && !this.#deletedAnnotationsElementIds.has(id)) allComments.push(annotation);
            }
            this.#commentManager?.showSidebar(allComments);
        }
        if (!editId) {
            if (isFromKeyboard) this.addNewEditorFromKeyboard();
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())if (editor.uid === editId) {
            this.setSelected(editor);
            if (editComment) editor.editComment();
            else if (mustEnterInEditMode) editor.enterInEditMode();
            else editor.focus();
        } else editor.unselect();
        this.#updateModeCapability.resolve();
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(options) {
        if (options.mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            ...options
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        if (this.hasSelection) for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        else for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    async #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            const promises = [];
            for (const layer of this.#allLayers.values())promises.push(layer.enable());
            await Promise.all(promises);
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    *getEditors(pageIndex) {
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) yield editor;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        if (editor.annotationElementId) this.#missingCanvases?.delete(editor.annotationElementId);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    updateUIForDefaultProperties(editorType) {
        this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        this.updateToolbar({
            mode: editor.mode,
            editId: editor.uid
        });
        this.#currentDrawingSession?.commitOrRemove();
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#commentManager?.destroyPopup();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
        this._editorUndoBar?.hide();
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    cleanUndoStack(type) {
        this.#commandManager.cleanType(type);
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        const drawingEditor = this.currentLayer?.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) return;
        const editors = drawingEditor ? [
            drawingEditor
        ] : [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) return;
        }
        if (this.#currentDrawingSession?.commitOrRemove()) return;
        this.#commentManager?.destroyPopup();
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(totalX, totalY);
                        editor.translationDone();
                    }
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(-totalX, -totalY);
                        editor.translationDone();
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors){
            editor.translateInPage(x, y);
            editor.translationDone();
        }
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    isEditingMode() {
        return this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    }
    get imageManager() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "imageManager", new $b3a01b20dd2ade98$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
    setMissingCanvas(annotationId, annotationElementId, canvas) {
        const editor = this.#missingCanvases?.get(annotationId);
        if (!editor) return;
        editor.setCanvas(annotationElementId, canvas);
        this.#missingCanvases.delete(annotationId);
    }
    addMissingCanvas(annotationId, editor) {
        (this.#missingCanvases ||= new Map()).set(annotationId, editor);
    }
}
class $b3a01b20dd2ade98$var$AltText {
    #altText = null;
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextButtonLabel = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #badge = null;
    #editor = null;
    #guessedText = null;
    #textWithDisclaimer = null;
    #useNewAltTextFlow = false;
    static #l10nNewButton = null;
    static _l10n = null;
    constructor(editor){
        this.#editor = editor;
        this.#useNewAltTextFlow = editor._uiManager.useNewAltTextFlow;
        $b3a01b20dd2ade98$var$AltText.#l10nNewButton ||= Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        });
    }
    static initialize(l10n) {
        $b3a01b20dd2ade98$var$AltText._l10n ??= l10n;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        altText.tabIndex = "0";
        const label = this.#altTextButtonLabel = document.createElement("span");
        altText.append(label);
        if (this.#useNewAltTextFlow) {
            altText.classList.add("new");
            altText.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton.missing);
            label.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton["missing-label"]);
        } else {
            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
        }
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
            if (this.#useNewAltTextFlow) this.#editor._reportTelemetry({
                action: "pdfjs.image.alt_text.image_status_label_clicked",
                data: {
                    label: this.#label
                }
            });
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    get #label() {
        return this.#altText && "added" || this.#altText === null && this.guessedText && "review" || "missing";
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        if (this.#useNewAltTextFlow) return this.#altText === null;
        return !this.#altText && !this.#altTextDecorative;
    }
    hasData() {
        if (this.#useNewAltTextFlow) return this.#altText !== null || !!this.#guessedText;
        return this.isEmpty();
    }
    get guessedText() {
        return this.#guessedText;
    }
    async setGuessedText(guessedText) {
        if (this.#altText !== null) return;
        this.#guessedText = guessedText;
        this.#textWithDisclaimer = await $b3a01b20dd2ade98$var$AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
            generatedAltText: guessedText
        });
        this.#setState();
    }
    toggleAltTextBadge(visibility = false) {
        if (!this.#useNewAltTextFlow || this.#altText) {
            this.#badge?.remove();
            this.#badge = null;
            return;
        }
        if (!this.#badge) {
            const badge = this.#badge = document.createElement("div");
            badge.className = "noAltTextBadge";
            this.#editor.div.append(badge);
        }
        this.#badge.classList.toggle("hidden", !visibility);
    }
    serialize(isForCopying) {
        let altText = this.#altText;
        if (!isForCopying && this.#guessedText === altText) altText = this.#textWithDisclaimer;
        return {
            altText: altText,
            decorative: this.#altTextDecorative,
            guessedText: this.#guessedText,
            textWithDisclaimer: this.#textWithDisclaimer
        };
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative, guessedText: guessedText, textWithDisclaimer: textWithDisclaimer, cancel: cancel = false }) {
        if (guessedText) {
            this.#guessedText = guessedText;
            this.#textWithDisclaimer = textWithDisclaimer;
        }
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        if (!cancel) {
            this.#altText = altText;
            this.#altTextDecorative = decorative;
        }
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    shown() {
        this.#editor._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: this.#label
            }
        });
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextButtonLabel = null;
        this.#altTextTooltip = null;
        this.#badge?.remove();
        this.#badge = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (this.#useNewAltTextFlow) {
            button.classList.toggle("done", !!this.#altText);
            button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton[this.#label]);
            this.#altTextButtonLabel?.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton[`${this.#label}-label`]);
            if (!this.#altText) {
                this.#altTextTooltip?.remove();
                return;
            }
        } else {
            if (!this.#altText && !this.#altTextDecorative) {
                button.classList.remove("done");
                this.#altTextTooltip?.remove();
                return;
            }
            button.classList.add("done");
            button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        }
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        if (this.#altTextDecorative) tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
        else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = this.#altText;
        }
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getElementForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $b3a01b20dd2ade98$var$Comment {
    #commentStandaloneButton = null;
    #commentToolbarButton = null;
    #commentWasFromKeyBoard = false;
    #editor = null;
    #initialText = null;
    #richText = null;
    #text = null;
    #date = null;
    #deleted = false;
    #popupPosition = null;
    constructor(editor){
        this.#editor = editor;
    }
    renderForToolbar() {
        const button = this.#commentToolbarButton = document.createElement("button");
        button.className = "comment";
        return this.#render(button, false);
    }
    renderForStandalone() {
        const button = this.#commentStandaloneButton = document.createElement("button");
        button.className = "annotationCommentButton";
        const position = this.#editor.commentButtonPosition;
        if (position) {
            const { style: style } = button;
            style.insetInlineEnd = `calc(${100 * (this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0])}% - var(--comment-button-dim))`;
            style.top = `calc(${100 * position[1]}% - var(--comment-button-dim))`;
            const color = this.#editor.commentButtonColor;
            if (color) style.backgroundColor = color;
        }
        return this.#render(button, true);
    }
    focusButton() {
        setTimeout(()=>{
            (this.#commentStandaloneButton ?? this.#commentToolbarButton)?.focus();
        }, 0);
    }
    onUpdatedColor() {
        if (!this.#commentStandaloneButton) return;
        const color = this.#editor.commentButtonColor;
        if (color) this.#commentStandaloneButton.style.backgroundColor = color;
        this.#editor._uiManager.updatePopupColor(this.#editor);
    }
    get commentButtonWidth() {
        return (this.#commentStandaloneButton?.getBoundingClientRect().width ?? 0) / this.#editor.parent.boundingClientRect.width;
    }
    get commentPopupPositionInLayer() {
        if (this.#popupPosition) return this.#popupPosition;
        if (!this.#commentStandaloneButton) return null;
        const { x: x, y: y, height: height } = this.#commentStandaloneButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#editor.parent.boundingClientRect;
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPositionInLayer(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    removeStandaloneCommentButton() {
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
    }
    removeToolbarCommentButton() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentStandaloneButton) return;
        this.#commentStandaloneButton.classList.toggle("selected", selected);
        this.#commentStandaloneButton.ariaExpanded = hasPopup;
    }
    #render(comment, isStandalone) {
        if (!this.#editor._uiManager.hasCommentManager()) return null;
        comment.tabIndex = "0";
        comment.ariaHasPopup = "dialog";
        if (isStandalone) {
            comment.ariaControls = "commentPopup";
            comment.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
        } else {
            comment.ariaControlsElements = [
                this.#editor._uiManager.getCommentDialogElement()
            ];
            comment.setAttribute("data-l10n-id", "pdfjs-editor-add-comment-button");
        }
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return comment;
        comment.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        if (isStandalone) {
            comment.addEventListener("focusin", (e)=>{
                this.#editor._focusEventsAllowed = false;
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
            comment.addEventListener("focusout", (e)=>{
                this.#editor._focusEventsAllowed = true;
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
        }
        comment.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            if (comment === this.#commentToolbarButton) this.edit();
            else this.#editor.toggleComment(true);
        };
        comment.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        comment.addEventListener("keydown", (event)=>{
            if (event.target === comment && event.key === "Enter") {
                this.#commentWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        comment.addEventListener("pointerenter", ()=>{
            this.#editor.toggleComment(false, true);
        }, {
            signal: signal
        });
        comment.addEventListener("pointerleave", ()=>{
            this.#editor.toggleComment(false, false);
        }, {
            signal: signal
        });
        return comment;
    }
    edit(options) {
        const position = this.commentPopupPositionInLayer;
        let posX, posY;
        if (position) [posX, posY] = position;
        else {
            [posX, posY] = this.#editor.commentButtonPosition;
            const { width: width, height: height, x: x, y: y } = this.#editor;
            posX = x + posX * width;
            posY = y + posY * height;
        }
        const parentDimensions = this.#editor.parent.boundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#editor._uiManager.editComment(this.#editor, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    finish() {
        if (!this.#commentToolbarButton) return;
        this.#commentToolbarButton.focus({
            focusVisible: this.#commentWasFromKeyBoard
        });
        this.#commentWasFromKeyBoard = false;
    }
    isDeleted() {
        return this.#deleted || this.#text === "";
    }
    isEmpty() {
        return this.#text === null;
    }
    hasBeenEdited() {
        return this.isDeleted() || this.#text !== this.#initialText;
    }
    serialize() {
        return this.data;
    }
    get data() {
        return {
            text: this.#text,
            richText: this.#richText,
            date: this.#date,
            deleted: this.isDeleted()
        };
    }
    set data(text) {
        if (text !== this.#text) this.#richText = null;
        if (text === null) {
            this.#text = "";
            this.#deleted = true;
            return;
        }
        this.#text = text;
        this.#date = new Date();
        this.#deleted = false;
    }
    restoreData({ text: text, richText: richText, date: date }) {
        this.#text = text;
        this.#richText = richText;
        this.#date = date;
        this.#deleted = false;
    }
    setInitialText(text, richText = null) {
        this.#initialText = text;
        this.data = text;
        this.#date = null;
        this.#richText = richText;
    }
    shown() {}
    destroy() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
        this.#text = "";
        this.#richText = null;
        this.#date = null;
        this.#editor = null;
        this.#commentWasFromKeyBoard = false;
        this.#deleted = false;
    }
}
class $b3a01b20dd2ade98$export$9ae7542b430d543e {
    #container;
    #isPinching = false;
    #isPinchingStopped = null;
    #isPinchingDisabled;
    #onPinchStart;
    #onPinching;
    #onPinchEnd;
    #pointerDownAC = null;
    #signal;
    #touchInfo = null;
    #touchManagerAC;
    #touchMoveAC = null;
    constructor({ container: container, isPinchingDisabled: isPinchingDisabled = null, isPinchingStopped: isPinchingStopped = null, onPinchStart: onPinchStart = null, onPinching: onPinching = null, onPinchEnd: onPinchEnd = null, signal: signal }){
        this.#container = container;
        this.#isPinchingStopped = isPinchingStopped;
        this.#isPinchingDisabled = isPinchingDisabled;
        this.#onPinchStart = onPinchStart;
        this.#onPinching = onPinching;
        this.#onPinchEnd = onPinchEnd;
        this.#touchManagerAC = new AbortController();
        this.#signal = AbortSignal.any([
            signal,
            this.#touchManagerAC.signal
        ]);
        container.addEventListener("touchstart", this.#onTouchStart.bind(this), {
            passive: false,
            signal: this.#signal
        });
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
        return 35 / $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
    }
    #onTouchStart(evt) {
        if (this.#isPinchingDisabled?.()) return;
        if (evt.touches.length === 1) {
            if (this.#pointerDownAC) return;
            const pointerDownAC = this.#pointerDownAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                pointerDownAC.signal
            ]);
            const container = this.#container;
            const opts = {
                capture: true,
                signal: signal,
                passive: false
            };
            const cancelPointerDown = (e)=>{
                if (e.pointerType === "touch") {
                    this.#pointerDownAC?.abort();
                    this.#pointerDownAC = null;
                }
            };
            container.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === "touch") {
                    $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
                    cancelPointerDown(e);
                }
            }, opts);
            container.addEventListener("pointerup", cancelPointerDown, opts);
            container.addEventListener("pointercancel", cancelPointerDown, opts);
            return;
        }
        if (!this.#touchMoveAC) {
            this.#touchMoveAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                this.#touchMoveAC.signal
            ]);
            const container = this.#container;
            const opt = {
                signal: signal,
                capture: false,
                passive: false
            };
            container.addEventListener("touchmove", this.#onTouchMove.bind(this), opt);
            const onTouchEnd = this.#onTouchEnd.bind(this);
            container.addEventListener("touchend", onTouchEnd, opt);
            container.addEventListener("touchcancel", onTouchEnd, opt);
            opt.capture = true;
            container.addEventListener("pointerdown", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointermove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointercancel", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointerup", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            this.#onPinchStart?.();
        }
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        if (evt.touches.length !== 2 || this.#isPinchingStopped?.()) {
            this.#touchInfo = null;
            return;
        }
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        this.#touchInfo = {
            touch0X: touch0.screenX,
            touch0Y: touch0.screenY,
            touch1X: touch1.screenX,
            touch1Y: touch1.screenY
        };
    }
    #onTouchMove(evt) {
        if (!this.#touchInfo || evt.touches.length !== 2) return;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        const { screenX: screen0X, screenY: screen0Y } = touch0;
        const { screenX: screen1X, screenY: screen1Y } = touch1;
        const touchInfo = this.#touchInfo;
        const { touch0X: pTouch0X, touch0Y: pTouch0Y, touch1X: pTouch1X, touch1Y: pTouch1Y } = touchInfo;
        const prevGapX = pTouch1X - pTouch0X;
        const prevGapY = pTouch1Y - pTouch0Y;
        const currGapX = screen1X - screen0X;
        const currGapY = screen1Y - screen0Y;
        const distance = Math.hypot(currGapX, currGapY) || 1;
        const pDistance = Math.hypot(prevGapX, prevGapY) || 1;
        if (!this.#isPinching && Math.abs(pDistance - distance) <= $b3a01b20dd2ade98$export$9ae7542b430d543e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
        touchInfo.touch0X = screen0X;
        touchInfo.touch0Y = screen0Y;
        touchInfo.touch1X = screen1X;
        touchInfo.touch1Y = screen1Y;
        if (!this.#isPinching) {
            this.#isPinching = true;
            return;
        }
        const origin = [
            (screen0X + screen1X) / 2,
            (screen0Y + screen1Y) / 2
        ];
        this.#onPinching?.(origin, pDistance, distance);
    }
    #onTouchEnd(evt) {
        if (evt.touches.length >= 2) return;
        if (this.#touchMoveAC) {
            this.#touchMoveAC.abort();
            this.#touchMoveAC = null;
            this.#onPinchEnd?.();
        }
        if (!this.#touchInfo) return;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        this.#touchInfo = null;
        this.#isPinching = false;
    }
    destroy() {
        this.#touchManagerAC?.abort();
        this.#touchManagerAC = null;
        this.#pointerDownAC?.abort();
        this.#pointerDownAC = null;
    }
}
class $b3a01b20dd2ade98$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #comment = null;
    #commentStandaloneButton = null;
    #disabled = false;
    #dragPointerId = null;
    #dragPointerType = "";
    #resizersDiv = null;
    #lastPointerCoords = null;
    #savedDimensions = null;
    #fakeAnnotation = null;
    #focusAC = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialRect = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    #touchManager = null;
    isSelected = false;
    _isCopy = false;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    static _l10n = null;
    static _l10nResizer = null;
    #isDraggable = false;
    #zIndex = $b3a01b20dd2ade98$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $b3a01b20dd2ade98$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $b3a01b20dd2ade98$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_resizerKeyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $b3a01b20dd2ade98$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        this.annotationElementId = parameters.annotationElementId || null;
        this.creationDate = parameters.creationDate || new Date();
        this.modificationDate = parameters.modificationDate || null;
        this.canAddComment = true;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    updatePageIndex(newPageIndex) {
        this.pageIndex = newPageIndex;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
        return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
        return false;
    }
    static get _defaultLineColor() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $b3a01b20dd2ade98$var$FakeEditor({
            id: editor._uiManager.getId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor._l10n ??= l10n;
        $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer ||= Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        });
        if ($b3a01b20dd2ade98$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $b3a01b20dd2ade98$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get uid() {
        return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else {
            this.#stopResizing();
            this.#fakeAnnotation?.remove();
            this.#fakeAnnotation = null;
        }
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        if (!this.isInEditMode()) return;
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    _moveAfterPaste(baseX, baseY) {
        if (this.isClone) {
            delete this.isClone;
            return;
        }
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    translationDone() {
        this._onTranslated(this.x, this.y);
    }
    drag(tx, ty) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        const { div: div, parentDimensions: [parentWidth, parentHeight] } = this;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    }
    _onTranslating(x, y) {}
    _onTranslated(x, y) {}
    get _hasBeenMoved() {
        return !!this.#initialRect && (this.#initialRect[0] !== this.x || this.#initialRect[1] !== this.y);
    }
    get _hasBeenResized() {
        return !!this.#initialRect && (this.#initialRect[2] !== this.width || this.#initialRect[3] !== this.height);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $b3a01b20dd2ade98$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const { div: { style: style }, pageDimensions: [pageWidth, pageHeight] } = this;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, 0, pageWidth - width);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, 0, pageHeight - height);
                break;
            case 90:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, 0, pageWidth - height);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, width, pageHeight);
                break;
            case 180:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, width, pageWidth);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, height, pageHeight);
                break;
            case 270:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, height, pageWidth);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, 0, pageHeight - width);
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $b3a01b20dd2ade98$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $b3a01b20dd2ade98$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        return [
            pageWidth * parentScale,
            pageHeight * parentScale
        ];
    }
    setDims() {
        const { div: { style: style }, width: width, height: height } = this;
        style.width = `${(100 * width).toFixed(2)}%`;
        style.height = `${(100 * height).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        this.#lastPointerCoords = [
            event.screenX,
            event.screenY
        ];
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", this.#resizerPointermove.bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            ac.abort();
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack();
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.setDims();
        this.fixAndSetPosition();
        this._onResized();
    }
    _onResized() {}
    #addResizeToUndoStack() {
        if (!this.#savedDimensions) return;
        const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
        this.#savedDimensions = null;
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: this.#resize.bind(this, newX, newY, newWidth, newHeight),
            undo: this.#resize.bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }
    static _round(x) {
        return Math.round(x * 10000) / 10000;
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedX + transfOppositePoint[0]);
        const oppositeY = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let deltaX, deltaY;
        if (!event.fromKeyboard) {
            const { screenX: screenX, screenY: screenY } = event;
            const [lastScreenX, lastScreenY] = this.#lastPointerCoords;
            [deltaX, deltaY] = this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY);
            this.#lastPointerCoords[0] = screenX;
            this.#lastPointerCoords[1] = screenY;
        } else ({ deltaX: deltaX, deltaY: deltaY } = event);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = $b3a01b20dd2ade98$export$b8106b171181a554(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        else ratioY = $b3a01b20dd2ade98$export$b8106b171181a554(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        const newWidth = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedWidth * ratioX);
        const newHeight = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    _onResizing() {}
    altTextFinish() {
        this.#altText?.finish();
    }
    get toolbarButtons() {
        return null;
    }
    async addEditToolbar() {
        if (this._editToolbar || this.#isInEditMode) return this._editToolbar;
        this._editToolbar = new $b3a01b20dd2ade98$var$EditorToolbar(this);
        this.div.append(this._editToolbar.render());
        const { toolbarButtons: toolbarButtons } = this;
        if (toolbarButtons) for (const [name, tool] of toolbarButtons)await this._editToolbar.addButton(name, tool);
        if (!this.hasComment) this._editToolbar.addButton("comment", this.addCommentButton());
        this._editToolbar.addButton("delete");
        return this._editToolbar;
    }
    addCommentButtonInToolbar() {
        this._editToolbar?.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
    }
    removeCommentButtonFromToolbar() {
        this._editToolbar?.removeButton("comment");
    }
    removeEditToolbar() {
        this._editToolbar?.remove();
        this._editToolbar = null;
        this.#altText?.destroy();
    }
    addContainer(container) {
        const editToolbarDiv = this._editToolbar?.div;
        if (editToolbarDiv) editToolbarDiv.before(container);
        else this.div.append(container);
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    createAltText() {
        if (!this.#altText) {
            $b3a01b20dd2ade98$var$AltText.initialize($b3a01b20dd2ade98$var$AnnotationEditor._l10n);
            this.#altText = new $b3a01b20dd2ade98$var$AltText(this);
            if (this.#accessibilityData) {
                this.#altText.data = this.#accessibilityData;
                this.#accessibilityData = null;
            }
        }
        return this.#altText;
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    get guessedAltText() {
        return this.#altText?.guessedText;
    }
    async setGuessedAltText(text) {
        await this.#altText?.setGuessedText(text);
    }
    serializeAltText(isForCopying) {
        return this.#altText?.serialize(isForCopying);
    }
    hasAltText() {
        return !!this.#altText && !this.#altText.isEmpty();
    }
    hasAltTextData() {
        return this.#altText?.hasData() ?? false;
    }
    focusCommentButton() {
        this.#comment?.focusButton();
    }
    addCommentButton() {
        return this.canAddComment ? this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this) : null;
    }
    addStandaloneCommentButton() {
        if (!this._uiManager.hasCommentManager()) return;
        if (this.#commentStandaloneButton) {
            if (this._uiManager.isEditingMode()) this.#commentStandaloneButton.classList.remove("hidden");
            return;
        }
        if (!this.hasComment) return;
        this.#commentStandaloneButton = this.#comment.renderForStandalone();
        this.div.append(this.#commentStandaloneButton);
    }
    removeStandaloneCommentButton() {
        this.#comment.removeStandaloneCommentButton();
        this.#commentStandaloneButton = null;
    }
    hideStandaloneCommentButton() {
        this.#commentStandaloneButton?.classList.add("hidden");
    }
    get comment() {
        if (!this.#comment) return null;
        const { data: { richText: richText, text: text, date: date, deleted: deleted } } = this.#comment;
        return {
            text: text,
            richText: richText,
            date: date,
            deleted: deleted,
            color: this.getNonHCMColor(),
            opacity: this.opacity ?? 1
        };
    }
    set comment(value) {
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        if (typeof value === "object" && value !== null) this.#comment.restoreData(value);
        else this.#comment.data = value;
        if (this.hasComment) {
            this.removeCommentButtonFromToolbar();
            this.addStandaloneCommentButton();
            this._uiManager.updateComment(this);
        } else {
            this.addCommentButtonInToolbar();
            this.removeStandaloneCommentButton();
            this._uiManager.removeComment(this);
        }
    }
    setCommentData({ comment: comment, popupRef: popupRef, richText: richText }) {
        if (!popupRef) return;
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        this.#comment.setInitialText(comment, richText);
        if (!this.annotationElementId) return;
        const storedData = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
        if (storedData) this.updateFromAnnotationLayer(storedData);
    }
    get hasEditedComment() {
        return this.#comment?.hasBeenEdited();
    }
    get hasDeletedComment() {
        return this.#comment?.isDeleted();
    }
    get hasComment() {
        return !!this.#comment && !this.#comment.isEmpty() && !this.#comment.isDeleted();
    }
    async editComment(options) {
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        this.#comment.edit(options);
    }
    toggleComment(isSelected, visibility) {
        if (this.hasComment) this._uiManager.toggleComment(this, isSelected, visibility);
    }
    setSelectedCommentButton(selected) {
        this.#comment.setSelectedButton(selected);
    }
    addComment(serialized) {
        if (this.hasEditedComment) {
            const DEFAULT_POPUP_WIDTH = 180;
            const DEFAULT_POPUP_HEIGHT = 100;
            const [, , , trY] = serialized.rect;
            const [pageWidth] = this.pageDimensions;
            const [pageX] = this.pageTranslation;
            const blX = pageX + pageWidth + 1;
            const blY = trY - DEFAULT_POPUP_HEIGHT;
            const trX = blX + DEFAULT_POPUP_WIDTH;
            serialized.popup = {
                contents: this.comment.text,
                deleted: this.comment.deleted,
                rect: [
                    blX,
                    blY,
                    trX,
                    trY
                ]
            };
        }
    }
    updateFromAnnotationLayer({ popup: { contents: contents, deleted: deleted } }) {
        this.#comment.data = deleted ? null : contents;
    }
    get parentBoundingClientRect() {
        return this.parent.boundingClientRect;
    }
    render() {
        const div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = this.#disabled ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) div.setAttribute("data-l10n-id", this.defaultL10nId);
        if (!this._isVisible) div.classList.add("hidden");
        this.setInForeground();
        this.#addFocusListeners();
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $b3a01b20dd2ade98$var$bindEvents(this, div, [
            "keydown",
            "pointerdown",
            "dblclick"
        ]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) this.#touchManager ||= new $b3a01b20dd2ade98$export$9ae7542b430d543e({
            container: div,
            isPinchingDisabled: ()=>!this.isSelected,
            onPinchStart: this.#touchPinchStartCallback.bind(this),
            onPinching: this.#touchPinchCallback.bind(this),
            onPinchEnd: this.#touchPinchEndCallback.bind(this),
            signal: this._uiManager._signal
        });
        this.addStandaloneCommentButton();
        this._uiManager._editorUndoBar?.hide();
        return div;
    }
    #touchPinchStartCallback() {
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        this.#altText?.toggle(false);
        this.parent.togglePointerEvents(false);
    }
    #touchPinchCallback(_origin, prevDistance, distance) {
        const slowDownFactor = 0.7;
        let factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) return;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        const newWidth = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedWidth * factor);
        const newHeight = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) return;
        this.#initialRect ||= [
            savedX,
            savedY,
            savedWidth,
            savedHeight
        ];
        const transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        const centerX = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedX + transfCenterPoint[0]);
        const centerY = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedY + transfCenterPoint[1]);
        const newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    #touchPinchEndCallback() {
        this.#altText?.toggle(true);
        this.parent.togglePointerEvents(true);
        this.#addResizeToUndoStack();
    }
    pointerdown(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const { isSelected: isSelected } = this;
        this._uiManager.setUpDragSession();
        let hasDraggingStarted = false;
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        const opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        const cancelDrag = (e)=>{
            ac.abort();
            this.#dragPointerId = null;
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(e);
            if (hasDraggingStarted) this._onStopDragging();
        };
        if (isSelected) {
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            this.#dragPointerId = event.pointerId;
            this.#dragPointerType = event.pointerType;
            window.addEventListener("pointermove", (e)=>{
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    this._uiManager.toggleComment(this, true, false);
                    this._onStartDragging();
                }
                const { clientX: x, clientY: y, pointerId: pointerId } = e;
                if (pointerId !== this.#dragPointerId) {
                    $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
                    return;
                }
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opts);
            window.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === this.#dragPointerType) {
                    if (this.#touchManager || e.isPrimary) cancelDrag(e);
                }
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, opts);
        }
        const pointerUpCallback = (e)=>{
            if (!this.#dragPointerId || this.#dragPointerId === e.pointerId) {
                cancelDrag(e);
                return;
            }
            $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getPDFRect() {
        return this.getRect(0, 0);
    }
    getNonHCMColor() {
        return this.color && $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
        this.#comment?.onUpdatedColor();
    }
    getData() {
        const { comment: { text: str, color: color, date: date, opacity: opacity, deleted: deleted, richText: richText }, uid: id, pageIndex: pageIndex, creationDate: creationDate, modificationDate: modificationDate } = this;
        return {
            id: id,
            pageIndex: pageIndex,
            rect: this.getPDFRect(),
            richText: richText,
            contentsObj: {
                str: str
            },
            creationDate: creationDate,
            modificationDate: date || modificationDate,
            popupRef: !deleted,
            color: color,
            opacity: opacity
        };
    }
    onceAdded(focus) {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        if (this.isInEditMode()) return false;
        this.parent.setEditingState(false);
        this.#isInEditMode = true;
        return true;
    }
    disableEditMode() {
        if (!this.isInEditMode()) return false;
        this.parent.setEditingState(true);
        this.#isInEditMode = false;
        return true;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
        const { top: top, left: left, bottom: bottom, right: right } = this.getClientDimensions();
        const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
        return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
    }
    #addFocusListeners() {
        if (this.#focusAC || !this.div) return;
        this.#focusAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#focusAC);
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }
    rebuild() {
        this.#addFocusListeners();
    }
    rotate(_angle) {}
    resize() {}
    serializeDeleted() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    serialize(isForCopying = false, context = null) {
        return {
            annotationType: this.mode,
            pageIndex: this.pageIndex,
            rect: this.getPDFRect(),
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    static async deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: uiManager.getId(),
            uiManager: uiManager,
            annotationElementId: data.annotationElementId,
            creationDate: data.creationDate,
            modificationDate: data.modificationDate
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        editor._isCopy = data.isCopy || false;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.#focusAC?.abort();
        this.#focusAC = null;
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        this.hideCommentPopup();
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
        this.#touchManager?.destroy();
        this.#touchManager = null;
        this.#fakeAnnotation?.remove();
        this.#fakeAnnotation = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
        }
    }
    get toolbarPosition() {
        return null;
    }
    get commentButtonPosition() {
        return this._uiManager.direction === "ltr" ? [
            1,
            0
        ] : [
            0,
            0
        ];
    }
    get commentButtonPositionInPage() {
        const { commentButtonPosition: [posX, posY] } = this;
        const [blX, blY, trX, trY] = this.getPDFRect();
        return [
            $b3a01b20dd2ade98$var$AnnotationEditor._round(blX + (trX - blX) * posX),
            $b3a01b20dd2ade98$var$AnnotationEditor._round(blY + (trY - blY) * (1 - posY))
        ];
    }
    get commentButtonColor() {
        return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
        return this.#comment.commentPopupPositionInLayer;
    }
    set commentPopupPosition(pos) {
        this.#comment.commentPopupPositionInLayer = pos;
    }
    hasDefaultPopupPosition() {
        return this.#comment.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
        return this.#comment.commentButtonWidth;
    }
    get elementBeforePopup() {
        return this.div;
    }
    setCommentButtonStates(options) {
        this.#comment?.setCommentButtonStates(options);
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                div.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstElementChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstElementChild.before(this.#resizersDiv.lastElementChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                child.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstElementChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $b3a01b20dd2ade98$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        this.#addResizeToUndoStack();
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        if (this.isSelected && this._editToolbar) {
            this._editToolbar.show();
            return;
        }
        this.isSelected = true;
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this._editToolbar?.show();
            });
            return;
        }
        this._editToolbar?.show();
        this.#altText?.toggleAltTextBadge(false);
    }
    focus() {
        if (this.div && !this.div.contains(document.activeElement)) setTimeout(()=>this.div?.focus({
                preventScroll: true
            }), 0);
    }
    unselect() {
        if (!this.isSelected) return;
        this.isSelected = false;
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this._editToolbar?.hide();
        this.#altText?.toggleAltTextBadge(true);
        this.hideCommentPopup();
    }
    hideCommentPopup() {
        if (this.hasComment) this._uiManager.toggleComment(null);
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
        return false;
    }
    enterInEditMode() {
        if (!this.canChangeContent) return;
        this.enableEditMode();
        this.div.focus();
    }
    dblclick(event) {
        if (event.target.nodeName === "BUTTON") return;
        this.enterInEditMode();
        this.parent.updateToolbar({
            mode: this.constructor._editorType,
            editId: this.uid
        });
    }
    getElementForAltText() {
        return this.div;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $b3a01b20dd2ade98$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    updateFakeAnnotationElement(annotationLayer) {
        if (!this.#fakeAnnotation && !this.deleted) {
            this.#fakeAnnotation = annotationLayer.addFakeAnnotation(this);
            return;
        }
        if (this.deleted) {
            this.#fakeAnnotation.remove();
            this.#fakeAnnotation = null;
            return;
        }
        if (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) this.#fakeAnnotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstElementChild: firstElementChild } = annotation.container;
        if (firstElementChild?.nodeName === "DIV" && firstElementChild.classList.contains("annotationContent")) firstElementChild.remove();
    }
}
class $b3a01b20dd2ade98$var$FakeEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return this.serializeDeleted();
    }
}
const $b3a01b20dd2ade98$var$SEED = 0xc3d2e1f0;
const $b3a01b20dd2ade98$var$MASK_HIGH = 0xffff0000;
const $b3a01b20dd2ade98$var$MASK_LOW = 0xffff;
class $b3a01b20dd2ade98$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $b3a01b20dd2ade98$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $b3a01b20dd2ade98$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $b3a01b20dd2ade98$var$MASK_LOW, C2_LOW = C2 & $b3a01b20dd2ade98$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k2 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k2 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $b3a01b20dd2ade98$var$MASK_HIGH | h1 * 0x8ccd & $b3a01b20dd2ade98$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $b3a01b20dd2ade98$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $b3a01b20dd2ade98$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $b3a01b20dd2ade98$var$MASK_HIGH | h1 * 0xec53 & $b3a01b20dd2ade98$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $b3a01b20dd2ade98$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $b3a01b20dd2ade98$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $b3a01b20dd2ade98$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $b3a01b20dd2ade98$var$AnnotationStorage {
    #modified = false;
    #modifiedIds = null;
    #editorsMap = null;
    #storage = new Map();
    onSetModified = null;
    onResetModified = null;
    onAnnotationEditor = null;
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        const storedValue = this.#storage.get(key);
        if (storedValue === undefined) return;
        if (storedValue instanceof $b3a01b20dd2ade98$var$AnnotationEditor) this.#editorsMap.delete(storedValue.annotationElementId);
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (this.#storage.values().some((v)=>v instanceof $b3a01b20dd2ade98$var$AnnotationEditor)) return;
        this.onAnnotationEditor?.(null);
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $b3a01b20dd2ade98$var$AnnotationEditor) {
            (this.#editorsMap ||= new Map()).set(value.annotationElementId, value);
            this.onAnnotationEditor?.(value.constructor._type);
        }
    }
    has(key) {
        return this.#storage.has(key);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            this.onSetModified?.();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            this.onResetModified?.();
        }
    }
    get print() {
        return new $b3a01b20dd2ade98$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $b3a01b20dd2ade98$var$SerializableEmpty;
        const map = new Map(), hash = new $b3a01b20dd2ade98$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $b3a01b20dd2ade98$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (val.page) {
                val.pageIndex = val.page._pageIndex;
                delete val.page;
            }
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $b3a01b20dd2ade98$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        let numberOfEditedComments = 0;
        let numberOfDeletedComments = 0;
        for (const value of this.#storage.values()){
            if (!(value instanceof $b3a01b20dd2ade98$var$AnnotationEditor)) {
                if (value.popup) {
                    if (value.popup.deleted) numberOfDeletedComments += 1;
                    else numberOfEditedComments += 1;
                }
                continue;
            }
            if (value.isCommentDeleted) numberOfDeletedComments += 1;
            else if (value.hasEditedComment) numberOfEditedComments += 1;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                const counters = map.getOrInsertComputed(key, $b3a01b20dd2ade98$export$b41394a5437791c8);
                counters.set(val, (counters.get(val) ?? 0) + 1);
            }
        }
        if (numberOfDeletedComments > 0 || numberOfEditedComments > 0) {
            stats ||= Object.create(null);
            stats.comments = {
                deleted: numberOfDeletedComments,
                edited: numberOfEditedComments
            };
        }
        if (!stats) return null;
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
    resetModifiedIds() {
        this.#modifiedIds = null;
    }
    updateEditor(annotationId, data) {
        const value = this.#editorsMap?.get(annotationId);
        if (value) {
            value.updateFromAnnotationLayer(data);
            return true;
        }
        return false;
    }
    getEditor(annotationId) {
        return this.#editorsMap?.get(annotationId) || null;
    }
    get modifiedIds() {
        if (this.#modifiedIds) return this.#modifiedIds;
        const ids = [];
        if (this.#editorsMap) for (const value of this.#editorsMap.values()){
            if (!value.serialize()) continue;
            ids.push(value.annotationElementId);
        }
        let hash = "";
        if (ids.length) {
            const h = new $b3a01b20dd2ade98$var$MurmurHash3_64();
            h.update(ids.join(","));
            hash = h.hexdigest();
        }
        return this.#modifiedIds = {
            ids: new Set(ids),
            hash: hash
        };
    }
    [Symbol.iterator]() {
        return this.#storage.entries();
    }
}
class $b3a01b20dd2ade98$var$PrintAnnotationStorage extends $b3a01b20dd2ade98$var$AnnotationStorage {
    #serializable = $b3a01b20dd2ade98$var$SerializableEmpty;
    constructor(parent){
        super();
        const { serializable: serializable } = parent;
        if (serializable === $b3a01b20dd2ade98$var$SerializableEmpty) return;
        const { map: map, hash: hash, transfer: transfer } = serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: []
        };
    }
    get print() {
        $b3a01b20dd2ade98$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
    get modifiedIds() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "modifiedIds", {
            ids: new Set(),
            hash: ""
        });
    }
}
const $b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL = "__forcedDependency";
const { floor: $b3a01b20dd2ade98$var$floor, ceil: $b3a01b20dd2ade98$var$ceil } = Math;
function $b3a01b20dd2ade98$var$expandBBox(array, index, minX, minY, maxX, maxY) {
    array[index * 4 + 0] = Math.min(array[index * 4 + 0], minX);
    array[index * 4 + 1] = Math.min(array[index * 4 + 1], minY);
    array[index * 4 + 2] = Math.max(array[index * 4 + 2], maxX);
    array[index * 4 + 3] = Math.max(array[index * 4 + 3], maxY);
}
const $b3a01b20dd2ade98$var$EMPTY_BBOX = new Uint32Array(new Uint8Array([
    255,
    255,
    0,
    0
]).buffer)[0];
class $b3a01b20dd2ade98$var$BBoxReader {
    #bboxes;
    #coords;
    constructor(bboxes, coords){
        this.#bboxes = bboxes;
        this.#coords = coords;
    }
    get length() {
        return this.#bboxes.length;
    }
    isEmpty(i) {
        return this.#bboxes[i] === $b3a01b20dd2ade98$var$EMPTY_BBOX;
    }
    minX(i) {
        return this.#coords[i * 4 + 0] / 256;
    }
    minY(i) {
        return this.#coords[i * 4 + 1] / 256;
    }
    maxX(i) {
        return (this.#coords[i * 4 + 2] + 1) / 256;
    }
    maxY(i) {
        return (this.#coords[i * 4 + 3] + 1) / 256;
    }
}
const $b3a01b20dd2ade98$var$ensureDebugMetadata = (map, key)=>map?.getOrInsertComputed(key, ()=>({
            dependencies: new Set(),
            isRenderingOperation: false
        }));
class $b3a01b20dd2ade98$var$CanvasBBoxTracker {
    #baseTransformStack = [
        [
            1,
            0,
            0,
            1,
            0,
            0
        ]
    ];
    #clipBox = [
        -Infinity,
        -Infinity,
        Infinity,
        Infinity
    ];
    #pendingBBox = new Float64Array($b3a01b20dd2ade98$var$BBOX_INIT);
    _pendingBBoxIdx = -1;
    #canvasWidth;
    #canvasHeight;
    #bboxesCoords;
    #bboxes;
    _savesStack = [];
    _markedContentStack = [];
    constructor(canvas, operationsCount){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
        this.#initializeBBoxes(operationsCount);
    }
    growOperationsCount(operationsCount) {
        if (operationsCount >= this.#bboxes.length) this.#initializeBBoxes(operationsCount, this.#bboxes);
    }
    #initializeBBoxes(operationsCount, oldBBoxes) {
        const buffer = new ArrayBuffer(operationsCount * 4);
        this.#bboxesCoords = new Uint8ClampedArray(buffer);
        this.#bboxes = new Uint32Array(buffer);
        if (oldBBoxes && oldBBoxes.length > 0) {
            this.#bboxes.set(oldBBoxes);
            this.#bboxes.fill($b3a01b20dd2ade98$var$EMPTY_BBOX, oldBBoxes.length);
        } else this.#bboxes.fill($b3a01b20dd2ade98$var$EMPTY_BBOX);
    }
    get clipBox() {
        return this.#clipBox;
    }
    save(opIdx) {
        this.#clipBox = {
            __proto__: this.#clipBox
        };
        this._savesStack.push(opIdx);
        return this;
    }
    restore(opIdx, onSavePopped) {
        const previous = Object.getPrototypeOf(this.#clipBox);
        if (previous === null) return this;
        this.#clipBox = previous;
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    recordOpenMarker(idx) {
        this._savesStack.push(idx);
        return this;
    }
    getOpenMarker() {
        if (this._savesStack.length === 0) return null;
        return this._savesStack.at(-1);
    }
    recordCloseMarker(opIdx, onSavePopped) {
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    beginMarkedContent(opIdx) {
        this._markedContentStack.push(opIdx);
        return this;
    }
    endMarkedContent(opIdx, onSavePopped) {
        const lastSave = this._markedContentStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    pushBaseTransform(ctx) {
        this.#baseTransformStack.push($b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform()));
        return this;
    }
    popBaseTransform() {
        if (this.#baseTransformStack.length > 1) this.#baseTransformStack.pop();
        return this;
    }
    resetBBox(idx) {
        if (this._pendingBBoxIdx !== idx) {
            this._pendingBBoxIdx = idx;
            this.#pendingBBox.set($b3a01b20dd2ade98$var$BBOX_INIT, 0);
        }
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        const clipBox = $b3a01b20dd2ade98$var$BBOX_INIT.slice();
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, clipBox);
        const intersection = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.#clipBox, clipBox);
        if (intersection) {
            this.#clipBox[0] = intersection[0];
            this.#clipBox[1] = intersection[1];
            this.#clipBox[2] = intersection[2];
            this.#clipBox[3] = intersection[3];
        } else {
            this.#clipBox[0] = this.#clipBox[1] = Infinity;
            this.#clipBox[2] = this.#clipBox[3] = -Infinity;
        }
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        const clipBox = this.#clipBox;
        if (clipBox[0] === Infinity) return this;
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        if (clipBox[0] === -Infinity) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                minX,
                minY,
                maxX,
                maxY
            ], transform, this.#pendingBBox);
            return this;
        }
        const bbox = $b3a01b20dd2ade98$var$BBOX_INIT.slice();
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, bbox);
        this.#pendingBBox[0] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[0], clipBox[0], this.#pendingBBox[0]);
        this.#pendingBBox[1] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[1], clipBox[1], this.#pendingBBox[1]);
        this.#pendingBBox[2] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[2], this.#pendingBBox[2], clipBox[2]);
        this.#pendingBBox[3] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[3], this.#pendingBBox[3], clipBox[3]);
        return this;
    }
    recordFullPageBBox(idx) {
        this.#pendingBBox[0] = Math.max(0, this.#clipBox[0]);
        this.#pendingBBox[1] = Math.max(0, this.#clipBox[1]);
        this.#pendingBBox[2] = Math.min(this.#canvasWidth, this.#clipBox[2]);
        this.#pendingBBox[3] = Math.min(this.#canvasHeight, this.#clipBox[3]);
        return this;
    }
    recordOperation(idx, preserve = false, dependencyLists) {
        if (this._pendingBBoxIdx !== idx) return this;
        const minX = $b3a01b20dd2ade98$var$floor(this.#pendingBBox[0] * 256 / this.#canvasWidth);
        const minY = $b3a01b20dd2ade98$var$floor(this.#pendingBBox[1] * 256 / this.#canvasHeight);
        const maxX = $b3a01b20dd2ade98$var$ceil(this.#pendingBBox[2] * 256 / this.#canvasWidth);
        const maxY = $b3a01b20dd2ade98$var$ceil(this.#pendingBBox[3] * 256 / this.#canvasHeight);
        $b3a01b20dd2ade98$var$expandBBox(this.#bboxesCoords, idx, minX, minY, maxX, maxY);
        if (dependencyLists) for (const dependencies of dependencyLists){
            for (const depIdx of dependencies)if (depIdx !== idx) $b3a01b20dd2ade98$var$expandBBox(this.#bboxesCoords, depIdx, minX, minY, maxX, maxY);
        }
        if (!preserve) this._pendingBBoxIdx = -1;
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (this._pendingBBoxIdx === idx) {
            this._pendingBBoxIdx = -1;
            this.#clipBox[0] = Math.max(this.#clipBox[0], this.#pendingBBox[0]);
            this.#clipBox[1] = Math.max(this.#clipBox[1], this.#pendingBBox[1]);
            this.#clipBox[2] = Math.min(this.#clipBox[2], this.#pendingBBox[2]);
            this.#clipBox[3] = Math.min(this.#clipBox[3], this.#pendingBBox[3]);
        }
        return this;
    }
    take() {
        return new $b3a01b20dd2ade98$var$BBoxReader(this.#bboxes, this.#bboxesCoords);
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
    recordSimpleData(name, idx) {
        return this;
    }
    recordIncrementalData(name, idx) {
        return this;
    }
    resetIncrementalData(name, idx) {
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        return this;
    }
    getSimpleIndex(dependencyName) {
        return undefined;
    }
    recordDependencies(idx, dependencyNames) {
        return this;
    }
    recordNamedDependency(idx, name) {
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        return this;
    }
}
class $b3a01b20dd2ade98$var$CanvasDependencyTracker {
    #simple = {
        __proto__: null
    };
    #incremental = {
        __proto__: null,
        transform: [],
        moveText: [],
        sameLineText: [],
        [$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]: []
    };
    #namedDependencies = new Map();
    #pendingDependencies = new Set();
    #fontBBoxTrustworthy = new Map();
    #debugMetadata;
    #recordDebugMetadataDepenencyAfterRestore;
    #bboxTracker;
    constructor(bboxTracker, recordDebugMetadata = false){
        this.#bboxTracker = bboxTracker;
        if (recordDebugMetadata) {
            this.#debugMetadata = new Map();
            this.#recordDebugMetadataDepenencyAfterRestore = (lastSave, opIdx)=>{
                $b3a01b20dd2ade98$var$ensureDebugMetadata(this.#debugMetadata, opIdx).dependencies.add(lastSave);
            };
        }
    }
    get clipBox() {
        return this.#bboxTracker.clipBox;
    }
    growOperationsCount(operationsCount) {
        this.#bboxTracker.growOperationsCount(operationsCount);
    }
    save(opIdx) {
        this.#simple = {
            __proto__: this.#simple
        };
        this.#incremental = {
            __proto__: this.#incremental,
            transform: {
                __proto__: this.#incremental.transform
            },
            moveText: {
                __proto__: this.#incremental.moveText
            },
            sameLineText: {
                __proto__: this.#incremental.sameLineText
            },
            [$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]: {
                __proto__: this.#incremental[$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]
            }
        };
        this.#bboxTracker.save(opIdx);
        return this;
    }
    restore(opIdx) {
        this.#bboxTracker.restore(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        const previous = Object.getPrototypeOf(this.#simple);
        if (previous === null) return this;
        this.#simple = previous;
        this.#incremental = Object.getPrototypeOf(this.#incremental);
        return this;
    }
    recordOpenMarker(opIdx) {
        this.#bboxTracker.recordOpenMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    getOpenMarker() {
        return this.#bboxTracker.getOpenMarker();
    }
    recordCloseMarker(opIdx) {
        this.#bboxTracker.recordCloseMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    beginMarkedContent(opIdx) {
        this.#bboxTracker.beginMarkedContent(opIdx);
        return this;
    }
    endMarkedContent(opIdx) {
        this.#bboxTracker.endMarkedContent(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    pushBaseTransform(ctx) {
        this.#bboxTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#bboxTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#simple[name] = idx;
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#incremental[name].push(idx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#incremental[name].length = 0;
        return this;
    }
    recordNamedData(name, idx) {
        this.#namedDependencies.set(name, idx);
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#simple[name] = this.#namedDependencies.get(depName) ?? fallbackIdx;
    }
    recordFutureForcedDependency(name, idx) {
        this.recordIncrementalData($b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL, idx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        for (const name of names)if (name in this.#simple) this.recordFutureForcedDependency(name, this.#simple[name]);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        for (const dep of this.#pendingDependencies)this.recordFutureForcedDependency($b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL, dep);
        return this;
    }
    resetBBox(idx) {
        this.#bboxTracker.resetBBox(idx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordClipBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordBBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        const fontBBox = font.bbox;
        let isBBoxTrustworthy;
        let computedBBox;
        if (fontBBox) {
            isBBoxTrustworthy = fontBBox[2] !== fontBBox[0] && fontBBox[3] !== fontBBox[1] && this.#fontBBoxTrustworthy.get(font);
            if (isBBoxTrustworthy !== false) {
                computedBBox = [
                    0,
                    0,
                    0,
                    0
                ];
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(fontBBox, font.fontMatrix, computedBBox);
                if (scale !== 1 || x !== 0 || y !== 0) $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.scaleMinMax([
                    scale,
                    0,
                    0,
                    -scale,
                    x,
                    y
                ], computedBBox);
                if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
            }
        }
        if (!getMeasure) return this.recordFullPageBBox(idx);
        const measure = getMeasure();
        if (fontBBox && computedBBox && isBBoxTrustworthy === undefined) {
            isBBoxTrustworthy = computedBBox[0] <= x - measure.actualBoundingBoxLeft && computedBBox[2] >= x + measure.actualBoundingBoxRight && computedBBox[1] <= y - measure.actualBoundingBoxAscent && computedBBox[3] >= y + measure.actualBoundingBoxDescent;
            this.#fontBBoxTrustworthy.set(font, isBBoxTrustworthy);
            if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
        }
        return this.recordBBox(idx, ctx, x - measure.actualBoundingBoxLeft, x + measure.actualBoundingBoxRight, y - measure.actualBoundingBoxAscent, y + measure.actualBoundingBoxDescent);
    }
    recordFullPageBBox(idx) {
        this.#bboxTracker.recordFullPageBBox(idx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#simple[dependencyName];
    }
    recordDependencies(idx, dependencyNames) {
        const pendingDependencies = this.#pendingDependencies;
        const simple = this.#simple;
        const incremental = this.#incremental;
        for (const name of dependencyNames){
            if (name in this.#simple) pendingDependencies.add(simple[name]);
            else if (name in incremental) incremental[name].forEach(pendingDependencies.add, pendingDependencies);
        }
        return this;
    }
    recordNamedDependency(idx, name) {
        if (this.#namedDependencies.has(name)) this.#pendingDependencies.add(this.#namedDependencies.get(name));
        return this;
    }
    recordOperation(idx, preserve = false) {
        this.recordDependencies(idx, [
            $b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL
        ]);
        if (this.#debugMetadata) {
            const metadata = $b3a01b20dd2ade98$var$ensureDebugMetadata(this.#debugMetadata, idx);
            const { dependencies: dependencies } = metadata;
            this.#pendingDependencies.forEach(dependencies.add, dependencies);
            this.#bboxTracker._savesStack.forEach(dependencies.add, dependencies);
            this.#bboxTracker._markedContentStack.forEach(dependencies.add, dependencies);
            dependencies.delete(idx);
            metadata.isRenderingOperation = true;
        }
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.recordOperation(idx, preserve, [
            this.#pendingDependencies,
            this.#bboxTracker._savesStack,
            this.#bboxTracker._markedContentStack
        ]);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        const deps = Array.from(this.#pendingDependencies);
        this.recordOperation(idx, preserve);
        this.recordIncrementalData("sameLineText", idx);
        for (const dep of deps)this.recordIncrementalData("sameLineText", dep);
        return this;
    }
    bboxToClipBoxDropOperation(idx, preserve = false) {
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.bboxToClipBoxDropOperation(idx);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    take() {
        this.#fontBBoxTrustworthy.clear();
        return this.#bboxTracker.take();
    }
    takeDebugMetadata() {
        return this.#debugMetadata;
    }
}
class $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker {
    #dependencyTracker;
    #opIdx;
    #ignoreBBoxes;
    #nestingLevel = 0;
    #savesLevel = 0;
    constructor(dependencyTracker, opIdx, ignoreBBoxes){
        if (dependencyTracker instanceof $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker && dependencyTracker.#ignoreBBoxes === !!ignoreBBoxes) return dependencyTracker;
        this.#dependencyTracker = dependencyTracker;
        this.#opIdx = opIdx;
        this.#ignoreBBoxes = !!ignoreBBoxes;
    }
    get clipBox() {
        return this.#dependencyTracker.clipBox;
    }
    growOperationsCount() {
        throw new Error("Unreachable");
    }
    save(opIdx) {
        this.#savesLevel++;
        this.#dependencyTracker.save(this.#opIdx);
        return this;
    }
    restore(opIdx) {
        if (this.#savesLevel > 0) {
            this.#dependencyTracker.restore(this.#opIdx);
            this.#savesLevel--;
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#nestingLevel++;
        return this;
    }
    getOpenMarker() {
        return this.#nestingLevel > 0 ? this.#opIdx : this.#dependencyTracker.getOpenMarker();
    }
    recordCloseMarker(idx) {
        this.#nestingLevel--;
        return this;
    }
    beginMarkedContent(opIdx) {
        return this;
    }
    endMarkedContent(opIdx) {
        return this;
    }
    pushBaseTransform(ctx) {
        this.#dependencyTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#dependencyTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#dependencyTracker.recordSimpleData(name, this.#opIdx);
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#dependencyTracker.recordIncrementalData(name, this.#opIdx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#dependencyTracker.resetIncrementalData(name, this.#opIdx);
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#dependencyTracker.recordSimpleDataFromNamed(name, depName, this.#opIdx);
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        this.#dependencyTracker.recordFutureForcedDependency(name, this.#opIdx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        this.#dependencyTracker.inheritSimpleDataAsFutureForcedDependencies(names);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        this.#dependencyTracker.inheritPendingDependenciesAsFutureForcedDependencies();
        return this;
    }
    resetBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.resetBBox(this.#opIdx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordClipBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordBBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale, x, y, getMeasure) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordCharacterBBox(this.#opIdx, ctx, font, scale, x, y, getMeasure);
        return this;
    }
    recordFullPageBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordFullPageBBox(this.#opIdx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#dependencyTracker.getSimpleIndex(dependencyName);
    }
    recordDependencies(idx, dependencyNames) {
        this.#dependencyTracker.recordDependencies(this.#opIdx, dependencyNames);
        return this;
    }
    recordNamedDependency(idx, name) {
        this.#dependencyTracker.recordNamedDependency(this.#opIdx, name);
        return this;
    }
    recordOperation(idx) {
        this.#dependencyTracker.recordOperation(this.#opIdx, true);
        return this;
    }
    recordShowTextOperation(idx) {
        this.#dependencyTracker.recordShowTextOperation(this.#opIdx, true);
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.bboxToClipBoxDropOperation(this.#opIdx, true);
        return this;
    }
    take() {
        throw new Error("Unreachable");
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
}
const $b3a01b20dd2ade98$var$Dependencies = {
    stroke: [
        "path",
        "transform",
        "filter",
        "strokeColor",
        "strokeAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "dash"
    ],
    fill: [
        "path",
        "transform",
        "filter",
        "fillColor",
        "fillAlpha",
        "globalCompositeOperation",
        "SMask"
    ],
    imageXObject: [
        "transform",
        "SMask",
        "filter",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation"
    ],
    rawFillPath: [
        "filter",
        "fillColor",
        "fillAlpha"
    ],
    showText: [
        "transform",
        "leading",
        "charSpacing",
        "wordSpacing",
        "hScale",
        "textRise",
        "moveText",
        "textMatrix",
        "font",
        "fontObj",
        "filter",
        "fillColor",
        "textRenderingMode",
        "SMask",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation",
        "sameLineText"
    ],
    transform: [
        "transform"
    ],
    transformAndFill: [
        "transform",
        "fillColor"
    ]
};
class $b3a01b20dd2ade98$var$CanvasImagesTracker {
    #canvasWidth;
    #canvasHeight;
    #capacity = 4;
    #count = 0;
    #coords = new $b3a01b20dd2ade98$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
    static #CoordsArray = $b3a01b20dd2ade98$export$5fb8891d35c36978.isFloat16ArraySupported ? Float16Array : Float32Array;
    constructor(canvas){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
    }
    record(ctx, width, height, clipBox) {
        if (this.#count === this.#capacity) {
            this.#capacity *= 2;
            const newCoords = new $b3a01b20dd2ade98$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
            newCoords.set(this.#coords);
            this.#coords = newCoords;
        }
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.domMatrixToTransform(ctx.getTransform());
        let coords;
        if (clipBox[0] !== Infinity) {
            const bbox = $b3a01b20dd2ade98$var$BBOX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                -height,
                width,
                0
            ], transform, bbox);
            const finalBBox = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(clipBox, bbox);
            if (!finalBBox) return;
            const [minX, minY, maxX, maxY] = finalBBox;
            if (minX !== bbox[0] || minY !== bbox[1] || maxX !== bbox[2] || maxY !== bbox[3]) {
                const rotationAngle = Math.atan2(transform[1], transform[0]);
                const sin = Math.abs(Math.sin(rotationAngle));
                const cos = Math.abs(Math.cos(rotationAngle));
                if (sin < 1e-6 || cos < 1e-6 || Math.abs(sin - cos) < 1e-6) coords = [
                    minX,
                    minY,
                    minX,
                    maxY,
                    maxX,
                    minY
                ];
                else {
                    const finalBBoxWidth = maxX - minX;
                    const finalBBoxHeight = maxY - minY;
                    const sin2 = sin * sin;
                    const cos2 = cos * cos;
                    const cosSin = cos * sin;
                    const denom = cos2 - sin2;
                    const a = (finalBBoxHeight * cos2 - finalBBoxWidth * cosSin) / denom;
                    const b = (finalBBoxHeight * cosSin - finalBBoxWidth * sin2) / denom;
                    coords = [
                        minX + b,
                        minY,
                        minX,
                        minY + a,
                        maxX,
                        maxY - a
                    ];
                }
            }
        }
        if (!coords) {
            coords = [
                0,
                -height,
                0,
                0,
                width,
                -height
            ];
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 0);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 2);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 4);
        }
        coords[0] /= this.#canvasWidth;
        coords[1] /= this.#canvasHeight;
        coords[2] /= this.#canvasWidth;
        coords[3] /= this.#canvasHeight;
        coords[4] /= this.#canvasWidth;
        coords[5] /= this.#canvasHeight;
        this.#coords.set(coords, this.#count * 6);
        this.#count++;
    }
    take() {
        return this.#coords.subarray(0, this.#count * 6);
    }
}
class $b3a01b20dd2ade98$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, disableFontFace: disableFontFace, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $b3a01b20dd2ade98$var$assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $b3a01b20dd2ade98$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $b3a01b20dd2ade98$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $b3a01b20dd2ade98$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isSyncFontLoadingSupported", $b3a01b20dd2ade98$var$isNodeJS || $b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $b3a01b20dd2ade98$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function string32(value) {
            return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $b3a01b20dd2ade98$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $b3a01b20dd2ade98$var$FontFaceObject {
    compiledGlyphs = Object.create(null);
    #fontData;
    constructor(translatedData, inspectFont = null, charProcOperatorList, extra){
        this.#fontData = translatedData;
        this._inspectFont = inspectFont;
        if (charProcOperatorList) this.charProcOperatorList = charProcOperatorList;
        if (extra) Object.assign(this, extra);
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const url = `url(data:${this.mimetype};base64,${this.data.toBase64()});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        const objId = this.loadedName + "_path_" + character;
        let cmds;
        try {
            cmds = objs.get(objId);
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        const path = $b3a01b20dd2ade98$var$makePathFromDrawOPS(cmds?.path);
        if (!this.fontExtraProperties) objs.delete(objId);
        return this.compiledGlyphs[character] = path;
    }
    get black() {
        return this.#fontData.black;
    }
    get bold() {
        return this.#fontData.bold;
    }
    get disableFontFace() {
        return this.#fontData.disableFontFace;
    }
    set disableFontFace(value) {
        $b3a01b20dd2ade98$export$b8972b998723d602(this, "disableFontFace", !!value);
    }
    get fontExtraProperties() {
        return this.#fontData.fontExtraProperties;
    }
    get isInvalidPDFjsFont() {
        return this.#fontData.isInvalidPDFjsFont;
    }
    get isType3Font() {
        return this.#fontData.isType3Font;
    }
    get italic() {
        return this.#fontData.italic;
    }
    get missingFile() {
        return this.#fontData.missingFile;
    }
    get remeasure() {
        return this.#fontData.remeasure;
    }
    get vertical() {
        return this.#fontData.vertical;
    }
    get ascent() {
        return this.#fontData.ascent;
    }
    get defaultWidth() {
        return this.#fontData.defaultWidth;
    }
    get descent() {
        return this.#fontData.descent;
    }
    get bbox() {
        return this.#fontData.bbox;
    }
    get fontMatrix() {
        return this.#fontData.fontMatrix;
    }
    get fallbackName() {
        return this.#fontData.fallbackName;
    }
    get loadedName() {
        return this.#fontData.loadedName;
    }
    get mimetype() {
        return this.#fontData.mimetype;
    }
    get name() {
        return this.#fontData.name;
    }
    get data() {
        return this.#fontData.data;
    }
    clearData() {
        this.#fontData.clearData();
    }
    get cssFontInfo() {
        return this.#fontData.cssFontInfo;
    }
    get systemFontInfo() {
        return this.#fontData.systemFontInfo;
    }
    get defaultVMetrics() {
        return this.#fontData.defaultVMetrics;
    }
}
class $b3a01b20dd2ade98$var$CSS_FONT_INFO {
    static strings = [
        "fontFamily",
        "fontWeight",
        "italicAngle"
    ];
}
class $b3a01b20dd2ade98$var$SYSTEM_FONT_INFO {
    static strings = [
        "css",
        "loadedName",
        "baseFontName",
        "src"
    ];
}
class $b3a01b20dd2ade98$var$FONT_INFO {
    static bools = [
        "black",
        "bold",
        "disableFontFace",
        "fontExtraProperties",
        "isInvalidPDFjsFont",
        "isType3Font",
        "italic",
        "missingFile",
        "remeasure",
        "vertical"
    ];
    static numbers = [
        "ascent",
        "defaultWidth",
        "descent"
    ];
    static strings = [
        "fallbackName",
        "loadedName",
        "mimetype",
        "name"
    ];
    static OFFSET_NUMBERS = Math.ceil(this.bools.length * 2 / 8);
    static OFFSET_BBOX = this.OFFSET_NUMBERS + this.numbers.length * 8;
    static OFFSET_FONT_MATRIX = this.OFFSET_BBOX + 1 + 8;
    static OFFSET_DEFAULT_VMETRICS = this.OFFSET_FONT_MATRIX + 1 + 48;
    static OFFSET_STRINGS = this.OFFSET_DEFAULT_VMETRICS + 1 + 6;
}
class $b3a01b20dd2ade98$var$PATTERN_INFO {
    static KIND = 0;
    static HAS_BBOX = 1;
    static HAS_BACKGROUND = 2;
    static SHADING_TYPE = 3;
    static N_COORD = 4;
    static N_COLOR = 8;
    static N_STOP = 12;
    static N_FIGURES = 16;
}
class $b3a01b20dd2ade98$var$CssFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$CSS_FONT_INFO.strings.length, "Invalid string index");
        let offset = 0;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fontFamily() {
        return this.#readString(0);
    }
    get fontWeight() {
        return this.#readString(1);
    }
    get italicAngle() {
        return this.#readString(2);
    }
}
class $b3a01b20dd2ade98$var$SystemFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    get guessFallback() {
        return this.#view.getUint8(0) !== 0;
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$SYSTEM_FONT_INFO.strings.length, "Invalid string index");
        let offset = 5;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get css() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get baseFontName() {
        return this.#readString(2);
    }
    get src() {
        return this.#readString(3);
    }
    get style() {
        let offset = 1;
        offset += 4 + this.#view.getUint32(offset);
        const styleLength = this.#view.getUint32(offset);
        const style = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, styleLength));
        offset += 4 + styleLength;
        const weightLength = this.#view.getUint32(offset);
        const weight = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, weightLength));
        return {
            style: style,
            weight: weight
        };
    }
}
class $b3a01b20dd2ade98$var$FontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor({ buffer: buffer, extra: extra }){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
        if (extra) Object.assign(this, extra);
    }
    #readBoolean(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.bools.length, "Invalid boolean index");
        const byteOffset = Math.floor(index / 4);
        const bitOffset = index * 2 % 8;
        const value = this.#view.getUint8(byteOffset) >> bitOffset & 0x03;
        return value === 0x00 ? undefined : value === 0x02;
    }
    get black() {
        return this.#readBoolean(0);
    }
    get bold() {
        return this.#readBoolean(1);
    }
    get disableFontFace() {
        return this.#readBoolean(2);
    }
    get fontExtraProperties() {
        return this.#readBoolean(3);
    }
    get isInvalidPDFjsFont() {
        return this.#readBoolean(4);
    }
    get isType3Font() {
        return this.#readBoolean(5);
    }
    get italic() {
        return this.#readBoolean(6);
    }
    get missingFile() {
        return this.#readBoolean(7);
    }
    get remeasure() {
        return this.#readBoolean(8);
    }
    get vertical() {
        return this.#readBoolean(9);
    }
    #readNumber(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.numbers.length, "Invalid number index");
        return this.#view.getFloat64($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_NUMBERS + index * 8);
    }
    get ascent() {
        return this.#readNumber(0);
    }
    get defaultWidth() {
        return this.#readNumber(1);
    }
    get descent() {
        return this.#readNumber(2);
    }
    #readArray(offset, arrLen, lookupName, increment) {
        const len = this.#view.getUint8(offset);
        if (len === 0) return undefined;
        $b3a01b20dd2ade98$var$assert(len === arrLen, "Invalid array length.");
        offset += 1;
        const arr = new Array(len);
        for(let i = 0; i < len; i++){
            arr[i] = this.#view[lookupName](offset, true);
            offset += increment;
        }
        return arr;
    }
    get bbox() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_BBOX, 4, "getInt16", 2);
    }
    get fontMatrix() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_FONT_MATRIX, 6, "getFloat64", 8);
    }
    get defaultVMetrics() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_DEFAULT_VMETRICS, 3, "getInt16", 2);
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.strings.length, "Invalid string index");
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS + 4;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fallbackName() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get mimetype() {
        return this.#readString(2);
    }
    get name() {
        return this.#readString(3);
    }
    #getDataOffsets() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        return {
            offset: offset,
            length: length
        };
    }
    get data() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        return length === 0 ? undefined : new Uint8Array(this.#buffer, offset + 4, length);
    }
    clearData() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        if (length === 0) return;
        this.#view.setUint32(offset, 0);
        this.#buffer = new Uint8Array(this.#buffer, 0, offset + 4).slice().buffer;
        this.#view = new DataView(this.#buffer);
    }
    get cssFontInfo() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        if (cssFontInfoLength === 0) return null;
        const cssFontInfoData = new Uint8Array(cssFontInfoLength);
        cssFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, cssFontInfoLength));
        return new $b3a01b20dd2ade98$var$CssFontInfo(cssFontInfoData.buffer);
    }
    get systemFontInfo() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        if (systemFontInfoLength === 0) return null;
        const systemFontInfoData = new Uint8Array(systemFontInfoLength);
        systemFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, systemFontInfoLength));
        return new $b3a01b20dd2ade98$var$SystemFontInfo(systemFontInfoData.buffer);
    }
}
class $b3a01b20dd2ade98$var$PatternInfo {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer);
        this.data = new Uint8Array(buffer);
    }
    getIR() {
        const dataView = this.view;
        const kind = this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.KIND];
        const hasBBox = !!this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.HAS_BBOX];
        const hasBackground = !!this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.HAS_BACKGROUND];
        const nCoord = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_COORD, true);
        const nColor = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_COLOR, true);
        const nStop = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_STOP, true);
        let offset = 20;
        const coords = new Float32Array(this.buffer, offset, nCoord * 2);
        offset += nCoord * 8;
        const colors = new Uint8Array(this.buffer, offset, nColor * 4);
        offset += nColor * 4;
        const stops = [];
        for(let i = 0; i < nStop; ++i){
            const p = dataView.getFloat32(offset, true);
            offset += 4;
            const rgb = dataView.getUint32(offset, true);
            offset += 4;
            stops.push([
                p,
                `#${rgb.toString(16).padStart(6, "0")}`
            ]);
        }
        let bbox = null;
        if (hasBBox) {
            bbox = [];
            for(let i = 0; i < 4; ++i){
                bbox.push(dataView.getFloat32(offset, true));
                offset += 4;
            }
        }
        let background = null;
        if (hasBackground) {
            background = new Uint8Array(this.buffer, offset, 3);
            offset += 3;
        }
        if (kind === 1) return [
            "RadialAxial",
            "axial",
            bbox,
            stops,
            Array.from(coords.slice(0, 2)),
            Array.from(coords.slice(2, 4)),
            null,
            null
        ];
        if (kind === 2) return [
            "RadialAxial",
            "radial",
            bbox,
            stops,
            [
                coords[0],
                coords[1]
            ],
            [
                coords[3],
                coords[4]
            ],
            coords[2],
            coords[5]
        ];
        if (kind === 3) {
            const shadingType = this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.SHADING_TYPE];
            let bounds = null;
            if (coords.length > 0) {
                bounds = $b3a01b20dd2ade98$var$BBOX_INIT.slice();
                for(let i = 0, ii = coords.length; i < ii; i += 2)$b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(coords[i], coords[i + 1], bounds);
            }
            return [
                "Mesh",
                shadingType,
                coords,
                colors,
                nCoord,
                bounds,
                bbox,
                background
            ];
        }
        throw new Error(`Unsupported pattern kind: ${kind}`);
    }
}
class $b3a01b20dd2ade98$var$FontPathInfo {
    #buffer;
    constructor(buffer){
        this.#buffer = buffer;
    }
    get path() {
        if ($b3a01b20dd2ade98$export$5fb8891d35c36978.isFloat16ArraySupported) return new Float16Array(this.#buffer);
        return new Float32Array(this.#buffer);
    }
}
function $b3a01b20dd2ade98$var$getUrlProp(val) {
    if (val instanceof URL) return val;
    if (typeof val === "string") {
        if ($b3a01b20dd2ade98$var$isNodeJS) {
            if (/^[a-z][a-z0-9\-+.]+:/i.test(val)) return new URL(val);
            const url = $4TZ3D.getBuiltinModule("url");
            return new URL(url.pathToFileURL(val));
        }
        const url = URL.parse(val, window.location);
        if (url) return url;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $b3a01b20dd2ade98$var$getDataProp(val) {
    if ($b3a01b20dd2ade98$var$isNodeJS && typeof $b3a01b20dd2ade98$require$Buffer !== "undefined" && val instanceof $b3a01b20dd2ade98$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $b3a01b20dd2ade98$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $b3a01b20dd2ade98$var$getFactoryUrlProp(val) {
    if (typeof val !== "string") return null;
    if (val.endsWith("/")) return val;
    throw new Error(`Invalid factory url: "${val}" must include trailing slash.`);
}
const $b3a01b20dd2ade98$var$isRefProxy = (v)=>typeof v === "object" && Number.isInteger(v?.num) && v.num >= 0 && Number.isInteger(v?.gen) && v.gen >= 0;
const $b3a01b20dd2ade98$var$isNameProxy = (v)=>typeof v === "object" && typeof v?.name === "string";
const $b3a01b20dd2ade98$export$b5acece0a447dcdc = $b3a01b20dd2ade98$var$_isValidExplicitDest.bind(null, $b3a01b20dd2ade98$var$isRefProxy, $b3a01b20dd2ade98$var$isNameProxy);
class $b3a01b20dd2ade98$var$LoopbackPort {
    #listeners = new Map();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const [listener] of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener, options = null) {
        let rmAbort = null;
        if (options?.signal instanceof AbortSignal) {
            const { signal: signal } = options;
            if (signal.aborted) {
                $b3a01b20dd2ade98$var$warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            const onAbort = ()=>this.removeEventListener(name, listener);
            rmAbort = ()=>signal.removeEventListener("abort", onAbort);
            signal.addEventListener("abort", onAbort);
        }
        this.#listeners.set(listener, rmAbort);
    }
    removeEventListener(name, listener) {
        const rmAbort = this.#listeners.get(listener);
        rmAbort?.();
        this.#listeners.delete(listener);
    }
    terminate() {
        for (const [, rmAbort] of this.#listeners)rmAbort?.();
        this.#listeners.clear();
    }
}
const $b3a01b20dd2ade98$var$CallbackKind = {
    DATA: 1,
    ERROR: 2
};
const $b3a01b20dd2ade98$var$StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $b3a01b20dd2ade98$var$onFn() {}
function $b3a01b20dd2ade98$var$wrapReason(ex) {
    if (ex instanceof $b3a01b20dd2ade98$export$d0e978393d193d1a || ex instanceof $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1 || ex instanceof $b3a01b20dd2ade98$var$PasswordException || ex instanceof $b3a01b20dd2ade98$export$ea8e9c34f66e603 || ex instanceof $b3a01b20dd2ade98$var$UnknownErrorException) return ex;
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) $b3a01b20dd2ade98$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(ex.name){
        case "AbortException":
            return new $b3a01b20dd2ade98$export$d0e978393d193d1a(ex.message);
        case "InvalidPDFException":
            return new $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1(ex.message);
        case "PasswordException":
            return new $b3a01b20dd2ade98$var$PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new $b3a01b20dd2ade98$export$ea8e9c34f66e603(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new $b3a01b20dd2ade98$var$UnknownErrorException(ex.message, ex.details);
    }
    return new $b3a01b20dd2ade98$var$UnknownErrorException(ex.message, ex.toString());
}
class $b3a01b20dd2ade98$var$MessageHandler {
    #messageAC = new AbortController();
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", this.#onMessage.bind(this), {
            signal: this.#messageAC.signal
        });
    }
    #onMessage({ data: data }) {
        if (data.targetName !== this.sourceName) return;
        if (data.stream) {
            this.#processStreamMessage(data);
            return;
        }
        if (data.callback) {
            const callbackId = data.callbackId;
            const capability = this.callbackCapabilities[callbackId];
            if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
            delete this.callbackCapabilities[callbackId];
            if (data.callback === $b3a01b20dd2ade98$var$CallbackKind.DATA) capability.resolve(data.data);
            else if (data.callback === $b3a01b20dd2ade98$var$CallbackKind.ERROR) capability.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
            else throw new Error("Unexpected callback case");
            return;
        }
        const action = this.actionHandler[data.action];
        if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
        if (data.callbackId) {
            const sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
            Promise.try(action, data.data).then(function(result) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $b3a01b20dd2ade98$var$CallbackKind.DATA,
                    callbackId: data.callbackId,
                    data: result
                });
            }, function(reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $b3a01b20dd2ade98$var$CallbackKind.ERROR,
                    callbackId: data.callbackId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
            });
            return;
        }
        if (data.streamId) {
            this.#createStreamSink(data);
            return;
        }
        action(data.data);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $b3a01b20dd2ade98$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $b3a01b20dd2ade98$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        Promise.try(action, data.data, streamSink).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $b3a01b20dd2ade98$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                break;
            case $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                break;
            case $b3a01b20dd2ade98$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                Promise.try(streamSink.onPull || $b3a01b20dd2ade98$var$onFn).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                    });
                });
                break;
            case $b3a01b20dd2ade98$var$StreamKind.ENQUEUE:
                $b3a01b20dd2ade98$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CLOSE:
                $b3a01b20dd2ade98$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.ERROR:
                $b3a01b20dd2ade98$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($b3a01b20dd2ade98$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CANCEL:
                if (!streamSink) break;
                const dataReason = $b3a01b20dd2ade98$var$wrapReason(data.reason);
                Promise.try(streamSink.onCancel || $b3a01b20dd2ade98$var$onFn, dataReason).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject(dataReason);
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.#messageAC?.abort();
        this.#messageAC = null;
    }
}
class $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    #errorStr = Object.freeze({
        cMapUrl: "CMap",
        standardFontDataUrl: "font",
        wasmUrl: "wasm"
    });
    constructor({ cMapUrl: cMapUrl = null, standardFontDataUrl: standardFontDataUrl = null, wasmUrl: wasmUrl = null }){
        this.cMapUrl = cMapUrl;
        this.standardFontDataUrl = standardFontDataUrl;
        this.wasmUrl = wasmUrl;
    }
    async fetch({ kind: kind, filename: filename }) {
        switch(kind){
            case "cMapUrl":
            case "standardFontDataUrl":
            case "wasmUrl":
                break;
            default:
                $b3a01b20dd2ade98$var$unreachable(`Not implemented: ${kind}`);
        }
        const baseUrl = this[kind];
        if (!baseUrl) throw new Error(`Ensure that the \`${kind}\` API parameter is provided.`);
        const url = `${baseUrl}${filename}`;
        return this._fetch(url, kind).catch((reason)=>{
            throw new Error(`Unable to load ${this.#errorStr[kind]} data at: ${url}`);
        });
    }
    async _fetch(url, kind) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $b3a01b20dd2ade98$var$DOMBinaryDataFactory extends $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        const type = kind === "cMapUrl" && !url.endsWith(".bcmap") ? "text" : "bytes";
        const data = await $b3a01b20dd2ade98$export$8134c072fddab6a5(url, type);
        return data instanceof Uint8Array ? data : $b3a01b20dd2ade98$var$stringToBytes(data);
    }
}
class $b3a01b20dd2ade98$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false }){
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset({ canvas: canvas }, width, height) {
        if (!canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvas.width = width;
        canvas.height = height;
    }
    destroy(canvasAndContext) {
        const { canvas: canvas } = canvasAndContext;
        if (!canvas) throw new Error("Canvas is not specified");
        canvas.width = canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $b3a01b20dd2ade98$var$DOMCanvasFactory extends $b3a01b20dd2ade98$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false }){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
class $b3a01b20dd2ade98$var$BaseFilterFactory {
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    destroy(keepHCM = false) {}
}
class $b3a01b20dd2ade98$var$DOMFilterFactory extends $b3a01b20dd2ade98$var$BaseFilterFactory {
    #baseUrl;
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document }){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    #createUrl(id) {
        if (this.#baseUrl === undefined) {
            this.#baseUrl = "";
            const url = this.#document.URL;
            if (url !== this.#document.baseURI) {
                if ($b3a01b20dd2ade98$export$f67aae4532d8295b(url)) $b3a01b20dd2ade98$var$warn('#createUrl: ignore "data:"-URL for performance reasons.');
                else this.#baseUrl = $b3a01b20dd2ade98$export$e1e4297c21ab9d13(url, "");
            }
        }
        return `url(${this.#baseUrl}#${id})`;
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getRGB.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#_hcmCache?.size) return;
        this.#_defs?.parentNode.parentNode.remove();
        this.#_defs = null;
        this.#_cache?.clear();
        this.#_cache = null;
        this.#_hcmCache?.clear();
        this.#_hcmCache = null;
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $b3a01b20dd2ade98$export$2a2e9b507863ddda(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
}
if ($b3a01b20dd2ade98$var$isNodeJS) $b3a01b20dd2ade98$var$warn("Please use the `legacy` build in Node.js environments.");
async function $b3a01b20dd2ade98$var$node_utils_fetchData(url) {
    const fs = $4TZ3D.getBuiltinModule("fs/promises");
    const data = await fs.readFile(url);
    return new Uint8Array(data);
}
class $b3a01b20dd2ade98$var$NodeFilterFactory extends $b3a01b20dd2ade98$var$BaseFilterFactory {
}
class $b3a01b20dd2ade98$var$NodeCanvasFactory extends $b3a01b20dd2ade98$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const require1 = $4TZ3D.getBuiltinModule("module").createRequire("file:///node_modules/pdfjs-dist/build/pdf.mjs");
        const canvas = require1("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    }
}
class $b3a01b20dd2ade98$var$NodeBinaryDataFactory extends $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        return $b3a01b20dd2ade98$var$node_utils_fetchData(url);
    }
}
const $b3a01b20dd2ade98$var$MESH_WGSL = `
struct Uniforms {
  offsetX      : f32,
  offsetY      : f32,
  scaleX       : f32,
  scaleY       : f32,
  paddedWidth  : f32,
  paddedHeight : f32,
  borderSize   : f32,
  _pad         : f32,
};

@group(0) @binding(0) var<uniform> u : Uniforms;

struct VertexInput {
  @location(0) position : vec2<f32>,
  @location(1) color    : vec4<f32>,
};

struct VertexOutput {
  @builtin(position) position : vec4<f32>,
  @location(0)       color    : vec3<f32>,
};

@vertex
fn vs_main(in : VertexInput) -> VertexOutput {
  var out : VertexOutput;
  let cx = (in.position.x + u.offsetX) * u.scaleX;
  let cy = (in.position.y + u.offsetY) * u.scaleY;
  out.position = vec4<f32>(
    ((cx + u.borderSize) / u.paddedWidth) * 2.0 - 1.0,
    1.0 - ((cy + u.borderSize) / u.paddedHeight) * 2.0,
    0.0,
    1.0
  );
  out.color = in.color.rgb;
  return out;
}

@fragment
fn fs_main(in : VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(in.color, 1.0);
}
`;
class $b3a01b20dd2ade98$var$WebGPU {
    #initPromise = null;
    #device = null;
    #meshPipeline = null;
    #preferredFormat = null;
    async #initGPU() {
        if (!globalThis.navigator?.gpu) return false;
        try {
            const adapter = await navigator.gpu.requestAdapter();
            if (!adapter) return false;
            this.#preferredFormat = navigator.gpu.getPreferredCanvasFormat();
            this.#device = await adapter.requestDevice();
            return true;
        } catch  {
            return false;
        }
    }
    init() {
        return this.#initPromise ||= this.#initGPU();
    }
    get isReady() {
        return this.#device !== null;
    }
    loadMeshShader() {
        if (!this.#device || this.#meshPipeline) return;
        const shaderModule = this.#device.createShaderModule({
            code: $b3a01b20dd2ade98$var$MESH_WGSL
        });
        this.#meshPipeline = this.#device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: shaderModule,
                entryPoint: "vs_main",
                buffers: [
                    {
                        arrayStride: 8,
                        attributes: [
                            {
                                shaderLocation: 0,
                                offset: 0,
                                format: "float32x2"
                            }
                        ]
                    },
                    {
                        arrayStride: 4,
                        attributes: [
                            {
                                shaderLocation: 1,
                                offset: 0,
                                format: "unorm8x4"
                            }
                        ]
                    }
                ]
            },
            fragment: {
                module: shaderModule,
                entryPoint: "fs_main",
                targets: [
                    {
                        format: this.#preferredFormat
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            }
        });
    }
    draw(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
        this.loadMeshShader();
        const device = this.#device;
        const { offsetX: offsetX, offsetY: offsetY, scaleX: scaleX, scaleY: scaleY } = context;
        const posBuffer = device.createBuffer({
            size: Math.max(posData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (posData.byteLength > 0) device.queue.writeBuffer(posBuffer, 0, posData);
        const colBuffer = device.createBuffer({
            size: Math.max(colData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (colData.byteLength > 0) device.queue.writeBuffer(colBuffer, 0, colData);
        const uniformBuffer = device.createBuffer({
            size: 32,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(uniformBuffer, 0, new Float32Array([
            offsetX,
            offsetY,
            scaleX,
            scaleY,
            paddedWidth,
            paddedHeight,
            borderSize,
            0
        ]));
        const bindGroup = device.createBindGroup({
            layout: this.#meshPipeline.getBindGroupLayout(0),
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: uniformBuffer
                    }
                }
            ]
        });
        const offscreen = new OffscreenCanvas(paddedWidth, paddedHeight);
        const gpuCtx = offscreen.getContext("webgpu");
        gpuCtx.configure({
            device: device,
            format: this.#preferredFormat,
            alphaMode: backgroundColor ? "opaque" : "premultiplied"
        });
        const clearValue = backgroundColor ? {
            r: backgroundColor[0] / 255,
            g: backgroundColor[1] / 255,
            b: backgroundColor[2] / 255,
            a: 1
        } : {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        const commandEncoder = device.createCommandEncoder();
        const renderPass = commandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: gpuCtx.getCurrentTexture().createView(),
                    clearValue: clearValue,
                    loadOp: "clear",
                    storeOp: "store"
                }
            ]
        });
        if (vertexCount > 0) {
            renderPass.setPipeline(this.#meshPipeline);
            renderPass.setBindGroup(0, bindGroup);
            renderPass.setVertexBuffer(0, posBuffer);
            renderPass.setVertexBuffer(1, colBuffer);
            renderPass.draw(vertexCount);
        }
        renderPass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
        posBuffer.destroy();
        colBuffer.destroy();
        uniformBuffer.destroy();
        return offscreen.transferToImageBitmap();
    }
}
const $b3a01b20dd2ade98$var$_webGPU = new $b3a01b20dd2ade98$var$WebGPU();
function $b3a01b20dd2ade98$var$initGPU() {
    return $b3a01b20dd2ade98$var$_webGPU.init();
}
function $b3a01b20dd2ade98$var$isGPUReady() {
    return $b3a01b20dd2ade98$var$_webGPU.isReady;
}
function $b3a01b20dd2ade98$var$loadMeshShader() {
    $b3a01b20dd2ade98$var$_webGPU.loadMeshShader();
}
function $b3a01b20dd2ade98$var$drawMeshWithGPU(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
    return $b3a01b20dd2ade98$var$_webGPU.draw(posData, colData, vertexCount, context, backgroundColor, paddedWidth, paddedHeight, borderSize);
}
const $b3a01b20dd2ade98$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $b3a01b20dd2ade98$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $b3a01b20dd2ade98$var$BaseShadingPattern {
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $b3a01b20dd2ade98$var$RadialAxialShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    isOriginBased() {
        return this._p0[0] === 0 && this._p0[1] === 0 && (!this.isRadial() || this._p1[0] === 0 && this._p1[1] === 0);
    }
    isRadial() {
        return this._type === "radial";
    }
    areConic() {
        if (!this.isRadial()) return false;
        const dist = Math.hypot(this._p0[0] - this._p1[0], this._p0[1] - this._p1[1]);
        return dist + this._r1 > this._r0 && dist + this._r0 > this._r1;
    }
    _createGradient(ctx, transform = null) {
        let grad;
        let firstPoint = this._p0;
        let secondPoint = this._p1;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        if (this._type === "axial") grad = ctx.createLinearGradient(firstPoint[0], firstPoint[1], secondPoint[0], secondPoint[1]);
        else if (this._type === "radial") {
            let r0 = this._r0;
            let r1 = this._r1;
            if (transform) {
                const scale = new Float32Array(2);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
                r0 *= scale[0];
                r1 *= scale[0];
            }
            grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        }
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    _createReversedGradient(ctx, transform = null) {
        let firstPoint = this._p1;
        let secondPoint = this._p0;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        let r0 = this._r1;
        let r1 = this._r0;
        if (transform) {
            const scale = new Float32Array(2);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
            r0 *= scale[0];
            r1 *= scale[0];
        }
        const grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        const reversedStops = this._colorStops.map(([t, c])=>[
                1 - t,
                c
            ]).reverse();
        for (const [t, c] of reversedStops)grad.addColorStop(t, c);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $b3a01b20dd2ade98$var$PathType.STROKE || pathType === $b3a01b20dd2ade98$var$PathType.FILL) {
            if (this.isOriginBased()) {
                let transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(inverse, owner.baseTransform);
                if (this.matrix) transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(transf, this.matrix);
                const precision = 1e-3;
                const n1 = Math.hypot(transf[0], transf[1]);
                const n2 = Math.hypot(transf[2], transf[3]);
                const ps = (transf[0] * transf[2] + transf[1] * transf[3]) / (n1 * n2);
                if (Math.abs(ps) < precision) {
                    if (this.isRadial()) {
                        if (Math.abs(n1 - n2) < precision) return this._createGradient(ctx, transf);
                    } else return this._createGradient(ctx, transf);
                }
            }
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $b3a01b20dd2ade98$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.canvasFactory.create(width, height);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $b3a01b20dd2ade98$var$applyBoundingBox(tmpCtx, this._bbox);
            if (this.areConic()) {
                tmpCtx.fillStyle = this._createReversedGradient(tmpCtx);
                tmpCtx.fill();
            }
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            owner.canvasFactory.destroy(tmpCanvas);
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            if (this.areConic()) {
                ctx.save();
                $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
                ctx.fillStyle = this._createReversedGradient(ctx);
                ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                ctx.restore();
            }
            $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $b3a01b20dd2ade98$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 * 2 + 1] > coords[p3 * 2 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1 * 2] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 * 2 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2 * 2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 * 2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3 * 2] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 * 2 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1 * 4], c1g = colors[c1 * 4 + 1], c1b = colors[c1 * 4 + 2];
    const c2r = colors[c2 * 4], c2g = colors[c2 * 4 + 1], c2b = colors[c2 * 4 + 2];
    const c3r = colors[c3 * 4], c3g = colors[c3 * 4 + 1], c3b = colors[c3 * 4 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
class $b3a01b20dd2ade98$var$MeshShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._posData = IR[2];
        this._colData = IR[3];
        this._vertexCount = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[6];
        this._background = IR[7];
        this.matrix = null;
        $b3a01b20dd2ade98$var$loadMeshShader();
    }
    _createMeshCanvas(combinedScale, backgroundColor, canvasFactory) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const scaleX = boundsWidth ? boundsWidth / width : 1;
        const scaleY = boundsHeight ? boundsHeight / height : 1;
        const context = {
            coords: this._posData,
            colors: this._colData,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = canvasFactory.create(paddedWidth, paddedHeight);
        if ($b3a01b20dd2ade98$var$isGPUReady() && this._vertexCount > 48) tmpCanvas.context.drawImage($b3a01b20dd2ade98$var$drawMeshWithGPU(this._posData, this._colData, this._vertexCount, context, backgroundColor, paddedWidth, paddedHeight, BORDER_SIZE), 0, 0);
        else {
            const data = tmpCanvas.context.createImageData(width, height);
            if (backgroundColor) {
                const bytes = data.data;
                for(let i = 0, ii = bytes.length; i < ii; i += 4){
                    bytes[i] = backgroundColor[0];
                    bytes[i + 1] = backgroundColor[1];
                    bytes[i + 2] = backgroundColor[2];
                    bytes[i + 3] = 255;
                }
            }
            for(let i = 0, ii = this._vertexCount; i < ii; i += 3)$b3a01b20dd2ade98$var$drawTriangle(data, context, i, i + 1, i + 2, i, i + 1, i + 2);
            tmpCanvas.context.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        }
        return {
            canvas: tmpCanvas.canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    isModifyingCurrentTransform() {
        return true;
    }
    getPattern(ctx, owner, inverse, pathType) {
        $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
        const scale = new Float32Array(2);
        if (pathType === $b3a01b20dd2ade98$var$PathType.SHADING) $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($b3a01b20dd2ade98$var$getCurrentTransform(ctx), scale);
        else if (this.matrix) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
            const [matrixScaleX, matrixScaleY] = scale;
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        } else $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $b3a01b20dd2ade98$var$PathType.SHADING ? null : this._background, owner.canvasFactory);
        if (pathType !== $b3a01b20dd2ade98$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas);
        return pattern;
    }
}
class $b3a01b20dd2ade98$var$DummyShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $b3a01b20dd2ade98$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $b3a01b20dd2ade98$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $b3a01b20dd2ade98$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $b3a01b20dd2ade98$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $b3a01b20dd2ade98$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $b3a01b20dd2ade98$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, ctx, canvasGraphicsFactory, baseTransform){
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.needsIsolation = IR[9] ?? true;
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
        this.patternBaseMatrix = this.matrix ? $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(baseTransform, this.matrix) : baseTransform;
    }
    canSkipPatternCanvas([width, height, offsetX, offsetY]) {
        const [x0, y0, x1, y1] = this.bbox;
        const absXStep = Math.abs(this.xstep);
        const absYStep = Math.abs(this.ystep);
        if (width > absXStep + 1e-6 || height > absYStep + 1e-6) return null;
        const nXFirst = Math.floor((offsetX - x1) / absXStep) + 1;
        const nXLast = Math.ceil((offsetX + width - x0) / absXStep) - 1;
        const nYFirst = Math.floor((offsetY - y1) / absYStep) + 1;
        const nYLast = Math.ceil((offsetY + height - y0) / absYStep) - 1;
        return nXLast <= nXFirst && nYLast <= nYFirst ? [
            nXFirst,
            nYFirst
        ] : null;
    }
    updatePatternDims(clippedBBox, dims) {
        const inv = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.inverseTransform(this.patternBaseMatrix);
        const c1 = [
            clippedBBox[0],
            clippedBBox[1]
        ];
        const c2 = [
            clippedBBox[2],
            clippedBBox[3]
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(c1, inv);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(c2, inv);
        dims[0] = Math.abs(c2[0] - c1[0]);
        dims[1] = Math.abs(c2[1] - c1[1]);
        dims[2] = Math.min(c1[0], c2[0]);
        dims[3] = Math.min(c1[1], c2[1]);
    }
    _renderTileCanvas(owner, opIdx, dimx, dimy) {
        const [x0, y0, x1, y1] = this.bbox;
        const tmpCanvas = owner.canvasFactory.create(dimx.size, dimy.size);
        const tmpCtx = tmpCanvas.context;
        const graphics = this.canvasGraphicsFactory.createCanvasGraphics(tmpCtx, opIdx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, this.paintType, this.color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(0, dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        graphics.dependencyTracker?.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(this.operatorList);
        graphics.endDrawing();
        graphics.dependencyTracker?.restore();
        tmpCtx.restore();
        return tmpCanvas;
    }
    _getCombinedScales() {
        const scale = new Float32Array(2);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
        const [matrixScaleX, matrixScaleY] = scale;
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.baseTransform, scale);
        return [
            matrixScaleX * scale[0],
            matrixScaleY * scale[1]
        ];
    }
    drawPattern(owner, path, useEOFill = false, [n, m], opIdx) {
        const [x0, y0, x1, y1] = this.bbox;
        const dependencyTracker = owner.dependencyTracker;
        if (dependencyTracker) owner.dependencyTracker = new $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx);
        owner.save();
        if (useEOFill) owner.ctx.clip(path, "evenodd");
        else owner.ctx.clip(path);
        owner.ctx.setTransform(...this.patternBaseMatrix);
        owner.ctx.translate(n * this.xstep, m * this.ystep);
        if (this.needsIsolation || owner.ctx.globalAlpha !== 1 || owner.ctx.globalCompositeOperation !== "source-over" || owner.inSMaskMode) {
            const bboxWidth = x1 - x0;
            const bboxHeight = y1 - y0;
            const [combinedScaleX, combinedScaleY] = this._getCombinedScales();
            const dimx = this.getSizeAndScale(bboxWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy = this.getSizeAndScale(bboxHeight, this.ctx.canvas.height, combinedScaleY);
            const tmpCanvas = this._renderTileCanvas(owner, opIdx, dimx, dimy);
            owner.ctx.drawImage(tmpCanvas.canvas, x0, y0, bboxWidth, bboxHeight);
            owner.canvasFactory.destroy(tmpCanvas);
        } else {
            this.setFillAndStrokeStyleToContext(owner, this.paintType, this.color);
            this.clipBbox(owner, x0, y0, x1, y1);
            owner.baseTransformStack.push(owner.baseTransform);
            owner.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(owner.ctx);
            owner.executeOperatorList(this.operatorList);
            owner.baseTransform = owner.baseTransformStack.pop();
        }
        owner.restore();
        if (dependencyTracker) owner.dependencyTracker = dependencyTracker;
    }
    createPatternCanvas(owner, opIdx) {
        const [x0, y0, x1, y1] = this.bbox;
        const width = x1 - x0;
        const height = y1 - y0;
        let { xstep: xstep, ystep: ystep } = this;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        $b3a01b20dd2ade98$var$info("TilingType: " + this.tilingType);
        const [combinedScaleX, combinedScaleY] = this._getCombinedScales();
        let canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        if (Math.ceil(xstep * combinedScaleX) >= Math.ceil(width * combinedScaleX)) canvasWidth = xstep;
        else redrawHorizontally = true;
        if (Math.ceil(ystep * combinedScaleY) >= Math.ceil(height * combinedScaleY)) canvasHeight = ystep;
        else redrawVertically = true;
        const dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        const dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        const tmpCanvas = this._renderTileCanvas(owner, opIdx, dimx, dimy);
        if (redrawHorizontally || redrawVertically) {
            const image = tmpCanvas.canvas;
            if (redrawHorizontally) canvasWidth = xstep;
            if (redrawVertically) canvasHeight = ystep;
            const dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            const xSize = dimx2.size;
            const ySize = dimy2.size;
            const tmpCanvas2 = owner.canvasFactory.create(xSize, ySize);
            const tmpCtx2 = tmpCanvas2.context;
            const ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            const jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for(let i = 0; i <= ii; i++)for(let j = 0; j <= jj; j++)tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
            owner.canvasFactory.destroy(tmpCanvas);
            return {
                canvas: tmpCanvas2.canvas,
                canvasEntry: tmpCanvas2,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            canvasEntry: tmpCanvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        const maxSize = Math.max($b3a01b20dd2ade98$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        const clip = new Path2D();
        clip.rect(x0, y0, bboxWidth, bboxHeight);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            x0,
            y0,
            x1,
            y1
        ], $b3a01b20dd2ade98$var$getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.ctx.clip(clip);
        graphics.current.updateClipFromPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        current.patternFill = current.patternStroke = false;
        switch(paintType){
            case $b3a01b20dd2ade98$var$PaintType.COLORED:
                const { fillStyle: fillStyle, strokeStyle: strokeStyle } = this.ctx;
                context.fillStyle = current.fillColor = fillStyle;
                context.strokeStyle = current.strokeColor = strokeStyle;
                break;
            case $b3a01b20dd2ade98$var$PaintType.UNCOLORED:
                context.fillStyle = context.strokeStyle = color;
                current.fillColor = current.strokeColor = color;
                break;
            default:
                throw new $b3a01b20dd2ade98$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern(ctx, owner, inverse, pathType, opIdx) {
        const matrix = pathType !== $b3a01b20dd2ade98$var$PathType.SHADING ? $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(inverse, this.patternBaseMatrix) : inverse;
        const temporaryPatternCanvas = this.createPatternCanvas(owner, opIdx);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas.canvasEntry);
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
/* unused harmony import specifier */ var $b3a01b20dd2ade98$var$image_utils_ImageKind;
/* unused harmony import specifier */ var $b3a01b20dd2ade98$var$image_utils_FeatureTest;
function $b3a01b20dd2ade98$var$convertToRGBA(params) {
    switch(params.kind){
        case $b3a01b20dd2ade98$var$image_utils_ImageKind.GRAYSCALE_1BPP:
            return $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA(params);
        case $b3a01b20dd2ade98$var$image_utils_ImageKind.RGB_24BPP:
            return $b3a01b20dd2ade98$var$convertRGBToRGBA(params);
    }
    return null;
}
function $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $b3a01b20dd2ade98$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const xorMask = zeroMapping ^ oneMapping;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; ++i){
        for(const max = srcPos + widthInSource; srcPos < max; ++srcPos, destPos += 8){
            const elem = src[srcPos];
            dest[destPos] = zeroMapping ^ -(elem >> 7 & 1) & xorMask;
            dest[destPos + 1] = zeroMapping ^ -(elem >> 6 & 1) & xorMask;
            dest[destPos + 2] = zeroMapping ^ -(elem >> 5 & 1) & xorMask;
            dest[destPos + 3] = zeroMapping ^ -(elem >> 4 & 1) & xorMask;
            dest[destPos + 4] = zeroMapping ^ -(elem >> 3 & 1) & xorMask;
            dest[destPos + 5] = zeroMapping ^ -(elem >> 2 & 1) & xorMask;
            dest[destPos + 6] = zeroMapping ^ -(elem >> 1 & 1) & xorMask;
            dest[destPos + 7] = zeroMapping ^ -(elem & 1) & xorMask;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; ++j, ++destPos)dest[destPos] = zeroMapping ^ -(elem >> 7 - j & 1) & xorMask;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $b3a01b20dd2ade98$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len = width * height * 3;
    const len32 = len >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    const alphaMask = $b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian ? 0xff000000 : 0xff;
    if ($b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | alphaMask;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | alphaMask;
            dest[destPos + 3] = s3 >>> 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | alphaMask;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | alphaMask;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | alphaMask;
            dest[destPos + 3] = s3 << 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | alphaMask;
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function $b3a01b20dd2ade98$var$grayToRGBA(src, dest) {
    if ($b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $b3a01b20dd2ade98$var$MIN_FONT_SIZE = 16;
const $b3a01b20dd2ade98$var$MAX_FONT_SIZE = 100;
const $b3a01b20dd2ade98$var$EXECUTION_TIME = 15;
const $b3a01b20dd2ade98$var$EXECUTION_STEPS = 10;
const $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT = 16;
const $b3a01b20dd2ade98$var$SCALE_MATRIX = new DOMMatrix();
const $b3a01b20dd2ade98$var$XY = new Float32Array(2);
function $b3a01b20dd2ade98$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = ()=>{
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function() {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function() {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function(x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function(x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function(a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function(a, b, c, d, e, f) {
        if (b === undefined) {
            destCtx.setTransform(a);
            this.__originalSetTransform(a);
        } else {
            destCtx.setTransform(a, b, c, d, e, f);
            this.__originalSetTransform(a, b, c, d, e, f);
        }
    };
    ctx.resetTransform = function() {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function(angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function(rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function(x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function(x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function(x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function() {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function() {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
function $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
class $b3a01b20dd2ade98$var$CanvasExtraState {
    alphaIsShape = false;
    fontSize = 0;
    fontSizeScale = 1;
    textMatrix = null;
    textMatrixScale = 1;
    fontMatrix = $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
    leading = 0;
    x = 0;
    y = 0;
    lineX = 0;
    lineY = 0;
    charSpacing = 0;
    wordSpacing = 0;
    textHScale = 1;
    textRenderingMode = $b3a01b20dd2ade98$var$TextRenderingMode.FILL;
    textRise = 0;
    fillColor = "#000000";
    strokeColor = "#000000";
    tilingPatternDims = null;
    patternFill = false;
    patternStroke = false;
    fillAlpha = 1;
    strokeAlpha = 1;
    lineWidth = 1;
    activeSMask = null;
    transferMaps = "none";
    minMax = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
    constructor(width, height){
        this.clipBox = new Float32Array([
            0,
            0,
            width,
            height
        ]);
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        clone.tilingPatternDims = this.tilingPatternDims?.slice();
        return clone;
    }
    getPathBoundingBox(pathType = $b3a01b20dd2ade98$var$PathType.FILL, transform = null) {
        const box = this.minMax.slice();
        if (pathType === $b3a01b20dd2ade98$var$PathType.STROKE) {
            if (!transform) $b3a01b20dd2ade98$var$unreachable("Stroke bounding box must include transform.");
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $b3a01b20dd2ade98$var$XY);
            const xStrokePad = $b3a01b20dd2ade98$var$XY[0] * this.lineWidth / 2;
            const yStrokePad = $b3a01b20dd2ade98$var$XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minMax[0] === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox.set(box, 0);
        this.minMax.set($b3a01b20dd2ade98$var$F32_BBOX_INIT, 0);
    }
    getClippedPathBoundingBox(pathType = $b3a01b20dd2ade98$var$PathType.FILL, transform = null) {
        return $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $b3a01b20dd2ade98$var$putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $b3a01b20dd2ade98$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.RGB_24BPP) {
        thisChunkHeight = $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $b3a01b20dd2ade98$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    }
}
function $b3a01b20dd2ade98$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $b3a01b20dd2ade98$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    const { filter: filter } = ctx;
    if (filter !== "none" && filter !== "") ctx.filter = "none";
}
function $b3a01b20dd2ade98$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $b3a01b20dd2ade98$var$XY);
    const actualScale = Math.fround($b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
    return $b3a01b20dd2ade98$var$XY[0] <= actualScale && $b3a01b20dd2ade98$var$XY[1] <= actualScale;
}
const $b3a01b20dd2ade98$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $b3a01b20dd2ade98$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $b3a01b20dd2ade98$var$NORMAL_CLIP = {};
const $b3a01b20dd2ade98$var$EO_CLIP = {};
class $b3a01b20dd2ade98$var$CanvasGraphics {
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors, dependencyTracker, imagesTracker){
        this.ctx = canvasCtx;
        this.current = new $b3a01b20dd2ade98$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.tempSMask = null;
        this.smaskGroupCanvases = [];
        this.smaskPreparedEntry = null;
        this.smaskPreparedFor = null;
        this.smaskPreparedOffsetX = 0;
        this.smaskPreparedOffsetY = 0;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
        this.dependencyTracker = dependencyTracker ?? null;
        this.imagesTracker = imagesTracker ?? null;
    }
    getObject(opIdx, data, fallback = null) {
        if (typeof data === "string") {
            this.dependencyTracker?.recordNamedDependency(opIdx, data);
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.transparentCanvasEntry = this.canvasFactory.create(width, height);
            this.compositeCtx = this.ctx;
            ({ canvas: this.transparentCanvas, context: this.ctx } = transparentCanvas);
            this.ctx.save();
            this.ctx.transform(...$b3a01b20dd2ade98$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[3];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper, operationsFilter) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $b3a01b20dd2ade98$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $b3a01b20dd2ade98$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId, fnArgs;
        while(true){
            if (stepper !== undefined) {
                if (i === stepper.nextBreakPoint) {
                    stepper.breakIt(i, continueCallback);
                    return i;
                }
                if (stepper.shouldSkip(i)) {
                    if (++i === argsArrayLen) return i;
                    continue;
                }
            }
            if (!operationsFilter || operationsFilter(i)) {
                fnId = fnArray[i];
                fnArgs = argsArray[i] ?? null;
                if (fnId !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.dependency) {
                    if (fnArgs === null) this[fnId](i);
                    else this[fnId](i, ...fnArgs);
                } else for (const depObjId of fnArgs){
                    this.dependencyTracker?.recordNamedData(depObjId, i);
                    const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                    }
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $b3a01b20dd2ade98$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.current.activeSMask = null;
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy(this.transparentCanvasEntry);
            this.transparentCanvas = null;
            this.transparentCanvasEntry = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        for (const canvas of this.smaskGroupCanvases)this.canvasFactory.destroy(canvas);
        this.smaskGroupCanvases.length = 0;
        this._clearPreparedSMask();
        this.tempSMask = null;
        this.smaskStack.length = 0;
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width ?? img.displayWidth;
        const height = img.height ?? img.displayHeight;
        const widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        const heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        const scaleSteps = [];
        let ws = widthScale, hs = heightScale, pw = width, ph = height;
        while(ws > 2 && pw > 1 || hs > 2 && ph > 1){
            let nw = pw, nh = ph;
            if (ws > 2 && pw > 1) {
                nw = Math.ceil(pw / 2);
                ws /= pw / nw;
            }
            if (hs > 2 && ph > 1) {
                nh = Math.ceil(ph / 2);
                hs /= ph / nh;
            }
            scaleSteps.push({
                newWidth: nw,
                newHeight: nh
            });
            pw = nw;
            ph = nh;
        }
        if (scaleSteps.length === 0) return {
            img: img,
            paintWidth: width,
            paintHeight: height,
            tmpCanvas: null
        };
        if (scaleSteps.length === 1) {
            const { newWidth: newWidth, newHeight: newHeight } = scaleSteps[0];
            const tmpCanvas = this.canvasFactory.create(newWidth, newHeight);
            tmpCanvas.context.drawImage(img, 0, 0, width, height, 0, 0, newWidth, newHeight);
            return {
                img: tmpCanvas.canvas,
                paintWidth: newWidth,
                paintHeight: newHeight,
                tmpCanvas: tmpCanvas
            };
        }
        let readEntry = this.canvasFactory.create(1, 1);
        let writeEntry = this.canvasFactory.create(1, 1);
        let paintWidth = width, paintHeight = height;
        let source = img;
        for (const { newWidth: newWidth, newHeight: newHeight } of scaleSteps){
            this.canvasFactory.reset(writeEntry, newWidth, newHeight);
            writeEntry.context.drawImage(source, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            [readEntry, writeEntry] = [
                writeEntry,
                readEntry
            ];
            source = readEntry.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
        }
        this.canvasFactory.destroy(writeEntry);
        return {
            img: readEntry.canvas,
            paintWidth: paintWidth,
            paintHeight: paintHeight,
            tmpCanvas: readEntry
        };
    }
    _createMaskCanvas(opIdx, img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.getOrInsertComputed(mainKey, $b3a01b20dd2ade98$export$b41394a5437791c8);
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.canvasFactory.create(width, height);
            $b3a01b20dd2ade98$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const minMax = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas, minMax);
        const [minX, minY, maxX, maxY] = minMax;
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        let scaledEntry = null;
        if (!scaled) {
            const scaleResult = this._scaleImage(maskCanvas.canvas, $b3a01b20dd2ade98$var$getCurrentTransformInverse(fillCtx));
            scaled = scaleResult.img;
            scaledEntry = scaleResult.tmpCanvas;
            if (scaled !== maskCanvas.canvas) {
                this.canvasFactory.destroy(maskCanvas);
                maskCanvas = null;
            }
            if (cache && isPatternFill) {
                cache.set(cacheKey, scaled);
                scaledEntry = null;
                maskCanvas = null;
            }
        }
        fillCtx.imageSmoothingEnabled = $b3a01b20dd2ade98$var$getImageSmoothingEnabled($b3a01b20dd2ade98$var$getCurrentTransform(fillCtx), img.interpolate);
        $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        if (scaledEntry) this.canvasFactory.destroy(scaledEntry);
        if (maskCanvas) this.canvasFactory.destroy(maskCanvas);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform($b3a01b20dd2ade98$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $b3a01b20dd2ade98$var$PathType.FILL, opIdx) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) cache.set(cacheKey, fillCanvas.canvas);
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
        return {
            canvas: fillCanvas.canvas,
            canvasEntry: cache && !isPatternFill ? null : fillCanvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(opIdx, width) {
        this.dependencyTracker?.recordSimpleData("lineWidth", opIdx);
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineCap", opIdx);
        this.ctx.lineCap = $b3a01b20dd2ade98$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineJoin", opIdx);
        this.ctx.lineJoin = $b3a01b20dd2ade98$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(opIdx, limit) {
        this.dependencyTracker?.recordSimpleData("miterLimit", opIdx);
        this.ctx.miterLimit = limit;
    }
    setDash(opIdx, dashArray, dashPhase) {
        this.dependencyTracker?.recordSimpleData("dash", opIdx);
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(opIdx, intent) {}
    setFlatness(opIdx, flatness) {}
    setGState(opIdx, states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(opIdx, value);
                break;
            case "LC":
                this.setLineCap(opIdx, value);
                break;
            case "LJ":
                this.setLineJoin(opIdx, value);
                break;
            case "ML":
                this.setMiterLimit(opIdx, value);
                break;
            case "D":
                this.setDash(opIdx, value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(opIdx, value);
                break;
            case "FL":
                this.setFlatness(opIdx, value);
                break;
            case "Font":
                this.setFont(opIdx, value[0], value[1]);
                break;
            case "CA":
                this.dependencyTracker?.recordSimpleData("strokeAlpha", opIdx);
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.dependencyTracker?.recordSimpleData("fillAlpha", opIdx);
                this.ctx.globalAlpha = this.current.fillAlpha = value;
                break;
            case "BM":
                this.dependencyTracker?.recordSimpleData("globalCompositeOperation", opIdx);
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.dependencyTracker?.recordSimpleData("SMask", opIdx);
                this.current.activeSMask = value ? this.tempSMask : null;
                if (this.current.activeSMask) this.current.activeSMask.blendMode = this.ctx.globalCompositeOperation;
                this.tempSMask = null;
                this.checkSMaskState(opIdx);
                break;
            case "TR":
                this.dependencyTracker?.recordSimpleData("filter", opIdx);
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    _clearPreparedSMask() {
        if (this.smaskPreparedEntry) {
            this.canvasFactory.destroy(this.smaskPreparedEntry);
            this.smaskPreparedEntry = null;
        }
        this.smaskPreparedFor = null;
        this.smaskPreparedOffsetX = 0;
        this.smaskPreparedOffsetY = 0;
    }
    _ensurePreparedSMask(smask, width, height) {
        if (smask === this.smaskPreparedFor) return;
        this._clearPreparedSMask();
        this._prepareSMaskCanvas(smask, width, height);
    }
    checkSMaskState(opIdx) {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode(opIdx);
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
        else if (this.current.activeSMask && inSMaskMode) this._ensurePreparedSMask(this.current.activeSMask, this.ctx.canvas.width, this.ctx.canvas.height);
    }
    _prepareSMaskCanvas(smask, width, height) {
        const { canvas: maskCanvas, subtype: subtype, backdrop: backdrop, transferMap: transferMap } = smask;
        const hasFilter = subtype === "Luminosity" || subtype === "Alpha" && transferMap;
        if (!backdrop && !hasFilter) {
            this.smaskPreparedFor = smask;
            return;
        }
        let preparedEntry, offsetX, offsetY;
        if (backdrop && hasFilter) {
            const srcEntry = this.canvasFactory.create(width, height);
            const sCtx = srcEntry.context;
            sCtx.drawImage(maskCanvas, smask.offsetX, smask.offsetY);
            sCtx.globalCompositeOperation = "destination-atop";
            sCtx.fillStyle = backdrop;
            sCtx.fillRect(0, 0, width, height);
            sCtx.globalCompositeOperation = "source-over";
            preparedEntry = this.canvasFactory.create(width, height);
            const pCtx = preparedEntry.context;
            pCtx.filter = subtype === "Alpha" ? this.filterFactory.addAlphaFilter(transferMap) : this.filterFactory.addLuminosityFilter(transferMap);
            pCtx.drawImage(srcEntry.canvas, 0, 0);
            pCtx.filter = "none";
            this.canvasFactory.destroy(srcEntry);
            offsetX = offsetY = 0;
        } else if (hasFilter) {
            preparedEntry = this.canvasFactory.create(maskCanvas.width, maskCanvas.height);
            const pCtx = preparedEntry.context;
            pCtx.filter = subtype === "Alpha" ? this.filterFactory.addAlphaFilter(transferMap) : this.filterFactory.addLuminosityFilter(transferMap);
            pCtx.drawImage(maskCanvas, 0, 0);
            pCtx.filter = "none";
            ({ offsetX: offsetX, offsetY: offsetY } = smask);
        } else {
            preparedEntry = this.canvasFactory.create(width, height);
            const pCtx = preparedEntry.context;
            pCtx.drawImage(maskCanvas, smask.offsetX, smask.offsetY);
            pCtx.globalCompositeOperation = "destination-atop";
            pCtx.fillStyle = backdrop;
            pCtx.fillRect(0, 0, width, height);
            pCtx.globalCompositeOperation = "source-over";
            offsetX = offsetY = 0;
        }
        this.smaskPreparedEntry = preparedEntry;
        this.smaskPreparedFor = smask;
        this.smaskPreparedOffsetX = offsetX;
        this.smaskPreparedOffsetY = offsetY;
    }
    beginSMaskMode(opIdx) {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const { width: drawnWidth, height: drawnHeight } = this.ctx.canvas;
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        this.smaskScratchCanvas = scratchCanvas;
        this.suspendedCtx = this.ctx;
        const ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        $b3a01b20dd2ade98$var$copyCtxState(this.suspendedCtx, ctx);
        $b3a01b20dd2ade98$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this._ensurePreparedSMask(this.current.activeSMask, drawnWidth, drawnHeight);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $b3a01b20dd2ade98$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
        this.canvasFactory.destroy(this.smaskScratchCanvas);
        this.smaskScratchCanvas = null;
        this._clearPreparedSMask();
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        if (!dirtyBox) dirtyBox = [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(dirtyBox[0], dirtyBox[1], dirtyBox[2] - dirtyBox[0], dirtyBox[3] - dirtyBox[1]);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        const preparedEntry = this.smaskPreparedEntry;
        if (preparedEntry) {
            const srcX = layerOffsetX - this.smaskPreparedOffsetX;
            const srcY = layerOffsetY - this.smaskPreparedOffsetY;
            layerCtx.save();
            layerCtx.globalAlpha = 1;
            layerCtx.setTransform(1, 0, 0, 1, 0, 0);
            const clip = new Path2D();
            clip.rect(layerOffsetX, layerOffsetY, layerWidth, layerHeight);
            layerCtx.clip(clip);
            layerCtx.globalCompositeOperation = "destination-in";
            layerCtx.drawImage(preparedEntry.canvas, srcX, srcY, layerWidth, layerHeight, layerOffsetX, layerOffsetY, layerWidth, layerHeight);
            layerCtx.restore();
        } else this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = smask.blendMode || "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, layerOffsetX, layerOffsetY, layerWidth, layerHeight, layerOffsetX, layerOffsetY, layerWidth, layerHeight);
        ctx.restore();
    }
    genericComposeSMask(maskCtx, layerCtx, width, height, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        const maskCanvas = maskCtx.canvas;
        const maskX = layerOffsetX - maskOffsetX;
        const maskY = layerOffsetY - maskOffsetY;
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    }
    save(opIdx) {
        if (this.inSMaskMode) $b3a01b20dd2ade98$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
        this.dependencyTracker?.save(opIdx);
    }
    restore(opIdx) {
        this.dependencyTracker?.restore(opIdx);
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) this.endSMaskMode();
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) {
            $b3a01b20dd2ade98$var$copyCtxState(this.suspendedCtx, this.ctx);
            this.ctx.setTransform(this.suspendedCtx.getTransform());
        }
        this.checkSMaskState(opIdx);
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    transform(opIdx, a, b, c, d, e, f) {
        this.dependencyTracker?.recordIncrementalData("transform", opIdx);
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(opIdx, op, data, minMax) {
        let [path] = data;
        if (!minMax) {
            path ||= data[0] = new Path2D();
            if (op !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.stroke && op !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.closeStroke) this.current.tilingPatternDims = null;
            this[op](opIdx, path);
            return;
        }
        if (this.dependencyTracker !== null) {
            const outerExtraSize = op === $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.stroke ? this.current.lineWidth / 2 : 0;
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, this.ctx, minMax[0] - outerExtraSize, minMax[2] + outerExtraSize, minMax[1] - outerExtraSize, minMax[3] + outerExtraSize).recordDependencies(opIdx, [
                "transform"
            ]);
        }
        if (!(path instanceof Path2D)) path = data[0] = $b3a01b20dd2ade98$var$makePathFromDrawOPS(path);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(minMax, $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx), this.current.minMax);
        const tilingDims = this.current.tilingPatternDims;
        if (tilingDims && op !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.stroke && op !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.closeStroke && this.current.fillColor instanceof $b3a01b20dd2ade98$var$TilingPattern) {
            const clippedBBox = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.current.clipBox, this.current.minMax);
            if (!clippedBBox) this.current.tilingPatternDims = null;
            else this.current.fillColor.updatePatternDims(clippedBBox, tilingDims);
        }
        this[op](opIdx, path);
        this._pathStartIdx = opIdx;
    }
    closePath(opIdx) {
        this.ctx.closePath();
    }
    stroke(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                const baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.STROKE, opIdx);
                if (baseTransform) {
                    const newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            } else this.rescaleAndStroke(path, true);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.stroke);
        if (consumePath) this.consumePath(opIdx, path, this.current.getClippedPathBoundingBox($b3a01b20dd2ade98$var$PathType.STROKE, $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx)));
        ctx.globalAlpha = this.current.fillAlpha;
    }
    closeStroke(opIdx, path) {
        this.stroke(opIdx, path);
    }
    fill(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        const intersect = this.current.getClippedPathBoundingBox();
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill);
        if (isPatternFill) {
            const dims = this.current.tilingPatternDims;
            const tileIdx = dims && fillColor.canSkipPatternCanvas(dims);
            if (tileIdx) {
                fillColor.drawPattern(this, path, this.pendingEOFill, tileIdx, opIdx);
                this.pendingEOFill = false;
                if (consumePath) this.consumePath(opIdx, path, intersect);
                this.current.tilingPatternDims = null;
                return;
            }
            const baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            this.dependencyTracker?.save(opIdx);
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx);
            if (baseTransform) {
                const newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            } else ctx.fill(path);
        }
        if (needRestore) {
            ctx.restore();
            this.dependencyTracker?.restore(opIdx);
        }
        if (consumePath) this.consumePath(opIdx, path, intersect);
    }
    eoFill(opIdx, path) {
        this.pendingEOFill = true;
        this.fill(opIdx, path);
    }
    fillStroke(opIdx, path) {
        this.fill(opIdx, path, false);
        this.stroke(opIdx, path, false);
        this.consumePath(opIdx, path);
    }
    eoFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    closeFillStroke(opIdx, path) {
        this.fillStroke(opIdx, path);
    }
    closeEOFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    endPath(opIdx, path) {
        this.consumePath(opIdx, path);
    }
    rawFillPath(opIdx, path) {
        this.ctx.fill(path);
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.rawFillPath).recordOperation(opIdx);
    }
    clip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $b3a01b20dd2ade98$var$NORMAL_CLIP;
    }
    eoClip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $b3a01b20dd2ade98$var$EO_CLIP;
    }
    beginText(opIdx) {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.dependencyTracker?.recordOpenMarker(opIdx).resetIncrementalData("sameLineText").resetIncrementalData("moveText", opIdx);
    }
    endText(opIdx) {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (this.dependencyTracker) {
            const { dependencyTracker: dependencyTracker } = this;
            if (paths !== undefined) dependencyTracker.recordFutureForcedDependency("textClip", dependencyTracker.getOpenMarker()).recordFutureForcedDependency("textClip", opIdx);
            dependencyTracker.recordCloseMarker(opIdx);
        }
        if (paths !== undefined) {
            const newPath = new Path2D();
            const invTransf = ctx.getTransform().invertSelf();
            for (const { transform: transform, x: x, y: y, fontSize: fontSize, path: path } of paths){
                if (!path) continue;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
            ctx.clip(newPath);
        }
        delete this.pendingTextPaths;
    }
    setCharSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("charSpacing", opIdx);
        this.current.charSpacing = spacing;
    }
    setWordSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("wordSpacing", opIdx);
        this.current.wordSpacing = spacing;
    }
    setHScale(opIdx, scale) {
        this.dependencyTracker?.recordSimpleData("hScale", opIdx);
        this.current.textHScale = scale / 100;
    }
    setLeading(opIdx, leading) {
        this.dependencyTracker?.recordSimpleData("leading", opIdx);
        this.current.leading = -leading;
    }
    setFont(opIdx, fontRefName, size) {
        this.dependencyTracker?.recordSimpleData("font", opIdx).recordSimpleDataFromNamed("fontObj", fontRefName, opIdx);
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $b3a01b20dd2ade98$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $b3a01b20dd2ade98$var$MIN_FONT_SIZE) browserFontSize = $b3a01b20dd2ade98$var$MIN_FONT_SIZE;
        else if (size > $b3a01b20dd2ade98$var$MAX_FONT_SIZE) browserFontSize = $b3a01b20dd2ade98$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(opIdx, mode) {
        this.dependencyTracker?.recordSimpleData("textRenderingMode", opIdx);
        this.current.textRenderingMode = mode;
    }
    setTextRise(opIdx, rise) {
        this.dependencyTracker?.recordSimpleData("textRise", opIdx);
        this.current.textRise = rise;
    }
    moveText(opIdx, x, y) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordIncrementalData("moveText", opIdx);
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(opIdx, x, y) {
        this.setLeading(opIdx, -y);
        this.moveText(opIdx, x, y);
    }
    setTextMatrix(opIdx, matrix) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordSimpleData("textMatrix", opIdx);
        const { current: current } = this;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    }
    nextLine(opIdx) {
        this.moveText(opIdx, 0, this.current.leading);
        this.dependencyTracker?.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? opIdx);
    }
    #getScaledPath(path, currentTransform, transform) {
        const newPath = new Path2D();
        newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
        return newPath;
    }
    paintChar(opIdx, character, x, y, patternFillTransform, patternStrokeTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        const patternStroke = current.patternStroke && !font.missingFile;
        let path;
        if ((font.disableFontFace || isAddToPathSet || patternFill || patternStroke) && !font.missingFile) path = font.getPathGenerator(this.commonObjs, character);
        if (path && (font.disableFontFace || patternFill || patternStroke)) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font);
            let currentTransform;
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform(...patternFillTransform);
                    const scaledPath = this.#getScaledPath(path, currentTransform, patternFillTransform);
                    ctx.fill(scaledPath);
                } else ctx.fill(path);
            }
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform ||= ctx.getTransform();
                    ctx.setTransform(...patternStrokeTransform);
                    const { a: a, b: b, c: c, d: d } = currentTransform;
                    const invPatternTransform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.inverseTransform(patternStrokeTransform);
                    const transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform([
                        a,
                        b,
                        c,
                        d,
                        0,
                        0
                    ], invPatternTransform);
                    $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transf, $b3a01b20dd2ade98$var$XY);
                    ctx.lineWidth *= Math.max($b3a01b20dd2ade98$var$XY[0], $b3a01b20dd2ade98$var$XY[1]) / fontSize;
                    ctx.stroke(this.#getScaledPath(path, currentTransform, patternStrokeTransform));
                } else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        } else {
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
                this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character));
            }
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (this.dependencyTracker) this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character)).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.stroke);
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $b3a01b20dd2ade98$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y);
        }
    }
    get isFontSubpixelAAEnabled() {
        const tmpCanvas = this.canvasFactory.create(10, 10);
        const ctx = tmpCanvas.context;
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        this.canvasFactory.destroy(tmpCanvas);
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(opIdx, glyphs) {
        if (this.dependencyTracker) {
            this.dependencyTracker.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.showText).resetBBox(opIdx);
            if (this.current.textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.ADD_TO_PATH_FLAG) this.dependencyTracker.recordFutureForcedDependency("textClip", opIdx).inheritPendingDependenciesAsFutureForcedDependencies();
        }
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) {
            this.showType3Text(opIdx, glyphs);
            this.dependencyTracker?.recordShowTextOperation(opIdx);
            return undefined;
        }
        const fontSize = current.fontSize;
        if (fontSize === 0) {
            this.dependencyTracker?.recordOperation(opIdx);
            return undefined;
        }
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternFillTransform, patternStrokeTransform;
        const fillStrokeMode = current.textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE_MASK;
        const needsFill = fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE;
        const needsStroke = fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE;
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            if (needsStroke) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (needsFill && current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx);
            patternFillTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (needsStroke && current.patternStroke) {
            ctx.save();
            const pattern = current.strokeColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.STROKE, opIdx);
            patternStrokeTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            const joinedChars = chars.join("");
            ctx.fillText(joinedChars, 0, 0);
            if (this.dependencyTracker !== null) {
                const measure = ctx.measureText(joinedChars);
                this.dependencyTracker.recordBBox(opIdx, this.ctx, -measure.actualBoundingBoxLeft, measure.actualBoundingBoxRight, -measure.actualBoundingBoxAscent, measure.actualBoundingBoxDescent).recordShowTextOperation(opIdx);
            }
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            let measure;
            if (font.remeasure && width > 0) {
                measure = ctx.measureText(character);
                const measuredWidth = measure.width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                    this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, measure ? {
                        bbox: null
                    } : font, fontSize / fontSizeScale, scaledX, scaledY, ()=>measure ?? ctx.measureText(character));
                } else {
                    this.paintChar(opIdx, character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(opIdx, accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordShowTextOperation(opIdx);
        return undefined;
    }
    showType3Text(opIdx, glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $b3a01b20dd2ade98$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        const dependencyTracker = this.dependencyTracker;
        this.dependencyTracker = dependencyTracker ? new $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx) : null;
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) $b3a01b20dd2ade98$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const p = [
                glyph.width,
                0
            ];
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        if (dependencyTracker) this.dependencyTracker = dependencyTracker;
    }
    setCharWidth(opIdx, xWidth, yWidth) {}
    setCharWidthAndBounds(opIdx, xWidth, yWidth, llx, lly, urx, ury) {
        const clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.dependencyTracker?.recordBBox(opIdx, this.ctx, llx, urx, lly, ury).recordClipBox(opIdx, this.ctx, llx, urx, lly, ury);
        this.endPath(opIdx);
    }
    getColorN_Pattern(opIdx, IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const baseTransform = this.baseTransform || $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx, renderingOpIdx)=>new $b3a01b20dd2ade98$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    }, undefined, undefined, this.dependencyTracker ? new $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker(this.dependencyTracker, renderingOpIdx, true) : null)
            };
            pattern = new $b3a01b20dd2ade98$var$TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(opIdx, IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.current.strokeColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternStroke = true;
    }
    setFillColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        const pattern = this.current.fillColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternFill = true;
        this.current.tilingPatternDims = pattern instanceof $b3a01b20dd2ade98$var$TilingPattern ? [
            0,
            0,
            0,
            0
        ] : null;
    }
    setStrokeRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = color;
        this.current.patternStroke = false;
    }
    setStrokeTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    }
    setFillRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = color;
        this.current.patternFill = false;
        this.current.tilingPatternDims = null;
    }
    setFillTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
        this.current.tilingPatternDims = null;
    }
    _getPattern(opIdx, objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $b3a01b20dd2ade98$var$getShadingPattern(this.getObject(opIdx, objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(opIdx, objId) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        this.save(opIdx);
        const pattern = this._getPattern(opIdx, objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.SHADING, opIdx);
        const inv = $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const minMax = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv, minMax);
            const [x0, y0, x1, y1] = minMax;
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.dependencyTracker?.resetBBox(opIdx).recordFullPageBBox(opIdx).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transform).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill).recordOperation(opIdx);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore(opIdx);
    }
    beginInlineImage() {
        $b3a01b20dd2ade98$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $b3a01b20dd2ade98$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(opIdx, matrix, bbox) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(opIdx, ...matrix);
        this.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
        if (bbox) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            const [x0, y0, x1, y1] = bbox;
            const clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.dependencyTracker?.recordClipBox(opIdx, this.ctx, x0, x1, y0, y1);
            this.endPath(opIdx);
        }
    }
    paintFormXObjectEnd(opIdx) {
        if (!this.contentVisible) return;
        this.restore(opIdx);
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        const { inSMaskMode: inSMaskMode } = this;
        if (inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated) $b3a01b20dd2ade98$var$info("TODO: Support non-isolated groups.");
        if (group.knockout) $b3a01b20dd2ade98$var$warn("Knockout groups not supported.");
        if (!group.needsIsolation && currentCtx.globalAlpha === 1 && currentCtx.globalCompositeOperation === "source-over" && !inSMaskMode) {
            if (group.bbox) {
                let clip = new Path2D();
                const [x0, y0, x1, y1] = group.bbox;
                clip.rect(x0, y0, x1 - x0, y1 - y0);
                if (group.matrix) {
                    const path = new Path2D();
                    path.addPath(clip, new DOMMatrix(group.matrix));
                    clip = path;
                }
                currentCtx.clip(clip);
            }
            this.groupStack.push(null);
            this.groupLevel++;
            return;
        }
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        let bounds;
        if (group.bbox) {
            bounds = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(group.bbox, $b3a01b20dd2ade98$var$getCurrentTransform(currentCtx), bounds);
            bounds = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(bounds, canvasBounds) || [
                0,
                0,
                0,
                0
            ];
        } else bounds = canvasBounds;
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        if (group.smask) this.smaskGroupCanvases.push(scratchCanvas);
        const groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        if (!group.isolated && !group.smask && inSMaskMode && group.needsIsolation) {
            groupCtx.save();
            groupCtx.setTransform(1, 0, 0, 1, 0, 0);
            groupCtx.drawImage(currentCtx.canvas, -offsetX, -offsetY);
            groupCtx.restore();
        }
        if (group.bbox) {
            let clip = new Path2D();
            const [x0, y0, x1, y1] = group.bbox;
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            if (group.matrix) {
                const path = new Path2D();
                path.addPath(clip, new DOMMatrix(group.matrix));
                clip = path;
            }
            groupCtx.clip(clip);
        }
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null
        });
        if (!group.smask || this.dependencyTracker) {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $b3a01b20dd2ade98$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.dependencyTracker?.inheritSimpleDataAsFutureForcedDependencies([
            "fillAlpha",
            "strokeAlpha",
            "globalCompositeOperation"
        ]).pushBaseTransform(currentCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ],
            [
                "TR",
                null
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    }
    endGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        if (ctx === null) {
            this.restore(opIdx);
            return;
        }
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        this.dependencyTracker?.popBaseTransform();
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore(opIdx);
            if (this.dependencyTracker) {
                this.ctx.restore();
                if (this.inSMaskMode) this.ctx.setTransform(this.suspendedCtx.getTransform());
            }
        } else {
            this.ctx.restore();
            const currentMtx = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            this.restore(opIdx);
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx, dirtyBox);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy({
                canvas: groupCtx.canvas,
                context: groupCtx
            });
            this.compose(dirtyBox);
        }
    }
    beginAnnotation(opIdx, id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save(opIdx);
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($b3a01b20dd2ade98$var$getCurrentTransform(this.ctx), $b3a01b20dd2ade98$var$XY);
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform($b3a01b20dd2ade98$var$XY[0], 0, 0, -$b3a01b20dd2ade98$var$XY[1], 0, height * $b3a01b20dd2ade98$var$XY[1]);
                $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
            } else {
                $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
                this.endPath(opIdx);
                const clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new $b3a01b20dd2ade98$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.baseTransformStack.push(this.baseTransform);
        this.transform(opIdx, ...transform);
        this.transform(opIdx, ...matrix);
        this.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
    }
    endAnnotation(opIdx) {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
        this.baseTransform = this.baseTransformStack.pop();
    }
    paintImageMaskXObject(opIdx, img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(opIdx, img.data, img);
        img.count = count;
        const ctx = this.ctx;
        const mask = this._createMaskCanvas(opIdx, img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, mask.offsetX, mask.offsetX + maskCanvas.width, mask.offsetY, mask.offsetY + maskCanvas.height).recordOperation(opIdx);
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
    }
    paintImageMaskXObjectRepeat(opIdx, img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(opIdx, img.data, img);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(opIdx, img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        this.dependencyTracker?.resetBBox(opIdx);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
            this.dependencyTracker?.recordBBox(opIdx, this.ctx, trans[4], trans[4] + mask.canvas.width, trans[5], trans[5] + mask.canvas.height);
        }
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageMaskXObjectGroup(opIdx, images) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        this.dependencyTracker?.resetBBox(opIdx).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.canvasFactory.create(width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(opIdx, data, image);
            $b3a01b20dd2ade98$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            this.canvasFactory.destroy(maskCanvas);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, width, 0, height);
            ctx.restore();
        }
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageXObject(opIdx, objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $b3a01b20dd2ade98$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(opIdx, imgData);
    }
    paintImageXObjectRepeat(opIdx, objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $b3a01b20dd2ade98$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(opIdx, imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return {
            img: imgData.bitmap,
            canvasEntry: null
        };
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.canvasFactory.create(width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return {
            img: tmpCanvas.canvas,
            canvasEntry: tmpCanvas
        };
    }
    paintInlineImageXObject(opIdx, imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const ctx = this.ctx;
        this.save(opIdx);
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) {
            const result = this.applyTransferMapsToBitmap(imgData);
            imgToPaint = result.img;
            inlineImgCanvas = result.canvasEntry;
        } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.canvasFactory.create(width, height);
            $b3a01b20dd2ade98$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        const scaled = this._scaleImage(imgToPaint, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $b3a01b20dd2ade98$var$getImageSmoothingEnabled($b3a01b20dd2ade98$var$getCurrentTransform(ctx), imgData.interpolate);
        if (this.dependencyTracker) {
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, ctx, 0, width, -height, 0).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.imageXObject).recordOperation(opIdx);
            this.imagesTracker?.record(ctx, width, height, this.dependencyTracker.clipBox);
        }
        $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        if (scaled.tmpCanvas) this.canvasFactory.destroy(scaled.tmpCanvas);
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.compose();
        this.restore(opIdx);
    }
    paintInlineImageXObjectGroup(opIdx, imgData, map) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.canvasFactory.create(w, h);
            $b3a01b20dd2ade98$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        this.dependencyTracker?.resetBBox(opIdx);
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, 1, -1, 0);
            ctx.restore();
        }
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.dependencyTracker?.recordOperation(opIdx);
        this.compose();
    }
    paintSolidColorImageMask(opIdx) {
        if (!this.contentVisible) return;
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, 0, 1, 0, 1).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill).recordOperation(opIdx);
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    }
    markPoint(opIdx, tag) {}
    markPointProps(opIdx, tag, properties) {}
    beginMarkedContent(opIdx, tag) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(opIdx, tag, properties) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent(opIdx) {
        this.dependencyTracker?.endMarkedContent(opIdx);
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat(opIdx) {}
    endCompat(opIdx) {}
    consumePath(opIdx, path, clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $b3a01b20dd2ade98$var$EO_CLIP) ctx.clip(path, "evenodd");
                else ctx.clip(path);
            }
            this.pendingClip = null;
            this.dependencyTracker?.bboxToClipBoxDropOperation(opIdx).recordFutureForcedDependency("clipPath", opIdx);
        } else this.dependencyTracker?.recordOperation(opIdx);
        this.current.startNewPathAndClipBox(this.current.clipBox);
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(path, saveRestore) {
        const { ctx: ctx, current: { lineWidth: lineWidth } } = this;
        const [scaleX, scaleY] = this.getScaleForStroking();
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        $b3a01b20dd2ade98$var$SCALE_MATRIX.a = 1 / scaleX;
        $b3a01b20dd2ade98$var$SCALE_MATRIX.d = 1 / scaleY;
        const newPath = new Path2D();
        newPath.addPath(path, $b3a01b20dd2ade98$var$SCALE_MATRIX);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b)if ($b3a01b20dd2ade98$var$CanvasGraphics.prototype[op] !== undefined) $b3a01b20dd2ade98$var$CanvasGraphics.prototype[$b3a01b20dd2ade98$export$3a0f7f7a8a0b306b[op]] = $b3a01b20dd2ade98$var$CanvasGraphics.prototype[op];
class $b3a01b20dd2ade98$var$BasePDFStream {
    #PDFStreamReader = null;
    #PDFStreamRangeReader = null;
    _fullReader = null;
    _rangeReaders = new Set();
    _source = null;
    constructor(source, PDFStreamReader, PDFStreamRangeReader){
        this._source = source;
        this.#PDFStreamReader = PDFStreamReader;
        this.#PDFStreamRangeReader = PDFStreamRangeReader;
    }
    get _progressiveDataLength() {
        return this._fullReader?._loaded ?? 0;
    }
    getFullReader() {
        $b3a01b20dd2ade98$var$assert(!this._fullReader, "BasePDFStream.getFullReader can only be called once.");
        return this._fullReader = new this.#PDFStreamReader(this);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new this.#PDFStreamRangeReader(this, begin, end);
        this._rangeReaders.add(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullReader?.cancel(reason);
        for (const reader of new Set(this._rangeReaders))reader.cancel(reason);
    }
}
class $b3a01b20dd2ade98$var$BasePDFStreamReader {
    onProgress = null;
    _contentLength = 0;
    _filename = null;
    _headersCapability = Promise.withResolvers();
    _isRangeSupported = false;
    _isStreamingSupported = false;
    _loaded = 0;
    _stream = null;
    constructor(stream){
        this._stream = stream;
    }
    _callOnProgress() {
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `cancel` called");
    }
}
class $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _stream = null;
    constructor(stream, begin, end){
        this._stream = stream;
    }
    async read() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `cancel` called");
    }
}
function $b3a01b20dd2ade98$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $b3a01b20dd2ade98$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $b3a01b20dd2ade98$var$createHeaders(isHttp, httpHeaders) {
    const headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") return headers;
    for(const key in httpHeaders){
        const val = httpHeaders[key];
        if (val !== undefined) headers.append(key, val);
    }
    return headers;
}
function $b3a01b20dd2ade98$var$getResponseOrigin(url) {
    return URL.parse(url)?.origin ?? null;
}
function $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({ responseHeaders: responseHeaders, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const rv = {
        contentLength: 0,
        isRangeSupported: false
    };
    const length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) return rv;
    rv.contentLength = length;
    if (length <= 2 * rangeChunkSize) return rv;
    if (disableRange || !isHttp) return rv;
    if (responseHeaders.get("Accept-Ranges") !== "bytes") return rv;
    const contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding === "identity") rv.isRangeSupported = true;
    return rv;
}
function $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders) {
    const contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        let filename = $b3a01b20dd2ade98$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($b3a01b20dd2ade98$export$61b52d3570d24719(filename)) return filename;
    }
    return null;
}
function $b3a01b20dd2ade98$var$createResponseError(status, url) {
    return new $b3a01b20dd2ade98$export$ea8e9c34f66e603(`Unexpected server response (${status}) while retrieving PDF "${url.href}".`, status, status === 404 || status === 0 && url.protocol === "file:");
}
function $b3a01b20dd2ade98$var$ensureResponseOrigin(rangeOrigin, origin) {
    if (rangeOrigin !== origin) throw new Error(`Expected range response-origin "${rangeOrigin}" to match "${origin}".`);
}
function $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, abortController) {
    return fetch(url, {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    });
}
function $b3a01b20dd2ade98$var$ensureResponseStatus(status, url) {
    if (status !== 200 && status !== 206) throw $b3a01b20dd2ade98$var$createResponseError(status, url);
}
function $b3a01b20dd2ade98$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    throw new Error(`getArrayBuffer - unexpected data: ${val}`);
}
class $b3a01b20dd2ade98$var$PDFFetchStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    _responseOrigin = null;
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFFetchStreamReader, $b3a01b20dd2ade98$var$PDFFetchStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        $b3a01b20dd2ade98$var$assert(/https?:/.test(url.protocol), "PDFFetchStream only supports http(s):// URLs.");
        this.headers = $b3a01b20dd2ade98$var$createHeaders(true, httpHeaders);
    }
}
class $b3a01b20dd2ade98$var$PDFFetchStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    _abortController = new AbortController();
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url, withCredentials: withCredentials } = stream._source;
        this._isStreamingSupported = !disableStream;
        const headers = new Headers(stream.headers);
        $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            stream._responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(response.url);
            $b3a01b20dd2ade98$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            const responseHeaders = response.headers;
            const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: true,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange
            });
            this._contentLength = contentLength;
            this._isRangeSupported = isRangeSupported;
            this._filename = $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch(this._headersCapability.reject);
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $b3a01b20dd2ade98$var$PDFFetchStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _abortController = new AbortController();
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url, withCredentials: withCredentials } = stream._source;
        const headers = new Headers(stream.headers);
        headers.append("Range", `bytes=${begin}-${end - 1}`);
        $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            const responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(response.url);
            $b3a01b20dd2ade98$var$ensureResponseOrigin(responseOrigin, stream._responseOrigin);
            $b3a01b20dd2ade98$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            this._readCapability.resolve();
        }).catch(this._readCapability.reject);
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
function $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(val) {
    return val instanceof Uint8Array && val.byteLength === val.buffer.byteLength ? val.buffer : new Uint8Array(val).buffer;
}
function $b3a01b20dd2ade98$var$endRequests() {
    for (const capability of this._requests)capability.resolve({
        value: undefined,
        done: true
    });
    this._requests.length = 0;
}
class $b3a01b20dd2ade98$var$PDFDataTransportStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    _progressiveDone = false;
    _queuedChunks = [];
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFDataTransportStreamReader, $b3a01b20dd2ade98$var$PDFDataTransportStreamRangeReader);
        const { pdfDataRangeTransport: pdfDataRangeTransport } = source;
        const { initialData: initialData, progressiveDone: progressiveDone } = pdfDataRangeTransport;
        if (initialData?.length > 0) {
            const buffer = $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(initialData);
            this._queuedChunks.push(buffer);
        }
        this._progressiveDone = progressiveDone;
        const listener = (args)=>{
            switch(args.type){
                case "range":
                case "progressiveRead":
                    this.#onReceiveData(args.begin, args.chunk);
                    break;
                case "progressiveDone":
                    this._fullReader?.progressiveDone();
                    this._progressiveDone = true;
                    break;
            }
        };
        pdfDataRangeTransport.transportReady(listener);
    }
    #onReceiveData(begin, chunk) {
        const buffer = $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(chunk);
        if (begin === undefined) {
            if (this._fullReader) this._fullReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const rangeReader = this._rangeReaders.keys().find((r)=>r._begin === begin);
            $b3a01b20dd2ade98$var$assert(rangeReader, "#onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
            rangeReader._enqueue(buffer);
        }
    }
    getFullReader() {
        const reader = super.getFullReader();
        this._queuedChunks = null;
        return reader;
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) {
            reader.onDone = ()=>this._rangeReaders.delete(reader);
            this._source.pdfDataRangeTransport.requestDataRange(begin, end);
        }
        return reader;
    }
    cancelAllRequests(reason) {
        super.cancelAllRequests(reason);
        this._source.pdfDataRangeTransport.abort();
    }
}
class $b3a01b20dd2ade98$var$PDFDataTransportStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    _done = false;
    _queuedChunks = null;
    _requests = [];
    constructor(stream){
        super(stream);
        const { pdfDataRangeTransport: pdfDataRangeTransport, disableRange: disableRange, disableStream: disableStream } = stream._source;
        const { length: length, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = stream._queuedChunks || [];
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._done = stream._progressiveDone;
        this._contentLength = length;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        if ($b3a01b20dd2ade98$export$61b52d3570d24719(contentDispositionFilename)) this._filename = contentDispositionFilename;
        this._headersCapability.resolve();
        const loaded = this._loaded;
        Promise.resolve().then(()=>{
            if (loaded > 0 && this._loaded === loaded) this._callOnProgress();
        });
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
        this._callOnProgress();
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
    }
    progressiveDone() {
        this._done ||= true;
        if (this._queuedChunks.length === 0) this.#endRequests();
    }
}
class $b3a01b20dd2ade98$var$PDFDataTransportStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    onDone = null;
    _begin = -1;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._begin = begin;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
            this.#endRequests();
        }
        this._done = true;
        this.onDone?.();
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this.onDone?.();
    }
}
const $b3a01b20dd2ade98$var$OK_RESPONSE = 200;
const $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE = 206;
function $b3a01b20dd2ade98$var$network_getArrayBuffer(val) {
    return typeof val !== "string" ? val : $b3a01b20dd2ade98$var$stringToBytes(val).buffer;
}
class $b3a01b20dd2ade98$var$PDFNetworkStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    #pendingRequests = new WeakMap();
    _responseOrigin = null;
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFNetworkStreamReader, $b3a01b20dd2ade98$var$PDFNetworkStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        this.url = url;
        this.isHttp = /https?:/.test(url.protocol);
        this.headers = $b3a01b20dd2ade98$var$createHeaders(this.isHttp, httpHeaders);
    }
    _request(args) {
        const xhr = new XMLHttpRequest();
        const pendingRequest = {
            validateStatus: null,
            onHeadersReceived: args.onHeadersReceived,
            onDone: args.onDone,
            onError: args.onError,
            onProgress: args.onProgress
        };
        this.#pendingRequests.set(xhr, pendingRequest);
        xhr.open("GET", this.url);
        xhr.withCredentials = this._source.withCredentials;
        for (const [key, val] of this.headers)xhr.setRequestHeader(key, val);
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.validateStatus = (status)=>status === $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE || status === $b3a01b20dd2ade98$var$OK_RESPONSE;
        } else pendingRequest.validateStatus = (status)=>status === $b3a01b20dd2ade98$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        $b3a01b20dd2ade98$var$assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = ()=>args.onError(xhr.status);
        xhr.onreadystatechange = this.#onStateChange.bind(this, xhr);
        xhr.onprogress = this.#onProgress.bind(this, xhr);
        xhr.send(null);
        return xhr;
    }
    #onProgress(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        pendingRequest?.onProgress?.(evt);
    }
    #onStateChange(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        if (!pendingRequest) return;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!this.#pendingRequests.has(xhr)) return;
        this.#pendingRequests.delete(xhr);
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $b3a01b20dd2ade98$var$OK_RESPONSE;
        if (!pendingRequest.validateStatus(xhrStatus)) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const chunk = $b3a01b20dd2ade98$var$network_getArrayBuffer(xhr.response);
        if (xhrStatus === $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            if (/bytes (\d+)-(\d+)\/(\d+)/.test(rangeHeader)) pendingRequest.onDone(chunk);
            else {
                $b3a01b20dd2ade98$var$warn(`Missing or invalid "Content-Range" header.`);
                pendingRequest.onError(0);
            }
        } else if (chunk) pendingRequest.onDone(chunk);
        else pendingRequest.onError(xhr.status);
    }
    _abortRequest(xhr) {
        if (this.#pendingRequests.has(xhr)) {
            this.#pendingRequests.delete(xhr);
            xhr.abort();
        }
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) reader.onClosed = ()=>this._rangeReaders.delete(reader);
        return reader;
    }
}
class $b3a01b20dd2ade98$var$PDFNetworkStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    _cachedChunks = [];
    _done = false;
    _requests = [];
    _storedError = null;
    constructor(stream){
        super(stream);
        this._fullRequestXhr = stream._request({
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: this.#onProgress.bind(this)
        });
    }
    #onHeadersReceived() {
        const stream = this._stream;
        const { disableRange: disableRange, rangeChunkSize: rangeChunkSize } = stream._source;
        const fullRequestXhr = this._fullRequestXhr;
        stream._responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(fullRequestXhr.responseURL);
        const rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        const responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((x)=>{
            const [key, ...val] = x.split(": ");
            return [
                key,
                val.join(": ")
            ];
        }) : []);
        const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: stream.isHttp,
            rangeChunkSize: rangeChunkSize,
            disableRange: disableRange
        });
        this._contentLength = contentLength;
        this._isRangeSupported = isRangeSupported;
        this._filename = $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) stream._abortRequest(fullRequestXhr);
        this._headersCapability.resolve();
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._cachedChunks.push(chunk);
        this._done = true;
        if (this._cachedChunks.length === 0) this.#endRequests();
    }
    #onError(status) {
        this._storedError = $b3a01b20dd2ade98$var$createResponseError(status, this._stream.url);
        this._headersCapability.reject(this._storedError);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    #onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    async read() {
        await this._headersCapability.promise;
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersCapability.reject(reason);
        this.#endRequests();
        this._stream._abortRequest(this._fullRequestXhr);
        this._fullRequestXhr = null;
    }
}
class $b3a01b20dd2ade98$var$PDFNetworkStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    onClosed = null;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    _storedError = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._requestXhr = stream._request({
            begin: begin,
            end: end,
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: null
        });
    }
    #onHeadersReceived() {
        const responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(this._requestXhr?.responseURL);
        try {
            $b3a01b20dd2ade98$var$ensureResponseOrigin(responseOrigin, this._stream._responseOrigin);
        } catch (ex) {
            this._storedError = ex;
            this.#onError(0);
        }
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        this.#endRequests();
        this.onClosed?.();
    }
    #onError(status) {
        this._storedError ??= $b3a01b20dd2ade98$var$createResponseError(status, this._stream.url);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this._stream._abortRequest(this._requestXhr);
        this.onClosed?.();
    }
}
function $b3a01b20dd2ade98$var$getReadableStream(url, opts = null) {
    const fs = $4TZ3D.getBuiltinModule("fs");
    const { Readable: Readable } = $4TZ3D.getBuiltinModule("stream");
    const readStream = fs.createReadStream(url, opts);
    return Readable.toWeb(readStream);
}
class $b3a01b20dd2ade98$var$PDFNodeStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFNodeStreamReader, $b3a01b20dd2ade98$var$PDFNodeStreamRangeReader);
        const { url: url } = source;
        $b3a01b20dd2ade98$var$assert(url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
    }
}
class $b3a01b20dd2ade98$var$PDFNodeStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url } = stream._source;
        this._isStreamingSupported = !disableStream;
        const fs = $4TZ3D.getBuiltinModule("fs/promises");
        fs.lstat(url).then((stat)=>{
            const readableStream = $b3a01b20dd2ade98$var$getReadableStream(url);
            this._reader = readableStream.getReader();
            const { size: size } = stat;
            this._contentLength = size;
            this._isRangeSupported = !disableRange && size > 2 * rangeChunkSize;
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch((error)=>{
            if (error.code === "ENOENT") error = $b3a01b20dd2ade98$var$createResponseError(0, url);
            this._headersCapability.reject(error);
        });
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
class $b3a01b20dd2ade98$var$PDFNodeStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url } = stream._source;
        try {
            const readableStream = $b3a01b20dd2ade98$var$getReadableStream(url, {
                start: begin,
                end: end - 1
            });
            this._reader = readableStream.getReader();
            this._readCapability.resolve();
        } catch (error) {
            this._readCapability.reject(error);
        }
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
function $b3a01b20dd2ade98$var$getNetworkStream(url) {
    return $b3a01b20dd2ade98$var$isValidFetchUrl(url) ? $b3a01b20dd2ade98$var$PDFFetchStream : $b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$PDFNodeStream : $b3a01b20dd2ade98$var$PDFNetworkStream;
}
class $b3a01b20dd2ade98$export$edf38ba293eb934 {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
class $b3a01b20dd2ade98$var$Metadata {
    #map;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#map = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#map.get(name) ?? null;
    }
    [Symbol.iterator]() {
        return this.#map.entries();
    }
}
const $b3a01b20dd2ade98$var$INTERNAL = Symbol("INTERNAL");
class $b3a01b20dd2ade98$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage, rbGroups: rbGroups }){
        this.#isDisplay = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $b3a01b20dd2ade98$var$INTERNAL) $b3a01b20dd2ade98$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $b3a01b20dd2ade98$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $b3a01b20dd2ade98$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($b3a01b20dd2ade98$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($b3a01b20dd2ade98$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($b3a01b20dd2ade98$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $b3a01b20dd2ade98$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $b3a01b20dd2ade98$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $b3a01b20dd2ade98$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true, preserveRB = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) for (const rbGroup of group.rbGroups){
            for (const otherId of rbGroup)if (otherId !== id) this.#groups.get(otherId)?._setVisible($b3a01b20dd2ade98$var$INTERNAL, false, true);
        }
        group._setVisible($b3a01b20dd2ade98$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    this.setVisibility(elem, true, preserveRB);
                    break;
                case "OFF":
                    this.setVisibility(elem, false, preserveRB);
                    break;
                case "Toggle":
                    this.setVisibility(elem, !group.visible, preserveRB);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $b3a01b20dd2ade98$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
    [Symbol.iterator]() {
        return this.#groups.entries();
    }
}
class $b3a01b20dd2ade98$var$PagesMapper {
    #pageNumberToId = null;
    #prevPageNumbers = null;
    #pagesNumber = 0;
    #clipboard = null;
    #savedData = null;
    get pagesNumber() {
        return this.#pagesNumber;
    }
    set pagesNumber(n) {
        if (this.#pagesNumber === n) return;
        this.#pagesNumber = n;
        this.#pageNumberToId = null;
        this.#prevPageNumbers = null;
    }
    #ensureInit() {
        if (this.#pageNumberToId) return;
        const n = this.#pagesNumber;
        const pageNumberToId = this.#pageNumberToId = new Uint32Array(n);
        for(let i = 0; i < n; i++)pageNumberToId[i] = i + 1;
        this.#prevPageNumbers = new Int32Array(pageNumberToId);
    }
    #buildIdToPageNumber() {
        const idToPageNumber = new Map();
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            const id = pageNumberToId[i];
            const pageNumbers = idToPageNumber.get(id);
            if (pageNumbers) pageNumbers.push(i + 1);
            else idToPageNumber.set(id, [
                i + 1
            ]);
        }
        return idToPageNumber;
    }
    movePages(selectedPages, pagesToMove, index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const movedCount = pagesToMove.length;
        const mappedPagesToMove = new Uint32Array(movedCount);
        let removedBeforeTarget = 0;
        for(let i = 0; i < movedCount; i++){
            const pageIndex = pagesToMove[i] - 1;
            mappedPagesToMove[i] = pageNumberToId[pageIndex];
            if (pageIndex < index) removedBeforeTarget++;
        }
        const pagesNumber = this.#pagesNumber;
        const remainingLen = pagesNumber - movedCount;
        const adjustedTarget = $b3a01b20dd2ade98$export$b8106b171181a554(index - removedBeforeTarget, 0, remainingLen);
        for(let i = 0, r = 0; i < pagesNumber; i++)if (!selectedPages.has(i + 1)) pageNumberToId[r++] = pageNumberToId[i];
        pageNumberToId.copyWithin(adjustedTarget + movedCount, adjustedTarget, remainingLen);
        pageNumberToId.set(mappedPagesToMove, adjustedTarget);
        this.#updatePrevPageNumbers(prevIdToPageNumber);
        if (pageNumberToId.every((id, i)=>id === i + 1)) this.#pageNumberToId = null;
    }
    deletePages(pagesToDelete) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        this.#savedData = {
            pageNumberToId: pageNumberToId.slice(),
            pagesNumber: this.#pagesNumber,
            prevPageNumbers: this.#prevPageNumbers.slice()
        };
        const newN = this.#pagesNumber - pagesToDelete.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        let sourceIndex = 0;
        let destIndex = 0;
        for (const pageNumber of pagesToDelete){
            const pageIndex = pageNumber - 1;
            if (pageIndex !== sourceIndex) {
                newPageNumberToId.set(pageNumberToId.subarray(sourceIndex, pageIndex), destIndex);
                destIndex += pageIndex - sourceIndex;
            }
            sourceIndex = pageIndex + 1;
        }
        if (sourceIndex < pageNumberToId.length) newPageNumberToId.set(pageNumberToId.subarray(sourceIndex), destIndex);
        this.#updatePrevPageNumbers(prevIdToPageNumber, new Set(pagesToDelete));
    }
    cancelDelete() {
        if (this.#savedData) {
            this.#pageNumberToId = this.#savedData.pageNumberToId;
            this.#pagesNumber = this.#savedData.pagesNumber;
            this.#prevPageNumbers = this.#savedData.prevPageNumbers;
            this.#savedData = null;
        }
    }
    cleanSavedData() {
        this.#savedData = null;
    }
    copyPages(pagesToCopy) {
        this.#ensureInit();
        this.#clipboard = {
            pageNumbers: pagesToCopy,
            pageIds: pagesToCopy.map((n)=>this.#pageNumberToId[n - 1])
        };
    }
    cancelCopy() {
        this.#clipboard = null;
    }
    pastePages(index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const { pageNumbers: copiedPageNumbers, pageIds: copiedPageIds } = this.#clipboard;
        const newN = this.#pagesNumber + copiedPageNumbers.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        newPageNumberToId.set(pageNumberToId.subarray(0, index), 0);
        newPageNumberToId.set(copiedPageIds, index);
        newPageNumberToId.set(pageNumberToId.subarray(index), index + copiedPageNumbers.length);
        this.#updatePrevPageNumbers(prevIdToPageNumber, null, index, copiedPageNumbers);
        this.#clipboard = null;
    }
    #updatePrevPageNumbers(prevIdToPageNumber, deletedPageNumbers = null, pasteIndex = -1, copiedPageNumbers = null) {
        const prevPageNumbers = this.#prevPageNumbers;
        const newPageNumberToId = this.#pageNumberToId;
        const pasteEnd = pasteIndex + (copiedPageNumbers?.length ?? 0);
        const idsIndices = new Map();
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (i >= pasteIndex && i < pasteEnd) {
                prevPageNumbers[i] = -copiedPageNumbers[i - pasteIndex];
                continue;
            }
            const id = newPageNumberToId[i];
            const oldPositions = prevIdToPageNumber.get(id);
            let j = idsIndices.get(id) || 0;
            if (deletedPageNumbers && oldPositions) while(j < oldPositions.length && deletedPageNumbers.has(oldPositions[j]))j++;
            prevPageNumbers[i] = oldPositions?.[j];
            idsIndices.set(id, j + 1);
        }
    }
    hasBeenAltered() {
        return this.#pageNumberToId !== null;
    }
    getPageMappingForSaving(idToPageNumber = null) {
        idToPageNumber ??= this.#buildIdToPageNumber();
        let nCopy = 0;
        for (const pageNumbers of idToPageNumber.values())nCopy = Math.max(nCopy, pageNumbers.length);
        const extractParams = new Array(nCopy);
        for(let i = 0; i < nCopy; i++)extractParams[i] = {
            document: null,
            pageIndices: [],
            includePages: []
        };
        for (const [id, pageNumbers] of idToPageNumber)for(let i = 0, ii = pageNumbers.length; i < ii; i++)extractParams[i].includePages.push([
            id - 1,
            pageNumbers[i] - 1
        ]);
        for (const { includePages: includePages, pageIndices: pageIndices } of extractParams){
            includePages.sort((a, b)=>a[0] - b[0]);
            for(let i = 0, ii = includePages.length; i < ii; i++){
                pageIndices.push(includePages[i][1]);
                includePages[i] = includePages[i][0];
            }
        }
        return extractParams;
    }
    extractPages(extractedPageNumbers) {
        extractedPageNumbers = Array.from(extractedPageNumbers).sort((a, b)=>a - b);
        const usedIds = new Map();
        for(let i = 0, ii = extractedPageNumbers.length; i < ii; i++){
            const id = this.getPageId(extractedPageNumbers[i]);
            const usedPageNumbers = usedIds.getOrInsertComputed(id, $b3a01b20dd2ade98$export$be9af9a47496243a);
            usedPageNumbers.push(i + 1);
        }
        return this.getPageMappingForSaving(usedIds);
    }
    getPrevPageNumber(pageNumber) {
        return this.#prevPageNumbers?.[pageNumber - 1] ?? 0;
    }
    getPageNumber(id) {
        if (!this.#pageNumberToId) return id;
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (pageNumberToId[i] === id) return i + 1;
        }
        return 0;
    }
    getPageId(pageNumber) {
        return this.#pageNumberToId?.[pageNumber - 1] ?? pageNumber;
    }
    getMapping() {
        return this.#pageNumberToId?.subarray(0, this.pagesNumber);
    }
}
const $b3a01b20dd2ade98$var$INITIAL_DATA = Symbol("INITIAL_DATA");
const $b3a01b20dd2ade98$var$dataObj = ()=>({
        ...Promise.withResolvers(),
        data: $b3a01b20dd2ade98$var$INITIAL_DATA
    });
class $b3a01b20dd2ade98$var$PDFObjects {
    #objs = new Map();
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#objs.getOrInsertComputed(objId, $b3a01b20dd2ade98$var$dataObj);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $b3a01b20dd2ade98$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs.get(objId);
        return !!obj && obj.data !== $b3a01b20dd2ade98$var$INITIAL_DATA;
    }
    delete(objId) {
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $b3a01b20dd2ade98$var$INITIAL_DATA) return false;
        this.#objs.delete(objId);
        return true;
    }
    resolve(objId, data = null) {
        const obj = this.#objs.getOrInsertComputed(objId, $b3a01b20dd2ade98$var$dataObj);
        if (obj.data !== $b3a01b20dd2ade98$var$INITIAL_DATA) throw new Error(`Object already resolved ${objId}.`);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for (const { data: data } of this.#objs.values())data?.bitmap?.close();
        this.#objs.clear();
    }
    *[Symbol.iterator]() {
        for (const [objId, { data: data }] of this.#objs)if (data !== $b3a01b20dd2ade98$var$INITIAL_DATA) yield [
            objId,
            data
        ];
    }
}
const $b3a01b20dd2ade98$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE = 30;
class $b3a01b20dd2ade98$export$fdbdc423a78c5262 {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #imagesHandler = null;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #canvasCtxFonts = new WeakMap();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, images: images, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#imagesHandler = images;
        this.#scale = viewport.scale * $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.#ensureMinFontSizeComputed();
        container.style.setProperty("--min-font-size", $b3a01b20dd2ade98$export$fdbdc423a78c5262.#minFontSize);
        $b3a01b20dd2ade98$export$af0a15a86e590226(container, viewport);
        this.#capability.promise.finally(()=>{
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        }).catch(()=>{});
    }
    static get fontFamilyMap() {
        const { isWindows: isWindows, isFirefox: isFirefox } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "fontFamilyMap", new Map([
            [
                "sans-serif",
                `${isWindows && isFirefox ? "Calibri, " : ""}sans-serif`
            ],
            [
                "monospace",
                `${isWindows && isFirefox ? "Lucida Console, " : ""}monospace`
            ]
        ]));
    }
    render() {
        if (this.#imagesHandler) this.#container.append(this.#imagesHandler.render());
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $b3a01b20dd2ade98$export$af0a15a86e590226(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                div: null,
                properties: null,
                ctx: $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $b3a01b20dd2ade98$export$d0e978393d193d1a("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $b3a01b20dd2ade98$var$MAX_TEXT_DIVS_TO_RENDER) {
                $b3a01b20dd2ade98$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id) this.#container.setAttribute("id", `${item.id}`);
                    if (item.tag === "Artifact") this.#container.ariaHidden = true;
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        let fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        fontFamily = $b3a01b20dd2ade98$export$fdbdc423a78c5262.fontFamilyMap.get(fontFamily) || fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getAscent(fontFamily, style, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const divStyle = textDiv.style;
        divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
        divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        divStyle.setProperty("--font-height", `${fontHeight.toFixed(2)}px`);
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx } = params;
        const { style: style } = div;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.#ensureCtxFont(ctx, fontSize * this.#scale, fontFamily);
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) style.setProperty("--scale-x", canvasWidth * this.#scale / width);
        }
        if (properties.angle !== 0) style.setProperty("--rotate", `${properties.angle}deg`);
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let ctx = this.#canvasContexts.get(lang ||= "");
        if (!ctx) {
            const canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, ctx);
            this.#canvasCtxFonts.set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }
    static #ensureCtxFont(ctx, size, family) {
        const cached = this.#canvasCtxFonts.get(ctx);
        if (size === cached.size && family === cached.family) return;
        ctx.font = `${size}px ${family}`;
        cached.size = size;
        cached.family = family;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, style, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        ctx.canvas.width = ctx.canvas.height = $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE;
        this.#ensureCtxFont(ctx, $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE, fontFamily);
        const metrics = ctx.measureText("");
        const ascent = metrics.fontBoundingBoxAscent;
        const descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        let ratio = 0.8;
        if (ascent) ratio = ascent / (ascent + descent);
        else {
            if ($b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox) $b3a01b20dd2ade98$var$warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.");
            if (style.ascent) ratio = style.ascent;
            else if (style.descent) ratio = 1 + style.descent;
        }
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
const $b3a01b20dd2ade98$var$RENDERING_CANCELLED_TIMEOUT = 100;
function $b3a01b20dd2ade98$export$f65ca476c09acec0(src = {}) {
    if (typeof src === "string" || src instanceof URL) src = {
        url: src
    };
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = {
        data: src
    };
    const task = new $b3a01b20dd2ade98$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $b3a01b20dd2ade98$var$getUrlProp(src.url) : null;
    const data = src.data ? $b3a01b20dd2ade98$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $b3a01b20dd2ade98$export$c06899d9d7bce9ab ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : 2 ** 16;
    let worker = src.worker instanceof $b3a01b20dd2ade98$export$84e2e9f37426b265 ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$b3a01b20dd2ade98$export$f67aae4532d8295b(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.cMapUrl);
    const cMapPacked = src.cMapPacked !== false;
    const iccUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.iccUrl);
    const standardFontDataUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.standardFontDataUrl);
    const wasmUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.wasmUrl);
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$b3a01b20dd2ade98$var$isNodeJS;
    const isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !$b3a01b20dd2ade98$var$isNodeJS && ($b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox || !globalThis.chrome);
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $b3a01b20dd2ade98$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const CanvasFactory = src.CanvasFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeCanvasFactory : $b3a01b20dd2ade98$var$DOMCanvasFactory);
    const FilterFactory = src.FilterFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeFilterFactory : $b3a01b20dd2ade98$var$DOMFilterFactory);
    const BinaryDataFactory = src.BinaryDataFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeBinaryDataFactory : $b3a01b20dd2ade98$var$DOMBinaryDataFactory);
    const enableHWA = src.enableHWA === true;
    const enableWebGPU = src.enableWebGPU === true;
    const gpuPromise = enableWebGPU ? $b3a01b20dd2ade98$var$initGPU() : Promise.resolve(false);
    const useWasm = src.useWasm !== false;
    const pagesMapper = src.pagesMapper || new $b3a01b20dd2ade98$var$PagesMapper();
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$b3a01b20dd2ade98$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(BinaryDataFactory === $b3a01b20dd2ade98$var$DOMBinaryDataFactory && cMapUrl && cMapPacked && standardFontDataUrl && wasmUrl && $b3a01b20dd2ade98$var$isValidFetchUrl(cMapUrl, document.baseURI) && $b3a01b20dd2ade98$var$isValidFetchUrl(standardFontDataUrl, document.baseURI) && $b3a01b20dd2ade98$var$isValidFetchUrl(wasmUrl, document.baseURI));
    const styleElement = null;
    $b3a01b20dd2ade98$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        binaryDataFactory: useWorkerFetch ? null : new BinaryDataFactory({
            cMapUrl: cMapUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        })
    };
    if (!worker) {
        worker = $b3a01b20dd2ade98$export$84e2e9f37426b265.create({
            verbosity: verbosity,
            port: $b3a01b20dd2ade98$export$edf38ba293eb934.workerPort
        });
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "5.7.284",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            cMapPacked: cMapPacked,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl,
            hasGPU: false
        }
    };
    const transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        enableHWA: enableHWA,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    Promise.all([
        worker.promise,
        gpuPromise
    ]).then(function([, hasGPU]) {
        if (task.destroyed) throw new Error("Loading aborted");
        if (worker.destroyed) throw new Error("Worker was destroyed");
        docParams.evaluatorOptions.hasGPU = hasGPU;
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (data) ;
        else if (rangeTransport) networkStream = new $b3a01b20dd2ade98$var$PDFDataTransportStream({
            pdfDataRangeTransport: rangeTransport,
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (url) {
            const NetworkStream = $b3a01b20dd2ade98$var$getNetworkStream(url);
            networkStream = new NetworkStream({
                url: url,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        } else throw new Error("getDocument - expected either `data`, `range`, or `url` parameter.");
        return workerIdPromise.then((workerId)=>{
            if (task.destroyed) throw new Error("Loading aborted");
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $b3a01b20dd2ade98$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $b3a01b20dd2ade98$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory, pagesMapper);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
class $b3a01b20dd2ade98$var$PDFDocumentLoadingTask {
    static #docId = 0;
    _capability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${$b3a01b20dd2ade98$var$PDFDocumentLoadingTask.#docId++}`;
    destroyed = false;
    onPassword = null;
    onProgress = null;
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        this._worker?.destroy();
        this._worker = null;
    }
    async getData() {
        return this._transport.getData();
    }
}
class $b3a01b20dd2ade98$export$c06899d9d7bce9ab {
    #capability = Promise.withResolvers();
    #listener = null;
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
        Object.defineProperty(this, "onDataProgress", {
            value: ()=>{
                $b3a01b20dd2ade98$var$deprecated("`PDFDataRangeTransport.prototype.onDataProgress` - method was removed, since loading progress is now reported automatically through the `PDFDataTransportStream` class (and related code).");
            }
        });
    }
    onDataRange(begin, chunk) {
        this.#listener({
            type: "range",
            begin: begin,
            chunk: chunk
        });
    }
    onDataProgressiveRead(chunk) {
        this.#capability.promise.then(()=>{
            this.#listener({
                type: "progressiveRead",
                chunk: chunk
            });
        });
    }
    onDataProgressiveDone() {
        this.#capability.promise.then(()=>{
            this.#listener({
                type: "progressiveDone"
            });
        });
    }
    transportReady(listener) {
        this.#listener = listener;
        this.#capability.resolve();
    }
    requestDataRange(begin, end) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $b3a01b20dd2ade98$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get pagesMapper() {
        return this._transport.pagesMapper;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get canvasFactory() {
        return this._transport.canvasFactory;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this._transport.getAnnotationsByType(types, pageIndexesToSkip);
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    extractPages(pageInfos) {
        return this._transport.extractPages(pageInfos);
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    getRawData(data) {
        return this._transport.getRawData(data);
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    destroy() {
        return this.loadingTask.destroy();
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $b3a01b20dd2ade98$var$PDFPageProxy {
    #pendingCleanup = false;
    #pagesMapper = null;
    constructor(pageIndex, pageInfo, transport, pagesMapper, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $b3a01b20dd2ade98$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $b3a01b20dd2ade98$var$PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
        this.recordedBBoxes = null;
        this.#pagesMapper = pagesMapper;
        this.imageCoordinates = null;
    }
    clone(id) {
        const clone = new $b3a01b20dd2ade98$var$PDFPageProxy(id, this._pageInfo, this._transport, this.#pagesMapper, this._pdfBug);
        clone.clonedFromIndex = this.clonedFromIndex ?? this._pageIndex;
        this._transport.updatePage(clone);
        return clone;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    set pageNumber(value) {
        this._pageIndex = value - 1;
        this._transport.updatePage(this);
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $b3a01b20dd2ade98$var$PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, canvas: canvas = canvasContext.canvas, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false, recordImages: recordImages = false, recordOperations: recordOperations = false, operationsFilter: operationsFilter = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        const intentState = this._intentStates.getOrInsertComputed(cacheKey, $b3a01b20dd2ade98$export$5b3b706fb9845c88);
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const recordForDebugger = !!(this._pdfBug && globalThis.StepperManager?.enabled);
        const shouldRecordOperations = !!canvas && !this.recordedBBoxes && (recordOperations || recordForDebugger);
        const shouldRecordImages = !!canvas && !this.imageCoordinates && recordImages;
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (shouldRecordOperations) {
                const recordedBBoxes = internalRenderTask.gfx?.dependencyTracker.take();
                if (recordedBBoxes) {
                    internalRenderTask.stepper?.setOperatorBBoxes(recordedBBoxes, internalRenderTask.gfx.dependencyTracker.takeDebugMetadata());
                    if (recordOperations) this.recordedBBoxes = recordedBBoxes;
                }
            }
            if (shouldRecordImages && !error) this.imageCoordinates = internalRenderTask.gfx?.imagesTracker.take();
            if (intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup();
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        let dependencyTracker = null;
        let bboxTracker = null;
        if (shouldRecordOperations || shouldRecordImages) bboxTracker = new $b3a01b20dd2ade98$var$CanvasBBoxTracker(canvas, intentState.operatorList.length);
        if (shouldRecordOperations) dependencyTracker = new $b3a01b20dd2ade98$var$CanvasDependencyTracker(bboxTracker, recordForDebugger);
        const internalRenderTask = new $b3a01b20dd2ade98$var$InternalRenderTask({
            callback: complete,
            params: {
                canvas: canvas,
                canvasContext: canvasContext,
                dependencyTracker: dependencyTracker ?? bboxTracker,
                imagesTracker: shouldRecordImages ? new $b3a01b20dd2ade98$var$CanvasImagesTracker(canvas) : null,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors,
            enableHWA: this._transport.enableHWA,
            operationsFilter: operationsFilter
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        const intentState = this._intentStates.getOrInsertComputed(intentArgs.cacheKey, $b3a01b20dd2ade98$export$5b3b706fb9845c88);
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    async getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$b3a01b20dd2ade98$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        const textContent = {
            items: [],
            styles: Object.create(null),
            lang: null
        };
        for await (const value of readableStream){
            textContent.lang ??= value.lang;
            Object.assign(textContent.styles, value.styles);
            textContent.items.push(...value.items);
        }
        return textContent;
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup();
        if (resetStats && success) this._stats &&= new $b3a01b20dd2ade98$var$StatTimer();
        return success;
    }
    #tryCleanup() {
        if (!this.#pendingCleanup || this.destroyed) return false;
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup();
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable, modifiedIds: modifiedIds }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, undefined, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup();
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $b3a01b20dd2ade98$export$245847d31c09154f) {
                let delay = $b3a01b20dd2ade98$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $b3a01b20dd2ade98$export$84e2e9f37426b265 {
    #capability = Promise.withResolvers();
    #messageHandler = null;
    #port = null;
    #webWorker = null;
    static #fakeWorkerId = 0;
    static #isWorkerDisabled = false;
    static #workerPorts = new WeakMap();
    static{
        if ($b3a01b20dd2ade98$var$isNodeJS) {
            this.#isWorkerDisabled = true;
            $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc ||= "./pdf.worker.mjs";
        }
        this._isSameOrigin = (baseUrl, otherUrl)=>{
            const base = URL.parse(baseUrl);
            if (!base?.origin || base.origin === "null") return false;
            const other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        this._createCDNWrapper = (url)=>{
            const wrapper = `await import("${url}");`;
            return URL.createObjectURL(new Blob([
                wrapper
            ], {
                type: "text/javascript"
            }));
        };
    }
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $b3a01b20dd2ade98$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        if (port) {
            if ($b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            $b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.set(port, this);
            this.#initializeFromPort(port);
        } else this.#initialize();
    }
    get promise() {
        return this.#capability.promise;
    }
    #resolve() {
        this.#capability.resolve();
        this.#messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this.#port;
    }
    get messageHandler() {
        return this.#messageHandler;
    }
    #initializeFromPort(port) {
        this.#port = port;
        this.#messageHandler = new $b3a01b20dd2ade98$var$MessageHandler("main", "worker", port);
        this.#messageHandler.on("ready", ()=>{});
        this.#resolve();
    }
    #initialize() {
        if ($b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled || $b3a01b20dd2ade98$export$84e2e9f37426b265.#mainThreadWorkerMessageHandler) {
            this.#setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $b3a01b20dd2ade98$export$84e2e9f37426b265;
        try {
            if (!$b3a01b20dd2ade98$export$84e2e9f37426b265._isSameOrigin(window.location, workerSrc)) workerSrc = $b3a01b20dd2ade98$export$84e2e9f37426b265._createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $b3a01b20dd2ade98$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this.#capability.reject(new Error("Worker was destroyed"));
                else this.#setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this.#webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this.#messageHandler = messageHandler;
                this.#port = worker;
                this.#webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this.#setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $b3a01b20dd2ade98$var$info("The worker has been disabled.");
        }
        this.#setupFakeWorker();
    }
    #setupFakeWorker() {
        if (!$b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled) {
            $b3a01b20dd2ade98$var$warn("Setting up fake worker.");
            $b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled = true;
        }
        $b3a01b20dd2ade98$export$84e2e9f37426b265._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this.#capability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $b3a01b20dd2ade98$var$LoopbackPort();
            this.#port = port;
            const id = `fake${$b3a01b20dd2ade98$export$84e2e9f37426b265.#fakeWorkerId++}`;
            const workerHandler = new $b3a01b20dd2ade98$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this.#messageHandler = new $b3a01b20dd2ade98$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this.#capability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        this.#webWorker?.terminate();
        this.#webWorker = null;
        $b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.delete(this.#port);
        this.#port = null;
        this.#messageHandler?.destroy();
        this.#messageHandler = null;
    }
    static create(params) {
        const cachedPort = this.#workerPorts.get(params?.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $b3a01b20dd2ade98$export$84e2e9f37426b265(params);
    }
    static get workerSrc() {
        if ($b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc) return $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ /*@vite-ignore*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $b3a01b20dd2ade98$var$WorkerTransport {
    downloadInfoCapability = Promise.withResolvers();
    #fullReader = null;
    #methodPromises = new Map();
    #networkStream = null;
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory, pagesMapper){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.#networkStream = networkStream;
        this.commonObjs = new $b3a01b20dd2ade98$var$PDFObjects();
        this.fontLoader = new $b3a01b20dd2ade98$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.enableHWA = params.enableHWA;
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.binaryDataFactory = factory.binaryDataFactory;
        this.pagesMapper = pagesMapper;
        this.destroyed = false;
        this.destroyCapability = null;
        this.setupMessageHandler();
    }
    updatePage(page) {
        const { _pageIndex: _pageIndex } = page;
        this.#pageCache.set(_pageIndex, page);
        this.#pagePromises.set(_pageIndex, Promise.resolve(page));
    }
    #cacheSimpleMethod(name, data = null) {
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, data));
    }
    #onProgress({ loaded: loaded, total: total }) {
        this.loadingTask.onProgress?.({
            loaded: loaded,
            total: total,
            percent: total ? $b3a01b20dd2ade98$export$b8106b171181a554(Math.round(loaded / total * 100), 0, 100) : NaN
        });
    }
    get annotationStorage() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "annotationStorage", new $b3a01b20dd2ade98$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage = null, isEditing = false, isOpList = false) {
        let renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $b3a01b20dd2ade98$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $b3a01b20dd2ade98$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        const annotationStorage = renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $b3a01b20dd2ade98$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch(annotationMode){
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.DISABLE:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE:
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE_FORMS:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE_STORAGE:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $b3a01b20dd2ade98$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isEditing) renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.IS_EDITING;
        if (isOpList) renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.OPLIST;
        const { ids: modifiedIds, hash: modifiedIdsHash } = annotationStorage.modifiedIds;
        const cacheKeyBuf = [
            renderingIntent,
            annotationStorageSerializable.hash,
            modifiedIdsHash
        ];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (Object.hasOwn(this, "annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.cleanup();
            this.#networkStream?.cancelAllRequests(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Worker was terminated."));
            this.messageHandler?.destroy();
            this.messageHandler = null;
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $b3a01b20dd2ade98$var$assert(this.#networkStream, "GetReader - no `BasePDFStream` instance available.");
            this.#fullReader = this.#networkStream.getFullReader();
            this.#fullReader.onProgress = (evt)=>this.#onProgress(evt);
            sink.onPull = ()=>{
                this.#fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $b3a01b20dd2ade98$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this.#fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", async (data)=>{
            await this.#fullReader.headersReady;
            const { isStreamingSupported: isStreamingSupported, isRangeSupported: isRangeSupported, contentLength: contentLength } = this.#fullReader;
            if (isStreamingSupported && isRangeSupported) this.#fullReader.onProgress = null;
            return {
                isStreamingSupported: isStreamingSupported,
                isRangeSupported: isRangeSupported,
                contentLength: contentLength
            };
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $b3a01b20dd2ade98$var$assert(this.#networkStream, "GetRangeReader - no `BasePDFStream` instance available.");
            const rangeReader = this.#networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $b3a01b20dd2ade98$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this.pagesMapper.pagesNumber = pdfInfo.numPages;
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $b3a01b20dd2ade98$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", (ex)=>{
            loadingTask._capability.reject($b3a01b20dd2ade98$var$wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", (ex)=>{
            this.#passwordCapability = Promise.withResolvers();
            try {
                if (!loadingTask.onPassword) throw $b3a01b20dd2ade98$var$wrapReason(ex);
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                loadingTask.onPassword(updatePassword, ex.code);
            } catch (err) {
                this.#passwordCapability.reject(err);
            }
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            this.#onProgress({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $b3a01b20dd2ade98$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const fontData = new $b3a01b20dd2ade98$var$FontInfo(exportedData);
                    const inspectFont = this._params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $b3a01b20dd2ade98$var$FontFaceObject(fontData, inspectFont, exportedData.charProcOperatorList, exportedData.extra);
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!font.fontExtraProperties) font.clearData();
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $b3a01b20dd2ade98$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        const copy = structuredClone(data);
                        this.commonObjs.resolve(id, copy);
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                    this.commonObjs.resolve(id, new $b3a01b20dd2ade98$var$FontPathInfo(exportedData));
                    break;
                case "Image":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                case "Pattern":
                    const pattern = new $b3a01b20dd2ade98$var$PatternInfo(exportedData);
                    this.commonObjs.resolve(id, pattern.getIR());
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            this.#onProgress(data);
        });
        messageHandler.on("FetchBinaryData", async (data)=>{
            if (this.destroyed) throw new Error("Worker was destroyed.");
            if (!this.binaryDataFactory) throw new Error("`BinaryDataFactory` not initialized, see the `useWorkerFetch` parameter.");
            return this.binaryDataFactory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $b3a01b20dd2ade98$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this.#fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    extractPages(pageInfos) {
        const params = {
            pageInfos: pageInfos
        };
        let transfer;
        if (this.annotationStorage.size > 0) {
            const { map: map, transfer: t } = this.annotationStorage.serializable;
            params.annotationStorage = map;
            transfer = t;
        }
        return this.messageHandler.sendWithPromise("ExtractPages", params, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.pagesMapper.pagesNumber) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1;
        const newPageIndex = this.pagesMapper.getPageId(pageNumber) - 1;
        const cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: newPageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, newPageIndex);
            const page = new $b3a01b20dd2ade98$var$PDFPageProxy(pageIndex, pageInfo, this, this.pagesMapper, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    async getPageIndex(ref) {
        if (!$b3a01b20dd2ade98$var$isRefProxy(ref)) throw new Error("Invalid pageIndex request.");
        const index = await this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
        const pageNumber = this.pagesMapper.getPageNumber(index + 1);
        if (pageNumber === 0) throw new Error("GetPageIndex: page has been removed.");
        return pageNumber - 1;
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
            types: types,
            pageIndexesToSkip: pageIndexesToSkip
        });
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $b3a01b20dd2ade98$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata";
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, null).then((results)=>({
                    info: results[0],
                    metadata: results[1] ? new $b3a01b20dd2ade98$var$Metadata(results[1]) : null,
                    contentDispositionFilename: this.#fullReader?.filename ?? null,
                    contentLength: this.#fullReader?.contentLength ?? null,
                    hasStructTree: results[2]
                })));
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    getRawData(data) {
        return this.messageHandler.sendWithPromise("GetRawData", data);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$b3a01b20dd2ade98$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        const pageIndex = this.#pageRefCache.get(refStr);
        if (pageIndex >= 0) {
            const pageNumber = this.pagesMapper.getPageNumber(pageIndex + 1);
            if (pageNumber !== 0) return pageNumber;
        }
        return null;
    }
}
class $b3a01b20dd2ade98$var$RenderTask {
    _internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(internalRenderTask){
        this._internalRenderTask = internalRenderTask;
    }
    get promise() {
        return this._internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this._internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this._internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this._internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
    get imageCoordinates() {
        return this._internalRenderTask.imageCoordinates || null;
    }
}
class $b3a01b20dd2ade98$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null, enableHWA: enableHWA = false, operationsFilter: operationsFilter = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $b3a01b20dd2ade98$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvas;
        this._canvasContext = params.canvas ? null : params.canvasContext;
        this._enableHWA = enableHWA;
        this._dependencyTracker = params.dependencyTracker;
        this._imagesTracker = params.imagesTracker;
        this._operationsFilter = operationsFilter;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { viewport: viewport, transform: transform, background: background, dependencyTracker: dependencyTracker, imagesTracker: imagesTracker } = this.params;
        const canvasContext = this._canvasContext || this._canvas.getContext("2d", {
            alpha: false,
            willReadFrequently: !this._enableHWA
        });
        this.gfx = new $b3a01b20dd2ade98$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors, dependencyTracker, imagesTracker);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        error ||= new $b3a01b20dd2ade98$export$245847d31c09154f(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay);
        this.callback(error);
        this.task.onError?.(error);
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length);
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $b3a01b20dd2ade98$export$83d89fbfd8236492 = "5.7.284";
const $b3a01b20dd2ade98$export$3f8fe6489e95757d = "7e5b36c2d";
class $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3 {
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #openDropdownAC = null;
    #uiManager = null;
    static #l10nColor = null;
    static get _keyboardManager() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#editor = editor;
        } else this.#isMainColorPicker = true;
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color?.toUpperCase() || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
        $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.#l10nColor ||= Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        });
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.ariaHasPopup = "true";
        if (this.#editor) button.ariaControls = `${this.#editor.id}_colorpicker_dropdown`;
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.ariaHidden = "true";
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.ariaOrientation = "horizontal";
        dropdown.ariaLabelledBy = "highlightColorPickerLabel";
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.ariaMultiSelectable = "false";
        div.ariaOrientation = "vertical";
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        if (this.#editor) div.id = `${this.#editor.id}_colorpicker_dropdown`;
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.#l10nColor[name]);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.ariaSelected = color === this.#defaultColor;
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            value: color
        });
        this.updateColor(color);
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstElementChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstElementChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstElementChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastElementChild?.focus();
    }
    #keyDown(event) {
        $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        if (!this.#openDropdownAC) {
            this.#openDropdownAC = new AbortController();
            window.addEventListener("pointerdown", this.#pointerDown.bind(this), {
                signal: this.#uiManager.combinedSignal(this.#openDropdownAC)
            });
        }
        this.#button.ariaExpanded = "true";
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        this.#button.ariaExpanded = "false";
        this.#openDropdownAC?.abort();
        this.#openDropdownAC = null;
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.ariaSelected = i.next().value === color.toUpperCase();
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $b3a01b20dd2ade98$var$BasicColorPicker {
    #input = null;
    #hasAlpha = false;
    #editor = null;
    #uiManager = null;
    static #l10nColor = null;
    constructor(editor){
        this.#editor = editor;
        this.#uiManager = editor._uiManager;
        $b3a01b20dd2ade98$var$BasicColorPicker.#l10nColor ||= Object.freeze({
            freetext: "pdfjs-editor-color-picker-free-text-input",
            ink: "pdfjs-editor-color-picker-ink-input"
        });
    }
    renderButton() {
        if (this.#input) return this.#input;
        const { editorType: editorType, colorType: colorType, colorAndOpacityType: colorAndOpacityType, opacityType: opacityType, color: color, opacity: opacity } = this.#editor;
        const hasAlpha = this.#hasAlpha = $b3a01b20dd2ade98$export$5fb8891d35c36978.isAlphaColorInputSupported && opacityType !== undefined;
        const input = this.#input = document.createElement("input");
        input.type = "color";
        if (hasAlpha) {
            input.setAttribute("alpha", "");
            const alphaHex = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.hexNums[Math.round((opacity ?? 1) * 255)];
            input.value = (color || "#000000") + alphaHex;
        } else input.value = color || "#000000";
        input.className = "basicColorPicker";
        input.tabIndex = 0;
        input.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$BasicColorPicker.#l10nColor[editorType]);
        input.addEventListener("input", ()=>{
            if (hasAlpha) {
                const rgba = $b3a01b20dd2ade98$export$c24a0a5c5129b2e1(input.value);
                if (!rgba) return;
                const [r, g, b, op] = rgba;
                const hex = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(r, g, b);
                if (colorAndOpacityType !== undefined) this.#uiManager.updateParams(colorAndOpacityType, {
                    color: hex,
                    opacity: op
                });
                else {
                    this.#uiManager.updateParams(colorType, hex);
                    this.#uiManager.updateParams(opacityType, op);
                }
            } else this.#uiManager.updateParams(colorType, input.value);
        }, {
            signal: this.#uiManager._signal
        });
        return input;
    }
    update(value) {
        if (!this.#input) return;
        if (this.#hasAlpha) {
            const alphaHex = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.hexNums[Math.round(this.#editor.opacity * 255)];
            this.#input.value = value + alphaHex;
        } else this.#input.value = value;
    }
    updateOpacity(value) {
        if (!this.#input || !this.#hasAlpha) return;
        const alphaHex = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.hexNums[Math.round(value * 255)];
        this.#input.value = this.#editor.color + alphaHex;
    }
    destroy() {
        this.#input?.remove();
        this.#input = null;
    }
    hideDropdown() {}
}
function $b3a01b20dd2ade98$var$makeColorComp(n) {
    return Math.floor($b3a01b20dd2ade98$export$b8106b171181a554(n, 0, 1) * 255).toString(16).padStart(2, "0");
}
function $b3a01b20dd2ade98$var$scaleAndClamp(x) {
    return $b3a01b20dd2ade98$export$b8106b171181a554(x, 0, 1) * 255;
}
class $b3a01b20dd2ade98$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $b3a01b20dd2ade98$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $b3a01b20dd2ade98$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($b3a01b20dd2ade98$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($b3a01b20dd2ade98$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
const $b3a01b20dd2ade98$var$DateFormats = /* unused pure expression or super */ null;
const $b3a01b20dd2ade98$var$TimeFormats = /* unused pure expression or super */ null;
class $b3a01b20dd2ade98$var$BaseSVGFactory {
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_createSVG` called.");
    }
}
class $b3a01b20dd2ade98$export$425e69f00724e63a extends $b3a01b20dd2ade98$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, type);
    }
}
const $b3a01b20dd2ade98$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $b3a01b20dd2ade98$var$GetElementsByNameSet = new WeakSet();
const $b3a01b20dd2ade98$var$TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60000;
class $b3a01b20dd2ade98$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.LINK:
                return new $b3a01b20dd2ade98$var$LinkAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.TEXT:
                return new $b3a01b20dd2ade98$var$TextAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $b3a01b20dd2ade98$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $b3a01b20dd2ade98$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $b3a01b20dd2ade98$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $b3a01b20dd2ade98$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $b3a01b20dd2ade98$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $b3a01b20dd2ade98$var$WidgetAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POPUP:
                return new $b3a01b20dd2ade98$var$PopupAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.FREETEXT:
                return new $b3a01b20dd2ade98$var$FreeTextAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.LINE:
                return new $b3a01b20dd2ade98$var$LineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.SQUARE:
                return new $b3a01b20dd2ade98$var$SquareAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.CIRCLE:
                return new $b3a01b20dd2ade98$var$CircleAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POLYLINE:
                return new $b3a01b20dd2ade98$var$PolylineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.CARET:
                return new $b3a01b20dd2ade98$var$CaretAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.INK:
                return new $b3a01b20dd2ade98$var$InkAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POLYGON:
                return new $b3a01b20dd2ade98$var$PolygonAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.HIGHLIGHT:
                return new $b3a01b20dd2ade98$var$HighlightAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.UNDERLINE:
                return new $b3a01b20dd2ade98$var$UnderlineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.SQUIGGLY:
                return new $b3a01b20dd2ade98$var$SquigglyAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.STRIKEOUT:
                return new $b3a01b20dd2ade98$var$StrikeOutAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.STAMP:
                return new $b3a01b20dd2ade98$var$StampAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.FILEATTACHMENT:
                return new $b3a01b20dd2ade98$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $b3a01b20dd2ade98$var$AnnotationElement(parameters);
        }
    }
}
class $b3a01b20dd2ade98$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableComment = parameters.enableComment;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        this.hasOwnCommentButton = false;
        if (isRenderable) this.contentElement = this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ contentsObj: contentsObj, richText: richText }) {
        return !!(contentsObj?.str || richText?.str);
    }
    get _isEditable() {
        return this.data.isEditable;
    }
    get hasPopupData() {
        return $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(this.data) || this.enableComment && !!this.commentText;
    }
    get commentData() {
        const { data: data } = this;
        const editor = this.annotationStorage?.getEditor(data.id);
        if (editor) return editor.getData();
        return data;
    }
    get hasCommentButton() {
        return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
        const editor = this.annotationStorage?.getEditor(this.data.id);
        if (editor) return editor.commentButtonPositionInPage;
        const { quadPoints: quadPoints, inkLists: inkLists, rect: rect } = this.data;
        let maxX = -Infinity;
        let maxY = -Infinity;
        if (quadPoints?.length >= 8) {
            for(let i = 0; i < quadPoints.length; i += 8){
                if (quadPoints[i + 1] > maxY) {
                    maxY = quadPoints[i + 1];
                    maxX = quadPoints[i + 2];
                } else if (quadPoints[i + 1] === maxY) maxX = Math.max(maxX, quadPoints[i + 2]);
            }
            return [
                maxX,
                maxY
            ];
        }
        if (inkLists?.length >= 1) {
            for (const inkList of inkLists)for(let i = 0, ii = inkList.length; i < ii; i += 2){
                if (inkList[i + 1] > maxY) {
                    maxY = inkList[i + 1];
                    maxX = inkList[i];
                } else if (inkList[i + 1] === maxY) maxX = Math.max(maxX, inkList[i]);
            }
            if (maxX !== Infinity) return [
                maxX,
                maxY
            ];
        }
        if (rect) return [
            rect[2],
            rect[3]
        ];
        return null;
    }
    _normalizePoint(point) {
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.parent;
        point[1] = view[3] - point[1] + view[1];
        point[0] = 100 * (point[0] - pageX) / pageWidth;
        point[1] = 100 * (point[1] - pageY) / pageHeight;
        return point;
    }
    get commentText() {
        const { data: data } = this;
        return this.annotationStorage.getRawValue(`${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${data.id}`)?.popup?.contents || data.contentsObj?.str || "";
    }
    set commentText(text) {
        const { data: data } = this;
        const popup = {
            deleted: !text,
            contents: text || ""
        };
        if (!this.annotationStorage.updateEditor(data.id, {
            popup: popup
        })) this.annotationStorage.setValue(`${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${data.id}`, {
            id: data.id,
            annotationType: data.annotationType,
            page: this.parent.page,
            popup: popup,
            popupRef: data.popupRef,
            modificationDate: new Date()
        });
        if (!text) this.removePopup();
    }
    removePopup() {
        (this.#popupElement?.popup || this.popup)?.remove();
        this.#popupElement = this.popup = null;
    }
    updateEdited(params) {
        if (!this.container) return;
        if (params.rect) this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect, popup: newPopup } = params;
        if (rect) this.#setRectEdited(rect);
        let popup = this.#popupElement?.popup || this.popup;
        if (!popup && newPopup?.text) {
            this._createPopup(newPopup);
            popup = this.#popupElement.popup;
        }
        if (!popup) return;
        popup.updateEdited(params);
        if (newPopup?.deleted) {
            popup.remove();
            this.#popupElement = null;
            this.popup = null;
        }
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * (rect[2] - rect[0]) / pageWidth}%`;
            style.height = `${100 * (rect[3] - rect[1]) / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $b3a01b20dd2ade98$var$WidgetAnnotationElement) && !(this instanceof $b3a01b20dd2ade98$var$LinkAnnotationElement)) container.tabIndex = 0;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex;
        this.parent.zIndex += 2;
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $b3a01b20dd2ade98$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = this;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--total-scale-factor)) / calc(${verticalRadius}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--total-scale-factor)) / calc(${height}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.BEVELED:
                    $b3a01b20dd2ade98$var$warn("Unimplemented border style: beveled");
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.INSET:
                    $b3a01b20dd2ade98$var$warn("Unimplemented border style: inset");
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...borderColor);
            } else style.borderWidth = 0;
        }
        const rect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        let { width: width, height: height } = this;
        if (angle % 180 !== 0) [width, height] = [
            height,
            width
        ];
        container.style.width = `${100 * width / pageWidth}%`;
        container.style.height = `${100 * height / pageHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $b3a01b20dd2ade98$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $b3a01b20dd2ade98$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="http://www.w3.org/2000/svg"`,
                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        svg.role = "none";
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup(popupData = null) {
        const { data: data } = this;
        let contentsObj, modificationDate;
        if (popupData) {
            contentsObj = {
                str: popupData.text
            };
            modificationDate = popupData.date;
        } else {
            contentsObj = data.contentsObj;
            modificationDate = data.modificationDate;
        }
        this.#popupElement = new $b3a01b20dd2ade98$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: modificationDate,
                contentsObj: contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation,
                noRotate: true
            },
            linkService: this.linkService,
            parent: this.parent,
            elements: [
                this
            ]
        });
    }
    get hasPopupElement() {
        return !!(this.#popupElement || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
        return this.#popupElement;
    }
    render() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) {
                    $b3a01b20dd2ade98$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId,
                mustEnterInEditMode: true
            });
        });
    }
    get width() {
        return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
        return this.data.rect[3] - this.data.rect[1];
    }
}
class $b3a01b20dd2ade98$var$EditorAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.editor = parameters.editor;
    }
    render() {
        this.container.className = "editorAnnotation";
        return this.container;
    }
    createOrUpdatePopup() {
        const { editor: editor } = this;
        if (!editor.hasComment) return;
        this._createPopup(editor.comment);
    }
    get hasCommentButton() {
        return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
        return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
        return this.editor.comment.text;
    }
    set commentText(text) {
        this.editor.comment = text;
        if (!text) this.removePopup();
    }
    get commentData() {
        return this.editor.getData();
    }
    remove() {
        this.parent.removeAnnotation(this.data.id);
        this.container.remove();
        this.container = null;
        this.removePopup();
    }
}
class $b3a01b20dd2ade98$var$LinkAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action, data.overlaidText);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.overlaidText, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState, data.overlaidText);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest, data.overlaidText);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) {
            this.contentElement = link;
            this.container.append(link);
        }
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination, overlaidText = "") {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
        if (overlaidText) link.title = overlaidText;
    }
    _bindNamedAction(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, overlaidText = "", dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        else if (overlaidText) link.title = overlaidText;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (data.overlaidText) link.title = data.overlaidText;
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $b3a01b20dd2ade98$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) {
                    $b3a01b20dd2ade98$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $b3a01b20dd2ade98$var$TextAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(image);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$WidgetAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...color);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $b3a01b20dd2ade98$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($b3a01b20dd2ade98$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $b3a01b20dd2ade98$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $b3a01b20dd2ade98$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--total-scale-factor))`;
        style.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...fontColor);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $b3a01b20dd2ade98$var$TextWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
            this.contentElement = element;
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = 0;
            const { datetimeFormat: datetimeFormat, datetimeType: datetimeType, timeStep: timeStep } = this.data;
            const hasDateOrTime = !!datetimeType && this.enableScripting;
            if (datetimeFormat) element.title = datetimeFormat;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (hasDateOrTime) {
                        target.type = datetimeType;
                        if (timeStep) target.step = timeStep;
                    }
                    if (elementData.userValue) {
                        const value = elementData.userValue;
                        if (hasDateOrTime) {
                            if (datetimeType === "time") {
                                const date = new Date(value);
                                const parts = [
                                    date.getHours(),
                                    date.getMinutes(),
                                    date.getSeconds()
                                ];
                                target.value = parts.map((v)=>v.toString().padStart(2, "0")).join(":");
                            } else target.value = new Date(value - $b3a01b20dd2ade98$var$TIMEZONE_OFFSET).toISOString().split(datetimeType === "date" ? "T" : ".", 1)[0];
                        } else target.value = value;
                    }
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            if (!hasDateOrTime) storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            const data = {
                                formattedValue: formattedValue
                            };
                            if (hasDateOrTime) data.value = formattedValue;
                            storage.setValue(id, data);
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { target: target } = event;
                    let { value: value } = target;
                    if (hasDateOrTime) {
                        if (value && datetimeType === "time") {
                            const parts = value.split(":").map((v)=>parseInt(v, 10));
                            value = new Date(2000, 0, 1, parts[0], parts[1], parts[2] || 0).valueOf();
                            target.step = "";
                        } else {
                            if (!value.includes("T")) value = `${value}T00:00`;
                            value = new Date(value).valueOf();
                        }
                        target.type = "text";
                    }
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--total-scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$SignatureWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $b3a01b20dd2ade98$var$CheckboxWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PushButtonWidgetAnnotationElement extends $b3a01b20dd2ade98$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $b3a01b20dd2ade98$var$ChoiceWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = 0;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        const fixDisplayValue = (option, value)=>{
            const newValue = value.replaceAll(" ", "\u00A0");
            option.textContent = newValue;
            if (newValue !== value) option.setAttribute("display-value", value);
        };
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            fixDisplayValue(optionElement, option.displayValue);
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.getAttribute("display-value") || option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        fixDisplayValue(optionElement, displayValue);
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            fixDisplayValue(optionElement, displayValue);
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PopupAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements, parent: parent } = parameters;
        const hasCommentManager = !!parent._commentManager;
        super(parameters, {
            isRenderable: !hasCommentManager && $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        if (hasCommentManager && $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(data)) {
            const popup = this.popup = this.#createPopup();
            for (const element of elements)element.popup = popup;
        } else this.popup = null;
    }
    #createPopup() {
        return new $b3a01b20dd2ade98$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate || this.data.creationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open,
            commentManager: this.parent._commentManager
        });
    }
    render() {
        const { container: container } = this;
        container.classList.add("popupAnnotation");
        container.role = "comment";
        const popup = this.popup = this.#createPopup();
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            element.container.ariaHasPopup = "dialog";
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PopupElement {
    #commentManager = null;
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #popupAbortController = null;
    #position = null;
    #commentButton = null;
    #commentButtonPosition = null;
    #popupPosition = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    #firstElement = null;
    #commentText = null;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open, commentManager: commentManager = null }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#commentManager = commentManager;
        this.#firstElement = elements[0];
        this.#dateObj = $b3a01b20dd2ade98$export$66cbc314498fffc.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        if (!commentManager) {
            this.#addEventListeners();
            this.#container.hidden = true;
            if (open) this.#toggle();
        }
    }
    #addEventListeners() {
        if (this.#popupAbortController) return;
        this.#popupAbortController = new AbortController();
        const { signal: signal } = this.#popupAbortController;
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle, {
                signal: signal
            });
            element.addEventListener("pointerenter", this.#boundShow, {
                signal: signal
            });
            element.addEventListener("pointerleave", this.#boundHide, {
                signal: signal
            });
            element.classList.add("popupTriggerArea");
        }
        for (const element of this.#elements)element.container?.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
    }
    #setCommentButtonPosition() {
        const element = this.#elements.find((e)=>e.hasCommentButton);
        if (!element) return;
        this.#commentButtonPosition = element._normalizePoint(element.commentButtonPosition);
    }
    renderCommentButton() {
        if (this.#commentButton) {
            if (!this.#commentButton.parentNode) this.#firstElement.container.after(this.#commentButton);
            return;
        }
        if (!this.#commentButtonPosition) this.#setCommentButtonPosition();
        if (!this.#commentButtonPosition) return;
        const { signal: signal } = this.#popupAbortController = new AbortController();
        const hasOwnButton = this.#firstElement.hasOwnCommentButton;
        const togglePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, true, undefined, !hasOwnButton);
        };
        const showPopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, true, !hasOwnButton);
        };
        const hidePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, false);
        };
        if (!hasOwnButton) {
            const button = this.#commentButton = document.createElement("button");
            button.className = "annotationCommentButton";
            const parentContainer = this.#firstElement.container;
            button.style.zIndex = parseInt(parentContainer.style.zIndex, 10) + 1;
            button.tabIndex = 0;
            button.ariaHasPopup = "dialog";
            button.ariaControls = "commentPopup";
            button.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
            this.#updateColor();
            this.#updateCommentButtonPosition();
            button.addEventListener("keydown", this.#boundKeyDown, {
                signal: signal
            });
            button.addEventListener("click", togglePopup, {
                signal: signal
            });
            button.addEventListener("pointerenter", showPopup, {
                signal: signal
            });
            button.addEventListener("pointerleave", hidePopup, {
                signal: signal
            });
            parentContainer.after(button);
        } else {
            this.#commentButton = this.#firstElement.container;
            for (const element of this.trigger){
                element.ariaHasPopup = "dialog";
                element.ariaControls = "commentPopup";
                element.addEventListener("keydown", this.#boundKeyDown, {
                    signal: signal
                });
                element.addEventListener("click", togglePopup, {
                    signal: signal
                });
                element.addEventListener("pointerenter", showPopup, {
                    signal: signal
                });
                element.addEventListener("pointerleave", hidePopup, {
                    signal: signal
                });
                element.classList.add("popupTriggerArea");
            }
        }
    }
    #updateCommentButtonPosition() {
        if (this.#firstElement.extraPopupElement && !this.#firstElement.editor) return;
        if (!this.#commentButton) this.renderCommentButton();
        const [x, y] = this.#commentButtonPosition;
        const { style: style } = this.#commentButton;
        style.left = `calc(${x}%)`;
        style.top = `calc(${y}% - var(--comment-button-dim))`;
    }
    #updateColor() {
        if (this.#firstElement.extraPopupElement) return;
        if (!this.#commentButton) this.renderCommentButton();
        this.#commentButton.style.backgroundColor = this.commentButtonColor || "";
    }
    get commentButtonColor() {
        const { color: color, opacity: opacity } = this.#firstElement.commentData;
        if (!color) return null;
        return this.#parent._commentManager.makeCommentColor(color, opacity);
    }
    focusCommentButton() {
        setTimeout(()=>{
            this.#commentButton?.focus();
        }, 0);
    }
    getData() {
        const { richText: richText, color: color, opacity: opacity, creationDate: creationDate, modificationDate: modificationDate } = this.#firstElement.commentData;
        return {
            contentsObj: {
                str: this.comment
            },
            richText: richText,
            color: color,
            opacity: opacity,
            creationDate: creationDate,
            modificationDate: modificationDate
        };
    }
    get elementBeforePopup() {
        return this.#commentButton;
    }
    get comment() {
        this.#commentText ||= this.#firstElement.commentText;
        return this.#commentText;
    }
    set comment(text) {
        if (text === this.comment) return;
        this.#firstElement.commentText = this.#commentText = text;
    }
    focus() {
        this.#firstElement.container?.focus();
    }
    get parentBoundingClientRect() {
        return this.#firstElement.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentButton) return;
        this.#commentButton.classList.toggle("selected", selected);
        this.#commentButton.ariaExpanded = hasPopup;
    }
    setSelectedCommentButton(selected) {
        this.#commentButton.classList.toggle("selected", selected);
    }
    get commentPopupPosition() {
        if (this.#popupPosition) return this.#popupPosition;
        const { x: x, y: y, height: height } = this.#commentButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#firstElement.layer.getBoundingClientRect();
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPosition(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    get commentButtonPosition() {
        return this.#commentButtonPosition;
    }
    get commentButtonWidth() {
        return this.#commentButton.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(options) {
        const [posX, posY] = this.#popupPosition || this.commentButtonPosition.map((x)=>x / 100);
        const parentDimensions = this.parentBoundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#commentManager.showDialog(null, this, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...this.#color);
            popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
        }
        const header = document.createElement("span");
        header.className = "header";
        if (this.#titleObj?.str) {
            const title = document.createElement("span");
            title.className = "title";
            header.append(title);
            ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        }
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("time");
            modificationDate.className = "popupDate";
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: this.#dateObj.valueOf()
            }));
            modificationDate.dateTime = this.#dateObj.toISOString();
            header.append(modificationDate);
        }
        $b3a01b20dd2ade98$export$611c480766035c4({
            html: this.#html || this.#contentsObj.str,
            dir: this.#contentsObj?.dir,
            className: "popupContent"
        }, popup);
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--total-scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popup: popup, deleted: deleted }) {
        if (this.#commentManager) {
            if (deleted) {
                this.remove();
                this.#commentText = null;
            } else if (popup) {
                if (popup.deleted) this.remove();
                else {
                    this.#updateColor();
                    this.#commentText = popup.text;
                }
            }
            if (rect) {
                this.#commentButtonPosition = null;
                this.#setCommentButtonPosition();
                this.#updateCommentButtonPosition();
            }
            return;
        }
        if (deleted || popup?.deleted) {
            this.remove();
            return;
        }
        this.#addEventListeners();
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popup && popup.text) {
            this.#richText = this.#makePopupContent(popup.text);
            this.#dateObj = $b3a01b20dd2ade98$export$66cbc314498fffc.toDateObject(popup.date);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    remove() {
        this.#popupAbortController?.abort();
        this.#popupAbortController = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#wasVisible = false;
        this.#pinned = false;
        this.#commentButton?.remove();
        this.#commentButton = null;
        if (this.trigger) for (const element of this.trigger)element.classList.remove("popupTriggerArea");
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        if (this.#commentManager) {
            this.#commentManager.toggleCommentPopup(this, false);
            return;
        }
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex, 10) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex, 10) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (this.#commentManager) return;
        this.#addEventListeners();
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        if (this.#commentManager) return false;
        return this.#container.hidden === false;
    }
}
class $b3a01b20dd2ade98$var$FreeTextAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = this.contentElement = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$LineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$SquareAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$CircleAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$PolylineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef }, width: width, height: height } = this;
        if (!vertices) return this.container;
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$PolygonAnnotationElement extends $b3a01b20dd2ade98$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $b3a01b20dd2ade98$var$CaretAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$InkAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #polylinesGroupElement = null;
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = this.data.it === "InkHighlight" ? $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT : $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK;
    }
    #getTransform(rotation, rect) {
        switch(rotation){
            case 90:
                return {
                    transform: `rotate(90) translate(${-rect[0]},${rect[1]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            case 180:
                return {
                    transform: `rotate(180) translate(${-rect[2]},${rect[1]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
            case 270:
                return {
                    transform: `rotate(270) translate(${-rect[2]},${rect[3]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            default:
                return {
                    transform: `translate(${-rect[0]},${rect[3]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
        }
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, rotation: rotation, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { transform: transform, width: width, height: height } = this.#getTransform(rotation, rect);
        const svg = this.svgFactory.create(width, height, true);
        const g = this.#polylinesGroupElement = this.svgFactory.createElement("svg:g");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for(let i = 0, ii = inkLists.length; i < ii; i++){
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    }
    updateEdited(params) {
        super.updateEdited(params);
        const { thickness: thickness, points: points, rect: rect } = params;
        const g = this.#polylinesGroupElement;
        if (thickness >= 0) g.setAttribute("stroke-width", thickness || 1);
        if (points) for(let i = 0, ii = this.#polylines.length; i < ii; i++)this.#polylines[i].setAttribute("points", points[i].join(","));
        if (rect) {
            const { transform: transform, width: width, height: height } = this.#getTransform(this.data.rotation, rect);
            const root = g.parentElement;
            root.setAttribute("viewBox", `0 0 ${width} ${height}`);
            g.setAttribute("transform", transform);
        }
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$HighlightAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT;
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        if (overlaidText) {
            const mark = document.createElement("mark");
            mark.classList.add("overlaidText");
            mark.textContent = overlaidText;
            this.container.append(mark);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$UnderlineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("underlineAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$SquigglyAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("squigglyAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$StrikeOutAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("strikeoutAnnotation");
        if (overlaidText) {
            const strikeout = document.createElement("s");
            strikeout.classList.add("overlaidText");
            strikeout.textContent = overlaidText;
            this.container.append(strikeout);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$StampAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP;
    }
    render() {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$FileAttachmentAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        } else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $b3a01b20dd2ade98$export$3e7f45c326d9366c {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #annotationStorage = null;
    #editableAnnotations = new Map();
    #structTreeLayer = null;
    #linkService = null;
    #elements = [];
    #hasAriaAttributesFromStructTree = false;
    zIndex = 0;
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport, structTreeLayer: structTreeLayer, commentManager: commentManager, linkService: linkService, annotationStorage: annotationStorage }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.#structTreeLayer = structTreeLayer || null;
        this.#linkService = linkService || null;
        this.#annotationStorage = annotationStorage || new $b3a01b20dd2ade98$var$AnnotationStorage();
        this.page = page;
        this.viewport = viewport;
        this._annotationEditorUIManager = annotationEditorUIManager;
        this._commentManager = commentManager || null;
    }
    hasEditableAnnotations() {
        return this.#editableAnnotations.size > 0;
    }
    async render(params) {
        const { annotations: annotations } = params;
        const layer = this.div;
        $b3a01b20dd2ade98$export$af0a15a86e590226(layer, this.viewport);
        const popupToElements = new Map();
        const popupAnnotations = [];
        const elementParams = {
            data: null,
            layer: layer,
            linkService: this.#linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $b3a01b20dd2ade98$export$425e69f00724e63a(),
            annotationStorage: this.#annotationStorage,
            enableComment: params.enableComment === true,
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POPUP;
            if (!isPopupAnnotation) {
                if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                if (!this._commentManager) {
                    popupAnnotations.push(data);
                    continue;
                }
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation) {
                this.#elements.push(element);
                if (data.popupRef) popupToElements.getOrInsertComputed(data.popupRef, $b3a01b20dd2ade98$export$be9af9a47496243a).push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            if (element._isEditable) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        await this.#addElementsToDOM();
        for (const data of popupAnnotations){
            const elements = elementParams.elements = popupToElements.get(data.id);
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            const rendered = element.render();
            element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${data.id}`;
            if (data.hidden) rendered.style.visibility = "hidden";
            elements.at(-1).container.after(rendered);
        }
        this.#setAnnotationCanvasMap();
    }
    async #addElementsToDOM() {
        if (this.#elements.length === 0) return;
        this.div.replaceChildren();
        const promises = [];
        if (!this.#hasAriaAttributesFromStructTree) {
            this.#hasAriaAttributesFromStructTree = true;
            for (const { contentElement: contentElement, data: { id: id } } of this.#elements){
                const annotationId = contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`;
                promises.push(this.#structTreeLayer?.getAriaAttributes(annotationId).then((ariaAttributes)=>{
                    if (ariaAttributes) for (const [key, value] of ariaAttributes)contentElement.setAttribute(key, value);
                }));
            }
        }
        this.#elements.sort(({ data: { rect: [a0, a1, a2, a3] } }, { data: { rect: [b0, b1, b2, b3] } })=>{
            if (a0 === a2 && a1 === a3) return 1;
            if (b0 === b2 && b1 === b3) return -1;
            const top1 = a3;
            const bot1 = a1;
            const mid1 = (a1 + a3) / 2;
            const top2 = b3;
            const bot2 = b1;
            const mid2 = (b1 + b3) / 2;
            if (mid1 >= top2 && mid2 <= bot1) return -1;
            if (mid2 >= top1 && mid1 <= bot2) return 1;
            const centerX1 = (a0 + a2) / 2;
            const centerX2 = (b0 + b2) / 2;
            return centerX1 - centerX2;
        });
        const fragment = document.createDocumentFragment();
        for (const element of this.#elements){
            fragment.append(element.container);
            if (this._commentManager) (element.extraPopupElement?.popup || element.popup)?.renderCommentButton();
            else if (element.extraPopupElement) fragment.append(element.extraPopupElement.render());
        }
        this.div.append(fragment);
        await Promise.all(promises);
        if (this.#accessibilityManager) for (const element of this.#elements)this.#accessibilityManager.addPointerInTextLayer(element.contentElement, false);
    }
    async addLinkAnnotations(annotations) {
        const elementParams = {
            data: null,
            layer: this.div,
            linkService: this.#linkService,
            svgFactory: new $b3a01b20dd2ade98$export$425e69f00724e63a(),
            parent: this
        };
        for (const data of annotations){
            data.borderStyle ||= $b3a01b20dd2ade98$export$3e7f45c326d9366c._defaultBorderStyle;
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            element.render();
            element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${data.id}`;
            this.#elements.push(element);
        }
        await this.#addElementsToDOM();
    }
    update({ viewport: viewport }) {
        const layer = this.div;
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(layer, {
            rotation: viewport.rotation
        });
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
            const editableAnnotation = this.#editableAnnotations.get(id);
            if (!editableAnnotation) continue;
            if (editableAnnotation._hasNoCanvas) {
                this._annotationEditorUIManager?.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            } else editableAnnotation.canvas = canvas;
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return this.#editableAnnotations.values();
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
    addFakeAnnotation(editor) {
        const { div: div } = this;
        const { id: id, rotation: rotation } = editor;
        const element = new $b3a01b20dd2ade98$var$EditorAnnotationElement({
            data: {
                id: id,
                rect: editor.getPDFRect(),
                rotation: rotation
            },
            editor: editor,
            layer: div,
            parent: this,
            enableComment: !!this._commentManager,
            linkService: this.#linkService,
            annotationStorage: this.#annotationStorage
        });
        element.render();
        element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`;
        element.createOrUpdatePopup();
        this.#elements.push(element);
        return element;
    }
    removeAnnotation(id) {
        const index = this.#elements.findIndex((el)=>el.data.id === id);
        if (index < 0) return;
        const [element] = this.#elements.splice(index, 1);
        this.#accessibilityManager?.removePointerInTextLayer(element.contentElement);
    }
    updateFakeAnnotations(editors) {
        if (editors.length === 0) return;
        for (const editor of editors)editor.updateFakeAnnotationElement(this);
        this.#addElementsToDOM();
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    static get _defaultBorderStyle() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_defaultBorderStyle", Object.freeze({
            width: 1,
            rawWidth: 1,
            style: $b3a01b20dd2ade98$var$AnnotationBorderStyleType.SOLID,
            dashArray: [
                3
            ],
            horizontalCornerRadius: 0,
            verticalCornerRadius: 0
        }));
    }
}
const $b3a01b20dd2ade98$var$EOL_PATTERN = /\r\n?|\n/g;
class $b3a01b20dd2ade98$var$FreeTextEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #editModeAC = null;
    #fontSize;
    _colorPicker = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.color = params.color || $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor || $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize;
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
        this.canAddComment = false;
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor || $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                this.color
            ]
        ];
    }
    get toolbarButtons() {
        this._colorPicker ||= new $b3a01b20dd2ade98$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR;
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--total-scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    onUpdatedColor() {
        this.editorDiv.style.color = this.color;
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$b3a01b20dd2ade98$var$FreeTextEditor._internalPadding * scale,
            -($b3a01b20dd2ade98$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (!super.enableEditMode()) return false;
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        this.#editModeAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#editModeAC);
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
        return true;
    }
    disableEditMode() {
        if (!super.disableEditMode()) return false;
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.#editModeAC?.abort();
        this.#editModeAC = null;
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
        return true;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded(focus) {
        if (this.width) return;
        this.enableEditMode();
        if (focus) this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        let prevChild = null;
        for (const child of this.editorDiv.childNodes){
            if (prevChild?.nodeType === Node.TEXT_NODE && child.nodeName === "BR") continue;
            buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
            prevChild = child;
        }
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $b3a01b20dd2ade98$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    get canChangeContent() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        if (this._isCopy || this.annotationElementId) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this._initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this._moveAfterPaste(baseX, baseY);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $b3a01b20dd2ade98$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = Math.sumPrecise(bufferBefore.map((line)=>line.length));
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    getPDFRect() {
        const padding = $b3a01b20dd2ade98$var$FreeTextEditor._internalPadding * this.parentScale;
        return this.getRect(padding, padding);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                comment: contentsObj?.str || null,
                richText: richText,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...data.color);
        editor.#content = $b3a01b20dd2ade98$var$FreeTextEditor.#deserializeContent(data.value);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color);
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent()
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (!content) return null;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
                text: this.#content
            }
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $b3a01b20dd2ade98$var$Outline {
    static PRECISION = 1e-4;
    toSVGPath() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        $b3a01b20dd2ade98$var$unreachable("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `serialize` must be implemented.");
    }
    static _rescale(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    static _rescaleAndSwap(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    static _translate(src, tx, ty, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    }
    static svgRound(x) {
        return Math.round(x * 10000);
    }
    static _normalizePoint(x, y, parentWidth, parentHeight, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y / parentWidth,
                    x / parentHeight
                ];
            case 180:
                return [
                    1 - x / parentWidth,
                    1 - y / parentHeight
                ];
            case 270:
                return [
                    y / parentWidth,
                    1 - x / parentHeight
                ];
            default:
                return [
                    x / parentWidth,
                    y / parentHeight
                ];
        }
    }
    static _normalizePagePoint(x, y, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x
                ];
            case 180:
                return [
                    1 - x,
                    1 - y
                ];
            case 270:
                return [
                    y,
                    1 - x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    static createBezierPoints(x1, y1, x2, y2, x3, y3) {
        return [
            (x1 + 5 * x2) / 6,
            (y1 + 5 * y2) / 6,
            (5 * x2 + x3) / 6,
            (5 * y2 + y3) / 6,
            (x2 + x3) / 2,
            (y2 + y3) / 2
        ];
    }
}
class $b3a01b20dd2ade98$var$FreeDrawOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float32Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIST + $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIST * scaleFactor;
        this.#min = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        if (isNaN(this.#last[6]) && !this.isEmpty()) return this.#toSVGPathTwoPoints();
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        this.#toSVGPathEnd(buffer);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        this.#toSVGPathStart(buffer);
        return buffer.join(" ");
    }
    #toSVGPathTwoPoints() {
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
    }
    #toSVGPathStart(buffer) {
        const bottom = this.#bottom;
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
    }
    #toSVGPathEnd(buffer) {
        const [x, y, width, height] = this.#box;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
    }
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $b3a01b20dd2ade98$var$FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float32Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) return this.#getOutlineTwoPoints(points);
        const outline = new Float32Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = this.#getOutlineEnd(outline, N);
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        this.#getOutlineStart(outline, N);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineTwoPoints(points) {
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        const outline = new Float32Array(36);
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (last[2] - layerX) / layerWidth,
            (last[3] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[4] - layerX) / layerWidth,
            (last[5] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[16] - layerX) / layerWidth,
            (last[17] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[14] - layerX) / layerWidth,
            (last[15] - layerY) / layerHeight
        ], 0);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineStart(outline, pos) {
        const bottom = this.#bottom;
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], pos);
        return pos += 6;
    }
    #getOutlineEnd(outline, pos) {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], pos);
        return pos += 24;
    }
}
class $b3a01b20dd2ade98$var$FreeDrawOutline extends $b3a01b20dd2ade98$var$Outline {
    #box;
    #bbox = new Float32Array(4);
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.firstPoint = [
            NaN,
            NaN
        ];
        this.lastPoint = [
            NaN,
            NaN
        ];
        this.#computeMinMax(isLTR);
        const [x, y, width, height] = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = $b3a01b20dd2ade98$var$Outline._rescale(this.#outline, blX, trY, width, -height);
                points = $b3a01b20dd2ade98$var$Outline._rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = $b3a01b20dd2ade98$var$Outline._rescale(this.#outline, trX, blY, -width, height);
                points = $b3a01b20dd2ade98$var$Outline._rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        const minMax = [
            lastX,
            lastY,
            lastX,
            lastY
        ];
        let firstPointX = lastX;
        let firstPointY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        const bezierBbox = new Float32Array(4);
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            const x = outline[i + 4], y = outline[i + 5];
            if (isNaN(outline[i])) {
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(x, y, minMax);
                if (firstPointY > y) {
                    firstPointX = x;
                    firstPointY = y;
                } else if (firstPointY === y) firstPointX = ltrCallback(firstPointX, x);
                if (lastPointY < y) {
                    lastPointX = x;
                    lastPointY = y;
                } else if (lastPointY === y) lastPointX = ltrCallback(lastPointX, x);
            } else {
                bezierBbox.set($b3a01b20dd2ade98$var$BBOX_INIT, 0);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6), bezierBbox);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.rectBoundingBox(...bezierBbox, minMax);
                if (firstPointY > bezierBbox[1]) {
                    firstPointX = bezierBbox[0];
                    firstPointY = bezierBbox[1];
                } else if (firstPointY === bezierBbox[1]) firstPointX = ltrCallback(firstPointX, bezierBbox[0]);
                if (lastPointY < bezierBbox[3]) {
                    lastPointX = bezierBbox[2];
                    lastPointY = bezierBbox[3];
                } else if (lastPointY === bezierBbox[3]) lastPointX = ltrCallback(lastPointX, bezierBbox[2]);
            }
            lastX = x;
            lastY = y;
        }
        const bbox = this.#bbox;
        bbox[0] = minMax[0] - this.#innerMargin;
        bbox[1] = minMax[1] - this.#innerMargin;
        bbox[2] = minMax[2] - minMax[0] + 2 * this.#innerMargin;
        bbox[3] = minMax[3] - minMax[1] + 2 * this.#innerMargin;
        this.firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.lastPoint = [
            lastPointX,
            lastPointY
        ];
    }
    get box() {
        return this.#bbox;
    }
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $b3a01b20dd2ade98$var$FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
    getNewOutline(thickness, innerMargin) {
        const [x, y, width, height] = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = this.newOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $b3a01b20dd2ade98$var$HighlightOutliner {
    #box;
    #firstPoint;
    #lastPoint;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        const minMax = $b3a01b20dd2ade98$var$BBOX_INIT.slice();
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.rectBoundingBox(x1, y1, x2, y2, minMax);
        }
        const bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        const bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        const shiftedMinX = minMax[0] - innerMargin;
        const shiftedMinY = minMax[1] - innerMargin;
        let firstPointX = isLTR ? -Infinity : Infinity;
        let firstPointY = Infinity;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2, left] = edge;
            if (!left && isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.max(firstPointX, x);
            } else if (left && !isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.min(firstPointX, x);
            }
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = new Float32Array([
            shiftedMinX,
            shiftedMinY,
            bboxWidth,
            bboxHeight
        ]);
        this.#firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.#lastPoint = lastPoint;
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $b3a01b20dd2ade98$var$HighlightOutline(outlines, this.#box, this.#firstPoint, this.#lastPoint);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $b3a01b20dd2ade98$var$HighlightOutline extends $b3a01b20dd2ade98$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box, firstPoint, lastPoint){
        super();
        this.#outlines = outlines;
        this.#box = box;
        this.firstPoint = firstPoint;
        this.lastPoint = lastPoint;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
    get classNamesForOutlining() {
        return [
            "highlightOutline"
        ];
    }
}
class $b3a01b20dd2ade98$var$FreeHighlightOutliner extends $b3a01b20dd2ade98$var$FreeDrawOutliner {
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $b3a01b20dd2ade98$var$FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
}
class $b3a01b20dd2ade98$var$FreeHighlightOutline extends $b3a01b20dd2ade98$var$FreeDrawOutline {
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $b3a01b20dd2ade98$var$FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
}
class $b3a01b20dd2ade98$var$HighlightEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #firstPoint = null;
    #lastPoint = null;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = "highlight";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$var$HighlightEditor.prototype;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $b3a01b20dd2ade98$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness;
        this.opacity = params.opacity || $b3a01b20dd2ade98$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else if (this.#boxes) {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.getNonHCMColorName(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.getNonHCMColorName(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $b3a01b20dd2ade98$var$HighlightOutliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        [this.x, this.y, this.width, this.height] = this.#highlightOutlines.box;
        const outlinerForOutline = new $b3a01b20dd2ade98$var$HighlightOutliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { firstPoint: firstPoint } = this.#highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - this.x) / this.width,
            (firstPoint[1] - this.y) / this.height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.#outlineId = this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: this.#focusOutlines.box,
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            }, true);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(this.#id, {
                bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            });
        }
        const [x, y, width, height] = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { firstPoint: firstPoint } = highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - x) / width,
            (firstPoint[1] - y) / height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        $b3a01b20dd2ade98$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                $b3a01b20dd2ade98$var$HighlightEditor._defaultColor = value;
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    get commentButtonPosition() {
        return this.#firstPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                $b3a01b20dd2ade98$var$HighlightEditor._defaultColor
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                this.color || $b3a01b20dd2ade98$var$HighlightEditor._defaultColor
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                this.#thickness || $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    onUpdatedColor() {
        this.parent?.drawLayer.updateProperties(this.#id, {
            root: {
                fill: this.color,
                "fill-opacity": this.opacity
            }
        });
        this.#colorPicker?.updateColor(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColorAndOpacity = (col, opa)=>{
            this.color = col;
            this.opacity = opa;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, $b3a01b20dd2ade98$var$HighlightEditor._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.getNonHCMColorName(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    get toolbarButtons() {
        if (this._uiManager.highlightColors) {
            const colorPicker = this.#colorPicker = new $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3({
                editor: this
            });
            return [
                [
                    "colorPicker",
                    colorPicker
                ]
            ];
        }
        return super.toolbarButtons;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        if (focus) this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        this.setDims();
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.draw({
            bbox: this.#highlightOutlines.box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": this.opacity
            },
            rootClass: {
                highlight: true,
                free: this.#isFreeHighlight
            },
            path: {
                d: this.#highlightOutlines.toSVGPath()
            }
        }, false, true));
        this.#outlineId = parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: this.#isFreeHighlight
            },
            bbox: this.#focusOutlines.box,
            path: {
                d: this.#focusOutlines.toSVGPath()
            }
        }, this.#isFreeHighlight);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox([x, y, width, height], angle) {
        switch(angle){
            case 90:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 180:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
        }
        return [
            x,
            y,
            width,
            height
        ];
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox([
            this.x,
            this.y,
            this.width,
            this.height
        ], angle);
        drawLayer.updateProperties(this.#id, {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(this.#outlineId, {
            bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#keydown.bind(this), {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        this.setDims();
        $b3a01b20dd2ade98$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: true
            }
        });
    }
    pointerleave() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false
            }
        });
    }
    #keydown(event) {
        $b3a01b20dd2ade98$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                selected: false
            }
        });
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(this.#id, {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth + pageX;
            const sy = (1 - y) * pageHeight + pageY;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const ac = new AbortController();
        const signal = parent.combinedSignal(ac);
        const pointerUpCallback = (e)=>{
            ac.abort();
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", this.#highlightMove.bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new $b3a01b20dd2ade98$var$FreeHighlightOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.draw({
            bbox: [
                0,
                0,
                1,
                1
            ],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updateProperties(this._freeHighlightId, {
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        });
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.remove(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$HighlightAnnotationElement) {
            const { data: { quadPoints: quadPoints, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                opacity: opacity,
                quadPoints: quadPoints,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        } else if (data instanceof $b3a01b20dd2ade98$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                thickness: thickness,
                inkLists: inkLists,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const { color: color, quadPoints: quadPoints, inkLists: inkLists, outlines: outlines, opacity: opacity } = data;
        const editor = await super.deserialize(data, parent, uiManager);
        editor.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...color);
        editor.opacity = opacity || 1;
        if (inkLists) editor.#thickness = data.thickness;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [pageX, pageY] = editor.pageTranslation;
        if (quadPoints) {
            const boxes = editor.#boxes = [];
            for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
                x: (quadPoints[i] - pageX) / pageWidth,
                y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
            });
            editor.#createOutlines();
            editor.#addToDrawLayer();
            editor.rotate(editor.rotation);
        } else if (inkLists || outlines) {
            editor.#isFreeHighlight = true;
            const points = (inkLists || outlines.points)[0];
            const point = {
                x: points[0] - pageX,
                y: pageHeight - (points[1] - pageY)
            };
            const outliner = new $b3a01b20dd2ade98$var$FreeHighlightOutliner(point, [
                0,
                0,
                pageWidth,
                pageHeight
            ], 1, editor.#thickness / 2, true, 0.001);
            for(let i = 0, ii = points.length; i < ii; i += 2){
                point.x = points[i] - pageX;
                point.y = pageHeight - (points[i + 1] - pageY);
                outliner.add(point);
            }
            const { id: id, clipPathId: clipPathId } = parent.drawLayer.draw({
                bbox: [
                    0,
                    0,
                    1,
                    1
                ],
                root: {
                    viewBox: "0 0 1 1",
                    fill: editor.color,
                    "fill-opacity": editor._defaultOpacity
                },
                rootClass: {
                    highlight: true,
                    free: true
                },
                path: {
                    d: outliner.toSVGPath()
                }
            }, true, true);
            editor.#createFreeOutlines({
                highlightOutlines: outliner.getOutlines(),
                highlightId: id,
                clipPathId: clipPathId
            });
            editor.#addToDrawLayer();
            editor.rotate(editor.parentRotation);
        }
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
        const serialized = super.serialize(isForCopying);
        Object.assign(serialized, {
            color: color,
            opacity: this.opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(serialized.rect)
        });
        this.addComment(serialized);
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color } = this._initialData;
        return this.hasEditedComment || serialized.color.some((c, i)=>c !== color[i]);
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $b3a01b20dd2ade98$var$DrawingOptions {
    #svgProperties = Object.create(null);
    updateProperty(name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    }
    updateProperties(properties) {
        if (!properties) return;
        for (const [name, value] of Object.entries(properties))if (!name.startsWith("_")) this.updateProperty(name, value);
    }
    updateSVGProperty(name, value) {
        this.#svgProperties[name] = value;
    }
    toSVGProperties() {
        const root = this.#svgProperties;
        this.#svgProperties = Object.create(null);
        return {
            root: root
        };
    }
    reset() {
        this.#svgProperties = Object.create(null);
    }
    updateAll(options = this) {
        this.updateProperties(options);
    }
    clone() {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
}
class $b3a01b20dd2ade98$var$DrawingEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #drawOutlines = null;
    #mustBeCommitted;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #currentDraw = null;
    static #currentDrawingAC = null;
    static #currentDrawingOptions = null;
    static _INNER_MARGIN = 3;
    constructor(params){
        super(params);
        this.#mustBeCommitted = params.mustBeCommitted || false;
        this._addOutlines(params);
    }
    onUpdatedColor() {
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    onUpdatedOpacity() {
        this._colorPicker?.updateOpacity?.(this.opacity);
    }
    _addOutlines(params) {
        if (params.drawOutlines) {
            this.#createDrawOutlines(params);
            this.#addToDrawLayer();
        }
    }
    #createDrawOutlines({ drawOutlines: drawOutlines, drawId: drawId, drawingOptions: drawingOptions }) {
        this.#drawOutlines = drawOutlines;
        this._drawingOptions ||= drawingOptions;
        if (!this.annotationElementId) this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        } else this._drawId = this.#createDrawing(drawOutlines, this.parent);
        this.#updateBbox(drawOutlines.box);
    }
    #createDrawing(drawOutlines, parent) {
        const { id: id } = parent.drawLayer.draw($b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false);
        return id;
    }
    static _mergeSVGProperties(p1, p2) {
        const p1Keys = new Set(Object.keys(p1));
        for (const [key, value] of Object.entries(p2))if (p1Keys.has(key)) Object.assign(p1[key], value);
        else p1[key] = value;
        return p1;
    }
    static getDefaultDrawingOptions(_options) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static get typesMap() {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static get isDrawer() {
        return true;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static updateDefaultParams(type, value) {
        const propertyName = this.typesMap.get(type);
        if (propertyName) this._defaultDrawingOptions.updateProperty(propertyName, value);
        if (this._currentParent) {
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    }
    updateParams(type, value) {
        const propertyName = this.constructor.typesMap.get(type);
        if (propertyName) this._updateProperty(type, propertyName, value);
    }
    static get defaultPropertiesToUpdate() {
        const properties = [];
        const options = this._defaultDrawingOptions;
        for (const [type, name] of this.typesMap)properties.push([
            type,
            options[name]
        ]);
        return properties;
    }
    get propertiesToUpdate() {
        const properties = [];
        const { _drawingOptions: _drawingOptions } = this;
        for (const [type, name] of this.constructor.typesMap)properties.push([
            type,
            _drawingOptions[name]
        ]);
        return properties;
    }
    _updateProperty(type, name, value) {
        const options = this._drawingOptions;
        const savedValue = options[name];
        const setter = (val)=>{
            options.updateProperty(name, val);
            const bbox = this.#drawOutlines.updateProperty(name, val);
            if (bbox) this.#updateBbox(bbox);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            if (type === this.colorType) this.onUpdatedColor();
            else if (type === this.opacityType) this.onUpdatedOpacity();
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _updateColorAndOpacity(color, opacity) {
        const colorName = this.constructor.typesMap.get(this.colorType);
        const opacityName = this.constructor.typesMap.get(this.opacityType);
        const options = this._drawingOptions;
        const savedColor = options[colorName];
        const savedOpacity = options[opacityName];
        const setter = (c, op)=>{
            options.updateProperty(colorName, c);
            options.updateProperty(opacityName, op);
            this.#drawOutlines.updateProperty(colorName, c);
            this.#drawOutlines.updateProperty(opacityName, op);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            this.onUpdatedColor();
            this.onUpdatedOpacity();
        };
        this.addCommands({
            cmd: setter.bind(this, color, opacity),
            undo: setter.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _onResizing() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizingSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onResized() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizedSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onTranslating(_x, _y) {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            bbox: this.#rotateBox()
        });
    }
    _onTranslated() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathTranslatedSVGProperties(this.#convertToDrawSpace(), this.parentDimensions), {
            bbox: this.#rotateBox()
        }));
    }
    _onStartDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    }
    _onStopDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    }
    commit() {
        super.commit();
        this.disableEditMode();
        this.disableEditing();
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    get isResizable() {
        return true;
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        this._isDraggable = true;
        if (this.#mustBeCommitted) {
            this.#mustBeCommitted = false;
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) this.div.focus();
        }
    }
    remove() {
        this.#cleanDrawLayer();
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        this.#updateBbox(this.#drawOutlines.box);
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            this.#cleanDrawLayer();
        } else if (parent) {
            this._uiManager.addShouldRescale(this);
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        if (mustBeSelected) this.select();
    }
    #cleanDrawLayer() {
        if (this._drawId === null || !this.parent) return;
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }
    #addToDrawLayer(parent = this.parent) {
        if (this._drawId !== null && this.parent === parent) return;
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = this.#createDrawing(this.#drawOutlines, parent);
    }
    #convertToParentSpace([x, y, width, height]) {
        const { parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    y,
                    1 - x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    1 - y,
                    x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #convertToDrawSpace() {
        const { x: x, y: y, width: width, height: height, parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #updateBbox(bbox) {
        [this.x, this.y, this.width, this.height] = this.#convertToParentSpace(bbox);
        if (this.div) {
            this.fixAndSetPosition();
            this.setDims();
        }
        this._onResized();
    }
    #rotateBox() {
        const { x: x, y: y, width: width, height: height, rotation: rotation, parentRotation: parentRotation, parentDimensions: [pW, pH] } = this;
        switch((rotation * 4 + parentRotation) / 90){
            case 1:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 2:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 3:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
            case 4:
                return [
                    x,
                    y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 5:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 6:
                return [
                    1 - x - height * (pH / pW),
                    1 - y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 7:
                return [
                    y - width * (pW / pH),
                    1 - x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 8:
                return [
                    x - width,
                    y - height,
                    width,
                    height
                ];
            case 9:
                return [
                    1 - y,
                    x - width,
                    height,
                    width
                ];
            case 10:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 11:
                return [
                    y - height,
                    1 - x,
                    height,
                    width
                ];
            case 12:
                return [
                    x - height * (pH / pW),
                    y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 13:
                return [
                    1 - y - width * (pW / pH),
                    x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 14:
                return [
                    1 - x,
                    1 - y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 15:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    rotate() {
        if (!this.parent) return;
        this.parent.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties({
            bbox: this.#rotateBox()
        }, this.#drawOutlines.updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    }
    onScaleChanging() {
        if (!this.parent) return;
        this.#updateBbox(this.#drawOutlines.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        const div = super.render();
        div.classList.add("draw");
        const drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        this.setDims();
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        return div;
    }
    static createDrawerInstance(_x, _y, _parentWidth, _parentHeight, _rotation) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static startDrawing(parent, uiManager, _isLTR, event) {
        const { target: target, offsetX: x, offsetY: y, pointerId: pointerId, pointerType: pointerType } = event;
        if ($b3a01b20dd2ade98$var$CurrentPointers.isInitializedAndDifferentPointerType(pointerType)) return;
        const { viewport: { rotation: rotation } } = parent;
        const { width: parentWidth, height: parentHeight } = target.getBoundingClientRect();
        const ac = $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC = new AbortController();
        const signal = parent.combinedSignal(ac);
        $b3a01b20dd2ade98$var$CurrentPointers.setPointer(pointerType, pointerId);
        window.addEventListener("pointerup", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._endDraw(e);
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._currentParent.endDrawingSession();
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", (e)=>{
            if (!$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerType(e.pointerType)) return;
            $b3a01b20dd2ade98$var$CurrentPointers.initializeAndAddPointerId(e.pointerId);
            if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isCancellable()) {
                $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.removeLastElement();
                if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isEmpty()) this._currentParent.endDrawingSession(true);
                else this._endDraw(null);
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSameTimeStamp(e.timeStamp)) $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        uiManager._editorUndoBar?.hide();
        if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw) {
            parent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw = this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation);
        $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions = this.getDefaultDrawingOptions();
        this._currentParent = parent;
        ({ id: this._currentDrawId } = parent.drawLayer.draw(this._mergeSVGProperties($b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions.toSVGProperties(), $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.defaultSVGProperties), true, false));
    }
    static _drawMove(event) {
        $b3a01b20dd2ade98$var$CurrentPointers.isSameTimeStamp(event.timeStamp);
        if (!$b3a01b20dd2ade98$var$DrawingEditor.#currentDraw) return;
        const { offsetX: offsetX, offsetY: offsetY, pointerId: pointerId } = event;
        if (!$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerId(pointerId)) return;
        if ($b3a01b20dd2ade98$var$CurrentPointers.isUsingMultiplePointers()) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.add(offsetX, offsetY));
        $b3a01b20dd2ade98$var$CurrentPointers.setTimeStamp(event.timeStamp);
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(event);
    }
    static _cleanup(all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw = null;
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions = null;
            $b3a01b20dd2ade98$var$CurrentPointers.clearTimeStamp();
        }
        if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC) {
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC.abort();
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC = null;
            $b3a01b20dd2ade98$var$CurrentPointers.clearPointerIds();
        }
    }
    static _endDraw(event) {
        const parent = this._currentParent;
        if (!parent) return;
        parent.toggleDrawing(true);
        this._cleanup(false);
        if (event?.target === parent.div) parent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.end(event.offsetX, event.offsetY));
        if (this.supportMultipleDrawings) {
            const draw = $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw;
            const drawId = this._currentDrawId;
            const lastElement = draw.getLastElement();
            parent.addCommands({
                cmd: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.setLastElement(lastElement));
                },
                undo: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.removeLastElement());
                },
                mustExec: false,
                type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    }
    static endDrawing(isAborted) {
        const parent = this._currentParent;
        if (!parent) return null;
        parent.toggleDrawing(true);
        parent.cleanUndoStack($b3a01b20dd2ade98$export$cf3df2a6ecc26692.DRAW_STEP);
        if (!$b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isEmpty()) {
            const { pageDimensions: [pageWidth, pageHeight], scale: scale } = parent;
            const editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions,
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    }
    createDrawingOptions(_data) {}
    static deserializeDraw(_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static async deserialize(data, parent, uiManager) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = parent.viewport;
        const drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
        const editor = await super.deserialize(data, parent, uiManager);
        editor.createDrawingOptions(data);
        editor.#createDrawOutlines({
            drawOutlines: drawOutlines
        });
        editor.#addToDrawLayer();
        editor.onScaleChanging();
        editor.rotate();
        return editor;
    }
    serializeDraw(isForCopying) {
        const [pageX, pageY] = this.pageTranslation;
        const [pageWidth, pageHeight] = this.pageDimensions;
        return this.#drawOutlines.serialize([
            pageX,
            pageY,
            pageWidth,
            pageHeight
        ], isForCopying);
    }
    renderAnnotationElement(annotation) {
        annotation.updateEdited({
            rect: this.getPDFRect()
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $b3a01b20dd2ade98$var$InkDrawOutliner {
    #last = new Float64Array(6);
    #line;
    #lines;
    #rotation;
    #thickness;
    #points;
    #lastSVGPath = "";
    #lastIndex = 0;
    #outlines = new $b3a01b20dd2ade98$var$InkDrawOutline();
    #parentWidth;
    #parentHeight;
    constructor(x, y, parentWidth, parentHeight, rotation, thickness){
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        this.#thickness = thickness;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        this.#lines = [
            {
                line: line,
                points: this.#points
            }
        ];
        this.#last.set(line, 0);
    }
    updateProperty(name, value) {
        if (name === "stroke-width") this.#thickness = value;
    }
    #normalizePoint(x, y) {
        return $b3a01b20dd2ade98$var$Outline._normalizePoint(x, y, this.#parentWidth, this.#parentHeight, this.#rotation);
    }
    isEmpty() {
        return !this.#lines || this.#lines.length === 0;
    }
    isCancellable() {
        return this.#points.length <= 10;
    }
    add(x, y) {
        [x, y] = this.#normalizePoint(x, y);
        const [x1, y1, x2, y2] = this.#last.subarray(2, 6);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(this.#parentWidth * diffX, this.#parentHeight * diffY);
        if (d <= 2) return null;
        this.#points.push(x, y);
        if (isNaN(x1)) {
            this.#last.set([
                x2,
                y2,
                x,
                y
            ], 2);
            this.#line.push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(this.#last[0])) this.#line.splice(6, 6);
        this.#last.set([
            x1,
            y1,
            x2,
            y2,
            x,
            y
        ], 0);
        this.#line.push(...$b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    end(x, y) {
        const change = this.add(x, y);
        if (change) return change;
        if (this.#points.length === 2) return {
            path: {
                d: this.toSVGPath()
            }
        };
        return null;
    }
    startNew(x, y, parentWidth, parentHeight, rotation) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        const last = this.#lines.at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        this.#lines.push({
            line: line,
            points: this.#points
        });
        this.#last.set(line, 0);
        this.#lastIndex = 0;
        this.toSVGPath();
        return null;
    }
    getLastElement() {
        return this.#lines.at(-1);
    }
    setLastElement(element) {
        if (!this.#lines) return this.#outlines.setLastElement(element);
        this.#lines.push(element);
        this.#line = element.line;
        this.#points = element.points;
        this.#lastIndex = 0;
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        if (!this.#lines) return this.#outlines.removeLastElement();
        this.#lines.pop();
        this.#lastSVGPath = "";
        for(let i = 0, ii = this.#lines.length; i < ii; i++){
            const { line: line, points: points } = this.#lines[i];
            this.#line = line;
            this.#points = points;
            this.#lastIndex = 0;
            this.toSVGPath();
        }
        return {
            path: {
                d: this.#lastSVGPath
            }
        };
    }
    toSVGPath() {
        const firstX = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[4]);
        const firstY = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[5]);
        if (this.#points.length === 2) {
            this.#lastSVGPath = `${this.#lastSVGPath} M ${firstX} ${firstY} Z`;
            return this.#lastSVGPath;
        }
        if (this.#points.length <= 6) {
            const i = this.#lastSVGPath.lastIndexOf("M");
            this.#lastSVGPath = `${this.#lastSVGPath.slice(0, i)} M ${firstX} ${firstY}`;
            this.#lastIndex = 6;
        }
        if (this.#points.length === 4) {
            const secondX = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[10]);
            const secondY = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[11]);
            this.#lastSVGPath = `${this.#lastSVGPath} L ${secondX} ${secondY}`;
            this.#lastIndex = 12;
            return this.#lastSVGPath;
        }
        const buffer = [];
        if (this.#lastIndex === 0) {
            buffer.push(`M ${firstX} ${firstY}`);
            this.#lastIndex = 6;
        }
        for(let i = this.#lastIndex, ii = this.#line.length; i < ii; i += 6){
            const [c1x, c1y, c2x, c2y, x, y] = this.#line.slice(i, i + 6).map($b3a01b20dd2ade98$var$Outline.svgRound);
            buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
        }
        this.#lastSVGPath += buffer.join(" ");
        this.#lastIndex = this.#line.length;
        return this.#lastSVGPath;
    }
    getOutlines(parentWidth, parentHeight, scale, innerMargin) {
        const last = this.#lines.at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        this.#outlines.build(this.#lines, parentWidth, parentHeight, scale, this.#rotation, this.#thickness, innerMargin);
        this.#last = null;
        this.#line = null;
        this.#lines = null;
        this.#lastSVGPath = null;
        return this.#outlines;
    }
    get defaultSVGProperties() {
        return {
            root: {
                viewBox: "0 0 10000 10000"
            },
            rootClass: {
                draw: true
            },
            bbox: [
                0,
                0,
                1,
                1
            ]
        };
    }
}
class $b3a01b20dd2ade98$var$InkDrawOutline extends $b3a01b20dd2ade98$var$Outline {
    #bbox;
    #currentRotation = 0;
    #innerMargin;
    #lines;
    #parentWidth;
    #parentHeight;
    #parentScale;
    #rotation;
    #thickness;
    build(lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#parentScale = parentScale;
        this.#rotation = rotation;
        this.#thickness = thickness;
        this.#innerMargin = innerMargin ?? 0;
        this.#lines = lines;
        this.#computeBbox();
    }
    get thickness() {
        return this.#thickness;
    }
    setLastElement(element) {
        this.#lines.push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        this.#lines.pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    toSVGPath() {
        const buffer = [];
        for (const { line: line } of this.#lines){
            buffer.push(`M${$b3a01b20dd2ade98$var$Outline.svgRound(line[4])} ${$b3a01b20dd2ade98$var$Outline.svgRound(line[5])}`);
            if (line.length === 6) {
                buffer.push("Z");
                continue;
            }
            if (line.length === 12 && isNaN(line[6])) {
                buffer.push(`L${$b3a01b20dd2ade98$var$Outline.svgRound(line[10])} ${$b3a01b20dd2ade98$var$Outline.svgRound(line[11])}`);
                continue;
            }
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6).map($b3a01b20dd2ade98$var$Outline.svgRound);
                buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
            }
        }
        return buffer.join("");
    }
    serialize([pageX, pageY, pageWidth, pageHeight], isForCopying) {
        const serializedLines = [];
        const serializedPoints = [];
        const [x, y, width, height] = this.#getBBoxWithNoMargin();
        let tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch(this.#rotation){
            case 0:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        for (const { line: line, points: points } of this.#lines){
            serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
            serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [
                x1,
                y1,
                x2,
                y2
            ]
        };
    }
    static deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, { paths: { lines: lines, points: points }, rotation: rotation, thickness: thickness }) {
        const newLines = [];
        let tx, ty, sx, sy, rescaleFn;
        switch(rotation){
            case 0:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            for (const point of points){
                const len = point.length;
                if (len === 2) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1]
                    ]));
                    continue;
                }
                if (len === 4) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1],
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[2],
                        point[3]
                    ]));
                    continue;
                }
                const line = new Float32Array(3 * (len - 2));
                lines.push(line);
                let [x1, y1, x2, y2] = point.subarray(0, 4);
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    x1,
                    y1
                ], 0);
                for(let i = 4; i < len; i += 2){
                    const x = point[i];
                    const y = point[i + 1];
                    line.set($b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    [x1, y1, x2, y2] = [
                        x2,
                        y2,
                        x,
                        y
                    ];
                }
            }
        }
        for(let i = 0, ii = lines.length; i < ii; i++)newLines.push({
            line: rescaleFn(lines[i].map((x)=>x ?? NaN), tx, ty, sx, sy),
            points: rescaleFn(points[i].map((x)=>x ?? NaN), tx, ty, sx, sy)
        });
        const outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    }
    #getMarginComponents(thickness = this.#thickness) {
        const margin = this.#innerMargin + thickness / 2 * this.#parentScale;
        return this.#rotation % 180 === 0 ? [
            margin / this.#parentWidth,
            margin / this.#parentHeight
        ] : [
            margin / this.#parentHeight,
            margin / this.#parentWidth
        ];
    }
    #getBBoxWithNoMargin() {
        const [x, y, width, height] = this.#bbox;
        const [marginX, marginY] = this.#getMarginComponents(0);
        return [
            x + marginX,
            y + marginY,
            width - 2 * marginX,
            height - 2 * marginY
        ];
    }
    #computeBbox() {
        const bbox = this.#bbox = $b3a01b20dd2ade98$var$F32_BBOX_INIT.slice();
        for (const { line: line } of this.#lines){
            if (line.length <= 12) {
                for(let i = 4, ii = line.length; i < ii; i += 6)$b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(line[i], line[i + 1], bbox);
                continue;
            }
            let lastX = line[4], lastY = line[5];
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
        const [marginX, marginY] = this.#getMarginComponents();
        bbox[0] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[0] - marginX, 0, 1);
        bbox[1] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[1] - marginY, 0, 1);
        bbox[2] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[2] + marginX, 0, 1);
        bbox[3] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[3] + marginY, 0, 1);
        bbox[2] -= bbox[0];
        bbox[3] -= bbox[1];
    }
    get box() {
        return this.#bbox;
    }
    updateProperty(name, value) {
        if (name === "stroke-width") return this.#updateThickness(value);
        return null;
    }
    #updateThickness(thickness) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#thickness = thickness;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const [diffMarginX, diffMarginY] = [
            newMarginX - oldMarginX,
            newMarginY - oldMarginY
        ];
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateParentDimensions([width, height], scale) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#parentWidth = width;
        this.#parentHeight = height;
        this.#parentScale = scale;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const diffMarginX = newMarginX - oldMarginX;
        const diffMarginY = newMarginY - oldMarginY;
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateRotation(rotation) {
        this.#currentRotation = rotation;
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    }
    get viewBox() {
        return this.#bbox.map($b3a01b20dd2ade98$var$Outline.svgRound).join(" ");
    }
    get defaultProperties() {
        const [x, y] = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(x)} ${$b3a01b20dd2ade98$var$Outline.svgRound(y)}`
            }
        };
    }
    get rotationTransform() {
        const [, , width, height] = this.#bbox;
        let a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
        switch(this.#currentRotation){
            case 90:
                b = height / width;
                c = -width / height;
                e = width;
                break;
            case 180:
                a = -1;
                d = -1;
                e = width;
                f = height;
                break;
            case 270:
                b = -height / width;
                c = width / height;
                f = height;
                break;
            default:
                return "";
        }
        return `matrix(${a} ${b} ${c} ${d} ${$b3a01b20dd2ade98$var$Outline.svgRound(e)} ${$b3a01b20dd2ade98$var$Outline.svgRound(f)})`;
    }
    getPathResizingSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const [x, y, width, height] = this.#bbox;
        if (Math.abs(width - marginX) <= $b3a01b20dd2ade98$var$Outline.PRECISION || Math.abs(height - marginY) <= $b3a01b20dd2ade98$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                    transform: `${this.rotationTransform} translate(${tx} ${ty})`
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const s2x = width / newWidth;
        const s2y = height / newHeight;
        return {
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(x)} ${$b3a01b20dd2ade98$var$Outline.svgRound(y)}`,
                transform: `${this.rotationTransform} scale(${s2x} ${s2y}) ` + `translate(${$b3a01b20dd2ade98$var$Outline.svgRound(marginX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(marginY)}) scale(${s1x} ${s1y}) ` + `translate(${$b3a01b20dd2ade98$var$Outline.svgRound(-marginX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(-marginY)})`
            }
        };
    }
    getPathResizedSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const bbox = this.#bbox;
        const [x, y, width, height] = bbox;
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= $b3a01b20dd2ade98$var$Outline.PRECISION || Math.abs(height - marginY) <= $b3a01b20dd2ade98$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            for (const { line: line, points: points } of this.#lines){
                $b3a01b20dd2ade98$var$Outline._translate(line, tx, ty, line);
                $b3a01b20dd2ade98$var$Outline._translate(points, tx, ty, points);
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const tx = -s1x * (x + marginX) + newX + marginX;
        const ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) for (const { line: line, points: points } of this.#lines){
            $b3a01b20dd2ade98$var$Outline._rescale(line, tx, ty, s1x, s1y, line);
            $b3a01b20dd2ade98$var$Outline._rescale(points, tx, ty, s1x, s1y, points);
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    }
    getPathTranslatedSVGProperties([newX, newY], parentDimensions) {
        const [newParentWidth, newParentHeight] = parentDimensions;
        const bbox = this.#bbox;
        const tx = newX - bbox[0];
        const ty = newY - bbox[1];
        if (this.#parentWidth === newParentWidth && this.#parentHeight === newParentHeight) for (const { line: line, points: points } of this.#lines){
            $b3a01b20dd2ade98$var$Outline._translate(line, tx, ty, line);
            $b3a01b20dd2ade98$var$Outline._translate(points, tx, ty, points);
        }
        else {
            const sx = this.#parentWidth / newParentWidth;
            const sy = this.#parentHeight / newParentHeight;
            this.#parentWidth = newParentWidth;
            this.#parentHeight = newParentHeight;
            for (const { line: line, points: points } of this.#lines){
                $b3a01b20dd2ade98$var$Outline._rescale(line, tx, ty, sx, sy, line);
                $b3a01b20dd2ade98$var$Outline._rescale(points, tx, ty, sx, sy, points);
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`
            }
        };
    }
    get defaultSVGProperties() {
        const bbox = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            rootClass: {
                draw: true
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(bbox[0])} ${$b3a01b20dd2ade98$var$Outline.svgRound(bbox[1])}`,
                transform: this.rotationTransform || null
            },
            bbox: bbox
        };
    }
}
class $b3a01b20dd2ade98$var$InkDrawingOptions extends $b3a01b20dd2ade98$var$DrawingOptions {
    constructor(viewerParameters){
        super();
        this._viewParameters = viewerParameters;
        super.updateProperties({
            fill: "none",
            stroke: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
    }
    updateSVGProperty(name, value) {
        if (name === "stroke-width") {
            value ??= this["stroke-width"];
            value *= this._viewParameters.realScale;
        }
        super.updateSVGProperty(name, value);
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$InkEditor extends $b3a01b20dd2ade98$var$DrawingEditor {
    static _type = "ink";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this._willKeepAspectRatio = true;
        this.defaultL10nId = "pdfjs-editor-ink-editor";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $b3a01b20dd2ade98$var$InkDrawingOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return true;
    }
    static get typesMap() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "typesMap", new Map([
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_THICKNESS,
                "stroke-width"
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR,
                "stroke"
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_OPACITY,
                "stroke-opacity"
            ]
        ]));
    }
    static createDrawerInstance(x, y, parentWidth, parentHeight, rotation) {
        return new $b3a01b20dd2ade98$var$InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return $b3a01b20dd2ade98$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK,
                color: Array.from(color),
                thickness: thickness,
                opacity: opacity,
                paths: {
                    points: inkLists
                },
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    get toolbarButtons() {
        this._colorPicker ||= new $b3a01b20dd2ade98$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR;
    }
    get colorAndOpacityType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY;
    }
    get opacityType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_OPACITY;
    }
    updateParams(type, value) {
        if (type === $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY) {
            this._updateColorAndOpacity(value.color, value.opacity);
            return;
        }
        super.updateParams(type, value);
    }
    static updateDefaultParams(type, value) {
        if (type === $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR_AND_OPACITY) {
            super.updateDefaultParams($b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR, value.color);
            super.updateDefaultParams($b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_OPACITY, value.opacity);
            return;
        }
        super.updateDefaultParams(type, value);
    }
    get color() {
        return this._drawingOptions.stroke;
    }
    get opacity() {
        return this._drawingOptions["stroke-opacity"];
    }
    onScaleChanging() {
        if (!this.parent) return;
        super.onScaleChanging();
        const { _drawId: _drawId, _drawingOptions: _drawingOptions, parent: parent } = this;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    }
    static onScaleChangingWhenDrawing() {
        const parent = this._currentParent;
        if (!parent) return;
        super.onScaleChangingWhenDrawing();
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    }
    createDrawingOptions({ color: color, thickness: thickness, opacity: opacity }) {
        this._drawingOptions = $b3a01b20dd2ade98$var$InkEditor.getDefaultDrawingOptions({
            stroke: $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...color),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { stroke: stroke, "stroke-opacity": opacity, "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            }
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color, thickness: thickness, opacity: opacity, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || serialized.color.some((c, i)=>c !== color[i]) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        const { points: points, rect: rect } = this.serializeDraw(false);
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points,
            popup: this.comment
        });
        return null;
    }
}
class $b3a01b20dd2ade98$var$ContourDrawOutline extends $b3a01b20dd2ade98$var$InkDrawOutline {
    toSVGPath() {
        let path = super.toSVGPath();
        if (!path.endsWith("Z")) path += "Z";
        return path;
    }
}
const $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH = 8;
const $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER = 3;
class $b3a01b20dd2ade98$export$cc4fe8633f466b4a {
    static #PARAMETERS = {
        maxDim: 512,
        sigmaSFactor: 0.02,
        sigmaR: 25,
        kernelSize: 16
    };
    static #neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) return j > 0 ? 0 : 4;
        if (i === 1) return j + 6;
        return 2 - j;
    }
    static #neighborIdToIndex = new Int32Array([
        0,
        1,
        -1,
        1,
        -1,
        0,
        -1,
        -1,
        0,
        -1,
        1,
        -1,
        1,
        0,
        1,
        1
    ]);
    static #clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (-k + id - offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (k + id + offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #findContours(buf, width, height, threshold) {
        const N = buf.length;
        const types = new Int32Array(N);
        for(let i = 0; i < N; i++)types[i] = buf[i] <= threshold ? 1 : 0;
        for(let i = 1; i < height - 1; i++)types[i * width] = types[i * width + width - 1] = 0;
        for(let i = 0; i < width; i++)types[i] = types[width * height - 1 - i] = 0;
        let nbd = 1;
        let lnbd;
        const contours = [];
        for(let i = 1; i < height - 1; i++){
            lnbd = 1;
            for(let j = 1; j < width - 1; j++){
                const ij = i * width + j;
                const pix = types[ij];
                if (pix === 0) continue;
                let i2 = i;
                let j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                } else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) lnbd = pix;
                } else {
                    if (pix !== 1) lnbd = Math.abs(pix);
                    continue;
                }
                const points = [
                    j,
                    i
                ];
                const isHole = j2 === j + 1;
                const contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                let contour0;
                for (const c of contours)if (c.id === lnbd) {
                    contour0 = c;
                    break;
                }
                if (!contour0) contour.parent = isHole ? lnbd : 0;
                else if (contour0.isHole) contour.parent = isHole ? contour0.parent : lnbd;
                else contour.parent = isHole ? lnbd : contour0.parent;
                const k = this.#clockwiseNonZero(types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                    continue;
                }
                let shiftI = this.#neighborIdToIndex[2 * k];
                let shiftJ = this.#neighborIdToIndex[2 * k + 1];
                const i1 = i + shiftI;
                const j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                let i3 = i;
                let j3 = j;
                while(true){
                    const kk = this.#counterClockwiseNonZero(types, width, i3, j3, i2, j2, 1);
                    shiftI = this.#neighborIdToIndex[2 * kk];
                    shiftJ = this.#neighborIdToIndex[2 * kk + 1];
                    const i4 = i3 + shiftI;
                    const j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    const ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) types[ij3] = -nbd;
                    else if (types[ij3] === 1) types[ij3] = nbd;
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                        break;
                    } else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }
    static #douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for(let i = start; i < end - 2; i += 2)output.push(points[i], points[i + 1]);
            return;
        }
        const ax = points[start];
        const ay = points[start + 1];
        const abx = points[end - 4] - ax;
        const aby = points[end - 3] - ay;
        const dist = Math.hypot(abx, aby);
        const nabx = abx / dist;
        const naby = aby / dist;
        const aa = nabx * ay - naby * ax;
        const m = aby / abx;
        const invS = 1 / dist;
        const phi = Math.atan(m);
        const cosPhi = Math.cos(phi);
        const sinPhi = Math.sin(phi);
        const tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        const poly = invS * (1 - tmax + tmax ** 2);
        const partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        let dmax = 0;
        let index = start;
        for(let i = start + 2; i < end - 2; i += 2){
            const d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > (dist * partialPhi) ** 2) {
            this.#douglasPeuckerHelper(points, start, index + 2, output);
            this.#douglasPeuckerHelper(points, index, end, output);
        } else output.push(ax, ay);
    }
    static #douglasPeucker(points) {
        const output = [];
        const len = points.length;
        this.#douglasPeuckerHelper(points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }
    static #bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        const kernel = new Float32Array(kernelSize ** 2);
        const sigmaS2 = -2 * sigmaS ** 2;
        const halfSize = kernelSize >> 1;
        for(let i = 0; i < kernelSize; i++){
            const x = (i - halfSize) ** 2;
            for(let j = 0; j < kernelSize; j++)kernel[i * kernelSize + j] = Math.exp((x + (j - halfSize) ** 2) / sigmaS2);
        }
        const rangeValues = new Float32Array(256);
        const sigmaR2 = -2 * sigmaR ** 2;
        for(let i = 0; i < 256; i++)rangeValues[i] = Math.exp(i ** 2 / sigmaR2);
        const N = buf.length;
        const out = new Uint8Array(N);
        const histogram = new Uint32Array(256);
        for(let i = 0; i < height; i++)for(let j = 0; j < width; j++){
            const ij = i * width + j;
            const center = buf[ij];
            let sum = 0;
            let norm = 0;
            for(let k = 0; k < kernelSize; k++){
                const y = i + k - halfSize;
                if (y < 0 || y >= height) continue;
                for(let l = 0; l < kernelSize; l++){
                    const x = j + l - halfSize;
                    if (x < 0 || x >= width) continue;
                    const neighbour = buf[y * width + x];
                    const w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                    sum += neighbour * w;
                    norm += w;
                }
            }
            const pix = out[ij] = Math.round(sum / norm);
            histogram[pix]++;
        }
        return [
            out,
            histogram
        ];
    }
    static #getHistogram(buf) {
        const histogram = new Uint32Array(256);
        for (const g of buf)histogram[g]++;
        return histogram;
    }
    static #toUint8(buf) {
        const N = buf.length;
        const out = new Uint8ClampedArray(N >> 2);
        let max = -Infinity;
        let min = Infinity;
        for(let i = 0, ii = out.length; i < ii; i++){
            const pix = out[i] = buf[i << 2];
            max = Math.max(max, pix);
            min = Math.min(min, pix);
        }
        const ratio = 255 / (max - min);
        for(let i = 0, ii = out.length; i < ii; i++)out[i] = (out[i] - min) * ratio;
        return out;
    }
    static #guessThreshold(histogram) {
        let i;
        let M = -Infinity;
        let L = -Infinity;
        const min = histogram.findIndex((v)=>v !== 0);
        let pos = min;
        let spos = min;
        for(i = min; i < 256; i++){
            const v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for(i = spos - 1; i >= 0; i--){
            if (histogram[i] > histogram[i + 1]) break;
        }
        return i;
    }
    static #getGrayPixels(bitmap) {
        const originalBitmap = bitmap;
        const { width: width, height: height } = bitmap;
        const { maxDim: maxDim } = this.#PARAMETERS;
        let newWidth = width;
        let newHeight = height;
        if (width > maxDim || height > maxDim) {
            let prevWidth = width;
            let prevHeight = height;
            let steps = Math.log2(Math.max(width, height) / maxDim);
            const isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for(let i = 0; i < steps; i++){
                newWidth = Math.ceil(prevWidth / 2);
                newHeight = Math.ceil(prevHeight / 2);
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx = offscreen.getContext("2d");
                ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) bitmap.close();
                bitmap = offscreen.transferToImageBitmap();
            }
            const ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        const offscreen = new OffscreenCanvas(newWidth, newHeight);
        const ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, newWidth, newHeight);
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        const grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        const uint8Buf = this.#toUint8(grayImage);
        return [
            uint8Buf,
            newWidth,
            newHeight
        ];
    }
    static extractContoursFromText(text, { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }, pageWidth, pageHeight, rotation, innerMargin) {
        let canvas = new OffscreenCanvas(1, 1);
        let ctx = canvas.getContext("2d", {
            alpha: false
        });
        const fontSize = 200;
        const font = ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, fontBoundingBoxAscent: fontBoundingBoxAscent, fontBoundingBoxDescent: fontBoundingBoxDescent, width: width } = ctx.measureText(text);
        const SCALE = 1.5;
        const canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        const canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        const uint8Buf = this.#toUint8(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        const histogram = this.#getHistogram(uint8Buf);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static process(bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        const [uint8Buf, width, height] = this.#getGrayPixels(bitmap);
        const [buffer, histogram] = this.#bilateralFilter(uint8Buf, width, height, Math.hypot(width, height) * this.#PARAMETERS.sigmaSFactor, this.#PARAMETERS.sigmaR, this.#PARAMETERS.kernelSize);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static processDrawnLines({ lines: lines, pageWidth: pageWidth, pageHeight: pageHeight, rotation: rotation, innerMargin: innerMargin, mustSmooth: mustSmooth, areContours: areContours }) {
        if (rotation % 180 !== 0) [pageWidth, pageHeight] = [
            pageHeight,
            pageWidth
        ];
        const { curves: curves, width: width, height: height } = lines;
        const thickness = lines.thickness ?? 0;
        const linesAndPoints = [];
        const ratio = Math.min(pageWidth / width, pageHeight / height);
        const xScale = ratio / pageWidth;
        const yScale = ratio / pageHeight;
        const newCurves = [];
        for (const { points: points } of curves){
            const reducedPoints = mustSmooth ? this.#douglasPeucker(points) : points;
            if (!reducedPoints) continue;
            newCurves.push(reducedPoints);
            const len = reducedPoints.length;
            const newPoints = new Float32Array(len);
            const line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
            linesAndPoints.push({
                line: line,
                points: newPoints
            });
            if (len === 2) {
                newPoints[0] = reducedPoints[0] * xScale;
                newPoints[1] = reducedPoints[1] * yScale;
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    newPoints[0],
                    newPoints[1]
                ], 0);
                continue;
            }
            let [x1, y1, x2, y2] = reducedPoints;
            x1 *= xScale;
            y1 *= yScale;
            x2 *= xScale;
            y2 *= yScale;
            newPoints.set([
                x1,
                y1,
                x2,
                y2
            ], 0);
            line.set([
                NaN,
                NaN,
                NaN,
                NaN,
                x1,
                y1
            ], 0);
            for(let i = 4; i < len; i += 2){
                const x = newPoints[i] = reducedPoints[i] * xScale;
                const y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                line.set($b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                [x1, y1, x2, y2] = [
                    x2,
                    y2,
                    x,
                    y
                ];
            }
        }
        if (linesAndPoints.length === 0) return null;
        const outline = areContours ? new $b3a01b20dd2ade98$var$ContourDrawOutline() : new $b3a01b20dd2ade98$var$InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    }
    static async compressSignature({ outlines: outlines, areContours: areContours, thickness: thickness, width: width, height: height }) {
        let minDiff = Infinity;
        let maxDiff = -Infinity;
        let outlinesLength = 0;
        for (const points of outlines){
            outlinesLength += points.length;
            for(let i = 2, ii = points.length; i < ii; i++){
                const dx = points[i] - points[i - 2];
                minDiff = Math.min(minDiff, dx);
                maxDiff = Math.max(maxDiff, dx);
            }
        }
        let bufferType;
        if (minDiff >= -128 && maxDiff <= 127) bufferType = Int8Array;
        else if (minDiff >= -32768 && maxDiff <= 32767) bufferType = Int16Array;
        else bufferType = Int32Array;
        const len = outlines.length;
        const headerLength = $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * len;
        const header = new Uint32Array(headerLength);
        let offset = 0;
        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
        header[offset++] = 0;
        header[offset++] = width;
        header[offset++] = height;
        header[offset++] = areContours ? 0 : 1;
        header[offset++] = Math.max(0, Math.floor(thickness ?? 0));
        header[offset++] = len;
        header[offset++] = bufferType.BYTES_PER_ELEMENT;
        for (const points of outlines){
            header[offset++] = points.length - 2;
            header[offset++] = points[0];
            header[offset++] = points[1];
        }
        const cs = new CompressionStream("deflate-raw");
        const writer = cs.writable.getWriter();
        await writer.ready;
        writer.write(header);
        const BufferCtor = bufferType.prototype.constructor;
        for (const points of outlines){
            const diffs = new BufferCtor(points.length - 2);
            for(let i = 2, ii = points.length; i < ii; i++)diffs[i - 2] = points[i] - points[i - 2];
            writer.write(diffs);
        }
        writer.close();
        const bytes = await new Response(cs.readable).bytes();
        return bytes.toBase64();
    }
    static async decompressSignature(signatureData) {
        try {
            const bytes = Uint8Array.fromBase64(signatureData);
            const { readable: readable, writable: writable } = new DecompressionStream("deflate-raw");
            const writer = writable.getWriter();
            await writer.ready;
            writer.write(bytes).then(async ()=>{
                await writer.ready;
                await writer.close();
            }).catch(()=>{});
            let data = null;
            let offset = 0;
            for await (const chunk of readable){
                data ||= new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]);
                data.set(chunk, offset);
                offset += chunk.length;
            }
            const header = new Uint32Array(data.buffer, 0, data.length >> 2);
            const version = header[1];
            if (version !== 0) throw new Error(`Invalid version: ${version}`);
            const width = header[2];
            const height = header[3];
            const areContours = header[4] === 0;
            const thickness = header[5];
            const numberOfDrawings = header[6];
            const bufferType = header[7];
            const outlines = [];
            const diffsOffset = ($b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
            let diffs;
            switch(bufferType){
                case Int8Array.BYTES_PER_ELEMENT:
                    diffs = new Int8Array(data.buffer, diffsOffset);
                    break;
                case Int16Array.BYTES_PER_ELEMENT:
                    diffs = new Int16Array(data.buffer, diffsOffset);
                    break;
                case Int32Array.BYTES_PER_ELEMENT:
                    diffs = new Int32Array(data.buffer, diffsOffset);
                    break;
            }
            offset = 0;
            for(let i = 0; i < numberOfDrawings; i++){
                const len = header[$b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * i + $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH];
                const points = new Float32Array(len + 2);
                outlines.push(points);
                for(let j = 0; j < $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER - 1; j++)points[j] = header[$b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * i + $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + j + 1];
                for(let j = 0; j < len; j++)points[j + 2] = points[j] + diffs[offset++];
            }
            return {
                areContours: areContours,
                thickness: thickness,
                outlines: outlines,
                width: width,
                height: height
            };
        } catch (e) {
            $b3a01b20dd2ade98$var$warn(`decompressSignature: ${e}`);
            return null;
        }
    }
}
class $b3a01b20dd2ade98$var$SignatureOptions extends $b3a01b20dd2ade98$var$DrawingOptions {
    constructor(){
        super();
        super.updateProperties({
            fill: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$SignatureOptions();
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$DrawnSignatureOptions extends $b3a01b20dd2ade98$var$InkDrawingOptions {
    constructor(viewerParameters){
        super(viewerParameters);
        super.updateProperties({
            stroke: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$SignatureEditor extends $b3a01b20dd2ade98$var$DrawingEditor {
    #isExtracted = false;
    #description = null;
    #signatureData = null;
    #signatureUUID = null;
    static _type = "signature";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            mustBeCommitted: true,
            name: "signatureEditor"
        });
        this._willKeepAspectRatio = true;
        this.#signatureData = params.signatureData || null;
        this.#description = null;
        this.defaultL10nId = "pdfjs-editor-signature-editor1";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $b3a01b20dd2ade98$var$SignatureOptions();
        this._defaultDrawnSignatureOptions = new $b3a01b20dd2ade98$var$DrawnSignatureOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static get typesMap() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "typesMap", new Map());
    }
    static get isDrawer() {
        return false;
    }
    get telemetryFinalData() {
        return {
            type: "signature",
            hasDescription: !!this.#description
        };
    }
    static computeTelemetryFinalData(data) {
        const hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: hasDescriptionStats.get(true) ?? 0,
            hasNoAltText: hasDescriptionStats.get(false) ?? 0
        };
    }
    get isResizable() {
        return true;
    }
    onScaleChanging() {
        if (this._drawId === null) return;
        super.onScaleChanging();
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        const { _isCopy: _isCopy } = this;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        if (this._drawId === null) {
            if (this.#signatureData) {
                const { lines: lines, mustSmooth: mustSmooth, areContours: areContours, description: description, uuid: uuid, heightInPage: heightInPage } = this.#signatureData;
                const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
                const outline = $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            } else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        } else this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: this.#description || ""
        }));
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    }
    setUuid(uuid) {
        this.#signatureUUID = uuid;
        this.addEditToolbar();
    }
    getUuid() {
        return this.#signatureUUID;
    }
    get description() {
        return this.#description;
    }
    set description(description) {
        this.#description = description;
        if (!this.div) return;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        super.addEditToolbar().then((toolbar)=>{
            toolbar?.updateEditSignatureButton(description);
        });
    }
    getSignaturePreview() {
        const { newCurves: newCurves, areContours: areContours, thickness: thickness, width: width, height: height } = this.#signatureData;
        const maxDim = Math.max(width, height);
        const outlineData = $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
            lines: {
                curves: newCurves.map((points)=>({
                        points: points
                    })),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    }
    get toolbarButtons() {
        if (this._uiManager.signatureManager) return [
            [
                "editSignature",
                this._uiManager.signatureManager
            ]
        ];
        return super.toolbarButtons;
    }
    addSignature(data, heightInPage, description, uuid) {
        const { x: savedX, y: savedY } = this;
        const { outline: outline } = this.#signatureData = data;
        this.#isExtracted = outline instanceof $b3a01b20dd2ade98$var$ContourDrawOutline;
        this.description = description;
        let drawingOptions;
        if (this.#isExtracted) drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        const [, pageHeight] = this.pageDimensions;
        let newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims();
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    }
    getFromImage(bitmap) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.process(bitmap, pageWidth, pageHeight, rotation, $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN);
    }
    getFromText(text, fontInfo) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN);
    }
    getDrawnSignature(curves) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    }
    createDrawingOptions({ areContours: areContours, thickness: thickness }) {
        if (areContours) this._drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            this._drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            isSignature: true,
            areContours: this.#isExtracted,
            color: [
                0,
                0,
                0
            ],
            thickness: this.#isExtracted ? 0 : thickness
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = this.#signatureUUID;
            serialized.isCopy = true;
        } else serialized.lines = lines;
        if (this.#description) serialized.accessibilityData = {
            type: "Figure",
            alt: this.#description
        };
        return serialized;
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) return $b3a01b20dd2ade98$var$ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        return $b3a01b20dd2ade98$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#isExtracted = data.areContours;
        editor.description = data.accessibilityData?.alt || "";
        editor.#signatureUUID = data.uuid;
        return editor;
    }
}
class $b3a01b20dd2ade98$var$StampEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #missingCanvas = false;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
        this.defaultL10nId = "pdfjs-editor-stamp-editor";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static isHandlingMimeForPasting(mime) {
        return $b3a01b20dd2ade98$export$3234c88e9de64a88.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor({
            mode: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP
        }, {
            bitmapFile: item.getAsFile()
        });
    }
    altTextFinish() {
        if (this._uiManager.useNewAltTextFlow) this.div.hidden = false;
        super.altTextFinish();
    }
    get telemetryFinalData() {
        return {
            type: "stamp",
            hasAltText: !!this.altTextData?.altText
        };
    }
    static computeTelemetryFinalData(data) {
        const hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: hasAltTextStats.get(true) ?? 0,
            hasNoAltText: hasAltTextStats.get(false) ?? 0
        };
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (!this.#canvas) return;
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this.addEditToolbar().then(()=>{
                this._editToolbar.hide();
                this._uiManager.editAltText(this, true);
            });
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            } catch  {}
        }
        this.div.focus();
    }
    async mlGuessAltText(imageData = null, updateAltTextData = true) {
        if (this.hasAltTextData()) return null;
        const { mlManager: mlManager } = this._uiManager;
        if (!mlManager) throw new Error("No ML.");
        if (!await mlManager.isEnabledFor("altText")) throw new Error("ML isn't enabled for alt text.");
        const { data: data, width: width, height: height } = imageData || this.copyCanvas(null, null, true).imageData;
        const response = await mlManager.guess({
            name: "altText",
            request: {
                data: data,
                width: width,
                height: height,
                channels: data.length / (width * height)
            }
        });
        if (!response) throw new Error("No response from the AI service.");
        if (response.error) throw new Error("Error from the AI service.");
        if (response.cancel) return null;
        if (!response.output) throw new Error("No valid response from the AI service.");
        const altText = response.output;
        await this.setGuessedAltText(altText);
        if (updateAltTextData && !this.hasAltTextData()) this.altTextData = {
            alt: altText,
            decorative: false
        };
        return altText;
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $b3a01b20dd2ade98$export$3234c88e9de64a88.join(",");
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this._reportTelemetry({
                        action: "pdfjs.image.image_selected",
                        data: {
                            alt_text_modal: this._uiManager.useNewAltTextFlow
                        }
                    });
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded(focus) {
        this._isDraggable = true;
        if (focus) this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId || this.#missingCanvas);
    }
    get toolbarButtons() {
        return [
            [
                "altText",
                this.createAltText()
            ]
        ];
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.createAltText();
        if (!this.#missingCanvas) {
            if (this.#bitmap) this.#createCanvas();
            else this.#getBitmap();
        }
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        this._uiManager.addShouldRescale(this);
        return this.div;
    }
    setCanvas(annotationElementId, canvas) {
        const { id: bitmapId, bitmap: bitmap } = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas);
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            this.#bitmapId = bitmapId;
            if (bitmap) this.#bitmap = bitmap;
            this.#missingCanvas = false;
            this.#createCanvas();
        }
    }
    _onResized() {
        this.onScaleChanging();
    }
    onScaleChanging() {
        if (!this.parent) return;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap();
        }, TIME_TO_WAIT);
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        this.setDims();
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) div.hidden = false;
        this.#drawBitmap();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) this.div.setAttribute("aria-description", this.#bitmapFileName);
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
    }
    copyCanvas(maxDataDimension, maxPreviewDimension, createImageData = false) {
        if (!maxDataDimension) maxDataDimension = 224;
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        const outputScale = new $b3a01b20dd2ade98$export$f16a99f63bccd50b();
        let bitmap = this.#bitmap;
        let width = bitmapWidth, height = bitmapHeight;
        let canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                const ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            const scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            const scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!this.#isSvg) bitmap = this.#scaleBitmap(scaledWidth, scaledHeight);
            const ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            let white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") black = "black";
            else if ($b3a01b20dd2ade98$var$ColorScheme.isDarkMode) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            const boxDim = 15;
            const boxDimWidth = boxDim * outputScale.sx;
            const boxDimHeight = boxDim * outputScale.sy;
            const pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            const patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        let imageData = null;
        if (createImageData) {
            let dataWidth, dataHeight;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            } else {
                bitmap = this.#bitmap;
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    const ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!this.#isSvg) bitmap = this.#scaleBitmap(dataWidth, dataHeight);
                }
            }
            const offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            const offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { width: width, height: height } = this;
        const outputScale = new $b3a01b20dd2ade98$export$f16a99f63bccd50b();
        const scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        const scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) return;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(scaledWidth, scaledHeight);
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        let missingCanvas = false;
        if (data instanceof $b3a01b20dd2ade98$var$StampAnnotationElement) {
            const { data: { rect: rect, rotation: rotation, id: id, structParent: structParent, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, container: container, parent: { page: { pageNumber: pageNumber } }, canvas: canvas } = data;
            let bitmapId, bitmap;
            if (canvas) {
                delete data.canvas;
                ({ id: bitmapId, bitmap: bitmap } = uiManager.imageManager.getFromCanvas(container.id, canvas));
                canvas.remove();
            } else {
                missingCanvas = true;
                data._hasNoCanvas = true;
            }
            const altText = (await parent._structTree.getAriaAttributes(`${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`))?.get("aria-label") || "";
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP,
                bitmapId: bitmapId,
                bitmap: bitmap,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                accessibilityData: {
                    decorative: false,
                    altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmap: bitmap, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (missingCanvas) {
            uiManager.addMissingCanvas(data.id, editor);
            editor.#missingCanvas = true;
        } else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
            editor.#bitmapId = bitmapId;
            if (bitmap) editor.#bitmap = bitmap;
        } else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        editor.#hasBeenAddedInUndoStack = !!initialData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const serialized = Object.assign(super.serialize(isForCopying), {
            bitmapId: this.#bitmapId,
            isSvg: this.#isSvg
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.serializeAltText(false);
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (this.annotationElementId) {
            const changes = this.#hasElementChanged(serialized);
            if (changes.isSame) return null;
            if (changes.isSameAltText) delete serialized.accessibilityData;
            else serialized.accessibilityData.structParent = this._initialData.structParent ?? -1;
            serialized.id = this.annotationElementId;
            delete serialized.bitmapId;
            return serialized;
        }
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { pageIndex: pageIndex, accessibilityData: { altText: altText } } = this._initialData;
        const isSamePageIndex = serialized.pageIndex === pageIndex;
        const isSameAltText = (serialized.accessibilityData?.alt || "") === altText;
        return {
            isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
}
class $b3a01b20dd2ade98$export$47948c9fe1adbf1b {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #clickAC = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isDisabling = false;
    #isEnabling = false;
    #drawingAC = null;
    #focusedElement = null;
    #textLayer = null;
    #textSelectionAC = null;
    #textLayerDblClickAC = null;
    #lastPointerDownTimestamp = -1;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $b3a01b20dd2ade98$var$FreeTextEditor,
        $b3a01b20dd2ade98$var$InkEditor,
        $b3a01b20dd2ade98$var$StampEditor,
        $b3a01b20dd2ade98$var$HighlightEditor,
        $b3a01b20dd2ade98$var$SignatureEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, structTreeLayer: structTreeLayer, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values()
        ];
        if (!$b3a01b20dd2ade98$export$47948c9fe1adbf1b._initialized) {
            $b3a01b20dd2ade98$export$47948c9fe1adbf1b._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    }
    updateToolbar(options) {
        this.#uiManager.updateToolbar(options);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE:
                this.div.classList.toggle("nonEditing", true);
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        classList.toggle("nonEditing", false);
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) classList.toggle("commentEditing", true);
        else {
            classList.toggle("commentEditing", false);
            for (const editorType of $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        }
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    cleanUndoStack(type) {
        this.#uiManager.cleanUndoStack(type);
    }
    toggleDrawing(enabled = false) {
        this.div.classList.toggle("drawing", !enabled);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.togglePointerEvents(enabled);
    }
    get #allEditorsIterator() {
        return this.#editors.size !== 0 ? this.#editors.values() : this.#uiManager.getEditors(this.pageIndex);
    }
    async enable() {
        this.#isEnabling = true;
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        this.div.classList.toggle("nonEditing", false);
        this.#textLayerDblClickAC?.abort();
        this.#textLayerDblClickAC = null;
        const annotationElementIds = new Set();
        for (const editor of this.#allEditorsIterator){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) for (const editable of annotationLayer.getEditableAnnotations()){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = await this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
        this.#isEnabling = false;
        this.#uiManager._eventBus.dispatch("editorsrendered", {
            source: this,
            pageNumber: this.pageIndex + 1
        });
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        this.div.classList.toggle("nonEditing", true);
        if (this.#textLayer && !this.#textLayerDblClickAC) {
            this.#textLayerDblClickAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textLayerDblClickAC);
            this.#textLayer.div.addEventListener("pointerdown", (e)=>{
                const DBL_CLICK_THRESHOLD = 500;
                const { clientX: clientX, clientY: clientY, timeStamp: timeStamp } = e;
                const lastPointerDownTimestamp = this.#lastPointerDownTimestamp;
                if (timeStamp - lastPointerDownTimestamp > DBL_CLICK_THRESHOLD) {
                    this.#lastPointerDownTimestamp = timeStamp;
                    return;
                }
                this.#lastPointerDownTimestamp = -1;
                const { classList: classList } = this.div;
                classList.toggle("getElements", true);
                const elements = document.elementsFromPoint(clientX, clientY);
                classList.toggle("getElements", false);
                if (!this.div.contains(elements[0])) return;
                let id;
                const regex = new RegExp(`^${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}[0-9]+$`);
                for (const element of elements)if (regex.test(element.id)) {
                    id = element.id;
                    break;
                }
                if (!id) return;
                const editor = this.#editors.get(id);
                if (editor?.annotationElementId === null) {
                    $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
                    editor.dblclick(e);
                }
            }, {
                signal: signal,
                capture: true
            });
        }
        const annotationLayer = this.#annotationLayer;
        const needFakeAnnotation = [];
        if (annotationLayer) {
            const changedAnnotations = new Map();
            const resetAnnotations = new Map();
            for (const editor of this.#allEditorsIterator){
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    needFakeAnnotation.push(editor);
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                } else resetAnnotations.set(editor.annotationElementId, editor);
                this.getEditableAnnotation(editor.annotationElementId)?.show();
                editor.remove();
            }
            for (const editable of annotationLayer.getEditableAnnotations()){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) {
                    editable.updateEdited({
                        deleted: true
                    });
                    continue;
                }
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    if (editor.renderAnnotationElement(editable)) editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        annotationLayer?.updateFakeAnnotations(needFakeAnnotation);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#textSelectionAC) {
            this.#textSelectionAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textSelectionAC);
            this.#textLayer.div.addEventListener("pointerdown", this.#textLayerPointerDown.bind(this), {
                signal: signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#textSelectionAC) {
            this.#textSelectionAC.abort();
            this.#textSelectionAC = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        const { target: target } = event;
        if (target === this.#textLayer.div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent") || target.classList.contains("textLayerImagePlaceholder")) && this.#textLayer.div.contains(target)) {
            const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            this.toggleDrawing();
            $b3a01b20dd2ade98$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", {
                target: this.#textLayer.div,
                x: event.x,
                y: event.y
            });
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
                this.toggleDrawing(true);
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#clickAC) return;
        this.#clickAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#clickAC);
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        const pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    }
    disableClick() {
        this.#clickAC?.abort();
        this.#clickAC = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor);
            $b3a01b20dd2ade98$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!this.#isEnabling);
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getEditorByUID(uid) {
        for (const editor of this.#editors.values()){
            if (editor.uid === uid) return editor;
        }
        return null;
    }
    get #currentEditorType() {
        return $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.get(this.#uiManager.getMode());
    }
    combinedSignal(ac) {
        return this.#uiManager.combinedSignal(ac);
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    async pasteEditor(options, params) {
        this.updateToolbar(options);
        await this.#uiManager.updateMode(options.mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    async deserialize(data) {
        return await $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    get boundingClientRect() {
        return this.div.getBoundingClientRect();
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.boundingClientRect;
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor(data = {}) {
        this.createAndAddNewEditor(this.#getCenterPoint(), true, data);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (this.#currentEditorType?.isDrawer && this.#currentEditorType.supportMultipleDrawings) return;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        const currentMode = this.#uiManager.getMode();
        if (currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP || currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP || currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        if (this.#currentEditorType?.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    startDrawingSession(event) {
        this.div.focus({
            preventScroll: true
        });
        if (this.#drawingAC) {
            this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
            return;
        }
        this.#uiManager.setCurrentDrawingSession(this);
        this.#drawingAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#drawingAC);
        this.div.addEventListener("blur", ({ relatedTarget: relatedTarget })=>{
            if (relatedTarget && !this.div.contains(relatedTarget)) {
                this.#focusedElement = null;
                this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
    }
    pause(on) {
        if (on) {
            const { activeElement: activeElement } = document;
            if (this.div.contains(activeElement)) this.#focusedElement = activeElement;
            return;
        }
        if (this.#focusedElement) setTimeout(()=>{
            this.#focusedElement?.focus();
            this.#focusedElement = null;
        }, 0);
    }
    endDrawingSession(isAborted = false) {
        if (!this.#drawingAC) return null;
        this.#uiManager.setCurrentDrawingSession(null);
        this.#drawingAC.abort();
        this.#drawingAC = null;
        this.#focusedElement = null;
        return this.#currentEditorType.endDrawing(isAborted);
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    commitOrRemove() {
        if (this.#drawingAC) {
            this.endDrawingSession();
            return true;
        }
        return false;
    }
    onScaleChanging() {
        if (!this.#drawingAC) return;
        this.#currentEditorType.onScaleChangingWhenDrawing(this);
    }
    destroy() {
        this.commitOrRemove();
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
    }
    async render({ viewport: viewport }) {
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        await this.#uiManager.findClonesForPage(this);
        this.div.hidden = this.isEmpty;
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
class $b3a01b20dd2ade98$export$3eb4521511f02450 {
    #parent = null;
    #mapping = new Map();
    #toUpdate = new Map();
    static #id = 0;
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static get _svgFactory() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_svgFactory", new $b3a01b20dd2ade98$export$425e69f00724e63a());
    }
    static #setBox(element, [x, y, width, height]) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG() {
        const svg = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", true);
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    #updateProperties(element, properties) {
        for (const [key, value] of Object.entries(properties))if (value === null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
    draw(properties, isPathUpdatable = false, hasClip = false) {
        const id = $b3a01b20dd2ade98$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = hasClip ? this.#createClipPath(defs, pathId) : null;
        const use = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", `#${pathId}`);
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    drawOutline(properties, mustRemoveSelfIntersections) {
        const id = $b3a01b20dd2ade98$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (mustRemoveSelfIntersections) {
            const mask = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return id;
    }
    finalizeDraw(id, properties) {
        this.#toUpdate.delete(id);
        this.updateProperties(id, properties);
    }
    updateProperties(elementOrId, properties) {
        if (!properties) return;
        const { root: root, bbox: bbox, rootClass: rootClass, path: path } = properties;
        const element = typeof elementOrId === "number" ? this.#mapping.get(elementOrId) : elementOrId;
        if (!element) return;
        if (root) this.#updateProperties(element, root);
        if (bbox) $b3a01b20dd2ade98$export$3eb4521511f02450.#setBox(element, bbox);
        if (rootClass) {
            const { classList: classList } = element;
            for (const [className, value] of Object.entries(rootClass))classList.toggle(className, value);
        }
        if (path) {
            const defs = element.firstElementChild;
            const pathElement = defs.firstElementChild;
            this.#updateProperties(pathElement, path);
        }
    }
    updateParent(id, layer) {
        if (layer === this) return;
        const root = this.#mapping.get(id);
        if (!root) return;
        layer.#parent.append(root);
        this.#mapping.delete(id);
        layer.#mapping.set(id, root);
    }
    remove(id) {
        this.#toUpdate.delete(id);
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
        this.#toUpdate.clear();
    }
}
function $b3a01b20dd2ade98$var$percentage(value) {
    return `${(value * 100).toFixed(2)}%`;
}
class $b3a01b20dd2ade98$export$f44e3dd51af47bcc {
    #coordinates = [];
    #coordinatesByElement = new Map();
    #getPageCanvas = null;
    #minSize = 0;
    #pageWidth = 0;
    #pageHeight = 0;
    static #activeImage = null;
    constructor(minSize, coordinates, viewport, getPageCanvas){
        this.#minSize = minSize;
        this.#coordinates = coordinates;
        this.#pageWidth = viewport.rawDims.pageWidth;
        this.#pageHeight = viewport.rawDims.pageHeight;
        this.#getPageCanvas = getPageCanvas;
    }
    render() {
        const container = document.createElement("div");
        container.className = "textLayerImages";
        for(let i = 0; i < this.#coordinates.length; i += 6){
            const el = this.#createImagePlaceholder(this.#coordinates.subarray(i, i + 6));
            if (el) container.append(el);
        }
        container.addEventListener("contextmenu", (event)=>{
            if (!(event.target instanceof HTMLCanvasElement)) return;
            const imgElement = event.target;
            const coords = this.#coordinatesByElement.get(imgElement);
            if (!coords) return;
            const activeImage = $b3a01b20dd2ade98$export$f44e3dd51af47bcc.#activeImage?.deref();
            if (activeImage === imgElement) return;
            if (activeImage) {
                activeImage.width = 0;
                activeImage.height = 0;
            }
            $b3a01b20dd2ade98$export$f44e3dd51af47bcc.#activeImage = new WeakRef(imgElement);
            const { inverseTransform: inverseTransform, x1: x1, y1: y1, width: width, height: height } = coords;
            const pageCanvas = this.#getPageCanvas();
            const imageX1 = Math.ceil(x1 * pageCanvas.width);
            const imageY1 = Math.ceil(y1 * pageCanvas.height);
            const imageX2 = Math.floor((x1 + width / this.#pageWidth) * pageCanvas.width);
            const imageY2 = Math.floor((y1 + height / this.#pageHeight) * pageCanvas.height);
            imgElement.width = imageX2 - imageX1;
            imgElement.height = imageY2 - imageY1;
            const ctx = imgElement.getContext("2d");
            ctx.setTransform(...inverseTransform);
            ctx.translate(-imageX1, -imageY1);
            ctx.drawImage(pageCanvas, 0, 0);
        });
        return container;
    }
    #createImagePlaceholder([x1, y1, x2, y2, x3, y3]) {
        const width = Math.hypot((x3 - x1) * this.#pageWidth, (y3 - y1) * this.#pageHeight);
        const height = Math.hypot((x2 - x1) * this.#pageWidth, (y2 - y1) * this.#pageHeight);
        if (width < this.#minSize || height < this.#minSize) return null;
        const transform = [
            (x3 - x1) * this.#pageWidth / width,
            (y3 - y1) * this.#pageHeight / width,
            (x2 - x1) * this.#pageWidth / height,
            (y2 - y1) * this.#pageHeight / height,
            0,
            0
        ];
        const inverseTransform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.inverseTransform(transform);
        const imgElement = document.createElement("canvas");
        imgElement.className = "textLayerImagePlaceholder";
        imgElement.width = 0;
        imgElement.height = 0;
        Object.assign(imgElement.style, {
            opacity: 0,
            position: "absolute",
            left: $b3a01b20dd2ade98$var$percentage(x1),
            top: $b3a01b20dd2ade98$var$percentage(y1),
            width: $b3a01b20dd2ade98$var$percentage(width / this.#pageWidth),
            height: $b3a01b20dd2ade98$var$percentage(height / this.#pageHeight),
            transformOrigin: "0% 0%",
            transform: `matrix(${transform.join(",")})`
        });
        this.#coordinatesByElement.set(imgElement, {
            inverseTransform: inverseTransform,
            width: width,
            height: height,
            x1: x1,
            y1: y1
        });
        return imgElement;
    }
}
globalThis._pdfjsTestingUtils = {
    HighlightOutliner: $b3a01b20dd2ade98$var$HighlightOutliner
};
globalThis.pdfjsLib = {
    AbortException: $b3a01b20dd2ade98$export$d0e978393d193d1a,
    AnnotationEditorLayer: $b3a01b20dd2ade98$export$47948c9fe1adbf1b,
    AnnotationEditorParamsType: $b3a01b20dd2ade98$export$cf3df2a6ecc26692,
    AnnotationEditorType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf,
    AnnotationEditorUIManager: $b3a01b20dd2ade98$export$26cb16552a82cf63,
    AnnotationLayer: $b3a01b20dd2ade98$export$3e7f45c326d9366c,
    AnnotationMode: $b3a01b20dd2ade98$export$5a7af0c07e33392e,
    AnnotationType: $b3a01b20dd2ade98$export$f50c3066a53a6f2c,
    applyOpacity: $b3a01b20dd2ade98$export$f8d1472813e87bf9,
    build: $b3a01b20dd2ade98$export$3f8fe6489e95757d,
    ColorPicker: $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3,
    createValidAbsoluteUrl: $b3a01b20dd2ade98$export$e076b47f5805ca0b,
    CSSConstants: $b3a01b20dd2ade98$export$cec677744f6a5015,
    DOMSVGFactory: $b3a01b20dd2ade98$export$425e69f00724e63a,
    DrawLayer: $b3a01b20dd2ade98$export$3eb4521511f02450,
    FeatureTest: $b3a01b20dd2ade98$export$5fb8891d35c36978,
    fetchData: $b3a01b20dd2ade98$export$8134c072fddab6a5,
    findContrastColor: $b3a01b20dd2ade98$export$7a96203b1fdebe8d,
    getDocument: $b3a01b20dd2ade98$export$f65ca476c09acec0,
    getFilenameFromUrl: $b3a01b20dd2ade98$export$b1c11df0696253ae,
    getPdfFilenameFromUrl: $b3a01b20dd2ade98$export$9de51790aa4bc73a,
    getRGB: $b3a01b20dd2ade98$export$2a2e9b507863ddda,
    getRGBA: $b3a01b20dd2ade98$export$c24a0a5c5129b2e1,
    getUuid: $b3a01b20dd2ade98$export$75f13a91ebdf8eb3,
    getXfaPageViewport: $b3a01b20dd2ade98$export$dd5d6edf3fc80aae,
    GlobalWorkerOptions: $b3a01b20dd2ade98$export$edf38ba293eb934,
    ImageKind: $b3a01b20dd2ade98$export$b890e9c15247e0b3,
    InvalidPDFException: $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1,
    isDataScheme: $b3a01b20dd2ade98$export$f67aae4532d8295b,
    isPdfFile: $b3a01b20dd2ade98$export$61b52d3570d24719,
    isValidExplicitDest: $b3a01b20dd2ade98$export$b5acece0a447dcdc,
    makeArr: $b3a01b20dd2ade98$export$be9af9a47496243a,
    makeMap: $b3a01b20dd2ade98$export$b41394a5437791c8,
    makeObj: $b3a01b20dd2ade98$export$5b3b706fb9845c88,
    MathClamp: $b3a01b20dd2ade98$export$b8106b171181a554,
    noContextMenu: $b3a01b20dd2ade98$export$455b7811f904cadc,
    normalizeUnicode: $b3a01b20dd2ade98$export$1fa1e6b1a06bd7fa,
    OPS: $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b,
    OutputScale: $b3a01b20dd2ade98$export$f16a99f63bccd50b,
    PasswordResponses: $b3a01b20dd2ade98$export$5e72215208e4d9ad,
    PDFDataRangeTransport: $b3a01b20dd2ade98$export$c06899d9d7bce9ab,
    PDFDateString: $b3a01b20dd2ade98$export$66cbc314498fffc,
    PDFWorker: $b3a01b20dd2ade98$export$84e2e9f37426b265,
    PermissionFlag: $b3a01b20dd2ade98$export$bb99a5b8411e07d8,
    PixelsPerInch: $b3a01b20dd2ade98$export$6ef3b6b69e65342c,
    RenderingCancelledException: $b3a01b20dd2ade98$export$245847d31c09154f,
    renderRichText: $b3a01b20dd2ade98$export$611c480766035c4,
    ResponseException: $b3a01b20dd2ade98$export$ea8e9c34f66e603,
    setLayerDimensions: $b3a01b20dd2ade98$export$af0a15a86e590226,
    shadow: $b3a01b20dd2ade98$export$b8972b998723d602,
    SignatureExtractor: $b3a01b20dd2ade98$export$cc4fe8633f466b4a,
    stopEvent: $b3a01b20dd2ade98$export$7ae4cd3a66c1e050,
    SupportedImageMimeTypes: $b3a01b20dd2ade98$export$3234c88e9de64a88,
    TextLayer: $b3a01b20dd2ade98$export$fdbdc423a78c5262,
    TextLayerImages: $b3a01b20dd2ade98$export$f44e3dd51af47bcc,
    TouchManager: $b3a01b20dd2ade98$export$9ae7542b430d543e,
    updateUrlHash: $b3a01b20dd2ade98$export$e1e4297c21ab9d13,
    Util: $b3a01b20dd2ade98$export$f8f26dd395d7e1bd,
    VerbosityLevel: $b3a01b20dd2ade98$export$b18df09d23c244c4,
    version: $b3a01b20dd2ade98$export$83d89fbfd8236492,
    XfaLayer: $b3a01b20dd2ade98$export$f6af20c312d4b9a2
};


var $476338592ba8a76c$exports = {};
$476338592ba8a76c$exports = $parcel$resolve("94LWX");


let $b25dfe2ee2c25921$var$workerReadyPromise = null;
function $b25dfe2ee2c25921$var$ensurePdfWorker() {
    if (!$b25dfe2ee2c25921$var$workerReadyPromise) {
        $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc = (0, (/*@__PURE__*/$parcel$interopDefault($476338592ba8a76c$exports)));
        $b25dfe2ee2c25921$var$workerReadyPromise = Promise.resolve();
    }
    return $b25dfe2ee2c25921$var$workerReadyPromise;
}
const $b25dfe2ee2c25921$var$myPdfs = {};
function $b25dfe2ee2c25921$var$renderPdf(pdfs, canvas, pageno, scale, width) {
    const pdf = pdfs.pdf;
    pdf.getPage(pageno).then(function(page) {
        let viewport = page.getViewport({
            scale: scale
        });
        if (width) {
            const wscale = width / viewport.width;
            const newScale = wscale * scale;
            const height = wscale * viewport.height;
            viewport = page.getViewport({
                scale: newScale
            });
            viewport.width = width;
            viewport.height = height;
        }
        const context = canvas.getContext("2d", {
            alpha: false
        });
        const outputScale = $b25dfe2ee2c25921$var$getOutputScale(context);
        canvas.width = viewport.width * outputScale.sx | 0;
        canvas.height = viewport.height * outputScale.sy | 0;
        canvas.style.height = viewport.height + "px";
        canvas.style.width = viewport.width + "px";
        context.scale(outputScale.sx, outputScale.sy);
        pdfs.prevHeight = viewport.height;
        pdfs.prevWidth = viewport.width;
        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        page.render(renderContext);
    });
}
function $b25dfe2ee2c25921$var$getOutputScale(ctx) {
    const devicePixelRatio = window.devicePixelRatio || 1;
    const backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    const pixelRatio = devicePixelRatio / backingStoreRatio;
    return {
        sx: pixelRatio,
        sy: pixelRatio,
        scaled: pixelRatio !== 1
    };
}
class $b25dfe2ee2c25921$var$PdfViewerCustomElement extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        this.canvas = document.createElement("canvas");
        shadow.appendChild(this.canvas);
    }
    connectedCallback() {
        const name = this.getAttribute("name");
        const page = parseInt(this.getAttribute("page"), 10);
        const widthRaw = Number.parseFloat(this.getAttribute("width"));
        const width = Number.isFinite(widthRaw) ? widthRaw : undefined;
        const pdf = $b25dfe2ee2c25921$var$myPdfs[name];
        if (pdf) {
            if (width) this.canvas.width = width;
            else if (pdf.prevWidth) this.canvas.width = pdf.prevWidth;
            if (pdf.prevHeight) this.canvas.height = pdf.prevHeight;
            $b25dfe2ee2c25921$var$renderPdf(pdf, this.canvas, page, 1, width);
        }
    }
}
function $b25dfe2ee2c25921$var$formatPdfError(reason) {
    if (reason == null) return "unknown error";
    if (typeof reason === "string") return reason;
    if (typeof reason === "object" && reason.message) return String(reason.message);
    return String(reason);
}
function $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd) {
    if (!app.ports.receivePdfMsg) return;
    if (cmd.cmd === "openurl") $b3a01b20dd2ade98$export$f65ca476c09acec0(cmd.url).promise.then(function(pdf) {
        $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
            pdf: pdf
        };
        app.ports.receivePdfMsg.send({
            msg: "loaded",
            name: cmd.name,
            pageCount: pdf.numPages
        });
    }, function(reason) {
        app.ports.receivePdfMsg.send({
            msg: "error",
            name: cmd.name,
            error: $b25dfe2ee2c25921$var$formatPdfError(reason)
        });
    });
    else if (cmd.cmd === "openstring") {
        const buff = Uint8Array.from(atob(cmd.string), (c)=>c.charCodeAt(0));
        $b3a01b20dd2ade98$export$f65ca476c09acec0(buff).promise.then(function(pdf) {
            $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
                pdf: pdf
            };
            app.ports.receivePdfMsg.send({
                msg: "loaded",
                name: cmd.name,
                pageCount: pdf.numPages
            });
        }, function(reason) {
            app.ports.receivePdfMsg.send({
                msg: "error",
                name: cmd.name,
                error: $b25dfe2ee2c25921$var$formatPdfError(reason)
            });
        });
    } else if (cmd.cmd === "close") {
        const entry = $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        if (entry && entry.pdf) entry.pdf.destroy().then(function() {
            delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        }).catch(function() {
            delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        });
        else delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
    } else app.ports.receivePdfMsg.send({
        msg: "error",
        name: typeof cmd.name === "string" ? cmd.name : "",
        error: "invalid command to pdf-element: " + cmd.cmd
    });
}
const $b25dfe2ee2c25921$var$PdfPreviewPort = {
    add: function(app) {
        if (typeof customElements !== "undefined" && !customElements.get("pdf-element")) customElements.define("pdf-element", $b25dfe2ee2c25921$var$PdfViewerCustomElement);
        if (app.ports.sendPdfCommand) app.ports.sendPdfCommand.subscribe(function(cmd) {
            $b25dfe2ee2c25921$var$ensurePdfWorker().then(function() {
                $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd);
            }).catch(function(err) {
                if (app.ports.receivePdfMsg) app.ports.receivePdfMsg.send({
                    msg: "error",
                    name: typeof cmd.name === "string" ? cmd.name : "",
                    error: $b25dfe2ee2c25921$var$formatPdfError(err)
                });
            });
        });
    }
};
var $b25dfe2ee2c25921$export$2e2bcd8739ae039 = $b25dfe2ee2c25921$var$PdfPreviewPort;


var $91f945baf304556d$exports = {};
$91f945baf304556d$exports = $parcel$resolve("hW73M");


function $5b09ccb12fff0951$var$appendPreFallback(el, xmlText) {
    const pre = document.createElement("pre");
    pre.className = "whitespace-pre-wrap break-words rounded-md bg-gray-50 p-3 text-xs text-gray-800";
    pre.textContent = xmlText;
    el.appendChild(pre);
}
function $5b09ccb12fff0951$var$hasXmlParserError(doc) {
    return doc.getElementsByTagName("parsererror").length > 0;
}
let $5b09ccb12fff0951$var$xslCachePromise = null;
function $5b09ccb12fff0951$var$loadXslText() {
    if (!$5b09ccb12fff0951$var$xslCachePromise) $5b09ccb12fff0951$var$xslCachePromise = fetch((0, (/*@__PURE__*/$parcel$interopDefault($91f945baf304556d$exports)))).then((res)=>{
        if (!res.ok) throw new Error("xsl fetch failed");
        return res.text();
    });
    return $5b09ccb12fff0951$var$xslCachePromise;
}
const $5b09ccb12fff0951$var$XmlPreviewPort = {
    add (app) {
        if (!app.ports.requestXmlPreview || !app.ports.xmlPreviewResult) return;
        app.ports.requestXmlPreview.subscribe(async ({ requestId: requestId, url: url, elementId: elementId })=>{
            const sendFail = ()=>{
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: false
                });
            };
            try {
                const el = document.getElementById(elementId);
                if (!el) {
                    sendFail();
                    return;
                }
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                const xmlText = await res.text();
                el.replaceChildren();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlText, "application/xml");
                if ($5b09ccb12fff0951$var$hasXmlParserError(xmlDoc)) {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                    app.ports.xmlPreviewResult.send({
                        requestId: requestId,
                        ok: true
                    });
                    return;
                }
                try {
                    const xslText = await $5b09ccb12fff0951$var$loadXslText();
                    const xsltProcessor = new XSLTProcessor();
                    const xslDoc = parser.parseFromString(xslText, "application/xml");
                    if ($5b09ccb12fff0951$var$hasXmlParserError(xslDoc)) throw new Error("Invalid XSL");
                    xsltProcessor.importStylesheet(xslDoc);
                    const fragment = xsltProcessor.transformToFragment(xmlDoc, document);
                    el.appendChild(fragment);
                } catch  {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                }
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: true
                });
            } catch  {
                sendFail();
            }
        });
        if (app.ports.clearXmlMount) app.ports.clearXmlMount.subscribe((elementId)=>{
            if (!elementId) return;
            const mount = document.getElementById(elementId);
            if (mount) mount.replaceChildren();
        });
    }
};
var $5b09ccb12fff0951$export$2e2bcd8739ae039 = $5b09ccb12fff0951$var$XmlPreviewPort;


var $397bcf58b99e38b9$exports = {};
const $397bcf58b99e38b9$var$WindowPort = {
    add: function(app) {
        const isInView = function(element) {
            if (!element) return false;
            const rect = element.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom <= window.innerHeight && rect.left >= 0 && rect.right <= window.innerWidth;
        };
        app.ports.scrollTopAndIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            var scrollTimeout;
            var handleScroll = function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function() {
                    removeEventListener("scroll", handleScroll, true);
                    setTimeout(function() {
                        window.scroll({
                            top: 0,
                            behavior: "smooth"
                        });
                    }, 250);
                }, 100);
            };
            addEventListener("scroll", handleScroll, true);
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        app.ports.scrollIdIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            element.scrollIntoView({
                behavior: "smooth"
            });
        });
        app.ports.scrollIdToBottom.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        var scrollTimer = null;
        var lastScrollFireTime = 0;
        var minScrollTime = 100;
        window.addEventListener("scroll", ()=>{
            if (!scrollTimer) {
                var now = new Date().getTime();
                if (now - lastScrollFireTime > minScrollTime) {
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                    lastScrollFireTime = now;
                }
                scrollTimer = setTimeout(function() {
                    scrollTimer = null;
                    lastScrollFireTime = new Date().getTime();
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                }, minScrollTime);
            }
        });
        app.ports.printWindow.subscribe(function() {
            window.print();
        });
    }
};
$397bcf58b99e38b9$exports = $397bcf58b99e38b9$var$WindowPort;


var $0d34a6c94bf1f37e$exports = {};
/* global google */ var $a74131a19464fd13$exports = {};
!function(o, e) {
    e($a74131a19464fd13$exports);
}($a74131a19464fd13$exports, function(o) {
    "use strict";
    const e = (o)=>{
        var e, n, r, t = "The Google Maps JavaScript API", a = "google", i = "importLibrary", s = "__ib__", p = document, c = window, l = c[a] || (c[a] = {}), d = l.maps || (l.maps = {}), m = new Set, g = new URLSearchParams;
        d[i] ? console.warn(t + " only loads once. Ignoring:", o) : d[i] = (c, ...l)=>m.add(c) && (e || (e = new Promise(async (i, c)=>{
                for(r in await (n = p.createElement("script")), g.set("libraries", [
                    ...m
                ] + ""), o)g.set(r.replace(/[A-Z]/g, (o)=>"_" + o[0].toLowerCase()), o[r]);
                g.set("callback", a + ".maps." + s), function(o, e) {
                    o.src = e;
                }(n, "https://maps.googleapis.com/maps/api/js?" + g), d[s] = i, n.onerror = ()=>e = c(Error(t + " could not load.")), n.nonce = p.querySelector("script[nonce]")?.nonce || "", p.head.append(n);
            }))).then(()=>d[i](c, ...l));
    };
    "production";
    "production";
    let n = !1;
    o.Loader = class {
        constructor(...o){
            throw new Error("[@googlemaps/js-api-loader]: The Loader class is no longer available in this version.\nPlease use the new functional API: setOptions() and importLibrary().\nFor more information, see the updated documentation at: https://github.com/googlemaps/js-api-loader/blob/main/README.md");
        }
    }, o.importLibrary = async function(o) {
        if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
        return await google.maps.importLibrary(o);
    }, o.setOptions = function(o) {
        n ? ((o)=>{
            JSON.stringify(o);
        })(o) : (!function(o) {
            const n = Boolean(window.google?.maps?.importLibrary);
            n && ((o)=>{
                JSON.stringify(o);
            })(o);
            n || e(o);
        }(o), n = !0);
    };
}); //# sourceMappingURL=index.cjs.map


const $0d34a6c94bf1f37e$var$GooglePlacesPort = {
    add: function(app, googleMapsKey) {
        if (!googleMapsKey) throw new Error("Google Maps Key is not configured.");
        let places;
        (0, $a74131a19464fd13$exports.setOptions)({
            key: googleMapsKey
        });
        const fetchAutocompleteSuggestions = (id, request, callback)=>{
            places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request).then(({ suggestions: suggestions })=>{
                const formattedSuggestions = suggestions.map((s)=>{
                    const p = s.placePrediction;
                    return {
                        description: p.text.text,
                        place_id: p.placeId,
                        types: p.types
                    };
                });
                callback({
                    suggestions: formattedSuggestions,
                    id: id
                });
            }).catch((error)=>{
                console.log(error);
            });
        };
        (0, $a74131a19464fd13$exports.importLibrary)("places").then((imported)=>{
            places = imported;
            app.ports.googlePlacesPredictAddress.subscribe(function({ address: address, id: id }) {
                if (!address) return;
                let sessionToken = new places.AutocompleteSessionToken();
                let request = {
                    input: address,
                    sessionToken: sessionToken
                };
                navigator.geolocation.getCurrentPosition(({ coords: { latitude: latitude, longitude: longitude } })=>{
                    fetchAutocompleteSuggestions(id, {
                        ...request,
                        locationBias: {
                            radius: 5000,
                            center: {
                                lat: latitude,
                                lng: longitude
                            }
                        }
                    }, app.ports.googlePlacesAddressSuggestions.send);
                }, ()=>{
                    fetchAutocompleteSuggestions(id, request, app.ports.googlePlacesAddressSuggestions.send);
                });
            });
            app.ports.googlePlacesPredictionDetails.subscribe(function({ placeId: placeId, id: id }) {
                const place = new google.maps.places.Place({
                    id: placeId
                });
                place.fetchFields({
                    fields: [
                        "addressComponents",
                        "formattedAddress",
                        "displayName",
                        "id",
                        "types"
                    ]
                }).then((response)=>{
                    const transformedPlace = {
                        address_components: (response.place.addressComponents || []).map((component)=>({
                                long_name: component.longText,
                                short_name: component.shortText,
                                types: component.types
                            })),
                        formatted_address: response.place.formattedAddress,
                        name: response.place.displayName,
                        place_id: response.place.id,
                        types: response.place.types
                    };
                    const address = JSON.stringify(transformedPlace);
                    app.ports.googlePlacesAddressDetails.send({
                        address: address,
                        id: id
                    });
                }).catch((error)=>{
                    console.log("Error fetching place details:", error);
                    app.ports.googlePlacesAddressDetails.send({
                        address: null,
                        id: id
                    });
                });
            });
        }).catch((error)=>console.log(error));
    }
};
$0d34a6c94bf1f37e$exports = $0d34a6c94bf1f37e$var$GooglePlacesPort;


var $44d2ba25a7bfecb2$exports = {};
/* global CONFIGURATION, grecaptcha */ const $44d2ba25a7bfecb2$var$setup = function() {
    function loadRecaptchaAPI() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.google.com/recaptcha/api.js?render=" + CONFIGURATION.googleRecaptchaSiteKey + "&onload=recaptchaOnLoadfunction";
        document.body.appendChild(script);
    }
    if (CONFIGURATION.googleRecaptchaSiteKey) window.addEventListener("load", loadRecaptchaAPI, false);
};
window.recaptchaLoaded = false;
function $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app) {
    setTimeout(function() {
        app.ports.gotRecaptchaInitializedPort.send("Ok");
    }, 0);
}
const $44d2ba25a7bfecb2$var$GoogleRecaptchaPort = {
    add: function(app) {
        window.recaptchaOnLoadfunction = function() {
            window.recaptchaLoaded = true;
            $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        };
        app.ports.initializeRecaptchaPort.subscribe(function() {
            if (window.recaptchaLoaded) $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        });
        $44d2ba25a7bfecb2$var$setup();
        app.ports.getRecaptchaTokenPort.subscribe(function(action) {
            if (typeof grecaptcha !== "undefined") grecaptcha.ready(function() {
                grecaptcha.execute(CONFIGURATION.googleRecaptchaSiteKey, {
                    action: action
                }).then(function(token) {
                    app.ports.gotRecaptchaTokenPort.send({
                        token: token,
                        result: "ok"
                    });
                }).catch(()=>app.ports.gotRecaptchaTokenPort.send({
                        token: "",
                        result: "remote-error"
                    }));
            });
            else app.ports.gotRecaptchaTokenPort.send({
                token: "",
                result: "recaptcha-not-defined"
            });
        });
    }
};
$44d2ba25a7bfecb2$exports = $44d2ba25a7bfecb2$var$GoogleRecaptchaPort;


var $f2086779cc7dd10e$exports = {};
var $37d19e55f1d922da$exports = {};
"use strict";
Object.defineProperty($37d19e55f1d922da$exports, "__esModule", {
    value: true
});
$37d19e55f1d922da$exports.storageFactory = void 0;
function $37d19e55f1d922da$var$storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) getStorage().clear();
        else inMemoryStorage = {};
    }
    function getItem(name) {
        if (isSupported()) return getStorage().getItem(name);
        if (inMemoryStorage.hasOwnProperty(name)) return inMemoryStorage[name];
        return null;
    }
    function key(index) {
        if (isSupported()) return getStorage().key(index);
        else return Object.keys(inMemoryStorage)[index] || null;
    }
    function removeItem(name) {
        if (isSupported()) getStorage().removeItem(name);
        else delete inMemoryStorage[name];
    }
    function setItem(name, value) {
        if (isSupported()) getStorage().setItem(name, value);
        else inMemoryStorage[name] = String(value);
    }
    function length() {
        if (isSupported()) return getStorage().length;
        else return Object.keys(inMemoryStorage).length;
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length () {
            return length();
        }
    };
}
$37d19e55f1d922da$exports.storageFactory = $37d19e55f1d922da$var$storageFactory;


const $f2086779cc7dd10e$var$storage = (0, $37d19e55f1d922da$exports.storageFactory)(()=>localStorage);
const $f2086779cc7dd10e$var$LocalStoragePort = {
    getItem: $f2086779cc7dd10e$var$storage.getItem,
    add: (app)=>{
        app.ports.setItemPort.subscribe((object)=>{
            $f2086779cc7dd10e$var$storage.setItem(object.key, object.value);
        // Uncomment if you want a SetItem callback
        // app.ports.setItemPortCompleted.send({ value: object.value, itemType: object.itemType, action: object.action });
        });
        app.ports.getItemPort.subscribe(function(object) {
            const value = $f2086779cc7dd10e$var$storage.getItem(object.key);
            app.ports.gotItemPort.send({
                value: value,
                itemType: object.itemType,
                action: object.action
            });
        });
        app.ports.removeItemPort.subscribe(function(object) {
            $f2086779cc7dd10e$var$storage.removeItem(object.key);
            app.ports.removedItemPort.send({
                value: "",
                itemType: object.itemType,
                action: object.action
            });
        });
        window.addEventListener("storage", function(event) {
            if (event.key === "accountToken" && event.newValue === null) app.ports.removedItemPort.send({
                value: "",
                itemType: "AccountToken",
                action: "remove"
            });
        });
    }
};
$f2086779cc7dd10e$exports = $f2086779cc7dd10e$var$LocalStoragePort;


var $36331f456e6baed0$exports = {};
var $602195b98aff1e07$exports = {};
/* global CONFIGURATION */ "use strict";
var $c1c5241450caa1c1$exports = {};
/*! js-cookie v3.0.7 | MIT */ (function(global, factory) {
    $c1c5241450caa1c1$exports = factory();
})($c1c5241450caa1c1$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch  {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


const $602195b98aff1e07$var$isSafari = window.safari !== undefined;
const $602195b98aff1e07$var$cookieOptions = {
    sameSite: "strict",
    secure: true,
    path: "/"
};
if ($602195b98aff1e07$var$isSafari && CONFIGURATION && CONFIGURATION.debugOrTest) delete $602195b98aff1e07$var$cookieOptions["secure"];
const $602195b98aff1e07$var$keyName = window.location.protocol === "https:" ? "__Host-hint.account_token" : "hint.account_token";
$602195b98aff1e07$exports = {
    set: function(value) {
        return $c1c5241450caa1c1$exports.set($602195b98aff1e07$var$keyName, value, $602195b98aff1e07$var$cookieOptions);
    },
    get: function() {
        return $c1c5241450caa1c1$exports.get($602195b98aff1e07$var$keyName);
    },
    remove: function() {
        $c1c5241450caa1c1$exports.remove($602195b98aff1e07$var$keyName, $602195b98aff1e07$var$cookieOptions);
    }
};


const $36331f456e6baed0$var$logoutChannel = new BroadcastChannel("account-token-channel");
const $36331f456e6baed0$var$AccountTokenStoragePort = {
    getItem: function(_key) {
        return $602195b98aff1e07$exports.get();
    },
    add: (app)=>{
        app.ports.setTokenPort.subscribe((object)=>{
            $602195b98aff1e07$exports.set(object.value);
        });
        app.ports.removeTokenPort.subscribe(()=>{
            $602195b98aff1e07$exports.remove();
            $36331f456e6baed0$var$logoutChannel.postMessage("logout");
            app.ports.accountTokenRemovedPort.send(null);
        });
        $36331f456e6baed0$var$logoutChannel.onmessage = (event)=>{
            if (event.data === "logout") app.ports.accountTokenRemovedPort.send(null);
        };
    }
};
$36331f456e6baed0$exports = $36331f456e6baed0$var$AccountTokenStoragePort;


var $1e586fe0a96f962b$exports = {};
const $1e586fe0a96f962b$var$NavigationPort = {
    add: function(app) {
        // Inform app of browser navigation (the BACK and FORWARD buttons)
        window.addEventListener("popstate", function() {
            app.ports.onUrlChange.send(location.href);
        });
        // Change the URL upon request, inform app of the change.
        app.ports.pushUrl.subscribe(function(url) {
            history.pushState({}, "", url);
            app.ports.onUrlChange.send(location.href);
        });
        // Intercept link clicks to change the location without refreshing the page
        document.addEventListener("click", function(event) {
            const { target: target } = event;
            if (event.ctrlKey || event.metaKey) return;
            const isLocalHref = (targetA)=>{
                return targetA.host == location.host;
            };
            const linkElement = target.localName == "a" ? target : target.closest("a");
            if (linkElement && linkElement.href && isLocalHref(linkElement) && linkElement.target !== "_blank") {
                event.preventDefault();
                history.pushState({}, "", linkElement.href);
                app.ports.onUrlChange.send(linkElement.href);
            }
        });
        if (app.ports.openInNewWindow) app.ports.openInNewWindow.subscribe((url)=>{
            const newPage = window.open(url, "_blank");
            if (!newPage) console.warn("Failed to open new window - pop-up may be blocked");
        });
        if (app.ports.replaceUrl) app.ports.replaceUrl.subscribe((url)=>{
            history.replaceState({}, "", url);
        });
    }
};
$1e586fe0a96f962b$exports = $1e586fe0a96f962b$var$NavigationPort;


var $3cef90824005e2d6$exports = {};

const $3cef90824005e2d6$var$SentryPort = {
    add: function(app, env) {
        app.ports.sentryPortCaptureErrorMessage.subscribe(function(messageAndContext) {
            const message = messageAndContext[0];
            const context = messageAndContext[1];
            if (![
                "feature",
                "staging",
                "production"
            ].includes(env)) console.error(message, context);
            $6cb5f8bff4d365d9$exports.withScope(function(scope) {
                Object.keys(context || {}).forEach(function(contextKey) {
                    scope.setContext(contextKey, context[contextKey]);
                });
                $6cb5f8bff4d365d9$exports.captureMessage(message, "info");
            });
        });
    }
};
$3cef90824005e2d6$exports = $3cef90824005e2d6$var$SentryPort;


var $d5d5137484b98c41$exports = {};
/* global Stripe */ const $d5d5137484b98c41$var$StripePort = {
    add: function(app, publishableKey) {
        if (!window.Stripe) return;
        let stripeElements = {};
        // Cross browser support
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        const mountAttemptsMax = 20;
        let mountAttempts = 0;
        let elements;
        function buildAndMountElementWithSetupIntent(stripeClient, params) {
            const cardElement = document.querySelector(params.selector);
            elements = stripeClient.elements({
                clientSecret: params.setupIntentSecret,
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:ital,wght@0,400..800;1,400..800&display=swap"
                    }
                ],
                appearance: {
                    theme: "flat",
                    variables: {
                        borderRadius: "3px",
                        border: "1px solid #C4DCF8",
                        boxShadow: "none",
                        colorPrimary: "#006CD1",
                        colorText: "#1D2334",
                        colorTextPlaceholder: "#497AA5",
                        colorTextSecondary: "#497AA5",
                        fontFamily: "Wix Madefor Text",
                        fontLineHeight: "21px",
                        colorBackground: "#FFFFFF",
                        fontSize: "1rem",
                        colorIconTabSelected: "#0056A6",
                        colorIconTabHover: "#0056A6"
                    },
                    rules: {
                        ".DropdownItem--highlight": {
                            backgroundColor: "#F1F6FC",
                            border: "1px solid #81AFE4"
                        },
                        ".Tab--selected, .Tab--selected:hover": {
                            borderColor: "#0056A6",
                            color: "#0056A6",
                            backgroundColor: "#f1f6fc"
                        },
                        ".Tab, .Input, .PickerItem": {
                            border: "1px solid #c4dcf8",
                            boxShadow: "none"
                        },
                        ".Input": {
                            padding: "10px",
                            fontSize: ".875rem"
                        },
                        ".Label": {
                            fontWeight: "850",
                            fontSize: "1rem",
                            fontLineHeight: "21px",
                            marginBottom: "10px"
                        },
                        ".PickerItem": {
                            color: "#497aa4",
                            textTransform: "uppercase",
                            lineHeight: "25px"
                        },
                        ".PickerItem:hover": {
                            backgroundColor: "#FFFFFF"
                        },
                        ".Tab:hover, .Input:hover, .PickerItem:hover": {
                            borderColor: "#81AFE4",
                            color: "#0056A6"
                        }
                    }
                }
            });
            const disallowedBrands = params.options.rejectAmex ? [
                "amex"
            ] : [];
            const paymentMethodOrder = params.options.encourageAch ? [
                "us_bank_account",
                "card"
            ] : [];
            const paymentElement = elements.create("payment", {
                paymentMethodOrder: paymentMethodOrder,
                terms: {
                    card: "never",
                    usBankAccount: "never"
                },
                disallowedCardBrands: disallowedBrands,
                wallets: {
                    applePay: "never",
                    googlePay: "never"
                }
            });
            paymentElement.mount(cardElement);
            paymentElement.on("change", function(element) {
                const type = element && element.value && element.value.type || "";
                app.ports.stripePortOnSetupIntentChange.send(type);
            });
            return {
                stripeClient: stripeClient,
                elements: elements,
                paymentElement: paymentElement,
                options: params.options
            };
        }
        function tryBuildAndMountElementWithSetupIntent(params) {
            const stripeClient = Stripe(publishableKey, {
                betas: [
                    "blocked_card_brands_beta_1"
                ],
                apiVersion: "2019-12-03",
                locale: params.locale
            });
            const cardElement = document.querySelector(params.selector);
            if (cardElement) requestAnimationFrame(function() {
                stripeElements[params.selector] = buildAndMountElementWithSetupIntent(stripeClient, params);
            });
            else if (mountAttempts <= mountAttemptsMax) {
                mountAttempts += 1;
                setTimeout(function() {
                    tryBuildAndMountElementWithSetupIntent(params);
                }, 100);
            }
        }
        app.ports.stripePortBuildAndMountElementWithSetupIntent.subscribe(tryBuildAndMountElementWithSetupIntent);
        app.ports.stripePortConfirmSetupIntent.subscribe(function(params) {
            const stripeElement = stripeElements[params.selector];
            const billingDetails = params.options && params.options.billingOptions ? {
                billing_details: {
                    name: params.options.billingOptions.name
                }
            } : {};
            stripeElement.stripeClient.confirmSetup({
                elements: elements,
                confirmParams: {
                    return_url: window.location.href,
                    payment_method_data: billingDetails
                },
                redirect: "if_required"
            }).then(({ error: error, setupIntent: setupIntent })=>{
                if (error) app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: null,
                    error: error.message
                });
                else app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: setupIntent,
                    error: null
                });
            });
        });
    }
};
$d5d5137484b98c41$exports = $d5d5137484b98c41$var$StripePort;


var $b78de99e3cb6b90b$exports = {};
function $b78de99e3cb6b90b$var$hexToHsl(hex) {
    // Convert hex to RGB first
    let r = 0, g = 0, b = 0;
    if (hex.length == 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length == 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin;
    let h, s, l;
    if (delta == 0) h = 0;
    else if (cmax == r) h = (g - b) / delta % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return {
        h: h,
        s: s,
        l: l
    };
}
function $b78de99e3cb6b90b$var$toHsl({ h: h, s: s, l: l }) {
    return "hsl(" + h + "," + s + "%," + l + "%)";
}
function $b78de99e3cb6b90b$var$setTheme(hex) {
    const root = document.documentElement;
    const { h: h, s: s, l: l } = $b78de99e3cb6b90b$var$hexToHsl(hex);
    $b78de99e3cb6b90b$var$setProperty(root, "500", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 8,
        l: 40
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "400", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l - 10
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "300", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "200", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 79,
        l: 87
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "250", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 70
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "100", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 97
    }));
}
function $b78de99e3cb6b90b$var$setProperty(root, scale, color) {
    root.style.setProperty(`--custom-color-primary-${scale}`, color);
}
const $b78de99e3cb6b90b$var$ThemePort = {
    add: (app)=>{
        app.ports.setTheme.subscribe($b78de99e3cb6b90b$var$setTheme);
    }
};
$b78de99e3cb6b90b$exports = $b78de99e3cb6b90b$var$ThemePort;


var $72eb1b7e8424fce8$exports = {};
const $72eb1b7e8424fce8$var$CustomJavascriptPort = {
    add: function(app) {
        app.ports.fetchCustomJsFile.subscribe(function(customJavascriptFileUrl) {
            var script = document.createElement("script");
            script.src = customJavascriptFileUrl;
            document.head.appendChild(script);
        });
    }
};
$72eb1b7e8424fce8$exports = $72eb1b7e8424fce8$var$CustomJavascriptPort;


var $f4b7f13ee09e6363$exports = {};
const $f4b7f13ee09e6363$var$PageTitlePort = {
    add: function(app) {
        app.ports.updateTitle.subscribe((newText)=>{
            document.getElementsByTagName("title")[0].innerHTML = newText;
        });
    }
};
$f4b7f13ee09e6363$exports = $f4b7f13ee09e6363$var$PageTitlePort;


var $53030c4d0d659628$exports = {};
"use strict";
const $53030c4d0d659628$var$RainforestPort = {
    add: function(app) {
        const insertScriptTag = (rainforestEnv)=>{
            const paymentScript = document.createElement("script");
            if (rainforestEnv === "production") paymentScript.src = "https://static.rainforestpay.com/payment.js";
            else paymentScript.src = "https://static.rainforestpay.com/sandbox.payment.js";
            document.body.appendChild(paymentScript);
        };
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        app.ports.rainforestPortLoad.subscribe(function(rainforestEnv) {
            requestAnimationFrame(function() {
                insertScriptTag(rainforestEnv);
            });
        });
        app.ports.rainforestSubmitPaymentMethod.subscribe(function() {
            const component = document.getElementsByTagName("rainforest-payment")[0];
            if (!component) return;
            component.submit();
        });
    }
};
$53030c4d0d659628$exports = $53030c4d0d659628$var$RainforestPort;


var $88841e90a30ba512$exports = {};
const $88841e90a30ba512$var$OnBeforeUnloadPort = {
    add: function(app) {
        window.addEventListener("beforeunload", ()=>{
            app.ports.onBeforeUnload.send(true);
        });
    }
};
$88841e90a30ba512$exports = $88841e90a30ba512$var$OnBeforeUnloadPort;


var $13a1730e1cbf1cc4$exports = {};
const $13a1730e1cbf1cc4$var$OnElementScrollPort = {
    add: function(app) {
        var sendElementScroll = function(element) {
            var scrollInfo = {
                scrollTop: element.scrollTop,
                scrollHeight: element.scrollHeight,
                clientHeight: element.clientHeight,
                atTop: element.scrollTop <= 0,
                atBottom: element.scrollHeight - element.scrollTop - element.clientHeight <= 1
            };
            app.ports.onElementScroll.send(scrollInfo);
        };
        app.ports.setupElementScroll.subscribe((elementId)=>{
            // wait for element creation, if it doesn't exist yet
            var waitTimer = null;
            var waitInterval = 100;
            var waitForElementCreation = function() {
                var element = document.getElementById(elementId);
                if (element) {
                    clearTimeout(waitTimer);
                    listenToElementScroll(element);
                } else waitTimer = setTimeout(function() {
                    clearTimeout(waitTimer);
                    waitForElementCreation();
                }, waitInterval);
            };
            var scrollTimer = null;
            var lastScrollFireTime = 0;
            var minScrollTime = 100;
            var listenToElementScroll = function(element) {
                if (element) {
                    // send scroll event for initial position
                    sendElementScroll(element);
                    element.addEventListener("scroll", ()=>{
                        if (!scrollTimer) {
                            var now = new Date().getTime();
                            if (now - lastScrollFireTime > minScrollTime) {
                                sendElementScroll(element);
                                lastScrollFireTime = now;
                            }
                            scrollTimer = setTimeout(function() {
                                scrollTimer = null;
                                lastScrollFireTime = new Date().getTime();
                                sendElementScroll(element);
                            }, minScrollTime);
                        }
                    });
                }
            };
            waitForElementCreation();
        });
    }
};
$13a1730e1cbf1cc4$exports = $13a1730e1cbf1cc4$var$OnElementScrollPort;


var $b28e419d9143a3c3$exports = {};
const $b28e419d9143a3c3$var$OnTabSelectPort = {
    add: function(app) {
        app.ports.tabSelected.subscribe((tabId)=>{
            app.ports.onTabSelected.send(tabId);
        });
    }
};
$b28e419d9143a3c3$exports = $b28e419d9143a3c3$var$OnTabSelectPort;


var $f2c7c3c854a3894f$exports = {};
const $f2c7c3c854a3894f$var$IntercomPort = {
    add: function(app, key) {
        window.setupIntercom(key);
        app.ports.start.subscribe(function() {
            if (!window.Intercom) return;
            window.Intercom("boot");
        });
    }
};
$f2c7c3c854a3894f$exports = $f2c7c3c854a3894f$var$IntercomPort;


var $085e3b96bb7da772$exports = {};
// @ts-nocheck
var $cc8e582106535db5$var$SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\nthen:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\nh(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,j){h(\"setProperties\",{type:b,properties:d},j)}function j(b,h){d(\"user\",b,h)}function r(b,h,d){j({\nuid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h(\"trackEvent\",{\nname:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $cc8e582106535db5$var$SnippetSrcV2Delayed = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(d){\nreturn!(d in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var d,h=[];function k(){d&&(h.forEach((function(b){var h;try{h=b[d[0]]&&b[d[0]](d[1])}catch(d){return void(b[3]&&b[3](d))}\nh&&h.then?h.then(b[2],b[3]):b[2]&&b[2](h)})),h.length=0)}function r(b){return function(h){d||(d=[b,h],k())}}return b(r(0),r(1)),{\nthen:function(b,d){return p((function(r,i){h.push([b,d,r,i]),k()}))}}}function j(){(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",\no.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)};var b=n.getElementsByTagName(t)[0]\n;b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}a&&(g=m[e]=function(){var b=function(b,h,k,r){function i(i,c){\nd(b,h,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):d(b,h,k,c,c,r)}\n;function d(d,h,k,r,i,c){return b._api?b._api(d,h,k,r,i,c):(b.q&&b.q.push([d,h,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function d(d){\n\"function\"==typeof d[4]&&d[4](new Error(b))}var h=g.q;if(h){for(var k=0;k<h.length;k++)d(h[k]);h.length=0,h.push=d}},function(){try{\nvar b=!1,d=\"paint\";if(void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf(d)>-1){\nvar h=new PerformanceObserver((function(d){for(var k=d.getEntriesByName(\"first-contentful-paint\"),r=0;r<k.length;r++)k[r]&&(h.disconnect(),\nb||(b=!0,j()))}));h.observe({buffered:!0,type:d}),setTimeout((function(){b||(b=!0,j())}),1e3)}else j()}catch(b){}}(),function(){function b(){}\nfunction d(b,d,h){g(b,d,h,1)}function h(b,h,k){d(\"setProperties\",{type:b,properties:h},k)}function k(b,d){h(\"user\",b,d)}function r(b,d,h){k({\nuid:b},h),d&&k(d,h)}g.identify=r,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=h,g.event=function(b,h,k){d(\"trackEvent\",{\nname:b,properties:h},k)},g.anonymize=function(){r(!1)},g.shutdown=function(){d(\"shutdown\")},g.restart=function(){d(\"restart\")},\ng.log=function(b,h){d(\"log\",{level:b,msg:h})},g.consent=function(b){d(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0.delayed\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $cc8e582106535db5$var$mockSnippetV1 = "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"1.3.0\";\n})(window,document,window['_fs_namespace'],'script','user');";
var $cc8e582106535db5$var$mockSnippetV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function i(b){return function(d){h||(h=[b,d],k())}}return b(i(0),i(1)),{\nthen:function(b,h){return j((function(i,c){d.push([b,h,i,c]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,i){function c(c,r){\nh(b,d,k,c,r,i)}i=i||2;var r,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(c):j(c)):h(b,d,k,r,r,i)}\n;function h(h,d,k,i,c,r){return b._api?b._api(h,d,k,i,c,r):(b.q&&b.q.push([h,d,k,i,c,r]),null)}return b.q=[],b}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,k){h(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function i(b,h,d){k({\nuid:b},d),h&&k(h,d)}g.identify=i,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{\nname:b,properties:d},k)},g.anonymize=function(){i(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,0,window._fs_script);";
var $cc8e582106535db5$var$executeSnippet = function executeSnippet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$wnd = _ref.wnd, wnd = _ref$wnd === void 0 ? window : _ref$wnd, _ref$injectedNamespac = _ref.injectedNamespace, injectedNamespace = _ref$injectedNamespac === void 0 ? wnd['_fs_namespace'] : _ref$injectedNamespac, _ref$injectedScript = _ref.injectedScript, injectedScript = _ref$injectedScript === void 0 ? wnd['_fs_script'] : _ref$injectedScript;
    (function(win, doc, fsNamespace, tagName, fsScript, script, api, rejector) {
        var valid = function checkNamespace(fsNamespace) {
            if (!(fsNamespace in win)) return true;
            if (win.console && win.console.log) win.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"].");
            return false;
        }(fsNamespace);
        if (!valid) return;
        function makeThenable(callback) {
            var waiters = [];
            var resolution;
            function flush() {
                if (!resolution) return;
                waiters.forEach(function(waiter) {
                    var result;
                    try {
                        result = waiter[resolution[0]] && waiter[resolution[0]](resolution[1]);
                    } catch (error) {
                        waiter[3] && waiter[3](error);
                        return;
                    }
                    if (result && result.then) result.then(waiter[2], waiter[3]);
                    else waiter[2] && waiter[2](result);
                });
                waiters.length = 0;
            }
            function makeHandler(which) {
                return function(value) {
                    if (resolution) return;
                    resolution = [
                        which,
                        value
                    ];
                    flush();
                };
            }
            callback(makeHandler(0), makeHandler(1));
            function _then(onFulfilled, onRejected) {
                return makeThenable(function(nextResolve, nextReject) {
                    waiters.push([
                        onFulfilled,
                        onRejected,
                        nextResolve,
                        nextReject
                    ]);
                    flush();
                });
            }
            return {
                then: _then
            };
        }
        api = win[fsNamespace] = function createV2API() {
            var FS = function FS(action, options, source, apiVersion) {
                apiVersion = apiVersion || 2;
                function setResolve(resolve, reject) {
                    api(action, options, source, resolve, reject, apiVersion);
                }
                var re = /Async$/;
                if (re.test(action)) {
                    action = action.replace(re, '');
                    // @ts-ignore
                    if (typeof Promise === 'function') // @ts-ignore
                    return new Promise(setResolve);
                    return makeThenable(setResolve);
                }
                var _undefined;
                return api(action, options, source, _undefined, _undefined, apiVersion);
            };
            function api(op, args, source, resolve, reject, apiVersion) {
                // Once fs.js is bootstrapped, we have access to ._api which
                //   handles pushing deferred methods into the queue internally.
                if (FS._api) return FS._api(op, args, source, resolve, reject, apiVersion);
                if (FS.q) FS.q.push([
                    op,
                    args,
                    source,
                    resolve,
                    reject,
                    apiVersion
                ]);
                return null;
            }
            FS.q = [];
            return FS;
        }();
        rejector = function createRejector() {
            // Returns a function called on the error handler of the fs.js script tag.
            // Its purpose is to reject all pending and future asynchronous api calls.
            // The 4th argument to any api operation is always the reject function if it
            // has been called with the "Async" modifier.
            return function(reason) {
                function doReject(operation) {
                    if (typeof operation[4] === 'function') operation[4](new Error(reason));
                }
                var q = api.q;
                if (q) {
                    for(var i = 0; i < q.length; i++)doReject(q[i]);
                    q.length = 0;
                    q.push = doReject;
                }
            };
        }();
        (function insertScript() {
            script = doc.createElement(tagName);
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://' + fsScript;
            script.onerror = function() {
                rejector('Error loading ' + fsScript);
            };
            var firstScript = doc.getElementsByTagName(tagName)[0];
            if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
            else doc.head.appendChild(script);
        })();
        (function translateV1API() {
            function noop() {}
            function callAPI(action, option, source) {
                api(action, option, source, 1);
            }
            function setProperties(scope, props, source) {
                callAPI('setProperties', {
                    type: scope,
                    properties: props
                }, source);
            }
            function setUserProperties(props, source) {
                setProperties('user', props, source);
            }
            function identify(uid, customVars, source) {
                setUserProperties({
                    uid: uid
                }, source);
                if (customVars) setUserProperties(customVars, source);
            }
            api.identify = identify;
            api.setUserVars = setUserProperties;
            api.identifyAccount = noop;
            api.clearUserCookie = noop;
            api.setVars = setProperties;
            api.event = function(eventName, eventProps, source) {
                callAPI('trackEvent', {
                    name: eventName,
                    properties: eventProps
                }, source);
            };
            api.anonymize = function() {
                identify(false);
            };
            api.shutdown = function() {
                callAPI('shutdown');
            };
            api.restart = function() {
                callAPI('restart');
            };
            api.log = function(level, msg) {
                callAPI('log', {
                    level: level,
                    msg: msg
                });
            };
            api.consent = function(userConsents) {
                callAPI('setIdentity', {
                    consent: !arguments.length || userConsents
                });
            };
        })();
        (function snapshotGlobals() {
            var f = 'fetch';
            var xhr = 'XMLHttpRequest';
            api._w = {};
            api._w[xhr] = win[xhr];
            api._w[f] = win[f];
            if (win[f]) win[f] = function() {
                return api._w[f].apply(this, arguments);
            };
        })();
        api._v = "2.0.0";
    })(wnd, wnd.document, injectedNamespace, 'script', injectedScript);
};
var $cc8e582106535db5$var$executeSnippetV1 = function executeSnippetV1() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$wnd = _ref2.wnd, wnd = _ref2$wnd === void 0 ? window : _ref2$wnd, _ref2$injectedNamespa = _ref2.injectedNamespace, injectedNamespace = _ref2$injectedNamespa === void 0 ? wnd['_fs_namespace'] : _ref2$injectedNamespa;
    (function(m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            return;
        }
        g = m[e] = function(a, b, s) {
            g.q ? g.q.push([
                a,
                b,
                s
            ]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.crossOrigin = 'anonymous';
        o.src = 'https://' + _fs_script;
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function(i, v, s) {
            g(l, {
                uid: i
            }, s);
            if (v) g(l, v, s);
        };
        g.setUserVars = function(v, s) {
            g(l, v, s);
        };
        g.event = function(i, v, s) {
            g('event', {
                n: i,
                p: v
            }, s);
        };
        g.anonymize = function() {
            g.identify(false);
        };
        g.shutdown = function() {
            g("rec", !1);
        };
        g.restart = function() {
            g("rec", !0);
        };
        g.log = function(a, b) {
            g("log", [
                a,
                b
            ]);
        };
        g.consent = function(a) {
            g("consent", !arguments.length || a);
        };
        g.identifyAccount = function(i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
        };
        g.clearUserCookie = function() {};
        g.setVars = function(n, p) {
            g('setVars', [
                n,
                p
            ]);
        };
        g._w = {};
        y = 'XMLHttpRequest';
        g._w[y] = m[y];
        y = 'fetch';
        g._w[y] = m[y];
        if (m[y]) m[y] = function() {
            return g._w[y].apply(this, arguments);
        };
        g._v = "1.3.0";
    })(wnd, wnd.document, injectedNamespace, 'script', 'user');
};
var $cc8e582106535db5$var$getDocumentVar = function getDocumentVar(globalVar) {
    return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var $cc8e582106535db5$var$toV1String = function toV1String() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$shouldInsertScr = _ref3.shouldInsertScript, shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr, _ref3$globalVar = _ref3.globalVar, globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar, _ref3$globalNamespace = _ref3.globalNamespace, globalNamespace = _ref3$globalNamespace === void 0 ? "".concat(globalVar, "['_fs_namespace']") : _ref3$globalNamespace, _ref3$apiVersion = _ref3.apiVersion, apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
    return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat($cc8e582106535db5$var$getDocumentVar(globalVar), ",").concat(globalNamespace, ",'script','user');");
};
var $cc8e582106535db5$export$52a15e44b483bf1c = function initFS(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $cc8e582106535db5$var$executeSnippet();
};
var $cc8e582106535db5$export$26bbcb54e60c59be = function initFSV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $cc8e582106535db5$var$executeSnippetV1();
};
var $cc8e582106535db5$export$41ad23cd2470a6dd = $cc8e582106535db5$var$SnippetSrcV2;
var $cc8e582106535db5$export$56870719feaa6534 = $cc8e582106535db5$var$SnippetSrcV2Delayed;
var $cc8e582106535db5$export$7ab8f32ee68a385 = $cc8e582106535db5$var$toV1String();
var $cc8e582106535db5$export$e843673607dd064a = function generateSnippetText(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($cc8e582106535db5$export$41ad23cd2470a6dd, "\n");
};
var $cc8e582106535db5$export$449f4f90c1f01cdf = function generateSnippetTextV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($cc8e582106535db5$export$7ab8f32ee68a385, "\n");
};
var $cc8e582106535db5$export$a91c1a98ec2aac0d = $cc8e582106535db5$var$mockSnippetV2;
var $cc8e582106535db5$export$f721247e8e626cdb = $cc8e582106535db5$var$mockSnippetV1;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5eac6979fd23fa61$var$__assign = function() {
    $5eac6979fd23fa61$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5eac6979fd23fa61$var$__assign.apply(this, arguments);
};
var $5eac6979fd23fa61$var$getFullStory = function() {
    if (window._fs_namespace) return window[window._fs_namespace];
    return undefined;
};
var $5eac6979fd23fa61$var$ensureSnippetLoaded = function() {
    var fs = $5eac6979fd23fa61$var$getFullStory();
    if (!fs) throw Error('FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions');
    return fs;
};
var $5eac6979fd23fa61$var$_init = function(inputOptions, readyCallback) {
    // Make a copy so we can modify `options` if desired.
    var options = $5eac6979fd23fa61$var$__assign({}, inputOptions);
    if ($5eac6979fd23fa61$var$getFullStory()) {
        console.warn('The FullStory snippet has already been defined elsewhere (likely in the <head> element)');
        return;
    }
    // see README for details on the recordCrossDomainIFrames option
    if (options.recordCrossDomainIFrames) window._fs_run_in_iframe = true;
    if (options.appHost) window._fs_app_host = options.appHost;
    if (options.assetMapId) window._fs_asset_map_id = options.assetMapId;
    if (options.startCaptureManually) window._fs_capture_on_startup = false;
    // record the contents of this iFrame when embedded in a parent site
    if (options.recordOnlyThisIFrame) window._fs_is_outer_script = true;
    // Set cookie domain if it was specified.
    if (options.cookieDomain) window._fs_cookie_domain = options.cookieDomain;
    if (options.debug === true) {
        if (!options.script) options.script = 'edge.fullstory.com/s/fs-debug.js';
        else console.warn('Ignoring `debug = true` because `script` is set');
    }
    (0, $cc8e582106535db5$export$52a15e44b483bf1c)(options);
    var fs = $5eac6979fd23fa61$var$getFullStory();
    if (!fs) {
        console.warn('Failed to initialize FS snippet');
        return;
    }
    if (options.sessionUid) fs('init', {
        env: {
            sessionUid: options.sessionUid
        }
    });
    if (readyCallback) fs('observe', {
        type: 'start',
        callback: readyCallback
    });
    if (options.devMode === true) {
        var message = 'FullStory was initialized in devMode and will stop recording';
        fs('trackEvent', {
            name: 'FullStory Dev Mode',
            properties: {
                message: message
            }
        });
        fs('shutdown');
        window._fs_dev_mode = true;
        console.warn(message);
    }
};
var $5eac6979fd23fa61$var$initOnce = function(message) {
    return function(inputOptions, readyCallback) {
        if (window._fs_initialized) {
            if (message) console.warn(message);
            return;
        }
        $5eac6979fd23fa61$var$_init(inputOptions, readyCallback);
        window._fs_initialized = true;
    };
};
var $5eac6979fd23fa61$export$2cd8252107eb640b = $5eac6979fd23fa61$var$initOnce('FullStory init has already been called once, additional invocations are ignored');
// normalize undefined into boolean
var $5eac6979fd23fa61$export$3f95c6f800b78024 = function() {
    return !!window._fs_initialized;
};
var $5eac6979fd23fa61$var$hasFullStoryWithFunction = function() {
    var testNames = [];
    for(var _i = 0; _i < arguments.length; _i++)testNames[_i] = arguments[_i];
    var fs = $5eac6979fd23fa61$var$ensureSnippetLoaded();
    return testNames.every(function(current) {
        return fs[current];
    });
};
var $5eac6979fd23fa61$var$guard = function(name) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(name, " method not executed");
            console.warn(message);
            return message;
        }
        var fs = $5eac6979fd23fa61$var$getFullStory();
        if ($5eac6979fd23fa61$var$hasFullStoryWithFunction(name) && fs) return fs[name].apply(fs, args);
        console.warn("FS.".concat(name, " not ready"));
        return null;
    };
};
var $5eac6979fd23fa61$var$buildFullStoryShim = function() {
    var FS = function(operation, options, source) {
        var fs = $5eac6979fd23fa61$var$ensureSnippetLoaded();
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(operation, " not executed");
            console.warn(message);
            return undefined;
        }
        return fs(operation, options, source);
    };
    FS.anonymize = $5eac6979fd23fa61$var$guard('anonymize');
    FS.consent = $5eac6979fd23fa61$var$guard('consent');
    FS.disableConsole = $5eac6979fd23fa61$var$guard('disableConsole');
    FS.enableConsole = $5eac6979fd23fa61$var$guard('enableConsole');
    FS.event = $5eac6979fd23fa61$var$guard('event');
    FS.getCurrentSessionURL = $5eac6979fd23fa61$var$guard('getCurrentSessionURL');
    FS.identify = $5eac6979fd23fa61$var$guard('identify');
    FS.log = $5eac6979fd23fa61$var$guard('log');
    FS.restart = $5eac6979fd23fa61$var$guard('restart');
    FS.setUserVars = $5eac6979fd23fa61$var$guard('setUserVars');
    FS.setVars = $5eac6979fd23fa61$var$guard('setVars');
    FS.shutdown = $5eac6979fd23fa61$var$guard('shutdown');
    return FS;
};
var $5eac6979fd23fa61$export$d55ddad8cc9093bd = $5eac6979fd23fa61$var$buildFullStoryShim();


"use strict";
const $085e3b96bb7da772$var$FullStoryPort = {
    add: function(app, orgId) {
        if (orgId) {
            (0, $5eac6979fd23fa61$export$2cd8252107eb640b)({
                orgId: orgId
            });
            app.ports.fullStoryPortInit.subscribe(function(practice) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    anonymous: true,
                    properties: {
                        practice_id: practice.id,
                        practice_name: practice.name,
                        practice_email: practice.email
                    }
                });
            });
            app.ports.fullStoryPortIdentifySignup.subscribe(function(onlineEnrollmentId) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: onlineEnrollmentId,
                    properties: {
                        online_enrollment_id: onlineEnrollmentId
                    }
                });
            });
            app.ports.fullStoryPortIdentifyPatientPortal.subscribe(function(event) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: event.userId,
                    properties: {
                        scope: event.scope
                    }
                });
            });
            app.ports.fullStoryPortStopCapturing.subscribe(function() {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("shutdown");
            });
            app.ports.fullStoryPortLogEvent.subscribe(function(event) {
                const options = Object.assign(event.payload, {
                    app: "member"
                });
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("trackEvent", {
                    name: event.type,
                    properties: options
                });
            });
        }
    }
};
$085e3b96bb7da772$exports = $085e3b96bb7da772$var$FullStoryPort;


var $15ca76013f461cc0$exports = {};
"use strict";
const $15ca76013f461cc0$var$FaviconPort = {
    add: function(app) {
        if (app.ports.setFaviconPort) app.ports.setFaviconPort.subscribe((favicons)=>{
            let icoLink = document.getElementById("faviconIco");
            let pngLink = document.getElementById("faviconPng");
            let appleLink = document.getElementById("faviconApple");
            icoLink.setAttribute("href", favicons.icoUrl);
            pngLink.setAttribute("href", favicons.pngUrl);
            appleLink.setAttribute("href", favicons.appleUrl);
        });
    }
};
$15ca76013f461cc0$exports = $15ca76013f461cc0$var$FaviconPort;


var $d13a3aa875c41ca7$exports = {};

const $d13a3aa875c41ca7$var$storage = (0, $37d19e55f1d922da$exports.storageFactory)(()=>localStorage);
const $d13a3aa875c41ca7$var$IdleTimePort = {
    add: (app)=>{
        const storageKey = "lastActivityAt";
        const oneMinMs = 60000;
        const halfMinMs = 30000;
        const sessionInactivityThreshold = 60; // matches JWT expiration
        const idleThresholdMs = sessionInactivityThreshold * oneMinMs;
        function throttle(func, timeFrame) {
            var lastTime = 0;
            return function() {
                var now = Date.now();
                if (now - lastTime >= timeFrame) {
                    func();
                    lastTime = now;
                }
            };
        }
        function checkIdleTimeAndlogout() {
            const lastActivityAt = parseInt($d13a3aa875c41ca7$var$storage.getItem(storageKey));
            const now = Date.now();
            if (lastActivityAt && now - lastActivityAt > idleThresholdMs) app.ports.idleUser.send(true);
        }
        const trackLastActivity = ()=>{
            $d13a3aa875c41ca7$var$storage.setItem(storageKey, Date.now());
        };
        setInterval(checkIdleTimeAndlogout, oneMinMs);
        window.addEventListener("mousemove", throttle(trackLastActivity, halfMinMs));
        window.addEventListener("keypress", throttle(trackLastActivity, halfMinMs));
    }
};
$d13a3aa875c41ca7$exports = $d13a3aa875c41ca7$var$IdleTimePort;


var $d2be32b72d8b955d$exports = {};
"use strict";
const $d2be32b72d8b955d$var$ScrollDetectionPort = {
    add: function(app) {
        if (app.ports.setupScrollDetection) app.ports.setupScrollDetection.subscribe(({ containerId: containerId })=>{
            // Find the visible container (not hidden by CSS)
            const allContainers = document.querySelectorAll(`#${containerId}`);
            let targetContainer = null;
            for (let container of allContainers){
                const style = getComputedStyle(container);
                if (style.display !== "none" && style.visibility !== "hidden" && container.offsetParent !== null) {
                    targetContainer = container;
                    break;
                }
            }
            if (targetContainer) {
                targetContainer.removeEventListener("scroll", handleScroll);
                targetContainer.addEventListener("scroll", handleScroll, {
                    passive: true
                });
            } else console.warn(`Container with id "${containerId}" not found when trying to setup scroll detection`);
        });
        const handleScroll = (event)=>{
            const container = event.target;
            const containerId = container.id;
            const scrollInfo = {
                containerId: containerId,
                x: container.scrollLeft,
                y: container.scrollTop,
                scrollHeight: container.scrollHeight,
                clientHeight: container.clientHeight
            };
            app.ports.onScroll.send(scrollInfo);
        };
    }
};
$d2be32b72d8b955d$exports = $d2be32b72d8b955d$var$ScrollDetectionPort;


var $a8ede6276a337434$exports = {};
let $a8ede6276a337434$var$selectedFiles = [];
function $a8ede6276a337434$var$initFileSelection(app) {
    if (!app.ports.openFileDialogPort || !app.ports.onFileSelectedPort) return;
    app.ports.openFileDialogPort.subscribe((acceptedTypes)=>{
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.style.display = "none";
        fileInput.accept = acceptedTypes || "*/*";
        fileInput.multiple = true;
        fileInput.addEventListener("change", (event)=>{
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                $a8ede6276a337434$var$selectedFiles = files;
                const fileInfos = files.map((file)=>({
                        name: file.name,
                        size: file.size,
                        type: file.type || "application/octet-stream"
                    }));
                app.ports.onFileSelectedPort.send(fileInfos);
            } else {
                $a8ede6276a337434$var$selectedFiles = [];
                app.ports.onFileSelectedPort.send([]);
            }
            document.body.removeChild(fileInput);
        });
        document.body.appendChild(fileInput);
        fileInput.click();
    });
}
function $a8ede6276a337434$var$getSelectedFile(index) {
    return $a8ede6276a337434$var$selectedFiles[index] || null;
}
$a8ede6276a337434$exports = {
    initFileSelection: $a8ede6276a337434$var$initFileSelection,
    getSelectedFile: $a8ede6276a337434$var$getSelectedFile
};


var $70bed06a98643566$exports = {};
/**
 * File Upload Port Handler
 * Handles file uploads to API via multipart/form-data
 */ 
var $70bed06a98643566$require$getSelectedFile = $a8ede6276a337434$exports.getSelectedFile;
const $70bed06a98643566$var$FileUploadPort = {
    add: function(app) {
        if (app.ports && app.ports.uploadFileToApi) app.ports.uploadFileToApi.subscribe(async ({ request: request, url: url })=>{
            try {
                const file = $70bed06a98643566$require$getSelectedFile(request.fileIndex);
                if (!file) throw new Error("File not found at index " + request.fileIndex);
                const formData = new FormData();
                formData.append("file", file);
                const response = await fetch(url, {
                    method: "POST",
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${request.authToken}`
                    }
                });
                if (response.ok) {
                    const result = await response.json();
                    if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                        fileIndex: request.fileIndex,
                        success: true,
                        filePath: result.filePath,
                        filename: result.filename
                    });
                } else {
                    const errorText = await response.text();
                    throw new Error(`Upload failed with status: ${response.status} - ${errorText}`);
                }
            } catch (error) {
                console.error("FileUpload: Upload failed", error);
                if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                    fileIndex: request.fileIndex,
                    success: false,
                    filePath: "",
                    filename: "",
                    error: error.message
                });
            }
        });
    }
};
$70bed06a98643566$exports = $70bed06a98643566$var$FileUploadPort;


var $ba7a6a20ab3b4d24$exports = {};
const $ba7a6a20ab3b4d24$var$ElementMeasurementPort = {
    add: function(app) {
        const observers = new Map();
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                const elementId = entry.target.id;
                const config = observers.get(elementId);
                if (config) measureElement(entry.target, config, app);
            });
        });
        const measureElement = (element, config, app)=>{
            const { elementId: elementId, maxLines: maxLines } = config;
            const computedStyle = window.getComputedStyle(element);
            let lineHeight = parseFloat(computedStyle.lineHeight);
            if (isNaN(lineHeight) || lineHeight === 0) {
                const fontSize = parseFloat(computedStyle.fontSize);
                lineHeight = fontSize * 1.5;
            }
            const scrollHeight = element.scrollHeight;
            const maxHeight = lineHeight * maxLines;
            const tolerance = 2;
            const exceedsMaxLines = scrollHeight > maxHeight + tolerance;
            app.ports.onElementMeasured.send({
                elementId: elementId,
                scrollHeight: scrollHeight,
                clientHeight: element.clientHeight,
                lineHeight: lineHeight,
                exceedsMaxLines: exceedsMaxLines
            });
        };
        const setupObserver = (element, config, app)=>{
            const mutationObserver = new MutationObserver((mutations)=>{
                let shouldMeasure = false;
                mutations.forEach((mutation)=>{
                    if (mutation.type === "childList" || mutation.type === "characterData" || mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) shouldMeasure = true;
                });
                if (shouldMeasure) requestAnimationFrame(()=>measureElement(element, config, app));
            });
            mutationObserver.observe(element, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
                attributeFilter: [
                    "style",
                    "class"
                ]
            });
            resizeObserver.observe(element);
            return mutationObserver;
        };
        app.ports.measureElement.subscribe(function(config) {
            const { elementId: elementId } = config;
            const element = document.getElementById(elementId);
            if (!element) {
                console.warn(`Element with id "${elementId}" not found for measurement`);
                return;
            }
            if (observers.has(elementId)) {
                const existingObserver = observers.get(elementId).observer;
                existingObserver.disconnect();
                resizeObserver.unobserve(element);
            }
            const observer = setupObserver(element, config, app);
            observers.set(elementId, {
                ...config,
                observer: observer
            });
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>measureElement(element, config, app));
            });
        });
        return function cleanup() {
            observers.forEach(({ observer: observer }, elementId)=>{
                observer.disconnect();
                const element = document.getElementById(elementId);
                if (element) resizeObserver.unobserve(element);
            });
            observers.clear();
            resizeObserver.disconnect();
        };
    }
};
$ba7a6a20ab3b4d24$exports = $ba7a6a20ab3b4d24$var$ElementMeasurementPort;


var $3b9526d384f0dd3d$exports = {};
"use strict";
const $3b9526d384f0dd3d$var$DropdownPort = {
    add: function(app) {
        // Handle outside click to close dropdown
        document.addEventListener("click", (event)=>{
            const dropdown = event.target.closest(".dropdown");
            if (!dropdown) {
                if (app.ports.onDropdownOutsideClick) app.ports.onDropdownOutsideClick.send("");
                return;
            }
            // Clicked inside a dropdown, check if it's the toggle button
            const toggleButton = dropdown.querySelector(".dropdown-toggle");
            if (toggleButton && toggleButton.contains(event.target)) // Toggle button clicked, let Elm handle it
            return;
        // Clicked inside dropdown but not on toggle, don't close
        // (This allows clicking on dropdown items without closing)
        });
        // Handle escape key to close dropdown
        document.addEventListener("keydown", function(event) {
            if (event.key === "Escape") {
                const dropdown = document.querySelector(".dropdown--open");
                if (dropdown) {
                    event.stopPropagation();
                    if (app.ports.onDropdownEscapeKeyPressed) app.ports.onDropdownEscapeKeyPressed.send("");
                }
            }
        }, {
            capture: true
        });
    }
};
$3b9526d384f0dd3d$exports = $3b9526d384f0dd3d$var$DropdownPort;


var $8e7e1145409c40a4$exports = {};
const $8e7e1145409c40a4$var$TextareaAutoResizePort = {
    add: function(app) {
        const elements = new Map();
        const getMaxHeight = ()=>{
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            return Math.min(viewportHeight * 0.4, 300);
        };
        const resizeTextarea = (element)=>{
            element.style.height = "auto";
            const scrollHeight = element.scrollHeight;
            const maxHeight = getMaxHeight();
            element.style.height = Math.min(scrollHeight, maxHeight) + "px";
            element.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
        };
        const setupElement = (elementId)=>{
            if (elements.has(elementId)) return;
            const element = document.getElementById(elementId);
            if (!element) return;
            const handleResize = ()=>{
                resizeTextarea(element);
            };
            element.addEventListener("input", handleResize);
            window.addEventListener("resize", handleResize);
            const visualViewport = window.visualViewport;
            if (visualViewport) visualViewport.addEventListener("resize", handleResize);
            elements.set(elementId, {
                element: element,
                handleResize: handleResize
            });
            resizeTextarea(element);
        };
        app.ports.autoResize.subscribe(function(elementId) {
            setupElement(elementId);
            const elementData = elements.get(elementId);
            if (elementData) setTimeout(()=>resizeTextarea(elementData.element), 0);
        });
    }
};
$8e7e1145409c40a4$exports = $8e7e1145409c40a4$var$TextareaAutoResizePort;


var $5ce5aeca99e3b2a2$exports = {};
var $c513f619e4da868b$var$d = (r, t, e)=>new Promise((c, f)=>{
        var o = (s)=>{
            try {
                a(e.next(s));
            } catch (u) {
                f(u);
            }
        }, n = (s)=>{
            try {
                a(e.throw(s));
            } catch (u) {
                f(u);
            }
        }, a = (s)=>s.done ? c(s.value) : Promise.resolve(s.value).then(o, n);
        a((e = e.apply(r, t)).next());
    });
var $c513f619e4da868b$export$cf709db89eaa620b = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        let e = (yield r.arrayBuffer()).slice(8, 12);
        switch(new TextDecoder("utf-8").decode(e).replace("\0", " ").trim()){
            case "mif1":
                return !0;
            case "msf1":
                return !0;
            case "heic":
            case "heix":
                return !0;
            case "hevc":
            case "hevx":
                return !0;
        }
        return !1;
    }), $c513f619e4da868b$var$i, $c513f619e4da868b$var$g = ()=>{
    if (!$c513f619e4da868b$var$i) {
        let r = '(()=>{var MP=Object.defineProperty;var UP=(E1,s1,I1)=>s1 in E1?MP(E1,s1,{enumerable:!0,configurable:!0,writable:!0,value:I1}):E1[s1]=I1;var S5=(E1=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(E1,{get:(s1,I1)=>(typeof require!="undefined"?require:s1)[I1]}):E1)(function(E1){if(typeof require!="undefined")return require.apply(this,arguments);throw Error(\'Dynamic require of "\'+E1+\'" is not supported\')});var DP=(E1,s1)=>()=>(E1&&(s1=E1(E1=0)),s1);var HP=(E1,s1)=>()=>(s1||E1((s1={exports:{}}).exports,s1),s1.exports);var h8=(E1,s1,I1)=>UP(E1,typeof s1!="symbol"?s1+"":s1,I1);var v6=(E1,s1,I1)=>new Promise((r8,P)=>{var m6=E4=>{try{Ri(I1.next(E4))}catch(_8){P(_8)}},Z6=E4=>{try{Ri(I1.throw(E4))}catch(_8){P(_8)}},Ri=E4=>E4.done?r8(E4.value):Promise.resolve(E4.value).then(m6,Z6);Ri((I1=I1.apply(E1,s1)).next())});var xP,nw,tw=DP(()=>{xP=(()=>{var s1;var E1=typeof document!="undefined"?(s1=document.currentScript)==null?void 0:s1.src:void 0;return(function(I1={}){var r8,P=I1,m6,Z6,Ri=new Promise((J,U)=>{m6=J,Z6=U}),E4=typeof window=="object",_8=typeof WorkerGlobalScope!="undefined",G6=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string"&&process.type!="renderer",O5=[],x3="./this.program",ow=(J,U)=>{throw U};typeof __filename!="undefined"?E1=__filename:_8&&(E1=self.location.href);var He="";function lw(J){return P.locateFile?P.locateFile(J,He):He+J}var z3,Ji;if(G6){var T3=S5("fs"),SP=S5("path");He=__dirname+"/",Ji=J=>{J=S3(J)?new URL(J):J;var U=T3.readFileSync(J);return U},z3=(J,U=!0)=>v6(null,null,function*(){J=S3(J)?new URL(J):J;var j=T3.readFileSync(J,U?void 0:"utf8");return j}),process.argv.length>1&&(x3=process.argv[1].replace(/\\\\/g,"/")),O5=process.argv.slice(2),ow=(J,U)=>{throw process.exitCode=J,U}}else if(E4||_8){try{He=new URL(".",E1).href}catch(J){}_8&&(Ji=J=>{var U=new XMLHttpRequest;return U.open("GET",J,!1),U.responseType="arraybuffer",U.send(null),new Uint8Array(U.response)}),z3=J=>v6(null,null,function*(){if(S3(J))return new Promise((j,q)=>{var i0=new XMLHttpRequest;i0.open("GET",J,!0),i0.responseType="arraybuffer",i0.onload=()=>{if(i0.status==200||i0.status==0&&i0.response){j(i0.response);return}q(i0.status)},i0.onerror=q,i0.send(null)});var U=yield fetch(J,{credentials:"same-origin"});if(U.ok)return U.arrayBuffer();throw new Error(U.status+" : "+U.url)})}var xe=console.log.bind(console),Ni=console.error.bind(console),ze,S6={Memory:function(J){this.buffer=new ArrayBuffer(J.initial*65536)},Module:function(J){},Instance:function(J,U){this.exports=(function(q){function i0(h1){return h1.set=function(X1,u){this[X1]=u},h1.get=function(X1){return this[X1]},h1}for(var c,_0=new Uint8Array(123),Z0=25;Z0>=0;--Z0)_0[48+Z0]=52+Z0,_0[65+Z0]=Z0,_0[97+Z0]=26+Z0;_0[43]=62,_0[47]=63;function B0(h1,X1,u){for(var Q,i,l=0,F=X1,u0=u.length,E0=X1+(u0*3>>2)-(u[u0-2]=="=")-(u[u0-1]=="=");l<u0;l+=4)Q=_0[u.charCodeAt(l+1)],i=_0[u.charCodeAt(l+2)],h1[F++]=_0[u.charCodeAt(l)]<<2|Q>>4,F<E0&&(h1[F++]=Q<<4|i>>2),F<E0&&(h1[F++]=i<<6|_0[u.charCodeAt(l+3)]);return h1}function K0(h1){B0(c,1024,"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"),B0(c,47186,"AQ=="),B0(c,47203,"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"),B0(c,49806,"AQ=="),B0(c,49823,"QDE1TWRhdERhdGFfTWVtb3J5ADhNZGF0RGF0YQADAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAMTRJbWFnZUV4dHJhRGF0YQAxNEhlaWZQaXhlbEltYWdlAE5TdDNfXzIyM2VuYWJsZV9zaGFyZWRfZnJvbV90aGlzSTE0SGVpZlBpeGVsSW1hZ2VFRQAxMUVycm9yQnVmZmVyAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE4Y29sb3JfcHJvZmlsZV9uY2x4TlNfOWFsbG9jYXRvcklTMV9FRUVFAAMAAAAEAAAABgAAAAgAAAAGAAAACAAAADE3Y29sb3JfcHJvZmlsZV9yYXcAMThjb2xvcl9wcm9maWxlX25jbHgAOEJveF9jb2xyAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE3Y29sb3JfcHJvZmlsZV9yYXdOU185YWxsb2NhdG9ySVMxX0VFRUUAAACamZk+AAAAAAAAAAA9Clc+4XqUPlK4nj5SuJ4+/tR4PnsULj4AAAAAFK6HPhSuhz4="),B0(c,50284,"PQqXPpqZGT8AAAAAAAAAAI/CNT+amRk/7FEYP+xRGD/pJjE/MQhMPwAAgD/XozA/16MwPw=="),B0(c,50372,"SOEaP5qZGT4AAAAAAAAAAClcDz6amRk+UrgePlK4Hj7hehQ+3SQGPgAAAACamRk+mpkZPg=="),B0(c,50460,"UrgePo/CdT0AAAAAAAAAAArXoz2PwnU9KVyPPSlcjz05tEg9f2o8PQAAAACPwnU9j8J1PQ=="),B0(c,50548,"LbKdPQrXIz8AAAAAAAAAAB+FKz8K1yM/rkchP65HIT8EVi4/fT81PwAAgD97FC4/exQuPw=="),B0(c,50636,"rkchP8P1qD4AAAAAAAAAAMP1qD7D9ag+exSuPnsUrj74U6M+BoGVPgAAAAAK16M+CtejPg=="),B0(c,50724,"exSuPjcaoD4AAAAAAAAAAFK4nj43GqA+NxqgPjcaoD5SuJ4+NxqgPp+qqj6cxKA+NxqgPg=="),B0(c,50812,"NxqgPrByqD4AAAAAAAAAAMHKoT6wcqg+sHKoPrByqD7ByqE+sHKoPjuqqj5GtrM+sHKoPg=="),B0(c,50900,"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"),B0(c,59070,"AQ=="),B0(c,59087,"QDEyVHJhY2tfVmlzdWFsADE0VHJhY2tfTWV0YWRhdGEAU3VjY2Vzcw=="),B0(c,59136,"AQAAAAIAAABMAAAAVAAAAFQAAABQAAAAWAAAAFgAAADAQQAAyEEAAMhBAAAAAAAAxQAAALkAAADJAAAAxQAAALkAAADJAAAAlQAAAIYAAABuAAAAmgAAAHoAAACJAAAAjAAAAMYAAACpAAAAxgAAAIsAAACNAAAAnQAAAGsAAACLAAAAfgAAAGsAAACLAAAAfg=="),B0(c,59296,"uAAAAJoAAACLAAAAmgAAAJoAAACaAAAAiwAAAJoAAACaAAAAuAAAAJoAAAC3AAAAPwAAAJgAAACYAAAAAAAAAG8AAACNAAAAmQAAAG8AAABeAAAAigAAALYAAACaAAAAlQAAAGsAAACnAAAAmgAAAJUAAABcAAAApwAAAJoAAACZAAAAigAAAIoAAAB8AAAAigAAAF4AAADgAAAApwAAAHo="),B0(c,59472,"bgAAAG4AAAB8AAAAfQAAAIwAAACZAAAAfQAAAH8AAACMAAAAbQAAAG8AAACPAAAAfwAAAG8AAABPAAAAbAAAAHsAAAA/AAAAfQAAAG4AAABeAAAAbgAAAF8AAABPAAAAfQAAAG8AAABuAAAATgAAAG4AAABvAAAAbwAAAF8AAABeAAAAbAAAAHsAAABsAAAAfQAAAG4AAAB8AAAAbgAAAF8AAABeAAAAfQAAAG8AAABvAAAATwAAAH0AAAB+AAAAbwAAAG8AAABPAAAAbAAAAHsAAABd"),B0(c,59696,"WwAAAKsAAACGAAAAjQAAAHkAAACMAAAAPQAAAJoAAAB5AAAAjAAAAD0AAACaAAAAbwAAAG8AAAB9AAAAbgAAAG4AAABeAAAAfAAAAGwAAAB8AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAjAAAAIsAAAC2AAAAtgAAAJgAAACIAAAAmAAAAIgAAACZAAAAiAAAAIsAAABvAAAAiAAAAIsAAABvAAAAmwAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAACZAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAAB7AAAAewAAAGsAAAB5AAAAawAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACMAAAAqgAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAAB8AAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAACKAAAAigAAAHoAAAB5AAAAegAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACM"),B0(c,60256,"jQAAAG8AAACMAAAAjAAAAIwAAACM"),B0(c,60288,"jAAAAFwAAACJAAAAigAAAIwAAACYAAAAigAAAIsAAACZAAAASgAAAJUAAABcAAAAiwAAAGsAAAB6AAAAmAAAAIwAAACzAAAApgAAALYAAACMAAAA4wAAAHoAAADFAAAAmgAAAMQAAADEAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAiQAAAKkAAADCAAAApgAAAKcAAACaAAAApwAAAIkAAAC2AAAAmgAAAMQAAACnAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAegAAAKkAAADQAAAApgAAAKcAAACaAAAAmAAAAKcAAAC2AAAAigAAAJkAAACIAAAApwAAAJgAAACYAAAAawAAAKcAAABbAAAAegAAAGsAAACnAAAAawAAAKcAAABbAAAAawAAAGsAAACnAAAAyAAAALkAAACgAAAAAAAAAAztAAAnBwAAKAcAACkHAAAqBwAAhE4BABjtAAA47QAAMjZ0aHJlYWRfdGFza19kZWJsb2NrX0NUQlJvdwAAAABcTgEAQO0AADExdGhyZWFkX3Rhc2s="),B0(c,60768,"BgcICQoLDA0ODxAREhQWGBocHiAiJCYoKiwuMDI0Njg6PD5A"),B0(c,60834,"AQEBAQEBAQEBAgICAgMDAwMEBAQFBQYGBwgJCgsNDhASFBYY"),B0(c,60880,"gLDQ8ICnxeOAnrvYe5ayzXSOqcNvh6C5aYCYr2R6kKZfdImeWm6CllVoe45RY3WHTV5vgElZaXpFVWR0QlBfbj5MWmg7SFZjOEVRXjVBTVkzPklVMDtFUC44QkwrNT9IKTI7RScwOEElLTY+IyszOyEpMDggJy41HiUrMh0jKTAbISctGh8lKxgeIykXHCEnFhsgJRUaHiMUGB0hExcbHxIWGh4RFRkcEBQXGw8TFhkOEhUYDhEUFw0QExYMDxIVDA4RFAsOEBMLDQ8SCgwPEQoMDhAJCw0PCQsMDggKDA4ICQsNBwkLDAcJCgwHCAoLBggJCwYHCQoGBwgJAgICAgECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJCUmJygpKissLS4vMDEyMzQ1Njc4OTo7PD0+Pj8GBQQEAwMDAwICAgICAgICAQEBAQEBAQEBAQEBAQEBAQAAAQICBAQFBgcICQkLCwwNDQ8PEBASEhMTFRUWFhcYGBkaGhsbHB0dHh4eHyAgISEhIiIjIyMkJCQlJSUmJj8AAAAAwO8AACsHAAAsBwAAHgAAAB4AAAAAAAAAoO8AAC0HAAAuBwAALwcAADAHAACETgEArO8AAMDvAAAxNWRlY29kZXJfY29udGV4dAAAAOBOAQDY7wAAAAAAAAEAAADo7wAAAgQAADEyYmFzZV9jb250ZXh0AABcTgEA8O8AADExZXJyb3JfcXVldWUAAAAAAAAAHPAAADEHAAAyBwAAMwcAAC0BAAA0BwAAhE4BACjwAAAgSwEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTl2aWRlb19wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAAAACQ8AAANQcAADYHAAA3BwAALQEAADgHAACETgEAnPAAACBLAQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxN3NlcV9wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAAAPEAADkHAAA6BwAAOwcAAC0BAAA8BwAAhE4BAAzxAAAgSwEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTdwaWNfcGFyYW1ldGVyX3NldE5TXzlhbGxvY2F0b3JJUzFfRUVFRQ=="),B0(c,61792,"QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBaWlhVUk5JQz02LiYfFg0E/PPq4drSysO9t7Kuq6implpXUEY5KxkJ9+fVx7qwqaamqbC6x9Xn9wkZKzlGUFdaWlJDLhb84cq3q6aossPa8w0mPU5YWlVJNh8E6tK9rqZZSzIS7s61p6e1zu4SMktZWUsyEu7Otaentc7uEjJLWVhDH/PKrqay0vwmSVpVPRbqw6umt9oELk5aUjYN4b2oVzkJ1bCmuucZRlpQK/fHqanH9ytQWkYZ57qmsNUJOVdVLvO9prfqJlJYNvzDprLhH05aPQTKqK7aFklaQw3Sq1Mk3K2t3CRTUyTcra3cJFNTJNytrdwkU1Mk3K2t3CRTUhbKpsMNTlUf0qa9BElYJtqot/xDWi7hq7LzPVo26q5QCbqp5zlaK9WmxxlXRvewsPdGVxnHptUrWjnnqboJUE78rrcNVUPqqMMfWjbaptIuWibKpuE9WBa9q/NJUgSyS+6nzjJZErW1ElkyzqfuS0vup84yWRK1tRJZMs6n7ktJ4abqTkPapvNSPdKo/FU2yqsEWC7Drg1aJr2yFloft0bVqQlaGbDHOVDnpvdXK7q6K1f3pudQOcewGVoJqdVGQ8qyJlXqpgRaDajhUi63wz1J0q4fWPOm/FoWq9pONr1AwMBAQMDAQEDAwEBAwMBAQMDAQEDAwEBAwMBAQMDAQD230lIfqPNa/KYWVdqyNkO9yk4mq+paBKYNWOGuLknDObDnWvepK0a61VcJphlQx8dQGaYJV9W6Riup91rnsDk2q/xY0sNSDaYmQ7LqWuG3SR+mFk692lrzrj0uqARVyjKnEku17lnOzlnutUsSpzIypxJLte5Zzs5Z7rVLEqcyLqYmNqYfPagWQ6sNSa4ETrL8UrfzVb3qWMPhWsraWtIrpjkZqUYJsFD3ulfnx1rV1VrH51e691CwCUapGTmmKyaoSfy9WtLhVbINPaY2Fq5S6spaw/NOqx8upkMEt1jaJK1T3NxTrSQkrVPc3FOtJCStU9zcU60kJK1T3NxTrSQfslrDBDaoUtrqSaZD89JVqy4NvVq3FiauWMr8PaZO4Rm6WrArCcdXqTn31VCmRufnRqZQ1fc5qVfHCSuwWroZFsNVpkna/C6yWq428+FDqFi9Hw3KUqZO0gQmt1qrPeoSzkunWbUy7u4ytVmnS84SEs5Lp1m1Mu7uMrVZp0vOEg3aPbJYplW3NuEEFtJDrlqmUr0u6vwfykmrWqhOwybzCecrx0awV6ZaqVC6OdUZ9/cZ1Tm6UKlaplewRscr5wkE8xbhJtI2w0O3Tq5VqFqmWqZYq1KySb09yi7aH+oN/AAAAAADAAAAAwAAAAIAAAAAAAAAAwAAAAQAAAAEAAAAAAAAAJj1AAAnBwAAkAcAAJEHAACSBwAAhE4BAKT1AAA47QAAMTV0aHJlYWRfdGFza19zYW8AAAABAAAAAAAAAAEAAAD//////////wAAAAD/////AQAAAAAAAAABAAAAAQAAAAEAAAAAAAAA////////////////AAAAAAAAAACUqAEAlqgBAKCoAQDAqAEAQKkBAECrAQ=="),B0(c,63008,"lKgBAECzAQBQswEAcLMBAPCzAQDwtQE="),B0(c,63040,"lKgBAPC9AQAAvgEAIL4BAKC+AQCgwAE="),B0(c,63080,"oMgBAMDIAQBAyQEAQMsB"),B0(c,63104,"QNMBAGDTAQDg0wEA4NUB"),B0(c,63128,"4N0BAADeAQCA3gEAgOABAAD2AAAg9gAAQPY="),B0(c,63176,"IAAAABoAAAAVAAAAEQAAAA0AAAAJAAAABQAAAAIAAAAAAAAA/v////v////3////8////+/////r////5v///+D////m////6////+/////z////9/////v////+////AAAAAAIAAAAFAAAACQAAAA0AAAARAAAAFQAAABoAAAAgAAAAAAAAAADw//+a+f//cvz//4r9//8e/v//ev7//8X+//8A////xf7//3r+//8e/v//iv3//3L8//+a+f//APD//wAAAAAAAAAAAQAAAAAAAAACAAAAAQAAAAIAAAAAAAAAAwAAAAEAAAADAAAAAgAAAAMAAAABAAAAAAAAAAIAAAAAAAAAAgAAAAEAAAADAAAAAAAAAAMAAAABAAAAAwAAAAIAAAAAAAAAAPgAAJMHAACUBwAAhE4BAAz4AAAw+AAAMzBNb3Rpb25WZWN0b3JBY2Nlc3NfZGUyNjVfaW1hZ2UAAAAAXE4BADj4AAAxOE1vdGlvblZlY3RvckFjY2VzcwAAAAAAAAAAAwAAAAMAAAACAAAAAAAAAAMAAAAEAAAABAAAAAABBAUCAwQFBgYICAcHCGMAAAAAGgAAAAoAAAABAAAAAAECAgICAwUHCAoMDQ8REhMUFRYXFxgYGRkaGxscHB0dHh8AAAAAAMz4AAAnBwAAlQcAAJYHAACXBwAAhE4BANj4AAA47QAAMjV0aHJlYWRfdGFza19zbGljZV9zZWdtZW50AAAAAAAM+QAAJwcAAJgHAACZBwAAmgcAAIROAQAY+QAAOO0AADE5dGhyZWFkX3Rhc2tfY3RiX3JvdwAAAAEAAAACAAAAAgAAAAEAAAABAAAAAgAAAAEAAAABAAAA7zIAAA9WAAA/VAAAAAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIQAAACIAAAAiAAAAIwAAACMAAAAkAAAAJAAAACU="),B0(c,63904,"KAAAAC0AAAAzAAAAOQAAAEAAAABIAAAAICQAACVWAAA2MAAAJBM="),B0(c,63956,"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"),B0(c,67539,"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"),B0(c,69538,"pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"),B0(c,69736,"IQQAAAAAAAAAAC8C"),B0(c,69768,"NQRHBFYE"),B0(c,69790,"oAQ="),B0(c,69810,"RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="),B0(c,69856,"GQALABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZAAoKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="),B0(c,69937,"DgAAAAAAAAAAGQALDRkZGQANAAACAAkOAAAACQAOAAAO"),B0(c,69995,"DA=="),B0(c,70007,"EwAAAAATAAAAAAkMAAAAAAAMAAAM"),B0(c,70053,"EA=="),B0(c,70065,"DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"),B0(c,70111,"Eg=="),B0(c,70123,"EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"),B0(c,70178,"GgAAABoaGgAAAAAAAAk="),B0(c,70227,"FA=="),B0(c,70239,"FwAAAAAXAAAAAAkUAAAAAAAUAAAU"),B0(c,70285,"Fg=="),B0(c,70297,"FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"),B0(c,70372,"owc="),B0(c,70412,"//////////8="),B0(c,70484,"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"),B0(c,73200,"tB0B"),B0(c,73232,"AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAABwfAQCmBwAAAggAAAMIAACpBwAAqgcAAKsHAACsBwAArQcAAK4HAAAECAAABQgAAAYIAACyBwAAswcAAIROAQAoHwEAMBcBAE5TdDNfXzIxMF9fc3RkaW5idWZJY0VFAAAAAACAHwEApgcAAAcIAAAICAAAqQcAAKoHAACrBwAACQgAAK0HAACuBwAArwcAALAHAACxBwAACggAAAsIAACETgEAjB8BADAXAQBOU3QzX18yMTFfX3N0ZG91dGJ1ZkljRUUAAAAAAAAAAOgfAQDCBwAADAgAAA0IAADFBwAAxgcAAMcHAADIBwAAyQcAAMoHAAAOCAAADwgAABAIAADOBwAAzwcAAIROAQD0HwEA5BgBAE5TdDNfXzIxMF9fc3RkaW5idWZJd0VFAAAAAABMIAEAwgcAABEIAAASCAAAxQcAAMYHAADHBwAAEwgAAMkHAADKBwAAywcAAMwHAADNBwAAFAgAABUIAACETgEAWCABAOQYAQBOU3QzX18yMTFfX3N0ZG91dGJ1Zkl3RUU="),B0(c,73856,"0XSeAFedvSqAcFIP//8+JwoAAABkAAAA6AMAABAnAACghgEAQEIPAICWmAAA4fUFGAAAADUAAABxAAAAa////877//+Sv///AAAAAAAAAAD/////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI////////woLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIj/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////wABAgQHAwYFAAAAAAAAAExDX0NUWVBFAAAAAExDX05VTUVSSUMAAExDX1RJTUUAAAAAAExDX0NPTExBVEUAAExDX01PTkVUQVJZAExDX01FU1NBR0VT"),B0(c,74292,"gN4oAIDITQAAp3YAADSeAIASxwCAn+4AAH4XAYBcQAGA6WcBAMiQAQBVuAEu"),B0(c,74352,"U3VuAE1vbgBUdWUAV2VkAFRodQBGcmkAU2F0AFN1bmRheQBNb25kYXkAVHVlc2RheQBXZWRuZXNkYXkAVGh1cnNkYXkARnJpZGF5AFNhdHVyZGF5AEphbgBGZWIATWFyAEFwcgBNYXkASnVuAEp1bABBdWcAU2VwAE9jdABOb3YARGVjAEphbnVhcnkARmVicnVhcnkATWFyY2gAQXByaWwATWF5AEp1bmUASnVseQBBdWd1c3QAU2VwdGVtYmVyAE9jdG9iZXIATm92ZW1iZXIARGVjZW1iZXIAQU0AUE0AJWEgJWIgJWUgJVQgJVkAJW0vJWQvJXkAJUg6JU06JVMAJUk6JU06JVMgJXAAAAAlbS8lZC8leQAwMTIzNDU2Nzg5ACVhICViICVlICVUICVZACVIOiVNOiVTAAAAAABeW3lZXQBeW25OXQB5ZXMAbm8AANAlAQ=="),B0(c,75220,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),B0(c,76240,"4CsB"),B0(c,76772,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),B0(c,77792,"MDEyMzQ1Njc4OWFiY2RlZkFCQ0RFRnhYKy1wUGlJbk4AJUk6JU06JVMgJXAlSDolTQ=="),B0(c,77856,"JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"),B0(c,78e3,"JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAEDoBACgIAAApCAAAKggAAAAAAAB0OgEAKwgAACwIAAAqCAAALQgAAC4IAAAvCAAAMAgAADEIAAAyCAAAMwgAADQI"),B0(c,78112,"BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="),B0(c,79140,"zDkBADUIAAA2CAAAKggAADcIAAA4CAAAOQgAADoIAAA7CAAAPAgAAD0IAAAAAAAAqDoBAD4IAAA/CAAAKggAAEAIAABBCAAAQggAAEMIAABECAAAAAAAAMw6AQBFCAAARggAACoIAABHCAAASAgAAEkIAABKCAAASwgAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="),B0(c,79516,"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"),B0(c,84644,"kD8BAMAIAADBCAAAwggAAMMIAADECAAAxQgAAMYIAAAAAAAAgEABANAIAADRCAAA0ggAANMIAADUCAAA1QgAANYIAAAAAAAA/EoBAD8FAAAZCQAAHgAAAFxOAQAESwEATlN0M19fMjE0X19zaGFyZWRfY291bnRFAAAAAOBOAQA4SwEAAAAAAAEAAAD8SgEAAAAAAE5TdDNfXzIxOV9fc2hhcmVkX3dlYWtfY291bnRFAAAAAAAAAGxLAQAPAwAAGgkAABsJAACETgEAeEsBAIxPAQBOU3QzX18yMTJiYWRfd2Vha19wdHJFAAAAAAAApEsBACAAAAAcCQAAHQkAAIROAQCwSwEAjE8BAFN0MThiYWRfdmFyaWFudF9hY2Nlc3MAAIROAQDUSwEAgFABAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAAIROAQAETAEAyEsBAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAAIROAQA0TAEAyEsBAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAAIROAQBkTAEAKEwBAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FAIROAQCUTAEAyEsBAE4xMF9fY3h4YWJpdjEyMF9fZnVuY3Rpb25fdHlwZV9pbmZvRQAAAACETgEAyEwBAChMAQBOMTBfX2N4eGFiaXYxMjlfX3BvaW50ZXJfdG9fbWVtYmVyX3R5cGVfaW5mb0UAAAAAAAAAFE0BAB4JAAAfCQAAIAkAACEJAAAiCQAAhE4BACBNAQDISwEATjEwX19jeHhhYml2MTIzX19mdW5kYW1lbnRhbF90eXBlX2luZm9FAABNAQBQTQEAdgAAAABNAQBcTQEARG4AAABNAQBoTQEAYgAAAABNAQB0TQEAYwAAAABNAQCATQEAaAAAAABNAQCMTQEAYQAAAABNAQCYTQEAcwAAAABNAQCkTQEAdAAAAABNAQCwTQEAaQAAAABNAQC8TQEAagAAAABNAQDITQEAbAAAAABNAQDUTQEAbQAAAABNAQDgTQEAeAAAAABNAQDsTQEAeQAAAABNAQD4TQEAZgAAAABNAQAETgEAZAAAAAAAAAAkTgEAHgkAACMJAAAgCQAAIQkAACQJAACETgEAME4BAMhLAQBOMTBfX2N4eGFiaXYxMTZfX2VudW1fdHlwZV9pbmZvRQAAAAAAAAAA+EsBAB4JAAAlCQAAIAkAACEJAAAmCQAAJwkAACgJAAApCQAAAAAAAKROAQAeCQAAKgkAACAJAAAhCQAAJgkAACsJAAAsCQAALQkAAIROAQCwTgEA+EsBAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQ=="),B0(c,85725,"TwEAHgkAAC4JAAAgCQAAIQkAACYJAAAvCQAAMAkAADEJAACETgEADE8BAPhLAQBOMTBfX2N4eGFiaXYxMjFfX3ZtaV9jbGFzc190eXBlX2luZm9FAAAAAAAAAFhMAQAeCQAAMgkAACAJAAAhCQAAMwkAAAAAAACkTwEAIAAAADQJAAA1CQAAAAAAAMBPAQAgAAAANgkAADcJAAAAAAAAjE8BACAAAAA4CQAAOQkAAFxOAQCUTwEAU3Q5ZXhjZXB0aW9uAAAAAIROAQCwTwEAjE8BAFN0OWJhZF9hbGxvYwAAAACETgEAzE8BAKRPAQBTdDIwYmFkX2FycmF5X25ld19sZW5ndGgAAAAAAAAAAPxPAQABAAAAOgkAADsJAACETgEACFABAIxPAQBTdDExbG9naWNfZXJyb3IAAAAAACxQAQABAAAAPAkAADsJAACETgEAOFABAPxPAQBTdDEybGVuZ3RoX2Vycm9yAAAAAAAAAABgUAEAAQAAAD0JAAA7CQAAhE4BAGxQAQD8TwEAU3QxMm91dF9vZl9yYW5nZQAAAABcTgEAiFABAFN0OXR5cGVfaW5mbw=="),B0(c,86180,"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"),B0(c,95579,"QAAAAAAAAAABAAAAAAABAADoAwAAAABABgAAAAAAAAAAAQAAAAABAAAgAAAAQAAAAGQAAAAAAAAAAQAAAAAEAAAABAAAgKgSAegDAAAD"),B0(c,95744,"BAAAAAAAAABmPwAAAAAAACx2AQA2AwAANwMAADgDAAA5AwAAOgMAADsDAACETgEA+MYAAFRyAQAAAAAAWHYBADYDAAA8AwAAPQMAAD4DAAA/AwAAQAMAAIROAQAPxwAAVHIBAAAAAACEdgEANgMAAEEDAABCAwAAQwMAAEQDAABFAwAAhE4BACrHAABUcgEAAAAAALB2AQA2AwAARgMAAEcDAABIAwAASQMAAEoDAACETgEAQ8cAAFRyAQAAAAAA3HYBAEsDAABMAwAATQMAAE4DAABPAwAAUAMAAIROAQBjxwAAVHIBAAAAAAAIdwEAUQMAAFIDAABTAwAAVAMAAEkDAABVAwAAhE4BAHzHAABUcgEAAAAAADB3AQBWAwAAVwMAAFgDAAAtAQAAWQMAAIROAQCYxwAAIEsBAAAAAABYdwEAWgMAAFsDAABcAwAALQEAAF0DAACETgEA4scAACBLAQAAAAAAgHcBAF4DAABfAwAAYAMAAC0BAABhAwAAhE4BADDIAAAgSwEAAAAAAKh3AQBiAwAAYwMAAGQDAAAtAQAAZQMAAIROAQB8yAAAIEsBAAAAAADQdwEAZgMAAGcDAABoAwAALQEAAGkDAACETgEAyMgAACBLAQAAAAAA+HcBAGoDAABrAwAAbAMAAC0BAABtAwAAhE4BABvJAAAgSwEAAAAAAG4DAABvAw=="),B0(c,96280,"Cr8AACB4AQBcTgEAaskAADR4AQA8eAEAIHgBAFxOAQCsyQAAPE8BALnJAAAAAAAATHgBAFxOAQDJyQAAXHgBACB4AQAQTgEA3ckAAGx4AQA8eAEAXE4BAPjJAABseAEAPHgBALRNAQA8TwEAFMoAAAAAAACQeAEAXE4BACnK"),B0(c,96416,"bHgBAIB4AQCweAEAuHgBABBOAQA9ygAAEE4BAE/KAAA8TwEAhMoAAAAAAADQeAEAXE4BAJLKAAAQTgEAn8oAAFxOAQCuygAASE0BAGx4AQC0TQEAPHgBAEhNAQA8eAEAqE0BADx4AQBITQEAEHkBADxPAQDUygAAAQAAAJB4AQCoTQEAEHkBAEhNAQAweQEAPE8BAOrKAAABAAAA0HgBAGx4AQBMeQEAtE0BADxPAQD5ygAAAQAAAEx4AQCoTQEATHkBAKhNAQBMeQEAtE0BABBOAQAPywAAEE4BACHLAAAQTgEANssAABBOAQBQywAAEE4BAHXLAAAFAAAA0wcAAEwiAAAAAAAAswIAALQCAAAFAAAAAAAAAPpm"),B0(c,96708,"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"),B0(c,106932,"8OYAAAMAAAAJAAAAyScAADwAAAABAAAAAQAAABAHAAARBwAAEgcAABMHAAAUBwAAFQcAABYHAAAXBwAAGAcAABkHAAAaBwAAGwcAABwHAAAdBwAAHgcAAB8HAAAgBwAAIQcAACIHAAAjBwAAJAcAACUH"),B0(c,107080,"jgcAAI8HAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBEQERAREhESEhESFRMUFRQTFRgWFhgYFhYYGRkbHhsZGR0fIyMfHSQpLCkkLzY2L0FGQVhYcxAQEBAQEBAQEBARERERERISEhISEhQUFBQUFBQYGBgYGBgYGBkZGRkZGRkcHBwcHBwhISEhISkpKSk2NjZHR1sAIAAAAAAAAAU="),B0(c,107252,"nAc="),B0(c,107276,"nQcAAJ4HAAB06gE="),B0(c,107300,"Ag=="),B0(c,107316,"//////////8="),B0(c,107384,"6KIBAAAAAAAF"),B0(c,107404,"nwc="),B0(c,107428,"nQcAAKAHAACI6gEAAAQ="),B0(c,107452,"AQ=="),B0(c,107468,"/////wo="),B0(c,107536,"gKMBACABAwAJ"),B0(c,107556,"nAc="),B0(c,107576,"pAcAAAAAAACeBwAAiPABAAAE"),B0(c,107620,"/////w=="),B0(c,107688,"JW0vJWQvJXkAAAAIJUg6JU06JVMAAAAI")}var a0=new ArrayBuffer(16),m2=new Int32Array(a0),F2=new Float32Array(a0),B2=new Float64Array(a0);function t2(h1){return m2[h1]}function U2(h1,X1){m2[h1]=X1}function r1(){return B2[0]}function D2(h1){B2[0]=h1}function o0(h1,X1,u){if(h1=h1>>>0,u=u>>>0,h1+u>c.length)throw"trap: invalid memory.fill";c.fill(X1,h1,h1+u)}function H(){throw new Error("abort")}function z(h1,X1,u){c.copyWithin(h1,X1,X1+u)}function N1(h1){F2[2]=h1}function q4(){return F2[2]}function z1(h1){var X1=new ArrayBuffer(17039360),u=new Int8Array(X1),Q=new Int16Array(X1),i=new Int32Array(X1),l=new Uint8Array(X1),F=new Uint16Array(X1),u0=new Uint32Array(X1),E0=new Float32Array(X1),t0=new Float64Array(X1),G=Math.imul,M=Math.fround,w2=Math.abs,k1=Math.clz32,Q00=Math.min,I00=Math.max,W_=Math.floor,g7=Math.ceil,C00=Math.trunc,X_=Math.sqrt,S2=h1.a,Y0=S2.a,M0=S2.b,o1=S2.c,B1=S2.d,y1=S2.e,i4=S2.f,U4=S2.g,f8=S2.h,N8=S2.i,M8=S2.j,Si=S2.k,ir=S2.l,nf=S2.m,tf=S2.n,uf=S2.o,of=S2.p,lf=S2.q,Q7=S2.r,I7=S2.s,C7=S2.t,V7=S2.u,g_=S2.v,Q_=S2.w,I_=S2.x,C_=S2.y,V_=S2.z,F_=S2.A,E_=S2.B,p_=S2.C,y_=S2.D,Y_=S2.E,R_=S2.F,J_=S2.G,N_=S2.H,M_=S2.I,U_=S2.J,D_=S2.K,H_=S2.L,x_=S2.M,z_=S2.N,T_=S2.O,v=196896,g6=0,Q6=0,l0=0;function sf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0;i:{e:{r:{if(!i[i[e+48>>2]+44>>2])break r;if(t=v-416|0,v=t,Fe(e+16|0,i[e+20>>2]),C=e+20|0,i[e+16>>2]=C,i[e+20>>2]=0,i[e+24>>2]=0,r=i[e+32>>2],o=i[e+28>>2],(r|0)!=(o|0))for(;;){f=i[r-4>>2];f:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r-8|0,(o|0)==(r|0))break}i[e+32>>2]=o,r=i[e+44>>2],i[e+40>>2]=0,i[e+44>>2]=0;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(AA(t+364|0,i[e+48>>2]),m=i[t+364>>2],g=i[t+368>>2],(m|0)!=(g|0))for(V=e+28|0,B=t+160|0;;){s=i[m>>2],s4(t+328|0,i[e+48>>2],s);f:{A:{if(i[t+328>>2]){f=v-192|0,v=f,i[f+188>>2]=e,o=i[t+328>>2],r=i[o+112>>2],i[f+184>>2]=r,n=i[o+104>>2],i[f+180>>2]=n;k:{n:{t:{u:{o:{l:{s:{w:{_:{if((r|0)<=1785750886){if((r|0)<=1752589104){if((r|0)==1635135537)break w;if((r|0)==1635148593)break s;if((r|0)!=1735551332)break n;n=E(496),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101064,r=Y4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=101224,i[r+456>>2]=0,i[r+460>>2]=0,i[r+464>>2]=0,i[r+468>>2]=0,i[r+472>>2]=0,d0=r,n2=D6(),i[d0+472>>2]=n2,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(o);break k}if((r|0)<=1768912491){if((r|0)==1752589105)break _;if((r|0)!=1768187246)break n;r=E(464),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101144,n=Y4(r+16|0,i[f+188>>2],i[f+180>>2]),i[n>>2]=101592,o=f+32|0,i[o+4>>2]=r,i[o>>2]=n,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(o);break k}if((r|0)==1768912492)break t;if((r|0)!=1781689137)break n;n=E(480),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100984,o=Y4(r+16|0,i[f+188>>2],i[f+180>>2]),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=98768,i[r+456>>2]=0,i[r+460>>2]=0,r=E(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=98912,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=99024,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,r=f+32|0,i[r+4>>2]=n,i[r>>2]=o,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(r);break k}if((r|0)<=1836280680){if((r|0)!=1785750887){if((r|0)==1818785329)break o;if((r|0)!=1835625829||(k=u[o+139|0],r=(k|0)<0,((r?i[o+132>>2]:k)|0)!=10)||N2(r?i[o+128>>2]:o+128|0,11266,10))break n}k=E(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100784,o=Y4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=98368,i[r+456>>2]=0,i[r+460>>2]=0,r=E(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=98512,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=98704,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}if((r|0)<=1970168680){if((r|0)==1836280681)break u;if((r|0)!=1953066089)break n;n=E(576),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101184,r=Y4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+512>>2]=0,i[r+516>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,u[r+540|0]=0,i[r+536>>2]=65536,i[r>>2]=101736,i[r+520>>2]=0,i[r+524>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+552>>2]=0,i[r+556>>2]=0,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(o);break k}if((r|0)==1970168681)break l;if((r|0)!=1987470129)break n;k=E(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100904,o=Y4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=99544,i[r+456>>2]=0,i[r+460>>2]=0,r=E(92),i[r>>2]=99688,i[r+4>>2]=0,i[r+8>>2]=0,o0(r+20|0,0,72),i[r+16>>2]=0,i[r+12>>2]=99792,u[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,u[r+32|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,u[r+44|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=E(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100824,o=Y4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=97368,i[r+456>>2]=0,i[r+460>>2]=0,r=E(92),i[r>>2]=97512,i[r+4>>2]=0,i[r+8>>2]=0,o0(r+20|0,0,72),i[r+16>>2]=0,i[r+12>>2]=97760,u[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,u[r+32|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,u[r+44|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=E(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100864,o=Y4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=97824,i[r+456>>2]=0,i[r+460>>2]=0,r=E(84),i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=97968,i[r+4>>2]=0,i[r+8>>2]=0,u[r+19|0]=0,u[r+20|0]=0,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+18|0]=1,Q[r+16>>1]=0,i[r+12>>2]=98008,u[r+27|0]=0,u[r+28|0]=0,u[r+29|0]=0,u[r+30|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=E(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100944,o=Y4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=99976,i[r+456>>2]=0,i[r+460>>2]=0,r=E(92),i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r>>2]=100120,i[r+4>>2]=0,i[r+8>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=100304,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+27|0]=0,u[r+28|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+88>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,u[r+40|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}_=_A(f+32|0),r=Y(_+8|0,27443,20),o=f+12|0,P1(o,i[f+184>>2]),n=r,k=o,r=u[f+23|0],o=(r|0)<0,Y(Y(n,o?i[f+12>>2]:k,o?i[f+16>>2]:r),25910,19),u[f+23|0]<0&&Z(i[f+12>>2]),QA(f,_),k=K(f+12|0,4,3001,f),u[f+11|0]<0&&Z(i[f>>2]),W=E(488),r=W,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94552,I=r+16|0,r=I,o=v-32|0,v=o,y=i[f+180>>2],R=i[f+184>>2],w=i[k+4>>2],n=i[k>>2],i[o+8>>2]=n,i[o+12>>2]=w,h=o+16|0;l:{if(u[k+19|0]>=0){x=i[k+12>>2],i[h>>2]=i[k+8>>2],i[h+4>>2]=x,i[h+8>>2]=i[k+16>>2];break l}T(h,i[k+8>>2],i[k+12>>2]),n=i[o+8>>2],w=i[o+12>>2]}i[r+84>>2]=0,i[r+88>>2]=0,u[r+80|0]=0,u[r+68|0]=0,i[r+64>>2]=0,u[r+60|0]=0,u[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,u[r+12|0]=1,Q[r+10>>1]=2,Q[r+6>>1]=2,Q[r+8>>1]=2,u[r+4|0]=0,u[r+232|0]=0,i[r+132>>2]=0,i[r+136>>2]=0,i[r+92>>2]=0,i[r+96>>2]=4740,Q[r+138>>1]=0,Q[r+140>>1]=0,Q[r+142>>1]=0,Q[r+144>>1]=0,u[r+156|0]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,u[r+168|0]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+248>>2]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,i[r+112>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,Q[r+122>>1]=0,Q[r+124>>1]=0,Q[r+126>>1]=0,Q[r+128>>1]=0,i[r+352>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,u[r+272|0]=1,u[r+281|0]=0,u[r+282|0]=0,u[r+283|0]=0,u[r+284|0]=0,u[r+285|0]=0,u[r+286|0]=0,u[r+287|0]=0,u[r+288|0]=0,i[r+276>>2]=0,i[r+280>>2]=0,u[r+336|0]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,Q[r+356>>1]=1,i[r+368>>2]=0,i[r+372>>2]=0,i[r+360>>2]=0,i[r+364>>2]=0,i[r+384>>2]=0,i[r+388>>2]=1072693248,i[r+176>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+416>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+432>>2]=0,i[r+436>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+116>>2]=y,i[r+452>>2]=n,i[r+456>>2]=w,i[r+448>>2]=R,i[r>>2]=94592,r=r+460|0;l:{if(u[o+27|0]>=0){n=i[h+4>>2],i[r>>2]=i[h>>2],i[r+4>>2]=n,i[r+8>>2]=i[h+8>>2];break l}if(T(r,i[o+16>>2],i[o+20>>2]),u[o+27|0]>=0)break l;Z(i[o+16>>2])}v=o+32|0,i[f+4>>2]=W,i[f>>2]=I,i[t+68>>2]=i[f>>2],i[t+72>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,V2(f),u[k+19|0]<0&&Z(i[k+8>>2]),H6(_);break k}k=d2(f+12|0,4116),o=K(f+32|0,4,3001,k),w=E(488),r=w,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94552,h=i[o+12>>2],n=i[o+8>>2],W=i[f+184>>2],I=i[f+180>>2],i[o+8>>2]=0,i[o+12>>2]=0,_=i[o+16>>2],i[o+16>>2]=0,y=i[o>>2],R=i[o+4>>2],r=r+16|0,i[r+84>>2]=0,i[r+88>>2]=0,u[r+80|0]=0,u[r+68|0]=0,i[r+64>>2]=0,u[r+60|0]=0,u[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,u[r+12|0]=1,Q[r+10>>1]=2,Q[r+6>>1]=2,Q[r+8>>1]=2,u[r+4|0]=0,i[r+92>>2]=0,u[r+232|0]=0,i[r+96>>2]=4740,Q[r+138>>1]=0,Q[r+140>>1]=0,Q[r+142>>1]=0,Q[r+144>>1]=0,i[r+132>>2]=0,i[r+136>>2]=0,u[r+156|0]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,u[r+168|0]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+248>>2]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,i[r+112>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,Q[r+122>>1]=0,Q[r+124>>1]=0,Q[r+126>>1]=0,Q[r+128>>1]=0,i[r+352>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,u[r+272|0]=1,u[r+281|0]=0,u[r+282|0]=0,u[r+283|0]=0,u[r+284|0]=0,u[r+285|0]=0,u[r+286|0]=0,u[r+287|0]=0,u[r+288|0]=0,i[r+276>>2]=0,i[r+280>>2]=0,u[r+336|0]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,Q[r+356>>1]=1,i[r+368>>2]=0,i[r+372>>2]=0,i[r+360>>2]=0,i[r+364>>2]=0,i[r+384>>2]=0,i[r+388>>2]=1072693248,i[r+176>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+416>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+432>>2]=0,i[r+436>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+116>>2]=I,i[r+452>>2]=y,i[r+456>>2]=R,i[r+448>>2]=W,i[r>>2]=94592;o:{if((_|0)>=0){i[r+468>>2]=_,i[r+464>>2]=h,i[r+460>>2]=n;break o}T(r+460|0,n,h),Z(n)}if(i[f+4>>2]=w,i[f>>2]=r,i[t+68>>2]=i[f>>2],i[t+72>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,V2(f),u[o+19|0]<0&&Z(i[o+8>>2]),u[k+11|0]>=0)break k;Z(i[k>>2]);break k}r=E(464),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101024,o=i[f+180>>2],n=i[f+188>>2],i[r+100>>2]=0,i[r+104>>2]=0,u[r+96|0]=0,u[r+84|0]=0,i[r+80>>2]=0,u[r+76|0]=0,u[r+52|0]=0,i[r+48>>2]=0,i[r+40>>2]=1,i[r+44>>2]=1,i[r+32>>2]=0,i[r+36>>2]=0,u[r+28|0]=1,Q[r+26>>1]=2,Q[r+22>>1]=2,Q[r+24>>1]=2,u[r+20|0]=0,i[r+108>>2]=0,u[r+248|0]=0,i[r+116>>2]=n,i[r+112>>2]=4740,Q[r+144>>1]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+120>>2]=0,i[r+124>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,Q[r+154>>1]=0,Q[r+156>>1]=0,Q[r+158>>1]=0,Q[r+160>>1]=0,i[r+164>>2]=0,i[r+168>>2]=0,u[r+172|0]=0,i[r+176>>2]=0,i[r+180>>2]=0,u[r+184|0]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,u[r+288|0]=1,i[r+360>>2]=0,i[r+364>>2]=0,i[r+368>>2]=0,u[r+297|0]=0,u[r+298|0]=0,u[r+299|0]=0,u[r+300|0]=0,u[r+301|0]=0,u[r+302|0]=0,u[r+303|0]=0,u[r+304|0]=0,i[r+292>>2]=0,i[r+296>>2]=0,u[r+352|0]=0,i[r+344>>2]=0,i[r+348>>2]=0,i[r+336>>2]=0,i[r+340>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,Q[r+372>>1]=1,i[r+384>>2]=0,i[r+388>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,i[r+400>>2]=0,i[r+404>>2]=1072693248,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+232>>2]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+432>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+416>>2]=0,i[r+420>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,i[r+448>>2]=0,i[r+452>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+132>>2]=o,i[r+16>>2]=100440,o=f+32|0,i[o+4>>2]=r,i[o>>2]=r+16,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(o);break k}n=E(512),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101104,r=Y4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+448>>2]=0,i[r+452>>2]=0,i[r+460>>2]=0,i[r+464>>2]=0,i[r>>2]=101432,Q[r+456>>1]=0,i[r+468>>2]=0,i[r+472>>2]=0,i[r+476>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+488>>2]=0,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,V2(o);break k}i[t+68>>2]=0,i[t+72>>2]=0}v=f+192|0;k:{if(!i[t+68>>2])break k;i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,j1(t+376|0,i[e+48>>2],s,t+304|0);n:{if(!i[t+376>>2])break n;r=i[t+68>>2],f=X[i[i[r>>2]+40>>2]](r)|0,r=E(488),i[r>>2]=94552,i[r+4>>2]=0,i[r+8>>2]=0,o=i[t+380>>2],i[t+152>>2]=i[t+376>>2],i[t+156>>2]=o,o=r+16|0;t:{if(u[t+395|0]>=0){n=i[t+388>>2],i[B>>2]=i[t+384>>2],i[B+4>>2]=n,i[B+8>>2]=i[t+392>>2];break t}T(B,i[t+384>>2],i[t+388>>2])}o=Y4(o,0,s),i[o>>2]=94592,i[r+464>>2]=f,f=i[t+156>>2],i[r+468>>2]=i[t+152>>2],i[r+472>>2]=f,f=r+476|0;t:{if(u[t+171|0]>=0){n=i[B+4>>2],i[f>>2]=i[B>>2],i[f+4>>2]=n,i[f+8>>2]=i[B+8>>2];break t}if(T(f,i[t+160>>2],i[t+164>>2]),u[t+171|0]>=0)break t;Z(i[t+160>>2])}if(i[t+68>>2]=o,f=i[t+72>>2],i[t+72>>2]=r,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;X[i[i[f>>2]+8>>2]](f),p(f)}if(w=0,i[t+360>>2]=0,i[t+352>>2]=0,i[t+356>>2]=0,f=i[t+68>>2],r=0,h=0,o=i[t+304>>2],k=i[t+308>>2],(o|0)!=(k|0)){if(r=k-o|0,(r|0)<0)break i;for(h=E(r),i[t+352>>2]=h,w=r+h|0,i[t+360>>2]=w,r=h;i[r>>2]=i[o>>2],n=i[o+4>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,o=o+8|0,(k|0)!=(o|0););i[t+356>>2]=r}if(n=i[f+104>>2],n){if(o=i[f+108>>2],k=n,(o|0)!=(k|0)){for(;;){r=i[o-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=o-8|0,(n|0)==(o|0))break}k=i[f+104>>2],w=i[t+360>>2],h=i[t+352>>2],r=i[t+356>>2]}i[f+108>>2]=n,Z(k),o=i[t+68>>2]}else o=f;if(i[f+112>>2]=w,i[f+108>>2]=r,i[f+104>>2]=h,i[t+360>>2]=0,i[t+352>>2]=0,i[t+356>>2]=0,X[i[i[o>>2]+92>>2]](t+152|0,o),f=i[t+156>>2],r=i[t+152>>2],i[t+376>>2]=r,i[t+380>>2]=f,u[t+395|0]<0&&(Z(i[t+384>>2]),r=i[t+376>>2]),f=i[B+4>>2],i[t+384>>2]=i[B>>2],i[t+388>>2]=f,i[t+392>>2]=i[B+8>>2],f=i[t+68>>2],r){f=X[i[i[f>>2]+40>>2]](f)|0,r=E(488),i[r>>2]=94552,i[r+4>>2]=0,i[r+8>>2]=0,o=i[t+380>>2],i[t+152>>2]=i[t+376>>2],i[t+156>>2]=o,o=r+16|0;n:{if(u[t+395|0]>=0){n=i[t+388>>2],i[B>>2]=i[t+384>>2],i[B+4>>2]=n,i[B+8>>2]=i[t+392>>2];break n}T(B,i[t+384>>2],i[t+388>>2])}o=Y4(o,0,s),i[o>>2]=94592,i[r+464>>2]=f,f=i[t+156>>2],i[r+468>>2]=i[t+152>>2],i[r+472>>2]=f,f=r+476|0;n:{if(u[t+171|0]>=0){n=i[B+4>>2],i[f>>2]=i[B>>2],i[f+4>>2]=n,i[f+8>>2]=i[B+8>>2];break n}if(T(f,i[t+160>>2],i[t+164>>2]),u[t+171|0]>=0)break n;Z(i[t+160>>2])}i[t+68>>2]=o,f=i[t+72>>2],i[t+72>>2]=r;n:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;X[i[i[f>>2]+8>>2]](f),p(f)}if(w=0,i[t+348>>2]=0,i[t+340>>2]=0,i[t+344>>2]=0,n=i[t+68>>2],r=0,h=0,o=i[t+304>>2],k=i[t+308>>2],(o|0)!=(k|0)){if(r=k-o|0,(r|0)<0)break i;for(h=E(r),i[t+340>>2]=h,w=r+h|0,i[t+348>>2]=w,r=h;i[r>>2]=i[o>>2],f=i[o+4>>2],i[r+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),r=r+8|0,o=o+8|0,(k|0)!=(o|0););i[t+344>>2]=r}if(f=i[n+104>>2],f){if(o=i[n+108>>2],k=f,(o|0)!=(f|0)){for(;;){r=i[o-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=o-8|0,(f|0)==(o|0))break}k=i[n+104>>2],w=i[t+348>>2],h=i[t+340>>2],r=i[t+344>>2]}i[n+108>>2]=f,Z(k),f=i[t+68>>2]}else f=n;i[n+112>>2]=w,i[n+108>>2]=r,i[n+104>>2]=h,i[t+348>>2]=0,i[t+340>>2]=0,i[t+344>>2]=0}n=i[t+72>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);n:{t:{k=C,r=k,o=i[r>>2];u:{if(!o)break u;for(;;){if(r=o,o=i[r+16>>2],o>>>0>s>>>0){if(k=r,o=i[r>>2],o)continue;break u}if(o>>>0>=s>>>0)break t;if(o=i[r+4>>2],!o)break}k=r+4|0}o=E(28),i[o+24>>2]=n,i[o+20>>2]=f,i[o+16>>2]=s,i[o+8>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[k>>2]=o,r=i[i[e+16>>2]>>2],r&&(i[e+16>>2]=r),m1(i[e+20>>2],o),i[e+24>>2]=i[e+24>>2]+1;break n}if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break n;X[i[i[n>>2]+8>>2]](n),p(n)}if(!l[i[t+328>>2]+164|0]){n:{if((s|0)!=i[i[i[e+48>>2]+92>>2]+104>>2]||(r=i[t+68>>2],u[r+128|0]=1,f=i[t+72>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+40>>2]=r,r=i[e+44>>2],i[e+44>>2]=f,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break n;X[i[i[r>>2]+8>>2]](r),p(r)}r2(V,t+68|0)}if(r=i[t+68>>2],X[i[i[r>>2]+96>>2]](r),u[t+395|0]<0&&Z(i[t+384>>2]),f=i[t+304>>2],!f)break k;if(r=i[t+308>>2],o=f,(r|0)!=(f|0)){for(;;){o=i[r-4>>2];n:{if(!o||(n=i[o+4>>2],i[o+4>>2]=n-1,n))break n;X[i[i[o>>2]+8>>2]](o),p(o)}if(r=r-8|0,(f|0)==(r|0))break}o=i[t+304>>2]}i[t+308>>2]=f,Z(o)}r=i[t+72>>2];k:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break k;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=i[t+332>>2],!r)break f;if(f=i[r+4>>2],i[r+4>>2]=f-1,!f)break A;break f}if(r=i[t+332>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f}X[i[i[r>>2]+8>>2]](r),p(r)}if(m=m+4|0,(g|0)==(m|0))break}f:{A:{k:{if(!i[e+40>>2]){if(r=E(64),i[t+152>>2]=r,i[t+156>>2]=58,i[t+160>>2]=-2147483584,f=l[14429]|l[14430]<<8|(l[14431]<<16|l[14432]<<24),o=l[14425]|l[14426]<<8|(l[14427]<<16|l[14428]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+58|0]=0,f=l[14481]|l[14482]<<8,u[r+56|0]=f,u[r+57|0]=f>>>8,f=l[14477]|l[14478]<<8|(l[14479]<<16|l[14480]<<24),o=l[14473]|l[14474]<<8|(l[14475]<<16|l[14476]<<24),u[r+48|0]=o,u[r+49|0]=o>>>8,u[r+50|0]=o>>>16,u[r+51|0]=o>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[14469]|l[14470]<<8|(l[14471]<<16|l[14472]<<24),o=l[14465]|l[14466]<<8|(l[14467]<<16|l[14468]<<24),u[r+40|0]=o,u[r+41|0]=o>>>8,u[r+42|0]=o>>>16,u[r+43|0]=o>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[14461]|l[14462]<<8|(l[14463]<<16|l[14464]<<24),o=l[14457]|l[14458]<<8|(l[14459]<<16|l[14460]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14453]|l[14454]<<8|(l[14455]<<16|l[14456]<<24),o=l[14449]|l[14450]<<8|(l[14451]<<16|l[14452]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14445]|l[14446]<<8|(l[14447]<<16|l[14448]<<24),o=l[14441]|l[14442]<<8|(l[14443]<<16|l[14444]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14437]|l[14438]<<8|(l[14439]<<16|l[14440]<<24),o=l[14433]|l[14434]<<8|(l[14435]<<16|l[14436]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+152|0),u[t+163|0]>=0)break k;Z(i[t+152>>2]);break k}if(o=i[e+16>>2],(C|0)!=(o|0))for(N=A+8|0,A0=i[18063],r0=A0-12|0,n0=i[18064],N0=n0-12|0,h0=i[18067],U0=h0-12|0,m0=i[18065],D0=m0-12|0,x=t+136|0,H0=i[18072],L0=i[18071],y=t+172|0,R=t+184|0,q0=i[18069],$0=i[18068],W0=i[18066],a=t+164|0,S=t+160|0,Q0=t+216|0;;){r=i[o+20>>2],X[i[i[r>>2]+52>>2]](t+152|0,r),r=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]);n:{if(r)break n;i[t+336>>2]=0,i[t+328>>2]=0,i[t+332>>2]=0,j1(t+304|0,i[e+48>>2],i[o+16>>2],t+328|0);t:{if(i[t+304>>2]){r=i[t+308>>2],i[A>>2]=i[t+304>>2],i[A+4>>2]=r,i[N+8>>2]=i[t+320>>2],r=i[t+316>>2],i[N>>2]=i[t+312>>2],i[N+4>>2]=r,i[t+312>>2]=0,i[t+316>>2]=0,i[t+320>>2]=0,m=1;break t}u:{o:{l:{s:{r=i[t+328>>2],s=i[t+332>>2];w:{_:{if((r|0)==(s|0))break _;for(;;){h:{if(f=i[r>>2],!f||!X0(f,86628,86832))break h;n=i[r+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),f=i[e+48>>2],k=i[e+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),m=i[f+52>>2],w=i[f+56>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),g=i[o+16>>2],i[t+152>>2]=i[r>>2],f=i[r+4>>2],i[t+156>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[e+48>>2],h=i[e+52>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[t+376>>2]=i[f+60>>2],f=i[f+64>>2],i[t+380>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[m+36>>2],m=i[m+40>>2]-f>>3;B:{if((m|0)>0)v:for(_=i[t+152>>2],B=0;;){if((_|0)==i[f+(B<<3)>>2]){if(f=i[t+376>>2],_=i[f+104>>2],f=i[f+108>>2],(_|0)==(f|0))break v;for(m=B+1|0;;){Z:{G:{if((g|0)!=i[_>>2]||(B=i[_+4>>2],V=i[_+8>>2],(B|0)==(V|0)))break G;for(;;){if((m|0)==F[B+2>>1])break Z;if(B=B+4|0,(V|0)==(B|0))break}}if(_=_+16|0,(f|0)!=(_|0))continue;break v}break}f=u[B|0]&1;break B}if(B=B+1|0,(m|0)==(B|0))break}f=0}m=i[t+380>>2];B:{if(!m||(B=i[m+4>>2],i[m+4>>2]=B-1,B))break B;X[i[i[m>>2]+8>>2]](m),p(m)}B:{if(!h||(m=i[h+4>>2],i[h+4>>2]=m-1,m))break B;X[i[i[h>>2]+8>>2]](h),p(h)}h=i[t+156>>2];B:{if(!h||(m=i[h+4>>2],i[h+4>>2]=m-1,m))break B;X[i[i[h>>2]+8>>2]](h),p(h)}B:{if(!w||(h=i[w+4>>2],i[w+4>>2]=h-1,h))break B;X[i[i[w>>2]+8>>2]](w),p(w)}B:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break B;X[i[i[k>>2]+8>>2]](k),p(k)}B:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break B;X[i[i[n>>2]+8>>2]](n),p(n)}if(!f)break h;i[t+244>>2]=0,i[t+152>>2]=m0,i[t+216>>2]=72244,i[t+160>>2]=72224,f=t+152|0,i[f+i[D0>>2]>>2]=W0,i[t+156>>2]=0,n=f+i[i[t+152>>2]-12>>2]|0,J0(n,a),u[n+80|0]=0,i[n+72>>2]=0,i[t+160>>2]=h0,i[S+i[U0>>2]>>2]=$0,i[t+152>>2]=n0,i[f+i[N0>>2]>>2]=q0,i[t+216>>2]=72244,i[t+152>>2]=72204,i[t+160>>2]=72224,n=R0(a),i[n>>2]=71280,i[t+204>>2]=0,i[t+208>>2]=0,i[t+196>>2]=0,i[t+200>>2]=0,i[t+212>>2]=24,f=Y(S,27344,31),k=t+376|0,ie(k,i[r>>2]),h=f,r=u[t+387|0],f=(r|0)<0,Y(Y(h,f?i[t+376>>2]:k,f?i[t+380>>2]:r),27462,1),u[t+387|0]<0&&Z(i[t+376>>2]),r=i[t+212>>2];B:{if(r&16){if(r=R,B=i[t+208>>2],f=i[t+188>>2],B>>>0>=f>>>0)break B;i[t+208>>2]=f,B=f;break B}if(!(r&8)){r=0,u[t+387|0]=0,B=t+376|0;break u}B=i[t+180>>2],r=y}if(f=i[r>>2],r=B-f|0,r>>>0>=2147483640)break s;if(r>>>0>=11){k=r|7,B=E(k+1|0),i[t+384>>2]=k-2147483647,i[t+376>>2]=B,i[t+380>>2]=r;break o}if(u[t+387|0]=r,B=t+376|0,r)break o;r=0;break u}if(r=r+8|0,(s|0)==(r|0))break}if(r=i[t+328>>2],f=i[t+332>>2],(r|0)!=(f|0)){for(;;){n=i[r>>2];h:{if(!n||(n=X0(n,86628,86912),!n))break h;if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),(X[i[i[n>>2]+36>>2]](n)|0)!=2)break l;w=i[o+20>>2],h=i[n+108>>2],i[t+128>>2]=i[n+104>>2],i[t+132>>2]=h;B:{if(u[n+123|0]>=0){h=i[n+116>>2],i[x>>2]=i[n+112>>2],i[x+4>>2]=h,i[x+8>>2]=i[n+120>>2];break B}T(x,i[n+112>>2],i[n+116>>2])}n=i[w+428>>2];B:{if(n>>>0<u0[w+432>>2]){h=i[t+132>>2],i[n>>2]=i[t+128>>2],i[n+4>>2]=h,i[n+16>>2]=i[x+8>>2],h=i[x+4>>2],i[n+8>>2]=i[x>>2],i[n+12>>2]=h,i[x>>2]=0,i[x+4>>2]=0,i[x+8>>2]=0,i[w+428>>2]=n+20;break B}if(n=ee(w+424|0,t+128|0),h=u[t+147|0],i[w+428>>2]=n,(h|0)>=0)break B;Z(i[t+136>>2])}if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break h;X[i[i[k>>2]+8>>2]](k),p(k)}if(r=r+8|0,(f|0)==(r|0))break}f=i[t+332>>2],r=i[t+328>>2]}if(h=0,(r|0)==(f|0))break _;for(;;){h:{if(n=i[r>>2],!n||(n=X0(n,86628,86648),!n))break h;k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),w=i[n+104>>2],n=i[n+108>>2],B=(w|0)!=0&(n|0)!=0;B:{if(!B){if(n=E(32),i[t+152>>2]=n,i[t+156>>2]=26,i[t+160>>2]=-2147483616,w=l[4093]|l[4094]<<8|(l[4095]<<16|l[4096]<<24),m=l[4089]|l[4090]<<8|(l[4091]<<16|l[4092]<<24),u[n|0]=m,u[n+1|0]=m>>>8,u[n+2|0]=m>>>16,u[n+3|0]=m>>>24,u[n+4|0]=w,u[n+5|0]=w>>>8,u[n+6|0]=w>>>16,u[n+7|0]=w>>>24,u[n+26|0]=0,w=l[4113]|l[4114]<<8,u[n+24|0]=w,u[n+25|0]=w>>>8,w=l[4109]|l[4110]<<8|(l[4111]<<16|l[4112]<<24),m=l[4105]|l[4106]<<8|(l[4107]<<16|l[4108]<<24),u[n+16|0]=m,u[n+17|0]=m>>>8,u[n+18|0]=m>>>16,u[n+19|0]=m>>>24,u[n+20|0]=w,u[n+21|0]=w>>>8,u[n+22|0]=w>>>16,u[n+23|0]=w>>>24,w=l[4101]|l[4102]<<8|(l[4103]<<16|l[4104]<<24),m=l[4097]|l[4098]<<8|(l[4099]<<16|l[4100]<<24),u[n+8|0]=m,u[n+9|0]=m>>>8,u[n+10|0]=m>>>16,u[n+11|0]=m>>>24,u[n+12|0]=w,u[n+13|0]=w>>>8,u[n+14|0]=w>>>16,u[n+15|0]=w>>>24,K(A,2,129,t+152|0),u[t+163|0]>=0)break B;Z(i[t+152>>2]);break B}h=i[o+20>>2],i[h+124>>2]=n,i[h+120>>2]=w,h=1}B:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break B;if(X[i[i[k>>2]+8>>2]](k),p(k),B)break h;m=1;break t}if(B)break h;m=1;break t}if(r=r+8|0,(f|0)==(r|0))break}if(W=1,h&1)break w}f=i[o+20>>2],u[t+152|0]=0,u[t+163|0]=0,n=K(t+104|0,2,137,t+152|0),r=i[f+428>>2];_:{if(r>>>0<u0[f+432>>2]){k=i[n+4>>2],i[r>>2]=i[n>>2],i[r+4>>2]=k,i[r+16>>2]=i[t+120>>2],n=i[t+116>>2],i[r+8>>2]=i[t+112>>2],i[r+12>>2]=n,i[t+112>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[f+428>>2]=r+20;break _}if(r=ee(f+424|0,n),n=u[t+123|0],i[f+428>>2]=r,(n|0)>=0)break _;Z(i[t+112>>2])}u[t+163|0]<0&&Z(i[t+152>>2]),W=0}r=i[t+328>>2],h=i[t+332>>2];w:{if((r|0)==(h|0))break w;for(;;){k=i[r>>2];_:{if(!k)break _;if(n=X0(k,86628,95516),n){f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[t+152>>2]=i[n+100>>2],n=i[n+104>>2],i[t+156>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),st(i[o+20>>2],t+152|0),n=i[t+156>>2];h:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break h;X[i[i[n>>2]+8>>2]](n),p(n)}if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break _;X[i[i[f>>2]+8>>2]](f),p(f);break _}m=0,B=0;h:{B:{if(f=X0(k,86628,89244),!f)break B;if(B=i[r+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),!W){u[t+152|0]=0,u[t+163|0]=0,K(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]),m=1,w=0;break h}if(n=i[o+20>>2],k=i[f+148>>2],i[t+192>>2]=i[f+144>>2],i[t+196>>2]=k,k=i[f+140>>2],i[t+184>>2]=i[f+136>>2],i[t+188>>2]=k,k=i[f+132>>2],i[t+176>>2]=i[f+128>>2],i[t+180>>2]=k,k=i[f+124>>2],i[t+168>>2]=i[f+120>>2],i[t+172>>2]=k,k=i[f+116>>2],i[S>>2]=i[f+112>>2],i[S+4>>2]=k,k=i[f+108>>2],i[t+152>>2]=i[f+104>>2],i[t+156>>2]=k,w=1,u[n+288|0]=1,f=yA(n),k=YA(n),D=+(f|0),L=t0[t+152>>3]*D,t0[t+376>>3]=L,P0=+(k|0),t0[t+384>>3]=l[t+176|0]?t0[t+184>>3]*P0:L,t0[t+392>>3]=t0[t+160>>3]*D,t0[t+400>>3]=t0[t+168>>3]*P0,t0[t+408>>3]=t0[t+192>>3],f=i[t+412>>2],i[n+328>>2]=i[t+408>>2],i[n+332>>2]=f,f=i[t+404>>2],i[n+320>>2]=i[t+400>>2],i[n+324>>2]=f,f=i[t+396>>2],i[n+312>>2]=i[t+392>>2],i[n+316>>2]=f,f=i[t+388>>2],i[n+304>>2]=i[t+384>>2],i[n+308>>2]=f,f=i[t+380>>2],i[n+296>>2]=i[t+376>>2],i[n+300>>2]=f,k=i[r>>2],k)break B;break h}if(k=X0(k,86628,89324),!k){w=1;break h}if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=i[o+20>>2],s=t+152|0,z(s,k+104|0,80),w=1,u[n+336|0]=1,z(n+344|0,s,76),!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break h;X[i[i[f>>2]+8>>2]](f),p(f)}h:{if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break h;X[i[i[B>>2]+8>>2]](B),p(B)}if(!w)break t}if(r=r+8|0,(h|0)==(r|0))break}if(r=i[t+328>>2],V0=i[t+332>>2],(r|0)==(V0|0))break w;for(;;){f=i[r>>2];_:{if(!f)break _;B=0,k=0,g=X0(f,86628,88100);h:{if(g){if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),w=i[g+100>>2],f=i[g+104>>2],h=(f|0)/2|0,n=w+h|0,_=(w>>31)+(h>>31)|0,f=G2(n,n>>>0<h>>>0?_+1|0:_,f,f>>31),m=i[g+108>>2],n=i[g+112>>2],s=(n|0)/2|0,w=m+s|0,_=(m>>31)+(s>>31)|0,h=i[o+20>>2],d0=h,n2=G2(w,s>>>0>w>>>0?_+1|0:_,n,n>>31),i[d0+124>>2]=n2,i[h+120>>2]=f,V=i[o+20>>2],l[V+288|0]==1){O=i[V+124>>2],f=i[V+120>>2],n=f-1|0,f=f+65535>>>0<131073,_=f?n:(n|0)/2|0,n=i[g+116>>2],m=n>>31,h=f?2:1,w=i[g+120>>2];B:{if((h|0)==(w|0)){if(s=(_>>31)+m|0,m=n+_|0,s=m>>>0<_>>>0?s+1|0:s,f=s,!(m- -2147483648>>>0<2147483648?f+1|0:f))break B;s=f>>31,n=m+(s|1)|0,_=f+s|0,m=G2(n,n>>>0<m>>>0?_+1|0:_,2,0),h=1;break B}if(I=w>>31,s=O0(w,I,_,_>>31),e0=l0,h=f,f0=s,$=n,s=f&31,(f&63)>>>0>=32?(_=n<<s,f=0):(_=(1<<s)-1&$>>>32-s|m<<s,f=$<<s),m=f0+f|0,s=_+e0|0,f=f>>>0>m>>>0?s+1|0:s,$=0-(f+(m>>>0>2147483647)|0)|0,s=w,n=h&31,(h&63)>>>0>=32?(_=s<<n,n=0):(_=(1<<n)-1&s>>>32-n|I<<n,n=s<<n),w=_,h=0-(w+(n>>>0>2147483647)|0)|$,(h|0)==1|h>>>0>1)for(;s=w>>31,h=n+(s|1)|0,_=s+w|0,n=G2(h,n>>>0>h>>>0?_+1|0:_,2,0),w=l0,s=f>>31,h=m+(s|1)|0,s=f+s|0,m=G2(h,h>>>0<m>>>0?s+1|0:s,2,0),f=l0,(f-(m>>>0<2147483648)|0)!=-1;);h=n}if(w=i[g+100>>2],s=w,n=i[g+104>>2],f=s-n|0,w=n>>31,s=(s>>31)-(w+(n>>>0>s>>>0)|0)|0,_=0-(s+(f>>>0>2147483647)|0)|0-((n>>>0>2147483647)+w|0),(_|0)==1|_>>>0>1){for(;_=w>>31,I=n+(_|1)|0,_=w+_|0,n=G2(I,n>>>0>I>>>0?_+1|0:_,2,0),w=l0,_=s>>31,I=f+(_|1)|0,s=s+_|0,f=G2(I,f>>>0>I>>>0?s+1|0:s,2,0),s=l0,(s-(f>>>0<2147483648)|0)!=-1;);w=n>>31}s=w<<1|n>>>31,n=n<<1,I=f>>31,_=0-((n>>>0>2147483646)+s|0)|0-(I+(f>>>0>2147483647)|0),(_|0)==1|_>>>0>1&&(_=w>>31,w=n+(_|1)|0,s=s+_|0,n=G2(w,n>>>0>w>>>0?s+1|0:s,2,0),s=I>>31,w=f+(s|1)|0,s=s+I|0,f=G2(w,f>>>0>w>>>0?s+1|0:s,2,0)),w=m>>31;B:{if((n|0)==(h|0)){if(w=w-((f>>31)+(f>>>0>m>>>0)|0)|0,n=m-f|0,f=h,s=f>>31,!(0-(w+(n>>>0>2147483647)|0)|0-(s+(f>>>0>2147483647)|0)))break B;for(;_=s>>31,h=f+(_|1)|0,_=s+_|0,f=G2(h,f>>>0>h>>>0?_+1|0:_,2,0),s=l0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)|0)!=-1;);h=f;break B}if(s=n>>31,w=O0(n,s,m,w),_=l0,I=h>>31,f=O0(h,I,f,f>>31),m=w-f|0,w=_-(l0+(f>>>0>w>>>0)|0)|0,f=O0(n,s,h,I),n=m,s=l0,h=0-((n>>>0>2147483647)+w|0)|0-(s+(f>>>0>2147483647)|0),(h|0)==1|h>>>0>1)for(;_=s>>31,h=f+(_|1)|0,s=s+_|0,f=G2(h,f>>>0>h>>>0?s+1|0:s,2,0),m=l0,s=m,m=s-(f>>>0<2147483648)|0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)&m)!=-1;);h=f}t0[V+312>>3]=t0[V+312>>3]-+(n|0)/+(h|0),D=t0[V+320>>3],f=O-1|0,n=f,h=(f|0)/2|0,f=O+65535>>>0<131073,_=f?n:h,n=i[g+124>>2],m=n>>31,h=f?2:1,w=i[g+128>>2];B:{if((h|0)==(w|0)){if(s=(_>>31)+m|0,m=n+_|0,s=m>>>0<_>>>0?s+1|0:s,f=s,!(m- -2147483648>>>0<2147483648?f+1|0:f))break B;s=f>>31,n=m+(s|1)|0,_=f+s|0,m=G2(n,n>>>0<m>>>0?_+1|0:_,2,0),h=1;break B}if(h=w,I=w>>31,s=O0(w,I,_,_>>31),$=l0,w=f,f0=s,O=n,s=f&31,(f&63)>>>0>=32?(_=n<<s,f=0):(_=(1<<s)-1&O>>>32-s|m<<s,f=O<<s),m=f0+f|0,s=_+$|0,f=f>>>0>m>>>0?s+1|0:s,s=0-(f+(m>>>0>2147483647)|0)|0,n=w&31,(w&63)>>>0>=32?(_=h<<n,n=0):(_=(1<<n)-1&h>>>32-n|I<<n,n=h<<n),w=_,h=0-(w+(n>>>0>2147483647)|0)|s,(h|0)==1|h>>>0>1)for(;s=w>>31,h=n+(s|1)|0,_=s+w|0,n=G2(h,n>>>0>h>>>0?_+1|0:_,2,0),w=l0,s=f>>31,h=m+(s|1)|0,s=f+s|0,m=G2(h,h>>>0<m>>>0?s+1|0:s,2,0),f=l0,(f-(m>>>0<2147483648)|0)!=-1;);h=n}if(w=i[g+108>>2],s=w,n=i[g+112>>2],f=s-n|0,w=n>>31,s=(s>>31)-(w+(n>>>0>s>>>0)|0)|0,_=0-(s+(f>>>0>2147483647)|0)|0-((n>>>0>2147483647)+w|0),(_|0)==1|_>>>0>1){for(;_=w>>31,g=n+(_|1)|0,_=w+_|0,n=G2(g,n>>>0>g>>>0?_+1|0:_,2,0),w=l0,_=s>>31,g=f+(_|1)|0,s=s+_|0,f=G2(g,f>>>0>g>>>0?s+1|0:s,2,0),s=l0,(s-(f>>>0<2147483648)|0)!=-1;);w=n>>31}s=w<<1|n>>>31,n=n<<1,g=f>>31,_=0-((n>>>0>2147483646)+s|0)|0-(g+(f>>>0>2147483647)|0),(_|0)==1|_>>>0>1&&(_=w>>31,w=n+(_|1)|0,s=s+_|0,n=G2(w,n>>>0>w>>>0?s+1|0:s,2,0),s=g>>31,w=f+(s|1)|0,s=s+g|0,f=G2(w,f>>>0>w>>>0?s+1|0:s,2,0)),w=m>>31;B:{if((n|0)==(h|0)){if(w=w-((f>>31)+(f>>>0>m>>>0)|0)|0,n=m-f|0,f=h,s=f>>31,!(0-(w+(n>>>0>2147483647)|0)|0-(s+(f>>>0>2147483647)|0)))break B;for(;_=s>>31,h=f+(_|1)|0,_=s+_|0,f=G2(h,f>>>0>h>>>0?_+1|0:_,2,0),s=l0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)|0)!=-1;);h=f;break B}if(s=n>>31,w=O0(n,s,m,w),_=l0,g=h>>31,f=O0(h,g,f,f>>31),m=w-f|0,w=_-(l0+(f>>>0>w>>>0)|0)|0,f=O0(n,s,h,g),n=m,s=l0,h=0-((n>>>0>2147483647)+w|0)|0-(s+(f>>>0>2147483647)|0),(h|0)==1|h>>>0>1)for(;_=s>>31,h=f+(_|1)|0,s=s+_|0,f=G2(h,f>>>0>h>>>0?s+1|0:s,2,0),m=l0,s=m,m=s-(f>>>0<2147483648)|0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)&m)!=-1;);h=f}t0[V+320>>3]=D-+(n|0)/+(h|0)}if(f=i[r>>2],!f)break h}n=X0(f,86628,88020);B:{if(!n)break B;if(B=i[r+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),!W){u[t+152|0]=0,u[t+163|0]=0,K(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);v:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break v;X[i[i[B>>2]+8>>2]](B),p(B)}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;X[i[i[k>>2]+8>>2]](k),p(k);break t}f=i[o+20>>2],h=i[f+124>>2],w=24,_=8;v:switch(i[n+100>>2]){case 1:t0[f+296>>3]=-t0[f+296>>3],h=i[f+120>>2],w=16,_=32;break;case 0:break v;default:break B}f=f+296|0,n=f+_|0,t0[n>>3]=-t0[n>>3],f=f+w|0,t0[f>>3]=+(h-1>>>0)-t0[f>>3]}f=i[r>>2];B:{if(!f||(n=X0(f,86628,87940),!n))break B;if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=i[n+100>>2],!((n|0)!=270&(n|0)!=90)){if(!W){u[t+152|0]=0,u[t+163|0]=0,K(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);v:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break v;X[i[i[f>>2]+8>>2]](f),p(f)}v:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break v;X[i[i[B>>2]+8>>2]](B),p(B)}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;X[i[i[k>>2]+8>>2]](k),p(k);break t}n=i[o+20>>2],w=i[n+124>>2],i[n+124>>2]=i[n+120>>2],i[n+120>>2]=w}if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break B;X[i[i[f>>2]+8>>2]](f),p(f)}if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break h;X[i[i[B>>2]+8>>2]](B),p(B)}if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break _;X[i[i[k>>2]+8>>2]](k),p(k)}if(r=r+8|0,(V0|0)==(r|0))break}}if(m=0,w=i[o+20>>2],r=i[w+104>>2],n=i[w+108>>2],(r|0)==(n|0))break t;for(;;){w:{if(f=i[r>>2],!f||(f=X0(f,86628,89620),!f))break w;r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1,w=i[o+20>>2]);_:{if(u[f+111|0]>=0){i[t+96>>2]=i[f+108>>2],n=i[f+104>>2],i[t+88>>2]=i[f+100>>2],i[t+92>>2]=n;break _}T(t+88|0,i[f+100>>2],i[f+104>>2])}if(X[i[i[w>>2]+36>>2]](w,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;X[i[i[r>>2]+8>>2]](r),p(r);break t}if(r=r+8|0,(n|0)==(r|0))break}break t}g0(),H()}r=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=r;l:{if(u[n+123|0]>=0){r=i[n+116>>2],i[N>>2]=i[n+112>>2],i[N+4>>2]=r,i[N+8>>2]=i[n+120>>2];break l}T(N,i[n+112>>2],i[n+116>>2])}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;X[i[i[k>>2]+8>>2]](k),p(k);break t}if(!r)break u;z(B,f,r)}u[r+B|0]=0,K(A,4,3007,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),i[t+152>>2]=A0,i[i[r0>>2]+(t+152|0)>>2]=L0,i[t+160>>2]=H0,i[n>>2]=71280,u[t+207|0]<0&&Z(i[t+196>>2]),y0(n),p0(Q0),m=1}if(u[t+323|0]<0&&Z(i[t+312>>2]),f=i[t+328>>2],f){if(r=i[t+332>>2],k=f,(r|0)!=(f|0)){for(;;){n=i[r-4>>2];t:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break t;X[i[i[n>>2]+8>>2]](n),p(n)}if(r=r-8|0,(f|0)==(r|0))break}k=i[t+328>>2]}i[t+332>>2]=f,Z(k)}switch(m|0){case 0:case 5:break n;default:break k}}k=i[o+4>>2];n:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break n}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(C|0))break}r=i[e+48>>2],R=i[r+84>>2],x=i[r+88>>2],x&&(i[x+4>>2]=i[x+4>>2]+1),o=i[e+16>>2];n:{if(!(!R|(C|0)==(o|0))){for(O=i[18063],$=O-12|0,A0=i[18064],r0=A0-12|0,n0=i[18067],N0=n0-12|0,h0=i[18065],U0=h0-12|0,m0=i[18072],D0=i[18071],g=t+172|0,V=t+184|0,H0=i[18069],L0=i[18068],q0=i[18066],S=t+164|0,a=t+160|0,$0=t+216|0;;){i3(t+376|0,R,i[i[o+20>>2]+116>>2]),m=i[t+376>>2],W0=i[t+380>>2];t:{if((m|0)==(W0|0)){f=18;break t}y=o+20|0;u:{o:{l:{s:{for(;;){w:{_:{h:{B:{v:{Z:{G:{if(r=i[m+16>>2],(r|0)!=1635088492){if((r|0)!=1953000802)break w;if(i[t+160>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,r=i[m+48>>2],n=i[m+44>>2],(r|0)==(n|0))break G;if(r=r-n|0,(r|0)<0)break i;for(f=E(r),i[t+152>>2]=f,_=r+f|0,i[t+160>>2]=_,r&&z(f,n,r),i[t+156>>2]=_,w=f;;){n=i[w>>2],B=i[y>>2],u[B+129|0]=1;m:{k=C,r=i[k>>2];W:{if(!r)break W;for(;h=n>>>0>u0[r+16>>2],k=h?k:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)==(C|0))break W;if(n>>>0>=u0[k+16>>2])break m}if(r=E(48),i[t+304>>2]=r,i[t+308>>2]=41,i[t+312>>2]=-2147483600,n=l[14655]|l[14656]<<8|(l[14657]<<16|l[14658]<<24),k=l[14651]|l[14652]<<8|(l[14653]<<16|l[14654]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+41|0]=0,u[r+40|0]=l[14691],n=l[14687]|l[14688]<<8|(l[14689]<<16|l[14690]<<24),k=l[14683]|l[14684]<<8|(l[14685]<<16|l[14686]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=n,u[r+37|0]=n>>>8,u[r+38|0]=n>>>16,u[r+39|0]=n>>>24,n=l[14679]|l[14680]<<8|(l[14681]<<16|l[14682]<<24),k=l[14675]|l[14676]<<8|(l[14677]<<16|l[14678]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14671]|l[14672]<<8|(l[14673]<<16|l[14674]<<24),k=l[14667]|l[14668]<<8|(l[14669]<<16|l[14670]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14663]|l[14664]<<8|(l[14665]<<16|l[14666]<<24),k=l[14659]|l[14660]<<8|(l[14661]<<16|l[14662]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}if(h=i[k+20>>2],l[h+129|0]==1){if(r=E(40),i[t+304>>2]=r,i[t+308>>2]=38,i[t+312>>2]=-2147483608,n=l[9875]|l[9876]<<8|(l[9877]<<16|l[9878]<<24),k=l[9871]|l[9872]<<8|(l[9873]<<16|l[9874]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+38|0]=0,n=l[9905]|l[9906]<<8|(l[9907]<<16|l[9908]<<24),k=l[9901]|l[9902]<<8|(l[9903]<<16|l[9904]<<24),u[r+30|0]=k,u[r+31|0]=k>>>8,u[r+32|0]=k>>>16,u[r+33|0]=k>>>24,u[r+34|0]=n,u[r+35|0]=n>>>8,u[r+36|0]=n>>>16,u[r+37|0]=n>>>24,n=l[9899]|l[9900]<<8|(l[9901]<<16|l[9902]<<24),k=l[9895]|l[9896]<<8|(l[9897]<<16|l[9898]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[9891]|l[9892]<<8|(l[9893]<<16|l[9894]<<24),k=l[9887]|l[9888]<<8|(l[9889]<<16|l[9890]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[9883]|l[9884]<<8|(l[9885]<<16|l[9886]<<24),k=l[9879]|l[9880]<<8|(l[9881]<<16|l[9882]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}if((h|0)==(B|0)){if(r=E(40),i[t+304>>2]=r,i[t+308>>2]=34,i[t+312>>2]=-2147483608,n=l[16571]|l[16572]<<8|(l[16573]<<16|l[16574]<<24),k=l[16567]|l[16568]<<8|(l[16569]<<16|l[16570]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+34|0]=0,n=l[16599]|l[16600]<<8,u[r+32|0]=n,u[r+33|0]=n>>>8,n=l[16595]|l[16596]<<8|(l[16597]<<16|l[16598]<<24),k=l[16591]|l[16592]<<8|(l[16593]<<16|l[16594]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[16587]|l[16588]<<8|(l[16589]<<16|l[16590]<<24),k=l[16583]|l[16584]<<8|(l[16585]<<16|l[16586]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[16579]|l[16580]<<8|(l[16581]<<16|l[16582]<<24),k=l[16575]|l[16576]<<8|(l[16577]<<16|l[16578]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}r=i[h+136>>2],s=i[h+140>>2];m:{if(r>>>0<s>>>0){i[r>>2]=B,n=i[o+24>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),k=r+8|0;break m}if(B=i[h+132>>2],k=r-B|0,n=k>>3,r=n+1|0,r>>>0>=536870912)break i;if(s=s-B|0,W=s>>2,r=s>>>0>=2147483640?536870911:r>>>0<W>>>0?W:r,r>>>0>=536870912)break Z;if(W=r<<3,I=E(W),r=I+k|0,i[r>>2]=i[o+20>>2],s=i[o+24>>2],i[r+4>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1,B=i[h+132>>2],k=i[h+136>>2]-B|0,n=k>>3),n=r-(n<<3)|0,k&&z(n,B,k),i[h+140>>2]=W+I,k=r+8|0,i[h+136>>2]=k,i[h+132>>2]=n,!B)break m;Z(B)}if(i[h+136>>2]=k,w=w+4|0,(_|0)==(w|0))break}zr(e,y),Z(f);break w}m:{W:{X:{C:{I:{if(f=i[y>>2],r=i[f+104>>2],f=i[f+108>>2],(r|0)!=(f|0))for(;;){F:{if(n=i[r>>2],!n||(W=X0(n,86628,87860),!W))break F;if(N=i[r+4>>2],N&&(i[N+4>>2]=i[N+4>>2]+1),w=0,i[t+160>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,h=0,r=i[m+48>>2],f=i[m+44>>2],(r|0)!=(f|0)){if(r=r-f|0,(r|0)<0)break i;h=E(r),i[t+152>>2]=h,w=r+h|0,i[t+160>>2]=w,r&&z(h,f,r),i[t+156>>2]=w}switch(I=W+104|0,r=u[W+115|0],f=(r|0)<0,k=i[W+108>>2],n=f?k:r,n-25|0){case 0:break I;case 1:break C;case 18:break X;default:break m}}if(r=r+8|0,(f|0)==(r|0))break}i[t+244>>2]=0,i[t+152>>2]=h0,i[t+216>>2]=72244,i[t+160>>2]=72224,r=t+152|0,i[r+i[U0>>2]>>2]=q0,i[t+156>>2]=0,f=r+i[i[t+152>>2]-12>>2]|0,J0(f,S),u[f+80|0]=0,i[f+72>>2]=0,i[t+160>>2]=n0,i[a+i[N0>>2]>>2]=L0,i[t+152>>2]=A0,i[r+i[r0>>2]>>2]=H0,i[t+216>>2]=72244,i[t+152>>2]=72204,i[t+160>>2]=72224,n=R0(S),i[n>>2]=71280,i[t+204>>2]=0,i[t+208>>2]=0,i[t+196>>2]=0,i[t+200>>2]=0,i[t+212>>2]=24,I0(Y(a,28880,27),i[i[y>>2]+116>>2]),r=i[t+212>>2];F:{if(r&16){if(r=V,B=i[t+208>>2],f=i[t+188>>2],B>>>0>=f>>>0)break F;i[t+208>>2]=f,B=f;break F}if(!(r&8)){r=0,u[t+315|0]=0,B=t+304|0;break l}B=i[t+180>>2],r=g}if(f=i[r>>2],r=B-f|0,r>>>0>=2147483640)break v;if(r>>>0>=11){k=r|7,B=E(k+1|0),i[t+312>>2]=k-2147483647,i[t+304>>2]=B,i[t+308>>2]=r;break s}if(u[t+315|0]=r,B=t+304|0,r)break s;r=0;break l}if(N2(f?i[I>>2]:I,21829,25))break m;if((w|0)!=(h|0))break W;break m}if(N2(f?i[I>>2]:I,21802,n))break m;if((w|0)!=(h|0))break W;break m}if(N2(f?i[I>>2]:I,19037,n)|(w|0)==(h|0))break m}for(;;){f=i[h>>2];W:{X:{k=C,r=i[k>>2];C:{if(!r)break C;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(C|0))break C;if(f>>>0>=u0[k+16>>2])break X}if(ar(i[e+48>>2],f))break W;r=E(40),i[t+304>>2]=r,i[t+308>>2]=35,i[t+312>>2]=-2147483608,f=l[17768]|l[17769]<<8|(l[17770]<<16|l[17771]<<24),n=l[17764]|l[17765]<<8|(l[17766]<<16|l[17767]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+35|0]=0,f=l[17795]|l[17796]<<8|(l[17797]<<16|l[17798]<<24),u[r+31|0]=f,u[r+32|0]=f>>>8,u[r+33|0]=f>>>16,u[r+34|0]=f>>>24,f=l[17792]|l[17793]<<8|(l[17794]<<16|l[17795]<<24),n=l[17788]|l[17789]<<8|(l[17790]<<16|l[17791]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17784]|l[17785]<<8|(l[17786]<<16|l[17787]<<24),n=l[17780]|l[17781]<<8|(l[17782]<<16|l[17783]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17776]|l[17777]<<8|(l[17778]<<16|l[17779]<<24),n=l[17772]|l[17773]<<8|(l[17774]<<16|l[17775]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}n=i[k+20>>2],f=i[k+24>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),B=i[y>>2];X:{if((B|0)==(n|0)){if(r=E(32),i[t+304>>2]=r,i[t+308>>2]=30,i[t+312>>2]=-2147483616,k=l[16637]|l[16638]<<8|(l[16639]<<16|l[16640]<<24),s=l[16633]|l[16634]<<8|(l[16635]<<16|l[16636]<<24),u[r|0]=s,u[r+1|0]=s>>>8,u[r+2|0]=s>>>16,u[r+3|0]=s>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+30|0]=0,k=l[16659]|l[16660]<<8|(l[16661]<<16|l[16662]<<24),s=l[16655]|l[16656]<<8|(l[16657]<<16|l[16658]<<24),u[r+22|0]=s,u[r+23|0]=s>>>8,u[r+24|0]=s>>>16,u[r+25|0]=s>>>24,u[r+26|0]=k,u[r+27|0]=k>>>8,u[r+28|0]=k>>>16,u[r+29|0]=k>>>24,k=l[16653]|l[16654]<<8|(l[16655]<<16|l[16656]<<24),s=l[16649]|l[16650]<<8|(l[16651]<<16|l[16652]<<24),u[r+16|0]=s,u[r+17|0]=s>>>8,u[r+18|0]=s>>>16,u[r+19|0]=s>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[16645]|l[16646]<<8|(l[16647]<<16|l[16648]<<24),s=l[16641]|l[16642]<<8|(l[16643]<<16|l[16644]<<24),u[r+8|0]=s,u[r+9|0]=s>>>8,u[r+10|0]=s>>>16,u[r+11|0]=s>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,K(A,2,2e3,t+304|0),u[t+315|0]>=0)break X;Z(i[t+304>>2]);break X}if(u[B+144|0]=1,k=i[o+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+148>>2]=B,r=i[n+152>>2],i[n+152>>2]=k,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break X;X[i[i[r>>2]+8>>2]](r),p(r)}X:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break X;X[i[i[f>>2]+8>>2]](f),p(f)}if((n|0)!=(B|0))break W;r=0;break h}if(h=h+4|0,(w|0)==(h|0))break}r=l[W+115|0],k=i[W+108>>2]}m:{W:{if(f=r,r=r<<24>>24<0,f=(r?k:f)-26|0,f){if((f|0)==17)break W;break B}if(!N2(r?i[I>>2]:I,21535,26))break m;break B}if(N2(r?i[I>>2]:I,10671,43))break B}if(u[i[y>>2]+156|0]=1,h=i[t+152>>2],Q0=i[t+156>>2],(h|0)==(Q0|0))break B;for(;;){m:{f=i[h>>2];W:{X:{k=C,r=i[k>>2];C:{if(!r)break C;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(C|0))break C;if(f>>>0>=u0[k+16>>2])break X}if(ar(i[e+48>>2],f))break W;r=E(40),i[t+304>>2]=r,i[t+308>>2]=35,i[t+312>>2]=-2147483608,f=l[17698]|l[17699]<<8|(l[17700]<<16|l[17701]<<24),n=l[17694]|l[17695]<<8|(l[17696]<<16|l[17697]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+35|0]=0,f=l[17725]|l[17726]<<8|(l[17727]<<16|l[17728]<<24),u[r+31|0]=f,u[r+32|0]=f>>>8,u[r+33|0]=f>>>16,u[r+34|0]=f>>>24,f=l[17722]|l[17723]<<8|(l[17724]<<16|l[17725]<<24),n=l[17718]|l[17719]<<8|(l[17720]<<16|l[17721]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17714]|l[17715]<<8|(l[17716]<<16|l[17717]<<24),n=l[17710]|l[17711]<<8|(l[17712]<<16|l[17713]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17706]|l[17707]<<8|(l[17708]<<16|l[17709]<<24),n=l[17702]|l[17703]<<8|(l[17704]<<16|l[17705]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}if(r=i[y>>2],f=i[k+20>>2],(r|0)==(f|0)){r=E(32),i[t+304>>2]=r,i[t+308>>2]=30,i[t+312>>2]=-2147483616,f=l[16606]|l[16607]<<8|(l[16608]<<16|l[16609]<<24),n=l[16602]|l[16603]<<8|(l[16604]<<16|l[16605]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+30|0]=0,f=l[16628]|l[16629]<<8|(l[16630]<<16|l[16631]<<24),n=l[16624]|l[16625]<<8|(l[16626]<<16|l[16627]<<24),u[r+22|0]=n,u[r+23|0]=n>>>8,u[r+24|0]=n>>>16,u[r+25|0]=n>>>24,u[r+26|0]=f,u[r+27|0]=f>>>8,u[r+28|0]=f>>>16,u[r+29|0]=f>>>24,f=l[16622]|l[16623]<<8|(l[16624]<<16|l[16625]<<24),n=l[16618]|l[16619]<<8|(l[16620]<<16|l[16621]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[16614]|l[16615]<<8|(l[16616]<<16|l[16617]<<24),n=l[16610]|l[16611]<<8|(l[16612]<<16|l[16613]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}n=i[o+24>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+160>>2]=r,r=i[f+164>>2],i[f+164>>2]=n;X:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break X;X[i[i[r>>2]+8>>2]](r),p(r)}if(i[W+116>>2]==i[W+120>>2])break W;i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,V0=t+304|0,n=v-112|0,v=n,r=i[W+116>>2],f=ei(n- -64|0,r,i[W+120>>2]-r|0),r=i[f+12>>2],w=r>>31<<3|r>>>29,k=i[f+24>>2],r=k+(r<<3)|0,s=(k>>31)+w|0;X:{C:{s=r>>>0<k>>>0?s+1|0:s;I:{if((s|0)<=0&r>>>0<=31|(s|0)<0){if(r=E(24),i[n+32>>2]=r,i[n+36>>2]=22,i[n+40>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,100,n+32|0),u[n+43|0]>=0)break I;Z(i[n+32>>2]);break I}k=i2(f,32),r=(i[f+8>>2]-i[f+12>>2]|0)+(i[f+24>>2]/-8|0)|0;F:{if((k|0)<=(r|0))break F;if(r=r+i[W+116>>2]|0,k=ei(n+32|0,r,i[W+120>>2]-r|0),r=i[k+12>>2],s=r>>31<<3|r>>>29,f=i[k+24>>2],r=f+(r<<3)|0,_=(f>>31)+s|0,_=r>>>0<f>>>0?_+1|0:_,(_|0)<=0&r>>>0<=39|(_|0)<0){if(r=E(24),i[n+8>>2]=r,i[n+12>>2]=22,i[n+16>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,100,n+8|0),u[n+19|0]>=0)break I;Z(i[n+8>>2]);break I}if(i2(k,32),r=V1(k,8),I2(k,8),((r>>>1|0)-39&255)>>>0>1)break F;if(r=i[k+24>>2],f=r,w=r>>31,r=i[k+12>>2],_=r>>31<<3|r>>>29,s=f,f=r<<3,r=s+f|0,w=w+_|0,w=r>>>0<f>>>0?w+1|0:w,(w|0)<=0&r>>>0<=15|(w|0)<0){if(r=E(24),i[n+8>>2]=r,i[n+12>>2]=22,i[n+16>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,100,n+8|0),u[n+19|0]>=0)break I;Z(i[n+8>>2]);break I}if(r=V1(k,8),V1(k,8),(r|0)!=177)break F;B=n+8|0,w=v-48|0,v=w,r=E(80),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r>>2]=97632,i[r+16>>2]=97672,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,f=r- -64|0,i[f>>2]=0,i[f+4>>2]=0,u[r+24|0]=1,f=i2(k,1),u[r+25|0]=f,d0=r,n2=i2(k,1),u[d0+26|0]=n2,s=i2(k,1),u[r+27|0]=s,_=i2(k,1),u[r+28|0]=_;Q:{if(!$2(k,w+44|0)){f=E(48),i[w+12>>2]=f,i[w+16>>2]=42,i[w+20>>2]=-2147483600,k=l[3289]|l[3290]<<8,u[f+40|0]=k,u[f+41|0]=k>>>8,k=l[3285]|l[3286]<<8|(l[3287]<<16|l[3288]<<24),s=l[3281]|l[3282]<<8|(l[3283]<<16|l[3284]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[3277]|l[3278]<<8|(l[3279]<<16|l[3280]<<24),s=l[3273]|l[3274]<<8|(l[3275]<<16|l[3276]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[3269]|l[3270]<<8|(l[3271]<<16|l[3272]<<24),s=l[3265]|l[3266]<<8|(l[3267]<<16|l[3268]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[3261]|l[3262]<<8|(l[3263]<<16|l[3264]<<24),s=l[3257]|l[3258]<<8|(l[3259]<<16|l[3260]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[3253]|l[3254]<<8|(l[3255]<<16|l[3256]<<24),s=l[3249]|l[3250]<<8|(l[3251]<<16|l[3252]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+42|0]=0,f=K(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;V:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break V}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break V;Z(i[f+8>>2])}if(u[w+23|0]>=0)break Q;Z(i[w+12>>2]);break Q}if(e0=i[w+44>>2],e0>>>0>=4){f=E(48),i[w+12>>2]=f,i[w+16>>2]=44,i[w+20>>2]=-2147483600,k=l[14026]|l[14027]<<8|(l[14028]<<16|l[14029]<<24),u[f+40|0]=k,u[f+41|0]=k>>>8,u[f+42|0]=k>>>16,u[f+43|0]=k>>>24,k=l[14022]|l[14023]<<8|(l[14024]<<16|l[14025]<<24),s=l[14018]|l[14019]<<8|(l[14020]<<16|l[14021]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[14014]|l[14015]<<8|(l[14016]<<16|l[14017]<<24),s=l[14010]|l[14011]<<8|(l[14012]<<16|l[14013]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[14006]|l[14007]<<8|(l[14008]<<16|l[14009]<<24),s=l[14002]|l[14003]<<8|(l[14004]<<16|l[14005]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[13998]|l[13999]<<8|(l[14e3]<<16|l[14001]<<24),s=l[13994]|l[13995]<<8|(l[13996]<<16|l[13997]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[13990]|l[13991]<<8|(l[13992]<<16|l[13993]<<24),s=l[13986]|l[13987]<<8|(l[13988]<<16|l[13989]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+44|0]=0,f=K(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;V:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break V}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break V;Z(i[f+8>>2])}if(u[w+23|0]>=0)break Q;Z(i[w+12>>2]);break Q}if(i[r+64>>2]=e0,(s|_)&255){if(!$2(k,w+8|0)){f=E(48),i[w+12>>2]=f,i[w+16>>2]=41,i[w+20>>2]=-2147483600,u[f+40|0]=l[3247],k=l[3243]|l[3244]<<8|(l[3245]<<16|l[3246]<<24),s=l[3239]|l[3240]<<8|(l[3241]<<16|l[3242]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[3235]|l[3236]<<8|(l[3237]<<16|l[3238]<<24),s=l[3231]|l[3232]<<8|(l[3233]<<16|l[3234]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[3227]|l[3228]<<8|(l[3229]<<16|l[3230]<<24),s=l[3223]|l[3224]<<8|(l[3225]<<16|l[3226]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[3219]|l[3220]<<8|(l[3221]<<16|l[3222]<<24),s=l[3215]|l[3216]<<8|(l[3217]<<16|l[3218]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[3211]|l[3212]<<8|(l[3213]<<16|l[3214]<<24),s=l[3207]|l[3208]<<8|(l[3209]<<16|l[3210]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+41|0]=0,f=K(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;V:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break V}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break V;Z(i[f+8>>2])}if(u[w+23|0]>=0)break Q;Z(i[w+12>>2]);break Q}i[r+68>>2]=i[w+8>>2],f=l[r+25|0]}if(f&255){_=V1(k,1),f=i2(k,7),s=V1(k,5)+1&255,D=+(i2(k,s)>>>0);V:{if((f|0)>0){L=A4(1,s),D=A4(1,f-31|0)*(D/L+1);break V}D=A4(1,-30-s|0)*D}t0[r+32>>3]=_?-D:D}if(l[r+26|0]){_=V1(k,1),f=i2(k,7),s=V1(k,5)+1&255,D=+(i2(k,s)>>>0);V:{if((f|0)>0){L=A4(1,s),D=A4(1,f-31|0)*(D/L+1);break V}D=A4(1,-30-s|0)*D}t0[r+40>>3]=_?-D:D}if(l[r+27|0]){_=V1(k,1),f=i2(k,7),s=V1(k,5)+1&255,D=+(i2(k,s)>>>0);V:{if((f|0)>0){L=A4(1,s),D=A4(1,f-31|0)*(D/L+1);break V}D=A4(1,-30-s|0)*D}t0[r+48>>3]=_?-D:D}if(l[r+28|0]){s=V1(k,1),f=i2(k,7),_=k,k=V1(k,5)+1&255,D=+(i2(_,k)>>>0);V:{if((f|0)>0){L=A4(1,k),D=A4(1,f-31|0)*(D/L+1);break V}D=A4(1,-30-k|0)*D}t0[r+56>>3]=s?-D:D}i[r+4>>2]=i[r+4>>2]+1,u[B+20|0]=0,i[B+4>>2]=r,i[B>>2]=r+16}f=i[r+4>>2],i[r+4>>2]=f-1,f||(X[i[i[r>>2]+8>>2]](r),p(r)),v=w+48|0,r=l[n+28|0];Q:{if(r){if((r|0)!=1)break C;k8(A,B);break Q}r2(V0,n+8|0)}if(f=l[n+28|0],(f|0)!=255&&(k=i[24421],i[n+104>>2]=i[24420],i[n+108>>2]=k,X[i[(n+104|0)+(f<<2)>>2]](n+103|0,n+8|0)),r)break I}if(r=i[26929],i[A>>2]=i[26928],i[A+4>>2]=r,r=A+8|0,u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break I}T(r,i[26930],i[26931])}v=n+112|0;break X}_2(),H()}if(r=i[t+304>>2],i[A>>2])break m;if(w=i[t+308>>2],(w|0)!=(r|0))for(;;){f=i[r>>2];X:{if(!f||(f=X0(f,94716,94724),!f))break X;if(k=i[r+4>>2],!k){n=i[y>>2],u[n+168|0]=1,k=i[f+12>>2],i[n+176>>2]=i[f+8>>2],i[n+180>>2]=k,k=i[f+20>>2],i[n+184>>2]=i[f+16>>2],i[n+188>>2]=k,k=i[f+28>>2],i[n+192>>2]=i[f+24>>2],i[n+196>>2]=k,k=i[f+36>>2],i[n+200>>2]=i[f+32>>2],i[n+204>>2]=k,k=i[f+44>>2],i[n+208>>2]=i[f+40>>2],i[n+212>>2]=k,k=i[f+52>>2],i[n+216>>2]=i[f+48>>2],i[n+220>>2]=k,k=i[f+60>>2],i[n+224>>2]=i[f+56>>2],i[n+228>>2]=k;break X}if(i[k+4>>2]=i[k+4>>2]+1,n=i[y>>2],u[n+168|0]=1,B=i[f+12>>2],i[n+176>>2]=i[f+8>>2],i[n+180>>2]=B,B=i[f+20>>2],i[n+184>>2]=i[f+16>>2],i[n+188>>2]=B,B=i[f+28>>2],i[n+192>>2]=i[f+24>>2],i[n+196>>2]=B,B=i[f+36>>2],i[n+200>>2]=i[f+32>>2],i[n+204>>2]=B,B=i[f+44>>2],i[n+208>>2]=i[f+40>>2],i[n+212>>2]=B,B=i[f+52>>2],i[n+216>>2]=i[f+48>>2],i[n+220>>2]=B,B=i[f+60>>2],i[n+224>>2]=i[f+56>>2],i[n+228>>2]=B,f=i[k+4>>2],i[k+4>>2]=f-1,f)break X;X[i[i[k>>2]+8>>2]](k),p(k)}if(r=r+8|0,(w|0)==(r|0))break}if(u[A+19|0]<0&&Z(i[A+8>>2]),f=i[t+304>>2],!f)break W;if(r=i[t+308>>2],k=f,(r|0)!=(f|0)){for(;;){n=i[r-4>>2];X:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break X;X[i[i[n>>2]+8>>2]](n),p(n)}if(r=r-8|0,(f|0)==(r|0))break}k=i[t+304>>2]}i[t+308>>2]=f,Z(k)}if(h=h+4|0,(Q0|0)!=(h|0))continue;break B}break}if(r){if(B=r,k=i[t+308>>2],(k|0)!=(r|0)){for(;;){f=i[k-4>>2];m:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break m;X[i[i[f>>2]+8>>2]](f),p(f)}if(k=k-8|0,(k|0)==(r|0))break}B=i[t+304>>2]}i[t+308>>2]=r,Z(B)}r=0;break h}zr(e,y);break w}x0(),H()}g0(),H()}n=i[y>>2],u[n+232|0]=1,r=n+236|0;B:{if((r|0)==(I|0))break B;if(f=u[W+115|0],u[n+247|0]>=0){if((f|0)>=0){f=i[I+4>>2],i[r>>2]=i[I>>2],i[r+4>>2]=f,i[r+8>>2]=i[I+8>>2];break B}D1(r,i[W+104>>2],i[W+108>>2]);break B}k=r,r=(f|0)<0,O1(k,r?i[W+104>>2]:I,r?i[W+108>>2]:f)}if(w=i[t+152>>2],_=i[t+156>>2],(w|0)==(_|0)){r=1;break _}for(;;){f=i[w>>2];B:{v:{k=C,r=i[k>>2];Z:{if(!r)break Z;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(C|0))break Z;if(f>>>0>=u0[k+16>>2])break v}if(ar(i[e+48>>2],f))break B;r=E(40),i[t+304>>2]=r,i[t+308>>2]=33,i[t+312>>2]=-2147483608,f=l[17664]|l[17665]<<8|(l[17666]<<16|l[17667]<<24),n=l[17660]|l[17661]<<8|(l[17662]<<16|l[17663]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+33|0]=0,u[r+32|0]=l[17692],f=l[17688]|l[17689]<<8|(l[17690]<<16|l[17691]<<24),n=l[17684]|l[17685]<<8|(l[17686]<<16|l[17687]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17680]|l[17681]<<8|(l[17682]<<16|l[17683]<<24),n=l[17676]|l[17677]<<8|(l[17678]<<16|l[17679]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17672]|l[17673]<<8|(l[17674]<<16|l[17675]<<24),n=l[17668]|l[17669]<<8|(l[17670]<<16|l[17671]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}if(r=i[y>>2],n=i[k+20>>2],(r|0)==(n|0)){r=E(32),i[t+304>>2]=r,i[t+308>>2]=28,i[t+312>>2]=-2147483616,f=l[16542]|l[16543]<<8|(l[16544]<<16|l[16545]<<24),n=l[16538]|l[16539]<<8|(l[16540]<<16|l[16541]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+28|0]=0,f=l[16562]|l[16563]<<8|(l[16564]<<16|l[16565]<<24),u[r+24|0]=f,u[r+25|0]=f>>>8,u[r+26|0]=f>>>16,u[r+27|0]=f>>>24,f=l[16558]|l[16559]<<8|(l[16560]<<16|l[16561]<<24),n=l[16554]|l[16555]<<8|(l[16556]<<16|l[16557]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[16550]|l[16551]<<8|(l[16552]<<16|l[16553]<<24),n=l[16546]|l[16547]<<8|(l[16548]<<16|l[16549]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}i[t+80>>2]=r,r=i[o+24>>2],i[t+84>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[t+84>>2],i[t+8>>2]=i[t+80>>2],i[t+12>>2]=r;v:{if(r=i[n+252>>2],h=i[n+256>>2],r>>>0<h>>>0){i[r>>2]=i[t+8>>2],i[r+4>>2]=i[t+12>>2],i[n+252>>2]=r+8;break v}Z:{if(k=i[n+248>>2],r=r-k|0,s=r>>3,f=s+1|0,f>>>0<536870912){if(h=h-k|0,B=h>>2,h=h>>>0>=2147483640?536870911:f>>>0<B>>>0?B:f,h){if(h>>>0>=536870912)break Z;f=E(h<<3)}else f=0;B=f+r|0,i[B>>2]=i[t+8>>2],i[B+4>>2]=i[t+12>>2],s=B-(s<<3)|0,r&&z(s,k,r),i[n+256>>2]=f+(h<<3),r=B+8|0,i[n+252>>2]=r,i[n+248>>2]=s,k&&Z(k),i[n+252>>2]=r;break v}G0(),H()}x0(),H()}zr(e,y)}if(w=w+4|0,(_|0)==(w|0))break}r=1}w=i[t+152>>2]}w&&(i[t+156>>2]=w,Z(w));_:{if(!N||(f=i[N+4>>2],i[N+4>>2]=f-1,f))break _;X[i[i[N>>2]+8>>2]](N),p(N)}if(r)break w;f=1;break u}if(m=m+56|0,(W0|0)==(m|0))break}f=18;break u}if(!r)break l;z(B,f,r)}u[r+B|0]=0,K(A,2,123,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),i[t+152>>2]=O,i[i[$>>2]+(t+152|0)>>2]=D0,i[t+160>>2]=m0,i[n>>2]=71280,u[t+207|0]<0&&Z(i[t+196>>2]),y0(n),p0($0),f=1;break u}Z(f),f=1}m=i[t+376>>2]}if(m){if(r=i[t+380>>2],k=m,(r|0)!=(k|0)){for(;n=i[r-12>>2],n&&(i[r-8>>2]=n,Z(n)),n=r-56|0,i[n>>2]=86404,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=n,(m|0)!=(r|0););k=i[t+376>>2]}i[t+380>>2]=m,Z(k)}t:{if((f|0)!=18){if((f|0)==16)break t;break n}k=o,r=i[k+4>>2];u:{if(r){for(;;)if(o=r,r=i[r>>2],!r)break u}for(;o=i[k+8>>2],r=i[o>>2]!=(k|0),k=o,!!r;);}if((o|0)!=(C|0))continue}break}o=i[e+16>>2]}if((o|0)!=(C|0)){for(;;){if(r=i[o+20>>2],X[i[i[r>>2]+52>>2]](t+152|0,r),r=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]),!r){s4(t+376|0,i[e+48>>2],i[i[o+20>>2]+116>>2]),r=i[i[t+376>>2]+112>>2];t:{if((r|0)==1752589105){r=i[e+48>>2],i[t+304>>2]=i[r+60>>2],f=i[r+64>>2],i[t+308>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),n=i[r+52>>2],f=i[r+56>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),Mt(t+152|0,n,i[i[o+20>>2]+116>>2],t+304|0,1752589123),n=i[t+152>>2],r=i[t+156>>2];u:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break u;X[i[i[r>>2]+8>>2]](r),p(r)}if(!n){r=E(40),i[t+152>>2]=r,i[t+156>>2]=35,i[t+160>>2]=-2147483608,n=l[14733]|l[14734]<<8|(l[14735]<<16|l[14736]<<24),k=l[14729]|l[14730]<<8|(l[14731]<<16|l[14732]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+35|0]=0,n=l[14760]|l[14761]<<8|(l[14762]<<16|l[14763]<<24),u[r+31|0]=n,u[r+32|0]=n>>>8,u[r+33|0]=n>>>16,u[r+34|0]=n>>>24,n=l[14757]|l[14758]<<8|(l[14759]<<16|l[14760]<<24),k=l[14753]|l[14754]<<8|(l[14755]<<16|l[14756]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14749]|l[14750]<<8|(l[14751]<<16|l[14752]<<24),k=l[14745]|l[14746]<<8|(l[14747]<<16|l[14748]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14741]|l[14742]<<8|(l[14743]<<16|l[14744]<<24),k=l[14737]|l[14738]<<8|(l[14739]<<16|l[14740]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(A,2,106,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;X[i[i[f>>2]+8>>2]](f),p(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}k=0;break t}u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;X[i[i[f>>2]+8>>2]](f),p(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[i[t+376>>2]+112>>2]}if(k=1,(r|0)!=1987470129)break t;r=i[e+48>>2],i[t+304>>2]=i[r+60>>2],f=i[r+64>>2],i[t+308>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),n=i[r+52>>2],f=i[r+56>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),Mt(t+152|0,n,i[i[o+20>>2]+116>>2],t+304|0,1987470147),n=i[t+152>>2],r=i[t+156>>2];u:{if(!r||(w=i[r+4>>2],i[r+4>>2]=w-1,w))break u;X[i[i[r>>2]+8>>2]](r),p(r)}if(!n){r=E(40),i[t+152>>2]=r,i[t+156>>2]=35,i[t+160>>2]=-2147483608,n=l[14697]|l[14698]<<8|(l[14699]<<16|l[14700]<<24),k=l[14693]|l[14694]<<8|(l[14695]<<16|l[14696]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+35|0]=0,n=l[14724]|l[14725]<<8|(l[14726]<<16|l[14727]<<24),u[r+31|0]=n,u[r+32|0]=n>>>8,u[r+33|0]=n>>>16,u[r+34|0]=n>>>24,n=l[14721]|l[14722]<<8|(l[14723]<<16|l[14724]<<24),k=l[14717]|l[14718]<<8|(l[14719]<<16|l[14720]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14713]|l[14714]<<8|(l[14715]<<16|l[14716]<<24),k=l[14709]|l[14710]<<8|(l[14711]<<16|l[14712]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14705]|l[14706]<<8|(l[14707]<<16|l[14708]<<24),k=l[14701]|l[14702]<<8|(l[14703]<<16|l[14704]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(A,2,141,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;X[i[i[f>>2]+8>>2]](f),p(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}k=0;break t}u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=i[t+308>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[t+380>>2];t:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;X[i[i[r>>2]+8>>2]](r),p(r)}if(!k)break n}k=i[o+4>>2];t:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break t}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(C|0))break}o=i[e+16>>2]}t:{if((o|0)==(C|0))break t;for(;;){r=i[o+16>>2],f=i[o+20>>2],X[i[i[f>>2]+52>>2]](t+152|0,f),f=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]);u:{if(f)break u;s4(t+376|0,i[e+48>>2],r),n=i[t+376>>2],f=n?32:33;o:{if(!R|!n)break o;if(i[n+112>>2]==1735551332){L8(t+152|0,R,r,1684630887),k=i[t+152>>2];l:{if((k|0)==i[t+156>>2]){f=33;break l}f=33,r=i[C>>2];s:{if(!r)break s;for(n=i[k>>2],k=C;w=n>>>0>u0[r+16>>2],k=w?k:r,r=i[(w?4:0)+r>>2],!!r;);if((k|0)==(C|0)|n>>>0<u0[k+16>>2])break s;f=i[k+20>>2],r=i[k+24>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k=i[o+20>>2];w:{if(i[k+16>>2]||(n=i[f+16>>2],!n))break w;i[t+304>>2]=n,n=i[f+20>>2],i[t+308>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),n=t+304|0,st(k,n),V2(n),k=i[o+20>>2]}w:{if(S4(k)||!S4(f))break w;n=i[o+20>>2],k=F[f+10>>1]|F[f+12>>1]<<16,i[t+304>>2]=F[f+6>>1]|F[f+8>>1]<<16,i[t+308>>2]=k,X[i[i[n>>2]+8>>2]](n,t+304|0)}if(f=0,!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break s;X[i[i[r>>2]+8>>2]](r),p(r)}k=i[t+152>>2]}if(k&&(i[t+156>>2]=k,Z(k)),f)break o}f=0}r=i[t+380>>2];o:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break o;X[i[i[r>>2]+8>>2]](r),p(r)}if((f|0)==33)break u;if(f)break t}k=i[o+4>>2];u:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break u}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(C|0))break}}f=i[t+364>>2],V=i[t+368>>2];t:{if((f|0)==(V|0))break t;for(s=A+8|0,n=i[23602],W=i[23603];;){w=i[f>>2],r=J6(i[e+48>>2],w),m=t+376|0,o=0;u:{o:{k=i[e+48>>2],B=i[k+128>>2];l:{if(!B)break l;for(h=k+128|0,k=h;o=w>>>0>u0[B+16>>2],k=o?k:B,B=i[(o?4:0)+B>>2],!!B;);if(o=0,(k|0)==(h|0)|w>>>0<u0[k+16>>2])break l;if(h=i[k+20>>2],o=i[k+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),h)break o}u[m|0]=0,u[m+11|0]=0;break u}if(u[h+139|0]>=0){k=i[h+132>>2],i[m>>2]=i[h+128>>2],i[m+4>>2]=k,i[m+8>>2]=i[h+136>>2];break u}T(m,i[h+128>>2],i[h+132>>2])}u:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break u;X[i[i[o>>2]+8>>2]](o),p(o)}u:{o:{if((r|0)<=1785750886){if((r|0)<=1752589104){if(o=35,(r|0)==1635135537|(r|0)==1635148593)break u;if((r|0)!=1735551332)break o;break u}if((r|0)<=1768912491){if(o=35,(r|0)==1752589105)break u;if((r|0)!=1768187246)break o;break u}if(o=35,(r|0)==1768912492)break u;if((r|0)!=1781689137)break o;break u}l:{if((r|0)<=1919377773){if(o=35,(r|0)==1785750887)break u;if((r|0)==1835625829)break l;if((r|0)!=1836280681)break o;break u}if((r|0)<=1970168680){if(o=35,(r|0)==1919377774)break u;if((r|0)!=1953066089)break o;break u}if(o=35,(r|0)==1970168681)break u;if((r|0)!=1987470129)break o;break u}if(o=u[t+387|0],k=(o|0)<0,((k?i[t+380>>2]:o)|0)!=10)break o;if(o=35,!N2(k?i[t+376>>2]:t+376|0,11266,10))break u}m=t+304|0,o=0;o:{l:{k=i[e+48>>2],B=i[k+128>>2];s:{if(!B)break s;for(h=k+128|0,k=h;o=w>>>0>u0[B+16>>2],k=o?k:B,B=i[(o?4:0)+B>>2],!!B;);if(o=0,(k|0)==(h|0)|w>>>0<u0[k+16>>2])break s;if(h=i[k+20>>2],o=i[k+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),h)break l}u[m|0]=0,u[m+11|0]=0;break o}if(u[h+163|0]>=0){k=i[h+156>>2],i[m>>2]=i[h+152>>2],i[m+4>>2]=k,i[m+8>>2]=i[h+160>>2];break o}T(m,i[h+152>>2],i[h+156>>2])}o:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break o;X[i[i[o>>2]+8>>2]](o),p(o)}k=E(64),i[k+16>>2]=0,i[k+20>>2]=0,i[k>>2]=94772,i[k+4>>2]=0,i[k+8>>2]=0,i[k+12>>2]=w,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,P1(t+152|0,r),u[k+27|0]<0&&Z(i[k+16>>2]),o=i[t+156>>2],i[k+16>>2]=i[t+152>>2],i[k+20>>2]=o,i[k+24>>2]=i[t+160>>2],o=k+28|0,h=u[t+387|0];o:{if(u[k+39|0]>=0){if((h|0)>=0){h=i[t+380>>2],i[o>>2]=i[t+376>>2],i[o+4>>2]=h,i[o+8>>2]=i[t+384>>2];break o}D1(o,i[t+376>>2],i[t+380>>2]);break o}B=o,o=(h|0)<0,O1(B,o?i[t+376>>2]:t+376|0,o?i[t+380>>2]:h)}u[k+51|0]<0&&Z(i[k+40>>2]),o=i[t+308>>2],i[k+40>>2]=i[t+304>>2],i[k+44>>2]=o,i[k+48>>2]=i[t+312>>2],u[t+315|0]=0,u[t+304|0]=0,a6(t+152|0,i[e+48>>2],w),B=l[t+172|0];o:{l:{if(B){if((r|0)!=1835625829&&(o=35,(r|0)!=1165519206))break o;if((B|0)!=1)break A;if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[s>>2]=i[t+160>>2],i[s+4>>2]=r,i[s+8>>2]=i[t+168>>2],o=1;break l}T(s,i[t+160>>2],i[t+164>>2]),o=1;break l}if(r=i[t+152>>2],o=i[t+156>>2],d4(k+52|0,r,o,o-r|0),R){L8(t+328|0,R,w,1667527523),w=i[t+328>>2],I=i[t+332>>2];s:{if((w|0)!=(I|0)){y=k+12|0;w:{for(;;){h=i[w>>2];_:{h:{o=C,r=i[o>>2];B:{if(!r)break B;for(;m=h>>>0>u0[r+16>>2],o=m?o:r,r=i[(m?4:0)+r>>2],!!r;);if((o|0)==(C|0))break B;if(h>>>0>=u0[o+16>>2])break h}if(ar(i[e+48>>2],h))break _;r=E(40),i[t+68>>2]=r,i[t+72>>2]=39,i[t+76>>2]=-2147483608,o=l[14615]|l[14616]<<8|(l[14617]<<16|l[14618]<<24),w=l[14611]|l[14612]<<8|(l[14613]<<16|l[14614]<<24),u[r|0]=w,u[r+1|0]=w>>>8,u[r+2|0]=w>>>16,u[r+3|0]=w>>>24,u[r+4|0]=o,u[r+5|0]=o>>>8,u[r+6|0]=o>>>16,u[r+7|0]=o>>>24,u[r+39|0]=0,o=l[14646]|l[14647]<<8|(l[14648]<<16|l[14649]<<24),w=l[14642]|l[14643]<<8|(l[14644]<<16|l[14645]<<24),u[r+31|0]=w,u[r+32|0]=w>>>8,u[r+33|0]=w>>>16,u[r+34|0]=w>>>24,u[r+35|0]=o,u[r+36|0]=o>>>8,u[r+37|0]=o>>>16,u[r+38|0]=o>>>24,o=l[14639]|l[14640]<<8|(l[14641]<<16|l[14642]<<24),w=l[14635]|l[14636]<<8|(l[14637]<<16|l[14638]<<24),u[r+24|0]=w,u[r+25|0]=w>>>8,u[r+26|0]=w>>>16,u[r+27|0]=w>>>24,u[r+28|0]=o,u[r+29|0]=o>>>8,u[r+30|0]=o>>>16,u[r+31|0]=o>>>24,o=l[14631]|l[14632]<<8|(l[14633]<<16|l[14634]<<24),w=l[14627]|l[14628]<<8|(l[14629]<<16|l[14630]<<24),u[r+16|0]=w,u[r+17|0]=w>>>8,u[r+18|0]=w>>>16,u[r+19|0]=w>>>24,u[r+20|0]=o,u[r+21|0]=o>>>8,u[r+22|0]=o>>>16,u[r+23|0]=o>>>24,o=l[14623]|l[14624]<<8|(l[14625]<<16|l[14626]<<24),w=l[14619]|l[14620]<<8|(l[14621]<<16|l[14622]<<24),u[r+8|0]=w,u[r+9|0]=w>>>8,u[r+10|0]=w>>>16,u[r+11|0]=w>>>24,u[r+12|0]=o,u[r+13|0]=o>>>8,u[r+14|0]=o>>>16,u[r+15|0]=o>>>24,K(A,2,2e3,t+68|0),u[t+79|0]<0&&Z(i[t+68>>2]),r=0;break w}h=i[o+20>>2],i[t+64>>2]=k,i[t+60>>2]=y,i[k+4>>2]=i[k+4>>2]+1,r=i[t+64>>2],i[t>>2]=i[t+60>>2],i[t+4>>2]=r;h:{if(r=i[h+264>>2],B=i[h+268>>2],r>>>0<B>>>0){i[r>>2]=i[t>>2],i[r+4>>2]=i[t+4>>2],i[h+264>>2]=r+8;break h}B:{if(m=i[h+260>>2],r=r-m|0,g=r>>3,o=g+1|0,o>>>0<536870912){if(B=B-m|0,_=B>>2,B=B>>>0>=2147483640?536870911:o>>>0<_>>>0?_:o,B){if(B>>>0>=536870912)break B;o=E(B<<3)}else o=0;_=o+r|0,i[_>>2]=i[t>>2],i[_+4>>2]=i[t+4>>2],g=_-(g<<3)|0,r&&z(g,m,r),i[h+268>>2]=o+(B<<3),r=_+8|0,i[h+264>>2]=r,i[h+260>>2]=g,m&&Z(m),i[h+264>>2]=r;break h}G0(),H()}x0(),H()}}if(w=w+4|0,(I|0)==(w|0))break}r=1}w=i[t+328>>2];break s}r=1}if(w&&(i[t+332>>2]=w,Z(w)),o=1,!r)break l}o=0}B=l[t+172|0]}if(r=B&255,(r|0)!=255&&(i[t+328>>2]=n,i[t+332>>2]=W,X[i[(t+328|0)+(r<<2)>>2]](t+68|0,t+152|0)),r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),u[t+315|0]>=0)break u;Z(i[t+304>>2])}if(u[t+387|0]<0&&Z(i[t+376>>2]),o&&(o|0)!=35)break n;if(f=f+4|0,(V|0)==(f|0))break}if(m=i[t+364>>2],g=i[t+368>>2],!(!R|(m|0)==(g|0))){for(;;){w=i[m>>2],L8(t+152|0,R,w,1886545261),n=i[t+152>>2],h=i[t+156>>2];u:{if((n|0)==(h|0)){r=1;break u}f=n;o:{if(k=i[C>>2],!k)break o;for(;;){for(o=C,r=k;B=w>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(C|0)|w>>>0<u0[o+16>>2])break o;if(r=1,u[i[o+20>>2]+145|0]=1,f=f+4|0,(h|0)==(f|0))break}break u}r=E(48),i[t+376>>2]=r,i[t+380>>2]=42,i[t+384>>2]=-2147483600,f=l[14572]|l[14573]<<8|(l[14574]<<16|l[14575]<<24),o=l[14568]|l[14569]<<8|(l[14570]<<16|l[14571]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+42|0]=0,f=l[14608]|l[14609]<<8,u[r+40|0]=f,u[r+41|0]=f>>>8,f=l[14604]|l[14605]<<8|(l[14606]<<16|l[14607]<<24),o=l[14600]|l[14601]<<8|(l[14602]<<16|l[14603]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14596]|l[14597]<<8|(l[14598]<<16|l[14599]<<24),o=l[14592]|l[14593]<<8|(l[14594]<<16|l[14595]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14588]|l[14589]<<8|(l[14590]<<16|l[14591]<<24),o=l[14584]|l[14585]<<8|(l[14586]<<16|l[14587]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14580]|l[14581]<<8|(l[14582]<<16|l[14583]<<24),o=l[14576]|l[14577]<<8|(l[14578]<<16|l[14579]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0,n=i[t+152>>2]}if(n&&(i[t+156>>2]=n,Z(n)),!r)break n;if(m=m+4|0,(g|0)==(m|0))break}g=i[t+368>>2],m=i[t+364>>2]}if((m|0)!=(g|0)){for(y=e+156|0,N=e- -64|0,V=A+8|0,s=i[23602],S=i[23603];;){u:{W=i[m>>2];o:{if((J6(i[e+48>>2],W)|0)!=1919377774)break o;r=E(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94512,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[t+72>>2]=r,i[t+68>>2]=r+12,i[r+12>>2]=W,a6(t+152|0,i[e+48>>2],W);l:{s:switch(l[t+172|0]){case 1:if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[V>>2]=i[t+160>>2],i[V+4>>2]=r,i[V+8>>2]=i[t+168>>2],B=1;break l}T(V,i[t+160>>2],i[t+164>>2]),B=1;break l;case 0:break s;default:break A}o=t+40|0,k=i[t+68>>2],f=v-16|0,v=f,w=t+152|0,r=i[w>>2],n=i[w+4>>2]-r|0;s:{if(n>>>0<=7){if(r=E(32),i[f+4>>2]=r,i[f+8>>2]=25,i[f+12>>2]=-2147483616,n=l[18866]|l[18867]<<8|(l[18868]<<16|l[18869]<<24),k=l[18862]|l[18863]<<8|(l[18864]<<16|l[18865]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+25|0]=0,u[r+24|0]=l[18886],n=l[18882]|l[18883]<<8|(l[18884]<<16|l[18885]<<24),k=l[18878]|l[18879]<<8|(l[18880]<<16|l[18881]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[18874]|l[18875]<<8|(l[18876]<<16|l[18877]<<24),k=l[18870]|l[18871]<<8|(l[18872]<<16|l[18873]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}_=u[r+1|0]&1;w:{if(_){if(n>>>0<=11){if(r=E(24),i[f+4>>2]=r,i[f+8>>2]=22,i[f+12>>2]=-2147483624,n=l[12108]|l[12109]<<8|(l[12110]<<16|l[12111]<<24),k=l[12104]|l[12105]<<8|(l[12106]<<16|l[12107]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+22|0]=0,n=l[12122]|l[12123]<<8|(l[12124]<<16|l[12125]<<24),k=l[12118]|l[12119]<<8|(l[12120]<<16|l[12121]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=n,u[r+19|0]=n>>>8,u[r+20|0]=n>>>16,u[r+21|0]=n>>>24,n=l[12116]|l[12117]<<8|(l[12118]<<16|l[12119]<<24),k=l[12112]|l[12113]<<8|(l[12114]<<16|l[12115]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}n=l[r+2|0]|l[r+3|0]<<8|(l[r+4|0]<<16|l[r+5|0]<<24),i[k+4>>2]=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24),h=l[r+7|0]<<16|l[r+6|0]<<24|l[r+8|0]<<8,B=10,n=r+9|0;break w}i[k+4>>2]=l[r+3|0]|l[r+2|0]<<8,h=l[r+4|0]<<8,B=6,n=r+5|0}if(i[k+8>>2]=l[n|0]|h,n=l[r+B|0],i[f>>2]=B|1,n)for(h=_?32:16,k=k+12|0,B=0;;){if(r=i[f>>2],_=i[w>>2],r>>>0>=i[w+4>>2]-_>>>0){if(r=E(24),i[f+4>>2]=r,i[f+8>>2]=22,i[f+12>>2]=-2147483624,n=l[12108]|l[12109]<<8|(l[12110]<<16|l[12111]<<24),k=l[12104]|l[12105]<<8|(l[12106]<<16|l[12107]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+22|0]=0,n=l[12122]|l[12123]<<8|(l[12124]<<16|l[12125]<<24),k=l[12118]|l[12119]<<8|(l[12120]<<16|l[12121]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=n,u[r+19|0]=n>>>8,u[r+20|0]=n>>>16,u[r+21|0]=n>>>24,n=l[12116]|l[12117]<<8|(l[12118]<<16|l[12119]<<24),k=l[12112]|l[12113]<<8|(l[12114]<<16|l[12115]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,K(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}_=l[r+_|0],i[f>>2]=r+1;w:{_:{h:switch(_|0){case 0:r=E(24),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96028,i[r+12>>2]=95764,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 1:r=E(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96068,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95808,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 2:r=E(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96108,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95852,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 3:if(r=E(40),i[r+16>>2]=1,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=96148,i[r+12>>2]=95940,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break _;X[i[i[r>>2]+8>>2]](r),p(r);break _;case 4:r=E(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96188,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+12>>2]=95896,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 5:r=E(52),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r>>2]=96228,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95984,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 6:break h;default:break w}if(r=E(40),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=96148,i[r+12>>2]=95940,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break _;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[f+4>>2],X[i[i[r>>2]+12>>2]](o,r,w,h,f,N),_=i[o>>2];_:{if(_||(r2(k,f+4|0),u[o+19|0]>=0))break _;Z(i[o+8>>2])}r=i[f+8>>2];_:{if(!r||(I=i[r+4>>2],i[r+4>>2]=I-1,I))break _;X[i[i[r>>2]+8>>2]](r),p(r)}if(_)break s}if(B=B+1|0,(n|0)==(B|0))break}if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,r=o+8|0,u[107731]>=0){o=i[26931],i[r>>2]=i[26930],i[r+4>>2]=o,i[r+8>>2]=i[26932];break s}T(r,i[26930],i[26931])}if(v=f+16|0,u[t+59|0]<0&&Z(i[t+48>>2]),R){i3(t+304|0,R,W),h=i[t+304>>2],a=i[t+308>>2];s:{if((h|0)==(a|0)){B=44;break s}w:{for(;;){if(r=i[h+16>>2],(r|0)==1667527523){if(i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=i[h+48>>2],f=i[h+44>>2],(r|0)!=(f|0)){if(r=r-f|0,(r|0)<0)break i;for(n=E(r),r&&z(n,f,r),w=r+n|0,f=n;;){_:{r=i[C>>2];h:{if(!r)break h;for(k=i[f>>2],o=C;B=k>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(C|0))break h;if(k>>>0>=u0[o+16>>2])break _}r=E(48),i[t+328>>2]=r,i[t+332>>2]=42,i[t+336>>2]=-2147483600,f=l[14529]|l[14530]<<8|(l[14531]<<16|l[14532]<<24),o=l[14525]|l[14526]<<8|(l[14527]<<16|l[14528]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+42|0]=0,f=l[14565]|l[14566]<<8,u[r+40|0]=f,u[r+41|0]=f>>>8,f=l[14561]|l[14562]<<8|(l[14563]<<16|l[14564]<<24),o=l[14557]|l[14558]<<8|(l[14559]<<16|l[14560]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14553]|l[14554]<<8|(l[14555]<<16|l[14556]<<24),o=l[14549]|l[14550]<<8|(l[14551]<<16|l[14552]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14545]|l[14546]<<8|(l[14547]<<16|l[14548]<<24),o=l[14541]|l[14542]<<8|(l[14543]<<16|l[14544]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14537]|l[14538]<<8|(l[14539]<<16|l[14540]<<24),o=l[14533]|l[14534]<<8|(l[14535]<<16|l[14536]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+328|0),u[t+339|0]<0&&Z(i[t+328>>2]),Z(n),B=1;break w}if(ku(i[o+20>>2],W),r2(y,t+68|0),f=f+4|0,(w|0)==(f|0))break}Z(n)}r=i[h+16>>2]}if((r|0)==1835103083){if(n=0,i[t+336>>2]=0,i[t+328>>2]=0,i[t+332>>2]=0,r=0,f=i[h+48>>2],o=i[h+44>>2],(f|0)!=(o|0)){if(f=f-o|0,(f|0)<0)break i;r=E(f),i[t+328>>2]=r,k=r+f|0,i[t+336>>2]=k,f&&z(r,o,f),i[t+332>>2]=k}I=0,o=i[t+68>>2],f=i[o+16>>2],o=i[o+12>>2],k=f-o|0;_:{if((k|0)<=0){B=48;break _}h:{for(;;){if(i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=0,B=0,(f|0)!=(o|0)){if((k|0)<0)break i;for(B=E(k),i[t+376>>2]=B,i[t+384>>2]=k+B,r=B;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[t+380>>2]=r}if(O=n<<3,f=i[O+B>>2],k=X[i[i[f>>2]+8>>2]](f)|0,o=B,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];B:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break B;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r-8|0,(B|0)==(r|0))break}o=i[t+376>>2]}i[t+380>>2]=B,Z(o);B:{if((k|0)!=4)break B;if(w=0,i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=0,B=0,o=i[t+68>>2],f=i[o+16>>2],o=i[o+12>>2],(f|0)!=(o|0)){if(r=f-o|0,(r|0)<0)break i;for(B=E(r),i[t+376>>2]=B,i[t+384>>2]=r+B,r=B;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[t+380>>2]=r}_=0,f=B+O|0,o=i[f>>2];v:{if(!o)break v;if(_=X0(o,94804,95920),!_){_=0;break v}if(w=i[f+4>>2],!w){w=0;break v}i[w+4>>2]=i[w+4>>2]+1}if(o=B,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];v:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break v;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r-8|0,(B|0)==(r|0))break}o=i[t+376>>2]}i[t+380>>2]=B,Z(o),r=i[t+328>>2];v:{if(i[t+332>>2]-r>>2>>>0<=I>>>0){r=E(64),i[t+376>>2]=r,i[t+380>>2]=60,i[t+384>>2]=-2147483584,f=l[15361]|l[15362]<<8|(l[15363]<<16|l[15364]<<24),o=l[15357]|l[15358]<<8|(l[15359]<<16|l[15360]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+60|0]=0,f=l[15413]|l[15414]<<8|(l[15415]<<16|l[15416]<<24),u[r+56|0]=f,u[r+57|0]=f>>>8,u[r+58|0]=f>>>16,u[r+59|0]=f>>>24,f=l[15409]|l[15410]<<8|(l[15411]<<16|l[15412]<<24),o=l[15405]|l[15406]<<8|(l[15407]<<16|l[15408]<<24),u[r+48|0]=o,u[r+49|0]=o>>>8,u[r+50|0]=o>>>16,u[r+51|0]=o>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[15401]|l[15402]<<8|(l[15403]<<16|l[15404]<<24),o=l[15397]|l[15398]<<8|(l[15399]<<16|l[15400]<<24),u[r+40|0]=o,u[r+41|0]=o>>>8,u[r+42|0]=o>>>16,u[r+43|0]=o>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[15393]|l[15394]<<8|(l[15395]<<16|l[15396]<<24),o=l[15389]|l[15390]<<8|(l[15391]<<16|l[15392]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[15385]|l[15386]<<8|(l[15387]<<16|l[15388]<<24),o=l[15381]|l[15382]<<8|(l[15383]<<16|l[15384]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[15377]|l[15378]<<8|(l[15379]<<16|l[15380]<<24),o=l[15373]|l[15374]<<8|(l[15375]<<16|l[15376]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[15369]|l[15370]<<8|(l[15371]<<16|l[15372]<<24),o=l[15365]|l[15366]<<8|(l[15367]<<16|l[15368]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,0,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0;break v}Z:{f=i[C>>2];G:{if(!f)break G;for(k=i[r+(I<<2)>>2],o=C,r=f;B=k>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(C|0))break G;if(k>>>0>=u0[o+16>>2])break Z}r=E(48),i[t+376>>2]=r,i[t+380>>2]=43,i[t+384>>2]=-2147483600,f=l[14336]|l[14337]<<8|(l[14338]<<16|l[14339]<<24),o=l[14332]|l[14333]<<8|(l[14334]<<16|l[14335]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+43|0]=0,f=l[14371]|l[14372]<<8|(l[14373]<<16|l[14374]<<24),u[r+39|0]=f,u[r+40|0]=f>>>8,u[r+41|0]=f>>>16,u[r+42|0]=f>>>24,f=l[14368]|l[14369]<<8|(l[14370]<<16|l[14371]<<24),o=l[14364]|l[14365]<<8|(l[14366]<<16|l[14367]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14360]|l[14361]<<8|(l[14362]<<16|l[14363]<<24),o=l[14356]|l[14357]<<8|(l[14358]<<16|l[14359]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14352]|l[14353]<<8|(l[14354]<<16|l[14355]<<24),o=l[14348]|l[14349]<<8|(l[14350]<<16|l[14351]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14344]|l[14345]<<8|(l[14346]<<16|l[14347]<<24),o=l[14340]|l[14341]<<8|(l[14342]<<16|l[14343]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,0,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0;break v}for(r=C;o=k>>>0>u0[f+16>>2],r=o?r:f,f=i[(o?4:0)+f>>2],!!f;);Z:{if(!((r|0)!=(C|0)&k>>>0>=u0[r+16>>2])){i[t+376>>2]=0,i[t+380>>2]=0,r=0,o=0;break Z}if(f=i[r+20>>2],X[i[i[f>>2]+52>>2]](t+376|0,f),u[t+395|0]<0&&Z(i[t+384>>2]),o=i[r+20>>2],i[t+376>>2]=o,r=i[r+24>>2],i[t+380>>2]=r,!r){r=0;break Z}i[r+4>>2]=i[r+4>>2]+1}X[i[i[o>>2]+52>>2]](A,o),f=i[A>>2],f||(u[A+19|0]<0&&Z(i[A+8>>2]),i[_+20>>2]=k,i[_+12>>2]||(d0=_,n2=yA(o),i[d0+12>>2]=n2),i[_+16>>2]||(d0=_,n2=YA(o),i[d0+16>>2]=n2),zr(e,t+376|0),I=I+1|0);Z:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break Z;X[i[i[r>>2]+8>>2]](r),p(r)}r=!f}v:{if(!w||(f=i[w+4>>2],i[w+4>>2]=f-1,f))break v;X[i[i[w>>2]+8>>2]](w),p(w)}if(r)break B;B=1,n=1;break h}if(n=n+1|0,r=i[t+68>>2],f=i[r+16>>2],o=i[r+12>>2],k=f-o|0,!((n|0)<k>>3))break}B=48,n=0}r=i[t+328>>2]}if(r&&(i[t+332>>2]=r,Z(r)),n)break w}if(h=h+56|0,(a|0)==(h|0))break}B=44}h=i[t+304>>2]}if(h){if(r=i[t+308>>2],o=h,(r|0)!=(o|0)){for(;f=i[r-12>>2],f&&(i[r-8>>2]=f,Z(f)),f=r-56|0,i[f>>2]=86404,o=i[r-36>>2],o&&(i[r-32>>2]=o,Z(o)),r=f,(h|0)!=(r|0););o=i[t+304>>2]}i[t+308>>2]=h,Z(o)}if((B|0)!=44)break l}B=0}r=l[t+172|0],(r|0)!=255&&(i[t+376>>2]=s,i[t+380>>2]=S,X[i[(t+376|0)+(r<<2)>>2]](t+304|0,t+152|0)),r=i[t+72>>2];l:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break l;X[i[i[r>>2]+8>>2]](r),p(r)}l:switch(B-42|0){case 1:break o;case 0:break u;default:break l}if(B)break n}if(m=m+4|0,(g|0)!=(m|0))continue}break}g=i[t+368>>2],m=i[t+364>>2]}if((m|0)==(g|0))break t;for(W=e+168|0,s=A+8|0,w=i[23602],I=i[23603];;){_=i[m>>2];u:{if((J6(i[e+48>>2],_)|0)!=1835625829)break u;r=E(28),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94820,i[r+24>>2]=0,i[t+72>>2]=r,i[t+68>>2]=r+12,i[r+12>>2]=_,a6(t+152|0,i[e+48>>2],_);o:{l:switch(l[t+172|0]){case 1:if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[s>>2]=i[t+160>>2],i[s+4>>2]=r,i[s+8>>2]=i[t+168>>2],B=1;break o}T(s,i[t+160>>2],i[t+164>>2]),B=1;break o;case 0:break l;default:break A}o=t+20|0,r=i[t+156>>2],V=r;l:{s:{f=i[t+152>>2],B=r-f|0,n=i[t+68>>2]+4|0,k=i[n+8>>2],y=u[n+11|0],r=(y|0)>=0?10:(k&2147483647)-1|0;w:{if(B>>>0<=r>>>0){k=(k|0)<0?i[n>>2]:n;break w}if(B-r>>>0>2147483639-r>>>0)break s;N=i[n>>2];_:{h:{if(r>>>0>=1073741811){h=2147483639,k=E(2147483639);break h}if(k=r<<1,k=k>>>0<B>>>0?B:k,h=k>>>0<11?11:(k|7)+1|0,k=E(h),(r|0)==10)break _}Z((y|0)<0?N:n)}i[n>>2]=k,i[n+4>>2]=0,i[n+8>>2]=h|-2147483648}w:{if((f|0)==(V|0))break w;y=V-f&7;_:{if(!y){r=f;break _}for(h=0,r=f;u[k|0]=l[r|0],r=r+1|0,k=k+1|0,h=h+1|0,(y|0)!=(h|0););}if(f-V>>>0>4294967288)break w;for(;u[k|0]=l[r|0],u[k+1|0]=l[r+1|0],u[k+2|0]=l[r+2|0],u[k+3|0]=l[r+3|0],u[k+4|0]=l[r+4|0],u[k+5|0]=l[r+5|0],u[k+6|0]=l[r+6|0],u[k+7|0]=l[r+7|0],k=k+8|0,r=r+8|0,(V|0)!=(r|0););}if(u[k|0]=0,u[n+11|0]<0){i[n+4>>2]=B;break l}u[n+11|0]=B&127;break l}g0(),H()}f=i[26929],r=o,i[r>>2]=i[26928],i[r+4>>2]=f,r=r+8|0;l:{if(u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break l}T(r,i[26930],i[26931])}if(u[t+39|0]<0&&Z(i[t+28>>2]),R){i3(t+376|0,R,_),f=i[t+376>>2],B=i[t+380>>2];l:{if((f|0)==(B|0)){B=53;break l}s:{for(;;){w:{if(i[f+16>>2]!=1952807028||(i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,r=i[f+48>>2],o=i[f+44>>2],(r|0)==(o|0)))break w;if(r=r-o|0,(r|0)<0)break i;for(k=E(r),r&&z(k,o,r),V=r+k|0,n=k;;){_:{r=i[C>>2];h:{if(!r)break h;for(h=i[n>>2],o=C;y=h>>>0>u0[r+16>>2],o=y?o:r,r=i[(y?4:0)+r>>2],!!r;);if((o|0)==(C|0))break h;if(h>>>0>=u0[o+16>>2])break _}r=E(48),i[t+328>>2]=r,i[t+332>>2]=40,i[t+336>>2]=-2147483600,f=l[14488]|l[14489]<<8|(l[14490]<<16|l[14491]<<24),o=l[14484]|l[14485]<<8|(l[14486]<<16|l[14487]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,f=l[14520]|l[14521]<<8|(l[14522]<<16|l[14523]<<24),o=l[14516]|l[14517]<<8|(l[14518]<<16|l[14519]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14512]|l[14513]<<8|(l[14514]<<16|l[14515]<<24),o=l[14508]|l[14509]<<8|(l[14510]<<16|l[14511]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14504]|l[14505]<<8|(l[14506]<<16|l[14507]<<24),o=l[14500]|l[14501]<<8|(l[14502]<<16|l[14503]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14496]|l[14497]<<8|(l[14498]<<16|l[14499]<<24),o=l[14492]|l[14493]<<8|(l[14494]<<16|l[14495]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,2,2e3,t+328|0),u[t+339|0]<0&&Z(i[t+328>>2]),Z(k),B=1;break s}if(nu(i[o+20>>2],_),r2(W,t+68|0),n=n+4|0,(V|0)==(n|0))break}Z(k)}if(f=f+56|0,(B|0)==(f|0))break}B=53}f=i[t+376>>2]}if(f){if(r=i[t+380>>2],o=f,(r|0)!=(f|0)){for(;o=i[r-12>>2],o&&(i[r-8>>2]=o,Z(o)),o=r-56|0,i[o>>2]=86404,n=i[r-36>>2],n&&(i[r-32>>2]=n,Z(n)),r=o,(f|0)!=(r|0););o=i[t+376>>2]}i[t+380>>2]=f,Z(o)}if((B|0)!=53)break o}B=0}r=l[t+172|0],(r|0)!=255&&(i[t+376>>2]=w,i[t+380>>2]=I,X[i[(t+376|0)+(r<<2)>>2]](t+304|0,t+152|0)),r=i[t+72>>2];o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;X[i[i[r>>2]+8>>2]](r),p(r)}o:switch(B-51|0){case 0:break t;case 1:break u;default:break o}if(B)break n}if(m=m+4|0,(g|0)==(m|0))break}}k8(A,107712)}if(!x||(r=i[x+4>>2],i[x+4>>2]=r-1,r))break k;X[i[i[x>>2]+8>>2]](x),p(x)}r=i[t+364>>2],r&&(i[t+368>>2]=r,Z(r)),v=t+416|0;break f}_2(),H()}if(i[A>>2])break e;if(u[A+19|0]>=0)break r;Z(i[A+8>>2])}r:{if(!i[i[e+48>>2]+140>>2])break r;g=0,_=v+-64|0,v=_,C=e,k3(e+180|0,i[e+184>>2]),h=e+184|0,i[e+180>>2]=h,i[e+184>>2]=0,i[e+188>>2]=0,e=i[e+48>>2],f=i[e+140>>2],V=i[e+144>>2],V&&(i[V+4>>2]=i[V+4>>2]+1);f:{A:{k:{n:{r=i[f+36>>2],o=i[f+40>>2];t:{if((r|0)!=(o|0)){e=r;u:{for(;;){o:{l:{if(n=i[e>>2],!n||!X0(n,86628,104488))break l;if(g=i[e+4>>2],!g)break o;i[g+4>>2]=i[g+4>>2]+1,o=i[f+40>>2],r=i[f+36>>2];break u}if(e=e+8|0,(o|0)!=(e|0))continue}break}g=0}if(i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0,(r|0)==(o|0))break t;for(;;){e=i[r>>2];u:{if(!e||(e=X0(e,86628,92872),!e)||(i[_+24>>2]=e,e=i[r+4>>2],i[_+28>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(_+48|0,_+24|0),e=i[_+28>>2],!e)||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break u;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r+8|0,(o|0)==(r|0))break}if(e=i[_+48>>2],t=i[_+52>>2],(e|0)==(t|0))break t;for(f=_+36|0,n=_+43|0,w=_+32|0,I=A+8|0,B=i[23614],x=i[23615],y=_+8|0;;){o=_+24|0,k=v-192|0,v=k,m=e;u:{o:{l:{s:{if(r=i[e>>2],e=i[r+36>>2],s=i[r+40>>2],(e|0)!=(s|0))for(;;){w:{if(r=i[e>>2],!r||(r=X0(r,86628,93032),!r))break w;s=i[e+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);_:{h:{B:{if(e=i[r+36>>2],W=i[r+40>>2],(e|0)!=(W|0))for(;;){v:{if(r=i[e>>2],!r||(r=X0(r,86628,87232),!r))break v;if(W=i[e+4>>2],W&&(i[W+4>>2]=i[W+4>>2]+1),e=i[r+108>>2],(e|0)>1885954931)break B;if((e|0)==1635088502)break h;if((e|0)!=1835365473)break _;e=E(320),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94940,r=Ru(e+16|0,C),i[r+288>>2]=0,i[r+292>>2]=0,i[r>>2]=106816,i[r+296>>2]=0;break s}if(e=e+8|0,(W|0)==(e|0))break}e=E(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=l[22947]|l[22948]<<8|(l[22949]<<16|l[22950]<<24),W=l[22943]|l[22944]<<8|(l[22945]<<16|l[22946]<<24),u[e+16|0]=W,u[e+17|0]=W>>>8,u[e+18|0]=W>>>16,u[e+19|0]=W>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22939]|l[22940]<<8|(l[22941]<<16|l[22942]<<24),W=l[22935]|l[22936]<<8|(l[22937]<<16|l[22938]<<24),u[e+8|0]=W,u[e+9|0]=W>>>8,u[e+10|0]=W>>>16,u[e+11|0]=W>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[22931]|l[22932]<<8|(l[22933]<<16|l[22934]<<24),W=l[22927]|l[22928]<<8|(l[22929]<<16|l[22930]<<24),u[e|0]=W,u[e+1|0]=W>>>8,u[e+2|0]=W>>>16,u[e+3|0]=W>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,e=K(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;v:{if(u[e+19|0]>=0){W=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=W,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break v}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break v;Z(i[e+8>>2])}if(u[k+27|0]>=0)break o;Z(i[k+16>>2]);break o}if((e|0)==1986618469)break h;if((e|0)!=1885954932)break _}e=E(352),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94900,r=Ru(e+16|0,C),i[r+308>>2]=0,i[r+312>>2]=0,u[r+300|0]=0,i[r+296>>2]=0,i[r+288>>2]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r>>2]=106720,i[r+304>>2]=r+308,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0;break s}i[k+132>>2]=0,i[k+104>>2]=72244,i[k+48>>2]=72224,e=i[18065],i[k+40>>2]=e,f0=i[e-12>>2],e=k+40|0,i[f0+e>>2]=i[18066],i[k+44>>2]=0,R=e+i[i[k+40>>2]-12>>2]|0,N=k+52|0,J0(R,N),u[R+80|0]=0,i[R+72>>2]=0,R=i[18067],i[k+48>>2]=R,S=k+48|0,i[S+i[R-12>>2]>>2]=i[18068],R=i[18064],i[k+40>>2]=R,i[e+i[R-12>>2]>>2]=i[18069],i[k+104>>2]=72244,i[k+40>>2]=72204,i[k+48>>2]=72224,R=R0(N),i[R>>2]=71280,i[k+92>>2]=0,i[k+96>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,i[k+100>>2]=24,e=Y(S,27383,37),N=k+16|0,P1(N,i[r+108>>2]),f0=e,e=u[k+27|0],r=(e|0)<0,Y(Y(f0,r?i[k+16>>2]:N,r?i[k+20>>2]:e),26337,2),u[k+27|0]<0&&Z(i[k+16>>2]),e=i[k+100>>2];_:{h:{if(e&16){e=i[k+96>>2],r=i[k+76>>2],e>>>0<r>>>0&&(i[k+96>>2]=r,e=r),r=k+72|0;break h}if(!(e&8)){e=0,u[k+15|0]=0,r=k+4|0;break _}e=i[k+68>>2],r=k+60|0}h:{if(N=i[r>>2],e=e-N|0,e>>>0<2147483640){if(e>>>0>=11){S=e|7,r=E(S+1|0),i[k+12>>2]=S-2147483647,i[k+4>>2]=r,i[k+8>>2]=e;break h}if(u[k+15|0]=e,r=k+4|0,e)break h;e=0;break _}g0(),H()}if(!e)break _;z(r,N,e)}u[e+r|0]=0,e=K(k+16|0,4,3008,k+4|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;_:{if(u[e+19|0]>=0){N=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=N,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break _}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break _;Z(i[e+8>>2])}u[k+15|0]<0&&Z(i[k+4>>2]),e=i[18063],i[k+40>>2]=e,i[i[e-12>>2]+(k+40|0)>>2]=i[18071],i[k+48>>2]=i[18072],i[R>>2]=71280,u[k+95|0]<0&&Z(i[k+84>>2]),y0(R),p0(k+104|0);break l}if(e=e+8|0,(s|0)==(e|0))break}e=E(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=l[23301]|l[23302]<<8|(l[23303]<<16|l[23304]<<24),s=l[23297]|l[23298]<<8|(l[23299]<<16|l[23300]<<24),u[e+16|0]=s,u[e+17|0]=s>>>8,u[e+18|0]=s>>>16,u[e+19|0]=s>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23293]|l[23294]<<8|(l[23295]<<16|l[23296]<<24),s=l[23289]|l[23290]<<8|(l[23291]<<16|l[23292]<<24),u[e+8|0]=s,u[e+9|0]=s>>>8,u[e+10|0]=s>>>16,u[e+11|0]=s>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[23285]|l[23286]<<8|(l[23287]<<16|l[23288]<<24),s=l[23281]|l[23282]<<8|(l[23283]<<16|l[23284]<<24),u[e|0]=s,u[e+1|0]=s>>>8,u[e+2|0]=s>>>16,u[e+3|0]=s>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,e=K(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;w:{if(u[e+19|0]>=0){s=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=s,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break w}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break w;Z(i[e+8>>2])}if(u[k+27|0]>=0)break u;Z(i[k+16>>2]);break u}X[i[i[r>>2]+8>>2]](k+40|0,r,m);s:{if(i[k+40>>2]){if(r=i[k+44>>2],i[o>>2]=i[k+40>>2],i[o+4>>2]=r,r=o+8|0,u[k+59|0]>=0){R=i[k+52>>2],i[r>>2]=i[k+48>>2],i[r+4>>2]=R,i[r+8>>2]=i[k+56>>2],r=1;break s}T(r,i[k+48>>2],i[k+52>>2]),r=1;break s}i[e+4>>2]=i[e+4>>2]+1,i[o+4>>2]=e,i[o>>2]=r,r=0}if(u[o+20|0]=r,u[k+59|0]<0&&Z(i[k+48>>2]),r=i[e+4>>2],i[e+4>>2]=r-1,r)break l;X[i[i[e>>2]+8>>2]](e),p(e)}if(!W||(e=i[W+4>>2],i[W+4>>2]=e-1,e))break o;X[i[i[W>>2]+8>>2]](W),p(W)}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break u;X[i[i[s>>2]+8>>2]](s),p(s)}v=k+192|0,r=107712,k=107724,o=107731,e=107720;u:switch(l[_+44|0]){case 1:r=_+24|0,e=w,o=n,k=f;break;case 0:break u;default:break n}W=i[r+4>>2],r=i[r>>2],i[_>>2]=r,i[_+4>>2]=W;u:{if(u[o|0]>=0){o=i[e+4>>2],i[y>>2]=i[e>>2],i[y+4>>2]=o,i[y+8>>2]=i[e+8>>2],e=r;break u}T(y,i[e>>2],i[k>>2]),e=i[_>>2]}u:{if(!e){r=1,e=0;break u}if(!((e|0)!=4|i[_+4>>2]!=3008)){r=1,e=1;break u}r=107712,k=107724,o=107731,e=107720;o:switch(l[_+44|0]){case 1:r=_+24|0,e=w,o=n,k=f;break;case 0:break o;default:break n}s=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=s;o:{if(u[o|0]>=0){r=i[e+4>>2],i[I>>2]=i[e>>2],i[I+4>>2]=r,i[I+8>>2]=i[e+8>>2];break o}T(I,i[e>>2],i[k>>2])}r=0,e=0}if(u[_+19|0]<0&&Z(i[_+8>>2]),r){u:{if(e)break u;if(l[_+44|0])break n;W=i[_+24>>2],s=i[_+28>>2];o:{if(!s){o=i[W+24>>2];break o}e=i[s+4>>2],i[s+4>>2]=e+1,o=i[W+24>>2],i[s+4>>2]=e+2}o:{l:{k=h,r=k,e=i[r>>2];s:{if(!e)break s;for(;;){if(r=e,e=i[r+16>>2],e>>>0>o>>>0){if(k=r,e=i[r>>2],e)continue;break s}if(e>>>0>=o>>>0)break l;if(e=i[r+4>>2],!e)break}k=r+4|0}e=E(28),i[e+24>>2]=s,i[e+20>>2]=W,i[e+16>>2]=o,i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[k>>2]=e,r=i[i[C+180>>2]>>2],r&&(i[C+180>>2]=r),m1(i[C+184>>2],e),i[C+188>>2]=i[C+188>>2]+1;break o}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break o;X[i[i[s>>2]+8>>2]](s),p(s)}if(e=i[W+28>>2],i[C+192>>2]|!((e|0)==1885954932|(e|0)==1986618469)||(i[C+192>>2]=i[W+24>>2]),!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break u;X[i[i[s>>2]+8>>2]](s),p(s)}if(e=l[_+44|0],(e|0)!=255&&(i[_>>2]=B,i[_+4>>2]=x,X[i[_+(e<<2)>>2]](_+63|0,_+24|0)),e=m+8|0,(t|0)!=(e|0))continue;break t}break}if(e=l[_+44|0],(e|0)==255)break f;r=i[23615],i[_>>2]=i[23614],i[_+4>>2]=r,X[i[_+(e<<2)>>2]](_+63|0,_+24|0);break f}i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0}if(i[_+32>>2]=0,i[_+24>>2]=0,i[_+28>>2]=0,r=i[C+180>>2],(h|0)==(r|0))break A;for(;;){r2(_+24|0,r+20|0),o=i[r+4>>2];t:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break t}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(h|0)==(r|0))break}break k}_2(),H()}r=i[C+180>>2]}A:{if((r|0)!=(h|0))for(;;){if(e=i[r+20>>2],X[i[i[e>>2]+12>>2]](A,e,C,_+24|0),i[A>>2])break A;u[A+19|0]<0&&Z(i[A+8>>2]),o=i[r+4>>2];k:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break k}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(h|0)==(r|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){r=i[26931],i[e>>2]=i[26930],i[e+4>>2]=r,i[e+8>>2]=i[26932];break A}T(e,i[26930],i[26931])}if(f=i[_+24>>2],!f)break f;if(r=i[_+28>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];A:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+24>>2]}i[_+28>>2]=f,Z(e)}if(f=i[_+48>>2],f){if(r=i[_+52>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];f:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break f;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+48>>2]}i[_+52>>2]=f,Z(e)}f:{if(!g||(e=i[g+4>>2],i[g+4>>2]=e-1,e))break f;X[i[i[g>>2]+8>>2]](g),p(g)}f:{if(!V||(e=i[V+4>>2],i[V+4>>2]=e-1,e))break f;X[i[i[V>>2]+8>>2]](V),p(V)}if(v=_- -64|0,i[A>>2])break e;if(u[A+19|0]>=0)break r;Z(i[A+8>>2])}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}return}G0(),H()}function F7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0;W0=v-16|0,v=W0;i:{e:{r:{f:{A:{if(i[A+580>>2])break A;n=l[A+549|0];k:{k=l[A+548|0];n:{if(!(k&1)&&(o=0,!(n&1)))break n;if(i[A+3208>>2]==i[A+3212>>2])break k;f=n,o=k}if(o&1|f&1)break A;if(r=13,!e)break f;i[e>>2]=1;break f}if(Tl(A+2140|0),!e)break f;i[e>>2]=i[A+2192>>2];break f}if(!lo(A+2140|0,0)){if(r=9,!e)break f;i[e>>2]=1;break f}n=i[A+580>>2];A:{k:{if(n){if(n?(k=i[A+564>>2],o=i[A+576>>2],f=i[i[k+(o>>>8&16777212)>>2]+((o&1023)<<2)>>2],i[A+580>>2]=n-1,n=o+1|0,i[A+576>>2]=n,n>>>0>=2048&&(Z(i[k>>2]),i[A+564>>2]=i[A+564>>2]+4,i[A+576>>2]=i[A+576>>2]-1024),i[A+584>>2]=i[A+584>>2]-i[f+24>>2]):f=0,O=f,!f)break r;L=v-32|0,v=L,w=i[f+20>>2],h=i[f+24>>2],f=L+8|0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=h,i[f>>2]=w,n=-64;n:{if(!h||(i[f>>2]=w+1,o=l[w|0],k=h-1|0,i[f+4>>2]=k,i[f+8>>2]=0,o=o<<24,i[f+12>>2]=o,!k)||(i[f>>2]=w+2,k=l[w+1|0],m=h-2|0,i[f+4>>2]=m,o=k<<16|o,k=o,i[f+8>>2]=_,i[f+12>>2]=k,!m)||(i[f>>2]=w+3,o=l[w+2|0],m=h-3|0,i[f+4>>2]=m,o=o<<8|k,k=o,i[f+8>>2]=t,i[f+12>>2]=k,!m)||(i[f>>2]=w+4,o=l[w+3|0],m=h-4|0,i[f+4>>2]=m,i[f+8>>2]=t,o=k|o,i[f+12>>2]=o,!m)||(i[f>>2]=w+5,k=l[w+4|0],g=h-5|0,i[f+4>>2]=g,m=k<<24|_,i[f+8>>2]=m,o=k>>>8|o,i[f+12>>2]=o,!g)||(i[f>>2]=w+6,k=l[w+5|0],g=h-6|0,i[f+4>>2]=g,_=k<<16|m,i[f+8>>2]=_,o=k>>>16|o,i[f+12>>2]=o,!g)||(i[f>>2]=w+7,k=l[w+6|0],m=h-7|0,i[f+4>>2]=m,t=o,o=_,_=k>>>24|0,o=o|k<<8,i[f+8>>2]=o,k=t|_,i[f+12>>2]=k,!m))break n;i[f>>2]=w+8,n=l[w+7|0],i[f+4>>2]=h-8,i[f+8>>2]=n|o,i[f+12>>2]=k,n=-56}i[f+16>>2]=(((h>>>0>=7?7:h)<<3)+n|0)- -64,u[L+7|0]=0,u[L+5|0]=0,u[L+6|0]=0,y6(f,1),e0=L,r0=v0(f,6),u[e0+5|0]=r0,e0=L,r0=v0(f,6),u[e0+6|0]=r0,e0=L,r0=v0(f,3)-1|0,u[e0+7|0]=r0,f=l[L+5|0],u[A+3204|0]=f,u[A+3206|0]=(f&248)==16,u[A+3205|0]=(f-19&255)>>>0<2;n:{if(l[L+6|0]){F4(A+548|0,O);break n}if(i[A+1904>>2]<l[L+7|0]){F4(A+548|0,O);break n}if(f>>>0<=31){s=A,_=L+8|0,B=v-16|0,v=B,k=E(1364),i[k+792>>2]=0,i[k+784>>2]=0,i[k+788>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,S=k+1340|0,A=S,i[A>>2]=0,i[A+4>>2]=0,i[k+1360>>2]=0,i[k+1352>>2]=0,i[k+1356>>2]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;X[i[i[A>>2]+8>>2]](A),p(A)}u[k+40|0]=0,i[k+36>>2]=0,u[k+20|0]=0,i[k+16>>2]=0,Q[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,Q[k+32>>1]=0,o0(k+42|0,0,100),i[k+776>>2]=0,i[k+780>>2]=0,o0(k+144|0,0,237),o0(k+384|0,0,358),u[k+759|0]=0,u[k+760|0]=0,u[k+761|0]=0,u[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,u[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],o0(k+820|0,0,100),o0(k+920|0,0,420),u[k+1348|0]=0,i[k+1356>>2]=i[k+1352>>2],u[B+15|0]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;X[i[i[A>>2]+8>>2]](A),p(A)}u[k+40|0]=0,i[k+36>>2]=0,u[k+20|0]=0,i[k+16>>2]=0,Q[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,Q[k+32>>1]=0,o=k+42|0,o0(o,0,100),i[k+776>>2]=0,i[k+780>>2]=0,o0(k+144|0,0,237),o0(k+384|0,0,358),u[k+759|0]=0,u[k+760|0]=0,u[k+761|0]=0,u[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,u[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],h=k+820|0,o0(h,0,100),o0(k+920|0,0,420),u[k+1348|0]=0,u[k+20|0]=0,i[k+1356>>2]=i[k+1352>>2],e0=k,r0=v0(_,1),u[e0+12|0]=r0,l[s+3206|0]&&(e0=k,r0=v0(_,1),u[e0+13|0]=r0),A=f2(_),i[k+16>>2]=A;t:{u:{o:{l:{s:{if(!((A|0)!=-99999&(A|0)<=63)||(A=s+(A<<3)|0,f=i[A+856>>2],!f))break s;r=i[A+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[k+4>>2]=f,A=i[k+8>>2],i[k+8>>2]=r;w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;X[i[i[A>>2]+8>>2]](A),p(A)}if(r=i[k+4>>2],w=i[r+4>>2],!l[w|0]){C2(s+4|0,1010,0);break l}w:{_:{h:{B:{v:{if(!l[k+12|0]){for(A=0,l[r+14|0]?r=v0(_,1):r=0,u[k+20|0]=r,f=i[w+16908>>2];r=A,A=r+1|0,(f|0)>1<<r;);if(f=v0(_,r),t=l[k+20|0],t){if(!f){u[B+15|0]=0,C2(s+4|0,1021,0),A=0;break t}if(r=i[s+2220>>2],A=16,!r)break t;i[k>>2]=i[r>>2],A=i[r+4>>2],n=i[r+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+4>>2]=A,A=i[k+8>>2],i[k+8>>2]=n;Z:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break Z;X[i[i[A>>2]+8>>2]](A),p(A)}z(k+12|0,r+12|0,772);Z:{if((r|0)!=(k|0)){A=i[r+784>>2],n=i[r+788>>2],k6(k+784|0,A,n,n-A>>2),z(k+796|0,r+796|0,544),ni(k+1340|0,r+1340|0),u[k+1348|0]=l[r+1348|0],A=i[r+1352>>2],r=i[r+1356>>2],k6(k+1352|0,A,r,r-A>>2);break Z}z(k+796|0,r+796|0,544),ni(k+1340|0,r+1340|0),u[k+1348|0]=l[r+1348|0]}u[k+20|0]=1,u[k+12|0]=0}if(i[k+24>>2]=f,(f|0)<0)break w;if((f|0)<i[w+16908>>2])break v;break w}if(i[k+24>>2]=0,u[k+20|0]=0,i[w+16908>>2]<=0)break w;r=i[k+4>>2];break B}if(r=i[k+4>>2],t)break h}if(A=0,u[r+8240|0]>0)for(;y6(_,1),A=A+1|0,(A|0)<u[i[k+4>>2]+8240|0];);if(A=f2(_),i[k+28>>2]=A,!((A|0)!=-99999&(A|0)<=2)){C2(s+4|0,1007,0);break l}l[i[k+4>>2]+43|0]?A=v0(_,1):A=1,u[k+32|0]=A,l[w+480|0]==1&&(e0=k,r0=v0(_,2),u[e0+33|0]=r0),u[k+40|0]=0,i[k+36>>2]=0;B:{v:{Z:{G:{m:{if((l[s+3204|0]-19&255)>>>0>=2){e0=k,r0=v0(_,i[w+520>>2]),i[e0+36>>2]=r0,A=v0(_,1),u[k+40|0]=A;W:{if(!(A&255)){Z9(s+4|0,w,_,o,(i[w+8820>>2]-i[w+8816>>2]|0)/100|0,w+8816|0,1),i[k+816>>2]=(i[w+8820>>2]-i[w+8816>>2]|0)/100;break W}for(o=i[w+8816>>2],t=(i[w+8820>>2]-o|0)/100|0,r=0;A=r,r=r+1|0,1<<A<(t|0););X:{if(!A){A=0;break X}A=v0(_,A),o=i[w+8816>>2],t=(i[w+8820>>2]-o|0)/100|0}if(i[k+144>>2]=A,(A|0)>=(t|0))break G;i[k+816>>2]=A,o=G(A,100)+o|0}z(h,o,100);W:{if(l[w+8828|0]){X:{if(i[w+8832>>2]>0){if(A=f2(_),i[k+148>>2]=A,(A|0)!=-99999)break X;A=8;break t}i[k+148>>2]=0}if(r=f2(_),i[k+152>>2]=r,o=8,(r|0)==-99999)break _;if(A=i[k+148>>2],r=r+A|0,i[(w+(u[w+2|0]<<2)|0)+524>>2]<(l[k+917|0]+(r+l[k+916|0]|0)|0))break Z;if((r|0)<=0)break W;for(f=s+2352|0,n=k+268|0,m=k+252|0,g=w+8964|0,W=w+8836|0,C=k+156|0,y=s+2288|0,h=s+2224|0,I=k+236|0,N=k+172|0,t=0;;){X:{if((A|0)>(t|0)){for(x=i[w+8832>>2],A=0;r=A,A=r+1|0,(x|0)>1<<r;);if(A=t+C|0,r=v0(_,r),u[A|0]=r,r=r&255,(r|0)<i[w+8832>>2]){i[h+(t<<2)>>2]=i[W+(r<<2)>>2],A=g+l[A|0]|0;break X}C2(s+4|0,1023,0);break l}r=t<<2,x=r+N|0,e0=x,r0=v0(_,i[w+520>>2]),i[e0>>2]=r0,A=t+I|0,e0=A,r0=v0(_,1),u[e0|0]=r0,i[r+h>>2]=i[x>>2]}r=t<<2,x=u[A|0],i[r+y>>2]=x,A=v0(_,1),u[t+m|0]=A;X:{if(A&255){if(A=f2(_),i[r+n>>2]=A,(A|0)!=-99999)break X;break _}A=0,i[r+n>>2]=0}if(V=((x|0)!=0)+V|0,i[r+f>>2]=!t|i[k+148>>2]==(t|0)?A:i[(r+f|0)-4>>2]+A|0,t=t+1|0,A=i[k+148>>2],!((t|0)<(A+i[k+152>>2]|0)))break}break W}i[k+148>>2]=0,i[k+152>>2]=0}if(l[w+8996|0]){e0=k,r0=v0(_,1),u[e0+332|0]=r0;break m}u[k+332|0]=0;break m}i[k+148>>2]=0,i[k+152>>2]=0}m:{if(l[w+8799|0]){if(e0=k,r0=v0(_,1),u[e0+333|0]=r0,A=0,!i[w+16848>>2])break m;A=v0(_,1);break m}u[k+333|0]=0,A=0}if(i[k+336>>2]=0,i[k+340>>2]=0,u[k+334|0]=A,u0[k+28>>2]>1)break B;A=v0(_,1),u[k+335|0]=A;m:{if(A&255){if(A=f2(_),i[k+336>>2]=A,(A|0)==-99999)break o;if(A=A+1|0,i[k+336>>2]=A,i[k+28>>2]){r=i[k+340>>2];break m}if(A=f2(_),i[k+340>>2]=A,(A|0)==-99999)break o;r=A+1|0,i[k+340>>2]=r,A=i[k+336>>2];break m}r=i[k+4>>2],A=u[r+17|0],i[k+336>>2]=A,r=u[r+18|0],i[k+340>>2]=r}if(o=8,(A|0)>16|(r|0)>16)break _;f=l[k+919|0]+V|0,i[k+920>>2]=f;m:{W:{if(!(!l[i[k+4>>2]+8233|0]|(f|0)<2)){for(r=0;A=r,r=r+1|0,(f|0)>1<<A;);if(r=v0(_,1),u[k+344|0]=r,!(!(r&255)|i[k+336>>2]<=0))for(f=k+346|0,r=0;e0=r+f|0,r0=v0(_,A),u[e0|0]=r0,r=r+1|0,(r|0)<i[k+336>>2];);if(!i[k+28>>2]){if(r=v0(_,1),u[k+345|0]=r,!(r&255)|i[k+340>>2]<=0)break W;for(f=k+362|0,r=0;e0=r+f|0,r0=v0(_,A),u[e0|0]=r0,r=r+1|0,(r|0)<i[k+340>>2];);break W}u[k+345|0]=0;break m}Q[k+344>>1]=0}if(i[k+28>>2])break m;e0=k,r0=v0(_,1),u[e0+378|0]=r0}if(l[i[k+4>>2]+16|0]?A=v0(_,1):A=0,u[k+379|0]=A,!l[k+332|0])break v;A=1,i[k+28>>2]||(A=v0(_,1)),u[k+380|0]=A,r=A&255;m:{if(!(i[k+340>>2]<2|r)||i[k+336>>2]>1&&r){if(r=f2(_),i[k+384>>2]=r,(r|0)!=-99999){A=l[k+380|0];break m}break o}r=0,i[k+384>>2]=0}m:{if(A&255){if(i[k+336>>2]<=(r|0))break m;break v}if(i[k+340>>2]>(r|0))break v}break u}C2(s+4|0,1015,0),A=8;break t}C2(s+4|0,1018,0);break l}v:{if(A=i[k+4>>2],r=i[k+28>>2],!(!(r|!l[A+42|0])||(r|0)==1&&l[A+41|0]))break v;n=0;Z:{G:{if(A=i[(s+(i[k+16>>2]<<3)|0)+856>>2],A){if(t=i[(s+(u[A+13|0]<<3)|0)+728>>2],!t)break G;A=f2(_),u[k+388|0]=A;m:{if(A>>>0>7)break m;if(i[t+476>>2]){if(A=q1(_)+l[k+388|0]|0,A>>>0>7)break m;u[k+389|0]=A}for(R=k+679|0,A0=k+552|0,C=k+678|0,y=k+550|0,m0=k+518|0,I=k+454|0,N=k+422|0,a=k+390|0,f=k+336|0,o=k+340|0,r=1;;){A=f;W:{if(r||(A=o,!i[k+28>>2]))break W;n=1;break Z}if(h=0,g=i[A>>2],(g|0)>0){for(;V=n<<4,h0=V+a|0,e0=h0+h|0,r0=v0(_,1),u[e0|0]=r0,h=h+1|0,(g|0)!=(h|0););if(h=0,i[t+476>>2])for(;e0=(V+N|0)+h|0,r0=v0(_,1),u[e0|0]=r0,h=h+1|0,(g|0)!=(h|0););for(m=n<<5,D=m+R|0,x=n<<6,$=x+A0|0,h=0;;){W:{if(l[h+h0|0]){if(n=0,A=q1(_),A-128>>>0<4294967040)break Z;if(Q[(m+I|0)+(h<<1)>>1]=A+(1<<l[k+388|0]),A=q1(_),W=i[t+16996>>2],(A|0)<(0-W|0))break m;if((A|0)<(W|0))break W;break m}Q[(m+I|0)+(h<<1)>>1]=1<<l[k+388|0],A=0}u[(V+m0|0)+h|0]=A,V0=D+(h<<1)|0;W:{X:{if(l[(V+N|0)+h|0]){if(A=q1(_),A-128>>>0>=4294967040)break X;n=0;break Z}A=h<<2,n=1<<l[k+389|0],Q[A+(y+x|0)>>1]=n,u[(m+C|0)+(h<<1)|0]=0,Q[A+$>>1]=n,A=0;break W}if(f0=h<<2,n0=f0+(y+x|0)|0,Q[n0>>1]=A+(1<<l[k+389|0]),n=0,W=q1(_),A=i[t+17e3>>2],Q0=A<<2,(W|0)<(0-Q0|0)|(W|0)>=(Q0|0)||(Q0=0-A|0,W=(A+W|0)-(G(A,Q[n0>>1])>>l[k+389|0])|0,u[(m+C|0)+(h<<1)|0]=(W|0)<(Q0|0)?Q0:(A|0)>(W|0)?W:A-1|0,A=q1(_),A-128>>>0<4294967040)||(f0=$+f0|0,Q[f0>>1]=A+(1<<l[k+389|0]),W=q1(_),A=i[t+17e3>>2],n0=A<<2,(W|0)<(0-n0|0)|(W|0)>=(n0|0)))break m;n0=0-A|0,n=(A+W|0)-(G(A,Q[f0>>1])>>l[k+389|0])|0,A=(n|0)<(n0|0)?n0:(A|0)>(n|0)?n:A+255|0}if(u[V0|0]=A,h=h+1|0,(g|0)==(h|0))break}}if(n=1,A=r,r=0,!A)break}}break Z}M0(4839,18308,152,13628),H()}M0(4835,18308,154,13628),H()}if(n)break v;break u}if(A=f2(_),i[k+744>>2]=A,(A|0)==-99999)break o;i[k+812>>2]=5-A}if(A=q1(_),i[k+748>>2]=A,(A|0)==-99999)break o;A=i[k+4>>2];B:{if(l[A+40|0]){if(A=q1(_),i[k+752>>2]=A,(A|0)==-99999)break o;if(A=q1(_),i[k+756>>2]=A,(A|0)!=-99999){A=i[k+4>>2];break B}break o}i[k+752>>2]=0,i[k+756>>2]=0}l[A+8248|0]==1&&(e0=k,r0=v0(_,1),u[e0+760|0]=r0,A=i[k+4>>2]);B:{v:{if(!l[A+60|0]){u[k+761|0]=0,i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2];break v}if(r=v0(_,1),u[k+761|0]=r,A=i[k+4>>2],i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2],!(r&255))break v;if(A=v0(_,1),u[k+762|0]=A,A&255)break B;if(A=q1(_),i[k+764>>2]=A,(A|0)==-99999||(i[k+764>>2]=A<<1,A=q1(_),i[k+768>>2]=A,(A|0)==-99999))break o;i[k+768>>2]=A<<1;break B}u[k+762|0]=l[A+61|0]}if(r=i[k+4>>2],A=l[r+58|0],!(!A|!(!l[k+762|0]||l[k+333|0]|l[k+334|0]))){e0=k,r0=v0(_,1),u[e0+772|0]=r0,r=i[k+4>>2];break h}u[k+772|0]=A}h:{if(l[r+46|0]|l[r+45|0]){if(A=f2(_),i[k+776>>2]=A,(A|0)==-99999||(r=i[k+4>>2],!(!l[r+45|0]|i[w+16900>>2]>(A+(i[k+24>>2]/i[w+16892>>2]|0)|0))|!(!l[r+46|0]|(A|0)<=(G(i[r+52>>2],i[r+48>>2])|0))))break o;r=k+784|0,f=i[r>>2],n=i[r+4>>2]-f>>2;B:{if(n>>>0<A>>>0){I8(r,A-n|0);break B}A>>>0<n>>>0&&(i[r+4>>2]=f+(A<<2))}if(i[k+776>>2]<=0)break h;if(r=f2(_),i[k+780>>2]=r,(r|0)==-99999)break o;if(f=r+1|0,i[k+780>>2]=f,A=8,(r|0)>31)break t;if(i[k+776>>2]<=0||(A=1,r=v0(_,f),i[i[k+784>>2]>>2]=r+1,i[k+776>>2]<2))break h;for(;r=v0(_,i[k+780>>2]),f=i[k+784>>2]+(A<<2)|0,i[f>>2]=(r+i[f-4>>2]|0)+1,A=A+1|0,(A|0)<i[k+776>>2];);break h}i[k+776>>2]=0}h:{if(!l[i[k+4>>2]+8241|0])break h;if(r=f2(_),i[k+796>>2]=r,(r|0)==-99999|(r|0)>1e3)break o;if(A=0,(r|0)<=0)break h;for(;v0(_,8),A=A+1|0,(A|0)<i[k+796>>2];);}i[k+800>>2]=i[k+748>>2]+i[i[k+4>>2]+20>>2],A=0;h:{B:{v:switch(i[k+28>>2]){case 1:A=u[k+379|0]+1|0;break B;case 0:break v;case 2:break B;default:break h}A=2-u[k+379|0]|0}i[k+804>>2]=A}i[k+812>>2]=5-i[k+744>>2],u[B+15|0]=1,o=0}A=o;break t}C2(s+4|0,1020,0),A=8;break t}C2(s+4|0,1009,0),A=0;break t}u[B+15|0]=0,A=0;break t}C2(s+4|0,1007,0),A=8;break t}C2(s+4|0,8,0),A=8}i[B+8>>2]=A;t:{u:{if(!l[B+15|0]){A=i[s+2216>>2],A&&(u[A+312|0]=2),F4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),P8(S),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];o:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;X[i[i[A>>2]+8>>2]](A),p(A)}Z(k),r=i[B+8>>2];break u}if(f=i[s+528>>2],(f|0)>=0)o:{A=v-864|0,v=A,r=67604;l:{s:{w:{_:switch(f-1|0){case 1:r=67600;break;case 0:break _;default:break w}if(r=i[r>>2],k0(r,42254,0),f=i[(s+(i[k+16>>2]<<3)|0)+856>>2],!f){k0(r,33521,0);break w}if(!l[f|0])break s;if(n=i[(s+(u[f+13|0]<<3)|0)+728>>2],!n){k0(r,33497,0);break w}if(!l[n|0])break l;i[A+848>>2]=u[k+12|0],k0(r,38735,A+848|0),(l[s+3204|0]&248)==16&&(i[A+832>>2]=u[k+13|0],k0(r,39373,A+832|0)),i[A+816>>2]=i[k+16>>2],k0(r,40095,A+816|0),l[k+12|0]||(i[A+800>>2]=u[k+20|0],k0(r,39330,A+800|0),i[A+784>>2]=i[k+24>>2],k0(r,40871,A+784|0)),o=i[k+28>>2],i[A+768>>2]=o?(o|0)==1?80:73:66,k0(r,41590,A+768|0),l[f+43|0]&&(i[A+752>>2]=u[k+32|0],k0(r,41319,A+752|0)),l[n+480|0]==1&&(i[A+736>>2]=u[k+33|0],k0(r,41362,A+736|0)),i[A+720>>2]=i[k+36>>2],k0(r,40603,A+720|0);_:{if((l[s+3204|0]-19&255)>>>0<2)break _;i[A+704>>2]=u[k+40|0],k0(r,38454,A+704|0),o=i[n+8820>>2]-i[n+8816>>2]|0;h:{B:{if(!l[k+40|0]){i[A+672>>2]=(o|0)/100,k0(r,32487,A+672|0),o=k+42|0;break B}if((o|0)<101)break h;i[A+688>>2]=i[k+144>>2],k0(r,39826,A+688|0),o=i[n+8816>>2]+G(i[k+144>>2],100)|0}Bt(o,r)}if(l[n+8828|0]&&(i[n+8832>>2]>0&&(i[A+656>>2]=i[k+148>>2],k0(r,41496,A+656|0)),i[A+640>>2]=i[k+152>>2],k0(r,41405,A+640|0)),!l[n+8996|0])break _;i[A+624>>2]=u[k+332|0],k0(r,36039,A+624|0)}if(l[n+8799|0]&&(i[A+608>>2]=u[k+333|0],k0(r,40492,A+608|0),i[A+592>>2]=u[k+334|0],k0(r,40057,A+592|0)),u0[k+28>>2]<=1){i[A+576>>2]=u[k+335|0],k0(r,35746,A+576|0),o=l[k+335|0],i[A+560>>2]=i[k+336>>2],i[A+564>>2]=o?42716:26617,k0(r,33045,A+560|0),i[k+28>>2]||(o=l[k+335|0],i[A+544>>2]=i[k+340>>2],i[A+548>>2]=o?42716:26617,k0(r,33005,A+544|0));_:{if(!l[f+8233|0]|i[k+920>>2]<2)break _;if(i[A+528>>2]=u[k+344|0],k0(r,36664,A+528|0),!(!l[k+344|0]|i[k+336>>2]<=0))for(o=k+346|0,t=0;i[A+516>>2]=l[o+t|0],i[A+512>>2]=t,k0(r,34729,A+512|0),t=t+1|0,(t|0)<i[k+336>>2];);if(i[A+496>>2]=u[k+345|0],k0(r,36624,A+496|0),!l[k+345|0]|i[k+340>>2]<=0)break _;for(o=k+362|0,t=0;i[A+484>>2]=l[o+t|0],i[A+480>>2]=t,k0(r,34729,A+480|0),t=t+1|0,(t|0)<i[k+340>>2];);}i[k+28>>2]||(i[A+464>>2]=u[k+378|0],k0(r,40804,A+464|0)),i[A+448>>2]=u[k+379|0],k0(r,40947,A+448|0),l[k+332|0]&&(i[A+432>>2]=u[k+380|0],k0(r,39150,A+432|0),i[A+416>>2]=i[k+384>>2],k0(r,40293,A+416|0)),o=i[k+28>>2];_:{if(!(!(o|!l[f+42|0])||(o|0)==1&&l[f+41|0]))break _;if(i[A+400>>2]=l[k+388|0],k0(r,39293,A+400|0),i[n+476>>2]&&(i[A+384>>2]=l[k+389|0],k0(r,39621,A+384|0)),o=i[k+336>>2],(o|0)>0)for(w=k+678|0,h=k+550|0,m=k+518|0,g=k+454|0,V=k+679|0,W=k+552|0,t=0;n=t<<1,i[A+376>>2]=Q[n+g>>1],i[A+372>>2]=t,i[A+368>>2]=0,k0(r,40530,A+368|0),i[A+360>>2]=u[t+m|0],i[A+356>>2]=t,i[A+352>>2]=0,k0(r,40256,A+352|0),C=t<<2,i[A+348>>2]=Q[C+h>>1],i[A+344>>2]=0,i[A+340>>2]=t,i[A+336>>2]=0,k0(r,39187,A+336|0),i[A+332>>2]=u[n+w|0],i[A+328>>2]=0,i[A+324>>2]=t,i[A+320>>2]=0,k0(r,39225,A+320|0),i[A+316>>2]=Q[W+C>>1],i[A+312>>2]=1,i[A+308>>2]=t,i[A+304>>2]=0,k0(r,39187,A+304|0),i[A+300>>2]=u[n+V|0],i[A+296>>2]=1,i[A+292>>2]=t,i[A+288>>2]=0,k0(r,39225,A+288|0),t=t+1|0,(o|0)!=(t|0););if(i[k+28>>2]||(o=i[k+340>>2],(o|0)<=0))break _;for(w=k+711|0,h=k+616|0,m=k+710|0,g=k+614|0,V=k+534|0,W=k+486|0,t=0;n=t<<1,i[A+280>>2]=Q[n+W>>1],i[A+276>>2]=t,i[A+272>>2]=1,k0(r,40530,A+272|0),i[A+264>>2]=u[t+V|0],i[A+260>>2]=t,i[A+256>>2]=1,k0(r,40256,A+256|0),C=t<<2,i[A+252>>2]=Q[C+g>>1],i[A+248>>2]=0,i[A+244>>2]=t,i[A+240>>2]=1,k0(r,39187,A+240|0),i[A+236>>2]=u[n+m|0],i[A+232>>2]=0,i[A+228>>2]=t,i[A+224>>2]=1,k0(r,39225,A+224|0),i[A+220>>2]=Q[h+C>>1],i[A+216>>2]=1,i[A+212>>2]=t,i[A+208>>2]=1,k0(r,39187,A+208|0),i[A+204>>2]=u[n+w|0],i[A+200>>2]=1,i[A+196>>2]=t,i[A+192>>2]=1,k0(r,39225,A+192|0),t=t+1|0,(o|0)!=(t|0););}i[A+176>>2]=i[k+744>>2],k0(r,37013,A+176|0)}if(i[A+160>>2]=i[k+748>>2],k0(r,39521,A+160|0),l[f+40|0]&&(i[A+144>>2]=i[k+752>>2],k0(r,37911,A+144|0),i[A+128>>2]=i[k+756>>2],k0(r,37882,A+128|0)),l[f+60|0]&&(i[A+112>>2]=u[k+761|0],k0(r,35708,A+112|0)),n=l[k+761|0],i[A+96>>2]=u[k+762|0],i[A+100>>2]=n?26583:26412,k0(r,32958,A+96|0),l[k+762|0]|!l[k+761|0]||(i[A+80>>2]=i[k+764>>2],k0(r,36850,A+80|0),i[A+64>>2]=i[k+768>>2],k0(r,37465,A- -64|0)),!l[f+58|0]|!(!l[k+762|0]||l[k+333|0]|l[k+334|0])||(i[A+48>>2]=u[k+772|0],k0(r,35988,A+48|0)),!(l[f+46|0]|l[f+45|0])||(i[A+32>>2]=i[k+776>>2],k0(r,37527,A+32|0),i[k+776>>2]<=0)||(i[A+16>>2]=i[k+780>>2],k0(r,41064,A+16|0),i[k+776>>2]<=0))break w;for(t=0;i[A+4>>2]=i[i[k+784>>2]+(t<<2)>>2],i[A>>2]=t,k0(r,36562,A),t=t+1|0,(t|0)<i[k+776>>2];);}v=A+864|0;break o}M0(17850,18308,1287,7306),H()}M0(17836,18308,1294,7306),H()}n=i[O+8>>2],C=i[O+12>>2],y=i[O+16>>2],g=v-80|0,v=g,i[B+8>>2]=0,u[s+3220|0]=0,r=i[k+16>>2],f=s+(r<<3)|0,A=i[f+856>>2];o:{if(!(l[A|0]&&A)){if(i[g>>2]=r,r=v-16|0,v=r,l[125317]|i[31328]<-9999||(A=i[16901],f=l[33545]==42,f||L1(32530,5,1,A),i[r+12>>2]=g,Mr(A,f+33545|0,g,1953,1954),n6(A)),v=r+16|0,A=i[i[s+2216>>2]+112>>2],r=i[A+84>>2],(r|0)==20){i[A+80>>2]=1001,r=0;break o}i[A+84>>2]=r+1,i[(A+(r<<2)|0)+4>>2]=1009,r=0;break o}r=i[f+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1384>>2]=A,A=i[s+1388>>2],i[s+1388>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;X[i[i[A>>2]+8>>2]](A),p(A)}A=s+(u[i[s+1384>>2]+13|0]<<3)|0,f=i[A+728>>2],r=i[A+732>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1376>>2]=f,A=i[s+1380>>2],i[s+1380>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;X[i[i[A>>2]+8>>2]](A),p(A)}A=s+(u[i[s+1376>>2]+1|0]<<3)|0,f=i[A+600>>2],r=i[A+604>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1368>>2]=f,A=i[s+1372>>2],i[s+1372>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;X[i[i[A>>2]+8>>2]](A),p(A)}l:{s:{w:{_:{if(A=i[s+1376>>2],!A){if(A=i[s+1368>>2],A)break _;if(A=6,l[s+2108|0]!=6)break s;break l}if(t=u[A+2|0],A=t-1|0,(A|0)!=u[s+2108|0])break w;break l}if(t=i[A+8>>2],u[s+2108|0]==(t-1|0))break l;A=t-1|0}if((t|0)<=0)break l}for(I=s+2112|0,h=s+1908|0,m=A+1|0;;){r=G(A,100),w=(r+100|0)/(m|0)|0,f=(r|0)/(m|0)|0;s:{if((w|0)<(f|0)){r=A;break s}o=i[s+1888>>2];w:{if(f+w&1){r=A,t=f;break w}r=h+(f<<1)|0,u[r+1|0]=(A|0)>(o|0)?100:0,t=r,r=(A|0)<(o|0)?A:o,u[t|0]=r,t=f+1|0}if((f|0)==(w|0))break s;for(V=w-f|0,A=r;W=h+(t<<1)|0,r=(A|0)<(o|0)?A:o,u[W|0]=r,u[W+1|0]=(A|0)>(o|0)?100:(G(t-f|0,100)|0)/(V|0)|0,W=t+1|0,A=h+(W<<1)|0,u[A+1|0]=(G(W-f|0,100)|0)/(V|0),u[A|0]=r,t=t+2|0,A=r,(w|0)!=(W|0););}if(i[I+(r<<2)>>2]=w,A=r-1|0,!((r|0)>0))break}}A=s+(i[s+1892>>2]<<1)|0,r=u[A+1908|0],i[s+1896>>2]=r,i[s+1900>>2]=u[A+1909|0],i[s+1904>>2]=r;l:{s:{if(l[k+12|0]){if(i[s+2196>>2]=i[k+36>>2],A=i[s+1376>>2],r=l[A+8799|0],f=l[s+533|0],i[g+72>>2]=A,A=i[s+1380>>2],i[g+76>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[g+76>>2],i[g+40>>2]=i[g+72>>2],i[g+44>>2]=A,A=ln(s+2140|0,g+40|0,s,n,C,y,(f|!r)&1),(A|0)<0){r=0,i[B+8>>2]=0-A;break o}r=0,f=i[s+2148>>2],A>>>0<i[s+2152>>2]-f>>2>>>0&&(r=i[f+(A<<2)>>2]),i[s+2216>>2]=r,u[r+316|0]=l[L+7|0],A=l[L+5|0]|l[L+6|0]<<8,u[r+314|0]=A,u[r+315|0]=A>>>8,A=i[s+2216>>2],i[g+64>>2]=i[s+1368>>2],r=i[s+1372>>2],i[g+68>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[g+56>>2]=i[s+1376>>2],r=i[s+1380>>2],i[g+60>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[g+48>>2]=i[s+1384>>2],r=i[s+1388>>2],i[g+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[g+68>>2],i[g+32>>2]=i[g+64>>2],i[g+36>>2]=r,r=i[g+60>>2],i[g+24>>2]=i[g+56>>2],i[g+28>>2]=r,r=i[g+52>>2],i[g+16>>2]=i[g+48>>2],i[g+20>>2]=r,r=i[g+32>>2],f=i[g+36>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+116>>2]=r,r=i[A+120>>2],i[A+120>>2]=f;w:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break w;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[g+24>>2],f=i[g+28>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+124>>2]=r,r=i[A+128>>2],i[A+128>>2]=f;w:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break w;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[g+16>>2],f=i[g+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+132>>2]=r,r=i[A+136>>2],i[A+136>>2]=f;w:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break w;X[i[i[r>>2]+8>>2]](r),p(r)}A=i[g+20>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[g+28>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[g+36>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[s+2216>>2],i[A+112>>2]=s,o=0,h=0,r=i[A+160>>2];w:{if(!r||(f=G(i[A+164>>2],3),!f))break w;o0(r,0,f)}r=i[A+140>>2];w:{if(!r||(f=G(i[A+144>>2],24),!f))break w;o0(r,0,f)}r=i[A+260>>2];w:{if(!r||(f=i[A+264>>2],!f))break w;o0(r,0,f)}n=i[A+144>>2];w:{if((n|0)<=0)break w;if(A=i[A+320>>2],r=0,n>>>0>=8)for(t=A+532|0,w=A+456|0,m=A+380|0,V=A+304|0,W=A+228|0,C=A+152|0,y=A+76|0,I=n&2147483640;f=G(r,76),i[f+A>>2]=0,i[f+y>>2]=0,i[f+C>>2]=0,i[f+W>>2]=0,i[f+V>>2]=0,i[f+m>>2]=0,i[f+w>>2]=0,i[f+t>>2]=0,r=r+8|0,h=h+8|0,(I|0)!=(h|0););if(f=n&7,!f)break w;for(;i[A+G(r,76)>>2]=0,r=r+1|0,o=o+1|0,(f|0)!=(o|0););}A=l[s+3204|0];w:{if((A&248)!=16)break w;_:{if(!(u[s+2200|0]&1|((A|0)==18|(A&254)==16|(A-19&255)>>>0<2))&&!(u[s+2203|0]&1))break _;u[s+2203|0]=0,u[s+2201|0]=1;break w}u[s+2201|0]=0,u[s+2202|0]=0}w:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&254)!=8)){u[i[s+2216>>2]+104|0]=0;break w}u[i[s+2216>>2]+104|0]=l[k+32|0]!=0}f=0;w:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&248)!=16)){u[s+3220|0]=1,i[s+2204>>2]=0,A=i[k+36>>2];break w}A=i[k+36>>2],f=i[s+2208>>2],r=i[i[s+1376>>2]+16868>>2];_:{if(!((A|0)>=(f|0)|(f-A|0)<((r|0)/2|0))){o=r+i[s+2212>>2]|0;break _}if(o=i[s+2212>>2]-r|0,!((A|0)<=(f|0)|(A-f|0)<=((r|0)/2|0)))break _;o=i[s+2212>>2]}f=o,i[s+2204>>2]=f}r=i[s+2216>>2],i[r+92>>2]=A,i[r+96>>2]=A+f;w:{if(l[r+316|0]||(A=l[s+3204|0],!(A&241))||(A=A&254,(A|0)==8|(A|0)==6))break w;i[s+2208>>2]=i[k+36>>2],i[s+2212>>2]=i[s+2204>>2]}if(!l[k+12|0])break s;i[i[s+2216>>2]+100>>2]=1,f=0,o=0,h=0,n=0,m=v-32|0,v=m,i[m+28>>2]=0,i[m+20>>2]=0,i[m+24>>2]=0,r=i[s+2216>>2],V=i[r>>2];w:{_:{h:{B:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&248)!=16)){if(A=i[s+2152>>2],t=i[s+2148>>2],(A|0)!=(t|0))for(y=i[r+96>>2];;){W=i[(f<<2)+t>>2];v:{if(!i[W+100>>2]|(y|0)<=i[W+96>>2]||(w=i[W>>2],w>>>0>=u0[W+108>>2]))break v;Z:{if(n>>>0<h>>>0){i[n>>2]=w,n=n+4|0;break Z}if(r=n-o|0,I=r>>2,C=I+1|0,C>>>0>=1073741824)break B;if(n=h-o|0,h=n>>1,C=n>>>0>=2147483644?1073741823:h>>>0>C>>>0?h:C,C){if(C>>>0>=1073741824)break e;h=E(C<<2)}else h=0;n=h+r|0,i[n>>2]=w,w=n-(I<<2)|0,r&&z(w,o,r),n=n+4|0,h=h+(C<<2)|0,o&&(Z(o),t=i[s+2148>>2],A=i[s+2152>>2]),o=w}i[W+108>>2]=i[W>>2]}if(f=f+1|0,!(f>>>0<A-t>>2>>>0))break}i[m+28>>2]=h,i[m+24>>2]=n,i[m+20>>2]=o}v:{if((l[s+3204|0]-19&255)>>>0<2){i[s+2544>>2]=0,i[s+2548>>2]=0,i[s+2560>>2]=0,A=s+2552|0,i[A>>2]=0,i[A+4>>2]=0;break v}if(t=0,o=0,A=0,n=l[k+916|0],n)for(w=k+820|0,h=s+2692|0,W=s+2564|0,C=k+884|0,y=i[s+2216>>2],f=0;;){r=i[y+96>>2]+Q[w+(f<<1)>>1]|0;Z:{if(l[f+C|0]){i[W+(A<<2)>>2]=r,A=A+1|0;break Z}i[h+(o<<2)>>2]=r,o=o+1|0}if(f=f+1|0,(n|0)==(f|0))break}if(i[s+2544>>2]=A,r=l[k+917|0],r)for(n=s+2692|0,w=s+2628|0,h=k+852|0,W=k+900|0,C=i[s+2216>>2],f=0;;){A=i[C+96>>2]+Q[h+(f<<1)>>1]|0;Z:{if(l[f+W|0]){i[w+(t<<2)>>2]=A,t=t+1|0;break Z}i[n+(o<<2)>>2]=A,o=o+1|0}if(f=f+1|0,(r|0)==(f|0))break}i[s+2552>>2]=o,i[s+2548>>2]=t;Z:{if((i[k+152>>2]+i[k+148>>2]|0)<=0){n=0,r=0;break Z}for(w=s+2480|0,h=s+2820|0,W=s+2416|0,C=s+2756|0,y=s+2288|0,I=s+2352|0,N=k+252|0,x=s+2224|0,$=i[s+1376>>2],R=i[s+2216>>2],f=0,r=0,n=0;;){A=f<<2,o=i[A+x>>2],t=f+N|0,l[t|0]&&(o=i[R+96>>2]+o-(i[k+36>>2]+G(i[$+16868>>2],i[A+I>>2]))|0);G:{if(i[A+y>>2]){A=r<<2,i[A+C>>2]=o,i[A+W>>2]=u[t|0],r=r+1|0;break G}A=n<<2,i[A+h>>2]=o,i[A+w>>2]=u[t|0],n=n+1|0}if(f=f+1|0,!((f|0)<(i[k+152>>2]+i[k+148>>2]|0)))break}}i[s+2560>>2]=n,i[s+2556>>2]=r}if(A=i[s+2148>>2],r=i[s+2152>>2],i[m+16>>2]=0,i[m+8>>2]=0,i[m+12>>2]=0,(A|0)!=(r|0)){if(A=r-A>>2,(A|0)<0)break i;r=E(A),i[m+8>>2]=r,f=A+r|0,i[m+16>>2]=f,A&&o0(r,0,A),i[m+12>>2]=f}if(n=s+2140|0,A=i[s+2556>>2],(A|0)<=0)break h;for(W=s+3076|0,C=s+2756|0,y=s+2416|0,t=0;;){A=t<<2,o=A+C|0,r=i[o>>2],I=A+W|0;v:{if(!i[A+y>>2]){f=tu(n,r,V);break v}f=ue(n,r,V,1)}i[I>>2]=f;v:{Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=Yr(s,i[s+1376>>2],i[o>>2],1),(f|0)<0)break v;o=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],r=i[m+8>>2],w=A-r|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,N=i[m+16>>2],h>>>0<=N-A>>>0){h&&o0(A,0,h),i[m+12>>2]=A+h;break G}if((o|0)<0)break i;if(A=N-r|0,N=A<<1,N=A>>>0>=1073741823?2147483647:o>>>0<N>>>0?N:o,A=E(N),h&&o0(A+w|0,0,h),w&&z(A,r,w),i[m+16>>2]=A+N,i[m+12>>2]=A+o,i[m+8>>2]=A,!r){r=A;break G}Z(r),r=A;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=r+o}i[I>>2]=f,u[r+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),A=i[s+2556>>2],t=t+1|0,(A|0)>(t|0))continue;break h}break}f=0-f|0;break _}i[m+28>>2]=h,i[m+24>>2]=n,i[m+20>>2]=o;break i}if(o=i[s+2560>>2],(o|0)>0){W=s+3140|0,C=s+2820|0,y=s+2480|0,t=0;h:{B:{for(;;){A=t<<2,f=A+C|0,r=i[f>>2],I=A+W|0;v:{if(!i[A+y>>2]){A=tu(n,r,V);break v}A=ue(n,r,V,1)}i[I>>2]=A;v:{Z:{if((A|0)>=0){u[A+i[m+8>>2]|0]=1;break Z}if(h=Yr(s,i[s+1376>>2],i[f>>2],1),(h|0)<0)break B;r=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],f=i[m+8>>2],o=A-f|0;G:{if(r>>>0>o>>>0){if(w=r-o|0,N=i[m+16>>2],w>>>0<=N-A>>>0){w&&o0(A,0,w),i[m+12>>2]=A+w;break G}if((r|0)<0)break v;if(A=N-f|0,N=A<<1,N=A>>>0>=1073741823?2147483647:r>>>0<N>>>0?N:r,A=E(N),w&&o0(A+o|0,0,w),o&&z(A,f,o),i[m+16>>2]=A+N,i[m+12>>2]=A+r,i[m+8>>2]=A,!f){f=A;break G}Z(f),f=A;break G}if(r>>>0>=o>>>0)break G;i[m+12>>2]=r+f}i[I>>2]=h,u[f+h|0]=1}if(o=i[s+2560>>2],t=t+1|0,(o|0)<=(t|0))break h;continue}break}break i}f=0-h|0;break _}A=i[s+2556>>2]}h:{if((A|0)<=0)break h;if(W=s+3076|0,w=i[s+2148>>2],r=0,f=0,A>>>0>=4)for(C=A&2147483644,t=0;h=W+(f<<2)|0,i[i[w+(i[h>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+4>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+8>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,t=t+4|0,(C|0)!=(t|0););if(A=A&3,!A)break h;for(;i[i[w+(i[W+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(A|0)!=(r|0););}h:{if((o|0)<=0)break h;if(w=o&3,h=s+3140|0,A=i[s+2148>>2],r=0,f=0,o>>>0>=4)for(W=o&2147483644,o=0;t=h+(f<<2)|0,i[i[A+(i[t>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+4>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+8>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,o=o+4|0,(W|0)!=(o|0););if(!w)break h;for(;i[i[A+(i[h+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(w|0)!=(r|0););}h:{if(i[s+2544>>2]<=0)break h;W=s+2884|0,C=s+2564|0,t=0;B:{for(;;){v:{A=t<<2,r=A+W|0,A=A+C|0,f=ue(n,i[A>>2],V,0),i[r>>2]=f;Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=Yr(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break B;i[r>>2]=f,o=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],w=r-A|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,y=i[m+16>>2],h>>>0<=y-r>>>0){h&&o0(r,0,h),i[m+12>>2]=r+h;break G}if((o|0)<0)break v;if(r=y-A|0,y=r<<1,y=r>>>0>=1073741823?2147483647:o>>>0<y>>>0?y:o,r=E(y),h&&o0(r+w|0,0,h),w&&z(r,A,w),i[m+16>>2]=r+y,i[m+12>>2]=r+o,i[m+8>>2]=r,!A){A=r;break G}Z(A),A=r;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=A+o}u[A+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),t=t+1|0,(t|0)<i[s+2544>>2])continue;break h}break}break i}f=0-f|0;break _}h:{if(i[s+2548>>2]<=0)break h;W=s+2948|0,C=s+2628|0,t=0;B:{for(;;){v:{A=t<<2,r=A+W|0,A=A+C|0,f=ue(n,i[A>>2],V,0),i[r>>2]=f;Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=Yr(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break B;i[r>>2]=f,o=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],w=r-A|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,y=i[m+16>>2],h>>>0<=y-r>>>0){h&&o0(r,0,h),i[m+12>>2]=r+h;break G}if((o|0)<0)break v;if(r=y-A|0,y=r<<1,y=r>>>0>=1073741823?2147483647:o>>>0<y>>>0?y:o,r=E(y),h&&o0(r+w|0,0,h),w&&z(r,A,w),i[m+16>>2]=r+y,i[m+12>>2]=r+o,i[m+8>>2]=r,!A){A=r;break G}Z(A),A=r;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=A+o}u[A+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),t=t+1|0,(t|0)<i[s+2548>>2])continue;break h}break}break i}f=0-f|0;break _}if(i[s+2552>>2]>0)for(r=s+3012|0,o=s+2692|0,f=0;t=f<<2,A=ue(n,i[t+o>>2],V,0),i[r+t>>2]=A,(A|0)>=0&&(u[A+i[m+8>>2]|0]=1),f=f+1|0,(f|0)<i[s+2552>>2];);if(A=i[s+2152>>2],V=i[s+2148>>2],(A-V|0)>0)for(C=i[m+8>>2],y=i[m+12>>2]-C|0,f=0,n=i[m+24>>2],h=i[m+28>>2],t=i[m+20>>2];;){h:{if(l[f+C|0]&&f>>>0<y>>>0||(w=i[(f<<2)+V>>2],r=i[s+2216>>2],(w|0)==(r|0)|u0[w+108>>2]<=u0[r>>2]|!i[w+100>>2]))break h;o=i[w>>2];B:{if(n>>>0<h>>>0){i[n>>2]=o,n=n+4|0;break B}if(r=n-t|0,I=r>>2,n=I+1|0,n>>>0>=1073741824)break i;if(h=h-t|0,W=h>>1,h=h>>>0>=2147483644?1073741823:n>>>0<W>>>0?W:n,h){if(h>>>0>=1073741824)break e;n=E(h<<2)}else n=0;W=n+r|0,i[W>>2]=o,o=W-(I<<2)|0,r&&z(o,t,r),h=n+(h<<2)|0,i[m+28>>2]=h,i[m+20>>2]=o,n=W+4|0,t&&(Z(t),V=i[s+2148>>2],A=i[s+2152>>2]),t=o}i[m+24>>2]=n,i[w+108>>2]=i[i[s+2216>>2]>>2]}if(f=f+1|0,!((f|0)<A-V>>2))break}if(f=0,A=k+1352|0,(A|0)==(m+20|0))break _;o=A,A=i[m+20>>2],r=i[m+24>>2],k6(o,A,r,r-A>>2)}A=i[m+8>>2],A&&(i[m+12>>2]=A,Z(A)),A=i[m+20>>2],A&&(i[m+24>>2]=A,Z(A)),v=m+32|0;break w}if(i[B+8>>2]=f,!f)break s;r=0;break o}if(i[s+2216>>2])break l;r=0;break o}A=i[s+2216>>2],i[A+100>>2]=1,i[31328]=i[A+96>>2],u[s+2200|0]=0}r=1;l:{if(u0[k+28>>2]>1)break l;A=0,n=v-480|0,v=n,o=i[k+336>>2],t=i[k+920>>2],o0(n,0,96),h=s+3076|0,m=s+2948|0,V=s+2884|0,f=(o|0)>(t|0)?o:t,w=f-1|0,N=i[s+2556>>2],W=N-1|0,x=i[s+2548>>2],C=x-1|0,I=i[s+2544>>2],y=I-1|0,$=(I|0)<=0;s:{w:{_:{h:{B:{for(;;){if((A|0)>=(f|0))break B;if($||(I=w-A|0,I=I>>>0<y>>>0?I:y,R=(I<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,V,R),A=(A+I|0)+1|0),(x|0)<=0|(A|0)>=(f|0)||(I=w-A|0,I=C>>>0>I>>>0?I:C,R=(I<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,m,R),A=(A+I|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(I=w-A|0,R=W>>>0>I>>>0?I:W,I=R+1|0,I&&o0(A+n|0,1,I),R=(R<<2)+4|0,R&&z((n+288|0)+(A<<2)|0,h,R),A=A+I|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break h}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break h}if((o|0)>16)break _;if((o|0)>0)for(C=k+1180|0,y=k+1052|0,I=k+1308|0,N=k+924|0,x=k+346|0,A=0,$=l[k+344|0];;){if(w=A<<2,W=w+N|0,f=$?l[A+x|0]:A,i[W>>2]=i[(n+288|0)+(f<<2)>>2],u[A+I|0]=l[f+n|0],f=0,W=i[W>>2],R=i[s+2148>>2],W>>>0>=i[s+2152>>2]-R>>2>>>0||(W=i[R+(W<<2)>>2],!W))break h;if(i[w+y>>2]=i[W+96>>2],i[w+C>>2]=i[W+100>>2],A=A+1|0,(o|0)==(A|0))break}if(f=1,i[k+28>>2])break h;N=i[s+2556>>2],w=N-1|0,x=i[s+2544>>2],W=x-1|0,I=i[s+2548>>2],C=I-1|0,o=i[k+340>>2],f=(o|0)>(t|0)?o:t,t=f-1|0,y=n+48|0,A=0,$=(I|0)<=0;B:{for(;;){if((A|0)>=(f|0))break B;if($||(I=t-A|0,I=C>>>0>I>>>0?I:C,R=(I<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,m,R),A=(A+I|0)+1|0),(x|0)<=0|(A|0)>=(f|0)||(I=t-A|0,I=W>>>0>I>>>0?I:W,R=(I<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,V,R),A=(A+I|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(I=t-A|0,R=w>>>0>I>>>0?I:w,I=R+1|0,I&&o0(A+y|0,1,I),R=(R<<2)+4|0,R&&z((n+96|0)+(A<<2)|0,h,R),A=A+I|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break h}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break h}if((o|0)>16)break w;if(f=1,(o|0)<=0)break h;for(h=k+1244|0,m=k+1116|0,V=k+1324|0,W=k+988|0,C=k+362|0,A=0,I=l[k+345|0];;){if(t=A<<2,w=t+W|0,f=I?l[A+C|0]:A,i[w>>2]=i[(n+96|0)+(f<<2)>>2],u[A+V|0]=l[f+y|0],f=0,w=i[w>>2],N=i[s+2148>>2],w>>>0>=i[s+2152>>2]-N>>2>>>0||(w=i[N+(w<<2)>>2],!w))break h;if(i[t+m>>2]=i[w+96>>2],i[t+h>>2]=i[w+100>>2],f=1,A=A+1|0,(o|0)==(A|0))break}}v=n+480|0;break s}M0(21158,18166,1802,4451),H()}M0(21125,18166,1855,4451),H()}if(f)break l;r=0;break o}i[k+808>>2]=i[(l[k+20|0]?i[s+2220>>2]+808|0:k+24|0)>>2],i[s+2220>>2]=k}if(v=g+80|0,f=i[s+2216>>2],!r){f&&(u[f+312|0]=2),F4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),P8(S),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];o:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;X[i[i[A>>2]+8>>2]](A),p(A)}Z(k),r=i[B+8>>2];break u}A=i[f+56>>2],r=i[f+52>>2],n=A-r|0,t=n>>2,i[k>>2]=t;o:{if(o=i[f+60>>2],o>>>0>A>>>0){i[A>>2]=k,i[f+56>>2]=A+4;break o}l:{if(A=t+1|0,A>>>0<1073741824){if(o=o-r|0,w=o>>1,o=o>>>0>=2147483644?1073741823:A>>>0<w>>>0?w:A,o){if(o>>>0>=1073741824)break l;A=E(o<<2)}else A=0;w=A+n|0,i[w>>2]=k,t=w-(t<<2)|0,n&&z(t,r,n),i[f+60>>2]=A+(o<<2),A=w+4|0,i[f+56>>2]=A,i[f+52>>2]=t,r&&Z(r),i[f+56>>2]=A;break o}break i}break e}if(y6(_,1),Ql(_),i[k+776>>2]>0)for(o=i[_>>2]-i[O+20>>2]|0,f=i[k+784>>2],t=0;;){w=t<<2,f=i[w+f>>2],h=i[O+32>>2],A=i[O+36>>2]-h>>2;o:{for(;;){if(r=A,n=0,(r|0)<=0)break o;if(A=r-1|0,n=i[h+(A<<2)>>2],!((n|0)<(o|0)|(f|0)<(n-o|0)))break}n=r}if(f=i[k+784>>2],A=w+f|0,i[A>>2]=i[A>>2]-n,t=t+1|0,!((t|0)<i[k+776>>2]))break}o:{if(!l[k+12|0]){t=i[s+3212>>2];break o}f=E(480),Kt(f+8|0),i[f+472>>2]=0,i[f+476>>2]=0,i[f+464>>2]=0,i[f+468>>2]=0,i[f+456>>2]=0,i[f+460>>2]=0,i[f+448>>2]=0,i[f+452>>2]=0,i[f+440>>2]=0,i[f+444>>2]=0,i[f+432>>2]=0,i[f+436>>2]=0,i[f+424>>2]=0,i[f+428>>2]=0,i[f>>2]=i[s+2216>>2],A=i[s+3212>>2],o=i[s+3216>>2];l:{if(A>>>0<o>>>0){i[A>>2]=f,t=A+4|0;break l}if(n=i[s+3208>>2],A=A-n|0,w=A>>2,r=w+1|0,r>>>0>=1073741824)break i;if(o=o-n|0,t=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,o){if(o>>>0>=1073741824)break e;r=E(o<<2)}else r=0;if(t=r+A|0,i[t>>2]=f,f=t-(w<<2)|0,A&&z(f,n,A),i[s+3216>>2]=r+(o<<2),t=t+4|0,i[s+3212>>2]=t,i[s+3208>>2]=f,!n)break l;Z(n)}i[s+3212>>2]=t}o:{if(i[s+3208>>2]!=(t|0)){if(f=E(144),u[f+36|0]=0,i[f+32>>2]=0,i[f>>2]=0,i[f+4>>2]=0,i[f+44>>2]=0,i[f+140>>2]=s,i[f+128>>2]=-1,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=-1,i[f+136>>2]=0,i[f+40>>2]=0,i[f+4>>2]=k,i[f>>2]=O,A=i[_+4>>2],i[f+8>>2]=i[_>>2],i[f+12>>2]=A,A=i[_+12>>2],i[f+16>>2]=i[_+8>>2],i[f+20>>2]=A,A=i[_+20>>2],i[f+24>>2]=i[_+16>>2],i[f+28>>2]=A,u[f+36|0]=l[s+3220|0],n=i[i[s+3212>>2]-4>>2],A=i[n+428>>2],k=i[n+432>>2],A>>>0<k>>>0){i[A>>2]=f,i[n+428>>2]=A+4;break o}if(o=i[n+424>>2],A=A-o|0,O=A>>2,r=O+1|0,r>>>0>=1073741824)break i;if(k=k-o|0,t=k>>1,k=k>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,k){if(k>>>0>=1073741824)break e;r=E(k<<2)}else r=0;t=r+A|0,i[t>>2]=f,f=t-(O<<2)|0,A&&z(f,o,A),i[n+432>>2]=r+(k<<2),A=t+4|0,i[n+428>>2]=A,i[n+424>>2]=f,o&&Z(o),i[n+428>>2]=A;break o}F4(s+548|0,O)}y7(s,B+7|0),r=0}v=B+16|0;break t}break n}t:switch(f-32|0){case 0:s=E(668),i[s>>2]=61448,i[s+4>>2]=0,i[s+8>>2]=0,r=s+12|0,o0(r,0,656),o=A,_=A+4|0,k=L+8|0,A=v0(k,4),i[r>>2]=A,n=8;u:{o:{l:{s:{if((A|0)>15||(y6(k,2),A=v0(k,6),i[r+4>>2]=A+1,(A|0)>62)||(A=v0(k,3),i[r+8>>2]=A+1,(A|0)>6))break s;if(e0=r,r0=v0(k,1),i[e0+12>>2]=r0,y6(k,16),Uu(r+16|0,k,i[r+8>>2]),A=v0(k,1),i[r+484>>2]=A,t=i[r+8>>2],f=A?0:t-1|0,(f|0)<(t|0)){for(B=r+488|0,A=f;;){if(t=B+G(A,12)|0,e0=t,r0=f2(k),i[e0>>2]=r0,e0=t,r0=f2(k),i[e0+4>>2]=r0,w=f2(k),i[t+8>>2]=w,i[t>>2]==-99999|(w|0)==-99999|i[t+4>>2]==-99999)break s;if(A=A+1|0,!((A|0)<i[r+8>>2]))break}A=i[r+484>>2]}w:{if(A)break w;if((f|0)>7)break l;if((f|0)<=0||(t=(r+488|0)+G(f,12)|0,A=i[t>>2],n=i[t+4>>2],t=i[t+8>>2],i[r+496>>2]=t,i[r+492>>2]=n,i[r+488>>2]=A,(f|0)==1)||(i[r+508>>2]=t,i[r+504>>2]=n,i[r+500>>2]=A,(f|0)==2)||(i[r+520>>2]=t,i[r+516>>2]=n,i[r+512>>2]=A,(f|0)==3)||(i[r+532>>2]=t,i[r+528>>2]=n,i[r+524>>2]=A,(f|0)==4)||(i[r+544>>2]=t,i[r+540>>2]=n,i[r+536>>2]=A,(f|0)==5)||(i[r+556>>2]=t,i[r+552>>2]=n,i[r+548>>2]=A,(f|0)==6))break w;i[r+568>>2]=t,i[r+564>>2]=n,i[r+560>>2]=A}if(e0=r,r0=v0(k,6),u[e0+584|0]=r0,A=f2(k),i[r+588>>2]=A,A-1023>>>0<=4294966271)break o;f=A+1|0,i[r+588>>2]=f,A=i[r+596>>2],n=i[r+592>>2],t=(A-n|0)/12|0;w:{if(t>>>0<f>>>0){if(n=0,f=f-t|0,w=i[r+600>>2],f>>>0<=(w-A|0)/12>>>0){f&&(f=G(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&o0(A,0,f),A=A+f|0),i[r+596>>2]=A;break w}_:{if(t=A,A=i[r+592>>2],t=t-A|0,B=f+((t|0)/12|0)|0,B>>>0<357913942){if(w=(w-A|0)/12|0,h=w<<1,B=w>>>0>=178956970?357913941:h>>>0>B>>>0?h:B,B){if(B>>>0>=357913942)break _;n=E(G(B,12))}w=n+t|0,f=G(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&o0(w,0,f),h=w+G((t|0)/-12|0,12)|0,t&&z(h,A,t),i[r+600>>2]=G(B,12)+n,i[r+596>>2]=f+w,i[r+592>>2]=h,A&&Z(A);break w}break i}break e}if(f>>>0>=t>>>0)break w;if(n=n+G(f,12)|0,(n|0)!=(A|0))for(;f=A-12|0,t=i[f>>2],t&&(i[A-8>>2]=t,Z(t)),A=f,(A|0)!=(n|0););i[r+596>>2]=n}if(i[r+588>>2]>=2)for(n=l[r+584|0],f=1;;){t=n+1|0,I=n,m=G(f,12),A=m+i[r+592>>2]|0,h=i[A+4>>2],n=i[A>>2],B=h-n|0;w:{if(I>>>0>=B>>>0){if(w=t-B|0,g=i[A+8>>2],w>>>0<=g-h>>>0){w&&o0(h,0,w),i[A+4>>2]=w+h;break w}if(h=g-n|0,g=h<<1,g=h>>>0>=1073741823?2147483647:t>>>0<g>>>0?g:t,h=E(g),w&&o0(h+B|0,0,w),B&&z(h,n,B),i[A+8>>2]=h+g,i[A+4>>2]=t+h,i[A>>2]=h,!n)break w;Z(n);break w}if(t>>>0>=B>>>0)break w;i[A+4>>2]=n+t}for(A=0;n=v0(k,1),u[i[m+i[r+592>>2]>>2]+A|0]=n,n=l[r+584|0],t=n>>>0>A>>>0,A=A+1|0,!!t;);if(f=f+1|0,!((f|0)<i[r+588>>2]))break}A=v0(k,1),u[r+604|0]=A;w:{_:{if(!(A&255)||(e0=r,r0=v0(k,32),i[e0+608>>2]=r0,e0=r,r0=v0(k,32),i[e0+612>>2]=r0,A=v0(k,1),u[r+616|0]=A,!(A&255)))break _;if(e0=r,r0=f2(k)+1|0,i[e0+620>>2]=r0,n=f2(k),i[r+624>>2]=n,n>>>0>=1024)break o;f=0,A=i[r+632>>2],B=i[r+628>>2],t=A-B>>1;h:{if(t>>>0<n>>>0){if(n=n-t|0,w=i[r+636>>2],n>>>0<=w-A>>1>>>0){n&&(f=n<<1,f&&o0(A,0,f),A=A+f|0),i[r+632>>2]=A;break h}B:{if(t=A,A=i[r+628>>2],t=t-A|0,h=t>>1,B=h+n|0,(B|0)>=0){if(w=w-A|0,B=w>>>0>=2147483646?2147483647:w>>>0>B>>>0?w:B,B){if((B|0)<0)break B;f=E(B<<1)}w=f+t|0,n=n<<1,n&&o0(w,0,n),h=w-(h<<1)|0,t&&z(h,A,t),i[r+636>>2]=(B<<1)+f,i[r+632>>2]=n+w,i[r+628>>2]=h,A&&Z(A);break h}break i}break e}n>>>0<t>>>0&&(i[r+632>>2]=B+(n<<1))}h:{if(A=i[r+624>>2],B=i[r+644>>2],f=i[r+640>>2],n=B-f|0,A>>>0>n>>>0){if(t=A-n|0,w=i[r+648>>2],t>>>0<=w-B>>>0){t&&o0(B,0,t),i[r+644>>2]=t+B;break h}if((A|0)<0)break i;if(B=w-f|0,w=B<<1,w=B>>>0>=1073741823?2147483647:A>>>0<w>>>0?w:A,B=E(w),t&&o0(n+B|0,0,t),n&&z(B,f,n),i[r+648>>2]=w+B,i[r+644>>2]=A+B,i[r+640>>2]=B,!f)break h;Z(f);break h}if(A>>>0>=n>>>0)break h;i[r+644>>2]=A+f;break h}if(i[r+624>>2]<=0)break _;A=f2(k),Q[i[r+628>>2]>>1]=A;break w}e0=r,r0=v0(k,1),u[e0+652|0]=r0}n=0}f=n;break u}M0(19284,18192,144,17859),H()}C2(_,8,0),f=8}u:{if(f)break u;if(n=i[o+520>>2],(n|0)>=0){k=v-368|0,v=k,A=67604;o:{l:switch(n-1|0){case 1:A=67600;break;case 0:break l;default:break o}if(t=i[A>>2],k0(t,42090,0),i[k+352>>2]=i[r>>2],k0(t,41020,k+352|0),i[k+336>>2]=i[r+4>>2],k0(t,41452,k+336|0),i[k+320>>2]=i[r+8>>2],k0(t,41097,k+320|0),i[k+304>>2]=i[r+12>>2],k0(t,39704,k+304|0),A=i[r+8>>2],lr(r+16|0,1,t),(A|0)>=2)for(n=A-2|0,B=r+68|0,A=0;i[k+288>>2]=A,k0(t,41633,k+288|0),lr(B+G(A,52)|0,0,t),w=(A|0)!=(n|0),A=A+1|0,!!w;);i[k+272>>2]=i[r+484>>2],k0(t,35145,k+272|0);l:{if(i[r+484>>2]){if(i[r+8>>2]<=0)break l;for(B=r+488|0,A=0;n=B+G(A,12)|0,i[k+260>>2]=i[n>>2],i[k+256>>2]=A,k0(t,33670,k+256|0),i[k+240>>2]=i[n+4>>2],k0(t,33961,k+240|0),i[k+224>>2]=i[n+8>>2],k0(t,34006,k+224|0),A=A+1|0,(A|0)<i[r+8>>2];);break l}i[k+208>>2]=i[r+488>>2],k0(t,33712,k+208|0),i[k+192>>2]=i[r+492>>2],k0(t,33957,k+192|0),i[k+176>>2]=i[r+496>>2],k0(t,34002,k+176|0)}if(i[k+160>>2]=l[r+584|0],k0(t,34047,k+160|0),i[k+144>>2]=i[r+588>>2],k0(t,33617,k+144|0),i[r+588>>2]>=2)for(n=1;;){for(A=0,B=G(n,12);i[k+136>>2]=u[i[B+i[r+592>>2]>>2]+A|0],i[k+132>>2]=A,i[k+128>>2]=n,k0(t,33920,k+128|0),w=l[r+584|0]>A>>>0,A=A+1|0,!!w;);if(n=n+1|0,!((n|0)<i[r+588>>2]))break}i[k+112>>2]=u[r+604|0],k0(t,33757,k+112|0);l:{if(!l[r+604|0]||(i[k+96>>2]=i[r+608>>2],k0(t,33642,k+96|0),i[k+80>>2]=i[r+612>>2],k0(t,34105,k+80|0),i[k+64>>2]=u[r+616|0],k0(t,33817,k- -64|0),!l[r+616|0])||(i[k+48>>2]=i[r+620>>2],k0(t,33859,k+48|0),i[k+32>>2]=i[r+624>>2],k0(t,34072,k+32|0),i[r+624>>2]<=0))break l;i[k+20>>2]=F[i[r+628>>2]>>1],i[k+16>>2]=0,k0(t,33892,k+16|0);break o}i[k>>2]=u[r+652|0],k0(t,33792,k)}v=k+368|0}if(i[s+4>>2]=i[s+4>>2]+1,n=o+(i[s+12>>2]<<3)|0,i[n+600>>2]=r,A=i[n+604>>2],i[n+604>>2]=s,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[s+4>>2],i[s+4>>2]=A-1,A||(X[i[i[s>>2]+8>>2]](s),p(s)),r=f,F4(o+548|0,O);break n;case 1:B=E(17016),i[B>>2]=61564,i[B+4>>2]=0,i[B+8>>2]=0,w=A+4|0,k=B+12|0,i[k+8824>>2]=0,i[k+8816>>2]=0,i[k+8820>>2]=0,r=k+9e3|0,Q[r+2>>1]=0,Q[r+4>>1]=0,u[r|0]=0,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+27|0]=0,u[r+28|0]=0,u[r+20|0]=2,i[r+12>>2]=5,i[r+16>>2]=33685504,i[r+48>>2]=0,i[r+52>>2]=0,Q[r+7810>>1]=258,Q[r+7812>>1]=3855,Q[r+7808>>1]=0,i[r+7804>>2]=65536,u[r+64|0]=0,i[r+60>>2]=1,u[r+5|0]=0,u[r+6|0]=0,u[r+7|0]=0,u[r+8|0]=0,u[r+29|0]=0,u[r+30|0]=0,u[r+31|0]=0,u[r+32|0]=0,u[r+33|0]=0,u[r+34|0]=0,u[r+35|0]=0,u[r+36|0]=0,u[r+37|0]=0,u[r+38|0]=0,u[r+39|0]=0,u[r+40|0]=0,u[r+41|0]=0,u[r+42|0]=0,u[r+43|0]=0,u[r+44|0]=0,u[r+56|0]=0,u[k+16828|0]=0,i[k+16820>>2]=0,i[k+16824>>2]=0,u[k|0]=0,o=L+8|0,e0=k,r0=v0(o,4),u[e0+1|0]=r0,r=v0(o,3)+1|0,u[k+2|0]=r,n=8;u:{if(r<<24>>24>7)break u;e0=k,r0=v0(o,1),u[e0+3|0]=r0,Uu(k+4|0,o,u[k+2|0]);o:{l:{s:{if(r=f2(o),(r|0)==-99999)break s;if(i[k+472>>2]=r,(r|0)>15)break u;if(t=f2(o),(t|0)==-99999)break s;if(i[k+476>>2]=t,(t|0)==3&&(s=v0(o,1),t=i[k+476>>2]),u[k+480|0]=s,t>>>0>=4){C2(w,1019,0);break u}if(r=f2(o),(r|0)==-99999||(i[k+484>>2]=r,r=f2(o),(r|0)==-99999))break s;if(i[k+488>>2]=r,!r||(f=i[k+484>>2],!f|(r|0)>65535|(f|0)>65535))break u;r=v0(o,1),u[k+492|0]=r;w:{if(r&255){if(r=f2(o),(r|0)==-99999||(i[k+496>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+500>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+504>>2]=r,r=f2(o),(r|0)==-99999))break s;i[k+508>>2]=r;break w}i[k+496>>2]=0,i[k+500>>2]=0,i[k+504>>2]=0,i[k+508>>2]=0}if(r=f2(o),(r|0)==-99999||(i[k+512>>2]=r+8,r=f2(o),(r|0)==-99999))break s;if(i[k+516>>2]=r+8,!(i[k+512>>2]<17&(r|0)<=8))break l;if(r=f2(o),(r|0)==-99999)break s;if(f=r+4|0,i[k+520>>2]=f,r>>>0>=13)break l;if(i[k+16868>>2]=1<<f,r=v0(o,1),u[k+524|0]=r,t=u[k+2|0],n=r&255?0:t-1|0,(n|0)<(t|0)){for(s=k+16964|0,h=k+584|0,_=k+556|0,m=k+528|0;;){if(f=f2(o),!((f|0)!=-99999&(f|0)<16)||(r=n<<2,i[r+m>>2]=f+1,f=f2(o),(f|0)==-99999)||(t=r+_|0,i[t>>2]=f,f=f2(o),(f|0)==-99999))break s;if(i[r+h>>2]=f,i[r+s>>2]=(f+i[t>>2]|0)-1,t=u[k+2|0],n=n+1|0,!((t|0)>(n|0)))break}r=l[k+524|0]}w:{_:{if(!(r&255))break _;if((t|0)>7)break w;if((t|0)<2||(r=t-1|0,t=r<<2,f=t+(k+528|0)|0,i[k+528>>2]=i[f>>2],n=t+(k+556|0)|0,i[k+556>>2]=i[n>>2],t=t+(k+584|0)|0,i[k+584>>2]=i[t>>2],(r|0)==1)||(i[k+532>>2]=i[f>>2],i[k+560>>2]=i[n>>2],i[k+588>>2]=i[t>>2],(r|0)==2)||(i[k+536>>2]=i[f>>2],i[k+564>>2]=i[n>>2],i[k+592>>2]=i[t>>2],(r|0)==3)||(i[k+540>>2]=i[f>>2],i[k+568>>2]=i[n>>2],i[k+596>>2]=i[t>>2],(r|0)==4)||(i[k+544>>2]=i[f>>2],i[k+572>>2]=i[n>>2],i[k+600>>2]=i[t>>2],(r|0)==5))break _;i[k+548>>2]=i[f>>2],i[k+576>>2]=i[n>>2],i[k+604>>2]=i[t>>2]}if(r=f2(o),(r|0)==-99999||(i[k+612>>2]=r+3,r=f2(o),(r|0)==-99999)||(i[k+616>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+620>>2]=r+2,r=f2(o),(r|0)==-99999)||(i[k+624>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+628>>2]=r,r=f2(o),(r|0)==-99999))break s;if(i[k+632>>2]=r,n=8,r=i[k+612>>2],(r|0)>6|(r+i[k+616>>2]|0)>6||(r=i[k+620>>2],(r|0)>5|(r+i[k+624>>2]|0)>5))break u;r=v0(o,1),u[k+636|0]=r;_:{if(!(r&255))break _;if(f=v0(o,1),u[k+637|0]=f,r=k+638|0,f&255){if(n=n9(o,r),!n)break _;break u}for(n=0,G8(r,107088,0),G8(r+16|0,107088,0),G8(r+32|0,107088,0),G8(r+48|0,107088,0),G8(r- -64|0,107088,0),G8(r+80|0,107088,0),t=r+96|0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107104|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107105|0],n=n+2|0,(n|0)!=64;);for(t=r+288|0,n=0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107168|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107169|0],n=n+2|0,(n|0)!=64;);for(t=r+160|0,n=0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107104|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107105|0],n=n+2|0,(n|0)!=64;);for(t=r+352|0,n=0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107168|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107169|0],n=n+2|0,(n|0)!=64;);for(t=r+224|0,n=0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107104|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107105|0],n=n+2|0,(n|0)!=64;);for(t=r+416|0,n=0,s=i[i[15786]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107168|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107169|0],n=n+2|0,(n|0)!=64;);for(t=r+481|0,s=r+480|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107104|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1249|0,s=r+1248|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107168|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+737|0,s=r+736|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107104|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1505|0,s=r+1504|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107168|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+993|0,s=r+992|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107104|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1761|0,s=r+1760|0,n=0,h=i[i[15786]+12>>2];f=h+(n<<1)|0,_=n+107168|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);G8(r+2016|0,107104,3),G8(r+3040|0,107168,3)}e0=k,r0=v0(o,1),u[e0+8798|0]=r0,e0=k,r0=v0(o,1),u[e0+8799|0]=r0,r=v0(o,1),u[k+8800|0]=r;_:{if(r&255){if(e0=k,r0=v0(o,4)+1|0,u[e0+8801|0]=r0,e0=k,r0=v0(o,4)+1|0,u[e0+8802|0]=r0,r=f2(o),(r|0)==-99999||(i[k+8804>>2]=r+3,r=f2(o),(r|0)==-99999))break s;if(i[k+8808>>2]=r,e0=k,r0=v0(o,1),u[e0+8812|0]=r0,i[k+512>>2]<u[k+8801|0])break o;if(i[k+516>>2]>=u[k+8802|0])break _;break o}i[k+8804>>2]=0,i[k+8808>>2]=0,u[k+8801|0]=0,u[k+8802|0]=0,u[k+8812|0]=0}if(n=f2(o),(n|0)==-99999)break s;if(n>>>0>=65){C2(w,1014,0),n=8;break u}s=0,r=k+8816|0,f=i[r+4>>2],h=i[r>>2],t=(f-h|0)/100|0;_:{if(t>>>0<n>>>0){if(t=n-t|0,m=i[r+8>>2],t>>>0<=(m-f|0)/100>>>0){t&&(t=G(t,100)-100|0,t=(t-((t>>>0)%100|0)|0)+100|0,t&&o0(f,0,t),f=f+t|0),i[r+4>>2]=f;break _}h:{if(I=f,f=i[r>>2],h=I-f|0,_=t+((h|0)/100|0)|0,_>>>0<42949673){if(m=(m-f|0)/100|0,g=m<<1,_=m>>>0>=21474836?42949672:_>>>0<g>>>0?g:_,_){if(_>>>0>=42949673)break h;s=E(G(_,100))}m=s+h|0,t=G(t,100)-100|0,t=(t-((t>>>0)%100|0)|0)+100|0,t&&o0(m,0,t),g=m+G((h|0)/-100|0,100)|0,h&&z(g,f,h),i[r+8>>2]=G(_,100)+s,i[r+4>>2]=t+m,i[r>>2]=g,f&&Z(f);break _}break i}break e}n>>>0<t>>>0&&(i[r+4>>2]=h+G(n,100))}_:{if(!n)break _;for(t=0;;){if(Z9(w,k,o,i[k+8816>>2]+G(t,100)|0,t,r,0)){if(t=t+1|0,(n|0)!=(t|0))continue;break _}break}n=1005;break u}r=v0(o,1),u[k+8828|0]=r;_:{if(r&255){if(r=f2(o),(r|0)==-99999)break s;if(i[k+8832>>2]=r,n=8,(r|0)>32)break u;if((r|0)<=0)break _;for(r=k+8964|0,f=k+8836|0,t=0;e0=f+(t<<2)|0,r0=v0(o,i[k+520>>2]),i[e0>>2]=r0,e0=r+t|0,r0=v0(o,1),u[e0|0]=r0,t=t+1|0,(t|0)<i[k+8832>>2];);break _}i[k+8832>>2]=0}if(e0=k,r0=v0(o,1),u[e0+8996|0]=r0,e0=k,r0=v0(o,1),u[e0+8997|0]=r0,r=v0(o,1),u[k+8998|0]=r,r&255){n=0,r=k+9e3|0,f=v0(o,1),u[r|0]=(f|0)!=0;_:{if(f){if(f=v0(o,8),(f|0)<=17){f=f<<2,Q[r+2>>1]=F[f+63952>>1],n=F[f+63954>>1];break _}if((f|0)==255){e0=r,r0=v0(o,16),Q[e0+2>>1]=r0,n=v0(o,16);break _}}Q[r+2>>1]=0}Q[r+4>>1]=n,f=v0(o,1),u[r+6|0]=(f|0)!=0,f&&(e0=r,r0=(v0(o,1)|0)!=0,u[e0+7|0]=r0),u[r+20|0]=2,Q[r+18>>1]=514,u[r+16|0]=0,i[r+12>>2]=5,f=v0(o,1),u[r+8|0]=(f|0)!=0;_:{if(!f||(f=v0(o,3),i[r+12>>2]=(f|0)>=5?5:f,e0=r,r0=(v0(o,1)|0)!=0,u[e0+16|0]=r0,f=v0(o,1),u[r+17|0]=(f|0)!=0,!f))break _;f=v0(o,8),u[r+18|0]=f;h:{B:{v:switch(f=f&255,f|0){case 0:case 3:break B;default:break v}if(f>>>0<11)break h}u[r+18|0]=2}f=v0(o,8),u[r+19|0]=f;h:{B:switch(f&255){default:if((f&254)>>>0<18)break h;break;case 0:case 3:break B}u[r+19|0]=2}f=v0(o,8),u[r+20|0]=(f&255)>>>0>10?2:f}n=0,f=v0(o,1),u[r+21|0]=(f|0)!=0;_:{h:{B:{if(f){if(f=f2(o),(f|0)==-99999)break h;if(u[r+22|0]=f,n=f2(o),(n|0)!=-99999)break B;break h}u[r+22|0]=0}u[r+23|0]=n,e0=r,r0=(v0(o,1)|0)!=0,u[e0+24|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+25|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+26|0]=r0,f=v0(o,1),u[r+27|0]=(f|0)!=0;B:{if(f){if(f=f2(o),(f|0)==-99999||(i[r+28>>2]=f,f=f2(o),(f|0)==-99999)||(i[r+32>>2]=f,f=f2(o),(f|0)==-99999)||(i[r+36>>2]=f,f=f2(o),(f|0)==-99999))break h;i[r+40>>2]=f;break B}i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0}f=v0(o,1),u[r+44|0]=(f|0)!=0;B:{v:{if(!f)break v;if(e0=r,r0=v0(o,32),i[e0+48>>2]=r0,e0=r,r0=v0(o,32),i[e0+52>>2]=r0,f=v0(o,1),u[r+56|0]=(f|0)!=0,f){if(f=f2(o),(f|0)==-99999)break h;i[r+60>>2]=f+1}if(f=v0(o,1),u[r+64|0]=(f|0)!=0,!f)break v;s=0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+65|0]=r0,f=v0(o,1),u[r+66|0]=(f|0)!=0,f|u[r+65|0]&1&&(f=v0(o,1),u[r+67|0]=(f|0)!=0,f&&(e0=r,r0=v0(o,8),i[e0+68>>2]=r0,e0=r,r0=v0(o,5),i[e0+72>>2]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+76|0]=r0,e0=r,r0=v0(o,5),i[e0+80>>2]=r0),e0=r,r0=v0(o,4),i[e0+84>>2]=r0,e0=r,r0=v0(o,4),i[e0+88>>2]=r0,l[r+67|0]==1&&(e0=r,r0=v0(o,4),i[e0+92>>2]=r0),e0=r,r0=v0(o,5),i[e0+96>>2]=r0,e0=r,r0=v0(o,5),i[e0+100>>2]=r0,e0=r,r0=v0(o,5),i[e0+104>>2]=r0),n=0;Z:{if(u[k+2|0]<=0)break Z;V=r+7357|0,W=r+5568|0,C=r+3776|0,S=r+1984|0,y=r+192|0,I=r+7356|0,N=r+5564|0,x=r+3772|0,$=r+1980|0,R=r+188|0,A0=r+160|0,_=r+132|0,m=r+122|0,g=r+115|0,m0=r+108|0;G:{for(;;){m:{f=v0(o,1),u[s+m0|0]=(f|0)!=0;W:{X:{C:{I:{if(f){u[s+g|0]=1,n=s+m|0,u[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0;break I}if(t=v0(o,1),u[s+g|0]=(t|0)!=0,n=s+m|0,u[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0,!t)break C}if(t=f2(o),(t|0)==-99999)break m;if(i[A0+(s<<2)>>2]=t,u[n|0]&1)break W;break X}if(t=n,n=v0(o,1),u[t|0]=(n|0)!=0,n)break W}if(n=f2(o),(n|0)==-99999)break m;if(i[f>>2]=n,n>>>0<=31)break W;n=8;break Z}if(n=0,u[r+65|0]&1)for(;;){if(a=f2(o),(a|0)==-99999||(h=n<<3,t=s<<8,i[h+(t+R|0)>>2]=a,a=f2(o),(a|0)==-99999))break m;if(i[h+(t+$|0)>>2]=a,l[r+67|0]==1){if(a=f2(o),(a|0)==-99999||(i[h+(t+x|0)>>2]=a,a=f2(o),(a|0)==-99999))break m;i[h+(t+N|0)>>2]=a}if(e0=(I+(s<<6)|0)+(n<<1)|0,r0=(v0(o,1)|0)!=0,u[e0|0]=r0,t=u0[f>>2]>n>>>0,n=n+1|0,!t)break}if(u[r+66|0]&1)for(h=V+(s<<6)|0,n=s<<8,a=n+W|0,h0=n+C|0,D=n+S|0,n0=n+y|0,n=0;;){if(f0=f2(o),(f0|0)==-99999||(t=n<<3,i[t+n0>>2]=f0,f0=f2(o),(f0|0)==-99999))break m;if(i[t+D>>2]=f0,l[r+67|0]==1){if(f0=f2(o),(f0|0)==-99999||(i[t+h0>>2]=f0,f0=f2(o),(f0|0)==-99999))break m;i[t+a>>2]=f0}if(e0=h+(n<<1)|0,r0=(v0(o,1)|0)!=0,u[e0|0]=r0,t=u0[f>>2]>n>>>0,n=n+1|0,!t)break}if(n=0,s=s+1|0,(s|0)<u[k+2|0])continue;break G}break}n=8,C2(w,8,0)}}if(n)break B}if(f=v0(o,1),u[r+7804|0]=(f|0)!=0,f){if(e0=r,r0=(v0(o,1)|0)!=0,u[e0+7805|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+7806|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+7807|0]=r0,f=f2(o),(f|0)==-99999||(Q[r+7808>>1]=f,f&61440&&(C2(w,8,0),Q[r+7808>>1]=0),f=f2(o),(f|0)==-99999)||(u[r+7810|0]=f,(f&255)>>>0>=17&&(C2(w,8,0),u[r+7810|0]=2),f=f2(o),(f|0)==-99999)||(u[r+7811|0]=f,(f&255)>>>0>=17&&(C2(w,8,0),u[r+7811|0]=1),f=f2(o),(f|0)==-99999)||(u[r+7812|0]=f,f&240&&(C2(w,8,0),u[r+7812|0]=15),f=f2(o),(f|0)==-99999))break h;if(u[r+7813|0]=f,n=0,!(f&240))break B;C2(w,8,0),u[r+7813|0]=15;break _}Q[r+7810>>1]=258,Q[r+7812>>1]=3855,n=0,Q[r+7808>>1]=0,u[r+7807|0]=0,u[r+7805|0]=0,u[r+7806|0]=1}break _}C2(w,8,0),n=8}if(n)break u}r=v0(o,1),u[k+16816|0]=r;_:{if(!(r&255)){u[k+16817|0]=0;break _}if(e0=k,r0=v0(o,1),u[e0+16817|0]=r0,e0=k,r0=v0(o,1),u[e0+16818|0]=r0,e0=k,r0=v0(o,6),u[e0+16819|0]=r0,!l[k+16817|0])break _;r=k+16820|0,e0=r,r0=v0(o,1),u[e0|0]=r0,e0=r,r0=v0(o,1),u[e0+1|0]=r0,e0=r,r0=v0(o,1),u[e0+2|0]=r0,e0=r,r0=v0(o,1),u[e0+3|0]=r0,e0=r,r0=v0(o,1),u[e0+4|0]=r0,e0=r,r0=v0(o,1),u[e0+5|0]=r0,e0=r,r0=v0(o,1),u[e0+6|0]=r0,e0=r,r0=v0(o,1),u[e0+7|0]=r0,e0=r,r0=v0(o,1),u[e0+8|0]=r0}t=i[k+476>>2],r=t<<2,V=i[r+63808>>2],i[k+16856>>2]=V,W=i[r+63792>>2],i[k+16852>>2]=W,y=l[k+480|0];_:{if(y){i[k+16848>>2]=0,o=1,r=1;break _}i[k+16848>>2]=t,o=t?V:1,r=t?W:1}i[k+16864>>2]=o,i[k+16860>>2]=r,w=i[k+512>>2],i[k+16832>>2]=w,h=i[k+516>>2],i[k+16840>>2]=h,_=i[k+612>>2],i[k+16872>>2]=_,n=1<<_,i[k+16880>>2]=n,I=i[k+616>>2],m=I+_|0,i[k+16876>>2]=m,C=i[k+488>>2],S=i[k+484>>2],i[k+16912>>2]=G(C,S),i[k+16836>>2]=G(w,6)-48,i[k+16844>>2]=G(h,6)-48,f=1<<m,i[k+16884>>2]=f,r=S-1|0,s=(r+n|0)/(n|0)|0,i[k+16888>>2]=s,g=C-1|0,N=(g+n|0)/(n|0)|0,i[k+16896>>2]=N,o=(r+f|0)/(f|0)|0,i[k+16892>>2]=o,i[k+16904>>2]=G(s,N),s=(f+g|0)/(f|0)|0,i[k+16900>>2]=s,i[k+16908>>2]=G(o,s),r=0,A0=0;_:{if(!t||(A0=0,y))break _;r=(f|0)/(W|0)|0,A0=(f|0)/(V|0)|0}i[k+16920>>2]=A0,i[k+16916>>2]=r,r=i[k+620>>2],i[k+16936>>2]=r,g=r+i[k+624>>2]|0,i[k+16940>>2]=g;_:{h:{if(f=m-r|0,(f|0)<i[k+628>>2]){L1(33269,70,1,i[16900]);break h}if((f|0)<i[k+632>>2]){L1(33340,70,1,i[16900]);break h}i[k+16944>>2]=_-1,t=i[k+8804>>2],i[k+16956>>2]=t,V=s<<f,i[k+16928>>2]=V,f=o<<f,i[k+16924>>2]=f,A0=s,s=I+1|0,i[k+16952>>2]=A0<<s,i[k+16948>>2]=o<<s,i[k+16960>>2]=t+i[k+8808>>2],i[k+16932>>2]=G(f,V);B:{if(l[k+16826|0]){s=1<<h-1,o=1<<w-1,t=0,f=0;break B}o=128,s=128,t=h-8|0,f=w-8|0}if(i[k+17e3>>2]=s,i[k+16996>>2]=o,u[k+16993|0]=t,u[k+16992|0]=f,n-1&(C|S)){L1(32911,24,1,i[16900]);break h}if((r|0)>(_|0)){L1(41771,19,1,i[16900]);break h}if((g|0)>(((m|0)>=5?5:m)|0)){L1(41740,30,1,i[16900]);break h}if(w-17>>>0<=4294967286){L1(41666,36,1,i[16900]);break h}if(h-17>>>0<=4294967286){L1(41703,36,1,i[16900]);break h}u[k|0]=1,n=0;break _}n=8}if(n)break u;u[k|0]=1,n=0;break u}M0(21112,18199,320,17859),H()}C2(w,8,0),n=8;break u}C2(w,1005,0);break u}C2(w,1027,0),n=8}if(o=n,!n){if(s=i[A+516>>2],(s|0)>=0){r=v-928|0,v=r,t=67604;u:{o:switch(s-1|0){case 1:t=67600;break;case 0:break o;default:break u}if(f=i[t>>2],k0(f,42131,0),i[r+912>>2]=u[k+1|0],k0(f,37050,r+912|0),i[r+896>>2]=u[k+2|0],k0(f,38307,r+896|0),i[r+880>>2]=u[k+3|0],k0(f,35526,r+880|0),o=u[k+2|0],n=v-16|0,v=n,t=k+4|0,lr(t,1,f),(o|0)>=2)for(o=o-2|0,w=t+52|0,t=0;i[n>>2]=t,k0(f,41633,n),lr(w+G(t,52)|0,0,f),h=(o|0)==(t|0),t=t+1|0,!h;);v=n+16|0,i[r+864>>2]=i[k+472>>2],k0(f,37852,r+864|0),n=i[k+476>>2];o:{if(n>>>0>=3){o=(n|0)==3?21375:7978;break o}o=i[(n<<2)+63824>>2]}if(i[r+852>>2]=o,i[r+848>>2]=n,k0(f,42379,r+848|0),i[k+476>>2]==3&&(i[r+832>>2]=u[k+480|0],k0(f,35603,r+832|0)),i[r+816>>2]=i[k+484>>2],k0(f,36875,r+816|0),i[r+800>>2]=i[k+488>>2],k0(f,34834,r+800|0),i[r+784>>2]=u[k+492|0],k0(f,37663,r+784|0),l[k+492|0]&&(i[r+768>>2]=i[k+496>>2],k0(f,36786,r+768|0),i[r+752>>2]=i[k+500>>2],k0(f,34739,r+752|0),i[r+736>>2]=i[k+504>>2],k0(f,37116,r+736|0),i[r+720>>2]=i[k+508>>2],k0(f,34133,r+720|0)),i[r+704>>2]=i[k+512>>2],k0(f,37294,r+704|0),i[r+688>>2]=i[k+516>>2],k0(f,36539,r+688|0),i[r+672>>2]=i[k+520>>2],k0(f,36464,r+672|0),i[r+656>>2]=u[k+524|0],k0(f,35192,r+656|0),n=u[k+2|0],t=l[k+524|0]?0:n-1|0,(t|0)<(n|0))for(o=k+584|0,w=k+556|0,h=k+528|0;i[r+640>>2]=t,k0(f,33607,r+640|0),n=t<<2,i[r+624>>2]=i[n+h>>2],k0(f,38415,r+624|0),i[r+608>>2]=i[n+w>>2],k0(f,38850,r+608|0),i[r+592>>2]=i[n+o>>2],k0(f,36585,r+592|0),t=t+1|0,(t|0)<u[k+2|0];);i[r+576>>2]=i[k+612>>2],k0(f,36261,r+576|0),i[r+560>>2]=i[k+616>>2],k0(f,36214,r+560|0),i[r+544>>2]=i[k+620>>2],k0(f,37213,r+544|0),i[r+528>>2]=i[k+624>>2],k0(f,36169,r+528|0),i[r+512>>2]=i[k+628>>2],k0(f,34867,r+512|0),i[r+496>>2]=i[k+632>>2],k0(f,36497,r+496|0),i[r+480>>2]=u[k+636|0],k0(f,35636,r+480|0);o:{if(!l[k+636|0]||(i[r+464>>2]=u[k+637|0],k0(f,35365,r+464|0),!l[k+637|0]))break o;k0(f,16494,0)}if(i[r+448>>2]=u[k+8798|0],k0(f,41141,r+448|0),i[r+432>>2]=u[k+8799|0],k0(f,35858,r+432|0),i[r+416>>2]=u[k+8800|0],k0(f,41183,r+416|0),l[k+8800|0]&&(i[r+400>>2]=u[k+8801|0],k0(f,38252,r+400|0),i[r+384>>2]=u[k+8802|0],k0(f,37317,r+384|0),i[r+368>>2]=i[k+8804>>2],k0(f,36350,r+368|0),i[r+352>>2]=i[k+8808>>2],k0(f,36299,r+352|0),i[r+336>>2]=u[k+8812|0],k0(f,36977,r+336|0)),i[r+320>>2]=(i[k+8820>>2]-i[k+8816>>2]|0)/100,k0(f,34767,r+320|0),i[k+8820>>2]!=i[k+8816>>2])for(t=0;i[r+304>>2]=t,k0(f,32487,r+304|0),Bt(i[k+8816>>2]+G(t,100)|0,f),t=t+1|0,t>>>0<(i[k+8820>>2]-i[k+8816>>2]|0)/100>>>0;);i[r+288>>2]=u[k+8828|0],k0(f,35074,r+288|0);o:{if(!l[k+8828|0]||(i[r+272>>2]=i[k+8832>>2],k0(f,34801,r+272|0),i[k+8832>>2]<=0))break o;for(n=k+8964|0,o=k+8836|0,t=0;w=i[o+(t<<2)>>2],i[r+264>>2]=u[n+t|0],i[r+260>>2]=w,i[r+256>>2]=t,k0(f,42618,r+256|0),t=t+1|0,(t|0)<i[k+8832>>2];);}if(i[r+240>>2]=u[k+8996|0],k0(f,38694,r+240|0),i[r+224>>2]=u[k+8997|0],k0(f,35667,r+224|0),i[r+208>>2]=u[k+8998|0],k0(f,39109,r+208|0),i[r+192>>2]=u[k+16816|0],k0(f,37729,r+192|0),i[r+176>>2]=u[k+16817|0],k0(f,38497,r+176|0),i[r+160>>2]=u[k+16818|0],k0(f,35454,r+160|0),i[r+144>>2]=u[k+16819|0],k0(f,39869,r+144|0),i[r+128>>2]=i[k+16884>>2],k0(f,38288,r+128|0),i[r+112>>2]=i[k+16880>>2],k0(f,37372,r+112|0),i[r+96>>2]=1<<i[k+616>>2]+i[k+612>>2],k0(f,37353,r+96|0),i[r+80>>2]=1<<i[k+620>>2],k0(f,37410,r+80|0),i[r+64>>2]=1<<i[k+624>>2]+i[k+620>>2],k0(f,37391,r- -64|0),i[r+48>>2]=i[k+16892>>2],k0(f,39550,r+48|0),i[r+32>>2]=i[k+16900>>2],k0(f,39263,r+32|0),i[r+16>>2]=i[k+16852>>2],k0(f,40841,r+16|0),i[r>>2]=i[k+16856>>2],k0(f,40692,r),l[k+16817|0]){o=k+16820|0,f=v-144|0,v=f,n=67604;o:switch(s-1|0){case 1:n=67600;case 0:n=i[n>>2],k0(n,42033,0),i[f+128>>2]=l[o|0],k0(n,37806,f+128|0),i[f+112>>2]=l[o+1|0],k0(n,38044,f+112|0),i[f+96>>2]=l[o+2|0],k0(n,40446,f+96|0),i[f+80>>2]=l[o+3|0],k0(n,40400,f+80|0),i[f+64>>2]=l[o+4|0],k0(n,38569,f- -64|0),i[f+48>>2]=l[o+5|0],k0(n,39976,f+48|0),i[f+32>>2]=l[o+6|0],k0(n,38136,f+32|0),i[f+16>>2]=l[o+7|0],k0(n,36123,f+16|0),i[f>>2]=l[o+8|0],k0(n,38090,f);break;default:break o}v=f+144|0}if(!l[k+8998|0])break u;o=k+9e3|0,f=v-576|0,v=f,n=67604;o:{l:switch(s-1|0){case 1:n=67600;break;case 0:break l;default:break o}if(n=i[n>>2],k0(n,42213,0),t=F[o+2>>1],i[f+564>>2]=F[o+4>>1],i[f+560>>2]=t,k0(n,33571,f+560|0),i[f+544>>2]=l[o+6|0],k0(n,35112,f+544|0),i[f+528>>2]=l[o+7|0],k0(n,36944,f+528|0),i[f+512>>2]=l[o+8|0],k0(n,34276,f+512|0),l[o+8|0]==1&&(t=i[o+12>>2],t>>>0<=4?t=i[(t<<2)+64024>>2]:t=17196,i[f+496>>2]=t,k0(n,33114,f+496|0),i[f+480>>2]=l[o+16|0],k0(n,38966,f+480|0),i[f+464>>2]=l[o+17|0],k0(n,35275,f+464|0),i[f+448>>2]=l[o+18|0],k0(n,40138,f+448|0),i[f+432>>2]=l[o+19|0],k0(n,37586,f+432|0),i[f+416>>2]=l[o+20|0],k0(n,40722,f+416|0)),i[f+400>>2]=l[o+21|0],k0(n,34161,f+400|0),l[o+21|0]==1&&(i[f+384>>2]=l[o+22|0],k0(n,37251,f+384|0),i[f+368>>2]=l[o+23|0],k0(n,34686,f+368|0)),i[f+352>>2]=l[o+24|0],k0(n,34392,f+352|0),i[f+336>>2]=l[o+25|0],k0(n,40984,f+336|0),i[f+320>>2]=l[o+26|0],k0(n,35239,f+320|0),i[f+304>>2]=l[o+27|0],k0(n,37144,f+304|0),i[f+288>>2]=i[o+28>>2],k0(n,37429,f+288|0),i[f+272>>2]=i[o+32>>2],k0(n,37080,f+272|0),i[f+256>>2]=i[o+36>>2],k0(n,37940,f+256|0),i[f+240>>2]=i[o+40>>2],k0(n,36814,f+240|0),i[f+224>>2]=l[o+44|0],k0(n,36908,f+224|0),l[o+44|0]==1&&(i[f+208>>2]=i[o+48>>2],k0(n,38889,f+208|0),i[f+192>>2]=i[o+52>>2],k0(n,40567,f+192|0)),i[f+176>>2]=l[o+56|0],k0(n,35561,f+176|0),i[f+160>>2]=i[o+60>>2],k0(n,39784,f+160|0),i[f+144>>2]=l[o+64|0],k0(n,35036,f+144|0),i[f+128>>2]=l[o+7804|0],k0(n,39445,f+128|0),l[o+7804|0]!=1)break o;i[f+112>>2]=l[o+7805|0],k0(n,38925,f+112|0),i[f+96>>2]=l[o+7806|0],k0(n,35406,f+96|0),i[f+80>>2]=l[o+7807|0],k0(n,37765,f+80|0),i[f+64>>2]=F[o+7808>>1],k0(n,38211,f- -64|0),i[f+48>>2]=l[o+7810|0],k0(n,39580,f+48|0),i[f+32>>2]=l[o+7811|0],k0(n,39068,f+32|0),i[f+16>>2]=l[o+7812|0],k0(n,37622,f+16|0),i[f>>2]=l[o+7813|0],k0(n,38374,f)}v=f+576|0}v=r+928|0}i[B+4>>2]=i[B+4>>2]+1,f=(i[B+484>>2]<<3)+A|0,i[f+728>>2]=k,r=i[f+732>>2],i[f+732>>2]=B;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}for(o=856,t=A+856|0;;){r=i[t>>2];u:{if(!r|i[B+484>>2]!=u[r+13|0]||(r=i[t+4>>2],i[t>>2]=0,i[t+4>>2]=0,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=o+8|0,t=o+A|0,(o|0)==1368)break}o=0}r=i[B+4>>2],i[B+4>>2]=r-1,r||(X[i[i[B>>2]+8>>2]](B),p(B)),r=o,F4(A+548|0,O);break n;case 2:o=A,A=L+8|0,m=E(8520),i[m>>2]=61676,i[m+4>>2]=0,i[m+8>>2]=0,t=1006,k=m+12|0,u[k+8263|0]=0,u[k+8264|0]=0,u[k+8246|0]=2,u[k+8247|0]=0,u[k+8248|0]=0,u[k+8249|0]=0,u[k+8250|0]=0,i[k+4>>2]=0,i[k+8>>2]=0,u[k|0]=0,i[k+8448>>2]=0,i[k+8452>>2]=0,u[k+26|0]=0,Q[k+24>>1]=0,i[k+20>>2]=27,u[k+17|0]=1,u[k+18|0]=1,u[k+9|0]=0,u[k+10|0]=0,u[k+11|0]=0,u[k+12|0]=0,u[k+13|0]=0,u[k+14|0]=0,u[k+15|0]=0,u[k+16|0]=0,r=k+8456|0,i[r>>2]=0,i[r+4>>2]=0,r=k+8464|0,i[r>>2]=0,i[r+4>>2]=0,f=k+8472|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8480|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8488|0,i[f>>2]=0,i[f+4>>2]=0,n=k+8496|0,i[n>>2]=0,i[n+4>>2]=0,i[k+8504>>2]=0,u[k+43|0]=0,u[k+44|0]=0,u[k+45|0]=0,u[k+46|0]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,Q[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,u[k+58|0]=1,o0(k+8280|0,0,168),i[f>>2]=0,i[r>>2]=0,i[k+8268>>2]=0,u[k+8233|0]=0,u[k+61|0]=0,u[k+59|0]=0,u[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,u[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,Q[k+8244>>1]=0,u[k|0]=0,r=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}i[k+12>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,u[k+26|0]=0,Q[k+24>>1]=0,i[k+20>>2]=27,u[k+18|0]=1,u[k+58|0]=1,Q[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,Q[k+16>>1]=256,i[k+36>>2]=0,i[k+40>>2]=0,u[k+43|0]=0,u[k+44|0]=0,u[k+45|0]=0,u[k+46|0]=0,w=k+8280|0,o0(w,0,168),i[k+8268>>2]=0,u[k+8233|0]=0,u[k+61|0]=0,u[k+59|0]=0,u[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,u[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,Q[k+8244>>1]=0,i[k+8452>>2]=i[k+8448>>2],i[k+8464>>2]=i[k+8460>>2],i[k+8476>>2]=i[k+8472>>2],i[k+8488>>2]=i[k+8484>>2],i[k+8500>>2]=i[k+8496>>2],r=f2(A),u[k+12|0]=r;u:{if(!((r|0)!=-99999&(r|0)<=63)){C2(o+4|0,1009,0);break u}r=f2(A),u[k+13|0]=r;o:{l:{if(!((r|0)!=-99999&(r|0)<=15))break l;if(e0=k,r0=v0(A,1),u[e0+14|0]=r0,e0=k,r0=v0(A,1),u[e0+43|0]=r0,e0=k,r0=v0(A,3),u[e0+8240|0]=r0,e0=k,r0=v0(A,1),u[e0+15|0]=r0,e0=k,r0=v0(A,1),u[e0+16|0]=r0,r=f2(A),u[k+17|0]=r,(r|0)==-99999||(u[k+17|0]=r+1,r=f2(A),u[k+18|0]=r,(r|0)==-99999))break o;if(u[k+18|0]=r+1,r=o+(u[k+13|0]<<3)|0,n=i[r+728>>2],!n)break l;f=i[r+732>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[k+4>>2]=n,r=i[k+8>>2],i[k+8>>2]=f;s:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break s;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=q1(A),i[k+20>>2]=r,(r|0)==-99999)break o;i[k+20>>2]=r+26,e0=k,r0=v0(A,1),u[e0+24|0]=r0,e0=k,r0=v0(A,1),u[e0+25|0]=r0,r=v0(A,1),u[k+26|0]=r;s:{if(r&255){if(r=f2(A),i[k+28>>2]=r,(r|0)!=-99999)break s;break o}i[k+28>>2]=0}if(r=q1(A),i[k+32>>2]=r,(r|0)==-99999||(r=q1(A),i[k+36>>2]=r,(r|0)==-99999))break o;e0=k,r0=v0(A,1),u[e0+40|0]=r0,e0=k,r0=v0(A,1),u[e0+41|0]=r0,e0=k,r0=v0(A,1),u[e0+42|0]=r0,e0=k,r0=v0(A,1),u[e0+44|0]=r0,e0=k,r0=v0(A,1),u[e0+46|0]=r0,e0=k,r0=v0(A,1),u[e0+45|0]=r0;s:{w:{if(l[k+46|0]){if(r=f2(A),i[k+48>>2]=r,!((r|0)!=-99999&(r|0)<10)||(i[k+48>>2]=r+1,r=f2(A),i[k+52>>2]=r,!((r|0)!=-99999&(r|0)<10)))break o;if(i[k+52>>2]=r+1,r=v0(A,1),u[k+56|0]=r,!(r&255)){if(r=i[k+4>>2],f=i[r+16900>>2],n=i[r+16892>>2],h=i[k+48>>2],(h|0)>=2)for(r=0;;){if(_=w+(r<<2)|0,h=f2(A),i[_>>2]=h,(h|0)==-99999)break o;if(h=h+1|0,i[_>>2]=h,n=n-h|0,r=r+1|0,h=i[k+48>>2],!((r|0)<(h-1|0)))break}if((n|0)<=0)break s;if(i[(w+(h<<2)|0)-4>>2]=n,n=i[k+52>>2],(n|0)>=2)for(w=k+8320|0,r=0;;){if(h=w+(r<<2)|0,n=f2(A),i[h>>2]=n,(n|0)==-99999)break o;if(n=n+1|0,i[h>>2]=n,f=f-n|0,r=r+1|0,n=i[k+52>>2],!((r|0)<(n-1|0)))break}if((f|0)<=0)break s;i[(k+(n<<2)|0)+8316>>2]=f}r=v0(A,1);break w}u[k+56|0]=1,i[k+48>>2]=1,i[k+52>>2]=1,r=0}i[k+64>>2]=0,i[k+68>>2]=0,u[k+57|0]=r,e0=k,r0=v0(A,1),u[e0+58|0]=r0,r=v0(A,1),u[k+59|0]=r;w:{if(r&255){if(e0=k,r0=v0(A,1),u[e0+60|0]=r0,r=v0(A,1),u[k+61|0]=r,r&255)break w;if(r=q1(A),i[k- -64>>2]=r,(r|0)==-99999||(i[k+64>>2]=r<<1,r=q1(A),i[k+68>>2]=r,(r|0)==-99999))break o;i[k+68>>2]=r<<1;break w}Q[k+60>>1]=0}if(f=v0(A,1),u[k+72|0]=f,r=i[k+4>>2],n=f&255,!(l[r+636|0]|!n))break o;f=k+73|0;w:{if(n){if(r=n9(A,f),!r)break w;C2(o+4|0,r,0);break u}z(f,r+638|0,8160)}if(e0=k,r0=v0(A,1),u[e0+8233|0]=r0,r=f2(A),i[k+8236>>2]=r,(r|0)==-99999)break o;if(i[k+8236>>2]=r+2,f=i[k+4>>2],(r|0)>((i[f+612>>2]+i[f+616>>2]|0)-2|0))break s;e0=k,r0=v0(A,1),u[e0+8241|0]=r0,r=v0(A,1),u[k+8242|0]=r;w:{if(!(r&255)||(e0=k,r0=v0(A,1),u[e0+8243|0]=r0,e0=k,r0=v0(A,1),u[e0+8244|0]=r0,e0=k,r0=v0(A,6),u[e0+8245|0]=r0,!l[k+8243|0]))break w;r=k+8246|0,f=i[(o+(u[k+13|0]<<3)|0)+728>>2],l[k+25|0]&&(e0=r,r0=f2(A)+2|0,u[e0|0]=r0),n=v0(A,1),u[r+1|0]=(n|0)!=0,!n|i[f+16848>>2]==3||C2(o+4|0,1006,0),n=v0(A,1),u[r+2|0]=(n|0)!=0;_:{h:{B:{v:{if(!(i[f+16848>>2]|!n)){if(C2(o+4|0,1006,0),u[r+2|0]&1)break v;break B}if(!n)break B}if(n=f2(A),!((n|0)!=-99999&(n|0)<=i[f+616>>2])||(u[r+3|0]=n,n=f2(A),!((n|0)!=-99999&(n|0)<6)))break h;if(n=(n&255)+1|0,u[r+4|0]=n,(n|0)!=(n&255))break B;for(w=r+11|0,h=r+5|0,n=0;;){if(_=q1(A),_-13>>>0<=4294967270||(u[n+h|0]=_,_=q1(A),_-13>>>0<=4294967270))break h;if(u[n+w|0]=_,n=n+1|0,!(n>>>0<l[r+4|0]))break}}B:{if(n=f2(A),(n|0)!=-99999&&(w=i[f+16832>>2],(n|0)<=(((w|0)<=10?10:w)-10|0)))break B;break h}u[r+17|0]=n;B:{if(A=f2(A),(A|0)!=-99999&&(f=i[f+16840>>2],(A|0)<=(((f|0)<=10?10:f)-10|0)))break B;break h}u[r+18|0]=A,A=1;break _}C2(o+4|0,1006,0),A=0}if(!A)break s}f=0,r=v,A0=r,w=i[k+4>>2],A=i[w+16876>>2],i[k+8276>>2]=l[k+8246|0],i[k+8268>>2]=A-i[k+28>>2],i[k+8272>>2]=A-l[k+8249|0],h=i[k+48>>2];w:{if(!l[k+56|0])break w;_=r-((h<<2)+19&-16)|0,v=_;_:{if((h|0)<0)break _;if(A=i[w+16892>>2],h)for(n=h+1&-2,r=0;i[_+(f<<2)>>2]=(G(A,f)|0)/(h|0),g=f|1,i[_+(g<<2)>>2]=(G(A,g)|0)/(h|0),f=f+2|0,r=r+2|0,(n|0)!=(r|0););h&1||(i[_+(f<<2)>>2]=(G(A,f)|0)/(h|0)),V=h&3,g=k+8280|0,r=i[_>>2];h:{if(h-1>>>0<3){f=0;break h}for(C=h&2147483644,f=0,n=0;A=f<<2,S=A|4,W=i[S+_>>2],i[A+g>>2]=W-r,I=g+S|0,r=A|8,S=i[r+_>>2],i[I>>2]=S-W,A=A|12,W=i[A+_>>2],i[r+g>>2]=W-S,f=f+4|0,r=i[_+(f<<2)>>2],i[A+g>>2]=r-W,n=n+4|0,(C|0)!=(n|0););}if(!V)break _;for(;n=g+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(V|0)!=(s|0););}if(f=0,A=i[k+52>>2],_=_-((A<<2)+19&-16)|0,v=_,(A|0)<0)break w;if(n=i[w+16900>>2],A)for(s=A+1&-2,r=0;i[_+(f<<2)>>2]=(G(f,n)|0)/(A|0),g=f|1,i[_+(g<<2)>>2]=(G(n,g)|0)/(A|0),f=f+2|0,r=r+2|0,(s|0)!=(r|0););A&1||(i[_+(f<<2)>>2]=(G(f,n)|0)/(A|0)),V=A&3,g=k+8320|0,r=i[_>>2],s=0;_:{if(A-1>>>0<3){f=0;break _}for(C=A&2147483644,f=0,n=0;A=f<<2,S=A|4,W=i[S+_>>2],i[A+g>>2]=W-r,I=g+S|0,r=A|8,S=i[r+_>>2],i[I>>2]=S-W,A=A|12,W=i[A+_>>2],i[r+g>>2]=W-S,f=f+4|0,r=i[_+(f<<2)>>2],i[A+g>>2]=r-W,n=n+4|0,(C|0)!=(n|0););}if(!V)break w;for(;n=g+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(V|0)!=(s|0););}i[k+8360>>2]=0,_=k+8360|0;w:{if((h|0)<=0)break w;if(s=k+8280|0,A=0,h>>>0>=4)for(f=h&2147483644,n=0;r=A<<2,g=r|4,B=i[r+s>>2]+B|0,i[g+_>>2]=B,V=r|8,B=B+i[s+g>>2]|0,i[V+_>>2]=B,r=r|12,B=B+i[s+V>>2]|0,i[r+_>>2]=B,A=A+4|0,B=B+i[r+s>>2]|0,i[_+(A<<2)>>2]=B,n=n+4|0,(f|0)!=(n|0););if(n=h&3,!n)break w;for(r=0;f=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[_+(f<<2)>>2]=B,A=f,r=r+1|0,(n|0)!=(r|0););}i[k+8404>>2]=0,h=k+8404|0,r=i[k+52>>2];w:{if((r|0)<=0)break w;if(s=k+8320|0,n=0,B=0,A=0,r>>>0>=4)for(V=r&2147483644,f=0;g=A<<2,W=g|4,B=i[s+g>>2]+B|0,i[W+h>>2]=B,C=g|8,B=B+i[s+W>>2]|0,i[C+h>>2]=B,g=g|12,B=B+i[s+C>>2]|0,i[g+h>>2]=B,A=A+4|0,B=B+i[s+g>>2]|0,i[h+(A<<2)>>2]=B,f=f+4|0,(V|0)!=(f|0););if(f=r&3,!f)break w;for(;r=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[h+(r<<2)>>2]=B,A=r,n=n+1|0,(f|0)!=(n|0););}S=k+8448|0,A=i[w+16908>>2],f=i[k+8448>>2],r=i[k+8452>>2]-f>>2;w:{if(A>>>0>r>>>0){I8(S,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8452>>2]=f+(A<<2)}f=i[k+8460>>2],r=i[k+8464>>2]-f>>2;w:{if(r>>>0<A>>>0){I8(k+8460|0,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8464>>2]=f+(A<<2)}N=k+8472|0,f=i[k+8472>>2],r=i[k+8476>>2]-f>>2;w:{if(r>>>0<A>>>0){I8(N,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8476>>2]=f+(A<<2)}x=k+8484|0,f=i[k+8484>>2],r=i[k+8488>>2]-f>>2;w:{if(r>>>0<A>>>0){I8(x,A-r|0);break w}if(A>>>0>=r>>>0)break w;i[k+8488>>2]=f+(A<<2)}$=k+8496|0,A=i[w+16932>>2],f=i[k+8496>>2],r=i[k+8500>>2]-f>>2;w:{if(A>>>0>r>>>0){I8($,A-r|0);break w}if(A>>>0>=r>>>0)break w;i[k+8500>>2]=f+(A<<2)}if(i[w+16908>>2]>0)for(y=k+8280|0,I=k+8320|0,m0=i[k+8460>>2],a=i[k+8448>>2],r=0;;){A=i[w+16892>>2],g=(r|0)/(A|0)|0,V=r-G(A,g)|0,s=-1,n=i[k+48>>2];w:{if((n|0)<=0)break w;if(f=0,A=0,n>>>0>=4)for(W=n&2147483644,B=0;D=(V|0)<i[_+(A<<2)>>2]?s:A,s=A|1,D=(V|0)<i[_+(s<<2)>>2]?D:s,s=A|2,D=(V|0)<i[_+(s<<2)>>2]?D:s,s=A|3,s=(V|0)<i[_+(s<<2)>>2]?D:s,A=A+4|0,B=B+4|0,(W|0)!=(B|0););if(n=n&3,!n)break w;for(;s=(V|0)<i[_+(A<<2)>>2]?s:A,A=A+1|0,f=f+1|0,(n|0)!=(f|0););}W=i[k+52>>2];w:{if((W|0)<=0){n=-1;break w}if(n=-1,f=0,A=0,W>>>0>=4)for(C=W&2147483644,B=0;D=(g|0)<i[h+(A<<2)>>2]?n:A,n=A|1,D=(g|0)<i[h+(n<<2)>>2]?D:n,n=A|2,D=(g|0)<i[h+(n<<2)>>2]?D:n,n=A|3,n=(g|0)<i[h+(n<<2)>>2]?D:n,A=A+4|0,B=B+4|0,(C|0)!=(B|0););if(B=W&3,!B)break w;for(;n=(g|0)<i[h+(A<<2)>>2]?n:A,A=A+1|0,f=f+1|0,(B|0)!=(f|0););}f=0,A=a+(r<<2)|0,i[A>>2]=0;w:{if((s|0)<=0)break w;if(W=I+(n<<2)|0,C=0,B=0,s>>>0>=4)for(h0=s&2147483644,R=0;D=f,f=y+(B<<2)|0,D=D+G(i[f>>2],i[W>>2])|0,i[A>>2]=D,D=D+G(i[f+4>>2],i[W>>2])|0,i[A>>2]=D,D=D+G(i[f+8>>2],i[W>>2])|0,i[A>>2]=D,f=D+G(i[f+12>>2],i[W>>2])|0,i[A>>2]=f,B=B+4|0,R=R+4|0,(h0|0)!=(R|0););if(R=s&3,!R)break w;for(;f=G(i[y+(B<<2)>>2],i[W>>2])+f|0,i[A>>2]=f,B=B+1|0,C=C+1|0,(R|0)!=(C|0););}w:{if((n|0)<=0)break w;R=n&3,W=0;_:{if(n>>>0<4){B=0;break _}for(h0=n&2147483644,B=0,C=0;D=f,f=I+(B<<2)|0,D=D+G(i[f>>2],i[w+16892>>2])|0,i[A>>2]=D,D=D+G(i[f+4>>2],i[w+16892>>2])|0,i[A>>2]=D,D=D+G(i[f+8>>2],i[w+16892>>2])|0,i[A>>2]=D,f=D+G(i[f+12>>2],i[w+16892>>2])|0,i[A>>2]=f,B=B+4|0,C=C+4|0,(h0|0)!=(C|0););}if(!R)break w;for(;f=G(i[I+(B<<2)>>2],i[w+16892>>2])+f|0,i[A>>2]=f,B=B+1|0,W=W+1|0,(R|0)!=(W|0););}if((n|s)<0&&(M0(21984,18206,620,5221),H()),B=f,f=s<<2,n=B+G(i[f+y>>2],g-i[h+(n<<2)>>2]|0)|0,i[A>>2]=n,s=A,A=n+(V-i[f+_>>2]|0)|0,i[s>>2]=A,i[m0+(A<<2)>>2]=r,r=r+1|0,!((r|0)<i[w+16908>>2]))break}f=i[k+52>>2];w:{if((f|0)<=0||(B=0,A=i[k+48>>2],(A|0)<=0))break w;for(s=0;;){_:{if((A|0)<=0){s=s+1|0;break _}if(n=0,g=h+(s<<2)|0,s=s+1|0,C=h+(s<<2)|0,W=i[C>>2],(W|0)<=i[g>>2]){B=((A|0)<=1?1:A)+B|0;break _}for(;;){f=i[g>>2];h:{if((W|0)<=(f|0)){n=n+1|0;break h}if(V=_+(n<<2)|0,n=n+1|0,y=_+(n<<2)|0,r=i[y>>2],(r|0)<=i[V>>2])break h;for(I=i[x>>2],R=i[N>>2],m0=i[S>>2];;){if(A=i[V>>2],(r|0)>(A|0)){for(;r=A<<2,i[R+(i[r+(m0+(G(i[w+16892>>2],f)<<2)|0)>>2]<<2)>>2]=B,i[r+(I+(G(i[w+16892>>2],f)<<2)|0)>>2]=B,A=A+1|0,r=i[y>>2],(A|0)<(r|0););W=i[C>>2]}if(f=f+1|0,!((W|0)>(f|0)))break}A=i[k+48>>2]}if(B=B+1|0,!((A|0)>(n|0)))break}f=i[k+52>>2]}if(!((f|0)>(s|0)))break}}f=i[w+16928>>2];w:{if((f|0)<=0||(n=0,A=i[w+16924>>2],(A|0)<=0))break w;for(_=i[$>>2],g=i[S>>2];;){if(r=0,(A|0)>0){for(;;){V=_+(r<<2)|0,s=V+(G(A,n)<<2)|0,A=i[w+16936>>2],f=i[w+16876>>2],i[s>>2]=i[(g+(G(i[w+16892>>2],n<<A>>f)<<2)|0)+(r<<A>>f<<2)>>2]<<(f-A<<1),s=i[w+16876>>2],B=i[w+16936>>2],h=s-B|0;_:{if((h|0)<=0){f=0;break _}if(A=0,f=0,(s|0)!=(B+1|0))for(W=h&2147483646,s=0;C=A|1,B=2<<A,I=f,f=1<<A,f=((B&n?4<<A<<C:0)+((I+(f&n?B<<A:0)|0)+(r&f?f<<A:0)|0)|0)+(r&B?B<<C:0)|0,A=A+2|0,s=s+2|0,(W|0)!=(s|0););if(!(h&1))break _;s=f,f=1<<A,f=(s+(f&n?2<<A<<A:0)|0)+(r&f?f<<A:0)|0}if(A=V+(G(i[w+16924>>2],n)<<2)|0,i[A>>2]=i[A>>2]+f,A=i[w+16924>>2],r=r+1|0,!((A|0)>(r|0)))break}f=i[w+16928>>2]}if(n=n+1|0,!((n|0)<(f|0)))break}}v=A0,u[k|0]=1,s=1}break u}C2(o+4|0,1010,0);break u}C2(o+4|0,1006,0)}u:{if(!s)break u;if(t=0,s=i[o+524>>2],(s|0)>=0){f=0,A=v-720|0,v=A,r=67604;o:{l:switch(s-1|0){case 1:r=67600;break;case 0:break l;default:break o}if(r=i[r>>2],k0(r,42172,0),i[A+704>>2]=u[k+12|0],k0(r,39035,A+704|0),i[A+688>>2]=u[k+13|0],k0(r,39002,A+688|0),i[A+672>>2]=u[k+14|0],k0(r,35900,A+672|0),i[A+656>>2]=u[k+15|0],k0(r,38615,A+656|0),i[A+640>>2]=u[k+16|0],k0(r,37696,A+640|0),i[A+624>>2]=u[k+17|0],k0(r,36428,A+624|0),i[A+608>>2]=u[k+18|0],k0(r,36392,A+608|0),i[A+592>>2]=i[k+20>>2],k0(r,40914,A+592|0),i[A+576>>2]=u[k+24|0],k0(r,34489,A+576|0),i[A+560>>2]=u[k+25|0],k0(r,34570,A+560|0),i[A+544>>2]=u[k+26|0],k0(r,37180,A+544|0),l[k+26|0]&&(i[A+528>>2]=i[k+28>>2],k0(r,37976,A+528|0)),i[A+512>>2]=i[k+32>>2],k0(r,40365,A+512|0),i[A+496>>2]=i[k+36>>2],k0(r,40330,A+496|0),i[A+480>>2]=u[k+40|0],k0(r,34989,A+480|0),i[A+464>>2]=u[k+41|0],k0(r,39941,A+464|0),i[A+448>>2]=u[k+42|0],k0(r,39486,A+448|0),i[A+432>>2]=u[k+43|0],k0(r,38009,A+432|0),i[A+416>>2]=u[k+44|0],k0(r,34454,A+416|0),i[A+400>>2]=u[k+46|0],k0(r,40022,A+400|0),i[A+384>>2]=u[k+45|0],k0(r,34648,A+384|0),l[k+46|0]){if(i[A+368>>2]=i[k+48>>2],k0(r,37560,A+368|0),i[A+352>>2]=i[k+52>>2],k0(r,38824,A+352|0),i[A+336>>2]=u[k+56|0],k0(r,34428,A+336|0),k0(r,30218,0),i[k+48>>2]>=0)for(n=k+8360|0;i[A+320>>2]=i[n+(f<<2)>>2],k0(r,29206,A+320|0),B=i[k+48>>2]>(f|0),f=f+1|0,!!B;);if(f=0,k0(r,42366,0),k0(r,30196,0),i[k+52>>2]>=0)for(n=k+8404|0;i[A+304>>2]=i[n+(f<<2)>>2],k0(r,29206,A+304|0),B=i[k+52>>2]>(f|0),f=f+1|0,!!B;);k0(r,42366,0),i[A+288>>2]=u[k+57|0],k0(r,35944,A+288|0)}if(i[A+272>>2]=u[k+58|0],k0(r,34522,A+272|0),i[A+256>>2]=u[k+59|0],k0(r,34232,A+256|0),l[k+59|0]&&(i[A+240>>2]=u[k+60|0],k0(r,34603,A+240|0),i[A+224>>2]=u[k+61|0],k0(r,34352,A+224|0),i[A+208>>2]=i[k+64>>2],k0(r,41543,A+208|0),i[A+192>>2]=i[k+68>>2],k0(r,41561,A+192|0)),i[A+176>>2]=u[k+72|0],k0(r,34312,A+176|0),i[A+160>>2]=u[k+8233|0],k0(r,34195,A+160|0),i[A+144>>2]=i[k+8236>>2],k0(r,38337,A+144|0),i[A+128>>2]=u[k+8240|0],k0(r,37490,A+128|0),i[A+112>>2]=u[k+8241|0],k0(r,35315,A+112|0),i[A+96>>2]=u[k+8242|0],k0(r,40174,A+96|0),i[A+80>>2]=u[k+8243|0],k0(r,38533,A+80|0),i[A+64>>2]=u[k+8244|0],k0(r,35490,A- -64|0),i[A+48>>2]=u[k+8245|0],k0(r,39905,A+48|0),i[A+32>>2]=i[k+8268>>2],k0(r,39748,A+32|0),i[A+16>>2]=i[k+8272>>2],k0(r,36704,A+16|0),i[A>>2]=i[k+8276>>2],k0(r,36745,A),!l[k+8243|0])break o;f=k+8246|0,r=v-144|0,v=r,n=67604;l:switch(s-1|0){case 1:n=67600;case 0:s=i[n>>2],k0(s,42297,0),i[r+128>>2]=l[f|0],k0(s,38778,r+128|0),i[r+112>>2]=l[f+1|0],k0(s,36077,r+112|0),i[r+96>>2]=l[f+2|0],k0(s,38648,r+96|0);s:{if(l[f+2|0]!=1||(i[r+80>>2]=l[f+3|0],k0(s,39658,r+80|0),i[r+64>>2]=l[f+4|0],k0(s,40758,r- -64|0),!l[f+4|0]))break s;for(B=f+11|0,w=f+5|0,n=0;i[r+52>>2]=u[n+w|0],i[r+48>>2]=n,k0(s,41272,r+48|0),i[r+36>>2]=u[n+B|0],i[r+32>>2]=n,k0(s,41225,r+32|0),n=n+1|0,n>>>0<l[f+4|0];);}i[r+16>>2]=l[f+17|0],k0(s,40646,r+16|0),i[r>>2]=l[f+18|0],k0(s,40210,r);break;default:break l}v=r+144|0}v=A+720|0}if(i[m+4>>2]=i[m+4>>2]+1,r=o+(u[m+24|0]<<3)|0,i[r+856>>2]=k,A=i[r+860>>2],i[r+860>>2]=m,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[m+4>>2],i[m+4>>2]=A-1,A||(X[i[i[m>>2]+8>>2]](m),p(m)),r=t,F4(o+548|0,O);break n;case 7:case 8:n=L+8|0,s=(f|0)==40,f=0,t=0,o=v-80|0,v=o;u:{for(k=i[A+1376>>2];r=v0(n,8),f=r+f|0,(r|0)==255;);for(;r=v0(n,8),t=r+t|0,(r|0)==255;);i[o+4>>2]=t,i[o>>2]=f,r=0;o:{if((f|0)!=132||(e0=o,r0=v0(n,8),i[e0+8>>2]=r0,r=1025,!k))break o;for(f=o+27|0,B=o+26|0,w=o+25|0,h=o+24|0,_=o+23|0,m=o+22|0,g=o+21|0,V=o+20|0,W=o+19|0,C=o+18|0,S=o+17|0,y=o+16|0,I=o+15|0,N=o+14|0,x=o+13|0,$=o+12|0,R=o+60|0,A0=o+68|0,k=i[k+476>>2],t=0;;){l:{s:switch(i[o+8>>2]){case 0:r=t<<4,e0=r+$|0,r0=v0(n,8),u[e0|0]=r0,e0=r+x|0,r0=v0(n,8),u[e0|0]=r0,e0=r+N|0,r0=v0(n,8),u[e0|0]=r0,e0=r+I|0,r0=v0(n,8),u[e0|0]=r0,e0=r+y|0,r0=v0(n,8),u[e0|0]=r0,e0=r+S|0,r0=v0(n,8),u[e0|0]=r0,e0=r+C|0,r0=v0(n,8),u[e0|0]=r0,e0=r+W|0,r0=v0(n,8),u[e0|0]=r0,e0=r+V|0,r0=v0(n,8),u[e0|0]=r0,e0=r+g|0,r0=v0(n,8),u[e0|0]=r0,e0=r+m|0,r0=v0(n,8),u[e0|0]=r0,e0=r+_|0,r0=v0(n,8),u[e0|0]=r0,e0=r+h|0,r0=v0(n,8),u[e0|0]=r0,e0=r+w|0,r0=v0(n,8),u[e0|0]=r0,e0=r+B|0,r0=v0(n,8),u[e0|0]=r0,e0=r+f|0,r0=v0(n,8),u[e0|0]=r0;break l;case 1:e0=R+(t<<1)|0,r0=v0(n,16),Q[e0>>1]=r0;break l;case 2:break s;default:break l}e0=A0+(t<<2)|0,r0=v0(n,32),i[e0>>2]=r0}if(!(k&&(r=t>>>0<2,t=t+1|0,r)))break}r=0}o:{if(!r){if(!s||(f=i[A+3212>>2],(f|0)==i[A+3208>>2]))break o;if(k=i[f-4>>2],f=i[k+440>>2],s=i[k+444>>2],f>>>0<s>>>0){z(f,o,80),i[k+440>>2]=f+80;break o}if(t=i[k+436>>2],f=f-t|0,n=((f|0)/80|0)+1|0,n>>>0>=53687092)break i;if(s=(s-t|0)/80|0,B=s<<1,s=s>>>0>=26843545?53687091:n>>>0<B>>>0?B:n,s){if(s>>>0>=53687092)break e;n=E(G(s,80))}else n=0;B=n+f|0,z(B,o,80),w=B+G((f|0)/-80|0,80)|0,f&&z(w,t,f),i[k+444>>2]=n+G(s,80),f=B+80|0,i[k+440>>2]=f,i[k+436>>2]=w,t&&Z(t),i[k+440>>2]=f;break o}if(f=i[A+84>>2],(f|0)==20){i[A+80>>2]=1001;break o}i[A+84>>2]=f+1,i[((f<<2)+A|0)+4>>2]=r}v=o+80|0;break u}F4(A+548|0,O);break n;case 4:u[A+2203|0]=1,F4(A+548|0,O);break n;default:break t}F4(A+548|0,O)}v=L+32|0,u[W0+15|0]=1;break k}if(!(l[A+549|0]!=1|i[A+3208>>2]!=i[A+3212>>2])){if(r=13,A=1,e)break A;break f}r=y7(A,W0+15|0)}if(!e)break f;A=r?0:l[W0+15|0]}i[e>>2]=A}return v=W0+16|0,r}M0(10152,18166,1331,15119),H()}x0(),H()}G0(),H()}function I6(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-336|0,v=n,i[n+304>>2]=0,i[n+308>>2]=0,i[n+312>>2]=0,i[n+316>>2]=0,i[n+320>>2]=0,i[n+296>>2]=0,i[n+300>>2]=0,i[n+288>>2]=86404,$6(n+264|0,n+288|0,e);i:{if(i[n+264>>2]){e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+280>>2]=0,i[n+272>>2]=0,i[n+276>>2]=0;break i}if(l[e+20|0]==1){if(u[n+72|0]=0,u[n+83|0]=0,K(A,2,100,n+72|0),u[n+83|0]>=0)break i;Z(i[n+72>>2]);break i}k=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0;e:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break e;X[i[i[k>>2]+8>>2]](k),p(k)}i[n+256>>2]=0,i[n+260>>2]=0;e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{W:{X:{C:{I:{F:{Q:{V:{p:{M:{U:{D:{J:{E:{y:{$:{Y:{H:{x:{z:{T:{R:{S:{j:{O:{L:{P:{q:{K:{_0:{d:{v0:{c:{b:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{m0:{u0:{o0:{l0:{s0:{w0:{N:{a:{h0:{k=i[n+304>>2];Z0:{if((k|0)<=1781689192){if((k|0)<=1701604966){if((k|0)<=1667523941){if((k|0)<=1635135536){if((k|0)<=1634563684){if((k|0)==1630628984)break O;if((k|0)==1630629744)break L;if((k|0)!=1634497650)break f;k=E(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=91012,t=k+16|0,o0(t,0,104),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=88360,i[k+128>>2]=0,i[k+132>>2]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1634563685)break R;if((k|0)==1635088451)break k0;if((k|0)!=1635088489)break f;k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105468,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93692,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1635088489,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1635148592){if((k|0)==1635135537)break i0;if((k|0)!=1635135811)break f;k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=98128,Q[k+114>>1]=0,Q[k+116>>1]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=90572,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=256,u[k+121|0]=0,u[k+122|0]=0,u[k+123|0]=0,u[k+124|0]=0,i[k+32>>2]=1635135811,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}g:switch(k-1635148593|0){case 0:break p;case 18:break M;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break f;default:break g}if((k|0)==1651798644)break o;if((k|0)!=1667462004)break f;k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,u[k+122|0]=0,u[k+120|0]=0,u[k+121|0]=0,i[k+16>>2]=105388,i[k>>2]=93652,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1667462004,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1668114797){if((k|0)<=1668050024){if((k|0)==1667523942)break y;if((k|0)!=1668047216)break f;k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+140>>2]=0,i[k+144>>2]=1,i[k+132>>2]=0,i[k+136>>2]=1,i[k+124>>2]=0,i[k+128>>2]=1,i[k+116>>2]=0,i[k+120>>2]=1,i[k>>2]=90332,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88040,i[k+32>>2]=1668047216,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1668050025)break j;if((k|0)==1668112752)break E;if((k|0)!=1668113784)break f;bn(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1684631141){if((k|0)==1668114798)break T;if((k|0)==1668246642)break P;if((k|0)!=1668576371)break f;k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104988,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93452,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1668576371,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1684631142)break _0;if((k|0)==1685218662)break K;if((k|0)!=1701082227)break f;k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93732,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93772,i[k+32>>2]=1701082227,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1768778097){if((k|0)<=1752589104){if((k|0)<=1718909295){if((k|0)==1701604967)break Y;if((k|0)==1701606260)break w;if((k|0)==1718773093)break Z0;break f}if((k|0)==1718909296)break w0;if((k|0)==1735553132)break v0;if((k|0)!=1751411826)break f;k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=1885954932,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=89852,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87172,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1751411826,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1768517221)switch(k-1752589105|0){case 0:break e0;case 18:break r0;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break f;default:break A}if((k|0)==1768517222)break o0;if((k|0)!=1768714083)break f;k=E(176),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k>>2]=89932,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=86432,u[k+133|0]=0,u[k+134|0]=0,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,u[k+139|0]=0,u[k+140|0]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1768714083,u[k+148|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1769107315){if((k|0)<=1768975712){if((k|0)==1768778098)break f0;if((k|0)==1768842853)break u0;if((k|0)!=1768973167)break f;k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90092,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87572,i[k+32>>2]=1768973167,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1768975713)break t0;if((k|0)==1768977008)break m0;if((k|0)!=1769104742)break f;k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90372,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=88120,i[k+32>>2]=1769104742,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1781689159){if((k|0)==1769107316)break A0;if((k|0)==1769173093)break n0;if((k|0)!=1769234793)break f;k=E(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92252,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=89492,i[k+32>>2]=1769234793,i[k+128>>2]=0,i[k+132>>2]=0,u[k+120|0]=1,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}switch(k-1781689160|0){case 0:break $;case 4:break D;default:break f}}if((k|0)<=1936158819){if((k|0)<=1836476515){if((k|0)<=1835297120){if((k|0)<=1835295091){if((k|0)==1781689193)break U;if((k|0)==1785751363)break x;if((k|0)!=1819501932)break f;k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+114>>1]=0,i[k>>2]=91332,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=89e3,i[k+32>>2]=1819501932,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1835295092)break V;if((k|0)==1835295606)break S;if((k|0)!=1835296868)break f;k=E(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104588,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93052,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1835296868,u[k+152|0]=117,u[k+153|0]=110,u[k+154|0]=107,u[k+155|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1835692134){if((k|0)==1835297121)break W;if((k|0)==1835365473)break s0;if((k|0)!=1835626086)break f;k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93092,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93132,i[k+32>>2]=1835626086,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1835692135)break H;if((k|0)==1836019574)break F;if((k|0)!=1836280643)break f;k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,u[k+120|0]=0,i[k+16>>2]=100360,i[k>>2]=92212,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1836280643,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1887006051){if((k|0)<=1885564017){if((k|0)==1836476516)break I;if((k|0)==1852663908)break k;if((k|0)!=1885434736)break f;k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+120>>2]=1,i[k>>2]=91292,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88920,i[k+32>>2]=1885434736,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1885564018)break J;if((k|0)==1885959277)break l0;if((k|0)!=1885960297)break f;k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91252,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=88840,i[k+32>>2]=1885960297,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1935828847)switch(k-1935763823|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:break f;case 0:break t;case 11:break u;default:break d}if((k|0)==1935828848)break s;if((k|0)!=1935963248)break f;k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=106236,i[k>>2]=94252,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1935963248,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)>1953196131)break N;if((k|0)>1937011554)break a;if((k|0)>1937007211)break h0;if((k|0)==1936158820)break l;if((k|0)!=1936419184)break f}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89812,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87012,i[k+32>>2]=1718773093,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1937007212)break m;if((k|0)==1937007471)break B;if((k|0)!=1937007986)break f;k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91052,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=88440,i[k+32>>2]=1937007986,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;h0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break h0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}a:switch(k-1937011555|0){case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 17:case 18:case 19:case 20:case 21:case 22:break f;case 0:break v;case 1:break G;case 16:break _;case 23:break h;default:break a}if((k|0)==1937011827)break Z;if((k|0)!=1952541027)break f;k=E(152),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92292,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=89424,i[k+32>>2]=1952541027,u[k+144|0]=0,i[k+136>>2]=0,i[k+140>>2]=2147483647,i[k+128>>2]=-1,i[k+132>>2]=-1,u[k+120|0]=1,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;a:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break a;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)<=1970433055){if((k|0)<=1969513842){if((k|0)==1953196132)break X;if((k|0)==1953653099)break C;if((k|0)!=1953654118)break f;k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=106316,i[k>>2]=94212,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1953654118,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;N:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break N;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1969513843)break z;if((k|0)==1970432288)break n;if((k|0)!=1970432365)break f;k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105628,i[k>>2]=94092,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1970432365,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1987470128){if((k|0)==1970433056)break q;if((k|0)==1970628964)break Q;if((k|0)!=1986881636)break f;k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=104668,i[k+116>>2]=1,i[k>>2]=93212,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1986881636,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;N:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break N;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if(t=k-1987470129|0,!t)break c;if((t|0)==18)break b;break f}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=89772,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86932,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+32>>2]=1718909296,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;w0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break w0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89732,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87092,i[k+32>>2]=1835365473,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;s0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break s0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=89892,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87252,i[k+32>>2]=1885959277,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;l0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break l0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89972,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87412,i[k+32>>2]=1768517222,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;o0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break o0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(184),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+124>>1]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=90012,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87332,u[k+173|0]=0,u[k+174|0]=0,u[k+175|0]=0,u[k+176|0]=0,u[k+177|0]=0,u[k+178|0]=0,u[k+179|0]=0,u[k+180|0]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1768842853,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;u0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break u0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90052,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87492,i[k+32>>2]=1768977008,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90132,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87720,i[k+32>>2]=1768975713,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;t0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break t0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}at(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;n0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break n0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90212,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87800,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1635088451,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;k0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=90252,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87880,i[k+32>>2]=1769107316,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;A0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break A0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=90292,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87960,i[k+32>>2]=1768778098,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;f0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break f0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+156>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,u[k+145|0]=4,i[k+124>>2]=0,i[k+128>>2]=0,i[k+16>>2]=97552,i[k>>2]=90412,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1752589123,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;r0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break r0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=90452,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90492,i[k+32>>2]=1752589105,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;e0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break e0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=90612,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90652,i[k+32>>2]=1635135537,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;i0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break i0;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+120>>1]=259,i[k+16>>2]=99864,i[k+136>>2]=0,i[k+140>>2]=0,i[k>>2]=90732,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0,i[k+200>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+32>>2]=1987470147,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;b:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break b;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=90772,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90812,i[k+32>>2]=1987470129,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;c:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break c;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90932,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88280,i[k+32>>2]=1735553132,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)!=1887006052)break f;k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=90972,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=88520,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1887006052,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;d:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break d;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=91092,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88600,i[k+32>>2]=1684631142,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=91132,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=88680,i[k+32>>2]=1685218662,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;K:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break K;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+116>>2]=1,i[k>>2]=91172,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=88760,i[k+128>>2]=0,i[k+32>>2]=1970433056,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break q;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=95456,i[k>>2]=91212,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1668246642,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;P:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break P;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=98208,i[k>>2]=91372,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1630629744,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;L:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break L;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=98288,i[k>>2]=91412,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+124>>2]=0,i[k+32>>2]=1630628984,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;O:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break O;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+114>>1]=0,Q[k+116>>1]=0,i[k>>2]=91452,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=89080,i[k+32>>2]=1668050025,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;j:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break j;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91492,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86500,i[k+132>>2]=0,i[k+136>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+32>>2]=1835295606,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;S:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break S;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91532,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86568,i[k+32>>2]=1634563685,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;R:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break R;X[i[i[k>>2]+8>>2]](k),p(k)}break e}mt(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;T:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break T;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91652,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=89344,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+32>>2]=1969513843,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;z:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break z;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=98552,i[k>>2]=91692,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1785751363,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;x:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break x;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=91732,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=91772,i[k+32>>2]=1835692135,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;H:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break H;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91852,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=89640,i[k+128>>2]=0,i[k+32>>2]=1701604967,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Y:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Y;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=99464,i[k>>2]=91892,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1781689160,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99144,i[k>>2]=91932,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1667523942,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;y:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break y;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99224,i[k>>2]=91972,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1668112752,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;E:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break E;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99304,i[k>>2]=92012,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1885564018,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;J:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break J;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=99384,i[k>>2]=92052,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1781689164,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;D:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break D;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=92092,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=92132,i[k+32>>2]=1781689193,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;U:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break U;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+16>>2]=100160,Q[k+128>>1]=2056,i[k+124>>2]=1,i[k>>2]=92332,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,u[k+120|0]=0,i[k+164>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1635148611,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;M:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break M;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,Q[k+118>>1]=0,Q[k+120>>1]=0,Q[k+122>>1]=0,Q[k+124>>1]=0,Q[k+116>>1]=1,i[k>>2]=92372,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,Q[k+126>>1]=0,Q[k+128>>1]=0,Q[k+130>>1]=0,Q[k+132>>1]=0,Q[k+134>>1]=0,Q[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=92412,i[k+32>>2]=1635148593,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;p:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break p;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=92492,t=k+16|0,o0(t,0,104),i[k+52>>2]=0,i[k+56>>2]=0,i[k+16>>2]=86704,i[k+60>>2]=0,i[k+64>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0;break e}if($r(n+40|0,n+288|0),i[n+240>>2]=16,u[n+80|0]=157,u[n+81|0]=144,u[n+82|0]=78,u[n+83|0]=182,u[n+84|0]=236,u[n+85|0]=186,u[n+86|0]=243,u[n+87|0]=163,u[n+72|0]=34,u[n+73|0]=204,u[n+74|0]=4,u[n+75|0]=199,u[n+76|0]=214,u[n+77|0]=217,u[n+78|0]=78,u[n+79|0]=7,i[n+236>>2]=n+72,k=i[n+240>>2],i[n+24>>2]=i[n+236>>2],i[n+28>>2]=k,t=0,s=KA(n+244|0,n+24|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){mt(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if($r(n+40|0,n+288|0),i[n+232>>2]=16,u[n+80|0]=151,u[n+81|0]=174,u[n+82|0]=190,u[n+83|0]=166,u[n+84|0]=152,u[n+85|0]=3,u[n+86|0]=180,u[n+87|0]=52,u[n+72|0]=67,u[n+73|0]=99,u[n+74|0]=233,u[n+75|0]=20,u[n+76|0]=91,u[n+77|0]=125,u[n+78|0]=74,u[n+79|0]=171,i[n+228>>2]=n+72,k=i[n+232>>2],i[n+16>>2]=i[n+228>>2],i[n+20>>2]=k,t=0,s=KA(n+244|0,n+16|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){bn(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if($r(n+40|0,n+288|0),i[n+224>>2]=16,u[n+80|0]=172,u[n+81|0]=189,u[n+82|0]=157,u[n+83|0]=44,u[n+84|0]=142,u[n+85|0]=167,u[n+86|0]=53,u[n+87|0]=34,u[n+72|0]=38,u[n+73|0]=30,u[n+74|0]=243,u[n+75|0]=116,u[n+76|0]=29,u[n+77|0]=151,u[n+78|0]=91,u[n+79|0]=186,i[n+220>>2]=n+72,k=i[n+224>>2],i[n+8>>2]=i[n+220>>2],i[n+12>>2]=k,t=0,s=KA(n+244|0,n+8|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){t=E(128),i[t+24>>2]=0,i[t+28>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+88>>2]=0,i[t+92>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[t>>2]=92532,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+60>>2]=0,i[t- -64>>2]=0,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,u[t+112|0]=0,i[t+16>>2]=89560,i[t+124>>2]=0,o=E(16),u[o|0]=38,u[o+1|0]=30,u[o+2|0]=243,u[o+3|0]=116,u[o+4|0]=29,u[o+5|0]=151,u[o+6|0]=91,u[o+7|0]=186,u[o+8|0]=172,u[o+9|0]=189,u[o+10|0]=157,u[o+11|0]=44,u[o+12|0]=142,u[o+13|0]=167,u[o+14|0]=53,u[o+15|0]=34,i[t+32>>2]=1970628964,k=E(16),i[t+36>>2]=k,h=k+16|0,i[t+44>>2]=h,s=l[o+12|0]|l[o+13|0]<<8|(l[o+14|0]<<16|l[o+15|0]<<24),w=l[o+8|0]|l[o+9|0]<<8|(l[o+10|0]<<16|l[o+11|0]<<24),u[k+8|0]=w,u[k+9|0]=w>>>8,u[k+10|0]=w>>>16,u[k+11|0]=w>>>24,u[k+12|0]=s,u[k+13|0]=s>>>8,u[k+14|0]=s>>>16,u[k+15|0]=s>>>24,s=l[o+4|0]|l[o+5|0]<<8|(l[o+6|0]<<16|l[o+7|0]<<24),w=l[o|0]|l[o+1|0]<<8|(l[o+2|0]<<16|l[o+3|0]<<24),u[k|0]=w,u[k+1|0]=w>>>8,u[k+2|0]=w>>>16,u[k+3|0]=w>>>24,u[k+4|0]=s,u[k+5|0]=s>>>8,u[k+6|0]=s>>>16,u[k+7|0]=s>>>24,i[t+40>>2]=h,Z(o),i[n+76>>2]=t,i[n+72>>2]=t+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;X[i[i[k>>2]+8>>2]](k),p(k)}break e}i[n+40>>2]=1970628964,dt(n+72|0,n+40|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92612,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92652,i[k+32>>2]=1836019574,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(200),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104428,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=92732,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,Q[k+156>>1]=256,i[k+152>>2]=65536,i[k+196>>2]=0,i[k+32>>2]=1836476516,t=i[11793],i[k+160>>2]=i[11792],i[k+164>>2]=t,t=i[11795],i[k+168>>2]=i[11794],i[k+172>>2]=t,t=i[11797],i[k+176>>2]=i[11796],i[k+180>>2]=t,t=i[11799],i[k+184>>2]=i[11798],i[k+188>>2]=t,i[k+192>>2]=i[11800],i[n+72>>2]=k+16,i[n+76>>2]=k,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;I:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break I;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92772,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92812,i[k+32>>2]=1953653099,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104508,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=92892,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,Q[k+156>>1]=256,i[k+196>>2]=0,i[k+200>>2]=0,i[k+116>>2]=7,i[k+32>>2]=1953196132,i[k+192>>2]=i[11800],t=i[11799],i[k+184>>2]=i[11798],i[k+188>>2]=t,t=i[11797],i[k+176>>2]=i[11796],i[k+180>>2]=t,t=i[11795],i[k+168>>2]=i[11794],i[k+172>>2]=t,t=i[11793],i[k+160>>2]=i[11792],i[k+164>>2]=t,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;X:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break X;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92932,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92972,i[k+32>>2]=1835297121,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93252,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93292,i[k+32>>2]=1937007212,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=104828,i[k>>2]=93372,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1937011556,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;G:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break G;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104908,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93412,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011827,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Z:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Z;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105068,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93492,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011555,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;v:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break v;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105148,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93532,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1937007471,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;B:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break B;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105228,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93572,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+32>>2]=1937011578,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;h:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break h;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105308,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93612,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,u[k+133|0]=0,u[k+134|0]=0,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,u[k+139|0]=0,u[k+140|0]=0,i[k+32>>2]=1937011571,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;_:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break _;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=106396,i[k>>2]=93852,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1701606260,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;w:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break w;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,u[k+128|0]=0,u[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105788,i[k>>2]=93892,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935828848,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;s:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break s;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,u[k+136|0]=0,u[k+132|0]=0,u[k+128|0]=0,u[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105916,i[k>>2]=93932,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1936158820,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;l:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break l;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105996,i[k>>2]=93972,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1651798644,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;o:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break o;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=106076,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=94012,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,u[k+128|0]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935763834,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;u:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break u;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=106156,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=94052,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,u[k+128|0]=0,i[k+160>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1935763823,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;t:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break t;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105708,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=94132,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1970432288,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;n:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break n;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+16>>2]=104748,i[k>>2]=94172,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+32>>2]=1852663908,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;k:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k;X[i[i[k>>2]+8>>2]](k),p(k)}break e}if((k|0)==1768186228)break r}i[n+40>>2]=k,dt(n+72|0,n+40|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;f:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break f;X[i[i[k>>2]+8>>2]](k),p(k)}break e}k=E(152),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90892,t=k+16|0,o0(t,0,136),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=88200,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0}t=n+72|0,V2(t),o=i[n+300>>2],k=i[n+256>>2],i[k+8>>2]=i[n+296>>2],i[k+12>>2]=o,i[k+16>>2]=i[n+304>>2],o=i[n+308>>2],s=i[n+312>>2],d4(k+20|0,o,s,s-o|0),o=k,k=i[n+320>>2],i[o+32>>2]=k,ie(t,n+288|0),t=i[n+256>>2],u[t+95|0]<0&&Z(i[t+84>>2]),o=i[n+76>>2],i[t+84>>2]=i[n+72>>2],i[t+88>>2]=o,i[t+92>>2]=i[n+80>>2];e:{if(i[e+12>>2]>=21){if(e=E(64),i[n+72>>2]=e,i[n+76>>2]=61,i[n+80>>2]=-2147483584,r=l[17362]|l[17363]<<8|(l[17364]<<16|l[17365]<<24),f=l[17358]|l[17359]<<8|(l[17360]<<16|l[17361]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17415]|l[17416]<<8|(l[17417]<<16|l[17418]<<24),f=l[17411]|l[17412]<<8|(l[17413]<<16|l[17414]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17410]|l[17411]<<8|(l[17412]<<16|l[17413]<<24),f=l[17406]|l[17407]<<8|(l[17408]<<16|l[17409]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17402]|l[17403]<<8|(l[17404]<<16|l[17405]<<24),f=l[17398]|l[17399]<<8|(l[17400]<<16|l[17401]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17394]|l[17395]<<8|(l[17396]<<16|l[17397]<<24),f=l[17390]|l[17391]<<8|(l[17392]<<16|l[17393]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17386]|l[17387]<<8|(l[17388]<<16|l[17389]<<24),f=l[17382]|l[17383]<<8|(l[17384]<<16|l[17385]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17378]|l[17379]<<8|(l[17380]<<16|l[17381]<<24),f=l[17374]|l[17375]<<8|(l[17376]<<16|l[17377]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17370]|l[17371]<<8|(l[17372]<<16|l[17373]<<24),f=l[17366]|l[17367]<<8|(l[17368]<<16|l[17369]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,n+72|0),u[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}r:{f:{A:{t=i[n+296>>2],s=i[n+300>>2];k:{if(t|s){if(o=k,!s&k>>>0>t>>>0){i[n+164>>2]=0,i[n+136>>2]=72244,i[n+80>>2]=72224,e=i[18065],i[n+72>>2]=e,r=i[e-12>>2],e=n+72|0,i[r+e>>2]=i[18066],i[n+76>>2]=0,r=e+i[i[n+72>>2]-12>>2]|0,f=n+84|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[n+80>>2]=r,o=i[r-12>>2],r=n+80|0,i[o+r>>2]=i[18068],o=i[18064],i[n+72>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[n+136>>2]=72244,i[n+72>>2]=72204,i[n+80>>2]=72224,f=R0(f),i[f>>2]=71280,i[n+124>>2]=0,i[n+128>>2]=0,i[n+116>>2]=0,i[n+120>>2]=0,i[n+132>>2]=24,Y(I0(Y(K2(Y(r,27117,10),t,s),27128,34),k),26454,7),e=i[n+132>>2];n:{if(e&16){k=n+104|0,r=i[n+128>>2],e=i[n+108>>2],r>>>0<e>>>0?i[n+128>>2]=e:e=r;break n}if(!(e&8)){e=0,u[n+51|0]=0,k=n+40|0;break r}k=n+92|0,e=i[n+100>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break A;if(e>>>0>=11){t=e|7,k=E(t+1|0),i[n+48>>2]=t-2147483647,i[n+40>>2]=k,i[n+44>>2]=e;break f}if(u[n+51|0]=e,k=n+40|0,e)break f;e=0;break r}if(k=t-o|0,t=s-(t>>>0<o>>>0)|0,(t|0)==1|t>>>0>1){if(e=A,A=d2(n+72|0,13910),K(e,6,101,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if((s|0)<0){if(e=A,A=d2(n+72|0,42716),K(e,2,101,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(o=i[e>>2],s=X[i[i[o>>2]+8>>2]](o)|0,w=i[e>>2],o=l0,s=k+s|0,o=s>>>0<k>>>0?o+1|0:o,X[i[i[w>>2]+12>>2]](w,s,o)|0){if(e=A,A=d2(n+72|0,42716),K(e,2,100,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(!t&u0[e+16>>2]>=k>>>0)break k;if(u[n+72|0]=0,u[n+83|0]=0,K(A,2,101,n+72|0),u[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}k=i[e+16>>2]}if(i[n+64>>2]=i[e>>2],t=i[e+4>>2],i[n+68>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),t=i[n+68>>2],i[n>>2]=i[n+64>>2],i[n+4>>2]=t,k=Ee(n+72|0,n,k,e),e=i[n+256>>2],X[i[i[e>>2]+48>>2]](n+40|0,e,k,f),e=i[n+44>>2],i[n+264>>2]=i[n+40>>2],i[n+268>>2]=e,u[n+283|0]<0&&Z(i[n+272>>2]),e=i[n+52>>2],i[n+272>>2]=i[n+48>>2],i[n+276>>2]=e,i[n+280>>2]=i[n+56>>2],f=i[k+16>>2],f&&(e=i[k+8>>2],e&&(c1(e,f),f=i[k+16>>2]),e=i[k>>2],o=X[i[i[e>>2]+8>>2]](e)|0,t=l0,s=f,f=f+o|0,t=s>>>0>f>>>0?t+1|0:t,X[i[i[e>>2]+20>>2]](e,f,t)|0,i[k+16>>2]=0),i[n+264>>2]!=i[26928]){e=i[n+256>>2],_=n,B=X[i[i[e>>2]+36>>2]](e)|0,i[_+244>>2]=B,i[n+36>>2]=i[i[n+256>>2]+16>>2],t=v-32|0,v=t,e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94292,o=i[n+36>>2],f=i[n+268>>2],i[t+8>>2]=i[n+264>>2],i[t+12>>2]=f,f=t+16|0;k:{if(u[n+283|0]>=0){s=i[n+276>>2],i[f>>2]=i[n+272>>2],i[f+4>>2]=s,i[f+8>>2]=i[n+280>>2];break k}T(f,i[n+272>>2],i[n+276>>2])}s=i[n+244>>2],i[e- -64>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=86852,i[e+120>>2]=0,i[e+124>>2]=0,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+116>>2]=o,i[e+32>>2]=1163022880,o=i[t+12>>2],i[e+120>>2]=i[t+8>>2],i[e+124>>2]=o,u[e+139|0]<0&&Z(i[e+128>>2]),o=i[f+4>>2],i[e+128>>2]=i[f>>2],i[e+132>>2]=o,i[e+136>>2]=i[f+8>>2],i[e+140>>2]=s,i[n+44>>2]=e,i[n+40>>2]=e+16,v=t+32|0,f=i[n+40>>2],t=i[n+44>>2],i[n+40>>2]=0,i[n+44>>2]=0,e=i[n+260>>2],i[n+256>>2]=f,i[n+260>>2]=t;k:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break k;X[i[i[e>>2]+8>>2]](e),p(e)}V2(n+40|0)}if(E8(r,n+256|0),e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+272>>2]=0,i[n+276>>2]=0,i[n+280>>2]=0,A=i[k+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}g0(),H()}if(!e)break r;z(k,r,e)}u[e+k|0]=0,K(A,2,101,n+40|0),u[n+51|0]<0&&Z(i[n+40>>2]),A=i[18063],i[n+72>>2]=A,i[i[A-12>>2]+(n+72|0)>>2]=i[18071],i[n+80>>2]=i[18072],i[f>>2]=71280,u[n+127|0]<0&&Z(i[n+116>>2]),y0(f),p0(n+136|0)}if(A=i[n+260>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}u[n+283|0]<0&&Z(i[n+272>>2]),A=i[n+308>>2],A&&Z(A),v=n+336|0}function U8(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0;i:{e:{r:{if(!n){C=i[A+18588>>2],A0=i[C+124>>2];f:{if(!k){if(s=i[C+208>>2],o=e>>s,(o|0)<0||(h=i[C+212>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[C+216>>2])break i;o=l[(o+i[C+200>>2]|0)+G(s,h)|0],o=o>>>0<=34?o:0;break f}if(s=i[C+228>>2],o=G(i[A0+16852>>2],e)>>s,(o|0)<0||(h=i[C+232>>2],(h|0)<=(o|0)))break e;if(s=G(i[A0+16856>>2],r)>>s,(s|0)<0|(s|0)>=i[C+236>>2])break i;o=l[(o+i[C+220>>2]|0)+G(s,h)|0]&63}n0=o>>>0>34?1:o,y=n0,x=i[C+(k?44:40)>>2],o=G(x,r),s=i[(C+(k<<2)|0)+4>>2];f:{A:{k:{n:{t:{u:{if(i[i[C+124>>2]+(k?16840:16832)>>2]>=9){D=s+(e+o<<1)|0,h=0,S=v-528|0,v=S,W=v-336|0,v=W,i[W+24>>2]=k,i[W+16>>2]=C,i[W+32>>2]=r,i[W+28>>2]=e,m=S+256|0,i[W+12>>2]=m,i[W+20>>2]=f;o:{if((f|0)<65){i[W+316>>2]=16843009,w=W+12|0,un(w);l:{if(i[w+8>>2]<33){if(s=i[w+4>>2],o=i[w+12>>2],B=i[s+(o?44:40)>>2],_=i[w+16>>2],g=i[w+24>>2],I=i[g+16936>>2],N=i[w+20>>2],g=i[(i[i[w+28>>2]+8496>>2]+(G(_,i[w+296>>2])>>I<<2)|0)+(G(i[g+16924>>2],G(N,i[w+300>>2])>>I)<<2)>>2],I=i[(s+(o<<2)|0)+4>>2],o=i[w+308>>2],!(l[w+304|0]!=1|(o|0)<=0))for(O=I-2|0,o=o-1|0;;){s=o;s:{if(l[w+304|0]!=1)break s;R=i[w+28>>2],L=G(i[w+296>>2],_-1|0),V=i[w+24>>2],a=i[V+16936>>2],$=o+N|0,f0=G($,i[w+300>>2]),V=i[(i[R+8496>>2]+(L>>a<<2)|0)+(G(i[V+16924>>2],f0>>a)<<2)>>2];w:{if(l[R+24|0]){if(R=L,o=i[w+4>>2],L=i[o+168>>2],R=R>>L,(R|0)<0||(a=i[o+172>>2],(a|0)<=(R|0)))break e;if(L=f0>>L,(L|0)<0|(L|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(R,3)|0)+G(G(L,a),3)|0)+1|0]&3)break s;if((g|0)>=(V|0))break w;break s}if((g|0)<(V|0))break s}i[w+316>>2]||(Q[w+320>>1]=F[(O+(_<<1)|0)+(G(B,$)<<1)>>1]),o=s^-1,u[o+i[w+292>>2]|0]=1,Q[i[w>>2]+(o<<1)>>1]=F[(O+(i[w+16>>2]<<1)|0)+(G(B,s+i[w+20>>2]|0)<<1)>>1],u[i[w+292>>2]-s|0]=1,Q[i[w>>2]-(s<<1)>>1]=F[(O+(i[w+16>>2]<<1)|0)+(G(B,(s+i[w+20>>2]|0)-1|0)<<1)>>1],o=1-s|0,u[o+i[w+292>>2]|0]=1,Q[i[w>>2]+(o<<1)>>1]=F[(O+(i[w+16>>2]<<1)|0)+(G(B,(s+i[w+20>>2]|0)-2|0)<<1)>>1],o=2-s|0,u[o+i[w+292>>2]|0]=1,_=i[w+16>>2],N=i[w+20>>2],Q[i[w>>2]+(o<<1)>>1]=F[(O+(_<<1)|0)+(G(B,(s+N|0)-3|0)<<1)>>1],i[w+316>>2]=i[w+316>>2]+4}if(o=s-4|0,!((s|0)>3))break}s:{if(!l[w+307|0])break s;o=i[w+28>>2],O=G(i[w+296>>2],_-1|0),s=i[w+24>>2],V=i[s+16936>>2],R=N-1|0,N=G(R,i[w+300>>2]),s=i[(i[o+8496>>2]+(O>>V<<2)|0)+(G(i[s+16924>>2],N>>V)<<2)>>2];w:{if(l[o+24|0]){if(o=i[w+4>>2],V=i[o+168>>2],O=O>>V,(O|0)<0||(L=i[o+172>>2],(L|0)<=(O|0)))break e;if(N=N>>V,(N|0)<0|(N|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(O,3)|0)+G(G(N,L),3)|0)+1|0]&3)break s;if((s|0)<=(g|0))break w;break s}if((s|0)>(g|0))break s}o=G(B,R),i[w+316>>2]||(Q[w+320>>1]=F[((I+(_<<1)|0)+(o<<1)|0)-2>>1]),Q[i[w>>2]>>1]=F[((I+(_<<1)|0)+(o<<1)|0)-2>>1],u[i[w+292>>2]]=1,i[w+316>>2]=i[w+316>>2]+1}if(o=i[w+312>>2],(o|0)>0)for(_=0;;){s:{if(l[w+(i[w+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[w+28>>2],O=i[w+16>>2],V=G(i[w+296>>2],O+_|0),N=i[w+24>>2],R=i[N+16936>>2],L=i[w+20>>2]-1|0,a=G(L,i[w+300>>2]),N=i[(i[s+8496>>2]+(V>>R<<2)|0)+(G(i[N+16924>>2],a>>R)<<2)>>2];w:{if(l[s+24|0]){if(s=i[w+4>>2],R=i[s+168>>2],V=V>>R,(V|0)<0||($=i[s+172>>2],($|0)<=(V|0)))break e;if(R=a>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(l[((i[s+160>>2]+G(V,3)|0)+G(G(R,$),3)|0)+1|0]&3)break s;if((g|0)>=(N|0))break w;break s}if((g|0)<(N|0))break s}s=G(B,L),i[w+316>>2]||(Q[w+320>>1]=F[((I+(O<<1)|0)+(_<<1)|0)+(s<<1)>>1]),N=_|1,o=I+(_<<1)|0,Q[i[w>>2]+(N<<1)>>1]=F[(o+(O<<1)|0)+(s<<1)>>1],u[N+i[w+292>>2]|0]=1,s=_|2,Q[i[w>>2]+(s<<1)>>1]=F[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+2>>1],u[s+i[w+292>>2]|0]=1,s=_|3,Q[i[w>>2]+(s<<1)>>1]=F[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+4>>1],u[s+i[w+292>>2]|0]=1,s=_+4|0,Q[i[w>>2]+(s<<1)>>1]=F[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+6>>1],u[s+i[w+292>>2]|0]=1,i[w+316>>2]=i[w+316>>2]+4,o=i[w+312>>2]}if(_=_+4|0,!((_|0)<(o|0)))break}break l}break u}s=i[W+328>>2],o=i[W+20>>2],w=o<<2,I=w|1;l:{if((s|0)==(I|0))break l;if(!s){if(B=0,g=o<<1,_=0-g|0,(_|0)>(g|0))break l;for(I=I&5,o=1<<i[i[i[W+16>>2]+124>>2]+(i[W+24>>2]?16840:16832)>>2]-1,s=i[W+12>>2];Q[s+(_<<1)>>1]=o,_=_+1|0,B=B+1|0,(I|0)!=(B|0););if(w>>>0<7)break l;for(B=s+12|0,I=s+10|0,O=s+8|0,N=s+6|0,V=s+4|0,R=s+2|0;w=_<<1,Q[w+s>>1]=o,Q[w+R>>1]=o,Q[w+V>>1]=o,Q[w+N>>1]=o,Q[w+O>>1]=o,Q[w+I>>1]=o,Q[w+B>>1]=o,w=_+7|0,Q[s+(w<<1)>>1]=o,_=_+8|0,(w|0)!=(g|0););break l}if(o=o<<1,s=0-o|0,w=i[W+304>>2],l[w-o|0]||(Q[i[W+12>>2]+(s<<1)>>1]=F[W+332>>1]),(o|0)<=(s|0))break l;for(_=s|1,s=i[W+12>>2];l[w+_|0]||(B=s+(_<<1)|0,Q[B>>1]=F[B-2>>1]),B=_+1|0,l[B+w|0]||(g=s+(B<<1)|0,Q[g>>1]=F[g-2>>1]),_=_+2|0,(o|0)!=(B|0););}v=W+336|0;break o}break t}o=i[C+124>>2];o:{if(l[o+16825|0]||k&&(h=k,i[o+16848>>2]!=3))break o;w=v-272|0,v=w;l:{if((f|0)==4|(y|0)==1)break l;s=(y|0)<26?26-y|0:y-26|0,_=(y|0)<10?10-y|0:y-10|0,s=(s|0)<(_|0)?s:_;s:{w:switch(k2(f-8|0,29)|0){case 1:if((s|0)<=1)break l;break s;case 3:if((s|0)>0)break s;break l;case 7:break l;case 0:break w;default:break n}if((s|0)<8)break l}s:{w:{_:{if(!(!l[o+8997|0]|(h|(f|0)!=32))&&(h=F[m+128>>1],s=F[m>>1],B=(h+s|0)-(F[m+64>>1]<<1)|0,_=B>>31,W=1<<i[o+512>>2]-5,(W|0)>((_^B)-_|0)))break _;o=w+128|0;break w}if(o=w+128|0,_=F[m-128>>1],g=(_+s|0)-(F[m+-64>>1]<<1)|0,B=g>>31,W>>>0<=(B^g)-B>>>0)break w;for(Q[w+256>>1]=h,Q[w>>1]=_,Q[w+128>>1]=s,B=h-s|0,W=_-s|0,h=1;;)if(_=h<<1,Q[o-_>>1]=s+(G(h,W)+32>>>6|0),Q[o+_>>1]=s+(G(h,B)+32>>>6|0),_=h+1|0,(_|0)==64){_=-64;break s}else{Q[((h^-1)<<1)+o>>1]=s+(G(_,W)+32>>>6|0),Q[(_<<1)+o>>1]=s+(G(_,B)+32>>>6|0),h=h+2|0;continue}}if(s=w+128|0,h=f<<2,Q[s-h>>1]=F[m-h>>1],Q[s+h>>1]=F[h+m>>1],B=f<<1,_=0-B|0,h=1-B|0,(h|0)>=(B|0))break s;for(g=h<<1,O=m-2|0,h=2-B|0,W=F[m+(h<<1)>>1],Q[g+s>>1]=(F[O+g>>1]+(W+(F[m+g>>1]<<1)|0)|0)+2>>>2;g=h<<1,N=g+2|0,I=F[N+m>>1],Q[s+g>>1]=(F[g+O>>1]+(I+(W<<1)|0)|0)+2>>>2,h=h+2|0,W=F[m+(h<<1)>>1],Q[s+N>>1]=(F[m+g>>1]+(W+(I<<1)|0)|0)+2>>>2,(h|0)!=(B|0););}if(s=f<<3|2,!s)break l;h=_<<1,z(h+m|0,o+h|0,s)}v=w+272|0}o:{l:switch(y|0){case 0:s:{if((f|0)>=2){for(s=0,o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);w=h+2|0;break s}if(w=1,(f|0)!=1)break o}for(N=f&-2,V=f&1,h=f-1|0,R=F[m+((f^-1)<<1)>>1],_=F[(m+(f<<1)|0)+2>>1],o=0;;){if(B=h-o|0,s=o+1|0,y=G(s,R),C=D+(G(o,x)<<1)|0,W=F[m+((o^-1)<<1)>>1],o=0,g=0,(f|0)!=1)for(;I=o|1,O=I<<1,Q[C+(o<<1)>>1]=y+(((G(W,h-o|0)+f|0)+G(_,I)|0)+G(B,F[m+O>>1])|0)>>w,o=o+2|0,Q[C+O>>1]=y+(((G(W,h-I|0)+f|0)+G(_,o)|0)+G(B,F[m+(o<<1)>>1])|0)>>w,g=g+2|0,(N|0)!=(g|0););if(V&&(I=C+(o<<1)|0,L=G(W,h-o|0)+f|0,o=o+1|0,Q[I>>1]=y+((L+G(o,_)|0)+G(B,F[m+(o<<1)>>1])|0)>>w),o=s,(o|0)==(f|0))break}break o;case 1:s=0,h=0;s:{w:{if((f|0)>=2){for(o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);_=h+2|0;break w}if(_=1,(f|0)!=1)break s}h=1,y=f&1;w:{if((f|0)==1){w=0,s=0;break w}for(C=m+2|0,W=f&-2,o=0,s=0,B=0;w=o+2|0,s=F[m+((o^2147483646)<<1)>>1]+(F[m+(w<<1)>>1]+(F[m+((o^-1)<<1)>>1]+(F[C+(o<<1)>>1]+s|0)|0)|0)|0,o=w,B=B+2|0,(W|0)!=(B|0););}if(!y)break s;s=F[m+((w^-1)<<1)>>1]+(F[(m+(w<<1)|0)+2>>1]+s|0)|0}_=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!h)break s;for(y=f&-8,m=f&7,w=0,C=f-1>>>0<7;;){if(o=D+(G(w,x)<<1)|0,s=0,!C)for(W=o+14|0,g=o+12|0,I=o+10|0,O=o+8|0,N=o+6|0,V=o+4|0,R=o+2|0,B=0;h=s<<1,Q[h+o>>1]=_,Q[h+R>>1]=_,Q[h+V>>1]=_,Q[h+N>>1]=_,Q[h+O>>1]=_,Q[h+I>>1]=_,Q[h+g>>1]=_,Q[h+W>>1]=_,s=s+8|0,B=B+8|0,(y|0)!=(B|0););if(B=0,m)for(;Q[o+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(w=w+1|0,(w|0)==(f|0))break}break s}if(s=1,Q[D>>1]=(F[m+2>>1]+(F[m-2>>1]+(_<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(h=f-1|0,y=h&3,w=G(_,3)+2|0,C=f-2|0,C>>>0>=3)for(g=h&-4,o=0;B=s<<1,W=B+2|0,Q[B+D>>1]=w+F[m+W>>1]>>>2,V=W+D|0,W=B+4|0,Q[V>>1]=w+F[W+m>>1]>>>2,B=B+6|0,Q[W+D>>1]=w+F[B+m>>1]>>>2,s=s+4|0,Q[B+D>>1]=w+F[m+(s<<1)>>1]>>>2,o=o+4|0,(g|0)!=(o|0););if(y)for(B=0;o=D+(s<<1)|0,s=s+1|0,Q[o>>1]=w+F[m+(s<<1)>>1]>>>2,B=B+1|0,(y|0)!=(B|0););if(s=1,o=G(_,3)+2|0,C)for(w=h&-2,B=0;Q[D+(G(s,x)<<1)>>1]=o+F[m+((s^-1)<<1)>>1]>>>2,Q[D+(G(x,s+1|0)<<1)>>1]=o+F[m+(-2-s<<1)>>1]>>>2,s=s+2|0,B=B+2|0,(w|0)!=(B|0););for(h&1&&(Q[D+(G(s,x)<<1)>>1]=o+F[m+((s^-1)<<1)>>1]>>>2),y=h&-8,m=h&7,w=1;;){if(o=D+(G(w,x)<<1)|0,s=1,C>>>0>=7)for(W=o+14|0,g=o+12|0,I=o+10|0,O=o+8|0,N=o+6|0,V=o+4|0,R=o+2|0,B=0;h=s<<1,Q[h+o>>1]=_,Q[h+R>>1]=_,Q[h+V>>1]=_,Q[h+N>>1]=_,Q[h+O>>1]=_,Q[h+I>>1]=_,Q[h+g>>1]=_,Q[h+W>>1]=_,s=s+8|0,B=B+8|0,(y|0)!=(B|0););if(B=0,m)for(;Q[o+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(w=w+1|0,(w|0)==(f|0))break}}break o;default:break l}if(o=i[C+124>>2],O=i[o+(k?16840:16832)>>2],l[o+16822|0]){if(s=i[C+168>>2],o=e>>s,(o|0)<0||(h=i[C+172>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[C+176>>2])break i;w=(l[((i[C+160>>2]+G(o,3)|0)+G(G(s,h),3)|0)+1|0]&8)>>>3|0}else w=0;o=0,h=0,C=v-528|0,v=C;l:{if((y|0)<35){if((y|0)<=1)break A;_=C+256|0,B=i[(y<<2)+63168>>2];s:{w:{_:{if(y>>>0<=17){h:{if((f|0)<0)break h;if(s=f+1|0,W=s&3,f>>>0>=3)for(g=s&-4;s=o<<1,Q[s+_>>1]=F[m-s>>1],I=s|2,Q[I+_>>1]=F[m-I>>1],I=s|4,Q[I+_>>1]=F[m-I>>1],s=s|6,Q[s+_>>1]=F[m-s>>1],o=o+4|0,h=h+4|0,(g|0)!=(h|0););if(!W)break h;for(s=0;h=o<<1,Q[h+_>>1]=F[m-h>>1],o=o+1|0,s=s+1|0,(W|0)!=(s|0););}if(s=y-11|0,s>>>0<15)break _;if(W=f<<1,(W|0)<=(f|0))break w;if(o=f,g=o&3,g)for(h=0,s=o;o=s+1|0,Q[_+(o<<1)>>1]=F[m+((s^-1)<<1)>>1],s=o,h=h+1|0,(g|0)!=(h|0););if(f-1>>>0<3)break w;for(h=_+6|0,g=_+4|0,I=_+2|0;s=o<<1,Q[s+I>>1]=F[m+((o^-1)<<1)>>1],Q[s+g>>1]=F[m+(-2-o<<1)>>1],Q[s+h>>1]=F[m+(-3-o<<1)>>1],s=o+4|0,Q[_+(s<<1)>>1]=F[m+(-4-o<<1)>>1],o=s,(W|0)!=(o|0););break w}h:{if((f|0)<0||(o=(f<<1)+2|0,!o))break h;z(_,m,o)}s=y-11|0;h:{if(s>>>0>=15){if(o=f<<1,(o|0)<=(f|0)|!o)break h;z((o+C|0)+258|0,(o+m|0)+2|0,o);break h}if(h=G(f,B),o=h>>5,(o|0)>-2)break h;for(s=i[(s<<2)+63312>>2],h&32&&(Q[_+(o<<1)>>1]=F[m-(G(o,s)+128>>8<<1)>>1],o=o+1|0);Q[_+(o<<1)>>1]=F[m-(G(o,s)+128>>8<<1)>>1],h=o+1|0,Q[_+(h<<1)>>1]=F[m-(G(s,h)+128>>8<<1)>>1],o=o+2|0,!!o;);}if((f|0)>0)for(a=C+258|0,$=f&2147483646,f0=f&1,N=f<<1,m0=x<<1,s=0;;){o=s,s=o+1|0,h=G(B,s),I=h>>5<<1,h=h&31;h:{if(h){if(W=D+(G(o,x)<<1)|0,g=32-h|0,I=_+I|0,o=0,(f|0)!=1)for(W0=I+4|0,V=0;R=o<<1,h0=R+I|0,L=F[h0+4>>1],Q[W+R>>1]=(G(g,F[h0+2>>1])+G(h,L)|0)+16>>>5,R=R|2,Q[R+W>>1]=(G(g,L)+G(h,F[R+W0>>1])|0)+16>>>5,o=o+2|0,V=V+2|0,($|0)!=(V|0););if(!f0)break h;V=I,I=o<<1,o=V+I|0,Q[W+I>>1]=(G(g,F[o+2>>1])+G(h,F[o+4>>1])|0)+16>>>5;break h}if(!N)break h;z(D+G(o,m0)|0,I+a|0,N)}if((f|0)==(s|0))break}if((y|0)!=26|f-32>>>0<4294967265|(k|w))break s;for(s=-1<<O^-1,o=0;h=F[m+2>>1]+(F[m+((o^-1)<<1)>>1]-F[m>>1]>>1)|0,Q[D+(G(o,x)<<1)>>1]=(h|0)>=0?(s|0)>(h|0)?h:s:0,o=o+1|0,(o|0)!=(f|0););break s}if(h=G(f,B),o=h>>5,(o|0)>-2)break w;for(s=i[(s<<2)+63312>>2],h&32&&(Q[_+(o<<1)>>1]=F[m+(G(o,s)+128>>8<<1)>>1],o=o+1|0);Q[_+(o<<1)>>1]=F[m+(G(o,s)+128>>8<<1)>>1],h=o+1|0,Q[_+(h<<1)>>1]=F[m+(G(s,h)+128>>8<<1)>>1],o=o+2|0,!!o;);}if((f|0)>0)for(g=C+258|0,h=0;;){for(o=h<<1,I=o+g|0,N=o+_|0,V=D+(G(h,x)<<1)|0,o=0;;){s=o+1|0,R=G(s,B),W=R>>5,L=V+(o<<1)|0,o=R&31;w:{if(o){W=N+(W<<1)|0,o=(G(F[W+2>>1],32-o|0)+G(o,F[W+4>>1])|0)+16>>>5|0;break w}o=F[I+(W<<1)>>1]}if(Q[L>>1]=o,o=s,(o|0)==(f|0))break}if(h=h+1|0,(h|0)==(f|0))break}if((y|0)!=10|f-32>>>0<4294967265|(k|w))break s;if(h=m-2|0,o=-1<<O^-1,s=0,(f|0)!=1)for(_=f&30,B=0;y=s<<1,x=y|2,w=F[h>>1]+(F[x+m>>1]-F[m>>1]>>1)|0,Q[y+D>>1]=(w|0)>=0?(o|0)>(w|0)?w:o:0,s=s+2|0,w=F[h>>1]+(F[m+(s<<1)>>1]-F[m>>1]>>1)|0,Q[D+x>>1]=(w|0)>=0?(o|0)>(w|0)?w:o:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;w=F[h>>1],h=s<<1,s=w+(F[(h+m|0)+2>>1]-F[m>>1]>>1)|0,Q[h+D>>1]=(s|0)>=0?(o|0)>(s|0)?s:o:0}v=C+528|0;break l}break k}}v=S+528|0;break f}D=o+(e+s|0)|0,h=0,O=v-272|0,v=O,B=v-336|0,v=B,i[B+24>>2]=k,i[B+16>>2]=C,i[B+32>>2]=r,i[B+28>>2]=e,m=O+128|0,i[B+12>>2]=m,i[B+20>>2]=f;o:{if((f|0)<65){i[B+316>>2]=16843009,w=B+12|0,un(w);l:{if(i[w+8>>2]<33){if(s=i[w+4>>2],o=i[w+12>>2],W=i[s+(o?44:40)>>2],_=i[w+24>>2],g=i[_+16936>>2],g=i[(i[i[w+28>>2]+8496>>2]+(G(i[w+296>>2],i[w+16>>2])>>g<<2)|0)+(G(i[_+16924>>2],G(i[w+300>>2],i[w+20>>2])>>g)<<2)>>2],I=i[(s+(o<<2)|0)+4>>2],o=i[w+308>>2],!(l[w+304|0]!=1|(o|0)<=0))for(_=I-1|0,o=o-1|0;;){s=o;s:{if(l[w+304|0]!=1)break s;S=i[w+28>>2],R=i[w+16>>2],V=G(i[w+296>>2],R-1|0),N=i[w+24>>2],L=i[N+16936>>2],a=o+i[w+20>>2]|0,$=G(a,i[w+300>>2]),N=i[(i[S+8496>>2]+(V>>L<<2)|0)+(G(i[N+16924>>2],$>>L)<<2)>>2];w:{if(l[S+24|0]){if(S=V,o=i[w+4>>2],V=i[o+168>>2],S=S>>V,(S|0)<0||(L=i[o+172>>2],(L|0)<=(S|0)))break e;if(V=$>>V,(V|0)<0|(V|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(S,3)|0)+G(G(V,L),3)|0)+1|0]&3)break s;if((g|0)>=(N|0))break w;break s}if((g|0)<(N|0))break s}i[w+316>>2]||(u[w+320|0]=l[(_+R|0)+G(W,a)|0]),o=s^-1,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(W,s+i[w+20>>2]|0)|0],u[i[w+292>>2]-s|0]=1,u[i[w>>2]-s|0]=l[(_+i[w+16>>2]|0)+G(W,(s+i[w+20>>2]|0)-1|0)|0],o=1-s|0,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(W,(s+i[w+20>>2]|0)-2|0)|0],o=2-s|0,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(W,(s+i[w+20>>2]|0)-3|0)|0],i[w+316>>2]=i[w+316>>2]+4}if(o=s-4|0,!((s|0)>3))break}s:{if(!l[w+307|0])break s;o=i[w+28>>2],s=i[w+16>>2],N=G(i[w+296>>2],s-1|0),_=i[w+24>>2],S=i[_+16936>>2],V=i[w+20>>2]-1|0,R=G(V,i[w+300>>2]),_=i[(i[o+8496>>2]+(N>>S<<2)|0)+(G(i[_+16924>>2],R>>S)<<2)>>2];w:{if(l[o+24|0]){if(o=i[w+4>>2],S=i[o+168>>2],N=N>>S,(N|0)<0||(L=i[o+172>>2],(L|0)<=(N|0)))break e;if(S=R>>S,(S|0)<0|(S|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(N,3)|0)+G(G(S,L),3)|0)+1|0]&3)break s;if((_|0)<=(g|0))break w;break s}if((_|0)>(g|0))break s}o=G(W,V),i[w+316>>2]||(u[w+320|0]=l[(o+(s+I|0)|0)-1|0]),u[i[w>>2]]=l[(o+(s+I|0)|0)-1|0],u[i[w+292>>2]]=1,i[w+316>>2]=i[w+316>>2]+1}if(o=i[w+312>>2],(o|0)>0)for(_=0;;){s:{if(l[w+(i[w+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[w+28>>2],N=i[w+16>>2],V=G(i[w+296>>2],N+_|0),S=i[w+24>>2],R=i[S+16936>>2],L=i[w+20>>2]-1|0,a=G(L,i[w+300>>2]),S=i[(i[s+8496>>2]+(V>>R<<2)|0)+(G(i[S+16924>>2],a>>R)<<2)>>2];w:{if(l[s+24|0]){if(s=i[w+4>>2],R=i[s+168>>2],V=V>>R,(V|0)<0||($=i[s+172>>2],($|0)<=(V|0)))break e;if(R=a>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(l[((i[s+160>>2]+G(V,3)|0)+G(G(R,$),3)|0)+1|0]&3)break s;if((g|0)>=(S|0))break w;break s}if((g|0)<(S|0))break s}s=G(W,L),i[w+316>>2]||(u[w+320|0]=l[s+((I+N|0)+_|0)|0]),S=_|1,o=_+I|0,u[S+i[w>>2]|0]=l[s+(o+N|0)|0],u[S+i[w+292>>2]|0]=1,s=_|2,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(W,i[w+20>>2]-1|0)|0)+1|0],u[s+i[w+292>>2]|0]=1,s=_|3,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(W,i[w+20>>2]-1|0)|0)+2|0],u[s+i[w+292>>2]|0]=1,s=_+4|0,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(W,i[w+20>>2]-1|0)|0)+3|0],u[s+i[w+292>>2]|0]=1,i[w+316>>2]=i[w+316>>2]+4,o=i[w+312>>2]}if(_=_+4|0,!((_|0)<(o|0)))break}break l}break u}w=i[B+328>>2],o=i[B+20>>2],s=o<<2|1;l:{if((w|0)==(s|0))break l;if(!w){if(!s)break l;o0(i[B+12>>2]-(o<<1)|0,1<<i[i[i[B+16>>2]+124>>2]+(i[B+24>>2]?16840:16832)>>2]-1,s);break l}if(s=o<<1,_=0-s|0,l[i[B+304>>2]-s|0]||(u[i[B+12>>2]+_|0]=l[B+332|0],o=i[B+20>>2],_=0-(o<<1)|0),o<<1<=(_|0))break l;for(_=_|1;l[i[B+304>>2]+_|0]||(o=i[B+12>>2]+_|0,u[o|0]=l[o-1|0],o=i[B+20>>2]),s=o<<1>(_|0),_=_+1|0,!!s;);}v=B+336|0;break o}break t}o=i[C+124>>2];o:{if(l[o+16825|0]||k&&(h=k,i[o+16848>>2]!=3))break o;w=v-144|0,v=w;l:{if((f|0)==4|(y|0)==1)break l;s=(y|0)<26?26-y|0:y-26|0,_=(y|0)<10?10-y|0:y-10|0,s=(s|0)<(_|0)?s:_;s:{w:switch(k2(f-8|0,29)|0){case 1:if((s|0)<=1)break l;break s;case 3:if((s|0)>0)break s;break l;case 7:break l;case 0:break w;default:break n}if((s|0)<8)break l}s:{w:{_:{if(!(!l[o+8997|0]|(h|(f|0)!=32))&&(h=l[m+64|0],s=l[m|0],B=(h+s|0)-(l[m+32|0]<<1)|0,_=B>>31,W=1<<i[o+512>>2]-5,(W|0)>((_^B)-_|0)))break _;o=w- -64|0;break w}if(o=w- -64|0,_=l[m+-64|0],g=(_+s|0)-(l[m-32|0]<<1)|0,B=g>>31,W>>>0<=(B^g)-B>>>0)break w;for(u[w+128|0]=h,u[w|0]=_,u[w+64|0]=s,B=h-s|0,W=_-s|0,h=1;;)if(u[o-h|0]=s+(G(h,W)+32>>>6|0),u[o+h|0]=s+(G(h,B)+32>>>6|0),_=h+1|0,(_|0)==64){B=-64;break s}else{u[(h^-1)+o|0]=s+(G(_,W)+32>>>6|0),u[o+_|0]=s+(G(_,B)+32>>>6|0),h=h+2|0;continue}}if(_=w- -64|0,s=f<<1,u[_-s|0]=l[m-s|0],u[s+_|0]=l[s+m|0],B=0-s|0,g=1-s|0,(g|0)>=(s|0))break s;for(I=m-1|0,h=2-s|0,W=l[m+h|0],u[_+g|0]=(l[I+g|0]+(W+(l[m+g|0]<<1)|0)|0)+2>>>2;V=W<<1,W=h+1|0,g=l[W+m|0],u[h+_|0]=(l[h+I|0]+(V+g|0)|0)+2>>>2,V=_+W|0,R=l[h+m|0],h=h+2|0,W=l[m+h|0],u[V|0]=(R+(W+(g<<1)|0)|0)+2>>>2,(s|0)!=(h|0););}if(s=f<<2|1,!s)break l;z(m+B|0,o+B|0,s)}v=w+144|0}o:{l:switch(y|0){case 0:s:{if((f|0)>=2){for(s=0,o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);w=h+2|0;break s}if(w=1,(f|0)!=1)break o}for(N=f&-2,S=f&1,h=f-1|0,V=l[m+(f^-1)|0],_=l[(f+m|0)+1|0],o=0;;){if(y=h-o|0,s=o+1|0,C=G(s,V),W=D+G(o,x)|0,g=l[m+(o^-1)|0],o=0,B=0,(f|0)!=1)for(;I=o|1,u[o+W|0]=C+(((G(g,h-o|0)+f|0)+G(I,_)|0)+G(y,l[m+I|0])|0)>>w,o=o+2|0,u[W+I|0]=C+(((G(g,h-I|0)+f|0)+G(_,o)|0)+G(y,l[o+m|0])|0)>>w,B=B+2|0,(N|0)!=(B|0););if(S&&(I=o+W|0,R=G(g,h-o|0)+f|0,o=o+1|0,u[I|0]=C+((R+G(o,_)|0)+G(y,l[o+m|0])|0)>>w),o=s,(o|0)==(f|0))break}break o;case 1:s=0,h=0;s:{w:{if((f|0)>=2){for(o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);_=h+2|0;break w}if(_=1,(f|0)!=1)break s}h=1,y=f&1;w:{if((f|0)==1){w=0,s=0;break w}for(C=m+1|0,W=f&-2,o=0,s=0,B=0;w=o+2|0,s=l[m+(o^-2)|0]+(l[m+w|0]+(l[m+(o^-1)|0]+(l[o+C|0]+s|0)|0)|0)|0,o=w,B=B+2|0,(W|0)!=(B|0););}if(!y)break s;s=l[m+(w^-1)|0]+(l[(w+m|0)+1|0]+s|0)|0}s=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!h)break s;if(w=0,o=0,f-1>>>0>=3)for(m=f&-4,B=0;h=!f,h||o0(D+G(o,x)|0,s,f),h||o0(D+G(x,o|1)|0,s,f),h||o0(D+G(x,o|2)|0,s,f),h||o0(D+G(x,o|3)|0,s,f),o=o+4|0,B=B+4|0,(m|0)!=(B|0););if(h=f&3,!h)break s;for(;f&&o0(D+G(o,x)|0,s,f),o=o+1|0,w=w+1|0,(h|0)!=(w|0););break s}if(o=1,u[D|0]=(l[m+1|0]+(l[m-1|0]+(s<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(w=f-1|0,_=w&3,h=G(s,3)+2|0,y=f-2|0,y>>>0>=3)for(C=w&-4,B=0;W=o+1|0,u[o+D|0]=h+l[W+m|0]>>>2,V=W+D|0,W=o+2|0,u[V|0]=h+l[W+m|0]>>>2,V=W+D|0,W=o+3|0,u[V|0]=h+l[W+m|0]>>>2,o=o+4|0,u[W+D|0]=h+l[m+o|0]>>>2,B=B+4|0,(C|0)!=(B|0););if(_)for(B=0;V=o+D|0,o=o+1|0,u[V|0]=h+l[m+o|0]>>>2,B=B+1|0,(_|0)!=(B|0););if(o=1,h=G(s,3)+2|0,y)for(_=w&-2,B=0;u[D+G(o,x)|0]=h+l[m+(o^-1)|0]>>>2,u[D+G(x,o+1|0)|0]=h+l[(m-o|0)-2|0]>>>2,o=o+2|0,B=B+2|0,(_|0)!=(B|0););if(w&1&&(u[D+G(o,x)|0]=h+l[m+(o^-1)|0]>>>2),h=f-1|0,m=(D+x|0)+1|0,_=0,o=0,y>>>0>=3)for(C=w&-4,B=0;y=!h,y||o0(m+G(o,x)|0,s,h),y||o0(m+G(x,o|1)|0,s,h),y||o0(m+G(x,o|2)|0,s,h),y||o0(m+G(x,o|3)|0,s,h),o=o+4|0,B=B+4|0,(C|0)!=(B|0););if(w=w&3,!w)break s;for(;h&&o0(m+G(o,x)|0,s,h),o=o+1|0,_=_+1|0,(w|0)!=(_|0););}break o;default:break l}if(o=i[C+124>>2],N=i[o+(k?16840:16832)>>2],l[o+16822|0]){if(s=i[C+168>>2],o=e>>s,(o|0)<0||(h=i[C+172>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[C+176>>2])break i;w=(l[((i[C+160>>2]+G(o,3)|0)+G(G(s,h),3)|0)+1|0]&8)>>>3|0}else w=0;o=0,C=v-272|0,v=C;l:{if((y|0)<35){if((y|0)<=1)break A;_=C+128|0,B=i[(y<<2)+63168>>2];s:{w:{_:{if(y>>>0<=17){h:{if((f|0)<0)break h;if(s=f+1|0,h=s&3,f>>>0>=3)for(W=s&-4,s=0;u[o+_|0]=l[m-o|0],g=o|1,u[g+_|0]=l[m-g|0],g=o|2,u[g+_|0]=l[m-g|0],g=o|3,u[g+_|0]=l[m-g|0],o=o+4|0,s=s+4|0,(W|0)!=(s|0););if(!h)break h;for(s=0;u[o+_|0]=l[m-o|0],o=o+1|0,s=s+1|0,(h|0)!=(s|0););}if(s=y-11|0,s>>>0<15)break _;if(W=f<<1,(W|0)<=(f|0))break w;if(o=f,g=o&3,g)for(h=0,s=o;o=s+1|0,u[_+o|0]=l[m+(s^-1)|0],s=o,h=h+1|0,(g|0)!=(h|0););if(f-1>>>0<3)break w;for(h=_+3|0,g=_+2|0,I=_+1|0;u[o+I|0]=l[m+(o^-1)|0],s=m-o|0,u[o+g|0]=l[s-2|0],u[o+h|0]=l[s-3|0],o=o+4|0,u[_+o|0]=l[s-4|0],(o|0)!=(W|0););break w}h:{if((f|0)<0||(o=f+1|0,!o))break h;z(_,m,o)}s=y-11|0;h:{if(s>>>0>=15){if(!f|f<<1<=(f|0))break h;z((f+C|0)+129|0,(f+m|0)+1|0,f);break h}if(h=G(f,B),o=h>>5,(o|0)>-2)break h;for(s=i[(s<<2)+63312>>2],h&32&&(u[o+_|0]=l[m-(G(o,s)+128>>8)|0],o=o+1|0);u[o+_|0]=l[m-(G(o,s)+128>>8)|0],h=o+1|0,u[h+_|0]=l[m-(G(s,h)+128>>8)|0],o=o+2|0,!!o;);}if((f|0)>0)for(R=C+129|0,L=f&2147483646,a=f&1,s=0;;){h=D+G(s,x)|0,s=s+1|0,W=G(B,s),o=W>>5,W=W&31;h:{if(W){if(g=o+_|0,I=32-W|0,o=0,(f|0)!=1)for($=g+2|0,S=0;f0=o+g|0,V=l[f0+2|0],u[o+h|0]=(G(I,l[f0+1|0])+G(W,V)|0)+16>>>5,f0=o|1,u[f0+h|0]=(G(I,V)+G(W,l[$+f0|0])|0)+16>>>5,o=o+2|0,S=S+2|0,(L|0)!=(S|0););if(!a)break h;h=o+h|0,o=o+g|0,u[h|0]=(G(I,l[o+1|0])+G(W,l[o+2|0])|0)+16>>>5;break h}if(!f)break h;z(h,o+R|0,f)}if((f|0)==(s|0))break}if((y|0)!=26|f-32>>>0<4294967265|(k|w))break s;for(s=-1<<N^-1,o=0;h=l[m+1|0]+(l[m+(o^-1)|0]-l[m|0]>>1)|0,u[D+G(o,x)|0]=(h|0)>=0?(s|0)>(h|0)?h:s:0,o=o+1|0,(o|0)!=(f|0););break s}if(h=G(f,B),o=h>>5,(o|0)>-2)break w;for(s=i[(s<<2)+63312>>2],h&32&&(u[o+_|0]=l[m+(G(o,s)+128>>8)|0],o=o+1|0);u[o+_|0]=l[m+(G(o,s)+128>>8)|0],h=o+1|0,u[h+_|0]=l[m+(G(s,h)+128>>8)|0],o=o+2|0,!!o;);}if((f|0)>0)for(g=C+129|0,h=0;;){for(I=h+g|0,S=h+_|0,V=D+G(h,x)|0,o=0;;){s=o+1|0,R=G(s,B),W=R>>5,L=o+V|0,o=R&31;w:{if(o){W=W+S|0,o=(G(l[W+1|0],32-o|0)+G(o,l[W+2|0])|0)+16>>>5|0;break w}o=l[W+I|0]}if(u[L|0]=o,o=s,(o|0)==(f|0))break}if(h=h+1|0,(h|0)==(f|0))break}if((y|0)!=10|f-32>>>0<4294967265|(k|w))break s;if(h=m-1|0,s=-1<<N^-1,o=0,(f|0)!=1)for(_=f&30,B=0;y=o|1,w=l[h|0]+(l[y+m|0]-l[m|0]>>1)|0,u[o+D|0]=(w|0)>=0?(s|0)>(w|0)?w:s:0,o=o+2|0,w=l[h|0]+(l[m+o|0]-l[m|0]>>1)|0,u[y+D|0]=(w|0)>=0?(s|0)>(w|0)?w:s:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;w=o+D|0,o=l[h|0]+(l[(o+m|0)+1|0]-l[m|0]>>1)|0,u[w|0]=(o|0)>=0?(o|0)<(s|0)?o:s:0}v=C+272|0;break l}break k}}v=O+272|0;break f}M0(21594,10923,533,14244),H()}M0(19673,10923,146,3881),H()}M0(12200,10923,211,11160),H()}M0(21292,10923,342,7633),H()}M0(21502,10923,343,7633),H()}o=0,o=!l[A0+16822|0]|!(l[A+32|0]|l[(A+k|0)+33|0])?o:(n0&47)==10,o=(n0|0)==26?o&&2:o;break r}if(o=0,!l[A+36|0])break r;o=l[A+37|0]?2:1}r:{f:{A:{k:{if(!t){if(!k|!i[A+28>>2])break k;Q[((k<<1)+A|0)+14396>>1]=0,o=0}W=l[(A+k|0)+33|0]!=0,h=!n,n=k?16840:16832;n:{if(i[n+i[i[A+18588>>2]+124>>2]>>2]>=9){t=A,D=v-4096|0,v=D;t:{if(k>>>0<3){if(s=i[A+18588>>2],m=i[s+168>>2],w=e>>m,(w|0)<0||(C=i[s+172>>2],(C|0)<=(w|0)))break e;if(_=r>>m,(_|0)<0|(_|0)>=i[s+176>>2])break i;g=k<<2,y=i[s+(k?44:40)>>2],x=i[(g+s|0)+4>>2]+(G(y,r)+e<<1)|0,B=i[s+124>>2],m=i[B+n>>2],n=i[A+2104>>2],e=0,I=l[((i[s+160>>2]+G(w,3)|0)+G(G(_,C),3)|0)+1|0]&3,C=!I&(f|0)==4&l[B+16820|0]!=0;u:{if(l[A+32|0]){if(A=A+(k<<1)|0,Q[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(t+8252|0)|0,r=r+(t+2108|0)|0;h=A<<1,Q[n+(Q[h+s>>1]<<1)>>1]=F[r+h>>1],A=A+1|0,(A|0)<Q[e>>1];);if(C&&X[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?D:h,X[i[i[t+18584>>2]+(o?(o|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],W=f&2147483646,g=f&1,r=0;;){if(_=G(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,I=B+s|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),B=B+4|0,I=B+s|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(W|0)!=(e|0););if(g&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(X[i[i[t+18584>>2]+460>>2]](x,y,s,f,m),!C)break u;Q[n>>1]=0,Q[n+2>>1]=0,Q[n+4>>1]=0,Q[n+6>>1]=0,Q[n+24>>1]=0,Q[n+26>>1]=0,Q[n+28>>1]=0,Q[n+30>>1]=0,Q[n+16>>1]=0,Q[n+18>>1]=0,Q[n+20>>1]=0,Q[n+22>>1]=0,Q[n+8>>1]=0,Q[n+10>>1]=0,Q[n+12>>1]=0,Q[n+14>>1]=0;break u}if((f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);_=i[s+132>>2],r=i[(t+g|0)+18536>>2],e=e+m|0;o:{if(!l[B+636|0]){if(A=t+(k<<1)|0,Q[A+14396>>1]<=0)break o;for(r=i[((r|0)%6<<2)+63904>>2]<<(r|0)/6,s=e-9|0,h=1<<e-10,w=A+14396|0,A=0,e=k<<11,B=e+(t+2108|0)|0,g=e+(t+8252|0)|0;O=A<<1,e=h+G(r,Q[O+B>>1])>>s,e=(e|0)>=32767?32767:e,Q[n+(Q[g+O>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<Q[w>>1];);break o}s=(f|0)!=32?k:0,A=s;l:{if(h||(A=k+3|0,(f|0)<=31))break l;A=s+1|0}l:{s:switch(k2(f-4|0,30)|0){case 1:A=(_+(A<<6)|0)+169|0;break l;case 3:A=(_+(A<<8)|0)+553|0;break l;case 7:A=(_+(A<<10)|0)+2089|0;break l;case 0:break s;default:break A}A=(_+(A<<4)|0)+73|0}if(s=t+(k<<1)|0,Q[s+14396>>1]<=0)break o;for(w=A,g=s+14396|0,O=(r|0)/6|0,A0=i[(r-G(O,6)<<2)+63904>>2],s=e-5|0,h=1<<e-6,N=h>>31,A=0,e=k<<11,n0=e+(t+2108|0)|0,S=e+(t+8252|0)|0;e=A<<1,r=Q[e+S>>1],V=n+(r<<1)|0,e=Q[e+n0>>1],R=e,L=e>>31,e=G(A0,l[r+w|0])<<O,e=O0(R,L,e,e>>31),r=N+l0|0,e=e+h|0,r=e>>>0<h>>>0?r+1|0:r,R=e,B=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>B):(e=r>>B,r=((1<<B)-1&r)<<32-B|R>>>B),B=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=B?32767:r,e=B?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,Q[V>>1]=e?-32768:r,A=A+1|0,(A|0)<Q[g>>1];);}if(W){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(C&&X[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?D:h,X[i[i[t+18584>>2]+(o?(o|0)==2?464:468:472)>>2]](s,n,f,A,(m|0)<20?20-m|0:0),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],W=f&2147483646,g=f&1,r=0;;){if(_=G(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,I=B+s|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),B=B+4|0,I=B+s|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(W|0)!=(e|0););if(g&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(X[i[i[t+18584>>2]+460>>2]](x,y,s,f,m),!C)break u;Q[n>>1]=0,Q[n+2>>1]=0,Q[n+4>>1]=0,Q[n+6>>1]=0,Q[n+24>>1]=0,Q[n+26>>1]=0,Q[n+28>>1]=0,Q[n+30>>1]=0,Q[n+16>>1]=0,Q[n+18>>1]=0,Q[n+20>>1]=0,Q[n+22>>1]=0,Q[n+8>>1]=0,Q[n+10>>1]=0,Q[n+12>>1]=0,Q[n+14>>1]=0;break u}if(o)break t;if(e=!(k|I)&(f|0)==4,l[_+8247|0]==1){r=0,h=v-4096|0,v=h,s=20-m|0,o=t+14404|0,A=k?h:o,w=i[t+18584>>2];o:{if(e){e=436;break o}e=440;l:switch(f-4|0){case 4:e=444;break o;case 12:e=448;break o;case 0:break o;default:break l}e=452}if(X[i[e+w>>2]](A,n,s,15),!(!k|!i[t+28>>2]|(f|0)<=0))for(e=i[i[t+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],W=f&2147483646,g=f&1;;){if(B=G(r,f),e=0,_=0,(f|0)!=1)for(;C=e+B<<2,I=C+A|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[o+C>>2]<<s>>n)>>3),C=C+4|0,I=C+A|0,i[I>>2]=i[I>>2]+(G(i[t+28>>2],i[o+C>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(W|0)!=(_|0););if(g&&(e=e+B<<2,_=e+A|0,i[_>>2]=i[_>>2]+(G(i[t+28>>2],i[e+o>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}X[i[w+460>>2]](x,y,A,f,m),v=h+4096|0;break u}r=i[t+18584>>2]+172|0;o:{if(e){A=240;break o}A=244;l:switch(f-4|0){case 4:A=248;break o;case 12:A=252;break o;case 0:break o;default:break l}A=256}X[i[A+r>>2]](x,n,y,m)}if(A=t+(k<<1)|0,Q[A+14396>>1]>0)for(e=A+14396|0,r=i[t+2104>>2],f=(t+8252|0)+(k<<11)|0,A=0;Q[r+(Q[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<Q[e>>1];);v=D+4096|0;break n}break f}break r}t=A,C=v-4096|0,v=C;t:{if(k>>>0<3){if(s=i[A+18588>>2],n=i[s+168>>2],w=e>>n,(w|0)<0||(_=i[s+172>>2],(_|0)<=(w|0)))break e;if(m=r>>n,(m|0)<0|(m|0)>=i[s+176>>2])break i;D=k<<2,B=i[s+(k?44:40)>>2],y=(i[(D+s|0)+4>>2]+e|0)+G(B,r)|0,n=i[A+2104>>2],e=0,g=l[((i[s+160>>2]+G(w,3)|0)+G(G(_,m),3)|0)+1|0]&3,w=i[s+124>>2],x=!g&(f|0)==4&l[w+16820|0]!=0;u:{if(l[A+32|0]){if(A=A+(k<<1)|0,Q[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(t+8252|0)|0,r=r+(t+2108|0)|0;h=A<<1,Q[n+(Q[h+s>>1]<<1)>>1]=F[r+h>>1],A=A+1|0,(A|0)<Q[e>>1];);if(x&&X[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?C:h,X[i[i[t+18584>>2]+(o?(o|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],D=f&2147483646,W=f&1,r=0;;){if(m=G(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,g=_+s|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),_=_+4|0,g=_+s|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(D|0)!=(e|0););if(W&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(X[i[i[t+18584>>2]+456>>2]](y,B,s,f,8),!x)break u;Q[n>>1]=0,Q[n+2>>1]=0,Q[n+4>>1]=0,Q[n+6>>1]=0,Q[n+24>>1]=0,Q[n+26>>1]=0,Q[n+28>>1]=0,Q[n+30>>1]=0,Q[n+16>>1]=0,Q[n+18>>1]=0,Q[n+20>>1]=0,Q[n+22>>1]=0,Q[n+8>>1]=0,Q[n+10>>1]=0,Q[n+12>>1]=0,Q[n+14>>1]=0;break u}if(_=i[w+(k?16840:16832)>>2],(f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);m=i[s+132>>2],r=i[(t+D|0)+18536>>2],e=e+_|0;o:{if(!l[w+636|0]){if(A=t+(k<<1)|0,Q[A+14396>>1]<=0)break o;for(r=i[((r|0)%6<<2)+63904>>2]<<(r|0)/6,s=e-9|0,h=1<<e-10,w=A+14396|0,A=0,e=k<<11,_=e+(t+2108|0)|0,D=e+(t+8252|0)|0;I=A<<1,e=h+G(r,Q[I+_>>1])>>s,e=(e|0)>=32767?32767:e,Q[n+(Q[I+D>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<Q[w>>1];);break o}s=(f|0)!=32?k:0,A=s;l:{if(h||(A=k+3|0,(f|0)<=31))break l;A=s+1|0}l:{s:switch(k2(f-4|0,30)|0){case 1:A=(m+(A<<6)|0)+169|0;break l;case 3:A=(m+(A<<8)|0)+553|0;break l;case 7:A=(m+(A<<10)|0)+2089|0;break l;case 0:break s;default:break A}A=(m+(A<<4)|0)+73|0}if(s=t+(k<<1)|0,Q[s+14396>>1]<=0)break o;for(w=A,D=s+14396|0,I=(r|0)/6|0,O=i[(r-G(I,6)<<2)+63904>>2],s=e-5|0,h=1<<e-6,A0=h>>31,A=0,e=k<<11,N=e+(t+2108|0)|0,n0=e+(t+8252|0)|0;e=A<<1,r=Q[e+n0>>1],S=n+(r<<1)|0,e=Q[e+N>>1],V=e,R=e>>31,e=G(O,l[r+w|0])<<I,e=O0(V,R,e,e>>31),r=A0+l0|0,e=e+h|0,r=e>>>0<h>>>0?r+1|0:r,V=e,_=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>_):(e=r>>_,r=((1<<_)-1&r)<<32-_|V>>>_),_=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=_?32767:r,e=_?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,Q[S>>1]=e?-32768:r,A=A+1|0,(A|0)<Q[D>>1];);}if(W){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(x&&X[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?C:h,X[i[i[t+18584>>2]+(o?(o|0)==2?464:468:472)>>2]](s,n,f,A,12),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],D=f&2147483646,W=f&1,r=0;;){if(m=G(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,g=_+s|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),_=_+4|0,g=_+s|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(D|0)!=(e|0););if(W&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(X[i[i[t+18584>>2]+456>>2]](y,B,s,f,8),!x)break u;Q[n>>1]=0,Q[n+2>>1]=0,Q[n+4>>1]=0,Q[n+6>>1]=0,Q[n+24>>1]=0,Q[n+26>>1]=0,Q[n+28>>1]=0,Q[n+30>>1]=0,Q[n+16>>1]=0,Q[n+18>>1]=0,Q[n+20>>1]=0,Q[n+22>>1]=0,Q[n+8>>1]=0,Q[n+10>>1]=0,Q[n+12>>1]=0,Q[n+14>>1]=0;break u}if(o)break r;if(e=!(k|g)&(f|0)==4,l[m+8247|0]==1){r=0,h=v-4096|0,v=h,o=t+14404|0,A=k?h:o,w=i[t+18584>>2];o:{if(e){e=436;break o}e=440;l:switch(f-4|0){case 4:e=444;break o;case 12:e=448;break o;case 0:break o;default:break l}e=452}if(X[i[e+w>>2]](A,n,12,15),!(!k|!i[t+28>>2]|(f|0)<=0))for(e=i[i[t+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],D=f&2147483646,W=f&1;;){if(m=G(r,f),e=0,_=0,(f|0)!=1)for(;x=e+m<<2,g=x+A|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[o+x>>2]<<s>>n)>>3),x=x+4|0,g=x+A|0,i[g>>2]=i[g>>2]+(G(i[t+28>>2],i[o+x>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(D|0)!=(_|0););if(W&&(e=e+m<<2,m=e+A|0,i[m>>2]=i[m>>2]+(G(i[t+28>>2],i[e+o>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}X[i[w+456>>2]](y,B,A,f,8),v=h+4096|0;break u}r=i[t+18584>>2]+172|0;o:{if(e){A=216;break o}A=220;l:switch(f-4|0){case 4:A=224;break o;case 12:A=228;break o;case 0:break o;default:break l}A=232}X[i[A+r>>2]](y,n,B)}if(A=t+(k<<1)|0,Q[A+14396>>1]>0)for(e=A+14396|0,r=i[t+2104>>2],f=(t+8252|0)+(k<<11)|0,A=0;Q[r+(Q[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<Q[e>>1];);v=C+4096|0;break t}break f}}}return}M0(22224,18246,507,10128),H()}M0(22224,18246,377,10128),H()}M0(22005,18246,604,10128),H()}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function wf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;B=v-48|0,v=B,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+8>>2]=f,f=i[e+12>>2],i[e+12>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;X[i[i[f>>2]+8>>2]](f),p(f)}if(i[B+24>>2]=0,i[B+28>>2]=0,i[B+40>>2]=0,i[B+32>>2]=0,i[B+36>>2]=0,I=i[e+156>>2],t=v-320|0,v=t,w=i[e>>2],k=i[w+16>>2],n=i[w+20>>2],(k|0)!=(n|0))for(;;){f=i[n-4>>2];i:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break i;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n-8|0,(k|0)==(n|0))break}i[w+20>>2]=k,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[w+64>>2]=f,f=i[w+68>>2],i[w+68>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[r>>2],f=X[i[i[f>>2]+24>>2]](f,0,0,1024,0)|0,i[w+56>>2]=f,k=l0,i[w+60>>2]=k;i:{if(!k&f>>>0<=31){if(r=E(24),i[t+248>>2]=r,i[t+252>>2]=20,i[t+256>>2]=-2147483624,f=l[24637]|l[24638]<<8|(l[24639]<<16|l[24640]<<24),k=l[24633]|l[24634]<<8|(l[24635]<<16|l[24636]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+20|0]=0,f=l[24649]|l[24650]<<8|(l[24651]<<16|l[24652]<<24),u[r+16|0]=f,u[r+17|0]=f>>>8,u[r+18|0]=f>>>16,u[r+19|0]=f>>>24,f=l[24645]|l[24646]<<8|(l[24647]<<16|l[24648]<<24),k=l[24641]|l[24642]<<8|(l[24643]<<16|l[24644]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,0,t+248|0),u[t+259|0]>=0)break i;Z(i[t+248>>2]);break i}i[t+288>>2]=i[w+64>>2],k=i[w+68>>2],i[t+292>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1,f=i[w+56>>2]),k=i[t+292>>2],i[t+32>>2]=i[t+288>>2],i[t+36>>2]=k,V=Ee(t+296|0,t+32|0,f,0),g=t+248|0,f=g,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[t+224>>2]=0,i[t+228>>2]=0,i[t+240>>2]=0,i[t+232>>2]=0,i[t+236>>2]=0,$6(t+112|0,f,V),k=i[t+116>>2],f=i[t+112>>2],i[t+224>>2]=f,i[t+228>>2]=k,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),k=i[t+124>>2],i[t+232>>2]=i[t+120>>2],i[t+236>>2]=k,i[t+240>>2]=i[t+128>>2];e:{if(f){r=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=r,i[B+16>>2]=i[t+240>>2],r=i[t+236>>2],i[B+8>>2]=i[t+232>>2],i[B+12>>2]=r,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break e}if(i[g+16>>2]!=1718909296){if(r=E(40),i[t+112>>2]=r,i[t+116>>2]=36,i[t+120>>2]=-2147483608,f=l[22956]|l[22957]<<8|(l[22958]<<16|l[22959]<<24),k=l[22952]|l[22953]<<8|(l[22954]<<16|l[22955]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+36|0]=0,f=l[22984]|l[22985]<<8|(l[22986]<<16|l[22987]<<24),u[r+32|0]=f,u[r+33|0]=f>>>8,u[r+34|0]=f>>>16,u[r+35|0]=f>>>24,f=l[22980]|l[22981]<<8|(l[22982]<<16|l[22983]<<24),k=l[22976]|l[22977]<<8|(l[22978]<<16|l[22979]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[22972]|l[22973]<<8|(l[22974]<<16|l[22975]<<24),k=l[22968]|l[22969]<<8|(l[22970]<<16|l[22971]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[22964]|l[22965]<<8|(l[22966]<<16|l[22967]<<24),k=l[22960]|l[22961]<<8|(l[22962]<<16|l[22963]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}if(f=i[g+12>>2],_=f,k=i[g+8>>2],!(f|k)){if(r=E(48),i[t+112>>2]=r,i[t+116>>2]=46,i[t+120>>2]=-2147483600,f=l[13361]|l[13362]<<8|(l[13363]<<16|l[13364]<<24),k=l[13357]|l[13358]<<8|(l[13359]<<16|l[13360]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+46|0]=0,f=l[13399]|l[13400]<<8|(l[13401]<<16|l[13402]<<24),k=l[13395]|l[13396]<<8|(l[13397]<<16|l[13398]<<24),u[r+38|0]=k,u[r+39|0]=k>>>8,u[r+40|0]=k>>>16,u[r+41|0]=k>>>24,u[r+42|0]=f,u[r+43|0]=f>>>8,u[r+44|0]=f>>>16,u[r+45|0]=f>>>24,f=l[13393]|l[13394]<<8|(l[13395]<<16|l[13396]<<24),k=l[13389]|l[13390]<<8|(l[13391]<<16|l[13392]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[13385]|l[13386]<<8|(l[13387]<<16|l[13388]<<24),k=l[13381]|l[13382]<<8|(l[13383]<<16|l[13384]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[13377]|l[13378]<<8|(l[13379]<<16|l[13380]<<24),k=l[13373]|l[13374]<<8|(l[13375]<<16|l[13376]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[13369]|l[13370]<<8|(l[13371]<<16|l[13372]<<24),k=l[13365]|l[13366]<<8|(l[13367]<<16|l[13368]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}if(s=i[w+60>>2],(_|0)==(s|0)&k>>>0>u0[w+56>>2]|s>>>0<_>>>0){if(r=E(40),i[t+112>>2]=r,i[t+116>>2]=39,i[t+120>>2]=-2147483608,f=l[14075]|l[14076]<<8|(l[14077]<<16|l[14078]<<24),k=l[14071]|l[14072]<<8|(l[14073]<<16|l[14074]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+39|0]=0,f=l[14106]|l[14107]<<8|(l[14108]<<16|l[14109]<<24),k=l[14102]|l[14103]<<8|(l[14104]<<16|l[14105]<<24),u[r+31|0]=k,u[r+32|0]=k>>>8,u[r+33|0]=k>>>16,u[r+34|0]=k>>>24,u[r+35|0]=f,u[r+36|0]=f>>>8,u[r+37|0]=f>>>16,u[r+38|0]=f>>>24,f=l[14099]|l[14100]<<8|(l[14101]<<16|l[14102]<<24),k=l[14095]|l[14096]<<8|(l[14097]<<16|l[14098]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14091]|l[14092]<<8|(l[14093]<<16|l[14094]<<24),k=l[14087]|l[14088]<<8|(l[14089]<<16|l[14090]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14083]|l[14084]<<8|(l[14085]<<16|l[14086]<<24),k=l[14079]|l[14080]<<8|(l[14081]<<16|l[14082]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}i[t+192>>2]=i[w+64>>2],f=i[w+68>>2],i[t+196>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+196>>2],i[t+24>>2]=i[t+192>>2],i[t+28>>2]=f,s=0,R=t3(t+200|0,t+24|0,0,k),i[t+184>>2]=0,i[t+188>>2]=0,I6(t+112|0,R,t+184|0,I),f=i[t+116>>2],i[t+224>>2]=i[t+112>>2],i[t+228>>2]=f,u[t+243|0]<0&&Z(i[t+232>>2]),f=i[t+124>>2],i[t+232>>2]=i[t+120>>2],i[t+236>>2]=f,i[t+240>>2]=i[t+128>>2],y=w+16|0,r2(y,t+184|0),n=0,f=i[t+184>>2];r:{if(!f)break r;if(n=X0(f,86628,86992),!n){n=0;break r}if(s=i[t+188>>2],!s){s=0;break r}i[s+4>>2]=i[s+4>>2]+1}i[w+28>>2]=n,f=i[w+32>>2],i[w+32>>2]=s;r:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break r;X[i[i[f>>2]+8>>2]](f),p(f)}for(D=w+44|0,m=B+8|0,s=0;;){f=_,o=k+32|0,n=o>>>0<32?f+1|0:f,W=i[w+60>>2],f=i[w+56>>2],(n|0)==(W|0)&f>>>0<o>>>0|n>>>0>W>>>0&&(f=i[r>>2],f=X[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,W=h,i[w+56>>2]=f,i[w+60>>2]=h);r:{if((n|0)==(W|0)&f>>>0<o>>>0|n>>>0>W>>>0){if((s|C)&1){if(r=i[26929],i[B>>2]=i[26928],i[B+4>>2]=r,u[107731]>=0){r=i[26931],i[m>>2]=i[26930],i[m+4>>2]=r,i[m+8>>2]=i[26932];break r}T(m,i[26930],i[26931]);break r}if(r=E(24),i[t+112>>2]=r,i[t+116>>2]=23,i[t+120>>2]=-2147483624,f=l[18767]|l[18768]<<8|(l[18769]<<16|l[18770]<<24),k=l[18763]|l[18764]<<8|(l[18765]<<16|l[18766]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+23|0]=0,f=l[18782]|l[18783]<<8|(l[18784]<<16|l[18785]<<24),k=l[18778]|l[18779]<<8|(l[18780]<<16|l[18781]<<24),u[r+15|0]=k,u[r+16|0]=k>>>8,u[r+17|0]=k>>>16,u[r+18|0]=k>>>24,u[r+19|0]=f,u[r+20|0]=f>>>8,u[r+21|0]=f>>>16,u[r+22|0]=f>>>24,f=l[18775]|l[18776]<<8|(l[18777]<<16|l[18778]<<24),k=l[18771]|l[18772]<<8|(l[18773]<<16|l[18774]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,0,t+112|0),u[t+123|0]>=0)break r;Z(i[t+112>>2]);break r}i[t+152>>2]=i[w+64>>2],n=i[w+68>>2],i[t+156>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1,f=i[w+56>>2]),n=i[t+156>>2],i[t+16>>2]=i[t+152>>2],i[t+20>>2]=n,n=t3(t+160|0,t+16|0,k,f),N=t+112|0,f=N,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,$6(t+88|0,f,n),n=i[t+92>>2],f=i[t+88>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+100>>2],i[t+232>>2]=i[t+96>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+104>>2];f:{if(f){f=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=f,i[m+8>>2]=i[t+240>>2],f=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=f,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0,f=0;break f}if(f=i[t+128>>2],(f|0)==1835365473){if(o=i[t+120>>2],n=i[t+124>>2],!(o|n)){f=E(48),i[t+88>>2]=f,i[t+92>>2]=42,i[t+96>>2]=-2147483600,n=l[11794]|l[11795]<<8|(l[11796]<<16|l[11797]<<24),o=l[11790]|l[11791]<<8|(l[11792]<<16|l[11793]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+42|0]=0,n=l[11830]|l[11831]<<8,u[f+40|0]=n,u[f+41|0]=n>>>8,n=l[11826]|l[11827]<<8|(l[11828]<<16|l[11829]<<24),o=l[11822]|l[11823]<<8|(l[11824]<<16|l[11825]<<24),u[f+32|0]=o,u[f+33|0]=o>>>8,u[f+34|0]=o>>>16,u[f+35|0]=o>>>24,u[f+36|0]=n,u[f+37|0]=n>>>8,u[f+38|0]=n>>>16,u[f+39|0]=n>>>24,n=l[11818]|l[11819]<<8|(l[11820]<<16|l[11821]<<24),o=l[11814]|l[11815]<<8|(l[11816]<<16|l[11817]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[11810]|l[11811]<<8|(l[11812]<<16|l[11813]<<24),o=l[11806]|l[11807]<<8|(l[11808]<<16|l[11809]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[11802]|l[11803]<<8|(l[11804]<<16|l[11805]<<24),o=l[11798]|l[11799]<<8|(l[11800]<<16|l[11801]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,K(B,2,104,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}if(f=i[w+56>>2],h=i[w+60>>2],W=h,n=n+_|0,o=k+o|0,n=o>>>0<k>>>0?n+1|0:n,(n|0)==(h|0)&f>>>0<o>>>0|n>>>0>h>>>0&&(f=i[w+64>>2],f=X[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,W=h,i[w+56>>2]=f,i[w+60>>2]=h),(n|0)==(W|0)&f>>>0<o>>>0|n>>>0>W>>>0){f=E(32),i[t+88>>2]=f,i[t+92>>2]=25,i[t+96>>2]=-2147483616,n=l[2437]|l[2438]<<8|(l[2439]<<16|l[2440]<<24),o=l[2433]|l[2434]<<8|(l[2435]<<16|l[2436]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+25|0]=0,u[f+24|0]=l[2457],n=l[2453]|l[2454]<<8|(l[2455]<<16|l[2456]<<24),o=l[2449]|l[2450]<<8|(l[2451]<<16|l[2452]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[2445]|l[2446]<<8|(l[2447]<<16|l[2448]<<24),o=l[2441]|l[2442]<<8|(l[2443]<<16|l[2444]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,K(B,2,104,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}i[t+80>>2]=i[w+64>>2],f=i[w+68>>2],i[t+84>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+84>>2],i[t+8>>2]=i[t+80>>2],i[t+12>>2]=f,f=t3(t+88|0,t+8|0,k,o),i[t+72>>2]=0,i[t+76>>2]=0,I6(t+48|0,f,t+72|0,I),n=i[t+52>>2],f=i[t+48>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+60>>2],i[t+232>>2]=i[t+56>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+64>>2],o=f;A:{if(f){f=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=f,i[m+8>>2]=i[t+240>>2],f=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=f,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break A}r2(y,t+72|0);k:{n:{if(f=i[t+72>>2],!f||(n=X0(f,86628,87152),!n))break n;if(s=i[t+76>>2],!s){s=0;break k}i[s+4>>2]=i[s+4>>2]+1;break k}s=0,n=0}if(i[w+36>>2]=n,f=i[w+40>>2],i[w+40>>2]=s,s=1,!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[t+76>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[t+92>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}if(f=0,o)break f;f=i[t+128>>2]}A:{if((f|0)!=1836019574)break A;if(o=i[t+120>>2],n=i[t+124>>2],!(o|n)){f=E(48),i[t+88>>2]=f,i[t+92>>2]=42,i[t+96>>2]=-2147483600,n=l[11751]|l[11752]<<8|(l[11753]<<16|l[11754]<<24),o=l[11747]|l[11748]<<8|(l[11749]<<16|l[11750]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+42|0]=0,n=l[11787]|l[11788]<<8,u[f+40|0]=n,u[f+41|0]=n>>>8,n=l[11783]|l[11784]<<8|(l[11785]<<16|l[11786]<<24),o=l[11779]|l[11780]<<8|(l[11781]<<16|l[11782]<<24),u[f+32|0]=o,u[f+33|0]=o>>>8,u[f+34|0]=o>>>16,u[f+35|0]=o>>>24,u[f+36|0]=n,u[f+37|0]=n>>>8,u[f+38|0]=n>>>16,u[f+39|0]=n>>>24,n=l[11775]|l[11776]<<8|(l[11777]<<16|l[11778]<<24),o=l[11771]|l[11772]<<8|(l[11773]<<16|l[11774]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[11767]|l[11768]<<8|(l[11769]<<16|l[11770]<<24),o=l[11763]|l[11764]<<8|(l[11765]<<16|l[11766]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[11759]|l[11760]<<8|(l[11761]<<16|l[11762]<<24),o=l[11755]|l[11756]<<8|(l[11757]<<16|l[11758]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,K(B,2,151,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}if(f=i[w+56>>2],h=i[w+60>>2],W=h,n=n+_|0,o=k+o|0,n=o>>>0<k>>>0?n+1|0:n,(n|0)==(h|0)&f>>>0<o>>>0|n>>>0>h>>>0&&(f=i[w+64>>2],f=X[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,W=h,i[w+56>>2]=f,i[w+60>>2]=h),(n|0)==(W|0)&f>>>0<o>>>0|n>>>0>W>>>0){f=E(32),i[t+88>>2]=f,i[t+92>>2]=25,i[t+96>>2]=-2147483616,n=l[2347]|l[2348]<<8|(l[2349]<<16|l[2350]<<24),o=l[2343]|l[2344]<<8|(l[2345]<<16|l[2346]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+25|0]=0,u[f+24|0]=l[2367],n=l[2363]|l[2364]<<8|(l[2365]<<16|l[2366]<<24),o=l[2359]|l[2360]<<8|(l[2361]<<16|l[2362]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[2355]|l[2356]<<8|(l[2357]<<16|l[2358]<<24),o=l[2351]|l[2352]<<8|(l[2353]<<16|l[2354]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,K(B,2,151,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}i[t+40>>2]=i[w+64>>2],f=i[w+68>>2],i[t+44>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+44>>2],i[t>>2]=i[t+40>>2],i[t+4>>2]=f,f=t3(t+88|0,t,k,o),i[t+72>>2]=0,i[t+76>>2]=0,I6(t+48|0,f,t+72|0,I),n=i[t+52>>2],f=i[t+48>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+60>>2],i[t+232>>2]=i[t+56>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+64>>2];k:{if(f){n=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=n,i[m+8>>2]=i[t+240>>2],n=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=n,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break k}r2(y,t+72|0),n=t+48|0;n:{t:{if(o=i[t+72>>2],!o||(o=X0(o,86628,92712),!o))break t;if(i[n>>2]=o,o=i[t+76>>2],i[n+4>>2]=o,!o)break n;i[o+4>>2]=i[o+4>>2]+1;break n}i[n>>2]=0,i[n+4>>2]=0}E8(D,n),V2(n),C=1}n=i[t+76>>2];k:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break k;X[i[i[n>>2]+8>>2]](n),p(n)}n=i[t+92>>2];k:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break k;X[i[i[n>>2]+8>>2]](n),p(n)}if(!f)break A;f=0;break f}if(f=i[t+120>>2],n=i[t+124>>2],!(f|n)){if((s|C)&1){if(f=i[26929],i[B>>2]=i[26928],i[B+4>>2]=f,u[107731]>=0){f=i[26931],i[m>>2]=i[26930],i[m+4>>2]=f,i[m+8>>2]=i[26932],f=0;break f}T(m,i[26930],i[26931]),f=0;break f}f=E(24),i[t+88>>2]=f,i[t+92>>2]=17,i[t+96>>2]=-2147483624,s=l[15846]|l[15847]<<8|(l[15848]<<16|l[15849]<<24),n=l[15842]|l[15843]<<8|(l[15844]<<16|l[15845]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=s,u[f+5|0]=s>>>8,u[f+6|0]=s>>>16,u[f+7|0]=s>>>24,u[f+17|0]=0,u[f+16|0]=l[15858],s=l[15854]|l[15855]<<8|(l[15856]<<16|l[15857]<<24),n=l[15850]|l[15851]<<8|(l[15852]<<16|l[15853]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=s,u[f+13|0]=s>>>8,u[f+14|0]=s>>>16,u[f+15|0]=s>>>24,K(B,2,0,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),C=0,s=0,f=0;break f}if(o=n^-1,(_|0)==(o|0)&k>>>0>(f^-1)>>>0|o>>>0<_>>>0){f=E(40),i[t+88>>2]=f,i[t+92>>2]=36,i[t+96>>2]=-2147483608,n=l[3004]|l[3005]<<8|(l[3006]<<16|l[3007]<<24),o=l[3e3]|l[3001]<<8|(l[3002]<<16|l[3003]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+36|0]=0,n=l[3032]|l[3033]<<8|(l[3034]<<16|l[3035]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,n=l[3028]|l[3029]<<8|(l[3030]<<16|l[3031]<<24),o=l[3024]|l[3025]<<8|(l[3026]<<16|l[3027]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[3020]|l[3021]<<8|(l[3022]<<16|l[3023]<<24),o=l[3016]|l[3017]<<8|(l[3018]<<16|l[3019]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[3012]|l[3013]<<8|(l[3014]<<16|l[3015]<<24),o=l[3008]|l[3009]<<8|(l[3010]<<16|l[3011]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,K(B,2,0,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}_=n+_|0,h=k,k=f+k|0,_=h>>>0>k>>>0?_+1|0:_,f=1}i[N>>2]=86404,n=i[t+132>>2],n&&(i[t+136>>2]=n,Z(n)),n=i[t+164>>2];f:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break f;X[i[i[n>>2]+8>>2]](n),p(n)}if(f)continue}break}r=i[t+188>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=i[R+4>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(u[t+243|0]<0&&Z(i[t+232>>2]),i[g>>2]=86404,r=i[g+20>>2],r&&(i[g+24>>2]=r,Z(r)),r=i[V+4>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=t+320|0,f=i[B+4>>2],r=i[B>>2],i[B+24>>2]=r,i[B+28>>2]=f,u[B+43|0]<0&&(Z(i[B+32>>2]),r=i[B+24>>2]),f=i[B+12>>2],i[B+32>>2]=i[B+8>>2],i[B+36>>2]=f,i[B+40>>2]=i[B+16>>2];i:{if(r){e=i[B+28>>2],i[A>>2]=i[B+24>>2],i[A+4>>2]=e,e=i[B+36>>2],i[A+8>>2]=i[B+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[B+40>>2];break i}W=v-160|0,v=W,f=i[e>>2],r=i[f+28>>2],k=i[f+32>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+28>>2]=r,f=i[e+32>>2],i[e+32>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(X[i[i[f>>2]+8>>2]](f),p(f)),r=i[e+28>>2]);e:{r:{f:{A:{if(!r){if(u[W+12|0]=0,u[W+23|0]=0,K(A,2,102,W+12|0),u[W+23|0]>=0)break A;Z(i[W+12>>2]);break A}s=i[e+32>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],_=i[e+24>>2];k:{if(f>>>0<_>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(n=i[e+16>>2],f=f-n|0,h=f>>3,k=h+1|0,k>>>0>=536870912)break f;if(_=_-n|0,o=_>>2,_=_>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,_){if(_>>>0>=536870912)break r;k=E(_<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=s,i[o>>2]=r,s=o-(h<<3)|0,f&&z(s,n,f),i[e+24>>2]=k+(_<<3),r=o+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!n)break k;Z(n)}i[e+20>>2]=r,n=1;k:{if(J4(i[e+28>>2],1836279345)||J4(i[e+28>>2],1769172845)||J4(i[e+28>>2],1836069937))break k;n=J4(i[e+28>>2],1836069938)}k:{if(J4(i[e+28>>2],1751476579)||J4(i[e+28>>2],1751476600)||J4(i[e+28>>2],1835623985)||J4(i[e+28>>2],1635150182)||J4(i[e+28>>2],829450595)||J4(i[e+28>>2],1785750887)||J4(i[e+28>>2],1769172845)||J4(i[e+28>>2],1836069938)||J4(i[e+28>>2],1836069937)||J4(i[e+28>>2],1836279345))break k;e=_A(W+12|0),Y(e+8|0,41851,44),QA(W,e),K(A,3,0,W),u[W+11|0]<0&&Z(i[W>>2]),H6(e);break A}if(f=i[e>>2],r=i[f+36>>2],k=i[f+40>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+44>>2]=r,f=i[e+48>>2],i[e+48>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(X[i[i[f>>2]+8>>2]](f),p(f)),r=i[e+44>>2]),r){s=i[e+48>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],o=i[e+24>>2];k:{if(f>>>0<o>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],f=f-_|0,t=f>>3,k=t+1|0,k>>>0>=536870912)break f;if(o=o-_|0,h=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,o){if(o>>>0>=536870912)break r;k=E(o<<3)}else k=0;if(h=k+f|0,i[h+4>>2]=s,i[h>>2]=r,s=h-(t<<3)|0,f&&z(s,_,f),i[e+24>>2]=k+(o<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e>>2],r=i[f+44>>2],k=i[f+48>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+140>>2]=r,f=i[e+144>>2],i[e+144>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(X[i[i[f>>2]+8>>2]](f),p(f)),r=i[e+140>>2]),r){s=i[e+144>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],o=i[e+24>>2];k:{if(f>>>0<o>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],f=f-_|0,t=f>>3,k=t+1|0,k>>>0>=536870912)break f;if(o=o-_|0,h=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,o){if(o>>>0>=536870912)break r;k=E(o<<3)}else k=0;if(h=k+f|0,i[h+4>>2]=s,i[h>>2]=r,s=h-(t<<3)|0,f&&z(s,_,f),i[e+24>>2]=k+(o<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e+44>>2],!((f|0)!=0|n)){if(u[W+12|0]=0,u[W+23|0]=0,K(A,2,104,W+12|0),u[W+23|0]>=0)break A;Z(i[W+12>>2]);break A}if(r=i[e+140>>2],!(n^1|(r|0)!=0)){if(u[W+12|0]=0,u[W+23|0]=0,K(A,2,151,W+12|0),u[W+23|0]>=0)break A;Z(i[W+12>>2]);break A}if(f){w=v-48|0,v=w,r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];k:{n:{if((f|0)!=(k|0))for(;;){t:{if(r=i[f>>2],!r||(r=X0(r,86628,87232),!r))break t;if(f=i[f+4>>2],!f)break n;i[f+4>>2]=i[f+4>>2]+1;break k}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}i[e+36>>2]=r,k=i[e+40>>2],i[e+40>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+36>>2]);k:{if(!(!r|i[r+108>>2]==1885954932)){if(u[w+36|0]=0,u[w+47|0]=0,K(A,2,114,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];n:{t:{if((f|0)!=(k|0))for(;;){u:{if(r=i[f>>2],!r||(r=X0(r,86628,87312),!r))break u;if(f=i[f+4>>2],!f)break t;i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}if(i[e+92>>2]=r,k=i[e+96>>2],i[e+96>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+92>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,K(A,2,107,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];n:{t:{if((f|0)!=(k|0))for(;;){u:{if(r=i[f>>2],!r||(r=X0(r,86628,87552),!r))break u;if(f=i[f+4>>2],!f)break t;i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}if(i[e+116>>2]=r,k=i[e+120>>2],i[e+120>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+116>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,K(A,2,112,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}f=i[r+36>>2],k=i[r+40>>2];n:{if((f|0)!=(k|0))for(;;){t:{if(r=i[f>>2],!r||(r=X0(r,86628,87632),!r))break t;if(f=i[f+4>>2],!f){f=0;break n}i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}if(i[e+52>>2]=r,k=i[e+56>>2],i[e+56>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+52>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,K(A,2,108,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+116>>2],i[w+44>>2]=0,i[w+36>>2]=0,i[w+40>>2]=0;n:{t:{if(f=i[r+36>>2],k=i[r+40>>2],(f|0)==(k|0))break t;for(;;){r=i[f>>2];u:{if(!r||(r=X0(r,86628,87780),!r)||(i[w+24>>2]=r,r=i[f+4>>2],i[w+28>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r2(w+36|0,w+24|0),r=i[w+28>>2],!r)||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break u;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f+8|0,(k|0)==(f|0))break}if(f=i[w+36>>2],r=i[w+40>>2],(f|0)==(r|0))break t;if(r-f>>>0>8)for(r=1;;){k=0,s=i[f>>2],g=s+104|0,_=i[s+108>>2],f=i[(r<<3)+f>>2],s=i[f+104>>2],o=s,f=i[f+108>>2],C=f,m=v-32|0,v=m;u:{o:{l:{s:{w:{s=f-o>>4;_:{if((s|0)<=0)break _;if(h=i[g+8>>2],n=i[g+4>>2],(s|0)<=h-n>>4){f=n-_|0,R=f>>4;h:{if((R|0)>=(s|0)){t=(s<<4)+o|0,f=n;break h}t=f+o|0;B:{if((C|0)==(t|0)){f=n;break B}for(k=t,f=n;;){if(h=i[k>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=h,h=i[k+8>>2],V=i[k+4>>2],(h|0)!=(V|0)){if(h=h-V|0,(h|0)<0)break w;I=E(h),i[f+8>>2]=I,i[f+4>>2]=I,y=h+I|0,i[f+12>>2]=y,h&&z(I,V,h),i[f+8>>2]=y}if(f=f+16|0,k=k+16|0,(C|0)==(k|0))break}}if(i[g+4>>2]=f,(R|0)<=0)break _}if(s=s<<4,I=s+_|0,k=f,s=f-s|0,n>>>0>s>>>0)for(h=s;C=i[h>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=C,i[k+4>>2]=i[h+4>>2],i[k+8>>2]=i[h+8>>2],i[k+12>>2]=i[h+12>>2],i[h+12>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0,k=k+16|0,h=h+16|0,n>>>0>h>>>0;);if(i[g+4>>2]=k,(f|0)!=(I|0))for(;k=f-16|0,n=s-16|0,i[k>>2]=i[n>>2],h=f-12|0,g=i[h>>2],g&&(I=f-8|0,i[I>>2]=g,Z(g),i[I>>2]=0,i[I+4>>2]=0,i[h>>2]=0),g=h,h=s-12|0,i[g>>2]=i[h>>2],i[f-8>>2]=i[s-8>>2],g=f-4|0,f=s-4|0,i[g>>2]=i[f>>2],i[f>>2]=0,i[h>>2]=0,i[h+4>>2]=0,f=k,s=n,(n|0)!=(_|0););if((t|0)==(o|0))break _;for(f=_;i[f>>2]=i[o>>2],(f|0)!=(o|0)&&(k=i[o+4>>2],s=i[o+8>>2],k6(f+4|0,k,s,s-k>>2)),f=f+16|0,o=o+16|0,(t|0)!=(o|0););break _}if(f=i[g>>2],n=s+(n-f>>4)|0,n>>>0>=268435456)break s;if(i[m+28>>2]=g+8,h=h-f|0,t=h>>3,n=h>>>0>=2147483632?268435455:n>>>0<t>>>0?t:n,n){if(n>>>0>=268435456)break l;k=E(n<<4)}for(i[m+12>>2]=k,f=(_-f|0)+k|0,i[m+20>>2]=f,i[m+24>>2]=(n<<4)+k,i[m+16>>2]=f,n=(s<<4)+f|0;;){if(k=i[o>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=k,k=i[o+8>>2],h=i[o+4>>2],(k|0)!=(h|0)){if(k=k-h|0,(k|0)<0)break o;s=E(k),i[f+8>>2]=s,i[f+4>>2]=s,t=k+s|0,i[f+12>>2]=t,k&&z(s,h,k),i[f+8>>2]=t}if(o=o+16|0,f=f+16|0,(n|0)==(f|0))break}i[m+20>>2]=n,k=i[m+20>>2],s=i[m+16>>2],f=_,n=i[g+4>>2];h:{if((f|0)==(n|0)){n=f;break h}for(s=f;_=i[s>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=_,i[k+4>>2]=i[s+4>>2],i[k+8>>2]=i[s+8>>2],i[k+12>>2]=i[s+12>>2],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,k=k+16|0,s=s+16|0,(n|0)!=(s|0););for(k=f;s=i[k+4>>2],s&&(i[k+8>>2]=s,Z(s)),k=k+16|0,(n|0)!=(k|0););k=i[m+20>>2],s=i[m+16>>2],n=i[g+4>>2]}if(i[m+20>>2]=(n-f|0)+k,i[g+4>>2]=f,n=i[g>>2],_=(n-f|0)+s|0,(f|0)!=(n|0)){for(k=n,s=_;o=i[k>>2],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=o,i[s+4>>2]=i[k+4>>2],i[s+8>>2]=i[k+8>>2],i[s+12>>2]=i[k+12>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,s=s+16|0,k=k+16|0,(f|0)!=(k|0););for(;k=i[n+4>>2],k&&(i[n+8>>2]=k,Z(k)),n=n+16|0,(f|0)!=(n|0););n=i[g>>2]}if(i[m+16>>2]=_,i[g+4>>2]=n,i[g>>2]=i[m+16>>2],i[m+16>>2]=n,f=i[g+4>>2],i[g+4>>2]=i[m+20>>2],i[m+20>>2]=f,f=i[g+8>>2],i[g+8>>2]=i[m+24>>2],i[m+24>>2]=f,i[m+12>>2]=i[m+16>>2],o=i[m+20>>2],k=i[m+16>>2],(o|0)!=(k|0))for(;f=o-16|0,i[m+20>>2]=f,s=i[o-12>>2],s&&(i[o-8>>2]=s,Z(s),f=i[m+20>>2]),o=f,(k|0)!=(f|0););if(f=i[m+12>>2],!f)break _;Z(f)}v=m+32|0;break u}G0(),H()}G0(),H()}x0(),H()}G0(),H()}if(r=r+1|0,f=i[w+36>>2],!(r>>>0<i[w+40>>2]-f>>3>>>0))break}r=i[f>>2],f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+60>>2]=r,r=i[e+64>>2],i[e+64>>2]=f;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=X0(r,86628,89712),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}if(i[e+68>>2]=r,k=i[e+72>>2],i[e+72>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+68>>2]),!r){if(u[w+24|0]=0,u[w+35|0]=0,K(A,2,110,w+24|0),u[w+35|0]>=0)break n;Z(i[w+24>>2]);break n}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=X0(r,86628,88260),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}i[e+76>>2]=r,r=i[e+80>>2],i[e+80>>2]=f;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=X0(r,86628,88180),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}i[e+84>>2]=r,k=i[e+88>>2],i[e+88>>2]=f,f=e+84|0,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[f>>2]);u:{if(!r)break u;if(r=i[i[e+92>>2]+104>>2],k=v-32|0,v=k,i[k+16>>2]=0,i[k+20>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+24>>2]=1065353216,K7(A,e,r,f,k+8|0),r=i[k+16>>2],r)for(;f=i[r>>2],Z(r),r=f,!!f;);if(r=i[k+8>>2],i[k+8>>2]=0,r&&Z(r),v=k+32|0,i[A>>2])break n;if(u[A+19|0]>=0)break u;Z(i[A+8>>2])}if(r=w+24|0,GA(r,i[e+44>>2]),E8(e+100|0,r),V2(r),!i[e+100>>2]){if(r=d2(r,42716),K(A,2,111,r),u[r+11|0]>=0)break n;Z(i[r>>2]);break n}f=w+24|0;u:{o:{if(r=i[e+44>>2],s=i[r+36>>2],n=i[r+40>>2],(s|0)!=(n|0)){if(k=i[s>>2],k&&(r=i[f+4>>2],k=X0(k,86628,88340),k))break o;if(s=s+8|0,(n|0)!=(s|0))for(;;){if(k=i[s>>2],k&&(r=0,k=X0(k,86628,88340),k))break o;if(s=s+8|0,(n|0)==(s|0))break}i[f>>2]=0,i[f+4>>2]=0}i[f>>2]=0,i[f+4>>2]=0;break u}if(i[f+4>>2]=r,i[f>>2]=k,r=i[s+4>>2],i[f+4>>2]=r,!r)break u;i[r+4>>2]=i[r+4>>2]+1}E8(e+108|0,f),V2(f),Zu(f,i[e+100>>2]),_=i[w+24>>2],t=i[w+28>>2];u:{if((_|0)!=(t|0))for(s=e+128|0;;){if(h=i[_>>2],!h){if(u[w+12|0]=0,u[w+23|0]=0,K(A,2,125,w+12|0),u[w+23|0]>=0)break u;Z(i[w+12>>2]);break u}o=i[h+104>>2],n=i[_+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);o:{l:{k=s,f=k,r=i[f>>2];s:{if(!r)break s;for(;;){if(f=r,r=i[f+16>>2],r>>>0>o>>>0){if(k=f,r=i[f>>2],r)continue;break s}if(r>>>0>=o>>>0)break l;if(r=i[f+4>>2],!r)break}k=f+4|0}r=E(28),i[r+24>>2]=n,i[r+20>>2]=h,i[r+16>>2]=o,i[r+8>>2]=f,i[r>>2]=0,i[r+4>>2]=0,i[k>>2]=r,f=i[i[e+124>>2]>>2],f&&(i[e+124>>2]=f),m1(i[e+128>>2],r),i[e+132>>2]=i[e+132>>2]+1;break o}if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break o;X[i[i[n>>2]+8>>2]](n),p(n)}if(_=_+8|0,(t|0)==(_|0))break}k8(A,107712)}ve(w+24|0);break n}if(u[w+24|0]=0,u[w+35|0]=0,K(A,2,109,w+24|0),u[w+35|0]>=0)break n;Z(i[w+24>>2])}if(k=i[w+36>>2],!k)break k;if(r=k,f=i[w+40>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];n:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break n;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(k|0)==(f|0))break}r=i[w+36>>2]}i[w+40>>2]=k,Z(r)}if(v=w+48|0,i[A>>2])break A;u[A+19|0]<0&&Z(i[A+8>>2]),r=i[e+140>>2]}k:{if(!r)break k;r=v-16|0,v=r,k=i[e+140>>2],f=i[k+36>>2],k=i[k+40>>2];n:{if((f|0)!=(k|0))for(;;){t:{if(s=i[f>>2],!s||(s=X0(s,86628,104488),!s))break t;if(k=i[f+4>>2],!k){k=0;break n}i[k+4>>2]=i[k+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}k=0,s=0}i[e+148>>2]=s,f=i[e+152>>2],i[e+152>>2]=k,f&&(k=i[f+4>>2],i[f+4>>2]=k-1,k||(X[i[i[f>>2]+8>>2]](f),p(f)),s=i[e+148>>2]);n:{if(!s){if(e=E(32),i[r+4>>2]=e,i[r+8>>2]=30,i[r+12>>2]=-2147483616,f=l[25619]|l[25620]<<8|(l[25621]<<16|l[25622]<<24),k=l[25615]|l[25616]<<8|(l[25617]<<16|l[25618]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+30|0]=0,f=l[25641]|l[25642]<<8|(l[25643]<<16|l[25644]<<24),k=l[25637]|l[25638]<<8|(l[25639]<<16|l[25640]<<24),u[e+22|0]=k,u[e+23|0]=k>>>8,u[e+24|0]=k>>>16,u[e+25|0]=k>>>24,u[e+26|0]=f,u[e+27|0]=f>>>8,u[e+28|0]=f>>>16,u[e+29|0]=f>>>24,f=l[25635]|l[25636]<<8|(l[25637]<<16|l[25638]<<24),k=l[25631]|l[25632]<<8|(l[25633]<<16|l[25634]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[25627]|l[25628]<<8|(l[25629]<<16|l[25630]<<24),k=l[25623]|l[25624]<<8|(l[25625]<<16|l[25626]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,r+4|0),u[r+15|0]>=0)break n;Z(i[r+4>>2]);break n}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){f=i[26931],i[e>>2]=i[26930],i[e+4>>2]=f,i[e+8>>2]=i[26932];break n}T(e,i[26930],i[26931])}if(v=r+16|0,i[A>>2])break A;if(u[A+19|0]>=0)break k;Z(i[A+8>>2])}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break A}T(A,i[26930],i[26931])}v=W+160|0;break e}G0(),H()}x0(),H()}if(u[B+43|0]>=0)break i;Z(i[B+32>>2])}v=B+48|0}function hf(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;s=v-192|0,v=s,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+132>>2]=f,f=i[e+136>>2],i[e+136>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;X[i[i[f>>2]+8>>2]](f),p(f)}i:{e:{r:{if(k=i[r>>2],f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))for(;;){f:{if(k=i[f>>2],!k||(k=X0(k,86628,104568),!k))break f;C=i[f+4>>2],C&&(i[C+4>>2]=i[C+4>>2]+2),i[e+140>>2]=k,f=i[e+144>>2],i[e+144>>2]=C;A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}if(i[e+24>>2]=i[k+120>>2],k=i[r>>2],f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))break r;break e}if(f=f+8|0,(n|0)==(f|0))break}if(e=E(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23210]|l[23211]<<8|(l[23212]<<16|l[23213]<<24),f=l[23206]|l[23207]<<8|(l[23208]<<16|l[23209]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23226]|l[23227]<<8|(l[23228]<<16|l[23229]<<24),f=l[23222]|l[23223]<<8|(l[23224]<<16|l[23225]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23218]|l[23219]<<8|(l[23220]<<16|l[23221]<<24),f=l[23214]|l[23215]<<8|(l[23216]<<16|l[23217]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+24|0),u[s+35|0]>=0)break i;Z(i[s+24>>2]);break i}for(;;){r:{if(k=i[f>>2],!k||(k=X0(k,86628,93832),!k))break r;y=i[f+4>>2],y&&(i[y+4>>2]=i[y+4>>2]+1),f=i[k+36>>2],n=i[k+40>>2];f:{if((f|0)!=(n|0))for(;;){A:{if(k=i[f>>2],!k||(k=X0(k,86628,106456),!k))break A;if(t=i[f+4>>2],!t){t=0;break f}i[t+4>>2]=i[t+4>>2]+1;break f}if(f=f+8|0,(n|0)==(f|0))break}k=0}if(i[e+236>>2]=k,f=i[e+240>>2],i[e+240>>2]=t,!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break e;X[i[i[f>>2]+8>>2]](f),p(f);break e}if(f=f+8|0,(n|0)==(f|0))break}}f=i[r>>2],k=i[f+36>>2],t=i[f+40>>2];e:{if((k|0)!=(t|0))for(f=k;;){r:{if(n=i[f>>2],!n||(n=X0(n,86628,93032),!n))break r;R=i[f+4>>2],R&&(i[R+4>>2]=i[R+4>>2]+1,f=i[r>>2],t=i[f+40>>2],k=i[f+36>>2]);f:{if((k|0)!=(t|0))for(;;){A:{if(f=i[k>>2],!f||(f=X0(f,86628,106376),!f))break A;if(t=i[k+4>>2],!t){t=0;break f}i[t+4>>2]=i[t+4>>2]+1;break f}if(k=k+8|0,(t|0)==(k|0))break}t=0,f=0}i[e+244>>2]=f,f=i[e+248>>2],i[e+248>>2]=t;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;X[i[i[f>>2]+8>>2]](f),p(f)}k=i[n+36>>2],t=i[n+40>>2];f:{if((k|0)!=(t|0))for(f=k;;){A:{if(o=i[f>>2],!o||(o=X0(o,86628,87232),!o))break A;N=i[f+4>>2],N&&(i[N+4>>2]=i[N+4>>2]+1,t=i[n+40>>2],k=i[n+36>>2]),i[e+28>>2]=i[o+108>>2];k:{if((k|0)!=(t|0))for(;;){n:{if(f=i[k>>2],!f||(f=X0(f,86628,93192),!f))break n;if(t=i[k+4>>2],!t){t=0;break k}i[t+4>>2]=i[t+4>>2]+1;break k}if(k=k+8|0,(t|0)==(k|0))break}t=0,f=0}i[e+148>>2]=f,k=i[e+152>>2],i[e+152>>2]=t,k&&(f=i[k+4>>2],i[k+4>>2]=f-1,f||(X[i[i[k>>2]+8>>2]](k),p(k)),f=i[e+148>>2]);k:{if(!f){if(e=E(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23160]|l[23161]<<8|(l[23162]<<16|l[23163]<<24),f=l[23156]|l[23157]<<8|(l[23158]<<16|l[23159]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23176]|l[23177]<<8|(l[23178]<<16|l[23179]<<24),f=l[23172]|l[23173]<<8|(l[23174]<<16|l[23175]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23168]|l[23169]<<8|(l[23170]<<16|l[23171]<<24),f=l[23164]|l[23165]<<8|(l[23166]<<16|l[23167]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+24|0),u[s+35|0]>=0)break k;Z(i[s+24>>2]);break k}f=i[n+36>>2],n=i[n+40>>2];n:{if((f|0)!=(n|0))for(;;){t:{if(k=i[f>>2],!k||(k=X0(k,86628,104648),!k))break t;if(t=i[f+4>>2],!t){t=0;break n}i[t+4>>2]=i[t+4>>2]+1;break n}if(f=f+8|0,(n|0)==(f|0))break}t=0,k=0}if(i[e+156>>2]=k,f=i[e+160>>2],i[e+160>>2]=t,f&&(k=i[f+4>>2],i[f+4>>2]=k-1,k||(X[i[i[f>>2]+8>>2]](f),p(f)),k=i[e+156>>2]),!k){if(e=E(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23235]|l[23236]<<8|(l[23237]<<16|l[23238]<<24),f=l[23231]|l[23232]<<8|(l[23233]<<16|l[23234]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23251]|l[23252]<<8|(l[23253]<<16|l[23254]<<24),f=l[23247]|l[23248]<<8|(l[23249]<<16|l[23250]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23243]|l[23244]<<8|(l[23245]<<16|l[23246]<<24),f=l[23239]|l[23240]<<8|(l[23241]<<16|l[23242]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+24|0),u[s+35|0]>=0)break k;Z(i[s+24>>2]);break k}n:{t:{if(k=i[e+148>>2],f=i[k+36>>2],k=i[k+40>>2],(f|0)!=(k|0))for(;;){u:{if(n=i[f>>2],!n||(W=X0(n,86628,93352),!W))break u;D=i[f+4>>2],D&&(i[D+4>>2]=i[D+4>>2]+1),n=s+24|0;o:{l:{if(t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=X0(f,86628,104888),f))break l;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=X0(f,86628,104888),f))break l;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break o}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break o;i[f+4>>2]=i[f+4>>2]+1}if(E8(e+180|0,n),V2(n),i[e+180>>2])break t;if(e=A,A=d2(n,23181),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}if(f=f+8|0,(k|0)==(f|0))break}if(e=A,A=d2(s+24|0,23131),K(e,2,0,A),u[A+11|0]>=0)break k;Z(i[A>>2]);break k}n=s+24|0;t:{u:{if(t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=X0(f,86628,105128),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=X0(f,86628,105128),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(E8(e+188|0,n),V2(n),!i[e+188>>2]){if(e=A,A=d2(n,23256),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=X0(f,86628,105208),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=X0(f,86628,105208),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(E8(e+196|0,n),V2(n),!i[e+196>>2]){if(e=A,A=d2(n,23106),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=X0(f,86628,105288),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=X0(f,86628,105288),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(E8(e+228|0,n),V2(n),!i[e+228>>2]){if(e=A,A=d2(n,22809),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=X0(f,86628,104968),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=X0(f,86628,104968),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(E8(e+204|0,n),V2(n),f=i[e+204>>2],!f){if(e=A,A=d2(n,22902),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}if((ol(f)|0)!=i[i[e+228>>2]+108>>2]){if(e=A,A=d2(s+24|0,23390),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}t:{if(f=i[e+212>>2],!f||(ol(f)|0)==i[i[e+228>>2]+108>>2])break t;if(e=A,A=d2(s+24|0,23446),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}h=i[e+196>>2],i[s+176>>2]=0;t:{if(i[h+108>>2]!=i[h+104>>2])for(f0=e+100|0,A0=e+280|0,g=-1,f=0;;){if(B=f+1|0,k=TA(i[e+188>>2],B),!k){if(e=A,A=d2(s+24|0,24654),K(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=i[k+8>>2],i[s+32>>2]=n,o=i[k+4>>2],i[s+24>>2]=i[k>>2],i[s+28>>2]=o,o=i[e+180>>2],k=i[o+104>>2];u:{n=n-1|0;o:{if(n>>>0>=i[o+108>>2]-k>>3>>>0){i[s+140>>2]=0,i[s+144>>2]=0;break o}if(n=k+(n<<3)|0,k=i[n>>2],i[s+140>>2]=k,n=i[n+4>>2],i[s+144>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),k)break u}if(e=A,A=d2(s+48|0,24306),K(e,2,0,A),u[A+11|0]>=0)break t;Z(i[A>>2]);break t}u:{o:{if(w=i[k+36>>2],n=i[k+40>>2],(w|0)!=(n|0)){if(k=i[w>>2],k&&(t=i[s+132>>2],k=X0(k,86628,105528),k))break o;if(w=w+8|0,(n|0)!=(w|0))for(;;){if(k=i[w>>2],k&&(t=0,k=X0(k,86628,105528),k))break o;if(w=w+8|0,(n|0)==(w|0))break}i[s+128>>2]=0,i[s+132>>2]=0}i[s+128>>2]=0,i[s+132>>2]=0;break u}if(i[s+132>>2]=t,i[s+128>>2]=k,k=i[w+4>>2],i[s+132>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[s+128>>2],k){u:{if(u[k+115|0]>=0){i[s+56>>2]=i[k+112>>2],n=i[k+108>>2],i[s+48>>2]=i[k+104>>2],i[s+52>>2]=n;break u}T(s+48|0,i[k+104>>2],i[k+108>>2])}u[e+263|0]<0&&Z(i[e+252>>2]),k=i[s+52>>2],i[e+252>>2]=i[s+48>>2],i[e+256>>2]=k,i[e+260>>2]=i[s+56>>2]}if(V2(s+128|0),!i[A0>>2]){n=s+48|0;u:{o:{if(k=i[s+140>>2],w=i[k+36>>2],o=i[k+40>>2],(w|0)!=(o|0)){if(k=i[w>>2],k&&(t=i[n+4>>2],k=X0(k,86628,86672),k))break o;if(w=w+8|0,(o|0)!=(w|0))for(;;){if(k=i[w>>2],k&&(t=0,k=X0(k,86628,86672),k))break o;if(w=w+8|0,(o|0)==(w|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break u}if(i[n+4>>2]=t,i[n>>2]=k,k=i[w+4>>2],i[n+4>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}i[s+48>>2]&&r3(A0,n),V2(s+48|0)}if(u0[i[e+228>>2]+108>>2]<i[s+28>>2]+i[s+176>>2]>>>0){if(e=A,A=d2(s+48|0,22834),K(e,2,0,A),u[A+11|0]>=0)break t;Z(i[A>>2]);break t}n=i[i[e+196>>2]+104>>2],_=v-16|0,v=_,a=E(68),k=a,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=106680,o=i[(f<<2)+n>>2],n=0,$=i[s+28>>2],I=i[s+176>>2],t=i[e+24>>2],w=i[e+20>>2],i[_+8>>2]=i[e+228>>2],k=i[e+232>>2],i[_+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),O=0,k=a+12|0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+8>>2]=t,i[k+4>>2]=w,i[k+16>>2]=I,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,m=0,i[k+52>>2]=0,i[k>>2]=106516,i[k+24>>2]=I,i[k+20>>2]=(I+$|0)-1;u:{o:{l:{if($)for(;;){t=i[_+8>>2],w=i[t+104>>2],w||(w=i[(i[t+112>>2]+(I<<2)|0)+(O<<2)>>2]),V=i[k+36>>2];s:{if(V>>>0>m>>>0){i[m+8>>2]=w,i[m>>2]=o,i[m+4>>2]=n,m=m+16|0;break s}if(x=i[k+28>>2],L=m-x|0,S=L>>4,t=S+1|0,t>>>0>=268435456)break l;if(m=V-x|0,V=m>>3,V=m>>>0>=2147483632?268435455:t>>>0<V>>>0?V:t,V){if(V>>>0>=268435456)break o;t=E(V<<4)}else t=0;if(m=t+L|0,i[m+8>>2]=w,i[m>>2]=o,i[m+4>>2]=n,S=m-(S<<4)|0,L&&z(S,x,L),i[k+36>>2]=t+(V<<4),m=m+16|0,i[k+32>>2]=m,i[k+28>>2]=S,!x)break s;Z(x)}if(i[k+32>>2]=m,o=o+w|0,n=o>>>0<w>>>0?n+1|0:n,O=O+1|0,($|0)==(O|0))break}break u}G0(),H()}x0(),H()}n=i[_+12>>2];u:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break u;X[i[i[n>>2]+8>>2]](n),p(n)}i[s+52>>2]=a,i[s+48>>2]=k,v=_+16|0;u:{o:{if(k=i[s+140>>2],!k||(k=X0(k,86628,105608),!k))break o;if(i[s+128>>2]=k,k=i[s+144>>2],i[s+132>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1;break u}i[s+128>>2]=0,i[s+132>>2]=0}if(k=i[s+128>>2],k){w=i[s+48>>2];u:{if(!(!f|i[s+32>>2]!=(g|0))){k=s+168|0,f=i[(i[f0>>2]+(f<<3)|0)-8>>2],X[i[i[f>>2]+8>>2]](k,f),f=k;break u}i[s+152>>2]=k,f=i[s+132>>2],i[s+156>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+156>>2],i[s+16>>2]=i[s+152>>2],i[s+20>>2]=f,n=s+160|0,_=v-16|0,v=_,f=i[s+16>>2];o:{if(u[f+143|0]>=0){i[_+8>>2]=i[f+140>>2],k=i[f+136>>2],i[_>>2]=i[f+132>>2],i[_+4>>2]=k;break o}T(_,i[f+132>>2],i[f+136>>2])}o:{l:{s:{w:{_:{if(k=i[f+16>>2],(k|0)<=1781689192){h:{B:{v:{Z:{if((k|0)!=1635135537){if((k|0)==1635148593)break Z;if((k|0)!=1752589105)break _;t=i[f+36>>2],f=i[f+40>>2];G:{m:{if((t|0)!=(f|0))for(;;){W:{if(k=i[t>>2],!k||(k=X0(k,86628,97612),!k))break W;if(f=i[t+4>>2],!f)break m;i[f+4>>2]=i[f+4>>2]+1;break G}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=E(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97128,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=97696,!f)break v;if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;X[i[i[f>>2]+8>>2]](f),p(f);break o}t=i[f+36>>2],f=i[f+40>>2];G:{m:{if((t|0)!=(f|0))for(;;){W:{if(k=i[t>>2],!k||(k=X0(k,86628,98188),!k))break W;if(f=i[t+4>>2],!f)break m;i[f+4>>2]=i[f+4>>2]+1;break G}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=E(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97168,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98064,!f)break B;if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;X[i[i[f>>2]+8>>2]](f),p(f);break o}t=i[f+36>>2],f=i[f+40>>2];Z:{if((t|0)!=(f|0))for(;;){G:{if(k=i[t>>2],!k||(k=X0(k,86628,100220),!k))break G;if(f=i[t+4>>2],!f){f=0;break Z}i[f+4>>2]=i[f+4>>2]+1;break Z}if(t=t+8|0,(f|0)==(t|0))break}f=0,k=0}if(o=E(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97208,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=100240,!f)break h;if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;X[i[i[f>>2]+8>>2]](f),p(f);break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}h:{if((k|0)!=1781689193){if((k|0)==1835692135)break h;if((k|0)!=1987470129)break _;t=i[f+36>>2],f=i[f+40>>2];B:{v:{if((t|0)!=(f|0))for(;;){Z:{if(k=i[t>>2],!k||(k=X0(k,86628,99924),!k))break Z;if(f=i[t+4>>2],!f)break v;i[f+4>>2]=i[f+4>>2]+1;break B}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=E(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97288,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=99728,!f)break w;if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;X[i[i[f>>2]+8>>2]](f),p(f);break o}t=i[f+36>>2],f=i[f+40>>2];B:{if((t|0)!=(f|0))for(;;){v:{if(k=i[t>>2],!k||(k=X0(k,86628,99524),!k))break v;if(f=i[t+4>>2],!f){f=0;break B}i[f+4>>2]=i[f+4>>2]+1;break B}if(t=t+8|0,(f|0)==(t|0))break}f=0,k=0}if(o=E(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97248,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98952,!f)break s;if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;X[i[i[f>>2]+8>>2]](f),p(f);break o}t=i[f+36>>2],k=i[f+40>>2];h:{if((t|0)!=(k|0))for(;;){B:{if(f=i[t>>2],!f||(f=X0(f,86628,98612),!f))break B;if(k=i[t+4>>2],!k){k=0;break h}i[k+4>>2]=i[k+4>>2]+1;break h}if(t=t+8|0,(k|0)==(t|0))break}k=0,f=0}if(o=E(112),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97328,k&&(i[k+4>>2]=i[k+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=k,i[o+80>>2]=f,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98632,!k)break l;if(i[k+4>>2]=i[k+4>>2]+1,u[o+104|0]=0,u[o+88|0]=0,f=i[k+4>>2],i[k+4>>2]=f-1,f||(X[i[i[k>>2]+8>>2]](k),p(k)),i[n+4>>2]=o,i[n>>2]=t,f=i[k+4>>2],i[k+4>>2]=f-1,f)break o;X[i[i[k>>2]+8>>2]](k),p(k);break o}i[n>>2]=0,i[n+4>>2]=0;break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}u[o+104|0]=0,u[o+88|0]=0,i[n+4>>2]=o,i[n>>2]=t}u[_+11|0]<0&&Z(i[_>>2]),f=i[s+20>>2];o:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break o;X[i[i[f>>2]+8>>2]](f),p(f)}v=_+16|0,f=n}k=i[f+4>>2],i[s+8>>2]=i[f>>2],i[s+12>>2]=k,f=i[s+8>>2],k=i[s+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[w+40>>2]=f,f=i[w+44>>2],i[w+44>>2]=k;u:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break u;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[s+12>>2];u:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break u;X[i[i[f>>2]+8>>2]](f),p(f)}}if(V2(s+128|0),f=s+48|0,r2(f0,f),i[s+176>>2]=i[s+176>>2]+i[s+28>>2],g=i[s+32>>2],V2(f),V2(s+140|0),f=B,!(f>>>0<i[h+108>>2]-i[h+104>>2]>>2>>>0))break}if(f=v-16|0,v=f,n=s+140|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0))for(;;){k=i[t>>2];u:{if(!k||(k=X0(k,86628,106136),!k)||(i[f+8>>2]=k,k=i[t+4>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(n,f+8|0),k=i[f+12>>2],!k)||(B=i[k+4>>2],i[k+4>>2]=B-1,B))break u;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t+8|0,(o|0)==(t|0))break}if(v=f+16|0,f=v-16|0,v=f,n=s+128|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t=i[W+36>>2],o=i[W+40>>2],(t|0)!=(o|0))for(;;){k=i[t>>2];u:{if(!k||(k=X0(k,86628,106216),!k)||(i[f+8>>2]=k,k=i[t+4>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(n,f+8|0),k=i[f+12>>2],!k)||(B=i[k+4>>2],i[k+4>>2]=B-1,B))break u;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t+8|0,(o|0)==(t|0))break}v=f+16|0;u:{o:{l:{if(o=i[s+144>>2],f=i[s+140>>2],(i[s+132>>2]-i[s+128>>2]|0)==(o-f|0)){if((f|0)!=(o|0))for(B=e+276|0,W=e+272|0,t=e+100|0;;){if(k=i[f>>2],_=i[k+108>>2],n=i[k+104>>2],i[s+48>>2]=0,i[s+52>>2]=0,k=i[s+128>>2],g=i[s+132>>2],(k|0)==(g|0))break l;for(;;){if(w=i[k>>2],!((n|0)==i[w+104>>2]&(_|0)==i[w+108>>2])){if(k=k+8|0,(g|0)!=(k|0))continue;break l}break}if(r3(s+48|0,k),k=i[s+48>>2],!k)break l;s:{if(k=i[k+132>>2]-i[k+128>>2]|0,(k|0)==8||(_=k>>3,k=i[e+196>>2],(_|0)==i[k+108>>2]-i[k+104>>2]>>2))break s;if(e=A,A=d2(s+24|0,23026),K(e,2,0,A),u[A+11|0]>=0)break o;Z(i[A>>2]);break o}s:{if((n|0)!=1937006953){if((n|0)!=1937074532)break s;k=q9(f,s+48|0,t),i[s+24>>2]=0,_i(B,k),_i(s+24|0,0);break s}k=q9(f,s+48|0,t),i[s+24>>2]=0,_i(W,k),_i(s+24|0,0)}if(V2(s+48|0),f=f+8|0,(o|0)==(f|0))break}s:{w:{if(r=i[r>>2],k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+124>>2],r=X0(r,86628,87152),r))break w;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=X0(r,86628,87152),r))break w;if(k=k+8|0,(n|0)==(k|0))break}i[s+120>>2]=0,i[s+124>>2]=0}i[s+120>>2]=0,i[s+124>>2]=0;break s}if(i[s+124>>2]=f,i[s+120>>2]=r,r=i[k+4>>2],i[s+124>>2]=r,!r)break s;i[r+4>>2]=i[r+4>>2]+1}s:{if(r=i[s+120>>2],r){w:{_:{if(k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+116>>2],r=X0(r,86628,89712),r))break _;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=X0(r,86628,89712),r))break _;if(k=k+8|0,(n|0)==(k|0))break}i[s+112>>2]=0,i[s+116>>2]=0}i[s+112>>2]=0,i[s+116>>2]=0;break w}if(i[s+116>>2]=f,i[s+112>>2]=r,r=i[k+4>>2],i[s+116>>2]=r,!r)break w;i[r+4>>2]=i[r+4>>2]+1}w:{_:{if(r=i[s+120>>2],k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+108>>2],r=X0(r,86628,88260),r))break _;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=X0(r,86628,88260),r))break _;if(k=k+8|0,(n|0)==(k|0))break}i[s+104>>2]=0,i[s+108>>2]=0}i[s+104>>2]=0,i[s+108>>2]=0;break w}if(i[s+108>>2]=f,i[s+104>>2]=r,r=i[k+4>>2],i[s+108>>2]=r,!r)break w;i[r+4>>2]=i[r+4>>2]+1}if(GA(s+96|0,i[s+120>>2]),r=i[s+96>>2],r){if(Zu(s+84|0,r),k=i[s+84>>2],t=i[s+88>>2],(k|0)!=(t|0))for(B=e+52|0,r=i[26660],W=i[26661];;){f=i[k>>2];w:{if(i[f+112>>2]!=1970432288||(f=f+152|0,o=u[f+11|0],n=(o|0)<0,o=n?i[f+4>>2]:o,(h2(21434)|0)==(o|0)?f=N2(n?i[f>>2]:f,21434,o):f=1,f))break w;if(o=i[i[k>>2]+104>>2],i[s+80>>2]=0,i[s+72>>2]=0,i[s+76>>2]=0,_=i[s+112>>2],f=i[e+20>>2],n=i[f+48>>2],i[s+184>>2]=n,f=i[f+52>>2],i[s+188>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),i[s+24>>2]=i[n+8>>2],f=i[n+12>>2],i[s+28>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=s+24|0,n=s+72|0,K6(s+48|0,_,o,f,s+104|0,n,0,0,-1,-1,i[e+20>>2]- -64|0),V2(f),o=s+184|0,V2(o),Vf(f,n),l[s+44|0])break s;if(Co(B,f),n=l[s+44|0],(n|0)!=255&&(i[s+184>>2]=r,i[s+188>>2]=W,X[i[o+(n<<2)>>2]](s+183|0,f)),u[s+67|0]<0&&Z(i[s+56>>2]),f=i[s+72>>2],!f)break w;i[s+76>>2]=f,Z(f)}if(k=k+8|0,(t|0)==(k|0))break}ve(s+84|0)}V2(s+96|0),V2(s+104|0),V2(s+112|0)}if(V2(s+120|0),u0[i[e+228>>2]+108>>2]>u0[i[e+20>>2]+144>>2]){if(e=A,A=d2(s+24|0,17296),K(e,6,1e3,A),u[A+11|0]>=0)break u;Z(i[A>>2]);break u}W=s+24|0,w=0,k=0,g=0,m=0,o=0,n=0,f=0,h=v-32|0,v=h,r=i[i[e+228>>2]+108>>2],i[e+64>>2]=r;w:{if(!r){t=0;break w}t=0;_:{for(;;){i[h+4>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0,i[h+16>>2]=0,_=f,f=f+1|0,B=i[e+204>>2],r=i[B+104>>2],r=(r|0)!=i[B+108>>2]?i[r+4>>2]:0,I=i[e+100>>2],B=i[e+104>>2]-I>>3;h:{if(B>>>0<=k>>>0|u0[i[I+(k<<3)>>2]+20>>2]>=m>>>0)break h;if(f=0,k=k+1|0,(B|0)!=(k|0))for(;;){if(u0[i[I+(k<<3)>>2]+20>>2]>=m>>>0)break h;if(k=k+1|0,(B|0)==(k|0))break}k=B}h:{B:{if(w>>>0<g>>>0){i[w+8>>2]=k,i[w+4>>2]=_,i[w>>2]=m,B=i[h+4>>2],i[w+12>>2]=i[h>>2],i[w+16>>2]=B,B=i[h+12>>2],i[w+20>>2]=i[h+8>>2],i[w+24>>2]=B,i[w+28>>2]=i[h+16>>2],i[w+44>>2]=0,i[w+40>>2]=r,i[w+32>>2]=o,i[w+36>>2]=n,w=w+48|0;break B}if(B=w-t|0,I=((B|0)/48|0)+1|0,I>>>0>=89478486)break h;if(g=(g-t|0)/48|0,w=g<<1,I=g>>>0>=44739242?89478485:w>>>0>I>>>0?w:I,I){if(I>>>0>=89478486)break _;g=E(G(I,48))}else g=0;w=g+B|0,i[w+8>>2]=k,i[w+4>>2]=_,i[w>>2]=m,_=i[h+4>>2],i[w+12>>2]=i[h>>2],i[w+16>>2]=_,_=i[h+12>>2],i[w+20>>2]=i[h+8>>2],i[w+24>>2]=_,i[w+28>>2]=i[h+16>>2],i[w+44>>2]=0,i[w+40>>2]=r,i[w+32>>2]=o,i[w+36>>2]=n,_=w+G((B|0)/-48|0,48)|0,B&&z(_,t,B),w=w+48|0,g=g+G(I,48)|0,t&&Z(t),t=_}if(o=r+o|0,n=o>>>0<r>>>0?n+1|0:n,m=m+1|0,m>>>0>=u0[e+64>>2])break w;continue}break}i[h+28>>2]=g,i[h+24>>2]=w,i[h+20>>2]=t,G0(),H()}x0(),H()}i[h+28>>2]=g,i[h+24>>2]=w,i[h+20>>2]=t;w:{_:{h:{if(f=e,r=Yo(i[f+20>>2]),o=i[f+156>>2],(r|0)!=i[o+120>>2]||(n=i[f+236>>2],!n)||(k=i[n+104>>2],(i[n+108>>2]-k|0)!=24|(i[k+8>>2]|i[k+12>>2]))||(r=i[k>>2],k=i[k+4>>2],!(u[n+100|0]&1)|((r|0)!=i[o+128>>2]|(k|0)!=i[o+132>>2])))break h;if(n=f+68|0,(n|0)!=(h+20|0)&&(Xt(n,t,w,(w-t|0)/48|0),k=i[f+156>>2],r=i[k+128>>2],k=i[k+132>>2]),!(r|k)){e=d2(h,24282),K(W,2,0,e),u[e+11|0]<0&&Z(i[e>>2]),t=i[h+20>>2];break w}r=Wo(i[e+20>>2]),e=i[e+156>>2],e=d8(r,l0,i[e+128>>2],i[e+132>>2]),t=i[h+20>>2],e=O0(e,l0,(i[h+24>>2]-t|0)/48|0,0),r=l0;break _}e=e+68|0,(e|0)!=(h+20|0)&&(Xt(e,t,w,(w-t|0)/48|0),w=i[h+24>>2],t=i[h+20>>2]),e=(w-t|0)/48|0,r=0}i[f+80>>2]=e,i[f+84>>2]=r,e=W,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0}if(t&&(i[h+24>>2]=t,Z(t)),v=h+32|0,i[s+24>>2]){e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=i[s+36>>2],i[A+8>>2]=i[s+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[s+40>>2];break u}if(i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,u[s+43|0]>=0)break u;Z(i[s+32>>2]);break u}_2(),H()}if(e=A,A=d2(s+24|0,23872),K(e,2,0,A),u[A+11|0]>=0)break u;Z(i[A>>2]);break u}if(e=A,A=d2(s+24|0,23066),K(e,2,0,A),u[A+11|0]>=0)break o;Z(i[A>>2])}V2(s+48|0)}ve(s+128|0),ve(s+140|0);break n}V2(s+140|0)}if(!D||(A=i[D+4>>2],i[D+4>>2]=A-1,A))break k;X[i[i[D>>2]+8>>2]](D),p(D)}if(!N||(A=i[N+4>>2],i[N+4>>2]=A-1,A))break f;X[i[i[N>>2]+8>>2]](N),p(N);break f}if(f=f+8|0,(t|0)==(f|0))break}if(e=E(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[22931]|l[22932]<<8|(l[22933]<<16|l[22934]<<24),f=l[22927]|l[22928]<<8|(l[22929]<<16|l[22930]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[22947]|l[22948]<<8|(l[22949]<<16|l[22950]<<24),f=l[22943]|l[22944]<<8|(l[22945]<<16|l[22946]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22939]|l[22940]<<8|(l[22941]<<16|l[22942]<<24),f=l[22935]|l[22936]<<8|(l[22937]<<16|l[22938]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+24|0),u[s+35|0]>=0)break f;Z(i[s+24>>2])}if(!R||(A=i[R+4>>2],i[R+4>>2]=A-1,A))break e;X[i[i[R>>2]+8>>2]](R),p(R);break e}if(f=f+8|0,(t|0)==(f|0))break}if(e=E(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23285]|l[23286]<<8|(l[23287]<<16|l[23288]<<24),f=l[23281]|l[23282]<<8|(l[23283]<<16|l[23284]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23301]|l[23302]<<8|(l[23303]<<16|l[23304]<<24),f=l[23297]|l[23298]<<8|(l[23299]<<16|l[23300]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23293]|l[23294]<<8|(l[23295]<<16|l[23296]<<24),f=l[23289]|l[23290]<<8|(l[23291]<<16|l[23292]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+24|0),u[s+35|0]>=0)break e;Z(i[s+24>>2])}e:{if(!y||(A=i[y+4>>2],i[y+4>>2]=A-1,A))break e;X[i[i[y>>2]+8>>2]](y),p(y)}if(!C||(A=i[C+4>>2],i[C+4>>2]=A-1,A))break i;X[i[i[C>>2]+8>>2]](C),p(C)}v=s+192|0}function S_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0;y=v+-64|0,v=y,W=i[e+116>>2],_=t+4|0,h=_,s=h,o=i[t+4>>2];i:{e:{r:{if(!o)break r;for(s=o;m=W>>>0>u0[s+16>>2],h=m?h:s,s=i[(m?4:0)+s>>2],!!s;);if(!((h|0)==(_|0)|W>>>0<u0[h+16>>2])){f=E(32),i[y+28>>2]=f,i[y+32>>2]=28,i[y+36>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=K(y+40|0,2,0,y+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[y+39|0]>=0)break i;Z(i[y+28>>2]);break i}for(;;){if(s=o,h=i[s+16>>2],h>>>0>W>>>0){if(h=s,o=i[s>>2],o)continue;break r}if(h>>>0>=W>>>0)break e;if(o=i[s+4>>2],!o)break}h=s+4|0}o=E(20),i[o+8>>2]=s,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=W,i[h>>2]=o,s=i[i[t>>2]>>2],s&&(i[t>>2]=s),m1(i[t+4>>2],o),i[t+8>>2]=i[t+8>>2]+1}if(f){i[y+20>>2]=0,i[y+24>>2]=0,i[y+16>>2]=y+20,o=y+16|0,t8(o,i[t>>2],_),s=v-48|0,v=s,f=s+24|0,r4(f,i[e+100>>2],i[(i[e+460>>2]+(G(F[e+450>>1],n)<<2)|0)+(k<<2)>>2],1),t=i[s+28>>2],e=f,f=i[s+24>>2],X[i[i[f>>2]+52>>2]](e,f);e:{if(i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}u[s+43|0]<0&&Z(i[s+32>>2]),i[s+16>>2]=0,i[s+20>>2]=0,i[s+12>>2]=s+16,e=s+12|0,t8(e,i[o>>2],o+4|0),X[i[i[f>>2]+104>>2]](A,f,r,1,k,n,e),Y1(e,i[s+16>>2])}e:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break e;X[i[i[t>>2]+8>>2]](t),p(t)}v=s+48|0,Y1(o,i[y+20>>2]);break i}i[y+8>>2]=0,i[y+12>>2]=0,i[y+4>>2]=y+8,$0=y+4|0,t8($0,i[t>>2],_),f=0,w=v-240|0,v=w,i[w+232>>2]=0,i[w+236>>2]=0;e:{r:{f:{A:{k:{if(k=i[e+460>>2],t=i[e+464>>2],(k|0)==(t|0))break k;for(;;){if(n=i[k>>2],Io(i[e+100>>2],n)){if(k=k+4|0,(t|0)!=(k|0))continue;break k}break}i[w+172>>2]=0,i[w+144>>2]=72244,i[w+88>>2]=72224,e=i[18065],i[w+80>>2]=e,k=w+80|0,i[k+i[e-12>>2]>>2]=i[18066],i[w+84>>2]=0,e=k+i[i[w+80>>2]-12>>2]|0,f=w+92|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[w+88>>2]=e,r=w+88|0,i[r+i[e-12>>2]>>2]=i[18068],e=i[18064],i[w+80>>2]=e,i[k+i[e-12>>2]>>2]=i[18069],i[w+144>>2]=72244,i[w+80>>2]=72204,i[w+88>>2]=72224,k=R0(f),i[k>>2]=71280,i[w+132>>2]=0,i[w+136>>2]=0,i[w+124>>2]=0,i[w+128>>2]=0,i[w+140>>2]=24,Y(I0(Y(r,21029,14),n),25357,23),e=i[w+140>>2];n:{if(e&16){t=w+112|0,e=i[w+136>>2],r=i[w+116>>2],e>>>0<r>>>0&&(i[w+136>>2]=r,e=r);break n}if(!(e&8)){e=0,u[w+55|0]=0,t=w+44|0;break r}t=w+100|0,e=i[w+108>>2]}if(f=i[t>>2],e=e-f|0,e>>>0>=2147483640)break A;if(e>>>0>=11){r=e|7,t=E(r+1|0),i[w+52>>2]=r-2147483647,i[w+44>>2]=t,i[w+48>>2]=e;break f}if(u[w+55|0]=e,t=w+44|0,e)break f;e=0;break r}di(w+80|0,i[e+100>>2]- -64|0,i[e+452>>2],i[e+456>>2]);k:{if(i[w+80>>2]){e=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=e,r=A+8|0;n:{if(u[w+99|0]>=0){e=i[w+92>>2],i[r>>2]=i[w+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+96>>2];break n}T(r,i[w+88>>2],i[w+92>>2])}u[A+20|0]=1;break k}k=i[r+4>>2],k&&X[k|0](0,G(F[e+450>>1],F[e+448>>1]),i[r+16>>2]),k=i[r+8>>2],k&&X[k|0](0,0,i[r+16>>2]),i[w+40>>2]=0,O=E(12),i[O+8>>2]=0,i[O>>2]=0,i[O+4>>2]=0,L=E(16),i[L+12>>2]=O,i[L>>2]=101392,i[L+4>>2]=0,i[L+8>>2]=0,t=F[e+448>>1];n:{t:{if(!t)break t;for(H2=$0+4|0,C=A+8|0,k=F[e+450>>1],g=w- -64|0,T2=w+24|0,n=0;;){u:{o:{if(k&65535){P0=0,t=0;break o}k=0,n0=0;break u}for(;;){k=w+56|0,h=i[i[e+460>>2]+(h0<<2)>>2],r4(k,i[e+100>>2],h,1),e0=i[w+60>>2],_=i[w+56>>2];o:{if(!_){if(!(l[r+21|0]|!h0)){u[w+44|0]=0,u[w+55|0]=0,o=K(k,2,119,w+44|0),s=i[O+4>>2];l:{if(s>>>0<u0[O+8>>2]){k=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=k,i[s+16>>2]=i[g+8>>2],k=i[g+4>>2],i[s+8>>2]=i[g>>2],i[s+12>>2]=k,i[g>>2]=0,i[g+4>>2]=0,i[g+8>>2]=0,i[O+4>>2]=s+20;break l}if(o=ee(O,o),k=u[w+75|0],i[O+4>>2]=o,(k|0)>=0)break l;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),t=f+t|0,h0=h0+1|0,k=9,n0=0;break o}s=E(40),i[w+44>>2]=s,i[w+48>>2]=33,i[w+52>>2]=-2147483608,u[s+32|0]=l[17762],o=l[17758]|l[17759]<<8|(l[17760]<<16|l[17761]<<24),k=l[17754]|l[17755]<<8|(l[17756]<<16|l[17757]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[17750]|l[17751]<<8|(l[17752]<<16|l[17753]<<24),k=l[17746]|l[17747]<<8|(l[17748]<<16|l[17749]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[17742]|l[17743]<<8|(l[17744]<<16|l[17745]<<24),k=l[17738]|l[17739]<<8|(l[17740]<<16|l[17741]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[17734]|l[17735]<<8|(l[17736]<<16|l[17737]<<24),k=l[17730]|l[17731]<<8|(l[17732]<<16|l[17733]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+33|0]=0,o=K(w+56|0,2,119,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;l:{if(u[w+75|0]>=0){k=i[g+4>>2],i[C>>2]=i[g>>2],i[C+4>>2]=k,i[C+8>>2]=i[g+8>>2],u[A+20|0]=1;break l}if(T(C,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break l;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1,n0=0;break o}X[i[i[_>>2]+52>>2]](w+56|0,_),s=i[w+56>>2],k=0;l:{if(!s)break l;if(!(l[r+21|0]|!h0)){k=O,W=i[k+4>>2];s:{if(W>>>0<u0[k+8>>2]){if(o=i[w+60>>2],i[W>>2]=i[w+56>>2],i[W+4>>2]=o,m=W+8|0,u[w+75|0]>=0){o=i[g+4>>2],i[m>>2]=i[g>>2],i[m+4>>2]=o,i[m+8>>2]=i[g+8>>2],o=W+20|0;break s}T(m,i[w+64>>2],i[w+68>>2]),o=W+20|0;break s}o=fi(O,w+56|0)}i[k+4>>2]=o,t=f+t|0,h0=h0+1|0,k=9;break l}k=i[w+60>>2],i[A>>2]=i[w+56>>2],i[A+4>>2]=k;s:{if(u[w+75|0]>=0){k=i[g+4>>2],i[C>>2]=i[g>>2],i[C+4>>2]=k,i[C+8>>2]=i[g+8>>2];break s}T(C,i[w+64>>2],i[w+68>>2])}u[A+20|0]=1,k=1}if(u[w+75|0]<0&&Z(i[w+64>>2]),n0=0,s)break o;D0=i[_+120>>2],o=i[_+124>>2],di(w+56|0,i[e+100>>2]- -64|0,D0,o),s=i[w+60>>2],k=i[w+56>>2],i[w+80>>2]=k,i[w+84>>2]=s,u[w+99|0]<0&&(Z(i[w+88>>2]),k=i[w+80>>2]),s=i[g+4>>2],i[w+88>>2]=i[g>>2],i[w+92>>2]=s,i[w+96>>2]=i[g+8>>2];l:{if(k){if(k=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=k,u[w+99|0]>=0){k=i[w+92>>2],i[C>>2]=i[w+88>>2],i[C+4>>2]=k,i[C+8>>2]=i[w+96>>2];break l}T(C,i[w+88>>2],i[w+92>>2]);break l}s:{if(u0[e+452>>2]/F[e+450>>1]>>>0<=D0>>>0&&o>>>0>=u0[e+456>>2]/F[e+448>>1]>>>0)break s;s=E(40),i[w+44>>2]=s,i[w+48>>2]=35,i[w+52>>2]=-2147483608,k=l[14796]|l[14797]<<8|(l[14798]<<16|l[14799]<<24),u[s+31|0]=k,u[s+32|0]=k>>>8,u[s+33|0]=k>>>16,u[s+34|0]=k>>>24,o=l[14793]|l[14794]<<8|(l[14795]<<16|l[14796]<<24),k=l[14789]|l[14790]<<8|(l[14791]<<16|l[14792]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[14785]|l[14786]<<8|(l[14787]<<16|l[14788]<<24),k=l[14781]|l[14782]<<8|(l[14783]<<16|l[14784]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[14777]|l[14778]<<8|(l[14779]<<16|l[14780]<<24),k=l[14773]|l[14774]<<8|(l[14775]<<16|l[14776]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[14769]|l[14770]<<8|(l[14771]<<16|l[14772]<<24),k=l[14765]|l[14766]<<8|(l[14767]<<16|l[14768]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+35|0]=0,o=K(w+56|0,2,118,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;w:{if(u[w+75|0]>=0){k=i[g+4>>2],i[C>>2]=i[g>>2],i[C+4>>2]=k,i[C+8>>2]=i[g+8>>2],u[A+20|0]=1;break w}if(T(C,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break w;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1;break o}s:{if(!(P0|Z2)){f=D0,n=o;break s}if((f|0)==(D0|0)&(n|0)==(o|0))break s;s=E(32),i[w+44>>2]=s,i[w+48>>2]=31,i[w+52>>2]=-2147483616,o=l[5177]|l[5178]<<8|(l[5179]<<16|l[5180]<<24),k=l[5173]|l[5174]<<8|(l[5175]<<16|l[5176]<<24),u[s+23|0]=k,u[s+24|0]=k>>>8,u[s+25|0]=k>>>16,u[s+26|0]=k>>>24,u[s+27|0]=o,u[s+28|0]=o>>>8,u[s+29|0]=o>>>16,u[s+30|0]=o>>>24,o=l[5170]|l[5171]<<8|(l[5172]<<16|l[5173]<<24),k=l[5166]|l[5167]<<8|(l[5168]<<16|l[5169]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[5162]|l[5163]<<8|(l[5164]<<16|l[5165]<<24),k=l[5158]|l[5159]<<8|(l[5160]<<16|l[5161]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[5154]|l[5155]<<8|(l[5156]<<16|l[5157]<<24),k=l[5150]|l[5151]<<8|(l[5152]<<16|l[5153]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+31|0]=0,o=K(w+56|0,2,118,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;w:{if(u[w+75|0]>=0){k=i[g+4>>2],i[C>>2]=i[g>>2],i[C+4>>2]=k,i[C+8>>2]=i[g+8>>2],u[A+20|0]=1;break w}if(T(C,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break w;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1;break o}k=i[r+44>>2],k?n0=(X[k|0](i[r+16>>2])|0)!=0:n0=0,i[w+36>>2]=L,i[w+32>>2]=O,i[L+4>>2]=i[L+4>>2]+1,i[w+20>>2]=T2,i[w+24>>2]=0,i[w+28>>2]=0,o=w+20|0,t8(o,i[$0>>2],H2),k=i[w+36>>2],i[w+8>>2]=i[w+32>>2],i[w+12>>2]=k,R=w+56|0,r0=w+232|0,B=v-80|0,v=B,k=B+40|0,r4(k,i[e+100>>2],h,1),N0=i[B+44>>2];s:{w:{s=i[B+40>>2];_:{if(!(s|l[r+21|0])){s=i[w+8>>2],u[B+64|0]=0,u[B+75|0]=0,h=K(k,2,119,B- -64|0),o=i[s+4>>2];h:{if(o>>>0<u0[s+8>>2]){k=i[h+4>>2],i[o>>2]=i[h>>2],i[o+4>>2]=k,i[o+16>>2]=i[h+16>>2],k=i[h+12>>2],i[o+8>>2]=i[h+8>>2],i[o+12>>2]=k,i[h+16>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0,i[s+4>>2]=o+20;break h}if(o=ee(s,h),k=u[h+19|0],i[s+4>>2]=o,(k|0)>=0)break h;Z(i[h+8>>2])}if(u[B+75|0]<0&&Z(i[B+64>>2]),s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,X[s|0](0,k,o)),k=i[26929],i[R>>2]=i[26928],i[R+4>>2]=k,o=R+8|0,V=0,u[107731]>=0){k=i[26931],i[o>>2]=i[26930],i[o+4>>2]=k,i[o+8>>2]=i[26932];break _}T(o,i[26930],i[26931]);break _}if(X[i[i[s>>2]+52>>2]](R,s),V=0,i[R>>2])break _;u[R+19|0]<0&&Z(i[R+8>>2]),i[B+32>>2]=0,i[B+36>>2]=0,i[B+28>>2]=B+32,k=B+28|0,t8(k,i[o>>2],o+4|0),X[i[i[s>>2]+100>>2]](B+40|0,s,r,0,0,0,k),Y1(k,i[B+32>>2]),k=l[B+60|0];h:{if(k){if(!l[r+21|0]){if((k|0)!=1)break w;o=i[w+8>>2],h=i[o+4>>2];B:{if(h>>>0<u0[o+8>>2]){k=i[B+44>>2],i[h>>2]=i[B+40>>2],i[h+4>>2]=k,s=h+8|0;v:{if(u[B+59|0]>=0){k=i[B+52>>2],i[s>>2]=i[B+48>>2],i[s+4>>2]=k,i[s+8>>2]=i[B+56>>2];break v}T(s,i[B+48>>2],i[B+52>>2])}k=h+20|0;break B}k=fi(o,B+40|0)}if(i[o+4>>2]=k,s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,X[s|0](0,k,o)),k=i[26929],i[R>>2]=i[26928],i[R+4>>2]=k,o=R+8|0,u[107731]>=0){k=i[26931],i[o>>2]=i[26930],i[o+4>>2]=k,i[o+8>>2]=i[26932];break h}T(o,i[26930],i[26931]);break h}if((k|0)!=1)break w;if(k=i[B+44>>2],i[R>>2]=i[B+40>>2],i[R+4>>2]=k,o=R+8|0,u[B+59|0]>=0){k=i[B+52>>2],i[o>>2]=i[B+48>>2],i[o+4>>2]=k,i[o+8>>2]=i[B+56>>2];break h}T(o,i[B+48>>2],i[B+52>>2]);break h}V=i[B+44>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),Q0=i[B+40>>2];B:{if(o=i[r0>>2],!o){s=i[e+456>>2],o=i[e+452>>2],h=E(172),i[h+4>>2]=0,i[h+8>>2]=0,i[h>>2]=94860,o0(h+16|0,0,80),i[h+104>>2]=0,i[h+108>>2]=0,i[h+36>>2]=1,i[h+40>>2]=1,u[h+24|0]=1,Q[h+22>>1]=2,Q[h+18>>1]=2,Q[h+20>>1]=2,i[h+112>>2]=0,i[h+116>>2]=4740,i[h+140>>2]=0,i[h+144>>2]=0,i[h+128>>2]=99,i[h+132>>2]=99,i[h+120>>2]=0,i[h+124>>2]=0,i[h+12>>2]=95208,i[h+148>>2]=0,i[h+152>>2]=0,i[h+136>>2]=h+140,i[h+156>>2]=0,i[h+160>>2]=0,i[h+164>>2]=0,i[h+168>>2]=0,i[B+68>>2]=h,k=h+12|0,i[B+64>>2]=k,i[h+96>>2]=k,i[h+8>>2]=i[h+8>>2]+1,i[h+100>>2]=h,i[h+4>>2]==-1&&(X[i[i[h>>2]+8>>2]](h),p(h)),k=i[B+64>>2],i[B+24>>2]=V,i[B+20>>2]=Q0,V&&(i[V+4>>2]=i[V+4>>2]+1),I9(R,k,B+20|0,o,s,i[e+100>>2]- -64|0),o=i[B+24>>2];v:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break v;X[i[i[o>>2]+8>>2]](o),p(o)}if(i[R>>2])break B;if(u1(i[B+64>>2],6)){D=(-1<<j0(i[B+64>>2],6)^-1)&65535,V0=0,k=1;v:{Z:{G:{m:switch(s=i[B+64>>2],i[s+120>>2]){case 10:case 12:case 14:break m;case 11:case 13:case 15:break G;case 0:case 1:case 2:case 3:case 99:break v;default:break Z}k=3;break v}k=4;break v}k=0}N=k,o=i[s+128>>2];v:{if(!o)break v;for(s=s+128|0,h=s,k=o;m=i[k+16>>2]<6,h=m?h:k,k=i[(m?4:0)+k>>2],!!k;);m=0;Z:{if((s|0)==(h|0)||(m=0,i[h+16>>2]>6))break Z;m=l[h+24|0]<9}for(h=s,k=o;_=i[k+16>>2]<6,h=_?h:k,k=i[(_?4:0)+k>>2],!!k;);W=0;Z:{if((s|0)==(h|0)||(W=0,i[h+16>>2]>6))break Z;W=i[h+28>>2]}for(h=s,k=o;_=i[k+16>>2]<6,h=_?h:k,k=i[(_?4:0)+k>>2],!!k;);if(_=0,_=(s|0)==(h|0)|i[h+16>>2]>6?_:i[h+32>>2],m){for(k=s;h=i[o+16>>2]<6,k=h?k:o,o=i[(h?4:0)+o>>2],!!o;);Z:{if((k|0)==(s|0)){h=0,o=0;break Z}if(h=0,o=0,i[k+16>>2]>6)break Z;h=i[k+56>>2],o=i[k+44>>2]}if(!_)break v;if(k=o,W=G(W,N),N=0,o=0,_>>>0>=4)for(s=_&-4;m=!W,m||o0(k+G(o,h)|0,D,W),m||o0(k+G(o|1,h)|0,D,W),m||o0(k+G(o|2,h)|0,D,W),m||o0(k+G(o|3,h)|0,D,W),o=o+4|0,V0=V0+4|0,(s|0)!=(V0|0););if(s=_&3,!s)break v;for(;W&&o0(k+G(o,h)|0,D,W),o=o+1|0,N=N+1|0,(s|0)!=(N|0););break v}for(k=s;h=i[o+16>>2]<6,k=h?k:o,o=i[(h?4:0)+o>>2],!!o;);o=0;Z:{if((k|0)==(s|0)||(o=0,i[k+16>>2]>6))break Z;V0=i[k+44>>2],o=i[k+56>>2]>>>1|0}if(!_||(s=G(W,N),!s))break v;for(k=o,g2=s&-8,d0=s&7,N=0,Q2=s>>>0<8;;){if(a=(G(k,N)<<1)+V0|0,f0=0,!Q2)for(U0=a+14|0,m0=a+12|0,W0=a+10|0,W=a+8|0,m=a+6|0,s=a+4|0,o=a+2|0,h=0;x=f0<<1,Q[x+a>>1]=D,Q[o+x>>1]=D,Q[s+x>>1]=D,Q[m+x>>1]=D,Q[W+x>>1]=D,Q[x+W0>>1]=D,Q[x+m0>>1]=D,Q[x+U0>>1]=D,f0=f0+8|0,h=h+8|0,(g2|0)!=(h|0););if(o=0,d0)for(;Q[a+(f0<<1)>>1]=D,f0=f0+1|0,o=o+1|0,(d0|0)!=(o|0););if(N=N+1|0,(N|0)==(_|0))break}}}k=i[B+64>>2],i[B+24>>2]=V,i[B+20>>2]=Q0,V&&(i[V+4>>2]=i[V+4>>2]+1),_=v-32|0,v=_,m=B+20|0,s=i[m>>2],o=F[s+10>>1]|F[s+12>>1]<<16,i[_+8>>2]=F[s+6>>1]|F[s+8>>1]<<16,i[_+12>>2]=o,X[i[i[k>>2]+8>>2]](k,_+8|0),X[i[i[k>>2]+12>>2]](k,i[m>>2]+16|0),o=i[m>>2],h=i[o+24>>2],s=i[o+28>>2],(h|0)!=(s|0)&&(X[i[i[k>>2]+20>>2]](k,h,s),o=i[m>>2]),F[o+32>>1]|F[o+34>>1]&&(i[_+8>>2]=i[o+32>>2],X[i[i[k>>2]+24>>2]](k,_+8|0),o=i[m>>2]),l[o+60|0]==1&&(s=i[o+56>>2],i[_+24>>2]=i[o+52>>2],i[_+28>>2]=s,s=i[o+48>>2],i[_+16>>2]=i[o+44>>2],i[_+20>>2]=s,s=i[o+40>>2],i[_+8>>2]=i[o+36>>2],i[_+12>>2]=s,X[i[i[k>>2]+28>>2]](k,_+8|0),o=i[m>>2]),X[i[i[k>>2]+16>>2]](k,l[o+4|0]),v=_+32|0,V2(m),r3(r0,B- -64|0),u[R+19|0]<0&&Z(i[R+8>>2]),V2(B- -64|0),o=i[r0>>2]}if(i[o+120>>2]!=i[Q0+120>>2]){if(s=E(64),i[B+64>>2]=s,i[B+68>>2]=58,i[B+72>>2]=-2147483584,o=l[14967]|l[14968]<<8|(l[14969]<<16|l[14970]<<24),k=l[14963]|l[14964]<<8|(l[14965]<<16|l[14966]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+58|0]=0,k=l[15019]|l[15020]<<8,u[s+56|0]=k,u[s+57|0]=k>>>8,o=l[15015]|l[15016]<<8|(l[15017]<<16|l[15018]<<24),k=l[15011]|l[15012]<<8|(l[15013]<<16|l[15014]<<24),u[s+48|0]=k,u[s+49|0]=k>>>8,u[s+50|0]=k>>>16,u[s+51|0]=k>>>24,u[s+52|0]=o,u[s+53|0]=o>>>8,u[s+54|0]=o>>>16,u[s+55|0]=o>>>24,o=l[15007]|l[15008]<<8|(l[15009]<<16|l[15010]<<24),k=l[15003]|l[15004]<<8|(l[15005]<<16|l[15006]<<24),u[s+40|0]=k,u[s+41|0]=k>>>8,u[s+42|0]=k>>>16,u[s+43|0]=k>>>24,u[s+44|0]=o,u[s+45|0]=o>>>8,u[s+46|0]=o>>>16,u[s+47|0]=o>>>24,o=l[14999]|l[15e3]<<8|(l[15001]<<16|l[15002]<<24),k=l[14995]|l[14996]<<8|(l[14997]<<16|l[14998]<<24),u[s+32|0]=k,u[s+33|0]=k>>>8,u[s+34|0]=k>>>16,u[s+35|0]=k>>>24,u[s+36|0]=o,u[s+37|0]=o>>>8,u[s+38|0]=o>>>16,u[s+39|0]=o>>>24,o=l[14991]|l[14992]<<8|(l[14993]<<16|l[14994]<<24),k=l[14987]|l[14988]<<8|(l[14989]<<16|l[14990]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[14983]|l[14984]<<8|(l[14985]<<16|l[14986]<<24),k=l[14979]|l[14980]<<8|(l[14981]<<16|l[14982]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[14975]|l[14976]<<8|(l[14977]<<16|l[14978]<<24),k=l[14971]|l[14972]<<8|(l[14973]<<16|l[14974]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,K(R,2,127,B- -64|0),u[B+75|0]>=0)break h;Z(i[B+64>>2]);break h}i[B+68>>2]=V,i[B+64>>2]=Q0,V&&(i[V+4>>2]=i[V+4>>2]+1),h=o,I=v-32|0,v=I,f0=B- -64|0,k=i[f0>>2],U0=I+24|0,i[I+20>>2]=U0,i[I+24>>2]=0,i[I+28>>2]=0;v:{Z:{s=i[k+124>>2],_=k+128|0;G:{if((s|0)==(_|0))break G;for(;;){W=i[s+16>>2],m=U0,k=m,o=i[I+24>>2];m:{W:{if(!o)break W;for(;;){if(k=o,o=i[o+16>>2],(o|0)>(W|0)){if(m=k,o=i[k>>2],o)continue;break W}if((o|0)>=(W|0))break m;if(o=i[k+4>>2],!o)break}m=k+4|0}o=E(20),i[o+8>>2]=k,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=W,i[m>>2]=o,k=i[i[I+20>>2]>>2],k&&(i[I+20>>2]=k),m1(i[I+24>>2],o),i[I+28>>2]=i[I+28>>2]+1}o=i[s+4>>2];m:{if(o){for(;;)if(k=o,o=i[o>>2],!o)break m}for(;k=i[s+8>>2],o=i[k>>2]!=(s|0),s=k,!!o;);}if(s=k,(_|0)==(s|0))break}if(N=i[I+20>>2],(U0|0)==(N|0))break G;if(o=i[h+108>>2],o>>>0<=t>>>0||(k=i[h+112>>2],k>>>0<=A0>>>0))break Z;for(W=h+128|0,H0=A0+1>>>1|0,a=t+1>>>1|0,Q0=k-A0|0,V0=Q0+1>>>1|0,r0=o-t|0,d0=r0+1>>>1|0,k=i[h+120>>2],g2=(k|0)==1,Q2=k-1>>>0<2;;){S=i[N+16>>2],x=i[f0>>2],h=x+128|0,s=h,k=i[x+128>>2],o=k;m:{W:{if(!o)break W;for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);if((s|0)==(h|0))break W;if(L0=0,m0=0,(S|0)<i[s+16>>2])break m;L0=i[s+44>>2],m0=i[s+56>>2];break m}L0=0,m0=0}m:{W:{if(m=W,o=i[m>>2],s=o,!s)break W;for(;_=(S|0)>i[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if((m|0)==(W|0))break W;if(E2=0,W0=0,(S|0)<i[m+16>>2])break m;E2=i[m+44>>2],W0=i[m+56>>2];break m}E2=0,W0=0}$=255,m=h,s=k,_=255;m:{if(!s)break m;for(;_=(S|0)>i[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if(_=255,(h|0)==(m|0)||(_=255,(S|0)<i[m+16>>2]))break m;_=l[m+24|0]}m=_,s=W;m:{if(!o)break m;for(;_=(S|0)>i[o+16>>2],s=_?s:o,o=i[(_?4:0)+o>>2],!!o;);if((s|0)==(W|0)|(S|0)<i[s+16>>2])break m;$=l[s+24|0]}m:{W:{if((m&255)==($|0)){s=h,o=k;X:{if(!o){q0=0,o=0;break X}for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);for(q0=0,q0=(s|0)==(h|0)|(S|0)<i[s+16>>2]?q0:i[s+28>>2],s=h,o=k;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);if(o=0,(s|0)==(h|0)|(S|0)<i[s+16>>2])break X;o=i[s+32>>2]}if(m=S-1>>>0<2,_=m&g2,s=_?V0:Q0,n2=s>>>0<o>>>0?s:o,D=m&Q2,(S|0)!=10){if(s=h,o=k,!o)break W;for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);for($=0,$=(s|0)==(h|0)|(S|0)<i[s+16>>2]?$:(l[s+24|0]+7&248)>>>3|0,m=_?H0:A0,_=D?a:t,o=h;s=(S|0)>i[k+16>>2],o=s?o:k,k=i[(s?4:0)+k>>2],!!k;);if(s=0,(o|0)==(h|0)|(S|0)<i[o+16>>2])break m;s=(l[o+24|0]+7&248)>>>3|0;break m}s=8,$=8;X:{C:{I:{F:{Q:switch(k=i[x+120>>2],k-10|0){case 0:break Q;case 1:break I;case 2:case 4:break F;case 3:case 5:break X;default:break C}m=_?H0:A0,$=3,_=t,s=3;break m}$=6;break X}m=_?H0:A0,$=4,_=t,s=4;break m}$=31}m=_?H0:A0,_=t;X:{C:switch(k-12|0){case 0:case 2:s=6;break X;case 1:case 3:break m;default:break C}s=31}break m}if(u[I+8|0]=0,u[I+19|0]=0,K(B,2,132,I+8|0),u[I+19|0]>=0)break v;Z(i[I+8>>2]);break v}m=_?H0:A0,_=D?a:t,$=0,s=0}m:{if(!n2)break m;if(k=D?d0:r0,x=G(k>>>0<q0>>>0?k:q0,$),_=G(s,_)+E2|0,k=0,(n2|0)!=1)for(h=n2&-2,s=0;o=!x,o||z(_+G(W0,k+m|0)|0,G(k,m0)+L0|0,x),o||(o=k|1,z(_+G(W0,o+m|0)|0,G(o,m0)+L0|0,x)),k=k+2|0,s=s+2|0,(h|0)!=(s|0););if(!(n2&1)|!x)break m;z(_+G(W0,k+m|0)|0,G(k,m0)+L0|0,x)}o=i[N+4>>2];m:{if(o){for(;;)if(k=o,o=i[o>>2],!o)break m}for(;k=i[N+8>>2],o=i[k>>2]!=(N|0),N=k,!!o;);}if(N=k,(k|0)==(U0|0))break}}if(k=i[26929],i[B>>2]=i[26928],i[B+4>>2]=k,o=B+8|0,u[107731]>=0){k=i[26931],i[o>>2]=i[26930],i[o+4>>2]=k,i[o+8>>2]=i[26932];break v}T(o,i[26930],i[26931]);break v}if(u[I+8|0]=0,u[I+19|0]=0,K(B,2,118,I+8|0),u[I+19|0]>=0)break v;Z(i[I+8>>2])}Vi(I+20|0,i[I+24>>2]),v=I+32|0,u[B+19|0]<0&&Z(i[B+8>>2]),o=i[B+68>>2];v:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break v;X[i[i[o>>2]+8>>2]](o),p(o)}if(s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,X[s|0](0,k,o)),k=i[26929],i[R>>2]=i[26928],i[R+4>>2]=k,o=R+8|0,u[107731]>=0){k=i[26931],i[o>>2]=i[26930],i[o+4>>2]=k,i[o+8>>2]=i[26932];break h}T(o,i[26930],i[26931]);break h}if(o=i[B+68>>2],!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break h;X[i[i[o>>2]+8>>2]](o),p(o)}if(o=l[B+60|0],(o|0)==255)break _;k=i[25343],i[B+64>>2]=i[25342],i[B+68>>2]=k,X[i[(B- -64|0)+(o<<2)>>2]](B+20|0,B+40|0)}_:{if(!N0||(k=i[N0+4>>2],i[N0+4>>2]=k-1,k))break _;X[i[i[N0>>2]+8>>2]](N0),p(N0)}_:{if(!V||(k=i[V+4>>2],i[V+4>>2]=k-1,k))break _;X[i[i[V>>2]+8>>2]](V),p(V)}o=i[w+12>>2];_:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break _;X[i[i[o>>2]+8>>2]](o),p(o)}v=B+80|0;break s}_2(),H()}if(k=i[w+60>>2],i[w+80>>2]=i[w+56>>2],i[w+84>>2]=k,u[w+99|0]<0&&Z(i[w+88>>2]),k=i[g+4>>2],i[w+88>>2]=i[g>>2],i[w+92>>2]=k,i[w+96>>2]=i[g+8>>2],u[w+64|0]=0,u[w+75|0]=0,Y1(w+20|0,i[w+24>>2]),i[w+80>>2]){if(k=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=k,u[w+99|0]>=0){k=i[w+92>>2],i[C>>2]=i[w+88>>2],i[C+4>>2]=k,i[C+8>>2]=i[w+96>>2];break l}T(C,i[w+88>>2],i[w+92>>2]);break l}h0=h0+1|0,t=t+D0|0,k=0;break o}k=1,u[A+20|0]=1}o:{if(!e0||(o=i[e0+4>>2],i[e0+4>>2]=o-1,o))break o;X[i[i[e0>>2]+8>>2]](e0),p(e0)}o:switch(k|0){case 0:case 9:break o;default:break n}if(k=F[e+450>>1],P0=P0+1|0,!!(k>>>0<=P0>>>0|n0))break}t=F[e+448>>1]}if(Z2=Z2+1|0,Z2>>>0>=(t&65535)>>>0)break t;if(A0=n+A0|0,!!n0)break}}if(e=i[r+12>>2],e&&X[e|0](0,i[r+16>>2]),n0){e=E(32),i[w+44>>2]=e,i[w+48>>2]=31,i[w+52>>2]=-2147483616,f=l[17100]|l[17101]<<8|(l[17102]<<16|l[17103]<<24),r=l[17096]|l[17097]<<8|(l[17098]<<16|l[17099]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,f=l[17093]|l[17094]<<8|(l[17095]<<16|l[17096]<<24),r=l[17089]|l[17090]<<8|(l[17091]<<16|l[17092]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[17085]|l[17086]<<8|(l[17087]<<16|l[17088]<<24),r=l[17081]|l[17082]<<8|(l[17083]<<16|l[17084]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,f=l[17077]|l[17078]<<8|(l[17079]<<16|l[17080]<<24),r=l[17073]|l[17074]<<8|(l[17075]<<16|l[17076]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+31|0]=0,f=K(w+56|0,12,0,w+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;t:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break t}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break t;Z(i[f+8>>2])}if(u[w+55|0]>=0)break n;Z(i[w+44>>2]);break n}r=i[w+232>>2],e=0;t:{if(!r||(e=r,k=i[O>>2],t=i[O+4>>2],(k|0)==(t|0)))break t;for(n=e+148|0,e=i[e+152>>2];;){u:{if(u0[r+156>>2]>e>>>0){if(f=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=f,o=e+8|0,u[k+19|0]>=0){f=i[k+12>>2],i[o>>2]=i[k+8>>2],i[o+4>>2]=f,i[o+8>>2]=i[k+16>>2],e=e+20|0;break u}T(o,i[k+8>>2],i[k+12>>2]),e=e+20|0;break u}e=fi(n,k)}if(i[r+152>>2]=e,k=k+20|0,(t|0)==(k|0))break}e=i[w+232>>2]}r=i[w+236>>2],i[w+232>>2]=0,i[w+236>>2]=0,u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}if(A=i[L+4>>2],i[L+4>>2]=A-1,A)break k;X[i[i[L>>2]+8>>2]](L),p(L)}if(u[w+99|0]>=0)break e;Z(i[w+88>>2]);break e}g0(),H()}if(!e)break r;z(t,f,e)}u[e+t|0]=0,f=K(w+56|0,2,119,w+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),A=i[18063],i[w+80>>2]=A,i[i[A-12>>2]+(w+80|0)>>2]=i[18071],i[w+88>>2]=i[18072],i[k>>2]=71280,u[w+135|0]<0&&Z(i[w+124>>2]),y0(k),p0(w+144|0)}e=i[w+236>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}v=w+240|0,Y1($0,i[y+8>>2])}v=y- -64|0}function E7(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;C=v-48|0,v=C;i:{e:{if(!r){if(u[C+12|0]=0,u[C+23|0]=0,r=A,A=K(C+24|0,5,2001,C+12|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[C+23|0]>=0)break e;Z(i[C+12>>2]);break e}if(i[r>>2]!=1){if(u[C+12|0]=0,u[C+23|0]=0,r=K(C+24|0,5,2004,C+12|0),u[C+23|0]<0&&Z(i[C+12>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}i[C+32>>2]=0,i[C+36>>2]=0,i[C+24>>2]=0,i[C+28>>2]=0,D=C+24|0,B=v-80|0,v=B,h=i[e>>2],n=i[h+48>>2],y=i[n+148>>2],I=i[n+152>>2],I&&(i[I+4>>2]=i[I+4>>2]+1);r:{f:{if(y){if(k=i[h+180>>2],x=h+184|0,(k|0)!=(x|0))for(;;){n=i[k+20>>2],X[i[i[n>>2]+20>>2]](B+56|0,n),u[B+75|0]<0&&Z(i[B+64>>2]),t=i[i[k+20>>2]+156>>2],n=i[t+128>>2],m=i[t+132>>2],w=i[t+120>>2],o=i[h+48>>2],t=i[o+148>>2],o=i[o+152>>2];A:{if(!o){t=i[t+120>>2];break A}if(s=i[o+4>>2],W=s+1|0,i[o+4>>2]=W,t=i[t+120>>2],i[o+4>>2]=s,W)break A;X[i[i[o>>2]+8>>2]](o),p(o)}A:{if(t)break A;if(t=i[i[i[k+20>>2]+156>>2]+120>>2],o=i[h+48>>2],s=i[o+148>>2],o=i[o+152>>2],!o){i[s+120>>2]=t;break A}if(i[o+4>>2]=i[o+4>>2]+1,i[s+120>>2]=t,s=i[o+4>>2],i[o+4>>2]=s-1,s)break A;X[i[i[o>>2]+8>>2]](o),p(o)}w?(n=d8(O0(n,m,t,0),l0,w,0),w=l0):(n=0,w=0),t=i[h+196>>2];A:{k:{if(!t){o=-1,V=-1;break k}if($1(B,t,0,0,0,n,w,0,0),R=O0(t,0,n,w),s=(i[B+8>>2]|i[B+12>>2])!=0,o=s?-1:R,V=s?-1:l0,(t|0)==1)break A}m=v-16|0,v=m,W=i[k+20>>2];k:{if(i[W+236>>2])break k;s=E(120),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=93732,t=s+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+16>>2]=86404,i[s+60>>2]=0,i[s+64>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+72>>2]=-1,i[s+76>>2]=-1,i[s+80>>2]=-1,i[s+84>>2]=-1,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0,u[s+112|0]=0,i[s+32>>2]=1701082227,i[s+16>>2]=93772,g=i[W+132>>2],i[m+12>>2]=s,i[m+8>>2]=t,i[s+4>>2]=i[s+4>>2]+1,r2(g+36|0,m+8|0),t=i[m+12>>2];n:{if(!t||(g=i[t+4>>2],i[t+4>>2]=g-1,g))break n;X[i[i[t>>2]+8>>2]](t),p(t)}S=s+52|0,t=E(136),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=93852,R=t+16|0,g=R,i[g+8>>2]=0,i[g+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86404,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,Q[t+112>>1]=0,i[t+16>>2]=106396,i[t+128>>2]=0,i[t+120>>2]=0,i[t+124>>2]=0,i[t+32>>2]=1701606260,i[W+236>>2]=g,g=i[W+240>>2],i[W+240>>2]=t;n:{t:{if(!g){i[m+12>>2]=t,i[m+8>>2]=R;break t}if(t=i[g+4>>2],i[g+4>>2]=t-1,t||(X[i[i[g>>2]+8>>2]](g),p(g)),g=i[W+236>>2],t=i[W+240>>2],i[m+12>>2]=t,i[m+8>>2]=g,!t)break n}i[t+4>>2]=i[t+4>>2]+1}r2(S,m+8|0),t=i[m+12>>2];n:{if(!t||(g=i[t+4>>2],i[t+4>>2]=g-1,g))break n;X[i[i[t>>2]+8>>2]](t),p(t)}if(t=i[W+236>>2],i[t+100>>2]=i[t+100>>2]&-2|1,t=i[s+4>>2],i[s+4>>2]=t-1,t)break k;X[i[i[s>>2]+8>>2]](s),p(s)}v=m+16|0}if(s=v-32|0,v=s,t=i[k+20>>2],m=i[t+140>>2],i[m+128>>2]=o,i[m+132>>2]=V,m=i[t+236>>2],m){i[s+24>>2]=1,i[s+16>>2]=0,i[s+20>>2]=0,i[s+8>>2]=n,i[s+12>>2]=w;A:{if(n=i[m+108>>2],w=i[m+112>>2],n>>>0<w>>>0){t=i[s+12>>2],i[n>>2]=i[s+8>>2],i[n+4>>2]=t,t=i[s+28>>2],i[n+16>>2]=i[s+24>>2],i[n+20>>2]=t,t=i[s+20>>2],i[n+8>>2]=i[s+16>>2],i[n+12>>2]=t,i[m+108>>2]=n+24;break A}k:{if(W=i[m+104>>2],n=n-W|0,t=((n|0)/24|0)+1|0,t>>>0<178956971){if(w=(w-W|0)/24|0,g=w<<1,g=w>>>0>=89478485?178956970:t>>>0<g>>>0?g:t,g){if(g>>>0>=178956971)break k;t=E(G(g,24))}else t=0;w=t+n|0,R=i[s+12>>2],i[w>>2]=i[s+8>>2],i[w+4>>2]=R,R=i[s+28>>2],i[w+16>>2]=i[s+24>>2],i[w+20>>2]=R,R=i[s+20>>2],i[w+8>>2]=i[s+16>>2],i[w+12>>2]=R,R=w+G((n|0)/-24|0,24)|0,n&&z(R,W,n),i[m+112>>2]=t+G(g,24),n=w+24|0,i[m+108>>2]=n,i[m+104>>2]=R,W&&Z(W),i[m+108>>2]=n;break A}break f}x0(),H()}}v=s+32|0,w=(V|0)==(N|0)&o>>>0<_>>>0|V>>>0<N>>>0,t=i[k+4>>2];A:{if(t){for(;;)if(n=t,t=i[n>>2],!t)break A}for(;n=i[k+8>>2],t=i[n>>2]!=(k|0),k=n,!!t;);}if(_=w?_:o,N=w?N:V,k=n,(x|0)==(k|0))break}i[y+128>>2]=_,i[y+132>>2]=N}A:{if(!I||(n=i[I+4>>2],i[I+4>>2]=n-1,n))break A;X[i[i[I>>2]+8>>2]](I),p(I)}if(t=i[h+16>>2],I=h+20|0,(t|0)!=(I|0))for(;;){if(k=i[t+20>>2],n=i[k+276>>2],o=i[k+280>>2],(n|0)!=(o|0))for(;w=i[h+48>>2],_=i[n>>2],s=i[t+16>>2],k=E(4),i[B+16>>2]=k,m=k+4|0,i[B+24>>2]=m,i[k>>2]=s,i[B+20>>2]=m,a4(w,_,1667527523,B+16|0),k=i[B+16>>2],k&&(i[B+20>>2]=k,Z(k)),n=n+4|0,(o|0)!=(n|0););k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(I|0)==(n|0))break}if(n=i[h+156>>2],W=i[h+160>>2],(n|0)!=(W|0))for(;;){i[B+48>>2]=0,i[B+40>>2]=0,i[B+44>>2]=0,_=B+16|0,o=i[n>>2],m=B+40|0,w=0,t=v-32|0,v=t,i[t+24>>2]=0,i[t+28>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,l2(t+16|0,0);A:{k:{if(!(u0[o+4>>2]>65535|u0[o+8>>2]>=65536)){w=1;break k}if(s=2,k=i[o+12>>2],g=i[o+16>>2],(k|0)==(g|0))break A;for(;;){if(w=i[k>>2],w=X[i[i[w>>2]+16>>2]](w)|0,w)break k;if(k=k+8|0,(g|0)==(k|0))break}break A}s=4}k=t+16|0,l2(k,w),Z1(k,s,i[o+4>>2],0),Z1(k,s,i[o+8>>2],0),k=i[o+16>>2]-i[o+12>>2]>>3;A:{if(k>>>0>=256){if(u[t+4|0]=0,u[t+15|0]=0,K(_,9,5004,t+4|0),u[t+15|0]>=0)break A;Z(i[t+4>>2]);break A}if(l2(t+16|0,k),k=i[o+12>>2],o=i[o+16>>2],(k|0)!=(o|0))for(;w=i[k>>2],X[i[i[w>>2]+20>>2]](w,t+16|0,s),k=k+8|0,(o|0)!=(k|0););if(w=0,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,k=0,o=i[t+20>>2],s=i[t+16>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break f;k=E(o),o&&z(k,s,o),w=k+o|0}if((m|0)!=(t+4|0)&&d4(m,k,w,w-k|0),k&&Z(k),k=i[26929],i[_>>2]=i[26928],i[_+4>>2]=k,k=_+8|0,u[107731]>=0){o=i[26931],i[k>>2]=i[26930],i[k+4>>2]=o,i[k+8>>2]=i[26932];break A}T(k,i[26930],i[26931])}if(k=i[t+16>>2],k&&(i[t+20>>2]=k,Z(k)),v=t+32|0,K8(i[h+48>>2],i[i[n>>2]>>2],m,0),u[B+35|0]<0&&Z(i[B+24>>2]),t=i[B+40>>2],t&&(i[B+44>>2]=t,Z(t)),n=n+8|0,(W|0)==(n|0))break}if(t=i[h+16>>2],(I|0)!=(t|0))for(;;){if(k=i[t+20>>2],n=i[k+436>>2],o=i[k+440>>2],(n|0)!=(o|0))for(;w=i[h+48>>2],_=i[n>>2],s=i[t+16>>2],k=E(4),i[B+16>>2]=k,m=k+4|0,i[B+24>>2]=m,i[k>>2]=s,i[B+20>>2]=m,a4(w,_,1952807028,B+16|0),k=i[B+16>>2],k&&(i[B+20>>2]=k,Z(k)),n=n+4|0,(o|0)!=(n|0););k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(I|0)==(n|0))break}if(n=i[h+168>>2],g=i[h+172>>2],(n|0)!=(g|0))for(w=i[23602],V=i[23603];;){t=i[n>>2],o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,_=u[t+15|0],s=(_|0)<0,k=s?i[t+4>>2]:t+4|0,t=s?i[t+8>>2]:_,m=k+t|0;A:{if(s=i[o+12>>2],_=i[o+4>>2],t>>>0<=s-_>>>0){if(y=t,t=i[o+8>>2],W=t-_|0,y>>>0>W>>>0){if(s=k+W|0,(t|0)!=(_|0)&&(W&&z(_,k,W),t=i[o+8>>2]),k=t,(s|0)!=(m|0))for(;u[k|0]=l[s|0],k=k+1|0,s=s+1|0,(m|0)!=(s|0););i[o+8>>2]=(k-t|0)+t;break A}t=m-k|0,!t|(k|0)==(m|0)||z(_,k,t),i[o+8>>2]=t+_;break A}if(_&&(i[o+8>>2]=_,Z(_),i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,s=0),(t|0)>=0){_=s<<1,_=s>>>0>=1073741823?2147483647:t>>>0<_>>>0?_:t,t=E(_),i[o+8>>2]=t,i[o+4>>2]=t,i[o+12>>2]=t+_,(k|0)!=(m|0)&&(_=m-k|0,_&&z(t,k,_),t=t+_|0),i[o+8>>2]=t;break A}break f}if(t=i[o+4>>2],_=i[o+8>>2],s=i[o+12>>2],k=B+16|0,u[k+20|0]=0,i[k+8>>2]=s,i[k>>2]=t,i[k+4>>2]=_,v=o+16|0,t=l[B+36|0],t||(K8(i[h+48>>2],i[i[n>>2]>>2],k,1),t=l[B+36|0]),t=t&255,(t|0)!=255&&(i[B+40>>2]=w,i[B+44>>2]=V,X[i[(B+40|0)+(t<<2)>>2]](B+79|0,B+16|0)),n=n+8|0,(g|0)==(n|0))break}if(t=i[h+16>>2],(I|0)!=(t|0))for(;;){n=i[t+20>>2],X[i[i[n>>2]+80>>2]](n),k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(I|0)==(n|0))break}n=i[h+48>>2],o=i[n+60>>2],_=i[n+64>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);A:{if(!o)break A;if(n=i[h+48>>2],i[B+16>>2]=i[n+52>>2],n=i[n+56>>2],i[B+20>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),n=0,t=0,I=v-16|0,v=I,w=i[B+16>>2],i[I+12>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,k=i[w+36>>2],s=i[w+40>>2],(k|0)!=(s|0)){if(n=s-k|0,(n|0)<0)break f;for(t=E(n),i[I+4>>2]=t,i[I+12>>2]=n+t,n=t;i[n>>2]=i[k>>2],w=i[k+4>>2],i[n+4>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),n=n+8|0,k=k+8|0,(s|0)!=(k|0););i[I+8>>2]=n}if(m=i[o+104>>2],N=i[o+108>>2],(m|0)!=(N|0))for(g=t-8|0;;){if(s=0,y=(i[m+8>>2]-i[m+4>>2]>>2)-1|0,w=y,w)for(;;){for(R=w>>>0<=1?1:w,k=0;;){o=k,k=k+1|0,o=o<<2,W=i[g+(F[(o+i[m+4>>2]|0)+2>>1]<<3)>>2];k:{if(!(X[i[i[W>>2]+44>>2]](W)|0)||(W=k<<2,V=i[g+(F[(W+i[m+4>>2]|0)+2>>1]<<3)>>2],X[i[i[V>>2]+44>>2]](V)|0))break k;x=i[m+4>>2],o=x+o|0,V=F[o>>1]|F[o+2>>1]<<16,W=W+x|0,x=F[W>>1]|F[W+2>>1]<<16,Q[o>>1]=x,Q[o+2>>1]=x>>>16,Q[W>>1]=V,Q[W+2>>1]=V>>>16}if((k|0)==(R|0))break}if(w=w-1|0,s=s+1|0,(y|0)==(s|0))break}if(m=m+16|0,(N|0)==(m|0))break}if(t){if((n|0)!=(t|0)){for(;;){k=i[n-4>>2];k:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break k;X[i[i[k>>2]+8>>2]](k),p(k)}if(n=n-8|0,(t|0)==(n|0))break}t=i[I+4>>2]}Z(t)}if(v=I+16|0,n=i[B+20>>2],!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break A;X[i[i[n>>2]+8>>2]](n),p(n)}A:{if(!_||(n=i[_+4>>2],i[_+4>>2]=n-1,n))break A;X[i[i[_>>2]+8>>2]](_),p(_)}if(t=i[h+48>>2],n=i[t+16>>2],t=i[t+20>>2],(n|0)!=(t|0))for(;kl(i[n>>2]),n=n+8|0,(t|0)!=(n|0););m=0,_=v+-64|0,v=_,i[B+24>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,I=B+40|0,I&&(i[I>>2]=0),n=h,k=i[n+48>>2],w=i[n+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),t=i[k+44>>2],s=i[k+48>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);A:{if(l[t+97|0]|!t||(k=i[t+36>>2],h=i[t+40>>2],(k|0)==(h|0)))break A;for(;;){k:{if(o=i[k>>2],!o||(o=X0(o,86628,87232),!o))break k;W=i[k+4>>2],W&&(i[W+4>>2]=i[W+4>>2]+1);n:{if(l[o+97|0]||(k=i[t+36>>2],h=i[t+40>>2],(k|0)==(h|0)))break n;for(;;){t:{if(o=i[k>>2],!o||(o=X0(o,86628,89712),!o))break t;if(g=i[k+4>>2],g&&(i[g+4>>2]=i[g+4>>2]+1),l[o+97|0]<=2){if(GA(_+12|0,t),k=i[_+12>>2],!(!k|l[k+97|0]>1)){u:{o:{if(o=i[k+36>>2],h=i[k+40>>2],(o|0)!=(h|0)){if(k=i[o>>2],k&&(V=i[_+40>>2],k=X0(k,86628,87392),k))break o;if(o=o+8|0,(h|0)!=(o|0))for(;;){if(k=i[o>>2],k&&(V=0,k=X0(k,86628,87392),k))break o;if(o=o+8|0,(h|0)==(o|0))break}i[_+36>>2]=0,i[_+40>>2]=0}i[_+36>>2]=0,i[_+40>>2]=0;break u}if(i[_+40>>2]=V,i[_+36>>2]=k,k=i[o+4>>2],i[_+40>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[_+36>>2],!(!k|(l[k+97|0]&254)!=2)){u:{o:{if(o=i[t+36>>2],h=i[t+40>>2],(o|0)!=(h|0)){if(k=i[o>>2],k&&(V=i[_+60>>2],k=X0(k,86628,87312),k))break o;if(o=o+8|0,(h|0)!=(o|0))for(;;){if(k=i[o>>2],k&&(V=0,k=X0(k,86628,87312),k))break o;if(o=o+8|0,(h|0)==(o|0))break}i[_+56>>2]=0,i[_+60>>2]=0}i[_+56>>2]=0,i[_+60>>2]=0;break u}if(i[_+60>>2]=V,i[_+56>>2]=k,k=i[o+4>>2],i[_+60>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[_+56>>2],!(!k|l[k+97|0]>1)){h=_+48|0;u:{o:{if(o=i[t+36>>2],t=i[t+40>>2],(o|0)!=(t|0)){if(m=i[o>>2],m&&(k=i[h+4>>2],V=X0(m,86628,87552),V))break o;if(o=o+8|0,(t|0)!=(o|0))for(;;){if(m=i[o>>2],m&&(k=0,V=X0(m,86628,87552),V))break o;if(o=o+8|0,(t|0)==(o|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break u}if(i[h+4>>2]=k,i[h>>2]=V,t=i[o+4>>2],i[h+4>>2]=t,!t)break u;i[t+4>>2]=i[t+4>>2]+1}m=i[_+48>>2]!=0,V2(h)}V2(_+56|0)}V2(_+36|0)}V2(_+12|0)}if(!g||(t=i[g+4>>2],i[g+4>>2]=t-1,t))break n;X[i[i[g>>2]+8>>2]](g),p(g);break n}if(k=k+8|0,(h|0)==(k|0))break}}if(!W||(t=i[W+4>>2],i[W+4>>2]=t-1,t))break A;X[i[i[W>>2]+8>>2]](W),p(W);break A}if(k=k+8|0,(h|0)==(k|0))break}}A:{if(!s||(t=i[s+4>>2],i[s+4>>2]=t-1,t))break A;X[i[i[s>>2]+8>>2]](s),p(s)}A:{if(!w||(t=i[w+4>>2],i[w+4>>2]=t-1,t))break A;X[i[i[w>>2]+8>>2]](w),p(w)}A:{k:{n:{t:{if(!m)break t;t=i[B+20>>2],o=i[B+24>>2];u:{if(t>>>0<o>>>0){i[t>>2]=1835623985,k=t+4|0;break u}if(h=i[B+16>>2],t=t-h|0,s=t>>2,k=s+1|0,k>>>0>=1073741824)break f;if(o=o-h|0,w=o>>1,o=o>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,o){if(o>>>0>=1073741824)break n;k=E(o<<2)}else k=0;if(w=k+t|0,i[w>>2]=1835623985,s=w-(s<<2)|0,t&&z(s,h,t),i[B+24>>2]=k+(o<<2),k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!h)break u;Z(h)}if(i[B+20>>2]=k,!I)break t;i[I>>2]=1835623985}t=v-16|0,v=t,o=v-32|0,v=o;t:{u:{if(h=n,n=i[n+40>>2],!n||(X[i[i[n>>2]+52>>2]](o+12|0,n),n=i[o+12>>2],u[o+31|0]<0&&Z(i[o+20>>2]),n))break u;if(k=i[h+40>>2],n=i[h+44>>2],!n){n=0;break t}i[n+4>>2]=i[n+4>>2]+1;break t}n=0,k=0}i[t+12>>2]=n,i[t+8>>2]=k,v=o+32|0,w=i[t+8>>2];t:{if(w){if(n=i[t+12>>2],i[t+8>>2]=0,i[t+12>>2]=0,k=E(8),i[_+36>>2]=k,o=k+8|0,i[_+44>>2]=o,i[k+4>>2]=n,i[k>>2]=w,!n){i[_+40>>2]=o;break t}if(i[n+4>>2]=i[n+4>>2]+1,i[_+40>>2]=o,k=i[n+4>>2],i[n+4>>2]=k-1,k)break t;X[i[i[n>>2]+8>>2]](n),p(n);break t}i[_+44>>2]=0,i[_+36>>2]=0,i[_+40>>2]=0}n=i[t+12>>2];t:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break t;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+16|0;t:{u:{o:{n=i[_+36>>2],V=i[_+40>>2],R=(n|0)==(V|0);l:{if(R){t=1;break l}if(!m)break o;for(t=1,k=n;;){o=i[k>>2],s=X[i[i[o>>2]+88>>2]](o)|0;s:{if(!s||(o=i[B+16>>2],w=i[B+20>>2],o=_3(o,s,w-o>>2),o=o||w,w=i[B+20>>2],(o|0)!=(w|0)))break s;g=i[B+24>>2];w:{if(g>>>0>o>>>0){i[w>>2]=s,s=w+4|0;break w}if(W=i[B+16>>2],o=o-W|0,y=o>>2,w=y+1|0,w>>>0>=1073741824)break f;if(g=g-W|0,N=g>>1,g=g>>>0>=2147483644?1073741823:w>>>0<N>>>0?N:w,g){if(g>>>0>=1073741824)break n;w=E(g<<2)}else w=0;if(N=w+o|0,i[N>>2]=s,y=N-(y<<2)|0,o&&z(y,W,o),i[B+24>>2]=w+(g<<2),s=N+4|0,i[B+20>>2]=s,i[B+16>>2]=y,!W)break w;Z(W)}i[B+20>>2]=s}if(t=l[i[k>>2]+272|0]&t,k=k+8|0,(V|0)==(k|0))break}}if(t&m){t=i[B+20>>2],w=i[B+24>>2];l:{if(t>>>0<w>>>0){i[t>>2]=1835622758,k=t+4|0;break l}if(o=i[B+16>>2],t=t-o|0,m=t>>2,k=m+1|0,k>>>0>=1073741824)break f;if(w=w-o|0,s=w>>1,w=w>>>0>=2147483644?1073741823:k>>>0<s>>>0?s:k,w){if(w>>>0>=1073741824)break n;k=E(w<<2)}else k=0;if(s=k+t|0,i[s>>2]=1835622758,m=s-(m<<2)|0,t&&z(m,o,t),i[B+24>>2]=k+(w<<2),k=s+4|0,i[B+20>>2]=k,i[B+16>>2]=m,!o)break l;Z(o)}i[B+20>>2]=k}if(R)break t;break u}for(k=n;t=i[k>>2],X[i[i[t>>2]+88>>2]](t)|0,k=k+8|0,(V|0)!=(k|0););}if(t=i[n>>2],t=X[i[i[t>>2]+88>>2]](t)|0,!I|!t)break t;i[I>>2]=t}if(i[h+188>>2]){t=i[B+24>>2],n=i[B+20>>2];t:{if(t>>>0>n>>>0){i[n>>2]=1836279345,k=n+4|0;break t}if(o=i[B+16>>2],n=n-o|0,s=n>>2,k=s+1|0,k>>>0>=1073741824)break f;if(t=t-o|0,w=t>>1,k=t>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,k){if(k>>>0>=1073741824)break n;t=E(k<<2)}else t=0;if(w=t+n|0,i[w>>2]=1836279345,s=w-(s<<2)|0,n&&z(s,o,n),t=t+(k<<2)|0,i[B+24>>2]=t,k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!o)break t;Z(o),t=i[B+24>>2]}i[B+20>>2]=k;t:{if(k>>>0<t>>>0){i[k>>2]=1769172792,k=k+4|0;break t}if(o=i[B+16>>2],n=k-o|0,s=n>>2,k=s+1|0,k>>>0>=1073741824)break f;if(t=t-o|0,w=t>>1,k=t>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,k){if(k>>>0>=1073741824)break n;t=E(k<<2)}else t=0;if(w=t+n|0,i[w>>2]=1769172792,s=w-(s<<2)|0,n&&z(s,o,n),i[B+24>>2]=t+(k<<2),k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!o)break t;Z(o)}i[B+20>>2]=k,t=_+12|0,n=v-48|0,v=n,Df(n+8|0,h,0);t:{u:{o:{l:switch(o=l[n+28|0],o|0){case 0:break u;case 1:break o;default:break l}_2(),H()}if(k=i[n+12>>2],i[t>>2]=i[n+8>>2],i[t+4>>2]=k,k=t+8|0,u[n+27|0]>=0){w=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=w,i[k+8>>2]=i[n+24>>2];break t}T(k,i[n+16>>2],i[n+20>>2]);break t}w=i[n+8>>2],k=i[n+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[t+4>>2]=k,i[t>>2]=w}if(u[t+20|0]=o,t=l[n+28|0],(t|0)!=255&&(k=i[23615],i[n+40>>2]=i[23614],i[n+44>>2]=k,X[i[(n+40|0)+(t<<2)>>2]](n+39|0,n+8|0)),v=n+48|0,l[_+32|0])break k;if(n=i[_+12>>2],k=i[_+16>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),t=0,n=X0(n,106612,106744),!k|!n||(i[k+4>>2]=i[k+4>>2]+1,t=k),o=i[n+180>>2],n=i[o+104>>2],(n|0)==i[o+108>>2])n=0;else{w=i[n>>2],o=i[n+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);t:{u:{o:{l:{s:{w:{if(n=i[w+16>>2],(n|0)<=1781689192){if((n|0)==1635135537)break w;if((n|0)!=1635148593)break o;n=1635148659;break t}if((n|0)==1781689193)break s;if((n|0)==1835692135)break l;if((n|0)!=1987470129)break u;n=1987471731;break t}n=1635150195;break t}n=1781688691;break t}n=1785751411;break t}if((n|0)!=1752589105||(n=i[w+36>>2],w=i[w+40>>2],(n|0)==(w|0)))break u;for(;;){o:{if(s=i[n>>2],!s||(s=X0(s,86628,97612),!s))break o;if(w=i[n+4>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),n=1751479907,m=l[s+103|0],s=i[s+104>>2],(m|0)==1|(s&1073741824)!=0||(n=s&268435456|(m|0)==3?1751479907:1751479928),!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break t;X[i[i[w>>2]+8>>2]](w),p(w);break t}if(n=n+8|0,(w|0)==(n|0))break}}n=0}t:{if(!o||(w=i[o+4>>2],i[o+4>>2]=w-1,w))break t;X[i[i[o>>2]+8>>2]](o),p(o)}}t:{u:{if(n){o=i[B+20>>2],s=i[B+24>>2];o:{if(o>>>0<s>>>0){i[o>>2]=n,s=o+4|0;break o}if(m=i[B+16>>2],o=o-m|0,g=o>>2,w=g+1|0,w>>>0>=1073741824)break f;if(s=s-m|0,W=s>>1,s=s>>>0>=2147483644?1073741823:w>>>0<W>>>0?W:w,s){if(s>>>0>=1073741824)break n;w=E(s<<2)}else w=0;if(W=w+o|0,i[W>>2]=n,g=W-(g<<2)|0,o&&z(g,m,o),i[B+24>>2]=w+(s<<2),s=W+4|0,i[B+20>>2]=s,i[B+16>>2]=g,!m)break o;Z(m)}if(i[B+20>>2]=s,I)break u;break t}if(i[I>>2]|!I)break t;n=1836279345}i[I>>2]=n}t:{if(!t||(n=i[t+4>>2],i[t+4>>2]=n-1,n))break t;X[i[i[t>>2]+8>>2]](t),p(t)}t:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break t;X[i[i[k>>2]+8>>2]](k),p(k)}n=l[_+32|0],(n|0)!=255&&(t=i[24067],i[_+56>>2]=i[24066],i[_+60>>2]=t,X[i[(_+56|0)+(n<<2)>>2]](_+48|0,_+12|0)),n=i[_+36>>2]}if(n){if(k=n,t=i[_+40>>2],(k|0)!=(t|0)){for(;;){k=i[t-4>>2];t:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break t;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t-8|0,(t|0)==(n|0))break}k=i[_+36>>2]}i[_+40>>2]=n,Z(k)}v=_- -64|0;break A}x0(),H()}_2(),H()}if(o=i[B+20>>2],n=i[h+48>>2],k=i[n+28>>2],m=i[n+32>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),t=i[B+16>>2],i[k+100>>2]||(i[k+100>>2]=i[B+40>>2]),i[k+104>>2]=0,(t|0)!=(o|0))for(n=t;Hr(k,i[n>>2]),n=n+4|0,(o|0)!=(n|0););if(s=v-48|0,v=s,I=i[h+48>>2],k=i[I+16>>2],n=i[I+20>>2],(k|0)!=(n|0))for(;h=i[k>>2],X[i[i[h>>2]+20>>2]](s+12|0,h,D),u[s+31|0]<0&&Z(i[s+20>>2]),k=k+8|0,(n|0)!=(k|0););n=i[I+68>>2];A:{if(!n)break A;if(_=0,h=v-176|0,v=h,y=D,o=i[n+104>>2],k=i[n+108>>2],(o|0)==(k|0))k=8;else{for(;;){k:{if(l[o+4|0]||(w=i[o+16>>2],W=i[o+20>>2],(w|0)==(W|0)))break k;for(;_=i[w+16>>2]+_|0,w=w+40|0,(W|0)!=(w|0););}if(o=o+32|0,(k|0)==(o|0))break}k=_+8|0}C0(y,k),C0(D,1835295092),l[n+132|0]&&bo(i[n+136>>2],0,0,0),g=s+12|0;k:{n:{t:{u:{o:{if(_=i[n+104>>2],V=i[n+108>>2],(_|0)!=(V|0))for(;;){l:{if(l[_+4|0]||(i[_+8>>2]=i[D+12>>2],i[_+12>>2]=0,w=i[_+16>>2],N=i[_+20>>2],(w|0)==(N|0)))break l;for(;;){k=i[D+12>>2],o=i[_+8>>2],W=k-o|0,k=0-(i[_+12>>2]+(k>>>0<o>>>0)|0)|0,i[w+8>>2]=W,i[w+12>>2]=k;s:{if(l[n+132|0]==1){W=i[w+16>>2],k=0,i[h+172>>2]=0,i[h+164>>2]=0,i[h+168>>2]=0;w:{if(!W){o=0;break w}if((W|0)<0)break f;o=E(W),i[h+164>>2]=o,k=o+W|0,i[h+172>>2]=k,W&&o0(o,0,W),i[h+168>>2]=k,k=i[w+16>>2]}if(y=i[n+136>>2],W=v-16|0,v=W,i[W+12>>2]=k,i[W+8>>2]=o,k=C7(y|0,W+8|0,1,W+4|0)|0,k?(i[31336]=k,k=-1):k=0,v=W+16|0,k=k?-1:i[W+4>>2],(k|0)<0){i[h+108>>2]=0,i[h+80>>2]=72244,i[h+24>>2]=72224,n=i[18065],i[h+16>>2]=n,k=i[n-12>>2],n=h+16|0,i[k+n>>2]=i[18066],i[h+20>>2]=0,k=n+i[i[h+16>>2]-12>>2]|0,o=h+28|0,J0(k,o),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[h+24>>2]=k,w=i[k-12>>2],k=h+24|0,i[w+k>>2]=i[18068],w=i[18064],i[h+16>>2]=w,i[n+i[w-12>>2]>>2]=i[18069],i[h+80>>2]=72244,i[h+16>>2]=72204,i[h+24>>2]=72224,o=R0(o),i[o>>2]=71280,i[h+68>>2]=0,i[h+72>>2]=0,i[h+60>>2]=0,i[h+64>>2]=0,i[h+76>>2]=24,S0(Y(k,27752,33),i[31336]),n=i[h+76>>2];w:{if(n&16){_=h+48|0,k=i[h+72>>2],n=i[h+52>>2],k>>>0<n>>>0?i[h+72>>2]=n:n=k;break w}if(!(n&8)){w=0,u[h+15|0]=0,_=h+4|0;break t}_=h+36|0,n=i[h+44>>2]}if(k=n,n=i[_>>2],w=k-n|0,w>>>0>=2147483640)break o;if(w>>>0>=11){k=w|7,_=E(k+1|0),i[h+12>>2]=k-2147483647,i[h+4>>2]=_,i[h+8>>2]=w;break u}if(u[h+15|0]=w,_=h+4|0,w)break u;w=0;break t}if(i[w+16>>2]!=(k|0)|i[w+20>>2]){if(n=E(40),i[h+16>>2]=n,i[h+20>>2]=37,i[h+24>>2]=-2147483608,k=l[1636]|l[1637]<<8|(l[1638]<<16|l[1639]<<24),o=l[1632]|l[1633]<<8|(l[1634]<<16|l[1635]<<24),u[n|0]=o,u[n+1|0]=o>>>8,u[n+2|0]=o>>>16,u[n+3|0]=o>>>24,u[n+4|0]=k,u[n+5|0]=k>>>8,u[n+6|0]=k>>>16,u[n+7|0]=k>>>24,u[n+37|0]=0,k=l[1665]|l[1666]<<8|(l[1667]<<16|l[1668]<<24),o=l[1661]|l[1662]<<8|(l[1663]<<16|l[1664]<<24),u[n+29|0]=o,u[n+30|0]=o>>>8,u[n+31|0]=o>>>16,u[n+32|0]=o>>>24,u[n+33|0]=k,u[n+34|0]=k>>>8,u[n+35|0]=k>>>16,u[n+36|0]=k>>>24,k=l[1660]|l[1661]<<8|(l[1662]<<16|l[1663]<<24),o=l[1656]|l[1657]<<8|(l[1658]<<16|l[1659]<<24),u[n+24|0]=o,u[n+25|0]=o>>>8,u[n+26|0]=o>>>16,u[n+27|0]=o>>>24,u[n+28|0]=k,u[n+29|0]=k>>>8,u[n+30|0]=k>>>16,u[n+31|0]=k>>>24,k=l[1652]|l[1653]<<8|(l[1654]<<16|l[1655]<<24),o=l[1648]|l[1649]<<8|(l[1650]<<16|l[1651]<<24),u[n+16|0]=o,u[n+17|0]=o>>>8,u[n+18|0]=o>>>16,u[n+19|0]=o>>>24,u[n+20|0]=k,u[n+21|0]=k>>>8,u[n+22|0]=k>>>16,u[n+23|0]=k>>>24,k=l[1644]|l[1645]<<8|(l[1646]<<16|l[1647]<<24),o=l[1640]|l[1641]<<8|(l[1642]<<16|l[1643]<<24),u[n+8|0]=o,u[n+9|0]=o>>>8,u[n+10|0]=o>>>16,u[n+11|0]=o>>>24,u[n+12|0]=k,u[n+13|0]=k>>>8,u[n+14|0]=k>>>16,u[n+15|0]=k>>>24,K(g,9,0,h+16|0),u[h+27|0]>=0)break n;Z(i[h+16>>2]);break n}if(V4(D,h+164|0),k=i[h+164>>2],!k)break s;i[h+168>>2]=k,Z(k);break s}V4(D,w+24|0)}if(w=w+40|0,(N|0)==(w|0))break}}if(_=_+32|0,(V|0)==(_|0))break}if(an(n,D),n=i[26929],i[g>>2]=i[26928],i[g+4>>2]=n,n=g+8|0,u[107731]>=0){k=i[26931],i[n>>2]=i[26930],i[n+4>>2]=k,i[n+8>>2]=i[26932];break k}T(n,i[26930],i[26931]);break k}g0(),H()}if(!w)break t;z(_,n,w)}u[w+_|0]=0,K(g,9,0,h+4|0),u[h+15|0]<0&&Z(i[h+4>>2]),n=i[18063],i[h+16>>2]=n,i[i[n-12>>2]+(h+16|0)>>2]=i[18071],i[h+24>>2]=i[18072],i[o>>2]=71280,u[h+71|0]<0&&Z(i[h+60>>2]),y0(o),p0(h+80|0)}if(n=i[h+164>>2],!n)break k;i[h+168>>2]=n,Z(n)}if(v=h+176|0,u[s+31|0]>=0)break A;Z(i[s+20>>2])}k=i[I+136>>2];A:{if(!k)break A;n=v-32|0,v=n,k=X[i[i[k>>2]+12>>2]](k)|0;k:{if(k>>>0<=4294967287){C0(D,k+8|0),C0(D,1835295092);break k}C0(D,1),C0(D,1835295092),e4(D,k+16|0,0)}if(k=i[D+12>>2],h=i[I+136>>2],X[i[i[h>>2]+16>>2]](n+12|0,h,D),u[n+31|0]<0&&Z(i[n+20>>2]),u[s+32|0]=0,i[s+12>>2]=k,v=n+32|0,n=l[s+32|0],(n|0)==255)break A;k:{if(n||(k=i[I+16>>2],h=i[I+20>>2],(k|0)==(h|0)))break k;for(;Ko(i[k>>2],D,i[s+12>>2]),k=k+8|0,(h|0)!=(k|0););}k=i[23745],i[s+40>>2]=i[23744],i[s+44>>2]=k,X[i[(s+40|0)+(n<<2)>>2]](s+39|0,s+12|0)}v=s+48|0;A:{if(!m||(n=i[m+4>>2],i[m+4>>2]=n-1,n))break A;X[i[i[m>>2]+8>>2]](m),p(m)}t&&Z(t),v=B+80|0;break r}G0(),H()}i[C+20>>2]=0,i[C+12>>2]=0,i[C+16>>2]=0,n=i[C+28>>2],k=i[C+24>>2];r:{if((n|0)==(k|0)){n=0;break r}if(t=n-k|0,(t|0)<0)break i;n=E(t),t&&z(n,k,t),O=n+t|0}X[i[r+4>>2]](C,e,n,O-n|0,f);r:{if(!i[C+8>>2]){if(!i[C>>2]){i[C+8>>2]=48906,i[A+8>>2]=48906,e=i[C+4>>2],i[A>>2]=i[C>>2],i[A+4>>2]=e;break r}i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=3134;break r}e=i[C+4>>2],i[A>>2]=i[C>>2],i[A+4>>2]=e,i[A+8>>2]=i[C+8>>2]}if(n&&Z(n),A=i[C+24>>2],!A)break e;i[C+28>>2]=A,Z(A)}v=C+48|0;return}G0(),H()}function p7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;t=v-48|0,v=t,i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,u[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+12>>2]=0,i[A+16>>2]=4740,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,k=A- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A>>2]=106588,o0(A+100|0,0,188),i[A+20>>2]=e,k=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),e=i[k+140>>2],k=i[k+144>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[A+124>>2]=e,n=i[A+128>>2],i[A+128>>2]=k;i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;X[i[i[n>>2]+8>>2]](n),p(n)}i:{if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break i;X[i[i[s>>2]+8>>2]](s),p(s)}k=i[A+124>>2],i[t+36>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,e=i[k+36>>2],n=i[k+40>>2];i:{if((e|0)==(n|0)){o=1;break i}for(;;){k=i[e>>2];e:{if(!k||(k=X0(k,86628,92872),!k)||(i[t+40>>2]=k,k=i[e+4>>2],i[t+44>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(t+28|0,t+40|0),s=i[t+44>>2],!s)||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break e;X[i[i[s>>2]+8>>2]](s),p(s)}if(e=e+8|0,(n|0)==(e|0))break}if(o=1,n=i[t+28>>2],s=i[t+32>>2],(n|0)!=(s|0)){for(;;){for(e=i[i[n>>2]+36>>2];;){e:{if(k=i[e>>2],k&&(w=X0(k,86628,104568),w))break e;e=e+8|0;continue}break}_=i[e+4>>2];e:{if(!_){e=i[w+120>>2],o=e>>>0<o>>>0?o:e+1|0;break e}if(k=i[_+4>>2],e=k+1|0,i[_+4>>2]=e,w=i[w+120>>2],i[_+4>>2]=k,o=o>>>0>w>>>0?o:w+1|0,e)break e;X[i[i[_>>2]+8>>2]](_),p(_)}if(n=n+8|0,(s|0)==(n|0))break}n=i[t+28>>2]}if(!n)break i;if(e=i[t+32>>2],k=n,(e|0)!=(k|0)){for(;;){s=i[e-4>>2];e:{if(!s||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break e;X[i[i[s>>2]+8>>2]](s),p(s)}if(e=e-8|0,(n|0)==(e|0))break}k=i[t+28>>2]}i[t+32>>2]=n,Z(k)}for(e=i[i[A+124>>2]+36>>2];;){i:{e:{if(k=i[e>>2],!k||(k=X0(k,86628,104488),!k))break e;if(n=i[e+4>>2],!n){i[k+180>>2]=o+1,i[A+24>>2]=o;break i}if(i[n+4>>2]=i[n+4>>2]+1,i[k+180>>2]=o+1,i[A+24>>2]=o,e=i[n+4>>2],i[n+4>>2]=e-1,e)break i;X[i[i[n>>2]+8>>2]](n),p(n);break i}e=e+8|0;continue}break}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92772,n=e+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1953653099,i[e+16>>2]=92812,i[A+132>>2]=k,k=i[A+136>>2],i[A+136>>2]=e;i:{e:{if(!k){k=i[A+124>>2],i[t+32>>2]=e,i[t+28>>2]=n;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(X[i[i[k>>2]+8>>2]](k),p(k)),k=i[A+124>>2],n=i[A+132>>2],e=i[A+136>>2],i[t+32>>2]=e,i[t+28>>2]=n,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(k+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(208),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92892,n=e+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104508,k=i[14764],i[e+160>>2]=i[14763],i[e+164>>2]=k,k=i[14766],i[e+168>>2]=i[14765],i[e+172>>2]=k,k=i[14768],i[e+176>>2]=i[14767],i[e+180>>2]=k,k=i[14770],i[e+184>>2]=i[14769],i[e+188>>2]=k,i[e+192>>2]=i[14771],i[e+152>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,Q[e+156>>1]=256,i[e+196>>2]=0,i[e+200>>2]=0,i[e+32>>2]=1953196132,i[e+116>>2]=7,i[A+140>>2]=n,k=i[A+144>>2],i[A+144>>2]=e;i:{e:{if(!k){k=i[A+132>>2],i[t+32>>2]=e,i[t+28>>2]=n;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(X[i[i[k>>2]+8>>2]](k),p(k)),k=i[A+132>>2],n=i[A+140>>2],e=i[A+144>>2],i[t+32>>2]=e,i[t+28>>2]=n,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(k+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}i[i[A+140>>2]+120>>2]=o,s=E(120),i[s>>2]=92932,i[s+4>>2]=0,i[s+8>>2]=0,k=s+16|0,e=k,i[e+8>>2]=0,i[e+12>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+16>>2]=86404,i[s+60>>2]=0,i[s+64>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+72>>2]=-1,i[s+76>>2]=-1,i[s+80>>2]=-1,i[s+84>>2]=-1,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0,u[s+112|0]=0,i[s+32>>2]=1835297121,i[s+16>>2]=92972,e=i[A+132>>2],i[t+32>>2]=s,i[t+28>>2]=k,i[s+4>>2]=i[s+4>>2]+1,r2(e+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(160),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93052,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104588,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,u[e+152|0]=117,u[e+153|0]=110,u[e+154|0]=107,u[e+155|0]=0,i[e+32>>2]=1835296868,i[A+156>>2]=k,k=i[A+160>>2],i[A+160>>2]=e;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=i[A+156>>2],i[e+120>>2]=r?i[r>>2]:9e4,i[t+28>>2]=e,e=i[A+160>>2],i[t+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),n=s+52|0,r2(n,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89852,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87172,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=1885954932,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+32>>2]=1751411826,i[A+164>>2]=k,w=i[A+168>>2],i[A+168>>2]=e;i:{e:{if(!w){i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[w+4>>2],i[w+4>>2]=e-1,e||(X[i[i[w>>2]+8>>2]](w),p(w)),k=i[A+164>>2],e=i[A+168>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(n,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}i[i[A+164>>2]+108>>2]=f,e=E(120),i[e>>2]=93092,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1835626086,i[e+16>>2]=93132,i[A+148>>2]=f,k=i[A+152>>2],i[A+152>>2]=e;i:{e:{if(!k){i[t+32>>2]=e,i[t+28>>2]=f;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(X[i[i[k>>2]+8>>2]](k),p(k)),f=i[A+148>>2],e=i[A+152>>2],i[t+32>>2]=e,i[t+28>>2]=f,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(n,t+28|0),f=i[t+32>>2];i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;X[i[i[f>>2]+8>>2]](f),p(f)}f=E(120),e=f,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91092,k=e+16|0,e=k,i[e+8>>2]=0,i[e+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[f+16>>2]=88600,i[f+32>>2]=1684631142,m=E(120),i[m>>2]=91132,i[m+4>>2]=0,i[m+8>>2]=0,o=m+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[m+60>>2]=0,i[m+64>>2]=0,i[m+52>>2]=0,i[m+56>>2]=0,i[m+72>>2]=-1,i[m+76>>2]=-1,i[m+80>>2]=-1,i[m+84>>2]=-1,i[m+116>>2]=0,i[m+88>>2]=0,i[m+92>>2]=0,i[m+96>>2]=0,i[m+100>>2]=0,i[m+104>>2]=0,i[m+108>>2]=0,Q[m+112>>1]=0,i[e>>2]=88680,i[m+32>>2]=1685218662,_=E(136),i[_>>2]=91172,i[_+4>>2]=0,i[_+8>>2]=0,w=_+16|0,e=w,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[_+60>>2]=0,i[_+64>>2]=0,i[_+52>>2]=0,i[_+56>>2]=0,i[_+72>>2]=-1,i[_+76>>2]=-1,i[_+80>>2]=-1,i[_+84>>2]=-1,i[_+88>>2]=0,i[_+92>>2]=0,i[_+96>>2]=0,i[_+100>>2]=0,i[_+104>>2]=0,i[_+108>>2]=0,Q[_+112>>1]=0,i[e>>2]=88760,i[_+128>>2]=0,i[_+120>>2]=0,i[_+124>>2]=0,i[_+116>>2]=1,i[_+32>>2]=1970433056,e=i[A+148>>2],i[t+32>>2]=f,i[t+28>>2]=k,i[f+4>>2]=i[f+4>>2]+1,r2(e+36|0,t+28|0),n=f+52|0,k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}k=m+52|0,i[t+32>>2]=m,i[t+28>>2]=o,i[m+4>>2]=i[m+4>>2]+1,r2(n,t+28|0),n=i[t+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;X[i[i[n>>2]+8>>2]](n),p(n)}i[t+32>>2]=_,i[t+28>>2]=w,i[_+4>>2]=i[_+4>>2]+1,r2(k,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93252,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1937007212,i[e+16>>2]=93292,i[A+172>>2]=k,n=i[A+176>>2],i[A+176>>2]=e;i:{e:{if(!n){o=i[A+148>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+148>>2],k=i[A+172>>2],e=i[A+176>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93372,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104828,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011556,i[A+180>>2]=k,n=i[A+184>>2],i[A+184>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+180>>2],e=i[A+184>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93412,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104908,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011827,i[A+204>>2]=k,n=i[A+208>>2],i[A+208>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+204>>2],e=i[A+208>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93452,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104988,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1668576371,i[A+212>>2]=k,k=i[A+216>>2],i[A+216>>2]=e;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93492,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=105068,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011555,i[A+188>>2]=k,n=i[A+192>>2],i[A+192>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+188>>2],e=i[A+192>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93572,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=105228,i[e+144>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011578,i[A+228>>2]=k,n=i[A+232>>2],i[A+232>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+228>>2],e=i[A+232>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93532,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=105148,i[e+136>>2]=0,i[e+140>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937007471,i[A+196>>2]=k,n=i[A+200>>2],i[A+200>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+196>>2],e=i[A+200>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93612,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=105308,u[e+133|0]=0,u[e+134|0]=0,u[e+135|0]=0,u[e+136|0]=0,u[e+137|0]=0,u[e+138|0]=0,u[e+139|0]=0,u[e+140|0]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011571,i[A+220>>2]=k,n=i[A+224>>2],i[A+224>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(X[i[i[n>>2]+8>>2]](n),p(n)),o=i[A+172>>2],k=i[A+220>>2],e=i[A+224>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}i:{if(!r)break i;if(o=A+32|0,(o|0)!=(r|0))e:{i[o>>2]=i[r>>2],u[o+4|0]=l[r+4|0],i[o+8>>2]=i[r+8>>2];r:{if(i[r+12>>2]){e=Ak(),i[o+12>>2]=e,A3(e,i[r+12>>2]);break r}i[o+12>>2]=0}if(i[o+16>>2]=i[r+16>>2],w=o+20|0,n=r+20|0,k=u[r+31|0],u[o+31|0]>=0){if((k|0)>=0){e=i[n+4>>2],i[w>>2]=i[n>>2],i[w+4>>2]=e,i[w+8>>2]=i[n+8>>2];break e}D1(w,i[r+20>>2],i[r+24>>2]);break e}e=(k|0)<0,O1(w,e?i[r+20>>2]:n,e?i[r+24>>2]:k)}if(i[A+40>>2]&&(e=tn(E(32),l[A+36|0]),i[t+28>>2]=0,Bi(A+264|0,e),Bi(t+28|0,0),e=i[A+264>>2],k=i[e>>2],i[k+108>>2]=0,i[k+104>>2]=1937006953,i[k+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937006953,i[e+100>>2]=1),i[A+48>>2]&&(e=tn(E(32),l[A+36|0]),i[t+28>>2]=0,Bi(A+268|0,e),Bi(t+28|0,0),e=i[A+268>>2],k=i[e>>2],i[k+108>>2]=0,i[k+104>>2]=1937074532,i[k+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937074532,i[e+100>>2]=1),e=u[r+31|0],!((e|0)<0?i[r+24>>2]:e))break i;I=r+20|0,n=E(152),e=n,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89852,g=e+16|0,e=g,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,Q[n+112>>1]=0,i[e>>2]=87172,i[n+128>>2]=0,i[n+132>>2]=0,i[n+120>>2]=0,i[n+124>>2]=1835365473,i[n+136>>2]=0,i[n+140>>2]=0,i[n+144>>2]=0,i[n+148>>2]=0,i[n+32>>2]=1751411826,k=E(184),i[k>>2]=90012,i[k+4>>2]=0,i[k+8>>2]=0,o=k+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87332,i[k+128>>2]=0,i[k+132>>2]=0,Q[k+124>>1]=0,i[k+120>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,w=k+168|0,e=w,i[e>>2]=0,i[e+4>>2]=0,u[k+173|0]=0,u[k+174|0]=0,u[k+175|0]=0,u[k+176|0]=0,u[k+177|0]=0,u[k+178|0]=0,u[k+179|0]=0,u[k+180|0]=0,i[k+32>>2]=1768842853,i[k+128>>2]=1970432288,e=E(48),u[e+45|0]=0,B=l[21475]|l[21476]<<8|(l[21477]<<16|l[21478]<<24),h=l[21471]|l[21472]<<8|(l[21473]<<16|l[21474]<<24),u[e+37|0]=h,u[e+38|0]=h>>>8,u[e+39|0]=h>>>16,u[e+40|0]=h>>>24,u[e+41|0]=B,u[e+42|0]=B>>>8,u[e+43|0]=B>>>16,u[e+44|0]=B>>>24,B=l[21470]|l[21471]<<8|(l[21472]<<16|l[21473]<<24),h=l[21466]|l[21467]<<8|(l[21468]<<16|l[21469]<<24),u[e+32|0]=h,u[e+33|0]=h>>>8,u[e+34|0]=h>>>16,u[e+35|0]=h>>>24,u[e+36|0]=B,u[e+37|0]=B>>>8,u[e+38|0]=B>>>16,u[e+39|0]=B>>>24,B=l[21462]|l[21463]<<8|(l[21464]<<16|l[21465]<<24),h=l[21458]|l[21459]<<8|(l[21460]<<16|l[21461]<<24),u[e+24|0]=h,u[e+25|0]=h>>>8,u[e+26|0]=h>>>16,u[e+27|0]=h>>>24,u[e+28|0]=B,u[e+29|0]=B>>>8,u[e+30|0]=B>>>16,u[e+31|0]=B>>>24,B=l[21454]|l[21455]<<8|(l[21456]<<16|l[21457]<<24),h=l[21450]|l[21451]<<8|(l[21452]<<16|l[21453]<<24),u[e+16|0]=h,u[e+17|0]=h>>>8,u[e+18|0]=h>>>16,u[e+19|0]=h>>>24,u[e+20|0]=B,u[e+21|0]=B>>>8,u[e+22|0]=B>>>16,u[e+23|0]=B>>>24,B=l[21446]|l[21447]<<8|(l[21448]<<16|l[21449]<<24),h=l[21442]|l[21443]<<8|(l[21444]<<16|l[21445]<<24),u[e+8|0]=h,u[e+9|0]=h>>>8,u[e+10|0]=h>>>16,u[e+11|0]=h>>>24,u[e+12|0]=B,u[e+13|0]=B>>>8,u[e+14|0]=B>>>16,u[e+15|0]=B>>>24,B=l[21438]|l[21439]<<8|(l[21440]<<16|l[21441]<<24),h=l[21434]|l[21435]<<8|(l[21436]<<16|l[21437]<<24),u[e|0]=h,u[e+1|0]=h>>>8,u[e+2|0]=h>>>16,u[e+3|0]=h>>>24,u[e+4|0]=B,u[e+5|0]=B>>>8,u[e+6|0]=B>>>16,u[e+7|0]=B>>>24,D1(w,e,45),Z(e),i[k+120>>2]=1,w=E(120),i[w>>2]=89972,i[w+4>>2]=0,i[w+8>>2]=0,e=w+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[w+60>>2]=0,i[w+64>>2]=0,i[w+52>>2]=0,i[w+56>>2]=0,i[w+72>>2]=-1,i[w+76>>2]=-1,i[w+80>>2]=-1,i[w+84>>2]=-1,i[w+116>>2]=0,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+100>>2]=0,i[w+104>>2]=0,i[w+108>>2]=0,Q[w+112>>1]=0,i[e>>2]=87412,i[w+32>>2]=1768517222,i[t+32>>2]=k,i[t+28>>2]=o,i[k+4>>2]=i[k+4>>2]+1,r2(w+52|0,t+28|0),h=i[t+32>>2];e:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break e;X[i[i[h>>2]+8>>2]](h),p(h)}i[t+36>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,B=t+28|0,o=I,h=u[r+31|0],I=(h|0)<0,o=I?i[r+20>>2]:o,r=(I?i[r+24>>2]:h)+1|0,Xn(B,o,r+o|0,r),W=E(176),i[W>>2]=89932,i[W+4>>2]=0,i[W+8>>2]=0,I=Ft(W+16|0),rr(t+8|0,I,1,B,1),u[t+27|0]<0&&Z(i[t+16>>2]),r=E(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=89732,B=r+16|0,o=B,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,Q[r+112>>1]=0,i[o>>2]=87092,i[r+32>>2]=1835365473,i[t+44>>2]=n,i[t+40>>2]=g,i[n+4>>2]=i[n+4>>2]+1,h=r+52|0,r2(h,t+40|0),g=i[t+44>>2];e:{if(!g||(o=i[g+4>>2],i[g+4>>2]=o-1,o))break e;X[i[i[g>>2]+8>>2]](g),p(g)}i[t+44>>2]=w,i[t+40>>2]=e,i[w+4>>2]=i[w+4>>2]+1,r2(h,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;X[i[i[o>>2]+8>>2]](o),p(o)}i[t+44>>2]=W,i[t+40>>2]=I,i[W+4>>2]=i[W+4>>2]+1,r2(h,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;X[i[i[o>>2]+8>>2]](o),p(o)}e=i[A+132>>2],i[t+44>>2]=r,i[t+40>>2]=B,i[r+4>>2]=i[r+4>>2]+1,r2(e+36|0,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;X[i[i[o>>2]+8>>2]](o),p(o)}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(X[i[i[r>>2]+8>>2]](r),p(r)),e=i[W+4>>2],i[W+4>>2]=e-1,e||(X[i[i[W>>2]+8>>2]](W),p(W)),e=i[t+28>>2],e&&(i[t+32>>2]=e,Z(e)),e=i[w+4>>2],i[w+4>>2]=e-1,e||(X[i[i[w>>2]+8>>2]](w),p(w)),e=i[k+4>>2],i[k+4>>2]=e-1,e||(X[i[i[k>>2]+8>>2]](k),p(k)),e=i[n+4>>2],i[n+4>>2]=e-1,e)break i;X[i[i[n>>2]+8>>2]](n),p(n)}return e=i[_+4>>2],i[_+4>>2]=e-1,e||(X[i[i[_>>2]+8>>2]](_),p(_)),e=i[m+4>>2],i[m+4>>2]=e-1,e||(X[i[i[m>>2]+8>>2]](m),p(m)),e=i[f+4>>2],i[f+4>>2]=e-1,e||(X[i[i[f>>2]+8>>2]](f),p(f)),e=i[s+4>>2],i[s+4>>2]=e-1,e||(X[i[i[s>>2]+8>>2]](s),p(s)),v=t+48|0,A}function j_(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;k=v-144|0,v=k,r=i[e+100>>2],i[k+124>>2]=i[r+48>>2],W=i[r+52>>2],i[k+128>>2]=W,W&&(i[W+4>>2]=i[W+4>>2]+1),r=i[e+108>>2],n=i[e+104>>2];i:{if((r|0)!=(n|0))for(f=n;;){e:{if(t=i[f>>2],!t||(t=X0(t,86628,101860),!t))break e;I=i[f+4>>2],I&&(i[I+4>>2]=i[I+4>>2]+1,n=i[e+104>>2],r=i[e+108>>2]);r:{f:{A:{k:{n:{t:{if((r|0)!=(n|0))for(;;){u:{if(f=i[n>>2],!f||(B=X0(f,86628,86648),!B))break u;if(C=i[n+4>>2],C&&(i[C+4>>2]=i[C+4>>2]+1),r=i[t+164>>2],i[k+112>>2]=i[t+160>>2],i[k+116>>2]=r,r=i[t+156>>2],i[k+104>>2]=i[t+152>>2],i[k+108>>2]=r,r=i[t+148>>2],i[k+96>>2]=i[t+144>>2],i[k+100>>2]=r,r=i[t+140>>2],i[k+88>>2]=i[t+136>>2],i[k+92>>2]=r,r=i[t+132>>2],i[k+80>>2]=i[t+128>>2],i[k+84>>2]=r,r=i[t+124>>2],i[k+72>>2]=i[t+120>>2],i[k+76>>2]=r,r=i[t+116>>2],n=k- -64|0,i[n>>2]=i[t+112>>2],i[n+4>>2]=r,r=i[t+108>>2],i[k+56>>2]=i[t+104>>2],i[k+60>>2]=r,f=i[B+104>>2],i[k+60>>2]=f,r=i[B+108>>2],i[n>>2]=r,r&&f)break t;if(e=E(40),i[k+32>>2]=e,i[k+36>>2]=39,i[k+40>>2]=-2147483608,f=l[23587]|l[23588]<<8|(l[23589]<<16|l[23590]<<24),r=l[23583]|l[23584]<<8|(l[23585]<<16|l[23586]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+39|0]=0,f=l[23618]|l[23619]<<8|(l[23620]<<16|l[23621]<<24),r=l[23614]|l[23615]<<8|(l[23616]<<16|l[23617]<<24),u[e+31|0]=r,u[e+32|0]=r>>>8,u[e+33|0]=r>>>16,u[e+34|0]=r>>>24,u[e+35|0]=f,u[e+36|0]=f>>>8,u[e+37|0]=f>>>16,u[e+38|0]=f>>>24,f=l[23611]|l[23612]<<8|(l[23613]<<16|l[23614]<<24),r=l[23607]|l[23608]<<8|(l[23609]<<16|l[23610]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[23603]|l[23604]<<8|(l[23605]<<16|l[23606]<<24),r=l[23599]|l[23600]<<8|(l[23601]<<16|l[23602]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[23595]|l[23596]<<8|(l[23597]<<16|l[23598]<<24),r=l[23591]|l[23592]<<8|(l[23593]<<16|l[23594]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,k+32|0),u[k+43|0]>=0)break n;Z(i[k+32>>2]);break n}if(n=n+8|0,(n|0)==(r|0))break}if(e=E(48),i[k+56>>2]=e,i[k+60>>2]=40,i[k+64>>2]=-2147483600,f=l[22318]|l[22319]<<8|(l[22320]<<16|l[22321]<<24),r=l[22314]|l[22315]<<8|(l[22316]<<16|l[22317]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[22350]|l[22351]<<8|(l[22352]<<16|l[22353]<<24),r=l[22346]|l[22347]<<8|(l[22348]<<16|l[22349]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[22342]|l[22343]<<8|(l[22344]<<16|l[22345]<<24),r=l[22338]|l[22339]<<8|(l[22340]<<16|l[22341]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[22334]|l[22335]<<8|(l[22336]<<16|l[22337]<<24),r=l[22330]|l[22331]<<8|(l[22332]<<16|l[22333]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[22326]|l[22327]<<8|(l[22328]<<16|l[22329]<<24),r=l[22322]|l[22323]<<8|(l[22324]<<16|l[22325]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,k+56|0),u[k+67|0]>=0)break k;Z(i[k+56>>2]);break k}B=A,V=v-16|0,v=V,A=i[k+60>>2],_=e+448|0,r=_,i[r>>2]=i[k+56>>2],i[r+4>>2]=A,A=i[k+116>>2],i[r+56>>2]=i[k+112>>2],i[r+60>>2]=A,A=i[k+108>>2],i[r+48>>2]=i[k+104>>2],i[r+52>>2]=A,A=i[k+100>>2],i[r+40>>2]=i[k+96>>2],i[r+44>>2]=A,A=i[k+92>>2],i[r+32>>2]=i[k+88>>2],i[r+36>>2]=A,A=i[k+84>>2],i[r+24>>2]=i[k+80>>2],i[r+28>>2]=A,A=i[k+76>>2],i[r+16>>2]=i[k+72>>2],i[r+20>>2]=A,A=i[k+68>>2],i[r+8>>2]=i[k+64>>2],i[r+12>>2]=A,n=i[k+68>>2],r=i[k+60>>2],A=i[23897],w=A;t:{u:{if(f=i[23896],!(A|f)){n=((r+n|0)-1>>>0)/(n>>>0)|0,A=i[k+72>>2],g=((A+i[k+64>>2]|0)-1>>>0)/(A>>>0)|0,r=l[k+82|0];break u}A=i[k+72>>2],g=((A+i[k+64>>2]|0)-1>>>0)/(A>>>0)|0,n=((r+n|0)-1>>>0)/(n>>>0)|0,A=O0(g,0,n,0),o=l0,r=l[k+82|0];o:{if(!r||(A=O0(A,o,i[k+84>>2],0),o=l0,h=r-1|0,!h)||(A=O0(A,o,i[k+88>>2],0),o=l0,(h|0)==1)||(A=O0(A,o,i[k+92>>2],0),o=l0,(h|0)==2)||(A=O0(A,o,i[k+96>>2],0),o=l0,(h|0)==3)||(A=O0(A,o,i[k+100>>2],0),o=l0,(h|0)==4)||(A=O0(A,o,i[k+104>>2],0),o=l0,(h|0)==5)||(A=O0(A,o,i[k+108>>2],0),o=l0,(h|0)==6))break o;A=O0(A,o,i[k+112>>2],0),o=l0}if((w|0)==(o|0)&A>>>0<=f>>>0|o>>>0<w>>>0)break u;if(A=E(40),i[V+4>>2]=A,i[V+8>>2]=38,i[V+12>>2]=-2147483608,f=l[3890]|l[3891]<<8|(l[3892]<<16|l[3893]<<24),r=l[3886]|l[3887]<<8|(l[3888]<<16|l[3889]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=f,u[A+5|0]=f>>>8,u[A+6|0]=f>>>16,u[A+7|0]=f>>>24,u[A+38|0]=0,f=l[3920]|l[3921]<<8|(l[3922]<<16|l[3923]<<24),r=l[3916]|l[3917]<<8|(l[3918]<<16|l[3919]<<24),u[A+30|0]=r,u[A+31|0]=r>>>8,u[A+32|0]=r>>>16,u[A+33|0]=r>>>24,u[A+34|0]=f,u[A+35|0]=f>>>8,u[A+36|0]=f>>>16,u[A+37|0]=f>>>24,f=l[3914]|l[3915]<<8|(l[3916]<<16|l[3917]<<24),r=l[3910]|l[3911]<<8|(l[3912]<<16|l[3913]<<24),u[A+24|0]=r,u[A+25|0]=r>>>8,u[A+26|0]=r>>>16,u[A+27|0]=r>>>24,u[A+28|0]=f,u[A+29|0]=f>>>8,u[A+30|0]=f>>>16,u[A+31|0]=f>>>24,f=l[3906]|l[3907]<<8|(l[3908]<<16|l[3909]<<24),r=l[3902]|l[3903]<<8|(l[3904]<<16|l[3905]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=f,u[A+21|0]=f>>>8,u[A+22|0]=f>>>16,u[A+23|0]=f>>>24,f=l[3898]|l[3899]<<8|(l[3900]<<16|l[3901]<<24),r=l[3894]|l[3895]<<8|(l[3896]<<16|l[3897]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=f,u[A+13|0]=f>>>8,u[A+14|0]=f>>>16,u[A+15|0]=f>>>24,K(B,3,1e3,V+4|0),u[V+15|0]>=0)break t;Z(i[V+4>>2]);break t}A=G(n,g),r=r&255;u:{if(!r||(A=G(A,i[k+84>>2]),r=r-1|0,!r)||(A=G(A,i[k+88>>2]),(r|0)==1)||(A=G(A,i[k+92>>2]),(r|0)==2)||(A=G(A,i[k+96>>2]),(r|0)==3)||(A=G(A,i[k+100>>2]),(r|0)==4)||(A=G(A,i[k+104>>2]),(r|0)==5)||(A=G(A,i[k+108>>2]),(r|0)==6))break u;A=G(A,i[k+112>>2])}f=A,r=i[_+68>>2],A=i[_+64>>2],w=r-A>>4;u:{if(f>>>0>w>>>0){g=0;o:{if(h=f-w|0,o=_- -64|0,n=i[o+8>>2],r=i[o+4>>2],h>>>0<=n-r>>4>>>0){l:{if(!h)break l;if(A=r,f=h&7,f)for(;i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=A+16|0,g=g+1|0,(f|0)!=(g|0););if(r=(h<<4)+r|0,(h-1&268435455)>>>0<7)break l;for(;i[A+24>>2]=0,i[A+28>>2]=0,i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+16>>2]=10,i[A+20>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=10,i[A+36>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+48>>2]=10,i[A+52>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+64>>2]=10,i[A+68>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+80>>2]=10,i[A+84>>2]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+96>>2]=10,i[A+100>>2]=0,i[A+112>>2]=10,i[A+116>>2]=0,A=A+128|0,(r|0)!=(A|0););}i[o+4>>2]=r;break o}l:{if(A=i[o>>2],f=r-A|0,w=h+(f>>4)|0,w>>>0<268435456){if(r=n-A|0,A=r>>3,w=r>>>0>=2147483632?268435455:A>>>0>w>>>0?A:w,w){if(w>>>0>=268435456)break l;s=E(w<<4)}if(n=f+s|0,A=n,r=h&7,r)for(;i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=A+16|0,g=g+1|0,(r|0)!=(g|0););if(f=n+(h<<4)|0,(h-1&268435455)>>>0>=7)for(;i[A+24>>2]=0,i[A+28>>2]=0,i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+16>>2]=10,i[A+20>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=10,i[A+36>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+48>>2]=10,i[A+52>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+64>>2]=10,i[A+68>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+80>>2]=10,i[A+84>>2]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+96>>2]=10,i[A+100>>2]=0,i[A+112>>2]=10,i[A+116>>2]=0,A=A+128|0,(f|0)!=(A|0););A=n,n=i[o>>2],r=i[o+4>>2]-n|0,A=A-r|0,r&&z(A,n,r),i[o+4>>2]=f,i[o>>2]=A,i[o+8>>2]=(w<<4)+s,n&&Z(n);break o}G0(),H()}x0(),H()}r=i[_+68>>2],A=i[_+64>>2];break u}if(f>>>0>=w>>>0)break u;r=(f<<4)+A|0,i[_+68>>2]=r}if((A|0)!=(r|0))for(;i[A>>2]=10,i[A+4>>2]=0,A=A+16|0,(r|0)!=(A|0););if(A=i[26929],i[B>>2]=i[26928],i[B+4>>2]=A,r=B+8|0,u[107731]>=0){A=i[26931],i[r>>2]=i[26930],i[r+4>>2]=A,i[r+8>>2]=i[26932];break t}T(r,i[26930],i[26931])}if(v=V+16|0,i[B>>2])break n;u[B+19|0]<0&&Z(i[B+8>>2]),A=xu(i[e+468>>2]),Wf(k+32|0,i[e+100>>2],A),r=i[k+32>>2],A=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,f=i[e+548>>2],i[e+544>>2]=r,i[e+548>>2]=A;t:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break t;X[i[i[f>>2]+8>>2]](f),p(f)}r=i[k+36>>2];t:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break t;X[i[i[r>>2]+8>>2]](r),p(r)}t:{if(l[t+97|0]==1){A=k+32|0,bi(A,e),m=l[k+52|0];u:{if(m){if((m|0)!=1)break A;k8(B,A);break u}s=i[e+544>>2],f=k+20|0,i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0;o:{l:{if(A=i[k+32>>2],t=i[k+36>>2],(A|0)!=(t|0)){if(n=t-A|0,(n|0)<0)break l;for(r=E(n),i[f+4>>2]=r,i[f>>2]=r,i[f+8>>2]=r+n;i[r>>2]=i[A>>2],n=i[A+4>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,A=A+8|0,(t|0)!=(A|0););i[f+4>>2]=r}A=f;break o}G0(),H()}if(r=A,A=i[s+104>>2],A){if(t=i[s+108>>2],f=A,(t|0)!=(A|0)){for(;;){n=i[t-4>>2];o:{if(!n||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break o;X[i[i[n>>2]+8>>2]](n),p(n)}if(t=t-8|0,(A|0)==(t|0))break}f=i[s+104>>2]}i[s+108>>2]=A,Z(f),i[s+112>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0}i[s+104>>2]=i[r>>2],i[s+108>>2]=i[r+4>>2],i[s+112>>2]=i[r+8>>2],i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,ve(r)}if(r=l[k+52|0],(r|0)!=255&&(A=i[25473],i[k+136>>2]=i[25472],i[k+140>>2]=A,X[i[(k+136|0)+(r<<2)>>2]](k+135|0,k+32|0)),!m)break t;break n}i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,f=i[t+36>>2],t=i[t+40>>2];u:{if((f|0)!=(t|0)){if(A=t-f|0,(A|0)<0)break f;for(r=E(A),i[k+36>>2]=r,i[k+32>>2]=r,i[k+40>>2]=A+r,A=r;i[A>>2]=i[f>>2],n=A,A=i[f+4>>2],i[n+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=n+8|0,f=f+8|0,(t|0)!=(f|0););for(i[k+36>>2]=A,f=r;;){if(i[i[f>>2]+16>>2]==1769173093)break u;if(t=(f|0)==(n|0),f=f+8|0,!!t)break}}h=k+136|0,at(h),A=i[k+72>>2],r=i[k+136>>2],i[r+104>>2]=i[k+68>>2],i[r+108>>2]=A;o:{l:{s:{r=i[k+36>>2],A=i[k+40>>2];w:{if(r>>>0<A>>>0){i[r>>2]=i[h>>2],i[r+4>>2]=i[h+4>>2],i[h>>2]=0,i[h+4>>2]=0,n=r+8|0;break w}if(w=i[k+32>>2],s=r-w|0,f=s>>3,n=f+1|0,n>>>0>=536870912)break s;if(r=A-w|0,A=r>>2,t=r>>>0>=2147483640?536870911:A>>>0>n>>>0?A:n,t){if(t>>>0>=536870912)break l;A=E(t<<3)}else A=0;if(n=A+s|0,i[n>>2]=i[h>>2],i[n+4>>2]=i[h+4>>2],i[h>>2]=0,i[h+4>>2]=0,r=n-(f<<3)|0,s&&z(r,w,s),i[k+40>>2]=A+(t<<3),n=n+8|0,i[k+36>>2]=n,i[k+32>>2]=r,!w)break w;Z(w)}i[k+36>>2]=n;break o}G0(),H()}x0(),H()}V2(h),A=i[k+36>>2],r=i[k+32>>2]}if(w=i[e+544>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,f=0,t=0,(A|0)!=(r|0)){if(f=A-r|0,(f|0)<0)break r;for(t=E(f),i[k+8>>2]=t,m=f+t|0,i[k+16>>2]=m,n=r,f=t;i[f>>2]=i[n>>2],s=i[n+4>>2],i[f+4>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),f=f+8|0,n=n+8|0,(n|0)!=(A|0););i[k+12>>2]=f}if(A=i[w+104>>2],A){if(r=A,n=i[w+108>>2],(A|0)!=(n|0)){for(;;){f=i[n-4>>2];u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n-8|0,(A|0)==(n|0))break}m=i[k+16>>2],f=i[k+12>>2],t=i[k+8>>2],r=i[w+104>>2]}i[w+108>>2]=A,Z(r),r=i[k+32>>2]}if(i[w+112>>2]=m,i[w+108>>2]=f,i[w+104>>2]=t,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,!r)break t;if(n=r,f=i[k+36>>2],(f|0)!=(r|0)){for(;;){n=i[f-4>>2];u:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break u;X[i[i[n>>2]+8>>2]](n),p(n)}if(f=f-8|0,(f|0)==(r|0))break}n=i[k+32>>2]}i[k+36>>2]=r,Z(n)}t:{u:{o:{l:{s:{if(f=i[e+544>>2],A=X[i[i[f>>2]+40>>2]](f)|0,(A|0)<=1781689136){w:{if((A|0)!=1635135537){if((A|0)==1635148593)break w;if((A|0)!=1752589105)break s;r=i[f+104>>2],f=i[f+108>>2];_:{h:{if((r|0)!=(f|0))for(;;){B:{if(A=i[r>>2],!A||(n=X0(A,86628,97612),!n))break B;if(f=i[r+4>>2],!f)break h;i[f+4>>2]=i[f+4>>2]+1;break _}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=E(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97128,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=97696,!f)break u;break o}r=i[f+104>>2],f=i[f+108>>2];_:{h:{if((r|0)!=(f|0))for(;;){B:{if(A=i[r>>2],!A||(n=X0(A,86628,98188),!n))break B;if(f=i[r+4>>2],!f)break h;i[f+4>>2]=i[f+4>>2]+1;break _}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=E(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97168,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98064,!f)break u;break o}r=i[f+104>>2],f=i[f+108>>2];w:{_:{if((r|0)!=(f|0))for(;;){h:{if(A=i[r>>2],!A||(n=X0(A,86628,100220),!n))break h;if(f=i[r+4>>2],!f)break _;i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=E(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97208,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=100240,!f)break u;break o}if((A|0)<=1836280680){if((A|0)!=1781689137){if((A|0)!=1785750887)break s;r=i[f+104>>2],n=i[f+108>>2];w:{if((r|0)!=(n|0))for(;;){_:{if(A=i[r>>2],!A||(f=X0(A,86628,98612),!f))break _;if(n=i[r+4>>2],!n){n=0;break w}i[n+4>>2]=i[n+4>>2]+1;break w}if(r=r+8|0,(n|0)==(r|0))break}n=0,f=0}if(r=E(112),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97328,n&&(i[n+4>>2]=i[n+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=n,i[r+80>>2]=f,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98632,n){if(i[n+4>>2]=i[n+4>>2]+1,u[r+104|0]=0,u[r+88|0]=0,f=i[n+4>>2],i[n+4>>2]=f-1,f||(X[i[i[n>>2]+8>>2]](n),p(n)),i[k+36>>2]=r,i[k+32>>2]=A,A=i[n+4>>2],i[n+4>>2]=A-1,A)break t;X[i[i[n>>2]+8>>2]](n),p(n);break t}u[r+104|0]=0,u[r+88|0]=0;break u}r=i[f+104>>2],f=i[f+108>>2];w:{if((r|0)!=(f|0))for(;;){_:{if(A=i[r>>2],!A||(n=X0(A,86628,99524),!n))break _;if(f=i[r+4>>2],!f){f=0;break w}i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}f=0,n=0}if(r=E(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97248,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98952,f)break o;break u}if((A|0)!=1836280681){if((A|0)!=1987470129)break s;r=i[f+104>>2],f=i[f+108>>2];w:{if((r|0)!=(f|0))for(;;){_:{if(A=i[r>>2],!A||(n=X0(A,86628,99924),!n))break _;if(f=i[r+4>>2],!f){f=0;break w}i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}f=0,n=0}if(r=E(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97288,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=99728,!f)break l;break o}i[k+32>>2]=0,i[k+36>>2]=0;break t}i[k+32>>2]=0,i[k+36>>2]=0;break t}i[k+36>>2]=r,i[k+32>>2]=A;break t}if(i[f+4>>2]==-1&&(X[i[i[f>>2]+8>>2]](f),p(f)),i[k+36>>2]=r,i[k+32>>2]=A,A=i[f+4>>2],i[f+4>>2]=A-1,A)break t;X[i[i[f>>2]+8>>2]](f),p(f);break t}i[k+36>>2]=r,i[k+32>>2]=A}r=i[k+32>>2],A=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,f=i[e+556>>2],i[e+552>>2]=r,i[e+556>>2]=A;t:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break t;X[i[i[f>>2]+8>>2]](f),p(f)}r=i[k+36>>2];t:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break t;X[i[i[r>>2]+8>>2]](r),p(r)}if(!i[e+552>>2]){if(A=E(56),i[k+32>>2]=A,i[k+36>>2]=49,i[k+40>>2]=-2147483592,r=l[23627]|l[23628]<<8|(l[23629]<<16|l[23630]<<24),e=l[23623]|l[23624]<<8|(l[23625]<<16|l[23626]<<24),u[A|0]=e,u[A+1|0]=e>>>8,u[A+2|0]=e>>>16,u[A+3|0]=e>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+49|0]=0,u[A+48|0]=l[23671],r=l[23667]|l[23668]<<8|(l[23669]<<16|l[23670]<<24),e=l[23663]|l[23664]<<8|(l[23665]<<16|l[23666]<<24),u[A+40|0]=e,u[A+41|0]=e>>>8,u[A+42|0]=e>>>16,u[A+43|0]=e>>>24,u[A+44|0]=r,u[A+45|0]=r>>>8,u[A+46|0]=r>>>16,u[A+47|0]=r>>>24,r=l[23659]|l[23660]<<8|(l[23661]<<16|l[23662]<<24),e=l[23655]|l[23656]<<8|(l[23657]<<16|l[23658]<<24),u[A+32|0]=e,u[A+33|0]=e>>>8,u[A+34|0]=e>>>16,u[A+35|0]=e>>>24,u[A+36|0]=r,u[A+37|0]=r>>>8,u[A+38|0]=r>>>16,u[A+39|0]=r>>>24,r=l[23651]|l[23652]<<8|(l[23653]<<16|l[23654]<<24),e=l[23647]|l[23648]<<8|(l[23649]<<16|l[23650]<<24),u[A+24|0]=e,u[A+25|0]=e>>>8,u[A+26|0]=e>>>16,u[A+27|0]=e>>>24,u[A+28|0]=r,u[A+29|0]=r>>>8,u[A+30|0]=r>>>16,u[A+31|0]=r>>>24,r=l[23643]|l[23644]<<8|(l[23645]<<16|l[23646]<<24),e=l[23639]|l[23640]<<8|(l[23641]<<16|l[23642]<<24),u[A+16|0]=e,u[A+17|0]=e>>>8,u[A+18|0]=e>>>16,u[A+19|0]=e>>>24,u[A+20|0]=r,u[A+21|0]=r>>>8,u[A+22|0]=r>>>16,u[A+23|0]=r>>>24,r=l[23635]|l[23636]<<8|(l[23637]<<16|l[23638]<<24),e=l[23631]|l[23632]<<8|(l[23633]<<16|l[23634]<<24),u[A+8|0]=e,u[A+9|0]=e>>>8,u[A+10|0]=e>>>16,u[A+11|0]=e>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,K(B,4,3e3,k+32|0),u[k+43|0]>=0)break n;Z(i[k+32>>2]);break n}t:{if(l[e+540|0]!=1)break t;t=k+124|0,n=i[e+116>>2],s=v-16|0,v=s,r=i[23896],m=i[23897],o=!(r|m),A=i[_+16>>2],e=((A+i[_+8>>2]|0)-1>>>0)/(A>>>0)|0,A=i[_+12>>2],A=O0(e,0,((A+i[_+4>>2]|0)-1>>>0)/(A>>>0)|0,0),e=l0,f=l[_+26|0];u:{if(!f||(A=O0(A,e,i[_+28>>2],0),e=l0,f=f-1|0,!f)||(A=O0(A,e,i[_+32>>2],0),e=l0,(f|0)==1)||(A=O0(A,e,i[_+36>>2],0),e=l0,(f|0)==2)||(A=O0(A,e,i[_+40>>2],0),e=l0,(f|0)==3)||(A=O0(A,e,i[_+44>>2],0),e=l0,(f|0)==4)||(A=O0(A,e,i[_+48>>2],0),e=l0,(f|0)==5)||(A=O0(A,e,i[_+52>>2],0),e=l0,(f|0)==6))break u;A=O0(A,e,i[_+56>>2],0),e=l0}u:{if(!(o|((e|0)==(m|0)&A>>>0<=r>>>0|e>>>0<m>>>0))){if(A=E(40),i[s+4>>2]=A,i[s+8>>2]=39,i[s+12>>2]=-2147483608,r=l[23506]|l[23507]<<8|(l[23508]<<16|l[23509]<<24),e=l[23502]|l[23503]<<8|(l[23504]<<16|l[23505]<<24),u[A|0]=e,u[A+1|0]=e>>>8,u[A+2|0]=e>>>16,u[A+3|0]=e>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+39|0]=0,r=l[23537]|l[23538]<<8|(l[23539]<<16|l[23540]<<24),e=l[23533]|l[23534]<<8|(l[23535]<<16|l[23536]<<24),u[A+31|0]=e,u[A+32|0]=e>>>8,u[A+33|0]=e>>>16,u[A+34|0]=e>>>24,u[A+35|0]=r,u[A+36|0]=r>>>8,u[A+37|0]=r>>>16,u[A+38|0]=r>>>24,r=l[23530]|l[23531]<<8|(l[23532]<<16|l[23533]<<24),e=l[23526]|l[23527]<<8|(l[23528]<<16|l[23529]<<24),u[A+24|0]=e,u[A+25|0]=e>>>8,u[A+26|0]=e>>>16,u[A+27|0]=e>>>24,u[A+28|0]=r,u[A+29|0]=r>>>8,u[A+30|0]=r>>>16,u[A+31|0]=r>>>24,r=l[23522]|l[23523]<<8|(l[23524]<<16|l[23525]<<24),e=l[23518]|l[23519]<<8|(l[23520]<<16|l[23521]<<24),u[A+16|0]=e,u[A+17|0]=e>>>8,u[A+18|0]=e>>>16,u[A+19|0]=e>>>24,u[A+20|0]=r,u[A+21|0]=r>>>8,u[A+22|0]=r>>>16,u[A+23|0]=r>>>24,r=l[23514]|l[23515]<<8|(l[23516]<<16|l[23517]<<24),e=l[23510]|l[23511]<<8|(l[23512]<<16|l[23513]<<24),u[A+8|0]=e,u[A+9|0]=e>>>8,u[A+10|0]=e>>>16,u[A+11|0]=e>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,K(B,2,1e3,s+4|0),u[s+15|0]>=0)break u;Z(i[s+4>>2]);break u}b7(B,_,t,n,0,A,e)}if(v=s+16|0,i[B>>2])break n;if(u[B+19|0]>=0)break t;Z(i[B+8>>2])}k8(B,107712)}if(!C||(A=i[C+4>>2],i[C+4>>2]=A-1,A))break k;X[i[i[C>>2]+8>>2]](C),p(C)}if(!I||(A=i[I+4>>2],i[I+4>>2]=A-1,A))break i;X[i[i[I>>2]+8>>2]](I),p(I);break i}_2(),H()}G0(),H()}G0(),H()}if(f=f+8|0,(f|0)==(r|0))break}if(e=E(48),i[k+56>>2]=e,i[k+60>>2]=40,i[k+64>>2]=-2147483600,f=l[22359]|l[22360]<<8|(l[22361]<<16|l[22362]<<24),r=l[22355]|l[22356]<<8|(l[22357]<<16|l[22358]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[22391]|l[22392]<<8|(l[22393]<<16|l[22394]<<24),r=l[22387]|l[22388]<<8|(l[22389]<<16|l[22390]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[22383]|l[22384]<<8|(l[22385]<<16|l[22386]<<24),r=l[22379]|l[22380]<<8|(l[22381]<<16|l[22382]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[22375]|l[22376]<<8|(l[22377]<<16|l[22378]<<24),r=l[22371]|l[22372]<<8|(l[22373]<<16|l[22374]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[22367]|l[22368]<<8|(l[22369]<<16|l[22370]<<24),r=l[22363]|l[22364]<<8|(l[22365]<<16|l[22366]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,k+56|0),u[k+67|0]>=0)break i;Z(i[k+56>>2])}i:{if(!W||(A=i[W+4>>2],i[W+4>>2]=A-1,A))break i;X[i[i[W>>2]+8>>2]](W),p(W)}v=k+144|0}function y7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0;if(u[e|0]=0,r=i[A+3212>>2],f=i[A+3208>>2],(r|0)==(f|0))return 0;i:{e:{w=i[f>>2],k=i[w+428>>2],s=i[w+424>>2];r:{f:{if((k|0)==(s|0))break f;for(k=k-s>>2,t=k>>>0<=1?1:k;;){if(k=i[s+(h<<2)>>2],i[k+40>>2]){if(h=h+1|0,(t|0)!=(h|0))continue;break f}break}if(l[k+36|0]==1&&Tl(A+2140|0),u[e|0]=1,f=k,k=i[f+4>>2],r=i[k+1352>>2],(r|0)!=i[k+1356>>2])for(s=A+2140|0;r=Mo(s,i[(n<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),n=n+1|0,r=i[k+1352>>2],n>>>0<i[k+1356>>2]-r>>2>>>0;);o=i[w>>2],r=i[o+132>>2],i[f+40>>2]=1,k=l[r+46|0],s=l[r+45|0],r=i[o+112>>2],_=i[r+1884>>2];A:{if(k|(s|(_|0)<=0))break A;t=i[r+168>>2];k:{if((t|0)>0){for(h=r+88|0,n=0;;){if(i[h+(n<<2)>>2]==1e3)break A;if(n=n+1|0,(t|0)==(n|0))break}if((t|0)>19)break k}i[r+168>>2]=t+1,i[(r+(t<<2)|0)+88>>2]=1e3}if(t=i[r+84>>2],(t|0)==20){i[r+80>>2]=1001;break A}i[r+84>>2]=t+1,i[(r+4|0)+(t<<2)>>2]=1e3}r=i[w+424>>2],n=i[w+428>>2];A:{if((r|0)==(n|0)|(f|0)!=i[r>>2]||(t=i[i[f+4>>2]+24>>2],(t|0)<=0))break A;for(n=0;r=i[o+320>>2]+G(n,76)|0,i[r>>2]<=0&&(i[r>>2]=1),n=n+1|0,(t|0)!=(n|0););r=i[w+424>>2],n=i[w+428>>2]}o=n-r>>2;A:{if(o>>>0<2)break A;for(n=1;;){if(t=(n<<2)+r|0,(f|0)!=i[t>>2]){if(n=n+1|0,(o|0)!=(n|0))continue;break A}break}if(t=i[t-4>>2],!t|i[t+40>>2]!=2||(o=o-1|0,!o))break A;for(n=0;;){if(h=(n<<2)+r|0,(t|0)!=i[h>>2]){if(n=n+1|0,(o|0)!=(n|0))continue;break A}break}if(r=i[h+4>>2],!r||(n=i[i[t+4>>2]+24>>2],(n|0)>=i[i[r+4>>2]+24>>2]))break A;for(;;){if(t=i[w>>2],i[t+144>>2]<=(n|0))break A;if(t=i[t+320>>2]+G(n,76)|0,i[t>>2]<=0&&(i[t>>2]=1),n=n+1|0,!((n|0)<i[i[r+4>>2]+24>>2]))break}}n=0;A:{if(!(k|s&&(_|0)>0)){if(k=0,o=v-18608|0,v=o,s=i[f+4>>2],r=i[s+1352>>2],(r|0)!=i[s+1356>>2]){for(t=A+2140|0;r=Mo(t,i[(k<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),k=k+1|0,r=i[s+1352>>2],k>>>0<i[s+1356>>2]-r>>2>>>0;);s=i[f+4>>2]}if(k=6,r=i[i[w>>2]+132>>2],u0[s+24>>2]<i[r+8452>>2]-i[r+8448>>2]>>2>>>0){h=o+18572|0,i[h>>2]=0,i[h+4>>2]=0,i[o+18516>>2]=0,r=o+18508|0,i[r>>2]=0,i[r+4>>2]=0,i[o+18500>>2]=0,i[o+18504>>2]=0,r=(o+38&-16)+16|0,i[o+2104>>2]=r,o0(r,0,2048),k=i[f+4>>2],i[o+18592>>2]=k,r=i[w>>2],i[o+18600>>2]=f,i[o+18596>>2]=w,i[o+18584>>2]=A,i[o+18588>>2]=r,r=i[i[i[r+132>>2]+8448>>2]+(i[k+24>>2]<<2)>>2],i[o+18604>>2]=0,i[o+4>>2]=r,ke(o),r=i[f+12>>2];k:{if((r|0)<=0){k=17;break k}Ye(o+18548|0,i[f+8>>2],r);n:{if(!l[i[i[w>>2]+132>>2]+45|0]|!l[i[f+4>>2]+12|0])break n;if(r=i[i[i[A+2216>>2]+124>>2]+16900>>2]-1|0,k=i[w+472>>2],t=i[w+468>>2],s=k-t>>3,r>>>0>s>>>0){Yn(w+468|0,r-s|0);break n}if(r>>>0>=s>>>0)break n;if(r=t+(r<<3)|0,(r|0)!=(k|0))for(;k=P8(k-8|0),(r|0)!=(k|0););i[w+472>>2]=r}i[f+120>>2]=1,k=0,s=0,r=i[o+18588>>2],_=i[r+132>>2],r=i[r+124>>2],t=i[r+16908>>2],B=i[o+4>>2],(t|0)>(B|0)&&(t=i[i[_+8460>>2]+(B<<2)>>2]),r=i[r+16892>>2],i[o>>2]=t,B=(t|0)/(r|0)|0,i[o+12>>2]=B,i[o+8>>2]=t-G(r,B),B=i[o+18592>>2],r=18;n:{t:{if(!$f(o)||(Ze(o+18548|0),t=1,r=0,!(fr(o,0,!l[B+20|0])&1)))break n;B=o+18572|0;u:{if(l[_+46|0]){if(k=i[o+18592>>2],s=i[k+804>>2],s>>>0>2)break t;r=0;break u}r=1}for(;;){if(!r){ji(B,s,i[k+800>>2]),u[o+18580|0]=0,u[o+18581|0]=0,u[o+18582|0]=0,u[o+18583|0]=0,r=1;continue}for(;;){k=i[o+18592>>2],r=i[k+784>>2],s=i[k+788>>2]-r>>2,k=t-1|0;u:{if(s>>>0>k>>>0&&i[r+(k<<2)>>2]==((i[o+18552>>2]-i[o+18548>>2]|0)-2|0))break u;C2(i[o+18584>>2]+4|0,1003,1)}if(r=0,!(fr(o,0,0)&1))break n;if(t=t+1|0,!!l[_+46|0])break}if(k=i[o+18592>>2],s=i[k+804>>2],!(s>>>0<3))break}break t}M0(21701,18308,1520,5105),H()}k=r,i[f+44>>2]<=0&&(i[f+44>>2]=1)}P8(h)}if(v=o+18608|0,r=k,i[f+40>>2]=2,k=i[w+424>>2],s=(i[w+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(t=k+(n<<2)|0,(f|0)!=i[t>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[t+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[w>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+G(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}if(s&&(r=1006,k))break A;if(s){s=f;k:{if(t=i[w>>2],i[t+332>>2]==(0-i[t+328>>2]|0)){h=i[f+4>>2],_=i[h+776>>2],I=i[t+132>>2],r=i[t+124>>2],W=i[r+16892>>2];n:{if(!l[h+12|0])break n;if(r=i[r+16900>>2]-1|0,f=i[w+472>>2],o=i[w+468>>2],k=f-o>>3,r>>>0>k>>>0){Yn(w+468|0,r-k|0);break n}if(r>>>0>=k>>>0)break n;if(r=o+(r<<3)|0,(r|0)!=(f|0))for(;f=P8(f-8|0),(r|0)!=(f|0););i[w+472>>2]=r}if(i[s+132>>2])break e;k=_+1|0,o=E((P0=-1,d0=O0(k,0,18608,0)|4,n2=l0,n2?P0:d0)),i[o>>2]=k,r=o+4|0;n:{if(!k){i[s+136>>2]=k,i[s+132>>2]=r;break n}for(B=r+G(k,18608)|0,f=r;g=f+18572|0,i[g>>2]=0,i[g+4>>2]=0,i[f+18516>>2]=0,g=f+18508|0,i[g>>2]=0,i[g+4>>2]=0,i[f+18500>>2]=0,i[f+18504>>2]=0,i[f+18584>>2]=0,i[f+18588>>2]=0,g=f+18592|0,i[g>>2]=0,i[g+4>>2]=0,i[f+18600>>2]=0,g=(f+38&-15)+16|0,i[f+2104>>2]=g,o0(g,0,2048),f=f+18608|0,(B|0)!=(f|0););if(i[s+136>>2]=k,i[s+132>>2]=r,(_|0)<0)break n;if(f=i[h+24>>2],B=(f|0)/(W|0)|0,_){if(f-G(B,W)|0)break n;if((_|0)==2147483647)break i}if(i[o+18596>>2]=h,k=i[t+112>>2],i[o+18604>>2]=s,i[o+18600>>2]=w,i[o+18592>>2]=t,i[o+18588>>2]=k,i[o+8>>2]=i[i[I+8448>>2]+(f<<2)>>2],ke(r),g=s+12|0,f=g,_&&(f=i[h+784>>2]),f=i[f>>2],(f|0)>i[g>>2]||(k=1,(f|0)<=0)||(Ye(o+18552|0,i[s+8>>2],f),i[t+324>>2]=i[t+324>>2]+1,i[t+340>>2]=i[t+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,pt(A,r,1,B),!_))break n;for(;;){if(i[s+136>>2]<=(k|0))break i;if(r=i[s+132>>2]+G(k,18608)|0,i[r+18592>>2]=h,f=i[t+112>>2],i[r+18600>>2]=s,i[r+18596>>2]=w,i[r+18588>>2]=t,i[r+18584>>2]=f,B=B+1|0,i[r+4>>2]=i[i[I+8448>>2]+(G(W,B)<<2)>>2],ke(r),o=k<<2,m=i[h+784>>2],f=i[(o+m|0)-4>>2],(f|0)<0||(R=o+m|0,m=(k|0)!=(_|0),o=i[(m?R:g)>>2],(o|0)>i[g>>2]|(f|0)>=(o|0)))break n;if(Ye(r+18548|0,f+i[s+8>>2]|0,o-f|0),i[t+324>>2]=i[t+324>>2]+1,i[t+340>>2]=i[t+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,pt(A,r,0,B),k=k+1|0,!m)break}}if(v3(t),r=i[w+460>>2],k=i[w+456>>2],(r|0)!=(k|0))for(f=0;t=i[(f<<2)+k>>2],t&&(X[i[i[t>>2]+4>>2]](t),k=i[w+456>>2],r=i[w+460>>2]),f=f+1|0,f>>>0<r-k>>2>>>0;);i[w+460>>2]=k;break k}M0(22195,18166,1006,19411),H()}if(i[s+40>>2]=2,r=0,f=i[w+424>>2],k=(i[w+428>>2]-f>>2)-1|0,!k)break A;for(;;){if(t=f+(n<<2)|0,(s|0)!=i[t>>2]){if(n=n+1|0,(k|0)!=(n|0))continue;break A}break}if(f=i[t+4>>2],!f||(n=i[i[s+4>>2]+24>>2],(n|0)>=i[i[f+4>>2]+24>>2]))break A;for(;;){if(k=i[w>>2],i[k+144>>2]<=(n|0))break A;if(k=i[k+320>>2]+G(n,76)|0,i[k>>2]<=0&&(i[k>>2]=1),n=n+1|0,!((n|0)<i[i[f+4>>2]+24>>2]))break}break A}k:{if(!k)break k;t=0;n:{if(o=i[w>>2],i[o+332>>2]==(0-i[o+328>>2]|0)){if(i[f+132>>2])break e;h=i[o+132>>2],W=i[i[o+124>>2]+16892>>2],g=i[f+4>>2],B=i[g+776>>2],k=B+1|0,_=E((P0=-1,d0=O0(k,0,18608,0)|4,n2=l0,n2?P0:d0)),i[_>>2]=k,r=_+4|0;t:{if(!k){i[f+136>>2]=k,i[f+132>>2]=r;break t}for(I=r+G(k,18608)|0,s=r;m=s+18572|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18516>>2]=0,m=s+18508|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18500>>2]=0,i[s+18504>>2]=0,i[s+18584>>2]=0,i[s+18588>>2]=0,m=s+18592|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18600>>2]=0,m=(s+38&-15)+16|0,i[s+2104>>2]=m,o0(m,0,2048),s=s+18608|0,(I|0)!=(s|0););if(i[f+136>>2]=k,i[f+132>>2]=r,(B|0)<0)break t;if((B|0)==2147483647)break i;if(m=i[g+24>>2],k=m<<2,s=i[k+i[h+8484>>2]>>2],i[_+18596>>2]=g,I=i[o+112>>2],i[_+18604>>2]=f,i[_+18600>>2]=w,i[_+18592>>2]=o,i[_+18588>>2]=I,i[_+8>>2]=i[k+i[h+8448>>2]>>2],ke(r),I=f+12|0,k=I,B&&(k=i[g+784>>2]),V=i[k>>2],(V|0)>i[I>>2]){t=17;break t}if(k=1,(V|0)<=0){t=17;break t}if(Ye(_+18552|0,i[f+8>>2],V),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,R=r,r=(m|0)/(W|0)|0,Vt(A,R,1,m-G(r,W)|0,r),!B)break t;for(V=h+8404|0,y=h+8360|0;;){if(s=s+1|0,r=i[h+48>>2],(s|0)>=(G(r,i[h+52>>2])|0)){t=1007;break t}if(i[f+136>>2]<=(k|0))break i;if(t=(s|0)/(r|0)|0,_=i[V+(t<<2)>>2],t=i[y+(s-G(r,t)<<2)>>2],r=i[f+132>>2]+G(k,18608)|0,i[r+18592>>2]=g,m=i[o+112>>2],i[r+18600>>2]=f,i[r+18596>>2]=w,i[r+18588>>2]=o,i[r+18584>>2]=m,_=t+G(_,W)|0,i[r+4>>2]=i[i[h+8448>>2]+(_<<2)>>2],ke(r),m=k<<2,C=i[g+784>>2],t=i[(m+C|0)-4>>2],(t|0)<0){t=17;break t}if(m=i[((k|0)!=(B|0)?m+C|0:I)>>2],(m|0)>i[I>>2]){t=17;break t}if((t|0)>=(m|0)){t=17;break t}if(Ye(r+18548|0,t+i[f+8>>2]|0,m-t|0),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,t=0,R=r,r=(_|0)/(W|0)|0,Vt(A,R,0,_-G(r,W)|0,r),r=(k|0)!=(B|0),k=k+1|0,!r)break}}if(v3(o),r=i[w+460>>2],k=i[w+456>>2],(r|0)!=(k|0))for(s=0;o=i[(s<<2)+k>>2],o&&(X[i[i[o>>2]+4>>2]](o),k=i[w+456>>2],r=i[w+460>>2]),s=s+1|0,s>>>0<r-k>>2>>>0;);i[w+460>>2]=k,r=t;break n}M0(22195,18166,1120,5457),H()}if(i[f+40>>2]=2,k=i[w+424>>2],s=(i[w+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(t=k+(n<<2)|0,(f|0)!=i[t>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[t+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[w>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+G(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}M0(12200,18166,988,10067),H()}if(r)break r;f=i[A+3208>>2],r=i[A+3212>>2]}f:{if(r-f>>>0>=5&&(s=i[f>>2],k=i[s+428>>2],i[i[k-4>>2]+40>>2]|(k|0)==i[s+424>>2]))break f;if((r|0)==(f|0))return 0;if(s=i[f>>2],f=i[s+428>>2],(f|0)!=i[s+424>>2]&&(r=0,!i[i[f-4>>2]+40>>2])||(r=0,i[A+580>>2]!=((i[A+556>>2]?-1:0)|0)))break r;if(l[A+548|0])break f;if(!(u[A+549|0]&1))break r}if(u[e|0]=1,e=i[s>>2],i[e+144>>2]>0)for(h=0;r=i[e+320>>2]+G(h,76)|0,i[r>>2]<=0&&(i[r>>2]=1),h=h+1|0,(h|0)<i[e+144>>2];);w=i[s>>2],e=i[w+112>>2],r=l[e+532|0];f:{if(i[i[i[A+2216>>2]+112>>2]+1884>>2]){if(f=1,!(r&1)){f=0,k=i[s>>2],e=i[k+112>>2],r=i[i[k+124>>2]+16900>>2]<<1,i[k+324>>2]=r+i[k+324>>2],i[k+340>>2]=r+i[k+340>>2];A:{if(i[i[k+124>>2]+16900>>2]<=0)break A;_=e+1392|0;k:{n:{for(;;){t=E(20),u[t+16|0]=1,i[t+12>>2]=f,i[t+8>>2]=k,i[t>>2]=60668,i[t+4>>2]=0,e=i[s+460>>2],o=i[s+464>>2];t:{if(e>>>0<o>>>0){i[e>>2]=t,e=e+4|0;break t}if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>=1073741824)break n;if(o=o-n|0,h=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<h>>>0?h:r,o){if(o>>>0>=1073741824)break k;r=E(o<<2)}else r=0;if(h=r+e|0,i[h>>2]=t,B=h-(B<<2)|0,e&&z(B,n,e),i[s+464>>2]=r+(o<<2),e=h+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n)}if(i[s+460>>2]=e,Be(_,t),f=f+1|0,e=i[i[k+124>>2]+16900>>2],!((f|0)<(e|0)))break}if((e|0)<=0)break A;for(f=0;;){t=E(20),u[t+16|0]=0,i[t+12>>2]=f,i[t+8>>2]=k,i[t>>2]=60668,i[t+4>>2]=0,e=i[s+460>>2],o=i[s+464>>2];t:{if(e>>>0>=o>>>0){if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>1073741823)break n;if(o=o-n|0,h=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<h>>>0?h:r,o){if(o>>>0>1073741823)break k;r=E(o<<2)}else r=0;if(h=r+e|0,i[h>>2]=t,B=h-(B<<2)|0,e&&z(B,n,e),i[s+464>>2]=r+(o<<2),e=h+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n);break t}i[e>>2]=t,e=e+4|0}if(i[s+460>>2]=e,Be(_,t),f=f+1|0,!((f|0)<i[i[k+124>>2]+16900>>2]))break}break A}G0(),H()}x0(),H()}f=3,e=i[w+112>>2]}if(!l[e+533|0])A:{k=f,_=v-16|0,v=_;k:{n:{n=i[s>>2],t=i[n+124>>2];t:{if(!l[t+8799|0])break t;if(o=i[n+20>>2],h=i[n+28>>2],B=i[n+24>>2],e=i[n+112>>2],i[_+8>>2]=t,r=i[n+128>>2],i[_+12>>2]=r,f=e,r&&(i[r+4>>2]=i[r+4>>2]+1,f=i[n+112>>2]),r=i[n+288>>2],W=i[n+280>>2],g=i[n+284>>2],I=i[_+12>>2],i[_>>2]=i[_+8>>2],i[_+4>>2]=I,I=s+8|0,k9(I,B,h,o,_,0,f,W,g,r,1)){C2(i[n+112>>2]+4|0,1024,0);break t}if(g=i[t+16900>>2],r=g,i[n+324>>2]=r+i[n+324>>2],i[n+340>>2]=r+i[n+340>>2],(r|0)>0)for(m=e+1392|0,t=0;;){o=E(28),i[o+20>>2]=I,i[o+16>>2]=n,i[o>>2]=62856,i[o+4>>2]=0,i[o+12>>2]=n,i[o+24>>2]=k,i[o+8>>2]=t,e=i[s+460>>2],f=i[s+464>>2];u:{if(e>>>0<f>>>0){i[e>>2]=o,f=e+4|0;break u}if(h=i[s+456>>2],e=e-h|0,W=e>>2,r=W+1|0,r>>>0>=1073741824)break n;if(f=f-h|0,B=f>>1,f=f>>>0>=2147483644?1073741823:r>>>0<B>>>0?B:r,f){if(f>>>0>=1073741824)break k;r=E(f<<2)}else r=0;if(B=r+e|0,i[B>>2]=o,W=B-(W<<2)|0,e&&z(W,h,e),i[s+464>>2]=r+(f<<2),f=B+4|0,i[s+460>>2]=f,i[s+456>>2]=W,!h)break u;Z(h)}if(i[s+460>>2]=f,Be(m,o),t=t+1|0,(g|0)==(t|0))break}v3(n),e=i[n+4>>2],i[n+4>>2]=i[s+12>>2],i[s+12>>2]=e,e=i[n+64>>2],i[n+64>>2]=i[s+72>>2],i[s+72>>2]=e,e=i[n+292>>2],i[n+292>>2]=i[s+300>>2],i[s+300>>2]=e,e=i[n+8>>2],i[n+8>>2]=i[s+16>>2],i[s+16>>2]=e,e=i[n+68>>2],i[n+68>>2]=i[s+76>>2],i[s+76>>2]=e,e=i[n+296>>2],i[n+296>>2]=i[s+304>>2],i[s+304>>2]=e,e=i[n+12>>2],i[n+12>>2]=i[s+20>>2],i[s+20>>2]=e,e=i[n+72>>2],i[n+72>>2]=i[s+80>>2],i[s+80>>2]=e,e=i[n+300>>2],i[n+300>>2]=i[s+308>>2],i[s+308>>2]=e,e=i[n+40>>2],i[n+40>>2]=i[s+48>>2],i[s+48>>2]=e,e=i[n+44>>2],i[n+44>>2]=i[s+52>>2],i[s+52>>2]=e,e=i[n+304>>2],r=i[n+308>>2],f=i[s+316>>2],i[n+304>>2]=i[s+312>>2],i[n+308>>2]=f,i[s+312>>2]=e,i[s+316>>2]=r}v=_+16|0;break A}G0(),H()}x0(),H()}v3(w);break f}if(!(r&1)){f=0,r=0;A:{if(i[i[w+124>>2]+16900>>2]<=0)break A;for(;r=u9(w,f)|r,f=f+1|0,(f|0)<i[i[w+124>>2]+16900>>2];);if(!(r&1))break A;Qf(w,1,0,i[w+276>>2],i[w+272>>2]),e=i[w+272>>2],r=i[w+276>>2];k:{if(i[i[w+124>>2]+16832>>2]>=9){vf(w,1,0,r,e);break k}mf(w,1,0,r,e)}f=i[w+124>>2];k:{if(!i[f+16848>>2])break k;if(e=i[w+272>>2],r=i[w+276>>2],i[f+16840>>2]>=9){Xf(w,1,0,r,e);break k}gf(w,1,0,r,e)}Qf(w,0,0,i[w+276>>2],i[w+272>>2]),e=i[w+272>>2],r=i[w+276>>2];k:{if(i[i[w+124>>2]+16832>>2]>=9){vf(w,0,0,r,e);break k}mf(w,0,0,r,e)}if(f=i[w+124>>2],!i[f+16848>>2])break A;if(e=i[w+272>>2],r=i[w+276>>2],i[f+16840>>2]>=9){Xf(w,0,0,r,e);break A}gf(w,0,0,r,e)}e=i[w+112>>2]}if(l[e+533|0])break f;if(e=i[w+124>>2],l[e+8799|0]){for(r=G(G(i[w+28>>2],i[w+40>>2]),(i[e+16832>>2]+7|0)/8|0),f=G(G(i[w+36>>2],i[w+44>>2]),(i[e+16840>>2]+7|0)/8|0),k=E((r|0)>(f|0)?r:f),g=i[e+16848>>2]?3:1,I=w+4|0,f=i[e+16900>>2],n=0;;){_=I+(n<<2)|0,m=w+(n?44:40)|0,o=i[m>>2],r=G(G(o,i[w+(n?36:28)>>2]),(i[i[w+124>>2]+(n?16840:16832)>>2]+7|0)/8|0),r&&z(k,i[_>>2],r);A:{k:{if((f|0)<=0||(r=0,t=i[e+16892>>2],(t|0)<=0))break k;for(;;){n:{if((t|0)<=0)break n;if(f=0,!n)for(;;){if(h=F[((i[w+140>>2]+G(f,24)|0)+G(G(i[w+152>>2],r),24)|0)+2>>1],t=i[w+52>>2],h>>>0>=i[w+56>>2]-t>>2>>>0||(t=i[t+(h<<2)>>2],!t))break A;t:{if(!l[t+333|0])break t;if(t=1<<i[e+16876>>2],h=i[w+40>>2],B=i[w+4>>2],i[i[w+124>>2]+16832>>2]<=8){qi(w,f,r,0,t,t,k,o,B,h);break t}Li(w,f,r,0,t,t,k,o,B,h)}if(f=f+1|0,t=i[e+16892>>2],!((f|0)<(t|0)))break n}for(;;){if(h=F[((i[w+140>>2]+G(f,24)|0)+G(G(i[w+152>>2],r),24)|0)+2>>1],t=i[w+52>>2],h>>>0>=i[w+56>>2]-t>>2>>>0||(t=i[t+(h<<2)>>2],!t))break A;t:{if(!l[t+334|0])break t;if(h=1<<i[e+16876>>2],t=(h|0)/i[e+16856>>2]|0,h=(h|0)/i[e+16852>>2]|0,B=i[m>>2],W=i[_>>2],i[i[w+124>>2]+16840>>2]>=9){Li(w,f,r,n,h,t,k,o,W,B);break t}qi(w,f,r,n,h,t,k,o,W,B)}if(f=f+1|0,t=i[e+16892>>2],!((f|0)<(t|0)))break}}if(r=r+1|0,f=i[e+16900>>2],!((r|0)<(f|0)))break}}if(n=n+1|0,(g|0)!=(n|0))continue}break}Z(k)}}r=i[s+436>>2];f:{if((r|0)==i[s+440>>2]){r=0;break f}for(h=0;;){e=0,t=0,n=v-176|0,v=n,o=G(h,80)+r|0,B=i[s>>2];A:{if(i[o>>2]!=132|l[i[B+112>>2]+512|0]!=1|!l[B+104|0])break A;for(S=o+27|0,O=o+26|0,L=o+25|0,a=o+24|0,$=o+23|0,f0=o+22|0,A0=o+21|0,n0=o+20|0,h0=o+19|0,m0=o+18|0,W0=o+17|0,Q0=o+16|0,V0=o+15|0,e0=o+14|0,r0=o+13|0,N0=o+12|0,U0=o+60|0,D0=o+68|0,H0=B+4|0,L0=i[i[B+124>>2]+476>>2];;){g=i[B+(t?44:40)>>2],_=i[B+(t?36:28)>>2],w=i[B+(t?32:24)>>2],V=t<<2,I=i[V+H0>>2];k:{n:switch(i[o+8>>2]){case 0:r=i[i[B+124>>2]+(t?16840:16832)>>2],i[n+40>>2]=-1732584194,i[n+44>>2]=271733878,i[n+32>>2]=1732584193,i[n+36>>2]=-271733879,i[n+24>>2]=0,i[n+28>>2]=0;t:{if((_|0)>0){if((r|0)>=9){r=w<<1;u:{if((w|0)<=0){for(f=0;f||(f=E(r)),xA(n+24|0,f,r),e=e+1|0,(_|0)!=(e|0););break u}for(y=w&2147483646,C=w&1,W=0,f=0;;){if(f||(f=E(r)),m=I+(G(W,g)<<1)|0,e=0,k=0,(w|0)!=1)for(;V=e<<1,N=V+f|0,D=m+V|0,u[N|0]=l[D|0],u[N+1|0]=l[D+1|0],V=V|2,N=V+f|0,V=m+V|0,u[N|0]=l[V|0],u[N+1|0]=l[V+1|0],e=e+2|0,k=k+2|0,(y|0)!=(k|0););if(C&&(e=e<<1,k=e+f|0,e=e+m|0,u[k|0]=l[e|0],u[k+1|0]=l[e+1|0]),xA(n+24|0,f,r),W=W+1|0,(_|0)==(W|0))break}}_t(n,n+24|0),Z(f);break t}for(;xA(n+24|0,I+G(e,g)|0,w),e=e+1|0,(_|0)!=(e|0););}_t(n,n+24|0)}e=t<<4;t:{if(l[n|0]!=l[e+N0|0]|l[n+1|0]!=l[e+r0|0]|(l[n+2|0]!=l[e+e0|0]|l[n+3|0]!=l[e+V0|0])||l[n+4|0]!=l[e+Q0|0]|l[n+5|0]!=l[e+W0|0]|(l[n+6|0]!=l[e+m0|0]|l[n+7|0]!=l[e+h0|0])||l[n+8|0]!=l[e+n0|0]|l[n+9|0]!=l[e+A0|0]|(l[n+10|0]!=l[e+f0|0]|l[n+11|0]!=l[e+$|0])||l[n+12|0]!=l[e+a|0]|l[n+13|0]!=l[e+L|0]|l[n+14|0]!=l[e+O|0])break t;if(l[n+15|0]==l[e+S|0])break k}e=5;break A;case 1:e=7439;t:{if((_|0)<=0)break t;if(i[i[B+124>>2]+(t?16840:16832)>>2]>=9){if(W=w<<1,(w|0)<=0){for(e=0,r=0;r||(r=E(W)),e=e+1|0,(_|0)!=(e|0););e=7439,Z(r);break t}for(N=w&2147483646,D=w&1,V=(W|0)<=1?1:W,q0=V&2147483646,$0=V&1,m=0,f=0;;){if(f||(f=E(W)),k=I+(G(m,g)<<1)|0,r=0,y=0,(w|0)!=1)for(;C=r<<1,R=C+f|0,x=k+C|0,u[R|0]=l[x|0],u[R+1|0]=l[x+1|0],C=C|2,R=C+f|0,C=k+C|0,u[R|0]=l[C|0],u[R+1|0]=l[C+1|0],r=r+2|0,y=y+2|0,(N|0)!=(y|0););if(D&&(r=r<<1,y=r+f|0,r=r+k|0,u[y|0]=l[r|0],u[y+1|0]=l[r+1|0]),r=0,(V|0)!=1)for(y=f+1|0,k=0;R=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,C=(R|e)^e<<5,e=l[r+y|0]^((C^e<<12)&65280)>>>8,e=e>>>4^e,e=(C<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(q0|0)!=(k|0););if($0&&(k=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),m=m+1|0,(_|0)==(m|0))break}Z(f);break t}if((w|0)<=0)break t;for(m=w&2147483646,V=w&1,W=0;;){f=I+G(W,g)|0;u:{if((w|0)==1){r=0;break u}for(y=f+1|0,r=0,k=0;R=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,C=(R|e)^e<<5,e=l[r+y|0]^((C^e<<12)&65280)>>>8,e=e>>>4^e,e=(C<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(m|0)!=(k|0););}if(V&&(k=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),W=W+1|0,(_|0)==(W|0))break}}if(F[(t<<1)+U0>>1]==(e&65535))break k;e=5;break A;case 2:break n;default:break k}e=(w|0)>0&(_|0)>0;n:{if(i[i[B+124>>2]+(t?16840:16832)>>2]>=9){if(!e){r=0;break n}for(y=w&2147483646,C=w&1,r=0,f=0;;){if(W=I+G(f,g)|0,e=0,k=0,(w|0)!=1)for(;N=(e^f)>>>8^f,D=e|1,m=(N^D)&255,R=r,r=(e^N)&255,r=(m+((R+r|0)+(r^l[e+W|0])|0)|0)+(m^l[W+D|0])|0,e=e+2|0,k=k+2|0,(y|0)!=(k|0););if(C&&(k=r,r=((e^f)>>>8^f^e)&255,r=(k+r|0)+(r^l[e+W|0])|0),f=f+1|0,(_|0)==(f|0))break}break n}if(!e){r=0;break n}for(m=w&2147483646,y=w&1,r=0,f=0;;){if(W=I+G(f,g)|0,e=0,k=0,(w|0)!=1)for(;C=(e^f)>>>8^f,N=e|1,r=((C^N)&255^l[W+N|0])+((l[e+W|0]^(e^C)&255)+r|0)|0,e=e+2|0,k=k+2|0,(m|0)!=(k|0););if(y&&(r=(l[e+W|0]^((e^f)>>>8^f^e)&255)+r|0),f=f+1|0,(_|0)==(f|0))break}}if(i[V+D0>>2]==(r|0))break k;e=5;break A}if(e=0,!L0)break A;if(r=t>>>0<2,t=t+1|0,!r)break}}if(v=n+176|0,r=e,r)break f;if(h=h+1|0,r=i[s+436>>2],!(h>>>0<(i[s+440>>2]-r|0)/80>>>0))break}r=0}if(t=i[s>>2],t){if(!(l[t+104|0]!=1|(u[A+514|0]&1?l[t+312|0]:0)))f:{if(k=A+2140|0,e=i[k+24>>2],w=i[k+28>>2],e>>>0<w>>>0){i[e>>2]=t,i[k+24>>2]=e+4;break f}A:{if(n=i[k+20>>2],e=e-n|0,_=e>>2,f=_+1|0,f>>>0<1073741824){if(w=w-n|0,o=w>>1,w=w>>>0>=2147483644?1073741823:f>>>0<o>>>0?o:f,w){if(w>>>0>=1073741824)break A;f=E(w<<2)}else f=0;o=f+e|0,i[o>>2]=t,_=o-(_<<2)|0,e&&z(_,n,e),i[k+28>>2]=f+(w<<2),e=o+4|0,i[k+24>>2]=e,i[k+20>>2]=_,n&&Z(n),i[k+24>>2]=e;break f}G0(),H()}x0(),H()}e=i[t+116>>2],e?e=i[(e+G(i[e+8>>2],12)|0)+480>>2]:e=0,(e|0)<i[A+2164>>2]-i[A+2160>>2]>>2&&Kn(A+2140|0)}Z(Sn(s)),f=i[A+3212>>2],e=i[A+3208>>2],k=f-e|0;f:{if(k>>>0<5||(k=k-4|0,!k))break f;z(e,e+4|0,k)}i[A+3212>>2]=f-4}return r}M0(19467,18166,172,4396),H()}M0(4421,10882,174,3115),H()}function r6(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;h=v-160|0,v=h,N=il(),ko(N,o),_=i[e>>2],w=i[_+112>>2],o=i[_+108>>2];i:{e:{if(!u1(_,6)||(o8(i[e>>2],6)|0)==(o|0)&&(l8(i[e>>2],6)|0)==(w|0))break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(!(f-4>>>0>4294967292|r)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(u[h+158|0]=1,Q[h+156>>1]=2,i[h+148>>2]=8,i[h+152>>2]=131074,o=i[e>>2],i[h+136>>2]=i[o+116>>2],i[h+140>>2]=i[o+120>>2],u1(o,6)?o=1:(o=i[i[e>>2]+120>>2],o=43008>>>o&o>>>0<16),u[h+144|0]=o,S4(i[e>>2])&&(w=i[e>>2],o=F[w+6>>1]|F[w+8>>1]<<16,w=F[w+10>>1]|F[w+12>>1]<<16,u[h+158|0]=w>>>16,Q[h+156>>1]=w,i[h+152>>2]=o),Sl(h+152|0),o=i[e>>2],y=h+124|0,w=y,i[w+4>>2]=0,i[w+8>>2]=0,V=w+4|0,i[w>>2]=V,w=i[o+124>>2],C=o+128|0,(w|0)!=(C|0))for(;;){I=i[w+16>>2],W=V,o=W,_=i[o>>2];e:{r:{if(!_)break r;for(;;){if(o=_,_=i[o+16>>2],(_|0)>(I|0)){if(W=o,_=i[o>>2],_)continue;break r}if((_|0)>=(I|0))break e;if(_=i[o+4>>2],!_)break}W=o+4|0}_=E(20),i[_+8>>2]=o,i[_>>2]=0,i[_+4>>2]=0,i[_+16>>2]=I,i[W>>2]=_,o=i[i[y>>2]>>2],o&&(i[y>>2]=o),m1(i[y+4>>2],_),i[y+8>>2]=i[y+8>>2]+1}_=i[w+4>>2];e:{if(_){for(;;)if(o=_,_=i[o>>2],!_)break e}for(;o=i[w+8>>2],_=i[o>>2]!=(w|0),w=o,!!_;);}if(w=o,(C|0)==(o|0))break}f0=h,A0=j0(i[e>>2],i[i[h+124>>2]+16>>2]),i[f0+148>>2]=A0,o=i[h+156>>2],i[h+112>>2]=i[h+152>>2],i[h+116>>2]=o,o=i[h+148>>2],i[h+104>>2]=i[h+144>>2],i[h+108>>2]=o,o=i[h+140>>2],i[h+96>>2]=i[h+136>>2],i[h+100>>2]=o,i[h+100>>2]=f,i[h+96>>2]=r,r=l[k+3|0]|l[k+4|0]<<8|(l[k+5|0]<<16|l[k+6|0]<<24),u[h+115|0]=r,u[h+116|0]=r>>>8,u[h+117|0]=r>>>16,u[h+118|0]=r>>>24,i[h+112>>2]=F[k>>1]|F[k+2>>1]<<16,F[h+116>>1]==2&&(Q[h+116>>1]=F[h+156>>1]),F[h+112>>1]==2&&(Q[h+112>>1]=F[h+152>>1]),F[h+114>>1]==2&&(Q[h+114>>1]=F[h+154>>1]),r=1;e:{r:switch(f|0){case 10:case 12:case 14:r=3;break e;case 11:case 13:case 15:r=4;break e;case 0:case 1:case 2:case 3:case 99:break e;default:break r}r=0}e:{if((r|0)>=2){u[h+104|0]=43008>>>f&f>>>0<16;break e}if(i[N+4>>2]){u[h+104|0]=0;break e}u[h+104|0]=l[h+144|0]}if(n&&(i[h+108>>2]=n),(f&-2)!=10?r=i[h+108>>2]<9:(i[h+108>>2]=8,r=1),!r|(f&-4)!=12||(i[h+108>>2]=10),i[h+52>>2]=0,i[h+44>>2]=0,i[h+48>>2]=0,m=h+136|0,g=h+96|0,B=v+-64|0,v=B,f=i[h+48>>2],k=i[h+44>>2],(f|0)!=(k|0))for(;;){n=i[f-52>>2];e:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break e;X[i[i[n>>2]+8>>2]](n),p(n)}if(f=f-56|0,(k|0)==(f|0))break}i[h+48>>2]=k,r=i[t+12>>2],i[h+64>>2]=i[t+8>>2],i[h+68>>2]=r,r=i[t+4>>2],i[h+56>>2]=i[t>>2],i[h+60>>2]=r,r=i[N+20>>2],i[h+88>>2]=i[N+16>>2],i[h+92>>2]=r,r=i[N+12>>2],i[h+80>>2]=i[N+8>>2],i[h+84>>2]=r,r=i[N+4>>2],i[h+72>>2]=i[N>>2],i[h+76>>2]=r,r=i[m>>2];e:{if(!((r|0)!=i[g>>2]|i[m+4>>2]!=i[g+4>>2]|(l[m+8|0]!=l[g+8|0]|i[m+12>>2]!=i[g+12>>2]))&&(w=1,r||G3(m+16|0,g+16|0)))break e;_f(),i[B+60>>2]=0,i[B+52>>2]=0,i[B+56>>2]=0,i[B+48>>2]=0,i[B+40>>2]=0,i[B+44>>2]=0,i[B>>2]=-1,i[B+24>>2]=0,i[B+36>>2]=0;r:{f:{A:{w=i[B+44>>2],r=i[B+48>>2];k:{if(w>>>0<r>>>0){o=i[B+36>>2],r=i[B>>2],i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=r,u[w+34|0]=1,Q[w+32>>1]=2,i[w+24>>2]=8,i[w+28>>2]=131074,u[w+20|0]=0,i[w+12>>2]=99,i[w+16>>2]=99,r=i[m+12>>2],i[w+20>>2]=i[m+8>>2],i[w+24>>2]=r,n=i[m+16>>2],k=i[m+20>>2],f=i[m>>2],r=i[m+4>>2],i[w+36>>2]=o,i[w+28>>2]=n,i[w+32>>2]=k,i[w+12>>2]=f,i[w+16>>2]=r,r=w+40|0;break k}if(f=w,w=i[B+40>>2],o=f-w|0,k=((o|0)/40|0)+1|0,k>>>0>=107374183)break A;if(f=(r-w|0)/40|0,r=f<<1,n=f>>>0>=53687091?107374182:r>>>0>k>>>0?r:k,n){if(n>>>0>=107374183)break f;r=E(G(n,40))}else r=0;if(k=i[B+36>>2],f=i[B>>2],_=r+o|0,i[_+4>>2]=0,i[_+8>>2]=0,i[_>>2]=f,f=i[m+4>>2],i[_+12>>2]=i[m>>2],i[_+16>>2]=f,f=i[m+12>>2],i[_+20>>2]=i[m+8>>2],i[_+24>>2]=f,f=i[m+20>>2],i[_+28>>2]=i[m+16>>2],i[_+32>>2]=f,i[_+36>>2]=k,f=_+G((o|0)/-40|0,40)|0,o&&z(f,w,o),i[B+48>>2]=r+G(n,40),r=_+40|0,i[B+44>>2]=r,i[B+40>>2]=f,!w)break k;Z(w)}i[B+44>>2]=r;break r}G0(),H()}x0(),H()}f=i[B+44>>2],k=i[B+40>>2],w=0;r:{if((f|0)==(k|0))break r;for(a=g+16|0;;){f=f-k|0;f:{if((f|0)<=0){W=-1;break f}r=(f>>>0)/40|0,r=r>>>0<=1?1:r,x=r&3,w=0;A:{if(f>>>0<160){r=2147483647,W=-1,f=0;break A}for(I=r&67108860,f=0,r=2147483647,W=-1,R=0;o=i[(G(f,40)+k|0)+36>>2],O=(o|0)<(r|0),C=f|1,n=i[(G(C,40)+k|0)+36>>2],r=O?o:r,L=(n|0)<(r|0),V=f|2,_=i[(G(V,40)+k|0)+36>>2],r=L?n:r,y=(_|0)<(r|0),o=f|3,n=i[(G(o,40)+k|0)+36>>2],r=y?_:r,_=(n|0)<(r|0),r=_?n:r,W=_?o:y?V:L?C:O?f:W,f=f+4|0,R=R+4|0,(I|0)!=(R|0););}if(!x)break f;for(;n=i[(G(f,40)+k|0)+36>>2],o=(n|0)<(r|0),r=o?n:r,W=o?f:W,f=f+1|0,w=w+1|0,(x|0)!=(w|0););}o=G(W,40),_=o+k|0;f:{if(f=i[B+56>>2],r=i[B+60>>2],f>>>0<r>>>0){i[f>>2]=i[_>>2],i[f+4>>2]=i[_+4>>2],r=i[_+8>>2],i[f+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[_+16>>2],i[f+12>>2]=i[_+12>>2],i[f+16>>2]=r,i[f+36>>2]=i[_+36>>2],r=i[_+32>>2],i[f+28>>2]=i[_+28>>2],i[f+32>>2]=r,r=i[_+24>>2],i[f+20>>2]=i[_+20>>2],i[f+24>>2]=r,i[B+56>>2]=f+40;break f}A:{if(k=i[B+52>>2],w=f-k|0,n=((w|0)/40|0)+1|0,n>>>0<107374183){if(f=(r-k|0)/40|0,r=f<<1,r=f>>>0>=53687091?107374182:r>>>0>n>>>0?r:n,r>>>0>=107374183)break A;n=G(r,40),f=E(n),W=f+w|0,i[W>>2]=i[_>>2],i[W+4>>2]=i[_+4>>2],r=i[_+8>>2],i[W+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1,k=i[B+52>>2],w=i[B+56>>2]-k|0),r=i[_+16>>2],i[W+12>>2]=i[_+12>>2],i[W+16>>2]=r,i[W+36>>2]=i[_+36>>2],r=i[_+32>>2],i[W+28>>2]=i[_+28>>2],i[W+32>>2]=r,r=i[_+24>>2],i[W+20>>2]=i[_+20>>2],i[W+24>>2]=r,_=W+G((w|0)/-40|0,40)|0,w&&z(_,k,w),i[B+60>>2]=f+n,r=W+40|0,i[B+56>>2]=r,i[B+52>>2]=_,k&&Z(k),i[B+56>>2]=r;break f}G0(),H()}x0(),H()}o=o+i[B+40>>2]|0,k=i[B+44>>2],i[o>>2]=i[k-40>>2],r=i[k-36>>2],f=i[k-32>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[o+4>>2]=r,n=i[o+8>>2],i[o+8>>2]=f;f:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;X[i[i[n>>2]+8>>2]](n),p(n)}f=k-28|0,r=i[f+4>>2],i[o+12>>2]=i[f>>2],i[o+16>>2]=r,i[o+36>>2]=i[f+24>>2],r=i[f+20>>2],i[o+28>>2]=i[f+16>>2],i[o+32>>2]=r,r=i[f+12>>2],i[o+20>>2]=i[f+8>>2],i[o+24>>2]=r,f=i[B+44>>2],k=i[f-32>>2];f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;X[i[i[k>>2]+8>>2]](k),p(k)}i[B+44>>2]=f-40;f:{if(r=i[B+56>>2],f=i[r-28>>2],(f|0)!=i[g>>2]|i[r-24>>2]!=i[g+4>>2]|(l[r-20|0]!=l[g+8|0]|i[r-16>>2]!=i[g+12>>2]))break f;if(!f){if(!G3(r-12|0,a))break f;r=i[B+56>>2]}k=i[B+52>>2],r=((r-k|0)/40|0)-1|0;A:{k:{if(r){for(f=0;n=f,f=f+1|0,r=i[k+G(r,40)>>2],!!r;);if(t=i[h+48>>2],r=t,w=i[h+44>>2],k=(r-w|0)/56|0,n>>>0<k>>>0)break k;n:{if(w=f-k|0,n=i[h+52>>2],w>>>0<=(n-r|0)/56>>>0){if(w){for(r=G(w,56)+r|0;i[t+48>>2]=0,i[t+52>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t>>2]=0,i[t+4>>2]=0,i[t+32>>2]=99,i[t+36>>2]=99,i[t+8>>2]=99,i[t+12>>2]=99,u[t+54|0]=1,Q[t+52>>1]=2,Q[t+48>>1]=2,Q[t+50>>1]=2,i[t+44>>2]=8,u[t+30|0]=1,Q[t+28>>1]=2,Q[t+24>>1]=2,Q[t+26>>1]=2,i[t+20>>2]=8,t=t+56|0,(r|0)!=(t|0););t=r}i[h+48>>2]=t;break n}t:{if(k=i[h+44>>2],r=t-k|0,o=w+((r|0)/56|0)|0,o>>>0<76695845){if(n=(n-k|0)/56|0,k=n<<1,_=n>>>0>=38347922?76695844:k>>>0>o>>>0?k:o,_){if(_>>>0>=76695845)break t;k=E(G(_,56))}else k=0;for(n=k+r|0,o=n+G(w,56)|0,r=n;i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r+32>>2]=99,i[r+36>>2]=99,i[r+8>>2]=99,i[r+12>>2]=99,u[r+54|0]=1,Q[r+52>>1]=2,Q[r+48>>1]=2,Q[r+50>>1]=2,i[r+44>>2]=8,u[r+30|0]=1,Q[r+28>>1]=2,Q[r+24>>1]=2,Q[r+26>>1]=2,i[r+20>>2]=8,r=r+56|0,(o|0)!=(r|0););w=i[h+44>>2],t=t-w|0,r=n+G((t|0)/-56|0,56)|0,t&&z(r,w,t),i[h+52>>2]=k+G(_,56),i[h+48>>2]=o,i[h+44>>2]=r,w&&Z(w);break n}G0(),H()}x0(),H()}break A}r=i[h+48>>2],w=i[h+44>>2],k=(r-w|0)/56|0,f=0}if(f>>>0>=k>>>0)break A;if(n=G(f,56)+w|0,(n|0)!=(r|0))for(;;){t=i[r-52>>2];k:{if(!t||(k=i[t+4>>2],i[t+4>>2]=k-1,k))break k;X[i[i[t>>2]+8>>2]](t),p(t)}if(r=r-56|0,(n|0)==(r|0))break}i[h+48>>2]=n}if(r=i[h+44>>2],k=i[B+52>>2],t=((i[B+56>>2]-k|0)/40|0)-1|0,t){n=f-1|0,o=G(n,56)+r|0,k=k+G(t,40)|0,r=i[k+4>>2],k=i[k+8>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[o>>2]=r,w=i[o+4>>2],i[o+4>>2]=k;A:{if(!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break A;X[i[i[w>>2]+8>>2]](w),p(w)}if(k=i[h+44>>2]+G(n,56)|0,_=i[B+52>>2],n=_+G(t,40)|0,r=i[n+16>>2],i[k+32>>2]=i[n+12>>2],i[k+36>>2]=r,r=i[n+32>>2],i[k+48>>2]=i[n+28>>2],i[k+52>>2]=r,r=i[n+24>>2],i[k+40>>2]=i[n+20>>2],i[k+44>>2]=r,W=i[n>>2],W)for(r=1;;){o=G((r^-1)+f|0,56),w=o+i[h+44>>2]|0,t=G(W,40),n=t+_|0,k=i[n+4>>2],n=i[n+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[w>>2]=k,_=i[w+4>>2],i[w+4>>2]=n;A:{if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break A;X[i[i[_>>2]+8>>2]](_),p(_)}if(_=i[B+52>>2],w=t+_|0,k=i[w+16>>2],n=o+i[h+44>>2]|0,i[n+32>>2]=i[w+12>>2],i[n+36>>2]=k,k=i[w+32>>2],i[n+48>>2]=i[w+28>>2],i[n+52>>2]=k,k=i[w+24>>2],i[n+40>>2]=i[w+20>>2],i[n+44>>2]=k,k=i[h+44>>2],n=k+G(f-r|0,56)|0,t=k+o|0,k=i[t+36>>2],i[n+8>>2]=i[t+32>>2],i[n+12>>2]=k,k=i[t+52>>2],i[n+24>>2]=i[t+48>>2],i[n+28>>2]=k,k=i[t+44>>2],i[n+16>>2]=i[t+40>>2],i[n+20>>2]=k,r=r+1|0,W=i[w>>2],!W)break}r=i[h+44>>2]}f=i[m+4>>2],i[r+8>>2]=i[m>>2],i[r+12>>2]=f,f=i[m+20>>2],i[r+24>>2]=i[m+16>>2],i[r+28>>2]=f,f=i[m+12>>2],i[r+16>>2]=i[m+8>>2],i[r+20>>2]=f,k=i[B+40>>2],w=1;break r}if(w=i[26982],$=i[26983],(w|0)!=($|0))for(;;){if(r=i[w>>2],X[i[i[r>>2]+8>>2]](B+24|0,r,i[B+56>>2]-28|0,g,t,N),f=i[B+24>>2],x=i[B+28>>2],(f|0)!=(x|0)){f:{A:{for(;;){k:{W=i[B+56>>2],_=i[W-4>>2],o=i[f+24>>2],r=i[B+52>>2];n:{if((W|0)!=(r|0))for(n=f+16|0;;){if(k=i[r+12>>2],!((k|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]|(l[r+20|0]!=l[f+8|0]|i[r+24>>2]!=i[f+12>>2]))&&(k||G3(r+28|0,n)))break n;if(r=r+40|0,(W|0)==(r|0))break}if(r=i[B+40>>2],k=i[B+44>>2],(r|0)!=(k|0)){for(S=o+_|0,o=f+16|0;;){t:{if(n=i[r+12>>2],(n|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]|(l[r+20|0]!=l[f+8|0]|i[r+24>>2]!=i[f+12>>2])||!n&&!G3(r+28|0,o))break t;if((S|0)>=i[r+36>>2])break n;O=((i[B+56>>2]-i[B+52>>2]|0)/40|0)-1|0,k=i[w>>2],D=i[w+4>>2],D&&(i[D+4>>2]=i[D+4>>2]+1),L=l[f+8|0],y=i[f+4>>2],I=i[f>>2],u[B+2|0]=l[f+11|0],Q[B>>1]=l[f+9|0]|l[f+10|0]<<8,R=i[r+8>>2],C=l[f+23|0],V=l[f+22|0],W=F[f+20>>1],_=F[f+18>>1],o=F[f+16>>1],n=i[f+12>>2],i[r+8>>2]=D,i[r+4>>2]=k,i[r>>2]=O;u:{if(!R||(k=i[R+4>>2],i[R+4>>2]=k-1,k))break u;X[i[i[R>>2]+8>>2]](R),p(R)}u[r+20|0]=L,i[r+16>>2]=y,i[r+12>>2]=I,k=F[B>>1],u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=l[B+2|0],u[r+35|0]=C,u[r+34|0]=V,Q[r+32>>1]=W,Q[r+30>>1]=_,Q[r+28>>1]=o,i[r+24>>2]=n,i[r+36>>2]=S;break n}if(r=r+40|0,(k|0)==(r|0))break}k=i[B+44>>2]}r=i[f+20>>2],i[B+16>>2]=i[f+16>>2],i[B+20>>2]=r,r=i[f+12>>2],i[B+8>>2]=i[f+8>>2],i[B+12>>2]=r,r=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=r,r=i[B+56>>2],W=((r-i[B+52>>2]|0)/40|0)-1|0,_=i[r-4>>2]+i[f+24>>2]|0,r=i[B+48>>2];t:{if(r>>>0>k>>>0){u[k+34|0]=1,Q[k+32>>1]=2,i[k+24>>2]=8,i[k+28>>2]=131074,u[k+20|0]=0,i[k+12>>2]=99,i[k+16>>2]=99,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=W,r=i[w>>2],n=i[w+4>>2];u:{if(!n){i[k+8>>2]=0,i[k+4>>2]=r;break u}if(i[n+4>>2]=i[n+4>>2]+1,i[k+4>>2]=r,o=i[k+8>>2],i[k+8>>2]=n,!o||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break u;X[i[i[o>>2]+8>>2]](o),p(o)}r=i[B+4>>2],i[k+12>>2]=i[B>>2],i[k+16>>2]=r,r=i[B+20>>2],i[k+28>>2]=i[B+16>>2],i[k+32>>2]=r,r=i[B+12>>2],i[k+20>>2]=i[B+8>>2],i[k+24>>2]=r,i[k+36>>2]=_,r=k+40|0;break t}if(C=i[B+40>>2],k=k-C|0,o=((k|0)/40|0)+1|0,o>>>0>=107374183)break k;if(n=(r-C|0)/40|0,r=n<<1,V=n>>>0>=53687091?107374182:r>>>0>o>>>0?r:o,V){if(V>>>0>=107374183)break A;r=E(G(V,40))}else r=0;if(I=r+k|0,i[I>>2]=W,n=i[w>>2],o=i[w+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1,k=i[B+44>>2]-C|0),i[I+8>>2]=o,i[I+4>>2]=n,n=i[B+20>>2],i[I+28>>2]=i[B+16>>2],i[I+32>>2]=n,n=i[B+12>>2],i[I+20>>2]=i[B+8>>2],i[I+24>>2]=n,n=i[B+4>>2],i[I+12>>2]=i[B>>2],i[I+16>>2]=n,i[I+36>>2]=_,n=I+G((k|0)/-40|0,40)|0,k&&z(n,C,k),i[B+48>>2]=r+G(V,40),r=I+40|0,i[B+44>>2]=r,i[B+40>>2]=n,!C)break t;Z(C)}i[B+44>>2]=r}if(f=f+28|0,(x|0)!=(f|0))continue;break f}break}G0(),H()}x0(),H()}f=i[B+24>>2]}if(f&&(i[B+28>>2]=f,Z(f)),w=w+8|0,($|0)==(w|0))break}if(f=i[B+44>>2],k=i[B+40>>2],(f|0)==(k|0))break}w=0}if(k){if(r=k,f=i[B+44>>2],(r|0)!=(f|0)){for(;;){n=i[f-32>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;X[i[i[n>>2]+8>>2]](n),p(n)}if(f=f-40|0,(k|0)==(f|0))break}r=i[B+40>>2]}i[B+44>>2]=k,Z(r)}if(k=i[B+52>>2],!k)break e;if(r=k,f=i[B+56>>2],(r|0)!=(f|0)){for(;;){n=i[f-32>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;X[i[i[n>>2]+8>>2]](n),p(n)}if(f=f-40|0,(k|0)==(f|0))break}r=i[B+52>>2]}i[B+56>>2]=k,Z(r)}v=B- -64|0;e:{if(!w){u[h+12|0]=0,u[h+23|0]=0,f=K(h+24|0,4,3003,h+12|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[h+23|0]>=0)break e;Z(i[h+12>>2]);break e}if(i[h+44>>2]==i[h+48>>2]){r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break e}n=A,m=v-112|0,v=m,A=i[e>>2],r=i[e+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+2);r:{f:{if(e=h+44|0,_=i[e>>2],$=i[e+4>>2],(_|0)==($|0)){e=A;break f}for(D=n+8|0,x=e+28|0,O=e+12|0,f=i[25484],L=i[25485],g=m+8|0,e=A;;){k=i[_>>2],i[m+60>>2]=r,i[m+56>>2]=A,r&&(i[r+4>>2]=i[r+4>>2]+1),X[i[i[k>>2]+12>>2]](m+80|0,k,m+56|0,_+8|0,_+32|0,O,x,s),t=i[m+60>>2];A:{if(!t||(k=i[t+4>>2],i[t+4>>2]=k-1,k))break A;X[i[i[t>>2]+8>>2]](t),p(t)}A:{k:{n:{t:{u:{if(a=l[m+100|0],a){if((a|0)!=1)break u;k=i[m+84>>2],i[n>>2]=i[m+80>>2],i[n+4>>2]=k;o:{if(u[m+99|0]>=0){k=i[m+92>>2],i[D>>2]=i[m+88>>2],i[D+4>>2]=k,i[D+8>>2]=i[m+96>>2];break o}T(D,i[m+88>>2],i[m+92>>2])}u[n+20|0]=1;break A}k=i[m+84>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),e=i[m+80>>2];o:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break o;X[i[i[r>>2]+8>>2]](r),p(r)}X[i[i[e>>2]+8>>2]](e,_+48|0),X[i[i[e>>2]+12>>2]](e,A+16|0),X[i[i[e>>2]+16>>2]](e,l[A+4|0]),F[A+32>>1]|F[A+34>>1]&&(i[m+56>>2]=i[A+32>>2],X[i[i[e>>2]+24>>2]](e,m+56|0)),l[A+60|0]==1&&(t=i[A+56>>2],i[m+72>>2]=i[A+52>>2],i[m+76>>2]=t,t=i[A+48>>2],o=m- -64|0,i[o>>2]=i[A+44>>2],i[o+4>>2]=t,t=i[A+40>>2],i[m+56>>2]=i[A+36>>2],i[m+60>>2]=t,X[i[i[e>>2]+28>>2]](e,m+56|0)),o=i[A+24>>2],t=i[A+28>>2],(o|0)!=(t|0)&&X[i[i[e>>2]+20>>2]](e,o,t);o:{if(l[A+80|0]!=1)break o;l:{if(u[A+79|0]>=0){i[m+48>>2]=i[A+76>>2],t=i[A+72>>2],i[m+40>>2]=i[A+68>>2],i[m+44>>2]=t;break l}T(m+40|0,i[A+68>>2],i[A+72>>2])}if(X[i[i[e>>2]+36>>2]](e,m+40|0),u[m+51|0]>=0)break o;Z(i[m+40>>2])}t=i[A+64>>2];o:{if(!t||(X[i[i[e>>2]+32>>2]](m+20|0,e,t),u[m+39|0]>=0))break o;Z(i[m+28>>2])}if(i[e+144>>2]=i[A+144>>2],w=i[A+148>>2],y=i[A+152>>2],(w|0)==(y|0))break k;for(;;){A=i[w+4>>2],i[m>>2]=i[w>>2],i[m+4>>2]=A;o:{if(u[w+19|0]>=0){A=i[w+12>>2],i[g>>2]=i[w+8>>2],i[g+4>>2]=A,i[g+8>>2]=i[w+16>>2];break o}T(g,i[w+8>>2],i[w+12>>2])}o=i[e+152>>2],t=i[e+156>>2];o:{if(o>>>0<t>>>0){A=i[m+4>>2],i[o>>2]=i[m>>2],i[o+4>>2]=A,i[o+16>>2]=i[g+8>>2],A=i[g+4>>2],i[o+8>>2]=i[g>>2],i[o+12>>2]=A,i[g>>2]=0,i[g+4>>2]=0,i[g+8>>2]=0,R=o+20|0;break o}if(A=i[e+148>>2],o=o-A|0,W=((o|0)/20|0)+1|0,W>>>0>=214748365)break t;if(t=(t-A|0)/20|0,A=t<<1,A=t>>>0>=107374182?214748364:A>>>0>W>>>0?A:W,A>>>0>=214748365)break n;if(I=G(A,20),C=E(I),t=C+o|0,A=i[m+4>>2],i[t>>2]=i[m>>2],i[t+4>>2]=A,i[t+16>>2]=i[g+8>>2],A=i[g+4>>2],i[t+8>>2]=i[g>>2],i[t+12>>2]=A,i[g>>2]=0,i[g+4>>2]=0,i[g+8>>2]=0,R=t+20|0,o=i[e+148>>2],A=o,S=i[e+152>>2],V=t+G((S-o|0)/-20|0,20)|0,W=V,(o|0)!=(S|0)){for(;t=i[A+4>>2],i[W>>2]=i[A>>2],i[W+4>>2]=t,i[W+16>>2]=i[A+16>>2],t=i[A+12>>2],i[W+8>>2]=i[A+8>>2],i[W+12>>2]=t,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,W=W+20|0,A=A+20|0,(S|0)!=(A|0););for(;u[o+19|0]<0&&Z(i[o+8>>2]),o=o+20|0,(S|0)!=(o|0););o=i[e+148>>2]}if(i[e+152>>2]=R,i[e+148>>2]=V,i[e+156>>2]=I+C,!o)break o;Z(o)}if(i[e+152>>2]=R,u[m+19|0]<0&&Z(i[m+8>>2]),w=w+20|0,(y|0)==(w|0))break}break k}_2(),H()}G0(),H()}x0(),H()}k&&(i[k+4>>2]=i[k+4>>2]+1);k:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break k;X[i[i[r>>2]+8>>2]](r),p(r)}r=k,A=e}if(k=l[m+100|0],(k|0)!=255&&(i[m+56>>2]=f,i[m+60>>2]=L,X[i[(m+56|0)+(k<<2)>>2]](m+111|0,m+80|0)),!a){if(_=_+56|0,($|0)==(_|0))break f;continue}break}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break r;X[i[i[r>>2]+8>>2]](r),p(r);break r}u[n+20|0]=0,i[n+4>>2]=r,i[n>>2]=e}r:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break r;X[i[i[r>>2]+8>>2]](r),p(r)}v=m+112|0}if(r=i[h+44>>2],r){if(e=i[h+48>>2],A=r,(e|0)!=(r|0)){for(;;){f=i[e-52>>2];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(e=e-56|0,(r|0)==(e|0))break}A=i[h+44>>2]}i[h+48>>2]=r,Z(A)}Vi(h+124|0,i[h+128>>2])}N&&z2(N),v=h+160|0}function Y7(A,e,r,f,k,n,t,o,s,w,h,_){var B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0,b1=0,G4=0,W4=0,X4=0,j4=0,O4=0,L4=0,c8=0,b8=0;x1=v-16|0,v=x1,R=x1+4|0,D=v-80|0,v=D;i:{e:{if(m=i[r+168>>2],L=k>>m,(L|0)<0||(C=i[r+172>>2],(C|0)<=(L|0)))break e;if(a=n>>m,(a|0)<0|(a|0)>=i[r+176>>2])break i;m=n+o|0,y=k+t|0,N=l[f+10|0];r:{f:{A:switch((l[((i[r+160>>2]+G(L,3)|0)+G(G(C,a),3)|0)+1|0]&3)-1|0){case 0:if(!(N&16))break f;break;case 1:break A;default:break f}i[D+12>>2]=r,i[D+8>>2]=63480,B=D+8|0,f=m,L=w,a=h,C=_,n0=N>>>5|0,g=D+16|0,N=v-16|0,v=N,V=i[i[r+132>>2]+8236>>2],(s|0)!=8|i[i[r+132>>2]+8236>>2]<3||(a=8,C=0,L=8,y=k,f=n),O=f+a|0,x=O-1|0,m=X[i[i[B>>2]>>2]](B,k,n)|0;A:{f0=n0+1|0,$=y>>V,A0=y-1|0,N0=($|0)!=A0>>V;k:{if(!N0&&(_=0,f>>V==x>>V)||!((C|0)!=1|m>>>0>7)&&(_=0,1<<m&196)||(_=0,!W8(r,k,n,s,y,f,L,a,C,A0,x)))break k;_=X[i[i[B>>2]+4>>2]](B,A0,x)|0,B=F[_+4>>1]|F[_+6>>1]<<16,x=F[_>>1]|F[_+2>>1]<<16,Q[g>>1]=x,Q[g+2>>1]=x>>>16,Q[g+4>>1]=B,Q[g+6>>1]=B>>>16,_=F[_+8>>1]|F[_+10>>1]<<16,Q[g+8>>1]=_,Q[g+10>>1]=_>>>16,_=1}if((f0|0)<=(_|0))break A;k:{n:{t:{if(I=y+L|0,B=I-1|0,x=f-1|0,!(!(1<<m&50)||(C|0)!=1|m>>>0>5)|($|0)==B>>V&f>>V==x>>V||!W8(r,k,n,s,y,f,L,a,C,B,x))break t;if(W=i[r+188>>2],m=B>>W,(m|0)<0||(B=i[r+192>>2],(B|0)<=(m|0)))break e;if(W=x>>W,!((W|0)<0|(W|0)>=i[r+196>>2])){B=(i[r+180>>2]+G(m,12)|0)+G(G(B,W),12)|0;u:{if(!_||(m=l[g|0],(m|0)!=l[B|0])||m&&F[g+4>>1]!=F[B+4>>1]|F[g+6>>1]!=F[B+6>>1]|l[g+2|0]!=l[B+2|0]||(V0=l[g+1|0],(V0|0)!=l[B+1|0]))break u;if(W=0,Q0=1,m=_,!V0)break n;if(F[g+8>>1]!=F[B+8>>1]|F[g+10>>1]!=F[B+10>>1]|l[g+3|0]!=l[B+3|0])break u;m=_;break n}W=F[B+4>>1]|F[B+6>>1]<<16,m=g+G(_,12)|0,Q0=F[B>>1]|F[B+2>>1]<<16,Q[m>>1]=Q0,Q[m+2>>1]=Q0>>>16,Q[m+4>>1]=W,Q[m+6>>1]=W>>>16,W=F[B+8>>1]|F[B+10>>1]<<16,Q[m+8>>1]=W,Q[m+10>>1]=W>>>16,Q0=1,W=_,m=_+1|0;break n}break k}m=_}n:{if(f0>>>0<=m>>>0)break n;t:{if(($|0)==I>>V&f>>V==x>>V||!W8(r,k,n,s,y,f,L,a,C,I,x))break t;if(B=I,I=i[r+188>>2],B=B>>I,(B|0)<0||($=i[r+192>>2],($|0)<=(B|0)))break e;if(I=x>>I,(I|0)<0|(I|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+G(B,12)|0)+G(G(I,$),12)|0;u:{if(!Q0||(I=g+G(W,12)|0,$=l[I|0],($|0)!=l[B|0])||$&&F[I+4>>1]!=F[B+4>>1]|F[I+6>>1]!=F[B+6>>1]|l[I+2|0]!=l[B+2|0]||($=l[I+1|0],($|0)!=l[B+1|0]))break u;if(!$)break t;if(F[I+8>>1]!=F[B+8>>1]|F[I+10>>1]!=F[B+10>>1])break u;if(l[I+3|0]==l[B+3|0])break t}$=F[B+4>>1]|F[B+6>>1]<<16,I=g+G(m,12)|0,V0=F[B>>1]|F[B+2>>1]<<16,Q[I>>1]=V0,Q[I+2>>1]=V0>>>16,Q[I+4>>1]=$,Q[I+6>>1]=$>>>16,B=F[B+8>>1]|F[B+10>>1]<<16,Q[I+8>>1]=B,Q[I+10>>1]=B>>>16,m=m+1|0}if(m>>>0>=f0>>>0)break n;t:{u:{if(!N0&&(B=f>>V,(B|0)==O>>V))break u;o:{if(!W8(r,k,n,s,y,f,L,a,C,A0,O))break o;if(I=i[r+188>>2],B=A0>>I,(B|0)<0||($=i[r+192>>2],($|0)<=(B|0)))break e;if(I=O>>I,(I|0)<0|(I|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+G(B,12)|0)+G(G(I,$),12)|0;l:{if(!_||(I=l[g|0],(I|0)!=l[B|0])||I&&F[g+4>>1]!=F[B+4>>1]|F[g+6>>1]!=F[B+6>>1]|l[g+2|0]!=l[B+2|0]||(I=l[g+1|0],(I|0)!=l[B+1|0]))break l;if(!I)break o;if(F[g+8>>1]!=F[B+8>>1]|F[g+10>>1]!=F[B+10>>1])break l;if(l[g+3|0]==l[B+3|0])break o}O=F[B+4>>1]|F[B+6>>1]<<16,I=g+G(m,12)|0,$=F[B>>1]|F[B+2>>1]<<16,Q[I>>1]=$,Q[I+2>>1]=$>>>16,Q[I+4>>1]=O,Q[I+6>>1]=O>>>16,B=F[B+8>>1]|F[B+10>>1]<<16,Q[I+8>>1]=B,Q[I+10>>1]=B>>>16,m=m+1|0}if((m|0)==4|m>>>0>=f0>>>0)break n;if(N0)break t;B=f>>V}if(x>>V==(B|0))break n}if(!W8(r,k,n,s,y,f,L,a,C,A0,x))break n;if(V=i[r+188>>2],C=A0>>V,(C|0)<0||(B=i[r+192>>2],(B|0)<=(C|0)))break e;if(V=x>>V,(V|0)<0|(V|0)>=i[r+196>>2])break k;if(C=(i[r+180>>2]+G(C,12)|0)+G(G(B,V),12)|0,Q0&&uo(g+G(W,12)|0,C)||_&&uo(g,C))break n;W=F[C+4>>1]|F[C+6>>1]<<16,_=g+G(m,12)|0,V=F[C>>1]|F[C+2>>1]<<16,Q[_>>1]=V,Q[_+2>>1]=V>>>16,Q[_+4>>1]=W,Q[_+6>>1]=W>>>16,C=F[C+8>>1]|F[C+10>>1]<<16,Q[_+8>>1]=C,Q[_+10>>1]=C>>>16,m=m+1|0}_=m;break A}break i}i[N+12>>2]=_;A:{if((_|0)>(n0|0)||(Ur(A,r,e,y,f,L,a,0,0,N+4|0,N+2|0),u[N+3|0]=0,m=l[N+2|0],i[e+28>>2]||(Ur(A,r,e,y,f,L,a,0,1,N+8|0,N+3|0),D0=l[N+3|0],m=m|D0),!(m&255)))break A;i[N+12>>2]=_+1,f=g+G(_,12)|0,_=i[N+4>>2],Q[f+4>>1]=_,Q[f+6>>1]=_>>>16,_=i[N+8>>2],Q[f+8>>1]=_,Q[f+10>>1]=_>>>16,_=l[N+2|0],Q[f+2>>1]=0,u[f+1|0]=D0,u[f|0]=_}if(_=i[e+28>>2],!_){y=0;A:{if(L=i[N+12>>2],(L|0)<2|(L|0)>=(f0|0))break A;V=e+988|0,B=e+924|0,x=G(L,L-1|0);k:{for(;;){if(f=y<<2,_=i[f+63376>>2],(_|0)>=(L|0)||(m=i[f+63424>>2],(m|0)>=(L|0)))break k;if(C=0,f=0,_=g+G(_,12)|0,l[_|0]&&(f=X[i[i[A>>2]+8>>2]](A,i[B+(u[_+2|0]<<2)>>2])|0),m=g+G(m,12)|0,l[m+1|0]&&(C=X[i[i[A>>2]+8>>2]](A,i[V+(u[m+3|0]<<2)>>2])|0),a=l[_|0],!(!a||f)||(W=l[m+1|0],!(!W||C))||(!(i[f+96>>2]!=i[C+96>>2]|F[_+4>>1]!=F[m+8>>1])&F[_+6>>1]==F[m+10>>1]|(!a|!W)||(f=g+G(i[N+12>>2],12)|0,u[f+2|0]=l[_+2|0],C=l[m+3|0],u[f+1|0]=W,u[f|0]=a,u[f+3|0]=C,_=F[_+4>>1]|F[_+6>>1]<<16,Q[f+4>>1]=_,Q[f+6>>1]=_>>>16,_=F[m+8>>1]|F[m+10>>1]<<16,Q[f+8>>1]=_,Q[f+10>>1]=_>>>16,i[N+12>>2]=i[N+12>>2]+1),y=y+1|0,(x|0)==(y|0)))break A;if((f0|0)==i[N+12>>2])break}break A}M0(12200,18236,1432,5247),H()}_=i[e+28>>2]}L=i[e+336>>2],(_|0)!=1&&(f=i[e+340>>2],L=(f|0)>(L|0)?L:f),a=i[N+12>>2];A:{if((n0|0)<(a|0))break A;if(f=f0-a|0,y=f&1,_=0,(a|0)!=(n0|0))for(C=f&-2,f=0;f0=i[e+28>>2],m=g+G(a,12)|0,W=(_|0)<(L|0)?_:0,u[m+2|0]=W,Q[m+4>>1]=0,Q[m+6>>1]=0,Q[m+8>>1]=0,Q[m+10>>1]=0,f0=(f0|0)!=1,u[m+1|0]=f0,u[m|0]=1,u[m+3|0]=f0?W:-1,f0=i[e+28>>2],W=_|1,W=(W|0)<(L|0)?W:0,u[m+14|0]=W,Q[m+16>>1]=0,Q[m+18>>1]=0,Q[m+20>>1]=0,Q[m+22>>1]=0,u[m+12|0]=1,f0=(f0|0)!=1,u[m+13|0]=f0,u[m+15|0]=f0?W:-1,_=_+2|0,a=a+2|0,f=f+2|0,(C|0)!=(f|0););if(!y)break A;m=i[e+28>>2],f=g+G(a,12)|0,_=(_|0)<(L|0)?_:0,u[f+2|0]=_,Q[f+4>>1]=0,Q[f+6>>1]=0,Q[f+8>>1]=0,Q[f+10>>1]=0,m=(m|0)!=1,u[f+1|0]=m,u[f|0]=1,u[f+3|0]=m?_:-1}if(v=N+16|0,f=g+G(n0,12)|0,_=F[f>>1]|F[f+2>>1]<<16,m=F[f+4>>1]|F[f+6>>1]<<16,Q[R>>1]=_,Q[R+2>>1]=_>>>16,Q[R+4>>1]=m,Q[R+6>>1]=m>>>16,f=F[f+8>>1]|F[f+10>>1]<<16,Q[R+8>>1]=f,Q[R+10>>1]=f>>>16,!(_&255)|!l[R+1|0]|(w+h|0)!=12)break r;u[R+1|0]=0,u[R+3|0]=255;break r}f:{A:{k:{n:switch((N&3)-1|0){case 0:case 2:if(N=u[f|0],u[R|0]=1,u[R+2|0]=N,u[f|0]<16)break k;f=R+2|0;break f;default:break n}u[R|0]=0,u[R+2|0]=255;break A}L=F[f+4>>1],a=F[f+2>>1],W=N,N=D+16|0,z7(A,e,r,k,n,s,y,m,w,h,0,W,_,N),N=N+(l[f+10|0]&4)|0,N=F[N>>1]|F[N+2>>1]<<16,Q[R+4>>1]=N+a,Q[R+6>>1]=L+(N>>>16|0)}if(!(l[f+10|0]&2)){u[R+1|0]=0,u[R+3|0]=255;break r}if(N=u[f+1|0],u[R+1|0]=1,u[R+3|0]=N,u[f+1|0]>15){f=R+3|0;break f}L=F[f+8>>1],a=F[f+6>>1],W=_,_=D+16|0,z7(A,e,r,k,n,s,y,m,w,h,1,N,W,_),f=_+(l[f+10|0]>>>1&4)|0,f=F[f>>1]|F[f+2>>1]<<16,Q[R+8>>1]=f+a,Q[R+10>>1]=L+(f>>>16|0);break r}u[f|0]=0,u[r+312|0]=3,C2(A+4|0,1012,0)}v=D+80|0,_=A,m=k,N=n,L=t,a=o,f=R,k=v-49152|0,v=k;r:{f:{if(n=e,T2=i[e+4>>2],I=i[T2+4>>2],x=i[I+16832>>2],A=i[r+124>>2],(x|0)==i[A+16832>>2]&&(B=i[I+16840>>2],(B|0)==i[A+16840>>2]))break f;u[r+312|0]=3,C2(_+4|0,1031,0);break r}if(i[I+476>>2]!=i[r+20>>2]){u[r+312|0]=3,C2(_+4|0,1030,0);break r}V=i[r+44>>2],d0=N+a|0,n2=i[I+16856>>2],Z2=m+L|0,g2=i[I+16852>>2],A=G(V,(d0|0)/(n2|0)|0)+((Z2|0)/(g2|0)|0)|0,e=A<<l[r+18|0],o=i[r+12>>2],A=A<<l[r+17|0],R=i[r+8>>2],Q0=i[r+40>>2],W=G(Q0,d0)+Z2<<l[r+16|0],g=i[r+4>>2],y=l[f+1|0],t=l[f|0];f:{if(l[T2+41|0]|!t|(!y|F[f+4>>1]!=F[f+8>>1])||F[f+6>>1]!=F[f+10>>1])break f;y=i[(n+(u[f+2|0]<<2)|0)+924>>2]!=i[(n+(u[f+3|0]<<2)|0)+988>>2]?y:0}for(C=k+40960|0,f0=k- -8192|0,$=e+o|0,N0=A+R|0,V0=g+W|0,c8=f+4|0,H2=_+4|0,b8=n+924|0,b1=f+2|0,D0=k+16384|0,o=k+32768|0,e=k,R=1,A=t;;){f:{if(!A)break f;if(A=u[e1+b1|0],(A|0)>=16){u[r+312|0]=3,C2(H2,1012,0);break r}if(n0=X[i[i[_>>2]+8>>2]](_,i[((e1<<6)+b8|0)+(A<<2)>>2])|0,!(i[n0+100>>2]&&n0)){u[r+312|0]=3,C2(H2,1012,0);break f}if(!(!(i[n0+24>>2]!=i[I+484>>2]|i[n0+28>>2]!=i[I+488>>2])&i[r+20>>2]==i[n0+20>>2])){u[r+312|0]=3,C2(H2,1029,0);break f}if(W=i[r+124>>2],g=i[W+16832>>2],A=i[n0+124>>2],!((g|0)==i[A+16832>>2]&i[W+16840>>2]==i[A+16840>>2])){u[r+312|0]=3,C2(H2,1028,0);break f}Q2=(e1<<2)+c8|0,A=Q[Q2+2>>1],W=Q[Q2>>1],A0=i[n0+40>>2],E2=i[n0+4>>2];A:{if((g|0)>=9){D=0,m0=v-20448|0,v=m0,e0=(A>>2)+d0|0,O=(W>>2)+Z2|0,H0=i[I+488>>2],W0=i[I+484>>2];k:{if(!((A|W)&3)){A=i[I+16832>>2];n:{if(!((O|e0)<0|(W0|0)<(w+O|0))&&(H0|0)>=(h+e0|0))break n;if((h|0)<=0|(w|0)<=0)break k;for(g=14-A|0,L0=H0-1|0,h0=W0-1|0,q0=w&2147483646,$0=w&1;;){if(A=D+e0|0,r0=(G((A|0)>=0?(A|0)<(H0|0)?A:L0:0,A0)<<1)+E2|0,U0=(G(s,D)<<1)+o|0,A=0,W=0,(w|0)!=1)for(;S=A+O|0,Q[U0+(A<<1)>>1]=F[r0+(((S|0)>=0?(S|0)<(W0|0)?S:h0:0)<<1)>>1]<<g,P0=A|1,S=P0+O|0,Q[U0+(P0<<1)>>1]=F[r0+(((S|0)>=0?(S|0)<(W0|0)?S:h0:0)<<1)>>1]<<g,A=A+2|0,W=W+2|0,(q0|0)!=(W|0););if($0&&(W=U0+(A<<1)|0,A=A+O|0,Q[W>>1]=F[r0+(((A|0)>=0?(A|0)<(W0|0)?A:h0:0)<<1)>>1]<<g),D=D+1|0,(D|0)==(h|0))break}break k}if(A=((G(A0,e0)<<1)+E2|0)+(O<<1)|0,(x|0)<=8){X[i[_+220>>2]](o,s,A,A0,w,h,m0+11360|0);break k}X[i[_+300>>2]](o,s,A,A0,w,h,m0+11360|0,x);break k}L0=A&3,A=L0<<2,g=i[A+63584>>2],r0=i[A+63568>>2],q0=W&3,W=q0<<2,A=i[W+63584>>2],h0=i[W+63568>>2];n:{if(!((e0|0)<(r0|0)|(h0|0)>(O|0)|((W0|0)<=(A+(w+O|0)|0)|(H0|0)<=(g+(h+e0|0)|0)))){A=((O<<1)+E2|0)+(G(A0,e0)<<1)|0;break n}D=0-r0|0,P0=h+g|0;t:{if((D|0)>=(P0|0)||(b2=A+w|0,W=0-h0|0,(b2|0)<=(W|0)))break t;for(G4=H0-1|0,W4=h0+1|0,X4=O+1|0,g=1-h0|0,W1=(A+h0|0)+w|0,J1=W1&1,A=O-h0|0,$0=W0-1|0,j4=((A|0)>=0?(A|0)<(W0|0)?A:$0:0)<<1;;){if(A=D+e0|0,U0=(G((A|0)>=0?(A|0)<(H0|0)?A:G4:0,A0)<<1)+E2|0,S=G(D+r0|0,80),A=W,J1&&(Q[m0+(S<<1)>>1]=F[U0+j4>>1],A=g),(W1|0)!=1)for(O4=S+h0|0,L4=S+W4|0;S=A+O|0,Q[m0+(A+O4<<1)>>1]=F[U0+(((S|0)>=0?(S|0)<(W0|0)?S:$0:0)<<1)>>1],S=A+X4|0,Q[m0+(A+L4<<1)>>1]=F[U0+(((S|0)>=0?(S|0)<(W0|0)?S:$0:0)<<1)>>1],A=A+2|0,(b2|0)!=(A|0););if(D=D+1|0,(P0|0)==(D|0))break}}A0=80,A=m0+(h0+G(r0,80)<<1)|0}if((x|0)<=8){X[i[((_+(q0<<4)|0)+(L0<<2)|0)+220>>2]](o,s,A,A0,w,h,m0+11360|0);break k}X[i[((_+(q0<<4)|0)+(L0<<2)|0)+300>>2]](o,s,A,A0,w,h,m0+11360|0,x)}v=m0+20448|0;break A}D=0,m0=v-14768|0,v=m0,e0=(A>>2)+d0|0,O=(W>>2)+Z2|0,H0=i[I+488>>2],W0=i[I+484>>2];k:{if(!((A|W)&3)){A=i[I+16832>>2];n:{if(!((O|e0)<0|(W0|0)<(w+O|0))&&(H0|0)>=(h+e0|0))break n;if((h|0)<=0|(w|0)<=0)break k;for(g=14-A|0,L0=H0-1|0,h0=W0-1|0,q0=w&2147483646,$0=w&1;;){if(A=D+e0|0,r0=G((A|0)>=0?(A|0)<(H0|0)?A:L0:0,A0)+E2|0,U0=(G(s,D)<<1)+o|0,A=0,W=0,(w|0)!=1)for(;S=A+O|0,Q[U0+(A<<1)>>1]=l[r0+((S|0)>=0?(S|0)<(W0|0)?S:h0:0)|0]<<g,P0=A|1,S=P0+O|0,Q[U0+(P0<<1)>>1]=l[r0+((S|0)>=0?(S|0)<(W0|0)?S:h0:0)|0]<<g,A=A+2|0,W=W+2|0,(q0|0)!=(W|0););if($0&&(W=U0+(A<<1)|0,A=A+O|0,Q[W>>1]=l[r0+((A|0)>=0?(A|0)<(W0|0)?A:h0:0)|0]<<g),D=D+1|0,(D|0)==(h|0))break}break k}if(A=O+(G(A0,e0)+E2|0)|0,(x|0)<=8){X[i[_+220>>2]](o,s,A,A0,w,h,m0+5680|0);break k}X[i[_+300>>2]](o,s,A,A0,w,h,m0+5680|0,x);break k}L0=A&3,A=L0<<2,g=i[A+63584>>2],r0=i[A+63568>>2],q0=W&3,W=q0<<2,A=i[W+63584>>2],h0=i[W+63568>>2];n:{if(!((e0|0)<(r0|0)|(h0|0)>(O|0)|((W0|0)<=(A+(w+O|0)|0)|(H0|0)<=(g+(h+e0|0)|0)))){A=(O+E2|0)+G(A0,e0)|0;break n}D=0-r0|0,P0=h+g|0;t:{if((D|0)>=(P0|0)||(b2=A+w|0,W=0-h0|0,(b2|0)<=(W|0)))break t;for(G4=H0-1|0,g=O-h0|0,$0=W0-1|0,W4=(g|0)>=0?(g|0)<(W0|0)?g:$0:0,X4=h0+1|0,W1=O+1|0,g=1-h0|0,J1=(A+h0|0)+w|0,j4=J1&1;;){if(A=D+e0|0,U0=G((A|0)>=0?(A|0)<(H0|0)?A:G4:0,A0)+E2|0,S=G(D+r0|0,80),A=W,j4&&(u[S+m0|0]=l[U0+W4|0],A=g),(J1|0)!=1)for(O4=S+h0|0,L4=S+X4|0;S=A+O|0,u[m0+(A+O4|0)|0]=l[U0+((S|0)>=0?(S|0)<(W0|0)?S:$0:0)|0],S=A+W1|0,u[m0+(A+L4|0)|0]=l[U0+((S|0)>=0?(S|0)<(W0|0)?S:$0:0)|0],A=A+2|0,(b2|0)!=(A|0););if(D=D+1|0,(P0|0)==(D|0))break}}A0=80,A=m0+(h0+G(r0,80)|0)|0}if((x|0)<=8){X[i[((_+(q0<<4)|0)+(L0<<2)|0)+220>>2]](o,s,A,A0,w,h,m0+5680|0);break k}X[i[((_+(q0<<4)|0)+(L0<<2)|0)+300>>2]](o,s,A,A0,w,h,m0+5680|0,x)}v=m0+14768|0}if(!i[r+20>>2])break f;if(A=(h|0)/(n2|0)|0,o=(w|0)/(g2|0)|0,W=(e1<<13)+D0|0,g=Q[Q2+2>>1],D=Q[Q2>>1],A0=i[n0+44>>2],O=i[n0+8>>2],i[i[r+124>>2]+16840>>2]>=9){x9(_,I,D,g,Z2,d0,e,s,O,A0,o,A,B),x9(_,I,Q[Q2>>1],Q[Q2+2>>1],Z2,d0,W,s,i[n0+12>>2],i[n0+44>>2],o,A,B);break f}O9(_,I,D,g,Z2,d0,e,s,O,A0,o,A,B),O9(_,I,Q[Q2>>1],Q[Q2+2>>1],Z2,d0,W,s,i[n0+12>>2],i[n0+44>>2],o,A,B)}if(e1=1,W=R,R=0,A=y,e=f0,o=C,!W)break}A=i[I+16840>>2],o=(A|0)>12?2:14-A|0,A=i[I+16832>>2],R=(A|0)>12?2:14-A|0,e=i[r+124>>2],A=l[e+16993|0],e=l[e+16992|0];f:switch(i[n+28>>2]){case 1:if(t=!y&(t|0)==1,!l[T2+41|0]){if(t){A:{if((x|0)<=8){X[i[_+176>>2]](V0,Q0,k+32768|0,s,w,h);break A}X[i[_+192>>2]](V0,Q0,k+32768|0,s,w,h,x)}if(!i[r+20>>2])break r;if(A=(h|0)/(n2|0)|0,e=(w|0)/(g2|0)|0,(B|0)<=8){X[i[_+176>>2]](N0,V,k,s,e,A),X[i[_+176>>2]]($,V,D0,s,e,A);break r}X[i[_+192>>2]](N0,V,k,s,e,A,B),X[i[_+192>>2]]($,V,D0,s,e,A,B);break r}C2(H2,1011,0),u[r+312|0]=3;break r}if(t){t=R+l[n+388|0]|0,y=u[b1|0],e=u[(y+n|0)+518|0]<<e,R=n+(y<<1)|0,f0=u[R+679|0],C=n+(y<<2)|0,y=Q[C+552>>1],W=u[R+678|0],C=Q[C+550>>1],R=Q[R+454>>1],g=l[n+389|0];A:{if((x|0)<=8){X[i[_+180>>2]](V0,Q0,k+32768|0,s,w,h,R,e,t);break A}X[i[_+196>>2]](V0,Q0,k+32768|0,s,w,h,R,e,t,x)}if(!i[r+20>>2])break r;if(e=(h|0)/(n2|0)|0,n=(w|0)/(g2|0)|0,t=o+g|0,o=W<<A,A=f0<<A,(B|0)<=8){X[i[_+180>>2]](N0,V,k,s,n,e,C,o,t),X[i[_+180>>2]]($,V,D0,s,n,e,y,A,t);break r}X[i[_+196>>2]](N0,V,k,s,n,e,C,o,t,B),X[i[_+196>>2]]($,V,D0,s,n,e,y,A,t,B);break r}C2(H2,1011,0),u[r+312|0]=3;break r;default:M0(20079,18236,528,5388),H();case 0:break f}if(!((t|0)!=1|(y|0)!=1)){if(!l[T2+42|0]){A=k+40960|0;f:{if((x|0)<=8){X[i[_+172>>2]](V0,Q0,k+32768|0,A,s,w,h);break f}X[i[_+188>>2]](V0,Q0,k+32768|0,A,s,w,h,x)}if(!i[r+20>>2])break r;if(A=(h|0)/(n2|0)|0,e=(w|0)/(g2|0)|0,n=k- -8192|0,t=k+24576|0,(B|0)<=8){X[i[_+172>>2]](N0,V,k,n,s,e,A),X[i[_+172>>2]]($,V,D0,t,s,e,A);break r}X[i[_+188>>2]](N0,V,k,n,s,e,A,B),X[i[_+188>>2]]($,V,D0,t,s,e,A,B);break r}if(t=u[f+3|0],y=n+(t<<1)|0,W=u[y+711|0],C=n+(t<<2)|0,g=Q[C+616>>1],D=u[y+710|0],I=Q[C+614>>1],C=u[f+2|0],f0=n+(C<<1)|0,A0=u[f0+679|0],n0=n+(C<<2)|0,O=Q[n0+552>>1],W0=u[f0+678|0],n0=Q[n0+550>>1],m0=l[n+389|0],_=_+172|0,rk(_,V0,Q0,k+32768|0,k+40960|0,s,w,h,Q[f0+454>>1],u[(n+C|0)+518|0]<<e,Q[y+486>>1],u[(n+t|0)+534|0]<<e,R+l[n+388|0]|0,x),!i[r+20>>2])break r;e=(w|0)/(g2|0)|0,n=(h|0)/(n2|0)|0,t=o+m0|0,rk(_,N0,V,k,k- -8192|0,s,e,n,n0,W0<<A,I,D<<A,t,B),rk(_,$,V,D0,k+24576|0,s,e,n,O,A0<<A,g,W<<A,t,B);break r}if(!((t|0)!=1&(y|0)!=1)){if(!l[T2+42|0]){A=(k+32768|0)+(t?0:8192)|0;f:{if((x|0)<=8){X[i[_+176>>2]](V0,Q0,A,s,w,h);break f}X[i[_+192>>2]](V0,Q0,A,s,w,h,x)}if(!i[r+20>>2])break r;if(n=t?D0:k+24576|0,t=k+(t?0:8192)|0,A=(h|0)/(n2|0)|0,e=(w|0)/(g2|0)|0,(B|0)<=8){X[i[_+176>>2]](N0,V,t,s,e,A),X[i[_+176>>2]]($,V,n,s,e,A);break r}X[i[_+192>>2]](N0,V,t,s,e,A,B),X[i[_+192>>2]]($,V,n,s,e,A,B);break r}y=!t,C=u[y+b1|0],e=u[(C+(n+(y<<4)|0)|0)+518|0]<<e,f0=(k+32768|0)+(t?0:8192)|0,W=(n+(y<<5)|0)+(C<<1)|0,g=u[W+679|0],C=(n+(y<<6)|0)+(C<<2)|0,y=Q[C+552>>1],D=u[W+678|0],C=Q[C+550>>1],W=Q[W+454>>1],R=R+l[n+388|0]|0,I=l[n+389|0];f:{if((x|0)<=8){X[i[_+180>>2]](V0,Q0,f0,s,w,h,W,e,R);break f}X[i[_+196>>2]](V0,Q0,f0,s,w,h,W,e,R,x)}if(!i[r+20>>2])break r;if(R=t?D0:k+24576|0,f0=k+(t?0:8192)|0,e=(h|0)/(n2|0)|0,n=(w|0)/(g2|0)|0,t=o+I|0,o=D<<A,A=g<<A,(B|0)<=8){X[i[_+180>>2]](N0,V,f0,s,n,e,C,o,t),X[i[_+180>>2]]($,V,R,s,n,e,y,A,t);break r}X[i[_+196>>2]](N0,V,f0,s,n,e,C,o,t,B),X[i[_+196>>2]]($,V,R,s,n,e,y,A,t,B);break r}C2(H2,1011,0),u[r+312|0]=3}v=k+49152|0,k=m+L|0,n=N+a|0,A=f,h=h>>2;r:{if((h|0)<=0||(e=w>>2,(e|0)<=0))break r;for(_=n>>2,n=k>>2,m=i[r+192>>2],w=w&4,y=e&2147483646,f=0,R=(e|0)==1;;){if(o=G(m,f+_|0),e=0,t=0,!R)for(;s=F[A+4>>1]|F[A+6>>1]<<16,a=G(o,12),L=G(e,12),N=G(n,12),k=a+(L+(N+i[r+180>>2]|0)|0)|0,C=F[A>>1]|F[A+2>>1]<<16,Q[k>>1]=C,Q[k+2>>1]=C>>>16,Q[k+4>>1]=s,Q[k+6>>1]=s>>>16,s=F[A+8>>1]|F[A+10>>1]<<16,Q[k+8>>1]=s,Q[k+10>>1]=s>>>16,k=a+(L+(N+i[r+180>>2]|0)|0)|0,s=F[A+8>>1]|F[A+10>>1]<<16,Q[k+20>>1]=s,Q[k+22>>1]=s>>>16,s=F[A+4>>1]|F[A+6>>1]<<16,N=F[A>>1]|F[A+2>>1]<<16,Q[k+12>>1]=N,Q[k+14>>1]=N>>>16,Q[k+16>>1]=s,Q[k+18>>1]=s>>>16,e=e+2|0,t=t+2|0,(y|0)!=(t|0););if(w&&(k=F[A+4>>1]|F[A+6>>1]<<16,e=((i[r+180>>2]+G(n,12)|0)+G(e,12)|0)+G(o,12)|0,t=F[A>>1]|F[A+2>>1]<<16,Q[e>>1]=t,Q[e+2>>1]=t>>>16,Q[e+4>>1]=k,Q[e+6>>1]=k>>>16,k=F[A+8>>1]|F[A+10>>1]<<16,Q[e+8>>1]=k,Q[e+10>>1]=k>>>16),f=f+1|0,(h|0)==(f|0))break}}v=x1+16|0;return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function _f(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(r=i[26982],n=i[26983],(r|0)==(n|0)){A=E(16),i[A+12>>2]=103996,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=101952,f=A+12|0,e=i[26984];r:{if(r>>>0<e>>>0){i[n+4>>2]=A,i[n>>2]=f,A=n+8|0;break r}if(e=e-r|0,n=e>>2,e=e>>>0>=2147483640?536870911:n>>>0<=1?1:n,e>>>0>=536870912)break e;if(e=e<<3,n=E(e),i[n+4>>2]=A,i[n>>2]=f,e=e+n|0,i[26984]=e,A=n+8|0,i[26983]=A,i[26982]=n,!r)break r;Z(r),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104140,i[r>>2]=102e3,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102080,i[r>>2]=102040,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102156,i[r>>2]=102116,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103888,i[r>>2]=102192,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103924,i[r>>2]=102232,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103960,i[r>>2]=102272,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104032,i[r>>2]=102312,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104068,i[r>>2]=102352,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104212,i[r>>2]=102392,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104248,i[r>>2]=102432,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104176,i[r>>2]=102472,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104104,i[r>>2]=102512,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103780,i[r>>2]=102552,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102632,i[r>>2]=102592,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102708,i[r>>2]=102668,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103744,i[r>>2]=102744,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103816,i[r>>2]=102784,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104356,i[r>>2]=102824,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102904,i[r>>2]=102864,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=102980,i[r>>2]=102940,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104284,i[r>>2]=103016,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=104320,i[r>>2]=103056,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103136,i[r>>2]=103096,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103212,i[r>>2]=103172,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103288,i[r>>2]=103248,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103364,i[r>>2]=103324,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103440,i[r>>2]=103400,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103516,i[r>>2]=103476,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103592,i[r>>2]=103552,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103668,i[r>>2]=103628,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),e=e+(f<<3)|0,i[26984]=e,A=k+8|0,i[26983]=A,i[26982]=r,!n)break r;Z(n),e=i[26984]}i[26983]=A,r=E(16),i[r+12>>2]=103852,i[r>>2]=103704,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,e=A+8|0;break r}if(n=i[26982],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=E(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&z(r,n,A),i[26984]=e+(f<<3),e=k+8|0,i[26983]=e,i[26982]=r,!n)break r;Z(n)}i[26983]=e}return}x0(),H()}G0(),H()}function R7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;W=v-48|0,v=W;i:{e:{if(r>>>0>2)break e;for(r=r<<2,L=i[r+73916>>2],O=i[r+73904>>2];;){r=i[e+4>>2];r:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break r}r=j2(e)}if(!((r|0)==32|r-9>>>0<5))break}I=1;r:{f:switch(r-43|0){case 0:case 2:break f;default:break r}if(I=(r|0)==45?-1:1,r=i[e+4>>2],(r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break r}r=j2(e)}r:{f:{if((r&-33)==73)for(;;){if((t|0)==7)break f;r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break A}r=j2(e)}if(k=t+1491|0,t=t+1|0,u[k|0]!=(r|32))break}if((t|0)!=3){if(k=(t|0)==8,k)break f;if(!f|t>>>0<4)break r;if(k)break f}if(r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1),!f|t>>>0<4)break f;for(r=(r|0)<0;r||(i[e+4>>2]=i[e+4>>2]-1),t=t-1|0,t>>>0>3;);}s=v-16|0,v=s,f=(N1(M(M(I|0)*M(1/0))),t2(2)),e=f&8388607,g=f>>>23|0,r=g&255;f:{if(r){if((r|0)!=255){r=e,e=e>>>7|0,o=r<<25,n=e,r=(g&255)+16256|0;break f}r=e,e=e>>>7|0,o=r<<25,n=e,r=32767;break f}if(r=0,!e)break f;r=e,e=k1(e),o4(s,r,0,0,0,e+81|0),o=i[s+8>>2],n=i[s+12>>2]^65536,w=i[s>>2],h=i[s+4>>2],r=16265-e|0}i[W>>2]=w,i[W+4>>2]=h,e=W,i[e+8>>2]=o,i[e+12>>2]=n|(f&-2147483648|r<<16),v=s+16|0,o=i[e+8>>2],n=i[e+12>>2],w=i[e>>2],h=i[e+4>>2];break i}r:{f:{A:{k:{n:{t:{if(t||(t=0,(r&-33)!=78))break t;for(;;){if((t|0)==2)break n;r=i[e+4>>2];u:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break u}r=j2(e)}if(k=t+9337|0,t=t+1|0,u[k|0]!=(r|32))break}}switch(t|0){case 3:break n;case 0:break f;default:break k}}n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break t}r=j2(e)}if((r|0)==40){t=1;break n}if(n=2147450880,i[e+116>>2]<0)break i;i[e+4>>2]=i[e+4>>2]-1;break i}for(;;){n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break t}r=j2(e)}if(!(r-48>>>0<10|r-65>>>0<26|(r|0)==95)&&r-97>>>0>=26)break n;t=t+1|0;continue}break}if(n=2147450880,(r|0)==41)break i;r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1);n:{if(f){if(t)break n;break r}i[31336]=28;break A}for(;(r|0)>0|(r|0)>=0&&(i[e+4>>2]=i[e+4>>2]-1),t=t-1|0,!!t;);break r}r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r&&(i[e+4>>2]=i[e+4>>2]-1),i[31336]=28}u8(e,0,0);break e}f:{if((r|0)!=48)break f;t=i[e+4>>2];A:{if((t|0)!=i[e+104>>2]){i[e+4>>2]=t+1,t=l[t|0];break A}t=j2(e)}if((t&-33)==88){k=v-432|0,v=k,r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break A}r=j2(e)}A:{k:{for(;;){if((r|0)!=48)n:{if((r|0)!=46)break A;if(r=i[e+4>>2],(r|0)==i[e+104>>2])break n;i[e+4>>2]=r+1,r=l[r|0];break k}else{r=i[e+4>>2],(r|0)!=i[e+104>>2]?(C=1,i[e+4>>2]=r+1,r=l[r|0]):(C=1,r=j2(e));continue}break}r=j2(e)}if((r|0)!=48){D=1;break A}for(;;){r=g,g=r-1|0,V=V-!r|0,r=i[e+4>>2];k:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break k}r=j2(e)}if((r|0)!=48)break}D=1,C=1}for(h=1073676288;;){A:{t=r;k:{n:{if(a=r-48|0,a>>>0<10)break n;if(f0=(r|0)!=46,t=r|32,f0&t-97>>>0>5)break A;if(f0)break n;if(D)break A;D=1,g=o,V=n;break k}r=(r|0)>57?t-87|0:a;n:{if((n|0)<=0&o>>>0<=7|(n|0)<0){_=r+(_<<4)|0;break n}if(!n&o>>>0<=28){H4(k+48|0,r),n1(k+32|0,x,S,w,h,0,0,0,1073414144),x=i[k+32>>2],S=i[k+36>>2],w=i[k+40>>2],h=i[k+44>>2],n1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],x,S,w,h),y4(k,i[k+16>>2],i[k+20>>2],i[k+24>>2],i[k+28>>2],s,B,R,N),R=i[k+8>>2],N=i[k+12>>2],s=i[k>>2],B=i[k+4>>2];break n}if(m|!r)break n;n1(k+80|0,x,S,w,h,0,0,0,1073610752),y4(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],s,B,R,N),m=1,R=i[k+72>>2],N=i[k+76>>2],s=i[k+64>>2],B=i[k+68>>2]}o=o+1|0,n=o?n:n+1|0,C=1}r=i[e+4>>2],(r|0)!=i[e+104>>2]?(i[e+4>>2]=r+1,r=l[r|0]):r=j2(e);continue}break}A:{if(!C){r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0;k:{n:{if(r){if(r=i[e+4>>2],i[e+4>>2]=r-1,!f)break n;if(i[e+4>>2]=r-2,!D)break k;i[e+4>>2]=r-3;break k}if(f)break k}u8(e,0,0)}D2(0),e=t2(1)|0,f=t2(0)|0,D2(+(I|0)),r=t2(1)|0,t2(0)|0,U2(0,f|0),U2(1,e&2147483647|r&-2147483648),Q8(k+96|0,+r1()),s=i[k+96>>2],B=i[k+100>>2],r=i[k+108>>2],e=i[k+104>>2];break A}if((n|0)<=0&o>>>0<=7|(n|0)<0)for(w=o,h=n;_=_<<4,w=w+1|0,h=w?h:h+1|0,!!((w|0)!=8|h););k:{n:{t:{if((r&-33)==80){if(w=_n(e,f),r=l0,h=r,w|(r|0)!=-2147483648)break k;if(f){if(r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r)break t;break n}s=0,B=0,u8(e,0,0),r=0,e=0;break A}if(w=0,h=0,i[e+116>>2]<0)break k}i[e+4>>2]=i[e+4>>2]-1}w=0,h=0}if(!_){D2(0),e=t2(1)|0,f=t2(0)|0,D2(+(I|0)),r=t2(1)|0,t2(0)|0,U2(0,f|0),U2(1,e&2147483647|r&-2147483648),Q8(k+112|0,+r1()),s=i[k+112>>2],B=i[k+116>>2],r=i[k+124>>2],e=i[k+120>>2];break A}if(e=D?g:o,f=w+(e<<2)|0,e=h+((D?V:n)<<2|e>>>30)|0,o=f-32|0,r=0-L|0,n=(f>>>0<w>>>0?e+1|0:e)-(f>>>0<32)|0,e=n,(e|0)>0?e=1:e=r>>>0<o>>>0&(e|0)>=0,e){i[31336]=68,H4(k+160|0,I),n1(k+144|0,i[k+160>>2],i[k+164>>2],i[k+168>>2],i[k+172>>2],-1,-1,-1,2147418111),n1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],-1,-1,-1,2147418111),s=i[k+128>>2],B=i[k+132>>2],r=i[k+140>>2],e=i[k+136>>2];break A}if(e=L-226|0,r=e>>31,(n|0)>=(r|0)&e>>>0<=o>>>0|(r|0)<(n|0)){if((_|0)>=0)for(;y4(k+416|0,s,B,R,N,0,0,0,-1073807360),e=vu(s,B,R,N,1073610752),e=(e|0)>=0,y4(k+400|0,s,B,R,N,e?i[k+416>>2]:s,e?i[k+420>>2]:B,e?i[k+424>>2]:R,e?i[k+428>>2]:N),r=_<<1,_=r|e,e=o,o=e-1|0,n=n-!e|0,R=i[k+408>>2],N=i[k+412>>2],s=i[k+400>>2],B=i[k+404>>2],(r|0)>=0;);e=32-L|0,r=e,e=e+o|0,h=r>>>0>e>>>0?n+1|0:n,r=e>>>0<O>>>0&(h|0)<=0|(h|0)<0?(e|0)>0?e:0:O;k:{if(r>>>0>=113){H4(k+384|0,I),w=i[k+392>>2],h=i[k+396>>2],x=i[k+384>>2],S=i[k+388>>2],n=0,e=0;break k}Q8(k+352|0,A4(1,144-r|0)),H4(k+336|0,I),x=i[k+336>>2],S=i[k+340>>2],w=i[k+344>>2],h=i[k+348>>2],pl(k+368|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],h),y=i[k+376>>2],$=i[k+380>>2],n=i[k+372>>2],e=i[k+368>>2]}f=!(_&1)&((E6(s,B,R,N,0,0,0,0)|0)!=0&r>>>0<32),mi(k+320|0,f|_),n1(k+304|0,x,S,w,h,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2]),r=e,y4(k+272|0,i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2],e,n,y,$),e=f,n1(k+288|0,x,S,w,h,e?0:s,e?0:B,e?0:R,e?0:N),y4(k+256|0,i[k+288>>2],i[k+292>>2],i[k+296>>2],i[k+300>>2],i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2]),bA(k+240|0,i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2],r,n,y,$),e=i[k+240>>2],f=i[k+244>>2],r=i[k+248>>2],w=i[k+252>>2],E6(e,f,r,w,0,0,0,0)||(i[31336]=68),et(k+224|0,e,f,r,w,o),s=i[k+224>>2],B=i[k+228>>2],r=i[k+236>>2],e=i[k+232>>2];break A}i[31336]=68,H4(k+208|0,I),n1(k+192|0,i[k+208>>2],i[k+212>>2],i[k+216>>2],i[k+220>>2],0,0,0,65536),n1(k+176|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],0,0,0,65536),s=i[k+176>>2],B=i[k+180>>2],r=i[k+188>>2],e=i[k+184>>2]}i[W+16>>2]=s,i[W+20>>2]=B,i[W+24>>2]=e,i[W+28>>2]=r,v=k+432|0,o=i[W+24>>2],n=i[W+28>>2],w=i[W+16>>2],h=i[W+20>>2];break i}if(i[e+116>>2]<0)break f;i[e+4>>2]=i[e+4>>2]-1}t=e,s=r,y=f,f=0,k=v-8976|0,v=k,a=0-L|0,$=a-O|0;f:{A:{for(;;){if((s|0)!=48)k:{if((s|0)!=46)break f;if(e=i[t+4>>2],(e|0)==i[t+104>>2])break k;i[t+4>>2]=e+1,s=l[e|0];break A}else{e=i[t+4>>2],(e|0)!=i[t+104>>2]?(i[t+4>>2]=e+1,s=l[e|0]):s=j2(t),f=1;continue}break}s=j2(t)}if((s|0)==48){for(;;){e=o,o=e-1|0,n=n-!e|0,e=i[t+4>>2];A:{if((e|0)!=i[t+104>>2]){i[t+4>>2]=e+1,s=l[e|0];break A}s=j2(t)}if((s|0)!=48)break}f=1}D=1}i[k+784>>2]=0;f:{A:{e=(s|0)==46,r=s-48|0;k:{n:{t:{if(e|r>>>0<=9)for(;;){u:{if(e&1){if(!D){o=w,n=h,D=1;break u}e=!f;break t}if(e=h,w=w+1|0,h=w?e:e+1|0,(_|0)<=2044){C=(s|0)==48?C:w,e=(k+784|0)+(_<<2)|0,m&&(r=(G(i[e>>2],10)+s|0)-48|0),i[e>>2]=r,f=1,r=m+1|0,e=(r|0)==9,m=e?0:r,_=e+_|0;break u}if((s|0)==48)break u;i[k+8960>>2]=i[k+8960>>2]|1,C=18396}e=i[t+4>>2];u:{if((e|0)!=i[t+104>>2]){i[t+4>>2]=e+1,s=l[e|0];break u}s=j2(t)}if(e=(s|0)==46,r=s-48|0,!(e|r>>>0<10))break}if(o=D?o:w,n=D?n:h,!(!f|(s&-33)!=69)){s=_n(t,y),e=l0,B=e;u:{if(s|(e|0)!=-2147483648)break u;if(!y)break k;if(s=0,B=0,i[t+116>>2]<0)break u;i[t+4>>2]=i[t+4>>2]-1}n=n+B|0,o=o+s|0,n=o>>>0<s>>>0?n+1|0:n;break A}if(e=!f,(s|0)<0)break n}if(i[t+116>>2]<0)break n;i[t+4>>2]=i[t+4>>2]-1}if(!e)break A;i[31336]=28}u8(t,0,0),o=0,n=0,r=0,e=0;break f}if(e=i[k+784>>2],!e){D2(0),e=t2(1)|0,f=t2(0)|0,D2(+(I|0)),r=t2(1)|0,t2(0)|0,U2(0,f|0),U2(1,e&2147483647|r&-2147483648),Q8(k,+r1()),o=i[k+8>>2],n=i[k+12>>2],r=i[k+4>>2],e=i[k>>2];break f}if(!(w>>>0>9&(h|0)>=0|(h|0)>0|((o|0)!=(w|0)|(n|0)!=(h|0))|(e>>>O|0?O>>>0<=30:0))){H4(k+48|0,I),mi(k+32|0,e),n1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],i[k+32>>2],i[k+36>>2],i[k+40>>2],i[k+44>>2]),o=i[k+24>>2],n=i[k+28>>2],r=i[k+20>>2],e=i[k+16>>2];break f}if(e=a>>>1|0,e>>>0<o>>>0&(n|0)>=0|(n|0)>0){i[31336]=68,H4(k+96|0,I),n1(k+80|0,i[k+96>>2],i[k+100>>2],i[k+104>>2],i[k+108>>2],-1,-1,-1,2147418111),n1(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],-1,-1,-1,2147418111),o=i[k+72>>2],n=i[k+76>>2],r=i[k+68>>2],e=i[k+64>>2];break f}if(e=L-226|0,r=o>>>0<e>>>0,e=e>>31,r&(n|0)<=(e|0)|(e|0)>(n|0)){i[31336]=68,H4(k+144|0,I),n1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],0,0,0,65536),n1(k+112|0,i[k+128>>2],i[k+132>>2],i[k+136>>2],i[k+140>>2],0,0,0,65536),o=i[k+120>>2],n=i[k+124>>2],r=i[k+116>>2],e=i[k+112>>2];break f}if(m){if((m|0)<=8){for(e=(k+784|0)+(_<<2)|0,t=i[e>>2];t=G(t,10),m=m+1|0,(m|0)!=9;);i[e>>2]=t}_=_+1|0}m=o;A:{if(o>>>0>17&(n|0)>=0|(n|0)>0|(C|0)>=9|(o|0)<(C|0))break A;if(!n&(o|0)==9){H4(k+192|0,I),mi(k+176|0,i[k+784>>2]),n1(k+160|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],i[k+176>>2],i[k+180>>2],i[k+184>>2],i[k+188>>2]),o=i[k+168>>2],n=i[k+172>>2],r=i[k+164>>2],e=i[k+160>>2];break f}if((n|0)<=0&o>>>0<=8|(n|0)<0){H4(k+272|0,I),mi(k+256|0,i[k+784>>2]),n1(k+240|0,i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2],i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2]),H4(k+224|0,i[(0-m<<2)+73904>>2]),j7(k+208|0,i[k+240>>2],i[k+244>>2],i[k+248>>2],i[k+252>>2],i[k+224>>2],i[k+228>>2],i[k+232>>2],i[k+236>>2]),o=i[k+216>>2],n=i[k+220>>2],r=i[k+212>>2],e=i[k+208>>2];break f}if(e=(G(m,-3)+O|0)+27|0,r=i[k+784>>2],r>>>e|0&&(e|0)<=30)break A;H4(k+352|0,I),mi(k+336|0,r),n1(k+320|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],i[k+336>>2],i[k+340>>2],i[k+344>>2],i[k+348>>2]),H4(k+304|0,i[(m<<2)+73832>>2]),n1(k+288|0,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2],i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2]),o=i[k+296>>2],n=i[k+300>>2],r=i[k+292>>2],e=i[k+288>>2];break f}for(;e=_,_=e-1|0,!i[(k+784|0)+(_<<2)>>2];);C=0,r=(m|0)%9|0;A:{if(!r){r=0;break A}f=(n|0)<0?r+9|0:r;k:{if(!e){r=0,e=0;break k}for(o=i[(0-f<<2)+73904>>2],n=1e9/(o|0)|0,s=0,t=0,r=0;w=s,h=k+784|0,s=h+(t<<2)|0,_=i[s>>2],y=(_>>>0)/(o>>>0)|0,w=w+y|0,i[s>>2]=w,w=!w&(r|0)==(t|0),r=w?r+1&2047:r,m=w?m-9|0:m,s=G(n,_-G(o,y)|0),t=t+1|0,(t|0)!=(e|0););if(!s)break k;i[h+(e<<2)>>2]=s,e=e+1|0}m=(m-f|0)+9|0}for(;;){h=(k+784|0)+(r<<2)|0,t=(m|0)<36;A:{for(;;){if(!t&((m|0)!=36|u0[h>>2]>=10384593))break A;for(_=e+2047|0,f=0;w=e,o=f,s=_&2047,_=(k+784|0)+(s<<2)|0,f=i[_>>2],e=f>>>3|0,f=f<<29,o=o+f|0,n=f>>>0>o>>>0?e+1|0:e,!n&o>>>0<1000000001?f=0:(e=o,f=d8(e,n,1e9,0),y=O0(f,l0,1e9,0),o=e-y|0,n=n-(l0+(e>>>0<y>>>0)|0)|0),i[_>>2]=o,e=(r|0)==(s|0)||n|o?w:s,o=w-1&2047,e=(o|0)!=(s|0)?w:e,_=s-1|0,(r|0)!=(s|0););if(C=C-29|0,e=w,!!f)break}r=r-1&2047,(r|0)==(e|0)&&(n=(e+2046&2047)<<2,e=k+784|0,w=n+e|0,i[w>>2]=i[w>>2]|i[e+(o<<2)>>2],e=o),m=m+9|0,i[(k+784|0)+(r<<2)>>2]=f;continue}break}A:{k:for(;;){for(o=e+1&2047,n=(k+784|0)+((e-1&2047)<<2)|0;;){w=(m|0)>45?9:1;n:{for(;;){f=r,t=0;t:{for(;;){u:{if(r=f+t&2047,(r|0)==(e|0)||(r=i[(k+784|0)+(r<<2)>>2],s=i[(t<<2)+73856>>2],r>>>0<s>>>0))break u;if(r>>>0>s>>>0)break t;if(t=t+1|0,(t|0)!=4)continue}break}if((m|0)!=36)break t;for(o=0,n=0,t=0,w=0,h=0;r=f+t&2047,(r|0)==(e|0)&&(e=e+1&2047,i[((e<<2)+k|0)+780>>2]=0),mi(k+768|0,i[(k+784|0)+(r<<2)>>2]),n1(k+752|0,o,n,w,h,0,0,1342177280,1075633366),y4(k+736|0,i[k+752>>2],i[k+756>>2],i[k+760>>2],i[k+764>>2],i[k+768>>2],i[k+772>>2],i[k+776>>2],i[k+780>>2]),w=i[k+744>>2],h=i[k+748>>2],o=i[k+736>>2],n=i[k+740>>2],t=t+1|0,(t|0)!=4;);if(H4(k+720|0,I),n1(k+704|0,o,n,w,h,i[k+720>>2],i[k+724>>2],i[k+728>>2],i[k+732>>2]),o=0,n=0,w=i[k+712>>2],h=i[k+716>>2],s=i[k+704>>2],B=i[k+708>>2],y=C+113|0,t=y-L|0,m=(t|0)<(O|0),r=m?(t|0)>0?t:0:O,r>>>0<=112)break n;break A}if(C=w+C|0,r=e,(e|0)!=(f|0))break}for(h=1e9>>>w|0,_=-1<<w^-1,t=0,r=f;s=t,y=k+784|0,t=y+(f<<2)|0,B=i[t>>2],s=s+(B>>>w|0)|0,i[t>>2]=s,s=!s&(r|0)==(f|0),r=s?r+1&2047:r,m=s?m-9|0:m,t=G(h,_&B),f=f+1&2047,(f|0)!=(e|0););if(!t)continue;if((r|0)!=(o|0)){i[y+(e<<2)>>2]=t,e=o;continue k}i[n>>2]=i[n>>2]|1;continue}break}break}Q8(k+656|0,A4(1,225-r|0)),pl(k+688|0,i[k+656>>2],i[k+660>>2],i[k+664>>2],i[k+668>>2],h),x=i[k+696>>2],S=i[k+700>>2],R=i[k+688>>2],N=i[k+692>>2],Q8(k+640|0,A4(1,113-r|0)),U9(k+672|0,s,B,w,h,i[k+640>>2],i[k+644>>2],i[k+648>>2],i[k+652>>2]),o=i[k+672>>2],n=i[k+676>>2],g=i[k+680>>2],V=i[k+684>>2],bA(k+624|0,s,B,w,h,o,n,g,V),y4(k+608|0,R,N,x,S,i[k+624>>2],i[k+628>>2],i[k+632>>2],i[k+636>>2]),w=i[k+616>>2],h=i[k+620>>2],s=i[k+608>>2],B=i[k+612>>2]}_=f+4&2047;A:{if((_|0)==(e|0))break A;_=i[(k+784|0)+(_<<2)>>2];k:{if(_>>>0<=499999999){if(!_&(f+5&2047)==(e|0))break k;Q8(k+496|0,+(I|0)*.25),y4(k+480|0,o,n,g,V,i[k+496>>2],i[k+500>>2],i[k+504>>2],i[k+508>>2]),g=i[k+488>>2],V=i[k+492>>2],o=i[k+480>>2],n=i[k+484>>2];break k}if((_|0)!=5e8){Q8(k+592|0,+(I|0)*.75),y4(k+576|0,o,n,g,V,i[k+592>>2],i[k+596>>2],i[k+600>>2],i[k+604>>2]),g=i[k+584>>2],V=i[k+588>>2],o=i[k+576>>2],n=i[k+580>>2];break k}if(A0=+(I|0),(f+5&2047)==(e|0)){Q8(k+528|0,A0*.5),y4(k+512|0,o,n,g,V,i[k+528>>2],i[k+532>>2],i[k+536>>2],i[k+540>>2]),g=i[k+520>>2],V=i[k+524>>2],o=i[k+512>>2],n=i[k+516>>2];break k}Q8(k+560|0,A0*.75),y4(k+544|0,o,n,g,V,i[k+560>>2],i[k+564>>2],i[k+568>>2],i[k+572>>2]),g=i[k+552>>2],V=i[k+556>>2],o=i[k+544>>2],n=i[k+548>>2]}if(r>>>0>111||(U9(k+464|0,o,n,g,V,0,0,0,1073676288),E6(i[k+464>>2],i[k+468>>2],i[k+472>>2],i[k+476>>2],0,0,0,0)))break A;y4(k+448|0,o,n,g,V,0,0,0,1073676288),g=i[k+456>>2],V=i[k+460>>2],o=i[k+448>>2],n=i[k+452>>2]}y4(k+432|0,s,B,w,h,o,n,g,V),bA(k+416|0,i[k+432>>2],i[k+436>>2],i[k+440>>2],i[k+444>>2],R,N,x,S),w=i[k+424>>2],h=i[k+428>>2],s=i[k+416>>2],B=i[k+420>>2];A:{if(($-2|0)>=(y&2147483647)||(i[k+408>>2]=w,i[k+412>>2]=h&2147483647,i[k+400>>2]=s,i[k+404>>2]=B,n1(k+384|0,s,B,w,h,0,0,0,1073610752),f=vu(i[k+400>>2],i[k+404>>2],i[k+408>>2],i[k+412>>2],1081081856),e=(f|0)>=0,w=e?i[k+392>>2]:w,h=e?i[k+396>>2]:h,s=e?i[k+384>>2]:s,B=e?i[k+388>>2]:B,o=E6(o,n,g,V,0,0,0,0),C=e+C|0,(C+110|0)<=($|0)&&!(m&((r|0)!=(t|0)|(f|0)<0)&(o|0)!=0)))break A;i[31336]=68}et(k+368|0,s,B,w,h,C),o=i[k+376>>2],n=i[k+380>>2],r=i[k+372>>2],e=i[k+368>>2]}i[W+40>>2]=o,i[W+44>>2]=n,i[W+32>>2]=e,i[W+36>>2]=r,v=k+8976|0,o=i[W+40>>2],n=i[W+44>>2],w=i[W+32>>2],h=i[W+36>>2];break i}break i}n=0}i[A>>2]=w,i[A+4>>2]=h,i[A+8>>2]=o,i[A+12>>2]=n,v=W+48|0}function er(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0;h=A+18548|0;i:{e:{r:{f:{A:{k:{n:{t:{for(;;){s=i[A+18588>>2],w=i[s+132>>2];u:{o:{if(_=i[s+124>>2],o=i[_+484>>2],t=1<<f,(o|0)<(t+e|0)||(m=i[_+488>>2],(m|0)<(r+t|0)|i[_+16872>>2]>=(f|0)))break o;n=1,B=e-1|0,t=1;l:{if((B|r)<0||(t=1,(e|0)>(o|0))||(t=1,(r|0)>=(m|0))||(g=i[_+16876>>2],C=G(i[_+16892>>2],r>>g),I=i[s+140>>2],W=C+(e>>g)|0,g=C+(B>>g)|0,t=1,F[I+G(W,24)>>1]!=F[I+G(g,24)>>1]))break l;t=i[w+8484>>2],t=i[t+(W<<2)>>2]!=i[t+(g<<2)>>2]}g=r-1|0;l:{if((g|e)<0|(e|0)>=(o|0)|(r|0)>(m|0)||(o=i[_+16876>>2],m=e>>o,I=i[s+140>>2],C=i[_+16892>>2],W=m+G(C,r>>o)|0,o=m+G(C,g>>o)|0,F[I+G(W,24)>>1]!=F[I+G(o,24)>>1]))break l;n=i[w+8484>>2],n=i[n+(W<<2)>>2]!=i[n+(o<<2)>>2]}if(o=0,!t){if(o=i[s+168>>2],t=B>>o,(t|0)<0||(m=i[s+172>>2],(m|0)<=(t|0)))break A;if(o=r>>o,(o|0)<0|(o|0)>=i[s+176>>2])break f;t=(i[s+160>>2]+G(t,3)|0)+G(G(o,m),3)|0,o=((l[t|0]|l[t+1|0]<<8)>>>6&3)>(k|0)}if(n)t=0;else{if(n=i[s+168>>2],t=e>>n,(t|0)<0||(m=i[s+172>>2],(m|0)<=(t|0)))break A;if(n=g>>n,(n|0)<0|(n|0)>=i[s+176>>2])break f;t=(i[s+160>>2]+G(t,3)|0)+G(G(n,m),3)|0,t=((l[t|0]|l[t+1|0]<<8)>>>6&3)>(k|0)}t=!v2(h,(t+(i[A+18572>>2]+o|0)|0)+2|0);break u}t=i[_+16872>>2]>=(f|0)}if(!l[w+26|0]|i[w+8268>>2]>(f|0)||(i[A+18500>>2]=0,i[A+18504>>2]=0),!l[i[A+18592>>2]+760|0]|i[w+8272>>2]>(f|0)||(i[A+18508>>2]=0),!t){if(f=f-1|0,k=k+1|0,er(A,e,r,f,k),s=1<<f,t=s+r|0,s=e+s|0,(s|0)<i[_+484>>2]&&er(A,s,r,f,k),(t|0)<i[_+488>>2]&&er(A,e,t,f,k),(s|0)>=i[_+484>>2])break t;if(e=s,r=t,(r|0)<i[_+488>>2])continue;break t}break}if(t=i[s+168>>2],h=f-t|0,(h|0)!=31)for(o=r>>t,h=1<<h,n=o+h|0,t=e>>t,m=t+h|0,B=k<<6&192;;){for(w=t;h=(i[s+160>>2]+G(w,3)|0)+G(G(i[s+172>>2],o),3)|0,_=B|(l[h|0]|l[h+1|0]<<8)&65343,u[h|0]=_,u[h+1|0]=_>>>8,w=w+1|0,(m|0)>(w|0););if(o=o+1|0,!((n|0)>(o|0)))break}if(m=v+-64|0,v=m,t=A,C=i[A+18592>>2],n=i[A+18588>>2],B=i[n+132>>2],g=i[n+124>>2],s=e,h=r,_=f,A=i[n+168>>2],w=f-A|0,(w|0)!=31)for(r=r>>A,w=1<<w,W=r+w|0,e=e>>A,I=e+w|0;;){for(A=e;w=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,o=(l[w|0]|l[w+1|0]<<8)&65528,u[w|0]=o,u[w+1|0]=o>>>8,A=A+1|0,(I|0)>(A|0););if(r=r+1|0,!((W|0)>(r|0)))break}if(e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+G(A,3)|0)+G(G(e,r),3)|0,e=(l[A|0]|l[A+1|0]<<8)&65528|f&7,u[A|0]=e,u[A+1|0]=e>>>8,e=i[n+248>>2],r=_-e|0,(r|0)!=31)for(A=h>>e,r=1<<r,f=A+r|0,w=r,r=s>>e,w=w+r|0;;){for(e=r;u[(i[n+240>>2]+e|0)+G(i[n+252>>2],A)|0]=0,e=e+1|0,(w|0)>(e|0););if(A=A+1|0,!((f|0)>(A|0)))break}y9(t,s,h);u:{if(l[B+44|0]){if(A=v2(t+18548|0,i[t+18572>>2]+161|0),u[t+32|0]=A,!A)break u;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,o=r+e|0,f=e,e=s>>A,B=f+e|0;;){for(A=e;f=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,w=(l[f|0]|l[f+1|0]<<8)&63487|2048,u[f|0]=w,u[f+1|0]=w>>>8,A=A+1|0,(B|0)>(A|0););if(r=r+1|0,!((o|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;u[((i[n+140>>2]+G(A,24)|0)+G(G(e,r),24)|0)+22|0]=1;break u}u[t+32|0]=0}o=1<<_,f=0;u:{o:{if(i[C+28>>2]==2)break o;e=i[t+18588>>2],B=1,w=s-1|0,A=1;l:{if((w|h)<0||(r=i[e+124>>2],A=1,(s|0)>i[r+484>>2])||(A=1,(h|0)>=i[r+488>>2])||(A=i[r+16892>>2],r=i[r+16876>>2],f=G(A,h>>r),I=i[e+140>>2],W=f+(s>>r)|0,r=f+(w>>r)|0,A=1,F[I+G(W,24)>>1]!=F[I+G(r,24)>>1]))break l;A=i[i[e+132>>2]+8484>>2],A=i[A+(W<<2)>>2]!=i[A+(r<<2)>>2]}W=h-1|0;l:{if((W|s)<0||(r=i[e+124>>2],(s|0)>=i[r+484>>2]|(h|0)>i[r+488>>2])||(f=i[r+16876>>2],I=s>>f,y=i[e+140>>2],r=i[r+16892>>2],V=I+G(r,h>>f)|0,r=I+G(r,W>>f)|0,F[y+G(V,24)>>1]!=F[y+G(r,24)>>1]))break l;f=i[i[e+132>>2]+8484>>2],B=i[f+(V<<2)>>2]!=i[f+(r<<2)>>2]}if(f=0,r=0,!A){if(r=i[e+168>>2],A=w>>r,(A|0)<0||(w=i[e+172>>2],(w|0)<=(A|0)))break A;if(r=h>>r,(r|0)<0|(r|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+G(A,3)|0)+G(G(r,w),3)|0,r=((l[A|0]|l[A+1|0]<<8)&768)==512}if(!B){if(f=i[e+168>>2],A=s>>f,(A|0)<0||(w=i[e+172>>2],(w|0)<=(A|0)))break A;if(f=W>>f,(f|0)<0|(f|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+G(A,3)|0)+G(G(f,w),3)|0,f=((l[A|0]|l[A+1|0]<<8)&768)==512}if(A=t+18548|0,v2(A,((i[t+18572>>2]+r|0)+f|0)+5|0)&255){e=16;l:{if(i[i[t+18592>>2]+812>>2]<2||!v2(A,i[t+18572>>2]+148|0)||(e=48,i[i[t+18592>>2]+812>>2]<3))break l;for(e=1;k4(A)&&(e=e+1|0,(e|0)<(i[i[t+18592>>2]+812>>2]-1|0)););e=e<<5|16}if(u[t+26|0]=l[t+26|0]&15|e,e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+G(A,3)|0)+G(G(e,r),3)|0,e=(l[A|0]|l[A+1|0]<<8)&65479,u[A|0]=e,u[A+1|0]=e>>>8,A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,_=r+e|0,A=s>>A,w=A+e|0;;){for(e=A;f=(i[n+160>>2]+G(e,3)|0)+G(G(i[n+172>>2],r),3)|0,k=(l[f|0]|l[f+1|0]<<8)&64767|512,u[f|0]=k,u[f+1|0]=k>>>8,e=e+1|0,(w|0)>(e|0););if(r=r+1|0,!((_|0)>(r|0)))break}Y7(i[t+18584>>2],i[t+18592>>2],i[t+18588>>2],t+16|0,s,h,0,0,o,o,o,0);break u}if(f=0,i[C+28>>2]==2)break o;f=!v2(A,i[t+18572>>2]+149|0)}if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,C=r+e|0,W=f<<8,A=s>>A,I=A+e|0;;){for(e=A;w=(i[n+160>>2]+G(e,3)|0)+G(G(i[n+172>>2],r),3)|0,B=W|(l[w|0]|l[w+1|0]<<8)&64767,u[w|0]=B,u[w+1|0]=B>>>8,e=e+1|0,(I|0)>(e|0););if(r=r+1|0,!((C|0)>(r|0)))break}B=!f;o:{l:{if(f){w=i[i[t+18588>>2]+124>>2],A=0,r=t+18548|0;s:{if(v2(r,i[t+18572>>2]+8|0))break s;e=v2(r,i[t+18572>>2]+9|0);w:{_:{if((_|0)>i[w+16872>>2]){if(A=e?1:2,!l[w+8798|0]||v2(r,i[t+18572>>2]+11|0))break s;if(A=k4(r),!(!e|!A)){A=5;break s}if(!(A|!e)){A=4;break s}if(A|e)break _;A=6;break s}if(A=1,e)break s;if((_|0)!=3)break w;A=2;break s}if(!(!A|e)){A=7;break s}M0(12200,18308,1774,15102),H()}A=3-v2(r,i[t+18572>>2]+10|0)|0}break l}if(e=0,w=0,(_|0)!=i[g+16872>>2])break o;A=v2(t+18548|0,i[t+18572>>2]+8|0)?0:3}e=A,w=(A|0)==3&B}if(r=i[n+168>>2],A=s>>r,(A|0)<0||(B=i[n+172>>2],(B|0)<=(A|0)))break n;if(r=h>>r,(r|0)<0|(r|0)>=i[n+176>>2])break k;A=(i[n+160>>2]+G(A,3)|0)+G(G(r,B),3)|0,r=(l[A|0]|l[A+1|0]<<8)&65479|e<<3&56,u[A|0]=r,u[A+1|0]=r>>>8;o:{if(!f){l:{if(!l[g+8800|0]|e|((_|0)<i[g+16956>>2]|(_|0)>i[g+16960>>2])||!MA(t+18548|0))break l;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,w=r+e|0,f=e,e=s>>A,o=f+e|0;;){for(A=e;f=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,k=(l[f|0]|l[f+1|0]<<8)&64511|1024,u[f|0]=k,u[f+1|0]=k>>>8,A=A+1|0,(o|0)>(A|0););if(r=r+1|0,!((w|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;u[((i[n+140>>2]+G(A,24)|0)+G(G(e,r),24)|0)+22|0]=1,r=0,k=v-32|0,v=k,A=i[t+18552>>2],i[k+8>>2]=A,e=i[t+18556>>2],i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+12>>2]=e-A,A=1<<_,e=i[t+18588>>2],w=i[e+40>>2],n=G(w,h),o=i[e+4>>2],e=i[e+124>>2],f=u[e+8801|0],e=i[e+16832>>2];s:{if((e|0)>=9){if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=o+(n+s<<1)|0;;){for(o=n+(G(r,w)<<1)|0,e=0;A0=o+(e<<1)|0,n0=v0(k+8|0,f)<<B,Q[A0>>1]=n0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}break s}if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=n+(o+s|0)|0;;){for(o=n+G(r,w)|0,e=0;A0=e+o|0,n0=v0(k+8|0,f)<<B,u[A0|0]=n0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}}w=i[t+18588>>2],f=i[w+124>>2];s:{if(!i[f+16848>>2])break s;if(A=i[f+16852>>2],B=(s|0)/(A|0)|0,g=1<<_,_=i[f+16856>>2],r=(g|0)/(_|0)|0,e=(g|0)/(A|0)|0,o=i[w+44>>2],A=G(o,(h|0)/(_|0)|0),C=i[w+8>>2],_=u[f+8802|0],n=i[f+16840>>2],(n|0)>=9){if(f=0,n=n-_|0,n=(n|0)>0?n:0,A=A+B<<1,!((e|0)<=0|(r|0)<=0)){for(w=A+C|0;;){for(B=w+(G(f,o)<<1)|0,A=0;A0=B+(A<<1)|0,n0=v0(k+8|0,_)<<n,Q[A0>>1]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}w=i[t+18588>>2],A=i[w+124>>2],_=u[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,o=i[w+44>>2],e=i[A+16856>>2],f=i[A+16852>>2],A=G(o,(h|0)/(e|0)|0)+((s|0)/(f|0)|0)<<1,r=(g|0)/(e|0)|0,e=(g|0)/(f|0)|0}if((e|0)<=0|(r|0)<=0)break s;for(s=i[w+12>>2]+A|0,f=0;;){for(h=s+(G(f,o)<<1)|0,A=0;A0=h+(A<<1)|0,n0=v0(k+8|0,_)<<n,Q[A0>>1]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}break s}if(f=0,n=n-_|0,n=(n|0)>0?n:0,!((e|0)<=0|(r|0)<=0)){for(w=(B+C|0)+A|0;;){for(B=w+G(f,o)|0,A=0;A0=A+B|0,n0=v0(k+8|0,_)<<n,u[A0|0]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}w=i[t+18588>>2],A=i[w+124>>2],_=u[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,e=i[A+16852>>2],B=(s|0)/(e|0)|0,A=i[A+16856>>2],r=(g|0)/(A|0)|0,e=(g|0)/(e|0)|0,o=i[w+44>>2],A=G(o,(h|0)/(A|0)|0)}if((e|0)<=0|(r|0)<=0)break s;for(s=(i[w+12>>2]+B|0)+A|0,f=0;;){for(h=s+G(f,o)|0,A=0;A0=A+h|0,n0=v0(k+8|0,_)<<n,u[A0|0]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}}Ql(k+8|0),i[t+18552>>2]=i[k+8>>2],Ze(t+18548|0),v=k+32|0;break u}if(B=(e|0)==3,C=B?(o|0)/2|0:o,(_|0)!=31)for(r=t+18548|0,e=0,f=0;;){for(A=0;A0=(m+48|0)+(e<<2)|0,n0=v2(r,i[t+18572>>2]+12|0),i[A0>>2]=n0,e=e+1|0,A=A+C|0,(o|0)>(A|0););if(f=f+C|0,!((o|0)>(f|0)))break}f=s-1|0,A=0;l:{if((f|h)<0||(e=i[n+124>>2],A=0,(s|0)>i[e+484>>2])||(A=0,(h|0)>=i[e+488>>2])||(A=i[e+16892>>2],e=i[e+16876>>2],r=G(A,h>>e),W=i[n+140>>2],k=r+(s>>e)|0,e=r+(f>>e)|0,A=0,F[W+G(k,24)>>1]!=F[W+G(e,24)>>1]))break l;A=i[i[n+132>>2]+8484>>2],A=i[A+(k<<2)>>2]==i[A+(e<<2)>>2]}k=A,f=h-1|0;l:{if((f|s)<0||(A=i[n+124>>2],(s|0)>=i[A+484>>2]|(h|0)>i[A+488>>2])||(e=i[A+16876>>2],r=s>>e,I=i[n+140>>2],A=i[A+16892>>2],W=r+G(A,h>>e)|0,A=r+G(A,f>>e)|0,F[I+G(W,24)>>1]!=F[I+G(A,24)>>1]))break l;e=i[i[n+132>>2]+8484>>2],$=i[e+(W<<2)>>2]==i[e+(A<<2)>>2]}if(I=_-B|0,(_|0)!=31)for(S=t+18548|0,B=0;;){for(W=h+B|0,f0=(B|0)>0|$,V=0;;){y=O<<2,L=i[y+(m+48|0)>>2];l:{if(L){f=we(S,2),A=m+32|0;break l}f=C8(S,5),A=m+16|0}i[A+y>>2]=f,r=s+V|0,x=r,A=i[g+16944>>2],R=G(i[g+16948>>2],W>>A)+(r>>A)|0,f=R,D=i[n+124>>2],e=1,A=1;l:{if(!((V|0)>0|k))break l;if(A=i[n+168>>2],r=r-1>>A,(r|0)<0||(a=i[n+172>>2],(a|0)<=(r|0)))break A;if(N=W>>A,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(A=1,l[((i[n+160>>2]+G(r,3)|0)+G(G(N,a),3)|0)+1|0]&7)break l;A=l[(f+i[n+200>>2]|0)-1|0]}l:{if(!f0)break l;if(N=i[n+168>>2],r=x>>N,(r|0)<0||(x=i[n+172>>2],(x|0)<=(r|0)))break A;if(N=W-1>>N,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(l[((i[n+160>>2]+G(r,3)|0)+G(G(N,x),3)|0)+1|0]&7|(W|0)==(W&-1<<i[D+16876>>2]))break l;e=l[i[n+200>>2]+(f-i[D+16948>>2]|0)|0]}l:{if((A|0)==(e|0)){if(A>>>0<=1){i[m+12>>2]=26,i[m+4>>2]=0,i[m+8>>2]=1;break l}i[m+4>>2]=A,i[m+12>>2]=(A-1&31)+2,i[m+8>>2]=(A+29&31)+2;break l}if(i[m+8>>2]=e,i[m+4>>2]=A,!(!A|!e)){i[m+12>>2]=0;break l}if(!((A|0)==1|(e|0)==1)){i[m+12>>2]=1;break l}i[m+12>>2]=26}l:{if((L|0)!=1){A=i[m+4>>2],r=i[m+8>>2],e=(A|0)>(r|0)?A:r,A=(A|0)<(r|0)?A:r,r=i[m+12>>2];s:{if((A|0)<=(r|0)){f=A,A=r;break s}i[m+12>>2]=A,i[m+4>>2]=r,f=r}s:{if((A|0)>=(e|0)){r=A,A=e;break s}i[m+8>>2]=A,r=e}e=A,A=i[y+(m+16|0)>>2],A=((A|0)>=(f|0))+A|0,A=((e|0)<=(A|0))+A|0,f=((A|0)>=(r|0))+A|0;break l}f=i[(m+4|0)+(i[y+(m+32|0)>>2]<<2)>>2]}if(y=i[n+208>>2],A=I-y|0,(A|0)!=31)for(D=1<<A,N=D&2147483646,A=0;;){if(e=0,r=0,(I|0)!=(y|0))for(;u[((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0]=f,u[(((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0)+1|0]=f,e=e+2|0,r=r+2|0,(N|0)!=(r|0););if((I|0)==(y|0)&&(u[((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0]=f),A=A+1|0,(D|0)==(A|0))break}if(O=O+1|0,V=C+V|0,!((o|0)>(V|0)))break}if(B=B+C|0,!((o|0)>(B|0)))break}l:switch(i[g+16848>>2]){case 3:if((_|0)==31)break o;f=t+18548|0,r=0;s:{for(;;){k=r+h|0,B=0;w:{for(;;){if(v2(f,i[t+18572>>2]+13|0)?A=C8(f,2):A=4,y=s+B|0,W=i[n+208>>2],e=y>>W,(e|0)<0||(R=i[n+212>>2],(R|0)<=(e|0)))break w;if(V=k>>W,(V|0)<0|(V|0)>=i[n+216>>2])break f;if(e=l[(e+i[n+200>>2]|0)+G(V,R)|0],e=e>>>0<=34?e:0,V=(A|0)==4,V||(A=i[(A<<2)+63616>>2],e=(A|0)==(e|0)?34:A),A=I-W|0,(A|0)!=31)for(V=V?e|-128:e,e=i[n+124>>2],W=i[e+16944>>2],y=G(k>>W,i[e+16948>>2])+(y>>W)|0,W=1<<A,A=0;;){for(e=0;;){if(R=i[n+124>>2],i[R+16948>>2]<=(e|0))break r;if(i[R+16952>>2]<=(A|0))break e;if(R=(e+y|0)+G(i[n+232>>2],A)|0,(R|0)>=i[n+224>>2])break s;if(u[R+i[n+220>>2]|0]=V,e=e+1|0,(W|0)==(e|0))break}if(A=A+1|0,(W|0)==(A|0))break}if(B=B+C|0,!((o|0)>(B|0)))break}if(r=r+C|0,(o|0)>(r|0))continue;break o}break}break A}break i;case 0:break o;default:break l}if(A=t+18548|0,v2(A,i[t+18572>>2]+13|0)?A=C8(A,2):A=4,r=i[n+208>>2],e=s>>r,(e|0)<0||(f=i[n+212>>2],(f|0)<=(e|0)))break A;if(r=h>>r,(r|0)<0|(r|0)>=i[n+216>>2])break f;if(e=l[(e+i[n+200>>2]|0)+G(r,f)|0],e=e>>>0<=34?e:0,(A|0)!=4&&(r=i[(A<<2)+63616>>2],e=(e|0)==(r|0)?34:r),e=i[g+16848>>2]==2?l[e+63632|0]:e,A=(A|0)==4,r=_-i[n+208>>2]|0,(r|0)!=31)for(f=i[n+124>>2],k=i[f+16944>>2],f=G(h>>k,i[f+16948>>2])+(s>>k)|0,k=A?e|-128:e,r=1<<r,A=0;;){for(e=0;;){if(o=i[n+124>>2],i[o+16948>>2]<=(e|0))break r;if(i[o+16952>>2]<=(A|0))break e;if(o=(e+f|0)+G(i[n+232>>2],A)|0,(o|0)>=i[n+224>>2])break i;if(u[o+i[n+220>>2]|0]=k,e=e+1|0,(r|0)==(e|0))break}if(A=A+1|0,(r|0)==(A|0))break}break o}l:{s:{w:switch(e|0){case 1:A=(o|0)/2|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,A,k,o,1);break s;case 2:A=(o|0)/2|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,A,o,k,o,1);break s;case 4:A=(o|0)/4|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,(3<<_)/4|0,k,o,1);break s;case 5:A=(3<<_)/4|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,(o|0)/4|0,k,o,1);break s;case 6:A=(o|0)/4|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,(3<<_)/4|0,o,k,o,1);break s;case 7:A=(3<<_)/4|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,(o|0)/4|0,o,k,o,1);break s;case 3:A=(o|0)/2|0,_4(t,s,h,0,0,A,A,k,o,0),_4(t,s,h,A,0,A,A,k,o,1),_4(t,s,h,0,A,A,A,k,o,2),_4(t,s,h,A,A,A,A,k,o,3);break s;default:M0(22224,18308,4544,3864),H();case 0:break w}if(_4(t,s,h,0,0,o,o,k,o,0),l[t+26|0]&16)break l}if(!v2(t+18548|0,i[t+18572>>2]+153|0))break u}A=i[g+16848>>2]!=0,Pi(t,s,h,s,h,s,h,_,0,0,i[g+628>>2],w,1,A,A);break u}A=i[g+16848>>2]!=0,Pi(t,s,h,s,h,s,h,_,0,0,w+i[g+632>>2]|0,w,0,A,A)}v=m- -64|0}return}M0(4656,10893,128,4231),H()}M0(4618,10893,129,4231),H()}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}M0(6129,10893,691,19924),H()}M0(6104,10893,692,19924),H()}M0(11452,10893,695,19924),H()}function O_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0;f=v-16|0,v=f,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=f+8,k=f+4|0,t8(k,i[t>>2],t+4|0),n=A,f0=r,o=v-112|0,v=o,C=e,s=i[e+116>>2],A0=k+4|0,t=A0,A=t,e=i[k+4>>2];i:{e:{r:{if(!e)break r;for(A=e;r=s>>>0>u0[A+16>>2],t=r?t:A,A=i[(r?4:0)+A>>2],!!A;);if(!((t|0)==(A0|0)|s>>>0<u0[t+16>>2])){r=E(32),i[o>>2]=r,i[o+4>>2]=28,i[o+8>>2]=-2147483616,A=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[r+24|0]=A,u[r+25|0]=A>>>8,u[r+26|0]=A>>>16,u[r+27|0]=A>>>24,e=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),A=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[r+16|0]=A,u[r+17|0]=A>>>8,u[r+18|0]=A>>>16,u[r+19|0]=A>>>24,u[r+20|0]=e,u[r+21|0]=e>>>8,u[r+22|0]=e>>>16,u[r+23|0]=e>>>24,e=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),A=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[r+8|0]=A,u[r+9|0]=A>>>8,u[r+10|0]=A>>>16,u[r+11|0]=A>>>24,u[r+12|0]=e,u[r+13|0]=e>>>8,u[r+14|0]=e>>>16,u[r+15|0]=e>>>24,e=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),A=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[r|0]=A,u[r+1|0]=A>>>8,u[r+2|0]=A>>>16,u[r+3|0]=A>>>24,u[r+4|0]=e,u[r+5|0]=e>>>8,u[r+6|0]=e>>>16,u[r+7|0]=e>>>24,u[r+28|0]=0,r=K(o+48|0,2,0,o),A=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=A,e=n+8|0;f:{if(u[r+19|0]>=0){A=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=A,i[e+8>>2]=i[r+16>>2],u[n+20|0]=1;break f}if(T(e,i[r+8>>2],i[r+12>>2]),A=u[r+19|0],u[n+20|0]=1,(A|0)>=0)break f;Z(i[r+8>>2])}if(u[o+11|0]>=0)break i;Z(i[o>>2]);break i}for(;;){if(A=e,e=i[e+16>>2],e>>>0>s>>>0){if(t=A,e=i[t>>2],e)continue;break r}if(e>>>0>=s>>>0)break e;if(e=i[A+4>>2],!e)break}t=A+4|0}e=E(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=s,i[t>>2]=e,A=i[i[k>>2]>>2],A&&(i[k>>2]=A),m1(i[k+4>>2],e),i[k+8>>2]=i[k+8>>2]+1}s=i[C+460>>2],t=i[C+464>>2],di(o+80|0,i[C+100>>2]- -64|0,s,t);e:{if(i[o+80>>2]){A=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=A,e=n+8|0;r:{if(u[o+99|0]>=0){A=i[o+92>>2],i[e>>2]=i[o+88>>2],i[e+4>>2]=A,i[e+8>>2]=i[o+96>>2];break r}T(e,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1,A=0;break e}if(A=E(172),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=94860,o0(A+16|0,0,80),e=i[A+4>>2],r=e+1|0,i[A+4>>2]=r,i[A+104>>2]=0,i[A+108>>2]=0,i[A+36>>2]=1,i[A+40>>2]=1,u[A+24|0]=1,Q[A+22>>1]=2,Q[A+18>>1]=2,Q[A+20>>1]=2,i[A+112>>2]=0,i[A+116>>2]=4740,i[A+140>>2]=0,i[A+144>>2]=0,i[A+128>>2]=99,i[A+132>>2]=99,i[A+120>>2]=0,i[A+124>>2]=0,i[A+12>>2]=95208,i[A+148>>2]=0,i[A+152>>2]=0,i[A+136>>2]=A+140,i[A+156>>2]=0,i[A+160>>2]=0,i[A+164>>2]=0,i[A+168>>2]=0,i[A+4>>2]=e,e=i[A+8>>2],y=A+12|0,i[A+96>>2]=y,i[A+8>>2]=e+1,i[A+100>>2]=A,r||(X[i[i[A>>2]+8>>2]](A),p(A)),i[y+120>>2]=3,i[y+116>>2]=1,i[y+112>>2]=t,i[y+108>>2]=s,T0(o+48|0,y,3,s,t,8,i[C+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}if(u[o+67|0]<0&&Z(i[o+56>>2]),T0(o+48|0,y,4,s,t,8,i[C+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}if(u[o+67|0]<0&&Z(i[o+56>>2]),T0(o+48|0,y,5,s,t,8,i[C+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}u[o+67|0]<0&&Z(i[o+56>>2]),m=o+48|0,w=F[C+450>>1],I=F[C+452>>1],W=F[C+454>>1],s=F[C+456>>1],_=v-16|0,v=_;r:{f:{if(h=i[y+128>>2],!h)break f;for(e=y+128|0,r=e;t=i[h+16>>2]<3,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>=4)break f;R=I>>>8|0,I=W>>>8|0,W=s>>>8|0,s=w>>>8|0;A:{if(l[r+24|0]!=8)break A;if(t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],s,t),h=i[e>>2],!h)break f;for(r=e;t=i[h+16>>2]<4,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>4)break f;if(l[r+24|0]!=8)break A;if(t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],R,t),h=i[e>>2],!h)break f;for(r=e;t=i[h+16>>2]<5,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>5)break f;if(l[r+24|0]!=8)break A;t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],I,t),h=i[e>>2];k:{if(!h)break k;for(r=e;t=i[h+16>>2]<6,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>6)break k;if(l[r+24|0]!=8)break A;if(e=G(i[r+56>>2],i[r+32>>2]),!e)break k;o0(i[r+44>>2],W,e)}if(e=i[26929],i[m>>2]=i[26928],i[m+4>>2]=e,r=m+8|0,u[107731]>=0){e=i[26931],i[r>>2]=i[26930],i[r+4>>2]=e,i[r+8>>2]=i[26932];break r}T(r,i[26930],i[26931]);break r}if(e=E(56),i[_+4>>2]=e,i[_+8>>2]=52,i[_+12>>2]=-2147483592,t=l[9929]|l[9930]<<8|(l[9931]<<16|l[9932]<<24),r=l[9925]|l[9926]<<8|(l[9927]<<16|l[9928]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=t,u[e+5|0]=t>>>8,u[e+6|0]=t>>>16,u[e+7|0]=t>>>24,u[e+52|0]=0,r=l[9973]|l[9974]<<8|(l[9975]<<16|l[9976]<<24),u[e+48|0]=r,u[e+49|0]=r>>>8,u[e+50|0]=r>>>16,u[e+51|0]=r>>>24,t=l[9969]|l[9970]<<8|(l[9971]<<16|l[9972]<<24),r=l[9965]|l[9966]<<8|(l[9967]<<16|l[9968]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,u[e+44|0]=t,u[e+45|0]=t>>>8,u[e+46|0]=t>>>16,u[e+47|0]=t>>>24,t=l[9961]|l[9962]<<8|(l[9963]<<16|l[9964]<<24),r=l[9957]|l[9958]<<8|(l[9959]<<16|l[9960]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=t,u[e+37|0]=t>>>8,u[e+38|0]=t>>>16,u[e+39|0]=t>>>24,t=l[9953]|l[9954]<<8|(l[9955]<<16|l[9956]<<24),r=l[9949]|l[9950]<<8|(l[9951]<<16|l[9952]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=t,u[e+29|0]=t>>>8,u[e+30|0]=t>>>16,u[e+31|0]=t>>>24,t=l[9945]|l[9946]<<8|(l[9947]<<16|l[9948]<<24),r=l[9941]|l[9942]<<8|(l[9943]<<16|l[9944]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=t,u[e+21|0]=t>>>8,u[e+22|0]=t>>>16,u[e+23|0]=t>>>24,t=l[9937]|l[9938]<<8|(l[9939]<<16|l[9940]<<24),r=l[9933]|l[9934]<<8|(l[9935]<<16|l[9936]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=t,u[e+13|0]=t>>>8,u[e+14|0]=t>>>16,u[e+15|0]=t>>>24,K(m,4,0,_+4|0),u[_+15|0]>=0)break r;Z(i[_+4>>2]);break r}if(u[_+4|0]=0,u[_+15|0]=0,K(m,5,2002,_+4|0),u[_+15|0]>=0)break r;Z(i[_+4>>2])}if(v=_+16|0,r=i[o+52>>2],e=i[o+48>>2],i[o+80>>2]=e,i[o+84>>2]=r,u[o+99|0]<0&&(Z(i[o+88>>2]),e=i[o+80>>2]),r=i[o+60>>2],i[o+88>>2]=i[o+56>>2],i[o+92>>2]=r,i[o+96>>2]=i[o- -64>>2],!e){r:{f:{A:{if(r=i[C+480>>2],(r|0)!=i[C+484>>2])for(g=n+8|0,D0=f0+28|0,W0=i[25394],Q0=i[25395],H0=o+40|0,e=0;;){if(t=i[(e<<2)+r>>2],(t|0)==i[C+116>>2]){r=d2(o,24485),t=K(o+48|0,2,0,r),e=i[t+4>>2],i[n>>2]=i[t>>2],i[n+4>>2]=e;k:{if(u[t+19|0]>=0){e=i[t+12>>2],i[g>>2]=i[t+8>>2],i[g+4>>2]=e,i[g+8>>2]=i[t+16>>2],u[n+20|0]=1;break k}if(T(g,i[t+8>>2],i[t+12>>2]),e=u[t+19|0],u[n+20|0]=1,(e|0)>=0)break k;Z(i[t+8>>2])}if(u[r+11|0]>=0)break e;Z(i[r>>2]);break e}if(r=o+48|0,r4(r,i[C+100>>2],t,1),t=i[o+48>>2],i[o+72>>2]=t,i[o+76>>2]=i[o+52>>2],!t){e=r,r=d2(o,24440),t=K(e,2,2e3,r),e=i[t+4>>2],i[n>>2]=i[t>>2],i[n+4>>2]=e;k:{if(u[t+19|0]>=0){e=i[t+12>>2],i[g>>2]=i[t+8>>2],i[g+4>>2]=e,i[g+8>>2]=i[t+16>>2],u[n+20|0]=1;break k}if(T(g,i[t+8>>2],i[t+12>>2]),e=u[t+19|0],u[n+20|0]=1,(e|0)>=0)break k;Z(i[t+8>>2])}if(u[r+11|0]>=0)break r;Z(i[r>>2]);break r}if(X[i[i[t>>2]+52>>2]](o+48|0,t),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,u[o+67|0]>=0){e=i[o+60>>2],i[g>>2]=i[o+56>>2],i[g+4>>2]=e,i[g+8>>2]=i[o+64>>2],u[n+20|0]=1;break r}if(T(g,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[o+56>>2]);break r}if(u[o+67|0]<0&&Z(i[o+56>>2]),i[o+40>>2]=0,i[o+44>>2]=0,i[o+36>>2]=H0,s=i[o+72>>2],r=o+36|0,t8(r,i[k>>2],A0),t=o+48|0,X[i[i[s>>2]+100>>2]](t,s,f0,0,0,0,r),Y1(r,i[o+40>>2]),r=l[o+68|0],r){if((r|0)!=1)break f;U6(n,t),r=l[o+68|0],(r|0)!=255&&(e=i[25395],i[o>>2]=i[25394],i[o+4>>2]=e,X[i[o+(r<<2)>>2]](o+104|0,t)),V2(o+72|0);break e}if(r=i[o+48>>2],i[o+28>>2]=r,t=i[o+52>>2],i[o+32>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),!(i[r+116>>2]==1&i[r+120>>2]==3)){u[o+110|0]=1,Q[o+108>>1]=2,Q[o+104>>1]=2,Q[o+106>>1]=2,r6(o,o+28|0,1,3,o+104|0,0,D0,i[f0+48>>2],i[C+100>>2]- -64|0),t=l[o+20|0];k:{if(t){if((t|0)!=1)break f;if(r=i[o+4>>2],i[n>>2]=i[o>>2],i[n+4>>2]=r,u[o+19|0]>=0){r=i[o+12>>2],i[g>>2]=i[o+8>>2],i[g+4>>2]=r,i[g+8>>2]=i[o+16>>2],u[n+20|0]=1;break k}T(g,i[o+8>>2],i[o+12>>2]),u[n+20|0]=1;break k}if(r=i[o+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[o+28>>2]=i[o>>2],s=i[o+32>>2],i[o+32>>2]=r,!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break k;X[i[i[s>>2]+8>>2]](s),p(s)}if(r=l[o+20|0],(r|0)!=255&&(i[o+104>>2]=W0,i[o+108>>2]=Q0,X[i[(o+104|0)+(r<<2)>>2]](o+103|0,o)),t)break A}if(r=i[C+468>>2]+G(e,12)|0,x=i[r+4>>2],N=i[r+8>>2],V0=0,V=v-16|0,v=V,t=i[o+28>>2],L=V+8|0,i[V+4>>2]=L,i[V+8>>2]=0,i[V+12>>2]=0,s=i[t+124>>2],I=t+128|0,(s|0)!=(I|0)){for(;;){R=i[s+16>>2],W=L,r=W,t=i[V+8>>2];k:{n:{if(!t)break n;for(;;){if(r=t,t=i[r+16>>2],(t|0)>(R|0)){if(W=r,t=i[r>>2],t)continue;break n}if((t|0)>=(R|0))break k;if(t=i[r+4>>2],!t)break}W=r+4|0}t=E(20),i[t+8>>2]=r,i[t>>2]=0,i[t+4>>2]=0,i[t+16>>2]=R,i[W>>2]=t,r=i[i[V+4>>2]>>2],r&&(i[V+4>>2]=r),m1(i[V+8>>2],t),i[V+12>>2]=i[V+12>>2]+1}t=i[s+4>>2];k:{if(t){for(;;)if(r=t,t=i[r>>2],!t)break k}for(;r=i[s+8>>2],t=i[r>>2]!=(s|0),s=r,!!t;);}if(s=r,(r|0)==(I|0))break}t=i[o+28>>2]}r=i[t+128>>2];k:{if(!r){e0=1;break k}for(W=t+128|0,s=W,t=r;I=i[t+16>>2]<6,s=I?s:t,t=i[(I?4:0)+t>>2],!!t;);for(e0=(s|0)==(W|0)|i[s+16>>2]>6,t=W;s=i[r+16>>2]<6,t=s?t:r,r=i[(s?4:0)+r>>2],!!r;);if((t|0)==(W|0)|i[t+16>>2]>6)break k;V0=i[t+44>>2]}k:{n:{if(W=i[V+4>>2],(L|0)==(W|0)||(t=i[y+128>>2],!t))break n;for(r0=0-x|0,a=(x|0)>=0,$=a?0:r0,L0=a?0:x,q0=a?x:0,I=y+128|0,$0=N>>31,P0=x>>31,d0=N+1|0,N0=0-N|0,n0=(N|0)>=0,R=n0?0:N0,h0=n0?0:N,n2=R-h0|0,Z2=R+1|0,g2=N+R|0,Q2=h0-R|0;;){t:{if(!t)break t;for(B=i[W+16>>2],s=I,r=t;w=(B|0)>i[r+16>>2],s=w?s:r,r=i[(w?4:0)+r>>2],!!r;);if((s|0)==(I|0)|(B|0)<i[s+16>>2])break t;r=i[o+28>>2],m=r+128|0,w=m;u:{o:{if(s=i[r+128>>2],r=s,!r)break o;for(;_=(B|0)>i[r+16>>2],w=_?w:r,r=i[(_?4:0)+r>>2],!!r;);if((w|0)==(m|0))break o;if(S=0,r=0,(B|0)<i[w+16>>2])break u;S=i[w+56>>2],r=i[w+44>>2];break u}S=0,r=0}for(U0=r,w=I,r=t;_=(B|0)>i[r+16>>2],w=_?w:r,r=i[(_?4:0)+r>>2],!!r;);_=0;u:{if((w|0)==(I|0)){O=0,h=0;break u}if(O=0,h=0,(B|0)<i[w+16>>2])break u;O=i[w+56>>2],h=i[w+44>>2]}w=m,r=s,D=0;u:{if(!r)break u;for(;D=(B|0)>i[r+16>>2],w=D?w:r,r=i[(D?4:0)+r>>2],!!r;);for(_=(w|0)==(m|0)|(B|0)<i[w+16>>2]?_:i[w+28>>2],r=m;w=(B|0)>i[s+16>>2],r=w?r:s,s=i[(w?4:0)+s>>2],!!s;);if(D=0,(r|0)==(m|0)|(B|0)<i[r+16>>2])break u;D=i[r+32>>2]}for(s=I,r=t;w=(B|0)>i[r+16>>2],s=w?s:r,r=i[(w?4:0)+r>>2],!!r;);for(w=0,w=(s|0)==(I|0)|(B|0)<i[s+16>>2]?w:i[s+28>>2],r=I;s=(B|0)>i[t+16>>2],r=s?r:t,t=i[(s?4:0)+t>>2],!!t;);if(s=0,s=(r|0)==(I|0)|(B|0)<i[r+16>>2]?s:i[r+32>>2],!((x|0)<=0|w>>>0>x>>>0)){if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,t=o+8|0,u[107731]>=0){r=i[26931],i[t>>2]=i[26930],i[t+4>>2]=r,i[t+8>>2]=i[26932];break k}T(t,i[26930],i[26931]);break k}if(!(_>>>0>r0>>>0|a)){if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,t=o+8|0,u[107731]>=0){r=i[26931],i[t>>2]=i[26930],i[t+4>>2]=r,i[t+8>>2]=i[26932];break k}T(t,i[26930],i[26931]);break k}if(!((N|0)<=0|s>>>0>N>>>0)){if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,t=o+8|0,u[107731]>=0){r=i[26931],i[t>>2]=i[26930],i[t+4>>2]=r,i[t+8>>2]=i[26932];break k}T(t,i[26930],i[26931]);break k}if(!(D>>>0>N0>>>0|n0)){if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,t=o+8|0,u[107731]>=0){r=i[26931],i[t>>2]=i[26930],i[t+4>>2]=r,i[t+8>>2]=i[26932];break k}T(t,i[26930],i[26931]);break k}if(r=$0,m0=s-N|0,m=D,t=m+N|0,r=t>>>0<N>>>0?r+1|0:r,(r|0)>0?r=1:r=t>>>0>s>>>0&(r|0)>=0,m=r?m0:m,D=m+h0|0,D>>>0<=R>>>0)break t;if(r=P0,s=w-x|0,t=_+x|0,r=t>>>0<x>>>0?r+1|0:r,(r|0)>0?r=1:r=t>>>0>w>>>0&(r|0)>=0,B=(r?s:_)+L0|0,h=h+q0|0,e0){if(s=$+U0|0,r=R,m+Q2&1&&(B&&z(G(O,g2)+h|0,s+G(r,S)|0,B),r=Z2),(m-1|0)==(n2|0))break t;for(;t=!B,t||z(G(r+N|0,O)+h|0,s+G(r,S)|0,B),t||z(G(r+d0|0,O)+h|0,s+G(r+1|0,S)|0,B),r=r+2|0,(D|0)!=(r|0););break t}if(_=R,B>>>0<=$>>>0)break t;for(;;){for(m=G(_,S)+$|0,w=G(_+N|0,O)+h|0,r=$;t=r+w|0,m0=t,E2=l[t|0],s=r+m|0,t=l[s+V0|0],u[m0|0]=(G(E2,t^255)+G(t,l[s+U0|0])>>>0)/255,r=r+1|0,(B|0)!=(r|0););if(_=_+1|0,(D|0)==(_|0))break}}t=i[W+4>>2];t:{if(t){for(;;)if(r=t,t=i[r>>2],!t)break t}for(;r=i[W+8>>2],t=i[r>>2]!=(W|0),W=r,!!t;);}if((r|0)==(L|0))break n;t=i[I>>2],W=r}}if(r=i[26929],i[o>>2]=i[26928],i[o+4>>2]=r,t=o+8|0,u[107731]>=0){r=i[26931],i[t>>2]=i[26930],i[t+4>>2]=r,i[t+8>>2]=i[26932];break k}T(t,i[26930],i[26931])}if(Vi(V+4|0,i[V+8>>2]),v=V+16|0,t=i[o+4>>2],r=i[o>>2],i[o+80>>2]=r,i[o+84>>2]=t,u[o+99|0]<0&&(Z(i[o+88>>2]),r=i[o+80>>2]),t=i[o+12>>2],i[o+88>>2]=i[o+8>>2],i[o+92>>2]=t,i[o+96>>2]=i[o+16>>2],!(!r|(r|0)==2&i[o+84>>2]==122)){e=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=e;k:{if(u[o+99|0]>=0){e=i[o+92>>2],i[g>>2]=i[o+88>>2],i[g+4>>2]=e,i[g+8>>2]=i[o+96>>2];break k}T(g,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1,V2(o+28|0),r=l[o+68|0],(r|0)!=255&&(e=i[25395],i[o>>2]=i[25394],i[o+4>>2]=e,X[i[o+(r<<2)>>2]](o+104|0,o+48|0)),V2(o+72|0);break e}t=i[o+32>>2];k:{if(!t||(r=i[t+4>>2],i[t+4>>2]=r-1,r))break k;X[i[i[t>>2]+8>>2]](t),p(t)}r=l[o+68|0],(r|0)!=255&&(i[o>>2]=W0,i[o+4>>2]=Q0,X[i[o+(r<<2)>>2]](o+104|0,o+48|0)),t=i[o+76>>2];k:{if(!t||(r=i[t+4>>2],i[t+4>>2]=r-1,r))break k;X[i[i[t>>2]+8>>2]](t),p(t)}if(e=e+1|0,r=i[C+480>>2],!(e>>>0<i[C+484>>2]-r>>2>>>0))break}u[n+20|0]=0,i[n+4>>2]=A,i[n>>2]=y,A=0;break e}V2(o+28|0),r=l[o+68|0],(r|0)!=255&&(e=i[25395],i[o>>2]=i[25394],i[o+4>>2]=e,X[i[(r<<2)+o>>2]](o+104|0,o+48|0)),V2(o+72|0);break e}_2(),H()}V2(o+72|0);break e}e=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=e,r=n+8|0;r:{if(u[o+99|0]>=0){e=i[o+92>>2],i[r>>2]=i[o+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+96>>2];break r}T(r,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1}if(u[o+99|0]<0&&Z(i[o+88>>2]),!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=o+112|0,Y1(k,i[f+8>>2]),v=f+16|0}function K6(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0;_=v-192|0,v=_;i:{e:{r:{f:{A:{if(W=i[e+104>>2],e=i[e+108>>2],(W|0)!=(e|0))for(;;){if(i[W>>2]==(r|0))break A;if(W=W+32|0,(e|0)==(W|0))break}i[_+136>>2]=0,i[_+108>>2]=72244,i[_+52>>2]=72224,e=i[18065],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18066],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18068],f=i[18064],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18069],i[_+108>>2]=72244,i[_+44>>2]=72204,i[_+52>>2]=72224,f=R0(k),i[f>>2]=71280,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,Y(I0(Y(n,29218,13),r),18929,23),e=i[_+104>>2];k:{if(e&16){W=i[_+100>>2],e=i[_+80>>2],W>>>0<e>>>0&&(i[_+100>>2]=e,W=e),e=_+76|0;break k}if(!(e&8)){W=0,u[_+43|0]=0,r=_+32|0;break r}W=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],W=W-e|0,W>>>0>=2147483640)break i;if(W>>>0>=11){k=W|7,r=E(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=W;break f}if(u[_+43|0]=W,r=_+32|0,W)break f;W=0;break r}e=s,D=w;A:{k:{n:{t:{u:{o:{if(r=i[W+16>>2],a=i[W+20>>2],(r|0)!=(a|0))for(;;){l:{s:{w:switch(l[W+4|0]){case 0:I=i[r+8>>2];_:{B=i[r+12>>2];h:{if(B>>>0>8388607||(m=i[W+8>>2],g=i[W+12>>2],V=g,g>>>0>8388607))break h;if(g=i[r+16>>2],C=i[r+20>>2],C>>>0<8388608)break _}if(e=E(40),i[_+44>>2]=e,i[_+48>>2]=39,i[_+52>>2]=-2147483608,r=l[14035]|l[14036]<<8|(l[14037]<<16|l[14038]<<24),f=l[14031]|l[14032]<<8|(l[14033]<<16|l[14034]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[14066]|l[14067]<<8|(l[14068]<<16|l[14069]<<24),f=l[14062]|l[14063]<<8|(l[14064]<<16|l[14065]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[14059]|l[14060]<<8|(l[14061]<<16|l[14062]<<24),f=l[14055]|l[14056]<<8|(l[14057]<<16|l[14058]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[14051]|l[14052]<<8|(l[14053]<<16|l[14054]<<24),f=l[14047]|l[14048]<<8|(l[14049]<<16|l[14050]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[14043]|l[14044]<<8|(l[14045]<<16|l[14046]<<24),f=l[14039]|l[14040]<<8|(l[14041]<<16|l[14042]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,1e3,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}y=i[f>>2],B=B+V|0,R=m,m=m+I|0,B=C+(R>>>0>m>>>0?B+1|0:B)|0,m=m+g|0,B=m>>>0<g>>>0?B+1|0:B;_:switch((X[i[i[y>>2]+12>>2]](y,m,B)|0)-1|0){case 1:i[n+4>>2]=i[n>>2],i[_+108>>2]=72244,i[_+136>>2]=0,i[_+52>>2]=72224,e=i[18065],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18066],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18068],f=i[18064],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18069],i[_+108>>2]=72244,i[_+44>>2]=72204,i[_+52>>2]=72224,f=R0(k),i[f>>2]=71280,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,k=Y(Y(n,27657,58),27994,25),B=i[W+12>>2]+i[r+12>>2]|0,n=i[r+8>>2],e=n+i[W+8>>2]|0,Y(K2(k,e,e>>>0<n>>>0?B+1|0:B),42712,2),e=i[_+104>>2];h:{if(e&16){W=i[_+100>>2],e=i[_+80>>2],W>>>0<e>>>0&&(i[_+100>>2]=e,W=e),e=_+76|0;break h}if(!(e&8)){W=0,u[_+43|0]=0,r=_+32|0;break A}W=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],W=W-e|0,W>>>0>=2147483640)break i;if(W>>>0>=11){k=W|7,r=E(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=W;break k}if(u[_+43|0]=W,r=_+32|0,W)break k;W=0;break A;case 0:if(u[_+44|0]=0,u[_+55|0]=0,K(A,2,100,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e;default:break _}if(g=i[r+16>>2],I=i[r+20>>2],V=(I|0)==(o|0)&t>>>0>g>>>0|o>>>0>I>>>0,B=V?g:t,m=t-B|0,V=V?I:o,o=o-(V+(t>>>0<B>>>0)|0)|0,t=m,o|m||(m=g-B|0,g=I-((B>>>0>g>>>0)+V|0)|0,I=(D|0)==(g|0)&e>>>0<m>>>0|g>>>0>D>>>0,m=I?e:m,g=I?D:g,I=g,!(m|g)))break l;g=i[n+4>>2]-i[n>>2]|0;_:{if(t=i[h+40>>2],o=i[h+44>>2],!(t|o)||(y=o-(t>>>0<g>>>0)|0,(I|0)==(y|0)&m>>>0<=t-g>>>0|I>>>0<y>>>0))break _;i[_+136>>2]=0,i[_+108>>2]=72244,i[_+52>>2]=72224,e=i[18065],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18066],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18068],f=i[18064],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18069],i[_+108>>2]=72244,i[_+44>>2]=72204,i[_+52>>2]=72224,f=R0(k),i[f>>2]=71280,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,e=Y(K2(Y(n,29024,19),i[r+16>>2],i[r+20>>2]),28908,35),B=i[r+20>>2],r=g+i[r+16>>2]|0,B=r>>>0<g>>>0?B+1|0:B,Y(K2(Y(K2(e,r,B),28634,40),t,o),5240,6),e=i[_+104>>2];h:{if(e&16){W=i[_+100>>2],e=i[_+80>>2],W>>>0<e>>>0&&(i[_+100>>2]=e,W=e),e=_+76|0;break h}if(!(e&8)){W=0,u[_+43|0]=0,r=_+32|0;break n}W=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],W=W-e|0,W>>>0>=2147483640)break i;if(W>>>0>=11){k=W|7,r=E(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=W;break t}if(u[_+43|0]=W,r=_+32|0,W)break t;W=0;break n}if(C=i[f>>2],y=i[W+8>>2],t=V+i[r+12>>2]|0,o=B+i[r+8>>2]|0,B=i[W+12>>2]+(o>>>0<B>>>0?t+1|0:t)|0,t=o+y|0,o=t>>>0<o>>>0?B+1|0:B,B=I+o|0,V=t+m|0,B=V>>>0<m>>>0?B+1|0:B,V=X[i[i[C>>2]+24>>2]](C,t,o,V,B)|0,B=i[f>>2],!(l0|V)){if(e=i[B+8>>2],i[A>>2]=i[B+4>>2],i[A+4>>2]=e,A=A+8|0,u[B+23|0]>=0){e=i[B+16>>2],i[A>>2]=i[B+12>>2],i[A+4>>2]=e,i[A+8>>2]=i[B+20>>2];break e}T(A,i[B+12>>2],i[B+16>>2]);break e}if(!(X[i[i[B>>2]+20>>2]](B,t,o)|0)){if(e=A,A=d2(_+44|0,8155),K(e,2,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(gu(n,m+g|0),t=i[f>>2],X[i[i[t>>2]+16>>2]](t,g+i[n>>2]|0,m)|0)break s;if(e=A,A=d2(_+44|0,13233),K(e,2,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e;case 1:if(x=i[k>>2],!x){if(e=E(56),i[_+44>>2]=e,i[_+48>>2]=54,i[_+52>>2]=-2147483592,r=l[13262]|l[13263]<<8|(l[13264]<<16|l[13265]<<24),f=l[13258]|l[13259]<<8|(l[13260]<<16|l[13261]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[13308]|l[13309]<<8|(l[13310]<<16|l[13311]<<24),f=l[13304]|l[13305]<<8|(l[13306]<<16|l[13307]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[13302]|l[13303]<<8|(l[13304]<<16|l[13305]<<24),f=l[13298]|l[13299]<<8|(l[13300]<<16|l[13301]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[13294]|l[13295]<<8|(l[13296]<<16|l[13297]<<24),f=l[13290]|l[13291]<<8|(l[13292]<<16|l[13293]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[13286]|l[13287]<<8|(l[13288]<<16|l[13289]<<24),f=l[13282]|l[13283]<<8|(l[13284]<<16|l[13285]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[13278]|l[13279]<<8|(l[13280]<<16|l[13281]<<24),f=l[13274]|l[13275]<<8|(l[13276]<<16|l[13277]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13270]|l[13271]<<8|(l[13272]<<16|l[13273]<<24),f=l[13266]|l[13267]<<8|(l[13268]<<16|l[13269]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,103,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}S=_+12|0,m=i[r+8>>2],C=m+i[W+8>>2]|0,B=i[W+12>>2]+i[r+12>>2]|0,y=m>>>0>C>>>0?B+1|0:B,g=i[r+16>>2],V=i[r+20>>2],m=v-160|0,v=m,O=i[n+4>>2]-i[n>>2]|0,B=i[h+40>>2],I=B;_:{h:{B:{v:{Z:{G:{if(N=i[h+44>>2],!(N|B)||(R=B-O|0,B=N-(B>>>0<O>>>0)|0,(V|0)==(B|0)&g>>>0<=R>>>0|B>>>0>V>>>0))break G;i[m+104>>2]=0,i[m+76>>2]=72244,i[m+20>>2]=72224,B=i[18065],i[m+12>>2]=B,R=i[B-12>>2],B=m+12|0,i[R+B>>2]=i[18066],i[m+16>>2]=0,C=B+i[i[m+12>>2]-12>>2]|0,y=m+24|0,J0(C,y),u[C+80|0]=0,i[C+72>>2]=0,C=i[18067],i[m+20>>2]=C,R=m+20|0,i[R+i[C-12>>2]>>2]=i[18068],C=i[18064],i[m+12>>2]=C,i[B+i[C-12>>2]>>2]=i[18069],i[m+76>>2]=72244,i[m+12>>2]=72204,i[m+20>>2]=72224,C=R0(y),i[C>>2]=71280,B=m- -64|0,i[B>>2]=0,i[B+4>>2]=0,i[m+56>>2]=0,i[m+60>>2]=0,i[m+72>>2]=24,y=Y(K2(Y(R,29004,19),g,V),28908,35),B=V,g=g+O|0,B=g>>>0<O>>>0?B+1|0:B,Y(K2(Y(K2(y,g,B),28634,40),I,N),5240,6),B=i[m+72>>2];m:{if(B&16){g=m+44|0,I=i[m+68>>2],B=i[m+48>>2],I>>>0<B>>>0?i[m+68>>2]=B:B=I;break m}if(!(B&8)){B=0,u[m+11|0]=0,g=m;break h}g=m+32|0,B=i[m+40>>2]}if(I=i[g>>2],B=B-I|0,B>>>0>=2147483640)break Z;if(B>>>0>=11){V=B|7,g=E(V+1|0),i[m+8>>2]=V-2147483647,i[m>>2]=g,i[m+4>>2]=B;break B}if(u[m+11|0]=B,g=m,B)break B;B=0;break h}if(I=i[x+8>>2],N=i[x+112>>2],L=I+N|0,R=i[x+12>>2],$=i[x+116>>2],B=R+$|0,B=N>>>0>L>>>0?B+1|0:B,(y|0)==(B|0)&C>>>0>L>>>0|B>>>0<y>>>0){if(u[m+12|0]=0,u[m+23|0]=0,K(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}G:{if(B=R,(B|0)==(V|0)&g>>>0<=I>>>0|B>>>0>V>>>0&&(R=I,I=B,B=V+y|0,L=g+C|0,B=L>>>0<C>>>0?B+1|0:B,f0=R,R=L,(B|0)==(I|0)&f0>>>0>=R>>>0|B>>>0<I>>>0))break G;if(u[m+12|0]=0,u[m+23|0]=0,K(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}if(I=i[f>>2],B=B+$|0,N=N+R|0,B=N>>>0<R>>>0?B+1|0:B,((X[i[i[I>>2]+12>>2]](I,N,B)|0)-1&255)>>>0<=1){if(u[m+12|0]=0,u[m+23|0]=0,K(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}if(I=i[f>>2],B=y+i[x+116>>2]|0,R=C,C=C+i[x+112>>2]|0,B=R>>>0>C>>>0?B+1|0:B,X[i[i[I>>2]+20>>2]](I,C,B)|0,g|V){B=g+O|0,y=i[n+4>>2],I=i[n>>2],V=y-I|0;G:{if(B>>>0>V>>>0){if(C=B-V|0,N=i[n+8>>2],C>>>0<=N-y>>>0){C&&o0(y,0,C),i[n+4>>2]=C+y;break G}if((B|0)<0)break v;if(y=N-I|0,N=y<<1,N=y>>>0>=1073741823?2147483647:B>>>0<N>>>0?N:B,y=E(N),C&&o0(V+y|0,0,C),V&&z(y,I,V),i[n+8>>2]=y+N,i[n+4>>2]=B+y,i[n>>2]=y,!I)break G;Z(I);break G}if(B>>>0>=V>>>0)break G;i[n+4>>2]=B+I}B=i[f>>2],X[i[i[B>>2]+16>>2]](B,i[n>>2]+O|0,g)|0}if(B=i[26929],i[S>>2]=i[26928],i[S+4>>2]=B,B=S+8|0,u[107731]>=0){g=i[26931],i[B>>2]=i[26930],i[B+4>>2]=g,i[B+8>>2]=i[26932];break _}T(B,i[26930],i[26931]);break _}g0(),H()}G0(),H()}if(!B)break h;z(g,I,B)}u[B+g|0]=0,K(S,6,1e3,m),u[m+11|0]<0&&Z(i[m>>2]),B=i[18063],i[m+12>>2]=B,i[i[B-12>>2]+(m+12|0)>>2]=i[18071],i[m+20>>2]=i[18072],i[C>>2]=71280,u[m+67|0]<0&&Z(i[m+56>>2]),y0(C),p0(m+76|0)}v=m+160|0,u[_+31|0]<0&&Z(i[_+20>>2]),B=e,m=i[r+16>>2],e=e-m|0,D=D-(i[r+20>>2]+(B>>>0<m>>>0)|0)|0;break l;default:break w}i[_+136>>2]=0,i[_+108>>2]=72244,i[_+52>>2]=72224,e=i[18065],i[_+44>>2]=e,r=i[e-12>>2],e=_+44|0,i[r+e>>2]=i[18066],i[_+48>>2]=0,r=e+i[i[_+44>>2]-12>>2]|0,f=_+56|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[_+52>>2]=r,k=_+52|0,i[k+i[r-12>>2]>>2]=i[18068],r=i[18064],i[_+44>>2]=r,i[e+i[r-12>>2]>>2]=i[18069],i[_+108>>2]=72244,i[_+44>>2]=72204,i[_+52>>2]=72224,r=R0(f),i[r>>2]=71280,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,Y(S0(Y(k,28944,25),l[W+4|0]),16521,16),e=i[_+104>>2];w:{if(e&16){W=i[_+100>>2],e=i[_+80>>2],W>>>0<e>>>0&&(i[_+100>>2]=e,W=e),e=_+76|0;break w}if(!(e&8)){W=0,u[_+43|0]=0,e=_+32|0;break u}W=i[_+72>>2],e=_- -64|0}if(f=i[e>>2],W=W-f|0,W>>>0>=2147483640)break i;if(W>>>0>=11){k=W|7,e=E(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=e,i[_+36>>2]=W;break o}if(u[_+43|0]=W,e=_+32|0,W)break o;W=0;break u}t=e,e=e-m|0,D=D-((t>>>0<m>>>0)+I|0)|0,t=0,o=0}if(r=r+40|0,(a|0)==(r|0))break}if(!(!(e|D)|(s&w)==-1)){if(e=E(56),i[_+44>>2]=e,i[_+48>>2]=53,i[_+52>>2]=-2147483592,r=l[23310]|l[23311]<<8|(l[23312]<<16|l[23313]<<24),f=l[23306]|l[23307]<<8|(l[23308]<<16|l[23309]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+53|0]=0,r=l[23355]|l[23356]<<8|(l[23357]<<16|l[23358]<<24),f=l[23351]|l[23352]<<8|(l[23353]<<16|l[23354]<<24),u[e+45|0]=f,u[e+46|0]=f>>>8,u[e+47|0]=f>>>16,u[e+48|0]=f>>>24,u[e+49|0]=r,u[e+50|0]=r>>>8,u[e+51|0]=r>>>16,u[e+52|0]=r>>>24,r=l[23350]|l[23351]<<8|(l[23352]<<16|l[23353]<<24),f=l[23346]|l[23347]<<8|(l[23348]<<16|l[23349]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[23342]|l[23343]<<8|(l[23344]<<16|l[23345]<<24),f=l[23338]|l[23339]<<8|(l[23340]<<16|l[23341]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[23334]|l[23335]<<8|(l[23336]<<16|l[23337]<<24),f=l[23330]|l[23331]<<8|(l[23332]<<16|l[23333]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23326]|l[23327]<<8|(l[23328]<<16|l[23329]<<24),f=l[23322]|l[23323]<<8|(l[23324]<<16|l[23325]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23318]|l[23319]<<8|(l[23320]<<16|l[23321]<<24),f=l[23314]|l[23315]<<8|(l[23316]<<16|l[23317]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,100,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931]);break e}if(!W)break u;z(e,f,W)}u[e+W|0]=0,K(A,4,3004,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18063],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18071],i[_+52>>2]=i[18072],i[r>>2]=71280,u[_+99|0]<0&&Z(i[_+88>>2]),y0(r),p0(_+108|0);break e}if(!W)break n;z(r,e,W)}u[r+W|0]=0,K(A,6,1e3,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18063],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18071],i[_+52>>2]=i[18072],i[f>>2]=71280,u[_+99|0]<0&&Z(i[_+88>>2]),y0(f),p0(_+108|0);break e}if(!W)break A;z(r,e,W)}u[r+W|0]=0,K(A,2,100,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18063],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18071],i[_+52>>2]=i[18072],i[f>>2]=71280,u[_+99|0]<0&&Z(i[_+88>>2]),y0(f),p0(_+108|0);break e}if(!W)break r;z(r,e,W)}u[r+W|0]=0,K(A,2,117,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18063],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18071],i[_+52>>2]=i[18072],i[f>>2]=71280,u[_+99|0]<0&&Z(i[_+88>>2]),y0(f),p0(_+108|0)}v=_+192|0;return}g0(),H()}function J7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0;I=v+-64|0,v=I;i:{e:{r:{f:{A:{k:{n:{t:switch(i[e+120>>2]-1|0){case 1:if((r|0)<=179){if(!r)break A;if((r|0)==90)break n;break r}if((r|0)==270)break n;if((r|0)!=180)break r;if(k=i[e+112>>2],k&1)break n;n=i[e+108>>2];break e;case 0:break t;default:break k}if((r|0)<=179){if(!r)break A;if((r|0)!=90)break r;if(k=i[e+108>>2],k&1)break n;n=i[e+112>>2];break e}if((r|0)!=180){if((r|0)!=270)break r;if(n=i[e+112>>2],n&1)break n;k=i[e+108>>2];break e}if(n=i[e+108>>2],n&1)break n;if(k=i[e+112>>2],!(k&1))break e}if(i[I+48>>2]=0,i[I+52>>2]=0,i[I+40>>2]=0,i[I+44>>2]=0,u[I+52|0]=1,i[I+44>>2]=2,i[I+48>>2]=2,u[I+40|0]=1,i[I+56>>2]=i[e+84>>2],k=i[e+88>>2],!k||(k=Gi(k),i[I+60>>2]=k,!k))break f;i[I+8>>2]=131074,i[I+12>>2]=65538,k=255,t=i[e+128>>2];n:{if(!t)break n;for(e=e+128|0,n=e;L=i[t+16>>2],n=(L|0)<0?n:t,t=i[(L>>>29&4)+t>>2],!!t;);if((e|0)==(n|0)|i[n+16>>2]>0)break n;k=l[n+24|0]}r6(I+16|0,I+56|0,0,3,I+8|0,k,I+40|0,0,f),e=i[I+60>>2];n:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break n;X[i[i[e>>2]+8>>2]](e),p(e)}n:{t:switch(l[I+36|0]){default:_2(),H();case 1:e=i[I+20>>2],i[A>>2]=i[I+16>>2],i[A+4>>2]=e,e=A+8|0;u:{if(u[I+35|0]>=0){r=i[I+28>>2],i[e>>2]=i[I+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[I+32>>2];break u}T(e,i[I+24>>2],i[I+28>>2])}u[A+20|0]=1;break n;case 0:break t}J7(A,i[I+16>>2],r,f)}if(A=l[I+36|0],(A|0)==255)break i;e=i[23829],i[I+56>>2]=i[23828],i[I+60>>2]=e,X[i[(I+56|0)+(A<<2)>>2]](I+8|0,I+16|0);break i}if(r)break r}if(r=i[e+88>>2],!r||(e=i[e+84>>2],r=Gi(r),!r))break f;u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break i}g3(),H()}if(n=i[e+112>>2],t=i[e+108>>2],!((r|0)==270|(r|0)==90)){k=n,n=t;break e}k=t}D=E(172),t=D,i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94860,o0(t+16|0,0,80),o=i[t+4>>2],_=o+1|0,i[t+4>>2]=_,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,L=t+140|0,i[t+136>>2]=L,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=o,o=i[t+8>>2],a=t+12|0,i[t+96>>2]=a,i[t+8>>2]=o+1,i[t+100>>2]=t,_||(X[i[i[t>>2]+8>>2]](t),p(t)),t=i[e+120>>2],o=i[e+116>>2],i[D+124>>2]=k,i[D+128>>2]=o,i[D+132>>2]=t,i[D+120>>2]=n;e:{if(t=i[e+124>>2],A0=e+128|0,(t|0)!=(A0|0))for(f0=A+8|0,h0=(r|0)==270,m0=(r|0)!=90;;){o=i[t+32>>2],n=i[t+28>>2];r:{if(!(!m0|h0)){k=n,n=o;break r}k=o}o=i[t+16>>2],Sf(I+16|0,a,o,k,n,i[t+20>>2],l[t+24|0],f),n0=i[I+16>>2];r:{if(n0){if(k=i[I+20>>2],i[A>>2]=i[I+16>>2],i[A+4>>2]=k,u[I+35|0]>=0){k=i[I+28>>2],i[f0>>2]=i[I+24>>2],i[f0+4>>2]=k,i[f0+8>>2]=i[I+32>>2],u[A+20|0]=1;break r}T(f0,i[I+24>>2],i[I+28>>2]),u[A+20|0]=1;break r}k=L,n=i[k>>2];f:{A:{if(!n)break A;for(;_=(o|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((k|0)==(L|0))break A;if((o|0)>=i[k+16>>2])break f}k=L}if(n=l[t+24|0],n>>>0<=8){o=0,N=i[k+44>>2],_=i[k+56>>2],y=i[t+44>>2],m=i[t+56>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(g=k+y|0,W=k&-4,y=k&3,R=k>>>0<4;;){if(s=o+N|0,h=g+G(o,m)|0,k=0,n=0,!R)for(;u[s+G(k,_)|0]=l[h+(k^-1)|0],u[s+G(_,k|1)|0]=l[h+(k^-2)|0],u[s+G(_,k|2)|0]=l[h+(k^-3)|0],u[s+G(_,k|3)|0]=l[h+(k^-4)|0],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,y)for(;u[s+G(k,_)|0]=l[h+(k^-1)|0],k=k+1|0,n=n+1|0,(y|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(g=k+y|0,W=k&-4,y=k&3,R=k>>>0<4;;){if(s=N+G(o,_)|0,h=g+G(m,B+(o^-1)|0)|0,k=0,!R)for(w=s+3|0,V=s+2|0,C=s+1|0,n=0;u[k+s|0]=l[h+(k^-1)|0],u[k+C|0]=l[h+(k^-2)|0],u[k+V|0]=l[h+(k^-3)|0],u[k+w|0]=l[h+(k^-4)|0],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,y)for(;u[k+s|0]=l[h+(k^-1)|0],k=k+1|0,n=n+1|0,(y|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=k&-4,g=k&3,R=k-1>>>0<3;;){if(s=o+N|0,h=y+G(m,B+(o^-1)|0)|0,k=0,n=0,!R)for(;u[s+G(k,_)|0]=l[k+h|0],w=k|1,u[s+G(w,_)|0]=l[h+w|0],w=k|2,u[s+G(w,_)|0]=l[h+w|0],w=k|3,u[s+G(w,_)|0]=l[h+w|0],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,g)for(;u[s+G(k,_)|0]=l[k+h|0],k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=16){o=0,_=i[k+56>>2]>>>1|0,N=i[t+56>>2]>>>1|0,y=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(g=m+(k<<1)|0,W=k&-4,m=k&3,R=k>>>0<4;;){if(s=y+(o<<1)|0,h=g+(G(o,N)<<1)|0,k=0,n=0,!R)for(;Q[s+(G(k,_)<<1)>>1]=F[h+((k^-1)<<1)>>1],Q[s+(G(_,k|1)<<1)>>1]=F[h+((k^2147483646)<<1)>>1],Q[s+(G(_,k|2)<<1)>>1]=F[h+((k^2147483645)<<1)>>1],Q[s+(G(_,k|3)<<1)>>1]=F[h+((k^2147483644)<<1)>>1],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,m)for(;Q[s+(G(k,_)<<1)>>1]=F[h+((k^-1)<<1)>>1],k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=m+(k<<1)|0,R=k&-4,g=k&3,w=k>>>0<4;;){if(s=y+(G(o,_)<<1)|0,h=W+(G(N,B+(o^-1)|0)<<1)|0,k=0,!w)for(V=s+6|0,C=s+4|0,S=s+2|0,n=0;m=k<<1,Q[m+s>>1]=F[h+((k^-1)<<1)>>1],Q[m+S>>1]=F[h+((k^2147483646)<<1)>>1],Q[m+C>>1]=F[h+((k^2147483645)<<1)>>1],Q[m+V>>1]=F[h+((k^2147483644)<<1)>>1],k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,g)for(;Q[s+(k<<1)>>1]=F[h+((k^-1)<<1)>>1],k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=k&-4,g=k&3,R=k-1>>>0<3;;){if(s=y+(o<<1)|0,h=m+(G(N,B+(o^-1)|0)<<1)|0,k=0,n=0,!R)for(;Q[s+(G(k,_)<<1)>>1]=F[h+(k<<1)>>1],w=k|1,Q[s+(G(w,_)<<1)>>1]=F[h+(w<<1)>>1],w=k|2,Q[s+(G(w,_)<<1)>>1]=F[h+(w<<1)>>1],w=k|3,Q[s+(G(w,_)<<1)>>1]=F[h+(w<<1)>>1],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,g)for(;Q[s+(G(k,_)<<1)>>1]=F[h+(k<<1)>>1],k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=32){o=0,_=i[k+56>>2]>>>2|0,N=i[t+56>>2]>>>2|0,y=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(g=m+(k<<2)|0,W=k&-4,m=k&3,R=k>>>0<4;;){if(s=y+(o<<2)|0,h=g+(G(o,N)<<2)|0,k=0,n=0,!R)for(;i[s+(G(k,_)<<2)>>2]=i[h+((k^-1)<<2)>>2],i[s+(G(_,k|1)<<2)>>2]=i[h+((k^1073741822)<<2)>>2],i[s+(G(_,k|2)<<2)>>2]=i[h+((k^1073741821)<<2)>>2],i[s+(G(_,k|3)<<2)>>2]=i[h+((k^1073741820)<<2)>>2],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,m)for(;i[s+(G(k,_)<<2)>>2]=i[h+((k^-1)<<2)>>2],k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=m+(k<<2)|0,R=k&-4,g=k&3,w=k>>>0<4;;){if(s=y+(G(o,_)<<2)|0,h=W+(G(N,B+(o^-1)|0)<<2)|0,k=0,!w)for(V=s+12|0,C=s+8|0,S=s+4|0,n=0;m=k<<2,i[m+s>>2]=i[h+((k^-1)<<2)>>2],i[m+S>>2]=i[h+((k^1073741822)<<2)>>2],i[m+C>>2]=i[h+((k^1073741821)<<2)>>2],i[m+V>>2]=i[h+((k^1073741820)<<2)>>2],k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,g)for(;i[s+(k<<2)>>2]=i[h+((k^-1)<<2)>>2],k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=k&-4,g=k&3,R=k-1>>>0<3;;){if(s=y+(o<<2)|0,h=m+(G(N,B+(o^-1)|0)<<2)|0,k=0,n=0,!R)for(;i[s+(G(k,_)<<2)>>2]=i[h+(k<<2)>>2],w=k|1,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],w=k|2,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],w=k|3,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,g)for(;i[s+(G(k,_)<<2)>>2]=i[h+(k<<2)>>2],k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=64){o=0,_=i[k+56>>2]>>>3|0,N=i[t+56>>2]>>>3|0,y=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(g=m+(k<<3)|0,W=k&-4,m=k&3,R=k>>>0<4;;){if(s=y+(o<<3)|0,h=g+(G(o,N)<<3)|0,k=0,n=0,!R)for(;V=h+((k^-1)<<3)|0,C=i[V+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,V=h+((k^536870910)<<3)|0,C=i[V+4>>2],w=s+(G(_,k|1)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,V=h+((k^536870909)<<3)|0,C=i[V+4>>2],w=s+(G(_,k|2)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,V=h+((k^536870908)<<3)|0,C=i[V+4>>2],w=s+(G(_,k|3)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,m)for(;V=h+((k^-1)<<3)|0,C=i[V+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=m+(k<<3)|0,R=k&-4,g=k&3,w=k>>>0<4;;){if(s=y+(G(o,_)<<3)|0,h=W+(G(N,B+(o^-1)|0)<<3)|0,k=0,!w)for(V=s+24|0,C=s+16|0,S=s+8|0,n=0;O=h+((k^-1)<<3)|0,$=i[O+4>>2],m=k<<3,x=m+s|0,i[x>>2]=i[O>>2],i[x+4>>2]=$,O=h+((k^536870910)<<3)|0,$=i[O+4>>2],x=m+S|0,i[x>>2]=i[O>>2],i[x+4>>2]=$,O=h+((k^536870909)<<3)|0,$=i[O+4>>2],x=m+C|0,i[x>>2]=i[O>>2],i[x+4>>2]=$,x=h+((k^536870908)<<3)|0,O=i[x+4>>2],m=m+V|0,i[m>>2]=i[x>>2],i[m+4>>2]=O,k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,g)for(;V=h+((k^-1)<<3)|0,C=i[V+4>>2],m=s+(k<<3)|0,i[m>>2]=i[V>>2],i[m+4>>2]=C,k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(W=k&-4,g=k&3,R=k-1>>>0<3;;){if(s=y+(o<<3)|0,h=m+(G(N,B+(o^-1)|0)<<3)|0,k=0,n=0,!R)for(;V=h+(k<<3)|0,C=i[V+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,w=k|1,V=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,C=i[w+4>>2],i[V>>2]=i[w>>2],i[V+4>>2]=C,w=k|2,V=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,C=i[w+4>>2],i[V>>2]=i[w>>2],i[V+4>>2]=C,w=k|3,V=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,C=i[w+4>>2],i[V>>2]=i[w>>2],i[V+4>>2]=C,k=k+4|0,n=n+4|0,(W|0)!=(n|0););if(n=0,g)for(;V=h+(k<<3)|0,C=i[V+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[V>>2],i[w+4>>2]=C,k=k+1|0,n=n+1|0,(g|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0>128)break r;s=i[k+56>>2]>>>4|0,h=i[t+56>>2]>>>4|0,N=i[k+44>>2],y=i[t+44>>2],_=i[t+32>>2],n=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!n|(!_|(r|0)!=90))break f;for(R=y+(n<<4)|0,w=n&-2,V=n&1,o=0;;){if(y=N+(o<<4)|0,m=R+(G(o,h)<<4)|0,k=0,B=0,(n|0)!=1)for(;g=m+((k^-1)<<4)|0,C=i[g+4>>2],W=y+(G(k,s)<<4)|0,i[W>>2]=i[g>>2],i[W+4>>2]=C,C=i[g+12>>2],i[W+8>>2]=i[g+8>>2],i[W+12>>2]=C,g=m+((k^268435454)<<4)|0,C=i[g+12>>2],W=y+(G(s,k|1)<<4)|0,i[W+8>>2]=i[g+8>>2],i[W+12>>2]=C,C=i[g+4>>2],i[W>>2]=i[g>>2],i[W+4>>2]=C,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(V&&(B=y+(G(k,s)<<4)|0,k=m+((k^-1)<<4)|0,y=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=y,y=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=y),o=o+1|0,(_|0)==(o|0))break}break f}if(!_|!n)break f;for(R=y+(n<<4)|0,w=n&-2,V=n&1,o=0;;){if(y=N+(G(s,o)<<4)|0,m=R+(G(h,_+(o^-1)|0)<<4)|0,k=0,(n|0)!=1)for(C=y+16|0,B=0;g=m+((k^-1)<<4)|0,x=i[g+4>>2],S=k<<4,W=S+y|0,i[W>>2]=i[g>>2],i[W+4>>2]=x,x=i[g+12>>2],i[W+8>>2]=i[g+8>>2],i[W+12>>2]=x,W=C+S|0,g=m+((k^268435454)<<4)|0,S=i[g+12>>2],i[W+8>>2]=i[g+8>>2],i[W+12>>2]=S,S=i[g+4>>2],i[W>>2]=i[g>>2],i[W+4>>2]=S,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(V&&(B=y+(k<<4)|0,k=m+((k^-1)<<4)|0,y=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=y,y=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=y),o=o+1|0,(_|0)==(o|0))break}break f}if(!_|!n)break f;for(w=n&-2,V=n&1,o=0;;){if(m=N+(o<<4)|0,g=y+(G(h,_+(o^-1)|0)<<4)|0,k=0,B=0,(n|0)!=1)for(;W=g+(k<<4)|0,C=i[W+4>>2],R=m+(G(k,s)<<4)|0,i[R>>2]=i[W>>2],i[R+4>>2]=C,C=i[W+12>>2],i[R+8>>2]=i[W+8>>2],i[R+12>>2]=C,W=k|1,R=m+(G(W,s)<<4)|0,W=g+(W<<4)|0,C=i[W+12>>2],i[R+8>>2]=i[W+8>>2],i[R+12>>2]=C,C=i[W+4>>2],i[R>>2]=i[W>>2],i[R+4>>2]=C,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(V&&(B=m+(G(k,s)<<4)|0,k=g+(k<<4)|0,m=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=m,m=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=m),o=o+1|0,(_|0)==(o|0))break}}}if(u[I+35|0]<0&&Z(i[I+24>>2]),n0)break e;k=t,n=i[k+4>>2];r:{if(n){for(;;)if(t=n,n=i[n>>2],!n)break r}for(;t=i[k+8>>2],n=i[t>>2]!=(k|0),k=t,!!n;);}if((t|0)==(A0|0))break}if(r=F[e+10>>1]|F[e+12>>1]<<16,i[I+16>>2]=F[e+6>>1]|F[e+8>>1]<<16,i[I+20>>2]=r,X[i[i[a>>2]+8>>2]](a,I+16|0),X[i[i[a>>2]+12>>2]](a,e+16|0),n=i[e+148>>2],r=i[e+152>>2],(n|0)!=(r|0))for(f=D+160|0,t=i[D+164>>2];;){r:{if(u0[D+168>>2]>t>>>0){if(e=i[n+4>>2],i[t>>2]=i[n>>2],i[t+4>>2]=e,e=t+8|0,u[n+19|0]>=0){k=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=k,i[e+8>>2]=i[n+16>>2],t=t+20|0;break r}T(e,i[n+8>>2],i[n+12>>2]),t=t+20|0;break r}t=fi(f,n)}if(i[D+164>>2]=t,n=n+20|0,(r|0)==(n|0))break}u[A+20|0]=0,i[A+4>>2]=D,i[A>>2]=a;break i}if(A=i[D+4>>2],i[D+4>>2]=A-1,A)break i;X[i[i[D>>2]+8>>2]](D),p(D)}v=I- -64|0}function Bf(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0;B=v-16|0,v=B,t=E(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94860,o0(t+16|0,0,80),h=i[t+4>>2],o=h+1|0,i[t+4>>2]=o,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,i[t+136>>2]=t+140,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=h,h=i[t+8>>2],s=t+12|0,i[t+96>>2]=s,i[t+8>>2]=h+1,i[t+100>>2]=t,o||(X[i[i[t>>2]+8>>2]](t),p(t)),i[r>>2]=s,h=i[r+4>>2],i[r+4>>2]=t;i:{if(!h||(t=i[h+4>>2],i[h+4>>2]=t-1,t))break i;X[i[i[h>>2]+8>>2]](h),p(h)}I=i[e+116>>2],m=i[r>>2],W=i[e+120>>2],i[m+120>>2]=W,i[m+116>>2]=I,i[m+112>>2]=k,i[m+108>>2]=f;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(s=i[e+128>>2],s){for(h=e+128|0,o=h,t=s;w=i[t+16>>2]<10,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if(!((o|0)==(h|0)|i[o+16>>2]>10)){for(t=h;o=i[s+16>>2]<10,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,T0(A,m,10,f,k,(t|0)==(h|0)|i[t+16>>2]>10?o:l[t+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2]);break e}switch(_=h,t=s,o=t,w=t,I|0){case 0:break t;case 1:break s;case 2:break o;default:break A}}switch(I|0){case 1:break l;case 2:break u;case 0:break n;default:break A}}for(;o=i[t+16>>2]<3,_=o?_:t,t=i[(o?4:0)+t>>2],!!t;);if((h|0)==(_|0)|i[_+16>>2]>3)break l;for(o=h,t=s;w=i[t+16>>2]<4,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>4)break l;for(o=h,t=s;w=i[t+16>>2]<5,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>=6)break l;for(t=h;o=i[s+16>>2]<3,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,T0(A,m,3,f,k,(t|0)==(h|0)|i[t+16>>2]>3?o:l[t+24|0],n),i[A>>2]||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],4,f,k,j0(e,4),n),i[A>>2])||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],5,f,k,j0(e,5),n),i[A>>2]))break i;if(u[A+19|0]>=0)break r;Z(i[A+8>>2]);break r}if(e=E(32),i[B+4>>2]=e,i[B+8>>2]=31,i[B+12>>2]=-2147483616,r=l[5334]|l[5335]<<8|(l[5336]<<16|l[5337]<<24),f=l[5330]|l[5331]<<8|(l[5332]<<16|l[5333]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[5357]|l[5358]<<8|(l[5359]<<16|l[5360]<<24),f=l[5353]|l[5354]<<8|(l[5355]<<16|l[5356]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[5350]|l[5351]<<8|(l[5352]<<16|l[5353]<<24),f=l[5346]|l[5347]<<8|(l[5348]<<16|l[5349]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5342]|l[5343]<<8|(l[5344]<<16|l[5345]<<24),f=l[5338]|l[5339]<<8|(l[5340]<<16|l[5341]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;t=i[o+16>>2],_=(t|0)<0?_:o,o=i[(t>>>29&4)+o>>2],!!o;);if((h|0)==(_|0)|i[_+16>>2]>0)break u;for(t=h;o=i[s+16>>2],t=(o|0)<0?t:s,s=i[(o>>>29&4)+s>>2],!!s;);if(o=255,T0(A,m,0,f,k,(t|0)==(h|0)|i[t+16>>2]>0?o:l[t+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break r;Z(i[A+8>>2]);break r}if(e=E(40),i[B+4>>2]=e,i[B+8>>2]=32,i[B+12>>2]=-2147483608,r=l[12942]|l[12943]<<8|(l[12944]<<16|l[12945]<<24),f=l[12938]|l[12939]<<8|(l[12940]<<16|l[12941]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+32|0]=0,r=l[12966]|l[12967]<<8|(l[12968]<<16|l[12969]<<24),f=l[12962]|l[12963]<<8|(l[12964]<<16|l[12965]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12958]|l[12959]<<8|(l[12960]<<16|l[12961]<<24),f=l[12954]|l[12955]<<8|(l[12956]<<16|l[12957]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12950]|l[12951]<<8|(l[12952]<<16|l[12953]<<24),f=l[12946]|l[12947]<<8|(l[12948]<<16|l[12949]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;t=i[w+16>>2],_=(t|0)<0?_:w,w=i[(t>>>29&4)+w>>2],!!w;);if((h|0)==(_|0)|i[_+16>>2]>0)break n;for(t=h;o=i[s+16>>2]<=0,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if((t|0)==(h|0)|i[t+16>>2]>1)break n;if(u1(e,2))break k}if(e=E(40),i[B+4>>2]=e,i[B+8>>2]=34,i[B+12>>2]=-2147483608,r=l[5299]|l[5300]<<8|(l[5301]<<16|l[5302]<<24),f=l[5295]|l[5296]<<8|(l[5297]<<16|l[5298]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+34|0]=0,r=l[5327]|l[5328]<<8,u[e+32|0]=r,u[e+33|0]=r>>>8,r=l[5323]|l[5324]<<8|(l[5325]<<16|l[5326]<<24),f=l[5319]|l[5320]<<8|(l[5321]<<16|l[5322]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5315]|l[5316]<<8|(l[5317]<<16|l[5318]<<24),f=l[5311]|l[5312]<<8|(l[5313]<<16|l[5314]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5307]|l[5308]<<8|(l[5309]<<16|l[5310]<<24),f=l[5303]|l[5304]<<8|(l[5305]<<16|l[5306]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}if(LA(f,k,1,W,B+4|0,B),T0(A,i[r>>2],0,f,k,j0(e,0),n),i[A>>2]||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],1,i[B+4>>2],i[B>>2],j0(e,1),n),i[A>>2]))break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],2,i[B+4>>2],i[B>>2],j0(e,2),n),t=i[A>>2],t|u[A+19|0]>=0)break f;Z(i[A+8>>2]);break r}if(e=E(32),i[B+4>>2]=e,i[B+8>>2]=27,i[B+12>>2]=-2147483616,r=l[8299]|l[8300]<<8|(l[8301]<<16|l[8302]<<24),f=l[8295]|l[8296]<<8|(l[8297]<<16|l[8298]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[8318]|l[8319]<<8|(l[8320]<<16|l[8321]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[8315]|l[8316]<<8|(l[8317]<<16|l[8318]<<24),f=l[8311]|l[8312]<<8|(l[8313]<<16|l[8314]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8307]|l[8308]<<8|(l[8309]<<16|l[8310]<<24),f=l[8303]|l[8304]<<8|(l[8305]<<16|l[8306]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}if(t)break i}if(t=i[h>>2],!t)break e;for(o=h;s=i[t+16>>2]<6,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>6)break e;if(T0(A,i[r>>2],6,f,k,j0(e,6),n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}n=1;e:{r:switch(i[e+120>>2]){case 10:case 12:case 14:n=3;break e;case 11:case 13:case 15:n=4;break e;case 0:case 1:case 2:case 3:case 99:break e;default:break r}n=0}e:{r:{if(n>>>0>=2){t=i[h>>2];f:{A:{if(!t)break A;for(w=h;o=i[t+16>>2]<10,w=o?w:t,t=i[(o?4:0)+t>>2],!!t;);if((w|0)==(h|0))break A;if(i[w+16>>2]<11)break f}w=h}if(r=i[r>>2],t=i[r+128>>2],!t)break e;for(r=r+128|0,s=r,o=t;h=i[o+16>>2]<10,s=h?s:o,o=i[(h?4:0)+o>>2],!!o;);h=0;f:{if((r|0)==(s|0)||(h=0,i[s+16>>2]>10))break f;h=i[s+28>>2]}for(s=r,o=t;_=i[o+16>>2]<10,s=_?s:o,o=i[(_?4:0)+o>>2],!!o;);if(C=(r|0)==(s|0)|i[s+16>>2]>10?C:i[s+32>>2],I=i[w+44>>2],W=i[w+56>>2],l[w+24|0]>8)break r;for(o=r;s=i[t+16>>2]<10,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);t=0;f:{if((r|0)==(o|0)||(t=0,i[o+16>>2]>10))break f;g=i[o+44>>2],t=i[o+56>>2]}if(!C)break e;for(r=t,R=n&4,N=n&3,_=0;;){if(h)for(D=G(r,_)+g|0,y=I+G(W,(G(i[e+112>>2],_)>>>0)/(k>>>0)|0)|0,m=0;;){if(o=D+G(n,m)|0,w=y+G((G(i[e+108>>2],m)>>>0)/(f>>>0)|0,n)|0,t=0,s=0,n>>>0>3)for(;u[t+o|0]=l[t+w|0],V=t|1,u[V+o|0]=l[w+V|0],V=t|2,u[V+o|0]=l[w+V|0],V=t|3,u[V+o|0]=l[w+V|0],t=t+4|0,s=s+4|0,(R|0)!=(s|0););if(s=0,N)for(;u[t+o|0]=l[t+w|0],t=t+1|0,s=s+1|0,(N|0)!=(s|0););if(m=m+1|0,(h|0)==(m|0))break}if(_=_+1|0,(C|0)==(_|0))break}break e}if(m=i[e+124>>2],(h|0)==(m|0))break e;for(;;){f:{n=i[r>>2],w=i[n+128>>2];A:{if(!w)break A;for(o=i[m+16>>2],n=n+128|0,s=n,t=w;_=(o|0)>i[t+16>>2],s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);if((n|0)==(s|0))break A;if(_=n,t=w,(o|0)>=i[s+16>>2])break f}if(e=E(40),i[B+4>>2]=e,i[B+8>>2]=35,i[B+12>>2]=-2147483608,r=l[12906]|l[12907]<<8|(l[12908]<<16|l[12909]<<24),f=l[12902]|l[12903]<<8|(l[12904]<<16|l[12905]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+35|0]=0,r=l[12933]|l[12934]<<8|(l[12935]<<16|l[12936]<<24),u[e+31|0]=r,u[e+32|0]=r>>>8,u[e+33|0]=r>>>16,u[e+34|0]=r>>>24,r=l[12930]|l[12931]<<8|(l[12932]<<16|l[12933]<<24),f=l[12926]|l[12927]<<8|(l[12928]<<16|l[12929]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12922]|l[12923]<<8|(l[12924]<<16|l[12925]<<24),f=l[12918]|l[12919]<<8|(l[12920]<<16|l[12921]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12914]|l[12915]<<8|(l[12916]<<16|l[12917]<<24),f=l[12910]|l[12911]<<8|(l[12912]<<16|l[12913]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;s=(o|0)>i[t+16>>2],_=s?_:t,t=i[(s?4:0)+t>>2],!!t;);for(g=0,g=(n|0)==(_|0)|(o|0)<i[_+16>>2]?g:i[_+28>>2],s=n,t=w;_=(o|0)>i[t+16>>2],s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);I=0,I=(n|0)==(s|0)|(o|0)<i[s+16>>2]?I:i[s+32>>2],N=i[m+44>>2],W=i[m+56>>2],t=n,s=t;f:{if(l[m+24|0]<=8){for(;s=(o|0)>i[w+16>>2],t=s?t:w,w=i[(s?4:0)+w>>2],!!w;);A:{if((n|0)==(t|0)){C=0,n=0;break A}if(C=0,n=0,(o|0)<i[t+16>>2])break A;C=i[t+56>>2],n=i[t+44>>2]}if(!I)break f;for(R=g&-2,D=g&1,_=0;;){A:{if(!g)break A;if(o=n+G(_,C)|0,w=N+G(W,(G(i[e+112>>2],_)>>>0)/(k>>>0)|0)|0,t=0,s=0,(g|0)!=1)for(;u[t+o|0]=l[w+((G(i[e+108>>2],t)>>>0)/(f>>>0)|0)|0],y=t|1,u[y+o|0]=l[w+((G(y,i[e+108>>2])>>>0)/(f>>>0)|0)|0],t=t+2|0,s=s+2|0,(R|0)!=(s|0););if(!D)break A;u[t+o|0]=l[w+((G(i[e+108>>2],t)>>>0)/(f>>>0)|0)|0]}if(_=_+1|0,(I|0)==(_|0))break}break f}for(;t=(o|0)>i[w+16>>2],s=t?s:w,w=i[(t?4:0)+w>>2],!!w;);A:{if((n|0)==(s|0)){C=0,n=0;break A}if(C=0,n=0,(o|0)<i[s+16>>2])break A;C=i[s+56>>2]>>>1|0,n=i[s+44>>2]}if(!I)break f;for(o=n,R=W>>>1|0,D=g&-2,y=g&1,w=i[e+108>>2],V=i[e+112>>2],n=0;;){A:{if(!g)break A;if(_=o+(G(n,C)<<1)|0,W=N+(G(R,(G(n,V)>>>0)/(k>>>0)|0)<<1)|0,t=0,s=0,(g|0)!=1)for(;Q[_+(t<<1)>>1]=F[W+((G(t,w)>>>0)/(f>>>0)<<1)>>1],S=t|1,Q[_+(S<<1)>>1]=F[W+((G(w,S)>>>0)/(f>>>0)<<1)>>1],t=t+2|0,s=s+2|0,(D|0)!=(s|0););if(!y)break A;Q[_+(t<<1)>>1]=F[W+((G(t,w)>>>0)/(f>>>0)<<1)>>1]}if(n=n+1|0,(I|0)==(n|0))break}}o=i[m+4>>2];f:{if(o){for(;;)if(t=o,o=i[t>>2],!o)break f}for(;t=i[m+8>>2],n=i[t>>2]!=(m|0),m=t,!!n;);}if(m=t,(t|0)==(h|0))break}break e}for(o=r;s=i[t+16>>2]<10,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);t=0;r:{if((r|0)==(o|0)||(t=0,i[o+16>>2]>10))break r;g=i[o+44>>2],t=i[o+56>>2]>>>1|0}if(!C)break e;for(r=t,N=W>>>1|0,R=n&4,W=n&3,D=i[e+108>>2],y=i[e+112>>2],m=0;;){if(h)for(V=(G(r,m)<<1)+g|0,S=I+(G(N,(G(m,y)>>>0)/(k>>>0)|0)<<1)|0,e=0;;){if(o=V+(G(e,n)<<1)|0,w=S+(G((G(e,D)>>>0)/(f>>>0)|0,n)<<1)|0,t=0,_=0,n>>>0>3)for(;s=t<<1,Q[s+o>>1]=F[s+w>>1],x=s|2,Q[x+o>>1]=F[w+x>>1],x=s|4,Q[x+o>>1]=F[w+x>>1],s=s|6,Q[s+o>>1]=F[s+w>>1],t=t+4|0,_=_+4|0,(R|0)!=(_|0););if(s=0,W)for(;_=t<<1,Q[_+o>>1]=F[w+_>>1],t=t+1|0,s=s+1|0,(W|0)!=(s|0););if(e=e+1|0,(h|0)==(e|0))break}if(m=m+1|0,(C|0)==(m|0))break}}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=B+16|0}function L_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;o=v-208|0,v=o,i[o+196>>2]=n,i[o+200>>2]=k;i:{e:{if(!f){if(n=i[e+104>>2],k=i[e+108>>2],(n|0)==(k|0))break e;for(;;){r:{if(w=i[n>>2],!w||(w=X0(w,86628,86648),!w))break r;k=i[n+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),di(o+168|0,i[e+100>>2]- -64|0,i[w+104>>2],i[w+108>>2]),w=i[o+168>>2];f:{if(w){if(n=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=n,n=A+8|0,u[o+187|0]>=0){s=i[o+180>>2],i[n>>2]=i[o+176>>2],i[n+4>>2]=s,i[n+8>>2]=i[o+184>>2],u[A+20|0]=1;break f}if(T(n,i[o+176>>2],i[o+180>>2]),n=u[o+187|0],u[A+20|0]=1,(n|0)>=0)break f;Z(i[o+176>>2]);break f}if(u[o+187|0]>=0)break f;Z(i[o+176>>2])}f:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break f;X[i[i[k>>2]+8>>2]](k),p(k)}if(!w)break e;break i}if(n=n+8|0,(k|0)==(n|0))break}break e}if(l[r+1|0])break e;if(kn(o+168|0,e,o+200|0,o+196|0),n=i[o+168>>2],n){k=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=k,k=A+8|0;r:{if(u[o+187|0]>=0){w=i[o+180>>2],i[k>>2]=i[o+176>>2],i[k+4>>2]=w,i[k+8>>2]=i[o+184>>2];break r}T(k,i[o+176>>2],i[o+180>>2])}u[A+20|0]=1}if(u[o+187|0]<0&&Z(i[o+176>>2]),n)break i}i[o+160>>2]=0,i[o+164>>2]=0,i[o+156>>2]=o+160,n=i[o+200>>2],w=i[o+196>>2],k=o+156|0,y=t+4|0,t8(k,i[t>>2],y),X[i[i[e>>2]+104>>2]](o+168|0,e,r,f,n,w,k),Y1(k,i[o+160>>2]);e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:switch(l[o+188|0]){case 1:e=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=e,e=A+8|0;w:{if(u[o+187|0]>=0){r=i[o+180>>2],i[e>>2]=i[o+176>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+184>>2];break w}T(e,i[o+176>>2],i[o+180>>2])}u[A+20|0]=1;break e;case 0:break s;default:break l}if(_=i[o+168>>2],w=i[o+172>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),!_){u[o+80|0]=0,u[o+91|0]=0,e=K(o+112|0,7,0,o+80|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;s:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break s}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break s;Z(i[e+8>>2])}if(u[o+91|0]>=0)break r;Z(i[o+80>>2]);break r}k=i[e+100>>2],R=i[k+48>>2],I=i[k+52>>2],I&&(i[I+4>>2]=i[I+4>>2]+1),W=o+136|0,k=W,i[k>>2]=0,i[k+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;s:{if(l[r+1|0])break s;bi(o+112|0,e);w:switch(l[o+132|0]){case 1:e=i[o+116>>2],i[A>>2]=i[o+112>>2],i[A+4>>2]=e,e=A+8|0;_:{if(u[o+131|0]>=0){r=i[o+124>>2],i[e>>2]=i[o+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+128>>2],n=1,u[A+20|0]=1;break _}if(T(e,i[o+120>>2],i[o+124>>2]),n=l[o+132|0],u[A+20|0]=1,(n|0)==255)break f}A=i[25191],i[o+80>>2]=i[25190],i[o+84>>2]=A,X[i[(o+80|0)+(n<<2)>>2]](o+56|0,o+112|0);break f;case 0:break w;default:break l}n=i[o+112>>2],N=i[o+116>>2];w:{if((n|0)==(N|0)){n=0;break w}for(B=A+8|0,k=i[25192],g=i[25193];;){s=i[n>>2];_:{if(!s||(h=X0(s,86628,87940),!h))break _;i[o+104>>2]=h,s=i[n+4>>2],i[o+108>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),J7(o+80|0,_,i[h+100>>2],i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if(s=i[W+4>>2],i[A>>2]=i[W>>2],i[A+4>>2]=s,u[W+19|0]>=0){s=i[W+12>>2],i[B>>2]=i[W+8>>2],i[B+4>>2]=s,i[B+8>>2]=i[W+16>>2],u[A+20|0]=1;break h}T(B,i[W+8>>2],i[W+12>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;X[i[i[w>>2]+8>>2]](w),p(w)}w=s}if(s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=g,X[i[(o+56|0)+(s<<2)>>2]](o+72|0,o+80|0)),h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;X[i[i[s>>2]+8>>2]](s),p(s)}s=i[n>>2];_:{if(!s||(h=X0(s,86628,88020),!h))break _;i[o+104>>2]=h,s=i[n+4>>2],i[o+108>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),D7(o+80|0,_,i[h+100>>2],i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if(s=i[W+4>>2],i[A>>2]=i[W>>2],i[A+4>>2]=s,u[W+19|0]>=0){s=i[W+12>>2],i[B>>2]=i[W+8>>2],i[B+4>>2]=s,i[B+8>>2]=i[W+16>>2],u[A+20|0]=1;break h}T(B,i[W+8>>2],i[W+12>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;X[i[i[w>>2]+8>>2]](w),p(w)}w=s}if(s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=g,X[i[(o+56|0)+(s<<2)>>2]](o+72|0,o+80|0)),h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;X[i[i[s>>2]+8>>2]](s),p(s)}_:{if(f||(s=i[n>>2],!s)||(s=X0(s,86628,88100),!s))break _;i[o+104>>2]=s,h=i[n+4>>2],i[o+108>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),i[o+72>>2]=0,i[o+76>>2]=0,h=i[_+112>>2],m=i[_+108>>2],C=$i(s,m),V=bf(s,m),D=Ki(s,h),s=iA(s,h);h:{if(C=(C|0)>0?C:0,m=m>>>0>V>>>0?V:m-1|0,(C|0)<=(m|0)&&(V=(D|0)>0?D:0,s=s>>>0<h>>>0?s:h-1|0,(V|0)<=(s|0)))break h;r=d2(o+56|0,42716),e=K(o+80|0,2,120,r),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;B:{if(u[e+19|0]>=0){f=i[e+12>>2],i[B>>2]=i[e+8>>2],i[B+4>>2]=f,i[B+8>>2]=i[e+16>>2],u[A+20|0]=1;break B}if(T(B,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break B;Z(i[e+8>>2])}u[r+11|0]<0&&Z(i[r>>2]),V2(o+72|0);break A}Cf(o+80|0,_,C,m,V,s,i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if((h|0)!=1)break l;if(s=i[o+84>>2],i[A>>2]=i[o+80>>2],i[A+4>>2]=s,u[o+99|0]>=0){s=i[o+92>>2],i[B>>2]=i[o+88>>2],i[B+4>>2]=s,i[B+8>>2]=i[o+96>>2],u[A+20|0]=1;break h}T(B,i[o+88>>2],i[o+92>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;X[i[i[w>>2]+8>>2]](w),p(w)}w=s}s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=g,X[i[(o+56|0)+(s<<2)>>2]](o+207|0,o+80|0)),s=i[o+76>>2];h:{if(!s||(m=i[s+4>>2],i[s+4>>2]=m-1,m))break h;X[i[i[s>>2]+8>>2]](s),p(s)}if(h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;X[i[i[s>>2]+8>>2]](s),p(s)}if(n=n+8|0,(N|0)==(n|0))break}if(n=l[o+132|0],(n|0)==255)break s}k=i[25191],i[o+80>>2]=i[25190],i[o+84>>2]=k,X[i[(o+80|0)+(n<<2)>>2]](o+56|0,o+112|0)}if(k=i[e+148>>2],h=i[e+152>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),!k)break t;if(X[i[i[k>>2]+52>>2]](o+112|0,k),n=i[o+112>>2],u[o+131|0]<0&&Z(i[o+120>>2]),n){if(X[i[i[k>>2]+52>>2]](o+112|0,k),e=i[o+116>>2],i[A>>2]=i[o+112>>2],i[A+4>>2]=e,e=A+8|0,u[o+131|0]>=0){r=i[o+124>>2],i[e>>2]=i[o+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+128>>2],u[A+20|0]=1;break k}if(T(e,i[o+120>>2],i[o+124>>2]),e=u[o+131|0],u[A+20|0]=1,(e|0)>=0)break k;Z(i[o+120>>2]);break k}switch(i[o+48>>2]=0,i[o+52>>2]=0,i[o+44>>2]=o+48,s=i[o+200>>2],B=i[o+196>>2],n=o+44|0,t8(n,i[t>>2],y),X[i[i[k>>2]+100>>2]](o+112|0,k,r,f,s,B,n),Y1(n,i[o+48>>2]),l[o+132|0]){case 0:break u;case 1:break o;default:break l}}_2(),H()}if(e=A,A=o+112|0,U6(e,A),e=l[o+132|0],(e|0)==255)break k;r=i[25193],i[o+80>>2]=i[25192],i[o+84>>2]=r,X[i[(o+80|0)+(e<<2)>>2]](o+56|0,A);break k}if(f=i[o+112>>2],i[o+104>>2]=f,r=i[o+116>>2],i[o+108>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[f+116>>2],r>>>0>=3){f=d2(o+56|0,42716),e=K(o+80|0,2,3003,f),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;u:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break u}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break u;Z(i[e+8>>2])}if(u[f+11|0]>=0)break n;Z(i[f>>2]);break n}t=i[(r<<2)+54696>>2],r=i[_+108>>2];u:{o:{if((r|0)!=i[k+120>>2]){n=i[_+112>>2];break o}if(n=i[_+112>>2],(n|0)==i[k+124>>2])break u}i[o+56>>2]=0,i[o+60>>2]=0,Bf(o+80|0,f,o+56|0,r,n,i[e+100>>2]- -64|0),f=i[o+80>>2];o:{if(f){r=i[o+84>>2],i[A>>2]=i[o+80>>2],i[A+4>>2]=r,r=A+8|0;l:{if(u[o+99|0]>=0){k=i[o+92>>2],i[r>>2]=i[o+88>>2],i[r+4>>2]=k,i[r+8>>2]=i[o+96>>2];break l}T(r,i[o+88>>2],i[o+92>>2])}u[A+20|0]=1;break o}if(k=i[o+56>>2],n=i[o+60>>2],i[o+56>>2]=0,i[o+60>>2]=0,r=i[o+108>>2],i[o+104>>2]=k,i[o+108>>2]=n,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break o;X[i[i[r>>2]+8>>2]](r),p(r)}if(u[o+99|0]<0&&Z(i[o+88>>2]),V2(o+56|0),f)break n}if(N9(_,o+104|0,t),l[e+145|0]==1&&X[i[i[_>>2]+16>>2]](_,1),V2(o+104|0),r=l[o+132|0],(r|0)==255)break t;f=i[25193],i[o+80>>2]=i[25192],i[o+84>>2]=f,X[i[(o+80|0)+(r<<2)>>2]](o+56|0,o+112|0)}r=F[e+10>>1]|F[e+12>>1]<<16,i[o+112>>2]=F[e+6>>1]|F[e+8>>1]<<16,i[o+116>>2]=r,f=0,r=o+112|0,F[r>>1]!=2|F[r+2>>1]!=2|F[r+4>>1]!=2||(f=l[r+6|0]),f||X[i[i[_>>2]+8>>2]](_,r),f=i[e+16>>2],i[o+80>>2]=f,r=i[e+20>>2],i[o+84>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f&&X[i[i[_>>2]+12>>2]](_,o+80|0),g=i[R+56>>2],g&&(i[g+4>>2]=i[g+4>>2]+1),m=i[R+64>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),r=i[e+104>>2],n=i[e+108>>2];t:{u:{if((r|0)==(n|0)){t=0,s=0,B=0;break u}k=r;o:{for(;;){l:{if(f=i[k>>2],!f||(f=X0(f,86628,89140),!f))break l;s=i[k+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),X[i[i[_>>2]+24>>2]](_,f+98|0),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}s=0}t=0;o:{if((r|0)!=(n|0))for(k=r;;){l:{if(f=i[k>>2],!f||(f=X0(f,86628,89152),!f))break l;B=i[k+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),X[i[i[_>>2]+28>>2]](_,f+100|0),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}B=0}o:{if((r|0)==(n|0))break o;for(k=r;;){l:{if(f=i[k>>2],!f||(f=X0(f,86628,88980),!f))break l;t=i[k+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),X[i[i[_>>2]+20>>2]](_,i[f+100>>2],i[f+104>>2]),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}}if((r|0)==(n|0))break u;for(;;){o:{if(f=i[r>>2],!f||(k=X0(f,86628,86684),!k))break o;if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),X[i[i[_>>2]+32>>2]](o+24|0,_,k+104|0),u[o+43|0]>=0)break t;Z(i[o+32>>2]);break t}if(r=r+8|0,(n|0)==(r|0))break}}f=0}n=i[e+104>>2],e=i[e+108>>2];t:{if((n|0)==(e|0))break t;for(;;){u:{if(r=i[n>>2],!r||(r=X0(r,86628,89620),!r))break u;e=i[n+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);o:{if(u[r+111|0]>=0){i[o+16>>2]=i[r+108>>2],k=i[r+104>>2],i[o+8>>2]=i[r+100>>2],i[o+12>>2]=k;break o}T(o+8|0,i[r+100>>2],i[r+104>>2])}if(X[i[i[_>>2]+36>>2]](_,o+8|0),u[o+19|0]<0&&Z(i[o+8>>2]),!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break t;X[i[i[e>>2]+8>>2]](e),p(e);break t}if(n=n+8|0,(e|0)==(n|0))break}}t:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break t;X[i[i[f>>2]+8>>2]](f),p(f)}t:{if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break t;X[i[i[t>>2]+8>>2]](t),p(t)}t:{if(!B||(e=i[B+4>>2],i[B+4>>2]=e-1,e))break t;X[i[i[B>>2]+8>>2]](B),p(B)}t:{if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break t;X[i[i[s>>2]+8>>2]](s),p(s)}t:{if(!m||(e=i[m+4>>2],i[m+4>>2]=e-1,e))break t;X[i[i[m>>2]+8>>2]](m),p(m)}t:{if(!g||(e=i[g+4>>2],i[g+4>>2]=e-1,e))break t;X[i[i[g>>2]+8>>2]](g),p(g)}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=_,A=i[o+84>>2];t:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break t;X[i[i[A>>2]+8>>2]](A),p(A)}w=0;break k}if(V2(o+104|0),A=l[o+132|0],(A|0)==255)break k;e=i[25193],i[o+80>>2]=i[25192],i[o+84>>2]=e,X[i[(o+80|0)+(A<<2)>>2]](o+56|0,o+112|0)}if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break f;X[i[i[h>>2]+8>>2]](h),p(h);break f}if(V2(o+104|0),A=l[o+132|0],(A|0)==255)break f;e=i[25191],i[o+80>>2]=i[25190],i[o+84>>2]=e,X[i[(o+80|0)+(A<<2)>>2]](o+56|0,o+112|0)}if(u[W+19|0]<0&&Z(i[W+8>>2]),!I||(A=i[I+4>>2],i[I+4>>2]=A-1,A))break r;X[i[i[I>>2]+8>>2]](I),p(I)}if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;X[i[i[w>>2]+8>>2]](w),p(w)}if(A=l[o+188|0],(A|0)==255)break i;e=i[25193],i[o+112>>2]=i[25192],i[o+116>>2]=e,X[i[(o+112|0)+(A<<2)>>2]](o+80|0,o+168|0)}v=o+208|0}function N7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;k=e+60|0,(k|0)!=(r|0)&&(f=k,k=i[r>>2],r=i[r+4>>2],d4(f,k,r,r-k|0)),o=v-48|0,v=o,i[e+72>>2]=0,t=o+24|0,k=v-16|0,v=k;i:{e:{if(f=i[e+60>>2],r=i[e+64>>2]-f|0,r>>>0>=2&&(n=r-2|0,r=i[e+72>>2],n>>>0>=r>>>0))break e;if(u[k+4|0]=0,u[k+15|0]=0,K(t,2,140,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=r+f|0,f=l[f|0]|l[f+1|0]<<8,i[e+72>>2]=r+2,((f<<8|f>>>8)&65535)==65359){if(r=i[26929],i[t>>2]=i[26928],i[t+4>>2]=r,r=t+8|0,u[107731]>=0){t=i[26931],i[r>>2]=i[26930],i[r+4>>2]=t,i[r+8>>2]=i[26932];break i}T(r,i[26930],i[26931]);break i}if(r=E(32),i[k+4>>2]=r,i[k+8>>2]=27,i[k+12>>2]=-2147483616,f=l[7180]|l[7181]<<8|(l[7182]<<16|l[7183]<<24),s=l[7176]|l[7177]<<8|(l[7178]<<16|l[7179]<<24),u[r|0]=s,u[r+1|0]=s>>>8,u[r+2|0]=s>>>16,u[r+3|0]=s>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+27|0]=0,f=l[7199]|l[7200]<<8|(l[7201]<<16|l[7202]<<24),u[r+23|0]=f,u[r+24|0]=f>>>8,u[r+25|0]=f>>>16,u[r+26|0]=f>>>24,f=l[7196]|l[7197]<<8|(l[7198]<<16|l[7199]<<24),s=l[7192]|l[7193]<<8|(l[7194]<<16|l[7195]<<24),u[r+16|0]=s,u[r+17|0]=s>>>8,u[r+18|0]=s>>>16,u[r+19|0]=s>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[7188]|l[7189]<<8|(l[7190]<<16|l[7191]<<24),s=l[7184]|l[7185]<<8|(l[7186]<<16|l[7187]<<24),u[r+8|0]=s,u[r+9|0]=s>>>8,u[r+10|0]=s>>>16,u[r+11|0]=s>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(t,2,140,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2])}v=k+16|0;i:{if(i[o+24>>2]){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0;break i}t=v-16|0,v=t;e:{r:{if(k=i[e+60>>2],s=i[e+64>>2]-k|0,s>>>0>=43&&(r=i[e+72>>2],r>>>0<=s-43>>>0))break r;if(u[t+4|0]=0,u[t+15|0]=0,K(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=r+k|0,f=l[f|0]|l[f+1|0]<<8,n=r+2|0,i[e+72>>2]=n,((f<<8|f>>>8)&65535)!=65361){if(r=E(32),i[t+4>>2]=r,i[t+8>>2]=27,i[t+12>>2]=-2147483616,k=l[7152]|l[7153]<<8|(l[7154]<<16|l[7155]<<24),f=l[7148]|l[7149]<<8|(l[7150]<<16|l[7151]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+27|0]=0,k=l[7171]|l[7172]<<8|(l[7173]<<16|l[7174]<<24),u[r+23|0]=k,u[r+24|0]=k>>>8,u[r+25|0]=k>>>16,u[r+26|0]=k>>>24,k=l[7168]|l[7169]<<8|(l[7170]<<16|l[7171]<<24),f=l[7164]|l[7165]<<8|(l[7166]<<16|l[7167]<<24),u[r+16|0]=f,u[r+17|0]=f>>>8,u[r+18|0]=f>>>16,u[r+19|0]=f>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[7160]|l[7161]<<8|(l[7162]<<16|l[7163]<<24),f=l[7156]|l[7157]<<8|(l[7158]<<16|l[7159]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,K(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=k+n|0,f=l[f|0]|l[f+1|0]<<8,n=r+4|0,i[e+72>>2]=n,((f<<8|f>>>8)+16345&65535)>>>0<=16385){if(r=E(24),i[t+4>>2]=r,i[t+8>>2]=23,i[t+12>>2]=-2147483624,k=l[11932]|l[11933]<<8|(l[11934]<<16|l[11935]<<24),f=l[11928]|l[11929]<<8|(l[11930]<<16|l[11931]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+23|0]=0,k=l[11947]|l[11948]<<8|(l[11949]<<16|l[11950]<<24),f=l[11943]|l[11944]<<8|(l[11945]<<16|l[11946]<<24),u[r+15|0]=f,u[r+16|0]=f>>>8,u[r+17|0]=f>>>16,u[r+18|0]=f>>>24,u[r+19|0]=k,u[r+20|0]=k>>>8,u[r+21|0]=k>>>16,u[r+22|0]=k>>>24,k=l[11940]|l[11941]<<8|(l[11942]<<16|l[11943]<<24),f=l[11936]|l[11937]<<8|(l[11938]<<16|l[11939]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,K(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=k+n|0,f=l[f|0]|l[f+1|0]<<8,n=r+6|0,i[e+72>>2]=n,Q[e>>1]=f<<8|f>>>8,f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+10|0,i[e+72>>2]=n,i[e+4>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+14|0,i[e+72>>2]=n,i[e+8>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+18|0,i[e+72>>2]=n,i[e+12>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+22|0,i[e+72>>2]=n,i[e+16>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+26|0,i[e+72>>2]=n,i[e+20>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+30|0,i[e+72>>2]=n,i[e+24>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+34|0,i[e+72>>2]=n,i[e+28>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+38|0,i[e+72>>2]=n,i[e+32>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),k=k+n|0,k=l[k|0]|l[k+1|0]<<8,r=r+40|0,i[e+72>>2]=r,_=k<<8|k>>>8,(_-16385&65535)>>>0<=49151){if(r=E(24),i[t+4>>2]=r,i[t+8>>2]=23,i[t+12>>2]=-2147483624,k=l[11956]|l[11957]<<8|(l[11958]<<16|l[11959]<<24),f=l[11952]|l[11953]<<8|(l[11954]<<16|l[11955]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+23|0]=0,k=l[11971]|l[11972]<<8|(l[11973]<<16|l[11974]<<24),f=l[11967]|l[11968]<<8|(l[11969]<<16|l[11970]<<24),u[r+15|0]=f,u[r+16|0]=f>>>8,u[r+17|0]=f>>>16,u[r+18|0]=f>>>24,u[r+19|0]=k,u[r+20|0]=k>>>8,u[r+21|0]=k>>>16,u[r+22|0]=k>>>24,k=l[11964]|l[11965]<<8|(l[11966]<<16|l[11967]<<24),f=l[11960]|l[11961]<<8|(l[11962]<<16|l[11963]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,K(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(r>>>0<=s+G(_&65535,-3)>>>0){r=i[e+40>>2];r:{f:{for(;;){f=i[e+60>>2],k=i[e+72>>2],s=l[f+k|0],n=k+1|0,i[e+72>>2]=n,w=l[f+n|0],n=k+2|0,i[e+72>>2]=n,B=l[f+n|0],i[e+72>>2]=k+3,m=s>>>7|0,W=(s&127)+1|0,f=i[e+44>>2];A:{if(f>>>0>r>>>0){k=w|(W<<16|m<<24|B<<8),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,r=r+4|0;break A}if(s=i[e+36>>2],r=r-s|0,g=r>>2,k=g+1|0,k>>>0>=1073741824)break f;if(f=f-s|0,n=f>>1,n=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,n){if(n>>>0>=1073741824)break r;k=E(n<<2)}else k=0;if(f=k+r|0,w=w|(W<<16|m<<24|B<<8),u[f|0]=w,u[f+1|0]=w>>>8,u[f+2|0]=w>>>16,u[f+3|0]=w>>>24,w=f-(g<<2)|0,r&&z(w,s,r),i[e+44>>2]=k+(n<<2),r=f+4|0,i[e+40>>2]=r,i[e+36>>2]=w,!s)break A;Z(s)}if(i[e+40>>2]=r,h=h+1|0,!((h&65535)>>>0<(_&65535)>>>0))break}k8(o,107712);break e}G0(),H()}x0(),H()}if(r=d2(t+4|0,42716),K(o,2,140,r),u[r+11|0]>=0)break e;Z(i[r>>2])}if(v=t+16|0,k=i[o+4>>2],r=i[o>>2],i[o+24>>2]=r,i[o+28>>2]=k,u[o+43|0]<0&&(Z(i[o+32>>2]),r=i[o+24>>2]),k=i[o+12>>2],i[o+32>>2]=i[o+8>>2],i[o+36>>2]=k,i[o+40>>2]=i[o+16>>2],r){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0;break i}if(r=i[e+72>>2],k=i[e+60>>2],r>>>0<(i[e+64>>2]-k|0)-2>>>0){if(k=r+k|0,k=l[k|0]|l[k+1|0]<<8,i[e+72>>2]=r+2,((k<<8|k>>>8)&65535)==65360){t=v-16|0,v=t,k=i[e+72>>2],r=i[e+60>>2];e:{if(k>>>0>(i[e+64>>2]-r|0)-8>>>0){if(u[t+4|0]=0,u[t+15|0]=0,K(A,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=r+k|0,f=l[f|0]|l[f+1|0]<<8,s=k+2|0,i[e+72>>2]=s,((f<<8|f>>>8)-71&65535)>>>0<=65472){if(e=E(24),i[t+4>>2]=e,i[t+8>>2]=23,i[t+12>>2]=-2147483624,r=l[12004]|l[12005]<<8|(l[12006]<<16|l[12007]<<24),k=l[12e3]|l[12001]<<8|(l[12002]<<16|l[12003]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+23|0]=0,r=l[12019]|l[12020]<<8|(l[12021]<<16|l[12022]<<24),k=l[12015]|l[12016]<<8|(l[12017]<<16|l[12018]<<24),u[e+15|0]=k,u[e+16|0]=k>>>8,u[e+17|0]=k>>>16,u[e+18|0]=k>>>24,u[e+19|0]=r,u[e+20|0]=r>>>8,u[e+21|0]=r>>>16,u[e+22|0]=r>>>24,r=l[12012]|l[12013]<<8|(l[12014]<<16|l[12015]<<24),k=l[12008]|l[12009]<<8|(l[12010]<<16|l[12011]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}for(r=r+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[e+72>>2]=k+6,_=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),f=2;;){r:{if(!(_>>>32-f&1))break r;if((f|0)==15){r=i[e+72>>2],k=r+i[e+60>>2]|0,s=l[k+1|0],k=l[k|0],i[e+72>>2]=r+2,r=k<<24|s<<16|15,i[t>>2]=r,i[t+4>>2]=r;f:{if(r=i[e+52>>2],n=i[e+56>>2],r>>>0<n>>>0){k=F[t>>1]|F[t+2>>1]<<16,Q[r>>1]=k,Q[r+2>>1]=k>>>16,i[e+52>>2]=r+4;break f}A:{if(s=i[e+48>>2],r=r-s|0,h=r>>2,k=h+1|0,k>>>0<1073741824){if(n=n-s|0,w=n>>1,n=n>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,n){if(n>>>0>=1073741824)break A;k=E(n<<2)}else k=0;w=k+r|0,B=F[t>>1]|F[t+2>>1]<<16,Q[w>>1]=B,Q[w+2>>1]=B>>>16,h=w-(h<<2)|0,r&&z(h,s,r),i[e+56>>2]=k+(n<<2),r=w+4|0,i[e+52>>2]=r,i[e+48>>2]=h,s&&Z(s),i[e+52>>2]=r;break f}G0(),H()}x0(),H()}break r}s=t+4|0,r=S0(Y(128324,31370,39),f),k=i[(i[i[r>>2]-12>>2]+r|0)+28>>2],i[s>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129808),n=X[i[i[k>>2]+28>>2]](k,10)|0,e2(s),k=v-16|0,v=k,G1(k+8|0,r);f:{if(!l[k+8|0]||(s=k+4|0,i[s>>2]=i[(r+i[i[r>>2]-12>>2]|0)+24>>2],Zk(s,n),i[s>>2]))break f;m4(r+i[i[r>>2]-12>>2]|0,1)}_1(k+8|0),v=k+16|0,Xe(r),i[e+72>>2]=i[e+72>>2]+2}if(f=f+1|0,(f|0)==33)break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=t+16|0;break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(e=E(40),i[o>>2]=e,i[o+4>>2]=33,i[o+8>>2]=-2147483608,r=l[26466]|l[26467]<<8|(l[26468]<<16|l[26469]<<24),k=l[26462]|l[26463]<<8|(l[26464]<<16|l[26465]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+33|0]=0,u[e+32|0]=l[26494],r=l[26490]|l[26491]<<8|(l[26492]<<16|l[26493]<<24),k=l[26486]|l[26487]<<8|(l[26488]<<16|l[26489]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26482]|l[26483]<<8|(l[26484]<<16|l[26485]<<24),k=l[26478]|l[26479]<<8|(l[26480]<<16|l[26481]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26474]|l[26475]<<8|(l[26476]<<16|l[26477]<<24),k=l[26470]|l[26471]<<8|(l[26472]<<16|l[26473]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,140,o),u[o+11|0]>=0)break i;Z(i[o>>2])}u[o+43|0]<0&&Z(i[o+32>>2]),v=o+48|0}function P_(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72548,t=i[18140],i[f+24>>2]=t,n=i[t-12>>2],t=f+24|0,i[n+t>>2]=i[18141],n=t+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+80>>2]=72548,i[f+24>>2]=72528,m=R0(k),i[m>>2]=71280,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,Y2(n,e,r),k=t,o=n,t=u[f+175|0],n=(t|0)<0,Y(k,n?i[f+164>>2]:o,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=f+164|0,s0(t,r),k=t,t=u[f+175|0],n=(t|0)<0,Y(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+24|0,30789,23),l[e+100|0]),42713,1),t=f+164|0,s0(t,r),o=t,t=u[f+175|0],n=(t|0)<0,Y(k,n?i[f+164>>2]:o,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=f+8|7,n=f+18|0,w=Y(S0(Y(k,30766,22),l[e+101|0]),27190,2);i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:switch(k=l[e+101|0],k-66|0){case 0:break r;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:break A;case 11:break l;case 22:break o;case 34:break u;case 44:break t;case 56:break n;default:break s}if((k|0)==244)break k;if((k|0)!=44)break A;n=E(16),i[f+8>>2]=n,i[f+12>>2]=11,i[f+16>>2]=-2147483632,t=l[21373]|l[21374]<<8|(l[21375]<<16|l[21376]<<24),k=l[21369]|l[21370]<<8|(l[21371]<<16|l[21372]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+11|0]=0,t=l[21376]|l[21377]<<8|(l[21378]<<16|l[21379]<<24),u[n+7|0]=t,u[n+8|0]=t>>>8,u[n+9|0]=t>>>16,u[n+10|0]=t>>>24;break e}t=f+8|4,i[f+8>>2]=1852399949,u[f+19|0]=4,k=4;break f}t=f+16|0,i[f+8>>2]=1702131781,i[f+12>>2]=1684366446,u[f+19|0]=8,k=8;break f}n=E(16),i[f+8>>2]=n,i[f+12>>2]=12,i[f+16>>2]=-2147483632,t=l[3814]|l[3815]<<8|(l[3816]<<16|l[3817]<<24),k=l[3810]|l[3811]<<8|(l[3812]<<16|l[3813]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+12|0]=0,t=l[3818]|l[3819]<<8|(l[3820]<<16|l[3821]<<24),u[n+8|0]=t,u[n+9|0]=t>>>8,u[n+10|0]=t>>>16,u[n+11|0]=t>>>24;break e}u[f+19|0]=7,i[f+8>>2]=l[22060]|l[22061]<<8|(l[22062]<<16|l[22063]<<24),n=l[22063]|l[22064]<<8|(l[22065]<<16|l[22066]<<24),u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,k=7;break f}Q[f+16>>1]=l[21570]|l[21571]<<8,u[f+19|0]=10,t=l[21566]|l[21567]<<8|(l[21568]<<16|l[21569]<<24),i[f+8>>2]=l[21562]|l[21563]<<8|(l[21564]<<16|l[21565]<<24),i[f+12>>2]=t,t=n,k=10;break f}Q[f+16>>1]=l[21366]|l[21367]<<8,u[f+19|0]=10,t=l[21362]|l[21363]<<8|(l[21364]<<16|l[21365]<<24),i[f+8>>2]=l[21358]|l[21359]<<8|(l[21360]<<16|l[21361]<<24),i[f+12>>2]=t,t=n,k=10;break f}u[f+19|0]=7,i[f+8>>2]=l[7986]|l[7987]<<8|(l[7988]<<16|l[7989]<<24),n=l[7989]|l[7990]<<8|(l[7991]<<16|l[7992]<<24),u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,k=7}u[t|0]=0,n=f+8|0;break i}n=E(24),i[f+8>>2]=n,i[f+12>>2]=20,i[f+16>>2]=-2147483624,t=l[12852]|l[12853]<<8|(l[12854]<<16|l[12855]<<24),k=l[12848]|l[12849]<<8|(l[12850]<<16|l[12851]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+20|0]=0,t=l[12864]|l[12865]<<8|(l[12866]<<16|l[12867]<<24),u[n+16|0]=t,u[n+17|0]=t>>>8,u[n+18|0]=t>>>16,u[n+19|0]=t>>>24,t=l[12860]|l[12861]<<8|(l[12862]<<16|l[12863]<<24),k=l[12856]|l[12857]<<8|(l[12858]<<16|l[12859]<<24),u[n+8|0]=k,u[n+9|0]=k>>>8,u[n+10|0]=k>>>16,u[n+11|0]=k>>>24,u[n+12|0]=t,u[n+13|0]=t>>>8,u[n+14|0]=t>>>16,u[n+15|0]=t>>>24}k=i[f+12>>2]}t=Y(Y(w,n,k),42712,2),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(t,29255,23),l[e+102|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(t,30745,20),l[e+103|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(t,29801,15),u[f+19|0]<0&&Z(i[f+8>>2]);i:{e:switch(i[e+108>>2]){case 0:Y(f+24|0,41844,6);break i;case 1:Y(f+24|0,41837,6);break i;case 2:Y(f+24|0,41830,6);break i;case 3:Y(f+24|0,41823,6);break i;default:break e}Y(f+24|0,33473,12)}t=f+164|0,s0(t,r),k=t,t=u[f+175|0],n=(t|0)<0,Y(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(f+24|0,32432,16),l[e+112|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(t,32468,18),l[e+113|0]),42713,1);i:{if(n=i[e+116>>2],I=i[e+120>>2],(n|0)!=(I|0))for(C=f+36|0;;){t=f+164|0,s0(t,r),o=t,t=u[f+175|0],k=(t|0)<0,Y(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32518,5);e:{if(t=i[n>>2],W=i[n+4>>2],(t|0)==(W|0))break e;for(;;){s=l[t|0],k=i[f+24>>2],w=i[k-12>>2]+(f+24|0)|0,l[w+80|0]||(o=f+164|0,k=i[w+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129808),X[i[i[k>>2]+28>>2]](k,32)|0,e2(o),k=i[f+24>>2]),u[w+76|0]=48,u[w+77|0]=0,u[w+78|0]=0,u[w+79|0]=0,u[w+80|0]=1,k=k-12|0,i[C+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=S0(f+24|0,s),g=G1(f+8|0,_);f:{if(l[g|0]!=1)break f;o=_+i[i[_>>2]-12>>2]|0,B=i[o+4>>2],h=i[o+24>>2];A:{if(l[o+80|0]==1){w=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break A}s=f+164|0,k=i[o+28>>2],i[s>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129808),w=X[i[i[k>>2]+28>>2]](k,32)|0,e2(s),u[o+76|0]=w,u[o+77|0]=w>>>8,u[o+78|0]=w>>>16,u[o+79|0]=w>>>24,u[o+80|0]=1}A:{if(!h||(k=i[o+12>>2],B=(B&176)==32?32852:32851,s=B-32851|0,(s|0)>0&&(X[i[i[h>>2]+48>>2]](h,32851,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){V=s|7,k=E(V+1|0),i[f+172>>2]=V-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}u[f+175|0]=s,k=f+164|0}if(s&&o0(k,w,s),u[k+s|0]=0,k=X[i[i[h>>2]+48>>2]](h,u[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=32852-B|0,(k|0)>0&&(X[i[i[h>>2]+48>>2]](h,B,k)|0)!=(k|0))break A;i[o+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(g),t=t+1|0,(W|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42713,1),t=i[i[f+24>>2]-12>>2]+m|0,i[t>>2]=i[t>>2]&-75|2,n=n+12|0,(I|0)==(n|0))break}if(n=i[e+140>>2],I=i[e+144>>2],(n|0)!=(I|0))for(C=f+36|0;;){t=f+164|0,s0(t,r),o=t,t=u[f+175|0],k=(t|0)<0,Y(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32508,9);e:{if(t=i[n>>2],W=i[n+4>>2],(t|0)==(W|0))break e;for(;;){s=l[t|0],k=i[f+24>>2],w=i[k-12>>2]+(f+24|0)|0,l[w+80|0]||(o=f+164|0,k=i[w+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129808),X[i[i[k>>2]+28>>2]](k,32)|0,e2(o),k=i[f+24>>2]),u[w+76|0]=48,u[w+77|0]=0,u[w+78|0]=0,u[w+79|0]=0,u[w+80|0]=1,k=k-12|0,i[C+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=S0(f+24|0,s),g=G1(f+8|0,_);f:{if(l[g|0]!=1)break f;o=_+i[i[_>>2]-12>>2]|0,B=i[o+4>>2],h=i[o+24>>2];A:{if(l[o+80|0]==1){w=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break A}s=f+164|0,k=i[o+28>>2],i[s>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129808),w=X[i[i[k>>2]+28>>2]](k,32)|0,e2(s),u[o+76|0]=w,u[o+77|0]=w>>>8,u[o+78|0]=w>>>16,u[o+79|0]=w>>>24,u[o+80|0]=1}A:{if(!h||(k=i[o+12>>2],B=(B&176)==32?32852:32851,s=B-32851|0,(s|0)>0&&(X[i[i[h>>2]+48>>2]](h,32851,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){V=s|7,k=E(V+1|0),i[f+172>>2]=V-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}u[f+175|0]=s,k=f+164|0}if(s&&o0(k,w,s),u[k+s|0]=0,k=X[i[i[h>>2]+48>>2]](h,u[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=32852-B|0,(k|0)>0&&(X[i[i[h>>2]+48>>2]](h,B,k)|0)!=(k|0))break A;i[o+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(g),t=t+1|0,(W|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42713,1),t=i[i[f+24>>2]-12>>2]+m|0,i[t>>2]=i[t>>2]&-75|2,n=n+12|0,(I|0)==(n|0))break}if(n=i[e+128>>2],B=i[e+132>>2],(n|0)!=(B|0))for(I=f+36|0;;){e=f+164|0,s0(e,r),k=e,e=u[f+175|0],t=(e|0)<0,Y(f+24|0,t?i[f+164>>2]:k,t?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32524,5);e:{if(t=i[n>>2],C=i[n+4>>2],(t|0)==(C|0))break e;for(;;){o=l[t|0],k=i[f+24>>2],e=i[k-12>>2]+(f+24|0)|0,l[e+80|0]||(w=f+164|0,k=i[e+28>>2],i[w>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(w,129808),X[i[i[k>>2]+28>>2]](k,32)|0,e2(w),k=i[f+24>>2]),u[e+76|0]=48,u[e+77|0]=0,u[e+78|0]=0,u[e+79|0]=0,u[e+80|0]=1,e=k-12|0,i[I+i[e>>2]>>2]=2,e=i[e>>2]+m|0,i[e>>2]=i[e>>2]&-75|8;r:{h=S0(f+24|0,o),W=G1(f+8|0,h);f:{if(l[W|0]!=1)break f;e=h+i[i[h>>2]-12>>2]|0,_=i[e+4>>2],s=i[e+24>>2];A:{if(l[e+80|0]==1){w=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}o=f+164|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129808),w=X[i[i[k>>2]+28>>2]](k,32)|0,e2(o),u[e+76|0]=w,u[e+77|0]=w>>>8,u[e+78|0]=w>>>16,u[e+79|0]=w>>>24,u[e+80|0]=1}A:{if(!s||(k=i[e+12>>2],_=(_&176)==32?32852:32851,o=_-32851|0,(o|0)>0&&(X[i[i[s>>2]+48>>2]](s,32851,o)|0)!=(o|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;o=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){g=o|7,k=E(g+1|0),i[f+172>>2]=g-2147483647,i[f+164>>2]=k,i[f+168>>2]=o;break k}u[f+175|0]=o,k=f+164|0}if(o&&o0(k,w,o),u[k+o|0]=0,k=X[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,o)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break A}if(k=32852-_|0,(k|0)>0&&(X[i[i[s>>2]+48>>2]](s,_,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=h+i[i[h>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}if(_1(W),t=t+1|0,(C|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42713,1),e=i[i[f+24>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,n=n+12|0,(B|0)==(n|0))break}e=i[f+76>>2];e:{r:{if(e&16){n=i[f+72>>2],e=i[f+52>>2],n>>>0<e>>>0&&(i[f+72>>2]=e,n=e),e=f+48|0;break r}if(!(e&8)){n=0,u[A+11|0]=0;break e}n=i[f+44>>2],e=f+36|0}r:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){t=n|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break r}if(u[A+11|0]=n,n)break r;n=0;break e}g0(),H()}if(!n)break e;z(A,r,n)}u[A+n|0]=0,A=i[18139],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18142],i[m>>2]=71280,u[f+71|0]<0&&Z(i[f+60>>2]),y0(m),p0(f+80|0),v=f+176|0;return}g0(),H()}function q_(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=M(0),w=M(0),h=0,_=0,B=0,m=0,W=0,g=0,I=M(0),C=0,V=0,y=0,R=M(0),N=0,D=0,x=M(0),S=M(0),O=M(0),L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0;n=v-160|0,v=n,e=i[r>>2],V=i[e+112>>2],g=i[e+108>>2],t=E(172),i[t>>2]=94860,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],h=f+1|0,i[t+4>>2]=h,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],L=t+12|0,i[t+96>>2]=L,i[t+8>>2]=f+1,i[t+100>>2]=t,h||(X[i[i[t>>2]+8>>2]](t),p(t)),f=i[k+4>>2],h=f>>>0<4,i[L+120>>2]=f,i[L+116>>2]=0,i[L+112>>2]=V,i[L+108>>2]=g,h0=l[k+8|0],V0=i[i[r>>2]+120>>2],T0(n+136|0,L,0,g,V,8,o),n0=g-1|0,f=f<<3,N=(h?16908801>>>f|0:0)&3,D=(n0+N>>>0)/(N>>>0)|0,m0=V-1|0,B=(h?16843265>>>f|0:0)&3,h=(m0+B>>>0)/(B>>>0)|0,T0(n+112|0,L,1,D,h,8,o),f=n+16|0;i:{if(i[n+136>>2]){if(W=i[n+140>>2],i[n+8>>2]=i[n+136>>2],i[n+12>>2]=W,u[n+155|0]>=0){W=i[n+148>>2],i[f>>2]=i[n+144>>2],i[f+4>>2]=W,i[f+8>>2]=i[n+152>>2];break i}T(f,i[n+144>>2],i[n+148>>2]);break i}if(W=i[n+116>>2],i[n+8>>2]=i[n+112>>2],i[n+12>>2]=W,u[n+131|0]>=0){W=i[n+124>>2],i[f>>2]=i[n+120>>2],i[f+4>>2]=W,i[f+8>>2]=i[n+128>>2];break i}T(f,i[n+120>>2],i[n+124>>2])}T0(n+88|0,L,2,D,h,8,o),h=n+56|0;i:{if(i[n+8>>2]){if(D=i[n+12>>2],i[n+48>>2]=i[n+8>>2],i[n+52>>2]=D,u[n+27|0]>=0){D=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=D,i[h+8>>2]=i[f+8>>2];break i}T(h,i[n+16>>2],i[n+20>>2]);break i}if(f=i[n+92>>2],i[n+48>>2]=i[n+88>>2],i[n+52>>2]=f,u[n+107|0]>=0){f=i[n+100>>2],i[h>>2]=i[n+96>>2],i[h+4>>2]=f,i[h+8>>2]=i[n+104>>2];break i}T(h,i[n+96>>2],i[n+100>>2])}u[n+107|0]<0&&Z(i[n+96>>2]),u[n+27|0]<0&&Z(i[n+16>>2]),u[n+131|0]<0&&Z(i[n+120>>2]),u[n+155|0]<0&&Z(i[n+144>>2]);i:{e:{if(i[n+48>>2]){if(e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0,u[n+67|0]>=0){r=i[h+4>>2],i[e>>2]=i[h>>2],i[e+4>>2]=r,i[e+8>>2]=i[h+8>>2],u[A+20|0]=1;break e}if(T(e,i[n+56>>2],i[n+60>>2]),e=u[n+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+56>>2]);break e}u[n+67|0]<0&&Z(i[n+56>>2]);r:{if(!(h0&1))break r;if(T0(n+48|0,L,6,g,V,8,o),i[n+48>>2]){if(e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0,u[n+67|0]>=0){r=i[n+60>>2],i[e>>2]=i[n+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+64>>2],u[A+20|0]=1;break e}if(T(e,i[n+56>>2],i[n+60>>2]),e=u[n+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+56>>2]);break e}if(u[n+67|0]>=0)break r;Z(i[n+56>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(f=r+128|0,r=f;h=i[o+16>>2]<10,r=h?r:o,o=i[(h?4:0)+o>>2],!!o;);if((r|0)==(f|0))break f;if(h=0,i[r+16>>2]>10)break r;a=i[r+44>>2],h=i[r+56>>2];break r}h=0}r:{f:{if(r=i[e>>2],r){for(f=e,o=r;_=i[o+16>>2],f=(_|0)<0?f:o,o=i[(_>>>29&4)+o>>2],!!o;);_=0;A:{if((e|0)==(f|0)||(_=0,i[f+16>>2]>0))break A;W0=i[f+56>>2],_=i[f+44>>2]}for(f=e,o=r;C=i[o+16>>2]<=0,f=C?f:o,o=i[(C?4:0)+o>>2],!!o;);C=0;A:{if((e|0)==(f|0)||(C=0,i[f+16>>2]>1))break A;$=i[f+44>>2],C=i[f+56>>2]}for(f=e,o=r;y=i[o+16>>2]<2,f=y?f:o,o=i[(y?4:0)+o>>2],!!o;);y=0;A:{if((e|0)==(f|0)||(y=0,i[f+16>>2]>2))break A;f0=i[f+56>>2],y=i[f+44>>2]}if(D=0,!(h0&1))break r;for(o=e;f=i[r+16>>2]<6,o=f?o:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}D=0;break r}if(D=0,i[o+16>>2]>6)break r;e0=i[o+56>>2],D=i[o+44>>2]}i[n+84>>2]=-1113159960,i[n+76>>2]=1056964608,i[n+80>>2]=-1093247418,i[n+68>>2]=-1096180881,i[n+72>>2]=1056964608,i[n+60>>2]=1038710997,i[n+64>>2]=-1104361250,i[n+52>>2]=1050220167,i[n+56>>2]=1058424226,u[n+48|0]=1,m=l[k+22|0],Nr(n+8|0,F[k+20>>1],F[k+16>>1]),e=i[n+44>>2],i[n+80>>2]=i[n+40>>2],i[n+84>>2]=e,e=i[n+36>>2],i[n+72>>2]=i[n+32>>2],i[n+76>>2]=e,r=i[n+28>>2],e=n- -64|0,i[e>>2]=i[n+24>>2],i[e+4>>2]=r,e=i[n+20>>2],i[n+56>>2]=i[n+16>>2],i[n+60>>2]=e,e=i[n+12>>2],i[n+48>>2]=i[n+8>>2],i[n+52>>2]=e,W=(V0|0)==11?4:3;r:{f:{A:{if(V){if(g){for(e=0,Q0=m&1;;){k=G(e,W0)+_|0,o=G(e,h)+a|0,f=0,r=0;k:{if(!Q0){for(;;)if(A0=f+k|0,s=M(M(M(M(M(l[o+2|0])*E0[n+60>>2])+M(M(M(l[o|0])*E0[n+52>>2])+M(E0[n+56>>2]*M(l[o+1|0]))))*M(.8554700016975403))+M(.5)),M(w2(s))<M(2147483648)?r=~~s:r=-2147483648,u[A0|0]=(r|0)<0?16:(r>>>0>=219?219:r)+16|0,o=o+W|0,f=f+1|0,(g|0)==(f|0))break k}for(;A0=r+k|0,s=M(M(M(M(l[o+2|0])*E0[n+60>>2])+M(M(M(l[o|0])*E0[n+52>>2])+M(E0[n+56>>2]*M(l[o+1|0]))))+M(.5)),M(w2(s))<M(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[A0|0]=(f|0)>0?f:0,o=o+W|0,r=r+1|0,(g|0)!=(r|0););}if(e=e+1|0,(V|0)==(e|0))break}if(o=(B|0)==1,(N|0)!=1|(B|0)!=1)break A;for(B=m&1,e=0;;){k=G(e,f0)+y|0,_=G(e,C)+$|0,o=G(e,h)+a|0,f=0,r=0;k:{if(!B){for(;;)if(s=E0[n+84>>2],w=E0[n+76>>2],R=E0[n+80>>2],m=f+_|0,I=M(l[o+2|0]),x=M(l[o|0]),S=M(l[o+1|0]),O=M(M(M(M(M(I*E0[n+72>>2])+M(M(x*E0[n+64>>2])+M(E0[n+68>>2]*S)))*M(.875))+M(128))+M(.5)),M(w2(O))<M(2147483648)?r=~~O:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,m=f+k|0,s=M(M(M(M(M(I*s)+M(M(x*w)+M(R*S)))*M(.875))+M(128))+M(.5)),M(w2(s))<M(2147483648)?r=~~s:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,o=o+W|0,f=f+1|0,(g|0)==(f|0))break k}for(;s=E0[n+84>>2],w=E0[n+76>>2],R=E0[n+80>>2],m=r+_|0,I=M(l[o+2|0]),x=M(l[o|0]),S=M(l[o+1|0]),O=M(M(M(M(I*E0[n+72>>2])+M(M(x*E0[n+64>>2])+M(E0[n+68>>2]*S)))+M(128))+M(.5)),M(w2(O))<M(2147483648)?f=~~O:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,m=r+k|0,s=M(M(M(M(I*s)+M(M(x*w)+M(R*S)))+M(128))+M(.5)),M(w2(s))<M(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,o=o+W|0,r=r+1|0,(g|0)!=(r|0););}if(e=e+1|0,(V|0)==(e|0))break}break f}if(e=(B|0)==1,o=e,(N|0)!=1)break A;if(e)break r;break A}if(e=(B|0)==1,o=e,(N|0)!=1)break A;if(e)break f}if(e=(N|0)!=2,!(e|(B|0)!=2)){B=V&-2;A:{if(!B||(N=g&-2,!N))break A;for(W0=W<<1,f=0;;){for(o=G(f,h)+a|0,e=f>>>1|0,Q0=G(e,f0)+y|0,A0=G(e,C)+$|0,r=0;;){e=o+W|0,k=e+h|0,_=o+h|0,w=M((l[k+2|0]+(l[_+2|0]+(l[e+2|0]+l[o+2|0]|0)|0)>>>2&255)>>>0),R=M((l[k|0]+(l[_|0]+(l[e|0]+l[o|0]|0)|0)>>>2&255)>>>0),I=M((l[k+1|0]+(l[_+1|0]+(l[e+1|0]+l[o+1|0]|0)|0)>>>2&255)>>>0),s=M(M(w*E0[n+84>>2])+M(M(R*E0[n+76>>2])+M(E0[n+80>>2]*I))),w=M(M(w*E0[n+72>>2])+M(M(R*E0[n+64>>2])+M(E0[n+68>>2]*I))),k=r>>>1|0,e=k+Q0|0,o=o+W0|0,_=k+A0|0;k:{if(!(m&1)){s=M(M(s*M(.875))+M(128)),w=M(M(M(w*M(.875))+M(128))+M(.5)),M(w2(w))<M(2147483648)?k=~~w:k=-2147483648,k=(k|0)>=255?255:k,k=(k|0)>0?k:0;break k}s=M(s+M(128)),w=M(M(w+M(128))+M(.5)),M(w2(w))<M(2147483648)?k=~~w:k=-2147483648,k=(k|0)>=255?255:k,k=(k|0)>0?k:0}if(u[_|0]=k,_=e,s=M(s+M(.5)),M(w2(s))<M(2147483648)?k=~~s:k=-2147483648,e=(k|0)>=255?255:k,u[_|0]=(e|0)>0?e:0,r=r+2|0,!(N>>>0>r>>>0))break}if(f=f+2|0,!(B>>>0>f>>>0))break}}if(g&1){if(!V)break f;for(_=h<<1,e=n0>>>1|0,B=e+y|0,N=e+$|0,o=G(W,n0)+a|0,f=0;;){r=l[o|0];A:{if((f|1)>>>0<V>>>0){e=o+h|0,r=l[e|0]+(r&255)>>>1|0,k=l[e+2|0]+l[o+2|0]>>>1|0,e=l[e+1|0]+l[o+1|0]>>>1|0;break A}k=l[o+2|0],e=l[o+1|0]}w=M((k&255)>>>0),R=M((r&255)>>>0),I=M((e&255)>>>0),s=M(M(w*E0[n+84>>2])+M(M(R*E0[n+76>>2])+M(E0[n+80>>2]*I))),w=M(M(w*E0[n+72>>2])+M(M(R*E0[n+64>>2])+M(E0[n+68>>2]*I))),r=f>>>1|0,e=B+G(r,f0)|0,k=N+G(r,C)|0;A:{if(m&1){s=M(s+M(128)),w=M(M(w+M(128))+M(.5)),M(w2(w))<M(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0;break A}s=M(M(s*M(.875))+M(128)),w=M(M(M(w*M(.875))+M(128))+M(.5)),M(w2(w))<M(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0}if(u[k|0]=r,k=e,s=M(s+M(.5)),M(w2(s))<M(2147483648)?r=~~s:r=-2147483648,e=(r|0)>=255?255:r,u[k|0]=(e|0)>0?e:0,o=o+_|0,f=f+2|0,!(V>>>0>f>>>0))break}}if(!(V&1)|!g)break f;for(_=W<<1,o=G(h,m0)+a|0,e=m0>>>1|0,y=G(e,f0)+y|0,C=G(e,C)+$|0,f=0;;){r=l[o|0];A:{if((f|1)>>>0<g>>>0){e=o+W|0,r=l[e|0]+(r&255)>>>1|0,k=l[e+2|0]+l[o+2|0]>>>1|0,e=l[e+1|0]+l[o+1|0]>>>1|0;break A}k=l[o+2|0],e=l[o+1|0]}w=M((k&255)>>>0),R=M((r&255)>>>0),I=M((e&255)>>>0),s=M(M(w*E0[n+84>>2])+M(M(R*E0[n+76>>2])+M(E0[n+80>>2]*I))),w=M(M(w*E0[n+72>>2])+M(M(R*E0[n+64>>2])+M(E0[n+68>>2]*I))),r=f>>>1|0,e=r+y|0,k=r+C|0;A:{if(m&1){s=M(s+M(128)),w=M(M(w+M(128))+M(.5)),M(w2(w))<M(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0;break A}s=M(M(s*M(.875))+M(128)),w=M(M(M(w*M(.875))+M(128))+M(.5)),M(w2(w))<M(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0}if(u[k|0]=r,k=e,s=M(s+M(.5)),M(w2(s))<M(2147483648)?r=~~s:r=-2147483648,e=(r|0)>=255?255:r,u[k|0]=(e|0)>0?e:0,o=o+_|0,f=f+2|0,!(g>>>0>f>>>0))break}break f}if(!g|(!V|(e|o^1)))break f;for(k=W<<1,e=0,B=m&1;;){_=G(e,f0)+y|0,W=G(e,C)+$|0,o=G(e,h)+a|0,r=0,f=0;A:{if(!B){for(;;)if(s=E0[n+84>>2],w=E0[n+76>>2],R=E0[n+80>>2],m=r>>>1|0,N=m+W|0,I=M(l[o+2|0]),x=M(l[o|0]),S=M(l[o+1|0]),O=M(M(M(M(M(I*E0[n+72>>2])+M(M(x*E0[n+64>>2])+M(E0[n+68>>2]*S)))*M(.875))+M(128))+M(.5)),M(w2(O))<M(2147483648)?f=~~O:f=-2147483648,f=(f|0)>=255?255:f,u[N|0]=(f|0)>0?f:0,m=_+m|0,s=M(M(M(M(M(I*s)+M(M(x*w)+M(R*S)))*M(.875))+M(128))+M(.5)),M(w2(s))<M(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,o=k+o|0,r=r+2|0,!(g>>>0>r>>>0))break A}for(;s=E0[n+84>>2],w=E0[n+76>>2],R=E0[n+80>>2],m=f>>>1|0,N=m+W|0,I=M(l[o+2|0]),x=M(l[o|0]),S=M(l[o+1|0]),O=M(M(M(M(I*E0[n+72>>2])+M(M(x*E0[n+64>>2])+M(E0[n+68>>2]*S)))+M(128))+M(.5)),M(w2(O))<M(2147483648)?r=~~O:r=-2147483648,r=(r|0)>=255?255:r,u[N|0]=(r|0)>0?r:0,m=_+m|0,s=M(M(M(M(I*s)+M(M(x*w)+M(R*S)))+M(128))+M(.5)),M(w2(s))<M(2147483648)?r=~~s:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,o=k+o|0,f=f+2|0,g>>>0>f>>>0;);}if(e=e+1|0,(V|0)==(e|0))break}}if(!g|(!(h0&1)|!V))break r;for(y=a+3|0,W=g&-4,C=g&3,_=0,a=(V0|0)!=11;;){e=G(_,e0)+D|0;f:{A:{k:{if(!a){if(f=y+G(h,_)|0,r=0,o=0,k=0,n0>>>0>=3)break k;break A}if(!g)break f;o0(e,255,g);break f}for(;u[e+o|0]=l[f+(o<<2)|0],B=o|1,u[B+e|0]=l[f+(B<<2)|0],B=o|2,u[B+e|0]=l[f+(B<<2)|0],B=o|3,u[B+e|0]=l[f+(B<<2)|0],o=o+4|0,k=k+4|0,(W|0)!=(k|0););}if(!C)break f;for(;u[e+o|0]=l[f+(o<<2)|0],o=o+1|0,r=r+1|0,(C|0)!=(r|0););}if(_=_+1|0,(V|0)==(_|0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=L;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=n+160|0}function ji(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;h=v-32|0,v=h,l[108685]==1&&(i[h+16>>2]=A,y8(32936,h+16|0));i:{k=i[A+4>>2];e:{if(k){if(n=i[k>>2],(n|0)==1){k=i[A>>2];break e}if((n|0)<=1)break i;i[k>>2]=n-1}l[108685]==1&&(i[h>>2]=A,y8(42687,h)),k=E(172),i[A>>2]=k,o0(k,0,172),s=A,A=E(4),i[s+4>>2]=A,i[A>>2]=1}e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{if((e|0)<=0){A=(r|0)>=51?51:r,n=(A|0)>0?A:0;break B}if(t=e-1|0,f=G(t,12)+59184|0,A=i[f>>2],r=(r|0)>=51?51:r,n=(r|0)>0?r:0,A=((A<<3&120)+(G(n,G(A>>4,5)-45|0)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+5|0,(s&127)>>>0>=63||(u[k+5|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+6|0,(s&127)>>>0>62)||(u[k+6|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+7|0,(f&127)>>>0>62))break k;if(u[k+7|0]=A,A=t<<2,r=i[A+59208>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break h;if(u[k+149|0]=r,r=i[A+59216>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break _;if(u[k+147|0]=r,A=i[A+59224>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break w;if(u[k+148|0]=A,A=G(n,-20)>>4,r=(A|0)>-41,f=r?A+104^64:-41-A|0,A=r|f<<1,r=k+156|0,(f&127)>>>0>=63||(u[k+156|0]=A,f=G(n,-25)>>4,t=-41-f|0,_=f+104^64,s=(f|0)>-41,A=s,o=A?_:t,A=o<<1|A,r=k+157|0,(o&127)>>>0>62)||(u[k+157|0]=A,A=G(n,-30)>>4,r=(A|0)>-41,o=r?A+104^64:-41-A|0,A=r|o<<1,r=k+158|0,(o&127)>>>0>62)||(u[k+158|0]=A,A=G(n,-40)>>4,r=(A|0)<=-103?-103:A,A=(A|0)>-41,o=A?r+104^64:-41-r|0,A=o<<1|A,r=k+159|0,(o&127)>>>0>62)||(A=G(A&255,257),u[k+159|0]=A,u[k+160|0]=A>>>8,u[k+154|0]=14,u[k+155|0]=14,o=(e|0)!=1?59240:59232,A=i[o>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,w=A?r^64:63-r|0,A=w<<1|A,r=k+150|0,(w&127)>>>0>=63)||(u[k+150|0]=A,A=i[o+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+151|0,(o&127)>>>0>62))break k;if(u[k+151|0]=A,u[k+152|0]=30-(G(n,5)>>>3&62),r=s?_:t,A=s|r<<1,(r&127)>>>0>62)break s;if(u[k+153|0]=A,A=G(n,-5)>>4,r=(A|0)>-9,f=r?A+72^64:-9-A|0,A=r|f<<1,(f&127)>>>0>=63)break l;A=G(A&255,16843009),u[k+143|0]=A,u[k+144|0]=A>>>8,u[k+145|0]=A>>>16,u[k+146|0]=A>>>24}if(t=G(e,12),f=t+59248|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+2|0,(s&127)>>>0>=63||(u[k+2|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+3|0,(s&127)>>>0>62)||(u[k+3|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+4|0,(f&127)>>>0>62)||(u[k+4|0]=A,f=(((e|0)==2?5:e)<<2)+59296|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+8|0,(s&127)>>>0>=63)||(u[k+8|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+9|0,(s&127)>>>0>62)||(u[k+9|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+10|0,(s&127)>>>0>62)||(u[k+10|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+11|0,(f&127)>>>0>62))break k;if(u[k+11|0]=A,s=e<<2,r=s,A=i[r+59332>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,f=(A|0)>=126?126:A,f=(f|0)<=1?1:f,A=(A|0)>63,f=A?f^64:63-f|0,A=f<<1|A,(f&127)>>>0>=63)break o;if(u[k+12|0]=A,A=i[r+59344>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break u;if(u[k+13|0]=A,f=e?59368:59360,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+14|0,(o&127)>>>0>=63||(u[k+14|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+15|0,(f&127)>>>0>62)||(u[k+15|0]=A,f=(e<<4)+59376|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+16|0,(o&127)>>>0>=63)||(u[k+16|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+17|0,(o&127)>>>0>62)||(u[k+17|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+18|0,(o&127)>>>0>62)||(u[k+18|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+19|0,(f&127)>>>0>62)||(u[k+19|0]=A,f=t+59424|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+20|0,(t&127)>>>0>=63)||(u[k+20|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+21|0,(t&127)>>>0>62)||(u[k+21|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+22|0,(f&127)>>>0>62))break k;for(u[k+22|0]=A,o=k+25|0,t=G(e,72)+59472|0,A=0;;){if(r=i[t+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,w=r?f^64:63-f|0,f=w<<1|r,r=A+o|0,(w&127)>>>0>=63)break A;if(u[r|0]=f,A=A+1|0,(A|0)==18)break}for(o=k+43|0,A=0;;){if(r=i[t+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,w=r?f^64:63-f|0,f=w<<1|r,r=A+o|0,(w&127)>>>0>=63)break A;if(u[r|0]=f,A=A+1|0,(A|0)==18)break}if(f=(s<<2)+59696|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+61|0,(t&127)>>>0>=63||(u[k+61|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+62|0,(t&127)>>>0>62)||(u[k+62|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+63|0,(t&127)>>>0>62)||(u[k+63|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k- -64|0,(f&127)>>>0>62))break k;for(u[r|0]=A,t=k+65|0,s=G(e,168)+59744|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,o=r?f^64:63-f|0,r=o<<1|r,f=A+t|0,(o&127)>>>0>=63)break f;if(u[f|0]=r,A=A+1|0,(A|0)==42)break}if(f=(e<<3)+60256|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+107|0,(t&127)>>>0>=63||(u[k+107|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+108|0,(f&127)>>>0>62))break k;for(u[k+108|0]=A,t=k+109|0,s=G(e,96)+60288|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,o=r?f^64:63-f|0,r=o<<1|r,f=A+t|0,(o&127)>>>0>=63)break f;if(u[f|0]=r,A=A+1|0,(A|0)==24)break}if(f=G(e,24)+60576|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+133|0,(t&127)>>>0>=63||(u[k+133|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+134|0,(t&127)>>>0>62)||(u[k+134|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+135|0,(t&127)>>>0>62)||(u[k+135|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+136|0,(t&127)>>>0>62)||(u[k+136|0]=A,A=i[f+16>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+137|0,(t&127)>>>0>62)||(u[k+137|0]=A,A=i[f+20>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+138|0,(f&127)>>>0>62))break k;if(u[k+138|0]=A,u[k|0]=14,A=i[(e<<2)+60648>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,e=(A|0)>=126?126:A,e=(e|0)<=1?1:e,A=(A|0)>63,e=A?e^64:63-e|0,A=e<<1|A,(e&127)>>>0>=63)break t;if(u[k+1|0]=A,u[k+139|0]=1,u[k+140|0]=1,A=G(n,-5)>>4,e=(A|0)>=54?54:A,e=(e|0)<=-71?-71:e,A=(A|0)>-9,e=A?e+72^64:-9-e|0,A=e<<1|A,(e&127)>>>0<=62)break n;u[k+141|0]=A;break r}u[k+149|0]=r;break r}u[k+147|0]=r;break r}u[k+148|0]=A;break r}u[k+153|0]=A;break r}u[k+143|0]=A;break r}u[k+12|0]=A;break r}u[k+13|0]=A;break r}u[k+1|0]=A;break r}A=G(A&255,257),u[k+141|0]=A,u[k+142|0]=A>>>8,u[k+170|0]=1,u[k+171|0]=1,u[k+162|0]=1,u[k+163|0]=1,u[k+164|0]=1,u[k+165|0]=1,u[k+166|0]=1,u[k+167|0]=1,u[k+168|0]=1,u[k+169|0]=1,u[k+161|0]=1,u[k+23|0]=1,u[k+24|0]=1;break e}u[r|0]=A;break r}u[r|0]=f;break r}u[f|0]=r}M0(21573,18272,212,12058),H()}v=h+32|0;return}M0(21782,18272,177,18425),H()}function Oi(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;t=v-208|0,v=t,Wf(t+200|0,e,i[i[f>>2]+4>>2]),i[t+192>>2]=i[k+32>>2],o=i[k+28>>2],i[t+184>>2]=i[k+24>>2],i[t+188>>2]=o,o=i[k+20>>2],i[t+176>>2]=i[k+16>>2],i[t+180>>2]=o,o=i[k+12>>2],i[t+168>>2]=i[k+8>>2],i[t+172>>2]=o,o=i[k+4>>2],i[t+160>>2]=i[k>>2],i[t+164>>2]=o,i[t+152>>2]=0,i[t+156>>2]=0,k=i[t+200>>2],X[i[i[k>>2]+116>>2]](t+128|0,k),o=i[t+128>>2],k=i[t+132>>2];i:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break i;X[i[i[k>>2]+8>>2]](k),p(k)}i:{e:{r:{f:{A:{k:{n:{if(o){k=i[t+200>>2],X[i[i[k>>2]+116>>2]](t+128|0,k),k=i[t+128>>2],o=X[i[i[k>>2]+8>>2]](k)|0,k=i[t+132>>2];t:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break t;X[i[i[k>>2]+8>>2]](k),p(k)}if(o&&(i[t+164>>2]=o),u[t+148|0]=0,i[t+128>>2]=0,i[t+132>>2]=0,k=i[t+200>>2],X[i[i[k>>2]+116>>2]](t+48|0,k),cf(t+104|0,i[t+48>>2],r,f,i[t+164>>2],t+176|0,e- -64|0),k=l[t+124|0],o=l[t+148|0],(o|0)==255){if((k|0)==255)break A;break n}if((k|0)!=255)break n;k=i[23607],i[t+80>>2]=i[23606],i[t+84>>2]=k,X[i[(t+80|0)+(o<<2)>>2]](t+72|0,t+128|0),u[t+148|0]=255;break k}if(k=i[r>>2],o=i[r+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[t+152>>2]=k,k=i[t+156>>2],i[t+156>>2]=o,!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break f;X[i[i[k>>2]+8>>2]](k),p(k);break f}o=t+128|0,i[t+72>>2]=o,w=i[23609],i[t+80>>2]=i[23608],i[t+84>>2]=w,X[i[(t+80|0)+(k<<2)>>2]](t+72|0,o,t+104|0)}if(k=l[t+124|0],(k|0)==255)break A;o=i[23607],i[t+80>>2]=i[23606],i[t+84>>2]=o,X[i[(t+80|0)+(k<<2)>>2]](t+72|0,t+104|0)}u[t+124|0]=255,k=i[t+52>>2];A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;X[i[i[k>>2]+8>>2]](k),p(k)}w=l[t+148|0];A:{if(w){if((w|0)!=1)break e;k=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=k,k=A+8|0;k:{if(u[t+147|0]>=0){o=i[t+140>>2],i[k>>2]=i[t+136>>2],i[k+4>>2]=o,i[k+8>>2]=i[t+144>>2];break k}T(k,i[t+136>>2],i[t+140>>2])}u[A+20|0]=1;break A}if(k=i[t+128>>2],o=i[t+132>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[t+152>>2]=k,k=i[t+156>>2],i[t+156>>2]=o,!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(k=l[t+148|0],(k|0)!=255&&(o=i[23607],i[t+104>>2]=i[23606],i[t+108>>2]=o,X[i[(t+104|0)+(k<<2)>>2]](t+80|0,t+128|0)),w)break r}B=t+80|0,o=v-80|0,v=o,W=t+152|0,s=i[W>>2],_=i[s+112>>2],w=i[t+200>>2],k=w,i[k+120>>2]=i[s+108>>2],i[k+124>>2]=_,T7(o+16|0,k,W,f,t+160|0,n);f:{A:{k:{n:switch(l[o+60|0]){case 1:if(k=i[o+20>>2],i[B>>2]=i[o+16>>2],i[B+4>>2]=k,k=B+8|0,u[o+35|0]>=0){n=i[o+28>>2],i[k>>2]=i[o+24>>2],i[k+4>>2]=n,i[k+8>>2]=i[o+32>>2];break k}T(k,i[o+24>>2],i[o+28>>2]);break k;case 0:break n;default:break A}n=i[e+48>>2],k=i[e+52>>2];n:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,Z8(o+72|0,n,X[i[i[w>>2]+40>>2]](w)|0),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;X[i[i[k>>2]+8>>2]](k),p(k);break n}Z8(o+72|0,n,X[i[i[w>>2]+40>>2]](w)|0)}n=o+28|0,_=i[i[o+72>>2]+104>>2],i[w+116>>2]=_,s=i[e+48>>2],k=i[e+52>>2];n:{if(!k){K8(s,_,n,0);break n}if(i[k+4>>2]=i[k+4>>2]+1,K8(s,_,n,0),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;X[i[i[k>>2]+8>>2]](k),p(k)}if(l[o+60|0])break A;if(k=i[o+16>>2],g=i[o+20>>2],(k|0)!=(g|0))for(;;){s=i[k>>2],n=i[s+16>>2]==1769173093,s=n?w:s,I=X[i[i[s>>2]+(n?48:40)>>2]](s)|0,s=i[e+48>>2],n=i[e+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),h=i[s+52>>2],s=i[s+56>>2];n:{if(!s){h=R6(h,k);break n}if(i[s+4>>2]=i[s+4>>2]+1,h=R6(h,k),m=i[s+4>>2],i[s+4>>2]=m-1,m)break n;X[i[i[s>>2]+8>>2]](s),p(s)}n:{if(!n||(s=i[n+4>>2],i[n+4>>2]=s-1,s))break n;X[i[i[n>>2]+8>>2]](n),p(n)}s=i[e+48>>2],n=i[e+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),m=i[s+60>>2],s=i[s+64>>2];n:{if(s){if(i[s+4>>2]=i[s+4>>2]+1,Q[o+14>>1]=h+1,u[o+12|0]=I,i[o+8>>2]=F[o+12>>1]|F[o+14>>1]<<16,F6(m,_,o+8|0),h=i[s+4>>2],i[s+4>>2]=h-1,h)break n;X[i[i[s>>2]+8>>2]](s),p(s);break n}u[o+12|0]=I,Q[o+14>>1]=h+1,i[o+4>>2]=F[o+12>>1]|F[o+14>>1]<<16,F6(m,_,o+4|0)}n:{if(!n||(s=i[n+4>>2],i[n+4>>2]=s-1,s))break n;X[i[i[n>>2]+8>>2]](n),p(n)}if(k=k+8|0,(g|0)==(k|0))break}n:{if(i[i[f>>2]+4>>2]==4||(n=i[W>>2],i[n+116>>2]))break n;s=i[n+108>>2],h=i[n+112>>2],k=1;t:{u:switch(i[n+120>>2]){case 2:k=!(s&1);break t;case 1:k=!((s|h)&1);break t;case 0:case 3:break t;default:break u}k=0}if(k)break n;u[w+272|0]=0}n=i[e+48>>2],k=i[e+52>>2];n:{if(!k){$9(n,_,i[t+172>>2]);break n}if(i[k+4>>2]=i[k+4>>2]+1,$9(n,_,i[t+172>>2]),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;X[i[i[k>>2]+8>>2]](k),p(k)}k=i[26929],i[B>>2]=i[26928],i[B+4>>2]=k,k=B+8|0;n:{if(u[107731]>=0){n=i[26931],i[k>>2]=i[26930],i[k+4>>2]=n,i[k+8>>2]=i[26932];break n}T(k,i[26930],i[26931])}if(k=i[o+76>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break k;X[i[i[k>>2]+8>>2]](k),p(k)}k=l[o+60|0],(k|0)!=255&&(n=i[25187],i[o+72>>2]=i[25186],i[o+76>>2]=n,X[i[(o+72|0)+(k<<2)>>2]](o+71|0,o+16|0)),v=o+80|0;break f}_2(),H()}f:{if(i[t+80>>2]){e=i[t+84>>2],i[A>>2]=i[t+80>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[t+99|0]>=0){r=i[t+92>>2],i[e>>2]=i[t+88>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+96>>2];break A}T(e,i[t+88>>2],i[t+92>>2])}u[A+20|0]=1;break f}Dr(e,i[i[t+200>>2]+116>>2],t+200|0);A:{if(!l[t+161|0]||!SA(i[t+152>>2])||(k=i[t+200>>2],!(X[i[i[k>>2]+44>>2]](k)|0)))break A;i[t+72>>2]=0,i[t+76>>2]=0,X9(t+128|0,t+152|0,e- -64|0);k:switch(l[t+148|0]){case 1:e=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=e,e=A+8|0;n:{t:{if(u[t+147|0]>=0){r=i[t+140>>2],i[e>>2]=i[t+136>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+144>>2],k=1,u[A+20|0]=1;break t}if(T(e,i[t+136>>2],i[t+140>>2]),k=l[t+148|0],u[A+20|0]=1,(k|0)==255)break n}A=i[23607],i[t+104>>2]=i[23606],i[t+108>>2]=A,X[i[(t+104|0)+(k<<2)>>2]](t+48|0,t+128|0)}if(A=i[t+76>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;X[i[i[A>>2]+8>>2]](A),p(A);break f;case 0:break k;default:break e}k=i[t+128>>2],n=i[t+132>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[t+72>>2]=k,k=i[t+76>>2],i[t+76>>2]=n;k:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break k;X[i[i[k>>2]+8>>2]](k),p(k)}k=t+104|0,Oi(k,e,t+72|0,f,t+160|0,2),s=l[t+124|0];k:{if(s){if((s|0)!=1)break e;U6(A,k);break k}k=i[t+104>>2],i[t+64>>2]=k,f=i[t+108>>2],i[t+68>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[k+116>>2],k=i[e+48>>2],n=i[i[t+200>>2]+116>>2],i[t+44>>2]=1,i[t+36>>2]=n,i[t+40>>2]=t+36,n=i[t+44>>2],i[t+8>>2]=i[t+40>>2],i[t+12>>2]=n,n=f,f=Vo(t+48|0,t+8|0),a4(k,n,1635088492,f),k=i[f>>2],k&&(i[f+4>>2]=k,Z(k)),B=i[e+48>>2],_=i[i[t+64>>2]+116>>2],f=i[t+200>>2],o=d2(t+48|0,X[i[i[f>>2]+44>>2]](f)|0),n=v-16|0,v=n,f=E(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90212,k=f+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,Q[f+112>>1]=0,i[k>>2]=87800,i[f+136>>2]=0,i[f+140>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=0,i[f+32>>2]=1635088451,w=f+120|0;n:{if((w|0)==(o|0))break n;if(u[o+11|0]>=0){h=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=h,i[w+8>>2]=i[o+8>>2];break n}D1(w,i[o>>2],i[o+4>>2])}w=i[B+52>>2],i[n+12>>2]=f,i[n+8>>2]=k,i[f+4>>2]=i[f+4>>2]+1,w=R6(w,n+8|0),k=i[n+12>>2];n:{if(!k||(h=i[k+4>>2],i[k+4>>2]=h-1,h))break n;X[i[i[k>>2]+8>>2]](k),p(k)}k=i[B+60>>2],u[n+4|0]=1,Q[n+6>>1]=w+1,i[n>>2]=F[n+4>>1]|F[n+6>>1]<<16,F6(k,_,n),k=i[f+4>>2],i[f+4>>2]=k-1,k||(X[i[i[f>>2]+8>>2]](f),p(f)),v=n+16|0,u[o+11|0]<0&&Z(i[o>>2]);n:{if(l[i[r>>2]+4|0]!=1||(r=i[i[t+200>>2]+116>>2],f=i[e+48>>2],k=i[i[t+64>>2]+116>>2],i[t+32>>2]=1,i[t+36>>2]=k,i[t+28>>2]=t+36,k=i[t+32>>2],i[t>>2]=i[t+28>>2],i[t+4>>2]=k,k=r,r=Vo(t+48|0,t),a4(f,k,1886545261,r),f=i[r>>2],!f))break n;i[r+4>>2]=f,Z(f)}V2(t- -64|0)}r=l[t+124|0],(r|0)!=255&&(f=i[23611],i[t+48>>2]=i[23610],i[t+52>>2]=f,X[i[(t+48|0)+(r<<2)>>2]](t- -64|0,t+104|0)),r=l[t+148|0],(r|0)!=255&&(f=i[23607],i[t+104>>2]=i[23606],i[t+108>>2]=f,X[i[(t+104|0)+(r<<2)>>2]](t+48|0,t+128|0)),r=i[t+76>>2];k:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break k;X[i[i[r>>2]+8>>2]](r),p(r)}if(s)break f}i[t+112>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,j1(t+128|0,i[e+48>>2],i[i[t+200>>2]+116>>2],t+104|0),r=i[t+132>>2],e=i[t+128>>2],i[t+80>>2]=e,i[t+84>>2]=r,u[t+99|0]<0&&(Z(i[t+88>>2]),e=i[t+80>>2]),r=i[t+140>>2],i[t+88>>2]=i[t+136>>2],i[t+92>>2]=r,i[t+96>>2]=i[t+144>>2];A:{if(e){if(e=i[t+84>>2],i[A>>2]=i[t+80>>2],i[A+4>>2]=e,e=A+8|0,u[t+99|0]>=0){r=i[t+92>>2],i[e>>2]=i[t+88>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+96>>2],e=1;break A}T(e,i[t+88>>2],i[t+92>>2]),e=1;break A}if(w=0,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,r=i[t+200>>2],k=0,n=0,e=i[t+104>>2],o=i[t+108>>2],(e|0)!=(o|0)){if(f=o-e|0,(f|0)<0)break i;for(n=E(f),i[t+16>>2]=n,w=f+n|0,i[t+24>>2]=w,k=n;i[k>>2]=i[e>>2],f=i[e+4>>2],i[k+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k=k+8|0,e=e+8|0,(o|0)!=(e|0););i[t+20>>2]=k}if(o=i[r+104>>2],o){if(e=i[r+108>>2],f=o,(e|0)!=(o|0)){for(;;){f=i[e-4>>2];k:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break k;X[i[i[f>>2]+8>>2]](f),p(f)}if(e=e-8|0,(o|0)==(e|0))break}w=i[t+24>>2],k=i[t+20>>2],n=i[t+16>>2],f=i[r+104>>2]}i[r+108>>2]=o,Z(f),e=i[t+200>>2]}else e=r;i[r+112>>2]=w,i[r+108>>2]=k,i[r+104>>2]=n,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,r=i[t+204>>2],i[t+200>>2]=0,i[t+204>>2]=0,i[A+4>>2]=r,i[A>>2]=e,e=0}if(u[A+20|0]=e,A=i[t+104>>2],!A)break f;if(e=A,k=i[t+108>>2],(e|0)!=(k|0)){for(;;){e=i[k-4>>2];A:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(k=k-8|0,(A|0)==(k|0))break}e=i[t+104>>2]}i[t+108>>2]=A,Z(e)}if(u[t+99|0]>=0)break r;Z(i[t+88>>2])}A=i[t+156>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[t+204>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+208|0;return}_2(),H()}G0(),H()}function K_(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;h=v-80|0,v=h;i:{if(!n){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(!k){if(u[h|0]=0,u[h+11|0]=0,r=A,A=K(h+24|0,5,2006,h),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+11|0]>=0)break i;Z(i[h>>2]);break i}i[h+64>>2]=0,i[h+56>>2]=0,i[h+60>>2]=0,w=n,m=k<<2,_=n+m|0,g=k;e:{if((k|0)<=0)break e;if(B=i[h+64>>2],n=i[h+60>>2],B-n>>2>=(k|0)){B=n>>2;r:{if((B|0)>=(k|0)){m=w+m|0,k=n;break r}if(m=n+w|0,k=_-m|0,!k|(_|0)==(m|0)||z(n,m,k),k=k+n|0,i[h+60>>2]=k,(B|0)<=0)break e}if(B=g<<2,I=B,_=k,B=k-B|0,n>>>0>B>>>0)for(;i[_>>2]=i[B>>2],_=_+4|0,B=B+4|0,n>>>0>B>>>0;);i[h+60>>2]=_;r:{if((k|0)==(I|0)||(n=k-I|0,!n))break r;z(k-n|0,0,n)}if((w|0)==(m|0)||(k=m-w|0,!k))break e;z(0,w,k);break e}r:{if(_=i[h+56>>2],k=g+(n-_>>2)|0,k>>>0<1073741824){if(B=B-_|0,m=B>>1,B=B>>>0>=2147483644?1073741823:k>>>0<m>>>0?m:k,B){if(B>>>0>=1073741824)break r;k=E(B<<2)}else k=0;m=0-_|0,I=k+m|0,C=g<<2,C&&z(I,w,C),C=I+C|0,n&&z(C,0,n),i[h+60>>2]=0,I=I-(m&-4)|0,m&&z(I,_,m),i[h+64>>2]=k+(B<<2),i[h+60>>2]=n+C,i[h+56>>2]=I,_&&Z(_);break e}G0(),H()}x0(),H()}Q[h+32>>1]=0,i[h+52>>2]=0,i[h+24>>2]=0,i[h+28>>2]=0,i[h+44>>2]=0,i[h+48>>2]=0,i[h+40>>2]=f,i[h+36>>2]=r,o&&(Q[h+26>>1]=F[o>>1],Q[h+28>>1]=F[o+2>>1],Q[h+30>>1]=F[o+4>>1],Q[h+32>>1]=F[o+6>>1]);e:{if(!t){for(;;)if(St(h+24|0,i[w+(W<<2)>>2],0,0),W=W+1|0,(g|0)==(W|0))break e}for(r=t+4|0;f=W<<3,St(h+24|0,i[w+(W<<2)>>2],i[f+t>>2],i[r+f>>2]),W=W+1|0,(g|0)!=(W|0););}I=i[e>>2],w=v-80|0,v=w,k=i[h+48>>2],f=i[h+44>>2];e:{if((k-f|0)/12>>>0>=65536){r=E(48),i[w+44>>2]=r,i[w+48>>2]=40,i[w+52>>2]=-2147483600,f=l[26838]|l[26839]<<8|(l[26840]<<16|l[26841]<<24),k=l[26834]|l[26835]<<8|(l[26836]<<16|l[26837]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[26830]|l[26831]<<8|(l[26832]<<16|l[26833]<<24),k=l[26826]|l[26827]<<8|(l[26828]<<16|l[26829]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[26822]|l[26823]<<8|(l[26824]<<16|l[26825]<<24),k=l[26818]|l[26819]<<8|(l[26820]<<16|l[26821]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[26814]|l[26815]<<8|(l[26816]<<16|l[26817]<<24),k=l[26810]|l[26811]<<8|(l[26812]<<16|l[26813]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[26806]|l[26807]<<8|(l[26808]<<16|l[26809]<<24),k=l[26802]|l[26803]<<8|(l[26804]<<16|l[26805]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,r=K(w+56|0,5,0,w+44|0),f=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=f,f=h+8|0;r:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[h+20|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[h+20|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(u[w+55|0]>=0)break e;Z(i[w+44>>2]);break e}i[w+64>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,W=i[I+48>>2],g=i[I+52>>2],g&&(i[g+4>>2]=i[g+4>>2]+1,k=i[h+48>>2],f=i[h+44>>2]);r:{if((f|0)==(k|0))break r;f:{for(;;){s4(w+44|0,W,i[f>>2]),r=i[w+44>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[w+48>>2];A:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break A;X[i[i[r>>2]+8>>2]](r),p(r)}A:{r=i[w+60>>2],o=i[w+64>>2];k:{if(r>>>0<o>>>0){i[r>>2]=i[f>>2],_=r+4|0;break k}if(t=i[w+56>>2],r=r-t|0,B=r>>2,n=B+1|0,n>>>0>=1073741824)break A;if(o=o-t|0,_=o>>1,o=o>>>0>=2147483644?1073741823:n>>>0<_>>>0?_:n,o){if(o>>>0>=1073741824)break f;n=E(o<<2)}else n=0;if(_=n+r|0,i[_>>2]=i[f>>2],B=_-(B<<2)|0,r&&z(B,t,r),i[w+64>>2]=n+(o<<2),_=_+4|0,i[w+60>>2]=_,i[w+56>>2]=B,!t)break k;Z(t)}if(i[w+60>>2]=_,f=f+12|0,(k|0)!=(f|0))continue;break r}break}G0(),H()}x0(),H()}_=i[h+36>>2],m=i[h+40>>2],f=_>>>0>65535|m>>>0>65535,t=i[h+44>>2],C=i[h+48>>2],R=(t|0)==(C|0),r=f;r:{f:{if(R)break f;for(k=t;;){if(n=i[k+4>>2],(n|0)>=32768){i[w+52>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,k=C-t|0,o=2,r=1,f=4;break r}if(r=1,(n|0)<-32768|i[k+8>>2]-32768>>>0<=4294901759)break f;if(k=k+12|0,(C|0)==(k|0))break}r=f}i[w+52>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,f=r&1,o=f?2:1,k=C-t|0,f=f?4:2}r:{if(n=((k|0)/12<<1)+2<<o,(n|0)>-11){if(k=0,o=n+10|0,n=E(o),o&&o0(n,0,o),o=n+o|0,i[w+52>>2]=o,i[w+48>>2]=o,i[w+44>>2]=n,o=l[h+24|0],u[n+1|0]=r&1,u[n|0]=o,r=F[h+26>>1],r=r<<8|r>>>8,u[n+2|0]=r,u[n+3|0]=r>>>8,r=F[h+28>>1],r=r<<8|r>>>8,u[n+4|0]=r,u[n+5|0]=r>>>8,r=F[h+30>>1],r=r<<8|r>>>8,u[n+6|0]=r,u[n+7|0]=r>>>8,r=F[h+32>>1],r=r<<8|r>>>8,u[n+8|0]=r,u[n+9|0]=r>>>8,o=n+10|0,f>>>0>=4)for(B=o+3|0,V=o+2|0,N=o+1|0,D=f&4,r=0;u[k+o|0]=_>>>(f+(k^-1)<<3),u[k+N|0]=_>>>(f+(k^536870910)<<3),u[k+V|0]=_>>>(f+(k^536870909)<<3),u[k+B|0]=_>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(D|0)!=(r|0););if(B=f&2,B)for(r=0;u[k+o|0]=_>>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(B|0)!=(r|0););if(V=f+10|0,o=n+V|0,B=0,k=0,f>>>0>=4)for(_=o+3|0,N=o+2|0,D=o+1|0,y=f&4,r=0;u[k+o|0]=m>>>(f+(k^-1)<<3),u[k+D|0]=m>>>(f+(k^536870910)<<3),u[k+N|0]=m>>>(f+(k^536870909)<<3),u[k+_|0]=m>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(y|0)!=(r|0););if(r=f&2,r)for(;u[k+o|0]=m>>>(f+(k^-1)<<3),k=k+1|0,B=B+1|0,(r|0)!=(B|0););if(!R)for(N=f<<1,R=f&4,m=f&2,D=f+n|0;;){if(o=V+D|0,_=i[t+4>>2],r=0,k=0,y=f>>>0<4,!y)for(x=o+3|0,S=o+2|0,O=o+1|0,B=0;u[k+o|0]=_>>(f+(k^-1)<<3),u[k+O|0]=_>>(f+(k^536870910)<<3),u[k+S|0]=_>>(f+(k^536870909)<<3),u[k+x|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;u[k+o|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(V=V+N|0,o=n+V|0,_=i[t+8>>2],r=0,k=0,!y)for(y=o+3|0,x=o+2|0,S=o+1|0,B=0;u[k+o|0]=_>>(f+(k^-1)<<3),u[k+S|0]=_>>(f+(k^536870910)<<3),u[k+x|0]=_>>(f+(k^536870909)<<3),u[k+y|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;u[k+o|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(t=t+12|0,(C|0)==(t|0))break}break r}G0(),H()}f=$A(W,1768912492),k=E(512),i[k>>2]=101104,r=k,i[r+4>>2]=0,i[r+8>>2]=0,_=Y4(r+16|0,I,f),i[_>>2]=101432,Q[r+472>>1]=0,i[r+464>>2]=0,i[r+468>>2]=0,i[r+476>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+496>>2]=0,i[r+500>>2]=0,i[r+504>>2]=0,i[w+40>>2]=r,i[w+36>>2]=_,i[r+4>>2]=i[r+4>>2]+1,Dr(I,f,w+36|0),r=i[w+40>>2];r:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break r;X[i[i[r>>2]+8>>2]](r),p(r)}K8(W,f,w+44|0,1),a4(W,f,1684630887,w+56|0),n=E(128),i[n>>2]=90172,i[n+4>>2]=0,i[n+8>>2]=0,r=n+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,Q[n+112>>1]=0,i[n+16>>2]=87652,i[n+32>>2]=1769173093,f=i[h+40>>2],i[n+120>>2]=i[h+36>>2],i[n+124>>2]=f,i[w+32>>2]=n,i[w+28>>2]=r,i[n+4>>2]=i[n+4>>2]+1,r=i[w+32>>2],i[w+8>>2]=i[w+28>>2],i[w+12>>2]=r,D4(_,w+8|0,0),r=i[i[w+56>>2]>>2],t=v-32|0,v=t,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,j1(t,W,r,t+20|0);r:{if(i[t>>2]){i[w+36>>2]=0,i[w+40>>2]=0;break r}f:{if(o=i[t+20>>2],f=i[t+24>>2],(o|0)!=(f|0)){if(r=i[o>>2],r&&(W=i[w+40>>2],r=X0(r,86628,88900),r))break f;if(o=o+8|0,(f|0)!=(o|0))for(;;){if(r=i[o>>2],r&&(W=0,r=X0(r,86628,88900),r))break f;if(o=o+8|0,(f|0)==(o|0))break}i[w+36>>2]=0,i[w+40>>2]=0}i[w+36>>2]=0,i[w+40>>2]=0;break r}if(i[w+40>>2]=W,i[w+36>>2]=r,r=i[o+4>>2],i[w+40>>2]=r,!r)break r;i[r+4>>2]=i[r+4>>2]+1}if(u[t+19|0]<0&&Z(i[t+8>>2]),f=i[t+20>>2],f){if(r=f,o=i[t+24>>2],(r|0)!=(o|0)){for(;;){r=i[o-4>>2];r:{if(!r||(B=i[r+4>>2],i[r+4>>2]=B-1,B))break r;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=o-8|0,(f|0)==(o|0))break}r=i[t+20>>2]}i[t+24>>2]=f,Z(r)}v=t+32|0,i[w+20>>2]=i[w+36>>2],r=i[w+40>>2],i[w+24>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[w+24>>2],i[w>>2]=i[w+20>>2],i[w+4>>2]=r,D4(_,w,1),u[h+20|0]=0,i[h+4>>2]=k,i[h>>2]=_,r=i[w+40>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[n+4>>2],i[n+4>>2]=r-1,r||(X[i[i[n>>2]+8>>2]](n),p(n)),r=i[w+44>>2],r&&(i[w+48>>2]=r,Z(r));r:{if(!g||(r=i[g+4>>2],i[g+4>>2]=r-1,r))break r;X[i[i[g>>2]+8>>2]](g),p(g)}if(r=i[w+56>>2],!r)break e;i[w+60>>2]=r,Z(r)}v=w+80|0;e:{r:switch(l[h+20|0]){default:_2(),H();case 1:b0(A,h,i[e>>2]);break e;case 0:break r}k=i[h>>2];r:{r=i[h+4>>2];f:{if(!r){if(s)break f;e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];break e}if(i[r+4>>2]=i[r+4>>2]+1,!s)break r}f=E(16),i[f+8>>2]=0,i[f+12>>2]=0,i[s>>2]=f,i[f+4>>2]=r,i[f>>2]=k,k=i[e>>2],r=i[e+4>>2];f:{if(!r){i[f+12>>2]=r,i[f+8>>2]=k;break f}if(i[r+4>>2]=i[r+4>>2]+1,i[f+8>>2]=k,e=i[f+12>>2],i[f+12>>2]=r,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];break e}if(e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(A=l[h+20|0],(A|0)!=255&&(e=i[24223],i[h+72>>2]=i[24222],i[h+76>>2]=e,X[i[(h+72|0)+(A<<2)>>2]](h+71|0,h)),A=i[h+44>>2],A&&(i[h+48>>2]=A,Z(A)),A=i[h+56>>2],!A)break i;i[h+60>>2]=A,Z(A)}v=h+80|0}function M7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0;t=v-176|0,v=t;i:{o=i[r>>2];e:{if(!(u0[o+108>>2]<=65535&u0[o+112>>2]<65536)){if(e=E(32),i[t+128>>2]=e,i[t+132>>2]=31,i[t+136>>2]=-2147483616,f=l[10848]|l[10849]<<8|(l[10850]<<16|l[10851]<<24),k=l[10844]|l[10845]<<8|(l[10846]<<16|l[10847]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+31|0]=0,f=l[10871]|l[10872]<<8|(l[10873]<<16|l[10874]<<24),k=l[10867]|l[10868]<<8|(l[10869]<<16|l[10870]<<24),u[e+23|0]=k,u[e+24|0]=k>>>8,u[e+25|0]=k>>>16,u[e+26|0]=k>>>24,u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,f=l[10864]|l[10865]<<8|(l[10866]<<16|l[10867]<<24),k=l[10860]|l[10861]<<8|(l[10862]<<16|l[10863]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[10856]|l[10857]<<8|(l[10858]<<16|l[10859]<<24),k=l[10852]|l[10853]<<8|(l[10854]<<16|l[10855]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}i[e+292>>2]=n;r:{f:{A:{if(!i[k+36>>2]||!SA(o)|i[e+320>>2]|i[i[f>>2]+4>>2]==8)break A;if(i[e+328>>2]){if(e=A,A=d2(t+128|0,24565),K(e,5,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}i[t+144>>2]=0,i[t+148>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,i[t+136>>2]=0,i[t+140>>2]=0,u[t+132|0]=0,i[t+128>>2]=i[e+32>>2],o=i[r>>2],fn(t+104|0,i[e+20>>2],t+128|0,1635088502,F[o+108>>1],F[o+112>>1]),o=107712;k:switch(l[t+124|0]){case 1:o=t+104|0;break;case 0:break k;default:break i}if(w=k8(A,o),i[w>>2])break f;if(u[w+19|0]<0&&Z(i[w+8>>2]),l[t+124|0])break i;if(r3(e+320|0,t+104|0),H9(i[e+320>>2],1635088492,i[e+24>>2]),o=E(8),s=i[f>>2],i[o+4>>2]=0,i[o>>2]=s,i[t+40>>2]=o,s=t+40|0,h=i[s>>2],i[s>>2]=0,o=i[e+332>>2],i[e+332>>2]=h,o&&(h=i[o+4>>2],h&&(X[i[i[o>>2]+40>>2]](h),i[o+4>>2]=0),Z(o)),o=i[s>>2],i[s>>2]=0,o&&(h=i[o+4>>2],h&&(X[i[i[o>>2]+40>>2]](h),i[o+4>>2]=0),Z(o)),hk(s,i[e+332>>2]),o=i[t+40>>2],o){e=i[t+44>>2],A=d2(t+16|0,i[t+48>>2]),K(w,o,e,A),u[A+11|0]<0&&Z(i[A>>2]),A=l[t+124|0],(A|0)!=255&&(e=i[26701],i[t+40>>2]=i[26700],i[t+44>>2]=e,X[i[(t+40|0)+(A<<2)>>2]](t+16|0,t+104|0)),Qk(t+128|0);break e}o=l[t+124|0],(o|0)!=255&&(s=i[26701],i[t+40>>2]=i[26700],i[t+44>>2]=s,X[i[(t+40|0)+(o<<2)>>2]](t+16|0,t+104|0)),Qk(t+128|0)}if(o=i[e+328>>2],!o){i[e+328>>2]=f;break r}if((f|0)==(o|0))break r;if(e=E(64),i[t+128>>2]=e,i[t+132>>2]=62,i[t+136>>2]=-2147483584,f=l[25650]|l[25651]<<8|(l[25652]<<16|l[25653]<<24),k=l[25646]|l[25647]<<8|(l[25648]<<16|l[25649]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+62|0]=0,f=l[25704]|l[25705]<<8|(l[25706]<<16|l[25707]<<24),k=l[25700]|l[25701]<<8|(l[25702]<<16|l[25703]<<24),u[e+54|0]=k,u[e+55|0]=k>>>8,u[e+56|0]=k>>>16,u[e+57|0]=k>>>24,u[e+58|0]=f,u[e+59|0]=f>>>8,u[e+60|0]=f>>>16,u[e+61|0]=f>>>24,f=l[25698]|l[25699]<<8|(l[25700]<<16|l[25701]<<24),k=l[25694]|l[25695]<<8|(l[25696]<<16|l[25697]<<24),u[e+48|0]=k,u[e+49|0]=k>>>8,u[e+50|0]=k>>>16,u[e+51|0]=k>>>24,u[e+52|0]=f,u[e+53|0]=f>>>8,u[e+54|0]=f>>>16,u[e+55|0]=f>>>24,f=l[25690]|l[25691]<<8|(l[25692]<<16|l[25693]<<24),k=l[25686]|l[25687]<<8|(l[25688]<<16|l[25689]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=f,u[e+45|0]=f>>>8,u[e+46|0]=f>>>16,u[e+47|0]=f>>>24,f=l[25682]|l[25683]<<8|(l[25684]<<16|l[25685]<<24),k=l[25678]|l[25679]<<8|(l[25680]<<16|l[25681]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[25674]|l[25675]<<8|(l[25676]<<16|l[25677]<<24),k=l[25670]|l[25671]<<8|(l[25672]<<16|l[25673]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[25666]|l[25667]<<8|(l[25668]<<16|l[25669]<<24),k=l[25662]|l[25663]<<8|(l[25664]<<16|l[25665]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[25658]|l[25659]<<8|(l[25660]<<16|l[25661]<<24),k=l[25654]|l[25655]<<8|(l[25656]<<16|l[25657]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,5,0,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}A=l[t+124|0],(A|0)!=255&&(e=i[26701],i[t+40>>2]=i[26700],i[t+44>>2]=e,X[i[(t+40|0)+(A<<2)>>2]](t+16|0,t+104|0)),Qk(t+128|0);break e}if(o=i[f>>2],i[o>>2]<=3){if(e=E(48),i[t+128>>2]=e,i[t+132>>2]=46,i[t+136>>2]=-2147483600,f=l[26119]|l[26120]<<8|(l[26121]<<16|l[26122]<<24),k=l[26115]|l[26116]<<8|(l[26117]<<16|l[26118]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+46|0]=0,f=l[26157]|l[26158]<<8|(l[26159]<<16|l[26160]<<24),k=l[26153]|l[26154]<<8|(l[26155]<<16|l[26156]<<24),u[e+38|0]=k,u[e+39|0]=k>>>8,u[e+40|0]=k>>>16,u[e+41|0]=k>>>24,u[e+42|0]=f,u[e+43|0]=f>>>8,u[e+44|0]=f>>>16,u[e+45|0]=f>>>24,f=l[26151]|l[26152]<<8|(l[26153]<<16|l[26154]<<24),k=l[26147]|l[26148]<<8|(l[26149]<<16|l[26150]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[26143]|l[26144]<<8|(l[26145]<<16|l[26146]<<24),k=l[26139]|l[26140]<<8|(l[26141]<<16|l[26142]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[26135]|l[26136]<<8|(l[26137]<<16|l[26138]<<24),k=l[26131]|l[26132]<<8|(l[26133]<<16|l[26134]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[26127]|l[26128]<<8|(l[26129]<<16|l[26130]<<24),k=l[26123]|l[26124]<<8|(l[26125]<<16|l[26126]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,11,6003,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}w=i[e+104>>2];r:{f:{if((w|0)==i[e+100>>2]){s=i[o+4>>2];break f}if(s=i[o+4>>2],o=i[w-8>>2],(s|0)==i[o+12>>2])break r}B9(e,s),o=i[i[e+104>>2]-8>>2]}X[i[i[o>>2]+12>>2]](t+96|0,o),o=i[t+96>>2],o=X[i[i[o>>2]+8>>2]](o)|0,o||(o=i[k+4>>2]),cf(t+128|0,i[t+96>>2],r,f,o,k+8|0,i[e+20>>2]- -64|0);r:{f:switch(l[t+148|0]){case 1:if(e=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=e,A=A+8|0,u[t+147|0]>=0){e=i[t+140>>2],i[A>>2]=i[t+136>>2],i[A+4>>2]=e,i[A+8>>2]=i[t+144>>2];break r}T(A,i[t+136>>2],i[t+140>>2]);break r;case 0:break f;default:break i}o=i[t+128>>2],i[t+88>>2]=o,s=i[t+132>>2],i[t+92>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),Q[e+288>>1]=i[o+108>>2],Q[e+290>>1]=i[o+112>>2],s=i[t+96>>2],X[i[i[s>>2]+20>>2]](t- -64|0,s,t+88|0,f,k,n,i[o+144>>2],i[i[e+156>>2]+120>>2],i[e+296>>2]);f:{if(i[t+64>>2]){e=i[t+68>>2],i[A>>2]=i[t+64>>2],i[A+4>>2]=e,e=i[t+76>>2],i[A+8>>2]=i[t+72>>2],i[A+12>>2]=e,i[A+16>>2]=i[t+80>>2];break f}if(n=i[i[t+88>>2]+144>>2],i[e+316>>2]=n,i[t+124>>2]=0,u[t+120|0]=0,u[t+108|0]=0,i[t+104>>2]=n,w=t+108|0,n=i[r>>2],l[n+80|0]==1){A:{k:{if(u[n+79|0]>=0){i[t+48>>2]=i[n+76>>2],o=i[n+72>>2],i[t+40>>2]=i[n+68>>2],i[t+44>>2]=o;break k}if(T(t+40|0,i[n+68>>2],i[n+72>>2]),!(u[t+120|0]&1))break k;u[t+119|0]<0&&Z(i[t+108>>2]),n=i[t+44>>2],i[w>>2]=i[t+40>>2],i[w+4>>2]=n,i[w+8>>2]=i[t+48>>2];break A}n=i[t+44>>2],i[w>>2]=i[t+40>>2],i[w+4>>2]=n,i[w+8>>2]=i[t+48>>2],u[t+120|0]=1}n=i[r>>2]}n=i[n+64>>2],n&&(o=pe(),i[t+124>>2]=o,gi(o,n)),_=i[e+296>>2],h=e+304|0,o=i[h+4>>2];A:{k:{if(!o){s=h+4|0,n=s;break k}for(;;){if(n=o,s=i[o+16>>2],s>>>0>_>>>0){if(s=o,o=i[o>>2],o)continue;break k}if(s>>>0>=_>>>0)break A;if(o=i[n+4>>2],!o)break}s=n+4|0}o=E(44),i[o+20>>2]=0,i[o+24>>2]=0,i[o+16>>2]=_,i[o+8>>2]=n,i[o>>2]=0,i[o+4>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[s>>2]=o,n=i[i[h>>2]>>2],n&&(i[h>>2]=n),m1(i[h+4>>2],o),i[h+8>>2]=i[h+8>>2]+1}n=o+20|0,i[n>>2]=i[t+104>>2],iu(n+4|0,w),i[n+20>>2]=i[t+124>>2],i[e+296>>2]=i[e+296>>2]+1,r9(t+40|0,e,f),o=107712;A:switch(l[t+60|0]){case 1:o=t+40|0;break;case 0:break A;default:break i}n=k8(A,o);A:{if(i[n>>2])break A;if(u[n+19|0]<0&&Z(i[n+8>>2]),i[e+320>>2]){X9(t+16|0,t+88|0,i[e+20>>2]- -64|0),A=107712;k:switch(l[t+36|0]){case 1:A=t+16|0;break;case 0:break k;default:break i}f=0,A=k8(n,A);k:{if(i[A>>2])break k;if(u[n+19|0]<0&&Z(i[A+8>>2]),l[t+36|0])break i;if(o=i[t+16>>2],i[o+144>>2]=i[i[t+88>>2]+144>>2],s=i[e+320>>2],i[t+8>>2]=o,o=i[t+20>>2],i[t+12>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[e+332>>2],o=i[t+12>>2],i[t>>2]=i[t+8>>2],i[t+4>>2]=o,M7(A,s,t,e,k,2),i[A>>2]||(f=1,u[n+19|0]>=0))break k;Z(i[A+8>>2])}if(A=l[t+36|0],(A|0)!=255&&(e=i[26691],i[t+168>>2]=i[26690],i[t+172>>2]=e,X[i[(t+168|0)+(A<<2)>>2]](t+167|0,t+16|0)),!f)break A}i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0}if(A=l[t+60|0],(A|0)!=255&&(e=i[26699],i[t+16>>2]=i[26698],i[t+20>>2]=e,X[i[(t+16|0)+(A<<2)>>2]](t+168|0,t+40|0)),l[t+120|0]!=1|u[t+119|0]>=0||Z(i[t+108>>2]),u[t+83|0]>=0)break f;Z(i[t+72>>2])}if(A=i[t+92>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=l[t+148|0],(A|0)!=255&&(e=i[26691],i[t+104>>2]=i[26690],i[t+108>>2]=e,X[i[(t+104|0)+(A<<2)>>2]](t+40|0,t+128|0)),A=i[t+100>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+176|0;return}_2(),H()}function a_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;o=v+-64|0,v=o,B=i[e+116>>2],m=t+4|0,h=m,s=h,w=i[t+4>>2];i:{e:{r:{if(!w)break r;for(s=w;_=B>>>0>u0[s+16>>2],h=_?h:s,s=i[(_?4:0)+s>>2],!!s;);if(!((h|0)==(m|0)|B>>>0<u0[h+16>>2])){f=E(32),i[o+28>>2]=f,i[o+32>>2]=28,i[o+36>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=K(o+40|0,2,0,o+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+39|0]>=0)break i;Z(i[o+28>>2]);break i}for(;;){if(s=w,w=i[s+16>>2],w>>>0>B>>>0){if(h=s,w=i[s>>2],w)continue;break r}if(w>>>0>=B>>>0)break e;if(w=i[s+4>>2],!w)break}h=s+4|0}w=E(20),i[w+8>>2]=s,i[w>>2]=0,i[w+4>>2]=0,i[w+16>>2]=B,i[h>>2]=w,s=i[i[t>>2]>>2],s&&(i[t>>2]=s),m1(i[t+4>>2],w),i[t+8>>2]=i[t+8>>2]+1}s=i[e+100>>2],i[o+40>>2]=i[s+48>>2],s=i[s+52>>2],i[o+44>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[o+40>>2],w=i[s+84>>2],_=i[s+88>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),h=i[o+44>>2];e:{if(!h||(s=i[h+4>>2],i[h+4>>2]=s-1,s))break e;X[i[i[h>>2]+8>>2]](h),p(h)}e:{if(!w){f=E(56),i[o+28>>2]=f,i[o+32>>2]=48,i[o+36>>2]=-2147483592,r=l[14327]|l[14328]<<8|(l[14329]<<16|l[14330]<<24),e=l[14323]|l[14324]<<8|(l[14325]<<16|l[14326]<<24),u[f+40|0]=e,u[f+41|0]=e>>>8,u[f+42|0]=e>>>16,u[f+43|0]=e>>>24,u[f+44|0]=r,u[f+45|0]=r>>>8,u[f+46|0]=r>>>16,u[f+47|0]=r>>>24,r=l[14319]|l[14320]<<8|(l[14321]<<16|l[14322]<<24),e=l[14315]|l[14316]<<8|(l[14317]<<16|l[14318]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[14311]|l[14312]<<8|(l[14313]<<16|l[14314]<<24),e=l[14307]|l[14308]<<8|(l[14309]<<16|l[14310]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[14303]|l[14304]<<8|(l[14305]<<16|l[14306]<<24),e=l[14299]|l[14300]<<8|(l[14301]<<16|l[14302]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[14295]|l[14296]<<8|(l[14297]<<16|l[14298]<<24),e=l[14291]|l[14292]<<8|(l[14293]<<16|l[14294]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[14287]|l[14288]<<8|(l[14289]<<16|l[14290]<<24),e=l[14283]|l[14284]<<8|(l[14285]<<16|l[14286]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+48|0]=0,f=K(o+40|0,2,113,o+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[o+39|0]>=0)break e;Z(i[o+28>>2]);break e}L8(o+28|0,w,i[e+116>>2],1684630887),s=i[o+32>>2],w=i[o+28>>2];r:{if(s-w>>>0>=5){f=E(48),i[o+16>>2]=f,i[o+20>>2]=47,i[o+24>>2]=-2147483600,r=l[14886]|l[14887]<<8|(l[14888]<<16|l[14889]<<24),e=l[14882]|l[14883]<<8|(l[14884]<<16|l[14885]<<24),u[f+39|0]=e,u[f+40|0]=e>>>8,u[f+41|0]=e>>>16,u[f+42|0]=e>>>24,u[f+43|0]=r,u[f+44|0]=r>>>8,u[f+45|0]=r>>>16,u[f+46|0]=r>>>24,r=l[14879]|l[14880]<<8|(l[14881]<<16|l[14882]<<24),e=l[14875]|l[14876]<<8|(l[14877]<<16|l[14878]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[14871]|l[14872]<<8|(l[14873]<<16|l[14874]<<24),e=l[14867]|l[14868]<<8|(l[14869]<<16|l[14870]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[14863]|l[14864]<<8|(l[14865]<<16|l[14866]<<24),e=l[14859]|l[14860]<<8|(l[14861]<<16|l[14862]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[14855]|l[14856]<<8|(l[14857]<<16|l[14858]<<24),e=l[14851]|l[14852]<<8|(l[14853]<<16|l[14854]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[14847]|l[14848]<<8|(l[14849]<<16|l[14850]<<24),e=l[14843]|l[14844]<<8|(l[14845]<<16|l[14846]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+47|0]=0,f=K(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}if((s|0)==(w|0)){f=E(40),i[o+16>>2]=f,i[o+20>>2]=37,i[o+24>>2]=-2147483608,r=l[15451]|l[15452]<<8|(l[15453]<<16|l[15454]<<24),e=l[15447]|l[15448]<<8|(l[15449]<<16|l[15450]<<24),u[f+29|0]=e,u[f+30|0]=e>>>8,u[f+31|0]=e>>>16,u[f+32|0]=e>>>24,u[f+33|0]=r,u[f+34|0]=r>>>8,u[f+35|0]=r>>>16,u[f+36|0]=r>>>24,r=l[15446]|l[15447]<<8|(l[15448]<<16|l[15449]<<24),e=l[15442]|l[15443]<<8|(l[15444]<<16|l[15445]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[15438]|l[15439]<<8|(l[15440]<<16|l[15441]<<24),e=l[15434]|l[15435]<<8|(l[15436]<<16|l[15437]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[15430]|l[15431]<<8|(l[15432]<<16|l[15433]<<24),e=l[15426]|l[15427]<<8|(l[15428]<<16|l[15429]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[15422]|l[15423]<<8|(l[15424]<<16|l[15425]<<24),e=l[15418]|l[15419]<<8|(l[15420]<<16|l[15421]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+37|0]=0,f=K(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}if(w=i[w>>2],(w|0)==i[e+116>>2]){f=E(40),i[o+16>>2]=f,i[o+20>>2]=32,i[o+24>>2]=-2147483608,r=l[11337]|l[11338]<<8|(l[11339]<<16|l[11340]<<24),e=l[11333]|l[11334]<<8|(l[11335]<<16|l[11336]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[11329]|l[11330]<<8|(l[11331]<<16|l[11332]<<24),e=l[11325]|l[11326]<<8|(l[11327]<<16|l[11328]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[11321]|l[11322]<<8|(l[11323]<<16|l[11324]<<24),e=l[11317]|l[11318]<<8|(l[11319]<<16|l[11320]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[11313]|l[11314]<<8|(l[11315]<<16|l[11316]<<24),e=l[11309]|l[11310]<<8|(l[11311]<<16|l[11312]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+32|0]=0,f=K(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}s=o+40|0,r4(s,i[e+100>>2],w,1),h=i[o+44>>2],w=i[o+40>>2];f:{if(!w){r=d2(o+16|0,14801),k=K(s,2,0,r),e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,f=A+8|0;A:{if(u[k+19|0]>=0){e=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=e,i[f+8>>2]=i[k+16>>2],u[A+20|0]=1;break A}if(T(f,i[k+8>>2],i[k+12>>2]),e=u[k+19|0],u[A+20|0]=1,(e|0)>=0)break A;Z(i[k+8>>2])}if(u[r+11|0]>=0)break f;Z(i[r>>2]);break f}if(X[i[i[w>>2]+52>>2]](o+40|0,w),i[o+40>>2]){if(e=i[o+44>>2],i[A>>2]=i[o+40>>2],i[A+4>>2]=e,r=A+8|0,u[o+59|0]>=0){e=i[o+52>>2],i[r>>2]=i[o+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+56>>2],u[A+20|0]=1;break f}if(T(r,i[o+48>>2],i[o+52>>2]),e=u[o+59|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[o+48>>2]);break f}u[o+59|0]<0&&Z(i[o+48>>2]),i[o+8>>2]=0,i[o+12>>2]=0,i[o+4>>2]=o+8,e=o+4|0,t8(e,i[t>>2],m),X[i[i[w>>2]+100>>2]](A,w,r,f,k,n,e),Y1(e,i[o+8>>2])}if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break r;X[i[i[h>>2]+8>>2]](h),p(h)}if(A=i[o+28>>2],!A)break e;i[o+32>>2]=A,Z(A)}if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;X[i[i[_>>2]+8>>2]](_),p(_)}v=o- -64|0}function p2(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;h=v-16|0,v=h;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(A>>>0<=244){if(k=i[31650],t=A>>>0<11?16:A+11&504,A=t>>>3|0,e=k>>>A|0,e&3){r=A+((e^-1)&1)|0,e=r<<3,A=e+126640|0,e=i[e+126648>>2],f=i[e+8>>2];l:{if((A|0)==(f|0)){B=126600,m=k2(-2,r)&k,i[B>>2]=m;break l}i[f+12>>2]=A,i[A+8>>2]=f}A=e+8|0,r=r<<3,i[e+4>>2]=r|3,e=e+r|0,i[e+4>>2]=i[e+4>>2]|1;break i}if(s=i[31652],s>>>0>=t>>>0)break o;if(e){r=2<<A,A=e8((0-r|r)&e<<A),r=A<<3,e=r+126640|0,r=i[r+126648>>2],f=i[r+8>>2];l:{if((e|0)==(f|0)){k=k2(-2,A)&k,i[31650]=k;break l}i[f+12>>2]=e,i[e+8>>2]=f}if(i[r+4>>2]=t|3,o=r+t|0,A=A<<3,n=A-t|0,i[o+4>>2]=n|1,i[A+r>>2]=n,s){A=(s&-8)+126640|0,f=i[31655],e=1<<(s>>>3);l:{if(!(e&k)){i[31650]=e|k,e=A;break l}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}A=r+8|0,i[31655]=o,i[31652]=n;break i}if(_=i[31651],!_)break o;for(r=i[(e8(_)<<2)+126904>>2],n=(i[r+4>>2]&-8)-t|0,e=r;;){l:{if(A=i[e+16>>2],!A&&(A=i[e+20>>2],!A))break l;f=(i[A+4>>2]&-8)-t|0,e=f>>>0<n>>>0,n=e?f:n,r=e?A:r,e=A;continue}break}if(w=i[r+24>>2],A=i[r+12>>2],(r|0)!=(A|0)){e=i[r+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break e}if(e=i[r+20>>2],e)f=r+20|0;else{if(e=i[r+16>>2],!e)break u;f=r+16|0}for(;o=f,A=e,f=A+20|0,e=i[A+20>>2],!(!e&&(f=A+16|0,e=i[A+16>>2],!e)););i[o>>2]=0;break e}if(t=-1,A>>>0>4294967231||(e=A+11|0,t=e&-8,o=i[31651],!o))break o;s=31,n=0-t|0,A>>>0<=16777204&&(A=k1(e>>>8|0),s=((t>>>38-A&1)-(A<<1)|0)+62|0),e=i[(s<<2)+126904>>2];l:{s:{w:{if(!e){A=0;break w}for(A=0,r=t<<((s|0)!=31?25-(s>>>1|0)|0:0);;){_:{if(k=(i[e+4>>2]&-8)-t|0,k>>>0>=n>>>0||(f=e,n=k,n))break _;n=0,A=e;break s}if(k=i[e+20>>2],e=i[((r>>>29&4)+e|0)+16>>2],A=k?(k|0)==(e|0)?A:k:A,r=r<<1,!e)break}}if(!(A|f)){if(f=0,A=2<<s,A=(0-A|A)&o,!A)break o;A=i[(e8(A)<<2)+126904>>2]}if(!A)break l}for(;r=(i[A+4>>2]&-8)-t|0,e=r>>>0<n>>>0,n=e?r:n,f=e?A:f,e=i[A+16>>2],e?A=e:A=i[A+20>>2],!!A;);}if(!f|i[31652]-t>>>0<=n>>>0)break o;if(s=i[f+24>>2],A=i[f+12>>2],(f|0)!=(A|0)){e=i[f+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break r}if(e=i[f+20>>2],e)r=f+20|0;else{if(e=i[f+16>>2],!e)break t;r=f+16|0}for(;k=r,A=e,r=A+20|0,e=i[A+20>>2],!(!e&&(r=A+16|0,e=i[A+16>>2],!e)););i[k>>2]=0;break r}if(f=i[31652],f>>>0>=t>>>0){A=i[31655],e=f-t|0;o:{if(e>>>0>=16){r=A+t|0,i[r+4>>2]=e|1,i[A+f>>2]=e,i[A+4>>2]=t|3;break o}i[A+4>>2]=f|3,e=A+f|0,i[e+4>>2]=i[e+4>>2]|1,r=0,e=0}i[31652]=e,i[31655]=r,A=A+8|0;break i}if(r=i[31653],r>>>0>t>>>0){e=r-t|0,i[31653]=e,A=i[31656],r=A+t|0,i[31656]=r,i[r+4>>2]=e|1,i[A+4>>2]=t|3,A=A+8|0;break i}if(A=0,n=t+47|0,i[31768]?e=i[31770]:(i[31771]=-1,i[31772]=-1,i[31769]=4096,i[31770]=4096,i[31768]=h+12&-16^1431655768,i[31773]=0,i[31761]=0,e=4096),k=n+e|0,o=0-e|0,e=k&o,e>>>0<=t>>>0||(s=i[31760],s&&(w=i[31758],f=w+e|0,f>>>0<=w>>>0|f>>>0>s>>>0)))break i;o:{if(!(l[127044]&4)){l:{s:{w:{_:{if(f=i[31656],f)for(A=127048;;){if(s=i[A>>2],s>>>0<=f>>>0&f>>>0<s+i[A+4>>2]>>>0)break _;if(A=i[A+8>>2],!A)break}if(r=Xi(0),(r|0)==-1||(k=e,A=i[31769],f=A-1|0,f&r&&(k=(e-r|0)+(r+f&0-A)|0),k>>>0<=t>>>0)||(f=i[31760],f&&(o=i[31758],A=o+k|0,A>>>0<=o>>>0|A>>>0>f>>>0)))break l;if(A=Xi(k),(r|0)!=(A|0))break w;break o}if(k=o&k-r,r=Xi(k),(r|0)==(i[A>>2]+i[A+4>>2]|0))break s;A=r}if((A|0)==-1)break l;if(t+48>>>0<=k>>>0){r=A;break o}if(r=i[31770],r=r+(n-k|0)&0-r,(Xi(r)|0)==-1)break l;k=r+k|0,r=A;break o}if((r|0)!=-1)break o}i[31761]=i[31761]|4}if(r=Xi(e),A=Xi(0),(r|0)==-1|(A|0)==-1|A>>>0<=r>>>0||(k=A-r|0,k>>>0<=t+40>>>0))break A}A=i[31758]+k|0,i[31758]=A,A>>>0>u0[31759]&&(i[31759]=A);o:{if(n=i[31656],n){for(A=127048;;){if(e=i[A>>2],f=i[A+4>>2],(e+f|0)==(r|0))break o;if(A=i[A+8>>2],!A)break}break n}for(A=i[31654],A>>>0<=r>>>0&&A||(i[31654]=r),A=0,i[31763]=k,i[31762]=r,i[31658]=-1,i[31659]=i[31768],i[31765]=0;e=A<<3,f=e+126640|0,i[e+126648>>2]=f,i[e+126652>>2]=f,A=A+1|0,(A|0)!=32;);A=k-40|0,e=-8-r&7,f=A-e|0,i[31653]=f,e=e+r|0,i[31656]=e,i[e+4>>2]=f|1,i[(A+r|0)+4>>2]=40,i[31657]=i[31772];break k}if(i[A+12>>2]&8|(r>>>0<=n>>>0|e>>>0>n>>>0))break n;i[A+4>>2]=f+k,A=-8-n&7,e=A+n|0,i[31656]=e,r=i[31653]+k|0,A=r-A|0,i[31653]=A,i[e+4>>2]=A|1,i[(r+n|0)+4>>2]=40,i[31657]=i[31772];break k}A=0;break e}A=0;break r}u0[31654]>r>>>0&&(i[31654]=r),f=r+k|0,A=127048;n:{for(;;){if(e=i[A>>2],(e|0)!=(f|0)){if(A=i[A+8>>2],A)continue;break n}break}if(!(l[A+12|0]&8))break f}for(A=127048;;){n:{if(e=i[A>>2],e>>>0<=n>>>0&&(f=e+i[A+4>>2]|0,f>>>0>n>>>0))break n;A=i[A+8>>2];continue}break}for(A=k-40|0,e=-8-r&7,o=A-e|0,i[31653]=o,e=e+r|0,i[31656]=e,i[e+4>>2]=o|1,i[(A+r|0)+4>>2]=40,i[31657]=i[31772],A=(f+(39-f&7)|0)-47|0,e=A>>>0<n+16>>>0?n:A,i[e+4>>2]=27,A=i[31765],i[e+16>>2]=i[31764],i[e+20>>2]=A,A=i[31763],i[e+8>>2]=i[31762],i[e+12>>2]=A,i[31764]=e+8,i[31763]=k,i[31762]=r,i[31765]=0,A=e+24|0;i[A+4>>2]=7,r=A+8|0,A=A+4|0,r>>>0<f>>>0;);if((e|0)==(n|0))break k;i[e+4>>2]=i[e+4>>2]&-2,r=e-n|0,i[n+4>>2]=r|1,i[e>>2]=r;n:{if(r>>>0<=255){A=(r&-8)+126640|0,e=i[31650],r=1<<(r>>>3);t:{if(!(e&r)){i[31650]=e|r,e=A;break t}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,f=8,r=12;break n}A=31,r>>>0<=16777215&&(A=k1(r>>>8|0),A=((r>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=A,i[n+16>>2]=0,i[n+20>>2]=0,e=(A<<2)+126904|0;t:{f=i[31651],k=1<<A;u:{if(!(f&k)){i[31651]=f|k,i[e>>2]=n;break u}for(A=r<<((A|0)!=31?25-(A>>>1|0)|0:0),f=i[e>>2];;){if(e=f,(r|0)==(i[e+4>>2]&-8))break t;if(f=A>>>29|0,A=A<<1,k=(f&4)+e|0,f=i[k+16>>2],!f)break}i[k+16>>2]=n}i[n+24>>2]=e,e=n,A=e,f=12,r=8;break n}A=i[e+8>>2],i[A+12>>2]=n,i[e+8>>2]=n,i[n+8>>2]=A,A=0,f=12,r=24}i[f+n>>2]=e,i[r+n>>2]=A}if(A=i[31653],A>>>0<=t>>>0)break A;e=A-t|0,i[31653]=e,A=i[31656],r=A+t|0,i[31656]=r,i[r+4>>2]=e|1,i[A+4>>2]=t|3,A=A+8|0;break i}i[31336]=48,A=0;break i}i[A>>2]=r,i[A+4>>2]=i[A+4>>2]+k,s=(-8-r&7)+r|0,i[s+4>>2]=t|3,k=e+(-8-e&7)|0,n=t+s|0,o=k-n|0;f:{if(i[31656]==(k|0)){i[31656]=n,A=i[31653]+o|0,i[31653]=A,i[n+4>>2]=A|1;break f}if(i[31655]==(k|0)){i[31655]=n,A=i[31652]+o|0,i[31652]=A,i[n+4>>2]=A|1,i[A+n>>2]=A;break f}if(A=i[k+4>>2],(A&3)==1){w=A&-8,r=i[k+12>>2];A:{if(A>>>0<=255){if(e=i[k+8>>2],(e|0)==(r|0)){B=126600,m=i[31650]&k2(-2,A>>>3|0),i[B>>2]=m;break A}i[e+12>>2]=r,i[r+8>>2]=e;break A}t=i[k+24>>2];k:{if((r|0)!=(k|0)){A=i[k+8>>2],i[A+12>>2]=r,i[r+8>>2]=A;break k}n:{if(A=i[k+20>>2],A)e=k+20|0;else{if(A=i[k+16>>2],!A)break n;e=k+16|0}for(;f=e,r=A,e=A+20|0,A=i[A+20>>2],!(!A&&(e=r+16|0,A=i[r+16>>2],!A)););i[f>>2]=0;break k}r=0}if(!t)break A;A=i[k+28>>2],e=(A<<2)+126904|0;k:{if(i[e>>2]==(k|0)){if(i[e>>2]=r,r)break k;B=126604,m=i[31651]&k2(-2,A),i[B>>2]=m;break A}n:{if(i[t+16>>2]==(k|0)){i[t+16>>2]=r;break n}i[t+20>>2]=r}if(!r)break A}if(i[r+24>>2]=t,A=i[k+16>>2],A&&(i[r+16>>2]=A,i[A+24>>2]=r),A=i[k+20>>2],!A)break A;i[r+20>>2]=A,i[A+24>>2]=r}o=o+w|0,k=k+w|0,A=i[k+4>>2]}if(i[k+4>>2]=A&-2,i[n+4>>2]=o|1,i[n+o>>2]=o,o>>>0<=255){A=(o&-8)+126640|0,e=i[31650],r=1<<(o>>>3);A:{if(!(e&r)){i[31650]=e|r,e=A;break A}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,i[n+12>>2]=A,i[n+8>>2]=e;break f}r=31,o>>>0<=16777215&&(A=k1(o>>>8|0),r=((o>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=r,i[n+16>>2]=0,i[n+20>>2]=0,A=(r<<2)+126904|0;A:{e=i[31651],f=1<<r;k:{if(!(e&f)){i[31651]=e|f,i[A>>2]=n;break k}for(r=o<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[A>>2];;){if(A=e,(i[A+4>>2]&-8)==(o|0))break A;if(e=r>>>29|0,r=r<<1,f=(e&4)+A|0,e=i[f+16>>2],!e)break}i[f+16>>2]=n}i[n+24>>2]=A,i[n+12>>2]=n,i[n+8>>2]=n;break f}e=i[A+8>>2],i[e+12>>2]=n,i[A+8>>2]=n,i[n+24>>2]=0,i[n+12>>2]=A,i[n+8>>2]=e}A=s+8|0;break i}r:{if(!s)break r;e=i[f+28>>2],r=(e<<2)+126904|0;f:{if(i[r>>2]==(f|0)){if(i[r>>2]=A,A)break f;o=k2(-2,e)&o,i[31651]=o;break r}A:{if(i[s+16>>2]==(f|0)){i[s+16>>2]=A;break A}i[s+20>>2]=A}if(!A)break r}if(i[A+24>>2]=s,e=i[f+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[f+20>>2],!e)break r;i[A+20>>2]=e,i[e+24>>2]=A}r:{if(n>>>0<=15){A=n+t|0,i[f+4>>2]=A|3,A=A+f|0,i[A+4>>2]=i[A+4>>2]|1;break r}if(i[f+4>>2]=t|3,k=f+t|0,i[k+4>>2]=n|1,i[n+k>>2]=n,n>>>0<=255){A=(n&-8)+126640|0,e=i[31650],r=1<<(n>>>3);f:{if(!(e&r)){i[31650]=e|r,e=A;break f}e=i[A+8>>2]}i[A+8>>2]=k,i[e+12>>2]=k,i[k+12>>2]=A,i[k+8>>2]=e;break r}A=31,n>>>0<=16777215&&(A=k1(n>>>8|0),A=((n>>>38-A&1)-(A<<1)|0)+62|0),i[k+28>>2]=A,i[k+16>>2]=0,i[k+20>>2]=0,e=(A<<2)+126904|0;f:{r=1<<A;A:{if(!(r&o)){i[31651]=r|o,i[e>>2]=k,i[k+24>>2]=e;break A}for(A=n<<((A|0)!=31?25-(A>>>1|0)|0:0),e=i[e>>2];;){if(r=e,(i[e+4>>2]&-8)==(n|0))break f;if(o=A>>>29|0,A=A<<1,o=e+(o&4)|0,e=i[o+16>>2],!e)break}i[o+16>>2]=k,i[k+24>>2]=r}i[k+12>>2]=k,i[k+8>>2]=k;break r}A=i[r+8>>2],i[A+12>>2]=k,i[r+8>>2]=k,i[k+24>>2]=0,i[k+12>>2]=r,i[k+8>>2]=A}A=f+8|0;break i}e:{if(!w)break e;e=i[r+28>>2],f=(e<<2)+126904|0;r:{if(i[f>>2]==(r|0)){if(i[f>>2]=A,A)break r;B=126604,m=k2(-2,e)&_,i[B>>2]=m;break e}f:{if(i[w+16>>2]==(r|0)){i[w+16>>2]=A;break f}i[w+20>>2]=A}if(!A)break e}if(i[A+24>>2]=w,e=i[r+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[r+20>>2],!e)break e;i[A+20>>2]=e,i[e+24>>2]=A}e:{if(n>>>0<=15){A=n+t|0,i[r+4>>2]=A|3,A=A+r|0,i[A+4>>2]=i[A+4>>2]|1;break e}if(i[r+4>>2]=t|3,o=r+t|0,i[o+4>>2]=n|1,i[n+o>>2]=n,s){A=(s&-8)+126640|0,f=i[31655],e=1<<(s>>>3);r:{if(!(e&k)){i[31650]=e|k,e=A;break r}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}i[31655]=o,i[31652]=n}A=r+8|0}return v=h+16|0,A|0}function $_(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,o=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+100|0]),l2(r,l[e+101|0]),l2(r,l[e+102|0]),l2(r,l[e+103|0]),l2(r,(l[e+104|0]-1|252)&255),f=(i[e+120>>2]-i[e+116>>2]|0)/12|0;i:{if(f>>>0>=32){if(e=E(48),i[k+20>>2]=e,i[k+24>>2]=44,i[k+28>>2]=-2147483600,r=l[22768]|l[22769]<<8|(l[22770]<<16|l[22771]<<24),f=l[22764]|l[22765]<<8|(l[22766]<<16|l[22767]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[22804]|l[22805]<<8|(l[22806]<<16|l[22807]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[22800]|l[22801]<<8|(l[22802]<<16|l[22803]<<24),f=l[22796]|l[22797]<<8|(l[22798]<<16|l[22799]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22792]|l[22793]<<8|(l[22794]<<16|l[22795]<<24),f=l[22788]|l[22789]<<8|(l[22790]<<16|l[22791]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22784]|l[22785]<<8|(l[22786]<<16|l[22787]<<24),f=l[22780]|l[22781]<<8|(l[22782]<<16|l[22783]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22776]|l[22777]<<8|(l[22778]<<16|l[22779]<<24),f=l[22772]|l[22773]<<8|(l[22774]<<16|l[22775]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(l2(r,(f|224)&255),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=E(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=l[22610]|l[22611]<<8|(l[22612]<<16|l[22613]<<24),f=l[22606]|l[22607]<<8|(l[22608]<<16|l[22609]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[22657]|l[22658]<<8|(l[22659]<<16|l[22660]<<24),f=l[22653]|l[22654]<<8|(l[22655]<<16|l[22656]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[22650]|l[22651]<<8|(l[22652]<<16|l[22653]<<24),f=l[22646]|l[22647]<<8|(l[22648]<<16|l[22649]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22642]|l[22643]<<8|(l[22644]<<16|l[22645]<<24),f=l[22638]|l[22639]<<8|(l[22640]<<16|l[22641]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22634]|l[22635]<<8|(l[22636]<<16|l[22637]<<24),f=l[22630]|l[22631]<<8|(l[22632]<<16|l[22633]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22626]|l[22627]<<8|(l[22628]<<16|l[22629]<<24),f=l[22622]|l[22623]<<8|(l[22624]<<16|l[22625]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22618]|l[22619]<<8|(l[22620]<<16|l[22621]<<24),f=l[22614]|l[22615]<<8|(l[22616]<<16|l[22617]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),V4(r,f),f=f+12|0,(n|0)==(f|0))break}if(f=(i[e+132>>2]-i[e+128>>2]|0)/12|0,f>>>0>=256){if(e=E(48),i[k+20>>2]=e,i[k+24>>2]=45,i[k+28>>2]=-2147483600,r=l[22722]|l[22723]<<8|(l[22724]<<16|l[22725]<<24),f=l[22718]|l[22719]<<8|(l[22720]<<16|l[22721]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+45|0]=0,r=l[22759]|l[22760]<<8|(l[22761]<<16|l[22762]<<24),f=l[22755]|l[22756]<<8|(l[22757]<<16|l[22758]<<24),u[e+37|0]=f,u[e+38|0]=f>>>8,u[e+39|0]=f>>>16,u[e+40|0]=f>>>24,u[e+41|0]=r,u[e+42|0]=r>>>8,u[e+43|0]=r>>>16,u[e+44|0]=r>>>24,r=l[22754]|l[22755]<<8|(l[22756]<<16|l[22757]<<24),f=l[22750]|l[22751]<<8|(l[22752]<<16|l[22753]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22746]|l[22747]<<8|(l[22748]<<16|l[22749]<<24),f=l[22742]|l[22743]<<8|(l[22744]<<16|l[22745]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22738]|l[22739]<<8|(l[22740]<<16|l[22741]<<24),f=l[22734]|l[22735]<<8|(l[22736]<<16|l[22737]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22730]|l[22731]<<8|(l[22732]<<16|l[22733]<<24),f=l[22726]|l[22727]<<8|(l[22728]<<16|l[22729]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(l2(r,f),f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=E(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=l[22666]|l[22667]<<8|(l[22668]<<16|l[22669]<<24),f=l[22662]|l[22663]<<8|(l[22664]<<16|l[22665]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[22713]|l[22714]<<8|(l[22715]<<16|l[22716]<<24),f=l[22709]|l[22710]<<8|(l[22711]<<16|l[22712]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[22706]|l[22707]<<8|(l[22708]<<16|l[22709]<<24),f=l[22702]|l[22703]<<8|(l[22704]<<16|l[22705]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22698]|l[22699]<<8|(l[22700]<<16|l[22701]<<24),f=l[22694]|l[22695]<<8|(l[22696]<<16|l[22697]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22690]|l[22691]<<8|(l[22692]<<16|l[22693]<<24),f=l[22686]|l[22687]<<8|(l[22688]<<16|l[22689]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22682]|l[22683]<<8|(l[22684]<<16|l[22685]<<24),f=l[22678]|l[22679]<<8|(l[22680]<<16|l[22681]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22674]|l[22675]<<8|(l[22676]<<16|l[22677]<<24),f=l[22670]|l[22671]<<8|(l[22672]<<16|l[22673]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),V4(r,f),f=f+12|0,(n|0)==(f|0))break}f=l[e+101|0]-66|0;e:{if(1<<f&4196353&&f>>>0<=22)break e;if(l2(r,l[e+108|0]),l2(r,l[e+112|0]-8&255),l2(r,l[e+113|0]-8&255),f=(i[e+144>>2]-i[e+140>>2]|0)/12|0,f>>>0>=256){if(e=A,A=d2(k+20|0,22496),K(e,9,0,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(l2(r,f),f=i[e+140>>2],n=i[e+144>>2],(f|0)==(n|0))break e;for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=E(64),i[k+20>>2]=e,i[k+24>>2]=59,i[k+28>>2]=-2147483584,r=l[22550]|l[22551]<<8|(l[22552]<<16|l[22553]<<24),f=l[22546]|l[22547]<<8|(l[22548]<<16|l[22549]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+59|0]=0,r=l[22601]|l[22602]<<8|(l[22603]<<16|l[22604]<<24),u[e+55|0]=r,u[e+56|0]=r>>>8,u[e+57|0]=r>>>16,u[e+58|0]=r>>>24,r=l[22598]|l[22599]<<8|(l[22600]<<16|l[22601]<<24),f=l[22594]|l[22595]<<8|(l[22596]<<16|l[22597]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[22590]|l[22591]<<8|(l[22592]<<16|l[22593]<<24),f=l[22586]|l[22587]<<8|(l[22588]<<16|l[22589]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22582]|l[22583]<<8|(l[22584]<<16|l[22585]<<24),f=l[22578]|l[22579]<<8|(l[22580]<<16|l[22581]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22574]|l[22575]<<8|(l[22576]<<16|l[22577]<<24),f=l[22570]|l[22571]<<8|(l[22572]<<16|l[22573]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22566]|l[22567]<<8|(l[22568]<<16|l[22569]<<24),f=l[22562]|l[22563]<<8|(l[22564]<<16|l[22565]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22558]|l[22559]<<8|(l[22560]<<16|l[22561]<<24),f=l[22554]|l[22555]<<8|(l[22556]<<16|l[22557]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),V4(r,f),f=f+12|0,(n|0)==(f|0))break}}if(f1(k,e,r,o),u[k+19|0]<0&&Z(i[k+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function d_(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0;V=v-32|0,v=V,s=v+-64|0,v=s,k=i[e+100>>2],r=i[k+48>>2],g=i[k+52>>2],g&&(i[g+4>>2]=i[g+4>>2]+1),k=i[r+84>>2],I=i[r+88>>2],I&&(i[I+4>>2]=i[I+4>>2]+1),m=V+8|0;i:{if(!k){if(e=E(56),i[s+40>>2]=e,i[s+44>>2]=48,i[s+48>>2]=-2147483592,r=l[14380]|l[14381]<<8|(l[14382]<<16|l[14383]<<24),k=l[14376]|l[14377]<<8|(l[14378]<<16|l[14379]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+48|0]=0,r=l[14420]|l[14421]<<8|(l[14422]<<16|l[14423]<<24),k=l[14416]|l[14417]<<8|(l[14418]<<16|l[14419]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[14412]|l[14413]<<8|(l[14414]<<16|l[14415]<<24),k=l[14408]|l[14409]<<8|(l[14410]<<16|l[14411]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[14404]|l[14405]<<8|(l[14406]<<16|l[14407]<<24),k=l[14400]|l[14401]<<8|(l[14402]<<16|l[14403]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[14396]|l[14397]<<8|(l[14398]<<16|l[14399]<<24),k=l[14392]|l[14393]<<8|(l[14394]<<16|l[14395]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[14388]|l[14389]<<8|(l[14390]<<16|l[14391]<<24),k=l[14384]|l[14385]<<8|(l[14386]<<16|l[14387]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(m,2,113,s+40|0),u[s+51|0]>=0)break i;Z(i[s+40>>2]);break i}L8(s+40|0,k,i[e+116>>2],1684630887),k=i[e+480>>2],k&&(i[e+484>>2]=k,Z(k)),i[e+480>>2]=i[s+40>>2],i[e+484>>2]=i[s+44>>2],i[e+488>>2]=i[s+48>>2],a6(s+40|0,r,i[e+116>>2]);e:{r:switch(l[s+60|0]){default:_2(),H();case 1:if(e=i[s+44>>2],i[m>>2]=i[s+40>>2],i[m+4>>2]=e,e=m+8|0,u[s+59|0]>=0){r=i[s+52>>2],i[e>>2]=i[s+48>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+56>>2];break e}T(e,i[s+48>>2],i[s+52>>2]);break e;case 0:break r}B=s+16|0,w=e+448|0,y=i[e+484>>2]-i[e+480>>2]>>2,o=v-192|0,v=o,r=E(32),i[o+20>>2]=r,i[o+24>>2]=29,i[o+28>>2]=-2147483616,k=l[12152]|l[12153]<<8|(l[12154]<<16|l[12155]<<24),t=l[12148]|l[12149]<<8|(l[12150]<<16|l[12151]<<24),u[r+21|0]=t,u[r+22|0]=t>>>8,u[r+23|0]=t>>>16,u[r+24|0]=t>>>24,u[r+25|0]=k,u[r+26|0]=k>>>8,u[r+27|0]=k>>>16,u[r+28|0]=k>>>24,k=l[12147]|l[12148]<<8|(l[12149]<<16|l[12150]<<24),t=l[12143]|l[12144]<<8|(l[12145]<<16|l[12146]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[12139]|l[12140]<<8|(l[12141]<<16|l[12142]<<24),t=l[12135]|l[12136]<<8|(l[12137]<<16|l[12138]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,k=l[12131]|l[12132]<<8|(l[12133]<<16|l[12134]<<24),t=l[12127]|l[12128]<<8|(l[12129]<<16|l[12130]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+29|0]=0,k=K(o+168|0,2,121,o+20|0),u[o+31|0]<0&&Z(i[o+20>>2]),r=i[s+40>>2],n=i[s+44>>2]-r|0;r:{if(n>>>0<=9){r=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=r,i[B+16>>2]=i[k+16>>2],r=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=r,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;break r}t=l[r|0],u[w|0]=t;f:{A:{k:{if(t){i[o+112>>2]=0,i[o+84>>2]=72244,i[o+28>>2]=72224,r=i[18065],i[o+20>>2]=r,n=i[r-12>>2],r=o+20|0,i[n+r>>2]=i[18066],i[o+24>>2]=0,f=r+i[i[o+20>>2]-12>>2]|0,t=o+32|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[o+28>>2]=f,n=i[f-12>>2],f=o+28|0,i[n+f>>2]=i[18068],n=i[18064],i[o+20>>2]=n,i[r+i[n-12>>2]>>2]=i[18069],i[o+84>>2]=72244,i[o+20>>2]=72204,i[o+28>>2]=72224,n=R0(t),i[n>>2]=71280,i[o+72>>2]=0,i[o+76>>2]=0,i[o+64>>2]=0,i[o+68>>2]=0,i[o+80>>2]=24,Y(S0(Y(f,28072,27),l[w|0]),4165,23),r=i[o+80>>2];n:{if(r&16){f=o+52|0,t=i[o+76>>2],r=i[o+56>>2],t>>>0<r>>>0?i[o+76>>2]=r:r=t;break n}if(!(r&8)){r=0,u[o+19|0]=0,f=o+8|0;break f}f=o+40|0,r=i[o+48>>2]}if(t=i[f>>2],r=r-t|0,r>>>0>=2147483640)break k;if(r>>>0>=11){w=r|7,f=E(w+1|0),i[o+16>>2]=w-2147483647,i[o+8>>2]=f,i[o+12>>2]=r;break A}if(u[o+19|0]=r,f=o+8|0,r)break A;r=0;break f}if(t=l[r+1|0],u[w+1|0]=t,r=10,N=t&1,W=N?4:2,x=W<<1,t=x+10|0,n>>>0>=t+(y<<1<<(N?2:1))>>>0){if(n=i[s+40>>2],n=l[n+2|0]|l[n+3|0]<<8,Q[w+2>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+4|0]|l[n+5|0]<<8,Q[w+4>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+6|0]|l[n+7|0]<<8,Q[w+6>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+8|0]|l[n+9|0]<<8,Q[w+8>>1]=n<<8|n>>>8,_=i[s+40>>2],N){for(C=W&4;n=r,r=r+4|0,h=h+4|0,(C|0)!=(h|0););n=n+_|0,n=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),h=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24)}if(n=W&2,n)for(;h=l[r+_|0]|h<<8,r=r+1|0,f=f+1|0,(n|0)!=(f|0););if(i[w+12>>2]=h,C=W&2,r=W+10|0,R=i[s+40>>2],_=0,N){for(D=W&4,f=0;n=r,r=r+4|0,f=f+4|0,(D|0)!=(f|0););f=n+R|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),f=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24)}else f=0;if(C)for(;f=l[r+R|0]|f<<8,r=r+1|0,_=_+1|0,(C|0)!=(_|0););if(i[w+16>>2]=f,!(f&&h)){if(r=E(48),i[o+20>>2]=r,i[o+24>>2]=40,i[o+28>>2]=-2147483600,f=l[23546]|l[23547]<<8|(l[23548]<<16|l[23549]<<24),t=l[23542]|l[23543]<<8|(l[23544]<<16|l[23545]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,f=l[23578]|l[23579]<<8|(l[23580]<<16|l[23581]<<24),t=l[23574]|l[23575]<<8|(l[23576]<<16|l[23577]<<24),u[r+32|0]=t,u[r+33|0]=t>>>8,u[r+34|0]=t>>>16,u[r+35|0]=t>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[23570]|l[23571]<<8|(l[23572]<<16|l[23573]<<24),t=l[23566]|l[23567]<<8|(l[23568]<<16|l[23569]<<24),u[r+24|0]=t,u[r+25|0]=t>>>8,u[r+26|0]=t>>>16,u[r+27|0]=t>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[23562]|l[23563]<<8|(l[23564]<<16|l[23565]<<24),t=l[23558]|l[23559]<<8|(l[23560]<<16|l[23561]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[23554]|l[23555]<<8|(l[23556]<<16|l[23557]<<24),t=l[23550]|l[23551]<<8|(l[23552]<<16|l[23553]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(B,2,121,o+20|0),u[o+31|0]>=0)break r;Z(i[o+20>>2]);break r}r=w+20|0,n=i[w+20>>2],f=(i[w+24>>2]-n|0)/12|0;n:{t:{if(f>>>0<y>>>0){Dt(r,y-f|0);break t}if(f>>>0>y>>>0&&(i[w+24>>2]=n+G(y,12)),!y)break n}for(D=W&4,C=W&2,S=128<<(W<<3)-8,a=i[r>>2],R=0;;){if(f=i[s+40>>2],r=t,_=0,h=0,N){for(;n=r,r=r+4|0,_=_+4|0,(D|0)!=(_|0););n=f+n|0,w=(l[n|0]<<16|l[n+1|0]<<8|l[n+2|0])<<8,h=w|l[n+3|0]}if(_=0,C)for(;w=h<<8,h=w|l[r+f|0],r=r+1|0,_=_+1|0,(C|0)!=(_|0););if(O=G(R,12)+a|0,i[O+4>>2]=w&S?h|-2147483648:h,r=t+W|0,L=i[s+40>>2],_=0,w=0,h=0,N){for(;f=r,r=r+4|0,w=w+4|0,(D|0)!=(w|0););n=f+L|0,f=(l[n|0]<<16|l[n+1|0]<<8|l[n+2|0])<<8,h=f|l[n+3|0]}if(C)for(;f=h<<8,h=f|l[r+L|0],r=r+1|0,_=_+1|0,(C|0)!=(_|0););if(i[O+8>>2]=f&S?h|-2147483648:h,t=t+x|0,R=R+1|0,(R|0)==(y|0))break}}if(r=i[26929],i[B>>2]=i[26928],i[B+4>>2]=r,r=B+8|0,u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break r}T(r,i[26930],i[26931]);break r}r=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=r,i[B+16>>2]=i[k+16>>2],r=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=r,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;break r}g0(),H()}if(!r)break f;z(f,t,r)}u[r+f|0]=0,K(B,4,3002,o+8|0),u[o+19|0]<0&&Z(i[o+8>>2]),r=i[18063],i[o+20>>2]=r,i[i[r-12>>2]+(o+20|0)>>2]=i[18071],i[o+28>>2]=i[18072],i[n>>2]=71280,u[o+75|0]<0&&Z(i[o+64>>2]),y0(n),p0(o+84|0)}u[k+19|0]<0&&Z(i[k+8>>2]),v=o+192|0;r:{if(i[s+16>>2]){e=i[s+20>>2],i[m>>2]=i[s+16>>2],i[m+4>>2]=e,i[m+16>>2]=i[s+32>>2],e=i[s+28>>2],i[m+8>>2]=i[s+24>>2],i[m+12>>2]=e,i[s+32>>2]=0,i[s+24>>2]=0,i[s+28>>2]=0;break r}if(((i[e+472>>2]-i[e+468>>2]|0)/12|0)!=i[e+484>>2]-i[e+480>>2]>>2){if(e=E(72),i[s+4>>2]=e,i[s+8>>2]=69,i[s+12>>2]=-2147483576,z(e,5858,69),u[e+69|0]=0,K(m,2,121,s+4|0),u[s+15|0]>=0)break r;Z(i[s+4>>2]);break r}if(e=i[26929],i[m>>2]=i[26928],i[m+4>>2]=e,e=m+8|0,u[107731]>=0){r=i[26931],i[e>>2]=i[26930],i[e+4>>2]=r,i[e+8>>2]=i[26932];break r}T(e,i[26930],i[26931])}if(u[s+35|0]>=0)break e;Z(i[s+24>>2])}if(e=l[s+60|0],(e|0)==255)break i;r=i[25393],i[s+16>>2]=i[25392],i[s+20>>2]=r,X[i[(s+16|0)+(e<<2)>>2]](s+4|0,s+40|0)}i:{if(!I||(e=i[I+4>>2],i[I+4>>2]=e-1,e))break i;X[i[i[I>>2]+8>>2]](I),p(I)}i:{if(!g||(e=i[g+4>>2],i[g+4>>2]=e-1,e))break i;X[i[i[g>>2]+8>>2]](g),p(g)}v=s- -64|0,r=A+8|0;i:{if(i[V+8>>2]){e=V,k=i[e+12>>2],i[A>>2]=i[e+8>>2],i[A+4>>2]=k,i[r+8>>2]=i[e+24>>2],A=i[e+20>>2],i[r>>2]=i[e+16>>2],i[r+4>>2]=A,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0;break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[r>>2]=i[26930],i[r+4>>2]=A,i[r+8>>2]=i[26932];break i}T(r,i[26930],i[26931])}u[V+27|0]<0&&Z(i[V+16>>2]),v=V+32|0}function c_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;W=v-32|0,v=W;i:{e:{if(!(!n|(!e|!r))&&t)break e;e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}e:{if(s=i[r>>2],!s)break e;if(h=X0(s,100708,101872),h){_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),o=v-112|0,v=o,Wf(o+100|0,i[h+100>>2],i[i[t>>2]+4>>2]),r=D6(),u[o+96|0]=0,i[o+76>>2]=0,i[o+80>>2]=0,s=i[o+100>>2],X[i[i[s>>2]+116>>2]](o+68|0,s),cf(o+16|0,i[o+68>>2],n,t,i[r+4>>2],r+16|0,i[h+100>>2]- -64|0),s=l[o+36|0];r:{if((s|0)==255){X[i[25474]](o,o+76|0),u[o+96|0]=255;break r}w=o+76|0,i[o+108>>2]=w,B=i[25477],i[o>>2]=i[25476],i[o+4>>2]=B,X[i[o+(s<<2)>>2]](o+108|0,w,o+16|0)}s=l[o+36|0],(s|0)!=255&&(w=i[25475],i[o>>2]=i[25474],i[o+4>>2]=w,X[i[o+(s<<2)>>2]](o+108|0,o+16|0)),w=W+12|0,u[o+36|0]=255,s=i[o+72>>2];r:{if(!s||(B=i[s+4>>2],i[s+4>>2]=B-1,B))break r;X[i[i[s>>2]+8>>2]](s),p(s)}r:{f:{A:{k:{n:{if(l[o+96|0]){z2(r),f=107712,k=107724,r=107731,t=107720;t:switch(l[o+96|0]){case 1:k=o+88|0,r=o+95|0,t=o+84|0,f=o+76|0;break;case 0:break t;default:break n}if(n=i[f+4>>2],i[w>>2]=i[f>>2],i[w+4>>2]=n,f=w+8|0,u[r|0]>=0){r=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=r,i[f+8>>2]=i[t+8>>2];break r}T(f,i[t>>2],i[k>>2]);break r}i[o+68>>2]=i[o+76>>2],s=i[o+80>>2],i[o+72>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),T7(o+16|0,i[o+100>>2],o+68|0,t,r,1),z2(r);t:{u:switch(l[o+60|0]){case 1:if(r=i[o+20>>2],i[w>>2]=i[o+16>>2],i[w+4>>2]=r,r=w+8|0,u[o+35|0]<0)break t;f=i[o+28>>2],i[r>>2]=i[o+24>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+32>>2];break f;case 0:break u;default:break n}if(r=i[h+100>>2],i[o>>2]=i[r+48>>2],r=i[r+52>>2],i[o+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),l[o+60|0])break n;K8(i[o>>2],i[h+116>>2],o+28|0,0),r=i[o+4>>2];u:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break u;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=i[n>>2],n=i[r+108>>2],!((n|0)==i[h+460>>2]&i[r+112>>2]==i[h+464>>2])){if(r=E(56),i[o>>2]=r,i[o+4>>2]=55,i[o+8>>2]=-2147483592,f=l[24934]|l[24935]<<8|(l[24936]<<16|l[24937]<<24),k=l[24930]|l[24931]<<8|(l[24932]<<16|l[24933]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+55|0]=0,f=l[24981]|l[24982]<<8|(l[24983]<<16|l[24984]<<24),k=l[24977]|l[24978]<<8|(l[24979]<<16|l[24980]<<24),u[r+47|0]=k,u[r+48|0]=k>>>8,u[r+49|0]=k>>>16,u[r+50|0]=k>>>24,u[r+51|0]=f,u[r+52|0]=f>>>8,u[r+53|0]=f>>>16,u[r+54|0]=f>>>24,f=l[24974]|l[24975]<<8|(l[24976]<<16|l[24977]<<24),k=l[24970]|l[24971]<<8|(l[24972]<<16|l[24973]<<24),u[r+40|0]=k,u[r+41|0]=k>>>8,u[r+42|0]=k>>>16,u[r+43|0]=k>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[24966]|l[24967]<<8|(l[24968]<<16|l[24969]<<24),k=l[24962]|l[24963]<<8|(l[24964]<<16|l[24965]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[24958]|l[24959]<<8|(l[24960]<<16|l[24961]<<24),k=l[24954]|l[24955]<<8|(l[24956]<<16|l[24957]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[24950]|l[24951]<<8|(l[24952]<<16|l[24953]<<24),k=l[24946]|l[24947]<<8|(l[24948]<<16|l[24949]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[24942]|l[24943]<<8|(l[24944]<<16|l[24945]<<24),k=l[24938]|l[24939]<<8|(l[24940]<<16|l[24941]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(w,5,0,o),u[o+11|0]>=0)break f;Z(i[o>>2]);break f}if(l[o+60|0])break n;if(r=i[h+532>>2],t=i[h+528>>2],f=(i[h+512>>2]+(G(((n+i[h+452>>2]|0)-1>>>0)/(n>>>0)|0,k)<<4)|0)+(f<<4)|0,k=i[o+32>>2]-i[o+28>>2]|0,i[f+8>>2]=k,i[f>>2]=t,i[f+4>>2]=r,f=k+t|0,r=k>>>0>f>>>0?r+1|0:r,i[h+528>>2]=f,i[h+532>>2]=r,f=i[h+104>>2],r=i[h+108>>2],(f|0)==(r|0))break k;for(;;){u:{o:{if(k=i[f>>2],!k||(t=X0(k,86628,101860),!t))break o;if(s=i[f+4>>2],s)break u;s=0;break A}if(f=f+8|0,(r|0)!=(f|0))continue;break k}break}if(i[s+4>>2]=i[s+4>>2]+1,l[o+60|0])break n;break A}T(r,i[o+24>>2],i[o+28>>2]);break f}_2(),H()}s=0,t=0}if(k=i[o+16>>2],n=i[o+20>>2],(k|0)!=(n|0))for(B=t+36|0;;){r=i[i[k>>2]+16>>2];A:{if((r|0)==1769173093)break A;if(f=i[t+36>>2],m=i[t+40>>2],(f|0)!=(m|0))for(;;){if((r|0)==i[i[f>>2]+16>>2])break A;if(f=f+8|0,(m|0)==(f|0))break}if(Ct(B,k),i[i[k>>2]+16>>2]!=1885960297||(r=i[h+100>>2],i[o>>2]=i[r+48>>2],r=i[r+52>>2],i[o+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[k>>2],f3(i[o>>2],i[h+116>>2],k,X[i[i[r>>2]+40>>2]](r)|0),r=i[o+4>>2],!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break A;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=k+8|0,(n|0)==(k|0))break}r=i[26929],i[w>>2]=i[26928],i[w+4>>2]=r,r=w+8|0;A:{if(u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break A}T(r,i[26930],i[26931])}if(!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break f;X[i[i[s>>2]+8>>2]](s),p(s)}if(r=l[o+60|0],(r|0)!=255&&(f=i[25479],i[o>>2]=i[25478],i[o+4>>2]=f,X[i[o+(r<<2)>>2]](o+108|0,o+16|0)),r=i[o+72>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}r=l[o+96|0],(r|0)!=255&&(f=i[25475],i[o+16>>2]=i[25474],i[o+20>>2]=f,X[i[(o+16|0)+(r<<2)>>2]](o,o+76|0)),r=i[o+104>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}if(v=o+112|0,b0(A,w,i[e>>2]),u[W+31|0]<0&&Z(i[W+20>>2]),!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;X[i[i[_>>2]+8>>2]](_),p(_);break i}if(w=X0(s,100708,101348),!w)break e;_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),m=W+12|0,s=0,o=v-192|0,v=o,C=i[w+472>>2],Oi(o+168|0,i[w+100>>2],n,t,C,1);r:{f:switch(l[o+188|0]){default:_2(),H();case 1:if(r=i[o+172>>2],i[m>>2]=i[o+168>>2],i[m+4>>2]=r,r=m+8|0,u[o+187|0]>=0){f=i[o+180>>2],i[r>>2]=i[o+176>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+184>>2];break r}T(r,i[o+176>>2],i[o+180>>2]);break r;case 0:break f}g=i[o+168>>2],B=i[o+172>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),r=i[w+100>>2],i[o+160>>2]=i[r+48>>2],r=i[r+52>>2],i[o+164>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),s4(o+88|0,i[o+160>>2],i[g+116>>2]),r=i[o+88>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[o+92>>2];f:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(X[i[i[w>>2]+108>>2]](o+88|0,w),t=i[w+116>>2],h=G(i[o+92>>2],k)+f|0,V=i[g+116>>2],I=i[i[o+160>>2]+84>>2],r=i[I+104>>2],I=i[I+108>>2],(r|0)!=(I|0))for(;;){f:{if(!((t|0)!=i[r+40>>2]|i[r+16>>2]!=1684630887)){i[i[r+44>>2]+(h<<2)>>2]=V;break f}if(r=r+56|0,(I|0)!=(r|0))continue}break}i[(i[w+460>>2]+(G(F[w+450>>1],k)<<2)|0)+(f<<2)>>2]=i[g+116>>2],t=0,r=i[g+104>>2],h=i[g+108>>2];f:{A:{if((r|0)==(h|0))break A;for(;;){k:{if(t=i[r>>2],!t||(t=X0(t,86628,88900),!t))break k;if(r=i[r+4>>2],!r)break A;i[r+4>>2]=i[r+4>>2]+1,i[o+84>>2]=r,i[o+80>>2]=t,i[r+4>>2]=i[r+4>>2]+1,s=r,h=0;break f}if(r=r+8|0,(h|0)==(r|0))break}t=0}i[o+84>>2]=0,i[o+80>>2]=t,h=1}r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,D4(w,o+24|0,1);f:{if(f|k)break f;if(Gf(o+68|0,g,0),r=i[o+68>>2],k=i[o+72>>2],(r|0)!=(k|0))for(;i[o+60>>2]=i[r>>2],f=i[r+4>>2],i[o+64>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),t=i[r>>2],f=i[t+16>>2]==1769173093,t=f?w:t,f=X[i[i[t>>2]+(f?48:40)>>2]](t)|0,t=i[o+64>>2],i[o+16>>2]=i[o+60>>2],i[o+20>>2]=t,D4(w,o+16|0,f),r=r+8|0,(k|0)!=(r|0););if(D9(o+48|0,n,C,1,i[C+4>>2]),r=i[o+48>>2],k=i[o+52>>2],(r|0)!=(k|0)){for(;;){n=i[r>>2],i[o+40>>2]=n,f=i[r+4>>2],i[o+44>>2]=f;A:{if(!f){i[o+36>>2]=0,i[o+32>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,n=i[r>>2],f=i[r+4>>2],i[o+36>>2]=f,i[o+32>>2]=n,!f)break A;i[f+4>>2]=i[f+4>>2]+1}n=i[o+32>>2],f=i[n+16>>2]==1769173093,n=f?w:n,f=X[i[i[n>>2]+(f?48:40)>>2]](n)|0,n=i[o+44>>2],i[o+8>>2]=i[o+40>>2],i[o+12>>2]=n,D4(w,o+8|0,f),f=i[o+36>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r+8|0,(k|0)==(r|0))break}r=i[o+48>>2]}if(r){if(t=r,f=i[o+52>>2],(f|0)!=(r|0)){for(;;){k=i[f-4>>2];A:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(f=f-8|0,(f|0)==(r|0))break}t=i[o+48>>2]}i[o+52>>2]=r,Z(t)}if(k=i[o+68>>2],!k)break f;if(r=i[o+72>>2],f=k,(r|0)!=(f|0)){for(;;){f=i[r-4>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r-8|0,(k|0)==(r|0))break}f=i[o+68>>2]}i[o+72>>2]=k,Z(f)}r=i[26929],i[m>>2]=i[26928],i[m+4>>2]=r,r=m+8|0;f:{if(u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break f}T(r,i[26930],i[26931])}f:{if(h||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break f;X[i[i[s>>2]+8>>2]](s),p(s)}r=i[o+164>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break r;X[i[i[B>>2]+8>>2]](B),p(B)}if(r=l[o+188|0],(r|0)!=255&&(f=i[25345],i[o+88>>2]=i[25344],i[o+92>>2]=f,X[i[(o+88|0)+(r<<2)>>2]](o+68|0,o+168|0)),v=o+192|0,b0(A,m,i[e>>2]),u[W+31|0]<0&&Z(i[W+20>>2]),!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;X[i[i[_>>2]+8>>2]](_),p(_);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=15022}v=W+32|0}function U7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=M(0),L=0;f=v-144|0,v=f,o0(f,0,144),i[f+76>>2]=-1,i[f+44>>2]=A,i[f+32>>2]=2070,i[f+84>>2]=A,k=e,R=r,o=v-304|0,v=o;i:{e:{if(!i[f+4>>2]&&(Ge(f),!i[f+4>>2]))break e;if(e=l[k|0],!e)break i;r:{f:{for(;;){A:{A=e&255;k:{if((A|0)==32|A-9>>>0<5){for(;e=k,k=k+1|0,A=l[e+1|0],!!((A|0)==32|A-9>>>0<5););for(u8(f,0,0);;){A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break n}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,r=A,t=W+i[f+124>>2]|0,k=A>>31,A=_+i[f+120>>2]|0,t=k+(A>>>0<_>>>0?t+1|0:t)|0,_=A+r|0,W=_>>>0<A>>>0?t+1|0:t;break k}n:{t:{u:{if((A|0)==37){if(A=l[k+1|0],(A|0)==42)break u;if((A|0)!=37)break t}u8(f,0,0);o:{if(l[k|0]==37){for(;;){A=i[f+4>>2];l:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=l[A|0];break l}e=j2(f)}if(!((e|0)==32|e-9>>>0<5))break}k=k+1|0;break o}if(A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=l[A|0];break o}e=j2(f)}if(l[k|0]!=(e|0)){if(A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),y|(e|0)>=0)break i;break e}A=i[f+4>>2]-i[f+44>>2]|0,r=A,n=A>>31,A=W+i[f+124>>2]|0,e=_+i[f+120>>2]|0,s=(e>>>0<_>>>0?A+1|0:A)+n|0,_=e+r|0,W=_>>>0<e>>>0?s+1|0:s,e=k;break k}h=0,e=k+2|0;break n}if(A=A-48|0,!(l[k+2|0]!=36|A>>>0>9)){e=v-16|0,i[e+12>>2]=R,A=A>>>0>1?((A<<2)+R|0)-4|0:R,i[e+8>>2]=A+4,h=i[A>>2],e=k+3|0;break n}h=i[R>>2],R=R+4|0,e=k+1|0}if(C=0,r=0,k=l[e|0],(k-48&255)>>>0<=9)for(;r=(G(r,10)+(k&255)|0)-48|0,k=l[e+1|0],e=e+1|0,(k-48&255)>>>0<10;);(k&255)==109&&(m=0,C=(h|0)!=0,k=l[e+1|0],g=0,e=e+1|0),n=e,e=e+1|0,A=3;n:{t:switch((k&255)-65|0){case 39:A=l[n+1|0]==104,e=A?n+2|0:e,A=A?-2:-1;break n;case 43:A=l[n+1|0]==108,e=A?n+2|0:e,A=A?3:1;break n;case 51:case 57:A=1;break n;case 11:A=2;break n;case 0:case 2:case 4:case 5:case 6:case 18:case 23:case 26:case 32:case 34:case 35:case 36:case 37:case 38:case 40:case 45:case 46:case 47:case 50:case 52:case 55:break t;case 41:break n;default:break f}A=0,e=n}n=A,A=l[e|0],k=(A&47)==3,N=k?1:n,I=k?A|32:A;n:{if((I|0)==91)break n;t:{if((I|0)!=110){if((I|0)!=99)break t;r=(r|0)<=1?1:r;break n}xo(h,N,_,W);break k}for(u8(f,0,0);;){A=i[f+4>>2];t:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break t}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,k=A,t=W+i[f+124>>2]|0,n=A>>31,A=_+i[f+120>>2]|0,W=n+(A>>>0<_>>>0?t+1|0:t)|0,_=A+k|0,W=_>>>0<A>>>0?W+1|0:W}s=r,B=r>>31,u8(f,r,B),A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1;break n}if((j2(f)|0)<0)break f}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),k=16;n:{t:{u:{o:{l:{s:{w:switch(I-88|0){default:if(A=I-65|0,A>>>0>6|!(1<<A&113))break n;case 9:case 13:case 14:case 15:if(R7(o+8|0,f,N,0),A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!h)break n;switch(A=i[o+16>>2],k=i[o+20>>2],r=i[o+8>>2],n=i[o+12>>2],N|0){case 0:break l;case 1:break o;case 2:break u;default:break n}case 3:case 11:case 27:if((I|16)==115){if(Ae(o+32|0,-1,257),u[o+32|0]=0,(I|0)!=115)break t;u[o+65|0]=0,u[o+46|0]=0,Q[o+42>>1]=0,Q[o+44>>1]=0;break t}k=l[e+1|0],n=(k|0)==94,Ae(o+32|0,n,257),u[o+32|0]=0,A=n?e+2|0:e+1|0;_:{h:{B:{if(e=l[(n?2:1)+e|0],(e|0)!=45){if((e|0)==93)break B;w=(k|0)!=94;break _}w=(k|0)!=94,u[o+78|0]=w;break h}w=(k|0)!=94,u[o+126|0]=w}A=A+1|0}for(e=A;;){A=l[e|0];_:{if((A|0)!=45){if(!A)break f;if((A|0)==93)break t;break _}if(A=45,n=l[e+1|0],!n|(n|0)==93)break _;t=e+1|0,k=l[e-1|0];h:{if(n>>>0<=k>>>0){A=n;break h}for(;k=k+1|0,u[k+(o+32|0)|0]=w,A=l[t|0],k>>>0<A>>>0;);}e=t}u[((o+32|0)+A|0)+1|0]=w,e=e+1|0}case 23:k=8;break s;case 12:case 29:k=10;break s;case 0:case 24:case 32:break s;case 1:case 2:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 22:case 25:case 26:case 28:case 30:case 31:break n;case 17:break w}k=0}n=0,t=0,r=0,s=0,w=0,D=v-16|0,v=D;s:{if(!((k|0)!=1&k>>>0<=36)){i[31336]=28;break s}for(;;){A=i[f+4>>2];w:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break w}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}w:{_:switch(A-43|0){case 0:case 2:break _;default:break w}if(w=(A|0)==45?-1:0,A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break w}A=j2(f)}w:{_:{h:{B:{if(!((k|0)!=0&(k|0)!=16|(A|0)!=48)){A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if((A&-33)==88){k=16,A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if(l[A+73937|0]<16)break h;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),u8(f,0,0);break s}if(k)break B;k=8;break h}if(k=k||10,k>>>0>l[A+73937|0])break B;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),u8(f,0,0),i[31336]=28;break s}if((k|0)!=10)break h;if(r=A-48|0,r>>>0<=9){for(A=0;;){A=G(A,10)+r|0,k=A>>>0<429496729,r=i[f+4>>2];B:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break B}r=j2(f)}if(r=r-48|0,!(k&r>>>0<=9))break}n=A}if(r>>>0>9)break w;for(k=O0(n,0,10,0),B=l0;;){B:{t=B,n=r+k|0,t=n>>>0<r>>>0?t+1|0:t,r=(t|0)==429496729&n>>>0<2576980378|t>>>0<429496729,A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if(s=A-48|0,!(r&s>>>0<=9)){if(s>>>0<=9)break B;break w}if(k=O0(n,t,10,0),B=l0,r=s,(B|0)==-1&(r^-1)>>>0>=k>>>0|(B|0)!=-1)continue}break}k=10;break _}if(k-1&k){if(s=l[A+73937|0],s>>>0<k>>>0){for(;;){r=G(r,k)+s|0,n=r>>>0<119304647,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(s=l[A+73937|0],!(n&s>>>0<k>>>0))break}n=r}if(k>>>0<=s>>>0)break _;for(;;){if(r=O0(n,t,k,0),B=l0,s=s&255,(B|0)==-1&(s^-1)>>>0<r>>>0)break _;t=B,n=r+s|0,t=n>>>0<s>>>0?t+1|0:t,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(s=l[A+73937|0],k>>>0<=s>>>0)break _;if($1(D,k,0,0,0,n,t,0,0),!!(i[D+8>>2]|i[D+12>>2]))break}break _}if(B=u[(G(k,23)>>>5&7)+74193|0],r=l[A+73937|0],k>>>0>r>>>0){for(;;){A=s<<B,s=A|r,n=A>>>0<134217728,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(r=l[A+73937|0],!(n&k>>>0>r>>>0))break}n=s}if(r>>>0>=k>>>0||(V=B&31,(B&63)>>>0>=32?(s=0,V=-1>>>V|0):(s=-1>>>V|0,V=s|(1<<V)-1<<32-V),!s&n>>>0>V>>>0))break _;for(;;){x=r&255,r=n,A=B&31,(B&63)>>>0>=32?(t=r<<A,A=0):(t=(1<<A)-1&r>>>32-A|t<<A,A=r<<A),n=x|A,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(r=l[A+73937|0],k>>>0<=r>>>0)break _;if(!((t|0)==(s|0)&n>>>0<=V>>>0|t>>>0<s>>>0))break}}if(l[A+73937|0]>=k>>>0)break w;for(;;){A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break _}A=j2(f)}if(!(l[A+73937|0]<k>>>0))break}i[31336]=68,w=0,n=-1,t=-1}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1);w:if((t&n)!=-1)break w;A=n^w,n=A-w|0,r=w>>31,t=(r^t)-((A>>>0<w>>>0)+r|0)|0}if(v=D+16|0,A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!(!h|(I|0)!=112)){i[h>>2]=n;break n}xo(h,N,n,t);break n}S=h,O=En(r,n,A,k),E0[S>>2]=O;break n}S=h,L=Pf(r,n,A,k),t0[S>>3]=L;break n}i[h>>2]=r,i[h+4>>2]=n,i[h+8>>2]=A,i[h+12>>2]=k;break n}n=(I|0)!=99,w=n?31:r+1|0;t:{if((N|0)==1){if(r=h,C&&(r=p2(w<<2),!r))break A;i[o+296>>2]=0,i[o+300>>2]=0,k=0;u:{o:{for(;;){for(A=r;;){r=i[f+4>>2];l:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break l}r=j2(f)}if(!l[(r+o|0)+33|0])break o;if(u[o+27|0]=r,r=ne(o+28|0,o+27|0,1,o+296|0),(r|0)!=-2){if((r|0)==-1){m=0;break u}if(A&&(i[(k<<2)+A>>2]=i[o+28>>2],k=k+1|0),!(!C|(k|0)!=(w|0)))break}}if(w=w<<1|1,r=vr(A,w<<2),!r)break}m=0,g=A,C=1;break f}if(m=0,g=A,!(o+296|0&&i[o+296>>2]))break t}g=A;break f}if(C){if(k=0,r=p2(w),!r)break A;for(;;){for(A=r;;){r=i[f+4>>2];u:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break u}r=j2(f)}if(!l[(r+o|0)+33|0]){m=A,g=0;break t}if(u[A+k|0]=r,k=k+1|0,(w|0)==(k|0))break}if(w=w<<1|1,r=vr(A,w),!r)break}g=0,m=A,C=1;break f}if(k=0,h)for(;;){A=i[f+4>>2];u:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break u}A=j2(f)}if(l[(A+o|0)+33|0]){u[k+h|0]=A,k=k+1|0;continue}else{A=h,m=A,g=0;break t}}for(;;){A=i[f+4>>2];u:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break u}A=j2(f)}if(!l[(A+o|0)+33|0])break}A=0,m=0,g=0}if(r=i[f+4>>2],t=i[f+116>>2],(t|0)>0?t=1:t=(t|0)>=0,t&&(r=r-1|0,i[f+4>>2]=r),t=r-i[f+44>>2]|0,w=t,r=t+i[f+120>>2]|0,t=i[f+124>>2]+(t>>31)|0,t=r>>>0<w>>>0?t+1|0:t,!(t|r)|!(n|(r|0)==(s|0)&(t|0)==(B|0)))break r;if(C&&(i[h>>2]=A),(I|0)==99)break n;if(g&&(i[(k<<2)+g>>2]=0),!m){m=0;break n}u[k+m|0]=0}A=i[f+4>>2]-i[f+44>>2]|0,k=A,n=A>>31,A=W+i[f+124>>2]|0,r=_+i[f+120>>2]|0,t=(r>>>0<_>>>0?A+1|0:A)+n|0,_=r+k|0,W=_>>>0<r>>>0?t+1|0:t,y=((h|0)!=0)+y|0}if(k=e+1|0,e=l[e+1|0],e)continue;break i}break}C=1,m=0,g=0}y=y||-1}if(!C)break i;Z(m),Z(g);break i}y=-1}return v=o+304|0,v=f+144|0,y}function b_(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=M(0),_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=M(0),W0=0,Q0=0,V0=0,e0=M(0),r0=M(0),N0=M(0),U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=M(0),Q2=M(0),E2=M(0),H2=0,T2=M(0),b2=M(0),e1=M(0),W1=M(0);w=v-160|0,v=w,e=i[r>>2],V=i[e+112>>2],B=i[e+108>>2],n=i[k+4>>2],f=n>>>0<4,t=n<<3,y=(f?16908801>>>t|0:0)&3,O=(f?16843265>>>t|0:0)&3,I=j0(e,3);i:{if(I>>>0<=8){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e:{if(A0=u1(i[r>>2],6),!A0||(j0(i[r>>2],6)|0)==(I|0))break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}x=E(172),s=x,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=94860,o0(s+16|0,0,80),e=i[s+4>>2],f=e+1|0,i[s+4>>2]=f,i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,Q[s+22>>1]=2,Q[s+18>>1]=2,Q[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95208,i[s+148>>2]=0,i[s+152>>2]=0,t=s+140|0,i[s+136>>2]=t,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[s+4>>2]=e,e=i[s+8>>2],N=s+12|0,i[s+96>>2]=N,i[s+8>>2]=e+1,i[s+100>>2]=s,f||(X[i[i[s>>2]+8>>2]](s),p(s)),i[N+120>>2]=n,i[N+116>>2]=0,i[N+112>>2]=V,i[N+108>>2]=B,T0(w+136|0,N,0,B,V,I,o),n=((B+y|0)-1>>>0)/(y>>>0)|0,f=((V+O|0)-1>>>0)/(O>>>0)|0,T0(w+112|0,N,1,n,f,I,o),s=w+16|0;e:{if(i[w+136>>2]){if(e=i[w+140>>2],i[w+8>>2]=i[w+136>>2],i[w+12>>2]=e,u[w+155|0]>=0){e=i[w+148>>2],i[s>>2]=i[w+144>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+152>>2];break e}T(s,i[w+144>>2],i[w+148>>2]);break e}if(e=i[w+116>>2],i[w+8>>2]=i[w+112>>2],i[w+12>>2]=e,u[w+131|0]>=0){e=i[w+124>>2],i[s>>2]=i[w+120>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+128>>2];break e}T(s,i[w+120>>2],i[w+124>>2])}T0(w+88|0,N,2,n,f,I,o),f=w+56|0;e:{if(i[w+8>>2]){if(e=i[w+12>>2],i[w+48>>2]=i[w+8>>2],i[w+52>>2]=e,u[w+27|0]>=0){e=i[s+4>>2],i[f>>2]=i[s>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+8>>2];break e}T(f,i[w+16>>2],i[w+20>>2]);break e}if(e=i[w+92>>2],i[w+48>>2]=i[w+88>>2],i[w+52>>2]=e,u[w+107|0]>=0){e=i[w+100>>2],i[f>>2]=i[w+96>>2],i[f+4>>2]=e,i[f+8>>2]=i[w+104>>2];break e}T(f,i[w+96>>2],i[w+100>>2])}u[w+107|0]<0&&Z(i[w+96>>2]),u[w+27|0]<0&&Z(i[w+16>>2]),u[w+131|0]<0&&Z(i[w+120>>2]),u[w+155|0]<0&&Z(i[w+144>>2]);e:{if(i[w+48>>2]){if(e=i[w+52>>2],i[A>>2]=i[w+48>>2],i[A+4>>2]=e,r=A+8|0,u[w+67|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[w+56>>2],i[w+60>>2]),e=u[w+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[w+56>>2]);break e}u[w+67|0]<0&&Z(i[w+56>>2]);r:{if(!A0)break r;if(T0(w+48|0,N,6,B,V,I,o),i[w+48>>2]){if(e=i[w+52>>2],i[A>>2]=i[w+48>>2],i[A+4>>2]=e,r=A+8|0,u[w+67|0]>=0){e=i[w+60>>2],i[r>>2]=i[w+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+64>>2],u[A+20|0]=1;break e}if(T(r,i[w+56>>2],i[w+60>>2]),e=u[w+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[w+56>>2]);break e}if(u[w+67|0]>=0)break r;Z(i[w+56>>2])}e=i[r>>2],n=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=n,e=o;s=i[e+16>>2]<3,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);_=0;A:{if((f|0)==(n|0)||(_=0,i[f+16>>2]>3))break A;n0=i[f+44>>2],_=i[f+56>>2]}for(f=n,e=o;s=i[e+16>>2]<4,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>4))break A;L=i[f+56>>2],e=i[f+44>>2]}for(U0=e,f=n,e=o;s=i[e+16>>2]<5,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);if((f|0)!=(n|0))break f}e=0;break r}if(e=0,i[f+16>>2]>5)break r;D0=i[f+56>>2]>>>1|0,e=i[f+44>>2]}H0=e;r:{f:{if(f=i[t>>2],f){for(s=t,e=f;R=i[e+16>>2],s=(R|0)<0?s:e,e=i[(R>>>29&4)+e>>2],!!e;);m=0;A:{if((t|0)==(s|0)||(m=0,i[s+16>>2]>0))break A;a=i[s+56>>2],m=i[s+44>>2]}for(s=t,e=f;R=i[e+16>>2]<=0,s=R?s:e,e=i[(R?4:0)+e>>2],!!e;);R=0;A:{if((t|0)==(s|0)||(R=0,i[s+16>>2]>1))break A;S=i[s+56>>2],R=i[s+44>>2]}for(s=t,e=f;D=i[e+16>>2]<2,s=D?s:e,e=i[(D?4:0)+e>>2],!!e;);if((t|0)!=(s|0))break f}D=0;break r}if(D=0,i[s+16>>2]>2)break r;H2=i[s+56>>2]>>>1|0,D=i[s+44>>2]}s=0;r:{if(!A0)break r;f:{A:{if(!o)break A;for(e=n;s=i[o+16>>2]<6,e=s?e:o,o=i[(s?4:0)+o>>2],!!o;);if((e|0)==(n|0))break A;if(n=0,i[e+16>>2]>6)break f;L0=i[e+44>>2],n=i[e+56>>2];break f}n=0}if(q0=n,s=0,!f)break r;for(e=t;n=i[f+16>>2]<6,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if(s=0,(e|0)==(t|0)||(s=0,i[e+16>>2]>6))break r;$0=i[e+56>>2],s=i[e+44>>2]}n=s,i[w+84>>2]=-1113159960,i[w+76>>2]=1056964608,i[w+80>>2]=-1093247418,i[w+68>>2]=-1096180881,i[w+72>>2]=1056964608,i[w+60>>2]=1038710997,i[w+64>>2]=-1104361250,i[w+52>>2]=1050220167,i[w+56>>2]=1058424226,u[w+48|0]=1,h0=l[k+22|0],P0=F[k+20>>1],Nr(w+8|0,P0,F[k+16>>1]),e=i[w+44>>2],i[w+80>>2]=i[w+40>>2],i[w+84>>2]=e,e=i[w+36>>2],i[w+72>>2]=i[w+32>>2],i[w+76>>2]=e,e=i[w+28>>2],f=w- -64|0,i[f>>2]=i[w+24>>2],i[f+4>>2]=e,e=i[w+20>>2],i[w+56>>2]=i[w+16>>2],i[w+60>>2]=e,e=i[w+12>>2],i[w+48>>2]=i[w+8>>2],i[w+52>>2]=e;r:{if(!V)break r;if(d0=L>>>1|0,n2=_>>>1|0,e=-1<<I^-1,m0=M(16<<I-8),B)for(Z2=a>>>1|0,W0=B&-4,$=B&3,L=B&-2,a=B&1,o=B>>>0<4,_=0;;){W=(G(_,Z2)<<1)+m|0,C=(G(_,D0)<<1)+H0|0,s=(G(_,n2)<<1)+n0|0,g=(G(_,d0)<<1)+U0|0,g2=E0[w+60>>2],Q2=E0[w+56>>2],E2=E0[w+52>>2],f=0;f:{A:{k:switch(P0|0){default:for(;k=f<<1,t=k+W|0,h=M(M(M(F[k+C>>1])*g2)+M(M(M(F[k+s>>1])*E2)+M(Q2*M(F[k+g>>1])))),h=M((h0&1?h:M(M(M(h*M(219))*M(.00390625))+m0))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,Q[t>>1]=(k|0)>=0?(e|0)<(k|0)?e:k:0,f=f+1|0,(B|0)!=(f|0););break f;case 0:if(s=0,h0&1){if(k=0,o)break A;for(;C=s<<1,Q[C+W>>1]=F[g+C>>1],t=C|2,Q[t+W>>1]=F[t+g>>1],t=C|4,Q[t+W>>1]=F[t+g>>1],t=C|6,Q[t+W>>1]=F[t+g>>1],s=s+4|0,f=f+4|0,(W0|0)!=(f|0););break A}for(;f=s<<1,k=f+W|0,h=M(M(M(M(M(F[f+g>>1])*M(219))*M(.00390625))+m0)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,Q[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,s=s+1|0,(B|0)!=(s|0););break f;case 8:break k}if(k=0,(B|0)!=1)for(;t=f<<1,Q[t+W>>1]=(F[t+g>>1]>>>1)+(F[t+C>>1]+F[t+s>>1]>>>2),t=t|2,Q[t+W>>1]=(F[t+g>>1]>>>1)+(F[t+C>>1]+F[t+s>>1]>>>2),f=f+2|0,k=k+2|0,(L|0)!=(k|0););if(!a)break f;f=f<<1,Q[f+W>>1]=(F[f+g>>1]>>>1)+(F[f+C>>1]+F[f+s>>1]>>>2);break f}if(!$)break f;for(;f=s<<1,Q[f+W>>1]=F[f+g>>1],s=s+1|0,k=k+1|0,($|0)!=(k|0););}if(_=_+1|0,(V|0)==(_|0))break}if(!B)break r;for(Z2=S>>>1|0,Q0=e&65535,I=1<<I-1&65535,T2=M(I>>>0),W0=(O|0)==2,L=W0&(y|0)==2,a=(y|O)>>>0<2,m=0;;){k=G(m,D0)<<1,f0=k+H0|0,W=(G(m,n2)<<1)+n0|0,g=(G(m,d0)<<1)+U0|0,t=(m>>>0)/(O>>>0)|0,f=G(t,Z2)<<1,V0=f+R|0;f:{A:{k:switch(P0|0){default:for(f=m+1|0,f=W0&&f>>>0<V>>>0?f:m,C=(G(f,D0)<<1)+H0|0,$=(G(f,d0)<<1)+U0|0,S=(G(f,n2)<<1)+n0|0,b2=E0[w+84>>2],e1=E0[w+80>>2],W1=E0[w+76>>2],g2=E0[w+72>>2],Q2=E0[w+68>>2],E2=E0[w+64>>2],_=(G(t,H2)<<1)+D|0,o=0;k=o<<1,e0=M(F[k+f0>>1]),r0=M(F[k+g>>1]),N0=M(F[k+W>>1]),a||(f=o+1|0,f=(f>>>0<B>>>0&&L?f:o)<<1,e0=M(M(M(M(e0+M(F[f+f0>>1]))+M(F[k+C>>1]))+M(F[f+C>>1]))*M(.25)),r0=M(M(M(M(r0+M(F[f+g>>1]))+M(F[k+$>>1]))+M(F[f+$>>1]))*M(.25)),N0=M(M(M(M(N0+M(F[f+W>>1]))+M(F[k+S>>1]))+M(F[f+S>>1]))*M(.25))),s=(o>>>0)/(y>>>0)<<1,k=s+V0|0,h=M(M(e0*g2)+M(M(N0*E2)+M(r0*Q2))),t=h0&1,h=M(M((t?h:M(M(h*M(224))*M(.00390625)))+T2)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,Q[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,k=s+_|0,h=M(M(e0*b2)+M(M(N0*W1)+M(r0*e1))),h=M(M((t?h:M(M(h*M(224))*M(.00390625)))+T2)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,Q[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,o=o+y|0,B>>>0>o>>>0;);break f;case 0:if(S=k+n0|0,_=f+D|0,o=0,h0&1)break A;for(;s=(o>>>0)/(y>>>0)<<1,k=s+V0|0,t=o<<1,h=M(M(M(M(M(F[t+f0>>1])*M(224))*M(.00390625))+m0)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,Q[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,k=s+_|0,h=M(M(M(M(M(F[t+S>>1])*M(224))*M(.00390625))+m0)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,Q[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,o=o+y|0,B>>>0>o>>>0;);break f;case 8:break k}for(t=(G(t,H2)<<1)+D|0,o=0;f=o<<1,_=f+f0|0,k=(o>>>0)/(y>>>0)<<1,s=F[f+g>>1]>>>1|0,f=f+W|0,s=I+(s-(F[_>>1]+F[f>>1]>>>2|0)|0)|0,Q[k+V0>>1]=(s|0)>=0?s>>>0<Q0>>>0?s:Q0:0,f=I+((F[f>>1]-F[_>>1]|0)/2|0)|0,Q[k+t>>1]=(f|0)>=0?f>>>0<Q0>>>0?f:Q0:0,o=o+y|0,B>>>0>o>>>0;);break f}for(;k=(o>>>0)/(y>>>0)<<1,f=o<<1,Q[k+V0>>1]=F[f+f0>>1],Q[k+_>>1]=F[f+S>>1],o=o+y|0,B>>>0>o>>>0;);}if(m=m+O|0,!(V>>>0>m>>>0))break}}r:{if(!A0||(e=j0(i[r>>2],6),!V))break r;if(k=B<<(e>>>0>8),e=0,(V|0)!=1)for(f=V&-2,o=0;r=!k,r||z(G(e,$0)+n|0,G(e,q0)+L0|0,k),r||(r=e|1,z(G(r,$0)+n|0,G(r,q0)+L0|0,k)),e=e+2|0,o=o+2|0,(f|0)!=(o|0););if(!(V&1)|!k)break r;z(G(e,$0)+n|0,G(e,q0)+L0|0,k)}u[A+20|0]=0,i[A+4>>2]=x,i[A>>2]=N;break i}if(A=i[x+4>>2],i[x+4>>2]=A-1,A)break i;X[i[i[x>>2]+8>>2]](x),p(x)}v=w+160|0}function D7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0;n=v-208|0,v=n;i:{e:{r:{f:{A:switch(i[e+120>>2]-1|0){case 1:if((r|0)!=1)break r;if(u[e+108|0]&1)break f;break r;case 0:break A;default:break r}if(u[e+108|0]&1)break f;if(!(u[e+112|0]&1))break r}if(i[n+32>>2]=0,i[n+36>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,u[n+36|0]=1,i[n+28>>2]=2,i[n+32>>2]=2,u[n+24|0]=1,i[n+8>>2]=i[e+84>>2],k=i[e+88>>2],!k||(k=Gi(k),i[n+12>>2]=k,!k))break i;i[n+200>>2]=131074,i[n+204>>2]=65538,t=255,k=i[e+128>>2];f:{if(!k)break f;for(e=e+128|0,h=e;B=i[k+16>>2],h=(B|0)<0?h:k,k=i[(B>>>29&4)+k>>2],!!k;);if((e|0)==(h|0)|i[h+16>>2]>0)break f;t=l[h+24|0]}r6(n+48|0,n+8|0,0,3,n+200|0,t,n+24|0,0,f),e=i[n+12>>2];f:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f:{A:switch(l[n+68|0]){default:_2(),H();case 1:e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0;k:{if(u[n+67|0]>=0){r=i[n+60>>2],i[e>>2]=i[n+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+64>>2];break k}T(e,i[n+56>>2],i[n+60>>2])}u[A+20|0]=1;break f;case 0:break A}D7(A,i[n+48>>2],r,f)}if(A=l[n+68|0],(A|0)==255)break e;e=i[23829],i[n+8>>2]=i[23828],i[n+12>>2]=e,X[i[(n+8|0)+(A<<2)>>2]](n+200|0,n+48|0);break e}if(B=i[e+124>>2],x=e+128|0,(B|0)!=(x|0))for(D=(r|0)==1;;){r:{if(r=l[B+24|0],r>>>0<=8){if(h=i[B+44>>2],_=i[B+32>>2],f=i[B+28>>2],!D){if(!f|_>>>0<2)break r;for(W=_>>>1|0,I=f&-2,o=f&1,r=0;;){if(t=_+(r^-1)|0,k=0,g=0,(f|0)!=1)for(;w=i[B+56>>2],y=(h+G(w,r)|0)+k|0,R=l[y|0],w=(h+G(t,w)|0)+k|0,u[y|0]=l[w|0],u[w|0]=R,y=k|1,w=i[B+56>>2],R=y+(h+G(w,r)|0)|0,s=l[R|0],w=y+(h+G(t,w)|0)|0,u[R|0]=l[w|0],u[w|0]=s,k=k+2|0,g=g+2|0,(I|0)!=(g|0););if(o&&(g=i[B+56>>2],w=(h+G(g,r)|0)+k|0,y=l[w|0],k=(h+G(t,g)|0)+k|0,u[w|0]=l[k|0],u[k|0]=y),r=r+1|0,(W|0)==(r|0))break}break r}if(!_|f>>>0<2)break r;for(g=f&2,W=f>>>1|0,I=W&2147483646,r=0;;){if(k=0,t=0,(W|0)!=1)for(;o=h+G(i[B+56>>2],r)|0,w=o+k|0,y=l[w|0],o=(f+o|0)+(k^-1)|0,u[w|0]=l[o|0],u[o|0]=y,o=h+G(i[B+56>>2],r)|0,w=o+k|0,y=l[w+1|0],o=(f+o|0)+(k^-2)|0,u[w+1|0]=l[o|0],u[o|0]=y,k=k+2|0,t=t+2|0,(I|0)!=(t|0););if(g&&(t=h+G(i[B+56>>2],r)|0,o=t+k|0,w=l[o|0],k=(f+t|0)+(k^-1)|0,u[o|0]=l[k|0],u[k|0]=w),r=r+1|0,(_|0)==(r|0))break}break r}if(r>>>0<=16){if(W=i[B+44>>2],_=i[B+32>>2],f=i[B+28>>2],!D){if(!f|_>>>0<2)break r;for(w=_>>>1|0,I=i[B+56>>2],y=f&-4,o=f&3,h=0,R=f>>>0<4;;){if(r=W+(G(h,I)&-2)|0,g=W+(G(I,_+(h^-1)|0)&-2)|0,k=0,t=0,!R)for(;f=k<<1,s=f+r|0,m=F[s>>1],V=s,s=f+g|0,Q[V>>1]=F[s>>1],Q[s>>1]=m,s=f|2,m=s+r|0,C=F[m>>1],s=s+g|0,Q[m>>1]=F[s>>1],Q[s>>1]=C,s=f|4,m=s+r|0,C=F[m>>1],s=s+g|0,Q[m>>1]=F[s>>1],Q[s>>1]=C,f=f|6,s=f+r|0,m=F[s>>1],f=f+g|0,Q[s>>1]=F[f>>1],Q[f>>1]=m,k=k+4|0,t=t+4|0,(y|0)!=(t|0););if(f=0,o)for(;t=k<<1,s=t+r|0,m=F[s>>1],t=t+g|0,Q[s>>1]=F[t>>1],Q[t>>1]=m,k=k+1|0,f=f+1|0,(o|0)!=(f|0););if(h=h+1|0,(w|0)==(h|0))break}break r}if(!_|f>>>0<2)break r;for(I=i[B+56>>2],o=f&2,w=f>>>1|0,y=w&2147483646,h=0;;){if(t=W+(G(h,I)&-2)|0,g=t+(f<<1)|0,k=0,(w|0)!=1)for(R=t+2|0,r=0;s=k<<1,m=s+t|0,C=F[m>>1],V=m,m=g+((k^-1)<<1)|0,Q[V>>1]=F[m>>1],Q[m>>1]=C,s=s+R|0,m=F[s>>1],V=s,s=g+((k^2147483646)<<1)|0,Q[V>>1]=F[s>>1],Q[s>>1]=m,k=k+2|0,r=r+2|0,(y|0)!=(r|0););if(o&&(r=t+(k<<1)|0,t=F[r>>1],s=r,r=g+((k^-1)<<1)|0,Q[s>>1]=F[r>>1],Q[r>>1]=t),h=h+1|0,(_|0)==(h|0))break}break r}if(r>>>0<=32){if(I=i[B+44>>2],g=i[B+32>>2],_=i[B+28>>2],!D){if(!_|g>>>0<2)break r;for(y=g>>>1|0,o=i[B+56>>2],R=_&-4,w=_&3,h=0;;){if(r=I+(G(o,h)&-4)|0,W=I+(G(o,g+(h^-1)|0)&-4)|0,k=0,t=0,_>>>0>=4)for(;f=k<<2,s=f+r|0,m=i[s>>2],V=s,s=f+W|0,i[V>>2]=i[s>>2],i[s>>2]=m,s=f|4,m=s+r|0,C=i[m>>2],s=s+W|0,i[m>>2]=i[s>>2],i[s>>2]=C,s=f|8,m=s+r|0,C=i[m>>2],s=s+W|0,i[m>>2]=i[s>>2],i[s>>2]=C,f=f|12,s=f+r|0,m=i[s>>2],f=f+W|0,i[s>>2]=i[f>>2],i[f>>2]=m,k=k+4|0,t=t+4|0,(R|0)!=(t|0););if(f=0,w)for(;t=k<<2,s=t+r|0,m=i[s>>2],t=t+W|0,i[s>>2]=i[t>>2],i[t>>2]=m,k=k+1|0,f=f+1|0,(w|0)!=(f|0););if(h=h+1|0,(y|0)==(h|0))break}break r}if(!g|_>>>0<2)break r;for(W=i[B+56>>2],o=_&2,w=_>>>1|0,y=w&2147483646,h=0;;){if(f=I+(G(h,W)&-4)|0,t=f+(_<<2)|0,k=0,(w|0)!=1)for(R=f+4|0,r=0;s=k<<2,m=s+f|0,C=i[m>>2],V=m,m=t+((k^-1)<<2)|0,i[V>>2]=i[m>>2],i[m>>2]=C,s=s+R|0,m=i[s>>2],V=s,s=t+((k^1073741822)<<2)|0,i[V>>2]=i[s>>2],i[s>>2]=m,k=k+2|0,r=r+2|0,(y|0)!=(r|0););if(o&&(r=f+(k<<2)|0,f=i[r>>2],s=r,r=t+((k^-1)<<2)|0,i[s>>2]=i[r>>2],i[r>>2]=f),h=h+1|0,(g|0)==(h|0))break}break r}if(r>>>0<=64){if(I=i[B+44>>2],g=i[B+32>>2],h=i[B+28>>2],!D){if(!h|g>>>0<2)break r;for(s=g>>>1|0,y=i[B+56>>2],m=h&-4,R=h&3,_=0;;){if(r=I+(G(_,y)&-8)|0,W=I+(G(y,g+(_^-1)|0)&-8)|0,k=0,t=0,h>>>0>=4)for(;f=k<<3,o=f+r|0,C=i[o>>2],V=i[o+4>>2],w=f+W|0,N=i[w+4>>2],i[o>>2]=i[w>>2],i[o+4>>2]=N,i[w>>2]=C,i[w+4>>2]=V,o=f|8,w=o+r|0,C=i[w>>2],V=i[w+4>>2],o=o+W|0,N=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=N,i[o>>2]=C,i[o+4>>2]=V,o=f|16,w=o+r|0,C=i[w>>2],V=i[w+4>>2],o=o+W|0,N=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=N,i[o>>2]=C,i[o+4>>2]=V,o=f|24,f=o+r|0,w=i[f>>2],C=i[f+4>>2],o=o+W|0,V=i[o+4>>2],i[f>>2]=i[o>>2],i[f+4>>2]=V,i[o>>2]=w,i[o+4>>2]=C,k=k+4|0,t=t+4|0,(m|0)!=(t|0););if(f=0,R)for(;o=k<<3,t=o+r|0,w=i[t>>2],C=i[t+4>>2],o=o+W|0,V=i[o+4>>2],i[t>>2]=i[o>>2],i[t+4>>2]=V,i[o>>2]=w,i[o+4>>2]=C,k=k+1|0,f=f+1|0,(R|0)!=(f|0););if(_=_+1|0,(s|0)==(_|0))break}break r}if(!g|h>>>0<2)break r;for(w=i[B+56>>2],y=h&2,R=h>>>1|0,s=R&2147483646,_=0;;){if(f=I+(G(_,w)&-8)|0,t=f+(h<<3)|0,k=0,(R|0)!=1)for(m=f+8|0,r=0;C=k<<3,W=C+f|0,V=i[W>>2],N=i[W+4>>2],o=t+((k^-1)<<3)|0,S=i[o+4>>2],i[W>>2]=i[o>>2],i[W+4>>2]=S,i[o>>2]=V,i[o+4>>2]=N,W=m+C|0,C=i[W>>2],V=i[W+4>>2],o=t+((k^536870910)<<3)|0,N=i[o+4>>2],i[W>>2]=i[o>>2],i[W+4>>2]=N,i[o>>2]=C,i[o+4>>2]=V,k=k+2|0,r=r+2|0,(s|0)!=(r|0););if(y&&(r=f+(k<<3)|0,W=i[r>>2],o=i[r+4>>2],f=t+((k^-1)<<3)|0,k=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=k,i[f>>2]=W,i[f+4>>2]=o),_=_+1|0,(g|0)==(_|0))break}break r}if(r>>>0<=128){if(g=i[B+44>>2],f=i[B+32>>2],h=i[B+28>>2],!D){if(!h|f>>>0<2)break r;for(W=f>>>1|0,r=0;;){for(I=f+(r^-1)|0,k=0;o=k<<4,_=i[B+56>>2],t=o+(g+(G(_,r)&-16)|0)|0,w=i[t+12>>2],i[n+56>>2]=i[t+8>>2],i[n+60>>2]=w,w=i[t+4>>2],i[n+48>>2]=i[t>>2],i[n+52>>2]=w,_=o+(g+(G(_,I)&-16)|0)|0,o=i[_+12>>2],i[t+8>>2]=i[_+8>>2],i[t+12>>2]=o,o=i[_+4>>2],i[t>>2]=i[_>>2],i[t+4>>2]=o,t=i[n+60>>2],i[_+8>>2]=i[n+56>>2],i[_+12>>2]=t,t=i[n+52>>2],i[_>>2]=i[n+48>>2],i[_+4>>2]=t,k=k+1|0,(h|0)!=(k|0););if(r=r+1|0,(W|0)==(r|0))break}break r}if(!f|h>>>0<2)break r;for(W=h>>>1|0,r=0;;){for(k=0;_=g+(G(i[B+56>>2],r)&-16)|0,t=_+(k<<4)|0,I=i[t+12>>2],i[n+56>>2]=i[t+8>>2],i[n+60>>2]=I,I=i[t+4>>2],i[n+48>>2]=i[t>>2],i[n+52>>2]=I,_=(_+(h<<4)|0)+((k^-1)<<4)|0,I=i[_+12>>2],i[t+8>>2]=i[_+8>>2],i[t+12>>2]=I,I=i[_+4>>2],i[t>>2]=i[_>>2],i[t+4>>2]=I,t=i[n+60>>2],i[_+8>>2]=i[n+56>>2],i[_+12>>2]=t,t=i[n+52>>2],i[_>>2]=i[n+48>>2],i[_+4>>2]=t,k=k+1|0,(W|0)!=(k|0););if(r=r+1|0,(f|0)==(r|0))break}break r}i[n+140>>2]=0,i[n+112>>2]=72244,i[n+56>>2]=72224,e=i[18065],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18066],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[n+56>>2]=r,s=i[r-12>>2],r=n+56|0,i[s+r>>2]=i[18068],k=i[18064],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18069],i[n+112>>2]=72244,i[n+48>>2]=72204,i[n+56>>2]=72224,f=R0(f),i[f>>2]=71280,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,e=Y(r,28374,26),u[n+24|0]=l[B+24|0],Y(Y(e,n+24|0,1),9962,15),e=i[n+108>>2];f:{A:{if(e&16){B=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break A}if(!(e&8)){k=0,u[n+19|0]=0,B=n+8|0;break f}B=n+68|0,e=i[n+76>>2]}A:{if(r=e,e=i[B>>2],k=r-e|0,k>>>0<2147483640){if(k>>>0>=11){r=k|7,B=E(r+1|0),i[n+16>>2]=r-2147483647,i[n+8>>2]=B,i[n+12>>2]=k;break A}if(u[n+19|0]=k,B=n+8|0,k)break A;k=0;break f}g0(),H()}if(!k)break f;z(B,e,k)}u[k+B|0]=0,e=K(n+24|0,4,0,n+8|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}u[n+19|0]<0&&Z(i[n+8>>2]),A=i[18063],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18071],i[n+56>>2]=i[18072],i[f>>2]=71280,u[n+103|0]<0&&Z(i[n+92>>2]),y0(f),p0(n+112|0);break e}h=i[B+4>>2];r:{if(h){for(;;)if(k=h,h=i[k>>2],!h)break r}for(;k=i[B+8>>2],r=i[k>>2]!=(B|0),B=k,!!r;);}if(B=k,(k|0)==(x|0))break}if(r=i[e+88>>2],!r||(e=i[e+84>>2],r=Gi(r),!r))break i;u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}v=n+208|0;return}g3(),H()}function iB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0;k=v-256|0,v=k,x2(k+236|0,e,r),u[k+255|0]<0&&Z(i[k+244>>2]);i:{m=l[e+97|0];e:{if(m>>>0>=3){t1(A,e,17970);break e}o=o2(r);r:{if((m|0)!=2){n=o2(r);break r}n=F0(r)}if(t=i[f+28>>2],V=n,!(t>>>0<n>>>0&&t)){r:{f:{A:{if(n)for(A0=o&15,r0=(A0|0)!=0&(m-1&255)>>>0<2,N0=e+104|0,g=i[18063],y=g-12|0,n0=i[18064],R=n0-12|0,h0=i[18067],N=h0-12|0,I=i[18065],D=I-12|0,x=i[18072],S=i[18071],U0=k+108|0,D0=k+120|0,O=i[18069],L=i[18068],a=i[18066],m0=k+100|0,W0=k+96|0,H0=k+152|0,B=k+56|6,L0=(o>>>4&15)-4|0,q0=(o>>>12|0)-4|0,$0=(o>>>8&15)-4|0;;){if(u[k+60|0]=0,i[k+56>>2]=0,Q[B+14>>1]=0,Q[B+16>>1]=0,Q[B+18>>1]=0,Q[B+20>>1]=0,Q[B+8>>1]=0,Q[B+10>>1]=0,Q[B+12>>1]=0,Q[B+14>>1]=0,Q[B>>1]=0,Q[B+2>>1]=0,Q[B+4>>1]=0,Q[B+6>>1]=0,!i[r+16>>2]){i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=72244,i[k+96>>2]=72224,f=k+88|0,i[f+i[D>>2]>>2]=a,i[k+92>>2]=0,e=f+i[i[k+88>>2]-12>>2]|0,r=k+100|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=k+96|0,i[e+i[N>>2]>>2]=L,i[f+i[R>>2]>>2]=O,i[k+152>>2]=72244,i[k+88>>2]=72204,i[k+96>>2]=72224,n=R0(r),i[n>>2]=71280,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(I0(Y(I0(Y(e,28294,24),V),29076,29),$),23916,7),e=i[k+148>>2];k:{if(e&16){h=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break k}if(!(e&8)){r=0,u[k+27|0]=0,h=k+16|0;break f}h=k+108|0,e=i[k+116>>2]}if(f=i[h>>2],r=e-f|0,r>>>0>=2147483640)break i;if(r>>>0>=11){e=r|7,h=E(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=h,i[k+20>>2]=r;break A}if(u[k+27|0]=r,h=k+16|0,r)break A;r=0;break f}k:{n:{if((m|0)==2){P0=k,d0=F0(r),i[P0+56>>2]=d0;break n}if(P0=k,d0=o2(r),i[P0+56>>2]=d0,!m)break k}P0=k,d0=o2(r)&15,u[P0+60|0]=d0}n=o2(r),i[k+64>>2]=0,i[k+68>>2]=0,Q[k+62>>1]=n,t=k;k:{n:{t:switch(L0|0){case 0:n=F0(r),o=0;break n;case 4:break t;default:break k}n=F0(r),i[k+64>>2]=0,i[k+68>>2]=n,n=F0(r)|i[k+64>>2],o=i[k+68>>2]}i[t+64>>2]=n,i[t+68>>2]=o}W=o2(r);k:{n:{t:{u:{if(n=i[f+52>>2],!(n>>>0<W>>>0&&n)){if(h=0,W)break u;break k}i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=72244,i[k+96>>2]=72224,f=k+88|0,i[f+i[D>>2]>>2]=a,i[k+92>>2]=0,e=f+i[i[k+88>>2]-12>>2]|0,r=k+100|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=k+96|0,i[e+i[N>>2]>>2]=L,i[f+i[R>>2]>>2]=O,i[k+152>>2]=72244,i[k+88>>2]=72204,i[k+96>>2]=72224,t=R0(r),i[t>>2]=71280,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(I0(Y(I0(Y(e,27012,31),W),27044,26),n),42712,2),e=i[k+148>>2];o:{if(e&16){n=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break o}if(!(e&8)){r=0,u[k+27|0]=0,n=k+16|0;break n}n=k+108|0,e=i[k+116>>2]}if(f=i[n>>2],r=e-f|0,r>>>0>=2147483640)break i;if(r>>>0>=11){e=r|7,n=E(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=n,i[k+20>>2]=r;break t}if(u[k+27|0]=r,n=k+16|0,r)break t;r=0;break n}for(;;){i[k+48>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;u:{o:{l:{s:{w:{if(Q0=i[r+16>>2],!Q0){i[k+180>>2]=0,i[k+88>>2]=I,i[k+152>>2]=72244,i[k+96>>2]=72224,t=k+88|0,i[t+i[D>>2]>>2]=a,i[k+92>>2]=0,n=t+i[i[k+88>>2]-12>>2]|0,J0(n,m0),u[n+80|0]=0,i[n+72>>2]=0,i[k+96>>2]=h0,i[i[N>>2]+W0>>2]=L,i[k+88>>2]=n0,i[t+i[R>>2]>>2]=O,i[k+152>>2]=72244,i[k+88>>2]=72204,i[k+96>>2]=72224,s=R0(m0),i[s>>2]=71280,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(S0(Y(I0(Y(W0,28319,25),W),29044,31),h),23779,9),n=i[k+148>>2];_:{if(n&16){if(n=D0,t=i[k+144>>2],o=i[k+124>>2],t>>>0>=o>>>0)break _;i[k+144>>2]=o,t=o;break _}if(!(n&8)){n=0,u[k+15|0]=0,t=k+4|0;break o}t=i[k+116>>2],n=U0}if(w=i[n>>2],n=t-w|0,n>>>0>=2147483640)break w;if(n>>>0>=11){o=n|7,t=E(o+1|0),i[k+12>>2]=o-2147483647,i[k+4>>2]=t,i[k+8>>2]=n;break l}if(u[k+15|0]=n,t=k+4|0,n)break l;n=0;break o}_:{if(!r0)break _;t=k;h:{B:switch(A0-4|0){case 0:n=F0(r),o=0;break h;case 4:break B;default:break _}n=F0(r),i[k+16>>2]=0,i[k+20>>2]=n,n=F0(r)|i[k+16>>2],o=i[k+20>>2]}i[t+16>>2]=n,i[t+20>>2]=o}i[k+24>>2]=0,i[k+28>>2]=0,t=k;_:{h:{B:switch(q0|0){case 0:n=F0(r),o=0;break h;case 4:break B;default:break _}n=F0(r),i[k+24>>2]=0,i[k+28>>2]=n,n=F0(r)|i[k+24>>2],o=i[k+28>>2]}i[t+24>>2]=n,i[t+28>>2]=o}i[k+32>>2]=0,i[k+36>>2]=0;_:{h:{B:switch($0|0){case 0:n=F0(r),o=0;break h;case 4:break B;default:break _}n=F0(r),i[k+32>>2]=0,i[k+36>>2]=n,n=F0(r)|i[k+32>>2],o=i[k+36>>2]}i[t+32>>2]=n,i[t+36>>2]=o}s=i[k+76>>2];_:{if(s>>>0<u0[k+80>>2]){if(n=i[k+20>>2],i[s>>2]=i[k+16>>2],i[s+4>>2]=n,n=i[k+36>>2],i[s+16>>2]=i[k+32>>2],i[s+20>>2]=n,n=i[k+28>>2],i[s+8>>2]=i[k+24>>2],i[s+12>>2]=n,i[s+32>>2]=0,i[s+24>>2]=0,i[s+28>>2]=0,n=i[k+44>>2],t=i[k+40>>2],(n|0)!=(t|0)){if(w=n-t|0,(w|0)<0)break s;o=E(w),i[s+28>>2]=o,i[s+24>>2]=o,n=o+w|0,i[s+32>>2]=n,w&&z(o,t,w),i[s+28>>2]=n}n=s+40|0;break _}h:{B:{v:{if(C=i[k+76>>2],n=i[k+72>>2],f0=C-n|0,w=((f0|0)/40|0)+1|0,w>>>0<107374183){if(o=(i[k+80>>2]-n|0)/40|0,t=o<<1,t=o>>>0>=53687091?107374182:t>>>0>w>>>0?t:w,t>>>0>=107374183)break v;if(V0=G(t,40),e0=E(V0),w=f0+e0|0,o=w,t=i[k+20>>2],i[o>>2]=i[k+16>>2],i[o+4>>2]=t,_=i[k+24>>2],s=i[k+28>>2],o=i[k+32>>2],t=i[k+36>>2],i[w+32>>2]=0,i[w+24>>2]=0,i[w+28>>2]=0,i[w+16>>2]=o,i[w+20>>2]=t,i[w+8>>2]=_,i[w+12>>2]=s,t=i[k+44>>2],s=i[k+40>>2],(t|0)!=(s|0)){if(_=t-s|0,(_|0)<0)break B;o=E(_),i[w+24>>2]=o,t=o+_|0,i[w+32>>2]=t,_&&z(o,s,_),i[w+28>>2]=t}if(o=w+G((f0|0)/-40|0,40)|0,(n|0)!=(C|0)){for(t=n,s=o;_=i[t+4>>2],i[s>>2]=i[t>>2],i[s+4>>2]=_,_=i[t+20>>2],i[s+16>>2]=i[t+16>>2],i[s+20>>2]=_,_=i[t+12>>2],i[s+8>>2]=i[t+8>>2],i[s+12>>2]=_,i[s+24>>2]=i[t+24>>2],i[s+28>>2]=i[t+28>>2],i[s+32>>2]=i[t+32>>2],i[t+32>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,s=s+40|0,t=t+40|0,(C|0)!=(t|0););for(;t=i[n+24>>2],t&&(i[n+28>>2]=t,Z(t)),n=n+40|0,(C|0)!=(n|0););n=i[k+72>>2]}i[k+80>>2]=V0+e0,t=w+40|0,i[k+76>>2]=t,i[k+72>>2]=o,n&&Z(n),n=t;break h}G0(),H()}x0(),H()}G0(),H()}}i[k+76>>2]=n;break u}g0(),H()}G0(),H()}if(!n)break o;z(t,w,n)}u[n+t|0]=0,K(A,2,100,k+4|0),u[k+15|0]<0&&Z(i[k+4>>2]),i[k+88>>2]=g,i[i[y>>2]+(k+88|0)>>2]=S,i[k+96>>2]=x,i[s>>2]=71280,u[k+143|0]<0&&Z(i[k+132>>2]),y0(s),p0(H0)}if(n=i[k+40>>2],n&&(i[k+44>>2]=n,Z(n)),!Q0)break r;if(h=h+1|0,(W|0)==(h|0))break}break k}if(!r)break n;z(n,f,r)}u[r+n|0]=0,K(A,6,1e3,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=g,i[i[y>>2]+(k+88|0)>>2]=S,i[k+96>>2]=x,i[t>>2]=71280,u[k+143|0]<0&&Z(i[k+132>>2]),y0(t),p0(k+152|0);break r}if(!l[r+20|0]){n=i[e+108>>2];k:{if(n>>>0<u0[e+112>>2]){t=i[k+60>>2],i[n>>2]=i[k+56>>2],i[n+4>>2]=t,o=k- -64|0,t=i[o+4>>2],i[n+8>>2]=i[o>>2],i[n+12>>2]=t,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,o=i[k+72>>2],t=i[k+76>>2],lA(n+16|0,o,t,(t-o|0)/40|0),o=n+32|0;break k}o=b9(N0,k+56|0)}i[e+108>>2]=o}if(t=i[k+72>>2],t){if(n=i[k+76>>2],h=t,(n|0)!=(t|0)){for(;o=i[n-16>>2],o&&(i[n-12>>2]=o,Z(o)),n=n-40|0,(t|0)!=(n|0););h=i[k+72>>2]}i[k+76>>2]=t,Z(h)}if($=$+1|0,($|0)==(V|0))break}if(l[r+20|0]==1){if(u[k+88|0]=0,u[k+99|0]=0,K(A,2,100,k+88|0),u[k+99|0]>=0)break e;Z(i[k+88>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break e}T(e,i[26930],i[26931]);break e}if(!r)break f;z(h,f,r)}u[r+h|0]=0,K(A,2,100,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=g,i[i[y>>2]+(k+88|0)>>2]=S,i[k+96>>2]=x,i[n>>2]=71280,u[k+143|0]<0&&Z(i[k+132>>2]),y0(n),p0(k+152|0)}if(A=i[k+72>>2],!A)break e;if(r=i[k+76>>2],n=A,(r|0)!=(n|0)){for(;e=i[r-16>>2],e&&(i[r-12>>2]=e,Z(e)),r=r-40|0,(A|0)!=(r|0););n=i[k+72>>2]}i[k+76>>2]=A,Z(n);break e}i[k+180>>2]=0,i[k+152>>2]=72244,i[k+96>>2]=72224,e=i[18065],i[k+88>>2]=e,t=k+88|0,i[t+i[e-12>>2]>>2]=i[18066],i[k+92>>2]=0,e=t+i[i[k+88>>2]-12>>2]|0,n=k+100|0,J0(e,n),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[k+96>>2]=e,r=k+96|0,i[r+i[e-12>>2]>>2]=i[18068],e=i[18064],i[k+88>>2]=e,i[t+i[e-12>>2]>>2]=i[18069],i[k+152>>2]=72244,i[k+88>>2]=72204,i[k+96>>2]=72224,n=R0(n),i[n>>2]=71280,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(I0(Y(I0(Y(r,27638,18),V),28589,44),i[f+28>>2]),23916,7),e=i[k+148>>2];r:{f:{if(e&16){h=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break f}if(!(e&8)){r=0,u[k+27|0]=0,h=k+16|0;break r}h=k+108|0,e=i[k+116>>2]}f:{if(f=i[h>>2],r=e-f|0,r>>>0<2147483640){if(r>>>0>=11){e=r|7,h=E(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=h,i[k+20>>2]=r;break f}if(u[k+27|0]=r,h=k+16|0,r)break f;r=0;break r}break i}if(!r)break r;z(h,f,r)}u[r+h|0]=0,K(A,6,1e3,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),A=i[18063],i[k+88>>2]=A,i[i[A-12>>2]+(k+88|0)>>2]=i[18071],i[k+96>>2]=i[18072],i[n>>2]=71280,u[k+143|0]<0&&Z(i[k+132>>2]),y0(n),p0(k+152|0)}v=k+256|0;return}g0(),H()}function H7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;f=v-192|0,v=f,k=i[r+52>>2],n=k?i[e+64>>2]:i[e+80>>2];i:{if(!(!k&&i[e+84>>2])&n>>>0<=u0[e+92>>2]){e=E(16),i[f+48>>2]=e,i[f+52>>2]=15,i[f+56>>2]=-2147483632,r=l[15297]|l[15298]<<8|(l[15299]<<16|l[15300]<<24),s=l[15293]|l[15294]<<8|(l[15295]<<16|l[15296]<<24),u[e+7|0]=s,u[e+8|0]=s>>>8,u[e+9|0]=s>>>16,u[e+10|0]=s>>>24,u[e+11|0]=r,u[e+12|0]=r>>>8,u[e+13|0]=r>>>16,u[e+14|0]=r>>>24,r=l[15290]|l[15291]<<8|(l[15292]<<16|l[15293]<<24),s=l[15286]|l[15287]<<8|(l[15288]<<16|l[15289]<<24),u[e|0]=s,u[e+1|0]=s>>>8,u[e+2|0]=s>>>16,u[e+3|0]=s>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+15|0]=0,e=K(f+120|0,13,0,f+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){s=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=s,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[f+59|0]>=0)break i;Z(i[f+48>>2]);break i}g=f+132|0,I=f+139|0,C=f+128|0,i[f+188>>2]=0,o=A+8|0,V=i[26690],y=i[26691];e:{r:{f:{A:{for(;;){k=i[e+68>>2],k=G(u0[e+88>>2]%((i[e+72>>2]-k|0)/48>>>0)|0,48)+k|0,m=i[k>>2],_=i[e+100>>2]+(i[k+8>>2]<<3)|0,k=i[_>>2],X[i[i[k>>2]+8>>2]](f+180|0,k);k:{if(i[e+88>>2]){k=i[f+180>>2],X[i[i[k>>2]+40>>2]](f+120|0,k,r,f+188|0,i[e+20>>2]- -64|0);n:{t:{u:{o:{l:{s:switch(l[f+140|0]){case 0:if(k=107712,!i[26928])break o;t=107724,h=107731,n=107720;break l;case 1:break s;default:break f}if(k=f+120|0,n=C,h=I,t=g,!i[f+120>>2])break f}B=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=B;l:{if(u[h|0]>=0){k=i[n+4>>2],i[o>>2]=i[n>>2],i[o+4>>2]=k,i[o+8>>2]=i[n+8>>2];break l}T(o,i[n>>2],i[t>>2])}u[A+20|0]=1;break u}if(h=i[f+120>>2],h){t=i[f+124>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);o:{if(!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break o;X[i[i[w>>2]+8>>2]](w),p(w)}if(n=2,k=0,(i[e+92>>2]+1>>>0)%((i[e+72>>2]-i[e+68>>2]|0)/48>>>0)|0)break t;u[e+96|0]=0;break t}if(k=1,l[e+96|0]!=1){n=0;break n}k=E(32),i[f+168>>2]=k,i[f+172>>2]=25,i[f+176>>2]=-2147483616,u[k+24|0]=l[5386],n=l[5382]|l[5383]<<8|(l[5384]<<16|l[5385]<<24),t=l[5378]|l[5379]<<8|(l[5380]<<16|l[5381]<<24),u[k+16|0]=t,u[k+17|0]=t>>>8,u[k+18|0]=t>>>16,u[k+19|0]=t>>>24,u[k+20|0]=n,u[k+21|0]=n>>>8,u[k+22|0]=n>>>16,u[k+23|0]=n>>>24,n=l[5374]|l[5375]<<8|(l[5376]<<16|l[5377]<<24),t=l[5370]|l[5371]<<8|(l[5372]<<16|l[5373]<<24),u[k+8|0]=t,u[k+9|0]=t>>>8,u[k+10|0]=t>>>16,u[k+11|0]=t>>>24,u[k+12|0]=n,u[k+13|0]=n>>>8,u[k+14|0]=n>>>16,u[k+15|0]=n>>>24,n=l[5366]|l[5367]<<8|(l[5368]<<16|l[5369]<<24),t=l[5362]|l[5363]<<8|(l[5364]<<16|l[5365]<<24),u[k|0]=t,u[k+1|0]=t>>>8,u[k+2|0]=t>>>16,u[k+3|0]=t>>>24,u[k+4|0]=n,u[k+5|0]=n>>>8,u[k+6|0]=n>>>16,u[k+7|0]=n>>>24,u[k+25|0]=0,k=K(f+48|0,7,0,f+168|0),n=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=n;o:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2],u[A+20|0]=1;break o}if(T(o,i[f+56>>2],i[f+60>>2]),k=u[f+67|0],u[A+20|0]=1,(k|0)>=0)break o;Z(i[f+56>>2])}u[f+179|0]<0&&Z(i[f+168>>2])}n=1,k=0;break n}s=h,w=t}if(t=l[f+140|0],(t|0)!=255&&(i[f+48>>2]=V,i[f+52>>2]=y,X[i[(f+48|0)+(t<<2)>>2]](f+168|0,f+120|0)),!k)break k;k=i[e+88>>2]}else k=0;n:{t:{if(n=i[e+84>>2],!n&u0[e+80>>2]>k>>>0|n){if(kt(f+120|0,i[_>>2],m),B=i[f+120>>2],i[f+72>>2]=B,t=i[f+124>>2],i[f+76>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),k=i[f+180>>2],i[f+92>>2]=0,i[f+84>>2]=0,i[f+88>>2]=0,u[f+80|0]=l[f+128|0],n=i[f+136>>2],h=i[f+132>>2],(n|0)!=(h|0)){if(n=n-h|0,(n|0)<0)break A;_=E(n),i[f+84>>2]=_,W=n+_|0,i[f+92>>2]=W,n&&z(_,h,n),i[f+88>>2]=W}n=i[f+148>>2],i[f+96>>2]=i[f+144>>2],i[f+100>>2]=n,i[f+112>>2]=i[f+160>>2],n=i[f+156>>2],i[f+104>>2]=i[f+152>>2],i[f+108>>2]=n,i[f+72>>2]=0,i[f+76>>2]=0,i[k+8>>2]=B,n=i[k+12>>2],i[k+12>>2]=t;u:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break u;X[i[i[n>>2]+8>>2]](n),p(n)}u[k+16|0]=l[f+80|0],n=i[k+20>>2],n&&(i[k+24>>2]=n,Z(n)),i[k+20>>2]=i[f+84>>2],i[k+24>>2]=i[f+88>>2],i[k+28>>2]=i[f+92>>2],i[f+92>>2]=0,i[f+84>>2]=0,i[f+88>>2]=0,i[k+48>>2]=i[f+112>>2],n=i[f+108>>2],i[k+40>>2]=i[f+104>>2],i[k+44>>2]=n,n=i[f+100>>2],i[k+32>>2]=i[f+96>>2],i[k+36>>2]=n,k=i[f+76>>2];u:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break u;X[i[i[k>>2]+8>>2]](k),p(k)}if(i[e+88>>2]=i[e+88>>2]+1,k=i[f+180>>2],X[i[i[k>>2]+32>>2]](f+48|0,k,!m,r,m,i[e+20>>2]- -64|0),!i[f+48>>2])break t;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;u:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2],u[A+20|0]=1;break u}if(T(o,i[f+56>>2],i[f+60>>2]),k=u[f+67|0],u[A+20|0]=1,(k|0)>=0)break u;Z(i[f+56>>2])}k=i[f+132>>2],k&&(i[f+136>>2]=k,Z(k)),k=i[f+124>>2];u:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break u;X[i[i[k>>2]+8>>2]](k),p(k)}n=1;break k}k=i[f+180>>2],X[i[i[k>>2]+36>>2]](f+120|0,k),k=i[f+120>>2];u:{if(k){if(n=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=n,u[f+139|0]>=0){n=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=n,i[o+8>>2]=i[f+136>>2],u[A+20|0]=1;break u}T(o,i[f+128>>2],i[f+132>>2]),u[A+20|0]=1;break u}u[e+96|0]=1}if(u[f+139|0]<0&&Z(i[f+128>>2]),n=1,!k)break n;break k}if(u[f+67|0]<0&&Z(i[f+56>>2]),k=i[f+132>>2],k&&(i[f+136>>2]=k,Z(k)),k=i[f+124>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break n;X[i[i[k>>2]+8>>2]](k),p(k)}n=0}k=i[f+184>>2];k:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k;X[i[i[k>>2]+8>>2]](k),p(k)}if(n)break}if((n|0)!=2)break e;if(k=i[e+204>>2],k&&(t=i[k+108>>2],k=i[k+104>>2],(t|0)==(k|0)?k=0:k=i[k+4>>2],i[s+144>>2]=k),k=i[e+320>>2],k){H7(f+120|0,k,r),k=l[f+140|0];k:{if(k){if((k|0)!=1)break f;r=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=r;n:{if(u[f+139|0]>=0){r=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=r,i[o+8>>2]=i[f+136>>2];break n}T(o,i[f+128>>2],i[f+132>>2])}u[A+20|0]=1;break k}if(i[f+48>>2]=i[f+120>>2],r=i[f+124>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),N9(s,f+48|0,0),r=i[f+52>>2],!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break k;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=l[f+140|0],(r|0)!=255&&(n=i[26691],i[f+48>>2]=i[26690],i[f+52>>2]=n,X[i[(f+48|0)+(r<<2)>>2]](f+168|0,f+120|0)),k)break e}if(k=i[e+276>>2],k){r=i[e+20>>2],i[f+48>>2]=i[r+48>>2],r=i[r+52>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),ri(f+120|0,k,i[f+48>>2],i[f+188>>2]),r=i[f+52>>2];k:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break k;X[i[i[r>>2]+8>>2]](r),p(r)}k:switch(l[f+140|0]){case 1:e=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=e;n:{if(u[f+139|0]>=0){e=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=e,i[o+8>>2]=i[f+136>>2],e=1,u[A+20|0]=1;break n}if(T(o,i[f+128>>2],i[f+132>>2]),e=l[f+140|0],u[A+20|0]=1,(e|0)==255)break e}A=i[26695],i[f+48>>2]=i[26694],i[f+52>>2]=A,X[i[(f+48|0)+(e<<2)>>2]](f+168|0,f+120|0);break e;case 0:break k;default:break f}Vf(f+48|0,f+120|0),r=l[f+68|0];k:{if(r){if((r|0)!=1)break f;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;n:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2];break n}T(o,i[f+56>>2],i[f+60>>2])}u[A+20|0]=1;break k}n:{if(u[f+59|0]>=0){i[f+40>>2]=i[f+56>>2],k=i[f+52>>2],i[f+32>>2]=i[f+48>>2],i[f+36>>2]=k;break n}T(f+32|0,i[f+48>>2],i[f+52>>2])}if(X[i[i[s>>2]+36>>2]](s,f+32|0),u[f+43|0]>=0)break k;Z(i[f+32>>2])}if(k=l[f+68|0],(k|0)!=255&&(n=i[26693],i[f+168>>2]=i[26692],i[f+172>>2]=n,X[i[(f+168|0)+(k<<2)>>2]](f+180|0,f+48|0)),k=l[f+140|0],(k|0)!=255&&(n=i[26695],i[f+48>>2]=i[26694],i[f+52>>2]=n,X[i[(f+48|0)+(k<<2)>>2]](f+168|0,f+120|0)),r)break e}k=i[e+272>>2];k:{if(!k)break k;r=i[e+20>>2],i[f+120>>2]=i[r+48>>2],r=i[r+52>>2],i[f+124>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),ri(f+48|0,k,i[f+120>>2],i[f+188>>2]),r=i[f+124>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;X[i[i[r>>2]+8>>2]](r),p(r)}n:switch(l[f+68|0]){case 1:e=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=e;t:{if(u[f+67|0]>=0){e=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=e,i[o+8>>2]=i[f+64>>2],k=1;break t}T(o,i[f+56>>2],i[f+60>>2]),k=l[f+68|0]}u[A+20|0]=1;break r;case 0:break n;default:break f}n:{if(i[f+48>>2]==i[f+52>>2]){k=0;break n}k=f+120|0,d9(k,f+48|0),r=l[f+144|0];t:{if(r){if((r|0)!=1)break f;U6(A,k);break t}if(X[i[i[s>>2]+32>>2]](f+12|0,s,f+120|0),u[f+31|0]>=0)break t;Z(i[f+20>>2])}if(k=l[f+144|0],(k|0)!=255&&(n=i[26697],i[f+168>>2]=i[26696],i[f+172>>2]=n,X[i[(f+168|0)+(k<<2)>>2]](f+180|0,f+120|0)),k=l[f+68|0],r)break r;if((k&255)==255)break k}r=i[26695],i[f+120>>2]=i[26694],i[f+124>>2]=r,X[i[(f+120|0)+((k&255)<<2)>>2]](f+168|0,f+48|0)}i[e+92>>2]=i[e+92>>2]+1,u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=s;break i}G0(),H()}_2(),H()}if(A=k&255,(A|0)==255)break e;e=i[26695],i[f+120>>2]=i[26694],i[f+124>>2]=e,X[i[(f+120|0)+(A<<2)>>2]](f+168|0,f+48|0)}if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=f+192|0}function eB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;for(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=72548,k=i[18140],i[f+4>>2]=k,n=i[k-12>>2],k=f+4|0,i[n+k>>2]=i[18141],n=k+i[i[f+4>>2]-12>>2]|0,t=f+8|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,i[f+60>>2]=72548,i[f+4>>2]=72528,m=R0(t),i[m>>2]=71280,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,n=f+164|0,Y2(n,e,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+4|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+4|0,30789,23),l[e+100|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32090,23),l[e+101|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(li(Y(k,31137,19),l[e+102|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(k,32365,21),l[e+103|0]),42713,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+4|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+4|0,30026,37),k=0;;){n=f+4|0,I0(n,i[e+104>>2]>>>31-k&1);i:{if((k&7)==7){u[f+164|0]=32,Y(n,f+164|0,1);break i}if((k&3)!=3)break i;u[f+164|0]=46,Y(f+4|0,f+164|0,1)}if(k=k+1|0,(k|0)==32)break}for(n=f+4|0,Y(n,42713,1),t=f+164|0,s0(t,r),k=0,o=n,s=t,n=u[f+175|0],t=(n|0)<0,Y(o,t?i[f+164>>2]:s,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+4|0,30064,36),n=e+108|0;t=f+4|0,S0(t,i[n+(k>>>3&536870908)>>2]>>>k&1),k=k+1|0,k&7||(u[f+164|0]=32,Y(t,f+164|0,1)),(k|0)!=48;);k=f+4|0,Y(k,42713,1),n=f+164|0,s0(n,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+4|0,32345,19),l[e+116|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(I0(Y(k,32314,30),F[e+118>>1]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,31666,18),l[e+120|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(k,29769,15);i:{e:{r:{f:{A:{k:switch(k=l[e+121|0],k|0){case 0:break k;case 1:break A;case 2:break f;case 3:break r;default:break e}Y(f+4|0,13039,10);break i}Y(f+4|0,22031,5);break i}Y(f+4|0,21567,5);break i}Y(f+4|0,21375,5);break i}S0(f+4|0,k)}k=Y(f+4|0,42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32415,16),l[e+122|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32449,18),l[e+123|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(I0(Y(k,31503,16),F[e+124>>1]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,31481,21),l[e+126|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,29925,21),l[e+127|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32203,20),l[e+128|0]),42713,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(k,31251,13),l[e+129|0]),42713,1);i:{if(_=i[e+132>>2],C=i[e+136>>2],(_|0)!=(C|0))for(y=f+16|0;;){e=f+164|0,s0(e,r),n=e,e=u[f+175|0],k=(e|0)<0,Y(f+4|0,k?i[f+164>>2]:n,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=f+4|0,Y(e,41791,8),i[r>>2]=i[r>>2]+1,k=f+164|0,s0(k,r),n=e,t=k,e=u[f+175|0],k=(e|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=Y(S0(Y(f+4|0,29867,20),l[_|0]),42713,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(e,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(e,31605,15),l[_+1|0]),42713,1);e:{if(B=i[_+4>>2],V=i[_+8>>2],(B|0)==(V|0))break e;for(;;){s0(f+144|0,r),t=u[f+155|0],o=i[f+144>>2],h=i[f+148>>2],e=f+4|0,W=G1(f+156|0,e);r:{if(l[W|0]!=1)break r;e=e+i[i[f+4>>2]-12>>2]|0,I=i[e+4>>2],s=i[e+24>>2];f:{if(l[e+80|0]==1){k=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break f}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(n),u[e+76|0]=k,u[e+77|0]=k>>>8,u[e+78|0]=k>>>16,u[e+79|0]=k>>>24,u[e+80|0]=1}f:{if(!s||(w=i[e+12>>2],n=o,o=(t|0)<0,n=o?n:f+144|0,t=o?h:t,g=n+t|0,o=(I&176)==32?g:n,h=o-n|0,(h|0)>0&&(X[i[i[s>>2]+48>>2]](s,n,h)|0)!=(h|0)))break f;if(t=(t|0)<(w|0)?w-t|0:0,(t|0)>0){if(t>>>0>=2147483640)break i;A:{if(t>>>0>=11){w=t|7,n=E(w+1|0),i[f+172>>2]=w-2147483647,i[f+164>>2]=n,i[f+168>>2]=t;break A}u[f+175|0]=t,n=f+164|0}if(t&&o0(n,k,t),u[n+t|0]=0,k=X[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break f}if(k=g-o|0,(k|0)>0&&(X[i[i[s>>2]+48>>2]](s,o,k)|0)!=(k|0))break f;i[e+12>>2]=0;break r}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}if(_1(W),u[f+155|0]<0&&Z(i[f+144>>2]),e=i[B>>2],W=i[B+4>>2],(e|0)!=(W|0))for(;;){s=l[e|0],n=i[f+4>>2],k=i[n-12>>2]+(f+4|0)|0,l[k+80|0]||(t=f+164|0,n=i[k+28>>2],i[t>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129808),X[i[i[n>>2]+28>>2]](n,32)|0,e2(t),n=i[f+4>>2]),u[k+76|0]=48,u[k+77|0]=0,u[k+78|0]=0,u[k+79|0]=0,u[k+80|0]=1,k=n-12|0,i[i[k>>2]+y>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8,o=S0(f+4|0,s),I=G1(f+144|0,o);r:{if(l[I|0]!=1)break r;n=o+i[i[o>>2]-12>>2]|0,h=i[n+4>>2],s=i[n+24>>2];f:{if(l[n+80|0]==1){w=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+164|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129808),w=X[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=w,u[n+77|0]=w>>>8,u[n+78|0]=w>>>16,u[n+79|0]=w>>>24,u[n+80|0]=1}f:{if(!s||(k=i[n+12>>2],h=(h&176)==32?32852:32851,t=h-32851|0,(t|0)>0&&(X[i[i[s>>2]+48>>2]](s,32851,t)|0)!=(t|0)))break f;if((k|0)>=2){if(k>>>0>=2147483641)break i;t=((k|0)<=1?1:k)-1|0;A:{if(k>>>0>=12){g=t|7,k=E(g+1|0),i[f+172>>2]=g-2147483647,i[f+164>>2]=k,i[f+168>>2]=t;break A}u[f+175|0]=t,k=f+164|0}if(t&&o0(k,w,t),u[k+t|0]=0,k=X[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break f}if(k=32852-h|0,(k|0)>0&&(X[i[i[s>>2]+48>>2]](s,h,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=o+i[i[o>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(I),e=e+1|0,(W|0)==(e|0))break}r:{e=f+4|0,o=G1(f+144|0,e);f:{if(l[o|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,t=i[e+4>>2],s=i[e+24>>2];A:{if(l[e+80|0]==1){k=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(n),u[e+76|0]=k,u[e+77|0]=k>>>8,u[e+78|0]=k>>>16,u[e+79|0]=k>>>24,u[e+80|0]=1}A:{if(!s||(n=i[e+12>>2],w=(t&176)==32?42714:42713,t=w-42713|0,(t|0)>0&&(X[i[i[s>>2]+48>>2]](s,42713,t)|0)!=(t|0)))break A;if((n|0)>=2){if(n>>>0>=2147483641)break r;t=((n|0)<=1?1:n)-1|0;k:{if(n>>>0>=12){h=t|7,n=E(h+1|0),i[f+172>>2]=h-2147483647,i[f+164>>2]=n,i[f+168>>2]=t;break k}u[f+175|0]=t,n=f+164|0}if(t&&o0(n,k,t),u[n+t|0]=0,k=X[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break A}if(k=42714-w|0,(k|0)>0&&(X[i[i[s>>2]+48>>2]](s,w,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}if(_1(o),e=i[i[f+4>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,B=B+12|0,(V|0)==(B|0))break e;continue}break}break i}if(e=i[r>>2],i[r>>2]=((e|0)<=1?1:e)-1,_=_+16|0,(C|0)==(_|0))break}e=i[f+56>>2];e:{r:{if(e&16){k=i[f+52>>2],e=i[f+32>>2],k>>>0<e>>>0&&(i[f+52>>2]=e,k=e),e=f+28|0;break r}if(!(e&8)){k=0,u[A+11|0]=0;break e}k=i[f+24>>2],e=f+16|0}r:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(u[A+11|0]=k,k)break r;k=0;break e}g0(),H()}if(!k)break e;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[18142],i[m>>2]=71280,u[f+51|0]<0&&Z(i[f+40>>2]),y0(m),p0(f+60|0),v=f+176|0;return}g0(),H()}function rB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=M(0),_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=M(0),h0=M(0),m0=M(0),W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=M(0),n2=M(0),Z2=M(0);s=v-160|0,v=s,e=i[r>>2],W=i[e+112>>2],_=i[e+108>>2],n=i[k+4>>2],f=n>>>0<4,t=n<<3,g=(f?16908801>>>t|0:0)&3,N=(f?16843265>>>t|0:0)&3;i:{if((j0(e,3)|0)!=8){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e:{if(S=u1(i[r>>2],6),!S||(j0(i[r>>2],6)|0)==8)break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}R=E(172),w=R,i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=94860,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,t=w+140|0,i[w+136>>2]=t,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],C=w+12|0,i[w+96>>2]=C,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[C+120>>2]=n,i[C+116>>2]=0,i[C+112>>2]=W,i[C+108>>2]=_,T0(s+136|0,C,0,_,W,8,o),n=((_+g|0)-1>>>0)/(g>>>0)|0,f=((W+N|0)-1>>>0)/(N>>>0)|0,T0(s+112|0,C,1,n,f,8,o),w=s+16|0;e:{if(i[s+136>>2]){if(e=i[s+140>>2],i[s+8>>2]=i[s+136>>2],i[s+12>>2]=e,u[s+155|0]>=0){e=i[s+148>>2],i[w>>2]=i[s+144>>2],i[w+4>>2]=e,i[w+8>>2]=i[s+152>>2];break e}T(w,i[s+144>>2],i[s+148>>2]);break e}if(e=i[s+116>>2],i[s+8>>2]=i[s+112>>2],i[s+12>>2]=e,u[s+131|0]>=0){e=i[s+124>>2],i[w>>2]=i[s+120>>2],i[w+4>>2]=e,i[w+8>>2]=i[s+128>>2];break e}T(w,i[s+120>>2],i[s+124>>2])}T0(s+88|0,C,2,n,f,8,o),f=s+56|0;e:{if(i[s+8>>2]){if(e=i[s+12>>2],i[s+48>>2]=i[s+8>>2],i[s+52>>2]=e,u[s+27|0]>=0){e=i[w+4>>2],i[f>>2]=i[w>>2],i[f+4>>2]=e,i[f+8>>2]=i[w+8>>2];break e}T(f,i[s+16>>2],i[s+20>>2]);break e}if(e=i[s+92>>2],i[s+48>>2]=i[s+88>>2],i[s+52>>2]=e,u[s+107|0]>=0){e=i[s+100>>2],i[f>>2]=i[s+96>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+104>>2];break e}T(f,i[s+96>>2],i[s+100>>2])}u[s+107|0]<0&&Z(i[s+96>>2]),u[s+27|0]<0&&Z(i[s+16>>2]),u[s+131|0]<0&&Z(i[s+120>>2]),u[s+155|0]<0&&Z(i[s+144>>2]);e:{if(i[s+48>>2]){if(e=i[s+52>>2],i[A>>2]=i[s+48>>2],i[A+4>>2]=e,r=A+8|0,u[s+67|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+56>>2],i[s+60>>2]),e=u[s+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+56>>2]);break e}u[s+67|0]<0&&Z(i[s+56>>2]);r:{if(!S)break r;if(T0(s+48|0,C,6,_,W,8,o),i[s+48>>2]){if(e=i[s+52>>2],i[A>>2]=i[s+48>>2],i[A+4>>2]=e,r=A+8|0,u[s+67|0]>=0){e=i[s+60>>2],i[r>>2]=i[s+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+64>>2],u[A+20|0]=1;break e}if(T(r,i[s+56>>2],i[s+60>>2]),e=u[s+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+56>>2]);break e}if(u[s+67|0]>=0)break r;Z(i[s+56>>2])}e=i[r>>2],n=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=n,e=o;w=i[e+16>>2]<3,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>3))break A;W0=i[f+56>>2],e=i[f+44>>2]}for(O=e,f=n,e=o;w=i[e+16>>2]<4,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>4))break A;Q0=i[f+56>>2],e=i[f+44>>2]}for(V0=e,f=n,e=o;w=i[e+16>>2]<5,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);if((f|0)!=(n|0))break f}e=0;break r}if(e=0,i[f+16>>2]>5)break r;e0=i[f+56>>2],e=i[f+44>>2]}r0=e;r:{f:{if(f=i[t>>2],f){for(w=t,e=f;I=i[e+16>>2],w=(I|0)<0?w:e,e=i[(I>>>29&4)+e>>2],!!e;);V=0;A:{if((t|0)==(w|0)||(V=0,i[w+16>>2]>0))break A;L=i[w+44>>2],V=i[w+56>>2]}for(w=t,e=f;I=i[e+16>>2]<=0,w=I?w:e,e=i[(I?4:0)+e>>2],!!e;);I=0;A:{if((t|0)==(w|0)||(I=0,i[w+16>>2]>1))break A;P0=i[w+56>>2],I=i[w+44>>2]}for(w=t,e=f;y=i[e+16>>2]<2,w=y?w:e,e=i[(y?4:0)+e>>2],!!e;);if((t|0)!=(w|0))break f}y=0;break r}if(y=0,i[w+16>>2]>2)break r;$0=i[w+56>>2],y=i[w+44>>2]}w=0;r:{if(!S)break r;f:{A:{if(!o)break A;for(e=n;w=i[o+16>>2]<6,e=w?e:o,o=i[(w?4:0)+o>>2],!!o;);if((e|0)==(n|0))break A;if(n=0,i[e+16>>2]>6)break f;N0=i[e+44>>2],n=i[e+56>>2];break f}n=0}if(U0=n,w=0,!f)break r;for(e=t;n=i[f+16>>2]<6,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if(w=0,(e|0)==(t|0)||(w=0,i[e+16>>2]>6))break r;D0=i[e+56>>2],w=i[e+44>>2]}if(t=w,i[s+84>>2]=-1113159960,i[s+76>>2]=1056964608,i[s+80>>2]=-1093247418,i[s+68>>2]=-1096180881,i[s+72>>2]=1056964608,i[s+60>>2]=1038710997,i[s+64>>2]=-1104361250,i[s+52>>2]=1050220167,i[s+56>>2]=1058424226,u[s+48|0]=1,a=l[k+22|0],H0=F[k+20>>1],Nr(s+8|0,H0,F[k+16>>1]),e=i[s+44>>2],i[s+80>>2]=i[s+40>>2],i[s+84>>2]=e,e=i[s+36>>2],i[s+72>>2]=i[s+32>>2],i[s+76>>2]=e,e=i[s+28>>2],f=s- -64|0,i[f>>2]=i[s+24>>2],i[f+4>>2]=e,e=i[s+20>>2],i[s+56>>2]=i[s+16>>2],i[s+60>>2]=e,e=i[s+12>>2],i[s+48>>2]=i[s+8>>2],i[s+52>>2]=e,!(!W|!_)){for($=_&-4,D=_&3,f0=_&-2,L0=_&1,q0=_>>>0<4,n=0;;){B=G(n,V)+L|0,w=G(n,e0)+r0|0,o=G(n,W0)+O|0,m=G(n,Q0)+V0|0,e=0;r:{f:{A:switch(H0|0){default:for(;k=e+B|0,h=M(M(M(l[e+w|0])*E0[s+60>>2])+M(M(M(l[e+o|0])*E0[s+52>>2])+M(E0[s+56>>2]*M(l[e+m|0])))),h=M((a&1?h:M(M(M(h*M(219))*M(.00390625))+M(16)))+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,u[k|0]=(f|0)>=0?f>>>0>=255?255:f:0,e=e+1|0,(_|0)!=(e|0););break r;case 0:if(a&1){if(w=0,o=0,q0)break f;for(;u[e+B|0]=l[e+m|0],f=e|1,u[f+B|0]=l[f+m|0],f=e|2,u[f+B|0]=l[f+m|0],f=e|3,u[f+B|0]=l[f+m|0],e=e+4|0,o=o+4|0,($|0)!=(o|0););break f}for(;k=e+B|0,h=M(M(M(M(M(l[e+m|0])*M(219))*M(.00390625))+M(16))+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,u[k|0]=(f|0)>=0?f>>>0>=255?255:f:0,e=e+1|0,(_|0)!=(e|0););break r;case 8:break A}if(f=0,(_|0)!=1)for(;u[e+B|0]=(l[e+m|0]>>>1)+(l[e+w|0]+l[e+o|0]>>>2),k=e|1,u[k+B|0]=(l[k+m|0]>>>1)+(l[k+w|0]+l[k+o|0]>>>2),e=e+2|0,f=f+2|0,(f0|0)!=(f|0););if(!L0)break r;u[e+B|0]=(l[e+m|0]>>>1)+(l[e+w|0]+l[e+o|0]>>>2);break r}if(!D)break r;for(;u[e+B|0]=l[e+m|0],e=e+1|0,w=w+1|0,(D|0)!=(w|0););}if(n=n+1|0,(W|0)==(n|0))break}for(f0=(N|0)==2,L0=f0&(g|0)==2,q0=(g|N)>>>0<2,f=0;;){k=G(f,e0),x=k+r0|0,B=G(f,W0)+O|0,m=G(f,Q0)+V0|0,n=(f>>>0)/(N>>>0)|0,e=G(n,P0),A0=e+I|0;r:{f:{A:switch(H0|0){default:for(e=f+1|0,e=f0&&e>>>0<W>>>0?e:f,D=G(e,e0)+r0|0,L=G(e,Q0)+V0|0,$=G(e,W0)+O|0,V=G(n,$0)+y|0,e=0;n0=M(l[e+x|0]),h0=M(l[e+m|0]),m0=M(l[e+B|0]),q0||(k=e+1|0,k=k>>>0<_>>>0&&L0?k:e,n0=M(M(M(M(n0+M(l[k+x|0]))+M(l[e+D|0]))+M(l[k+D|0]))*M(.25)),h0=M(M(M(M(h0+M(l[k+m|0]))+M(l[e+L|0]))+M(l[k+L|0]))*M(.25)),m0=M(M(M(M(m0+M(l[k+B|0]))+M(l[e+$|0]))+M(l[k+$|0]))*M(.25))),d0=E0[s+84>>2],n2=E0[s+76>>2],Z2=E0[s+80>>2],w=(e>>>0)/(g>>>0)|0,n=w+A0|0,h=M(M(n0*E0[s+72>>2])+M(M(m0*E0[s+64>>2])+M(h0*E0[s+68>>2]))),o=a&1,h=M(M((o?h:M(M(h*M(224))*M(.00390625)))+M(128))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,n=w+V|0,h=M(M(n0*d0)+M(M(m0*n2)+M(h0*Z2))),h=M(M((o?h:M(M(h*M(224))*M(.00390625)))+M(128))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+g|0,_>>>0>e>>>0;);break r;case 0:if(V=k+O|0,w=e+y|0,e=0,a&1)break f;for(;o=(e>>>0)/(g>>>0)|0,n=o+A0|0,h=M(M(M(M(M(l[e+x|0])*M(224))*M(.00390625))+M(16))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,n=o+w|0,h=M(M(M(M(M(l[e+V|0])*M(224))*M(.00390625))+M(16))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+g|0,_>>>0>e>>>0;);break r;case 8:break A}for(w=G(n,$0)+y|0,e=0;o=(e>>>0)/(g>>>0)|0,n=e+x|0,k=e+B|0,u[o+A0|0]=(l[e+m|0]>>>1)-(l[n|0]+l[k|0]>>>2)^128,u[o+w|0]=(l[k|0]-l[n|0]|0)/2^128,e=e+g|0,_>>>0>e>>>0;);break r}for(;k=(e>>>0)/(g>>>0)|0,u[k+A0|0]=l[e+x|0],u[k+w|0]=l[e+V|0],e=e+g|0,_>>>0>e>>>0;);}if(f=f+N|0,!(W>>>0>f>>>0))break}}r:{if(!S||(e=j0(i[r>>2],6),!W))break r;if(n=_<<(e>>>0>8),e=0,(W|0)!=1)for(k=W&-2,f=0;r=!n,r||z(G(e,D0)+t|0,G(e,U0)+N0|0,n),r||(r=e|1,z(G(r,D0)+t|0,G(r,U0)+N0|0,n)),e=e+2|0,f=f+2|0,(k|0)!=(f|0););if(!(W&1)|!n)break r;z(G(e,D0)+t|0,G(e,U0)+N0|0,n)}u[A+20|0]=0,i[A+4>>2]=R,i[A>>2]=C;break i}if(A=i[R+4>>2],i[R+4>>2]=A-1,A)break i;X[i[i[R>>2]+8>>2]](R),p(R)}v=s+160|0}function x7(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;for(u[114160]=0,u[114161]=0,u[114162]=0,u[114163]=1,u[114164]=1,u[114165]=0,u[114166]=1,u[114167]=1,u[111424]=0,u[111425]=0,u[111426]=1,u[111427]=0,u[111428]=0,u[111429]=1,u[111430]=1,u[111431]=1;;){if((A|0)<0)A=0;else{i:{e:{if(A>>>0<=1){if(k=e<<1,u[k+108695|0]=A,u[k+108694|0]=0,r=e+1|0,!A){e=r;break i}u[(r<<1)+108694|0]=1,f=A-1|0,k=2;break e}if((A|0)!=2)break i;f=1,u[(e<<1)+108694|0]=1,r=e,k=1}u[(r<<1)+108695|0]=f,e=e+k|0}A=A+1|0}if(!((e|0)<4))break}for(i[27866]=50397952,i[27867]=50529026,i[27864]=33620480,i[27865]=33751554,i[27862]=16843008,i[27863]=16974082,i[27860]=65536,i[27861]=196610,i[28544]=16777216,i[28545]=50332160,i[28546]=16842753,i[28547]=50397697,i[28548]=16908290,i[28549]=50463234,i[28550]=16973827,i[28551]=50528771,e=0,A=0;;){if((A|0)<0)A=0;else{i:{e:{r:{f:{A:{k:{n:{if(A>>>0<=3){if(k=e<<1,u[k+108705|0]=A,u[k+108704|0]=0,k=e+1|0,A)break n;e=k;break i}if((A|0)!=4)break k;Q[(e<<1)+108704>>1]=769,r=e+1|0,f=2;break A}if(k=k<<1,u[k+108705|0]=A-1,u[k+108704|0]=1,k=e+2|0,(A|0)==1){e=k;break i}if(k=k<<1,u[k+108705|0]=A-2,u[k+108704|0]=2,k=e+3|0,(A|0)!=2)break f;e=k;break i}if(f=1,r=e,A>>>0>=6)break r}k=r<<1,u[k+108705|0]=A-2,u[k+108704|0]=2,e=e+f|0;break e}k=k<<1,u[k+108705|0]=A-3,u[k+108704|0]=3,e=e+4|0;break i}if((A|0)!=6)break i}k=e<<1,u[k+108705|0]=A-3,u[k+108704|0]=3,e=e+1|0}A=A+1|0}if(!((e|0)<16))break}for(i[27898]=117769988,i[27899]=117901062,i[27896]=117507840,i[27897]=117638914,i[27894]=100992516,i[27895]=101123590,i[27892]=100730368,i[27893]=100861442,i[27890]=84215044,i[27891]=84346118,i[27888]=83952896,i[27889]=84083970,i[27886]=67437572,i[27887]=67568646,i[27884]=67175424,i[27885]=67306498,i[27882]=50660100,i[27883]=50791174,i[27880]=50397952,i[27881]=50529026,i[27878]=33882628,i[27879]=34013702,i[27876]=33620480,i[27877]=33751554,i[27874]=17105156,i[27875]=17236230,i[27872]=16843008,i[27873]=16974082,i[27870]=327684,i[27871]=458758,i[27868]=65536,i[27869]=196610,i[28552]=16777216,i[28553]=50332160,i[28554]=83887104,i[28555]=117442048,i[28556]=16842753,i[28557]=50397697,i[28558]=83952641,i[28559]=117507585,i[28560]=16908290,i[28561]=50463234,i[28562]=84018178,i[28563]=117573122,i[28564]=16973827,i[28565]=50528771,i[28566]=84083715,i[28567]=117638659,i[28568]=17039364,i[28569]=50594308,i[28570]=84149252,i[28571]=117704196,i[28572]=17104901,i[28573]=50659845,i[28574]=84214789,i[28575]=117769733,i[28576]=17170438,i[28577]=50725382,i[28578]=84280326,i[28579]=117835270,i[28580]=17235975,i[28581]=50790919,i[28582]=84345863,i[28583]=117900807,r=0,k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>7|e>>>0>7||(t=r<<1,u[t+108737|0]=A,u[t+108736|0]=e,r=r+1|0),(A|0)>8|e>>>0>7||(t=r<<1,u[t+108737|0]=A-1,u[t+108736|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>7|e>>>0>7||(n=r<<1,u[n+108737|0]=A,u[n+108736|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<64))break}for(r=0,f=0;A=f<<1,u[A+111631|0]=r,u[A+111630|0]=15,u[A+111629|0]=r,u[A+111628|0]=14,u[A+111627|0]=r,u[A+111626|0]=13,u[A+111625|0]=r,u[A+111624|0]=12,u[A+111623|0]=r,u[A+111622|0]=11,u[A+111621|0]=r,u[A+111620|0]=10,u[A+111619|0]=r,u[A+111618|0]=9,u[A+111617|0]=r,u[A+111616|0]=8,u[A+111615|0]=r,u[A+111614|0]=7,u[A+111613|0]=r,u[A+111612|0]=6,u[A+111611|0]=r,u[A+111610|0]=5,u[A+111609|0]=r,u[A+111608|0]=4,u[A+111607|0]=r,u[A+111606|0]=3,u[A+111605|0]=r,u[A+111604|0]=2,u[A+111603|0]=r,u[A+111602|0]=1,u[A+111601|0]=r,e=0,u[A+111600|0]=0,f=f+16|0,r=r+1|0,(r|0)!=16;);for(f=0;A=f<<1,u[A+114367|0]=15,u[A+114366|0]=e,u[A+114365|0]=14,u[A+114364|0]=e,u[A+114363|0]=13,u[A+114362|0]=e,u[A+114361|0]=12,u[A+114360|0]=e,u[A+114359|0]=11,u[A+114358|0]=e,u[A+114357|0]=10,u[A+114356|0]=e,u[A+114355|0]=9,u[A+114354|0]=e,u[A+114353|0]=8,u[A+114352|0]=e,u[A+114351|0]=7,u[A+114350|0]=e,u[A+114349|0]=6,u[A+114348|0]=e,u[A+114347|0]=5,u[A+114346|0]=e,u[A+114345|0]=4,u[A+114344|0]=e,u[A+114343|0]=3,u[A+114342|0]=e,u[A+114341|0]=2,u[A+114340|0]=e,u[A+114339|0]=1,u[A+114338|0]=e,r=0,u[A+114337|0]=0,u[A+114336|0]=e,f=f+16|0,e=e+1|0,(e|0)!=16;);for(n=0;;){if(f=0,(n|0)<0)n=0;else{i:{if(!n){e=0,A=n;break i}for(t=n+1&-2,e=0,A=n,k=0;(A|0)>15|e>>>0>15||(o=r<<1,u[o+108865|0]=A,u[o+108864|0]=e,r=r+1|0),(A|0)>16|e>>>0>15||(o=r<<1,u[o+108865|0]=A-1,u[o+108864|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,k=k+2|0,(t|0)!=(k|0););}n&1|(A|0)>15|e>>>0>15||(k=r<<1,u[k+108865|0]=A,u[k+108864|0]=e,r=r+1|0),n=n+1|0}if(!((r|0)<256))break}for(r=0;A=r<<1,u[A+112175|0]=f,u[A+112174|0]=31,u[A+112173|0]=f,u[A+112172|0]=30,u[A+112171|0]=f,u[A+112170|0]=29,u[A+112169|0]=f,u[A+112168|0]=28,u[A+112167|0]=f,u[A+112166|0]=27,u[A+112165|0]=f,u[A+112164|0]=26,u[A+112163|0]=f,u[A+112162|0]=25,u[A+112161|0]=f,u[A+112160|0]=24,u[A+112159|0]=f,u[A+112158|0]=23,u[A+112157|0]=f,u[A+112156|0]=22,u[A+112155|0]=f,u[A+112154|0]=21,u[A+112153|0]=f,u[A+112152|0]=20,u[A+112151|0]=f,u[A+112150|0]=19,u[A+112149|0]=f,u[A+112148|0]=18,u[A+112147|0]=f,u[A+112146|0]=17,u[A+112145|0]=f,u[A+112144|0]=16,u[A+112143|0]=f,u[A+112142|0]=15,u[A+112141|0]=f,u[A+112140|0]=14,u[A+112139|0]=f,u[A+112138|0]=13,u[A+112137|0]=f,u[A+112136|0]=12,u[A+112135|0]=f,u[A+112134|0]=11,u[A+112133|0]=f,u[A+112132|0]=10,u[A+112131|0]=f,u[A+112130|0]=9,u[A+112129|0]=f,u[A+112128|0]=8,u[A+112127|0]=f,u[A+112126|0]=7,u[A+112125|0]=f,u[A+112124|0]=6,u[A+112123|0]=f,u[A+112122|0]=5,u[A+112121|0]=f,u[A+112120|0]=4,u[A+112119|0]=f,u[A+112118|0]=3,u[A+112117|0]=f,u[A+112116|0]=2,u[A+112115|0]=f,u[A+112114|0]=1,u[A+112113|0]=f,e=0,u[A+112112|0]=0,r=r+32|0,f=f+1|0,(f|0)!=32;);for(f=0;A=f<<1,u[A+114911|0]=31,u[A+114910|0]=e,u[A+114909|0]=30,u[A+114908|0]=e,u[A+114907|0]=29,u[A+114906|0]=e,u[A+114905|0]=28,u[A+114904|0]=e,u[A+114903|0]=27,u[A+114902|0]=e,u[A+114901|0]=26,u[A+114900|0]=e,u[A+114899|0]=25,u[A+114898|0]=e,u[A+114897|0]=24,u[A+114896|0]=e,u[A+114895|0]=23,u[A+114894|0]=e,u[A+114893|0]=22,u[A+114892|0]=e,u[A+114891|0]=21,u[A+114890|0]=e,u[A+114889|0]=20,u[A+114888|0]=e,u[A+114887|0]=19,u[A+114886|0]=e,u[A+114885|0]=18,u[A+114884|0]=e,u[A+114883|0]=17,u[A+114882|0]=e,u[A+114881|0]=16,u[A+114880|0]=e,u[A+114879|0]=15,u[A+114878|0]=e,u[A+114877|0]=14,u[A+114876|0]=e,u[A+114875|0]=13,u[A+114874|0]=e,u[A+114873|0]=12,u[A+114872|0]=e,u[A+114871|0]=11,u[A+114870|0]=e,u[A+114869|0]=10,u[A+114868|0]=e,u[A+114867|0]=9,u[A+114866|0]=e,u[A+114865|0]=8,u[A+114864|0]=e,u[A+114863|0]=7,u[A+114862|0]=e,u[A+114861|0]=6,u[A+114860|0]=e,u[A+114859|0]=5,u[A+114858|0]=e,u[A+114857|0]=4,u[A+114856|0]=e,u[A+114855|0]=3,u[A+114854|0]=e,u[A+114853|0]=2,u[A+114852|0]=e,u[A+114851|0]=1,u[A+114850|0]=e,r=0,u[A+114849|0]=0,u[A+114848|0]=e,f=f+32|0,e=e+1|0,(e|0)!=32;);for(k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>31|e>>>0>31||(t=r<<1,u[t+109377|0]=A,u[t+109376|0]=e,r=r+1|0),(A|0)>32|e>>>0>31||(t=r<<1,u[t+109377|0]=A-1,u[t+109376|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>31|e>>>0>31||(n=r<<1,u[n+109377|0]=A,u[n+109376|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<1024))break}for(f=2;;){for(e=f-2|0,k=(1<<e<<e)-1|0,t=1<<f,o=f<<2,B=i[o+63072>>2],h=e<<2,_=i[h+62976>>2],n=0;;){for(W=B+(n<<f<<1)|0,r=0;;){for(s=W+(r<<1)|0,A=16,e=k;e=e-!A|0,w=_+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((l[m+108704|0]+(l[w|0]<<2)|0)!=(r|0)|(l[m+108705|0]+(l[w+1|0]<<2)|0)!=(n|0)););if(u[s+1|0]=A,u[s|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}for(B=i[h+63008>>2],_=i[o+63096>>2],n=0;;){for(W=_+(n<<f<<1)|0,r=0;;){for(s=W+(r<<1)|0,A=16,e=k;e=e-!A|0,w=B+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((l[m+111440|0]+(l[w|0]<<2)|0)!=(r|0)|(l[m+111441|0]+(l[w+1|0]<<2)|0)!=(n|0)););if(u[s+1|0]=A,u[s|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}for(s=i[h+63040>>2],w=i[o+63120>>2],n=0;;){for(B=w+(n<<f<<1)|0,r=0;;){for(o=B+(r<<1)|0,A=16,e=k;e=e-!A|0,h=s+(e<<1)|0,A=A?A-1|0:15,_=A<<1,!!((l[_+114176|0]+(l[h|0]<<2)|0)!=(r|0)|(l[_+114177|0]+(l[h+1|0]<<2)|0)!=(n|0)););if(u[o+1|0]=A,u[o|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}if(f=f+1|0,(f|0)==6)break}}function z7(A,e,r,f,k,n,t,o,s,w,h,_,B,m){var W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0;g=v-32|0,v=g,C=A,W=r,h0=e,O=f,A0=k,n0=n,y=g+20|0,V=v+-64|0,v=V;i:{e:{r:{f:{if((_|0)>=16){C2(A+4|0,1008,0),u[W+312|0]=3,u[g+30|0]=0,u[g+31|0]=0,Q[y>>1]=0,Q[y+2>>1]=0,Q[y+4>>1]=0,Q[y+6>>1]=0;break f}if(u[g+31|0]=0,f=-1,L=t-1|0,i[V+60>>2]=L,i[V+56>>2]=L,e=o+w|0,i[V+52>>2]=e,k=e-1|0,i[V+48>>2]=k,u[g+30|0]=0,Q[y>>1]=0,Q[y+2>>1]=0,R=W8(W,O,A0,n0,t,o,s,w,B,L,e),u[V+47|0]=R,a=W8(W,O,A0,n0,t,o,s,w,B,L,k),u[V+46|0]=a,D=h0+924|0,x=h<<6,m0=(D+x|0)+(_<<2)|0,r=X[i[i[C>>2]+8>>2]](C,i[m0>>2])|0,!r)break f;A=1-h|0,S=i[r+96>>2];A:{if(l[g+30|0]|!R)break A;if(n=i[W+168>>2],r=L>>n,(r|0)<0||(I=i[W+172>>2],(I|0)<=(r|0)))break r;if(n=e>>n,(n|0)<0|(n|0)>=i[W+176>>2])break e;if(!(l[((i[W+160>>2]+G(r,3)|0)+G(G(n,I),3)|0)+1|0]&3))break A;if(n=i[W+188>>2],r=L>>n,(r|0)<0||(f0=i[W+192>>2],(f0|0)<=(r|0)))break r;if(e=e>>n,(e|0)<0|(e|0)>=i[W+196>>2])break e;if(n=0,I=0,e=(i[W+180>>2]+G(r,12)|0)+G(G(e,f0),12)|0,r=e+h|0,l[r|0]){if(I=l[r+2|0],I>>>0>15)break f;I=X[i[i[C>>2]+8>>2]](C,i[(D+x|0)+(I<<2)>>2])|0}if(x=A+e|0,l[x|0]){if(n=l[x+2|0],n>>>0>15)break f;n=X[i[i[C>>2]+8>>2]](C,i[((A<<6)+D|0)+(n<<2)>>2])|0}k:{if(!(!I|!l[r|0])&&(r=h,i[I+96>>2]==(S|0)))break k;if(!n|!l[x|0]||(r=A,i[n+96>>2]!=(S|0)))break A}u[g+30|0]=1,f=e+(r<<2)|0,f=F[f+4>>1]|F[f+6>>1]<<16,Q[y>>1]=f,Q[y+2>>1]=f>>>16,f=u[(e+r|0)+2|0]}A:{if(l[g+30|0]|!a)break A;if(r=i[W+168>>2],e=L>>r,(e|0)<0||(n=i[W+172>>2],(n|0)<=(e|0)))break r;if(r=k>>r,(r|0)<0|(r|0)>=i[W+176>>2])break e;if(!(l[((i[W+160>>2]+G(e,3)|0)+G(G(r,n),3)|0)+1|0]&3))break A;if(r=i[W+188>>2],e=L>>r,(e|0)<0||(n=i[W+192>>2],(n|0)<=(e|0)))break r;if(k=k>>r,(k|0)<0|(k|0)>=i[W+196>>2])break e;if(I=0,r=0,k=(i[W+180>>2]+G(e,12)|0)+G(G(k,n),12)|0,e=k+h|0,l[e|0]){if(r=l[e+2|0],r>>>0>15)break f;r=X[i[i[C>>2]+8>>2]](C,i[((h<<6)+D|0)+(r<<2)>>2])|0}if(n=A+k|0,l[n|0]){if(I=l[n+2|0],I>>>0>15)break f;I=X[i[i[C>>2]+8>>2]](C,i[((A<<6)+D|0)+(I<<2)>>2])|0}k:{if(!(!r|!l[e|0])&&(e=h,i[r+96>>2]==(S|0)))break k;if(!I|!l[n|0]||(e=A,i[I+96>>2]!=(S|0)))break A}u[g+30|0]=1,r=k+(e<<2)|0,r=F[r+4>>1]|F[r+6>>1]<<16,Q[y>>1]=r,Q[y+2>>1]=r>>>16,f=u[(e+k|0)+2|0]}W0=R|a,x=h0+1308|0,R=x+(h<<4)|0,a=R+_|0,f0=C+4|0,e=V+60|0,I=V+52|0,n=V+47|0,r=1;A:{k:{n:{for(;;){if(!l[g+30|0]){k=-1;t:{if(l[n|0]!=1)break t;if(N=i[e>>2],n=i[W+168>>2],e=N>>n,(e|0)<0||($=i[W+172>>2],($|0)<=(e|0)))break r;if(I=i[I>>2],n=I>>n,(n|0)<0|(n|0)>=i[W+176>>2])break e;if(!(l[((i[W+160>>2]+G(e,3)|0)+G(G(n,$),3)|0)+1|0]&3))break t;if(n=i[W+188>>2],e=N>>n,(e|0)<0||(N=i[W+192>>2],(N|0)<=(e|0)))break r;if(n=I>>n,(n|0)<0|(n|0)>=i[W+196>>2])break e;if(e=(i[W+180>>2]+G(e,12)|0)+G(G(n,N),12)|0,n=e+h|0,!(l[n|0]!=1|l[a|0]!=l[R+u[n+2|0]|0])){u[g+30|0]=1,e=e+(h<<2)|0,e=F[e+4>>1]|F[e+6>>1]<<16,Q[y>>1]=e,Q[y+2>>1]=e>>>16,f=u[n+2|0],k=h;break t}if(n=A+e|0,l[n|0]!=1|l[a|0]!=l[u[n+2|0]+(x+(A<<4)|0)|0])break t;u[g+30|0]=1,e=e+(A<<2)|0,e=F[e+4>>1]|F[e+6>>1]<<16,Q[y>>1]=e,Q[y+2>>1]=e>>>16,f=u[n+2|0],k=A}t:{if(l[g+30|0]!=1)break t;if((f|0)<0){u[g+30|0]=0,u[g+31|0]=0;break f}if((k|0)<0)break n;if(n=X[i[i[C>>2]+8>>2]](C,i[((k<<6)+D|0)+(f<<2)>>2])|0,X[i[i[C>>2]+8>>2]](C,i[m0>>2])|0,l[(x+(k<<4)|0)+f|0]|l[a|0])break t;if(e=i[W+96>>2],k=i[n+96>>2],(e|0)!=(k|0)){k=e-k|0,k=(k|0)>=127?127:k,k=(k|0)<=-128?-128:k,n=k>>31,e=e-S|0,e=(e|0)>=127?127:e,e=G(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(e|0)<=-128?-128:e)+32>>6,e=(e|0)>=4095?4095:e,n=(e|0)<=-4096?-4096:e,I=F[y>>1]|F[y+2>>1]<<16,e=G(n,I>>16),k=e>>31,e=G(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,Q[y+2>>1]=(e|0)<=-32768?-32768:e,e=G(n,I<<16>>16),k=e>>31,e=G(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,Q[y>>1]=(e|0)<=-32768?-32768:e;break t}C2(f0,1008,0),u[W+312|0]=3}if(k=r&1,e=V+56|0,I=V+48|0,n=V+46|0,r=0,k)continue}break}i[V+40>>2]=L,e=t+s|0,i[V+32>>2]=e,r=-1,k=o-1|0,i[V+20>>2]=k,i[V+24>>2]=k,i[V+28>>2]=k,N=e-1|0,i[V+36>>2]=N,u[g+31|0]=0,Q[y+4>>1]=0,Q[y+6>>1]=0,f=W8(W,O,A0,n0,t,o,s,w,B,e,k),u[V+17|0]=f,R=y+4|0;t:{if(l[g+31|0]|!f)break t;if(f=i[W+188>>2],e=e>>f,(e|0)<0||($=i[W+192>>2],($|0)<=(e|0)))break r;if(f=k>>f,(f|0)<0|(f|0)>=i[W+196>>2])break e;if(n=0,I=0,f=(i[W+180>>2]+G(e,12)|0)+G(G(f,$),12)|0,e=f+h|0,l[e|0]){if(I=l[e+2|0],I>>>0>15)break f;I=X[i[i[C>>2]+8>>2]](C,i[((h<<6)+D|0)+(I<<2)>>2])|0}if($=A+f|0,l[$|0]){if(n=l[$+2|0],n>>>0>15)break f;n=X[i[i[C>>2]+8>>2]](C,i[((A<<6)+D|0)+(n<<2)>>2])|0}u:{if(!(!I|!l[e|0])&&(e=h,i[I+96>>2]==(S|0)))break u;if(!n|!l[$|0]||(e=A,i[n+96>>2]!=(S|0)))break t}u[g+31|0]=1,r=f+(e<<2)|0,r=F[r+4>>1]|F[r+6>>1]<<16,Q[R>>1]=r,Q[R+2>>1]=r>>>16,r=u[(e+f|0)+2|0]}e=W8(W,O,A0,n0,t,o,s,w,B,N,k),u[V+18|0]=e;t:{if(l[g+31|0]|!e)break t;if(e=i[W+188>>2],f=N>>e,(f|0)<0||(N=i[W+192>>2],(N|0)<=(f|0)))break r;if(n=k>>e,(n|0)<0|(n|0)>=i[W+196>>2])break e;if(I=0,e=0,n=(i[W+180>>2]+G(f,12)|0)+G(G(n,N),12)|0,f=n+h|0,l[f|0]){if(e=l[f+2|0],e>>>0>15)break f;e=X[i[i[C>>2]+8>>2]](C,i[((h<<6)+D|0)+(e<<2)>>2])|0}if(N=A+n|0,l[N|0]){if(I=l[N+2|0],I>>>0>15)break f;I=X[i[i[C>>2]+8>>2]](C,i[((A<<6)+D|0)+(I<<2)>>2])|0}u:{if(!(!e|!l[f|0])&&(f=h,i[e+96>>2]==(S|0)))break u;if(!I|!l[N|0]||(f=A,i[I+96>>2]!=(S|0)))break t}u[g+31|0]=1,e=n+(f<<2)|0,e=F[e+4>>1]|F[e+6>>1]<<16,Q[R>>1]=e,Q[R+2>>1]=e>>>16,r=u[(f+n|0)+2|0]}e=W8(W,O,A0,n0,t,o,s,w,B,L,k),u[V+19|0]=e;t:{if(l[g+31|0]|!e)break t;if(f=i[W+188>>2],e=L>>f,(e|0)<0||(n=i[W+192>>2],(n|0)<=(e|0)))break r;if(k=k>>f,(k|0)<0|(k|0)>=i[W+196>>2])break e;if(I=0,f=0,e=(i[W+180>>2]+G(e,12)|0)+G(G(k,n),12)|0,k=e+h|0,l[k|0]){if(f=l[k+2|0],f>>>0>15)break f;f=X[i[i[C>>2]+8>>2]](C,i[((h<<6)+D|0)+(f<<2)>>2])|0}if(B=A+e|0,l[B|0]){if(n=l[B+2|0],n>>>0>15)break f;I=X[i[i[C>>2]+8>>2]](C,i[((A<<6)+D|0)+(n<<2)>>2])|0}u:{if(!(!f|!l[k|0])&&(n=h,i[f+96>>2]==(S|0)))break u;if(!I|!l[B|0]||(n=A,i[I+96>>2]!=(S|0)))break t}u[g+31|0]=1,r=e+(n<<2)|0,r=F[r+4>>1]|F[r+6>>1]<<16,Q[R>>1]=r,Q[R+2>>1]=r>>>16,r=u[(e+n|0)+2|0]}if(W0)break f;for(l[g+31|0]&&(u[g+30|0]=1,e=F[y+4>>1]|F[y+6>>1]<<16,Q[y>>1]=e,Q[y+2>>1]=e>>>16),u[g+31|0]=0,n=x+(h<<4)|0,k=0;;){e=-1;t:{if(l[(V+17|0)+k|0]!=1)break t;if(f=k<<2,B=i[W+188>>2],e=i[f+(V+32|0)>>2]>>B,(e|0)<0||(O=i[W+192>>2],(O|0)<=(e|0)))break r;if(f=i[f+(V+20|0)>>2]>>B,(f|0)<0|(f|0)>=i[W+196>>2])break e;if(f=(i[W+180>>2]+G(e,12)|0)+G(G(f,O),12)|0,B=f+2|0,e=B+h|0,O=u[e|0],(O|0)>15)break k;if(!(l[f+h|0]!=1|l[a|0]!=l[n+O|0])){u[g+31|0]=1,r=f+(h<<2)|0,r=F[r+4>>1]|F[r+6>>1]<<16,Q[R>>1]=r,Q[R+2>>1]=r>>>16,r=u[e|0],e=h;break t}if(e=-1,l[A+f|0]!=1||(B=A+B|0,e=-1,l[a|0]!=l[u[B|0]+(x+(A<<4)|0)|0]))break t;u[g+31|0]=1,e=f+(A<<2)|0,e=F[e+4>>1]|F[e+6>>1]<<16,Q[R>>1]=e,Q[R+2>>1]=e>>>16,r=u[B|0],e=A}t:{if(l[g+31|0]!=1)break t;if((r|0)<0){u[g+30|0]=0,u[g+31|0]=0;break f}if((e|0)<0)break A;f=X[i[i[C>>2]+8>>2]](C,i[((e<<6)+D|0)+(r<<2)>>2])|0,B=X[i[i[C>>2]+8>>2]](C,i[m0>>2])|0;u:{if(!(B&&f)){C2(i[W+112>>2]+4|0,1012,0);break u}if(f=i[f+96>>2],l[a|0]|(l[(x+(e<<4)|0)+r|0]|(f|0)==i[B+96>>2])||(e=i[W+96>>2],B=F[R>>1]|F[R+2>>1]<<16,i[V+8>>2]=B,i[V+12>>2]=B,Ut(R,V+8|0,e-f|0,e-S|0)))break t;C2(f0,1008,0)}u[W+312|0]=3}if(k=k+1|0,(k|0)==3)break f;if(l[g+31|0])break}break f}M0(21970,18236,1801,8189),H()}u[W+312|0]=3,C2(f0,1012,0);break f}M0(21970,18236,1959,8189),H()}v=V- -64|0;break i}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}i:{e:{r:{f:{A:{k:{if(A=l[g+30|0],e=l[g+31|0],!(!A|!e)){if(F[g+20>>1]!=F[g+24>>1]|F[g+22>>1]!=F[g+26>>1])break k;Ur(C,W,h0,t,o,s,w,_,h,g+12|0,g+19|0);break A}if(Ur(C,W,h0,t,o,s,w,_,h,g+12|0,g+19|0),A)break f;if(_=0,A=0,!e)break i;break e}u[g+19|0]=0}A=i[g+20>>2],Q[m>>1]=A,Q[m+2>>1]=A>>>16;break r}if(A=i[g+20>>2],Q[m>>1]=A,Q[m+2>>1]=A>>>16,e)break r;A=1;break i}if(_=1,F[g+20>>1]!=F[g+24>>1])break e;if(A=1,F[g+22>>1]==F[g+26>>1])break i}A=(_<<2)+m|0,e=i[g+24>>2],Q[A>>1]=e,Q[A+2>>1]=e>>>16,A=_+1|0}_=A,l[g+19|0]&&(A=(_<<2)+m|0,e=i[g+12>>2],Q[A>>1]=e,Q[A+2>>1]=e>>>16,_=_+1|0);i:{if(_>>>0<=1){if(A=_<<2,e=8-A|0,!e)break i;o0(A+m|0,0,e);break i}if((_|0)==2)break i;M0(21519,18236,2063,4767),H()}v=g+32|0}function Z8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;h=v-16|0,v=h,n=v-16|0,v=n;i:{e:{r:{if(k=e,!i[e+44>>2]){e=E(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89852,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87172,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=1885954932,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+32>>2]=1751411826,i[k+36>>2]=f,f=i[k+40>>2],i[k+40>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89732,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87092,i[e+32>>2]=1835365473,i[k+44>>2]=f,f=i[k+48>>2],i[k+48>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90092,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=87572,i[e+32>>2]=1768973167,i[k+52>>2]=f,f=i[k+56>>2],i[k+56>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}e=E(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90132,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87720,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1768975713,i[k+60>>2]=f,f=i[k+64>>2],i[k+64>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}f=E(176),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=89932,W=k,g=Ft(f+16|0),i[W+68>>2]=g,e=i[k+72>>2],i[k+72>>2]=f;f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89972,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87412,i[e+32>>2]=1768517222,i[k+100>>2]=f,f=i[k+104>>2],i[k+104>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90052,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=87492,i[e+32>>2]=1768977008,i[k+116>>2]=f,f=i[k+120>>2],i[k+120>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}e=E(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89892,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87252,i[e+32>>2]=1885959277,i[e+120>>2]=0,i[k+92>>2]=f,f=i[k+96>>2],i[k+96>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[k+44>>2],i[n+8>>2]=i[k+36>>2],e=i[k+40>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+44>>2],i[n+8>>2]=i[k+92>>2],e=i[k+96>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+44>>2],i[n+8>>2]=i[k+68>>2],e=i[k+72>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+44>>2],i[n+8>>2]=i[k+100>>2],e=i[k+104>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+44>>2],i[n+8>>2]=i[k+116>>2],e=i[k+120>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+116>>2],i[n+8>>2]=i[k+52>>2],e=i[k+56>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}f=i[k+116>>2],i[n+8>>2]=i[k+60>>2],e=i[k+64>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}n3(k+124|0,i[k+128>>2]),i[k+124>>2]=k+128,i[k+128>>2]=0,i[k+132>>2]=0,B=i[k+44>>2],o=i[k+48>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[k+20>>2],t=i[k+24>>2];f:{if(e>>>0<t>>>0){i[e+4>>2]=o,i[e>>2]=B,e=e+8|0;break f}if(s=i[k+16>>2],e=e-s|0,m=e>>3,f=m+1|0,f>>>0>=536870912)break r;if(t=t-s|0,w=t>>2,t=t>>>0>=2147483640?536870911:f>>>0<w>>>0?w:f,t){if(t>>>0>=536870912)break e;f=E(t<<3)}else f=0;if(w=f+e|0,i[w+4>>2]=o,i[w>>2]=B,o=w-(m<<3)|0,e&&z(o,s,e),i[k+24>>2]=f+(t<<3),e=w+8|0,i[k+20>>2]=e,i[k+16>>2]=o,!s)break f;Z(s)}i[k+20>>2]=e}v=n+16|0;break i}G0(),H()}x0(),H()}if(n=k+128|0,e=i[k+124>>2],(n|0)==(e|0))s=1;else{for(;;){o=i[i[e+20>>2]+104>>2],s=o>>>0<_>>>0,f=i[e+4>>2];i:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break i}for(;f=e,e=i[e+8>>2],(f|0)!=i[e>>2];);}if(_=s?_:o,(e|0)==(n|0))break}s=_+1|0}o=E(184),e=o,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90012,t=e+16|0,e=t,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,e=o,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[t>>2]=87332,i[e+128>>2]=0,i[e+132>>2]=0,Q[e+124>>1]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,u[e+173|0]=0,u[e+174|0]=0,u[e+175|0]=0,u[e+176|0]=0,u[e+177|0]=0,u[e+178|0]=0,u[e+179|0]=0,u[e+180|0]=0,i[e+32>>2]=1768842853,i[A+4>>2]=e,i[A>>2]=t,i[e+120>>2]=s,u[t+164|0]=0,i[t+100>>2]=i[t+100>>2]&-2,i[e+128>>2]=r,e=n,f=i[e>>2];i:{e:{if(!f)break e;for(;;){if(e=f,r=i[e+16>>2],r>>>0>s>>>0){if(n=e,f=i[e>>2],f)continue;break e}if(r>>>0>=s>>>0)break i;if(f=i[e+4>>2],!f)break}n=e+4|0}f=E(28),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=s,i[f+8>>2]=e,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,e=i[i[k+124>>2]>>2],e&&(i[k+124>>2]=e),m1(i[k+128>>2],f),i[k+132>>2]=i[k+132>>2]+1}i[o+4>>2]=i[o+4>>2]+1,i[f+20>>2]=t,e=i[f+24>>2],i[f+24>>2]=o;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[k+100>>2],i[h+8>>2]=i[A>>2],A=i[A+4>>2],i[h+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),r2(e+36|0,h+8|0),A=i[h+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=h+16|0}function T7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;s=v-112|0,v=s,X[i[i[e>>2]+120>>2]](A,e,r,f,k,n);i:{e:{r:{f:{if(l[A+44|0])break f;D9(s+100|0,r,k,n,i[k+4>>2]),k=i[s+100>>2],n=i[s+104>>2],c9(A,i[A+4>>2],k,n,n-k>>3),k=i[r>>2],h=i[k+112>>2],w=i[k+108>>2],k=i[A+28>>2],i[s+96>>2]=k,i[s+92>>2]=i[A+32>>2];A:{if(k)break A;k:{if(k=i[f>>2],i[k>>2]<3||(k=i[k+112>>2],!k))break k;X[k|0](i[f+4>>2],w,h,s+96|0,s+92|0);break A}i[s+92>>2]=h,i[s+96>>2]=w}n=E(128),f=n,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90172,t=f+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,Q[f+112>>1]=0,i[t>>2]=87652,i[f+32>>2]=1769173093,k=i[s+96>>2],i[f+124>>2]=i[s+92>>2],i[f+120>>2]=k,W=f,g=X[i[i[e>>2]+48>>2]](e)|0,u[W+112|0]=g,i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];A:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=t,k=k+8|0;break A}if(B=i[A>>2],f=k-B|0,m=f>>3,k=m+1|0,k>>>0>=536870912)break r;if(o=o-B|0,_=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<_>>>0?_:k,o){if(o>>>0>=536870912)break e;k=E(o<<3)}else k=0;if(_=k+f|0,i[_+4>>2]=n,i[_>>2]=t,t=_-(m<<3)|0,f&&z(t,B,f),i[A+8>>2]=k+(o<<3),k=_+8|0,i[A+4>>2]=k,i[A>>2]=t,!B)break A;Z(B)}i[A+4>>2]=k;A:{if((w|0)==i[s+96>>2]&i[s+92>>2]==(h|0))break A;k=E(152),f=k,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90332,B=f+16|0,i[B+8>>2]=0,i[B+12>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0,i[B+32>>2]=0,i[B>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[B>>2]=88040,i[f+140>>2]=0,i[f+144>>2]=1,i[f+132>>2]=0,i[f+136>>2]=1,i[f+124>>2]=0,i[f+128>>2]=1,i[f+116>>2]=0,i[f+120>>2]=1,i[f+32>>2]=1668047216,o=i[s+96>>2],t=i[s+92>>2],i[B+108>>2]=h,i[B+112>>2]=1,i[B+100>>2]=w,i[B+104>>2]=1,t=h-t|0,h=t-65537>>>0<4294836223,i[B+124>>2]=0|(h?(t|0)/2|0:t),i[B+128>>2]=h?1:2,t=w-o|0,h=t-65537>>>0<4294836223,i[B+116>>2]=0|(h?(t|0)/2|0:t),i[B+120>>2]=h?1:2,i[f+4>>2]=i[f+4>>2]+1,t=i[A+4>>2],w=i[A+8>>2];k:{if(t>>>0<w>>>0){i[t+4>>2]=f,i[t>>2]=B,f=t+8|0;break k}if(h=i[A>>2],f=t-h|0,_=f>>3,t=_+1|0,t>>>0>=536870912)break r;if(w=w-h|0,o=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<o>>>0?o:t,w){if(w>>>0>=536870912)break e;t=E(w<<3)}else t=0;if(o=t+f|0,i[o+4>>2]=k,i[o>>2]=B,B=o-(_<<3)|0,f&&z(B,h,f),i[A+8>>2]=t+(w<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=B,!h)break k;Z(h)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break A;X[i[i[k>>2]+8>>2]](k),p(k)}f=i[r>>2],k=i[f+120>>2],h=i[f+116>>2],t=E(136),i[t>>2]=91252,i[t+4>>2]=0,i[t+8>>2]=0,B=t+16|0,f=B,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,Q[t+112>>1]=0,i[f>>2]=88840,i[t+128>>2]=0,i[t+120>>2]=0,i[t+124>>2]=0,i[t+32>>2]=1885960297;A:{k:switch(h|0){case 2:if(w=j0(i[r>>2],0),f=i[t+124>>2],o=i[t+128>>2],f>>>0<o>>>0){u[f|0]=w,i[t+124>>2]=f+1;break A}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=w,f&&z(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,h&&Z(h),i[t+124>>2]=f;break A;case 0:w=j0(i[r>>2],0),f=i[t+124>>2],o=i[t+128>>2];n:{if(f>>>0<o>>>0){u[f|0]=w,f=f+1|0;break n}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;if(o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=w,f&&z(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!h)break n;Z(h)}i[t+124>>2]=f,w=j0(i[r>>2],1),f=i[t+124>>2],o=i[t+128>>2];n:{if(f>>>0<o>>>0){u[f|0]=w,f=f+1|0;break n}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;if(o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=w,f&&z(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!h)break n;Z(h)}if(i[t+124>>2]=f,w=j0(i[r>>2],2),f=i[t+124>>2],o=i[t+128>>2],f>>>0<o>>>0){u[f|0]=w,i[t+124>>2]=f+1;break A}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=w,f&&z(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,h&&Z(h),i[t+124>>2]=f;break A;case 1:break k;default:break A}if(k-10>>>0>=6){if((k|0)!=3)break A;FA(B,j0(i[r>>2],3)),FA(B,j0(i[r>>2],4)),FA(B,j0(i[r>>2],5));break A}h=j0(i[r>>2],10),f=i[t+124>>2],o=i[t+128>>2];k:{if(f>>>0<o>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=h,f&&z(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f,o=i[t+128>>2];k:{if(o>>>0>f>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=h,f&&z(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f,o=i[t+128>>2];k:{if(o>>>0>f>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=E(o):k=0,_=k+f|0,u[_|0]=h,f&&z(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f}i[t+4>>2]=i[t+4>>2]+1,f=i[A+4>>2],w=i[A+8>>2];A:{if(f>>>0<w>>>0){i[f+4>>2]=t,i[f>>2]=B,f=f+8|0;break A}if(h=i[A>>2],f=f-h|0,_=f>>3,k=_+1|0,k>>>0>=536870912)break r;if(w=w-h|0,o=w>>2,w=w>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,w){if(w>>>0>=536870912)break e;k=E(w<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=t,i[o>>2]=B,B=o-(_<<3)|0,f&&z(B,h,f),i[A+8>>2]=k+(w<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=B,!h)break A;Z(h)}if(i[A+4>>2]=f,f=i[r>>2],i[s+8>>2]=95160,u[s+20|0]=l[f+12|0],k=i[f+8>>2],i[s+12>>2]=i[f+4>>2],i[s+16>>2]=k,i[s+24>>2]=i[f+16>>2],k=i[f+20>>2],i[s+28>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[s+72>>2]=i[f- -64>>2],B=i[f+60>>2],k=s- -64|0,i[k>>2]=i[f+56>>2],i[k+4>>2]=B,k=i[f+52>>2],i[s+56>>2]=i[f+48>>2],i[s+60>>2]=k,k=i[f+44>>2],i[s+48>>2]=i[f+40>>2],i[s+52>>2]=k,k=i[f+36>>2],i[s+40>>2]=i[f+32>>2],i[s+44>>2]=k,k=i[f+28>>2],i[s+32>>2]=i[f+24>>2],i[s+36>>2]=k,u[s+88|0]=0,u[s+76|0]=0,k=s+76|0,l[f+80|0]==1){A:{if(u[f+79|0]>=0){B=i[f+72>>2],i[k>>2]=i[f+68>>2],i[k+4>>2]=B,i[k+8>>2]=i[f+76>>2];break A}T(k,i[f+68>>2],i[f+72>>2])}u[s+88|0]=1}f=i[s+16>>2],i[e+4>>2]=i[s+12>>2],i[e+8>>2]=f,u[e+12|0]=l[s+20|0],f=i[s+24>>2],B=i[s+28>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),i[e+16>>2]=f,f=i[e+20>>2],i[e+20>>2]=B;A:{if(!f||(B=i[f+4>>2],i[f+4>>2]=B-1,B))break A;X[i[i[f>>2]+8>>2]](f),p(f)}if(f=i[s+36>>2],i[e+24>>2]=i[s+32>>2],i[e+28>>2]=f,i[e- -64>>2]=i[s+72>>2],f=i[s+68>>2],i[e+56>>2]=i[s+64>>2],i[e+60>>2]=f,f=i[s+60>>2],i[e+48>>2]=i[s+56>>2],i[e+52>>2]=f,f=i[s+52>>2],i[e+40>>2]=i[s+48>>2],i[e+44>>2]=f,f=i[s+44>>2],i[e+32>>2]=i[s+40>>2],i[e+36>>2]=f,iu(e+68|0,k),e=s+8|0,PA(e),Gf(e,i[r>>2],0),r=A,f=i[A+4>>2],A=i[s+8>>2],e=i[s+12>>2],c9(r,f,A,e,e-A>>3),r=i[s+8>>2],r){if(A=i[s+12>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];A:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[s+8>>2]}i[s+12>>2]=r,Z(e)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(X[i[i[t>>2]+8>>2]](t),p(t)),A=i[n+4>>2],i[n+4>>2]=A-1,A||(X[i[i[n>>2]+8>>2]](n),p(n)),r=i[s+100>>2],!r)break f;if(A=i[s+104>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];A:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[s+100>>2]}i[s+104>>2]=r,Z(e)}v=s+112|0;return}G0(),H()}x0(),H()}G0(),H()}function fB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;t=v-16|0,v=t,o=(f|0)/8|0,w=i[r>>2],B=i[r+4>>2]-w|0,s=i[k>>2];i:{if(o>>>0>B-s>>>0){if(e=E(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[9161]|l[9162]<<8|(l[9163]<<16|l[9164]<<24),f=l[9157]|l[9158]<<8|(l[9159]<<16|l[9160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[9192]|l[9193]<<8|(l[9194]<<16|l[9195]<<24),f=l[9188]|l[9189]<<8|(l[9190]<<16|l[9191]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[9185]|l[9186]<<8|(l[9187]<<16|l[9188]<<24),f=l[9181]|l[9182]<<8|(l[9183]<<16|l[9184]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9177]|l[9178]<<8|(l[9179]<<16|l[9180]<<24),f=l[9173]|l[9174]<<8|(l[9175]<<16|l[9176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9169]|l[9170]<<8|(l[9171]<<16|l[9172]<<24),f=l[9165]|l[9166]<<8|(l[9167]<<16|l[9168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}h=w+s|0,_=l[h|0],w=l[h+1|0];e:{if((f|0)==32){_=w<<16|_<<24|l[h+2|0]<<8,w=l[h+3|0],h=4;break e}_=_<<8,h=2}if(h=h+s|0,i[k>>2]=h,s=B-h|0,h=w|_,o=O0(o,o>>31,h,0),w=l0<<1|o>>>31,o=o<<1,!w&s>>>0<o>>>0|w){if(e=E(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[9161]|l[9162]<<8|(l[9163]<<16|l[9164]<<24),f=l[9157]|l[9158]<<8|(l[9159]<<16|l[9160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[9192]|l[9193]<<8|(l[9194]<<16|l[9195]<<24),f=l[9188]|l[9189]<<8|(l[9190]<<16|l[9191]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[9185]|l[9186]<<8|(l[9187]<<16|l[9188]<<24),f=l[9181]|l[9182]<<8|(l[9183]<<16|l[9184]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9177]|l[9178]<<8|(l[9179]<<16|l[9180]<<24),f=l[9173]|l[9174]<<8|(l[9175]<<16|l[9176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9169]|l[9170]<<8|(l[9171]<<16|l[9172]<<24),f=l[9165]|l[9166]<<8|(l[9167]<<16|l[9168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}e:{if(l[e+4|0]==1){if(h>>>0>2)break e;if(e=E(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[23702]|l[23703]<<8|(l[23704]<<16|l[23705]<<24),f=l[23698]|l[23699]<<8|(l[23700]<<16|l[23701]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[23733]|l[23734]<<8|(l[23735]<<16|l[23736]<<24),f=l[23729]|l[23730]<<8|(l[23731]<<16|l[23732]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[23726]|l[23727]<<8|(l[23728]<<16|l[23729]<<24),f=l[23722]|l[23723]<<8|(l[23724]<<16|l[23725]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23718]|l[23719]<<8|(l[23720]<<16|l[23721]<<24),f=l[23714]|l[23715]<<8|(l[23716]<<16|l[23717]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23710]|l[23711]<<8|(l[23712]<<16|l[23713]<<24),f=l[23706]|l[23707]<<8|(l[23708]<<16|l[23709]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(h>>>0>1)break e;if(e=E(48),i[t+4>>2]=e,i[t+8>>2]=40,i[t+12>>2]=-2147483600,r=l[23742]|l[23743]<<8|(l[23744]<<16|l[23745]<<24),f=l[23738]|l[23739]<<8|(l[23740]<<16|l[23741]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+40|0]=0,r=l[23774]|l[23775]<<8|(l[23776]<<16|l[23777]<<24),f=l[23770]|l[23771]<<8|(l[23772]<<16|l[23773]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[23766]|l[23767]<<8|(l[23768]<<16|l[23769]<<24),f=l[23762]|l[23763]<<8|(l[23764]<<16|l[23765]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23758]|l[23759]<<8|(l[23760]<<16|l[23761]<<24),f=l[23754]|l[23755]<<8|(l[23756]<<16|l[23757]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23750]|l[23751]<<8|(l[23752]<<16|l[23753]<<24),f=l[23746]|l[23747]<<8|(l[23748]<<16|l[23749]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(_>>>0>=536870912){if(e=E(48),i[t+4>>2]=e,i[t+8>>2]=42,i[t+12>>2]=-2147483600,r=l[25211]|l[25212]<<8|(l[25213]<<16|l[25214]<<24),f=l[25207]|l[25208]<<8|(l[25209]<<16|l[25210]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+42|0]=0,r=l[25247]|l[25248]<<8,u[e+40|0]=r,u[e+41|0]=r>>>8,r=l[25243]|l[25244]<<8|(l[25245]<<16|l[25246]<<24),f=l[25239]|l[25240]<<8|(l[25241]<<16|l[25242]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25235]|l[25236]<<8|(l[25237]<<16|l[25238]<<24),f=l[25231]|l[25232]<<8|(l[25233]<<16|l[25234]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25227]|l[25228]<<8|(l[25229]<<16|l[25230]<<24),f=l[25223]|l[25224]<<8|(l[25225]<<16|l[25226]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25219]|l[25220]<<8|(l[25221]<<16|l[25222]<<24),f=l[25215]|l[25216]<<8|(l[25217]<<16|l[25218]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(K4(A,e+20|0,h<<3,n,9197),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),g=(f|0)!=32;e:{r:{for(;;){n=i[k>>2],f=n+4|0,o=i[r>>2],w=o+n|0,_=l[w|0],s=l[w+1|0];f:{if(!g){B=l[w+3|0],m=l[w+2|0],i[k>>2]=f,f=f+o|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),w=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=n+8|0,n=s<<16|_<<24|m<<8|B;break f}n=n+2|0,i[k>>2]=n,n=n+o|0,w=(l[n+1|0]<<16|l[n|0]<<24)>>16,n=(s<<16|_<<24)>>16}i[k>>2]=f;f:{f=i[e+12>>2],s=i[e+16>>2];A:{if(f>>>0<s>>>0){i[f>>2]=n,i[f+4>>2]=w,f=f+8|0;break A}if(_=i[e+8>>2],f=f-_|0,m=f>>3,o=m+1|0,o>>>0>=536870912)break f;if(s=s-_|0,B=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<B>>>0?B:o,s){if(s>>>0>=536870912)break r;o=E(s<<3)}else o=0;if(B=o+f|0,i[B>>2]=n,i[B+4>>2]=w,n=B-(m<<3)|0,f&&z(n,_,f),i[e+16>>2]=o+(s<<3),f=B+8|0,i[e+12>>2]=f,i[e+8>>2]=n,!_)break A;Z(_)}if(i[e+12>>2]=f,W=W+1|0,(h|0)==(W|0))break e;continue}break}G0(),H()}x0(),H()}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=t+16|0}function AB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=M(0),_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=M(0),h0=0,m0=0,W0=M(0),Q0=0,V0=0,e0=M(0),r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=M(0),H2=M(0),T2=M(0),b2=M(0),e1=M(0);s=v-128|0,v=s,e=i[r>>2],h0=i[e+120>>2],m=j0(e,0),a=j0(i[r>>2],1),e=j0(i[r>>2],2),m0=u1(i[r>>2],6),m0&&(f0=j0(i[r>>2],6));i:{if(!(!((m|0)==8|(a|0)==8)&(e|0)!=8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((m|0)==(a|0)&(e|0)==(m|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],V=i[e+112>>2],I=i[e+108>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,n=w+140|0,i[w+136>>2]=n,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],C=w+12|0,i[w+96>>2]=C,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[C+120>>2]=3,i[C+116>>2]=1,i[C+112>>2]=V,i[C+108>>2]=I,T0(s+56|0,C,3,I,V,m,o),T0(s+32|0,C,4,I,V,m,o),k=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=e,i[k+8>>2]=i[f+8>>2];break e}T(k,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[k>>2]=i[s+40>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+48>>2];break e}T(k,i[s+40>>2],i[s+44>>2])}T0(s+8|0,C,5,I,V,m,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=e,i[f+8>>2]=i[k+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!m0)break r;if(T0(s+104|0,C,6,I,V,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=k,e=o;t=i[e+16>>2],f=(t|0)<0?f:e,e=i[(t>>>29&4)+e>>2],!!e;);e=0;A:{if((f|0)==(k|0)||(e=0,i[f+16>>2]>0))break A;r0=i[f+44>>2],e=i[f+56>>2]}for(V0=e,f=k,e=o;t=i[e+16>>2]<=0,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);g=0;A:{if((f|0)==(k|0)||(g=0,i[f+16>>2]>1))break A;N0=i[f+44>>2],g=i[f+56>>2]}for(f=k,e=o;t=i[e+16>>2]<2,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}e=0;break r}if(e=0,i[f+16>>2]>2)break r;U0=i[f+56>>2]>>>1|0,e=i[f+44>>2]}D0=e;r:{f:{if(f=i[n>>2],f){for(t=n,e=f;_=i[e+16>>2]<3,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);B=0;A:{if((n|0)==(t|0)||(B=0,i[t+16>>2]>3))break A;H0=i[t+44>>2],B=i[t+56>>2]}for(t=n,e=f;_=i[e+16>>2]<4,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);_=0;A:{if((n|0)==(t|0)||(_=0,i[t+16>>2]>4))break A;L0=i[t+44>>2],_=i[t+56>>2]}for(t=n,e=f;W=i[e+16>>2]<5,t=W?t:e,e=i[(W?4:0)+e>>2],!!e;);if((n|0)!=(t|0))break f}e=0;break r}if(e=0,i[t+16>>2]>5)break r;q0=i[t+56>>2]>>>1|0,e=i[t+44>>2]}t=e,W=0;r:{if(!m0)break r;f:{A:{if(!o)break A;for(e=k;y=i[o+16>>2]<6,e=y?e:o,o=i[(y?4:0)+o>>2],!!o;);if((e|0)==(k|0))break A;if(y=0,i[e+16>>2]>6)break f;$0=i[e+44>>2],y=i[e+56>>2];break f}y=0}if(W=0,!f)break r;for(e=n;k=i[f+16>>2]<6,e=k?e:f,f=i[(k?4:0)+f>>2],!!f;);if(W=0,(e|0)==(n|0)||(W=0,i[e+16>>2]>6))break r;P0=i[e+56>>2],W=i[e+44>>2]}if(k=W,W=h0<<3,n=h0>>>0<4,f=(n?16908801>>>W|0:0)&3,i[s+116>>2]=-1086926434,i[s+120>>2]=1071829221,i[s+108>>2]=1068725436,i[s+112>>2]=-1095748968,u[s+104|0]=1,o=2,A0=1,S4(i[r>>2])&&(r=i[r>>2],e=F[r+6>>1]|F[r+8>>1]<<16,o=F[r+10>>1]|F[r+12>>1]<<16,r=o,le(s+80|0,r&65535,e&65535),i[s+120>>2]=i[s+96>>2],e=i[s+92>>2],i[s+112>>2]=i[s+88>>2],i[s+116>>2]=e,e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,A0=(r&65536)>>>16|0),V)for(d0=_>>>1|0,n2=B>>>1|0,Z2=g>>>1|0,g2=V0>>>1|0,R=f-1|0,Q2=((n?16843265>>>W|0:0)&3)-1|0,W0=M(16<<m-8),h0=I&-2,W=I&1,Q0=1<<m-1&65535,e=-1<<m^-1,$=e&65535,a=1<<a-1,f0=I<<(f0>>>0>8),V0=o&65535,f=0;;){r:{if(!I)break r;N=(G(f,q0)<<1)+t|0,D=(G(f,d0)<<1)+L0|0,x=(G(f,n2)<<1)+H0|0,S=(G(f,g2)<<1)+r0|0,r=f>>>Q2|0,O=(G(r,U0)<<1)+D0|0,L=(G(r,Z2)<<1)+N0|0,r=0,E2=E0[s+120>>2],H2=E0[s+116>>2],T2=E0[s+112>>2],b2=E0[s+108>>2];f:switch(V0|0){case 0:if(A0){if(g=0,(I|0)!=1)for(;o=r<<1,n=r>>>R<<1,Q[o+x>>1]=F[n+O>>1],Q[o+D>>1]=F[o+S>>1],Q[o+N>>1]=F[n+L>>1],n=r|1,o=n<<1,n=n>>>R<<1,Q[o+x>>1]=F[n+O>>1],Q[o+D>>1]=F[o+S>>1],Q[o+N>>1]=F[n+L>>1],r=r+2|0,g=g+2|0,(h0|0)!=(g|0););if(!W)break r;n=r<<1,r=r>>>R<<1,Q[n+x>>1]=F[r+O>>1],Q[n+D>>1]=F[n+S>>1],Q[n+N>>1]=F[r+L>>1];break r}for(;B=r<<1,o=B+x|0,_=r>>>R<<1,h=M(M(M(M(F[_+O>>1])-W0)*M(1.142899990081787))+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+D|0,h=M(M(M(M(F[B+S>>1])-W0)*M(1.1689000129699707))+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+N|0,h=M(M(M(M(F[_+L>>1])-W0)*M(1.142899990081787))+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,r=r+1|0,(I|0)!=(r|0););break r;case 8:for(;m=r<<1,_=F[m+S>>1],n=r>>>R<<1,o=F[n+L>>1]-Q0|0,g=_-o|0,n=F[n+O>>1]-Q0|0,B=n+g|0,Q[m+x>>1]=(B|0)>=0?B>>>0>=255?255:B:0,o=o+_|0,Q[m+D>>1]=(o|0)>=0?o>>>0>=255?255:o:0,n=g-n|0,Q[m+N>>1]=(n|0)>=0?n>>>0>=255?255:n:0,r=r+1|0,(I|0)!=(r|0););break r;case 16:for(;m=r<<1,n=r>>>R<<1,B=F[n+L>>1]-a|0,_=F[m+S>>1]-(B<<16>>16>>1)|0,n=F[n+O>>1]-a|0,g=_-(n<<16>>16>>1)|0,o=n+g<<16>>16,n=o<<2,Q[m+x>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,o=B+_<<16>>16,n=o<<2,Q[m+D>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,o=g<<16>>16,n=o<<2,Q[m+N>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,r=r+1|0,(I|0)!=(r|0););break r;default:break f}for(;n=r>>>R<<1,_=F[n+L>>1],B=r<<1,o=B+x|0,h=M(F[n+O>>1]-Q0|0),n0=A0?h:M(h*M(1.142899990081787)),h=M(F[B+S>>1]),e0=A0?h:M(M(h-W0)*M(1.1689000129699707)),h=M(M(M(b2*n0)+e0)+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+D|0,e1=M(H2*n0),h=M(_-Q0|0),n0=A0?h:M(h*M(1.142899990081787)),h=M(M(e1+M(M(T2*n0)+e0))+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+N|0,h=M(M(M(E2*n0)+e0)+M(.5)),M(w2(h))<M(2147483648)?n=~~h:n=-2147483648,Q[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,r=r+1|0,(I|0)!=(r|0););}if(!m0|!f0||z(G(f,P0)+k|0,G(f,y)+$0|0,f0),f=f+1|0,(V|0)==(f|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=C;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+128|0}function kB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0;s=v-128|0,v=s,h=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),f0=u1(i[r>>2],6),f0&&(H0=j0(i[r>>2],6));i:{if(!(!(h>>>0<9|t>>>0<9)&n>>>0>8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((t|0)==(h|0)&(n|0)==(h|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],V=i[e+112>>2],_=i[e+108>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],N=w+12|0,i[w+96>>2]=N,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[N+120>>2]=3,i[N+116>>2]=0,i[N+112>>2]=V,i[N+108>>2]=_,T0(s+56|0,N,0,_,V,h,o),T0(s+32|0,N,1,_,V,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,N,2,_,V,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!f0)break r;if(T0(s+104|0,N,6,_,V,H0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0,o=0;r:{f:{t=i[e+128>>2];A:{if(!t)break A;for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(f|0)||(r=0,i[e+16>>2]>0))break k;L0=i[e+44>>2],r=i[e+56>>2]}for(q0=r,e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);B=0;k:{if((e|0)==(f|0)||(B=0,i[e+16>>2]>1))break k;g=i[e+56>>2],B=i[e+44>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}W=0;break r}if(W=0,i[e+16>>2]>2)break r;D=i[e+56>>2]>>>1|0,W=i[e+44>>2]}r:{f:{if(e=i[k>>2],e){for(n=k,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);r=0;A:{if((k|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;$0=i[n+44>>2],r=i[n+56>>2]}for(P0=r,n=k,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;A:{if((k|0)==(n|0)||(o=0,i[n+16>>2]>1))break A;y=i[n+56>>2],o=i[n+44>>2]}for(n=k,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}h=0;break r}if(h=0,i[n+16>>2]>2)break r;x=i[n+56>>2]>>>1|0,h=i[n+44>>2]}n=0;r:{if(!f0)break r;f:{A:{if(!t)break A;for(r=f;n=i[t+16>>2]<6,r=n?r:t,t=i[(n?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;d0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(n2=f,n=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(n=0,(r|0)==(k|0)||(n=0,i[r+16>>2]>6))break r;Z2=i[r+56>>2],n=i[r+44>>2]}if(e=n,Q[o>>1]=F[B>>1],Q[h>>1]=F[W>>1],L=_-1|0,a=L>>>1|0,L>>>0>=2)for(I=a>>>0<=1?1:a,r=0;n=r<<2,m=n|2,C=r&-2,t=C+2|0,k=t+B|0,f=B+C|0,Q[m+o>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,n=n+4|0,Q[n+o>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,k=t+W|0,f=W+C|0,Q[h+m>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,Q[n+h>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,r=r+1|0,(I|0)!=(r|0););if($=_&1,$||(f=L<<1,r=_-2|0,Q[f+o>>1]=F[r+B>>1],Q[f+h>>1]=F[r+W>>1]),S=y>>>1|0,O=g>>>1|0,R=V-1|0,g=R>>>1|0,R>>>0>=2)for(I=g>>>0<=1?1:g,r=0;n=r<<1,m=n|1,y=r>>>1|0,t=y+1|0,k=(G(t,O)<<1)+B|0,f=(G(y,O)<<1)+B|0,Q[(G(m,S)<<1)+o>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,n=n+2|0,Q[(G(n,S)<<1)+o>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,k=(G(t,D)<<1)+W|0,f=(G(y,D)<<1)+W|0,Q[h+(G(x,m)<<1)>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,Q[h+(G(n,x)<<1)>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,r=r+1|0,(I|0)!=(r|0););if(y=V&1,y||(r=(V>>>1|0)-1|0,Q[(G(R,S)<<1)+o>>1]=F[(G(r,O)<<1)+B>>1],Q[h+(G(x,R)<<1)>>1]=F[(G(r,D)<<1)+W>>1]),!(R>>>0<2|$))for(A0=(_+W|0)-2|0,n0=(_+B|0)-2|0,r=_<<1,h0=(r+h|0)-2|0,C=(r+o|0)-2|0,I=g>>>0<=1?1:g,r=0;n=r<<1,m=n|1,g=r>>>1|0,t=g+1|0,k=n0+(G(t,O)<<1)|0,f=n0+(G(g,O)<<1)|0,Q[C+(G(m,S)<<1)>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,n=n+2|0,Q[C+(G(n,S)<<1)>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,k=A0+(G(t,D)<<1)|0,f=A0+(G(g,D)<<1)|0,Q[h0+(G(x,m)<<1)>>1]=(F[k>>1]+G(F[f>>1],3)|0)+2>>>2,Q[h0+(G(n,x)<<1)>>1]=(F[f>>1]+G(F[k>>1],3)|0)+2>>>2,r=r+1|0,(I|0)!=(r|0););r:{if(y)break r;if(L>>>0>=2)for(g=a>>>0<=1?1:a,y=h+(G(x,R)<<1)|0,I=(G(R,S)<<1)+o|0,r=(V>>>1|0)-1|0,m=(G(r,D)<<1)+W|0,t=(G(r,O)<<1)+B|0,r=0;n=r<<2,f=n+I|0,k=r&-2,C=k+t|0,Q[f+2>>1]=(F[C+2>>1]+G(F[C>>1],3)|0)+2>>>2,Q[f+4>>1]=(F[C>>1]+G(F[C+2>>1],3)|0)+2>>>2,f=n+y|0,k=k+m|0,Q[f+2>>1]=(F[k+2>>1]+G(F[k>>1],3)|0)+2>>>2,Q[f+4>>1]=(F[k>>1]+G(F[k+2>>1],3)|0)+2>>>2,r=r+1|0,(g|0)!=(r|0););if($)break r;f=_<<1,r=(V>>>1|0)-1|0,Q[(f+((G(R,S)<<1)+o|0)|0)-2>>1]=F[(((G(r,O)<<1)+B|0)+_|0)-2>>1],Q[(f+(h+(G(x,R)<<1)|0)|0)-2>>1]=F[(((G(r,D)<<1)+W|0)+_|0)-2>>1]}r:{if(R>>>0>=2){if(L>>>0>=2)for(t=1;;){for(a=h+(G(t,x)<<1)|0,$=(G(t,S)<<1)+o|0,r=t+1|0,A0=h+(G(r,x)<<1)|0,n0=(G(r,S)<<1)+o|0,r=t>>>1|0,h0=(G(r,D)<<1)+W|0,C=(G(r,O)<<1)+B|0,r=r+1|0,g=(G(r,D)<<1)+W|0,y=(G(r,O)<<1)+B|0,r=1;n=r&-2,f=n+g|0,W0=F[f+2>>1],Q0=F[f>>1],f=n+h0|0,V0=F[f>>1],e0=F[f+2>>1],f=n+y|0,r0=F[f>>1],m0=r<<1,k=m0+$|0,N0=F[f+2>>1],I=G(N0,3),f=n+C|0,U0=F[f>>1],m=G(U0,3)+8|0,D0=F[f+2>>1],Q[k+2>>1]=I+(r0+(m+G(D0,9)|0)|0)>>>4,f=k,k=G(r0,3),n=G(D0,3)+8|0,Q[f>>1]=N0+(k+(n+G(U0,9)|0)|0)>>>4,f=n0+m0|0,Q[f+2>>1]=(k+(n+U0|0)|0)+G(N0,9)>>>4,Q[f>>1]=((m+D0|0)+G(r0,9)|0)+I>>>4,f=a+m0|0,m=G(W0,3),I=G(V0,3)+8|0,Q[f+2>>1]=m+(Q0+(I+G(e0,9)|0)|0)>>>4,k=G(Q0,3),n=G(e0,3)+8|0,Q[f>>1]=W0+(k+(n+G(V0,9)|0)|0)>>>4,f=A0+m0|0,Q[f+2>>1]=(k+(n+V0|0)|0)+G(W0,9)>>>4,Q[f>>1]=m+((I+e0|0)+G(Q0,9)|0)>>>4,r=r+2|0,L>>>0>r>>>0;);if(t=t+2|0,!(R>>>0>t>>>0))break}if(!V)break r}for(k=P0>>>1|0,f=q0>>>1|0,t=_<<1,n=H0>>>0>8?t:_,r=0;t&&z((G(r,k)<<1)+$0|0,(G(r,f)<<1)+L0|0,t),!f0|!n||z(G(r,Z2)+e|0,G(r,n2)+d0|0,n),r=r+1|0,(V|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=N;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+128|0}function S7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;i:{e:{r:for(;;){I=e-4|0,C=e-20|0,W=e-24|0,V=e-12|0,g=e-16|0,B=e-8|0;f:for(;;){y=f&1;A:{for(;;){k:{n:{t:{u:{o:{l:switch(k=A,t=e-k>>3,t|0){case 0:case 1:break A;case 2:break l;case 3:break o;case 4:break n;case 5:break u;default:break t}if(i[e-4>>2]<=i[k+4>>2])break A;n=i[k>>2],_=i[k+4>>2],A=e-8|0,e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(A=e-8|0,f=e-4|0,r=i[f>>2],e=i[k+12>>2],(e|0)<=i[k+4>>2]){if((e|0)>=(r|0)||(f=i[k+8>>2],r=i[k+12>>2],e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,i[k+12>>2]<=i[k+4>>2]))break A;n=i[k+8>>2],_=i[k+12>>2];break i}if(n=i[k>>2],_=i[k+4>>2],(e|0)<(r|0)){e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(r=i[k+8>>2],e=i[k+12>>2],i[k+8>>2]=n,i[k+12>>2]=_,i[k>>2]=r,i[k+4>>2]=e,(_|0)>=i[f>>2])break A;e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e;break e}if(Er(k,k+8|0,k+16|0,k+24|0),i[e-4>>2]<=i[k+28>>2]||(f=i[k+24>>2],r=i[k+28>>2],e=e-8|0,A=i[e+4>>2],i[k+24>>2]=i[e>>2],i[k+28>>2]=A,i[e>>2]=f,i[e+4>>2]=r,i[k+28>>2]<=i[k+20>>2])||(n=i[k+24>>2],_=i[k+28>>2],A=i[k+20>>2],i[k+24>>2]=i[k+16>>2],i[k+28>>2]=A,i[k+16>>2]=n,i[k+20>>2]=_,(_|0)<=i[k+12>>2])||(A=i[k+12>>2],i[k+16>>2]=i[k+8>>2],i[k+20>>2]=A,i[k+8>>2]=n,i[k+12>>2]=_,(_|0)<=i[k+4>>2]))break A;break i}if((t|0)<=23){if(A=k+8|0,r=(e|0)==(k|0)|(e|0)==(A|0),f&1){if(r)break A;for(s=k;;){if(r=A,i[s+12>>2]>i[s+4>>2]){for(n=i[A>>2],f=i[A+4>>2],t=A;;){t:{if(A=s,w=i[A+4>>2],i[t>>2]=i[A>>2],i[t+4>>2]=w,(A|0)==(k|0)){A=k;break t}if(s=A-8|0,t=A,(f|0)>i[A-4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(s=r,A=s+8|0,(e|0)==(A|0))break}break A}if(r)break A;for(;;){if(i[k+12>>2]>i[k+4>>2]){for(f=i[A>>2],r=i[A+4>>2],s=A;n=s,s=k,t=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=t,k=k-8|0,(r|0)>i[s-4>>2];);i[s>>2]=f,i[s+4>>2]=r}if(k=A,A=k+8|0,(e|0)==(A|0))break}break A}if(!r){if((e|0)==(k|0))break A;for(h=t-2>>>1|0,A=h;;){_=A;t:{if(A>>>0>h>>>0||(w=(A<<3)+k|0,r=A<<1,s=r|1,A=(s<<3)+k|0,r=r+2|0,(r|0)<(t|0)&&(f=r,r=i[A+4>>2]>i[A+12>>2],s=r?f:s,A=(r?8:0)+A|0),i[A+4>>2]>i[w+4>>2]))break t;for(f=i[w>>2],r=i[w+4>>2];;){u:{if(n=w,w=A,m=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=m,(s|0)>(h|0))break u;if(n=s<<1,s=n|1,A=(s<<3)+k|0,n=n+2|0,(n|0)<(t|0)&&(m=n,n=i[A+4>>2]>i[A+12>>2],s=n?m:s,A=(n?8:0)+A|0),(r|0)>=i[A+4>>2])continue}break}i[w>>2]=f,i[w+4>>2]=r}if(A=_-1|0,!((_|0)>0))break}for(;;){for(w=t,_=t-2>>>1|0,f=i[k>>2],m=i[k+4>>2],s=0,t=k;;){n=s<<1,r=n|1,h=(s<<3)+t|0,A=h+8|0,n=n+2|0;t:{if((n|0)>=(w|0)){s=r;break t}s=r,r=i[h+12>>2]>i[h+20>>2],s=r?n:s,A=r?h+16|0:A}if(r=i[A+4>>2],i[t>>2]=i[A>>2],i[t+4>>2]=r,t=A,!((s|0)<=(_|0)))break}e=e-8|0;t:{if((A|0)==(e|0)){i[A>>2]=f,i[A+4>>2]=m;break t}if(r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[e>>2]=f,i[e+4>>2]=m,r=(A-k|0)+8>>3,(r|0)<2||(s=r-2>>>1|0,t=(s<<3)+k|0,i[t+4>>2]<=i[A+4>>2]))break t;for(n=i[A>>2],f=i[A+4>>2];;){u:{if(r=A,A=t,t=i[A+4>>2],i[r>>2]=i[A>>2],i[r+4>>2]=t,!s)break u;if(s=s-1>>>1|0,t=(s<<3)+k|0,(f|0)<i[t+4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(t=w-1|0,!((w|0)>2))break}break A}o=(t<<2&-8)+k|0,w=i[I>>2];t:{if(t>>>0>=129){n=i[o+4>>2];u:{if((n|0)<=i[k+4>>2]){if((n|0)>=(w|0)||(t=i[o>>2],n=i[o+4>>2],A=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=A,i[B>>2]=t,i[B+4>>2]=n,i[o+4>>2]<=i[k+4>>2]))break u;t=i[k>>2],n=i[k+4>>2],A=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=A,i[o>>2]=t,i[o+4>>2]=n;break u}A=i[k>>2],t=i[k+4>>2];o:{if((n|0)<(w|0)){n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n;break o}if(n=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=n,i[o>>2]=A,i[o+4>>2]=t,(t|0)>=i[I>>2])break u;n=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=n}i[B>>2]=A,i[B+4>>2]=t}h=o-8|0,t=i[V>>2],w=o-4|0,n=i[w>>2];u:{if((n|0)<=i[k+12>>2]){if((n|0)>=(t|0)||(t=i[h>>2],n=i[h+4>>2],A=i[g+4>>2],i[h>>2]=i[g>>2],i[h+4>>2]=A,i[g>>2]=t,i[g+4>>2]=n,i[w>>2]<=i[k+12>>2]))break u;t=i[k+8>>2],n=i[k+12>>2],A=i[h+4>>2],i[k+8>>2]=i[h>>2],i[k+12>>2]=A,i[h>>2]=t,i[h+4>>2]=n;break u}A=i[k+8>>2],s=i[k+12>>2];o:{if((n|0)<(t|0)){n=i[g+4>>2],i[k+8>>2]=i[g>>2],i[k+12>>2]=n;break o}if(n=i[h+4>>2],i[k+8>>2]=i[h>>2],i[k+12>>2]=n,i[h>>2]=A,i[h+4>>2]=s,(s|0)>=i[V>>2])break u;n=i[g+4>>2],i[h>>2]=i[g>>2],i[h+4>>2]=n}i[g>>2]=A,i[g+4>>2]=s}t=i[C>>2],n=i[o+12>>2];u:{if((n|0)<=i[k+20>>2]){if((n|0)>=(t|0)||(t=i[o+8>>2],n=i[o+12>>2],A=i[W+4>>2],i[o+8>>2]=i[W>>2],i[o+12>>2]=A,i[W>>2]=t,i[W+4>>2]=n,i[o+12>>2]<=i[k+20>>2]))break u;t=i[k+16>>2],n=i[k+20>>2],A=i[o+12>>2],i[k+16>>2]=i[o+8>>2],i[k+20>>2]=A,i[o+8>>2]=t,i[o+12>>2]=n;break u}A=i[k+16>>2],s=i[k+20>>2];o:{if((n|0)<(t|0)){n=i[W+4>>2],i[k+16>>2]=i[W>>2],i[k+20>>2]=n;break o}if(n=i[o+12>>2],i[k+16>>2]=i[o+8>>2],i[k+20>>2]=n,i[o+8>>2]=A,i[o+12>>2]=s,(s|0)>=i[C>>2])break u;n=i[W+4>>2],i[o+8>>2]=i[W>>2],i[o+12>>2]=n}i[W>>2]=A,i[W+4>>2]=s}m=i[o+12>>2],s=i[o+4>>2],w=i[w>>2];u:{o:{if((s|0)<=(w|0)){if(n=i[o>>2],_=i[o+4>>2],(s|0)>=(m|0))break u;if(A=i[o+8>>2],t=i[o+12>>2],i[o+8>>2]=n,i[o+12>>2]=_,i[o>>2]=A,i[o+4>>2]=t,(t|0)<=(w|0)){n=A,_=t;break u}n=i[h>>2],_=i[h+4>>2],i[h>>2]=A,i[h+4>>2]=t;break o}if(A=i[h>>2],t=i[h+4>>2],(s|0)<(m|0)){n=i[o+12>>2],i[h>>2]=i[o+8>>2],i[h+4>>2]=n,i[o+8>>2]=A,i[o+12>>2]=t,n=i[o>>2],_=i[o+4>>2];break u}if(n=i[o+4>>2],i[h>>2]=i[o>>2],i[h+4>>2]=n,i[o>>2]=A,i[o+4>>2]=t,(t|0)>=(m|0)){n=A,_=t;break u}n=i[o+8>>2],_=i[o+12>>2],i[o+8>>2]=A,i[o+12>>2]=t}i[o>>2]=n,i[o+4>>2]=_}t=i[k>>2],A=i[k+4>>2],i[k>>2]=n,i[k+4>>2]=_,i[o>>2]=t,i[o+4>>2]=A;break t}if(n=i[k+4>>2],(n|0)<=i[o+4>>2]){if((n|0)>=(w|0)||(t=i[k>>2],n=i[k+4>>2],A=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=A,i[B>>2]=t,i[B+4>>2]=n,i[k+4>>2]<=i[o+4>>2]))break t;t=i[o>>2],n=i[o+4>>2],A=i[k+4>>2],i[o>>2]=i[k>>2],i[o+4>>2]=A,i[k>>2]=t,i[k+4>>2]=n;break t}A=i[o>>2],t=i[o+4>>2];u:{if((n|0)<(w|0)){n=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=n;break u}if(n=i[k+4>>2],i[o>>2]=i[k>>2],i[o+4>>2]=n,i[k>>2]=A,i[k+4>>2]=t,(t|0)>=i[I>>2])break t;n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n}i[B>>2]=A,i[B+4>>2]=t}if(r=r-1|0,y){n=i[k>>2],_=i[k+4>>2];break k}if(n=i[k>>2],A=i[k+4>>2],_=A,i[k-4>>2]>i[k+4>>2])break k;t=k,w=k,s=A;t:{if((A|0)>i[I>>2]){for(;;)if(f=t,A=t+8|0,t=A,!((s|0)<=i[f+12>>2]))break t}for(;;){if(A=w+8|0,e>>>0<=A>>>0)break t;if(f=w,w=A,!((s|0)<=i[f+12>>2]))break}}if(w=e,w>>>0>A>>>0)for(;f=w-4|0,w=w-8|0,(s|0)>i[f>>2];);if(A>>>0<w>>>0)for(;;){for(m=i[A>>2],t=i[A+4>>2],f=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=f,i[w>>2]=m,i[w+4>>2]=t;t=A,f=A+8|0,A=f,(s|0)<=i[t+12>>2];);for(A=w;t=A-4|0,w=A-8|0,A=w,(s|0)>i[t>>2];);if(A=f,!(w>>>0>A>>>0))break}t=A-8|0,(t|0)!=(k|0)&&(f=i[t+4>>2],i[k>>2]=i[t>>2],i[k+4>>2]=f),i[t>>2]=n,i[t+4>>2]=_,f=0;continue f}Er(k,k+8|0,k+16|0,e-8|0);break A}for(t=k;s=t,t=t+8|0,i[s+12>>2]>(_|0););w=e,A=w;k:{if((k|0)==(s|0))for(;;){if(t>>>0>=w>>>0){m=w;break k}if(A=w-4|0,m=w-8|0,w=m,!(i[A>>2]<=(_|0)))break k}for(;w=A-4|0,m=A-8|0,A=m,i[w>>2]<=(_|0););}if(A=m,w=t,A>>>0>t>>>0)for(;;){for(o=i[w>>2],h=i[w+4>>2],s=i[A+4>>2],i[w>>2]=i[A>>2],i[w+4>>2]=s,i[A>>2]=o,i[A+4>>2]=h;s=w,w=s+8|0,i[s+12>>2]>(_|0););for(;h=A-4|0,A=A-8|0,i[h>>2]<=(_|0););if(!(A>>>0>w>>>0))break}if((k|0)!=(s|0)&&(A=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=A),i[s>>2]=n,i[s+4>>2]=_,t>>>0>=m>>>0){if(n=Y9(k,s),A=s+8|0,Y9(A,e)){if(e=s,A=k,!n)continue r;break A}if(n)continue}break}S7(k,s,r,y),A=s+8|0,f=0;continue}break}break}return}i[A>>2]=n,i[A+4>>2]=_;return}A=i[k+4>>2],i[k+8>>2]=i[k>>2],i[k+12>>2]=A,i[k>>2]=n,i[k+4>>2]=_}function nB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0;for(n=v-240|0,v=n,W0=e+100|0,B=A+8|0,V=i[18063],R=V-12|0,N=i[18064]-12|0,D=i[18067]-12|0,y=i[18065],x=y-12|0,S=n+48|0,O=n+60|0,g=n+40|0,I=n+36|0,L=n+92|0,a=i[18072],$=i[18071],f0=i[18069],A0=i[18068],n0=i[18066];;){i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(i[r+16>>2]){if(h0=n+200|0,k=h0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86404,$6(n+176|0,k,r),i[n+176>>2]!=i[26928]){k=i[n+180>>2],i[A>>2]=i[n+176>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+192>>2],k=i[n+188>>2],i[B>>2]=i[n+184>>2],i[B+4>>2]=k,i[n+184>>2]=0,i[n+188>>2]=0,k=0,i[n+192>>2]=0;break e}if(_=i[n+212>>2],k=i[n+208>>2],s=i[n+232>>2],!_&k>>>0<s>>>0){k=E(40),i[n+28>>2]=k,i[n+32>>2]=38,i[n+36>>2]=-2147483608,t=l[26500]|l[26501]<<8|(l[26502]<<16|l[26503]<<24),o=l[26496]|l[26497]<<8|(l[26498]<<16|l[26499]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+38|0]=0,t=l[26530]|l[26531]<<8|(l[26532]<<16|l[26533]<<24),o=l[26526]|l[26527]<<8|(l[26528]<<16|l[26529]<<24),u[k+30|0]=o,u[k+31|0]=o>>>8,u[k+32|0]=o>>>16,u[k+33|0]=o>>>24,u[k+34|0]=t,u[k+35|0]=t>>>8,u[k+36|0]=t>>>16,u[k+37|0]=t>>>24,t=l[26524]|l[26525]<<8|(l[26526]<<16|l[26527]<<24),o=l[26520]|l[26521]<<8|(l[26522]<<16|l[26523]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[26516]|l[26517]<<8|(l[26518]<<16|l[26519]<<24),o=l[26512]|l[26513]<<8|(l[26514]<<16|l[26515]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[26508]|l[26509]<<8|(l[26510]<<16|l[26511]<<24),o=l[26504]|l[26505]<<8|(l[26506]<<16|l[26507]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,K(A,2,0,n+28|0),u[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(t=k-s|0,o=t,w=_-(k>>>0<s>>>0)|0,!(!(t&3)&(!w&t>>>0>=4|(w|0)!=0))){k=E(72),i[n+28>>2]=k,i[n+32>>2]=64,i[n+36>>2]=-2147483576,t=l[25127]|l[25128]<<8|(l[25129]<<16|l[25130]<<24),o=l[25123]|l[25124]<<8|(l[25125]<<16|l[25126]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+64|0]=0,t=l[25183]|l[25184]<<8|(l[25185]<<16|l[25186]<<24),o=l[25179]|l[25180]<<8|(l[25181]<<16|l[25182]<<24),u[k+56|0]=o,u[k+57|0]=o>>>8,u[k+58|0]=o>>>16,u[k+59|0]=o>>>24,u[k+60|0]=t,u[k+61|0]=t>>>8,u[k+62|0]=t>>>16,u[k+63|0]=t>>>24,t=l[25175]|l[25176]<<8|(l[25177]<<16|l[25178]<<24),o=l[25171]|l[25172]<<8|(l[25173]<<16|l[25174]<<24),u[k+48|0]=o,u[k+49|0]=o>>>8,u[k+50|0]=o>>>16,u[k+51|0]=o>>>24,u[k+52|0]=t,u[k+53|0]=t>>>8,u[k+54|0]=t>>>16,u[k+55|0]=t>>>24,t=l[25167]|l[25168]<<8|(l[25169]<<16|l[25170]<<24),o=l[25163]|l[25164]<<8|(l[25165]<<16|l[25166]<<24),u[k+40|0]=o,u[k+41|0]=o>>>8,u[k+42|0]=o>>>16,u[k+43|0]=o>>>24,u[k+44|0]=t,u[k+45|0]=t>>>8,u[k+46|0]=t>>>16,u[k+47|0]=t>>>24,t=l[25159]|l[25160]<<8|(l[25161]<<16|l[25162]<<24),o=l[25155]|l[25156]<<8|(l[25157]<<16|l[25158]<<24),u[k+32|0]=o,u[k+33|0]=o>>>8,u[k+34|0]=o>>>16,u[k+35|0]=o>>>24,u[k+36|0]=t,u[k+37|0]=t>>>8,u[k+38|0]=t>>>16,u[k+39|0]=t>>>24,t=l[25151]|l[25152]<<8|(l[25153]<<16|l[25154]<<24),o=l[25147]|l[25148]<<8|(l[25149]<<16|l[25150]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[25143]|l[25144]<<8|(l[25145]<<16|l[25146]<<24),o=l[25139]|l[25140]<<8|(l[25141]<<16|l[25142]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[25135]|l[25136]<<8|(l[25137]<<16|l[25138]<<24),o=l[25131]|l[25132]<<8|(l[25133]<<16|l[25134]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,K(A,2,0,n+28|0),u[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(t=w,w=t>>>2|0,C=(t&3)<<30|o>>>2,t=i[f+28>>2],o=w,!(!t|!o&t>>>0>=C>>>0)){i[n+120>>2]=0,i[n+28>>2]=y,i[n+92>>2]=72244,i[n+36>>2]=72224,k=n+28|0,i[k+i[x>>2]>>2]=n0,i[n+32>>2]=0,t=k+i[i[n+28>>2]-12>>2]|0,J0(t,g),u[t+80|0]=0,i[t+72>>2]=0,i[i[D>>2]+I>>2]=A0,i[k+i[N>>2]>>2]=f0,i[n+92>>2]=72244,i[n+28>>2]=72204,i[n+36>>2]=72224,s=R0(g),i[s>>2]=71280,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,Y(I0(Y(K2(Y(I,26942,34),C,o),28675,33),i[f+28>>2]),24269,12),k=i[n+88>>2];w:{if(k&16){if(k=O,t=i[n+84>>2],o=i[n+64>>2],t>>>0>=o>>>0)break w;i[n+84>>2]=o,t=o;break w}if(!(k&8)){k=0,u[n+23|0]=0,t=n+12|0;break r}t=i[n+56>>2],k=S}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break s;if(k>>>0>=11){w=k|7,t=E(w+1|0),i[n+20>>2]=w-2147483647,i[n+12>>2]=t,i[n+16>>2]=k;break f}if(u[n+23|0]=k,t=n+12|0,k)break f;k=0;break r}if(i[n+24>>2]=0,w=0,t=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+12>>2]=i[n+216>>2],(k|0)!=(s|0)|_)for(;;){if(!i[r+16>>2]){i[n+120>>2]=0,i[n+28>>2]=y,i[n+92>>2]=72244,i[n+36>>2]=72224,k=n+28|0,i[k+i[x>>2]>>2]=n0,i[n+32>>2]=0,s=k+i[i[n+28>>2]-12>>2]|0,J0(s,g),u[s+80|0]=0,i[s+72>>2]=0,i[i[D>>2]+I>>2]=A0,i[k+i[N>>2]>>2]=f0,i[n+92>>2]=72244,i[n+28>>2]=72204,i[n+36>>2]=72224,s=R0(g),i[s>>2]=71280,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,Y(K2(Y(K2(Y(I,28244,24),C,o),29171,34),w,t),24269,12),k=i[n+88>>2];w:{if(k&16){if(k=O,t=i[n+84>>2],o=i[n+64>>2],t>>>0>=o>>>0)break w;i[n+84>>2]=o,t=o;break w}if(!(k&8)){k=0,u[n+11|0]=0,t=n;break k}t=i[n+56>>2],k=S}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break l;if(k>>>0>=11){w=k|7,t=E(w+1|0),i[n+8>>2]=w-2147483647,i[n>>2]=t,i[n+4>>2]=k;break n}if(u[n+11|0]=k,t=n,k)break n;k=0;break k}W=F0(r),k=i[n+20>>2],h=i[n+24>>2];w:{if(k>>>0<h>>>0){i[k>>2]=W,k=k+4|0;break w}if(_=i[n+16>>2],k=k-_|0,m0=k>>2,s=m0+1|0,s>>>0>=1073741824)break o;if(h=h-_|0,m=h>>1,h=h>>>0>=2147483644?1073741823:s>>>0<m>>>0?m:s,h){if(h>>>0>=1073741824)break u;s=E(h<<2)}else s=0;if(m=s+k|0,i[m>>2]=W,W=m-(m0<<2)|0,k&&z(W,_,k),i[n+24>>2]=s+(h<<2),k=m+4|0,i[n+20>>2]=k,i[n+16>>2]=W,!_)break w;Z(_)}if(i[n+20>>2]=k,w=w+1|0,t=w?t:t+1|0,!((w|0)!=(C|0)|(t|0)!=(o|0)))break}k=i[e+104>>2];w:{if(k>>>0<u0[e+108>>2]){if(t=i[n+12>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=t,t=i[n+20>>2],s=i[n+16>>2],(t|0)!=(s|0)){if(t=t-s|0,(t|0)<0)break t;o=E(t),i[k+8>>2]=o,i[k+4>>2]=o,w=t+o|0,i[k+12>>2]=w,t&&z(o,s,t),i[k+8>>2]=w}k=k+16|0;break w}k=yr(W0,n+12|0)}i[e+104>>2]=k,k=1;break A}if(m9(A,e),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),l[r+20|0]==1){if(u[n+28|0]=0,u[n+39|0]=0,K(A,2,100,n+28|0),u[n+39|0]>=0)break i;Z(i[n+28>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[B>>2]=i[26930],i[B+4>>2]=A,i[B+8>>2]=i[26932];break i}T(B,i[26930],i[26931]);break i}g0(),H()}g0(),H()}G0(),H()}x0(),H()}G0(),H()}if(!k)break k;z(t,o,k)}u[k+t|0]=0,K(A,2,100,n),u[n+11|0]<0&&Z(i[n>>2]),i[n+28>>2]=V,i[i[R>>2]+(n+28|0)>>2]=$,i[n+36>>2]=a,i[s>>2]=71280,u[n+83|0]<0&&Z(i[n+72>>2]),y0(s),p0(L),k=0}if(t=i[n+16>>2],!t)break e;i[n+20>>2]=t,Z(t);break e}if(!k)break r;z(t,o,k)}u[k+t|0]=0,K(A,2,1e3,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),i[n+28>>2]=V,i[i[R>>2]+(n+28|0)>>2]=$,i[n+36>>2]=a,i[s>>2]=71280,u[n+83|0]<0&&Z(i[n+72>>2]),y0(s),p0(L),k=0}if(u[n+195|0]<0&&Z(i[n+184>>2]),i[h0>>2]=86404,t=i[n+220>>2],t&&(i[n+224>>2]=t,Z(t)),k)continue}break}v=n+240|0}function tB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),W0=u1(i[r>>2],6),W0&&(N0=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],N=i[e+112>>2],W=i[e+108>>2],f0=E(172),i[f0>>2]=94860,e=f0,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],I=m+1|0,i[e+4>>2]=I,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],S=e+12|0,i[e+96>>2]=S,i[e+8>>2]=m+1,i[e+100>>2]=e,I||(X[i[i[e>>2]+8>>2]](e),p(e)),i[S+120>>2]=3,i[S+116>>2]=0,i[S+112>>2]=N,i[S+108>>2]=W,T0(s+56|0,S,0,W,N,k,o),T0(s+32|0,S,1,W,N,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,S,2,W,N,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!W0)break r;if(T0(s+104|0,S,6,W,N,N0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0,o=0;r:{f:{t=i[e+128>>2];A:{if(!t){m=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);h0=0;k:{if((e|0)==(k|0)||(h0=0,i[e+16>>2]>0))break k;L0=i[e+44>>2],h0=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>1))break k;O=i[e+56>>2],r=i[e+44>>2]}for(m=r,e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}r=0;break r}if(r=0,i[e+16>>2]>2)break r;L=i[e+56>>2],r=i[e+44>>2]}I=r;r:{f:{if(e=i[f>>2],e){for(n=f,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);m0=0;A:{if((f|0)==(n|0)||(m0=0,i[n+16>>2]>0))break A;q0=i[n+44>>2],m0=i[n+56>>2]}for(n=f,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;A:{if((f|0)==(n|0)||(o=0,i[n+16>>2]>1))break A;a=i[n+56>>2],o=i[n+44>>2]}for(n=f,r=e;C=i[r+16>>2]<2,n=C?n:r,r=i[(C?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;$=i[n+56>>2],r=i[n+44>>2]}C=r,n=0,D=0;r:{if(!W0)break r;f:{A:{if(!t)break A;for(r=k;D=i[t+16>>2]<6,r=D?r:t,t=i[(D?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(Q0=0,i[r+16>>2]>6)break f;$0=i[r+44>>2],Q0=i[r+56>>2];break f}Q0=0}if(D=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(D=0,(r|0)==(f|0)||(D=0,i[r+16>>2]>6))break r;n=i[r+56>>2],D=i[r+44>>2]}if(u[o|0]=l[m|0],u[C|0]=l[I|0],f=W-1|0,k=f>>>1|0,f>>>0>=2)for(t=k>>>0<=1?1:k,r=0;V=r<<1,w=V|1,e=r>>>1|0,y=e+1|0,B=y+m|0,h=e+m|0,u[w+o|0]=(l[B|0]+G(l[h|0],3)|0)+2>>>2,V=V+2|0,u[V+o|0]=(l[h|0]+G(l[B|0],3)|0)+2>>>2,x=w+C|0,w=I+y|0,e=e+I|0,u[x|0]=(l[w|0]+G(l[e|0],3)|0)+2>>>2,u[C+V|0]=(l[e|0]+G(l[w|0],3)|0)+2>>>2,r=r+1|0,(t|0)!=(r|0););if(V=W&1,V||(e=(W>>>1|0)-1|0,u[f+o|0]=l[e+m|0],u[f+C|0]=l[e+I|0]),e=N-1|0,t=e>>>1|0,e>>>0>=2)for(y=t>>>0<=1?1:t,r=0;B=r<<1,h=B|1,w=r>>>1|0,_=w+1|0,g=G(_,O)+m|0,R=G(w,O)+m|0,u[G(h,a)+o|0]=(l[g|0]+G(l[R|0],3)|0)+2>>>2,B=B+2|0,u[G(B,a)+o|0]=(l[R|0]+G(l[g|0],3)|0)+2>>>2,x=C+G(h,$)|0,h=G(_,L)+I|0,w=G(w,L)+I|0,u[x|0]=(l[h|0]+G(l[w|0],3)|0)+2>>>2,u[C+G(B,$)|0]=(l[w|0]+G(l[h|0],3)|0)+2>>>2,r=r+1|0,(y|0)!=(r|0););if(_=N&1,_||(r=(N>>>1|0)-1|0,u[G(e,a)+o|0]=l[G(r,O)+m|0],u[C+G(e,$)|0]=l[G(r,L)+I|0]),!(e>>>0<2|V))for(w=(W+C|0)-1|0,y=(o+W|0)-1|0,g=t>>>0<=1?1:t,r=W>>>1|0,t=(r+I|0)-1|0,B=(r+m|0)-1|0,r=0;R=r<<1,n0=R|1,h=r>>>1|0,V0=h+1|0,e0=B+G(V0,O)|0,r0=B+G(h,O)|0,u[y+G(n0,a)|0]=(l[e0|0]+G(l[r0|0],3)|0)+2>>>2,R=R+2|0,u[y+G(R,a)|0]=(l[r0|0]+G(l[e0|0],3)|0)+2>>>2,x=w+G($,n0)|0,n0=t+G(L,V0)|0,h=t+G(h,L)|0,u[x|0]=(l[n0|0]+G(l[h|0],3)|0)+2>>>2,u[w+G($,R)|0]=(l[h|0]+G(l[n0|0],3)|0)+2>>>2,r=r+1|0,(g|0)!=(r|0););r:{if(_)break r;if(f>>>0>=2)for(t=k>>>0<=1?1:k,w=C+G(e,$)|0,y=G(e,a)+o|0,r=(N>>>1|0)-1|0,B=G(r,L)+I|0,h=G(r,O)+m|0,r=0;_=r<<1,g=_+y|0,R=r>>>1|0,k=R+h|0,u[g+1|0]=(l[k+1|0]+G(l[k|0],3)|0)+2>>>2,u[g+2|0]=(l[k|0]+G(l[k+1|0],3)|0)+2>>>2,_=w+_|0,k=B+R|0,u[_+1|0]=(l[k+1|0]+G(l[k|0],3)|0)+2>>>2,u[_+2|0]=(l[k|0]+G(l[k+1|0],3)|0)+2>>>2,r=r+1|0,(t|0)!=(r|0););if(V)break r;k=W>>>1|0,r=(N>>>1|0)-1|0,u[((G(e,a)+o|0)+W|0)-1|0]=l[(k+(G(r,O)+m|0)|0)-1|0],u[((C+G(e,$)|0)+W|0)-1|0]=l[(k+(G(r,L)+I|0)|0)-1|0]}r:{if(e>>>0>=2){if(f>>>0>=2)for(k=1;;){for(R=C+G(k,$)|0,n0=G(k,a)+o|0,r=k+1|0,V0=C+G(r,$)|0,e0=G(r,a)+o|0,r=k>>>1|0,r0=G(r,L)+I|0,P0=G(r,O)+m|0,r=r+1|0,d0=G(r,L)+I|0,n2=G(r,O)+m|0,r=1;t=r>>>1|0,w=t+d0|0,V=l[w+1|0],w=l[w|0],B=t+r0|0,y=l[B|0],B=l[B+1|0],_=t+n2|0,h=l[_|0],A0=r+n0|0,_=l[_+1|0],U0=G(_,3),g=t+P0|0,t=l[g|0],D0=G(t,3)+8|0,g=l[g+1|0],u[A0+1|0]=U0+(h+(D0+G(g,9)|0)|0)>>>4,x=A0,H0=G(h,3),A0=G(g,3)+8|0,u[x|0]=_+(H0+(A0+G(t,9)|0)|0)>>>4,x=r+e0|0,u[x+1|0]=(H0+(t+A0|0)|0)+G(_,9)>>>4,u[x|0]=((g+D0|0)+G(h,9)|0)+U0>>>4,t=r+R|0,_=G(V,3),h=G(y,3)+8|0,u[t+1|0]=_+(w+(h+G(B,9)|0)|0)>>>4,x=t,g=G(w,3),t=G(B,3)+8|0,u[x|0]=V+(g+(t+G(y,9)|0)|0)>>>4,A0=r+V0|0,u[A0+1|0]=(g+(t+y|0)|0)+G(V,9)>>>4,u[A0|0]=_+((h+B|0)+G(w,9)|0)>>>4,r=r+2|0,f>>>0>r>>>0;);if(k=k+2|0,!(e>>>0>k>>>0))break}if(!N)break r}for(e=W<<(N0>>>0>8),r=0;W&&z(G(r,m0)+q0|0,G(r,h0)+L0|0,W),!W0|!e||z(G(r,n)+D|0,G(r,Q0)+$0|0,e),r=r+1|0,(N|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=f0,i[A>>2]=S;break i}if(A=i[f0+4>>2],i[f0+4>>2]=A-1,A)break i;X[i[i[f0>>2]+8>>2]](f0),p(f0)}v=s+128|0}function uB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;t=v-48|0,v=t,x2(t+28|0,e,r),u[t+47|0]<0&&Z(i[t+36>>2]),f=W2(r),n=f&1,u[e+105|0]=n,u[e+104|0]=f>>>1&3;i:{e:{r:{f:{A:{k:{if(n){if(f=o2(r),u[e+110|0]=f&3,Q[e+106>>1]=f>>>7,u[e+109|0]=f>>>2&3,u[e+108|0]=f>>>4&7,I=e,C=W2(r)>>>5|0,u[I+111|0]=C,f=W2(r)&63,u[e+112|0]=f,!f){if(e=E(56),i[t+12>>2]=e,i[t+16>>2]=54,i[t+20>>2]=-2147483592,r=l[25790]|l[25791]<<8|(l[25792]<<16|l[25793]<<24),f=l[25786]|l[25787]<<8|(l[25788]<<16|l[25789]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[25836]|l[25837]<<8|(l[25838]<<16|l[25839]<<24),f=l[25832]|l[25833]<<8|(l[25834]<<16|l[25835]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[25830]|l[25831]<<8|(l[25832]<<16|l[25833]<<24),f=l[25826]|l[25827]<<8|(l[25828]<<16|l[25829]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[25822]|l[25823]<<8|(l[25824]<<16|l[25825]<<24),f=l[25818]|l[25819]<<8|(l[25820]<<16|l[25821]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25814]|l[25815]<<8|(l[25816]<<16|l[25817]<<24),f=l[25810]|l[25811]<<8|(l[25812]<<16|l[25813]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25806]|l[25807]<<8|(l[25808]<<16|l[25809]<<24),f=l[25802]|l[25803]<<8|(l[25804]<<16|l[25805]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25798]|l[25799]<<8|(l[25800]<<16|l[25801]<<24),f=l[25794]|l[25795]<<8|(l[25796]<<16|l[25797]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,2006,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}if(f=W2(r),u[e+114|0]=f&1,u[e+113|0]=f>>>1,I=e,C=W2(r),u[I+115|0]=C,!l[e+112|0])break A;f=W2(r),u[e+116|0]=f>>>7,u[e+117|0]=f>>>6&1,w=f&63,n=i[e+124>>2],s=i[e+128>>2];n:{if(n>>>0>=s>>>0){if(f=0,k=i[e+120>>2],n=n-k|0,o=n+1|0,(o|0)<0)break k;if(s=s-k|0,h=s<<1,o=s>>>0>=1073741823?2147483647:o>>>0<h>>>0?h:o,o&&(f=E(o)),s=f+n|0,u[s|0]=w,n&&z(f,k,n),i[e+128>>2]=f+o,n=s+1|0,i[e+124>>2]=n,i[e+120>>2]=f,!k)break n;Z(k);break n}u[n|0]=w,n=n+1|0}if(i[e+124>>2]=n,n=1,l[e+112|0]<=1)break A;for(;;){o=W2(r),f=i[e+124>>2],s=i[e+128>>2];n:{if(f>>>0<s>>>0){u[f|0]=o,o=f+1|0;break n}if(w=i[e+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break k;if(s=s-w|0,h=s<<1,s=s>>>0>=1073741823?2147483647:k>>>0<h>>>0?h:k,s?k=E(s):k=0,h=k+f|0,u[h|0]=o,f&&z(k,w,f),i[e+128>>2]=k+s,o=h+1|0,i[e+124>>2]=o,i[e+120>>2]=k,!w)break n;Z(w)}if(i[e+124>>2]=o,n=n+1|0,!(n>>>0<l[e+112|0]))break}break A}if(e=E(72),i[t+12>>2]=e,i[t+16>>2]=68,i[t+20>>2]=-2147483576,z(e,25841,68),u[e+68|0]=0,K(A,4,0,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}G0(),H()}w=l[e+108|0];A:{if(w>>>0<=1||(An(e+132|0,w-1|0),s=W2(r),w=l[e+108|0],w>>>0<2))break A;for(f=w-2|0,h=i[e+132>>2],n=128;k=1<<f,o=h+(f>>>3&536870908)|0,n&s?k=k|i[o>>2]:k=i[o>>2]&(k^-1),i[o>>2]=k,n=n>>>1|0,k=(f|0)>0,f=f-1|0,!!k;);}o=i[e+148>>2],f=i[e+144>>2],n=o-f|0;A:{if(n>>>0<w>>>0){if(k=w-n|0,s=i[e+152>>2],k>>>0<=s-o>>>0){k&&o0(o,0,k),i[e+148>>2]=k+o;break A}if(o=s-f|0,s=o<<1,s=o>>>0>=1073741823?2147483647:w>>>0<s>>>0?s:w,o=E(s),k&&o0(n+o|0,0,k),n&&z(o,f,n),i[e+152>>2]=o+s,i[e+148>>2]=w+o,i[e+144>>2]=o,!f)break A;Z(f);break A}if(n>>>0<=w>>>0)break A;i[e+148>>2]=f+w}f=l[e+108|0];A:{if(!f||(u[(f+i[e+144>>2]|0)-1|0]=l[e+115|0],f=l[e+108|0],f>>>0<2))break A;for(f=f-2|0;;){k:{if(i[i[e+132>>2]+(f>>>3&536870908)>>2]>>>f&1){n=W2(r),u[i[e+144>>2]+f|0]=n;break k}n=i[e+144>>2]+f|0,u[n|0]=l[n+1|0]}if(n=(f|0)>0,f=f-1|0,!n)break}}if(_=W2(r),_)for(w=0;;){s=F0(r),f=i[e+160>>2],o=i[e+164>>2];A:{if(f>>>0<o>>>0){i[f>>2]=s,f=f+4|0;break A}if(k=i[e+156>>2],f=f-k|0,B=f>>2,n=B+1|0,n>>>0>=1073741824)break i;if(o=o-k|0,h=o>>1,o=o>>>0>=2147483644?1073741823:n>>>0<h>>>0?h:n,o){if(o>>>0>=1073741824)break r;n=E(o<<2)}else n=0;if(h=n+f|0,i[h>>2]=s,s=h-(B<<2)|0,f&&z(s,k,f),i[e+164>>2]=n+(o<<2),f=h+4|0,i[e+160>>2]=f,i[e+156>>2]=s,!k)break A;Z(k)}if(i[e+160>>2]=f,w=w+1|0,(_|0)==(w|0))break}I=e,C=o2(r),Q[I+168>>1]=C,I=e,C=o2(r),Q[I+170>>1]=C,I=e,C=o2(r),Q[I+172>>1]=C,m=W2(r);A:{if(!m)break A;for(g=e+176|0,B=0;;){if(l[r+20|0])break A;f=W2(r),o=0,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,u[t+13|0]=f&63,u[t+12|0]=f>>>7,W=o2(r);k:{n:{if(!W|u[r+20|0]&1)break n;for(;;){if(f=o2(r),f){w=0,n=0;t:{if(!f4(r,f))break t;n=E(f),f&&o0(n,0,f),w=f+n|0,s=i[r>>2],k=i[r+4>>2];u:{if(!k){if(!(X[i[i[s>>2]+16>>2]](s,n,f)|0))break u;break t}if(i[k+4>>2]=i[k+4>>2]+1,f=X[i[i[s>>2]+16>>2]](s,n,f)|0,s=i[k+4>>2],i[k+4>>2]=s-1,s||(X[i[i[k>>2]+8>>2]](k),p(k)),f)break t}f=E(32),i[t>>2]=f,i[t+4>>2]=28,i[t+8>>2]=-2147483616,k=l[2534]|l[2535]<<8|(l[2536]<<16|l[2537]<<24),w=l[2530]|l[2531]<<8|(l[2532]<<16|l[2533]<<24),u[f|0]=w,u[f+1|0]=w>>>8,u[f+2|0]=w>>>16,u[f+3|0]=w>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+28|0]=0,k=l[2554]|l[2555]<<8|(l[2556]<<16|l[2557]<<24),u[f+24|0]=k,u[f+25|0]=k>>>8,u[f+26|0]=k>>>16,u[f+27|0]=k>>>24,k=l[2550]|l[2551]<<8|(l[2552]<<16|l[2553]<<24),w=l[2546]|l[2547]<<8|(l[2548]<<16|l[2549]<<24),u[f+16|0]=w,u[f+17|0]=w>>>8,u[f+18|0]=w>>>16,u[f+19|0]=w>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[2542]|l[2543]<<8|(l[2544]<<16|l[2545]<<24),w=l[2538]|l[2539]<<8|(l[2540]<<16|l[2541]<<24),u[f+8|0]=w,u[f+9|0]=w>>>8,u[f+10|0]=w>>>16,u[f+11|0]=w>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,K(A,2,100,t),u[t+11|0]<0&&Z(i[t>>2]),Z(n),f=0;break k}f=i[t+20>>2],h=i[t+24>>2];t:{if(f>>>0<h>>>0){i[f+8>>2]=w,i[f+4>>2]=w,i[f>>2]=n,f=f+12|0;break t}if(s=i[t+16>>2],f=f-s|0,k=((f|0)/12|0)+1|0,k>>>0>=357913942)break e;if(h=(h-s|0)/12|0,_=h<<1,_=h>>>0>=178956970?357913941:k>>>0<_>>>0?_:k,_){if(_>>>0>=357913942)break r;k=E(G(_,12))}else k=0;if(h=k+f|0,i[h+8>>2]=w,i[h+4>>2]=w,i[h>>2]=n,n=h+G((f|0)/-12|0,12)|0,f&&z(n,s,f),i[t+24>>2]=k+G(_,12),f=h+12|0,i[t+20>>2]=f,i[t+16>>2]=n,!s)break t;Z(s)}i[t+20>>2]=f}if(o=o+1|0,W>>>0<=o>>>0)break n;if(u[r+20|0]&1)break}}f=i[e+180>>2];n:{if(f>>>0<u0[e+184>>2]){n=F[t+12>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,Q[f>>1]=n,i[f+4>>2]=i[t+16>>2],i[f+8>>2]=i[t+20>>2],i[f+12>>2]=i[t+24>>2],i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,f=f+16|0;break n}f=Mn(g,t+12|0)}i[e+180>>2]=f,f=1}if(w=f,k=i[t+16>>2],k){if(f=i[t+20>>2],n=k,(f|0)!=(k|0)){for(;n=f-12|0,o=i[n>>2],o&&(i[f-8>>2]=o,Z(o)),f=n,(k|0)!=(f|0););n=i[t+16>>2]}i[t+20>>2]=k,Z(n)}if(!w)break f;if(B=B+1|0,(m|0)==(B|0))break}}if(l[r+20|0]==1){if(u[t+12|0]=0,u[t+23|0]=0,K(A,2,100,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break f}T(A,i[26930],i[26931])}v=t+48|0;return}x0(),H()}G0(),H()}G0(),H()}function oB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=M(0),_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=M(0),f0=0,A0=0,n0=0,h0=0,m0=0,W0=M(0),Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=M(0);s=v-128|0,v=s,e=i[r>>2],f0=i[e+120>>2],k=j0(e,0),f=j0(i[r>>2],1),e=j0(i[r>>2],2),A0=u1(i[r>>2],6),A0&&(n0=j0(i[r>>2],6));i:{if(!(!((k|0)!=8|(f|0)!=8)&(e|0)==8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],g=i[e+112>>2],B=i[e+108>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,n=w+140|0,i[w+136>>2]=n,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],W=w+12|0,i[w+96>>2]=W,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[W+120>>2]=3,i[W+116>>2]=1,i[W+112>>2]=g,i[W+108>>2]=B,T0(s+56|0,W,3,B,g,k,o),T0(s+32|0,W,4,B,g,k,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,W,5,B,g,k,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!A0)break r;if(T0(s+104|0,W,6,B,g,n0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=k,e=o;t=i[e+16>>2],f=(t|0)<0?f:e,e=i[(t>>>29&4)+e>>2],!!e;);O=0;A:{if((f|0)==(k|0)||(O=0,i[f+16>>2]>0))break A;e0=i[f+44>>2],O=i[f+56>>2]}for(f=k,e=o;t=i[e+16>>2]<=0,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);L=0;A:{if((f|0)==(k|0)||(L=0,i[f+16>>2]>1))break A;r0=i[f+56>>2],L=i[f+44>>2]}for(f=k,e=o;t=i[e+16>>2]<2,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}h0=0;break r}if(h0=0,i[f+16>>2]>2)break r;N0=i[f+56>>2],h0=i[f+44>>2]}r:{f:{if(f=i[n>>2],f){for(t=n,e=f;I=i[e+16>>2]<3,t=I?t:e,e=i[(I?4:0)+e>>2],!!e;);a=0;A:{if((n|0)==(t|0)||(a=0,i[t+16>>2]>3))break A;U0=i[t+44>>2],a=i[t+56>>2]}for(t=n,e=f;I=i[e+16>>2]<4,t=I?t:e,e=i[(I?4:0)+e>>2],!!e;);e=0;A:{if((n|0)==(t|0)||(e=0,i[t+16>>2]>4))break A;D0=i[t+56>>2],e=i[t+44>>2]}for(I=e,t=n,e=f;_=i[e+16>>2]<5,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);if((n|0)!=(t|0))break f}e=0;break r}if(e=0,i[t+16>>2]>5)break r;H0=i[t+56>>2],e=i[t+44>>2]}t=e,m=0;r:{if(!A0)break r;f:{A:{if(!o)break A;for(e=k;m0=i[o+16>>2]<6,e=m0?e:o,o=i[(m0?4:0)+o>>2],!!o;);if((e|0)==(k|0))break A;if(k=0,i[e+16>>2]>6)break f;L0=i[e+44>>2],k=i[e+56>>2];break f}k=0}if(m0=k,m=0,!f)break r;for(e=n;k=i[f+16>>2]<6,e=k?e:f,f=i[(k?4:0)+f>>2],!!f;);if(m=0,(e|0)==(n|0)||(m=0,i[e+16>>2]>6))break r;q0=i[e+56>>2],m=i[e+44>>2]}f=m,_=f0<<3,o=f0>>>0<4,k=(o?16908801>>>_|0:0)&3,i[s+116>>2]=-1086926434,i[s+120>>2]=1071829221,i[s+108>>2]=1068725436,i[s+112>>2]=-1095748968,u[s+104|0]=1;r:{if(!S4(i[r>>2])){r=2,n=1;break r}r=i[r>>2],e=F[r+6>>1]|F[r+8>>1]<<16,r=F[r+10>>1]|F[r+12>>1]<<16,le(s+80|0,r&65535,e&65535),i[s+120>>2]=i[s+96>>2],e=i[s+92>>2],i[s+112>>2]=i[s+88>>2],i[s+116>>2]=e,e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,n=(r&65536)>>>16|0}if(g)for(C=k-1|0,$0=((o?16843265>>>_|0:0)&3)-1|0,m=B&-2,f0=B&1,Q0=B<<(n0>>>0>8),n0=r&65535,r=0;;){r:{if(!B)break r;V=G(r,H0)+t|0,y=G(r,D0)+I|0,R=G(r,a)+U0|0,N=G(r,O)+e0|0,e=r>>>$0|0,D=G(e,N0)+h0|0,x=G(e,r0)+L|0,e=0;f:switch(n0|0){case 0:if(n){if(o=0,(B|0)!=1)for(;k=e>>>C|0,u[e+R|0]=l[k+D|0],u[e+y|0]=l[e+N|0],u[e+V|0]=l[k+x|0],_=e|1,k=_>>>C|0,u[_+R|0]=l[k+D|0],u[_+y|0]=l[_+N|0],u[_+V|0]=l[k+x|0],e=e+2|0,o=o+2|0,(m|0)!=(o|0););if(!f0)break r;k=e>>>C|0,u[e+R|0]=l[k+D|0],u[e+y|0]=l[e+N|0],u[e+V|0]=l[k+x|0];break r}for(;o=e+R|0,_=e>>>C|0,h=M(M(M(M(l[_+D|0])+M(-16))*M(1.142899990081787))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+y|0,h=M(M(M(M(l[e+N|0])+M(-16))*M(1.1689000129699707))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+V|0,h=M(M(M(M(l[_+x|0])+M(-16))*M(1.142899990081787))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;case 8:for(;_=l[e+N|0],k=e>>>C|0,o=l[k+x|0]-128|0,V0=_-o|0,k=l[k+D|0]-128|0,S=V0+k|0,u[e+R|0]=(S|0)>=0?S>>>0>=255?255:S:0,o=o+_|0,u[e+y|0]=(o|0)>=0?o>>>0>=255?255:o:0,k=V0-k|0,u[e+V|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;case 16:for(;k=e>>>C|0,_=l[k+x|0]-128|0,o=l[e+N|0]-(_>>>1|0)|0,k=l[k+D|0]-128|0,S=o-(k>>>1|0)|0,k=k+S<<16>>14,u[e+R|0]=(k|0)>=0?k>>>0>=255?255:k:0,k=o+_<<16>>14,u[e+y|0]=(k|0)>=0?k>>>0>=255?255:k:0,k=S<<16>>14,u[e+V|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;default:break f}for(;k=e>>>C|0,_=l[k+x|0],o=e+R|0,h=M(l[k+D|0]-128|0),$=n?h:M(h*M(1.142899990081787)),h=M(l[e+N|0]),W0=n?h:M(M(h+M(-16))*M(1.1689000129699707)),h=M(M(M(E0[s+108>>2]*$)+W0)+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+y|0,P0=M(E0[s+116>>2]*$),h=M(_-128|0),$=n?h:M(h*M(1.142899990081787)),h=M(M(P0+M(M(E0[s+112>>2]*$)+W0))+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+V|0,h=M(M(M(E0[s+120>>2]*$)+W0)+M(.5)),M(w2(h))<M(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););}if(!A0|!Q0||z(G(r,q0)+f|0,G(r,m0)+L0|0,Q0),r=r+1|0,(g|0)==(r|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=W;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+128|0}function j7(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0;h=v-336|0,v=h,B=o,m=s&65535,W=f,g=k&65535,V=(k^s)&-2147483648,x=s>>>16&32767,R=k>>>16&32767;i:{e:{if(x-32767>>>0>4294934529&R-32767>>>0>=4294934530)break e;if(w=k&2147483647,!(!f&(w|0)==2147418112?!(e|r):w>>>0<2147418112)){C=f,V=k|32768;break i}if(k=s&2147483647,!(!o&(k|0)==2147418112?!(n|t):k>>>0<2147418112)){C=o,V=s|32768,e=n,r=t;break i}if(!(e|f|(w^2147418112|r))){if(!(n|o|(k^2147418112|t))){e=0,r=0,V=2147450880;break i}V=V|2147418112,e=0,r=0;break i}if(!(n|o|(k^2147418112|t))){e=0,r=0;break i}if(!(e|f|(r|w))){e=!(n|o|(k|t)),C=e?0:C,V=e?2147450880:V,e=0,r=0;break i}if(!(n|o|(k|t))){V=V|2147418112,e=0,r=0;break i}if((w|0)==65535|w>>>0<65535&&(f=!(W|g),s=k1(f?r:g),f=((s|0)==32?k1(f?e:W)+32|0:s)+(f?64:0)|0,o4(h+320|0,e,r,W,g,f-15|0),I=16-f|0,W=i[h+328>>2],g=i[h+332>>2],r=i[h+324>>2],e=i[h+320>>2]),k>>>0>65535)break e;f=!(m|B),o=k1(f?t:m),f=((o|0)==32?k1(f?n:B)+32|0:o)+(f?64:0)|0,o4(h+304|0,n,t,B,m,f-15|0),I=(f+I|0)-16|0,B=i[h+312>>2],m=i[h+316>>2],n=i[h+304>>2],t=i[h+308>>2]}k=m|65536,S=k,O=B,f=B,w=k<<15|f>>>17,k=f<<15|t>>>17,f=k,s=0-f|0,o=w,w=1963258675-(w+((f|0)!=0)|0)|0,$1(h+288|0,f,o,0,0,s,w,0,0),f=i[h+296>>2],$1(h+272|0,0-f|0,0-(i[h+300>>2]+((f|0)!=0)|0)|0,0,0,s,w,0,0),f=i[h+280>>2],s=f<<1|i[h+276>>2]>>>31,f=i[h+284>>2]<<1|f>>>31,$1(h+256|0,s,f,0,0,k,o,0,0),w=i[h+264>>2],$1(h+240|0,s,f,0,0,0-w|0,0-(i[h+268>>2]+((w|0)!=0)|0)|0,0,0),s=i[h+248>>2],w=s<<1|i[h+244>>2]>>>31,f=i[h+252>>2]<<1|s>>>31,$1(h+224|0,w,f,0,0,k,o,0,0),s=i[h+232>>2],$1(h+208|0,w,f,0,0,0-s|0,0-(i[h+236>>2]+((s|0)!=0)|0)|0,0,0),f=i[h+216>>2],s=f<<1|i[h+212>>2]>>>31,f=i[h+220>>2]<<1|f>>>31,$1(h+192|0,s,f,0,0,k,o,0,0),w=i[h+200>>2],$1(h+176|0,s,f,0,0,0-w|0,0-(i[h+204>>2]+((w|0)!=0)|0)|0,0,0),s=k,k=i[h+184>>2],f=o,B=k<<1|i[h+180>>2]>>>31,o=B-1|0,k=(i[h+188>>2]<<1|k>>>31)-!B|0,$1(h+160|0,s,f,0,0,o,k,0,0),f=o,$1(h+144|0,n<<15,t<<15|n>>>17,0,0,f,k,0,0),N=h+112|0,L=i[h+168>>2],o=i[h+172>>2],B=i[h+160>>2],s=i[h+152>>2],_=B+s|0,m=i[h+164>>2],w=m+i[h+156>>2]|0,w=s>>>0>_>>>0?w+1|0:w,s=w,w=(m|0)==(w|0)&_>>>0<B>>>0|w>>>0<m>>>0,m=w+L|0,w=w>>>0>m>>>0?o+1|0:o,B=!s&_>>>0>1|(s|0)!=0,o=m+B|0,w=B>>>0>o>>>0?w+1|0:w,$1(N,f,k,0,0,0-o|0,0-(((o|0)!=0)+w|0)|0,0,0),$1(h+128|0,1-_|0,0-((_>>>0>1)+s|0)|0,0,0,f,k,0,0),Q0=(R-x|0)+I|0,k=i[h+116>>2],R=k,f=i[h+112>>2],w=k<<1|f>>>31,s=f<<1,m=w,f=w,o=i[h+140>>2],D=o,k=i[h+136>>2],w=o<<1|k>>>31,_=k<<1|i[h+132>>2]>>>31,o=_+s|0,f=f+w|0,f=o>>>0<_>>>0?f+1|0:f,k=f,f=f-(o>>>0<13927)|0,y=f,N=f,_=0,w=g|65536,V0=w,e0=W,f=W,w=w<<1|f>>>31,N0=f<<1,U0=w,A0=w,f=O0(y,_,w,0),w=l0,a=f,$=w,h0=e<<1,f=r<<1|e>>>31,x=f,L=f,w=0,I=w,B=o-13927|0,y=(k|0)==(y|0)&B>>>0<o>>>0|k>>>0>y>>>0,k=(k|0)==(m|0)&o>>>0<s>>>0|k>>>0<m>>>0,f=i[h+120>>2],o=i[h+124>>2]<<1|f>>>31,f=f<<1|R>>>31,_=D>>>31|0,f=_+f|0,w=o,w=f>>>0<_>>>0?w+1|0:w,o=f,f=f+k|0,w=o>>>0>f>>>0?w+1|0:w,k=f,f=f+y|0,_=k>>>0>f>>>0?w+1|0:w,k=f-1|0,f0=_-!f|0,D=0,s=O0(L,I,f0,D),f=s+a|0,o=l0+$|0,o=f>>>0<s>>>0?o+1|0:o,m=($|0)==(o|0)&f>>>0<a>>>0|o>>>0<$>>>0,a=k,r0=r>>>31|0,n0=r0|W<<1,y=0,k=O0(k,0,n0,y),W=k+f|0,w=l0+o|0,_=0,w=k>>>0>W>>>0?w+1|0:w,g=w,f=(w|0)==(o|0)&f>>>0>W>>>0|o>>>0>w>>>0,k=f,f=f+m|0,_=k>>>0>f>>>0?1:_,k=O0(A0,I,f0,D),f=k+f|0,w=l0+_|0,m=f,f=f>>>0<k>>>0?w+1|0:w,k=O0(A0,I,a,y),_=l0,o=k,k=O0(n0,y,f0,D),s=o+k|0,w=l0+_|0,w=k>>>0>s>>>0?w+1|0:w,k=w,w=(_|0)==(w|0)&o>>>0>s>>>0|w>>>0<_>>>0,_=m+k|0,f=f+w|0,f=_>>>0<k>>>0?f+1|0:f,m=_,_=f,k=0,f=k+W|0,w=s+g|0,w=f>>>0<k>>>0?w+1|0:w,k=w,o=(w|0)==(g|0)&f>>>0<W>>>0|w>>>0<g>>>0,w=_,s=o,o=o+m|0,w=s>>>0>o>>>0?w+1|0:w,R=o,_=w,W=f,$=B,f=O0(B,0,n0,y),s=l0,o=f,B=O0(N,C,L,C),f=f+B|0,w=l0+s|0,w=f>>>0<B>>>0?w+1|0:w,B=(s|0)==(w|0)&f>>>0<o>>>0|s>>>0>w>>>0,o=w,m0=h0&-2,s=O0(a,y,m0,0),g=s+f|0,w=l0+w|0,w=s>>>0>g>>>0?w+1|0:w,s=w,f=(w|0)==(o|0)&f>>>0>g>>>0|o>>>0>w>>>0,o=0,w=f+B|0,f=(w>>>0<f>>>0?1:o)+k|0,m=w+W|0,f=m>>>0<w>>>0?f+1|0:f,w=_,B=f,f=(f|0)==(k|0)&m>>>0<W>>>0|f>>>0<k>>>0,k=f,f=f+R|0,w=k>>>0>f>>>0?w+1|0:w,D0=f,R=w,f=O0(A0,I,$,C),W0=l0,A0=f,k=O0(f0,D,m0,C),f=f+k|0,w=l0+W0|0,w=f>>>0<k>>>0?w+1|0:w,W=f,_=O0(N,C,n0,y),k=f+_|0,o=w,f=w+l0|0,f=k>>>0<_>>>0?f+1|0:f,I=k,w=O0(L,C,a,y),k=k+w|0,_=l0+f|0,_=k>>>0<w>>>0?_+1|0:_,f0=(f|0)==(_|0)&k>>>0<I>>>0|f>>>0>_>>>0,w=(o|0)==(W0|0)&W>>>0<A0>>>0|o>>>0<W0>>>0,f=(f|0)==(o|0)&W>>>0>I>>>0|f>>>0<o>>>0,f=f+w|0,f=f+f0|0,o=_,I=o+m|0,w=(f|D)+B|0,w=o>>>0>I>>>0?w+1|0:w,W=w,f=(B|0)==(w|0)&m>>>0>I>>>0|w>>>0<B>>>0,w=R,o=f,f=f+D0|0,w=o>>>0>f>>>0?w+1|0:w,D=f,B=w,f=O0(N,C,m0,C),N=l0,m=f,o=O0(L,C,$,C),f=f+o|0,w=l0+N|0,w=f>>>0<o>>>0?w+1|0:w,R=0,o=(w|0)==(N|0)&f>>>0<m>>>0|w>>>0<N>>>0,m=w,f=w+g|0,w=(o|R)+s|0,w=f>>>0<m>>>0?w+1|0:w,s=(s|0)==(w|0)&f>>>0<g>>>0|s>>>0>w>>>0,o=w,w=k,g=0,k=g+f|0,_=o+w|0,w=0,_=k>>>0<g>>>0?_+1|0:_,f=(o|0)==(_|0)&f>>>0>k>>>0|o>>>0>_>>>0,k=f,f=f+s|0,w=(k>>>0>f>>>0?1:w)+W|0,_=B,k=f,f=f+I|0,w=k>>>0>f>>>0?w+1|0:w,k=w,o=(W|0)==(w|0)&f>>>0<I>>>0|w>>>0<W>>>0,s=o,o=o+D|0,_=s>>>0>o>>>0?_+1|0:_,s=_;e:{if((_|0)==131071|_>>>0<131071){e0=N0|r0,V0=y|U0,$1(h+80|0,f,w,o,_,n,t,O,S),_=i[h+84>>2],I=_,w=e<<17,W=0,g=i[h+88>>2],r=W-g|0,e=i[h+80>>2],_=(_|e)!=0,B=r-_|0,m=(w-(i[h+92>>2]+(W>>>0<g>>>0)|0)|0)-(r>>>0<_>>>0)|0,g=0-(((e|0)!=0)+I|0)|0,I=Q0+16382|0,W=0-e|0;break e}f=(k&1)<<31|f>>>1,k=o<<31|k>>>1,o=(s&1)<<31|o>>>1,s=s>>>1|0,$1(h+96|0,f,k,o,s,n,t,O,S),B=i[h+100>>2],x=B,m=0,I=i[h+104>>2],W=m-I|0,_=i[h+96>>2],g=(B|_)!=0,B=W-g|0,m=((e<<16)-(i[h+108>>2]+(m>>>0<I>>>0)|0)|0)-(W>>>0<g>>>0)|0,g=0-(((_|0)!=0)+x|0)|0,h0=e,x=r,I=Q0+16383|0,W=0-_|0}if((I|0)>=32767){V=V|2147418112,e=0,r=0;break i}e:{if((I|0)>0){e=B<<1|g>>>31,r=m<<1|B>>>31,B=o,m=s&65535|I<<16,_=g<<1|W>>>31,o=W<<1;break e}if((I|0)<=-113){e=0,r=0;break i}Y6(h- -64|0,f,k,o,s,1-I|0),o4(h+48|0,h0,x,e0,V0,I+112|0),f=i[h+64>>2],k=i[h+68>>2],B=i[h+72>>2],m=i[h+76>>2],$1(h+32|0,n,t,O,S,f,k,B,m),e=i[h+40>>2],r=i[h+56>>2],s=i[h+36>>2],g=e<<1|s>>>31,_=r-g|0,g=i[h+60>>2]-((i[h+44>>2]<<1|e>>>31)+(r>>>0<g>>>0)|0)|0,r=i[h+52>>2],I=r,e=i[h+32>>2],o=s<<1|e>>>31,W=e<<1,e=W,w=i[h+48>>2],r=(r|0)==(o|0)&e>>>0>w>>>0|r>>>0<o>>>0,e=_-r|0,r=g-(r>>>0>_>>>0)|0,_=I-((w>>>0<W>>>0)+o|0)|0,o=w-W|0}$1(h+16|0,n,t,O,S,3,0,0,0),$1(h,n,t,O,S,5,0,0,0),W=f,g=f&1,s=g,f=o+s|0,w=0,o=w+_|0,o=f>>>0<s>>>0?o+1|0:o,s=f,t=(t|0)==(o|0)&f>>>0>n>>>0|t>>>0<o>>>0,_=r,f=(o|0)==(w|0)&f>>>0<g>>>0|o>>>0<w>>>0,n=e+f|0,_=f>>>0>n>>>0?_+1|0:_,w=k,e=(_|0)==(S|0),e=e&(n|0)==(O|0)?t:e&n>>>0>O>>>0|_>>>0>S>>>0,r=e,e=e+W|0,w=r>>>0>e>>>0?w+1|0:w,r=w,f=(k|0)==(w|0)&e>>>0<W>>>0|k>>>0>w>>>0,w=m,k=f,f=f+B|0,w=k>>>0>f>>>0?w+1|0:w,t=f,k=i[h+20>>2],B=(k|0)==(o|0)&u0[h+16>>2]<s>>>0|k>>>0<o>>>0,k=i[h+28>>2],f=i[h+24>>2],k=w>>>0<2147418112&((f|0)==(n|0)&(k|0)==(_|0)?B:(k|0)==(_|0)&f>>>0<n>>>0|k>>>0<_>>>0),f=r,B=k,k=e+k|0,f=B>>>0>k>>>0?f+1|0:f,e=(r|0)==(f|0)&e>>>0>k>>>0|r>>>0>f>>>0,r=e,e=e+t|0,w=r>>>0>e>>>0?w+1|0:w,t=e,r=i[h+4>>2],o=(r|0)==(o|0)&u0[h>>2]<s>>>0|r>>>0<o>>>0,r=i[h+12>>2],e=i[h+8>>2],e=w>>>0<2147418112&((e|0)==(n|0)&(r|0)==(_|0)?o:(r|0)==(_|0)&e>>>0<n>>>0|r>>>0<_>>>0),r=e,e=e+k|0,_=r>>>0>e>>>0?f+1|0:f,r=_,k=(f|0)==(_|0)&e>>>0<k>>>0|f>>>0>_>>>0,f=w,n=k,k=k+t|0,f=n>>>0>k>>>0?f+1|0:f,C=k|C,V=f|V}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=C,i[A+12>>2]=V,v=h+336|0}function lB(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;o=v-96|0,v=o;i:{e:{if(!(k&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break e}s=v-96|0,v=s,t=i[e>>2],n=i[t+48>>2],_=i[t+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),w=o+60|0;r:{if(!f){n=v-48|0,v=n,f=i[t+48>>2],B=i[t+52>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),t=v-32|0,v=t,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,j1(t,f,r,t+20|0);f:{if(i[t>>2]){i[n+40>>2]=0,i[n+44>>2]=0;break f}A:{if(h=i[t+20>>2],f=i[t+24>>2],(h|0)!=(f|0)){if(r=i[h>>2],r&&(m=i[n+44>>2],r=X0(r,86628,89404),r))break A;if(h=h+8|0,(f|0)!=(h|0))for(;;){if(r=i[h>>2],r&&(m=0,r=X0(r,86628,89404),r))break A;if(h=h+8|0,(f|0)==(h|0))break}i[n+40>>2]=0,i[n+44>>2]=0}i[n+40>>2]=0,i[n+44>>2]=0;break f}if(i[n+44>>2]=m,i[n+40>>2]=r,r=i[h+4>>2],i[n+44>>2]=r,!r)break f;i[r+4>>2]=i[r+4>>2]+1}if(u[t+19|0]<0&&Z(i[t+8>>2]),f=i[t+20>>2],f){if(r=f,h=i[t+24>>2],(r|0)!=(h|0)){for(;;){r=i[h-4>>2];f:{if(!r||(m=i[r+4>>2],i[r+4>>2]=m-1,m))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(h=h-8|0,(f|0)==(h|0))break}r=i[t+20>>2]}i[t+24>>2]=f,Z(r)}v=t+32|0,r=i[n+40>>2];f:{if(!r){r=E(32),i[n+4>>2]=r,i[n+8>>2]=26,i[n+12>>2]=-2147483616,f=l[9611]|l[9612]<<8,u[r+24|0]=f,u[r+25|0]=f>>>8,f=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),t=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),t=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),t=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+26|0]=0,r=K(n+16|0,2,116,n+4|0),f=i[r+4>>2],i[w>>2]=i[r>>2],i[w+4>>2]=f,f=w+8|0;A:{if(u[r+19|0]>=0){t=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=t,i[f+8>>2]=i[r+16>>2],u[w+20|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[w+20|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[n+15|0]<0&&Z(i[n+4>>2]),r=i[n+44>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r);break f}f=i[n+44>>2],u[w+20|0]=0,i[w+4>>2]=f,i[w>>2]=r}f:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break f;X[i[i[B>>2]+8>>2]](B),p(B)}v=n+48|0;break r}i[s+92>>2]=0,i[s+84>>2]=0,i[s+88>>2]=0,j1(s- -64|0,n,r,s+84|0);f:{if(i[s+64>>2]){r=i[s+68>>2],i[w>>2]=i[s+64>>2],i[w+4>>2]=r,r=w+8|0;A:{if(u[s+83|0]>=0){f=i[s+76>>2],i[r>>2]=i[s+72>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+80>>2];break A}T(r,i[s+72>>2],i[s+76>>2])}u[w+20|0]=1;break f}t=f-1|0,n=i[s+84>>2],t>>>0>=i[s+88>>2]-n>>3>>>0&&(r=E(32),i[s+24>>2]=r,i[s+28>>2]=27,i[s+32>>2]=-2147483616,f=l[13933]|l[13934]<<8|(l[13935]<<16|l[13936]<<24),n=l[13929]|l[13930]<<8|(l[13931]<<16|l[13932]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+27|0]=0,f=l[13952]|l[13953]<<8|(l[13954]<<16|l[13955]<<24),u[r+23|0]=f,u[r+24|0]=f>>>8,u[r+25|0]=f>>>16,u[r+26|0]=f>>>24,f=l[13949]|l[13950]<<8|(l[13951]<<16|l[13952]<<24),n=l[13945]|l[13946]<<8|(l[13947]<<16|l[13948]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),n=l[13937]|l[13938]<<8|(l[13939]<<16|l[13940]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,r=K(s+44|0,5,2007,s+24|0),u[r+19|0]<0&&Z(i[r+8>>2]),u[s+35|0]<0&&Z(i[s+24>>2]),n=i[s+84>>2]),f=n+(t<<3)|0,r=i[f>>2],f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);A:{k:{if(!r||(r=X0(r,86628,89404),!r))break k;f&&(i[f+4>>2]=i[f+4>>2]+1),u[w+20|0]=0,i[w+4>>2]=f,i[w>>2]=r;break A}r=E(24),i[s+12>>2]=r,i[s+16>>2]=19,i[s+20>>2]=-2147483624,n=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[r+15|0]=n,u[r+16|0]=n>>>8,u[r+17|0]=n>>>16,u[r+18|0]=n>>>24,n=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),t=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,n=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),t=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+19|0]=0,r=K(s+24|0,5,2007,s+12|0),n=i[r+4>>2],i[w>>2]=i[r>>2],i[w+4>>2]=n,n=w+8|0;k:{if(u[r+19|0]>=0){t=i[r+12>>2],i[n>>2]=i[r+8>>2],i[n+4>>2]=t,i[n+8>>2]=i[r+16>>2],u[w+20|0]=1;break k}if(T(n,i[r+8>>2],i[r+12>>2]),n=u[r+19|0],u[w+20|0]=1,(n|0)>=0)break k;Z(i[r+8>>2])}if(u[s+23|0]>=0)break A;Z(i[s+12>>2])}if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(u[s+83|0]<0&&Z(i[s+72>>2]),r=i[s+84>>2],!r)break r;if(f=r,n=i[s+88>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];f:{if(!f||(w=i[f+4>>2],i[f+4>>2]=w-1,w))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[s+84>>2]}i[s+88>>2]=r,Z(f)}r:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break r;X[i[i[_>>2]+8>>2]](_),p(_)}v=s+96|0;r:{f:switch(l[o+80|0]){case 1:b0(A,o+60|0,i[e>>2]);break r;case 0:break f;default:break i}e=E(20),i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=1,r=i[o+60>>2];f:{if(u[r+115|0]>=0){i[o+56>>2]=i[r+112>>2],f=i[r+108>>2],i[o+48>>2]=i[r+104>>2],i[o+52>>2]=f;break f}T(o+48|0,i[r+104>>2],i[r+108>>2])}if(f=u[o+59|0],r=(f|0)<0,n=E((r?i[o+52>>2]:f)+1|0),f=i[o+48>>2],W=e,g=c4(n,r?f:o+48|0),i[W+4>>2]=g,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+127|0]>=0){i[o+40>>2]=i[r+124>>2],f=i[r+120>>2],i[o+32>>2]=i[r+116>>2],i[o+36>>2]=f;break f}T(o+32|0,i[r+116>>2],i[r+120>>2])}if(f=u[o+43|0],r=(f|0)<0,n=E((r?i[o+36>>2]:f)+1|0),f=i[o+32>>2],W=e,g=c4(n,r?f:o+32|0),i[W+8>>2]=g,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+139|0]>=0){i[o+24>>2]=i[r+136>>2],f=i[r+132>>2],i[o+16>>2]=i[r+128>>2],i[o+20>>2]=f;break f}T(o+16|0,i[r+128>>2],i[r+132>>2])}if(f=u[o+27|0],r=(f|0)<0,n=E((r?i[o+20>>2]:f)+1|0),f=i[o+16>>2],W=e,g=c4(n,r?f:o+16|0),i[W+12>>2]=g,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+151|0]>=0){i[o+8>>2]=i[r+148>>2],f=i[r+144>>2],i[o>>2]=i[r+140>>2],i[o+4>>2]=f;break f}T(o,i[r+140>>2],i[r+144>>2])}f=u[o+11|0],r=(f|0)<0,n=E((r?i[o+4>>2]:f)+1|0),f=i[o>>2],W=e,g=c4(n,r?f:o),i[W+16>>2]=g,r&&Z(f),i[k>>2]=e,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}if(A=l[o+80|0],(A|0)==255)break e;e=i[24185],i[o+88>>2]=i[24184],i[o+92>>2]=e,X[i[(o+88|0)+(A<<2)>>2]](o+87|0,o+60|0)}v=o+96|0;return}_2(),H()}function sB(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;r=v+-64|0,v=r,i[r+56>>2]=0,i[r+60>>2]=0,i[r+52>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,f=i[e+100>>2],i[r>>2]=i[f+48>>2],f=i[f+52>>2],i[r+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),Qr(r+24|0,i[r>>2],i[e+116>>2],r+44|0,0,0,-1,-1),k=i[r+4>>2];i:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break i;X[i[i[k>>2]+8>>2]](k),p(k)}i:{if(i[r+24>>2]){e=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=e,f=A+8|0;e:{if(u[r+43|0]>=0){e=i[r+36>>2],i[f>>2]=i[r+32>>2],i[f+4>>2]=e,i[f+8>>2]=i[r+40>>2];break e}T(f,i[r+32>>2],i[r+36>>2])}u[A+20|0]=1;break i}t=0,s=v-32|0,v=s,f=s+8|0,n=i[e+100>>2],r4(f,n,i[e+116>>2],0),m=i[s+12>>2],_=i[s+8>>2];e:{if(!_){if(u[s+8|0]=0,u[s+19|0]=0,K(r,2,2e3,f),u[s+19|0]>=0)break e;Z(i[s+8>>2]);break e}r:{f:{f=i[_+104>>2],o=i[_+108>>2];A:{if((f|0)==(o|0))break A;e=f;k:{for(;;){n:{if(k=i[e>>2],!k||(k=X0(k,86628,86648),!k))break n;if(h=i[e+4>>2],!h){h=0;break k}i[h+4>>2]=i[h+4>>2]+1,o=i[_+108>>2],f=i[_+104>>2];break k}if(e=e+8|0,(o|0)==(e|0))break}k=0}k:{if((f|0)!=(o|0))for(;;){n:{if(e=i[f>>2],!e||(e=X0(e,86628,100420),!e))break n;if(t=i[f+4>>2],!t){t=0;break k}i[t+4>>2]=i[t+4>>2]+1;break k}if(f=f+8|0,(o|0)==(f|0))break}e=0}if(!k)break A;if(_=n- -64|0,w=i[k+104>>2],B=i[k+108>>2],di(r,_,w,B),i[r>>2])break r;if(u[r+19|0]<0&&Z(i[r+8>>2]),e)break f}if(e=E(40),i[s+8>>2]=e,i[s+12>>2]=35,i[s+16>>2]=-2147483608,k=l[18112]|l[18113]<<8|(l[18114]<<16|l[18115]<<24),f=l[18108]|l[18109]<<8|(l[18110]<<16|l[18111]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,f=l[18139]|l[18140]<<8|(l[18141]<<16|l[18142]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,k=l[18136]|l[18137]<<8|(l[18138]<<16|l[18139]<<24),f=l[18132]|l[18133]<<8|(l[18134]<<16|l[18135]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[18128]|l[18129]<<8|(l[18130]<<16|l[18131]<<24),f=l[18124]|l[18125]<<8|(l[18126]<<16|l[18127]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[18120]|l[18121]<<8|(l[18122]<<16|l[18123]<<24),f=l[18116]|l[18117]<<8|(l[18118]<<16|l[18119]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,K(r,4,3002,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r}f:switch(l[e+104|0]-8|0){default:if(e=E(40),i[s+8>>2]=e,i[s+12>>2]=35,i[s+16>>2]=-2147483608,k=l[9618]|l[9619]<<8|(l[9620]<<16|l[9621]<<24),f=l[9614]|l[9615]<<8|(l[9616]<<16|l[9617]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,f=l[9645]|l[9646]<<8|(l[9647]<<16|l[9648]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,k=l[9642]|l[9643]<<8|(l[9644]<<16|l[9645]<<24),f=l[9638]|l[9639]<<8|(l[9640]<<16|l[9641]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[9634]|l[9635]<<8|(l[9636]<<16|l[9637]<<24),f=l[9630]|l[9631]<<8|(l[9632]<<16|l[9633]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[9626]|l[9627]<<8|(l[9628]<<16|l[9629]<<24),f=l[9622]|l[9623]<<8|(l[9624]<<16|l[9625]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,K(r,4,3002,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r;case 0:case 8:break f}if(i[r+48>>2]-i[r+44>>2]>>>0<G(w,B)>>>0){if(e=E(32),i[s+8>>2]=e,i[s+12>>2]=28,i[s+16>>2]=-2147483616,k=l[3644]|l[3645]<<8|(l[3646]<<16|l[3647]<<24),f=l[3640]|l[3641]<<8|(l[3642]<<16|l[3643]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+28|0]=0,f=l[3664]|l[3665]<<8|(l[3666]<<16|l[3667]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,k=l[3660]|l[3661]<<8|(l[3662]<<16|l[3663]<<24),f=l[3656]|l[3657]<<8|(l[3658]<<16|l[3659]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[3652]|l[3653]<<8|(l[3654]<<16|l[3655]<<24),f=l[3648]|l[3649]<<8|(l[3650]<<16|l[3651]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,K(r,2,0,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r}o=E(172),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=94860,o0(o+16|0,0,80),f=i[o+4>>2],n=f+1|0,i[o+4>>2]=n,i[o+104>>2]=0,i[o+108>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,u[o+24|0]=1,Q[o+22>>1]=2,Q[o+18>>1]=2,Q[o+20>>1]=2,i[o+112>>2]=0,i[o+116>>2]=4740,i[o+140>>2]=0,i[o+144>>2]=0,i[o+128>>2]=99,i[o+132>>2]=99,i[o+120>>2]=0,i[o+124>>2]=0,i[o+12>>2]=95208,i[o+148>>2]=0,i[o+152>>2]=0,i[o+136>>2]=o+140,i[o+156>>2]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+168>>2]=0,i[o+4>>2]=f,k=i[o+8>>2],f=o+12|0,i[o+96>>2]=f,i[o+8>>2]=k+1,i[o+100>>2]=o,n||(X[i[i[o>>2]+8>>2]](o),p(o)),i[r+56>>2]=f,k=i[r+60>>2],i[r+60>>2]=o;f:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f;X[i[i[k>>2]+8>>2]](k),p(k)}if(f=i[r+56>>2],i[f+120>>2]=0,i[f+116>>2]=2,i[f+112>>2]=B,i[f+108>>2]=w,T0(s+8|0,i[r+56>>2],0,w,B,l[e+104|0],_),i[s+8>>2]){e=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=e,e=i[s+20>>2],i[r+8>>2]=i[s+16>>2],i[r+12>>2]=e,i[r+16>>2]=i[s+24>>2];break r}o=io(i[r+56>>2],0,s+4|0);f:{if((w|0)!=i[s+4>>2]){if(!B)break f;if(e=0,(B|0)!=1)for(n=B&-2,f=0;k=!w,k||z(o+G(i[s+4>>2],e)|0,i[r+44>>2]+G(e,w)|0,w),k||(k=e|1,z(o+G(k,i[s+4>>2])|0,i[r+44>>2]+G(k,w)|0,w)),e=e+2|0,f=f+2|0,(n|0)!=(f|0););if(!(B&1)|!w)break f;z(o+G(i[s+4>>2],e)|0,i[r+44>>2]+G(e,w)|0,w);break f}if(f=i[r+44>>2],e=i[r+48>>2]-f|0,!e)break f;z(o,f,e)}if(k8(r,107712),u[s+27|0]>=0)break r;Z(i[s+16>>2])}r:{if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break r;X[i[i[t>>2]+8>>2]](t),p(t)}if(!h||(e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;X[i[i[h>>2]+8>>2]](h),p(h)}e:{if(!m||(e=i[m+4>>2],i[m+4>>2]=e-1,e))break e;X[i[i[m>>2]+8>>2]](m),p(m)}v=s+32|0;e:{if(i[r>>2]){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,f=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=e,i[f+8>>2]=i[r+16>>2],e=1;break e}T(f,i[r+8>>2],i[r+12>>2]),e=1;break e}f=i[r+56>>2],e=i[r+60>>2],i[r+56>>2]=0,i[r+60>>2]=0,i[A>>2]=f,i[A+4>>2]=e,e=0}if(u[A+20|0]=e,u[r+19|0]>=0)break i;Z(i[r+8>>2])}u[r+43|0]<0&&Z(i[r+32>>2]),A=i[r+44>>2],A&&(i[r+48>>2]=A,Z(A)),e=i[r+60>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=r- -64|0}function wB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;s=v-16|0,v=s,w=i[r>>2],B=i[r+4>>2]-w|0,o=i[k>>2];i:{if(B-o>>>0<=(f|0)/8<<2>>>0){if(e=E(56),i[s+4>>2]=e,i[s+8>>2]=50,i[s+12>>2]=-2147483592,r=l[8959]|l[8960]<<8|(l[8961]<<16|l[8962]<<24),f=l[8955]|l[8956]<<8|(l[8957]<<16|l[8958]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+50|0]=0,r=l[9003]|l[9004]<<8,u[e+48|0]=r,u[e+49|0]=r>>>8,r=l[8999]|l[9e3]<<8|(l[9001]<<16|l[9002]<<24),f=l[8995]|l[8996]<<8|(l[8997]<<16|l[8998]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[8991]|l[8992]<<8|(l[8993]<<16|l[8994]<<24),f=l[8987]|l[8988]<<8|(l[8989]<<16|l[8990]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[8983]|l[8984]<<8|(l[8985]<<16|l[8986]<<24),f=l[8979]|l[8980]<<8|(l[8981]<<16|l[8982]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8975]|l[8976]<<8|(l[8977]<<16|l[8978]<<24),f=l[8971]|l[8972]<<8|(l[8973]<<16|l[8974]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8967]|l[8968]<<8|(l[8969]<<16|l[8970]<<24),f=l[8963]|l[8964]<<8|(l[8965]<<16|l[8966]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}t=o+w|0,h=l[t|0],_=l[t+1|0];e:{if((f|0)==32){m=l[t+3|0],t=l[t+2|0],i[k>>2]=o+4,i[e+4>>2]=_<<16|h<<24|t<<8|m,t=i[k>>2],o=t+w|0,o=l[o|0]|l[o+1|0]<<8|(l[o+2|0]<<16|l[o+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=o<<24|(o&65280)<<8|(o>>>8&65280|o>>>24),o=i[k>>2],t=w+o|0,h=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,_=4;break e}i[k>>2]=o+2,i[e+4>>2]=(_<<16|h<<24)>>16,o=i[k>>2],t=o+w|0,h=l[t+1|0],t=l[t|0],i[k>>2]=o+2,i[e+8>>2]=(h<<16|t<<24)>>16,o=i[k>>2],h=w+o|0,t=h+1|0,h=l[h|0]<<8,_=2}t=l[t|0],i[k>>2]=o+_,i[e+12>>2]=t|h,_=i[k>>2],t=_+w|0,h=l[t|0],o=l[t+1|0];e:{if((f|0)==32){f=o<<16|h<<24|l[t+2|0]<<8,o=l[t+3|0],t=4;break e}f=h<<8,t=2}if(i[k>>2]=t+_,i[e+16>>2]=f|o,f=i[k>>2],w=l[f+w|0],o=f+1|0,i[k>>2]=o,w){if(e=E(56),i[s+4>>2]=e,i[s+8>>2]=51,i[s+12>>2]=-2147483592,r=l[16446]|l[16447]<<8|(l[16448]<<16|l[16449]<<24),f=l[16442]|l[16443]<<8|(l[16444]<<16|l[16445]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[16489]|l[16490]<<8|(l[16491]<<16|l[16492]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[16486]|l[16487]<<8|(l[16488]<<16|l[16489]<<24),f=l[16482]|l[16483]<<8|(l[16484]<<16|l[16485]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16478]|l[16479]<<8|(l[16480]<<16|l[16481]<<24),f=l[16474]|l[16475]<<8|(l[16476]<<16|l[16477]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16470]|l[16471]<<8|(l[16472]<<16|l[16473]<<24),f=l[16466]|l[16467]<<8|(l[16468]<<16|l[16469]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16462]|l[16463]<<8|(l[16464]<<16|l[16465]<<24),f=l[16458]|l[16459]<<8|(l[16460]<<16|l[16461]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16454]|l[16455]<<8|(l[16456]<<16|l[16457]<<24),f=l[16450]|l[16451]<<8|(l[16452]<<16|l[16453]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}e:{if(f=i[e+12>>2],f&&(w=i[e+16>>2],w))break e;if(e=E(24),i[s+4>>2]=e,i[s+8>>2]=21,i[s+12>>2]=-2147483624,r=l[25538]|l[25539]<<8|(l[25540]<<16|l[25541]<<24),f=l[25534]|l[25535]<<8|(l[25536]<<16|l[25537]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,r=l[25551]|l[25552]<<8|(l[25553]<<16|l[25554]<<24),f=l[25547]|l[25548]<<8|(l[25549]<<16|l[25550]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[25546]|l[25547]<<8|(l[25548]<<16|l[25549]<<24),f=l[25542]|l[25543]<<8|(l[25544]<<16|l[25545]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}if(4294967295/(w>>>0)>>>0<=f>>>3>>>0){if(e=E(48),i[s+4>>2]=e,i[s+8>>2]=46,i[s+12>>2]=-2147483600,r=l[25254]|l[25255]<<8|(l[25256]<<16|l[25257]<<24),f=l[25250]|l[25251]<<8|(l[25252]<<16|l[25253]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[25292]|l[25293]<<8|(l[25294]<<16|l[25295]<<24),f=l[25288]|l[25289]<<8|(l[25290]<<16|l[25291]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[25286]|l[25287]<<8|(l[25288]<<16|l[25289]<<24),f=l[25282]|l[25283]<<8|(l[25284]<<16|l[25285]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25278]|l[25279]<<8|(l[25280]<<16|l[25281]<<24),f=l[25274]|l[25275]<<8|(l[25276]<<16|l[25277]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25270]|l[25271]<<8|(l[25272]<<16|l[25273]<<24),f=l[25266]|l[25267]<<8|(l[25268]<<16|l[25269]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25262]|l[25263]<<8|(l[25264]<<16|l[25265]<<24),f=l[25258]|l[25259]<<8|(l[25260]<<16|l[25261]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,0,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}if(t=d8(i[n+8>>2],i[n+12>>2],f,0),!l0&t>>>0<w>>>0){if(e=A,A=d2(s+4|0,25077),K(e,6,1e3,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(w=G(f,w),f=w>>>3|0,f>>>0>B-o>>>0){if(e=A,A=d2(s+4|0,19137),K(e,2,136,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(K4(A,e+32|0,f,n,10178),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),gu(e+20|0,f),!f|w>>>0<8||z(i[e+20>>2],i[r>>2]+i[k>>2]|0,f),k8(A,107712)}v=s+16|0}function O7(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;i:{if(o=p2(11296),o)for(o0(o,255,11296),k=o+1056|0,i[31300]=k,i[31296]=k,i[31295]=o+992,i[31294]=o+928,i[31293]=o+864,i[31292]=o+800,i[31291]=o+736,i[31290]=o+672,i[31289]=o+608,i[31288]=o+544,i[31287]=o+480,i[31286]=o+416,i[31285]=o+352,i[31284]=o+288,i[31283]=o+224,i[31282]=o+160,i[31281]=o+96,i[31280]=o+32,k=o+16|0,i[31279]=k,i[31278]=k,i[31277]=k,i[31276]=k,i[31275]=k,i[31274]=k,i[31273]=k,i[31272]=k,i[31271]=o,i[31270]=o,i[31269]=o,i[31268]=o,i[31267]=o,i[31266]=o,i[31265]=o,i[31264]=o,k=o+1312|0,i[31301]=k,i[31297]=k,k=o+1568|0,i[31302]=k,i[31298]=k,k=o+2080|0,i[31308]=k,i[31304]=k,k=o+1824|0,i[31303]=k,i[31299]=k,k=o+2336|0,i[31309]=k,i[31305]=k,k=o+2592|0,i[31310]=k,i[31306]=k,k=o+3104|0,i[31316]=k,i[31312]=k,k=o+2848|0,i[31311]=k,i[31307]=k,k=o+4128|0,i[31317]=k,i[31313]=k,k=o+5152|0,i[31318]=k,i[31314]=k,k=o+7200|0,i[31324]=k,i[31320]=k,k=o+6176|0,i[31319]=k,i[31315]=k,k=o+8224|0,i[31325]=k,i[31321]=k,k=o+9248|0,i[31326]=k,i[31322]=k,k=o+10272|0,i[31327]=k,i[31323]=k,m=2;;){N=m-2|0,s=1<<m;e:{if((m|0)!=2){for(C=(m|0)==3,B=C?11:14,D=0,r=1;;){for(k=1,A=0;;){for(V=((N<<6)+(D<<5)|0)+(A<<4)|0,g=V+125056|0,y=k?9:15,w=0;;){for(R=w&3,t=w<<m,A=0;;){f=A|w,e=0;r:{if(!f)break r;if(e=R+(A&3)|0,h=e>>>0<=2?e?1:2:0,r){if(h=f>>>0<4?h:h+3|0,e=h+y|0,(m|0)==3)break r;e=h+21|0;break r}if(e=h+9|0,(m|0)==3)break r;e=h|12}if(h=t+(i[g>>2]+A|0)|0,f=l[h|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(t=V+125060|0,w=0;;){for(e=w&3,h=e?(e|0)==1:2,f=C?h+9|0:h|12,W=h+3|0,n=w<<m,A=0;;){g=A|w,e=g?f:0,R=!r;r:{if(R|!g)break r;if(e=g>>>0<4?h:W,!C){e=e+21|0;break r}e=e+y|0}if(g=n+(i[t>>2]+A|0)|0,_=l[g|0],e=r?e:e+27|0,(_|0)!=255&(e|0)!=(_|0))break i;if(u[g|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(g=V+125064|0,w=0;;){for(t=w<<m,A=0;;){f=A|w,e=0;r:{if(!f)break r;if(e=A&3,h=e?(e|0)==1:2,!r){if(e=h|12,!C)break r;e=h+9|0;break r}if(h=f>>>0<4?h:h+3|0,e=h+21|0,!C)break r;e=h+y|0}if(h=t+(i[g>>2]+A|0)|0,f=l[h|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(V=V+125068|0,w=0;;){for(g=w<<m,A=0;;){h=A|w,e=h?B:0;r:{if(R|!h)break r;if(e=h>>>0<4?2:5,!C){e=e+21|0;break r}e=e+y|0}if(h=g+(i[V>>2]+A|0)|0,t=l[h|0],e=r?e:e+27|0,(t|0)!=255&(e|0)!=(t|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}if(A=1,e=k,k=0,!e)break}if(D=1,k=r,r=0,!k)break}break e}for(w=N<<6,C=w+125084|0,y=w+125080|0,h=w+125076|0,V=w+125072|0,N=w+125068|0,D=w+125064|0,g=w+125060|0,R=w+125056|0,e=0,k=1;;){r=0;r:{if(!k){for(e=w+(e<<5)|0,B=e+125056|0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125060|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125064|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125068|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125072|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125076|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125080|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(W=f+(i[B>>2]+A|0)|0,n=l[W|0],I=(n|0)!=255,_=n,n=l[(A+t|0)+63600|0]+27|0,I&(_|0)!=(n|0))break i;if(u[W|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(e=e+125084|0,r=0;;){for(B=r<<2,t=r<<m,A=0;;){if(f=t+(i[e>>2]+A|0)|0,W=l[f|0],_=(W|0)!=255,n=W,W=l[(A+B|0)+63600|0]+27|0,_&(n|0)!=(W|0))break i;if(u[f|0]=W,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}break r}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[R>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[g>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[D>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[N>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[V>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[h>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[y>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[C>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63600|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=e+1|0,(s|0)==(e|0))break}}if(e=1,r=k,k=0,!r)break}}if(m=m+1|0,(m|0)==6)break}return(o|0)!=0}M0(17975,18308,2114,13839),H()}function hB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=M(0),h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=M(0),a=M(0),$=0,f0=0,A0=M(0),n0=M(0),h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=M(0),D0=0,H0=M(0),L0=M(0),q0=M(0),$0=M(0),P0=M(0);n=v-144|0,v=n,e=i[r>>2],R=i[e+112>>2],V=i[e+108>>2],S=j0(e,10),I=i[i[r>>2]+120>>2],t=E(172),i[t>>2]=94860,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],s=f+1|0,i[t+4>>2]=s,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],N=t+12|0,i[t+96>>2]=N,i[t+8>>2]=f+1,i[t+100>>2]=t,s||(X[i[i[t>>2]+8>>2]](t),p(t)),i[N+120>>2]=1,i[N+116>>2]=0,i[N+112>>2]=R,i[N+108>>2]=V,T0(n+96|0,N,0,V,R,S,o),m=V+1>>>1|0,s=R+1>>>1|0,T0(n+72|0,N,1,m,s,S,o),_=n+128|0;i:{if(i[n+96>>2]){if(f=i[n+100>>2],i[n+120>>2]=i[n+96>>2],i[n+124>>2]=f,u[n+115|0]>=0){f=i[n+108>>2],i[_>>2]=i[n+104>>2],i[_+4>>2]=f,i[_+8>>2]=i[n+112>>2];break i}T(_,i[n+104>>2],i[n+108>>2]);break i}if(f=i[n+76>>2],i[n+120>>2]=i[n+72>>2],i[n+124>>2]=f,u[n+91|0]>=0){f=i[n+84>>2],i[_>>2]=i[n+80>>2],i[_+4>>2]=f,i[_+8>>2]=i[n+88>>2];break i}T(_,i[n+80>>2],i[n+84>>2])}T0(n+48|0,N,2,m,s,S,o),s=n+16|0;i:{if(i[n+120>>2]){if(f=i[n+124>>2],i[n+8>>2]=i[n+120>>2],i[n+12>>2]=f,u[n+139|0]>=0){f=i[_+4>>2],i[s>>2]=i[_>>2],i[s+4>>2]=f,i[s+8>>2]=i[_+8>>2];break i}T(s,i[n+128>>2],i[n+132>>2]);break i}if(f=i[n+52>>2],i[n+8>>2]=i[n+48>>2],i[n+12>>2]=f,u[n+67|0]>=0){f=i[n+60>>2],i[s>>2]=i[n+56>>2],i[s+4>>2]=f,i[s+8>>2]=i[n+64>>2];break i}T(s,i[n+56>>2],i[n+60>>2])}u[n+67|0]<0&&Z(i[n+56>>2]),u[n+139|0]<0&&Z(i[n+128>>2]),u[n+91|0]<0&&Z(i[n+80>>2]),u[n+115|0]<0&&Z(i[n+104>>2]);i:{e:{if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+8>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}u[n+27|0]<0&&Z(i[n+16>>2]);r:{f:switch(I-13|0){case 0:case 2:break f;default:break r}if(T0(n+8|0,N,6,V,R,S,o),i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}if(u[n+27|0]>=0)break r;Z(i[n+16>>2])}r:{f:{if(m=i[r>>2],o=i[m+128>>2],!o)break f;for(s=m+128|0,f=s;r=i[o+16>>2]<10,f=r?f:o,o=i[(r?4:0)+o>>2],!!o;);if((f|0)==(s|0))break f;if(s=0,i[f+16>>2]>10)break r;m0=i[f+44>>2],s=i[f+56>>2];break r}s=0}r:{f:{if(f=i[e>>2],f){for(r=e,o=f;C=i[o+16>>2],r=(C|0)<0?r:o,o=i[(C>>>29&4)+o>>2],!!o;);o=0;A:{if((e|0)==(r|0)||(o=0,i[r+16>>2]>0))break A;B=i[r+56>>2],o=i[r+44>>2]}for($=o,r=e,o=f;C=i[o+16>>2]<=0,r=C?r:o,o=i[(C?4:0)+o>>2],!!o;);h=0;A:{if((e|0)==(r|0)||(h=0,i[r+16>>2]>1))break A;D0=i[r+44>>2],h=i[r+56>>2]}for(r=e,o=f;C=i[o+16>>2]<2,r=C?r:o,o=i[(C?4:0)+o>>2],!!o;);C=0;A:{if((e|0)==(r|0)||(C=0,i[r+16>>2]>2))break A;V0=i[r+56>>2],C=i[r+44>>2]}r=0;A:switch(I-13|0){case 0:case 2:break A;default:break r}for(o=e;r=i[f+16>>2]<6,o=r?o:f,f=i[(r?4:0)+f>>2],!!f;);if((e|0)!=(o|0))break f}r=0;break r}if(i[o+16>>2]>6){r=0;break r}O=i[o+56>>2]>>>1|0,r=i[o+44>>2]}e0=l[k+22|0],e=i[m+120>>2],Nr(n+8|0,F[k+20>>1],F[k+16>>1]);r:{if(!R)break r;f0=(I&-3)==13?8:6,k=-1<<S^-1,D=e&-2,x=(D|0)==14,W0=x^3;f:{if(!V)break f;r0=B>>>1|0,A0=M(16<<S-8),W=x?4:5,y=!x,n0=E0[n+20>>2],L=E0[n+16>>2],a=E0[n+12>>2],e=0;A:switch(I-13|0){case 0:case 2:if(Q0=x^7,e0&1)for(;;){for(h0=G(e,s)+m0|0,_=(G(e,O)<<1)+r|0,I=(G(e,r0)<<1)+$|0,f=0;m=f<<1,N0=m+I|0,B=h0+G(f,f0)|0,g=B+x|0,w=M(M(M(M((l[g+4|0]<<8|l[W+B|0])>>>0)*n0)+M(M(M((l[B+y|0]|l[g|0]<<8)>>>0)*a)+M(L*M((l[B+W0|0]|l[g+2|0]<<8)>>>0))))+M(.5)),M(w2(w))<M(2147483648)?o=~~w:o=-2147483648,Q[N0>>1]=(o|0)>=0?(k|0)<(o|0)?k:o:0,Q[_+m>>1]=l[B+Q0|0]|l[g+6|0]<<8,f=f+1|0,(V|0)!=(f|0););if(e=e+1|0,(R|0)==(e|0))break f}for(;;){for(h0=G(e,s)+m0|0,_=(G(e,O)<<1)+r|0,I=(G(e,r0)<<1)+$|0,f=0;m=f<<1,N0=m+I|0,B=h0+G(f,f0)|0,g=B+x|0,w=M(M(M(M(M(M((l[g+4|0]<<8|l[W+B|0])>>>0)*n0)+M(M(M((l[B+y|0]|l[g|0]<<8)>>>0)*a)+M(L*M((l[B+W0|0]|l[g+2|0]<<8)>>>0))))*M(.8554700016975403))+A0)+M(.5)),M(w2(w))<M(2147483648)?o=~~w:o=-2147483648,Q[N0>>1]=(o|0)>=0?(k|0)<(o|0)?k:o:0,Q[_+m>>1]=l[B+Q0|0]|l[g+6|0]<<8,f=f+1|0,(V|0)!=(f|0););if(e=e+1|0,(R|0)==(e|0))break}break f;default:break A}for(;;){for(m=G(e,s)+m0|0,B=(G(e,r0)<<1)+$|0,o=0;f=B+(o<<1)|0,I=m+G(o,f0)|0,r=I+x|0,w=M(M(M((l[r+4|0]<<8|l[W+I|0])>>>0)*n0)+M(M(M((l[I+y|0]|l[r|0]<<8)>>>0)*a)+M(L*M((l[I+W0|0]|l[r+2|0]<<8)>>>0)))),w=M((e0&1?w:M(M(w*M(.8554700016975403))+A0))+M(.5)),M(w2(w))<M(2147483648)?r=~~w:r=-2147483648,Q[f>>1]=(r|0)>=0?(r|0)>(k|0)?k:r:0,o=o+1|0,(V|0)!=(o|0););if(e=e+1|0,(R|0)==(e|0))break}}if(!V)break r;for(Q0=V0>>>1|0,V0=h>>>1|0,h0=(D|0)==14?4:5,_=!x,U0=M((1<<S-1&65535)>>>0),o=0,H0=E0[n+44>>2],L0=E0[n+40>>2],q0=E0[n+36>>2],$0=E0[n+32>>2],P0=E0[n+28>>2],n0=E0[n+24>>2];;){for(W=(o|1)>>>0<R>>>0?s:0,I=G(o,s)+m0|0,e=o>>>1|0,m=(G(e,Q0)<<1)+C|0,B=(G(e,V0)<<1)+D0|0,r=0;$=r+B|0,O=I+G(r,f0)|0,y=O+x|0,h=y+4|0,g=(r|1)>>>0<V>>>0?f0:0,f=h+g|0,D=O+h0|0,e=D+g|0,L=M(M((((l[f|0]<<8|l[e|0])+(l[D|0]|l[y+4|0]<<8)|0)+(l[W+D|0]|l[W+h|0]<<8)|0)+(l[e+W|0]|l[f+W|0]<<8)>>>0)*M(.25)),h=_+O|0,f=h+g|0,e=g+y|0,a=M(M((((l[f|0]|l[e|0]<<8)+(l[h|0]|l[y|0]<<8)|0)+(l[W+h|0]|l[W+y|0]<<8)|0)+(l[f+W|0]|l[e+W|0]<<8)>>>0)*M(.25)),D=O+W0|0,h=D+g|0,f=y+2|0,e=f+g|0,A0=M(M((((l[h|0]|l[e|0]<<8)+(l[D|0]|l[y+2|0]<<8)|0)+(l[W+D|0]|l[f+W|0]<<8)|0)+(l[W+h|0]|l[e+W|0]<<8)>>>0)*M(.25)),w=M(M(L*$0)+M(M(a*n0)+M(P0*A0))),h=e0&1,w=M(M((h?w:M(w*M(.875)))+U0)+M(.5)),M(w2(w))<M(2147483648)?e=~~w:e=-2147483648,Q[$>>1]=(e|0)>=0?(e|0)>(k|0)?k:e:0,f=r+m|0,w=M(M(L*H0)+M(M(a*q0)+M(A0*L0))),w=M(M((h?w:M(w*M(.875)))+U0)+M(.5)),M(w2(w))<M(2147483648)?e=~~w:e=-2147483648,Q[f>>1]=(e|0)>=0?(e|0)>(k|0)?k:e:0,r=r+2|0,V>>>0>r>>>0;);if(o=o+2|0,!(R>>>0>o>>>0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=N;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=n+144|0}function _B(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v-32|0,v=t,k=F0(r),i[t+16>>2]=k;i:{e:{r:{f:{A:{k:{n:{if((k|0)<=1886547813){if((k|0)==1852009571)break k;if((k|0)!=1852009592)break n;f=E(24),u[f+22|0]=1,Q[f+20>>1]=6,Q[f+16>>1]=1,Q[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=95416,i[f>>2]=95336,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;t:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break t;X[i[i[k>>2]+8>>2]](k),p(k)}e=v-16|0,v=e,k=i[r>>2],o=X[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,o=o+7|0,k=o>>>0<7?k+1|0:k;t:{if(X[i[i[s>>2]+12>>2]](s,o,k)|0){if(u[e+4|0]=0,u[e+15|0]=0,K(A,2,100,e+4|0),u[e+15|0]>=0)break t;Z(i[e+4>>2]);break t}if(_=n,B=o2(r),Q[_+4>>1]=B,_=n,B=o2(r),Q[_+6>>1]=B,_=n,B=o2(r),Q[_+8>>1]=B,_=n,B=W2(r)>>>7|0,u[_+10|0]=B,k=i[26929],i[A>>2]=i[26928],i[A+4>>2]=k,k=A+8|0,u[107731]>=0){n=i[26931],i[k>>2]=i[26930],i[k+4>>2]=n,i[k+8>>2]=i[26932];break t}T(k,i[26930],i[26931])}if(v=e+16|0,i[A>>2])break r;if(u[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;X[i[i[f>>2]+8>>2]](f),p(f);break f}if((k|0)==1886547814|(k|0)==1917403971)break A}if(u[t+20|0]=0,u[t+31|0]=0,K(A,2,126,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}f=E(24),u[f+22|0]=1,Q[f+20>>1]=6,Q[f+16>>1]=1,Q[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=95416,i[f>>2]=95336,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;k:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break k;X[i[i[k>>2]+8>>2]](k),p(k)}e=v-16|0,v=e,k=i[r>>2],o=X[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,o=o+6|0,k=o>>>0<6?k+1|0:k;k:{if(X[i[i[s>>2]+12>>2]](s,o,k)|0){if(u[e+4|0]=0,u[e+15|0]=0,K(A,2,100,e+4|0),u[e+15|0]>=0)break k;Z(i[e+4>>2]);break k}if(_=n,B=o2(r),Q[_+4>>1]=B,_=n,B=o2(r),Q[_+6>>1]=B,k=o2(r),Q[n+8>>1]=k,u[n+10|0]=!k,k=i[26929],i[A>>2]=i[26928],i[A+4>>2]=k,k=A+8|0,u[107731]>=0){n=i[26931],i[k>>2]=i[26930],i[k+4>>2]=n,i[k+8>>2]=i[26932];break k}T(k,i[26930],i[26931])}if(v=e+16|0,i[A>>2])break e;if(u[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;X[i[i[f>>2]+8>>2]](f),p(f);break f}if(k=i[e+12>>2],w=k,n=i[e+8>>2],!(k|n)){if(e=E(56),i[t+20>>2]=e,i[t+24>>2]=52,i[t+28>>2]=-2147483592,r=l[16327]|l[16328]<<8|(l[16329]<<16|l[16330]<<24),f=l[16323]|l[16324]<<8|(l[16325]<<16|l[16326]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+52|0]=0,r=l[16371]|l[16372]<<8|(l[16373]<<16|l[16374]<<24),u[e+48|0]=r,u[e+49|0]=r>>>8,u[e+50|0]=r>>>16,u[e+51|0]=r>>>24,r=l[16367]|l[16368]<<8|(l[16369]<<16|l[16370]<<24),f=l[16363]|l[16364]<<8|(l[16365]<<16|l[16366]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16359]|l[16360]<<8|(l[16361]<<16|l[16362]<<24),f=l[16355]|l[16356]<<8|(l[16357]<<16|l[16358]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16351]|l[16352]<<8|(l[16353]<<16|l[16354]<<24),f=l[16347]|l[16348]<<8|(l[16349]<<16|l[16350]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16343]|l[16344]<<8|(l[16345]<<16|l[16346]<<24),f=l[16339]|l[16340]<<8|(l[16341]<<16|l[16342]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16335]|l[16336]<<8|(l[16337]<<16|l[16338]<<24),f=l[16331]|l[16332]<<8|(l[16333]<<16|l[16334]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,4,0,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(h=i[e+32>>2],o=n-h|0,k=o-4|0,f=i[f+32>>2],!(!f|(w-(n>>>0<h>>>0)|0)==(o>>>0<4|0)&f>>>0>=k>>>0)){if(e=E(48),i[t+20>>2]=e,i[t+24>>2]=44,i[t+28>>2]=-2147483600,r=l[11706]|l[11707]<<8|(l[11708]<<16|l[11709]<<24),f=l[11702]|l[11703]<<8|(l[11704]<<16|l[11705]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[11742]|l[11743]<<8|(l[11744]<<16|l[11745]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[11738]|l[11739]<<8|(l[11740]<<16|l[11741]<<24),f=l[11734]|l[11735]<<8|(l[11736]<<16|l[11737]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[11730]|l[11731]<<8|(l[11732]<<16|l[11733]<<24),f=l[11726]|l[11727]<<8|(l[11728]<<16|l[11729]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[11722]|l[11723]<<8|(l[11724]<<16|l[11725]<<24),f=l[11718]|l[11719]<<8|(l[11720]<<16|l[11721]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11714]|l[11715]<<8|(l[11716]<<16|l[11717]<<24),f=l[11710]|l[11711]<<8|(l[11712]<<16|l[11713]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,1e3,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(f=i[r>>2],n=X[i[i[f>>2]+8>>2]](f)|0,o=i[r>>2],f=l0,n=k+n|0,f=n>>>0<k>>>0?f+1|0:f,X[i[i[o>>2]+12>>2]](o,n,f)|0){if(u[t+20|0]=0,u[t+31|0]=0,K(A,2,100,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}f=t+20|0,i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0;A:{k:{if(k){if((k|0)<0)break k;n=E(k),i[f>>2]=n,o=k+n|0,i[f+8>>2]=o,k&&o0(n,0,k),i[f+4>>2]=o}break A}G0(),H()}if(k)for(;n=W2(r),u[i[f>>2]+s|0]=n,s=s+1|0,(k|0)!=(s|0););n=t+8|0,k=E(32),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=95536,o=i[t+16>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=o,i[k+12>>2]=95376;A:{k:{if(o=i[f+4>>2],s=i[f>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break k;w=E(o),i[k+20>>2]=w,h=o+w|0,i[k+28>>2]=h,o&&z(w,s,o),i[k+24>>2]=h}i[n+4>>2]=k,i[n>>2]=k+12;break A}G0(),H()}if(E8(e+100|0,n),V2(n),e=i[f>>2],!e)break f;i[f+4>>2]=e,Z(e)}if(l[r+20|0]==1){if(u[t+20|0]=0,u[t+31|0]=0,K(A,2,100,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=t+32|0}function BB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;w=v-48|0,v=w,s=w+16|0,o=v-48|0,v=o,t=i[i[e>>2]+180>>2],f=i[t+104>>2];i:{if((f|0)==i[t+108>>2]){f=E(40),i[o+12>>2]=f,i[o+16>>2]=33,i[o+20>>2]=-2147483608,u[f+32|0]=l[24231],t=l[24227]|l[24228]<<8|(l[24229]<<16|l[24230]<<24),k=l[24223]|l[24224]<<8|(l[24225]<<16|l[24226]<<24),u[f+24|0]=k,u[f+25|0]=k>>>8,u[f+26|0]=k>>>16,u[f+27|0]=k>>>24,u[f+28|0]=t,u[f+29|0]=t>>>8,u[f+30|0]=t>>>16,u[f+31|0]=t>>>24,t=l[24219]|l[24220]<<8|(l[24221]<<16|l[24222]<<24),k=l[24215]|l[24216]<<8|(l[24217]<<16|l[24218]<<24),u[f+16|0]=k,u[f+17|0]=k>>>8,u[f+18|0]=k>>>16,u[f+19|0]=k>>>24,u[f+20|0]=t,u[f+21|0]=t>>>8,u[f+22|0]=t>>>16,u[f+23|0]=t>>>24,t=l[24211]|l[24212]<<8|(l[24213]<<16|l[24214]<<24),k=l[24207]|l[24208]<<8|(l[24209]<<16|l[24210]<<24),u[f+8|0]=k,u[f+9|0]=k>>>8,u[f+10|0]=k>>>16,u[f+11|0]=k>>>24,u[f+12|0]=t,u[f+13|0]=t>>>8,u[f+14|0]=t>>>16,u[f+15|0]=t>>>24,t=l[24203]|l[24204]<<8|(l[24205]<<16|l[24206]<<24),k=l[24199]|l[24200]<<8|(l[24201]<<16|l[24202]<<24),u[f|0]=k,u[f+1|0]=k>>>8,u[f+2|0]=k>>>16,u[f+3|0]=k>>>24,u[f+4|0]=t,u[f+5|0]=t>>>8,u[f+6|0]=t>>>16,u[f+7|0]=t>>>24,u[f+33|0]=0,f=K(o+24|0,2,0,o+12|0),t=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=t,t=s+8|0;e:{if(u[f+19|0]>=0){k=i[f+12>>2],i[t>>2]=i[f+8>>2],i[t+4>>2]=k,i[t+8>>2]=i[f+16>>2],u[s+20|0]=1;break e}if(T(t,i[f+8>>2],i[f+12>>2]),t=u[f+19|0],u[s+20|0]=1,(t|0)>=0)break e;Z(i[f+8>>2])}if(u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}k=i[f>>2],t=i[f+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);e:{r:{if(!k||(k=X0(k,86628,105688),!k))break r;t&&(i[t+4>>2]=i[t+4>>2]+1);f:{A:{k:{if(f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))for(;;){n:{if(k=i[f>>2],!k||(k=X0(k,86628,105768),!k))break n;if(f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),u[k+115|0]<0)break k;i[o+8>>2]=i[k+112>>2],n=i[k+108>>2],i[o>>2]=i[k+104>>2],i[o+4>>2]=n;break A}if(f=f+8|0,(n|0)==(f|0))break}f=E(40),i[o+12>>2]=f,i[o+16>>2]=38,i[o+20>>2]=-2147483608,k=l[22491]|l[22492]<<8|(l[22493]<<16|l[22494]<<24),n=l[22487]|l[22488]<<8|(l[22489]<<16|l[22490]<<24),u[f+30|0]=n,u[f+31|0]=n>>>8,u[f+32|0]=n>>>16,u[f+33|0]=n>>>24,u[f+34|0]=k,u[f+35|0]=k>>>8,u[f+36|0]=k>>>16,u[f+37|0]=k>>>24,k=l[22485]|l[22486]<<8|(l[22487]<<16|l[22488]<<24),n=l[22481]|l[22482]<<8|(l[22483]<<16|l[22484]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[22477]|l[22478]<<8|(l[22479]<<16|l[22480]<<24),n=l[22473]|l[22474]<<8|(l[22475]<<16|l[22476]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[22469]|l[22470]<<8|(l[22471]<<16|l[22472]<<24),n=l[22465]|l[22466]<<8|(l[22467]<<16|l[22468]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[22461]|l[22462]<<8|(l[22463]<<16|l[22464]<<24),n=l[22457]|l[22458]<<8|(l[22459]<<16|l[22460]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+38|0]=0,f=K(o+24|0,2,0,o+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;n:{if(u[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],u[s+20|0]=1;break n}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[s+20|0]=1,(k|0)>=0)break n;Z(i[f+8>>2])}if(u[o+23|0]>=0)break f;Z(i[o+12>>2]);break f}T(o,i[k+104>>2],i[k+108>>2])}if(k=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=k,i[s+8>>2]=i[o+8>>2],i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0,u[s+20|0]=0,!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(!t)break i;if(f=i[t+4>>2],i[t+4>>2]=f-1,f)break e;X[i[i[t>>2]+8>>2]](t),p(t);break e}f=E(40),i[o+12>>2]=f,i[o+16>>2]=39,i[o+20>>2]=-2147483608,k=l[22309]|l[22310]<<8|(l[22311]<<16|l[22312]<<24),n=l[22305]|l[22306]<<8|(l[22307]<<16|l[22308]<<24),u[f+31|0]=n,u[f+32|0]=n>>>8,u[f+33|0]=n>>>16,u[f+34|0]=n>>>24,u[f+35|0]=k,u[f+36|0]=k>>>8,u[f+37|0]=k>>>16,u[f+38|0]=k>>>24,k=l[22302]|l[22303]<<8|(l[22304]<<16|l[22305]<<24),n=l[22298]|l[22299]<<8|(l[22300]<<16|l[22301]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[22294]|l[22295]<<8|(l[22296]<<16|l[22297]<<24),n=l[22290]|l[22291]<<8|(l[22292]<<16|l[22293]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[22286]|l[22287]<<8|(l[22288]<<16|l[22289]<<24),n=l[22282]|l[22283]<<8|(l[22284]<<16|l[22285]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[22278]|l[22279]<<8|(l[22280]<<16|l[22281]<<24),n=l[22274]|l[22275]<<8|(l[22276]<<16|l[22277]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+39|0]=0,f=K(o+24|0,5,0,o+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;r:{if(u[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],u[s+20|0]=1;break r}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[s+20|0]=1,(k|0)>=0)break r;Z(i[f+8>>2])}if(u[o+23|0]<0&&Z(i[o+12>>2]),!t)break i}if(f=i[t+4>>2],i[t+4>>2]=f-1,f)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=o+48|0;i:{e:switch(l[w+36|0]){default:_2(),H();case 1:b0(A,w+16|0,i[e+8>>2]);break i;case 0:break e}e:{if(!r)break e;i[w+8>>2]=i[w+24>>2],i[w+24>>2]=0,e=i[w+20>>2],i[w>>2]=i[w+16>>2],i[w+4>>2]=e,i[w+16>>2]=0,i[w+20>>2]=0,t=u[w+11|0],s=(t|0)<0,f=s?i[w+4>>2]:t,k=E(f+1|0),o=k,e=f,h=i[w>>2],s=s?h:w;r:{f:{A:{k:{if((s^k)&3)break k;n=(f|0)!=0;n:{if(!(s&3)|!f)break n;for(;;){if(n=l[s|0],u[o|0]=n,!n)break r;if(o=o+1|0,e=e-1|0,n=(e|0)!=0,s=s+1|0,!(s&3))break n;if(!e)break}}if(!n)break f;if(!l[s|0])break r;if(e>>>0<4)break k;for(;;){if(n=i[s>>2],((16843008-n|n)&-2139062144)!=-2139062144)break A;if(i[o>>2]=n,o=o+4|0,s=s+4|0,e=e-4|0,!(e>>>0>3))break}}if(!e)break f}for(;;){if(n=l[s|0],u[o|0]=n,!n)break r;if(o=o+1|0,s=s+1|0,e=e-1|0,!e)break}}e=0}if(Ae(o,0,e),u[f+k|0]=0,i[r>>2]=k,(t|0)>=0)break e;Z(h)}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}A=l[w+36|0],(A|0)!=255&&(e=i[24205],i[w>>2]=i[24204],i[w+4>>2]=e,X[i[w+(A<<2)>>2]](w+47|0,w+16|0)),v=w+48|0}function vB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0;h=v-112|0,v=h;i:{if(!(n&&r)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(!(k&&f)){if(u[h+4|0]=0,u[h+15|0]=0,r=A,A=K(h+48|0,5,2006,h+4|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+15|0]>=0)break i;Z(i[h+4>>2]);break i}y=D6();e:{if(!t||(Sr(y,t),i[y+4>>2])||!S4(i[i[r>>2]>>2]))break e;w=i[i[r>>2]>>2],t=F[w+6>>1]|F[w+8>>1]<<16,w=F[w+10>>1]|F[w+12>>1]<<16,i[y+4>>2]=h+48,i[h+56>>2]=t>>>16,i[h+52>>2]=t&65535,u[h+48|0]=1,u[h+64|0]=w>>>16&1,i[h+60>>2]=w&65535}if(t=0,i[h+44>>2]=0,i[h+36>>2]=0,i[h+40>>2]=0,w=G(f,k),w)for(;r2(h+36|0,i[(t<<2)+r>>2]),t=t+1|0,(w|0)!=(t|0););i[h+28>>2]=0,i[h+32>>2]=0,R=i[e>>2],s=v-112|0,v=s,r=o8(i[i[h+36>>2]>>2],10),m=G(l8(i[i[h+36>>2]>>2],10),k),t=G(r,f),w=m|t,W=w>>>0>65535,r=W?12:8,_=E(r),i[s+88>>2]=_,B=r+_|0,i[s+96>>2]=B,r&&o0(_,0,r),i[s+92>>2]=B,u[_+3|0]=f-1,u[_+2|0]=k-1,u[_+1|0]=W,u[_|0]=0;e:{if(w>>>0>=65536){r=m<<24|(m&65280)<<8|(m>>>8&65280|m>>>24),u[_+8|0]=r,u[_+9|0]=r>>>8,u[_+10|0]=r>>>16,u[_+11|0]=r>>>24,B=t>>>24|0,r=t,w=r>>>16|0;break e}B=t>>>8|0,r=m,w=t}u[_+7|0]=r,u[_+5|0]=w,u[_+4|0]=B,u[_+6|0]=r>>>8,x=i[R+48>>2],I=i[R+52>>2],I&&(i[I+4>>2]=i[I+4>>2]+1),C=h+4|0,_=n,i[s+84>>2]=0,i[s+76>>2]=0,i[s+80>>2]=0,r=0,n=0;e:{r:{f:{A:{a=G(f,k);k:{if(a)for(S=C+8|0,W=i[25344],f0=i[25345],k=0;;){Oi(s+48|0,R,i[h+36>>2]+(k<<3)|0,_,y,1),L=l[s+68|0];n:{if(L){if((L|0)!=1)break A;f=i[s+52>>2],i[C>>2]=i[s+48>>2],i[C+4>>2]=f;t:{if(u[s+67|0]>=0){f=i[s+60>>2],i[S>>2]=i[s+56>>2],i[S+4>>2]=f,i[S+8>>2]=i[s+64>>2];break t}T(S,i[s+56>>2],i[s+60>>2])}u[C+20|0]=1,B=0;break n}B=i[s+52>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),O=i[s+48>>2],s4(s+104|0,x,i[O+116>>2]),f=i[s+104>>2],u[f+164|0]=1,i[f+100>>2]=i[f+100>>2]&-2|1,f=i[s+108>>2];t:{if(!f||(w=i[f+4>>2],i[f+4>>2]=w-1,w))break t;X[i[i[f>>2]+8>>2]](f),p(f)}N=i[O+116>>2],f=i[s+80>>2],g=i[s+84>>2];t:{if(f>>>0<g>>>0){i[f>>2]=N,f=f+4|0;break t}if(D=i[s+76>>2],f=f-D|0,$=f>>2,w=$+1|0,w>>>0>=1073741824)break f;if(g=g-D|0,V=g>>1,g=g>>>0>=2147483644?1073741823:w>>>0<V>>>0?V:w,g){if(g>>>0>=1073741824)break r;w=E(g<<2)}else w=0;if(V=w+f|0,i[V>>2]=N,N=V-($<<2)|0,f&&z(N,D,f),i[s+84>>2]=w+(g<<2),f=V+4|0,i[s+80>>2]=f,i[s+76>>2]=N,!D)break t;Z(D)}if(i[s+80>>2]=f,r)break n;f=i[O+104>>2],w=i[O+108>>2];t:{if((f|0)!=(w|0))for(;;){u:{if(r=i[f>>2],!r||(r=X0(r,86628,88900),!r))break u;if(f=i[f+4>>2],!f){f=0;break t}i[f+4>>2]=i[f+4>>2]+1;break t}if(f=f+8|0,(w|0)==(f|0))break}f=0,r=0}t:{if(!n||(w=i[n+4>>2],i[n+4>>2]=w-1,w))break t;X[i[i[n>>2]+8>>2]](n),p(n)}n=f}f=l[s+68|0],(f|0)!=255&&(i[s+104>>2]=W,i[s+108>>2]=f0,X[i[(s+104|0)+(f<<2)>>2]](s+103|0,s+48|0));n:{if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break n;X[i[i[B>>2]+8>>2]](B),p(B)}if(L)break k;if(k=k+1|0,(a|0)==(k|0))break}w=$A(x,1735551332),k=E(496),i[k>>2]=101064,f=k,i[f+4>>2]=0,i[f+8>>2]=0,_=Y4(f+16|0,R,w),i[_>>2]=101224,i[f+488>>2]=0,i[f+480>>2]=0,i[f+484>>2]=0,i[f+472>>2]=0,i[f+476>>2]=0,i[f+464>>2]=0,i[f+468>>2]=0,A0=f,n0=D6(),i[A0+488>>2]=n0,i[s+52>>2]=f,i[s+48>>2]=_,i[f+4>>2]=i[f+4>>2]+1,Dr(R,w,s+48|0),f=i[s+52>>2];n:{if(!f||(W=i[f+4>>2],i[f+4>>2]=W-1,W))break n;X[i[i[f>>2]+8>>2]](f),p(f)}if(K8(x,w,s+88|0,1),a4(x,w,1684630887,s+76|0),w=E(128),i[w>>2]=90172,i[w+4>>2]=0,i[w+8>>2]=0,W=w+16|0,f=W,i[f+8>>2]=0,i[f+12>>2]=0,f=w,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,Q[f+112>>1]=0,i[f+16>>2]=87652,i[f+124>>2]=m,i[f+120>>2]=t,i[f+32>>2]=1769173093,i[s+44>>2]=f,i[s+40>>2]=W,i[f+4>>2]=i[f+4>>2]+1,f=i[s+44>>2],i[s+16>>2]=i[s+40>>2],i[s+20>>2]=f,D4(_,s+16|0,0),i[s+36>>2]=n,i[s+32>>2]=r,n&&(i[n+4>>2]=i[n+4>>2]+1),r=i[s+36>>2],i[s+8>>2]=i[s+32>>2],i[s+12>>2]=r,D4(_,s+8|0,1),Gf(s+48|0,i[i[h+36>>2]>>2],1),f=i[s+48>>2],t=i[s+52>>2],(f|0)!=(t|0)){for(;i[s+24>>2]=i[f>>2],r=i[f+4>>2],i[s+28>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),m=i[f>>2],r=i[m+16>>2]==1769173093,m=r?_:m,r=X[i[i[m>>2]+(r?48:40)>>2]](m)|0,m=i[s+28>>2],i[s>>2]=i[s+24>>2],i[s+4>>2]=m,D4(_,s,r),f=f+8|0,(t|0)!=(f|0););f=i[s+48>>2]}if(u[C+20|0]=0,i[C+4>>2]=k,i[C>>2]=_,f){if(k=f,B=i[s+52>>2],(B|0)!=(f|0)){for(;;){r=i[B-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;X[i[i[r>>2]+8>>2]](r),p(r)}if(B=B-8|0,(B|0)==(f|0))break}k=i[s+48>>2]}i[s+52>>2]=f,Z(k)}if(r=i[w+4>>2],i[w+4>>2]=r-1,r)break k;X[i[i[w>>2]+8>>2]](w),p(w)}k:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break k;X[i[i[n>>2]+8>>2]](n),p(n)}r=i[s+76>>2],r&&(i[s+80>>2]=r,Z(r));k:{if(!I||(r=i[I+4>>2],i[I+4>>2]=r-1,r))break k;X[i[i[I>>2]+8>>2]](I),p(I)}r=i[s+88>>2],r&&(i[s+92>>2]=r,Z(r)),v=s+112|0;break e}_2(),H()}G0(),H()}x0(),H()}z2(y);e:{r:switch(l[h+24|0]){default:_2(),H();case 1:b0(A,h+4|0,i[e>>2]);break e;case 0:break r}f=i[h+4>>2],r=i[h+8>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+32>>2]=r,i[h+28>>2]=f,r=i[e>>2],i[r+40>>2]||zf(r,h+28|0);r:{if(!o)break r;if(r=E(16),i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,f=i[h+28>>2],k=i[h+32>>2],i[h+28>>2]=0,i[h+32>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}A=l[h+24|0],(A|0)!=255&&(e=i[24249],i[h+104>>2]=i[24248],i[h+108>>2]=e,X[i[(h+104|0)+(A<<2)>>2]](h+103|0,h+4|0)),A=i[h+32>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[h+36>>2],!A)break i;if(r=A,t=i[h+40>>2],(r|0)!=(t|0)){for(;;){e=i[t-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(A|0)==(t|0))break}r=i[h+36>>2]}i[h+40>>2]=A,Z(r)}v=h+112|0}function L7(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;if(h=v-128|0,v=h,e){i:{for(;;){e:{r:{f:{A:{w=l[r|0];k:{if((w|0)!=37){if(w)break k;n=_;break i}t=0,o=1;n:switch(n=l[r+1|0],n-45|0){case 0:case 3:break A;case 1:case 2:break f;default:break n}if((n|0)==95)break A;if(n)break f}u[A+_|0]=w,_=_+1|0;break r}t=n,n=l[r+2|0],o=2}V=0,x=n,w=(r+o|0)+((n|0)==43)|0;f:{if(u[w|0]-48>>>0<=9){r=b6(w,h+12|0,10,-1,0),o=i[h+12>>2];break f}i[h+12>>2]=w,r=0,o=w}n=l[o|0],s=n-67|0;f:{if(s>>>0>22|!(1<<s&4194329)||(V=r,r))break f;V=(o|0)!=(w|0)}(n|0)==79|(n|0)==69?(n=l[o+1|0],r=o+1|0):r=o,w=h+16|0,N=t,t=0,m=v-80|0,v=m,B=1757,D=48,W=131112;f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{W:{X:{C:{I:{F:{Q:{V:{p:{M:{U:{D:{J:{E:{y:{$:{Y:{H:{x:{z:{T:{R:{S:{j:{O:{L:{P:{q:{K:{_0:switch(g=n<<24>>24,g-37|0){case 0:break B;case 28:break K;case 29:break P;case 30:break L;case 31:break o;case 33:break S;case 34:case 66:break R;case 35:break T;case 36:break z;case 40:break Y;case 45:break E;case 46:break D;case 47:break M;case 48:break V;case 49:break F;case 50:break Q;case 51:break W;case 52:break G;case 53:break v;case 60:break _0;case 61:case 67:break q;case 62:break l;case 63:break j;case 64:break O;case 69:break x;case 72:break H;case 73:break $;case 75:break y;case 77:break s;case 78:break J;case 79:break U;case 80:break p;case 82:break I;case 83:break X;case 84:break m;case 85:break Z;default:break f}if(n=i[f+24>>2],n>>>0<=6)break _;break k}if(n=i[f+24>>2],n>>>0>6)break k;t=n+131079|0;break w}if(n=i[f+16>>2],n>>>0>11)break k;t=n+131086|0;break w}if(n=i[f+16>>2],n>>>0>11)break k;t=n+131098|0;break w}n=i[f+20>>2],t=n>>31,n=n+1900|0,t=n>>>0<1900?t+1|0:t,n=G2(n,t,100,0),o=l0;break u}D=95}n=i[f+12>>2],o=n>>31;break u}B=17902;break o}s=i[f+20>>2],t=s>>31,n=s+1900|0,o=n>>>0<1900?t+1|0:t,W=i[f+28>>2];R:{if((W|0)<=2){s=s+1899|0,t=s>>>0<1899?t+1|0:t,I=s,s=(ZA(f)|0)==1,n=s?n:I,o=s?o:t;break R}if(W>>>0<361)break R;s=s+1901|0,t=s>>>0<1901?t+1|0:t,I=s,s=(ZA(f)|0)==1,n=s?I:n,o=s?t:o}if((g|0)==103)break h;break t}n=i[f+8>>2],o=n>>31;break u}if(t=2,o=i[f+8>>2],!o){n=12,o=0;break n}g=(o|0)>12,n=g?o-12|0:o,s=o>>31,o=g?s-(o>>>0<12)|0:s;break n}n=i[f+28>>2]+1|0,o=n>>31,t=3;break n}n=i[f+16>>2]+1|0,o=n>>31;break u}n=i[f+4>>2],o=n>>31;break u}i[h+124>>2]=1,t=42713;break f}t=i[f+8>>2]>11?131111:131110;break w}B=19446;break o}W=0,y=0,R=v-16|0,v=R,n=i[f+20>>2],o=n>>31,B=i[f+16>>2],B>>>0>=12&&(s=(B|0)/12|0,t=B-G(s,12)|0,B=(t|0)<0?t+12|0:t,t=s+(t>>31)|0,o=o+(t>>31)|0,s=n,n=n+t|0,o=s>>>0>n>>>0?o+1|0:o),s=R+12|0;J:{if((n>>>0<2|0)==(o|0)&n-2>>>0<=136){t=n-68>>2;E:{y:{if(!(n&3)){if(t=t-1|0,!s)break E;o=1;break y}if(!s)break E;o=0}i[s>>2]=o}n=(G(n,31536e3)+G(t,86400)|0)+2087447296|0,t=n>>31;break J}t=n-100|0,g=t,n=o-(n>>>0<100)|0,I=n,n=G2(t,n,400,0),C=O0(n,l0,400,0),o=t-C|0,t=I-(l0+(t>>>0<C>>>0)|0)|0,C=n+(t>>31)|0;E:{y:{$:{if(n=(t|0)<0?o+400|0:o,n){Y:{if((n|0)>=200){if(n>>>0>=300){W=3,n=n-300|0;break Y}W=2,n=n-200|0;break Y}W=(n|0)>99,n=W?n-100|0:n}if(n)break $;t=0}else t=1;if(s)break y;break E}if(y=n>>>2|0,t=!(n&3),!s)break E}i[s>>2]=t}o=O0(g,I,31536e3,0),s=l0,g=o,n=((G(W,24)+G(C,97)|0)+y|0)-t|0,o=O0(n,n>>31,86400,0),n=g+o|0,t=l0+s|0,t=n>>>0<o>>>0?t+1|0:t,n=n+946771200|0,t=n>>>0<946771200?t+1|0:t}y=i[f+12>>2],s=i[f+8>>2],I=s>>31,g=i[f+4>>2],C=g>>31,v=R+16|0,o=i[f>>2],W=o,S=o>>31,o=i[(B<<2)+74288>>2],B=(B|0)>1&&i[R+12>>2]?o+86400|0:o,o=(B>>31)+t|0,t=n+B|0,o=t>>>0<B>>>0?o+1|0:o,n=y-1|0,B=O0(n,n>>31,86400,0),n=B+t|0,t=l0+o|0,t=n>>>0<B>>>0?t+1|0:t,o=O0(s,I,3600,0),n=o+n|0,t=l0+t|0,t=n>>>0<o>>>0?t+1|0:t,o=O0(g,C,60,0),n=o+n|0,t=l0+t|0,o=(n>>>0<o>>>0?t+1|0:t)+S|0,t=n+W|0,o=t>>>0<n>>>0?o+1|0:o,s=i[f+36>>2],n=t-s|0,o=o-((s>>31)+(t>>>0<s>>>0)|0)|0;break C}n=i[f>>2],o=n>>31;break u}i[h+124>>2]=1,t=42715;break f}B=19387;break o}n=i[f+24>>2],n=n||7,o=n>>31;break C}n=((i[f+28>>2]-i[f+24>>2]|0)+7>>>0)/7|0,o=0;break u}n=((i[f+28>>2]-((i[f+24>>2]+6>>>0)%7|0)|0)+7>>>0)/7|0,o=0;break u}n=ZA(f),o=0;break u}n=i[f+24>>2],o=n>>31}t=1;break n}W=131113;break l}W=131114;break l}n=i[f+20>>2],t=n>>31,n=n+1900|0,t=n>>>0<1900?t+1|0:t,t=ul(n,t),n=l0,g=n,o=t,t=n>>31,s=o^t,n=s-t|0,o=(t^g)-((t>>>0>s>>>0)+t|0)|0;break u}if(n=i[f+20>>2],o=n>>31,s=n,t=o,n=n+1900|0,o=n>>>0<1900?t+1|0:t,s>>>0<8100&(t|0)<=0|(t|0)<0)break t;i[m+48>>2]=n,i[m+52>>2]=o,O=h,L=a8(w,100,15873,m+48|0),i[O+124>>2]=L,t=w;break f}if(i[f+32>>2]<0){i[h+124>>2]=0,t=42716;break f}n=i[f+36>>2],t=(n|0)/3600|0,i[m+64>>2]=G(t,100)+((n-G(t,3600)<<16>>16)/60<<16>>16),O=h,L=a8(w,100,15879,m- -64|0),i[O+124>>2]=L,t=w;break f}if(i[f+32>>2]<0){i[h+124>>2]=0,t=42716;break f}t=i[f+40>>2],u[129316]&1||(V_(129272,129276,129328,129360),i[32321]=129360,i[32320]=129328,u[129316]=1);break A}i[h+124>>2]=1,t=27464;break f}n=ul(n,o),o=l0;break u}t=n|131072}t=mu(t,k);break A}W=131115}B=mu(W,k)}n=L7(w,100,B,f,k),i[h+124>>2]=n,t=n?w:0;break f}t=2;break n}t=4}n:{if(s=N||D,(s|0)!=95){if((s|0)!=45)break n;i[m+16>>2]=n,i[m+20>>2]=o,O=h,L=a8(w,100,15874,m+16|0),i[O+124>>2]=L,t=w;break f}i[m+40>>2]=n,i[m+44>>2]=o,i[m+32>>2]=t,O=h,L=a8(w,100,15867,m+32|0),i[O+124>>2]=L,t=w;break f}i[m+8>>2]=n,i[m+12>>2]=o,i[m>>2]=t,O=h,L=a8(w,100,15860,m),i[O+124>>2]=L,t=w;break f}t=26340}O=h,L=h2(t),i[O+124>>2]=L}if(v=m+80|0,!t)break e;f:{if(!V){o=i[h+124>>2];break f}A:{k:{n:switch(n=l[t|0],n-43|0){case 0:case 2:break k;default:break n}o=i[h+124>>2];break A}n=l[t+1|0],t=t+1|0,o=i[h+124>>2]-1|0}A:{if((n&255)!=48)break A;for(;;){if(n=u[t+1|0],n-48>>>0>9)break A;if(t=t+1|0,o=o-1|0,(n|0)!=48)break}}for(i[h+124>>2]=o,n=0;w=n,n=n+1|0,u[t+w|0]-48>>>0<10;);n=o>>>0<V>>>0?V:o,s=A+_|0;A:{if(i[f+20>>2]<-1900)w=45;else{if((x|0)!=43|w+(n-o|0)>>>0<(l[i[h+12>>2]]==67?3:5)>>>0)break A;w=43}u[s|0]=w,n=n-1|0,_=_+1|0}if(n>>>0<=o>>>0|e>>>0<=_>>>0)break f;for(;;){if(u[A+_|0]=48,_=_+1|0,n=n-1|0,o>>>0>=n>>>0)break f;if(!(e>>>0>_>>>0))break}}n=e-_|0,n=n>>>0>o>>>0?o:n,i[h+124>>2]=n,A8(A+_|0,t,n),_=i[h+124>>2]+_|0}if(r=r+1|0,e>>>0>_>>>0)continue}break}_=(e|0)==(_|0)?e-1|0:_,n=0}u[A+_|0]=0}return v=h+128|0,n}function mB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;if(k=v-80|0,v=k,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,u[k+55|0]=0,u[k+56|0]=0,u[k+57|0]=0,u[k+58|0]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+60>>2]=0,i[k+64>>2]=0,i[k+72>>2]=0,u[k+68|0]=1,w=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+28>>2]=e,i[k+24>>2]=w,e=k+12|0,X[i[i[f>>2]+100>>2]](e,i[f+4>>2],k+24|0,n),X[i[i[f>>2]+104>>2]](e,i[f+4>>2],k+8|0,k+4|0,0),e=i[k+8>>2],e)for(;Me(k+32|0,e,i[k+4>>2]),X[i[i[f>>2]+104>>2]](k+12|0,i[f+4>>2],k+8|0,k+4|0,0),e=i[k+8>>2],!!e;);w=E(120),i[w>>2]=91892,i[w+4>>2]=0,i[w+8>>2]=0,h=w+16|0,e=h,i[e+8>>2]=0,i[e+12>>2]=0,e=w,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=99464,i[e+32>>2]=1781689160,t=E(128),i[t>>2]=91932,i[t+4>>2]=0,i[t+8>>2]=0,_=t+16|0,e=_,i[e+8>>2]=0,i[e+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86404,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,u[t+112|0]=0,i[t+16>>2]=99144,i[t+124>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[t+32>>2]=1667523942;i:{e:{r:{f:{A:{k:{n:{t:switch(i[i[r>>2]+116>>2]){case 1:f=i[t+124>>2],e=i[t+120>>2];u:{if(f>>>0>e>>>0){Q[e+4>>1]=1,Q[e>>1]=0,Q[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[t+116>>2],n=r-e|0,o=((n|0)/6|0)+1|0,o>>>0>=715827883)break n;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:o>>>0<s>>>0?s:o,f){if(f>>>0>=715827883)break k;r=E(G(f,6))}if(o=r+n|0,Q[o+4>>1]=1,Q[o>>1]=0,Q[o+2>>1]=0,s=o+G((n|0)/-6|0,6)|0,n&&z(s,e,n),f=G(f,6)+r|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!e)break u;Z(e),f=i[t+124>>2]}i[t+120>>2]=r;u:{if(r>>>0<f>>>0){Q[r+4>>1]=2,Q[r>>1]=1,Q[r+2>>1]=0,r=r+6|0;break u}if(n=i[t+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break n;if(f=(f-n|0)/6|0,o=f<<1,f=f>>>0>=357913941?715827882:r>>>0<o>>>0?o:r,f){if(f>>>0>=715827883)break k;r=E(G(f,6))}else r=0;if(o=r+e|0,Q[o+4>>1]=2,Q[o>>1]=1,Q[o+2>>1]=0,s=o+G((e|0)/-6|0,6)|0,e&&z(s,n,e),f=r+G(f,6)|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!n)break u;Z(n),f=i[t+124>>2]}if(i[t+120>>2]=r,r>>>0<f>>>0)break r;if(e=r,r=i[t+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break n;if(f=(f-r|0)/6|0,o=f<<1,n=f>>>0>=357913941?715827882:n>>>0<o>>>0?o:n,n){if(n>>>0>=715827883)break k;f=E(G(n,6))}else f=0;o=e+f|0,Q[o+4>>1]=3;break e;case 0:f=i[t+124>>2],e=i[t+120>>2];u:{if(f>>>0>e>>>0){Q[e+4>>1]=1,Q[e>>1]=0,Q[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[t+116>>2],n=r-e|0,o=((n|0)/6|0)+1|0,o>>>0>=715827883)break A;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:o>>>0<s>>>0?s:o,f){if(f>>>0>=715827883)break k;r=E(G(f,6))}if(o=r+n|0,Q[o+4>>1]=1,Q[o>>1]=0,Q[o+2>>1]=0,s=o+G((n|0)/-6|0,6)|0,n&&z(s,e,n),f=G(f,6)+r|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!e)break u;Z(e),f=i[t+124>>2]}i[t+120>>2]=r;u:{if(r>>>0<f>>>0){Q[r+4>>1]=2,Q[r>>1]=1,Q[r+2>>1]=0,r=r+6|0;break u}if(n=i[t+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break A;if(f=(f-n|0)/6|0,o=f<<1,f=f>>>0>=357913941?715827882:r>>>0<o>>>0?o:r,f){if(f>>>0>=715827883)break k;r=E(G(f,6))}else r=0;if(o=r+e|0,Q[o+4>>1]=2,Q[o>>1]=1,Q[o+2>>1]=0,s=o+G((e|0)/-6|0,6)|0,e&&z(s,n,e),f=r+G(f,6)|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!n)break u;Z(n),f=i[t+124>>2]}if(i[t+120>>2]=r,r>>>0<f>>>0)break r;if(e=r,r=i[t+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break A;if(f=(f-r|0)/6|0,o=f<<1,n=f>>>0>=357913941?715827882:n>>>0<o>>>0?o:n,n){if(n>>>0>=715827883)break k;f=E(G(n,6))}else f=0;o=e+f|0,Q[o+4>>1]=3;break e;case 2:break t;default:break i}e=i[t+120>>2],o=i[t+124>>2];t:{if(e>>>0<o>>>0){Q[e+4>>1]=1,Q[e>>1]=0,Q[e+2>>1]=0,f=e+6|0;break t}if(r=e,e=i[t+116>>2],r=r-e|0,f=((r|0)/6|0)+1|0,f>>>0>=715827883)break f;if(n=0,o=(o-e|0)/6|0,s=o<<1,o=o>>>0>=357913941?715827882:f>>>0<s>>>0?s:f,o){if(o>>>0>=715827883)break k;n=E(G(o,6))}if(f=r+n|0,Q[f+4>>1]=1,Q[f>>1]=0,Q[f+2>>1]=0,s=f+G((r|0)/-6|0,6)|0,r&&z(s,e,r),i[t+124>>2]=G(o,6)+n,f=f+6|0,i[t+120>>2]=f,i[t+116>>2]=s,!e)break t;Z(e)}i[t+120>>2]=f;break i}G0(),H()}x0(),H()}G0(),H()}G0(),H()}Q[r+4>>1]=3,Q[r>>1]=2,Q[r+2>>1]=0,i[t+120>>2]=r+6;break i}Q[o>>1]=2,Q[o+2>>1]=0,s=G((e|0)/-6|0,6)+o|0,e&&z(s,r,e),i[t+124>>2]=G(n,6)+f,e=o+6|0,i[t+120>>2]=e,i[t+116>>2]=s,r&&Z(r),i[t+120>>2]=e}i[k+16>>2]=t,i[k+12>>2]=_,i[t+4>>2]=i[t+4>>2]+1,r2(w+52|0,k+12|0),e=i[k+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}i[w+4>>2]=i[w+4>>2]+1;i:{e:{r=i[k+40>>2],e=i[k+36>>2];r:{if(r>>>0>e>>>0){i[e+4>>2]=w,i[e>>2]=h,n=e+8|0;break r}if(f=i[k+32>>2],n=e-f|0,s=n>>3,e=s+1|0,e>>>0>=536870912)break e;if(r=r-f|0,o=r>>2,r=r>>>0>=2147483640?536870911:e>>>0<o>>>0?o:e,r){if(r>>>0>=536870912)break i;e=E(r<<3)}else e=0;if(o=e+n|0,i[o+4>>2]=w,i[o>>2]=h,h=o-(s<<3)|0,n&&z(h,f,n),r=e+(r<<3)|0,i[k+40>>2]=r,n=o+8|0,i[k+36>>2]=n,i[k+32>>2]=h,!f)break r;Z(f),r=i[k+40>>2]}u[k+58|0]=0,Q[k+56>>1]=1,e=i[k+32>>2],i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,f=i[k+52>>2],i[k+52>>2]=0,o=i[k+44>>2],h=i[k+48>>2],i[k+44>>2]=0,i[k+48>>2]=0,i[A+20>>2]=f,i[A+12>>2]=o,i[A+16>>2]=h,i[A+8>>2]=r,i[A+4>>2]=n,i[A>>2]=e,e=i[k+60>>2],i[A+24>>2]=i[k+56>>2],i[A+28>>2]=e,e=k- -64|0,r=i[e+4>>2],i[A+32>>2]=i[e>>2],i[A+36>>2]=r,i[A+40>>2]=i[k+72>>2],u[A+44|0]=0,A=i[t+4>>2],i[t+4>>2]=A-1,A||(X[i[i[t>>2]+8>>2]](t),p(t)),A=i[w+4>>2],i[w+4>>2]=A-1,A||(X[i[i[w>>2]+8>>2]](w),p(w)),A=i[k+28>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[k+44>>2],A&&(i[k+48>>2]=A,Z(A)),A=i[k+32>>2],A){if(e=A,f=i[k+36>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[k+32>>2]}i[k+36>>2]=A,Z(e)}v=k+80|0;return}G0(),H()}x0(),H()}function ZB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),O=u1(i[r>>2],6),O&&(f0=j0(i[r>>2],6));i:{if(!(!(k>>>0<9|n>>>0<9)&t>>>0>8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],W=i[e+112>>2],g=i[e+108>>2],V=E(172),i[V>>2]=94860,e=V,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),_=i[e+4>>2],B=_+1|0,i[e+4>>2]=B,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=_,_=i[e+8>>2],I=e+12|0,i[e+96>>2]=I,i[e+8>>2]=_+1,i[e+100>>2]=e,B||(X[i[i[e>>2]+8>>2]](e),p(e)),i[I+120>>2]=1,i[I+116>>2]=0,i[I+112>>2]=W,i[I+108>>2]=g,T0(s+56|0,I,0,g,W,k,o),w=g+1>>>1|0,R=W+1>>>1|0,T0(s+32|0,I,1,w,R,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,I,2,w,R,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!O)break r;if(T0(s+104|0,I,6,g,W,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>0))break k;n0=i[e+44>>2],r=i[e+56>>2]}for(h0=r,e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(k|0)||(o=0,i[e+16>>2]>1))break k;m=i[e+56>>2],o=i[e+44>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}_=0;break r}if(_=0,i[e+16>>2]>2)break r;x=i[e+56>>2]>>>1|0,_=i[e+44>>2]}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;h=i[r+16>>2],n=(h|0)<0?n:r,r=i[(h>>>29&4)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],r=i[n+56>>2]}for(W0=r,n=f,r=e;h=i[r+16>>2]<=0,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);h=0;A:{if((f|0)==(n|0)||(h=0,i[n+16>>2]>1))break A;y=i[n+56>>2],h=i[n+44>>2]}for(n=f,r=e;B=i[r+16>>2]<2,n=B?n:r,r=i[(B?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}B=0;break r}if(B=0,i[n+16>>2]>2)break r;L=i[n+56>>2]>>>1|0,B=i[n+44>>2]}n=0;r:{if(!O)break r;f:{A:{if(!t)break A;for(r=k;n=i[t+16>>2]<6,r=n?r:t,t=i[(n?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(k=0,i[r+16>>2]>6)break f;Q0=i[r+44>>2],k=i[r+56>>2];break f}k=0}if(V0=k,n=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(n=0,(r|0)==(f|0)||(n=0,i[r+16>>2]>6))break r;e0=i[r+56>>2],n=i[r+44>>2]}t=y>>>1|0,e=m>>>1|0;r:{f:{A:{k:{if(a=W&1,a){if(f=g-1|0,!f)break k;for(r=R-1|0,k=B+(G(r,L)<<1)|0,m=W-1|0,y=(G(m,x)<<1)+_|0,S=(G(r,t)<<1)+h|0,m=(G(e,m)<<1)+o|0,r=0;C=r<<1,N=C+m|0,Q[r+S>>1]=(F[N>>1]+F[N+2>>1]|0)+1>>>1,C=y+C|0,Q[r+k>>1]=(F[C>>1]+F[C+2>>1]|0)+1>>>1,r=r+2|0,f>>>0>r>>>0;);}if(g&1)break k;f=W-1|0;break A}if(k=w<<1,w=g<<1,f=W-1|0,f){for(S=(k+B|0)-2|0,m=(w+_|0)-2|0,C=(k+h|0)-2|0,y=(o+w|0)-2|0,r=0;N=r>>>1|0,D=r|1,Q[C+(G(N,t)<<1)>>1]=(F[y+(G(e,r)<<1)>>1]+F[y+(G(D,e)<<1)>>1]|0)+1>>>1,Q[S+(G(L,N)<<1)>>1]=(F[m+(G(r,x)<<1)>>1]+F[m+(G(x,D)<<1)>>1]|0)+1>>>1,r=r+2|0,f>>>0>r>>>0;);if(!a)break f}r=R-1|0,Q[(k+((G(r,t)<<1)+h|0)|0)-2>>1]=F[(w+((G(e,f)<<1)+o|0)|0)-2>>1],Q[(k+(B+(G(r,L)<<1)|0)|0)-2>>1]=F[(w+((G(f,x)<<1)+_|0)|0)-2>>1]}if(!f)break r}if(R=g-1|0,!R)break r;for(k=0;;){for(m=(G(k,x)<<1)+_|0,y=(G(e,k)<<1)+o|0,r=k>>>1|0,a=B+(G(r,L)<<1)|0,S=(G(r,t)<<1)+h|0,r=k|1,C=(G(r,x)<<1)+_|0,N=(G(e,r)<<1)+o|0,r=0;w=r<<1,D=w+C|0,r0=F[D+2>>1],D=F[D>>1],$=w+m|0,N0=F[$+2>>1],$=F[$>>1],A0=w+N|0,w=w+y|0,Q[r+S>>1]=((F[A0>>1]+(F[w>>1]+F[w+2>>1]|0)|0)+F[A0+2>>1]|0)+2>>>2,Q[r+a>>1]=((D+($+N0|0)|0)+r0|0)+2>>>2,r=r+2|0,R>>>0>r>>>0;);if(k=k+2|0,!(k>>>0<f>>>0))break}}if(W)for(k=W0>>>1|0,t=h0>>>1|0,e=g<<1,f=f0>>>0>8?e:g,r=0;e&&z((G(r,k)<<1)+m0|0,(G(r,t)<<1)+n0|0,e),!O|!f||z(G(r,e0)+n|0,G(r,V0)+Q0|0,f),r=r+1|0,(W|0)!=(r|0););u[A+20|0]=0,i[A+4>>2]=V,i[A>>2]=I;break i}if(A=i[V+4>>2],i[V+4>>2]=A-1,A)break i;X[i[i[V>>2]+8>>2]](V),p(V)}v=s+128|0}function GB(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-240|0,v=n;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(t=i[A+24>>2],i[t>>2]>=2){X[i[t+20>>2]](n+216|0,e,r,f,k,i[A+28>>2]),i[n+208>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,r=i[n+236>>2];l:{if(!r)break l;if(e=h2(r),e>>>0>=2147483640)break o;s:{w:{if(e>>>0>=11){o=e|7,t=E(o+1|0),i[n+56>>2]=o-2147483647,i[n+48>>2]=t,i[n+52>>2]=e;break w}if(u[n+59|0]=e,t=n+48|0,!e)break s}if(!e)break s;z(t,r,e)}if(u[e+t|0]=0,u[n+211|0]<0&&Z(i[n+200>>2]),i[n+208>>2]=i[n+56>>2],e=i[n+52>>2],i[n+200>>2]=i[n+48>>2],i[n+204>>2]=e,e=i[i[A+24>>2]+32>>2],!e)break l;X[e|0](i[n+236>>2])}l:switch(i[n+216>>2]){case 2:e=E(24),i[n+24>>2]=e,i[n+28>>2]=21,i[n+32>>2]=-2147483624,r=l[11636]|l[11637]<<8|(l[11638]<<16|l[11639]<<24),f=l[11632]|l[11633]<<8|(l[11634]<<16|l[11635]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[11631]|l[11632]<<8|(l[11633]<<16|l[11634]<<24),f=l[11627]|l[11628]<<8|(l[11629]<<16|l[11630]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[11623]|l[11624]<<8|(l[11625]<<16|l[11626]<<24),f=l[11619]|l[11620]<<8|(l[11621]<<16|l[11622]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,e=K(n+48|0,2,100,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+35|0]<0&&Z(i[n+24>>2]),f=i[n+224>>2],k=i[n+228>>2];break e;case 3:if(i[n+236>>2]){i[n+140>>2]=0,i[n+112>>2]=72244,i[n+56>>2]=72224,e=i[18065],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18066],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[18068],k=i[18064],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18069],i[n+112>>2]=72244,i[n+48>>2]=72204,i[n+56>>2]=72224,f=R0(f),i[f>>2]=71280,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,k=Y(S0(Y(r,27103,13),i[n+232>>2]),32770,4),e=u[n+211|0],r=(e|0)<0,Y(k,r?i[n+200>>2]:n+200|0,r?i[n+204>>2]:e),e=i[n+108>>2];s:{if(e&16){t=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,u[n+23|0]=0,t=n+12|0;break f}t=n+68|0,e=i[n+76>>2]}if(r=i[t>>2],e=e-r|0,e>>>0>=2147483640)break u;if(e>>>0>=11){k=e|7,t=E(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=t,i[n+16>>2]=e;break A}if(u[n+23|0]=e,t=n+12|0,e)break A;e=0;break f}i[n+140>>2]=0,i[n+112>>2]=72244,i[n+56>>2]=72224,e=i[18065],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18066],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[18068],k=i[18064],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18069],i[n+112>>2]=72244,i[n+48>>2]=72204,i[n+56>>2]=72224,f=R0(f),i[f>>2]=71280,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,Y(S0(Y(r,27103,13),i[n+232>>2]),26940,1),e=i[n+108>>2];s:{if(e&16){t=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,u[n+23|0]=0,t=n+12|0;break k}t=n+68|0,e=i[n+76>>2]}if(r=i[t>>2],e=e-r|0,e>>>0>=2147483640)break t;if(e>>>0>=11){k=e|7,t=E(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=t,i[n+16>>2]=e;break n}if(u[n+23|0]=e,t=n+12|0,e)break n;e=0;break k;case 0:break e;case 1:break r;default:break l}if(e=E(40),i[n+24>>2]=e,i[n+28>>2]=33,i[n+32>>2]=-2147483608,u[e+32|0]=l[12056],r=l[12052]|l[12053]<<8|(l[12054]<<16|l[12055]<<24),f=l[12048]|l[12049]<<8|(l[12050]<<16|l[12051]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12044]|l[12045]<<8|(l[12046]<<16|l[12047]<<24),f=l[12040]|l[12041]<<8|(l[12042]<<16|l[12043]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12036]|l[12037]<<8|(l[12038]<<16|l[12039]<<24),f=l[12032]|l[12033]<<8|(l[12034]<<16|l[12035]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[12028]|l[12029]<<8|(l[12030]<<16|l[12031]<<24),f=l[12024]|l[12025]<<8|(l[12026]<<16|l[12027]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+33|0]=0,e=K(n+48|0,2,0,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+35|0]>=0)break r;Z(i[n+24>>2]);break r}if(!(X[i[t+16>>2]](f,k,i[A+28>>2])|0))break i;if(e=X[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,r=l0,t=r,o=e+1|0,r=o?r:r+1|0,(f|0)==(o|0)&(r|0)==(k|0)){f=e,k=t;break i}for(r=f,o=k,f=e,k=t;t=k+o|0,s=r+f|0,t=s>>>0<r>>>0?t+1|0:t,s=(t&1)<<31|s>>>1,e=t>>>1|0,w=X[i[i[A+24>>2]+16>>2]](s,e,i[A+28>>2])|0,r=w?s:r,t=w?e:o,o=t,e=w?k:e,k=e,f=w?f:s,s=f+1|0,e=s?e:e+1|0,!!((r|0)!=(s|0)|(e|0)!=(t|0)););break i}g0(),H()}g0(),H()}g0(),H()}if(!e)break k;z(t,r,e)}u[e+t|0]=0,e=K(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+23|0]<0&&Z(i[n+12>>2]),A=i[18063],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18071],i[n+56>>2]=i[18072],i[f>>2]=71280,u[n+103|0]<0&&Z(i[n+92>>2]),y0(f),p0(n+112|0);break r}if(!e)break f;z(t,r,e)}u[e+t|0]=0,e=K(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+23|0]<0&&Z(i[n+12>>2]),A=i[18063],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18071],i[n+56>>2]=i[18072],i[f>>2]=71280,u[n+103|0]<0&&Z(i[n+92>>2]),y0(f),p0(n+112|0)}f=0,k=0}if(u[n+211|0]>=0)break i;Z(i[n+200>>2])}return v=n+240|0,l0=k,f|0}function vf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0,b1=0,G4=0,W4=0,X4=0;n=v+-64|0,v=n;i:{e:{h=i[A+276>>2],n2=(f|0)<(h|0)?f:h;r:{if((n2|0)<=(r|0)||(q0=i[A+272>>2],Z2=(k|0)<(q0|0)?k:q0,(Z2|0)<=0))break r;for(b2=e?1:2,e1=e?2:1,R=i[A+40>>2],g2=R<<1,Q2=i[A+124>>2],f=i[Q2+16832>>2],E2=f-8|0,O=-1<<f^-1,W1=e?4:3,m0=G(R,-6),W0=G(R,6),e0=R<<2,$0=0-e0|0,J1=R<<(e^1)<<3,x1=G(r,R)<<3,b1=i[A+260>>2],Q0=0-R<<1,L=R<<1,U0=0-L<<1;;){for(r0=r<<2,H2=r0-1|0,G4=G(R,r0),W4=G(T2,J1)+x1|0,X4=G(r0>>2,q0)+b1|0,P0=0,D0=0;;){s=D0<<2,f0=l[(s>>2)+X4|0]&3;f:{if(!f0)break f;f=i[A+4>>2],h=f+(s+G4<<1)|0;A:{if(!e){Q[n+32>>1]=F[h>>1],f=F[h+Q0>>1],Q[n>>1]=f,Q[n+34>>1]=F[h+L>>1],w=F[h+U0>>1],Q[n+2>>1]=w,_=L<<1,Q[n+36>>1]=F[_+h>>1],m=F[h+m0>>1],Q[n+4>>1]=m,Q[n+38>>1]=F[h+W0>>1],B=$0<<1,o=F[B+h>>1],Q[n+6>>1]=o,k=h+2|0,Q[n+40>>1]=F[k>>1],Q[n+8>>1]=F[k+Q0>>1],Q[n+42>>1]=F[k+L>>1],Q[n+10>>1]=F[k+U0>>1],Q[n+44>>1]=F[k+_>>1],Q[n+12>>1]=F[k+m0>>1],Q[n+46>>1]=F[k+W0>>1],Q[n+14>>1]=F[k+B>>1],k=h+4|0,Q[n+48>>1]=F[k>>1],Q[n+16>>1]=F[k+Q0>>1],Q[n+50>>1]=F[k+L>>1],Q[n+18>>1]=F[k+U0>>1],Q[n+52>>1]=F[k+_>>1],Q[n+20>>1]=F[k+m0>>1],Q[n+54>>1]=F[k+W0>>1],Q[n+22>>1]=F[k+B>>1],t=h+6|0,Q[n+56>>1]=F[t>>1],C=F[t+Q0>>1],Q[n+24>>1]=C,Q[n+58>>1]=F[t+L>>1],k=F[t+U0>>1],Q[n+26>>1]=k,Q[n+60>>1]=F[t+_>>1],_=F[t+m0>>1],Q[n+28>>1]=_,Q[n+62>>1]=F[t+W0>>1],t=t+B|0;break A}k=f+((P0<<W1)+W4|0)|0,f=F[k+4>>1]|F[k+6>>1]<<16,i[n+32>>2]=F[k>>1]|F[k+2>>1]<<16,i[n+36>>2]=f,f=F[h-2>>1],Q[n>>1]=f,w=F[h-4>>1],Q[n+2>>1]=w,m=F[h-6>>1],Q[n+4>>1]=m,o=F[h-8>>1],Q[n+6>>1]=o,t=k+g2|0,_=F[t+4>>1]|F[t+6>>1]<<16,i[n+40>>2]=F[t>>1]|F[t+2>>1]<<16,i[n+44>>2]=_,t=h+L|0,Q[n+8>>1]=F[t-2>>1],Q[n+10>>1]=F[t-4>>1],Q[n+12>>1]=F[t-6>>1],Q[n+14>>1]=F[t-8>>1],t=k+e0|0,_=F[t+4>>1]|F[t+6>>1]<<16,i[n+48>>2]=F[t>>1]|F[t+2>>1]<<16,i[n+52>>2]=_,t=h+e0|0,Q[n+16>>1]=F[t-2>>1],Q[n+18>>1]=F[t-4>>1],Q[n+20>>1]=F[t-6>>1],Q[n+22>>1]=F[t-8>>1],k=k+W0|0,t=F[k+4>>1]|F[k+6>>1]<<16,i[n+56>>2]=F[k>>1]|F[k+2>>1]<<16,i[n+60>>2]=t,t=h+W0|0,C=F[t-2>>1],Q[n+24>>1]=C,k=F[t-4>>1],Q[n+26>>1]=k,_=F[t-6>>1],Q[n+28>>1]=_,t=t-8|0}if(H0=F[t>>1],Q[n+30>>1]=H0,B=i[A+168>>2],y=s>>B,(y|0)<0||(t=i[A+172>>2],(t|0)<=(y|0)))break i;if(N=r0>>B,(N|0)<0||(S=i[A+176>>2],(S|0)<=(N|0)))break e;W=G(y,3),y=i[A+160>>2],D=W+y|0,N=G(G(t,N),3),a=D+N|0,d0=u[a+2|0];A:{if(!e){if(W=H2>>B,(W|0)<0|(W|0)>=(S|0))break e;W=(D+G(G(t,W),3)|0)+2|0;break A}if(W=s-1>>B,(W|0)<0|t>>>0<=W>>>0)break i;W=(N+(y+G(W,3)|0)|0)+2|0}if(g=i[A+148>>2],I=s>>g,(I|0)<0||(L0=i[A+152>>2],(L0|0)<=(I|0)))break i;if(g=r0>>g,(g|0)<0|(g|0)>=i[A+156>>2])break e;if(V0=F[n+56>>1],A0=V0+(F[n+60>>1]-(F[n+58>>1]<<1)|0)|0,n0=A0>>31,C=C&65535,h0=C+(_-((k&65535)<<1)|0)|0,k=h0>>31,N0=F[n+32>>1],V=N0+(F[n+36>>1]-(F[n+34>>1]<<1)|0)|0,_=V>>31,m=(m-(w<<1)|0)+f|0,w=m>>31,n0=(n0^A0)-n0|0,A0=(k^h0)-k|0,h0=n0+A0|0,V=(_^V)-_|0,x=(w^m)-w|0,$=V+x|0,_=(d0+u[W|0]|0)+1>>1,k=i[i[A+52>>2]+(F[((i[A+140>>2]+G(I,24)|0)+G(G(g,L0),24)|0)+2>>1]<<2)>>2],w=_+i[k+764>>2]|0,w=(w|0)>=51?51:w,m=l[((w|0)>0?w:0)+60752|0]<<E2,(h0+$|0)>=(m|0))break f;k=(i[k+768>>2]+(_+(f0<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,_=l[((k|0)>0?k:0)+60816|0]<<E2,w=0,I=m>>>2|0,k=0;A:{if(I>>>0<=$<<1>>>0||(g=N0-F[n+38>>1]|0,W=g>>31,f0=o-f|0,o=f0>>31,k=0,(W^g)-W+((o^f0)-o)>>>0>=m>>>3>>>0))break A;k=f-N0|0,f=k>>31,k=((f^k)-f|0)<G(_,5)+1>>1}f=k;A:{if(I>>>0<=h0<<1>>>0||(W=V0-F[n+62>>1]|0,k=W>>31,I=H0-C|0,o=I>>31,(k^W)-k+((o^I)-o)>>>0>=m>>>3>>>0))break A;w=C-V0|0,k=w>>31,w=((k^w)-k|0)<G(_,5)+1>>1}o=l[Q2+8812|0];A:{if(!e){if(s=H2>>B,o){if((s|0)<0|(s|0)>=(S|0))break e;k=!(l[(D+G(G(t,s),3)|0)+1|0]&4)}else k=1;if((s|0)<0|(s|0)>=(S|0))break e;t=D+G(G(t,s),3)|0;break A}if(s=s-1>>B,o){if((s|0)<0|t>>>0<=s>>>0)break i;k=!(l[(N+(y+G(s,3)|0)|0)+1|0]&4)}else k=1;if((s|0)<0|t>>>0<=s>>>0)break i;t=N+(y+G(s,3)|0)|0}for(N0=f&w,y=!(l[t+1|0]&8)&k,f=m+(m>>>1|0)>>>3|0,f0=y&f>>>0>x+A0>>>0,k=f>>>0>V+n0>>>0,f=l[a|0]|l[a+1|0]<<8,S=!(f&2048)&(!o|!(f&1024)),n0=k&S,t=_<<1,f=0,V0=0-_|0,H0=G(_,10),d0=h+2|0,L0=h-4|0,A0=h-2|0,a=_>>1,W=0-a|0,h0=h+L|0;;){w=f<<3,k=w+n|0,s=F[k+2>>1],o=w+(n+32|0)|0,D=F[o+4>>1],w=F[o+2>>1],B=F[o>>1],N=F[k+4>>1],m=F[k>>1];A:{if(!N0){if(k=(G(B-m|0,9)+G(w-s|0,-3)|0)+8>>4,o=k>>31,(H0|0)<=((k^o)-o|0))break A;o=(k|0)<(V0|0)?V0:(k|0)<(_|0)?k:_;k:{n:{if(!e){if(y&&(k=o+m|0,Q[h+(f-R<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!S)break k;k=B-o|0,C=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=f;break n}if(y&&(k=o+m|0,Q[A0+(G(f,R)<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!S)break k;k=B-o|0,C=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=G(f,R)}Q[(k<<1)+h>>1]=C}k:{if(!f0)break k;if(k=o+(((m+N|0)+1>>>1|0)-s|0)>>1,k=((k|0)<(W|0)?W:(k|0)<(a|0)?k:a)+s|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){Q[h+(f-g2<<1)>>1]=k;break k}Q[L0+(G(f,R)<<1)>>1]=k}if(!n0)break A;if(k=((B+D|0)+1>>>1)-(o+w)>>1,k=w+((k|0)<(W|0)?W:(k|0)<(a|0)?k:a)|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){Q[h0+(f<<1)>>1]=k;break A}Q[d0+(G(f,R)<<1)>>1]=k;break A}if(I=w-t|0,g=B+m|0,V=g+w|0,C=(V+D|0)+2>>>2|0,x=t+w|0,C=(C|0)<(I|0)?I:(C|0)<(x|0)?C:x,x=s-t|0,g=s+g|0,I=(g+N|0)+2>>>2|0,$=t+s|0,I=(I|0)<(x|0)?x:(I|0)<($|0)?I:$,x=D-t|0,o=((V+G(D,3)|0)+(F[o+6>>1]<<1)|0)+4>>>3|0,V=t+D|0,o=(o|0)<(x|0)?x:(o|0)<(V|0)?o:V,V=N-t|0,k=((g+G(N,3)|0)+(F[k+6>>1]<<1)|0)+4>>>3|0,g=t+N|0,g=(k|0)<(V|0)?V:(k|0)<(g|0)?k:g,V=B-t|0,$=B<<1,x=(m<<1)+4|0,k=D+(($+(x+s|0)|0)+(w<<1)|0)>>>3|0,B=t+B|0,B=(k|0)<(V|0)?V:(k|0)<(B|0)?k:B,D=m-t|0,k=w+($+((N+x|0)+(s<<1)|0)|0)>>>3|0,s=t+m|0,s=(k|0)<(D|0)?D:(k|0)<(s|0)?k:s,!e){if(k=h+(f<<1)|0,!y){if(!S)break A;Q[k>>1]=B,Q[k+L>>1]=C,Q[k+e0>>1]=o;break A}if(!S){Q[k+Q0>>1]=s,Q[k+$0>>1]=I,Q[k+m0>>1]=g;break A}Q[k+Q0>>1]=s,Q[k>>1]=B,Q[k+$0>>1]=I,Q[k+L>>1]=C,Q[k+m0>>1]=g,Q[k+e0>>1]=o;break A}if(k=h+(G(f,R)<<1)|0,y&&(Q[k-2>>1]=s),S&&(Q[k>>1]=B),y&&(Q[k-4>>1]=I),S&&(Q[k+2>>1]=C),y&&(Q[k-6>>1]=g),!S)break A;Q[k+4>>1]=o}if(f=f+1|0,(f|0)==4)break}}if(P0=P0+1|0,D0=D0+e1|0,!((Z2|0)>(D0|0)))break}if(T2=T2+1|0,r=r+b2|0,!((n2|0)>(r|0)))break}}v=n- -64|0;return}M0(4618,10893,119,4231),H()}M0(4656,10893,118,4231),H()}function WB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),S=u1(i[r>>2],6),S&&($=j0(i[r>>2],6));i:{if(!(!(k>>>0<9|n>>>0<9)&t>>>0>8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],h=i[e+112>>2],_=i[e+108>>2],V=E(172),i[V>>2]=94860,e=V,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],w=m+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],I=e+12|0,i[e+96>>2]=I,i[e+8>>2]=m+1,i[e+100>>2]=e,w||(X[i[i[e>>2]+8>>2]](e),p(e)),i[I+120>>2]=3,i[I+116>>2]=0,i[I+112>>2]=h,i[I+108>>2]=_,T0(s+56|0,I,0,_,h,k,o),T0(s+32|0,I,1,_,h,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,I,2,_,h,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!S)break r;if(T0(s+104|0,I,6,_,h,$,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(t=i[e+128>>2],t){for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);D=0;A:{if((e|0)==(k|0)||(D=0,i[e+16>>2]>0))break A;h0=i[e+44>>2],D=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);C=0;A:{if((e|0)==(k|0)||(C=0,i[e+16>>2]>1))break A;B=i[e+56>>2],C=i[e+44>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}m=0,o=0;break r}if(m=0,o=0,i[e+16>>2]>2)break r;m=i[e+44>>2],o=i[e+56>>2]>>>1|0}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;W=i[r+16>>2],n=(W|0)<0?n:r,r=i[(W>>>29&4)+r>>2],!!r;);x=0;A:{if((f|0)==(n|0)||(x=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],x=i[n+56>>2]}for(n=f,r=e;W=i[r+16>>2]<=0,n=W?n:r,r=i[(W?4:0)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>1))break A;y=i[n+56>>2],r=i[n+44>>2]}for(W=r,n=f,r=e;w=i[r+16>>2]<2,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;R=i[n+56>>2]>>>1|0,r=i[n+44>>2]}n=r,w=0;r:{if(!S)break r;f:{A:{if(!t)break A;for(r=k;w=i[t+16>>2]<6,r=w?r:t,t=i[(w?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(O=0,i[r+16>>2]>6)break f;W0=i[r+44>>2],O=i[r+56>>2];break f}O=0}if(w=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(w=0,(r|0)==(f|0)||(w=0,i[r+16>>2]>6))break r;Q0=i[r+56>>2],w=i[r+44>>2]}f=y>>>1|0,k=B>>>1|0;r:{f:{A:{if(h){if(r=0,(h|0)!=1)for(B=h&-2,e=0;Q[(G(r,f)<<1)+W>>1]=F[(G(r,k)<<1)+C>>1],Q[n+(G(r,R)<<1)>>1]=F[(G(r,o)<<1)+m>>1],t=r|1,Q[(G(t,f)<<1)+W>>1]=F[(G(k,t)<<1)+C>>1],Q[n+(G(t,R)<<1)>>1]=F[(G(t,o)<<1)+m>>1],r=r+2|0,e=e+2|0,(B|0)!=(e|0););if(h&1&&(Q[(G(r,f)<<1)+W>>1]=F[(G(r,k)<<1)+C>>1],Q[n+(G(r,R)<<1)>>1]=F[(G(r,o)<<1)+m>>1]),_&1)break f;break A}if(_&1)break r}if(!h)break r;if(e=(_+m|0)-2|0,t=(_+C|0)-2|0,r=_<<1,B=(r+n|0)-2|0,y=(r+W|0)-2|0,r=0,(h|0)!=1)for(a=h&-2;Q[y+(G(r,f)<<1)>>1]=F[t+(G(r,k)<<1)>>1],Q[B+(G(r,R)<<1)>>1]=F[e+(G(r,o)<<1)>>1],N=r|1,Q[y+(G(N,f)<<1)>>1]=F[t+(G(k,N)<<1)>>1],Q[B+(G(R,N)<<1)>>1]=F[e+(G(o,N)<<1)>>1],r=r+2|0,L=L+2|0,(a|0)!=(L|0););if(!(h&1))break f;Q[y+(G(r,f)<<1)>>1]=F[t+(G(r,k)<<1)>>1],Q[B+(G(r,R)<<1)>>1]=F[e+(G(r,o)<<1)>>1]}if(y=_-1|0,y>>>0>=2)for(e=0;;){for(N=n+(G(e,R)<<1)|0,a=(G(e,f)<<1)+W|0,L=(G(e,o)<<1)+m|0,V0=(G(e,k)<<1)+C|0,r=1;g=r&-2,B=g+L|0,t=F[B>>1],B=F[B+2>>1],f0=r<<1,A0=a+f0|0,g=g+V0|0,n0=F[g>>1],g=F[g+2>>1],Q[A0>>1]=(G(n0,3)+g|0)+2>>>2,Q[A0+2>>1]=(G(g,3)+n0|0)+2>>>2,g=N+f0|0,Q[g+2>>1]=(t+G(B,3)|0)+2>>>2,Q[g>>1]=(B+G(t,3)|0)+2>>>2,r=r+2|0,y>>>0>r>>>0;);if(e=e+1|0,(h|0)==(e|0))break}for(k=x>>>1|0,n=D>>>1|0,e=_<<1,f=$>>>0>8?e:_,r=0;e&&z((G(r,k)<<1)+m0|0,(G(r,n)<<1)+h0|0,e),!S|!f||z(G(r,Q0)+w|0,G(r,O)+W0|0,f),r=r+1|0,(h|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=V,i[A>>2]=I;break i}if(A=i[V+4>>2],i[V+4>>2]=A-1,A)break i;X[i[i[V>>2]+8>>2]](V),p(V)}v=s+128|0}function P7(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=h,i[_+524>>2]=e;i:{if(P2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+76>>2]=2072,I=_+76|0,C=g1(_+104|0,_+112|0,I),e=i[C>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[I>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,v=e+16|0,e=v-16|0,v=e,W=_- -64|0,i[W>>2]=0,i[W+4>>2]=0,i[W+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+52|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+40|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,g=_+28|0,i[g>>2]=0,i[g+4>>2]=0,i[g+8>>2]=0,v=e+16|0,e=v-16|0,v=e;e:{if(r){h=e+4|0,r=c0(f,129544),X[i[i[r>>2]+44>>2]](h,r);break e}h=e+4|0,r=c0(f,129536),X[i[i[r>>2]+44>>2]](h,r)}for(f=i[e+4>>2],u[_+92|0]=f,u[_+93|0]=f>>>8,u[_+94|0]=f>>>16,u[_+95|0]=f>>>24,X[i[i[r>>2]+32>>2]](h,r),q8(B,h),s2(h),X[i[i[r>>2]+28>>2]](h,r),q8(m,h),s2(h),R=_,N=X[i[i[r>>2]+12>>2]](r)|0,u[R+91|0]=N,R=_,N=X[i[i[r>>2]+16>>2]](r)|0,u[R+90|0]=N,X[i[i[r>>2]+20>>2]](h,r),q8(I,h),s2(h),X[i[i[r>>2]+24>>2]](h,r),q8(W,h),s2(h),R=_,N=X[i[i[r>>2]+36>>2]](r)|0,i[R+24>>2]=N,v=e+16|0,i[w>>2]=i[s>>2],V=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||P2(A,_+524|0))break A;h=0;k:{n:{t:{u:{o:switch(l[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;e=i[A>>2],k=i[e+12>>2];l:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break l}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,e){As(_+16|0,A),oi(g,u[_+16|0]);break u}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break o;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(P2(A,_+524|0))break r;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;As(_+16|0,A),oi(g,u[_+16|0])}}t:{if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(k=e<<24>>24&255,l[m+11|0]>>>7|0?e=i[m>>2]:e=m,(k|0)!=l[e|0])break t;K1(A),u[t|0]=0,l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(k=e<<24>>24&255,l[B+11|0]>>>7|0?e=i[B>>2]:e=B,(k|0)!=l[e|0])break t;K1(A),u[t|0]=1,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,e=e>>>0>1?B:r;break e}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,k=!e,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!(k|!e)){i[n>>2]=i[n>>2]|4,A=0;break f}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e&&(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e))break r;l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,u[t|0]=!e;break r}if(!(V|(f>>>0<2|r))&&(e=0,!((f|0)==2&l[_+95|0]!=0)))break e;R=_,N=T4(W),i[R+12>>2]=N,i[_+16>>2]=i[_+12>>2];n:{if(!f|l[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=w6(W),i[R+12>>2]=N,e=i[_+16>>2],(e|0)==i[_+12>>2]||(e=u[e|0],(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,!e))break t;i[_+16>>2]=i[_+16>>2]+1;continue}break}if(R=_,N=T4(W),i[R+12>>2]=N,l[g+11|0]>>>7|0?h=i[g+4>>2]:h=l[g+11|0]&127,e=_+12|0,k=i[_+16>>2]-i[e>>2]|0,h>>>0>=k>>>0&&(R=_,N=w6(g),i[R+12>>2]=N,e=lk(e,0-k|0),k=w6(g),h=T4(W),y=v-16|0,v=y,e=h6(e),k=h6(k),e=N2(e,h6(h),k-e|0),v=y+16|0,!e))break n;R=_,N=T4(W),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2],i[_+16>>2]=i[_+12>>2]}for(i[_+12>>2]=i[_+16>>2];;){n:{if(R=_,N=w6(W),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]||P2(A,_+524|0))break n;e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if((e<<24>>24&255)!=l[i[_+12>>2]])break n;K1(A),i[_+12>>2]=i[_+12>>2]+1;continue}break}if(!V||(R=_,N=w6(W),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(P2(A,_+524|0))break k;e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break n}e=u[k|0]}e=e<<24>>24,(e|0)>=0?k=i[i[o+8>>2]+(e<<2)>>2]&64:k=0;n:{if(k){k=i[w>>2],(k|0)==i[_+520>>2]&&(yu(s,w,_+520|0),k=i[w>>2]),i[w>>2]=k+1,u[k|0]=e,h=h+1|0;break n}if(l[I+11|0]>>>7|0?k=i[I+4>>2]:k=l[I+11|0]&127,!k|!h|l[_+90|0]!=(e&255))break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(si(C,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h,h=0}K1(A);continue}break}e=i[_+100>>2],!h|(e|0)==i[C>>2]||(i[_+96>>2]==(e|0)&&(si(C,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h);k:{if(i[_+24>>2]<=0)break k;n:{if(!P2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if((e<<24>>24&255)==l[_+91|0])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(K1(A),i[_+24>>2]<=0)break k;n:{if(!P2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&64:e=0,e)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[w>>2]==i[_+520>>2]&&yu(s,w,_+520|0),e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break n}e=u[k|0]}k=i[w>>2],i[w>>2]=k+1,u[k|0]=e<<24>>24,i[_+24>>2]=i[_+24>>2]-1}}if(e=r,i[s>>2]!=i[w>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(h=1;;){if(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,e>>>0<=h>>>0)break A;k:{if(!P2(A,_+524|0)){e=i[A>>2],f=i[e+12>>2];n:{if((f|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break n}e=u[f|0]}if(f=e<<24>>24&255,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,(f|0)==l[e+h|0])break k}i[n>>2]=i[n>>2]|4,A=0;break f}K1(A),h=h+1|0}}if(A=1,i[C>>2]==i[_+100>>2])break f;if(A=0,i[_+16>>2]=0,l4(I,i[C>>2],i[_+100>>2],_+16|0),i[_+16>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}s2(g),s2(B),s2(m),s2(W),s2(I),e=i[C>>2],i[C>>2]=0,e&&X[i[C+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function XB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0;n=v-128|0,v=n,t=E(172),e=t,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94860,o0(e+16|0,0,80),k=i[e+4>>2],w=k+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=k,k=i[e+8>>2],I=e+12|0,i[e+96>>2]=I,i[e+8>>2]=k+1,i[e+100>>2]=e,w||(X[i[i[e>>2]+8>>2]](e),p(e)),k=i[r>>2],C=i[k+108>>2],e=C,m=i[k+112>>2],k=m,i[I+120>>2]=1,i[I+116>>2]=0,i[I+112>>2]=k,i[I+108>>2]=e,W=j0(i[r>>2],0),T0(n+56|0,I,0,e,k,W,o),w=e+1|0,g=w>>>1|0,y=k+1|0,R=y>>>1|0,T0(n+32|0,I,1,g,R,W,o),e=n+88|0;i:{if(i[n+56>>2]){if(k=i[n+60>>2],i[n+80>>2]=i[n+56>>2],i[n+84>>2]=k,u[n+75|0]>=0){k=n- -64|0,h=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=h,i[e+8>>2]=i[k+8>>2];break i}T(e,i[n+64>>2],i[n+68>>2]);break i}if(k=i[n+36>>2],i[n+80>>2]=i[n+32>>2],i[n+84>>2]=k,u[n+51|0]>=0){k=i[n+44>>2],i[e>>2]=i[n+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[n+48>>2];break i}T(e,i[n+40>>2],i[n+44>>2])}T0(n+8|0,I,2,g,R,W,o),k=n+112|0;i:{if(i[n+80>>2]){if(h=i[n+84>>2],i[n+104>>2]=i[n+80>>2],i[n+108>>2]=h,u[n+99|0]>=0){h=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=h,i[k+8>>2]=i[e+8>>2];break i}T(k,i[n+88>>2],i[n+92>>2]);break i}if(e=i[n+12>>2],i[n+104>>2]=i[n+8>>2],i[n+108>>2]=e,u[n+27|0]>=0){e=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[n+24>>2];break i}T(k,i[n+16>>2],i[n+20>>2])}u[n+27|0]<0&&Z(i[n+16>>2]),u[n+99|0]<0&&Z(i[n+88>>2]),u[n+51|0]<0&&Z(i[n+40>>2]),u[n+75|0]<0&&Z(i[n+64>>2]);i:{e:{if(i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,e=A+8|0,u[n+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}if(u[n+123|0]<0&&Z(i[n+112>>2]),D=u1(i[r>>2],6),D){if(e=j0(i[r>>2],6),T0(n+104|0,I,6,C,m,e,o),i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,e=A+8|0,u[n+123|0]>=0){r=i[n+116>>2],i[e>>2]=i[n+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+120>>2],u[A+20|0]=1;break e}if(T(e,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}u[n+123|0]<0&&Z(i[n+112>>2]),x=e>>>0>8}e=i[r>>2],k=e+128|0,o=i[e+128>>2];r:{f:{A:{if(W>>>0<=8){if(w=0,!o)break A;for(e=k;h=i[o+16>>2],e=(h|0)<0?e:o,o=i[(h>>>29&4)+o>>2],!!o;);if((e|0)==(k|0))break A;if(h=0,i[e+16>>2]>0)break f;B=i[e+44>>2],h=i[e+56>>2];break f}k:{n:{if(!o)break n;for(e=k;h=i[o+16>>2],e=(h|0)<0?e:o,o=i[(h>>>29&4)+o>>2],!!o;);if((e|0)==(k|0))break n;if(h=0,i[e+16>>2]>0)break k;V=i[e+44>>2],h=i[e+56>>2]>>>1|0;break k}h=0}k:{n:{if(o=i[f>>2],o){for(k=f,e=o;_=i[e+16>>2],k=(_|0)<0?k:e,e=i[(_>>>29&4)+e>>2],!!e;);_=0;t:{if((f|0)==(k|0)||(_=0,i[k+16>>2]>0))break t;S=i[k+56>>2],_=i[k+44>>2]}for(k=f,e=o;s=i[e+16>>2]<=0,k=s?k:e,e=i[(s?4:0)+e>>2],!!e;);s=0;t:{if((f|0)==(k|0)||(s=0,i[k+16>>2]>1))break t;O=i[k+44>>2],s=i[k+56>>2]}for(e=f;k=i[o+16>>2]<2,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break n}k=0;break k}if(k=0,i[e+16>>2]>2)break k;L=i[e+56>>2]>>>1|0,k=i[e+44>>2]}k:{if(y>>>0>=2){if(w>>>0<2)break k;for(a=s>>>1|0,o=128<<W-8,$=g&2147483644,y=g&3,w=0,f0=g-1>>>0<3;;){if(B=(G(w,L)<<1)+k|0,W=(G(w,a)<<1)+O|0,e=0,g=0,!f0)for(;s=e<<1,Q[s+W>>1]=o,Q[s+B>>1]=o,N=s|2,Q[N+W>>1]=o,Q[B+N>>1]=o,N=s|4,Q[N+W>>1]=o,Q[B+N>>1]=o,s=s|6,Q[s+W>>1]=o,Q[s+B>>1]=o,e=e+4|0,g=g+4|0,($|0)!=(g|0););if(s=0,y)for(;g=e<<1,Q[g+W>>1]=o,Q[B+g>>1]=o,e=e+1|0,s=s+1|0,(y|0)!=(s|0););if(w=w+1|0,(R|0)==(w|0))break}}if(!m)break r}if(s=S>>>1|0,e=C<<1,o=0,(m|0)!=1)for(w=m&-2,k=0;B=!e,B||z((G(o,s)<<1)+_|0,(G(o,h)<<1)+V|0,e),B||(B=o|1,z((G(B,s)<<1)+_|0,(G(B,h)<<1)+V|0,e)),o=o+2|0,k=k+2|0,(w|0)!=(k|0););if(!(m&1)|!e)break r;z((G(o,s)<<1)+_|0,(G(o,h)<<1)+V|0,e);break r}h=0}f:{A:{if(o=i[f>>2],o){for(k=f,e=o;_=i[e+16>>2],k=(_|0)<0?k:e,e=i[(_>>>29&4)+e>>2],!!e;);_=0;k:{if((f|0)==(k|0)||(_=0,i[k+16>>2]>0))break k;V=i[k+44>>2],_=i[k+56>>2]}for(k=f,e=o;w=i[e+16>>2]<=0,k=w?k:e,e=i[(w?4:0)+e>>2],!!e;);w=0;k:{if((f|0)==(k|0)||(w=0,i[k+16>>2]>1))break k;s=i[k+56>>2],w=i[k+44>>2]}for(e=f;k=i[o+16>>2]<2,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break A}o=0,k=0;break f}if(o=0,k=0,i[e+16>>2]>2)break f;o=i[e+56>>2],k=i[e+44>>2]}if(e=1<<W-1,s=G(s,R),s&&o0(w,e,s),o=G(o,R),o&&o0(k,e,o),!m)break r;if(o=0,(m|0)!=1)for(k=m&-2,e=0;s=!C,s||z(G(o,_)+V|0,G(o,h)+B|0,C),s||(s=o|1,z(G(s,_)+V|0,G(s,h)+B|0,C)),o=o+2|0,e=e+2|0,(k|0)!=(e|0););if(!(m&1)|!C)break r;z(G(o,_)+V|0,G(o,h)+B|0,C)}r:{if(!D)break r;s=0;f:{A:{if(e=i[r>>2],o=i[e+128>>2],!o)break A;for(r=e+128|0,e=r;k=i[o+16>>2]<6,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)==(r|0))break A;if(B=0,k=0,i[e+16>>2]>6)break f;B=i[e+44>>2],k=i[e+56>>2];break f}B=0,k=0}o=i[f>>2],r=0;f:{if(!o)break f;for(e=f;r=i[o+16>>2]<6,e=r?e:o,o=i[(r?4:0)+o>>2],!!o;);if(r=0,(e|0)==(f|0)||(r=0,i[e+16>>2]>6))break f;s=i[e+56>>2],r=i[e+44>>2]}if(!m)break r;if(e=k,f=C<<x,o=0,(m|0)!=1)for(_=m&-2,k=0;w=!f,w||z(r+G(o,s)|0,G(e,o)+B|0,f),w||(w=o|1,z(r+G(w,s)|0,G(e,w)+B|0,f)),o=o+2|0,k=k+2|0,(_|0)!=(k|0););if(!(m&1)|!f)break r;z(r+G(o,s)|0,G(e,o)+B|0,f)}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=I;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=n+128|0}function gB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),a=u1(i[r>>2],6),a&&(m0=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],_=i[e+112>>2],h=i[e+108>>2],I=E(172),i[I>>2]=94860,e=I,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),B=i[e+4>>2],w=B+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=B,B=i[e+8>>2],m=e+12|0,i[e+96>>2]=m,i[e+8>>2]=B+1,i[e+100>>2]=e,w||(X[i[i[e>>2]+8>>2]](e),p(e)),i[m+120>>2]=1,i[m+116>>2]=0,i[m+112>>2]=_,i[m+108>>2]=h,T0(s+56|0,m,0,h,_,k,o),C=h+1>>>1|0,R=_+1>>>1|0,T0(s+32|0,m,1,C,R,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,m,2,C,R,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!a)break r;if(T0(s+104|0,m,6,h,_,m0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);D=0;k:{if((e|0)==(k|0)||(D=0,i[e+16>>2]>0))break k;e0=i[e+44>>2],D=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);k:{if((e|0)==(k|0)){o=0;break k}if(o=0,i[e+16>>2]>1)break k;x=i[e+44>>2],o=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}r=0;break r}if(r=0,i[e+16>>2]>2)break r;N=i[e+56>>2],r=i[e+44>>2]}B=r;r:{f:{if(e=i[f>>2],e){for(n=f,r=e;w=i[r+16>>2],n=(w|0)<0?n:r,r=i[(w>>>29&4)+r>>2],!!r;);S=0;A:{if((f|0)==(n|0)||(S=0,i[n+16>>2]>0))break A;r0=i[n+44>>2],S=i[n+56>>2]}for(n=f,r=e;w=i[r+16>>2]<=0,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);V=0;A:{if((f|0)==(n|0)||(V=0,i[n+16>>2]>1))break A;$=i[n+56>>2],V=i[n+44>>2]}for(n=f,r=e;w=i[r+16>>2]<2,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}y=0;break r}if(y=0,i[n+16>>2]>2)break r;f0=i[n+56>>2],y=i[n+44>>2]}n=0,w=0;r:{if(!a)break r;f:{A:{if(!t)break A;for(r=k;w=i[t+16>>2]<6,r=w?r:t,t=i[(w?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(A0=0,i[r+16>>2]>6)break f;N0=i[r+44>>2],A0=i[r+56>>2];break f}A0=0}if(w=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(w=0,(r|0)==(f|0)||(w=0,i[r+16>>2]>6))break r;n=i[r+56>>2],w=i[r+44>>2]}r:{f:{A:{k:{if(t=_&1,t){if(e=h-1|0,!e)break k;for(r=R-1|0,f=G(r,f0)+y|0,k=_-1|0,O=G(k,N)+B|0,L=G(r,$)+V|0,k=G(k,o)+x|0,r=0;W=r>>>1|0,g=r+k|0,u[W+L|0]=(l[g|0]+l[g+1|0]|0)+1>>>1,h0=f+W|0,W=r+O|0,u[h0|0]=(l[W|0]+l[W+1|0]|0)+1>>>1,r=r+2|0,e>>>0>r>>>0;);}if(h&1)break k;e=_-1|0;break A}if(e=_-1|0,e){for(O=(C+y|0)-1|0,f=(h+B|0)-1|0,L=(C+V|0)-1|0,k=(h+x|0)-1|0,r=0;W=r>>>1|0,g=r|1,u[L+G(W,$)|0]=(l[k+G(r,o)|0]+l[k+G(g,o)|0]|0)+1>>>1,u[O+G(W,f0)|0]=(l[f+G(r,N)|0]+l[f+G(g,N)|0]|0)+1>>>1,r=r+2|0,r>>>0<e>>>0;);if(!t)break f}r=R-1|0,u[(C+(G(r,$)+V|0)|0)-1|0]=l[((G(e,o)+x|0)+h|0)-1|0],u[(C+(G(r,f0)+y|0)|0)-1|0]=l[((G(e,N)+B|0)+h|0)-1|0]}if(!e)break r}if(k=h-1|0,!k)break r;for(f=0;;){for(t=G(f,N)+B|0,C=G(f,o)+x|0,r=f>>>1|0,R=G(r,f0)+y|0,O=G(r,$)+V|0,r=f|1,L=G(r,N)+B|0,W=G(r,o)+x|0,r=0;g=r+L|0,U0=l[g+1|0],g=l[g|0],n0=r+t|0,h0=l[n0+1|0],n0=l[n0|0],W0=r>>>1|0,Q0=r+W|0,V0=r+C|0,u[O+W0|0]=((l[Q0|0]+(l[V0|0]+l[V0+1|0]|0)|0)+l[Q0+1|0]|0)+2>>>2,u[R+W0|0]=((g+(n0+h0|0)|0)+U0|0)+2>>>2,r=r+2|0,k>>>0>r>>>0;);if(f=f+2|0,!(f>>>0<e>>>0))break}}if(_)for(e=h<<(m0>>>0>8),r=0;h&&z(G(r,S)+r0|0,G(r,D)+e0|0,h),!a|!e||z(w+G(r,n)|0,G(r,A0)+N0|0,e),r=r+1|0,(_|0)!=(r|0););u[A+20|0]=0,i[A+4>>2]=I,i[A>>2]=m;break i}if(A=i[I+4>>2],i[I+4>>2]=A-1,A)break i;X[i[i[I>>2]+8>>2]](I),p(I)}v=s+128|0}function QB(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;m=v-48|0,v=m,h=v-96|0,v=h,A=i[A>>2],w=i[A+48>>2],W=i[A+52>>2],W&&(i[W+4>>2]=i[W+4>>2]+1),_=m+12|0;i:{if(!r){r=v-48|0,v=r,B=i[A+48>>2],g=i[A+52>>2],g&&(i[g+4>>2]=i[g+4>>2]+1),w=v-32|0,v=w,i[w+28>>2]=0,i[w+20>>2]=0,i[w+24>>2]=0,j1(w,B,e,w+20|0);e:{if(i[w>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(B=i[w+20>>2],A=i[w+24>>2],(B|0)!=(A|0)){if(e=i[B>>2],e&&(I=i[r+44>>2],e=X0(e,86628,88100),e))break r;if(B=B+8|0,(A|0)!=(B|0))for(;;){if(e=i[B>>2],e&&(I=0,e=X0(e,86628,88100),e))break r;if(B=B+8|0,(A|0)==(B|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=I,i[r+40>>2]=e,A=i[B+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[w+19|0]<0&&Z(i[w+8>>2]),A=i[w+20>>2],A){if(B=i[w+24>>2],e=A,(B|0)!=(A|0)){for(;;){e=i[B-4>>2];e:{if(!e||(I=i[e+4>>2],i[e+4>>2]=I-1,I))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(B=B-8|0,(A|0)==(B|0))break}e=i[w+20>>2]}i[w+24>>2]=A,Z(e)}v=w+32|0,A=i[r+40>>2];e:{if(!A){A=E(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),w=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=w,u[A+17|0]=w>>>8,u[A+18|0]=w>>>16,u[A+19|0]=w>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),w=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=w,u[A+9|0]=w>>>8,u[A+10|0]=w>>>16,u[A+11|0]=w>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),w=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=w,u[A+1|0]=w>>>8,u[A+2|0]=w>>>16,u[A+3|0]=w>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=K(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=e,e=_+8|0;r:{if(u[A+19|0]>=0){w=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=w,i[e+8>>2]=i[A+16>>2],u[_+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[_+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}e=i[r+44>>2],u[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A}e:{if(!g||(A=i[g+4>>2],i[g+4>>2]=A-1,A))break e;X[i[i[g>>2]+8>>2]](g),p(g)}v=r+48|0;break i}i[h+92>>2]=0,i[h+84>>2]=0,i[h+88>>2]=0,j1(h- -64|0,w,e,h+84|0);e:{if(i[h+64>>2]){A=i[h+68>>2],i[_>>2]=i[h+64>>2],i[_+4>>2]=A,A=_+8|0;r:{if(u[h+83|0]>=0){e=i[h+76>>2],i[A>>2]=i[h+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[h+80>>2];break r}T(A,i[h+72>>2],i[h+76>>2])}u[_+20|0]=1;break e}w=r-1|0,r=i[h+84>>2],w>>>0>=i[h+88>>2]-r>>3>>>0&&(A=E(32),i[h+24>>2]=A,i[h+28>>2]=27,i[h+32>>2]=-2147483616,e=l[13933]|l[13934]<<8|(l[13935]<<16|l[13936]<<24),r=l[13929]|l[13930]<<8|(l[13931]<<16|l[13932]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13952]|l[13953]<<8|(l[13954]<<16|l[13955]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13949]|l[13950]<<8|(l[13951]<<16|l[13952]<<24),r=l[13945]|l[13946]<<8|(l[13947]<<16|l[13948]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),r=l[13937]|l[13938]<<8|(l[13939]<<16|l[13940]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=K(h+44|0,5,2007,h+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+35|0]<0&&Z(i[h+24>>2]),r=i[h+84>>2]),e=r+(w<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=X0(A,86628,88100),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A;break r}A=E(24),i[h+12>>2]=A,i[h+16>>2]=19,i[h+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),w=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=w,u[A+9|0]=w>>>8,u[A+10|0]=w>>>16,u[A+11|0]=w>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),w=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=w,u[A+1|0]=w>>>8,u[A+2|0]=w>>>16,u[A+3|0]=w>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=K(h+24|0,5,2007,h+12|0),r=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=r,r=_+8|0;f:{if(u[A+19|0]>=0){w=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=w,i[r+8>>2]=i[A+16>>2],u[_+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[_+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[h+23|0]>=0)break r;Z(i[h+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(u[h+83|0]<0&&Z(i[h+72>>2]),A=i[h+84>>2],!A)break i;if(r=i[h+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(_=i[e+4>>2],i[e+4>>2]=_-1,_))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[h+84>>2]}i[h+88>>2]=A,Z(e)}i:{if(!W||(A=i[W+4>>2],i[W+4>>2]=A-1,A))break i;X[i[i[W>>2]+8>>2]](W),p(W)}v=h+96|0;i:{A=l[m+32|0];e:{r:{f:{if(A)break f;A:{k:{n:{t:{u:{o:{l:{if(n){if(C=n,V=$i(i[m+12>>2],f),i[C>>2]=V,A=l[m+32|0],!o)break o;if(!A)break l;break i}if(!o)break u}C=o,V=(bf(i[m+12>>2],f)^-1)+f|0,i[C>>2]=V,A=l[m+32|0]}if(!t)break n;if(A&255)break i;break t}if(!t)break k}C=t,V=Ki(i[m+12>>2],k),i[C>>2]=V,A=l[m+32|0]}if(!s)break f;if(A&255)break i;break A}if(s)break A;A=0;break r}C=s,V=(iA(i[m+12>>2],k)^-1)+k|0,i[C>>2]=V,A=l[m+32|0]}if((A&255)==255)break e}e=i[24191],i[m+40>>2]=i[24190],i[m+44>>2]=e,X[i[(m+40|0)+((A&255)<<2)>>2]](m+39|0,m+12|0)}v=m+48|0;return}_2(),H()}function D8(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0;w=v-160|0,v=w;i:{e:{if(B=i[A+18588>>2],t=i[B+168>>2],s=e>>t,(s|0)<0||(n=i[B+172>>2],(n|0)<=(s|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+176>>2])break i;L=i[B+132>>2],N=i[B+124>>2],h=l[((i[B+160>>2]+G(s,3)|0)+G(G(n,t),3)|0)+1|0];r:{if(k||(s=i[B+248>>2],n=f-s|0,(n|0)==31))break r;for(t=r>>s,n=1<<n,W=t+n|0,s=e>>s,o=s+n|0;;){for(n=s;m=(i[B+240>>2]+n|0)+G(i[B+252>>2],t)|0,u[m|0]=l[m|0]|128,n=n+1|0,(o|0)>(n|0););if(t=t+1|0,!((W|0)>(t|0)))break}}A0=h&3,n=A+k|0,a=n,t=0;r:{if(!l[L+25|0]||(t=0,l[A+32|0])||(t=0,i[L+8276>>2]<(f|0)))break r;t=v2(A+18548|0,i[A+18572>>2]+(k?142:141)|0)}u[n+33|0]=t,u[A+36|0]=0;r:{if(!(l[n+33|0]|l[A+32|0])|(!l[N+16823|0]|(A0|0)!=1)||(s=A+18548|0,t=(k|0)!=0,n=v2(s,(t+i[A+18572>>2]|0)+143|0),u[A+36|0]=n,!(n&255)))break r;D0=A,H0=v2(s,(t+i[A+18572>>2]|0)+145|0),u[D0+37|0]=H0}m=k?0:2,m=l[a+33|0]|l[A+32|0]?m|1:m,h=f<<1;r:{if(!k){o=f+1>>2,n=(G(f,3)+(f-1>>2)|0)-6|0;break r}o=f-2|0,n=15}_=i[A+18572>>2],t=h-1|0;r:{if((h|0)<2){n=t;break r}W=n+(_+25|0)|0,s=A+18548|0,n=0;f:{for(;;){if(!v2(s,W+(n>>>o|0)|0))break f;if(n=n+1|0,(t|0)==(n|0))break}n=t}_=i[A+18572>>2]}r:{if(!k){o=(G(f,3)+(f-1>>2)|0)-6|0,s=f+1>>2;break r}o=15,s=f-2|0}r:{if((h|0)<2)break r;for(h=o+(_+43|0)|0,W=A+18548|0,o=0;;){if(!v2(W,h+(o>>>s|0)|0)){t=o;break r}if(o=o+1|0,(o|0)==(t|0))break}}(n|0)>=4&&(s=(n>>>1|0)-1|0,n=C8(A+18548|0,s)+((n&1|2)<<s)|0),(t|0)>=4&&(s=(t>>>1|0)-1|0,t=C8(A+18548|0,s)+((t&1|2)<<s)|0);r:{f:{if(A0){o=0;break f}A:{if(!k){if(o=i[B+208>>2],W=e>>o,(W|0)<0||(s=i[B+212>>2],(s|0)<=(W|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+216>>2])break i;s=l[(W+i[B+200>>2]|0)+G(o,s)|0],_=s>>>0<=34?s:0,s=0;break A}if(o=i[B+228>>2],W=e>>o,(W|0)<0||(s=i[B+232>>2],(s|0)<=(W|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+236>>2])break i;_=l[(W+i[B+220>>2]|0)+G(o,s)|0]&63,s=k}o=2,W=s,s=0;A:{k:{n:switch(f-2|0){case 0:break k;case 1:break n;default:break A}if(!W)break k;if(i[N+16848>>2]!=3)break A}if(s=2,_-6>>>0<9)break A;s=_-22>>>0<9}if((s|0)!=2){o=s;break f}s=t;break r}s=n,n=t}for(R=f-2|0,t=R,o>>>0<=2?W=i[i[(o<<2)+63144>>2]+(t<<2)>>2]:W=0,Q0=o>>>0<=2?i[i[(o<<2)+63144>>2]+8>>2]:0,n=(i[(G(o,24)+(f<<2)|0)+63072>>2]+(n<<f<<1)|0)+(s<<1)|0,n=l[n|0]|l[n+1|0]<<8,u[w+158|0]=n,u[w+159|0]=n>>>8,S=l[w+158|0],V0=l[w+159|0],n=1<<R<<R,n&&o0(w+80|0,0,n),O=((k<<1)+A|0)+14396|0,Q[O>>1]=0,s=k?43:42,V=A+18548|0,$=(A+m|0)+18580|0,e0=V0-1|0,r0=R<<6|((k|0)!=0)<<5|((o|0)!=0)<<4,n=k<<11,N0=n+(A+2108|0)|0,U0=n+(A+8252|0)|0,y=1,n=S;;){t=(n<<1)+W|0,o=l[t+1|0],h=l[t|0],D=n;r:{f:{if(!(!n|n>>>0>=S>>>0)){if(n=l[w+80+(h+(o<<R))|0],n=n&1|n>>>1,m=1,v2(V,(i[A+18572>>2]+(k?n+2|0:n)|0)+61|0))break f;break r}if((D|0)!=(S|0)&&D)break r;m=0}if(h&&(n=(h+(o<<R)|0)+w|0,u[n+79|0]=l[n+79|0]|1),_=0,t=0,o&&(n=w+80+(h+(o-1<<R))|0,u[n|0]=l[n|0]|2,t=o),n=((l[w+80+(h+(t<<R))|0]<<2)+r0|0)+125056|0,(D|0)==(S|0)&&(u[w|0]=1,Q[w+48>>1]=1,u[w+32|0]=V0,_=1),f0=i[n>>2],n0=t<<2,h0=h<<2,t=(D|0)!=(S|0)?15:e0,(t|0)>0)for(g=f0+h0|0,n=t;;){o=(n<<1)+Q0|0,I=l[o+1|0],h=l[o|0],x=i[A+18572>>2];f:{if(l[N+16821|0]&&(o=s,l[A+32|0]|l[a+33|0]))break f;o=l[(h+g|0)+(I+n0<<f)|0]}if(v2(V,(x+(o&255)|0)+65|0)&&(u[w+_|0]=1,u[(w+32|0)+_|0]=n,Q[(w+48|0)+(_<<1)>>1]=1,_=_+1|0,m=0),o=(n|0)>1,n=n-1|0,!o)break}f:{if((t|0)<0)break f;if(!m){t=i[A+18572>>2];A:{if(l[N+16821|0]&&(n=s,l[A+32|0]|l[a+33|0]))break A;n=l[(f0+h0|0)+(n0<<f)|0]}if(!v2(V,(t+(n&255)|0)+65|0))break f}u[w+_|0]=1,u[(w+32|0)+_|0]=0,Q[(w+48|0)+(_<<1)>>1]=1,_=_+1|0}if(!_)break r;m=1;f:{if((_|0)<=0)break f;n=!y,y=(k|0)>0,g=n|(y?0:D?2:0),n=g<<2,I=y?n|16:n,C=v2(V,(I+i[A+18572>>2]|0)+110|0);A:{if(C){Q[w+48>>1]=F[w+48>>1]+1,m=0,t=0;break A}u[w|0]=0,m=2,t=-1}if(o=1,(_|0)!=1)for(h=(_|0)>=8?8:_,n=1;;){n=(n|0)>0?(C|0)!=1?n+1|0:0:n,C=v2(V,(I+(i[A+18572>>2]+((n|0)>=3?3:n)|0)|0)+109|0);A:{if(C){m=(w+48|0)+(o<<1)|0,Q[m>>1]=F[m>>1]+1,t=(t|0)==-1?o:t,m=0;break A}u[o+w|0]=0,m=(m-1>>>0<2)+m|0}if(o=o+1|0,(h|0)==(o|0))break}if((t|0)==-1)break f;o=v2(V,(i[A+18572>>2]+(y?g|4:g)|0)+133|0),u[t+w|0]=o,n=(w+48|0)+(t<<1)|0,Q[n>>1]=o+F[n>>1]}f:{if(!k){if(t=i[B+208>>2],o=e>>t,(o|0)<0||(n=i[B+212>>2],(n|0)<=(o|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+216>>2])break i;n=l[(o+i[B+200>>2]|0)+G(n,t)|0],t=n>>>0<=34?n:0;break f}if(t=i[B+228>>2],o=e>>t,(o|0)<0||(n=i[B+232>>2],(n|0)<=(o|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+236>>2])break i;t=l[(o+i[B+220>>2]|0)+G(n,t)|0]&63}n=0,I=0;f:{if(l[A+32|0]||!(!l[N+16822|0]|A0|(t&239)!=10)&&(I=0,l[a+33|0])||(I=0,l[A+36|0]))break f;I=(u[w+32|0]-u[(w+_|0)+31|0]|0)>3}if(m0=_-1|0,(_|0)>1)for(;D0=(w+16|0)+n|0,H0=k4(V),u[D0|0]=H0,n=n+1|0,(m0|0)!=(n|0););if(o=0,t=m0+(w+16|0)|0,I&l[L+15|0]!=0?n=0:n=k4(V),u[t|0]=n,o=l[N+16827|0]?l[$|0]>>>2|0:o,y=1,C=0,W0=0,(_|0)>0)for(;;){t=Q[(w+48|0)+(C<<1)>>1],n=-1;f:{if(!l[w+C|0]){n=0;break f}g=3<<o;A:{for(;;){if(f0=k4(V),h=n,x=0,(n|0)==64)break A;if(n=n+1|0,!f0)break}if((h|0)<=2){x=C8(V,o)+(n<<o)|0;break A}n=h-2|0,x=C8(V,n+o|0)+((1<<n)+2<<o)|0}n=x,h=t+n|0;A:{if(!l[N+16827|0]){if((h|0)<=(g|0))break A;o=((o|0)>=3?3:o)+1|0;break A}if(o=((h|0)>(g|0))+o|0,!(y&1))break A;if(g=l[$|0],h=g>>>2|0,3<<h<=(n|0)){u[$|0]=g+1;break A}if(!g|n<<1>=1<<h)break A;u[$|0]=g-1}y=0}if(n=n+t|0,n=l[(w+16|0)+C|0]?0-n|0:n,t=(u[(w+32|0)+C|0]<<1)+Q0|0,g=l[t+1|0],h=l[t|0],t=(Q[O>>1]<<1)+N0|0,I&l[L+15|0]!=0&&(W0=(n&65535)+W0|0,n=(C|0)!=(m0|0)?n:W0&1?0-n|0:n),Q[t>>1]=n,Q[(Q[O>>1]<<1)+U0>>1]=(h+h0|0)+(g+n0<<f),Q[O>>1]=F[O>>1]+1,C=C+1|0,(C|0)==(_|0))break}y=m}if(n=D-1|0,!((D|0)>0))break}v=w+160|0;return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function IB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),x=u1(i[r>>2],6),x&&(a=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;e:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break e}T(e,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],_=i[e+112>>2],B=i[e+108>>2],V=E(172),i[V>>2]=94860,e=V,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],h=m+1|0,i[e+4>>2]=h,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],I=e+12|0,i[e+96>>2]=I,i[e+8>>2]=m+1,i[e+100>>2]=e,h||(X[i[i[e>>2]+8>>2]](e),p(e)),i[I+120>>2]=3,i[I+116>>2]=0,i[I+112>>2]=_,i[I+108>>2]=B,T0(s+56|0,I,0,B,_,k,o),T0(s+32|0,I,1,B,_,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,I,2,B,_,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!x)break r;if(T0(s+104|0,I,6,B,_,a,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>0))break k;A0=i[e+44>>2],r=i[e+56>>2]}for(n0=r,e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(k|0)||(o=0,i[e+16>>2]>1))break k;N=i[e+44>>2],o=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}m=0;break r}if(m=0,i[e+16>>2]>2)break r;y=i[e+56>>2],m=i[e+44>>2]}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;w=i[r+16>>2],n=(w|0)<0?n:r,r=i[(w>>>29&4)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;h0=i[n+44>>2],r=i[n+56>>2]}for(m0=r,n=f,r=e;w=i[r+16>>2]<=0,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);w=0;A:{if((f|0)==(n|0)||(w=0,i[n+16>>2]>1))break A;D=i[n+44>>2],w=i[n+56>>2]}for(n=f,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}h=0;break r}if(h=0,i[n+16>>2]>2)break r;R=i[n+56>>2],h=i[n+44>>2]}n=0,W=0;r:{if(!x)break r;f:{A:{if(!t)break A;for(r=k;W=i[t+16>>2]<6,r=W?r:t,t=i[(W?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(k=0,i[r+16>>2]>6)break f;W0=i[r+44>>2],k=i[r+56>>2];break f}k=0}if(Q0=k,W=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(W=0,(r|0)==(f|0)||(W=0,i[r+16>>2]>6))break r;n=i[r+56>>2],W=i[r+44>>2]}if(_){k=_&1,C=_-1|0;r:{if(!C){r=0;break r}for(t=_&-2,r=0,e=0;u[G(r,w)+D|0]=l[G(r,o)+N|0],u[G(r,R)+h|0]=l[G(r,y)+m|0],f=r|1,u[G(f,w)+D|0]=l[G(f,o)+N|0],u[G(f,R)+h|0]=l[G(f,y)+m|0],r=r+2|0,e=e+2|0,(t|0)!=(e|0););}k&&(u[G(r,w)+D|0]=l[G(r,o)+N|0],u[G(r,R)+h|0]=l[G(r,y)+m|0]);r:{if(B&1)break r;O=_&1,e=(B+h|0)-1|0,f=(B+D|0)-1|0,r=B>>>1|0,k=(r+m|0)-1|0,t=(r+N|0)-1|0;f:{if(!C){r=0;break f}for(L=_&-2,r=0;u[f+G(r,w)|0]=l[t+G(r,o)|0],u[e+G(r,R)|0]=l[k+G(r,y)|0],C=r|1,u[f+G(C,w)|0]=l[t+G(o,C)|0],u[e+G(R,C)|0]=l[k+G(y,C)|0],r=r+2|0,S=S+2|0,(L|0)!=(S|0););}if(!O)break r;u[f+G(r,w)|0]=l[t+G(r,o)|0],u[e+G(r,R)|0]=l[k+G(r,y)|0]}if(t=B-1|0,t>>>0>=2)for(e=0;;){for(C=G(e,R)+h|0,O=G(e,w)+D|0,L=G(e,y)+m|0,S=G(e,o)+N|0,r=1;g=r>>>1|0,k=g+L|0,f=l[k|0],k=l[k+1|0],$=r+O|0,g=g+S|0,f0=l[g|0],g=l[g+1|0],u[$|0]=(G(f0,3)+g|0)+2>>>2,u[$+1|0]=(G(g,3)+f0|0)+2>>>2,g=r+C|0,u[g+1|0]=(f+G(k,3)|0)+2>>>2,u[g|0]=(k+G(f,3)|0)+2>>>2,r=r+2|0,t>>>0>r>>>0;);if(e=e+1|0,(_|0)==(e|0))break}for(e=B<<(a>>>0>8),r=0;B&&z(G(r,m0)+h0|0,G(r,n0)+A0|0,B),!x|!e||z(G(r,n)+W|0,G(r,Q0)+W0|0,e),r=r+1|0,(_|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=V,i[A>>2]=I;break i}if(A=i[V+4>>2],i[V+4>>2]=A-1,A)break i;X[i[i[V>>2]+8>>2]](V),p(V)}v=s+128|0}function q7(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=h,i[_+524>>2]=e;i:{if(q2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+72>>2]=2072,I=_+72|0,V=g1(_+104|0,_+112|0,I),e=i[V>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[I>>2]=0,i[I+4>>2]=0,i[I+8>>2]=0,v=e+16|0,e=v-16|0,v=e,W=_+60|0,i[W>>2]=0,i[W+4>>2]=0,i[W+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+48|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+36|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,g=_+24|0,i[g>>2]=0,i[g+4>>2]=0,i[g+8>>2]=0,v=e+16|0,C=v-16|0,v=C;e:{if(r){h=C+4|0,r=c0(f,129560),X[i[i[r>>2]+44>>2]](h,r);break e}h=C+4|0,r=c0(f,129552),X[i[i[r>>2]+44>>2]](h,r)}for(e=i[C+4>>2],u[_+92|0]=e,u[_+93|0]=e>>>8,u[_+94|0]=e>>>16,u[_+95|0]=e>>>24,X[i[i[r>>2]+32>>2]](h,r),me(B,h),R1(h),X[i[i[r>>2]+28>>2]](h,r),me(m,h),R1(h),R=_,N=X[i[i[r>>2]+12>>2]](r)|0,i[R+88>>2]=N,R=_,N=X[i[i[r>>2]+16>>2]](r)|0,i[R+84>>2]=N,X[i[i[r>>2]+20>>2]](h,r),q8(I,h),s2(h),X[i[i[r>>2]+24>>2]](h,r),me(W,h),R1(h),R=_,N=X[i[i[r>>2]+36>>2]](r)|0,i[R+20>>2]=N,v=C+16|0,i[w>>2]=i[s>>2],y=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||q2(A,_+524|0))break A;h=0;k:{n:{t:{u:{o:switch(l[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;k=i[A>>2],e=i[k+12>>2];l:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break l}e=i[e>>2]}if(X[i[i[o>>2]+12>>2]](o,1,e)|0){ss(_+12|0,A),vA(g,i[_+12>>2]);break u}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break o;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(q2(A,_+524|0))break r;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(!(X[i[i[o>>2]+12>>2]](o,1,e)|0))break r;ss(_+12|0,A),vA(g,i[_+12>>2])}}t:{if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(l[m+11|0]>>>7|0?k=i[m>>2]:k=m,(e|0)!=i[k>>2])break t;a1(A),u[t|0]=0,l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(l[B+11|0]>>>7|0?k=i[B>>2]:k=B,(e|0)!=i[k>>2])break t;a1(A),u[t|0]=1,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,e=e>>>0>1?B:r;break e}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=!e,l[B+11|0]>>>7|0?k=i[B+4>>2]:k=l[B+11|0]&127,!(e|!k)){i[n>>2]=i[n>>2]|4,A=0;break f}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e&&(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e))break r;l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,u[t|0]=!e;break r}if(!(y|(f>>>0<2|r))&&(e=0,!((f|0)==2&l[_+95|0]!=0)))break e;R=_,N=T4(W),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2];n:{if(!f|l[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=s6(W),i[R+8>>2]=N,e=i[_+12>>2],(e|0)==i[_+8>>2]||!(X[i[i[o>>2]+12>>2]](o,1,i[e>>2])|0))break t;i[_+12>>2]=i[_+12>>2]+4;continue}break}if(R=_,N=T4(W),i[R+8>>2]=N,l[g+11|0]>>>7|0?h=i[g+4>>2]:h=l[g+11|0]&127,k=_+8|0,e=i[_+12>>2]-i[k>>2]>>2,h>>>0>=e>>>0&&(R=_,N=s6(g),i[R+8>>2]=N,C=tk(k,0-e|0),e=s6(g),h=T4(W),k=v-16|0,v=k,C=h6(C),e=h6(e),e=N2(C,h6(h),e-C&-4),v=k+16|0,!e))break n;R=_,N=T4(W),i[R+4>>2]=N,i[_+8>>2]=i[_+4>>2],i[_+12>>2]=i[_+8>>2]}for(i[_+8>>2]=i[_+12>>2];;){n:{if(R=_,N=s6(W),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]||q2(A,_+524|0))break n;k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)!=i[i[_+8>>2]>>2])break n;a1(A),i[_+8>>2]=i[_+8>>2]+4;continue}break}if(!y||(R=_,N=s6(W),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(q2(A,_+524|0))break k;k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break n}e=i[e>>2]}n:{if(X[i[i[o>>2]+12>>2]](o,64,e)|0){k=i[w>>2],(k|0)==i[_+520>>2]&&(si(s,w,_+520|0),k=i[w>>2]),i[w>>2]=k+4,i[k>>2]=e,h=h+1|0;break n}if(l[I+11|0]>>>7|0?k=i[I+4>>2]:k=l[I+11|0]&127,!k|!h|(e|0)!=i[_+84>>2])break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(si(V,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h,h=0}a1(A);continue}break}e=i[_+100>>2],!h|(e|0)==i[V>>2]||(i[_+96>>2]==(e|0)&&(si(V,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h);k:{if(i[_+20>>2]<=0)break k;n:{if(!q2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)==i[_+88>>2])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(a1(A),i[_+20>>2]<=0)break k;n:{if(!q2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=X[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if(X[i[i[o>>2]+12>>2]](o,64,e)|0)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[w>>2]==i[_+520>>2]&&si(s,w,_+520|0),k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){k=X[i[i[k>>2]+36>>2]](k)|0;break n}k=i[e>>2]}e=i[w>>2],i[w>>2]=e+4,i[e>>2]=k,i[_+20>>2]=i[_+20>>2]-1}}if(e=r,i[s>>2]!=i[w>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(h=1;;){if(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,e>>>0<=h>>>0)break A;k:{if(!q2(A,_+524|0)){f=i[A>>2],e=i[f+12>>2];n:{if((e|0)==i[f+16>>2]){e=X[i[i[f>>2]+36>>2]](f)|0;break n}e=i[e>>2]}if(l[r+11|0]>>>7|0?f=i[r>>2]:f=r,(e|0)==i[f+(h<<2)>>2])break k}i[n>>2]=i[n>>2]|4,A=0;break f}a1(A),h=h+1|0}}if(A=1,i[V>>2]==i[_+100>>2])break f;if(A=0,i[_+12>>2]=0,l4(I,i[V>>2],i[_+100>>2],_+12|0),i[_+12>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}R1(g),R1(B),R1(m),R1(W),s2(I),e=i[V>>2],i[V>>2]=0,e&&X[i[V+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function mf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0;t=v-32|0,v=t;i:{e:{n=i[A+276>>2],n2=(f|0)<(n|0)?f:n;r:{if((n2|0)<=(r|0)||(f=i[A+272>>2],Z2=(f|0)>(k|0)?k:f,(Z2|0)<=0))break r;for(H2=e?1:2,T2=e?2:1,w=i[A+40>>2],b2=w<<1,g2=i[A+124>>2],f=i[g2+16832>>2],Q2=f-8|0,y=-1<<f^-1,e1=e?3:2,e0=G(w,-3),r0=0-w|0,N0=G(w,3),L=w<<1,U0=0-L|0,q0=0-(w<<2)|0;;){for(L0=r<<2,E2=L0-1|0,W1=L0>>2,d0=0,$0=0;;){g=$0<<2,B=l[(i[A+260>>2]+(g>>2)|0)+G(i[A+272>>2],W1)|0]&3;f:{if(!B)break f;f=G(i[A+40>>2],L0),k=i[A+4>>2],s=f+(k+g|0)|0;A:{if(!e){u[t+16|0]=l[s|0],f=l[s+r0|0],u[t|0]=f,u[t+17|0]=l[s+w|0],W=l[s+U0|0],u[t+1|0]=W,u[t+18|0]=l[s+L|0],a=l[s+e0|0],u[t+2|0]=a,u[t+19|0]=l[s+N0|0],O=l[s+q0|0],u[t+3|0]=O,k=s+1|0,u[t+20|0]=l[k|0],u[t+4|0]=l[k+r0|0],u[t+21|0]=l[k+w|0],u[t+5|0]=l[k+U0|0],u[t+22|0]=l[k+L|0],u[t+6|0]=l[k+e0|0],u[t+23|0]=l[k+N0|0],u[t+7|0]=l[k+q0|0],k=s+2|0,u[t+24|0]=l[k|0],u[t+8|0]=l[k+r0|0],u[t+25|0]=l[k+w|0],u[t+9|0]=l[k+U0|0],u[t+26|0]=l[k+L|0],u[t+10|0]=l[k+e0|0],u[t+27|0]=l[k+N0|0],u[t+11|0]=l[k+q0|0],n=s+3|0,u[t+28|0]=l[n|0],_=l[n+r0|0],u[t+12|0]=_,u[t+29|0]=l[n+w|0],k=l[n+U0|0],u[t+13|0]=k,u[t+30|0]=l[n+L|0],R=l[n+e0|0],u[t+14|0]=R,u[t+31|0]=l[n+N0|0],n=n+q0|0;break A}n=k+(f+(d0<<e1)|0)|0,i[t+16>>2]=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),f=l[s-1|0],u[t|0]=f,W=l[s-2|0],u[t+1|0]=W,a=l[s-3|0],u[t+2|0]=a,O=l[s-4|0],u[t+3|0]=O,k=n+w|0,i[t+20>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=s+w|0,u[t+4|0]=l[k-1|0],u[t+5|0]=l[k-2|0],u[t+6|0]=l[k-3|0],u[t+7|0]=l[k-4|0],k=n+L|0,i[t+24>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=s+L|0,u[t+8|0]=l[k-1|0],u[t+9|0]=l[k-2|0],u[t+10|0]=l[k-3|0],u[t+11|0]=l[k-4|0],k=n+N0|0,i[t+28>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),n=s+N0|0,_=l[n-1|0],u[t+12|0]=_,k=l[n-2|0],u[t+13|0]=k,R=l[n-3|0],u[t+14|0]=R,n=n-4|0}if(P0=l[n|0],u[t+15|0]=P0,I=i[A+168>>2],o=g>>I,(o|0)<0||(m=i[A+172>>2],(m|0)<=(o|0)))break i;if(n=L0>>I,(n|0)<0||(V=i[A+176>>2],(V|0)<=(n|0)))break e;N=i[A+160>>2],x=N+G(o,3)|0,S=G(G(n,m),3),$=x+S|0,D0=u[$+2|0];A:{if(!e){if(n=E2>>I,(n|0)<0|(n|0)>=(V|0))break e;A0=(x+G(G(n,m),3)|0)+2|0;break A}if(n=g-1>>I,(n|0)<0|n>>>0>=m>>>0)break i;A0=(S+(N+G(n,3)|0)|0)+2|0}if(n=i[A+148>>2],n0=g>>n,(n0|0)<0||(h0=i[A+152>>2],(h0|0)<=(n0|0)))break i;if(C=L0>>n,(C|0)<0|(C|0)>=i[A+156>>2])break e;if(m0=l[t+28|0],h=m0+(l[t+30|0]-(l[t+29|0]<<1)|0)|0,W0=h>>31,_=_&255,o=_+(R-((k&255)<<1)|0)|0,Q0=o>>31,H0=l[t+16|0],n=H0+(l[t+18|0]-(l[t+17|0]<<1)|0)|0,V0=n>>31,k=(a-(W<<1)|0)+f|0,R=k>>31,a=(h^W0)-W0|0,W0=(o^Q0)-Q0|0,Q0=a+W0|0,V0=(n^V0)-V0|0,R=(k^R)-R|0,h=V0+R|0,n=(D0+u[A0|0]|0)+1>>1,o=i[i[A+52>>2]+(F[((i[A+140>>2]+G(n0,24)|0)+G(G(C,h0),24)|0)+2>>1]<<2)>>2],k=n+i[o+764>>2]|0,k=(k|0)>=51?51:k,C=l[((k|0)>0?k:0)+60752|0]<<Q2,(Q0+h|0)>=(C|0))break f;k=(i[o+768>>2]+(n+(B<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,f0=l[((k|0)>0?k:0)+60816|0]<<Q2,W=0,n=h<<1,h=C>>>2|0,k=0;A:{if(n>>>0>=h>>>0||(o=H0-l[t+19|0]|0,D0=o>>31,n=O-f|0,h0=n>>31,k=0,(o^D0)-D0+((n^h0)-h0)>>>0>=C>>>3>>>0))break A;f=f-H0|0,k=f>>31,k=((f^k)-k|0)<G(f0,5)+1>>1}f=k;A:{if(h>>>0<=Q0<<1>>>0||(n=m0-l[t+31|0]|0,h=n>>31,k=P0-_|0,o=k>>31,(n^h)-h+((k^o)-o)>>>0>=C>>>3>>>0))break A;k=_-m0|0,n=k>>31,W=((k^n)-n|0)<G(f0,5)+1>>1}o=l[g2+8812|0];A:{if(!e){if(n=E2>>I,o){if((n|0)<0|(n|0)>=(V|0))break e;k=!(l[(x+G(G(n,m),3)|0)+1|0]&4)}else k=1;if((n|0)<0|(n|0)>=(V|0))break e;n=x+G(G(n,m),3)|0;break A}if(n=g-1>>I,o){if((n|0)<0|n>>>0>=m>>>0)break i;k=!(l[(S+(N+G(n,3)|0)|0)+1|0]&4)}else k=1;if((n|0)<0|n>>>0>=m>>>0)break i;n=S+(N+G(n,3)|0)|0}for(P0=f&W,N=!(l[n+1|0]&8)&k,f=C+(C>>>1|0)>>>3|0,D0=N&f>>>0>R+W0>>>0,k=f>>>0>a+V0>>>0,f=l[$|0]|l[$+1|0]<<8,V=!(f&2048)&(!o|!(f&1024)),h0=k&V,D=f0<<1,f=0,H0=0-f0|0,a=G(f0,10),W0=s+1|0,Q0=s+w|0,V0=s-2|0,R=s-1|0,O=f0>>1,$=0-O|0;;){k=f<<2,A0=k+t|0,m=l[A0+1|0],_=k+(t+16|0)|0,x=l[_+2|0],g=l[_+1|0],W=l[_|0],S=l[A0+2|0],I=l[A0|0];A:{if(!P0){if(n=(G(W-I|0,9)+G(g-m|0,-3)|0)+8>>4,k=n>>31,(a|0)<=((k^n)-k|0))break A;n=(n|0)<(H0|0)?H0:(n|0)<(f0|0)?n:f0;k:{n:{if(!e){if(N&&(k=n+I|0,u[s+(f-w|0)|0]=(k|0)>=0?(k|0)<(y|0)?k:y:0),!V)break k;k=W-n|0,_=(k|0)>=0?(k|0)<(y|0)?k:y:0,k=f;break n}if(N&&(k=n+I|0,u[R+G(f,w)|0]=(k|0)>=0?(k|0)<(y|0)?k:y:0),!V)break k;k=W-n|0,_=(k|0)>=0?(k|0)<(y|0)?k:y:0,k=G(f,w)}u[k+s|0]=_}k:{if(!D0)break k;if(k=n+(((I+S|0)+1>>>1|0)-m|0)>>1,k=((k|0)<($|0)?$:(k|0)<(O|0)?k:O)+m|0,k=(k|0)>=0?(k|0)<(y|0)?k:y:0,!e){u[s+(f-b2|0)|0]=k;break k}u[V0+G(f,w)|0]=k}if(!h0)break A;if(k=((W+x|0)+1>>>1)-(n+g)>>1,k=g+((k|0)<($|0)?$:(k|0)<(O|0)?k:O)|0,k=(k|0)>=0?(k|0)<(y|0)?k:y:0,!e){u[f+Q0|0]=k;break A}u[W0+G(f,w)|0]=k;break A}if(n=g-D|0,o=W+I|0,h=o+g|0,B=(h+x|0)+2>>>2|0,k=g+D|0,n0=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=m-D|0,o=o+m|0,B=(o+S|0)+2>>>2|0,k=m+D|0,C=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=x-D|0,h=((h+G(x,3)|0)+(l[_+3|0]<<1)|0)+4>>>3|0,k=D+x|0,m0=(n|0)>(h|0)?n:(k|0)>(h|0)?h:k,n=S-D|0,o=((o+G(S,3)|0)+(l[A0+3|0]<<1)|0)+4>>>3|0,k=D+S|0,_=(n|0)>(o|0)?n:(k|0)>(o|0)?o:k,n=W-D|0,o=W<<1,h=(I<<1)+4|0,B=x+((o+(h+m|0)|0)+(g<<1)|0)>>>3|0,k=W+D|0,B=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=I-D|0,o=g+(o+((h+S|0)+(m<<1)|0)|0)>>>3|0,k=I+D|0,k=(n|0)>(o|0)?n:(k|0)>(o|0)?o:k,!e){if(n=f+s|0,!N){if(!V)break A;u[n|0]=B,u[n+w|0]=n0,u[n+L|0]=m0;break A}if(!V){u[n+r0|0]=k,u[n+U0|0]=C,u[n+e0|0]=_;break A}u[n+r0|0]=k,u[n|0]=B,u[n+U0|0]=C,u[n+w|0]=n0,u[n+e0|0]=_,u[n+L|0]=m0;break A}if(n=s+G(f,w)|0,N&&(u[n-1|0]=k),V&&(u[n|0]=B),N&&(u[n-2|0]=C),V&&(u[n+1|0]=n0),N&&(u[n-3|0]=_),!V)break A;u[n+2|0]=m0}if(f=f+1|0,(f|0)==4)break}}if(d0=d0+1|0,$0=$0+T2|0,!((Z2|0)>($0|0)))break}if(r=r+H2|0,!((n2|0)>(r|0)))break}}v=t+32|0;return}M0(4618,10893,119,4231),H()}M0(4656,10893,118,4231),H()}function rr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-208|0,v=n,s=i[e+108>>2],h=i[e+104>>2],w=s-h>>5;i:{if((s|0)==(h|0))break i;for(o=w>>>0<=1?1:w;;){if(i[(t<<5)+h>>2]==(r|0))break i;if(t=t+1|0,(o|0)==(t|0))break}t=o}if(B=e+104|0,(t|0)==(w|0)){Q[n+36>>1]=0,Q[n+38>>1]=0,Q[n+40>>1]=0,Q[n+42>>1]=0,Q[n+30>>1]=0,Q[n+32>>1]=0,Q[n+34>>1]=0,Q[n+36>>1]=0,Q[n+22>>1]=0,Q[n+24>>1]=0,Q[n+26>>1]=0,Q[n+28>>1]=0,u[n+20|0]=k,i[n+16>>2]=r;i:{if(s>>>0<u0[e+112>>2]){r=i[n+20>>2],i[s>>2]=i[n+16>>2],i[s+4>>2]=r,r=i[n+28>>2],i[s+8>>2]=i[n+24>>2],i[s+12>>2]=r,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0,lA(s+16|0,0,0,0),i[e+108>>2]=s+32;break i}if(r=b9(B,n+16|0),o=i[n+32>>2],i[e+108>>2]=r,!o)break i;if(r=o,h=i[n+36>>2],(r|0)!=(h|0)){for(;r=i[h-16>>2],r&&(i[h-12>>2]=r,Z(r)),h=h-40|0,(o|0)!=(h|0););r=i[n+32>>2]}i[n+36>>2]=o,Z(r)}h=i[B>>2]}i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,i[n+184>>2]=0,i[n+188>>2]=0,i[n+176>>2]=0,i[n+180>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,o=i[f+4>>2],s=i[f>>2],_=o-s|0,i[n+184>>2]=_,i[n+188>>2]=0;i:{e:{r:{f:{A:{if(!(!(u[e+132|0]&1)|k)){if(e=rl(i[e+136>>2],s,_),(e|0)<0){i[n+108>>2]=0,i[n+80>>2]=72244,i[n+24>>2]=72224,e=i[18065],i[n+16>>2]=e,r=i[e-12>>2],k=n+16|0,e=k,i[r+e>>2]=i[18066],i[n+20>>2]=0,e=e+i[i[n+16>>2]-12>>2]|0,f=n+28|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[n+24>>2]=e,r=n+24|0,i[r+i[e-12>>2]>>2]=i[18068],e=i[18064],i[n+16>>2]=e,i[k+i[e-12>>2]>>2]=i[18069],i[n+80>>2]=72244,i[n+16>>2]=72204,i[n+24>>2]=72224,k=R0(f),i[k>>2]=71280,i[n+68>>2]=0,i[n+72>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+76>>2]=24,S0(Y(r,27716,35),i[31336]),e=i[n+76>>2];k:{if(e&16){t=i[n+72>>2],e=i[n+52>>2],t>>>0<e>>>0&&(i[n+72>>2]=e,t=e),e=n+48|0;break k}if(!(e&8)){t=0,u[n+15|0]=0,r=n+4|0;break e}t=i[n+44>>2],e=n+36|0}if(f=i[e>>2],t=t-f|0,t>>>0>=2147483640)break f;if(t>>>0>=11){e=t|7,r=E(e+1|0),i[n+12>>2]=e-2147483647,i[n+4>>2]=r,i[n+8>>2]=t;break r}if(u[n+15|0]=t,r=n+4|0,t)break r;t=0;break e}if((e|0)==(i[f+4>>2]-i[f>>2]|0))break A;if(e=E(48),i[n+16>>2]=e,i[n+20>>2]=43,i[n+24>>2]=-2147483600,f=l[26674]|l[26675]<<8|(l[26676]<<16|l[26677]<<24),r=l[26670]|l[26671]<<8|(l[26672]<<16|l[26673]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+43|0]=0,r=l[26709]|l[26710]<<8|(l[26711]<<16|l[26712]<<24),u[e+39|0]=r,u[e+40|0]=r>>>8,u[e+41|0]=r>>>16,u[e+42|0]=r>>>24,f=l[26706]|l[26707]<<8|(l[26708]<<16|l[26709]<<24),r=l[26702]|l[26703]<<8|(l[26704]<<16|l[26705]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[26698]|l[26699]<<8|(l[26700]<<16|l[26701]<<24),r=l[26694]|l[26695]<<8|(l[26696]<<16|l[26697]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[26690]|l[26691]<<8|(l[26692]<<16|l[26693]<<24),r=l[26686]|l[26687]<<8|(l[26688]<<16|l[26689]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[26682]|l[26683]<<8|(l[26684]<<16|l[26685]<<24),r=l[26678]|l[26679]<<8|(l[26680]<<16|l[26681]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,9,0,n+16|0),u[n+27|0]>=0)break i;Z(i[n+16>>2]);break i}if(r=(t<<5)+h|0,w=i[r+20>>2],(w|0)!=i[r+16>>2]){if(r=w-16|0,e=w-12|0,$4(r,i[e>>2],s,o,_),r=i[e>>2]-i[r>>2]|0,e=w-24|0,i[e>>2]=r,i[e+4>>2]=0,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931]);break i}if(r=n+192|0,(r|0)!=(f|0)&&d4(r,s,o,_),(k|0)!=1)break A;k=i[e+128>>2],r=k,i[n+176>>2]=r,i[n+180>>2]=r>>31,r=i[f+4>>2]-i[f>>2]|0,i[n+184>>2]=r,i[n+188>>2]=0,i[e+128>>2]=r+k}k=i[B>>2]+(t<<5)|0,e=i[k+20>>2];A:{if(u0[k+24>>2]>e>>>0){r=i[n+172>>2],i[e>>2]=i[n+168>>2],i[e+4>>2]=r,r=i[n+188>>2],i[e+16>>2]=i[n+184>>2],i[e+20>>2]=r,r=i[n+180>>2],i[e+8>>2]=i[n+176>>2],i[e+12>>2]=r,i[e+32>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+24>>2]=i[n+192>>2],i[e+28>>2]=i[n+196>>2],i[e+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,e=e+40|0;break A}k:{n:{if(w=i[k+20>>2],e=i[k+16>>2],o=w-e|0,t=((o|0)/40|0)+1|0,t>>>0<107374183){if(f=(i[k+24>>2]-e|0)/40|0,r=f<<1,r=f>>>0>=53687091?107374182:r>>>0>t>>>0?r:t,r>>>0>=107374183)break n;if(B=G(r,40),s=E(B),_=s+o|0,f=_,r=i[n+172>>2],i[f>>2]=i[n+168>>2],i[f+4>>2]=r,r=i[n+188>>2],i[f+16>>2]=i[n+184>>2],i[f+20>>2]=r,r=i[n+180>>2],i[f+8>>2]=i[n+176>>2],i[f+12>>2]=r,i[f+24>>2]=i[n+192>>2],i[f+28>>2]=i[n+196>>2],i[f+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,t=f+G((o|0)/-40|0,40)|0,(e|0)!=(w|0)){for(r=e,f=t;o=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=o,o=i[r+20>>2],i[f+16>>2]=i[r+16>>2],i[f+20>>2]=o,o=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=o,i[f+24>>2]=i[r+24>>2],i[f+28>>2]=i[r+28>>2],i[f+32>>2]=i[r+32>>2],i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,f=f+40|0,r=r+40|0,(w|0)!=(r|0););for(;r=i[e+24>>2],r&&(i[e+28>>2]=r,Z(r)),e=e+40|0,(w|0)!=(e|0););e=i[k+16>>2]}i[k+24>>2]=s+B,r=_+40|0,i[k+20>>2]=r,i[k+16>>2]=t,e&&Z(e),e=r;break k}G0(),H()}x0(),H()}}if(i[k+20>>2]=e,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931]);break i}g0(),H()}if(!t)break e;z(r,f,t)}u[r+t|0]=0,K(A,9,0,n+4|0),u[n+15|0]<0&&Z(i[n+4>>2]),A=i[18063],i[n+16>>2]=A,i[i[A-12>>2]+(n+16|0)>>2]=i[18071],i[n+24>>2]=i[18072],i[k>>2]=71280,u[n+71|0]<0&&Z(i[n+60>>2]),y0(k),p0(n+80|0)}A=i[n+192>>2],A&&(i[n+196>>2]=A,Z(A)),v=n+208|0}function fr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0;f=i[A+18588>>2],g=i[f+132>>2],R=i[f+124>>2],D=i[R+16892>>2];i:{e:{r:{f:{if(!l[g+45|0]|r||(r=i[A+12>>2],i[A+8>>2]|(r|0)<=0))break f;if(x=2,(D|0)>=2){if(r=r-1|0,k=i[A+18596>>2],r>>>0>=i[k+472>>2]-i[k+468>>2]>>3>>>0)break r;F8(f,i[A+18604>>2],1,r,1),ni(A+18572|0,(i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0),Zo((i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0);break f}if(F8(f,i[A+18604>>2],0,r-1|0,1),r=i[A+18592>>2],f=i[r+804>>2],f>>>0>=3)break e;ji(A+18572|0,f,i[r+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0}for(S=A+18548|0,m0=A+18572|0,V0=D-1|0,_=i[A+12>>2],r=i[A+8>>2],x=2;;){if(W0=G(_,D)+r|0,i[R+16892>>2]<=(r|0)|W0>>>0>=i[g+8452>>2]-i[g+8448>>2]>>2>>>0|i[R+16900>>2]<=(_|0)||(!e|(_|0)<=0|(r|0)>=(V0|0)||F8(i[A+18588>>2],i[A+18604>>2],r+1|0,_-1|0,1),!i[A+18576>>2]))break r;C=0,O=0,f=i[A>>2],k=i[A+18588>>2],L=i[k+124>>2],t=i[L+16892>>2],s=(f|0)/(t|0)|0,m=f-G(t,s)|0,f=i[L+16876>>2],h=m<<f,t=i[A+18592>>2],n=i[k+152>>2],(n|0)<=(m|0)|(s|0)>=i[k+156>>2]||(Q[(i[k+140>>2]+G(m,24)|0)+G(G(n,s),24)>>1]=i[t+808>>2]);f:{A:{if(o=i[k+148>>2],w=h>>o,!((w|0)<0|(n|0)<=(w|0))){if(I=s<<f,o=I>>o,(o|0)<0|(o|0)>=i[k+156>>2])break A;if(Q[((i[k+140>>2]+G(w,24)|0)+G(G(n,o),24)|0)+2>>1]=i[t>>2],e0=h,r0=I,l[t+333|0]|l[t+334|0]){t=v-32|0,v=t,N=i[A+18592>>2],w=i[A+18588>>2],a=i[w+132>>2],n=i[w+124>>2],u[t+24|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,f=0;k:{if((m|0)<=0||(f=0,i[A>>2]<=i[N+808>>2])||(k=(i[a+8484>>2]+(m<<2)|0)+(G(s,i[n+16892>>2])<<2)|0,f=0,i[k>>2]!=i[k-4>>2]))break k;f=v2(A+18548|0,i[A+18572>>2])}k:{if(f&255|(s|0)<=0||(k=i[n+16892>>2],i[N+808>>2]>(i[A>>2]-k|0))||(o=i[a+8484>>2]+(m<<2)|0,i[o+(G(k,s)<<2)>>2]!=i[o+(G(k,s-1|0)<<2)>>2]))break k;O=(v2(A+18548|0,i[A+18572>>2])&255)!=0}if(Q0=f&255,!(O|Q0)){for(k=A+18548|0,N0=t+16|0,f=t+8|0,U0=f|7,D0=f|6,H0=f|2,L0=f|5,q0=i[n+16848>>2],n=0,o=0;;){k:{n:{t:{u:{o:{if(!l[N+333|0]||n){if(!n|!l[N+334|0])break k;if((n|0)!=1)break t;if(v2(k,i[A+18572>>2]+1|0))break o;f=0;break u}if(!v2(k,i[A+18572>>2]+1|0)){o=0,f=0;break n}o=k4(k)?2:1,f=o;break n}f=k4(k)?2:1}o=f<<2|f<<4|o;break n}f=(o&255)>>>(n<<1)&3}if(!f)break k;h=n<<2,$=h+L0|0,W=n?16840:16832,B=i[W+i[w+124>>2]>>2],B=we(k,-1<<((B|0)>=10?10:B)-5^-1),u[$|0]=B,f0=h+D0|0,V=i[W+i[w+124>>2]>>2],V=we(k,-1<<((V|0)>=10?10:V)-5^-1),u[f0|0]=V,A0=h+U0|0,y=i[W+i[w+124>>2]>>2],y=we(k,-1<<((y|0)>=10?10:y)-5^-1),u[A0|0]=y,n0=h+N0|0,h=i[W+i[w+124>>2]>>2],W=we(k,-1<<((h|0)>=10?10:h)-5^-1),u[n0|0]=W;n:{if((f|0)==1){f=0,I=0,B&255&&(I=k4(k)?-1:1),V&255&&(f=k4(k)?-1:1),h=0,h0=0,y&255&&(h0=k4(k)?-1:1),W&255&&(h=k4(k)?-1:1),P0=n+H0|0,d0=C8(k,5),u[P0|0]=d0,W=l[n0|0],y=l[A0|0],V=l[f0|0],B=l[$|0];break n}t:{if(!n){f=1,h=-1,C=C8(k,2);break t}if(f=1,h=-1,(n|0)!=1)break t;I=C,C=C8(k,2),C=I|(C<<2|C<<4)}h0=-1,I=1}$0=B,B=l[(n?8264:8263)+a|0],u[$|0]=G($0<<B,I),u[f0|0]=G(V<<B,f),u[A0|0]=G(y<<B,h0),u[n0|0]=G(W<<B,h)}if(!(q0&&(f=n>>>0<2,n=n+1|0,f)))break}u[t+8|0]=o,u[t+9|0]=C,f=(i[w+140>>2]+G(m,24)|0)+G(G(s,i[w+152>>2]),24)|0,u[f+20|0]=l[t+24|0],k=i[t+20>>2],n=i[t+16>>2],u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,u[f+16|0]=k,u[f+17|0]=k>>>8,u[f+18|0]=k>>>16,u[f+19|0]=k>>>24,k=i[t+12>>2],n=i[t+8>>2],u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+8|0]=k,u[f+9|0]=k>>>8,u[f+10|0]=k>>>16,u[f+11|0]=k>>>24}Q0&&(f=(i[w+140>>2]+G(m,24)|0)+G(G(s,i[w+152>>2]),24)|0,k=f-20|0,n=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),o=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),u[f+4|0]=o,u[f+5|0]=o>>>8,u[f+6|0]=o>>>16,u[f+7|0]=o>>>24,u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+20|0]=l[k+16|0],n=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),k=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24),O&&(n=i[w+140>>2]+G(m,24)|0,k=i[w+152>>2],f=n+G(G(k,s),24)|0,k=n+G(G(k,s-1|0),24)|0,u[f+20|0]=l[k+20|0],n=l[k+16|0]|l[k+17|0]<<8|(l[k+18|0]<<16|l[k+19|0]<<24),s=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),u[f+12|0]=s,u[f+13|0]=s>>>8,u[f+14|0]=s>>>16,u[f+15|0]=s>>>24,u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,n=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),k=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24),v=t+32|0,f=i[L+16876>>2]}er(A,e0,r0,f,0);break f}M0(4656,10893,128,4231),H()}M0(4618,10893,129,4231),H()}if(!(!l[g+45|0]|(r|0)!=1|(i[R+16900>>2]-1|0)<=(_|0))){if(f=i[A+18596>>2],r=i[f+468>>2],i[f+472>>2]-r>>3>>>0<=_>>>0)break r;f=r,r=_<<3,ni(f+r|0,m0),to(r+i[i[A+18596>>2]+468>>2]|0)}if(k=MA(S),!k|!l[g+14|0]||(ni(i[A+18592>>2]+1340|0,m0),to(i[A+18592>>2]+1340|0),u[i[A+18592>>2]+1348|0]=1),r=i[i[A+18588>>2]+320>>2]+G(W0,76)|0,i[r>>2]<=0&&(i[r>>2]=1),s=i[A+4>>2],f=s+1|0,i[A+4>>2]=f,w=i[A+12>>2],_=i[A+18588>>2],n=i[_+124>>2],t=i[n+16908>>2],n=i[n+16892>>2],r=(f|0)<(t|0)?i[i[i[_+132>>2]+8460>>2]+(f<<2)>>2]:t,i[A>>2]=r,_=(r|0)/(n|0)|0,i[A+12>>2]=_,r=r-G(n,_)|0,i[A+8>>2]=r,!((f|0)<(t|0)|k)){C2(i[A+18584>>2]+4|0,1004,0);break i}if(k)return 0;if(l[g+46|0]?(t=f<<2,f=i[g+8472>>2],f=i[t+f>>2]!=i[f+(s<<2)>>2]):f=0,!!(f|l[g+45|0]!=0&(w|0)!=(_|0)))break}if(!MA(S)){C2(i[A+18584>>2]+4|0,1017,0);break i}Ze(S),x=1}return x}M0(21701,18308,1520,5105),H()}return u[i[A+18588>>2]+312|0]=3,2}function CB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0;s=v-128|0,v=s,_=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),D=u1(i[r>>2],6),D&&(f0=j0(i[r>>2],6));i:{if(!(!(_>>>0<9|t>>>0<9)&n>>>0>8)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((t|0)==(_|0)&(n|0)==(_|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],B=i[e+112>>2],W=i[e+108>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],m=w+12|0,i[w+96>>2]=m,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[m+120>>2]=2,i[m+116>>2]=0,i[m+112>>2]=B,i[m+108>>2]=W,T0(s+56|0,m,0,W,B,_,o),g=W+1>>>1|0,T0(s+32|0,m,1,g,B,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,m,2,g,B,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!D)break r;if(T0(s+104|0,m,6,W,B,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0;r:{f:{if(t=i[e+128>>2],t){for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);y=0;A:{if((e|0)==(f|0)||(y=0,i[e+16>>2]>0))break A;h0=i[e+44>>2],y=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);C=0;A:{if((e|0)==(f|0)||(C=0,i[e+16>>2]>1))break A;I=i[e+56>>2],C=i[e+44>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}R=0;break r}if(R=0,i[e+16>>2]>2)break r;x=i[e+56>>2]>>>1|0,R=i[e+44>>2]}r:{f:{e=i[k>>2];A:{if(!e){o=0;break A}for(n=k,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);N=0;k:{if((k|0)==(n|0)||(N=0,i[n+16>>2]>0))break k;m0=i[n+44>>2],N=i[n+56>>2]}for(n=k,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;k:{if((k|0)==(n|0)||(o=0,i[n+16>>2]>1))break k;A0=i[n+44>>2],o=i[n+56>>2]}for(n=k,r=e;_=i[r+16>>2]<2,n=_?n:r,r=i[(_?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;S=i[n+56>>2]>>>1|0,r=i[n+44>>2]}_=r,n=0,h=0;r:{if(!D)break r;f:{A:{if(!t)break A;for(r=f;O=i[t+16>>2]<6,r=O?r:t,t=i[(O?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;W0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(O=f,h=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(h=0,(r|0)==(k|0)||(h=0,i[r+16>>2]>6))break r;n=i[r+56>>2],h=i[r+44>>2]}e=h,L=o>>>1|0,a=I>>>1|0;r:{f:{A:{if(!(W&1))break A;if(k=B-1|0,!k)break f;if(f=g<<1,g=(f+_|0)-2|0,r=W<<1,I=(r+R|0)-2|0,V=(f+A0|0)-2|0,o=(r+C|0)-2|0,r=0,(B|0)!=2)for(f=k&-2;Q[V+(G(r,L)<<1)>>1]=F[o+(G(r,a)<<1)>>1],Q[g+(G(r,S)<<1)>>1]=F[I+(G(r,x)<<1)>>1],t=r|1,Q[V+(G(t,L)<<1)>>1]=F[o+(G(t,a)<<1)>>1],Q[g+(G(t,S)<<1)>>1]=F[I+(G(t,x)<<1)>>1],r=r+2|0,$=$+2|0,(f|0)!=($|0););if(!(k&1))break A;Q[V+(G(r,L)<<1)>>1]=F[o+(G(r,a)<<1)>>1],Q[g+(G(r,S)<<1)>>1]=F[I+(G(r,x)<<1)>>1]}if(!B)break r}if(n0=W-1|0,n0)for(o=0;;){for(h=(G(o,S)<<1)+_|0,g=(G(o,L)<<1)+A0|0,I=(G(o,x)<<1)+R|0,$=(G(o,a)<<1)+C|0,r=0;V=r<<1,f=V+I|0,t=F[f>>1],k=F[f+2>>1],f=V+$|0,Q[r+g>>1]=(F[f>>1]+F[f+2>>1]|0)+1>>>1,Q[r+h>>1]=(k+t|0)+1>>>1,r=r+2|0,n0>>>0>r>>>0;);if(o=o+1|0,(B|0)==(o|0))break}for(k=N>>>1|0,f=y>>>1|0,o=W<<1,t=f0>>>0>8?o:W,r=0;o&&z((G(r,k)<<1)+m0|0,(G(r,f)<<1)+h0|0,o),!D|!t||z(G(r,n)+e|0,G(r,O)+W0|0,t),r=r+1|0,(B|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=m;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+128|0}function VB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;if(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=72548,k=i[18140],i[f+4>>2]=k,t=i[k-12>>2],k=f+4|0,i[t+k>>2]=i[18141],t=k+i[i[f+4>>2]-12>>2]|0,n=f+8|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+60>>2]=72548,i[f+4>>2]=72528,W=R0(n),i[W>>2]=71280,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,t=f+164|0,Y2(t,e,r),w=k,n=t,k=u[f+175|0],t=(k|0)<0,Y(w,t?i[f+164>>2]:n,t?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),m=i[e+104>>2],g=i[e+108>>2],(m|0)!=(g|0))for(;;){if(e=f+164|0,s0(e,r),t=e,e=u[f+175|0],k=(e|0)<0,Y(f+4|0,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),Y(I0(Y(f+4|0,32598,26),i[m>>2]),42713,1),e=i[r>>2]+1|0,i[r>>2]=e,_=i[m+4>>2],I=i[m+8>>2],(_|0)!=(I|0)){i:{e:{for(;;){r:{s0(f+144|0,r),n=u[f+155|0],w=i[f+144>>2],h=i[f+148>>2],e=f+4|0,B=G1(f+156|0,e);f:{if(l[B|0]!=1)break f;k=e+i[i[f+4>>2]-12>>2]|0,V=i[k+4>>2],o=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}s=f+164|0,e=i[k+28>>2],i[s>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(s,129808),t=X[i[i[e>>2]+28>>2]](e,32)|0,e2(s),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!o||(s=i[k+12>>2],e=w,w=(n|0)<0,e=w?e:f+144|0,n=w?h:n,C=e+n|0,w=(V&176)==32?C:e,h=w-e|0,(h|0)>0&&(X[i[i[o>>2]+48>>2]](o,e,h)|0)!=(h|0)))break A;if(n=(n|0)<(s|0)?s-n|0:0,(n|0)>0){if(n>>>0>=2147483640)break r;k:{if(n>>>0>=11){s=n|7,e=E(s+1|0),i[f+172>>2]=s-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=X[i[i[o>>2]+48>>2]](o,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=C-w|0,(e|0)>0&&(X[i[i[o>>2]+48>>2]](o,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}_1(B),u[f+155|0]<0&&Z(i[f+144>>2]),e=f+4|0,w=G1(f+144|0,e);f:{if(l[w|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,s=i[e+4>>2],n=i[e+24>>2];A:{if(l[e+80|0]==1){t=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}o=f+164|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129808),t=X[i[i[k>>2]+28>>2]](k,32)|0,e2(o),u[e+76|0]=t,u[e+77|0]=t>>>8,u[e+78|0]=t>>>16,u[e+79|0]=t>>>24,u[e+80|0]=1}A:{if(!n||(o=i[e+12>>2],s=(s&176)==32?29523:29507,k=s-29507|0,(k|0)>0&&(X[i[i[n>>2]+48>>2]](n,29507,k)|0)!=(k|0)))break A;if((o|0)>=17){k=((o|0)<=16?16:o)-16|0;k:{if(o>>>0>=27){h=k|7,o=E(h+1|0),i[f+172>>2]=h-2147483647,i[f+164>>2]=o,i[f+168>>2]=k;break k}u[f+175|0]=k,o=f+164|0}if(k&&o0(o,t,k),u[k+o|0]=0,t=X[i[i[n>>2]+48>>2]](n,u[f+175|0]<0?i[f+164>>2]:f+164|0,k)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break A}if(k=29523-s|0,(k|0)>0&&(X[i[i[n>>2]+48>>2]](n,s,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}_1(w),o=I0(f+4|0,F[_+2>>1]),h=G1(f+144|0,o);f:{if(l[h|0]!=1)break f;k=o+i[i[o>>2]-12>>2]|0,w=i[k+4>>2],s=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129808),t=X[i[i[e>>2]+28>>2]](e,32)|0,e2(n),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!s||(e=i[k+12>>2],w=(w&176)==32?30948:30935,n=w-30935|0,(n|0)>0&&(X[i[i[s>>2]+48>>2]](s,30935,n)|0)!=(n|0)))break A;if((e|0)>=14){n=((e|0)<=13?13:e)-13|0;k:{if(e>>>0>=24){B=n|7,e=E(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=X[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=30948-w|0,(e|0)>0&&(X[i[i[s>>2]+48>>2]](s,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=o+i[i[o>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}_1(h),e=o+i[i[o>>2]-12>>2]|0,i[e+4>>2]=i[e+4>>2]|1,s=li(o,l[_|0]),h=G1(f+144|0,s);f:{if(l[h|0]!=1)break f;k=s+i[i[s>>2]-12>>2]|0,w=i[k+4>>2],o=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129808),t=X[i[i[e>>2]+28>>2]](e,32)|0,e2(n),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!o||(e=i[k+12>>2],w=(w&176)==32?42714:42712,n=w-42712|0,(n|0)>0&&(X[i[i[o>>2]+48>>2]](o,42712,n)|0)!=(n|0)))break A;if((e|0)>=3){if(e>>>0>=2147483642)break e;n=((e|0)<=2?2:e)-2|0;k:{if(e>>>0>=13){B=n|7,e=E(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=X[i[i[o>>2]+48>>2]](o,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=42714-w|0,(e|0)>0&&(X[i[i[o>>2]+48>>2]](o,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=s+i[i[s>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}if(_1(h),_=_+4|0,(I|0)!=(_|0))continue;break i}break}g0(),H()}g0(),H()}e=i[r>>2]}if(i[r>>2]=((e|0)<=1?1:e)-1,m=m+16|0,(g|0)==(m|0))break}e=i[f+56>>2];i:{e:{if(e&16){_=f+28|0,r=i[f+52>>2],e=i[f+32>>2],r>>>0<e>>>0?i[f+52>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}_=f+16|0,e=i[f+24>>2]}e:{if(k=i[_>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[18142],i[W>>2]=71280,u[f+51|0]<0&&Z(i[f+40>>2]),y0(W),p0(f+60|0),v=f+176|0}function FB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;if(f=v-192|0,v=f,i[f+116>>2]=0,i[f+88>>2]=72548,n=i[18140],i[f+32>>2]=n,k=i[n-12>>2],n=f+32|0,i[k+n>>2]=i[18141],k=n+i[i[f+32>>2]-12>>2]|0,t=f+36|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,i[f+88>>2]=72548,i[f+32>>2]=72528,m=R0(t),i[m>>2]=71280,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=16,k=f+180|0,M1(k,e,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,Y(S0(Y(n,31283,17),l[e+104|0]+1|0),42713,1),l[e+105|0]==1&&(k=f+180|0,s0(k,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(I0(Y(f+32|0,29484,11),F[e+106>>1]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,29909,15),l[e+108|0]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(n,31520,21),n=l[e+109|0],n=(n|0)==1?3801:(n|0)==2?6905:7978,n=Y(Y(k,n,h2(n)),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(n,29785,15),n=i[(l[e+110|0]<<2)+99840>>2],n=Y(Y(k,n,h2(n)),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,31009,11),l[e+111|0]+8|0),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(I0(Y(n,32789,20),F[e+168>>1]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),Y(I0(Y(n,29717,20),F[e+170>>1]),42713,1),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(f+32|0,31918,17),l[e+113|0]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,31208,11),l[e+114|0]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,21078,14),l[e+115|0]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,31175,32),l[e+116|0]),42713,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),Y(S0(Y(n,31220,30),l[e+117|0]),42713,1)),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,Y(I0(Y(n,29817,15),i[e+180>>2]-i[e+176>>2]>>4),42713,1),k=f+180|0,s0(k,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),Y(f+32|0,41809,13),w=i[e+176>>2],W=i[e+180>>2],(w|0)!=(W|0))for(e=i[r>>2]+1|0;;){i[r>>2]=e,e=f+180|0,s0(e,r),k=e,e=u[f+191|0],n=(e|0)<0,Y(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(S0(Y(f+32|0,31809,10),l[w+1|0]),27190,2),e=l[w+1|0]-12&255,e>>>0>7?e=20223:e=i[(e<<2)+99936>>2],Y(Y(k,e,h2(e)),42712,2),e=f+180|0,s0(e,r),k=e,e=u[f+191|0],n=(e|0)<0,Y(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),u[f+191|0]<0&&Z(i[f+180>>2]),Y(S0(Y(f+32|0,29888,20),l[w|0]),42713,1);i:{if(e=i[w+4>>2],g=i[w+8>>2],(e|0)==(g|0))break i;for(;;){e:{i[r>>2]=i[r>>2]+1,n=f+20|0,s0(n,r),k=i[e>>2],j9(f+8|0,k,i[e+4>>2]-k|0,n,n),s=u[f+19|0],o=i[f+8>>2],_=i[f+12>>2],n=f+32|0,I=G1(f+172|0,n);r:{if(l[I|0]!=1)break r;k=n+i[i[f+32>>2]-12>>2]|0,V=i[k+4>>2],h=i[k+24>>2];f:{if(l[k+80|0]==1){n=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break f}t=f+180|0,n=i[k+28>>2],i[t>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129808),n=X[i[i[n>>2]+28>>2]](n,32)|0,e2(t),u[k+76|0]=n,u[k+77|0]=n>>>8,u[k+78|0]=n>>>16,u[k+79|0]=n>>>24,u[k+80|0]=1}f:{if(!h||(B=i[k+12>>2],t=o,o=(s|0)<0,t=o?t:f+8|0,s=o?_:s,C=t+s|0,o=(V&176)==32?C:t,_=o-t|0,(_|0)>0&&(X[i[i[h>>2]+48>>2]](h,t,_)|0)!=(_|0)))break f;if(t=(s|0)<(B|0)?B-s|0:0,(t|0)>0){if(t>>>0>=2147483640)break e;A:{if(t>>>0>=11){B=t|7,s=E(B+1|0),i[f+188>>2]=B-2147483647,i[f+180>>2]=s,i[f+184>>2]=t;break A}u[f+191|0]=t,s=f+180|0}if(t&&o0(s,n,t),u[t+s|0]=0,n=X[i[i[h>>2]+48>>2]](h,u[f+191|0]<0?i[f+180>>2]:f+180|0,t)|0,u[f+191|0]<0&&Z(i[f+180>>2]),(n|0)!=(t|0))break f}if(n=C-o|0,(n|0)>0&&(X[i[i[h>>2]+48>>2]](h,o,n)|0)!=(n|0))break f;i[k+12>>2]=0;break r}n=i[i[f+32>>2]-12>>2]+(f+32|0)|0,H1(n,i[n+16>>2]|5)}if(_1(I),u[f+19|0]<0&&Z(i[f+8>>2]),n=i[r>>2],i[r>>2]=((n|0)<=1?1:n)-1,u[f+31|0]<0&&Z(i[f+20>>2]),e=e+12|0,(g|0)!=(e|0))continue;break i}break}g0(),H()}if(e=i[r>>2],e=(e|0)<=1?1:e,i[r>>2]=e-1,w=w+16|0,(W|0)==(w|0))break}e=i[f+84>>2];i:{e:{if(e&16){r=i[f+80>>2],e=i[f+60>>2],r>>>0<e>>>0&&(i[f+80>>2]=e,r=e),e=f+56|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+52>>2],e=f+44|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+32>>2]=A,i[i[A-12>>2]+(f+32|0)>>2]=i[18142],i[m>>2]=71280,u[f+79|0]<0&&Z(i[f+68>>2]),y0(m),p0(f+88|0),v=f+192|0}function K7(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=M(0),m=0,W=0,g=M(0);_=v-16|0,v=_,i[_+12>>2]=r;i:{e:{if(t=i[k+4>>2],!t)break e;n=i[k>>2],h=Re(t),s=t-1&r;r:{if(h>>>0<=1||(s=r,r>>>0<t>>>0))break r;s=(r>>>0)%(t>>>0)|0}if(n=i[n+(s<<2)>>2],!n||(n=i[n>>2],!n))break e;r:{if(h>>>0<=1){for(o=t-1|0;;){t=i[n+4>>2];f:{if((t|0)!=(r|0)){if((s|0)==(t&o))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}for(;;){o=i[n+4>>2];f:{if((o|0)!=(r|0)){if(t>>>0<=o>>>0&&(o=(o>>>0)%(t>>>0)|0),(o|0)==(s|0))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}if(e=E(24),i[_>>2]=e,i[_+4>>2]=21,i[_+8>>2]=-2147483624,r=l[13603]|l[13604]<<8|(l[13605]<<16|l[13606]<<24),f=l[13599]|l[13600]<<8|(l[13601]<<16|l[13602]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,r=l[13616]|l[13617]<<8|(l[13618]<<16|l[13619]<<24),f=l[13612]|l[13613]<<8|(l[13614]<<16|l[13615]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[13611]|l[13612]<<8|(l[13613]<<16|l[13614]<<24),f=l[13607]|l[13608]<<8|(l[13609]<<16|l[13610]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,2008,_),u[_+11|0]>=0)break i;Z(i[_>>2]);break i}r=0,s=i[_+12>>2],t=i[k+4>>2];e:{r:{if(!t)break r;n=i[k>>2],o=Re(t),r=s&t-1;f:{if(o>>>0<=1||(r=s,r>>>0<t>>>0))break f;r=(r>>>0)%(t>>>0)|0}if(n=i[n+(r<<2)>>2],!n||(w=i[n>>2],!w))break r;if(o>>>0<=1){for(n=t-1|0;;){f:{if(o=i[w+4>>2],(o|0)!=(s|0)){if((n&o)!=(r|0))break r;break f}if((s|0)!=i[w+8>>2])break f;r=0;break e}if(w=i[w>>2],!w)break}break r}for(;;){f:{if(n=i[w+4>>2],(n|0)!=(s|0)){if(n>>>0>=t>>>0&&(n=(n>>>0)%(t>>>0)|0),(r|0)!=(n|0))break r;break f}if((s|0)!=i[w+8>>2])break f;r=0;break e}if(w=i[w>>2],!w)break}}w=E(12),i[w+4>>2]=s,i[w>>2]=0,i[w+8>>2]=i[_+12>>2],g=M(i[k+12>>2]+1>>>0),B=E0[k+16>>2];r:{if(!(g>M(B*M(t>>>0)))&&t)break r;r=2,o=(t-1&t)!=0|t>>>0<3|t<<1,B=M(g7(M(g/B))),B<M(4294967296)&B>=M(0)?n=~~B>>>0:n=0,n=n>>>0<o>>>0?o:n;f:{if((n|0)==1)break f;if(!(n&n-1)){r=n;break f}r=e9(n),t=i[k+4>>2]}f:{if(r>>>0<=t>>>0){if(r>>>0>=t>>>0)break f;B=M(g7(M(M(u0[k+12>>2])/E0[k+16>>2]))),B<M(4294967296)&B>=M(0)?n=~~B>>>0:n=0;A:{k:{if(t>>>0<3||Re(t)>>>0>1)break k;n=n>>>0<2?n:1<<32-k1(n-1|0);break A}n=e9(n)}if(r=r>>>0>n>>>0?r:n,t>>>0<=r>>>0)break f}h=r;A:{k:{n:{if(r){if(r>>>0>=1073741824)break n;if(r=r<<2,m=E(r),n=i[k>>2],i[k>>2]=m,n&&(Z(n),m=i[k>>2]),i[k+4>>2]=h,r&&o0(m,0,r),r=i[k+8>>2],!r)break A;if(n=k+8|0,t=i[r+4>>2],o=h-1|0,!(o&h))break k;for(t=t>>>0>=h>>>0?(t>>>0)%(h>>>0)|0:t,i[(t<<2)+m>>2]=n;;){if(o=i[r>>2],!o)break A;if(n=i[o+4>>2],h>>>0<=n>>>0&&(n=(n>>>0)%(h>>>0)|0),(n|0)==(t|0)){r=o;continue}W=(n<<2)+m|0,i[W>>2]?(i[r>>2]=i[o>>2],i[o>>2]=i[i[W>>2]>>2],i[i[W>>2]>>2]=o):(i[W>>2]=r,r=o,t=n)}}r=i[k>>2],i[k>>2]=0,r&&Z(r),i[k+4>>2]=0;break A}x0(),H()}if(t=t&o,i[(t<<2)+m>>2]=n,n=i[r>>2],!n)break A;for(W=h-1|0;;){o=W&i[n+4>>2];k:{if((o|0)==(t|0)){r=n;break k}if(h=(o<<2)+m|0,i[h>>2]){i[r>>2]=i[n>>2],i[n>>2]=i[i[h>>2]>>2],i[i[h>>2]>>2]=n;break k}i[h>>2]=r,r=n,t=o}if(n=i[r>>2],!n)break}}}if(t=i[k+4>>2],r=t-1|0,!(r&t)){r=r&s;break r}if(t>>>0>s>>>0){r=s;break r}r=(s>>>0)%(t>>>0)|0}n=i[k>>2],o=n+(r<<2)|0,r=i[o>>2];r:{if(!r){if(r=k+8|0,i[w>>2]=i[r>>2],i[k+8>>2]=w,i[o>>2]=r,r=i[w>>2],!r)break r;r=i[r+4>>2],o=t-1|0;f:{if(!(o&t)){r=r&o;break f}if(r>>>0<t>>>0)break f;r=(r>>>0)%(t>>>0)|0}i[n+(r<<2)>>2]=w;break r}i[w>>2]=i[r>>2],i[r>>2]=w}i[k+12>>2]=i[k+12>>2]+1,r=1}u[_+4|0]=r,i[_>>2]=w,L8(_,i[f>>2],i[_+12>>2],1684630887),n=i[_>>2],r=i[_+4>>2];e:{if((n|0)!=(r|0))for(;;){if(K7(A,e,i[n>>2],f,k),i[A>>2])break e;if(u[A+19|0]<0&&Z(i[A+8>>2]),n=n+4|0,(r|0)==(n|0))break}h=v-16|0,v=h,o=i[k+4>>2];r:{if(!o)break r;f=i[k>>2],r=i[_+12>>2],e=r&o-1,s=Re(o);f:{if(s>>>0<=1||(e=r,r>>>0<o>>>0))break f;e=(r>>>0)%(o>>>0)|0}if(n=e,e=i[(n<<2)+f>>2],!e||(e=i[e>>2],!e))break r;f:{if(s>>>0<=1){for(f=o-1|0;;){o=i[e+4>>2];A:{if((o|0)!=(r|0)){if((n|0)==(f&o))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}for(;;){f=i[e+4>>2];A:{if((f|0)!=(r|0)){if(f>>>0>=o>>>0&&(f=(f>>>0)%(o>>>0)|0),(f|0)==(n|0))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}t=i[e+4>>2],s=i[k+4>>2],w=Re(s);f:{if(w>>>0<=1){t=s-1&t;break f}if(t>>>0<s>>>0)break f;t=(t>>>0)%(s>>>0)|0}for(m=i[k>>2],n=m+(t<<2)|0,f=i[n>>2];r=f,f=i[r>>2],(f|0)!=(e|0););W=k+8|0;f:{if((W|0)!=(r|0)){f=i[r+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(t|0))break f}if(f=i[e>>2],f){f=i[f+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(t|0))break f}i[n>>2]=0}o=i[e>>2],n=0;f:{if(!o)break f;f=i[o+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if(n=o,(f|0)==(t|0))break f;i[m+(f<<2)>>2]=r,n=i[e>>2]}i[r>>2]=n,i[e>>2]=0,i[k+12>>2]=i[k+12>>2]-1,u[h+12|0]=1,i[h+8>>2]=W,i[h+4>>2]=e,e=i[h+4>>2],i[h+4>>2]=0,e&&Z(e)}if(v=h+16|0,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}if(A=i[_>>2],!A)break i;i[_+4>>2]=A,Z(A)}v=_+16|0}function EB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;f=v-96|0,v=f,i[f+56>>2]=0,i[f+60>>2]=0,e=f- -64|0,i[e>>2]=0,i[e+4>>2]=0,u[f+71|0]=0,u[f+72|0]=0,u[f+73|0]=0,u[f+74|0]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+76>>2]=0,i[f+80>>2]=0,i[f+88>>2]=0,u[f+84|0]=1;i:{e:{e=i[r>>2];r:{if(i[e+116>>2]!=2){e=E(40),i[f+12>>2]=e,i[f+16>>2]=39,i[f+20>>2]=-2147483608,r=l[8950]|l[8951]<<8|(l[8952]<<16|l[8953]<<24),k=l[8946]|l[8947]<<8|(l[8948]<<16|l[8949]<<24),u[e+31|0]=k,u[e+32|0]=k>>>8,u[e+33|0]=k>>>16,u[e+34|0]=k>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[8943]|l[8944]<<8|(l[8945]<<16|l[8946]<<24),k=l[8939]|l[8940]<<8|(l[8941]<<16|l[8942]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8935]|l[8936]<<8|(l[8937]<<16|l[8938]<<24),k=l[8931]|l[8932]<<8|(l[8933]<<16|l[8934]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8927]|l[8928]<<8|(l[8929]<<16|l[8930]<<24),k=l[8923]|l[8924]<<8|(l[8925]<<16|l[8926]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[8919]|l[8920]<<8|(l[8921]<<16|l[8922]<<24),k=l[8915]|l[8916]<<8|(l[8917]<<16|l[8918]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,e=K(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}if((j0(e,0)|0)!=8){e=E(40),i[f+12>>2]=e,i[f+16>>2]=37,i[f+20>>2]=-2147483608,r=l[8910]|l[8911]<<8|(l[8912]<<16|l[8913]<<24),k=l[8906]|l[8907]<<8|(l[8908]<<16|l[8909]<<24),u[e+29|0]=k,u[e+30|0]=k>>>8,u[e+31|0]=k>>>16,u[e+32|0]=k>>>24,u[e+33|0]=r,u[e+34|0]=r>>>8,u[e+35|0]=r>>>16,u[e+36|0]=r>>>24,r=l[8905]|l[8906]<<8|(l[8907]<<16|l[8908]<<24),k=l[8901]|l[8902]<<8|(l[8903]<<16|l[8904]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8897]|l[8898]<<8|(l[8899]<<16|l[8900]<<24),k=l[8893]|l[8894]<<8|(l[8895]<<16|l[8896]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8889]|l[8890]<<8|(l[8891]<<16|l[8892]<<24),k=l[8885]|l[8886]<<8|(l[8887]<<16|l[8888]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[8881]|l[8882]<<8|(l[8883]<<16|l[8884]<<24),k=l[8877]|l[8878]<<8|(l[8879]<<16|l[8880]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+37|0]=0,e=K(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,t=i[r>>2],k=i[t+128>>2],n=0;f:{if(!k)break f;for(n=t+128|0,e=n;o=i[k+16>>2],e=(o|0)<0?e:k,k=i[(o>>>29&4)+k>>2],!!k;);if((e|0)==(n|0)){o=0,n=0;break f}if(o=0,n=0,i[e+16>>2]>0)break f;o=i[e+44>>2],n=i[e+56>>2]}f:{A:{k:{if(s=i[t+112>>2],t=i[t+108>>2],e=G(s,t),e){if((e|0)<0)break k;k=E(e),e&&o0(k,0,e),w=e+k|0,i[f+32>>2]=w,i[f+28>>2]=w,i[f+24>>2]=k}if((n|0)==(t|0))break A;if(!s)break f;for(k=0;Me(f+48|0,o+G(k,n)|0,t),k=k+1|0,(s|0)!=(k|0););break f}G0(),H()}Me(f+48|0,o,e)}k=E(128),e=k,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92212,n=e+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[e>>2]=100360,i[k+32>>2]=1836280643,u[k+120|0]=0,h=k,_=j0(i[r>>2],0),u[h+120|0]=_,i[k+4>>2]=i[k+4>>2]+1,e=i[f+56>>2],r=i[f+52>>2];f:{if(e>>>0>r>>>0){i[r+4>>2]=k,i[r>>2]=n,n=r+8|0;break f}if(o=i[f+48>>2],r=r-o|0,w=r>>3,t=w+1|0,t>>>0>=536870912)break e;if(e=e-o|0,s=e>>2,t=e>>>0>=2147483640?536870911:t>>>0<s>>>0?s:t,t){if(t>>>0>=536870912)break i;e=E(t<<3)}else e=0;if(s=e+r|0,i[s+4>>2]=k,i[s>>2]=n,w=s-(w<<3)|0,r&&z(w,o,r),e=e+(t<<3)|0,i[f+56>>2]=e,n=s+8|0,i[f+52>>2]=n,i[f+48>>2]=w,!o)break f;Z(o),e=i[f+56>>2]}if(r=i[f+60>>2],o=i[f+64>>2],i[f+56>>2]=0,i[f+60>>2]=0,t=i[f+48>>2],i[f+48>>2]=0,i[f+52>>2]=0,s=i[f+68>>2],i[f+64>>2]=0,i[f+68>>2]=0,i[A+20>>2]=s,i[A+12>>2]=r,i[A+16>>2]=o,i[A+8>>2]=e,i[A+4>>2]=n,i[A>>2]=t,e=i[f+76>>2],i[A+24>>2]=i[f+72>>2],i[A+28>>2]=e,e=i[f+84>>2],i[A+32>>2]=i[f+80>>2],i[A+36>>2]=e,i[A+40>>2]=i[f+88>>2],u[A+44|0]=0,A=i[k+4>>2],i[k+4>>2]=A-1,A||(X[i[i[k>>2]+8>>2]](k),p(k)),A=i[f+24>>2],!A)break r;i[f+28>>2]=A,Z(A)}if(A=i[f+60>>2],A&&(i[f+64>>2]=A,Z(A)),A=i[f+48>>2],A){if(e=A,k=i[f+52>>2],(e|0)!=(k|0)){for(;;){e=i[k-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(k=k-8|0,(A|0)==(k|0))break}e=i[f+48>>2]}i[f+52>>2]=A,Z(e)}v=f+96|0;return}G0(),H()}x0(),H()}function pB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0;n=v-272|0,v=n,x2(n+252|0,e,r),u[n+271|0]<0&&Z(i[n+260>>2]);i:{if(l[e+97|0]<=1){for(m0=e+104|0,B=A+8|0,C=i[18063],y=C-12|0,R=i[18064]-12|0,N=i[18067]-12|0,V=i[18065],D=V-12|0,x=n+40|0,S=n+52|0,_=n- -64|0,g=n+32|0,I=n+28|0,O=n+84|0,L=i[18072],a=i[18071],$=i[18069],f0=i[18068],A0=i[18066];;){e:{r:{f:{A:{k:{n:{t:{u:{o:{if(i[r+16>>2]){if(i[n+192>>2]=86404,i[n+224>>2]=0,i[n+216>>2]=0,i[n+220>>2]=0,i[n+208>>2]=0,i[n+212>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,i[n+244>>2]=0,i[n+236>>2]=0,i[n+240>>2]=0,$6(n+168|0,n+192|0,r),i[n+168>>2]!=i[26928]){k=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+184>>2],k=i[n+180>>2],i[B>>2]=i[n+176>>2],i[B+4>>2]=k,i[n+176>>2]=0,i[n+180>>2]=0,i[n+184>>2]=0,k=0;break e}if(n0=l[e+97|0]?32:16,W0=n,Q0=hn(r,n0),i[W0+232>>2]=Q0,w=o2(r),!w){k=E(56),i[n+20>>2]=k,i[n+24>>2]=48,i[n+28>>2]=-2147483592,t=l[24237]|l[24238]<<8|(l[24239]<<16|l[24240]<<24),o=l[24233]|l[24234]<<8|(l[24235]<<16|l[24236]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+48|0]=0,t=l[24277]|l[24278]<<8|(l[24279]<<16|l[24280]<<24),o=l[24273]|l[24274]<<8|(l[24275]<<16|l[24276]<<24),u[k+40|0]=o,u[k+41|0]=o>>>8,u[k+42|0]=o>>>16,u[k+43|0]=o>>>24,u[k+44|0]=t,u[k+45|0]=t>>>8,u[k+46|0]=t>>>16,u[k+47|0]=t>>>24,t=l[24269]|l[24270]<<8|(l[24271]<<16|l[24272]<<24),o=l[24265]|l[24266]<<8|(l[24267]<<16|l[24268]<<24),u[k+32|0]=o,u[k+33|0]=o>>>8,u[k+34|0]=o>>>16,u[k+35|0]=o>>>24,u[k+36|0]=t,u[k+37|0]=t>>>8,u[k+38|0]=t>>>16,u[k+39|0]=t>>>24,t=l[24261]|l[24262]<<8|(l[24263]<<16|l[24264]<<24),o=l[24257]|l[24258]<<8|(l[24259]<<16|l[24260]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[24253]|l[24254]<<8|(l[24255]<<16|l[24256]<<24),o=l[24249]|l[24250]<<8|(l[24251]<<16|l[24252]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[24245]|l[24246]<<8|(l[24247]<<16|l[24248]<<24),o=l[24241]|l[24242]<<8|(l[24243]<<16|l[24244]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,K(A,2,0,n+20|0),u[n+31|0]<0&&Z(i[n+20>>2]),k=0;break e}if(t=0,k=i[f+28>>2],!(!k|k>>>0>=w>>>0)){i[n+112>>2]=0,i[n+20>>2]=V,i[n+84>>2]=72244,i[n+28>>2]=72224,k=n+20|0,i[k+i[D>>2]>>2]=A0,i[n+24>>2]=0,t=k+i[i[n+20>>2]-12>>2]|0,J0(t,g),u[t+80|0]=0,i[t+72>>2]=0,i[i[N>>2]+I>>2]=f0,i[k+i[R>>2]>>2]=$,i[n+84>>2]=72244,i[n+20>>2]=72204,i[n+28>>2]=72224,s=R0(g),i[s>>2]=71280,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,Y(I0(Y(I0(Y(I,26977,34),w),28675,33),i[f+28>>2]),24269,12),k=i[n+80>>2];l:{if(k&16){if(k=S,t=i[n+76>>2],o=i[n+56>>2],t>>>0>=o>>>0)break l;i[n+76>>2]=o,t=o;break l}if(!(k&8)){k=0,u[n+19|0]=0,t=n+8|0;break r}t=i[n+48>>2],k=x}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break o;if(k>>>0>=11){w=k|7,t=E(w+1|0),i[n+16>>2]=w-2147483647,i[n+8>>2]=t,i[n+12>>2]=k;break f}if(u[n+19|0]=k,t=n+8|0,k)break f;k=0;break r}for(;;){if(!i[r+16>>2]){i[n+112>>2]=0,i[n+20>>2]=V,i[n+84>>2]=72244,i[n+28>>2]=72224,k=n+20|0,i[k+i[D>>2]>>2]=A0,i[n+24>>2]=0,o=k+i[i[n+20>>2]-12>>2]|0,J0(o,g),u[o+80|0]=0,i[o+72>>2]=0,i[i[N>>2]+I>>2]=f0,i[k+i[R>>2]>>2]=$,i[n+84>>2]=72244,i[n+20>>2]=72204,i[n+28>>2]=72224,s=R0(g),i[s>>2]=71280,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,Y(S0(Y(I0(Y(I,28269,24),w),29171,34),t),24269,12),k=i[n+80>>2];l:{if(k&16){if(k=S,t=i[n+76>>2],o=i[n+56>>2],t>>>0>=o>>>0)break l;i[n+76>>2]=o,t=o;break l}if(!(k&8)){k=0,u[n+19|0]=0,t=n+8|0;break A}t=i[n+48>>2],k=x}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break u;if(k>>>0>=11){w=k|7,t=E(w+1|0),i[n+16>>2]=w-2147483647,i[n+8>>2]=t,i[n+12>>2]=k;break k}if(u[n+19|0]=k,t=n+8|0,k)break k;k=0;break A}k=hn(r,n0),s=k,o=i[n+240>>2],h=i[n+244>>2];l:{if(o>>>0<h>>>0){i[o>>2]=k,k=o+4|0;break l}if(W=i[n+236>>2],k=o-W|0,h0=k>>2,o=h0+1|0,o>>>0>=1073741824)break t;if(h=h-W|0,m=h>>1,h=h>>>0>=2147483644?1073741823:o>>>0<m>>>0?m:o,h){if(h>>>0>=1073741824)break n;o=E(h<<2)}else o=0;if(m=o+k|0,i[m>>2]=s,s=m-(h0<<2)|0,k&&z(s,W,k),i[n+244>>2]=o+(h<<2),k=m+4|0,i[n+240>>2]=k,i[n+236>>2]=s,!W)break l;Z(W)}if(i[n+240>>2]=k,t=t+1|0,(w|0)==(t|0))break}k=i[e+108>>2];l:{if(k>>>0<u0[e+112>>2]){te(k,n+192|0),k=k+56|0;break l}k=tA(m0,n+192|0)}i[e+108>>2]=k,k=1;break e}if(v9(A,e),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),l[r+20|0]==1){if(u[n+20|0]=0,u[n+31|0]=0,K(A,2,100,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[B>>2]=i[26930],i[B+4>>2]=A,i[B+8>>2]=i[26932];break i}T(B,i[26930],i[26931]);break i}g0(),H()}g0(),H()}G0(),H()}x0(),H()}if(!k)break A;z(t,o,k)}u[k+t|0]=0,K(A,2,100,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=C,i[i[y>>2]+(n+20|0)>>2]=a,i[n+28>>2]=L,i[s>>2]=71280,u[n+75|0]<0&&Z(i[n+64>>2]),y0(s),p0(O),k=0;break e}if(!k)break r;z(t,o,k)}u[k+t|0]=0,K(A,2,1e3,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=C,i[i[y>>2]+(n+20|0)>>2]=a,i[n+28>>2]=L,i[s>>2]=71280,u[n+75|0]<0&&Z(i[n+64>>2]),y0(s),p0(O),k=0}if(u[n+187|0]<0&&Z(i[n+176>>2]),t=i[n+236>>2],t&&(i[n+240>>2]=t,Z(t)),i[n+192>>2]=86404,t=i[n+212>>2],t&&(i[n+216>>2]=t,Z(t)),!k)break}break i}t1(A,e,11368)}v=n+272|0}function yB(A,e,r,f,k,n){A=A|0,e=+e,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;m=v-560|0,v=m,i[m+44>>2]=0,D2(+e),o=t2(1)|0,t2(0)|0;i:{if((o|0)<0){V=1,D=2970,e=-e,D2(+e),o=t2(1)|0,t2(0)|0;break i}if(k&2048){V=1,D=2973;break i}V=k&1,D=V?2976:2971,S=!V}i:{if((o&2146435072)==2146435072){o=V+3|0,w4(A,32,r,o,k&-65537),t4(A,D,V),f=n&32,t4(A,e!=e?f?9336:19433:f?11305:19665,3),w4(A,32,r,o,k^8192),_=(r|0)>(o|0)?r:o;break i}R=m+16|0;e:{r:{f:{if(e=Xo(e,m+44|0),e=e+e,e!=0){if(o=i[m+44>>2],i[m+44>>2]=o-1,N=n|32,(N|0)!=97)break f;break e}if(N=n|32,(N|0)==97)break e;B=i[m+44>>2];break r}B=o-29|0,i[m+44>>2]=B,e=e*268435456}for(h=(f|0)<0?6:f,I=(m+48|0)+((B|0)>=0?288:0)|0,o=I;f=e<4294967295&e>=0?~~e>>>0:0,i[o>>2]=f,o=o+4|0,e=(e-+(f>>>0))*1e9,e!=0;);r:{if((B|0)<=0){w=B,t=o,s=I;break r}for(s=I,w=B;;){w=w>>>0>=29?29:w,t=o-4|0;f:{if(s>>>0>t>>>0)break f;for(W=0;f=i[t>>2],g=w&31,_=W,(w&63)>>>0>=32?(W=f<<g,f=0):(W=(1<<g)-1&f>>>32-g,f=f<<g),_=_+f|0,g=W+x|0,g=f>>>0>_>>>0?g+1|0:g,W=d8(_,g,1e9,0),O=t,L=_-O0(W,l0,1e9,0)|0,i[O>>2]=L,t=t-4|0,s>>>0<=t>>>0;);if(!g&_>>>0<1e9)break f;s=s-4|0,i[s>>2]=W}for(;t=o,s>>>0<t>>>0&&(o=t-4|0,!i[o>>2]););if(w=i[m+44>>2]-w|0,i[m+44>>2]=w,o=t,!((w|0)>0))break}}if((w|0)<0)for(y=((h+25>>>0)/9|0)+1|0,g=(N|0)==102;;){f=0-w|0,_=f>>>0>=9?9:f;r:{if(t>>>0<=s>>>0){o=i[s>>2]?0:4;break r}for(x=1e9>>>_|0,W=-1<<_^-1,w=0,o=s;f=i[o>>2],i[o>>2]=(f>>>_|0)+w,w=G(x,f&W),o=o+4|0,o>>>0<t>>>0;);if(o=i[s>>2]?0:4,!w)break r;i[t>>2]=w,t=t+4|0}if(w=_+i[m+44>>2]|0,i[m+44>>2]=w,s=o+s|0,f=g?I:s,t=t-f>>2>(y|0)?f+(y<<2)|0:t,!((w|0)<0))break}w=0;r:{if(t>>>0<=s>>>0||(w=G(I-s>>2,9),o=10,f=i[s>>2],f>>>0<10))break r;for(;w=w+1|0,o=G(o,10),f>>>0>=o>>>0;);}if(f=(h-((N|0)!=102?w:0)|0)-((N|0)==103&(h|0)!=0)|0,(f|0)<(G(t-I>>2,9)-9|0)){if(o=(m+48|0)+((B|0)<0?-4092:-3804)|0,B=f+9216|0,f=(B|0)/9|0,_=o+(f<<2)|0,o=10,f=B-G(f,9)|0,(f|0)<=7)for(;o=G(o,10),f=f+1|0,(f|0)!=8;);B=i[_>>2],y=(B>>>0)/(o>>>0)|0,W=B-G(o,y)|0,f=_+4|0;r:{if(!W&(f|0)==(t|0))break r;f:{if(!(y&1)&&(e=9007199254740992,!(u[_-4|0]&1)|((o|0)!=1e9|s>>>0>=_>>>0)))break f;e=9007199254740994}if(C=(f|0)==(t|0)?1:1.5,f=o>>>1|0,C=f>>>0>W>>>0?.5:(f|0)==(W|0)?C:1.5,l[D|0]!=45|S||(C=-C,e=-e),f=B-W|0,i[_>>2]=f,e+C==e)break r;if(f=f+o|0,i[_>>2]=f,f>>>0>=1e9)for(;i[_>>2]=0,_=_-4|0,_>>>0<s>>>0&&(s=s-4|0,i[s>>2]=0),f=i[_>>2]+1|0,i[_>>2]=f,f>>>0>999999999;);if(w=G(I-s>>2,9),o=10,f=i[s>>2],f>>>0<10)break r;for(;w=w+1|0,o=G(o,10),f>>>0>=o>>>0;);}f=_+4|0,t=f>>>0<t>>>0?f:t}for(;B=t,W=t>>>0<=s>>>0,!W&&(t=t-4|0,!i[t>>2]););r:{if((N|0)!=103){g=k&8;break r}if(o=h||1,f=(o|0)>(w|0)&(w|0)>-5,h=(f?w^-1:-1)+o|0,n=(f?-1:-2)+n|0,g=k&8,g)break r;t=-9;f:{if(W||(W=i[B-4>>2],!W)||(f=10,t=0,(W>>>0)%10|0))break f;for(;o=t,t=t+1|0,f=G(f,10),!((W>>>0)%(f>>>0)|0););t=o^-1}if(f=G(B-I>>2,9),(n&-33)==70){g=0,f=(f+t|0)-9|0,f=(f|0)>0?f:0,h=(f|0)>(h|0)?h:f;break r}g=0,f=((f+w|0)+t|0)-9|0,f=(f|0)>0?f:0,h=(f|0)>(h|0)?h:f}if(_=-1,W=h|g,((W?2147483645:2147483646)|0)<(h|0))break i;x=(((W|0)!=0)+h|0)+1|0,o=n&-33;r:{if((o|0)==70){if((x^2147483647)<(w|0))break i;t=(w|0)>0?w:0;break r}if(f=w>>31,t=vi((f^w)-f|0,0,R),(R-t|0)<=1)for(;t=t-1|0,u[t|0]=48,(R-t|0)<2;);if(y=t-2|0,u[y|0]=n,u[t-1|0]=(w|0)<0?45:43,t=R-y|0,(t|0)>(x^2147483647))break i}if(f=t+x|0,(f|0)>(V^2147483647))break i;w=f+V|0,w4(A,32,r,w,k),t4(A,D,V),w4(A,48,r,w,k^65536);r:{f:{A:{if((o|0)==70){for(o=m+16|9,n=s>>>0>I>>>0?I:s,s=n;;){t=vi(i[s>>2],0,o);k:{if((n|0)!=(s|0)){if(m+16>>>0>=t>>>0)break k;for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);break k}if((t|0)!=(o|0))break k;t=t-1|0,u[t|0]=48}if(t4(A,t,o-t|0),s=s+4|0,!(I>>>0>=s>>>0))break}if(W&&t4(A,26338,1),(h|0)<=0|s>>>0>=B>>>0)break A;for(;;){if(t=vi(i[s>>2],0,o),t>>>0>m+16>>>0)for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);if(t4(A,t,(h|0)>=9?9:h),t=h-9|0,s=s+4|0,B>>>0<=s>>>0)break f;if(f=(h|0)>9,h=t,!f)break}break f}k:{if((h|0)<0)break k;for(n=s>>>0<B>>>0?B:s+4|0,B=m+16|9,o=s;;){t=vi(i[o>>2],0,B),(B|0)==(t|0)&&(t=t-1|0,u[t|0]=48);n:{if((o|0)!=(s|0)){if(m+16>>>0>=t>>>0)break n;for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);break n}if(t4(A,t,1),t=t+1|0,!(h|g))break n;t4(A,26338,1)}if(f=B-t|0,t4(A,t,(f|0)<(h|0)?f:h),h=h-f|0,o=o+4|0,n>>>0<=o>>>0)break k;if(!((h|0)>=0))break}}w4(A,48,h+18|0,18,0),t4(A,y,R-y|0);break r}t=h}w4(A,48,t+9|0,9,0)}w4(A,32,r,w,k^8192),_=(r|0)>(w|0)?r:w;break i}h=(n<<26>>31&9)+D|0;e:{if(f>>>0>11)break e;for(t=12-f|0,C=16;C=C*16,t=t-1|0,!!t;);if(l[h|0]==45){e=-(C+(-e-C));break e}e=e+C-C}for(o=i[m+44>>2],t=o>>31,t=vi((t^o)-t|0,0,R),(R|0)==(t|0)&&(t=t-1|0,u[t|0]=48,o=i[m+44>>2]),I=V|2,s=n&32,B=t-2|0,u[B|0]=n+15,u[t-1|0]=(o|0)<0?45:43,t=!(k&8)&(f|0)<=0,o=m+16|0;n=o,w=w2(e)<2147483647?~~e:-2147483648,u[o|0]=s|l[w+70320|0],e=(e-+(w|0))*16,o=o+1|0,t&e==0|(o-(m+16|0)|0)!=1||(u[n+1|0]=46,o=n+2|0),e!=0;);if(_=-1,t=R-B|0,n=t+I|0,(2147483645-n|0)<(f|0))break i;w=n,n=m+16|0,s=o-n|0,f=f&&(s-2|0)<(f|0)?f+2|0:s,o=w+f|0,w4(A,32,r,o,k),t4(A,h,I),w4(A,48,r,o,k^65536),t4(A,n,s),w4(A,48,f-s|0,0,0),t4(A,B,t),w4(A,32,r,o,k^8192),_=(r|0)>(o|0)?r:o}return v=m+560|0,_|0}function a7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;g=v-48|0,v=g,D2(+A),h=t2(1)|0,r=t2(0)|0;i:{e:{o=h&2147483647;r:{if(o>>>0<=1074752122){if((h&1048575)==598523)break r;if(o>>>0<=1073928572){if((h|0)>0|(h|0)>=0){A=A+-1.5707963267341256,k=A+-6077100506506192e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-6077100506506192e-26,f=1;break i}A=A+1.5707963267341256,k=A+6077100506506192e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+6077100506506192e-26,f=-1;break i}if((h|0)>0|(h|0)>=0){A=A+-3.1415926534682512,k=A+-12154201013012384e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-12154201013012384e-26,f=2;break i}A=A+3.1415926534682512,k=A+12154201013012384e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+12154201013012384e-26,f=-2;break i}if(o>>>0<=1075594811){if(o>>>0<=1075183036){if((o|0)==1074977148)break r;if((h|0)>0|(h|0)>=0){A=A+-4.712388980202377,k=A+-18231301519518578e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-18231301519518578e-26,f=3;break i}A=A+4.712388980202377,k=A+18231301519518578e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+18231301519518578e-26,f=-3;break i}if((o|0)==1075388923)break r;if((h|0)>0|(h|0)>=0){A=A+-6.2831853069365025,k=A+-2430840202602477e-25,t0[e>>3]=k,t0[e+8>>3]=A-k+-2430840202602477e-25,f=4;break i}A=A+6.2831853069365025,k=A+2430840202602477e-25,t0[e>>3]=k,t0[e+8>>3]=A-k+2430840202602477e-25,f=-4;break i}if(o>>>0>1094263290)break e}w=A*.6366197723675814+6755399441055744+-6755399441055744,w2(w)<2147483647?f=~~w:f=-2147483648,k=A+w*-1.5707963267341256,B=w*6077100506506192e-26,R=k-B;r:{if(R<-.7853981633974483){f=f-1|0,w=w+-1,B=w*6077100506506192e-26,k=A+w*-1.5707963267341256;break r}if(!(R>.7853981633974483))break r;f=f+1|0,w=w+1,B=w*6077100506506192e-26,k=A+w*-1.5707963267341256}A=k-B,t0[e>>3]=A,D2(+A),r=t2(1)|0,t2(0)|0,h=o>>>20|0;r:{if((h-(r>>>20&2047)|0)<17||(B=k,A=w*6077100506303966e-26,k=k-A,B=w*20222662487959506e-37-(B-k-A),A=k-B,t0[e>>3]=A,D2(+A),r=t2(1)|0,t2(0)|0,(h-(r>>>20&2047)|0)<50))break r;B=k,A=w*20222662487111665e-37,k=k-A,B=w*84784276603689e-45-(B-k-A),A=k-B,t0[e>>3]=A}t0[e+8>>3]=k-A-B;break i}if(o>>>0>=2146435072){A=A-A,t0[e>>3]=A,t0[e+8>>3]=A;break i}for(f=g+16|0,n=f|8,U2(0,r|0),U2(1,h&1048575|1096810496),A=+r1(),r=1;k=+((w2(A)<2147483647?~~A:-2147483648)|0),t0[f>>3]=k,A=(A-k)*16777216,_=r,r=0,f=n,!!_;);for(t0[g+32>>3]=A,f=2;r=f,f=r-1|0,V=g+16|0,t0[V+(r<<3)>>3]==0;);if(n=0,t=v-560|0,v=t,f=(o>>>20|0)-1046|0,_=(f-3|0)/24|0,y=(_|0)>0?_:0,I=G(y,-24)+f|0,_=i[16189],C=r+1|0,s=C-1|0,(_+s|0)>=0)for(f=_+C|0,r=y-s|0;t0[(t+320|0)+(n<<3)>>3]=(r|0)<0?0:+i[(r<<2)+64768>>2],r=r+1|0,n=n+1|0,(f|0)!=(n|0););for(o=I-24|0,f=0,n=(_|0)>0?_:0,W=(C|0)<=0;;){e:{if(W){A=0;break e}for(m=f+s|0,r=0,A=0;A=t0[(r<<3)+V>>3]*t0[(t+320|0)+(m-r<<3)>>3]+A,r=r+1|0,(C|0)!=(r|0););}if(t0[(f<<3)+t>>3]=A,r=(f|0)==(n|0),f=f+1|0,!!r)break}S=47-I|0,N=48-I|0,O=I-25|0,f=_;e:{for(;;){if(A=t0[(f<<3)+t>>3],r=0,n=f,(f|0)>0)for(;W=(t+480|0)+(r<<2)|0,k=A*5960464477539063e-23,w2(k)<2147483647?s=~~k:s=-2147483648,k=+(s|0),A=k*-16777216+A,w2(A)<2147483647?s=~~A:s=-2147483648,i[W>>2]=s,n=n-1|0,A=t0[(n<<3)+t>>3]+k,r=r+1|0,(f|0)!=(r|0););A=A4(A,o),A=A+W_(A*.125)*-8,w2(A)<2147483647?W=~~A:W=-2147483648,A=A-+(W|0);r:{f:{A:{D=(o|0)<=0;k:{if(!D){n=(f<<2)+t|0,s=i[n+476>>2],r=s>>N,m=n,n=s-(r<<N)|0,i[m+476>>2]=n,W=r+W|0,s=n>>S;break k}if(o)break A;s=i[((f<<2)+t|0)+476>>2]>>23}if((s|0)<=0)break r;break f}if(s=2,A>=.5)break f;s=0;break r}if(r=0,m=0,n=1,(f|0)>0)for(;;){n=(t+480|0)+(r<<2)|0,x=i[n>>2];f:{A:{if(m)m=16777215;else{if(!x)break A;m=16777216}i[n>>2]=m-x,m=1,n=0;break f}m=0,n=1}if(r=r+1|0,(f|0)==(r|0))break}f:{if(D)break f;r=8388607;A:switch(O|0){case 1:r=4194303;break;case 0:break A;default:break f}m=(f<<2)+t|0,i[m+476>>2]=i[m+476>>2]&r}if(W=W+1|0,(s|0)!=2||(A=1-A,s=2,n))break r;A=A-A4(1,o)}if(A==0){n=0;r:{if(r=f,(_|0)>=(r|0))break r;for(;r=r-1|0,n=i[(t+480|0)+(r<<2)>>2]|n,(r|0)>(_|0););if(!n)break r;for(;o=o-24|0,f=f-1|0,!i[(t+480|0)+(f<<2)>>2];);break e}for(r=1;n=r,r=r+1|0,!i[(t+480|0)+(_-n<<2)>>2];);for(n=f+n|0;;){if(s=f+C|0,f=f+1|0,t0[(t+320|0)+(s<<3)>>3]=i[(y+f<<2)+64768>>2],r=0,A=0,(C|0)>0)for(;A=t0[(r<<3)+V>>3]*t0[(t+320|0)+(s-r<<3)>>3]+A,r=r+1|0,(C|0)!=(r|0););if(t0[(f<<3)+t>>3]=A,!((f|0)<(n|0)))break}f=n;continue}break}A=A4(A,24-I|0);r:{if(A>=16777216){o=(t+480|0)+(f<<2)|0,k=A*5960464477539063e-23,w2(k)<2147483647?r=~~k:r=-2147483648,A=+(r|0)*-16777216+A,w2(A)<2147483647?n=~~A:n=-2147483648,i[o>>2]=n,f=f+1|0,o=I;break r}r=w2(A)<2147483647?~~A:-2147483648}i[(t+480|0)+(f<<2)>>2]=r}if(A=A4(1,o),(f|0)>=0){for(r=f;n=r,t0[(r<<3)+t>>3]=A*+i[(t+480|0)+(r<<2)>>2],r=r-1|0,A=A*5960464477539063e-23,!!n;);for(n=f;;){if(A=0,r=0,o=f-n|0,I=(o|0)>(_|0)?_:o,(I|0)>=0)for(;A=t0[(r<<3)+67536>>3]*t0[(r+n<<3)+t>>3]+A,C=(r|0)!=(I|0),r=r+1|0,!!C;);if(t0[(t+160|0)+(o<<3)>>3]=A,r=(n|0)>0,n=n-1|0,!r)break}}if(A=0,(f|0)>=0)for(r=f;n=r,r=r-1|0,A=A+t0[(t+160|0)+(n<<3)>>3],!!n;);if(t0[g>>3]=s?-A:A,A=t0[t+160>>3]-A,r=1,(f|0)>0)for(;A=A+t0[(t+160|0)+(r<<3)>>3],n=(r|0)!=(f|0),r=r+1|0,!!n;);if(t0[g+8>>3]=s?-A:A,v=t+560|0,f=W&7,A=t0[g>>3],(h|0)<0){t0[e>>3]=-A,t0[e+8>>3]=-t0[g+8>>3],f=0-f|0;break i}t0[e>>3]=A,t0[e+8>>3]=t0[g+8>>3]}return v=g+48|0,f}function YB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0;s=v-128|0,v=s,h=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),x=u1(i[r>>2],6),x&&($=j0(i[r>>2],6));i:{if(!(!(h>>>0>8|t>>>0>8)&n>>>0<9)){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(!((t|0)==(h|0)&(n|0)==(h|0))){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e=i[r>>2],m=i[e+112>>2],_=i[e+108>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],W=w+12|0,i[w+96>>2]=W,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[W+120>>2]=2,i[W+116>>2]=0,i[W+112>>2]=m,i[W+108>>2]=_,T0(s+56|0,W,0,_,m,h,o),g=_+1>>>1|0,T0(s+32|0,W,1,g,m,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,W,2,g,m,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!x)break r;if(T0(s+104|0,W,6,_,m,$,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);V=0;k:{if((e|0)==(f|0)||(V=0,i[e+16>>2]>0))break k;h0=i[e+44>>2],V=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(f|0)||(o=0,i[e+16>>2]>1))break k;f0=i[e+44>>2],o=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}y=0;break r}if(y=0,i[e+16>>2]>2)break r;S=i[e+56>>2],y=i[e+44>>2]}r:{f:{if(e=i[k>>2],e){for(n=k,r=e;I=i[r+16>>2],n=(I|0)<0?n:r,r=i[(I>>>29&4)+r>>2],!!r;);I=0;A:{if((k|0)==(n|0)||(I=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],I=i[n+56>>2]}for(n=k,r=e;h=i[r+16>>2]<=0,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);C=0;A:{if((k|0)==(n|0)||(C=0,i[n+16>>2]>1))break A;A0=i[n+44>>2],C=i[n+56>>2]}for(n=k,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;O=i[n+56>>2],r=i[n+44>>2]}h=r,n=0,B=0;r:{if(!x)break r;f:{A:{if(!t)break A;for(r=f;L=i[t+16>>2]<6,r=L?r:t,t=i[(L?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;W0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(L=f,B=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(B=0,(r|0)==(k|0)||(B=0,i[r+16>>2]>6))break r;n=i[r+56>>2],B=i[r+44>>2]}f=B;r:{f:{A:{if(!(_&1))break A;if(k=m-1|0,!k)break f;if(R=(h+g|0)-1|0,N=(_+y|0)-1|0,g=(g+A0|0)-1|0,D=(_+f0|0)-1|0,r=0,(m|0)!=2)for(e=k&-2;u[g+G(r,C)|0]=l[D+G(r,o)|0],u[R+G(r,O)|0]=l[N+G(r,S)|0],t=r|1,u[g+G(t,C)|0]=l[D+G(t,o)|0],u[R+G(t,O)|0]=l[N+G(t,S)|0],r=r+2|0,a=a+2|0,(e|0)!=(a|0););if(!(k&1))break A;u[g+G(r,C)|0]=l[D+G(r,o)|0],u[R+G(r,O)|0]=l[N+G(r,S)|0]}if(!m)break r}if(n0=_-1|0,n0)for(e=0;;){for(B=G(e,O)+h|0,R=G(e,C)+A0|0,N=G(e,S)+y|0,g=G(e,o)+f0|0,r=0;k=r+N|0,a=l[k|0],D=l[k+1|0],t=r>>>1|0,k=r+g|0,u[R+t|0]=(l[k|0]+l[k+1|0]|0)+1>>>1,u[t+B|0]=(D+a|0)+1>>>1,r=r+2|0,n0>>>0>r>>>0;);if(e=e+1|0,(m|0)==(e|0))break}for(e=_<<($>>>0>8),r=0;_&&z(G(r,I)+m0|0,G(r,V)+h0|0,_),!x|!e||z(G(r,n)+f|0,G(r,L)+W0|0,e),r=r+1|0,(m|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=W;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+128|0}function RB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0;m=v-48|0,v=m,h=m+12|0,V=r,x=f,$=k,f0=n,m0=t,s=v-80|0,v=s,g=i[e>>2],n=i[g+108>>2],k=i[g+112>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),r=i[w+4>>2],f=r+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,S=w+140|0,i[w+136>>2]=S,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=r,r=i[w+8>>2],O=w+12|0,i[w+96>>2]=O,i[w+8>>2]=r+1,i[w+100>>2]=w,f||(X[i[i[w>>2]+8>>2]](w),p(w)),i[s+24>>2]=i[g+84>>2];i:{e:{if(r=i[g+88>>2],!r||(f=Gi(r),i[s+28>>2]=f,!f))break e;r=n-V|0,y=r>>>0<$>>>0?r:$,r=k-x|0,L=r>>>0<f0>>>0?r:f0,I9(s+56|0,O,s+24|0,y,L,m0),r=i[f+4>>2],i[f+4>>2]=r-1,r||(X[i[i[f>>2]+8>>2]](f),p(f));r:{if(i[s+56>>2]){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,k=h+8|0;f:{if(u[s+75|0]>=0){f=s- -64|0,r=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+8>>2];break f}T(k,i[s+64>>2],i[s+68>>2])}u[h+20|0]=1;break r}i[s+48>>2]=0,i[s+52>>2]=0,a=s+48|0,i[s+44>>2]=a,k=i[g+124>>2],t=g+128|0;f:{A:{if((k|0)==(t|0))break A;for(;;){W=i[k+16>>2],f=a,r=f,n=i[s+48>>2];k:{n:{if(!n)break n;for(;;){if(r=n,f=i[r+16>>2],(f|0)>(W|0)){if(f=r,n=i[r>>2],n)continue;break n}if((f|0)>=(W|0))break k;if(n=i[r+4>>2],!n)break}f=r+4|0}n=E(20),i[n+8>>2]=r,i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=W,i[f>>2]=n,r=i[i[s+44>>2]>>2],r&&(i[s+44>>2]=r),m1(i[s+48>>2],n),i[s+52>>2]=i[s+52>>2]+1}n=i[k+4>>2];k:{if(n){for(;;)if(r=n,n=i[r>>2],!n)break k}for(;r=i[k+8>>2],f=i[r>>2]!=(k|0),k=r,!!f;);}if(k=r,(t|0)==(r|0))break}if(W=i[s+44>>2],(a|0)==(W|0))break A;for(r=i[g+120>>2],W0=(r|0)==1,e0=W0?L+1>>>1|0:L,A0=r-1>>>0<2,r0=A0?y+1>>>1|0:y,N0=G(y,3),U0=y<<2,Q0=V+1>>>1|0,V0=x+1>>>1|0;;){B=i[W+16>>2],k=t,r=i[k>>2],n=r;k:{n:{if(!r)break n;for(;f=(B|0)>i[n+16>>2],k=f?k:n,n=i[(f?4:0)+n>>2],!!n;);if((k|0)==(t|0))break n;if(n0=0,f=0,(B|0)<i[k+16>>2])break k;n0=i[k+44>>2],f=i[k+56>>2];break k}n0=0,f=0}h0=f,I=255,f=S,n=i[f>>2],k=n;k:{if(!k){R=0,D=0,f=255;break k}for(;_=(B|0)>i[k+16>>2],f=_?f:k,k=i[(_?4:0)+k>>2],!!k;);n:{if((f|0)==(S|0)){D=0,R=0;break n}if(D=0,R=0,(B|0)<i[f+16>>2])break n;D=i[f+56>>2],R=i[f+44>>2]}for(k=S;f=(B|0)>i[n+16>>2],k=f?k:n,n=i[(f?4:0)+n>>2],!!n;);if(f=255,(k|0)==(S|0)||(f=255,(B|0)<i[k+16>>2]))break k;f=l[k+24|0]}k=t,n=r;k:{if(!r)break k;for(;_=(B|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((k|0)==(t|0)|(B|0)<i[k+16>>2])break k;I=l[k+24|0]}if((f&255)!=(I&255)){u[s+12|0]=0,u[s+23|0]=0,k=K(s+24|0,2,132,s+12|0),r=i[k+4>>2],i[h>>2]=i[k>>2],i[h+4>>2]=r,f=h+8|0;k:{if(u[k+19|0]>=0){r=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+16>>2],u[h+20|0]=1;break k}if(T(f,i[k+8>>2],i[k+12>>2]),r=u[k+19|0],u[h+20|0]=1,(r|0)>=0)break k;Z(i[k+8>>2])}if(u[s+23|0]>=0)break f;Z(i[s+12>>2]);break f}I=e0,_=W0,f=r0;k:n:{t:{u:{o:{l:{s:{w:{if(N=B-1>>>0<2,N||(_=0,I=L,f=y,(B|0)!=10))break w;k=3,r=6,_=x,C=V,f=N0;_:{h:switch(n=i[g+120>>2],n-10|0){case 0:break k;case 1:break h;case 2:case 4:break l;case 3:case 5:break s;default:break _}k=4,f=U0;break k}r=31;break l}if(k=t,n=r,!r)break o;for(;C=(B|0)>i[n+16>>2],k=C?k:n,n=i[(C?4:0)+n>>2],!!n;);for(n=0,_=_?V0:x,C=N&&A0?Q0:V,f=G((k|0)==(t|0)|(B|0)<i[k+16>>2]?n:(l[k+24|0]+7&248)>>>3|0,f),n=t;k=(B|0)>i[r+16>>2],n=k?n:r,r=i[(k?4:0)+r>>2],!!r;);if(k=0,(n|0)==(t|0)|(B|0)<i[n+16>>2])break k;k=(l[n+24|0]+7&248)>>>3|0;break k}r=8}switch(f=G(r,y),k=6,n-12|0){case 0:case 2:break k;case 1:case 3:break u;default:break t}}_=_?V0:x,C=N&&A0?Q0:V,f=0,k=0;break k}k=8;break n}k=31}k:{if(!I)break k;if(N=G(k,C)+n0|0,r=0,(I|0)!=1)for(C=I&-2,n=0;k=!f,k||z(G(r,D)+R|0,N+G(r+_|0,h0)|0,f),k||(k=r|1,z(G(k,D)+R|0,N+G(k+_|0,h0)|0,f)),r=r+2|0,n=n+2|0,(C|0)!=(n|0););if(!(I&1)|!f)break k;z(G(r,D)+R|0,N+G(r+_|0,h0)|0,f)}n=i[W+4>>2];k:{if(n){for(;;)if(r=n,n=i[r>>2],!n)break k}for(;r=i[W+8>>2],f=i[r>>2]!=(W|0),W=r,!!f;);}if(W=r,(r|0)==(a|0))break}}if(V9(s+24|0,O,$,f0,m0),f=i[s+28>>2],r=i[s+24>>2],i[s+56>>2]=r,i[s+60>>2]=f,k=s- -64|0,u[s+75|0]<0&&(Z(i[s+64>>2]),r=i[s+56>>2]),f=i[s+36>>2],i[k>>2]=i[s+32>>2],i[k+4>>2]=f,i[k+8>>2]=i[s+40>>2],r){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,f=h+8|0;A:{if(u[s+75|0]>=0){r=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+8>>2];break A}T(f,i[s+64>>2],i[s+68>>2])}u[h+20|0]=1;break f}u[h+20|0]=0,i[h+4>>2]=w,i[h>>2]=O,w=0}Vi(s+44|0,i[s+48>>2])}u[s+75|0]<0&&Z(i[s+64>>2]);r:{if(!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break r;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+80|0;break i}g3(),H()}i:{e:switch(l[m+32|0]){default:_2(),H();case 1:r=A,A=i[e>>2],b0(r,m+12|0,A?A+92|0:0);break i;case 0:break e}f=E(8),e=i[m+12>>2],r=i[m+16>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+4>>2]=r,i[f>>2]=e,i[o>>2]=f,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}e=l[m+32|0],(e|0)!=255&&(A=i[24171],i[m+40>>2]=i[24170],i[m+44>>2]=A,X[i[(m+40|0)+(e<<2)>>2]](m+39|0,m+12|0)),v=m+48|0}function JB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=o+12|0;i:{if(!r){r=v-48|0,v=r,t=i[A+48>>2],w=i[A+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,t,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(t=i[f+20>>2],A=i[f+24>>2],(t|0)!=(A|0)){if(e=i[t>>2],e&&(h=i[r+44>>2],e=X0(e,86628,88020),e))break r;if(t=t+8|0,(A|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(h=0,e=X0(e,86628,88020),e))break r;if(t=t+8|0,(A|0)==(t|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=h,i[r+40>>2]=e,A=i[t+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(t=i[f+24>>2],e=A,(t|0)!=(A|0)){for(;;){e=i[t-4>>2];e:{if(!e||(h=i[e+4>>2],i[e+4>>2]=h-1,h))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=E(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=f,u[A+17|0]=f>>>8,u[A+18|0]=f>>>16,u[A+19|0]=f>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=K(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(u[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],u[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}e=i[r+44>>2],u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;X[i[i[w>>2]+8>>2]](w),p(w)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,j1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(u[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}u[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=E(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=l[13933]|l[13934]<<8|(l[13935]<<16|l[13936]<<24),r=l[13929]|l[13930]<<8|(l[13931]<<16|l[13932]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13952]|l[13953]<<8|(l[13954]<<16|l[13955]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13949]|l[13950]<<8|(l[13951]<<16|l[13952]<<24),r=l[13945]|l[13946]<<8|(l[13947]<<16|l[13948]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),r=l[13937]|l[13938]<<8|(l[13939]<<16|l[13940]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=K(k+44|0,5,2007,k+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=X0(A,86628,88020),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=E(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),f=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),f=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=K(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(u[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],u[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}return v=k+96|0,A=-1,e=l[o+32|0],(e|0)!=255&&(A=e?A:i[i[o+12>>2]+100>>2],r=i[24187],i[o+40>>2]=i[24186],i[o+44>>2]=r,X[i[(o+40|0)+(e<<2)>>2]](o+39|0,o+12|0)),v=o+48|0,A|0}function NB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=o+12|0;i:{if(!r){r=v-48|0,v=r,t=i[A+48>>2],w=i[A+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,t,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(t=i[f+20>>2],A=i[f+24>>2],(t|0)!=(A|0)){if(e=i[t>>2],e&&(h=i[r+44>>2],e=X0(e,86628,87940),e))break r;if(t=t+8|0,(A|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(h=0,e=X0(e,86628,87940),e))break r;if(t=t+8|0,(A|0)==(t|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=h,i[r+40>>2]=e,A=i[t+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(t=i[f+24>>2],e=A,(t|0)!=(A|0)){for(;;){e=i[t-4>>2];e:{if(!e||(h=i[e+4>>2],i[e+4>>2]=h-1,h))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=E(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=f,u[A+17|0]=f>>>8,u[A+18|0]=f>>>16,u[A+19|0]=f>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=K(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(u[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],u[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}e=i[r+44>>2],u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;X[i[i[w>>2]+8>>2]](w),p(w)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,j1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(u[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}u[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=E(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=l[13933]|l[13934]<<8|(l[13935]<<16|l[13936]<<24),r=l[13929]|l[13930]<<8|(l[13931]<<16|l[13932]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13952]|l[13953]<<8|(l[13954]<<16|l[13955]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13949]|l[13950]<<8|(l[13951]<<16|l[13952]<<24),r=l[13945]|l[13946]<<8|(l[13947]<<16|l[13948]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),r=l[13937]|l[13938]<<8|(l[13939]<<16|l[13940]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=K(k+44|0,5,2007,k+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=X0(A,86628,87940),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=E(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),f=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),f=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=K(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(u[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],u[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}return v=k+96|0,A=-1,e=l[o+32|0],(e|0)!=255&&(A=e?A:i[i[o+12>>2]+100>>2],r=i[24189],i[o+40>>2]=i[24188],i[o+44>>2]=r,X[i[(o+40|0)+(e<<2)>>2]](o+39|0,o+12|0)),v=o+48|0,A|0}function MB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;if(f=Q[e+22>>1],B=Q[e+6>>1],h=Q[e+30>>1],o=((G(f,-74)+G(B,74)|0)+G(h,74)|0)- -64>>7,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,n=Q[e+20>>1],s=Q[e+4>>1],t=Q[e+28>>1],W=((G(n,-74)+G(s,74)|0)+G(t,74)|0)- -64>>7,W=(W|0)>=32767?32767:W,W=(W|0)<=-32768?-32768:W,C=Q[e+18>>1],w=Q[e+2>>1],m=Q[e+26>>1],_=((G(C,-74)+G(w,74)|0)+G(m,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,V=(_|0)<=-32768?-32768:_,y=Q[e+16>>1],R=Q[e>>1],N=Q[e+24>>1],_=((G(y,-74)+G(R,74)|0)+G(N,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,k=Q[e+14>>1],g=(((G(k,-74)+G(B,84)|0)+G(f,55)|0)+G(h,-29)|0)- -64>>7,g=(g|0)>=32767?32767:g,g=(g|0)<=-32768?-32768:g,I=G(k,74),k=(((I+G(B,55)|0)+G(f,-29)|0)+G(h,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,f=(((I+G(B,29)|0)+G(f,84)|0)+G(h,55)|0)- -64>>7,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,h=Q[e+12>>1],B=(((G(h,-74)+G(s,84)|0)+G(n,55)|0)+G(t,-29)|0)- -64>>7,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,I=G(h,74),h=(((I+G(s,55)|0)+G(n,-29)|0)+G(t,-84)|0)- -64>>7,h=(h|0)>=32767?32767:h,h=(h|0)<=-32768?-32768:h,n=(((I+G(s,29)|0)+G(n,84)|0)+G(t,55)|0)- -64>>7,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,s=Q[e+10>>1],t=(((G(s,-74)+G(w,84)|0)+G(C,55)|0)+G(m,-29)|0)- -64>>7,t=(t|0)>=32767?32767:t,I=(t|0)<=-32768?-32768:t,s=G(s,74),t=(((s+G(w,55)|0)+G(C,-29)|0)+G(m,-84)|0)- -64>>7,t=(t|0)>=32767?32767:t,D=(t|0)<=-32768?-32768:t,s=(((s+G(w,29)|0)+G(C,84)|0)+G(m,55)|0)- -64>>7,s=(s|0)>=32767?32767:s,C=(s|0)<=-32768?-32768:s,s=Q[e+8>>1],e=(((G(s,-74)+G(R,84)|0)+G(y,55)|0)+G(N,-29)|0)- -64>>7,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,t=G(s,74),s=(((t+G(R,55)|0)+G(y,-29)|0)+G(N,-84)|0)- -64>>7,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,t=(((t+G(R,29)|0)+G(y,84)|0)+G(N,55)|0)- -64>>7,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,(r|0)!=1){w=l[A+2|0]+(((G(n,-74)+G(t,74)|0)+G(f,74)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+2|0]=(w|0)>0?w:0,w=G(C,74),m=l[A|0]+((((w+G(t,29)|0)+G(n,84)|0)+G(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,u[A|0]=(m|0)>0?m:0,w=l[A+1|0]+((((w+G(t,55)|0)+G(n,-29)|0)+G(f,-84)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+1|0]=(w|0)>0?w:0,f=l[A+3|0]+((((G(C,-74)+G(t,84)|0)+G(n,55)|0)+G(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[A+3|0]=(f|0)>0?f:0,f=A+r|0,t=G(D,74),n=l[f|0]+((((t+G(s,29)|0)+G(h,84)|0)+G(k,55)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f|0]=(n|0)>0?n:0,n=l[f+1|0]+((((t+G(s,55)|0)+G(h,-29)|0)+G(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+1|0]=(n|0)>0?n:0,n=l[f+2|0]+(((G(h,-74)+G(s,74)|0)+G(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+2|0]=(n|0)>0?n:0,k=l[f+3|0]+((((G(D,-74)+G(s,84)|0)+G(h,55)|0)+G(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[f+3|0]=(k|0)>0?k:0,k=(r<<1)+A|0,h=G(V,74),f=l[k|0]+((((h+G(_,29)|0)+G(W,84)|0)+G(o,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k|0]=(f|0)>0?f:0,f=l[k+1|0]+((((h+G(_,55)|0)+G(W,-29)|0)+G(o,-84)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k+1|0]=(f|0)>0?f:0,f=l[k+2|0]+(((G(W,-74)+G(_,74)|0)+G(o,74)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k+2|0]=(f|0)>0?f:0,o=l[k+3|0]+((((G(V,-74)+G(_,84)|0)+G(W,55)|0)+G(o,-29)|0)+2048>>12)|0,o=(o|0)>=255?255:o,u[k+3|0]=(o|0)>0?o:0,A=G(r,3)+A|0,o=G(I,74),r=l[A|0]+((((o+G(e,29)|0)+G(B,84)|0)+G(g,55)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A|0]=(r|0)>0?r:0,r=l[A+1|0]+((((o+G(e,55)|0)+G(B,-29)|0)+G(g,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+1|0]=(r|0)>0?r:0,r=l[A+2|0]+(((G(B,-74)+G(e,74)|0)+G(g,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+2|0]=(r|0)>0?r:0,r=A,A=l[A+3|0]+((((G(I,-74)+G(e,84)|0)+G(B,55)|0)+G(g,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,u[r+3|0]=(A|0)>0?A:0;return}w=l[A+2|0]+(((G(n,-74)+G(t,74)|0)+G(f,74)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+2|0]=(w|0)>0?w:0,w=G(C,74),m=l[A|0]+((((w+G(t,29)|0)+G(n,84)|0)+G(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,u[A|0]=(m|0)>0?m:0,w=l[A+1|0]+((((w+G(t,55)|0)+G(n,-29)|0)+G(f,-84)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+1|0]=(w|0)>0?w:0,f=l[A+3|0]+((((G(C,-74)+G(t,84)|0)+G(n,55)|0)+G(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,n=(f|0)>0?f:0,u[A+3|0]=n,f=A+r|0,n=n+(((G(h,-74)+G(s,74)|0)+G(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+2|0]=(n|0)>0?n:0,n=G(D,74),t=l[f|0]+((((n+G(s,29)|0)+G(h,84)|0)+G(k,55)|0)+2048>>12)|0,t=(t|0)>=255?255:t,u[f|0]=(t|0)>0?t:0,n=l[f+1|0]+((((n+G(s,55)|0)+G(h,-29)|0)+G(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+1|0]=(n|0)>0?n:0,k=l[f+3|0]+((((G(D,-74)+G(s,84)|0)+G(h,55)|0)+G(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,k=(k|0)>0?k:0,u[f+3|0]=k,k=k+(((G(W,-74)+G(_,74)|0)+G(o,74)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[A+4|0]=(k|0)>0?k:0,k=G(V,74),f=l[A+2|0]+((((k+G(_,29)|0)+G(W,84)|0)+G(o,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[A+2|0]=(f|0)>0?f:0,k=l[A+3|0]+((((k+G(_,55)|0)+G(W,-29)|0)+G(o,-84)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[A+3|0]=(k|0)>0?k:0,o=l[A+5|0]+((((G(V,-74)+G(_,84)|0)+G(W,55)|0)+G(o,-29)|0)+2048>>12)|0,o=(o|0)>=255?255:o,o=(o|0)>0?o:0,u[A+5|0]=o,A=G(r,3)+A|0,r=o+(((G(B,-74)+G(e,74)|0)+G(g,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+2|0]=(r|0)>0?r:0,r=G(I,74),o=l[A|0]+((((r+G(e,29)|0)+G(B,84)|0)+G(g,55)|0)+2048>>12)|0,o=(o|0)>=255?255:o,u[A|0]=(o|0)>0?o:0,r=l[A+1|0]+((((r+G(e,55)|0)+G(B,-29)|0)+G(g,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+1|0]=(r|0)>0?r:0,r=A,A=l[A+3|0]+((((G(I,-74)+G(e,84)|0)+G(B,55)|0)+G(g,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,u[r+3|0]=(A|0)>0?A:0}function UB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0,b1=0,G4=0,W4=0,X4=0,j4=0,O4=0,L4=0,c8=0,b8=0,yi=0,Yi=0,zk=0,Tk=0,Sk=0,jk=0,Ok=0,Lk=0,Pk=0,qk=0,Kk=0,ak=0,$k=0,dk=0,ck=0,bk=0,i5=0,e5=0,r5=0,f5=0,A5=0,k5=0,n5=0,t5=0,u5=0,o5=0,l5=0,s5=0,w5=0,h5=0,_5=0,B5=0,v5=0,m5=0,Z5=0,G5=0,W5=0,X5=0,g5=0,Q5=0,I5=0,C5=0,V5=0,F5=0,E5=0,p5=0,y5=0,Y5=0,R5=0,J5=0,N5=0,M5=0,U5=0,D5=0,H5=0,x5=0,z5=0,T5=0;W=G(r,14)+e|0,y=F[W+14>>1],R=F[e+14>>1],N=F[e+6>>1],s=R+N|0,O=F[e+10>>1],L=F[e+2>>1],w=O+L|0,f=s+w|0,a=F[e+12>>1],$=F[e+4>>1],_=a+$|0,m0=F[e+8>>1],W0=F[e>>1],B=m0+W0|0,n=_+B|0,t=f+n|0,k=(r<<3)+e|0,Q0=F[k+14>>1],V0=F[k+6>>1],g=Q0+V0|0,e0=F[k+10>>1],r0=F[k+2>>1],I=e0+r0|0,h=g+I|0,N0=F[k+12>>1],U0=F[k+4>>1],C=N0+U0|0,Z2=F[k+8>>1],g2=F[k>>1],D=Z2+g2|0,m=C+D|0,o=h+m|0,V=t-o|0,k=(r<<2)+e|0,Q2=F[k+14>>1],E2=F[k+6>>1],D0=Q2+E2|0,H2=F[k+10>>1],T2=F[k+2>>1],H0=H2+T2|0,f0=D0+H0|0,b2=F[k+12>>1],e1=F[k+4>>1],L0=b2+e1|0,W1=F[k+8>>1],J1=F[k>>1],q0=W1+J1|0,A0=L0+q0|0,x=f0+A0|0,k=G(r,12)+e|0,x1=F[k+14>>1],b1=F[k+6>>1],$0=x1+b1|0,G4=F[k+10>>1],W4=F[k+2>>1],P0=G4+W4|0,n0=$0+P0|0,X4=F[k+12>>1],j4=F[k+4>>1],d0=X4+j4|0,O4=F[k+8>>1],c8=F[k>>1],L4=O4+c8|0,n2=d0+L4|0,h0=n0+n2|0,S=x-h0|0,b8=V-S|0,k=(r<<1)+e|0,yi=F[k+14>>1],Yi=F[k+6>>1],zk=yi+Yi|0,Tk=F[k+10>>1],Sk=F[k+2>>1],jk=Tk+Sk|0,Ok=zk+jk|0,Lk=F[k+12>>1],Pk=F[k+4>>1],qk=Lk+Pk|0,Kk=F[k+8>>1],ak=F[k>>1],$k=Kk+ak|0,dk=qk+$k|0,ck=Ok+dk|0,k=G(r,10)+e|0,bk=F[k+14>>1],i5=F[k+6>>1],e5=bk+i5|0,r5=F[k+10>>1],f5=F[k+2>>1],A5=r5+f5|0,k5=e5+A5|0,n5=F[k+12>>1],t5=F[k+4>>1],u5=n5+t5|0,o5=F[k+8>>1],k=F[k>>1],l5=o5+k|0,s5=u5+l5|0,w5=k5+s5|0,h5=ck-w5|0,e=G(r,6)+e|0,r=F[e+14>>1],_5=F[e+6>>1],B5=r+_5|0,v5=F[e+10>>1],m5=F[e+2>>1],Z5=v5+m5|0,G5=B5+Z5|0,W5=F[e+12>>1],X5=F[e+4>>1],g5=W5+X5|0,Q5=F[e+8>>1],e=F[e>>1],I5=Q5+e|0,C5=g5+I5|0,V5=G5+C5|0,F5=F[W+6>>1],E5=y+F5|0,p5=F[W+10>>1],y5=F[W+2>>1],Y5=p5+y5|0,R5=E5+Y5|0,J5=F[W+12>>1],N5=F[W+4>>1],M5=J5+N5|0,U5=F[W+8>>1],W=F[W>>1],D5=U5+W|0,H5=M5+D5|0,x5=R5+H5|0,z5=V5-x5|0,T5=h5-z5|0,Q[A+112>>1]=b8-T5,Q[A+96>>1]=b8+T5,V=V+S|0,S=h5+z5|0,Q[A+80>>1]=V-S,Q[A+64>>1]=V+S,t=t+o|0,o=x+h0|0,V=t-o|0,x=ck+w5|0,h0=V5+x5|0,S=x-h0|0,Q[A+48>>1]=V-S,Q[A+32>>1]=V+S,t=t+o|0,o=x+h0|0,Q[A+16>>1]=t-o,Q[A>>1]=t+o,f=n-f|0,n=m-h|0,t=f-n|0,h=A0-f0|0,m=n2-n0|0,o=h-m|0,V=t-o|0,f0=dk-Ok|0,A0=s5-k5|0,x=f0-A0|0,n0=C5-G5|0,n2=H5-R5|0,h0=n0-n2|0,S=x-h0|0,Q[A+114>>1]=V-S,Q[A+98>>1]=V+S,t=t+o|0,o=x+h0|0,Q[A+82>>1]=t-o,Q[A+66>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+A0|0,m=n0+n2|0,o=h-m|0,Q[A+50>>1]=t-o,Q[A+34>>1]=t+o,f=f+n|0,n=h+m|0,Q[A+18>>1]=f-n,Q[A+2>>1]=f+n,s=w-s|0,w=B-_|0,f=s+w|0,_=I-g|0,B=D-C|0,n=_+B|0,t=f-n|0,g=H0-D0|0,I=q0-L0|0,h=g+I|0,C=P0-$0|0,D=L4-d0|0,m=C+D|0,o=h-m|0,V=t-o|0,D0=jk-zk|0,H0=$k-qk|0,f0=D0+H0|0,L0=A5-e5|0,q0=l5-u5|0,A0=L0+q0|0,x=f0-A0|0,$0=Z5-B5|0,P0=I5-g5|0,n0=$0+P0|0,d0=Y5-E5|0,L4=D5-M5|0,n2=d0+L4|0,h0=n0-n2|0,S=x-h0|0,Q[A+116>>1]=V-S,Q[A+100>>1]=V+S,t=t+o|0,o=x+h0|0,Q[A+84>>1]=t-o,Q[A+68>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+A0|0,m=n0+n2|0,o=h-m|0,Q[A+52>>1]=t-o,Q[A+36>>1]=t+o,f=f+n|0,n=h+m|0,Q[A+20>>1]=f-n,Q[A+4>>1]=f+n,s=w-s|0,w=B-_|0,f=s-w|0,_=I-g|0,B=D-C|0,n=_-B|0,t=f-n|0,g=H0-D0|0,I=q0-L0|0,h=g-I|0,C=P0-$0|0,D=L4-d0|0,m=C-D|0,o=h-m|0,Q[A+118>>1]=t-o,Q[A+102>>1]=t+o,f=f+n|0,n=h+m|0,Q[A+86>>1]=f-n,Q[A+70>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=g+I|0,B=C+D|0,n=_-B|0,Q[A+54>>1]=f-n,Q[A+38>>1]=f+n,s=s+w|0,w=_+B|0,Q[A+22>>1]=s-w,Q[A+6>>1]=s+w,R=N-R|0,N=L-O|0,s=R+N|0,O=$-a|0,L=W0-m0|0,w=O+L|0,f=s+w|0,a=V0-Q0|0,$=r0-e0|0,_=a+$|0,m0=U0-N0|0,W0=g2-Z2|0,B=m0+W0|0,n=_+B|0,t=f-n|0,Q0=E2-Q2|0,V0=T2-H2|0,g=Q0+V0|0,e0=e1-b2|0,r0=J1-W1|0,I=e0+r0|0,h=g+I|0,N0=b1-x1|0,U0=W4-G4|0,C=N0+U0|0,Z2=j4-X4|0,g2=c8-O4|0,D=Z2+g2|0,m=C+D|0,o=h-m|0,V=t-o|0,Q2=Yi-yi|0,E2=Sk-Tk|0,D0=Q2+E2|0,H2=Pk-Lk|0,T2=ak-Kk|0,H0=H2+T2|0,f0=D0+H0|0,b2=i5-bk|0,e1=f5-r5|0,L0=b2+e1|0,W1=t5-n5|0,k=k-o5|0,J1=W1+k|0,q0=L0+J1|0,A0=f0-q0|0,r=_5-r|0,x=m5-v5|0,x1=r+x|0,b1=X5-W5|0,e=e-Q5|0,$0=b1+e|0,G4=x1+$0|0,y=F5-y|0,W4=y5-p5|0,P0=y+W4|0,n0=N5-J5|0,W=W-U5|0,X4=n0+W|0,j4=P0+X4|0,d0=G4-j4|0,O4=A0-d0|0,Q[A+120>>1]=V-O4,Q[A+104>>1]=V+O4,t=t+o|0,o=A0+d0|0,Q[A+88>>1]=t-o,Q[A+72>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+q0|0,m=G4+j4|0,o=h-m|0,Q[A+56>>1]=t-o,Q[A+40>>1]=t+o,f=f+n|0,n=h+m|0,Q[A+24>>1]=f-n,Q[A+8>>1]=f+n,s=w-s|0,w=B-_|0,f=s-w|0,_=I-g|0,B=D-C|0,n=_-B|0,t=f-n|0,g=H0-D0|0,I=J1-L0|0,h=g-I|0,C=$0-x1|0,D=X4-P0|0,m=C-D|0,o=h-m|0,Q[A+122>>1]=t-o,Q[A+106>>1]=t+o,f=f+n|0,n=h+m|0,Q[A+90>>1]=f-n,Q[A+74>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=g+I|0,B=C+D|0,n=_-B|0,Q[A+58>>1]=f-n,Q[A+42>>1]=f+n,s=s+w|0,w=_+B|0,Q[A+26>>1]=s-w,Q[A+10>>1]=s+w,R=N-R|0,N=L-O|0,s=R+N|0,O=$-a|0,L=W0-m0|0,w=O+L|0,f=s-w|0,a=V0-Q0|0,$=r0-e0|0,_=a+$|0,m0=U0-N0|0,W0=g2-Z2|0,B=m0+W0|0,n=_-B|0,t=f-n|0,Q0=E2-Q2|0,V0=T2-H2|0,g=Q0+V0|0,e0=e1-b2|0,k=k-W1|0,r0=e0+k|0,I=g-r0|0,r=x-r|0,e=e-b1|0,h=r+e|0,y=W4-y|0,W=W-n0|0,N0=y+W|0,U0=h-N0|0,C=I-U0|0,Q[A+124>>1]=t-C,Q[A+108>>1]=t+C,f=f+n|0,n=I+U0|0,Q[A+92>>1]=f-n,Q[A+76>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=g+r0|0,B=h+N0|0,n=_-B|0,Q[A+60>>1]=f-n,Q[A+44>>1]=f+n,s=s+w|0,w=_+B|0,Q[A+28>>1]=s-w,Q[A+12>>1]=s+w,W=W-y|0,e=e-r|0,r=W+e|0,k=k-e0|0,y=V0-Q0|0,s=k+y|0,w=r+s|0,f=W0-m0|0,a=$-a|0,$=f+a|0,O=L-O|0,R=N-R|0,N=O+R|0,L=$+N|0,Q[A+14>>1]=w+L,Q[A+30>>1]=L-w,r=s-r|0,N=N-$|0,Q[A+46>>1]=r+N,Q[A+62>>1]=N-r,e=e-W|0,r=y-k|0,W=e+r|0,k=a-f|0,y=R-O|0,R=k+y|0,Q[A+78>>1]=W+R,Q[A+94>>1]=R-W,e=r-e|0,r=y-k|0,Q[A+110>>1]=e+r,Q[A+126>>1]=r-e}function $7(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;s=v-32|0,v=s,h=i[r>>2],w=i[r+4>>2],$4(e+112|0,i[e+116>>2],h,w,w-h|0),h=i[i[e+188>>2]+108>>2]-8|0,i[h>>2]=i[h>>2]+1;i:{if(w=i[e+228>>2],h=i[w+108>>2],W=i[r+4>>2]-i[r>>2]|0,!(h|!W)){i[w+104>>2]=W,i[w+108>>2]=1;break i}if(r=i[w+104>>2],!(!W|(r|0)!=(W|0))){i[w+108>>2]=h+1;break i}e:{r:{f:{if(r){if(h)for(r=i[w+116>>2];;){_=i[w+120>>2];A:{if(_>>>0>r>>>0){i[r>>2]=i[w+104>>2],r=r+4|0;break A}if(m=i[w+112>>2],r=r-m|0,g=r>>2,h=g+1|0,h>>>0>=1073741824)break f;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:h>>>0<B>>>0?B:h,_){if(_>>>0>=1073741824)break r;h=E(_<<2)}else h=0;if(B=h+r|0,i[B>>2]=i[w+104>>2],g=B-(g<<2)|0,r&&z(g,m,r),i[w+120>>2]=h+(_<<2),r=B+4|0,i[w+116>>2]=r,i[w+112>>2]=g,!m)break A;Z(m)}if(i[w+116>>2]=r,I=I+1|0,!(I>>>0<u0[w+108>>2]))break}i[w+104>>2]=0}r=i[w+116>>2],_=i[w+120>>2];A:{if(r>>>0<_>>>0){i[r>>2]=W,r=r+4|0;break A}if(m=i[w+112>>2],r=r-m|0,g=r>>2,h=g+1|0,h>>>0>=1073741824)break e;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:h>>>0<B>>>0?B:h,_){if(_>>>0>=1073741824)break r;h=E(_<<2)}else h=0;if(B=h+r|0,i[B>>2]=W,W=B-(g<<2)|0,r&&z(W,m,r),i[w+120>>2]=h+(_<<2),r=B+4|0,i[w+116>>2]=r,i[w+112>>2]=W,!m)break A;Z(m)}i[w+116>>2]=r,i[w+108>>2]=i[w+108>>2]+1;break i}G0(),H()}x0(),H()}G0(),H()}n&&Au(i[e+220>>2],i[e+92>>2]+1|0);i:{if(!f){if(e=E(32),i[s+16>>2]=e,i[s+20>>2]=28,i[s+24>>2]=-2147483616,r=l[22098]|l[22099]<<8|(l[22100]<<16|l[22101]<<24),f=l[22094]|l[22095]<<8|(l[22096]<<16|l[22097]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,r=l[22118]|l[22119]<<8|(l[22120]<<16|l[22121]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[22114]|l[22115]<<8|(l[22116]<<16|l[22117]<<24),f=l[22110]|l[22111]<<8|(l[22112]<<16|l[22113]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22106]|l[22107]<<8|(l[22108]<<16|l[22109]<<24),f=l[22102]|l[22103]<<8|(l[22104]<<16|l[22105]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,5,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}Nt(i[e+204>>2],f),Nt(i[e+212>>2],k);e:{if(r=i[e+40>>2],!r)break e;if(t){if(r=s+16|0,Iu(r,t),M9(A,i[e+264>>2],r),f=i[A>>2],f|u[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+16>>2],r&&(i[s+20>>2]=r,Z(r)),f)break i;break e}if((r|0)==1){Kf(i[i[e+264>>2]>>2],0);break e}if(e=E(32),i[s+16>>2]=e,i[s+20>>2]=31,i[s+24>>2]=-2147483616,r=l[10974]|l[10975]<<8|(l[10976]<<16|l[10977]<<24),f=l[10970]|l[10971]<<8|(l[10972]<<16|l[10973]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[10997]|l[10998]<<8|(l[10999]<<16|l[11e3]<<24),f=l[10993]|l[10994]<<8|(l[10995]<<16|l[10996]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[10990]|l[10991]<<8|(l[10992]<<16|l[10993]<<24),f=l[10986]|l[10987]<<8|(l[10988]<<16|l[10989]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[10982]|l[10983]<<8|(l[10984]<<16|l[10985]<<24),f=l[10978]|l[10979]<<8|(l[10980]<<16|l[10981]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}e:{r:{r=i[e+48>>2];f:{if(!r)break f;if(l[o+12|0]==1){A:{if(u[o+11|0]>=0){i[s+24>>2]=i[o+8>>2],r=i[o+4>>2],i[s+16>>2]=i[o>>2],i[s+20>>2]=r;break A}T(s+16|0,i[o>>2],i[o+4>>2])}if(f=i[s+16>>2],r=u[s+27|0],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,k=s+4|0,n=f,f=(r|0)<0,n=f?n:s+16|0,r=(f?i[s+20>>2]:r)+1|0,Xn(k,n,r+n|0,r),M9(A,i[e+268>>2],k),f=i[A>>2],f|u[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+4>>2],r&&(i[s+8>>2]=r,Z(r)),u[s+27|0]<0&&Z(i[s+16>>2]),!f)break f;break i}if((r|0)!=1)break r;Kf(i[i[e+268>>2]>>2],0)}if(i[e+92>>2]=i[e+92>>2]+1,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break e;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}if(e=E(32),i[s+16>>2]=e,i[s+20>>2]=27,i[s+24>>2]=-2147483616,r=l[11006]|l[11007]<<8|(l[11008]<<16|l[11009]<<24),f=l[11002]|l[11003]<<8|(l[11004]<<16|l[11005]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[11025]|l[11026]<<8|(l[11027]<<16|l[11028]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[11022]|l[11023]<<8|(l[11024]<<16|l[11025]<<24),f=l[11018]|l[11019]<<8|(l[11020]<<16|l[11021]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11014]|l[11015]<<8|(l[11016]<<16|l[11017]<<24),f=l[11010]|l[11011]<<8|(l[11012]<<16|l[11013]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}T(A,i[26930],i[26931])}v=s+32|0}function DB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;k=v-160|0,v=k,i[k+84>>2]=0,i[k+56>>2]=72548,f=i[18140],i[k>>2]=f,i[i[f-12>>2]+k>>2]=i[18141],f=i[i[k>>2]-12>>2]+k|0,n=k+4|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,i[k+56>>2]=72548,i[k>>2]=72528,m=R0(n),i[m>>2]=71280,i[k+44>>2]=0,i[k+48>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+52>>2]=16,f=k+148|0,Y2(f,e,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(k,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]);i:{if(h=i[e+104>>2],W=i[e+108>>2],(h|0)!=(W|0))for(;;){e=k+148|0,s0(e,r),t=e,e=u[k+159|0],f=(e|0)<0,Y(k,f?i[k+148>>2]:t,f?i[k+152>>2]:e),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(I0(Y(k,32615,9),i[h>>2]),42713,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(S0(Y(e,32114,23),l[h+4|0]),42713,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(e,29459,24),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|8,e=I0(e,F[h+6>>1]),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|2,e=Y(e,42713,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),Y(K2(Y(e,29753,15),i[h+8>>2],i[h+12>>2]),42713,1),e=k+148|0,s0(e,r),t=e,e=u[k+159|0],f=(e|0)<0,Y(k,f?i[k+148>>2]:t,f?i[k+152>>2]:e),u[k+159|0]<0&&Z(i[k+148>>2]),Y(k,29833,11);e:{if(e=i[h+16>>2],g=i[h+20>>2],(e|0)==(g|0))break e;r:{for(;;){f:{w=K2(k,i[e+8>>2],i[e+12>>2]),B=G1(k+140|0,w);A:{if(l[B|0]!=1)break A;n=w+i[i[w>>2]-12>>2]|0,_=i[n+4>>2],o=i[n+24>>2];k:{if(l[n+80|0]==1){s=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129808),s=X[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=s,u[n+77|0]=s>>>8,u[n+78|0]=s>>>16,u[n+79|0]=s>>>24,u[n+80|0]=1}k:{if(!o||(f=i[n+12>>2],_=(_&176)==32?26344:26343,t=_-26343|0,(t|0)>0&&(X[i[i[o>>2]+48>>2]](o,26343,t)|0)!=(t|0)))break k;if((f|0)>=2){if(f>>>0>=2147483641)break f;t=((f|0)<=1?1:f)-1|0;n:{if(f>>>0>=12){I=t|7,f=E(I+1|0),i[k+156>>2]=I-2147483647,i[k+148>>2]=f,i[k+152>>2]=t;break n}u[k+159|0]=t,f=k+148|0}if(t&&o0(f,s,t),u[f+t|0]=0,f=X[i[i[o>>2]+48>>2]](o,u[k+159|0]<0?i[k+148>>2]:k+148|0,t)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(t|0))break k}if(f=26344-_|0,(f|0)>0&&(X[i[i[o>>2]+48>>2]](o,_,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=w+i[i[w>>2]-12>>2]|0,H1(f,i[f+16>>2]|5)}if(_1(B),K2(w,i[e+16>>2],i[e+20>>2]),i[e>>2]|i[e+4>>2]){_=G1(k+140|0,k);A:{if(l[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,o=i[n+4>>2],s=i[n+24>>2];k:{if(l[n+80|0]==1){f=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129808),f=X[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=f,u[n+77|0]=f>>>8,u[n+78|0]=f>>>16,u[n+79|0]=f>>>24,u[n+80|0]=1}k:{if(!s||(t=i[n+12>>2],w=(o&176)==32?20890:20883,o=w-20883|0,(o|0)>0&&(X[i[i[s>>2]+48>>2]](s,20883,o)|0)!=(o|0)))break k;if((t|0)>=8){if((t|0)==2147483647)break i;o=((t|0)<=7?7:t)-7|0;n:{if(t>>>0>=18){B=o|7,t=E(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=t,i[k+152>>2]=o;break n}u[k+159|0]=o,t=k+148|0}if(o&&o0(t,f,o),u[t+o|0]=0,f=X[i[i[s>>2]+48>>2]](s,u[k+159|0]<0?i[k+148>>2]:k+148|0,o)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(o|0))break k}if(f=20890-w|0,(f|0)>0&&(X[i[i[s>>2]+48>>2]](s,w,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,H1(f,i[f+16>>2]|5)}_1(_),K2(k,i[e>>2],i[e+4>>2])}_=G1(k+140|0,k);A:{if(l[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,o=i[n+4>>2],s=i[n+24>>2];k:{if(l[n+80|0]==1){f=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129808),f=X[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=f,u[n+77|0]=f>>>8,u[n+78|0]=f>>>16,u[n+79|0]=f>>>24,u[n+80|0]=1}k:{if(!s||(t=i[n+12>>2],w=(o&176)==32?32852:32851,o=w-32851|0,(o|0)>0&&(X[i[i[s>>2]+48>>2]](s,32851,o)|0)!=(o|0)))break k;if((t|0)>=2){if(t>>>0>=2147483641)break r;o=((t|0)<=1?1:t)-1|0;n:{if(t>>>0>=12){B=o|7,t=E(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=t,i[k+152>>2]=o;break n}u[k+159|0]=o,t=k+148|0}if(o&&o0(t,f,o),u[t+o|0]=0,f=X[i[i[s>>2]+48>>2]](s,u[k+159|0]<0?i[k+148>>2]:k+148|0,o)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(o|0))break k}if(f=32852-w|0,(f|0)>0&&(X[i[i[s>>2]+48>>2]](s,w,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,H1(f,i[f+16>>2]|5)}if(_1(_),e=e+40|0,(g|0)!=(e|0))continue;break e}break}break i}break i}if(Y(k,42713,1),h=h+32|0,(W|0)==(h|0))break}e=i[k+52>>2];e:{r:{if(e&16){e=i[k+48>>2],r=i[k+28>>2],e>>>0<r>>>0&&(i[k+48>>2]=r,e=r),r=k+24|0;break r}if(!(e&8)){e=0,u[A+11|0]=0;break e}e=i[k+20>>2],r=k+12|0}r:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(u[A+11|0]=e,e)break r;e=0;break e}g0(),H()}if(!e)break e;z(A,f,e)}u[A+e|0]=0,A=i[18139],i[k>>2]=A,i[i[A-12>>2]+k>>2]=i[18142],i[m>>2]=71280,u[k+47|0]<0&&Z(i[k+36>>2]),y0(m),p0(k+56|0),v=k+160|0;return}g0(),H()}function HB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=M(0),_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=M(0),O=0,L=0,a=0,$=0,f0=M(0),A0=M(0),n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=M(0),N0=0,U0=0,D0=0,H0=0,L0=M(0),q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0;s=v-48|0,v=s,e=i[r>>2],W=i[e+112>>2],g=i[e+108>>2],_=j0(e,0),D=u1(i[r>>2],6),B=i[k+4>>2],w=E(172),i[w>>2]=94860,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],n=e+1|0,i[w+4>>2]=n,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,Q[w+22>>1]=2,Q[w+18>>1]=2,Q[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95208,i[w+148>>2]=0,i[w+152>>2]=0,f=w+140|0,i[w+136>>2]=f,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],m=w+12|0,i[w+96>>2]=m,i[w+8>>2]=e+1,i[w+100>>2]=w,n||(X[i[i[w>>2]+8>>2]](w),p(w)),i[m+120>>2]=i[k+4>>2],i[m+116>>2]=1,i[m+112>>2]=W,i[m+108>>2]=g,T0(s+24|0,m,10,g,W,_,o);i:{e:{if(i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}u[s+43|0]<0&&Z(i[s+32>>2]);r:{if(!D)break r;f:{if((o8(i[r>>2],6)|0)==(g|0)&&(l8(i[r>>2],6)|0)==(W|0))break f;e=E(96),i[s+4>>2]=e,i[s+8>>2]=90,i[s+12>>2]=-2147483552,z(e,24986,90),u[e+90|0]=0,f=K(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;A:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break A}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break A;Z(i[f+8>>2])}if(u[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if((j0(i[r>>2],6)|0)!=(_|0)){e=E(96),i[s+4>>2]=e,i[s+8>>2]=94,i[s+12>>2]=-2147483552,z(e,25381,94),u[e+94|0]=0,f=K(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if(T0(s+24|0,m,6,g,W,_,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]>=0)break r;Z(i[s+32>>2])}r:{f:{if(k=i[f>>2],!k)break f;for(e=f;n=i[k+16>>2]<10,e=n?e:k,k=i[(n?4:0)+k>>2],!!k;);if((e|0)==(f|0))break f;if(f=0,i[e+16>>2]>10)break r;h0=i[e+56>>2],f=i[e+44>>2];break r}f=0}V=f;r:{f:{if(f=i[r>>2],e=i[f+128>>2],e){for(f=f+128|0,n=f,k=e;t=i[k+16>>2],n=(t|0)<0?n:k,k=i[(t>>>29&4)+k>>2],!!k;);y=0;A:{if((f|0)==(n|0)||(y=0,i[n+16>>2]>0))break A;m0=i[n+56>>2],y=i[n+44>>2]}for(n=f,k=e;t=i[k+16>>2]<=0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);R=0;A:{if((f|0)==(n|0)||(R=0,i[n+16>>2]>1))break A;W0=i[n+44>>2],R=i[n+56>>2]}for(n=f,k=e;t=i[k+16>>2]<2,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);N=0;A:{if((f|0)==(n|0)||(N=0,i[n+16>>2]>2))break A;Q0=i[n+56>>2],N=i[n+44>>2]}if(I=0,!D)break r;for(k=f;n=i[e+16>>2]<6,k=n?k:e,e=i[(n?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}I=0;break r}if(I=0,i[k+16>>2]>6)break r;V0=i[k+56>>2],I=i[k+44>>2]}if(i[s+36>>2]=-1086926434,i[s+40>>2]=1071829221,i[s+28>>2]=1068725436,i[s+32>>2]=-1095748968,u[s+24|0]=1,e=1,S4(i[r>>2])&&(r=i[r>>2],e=F[r+6>>1]|F[r+8>>1]<<16,r=F[r+10>>1]|F[r+12>>1]<<16,le(s+4|0,r&65535,e&65535),i[s+40>>2]=i[s+20>>2],e=i[s+16>>2],i[s+32>>2]=i[s+12>>2],i[s+36>>2]=e,e=i[s+8>>2],i[s+24>>2]=i[s+4>>2],i[s+28>>2]=e,e=(r&65536)>>>16|0),!(!W|!g))for(r=B&-2,L=(r|0)==14,e0=D?8:6,r0=M(16<<_-8),B=-1<<_^-1,n=B>>>8|0,a=1<<_-1,N0=((r|0)!=14)+V|0,r=(r|0)==14,U0=(r?6:7)+V|0,D0=(r?4:5)+V|0,H0=(r?2:3)+V|0,L0=E0[s+28>>2];;){for(x=G(C,h0),q0=U0+x|0,$0=(G(C,V0)&-2)+I|0,P0=(G(C,m0)&-2)+y|0,$=V+x|0,d0=($+L|0)+6|0,r=C>>>1|0,n2=(G(r,Q0)&-2)+N|0,Z2=(G(r,R)&-2)+W0|0,k=0;;){r=0,f=k&-2,h=M(F[f+Z2>>1]-a|0),f0=e?h:M(h*M(1.142899990081787)),t=0,h=M(F[f+n2>>1]-a|0),A0=e?h:M(h*M(1.142899990081787)),n0=k<<1,h=M(F[n0+P0>>1]),S=e?h:M(M(h-r0)*M(1.1689000129699707)),h=M(M(M(L0*A0)+S)+M(.5)),M(w2(h))<M(2147483648)?o=~~h:o=-2147483648,f=0;r:{if((o|0)<0)break r;if((o|0)>(B|0)){t=n,f=B;break r}t=o>>>8|0,f=o}g2=f,h=M(M(M(E0[s+36>>2]*A0)+M(M(E0[s+32>>2]*f0)+S))+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,o=0;r:{if((f|0)<0)break r;if((f|0)>(B|0)){r=B,o=n;break r}r=f,o=f>>>8|0}Q2=o,o=0,h=M(M(M(E0[s+40>>2]*f0)+S)+M(.5)),M(w2(h))<M(2147483648)?f=~~h:f=-2147483648,_=0;r:{if((f|0)<0)break r;if((f|0)>(B|0)){o=n,_=B;break r}o=f>>>8|0,_=f}if(f=G(k,e0),O=(f+$|0)+L|0,u[O|0]=t,u[O+2|0]=Q2,u[O+4|0]=o,f=f+x|0,u[f+N0|0]=g2,u[f+H0|0]=r,u[f+D0|0]=_,D&&(f=k<<3,r=$0+n0|0,u[f+d0|0]=l[r+1|0],u[f+q0|0]=l[r|0]),k=k+1|0,(g|0)==(k|0))break}if(C=C+1|0,(C|0)==(W|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=m;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;X[i[i[w>>2]+8>>2]](w),p(w)}v=s+48|0}function C6(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-160|0,v=k,n=J6(i[e+48>>2],r);i:{if(!(!((n|0)==1735551332|(n|0)==1768912492)&(n|0)!=1768187246)){n=i[e+48>>2],t=i[n+84>>2],n=i[n+88>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);e:{if(!t){if(e=E(56),i[k>>2]=e,i[k+4>>2]=54,i[k+8>>2]=-2147483592,r=l[5037]|l[5038]<<8|(l[5039]<<16|l[5040]<<24),f=l[5033]|l[5034]<<8|(l[5035]<<16|l[5036]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[5083]|l[5084]<<8|(l[5085]<<16|l[5086]<<24),f=l[5079]|l[5080]<<8|(l[5081]<<16|l[5082]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[5077]|l[5078]<<8|(l[5079]<<16|l[5080]<<24),f=l[5073]|l[5074]<<8|(l[5075]<<16|l[5076]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5069]|l[5070]<<8|(l[5071]<<16|l[5072]<<24),f=l[5065]|l[5066]<<8|(l[5067]<<16|l[5068]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5061]|l[5062]<<8|(l[5063]<<16|l[5064]<<24),f=l[5057]|l[5058]<<8|(l[5059]<<16|l[5060]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5053]|l[5054]<<8|(l[5055]<<16|l[5056]<<24),f=l[5049]|l[5050]<<8|(l[5051]<<16|l[5052]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5045]|l[5046]<<8|(l[5047]<<16|l[5048]<<24),f=l[5041]|l[5042]<<8|(l[5043]<<16|l[5044]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,117,k),u[k+11|0]>=0)break e;Z(i[k>>2]);break e}L8(k,t,r,1684630887);r:{f:{if(t=i[k>>2],(t|0)!=i[k+4>>2]&&(o=r,r=i[t>>2],(o|0)!=(r|0)))break f;if(e=E(56),i[k+148>>2]=e,i[k+152>>2]=54,i[k+156>>2]=-2147483592,r=l[5037]|l[5038]<<8|(l[5039]<<16|l[5040]<<24),f=l[5033]|l[5034]<<8|(l[5035]<<16|l[5036]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[5083]|l[5084]<<8|(l[5085]<<16|l[5086]<<24),f=l[5079]|l[5080]<<8|(l[5081]<<16|l[5082]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[5077]|l[5078]<<8|(l[5079]<<16|l[5080]<<24),f=l[5073]|l[5074]<<8|(l[5075]<<16|l[5076]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5069]|l[5070]<<8|(l[5071]<<16|l[5072]<<24),f=l[5065]|l[5066]<<8|(l[5067]<<16|l[5068]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5061]|l[5062]<<8|(l[5063]<<16|l[5064]<<24),f=l[5057]|l[5058]<<8|(l[5059]<<16|l[5060]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5053]|l[5054]<<8|(l[5055]<<16|l[5056]<<24),f=l[5049]|l[5050]<<8|(l[5051]<<16|l[5052]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5045]|l[5046]<<8|(l[5047]<<16|l[5048]<<24),f=l[5041]|l[5042]<<8|(l[5043]<<16|l[5044]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,117,k+148|0),u[k+159|0]>=0)break r;Z(i[k+148>>2]);break r}C6(A,e,r,f)}if(A=i[k>>2],!A)break e;i[k+4>>2]=A,Z(A)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n);break i}e:{r:{f:{A:{k:{if(n=i[e+20>>2],!n)break k;for(t=e+20|0,e=t;o=u0[n+16>>2]<r>>>0,e=o?e:n,n=i[(o?4:0)+n>>2],!!n;);if((e|0)==(t|0)|u0[e+16>>2]>r>>>0)break k;if(i[f>>2]=r,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break A;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}i[k+92>>2]=0,i[k+64>>2]=72244,i[k+8>>2]=72224,e=i[18065],i[k>>2]=e,i[i[e-12>>2]+k>>2]=i[18066],i[k+4>>2]=0,e=i[i[k>>2]-12>>2]+k|0,f=k+12|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[k+8>>2]=e,n=i[e-12>>2],e=k+8|0,i[n+e>>2]=i[18068],n=i[18064],i[k>>2]=n,i[i[n-12>>2]+k>>2]=i[18069],i[k+64>>2]=72244,i[k>>2]=72204,i[k+8>>2]=72224,f=R0(f),i[f>>2]=71280,i[k+52>>2]=0,i[k+56>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+60>>2]=24,Y(I0(Y(e,28357,11),r),32862,35),e=i[k+60>>2];k:{if(e&16){n=i[k+56>>2],e=i[k+36>>2],n>>>0<e>>>0&&(i[k+56>>2]=e,n=e),e=k+32|0;break k}if(!(e&8)){n=0,u[k+159|0]=0,e=k+148|0;break e}n=i[k+28>>2],e=k+20|0}if(r=i[e>>2],n=n-r|0,n>>>0>=2147483640)break f;if(n>>>0>=11){t=n|7,e=E(t+1|0),i[k+156>>2]=t-2147483647,i[k+148>>2]=e,i[k+152>>2]=n;break r}if(u[k+159|0]=n,e=k+148|0,n)break r;n=0;break e}T(A,i[26930],i[26931]);break i}g0(),H()}if(!n)break e;z(e,r,n)}u[e+n|0]=0,K(A,2,2e3,k+148|0),u[k+159|0]<0&&Z(i[k+148>>2]),A=i[18063],i[k>>2]=A,i[i[A-12>>2]+k>>2]=i[18071],i[k+8>>2]=i[18072],i[f>>2]=71280,u[k+55|0]<0&&Z(i[k+44>>2]),y0(f),p0(k- -64|0)}v=k+160|0}function Zf(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;n=v-96|0,v=n,k=i[e+48>>2],o=i[e+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);i:{if(!f){f=v-48|0,v=f,t=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,t,r,k+20|0);e:{if(i[k>>2]){i[f+40>>2]=0,i[f+44>>2]=0;break e}r:{if(t=i[k+20>>2],r=i[k+24>>2],(t|0)!=(r|0)){if(e=i[t>>2],e&&(w=i[f+44>>2],e=X0(e,86628,86832),e))break r;if(t=t+8|0,(r|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(w=0,e=X0(e,86628,86832),e))break r;if(t=t+8|0,(r|0)==(t|0))break}i[f+40>>2]=0,i[f+44>>2]=0}i[f+40>>2]=0,i[f+44>>2]=0;break e}if(i[f+44>>2]=w,i[f+40>>2]=e,e=i[t+4>>2],i[f+44>>2]=e,!e)break e;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,t=i[k+24>>2],(e|0)!=(t|0)){for(;;){e=i[t-4>>2];e:{if(!e||(w=i[e+4>>2],i[e+4>>2]=w-1,w))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(r|0)==(t|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}v=k+32|0,e=i[f+40>>2];e:{if(!e){e=E(32),i[f+4>>2]=e,i[f+8>>2]=26,i[f+12>>2]=-2147483616,r=l[9611]|l[9612]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),k=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),k=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),k=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,e=K(f+16|0,2,116,f+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[f+15|0]<0&&Z(i[f+4>>2]),A=i[f+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}r=i[f+44>>2],u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}e:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break e;X[i[i[s>>2]+8>>2]](s),p(s)}v=f+48|0;break i}i[n+92>>2]=0,i[n+84>>2]=0,i[n+88>>2]=0,j1(n- -64|0,k,r,n+84|0);e:{if(i[n+64>>2]){e=i[n+68>>2],i[A>>2]=i[n+64>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[n+83|0]>=0){r=i[n+76>>2],i[e>>2]=i[n+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+80>>2];break r}T(e,i[n+72>>2],i[n+76>>2])}u[A+20|0]=1;break e}k=f-1|0,e=i[n+84>>2],k>>>0>=i[n+88>>2]-e>>3>>>0&&(e=E(32),i[n+24>>2]=e,i[n+28>>2]=27,i[n+32>>2]=-2147483616,r=l[13933]|l[13934]<<8|(l[13935]<<16|l[13936]<<24),f=l[13929]|l[13930]<<8|(l[13931]<<16|l[13932]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[13952]|l[13953]<<8|(l[13954]<<16|l[13955]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[13949]|l[13950]<<8|(l[13951]<<16|l[13952]<<24),f=l[13945]|l[13946]<<8|(l[13947]<<16|l[13948]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),f=l[13937]|l[13938]<<8|(l[13939]<<16|l[13940]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,e=K(n+44|0,5,2007,n+24|0),u[e+19|0]<0&&Z(i[e+8>>2]),u[n+35|0]<0&&Z(i[n+24>>2]),e=i[n+84>>2]),r=e+(k<<3)|0,e=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{f:{if(!e||(e=X0(e,86628,86832),!e))break f;r&&(i[r+4>>2]=i[r+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break r}e=E(24),i[n+12>>2]=e,i[n+16>>2]=19,i[n+20>>2]=-2147483624,f=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[e+15|0]=f,u[e+16|0]=f>>>8,u[e+17|0]=f>>>16,u[e+18|0]=f>>>24,f=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),k=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,f=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),k=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+19|0]=0,e=K(n+24|0,5,2007,n+12|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break f;Z(i[e+8>>2])}if(u[n+23|0]>=0)break r;Z(i[n+12>>2])}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(u[n+83|0]<0&&Z(i[n+72>>2]),r=i[n+84>>2],!r)break i;if(e=i[n+88>>2],A=r,(e|0)!=(r|0)){for(;;){A=i[e-4>>2];e:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[n+84>>2]}i[n+88>>2]=r,Z(A)}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=n+96|0}function d7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;o=v-80|0,v=o,jf(o+68|0,e,r),e=i[o+68>>2],e=ei(o+32|0,e,i[o+72>>2]-e|0),I2(e,16),I2(e,4),I2(e,4),Q[f+2>>1]=0,B=f,m=V1(e,3)+1|0,u[B+4|0]=m,B=f,m=V1(e,2),u[B+6|0]=m,I2(e,2);i:{if(!i2(e,1))break i;B=f,m=V1(e,7),u[B+9|0]=m,B=f,m=V1(e,1),u[B+10|0]=m,B=f,m=V1(e,8),u[B+11|0]=m,B=f,m=V1(e,1),u[B+12|0]=m,B=f,m=V1(e,1),u[B+13|0]=m;e:{r:{if(!i2(e,1)){u[f+8|0]=1,r=i[f+20>>2],h=i[f+24>>2];f:{if(r>>>0<h>>>0){u[r|0]=0,s=r+1|0;break f}if(t=i[f+16>>2],s=r-t|0,w=s+1|0,(w|0)<0)break r;if(r=0,h=h-t|0,_=h<<1,w=h>>>0>=1073741823?2147483647:w>>>0<_>>>0?_:w,w&&(r=E(w)),h=r+s|0,u[h|0]=0,s&&z(r,t,s),i[f+24>>2]=r+w,s=h+1|0,i[f+20>>2]=s,i[f+16>>2]=r,!t)break f;Z(t)}i[f+20>>2]=s}if(r=i[e+24>>2],i[e+24>>2]=r&-8,w=i[e+20>>2],s=i[e+16>>2],t=r&7,r=t,(r&63)>>>0>=32?(t=s<<r,r=0):(t=(1<<r)-1&s>>>32-r|w<<r,r=s<<r),i[e+16>>2]=r,i[e+20>>2]=t,An(f+28|0,l[f+4|0]),r=l[f+4|0],r>>>0<2)break e;for(r=r-2|0;t=1<<r,w=i2(e,1),s=i[f+28>>2]+(r>>>3&536870908)|0,w?t=t|i[s>>2]:t=i[s>>2]&(t^-1),i[s>>2]=t,t=(r|0)>0,r=r-1|0,!!t;);break e}G0(),H()}r=i[e+24>>2],i[e+24>>2]=r&-8,w=i[e+20>>2],s=i[e+16>>2],t=r&7,r=t,(r&63)>>>0>=32?(t=s<<r,r=0):(t=(1<<r)-1&s>>>32-r|w<<r,r=s<<r),i[e+16>>2]=r,i[e+20>>2]=t,r=l[f+4|0],h=i[f+44>>2],t=i[f+40>>2],s=h-t|0;e:{if(r>>>0>s>>>0){if(w=r-s|0,_=i[f+48>>2],w>>>0<=_-h>>>0){w&&o0(h,0,w),i[f+44>>2]=w+h;break e}if(h=_-t|0,_=h<<1,_=h>>>0>=1073741823?2147483647:r>>>0<_>>>0?_:r,h=E(_),w&&o0(s+h|0,0,w),s&&z(h,t,s),i[f+48>>2]=h+_,i[f+44>>2]=r+h,i[f+40>>2]=h,!t)break e;Z(t);break e}if(r>>>0>=s>>>0)break e;i[f+44>>2]=r+t}if(r=l[f+4|0],r>>>0>=2)for(r=r-2|0;i[i[f+28>>2]+(r>>>3&536870908)>>2]>>>r&1&&(t=V1(e,8),u[i[f+40>>2]+r|0]=t),t=(r|0)>0,r=r-1|0,!!t;);s=f+52|0,t=i2(e,8),w=i[f+52>>2],r=i[f+56>>2]-w>>2;e:{if(t>>>0>r>>>0){I8(s,t-r|0);break e}if(r>>>0<=t>>>0)break e;i[f+56>>2]=w+(t<<2)}if(r=0,(t|0)<=0)break i;for(;w=i2(e,32),i[i[s>>2]+(r<<2)>>2]=w,r=r+1|0,(t|0)!=(r|0););}I2(e,1),i2(e,1)&&I2(e,1),$2(e,o+28|0),$2(e,o+24|0),r=i[o+28>>2],i[k>>2]=r,k=i[o+24>>2],i[n>>2]=k;i:{if(!((k|0)<65536&(r|0)<=65535)){if(e=E(56),i[o+12>>2]=e,i[o+16>>2]=55,i[o+20>>2]=-2147483592,r=l[26718]|l[26719]<<8|(l[26720]<<16|l[26721]<<24),f=l[26714]|l[26715]<<8|(l[26716]<<16|l[26717]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[26765]|l[26766]<<8|(l[26767]<<16|l[26768]<<24),f=l[26761]|l[26762]<<8|(l[26763]<<16|l[26764]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[26758]|l[26759]<<8|(l[26760]<<16|l[26761]<<24),f=l[26754]|l[26755]<<8|(l[26756]<<16|l[26757]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[26750]|l[26751]<<8|(l[26752]<<16|l[26753]<<24),f=l[26746]|l[26747]<<8|(l[26748]<<16|l[26749]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26742]|l[26743]<<8|(l[26744]<<16|l[26745]<<24),f=l[26738]|l[26739]<<8|(l[26740]<<16|l[26741]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26734]|l[26735]<<8|(l[26736]<<16|l[26737]<<24),f=l[26730]|l[26731]<<8|(l[26732]<<16|l[26733]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26726]|l[26727]<<8|(l[26728]<<16|l[26729]<<24),f=l[26722]|l[26723]<<8|(l[26724]<<16|l[26725]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,2006,o+12|0),u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}if(Q[f+66>>1]=k,Q[f+64>>1]=r,i2(e,1)&&($2(e,o+12|0),$2(e,o+8|0),$2(e,o+4|0),$2(e,o)),i2(e,1),$2(e,o+8|0),e=i[o+8>>2],(e|0)>=248){if(e=E(32),i[o+12>>2]=e,i[o+16>>2]=27,i[o+20>>2]=-2147483616,r=l[25301]|l[25302]<<8|(l[25303]<<16|l[25304]<<24),f=l[25297]|l[25298]<<8|(l[25299]<<16|l[25300]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[25320]|l[25321]<<8|(l[25322]<<16|l[25323]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[25317]|l[25318]<<8|(l[25319]<<16|l[25320]<<24),f=l[25313]|l[25314]<<8|(l[25315]<<16|l[25316]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25309]|l[25310]<<8|(l[25311]<<16|l[25312]<<24),f=l[25305]|l[25306]<<8|(l[25307]<<16|l[25308]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,o+12|0),u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}if(u[f+5|0]=1,u[f+7|0]=e,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}A=i[o+68>>2],A&&(i[o+72>>2]=A,Z(A)),v=o+80|0}function c7(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;w=v+-64|0,v=w,i[w+60>>2]=e,O=w+39|0,y=w+40|0;i:{e:{r:{f:{A:for(;;){o=0;k:for(;;){if(h=e,(W^2147483647)<(o|0))break f;W=o+W|0;n:{t:{u:{o:{if(o=e,s=l[o|0],s)for(;;){l:{e=s&255;s:{if(!e){e=o;break s}if((e|0)!=37)break l;for(s=o;;){if(l[s+1|0]!=37){e=s;break s}if(o=o+1|0,m=l[s+2|0],e=s+2|0,s=e,(m|0)!=37)break}}if(o=o-h|0,S=W^2147483647,(o|0)>(S|0))break f;if(A&&t4(A,h,o),o)continue k;i[w+60>>2]=e,o=e+1|0,I=-1,s=u[e+1|0]-48|0,l[e+2|0]!=36|s>>>0>9||(R=1,I=s,o=e+3|0),i[w+60>>2]=o,B=0,s=u[o|0],e=s-32|0;s:{if(e>>>0>31){m=o;break s}if(m=o,e=1<<e,!(e&75913))break s;for(;;){if(m=o+1|0,i[w+60>>2]=m,B=e|B,s=u[o+1|0],e=s-32|0,e>>>0>=32)break s;if(o=m,e=1<<e,!(e&75913))break}}s:{if((s|0)==42){e=u[m+1|0]-48|0;w:{if(!(l[m+2|0]!=36|e>>>0>9)){_:{if(!A){i[(e<<2)+k>>2]=10,g=0;break _}g=i[(e<<3)+f>>2]}e=m+3|0,R=1;break w}if(R)break o;if(e=m+1|0,!A){i[w+60>>2]=e,R=0,g=0;break s}o=i[r>>2],i[r>>2]=o+4,g=i[o>>2],R=0}if(i[w+60>>2]=e,(g|0)>=0)break s;g=0-g|0,B=B|8192;break s}if(g=Go(w+60|0),(g|0)<0)break f;e=i[w+60>>2]}o=0,_=-1,s=0;s:{if(l[e|0]!=46)break s;if(l[e+1|0]==42){s=u[e+2|0]-48|0;w:{if(!(l[e+3|0]!=36|s>>>0>9)){e=e+4|0;_:{if(!A){i[(s<<2)+k>>2]=10,_=0;break _}_=i[(s<<3)+f>>2]}break w}if(R)break o;if(e=e+2|0,_=0,!A)break w;s=i[r>>2],i[r>>2]=s+4,_=i[s>>2]}i[w+60>>2]=e,s=(_|0)>=0;break s}i[w+60>>2]=e+1,_=Go(w+60|0),e=i[w+60>>2],s=1}for(D=s;;){if(N=o,m=28,C=e,s=u[e|0],s-123>>>0<4294967238)break r;if(e=e+1|0,o=l[(s+G(o,58)|0)+69791|0],!((o-1&255)>>>0<8))break}i[w+60>>2]=e;s:{if((o|0)!=27){if(!o)break r;if((I|0)>=0){if(!A){i[(I<<2)+k>>2]=o;continue A}o=(I<<3)+f|0,s=i[o+4>>2],i[w+48>>2]=i[o>>2],i[w+52>>2]=s;break s}if(!A)break n;it(w+48|0,o,r,t);break s}if((I|0)>=0)break r;if(o=0,!A)continue k}if(l[A|0]&32)break e;s=B&-65537,B=B&8192?s:B,I=0,x=2960,m=y;s:{w:{_:{h:{B:{v:{Z:{G:{m:{W:{X:{C:{I:{F:{Q:{V:{p:switch(C=l[C|0],o=C<<24>>24,o=N&&(C&15)==3?o&-45:o,o-88|0){case 0:case 32:break I;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 25:case 26:case 28:case 30:case 31:break t;case 9:case 13:case 14:case 15:break s;case 11:break G;case 12:case 17:break X;case 22:break Q;case 23:break C;case 24:break F;case 27:break Z;case 29:break V;default:break p}p:switch(o-65|0){case 1:case 3:break t;case 0:case 4:case 5:case 6:break s;case 2:break v;default:break p}if((o|0)==83)break B;break t}s=i[w+48>>2],C=i[w+52>>2],e=2960;break W}o=0;Q:switch(N|0){case 0:i[i[w+48>>2]>>2]=W;continue k;case 1:i[i[w+48>>2]>>2]=W;continue k;case 2:h=i[w+48>>2],i[h>>2]=W,i[h+4>>2]=W>>31;continue k;case 3:Q[i[w+48>>2]>>1]=W;continue k;case 4:u[i[w+48>>2]]=W;continue k;case 6:i[i[w+48>>2]>>2]=W;continue k;case 7:break Q;default:continue k}h=i[w+48>>2],i[h>>2]=W,i[h+4>>2]=W>>31;continue k}_=_>>>0<=8?8:_,B=B|8,o=120}if(e=y,L=o&32,h=i[w+52>>2],C=h,s=i[w+48>>2],V=s,s|h)for(;e=e-1|0,u[e|0]=L|l[(V&15)+70320|0],N=!h&V>>>0>15|(h|0)!=0,V=(h&15)<<28|V>>>4,h=h>>>4|0,!!N;);if(h=e,!(s|C)|!(B&8))break m;x=(o>>>4|0)+2960|0,I=2;break m}if(e=y,h=i[w+52>>2],C=h,s=i[w+48>>2],V=s,s|h)for(;e=e-1|0,u[e|0]=V&7|48,N=!h&V>>>0>7|(h|0)!=0,V=(h&7)<<29|V>>>3,h=h>>>3|0,!!N;);if(h=e,!(B&8))break m;e=y-e|0,_=(e|0)<(_|0)?_:e+1|0;break m}if(s=i[w+48>>2],e=i[w+52>>2],C=e,(e|0)<0){o=0-(e+((s|0)!=0)|0)|0,C=o,s=0-s|0,i[w+48>>2]=s,i[w+52>>2]=o,I=1,e=2960;break W}if(B&2048){I=1,e=2961;break W}I=B&1,e=I?2962:2960}x=e,h=vi(s,C,y)}if((_|0)<0&D)break f;if(B=D?B&-65537:B,!(_|(s|C)!=0)){h=y,_=0;break t}e=!(s|C)+(y-h|0)|0,_=(e|0)<(_|0)?_:e;break t}o=l[w+48|0];break u}if(e=i[w+48>>2],h=e||26545,e=_>>>0>=2147483647?2147483647:_,o=hA(h,0,e),e=o?o-h|0:e,m=e+h|0,(_|0)>=0){B=s,_=e;break t}if(B=s,_=e,l[m|0])break f;break t}if(o=i[w+48>>2],o|i[w+52>>2])break h;o=0;break u}if(_){s=i[w+48>>2];break _}o=0,w4(A,32,g,0,B);break w}i[w+12>>2]=0,i[w+8>>2]=o,s=w+8|0,i[w+48>>2]=s,_=-1}for(o=0;;){_:{if(h=i[s>>2],!h)break _;if(h=E3(w+4|0,h),(h|0)<0)break e;if(h>>>0>_-o>>>0)break _;if(s=s+4|0,o=o+h|0,_>>>0>o>>>0)continue}break}if(m=61,(o|0)<0)break r;if(w4(A,32,g,o,B),!o){o=0;break w}for(m=0,s=i[w+48>>2];;){if(h=i[s>>2],!h||(_=w+4|0,h=E3(_,h),m=h+m|0,m>>>0>o>>>0))break w;if(t4(A,_,h),s=s+4|0,!(o>>>0>m>>>0))break}}w4(A,32,g,o,B^8192),o=(o|0)<(g|0)?g:o;continue k}if((_|0)<0&D)break f;if(m=61,o=X[n|0](A,t0[w+48>>3],g,_,B,o)|0,(o|0)>=0)continue k;break r}s=l[o+1|0],o=o+1|0}if(A)break i;if(!R)break n;for(o=1;;){if(A=i[(o<<2)+k>>2],A){if(it((o<<3)+f|0,A,r,t),W=1,o=o+1|0,(o|0)!=10)continue;break i}break}if(o>>>0>=10){W=1;break i}for(;;){if(i[(o<<2)+k>>2])break o;if(W=1,o=o+1|0,(o|0)==10)break}break i}m=28;break r}u[w+39|0]=o,_=1,h=O,B=s}if(s=m-h|0,_=(s|0)<(_|0)?_:s,(_|0)>(I^2147483647))break f;if(m=61,e=_+I|0,o=(e|0)<(g|0)?g:e,(S|0)<(o|0))break r;w4(A,32,o,e,B),t4(A,x,I),w4(A,48,o,e,B^65536),w4(A,48,_,s,0),t4(A,h,s),w4(A,32,o,e,B^8192),e=i[w+60>>2];continue}break}break}W=0;break i}m=61}i[31336]=m}W=-1}return v=w- -64|0,W}function b7(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;h=v+-64|0,v=h,o=E(32),i[h+8>>2]=o,i[h+12>>2]=27,i[h+16>>2]=-2147483616,s=l[12099]|l[12100]<<8|(l[12101]<<16|l[12102]<<24),u[o+23|0]=s,u[o+24|0]=s>>>8,u[o+25|0]=s>>>16,u[o+26|0]=s>>>24,s=l[12096]|l[12097]<<8|(l[12098]<<16|l[12099]<<24),w=l[12092]|l[12093]<<8|(l[12094]<<16|l[12095]<<24),u[o+16|0]=w,u[o+17|0]=w>>>8,u[o+18|0]=w>>>16,u[o+19|0]=w>>>24,u[o+20|0]=s,u[o+21|0]=s>>>8,u[o+22|0]=s>>>16,u[o+23|0]=s>>>24,s=l[12088]|l[12089]<<8|(l[12090]<<16|l[12091]<<24),w=l[12084]|l[12085]<<8|(l[12086]<<16|l[12087]<<24),u[o+8|0]=w,u[o+9|0]=w>>>8,u[o+10|0]=w>>>16,u[o+11|0]=w>>>24,u[o+12|0]=s,u[o+13|0]=s>>>8,u[o+14|0]=s>>>16,u[o+15|0]=s>>>24,s=l[12080]|l[12081]<<8|(l[12082]<<16|l[12083]<<24),w=l[12076]|l[12077]<<8|(l[12078]<<16|l[12079]<<24),u[o|0]=w,u[o+1|0]=w>>>8,u[o+2|0]=w>>>16,u[o+3|0]=w>>>24,u[o+4|0]=s,u[o+5|0]=s>>>8,u[o+6|0]=s>>>16,u[o+7|0]=s>>>24,u[o+27|0]=0,x=K(h+44|0,2,0,h+8|0),u[h+19|0]<0&&Z(i[h+8>>2]),i[h+40>>2]=0,i[h+32>>2]=0,i[h+36>>2]=0,o=i[r>>2],s=l[e+24|0],r=s+l[e+25|0]|0,s=r>>>0<s>>>0,w=O0(r,s,k,0),g=l0,I=r,r=n-k|0,s=O0(I,s,r,t-(k>>>0>n>>>0)|0),Qr(h+8|0,o,f,h+32|0,(g&7)<<29|w>>>3,0,(l0&7)<<29|s>>>3,0);i:{e:{if(!i[h+8>>2]){if(!t&k>>>0>=n>>>0)break e;if(f=l[e+24|0],W=f>>>3|0,g=i[e+64>>2],e=l[e+25|0],!e){if(f>>>0>=8){for(_=W&28,m=W&3,e=0,C=W-1>>>0<3;;){if(o=0,f=0,s=i[h+32>>2],r=e,!C)for(I=s+3|0,V=s+2|0,y=s+1|0,w=0;f=(f<<16|o>>>16)<<16,o=l[r+y|0]|(o<<16|l[r+s|0]<<8),f=f|o>>>16,o=l[r+I|0]|(o<<16|l[r+V|0]<<8),r=r+4|0,w=w+4|0,(_|0)!=(w|0););if(w=0,m)for(;f=f<<8|o>>>24,o=l[r+s|0]|o<<8,r=r+1|0,w=w+1|0,(m|0)!=(w|0););if(r=(k<<4)+g|0,i[r>>2]=o,i[r+4>>2]=f,e=e+W|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}if(o=k,f=0,e=0,B=r&7,B)for(r=0;s=(o<<4)+g|0,i[s>>2]=0,i[s+4>>2]=0,o=o+1|0,f=o?f:f+1|0,e=e+1|0,r=e?r:r+1|0,!!(r|(e|0)!=(B|0)););if((0-((k>>>0<n>>>0)+t|0)|0)==-1&k-n>>>0>4294967288)break e;for(r=g+112|0,k=g+96|0,B=g+80|0,s=g- -64|0,w=g+48|0,W=g+32|0,m=g+16|0;e=o<<4,_=e+g|0,i[_>>2]=0,i[_+4>>2]=0,_=e+m|0,i[_>>2]=0,i[_+4>>2]=0,_=e+W|0,i[_>>2]=0,i[_+4>>2]=0,_=e+w|0,i[_>>2]=0,i[_+4>>2]=0,_=e+s|0,i[_>>2]=0,i[_+4>>2]=0,_=e+B|0,i[_>>2]=0,i[_+4>>2]=0,_=e+k|0,i[_>>2]=0,i[_+4>>2]=0,e=e+r|0,i[e>>2]=0,i[e+4>>2]=0,o=o+8|0,f=o>>>0<8?f+1|0:f,!!((n|0)!=(o|0)|(f|0)!=(t|0)););break e}if(m=e>>>3|0,f>>>0<=7){if(e>>>0>=8){for(_=m&28,s=m&3,f=0,C=m-1>>>0<3;;){if(I=(k<<4)+g|0,e=I,i[e>>2]=0,i[e+4>>2]=0,W=i[h+32>>2],r=f,e=0,w=0,!C){for(;o=r,r=o+4|0,e=e+4|0,(_|0)!=(e|0););e=o+W|0,e=l[e|0]|l[e+1|0]<<8|(l[e+2|0]<<16|l[e+3|0]<<24),w=e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24)}if(e=0,s)for(;w=l[r+W|0]|w<<8,r=r+1|0,e=e+1|0,(s|0)!=(e|0););if(i[I+8>>2]=w,f=f+m|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}if(o=k,f=0,e=0,s=r&3,s)for(r=0;B=(o<<4)+g|0,i[B+8>>2]=0,i[B>>2]=0,i[B+4>>2]=0,o=o+1|0,f=o?f:f+1|0,e=e+1|0,r=e?r:r+1|0,!!(r|(e|0)!=(s|0)););if((0-((k>>>0<n>>>0)+t|0)|0)==-1&k-n>>>0>4294967292)break e;for(;e=(o<<4)+g|0,i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,i[e+56>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,o=o+4|0,f=o>>>0<4?f+1|0:f,!!((n|0)!=(o|0)|(f|0)!=(t|0)););break e}if(e>>>0<=7){for(_=W&28,m=W&3,C=W-1>>>0<3,e=0;;){if(o=0,f=0,s=i[h+32>>2],r=e,!C)for(I=s+3|0,V=s+2|0,y=s+1|0,w=0;R=l[r+y|0]|(l[r+s|0]<<8|o<<16),D=R<<16,f=(f<<16|o>>>16)<<16|R>>>16,o=l[r+I|0]|(l[r+V|0]<<8|D),r=r+4|0,w=w+4|0,(_|0)!=(w|0););if(w=0,m)for(;f=f<<8|o>>>24,o=l[r+s|0]|o<<8,r=r+1|0,w=w+1|0,(m|0)!=(w|0););if(r=(k<<4)+g|0,i[r+8>>2]=0,i[r>>2]=o,i[r+4>>2]=f,e=e+W|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}for(I=m&28,_=m&3,V=W&28,C=W&3,y=m+W|0,s=0,R=W-1>>>0<3,D=m-1>>>0<3;;){if(o=0,f=0,e=i[h+32>>2],r=s,!R)for(m=e+3|0,N=e+2|0,O=e+1|0,w=0;S=l[r+O|0]|(o<<16|l[e+r|0]<<8),f=(f<<16|o>>>16)<<16|S>>>16,o=l[r+m|0]|(l[r+N|0]<<8|S<<16),r=r+4|0,w=w+4|0,(V|0)!=(w|0););if(w=0,C)for(;f=f<<8|o>>>24,o=l[e+r|0]|o<<8,r=r+1|0,w=w+1|0,(C|0)!=(w|0););if(N=(k<<4)+g|0,e=N,i[e>>2]=o,i[e+4>>2]=f,r=s+W|0,e=0,m=i[h+32>>2],f=0,w=0,!D){for(;o=r,r=o+4|0,f=f+4|0,(I|0)!=(f|0););f=o+m|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),w=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24)}if(_)for(;w=l[r+m|0]|w<<8,r=r+1|0,e=e+1|0,(_|0)!=(e|0););if(i[N+8>>2]=w,s=s+y|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[h+24>>2],e=i[h+20>>2],i[A+8>>2]=i[h+16>>2],i[A+12>>2]=e,i[h+24>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0;break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[h+27|0]<0&&Z(i[h+16>>2]),A=i[h+32>>2],A&&(i[h+36>>2]=A,Z(A)),u[x+19|0]<0&&Z(i[x+8>>2]),v=h- -64|0}function Li(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0;C=v-128|0,v=C;i:{e:{r:{if(x=i[A+140>>2],n0=x+G(e,24)|0,W=i[A+152>>2],D=G(W,r),g=(n0+G(D,24)|0)+4|0,B=f<<1,h0=l[g|0]>>>B&3,!h0)break r;if(R=G(e,k),N=i[A+148>>2],h=R>>N,(h|0)<0|(h|0)>=(W|0))break e;if(L=G(r,n),r=L>>N,(r|0)<0|(r|0)>=i[A+156>>2])break i;if(I=i[A+124>>2],f0=i[I+(f?16840:16832)>>2],e=-1<<f0^-1,V=i[(f?36:28)+A>>2],a=(V|0)<(n+L|0)?V-L|0:n,y=i[(f?32:24)+A>>2],$=(y|0)<(k+R|0)?y-R|0:k,S=f?i[I+16856>>2]-1|0:0,n=f?i[I+16852>>2]-1|0:0,N0=l[(n0+G(D,24)|0)+22|0],(h0|0)==2){if(n0=i[A+132>>2],r=F[((x+G(h,24)|0)+G(G(r,W),24)|0)+2>>1]<<2,h=i[A+52>>2],D=i[i[r+h>>2]+808>>2],f0=i[A+56>>2],k=i[I+16876>>2],h0=i[I+16892>>2],m0=l[g+1|0],r=g+(f<<2)|0,u[C|0]=l[r+5|0],f=l[r+6|0],u[C+2|0]=0,u[C+1|0]=f,u[C+3|0]=l[r+7|0],u[C+4|0]=l[r+8|0],(a|0)<=0|($|0)<=0)break r;for(f0=f0-h>>2,r=(m0>>>B&3)<<2,m0=i[r+62920>>2],U0=i[r+62904>>2],W0=k-n|0,D0=R>>W0,P0=a-1|0,d0=$-1|0,Q0=k-S|0,H0=G(h0,L>>Q0),f=R<<1,n2=f+s|0,Z2=f+t|0,f=0,L0=i[r+62936>>2],g2=G(L0,o)<<1,q0=i[r+62952>>2],Q2=G(q0,o)<<1;;){for(r=f+L|0,E2=(G(r,w)<<1)+n2|0,H2=(G(r,o)<<1)+Z2|0,V0=r<<S,t=V0>>N,T2=(x+G(G(t,W),24)|0)+2|0,s=r+L0|0,e0=s<<S>>N,b2=(x+G(G(W,e0),24)|0)+2|0,g=r+q0|0,r0=g<<S>>N,e1=(x+G(G(W,r0),24)|0)+2|0,W1=G(h0,g>>>Q0|0)<<2,J1=G(h0,s>>>Q0|0)<<2,x1=(f|0)==(P0|0),k=0;;){f:{A:{if(!(N0&1)){r=i[A+168>>2];break A}if(r=i[A+168>>2],!l[I+8812|0])break A;if(B=k+R<<n>>r,(B|0)<0||(m=i[A+172>>2],(m|0)<=(B|0)))break e;if(_=V0>>r,(_|0)<0|(_|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(B,3)|0)+G(G(_,m),3)|0)+1|0]&4)break f}if(_=k+R|0,O=_<<n,B=O>>r,(B|0)<0||(m=i[A+172>>2],(m|0)<=(B|0)))break e;if(r=V0>>r,(r|0)<0|(r|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(B,3)|0)+G(G(r,m),3)|0)+1|0]&8)break f;A:{if(!(!f|!k|(k|0)==(d0|0))&&!x1)break A;if(r=_+m0|0,(r|0)>=(y|0)|(r|0)<0|((g|0)<0|(g|0)>=(V|0)))break f;if(m=r<<n>>N,(m|0)<0|(W|0)<=(m|0))break e;if((r0|0)<0||(B=i[A+156>>2],(B|0)<=(r0|0)))break i;if(m=F[G(m,24)+e1>>1],m>>>0>=f0>>>0||(m=i[h+(m<<2)>>2],!m))break r;O=O>>N,$0=(O|0)>=0&W>>>0>O>>>0,O=G(O,24)+T2|0;k:{if(A0=i[m+808>>2],(A0|0)<(D|0)){if(!$0)break e;if((t|0)<0|(t|0)>=(B|0))break k;if(!l[i[h+(F[O>>1]<<2)>>2]+772|0])break f}if(!l[m+772|0]&(D|0)<(A0|0)||(m=l[n0+57|0],!m&&(A0=r>>>W0<<2,r=i[n0+8484>>2],i[(A0+r|0)+W1>>2]!=i[(r+(D0<<2)|0)+(H0<<2)>>2]))||(r=_+U0|0,(r|0)>=(y|0)|(r|0)<0|((s|0)<0|(s|0)>=(V|0))))break f;if(_=r<<n>>N,(_|0)<0|(W|0)<=(_|0))break e;if((e0|0)<0|(B|0)<=(e0|0))break i;if(_=F[G(_,24)+b2>>1],_>>>0>=f0>>>0||(_=i[h+(_<<2)>>2],!_))break r;if(A0=i[_+808>>2],(A0|0)<(D|0)){if(!$0)break e;if((t|0)<0|(t|0)>=(B|0))break k;if(!l[i[h+(F[O>>1]<<2)>>2]+772|0])break f}if(!l[_+772|0]&(D|0)<(A0|0))break f;if(m||(_=r>>>W0<<2,r=i[n0+8484>>2],i[(_+r|0)+J1>>2]==i[(r+(D0<<2)|0)+(H0<<2)>>2]))break A;break f}break i}_=k<<1,B=_+H2|0,r=F[B>>1],m=_+E2|0,_=F[(B+(m0<<1)|0)+Q2>>1],B=F[(B+(U0<<1)|0)+g2>>1],r=r+u[(((_>>>0<r>>>0)-(r>>>0<_>>>0)+((B>>>0<r>>>0)-(r>>>0<B>>>0))|0)+C|0)+2|0]|0,Q[m>>1]=(r|0)>=0?(e|0)>(r|0)?r:e:0}if(k=k+1|0,($|0)==(k|0))break}if(f=f+1|0,(a|0)==(f|0))break}break r}if(r=l[(f+g|0)+2|0],o0(C,0,128),i[((r&31)<<2)+C>>2]=1,i[((r+1&31)<<2)+C>>2]=2,i[((r+2&31)<<2)+C>>2]=3,i[((r+3&31)<<2)+C>>2]=4,N=f0-5|0,!(N0&1)){if((a|0)<=0|($|0)<=0)break r;for(n=g+5|0,r=0;;){for(A=r+L|0,W=(G(A,w)<<1)+s|0,I=(G(A,o)<<1)+t|0,A=0;S=A+R<<1,k=F[S+I>>1],g=i[((e>>>0>k>>>0?k:e)>>>N<<2)+C>>2],(g|0)>0&&(k=k+u[(g+(n+(f<<2)|0)|0)-1|0]|0,Q[W+S>>1]=(k|0)>=0?(e|0)>(k|0)?k:e:0),A=A+1|0,($|0)>(A|0););if(r=r+1|0,!((a|0)>(r|0)))break}break r}if((a|0)<=0|($|0)<=0)break r;g=g+5|0,r=i[A+168>>2],W=0;f:{A:{k:{if(!l[I+8812|0])for(;;){if(k=W+L|0,I=k<<S>>r,(I|0)<0)break k;for(x=(G(k,w)<<1)+s|0,D=(G(k,o)<<1)+t|0,k=0;;){if(V=k+R|0,h=V<<n>>r,(h|0)<0||(y=i[A+172>>2],(y|0)<=(h|0)))break e;if((I|0)>=i[A+176>>2])break i;n:{if(l[((i[A+160>>2]+G(h,3)|0)+G(G(I,y),3)|0)+1|0]&8||(V=V<<1,h=F[V+D>>1],y=i[((e>>>0>h>>>0?h:e)>>>N<<2)+C>>2],(y|0)<=0))break n;h=h+u[(y+(g+(f<<2)|0)|0)-1|0]|0,Q[V+x>>1]=(h|0)>=0?(e|0)>(h|0)?h:e:0}if(k=k+1|0,!(($|0)>(k|0)))break}if(W=W+1|0,!((a|0)>(W|0)))break r}for(;;){if(k=W+L|0,I=k<<S>>r,(I|0)<0)break A;for(x=(G(k,w)<<1)+s|0,D=(G(k,o)<<1)+t|0,k=0;;){if(V=k+R|0,h=V<<n>>r,(h|0)<0||(y=i[A+172>>2],(y|0)<=(h|0)))break f;if((I|0)>=i[A+176>>2])break i;h=(i[A+160>>2]+G(h,3)|0)+G(G(I,y),3)|0;n:{if(l[h+1|0]&4|l[h+1|0]&8||(V=V<<1,h=F[V+D>>1],y=i[((e>>>0>h>>>0?h:e)>>>N<<2)+C>>2],(y|0)<=0))break n;h=h+u[(y+(g+(f<<2)|0)|0)-1|0]|0,Q[V+x>>1]=(h|0)>=0?(e|0)>(h|0)?h:e:0}if(k=k+1|0,!(($|0)>(k|0)))break}if(W=W+1|0,!((a|0)>(W|0)))break}break r}if(e=R<<n>>r,(e|0)<0)break e;if((e|0)<i[A+172>>2])break i;break e}if(e=R<<n>>r,(e|0)<0|(e|0)>=i[A+172>>2])break f;break i}break e}v=C+128|0;return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function xB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;f=v-16|0,v=f,B=o2(r);i:{e:{if(h=W2(r),!h)break e;for(;;){if(n=W2(r),n<<24>>24<0){if(e=E(40),i[f+4>>2]=e,i[f+8>>2]=38,i[f+12>>2]=-2147483608,r=l[16195]|l[16196]<<8|(l[16197]<<16|l[16198]<<24),k=l[16191]|l[16192]<<8|(l[16193]<<16|l[16194]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+38|0]=0,r=l[16225]|l[16226]<<8|(l[16227]<<16|l[16228]<<24),k=l[16221]|l[16222]<<8|(l[16223]<<16|l[16224]<<24),u[e+30|0]=k,u[e+31|0]=k>>>8,u[e+32|0]=k>>>16,u[e+33|0]=k>>>24,u[e+34|0]=r,u[e+35|0]=r>>>8,u[e+36|0]=r>>>16,u[e+37|0]=r>>>24,r=l[16219]|l[16220]<<8|(l[16221]<<16|l[16222]<<24),k=l[16215]|l[16216]<<8|(l[16217]<<16|l[16218]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16211]|l[16212]<<8|(l[16213]<<16|l[16214]<<24),k=l[16207]|l[16208]<<8|(l[16209]<<16|l[16210]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16203]|l[16204]<<8|(l[16205]<<16|l[16206]<<24),k=l[16199]|l[16200]<<8|(l[16201]<<16|l[16202]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,4,3002,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n>>>0>=17){if(e=E(56),i[f+4>>2]=e,i[f+8>>2]=51,i[f+12>>2]=-2147483592,r=l[16143]|l[16144]<<8|(l[16145]<<16|l[16146]<<24),k=l[16139]|l[16140]<<8|(l[16141]<<16|l[16142]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[16186]|l[16187]<<8|(l[16188]<<16|l[16189]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[16183]|l[16184]<<8|(l[16185]<<16|l[16186]<<24),k=l[16179]|l[16180]<<8|(l[16181]<<16|l[16182]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16175]|l[16176]<<8|(l[16177]<<16|l[16178]<<24),k=l[16171]|l[16172]<<8|(l[16173]<<16|l[16174]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16167]|l[16168]<<8|(l[16169]<<16|l[16170]<<24),k=l[16163]|l[16164]<<8|(l[16165]<<16|l[16166]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16159]|l[16160]<<8|(l[16161]<<16|l[16162]<<24),k=l[16155]|l[16156]<<8|(l[16157]<<16|l[16158]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16151]|l[16152]<<8|(l[16153]<<16|l[16154]<<24),k=l[16147]|l[16148]<<8|(l[16149]<<16|l[16150]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,4,3002,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}r:{k=i[e+104>>2],o=i[e+108>>2];f:{if(k>>>0<o>>>0){u[k|0]=n,n=k+1|0;break f}if(s=i[e+100>>2],k=k-s|0,t=k+1|0,(t|0)<0)break r;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:t>>>0<w>>>0?w:t,o?t=E(o):t=0,w=t+k|0,u[w|0]=n,k&&z(t,s,k),i[e+108>>2]=t+o,n=w+1|0,i[e+104>>2]=n,i[e+100>>2]=t,!s)break f;Z(s)}if(i[e+104>>2]=n,_=_+1|0,h>>>0>(_&255)>>>0)continue;break e}break}G0(),H()}e:{if(!B)break e;for(;;){r:{i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=i[e+116>>2];f:{if(k>>>0<u0[e+120>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break r;t=E(n),i[k+4>>2]=t,i[k>>2]=t,o=n+t|0,i[k+8>>2]=o,n&&z(t,s,n),i[k+4>>2]=o}k=k+12|0;break f}A:{k:{n:{if(h=i[e+116>>2],k=i[e+112>>2],t=h-k|0,n=((t|0)/12|0)+1|0,n>>>0<357913942){if(s=(i[e+120>>2]-k|0)/12|0,o=s<<1,n=s>>>0>=178956970?357913941:n>>>0<o>>>0?o:n,n>>>0>=357913942)break n;if(_=G(n,12),m=E(_),o=t+m|0,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break k;w=E(n),i[o>>2]=w,W=n+w|0,i[o+8>>2]=W,n&&z(w,s,n),i[o+4>>2]=W}if(s=o+G((t|0)/-12|0,12)|0,(k|0)!=(h|0)){for(t=k,n=s;i[n>>2]=i[t>>2],i[n+4>>2]=i[t+4>>2],i[n+8>>2]=i[t+8>>2],i[t+8>>2]=0,i[t>>2]=0,i[t+4>>2]=0,n=n+12|0,t=t+12|0,(h|0)!=(t|0););for(;n=i[k>>2],n&&(i[k+4>>2]=n,Z(n)),k=k+12|0,(h|0)!=(k|0););k=i[e+112>>2]}i[e+120>>2]=_+m,n=o+12|0,i[e+116>>2]=n,i[e+112>>2]=s,k&&Z(k),k=n;break A}G0(),H()}x0(),H()}G0(),H()}}if(i[e+116>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),g=g+1|0,(g&65535)>>>0<B>>>0)continue;break e}break}G0(),H()}if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function zB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;t=v-48|0,v=t,hf(t+24|0,e,r);i:{if(i[t+24>>2]){e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+40>>2],e=i[t+36>>2],i[A+8>>2]=i[t+32>>2],i[A+12>>2]=e,i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0;break i}r=i[e+196>>2];e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=TA(i[e+188>>2],1),!f){if(e=E(32),i[t+12>>2]=e,i[t+16>>2]=27,i[t+20>>2]=-2147483616,r=l[21900]|l[21901]<<8|(l[21902]<<16|l[21903]<<24),k=l[21896]|l[21897]<<8|(l[21898]<<16|l[21899]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[21919]|l[21920]<<8|(l[21921]<<16|l[21922]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[21916]|l[21917]<<8|(l[21918]<<16|l[21919]<<24),k=l[21912]|l[21913]<<8|(l[21914]<<16|l[21915]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[21908]|l[21909]<<8|(l[21910]<<16|l[21911]<<24),k=l[21904]|l[21905]<<8|(l[21906]<<16|l[21907]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,t+12|0),u[t+23|0]>=0)break i;Z(i[t+12>>2]);break i}r=0,n=i[e+180>>2],k=i[n+104>>2];r:{if(f=i[f+8>>2]-1|0,f>>>0<i[n+108>>2]-k>>3>>>0&&(r=k+(f<<3)|0,k=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k))break r;if(e=E(40),i[t+12>>2]=e,i[t+16>>2]=35,i[t+20>>2]=-2147483608,k=l[8006]|l[8007]<<8|(l[8008]<<16|l[8009]<<24),f=l[8002]|l[8003]<<8|(l[8004]<<16|l[8005]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,k=l[8033]|l[8034]<<8|(l[8035]<<16|l[8036]<<24),u[e+31|0]=k,u[e+32|0]=k>>>8,u[e+33|0]=k>>>16,u[e+34|0]=k>>>24,k=l[8030]|l[8031]<<8|(l[8032]<<16|l[8033]<<24),f=l[8026]|l[8027]<<8|(l[8028]<<16|l[8029]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[8022]|l[8023]<<8|(l[8024]<<16|l[8025]<<24),f=l[8018]|l[8019]<<8|(l[8020]<<16|l[8021]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[8014]|l[8015]<<8|(l[8016]<<16|l[8017]<<24),f=l[8010]|l[8011]<<8|(l[8012]<<16|l[8013]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,K(A,2,0,t+12|0),u[t+23|0]<0&&Z(i[t+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r);break i}r:{f:{if(k=X0(k,86628,105608),k){if(r)break f;Q[e+288>>1]=F[k+116>>1],Q[e+290>>1]=F[k+118>>1];break e}if(e=E(64),i[t+12>>2]=e,i[t+16>>2]=60,i[t+20>>2]=-2147483584,f=l[24827]|l[24828]<<8|(l[24829]<<16|l[24830]<<24),n=l[24823]|l[24824]<<8|(l[24825]<<16|l[24826]<<24),u[e|0]=n,u[e+1|0]=n>>>8,u[e+2|0]=n>>>16,u[e+3|0]=n>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+60|0]=0,f=l[24879]|l[24880]<<8|(l[24881]<<16|l[24882]<<24),u[e+56|0]=f,u[e+57|0]=f>>>8,u[e+58|0]=f>>>16,u[e+59|0]=f>>>24,f=l[24875]|l[24876]<<8|(l[24877]<<16|l[24878]<<24),n=l[24871]|l[24872]<<8|(l[24873]<<16|l[24874]<<24),u[e+48|0]=n,u[e+49|0]=n>>>8,u[e+50|0]=n>>>16,u[e+51|0]=n>>>24,u[e+52|0]=f,u[e+53|0]=f>>>8,u[e+54|0]=f>>>16,u[e+55|0]=f>>>24,f=l[24867]|l[24868]<<8|(l[24869]<<16|l[24870]<<24),n=l[24863]|l[24864]<<8|(l[24865]<<16|l[24866]<<24),u[e+40|0]=n,u[e+41|0]=n>>>8,u[e+42|0]=n>>>16,u[e+43|0]=n>>>24,u[e+44|0]=f,u[e+45|0]=f>>>8,u[e+46|0]=f>>>16,u[e+47|0]=f>>>24,f=l[24859]|l[24860]<<8|(l[24861]<<16|l[24862]<<24),n=l[24855]|l[24856]<<8|(l[24857]<<16|l[24858]<<24),u[e+32|0]=n,u[e+33|0]=n>>>8,u[e+34|0]=n>>>16,u[e+35|0]=n>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[24851]|l[24852]<<8|(l[24853]<<16|l[24854]<<24),n=l[24847]|l[24848]<<8|(l[24849]<<16|l[24850]<<24),u[e+24|0]=n,u[e+25|0]=n>>>8,u[e+26|0]=n>>>16,u[e+27|0]=n>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[24843]|l[24844]<<8|(l[24845]<<16|l[24846]<<24),n=l[24839]|l[24840]<<8|(l[24841]<<16|l[24842]<<24),u[e+16|0]=n,u[e+17|0]=n>>>8,u[e+18|0]=n>>>16,u[e+19|0]=n>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[24835]|l[24836]<<8|(l[24837]<<16|l[24838]<<24),n=l[24831]|l[24832]<<8|(l[24833]<<16|l[24834]<<24),u[e+8|0]=n,u[e+9|0]=n>>>8,u[e+10|0]=n>>>16,u[e+11|0]=n>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,t+12|0),u[t+23|0]<0&&Z(i[t+12>>2]),!r)break i;if(e=i[r+4>>2],i[r+4>>2]=e-1,!e)break r;break i}if(i[r+4>>2]=i[r+4>>2]+1,Q[e+288>>1]=F[k+116>>1],Q[e+290>>1]=F[k+118>>1],e=i[r+4>>2],i[r+4>>2]=e-1,e||(X[i[i[r>>2]+8>>2]](r),p(r)),e=i[r+4>>2],i[r+4>>2]=e-1,e)break e}if(X[i[i[r>>2]+8>>2]](r),p(r),!k)break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}u[t+43|0]<0&&Z(i[t+32>>2]),v=t+48|0}function Pi(A,e,r,f,k,n,t,o,s,w,h,_,B,m,W){var g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;i:{e:{if(V=i[A+18588>>2],I=i[V+168>>2],g=e>>I,(g|0)<0)break e;R=A+18548|0,N=r>>I;r:{f:{A:{k:{n:{t:{for(;;){if(I=i[V+172>>2],(I|0)<=(g|0))break e;if((N|0)<0|i[V+176>>2]<=(N|0))break i;if(g=(i[V+160>>2]+G(g,3)|0)+G(G(I,N),3)|0,g=l[g|0]|l[g+1|0]<<8,N=g>>>8&3,(N|0)!=(B|0))break n;u:{o:{l:{s:{w:{C=i[V+124>>2],I=i[C+16940>>2]<(o|0);_:{h:{B:{if(!(I|(s|0)>=(h|0)|(!s&(_|0)!=0|i[C+16936>>2]>=(o|0)))){if(o-3>>>0>=3)break k;if(v2(R,(i[A+18572>>2]-o|0)+25|0))break B;y=1;break _}if(y=1,I|!s&(_|0)==1)break B;if(!(!(i[C+628>>2]|s)&(N|0)==1&(g&56)!=0))break h}if(I=i[V+248>>2],g=e>>I,(g|0)<0||(y=i[V+252>>2],(y|0)<=(g|0)))break A;if(I=r>>I,(I|0)<0|(I|0)>=i[V+256>>2])break f;g=(g+i[V+240>>2]|0)+G(I,y)|0,u[g|0]=l[g|0]|1<<s,y=0}if((o|0)<3)break w}if(i[C+16848>>2])break s;g=-1,V=0;break o}if(g=-1,i[C+16848>>2]!=3)break l}g=-1,I=-1;s:{if(!(m&255)||(I=v2(R,(i[A+18572>>2]+s|0)+16|0),!y&(o|0)!=3|i[C+16848>>2]!=2))break s;I=v2(R,(i[A+18572>>2]+s|0)+16|0)<<1|I}s:{if(!(W&255)||(g=v2(R,(i[A+18572>>2]+s|0)+16|0),!y&(o|0)!=3|i[C+16848>>2]!=2))break s;g=v2(R,(i[A+18572>>2]+s|0)+16|0)<<1|g}if((I|0)>=0)break u}if(V=(o|0)==2,(o|0)!=2)break o;if(!s)break r}I=V&&(s|0)>0?m&255:0}if((g|0)<0&&(g=(o|0)==2&&(s|0)>0?W&255:0),y)break t;if(o=o-1|0,s=s+1|0,f=I&255,k=g&255,Pi(A,e,r,e,r,n,t,o,s,0,h,_,B,f,k),w=1<<o,y=w+e|0,Pi(A,y,r,e,r,n,t,o,s,1,h,_,B,f,k),C=r+w|0,Pi(A,e,C,e,r,n,t,o,s,2,h,_,B,f,k),V=i[A+18588>>2],D=i[V+168>>2],N=C>>D,w=3,W=g,m=I,k=r,f=e,r=C,e=y,g=e>>D,!((g|0)>=0))break}break e}t:{if(N&&(h=1,!(s|I|g)))break t;h=v2(R,i[A+18572>>2]+(s?14:15)|0)}t:{u:{o:{l:{s:{w:{if((I|0)!=-1){if((g|0)==-1)break w;if((h|0)==-1)break s;if(s=i[A+18588>>2],m=i[s+124>>2],W=i[m+16848>>2],u[A+33|0]=0,u[A+34|0]=0,u[A+35|0]=0,u[A+36|0]=0,B=i[s+168>>2],_=e>>B,(_|0)<0||(C=i[s+172>>2],(C|0)<=(_|0)))break e;if(B=r>>B,(B|0)<0|(B|0)>=i[s+176>>2])break i;if(y=o-((W|0)!=3)|0,V=(y|0)>2,R=l[((i[s+160>>2]+G(_,3)|0)+G(G(B,C),3)|0)+1|0],C=g|I,!(C|h))break t;if(_=0,i[A+18500>>2]|!l[i[s+132>>2]+26|0])break u;if(_=1,B=A+18548|0,!v2(B,i[A+18572>>2]+139|0)){s=0,B=1;break o}if(s=1,!v2(B,i[A+18572>>2]+140|0))break l;if(!v2(B,i[A+18572>>2]+140|0)){s=2;break l}if(!v2(B,i[A+18572>>2]+140|0)){s=3;break l}if(!v2(B,i[A+18572>>2]+140|0)){s=4;break l}if(s=rA(B,0)+5|0,s)break l;s=0,B=1;break o}M0(21868,18308,3575,3844),H()}M0(21855,18308,3576,3844),H()}M0(21881,18308,3577,3844),H()}B=1-(k4(B)<<1)|0}i[A+18500>>2]=1,i[A+18504>>2]=G(s,B)}u:{o:{l:{if(!(!C|!l[i[A+18592>>2]+760|0]|(l[A+32|0]|i[A+18508>>2]))){if(_=A+18548|0,!v2(_,i[A+18572>>2]+23|0))break l;s=0,B=i[i[A+18588>>2]+132>>2],l[B+8250|0]>=2&&(s=v2(_,i[A+18572>>2]+24|0)),i[A+18508>>2]=1,s=s+B|0,i[A+18512>>2]=u[s+8251|0],s=u[s+8257|0];break o}if(_)break u;break t}i[A+18508>>2]=1,i[A+18512>>2]=0,s=0}i[A+18516>>2]=s}y9(A,n,t)}n=i[m+16856>>2],s=i[m+16852>>2],i[A+28>>2]=0,h&&D8(A,e,r,o,0),C=V?y:2,_=1<<C,B=1<<o,t=R&3,U8(A,e,r,B,0,t,(h|0)!=0);t:{if(!((W|0)!=3&(o|0)<=2)){f=0,k=0;u:{if(!h||(o=i[A+18588>>2],k=0,!(u[i[o+132>>2]+8247|0]&1)))break u;if((t|0)!=1){if(f=i[o+228>>2],w=e>>f,(w|0)<0||(B=i[o+232>>2],(B|0)<=(w|0)))break e;if(h=r>>f,(h|0)<0|(h|0)>=i[o+236>>2])break i;if(f=0,k=0,u[(w+i[o+220>>2]|0)+G(h,B)|0]>=0)break u}if(o=A+18548|0,k=1,!v2(o,i[A+18572>>2]+162|0))break u;f=0;o:{if(!v2(o,i[A+18572>>2]+163|0)||(f=1,!v2(o,i[A+18572>>2]+164|0)))break o;f=v2(o,i[A+18572>>2]+165|0)?3:2}f=1-(v2(o,i[A+18572>>2]+170|0)<<1)<<f,k=1}i[A+28>>2]=f,f=I&1,f&&D8(A,e,r,C,1),i[m+16848>>2]&&U8(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,1,t,f),(W|0)==2&&(f=I&2,f&&D8(A,e,(n<<C)+r|0,C,1),U8(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,1,t,(f|0)!=0)),f=0;u:{if(!k||(k=A+18548|0,!v2(k,i[A+18572>>2]+166|0)))break u;f=0;o:{if(!v2(k,i[A+18572>>2]+167|0)||(f=1,!v2(k,i[A+18572>>2]+168|0)))break o;f=v2(k,i[A+18572>>2]+169|0)?3:2}f=1-(v2(k,i[A+18572>>2]+171|0)<<1)<<f}if(i[A+28>>2]=f,f=g&1,f&&D8(A,e,r,C,2),i[m+16848>>2]&&U8(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,2,t,f),(W|0)!=2)break t;f=g&2,f&&D8(A,e,(n<<C)+r|0,C,2),U8(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,2,t,(f|0)!=0);break t}if((w|0)!=3||(e=I&1,e&&D8(A,f,k,o,1),i[m+16848>>2]&&U8(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,1,t,e),e=I&2,e&&D8(A,f,k+B|0,o,1),(W|0)==2&&U8(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,1,t,(e|0)!=0),e=g&1,e&&D8(A,f,k,o,2),i[m+16848>>2]&&U8(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,2,t,e),e=g&2,e&&D8(A,f,k+_|0,o,2),(W|0)!=2))break t;U8(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,2,t,(e|0)!=0);break t}return}M0(15169,18308,3857,15064),H()}M0(21645,18308,1834,11277),H()}M0(4656,10893,128,4231),H()}M0(4618,10893,129,4231),H()}M0(26843,18308,3924,15064),H()}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function i9(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(i[A>>2]=61328,e=i[A+3212>>2],r=i[A+3208>>2],(e|0)!=(r|0))for(;f=i[e-4>>2],f&&(Z(Sn(f)),r=i[A+3208>>2],e=i[A+3212>>2]),e=e-4|0,i[A+3212>>2]=e,(e|0)!=(r|0););if(r&&(i[A+3212>>2]=r,Z(r)),r=0,e=A+2140|0,f=i[e+12>>2],k=i[e+8>>2],(f|0)!=(k|0))for(;n=i[(r<<2)+k>>2],n&&(Z(oA(n)),k=i[e+8>>2],f=i[e+12>>2]),r=r+1|0,r>>>0<f-k>>2>>>0;);BA(e+32|0),r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),r=i[e+8>>2],r&&(i[e+12>>2]=r,Z(r)),BA(A+1396|0),e=i[A+1388>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+1380>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+1372>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}for(f=A+4|0,e=1368;;){e=e-8|0,r=i[f+e>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if((e|0)==856)break}e=i[A+852>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+844>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+836>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+828>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+820>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+812>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+804>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+796>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+788>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+780>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+772>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+764>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+756>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+748>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+740>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+732>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+724>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+716>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+708>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+700>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+692>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+684>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+676>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+668>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+660>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+652>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+644>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+636>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+628>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+620>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+612>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+604>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=A+548|0,r=i[e+32>>2],r)for(;n=i[e+16>>2],f=i[e+28>>2],k=i[i[n+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2],i[e+32>>2]=r-1,r=f+1|0,i[e+28>>2]=r,r>>>0>=2048&&(Z(i[n>>2]),i[e+16>>2]=i[e+16>>2]+4,i[e+28>>2]=i[e+28>>2]-1024),i[e+36>>2]=i[e+36>>2]-i[k+24>>2],F4(e,k),r=i[e+32>>2],!!r;);if(r=i[e+8>>2],r&&F4(e,r),r=i[e+40>>2],n=i[e+44>>2],(r|0)!=(n|0))for(f=0;k=i[(f<<2)+r>>2],k&&(Z(i[k+20>>2]),r=i[k+32>>2],r&&(i[k+36>>2]=r,Z(r)),Z(k),n=i[e+44>>2],r=i[e+40>>2]),f=f+1|0,f>>>0<n-r>>2>>>0;);return r&&(i[e+44>>2]=r,Z(r)),BA(e+12|0),A|0}function TB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72548,n=i[18140],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18141],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=72548,i[f>>2]=72528,B=R0(k),i[B>>2]=71280,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,M1(n,e,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f,32256,15),n=i[e+100>>2]&1,n=Y(Y(k,n?5217:7951,n|2),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,31969,16),n=i[e+100>>2]&2,n=Y(Y(k,n?5217:7951,n?3:2),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,29624,18),n=i[e+100>>2]&4,n=Y(Y(k,n?5217:7951,n?3:2),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,30490,28),n=i[e+100>>2]&8,Y(Y(k,n?5217:7951,n?3:2),42713,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(f,32820,19),i[e+104>>2],i[e+108>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(n,31842,19),i[e+112>>2],i[e+116>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,32625,10),i[e+120>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(K2(Y(n,30676,10),i[e+128>>2],i[e+132>>2]),42713,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(f,30375,7),F[e+136>>1]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,30456,17),F[e+138>>1]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(Gu(Y(n,31820,8),M(M(F[e+140>>1])*M(.00390625))),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,41800,8),C=e+144|0;i:{for(;;){n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f,32850,2),V=G(m,3),n=0;e:{for(;;){k=f+140|0,o=n+V|0,(o|0)!=8?W=+u0[(o<<2)+C>>2]*152587890625e-16:W=1,h=d1(f,W),g=G1(k,h);r:{if(l[g|0]!=1)break r;o=i[i[h>>2]-12>>2]+h|0,_=i[o+4>>2],w=i[o+24>>2];f:{if(l[o+80|0]==1){k=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break f}t=f+148|0,k=i[o+28>>2],i[t>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[o+76|0]=k,u[o+77|0]=k>>>8,u[o+78|0]=k>>>16,u[o+79|0]=k>>>24,u[o+80|0]=1}f:{if(!w||(s=i[o+12>>2],_=(_&176)==32?32852:32851,t=_-32851|0,(t|0)>0&&(X[i[i[w>>2]+48>>2]](w,32851,t)|0)!=(t|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;t=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){I=t|7,s=E(I+1|0),i[f+156>>2]=I-2147483647,i[f+148>>2]=s,i[f+152>>2]=t;break A}u[f+159|0]=t,s=f+148|0}if(t&&o0(s,k,t),u[t+s|0]=0,k=X[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32852-_|0,(k|0)>0&&(X[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[o+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(g),n=n+1|0,(n|0)==3)break}if(Y(f,42713,1),m=m+1|0,(m|0)==3)break i;continue}break}g0(),H()}n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(d1(Y(f,31059,7),+M(u0[e+180>>2])*152587890625e-16),42713,1),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(n,29744,8),+M(u0[e+184>>2])*152587890625e-16),42713,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}g0(),H()}if(!n)break i;z(A,r,n)}u[A+n|0]=0,A=i[18139],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18142],i[B>>2]=71280,u[f+47|0]<0&&Z(i[f+36>>2]),y0(B),p0(f+56|0),v=f+160|0}function Gf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{r:{if(i[e+24>>2]==i[e+28>>2])break r;f=E(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91292,s=f+16|0,k=s,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[k>>2]=88920,i[f+32>>2]=1885434736,i[f+116>>2]=i[e+24>>2],i[f+120>>2]=i[e+28>>2],i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=s,k=k+8|0;break f}if(n=i[A>>2],k=k-n|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-n|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=E(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=s,s=w-(h<<3)|0,k&&z(s,n,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=s,!n)break f;Z(n)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;X[i[i[f>>2]+8>>2]](f),p(f)}if(F[e+32>>1]|F[e+34>>1]){f=E(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91452,n=f+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[n>>2]=89080,i[f+32>>2]=1668050025,k=i[e+32>>2],Q[f+114>>1]=k,Q[f+116>>1]=k>>>16,k=i[A+4>>2],o=i[A+8>>2];r:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=n,k=k+8|0;break r}if(s=i[A>>2],k=k-s|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-s|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=E(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=n,f=w-(h<<3)|0,k&&z(f,s,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=f,!s)break r;Z(s)}i[A+4>>2]=k}r:{if(l[e+60|0]!=1)break r;f=E(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91492,w=uu(f+16|0),k=i[e+56>>2],i[f+132>>2]=i[e+52>>2],i[f+136>>2]=k,k=i[e+48>>2],i[f+124>>2]=i[e+44>>2],i[f+128>>2]=k,k=i[e+40>>2],i[f+116>>2]=i[e+36>>2],i[f+120>>2]=k,i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],s=i[A+8>>2];f:{if(k>>>0<s>>>0){i[k+4>>2]=f,i[k>>2]=w,k=k+8|0;break f}if(n=i[A>>2],k=k-n|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(s=s-n|0,o=s>>2,s=s>>>0>=2147483640?536870911:o>>>0>t>>>0?o:t,s){if(s>>>0>=536870912)break i;t=E(s<<3)}else t=0;if(o=t+k|0,i[o+4>>2]=f,i[o>>2]=w,w=o-(h<<3)|0,k&&z(w,n,k),i[A+8>>2]=t+(s<<3),k=o+8|0,i[A+4>>2]=k,i[A>>2]=w,!n)break f;Z(n)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;X[i[i[f>>2]+8>>2]](f),p(f)}t=i[e+64>>2];r:{if(!t)break r;f=E(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92252,n=f+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,Q[f+112>>1]=0,i[n>>2]=89492,i[f+32>>2]=1769234793,k=f+120|0,i[k+8>>2]=0,i[k+12>>2]=0,u[k|0]=1,u[k+15|0]=0,u[k+16|0]=0,u[k+17|0]=0,u[k+18|0]=0,gi(k,t),i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=n,k=k+8|0;break f}if(s=i[A>>2],k=k-s|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-s|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=E(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=n,n=w-(h<<3)|0,k&&z(n,s,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=n,!s)break f;Z(s)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;X[i[i[f>>2]+8>>2]](f),p(f)}r:{if(!r)break r;f:{if(!(F[e+6>>1]!=2|F[e+8>>1]!=2|F[e+10>>1]!=2)&&l[e+12|0])break f;Ln(_+8|0,e),s=i[_+12>>2],o=i[_+8>>2],r=i[A+4>>2],f=i[A+8>>2];A:{if(r>>>0<f>>>0){i[r+4>>2]=s,i[r>>2]=o,k=r+8|0;break A}if(t=i[A>>2],r=r-t|0,w=r>>3,k=w+1|0,k>>>0>=536870912)break e;if(f=f-t|0,n=f>>2,f=f>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,f){if(f>>>0>=536870912)break i;k=E(f<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=o,s=n-(w<<3)|0,r&&z(s,t,r),i[A+8>>2]=k+(f<<3),k=n+8|0,i[A+4>>2]=k,i[A>>2]=s,!t)break A;Z(t)}i[A+4>>2]=k}if(!i[e+16>>2])break r;Pn(_+8|0,e),n=i[_+12>>2],s=i[_+8>>2],e=i[A+4>>2],t=i[A+8>>2];f:{if(e>>>0<t>>>0){i[e+4>>2]=n,i[e>>2]=s,e=e+8|0;break f}if(k=i[A>>2],e=e-k|0,o=e>>3,r=o+1|0,r>>>0>=536870912)break e;if(t=t-k|0,f=t>>2,t=t>>>0>=2147483640?536870911:r>>>0<f>>>0?f:r,t){if(t>>>0>=536870912)break i;r=E(t<<3)}else r=0;if(f=r+e|0,i[f+4>>2]=n,i[f>>2]=s,n=f-(o<<3)|0,e&&z(n,k,e),i[A+8>>2]=r+(t<<3),e=f+8|0,i[A+4>>2]=e,i[A>>2]=n,!k)break f;Z(k)}i[A+4>>2]=e}v=_+16|0;return}G0(),H()}x0(),H()}function SB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0;f=v-128|0,v=f,e=i[r>>2],I=i[e+112>>2],t=i[e+108>>2],n=E(172),i[n>>2]=94860,i[n+4>>2]=0,i[n+8>>2]=0,o0(n+16|0,0,80),s=i[n+4>>2],h=s+1|0,i[n+4>>2]=h,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,e=n+140|0,i[n+136>>2]=e,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=s,s=i[n+8>>2],W=n+12|0,i[n+96>>2]=W,i[n+8>>2]=s+1,i[n+100>>2]=n,h||(X[i[i[n>>2]+8>>2]](n),p(n)),i[W+120>>2]=3,i[W+116>>2]=0,i[W+112>>2]=I,i[W+108>>2]=t,_=l[k+8|0],h=i[i[r>>2]+120>>2],T0(f+56|0,W,0,t,I,8,o),T0(f+32|0,W,1,t,I,8,o),w=f+88|0;i:{if(i[f+56>>2]){if(k=i[f+60>>2],i[f+80>>2]=i[f+56>>2],i[f+84>>2]=k,u[f+75|0]>=0){s=f- -64|0,k=i[s+4>>2],i[w>>2]=i[s>>2],i[w+4>>2]=k,i[w+8>>2]=i[s+8>>2];break i}T(w,i[f+64>>2],i[f+68>>2]);break i}if(k=i[f+36>>2],i[f+80>>2]=i[f+32>>2],i[f+84>>2]=k,u[f+51|0]>=0){k=i[f+44>>2],i[w>>2]=i[f+40>>2],i[w+4>>2]=k,i[w+8>>2]=i[f+48>>2];break i}T(w,i[f+40>>2],i[f+44>>2])}T0(f+8|0,W,2,t,I,8,o),s=f+112|0;i:{if(i[f+80>>2]){if(k=i[f+84>>2],i[f+104>>2]=i[f+80>>2],i[f+108>>2]=k,u[f+99|0]>=0){k=i[w+4>>2],i[s>>2]=i[w>>2],i[s+4>>2]=k,i[s+8>>2]=i[w+8>>2];break i}T(s,i[f+88>>2],i[f+92>>2]);break i}if(k=i[f+12>>2],i[f+104>>2]=i[f+8>>2],i[f+108>>2]=k,u[f+27|0]>=0){k=i[f+20>>2],i[s>>2]=i[f+16>>2],i[s+4>>2]=k,i[s+8>>2]=i[f+24>>2];break i}T(s,i[f+16>>2],i[f+20>>2])}u[f+27|0]<0&&Z(i[f+16>>2]),u[f+99|0]<0&&Z(i[f+88>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+75|0]<0&&Z(i[f+64>>2]);i:{e:{if(i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+8>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}u[f+123|0]<0&&Z(i[f+112>>2]);r:{if(!(_&1))break r;if(T0(f+104|0,W,6,t,I,8,o),i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[f+116>>2],i[r>>2]=i[f+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+120>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}if(u[f+123|0]>=0)break r;Z(i[f+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(s=r+128|0,r=s;k=i[o+16>>2]<10,r=k?r:o,o=i[(k?4:0)+o>>2],!!o;);if((r|0)==(s|0))break f;if(s=0,i[r+16>>2]>10)break r;$=i[r+56>>2],s=i[r+44>>2];break r}s=0}r:{f:{if(r=i[e>>2],r){for(k=e,o=r;m=i[o+16>>2],k=(m|0)<0?k:o,o=i[(m>>>29&4)+o>>2],!!o;);V=0;A:{if((e|0)==(k|0)||(V=0,i[k+16>>2]>0))break A;f0=i[k+56>>2],V=i[k+44>>2]}for(k=e,o=r;m=i[o+16>>2]<=0,k=m?k:o,o=i[(m?4:0)+o>>2],!!o;);y=0;A:{if((e|0)==(k|0)||(y=0,i[k+16>>2]>1))break A;A0=i[k+44>>2],y=i[k+56>>2]}for(k=e,o=r;m=i[o+16>>2]<2,k=m?k:o,o=i[(m?4:0)+o>>2],!!o;);o=0;A:{if((e|0)==(k|0)||(o=0,i[k+16>>2]>2))break A;n0=i[k+56>>2],o=i[k+44>>2]}if(m=o,k=0,!(_&1))break r;for(o=e;k=i[r+16>>2]<6,o=k?o:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2],k=i[o+44>>2]}r:{if(!I|!t)break r;if(!(_&1)){for(C=(h|0)==11?4:3,w=t&-2,_=t&1,e=0;;){if(B=G(e,n0)+m|0,N=G(e,y)+A0|0,D=G(e,f0)+V|0,x=G(e,$)+s|0,o=0,r=0,(t|0)!=1)for(;g=x+G(o,C)|0,h=l[g|0],k=l[g+2|0],u[o+D|0]=l[g+1|0],u[o+N|0]=k,u[o+B|0]=h,R=o|1,g=x+G(R,C)|0,h=l[g|0],k=l[g+2|0],u[D+R|0]=l[g+1|0],u[N+R|0]=k,u[B+R|0]=h,o=o+2|0,r=r+2|0,(w|0)!=(r|0););if(_&&(h=x+G(o,C)|0,k=l[h|0],r=l[h+2|0],u[o+D|0]=l[h+1|0],u[o+N|0]=r,u[o+B|0]=k),e=e+1|0,(I|0)==(e|0))break}break r}for(D=s+3|0,x=t&-2,R=t&1,e=0,g=(h|0)==11;;){S=k+G(e,N)|0,O=G(e,n0)+m|0,L=G(e,y)+A0|0,a=G(e,f0)+V|0,r=G(e,$),C=r+s|0;f:{if(g){for(w=r+D|0,o=0;_=o<<2,B=_+C|0,h=l[B|0],r=l[B+2|0],u[o+a|0]=l[B+1|0],u[o+L|0]=r,u[o+O|0]=h,u[o+S|0]=l[w+_|0],o=o+1|0,(o|0)!=(t|0););break f}if(o=0,r=0,(t|0)!=1)for(;w=C+G(o,3)|0,_=l[w|0],h=l[w+2|0],u[o+a|0]=l[w+1|0],u[o+L|0]=h,u[o+O|0]=_,u[o+S|0]=255,B=o|1,w=C+G(B,3)|0,_=l[w|0],h=l[w+2|0],u[B+a|0]=l[w+1|0],u[B+L|0]=h,u[B+O|0]=_,u[B+S|0]=255,o=o+2|0,r=r+2|0,(x|0)!=(r|0););if(!R)break f;_=C+G(o,3)|0,h=l[_|0],r=l[_+2|0],u[o+a|0]=l[_+1|0],u[o+L|0]=r,u[o+O|0]=h,u[o+S|0]=255}if(e=e+1|0,(I|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=W;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=f+128|0}function jB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;h=v-48|0,v=h;i:{if(!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(!(n&&k)){if(u[h+32|0]=0,u[h+43|0]=0,r=A,A=K(h+8|0,5,2006,h+32|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+43|0]>=0)break i;Z(i[h+32>>2]);break i}if((k|n)>>>0>=65536){i[A>>2]=5,i[A+4>>2]=129,i[A+8>>2]=21309;break i}m=h+8|0,C=i[e>>2],W=t,s=v-48|0,v=s,g=G(k,n);e:{if(g>>>16|0){r=E(32),i[s+12>>2]=r,i[s+16>>2]=31,i[s+20>>2]=-2147483616,f=l[26797]|l[26798]<<8|(l[26799]<<16|l[26800]<<24),k=l[26793]|l[26794]<<8|(l[26795]<<16|l[26796]<<24),u[r+23|0]=k,u[r+24|0]=k>>>8,u[r+25|0]=k>>>16,u[r+26|0]=k>>>24,u[r+27|0]=f,u[r+28|0]=f>>>8,u[r+29|0]=f>>>16,u[r+30|0]=f>>>24,f=l[26790]|l[26791]<<8|(l[26792]<<16|l[26793]<<24),k=l[26786]|l[26787]<<8|(l[26788]<<16|l[26789]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[26782]|l[26783]<<8|(l[26784]<<16|l[26785]<<24),k=l[26778]|l[26779]<<8|(l[26780]<<16|l[26781]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[26774]|l[26775]<<8|(l[26776]<<16|l[26777]<<24),k=l[26770]|l[26771]<<8|(l[26772]<<16|l[26773]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+31|0]=0,r=K(s+24|0,5,0,s+12|0),f=i[r+4>>2],i[m>>2]=i[r>>2],i[m+4>>2]=f,f=m+8|0;r:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[m+20|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[m+20|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(u[s+23|0]>=0)break e;Z(i[s+12>>2]);break e}_=r|f,B=_>>>0>65535,t=B?12:8,w=E(t),i[s+24>>2]=w,I=t+w|0,i[s+32>>2]=I,t&&o0(w,0,t),i[s+28>>2]=I,u[w+3|0]=k-1,u[w+2|0]=n-1,u[w+1|0]=B,u[w|0]=0;r:{if(_>>>0>=65536){t=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),u[w+8|0]=t,u[w+9|0]=t>>>8,u[w+10|0]=t>>>16,u[w+11|0]=t>>>24,B=r>>>24|0,_=r,t=r>>>16|0;break r}B=r>>>8|0,_=f,t=r}u[w+7|0]=_,u[w+5|0]=t,u[w+4|0]=B,u[w+6|0]=_>>>8,w=i[C+48>>2],_=i[C+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),B=$A(w,1735551332),t=E(496),i[t>>2]=101064,i[t+4>>2]=0,i[t+8>>2]=0,I=Y4(t+16|0,C,B),i[I>>2]=101224,i[t+488>>2]=0,i[t+480>>2]=0,i[t+484>>2]=0,i[t+472>>2]=0,i[t+476>>2]=0,i[t+464>>2]=0,i[t+468>>2]=0,V=D6(),i[t+488>>2]=V,Sr(V,W),i[t+472>>2]=f,i[t+468>>2]=r,Q[t+466>>1]=k,Q[t+464>>1]=n,n=i[t+476>>2],k=i[t+480>>2]-n>>2;r:{if(k>>>0<g>>>0){I8(t+476|0,g-k|0);break r}if(k>>>0<=g>>>0)break r;i[t+480>>2]=n+(g<<2)}i[t+140>>2]=f,i[t+136>>2]=r,i[s+16>>2]=t,i[s+12>>2]=I,i[t+4>>2]=i[t+4>>2]+1,Dr(C,B,s+12|0),k=i[s+16>>2];r:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break r;X[i[i[k>>2]+8>>2]](k),p(k)}K8(w,B,s+24|0,1),i[s+20>>2]=0,i[s+12>>2]=0,i[s+16>>2]=0,g&&I8(s+12|0,g),a4(w,B,1684630887,s+12|0),n=v-16|0,v=n,k=E(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90172,W=k+16|0,i[W+8>>2]=0,i[W+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=87652,i[k+124>>2]=f,i[k+120>>2]=r,i[k+32>>2]=1769173093,r=i[w+52>>2],i[n+12>>2]=k,i[n+8>>2]=W,i[k+4>>2]=i[k+4>>2]+1,f=R6(r,n+8|0),r=i[n+12>>2];r:{if(!r||(W=i[r+4>>2],i[r+4>>2]=W-1,W))break r;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[w+60>>2],Q[n+6>>1]=f+1,u[n+4|0]=0,i[n>>2]=F[n+4>>1]|F[n+6>>1]<<16,F6(r,B,n),r=i[k+4>>2],i[k+4>>2]=r-1,r||(X[i[i[k>>2]+8>>2]](k),p(k)),v=n+16|0,u[m+20|0]=0,i[m+4>>2]=t,i[m>>2]=I,r=i[s+12>>2],r&&(i[s+16>>2]=r,Z(r));r:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break r;X[i[i[_>>2]+8>>2]](_),p(_)}if(r=i[s+24>>2],!r)break e;i[s+28>>2]=r,Z(r)}v=s+48|0;e:{r:switch(l[h+28|0]){default:_2(),H();case 1:b0(A,h+8|0,i[e>>2]);break e;case 0:break r}r:{if(!o)break r;k=E(16),r=k,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,n=i[h+8>>2],f=i[h+12>>2];f:{if(!f){i[r+4>>2]=f,i[r>>2]=n;break f}if(i[f+4>>2]=i[f+4>>2]+1,i[k>>2]=n,r=i[k+4>>2],i[k+4>>2]=f,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=i[e>>2],r=i[o>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(A=l[h+28|0],(A|0)==255)break i;e=i[24249],i[h+32>>2]=i[24248],i[h+36>>2]=e,X[i[(h+32|0)+(A<<2)>>2]](h+47|0,h+8|0)}v=h+48|0}function OB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0;w=v-112|0,v=w,e=i[r>>2],i[w+92>>2]=e,s=i[r+4>>2],i[w+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[t+20>>2],i[w+80>>2]=i[t+16>>2],i[w+84>>2]=s,s=i[t+12>>2],i[w+72>>2]=i[t+8>>2],i[w+76>>2]=s,s=i[t+4>>2],i[w+64>>2]=i[t>>2],i[w+68>>2]=s,i[w+68>>2]=0;i:{e:{r:{if(i[t+4>>2]){kA(w+40|0,w+92|0,1,f+16|0,i[f+12>>2],n,w- -64|0,o),B=l[w+60|0];f:{if(B){if((B|0)!=1)break r;e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,s=A+8|0;A:{if(u[w+59|0]>=0){e=i[w+52>>2],i[s>>2]=i[w+48>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+56>>2];break A}T(s,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f}if(e=i[w+40>>2],s=i[w+44>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[w+92>>2]=e,g=i[w+96>>2],i[w+96>>2]=s,!g||(e=i[g+4>>2],i[g+4>>2]=e-1,e))break f;X[i[i[g>>2]+8>>2]](g),p(g)}if(s=l[w+60|0],(s|0)!=255&&(e=i[26097],i[w+104>>2]=i[26096],i[w+108>>2]=e,X[i[(w+104|0)+(s<<2)>>2]](w+32|0,w+40|0)),B)break i;e=i[w+92>>2]}for(R=i[e+112>>2],C=i[e+108>>2],s=E(172),i[s>>2]=94860,i[s+4>>2]=0,i[s+8>>2]=0,o0(s+16|0,0,80),i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,Q[s+22>>1]=2,Q[s+18>>1]=2,Q[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95208,i[s+148>>2]=0,i[s+152>>2]=0,i[s+136>>2]=s+140,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[w+36>>2]=s,e=s+12|0,i[w+32>>2]=e,i[s+96>>2]=e,i[s+8>>2]=i[s+8>>2]+1,i[s+100>>2]=s,i[s+4>>2]==-1&&(X[i[i[s>>2]+8>>2]](s),p(s)),s=i[w+92>>2],e=i[s+116>>2],a=i[w+32>>2],B=a,i[B+120>>2]=i[s+120>>2],i[B+116>>2]=e,i[B+112>>2]=R,i[B+108>>2]=C,i[w+48>>2]=5,i[w+40>>2]=3,i[w+44>>2]=4,n0=C&-2,h0=C&1,A0=B+128|0;;){W=i[(w+40|0)+$>>2],T0(w+12|0,a,W,C,R,i[k+12>>2],o),u[w+31|0]<0&&Z(i[w+20>>2]),f0=0,_=i[w+92>>2],B=_+128|0,e=B;f:{A:{if(h=i[_+128>>2],!h)break A;for(;s=i[h+16>>2]<6,e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(B|0))break A;if(O=0,g=0,i[e+16>>2]>6)break f;O=i[e+44>>2],g=i[e+56>>2]>>>1|0;break f}O=0,g=0}D=j0(_,6),m=i[w+92>>2],_=m+128|0,e=_,h=i[m+128>>2],B=0;f:{if(!h)break f;for(;s=(W|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(_|0)){B=0;break f}if(B=0,(W|0)<i[e+16>>2])break f;f0=i[e+56>>2]>>>1|0,B=i[e+44>>2]}_=-1<<D;f:{A:{if(e=A0,h=i[e>>2],!h)break A;for(;s=(W|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(A0|0))break A;if(L=0,s=0,(W|0)<i[e+16>>2])break f;L=i[e+44>>2],s=i[e+56>>2]>>>1|0;break f}L=0,s=0}V=_^-1;f:{A:{k:switch(i[t+4>>2]-1|0){case 1:if(F[t+20>>1])break A;break;case 0:break k;default:break A}e=0;k:{n:switch(W-3|0){case 0:e=F[t+8>>1];break k;case 1:e=F[t+10>>1];break k;case 2:break n;default:break k}e=F[t+12>>1]}if(_=j0(m,W),!R|!C)break f;for(y=(e&65535)>>>16-_|0,N=V&65535,h=0;;){if(x=(G(s,h)<<1)+L|0,S=(G(h,f0)<<1)+B|0,W=(G(h,g)<<1)+O|0,e=0,V=0,(C|0)!=1)for(;m=e<<1,_=F[m+W>>1],Q[m+x>>1]=G(_,F[m+S>>1])+G(y,N-_|0)>>D,m=m|2,_=F[m+W>>1],Q[m+x>>1]=G(_,F[m+S>>1])+G(y,N-_|0)>>D,e=e+2|0,V=V+2|0,(n0|0)!=(V|0););if(h0&&(_=e<<1,e=F[_+W>>1],Q[_+x>>1]=G(e,F[_+S>>1])+G(y,N-e|0)>>D),h=h+1|0,(R|0)==(h|0))break}break f}e=0,I=0;A:{k:switch(W-3|0){case 0:I=F[t+14>>1],e=F[t+8>>1];break A;case 1:I=F[t+16>>1],e=F[t+10>>1];break A;case 2:break k;default:break A}I=F[t+18>>1],e=F[t+12>>1]}if(m=j0(m,W),_=j0(i[w+92>>2],W),!R|!C)break f;for(x=(e&65535)>>>16-m|0,S=(I&65535)>>>16-_|0,W=V&65535,I=0;;){for(V=(G(s,I)<<1)+L|0,m=(G(I,f0)<<1)+B|0,_=(G(I,g)<<1)+O|0,h=0;y=h<<1,N=F[y+_>>1],e=F[t+20>>1],Q[V+y>>1]=G(W-N|0,((I>>>0)/(e>>>0)|0)+((h>>>0)/(e>>>0)|0)&1?x:S)+G(N,F[m+y>>1])>>D,h=h+1|0,(C|0)!=(h|0););if(I=I+1|0,(R|0)==(I|0))break}}if($=$+4|0,($|0)==12)break}if(!i[t+4>>2])break e;e=i[r>>2],r6(w+40|0,w+32|0,i[e+116>>2],i[e+120>>2],f+16|0,i[f+12>>2],n,w- -64|0,o);f:{A:switch(l[w+60|0]){case 1:e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[w+59|0]>=0){e=i[w+52>>2],i[r>>2]=i[w+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+56>>2];break k}T(r,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f;case 0:break A;default:break r}u[A+20|0]=255,u[A|0]=0,i[w+104>>2]=A,X[i[26100]](w+104|0,w+40|0),u[A+20|0]=0}if(e=l[w+60|0],(e|0)!=255&&(A=i[26099],i[w+104>>2]=i[26098],i[w+108>>2]=A,X[i[(w+104|0)+(e<<2)>>2]](w+103|0,w+40|0)),e=i[w+36>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}_2(),H()}e=i[w+36>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=a}e=i[w+96>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=w+112|0}function LB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;n=v-128|0,v=n,B=l[k+8|0],w=i[i[r>>2]+120>>2],t=E(172),i[t>>2]=94860,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],k=f+1|0,i[t+4>>2]=k,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],_=t+12|0,i[t+96>>2]=_,i[t+8>>2]=f+1,i[t+100>>2]=t,k||(X[i[i[t>>2]+8>>2]](t),p(t)),f=i[r>>2],g=i[f+112>>2],m=i[f+108>>2],I=j0(f,10),i[_+120>>2]=3,i[_+116>>2]=1,i[_+112>>2]=g,i[_+108>>2]=m,T0(n+56|0,_,3,m,g,I,o),T0(n+32|0,_,4,m,g,I,o),s=n+88|0;i:{if(i[n+56>>2]){if(f=i[n+60>>2],i[n+80>>2]=i[n+56>>2],i[n+84>>2]=f,u[n+75|0]>=0){k=n- -64|0,f=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=f,i[s+8>>2]=i[k+8>>2];break i}T(s,i[n+64>>2],i[n+68>>2]);break i}if(f=i[n+36>>2],i[n+80>>2]=i[n+32>>2],i[n+84>>2]=f,u[n+51|0]>=0){f=i[n+44>>2],i[s>>2]=i[n+40>>2],i[s+4>>2]=f,i[s+8>>2]=i[n+48>>2];break i}T(s,i[n+40>>2],i[n+44>>2])}T0(n+8|0,_,5,m,g,I,o),k=n+112|0;i:{if(i[n+80>>2]){if(f=i[n+84>>2],i[n+104>>2]=i[n+80>>2],i[n+108>>2]=f,u[n+99|0]>=0){f=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=f,i[k+8>>2]=i[s+8>>2];break i}T(k,i[n+88>>2],i[n+92>>2]);break i}if(f=i[n+12>>2],i[n+104>>2]=i[n+8>>2],i[n+108>>2]=f,u[n+27|0]>=0){f=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=f,i[k+8>>2]=i[n+24>>2];break i}T(k,i[n+16>>2],i[n+20>>2])}u[n+27|0]<0&&Z(i[n+16>>2]),u[n+99|0]<0&&Z(i[n+88>>2]),u[n+51|0]<0&&Z(i[n+40>>2]),u[n+75|0]<0&&Z(i[n+64>>2]);i:{e:{if(i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,r=A+8|0,u[n+123|0]>=0){e=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(r,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}u[n+123|0]<0&&Z(i[n+112>>2]);r:{if(!(B&1))break r;if(T0(n+104|0,_,6,m,g,I,o),i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,r=A+8|0,u[n+123|0]>=0){e=i[n+116>>2],i[r>>2]=i[n+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+120>>2],u[A+20|0]=1;break e}if(T(r,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}if(u[n+123|0]>=0)break r;Z(i[n+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(k=r+128|0,f=k;r=i[o+16>>2]<10,f=r?f:o,o=i[(r?4:0)+o>>2],!!o;);if((f|0)==(k|0))break f;if(r=0,i[f+16>>2]>10)break r;D=i[f+44>>2],r=i[f+56>>2];break r}r=0}s=r;r:{f:{f=i[e>>2];A:{if(!f){r=0;break A}for(k=e,o=f;r=i[o+16>>2]<3,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);V=0;k:{if((e|0)==(k|0)||(V=0,i[k+16>>2]>3))break k;h=i[k+56>>2],V=i[k+44>>2]}for(k=e,o=f;r=i[o+16>>2]<4,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);y=0;k:{if((e|0)==(k|0)||(y=0,i[k+16>>2]>4))break k;R=i[k+56>>2],y=i[k+44>>2]}for(k=e,o=f;r=i[o+16>>2]<5,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);r=0;k:{if((e|0)==(k|0)||(r=0,i[k+16>>2]>5))break k;x=i[k+44>>2],r=i[k+56>>2]}if(k=0,!(B&1))break r;for(o=e;k=i[f+16>>2]<6,o=k?o:f,f=i[(k?4:0)+f>>2],!!f;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2]>>>1|0,k=i[o+44>>2]}f=k;r:{if(!g|!m)break r;if(S=(w&-3)==13?8:6,O=r>>>1|0,L=R>>>1|0,a=h>>>1|0,e=0,B&1){for(R=-1<<I^-1,k=w-13|0;;){$=G(e,s)+D|0,f0=(G(e,N)<<1)+f|0,A0=(G(e,O)<<1)+x|0,I=(G(e,L)<<1)+y|0,B=(G(e,a)<<1)+V|0,o=0;f:{A:switch(k|0){case 0:case 2:for(;C=$+(o<<3)|0,w=l[C+4|0]|l[C+5|0]<<8,h=l[C+2|0]|l[C+3|0]<<8,W=o<<1,r=l[C|0]|l[C+1|0]<<8,Q[W+B>>1]=r<<8|r>>>8,Q[I+W>>1]=h<<8|h>>>8,Q[W+A0>>1]=w<<8|w>>>8,r=l[C+6|0]|l[C+7|0]<<8,Q[W+f0>>1]=r<<8|r>>>8,o=o+1|0,(m|0)!=(o|0););break f;default:break A}for(;r=$+G(o,S)|0,w=l[r+4|0]|l[r+5|0]<<8,h=l[r+2|0]|l[r+3|0]<<8,W=o<<1,r=l[r|0]|l[r+1|0]<<8,Q[W+B>>1]=r<<8|r>>>8,Q[I+W>>1]=h<<8|h>>>8,Q[W+A0>>1]=w<<8|w>>>8,Q[W+f0>>1]=R,o=o+1|0,(m|0)!=(o|0););}if(e=e+1|0,(g|0)==(e|0))break}break r}for(;;){for(N=G(e,s)+D|0,R=(G(e,O)<<1)+x|0,k=(G(e,L)<<1)+y|0,f=(G(e,a)<<1)+V|0,o=0;r=N+G(o,S)|0,B=l[r+4|0]|l[r+5|0]<<8,w=l[r+2|0]|l[r+3|0]<<8,h=o<<1,r=l[r|0]|l[r+1|0]<<8,Q[h+f>>1]=r<<8|r>>>8,Q[k+h>>1]=w<<8|w>>>8,Q[h+R>>1]=B<<8|B>>>8,o=o+1|0,(m|0)!=(o|0););if(e=e+1|0,(g|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=_;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=n+128|0}function PB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0;f=v-128|0,v=f,w=l[k+8|0],C=i[i[r>>2]+120>>2],n=E(172),i[n>>2]=94860,i[n+4>>2]=0,i[n+8>>2]=0,o0(n+16|0,0,80),k=i[n+4>>2],t=k+1|0,i[n+4>>2]=t,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,e=n+140|0,i[n+136>>2]=e,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=k,k=i[n+8>>2],m=n+12|0,i[n+96>>2]=m,i[n+8>>2]=k+1,i[n+100>>2]=n,t||(X[i[i[n>>2]+8>>2]](n),p(n)),k=i[r>>2],h=i[k+108>>2],V=i[k+112>>2],k=V,i[m+120>>2]=3,i[m+116>>2]=1,i[m+112>>2]=k,i[m+108>>2]=h,T0(f+56|0,m,3,h,k,8,o),T0(f+32|0,m,4,h,k,8,o),s=f+88|0;i:{if(i[f+56>>2]){if(k=i[f+60>>2],i[f+80>>2]=i[f+56>>2],i[f+84>>2]=k,u[f+75|0]>=0){t=f- -64|0,k=i[t+4>>2],i[s>>2]=i[t>>2],i[s+4>>2]=k,i[s+8>>2]=i[t+8>>2];break i}T(s,i[f+64>>2],i[f+68>>2]);break i}if(k=i[f+36>>2],i[f+80>>2]=i[f+32>>2],i[f+84>>2]=k,u[f+51|0]>=0){k=i[f+44>>2],i[s>>2]=i[f+40>>2],i[s+4>>2]=k,i[s+8>>2]=i[f+48>>2];break i}T(s,i[f+40>>2],i[f+44>>2])}T0(f+8|0,m,5,h,V,8,o),t=f+112|0;i:{if(i[f+80>>2]){if(k=i[f+84>>2],i[f+104>>2]=i[f+80>>2],i[f+108>>2]=k,u[f+99|0]>=0){k=i[s+4>>2],i[t>>2]=i[s>>2],i[t+4>>2]=k,i[t+8>>2]=i[s+8>>2];break i}T(t,i[f+88>>2],i[f+92>>2]);break i}if(k=i[f+12>>2],i[f+104>>2]=i[f+8>>2],i[f+108>>2]=k,u[f+27|0]>=0){k=i[f+20>>2],i[t>>2]=i[f+16>>2],i[t+4>>2]=k,i[t+8>>2]=i[f+24>>2];break i}T(t,i[f+16>>2],i[f+20>>2])}u[f+27|0]<0&&Z(i[f+16>>2]),u[f+99|0]<0&&Z(i[f+88>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+75|0]<0&&Z(i[f+64>>2]);i:{e:{if(i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[t+4>>2],i[r>>2]=i[t>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+8>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}u[f+123|0]<0&&Z(i[f+112>>2]);r:{if(!(w&1))break r;if(T0(f+104|0,m,6,h,V,8,o),i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[f+116>>2],i[r>>2]=i[f+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+120>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}if(u[f+123|0]>=0)break r;Z(i[f+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(t=r+128|0,r=t;k=i[o+16>>2]<10,r=k?r:o,o=i[(k?4:0)+o>>2],!!o;);if((r|0)==(t|0))break f;if(t=0,i[r+16>>2]>10)break r;O=i[r+44>>2],t=i[r+56>>2];break r}t=0}r:{f:{r=i[e>>2];A:{if(!r)break A;for(k=e,o=r;_=i[o+16>>2]<3,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);y=0;k:{if((e|0)==(k|0)||(y=0,i[k+16>>2]>3))break k;L=i[k+56>>2],y=i[k+44>>2]}for(k=e,o=r;_=i[o+16>>2]<4,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);R=0;k:{if((e|0)==(k|0)||(R=0,i[k+16>>2]>4))break k;a=i[k+44>>2],R=i[k+56>>2]}for(k=e,o=r;_=i[o+16>>2]<5,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);k:{if((e|0)==(k|0)){o=0;break k}if(o=0,i[k+16>>2]>5)break k;$=i[k+56>>2],o=i[k+44>>2]}if(_=o,k=0,!(w&1))break r;for(o=e;k=i[r+16>>2]<6,o=k?o:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2],k=i[o+44>>2]}r:{if(!V|!h)break r;if(!(w&1)){for(g=(C|0)==11?4:3,C=h&-2,k=h&1,e=0;;){if(I=G(e,$)+_|0,W=G(e,R)+a|0,B=G(e,L)+y|0,N=G(e,t)+O|0,o=0,r=0,(h|0)!=1)for(;w=N+G(o,g)|0,u[o+B|0]=l[w|0],u[o+W|0]=l[w+1|0],u[o+I|0]=l[w+2|0],s=o|1,w=N+G(s,g)|0,u[s+B|0]=l[w|0],u[s+W|0]=l[w+1|0],u[s+I|0]=l[w+2|0],o=o+2|0,r=r+2|0,(C|0)!=(r|0););if(k&&(r=N+G(o,g)|0,u[o+B|0]=l[r|0],u[o+W|0]=l[r+1|0],u[o+I|0]=l[r+2|0]),e=e+1|0,(V|0)==(e|0))break}break r}for(s=h&-2,w=h&1,e=0,C=(C|0)==11;;){D=k+G(e,N)|0,x=G(e,$)+_|0,S=G(e,R)+a|0,g=G(e,L)+y|0,I=G(e,t)+O|0,o=0;f:{if(!C){if(r=0,(h|0)!=1)for(;B=I+G(o,3)|0,u[o+g|0]=l[B|0],u[o+S|0]=l[B+1|0],u[o+x|0]=l[B+2|0],u[o+D|0]=255,W=o|1,B=I+G(W,3)|0,u[g+W|0]=l[B|0],u[W+S|0]=l[B+1|0],u[W+x|0]=l[B+2|0],u[W+D|0]=255,o=o+2|0,r=r+2|0,(s|0)!=(r|0););if(!w)break f;r=I+G(o,3)|0,u[o+g|0]=l[r|0],u[o+S|0]=l[r+1|0],u[o+x|0]=l[r+2|0],u[o+D|0]=255;break f}for(;r=I+(o<<2)|0,u[o+g|0]=l[r|0],u[o+S|0]=l[r+1|0],u[o+x|0]=l[r+2|0],u[o+D|0]=l[r+3|0],o=o+1|0,(h|0)!=(o|0););}if(e=e+1|0,(V|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=m;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=f+128|0}function qB(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,i[_+12>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,k=_+4|0;i:{e:{if(w=i[e+64>>2],s=i[w+116>>2],h=i[w+120>>2],(s|0)!=(h|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(h|0)==(s|0))break}if(s=i[w+140>>2],h=i[w+144>>2],(s|0)!=(h|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=E(f):r=0,o=r+e|0,u[o|0]=n,e&&z(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(h|0)==(s|0))break}if(s=i[w+128>>2],f=i[w+132>>2],(s|0)!=(f|0))for(;;){t=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],n=i[k+8>>2];r:{if(e>>>0<n>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=E(n):r=0,h=r+e|0,u[h|0]=t,e&&z(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]>>>16|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=E(n):r=0,h=r+e|0,u[h|0]=t,e&&z(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]>>>8|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=E(n):r=0,h=r+e|0,u[h|0]=t,e&&z(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=E(n):r=0,h=r+e|0,u[h|0]=t,e&&z(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(f|0)==(s|0))break}break i}G0(),H()}e=i[_+8>>2],r=i[_+4>>2],k=i[_+12>>2],u[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=r,i[A+4>>2]=e,v=_+16|0}function KB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0;w=v-112|0,v=w,e=i[r>>2],i[w+92>>2]=e,s=i[r+4>>2],i[w+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[t+20>>2],i[w+80>>2]=i[t+16>>2],i[w+84>>2]=s,s=i[t+12>>2],i[w+72>>2]=i[t+8>>2],i[w+76>>2]=s,s=i[t+4>>2],i[w+64>>2]=i[t>>2],i[w+68>>2]=s,i[w+68>>2]=0;i:{e:{r:{if(i[t+4>>2]){kA(w+40|0,w+92|0,1,f+16|0,i[f+12>>2],n,w- -64|0,o),B=l[w+60|0];f:{if(B){if((B|0)!=1)break r;e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,s=A+8|0;A:{if(u[w+59|0]>=0){e=i[w+52>>2],i[s>>2]=i[w+48>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+56>>2];break A}T(s,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f}if(e=i[w+40>>2],s=i[w+44>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[w+92>>2]=e,g=i[w+96>>2],i[w+96>>2]=s,!g||(e=i[g+4>>2],i[g+4>>2]=e-1,e))break f;X[i[i[g>>2]+8>>2]](g),p(g)}if(s=l[w+60|0],(s|0)!=255&&(e=i[26097],i[w+104>>2]=i[26096],i[w+108>>2]=e,X[i[(w+104|0)+(s<<2)>>2]](w+32|0,w+40|0)),B)break i;e=i[w+92>>2]}for(V=i[e+112>>2],I=i[e+108>>2],s=E(172),i[s>>2]=94860,i[s+4>>2]=0,i[s+8>>2]=0,o0(s+16|0,0,80),i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,Q[s+22>>1]=2,Q[s+18>>1]=2,Q[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95208,i[s+148>>2]=0,i[s+152>>2]=0,i[s+136>>2]=s+140,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[w+36>>2]=s,e=s+12|0,i[w+32>>2]=e,i[s+96>>2]=e,i[s+8>>2]=i[s+8>>2]+1,i[s+100>>2]=s,i[s+4>>2]==-1&&(X[i[i[s>>2]+8>>2]](s),p(s)),s=i[w+92>>2],e=i[s+116>>2],L=i[w+32>>2],B=L,i[B+120>>2]=i[s+120>>2],i[B+116>>2]=e,i[B+112>>2]=V,i[B+108>>2]=I,i[w+48>>2]=5,i[w+40>>2]=3,i[w+44>>2]=4,A0=I&-2,n0=I&1,f0=B+128|0;;){m=i[(w+40|0)+a>>2],T0(w+12|0,L,m,I,V,i[k+12>>2],o),u[w+31|0]<0&&Z(i[w+20>>2]),$=0,_=i[w+92>>2],B=_+128|0,e=B;f:{A:{if(h=i[_+128>>2],!h)break A;for(;s=i[h+16>>2]<6,e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(B|0))break A;if(S=0,g=0,i[e+16>>2]>6)break f;S=i[e+44>>2],g=i[e+56>>2];break f}S=0,g=0}y=j0(_,6),W=i[w+92>>2],_=W+128|0,e=_,h=i[W+128>>2],B=0;f:{if(!h)break f;for(;s=(m|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(_|0)){B=0;break f}if(B=0,(m|0)<i[e+16>>2])break f;$=i[e+56>>2],B=i[e+44>>2]}_=-1<<y;f:{A:{if(e=f0,h=i[e>>2],!h)break A;for(;s=(m|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(f0|0))break A;if(O=0,s=0,(m|0)<i[e+16>>2])break f;O=i[e+44>>2],s=i[e+56>>2];break f}O=0,s=0}C=_^-1;f:{A:{k:switch(i[t+4>>2]-1|0){case 1:if(F[t+20>>1])break A;break;case 0:break k;default:break A}e=0;k:{n:switch(m-3|0){case 0:e=F[t+8>>1];break k;case 1:e=F[t+10>>1];break k;case 2:break n;default:break k}e=F[t+12>>1]}if(_=j0(W,m),!V|!I)break f;for(R=(e&65535)>>>16-_&255,N=C&255,e=0;;){if(D=G(e,s)+O|0,x=G(e,$)+B|0,m=G(e,g)+S|0,h=0,C=0,(I|0)!=1)for(;_=l[h+m|0],u[h+D|0]=G(_,l[h+x|0])+G(R,N-_|0)>>y,W=h|1,_=l[W+m|0],u[W+D|0]=G(_,l[W+x|0])+G(R,N-_|0)>>y,h=h+2|0,C=C+2|0,(A0|0)!=(C|0););if(n0&&(_=l[h+m|0],u[h+D|0]=G(_,l[h+x|0])+G(R,N-_|0)>>y),e=e+1|0,(V|0)==(e|0))break}break f}e=0,h=0;A:{k:switch(m-3|0){case 0:h=F[t+14>>1],e=F[t+8>>1];break A;case 1:h=F[t+16>>1],e=F[t+10>>1];break A;case 2:break k;default:break A}h=F[t+18>>1],e=F[t+12>>1]}if(W=j0(W,m),_=j0(i[w+92>>2],m),!V|!I)break f;for(R=(e&65535)>>>16-W|0,N=h>>>16-_|0,D=C&255,e=0;;){for(x=G(e,s)+O|0,m=G(e,$)+B|0,C=G(e,g)+S|0,h=0;W=l[h+C|0],_=F[t+20>>1],u[h+x|0]=G(D-W|0,(((e>>>0)/(_>>>0)|0)+((h>>>0)/(_>>>0)|0)&1?R:N)&255)+G(W,l[h+m|0])>>y,h=h+1|0,(I|0)!=(h|0););if(e=e+1|0,(V|0)==(e|0))break}}if(a=a+4|0,(a|0)==12)break}if(!i[t+4>>2])break e;e=i[r>>2],r6(w+40|0,w+32|0,i[e+116>>2],i[e+120>>2],f+16|0,i[f+12>>2],n,w- -64|0,o);f:{A:switch(l[w+60|0]){case 1:e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[w+59|0]>=0){e=i[w+52>>2],i[r>>2]=i[w+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+56>>2];break k}T(r,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f;case 0:break A;default:break r}u[A+20|0]=255,u[A|0]=0,i[w+104>>2]=A,X[i[26100]](w+104|0,w+40|0),u[A+20|0]=0}if(e=l[w+60|0],(e|0)!=255&&(A=i[26099],i[w+104>>2]=i[26098],i[w+108>>2]=A,X[i[(w+104|0)+(e<<2)>>2]](w+103|0,w+40|0)),e=i[w+36>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}_2(),H()}e=i[w+36>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=L}e=i[w+96>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=w+112|0}function qi(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0;m=v-128|0,v=m;i:{e:{r:{if(g=i[A+140>>2],h=g+G(e,24)|0,I=i[A+152>>2],N=G(I,r),_=(h+G(N,24)|0)+4|0,L=f<<1,C=l[_|0]>>>L&3,!C)break r;if(V=G(e,k),e=i[A+148>>2],y=V>>e,(y|0)<0|(I|0)<=(y|0))break e;if(a=G(r,n),r=a>>e,(r|0)<0|(r|0)>=i[A+156>>2])break i;if(R=i[A+124>>2],h0=i[R+(f?16840:16832)>>2],e=-1<<h0^-1,D=i[(f?36:28)+A>>2],$=(D|0)<(n+a|0)?D-a|0:n,n0=i[(f?32:24)+A>>2],f0=(n0|0)<(k+V|0)?n0-V|0:k,x=f?i[R+16856>>2]-1|0:0,S=f?i[R+16852>>2]-1|0:0,k=l[(h+G(N,24)|0)+22|0],(C|0)==2){if(N=i[A+132>>2],I=i[i[i[A+52>>2]+(F[((g+G(y,24)|0)+G(G(r,I),24)|0)+2>>1]<<2)>>2]+808>>2],n=i[R+16876>>2],y=i[R+16892>>2],g=l[_+1|0],r=_+(f<<2)|0,u[m|0]=l[r+5|0],f=l[r+6|0],u[m+2|0]=0,u[m+1|0]=f,u[m+3|0]=l[r+7|0],u[m+4|0]=l[r+8|0],($|0)<=0|(f0|0)<=0)break r;for(r=(g>>>L&3)<<2,V0=i[r+62936>>2],L0=G(V0,o),e0=i[r+62952>>2],q0=G(e0,o),h0=i[r+62920>>2],r0=i[r+62904>>2],m0=n-S|0,N0=V>>m0,$0=$-1|0,P0=f0-1|0,d0=s+V|0,n2=t+V|0,W0=n-x|0,U0=G(y,a>>W0),t=0,Z2=k&1;;){for(r=t+a|0,s=r<<x,_=r+V0|0,g2=_<<x,g=r+e0|0,Q2=g<<x,E2=G(r,w)+d0|0,H2=G(r,o)+n2|0,T2=G(y,g>>>W0|0)<<2,b2=G(y,_>>>W0|0)<<2,e1=(t|0)!=($0|0),k=0;;){f:{A:{if(!Z2){n=i[A+168>>2];break A}if(n=i[A+168>>2],!l[R+8812|0])break A;if(r=k+V<<S>>n,(r|0)<0||(h=i[A+172>>2],(h|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(r,3)|0)+G(G(f,h),3)|0)+1|0]&4)break f}if(W=k+V|0,A0=W<<S,r=A0>>n,(r|0)<0||(h=i[A+172>>2],(h|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(r,3)|0)+G(G(f,h),3)|0)+1|0]&8)break f;A:{if(!(!t|!k|(k|0)==(P0|0))&&e1)break A;if(h=W+h0|0,(h|0)>=(n0|0)|(h|0)<0|((g|0)<0|(g|0)>=(D|0)))break f;if(r=i[A+148>>2],C=h<<S>>r,(C|0)<0||(f=i[A+152>>2],(f|0)<=(C|0)))break e;if(B=Q2>>r,(B|0)<0||(L=i[A+156>>2],(L|0)<=(B|0)))break i;if(n=i[A+52>>2],D0=i[A+56>>2]-n>>2,O=G(C,24),C=i[A+140>>2],B=F[((O+C|0)+G(G(f,B),24)|0)+2>>1],D0>>>0<=B>>>0||(B=i[n+(B<<2)>>2],!B))break r;if(H0=i[B+808>>2],(I|0)>(H0|0)){if(O=A0>>r,(O|0)<0|f>>>0<=O>>>0)break e;if(Q0=s>>r,(Q0|0)<0|(L|0)<=(Q0|0))break i;if(!l[i[n+(F[((C+G(O,24)|0)+G(G(f,Q0),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!l[B+772|0]&(I|0)<(H0|0)||(O=l[N+57|0],!O&&(B=h>>>m0<<2,h=i[N+8484>>2],i[(B+h|0)+T2>>2]!=i[(h+(N0<<2)|0)+(U0<<2)>>2]))||(h=W+r0|0,(h|0)>=(n0|0)|(h|0)<0|((_|0)<0|(_|0)>=(D|0))))break f;if(W=h<<S>>r,(W|0)<0|f>>>0<=W>>>0)break e;if(B=g2>>r,(B|0)<0|(B|0)>=(L|0))break i;if(W=F[((C+G(W,24)|0)+G(G(f,B),24)|0)+2>>1],W>>>0>=D0>>>0||(W=i[n+(W<<2)>>2],!W))break r;if(B=i[W+808>>2],(B|0)<(I|0)){if(A0=A0>>r,(A0|0)<0|f>>>0<=A0>>>0)break e;if(r=s>>r,(r|0)<0|(r|0)>=(L|0))break i;if(!l[i[n+(F[((C+G(A0,24)|0)+G(G(r,f),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!l[W+772|0]&(B|0)>(I|0))break f;if(O||(r=i[N+8484>>2],i[(r+(h>>>m0<<2)|0)+b2>>2]==i[(r+(N0<<2)|0)+(U0<<2)>>2]))break A;break f}f=k+H2|0,r=l[f|0],n=l[(f+h0|0)+q0|0],f=l[(f+r0|0)+L0|0],r=u[(((r>>>0>n>>>0)-(r>>>0<n>>>0)+((f>>>0<r>>>0)-(r>>>0<f>>>0))|0)+m|0)+2|0]+r|0,u[k+E2|0]=(r|0)>=0?(e|0)>(r|0)?r:e:0}if(k=k+1|0,(f0|0)==(k|0))break}if(t=t+1|0,($|0)==(t|0))break}break r}if(r=l[(f+_|0)+2|0],o0(m,0,128),i[((r&31)<<2)+m>>2]=1,i[((r+1&31)<<2)+m>>2]=2,i[((r+2&31)<<2)+m>>2]=3,i[((r+3&31)<<2)+m>>2]=4,I=h0-5|0,!(k&1)){if(($|0)<=0|(f0|0)<=0)break r;for(n=_+5|0,r=0;;){for(A=r+a|0,R=G(A,w)+s|0,S=G(A,o)+t|0,A=0;_=A+V|0,k=l[_+S|0],x=i[((e>>>0>k>>>0?k:e)>>>I<<2)+m>>2],(x|0)>0&&(k=k+u[(x+(n+(f<<2)|0)|0)-1|0]|0,u[_+R|0]=(k|0)>=0?(e|0)>(k|0)?k:e:0),A=A+1|0,(f0|0)>(A|0););if(r=r+1|0,!(($|0)>(r|0)))break}break r}if(($|0)<=0|(f0|0)<=0)break r;n0=_+5|0,_=0;f:{for(;;){r=_+a|0,N=r<<x,y=G(r,w)+s|0,g=G(r,o)+t|0,r=0;A:{for(;;){n=i[A+168>>2],k=N>>n,D=r+V|0,n=D<<S>>n;k:{n:{if(l[R+8812|0]){if((n|0)<0||(h=i[A+172>>2],(h|0)<=(n|0)))break A;if((k|0)<0|(k|0)>=i[A+176>>2])break i;if(!(l[((i[A+160>>2]+G(n,3)|0)+G(G(k,h),3)|0)+1|0]&4))break n;break k}if((n|0)<0)break e}if(h=i[A+172>>2],(h|0)<=(n|0))break e;if((k|0)<0|(k|0)>=i[A+176>>2])break f;if(l[((i[A+160>>2]+G(n,3)|0)+G(G(k,h),3)|0)+1|0]&8||(k=l[g+D|0],n=i[((e>>>0>k>>>0?k:e)>>>I<<2)+m>>2],(n|0)<=0))break k;k=k+u[(n+(n0+(f<<2)|0)|0)-1|0]|0,u[y+D|0]=(k|0)>=0?(e|0)>(k|0)?k:e:0}if(r=r+1|0,!((f0|0)>(r|0)))break}if(_=_+1|0,($|0)<=(_|0))break r;continue}break}break e}break i}v=m+128|0;return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function e9(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k,i[k+12>>2]=A;i:{if(A>>>0<=211){A=i[so(70480,70672,k+12|0)>>2];break i}for(A>>>0>=4294967292&&(Q1(),H()),n=(A>>>0)/210|0,f=G(n,210),i[k+8>>2]=A-f,t=so(70672,70864,k+8|0)-70672>>2;;){A=i[(t<<2)+70672>>2]+f|0,f=5;e:{r:{for(;;){if(r=f,(r|0)==47)break r;if(o=i[(r<<2)+70480>>2],e=(A>>>0)/(o>>>0)|0,e>>>0<o>>>0)break i;if(f=r+1|0,(G(e,o)|0)==(A|0))break}if(r>>>0<47)break e}for(f=211;;){if(r=(A>>>0)/(f>>>0)|0,r>>>0<f>>>0)break i;if((G(r,f)|0)==(A|0))break e;if(e=f+10|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+12|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+16|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+18|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+22|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+28|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+30|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+36|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+40|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+42|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+46|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+52|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+58|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+60|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+66|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+70|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+72|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+78|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+82|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+88|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+96|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+100|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+102|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+106|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+108|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+112|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+120|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+126|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+130|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+136|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+138|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+142|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+148|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+150|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+156|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+162|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+166|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+168|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+172|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+178|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+180|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+186|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+190|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+192|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+196|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+198|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+208|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if(f=f+210|0,(G(r,e)|0)==(A|0))break}}A=t+1|0,r=(A|0)==48,t=r?0:A,n=r+n|0,f=G(n,210)}}return v=k+16|0,A}function aB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v+-64|0,v=n,h9(n+40|0,e,f);i:{e:{r:{f:{if(i[n+40>>2]){e=i[n+44>>2],i[A>>2]=i[n+40>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+56>>2],e=i[n+52>>2],i[A+8>>2]=i[n+48>>2],i[A+12>>2]=e,i[n+56>>2]=0,i[n+48>>2]=0,i[n+52>>2]=0;break f}o=e+60|0;A:{if(i[e+60>>2])break A;if(t=i[e+56>>2],s=i[t+20>>2],!s){if(e=E(48),i[n>>2]=e,i[n+4>>2]=42,i[n+8>>2]=-2147483600,r=l[24401]|l[24402]<<8|(l[24403]<<16|l[24404]<<24),f=l[24397]|l[24398]<<8|(l[24399]<<16|l[24400]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+42|0]=0,r=l[24437]|l[24438]<<8,u[e+40|0]=r,u[e+41|0]=r>>>8,r=l[24433]|l[24434]<<8|(l[24435]<<16|l[24436]<<24),f=l[24429]|l[24430]<<8|(l[24431]<<16|l[24432]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[24425]|l[24426]<<8|(l[24427]<<16|l[24428]<<24),f=l[24421]|l[24422]<<8|(l[24423]<<16|l[24424]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[24417]|l[24418]<<8|(l[24419]<<16|l[24420]<<24),f=l[24413]|l[24414]<<8|(l[24415]<<16|l[24416]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[24409]|l[24410]<<8|(l[24411]<<16|l[24412]<<24),f=l[24405]|l[24406]<<8|(l[24407]<<16|l[24408]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,11,6003,n),u[n+11|0]>=0)break f;Z(i[n>>2]);break f}if(i[t>>2]>=5){if(w=n,h=X[i[i[e>>2]+8>>2]](e)|0,i[w>>2]=h,i[n+8>>2]=i[f+64>>2],i[n+4>>2]=l[f+21|0],X[i[i[e+56>>2]+56>>2]](n+24|0,o,n),t=i[n+24>>2],!t)break A;if(r=i[n+28>>2],k=i[n+32>>2],e=h2(k),e>>>0>=2147483640)break r;k:{n:{if(e>>>0>=11){o=e|7,f=E(o+1|0),i[n+32>>2]=o-2147483647,i[n+24>>2]=f,i[n+28>>2]=e;break n}if(u[n+35|0]=e,f=n+24|0,!e)break k}if(!e)break k;z(f,k,e)}if(u[e+f|0]=0,K(A,t,r,n+24|0),u[n+35|0]>=0)break f;Z(i[n+24>>2]);break f}if(X[s|0](n,o),t=i[n>>2],t){if(r=i[n+4>>2],k=i[n+8>>2],e=h2(k),e>>>0>=2147483640)break e;k:{n:{if(e>>>0>=11){o=e|7,f=E(o+1|0),i[n+8>>2]=o-2147483647,i[n>>2]=f,i[n+4>>2]=e;break n}if(u[n+11|0]=e,f=n,!e)break k}if(!e)break k;z(f,k,e)}if(u[e+f|0]=0,K(A,t,r,n),u[n+11|0]>=0)break f;Z(i[n>>2]);break f}if(t=i[e+56>>2],i[t>>2]<2||(t=i[t+36>>2],!t))break A;X[t|0](i[o>>2],l[f+21|0])}Br(n,e,r);A:{k:switch(l[n+20|0]){default:_2(),H();case 1:if(e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,A=A+8|0,u[n+19|0]>=0){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[n+16>>2];break A}T(A,i[n+8>>2],i[n+12>>2]);break A;case 0:break k}if(f=i[n+4>>2],r=i[n>>2],(f|0)==(r|0)){if(e=E(32),i[n+24>>2]=e,i[n+28>>2]=29,i[n+32>>2]=-2147483616,r=l[23364]|l[23365]<<8|(l[23366]<<16|l[23367]<<24),f=l[23360]|l[23361]<<8|(l[23362]<<16|l[23363]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[23385]|l[23386]<<8|(l[23387]<<16|l[23388]<<24),f=l[23381]|l[23382]<<8|(l[23383]<<16|l[23384]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[23380]|l[23381]<<8|(l[23382]<<16|l[23383]<<24),f=l[23376]|l[23377]<<8|(l[23378]<<16|l[23379]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23372]|l[23373]<<8|(l[23374]<<16|l[23375]<<24),f=l[23368]|l[23369]<<8|(l[23370]<<16|l[23371]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,n+24|0),u[n+35|0]>=0)break A;Z(i[n+24>>2]);break A}f=f-r|0;k:{n:{if(e=i[e+56>>2],i[e>>2]<5||(t=i[e+60>>2],!t))break n;X[t|0](n+24|0,i[o>>2],r,f,k);break k}X[i[e+28>>2]](n+24|0,i[o>>2],r,f)}if(f=i[n+32>>2],k=i[n+28>>2],o=i[n+24>>2],o){if(e=h2(f),e>>>0>=2147483640)break i;k:{n:{if(e>>>0>=11){t=e|7,r=E(t+1|0),i[n+32>>2]=t-2147483647,i[n+24>>2]=r,i[n+28>>2]=e;break n}if(u[n+35|0]=e,r=n+24|0,!e)break k}if(!e)break k;z(r,f,e)}if(u[e+r|0]=0,K(A,o,k,n+24|0),u[n+35|0]>=0)break A;Z(i[n+24>>2]);break A}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(A=l[n+20|0],(A|0)==255)break f;e=i[24273],i[n+24>>2]=i[24272],i[n+28>>2]=e,X[i[(n+24|0)+(A<<2)>>2]](n+63|0,n)}u[n+59|0]<0&&Z(i[n+48>>2]),v=n- -64|0;return}g0(),H()}g0(),H()}g0(),H()}function Ar(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0;for(_=i[A+20>>2],h=i[A+16>>2],w=i[A+12>>2],a=i[A+8>>2];s=l[e|0]|l[e+1|0]<<8|(l[e+2|0]<<16|l[e+3|0]<<24),i[A+88>>2]=s,B=l[e+4|0]|l[e+5|0]<<8|(l[e+6|0]<<16|l[e+7|0]<<24),i[A+92>>2]=B,m=l[e+8|0]|l[e+9|0]<<8|(l[e+10|0]<<16|l[e+11|0]<<24),i[A+96>>2]=m,W=l[e+12|0]|l[e+13|0]<<8|(l[e+14|0]<<16|l[e+15|0]<<24),i[A+100>>2]=W,g=l[e+16|0]|l[e+17|0]<<8|(l[e+18|0]<<16|l[e+19|0]<<24),i[A+104>>2]=g,I=l[e+20|0]|l[e+21|0]<<8|(l[e+22|0]<<16|l[e+23|0]<<24),i[A+108>>2]=I,C=l[e+24|0]|l[e+25|0]<<8|(l[e+26|0]<<16|l[e+27|0]<<24),i[A+112>>2]=C,V=l[e+28|0]|l[e+29|0]<<8|(l[e+30|0]<<16|l[e+31|0]<<24),i[A+116>>2]=V,y=l[e+32|0]|l[e+33|0]<<8|(l[e+34|0]<<16|l[e+35|0]<<24),i[A+120>>2]=y,R=l[e+36|0]|l[e+37|0]<<8|(l[e+38|0]<<16|l[e+39|0]<<24),i[A+124>>2]=R,N=l[e+40|0]|l[e+41|0]<<8|(l[e+42|0]<<16|l[e+43|0]<<24),i[A+128>>2]=N,D=l[e+44|0]|l[e+45|0]<<8|(l[e+46|0]<<16|l[e+47|0]<<24),i[A+132>>2]=D,x=l[e+48|0]|l[e+49|0]<<8|(l[e+50|0]<<16|l[e+51|0]<<24),i[A+136>>2]=x,S=l[e+52|0]|l[e+53|0]<<8|(l[e+54|0]<<16|l[e+55|0]<<24),i[A+140>>2]=S,O=l[e+56|0]|l[e+57|0]<<8|(l[e+58|0]<<16|l[e+59|0]<<24),i[A+144>>2]=O,L=l[e+60|0]|l[e+61|0]<<8|(l[e+62|0]<<16|l[e+63|0]<<24),i[A+148>>2]=L,f=k2(((((h^_)&w^_)+a|0)+s|0)-680876936|0,7)+w|0,k=k2(((_+B|0)+(f&(w^h)^h)|0)-389564586|0,12)+f|0,n=k2(((h+m|0)+(k&(f^w)^w)|0)+606105819|0,17)+k|0,t=k2(((w+W|0)+(f^n&(f^k))|0)-1044525330|0,22)+n|0,f=k2(((f+g|0)+(k^t&(k^n))|0)-176418897|0,7)+t|0,k=k2(((k+I|0)+(n^f&(t^n))|0)+1200080426|0,12)+f|0,n=k2(((n+C|0)+(t^k&(f^t))|0)-1473231341|0,17)+k|0,t=k2(((t+V|0)+(f^n&(f^k))|0)-45705983|0,22)+n|0,f=k2(((f+y|0)+(k^t&(k^n))|0)+1770035416|0,7)+t|0,k=k2(((k+R|0)+(n^f&(t^n))|0)-1958414417|0,12)+f|0,n=k2(((n+N|0)+(t^k&(f^t))|0)-42063|0,17)+k|0,t=k2(((t+D|0)+(f^n&(f^k))|0)-1990404162|0,22)+n|0,o=k+S|0,k=k2(((f+x|0)+(k^t&(k^n))|0)+1804603682|0,7)+t|0,o=k2((o+(n^k&(t^n))|0)-40341101|0,12)+k|0,f=t+L|0,t=k2(((n+O|0)+(t^o&(k^t))|0)-1502002290|0,17)+o|0,f=k2((f+(k^t&(k^o))|0)+1236535329|0,22)+t|0,k=k2(((k+B|0)+(t^o&(f^t))|0)-165796510|0,5)+f|0,n=k2(((o+C|0)+((f^k)&t^f)|0)-1069501632|0,9)+k|0,t=k2(((t+D|0)+(k^f&(k^n))|0)+643717713|0,14)+n|0,f=k2(((f+s|0)+(n^k&(t^n))|0)-373897302|0,20)+t|0,k=k2(((k+I|0)+(t^n&(f^t))|0)-701558691|0,5)+f|0,n=k2(((n+N|0)+((f^k)&t^f)|0)+38016083|0,9)+k|0,t=k2(((t+L|0)+(k^f&(k^n))|0)-660478335|0,14)+n|0,f=k2(((f+g|0)+(n^k&(t^n))|0)-405537848|0,20)+t|0,k=k2(((k+R|0)+(t^n&(f^t))|0)+568446438|0,5)+f|0,n=k2(((n+O|0)+((f^k)&t^f)|0)-1019803690|0,9)+k|0,t=k2(((t+W|0)+(k^f&(k^n))|0)-187363961|0,14)+n|0,f=k2(((f+y|0)+(n^k&(t^n))|0)+1163531501|0,20)+t|0,k=k2(((k+S|0)+(t^n&(f^t))|0)-1444681467|0,5)+f|0,n=k2(((n+m|0)+((f^k)&t^f)|0)-51403784|0,9)+k|0,$=f+x|0,o=k2(((t+V|0)+(k^f&(k^n))|0)+1735328473|0,14)+n|0,f=o^n,t=k2(($+(n^k&f)|0)-1926607734|0,20)+o|0,f=k2(((k+I|0)+(f^t)|0)-378558|0,4)+t|0,k=k2(((n+y|0)+(f^(t^o))|0)-2022574463|0,11)+f|0,n=k2(((o+D|0)+(k^(f^t))|0)+1839030562|0,16)+k|0,t=k2(((t+O|0)+(n^(f^k))|0)-35309556|0,23)+n|0,f=k2(((f+B|0)+(t^(k^n))|0)-1530992060|0,4)+t|0,k=k2(((k+g|0)+(f^(t^n))|0)+1272893353|0,11)+f|0,n=k2(((n+V|0)+(k^(f^t))|0)-155497632|0,16)+k|0,t=k2(((t+N|0)+(n^(f^k))|0)-1094730640|0,23)+n|0,f=k2(((f+S|0)+(t^(k^n))|0)+681279174|0,4)+t|0,k=k2(((k+s|0)+(f^(t^n))|0)-358537222|0,11)+f|0,n=k2(((n+W|0)+(k^(f^t))|0)-722521979|0,16)+k|0,t=k2(((t+C|0)+(n^(f^k))|0)+76029189|0,23)+n|0,f=k2(((f+R|0)+(t^(k^n))|0)-640364487|0,4)+t|0,k=k2(((k+x|0)+(f^(t^n))|0)-421815835|0,11)+f|0,o=f+s|0,s=f^k,f=k2(((n+L|0)+(k^(f^t))|0)+530742520|0,16)+k|0,n=k2(((t+m|0)+(s^f)|0)-995338651|0,23)+f|0,t=k2((o+((n|k^-1)^f)|0)-198630844|0,6)+n|0,o=n+I|0,s=f+O|0,f=k2(((k+V|0)+(n^(t|f^-1))|0)+1126891415|0,10)+t|0,n=k2((s+(t^(f|n^-1))|0)-1416354905|0,15)+f|0,k=k2((o+((n|t^-1)^f)|0)-57434055|0,21)+n|0,o=n+N|0,s=f+W|0,f=k2(((t+x|0)+(n^(k|f^-1))|0)+1700485571|0,6)+k|0,n=k2((s+(k^(f|n^-1))|0)-1894986606|0,10)+f|0,t=k2((o+((n|k^-1)^f)|0)-1051523|0,15)+n|0,o=n+L|0,s=f+y|0,f=k2(((k+B|0)+(n^(t|f^-1))|0)-2054922799|0,21)+t|0,n=k2((s+(t^(f|n^-1))|0)+1873313359|0,6)+f|0,k=k2((o+((n|t^-1)^f)|0)-30611744|0,10)+n|0,o=n+g|0,s=f+S|0,f=k2(((t+C|0)+(n^(k|f^-1))|0)-1560198380|0,15)+k|0,n=k2((s+(k^(f|n^-1))|0)+1309151649|0,21)+f|0,t=k2((o+((n|k^-1)^f)|0)-145523070|0,6)+n|0,k=k2(((k+D|0)+(n^(t|f^-1))|0)-1120210379|0,10)+t|0,f=k2(((f+m|0)+(t^(k|n^-1))|0)+718787259|0,15)+k|0,w=(f+w|0)+k2(((n+R|0)+(k^(f|t^-1))|0)-343485551|0,21)|0,h=f+h|0,_=k+_|0,a=t+a|0,e=e- -64|0,r=r+-64|0,!!r;);return i[A+20>>2]=_,i[A+16>>2]=h,i[A+12>>2]=w,i[A+8>>2]=a,e}function r9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,f=i[i[e+104>>2]-8>>2],X[i[i[f>>2]+12>>2]](k+104|0,f),f=i[k+104>>2],X[i[i[f>>2]+28>>2]](k+56|0,f);i:{e:{if(!l[k+100|0]){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}if(o=i[k+68>>2],f=i[k+72>>2],!((o|0)!=(f|0)|i[k+56>>2]!=i[k+60>>2])){u[A+20|0]=0,u[A|0]=0;break e}if(!l[e+300|0]){if(f=i[k+104>>2],X[i[i[f>>2]+32>>2]](k+48|0,f,k+56|0),f=i[k+48>>2],f){Q[f+116>>1]=F[e+288>>1],Q[f+118>>1]=F[e+290>>1],t=E(128),i[t>>2]=93652,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,f=o,i[f+8>>2]=0,i[f+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86404,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,Q[t+112>>1]=0,i[t+16>>2]=105388,i[t+32>>2]=1667462004,Q[t+120>>1]=F[k+80>>1],u[t+122|0]=l[k+82|0],f=i[k+48>>2],i[k+20>>2]=t,i[k+16>>2]=o,i[t+4>>2]=i[t+4>>2]+1,r2(f+36|0,k+16|0),o=i[k+20>>2];r:{if(!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break r;X[i[i[o>>2]+8>>2]](o),p(o)}f=i[t+4>>2],i[t+4>>2]=f-1,f||(X[i[i[t>>2]+8>>2]](t),p(t));r:{if(i[e+292>>2]!=2)break r;if(n=E(136),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=93692,t=n+16|0,f=t,i[f+8>>2]=0,i[f+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,Q[n+112>>1]=0,i[n+16>>2]=105468,i[n+128>>2]=0,i[n+120>>2]=0,i[n+124>>2]=0,i[n+32>>2]=1635088489,r=i[i[r>>2]+4>>2],o=(r|0)==1?21802:(r|0)==2?21829:19037,s=h2(o),s>>>0>=2147483640)break i;f:{A:{if(s>>>0>=11){f=s|7,r=E(f+1|0),i[k+24>>2]=f-2147483647,i[k+16>>2]=r,i[k+20>>2]=s;break A}if(u[k+27|0]=s,r=k+16|0,!s)break f}if(!s)break f;z(r,o,s)}o=n+120|0,u[r+s|0]=0,f=u[k+27|0];f:{A:{if(u[n+131|0]>=0){if((f|0)>=0){r=i[k+20>>2],i[o>>2]=i[k+16>>2],i[o+4>>2]=r,i[o+8>>2]=i[k+24>>2];break f}D1(o,i[k+16>>2],i[k+20>>2]);break A}r=(f|0)<0,O1(o,r?i[k+16>>2]:k+16|0,r?i[k+20>>2]:f)}if(u[k+27|0]>=0)break f;Z(i[k+16>>2])}r=i[k+48>>2],i[k+20>>2]=n,i[k+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,r2(r+36|0,k+16|0),f=i[k+20>>2];f:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=i[n+4>>2],i[n+4>>2]=r-1,r)break r;X[i[i[n>>2]+8>>2]](n),p(n)}i[k+40>>2]=i[k+48>>2],r=i[k+52>>2],i[k+44>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[k+44>>2],i[k+8>>2]=i[k+40>>2],i[k+12>>2]=r,Zn(e,k+8|0),u[e+300|0]=1}f=i[k+52>>2];r:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break r;X[i[i[f>>2]+8>>2]](f),p(f)}o=i[k+68>>2],f=i[k+72>>2]}r:{if((f|0)==(o|0))break r;t=k+68|0,s=i[k+96>>2],i[k+48>>2]=s,n=e+304|0,f=i[e+308>>2];f:{A:{if(!f){r=e+308|0,o=r;break A}for(;;){if(o=f,r=i[f+16>>2],r>>>0>s>>>0){if(r=f,f=i[f>>2],f)continue;break A}if(r>>>0>=s>>>0)break f;if(f=i[o+4>>2],!f)break}r=o+4|0}f=E(44),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=s,i[f+8>>2]=o,i[f>>2]=0,i[f+4>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[r>>2]=f,r=i[i[n>>2]>>2],r&&(i[n>>2]=r),m1(i[e+308>>2],f),i[e+312>>2]=i[e+312>>2]+1}if($7(k+16|0,e,t,i[f+20>>2],G(i[e+316>>2],s-i[i[e+228>>2]+108>>2]|0),l[k+92|0],i[f+40>>2],f+24|0),z2(i[f+40>>2]),i[f+40>>2]=0,f=i[n+4>>2],f){for(s=i[k+48>>2],t=n+4|0,o=t,r=f;e=s>>>0>u0[r+16>>2],o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(!((t|0)==(o|0)|s>>>0<u0[o+16>>2])){e=i[o+4>>2];f:{if(!e){for(e=o;r=i[e+8>>2],t=i[r>>2]!=(e|0),e=r,!!t;);break f}for(;r=e,e=i[r>>2],!!e;);}i[n>>2]==(o|0)&&(i[n>>2]=r),i[n+8>>2]=i[n+8>>2]-1,pf(f,o),l[o+36|0]!=1|u[o+35|0]>=0||Z(i[o+24>>2]),Z(o)}}if(i[k+16>>2]){if(e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,r=A+8|0,u[k+35|0]>=0){e=i[k+28>>2],i[r>>2]=i[k+24>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+32>>2],u[A+20|0]=1;break e}if(T(r,i[k+24>>2],i[k+28>>2]),e=u[k+35|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[k+24>>2]);break e}if(u[k+35|0]>=0)break r;Z(i[k+24>>2])}u[A+20|0]=0,u[A|0]=1}e:{if(l[k+100|0]!=1||(A=i[k+68>>2],A&&(i[k+72>>2]=A,Z(A)),A=i[k+56>>2],!A))break e;if(o=i[k+60>>2],f=A,(o|0)!=(f|0)){for(;;){r=i[o-4>>2];r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=o-8|0,(A|0)==(o|0))break}f=i[k+56>>2]}i[k+60>>2]=A,Z(f)}e=i[k+108>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}v=k+112|0;return}g0(),H()}function $B(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n,f=v-224|0,v=f,r=i[e+100>>2],k=i[r+48>>2],o=i[r+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),t=n+8|0,a6(f+200|0,k,i[e+116>>2]);i:{e:switch(l[f+220|0]){default:_2(),H();case 1:if(e=i[f+204>>2],i[t>>2]=i[f+200>>2],i[t+4>>2]=e,r=t+8|0,u[f+219|0]>=0){e=i[f+212>>2],i[r>>2]=i[f+208>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+216>>2];break i}T(r,i[f+208>>2],i[f+212>>2]);break i;case 0:break e}w9(f+176|0,e+448|0,f+200|0);e:{if(i[f+176>>2]){e=i[f+180>>2],i[t>>2]=i[f+176>>2],i[t+4>>2]=e,i[t+16>>2]=i[f+192>>2],e=i[f+188>>2],i[t+8>>2]=i[f+184>>2],i[t+12>>2]=e,i[f+192>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0;break e}r=i[k+84>>2],s=i[k+88>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);r:{if(!r){if(k=E(56),i[f+24>>2]=k,i[f+28>>2]=48,i[f+32>>2]=-2147483592,r=l[14895]|l[14896]<<8|(l[14897]<<16|l[14898]<<24),e=l[14891]|l[14892]<<8|(l[14893]<<16|l[14894]<<24),u[k|0]=e,u[k+1|0]=e>>>8,u[k+2|0]=e>>>16,u[k+3|0]=e>>>24,u[k+4|0]=r,u[k+5|0]=r>>>8,u[k+6|0]=r>>>16,u[k+7|0]=r>>>24,u[k+48|0]=0,r=l[14935]|l[14936]<<8|(l[14937]<<16|l[14938]<<24),e=l[14931]|l[14932]<<8|(l[14933]<<16|l[14934]<<24),u[k+40|0]=e,u[k+41|0]=e>>>8,u[k+42|0]=e>>>16,u[k+43|0]=e>>>24,u[k+44|0]=r,u[k+45|0]=r>>>8,u[k+46|0]=r>>>16,u[k+47|0]=r>>>24,r=l[14927]|l[14928]<<8|(l[14929]<<16|l[14930]<<24),e=l[14923]|l[14924]<<8|(l[14925]<<16|l[14926]<<24),u[k+32|0]=e,u[k+33|0]=e>>>8,u[k+34|0]=e>>>16,u[k+35|0]=e>>>24,u[k+36|0]=r,u[k+37|0]=r>>>8,u[k+38|0]=r>>>16,u[k+39|0]=r>>>24,r=l[14919]|l[14920]<<8|(l[14921]<<16|l[14922]<<24),e=l[14915]|l[14916]<<8|(l[14917]<<16|l[14918]<<24),u[k+24|0]=e,u[k+25|0]=e>>>8,u[k+26|0]=e>>>16,u[k+27|0]=e>>>24,u[k+28|0]=r,u[k+29|0]=r>>>8,u[k+30|0]=r>>>16,u[k+31|0]=r>>>24,r=l[14911]|l[14912]<<8|(l[14913]<<16|l[14914]<<24),e=l[14907]|l[14908]<<8|(l[14909]<<16|l[14910]<<24),u[k+16|0]=e,u[k+17|0]=e>>>8,u[k+18|0]=e>>>16,u[k+19|0]=e>>>24,u[k+20|0]=r,u[k+21|0]=r>>>8,u[k+22|0]=r>>>16,u[k+23|0]=r>>>24,r=l[14903]|l[14904]<<8|(l[14905]<<16|l[14906]<<24),e=l[14899]|l[14900]<<8|(l[14901]<<16|l[14902]<<24),u[k+8|0]=e,u[k+9|0]=e>>>8,u[k+10|0]=e>>>16,u[k+11|0]=e>>>24,u[k+12|0]=r,u[k+13|0]=r>>>8,u[k+14|0]=r>>>16,u[k+15|0]=r>>>24,K(t,2,113,f+24|0),u[f+35|0]>=0)break r;Z(i[f+24>>2]);break r}L8(f+24|0,r,i[e+116>>2],1684630887),r=i[e+460>>2],r&&(i[e+464>>2]=r,Z(r)),k=i[f+24>>2],i[e+460>>2]=k,r=i[f+28>>2],i[e+464>>2]=r,i[e+468>>2]=i[f+32>>2];f:{A:{k:{if((G(F[e+450>>1],F[e+448>>1])|0)!=r-k>>2){i[f+116>>2]=0,i[f+88>>2]=72244,i[f+32>>2]=72224,r=i[18065],i[f+24>>2]=r,w=f+24|0,i[w+i[r-12>>2]>>2]=i[18066],i[f+28>>2]=0,r=w+i[i[f+24>>2]-12>>2]|0,h=f+36|0,J0(r,h),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[f+32>>2]=r,k=f+32|0,i[k+i[r-12>>2]>>2]=i[18068],r=i[18064],i[f+24>>2]=r,i[w+i[r-12>>2]>>2]=i[18069],i[f+88>>2]=72244,i[f+24>>2]=72204,i[f+32>>2]=72224,h=R0(h),i[h>>2]=71280,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=24,Y(I0(Y(S0(Y(I0(Y(I0(Y(k,28401,17),F[e+448>>1]),2998,1),F[e+450>>1]),21061,1),G(F[e+450>>1],F[e+448>>1])),27499,17),i[e+464>>2]-i[e+460>>2]>>2),13313,20),e=i[f+84>>2];n:{if(e&16){e=i[f+80>>2],r=i[f+60>>2],e>>>0<r>>>0&&(i[f+80>>2]=r,e=r),r=f+56|0;break n}if(!(e&8)){e=0,u[f+23|0]=0,w=f+12|0;break f}e=i[f+52>>2],r=f+44|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break k;if(e>>>0>=11){r=e|7,w=E(r+1|0),i[f+20>>2]=r-2147483647,i[f+12>>2]=w,i[f+16>>2]=e;break A}if(u[f+23|0]=e,w=f+12|0,e)break A;e=0;break f}if(e=i[26929],i[t>>2]=i[26928],i[t+4>>2]=e,r=t+8|0,u[107731]>=0){e=i[26931],i[r>>2]=i[26930],i[r+4>>2]=e,i[r+8>>2]=i[26932];break r}T(r,i[26930],i[26931]);break r}g0(),H()}if(!e)break f;z(w,k,e)}u[e+w|0]=0,K(t,2,119,f+12|0),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[18063],i[f+24>>2]=e,i[i[e-12>>2]+(f+24|0)>>2]=i[18071],i[f+32>>2]=i[18072],i[h>>2]=71280,u[f+79|0]<0&&Z(i[f+68>>2]),y0(h),p0(f+88|0)}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break e;X[i[i[s>>2]+8>>2]](s),p(s)}if(u[f+195|0]>=0)break i;Z(i[f+184>>2])}r=l[f+220|0],(r|0)!=255&&(e=i[25341],i[f+24>>2]=i[25340],i[f+28>>2]=e,X[i[(f+24|0)+(r<<2)>>2]](f+176|0,f+200|0));i:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=f+224|0,r=A+8|0;i:{if(i[n+8>>2]){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+24>>2],A=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=A,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0;break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[r>>2]=i[26930],i[r+4>>2]=A,i[r+8>>2]=i[26932];break i}T(r,i[26930],i[26931])}u[n+27|0]<0&&Z(i[n+16>>2]),v=n+32|0}function Wf(A,e,r){var f=0,k=0;i:{e:switch(r-1|0){case 2:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100784,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=98368,i[e+456>>2]=0,i[e+460>>2]=0,e=E(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=98512,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98704,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 0:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100824,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=97368,i[e+456>>2]=0,i[e+460>>2]=0,e=E(92),i[e>>2]=97512,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=97760,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 3:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100864,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=97824,i[e+456>>2]=0,i[e+460>>2]=0,e=E(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=97968,i[e+4>>2]=0,i[e+8>>2]=0,u[e+19|0]=0,u[e+20|0]=0,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+18|0]=1,Q[e+16>>1]=0,i[e+12>>2]=98008,u[e+27|0]=0,u[e+28|0]=0,u[e+29|0]=0,u[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 4:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100904,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=99544,i[e+456>>2]=0,i[e+460>>2]=0,e=E(92),i[e>>2]=99688,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=99792,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 1:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100944,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=99976,i[e+456>>2]=0,i[e+460>>2]=0,e=E(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e>>2]=100120,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=100304,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+27|0]=0,u[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,u[e+40|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 6:case 9:f=E(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100984,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=98768,i[e+456>>2]=0,i[e+460>>2]=0,e=E(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=98912,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=99024,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 8:break e;default:break i}f=E(464),u[f+96|0]=0,u[f+84|0]=0,i[f+80>>2]=0,u[f+76|0]=0,u[f+52|0]=0,i[f+48>>2]=0,i[f+40>>2]=1,i[f+44>>2]=1,i[f+32>>2]=0,i[f+36>>2]=0,u[f+28|0]=1,Q[f+26>>1]=2,Q[f+22>>1]=2,Q[f+24>>1]=2,u[f+20|0]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+112>>2]=4740,i[f+116>>2]=e,u[f+248|0]=0,i[f>>2]=101024,i[f+108>>2]=0,Q[f+144>>1]=0,i[f+136>>2]=0,i[f+140>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,Q[f+154>>1]=0,Q[f+156>>1]=0,Q[f+158>>1]=0,Q[f+160>>1]=0,i[f+164>>2]=0,i[f+168>>2]=0,u[f+172|0]=0,i[f+176>>2]=0,i[f+180>>2]=0,u[f+184|0]=0,i[f+252>>2]=0,i[f+256>>2]=0,i[f+260>>2]=0,i[f+264>>2]=0,i[f+268>>2]=0,i[f+272>>2]=0,i[f+276>>2]=0,i[f+280>>2]=0,i[f+284>>2]=0,u[f+288|0]=1,i[f+360>>2]=0,i[f+364>>2]=0,i[f+368>>2]=0,u[f+297|0]=0,u[f+298|0]=0,u[f+299|0]=0,u[f+300|0]=0,u[f+301|0]=0,u[f+302|0]=0,u[f+303|0]=0,u[f+304|0]=0,i[f+292>>2]=0,i[f+296>>2]=0,u[f+352|0]=0,i[f+344>>2]=0,i[f+348>>2]=0,i[f+336>>2]=0,i[f+340>>2]=0,i[f+328>>2]=0,i[f+332>>2]=0,i[f+320>>2]=0,i[f+324>>2]=0,i[f+312>>2]=0,i[f+316>>2]=0,i[f+392>>2]=0,i[f+396>>2]=0,Q[f+372>>1]=1,i[f+384>>2]=0,i[f+388>>2]=0,i[f+376>>2]=0,i[f+380>>2]=0,i[f+400>>2]=0,i[f+404>>2]=1072693248,i[f+192>>2]=0,i[f+196>>2]=0,i[f+200>>2]=0,i[f+204>>2]=0,i[f+208>>2]=0,i[f+212>>2]=0,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,i[f+432>>2]=0,i[f+424>>2]=0,i[f+428>>2]=0,i[f+416>>2]=0,i[f+420>>2]=0,i[f+408>>2]=0,i[f+412>>2]=0,i[f+456>>2]=0,i[f+460>>2]=0,i[f+448>>2]=0,i[f+452>>2]=0,i[f+440>>2]=0,i[f+444>>2]=0,i[f+16>>2]=100440,k=f+16|0}i[A+4>>2]=f,i[A>>2]=k}function f9(){var A=0,e=0;B1(8642,1,96284,51625,880,881,0,0),B1(1580,3,96296,51672,882,883,0,0),B1(12433,2,96340,51700,884,885,0,0),B1(6235,2,96356,51723,886,887,0,0),B1(13516,3,96372,51727,888,889,0,0),B1(13445,2,96356,51723,886,890,0,0),B1(21480,4,96416,51805,891,892,0,0),B1(7505,1,96496,51917,893,894,0,0),B1(17936,1,96500,51625,895,896,0,0),B1(15084,2,96504,51920,897,898,0,0),B1(5601,2,96512,51700,899,900,0,0),B1(12206,2,96520,51920,901,902,0,0),B1(10811,2,96544,51700,903,904,0,0),B1(4039,2,96544,51700,903,905,0,0),B1(14199,2,96544,51700,903,906,0,0),B1(12232,2,96552,51920,907,908,0,0),B1(9991,2,96544,51700,903,909,0,0),B1(18996,2,96544,51700,903,910,0,0),B1(6153,2,96356,51723,886,911,0,0),B1(12522,3,96576,51727,912,913,0,0),B1(12485,3,96576,51727,912,914,0,0),B1(11194,3,96576,51727,912,915,0,0),B1(12583,3,96576,51727,912,916,0,0),B1(13050,3,96576,51727,912,917,0,0),B1(5e3,2,96604,51700,918,919,0,0),B1(9311,3,96612,51978,920,921,0,0),B1(12410,2,96340,51700,884,885,0,0),B1(6187,2,96356,51723,886,887,0,0),B1(13483,3,96372,51727,888,889,0,0),B1(13404,2,96356,51723,886,890,0,0),M8(96624,15153,4,0),Y0(96624,10517,0),Y0(96624,3351,1),Y0(96624,3182,2),Y0(96624,6541,11),Y0(96624,12453,3),Y0(96624,12359,4),Y0(96624,6584,5),Y0(96624,6381,6),Y0(96624,6448,7),Y0(96624,6416,8),Y0(96624,6480,9),Y0(96624,15199,13),Y0(96624,3383,10),Y0(96624,17105,12),M8(96632,15134,4,0),Y0(96632,17208,0),Y0(96632,18494,5e3),Y0(96632,6334,1001),Y0(96632,18652,150),Y0(96632,8243,5001),Y0(96632,11235,5002),Y0(96632,7798,5003),Y0(96632,4922,5004),Y0(96632,18594,100),Y0(96632,11388,101),Y0(96632,1878,102),Y0(96632,1800,103),Y0(96632,2148,104),Y0(96632,1774,151),Y0(96632,1826,105),Y0(96632,2226,106),Y0(96632,2200,141),Y0(96632,1956,107),Y0(96632,1930,108),Y0(96632,2174,109),Y0(96632,2122,110),Y0(96632,2044,111),Y0(96632,1904,112),Y0(96632,2070,113),Y0(96632,7097,114),Y0(96632,1154,115),Y0(96632,9484,116),Y0(96632,18567,117),Y0(96632,18620,118),Y0(96632,5645,119),Y0(96632,2278,131),Y0(96632,2252,143),Y0(96632,2013,149),Y0(96632,12251,120),Y0(96632,18459,121),Y0(96632,6058,122),Y0(96632,17420,6001),Y0(96632,6506,6e3),Y0(96632,17125,123),Y0(96632,1537,6002),Y0(96632,16997,6003),Y0(96632,9443,124),Y0(96632,2096,125),Y0(96632,17234,1e3),Y0(96632,12615,126),Y0(96632,4269,127),Y0(96632,7529,128),Y0(96632,11419,129),Y0(96632,17529,2e3),Y0(96632,3730,2001),Y0(96632,17571,2002),Y0(96632,8700,2003),Y0(96632,8659,2004),Y0(96632,6917,2005),Y0(96632,11890,2006),Y0(96632,1240,2007),Y0(96632,13564,2008),Y0(96632,1982,130),Y0(96632,18533,136),Y0(96632,18076,3e3),Y0(96632,12656,3001),Y0(96632,8741,3002),Y0(96632,15675,3006),Y0(96632,1109,3007),Y0(96632,8570,3003),Y0(96632,15572,3004),Y0(96632,15623,3005),Y0(96632,10573,4e3),Y0(96632,12546,3008),Y0(96632,10609,132),Y0(96632,5513,133),Y0(96632,5968,134),Y0(96632,4538,135),Y0(96632,1209,137),Y0(96632,16806,138),Y0(96632,16758,139),Y0(96632,9743,140),Y0(96632,1852,142),M8(96640,4245,4,0),Y0(96640,16854,0),Y0(96640,20012,1),Y0(96640,20034,2),Y0(96640,19643,3),Y0(96640,21742,4),Y0(96640,19970,5),Y0(96640,19991,6),Y0(96640,22068,7),Y0(96640,16695,8),Y0(96640,10156,9),Y0(96640,19579,10),M8(96440,18968,4,0),Y0(96440,16907,99),Y0(96440,13027,0),Y0(96440,22037,1),Y0(96440,21601,2),Y0(96440,21381,3),Y0(96440,20132,10),Y0(96440,20160,11),Y0(96440,19775,12),Y0(96440,19809,13),Y0(96440,19705,14),Y0(96440,19739,15),Y0(96440,3979,10),Y0(96440,4009,11),M8(96648,9408,4,0),Y0(96648,14166,2),Y0(96648,6836,1),Y0(96648,3059,3),M8(96656,9375,4,0),Y0(96656,7672,2),Y0(96656,6796,1),M8(96432,15520,4,0),Y0(96432,16881,99),Y0(96432,7724,0),Y0(96432,20112,1),Y0(96432,13e3,2),Y0(96432,10094,3),M8(96472,9978,4,0),Y0(96472,19218,0),Y0(96472,7746,2),Y0(96472,18379,1),Y0(96472,19396,3),Y0(96472,19623,4),Y0(96472,20064,5),Y0(96472,19081,6),Y0(96472,15956,10),Y0(96472,1670,11),Y0(96472,10652,12),Y0(96472,1467,13),M8(96348,3823,4,0),Y0(96348,7937,0),Y0(96348,16011,1),Y0(96348,15981,2),Y0(96348,15547,3),uf(96332,96316,96588,0,51625,922,52120,0,52120,0,3102,52122,923),uf(96400,96384,96528,0,51625,924,52120,0,52120,0,13546,52122,925),uf(96464,96448,96560,0,51625,926,52120,0,52120,0,14260,52122,927),Q_(96308,6573,52125,928,52122,929),A=E(4),i[A>>2]=0,e=E(4),i[e>>2]=0,tf(96308,15164,96624,51700,930,A|0,96624,52127,931,e|0),A=E(4),i[A>>2]=4,e=E(4),i[e>>2]=4,tf(96308,15126,96632,51700,932,A|0,96632,52127,933,e|0),A=E(4),i[A>>2]=934,e=E(4),i[e>>2]=935,tf(96308,14158,96288,51723,936,A|0,96288,52132,937,e|0),g_(96308)}function dB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;h=v-48|0,v=h,t=i[e>>2],_=i[e+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{if(!i[t+84>>2]&u0[t+80>>2]<=u0[t+92>>2]){i[A>>2]=13,i[A+4>>2]=0,i[A+8>>2]=15286;break i}s=h+12|0,k=v-144|0,v=k,f=i[t+92>>2];e:{if(!i[t+84>>2]&f>>>0>=u0[t+80>>2]){f=E(16),i[k>>2]=f,i[k+4>>2]=15,i[k+8>>2]=-2147483632,n=l[15297]|l[15298]<<8|(l[15299]<<16|l[15300]<<24),t=l[15293]|l[15294]<<8|(l[15295]<<16|l[15296]<<24),u[f+7|0]=t,u[f+8|0]=t>>>8,u[f+9|0]=t>>>16,u[f+10|0]=t>>>24,u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,n=l[15290]|l[15291]<<8|(l[15292]<<16|l[15293]<<24),t=l[15286]|l[15287]<<8|(l[15288]<<16|l[15289]<<24),u[f|0]=t,u[f+1|0]=t>>>8,u[f+2|0]=t>>>16,u[f+3|0]=t>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+15|0]=0,f=K(k+80|0,13,0,k),n=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=n,n=s+8|0;r:{if(u[f+19|0]>=0){t=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=t,i[n+8>>2]=i[f+16>>2],u[s+20|0]=1;break r}if(T(n,i[f+8>>2],i[f+12>>2]),n=u[f+19|0],u[s+20|0]=1,(n|0)>=0)break r;Z(i[f+8>>2])}if(u[k+11|0]>=0)break e;Z(i[k>>2]);break e}n=f,f=i[t+68>>2],f=G((n>>>0)%((i[t+72>>2]-f|0)/48>>>0)|0,48)+f|0,w=i[f>>2],n=k+80|0,kt(n,i[i[t+100>>2]+(i[f+8>>2]<<3)>>2],w),fA(k+56|0,n);r:{f:{A:{k:{n:switch(l[k+76|0]){case 1:f=i[k+60>>2],i[s>>2]=i[k+56>>2],i[s+4>>2]=f,f=s+8|0;t:{if(u[k+75|0]>=0){n=k- -64|0,t=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=t,i[f+8>>2]=i[n+8>>2];break t}T(f,i[k+64>>2],i[k+68>>2])}u[s+20|0]=1;break r;case 0:break n;default:break k}n=E(32),f=n,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,o=i[k+56>>2],(o|0)!=(f|0)&&(f=i[o>>2],o=i[o+4>>2],d4(n,f,o,o-f|0)),f=i[t+204>>2],f&&(o=i[f+108>>2],f=i[f+104>>2],(o|0)==(f|0)?f=0:f=i[f+4>>2],i[n+12>>2]=f),o=i[t+276>>2];n:{if(!o)break n;f=i[t+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){ri(k,o,B,w);break t}if(i[f+4>>2]=i[f+4>>2]+1,ri(k,o,B,w),o=i[f+4>>2],i[f+4>>2]=o-1,o)break t;X[i[i[f>>2]+8>>2]](f),p(f)}t:switch(l[k+20|0]){case 1:f=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=f,f=s+8|0;u:{if(u[k+19|0]>=0){n=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+16>>2],f=1;break u}T(f,i[k+8>>2],i[k+12>>2]),f=l[k+20|0]}u[s+20|0]=1;break f;case 0:break t;default:break k}t:{if(i[k>>2]==i[k+4>>2]){f=0;break t}f=k+32|0,Vf(f,k),o=l[k+52|0];u:{if(o){if((o|0)!=1)break k;U6(s,f);break u}Co(n+20|0,k+32|0)}if(f=l[k+52|0],(f|0)!=255&&(B=i[26661],i[k+136>>2]=i[26660],i[k+140>>2]=B,X[i[(k+136|0)+(f<<2)>>2]](k+135|0,k+32|0)),f=l[k+20|0],o)break f;if((f|0)==255)break n}o=i[26663],i[k+32>>2]=i[26662],i[k+36>>2]=o,X[i[(k+32|0)+(f<<2)>>2]](k+136|0,k)}o=i[t+272>>2];n:{if(!o)break n;f=i[t+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){ri(k+32|0,o,B,w);break t}if(i[f+4>>2]=i[f+4>>2]+1,ri(k+32|0,o,B,w),w=i[f+4>>2],i[f+4>>2]=w-1,w)break t;X[i[i[f>>2]+8>>2]](f),p(f)}t:switch(l[k+52|0]){case 1:f=i[k+36>>2],i[s>>2]=i[k+32>>2],i[s+4>>2]=f,f=s+8|0;u:{if(u[k+51|0]>=0){n=i[k+44>>2],i[f>>2]=i[k+40>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+48>>2],f=1;break u}T(f,i[k+40>>2],i[k+44>>2]),f=l[k+52|0]}u[s+20|0]=1;break A;case 0:break t;default:break k}t:{if(i[k+32>>2]==i[k+36>>2]){f=0;break t}d9(k,k+32|0),w=l[k+24|0];u:{if(w){if((w|0)!=1)break k;U6(s,k);break u}if(f=pe(),i[n+16>>2]=f,l[k+24|0])break k;gi(f,k)}if(f=l[k+24|0],(f|0)!=255&&(o=i[26665],i[k+136>>2]=i[26664],i[k+140>>2]=o,X[i[(k+136|0)+(f<<2)>>2]](k+135|0,k)),f=l[k+52|0],w)break A;if((f|0)==255)break n}w=i[26663],i[k>>2]=i[26662],i[k+4>>2]=w,X[i[(f<<2)+k>>2]](k+136|0,k+32|0)}i[t+92>>2]=i[t+92>>2]+1,u[s+20|0]=0,i[s>>2]=n;break r}_2(),H()}if((f|0)==255)break r;n=i[26663],i[k>>2]=i[26662],i[k+4>>2]=n,X[i[(f<<2)+k>>2]](k+136|0,k+32|0);break r}if((f|0)==255)break r;n=i[26663],i[k+32>>2]=i[26662],i[k+36>>2]=n,X[i[(k+32|0)+(f<<2)>>2]](k+136|0,k)}if(f=l[k+76|0],(f|0)!=255&&(n=i[26667],i[k>>2]=i[26666],i[k+4>>2]=n,X[i[(f<<2)+k>>2]](k+32|0,k+56|0)),f=i[k+92>>2],f&&(i[k+96>>2]=f,Z(f)),f=i[k+84>>2],!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break e;X[i[i[f>>2]+8>>2]](f),p(f)}v=k+144|0;e:{r:switch(l[h+32|0]){default:_2(),H();case 0:i[r>>2]=i[h+12>>2],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;break e;case 1:break r}if(b0(A,h+12|0,i[e+8>>2]),m=l[h+32|0],(m|0)==255)break i}A=i[24207],i[h+40>>2]=i[24206],i[h+44>>2]=A,X[i[(h+40|0)+(m<<2)>>2]](h+39|0,h+12|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;X[i[i[_>>2]+8>>2]](_),p(_)}v=h+48|0}function A9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;if(t=v-144|0,v=t,jf(t+132|0,e,r),e=i[t+132>>2],s=ei(t+96|0,e,i[t+136>>2]-e|0),I2(s,8),u[f|0]=1,C=f,V=V1(s,8),u[C+1|0]=V,C=f,V=V1(s,8),u[C+2|0]=V,e=V1(s,8),u[f+4|0]=4,u[f+3|0]=e,$2(s,t+92|0),e=E(48),i[t+32>>2]=e,i[t+36>>2]=46,i[t+40>>2]=-2147483600,r=l[7405]|l[7406]<<8|(l[7407]<<16|l[7408]<<24),o=l[7401]|l[7402]<<8|(l[7403]<<16|l[7404]<<24),u[e+38|0]=o,u[e+39|0]=o>>>8,u[e+40|0]=o>>>16,u[e+41|0]=o>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[7399]|l[7400]<<8|(l[7401]<<16|l[7402]<<24),o=l[7395]|l[7396]<<8|(l[7397]<<16|l[7398]<<24),u[e+32|0]=o,u[e+33|0]=o>>>8,u[e+34|0]=o>>>16,u[e+35|0]=o>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[7391]|l[7392]<<8|(l[7393]<<16|l[7394]<<24),o=l[7387]|l[7388]<<8|(l[7389]<<16|l[7390]<<24),u[e+24|0]=o,u[e+25|0]=o>>>8,u[e+26|0]=o>>>16,u[e+27|0]=o>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[7383]|l[7384]<<8|(l[7385]<<16|l[7386]<<24),o=l[7379]|l[7380]<<8|(l[7381]<<16|l[7382]<<24),u[e+16|0]=o,u[e+17|0]=o>>>8,u[e+18|0]=o>>>16,u[e+19|0]=o>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[7375]|l[7376]<<8|(l[7377]<<16|l[7378]<<24),o=l[7371]|l[7372]<<8|(l[7373]<<16|l[7374]<<24),u[e+8|0]=o,u[e+9|0]=o>>>8,u[e+10|0]=o>>>16,u[e+11|0]=o>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[7367]|l[7368]<<8|(l[7369]<<16|l[7370]<<24),o=l[7363]|l[7364]<<8|(l[7365]<<16|l[7366]<<24),u[e|0]=o,u[e+1|0]=o>>>8,u[e+2|0]=o>>>16,u[e+3|0]=o>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,w=K(t+72|0,2,0,t+32|0),u[t+43|0]<0&&Z(i[t+32>>2]),i[t+56>>2]=i[13465],e=i[13464],i[t+48>>2]=i[13463],i[t+52>>2]=e,e=i[13462],i[t+40>>2]=i[13461],i[t+44>>2]=e,i[t+64>>2]=0,i[t+68>>2]=0,W=t- -64|0,i[t+60>>2]=W,e=i[13460],i[t+32>>2]=i[13459],i[t+36>>2]=e,B=t+32|0,h=t+60|0,(B|0)!=(h|0))for(m=h+4|0;;){_=i[h+4>>2];i:{e:{r:{if(o=m,I=i[h>>2],(o|0)==(I|0))break r;r=o;f:{if(e=_,e){for(;o=e,e=i[e+4>>2],!!e;);if(g=i[B>>2],(g|0)<=i[o+16>>2])break f;break r}for(;o=i[r+8>>2],e=i[o>>2]==(r|0),r=o,!!e;);if(r=m,e=r,i[o+16>>2]<i[B>>2])break r;break e}for(;;){if(e=_,r=i[e+16>>2],(r|0)>(g|0)){if(r=e,_=i[e>>2],_)continue;break e}if((r|0)>=(g|0))break i;if(_=i[e+4>>2],!_)break}r=e+4|0;break e}if(r=_?o+4|0:m,i[r>>2])break i;e=_?o:m}o=E(20),_=i[B>>2],i[o+8>>2]=e,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=_,i[r>>2]=o,e=i[I>>2],e&&(i[h>>2]=e),m1(i[h+4>>2],o),i[h+8>>2]=i[h+8>>2]+1}if(B=B+4|0,(h|0)==(B|0))break}i:{e:{r:{r=i[t+64>>2];f:{if(!r)break f;for(h=l[f+1|0],e=W,o=r;_=e,m=o,B=(h|0)>i[o+16>>2],e=B?e:o,o=i[(B?4:0)+o>>2],!!o;);if((e|0)==(W|0))break f;if((h|0)>=i[(B?_:m)+16>>2])break r}Q3(t+60|0,r),Q[f+12>>1]=2056,i[f+8>>2]=1;break e}if(Q3(t+60|0,r),!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(e=i[t+92>>2],i[f+8>>2]=e,(e|0)==3&&I2(s,1),!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(u[f+12|0]=l[t+92|0]+8,!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(u[f+13|0]=l[t+92|0]+8,I2(s,1),!i2(s,1))break e;for(o=0;;){r:{if(!i2(s,1))break r;if(r=8,e=0,o>>>0<=5)for(;;){if(w3(s,t+32|0),r=((i[t+32>>2]+r|0)+256|0)%256|0,!r)break r;if(e=e+1|0,(e|0)==16)break r}for(;;){if(w3(s,t+32|0),r=((i[t+32>>2]+r|0)+256|0)%256|0,!r)break r;if(e=e+1|0,(e|0)==64)break}}if(o=o+1|0,!(o>>>0<(i[f+8>>2]==3?12:8)>>>0))break}}$2(s,t+92|0),$2(s,t+32|0);e:{r:switch(i[t+32>>2]){case 1:if(i2(s,1),e=t+92|0,w3(s,e),w3(s,e),$2(s,t+60|0),r=0,i[t+60>>2]<=0)break e;for(;$2(s,t+92|0),r=r+1|0,(r|0)<i[t+60>>2];);break e;case 0:break r;default:break e}$2(s,t+92|0)}if($2(s,t+92|0),I2(s,1),$2(s,t+60|0),$2(s,t+28|0),i[k>>2]=(i[t+60>>2]<<4)+16,i[n>>2]=(i[t+28>>2]<<4)+16,i2(s,1)||I2(s,1),I2(s,1),i2(s,1)&&($2(s,t+24|0),$2(s,t+20|0),$2(s,t+16|0),$2(s,t+12|0),i[k>>2]=i[k>>2]-(i[t+20>>2]+i[t+24>>2]|0),i[n>>2]=i[n>>2]-(i[t+12>>2]+i[t+16>>2]|0)),i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,u[w+19|0]>=0)break i;Z(i[w+8>>2])}A=i[t+132>>2],A&&(i[t+136>>2]=A,Z(A)),v=t+144|0}function k9(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;_=v-48|0,v=_,B=i[k>>2];i:{e:{if(n){if(B)break e;M0(4835,18299,244,14271),H()}if(!B)break i}if(m=i[k+4>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),i[A+124>>2]=B,B=i[A+128>>2],i[A+128>>2]=m,!B||(m=i[B+4>>2],i[B+4>>2]=m-1,m))break i;X[i[i[B>>2]+8>>2]](B),p(B)}sA(A),W=1,m=i[27172],i[27172]=m+1,i[A+112>>2]=t,i[A+108>>2]=2147483647,i[A>>2]=m,i[A+288>>2]=w,i[A+36>>2]=r,i[A+32>>2]=e,i[A+28>>2]=r,i[A+24>>2]=e,i[A+20>>2]=f,i[A+280>>2]=o,i[A+284>>2]=s;i:{e:{r:{f:{A:{k:{n:{t:switch(f|0){default:M0(22224,18299,280,14271),H();case 1:W=2,i[_+8>>2]=2,g=(r+1|0)/2|0,i[A+36>>2]=g,I=(e+1|0)/2|0,i[A+32>>2]=I,w=2,f=2;break k;case 2:i[_+8>>2]=3,W=2,I=(e+1|0)/2|0,i[A+32>>2]=I,w=1;break n;case 0:break A;case 3:break t}i[_+8>>2]=4,I=e,w=1}g=r,f=1}if(u[A+51|0]=w,u[A+50|0]=W,w=i[k>>2],!w){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,V=1;break f}if(i[w+16852>>2]!=(W|0))break r;if(i[w+16856>>2]==(f|0)){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e;break e}M0(19866,18299,320,14271),H()}if(V=1,i[_+8>>2]=1,Q[A+50>>1]=257,i[A+32>>2]=0,i[A+36>>2]=0,w=i[k>>2],i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,w){f=1;break e}f=1}w=0,o=0;break i}M0(19896,18299,319,14271),H()}R=i[w+508>>2],y=i[w+504>>2],N=i[w+500>>2],V=0,o=i[w+496>>2]}C=8,D=o+N|0,B=G(D,W);i:{if((B|0)>=(e|0)||(m=y+R|0,s=G(m,f),(s|0)>=(r|0)))break i;i[A+88>>2]=g-m,i[A+84>>2]=I-D,r=r-s|0,i[A+80>>2]=r,e=e-B|0,i[A+76>>2]=e,i[_+44>>2]=r,i[_+40>>2]=e,i[_+36>>2]=G(f,R),g=G(f,y),i[_+32>>2]=g,i[_+28>>2]=G(W,N),s=G(o,W),i[_+24>>2]=s,f=0,r=8,W=0,e=8,V||(r=i[w+16832>>2],W=(r&255)>>>0>8,e=i[w+16840>>2]),u[A+49|0]=e,u[A+48|0]=r,u[A+16|0]=W,e=(e&255)>>>0>8,u[A+18|0]=e,u[A+17|0]=e;e:{r:{if(!t||(f=i[t+544>>2],!h))break r;r=i[t+540>>2],e=i[t+536>>2];break e}r=i[26771],e=i[26770]}i[A+304>>2]=e,i[A+308>>2]=r;e:{if(!e)break e;r=X[e|0](t,_+8|0,A,f)|0,i[A+64>>2]=(s+i[A+4>>2]|0)+G(g,i[A+40>>2]);r:{if(!i[A+20>>2]){W=0,e=0;break r}e=G(i[A+44>>2],y),W=e+(i[A+12>>2]+o|0)|0,e=e+(i[A+8>>2]+o|0)|0}if(i[A+72>>2]=W,i[A+68>>2]=e,r)break e;C=7;break i}e:{if(!n)break e;e=i[A+200>>2],n=i[w+16944>>2],f=i[w+16952>>2],r=i[w+16948>>2],t=G(f,r);r:{if((t|0)!=i[A+204>>2]){if(Z(e),e=p2(t),i[A+200>>2]=e,!e){i[A+204>>2]=0,r=0;break r}i[A+204>>2]=t}i[A+216>>2]=f,i[A+212>>2]=r,i[A+208>>2]=n,r=(e|0)!=0}e=i[A+220>>2],t=i[w+16944>>2],n=i[w+16952>>2],f=i[w+16948>>2],o=G(n,f);r:{if((o|0)!=i[A+224>>2]){if(Z(e),e=p2(o),i[A+220>>2]=e,!e){i[A+224>>2]=0,e=0;break r}i[A+224>>2]=o}i[A+236>>2]=n,i[A+232>>2]=f,i[A+228>>2]=t,e=(e|0)!=0}t=e&r,e=i[A+160>>2],n=i[w+16872>>2],f=i[w+16896>>2],r=i[w+16888>>2],o=G(f,r);r:{if((o|0)!=i[A+164>>2]){if(Z(e),e=p2(G(o,3)),i[A+160>>2]=e,!e){i[A+164>>2]=0,e=0;break r}i[A+164>>2]=o}i[A+176>>2]=f,i[A+172>>2]=r,i[A+168>>2]=n,e=(e|0)!=0}n=e&t,e=i[A+180>>2],r=i[w+16872>>2]-2|0,f=i[w+16896>>2]<<r,r=i[w+16888>>2]<<r,t=G(f,r);r:{if((t|0)!=i[A+184>>2]){if(Z(e),e=p2(G(t,12)),i[A+180>>2]=e,!e){i[A+184>>2]=0,e=0;break r}i[A+184>>2]=t}i[A+196>>2]=f,i[A+192>>2]=r,i[A+188>>2]=2,e=(e|0)!=0}t=e&n,e=i[A+240>>2],n=i[w+16936>>2],f=i[w+16928>>2],r=i[w+16924>>2],o=G(f,r);r:{if((o|0)!=i[A+244>>2]){if(Z(e),e=p2(o),i[A+240>>2]=e,!e){i[A+244>>2]=0,e=0;break r}i[A+244>>2]=o}i[A+256>>2]=f,i[A+252>>2]=r,i[A+248>>2]=n,e=(e|0)!=0}n=e&t,e=i[A+260>>2],f=(i[w+488>>2]+3|0)/4|0,r=(i[w+484>>2]+3|0)/4|0,t=G(f,r);r:{if((t|0)!=i[A+264>>2]){if(Z(e),e=p2(t),i[A+260>>2]=e,!e){i[A+264>>2]=0,e=0;break r}i[A+264>>2]=t}i[A+276>>2]=f,i[A+272>>2]=r,i[A+268>>2]=2,e=(e|0)!=0}if(t=e&n,w=i[k>>2],r=i[w+16892>>2],!((r|0)==i[A+152>>2]&i[A+156>>2]==i[w+16900>>2])){if(f=i[A+320>>2],f){if(r=f-4|0,e=i[r>>2],e){for(w=f+G(e,76)|0;w=w-76|0,(f|0)!=(w|0););w=i[k>>2]}Z(r),r=i[w+16892>>2]}e=i[A+140>>2],n=i[w+16876>>2],f=i[w+16900>>2],w=G(f,r);r:{if((w|0)!=i[A+144>>2]){if(Z(e),e=p2(G(w,24)),i[A+140>>2]=e,!e){w=0,i[A+144>>2]=0,e=0;break r}i[A+144>>2]=w}i[A+156>>2]=f,i[A+152>>2]=r,i[A+148>>2]=n,e=(e|0)!=0}if(r=O0(w,0,76,0),f=r+4|0,r=E(l0||r>>>0>f>>>0?-1:f),i[r>>2]=w,r=r+4|0,w)for(f=r+G(w,76)|0,w=r;i[w>>2]=0,w=w+76|0,(f|0)!=(w|0););if(i[A+320>>2]=r,e&t)break e;C=7;break i}if(t)break e;C=7;break i}C=0}e=i[k+4>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=_+48|0,C}function cB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0;t=v-32|0,v=t;i:{e:{r:{if(j0(i[r>>2],3)>>>0<9||j0(i[r>>2],4)>>>0<9)break r;if(j0(i[r>>2],5)>>>0>8)break e}e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}W=u1(i[r>>2],6),k=l[k+8|0];e:{if(!W)break e;if(j0(i[r>>2],6)>>>0<=8){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if((o8(i[r>>2],6)|0)==(o8(i[r>>2],4)|0)&&(l8(i[r>>2],6)|0)==(l8(i[r>>2],4)|0))break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}if(_=j0(i[r>>2],3),!_){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,s=n+140|0,i[n+136>>2]=s,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],V=n+12|0,i[n+96>>2]=V,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],R=i[e+108>>2],f=R,N=i[e+112>>2],e=N,I=k|W,i[V+120>>2]=I&1?13:12,i[V+116>>2]=1,i[V+112>>2]=e,i[V+108>>2]=f,T0(t+8|0,V,10,f,e,_,o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),i[t+8>>2]=0;r:{f:{g=i[r>>2],r=i[g+128>>2];A:{if(!r)break A;for(e=g+128|0,o=e,k=r;f=i[k+16>>2]<3,o=f?o:k,k=i[(f?4:0)+k>>2],!!k;);w=0;k:{if((e|0)==(o|0)||(w=0,i[o+16>>2]>3))break k;x=i[o+44>>2],w=i[o+56>>2]}for(o=e,k=r;f=i[k+16>>2]<4,o=f?o:k,k=i[(f?4:0)+k>>2],!!k;);f=0;k:{if((e|0)==(o|0)||(f=0,i[o+16>>2]>4))break k;y=i[o+56>>2],f=i[o+44>>2]}for(S=f,k=e;f=i[r+16>>2]<5,k=f?k:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}o=0,f=0;break r}if(o=0,f=0,i[k+16>>2]>5)break r;o=i[k+56>>2]>>>1|0,f=i[k+44>>2]}r=i[s>>2],e=0;r:{if(!r)break r;for(k=s;e=i[r+16>>2]<10,k=e?k:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(s|0)||(e=0,i[k+16>>2]>10))break r;O=i[k+56>>2],e=i[k+44>>2]}r=e;r:{if(W){if(h=io(g,6,t+8|0),!h)break r;B=i[t+8>>2]>>>1|0}f:{if(!N|!R)break f;if(e=I&1,L=e?8:6,a=y>>>1|0,$=w>>>1|0,!e){for(w=0;;){for(g=r+G(w,O)|0,I=(G(o,w)<<1)+f|0,y=(G(w,a)<<1)+S|0,s=(G(w,$)<<1)+x|0,k=0;e=k<<1,B=F[e+s>>1],_=F[e+y>>1],h=g+G(k,L)|0,e=F[e+I>>1],u[h+5|0]=e,u[h+3|0]=_,u[h+1|0]=B,u[h+4|0]=e>>>8,u[h+2|0]=_>>>8,u[h|0]=B>>>8,k=k+1|0,(R|0)!=(k|0););if(w=w+1|0,(N|0)==(w|0))break}break f}if(e=0,W)for(;;){for(_=r+G(e,O)|0,g=(G(e,B)<<1)+h|0,I=(G(e,o)<<1)+f|0,y=(G(e,a)<<1)+S|0,w=(G(e,$)<<1)+x|0,k=0;D=k<<1,m=F[D+w>>1],W=F[y+D>>1],C=_+G(k,L)|0,s=F[I+D>>1],u[C+5|0]=s,u[C+3|0]=W,u[C+1|0]=m,u[C+4|0]=s>>>8,u[C+2|0]=W>>>8,u[C|0]=m>>>8,s=F[g+D>>1],s=s<<8|s>>>8,u[C+6|0]=s,u[C+7|0]=s>>>8,k=k+1|0,(R|0)!=(k|0););if(e=e+1|0,(N|0)==(e|0))break f}for(_=-1<<_^-1,g=(_&65280)>>>8|0;;){for(I=r+G(e,O)|0,y=(G(e,o)<<1)+f|0,w=(G(e,a)<<1)+S|0,s=(G(e,$)<<1)+x|0,k=0;B=k<<1,W=F[B+s>>1],h=F[w+B>>1],B=F[B+y>>1],m=I+G(k,L)|0,u[m+7|0]=_,u[m+6|0]=g,u[m+5|0]=B,u[m+3|0]=h,u[m+1|0]=W,u[m+4|0]=B>>>8,u[m+2|0]=h>>>8,u[m|0]=W>>>8,k=k+1|0,(R|0)!=(k|0););if(e=e+1|0,(N|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=V;break i}U6(A,107732)}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+32|0}function bB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;w=v-80|0,v=w,_=D6(),Sr(_,n),h=w+56|0,m=i[e>>2],n=k,s=v+-64|0,v=s,B=i[r>>2],r=i[B+112>>2],k=i[B+108>>2];i:{if(!((k|0)>(t|0)|(r|0)>(t|0))){r=i[26929],i[h>>2]=i[26928],i[h+4>>2]=r,r=h+8|0;e:{if(u[107731]>=0){k=i[26931],i[r>>2]=i[26930],i[r+4>>2]=k,i[r+8>>2]=i[26932];break e}T(r,i[26930],i[26931])}u[h+20|0]=1;break i}e:{if((r|0)<(k|0)){r=(G(r,t)|0)/(k|0)|0,k=t;break e}k=(G(k,t)|0)/(r|0)|0,r=t}i[s+44>>2]=0,i[s+48>>2]=0,Bf(s+24|0,B,s+44|0,k&-2,r&-2,m- -64|0);e:{if(i[s+24>>2]){r=i[s+28>>2],i[h>>2]=i[s+24>>2],i[h+4>>2]=r,r=h+8|0;r:{if(u[s+43|0]>=0){k=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+40>>2];break r}T(r,i[s+32>>2],i[s+36>>2])}u[h+20|0]=1;break e}Oi(s,m,s+44|0,n,_,4);r:{f:{A:{k:switch(k=l[s+20|0],k|0){case 0:break f;case 1:break A;default:break k}_2(),H()}if(r=i[s+4>>2],i[h>>2]=i[s>>2],i[h+4>>2]=r,r=h+8|0,u[s+19|0]>=0){n=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[s+16>>2];break r}T(r,i[s+8>>2],i[s+12>>2]);break r}n=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+4>>2]=r,i[h>>2]=n}if(u[h+20|0]=k,r=l[s+20|0],(r|0)==255)break e;k=i[23611],i[s+56>>2]=i[23610],i[s+60>>2]=k,X[i[(s+56|0)+(r<<2)>>2]](s+55|0,s)}if(u[s+43|0]<0&&Z(i[s+32>>2]),r=i[s+48>>2],!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=s- -64|0,z2(_);i:{e:switch(l[w+76|0]){default:_2(),H();case 1:b0(A,w+56|0,i[e>>2]);break i;case 0:break e}k=i[w+56>>2],i[w+48>>2]=k,r=i[w+60>>2],i[w+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!k){if(f=E(64),i[w+12>>2]=f,i[w+16>>2]=57,i[w+20>>2]=-2147483584,u[f+56|0]=l[25532],k=l[25528]|l[25529]<<8|(l[25530]<<16|l[25531]<<24),n=l[25524]|l[25525]<<8|(l[25526]<<16|l[25527]<<24),u[f+48|0]=n,u[f+49|0]=n>>>8,u[f+50|0]=n>>>16,u[f+51|0]=n>>>24,u[f+52|0]=k,u[f+53|0]=k>>>8,u[f+54|0]=k>>>16,u[f+55|0]=k>>>24,k=l[25520]|l[25521]<<8|(l[25522]<<16|l[25523]<<24),n=l[25516]|l[25517]<<8|(l[25518]<<16|l[25519]<<24),u[f+40|0]=n,u[f+41|0]=n>>>8,u[f+42|0]=n>>>16,u[f+43|0]=n>>>24,u[f+44|0]=k,u[f+45|0]=k>>>8,u[f+46|0]=k>>>16,u[f+47|0]=k>>>24,k=l[25512]|l[25513]<<8|(l[25514]<<16|l[25515]<<24),n=l[25508]|l[25509]<<8|(l[25510]<<16|l[25511]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[25504]|l[25505]<<8|(l[25506]<<16|l[25507]<<24),n=l[25500]|l[25501]<<8|(l[25502]<<16|l[25503]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[25496]|l[25497]<<8|(l[25498]<<16|l[25499]<<24),n=l[25492]|l[25493]<<8|(l[25494]<<16|l[25495]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[25488]|l[25489]<<8|(l[25490]<<16|l[25491]<<24),n=l[25484]|l[25485]<<8|(l[25486]<<16|l[25487]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[25480]|l[25481]<<8|(l[25482]<<16|l[25483]<<24),n=l[25476]|l[25477]<<8|(l[25478]<<16|l[25479]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+57|0]=0,f=K(w+24|0,5,2006,w+12|0),u[w+23|0]<0&&Z(i[w+12>>2]),b0(A,f,i[e>>2]),u[f+19|0]>=0)break e;Z(i[f+8>>2]);break e}r=w+24|0,Vu(r,i[e>>2],f,w+48|0);r:{if(i[w+24>>2]!=i[26928]){b0(A,r,i[e>>2]);break r}f:{if(!o)break f;k=E(16),r=k,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,n=i[w+48>>2],f=i[w+52>>2];A:{if(!f){i[r+4>>2]=f,i[r>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,i[k>>2]=n,r=i[k+4>>2],i[k+4>>2]=f,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break A;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=i[e>>2],r=i[o>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[w+43|0]<0&&Z(i[w+32>>2]),r=i[w+52>>2]}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}A=l[w+76|0],(A|0)!=255&&(e=i[24213],i[w+24>>2]=i[24212],i[w+28>>2]=e,X[i[(w+24|0)+(A<<2)>>2]](w+12|0,w+56|0)),v=w+80|0}function iv(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;m=w-8|0,B=n+3|0,N=v-((G(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(I=r-2|0,R=N+2|0,r=n+2|0,C=(r|0)>0?r:0,S=k&2147483646,O=k&1,V=k-t&3,W=-1,y=k-1|0,L=y-t>>>0<3;;){_=R+(W<<1)|0,w=I+(G(f,W)<<1)|0;e:{r:{f:switch(t|0){case 0:if(s=0,r=t,V)for(;Q[_+(G(r,B)<<1)>>1]=F[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(V|0)!=(s|0););if(L)break e;for(;Q[_+(G(r,B)<<1)>>1]=F[w+2>>1],Q[_+(G(r+1|0,B)<<1)>>1]=F[w+4>>1],Q[_+(G(r+2|0,B)<<1)>>1]=F[w+6>>1],Q[_+(G(r+3|0,B)<<1)>>1]=F[w+8>>1],w=w+8|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=F[w>>1],r=0;h=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=(G(F[w+4>>1],58)+G(h,10)|0)-(F[w+6>>1]+(s&65535)<<1)>>m,w=w+2|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=F[w>>1],r=0;h=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=(G(F[w+4>>1],10)+G(h,58)|0)-(F[w+6>>1]+(s&65535)<<1)>>m,w=w+2|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=F[w>>1],r=0;h=s&65535,s=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=G(s,54)+(F[w+4>>1]<<4)-((h<<2)+(F[w+6>>1]<<1))>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=F[w>>1],r=0;h=s&65535,s=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=((G(s,46)+G(h,-6)|0)+G(F[w+4>>1],28)|0)-(F[w+6>>1]<<2)>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=F[w>>1],r=0,g=0,!y)break r;for(;h=s&65535,s=F[w+4>>1],D=F[w+2>>1],x=F[w+6>>1],Q[_+(G(r,B)<<1)>>1]=G(s+D|0,36)-(h+x<<2)>>m,Q[_+(G(r|1,B)<<1)>>1]=G(s+x|0,36)-(F[w+8>>1]+D<<2)>>m,r=r+2|0,w=w+4|0,g=g+2|0,(S|0)!=(g|0););break r;case 5:for(s=F[w>>1],r=0;h=s&65535,s=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=((G(s,28)-(h<<2)|0)+G(F[w+4>>1],46)|0)+G(F[w+6>>1],-6)>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=F[w>>1],r=0;h=s&65535,s=F[w+2>>1],Q[_+(G(r,B)<<1)>>1]=G(F[w+4>>1],54)+(s<<4)-((h<<1)+(F[w+6>>1]<<2))>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;Q[_+(G(r,B)<<1)>>1]=G(F[w+4>>1]+F[w+2>>1]|0,36)-(F[w+6>>1]+(s&65535)<<2)>>m}if(W=W+1|0,(C|0)==(W|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(h=t?6:m,m=n&2147483646,V=n&1,_=n-o&3,W=0,I=n-1|0,R=I-o>>>0<3;;){t=(W<<1)+A|0,w=(G(B,W)<<1)+N|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,_)for(;Q[t+(G(e,r)<<1)>>1]=F[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;Q[t+(G(e,r)<<1)>>1]=F[w+2>>1],Q[t+(G(r+1|0,e)<<1)>>1]=F[w+4>>1],Q[t+(G(r+2|0,e)<<1)>>1]=F[w+6>>1],Q[t+(G(r+3|0,e)<<1)>>1]=F[w+8>>1],w=w+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=F[w>>1],r=0;f=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=(G(Q[w+4>>1],58)+G(f,10)|0)-(Q[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=F[w>>1],r=0;f=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=(G(Q[w+4>>1],10)+G(f,58)|0)-(Q[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=G(s,54)+(Q[w+4>>1]<<4)-((f<<2)+(Q[w+6>>1]<<1))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=((G(s,46)+G(f,-6)|0)+G(Q[w+4>>1],28)|0)-(Q[w+6>>1]<<2)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=F[w>>1],r=0,g=0,!I)break r;for(;f=s<<16>>16,s=Q[w+4>>1],C=Q[w+2>>1],y=f,f=Q[w+6>>1],Q[t+(G(e,r)<<1)>>1]=G(s+C|0,36)-(y+f<<2)>>h,Q[t+(G(r|1,e)<<1)>>1]=G(f+s|0,36)-(C+Q[w+8>>1]<<2)>>h,r=r+2|0,w=w+4|0,g=g+2|0,(m|0)!=(g|0););break r;case 5:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=((G(s,28)-(f<<2)|0)+G(Q[w+4>>1],46)|0)+G(Q[w+6>>1],-6)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=G(Q[w+4>>1],54)+(s<<4)-((f<<1)+(Q[w+6>>1]<<2))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!V)break e;Q[t+(G(e,r)<<1)>>1]=G(Q[w+4>>1]+Q[w+2>>1]|0,36)-(Q[w+6>>1]+(s<<16>>16)<<2)>>h}if(W=W+1|0,(W|0)==(k|0))break}}}function n1(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0;h=v-96|0,v=h,R=s&65535,m=(k^s)&-2147483648,g=k&65535,L=g,D0=s>>>16&32767,H0=k>>>16&32767;i:{e:{if(D0-32767>>>0>4294934529&H0-32767>>>0>=4294934530)break e;if(_=k&2147483647,W=_,w=f,!(!w&(_|0)==2147418112?!(e|r):_>>>0<2147418112)){B=w,m=k|32768;break i}if(_=s&2147483647,k=o,!(!k&(_|0)==2147418112?!(n|t):_>>>0<2147418112)){B=k,m=s|32768,e=n,r=t;break i}if(!(e|w|(W^2147418112|r))){if(!(k|n|(t|_))){m=2147450880,e=0,r=0;break i}m=m|2147418112,e=0,r=0;break i}if(!(k|n|(_^2147418112|t))){if(k=e|w,f=r|W,e=0,r=0,!(f|k)){m=2147450880;break i}m=m|2147418112;break i}if(!(e|w|(r|W))){e=0,r=0;break i}if(!(k|n|(t|_))){e=0,r=0;break i}if((W|0)==65535|W>>>0<65535&&(w=!(f|g),s=k1(w?r:g),w=((s|0)==32?k1(w?e:f)+32|0:s)+(w?64:0)|0,o4(h+80|0,e,r,f,g,w-15|0),V=16-w|0,f=i[h+88>>2],L=i[h+92>>2],r=i[h+84>>2],e=i[h+80>>2]),_>>>0>65535)break e;s=!(o|R),k=k1(s?t:R),s=((k|0)==32?k1(s?n:o)+32|0:k)+(s?64:0)|0,o4(h- -64|0,n,t,o,R,s-15|0),V=(V-s|0)+16|0,o=i[h+72>>2],R=i[h+76>>2],n=i[h+64>>2],t=i[h+68>>2]}k=n,n=t<<15|k>>>17,s=k<<15,k=0,N=s&-32768,V0=r,S=O0(N,k,r,0),k=l0,a=k,e0=n,I=e,e=O0(n,0,e,0),r=e+S|0,w=l0+k|0,s=e>>>0>r>>>0?w+1|0:w,w=0,e=O0(I,y,N,y),W=w+e|0,n=r,k=n+l0|0,k=e>>>0>W>>>0?k+1|0:k,g=k,r=(n|0)==(k|0)&w>>>0>W>>>0|k>>>0<n>>>0,r0=f,C=O0(N,y,f,0),N0=l0,e=O0(V0,O,e0,O),D=e+C|0,w=l0+N0|0,w=e>>>0>D>>>0?w+1|0:w,_=w,e=R<<15|o>>>17,f0=o<<15|t>>>17,f=O0(f0,0,I,y),A0=f+D|0,w=l0+w|0,w=f>>>0>A0>>>0?w+1|0:w,n0=w,k=s,h0=k+A0|0,n=((k|0)==(a|0)&n>>>0<S>>>0|k>>>0<a>>>0)+w|0,n=k>>>0>h0>>>0?n+1|0:n,s=n,t=h0,m0=L|65536,a=O0(N,y,m0,x),U0=l0,f=O0(r0,B,e0,O),N=f+a|0,k=l0+U0|0,k=f>>>0>N>>>0?k+1|0:k,o=k,W0=e|-2147483648,e=O0(W0,0,I,y),y=e+N|0,w=l0+k|0,w=e>>>0>y>>>0?w+1|0:w,e=O0(f0,B,V0,O),x=e+y|0,Q0=w,n=w+l0|0,R=e>>>0>x>>>0?n+1|0:n,e=0,S=e+t|0,k=s+x|0,k=e>>>0>S>>>0?k+1|0:k,L=k,e=S+r|0,r=e>>>0<S>>>0?k+1|0:k,V=((H0+D0|0)+V|0)-16383|0,f=O0(W0,$,V0,O),t=l0,n=O0(m0,B,e0,O),k=n+f|0,w=l0+t|0,w=k>>>0<n>>>0?w+1|0:w,I=(t|0)==(w|0)&f>>>0>k>>>0|t>>>0>w>>>0,t=O0(f0,B,r0,B),f=t+k|0,n=l0+w|0,n=f>>>0<t>>>0?n+1|0:n,k=(n|0)==(w|0)&f>>>0<k>>>0|n>>>0<w>>>0,w=0,t=k,k=k+I|0,w=t>>>0>k>>>0?1:w,t=k,k=O0(W0,$,m0,B),t=t+k|0,w=l0+w|0,w=k>>>0>t>>>0?w+1|0:w,O=t,t=f,I=n,k=(_|0)==(N0|0)&C>>>0>D>>>0|_>>>0<N0>>>0,n=0,_=(_|0)==(n0|0)&D>>>0>A0>>>0|_>>>0>n0>>>0,C=_,_=k+_|0,k=(C>>>0>_>>>0?1:n)+I|0,f=f+_|0,k=f>>>0<_>>>0?k+1|0:k,_=k,D=f,f=(k|0)==(I|0)&f>>>0<t>>>0|k>>>0<I>>>0,k=f,f=f+O|0,w=k>>>0>f>>>0?w+1|0:w,I=f,C=w,k=O0(f0,B,m0,B),w=l0,t=O0(W0,$,r0,B),f=t+k|0,n=l0+w|0,n=f>>>0<t>>>0?n+1|0:n,t=n,n=(w|0)==(n|0)&f>>>0<k>>>0|n>>>0<w>>>0,$=I+t|0,k=n+C|0,k=t>>>0>$>>>0?k+1|0:k,C=$,w=f,n=0,f=n+D|0,w=w+_|0,w=f>>>0<n>>>0?w+1|0:w,n=k,t=(w|0)==(_|0)&f>>>0<D>>>0|w>>>0<_>>>0,k=t+C|0,n=t>>>0>k>>>0?n+1|0:n,D=k,t=n,_=f,C=w,n=(R|0)==(Q0|0)&y>>>0>x>>>0|R>>>0<Q0>>>0,k=(o|0)==(U0|0)&N>>>0<a>>>0|o>>>0<U0>>>0,o=(o|0)==(Q0|0)&y>>>0<N>>>0|o>>>0>Q0>>>0,k=k+o|0,n=k+n|0,o=R,f=o+f|0,k=n+C|0,n=t,k=f>>>0<o>>>0?k+1|0:k,o=(k|0)==(C|0)&f>>>0<_>>>0|k>>>0<C>>>0,t=o+D|0,n=o>>>0>t>>>0?n+1|0:n,x=t,w=n,t=f,o=k,k=(s|0)==(n0|0)&A0>>>0>h0>>>0|s>>>0<n0>>>0,n=0,s=(s|0)==(L|0)&S>>>0<h0>>>0|s>>>0>L>>>0,I=s,s=k+s|0,k=(I>>>0>s>>>0?1:n)+o|0,f=f+s|0,k=f>>>0<s>>>0?k+1|0:k,n=(k|0)==(o|0)&f>>>0<t>>>0|k>>>0<o>>>0,o=n+x|0,w=n>>>0>o>>>0?w+1|0:w,s=w;e:{if(w&65536){V=V+1|0;break e}x=g>>>31|0,w=s<<1|o>>>31,o=o<<1|k>>>31,s=w,w=k<<1|f>>>31,f=f<<1|r>>>31,k=w,w=g<<1|W>>>31,W=W<<1,g=w,w=r<<1|e>>>31,e=e<<1|x,r=w}if((V|0)>=32767){m=m|2147418112,e=0,r=0;break i}e:{if((V|0)<=0){if(t=1-V|0,t>>>0<=127){n=V+127|0,o4(h+48|0,W,g,e,r,n),o4(h+32|0,f,k,o,s,n),Y6(h+16|0,W,g,e,r,t),Y6(h,f,k,o,s,t),W=i[h+32>>2]|i[h+16>>2]|(i[h+48>>2]|i[h+56>>2]|(i[h+52>>2]|i[h+60>>2]))!=0,g=i[h+36>>2]|i[h+20>>2],e=i[h+40>>2]|i[h+24>>2],r=i[h+44>>2]|i[h+28>>2],f=i[h>>2],k=i[h+4>>2],t=i[h+8>>2],n=i[h+12>>2];break e}e=0,r=0;break i}t=o,n=s&65535|V<<16}if(B=t|B,m=n|m,!(!e&(r|0)==-2147483648?!(W|g):(r|0)>0|(r|0)>=0)){e=f+1|0,w=e?k:k+1|0,k=m,r=w,f=!(w|e),B=f+B|0,m=f>>>0>B>>>0?k+1|0:k;break i}if(e|W|(r^-2147483648|g)){e=f,r=k;break i}n=m,e=f&1,r=e,e=e+f|0,r=r>>>0>e>>>0?k+1|0:k,f=(k|0)==(r|0)&e>>>0<f>>>0|r>>>0<k>>>0,B=f+B|0,m=f>>>0>B>>>0?n+1|0:n}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=B,i[A+12>>2]=m,v=h+96|0}function ev(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-48|0,v=t,_=X[i[i[e>>2]+52>>2]](e,r,0)|0,w=t+24|0,o=v-16|0,v=o,l2(r,l[e+100|0]),l2(r,(l[e+103|0]&31|(l[e+102|0]<<5|l[e+101|0]<<6))&255),C0(r,i[e+104>>2]),f=l[e+108|0],k=f>>>6|0,n=f>>>4|0,l2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+108>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,l2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>22|0,n=f>>>20|0,s=f>>>18|0,l2(r,((k&1|((n&1|((s&1|f>>>16&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>30|0,n=f>>>28|0,s=f>>>26|0,l2(r,((k&1|((n&1|((s&1|f>>>24&2)<<2|s&2))<<2|n&2))<<2|k)&254),f=l[e+112|0],k=f>>>6|0,n=f>>>4|0,l2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+112>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,l2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),l2(r,l[e+116|0]),u2(r,F[e+118>>1]|61440),l2(r,l[e+120|0]|252),l2(r,l[e+121|0]|252),l2(r,l[e+122|0]|248),l2(r,l[e+123|0]|248),u2(r,F[e+124>>1]),l2(r,(l[e+129|0]-1&3|(l[e+128|0]<<2&4|(l[e+127|0]<<3&56|l[e+126|0]<<6)))&255),l2(r,i[e+136>>2]-i[e+132>>2]>>>4&255),f=i[e+132>>2],n=i[e+136>>2];i:{if((f|0)!=(n|0))for(;;){if(l2(r,l[f|0]<<6&64|l[f+1|0]&63),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(f=E(32),i[o+4>>2]=f,i[o+8>>2]=26,i[o+12>>2]=-2147483616,k=l[19947]|l[19948]<<8|(l[19949]<<16|l[19950]<<24),n=l[19943]|l[19944]<<8|(l[19945]<<16|l[19946]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+26|0]=0,k=l[19967]|l[19968]<<8,u[f+24|0]=k,u[f+25|0]=k>>>8,k=l[19963]|l[19964]<<8|(l[19965]<<16|l[19966]<<24),n=l[19959]|l[19960]<<8|(l[19961]<<16|l[19962]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[19955]|l[19956]<<8|(l[19957]<<16|l[19958]<<24),n=l[19951]|l[19952]<<8|(l[19953]<<16|l[19954]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,K(w,2,0,o+4|0),u[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(u2(r,k),k=i[f+4>>2],s=i[f+8>>2],(k|0)!=(s|0))for(;;){if(h=i[k+4>>2]-i[k>>2]|0,h>>>0>=65536){if(f=E(48),i[o+4>>2]=f,i[o+8>>2]=41,i[o+12>>2]=-2147483600,k=l[26632]|l[26633]<<8|(l[26634]<<16|l[26635]<<24),n=l[26628]|l[26629]<<8|(l[26630]<<16|l[26631]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+41|0]=0,u[f+40|0]=l[26668],k=l[26664]|l[26665]<<8|(l[26666]<<16|l[26667]<<24),n=l[26660]|l[26661]<<8|(l[26662]<<16|l[26663]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[26656]|l[26657]<<8|(l[26658]<<16|l[26659]<<24),n=l[26652]|l[26653]<<8|(l[26654]<<16|l[26655]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[26648]|l[26649]<<8|(l[26650]<<16|l[26651]<<24),n=l[26644]|l[26645]<<8|(l[26646]<<16|l[26647]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[26640]|l[26641]<<8|(l[26642]<<16|l[26643]<<24),n=l[26636]|l[26637]<<8|(l[26638]<<16|l[26639]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,K(w,2,0,o+4|0),u[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(u2(r,h),V4(r,k),k=k+12|0,(s|0)==(k|0))break}if(f=f+16|0,(n|0)==(f|0))break}if(f=i[26929],i[w>>2]=i[26928],i[w+4>>2]=f,f=w+8|0,u[107731]>=0){w=i[26931],i[f>>2]=i[26930],i[f+4>>2]=w,i[f+8>>2]=i[26932];break i}T(f,i[26930],i[26931])}v=o+16|0;i:{if(i[t+24>>2]){e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+40>>2],e=i[t+36>>2],i[A+8>>2]=i[t+32>>2],i[A+12>>2]=e,i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0;break i}if(f1(t+4|0,e,r,_),u[t+23|0]<0&&Z(i[t+12>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[t+43|0]<0&&Z(i[t+32>>2]),v=t+48|0}function rv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;k=v-16|0,v=k,g=e,I=F0(r),i[g+100>>2]=I,g=e,I=F0(r),i[g+104>>2]=I;i:{e:{if(o=i[e+12>>2],t=i[e+8>>2],!o&t>>>0>=8|o&&(n=o-(t>>>0<8)|0,t=t-8|0,w=i[e+32>>2],!n&t>>>0>=w>>>0|n))break e;if(e=E(40),i[k+4>>2]=e,i[k+8>>2]=38,i[k+12>>2]=-2147483608,r=l[26427]|l[26428]<<8|(l[26429]<<16|l[26430]<<24),f=l[26423]|l[26424]<<8|(l[26425]<<16|l[26426]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+38|0]=0,r=l[26457]|l[26458]<<8|(l[26459]<<16|l[26460]<<24),f=l[26453]|l[26454]<<8|(l[26455]<<16|l[26456]<<24),u[e+30|0]=f,u[e+31|0]=f>>>8,u[e+32|0]=f>>>16,u[e+33|0]=f>>>24,u[e+34|0]=r,u[e+35|0]=r>>>8,u[e+36|0]=r>>>16,u[e+37|0]=r>>>24,r=l[26451]|l[26452]<<8|(l[26453]<<16|l[26454]<<24),f=l[26447]|l[26448]<<8|(l[26449]<<16|l[26450]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26443]|l[26444]<<8|(l[26445]<<16|l[26446]<<24),f=l[26439]|l[26440]<<8|(l[26441]<<16|l[26442]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26435]|l[26436]<<8|(l[26437]<<16|l[26438]<<24),f=l[26431]|l[26432]<<8|(l[26433]<<16|l[26434]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,101,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(m=t-w|0,o=m,t=n-(t>>>0<w>>>0)|0,w=t>>>2|0,m=(t&3)<<30|o>>>2,!w&u0[f+84>>2]>=m>>>0){e:{f=l[r+20|0];r:{if(!(!t&o>>>0<4|f&1)){o=0,t=0;f:{A:{for(;;){_=F0(r),f=i[e+112>>2],s=i[e+116>>2];k:{if(f>>>0<s>>>0){i[f>>2]=_,f=f+4|0;break k}if(B=i[e+108>>2],f=f-B|0,W=f>>2,n=W+1|0,n>>>0>=1073741824)break A;if(s=s-B|0,h=s>>1,s=s>>>0>=2147483644?1073741823:n>>>0<h>>>0?h:n,s){if(s>>>0>=1073741824)break f;n=E(s<<2)}else n=0;if(h=n+f|0,i[h>>2]=_,_=h-(W<<2)|0,f&&z(_,B,f),i[e+116>>2]=n+(s<<2),f=h+4|0,i[e+112>>2]=f,i[e+108>>2]=_,!B)break k;Z(B)}if(i[e+112>>2]=f,f=t,n=u[r+20|0]&1,o=o+1|0,f=o?f:f+1|0,t=f,!(!n&((f|0)==(w|0)&o>>>0<m>>>0|f>>>0<w>>>0)))break}if(n)break r;break e}G0(),H()}x0(),H()}if(!(f&1))break e}if(u[k+4|0]=0,u[k+15|0]=0,K(A,2,100,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(e=E(56),i[k+4>>2]=e,i[k+8>>2]=53,i[k+12>>2]=-2147483592,r=l[3929]|l[3930]<<8|(l[3931]<<16|l[3932]<<24),f=l[3925]|l[3926]<<8|(l[3927]<<16|l[3928]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+53|0]=0,r=l[3974]|l[3975]<<8|(l[3976]<<16|l[3977]<<24),f=l[3970]|l[3971]<<8|(l[3972]<<16|l[3973]<<24),u[e+45|0]=f,u[e+46|0]=f>>>8,u[e+47|0]=f>>>16,u[e+48|0]=f>>>24,u[e+49|0]=r,u[e+50|0]=r>>>8,u[e+51|0]=r>>>16,u[e+52|0]=r>>>24,r=l[3969]|l[3970]<<8|(l[3971]<<16|l[3972]<<24),f=l[3965]|l[3966]<<8|(l[3967]<<16|l[3968]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[3961]|l[3962]<<8|(l[3963]<<16|l[3964]<<24),f=l[3957]|l[3958]<<8|(l[3959]<<16|l[3960]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[3953]|l[3954]<<8|(l[3955]<<16|l[3956]<<24),f=l[3949]|l[3950]<<8|(l[3951]<<16|l[3952]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[3945]|l[3946]<<8|(l[3947]<<16|l[3948]<<24),f=l[3941]|l[3942]<<8|(l[3943]<<16|l[3944]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[3937]|l[3938]<<8|(l[3939]<<16|l[3940]<<24),f=l[3933]|l[3934]<<8|(l[3935]<<16|l[3936]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2])}v=k+16|0}function fv(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;m=w-8|0,B=n+3|0,N=v-((G(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(I=r-1|0,R=N+2|0,r=n+2|0,C=(r|0)>0?r:0,S=k&2147483646,O=k&1,V=k-t&3,W=-1,y=k-1|0,L=y-t>>>0<3;;){_=R+(W<<1)|0,w=I+G(f,W)|0;e:{r:{f:switch(t|0){case 0:if(s=0,r=t,V)for(;Q[_+(G(r,B)<<1)>>1]=l[w+1|0],r=r+1|0,w=w+1|0,s=s+1|0,(V|0)!=(s|0););if(L)break e;for(;Q[_+(G(r,B)<<1)>>1]=l[w+1|0],Q[_+(G(r+1|0,B)<<1)>>1]=l[w+2|0],Q[_+(G(r+2|0,B)<<1)>>1]=l[w+3|0],Q[_+(G(r+3|0,B)<<1)>>1]=l[w+4|0],w=w+4|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=l[w|0],r=0;h=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=(G(l[w+2|0],58)+G(h,10)|0)-(l[w+3|0]+(s&255)<<1)>>m,w=w+1|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=l[w|0],r=0;h=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=(G(l[w+2|0],10)+G(h,58)|0)-(l[w+3|0]+(s&255)<<1)>>m,w=w+1|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=G(s,54)+(l[w+2|0]<<4)-((h<<2)+(l[w+3|0]<<1))>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=((G(s,46)+G(h,-6)|0)+G(l[w+2|0],28)|0)-(l[w+3|0]<<2)>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=l[w|0],r=0,g=0,!y)break r;for(;h=s&255,s=l[w+2|0],D=l[w+1|0],x=l[w+3|0],Q[_+(G(r,B)<<1)>>1]=G(s+D|0,36)-(h+x<<2)>>m,Q[_+(G(r|1,B)<<1)>>1]=G(s+x|0,36)-(l[w+4|0]+D<<2)>>m,r=r+2|0,w=w+2|0,g=g+2|0,(S|0)!=(g|0););break r;case 5:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=((G(s,28)-(h<<2)|0)+G(l[w+2|0],46)|0)+G(l[w+3|0],-6)>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],Q[_+(G(r,B)<<1)>>1]=G(l[w+2|0],54)+(s<<4)-((h<<1)+(l[w+3|0]<<2))>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;Q[_+(G(r,B)<<1)>>1]=G(l[w+2|0]+l[w+1|0]|0,36)-(l[w+3|0]+(s&255)<<2)>>m}if(W=W+1|0,(C|0)==(W|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(h=t?6:m,m=n&2147483646,V=n&1,_=n-o&3,W=0,I=n-1|0,R=I-o>>>0<3;;){t=(W<<1)+A|0,w=(G(B,W)<<1)+N|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,_)for(;Q[t+(G(e,r)<<1)>>1]=F[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;Q[t+(G(e,r)<<1)>>1]=F[w+2>>1],Q[t+(G(r+1|0,e)<<1)>>1]=F[w+4>>1],Q[t+(G(r+2|0,e)<<1)>>1]=F[w+6>>1],Q[t+(G(r+3|0,e)<<1)>>1]=F[w+8>>1],w=w+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=F[w>>1],r=0;f=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=(G(Q[w+4>>1],58)+G(f,10)|0)-(Q[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=F[w>>1],r=0;f=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=(G(Q[w+4>>1],10)+G(f,58)|0)-(Q[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=G(s,54)+(Q[w+4>>1]<<4)-((f<<2)+(Q[w+6>>1]<<1))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=((G(s,46)+G(f,-6)|0)+G(Q[w+4>>1],28)|0)-(Q[w+6>>1]<<2)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=F[w>>1],r=0,g=0,!I)break r;for(;f=s<<16>>16,s=Q[w+4>>1],C=Q[w+2>>1],y=f,f=Q[w+6>>1],Q[t+(G(e,r)<<1)>>1]=G(s+C|0,36)-(y+f<<2)>>h,Q[t+(G(r|1,e)<<1)>>1]=G(f+s|0,36)-(C+Q[w+8>>1]<<2)>>h,r=r+2|0,w=w+4|0,g=g+2|0,(m|0)!=(g|0););break r;case 5:for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=((G(s,28)-(f<<2)|0)+G(Q[w+4>>1],46)|0)+G(Q[w+6>>1],-6)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=F[w>>1],r=0;f=s<<16>>16,s=Q[w+2>>1],Q[t+(G(e,r)<<1)>>1]=G(Q[w+4>>1],54)+(s<<4)-((f<<1)+(Q[w+6>>1]<<2))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!V)break e;Q[t+(G(e,r)<<1)>>1]=G(Q[w+4>>1]+Q[w+2>>1]|0,36)-(Q[w+6>>1]+(s<<16>>16)<<2)>>h}if(W=W+1|0,(W|0)==(k|0))break}}}function Av(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(n=v-32|0,v=n,_=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+105|0]|l[e+104|0]<<1&6|248),l[e+105|0]==1){u2(r,(l[e+110|0]|(l[e+108|0]<<4|F[e+106>>1]<<7|l[e+109|0]<<2))&65535),l2(r,(l[e+111|0]<<5|31)&255),l2(r,l[e+112|0]&63),l2(r,l[e+114|0]|l[e+113|0]<<1&254),l2(r,l[e+115|0]);i:{if(!l[e+112|0]||(l2(r,(l[i[e+120>>2]]|(l[e+117|0]<<6|l[e+116|0]<<7))&255),k=1,l[e+112|0]<=1))break i;for(;l2(r,l[i[e+120>>2]+k|0]),k=k+1|0,k>>>0<l[e+112|0];);}f=l[e+108|0];i:{if(f>>>0<=1)break i;t=f-1|0,w=t&1,o=i[e+132>>2],k=f-2|0;e:{if(!k){t=128,f=0;break e}for(B=t&-2,t=128,f=0;s=k-1|0,m=0-(i[o+(s>>>3&536870908)>>2]>>>s&1)|0,s=t&255,f=m&s>>>1|(0-(i[o+(k>>>3&536870908)>>2]>>>k&1)&t|f),k=k-2|0,t=s>>>2|0,h=h+2|0,(h|0)!=(B|0););}if(w&&(f=0-(i[o+(k>>>3&536870908)>>2]>>>k&1)&t|f),l2(r,f&255),f=l[e+108|0],f>>>0<2)break i;for(k=f-2|0;i[i[e+132>>2]+(k>>>3&536870908)>>2]>>>k&1&&l2(r,l[i[e+144>>2]+k|0]),f=(k|0)>0,k=k-1|0,!!f;);}if(f=i[e+160>>2]-i[e+156>>2]>>>2&255,l2(r,f),f)for(k=0;C0(r,i[i[e+156>>2]+(k<<2)>>2]),k=k+1|0,(f|0)!=(k|0););u2(r,F[e+168>>1]),u2(r,F[e+170>>1]),u2(r,F[e+172>>1])}f=i[e+180>>2]-i[e+176>>2]>>4;i:{if(f>>>0>=256){if(e=E(32),i[n+20>>2]=e,i[n+24>>2]=24,i[n+28>>2]=-2147483616,r=l[23677]|l[23678]<<8|(l[23679]<<16|l[23680]<<24),f=l[23673]|l[23674]<<8|(l[23675]<<16|l[23676]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23693]|l[23694]<<8|(l[23695]<<16|l[23696]<<24),f=l[23689]|l[23690]<<8|(l[23691]<<16|l[23692]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23685]|l[23686]<<8|(l[23687]<<16|l[23688]<<24),f=l[23681]|l[23682]<<8|(l[23683]<<16|l[23684]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(l2(r,f),f=i[e+176>>2],t=i[e+180>>2],(f|0)!=(t|0))for(;;){if(l2(r,l[f+1|0]|l[f|0]<<7&128),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(e=E(24),i[n+20>>2]=e,i[n+24>>2]=23,i[n+28>>2]=-2147483624,r=l[23793]|l[23794]<<8|(l[23795]<<16|l[23796]<<24),f=l[23789]|l[23790]<<8|(l[23791]<<16|l[23792]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+23|0]=0,r=l[23808]|l[23809]<<8|(l[23810]<<16|l[23811]<<24),f=l[23804]|l[23805]<<8|(l[23806]<<16|l[23807]<<24),u[e+15|0]=f,u[e+16|0]=f>>>8,u[e+17|0]=f>>>16,u[e+18|0]=f>>>24,u[e+19|0]=r,u[e+20|0]=r>>>8,u[e+21|0]=r>>>16,u[e+22|0]=r>>>24,r=l[23801]|l[23802]<<8|(l[23803]<<16|l[23804]<<24),f=l[23797]|l[23798]<<8|(l[23799]<<16|l[23800]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,k),k=i[f+4>>2],o=i[f+8>>2],(k|0)!=(o|0))for(;;){if(w=i[k+4>>2]-i[k>>2]|0,w>>>0>=65536){if(e=E(24),i[n+20>>2]=e,i[n+24>>2]=18,i[n+28>>2]=-2147483624,r=l[25192]|l[25193]<<8|(l[25194]<<16|l[25195]<<24),f=l[25188]|l[25189]<<8|(l[25190]<<16|l[25191]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[25204]|l[25205]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[25200]|l[25201]<<8|(l[25202]<<16|l[25203]<<24),f=l[25196]|l[25197]<<8|(l[25198]<<16|l[25199]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,w),V4(r,k),k=k+12|0,(o|0)==(k|0))break}if(f=f+16|0,(t|0)==(f|0))break}if(f1(n,e,r,_),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function Xf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0,b1=0,G4=0,W4=0,X4=0,j4=0,O4=0,L4=0,c8=0,b8=0,yi=0,Yi=0;i:{e:{w=i[A+276>>2],e0=(f|0)<(w|0)?f:w;r:{if((e0|0)<=(r|0)||(h0=i[A+272>>2],r0=(k|0)<(h0|0)?k:h0,(r0|0)<=0))break r;for(a=i[A+124>>2],m0=i[a+16856>>2],H2=m0<<(e^1),W0=i[a+16852>>2],T2=W0<<e,b2=A+4|0,e1=3-m0|0,W1=3-W0|0,f=i[a+16840>>2],J1=f-8|0,s=-1<<f^-1,W=i[A+44>>2],N0=G(W,6),U0=W<<2,R=W<<1,D0=0-R|0,x1=i[A+260>>2],$=G(W,6),b1=0-W<<1,G4=1-W<<1,W4=2-W<<1,X4=3-W<<1;;){for(f=r<<e1,H0=G(f,W),j4=H0+W|0,f0=G(f,m0),O4=f0-1|0,L4=G((f0|0)/4|0,h0)+x1|0,A0=0;;){if(k=A0<<W1,n0=G(k,W0),f=l[((n0|0)/4|0)+L4|0]&3,f>>>0>1)for(w=1,c8=k+j4<<1,b8=(f<<1)-2|0,f=i[A+168>>2],V=n0-1>>f,y=O4>>f,Q0=f0>>f,V0=n0>>f,L0=k+H0<<1,yi=L0+D0|0,Yi=i[A+132>>2],f=1;;){k=i[(f<<2)+b2>>2],_=k+L0|0;f:{if(!e){N=_+6|0,D=_+4|0,x=_+2|0,f=k+c8|0,S=f+6|0,B=f+4|0,k=k+yi|0,O=k+6|0,n=k+2|0,g=k+D0|0,t=g+6|0,I=g+4|0,C=g+2|0,L=f+2|0,o=k+4|0;break f}g=_-4|0,t=$+g|0,f=_+2|0,S=$+f|0,h=R<<1,I=h+g|0,B=f+h|0,C=g+R|0,k=_-2|0,O=$+k|0,n=k+R|0,N=_+$|0,D=h+_|0,x=_+R|0,L=f+R|0,o=k+h|0}if((V0|0)<0||(h=i[A+172>>2],(h|0)<=(V0|0)))break e;if((Q0|0)<0||(m=i[A+176>>2],(m|0)<=(Q0|0)))break i;q0=F[t>>1],$0=F[I>>1],P0=F[C>>1],d0=F[g>>1],O=F[O>>1],o=F[o>>1],n=F[n>>1],t=F[k>>1],n2=F[S>>1],Z2=F[B>>1],g2=F[L>>1],Q2=F[f>>1],N=F[N>>1],D=F[D>>1],x=F[x>>1],S=F[_>>1],g=w,k=i[(w?32:36)+Yi>>2],I=i[A+160>>2],C=I+G(V0,3)|0,L=G(G(h,Q0),3),w=C+L|0,B=u[w+2|0];f:{if(!e){if((y|0)<0|(m|0)<=(y|0))break i;f=(C+G(G(h,y),3)|0)+2|0;break f}if((V|0)<0|h>>>0<=V>>>0)break e;f=(L+(I+G(V,3)|0)|0)+2|0}k=k+((B+u[f|0]|0)+1>>1)|0;f:{if(i[a+16848>>2]!=1){k=(k|0)>=51?51:k;break f}if((k|0)<30)break f;if(k>>>0<=42){k=i[(k<<2)+63720>>2];break f}k=k-6|0}if(B=i[A+148>>2],f=n0>>B,(f|0)<0||(E2=i[A+152>>2],(f|0)>=(E2|0)))break e;if(B=f0>>B,(B|0)<0|(B|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(F[((i[A+140>>2]+G(f,24)|0)+G(G(B,E2),24)|0)+2>>1]<<2)>>2]+768>>2]+(k+b8|0)|0,f=(f|0)>=53?53:f,f=l[((f|0)>0?f:0)+60816|0]<<J1,B=l[a+8812|0];f:{A:{if(!e){if(B){if((y|0)<0|(m|0)<=(y|0))break i;I=!(l[(C+G(G(h,y),3)|0)+1|0]&4)}else I=1;if((y|0)<0|(m|0)<=(y|0))break i;if(k=0-f|0,m=(((S-t<<2)+d0|0)-Q2|0)+4>>3,m=(k|0)>(m|0)?k:(f|0)>(m|0)?m:f,w=l[w|0]|l[w+1|0]<<8,w=!(w&2048)&(!B|!(w&1024)),h=I&!(l[(C+G(G(h,y),3)|0)+1|0]&8),h&&(t=t+m|0,Q[_+b1>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),w&&(t=S-m|0,Q[_>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),t=(((x-n<<2)+P0|0)-g2|0)+4>>3,t=(k|0)>(t|0)?k:(f|0)>(t|0)?t:f,h&&(n=n+t|0,Q[_+G4>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),w&&(n=x-t|0,Q[_+2>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((D-o<<2)+$0|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,h&&(o=n+o|0,Q[_+W4>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),w&&(o=D-n|0,Q[_+4>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),o=(((N-O<<2)+q0|0)-n2|0)+4>>3,f=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,h&&(k=f+O|0,Q[_+X4>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!w)break f;k=N-f|0,f=6;break A}if(B){if((V|0)<0|h>>>0<=V>>>0)break e;m=!(l[(L+(I+G(V,3)|0)|0)+1|0]&4)}else m=1;if((V|0)<0|h>>>0<=V>>>0)break e;if(k=0-f|0,h=(((S-t<<2)+d0|0)-Q2|0)+4>>3,C=(k|0)>(h|0)?k:(f|0)>(h|0)?h:f,w=l[w|0]|l[w+1|0]<<8,w=!(w&2048)&(!B|!(w&1024)),h=_-2|0,B=m&!(l[(L+(I+G(V,3)|0)|0)+1|0]&8),B&&(t=t+C|0,Q[h>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),w&&(t=S-C|0,Q[_>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),t=(((x-n<<2)+P0|0)-g2|0)+4>>3,t=(k|0)>(t|0)?k:(f|0)>(t|0)?t:f,B&&(n=n+t|0,Q[h+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),w&&(n=x-t|0,Q[_+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((D-o<<2)+$0|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,B&&(o=n+o|0,Q[h+U0>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),w&&(o=D-n|0,Q[_+U0>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),o=(((N-O<<2)+q0|0)-n2|0)+4>>3,f=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,B&&(k=f+O|0,Q[h+N0>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!w)break f;k=N-f|0,f=N0}Q[f+_>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0}if(f=2,w=0,!g)break}if(A0=A0+T2|0,!((r0|0)>(A0|0)))break}if(r=r+H2|0,!((e0|0)>(r|0)))break}}return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function n9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;m=v-6240|0,v=m,g=e+96|0,I=e+480|0,C=e+2016|0;i:{for(;;){for(_=h?64:16,W=(h|0)==3,V=W?3:1,B=(m+6144|0)+G(h,24)|0,k=0;;){n=k<<10,f=n+m|0;e:{r:{f:{A:{k:{if(!(v0(A,1)&255)){if(r=f2(A),(r|0)==-99999||(r=W?G(r,3):r,(r|0)>(k|0)))break f;if(t=B+(k<<2)|0,i[t>>2]=16,!r){if(!h){r=i[26775],i[f+8>>2]=i[26774],i[f+12>>2]=r,r=i[26773],i[f>>2]=i[26772],i[f+4>>2]=r;break r}if(k>>>0<=2){r=i[26791],i[f+56>>2]=i[26790],i[f+60>>2]=r,r=i[26789],i[f+48>>2]=i[26788],i[f+52>>2]=r,r=i[26787],i[f+40>>2]=i[26786],i[f+44>>2]=r,r=i[26785],i[f+32>>2]=i[26784],i[f+36>>2]=r,r=i[26783],i[f+24>>2]=i[26782],i[f+28>>2]=r,r=16,t=i[26781],i[f+16>>2]=i[26780],i[f+20>>2]=t,t=i[26779],i[f+8>>2]=i[26778],i[f+12>>2]=t,t=i[26777],i[f>>2]=i[26776],i[f+4>>2]=t;break k}r=i[26807],i[f+56>>2]=i[26806],i[f+60>>2]=r,r=i[26805],i[f+48>>2]=i[26804],i[f+52>>2]=r,r=i[26803],i[f+40>>2]=i[26802],i[f+44>>2]=r,r=i[26801],i[f+32>>2]=i[26800],i[f+36>>2]=r,r=i[26799],i[f+24>>2]=i[26798],i[f+28>>2]=r,r=16,t=i[26797],i[f+16>>2]=i[26796],i[f+20>>2]=t,t=i[26795],i[f+8>>2]=i[26794],i[f+12>>2]=t,t=i[26793],i[f>>2]=i[26792],i[f+4>>2]=t;break k}if((h|0)==3&(r|0)!=3)break A;r=k-r|0,_&&z(f,(r<<10)+m|0,_),r=i[B+(r<<2)>>2],i[t>>2]=r;break k}n:{if(h>>>0<2){t=8,r=16;break n}if(r=q1(A),r-248>>>0<4294967041)break f;t=r+8|0,i[B+(k<<2)>>2]=t,r=t}for(s=0;;){if(o=q1(A),o+128>>>0>255)break f;if(t=t+o|0,u[f+s|0]=t,s=s+1|0,(_|0)==(s|0))break}}k:switch(h|0){case 1:for(r=(k<<6)+g|0,s=0,t=i[i[15786]+12>>2];n=t+(s<<1)|0,u[(r+(l[n+1|0]<<3)|0)+l[n|0]|0]=l[f+s|0],n=s|1,o=t+(n<<1)|0,u[(r+(l[o+1|0]<<3)|0)+l[o|0]|0]=l[f+n|0],s=s+2|0,(s|0)!=64;);break e;case 2:for(n=(k<<8)+I|0,w=n+1|0,t=0,y=i[i[15786]+12>>2];s=(t<<1)+y|0,o=l[f+t|0],u[(n+(l[s|0]<<1)|0)+(l[s+1|0]<<5)|0]=o,u[((l[s|0]<<1)+w|0)+(l[s+1|0]<<5)|0]=o,u[((n+(l[s|0]<<1)|0)+(l[s+1|0]<<5)|0)+16|0]=o,u[(((l[s|0]<<1)+w|0)+(l[s+1|0]<<5)|0)+16|0]=o,t=t+1|0,(t|0)!=64;);u[n|0]=r;break e;case 0:break r;case 3:break k;default:break e}t=n+C|0,G8(t,f,3),u[t|0]=r;break e}M0(21397,18199,934,3595),H()}A=8;break i}G8((k<<4)+e|0,f,0)}if(k=k+V|0,!(k>>>0<6))break}if(h=h+1|0,(h|0)==4)break}for(s=e+96|0,h=e- -64|0,_=e+32|0,B=e+160|0,A=0,t=i[i[15786]+12>>2];r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+3040|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+3040|0]=l[e+160|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+224|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+4064|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+4064|0]=l[e+224|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+352|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+6112|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+6112|0]=l[e+352|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+416|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+7136|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);u[e+7136|0]=l[e+416|0],A=0}return v=m+6240|0,A}function kv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;o=v-48|0,v=o,i[o+44>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[o>>2]=s,(s|0)!=129624&&(i[s+4>>2]=i[s+4>>2]+1),s=c0(o,129800),e2(o);i:{e:{r:{f:switch(t-65|0){case 0:case 32:Gl(A,n+24|0,o+44|0,r,k,s);break e;case 1:case 33:case 39:Bl(A,n+16|0,o+44|0,r,k,s);break e;case 34:e=X[i[i[A+8>>2]+12>>2]](A+8|0)|0,t=A,w=i[o+44>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=T8(t,w,r,f,k,n,s,A+(e<<2)|0),i[h+44>>2]=_;break e;case 35:case 36:A=g8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:t=i[19471],i[o+24>>2]=i[19470],i[o+28>>2]=t,t=i[19469],i[o+16>>2]=i[19468],i[o+20>>2]=t,t=i[19467],i[o+8>>2]=i[19466],i[o+12>>2]=t,t=i[19465],i[o>>2]=i[19464],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 5:t=i[19479],i[o+24>>2]=i[19478],i[o+28>>2]=t,t=i[19477],i[o+16>>2]=i[19476],i[o+20>>2]=t,t=i[19475],i[o+8>>2]=i[19474],i[o+12>>2]=t,t=i[19473],i[o>>2]=i[19472],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 7:A=g8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=g8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=g8(o+44|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=g8(o+44|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=g8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=o+44|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(q2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=X[i[i[r>>2]+36>>2]](r)|0;break k}r=i[f>>2]}if(!(X[i[i[s>>2]+12>>2]](s,1,r)|0))break A;a1(A);continue}break}q2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:t=o+44|0,e=X[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(l[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=l[e+11|0]&127}l[e+23|0]>>>7|0?f=i[e+16>>2]:f=l[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=gr(t,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:z(o,77920,44),h=o,_=T8(A,e,r,f,k,n,o,o+44|0),i[h+44>>2]=_;break e;case 17:i[o+16>>2]=i[19496],t=i[19495],i[o+8>>2]=i[19494],i[o+12>>2]=t,t=i[19493],i[o>>2]=i[19492],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+20|0),i[h+44>>2]=_;break e;case 18:A=g8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:t=i[19507],i[o+24>>2]=i[19506],i[o+28>>2]=t,t=i[19505],i[o+16>>2]=i[19504],i[o+20>>2]=t,t=i[19503],i[o+8>>2]=i[19502],i[o+12>>2]=t,t=i[19501],i[o>>2]=i[19500],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 54:A=g8(o+44|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=X[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=X[i[i[A+8>>2]+24>>2]](A+8|0)|0,t=A,w=i[o+44>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=T8(t,w,r,f,k,n,s,A+(e<<2)|0),i[h+44>>2]=_;break e;case 56:Ul(n+20|0,o+44|0,r,k,s);break e;case 24:A=g8(o+44|0,r,k,s,4),l[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((t|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=o+44|0,n=A+12|0,e=6;r:{f:{if(q2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=X[i[i[e>>2]+36>>2]](e)|0;break A}f=i[f>>2]}if(e=4,(X[i[i[s>>2]+52>>2]](s,f,0)|0)!=37)break f;if(!q2(a1(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[o+44>>2]}return v=o+48|0,A|0}function nv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]),o=l[e+97|0];i:{if(o>>>0>=2){t1(A,e,4446);break i}if(n=F0(r),n>>>0>u0[f+80>>2]){if(e=E(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17300]|l[17301]<<8|(l[17302]<<16|l[17303]<<24),f=l[17296]|l[17297]<<8|(l[17298]<<16|l[17299]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17353]|l[17354]<<8|(l[17355]<<16|l[17356]<<24),f=l[17349]|l[17350]<<8|(l[17351]<<16|l[17352]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17348]|l[17349]<<8|(l[17350]<<16|l[17351]<<24),f=l[17344]|l[17345]<<8|(l[17346]<<16|l[17347]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17340]|l[17341]<<8|(l[17342]<<16|l[17343]<<24),f=l[17336]|l[17337]<<8|(l[17338]<<16|l[17339]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17332]|l[17333]<<8|(l[17334]<<16|l[17335]<<24),f=l[17328]|l[17329]<<8|(l[17330]<<16|l[17331]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17324]|l[17325]<<8|(l[17326]<<16|l[17327]<<24),f=l[17320]|l[17321]<<8|(l[17322]<<16|l[17323]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17316]|l[17317]<<8|(l[17318]<<16|l[17319]<<24),f=l[17312]|l[17313]<<8|(l[17314]<<16|l[17315]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17308]|l[17309]<<8|(l[17310]<<16|l[17311]<<24),f=l[17304]|l[17305]<<8|(l[17306]<<16|l[17307]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(K4(A,e+116|0,n<<3,f,13726),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{s=i[e+104>>2],t=i[e+108>>2]-s>>3;r:{f:{if(t>>>0<n>>>0){ui(f,n-t|0);break f}if(n>>>0<t>>>0&&(i[e+108>>2]=s+(n<<3)),!n)break r}if(e=0,!o)for(;;){if(!i[r+16>>2])break e;if(t=F0(r),o=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break r}for(;;){if(!i[r+16>>2])break e;if(t=F0(r),o=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,K(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}i[k+116>>2]=0,i[k+88>>2]=72244,i[k+32>>2]=72224,r=i[18065],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[18066],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,t=k+36|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[k+32>>2]=f,o=k+32|0,i[o+i[f-12>>2]>>2]=i[18068],f=i[18064],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[18069],i[k+88>>2]=72244,i[k+24>>2]=72204,i[k+32>>2]=72224,f=R0(t),i[f>>2]=71280,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(I0(Y(I0(Y(o,28161,24),n),28970,33),e),5504,8),e=i[k+84>>2];e:{r:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break r}if(!(e&8)){r=0,u[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}r:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){t=r|7,e=E(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(u[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}g0(),H()}if(!r)break e;z(e,n,r)}u[e+r|0]=0,K(A,2,100,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18063],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18071],i[k+32>>2]=i[18072],i[f>>2]=71280,u[k+79|0]<0&&Z(i[k+68>>2]),y0(f),p0(k+88|0)}v=k+192|0}function tv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0;t=v-32|0,v=t,s=u1(i[r>>2],6),h=l[k+8|0];i:{e:{r:{if((j0(i[r>>2],3)|0)!=8||(j0(i[r>>2],4)|0)!=8)break r;if((j0(i[r>>2],5)|0)==8)break e}e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}e:{if(!s||(j0(i[r>>2],6)|0)==8)break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],k=e+1|0,i[n+4>>2]=k,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],g=n+12|0,i[n+96>>2]=g,i[n+8>>2]=e+1,i[n+100>>2]=n,k||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],B=i[e+108>>2],k=B,R=i[e+112>>2],e=R,i[g+120>>2]=h&1?11:10,i[g+116>>2]=1,i[g+112>>2]=e,i[g+108>>2]=k,T0(t+8|0,g,10,k,e,8,o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),r=i[r>>2],e=r+128|0;r:{f:{if(k=i[r+128>>2],k){for(o=e,r=k;w=i[r+16>>2]<3,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);I=0;A:{if((e|0)==(o|0)||(I=0,i[o+16>>2]>3))break A;N=i[o+44>>2],I=i[o+56>>2]}for(o=e,r=k;w=i[r+16>>2]<4,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);C=0;A:{if((e|0)==(o|0)||(C=0,i[o+16>>2]>4))break A;D=i[o+56>>2],C=i[o+44>>2]}for(o=e,r=k;w=i[r+16>>2]<5,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}y=0;break r}if(y=0,i[o+16>>2]>5)break r;x=i[o+56>>2],y=i[o+44>>2]}r=i[f>>2],w=0;r:{if(!r)break r;for(o=f;w=i[r+16>>2]<10,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)==(o|0)){w=0;break r}if(w=0,i[o+16>>2]>10)break r;S=i[o+56>>2],w=i[o+44>>2]}o=0,f=0;r:{if(!k|s^1)break r;for(r=e;f=i[k+16>>2]<6,r=f?r:k,k=i[(f?4:0)+k>>2],!!k;);if(f=0,(e|0)==(r|0)||(f=0,i[r+16>>2]>6))break r;o=i[r+56>>2],f=i[r+44>>2]}r:{if(!R)break r;if((s&h)==1){if(!B)break r;for(e=0;;){for(m=f+G(e,o)|0,W=y+G(e,x)|0,s=G(e,D)+C|0,h=G(e,S)+w|0,k=G(e,I)+N|0,r=0;_=h+(r<<2)|0,u[_|0]=l[r+k|0],u[_+1|0]=l[r+s|0],u[_+2|0]=l[r+W|0],u[_+3|0]=l[r+m|0],r=r+1|0,(B|0)!=(r|0););if(e=e+1|0,(R|0)==(e|0))break}break r}if(h&1){if(!B)break r;for(h=B&-2,o=B&1,f=0;;){if(V=y+G(f,x)|0,_=G(f,D)+C|0,m=G(f,S)+w|0,W=G(f,I)+N|0,r=0,e=0,(B|0)!=1)for(;s=m+(r<<2)|0,u[s|0]=l[r+W|0],u[s+1|0]=l[r+_|0],k=l[r+V|0],u[s+3|0]=255,u[s+2|0]=k,k=r|1,s=m+(k<<2)|0,u[s|0]=l[k+W|0],u[s+1|0]=l[k+_|0],k=l[k+V|0],u[s+3|0]=255,u[s+2|0]=k,r=r+2|0,e=e+2|0,(h|0)!=(e|0););if(o&&(k=m+(r<<2)|0,u[k|0]=l[r+W|0],u[k+1|0]=l[r+_|0],e=l[r+V|0],u[k+3|0]=255,u[k+2|0]=e),f=f+1|0,(R|0)==(f|0))break}break r}if(!B)break r;for(o=B&-2,k=B&1,f=0;;){if(V=y+G(f,x)|0,_=G(f,D)+C|0,m=G(f,S)+w|0,W=G(f,I)+N|0,r=0,e=0,(B|0)!=1)for(;h=m+G(r,3)|0,u[h|0]=l[r+W|0],u[h+1|0]=l[r+_|0],u[h+2|0]=l[r+V|0],s=r|1,h=m+G(s,3)|0,u[h|0]=l[s+W|0],u[h+1|0]=l[s+_|0],u[h+2|0]=l[s+V|0],r=r+2|0,e=e+2|0,(o|0)!=(e|0););if(k&&(e=m+G(r,3)|0,u[e|0]=l[r+W|0],u[e+1|0]=l[r+_|0],u[e+2|0]=l[r+V|0]),f=f+1|0,(R|0)==(f|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=g;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+32|0}function gf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0,m0=0,W0=0,Q0=0,V0=0,e0=0,r0=0,N0=0,U0=0,D0=0,H0=0,L0=0,q0=0,$0=0,P0=0,d0=0,n2=0,Z2=0,g2=0,Q2=0,E2=0,H2=0,T2=0,b2=0,e1=0,W1=0,J1=0,x1=0,b1=0;i:{e:{C=i[A+276>>2],H0=(f|0)<(C|0)?f:C;r:{if((H0|0)<=(r|0)||(f=i[A+272>>2],L0=(f|0)>(k|0)?k:f,(L0|0)<=0))break r;for(D=i[A+124>>2],U0=i[D+16856>>2],Z2=U0<<(e^1),D0=i[D+16852>>2],g2=D0<<e,Q2=A+4|0,E2=3-U0|0,H2=3-D0|0,t=-1<<i[D+16840>>2]^-1,_=i[A+44>>2],x=G(_,3),S=_<<1,T2=3-_|0,b2=2-_|0,e1=1-_|0,W1=0-_|0;;){for(q0=r<<E2,h0=G(q0,U0),$0=h0-1|0,J1=(h0|0)/4|0,m0=0;;){if(W0=m0<<H2,Q0=G(D0,W0),f=l[(i[A+260>>2]+((Q0|0)/4|0)|0)+G(i[A+272>>2],J1)|0]&3,f>>>0>1)for(x1=W0-_|0,P0=Q0-1|0,n=1,b1=(f<<1)-2|0,f=1;;){k=G(i[A+44>>2],q0),o=i[(f<<2)+Q2>>2],s=k+(o+W0|0)|0;f:{if(!e){C=k+x1|0,f=C+o|0,N=f+3|0,y=f+1|0,k=o+(k+W0|0)|0,O=k+3|0,h=k+2|0,m=k+1|0,W=o+(C-_|0)|0,a=W+3|0,$=W+2|0,f0=W+1|0,g=k+_|0,A0=g+3|0,n0=g+2|0,V=g+1|0,C=f+2|0;break f}O=s+x|0,h=s+S|0,m=s+_|0,W=s-2|0,a=x+W|0,g=s+1|0,A0=x+g|0,$=W+S|0,n0=g+S|0,f0=_+W|0,V=_+g|0,f=s-1|0,N=x+f|0,y=f+_|0,k=s,C=f+S|0}if(L=i[A+168>>2],B=Q0>>L,(B|0)<0||(R=i[A+172>>2],(R|0)<=(B|0)))break e;if(o=h0>>L,(o|0)<0||(I=i[A+176>>2],(I|0)<=(o|0)))break i;d0=l[a|0],n2=l[$|0],a=l[f0|0],$=l[W|0],V0=l[N|0],e0=l[C|0],r0=l[y|0],N0=l[f|0],f0=l[A0|0],A0=l[n0|0],n0=l[V|0],V=l[g|0],O=l[O|0],W=l[h|0],g=l[m|0],N=l[k|0],C=n,k=i[i[A+132>>2]+(n?32:36)>>2],h=i[A+160>>2],m=h+G(B,3)|0,B=G(G(o,R),3),y=m+B|0,o=u[y+2|0];f:{if(!e){if(n=$0>>L,(n|0)<0|(n|0)>=(I|0))break i;f=(m+G(G(n,R),3)|0)+2|0;break f}if(n=P0>>L,(n|0)<0|n>>>0>=R>>>0)break e;f=(B+(h+G(n,3)|0)|0)+2|0}f=k+((o+u[f|0]|0)+1>>1)|0;f:{if(i[D+16848>>2]!=1){f=(f|0)>=51?51:f;break f}if((f|0)<30)break f;if(f>>>0<=42){f=i[(f<<2)+63720>>2];break f}f=f-6|0}if(n=i[A+148>>2],o=Q0>>n,(o|0)<0||(k=i[A+152>>2],(k|0)<=(o|0)))break e;if(n=h0>>n,(n|0)<0|(n|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(F[((i[A+140>>2]+G(o,24)|0)+G(G(k,n),24)|0)+2>>1]<<2)>>2]+768>>2]+(f+b1|0)|0,f=(f|0)>=53?53:f,w=l[((f|0)>0?f:0)+60816|0]<<i[D+16840>>2]-8,o=l[D+8812|0];f:{A:{if(!e){if(B=$0>>L,o){if((B|0)<0|(B|0)>=(I|0))break i;n=!(l[(m+G(G(B,R),3)|0)+1|0]&4)}else n=1;if((B|0)<0|(B|0)>=(I|0))break i;if(h=0-w|0,f=(((N-N0<<2)+$|0)-V|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,f=l[y|0]|l[y+1|0]<<8,o=!(f&2048)&(!o|!(f&1024)),n=n&!(l[(m+G(G(B,R),3)|0)+1|0]&8),n&&(f=k+N0|0,u[s+W1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=N-k|0,u[s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((g-r0<<2)+a|0)-n0|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(f=k+r0|0,u[s+e1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=g-k|0,u[s+1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((W-e0<<2)+n2|0)-A0|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(f=k+e0|0,u[s+b2|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=W-k|0,u[s+2|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((O-V0<<2)+d0|0)-f0|0)+4>>3,f=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(k=f+V0|0,u[s+T2|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),!o)break f;k=3;break A}if(m=P0>>L,o){if((m|0)<0|m>>>0>=R>>>0)break e;n=!(l[(B+(h+G(m,3)|0)|0)+1|0]&4)}else n=1;if((m|0)<0|m>>>0>=R>>>0)break e;if(I=0-w|0,f=(((N-N0<<2)+$|0)-V|0)+4>>3,k=(f|0)<(I|0)?I:(f|0)<(w|0)?f:w,f=l[y|0]|l[y+1|0]<<8,V=!(f&2048)&(!o|!(f&1024)),o=s-1|0,n=n&!(l[(B+(h+G(m,3)|0)|0)+1|0]&8),n&&(f=k+N0|0,u[o|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),V&&(f=N-k|0,u[s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((g-r0<<2)+a|0)-n0|0)+4>>3,k=(f|0)<(I|0)?I:(f|0)<(w|0)?f:w,n&&(f=k+r0|0,u[o+_|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),V&&(f=g-k|0,u[s+_|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((W-e0<<2)+n2|0)-A0|0)+4>>3,k=(f|0)<(I|0)?I:(f|0)<(w|0)?f:w,n&&(f=k+e0|0,u[o+S|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),V&&(f=W-k|0,u[s+S|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((O-V0<<2)+d0|0)-f0|0)+4>>3,f=(f|0)<(I|0)?I:(f|0)<(w|0)?f:w,n&&(k=f+V0|0,u[o+x|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),!V)break f;k=x}f=O-f|0,u[k+s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0}if(f=2,n=0,!C)break}if(m0=m0+g2|0,!((L0|0)>(m0|0)))break}if(r=r+Z2|0,!((H0|0)>(r|0)))break}}return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function uv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=M(0),m0=M(0),W0=M(0),Q0=M(0);t=v-48|0,v=t;i:{e:{r:{if((j0(i[r>>2],0)|0)!=8||(j0(i[r>>2],1)|0)!=8)break r;if((j0(i[r>>2],2)|0)==8)break e}e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,k=n+140|0,i[n+136>>2]=k,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],h=n+12|0,i[n+96>>2]=h,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],I=i[e+108>>2],f=I,C=i[e+112>>2],e=C,i[h+120>>2]=11,i[h+116>>2]=1,i[h+112>>2]=e,i[h+108>>2]=f,T0(t+24|0,h,10,f,e,8,o);e:{if(i[t+24>>2]){if(e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,r=A+8|0,u[t+43|0]>=0){e=i[t+36>>2],i[r>>2]=i[t+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+40>>2],u[A+20|0]=1;break e}if(T(r,i[t+32>>2],i[t+36>>2]),e=u[t+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+32>>2]);break e}u[t+43|0]<0&&Z(i[t+32>>2]),i[t+36>>2]=-1086926434,i[t+40>>2]=1071829221,i[t+28>>2]=1068725436,i[t+32>>2]=-1095748968,u[t+24|0]=1,S4(i[r>>2])&&(f=i[r>>2],e=F[f+6>>1]|F[f+8>>1]<<16,le(t+4|0,(F[f+10>>1]|F[f+12>>1]<<16)&65535,e&65535),i[t+40>>2]=i[t+20>>2],e=i[t+16>>2],i[t+32>>2]=i[t+12>>2],i[t+36>>2]=e,e=i[t+8>>2],i[t+24>>2]=i[t+4>>2],i[t+28>>2]=e),h0=E0[t+40>>2],m0=E0[t+32>>2],W0=E0[t+36>>2],Q0=E0[t+28>>2],s=u1(i[r>>2],6),e=i[r>>2],o=i[e+128>>2],S=u6(M(h0*M(256))),O=u6(M(m0*M(256))),L=u6(M(W0*M(256))),a=u6(M(Q0*M(256)));r:{f:{if(o){for(e=e+128|0,f=e,r=o;w=i[r+16>>2],f=(w|0)<0?f:r,r=i[(w>>>29&4)+r>>2],!!r;);B=0;A:{if((e|0)==(f|0)||(B=0,i[f+16>>2]>0))break A;$=i[f+56>>2],B=i[f+44>>2]}for(f=e,r=o;w=i[r+16>>2]<=0,f=w?f:r,r=i[(w?4:0)+r>>2],!!r;);m=0;A:{if((e|0)==(f|0)||(m=0,i[f+16>>2]>1))break A;f0=i[f+44>>2],m=i[f+56>>2]}for(f=e,r=o;w=i[r+16>>2]<2,f=w?f:r,r=i[(w?4:0)+r>>2],!!r;);r=0;A:{if((e|0)==(f|0)||(r=0,i[f+16>>2]>2))break A;A0=i[f+56>>2],r=i[f+44>>2]}if(w=r,f=0,!s)break r;for(r=e;f=i[o+16>>2]<6,r=f?r:o,o=i[(f?4:0)+o>>2],!!o;);if((e|0)!=(r|0))break f}f=0;break r}if(f=0,i[r+16>>2]>6)break r;g=i[r+56>>2],f=i[r+44>>2]}r=i[k>>2],e=0;r:{if(!r)break r;for(o=k;e=i[r+16>>2]<10,o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(o|0)||(e=0,i[o+16>>2]>10))break r;n0=i[o+56>>2],e=i[o+44>>2]}k=e;r:{if(!C|!I)break r;if(e=0,s)for(;;){for(W=f+G(e,g)|0,y=k+G(e,n0)|0,R=G(e,$)+B|0,r=e>>>1|0,N=G(r,A0)+w|0,D=G(r,m)+f0|0,r=0;s=r>>>1|0,o=l[s+N|0],V=y+(r<<2)|0,x=l[r+R|0],s=l[s+D|0]-128|0,_=x+(G(s,S)+128>>8)|0,u[V+2|0]=(_|0)>=0?_>>>0>=255?255:_:0,o=o-128|0,_=x+(G(o,a)+128>>8)|0,u[V|0]=(_|0)>=0?_>>>0>=255?255:_:0,o=x+((G(s,O)+G(o,L)|0)+128>>8)|0,u[V+1|0]=(o|0)>=0?o>>>0>=255?255:o:0,u[V+3|0]=l[r+W|0],r=r+1|0,(I|0)!=(r|0););if(e=e+1|0,(C|0)==(e|0))break r}for(;;){for(y=k+G(e,n0)|0,R=G(e,$)+B|0,r=e>>>1|0,N=G(r,A0)+w|0,D=G(r,m)+f0|0,r=0;f=r>>>1|0,s=l[f+N|0],g=l[r+R|0],f=l[f+D|0],W=y+(r<<2)|0,u[W+3|0]=255,o=f-128|0,f=g+(G(o,S)+128>>8)|0,u[W+2|0]=(f|0)>=0?f>>>0>=255?255:f:0,f=s-128|0,s=g+(G(f,a)+128>>8)|0,u[W|0]=(s|0)>=0?s>>>0>=255?255:s:0,f=g+((G(o,O)+G(f,L)|0)+128>>8)|0,u[W+1|0]=(f|0)>=0?f>>>0>=255?255:f:0,r=r+1|0,(I|0)!=(r|0););if(e=e+1|0,(C|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=h;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+48|0}function ov(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;k=v-144|0,v=k,i[k+104>>2]=0,i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,u[k+119|0]=0,u[k+120|0]=0,u[k+121|0]=0,u[k+122|0]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+136>>2]=0,u[k+132|0]=1,t=E(168),i[t>>2]=92332,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,e=t,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[o>>2]=100160,u[e+120|0]=0,i[e+116>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,Q[e+128>>1]=2056,i[e+124>>2]=1,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+32>>2]=1635148611,s=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+92>>2]=e,i[k+88>>2]=s,X[i[i[f>>2]+100>>2]](k+76|0,i[f+4>>2],k+88|0,n);i:{e:{r:{n=i[k+76>>2];f:{if(n){if(r=i[k+80>>2],o=i[k+84>>2],e=h2(o),e>>>0>=2147483640)break r;A:{k:{if(e>>>0>=11){s=e|7,f=E(s+1|0),i[k+52>>2]=s-2147483647,i[k+44>>2]=f,i[k+48>>2]=e;break k}if(u[k+55|0]=e,f=k+44|0,!e)break A}if(!e)break A;z(f,o,e)}u[e+f|0]=0,e=K(k+56|0,n,r,k+44|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}if(i[k+40>>2]=0,i[k+36>>2]=0,X[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),e=i[k+44>>2],e)for(s=t+116|0;;){n=i[k+32>>2];A:{k:switch((l[e|0]&31)-7|0){case 0:A9(k+12|0,e,n,s,k+40|0,k+36|0),u[k+31|0]<0&&Z(i[k+20>>2]),i[k+124>>2]=i[k+40>>2],i[k+128>>2]=i[k+36>>2],tt(o,i[k+44>>2],i[k+32>>2]);break A;case 6:ut(o,e,n);break A;case 1:ot(o,e,n);break A;default:break k}Wi(k+96|0,e,n)}if(X[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),e=i[k+44>>2],!e)break}if(!(i[k+36>>2]&&i[k+40>>2])){u[k+44|0]=0,u[k+55|0]=0,e=K(k+56|0,8,129,k+44|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}i[t+4>>2]=i[t+4>>2]+1,e=i[k+100>>2],w=i[k+104>>2];A:{if(e>>>0<w>>>0){i[e+4>>2]=t,i[e>>2]=o,e=e+8|0;break A}if(s=i[k+96>>2],e=e-s|0,_=e>>3,n=_+1|0,n>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:n>>>0<h>>>0?h:n,w){if(w>>>0>=536870912)break i;n=E(w<<3)}else n=0;if(h=n+e|0,i[h+4>>2]=t,i[h>>2]=o,o=h-(_<<3)|0,e&&z(o,s,e),i[k+104>>2]=n+(w<<3),e=h+8|0,i[k+100>>2]=e,i[k+96>>2]=o,!s)break A;Z(s)}i[k+100>>2]=e,n=i[f>>2];A:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break A;e=i[r>>2],r=i[e+108>>2],i[k+56>>2]=r,e=i[e+112>>2],i[k+44>>2]=e,X[n|0](i[f+4>>2],r,e,k+56|0,k+44|0),e=i[k+100>>2]}Q[k+120>>1]=257,r=i[k+96>>2],i[k+96>>2]=0,f=i[k+104>>2],n=i[k+108>>2],i[k+100>>2]=0,i[k+104>>2]=0,o=i[k+112>>2],s=i[k+116>>2],i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,i[A+16>>2]=o,i[A+20>>2]=s,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=e,i[A>>2]=r,e=i[k+124>>2],i[A+24>>2]=i[k+120>>2],i[A+28>>2]=e,e=i[k+132>>2],i[A+32>>2]=i[k+128>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+136>>2],u[A+44|0]=0}A=i[k+92>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(X[i[i[t>>2]+8>>2]](t),p(t)),A=i[k+108>>2],A&&(i[k+112>>2]=A,Z(A)),A=i[k+96>>2],A){if(e=A,r=i[k+100>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+96>>2]}i[k+100>>2]=A,Z(e)}v=k+144|0;return}g0(),H()}G0(),H()}x0(),H()}function Qf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0;i:{e:{n=i[A+276>>2],D=(f|0)<(n|0)?f:n;r:{if((D|0)<=(r|0)||(f=i[A+272>>2],x=(f|0)>(k|0)?k:f,(x|0)<=0))break r;for(L=e?16:32,a=e?80:160,$=e?1:2,f0=e?2:1,A0=e-1|0,n0=0-e|0;;){for(C=r<<2,V=A0+C|0,S=C>>2,f=0;;){f:{A:{k:{if(k=f<<2,O=k>>2,_=(O+i[A+260>>2]|0)+G(i[A+272>>2],S)|0,t=l[_|0],t&a){if(n=k+n0|0,e=i[A+168>>2],s=n>>e,(s|0)<0||(o=i[A+172>>2],(o|0)<=(s|0)))break e;if(w=V>>e,(w|0)<0||(h=i[A+176>>2],(h|0)<=(w|0)))break i;if(B=k>>e,(B|0)<0|o>>>0<=B>>>0)break e;if(m=C>>e,(m|0)<0|(h|0)<=(m|0))break i;e=2,h=G(s,3),s=i[A+160>>2],w=(h+s|0)+G(G(o,w),3)|0;n:{if(!((l[w|0]|l[w+1|0]<<8)&768)||(o=(s+G(B,3)|0)+G(G(o,m),3)|0,!((l[o|0]|l[o+1|0]<<8)&768)))break n;if(t&L){if(o=i[A+248>>2],w=k>>o,(w|0)<0||(s=i[A+252>>2],(s|0)<=(w|0)))break e;if(B=C>>o,(B|0)<0||(m=i[A+256>>2],(m|0)<=(B|0)))break i;if(e=1,h=i[A+240>>2],u[(h+w|0)+G(s,B)|0]<0)break n;if(w=n>>o,(w|0)<0|s>>>0<=w>>>0)break e;if(o=V>>o,(o|0)<0|(o|0)>=(m|0))break i;if(u[(w+h|0)+G(o,s)|0]<0)break n}if(e=i[A+188>>2],w=n>>e,(w|0)<0||(o=i[A+192>>2],(o|0)<=(w|0)))break e;if(B=V>>e,(B|0)<0||(s=i[A+196>>2],(s|0)<=(B|0)))break i;if(m=k>>e,(m|0)<0|o>>>0<=m>>>0)break e;if(h=C>>e,(h|0)<0|(s|0)<=(h|0))break i;if(e=n,n=i[A+148>>2],W=e>>n,(W|0)<0||(s=i[A+152>>2],(s|0)<=(W|0)))break e;if(g=V>>n,(g|0)<0||(y=i[A+156>>2],(y|0)<=(g|0)))break i;if(e=0,I=i[A+52>>2],R=i[A+56>>2]-I>>2,N=G(W,24),W=i[A+140>>2],g=F[((N+W|0)+G(G(s,g),24)|0)+2>>1],R>>>0>g>>>0&&(e=i[I+(g<<2)>>2]),k=k>>n,(k|0)<0|k>>>0>=s>>>0)break e;if(n=C>>n,(n|0)<0|(n|0)>=(y|0))break i;if(k=F[((W+G(k,24)|0)+G(G(n,s),24)|0)+2>>1],k>>>0>=R>>>0){e=0;break n}if(!e){e=0;break n}if(W=i[I+(k<<2)>>2],!W){e=0;break n}if(n=i[A+180>>2],k=(n+G(w,12)|0)+G(G(o,B),12)|0,w=u[k+2|0],(w|0)>16||(g=u[k+3|0],(g|0)>16)||(n=(n+G(m,12)|0)+G(G(o,h),12)|0,h=u[n+2|0],(h|0)>16)||(I=u[n+3|0],(I|0)>16))break A;if(s=-1,t=-1,m=l[k|0],t=m?i[((w<<2)+e|0)+924>>2]:t,B=l[k+1|0],s=B?i[((g<<2)+e|0)+988>>2]:s,_=-1,o=-1,w=l[n|0],o=w?i[(W+(h<<2)|0)+924>>2]:o,h=l[n+1|0],_=h?i[(W+(I<<2)|0)+988>>2]:_,!((t|0)==(o|0)&(_|0)==(s|0))&&(e=1,(t|0)!=(_|0)|(o|0)!=(s|0)))break n;e=F[n+8>>1],W=F[n+10>>1],g=F[n+4>>1],n=F[n+6>>1],I=F[k+8>>1],y=F[k+10>>1],R=F[k+4>>1],N=F[k+6>>1],(B+m|0)!=(w+h|0)&&(C2(i[A+112>>2]+4|0,1013,0),u[A+312|0]=3),e=h?e:0,k=h?W:0,h=w?g:0,n=w?n:0,w=B?I:0,B=B?y:0,W=m?R:0,m=m?N:0;t:{if((t|0)!=(s|0)){if(s=W<<16>>16,(t|0)!=(o|0)){if(t=s-(e<<16>>16)|0,e=t>>31,(e^t)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(w<<16>>16)-(h<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if(o=s-(h<<16>>16)|0,t=o>>31,(t^o)-t>>>0>3||(t=(m<<16>>16)-(n<<16>>16)|0,n=t>>31,(n^t)-n>>>0>3)||(n=(w<<16>>16)-(e<<16>>16)|0,e=n>>31,(e^n)-e>>>0>3)||(e=0,n=(B<<16>>16)-(k<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if((o|0)!=(_|0))break k;o=W<<16>>16,s=h<<16>>16,_=o-s|0,t=_>>31;u:{if((t^_)-t>>>0>3||(_=(m<<16>>16)-(n<<16>>16)|0,t=_>>31,(t^_)-t>>>0>3)||(_=(w<<16>>16)-(e<<16>>16)|0,t=_>>31,(t^_)-t>>>0>3)||(_=(B<<16>>16)-(k<<16>>16)|0,t=_>>31,(t^_)-t>>>0>=4))break u;e=0;break n}if(t=o-(e<<16>>16)|0,e=t>>31,(e^t)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(w<<16>>16)-s|0,e=k>>31,(e^k)-e>>>0>3))break t;if(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0<4)break n}e=1}k=(i[A+260>>2]+O|0)+G(i[A+272>>2],S)|0,u[k|0]=l[k|0]&252|e;break f}u[_|0]=t&252;break f}M0(21763,18288,355,10766),H()}u[_|0]=t&252}if(f=f+f0|0,!((x|0)>(f|0)))break}if(r=r+$|0,!((D|0)>(r|0)))break}}return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function lv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;k=v-192|0,v=k,u[k+167|0]=0,u[k+168|0]=0,u[k+169|0]=0,u[k+170|0]=0,u[k+171|0]=0,u[k+172|0]=0,u[k+173|0]=0,u[k+174|0]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0,i[k+188>>2]=0,u[k+184|0]=1,t=E(208),i[t>>2]=90732,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,Q[t+112>>1]=0,i[e>>2]=99864,i[t+136>>2]=0,i[t+140>>2]=0,Q[t+120>>1]=259,i[t+144>>2]=0,i[t+148>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+172>>2]=0,i[t+176>>2]=0,i[t+180>>2]=0,i[t+200>>2]=0,i[t+192>>2]=0,i[t+196>>2]=0,i[t+32>>2]=1987470147,i[t+4>>2]=i[t+4>>2]+1,s=E(8),i[s+4>>2]=t,i[s>>2]=e,e=s+8|0,i[k+156>>2]=e,i[k+148>>2]=s,i[k+152>>2]=e,i[k+144>>2]=0,e=i[r>>2],r=i[r+4>>2];i:{if(!r){i[k+140>>2]=e;break i}if(i[r+4>>2]=i[r+4>>2]+1,i[k+140>>2]=e,s=i[k+144>>2],i[k+144>>2]=r,!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break i;X[i[i[s>>2]+8>>2]](s),p(s)}X[i[i[f>>2]+100>>2]](k+128|0,i[f+4>>2],k+140|0,n);i:{s=i[k+128>>2];e:{if(s){if(n=i[k+132>>2],r=i[k+136>>2],o=h2(r),o>>>0>=2147483640)break i;r:{f:{if(o>>>0>=11){e=o|7,f=E(e+1|0),i[k+124>>2]=e-2147483647,i[k+116>>2]=f,i[k+120>>2]=o;break f}if(u[k+127|0]=o,f=k+116|0,!o)break r}if(!o)break r;z(f,r,o)}u[f+o|0]=0,f=K(k+32|0,s,n,k+116|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+44|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+44|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[k+127|0]>=0)break e;Z(i[k+116>>2]);break e}if(i[k+116>>2]=0,i[k+112>>2]=0,X[i[i[f>>2]+104>>2]](k+32|0,i[f+4>>2],k+108|0,k+104|0,0),e=i[k+108>>2],e)for(;;){r:{f:{if(r=i[k+104>>2],(r|0)<2)break f;A:switch((l[e+1|0]>>>3|0)-14|0){case 1:Q[k+32>>1]=259,i[k+88>>2]=0,i[k+92>>2]=0,i[k+80>>2]=0,i[k+84>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,d7(k+12|0,e,r,k+32|0,k+116|0,k+112|0),u[k+31|0]<0&&Z(i[k+20>>2]),n=k+32|0,e=i[n+4>>2],i[o+104>>2]=i[n>>2],i[o+108>>2]=e,i[o+112>>2]=i[n+8>>2],Q[o+116>>1]=F[n+12>>1];k:{if((n|0)==(o+104|0)){Xu(o+132|0,n+28|0);break k}r=i[n+16>>2],e=i[n+20>>2],d4(o+120|0,r,e,e-r|0),Xu(o+132|0,n+28|0),r=i[n+40>>2],e=i[n+44>>2],d4(o+144|0,r,e,e-r|0),r=i[n+52>>2],e=i[n+56>>2],k6(o+156|0,r,e,e-r>>2)}i[o+168>>2]=i[n+64>>2],Q[o+172>>1]=F[n+68>>1],e=i[k+84>>2],e&&(i[k+88>>2]=e,Z(e)),e=i[k+72>>2],e&&(i[k+76>>2]=e,Z(e)),e=i[k+60>>2],e&&Z(e),e=i[k+48>>2],e&&(i[k+52>>2]=e,Z(e)),r=i[k+104>>2],e=i[k+108>>2];break;case 0:case 2:break A;default:break f}Ir(o,e,r);break r}Wi(k+148|0,e,r)}if(X[i[i[f>>2]+104>>2]](k+32|0,i[f+4>>2],k+108|0,k+104|0,0),e=i[k+108>>2],!e)break}u[k+174|0]=0,Q[k+172>>1]=257,o=i[k+156>>2],s=i[k+160>>2],i[k+156>>2]=0,n=i[k+148>>2],f=i[k+152>>2],i[k+148>>2]=0,i[k+152>>2]=0,r=i[k+164>>2],e=i[k+168>>2],i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[A+16>>2]=r,i[A+20>>2]=e,i[A+8>>2]=o,i[A+12>>2]=s,i[A>>2]=n,i[A+4>>2]=f,e=i[k+176>>2],i[A+24>>2]=i[k+172>>2],i[A+28>>2]=e,e=i[k+184>>2],i[A+32>>2]=i[k+180>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+188>>2],u[A+44|0]=0}e=i[k+144>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(X[i[i[t>>2]+8>>2]](t),p(t)),A=i[k+160>>2],A&&(i[k+164>>2]=A,Z(A)),A=i[k+148>>2],A){if(e=A,r=i[k+152>>2],(e|0)!=(r|0)){for(;;){f=i[r-4>>2];e:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+148>>2]}i[k+152>>2]=A,Z(e)}v=k+192|0;return}g0(),H()}function sv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;o=v-16|0,v=o,i[o+12>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[o>>2]=s,(s|0)!=129624&&(i[s+4>>2]=i[s+4>>2]+1),s=c0(o,129808),e2(o);i:{e:{r:{f:switch(t-65|0){case 0:case 32:Zl(A,n+24|0,o+12|0,r,k,s);break e;case 1:case 33:case 39:_l(A,n+16|0,o+12|0,r,k,s);break e;case 34:e=X[i[i[A+8>>2]+12>>2]](A+8|0)|0,t=A,w=i[o+12>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=z8(t,w,r,f,k,n,s,A+e|0),i[h+12>>2]=_;break e;case 35:case 36:A=X8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:i[o>>2]=623865125,i[o+4>>2]=2032480100,h=o,_=z8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 5:i[o>>2]=623728933,i[o+4>>2]=1680158061,h=o,_=z8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 7:A=X8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=X8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=X8(o+12|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=X8(o+12|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=X8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=o+12|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(P2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=X[i[i[r>>2]+36>>2]](r)|0;break k}r=u[f|0]}if(r=r<<24>>24,(r|0)>=0?r=i[i[s+8>>2]+(r<<2)>>2]&1:r=0,!r)break A;K1(A);continue}break}P2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:t=o+12|0,e=X[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(l[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=l[e+11|0]&127}l[e+23|0]>>>7|0?f=i[e+16>>2]:f=l[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=Xr(t,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:t=l[77832]|l[77833]<<8|(l[77834]<<16|l[77835]<<24),u[o+7|0]=t,u[o+8|0]=t>>>8,u[o+9|0]=t>>>16,u[o+10|0]=t>>>24,t=l[77829]|l[77830]<<8|(l[77831]<<16|l[77832]<<24),i[o>>2]=l[77825]|l[77826]<<8|(l[77827]<<16|l[77828]<<24),i[o+4>>2]=t,h=o,_=z8(A,e,r,f,k,n,o,o+11|0),i[h+12>>2]=_;break e;case 17:u[o+4|0]=l[77840],i[o>>2]=l[77836]|l[77837]<<8|(l[77838]<<16|l[77839]<<24),h=o,_=z8(A,e,r,f,k,n,o,o+5|0),i[h+12>>2]=_;break e;case 18:A=X8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:i[o>>2]=624576549,i[o+4>>2]=1394948685,h=o,_=z8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 54:A=X8(o+12|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=X[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=X[i[i[A+8>>2]+24>>2]](A+8|0)|0,t=A,w=i[o+12>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=z8(t,w,r,f,k,n,s,A+e|0),i[h+12>>2]=_;break e;case 56:Ml(n+20|0,o+12|0,r,k,s);break e;case 24:A=X8(o+12|0,r,k,s,4),l[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((t|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=o+12|0,n=A+12|0,e=6;r:{f:{if(P2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=X[i[i[e>>2]+36>>2]](e)|0;break A}f=u[f|0]}if(e=4,(X[i[i[s>>2]+36>>2]](s,f<<24>>24,0)|0)!=37)break f;if(!P2(K1(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[o+12>>2]}return v=o+16|0,A|0}function wv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]){t1(A,e,4441);break i}if(n=F0(r),n>>>0>u0[f+80>>2]){if(e=E(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17300]|l[17301]<<8|(l[17302]<<16|l[17303]<<24),f=l[17296]|l[17297]<<8|(l[17298]<<16|l[17299]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17353]|l[17354]<<8|(l[17355]<<16|l[17356]<<24),f=l[17349]|l[17350]<<8|(l[17351]<<16|l[17352]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17348]|l[17349]<<8|(l[17350]<<16|l[17351]<<24),f=l[17344]|l[17345]<<8|(l[17346]<<16|l[17347]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17340]|l[17341]<<8|(l[17342]<<16|l[17343]<<24),f=l[17336]|l[17337]<<8|(l[17338]<<16|l[17339]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17332]|l[17333]<<8|(l[17334]<<16|l[17335]<<24),f=l[17328]|l[17329]<<8|(l[17330]<<16|l[17331]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17324]|l[17325]<<8|(l[17326]<<16|l[17327]<<24),f=l[17320]|l[17321]<<8|(l[17322]<<16|l[17323]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17316]|l[17317]<<8|(l[17318]<<16|l[17319]<<24),f=l[17312]|l[17313]<<8|(l[17314]<<16|l[17315]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17308]|l[17309]<<8|(l[17310]<<16|l[17311]<<24),f=l[17304]|l[17305]<<8|(l[17306]<<16|l[17307]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(K4(A,e+116|0,n<<3,f,13709),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{r:{f:{o=i[e+104>>2],t=i[e+108>>2]-o>>3;A:{k:{if(t>>>0<n>>>0){ui(f,n-t|0);break k}if(n>>>0<t>>>0&&(i[e+108>>2]=o+(n<<3)),!n)break A}for(e=0;;){if(!i[r+16>>2]){i[k+116>>2]=0,i[k+88>>2]=72244,i[k+32>>2]=72224,r=i[18065],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[18066],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,t=k+36|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[k+32>>2]=f,o=k+32|0,i[o+i[f-12>>2]>>2]=i[18068],f=i[18064],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[18069],i[k+88>>2]=72244,i[k+24>>2]=72204,i[k+32>>2]=72224,f=R0(t),i[f>>2]=71280,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(I0(Y(I0(Y(o,28136,24),n),28970,33),e),5504,8),e=i[k+84>>2];k:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break k}if(!(e&8)){r=0,u[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}if(n=i[e>>2],r=r-n|0,r>>>0>=2147483640)break f;if(r>>>0>=11){t=r|7,e=E(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(u[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}if(t=F0(r),o=F0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,K(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!r)break e;z(e,n,r)}u[e+r|0]=0,K(A,2,100,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18063],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18071],i[k+32>>2]=i[18072],i[f>>2]=71280,u[k+79|0]<0&&Z(i[k+68>>2]),y0(f),p0(k+88|0)}v=k+192|0}function a6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-96|0,v=f;i:{e:{r:{f:{A:{k:{if(n=i[e+128>>2],!n)break k;for(o=e+128|0,t=o,k=n;s=u0[k+16>>2]<r>>>0,t=s?t:k,k=i[(s?4:0)+k>>2],!!k;);if((t|0)==(o|0)|u0[t+16>>2]>r>>>0)break k;for(k=o;t=u0[n+16>>2]<r>>>0,k=t?k:n,n=i[(t?4:0)+n>>2],!!n;);if(t=0,!((k|0)==(o|0)|u0[k+16>>2]>r>>>0)&&(n=i[k+20>>2],t=i[k+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),n))break r;if(u[f+16|0]=0,u[f+27|0]=0,e=K(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]<0)break A;k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}u[f+16|0]=0,u[f+27|0]=0,e=K(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(u[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}k=i[n+112>>2];r:{if(u[n+139|0]>=0){i[f- -64>>2]=i[n+136>>2],o=i[n+132>>2],i[f+56>>2]=i[n+128>>2],i[f+60>>2]=o;break r}T(f+56|0,i[n+128>>2],i[n+132>>2])}i[f+72>>2]=0,i[f+76>>2]=0,i[f+88>>2]=0,i[f+80>>2]=0,i[f+84>>2]=0;r:{f:{A:{if((k|0)!=1835625829)break A;k:{if(u[n+151|0]>=0){i[f+48>>2]=i[n+148>>2],k=i[n+144>>2],i[f+40>>2]=i[n+140>>2],i[f+44>>2]=k;break k}T(f+40|0,i[n+140>>2],i[n+144>>2])}n=u[f+51|0],k=(n|0)<0;k:{n:{t:{u:{o:switch(o=k?i[f+44>>2]:n,o|0){case 0:break k;case 2:break t;case 7:break u;case 13:break o;default:break n}if(e=f+40|0,N2(k?i[f+40>>2]:e,18358,13))break n;if(e=K(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}if(e=f+40|0,N2(k?i[f+40>>2]:e,12192,o))break n;if(e=K(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}if(e=f+40|0,N2(k?i[f+40>>2]:e,7623,o))break n;if(e=K(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}k=d2(f+4|0,42716),e=K(f+16|0,4,3e3,k),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(u[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}if(u[k+11|0]>=0)break f;Z(i[k>>2]);break f}if((n|0)>=0)break A;Z(i[f+40>>2])}i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,K6(f+16|0,i[e+68>>2],r,e+8|0,e+76|0,f+40|0,0,0,-1,-1,i[e+156>>2]),r=i[f+20>>2],e=i[f+16>>2],i[f+72>>2]=e,i[f+76>>2]=r,u[f+91|0]<0&&(Z(i[f+80>>2]),e=i[f+72>>2]),r=i[f+28>>2],i[f+80>>2]=i[f+24>>2],i[f+84>>2]=r,i[f+88>>2]=i[f+32>>2];A:{k:{if(e){if(e=i[f+76>>2],i[A>>2]=i[f+72>>2],i[A+4>>2]=e,e=A+8|0,u[f+91|0]<0)break k;r=i[f+84>>2],i[e>>2]=i[f+80>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+88>>2];break A}e=i[f+48>>2],i[f+48>>2]=0,r=i[f+44>>2],k=i[f+40>>2],u[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=r;break r}T(e,i[f+80>>2],i[f+84>>2])}if(u[A+20|0]=1,A=i[f+40>>2],!A)break r;i[f+44>>2]=A,Z(A);break r}if(u[f+51|0]>=0)break r;Z(i[f+40>>2])}if(u[f+91|0]<0&&Z(i[f+80>>2]),u[f+67|0]>=0)break e;Z(i[f+56>>2])}if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=f+96|0}function hv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;k=v-144|0,v=k,i[k+104>>2]=0,i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,u[k+119|0]=0,u[k+120|0]=0,u[k+121|0]=0,u[k+122|0]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+136>>2]=0,u[k+132|0]=1,e=E(160),i[e>>2]=90412,i[e+4>>2]=0,i[e+8>>2]=0,o=e+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[o>>2]=97552,i[e+156>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,u[e+145|0]=4,i[e+124>>2]=0,i[e+128>>2]=0,i[e+32>>2]=1752589123,s=i[r>>2],t=i[r+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[k+92>>2]=t,i[k+88>>2]=s,X[i[i[f>>2]+100>>2]](k+76|0,i[f+4>>2],k+88|0,n);i:{e:{r:{n=i[k+76>>2];f:{if(n){if(t=i[k+80>>2],o=i[k+84>>2],r=h2(o),r>>>0>=2147483640)break r;A:{k:{if(r>>>0>=11){s=r|7,f=E(s+1|0),i[k+52>>2]=s-2147483647,i[k+44>>2]=f,i[k+48>>2]=r;break k}if(u[k+55|0]=r,f=k+44|0,!r)break A}if(!r)break A;z(f,o,r)}u[r+f|0]=0,r=K(k+56|0,n,t,k+44|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;A:{if(u[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}if(i[k+40>>2]=0,i[k+36>>2]=0,X[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),t=i[k+44>>2],t)for(w=e+116|0;;){n=l[t|0],(n&254)==66&&(K9(k+12|0,t,i[k+32>>2],w,k+40|0,k+36|0),u[k+31|0]<0&&Z(i[k+20>>2]),i[k+124>>2]=i[k+40>>2],i[k+128>>2]=i[k+36>>2],t=i[k+44>>2],n=l[t|0]),s=i[k+32>>2];A:{if((((n&254)>>>1|0)-32&255)>>>0<=2){Gr(o,t,s);break A}Wi(k+96|0,t,s)}if(X[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),t=i[k+44>>2],!t)break}if(!(i[k+36>>2]&&i[k+40>>2])){u[k+44|0]=0,u[k+55|0]=0,r=K(k+56|0,8,129,k+44|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;A:{if(u[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}i[e+4>>2]=i[e+4>>2]+1,n=i[k+100>>2],w=i[k+104>>2];A:{if(n>>>0<w>>>0){i[n+4>>2]=e,i[n>>2]=o,t=n+8|0;break A}if(s=i[k+96>>2],n=n-s|0,_=n>>3,t=_+1|0,t>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<h>>>0?h:t,w){if(w>>>0>=536870912)break i;t=E(w<<3)}else t=0;if(h=t+n|0,i[h+4>>2]=e,i[h>>2]=o,o=h-(_<<3)|0,n&&z(o,s,n),i[k+104>>2]=t+(w<<3),t=h+8|0,i[k+100>>2]=t,i[k+96>>2]=o,!s)break A;Z(s)}i[k+100>>2]=t,n=i[f>>2];A:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break A;r=i[r>>2],t=i[r+108>>2],i[k+56>>2]=t,r=i[r+112>>2],i[k+44>>2]=r,X[n|0](i[f+4>>2],t,r,k+56|0,k+44|0),t=i[k+100>>2]}Q[k+120>>1]=257,r=i[k+96>>2],i[k+96>>2]=0,f=i[k+104>>2],n=i[k+108>>2],i[k+100>>2]=0,i[k+104>>2]=0,o=i[k+112>>2],s=i[k+116>>2],i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,i[A+16>>2]=o,i[A+20>>2]=s,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=t,i[A>>2]=r,r=i[k+124>>2],i[A+24>>2]=i[k+120>>2],i[A+28>>2]=r,r=i[k+132>>2],i[A+32>>2]=i[k+128>>2],i[A+36>>2]=r,i[A+40>>2]=i[k+136>>2],u[A+44|0]=0}A=i[k+92>>2];f:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break f;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[e+4>>2],i[e+4>>2]=A-1,A||(X[i[i[e>>2]+8>>2]](e),p(e)),A=i[k+108>>2],A&&(i[k+112>>2]=A,Z(A)),A=i[k+96>>2],A){if(e=A,t=i[k+100>>2],(e|0)!=(t|0)){for(;;){e=i[t-4>>2];f:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[k+96>>2]}i[k+100>>2]=A,Z(e)}v=k+144|0;return}g0(),H()}G0(),H()}x0(),H()}function _v(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;i:{for(f=A,A=0,t=v-32|0,v=t,s=e+100|0,I=s,C=W2(r),u[I|0]=C,e=W2(r),u[s+3|0]=e&31,u[s+1|0]=e>>>6,u[s+2|0]=e>>>5&1,I=s,C=F0(r),i[I+4>>2]=C,w=s+8|0;e=W2(r),o=w+(A&-4)|0,n=i[o>>2],k=A<<3,n=(I=n|1<<k,C=k2(-2,k)&n,V=e<<24>>24<0,V?I:C),h=o,o=2<<k,n=e&64?o|n:n&(o^-1),o=4<<k,n=e&32?n|o:n&(o^-1),o=8<<k,n=e&16?n|o:n&(o^-1),o=16<<k,n=e&8?n|o:n&(o^-1),o=32<<k,n=e&4?n|o:n&(o^-1),o=64<<k,n=e&2?n|o:n&(o^-1),k=128<<k,i[h>>2]=e&1?n|k:n&(k^-1),A=A+1|0,(A|0)!=6;);I=s,C=W2(r),u[I+16|0]=C,I=s,C=o2(r)&4095,Q[I+18>>1]=C,I=s,C=W2(r)&3,u[I+20|0]=C,I=s,C=W2(r)&3,u[I+21|0]=C,I=s,C=W2(r)&7|8,u[I+22|0]=C,I=s,C=W2(r)&7|8,u[I+23|0]=C,I=s,C=o2(r),Q[I+24>>1]=C,A=W2(r),u[s+26|0]=A>>>6,u[s+29|0]=(A&3)+1,u[s+28|0]=A>>>2&1,u[s+27|0]=A>>>3&7;e:{r:{B=W2(r);f:{A:{if(!B)break A;for(g=s+32|0;;){if(l[r+20|0])break A;A=W2(r),_=0,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,u[t+17|0]=A&63,u[t+16|0]=A>>>6&1,m=o2(r);k:{n:{if(!m|u[r+20|0]&1)break n;for(;;){if(k=o2(r),k){e=0,A=0;t:{if(!f4(r,k))break t;e=E(k),k&&o0(e,0,k),A=e+k|0,w=i[r>>2],n=i[r+4>>2];u:{if(!n){if(!(X[i[i[w>>2]+16>>2]](w,e,k)|0))break u;break t}if(i[n+4>>2]=i[n+4>>2]+1,k=X[i[i[w>>2]+16>>2]](w,e,k)|0,w=i[n+4>>2],i[n+4>>2]=w-1,w||(X[i[i[n>>2]+8>>2]](n),p(n)),k)break t}A=E(32),i[t+4>>2]=A,i[t+8>>2]=28,i[t+12>>2]=-2147483616,k=l[2534]|l[2535]<<8|(l[2536]<<16|l[2537]<<24),n=l[2530]|l[2531]<<8|(l[2532]<<16|l[2533]<<24),u[A|0]=n,u[A+1|0]=n>>>8,u[A+2|0]=n>>>16,u[A+3|0]=n>>>24,u[A+4|0]=k,u[A+5|0]=k>>>8,u[A+6|0]=k>>>16,u[A+7|0]=k>>>24,u[A+28|0]=0,k=l[2554]|l[2555]<<8|(l[2556]<<16|l[2557]<<24),u[A+24|0]=k,u[A+25|0]=k>>>8,u[A+26|0]=k>>>16,u[A+27|0]=k>>>24,k=l[2550]|l[2551]<<8|(l[2552]<<16|l[2553]<<24),n=l[2546]|l[2547]<<8|(l[2548]<<16|l[2549]<<24),u[A+16|0]=n,u[A+17|0]=n>>>8,u[A+18|0]=n>>>16,u[A+19|0]=n>>>24,u[A+20|0]=k,u[A+21|0]=k>>>8,u[A+22|0]=k>>>16,u[A+23|0]=k>>>24,k=l[2542]|l[2543]<<8|(l[2544]<<16|l[2545]<<24),n=l[2538]|l[2539]<<8|(l[2540]<<16|l[2541]<<24),u[A+8|0]=n,u[A+9|0]=n>>>8,u[A+10|0]=n>>>16,u[A+11|0]=n>>>24,u[A+12|0]=k,u[A+13|0]=k>>>8,u[A+14|0]=k>>>16,u[A+15|0]=k>>>24,K(f,2,100,t+4|0),u[t+15|0]<0&&Z(i[t+4>>2]),Z(e),n=0;break k}k=i[t+24>>2],o=i[t+28>>2];t:{if(k>>>0<o>>>0){i[k+8>>2]=A,i[k+4>>2]=A,i[k>>2]=e,A=k+12|0;break t}if(w=i[t+20>>2],k=k-w|0,n=((k|0)/12|0)+1|0,n>>>0>=357913942)break r;if(o=(o-w|0)/12|0,h=o<<1,h=o>>>0>=178956970?357913941:n>>>0<h>>>0?h:n,h){if(h>>>0>=357913942)break e;n=E(G(h,12))}else n=0;if(o=n+k|0,i[o+8>>2]=A,i[o+4>>2]=A,i[o>>2]=e,e=o+G((k|0)/-12|0,12)|0,k&&z(e,w,k),i[t+28>>2]=n+G(h,12),A=o+12|0,i[t+24>>2]=A,i[t+20>>2]=e,!w)break t;Z(w)}i[t+24>>2]=A}if(_=_+1|0,m>>>0<=_>>>0)break n;if(u[r+20|0]&1)break}}A=i[s+36>>2];n:{if(A>>>0<u0[s+40>>2]){e=F[t+16>>1],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,Q[A>>1]=e,i[A+4>>2]=i[t+20>>2],i[A+8>>2]=i[t+24>>2],i[A+12>>2]=i[t+28>>2],i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,A=A+16|0;break n}A=Mn(g,t+16|0)}i[s+36>>2]=A,n=1}if(k=i[t+20>>2],k){if(A=i[t+24>>2],e=k,(A|0)!=(k|0)){for(;e=A-12|0,w=i[e>>2],w&&(i[A-8>>2]=w,Z(w)),A=e,(k|0)!=(A|0););e=i[t+20>>2]}i[t+24>>2]=k,Z(e)}if(!n)break f;if(W=W+1|0,(B|0)==(W|0))break}}if(e=i[r+16>>2],e&&(A=i[r+8>>2],A&&(c1(A,e),e=i[r+16>>2]),A=i[r>>2],k=X[i[i[A>>2]+8>>2]](A)|0,s=l0,n=e,e=e+k|0,s=n>>>0>e>>>0?s+1|0:s,X[i[i[A>>2]+20>>2]](A,e,s)|0,i[r+16>>2]=0),l[r+20|0]==1){if(u[t+16|0]=0,u[t+27|0]=0,K(f,2,100,t+16|0),u[t+27|0]>=0)break f;Z(i[t+16>>2]);break f}if(A=i[26929],i[f>>2]=i[26928],i[f+4>>2]=A,A=f+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break f}T(A,i[26930],i[26931])}v=t+32|0;break i}G0(),H()}x0(),H()}}function Bv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0;t=v-32|0,v=t;i:{e:{r:{if((j0(i[r>>2],3)|0)!=8||(j0(i[r>>2],4)|0)!=8)break r;if((j0(i[r>>2],5)|0)==8)break e}e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}_=u1(i[r>>2],6),B=l[k+8|0];e:{if(!_||(j0(i[r>>2],6)|0)==8)break e;e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],k=e+1|0,i[n+4>>2]=k,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],g=n+12|0,i[n+96>>2]=g,i[n+8>>2]=e+1,i[n+100>>2]=n,k||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],V=i[e+108>>2],k=V,y=i[e+112>>2],e=y,m=_|B,i[g+120>>2]=m&1?13:12,i[g+116>>2]=1,i[g+112>>2]=e,i[g+108>>2]=k,T0(t+8|0,g,10,k,e,j0(i[r>>2],3),o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),r=i[r>>2],e=r+128|0;r:{f:{if(k=i[r+128>>2],k){for(o=e,r=k;h=i[r+16>>2]<3,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);I=0;A:{if((e|0)==(o|0)||(I=0,i[o+16>>2]>3))break A;R=i[o+44>>2],I=i[o+56>>2]}for(o=e,r=k;h=i[r+16>>2]<4,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);C=0;A:{if((e|0)==(o|0)||(C=0,i[o+16>>2]>4))break A;N=i[o+56>>2],C=i[o+44>>2]}for(o=e,r=k;h=i[r+16>>2]<5,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}r=0;break r}if(r=0,i[o+16>>2]>5)break r;D=i[o+56>>2],r=i[o+44>>2]}h=r,r=i[f>>2],w=0;r:{if(!r)break r;for(o=f;W=i[r+16>>2]<10,o=W?o:r,r=i[(W?4:0)+r>>2],!!r;);if((f|0)==(o|0)){w=0;break r}if(w=0,i[o+16>>2]>10)break r;x=i[o+56>>2],w=i[o+44>>2]}f=w,o=0;r:{if(!k|_^1)break r;for(r=e;o=i[k+16>>2]<6,r=o?r:k,k=i[(o?4:0)+k>>2],!!k;);if(o=0,(e|0)==(r|0)||(o=0,i[r+16>>2]>6))break r;S=i[r+44>>2],o=i[r+56>>2]}r=o;r:{if(!y)break r;if(_){if(!V)break r;for(e=0;;){for(s=G(e,r)+S|0,_=G(e,D)+h|0,B=G(e,N)+C|0,m=G(e,I)+R|0,W=f+G(e,x)|0,k=0;w=(k<<3)+W|0,u[w|0]=0,o=l[k+m|0],u[w+2|0]=0,u[w+1|0]=o,o=l[k+B|0],u[w+4|0]=0,u[w+3|0]=o,o=l[k+_|0],u[w+6|0]=0,u[w+5|0]=o,u[w+7|0]=l[k+s|0],k=k+1|0,(V|0)!=(k|0););if(e=e+1|0,(y|0)==(e|0))break}break r}if(!V)break r;if(_=m&1?8:6,e=0,B&1)for(;;){for(B=G(e,D)+h|0,m=G(e,N)+C|0,W=G(e,I)+R|0,o=f+G(e,x)|0,k=0;s=o+G(k,_)|0,u[s|0]=0,r=l[k+W|0],u[s+2|0]=0,u[s+1|0]=r,r=l[k+m|0],u[s+4|0]=0,u[s+3|0]=r,r=l[k+B|0],u[s+6|0]=0,u[s+7|0]=255,u[s+5|0]=r,k=k+1|0,(V|0)!=(k|0););if(e=e+1|0,(y|0)==(e|0))break r}for(;;){for(B=G(e,D)+h|0,m=G(e,N)+C|0,W=G(e,I)+R|0,o=f+G(e,x)|0,r=0;s=o+G(r,_)|0,u[s|0]=0,k=l[r+W|0],u[s+2|0]=0,u[s+1|0]=k,k=l[r+m|0],u[s+4|0]=0,u[s+3|0]=k,u[s+5|0]=l[r+B|0],r=r+1|0,(V|0)!=(r|0););if(e=e+1|0,(y|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=g;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+32|0}function If(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;l[108684]||(u[108684]=1),e=i[27164],i[27164]=e+1;i:{if((e|0)>0||(x7(),O7()))break i;return i[27164]=i[27164]-1,0}A=E(3224),i[A+168>>2]=0,i[A+84>>2]=0,i[A>>2]=61304,i[A+384>>2]=1853,i[A+376>>2]=1854,i[A+360>>2]=1855,i[A+356>>2]=1856,i[A+352>>2]=1857,i[A+348>>2]=1858,i[A+344>>2]=1859,i[A+340>>2]=1860,i[A+336>>2]=1861,i[A+332>>2]=1862,i[A+328>>2]=1863,i[A+324>>2]=1864,i[A+320>>2]=1865,i[A+316>>2]=1866,i[A+312>>2]=1867,i[A+308>>2]=1868,i[A+304>>2]=1869,i[A+300>>2]=1870,i[A+296>>2]=1871,i[A+292>>2]=1871,i[A+288>>2]=1871,i[A+284>>2]=1872,i[A+280>>2]=1873,i[A+276>>2]=1874,i[A+272>>2]=1875,i[A+268>>2]=1876,i[A+264>>2]=1877,i[A+260>>2]=1878,i[A+256>>2]=1879,i[A+252>>2]=1880,i[A+248>>2]=1881,i[A+244>>2]=1882,i[A+240>>2]=1883,i[A+236>>2]=1884,i[A+232>>2]=1885,i[A+228>>2]=1886,i[A+224>>2]=1887,i[A+220>>2]=1888,i[A+216>>2]=1889,i[A+212>>2]=1889,i[A+208>>2]=1889,i[A+204>>2]=1890,i[A+200>>2]=1891,i[A+196>>2]=1892,i[A+192>>2]=1893,i[A+188>>2]=1894,i[A+184>>2]=1895,i[A+180>>2]=1896,i[A+176>>2]=1897,i[A+172>>2]=1898,i[A+372>>2]=1899,i[A+380>>2]=1900,i[A+364>>2]=1901,i[A+368>>2]=1902,i[A+388>>2]=1903,i[A+392>>2]=1904,i[A+396>>2]=1905,i[A+400>>2]=1906,i[A+404>>2]=1907,i[A+408>>2]=1908,i[A+412>>2]=1909,i[A+416>>2]=1910,i[A+420>>2]=1911,i[A+424>>2]=1912,i[A+428>>2]=1913,i[A+432>>2]=1914,i[A+456>>2]=1915,i[A+460>>2]=1916,i[A+468>>2]=1917,i[A+472>>2]=1918,i[A+464>>2]=1919,i[A+508>>2]=1920,i[A+504>>2]=1921,i[A+500>>2]=1922,i[A+496>>2]=1923,i[A+492>>2]=1924,i[A+488>>2]=1925,i[A+484>>2]=1926,i[A+480>>2]=1927,i[A+476>>2]=1928,i[A+452>>2]=1929,i[A+448>>2]=1930,i[A+444>>2]=1931,i[A+440>>2]=1932,i[A+436>>2]=1933,i[A>>2]=61328,i[A+552>>2]=0,i[A+556>>2]=0,Q[A+548>>1]=0,i[A+560>>2]=0,i[A+564>>2]=0,i[A+568>>2]=0,i[A+572>>2]=0,i[A+576>>2]=0,i[A+580>>2]=0,i[A+584>>2]=0,i[A+588>>2]=0,i[A+592>>2]=0,i[A+596>>2]=0,e=A+1412|0,i[e>>2]=0,i[e+4>>2]=0,e=A+1404|0,i[e>>2]=0,i[e+4>>2]=0,i[A+1396>>2]=0,i[A+1400>>2]=0,o0(A+600|0,0,792),e=A+2140|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=30,i[e+4>>2]=30,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[A+3216>>2]=0,i[A+3208>>2]=0,i[A+3212>>2]=0,Q[A+532>>1]=0,u[A+514|0]=0,Q[A+512>>1]=256,i[A+516>>2]=-1,i[A+520>>2]=-1,i[A+524>>2]=-1,i[A+528>>2]=-1,e=i[26771],r=i[26770],i[A+1368>>2]=0,i[A+544>>2]=0,i[A+536>>2]=r,i[A+540>>2]=e,e=i[A+1372>>2],i[A+1372>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+1380>>2],i[A+1376>>2]=0,i[A+1380>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+1388>>2],i[A+1384>>2]=0,i[A+1388>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}i[A+1892>>2]=100,i[A+1896>>2]=6,i[A+1884>>2]=0,i[A+1888>>2]=6,i[A+1900>>2]=100,i[A+1904>>2]=6,e=i[A+1376>>2];i:{e:{r:{if(e){e=u[e+2|0];break r}if(r=i[A+1368>>2],e=6,!r)break e;e=i[r+8>>2]}if((e|0)<=0)break i;e=e-1|0}for(_=A+2112|0,s=A+1908|0,w=e+1|0;;){r=G(e,100),n=(r+100|0)/(w|0)|0,f=(r|0)/(w|0)|0;e:{if((n|0)<(f|0)){r=e;break e}t=i[A+1888>>2];r:{if(f+n&1){r=e,e=f;break r}r=(f<<1)+s|0,u[r+1|0]=(e|0)>(t|0)?100:0,k=r,r=(e|0)<(t|0)?e:t,u[k|0]=r,e=f+1|0}if(k=e,(f|0)==(n|0))break e;for(h=n-f|0,e=r;o=(k<<1)+s|0,r=(e|0)<(t|0)?e:t,u[o|0]=r,u[o+1|0]=(e|0)>(t|0)?100:(G(k-f|0,100)|0)/(h|0)|0,o=k+1|0,e=(o<<1)+s|0,u[e+1|0]=(G(o-f|0,100)|0)/(h|0),u[e|0]=r,k=k+2|0,e=r,(n|0)!=(o|0););}if(i[(r<<2)+_>>2]=n,e=r-1|0,!((r|0)>0))break}}return i[A+2200>>2]=0,i[A+2204>>2]=0,i[A+2196>>2]=-1,e=A+2216|0,i[e>>2]=0,i[e+4>>2]=0,e=A+2208|0,i[e>>2]=0,i[e+4>>2]=0,u[A+2200|0]=1,A|0}function vv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;s=v-48|0,v=s,t=E(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94860,o0(t+16|0,0,80),f=i[t+4>>2],k=f+1|0,i[t+4>>2]=k,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],g=t+12|0,i[t+96>>2]=g,i[t+8>>2]=f+1,i[t+100>>2]=t,k||(X[i[i[t>>2]+8>>2]](t),p(t)),f=i[r>>2],k=i[f+108>>2],n=i[f+112>>2],_=i[f+116>>2],i[g+120>>2]=i[f+120>>2],i[g+116>>2]=_,i[g+112>>2]=n,i[g+108>>2]=k;i:{e:{for(;;){w=i[R+58412>>2];r:{if(!u1(i[r>>2],w))break r;f:{A:{if(B=j0(i[r>>2],w),B>>>0>=9){if(h=o8(i[r>>2],w),I=l8(i[r>>2],w),T0(s+24|0,g,w,h,I,8,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=A+8|0,u[s+43|0]>=0){r=i[s+36>>2],i[e>>2]=i[s+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(e,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]<0&&Z(i[s+32>>2]),V=0,k=i[r>>2],_=k+128|0,f=_,n=i[k+128>>2],!n)break A;for(;k=(w|0)>i[n+16>>2],f=k?f:n,n=i[(k?4:0)+n>>2],!!n;);if((f|0)==(_|0))break A;if(C=0,_=0,(w|0)<i[f+16>>2])break f;C=i[f+44>>2],_=i[f+56>>2]>>>1|0;break f}k:{n:{if((B|0)!=8){if(h=o8(i[r>>2],w),I=l8(i[r>>2],w),T0(s+24|0,g,w,h,I,8,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=A+8|0,u[s+43|0]>=0){r=i[s+36>>2],i[e>>2]=i[s+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(e,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]<0&&Z(i[s+32>>2]),f=1<<16-B,n=(f&65534)>>>B|0,n)for(;f=f|n,n=n>>>B|0,!!n;);if(V=0,n=i[r>>2],_=n+128|0,k=_,n=i[n+128>>2],!n)break n;for(;B=(w|0)>i[n+16>>2],k=B?k:n,n=i[(B?4:0)+n>>2],!!n;);if((k|0)==(_|0))break n;if(C=0,B=0,(w|0)<i[k+16>>2])break k;C=i[k+44>>2],B=i[k+56>>2];break k}if(f6(s+4|0,g,r,w,w,o),u[s+23|0]>=0)break r;Z(i[s+12>>2]);break r}C=0,B=0}k=e,n=i[k>>2],_=0;k:{if(!n)break k;for(;_=(w|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((e|0)==(k|0)){_=0;break k}if(_=0,(w|0)<i[k+16>>2])break k;V=i[k+56>>2],_=i[k+44>>2]}if(!I|!h)break r;for(N=h&-4,y=h&3,w=0,D=h-1>>>0<3;;){if(h=_+G(w,V)|0,W=G(w,B)+C|0,n=0,k=0,!D)for(;u[n+h|0]=G(l[n+W|0],f)>>>8,m=n|1,u[m+h|0]=G(l[W+m|0],f)>>>8,m=n|2,u[m+h|0]=G(l[W+m|0],f)>>>8,m=n|3,u[m+h|0]=G(l[W+m|0],f)>>>8,n=n+4|0,k=k+4|0,(N|0)!=(k|0););if(k=0,y)for(;u[n+h|0]=G(l[n+W|0],f)>>>8,n=n+1|0,k=k+1|0,(y|0)!=(k|0););if(w=w+1|0,(I|0)==(w|0))break}break r}C=0,_=0}f=e,n=i[f>>2],k=0;f:{if(!n)break f;for(;k=(w|0)>i[n+16>>2],f=k?f:n,n=i[(k?4:0)+n>>2],!!n;);if((e|0)==(f|0)){k=0;break f}if(k=0,(w|0)<i[f+16>>2])break f;V=i[f+56>>2],k=i[f+44>>2]}if(!I|!h)break r;for(f=k,B=B-8|0,N=h&-4,y=h&3,w=0,D=h-1>>>0<3;;){if(h=f+G(w,V)|0,W=(G(w,_)<<1)+C|0,n=0,k=0,!D)for(;u[n+h|0]=F[W+(n<<1)>>1]>>>B,m=n|1,u[m+h|0]=F[W+(m<<1)>>1]>>>B,m=n|2,u[m+h|0]=F[W+(m<<1)>>1]>>>B,m=n|3,u[m+h|0]=F[W+(m<<1)>>1]>>>B,n=n+4|0,k=k+4|0,(N|0)!=(k|0););if(k=0,y)for(;u[n+h|0]=F[W+(n<<1)>>1]>>>B,n=n+1|0,k=k+1|0,(y|0)!=(k|0););if(w=w+1|0,(I|0)==(w|0))break}}if(R=R+4|0,(R|0)==28)break}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=g;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=s+48|0}function mv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=72244,i[n+20>>2]=72224,t=i[18065],i[n+12>>2]=t,w=n+12|0,i[w+i[t-12>>2]>>2]=i[18066],i[n+16>>2]=0,t=w+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,t=i[18067],i[n+20>>2]=t,_=n+20|0,i[_+i[t-12>>2]>>2]=i[18068],t=i[18064],i[n+12>>2]=t,i[w+i[t-12>>2]>>2]=i[18069],i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,B=R0(k),i[B>>2]=71280,t=n- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y2(n,e,r),k=u[n+11|0],t=(k|0)<0,Y(_,t?i[n>>2]:n,t?i[n+4>>2]:k),u[n+11|0]<0&&Z(i[n>>2]),t=n,h=e+100|0,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,w=f+12|0,J0(k,w),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,m=R0(w),i[m>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,w=r,k=f+148|0,s0(k,r),s=k,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(I0(Y(o,29553,22),F[h>>1]),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(I0(Y(o,31059,7),F[h+16>>1]),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(I0(Y(o,29744,8),F[h+18>>1]),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(d1(Y(o,30538,19),+u0[h+20>>2]*152587890625e-16),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(d1(Y(o,30558,18),+u0[h+24>>2]*152587890625e-16),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(I0(Y(o,29657,13),F[h+28>>1]),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=Y(o,31875,16),k=u[h+43|0],r=(k|0)<0,o=Y(Y(s,r?i[h+32>>2]:h+32|0,r?i[h+36>>2]:k),42713,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(o,31013,7),F[h+44>>1]),42713,1),r=i[f+60>>2];i:{e:{if(r&16){r=i[f+56>>2],k=i[f+36>>2],r>>>0<k>>>0&&(i[f+56>>2]=k,r=k),k=f+32|0;break e}if(!(r&8)){r=0,u[t+11|0]=0;break i}r=i[f+28>>2],k=f+20|0}e:{if(h=i[k>>2],r=r-h|0,r>>>0<2147483640){if(r>>>0>=11){o=r|7,k=E(o+1|0),i[t+8>>2]=o-2147483647,i[t>>2]=k,i[t+4>>2]=r,t=k;break e}if(u[t+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(t,h,r)}u[r+t|0]=0,r=i[18063],i[f>>2]=r,i[i[r-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[m>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(m),p0(f- -64|0),v=f+160|0,t=u[n+11|0],r=(t|0)<0,Y(_,r?i[n>>2]:n,r?i[n+4>>2]:t),u[n+11|0]<0&&Z(i[n>>2]),mr(n,e,w,0),r=u[n+11|0],e=(r|0)<0,Y(_,e?i[n>>2]:n,e?i[n+4>>2]:r),u[n+11|0]<0&&Z(i[n>>2]),e=i[n+72>>2];i:{e:{if(e&16){e=i[n+68>>2],r=i[n+48>>2],e>>>0<r>>>0&&(i[n+68>>2]=r,e=r),r=n+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[n+40>>2],r=n+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18063],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18071],i[n+20>>2]=i[18072],i[B>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(B),p0(n+76|0),v=n+160|0}function Zv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72548,n=i[18140],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18141],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=72548,i[f>>2]=72528,B=R0(k),i[B>>2]=71280,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,M1(n,e,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(f,32820,19),i[e+104>>2],i[e+108>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(n,31842,19),i[e+112>>2],i[e+116>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,31957,11),i[e+120>>2]),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(K2(Y(n,30676,10),i[e+128>>2],i[e+132>>2]),42713,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(d1(Y(f,31535,6),+u0[e+136>>2]*152587890625e-16),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(Gu(Y(n,31820,8),M(M(F[e+140>>1])*M(.00390625))),42713,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,41800,8),C=e+144|0;i:{for(;;){n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f,32850,2),V=G(m,3),n=0;e:{for(;;){k=f+140|0,o=n+V|0,(o|0)!=8?W=+u0[(o<<2)+C>>2]*152587890625e-16:W=1,h=d1(f,W),g=G1(k,h);r:{if(l[g|0]!=1)break r;o=i[i[h>>2]-12>>2]+h|0,_=i[o+4>>2],w=i[o+24>>2];f:{if(l[o+80|0]==1){k=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break f}t=f+148|0,k=i[o+28>>2],i[t>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[o+76|0]=k,u[o+77|0]=k>>>8,u[o+78|0]=k>>>16,u[o+79|0]=k>>>24,u[o+80|0]=1}f:{if(!w||(s=i[o+12>>2],_=(_&176)==32?32852:32851,t=_-32851|0,(t|0)>0&&(X[i[i[w>>2]+48>>2]](w,32851,t)|0)!=(t|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;t=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){I=t|7,s=E(I+1|0),i[f+156>>2]=I-2147483647,i[f+148>>2]=s,i[f+152>>2]=t;break A}u[f+159|0]=t,s=f+148|0}if(t&&o0(s,k,t),u[t+s|0]=0,k=X[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32852-_|0,(k|0)>0&&(X[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[o+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(g),n=n+1|0,(n|0)==3)break}if(Y(f,42713,1),m=m+1|0,(m|0)==3)break i;continue}break}g0(),H()}n=f+148|0,s0(n,r),k=n,r=u[f+159|0],n=(r|0)<0,Y(f,n?i[f+148>>2]:k,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f,32558,15),i[e+180>>2]),42713,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}g0(),H()}if(!n)break i;z(A,r,n)}u[A+n|0]=0,A=i[18139],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18142],i[B>>2]=71280,u[f+47|0]<0&&Z(i[f+36>>2]),y0(B),p0(f+56|0),v=f+160|0}function t9(A){var e=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{W:{X:{C:{I:{F:{Q:{V:{p:{M:{U:{D:{J:{E:{y:{$:{Y:{H:{x:{z:{T:{R:{S:{j:{O:{L:{P:{q:{K:{_0:{d:{v0:{c:{b:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{m0:{u0:{o0:{l0:{s0:{w0:{N:{a:{h0:{Z0:{g:{G0:{W0:{X0:{g0:{Q0:{I0:{C0:{V0:{if((A|0)<=1999){e=17222;B0:switch(A|0){case 0:break e;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 22:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 34:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 44:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 58:case 59:case 60:case 61:case 62:case 63:case 64:case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 91:case 92:case 93:case 94:case 95:case 96:case 97:case 98:case 99:case 144:case 145:case 146:case 147:case 148:break r;case 108:break w0;case 109:break s0;case 110:break l0;case 111:break o0;case 112:break u0;case 113:break m0;case 114:break n0;case 115:break k0;case 116:break A0;case 117:break f0;case 100:break V0;case 118:break I0;case 119:break Q0;case 120:break r0;case 121:break e0;case 122:break i0;case 123:break b;case 124:break c;case 125:break t0;case 126:break v0;case 127:break d;case 101:break C0;case 128:break _0;case 129:break K;case 130:break q;case 131:break h0;case 132:break P;case 133:break L;case 134:break O;case 135:break j;case 136:break S;case 137:break R;case 102:break g0;case 138:break T;case 139:break z;case 140:break x;case 141:break Z0;case 142:break $;case 143:break a;case 149:break y;case 150:break H;case 151:break Y;case 103:break X0;case 104:break W0;case 105:break G0;case 106:break g;case 107:break N;default:break B0}switch(A-1e3|0){case 0:break E;case 1:break J;default:break r}}if((A|0)<=3999){B0:switch(A-2e3|0){case 0:break D;case 1:break U;case 2:break M;case 3:break p;case 4:break V;case 5:break Q;case 6:break F;case 7:break I;case 8:break C;default:break B0}switch(A-3e3|0){case 0:break X;case 1:break W;case 2:break m;case 3:break G;case 4:break Z;case 5:break v;case 6:break B;case 7:break h;case 8:break _;default:break r}}B0:switch(A-5e3|0){case 0:break w;case 1:break s;case 2:break l;case 3:break o;case 4:break u;default:break B0}switch(A-6e3|0){case 0:break t;case 1:break n;case 2:break k;case 3:break A;default:break f}}return 13334}return 11481}return 18911}return 5737}return 2615}return 2573}return 2761}return 2587}return 2803}return 2789}return 2831}return 2817}return 2657}return 2643}return 2775}return 2747}return 2705}return 2629}return 2719}return 2733}return 7127}return 1341}return 9556}return 18820}return 8533}return 18693}return 19100}return 17172}return 9529}return 12758}return 4347}return 7569}return 11641}return 2416}return 10737}return 5556}return 6020}return 4585}return 18837}return 1438}return 16963}return 16929}return 9780}return 8447}return 2559}return 2601}return 2671}return 17272}return 6756}return 17800}return 15933}return 17622}return 16089}return 16039}return 6983}return 11976}return 1387}return 13599}return 18144}return 12785}return 8807}return 8613}return 15728}return 15765}return 15803}return 1271}return 12735}return 18714}return 9703}return 9726}return 9687}return 24522}return 17500}return 17455}return 4953}return 9253}if((A|0)==4e3)break i}e=i[23584]}return e}return 10715}function kr(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0;w=v-160|0,v=w;i:{if(!(f&&r)){if(e=E(24),i[w+12>>2]=e,i[w+16>>2]=18,i[w+20>>2]=-2147483624,r=l[11645]|l[11646]<<8|(l[11647]<<16|l[11648]<<24),f=l[11641]|l[11642]<<8|(l[11643]<<16|l[11644]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[11657]|l[11658]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[11653]|l[11654]<<8|(l[11655]<<16|l[11656]<<24),f=l[11649]|l[11650]<<8|(l[11651]<<16|l[11652]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,5,0,w+12|0),u[w+23|0]>=0)break i;Z(i[w+12>>2]);break i}i[e+12>>2]=f,i[e+8>>2]=r,u[e+5|0]=t,u[e+4|0]=n,i[e>>2]=k,k=f+1|0,_=(k>>>0<=64?64:k)&-2,i[e+20>>2]=_,k=r+1|0,k=(k>>>0<=64?64:k)&-2,i[e+16>>2]=k,n=n&255,h=1;e:{if(n>>>0<9||(h=2,n>>>0<17)||(h=4,n>>>0<33))break e;h=n>>>0<65?8:16}n=G(h,G(k,t))+15&-16,i[e+36>>2]=n;e:{r:{f:{A:{k:{n:{if(!o||(k=i[o+8>>2],t=i[o+12>>2],!(k|t))||(k=d8(k,t,f,0),t=l0,!t&r>>>0<=k>>>0|t))break n;i[w+104>>2]=0,i[w+76>>2]=72244,i[w+20>>2]=72224,e=i[18065],i[w+12>>2]=e,n=i[e-12>>2],k=w+12|0,e=k,i[n+e>>2]=i[18066],i[w+16>>2]=0,e=e+i[i[w+12>>2]-12>>2]|0,n=w+24|0,J0(e,n),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[w+20>>2]=e,t=i[e-12>>2],e=w+20|0,i[t+e>>2]=i[18068],t=i[18064],i[w+12>>2]=t,i[k+i[t-12>>2]>>2]=i[18069],i[w+76>>2]=72244,i[w+12>>2]=72204,i[w+20>>2]=72224,k=R0(n),i[k>>2]=71280,n=w- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,i[w+72>>2]=24,Y(K2(Y(I0(Y(I0(Y(e,28754,28),r),2998,1),f),28602,31),i[o+8>>2],i[o+12>>2]),5088,7),e=i[w+72>>2];t:{if(e&16){e=i[w+68>>2],r=i[w+48>>2],e>>>0<r>>>0&&(i[w+68>>2]=r,e=r),r=w+44|0;break t}if(!(e&8)){e=0,u[w+11|0]=0,r=w;break e}e=i[w+40>>2],r=w+32|0}if(f=i[r>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){n=e|7,r=E(n+1|0),i[w+8>>2]=n-2147483647,i[w>>2]=r,i[w+4>>2]=e;break r}if(u[w+11|0]=e,r=w,e)break r;e=0;break e}if(r=G(n,_)|15,i[e+32>>2]=r,K4(A,s,r,o,18900),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),r=wl(i[e+32>>2]),i[e+28>>2]=r,!r){i[w+104>>2]=0,i[w+76>>2]=72244,i[w+20>>2]=72224,r=i[18065],i[w+12>>2]=r,k=i[r-12>>2],f=w+12|0,r=f,i[k+r>>2]=i[18066],i[w+16>>2]=0,r=r+i[i[w+12>>2]-12>>2]|0,k=w+24|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[w+20>>2]=r,n=i[r-12>>2],r=w+20|0,i[n+r>>2]=i[18068],n=i[18064],i[w+12>>2]=n,i[f+i[n-12>>2]>>2]=i[18069],i[w+76>>2]=72244,i[w+12>>2]=72204,i[w+20>>2]=72224,k=R0(k),i[k>>2]=71280,f=w- -64|0,i[f>>2]=0,i[f+4>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,i[w+72>>2]=24,Y(I0(Y(r,28419,11),i[e+32>>2]),17041,13),e=i[w+72>>2];n:{if(e&16){f=w+44|0,r=i[w+68>>2],e=i[w+48>>2],r>>>0<e>>>0?i[w+68>>2]=e:e=r;break n}if(!(e&8)){e=0,u[w+11|0]=0,f=w;break f}f=w+32|0,e=i[w+40>>2]}if(r=i[f>>2],e=e-r|0,e>>>0>=2147483640)break k;if(e>>>0>=11){n=e|7,f=E(n+1|0),i[w+8>>2]=n-2147483647,i[w>>2]=f,i[w+4>>2]=e;break A}if(u[w+11|0]=e,f=w,e)break A;e=0;break f}if(f=e,e=r&15,i[f+24>>2]=r+(e?16-e|0:0),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!e)break f;z(f,r,e)}u[e+f|0]=0,K(A,6,0,w),u[w+11|0]<0&&Z(i[w>>2]),A=i[18063],i[w+12>>2]=A,i[i[A-12>>2]+(w+12|0)>>2]=i[18071],i[w+20>>2]=i[18072],i[k>>2]=71280,u[w+67|0]<0&&Z(i[w+56>>2]),y0(k),p0(w+76|0);break i}if(!e)break e;z(r,f,e)}u[e+r|0]=0,K(A,6,1e3,w),u[w+11|0]<0&&Z(i[w>>2]),A=i[18063],i[w+12>>2]=A,i[i[A-12>>2]+(w+12|0)>>2]=i[18071],i[w+20>>2]=i[18072],i[k>>2]=71280,u[w+67|0]<0&&Z(i[w+56>>2]),y0(k),p0(w+76|0)}v=w+160|0}function u9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;if(k=i[A+124>>2],_=i[k+16876>>2],r=i[k+16872>>2],m=e<<_>>r,B=i[k+16896>>2],e=e+1<<_>>r,V=(e|0)>(B|0)?B:e,(m|0)>=(V|0))return 0;i:{e:{if(i[k+16888>>2]>0)for(y=-1<<_^-1,R=i[k+16892>>2],N=i[k+16880>>2],g=i[A+132>>2];;){if(i[k+16888>>2]>0)for(e=0,w=G(m,N),$=(w|0)!=0&!(w&y),B=w?32:0,D=G(w>>_,R),x=w-1|0,f0=G(x>>_,R)<<2;;){r=(i[A+160>>2]+G(e,3)|0)+G(G(i[A+172>>2],m),3)|0,o=(l[r|0]|l[r+1|0]<<8)&7;r:{if(!o)break r;if(n=G(e,N),s=i[A+148>>2],r=n>>s,(r|0)<0||(h=i[A+152>>2],(h|0)<=(r|0)))break e;if(f=w>>s,(f|0)<0||(S=i[A+156>>2],(f|0)>=(S|0)))break i;if(I=i[A+52>>2],C=i[A+56>>2]-I>>2,W=i[A+140>>2],O=W+G(r,24)|0,L=G(G(f,h),24),r=F[(O+L|0)+2>>1],C>>>0<=r>>>0)return 0;a=n>>_,t=i[I+(r<<2)>>2],f=n?16:0,r=f;f:{if(!n||(r=f,n&y))break f;A:{if(l[t+772|0])break A;if(r=n-1>>s,(r|0)<0|r>>>0>=h>>>0)break e;if(W=F[((G(r,24)+W|0)+L|0)+2>>1],W>>>0>=C>>>0)break A;if(r=0,i[t+808>>2]!=i[i[I+(W<<2)>>2]+808>>2])break f}if(r=f,l[g+57|0])break f;f=D<<2,r=i[g+8484>>2],r=i[f+(r+(a<<2)|0)>>2]==i[f+(r+(n-1>>_<<2)|0)>>2]?16:0}f=r,r=B;f:{if(!$)break f;A:{if(l[t+772|0])break A;if(r=x>>s,(r|0)<0|(r|0)>=(S|0))break i;if(s=F[(G(G(r,h),24)+O|0)+2>>1],s>>>0>=C>>>0)break A;if(r=0,i[t+808>>2]!=i[i[I+(s<<2)>>2]+808>>2])break f}if(r=B,l[g+57|0])break f;r=i[g+8484>>2]+(a<<2)|0,r=i[r+(D<<2)>>2]==i[r+f0>>2]?32:0}if(l[t+762|0])break r;if(V6(A,n,w,o,0,f,r),r=i[A+168>>2],t=n>>r,(t|0)<0||(h=i[A+172>>2],(h|0)<=(t|0)))break e;if(s=w>>r,(s|0)<0|(s|0)>=i[A+176>>2])break i;r=1<<o,k=1<<o-2,f=1<<o-1;f:{A:{k:{n:{t:{u:{o:{l:switch(t=(i[A+160>>2]+G(t,3)|0)+G(G(s,h),3)|0,((l[t|0]|l[t+1|0]<<8)>>>3&7)-1|0){case 3:break o;case 4:break l;case 5:break t;case 6:break u;case 0:break n;case 1:break k;case 2:break A;default:break f}for(t=(r|0)<=1?1:r,f=(k+(f+w|0)|0)/4|0,r=0;k=(r+n|0)/4|0,o=i[A+272>>2],(k|0)>=(o|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+G(f,o)|0,u[k|0]=l[k|0]|128),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+w|0)/4|0,r=0;k=(r+n|0)/4|0,o=i[A+272>>2],(k|0)>=(o|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+G(f,o)|0,u[k|0]=l[k|0]|128),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+(f+n|0)|0)/4|0,r=0;k=i[A+272>>2],n=(r+w|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(k,n)|0,u[n|0]=l[n|0]|64),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+n|0)/4|0,r=0;k=i[A+272>>2],n=(r+w|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(k,n)|0,u[n|0]=l[n|0]|64),r=r+1|0,(t|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+w|0)/4|0,r=0;t=(r+n|0)/4|0,o=i[A+272>>2],(t|0)>=(o|0)|(f|0)>=i[A+276>>2]||(t=(t+i[A+260>>2]|0)+G(f,o)|0,u[t|0]=l[t|0]|128),r=r+1|0,(k|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+n|0)/4|0,r=0;t=i[A+272>>2],n=(r+w|0)/4|0,(t|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(n,t)|0,u[n|0]=l[n|0]|64),r=r+1|0,(k|0)!=(r|0););break f}for(h=(r|0)<=1?1:r,t=(f+w|0)/4|0,o=(f+n|0)/4|0,r=0;f=i[A+276>>2],s=(r+w|0)/4|0,k=i[A+272>>2],(f|0)<=(s|0)|(o|0)>=(k|0)||(f=(o+i[A+260>>2]|0)+G(k,s)|0,u[f|0]=l[f|0]|64,k=i[A+272>>2],f=i[A+276>>2]),s=(r+n|0)/4|0,(f|0)<=(t|0)|(s|0)>=(k|0)||(f=(s+i[A+260>>2]|0)+G(k,t)|0,u[f|0]=l[f|0]|128),r=r+1|0,(h|0)!=(r|0););}k=i[A+124>>2],A0=1}if(e=e+1|0,!((e|0)<i[k+16888>>2]))break}if(m=m+1|0,(V|0)==(m|0))break}return A0}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function Gv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;k=v-112|0,v=k,X[i[i[e>>2]+32>>2]](k+80|0,e,1,r,0,f);i:{e:{if(i[k+80>>2]){e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[k+99|0]>=0){e=i[k+92>>2],i[r>>2]=i[k+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+96>>2];break r}T(r,i[k+88>>2],i[k+92>>2])}u[A+20|0]=1;break e}for(X[i[i[e>>2]+36>>2]](k+60|0,e),u[k+79|0]<0&&Z(i[k+68>>2]),h=k+44|0,_=k+51|0,o=k+40|0,m=i[24276],W=i[24277],s=i[24274],w=i[24275];;){u[k+52|0]=0,i[k+32>>2]=0,i[k+36>>2]=0,X[i[i[e>>2]+40>>2]](k+8|0,e,r,0,f),t=l[k+28|0];r:{f:{if(n=l[k+52|0],(n|0)==255){if((t|0)==255)break i;break f}if((t|0)!=255)break f;i[k+104>>2]=s,i[k+108>>2]=w,X[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+32|0),u[k+52|0]=255;break r}n=k+32|0,i[k+100>>2]=n,i[k+104>>2]=m,i[k+108>>2]=W,X[i[(k+104|0)+(t<<2)>>2]](k+100|0,n,k+8|0)}n=l[k+28|0],(n|0)!=255&&(i[k+104>>2]=s,i[k+108>>2]=w,X[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+8|0));r:{f:{A:{k:{n:{if(n=l[k+52|0],n){if((n|0)==1)break n;break i}if(n=107712,!i[26928])break A;h=107724,_=107731,o=107720;break k}if(n=k+32|0,!i[k+32>>2])break i}e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[_|0]>=0){e=i[o+4>>2],i[r>>2]=i[o>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+8>>2];break k}T(r,i[o>>2],i[h>>2])}u[A+20|0]=1;break f}if(!i[k+32>>2])break r;u[A+20|0]=255,u[A|0]=0,i[k+8>>2]=A,X[i[24278]](k+8|0,k+32|0),u[A+20|0]=0}if(A=l[k+52|0],(A|0)==255)break e;i[k+8>>2]=s,i[k+12>>2]=w,X[i[(k+8|0)+(A<<2)>>2]](k+104|0,k+32|0);break e}if(t=k+8|0,n=k+32|0,X[s|0](t,n),B=B+1|0,(B|0)==50)break}f=E(64),i[k+8>>2]=f,i[k+12>>2]=58,i[k+16>>2]=-2147483584,e=l[25612]|l[25613]<<8,u[f+56|0]=e,u[f+57|0]=e>>>8,r=l[25608]|l[25609]<<8|(l[25610]<<16|l[25611]<<24),e=l[25604]|l[25605]<<8|(l[25606]<<16|l[25607]<<24),u[f+48|0]=e,u[f+49|0]=e>>>8,u[f+50|0]=e>>>16,u[f+51|0]=e>>>24,u[f+52|0]=r,u[f+53|0]=r>>>8,u[f+54|0]=r>>>16,u[f+55|0]=r>>>24,r=l[25600]|l[25601]<<8|(l[25602]<<16|l[25603]<<24),e=l[25596]|l[25597]<<8|(l[25598]<<16|l[25599]<<24),u[f+40|0]=e,u[f+41|0]=e>>>8,u[f+42|0]=e>>>16,u[f+43|0]=e>>>24,u[f+44|0]=r,u[f+45|0]=r>>>8,u[f+46|0]=r>>>16,u[f+47|0]=r>>>24,r=l[25592]|l[25593]<<8|(l[25594]<<16|l[25595]<<24),e=l[25588]|l[25589]<<8|(l[25590]<<16|l[25591]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[25584]|l[25585]<<8|(l[25586]<<16|l[25587]<<24),e=l[25580]|l[25581]<<8|(l[25582]<<16|l[25583]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[25576]|l[25577]<<8|(l[25578]<<16|l[25579]<<24),e=l[25572]|l[25573]<<8|(l[25574]<<16|l[25575]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[25568]|l[25569]<<8|(l[25570]<<16|l[25571]<<24),e=l[25564]|l[25565]<<8|(l[25566]<<16|l[25567]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[25560]|l[25561]<<8|(l[25562]<<16|l[25563]<<24),e=l[25556]|l[25557]<<8|(l[25558]<<16|l[25559]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+58|0]=0,f=K(n,7,0,t),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[k+19|0]>=0)break e;Z(i[k+8>>2])}u[k+99|0]<0&&Z(i[k+88>>2]),v=k+112|0;return}_2(),H()}function Wv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;e=v-144|0,v=e,i[e+104>>2]=0,i[e+108>>2]=0,i[e+112>>2]=0,i[e+116>>2]=0,u[e+119|0]=0,u[e+120|0]=0,u[e+121|0]=0,u[e+122|0]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+136>>2]=0,u[e+132|0]=1,u[e+92|0]=0,u[e+93|0]=0,u[e+94|0]=0,u[e+95|0]=0,u[e+85|0]=0,u[e+86|0]=0,u[e+87|0]=0,u[e+88|0]=0,u[e+89|0]=0,u[e+90|0]=0,u[e+91|0]=0,u[e+92|0]=0,u[e+84|0]=1,vt(e- -64|0,e+84|0,r),u[e+83|0]<0&&Z(i[e+72>>2]),i[e+60>>2]=0,t=i[r>>2],k=i[r+4>>2];i:{if(!k){i[e+60>>2]=0,i[e+56>>2]=t;break i}if(i[k+4>>2]=i[k+4>>2]+1,i[e+56>>2]=t,r=i[e+60>>2],i[e+60>>2]=k,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}X[i[i[f>>2]+100>>2]](e+44|0,i[f+4>>2],e+56|0,n);i:{e:{r:{f:{A:{if(k=i[e+44>>2],!k)for(;;){if(X[i[i[f>>2]+104>>2]](e+24|0,i[f+4>>2],e+12|0,e+8|0,0),Q9(e+84|0,i[e+12>>2],i[e+8>>2]),r=i[e+12>>2],!r)break A;Me(e+96|0,r,i[e+8>>2])}if(n=i[e+48>>2],t=i[e+52>>2],f=h2(t),f>>>0>=2147483640)break r;k:{n:{if(f>>>0>=11){o=f|7,r=E(o+1|0),i[e+20>>2]=o-2147483647,i[e+12>>2]=r,i[e+16>>2]=f;break n}if(u[e+23|0]=f,r=e+12|0,!f)break k}if(!f)break k;z(r,t,f)}u[r+f|0]=0,r=K(e+24|0,k,n,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;k:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break k}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break k;Z(i[r+8>>2])}if(u[e+23|0]>=0)break f;Z(i[e+12>>2]);break f}f=E(144),i[f>>2]=90572,i[f+4>>2]=0,i[f+8>>2]=0,n=f+16|0,r=n,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[r>>2]=98128,i[f+136>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+32>>2]=1635135811,r=l[e+88|0]|l[e+89|0]<<8|(l[e+90|0]<<16|l[e+91|0]<<24),k=l[e+84|0]|l[e+85|0]<<8|(l[e+86|0]<<16|l[e+87|0]<<24),u[f+113|0]=k,u[f+114|0]=k>>>8,u[f+115|0]=k>>>16,u[f+116|0]=k>>>24,u[f+117|0]=r,u[f+118|0]=r>>>8,u[f+119|0]=r>>>16,u[f+120|0]=r>>>24,r=l[e+92|0]|l[e+93|0]<<8|(l[e+94|0]<<16|l[e+95|0]<<24),u[f+121|0]=r,u[f+122|0]=r>>>8,u[f+123|0]=r>>>16,u[f+124|0]=r>>>24,i[f+4>>2]=i[f+4>>2]+1,r=i[e+104>>2],k=i[e+100>>2];A:{if(r>>>0>k>>>0){i[k+4>>2]=f,i[k>>2]=n,n=k+8|0;break A}if(t=i[e+96>>2],k=k-t|0,w=k>>3,o=w+1|0,o>>>0>=536870912)break e;if(r=r-t|0,s=r>>2,o=r>>>0>=2147483640?536870911:o>>>0<s>>>0?s:o,o){if(o>>>0>=536870912)break i;r=E(o<<3)}else r=0;if(s=r+k|0,i[s+4>>2]=f,i[s>>2]=n,w=s-(w<<3)|0,k&&z(w,t,k),r=r+(o<<3)|0,i[e+104>>2]=r,n=s+8|0,i[e+100>>2]=n,i[e+96>>2]=w,!t)break A;Z(t),r=i[e+104>>2]}if(Q[e+120>>1]=257,k=i[e+96>>2],i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,t=i[e+116>>2],i[e+116>>2]=0,o=i[e+108>>2],s=i[e+112>>2],i[e+108>>2]=0,i[e+112>>2]=0,i[A+20>>2]=t,i[A+12>>2]=o,i[A+16>>2]=s,i[A+8>>2]=r,i[A+4>>2]=n,i[A>>2]=k,r=i[e+124>>2],i[A+24>>2]=i[e+120>>2],i[A+28>>2]=r,r=i[e+132>>2],i[A+32>>2]=i[e+128>>2],i[A+36>>2]=r,i[A+40>>2]=i[e+136>>2],u[A+44|0]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break f;X[i[i[f>>2]+8>>2]](f),p(f)}A=i[e+60>>2];f:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break f;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[e+108>>2],A&&(i[e+112>>2]=A,Z(A)),A=i[e+96>>2],A){if(r=A,f=i[e+100>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];f:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e+96>>2]}i[e+100>>2]=A,Z(r)}v=e+144|0;return}g0(),H()}G0(),H()}x0(),H()}function o9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,i[k+88>>2]=0,i[k+92>>2]=0,i[k+104>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0;i:{e:{n=i[e+128>>2];r:{if(!n)break r;for(s=e+128|0,t=s;o=u0[n+16>>2]<r>>>0,t=o?t:n,n=i[(o?4:0)+n>>2],!!n;);if(o=0,(t|0)==(s|0)|u0[t+16>>2]>r>>>0)break r;if(n=i[t+20>>2],o=i[t+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),n)break e}u[k+48|0]=0,u[k+59|0]=0,e=K(k- -64|0,5,2e3,k+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[k+59|0]>=0)break i;Z(i[k+48>>2]);break i}t=i[n+112>>2];e:{if(u[n+139|0]>=0){i[k+56>>2]=i[n+136>>2],s=i[n+132>>2],i[k+48>>2]=i[n+128>>2],i[k+52>>2]=s;break e}T(k+48|0,i[n+128>>2],i[n+132>>2])}e:{if((t|0)!=1835625829){f&&(i[f>>2]=0),n=0,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,K6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+32|0,0,0,-1,-1,i[e+156>>2]);r:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break r}T(e,i[k+72>>2],i[k+76>>2]),n=1;break r}e=i[k+40>>2],i[k+40>>2]=0,r=i[k+32>>2],f=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(u[A+20|0]=n,u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+32>>2],!A)break e;i[k+36>>2]=A,Z(A);break e}r:{if(u[n+151|0]>=0){i[k+40>>2]=i[n+148>>2],t=i[n+144>>2],i[k+32>>2]=i[n+140>>2],i[k+36>>2]=t;break r}T(k+32|0,i[n+140>>2],i[n+144>>2])}t=2,s=u[k+43|0],n=(s|0)<0;r:{f:{A:{k:{n:{t:switch(s=n?i[k+36>>2]:s,s|0){case 2:break A;case 7:break k;case 13:break n;case 0:break t;default:break f}f&&(i[f>>2]=0),n=0,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,K6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+20|0,0,0,-1,-1,i[e+156>>2]);t:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break t}T(e,i[k+72>>2],i[k+76>>2]),n=1;break t}e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,i[k+24>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(u[A+20|0]=n,u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+20>>2],!A)break r;i[k+24>>2]=A,Z(A);break r}t=N2(n?i[k+32>>2]:k+32|0,18358,13)?2:4;break f}t=N2(n?i[k+32>>2]:k+32|0,12192,s)?2:3;break f}t=N2(n?i[k+32>>2]:k+32|0,7623,s)?2:5}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,K6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+20|0,0,0,-1,-1,i[e+156>>2]),r=i[k+68>>2],e=i[k+64>>2],i[k+88>>2]=e,i[k+92>>2]=r,u[k+107|0]<0&&(Z(i[k+96>>2]),e=i[k+88>>2]),r=i[k+76>>2],i[k+96>>2]=i[k+72>>2],i[k+100>>2]=r,i[k+104>>2]=i[k+80>>2];f:{if(e){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break A}T(e,i[k+96>>2],i[k+100>>2])}u[A+20|0]=1;break f}if(f){i[f>>2]=t,e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,u[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f;break f}u[k+8|0]=0,u[k+19|0]=0,e=K(k- -64|0,3,3005,k+8|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+19|0]>=0)break f;Z(i[k+8>>2])}if(A=i[k+20>>2],!A)break r;i[k+24>>2]=A,Z(A)}if(u[k+43|0]>=0)break e;Z(i[k+32>>2])}if(u[k+59|0]>=0)break i;Z(i[k+48>>2])}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}u[k+107|0]<0&&Z(i[k+96>>2]),v=k+112|0}function Xv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;t=Q[e+8>>1],_=v-32|0,o=Q[e+16>>1],h=Q[e>>1],n=Q[e+24>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+16>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+24>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+8>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,Q[_>>1]=(o|0)<=-32768?-32768:o,t=Q[e+10>>1],o=Q[e+18>>1],h=Q[e+2>>1],n=Q[e+26>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+18>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+26>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+10>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,Q[_+2>>1]=(o|0)<=-32768?-32768:o,t=Q[e+12>>1],o=Q[e+20>>1],h=Q[e+4>>1],n=Q[e+28>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+20>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+28>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,Q[_+12>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,Q[_+4>>1]=(o|0)<=-32768?-32768:o,n=Q[e+14>>1],o=Q[e+22>>1],h=Q[e+6>>1],e=Q[e+30>>1],t=((G(o,-74)+G(h,74)|0)+G(e,74)|0)- -64>>7,t=(t|0)>=32767?32767:t,Q[_+22>>1]=(t|0)<=-32768?-32768:t,t=(((G(n,-74)+G(h,84)|0)+G(o,55)|0)+G(e,-29)|0)- -64>>7,t=(t|0)>=32767?32767:t,Q[_+30>>1]=(t|0)<=-32768?-32768:t,n=G(n,74),t=(((n+G(h,55)|0)+G(o,-29)|0)+G(e,-84)|0)- -64>>7,t=(t|0)>=32767?32767:t,Q[_+14>>1]=(t|0)<=-32768?-32768:t,e=(((n+G(h,29)|0)+G(o,84)|0)+G(e,55)|0)- -64>>7,e=(e|0)>=32767?32767:e,Q[_+6>>1]=(e|0)<=-32768?-32768:e,o=20-f|0,e=-1<<f^-1,h=1<<19-f;i:{if((r|0)!=1){for(f=0;t=(f<<3)+_|0,s=Q[t+2>>1],n=(G(r,f)<<1)+A|0,k=Q[t+4>>1],m=Q[t>>1],t=Q[t+6>>1],w=h+((G(k,-74)+G(m,74)|0)+G(t,74)|0)>>o,w=(w|0)>=32767?32767:w,w=F[n+4>>1]+((w|0)<=-32768?-32768:w)|0,Q[n+4>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,B=G(s,74),w=h+(((B+G(m,29)|0)+G(k,84)|0)+G(t,55)|0)>>o,w=(w|0)>=32767?32767:w,w=F[n>>1]+((w|0)<=-32768?-32768:w)|0,Q[n>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,w=h+(((B+G(m,55)|0)+G(k,-29)|0)+G(t,-84)|0)>>o,w=(w|0)>=32767?32767:w,w=F[n+2>>1]+((w|0)<=-32768?-32768:w)|0,Q[n+2>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,B=n,w=F[n+6>>1],n=h+(((G(s,-74)+G(m,84)|0)+G(k,55)|0)+G(t,-29)|0)>>o,n=(n|0)>=32767?32767:n,n=w+((n|0)<=-32768?-32768:n)|0,Q[B+6>>1]=(n|0)>=0?(e|0)>(n|0)?n:e:0,f=f+1|0,(f|0)!=4;);break i}for(k=F[A+4>>1],f=0;t=(f<<3)+_|0,w=Q[t+2>>1],n=(G(r,f)<<1)+A|0,B=k&65535,k=Q[t+4>>1],m=Q[t>>1],t=Q[t+6>>1],s=h+((G(k,-74)+G(m,74)|0)+G(t,74)|0)>>o,s=(s|0)>=32767?32767:s,s=B+((s|0)<=-32768?-32768:s)|0,Q[n+4>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=G(w,74),s=h+(((B+G(m,29)|0)+G(k,84)|0)+G(t,55)|0)>>o,s=(s|0)>=32767?32767:s,s=F[n>>1]+((s|0)<=-32768?-32768:s)|0,Q[n>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,s=h+(((B+G(m,55)|0)+G(k,-29)|0)+G(t,-84)|0)>>o,s=(s|0)>=32767?32767:s,s=F[n+2>>1]+((s|0)<=-32768?-32768:s)|0,Q[n+2>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=n,s=F[n+6>>1],n=h+(((G(w,-74)+G(m,84)|0)+G(k,55)|0)+G(t,-29)|0)>>o,n=(n|0)>=32767?32767:n,n=s+((n|0)<=-32768?-32768:n)|0,k=(n|0)>=0?(e|0)>(n|0)?n:e:0,Q[B+6>>1]=k,f=f+1|0,(f|0)!=4;);}}function l9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v+-64|0,v=k;i:{if(l[e+88|0]==1){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}Br(k+40|0,e,1);e:{r:switch(l[k+60|0]){default:_2(),H();case 1:if(e=i[k+44>>2],i[A>>2]=i[k+40>>2],i[A+4>>2]=e,A=A+8|0,u[k+59|0]>=0){e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+56>>2];break e}T(A,i[k+48>>2],i[k+52>>2]);break e;case 0:break r}f=E(24),i[k+4>>2]=f,i[k+8>>2]=23,i[k+12>>2]=-2147483624,n=l[7429]|l[7430]<<8|(l[7431]<<16|l[7432]<<24),r=l[7425]|l[7426]<<8|(l[7427]<<16|l[7428]<<24),u[f+15|0]=r,u[f+16|0]=r>>>8,u[f+17|0]=r>>>16,u[f+18|0]=r>>>24,u[f+19|0]=n,u[f+20|0]=n>>>8,u[f+21|0]=n>>>16,u[f+22|0]=n>>>24,n=l[7422]|l[7423]<<8|(l[7424]<<16|l[7425]<<24),r=l[7418]|l[7419]<<8|(l[7420]<<16|l[7421]<<24),u[f+8|0]=r,u[f+9|0]=r>>>8,u[f+10|0]=r>>>16,u[f+11|0]=r>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,n=l[7414]|l[7415]<<8|(l[7416]<<16|l[7417]<<24),r=l[7410]|l[7411]<<8|(l[7412]<<16|l[7413]<<24),u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+23|0]=0,r=K(k+16|0,2,0,k+4|0),u[k+15|0]<0&&Z(i[k+4>>2]);r:{f:{A:{k:{n:{t:{u:{o:{if(o=i[k+40>>2],s=i[k+44>>2]-o|0,s>>>0>=2)for(f=1;;){n=t,t=f;l:{if(w=n+o|0,l[w|0]!=255||(f=l[f+o|0],(f&240)!=192|l[(f&15)+53392|0]!=1))break l;if(t=n+9|0,t>>>0>=s>>>0){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}s:{if(h=l[t+o|0],t=n+11|0,s>>>0>G(h,3)+t>>>0){if(!h)break u;if(o=t+o|0,s=l[o|0],n=0,f=0,t=0,(h|0)!=1)break s;break o}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(t=l[o+3|0],f=t&15,t=t>>>4|0,(h|0)==2)break o;o=l[o+6|0],_=o&15,B=o>>>4|0;break o}if(f=t+1|0,(s|0)==(f|0))break}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}switch(w=l[w+4|0],o=s&15,s=s>>>4|0,h-1|0){case 0:break n;case 2:break t;default:break u}}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(!((t|0)==(B|0)&(f|0)==(_|0))){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(n=1,!((f|0)!=1|(t|0)!=1|(s|0)!=2)&&(o|0)==2)break n;if(n=(f|0)!=1,!(n|(t|0)!=1|((s|0)!=2|(o|0)!=1))){n=2;break n}if((t|0)!=1|n|((s|0)!=1|(o|0)!=1))break k;n=3}if(l[e+88|0]!=1)break A;u[e+72|0]=w,w=l[k+4|0]|l[k+5|0]<<8,u[e+73|0]=w,u[e+74|0]=w>>>8,u[e+75|0]=l[k+6|0];break f}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}u[e+72|0]=w,w=l[k+4|0]|l[k+5|0]<<8,u[e+73|0]=w,u[e+74|0]=w>>>8,u[e+75|0]=l[k+6|0],u[e+88|0]=1}u[e+86|0]=_,u[e+85|0]=f,u[e+84|0]=o,u[e+83|0]=B,u[e+82|0]=t,u[e+81|0]=s,u[e+80|0]=h,i[e+76>>2]=n,k8(A,107712)}if(u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(A=l[k+60|0],(A|0)==255)break i;e=i[24673],i[k+16>>2]=i[24672],i[k+20>>2]=e,X[i[(k+16|0)+(A<<2)>>2]](k+4|0,k+40|0)}v=k- -64|0}function K4(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;n=v-160|0,v=n;i:{if(!f){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}e:{r:{f:{A:{k:{if(t=i[f+40>>2],o=i[f+44>>2],!(!(t|o)|(!o&r>>>0<=t>>>0|(o|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=72244,i[n+20>>2]=72224,e=i[18065],i[n+12>>2]=e,t=i[e-12>>2],e=n+12|0,i[t+e>>2]=i[18066],i[n+16>>2]=0,t=e+i[i[n+12>>2]-12>>2]|0,o=n+24|0,J0(t,o),u[t+80|0]=0,i[t+72>>2]=0,t=i[18067],i[n+20>>2]=t,s=i[t-12>>2],t=n+20|0,i[s+t>>2]=i[18068],s=i[18064],i[n+12>>2]=s,i[e+i[s-12>>2]>>2]=i[18069],i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,o=R0(o),i[o>>2]=71280,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=I0(Y(t,28419,11),r);n:{if(k){e=Y(Y(Y(e,27786,11),k,h2(k)),28602,31);break n}e=Y(e,28551,37)}Y(K2(e,i[f+40>>2],i[f+44>>2]),5240,6),e=i[n+72>>2];n:{if(e&16){t=i[n+68>>2],e=i[n+48>>2],t>>>0<e>>>0&&(i[n+68>>2]=e,t=e),e=n+44|0;break n}if(!(e&8)){t=0,u[n+11|0]=0,f=n;break e}t=i[n+40>>2],e=n+32|0}if(e=i[e>>2],t=t-e|0,t>>>0>=2147483640)break k;if(t>>>0>=11){r=t|7,f=E(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=f,i[n+4>>2]=t;break r}if(u[n+11|0]=t,f=n,t)break r;t=0;break e}if(!((f|0)!=95568&(f|0)!=95656)){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}l[107800]||(u[107800]=1);n:{t=i[26952];t:{if(!t)break t;for(o=107808;s=u0[t+16>>2]<f>>>0,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);if((o|0)==107808)break t;if(u0[o+16>>2]<=f>>>0)break n}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(s=i[f+64>>2],w=i[f+68>>2],t=i[o+20>>2]+r|0,!(!(s|w)|(!w&s>>>0>=t>>>0|(w|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=72244,i[n+20>>2]=72224,e=i[18065],i[n+12>>2]=e,t=i[e-12>>2],e=n+12|0,i[t+e>>2]=i[18066],i[n+16>>2]=0,t=e+i[i[n+12>>2]-12>>2]|0,s=n+24|0,J0(t,s),u[t+80|0]=0,i[t+72>>2]=0,t=i[18067],i[n+20>>2]=t,w=n+20|0,i[w+i[t-12>>2]>>2]=i[18068],t=i[18064],i[n+12>>2]=t,i[e+i[t-12>>2]>>2]=i[18069],i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,s=R0(s),i[s>>2]=71280,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=I0(Y(w,28709,16),i[o+20>>2]+r|0);n:{if(k){e=Y(Y(Y(e,27786,11),k,h2(k)),28602,31);break n}e=Y(e,28551,37)}Y(K2(e,i[f+64>>2],i[f+68>>2]),14129,28),e=i[n+72>>2];n:{if(e&16){t=i[n+68>>2],e=i[n+48>>2],t>>>0<e>>>0&&(i[n+68>>2]=e,t=e),e=n+44|0;break n}if(!(e&8)){t=0,u[n+11|0]=0,f=n;break f}t=i[n+40>>2],e=n+32|0}if(e=i[e>>2],t=t-e|0,t>>>0>=2147483640)break k;if(t>>>0>=11){r=t|7,f=E(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=f,i[n+4>>2]=t;break A}if(u[n+11|0]=t,f=n,t)break A;t=0;break f}if(i[e>>2]=f,i[e+4>>2]=i[e+4>>2]+r,i[o+20>>2]=t,t>>>0>u0[o+24>>2]&&(i[o+24>>2]=t),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!t)break f;z(f,e,t)}u[f+t|0]=0,K(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18063],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18071],i[n+20>>2]=i[18072],i[s>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(s),p0(n+76|0);break i}if(!t)break e;z(f,e,t)}u[f+t|0]=0,K(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18063],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18071],i[n+20>>2]=i[18072],i[o>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(o),p0(n+76|0)}v=n+160|0}function Cf(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0;w=v+-64|0,v=w;i:{s=i[e+120>>2];e:{if(!(!(r&1&(s|0)==2)&(!((r|k)&1)|(s|0)!=1))){if(i[w+48>>2]=0,i[w+52>>2]=0,i[w+40>>2]=0,i[w+44>>2]=0,u[w+52|0]=1,i[w+44>>2]=2,i[w+48>>2]=2,u[w+40|0]=1,i[w+56>>2]=i[e+84>>2],s=i[e+88>>2],!s||(s=Gi(s),i[w+60>>2]=s,!s))break i;i[w+8>>2]=131074,i[w+12>>2]=65538,_=255,s=i[e+128>>2];r:{if(!s)break r;for(e=e+128|0,h=e;m=i[s+16>>2],h=(m|0)<0?h:s,s=i[(m>>>29&4)+s>>2],!!s;);if((e|0)==(h|0)|i[h+16>>2]>0)break r;_=l[h+24|0]}kA(w+16|0,w+56|0,0,w+8|0,_,w+40|0,0,t),e=i[w+60>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;X[i[i[e>>2]+8>>2]](e),p(e)}r:{f:switch(l[w+36|0]){default:_2(),H();case 1:e=i[w+20>>2],i[A>>2]=i[w+16>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[w+35|0]>=0){r=i[w+28>>2],i[e>>2]=i[w+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[w+32>>2];break A}T(e,i[w+24>>2],i[w+28>>2])}u[A+20|0]=1;break r;case 0:break f}Cf(A,i[w+16>>2],r,f,k,n,t)}if(A=l[w+36|0],(A|0)==255)break e;e=i[23831],i[w+56>>2]=i[23830],i[w+60>>2]=e,X[i[(w+56|0)+(A<<2)>>2]](w+8|0,w+16|0);break e}o=E(172),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=94860,o0(o+16|0,0,80),s=i[o+4>>2],_=s+1|0,i[o+4>>2]=_,i[o+104>>2]=0,i[o+108>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,u[o+24|0]=1,Q[o+22>>1]=2,Q[o+18>>1]=2,Q[o+20>>1]=2,i[o+112>>2]=0,i[o+116>>2]=4740,i[o+140>>2]=0,i[o+144>>2]=0,i[o+128>>2]=99,i[o+132>>2]=99,i[o+120>>2]=0,i[o+124>>2]=0,i[o+12>>2]=95208,i[o+148>>2]=0,i[o+152>>2]=0,m=o+140|0,i[o+136>>2]=m,i[o+156>>2]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+168>>2]=0,i[o+4>>2]=s,s=i[o+8>>2],W=o+12|0,i[o+96>>2]=W,i[o+8>>2]=s+1,i[o+100>>2]=o,_||(X[i[i[o>>2]+8>>2]](o),p(o)),s=i[e+120>>2],i[o+128>>2]=i[e+116>>2],i[o+132>>2]=s,i[o+124>>2]=(n-k|0)+1,i[o+120>>2]=(f-r|0)+1;r:{if(s=i[e+124>>2],R=e+128|0,(s|0)!=(R|0))for(g=A+8|0;;){B=i[s+16>>2],I=po(r,B,i[e+120>>2],2),_=po(f,B,i[e+120>>2],0),C=yo(k,B,i[e+120>>2],2),N=(_-I|0)+1|0,y=yo(n,B,i[e+120>>2],0),Sf(w+16|0,W,B,N,(y-C|0)+1|0,i[s+20>>2],l[s+24|0],t),D=i[w+16>>2];f:{if(D){if(_=i[w+20>>2],i[A>>2]=i[w+16>>2],i[A+4>>2]=_,u[w+35|0]>=0){_=i[w+28>>2],i[g>>2]=i[w+24>>2],i[g+4>>2]=_,i[g+8>>2]=i[w+32>>2],u[A+20|0]=1;break f}T(g,i[w+24>>2],i[w+28>>2]),u[A+20|0]=1;break f}_=m,h=i[_>>2];A:{k:{if(!h)break k;for(;V=(B|0)>i[h+16>>2],_=V?_:h,h=i[(V?4:0)+h>>2],!!h;);if((_|0)==(m|0))break k;if((B|0)>=i[_+16>>2])break A}_=m}B=l[s+24|0],h=1;A:{if(B>>>0<9||(h=2,B>>>0<17)||(h=4,B>>>0<33))break A;h=B>>>0<65?8:16}if(C>>>0>y>>>0)break f;for(B=i[_+44>>2],V=i[_+56>>2],x=i[s+56>>2],_=G(h,N),I=i[s+44>>2]+G(h,I)|0,h=C;_&&z(G(V,h-C|0)+B|0,I+G(h,x)|0,_),h=h+1|0,y>>>0>=h>>>0;);}if(u[w+35|0]<0&&Z(i[w+24>>2]),D)break r;_=s,h=i[s+4>>2];f:{if(h){for(;;)if(s=h,h=i[s>>2],!h)break f}for(;s=i[_+8>>2],h=i[s>>2]!=(_|0),_=s,!!h;);}if((s|0)==(R|0))break}if(r=F[e+10>>1]|F[e+12>>1]<<16,i[w+16>>2]=F[e+6>>1]|F[e+8>>1]<<16,i[w+20>>2]=r,X[i[i[W>>2]+8>>2]](W,w+16|0),X[i[i[W>>2]+12>>2]](W,e+16|0),h=i[e+148>>2],r=i[e+152>>2],(h|0)!=(r|0))for(f=o+160|0,s=i[o+164>>2];;){f:{if(u0[o+168>>2]>s>>>0){if(e=i[h+4>>2],i[s>>2]=i[h>>2],i[s+4>>2]=e,e=s+8|0,u[h+19|0]>=0){k=i[h+12>>2],i[e>>2]=i[h+8>>2],i[e+4>>2]=k,i[e+8>>2]=i[h+16>>2],s=s+20|0;break f}T(e,i[h+8>>2],i[h+12>>2]),s=s+20|0;break f}s=fi(f,h)}if(i[o+164>>2]=s,h=h+20|0,(r|0)==(h|0))break}u[A+20|0]=0,i[A+4>>2]=o,i[A>>2]=W;break e}if(A=i[o+4>>2],i[o+4>>2]=A-1,A)break e;X[i[i[o>>2]+8>>2]](o),p(o)}v=w- -64|0;return}g3(),H()}function Vf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-48|0,v=k;i:{r=i[e>>2],n=i[e+4>>2];e:{if((r|0)==(n|0)){u[A+20|0]=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}r:{f:{if(o=n-1|0,!l[o|0]){if(t=(r^-1)+n|0,!t)break r;e=0;break f}e=E(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=l[16690]|l[16691]<<8|(l[16692]<<16|l[16693]<<24),f=l[16686]|l[16687]<<8|(l[16688]<<16|l[16689]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[16684]|l[16685]<<8|(l[16686]<<16|l[16687]<<24),f=l[16680]|l[16681]<<8|(l[16682]<<16|l[16683]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16676]|l[16677]<<8|(l[16678]<<16|l[16679]<<24),f=l[16672]|l[16673]<<8|(l[16674]<<16|l[16675]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[16668]|l[16669]<<8|(l[16670]<<16|l[16671]<<24),f=l[16664]|l[16665]<<8|(l[16666]<<16|l[16667]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,e=K(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}for(;;){if(l[e+r|0]){if(e=e+1|0,(t|0)!=(e|0))continue;break r}break}e=E(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=l[7031]|l[7032]<<8|(l[7033]<<16|l[7034]<<24),f=l[7027]|l[7028]<<8|(l[7029]<<16|l[7030]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[7025]|l[7026]<<8|(l[7027]<<16|l[7028]<<24),f=l[7021]|l[7022]<<8|(l[7023]<<16|l[7024]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[7017]|l[7018]<<8|(l[7019]<<16|l[7020]<<24),f=l[7013]|l[7014]<<8|(l[7015]<<16|l[7016]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[7009]|l[7010]<<8|(l[7011]<<16|l[7012]<<24),f=l[7005]|l[7006]<<8|(l[7007]<<16|l[7008]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,e=K(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}if(f=o-r|0,f>>>0>=2147483640)break i;r:{if(f>>>0<=10){u[k+11|0]=f,e=k;break r}s=f|7,e=E(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=e,i[k+4>>2]=f}r:{if((r|0)==(o|0))break r;if(n=(n-r|0)-2|0,t=t&7,t)for(f=0;u[e|0]=l[r|0],r=r+1|0,e=e+1|0,f=f+1|0,(t|0)!=(f|0););if(n>>>0<7)break r;for(;u[e|0]=l[r|0],u[e+1|0]=l[r+1|0],u[e+2|0]=l[r+2|0],u[e+3|0]=l[r+3|0],u[e+4|0]=l[r+4|0],u[e+5|0]=l[r+5|0],u[e+6|0]=l[r+6|0],u[e+7|0]=l[r+7|0],e=e+8|0,r=r+8|0,(o|0)!=(r|0););}u[e|0]=0,i[A+8>>2]=i[k+8>>2],e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,u[A+20|0]=0}v=k+48|0;return}g0(),H()}function s9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-80|0,v=f,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,u[f+55|0]=0,u[f+56|0]=0,u[f+57|0]=0,u[f+58|0]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+72>>2]=0,u[f+68|0]=1,i[f+16>>2]=0,X[i[i[r>>2]+132>>2]](f+4|0,i[r+4>>2],f+28|0,f+24|0,f+20|0,f+16|0,0),k=i[f+28>>2];i:{if(!k)break i;for(t=e+6|0;;){if(s=l[k|0],Q9(t,k,i[f+24>>2]),Me(f+32|0,i[f+28>>2],i[f+24>>2]),i[f+72>>2]=i[f+20>>2],n=i[r>>2],i[n>>2]<4|!i[n+136>>2]||(u[f+68|0]=i[f+16>>2]!=0),(s&120)==16)break i;if(i[f+16>>2]=0,X[i[n+132>>2]](f+4|0,i[r+4>>2],f+28|0,f+24|0,f+20|0,f+16|0,0),k=i[f+28>>2],!k)break}}i:{e:{r:{if(l[e+18|0]|l[e+5|0]!=1)break r;n=E(144),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90572,s=r+16|0,r=s,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,r=n,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[s>>2]=98128,i[r+136>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+32>>2]=1635135811,k=l[e+10|0]|l[e+11|0]<<8|(l[e+12|0]<<16|l[e+13|0]<<24),t=l[e+6|0]|l[e+7|0]<<8|(l[e+8|0]<<16|l[e+9|0]<<24),u[r+113|0]=t,u[r+114|0]=t>>>8,u[r+115|0]=t>>>16,u[r+116|0]=t>>>24,u[r+117|0]=k,u[r+118|0]=k>>>8,u[r+119|0]=k>>>16,u[r+120|0]=k>>>24,k=l[e+14|0]|l[e+15|0]<<8|(l[e+16|0]<<16|l[e+17|0]<<24),u[r+121|0]=k,u[r+122|0]=k>>>8,u[r+123|0]=k>>>16,u[r+124|0]=k>>>24,i[r+4>>2]=i[r+4>>2]+1,k=i[f+36>>2],o=i[f+40>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=r,i[k>>2]=s,r=k+8|0;break f}if(t=i[f+32>>2],r=k-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break e;if(o=o-t|0,w=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<w>>>0?w:k,o){if(o>>>0>=536870912)break i;k=E(o<<3)}else k=0;if(w=k+r|0,i[w+4>>2]=n,i[w>>2]=s,s=w-(h<<3)|0,r&&z(s,t,r),i[f+40>>2]=k+(o<<3),r=w+8|0,i[f+36>>2]=r,i[f+32>>2]=s,!t)break f;Z(t)}if(i[f+36>>2]=r,u[e+18|0]=1,r=i[n+4>>2],i[n+4>>2]=r-1,r)break r;X[i[i[n>>2]+8>>2]](n),p(n)}u[f+57|0]=1,u[f+56|0]=l[e+68|0];r:{if(l[e+64|0]==1){if(n=i[e+20>>2],n){if(r=n,k=i[e+24>>2],(r|0)!=(k|0)){for(;;){r=i[k-4>>2];f:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=k-8|0,(n|0)==(k|0))break}r=i[e+20>>2]}i[e+24>>2]=n,Z(r)}i[e+20>>2]=i[f+32>>2],i[e+24>>2]=i[f+36>>2],i[e+28>>2]=i[f+40>>2],i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,r=i[e+32>>2],r&&(i[e+36>>2]=r,Z(r)),i[e+32>>2]=i[f+44>>2],i[e+36>>2]=i[f+48>>2],i[e+40>>2]=i[f+52>>2],i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[e+60>>2]=i[f+72>>2],r=i[f+68>>2],i[e+52>>2]=i[f+64>>2],i[e+56>>2]=r,r=i[f+60>>2],i[e+44>>2]=i[f+56>>2],i[e+48>>2]=r;break r}i[e+20>>2]=i[f+32>>2],i[e+24>>2]=i[f+36>>2],i[e+28>>2]=i[f+40>>2],i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[e+32>>2]=i[f+44>>2],i[e+36>>2]=i[f+48>>2],i[e+40>>2]=i[f+52>>2],i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[e+60>>2]=i[f+72>>2],r=i[f+68>>2],i[e+52>>2]=i[f+64>>2],i[e+56>>2]=r,r=i[f+60>>2],i[e+44>>2]=i[f+56>>2],i[e+48>>2]=r,u[e+64|0]=1}if(i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=i[f+44>>2],A&&(i[f+48>>2]=A,Z(A)),A=i[f+32>>2],A){if(r=A,k=i[f+36>>2],(r|0)!=(k|0)){for(;;){e=i[k-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(k=k-8|0,(A|0)==(k|0))break}r=i[f+32>>2]}i[f+36>>2]=A,Z(r)}v=f+80|0;return}G0(),H()}x0(),H()}function w9(A,e,r){var f=0,k=0,n=0,t=0;k=v-160|0,v=k,f=i[r>>2],n=i[r+4>>2]-f|0;i:{if(n>>>0<=7){if(e=E(32),i[k+12>>2]=e,i[k+16>>2]=25,i[k+20>>2]=-2147483616,r=l[18866]|l[18867]<<8|(l[18868]<<16|l[18869]<<24),f=l[18862]|l[18863]<<8|(l[18864]<<16|l[18865]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+25|0]=0,u[e+24|0]=l[18886],r=l[18882]|l[18883]<<8|(l[18884]<<16|l[18885]<<24),f=l[18878]|l[18879]<<8|(l[18880]<<16|l[18881]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[18874]|l[18875]<<8|(l[18876]<<16|l[18877]<<24),f=l[18870]|l[18871]<<8|(l[18872]<<16|l[18873]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,118,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}e:{r:{f:{if(t=l[f|0],t){i[k+104>>2]=0,i[k+76>>2]=72244,i[k+20>>2]=72224,e=i[18065],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[18066],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,f=k+24|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+20>>2]=r,n=i[r-12>>2],r=k+20|0,i[n+r>>2]=i[18068],n=i[18064],i[k+12>>2]=n,i[e+i[n-12>>2]>>2]=i[18069],i[k+76>>2]=72244,i[k+12>>2]=72204,i[k+20>>2]=72224,n=R0(f),i[n>>2]=71280,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(S0(Y(r,28033,19),t),16212,17),e=i[k+72>>2];A:{if(e&16){e=k+44|0,f=i[k+68>>2],r=i[k+48>>2],f>>>0<r>>>0?i[k+68>>2]=r:r=f;break A}if(!(e&8)){r=0,u[k+11|0]=0,e=k;break e}e=k+32|0,r=i[k+40>>2]}if(f=i[e>>2],r=r-f|0,r>>>0>=2147483640)break f;if(r>>>0>=11){t=r|7,e=E(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=e,i[k+4>>2]=r;break r}if(u[k+11|0]=r,e=k,r)break r;r=0;break e}t=l[f+1|0],Q[e>>1]=l[f+2|0]+1,Q[e+2>>1]=l[f+3|0]+1,r=e;A:{if(t&1){if(n>>>0<=11){if(e=E(32),i[k+12>>2]=e,i[k+16>>2]=26,i[k+20>>2]=-2147483616,r=l[12161]|l[12162]<<8|(l[12163]<<16|l[12164]<<24),f=l[12157]|l[12158]<<8|(l[12159]<<16|l[12160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,r=l[12181]|l[12182]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[12177]|l[12178]<<8|(l[12179]<<16|l[12180]<<24),f=l[12173]|l[12174]<<8|(l[12175]<<16|l[12176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12169]|l[12170]<<8|(l[12171]<<16|l[12172]<<24),f=l[12165]|l[12166]<<8|(l[12167]<<16|l[12168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,118,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}n=e,e=l[f+4|0]|l[f+5|0]<<8|(l[f+6|0]<<16|l[f+7|0]<<24),i[n+4>>2]=e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24),e=l[f+9|0]<<16|l[f+8|0]<<24|l[f+10|0]<<8,f=f+11|0;break A}i[e+4>>2]=l[f+5|0]|l[f+4|0]<<8,e=l[f+6|0]<<8,f=f+7|0}if(i[r+8>>2]=l[f|0]|e,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!r)break e;z(e,f,r)}u[e+r|0]=0,K(A,4,3002,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18063],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18071],i[k+20>>2]=i[18072],i[n>>2]=71280,u[k+67|0]<0&&Z(i[k+56>>2]),y0(n),p0(k+76|0)}v=k+160|0}function gv(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;o=v-128|0,v=o,k=t+4|0,w=i[e+116>>2],n=i[t+4>>2];i:{e:{r:{if(!n){f=k;break r}for(_=k,f=n;B=w>>>0>u0[f+16>>2],_=B?_:f,f=i[(B?4:0)+f>>2],!!f;);if(!((k|0)==(_|0)|w>>>0<u0[_+16>>2])){f=E(32),i[o+32>>2]=f,i[o+36>>2]=28,i[o+40>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=K(o- -64|0,2,0,o+32|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+43|0]>=0)break i;Z(i[o+32>>2]);break i}for(;;){if(f=n,k=i[f+16>>2],k>>>0>w>>>0){if(k=f,n=i[f>>2],n)continue;break r}if(k>>>0>=w>>>0)break e;if(n=i[f+4>>2],!n)break}k=f+4|0}n=E(20),i[n+8>>2]=f,i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=w,i[k>>2]=n,f=i[i[t>>2]>>2],f&&(i[t>>2]=f),m1(i[t+4>>2],n),i[t+8>>2]=i[t+8>>2]+1}u[o+72|0]=0,i[o+84>>2]=0,i[o+88>>2]=0,i[o+104>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+64>>2]=0,i[o+68>>2]=0,i[o+76>>2]=0,i[o+80>>2]=0,f=i[e+100>>2],i[o+56>>2]=i[f+48>>2],f=i[f+52>>2],i[o+60>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k=i[e+116>>2],f=i[o+60>>2],i[o>>2]=i[o+56>>2],i[o+4>>2]=f,Ku(o- -64|0,o,k),X[i[i[e>>2]+112>>2]](o+32|0,e);e:{r:switch(l[o+52|0]){default:_2(),H();case 1:e=i[o+36>>2],i[A>>2]=i[o+32>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[o+51|0]>=0){e=i[o+44>>2],i[r>>2]=i[o+40>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+48>>2];break f}T(r,i[o+40>>2],i[o+44>>2])}u[A+20|0]=1;break e;case 0:break r}s=i[o+32>>2],h=i[o+36>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[o+24>>2]=i[o+104>>2],f=i[o+100>>2],i[o+16>>2]=i[o+96>>2],i[o+20>>2]=f,f=i[o+92>>2],i[o+8>>2]=i[o+88>>2],i[o+12>>2]=f,B=i[o+68>>2],f=i[o+64>>2],i[o+64>>2]=0,i[o+68>>2]=0,_=i[o+76>>2],t=i[o+80>>2],i[o+76>>2]=0,i[o+80>>2]=0,n=i[o+84>>2],i[o+84>>2]=0,k=l[o+72|0],i[s+8>>2]=f,w=i[s+12>>2],i[s+12>>2]=B;r:{if(!w||(f=i[w+4>>2],i[w+4>>2]=f-1,f))break r;X[i[i[w>>2]+8>>2]](w),p(w)}if(u[s+16|0]=k,f=i[s+20>>2],f&&(i[s+24>>2]=f,Z(f)),i[s+28>>2]=n,i[s+24>>2]=t,i[s+20>>2]=_,f=i[o+12>>2],i[s+32>>2]=i[o+8>>2],i[s+36>>2]=f,f=i[o+20>>2],i[s+40>>2]=i[o+16>>2],i[s+44>>2]=f,i[s+48>>2]=i[o+24>>2],X[i[i[s>>2]+28>>2]](A,s,r,i[e+100>>2]- -64|0),!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break e;X[i[i[h>>2]+8>>2]](h),p(h)}if(e=l[o+52|0],(e|0)!=255&&(A=i[25189],i[o+120>>2]=i[25188],i[o+124>>2]=A,X[i[(o+120|0)+(e<<2)>>2]](o+119|0,o+32|0)),A=i[o+76>>2],A&&(i[o+80>>2]=A,Z(A)),e=i[o+68>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=o+128|0}function Ff(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;l[129792]||(f=v-16|0,v=f,l[129784]||(k=v-16|0,v=k,i[k+12>>2]=1,i[32407]=i[k+12>>2]-1,i[32406]=84720,i[32406]=79520,i[32406]=78040,e=v-16|0,v=e,i[32408]=0,i[32409]=0,i[e+12>>2]=0,i[32410]=0,u[129764]=0,i[e+4>>2]=129632,u[e+10|0]=0,r=v-16|0,v=r,Po()>>>0<30&&(Z4(),H()),hl(r+8|0,129644,30),n=i[r+8>>2],i[32409]=n,i[32408]=n,i[32410]=(i[r+12>>2]<<2)+n,v=r+16|0,Qo(30),u[e+10|0]=1,v=e+16|0,oe(129768,20062),Aw(129632),i[32764]=0,i[32763]=84720,i[32763]=79520,i[32763]=80632,v1(131052,l1(129456)),i[32766]=0,i[32765]=84720,i[32765]=79520,i[32765]=80664,v1(131060,l1(129464)),i[32768]=0,i[32767]=84720,i[32767]=79520,u[131080]=0,i[32769]=0,i[32767]=78060,i[32769]=78112,v1(131068,l1(129808)),i[32772]=0,i[32771]=84720,i[32771]=79520,i[32771]=79576,v1(131084,l1(129800)),i[32774]=0,i[32773]=84720,i[32773]=79520,i[32773]=79728,v1(131092,l1(129816)),i[32776]=0,i[32775]=84720,i[32775]=79520,i[32775]=79144,t=131108,o=a2(),i[t>>2]=o,v1(131100,l1(129824)),i[32779]=0,i[32778]=84720,i[32778]=79520,i[32778]=79876,v1(131112,l1(129832)),i[32781]=0,i[32780]=84720,i[32780]=79520,i[32780]=80108,v1(131120,l1(129848)),i[32783]=0,i[32782]=84720,i[32782]=79520,i[32782]=79992,v1(131128,l1(129840)),i[32785]=0,i[32784]=84720,i[32784]=79520,i[32784]=80224,v1(131136,l1(129856)),i[32787]=0,i[32786]=84720,i[32786]=79520,Q[65576]=11310,i[32786]=79192,e=v-16|0,v=e,i[32789]=0,i[32790]=0,i[32791]=0,v=e+16|0,v1(131144,l1(129864)),i[32793]=0,i[32792]=84720,i[32792]=79520,i[32794]=46,i[32795]=44,i[32792]=79232,e=v-16|0,v=e,i[32796]=0,i[32797]=0,i[32798]=0,v=e+16|0,v1(131168,l1(129872)),i[32800]=0,i[32799]=84720,i[32799]=79520,i[32799]=80696,v1(131196,l1(129472)),i[32802]=0,i[32801]=84720,i[32801]=79520,i[32801]=80944,v1(131204,l1(129480)),i[32804]=0,i[32803]=84720,i[32803]=79520,i[32803]=81156,v1(131212,l1(129488)),i[32806]=0,i[32805]=84720,i[32805]=79520,i[32805]=81392,v1(131220,l1(129496)),i[32808]=0,i[32807]=84720,i[32807]=79520,i[32807]=82388,v1(131228,l1(129536)),i[32810]=0,i[32809]=84720,i[32809]=79520,i[32809]=82536,v1(131236,l1(129544)),i[32812]=0,i[32811]=84720,i[32811]=79520,i[32811]=82652,v1(131244,l1(129552)),i[32814]=0,i[32813]=84720,i[32813]=79520,i[32813]=82768,v1(131252,l1(129560)),i[32816]=0,i[32815]=84720,i[32815]=79520,i[32815]=82884,v1(131260,l1(129568)),i[32818]=0,i[32817]=84720,i[32817]=79520,i[32817]=83052,v1(131268,l1(129576)),i[32820]=0,i[32819]=84720,i[32819]=79520,i[32819]=83220,v1(131276,l1(129584)),i[32822]=0,i[32821]=84720,i[32821]=79520,i[32821]=83388,v1(131284,l1(129592)),i[32824]=0,i[32823]=84720,i[32823]=79520,i[32825]=84648,i[32823]=81592,i[32825]=81640,v1(131292,l1(129504)),i[32827]=0,i[32826]=84720,i[32826]=79520,i[32828]=84684,i[32826]=81860,i[32828]=81908,v1(131304,l1(129512)),i[32830]=0,i[32829]=84720,i[32829]=79520,Cs(131324),i[32829]=82100,v1(131316,l1(129520)),i[32833]=0,i[32832]=84720,i[32832]=79520,Cs(131336),i[32832]=82260,v1(131328,l1(129528)),i[32836]=0,i[32835]=84720,i[32835]=79520,i[32835]=83556,v1(131340,l1(129600)),i[32838]=0,i[32837]=84720,i[32837]=79520,i[32837]=83676,v1(131348,l1(129608)),v=k+16|0,i[f+8>>2]=129624,i[32445]=i[f+8>>2],u[129784]=1),v=f+16|0,e=i[32445],i[32447]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),u[129792]=1),e=A,A=i[32447],i[e>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1)}function Qv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],k=n+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,s=R0(t),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,t=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(f+8|0,30819,9),l[e+97|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,31904,13),l[e+98|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,32698,17),l[e+99|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,30993,15),l[e+101|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29704,12),l[e+102|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,31829,12),l[e+103|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29594,22),l[e+104|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29337,22),l[e+105|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,30591,24),l[e+106|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,29290,28);i:{if(l[e+107|0]){Y(S0(f+8|0,l[e+108|0]+1|0),42713,1);break i}Y(f+8|0,32898,12)}if(n=f+148|0,s0(n,r),k=0,o=n,r=u[f+159|0],n=(r|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,21065,12),i[e+116>>2]!=i[e+112>>2])for(;n=Y(f+8|0,32851,1),t=i[n>>2],r=t-12|0,o=i[r>>2]+n|0,i[o+4>>2]=i[o+4>>2]&-75|8,r=n+i[r>>2]|0,l[r+80|0]||(o=f+148|0,t=i[r+28>>2],i[o>>2]=t,(t|0)!=129624&&(i[t+4>>2]=i[t+4>>2]+1),t=c0(o,129808),X[i[i[t>>2]+28>>2]](t,32)|0,e2(o),t=i[n>>2]),u[r+76|0]=48,u[r+77|0]=0,u[r+78|0]=0,u[r+79|0]=0,u[r+80|0]=1,i[(n+i[t-12>>2]|0)+12>>2]=2,S0(n,l[i[e+112>>2]+k|0]),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>>0;);e=f+8|0,r=e+i[i[f+8>>2]-12>>2]|0,i[r+4>>2]=i[r+4>>2]&-75|2,Y(e,42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function H8(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0;h=s<<2,m=i[h+62832>>2]+n|0,h=i[h+62816>>2],W=m+h|0,I=w-8|0,w=i[(o<<2)+62816>>2];i:{e:switch(o|0){case 0:if(B=0-h|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(C=(h<<1)+t|0,V=r-(w<<1)|0,y=k&2147483644,g=k&3,R=k>>>0<4;;){if(w=(B<<1)+C|0,h=(G(f,B)<<1)+V|0,_=0,!R)for(;Q[w>>1]=F[h>>1],r=W<<1,w=r+w|0,Q[w>>1]=F[h+2>>1],w=r+w|0,Q[w>>1]=F[h+4>>1],w=r+w|0,Q[w>>1]=F[h+6>>1],w=r+w|0,h=h+8|0,_=_+4|0,(y|0)!=(_|0););if(r=0,g)for(;Q[w>>1]=F[h>>1],h=h+2|0,w=(W<<1)+w|0,r=r+1|0,(g|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,g=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=g+(G(f,_)<<1)|0,r=0;Q[w>>1]=F[h+12>>1]+((((((F[h+2>>1]<<2)-F[h>>1]|0)+G(F[h+4>>1],-10)|0)+G(F[h+6>>1],58)|0)+G(F[h+8>>1],17)|0)+G(F[h+10>>1],-5)|0)>>I,h=h+2|0,w=(W<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,g=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=g+(G(f,_)<<1)|0,r=0;Q[w>>1]=(((((F[h+2>>1]<<2)-F[h>>1]|0)+G(F[h+8>>1]+F[h+6>>1]|0,40)|0)+(F[h+12>>1]<<2)|0)-F[h+14>>1]|0)+G(F[h+10>>1]+F[h+4>>1]|0,-11)>>I,h=h+2|0,w=(W<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,g=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=g+(G(f,_)<<1)|0,r=0;Q[w>>1]=(((((F[h>>1]+G(F[h+2>>1],-5)|0)+G(F[h+4>>1],17)|0)+G(F[h+6>>1],58)|0)+G(F[h+8>>1],-10)|0)+(F[h+10>>1]<<2)|0)-F[h+12>>1]>>I,h=h+2|0,w=(W<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=o?6:I;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(G(_,W)<<1)+t|0,r=0;Q[w>>1]=(((((Q[h>>1]+G(Q[h+2>>1],-5)|0)+G(Q[h+4>>1],17)|0)+G(Q[h+6>>1],58)|0)+G(Q[h+8>>1],-10)|0)+(Q[h+10>>1]<<2)|0)-Q[h+12>>1]>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(G(_,W)<<1)+t|0,r=0;Q[w>>1]=(((((Q[h+2>>1]<<2)-Q[h>>1]|0)+G(Q[h+8>>1]+Q[h+6>>1]|0,40)|0)+(Q[h+12>>1]<<2)|0)-Q[h+14>>1]|0)+G(Q[h+10>>1]+Q[h+4>>1]|0,-11)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,o=(n|0)<=0;;){if(!o)for(w=(_<<1)+A|0,h=(G(_,W)<<1)+t|0,r=0;Q[w>>1]=Q[h+12>>1]+((((((Q[h+2>>1]<<2)-Q[h>>1]|0)+G(Q[h+4>>1],-10)|0)+G(Q[h+6>>1],58)|0)+G(Q[h+8>>1],17)|0)+G(Q[h+10>>1],-5)|0)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(w=(f<<1)+A|0,h=(G(f,W)<<1)+t|0,r=0,n>>>0>3)for(;Q[w>>1]=F[h>>1],o=e<<1,w=o+w|0,Q[w>>1]=F[h+2>>1],w=o+w|0,Q[w>>1]=F[h+4>>1],w=o+w|0,Q[w>>1]=F[h+6>>1],w=o+w|0,h=h+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;Q[w>>1]=F[h>>1],h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function Iv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,1104);break r}B=e,m=F0(r),i[B+104>>2]=m,n=F0(r),i[e+108>>2]=n;f:{if(i[e+104>>2])break f;if(n>>>0>u0[f+80>>2]){if(e=E(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17300]|l[17301]<<8|(l[17302]<<16|l[17303]<<24),f=l[17296]|l[17297]<<8|(l[17298]<<16|l[17299]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17353]|l[17354]<<8|(l[17355]<<16|l[17356]<<24),f=l[17349]|l[17350]<<8|(l[17351]<<16|l[17352]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17348]|l[17349]<<8|(l[17350]<<16|l[17351]<<24),f=l[17344]|l[17345]<<8|(l[17346]<<16|l[17347]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17340]|l[17341]<<8|(l[17342]<<16|l[17343]<<24),f=l[17336]|l[17337]<<8|(l[17338]<<16|l[17339]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17332]|l[17333]<<8|(l[17334]<<16|l[17335]<<24),f=l[17328]|l[17329]<<8|(l[17330]<<16|l[17331]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17324]|l[17325]<<8|(l[17326]<<16|l[17327]<<24),f=l[17320]|l[17321]<<8|(l[17322]<<16|l[17323]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17316]|l[17317]<<8|(l[17318]<<16|l[17319]<<24),f=l[17312]|l[17313]<<8|(l[17314]<<16|l[17315]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17308]|l[17309]<<8|(l[17310]<<16|l[17311]<<24),f=l[17304]|l[17305]<<8|(l[17306]<<16|l[17307]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,k+24|0),u[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(K4(A,e+124|0,n<<2,f,13692),i[A>>2])break r;if(u[A+19|0]<0&&Z(i[A+8>>2]),!i[e+108>>2])break f;for(;;){if(!i[r+16>>2]){r=_A(k+24|0),Y(I0(Y(I0(Y(r+8|0,28111,24),i[e+108>>2]),28970,33),h),5504,8),e=k+12|0,QA(e,r),K(A,2,100,e),u[k+23|0]<0&&Z(i[k+12>>2]),H6(r);break r}s=F0(r),f=i[e+116>>2],t=i[e+120>>2];A:{if(f>>>0<t>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+112>>2],f=f-w|0,_=f>>2,n=_+1|0,n>>>0>=1073741824)break e;if(t=t-w|0,o=t>>1,t=t>>>0>=2147483644?1073741823:n>>>0<o>>>0?o:n,t){if(t>>>0>=1073741824)break i;n=E(t<<2)}else n=0;if(o=n+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&z(s,w,f),i[e+120>>2]=n+(t<<2),f=o+4|0,i[e+116>>2]=f,i[e+112>>2]=s,!w)break A;Z(w)}if(i[e+116>>2]=f,l[r+20|0]==1){cu(A,r);break r}if(h=h+1|0,!(h>>>0<u0[e+108>>2]))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,K(A,2,100,k+24|0),u[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}v=k+192|0;return}G0(),H()}x0(),H()}function Cv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-16|0,v=k;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=E(48),i[k+4>>2]=e,i[k+8>>2]=44,i[k+12>>2]=-2147483600,r=l[16380]|l[16381]<<8|(l[16382]<<16|l[16383]<<24),f=l[16376]|l[16377]<<8|(l[16378]<<16|l[16379]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[16416]|l[16417]<<8|(l[16418]<<16|l[16419]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[16412]|l[16413]<<8|(l[16414]<<16|l[16415]<<24),f=l[16408]|l[16409]<<8|(l[16410]<<16|l[16411]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16404]|l[16405]<<8|(l[16406]<<16|l[16407]<<24),f=l[16400]|l[16401]<<8|(l[16402]<<16|l[16403]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16396]|l[16397]<<8|(l[16398]<<16|l[16399]<<24),f=l[16392]|l[16393]<<8|(l[16394]<<16|l[16395]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16388]|l[16389]<<8|(l[16390]<<16|l[16391]<<24),f=l[16384]|l[16385]<<8|(l[16386]<<16|l[16387]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,4,0,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(o=i[f+40>>2],f=i[f+44>>2],t=i[r+16>>2],!(!(o|f)|(!f&t>>>0<=o>>>0|(f|0)!=0))){if(e=E(32),i[k+4>>2]=e,i[k+8>>2]=31,i[k+12>>2]=-2147483616,r=l[11591]|l[11592]<<8|(l[11593]<<16|l[11594]<<24),f=l[11587]|l[11588]<<8|(l[11589]<<16|l[11590]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[11614]|l[11615]<<8|(l[11616]<<16|l[11617]<<24),f=l[11610]|l[11611]<<8|(l[11612]<<16|l[11613]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[11607]|l[11608]<<8|(l[11609]<<16|l[11610]<<24),f=l[11603]|l[11604]<<8|(l[11605]<<16|l[11606]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11599]|l[11600]<<8|(l[11601]<<16|l[11602]<<24),f=l[11595]|l[11596]<<8|(l[11597]<<16|l[11598]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}n=i[e+104>>2],f=i[e+100>>2],o=n-f|0;r:{if(o>>>0<t>>>0){if(w=t-o|0,s=i[e+108>>2],w>>>0<=s-n>>>0){w&&o0(n,0,w),i[e+104>>2]=n+w;break r}if((t|0)<0)break i;if(n=s-f|0,s=n<<1,s=n>>>0>=1073741823?2147483647:t>>>0<s>>>0?s:t,n=E(s),w&&o0(n+o|0,0,w),o&&z(n,f,o),i[e+108>>2]=n+s,i[e+104>>2]=n+t,i[e+100>>2]=n,!f)break r;Z(f);break r}if(t>>>0>=o>>>0)break r;i[e+104>>2]=f+t}if(l6(r,i[e+100>>2],t),l[r+20|0]==1){if(u[k+4|0]=0,u[k+15|0]=0,K(A,2,100,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=k+16|0;return}G0(),H()}function Vv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=M(0),y=M(0),R=M(0),N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0,n0=0,h0=0;t=v-48|0,v=t;i:{e:{r:{if((j0(i[r>>2],0)|0)!=8||(j0(i[r>>2],1)|0)!=8)break r;if((j0(i[r>>2],2)|0)==8)break e}e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;r:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break r}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,k=n+140|0,i[n+136>>2]=k,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],w=n+12|0,i[n+96>>2]=w,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],W=i[e+108>>2],f=W,g=i[e+112>>2],e=g,i[w+120>>2]=10,i[w+116>>2]=1,i[w+112>>2]=e,i[w+108>>2]=f,T0(t+24|0,w,10,f,e,8,o);e:{if(i[t+24>>2]){if(e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,r=A+8|0,u[t+43|0]>=0){e=i[t+36>>2],i[r>>2]=i[t+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+40>>2],u[A+20|0]=1;break e}if(T(r,i[t+32>>2],i[t+36>>2]),e=u[t+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+32>>2]);break e}u[t+43|0]<0&&Z(i[t+32>>2]),i[t+36>>2]=-1086926434,i[t+40>>2]=1071829221,i[t+28>>2]=1068725436,i[t+32>>2]=-1095748968,u[t+24|0]=1,S4(i[r>>2])&&(f=i[r>>2],e=F[f+6>>1]|F[f+8>>1]<<16,le(t+4|0,(F[f+10>>1]|F[f+12>>1]<<16)&65535,e&65535),i[t+40>>2]=i[t+20>>2],e=i[t+16>>2],i[t+32>>2]=i[t+12>>2],i[t+36>>2]=e,e=i[t+8>>2],i[t+24>>2]=i[t+4>>2],i[t+28>>2]=e),V=E0[t+28>>2],y=E0[t+36>>2],R=E0[t+32>>2],e=i[r>>2],r=i[e+128>>2],N=u6(M(E0[t+40>>2]*M(256))),D=u6(M(R*M(256))),x=u6(M(y*M(256))),S=u6(M(V*M(256)));r:{f:{if(r){for(e=e+128|0,f=e,o=r;h=i[o+16>>2],f=(h|0)<0?f:o,o=i[(h>>>29&4)+o>>2],!!o;);_=0;A:{if((e|0)==(f|0)||(_=0,i[f+16>>2]>0))break A;O=i[f+44>>2],_=i[f+56>>2]}for(f=e,o=r;h=i[o+16>>2]<=0,f=h?f:o,o=i[(h?4:0)+o>>2],!!o;);B=0;A:{if((e|0)==(f|0)||(B=0,i[f+16>>2]>1))break A;L=i[f+56>>2],B=i[f+44>>2]}for(o=e;f=i[r+16>>2]<2,o=f?o:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}m=0;break r}if(m=0,i[o+16>>2]>2)break r;a=i[o+56>>2],m=i[o+44>>2]}r=i[k>>2],e=0;r:{if(!r)break r;for(o=k;e=i[r+16>>2]<10,o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(o|0)||(e=0,i[o+16>>2]>10))break r;$=i[o+56>>2],e=i[o+44>>2]}if(h=e,!(!g|!W))for(e=0;;){for(f0=G(e,$)+h|0,A0=G(e,_)+O|0,r=e>>>1|0,n0=G(r,a)+m|0,h0=G(r,L)+B|0,r=0,k=0,o=0,f=0;r&1||(f=r>>>1|0,k=l[f+h0|0]-128|0,f=l[f+n0|0]-128|0,o=(G(k,D)+G(f,x)|0)+128>>8,k=G(k,N)+128>>8,f=G(f,S)+128>>8),I=G(r,3)+f0|0,C=l[r+A0|0],s=C+k|0,u[I+2|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=o+C|0,u[I+1|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=f+C|0,u[I|0]=(s|0)>=0?s>>>0>=255?255:s:0,r=r+1|0,(W|0)!=(r|0););if(e=e+1|0,(g|0)==(e|0))break}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=w;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+48|0}function h9(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{if(i[e+56>>2])break e;r:{if(!i[r+24>>2])break r;t=X[i[i[e>>2]+8>>2]](e)|0,o=i[r+24>>2],Je(),f=i[26938];f:{if((f|0)!=107756)for(;;){A:{if(n=i[f+16>>2],(X[i[n+16>>2]](t)|0)<=0||n4(o,i[n+40>>2]))break A;f=1;break f}n=i[f+4>>2];A:{if(n){for(;;)if(f=n,n=i[f>>2],!n)break A}for(;n=f,f=i[f+8>>2],(n|0)!=i[f>>2];);}if((f|0)==107756)break}f=0}if(f)break r;if(e=E(32),i[k+4>>2]=e,i[k+8>>2]=30,i[k+12>>2]=-2147483616,r=l[25759]|l[25760]<<8|(l[25761]<<16|l[25762]<<24),f=l[25755]|l[25756]<<8|(l[25757]<<16|l[25758]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[25781]|l[25782]<<8|(l[25783]<<16|l[25784]<<24),f=l[25777]|l[25778]<<8|(l[25779]<<16|l[25780]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[25775]|l[25776]<<8|(l[25777]<<16|l[25778]<<24),f=l[25771]|l[25772]<<8|(l[25773]<<16|l[25774]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25767]|l[25768]<<8|(l[25769]<<16|l[25770]<<24),f=l[25763]|l[25764]<<8|(l[25765]<<16|l[25766]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,11,0,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=e,e=ht(X[i[i[e>>2]+8>>2]](e)|0,i[r+24>>2]),i[f+56>>2]=e,!e){if(u[k+4|0]=0,u[k+15|0]=0,K(A,11,6003,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(i[e>>2]>4)break e;if(e=E(48),i[k+4>>2]=e,i[k+8>>2]=46,i[k+12>>2]=-2147483600,r=l[26072]|l[26073]<<8|(l[26074]<<16|l[26075]<<24),f=l[26068]|l[26069]<<8|(l[26070]<<16|l[26071]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[26110]|l[26111]<<8|(l[26112]<<16|l[26113]<<24),f=l[26106]|l[26107]<<8|(l[26108]<<16|l[26109]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[26104]|l[26105]<<8|(l[26106]<<16|l[26107]<<24),f=l[26100]|l[26101]<<8|(l[26102]<<16|l[26103]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26096]|l[26097]<<8|(l[26098]<<16|l[26099]<<24),f=l[26092]|l[26093]<<8|(l[26094]<<16|l[26095]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26088]|l[26089]<<8|(l[26090]<<16|l[26091]<<24),f=l[26084]|l[26085]<<8|(l[26086]<<16|l[26087]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26080]|l[26081]<<8|(l[26082]<<16|l[26083]<<24),f=l[26076]|l[26077]<<8|(l[26078]<<16|l[26079]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,11,6003,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=k+16|0}function Fv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;h=v-32|0,v=h,e=i[r>>2],I=i[e+112>>2],W=i[e+108>>2];i:{if((j0(e,0)|0)!=8){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,r=A+8|0;e:{if(u[107751]>=0){e=i[26936],i[r>>2]=i[26935],i[r+4>>2]=e,i[r+8>>2]=i[26937];break e}T(r,i[26935],i[26936])}u[A+20|0]=1;break i}t=E(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94860,o0(t+16|0,0,80),e=i[t+4>>2],f=e+1|0,i[t+4>>2]=f,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,n=t+140|0,i[t+136>>2]=n,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=e,e=i[t+8>>2],g=t+12|0,i[t+96>>2]=g,i[t+8>>2]=e+1,i[t+100>>2]=t,f||(X[i[i[t>>2]+8>>2]](t),p(t)),S=u1(i[r>>2],6),i[g+120>>2]=l[k+8|0]?11:10,i[g+116>>2]=1,i[g+112>>2]=I,i[g+108>>2]=W,T0(h+8|0,g,10,W,I,8,o);e:{if(i[h+8>>2]){if(e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,r=A+8|0,u[h+27|0]>=0){e=i[h+20>>2],i[r>>2]=i[h+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[h+24>>2],u[A+20|0]=1;break e}if(T(r,i[h+16>>2],i[h+20>>2]),e=u[h+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[h+16>>2]);break e}u[h+27|0]<0&&Z(i[h+16>>2]);r:{f:{if(e=i[r>>2],o=i[e+128>>2],o){for(f=e+128|0,r=f,e=o;m=i[e+16>>2],r=(m|0)<0?r:e,e=i[(m>>>29&4)+e>>2],!!e;);m=0;A:{if((r|0)==(f|0)||(m=0,i[r+16>>2]>0))break A;C=i[r+56>>2],m=i[r+44>>2]}if(r=0,!S)break r;for(e=f;r=i[o+16>>2]<6,e=r?e:o,o=i[(r?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break f}r=0;break r}if(r=0,i[e+16>>2]>6)break r;O=i[e+56>>2],r=i[e+44>>2]}f=r,e=i[n>>2],o=0;r:{if(!e)break r;for(r=n;o=i[e+16>>2]<10,r=o?r:e,e=i[(o?4:0)+e>>2],!!e;);if(o=0,(r|0)==(n|0)||(o=0,i[r+16>>2]>10))break r;V=i[r+56>>2],o=i[r+44>>2]}if(I)for(y=W&-2,R=W&1,N=W-1|0,r=0;;){r:{if(!l[k+8|0]){if(!W)break r;if(B=o+G(r,V)|0,_=G(r,C)+m|0,e=0,n=0,N)for(;w=B+G(e,3)|0,s=l[e+_|0],u[w|0]=s,u[w+2|0]=s,u[w+1|0]=s,s=e|1,w=B+G(s,3)|0,s=l[s+_|0],u[w+2|0]=s,u[w+1|0]=s,u[w|0]=s,e=e+2|0,n=n+2|0,(y|0)!=(n|0););if(!R)break r;n=B+G(e,3)|0,e=l[e+_|0],u[n|0]=e,u[n+2|0]=e,u[n+1|0]=e;break r}if(!S){if(!W)break r;if(B=o+G(r,V)|0,_=G(r,C)+m|0,e=0,n=0,N)for(;w=B+(e<<2)|0,s=l[e+_|0],u[w|0]=s,u[w+3|0]=255,u[w+2|0]=s,u[w+1|0]=s,s=e|1,w=l[s+_|0],s=B+(s<<2)|0,u[s+3|0]=255,u[s+2|0]=w,u[s+1|0]=w,u[s|0]=w,e=e+2|0,n=n+2|0,(y|0)!=(n|0););if(!R)break r;n=B+(e<<2)|0,e=l[e+_|0],u[n|0]=e,u[n+3|0]=255,u[n+2|0]=e,u[n+1|0]=e;break r}if(!W)break r;if(D=G(r,O)+f|0,x=o+G(r,V)|0,B=G(r,C)+m|0,e=0,w=0,N)for(;s=x+(e<<2)|0,n=l[e+B|0],u[s|0]=n,u[s+2|0]=n,u[s+1|0]=n,u[s+3|0]=l[e+D|0],s=e|1,_=x+(s<<2)|0,n=l[s+B|0],u[_+2|0]=n,u[_+1|0]=n,u[_|0]=n,u[_+3|0]=l[s+D|0],e=e+2|0,w=w+2|0,(y|0)!=(w|0););if(!R)break r;s=x+(e<<2)|0,n=l[e+B|0],u[s|0]=n,u[s+2|0]=n,u[s+1|0]=n,u[s+3|0]=l[e+D|0]}if(r=r+1|0,(I|0)==(r|0))break}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=g;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=h+32|0}function x8(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;w=s<<2,m=i[w+62832>>2]+n|0,w=i[w+62816>>2],W=m+w|0,h=i[(o<<2)+62816>>2];i:{e:switch(o|0){case 0:if(B=0-w|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(I=(w<<1)+t|0,C=r-h|0,V=k&2147483644,g=k&3,y=k>>>0<4;;){if(h=(B<<1)+I|0,w=G(f,B)+C|0,_=0,!y)for(;Q[h>>1]=l[w|0],r=W<<1,h=r+h|0,Q[h>>1]=l[w+1|0],h=r+h|0,Q[h>>1]=l[w+2|0],h=r+h|0,Q[h>>1]=l[w+3|0],h=r+h|0,w=w+4|0,_=_+4|0,(V|0)!=(_|0););if(r=0,g)for(;Q[h>>1]=l[w|0],w=w+1|0,h=(W<<1)+h|0,r=r+1|0,(g|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,g=r-h|0;;){for(h=B+(_<<1)|0,w=g+G(f,_)|0,r=0;Q[h>>1]=l[w+6|0]+((((((l[w+1|0]<<2)-l[w|0]|0)+G(l[w+2|0],-10)|0)+G(l[w+3|0],58)|0)+G(l[w+4|0],17)|0)+G(l[w+5|0],-5)|0),w=w+1|0,h=(W<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,g=r-h|0;;){for(h=B+(_<<1)|0,w=g+G(f,_)|0,r=0;Q[h>>1]=(((((l[w+1|0]<<2)-l[w|0]|0)+G(l[w+4|0]+l[w+3|0]|0,40)|0)+(l[w+6|0]<<2)|0)-l[w+7|0]|0)+G(l[w+5|0]+l[w+2|0]|0,-11),w=w+1|0,h=(W<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,g=r-h|0;;){for(h=B+(_<<1)|0,w=g+G(f,_)|0,r=0;Q[h>>1]=(((((l[w|0]+G(l[w+1|0],-5)|0)+G(l[w+2|0],17)|0)+G(l[w+3|0],58)|0)+G(l[w+4|0],-10)|0)+(l[w+5|0]<<2)|0)-l[w+6|0],w=w+1|0,h=(W<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=o?6:0;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(G(_,W)<<1)+t|0,r=0;Q[h>>1]=(((((Q[w>>1]+G(Q[w+2>>1],-5)|0)+G(Q[w+4>>1],17)|0)+G(Q[w+6>>1],58)|0)+G(Q[w+8>>1],-10)|0)+(Q[w+10>>1]<<2)|0)-Q[w+12>>1]>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(G(_,W)<<1)+t|0,r=0;Q[h>>1]=(((((Q[w+2>>1]<<2)-Q[w>>1]|0)+G(Q[w+8>>1]+Q[w+6>>1]|0,40)|0)+(Q[w+12>>1]<<2)|0)-Q[w+14>>1]|0)+G(Q[w+10>>1]+Q[w+4>>1]|0,-11)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,o=(n|0)<=0;;){if(!o)for(h=(_<<1)+A|0,w=(G(_,W)<<1)+t|0,r=0;Q[h>>1]=Q[w+12>>1]+((((((Q[w+2>>1]<<2)-Q[w>>1]|0)+G(Q[w+4>>1],-10)|0)+G(Q[w+6>>1],58)|0)+G(Q[w+8>>1],17)|0)+G(Q[w+10>>1],-5)|0)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(h=(f<<1)+A|0,w=(G(f,W)<<1)+t|0,r=0,n>>>0>3)for(;Q[h>>1]=F[w>>1],o=e<<1,h=o+h|0,Q[h>>1]=F[w+2>>1],h=o+h|0,Q[h>>1]=F[w+4>>1],h=o+h|0,Q[h>>1]=F[w+6>>1],h=o+h|0,w=w+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;Q[h>>1]=F[w>>1],w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function nr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;r=v-32|0,v=r,f=i[e>>2],f>>>0>13?f=6623:f=i[(f<<2)+94340>>2],s=t9(i[e+4>>2]);i:{e:{r:{f:{A:{if(t=i[e+8>>2],n=h2(t),n>>>0<2147483640){k:{n:{if(n>>>0>=11){o=n|7,k=E(o+1|0),i[r+24>>2]=o-2147483647,i[r+16>>2]=k,i[r+20>>2]=n;break n}if(u[r+27|0]=n,k=r+16|0,!n)break k}if(!n)break k;z(k,t,n)}if(u[n+k|0]=0,t=h2(f),t>>>0>=2147483640)break i;k:{n:{if(t>>>0>=11){n=t|7,k=E(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=t;break n}if(u[r+15|0]=t,k=r+4|0,!t)break k}if(!t)break k;z(k,f,t)}if(n=0,u[k+t|0]=0,k=u[r+27|0],o=(k|0)<0,w=u[r+15|0],h=(w|0)<0,t=o?i[r+20>>2]:k,_=h?i[r+8>>2]:w,t>>>0>=_>>>0){if((_|0)==-1)break A;n=!N2(o?i[r+16>>2]:r+16|0,h?i[r+4>>2]:r+4|0,_)}(w|0)<0&&Z(i[r+4>>2]);k:{if(!n)break k;if(o=h2(f),o>>>0>t>>>0)break f;if(f=t-o|0,f>>>0>=2147483640)break i;w=i[r+16>>2];n:{t:{if(f>>>0>=11){t=f|7,n=E(t+1|0),i[r+12>>2]=t-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(u[r+15|0]=f,n=r+4|0,(t|0)==(o|0))break n}if(!f)break n;z(n,o+((k|0)<0?w:r+16|0)|0,f)}u[f+n|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,Q[r+4>>1]=8250,f=u[r+27|0],n=(f|0)<0,f=n?i[r+20>>2]:f;n:{if(f>>>0<=1||(t=i[r+16>>2],k=n?t:r+16|0,F[r+4>>1]!=(l[k|0]|l[k+1|0]<<8)))break n;if(f=f-2|0,f>>>0>=2147483640)break i;t:{u:{if(f>>>0>=11){o=f|7,k=E(o+1|0),i[r+12>>2]=o-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break u}if(u[r+15|0]=f,k=r+4|0,!f)break t}if(!f)break t;z(k,(n?t:r+16|0)+2|0,f)}u[f+k|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f}if(f=h2(s),f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){n=f|7,k=E(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(u[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;z(k,s,f)}if(n=0,u[f+k|0]=0,k=u[r+27|0],f=(k|0)<0,o=u[r+15|0],w=(o|0)<0,t=f?i[r+20>>2]:k,h=w?i[r+8>>2]:o,t>>>0>=h>>>0){if((h|0)==-1)break r;n=!N2(f?i[r+16>>2]:r+16|0,w?i[r+4>>2]:r+4|0,h)}if((o|0)<0&&Z(i[r+4>>2]),!n)break k;if(s=h2(s),s>>>0>t>>>0)break e;if(f=t-s|0,f>>>0>=2147483640)break i;o=i[r+16>>2];n:{t:{if(f>>>0>=11){t=f|7,n=E(t+1|0),i[r+12>>2]=t-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(u[r+15|0]=f,n=r+4|0,(t|0)==(s|0))break n}if(!f)break n;z(n,s+((k|0)<0?o:r+16|0)|0,f)}if(u[f+n|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,Q[r+4>>1]=8250,k=u[r+27|0],n=(k|0)<0,f=n?i[r+20>>2]:k,f>>>0<=1||(t=i[r+16>>2],s=n?t:r+16|0,F[r+4>>1]!=(l[s|0]|l[s+1|0]<<8)))break k;if(f=f-2|0,f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){s=f|7,k=E(s+1|0),i[r+12>>2]=s-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(u[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;z(k,(n?t:r+16|0)+2|0,f)}u[f+k|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,k=l[r+27|0]}f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,A=A+8|0;k:{if(k<<24>>24>=0){e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2];break k}e=A,A=i[r+16>>2],T(e,A,i[r+20>>2]),Z(A)}v=r+32|0;return}g0(),H()}X3(),H()}X3(),H()}X3(),H()}X3(),H()}g0(),H()}function Ev(){var A=0,e=0,r=0,f=0,k=0,n=0;A=v-16|0,v=A;i:{if(J_(A+12|0,A+8|0)|0||(e=p2((i[A+12>>2]<<2)+4|0),i[31337]=e,!e)||(e=p2(i[A+8>>2]),e&&(r=i[31337],i[r+(i[A+12>>2]<<2)>>2]=0,!(R_(r|0,e|0)|0))))break i;i[31337]=0}v=A+16|0,l[129209]||(r=i[18278],f=v-16|0,v=f,A=R0(128856),i[A+40>>2]=128912,i[A+32>>2]=r,i[A>>2]=73444,u[A+52|0]=0,i[A+48>>2]=-1,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),X[i[i[A>>2]+8>>2]](A,k),e2(k),v=f+16|0,i[32044]=0,i[32037]=73076,i[32037]=71408,i[32035]=70940,i[32037]=70960,i[32036]=0,V3(i[17732]+128140|0,128856),k=i[16901],Bo(128920,k,128968),kk(128324,128920),n=i[16900],Bo(128976,n,129024),kk(128500,128976),kk(128676,i[(i[i[32125]-12>>2]+128500|0)+24>>2]),i[(i[i[32035]-12>>2]+128140|0)+72>>2]=128324,A=i[i[32125]-12>>2]+128500|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[32125]-12>>2]+128500|0)+72>>2]=128324,f=v-16|0,v=f,A=ml(129032),i[A+40>>2]=129088,i[A+32>>2]=r,i[A>>2]=73648,u[A+52|0]=0,i[A+48>>2]=-1,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),X[i[i[A>>2]+8>>2]](A,r),e2(r),v=f+16|0,i[32067]=0,i[32060]=73076,i[32060]=71844,i[32058]=71188,i[32060]=71208,i[32059]=0,V3(i[17794]+128232|0,129032),vo(129096,k,129144),nk(128412,129096),vo(129152,n,129200),nk(128588,129152),nk(128764,i[(i[i[32147]-12>>2]+128588|0)+24>>2]),i[(i[i[32058]-12>>2]+128232|0)+72>>2]=128412,A=i[i[32147]-12>>2]+128588|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[32147]-12>>2]+128588|0)+72>>2]=128412,u[129209]=1),i[26928]=0,i[26929]=0,u[107731]=0,u[107720]=0,A=E(16),u[A+14|0]=0,e=l[6739]|l[6740]<<8|(l[6741]<<16|l[6742]<<24),r=l[6735]|l[6736]<<8|(l[6737]<<16|l[6738]<<24),u[A+6|0]=r,u[A+7|0]=r>>>8,u[A+8|0]=r>>>16,u[A+9|0]=r>>>24,u[A+10|0]=e,u[A+11|0]=e>>>8,u[A+12|0]=e>>>16,u[A+13|0]=e>>>24,e=l[6733]|l[6734]<<8|(l[6735]<<16|l[6736]<<24),r=l[6729]|l[6730]<<8|(l[6731]<<16|l[6732]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,i[26933]=4,i[26934]=0,T(107740,A,14),Z(A),i[26939]=0,i[26940]=0,i[26938]=107756,i[26941]=107768,i[26942]=0,i[26943]=0,eA(),i[26952]=0,i[26953]=0,i[26951]=107808,i[26957]=0,i[26956]=938,f9(),i[26957]=i[31333],i[31333]=107824,A=v-80|0,v=A,i[26961]=0,i[26962]=0,i[26960]=107844,e=i[13046],i[A+48>>2]=i[13045],i[A+52>>2]=e,e=i[13044],i[A+40>>2]=i[13043],i[A+44>>2]=e,e=i[13042],i[A+32>>2]=i[13041],i[A+36>>2]=e,e=i[13040],i[A+24>>2]=i[13039],i[A+28>>2]=e,e=i[13038],i[A+16>>2]=i[13037],i[A+20>>2]=e,e=i[13036],i[A+8>>2]=i[13035],i[A+12>>2]=e,e=A+8|0,fe(107840,e,A+56|0),z(e,52188,68),i[26963]=107856,i[26964]=0,i[26965]=0,fe(107852,e,A+76|0),i[26967]=0,i[26968]=0,i[26966]=107868,r=i[13077],i[A+56>>2]=i[13076],i[A+60>>2]=r,r=i[13075],i[A+48>>2]=i[13074],i[A+52>>2]=r,r=i[13073],i[A+40>>2]=i[13072],i[A+44>>2]=r,r=i[13071],i[A+32>>2]=i[13070],i[A+36>>2]=r,r=i[13069],i[A+24>>2]=i[13068],i[A+28>>2]=r,r=i[13067],i[A+16>>2]=i[13066],i[A+20>>2]=r,r=i[13065],i[A+8>>2]=i[13064],i[A+12>>2]=r,fe(107864,e,A- -64|0),v=A+80|0,i[31334]=1947,i[31335]=0,zn(),i[31335]=i[31333],i[31333]=125336,i[31378]=125392,i[31368]=65536,i[31367]=196896,i[31360]=42,i[31369]=i[26808]}function _9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0;if(I=v-2176|0,v=I,(e|0)>0){W=e>>>1|0;i:{if(e>>>0>=8){for(w=e>>>2|0,x=e&2,D=W&1073741822,t=I- -64|0,k=I;;){e:{if((e|0)==1)break e;if(h=(G(f,R)<<1)+r|0,n=0,o=0,(W|0)!=1)for(;_=n<<1,s=_+h|0,m=t+_|0,_=n+W<<1,B=_+h|0,Q[m>>1]=F[B>>1]+F[s>>1],Q[t+_>>1]=F[s>>1]-F[B>>1],s=n|1,_=s<<1,m=_+t|0,s=s+W<<1,B=s+h|0,_=h+_|0,Q[m>>1]=F[B>>1]+F[_>>1],Q[t+s>>1]=F[_>>1]-F[B>>1],n=n+2|0,o=o+2|0,(D|0)!=(o|0););if(!x)break e;s=n<<1,o=s+h|0,n=n+W<<1,h=n+h|0,Q[t+s>>1]=F[h>>1]+F[o>>1],Q[n+t>>1]=F[o>>1]-F[h>>1]}for(o=w,h=W;;){e:{if(n=t,t=k,!o)break e;for(C=o&536870910,y=o&1,s=0;;){if(k=0,_=0,(o|0)!=1)for(;B=k+s|0,g=B<<1,m=g+t|0,N=o+B<<1,V=F[N+n>>1],g=F[n+g>>1],Q[m>>1]=V+g,Q[t+N>>1]=g-V,B=B+1|0,g=B<<1,m=g+t|0,B=o+B<<1,N=F[B+n>>1],g=F[n+g>>1],Q[m>>1]=N+g,Q[t+B>>1]=g-N,k=k+2|0,_=_+2|0,(C|0)!=(_|0););if(y&&(k=k+s|0,_=k<<1,m=_+t|0,k=k+o<<1,B=F[k+n>>1],_=F[n+_>>1],Q[m>>1]=B+_,Q[k+t>>1]=_-B),s=s+h|0,!((s|0)<(e|0)))break}if(h=h>>>1|0,s=o>>>0>3,o=o>>>1|0,k=n,s)continue}break}for(o=G(e,R),k=0;h=I+128|0,s=k|1,_=(s<<1)+t|0,B=(k<<1)+t|0,Q[h+(k+o<<1)>>1]=F[_>>1]+F[B>>1],Q[h+(o+s<<1)>>1]=F[B>>1]-F[_>>1],k=k+2|0,(k|0)<(e|0););if(k=n,R=R+1|0,(R|0)==(e|0))break}break i}for(k=e-1|0,_=k&2,R=(k>>>1|0)+1&-2,B=W<<1,k=I- -64|0,x=B+k|0,D=W+2<<1,C=D+k|0,y=W+1<<1,g=y+k|0,N=e>>>0<3;;){e:{if((e|0)==1||(k=(G(f,o)<<1)+r|0,n=F[k+B>>1],t=F[k>>1],Q[I+64>>1]=n+t,Q[x>>1]=t-n,e>>>0<4)||(n=F[k+y>>1],t=F[k+2>>1],Q[I+66>>1]=n+t,Q[g>>1]=t-n,(W|0)==2))break e;n=F[k+D>>1],k=F[k+4>>1],Q[I+68>>1]=n+k,Q[C>>1]=k-n}if(n=G(e,o),t=0,k=0,!N)for(;h=I+128|0,w=I- -64|0,s=t|1,V=F[w+(s<<1)>>1],m=F[w+(t<<1)>>1],Q[h+(n+t<<1)>>1]=V+m,Q[h+(n+s<<1)>>1]=m-V,V=t|2,s=F[w+(V<<1)>>1],m=h+(n+V<<1)|0,V=t|3,w=F[w+(V<<1)>>1],Q[m>>1]=s+w,Q[h+(n+V<<1)>>1]=s-w,t=t+4|0,k=k+2|0,(R|0)!=(k|0););if(_||(k=I+128|0,m=k+(n+t<<1)|0,w=I- -64|0,h=t|1,s=F[w+(h<<1)>>1],t=F[w+(t<<1)>>1],Q[m>>1]=s+t,Q[k+(n+h<<1)>>1]=t-s),o=o+1|0,(o|0)==(e|0))break}n=I,t=n- -64|0}for(r=e>>>1|0,R=r>>>0<=1?1:r,f=e>>>2|0,W=0,B=e>>>0<8;;){k=0;i:{if((e|0)==1){k=n;break i}for(;w=I+128|0,h=r+k|0,o=F[w+(G(h,e)+W<<1)>>1],w=w+(G(e,k)+W<<1)|0,Q[(k<<1)+t>>1]=o+F[w>>1],Q[(h<<1)+t>>1]=F[w>>1]-o,k=k+1|0,(R|0)!=(k|0););if(o=f,h=r,k=n,B)break i;for(;;){if(k=t,t=n,!o)break i;for(x=o&536870910,D=o&1,s=0;;){if(n=0,_=0,(o|0)!=1)for(;w=n+s|0,C=w<<1,m=C+t|0,y=o+w<<1,g=F[y+k>>1],C=F[k+C>>1],Q[m>>1]=g+C,Q[t+y>>1]=C-g,w=w+1|0,C=w<<1,m=C+t|0,w=o+w<<1,y=F[w+k>>1],C=F[k+C>>1],Q[m>>1]=y+C,Q[t+w>>1]=C-y,n=n+2|0,_=_+2|0,(x|0)!=(_|0););if(D&&(n=n+s|0,w=n<<1,m=w+t|0,n=n+o<<1,_=F[n+k>>1],w=F[k+w>>1],Q[m>>1]=_+w,Q[n+t>>1]=w-_),s=s+h|0,!((s|0)<(e|0)))break}if(h=h>>>1|0,w=o>>>0>3,o=o>>>1|0,n=k,!w)break}}for(o=(W<<1)+A|0,n=0;h=n|1,w=(h<<1)+t|0,s=(n<<1)+t|0,Q[o+(G(e,n)<<1)>>1]=F[w>>1]+F[s>>1],Q[o+(G(e,h)<<1)>>1]=F[s>>1]-F[w>>1],n=n+2|0,(n|0)<(e|0););if(n=k,W=W+1|0,(W|0)==(e|0))break}}v=I+2176|0}function pv(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0;W=v-32|0,v=W,h=W+20|0,e=i[A+464>>2],f=((e+i[A+456>>2]|0)-1>>>0)/(e>>>0)|0,e=i[A+460>>2],e=G(f,((e+i[A+452>>2]|0)-1>>>0)/(e>>>0)|0),r=e,f=l[A+474|0];i:{if(!f||(r=G(e,i[A+476>>2]),e=f-1|0,!e)||(r=G(r,i[A+480>>2]),(e|0)==1)||(r=G(r,i[A+484>>2]),(e|0)==2)||(r=G(r,i[A+488>>2]),(e|0)==3)||(r=G(r,i[A+492>>2]),(e|0)==4)||(r=G(r,i[A+496>>2]),(e|0)==5)||(r=G(r,i[A+500>>2]),(e|0)==6))break i;r=G(r,i[A+504>>2])}f=l[A+473|0],n=l[A+472|0],e=0,i[h+8>>2]=0,i[h>>2]=0,i[h+4>>2]=0;i:{e:{if(r=G(r,f+n>>>3|0),r){if((r|0)<0)break e;o=E(r),r&&o0(o,0,r),e=r+o|0,i[h+8>>2]=e,i[h+4>>2]=e,i[h>>2]=o}if(m=i[A+512>>2],y=i[A+516>>2],(m|0)!=(y|0)){for(V=l[A+473|0],_=V>>>3|0,N=_&28,R=_&3,e=l[A+472|0],w=e>>>3|0,D=w&30,x=w&1,S=e>>>0<8,O=_-1>>>0<3,L=(w|0)==1;;){r:{if(S)break r;if(t=i[m>>2],f=i[m+4>>2],I=o+g|0,e=0,!L)for(a=I+1|0,r=0,k=0,n=0;B=w+(e^-1)<<3,s=B&31,C=e+I|0,(B&63)>>>0>=32?B=f>>>s|0:B=((1<<s)-1&f)<<32-s|t>>>s,u[C|0]=B,B=w+(e^536870910)<<3,s=B&31,C=e+a|0,(B&63)>>>0>=32?B=f>>>s|0:B=((1<<s)-1&f)<<32-s|t>>>s,u[C|0]=B,e=e+2|0,r=e>>>0<2?r+1|0:r,k=k+2|0,n=k>>>0<2?n+1|0:n,!!((k|0)!=(D|0)|n););if(!x)break r;C=e+I|0,n=t,r=w+(e^-1)<<3,e=r&31,(r&63)>>>0>=32?f=f>>>e|0:f=((1<<e)-1&f)<<32-e|n>>>e,u[C|0]=f}if(g=w+g|0,V){r:{if(V>>>0<8)break r;if(r=i[m+8>>2],f=o+g|0,n=0,e=0,!O)for(k=f+3|0,s=f+2|0,I=f+1|0,t=0;u[e+f|0]=r>>>(_+(e^-1)<<3),u[e+I|0]=r>>>(_+(e^536870910)<<3),u[e+s|0]=r>>>(_+(e^536870909)<<3),u[e+k|0]=r>>>(_+(e^536870908)<<3),e=e+4|0,t=t+4|0,(N|0)!=(t|0););if(!R)break r;for(;u[e+f|0]=r>>>(_+(e^-1)<<3),e=e+1|0,n=n+1|0,(n|0)!=(R|0););}g=_+g|0}if(m=m+16|0,(y|0)==(m|0))break}e=i[h+4>>2]}i[A+524>>2]=e-o;break i}G0(),H()}e=i[A+100>>2],i[W+12>>2]=i[e+48>>2],e=i[e+52>>2],i[W+16>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),o=i[A+116>>2],e=0,r=0,n=0,t=0,w=v-32|0,v=w,_=w+12|0,A=i[i[W+12>>2]+68>>2],f=i[A+108>>2],k=i[A+104>>2];i:{if((f|0)==(k|0)){A=0;break i}for(A=f-k>>5,f=A>>>0<=1?1:A,A=0;;){if((o|0)==i[k+(A<<5)>>2])break i;if(A=A+1|0,(f|0)==(A|0))break}A=f}f=k+(A<<5)|0,A=i[f+16>>2],m=i[f+20>>2];i:{if((A|0)==(m|0))break i;for(;;){s=i[A+24>>2],k=i[A+28>>2]-s|0;e:{if(!r&e>>>0>=k>>>0|r){f=e-k|0,r=r-(e>>>0<k>>>0)|0;break e}I=i[h>>2],f=i[h+4>>2]-I|0,o=f-n|0,C=o,g=k-e|0,k=0-((e>>>0>k>>>0)+r|0)|0,f=0-((f>>>0<n>>>0)+t|0)|0,o=(k|0)==(f|0)&o>>>0<g>>>0|f>>>0<k>>>0,r=o?C:g,f=o?f:k,r&&z(e+s|0,n+I|0,r),t=f+t|0,n=r+n|0,t=n>>>0<r>>>0?t+1|0:t,f=0,r=0}if(e=f,!t&(i[h+4>>2]-i[h>>2]|0)==(n|0))break i;if(A=A+40|0,(m|0)==(A|0))break}}e=i[26929],A=_,i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[w+31|0]<0&&Z(i[w+20>>2]),v=w+32|0,A=i[W+16>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[W+20>>2],A&&(i[W+24>>2]=A,Z(A)),v=W+32|0}function yv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-48|0,v=n,hf(n+24|0,e,r);i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}r=i[e+196>>2],f=i[e+140>>2],i[f+100>>2]=i[f+100>>2]&-7;e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=TA(i[e+188>>2],1),!f){if(e=E(32),i[n+12>>2]=e,i[n+16>>2]=29,i[n+20>>2]=-2147483616,r=l[21928]|l[21929]<<8|(l[21930]<<16|l[21931]<<24),f=l[21924]|l[21925]<<8|(l[21926]<<16|l[21927]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[21949]|l[21950]<<8|(l[21951]<<16|l[21952]<<24),f=l[21945]|l[21946]<<8|(l[21947]<<16|l[21948]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[21944]|l[21945]<<8|(l[21946]<<16|l[21947]<<24),f=l[21940]|l[21941]<<8|(l[21942]<<16|l[21943]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[21936]|l[21937]<<8|(l[21938]<<16|l[21939]<<24),f=l[21932]|l[21933]<<8|(l[21934]<<16|l[21935]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,n+12|0),u[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=0,k=i[e+180>>2],e=i[k+104>>2],f=i[f+8>>2]-1|0;r:{if(f>>>0>=i[k+108>>2]-e>>3>>>0)break r;if(r=e+(f<<3)|0,e=i[r>>2],r=i[r+4>>2],r){if(i[r+4>>2]=i[r+4>>2]+1,!e)break r;if(e=i[r+4>>2],i[r+4>>2]=e-1,e)break e;X[i[i[r>>2]+8>>2]](r),p(r);break e}if(r=0,e)break e}if(e=E(48),i[n+12>>2]=e,i[n+16>>2]=40,i[n+20>>2]=-2147483600,f=l[8042]|l[8043]<<8|(l[8044]<<16|l[8045]<<24),k=l[8038]|l[8039]<<8|(l[8040]<<16|l[8041]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[8074]|l[8075]<<8|(l[8076]<<16|l[8077]<<24),k=l[8070]|l[8071]<<8|(l[8072]<<16|l[8073]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[8066]|l[8067]<<8|(l[8068]<<16|l[8069]<<24),k=l[8062]|l[8063]<<8|(l[8064]<<16|l[8065]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[8058]|l[8059]<<8|(l[8060]<<16|l[8061]<<24),k=l[8054]|l[8055]<<8|(l[8056]<<16|l[8057]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[8050]|l[8051]<<8|(l[8052]<<16|l[8053]<<24),k=l[8046]|l[8047]<<8|(l[8048]<<16|l[8049]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,K(A,2,0,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}u[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function Yv(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v+-64|0,v=n;i:{e:{r:{f:{A:{if(!(f&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break A}if(o=E(168),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=91652,_=o+16|0,t=_,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+116>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,Q[o+112>>1]=0,i[t>>2]=89344,i[o+160>>2]=0,i[o+164>>2]=0,i[o+152>>2]=0,i[o+156>>2]=0,i[o+144>>2]=0,i[o+148>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,i[o+32>>2]=1969513843,t=i[f+4>>2],w=t||42716,s=h2(w),s>>>0>=2147483640)break f;k:{n:{if(s>>>0>=11){h=s|7,t=E(h+1|0),i[n+60>>2]=h-2147483647,i[n+52>>2]=t,i[n+56>>2]=s;break n}if(u[n+63|0]=s,t=n+52|0,!s)break k}if(!s)break k;z(t,w,s)}w=o+120|0,u[t+s|0]=0,t=u[n+63|0];k:{n:{if(u[o+131|0]>=0){if((t|0)>=0){t=i[n+56>>2],i[w>>2]=i[n+52>>2],i[w+4>>2]=t,i[w+8>>2]=i[n+60>>2];break k}D1(w,i[n+52>>2],i[n+56>>2]);break n}if(s=(t|0)<0,O1(w,s?i[n+52>>2]:n+52|0,s?i[n+56>>2]:t),u[n+63|0]>=0)break k}Z(i[n+52>>2])}if(t=i[f+8>>2],w=t||42716,s=h2(w),s>>>0>=2147483640)break r;k:{n:{if(s>>>0>=11){h=s|7,t=E(h+1|0),i[n+48>>2]=h-2147483647,i[n+40>>2]=t,i[n+44>>2]=s;break n}if(u[n+51|0]=s,t=n+40|0,!s)break k}if(!s)break k;z(t,w,s)}u[t+s|0]=0,t=o+132|0,s=u[n+51|0];k:{n:{if(u[o+143|0]>=0){if((s|0)>=0){s=i[n+44>>2],i[t>>2]=i[n+40>>2],i[t+4>>2]=s,i[t+8>>2]=i[n+48>>2];break k}D1(t,i[n+40>>2],i[n+44>>2]);break n}w=t,t=(s|0)<0,O1(w,t?i[n+40>>2]:n+40|0,t?i[n+44>>2]:s)}if(u[n+51|0]>=0)break k;Z(i[n+40>>2])}if(t=i[f+12>>2],w=t||42716,s=h2(w),s>>>0>=2147483640)break e;k:{n:{if(s>>>0>=11){h=s|7,t=E(h+1|0),i[n+36>>2]=h-2147483647,i[n+28>>2]=t,i[n+32>>2]=s;break n}if(u[n+39|0]=s,t=n+28|0,!s)break k}if(!s)break k;z(t,w,s)}u[t+s|0]=0,t=o+144|0,s=u[n+39|0];k:{n:{if(u[o+155|0]>=0){if((s|0)>=0){s=i[n+32>>2],i[t>>2]=i[n+28>>2],i[t+4>>2]=s,i[t+8>>2]=i[n+36>>2];break k}D1(t,i[n+28>>2],i[n+32>>2]);break n}w=t,t=(s|0)<0,O1(w,t?i[n+28>>2]:n+28|0,t?i[n+32>>2]:s)}if(u[n+39|0]>=0)break k;Z(i[n+28>>2])}if(f=i[f+16>>2],s=f||42716,f=h2(s),f>>>0>=2147483640)break i;k:{n:{if(f>>>0>=11){w=f|7,t=E(w+1|0),i[n+24>>2]=w-2147483647,i[n+16>>2]=t,i[n+20>>2]=f;break n}if(u[n+27|0]=f,t=n+16|0,!f)break k}if(!f)break k;z(t,s,f)}u[f+t|0]=0,f=o+156|0,t=u[n+27|0];k:{n:{if(u[o+167|0]>=0){if((t|0)>=0){t=i[n+20>>2],i[f>>2]=i[n+16>>2],i[f+4>>2]=t,i[f+8>>2]=i[n+24>>2];break k}D1(f,i[n+16>>2],i[n+20>>2]);break n}w=f,f=(t|0)<0,O1(w,f?i[n+16>>2]:n+16|0,f?i[n+20>>2]:t)}if(u[n+27|0]>=0)break k;Z(i[n+16>>2])}if(e=i[e>>2],i[n+12>>2]=o,i[n+8>>2]=_,i[o+4>>2]=i[o+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=re(e,r,n,0),k&&(i[k>>2]=e),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[o+4>>2],i[o+4>>2]=A-1,A)break A;X[i[i[o>>2]+8>>2]](o),p(o)}v=n- -64|0;return}g0(),H()}g0(),H()}g0(),H()}g0(),H()}function B9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;t=v-16|0,v=t,r=E(68),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=106680,n=i[A+20>>2],f=i[A+24>>2],k=r+12|0,i[k+16>>2]=0,i[k+20>>2]=0,i[r+24>>2]=e,i[r+20>>2]=f,i[r+16>>2]=n,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+12>>2]=106516;i:{e:{r:switch(e-1|0){case 0:e=E(92),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97512,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=97760,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0;break e;case 3:e=E(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,u[e+19|0]=0,u[e+20|0]=0,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+18|0]=1,Q[e+16>>1]=0,i[e+12>>2]=98008,i[e>>2]=97968,u[e+27|0]=0,u[e+28|0]=0,u[e+29|0]=0,u[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0;break e;case 4:e=E(92),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=99688,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=99792,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0;break e;case 1:e=E(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=100304,i[e>>2]=100120,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+27|0]=0,u[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,u[e+40|0]=0;break e;case 6:e=E(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=99024,i[e>>2]=98912,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 9:e=E(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=99080,i[e>>2]=106548,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 2:break r;default:break i}e=E(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98704,i[e>>2]=98512,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0}i[r+64>>2]=e,i[r+60>>2]=e+12}i[t+12>>2]=r,i[t+8>>2]=k,r2(A+100|0,t+8|0),o=i[A+104>>2]-i[A+100>>2]>>3;i:{if(r=i[A+188>>2],A=i[r+108>>2],f=i[r+112>>2],A>>>0<f>>>0){i[A+8>>2]=o,i[A>>2]=1,i[A+4>>2]=0,i[r+108>>2]=A+12;break i}e:{if(n=i[r+104>>2],A=A-n|0,e=((A|0)/12|0)+1|0,e>>>0<357913942){if(f=(f-n|0)/12|0,k=f<<1,k=f>>>0>=178956970?357913941:e>>>0<k>>>0?k:e,k){if(k>>>0>=357913942)break e;e=E(G(k,12))}else e=0;f=e+A|0,i[f+8>>2]=o,i[f>>2]=1,i[f+4>>2]=0,o=f+G((A|0)/-12|0,12)|0,A&&z(o,n,A),i[r+112>>2]=e+G(k,12),A=f+12|0,i[r+108>>2]=A,i[r+104>>2]=o,n&&Z(n),i[r+108>>2]=A;break i}G0(),H()}x0(),H()}A=i[t+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+16|0}function Ef(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-192|0,v=k,x2(k+168|0,e,r);i:{if(i[k+168>>2]!=i[26928]){e=i[k+172>>2],i[A>>2]=i[k+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+184>>2],e=i[k+180>>2],i[A+8>>2]=i[k+176>>2],i[A+12>>2]=e,i[k+184>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0;break i}s=e,w=F0(r),i[s+104>>2]=w,t=F0(r);e:{r:{f:{A:{k:{n:{if(t>>>0>i[r+16>>2]>>>2>>>0){i[k+112>>2]=0,i[k+84>>2]=72244,i[k+28>>2]=72224,e=i[18065],i[k+20>>2]=e,f=i[e-12>>2],e=k+20|0,i[f+e>>2]=i[18066],i[k+24>>2]=0,f=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[k+28>>2]=f,o=k+28|0,i[o+i[f-12>>2]>>2]=i[18068],f=i[18064],i[k+20>>2]=f,i[e+i[f-12>>2]>>2]=i[18069],i[k+84>>2]=72244,i[k+20>>2]=72204,i[k+28>>2]=72224,f=R0(n),i[f>>2]=71280,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,e=i[r+16>>2],Y(I0(Y(I0(Y(o,28211,32),t),29106,32),e>>>2|0),24188,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,u[k+19|0]=0,r=k+8|0;break e}e=i[k+48>>2],r=k+40|0}if(t=i[r>>2],e=e-t|0,e>>>0>=2147483640)break n;if(e>>>0>=11){n=e|7,r=E(n+1|0),i[k+16>>2]=n-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break r}if(u[k+19|0]=e,r=k+8|0,e)break r;e=0;break e}if(n=i[f+56>>2],!(!n|n>>>0>=t>>>0)){i[k+112>>2]=0,i[k+84>>2]=72244,i[k+28>>2]=72224,e=i[18065],i[k+20>>2]=e,r=i[e-12>>2],e=k+20|0,i[r+e>>2]=i[18066],i[k+24>>2]=0,r=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+28>>2]=r,o=i[r-12>>2],r=k+28|0,i[o+r>>2]=i[18068],o=i[18064],i[k+20>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[k+84>>2]=72244,i[k+20>>2]=72204,i[k+28>>2]=72224,n=R0(n),i[n>>2]=71280,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,Y(I0(Y(I0(Y(r,27611,26),t),27901,44),i[f+56>>2]),24188,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,u[k+19|0]=0,r=k+8|0;break f}e=i[k+48>>2],r=k+40|0}if(f=i[r>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){t=e|7,r=E(t+1|0),i[k+16>>2]=t-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break A}if(u[k+19|0]=e,r=k+8|0,e)break A;e=0;break f}f=e+108|0,o=i[e+108>>2],n=i[e+112>>2]-o>>2;t:{u:{if(n>>>0<t>>>0){I8(f,t-n|0);break u}if(n>>>0>t>>>0&&(i[e+112>>2]=o+(t<<2)),!t)break t}for(e=0;n=F0(r),i[i[f>>2]+(e<<2)>>2]=n,e=e+1|0,(t|0)!=(e|0););}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}g0(),H()}if(!e)break f;z(r,f,e)}u[e+r|0]=0,K(A,2,1e3,k+8|0),u[k+19|0]<0&&Z(i[k+8>>2]),A=i[18063],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[18071],i[k+28>>2]=i[18072],i[n>>2]=71280,u[k+75|0]<0&&Z(i[k+64>>2]),y0(n),p0(k+84|0);break i}if(!e)break e;z(r,t,e)}u[e+r|0]=0,K(A,2,100,k+8|0),u[k+19|0]<0&&Z(i[k+8>>2]),A=i[18063],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[18071],i[k+28>>2]=i[18072],i[f>>2]=71280,u[k+75|0]<0&&Z(i[k+64>>2]),y0(f),p0(k+84|0)}u[k+187|0]<0&&Z(i[k+176>>2]),v=k+192|0}function $6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-160|0,v=f,k=i[r>>2],n=X[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+8|0,k=n>>>0<8?k+1|0:k;i:{if(X[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,K(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}w=e,h=F0(r),i[w+8>>2]=h,i[e+12>>2]=0,k=F0(r),i[e+32>>2]=8,i[e+16>>2]=k;e:{r:{f:{if(!i[e+12>>2]&i[e+8>>2]==1){if(k=i[r>>2],n=X[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+8|0,k=n>>>0<8?k+1|0:k,X[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,K(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(k=F0(r),w=e,h=F0(r),i[w+8>>2]=h,i[e+12>>2]=k,i[e+32>>2]=i[e+32>>2]+8,i[f+76>>2]=72244,i[f+104>>2]=0,i[f+20>>2]=72224,k=i[18065],i[f+12>>2]=k,n=i[k-12>>2],k=f+12|0,i[n+k>>2]=i[18066],i[f+16>>2]=0,n=k+i[i[f+12>>2]-12>>2]|0,t=f+24|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[f+20>>2]=n,o=i[n-12>>2],n=f+20|0,i[o+n>>2]=i[18068],o=i[18064],i[f+12>>2]=o,i[k+i[o-12>>2]>>2]=i[18069],i[f+76>>2]=72244,i[f+12>>2]=72204,i[f+20>>2]=72224,k=R0(t),i[k>>2]=71280,t=f- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,Y(K2(Y(n,28744,9),i[e+8>>2],i[e+12>>2]),23517,24),n=f+76|0,t=i[e+12>>2],(t|0)==268435456|t>>>0>268435456){e=i[f+72>>2];A:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break A}if(!(e&8)){r=0,u[f+11|0]=0,e=f;break e}r=i[f+40>>2],e=f+32|0}if(t=i[e>>2],r=r-t|0,r>>>0>=2147483640)break f;if(r>>>0>=11){o=r|7,e=E(o+1|0),i[f+8>>2]=o-2147483647,i[f>>2]=e,i[f+4>>2]=r;break r}if(u[f+11|0]=r,e=f,r)break r;r=0;break e}t=i[18063],i[f+12>>2]=t,i[i[t-12>>2]+(f+12|0)>>2]=i[18071],i[f+20>>2]=i[18072],i[k>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(k),p0(n),k=i[e+16>>2]}if((k|0)==1970628964){if(k=i[r>>2],n=X[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+16|0,k=n>>>0<16?k+1|0:k,X[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,K(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}A:{if(!f4(r,16))break A;o=i[e+24>>2],k=i[e+20>>2],n=o-k|0;k:{if(n>>>0<=15){if(t=16-n|0,s=i[e+28>>2],t>>>0<=s-o>>>0){t&&o0(o,0,t),i[e+24>>2]=t+o;break k}if(o=s-k|0,s=o<<1,s=o>>>0>=1073741823?2147483647:s>>>0<=16?16:s,o=E(s),t&&o0(n+o|0,0,t),n&&z(o,k,n),i[e+28>>2]=o+s,i[e+24>>2]=o+16,i[e+20>>2]=o,!k)break k;Z(k);break k}if((n|0)==16)break k;i[e+24>>2]=k+16}if(n=i[r>>2],k=i[r+4>>2],k){if(i[k+4>>2]=i[k+4>>2]+1,X[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0,n=i[k+4>>2],i[k+4>>2]=n-1,n)break A;X[i[i[k>>2]+8>>2]](k),p(k);break A}X[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0}i[e+32>>2]=i[e+32>>2]+16}if(l[r+20|0]==1){if(u[f+12|0]=0,u[f+23|0]=0,K(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!r)break e;z(e,t,r)}u[e+r|0]=0,K(A,6,1e3,f),u[f+11|0]<0&&Z(i[f>>2]),A=i[18063],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[18071],i[f+20>>2]=i[18072],i[k>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(k),p0(n)}v=f+160|0}function v9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;n=v-32|0,v=n,s=i[e+104>>2],m=i[e+108>>2];i:{if((s|0)!=(m|0))for(h=n+24|0;;){if(i[n+20>>2]=h,i[n+24>>2]=0,W=h,_=0,w=i[s+44>>2],g=i[s+48>>2],(w|0)==(g|0))e=0;else{e:{for(;;){r:{o=i[w>>2],r=h,k=r,e=r,t=i[n+24>>2],f=t;f:{A:{if(!f)break A;for(;k=r,e=f,B=o>>>0>u0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(h|0)&o>>>0>=u0[(B?k:e)+16>>2])break r;for(;;){if(e=t,r=i[e+16>>2],r>>>0>o>>>0){if(k=e,t=i[e>>2],t)continue;break A}if(r>>>0>=o>>>0)break f;if(t=i[e+4>>2],!t)break}k=e+4|0}r=E(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=o,i[k>>2]=r,e=i[W>>2],e&&(i[n+20>>2]=e,W=e),t=i[n+24>>2],e=(t|0)==(r|0),u[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],l[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(o=i[e+4>>2],!(!o|l[o+12|0])){u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[o+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;u:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break u}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break u}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}u[r+12|0]=1,u[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(l[f+12|0]|!f)break k;u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[f+12|0]=1}if(r=e,(e|0)!=(t|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}u[f+12|0]=1,u[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(w=w+4|0,(g|0)!=(w|0))continue;break e}break}i[n+28>>2]=_,e=E(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=l[5853]|l[5854]<<8|(l[5855]<<16|l[5856]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[5849]|l[5850]<<8|(l[5851]<<16|l[5852]<<24),f=l[5845]|l[5846]<<8|(l[5847]<<16|l[5848]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5841]|l[5842]<<8|(l[5843]<<16|l[5844]<<24),f=l[5837]|l[5838]<<8|(l[5839]<<16|l[5840]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[5833]|l[5834]<<8|(l[5835]<<16|l[5836]<<24),f=l[5829]|l[5830]<<8|(l[5831]<<16|l[5832]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,K(A,2,0,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),Y1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,Y1(n+20|0,e),s=s+56|0,(m|0)==(s|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function m9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;n=v-32|0,v=n,s=i[e+100>>2],m=i[e+104>>2];i:{if((s|0)!=(m|0))for(h=n+24|0;;){if(i[n+20>>2]=h,i[n+24>>2]=0,W=h,_=0,w=i[s+4>>2],g=i[s+8>>2],(w|0)==(g|0))e=0;else{e:{for(;;){r:{o=i[w>>2],r=h,k=r,e=r,t=i[n+24>>2],f=t;f:{A:{if(!f)break A;for(;k=r,e=f,B=o>>>0>u0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(h|0)&o>>>0>=u0[(B?k:e)+16>>2])break r;for(;;){if(e=t,r=i[e+16>>2],r>>>0>o>>>0){if(k=e,t=i[e>>2],t)continue;break A}if(r>>>0>=o>>>0)break f;if(t=i[e+4>>2],!t)break}k=e+4|0}r=E(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=o,i[k>>2]=r,e=i[W>>2],e&&(i[n+20>>2]=e,W=e),t=i[n+24>>2],e=(t|0)==(r|0),u[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],l[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(o=i[e+4>>2],!(!o|l[o+12|0])){u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[o+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;u:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break u}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break u}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}u[r+12|0]=1,u[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(l[f+12|0]|!f)break k;u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[f+12|0]=1}if(r=e,(e|0)!=(t|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}u[f+12|0]=1,u[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(w=w+4|0,(g|0)!=(w|0))continue;break e}break}i[n+28>>2]=_,e=E(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=l[5824]|l[5825]<<8|(l[5826]<<16|l[5827]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[5820]|l[5821]<<8|(l[5822]<<16|l[5823]<<24),f=l[5816]|l[5817]<<8|(l[5818]<<16|l[5819]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5812]|l[5813]<<8|(l[5814]<<16|l[5815]<<24),f=l[5808]|l[5809]<<8|(l[5810]<<16|l[5811]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[5804]|l[5805]<<8|(l[5806]<<16|l[5807]<<24),f=l[5800]|l[5801]<<8|(l[5802]<<16|l[5803]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,K(A,2,0,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),Y1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,Y1(n+20|0,e),s=s+16|0,(m|0)==(s|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function Z9(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;I=v;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(!k||!(v0(r,1)&255))break o;if(t){if(A=0,e=f2(r),(e|0)==-99999|(e|0)>=(k|0))break r;A=e^-1}else A=-1;if(w=A+k|0,(w|0)<0)break t;if(e=v0(r,1),A=f2(r),(A|0)==-99999)break i;for(m=l[(i[n>>2]+G(w,100)|0)+98|0],k=m+16&496,s=I-k|0,t=s,v=t,o=A^-1,_=A+1|0,h=t-k|0,v=h,k=0;A=v0(r,1),u[k+s|0]=A,t=k+h|0,A&255?A=1:A=v0(r,1),u[t|0]=A,A=(k|0)!=(m|0),k=k+1|0,!!A;);o=e?o:_,r=G(w,100),e=r+i[n>>2]|0,A=l[e+96|0],e=l[e+97|0];l:{if(!e){t=0;break l}for(_=f- -64|0,t=0,B=e>>>0<17,k=e;;){if(W=i[n>>2],w>>>0>=(i[n+4>>2]-W|0)/100>>>0)break n;if(!B)break k;k=k-1|0,W=o+Q[((r+W|0)+(k<<1)|0)+32>>1]|0;s:{if((W|0)>=0||(g=A+k|0,!l[g+h|0]))break s;if((t|0)>15)break i;Q[(t<<1)+f>>1]=W,u[t+_|0]=l[s+g|0],t=t+1|0}if(!k)break}}if(!(!l[h+m|0]|(o|0)>=0)){if((t|0)>15)break i;Q[(t<<1)+f>>1]=o,u[(f+t|0)- -64|0]=l[s+m|0],t=t+1|0}l:{if(!A){u[f+96|0]=t,k=0;break l}for(r=f- -64|0,k=0,_=G(w,100);;){if(B=o+Q[(_+i[n>>2]|0)+(k<<1)>>1]|0,!(!l[k+h|0]|(B|0)>=0)){if((t|0)>15)break i;Q[(t<<1)+f>>1]=B,u[r+t|0]=l[k+s|0],t=t+1|0}if(k=k+1|0,(A|0)==(k|0))break}for(u[f+96|0]=t,_=f+80|0,B=f+32|0,k=0,W=G(w,100),t=A;;){if(r=t,t=t-1|0,g=o+Q[(W+i[n>>2]|0)+(t<<1)>>1]|0,!((g|0)<=0|!l[t+h|0])){if((k|0)>15)break i;Q[B+(k<<1)>>1]=g,u[k+_|0]=l[t+s|0],k=k+1|0}if(!((r|0)>1))break}}if(!(!l[h+m|0]|(o|0)<=0)){if((k|0)>15)break i;Q[((k<<1)+f|0)+32>>1]=o,u[(f+k|0)+80|0]=l[s+m|0],k=k+1|0}if(e)for(r=f+80|0,m=f+32|0,t=0,w=G(w,100);;){_=o+Q[((w+i[n>>2]|0)+(t<<1)|0)+32>>1]|0;l:{if((_|0)<=0||(B=A+t|0,!l[B+h|0]))break l;if((k|0)>15)break i;Q[m+(k<<1)>>1]=_,u[r+k|0]=l[s+B|0],k=k+1|0}if(t=t+1|0,(e|0)==(t|0))break}u[f+97|0]=k;break u}if(n=f2(r),o=f2(r),!((n|0)!=-99999&(o|0)!=-99999))break e;if(i[((u[e+2|0]<<2)+e|0)+524>>2]<(n+o|0)){Q[f+96>>1]=0,Q[f+98>>1]=0;break e}if(!((o|0)<17&(n|0)<=16))break e;if(u[f+97|0]=o,u[f+96|0]=n,(n|0)>0)for(t=f- -64|0,A=0,k=0,e=0;;){if(s=f2(r),(s|0)==-99999)break r;if(h=v0(r,1),w=(k<<1)+f|0,Q[w>>1]=(s^-1)+e,u[k+t|0]=h,e=F[w>>1],k=k+1|0,(n|0)==(k|0))break}if((o|0)<=0)break u;for(e=f+80|0,n=f+32|0,A=0,k=0,t=0;;){if(s=f2(r),(s|0)==-99999)break r;if(h=v0(r,1),w=n+(k<<1)|0,Q[w>>1]=(t+s|0)+1,u[e+k|0]=h,t=F[w>>1],k=k+1|0,(o|0)==(k|0))break}}if(k=0,u[f+99|0]=0,A=l[f+96|0],!A)break f;if(n=A&1,e=f- -64|0,(A|0)==1){r=0;break A}for(o=A&254,r=0,t=0;s=e+r|0,l[s|0]&&(k=k+1|0,u[f+99|0]=k),l[s+1|0]&&(k=k+1|0,u[f+99|0]=k),r=r+2|0,t=t+2|0,(o|0)!=(t|0););break A}M0(21962,18317,129,4203),H()}M0(26910,18317,174,4203),H()}M0(19358,18317,175,4203),H()}if(!n|!l[e+r|0])break f;k=k+1|0,u[f+99|0]=k}e=l[f+97|0];f:{if(!e)break f;if(n=f+80|0,r=0,(e|0)!=1)for(o=e&254,t=0;s=r+n|0,l[s|0]&&(k=k+1|0,u[f+99|0]=k),l[s+1|0]&&(k=k+1|0,u[f+99|0]=k),r=r+2|0,t=t+2|0,(o|0)!=(t|0););if(!(e&1)|!l[r+n|0])break f;u[f+99|0]=k+1}u[f+98|0]=A+e,A=1}return v=I,A}C2(A,1018,0)}return v=I,0}function Rv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-160|0,v=k,t=o2(r);i:{e:{r:{f:{A:{k:{n:{if(n=i[f+48>>2],!(!n|t>>>0<=n>>>0)){i[k+104>>2]=0,i[k+76>>2]=72244,i[k+20>>2]=72224,e=i[18065],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[18066],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+20>>2]=r,o=i[r-12>>2],r=k+20|0,i[o+r>>2]=i[18068],o=i[18064],i[k+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[k+76>>2]=72244,i[k+12>>2]=72204,i[k+20>>2]=72224,n=R0(n),i[n>>2]=71280,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(I0(Y(I0(Y(r,28828,25),t),27846,54),i[f+48>>2]),4526,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,u[k+11|0]=0,f=k;break e}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){t=r|7,f=E(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=f,i[k+4>>2]=r;break r}if(u[k+11|0]=r,f=k,r)break r;r=0;break e}if(t>>>0>u0[r+16>>2]/6>>>0){i[k+104>>2]=0,i[k+76>>2]=72244,i[k+20>>2]=72224,e=i[18065],i[k+12>>2]=e,f=i[e-12>>2],e=k+12|0,i[f+e>>2]=i[18066],i[k+16>>2]=0,f=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[k+20>>2]=f,o=i[f-12>>2],f=k+20|0,i[o+f>>2]=i[18068],o=i[18064],i[k+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[k+76>>2]=72244,i[k+12>>2]=72204,i[k+20>>2]=72224,n=R0(n),i[n>>2]=71280,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(I0(Y(I0(Y(f,28828,25),t),27566,44),u0[r+16>>2]/6|0),4526,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,u[k+11|0]=0,f=k;break f}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){t=r|7,f=E(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=f,i[k+4>>2]=r;break A}if(u[k+11|0]=r,f=k,r)break A;r=0;break f}n=e+100|0,o=i[e+100>>2],f=(i[e+104>>2]-o|0)/6|0;t:{if(f>>>0<t>>>0){xt(n,t-f|0);break t}if(f>>>0<=t>>>0)break t;i[e+104>>2]=o+G(t,6)}e=l[r+20|0];t:{if(!(!i[r+16>>2]|(!t|e&1))){for(f=0;;){u:{if(o=o2(r),s=o2(r),w=o2(r),e=i[n>>2]+G(f,6)|0,Q[e+4>>1]=w,Q[e+2>>1]=s,Q[e>>1]=o,e=l[r+20|0],f=f+1|0,e&1|t>>>0<=f>>>0)break u;if(i[r+16>>2])continue}break}if(e&1)break t;break k}if(!(e&1))break k}if(u[k+12|0]=0,u[k+23|0]=0,K(A,2,100,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}g0(),H()}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(!r)break f;z(f,e,r)}u[r+f|0]=0,K(A,2,100,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18063],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18071],i[k+20>>2]=i[18072],i[n>>2]=71280,u[k+67|0]<0&&Z(i[k+56>>2]),y0(n),p0(k+76|0);break i}if(!r)break e;z(f,e,r)}u[r+f|0]=0,K(A,2,1e3,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18063],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18071],i[k+20>>2]=i[18072],i[n>>2]=71280,u[k+67|0]<0&&Z(i[k+56>>2]),y0(n),p0(k+76|0)}v=k+160|0}function G9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;n=v-80|0,v=n,k=n+48|0,yf(k,e,r);i:{e:{if(t=l[n+68|0],(t|0)==255||(o=i[23613],i[n+32>>2]=i[23612],i[n+36>>2]=o,o=n+32|0,X[i[o+(t<<2)>>2]](n+79|0,k),t))break e;e=E(48),i[n+32>>2]=e,i[n+36>>2]=45,i[n+40>>2]=-2147483600,r=l[22269]|l[22270]<<8|(l[22271]<<16|l[22272]<<24),f=l[22265]|l[22266]<<8|(l[22267]<<16|l[22268]<<24),u[e+37|0]=f,u[e+38|0]=f>>>8,u[e+39|0]=f>>>16,u[e+40|0]=f>>>24,u[e+41|0]=r,u[e+42|0]=r>>>8,u[e+43|0]=r>>>16,u[e+44|0]=r>>>24,r=l[22264]|l[22265]<<8|(l[22266]<<16|l[22267]<<24),f=l[22260]|l[22261]<<8|(l[22262]<<16|l[22263]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22256]|l[22257]<<8|(l[22258]<<16|l[22259]<<24),f=l[22252]|l[22253]<<8|(l[22254]<<16|l[22255]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22248]|l[22249]<<8|(l[22250]<<16|l[22251]<<24),f=l[22244]|l[22245]<<8|(l[22246]<<16|l[22247]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22240]|l[22241]<<8|(l[22242]<<16|l[22243]<<24),f=l[22236]|l[22237]<<8|(l[22238]<<16|l[22239]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[22232]|l[22233]<<8|(l[22234]<<16|l[22235]<<24),f=l[22228]|l[22229]<<8|(l[22230]<<16|l[22231]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+45|0]=0,e=K(k,5,0,o),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[n+43|0]>=0)break i;Z(i[n+32>>2]);break i}k=E(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=91852,o=k+16|0,t=o,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[t>>2]=89640,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1701604967,t=k+120|0;e:{r:{f:{A:{if(u[f+11|0]>=0){if(i[n+24>>2]=i[f+8>>2],s=i[f+4>>2],i[n+16>>2]=i[f>>2],i[n+20>>2]=s,u[n+27|0]>=0)break A;break r}if(T(n+16|0,i[f>>2],i[f+4>>2]),f=u[n+27|0],u[k+131|0]<0)break f;if((f|0)<0)break r}f=i[n+20>>2],i[t>>2]=i[n+16>>2],i[t+4>>2]=f,i[t+8>>2]=i[n+24>>2];break e}s=t,t=(f|0)<0,O1(s,t?i[n+16>>2]:n+16|0,t?i[n+20>>2]:f);break e}D1(t,i[n+16>>2],i[n+20>>2])}if(u[n+27|0]<0&&Z(i[n+16>>2]),i[n+12>>2]=k,i[n+8>>2]=o,i[k+4>>2]=i[k+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=re(e,r,n,0),u[A+20|0]=0,i[A>>2]=e,A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;X[i[i[k>>2]+8>>2]](k),p(k)}v=n+80|0}function W9(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;Je(),h=E(8),w=E(216),i[w>>2]=96912,i[w+4>>2]=0,i[w+8>>2]=0,f=w+16|0,A=f,i[A>>2]=0,i[A+4>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[A+8>>2]=0,i[A+12>>2]=4740,i[A+16>>2]=A+20,i[A+36>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=4,i[A+152>>2]=0,l[107800]||(u[107800]=1),k=f- -64|0,A=i[26952];i:{e:{if(!A){r=107808,e=107808;break e}for(;;){if(e=A,r=i[A+16>>2],r>>>0>k>>>0){if(r=A,A=i[A>>2],A)continue;break e}if(r>>>0>=k>>>0)break i;if(A=i[e+4>>2],!A)break}r=e+4|0}A=E(28),i[A+20>>2]=0,i[A+24>>2]=0,i[A+16>>2]=k,i[A+8>>2]=e,i[A>>2]=0,i[A+4>>2]=0,i[r>>2]=A,e=i[i[26951]>>2],e&&(i[26951]=e),m1(i[26952],A),i[26953]=i[26953]+1}i[A+20>>2]=0,i[A+24>>2]=0,i[f+152>>2]=k,i[f+156>>2]=0,i[f+160>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+172>>2]=0,i[f+176>>2]=0,i[f+192>>2]=0,i[f+196>>2]=1,i[f+180>>2]=f+184;i:{e:{if(A=Tr(19260),!A||n4(A,11364)&&n4(A,19669))break e;z(k,95656,88);break i}z(k,95568,88)}e=E(172),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94472,B=f,m=Zr(e+12|0),i[B+48>>2]=m,A=i[f+52>>2],i[f+52>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(e=i[f+48>>2],i[e+156>>2]=f- -64,A=i[e+20>>2],k=i[e+16>>2],(A|0)!=(k|0))for(;;){r=i[A-4>>2];i:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(A=A-8|0,(k|0)==(A|0))break}i[e+20>>2]=k,A=E(136),i[A>>2]=89772,i[A+4>>2]=0,i[A+8>>2]=0,r=A+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[A+60>>2]=0,i[A+64>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+72>>2]=-1,i[A+76>>2]=-1,i[A+80>>2]=-1,i[A+84>>2]=-1,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,u[A+112|0]=0,i[r>>2]=86932,i[A+132>>2]=0,i[A+124>>2]=0,i[A+128>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+32>>2]=1718909296,i[e+28>>2]=r,k=i[e+32>>2],i[e+32>>2]=A;i:{e:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A||(X[i[i[k>>2]+8>>2]](k),p(k)),r=i[e+28>>2],A=i[e+32>>2],A))break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}i:{if(k=i[e+20>>2],n=i[e+24>>2],k>>>0<n>>>0){i[k+4>>2]=A,i[k>>2]=r,i[e+20>>2]=k+8;break i}e:{if(t=k,k=i[e+16>>2],s=t-k|0,_=s>>3,o=_+1|0,o>>>0<536870912){if(n=n-k|0,t=n>>2,o=n>>>0>=2147483640?536870911:o>>>0<t>>>0?t:o,o){if(o>>>0>=536870912)break e;t=E(o<<3)}else t=0;n=t+s|0,i[n+4>>2]=A,i[n>>2]=r,A=n-(_<<3)|0,s&&z(A,k,s),i[e+24>>2]=t+(o<<3),r=n+8|0,i[e+20>>2]=r,i[e+16>>2]=A,k&&Z(k),i[e+20>>2]=r;break i}G0(),H()}x0(),H()}if(Fe(f+16|0,i[f+20>>2]),i[f+16>>2]=f+20,i[f+20>>2]=0,i[f+24>>2]=0,A=i[f+32>>2],r=i[f+28>>2],(A|0)!=(r|0))for(;;){e=i[A-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}i[f+32>>2]=r,A=i[f+44>>2],i[f+40>>2]=0,i[f+44>>2]=0;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return i[h+4>>2]=w,i[h>>2]=f,h|0}function X9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;n=v-48|0,v=n,f=E(172),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=94860,o0(f+16|0,0,80),k=i[f+4>>2],o=k+1|0,i[f+4>>2]=o,i[f+104>>2]=0,i[f+108>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,u[f+24|0]=1,Q[f+22>>1]=2,Q[f+18>>1]=2,Q[f+20>>1]=2,i[f+112>>2]=0,i[f+116>>2]=4740,i[f+140>>2]=0,i[f+144>>2]=0,i[f+128>>2]=99,i[f+132>>2]=99,i[f+120>>2]=0,i[f+124>>2]=0,i[f+12>>2]=95208,i[f+148>>2]=0,i[f+152>>2]=0,i[f+136>>2]=f+140,i[f+156>>2]=0,i[f+160>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+4>>2]=k,k=i[f+8>>2],s=f+12|0,i[f+96>>2]=s,i[f+8>>2]=k+1,i[f+100>>2]=f,o||(X[i[i[f>>2]+8>>2]](f),p(f)),k=i[e>>2],o=i[k+108>>2],k=i[k+112>>2],i[s+120>>2]=0,i[s+116>>2]=2,i[s+112>>2]=k,i[s+108>>2]=o;i:{e:{r:{if(u1(i[e>>2],6)){if(i[n+8>>2]=i[e>>2],e=i[e+4>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f6(n+28|0,s,n+8|0,6,0,r),u[n+47|0]<0&&Z(i[n+36>>2]),r=i[n+12>>2],!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;X[i[i[r>>2]+8>>2]](r),p(r);break r}if(k=i[e>>2],i[k+120>>2]!=11)break r;i[n>>2]=k,e=i[e+4>>2],i[n+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),h=n+8|0,k=i[n>>2],W=i[k+112>>2],w=i[k+108>>2],_=255,e=i[k+128>>2];f:{if(!e)break f;for(o=k+128|0,t=o;k=i[e+16>>2]<10,t=k?t:e,e=i[(k?4:0)+e>>2],!!e;);if((t|0)==(o|0)|i[t+16>>2]>10)break f;_=l[t+24|0]}if(T0(h,s,0,w,W,_,r),!i[h>>2])f:{u[h+19|0]<0&&Z(i[h+8>>2]),_=0;A:{k:{if(r=i[n>>2],e=i[r+128>>2],!e)break k;for(k=r+128|0,t=k;r=i[e+16>>2]<10,t=r?t:e,e=i[(r?4:0)+e>>2],!!e;);if((k|0)==(t|0))break k;if(k=0,i[t+16>>2]>10)break A;I=i[t+56>>2],k=i[t+44>>2];break A}k=0}e=i[s+128>>2],r=0;A:{if(!e)break A;for(o=s+128|0,t=o;r=i[e+16>>2],t=(r|0)<0?t:e,e=i[(r>>>29&4)+e>>2],!!e;);if(r=0,(t|0)==(o|0)||(r=0,i[t+16>>2]>0))break A;_=i[t+56>>2],r=i[t+44>>2]}if(!(!W|!w))for(C=k+3|0,V=w&-4,g=w&3,o=w-1>>>0<3;;){if(B=G(_,m)+r|0,w=G(m,I)+C|0,e=0,t=0,!o)for(;u[e+B|0]=l[w+(e<<2)|0],k=e|1,u[k+B|0]=l[w+(k<<2)|0],k=e|2,u[k+B|0]=l[w+(k<<2)|0],k=e|3,u[k+B|0]=l[w+(k<<2)|0],e=e+4|0,t=t+4|0,(V|0)!=(t|0););if(t=0,g)for(;u[e+B|0]=l[w+(e<<2)|0],e=e+1|0,t=t+1|0,(g|0)!=(t|0););if(m=m+1|0,(W|0)==(m|0))break}if(e=i[26929],i[h>>2]=i[26928],i[h+4>>2]=e,r=h+8|0,u[107731]>=0){e=i[26931],i[r>>2]=i[26930],i[r+4>>2]=e,i[r+8>>2]=i[26932];break f}T(r,i[26930],i[26931])}r=i[n+4>>2];f:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}if(u[n+27|0]>=0)break r;Z(i[n+16>>2])}u[n+14|0]=1,Q[n+12>>1]=2,Q[n+8>>1]=2,Q[n+10>>1]=2,X[i[i[f+12>>2]+8>>2]](s,n+8|0),u[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=s;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+48|0}function tr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;s=v-32|0,v=s,i[s+28>>2]=0,i[s+20>>2]=0,i[s+24>>2]=0,j1(s,i[e>>2],r,s+20|0);i:{e:{if(i[s>>2]||(r=i[s+20>>2],n=i[s+24>>2],(r|0)==(n|0)))break e;for(;;){r:{if(t=i[r>>2],!t||(t=X0(t,86628,86648),!t))break r;r=i[r+4>>2];f:{if(!r){n=i[t+108>>2],t=i[t+104>>2];break f}if(o=i[r+4>>2],_=o+1|0,i[r+4>>2]=_,n=i[t+108>>2],t=i[t+104>>2],i[r+4>>2]=o,_)break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(!t|!n)break e;if(i[A+8>>2]=0,i[A+12>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,t0[A+24>>3]=+(n>>>0)/+(k|0),t0[A>>3]=+(t>>>0)/+(f|0),r=i[s+20>>2],_=i[s+24>>2],(r|0)==(_|0))break i;for(;;){f=i[r>>2],k=i[f+16>>2];f:{A:{if((k|0)!=1668047216){if((k|0)!=1769107316){if((k|0)!=1768778098)break f;k=0,o=X0(f,86628,88020);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}k:{if(i[o+100>>2]==1){t0[A>>3]=-t0[A>>3],t0[A+8>>3]=-t0[A+8>>3],t0[A+32>>3]=+(t-1>>>0)-t0[A+32>>3];break k}t0[A+16>>3]=-t0[A+16>>3],t0[A+24>>3]=-t0[A+24>>3],t0[A+40>>3]=+(n-1>>>0)-t0[A+40>>3]}if(!k)break f;if(f=i[k+4>>2],i[k+4>>2]=f-1,!f)break A;break f}k=0,o=X0(f,86628,87940);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}f=i[o+100>>2];k:{n:{t:{if((f|0)!=270){if((f|0)!=180){if((f|0)!=90){f=n;break k}w=t0[A+32>>3],t0[A+32>>3]=t0[A+40>>3],B=t0[A+8>>3],t0[A+8>>3]=t0[A+24>>3],m=t0[A>>3],t0[A>>3]=t0[A+16>>3],t0[A+24>>3]=-B,t0[A+16>>3]=-m,w=+(t>>>0)-w+-1;break t}t0[A>>3]=-t0[A>>3],t0[A+8>>3]=-t0[A+8>>3],t0[A+16>>3]=-t0[A+16>>3],t0[A+24>>3]=-t0[A+24>>3],t0[A+32>>3]=+(t-1>>>0)-t0[A+32>>3],w=+(n-1>>>0)-t0[A+40>>3],f=n;break n}w=t0[A+24>>3],t0[A+24>>3]=t0[A+8>>3],B=t0[A+16>>3],t0[A+16>>3]=t0[A>>3],t0[A+8>>3]=-w,t0[A>>3]=-B,w=t0[A+32>>3],t0[A+32>>3]=+(n>>>0)-t0[A+40>>3]+-1}f=t,t=n}t0[A+40>>3]=w}if(!k){n=f;break f}if(o=i[k+4>>2],i[k+4>>2]=o-1,n=f,!o)break A;break f}k=0,o=X0(f,86628,88100);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}if(f=$i(o,t),n=Ki(o,n),t0[A+32>>3]=t0[A+32>>3]-+(f|0),t0[A+40>>3]=t0[A+40>>3]-+(n|0),f=i[o+100>>2],n=i[o+104>>2],h=(n|0)/2|0,t=f+h|0,f=(f>>31)+(h>>31)|0,t=G2(t,t>>>0<h>>>0?f+1|0:f,n,n>>31),f=i[o+108>>2],n=i[o+112>>2],h=(n|0)/2|0,o=f+h|0,f=(f>>31)+(h>>31)|0,n=G2(o,o>>>0<h>>>0?f+1|0:f,n,n>>31),!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f}X[i[i[k>>2]+8>>2]](k),p(k)}if(r=r+8|0,(_|0)==(r|0))break}break i}if(r=r+8|0,(n|0)==(r|0))break}}i[A+8>>2]=0,i[A+12>>2]=0,i[A>>2]=0,i[A+4>>2]=1072693248,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=1072693248,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0}if(u[s+19|0]<0&&Z(i[s+8>>2]),f=i[s+20>>2],f){if(A=f,r=i[s+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(r=r-8|0,(f|0)==(r|0))break}A=i[s+20>>2]}i[s+24>>2]=f,Z(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=s+32|0}function y4(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;h=v-112|0,v=h,w=s&2147483647;i:{e:{if(m=k&2147483647,_=2147418112,B=!(e|r),!(f|m?m-_>>>0<2147549184:B)&&(C=w-_|0,!o&(C|0)==-2147418112?n|t:(C|0)==-2147418112&(o|0)!=0|C>>>0>2147549184))break e;if(!(!f&(m|0)==2147418112?B:m>>>0<2147418112)){o=f,s=k|32768,n=e,t=r;break i}if(!(!o&(w|0)==2147418112?!(n|t):w>>>0<2147418112)){s=s|32768;break i}if(!(e|f|(m^2147418112|r))){_=f,f=!(e^n|f^o|(r^t|k^s^-2147483648)),o=f?0:_,s=f?2147450880:k,n=f?0:e,t=f?0:r;break i}if(_=n|o,!(_|(w^2147418112|t)))break i;if(!(e|f|(r|m))){if(t|w|_)break i;n=e&n,t=r&t,o=f&o,s=k&s;break i}if(n|o|(t|w))break e;n=e,t=r,o=f,s=k;break i}_=(w|0)==(m|0),g=_&(f|0)==(o|0)?(r|0)==(t|0)&e>>>0<n>>>0|r>>>0<t>>>0:_&f>>>0<o>>>0|w>>>0>m>>>0,B=g,m=B?n:e,C=B?t:r,_=B?s:k,V=_,B=B?o:f,I=_&65535,w=g?f:o,_=g?k:s,o=_,_=o>>>16&32767,W=V>>>16&32767,W||(W=!(B|I),f=k1(W?C:I),W=((f|0)==32?k1(W?m:B)+32|0:f)+(W?64:0)|0,o4(h+96|0,m,C,B,I,W-15|0),B=i[h+104>>2],I=i[h+108>>2],C=i[h+100>>2],W=16-W|0,m=i[h+96>>2]),n=g?e:n,t=g?r:t,e=w,r=o&65535,_||(w=!(e|r),g=k1(w?t:r),w=((g|0)==32?k1(w?n:e)+32|0:g)+(w?64:0)|0,o4(h+80|0,n,t,e,r,w-15|0),_=16-w|0,n=i[h+80>>2],t=i[h+84>>2],e=i[h+88>>2],r=i[h+92>>2]),f=r<<3,r=e,e=f|e>>>29,w=r<<3,r=e,e=t>>>29|w,r=r|524288,w=I<<3|B>>>29,I=B<<3|C>>>29,g=w,o=k^s,w=t<<3|n>>>29,f=n<<3;e:{if((_|0)==(W|0))break e;if(k=W-_|0,k>>>0>127){e=0,r=0,w=0,f=1;break e}o4(h- -64|0,f,w,e,r,128-k|0),Y6(h+48|0,f,w,e,r,k),e=i[h+56>>2],r=i[h+60>>2],w=i[h+52>>2],f=i[h+48>>2]|(i[h+64>>2]|i[h+72>>2]|(i[h+68>>2]|i[h+76>>2]))!=0}B=f,_=w,g=g|524288,w=C<<3|m>>>29,m=m<<3;e:{if((o|0)<0){if(n=0,t=0,o=0,s=0,!(m^B|e^I|(w^_|r^g)))break i;if(f=m-B|0,k=w-((m>>>0<B>>>0)+_|0)|0,n=I-e|0,t=(w|0)==(_|0)&m>>>0<B>>>0|w>>>0<_>>>0,o=n-t|0,e=(g-((e>>>0>I>>>0)+r|0)|0)-(n>>>0<t>>>0)|0,s=e,e>>>0>524287)break e;r=!(e|o),t=k1(r?k:e),r=((t|0)==32?k1(r?f:o)+32|0:t)+(r?64:0)|0,e=r-12|0,o4(h+32|0,f,k,o,s,e),W=W-e|0,o=i[h+40>>2],s=i[h+44>>2],f=i[h+32>>2],k=i[h+36>>2];break e}if(k=w+_|0,f=m+B|0,k=f>>>0<m>>>0?k+1|0:k,n=(_|0)==(k|0)&f>>>0<B>>>0|k>>>0<_>>>0,w=r+g|0,e=e+I|0,w=e>>>0<I>>>0?w+1|0:w,o=e+n|0,s=o>>>0<e>>>0?w+1|0:w,!(s&1048576))break e;f=B&1|((k&1)<<31|f>>>1),k=o<<31|k>>>1,W=W+1|0,o=(s&1)<<31|o>>>1,s=s>>>1|0}if(n=0,e=V&-2147483648,t=e,(W|0)>=32767){o=n,s=e|2147418112,t=0;break i}_=0;e:{if((W|0)>0){_=W;break e}o4(h+16|0,f,k,o,s,W+127|0),Y6(h,f,k,o,s,1-W|0),f=i[h>>2]|(i[h+16>>2]|i[h+24>>2]|(i[h+20>>2]|i[h+28>>2]))!=0,k=i[h+4>>2],o=i[h+8>>2],s=i[h+12>>2]}r=(k&7)<<29|f>>>3,k=o<<29|k>>>3,n=n|((s&7)<<29|o>>>3),e=t|(s>>>3&65535|_<<16);e:{r:{if(w=f&7,(w|0)!=4){o=n,f=k,n=w>>>0>4,k=n,n=r+n|0,t=k>>>0>n>>>0?f+1|0:f,r=(f|0)==(t|0)&r>>>0>n>>>0|f>>>0>t>>>0,o=r+o|0,s=r>>>0>o>>>0?e+1|0:e;break r}o=n,f=e,e=k,n=r&1,k=n,n=r+n|0,t=k>>>0>n>>>0?e+1|0:e,e=(t|0)==(e|0)&r>>>0>n>>>0|e>>>0>t>>>0,o=e+o|0,s=o>>>0<e>>>0?f+1|0:f;break e}if(!w)break i}}i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,v=h+112|0}function Z(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{if(!A)break i;f=A-8|0,e=i[A-4>>2],A=e&-8,n=f+A|0;e:{if(e&1)break e;if(!(e&2)||(e=i[f>>2],f=f-e|0,f>>>0<u0[31654]))break i;A=A+e|0;r:{f:{A:{if(i[31655]!=(f|0)){if(r=i[f+12>>2],e>>>0<=255){if(k=i[f+8>>2],(k|0)!=(r|0))break A;w=126600,h=i[31650]&k2(-2,e>>>3|0),i[w>>2]=h;break e}if(o=i[f+24>>2],(r|0)!=(f|0)){e=i[f+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break r}if(k=i[f+20>>2],k)e=f+20|0;else{if(k=i[f+16>>2],!k)break f;e=f+16|0}for(;t=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[t>>2]=0;break r}if(e=i[n+4>>2],(e&3)!=3)break e;i[31652]=A,i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[n>>2]=A;return}i[k+12>>2]=r,i[r+8>>2]=k;break e}r=0}if(!o)break e;e=i[f+28>>2],k=(e<<2)+126904|0;r:{if(i[k>>2]==(f|0)){if(i[k>>2]=r,r)break r;w=126604,h=i[31651]&k2(-2,e),i[w>>2]=h;break e}f:{if(i[o+16>>2]==(f|0)){i[o+16>>2]=r;break f}i[o+20>>2]=r}if(!r)break e}if(i[r+24>>2]=o,e=i[f+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[f+20>>2],!e)break e;i[r+20>>2]=e,i[e+24>>2]=r}if(f>>>0>=n>>>0||(e=i[n+4>>2],!(e&1)))break i;e:{r:{f:{A:{if(!(e&2)){if(i[31656]==(n|0)){if(i[31656]=f,A=i[31653]+A|0,i[31653]=A,i[f+4>>2]=A|1,i[31655]!=(f|0))break i;i[31652]=0,i[31655]=0;return}if(s=i[31655],(s|0)==(n|0)){i[31655]=f,A=i[31652]+A|0,i[31652]=A,i[f+4>>2]=A|1,i[A+f>>2]=A;return}if(A=(e&-8)+A|0,r=i[n+12>>2],e>>>0<=255){if(k=i[n+8>>2],(k|0)==(r|0)){w=126600,h=i[31650]&k2(-2,e>>>3|0),i[w>>2]=h;break r}i[k+12>>2]=r,i[r+8>>2]=k;break r}if(o=i[n+24>>2],(r|0)!=(n|0)){e=i[n+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break f}if(k=i[n+20>>2],k)e=n+20|0;else{if(k=i[n+16>>2],!k)break A;e=n+16|0}for(;t=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[t>>2]=0;break f}i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[A+f>>2]=A;break e}r=0}if(!o)break r;e=i[n+28>>2],k=(e<<2)+126904|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=r,r)break f;w=126604,h=i[31651]&k2(-2,e),i[w>>2]=h;break r}A:{if(i[o+16>>2]==(n|0)){i[o+16>>2]=r;break A}i[o+20>>2]=r}if(!r)break r}if(i[r+24>>2]=o,e=i[n+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[n+20>>2],!e)break r;i[r+20>>2]=e,i[e+24>>2]=r}if(i[f+4>>2]=A|1,i[A+f>>2]=A,(f|0)!=(s|0))break e;i[31652]=A;return}if(A>>>0<=255){e=(A&-8)+126640|0,k=i[31650],A=1<<(A>>>3);e:{if(!(k&A)){i[31650]=A|k,A=e;break e}A=i[e+8>>2]}i[e+8>>2]=f,i[A+12>>2]=f,i[f+12>>2]=e,i[f+8>>2]=A;return}r=31,A>>>0<=16777215&&(e=k1(A>>>8|0),r=((A>>>38-e&1)-(e<<1)|0)+62|0),i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,e=(r<<2)+126904|0;e:{r:{k=i[31651],t=1<<r;f:{if(!(k&t)){i[31651]=k|t,i[e>>2]=f,r=24;break f}for(r=A<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[e>>2];;){if(k=e,(i[e+4>>2]&-8)==(A|0))break r;if(e=r>>>29|0,r=r<<1,t=(e&4)+k|0,e=i[t+16>>2],!e)break}i[t+16>>2]=f,e=k,r=24}k=f,t=f,A=8;break e}e=i[k+8>>2],i[e+12>>2]=f,i[k+8>>2]=f,r=8,t=0,A=24}i[r+f>>2]=e,i[f+12>>2]=k,i[A+f>>2]=t,A=i[31658]-1|0,i[31658]=A||-1}}function g9(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;n=v-128|0,v=n;i:{if(!k||!e|!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if((r|0)<=0){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=11845;break i}s=E(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=95072,t=dr(s+16|0,e,r,0),i[n+100>>2]=s,i[n+96>>2]=t,i[s+4>>2]=i[s+4>>2]+1,t=i[n+100>>2],i[n+8>>2]=i[n+96>>2],i[n+12>>2]=t,o=Ee(n+104|0,n+8|0,r,0),t=n+56|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,$6(n+36|0,t,o);e:{if(w=i[n+36>>2],w){i[A>>2]=w,i[A+4>>2]=i[n+40>>2],e=7332;break e}if(i[t+16>>2]!=1718909296){i[A>>2]=2,i[A+4>>2]=0,e=22989;break e}u[n+55|0]<0&&Z(i[n+44>>2]),i[t>>2]=86404,w=i[t+20>>2],w&&(i[t+24>>2]=w,Z(w)),t=i[o+4>>2];r:{if(!t||(o=i[t+4>>2],i[t+4>>2]=o-1,o))break r;X[i[i[t>>2]+8>>2]](t),p(t)}t=i[s+4>>2],i[s+4>>2]=t-1,t||(X[i[i[s>>2]+8>>2]](s),p(s)),s=E(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=95072,e=dr(s+16|0,e,r,0),i[n+32>>2]=s,i[n+28>>2]=e,i[s+4>>2]=i[s+4>>2]+1,e=i[n+32>>2],i[n>>2]=i[n+28>>2],i[n+4>>2]=e,w=Ee(n+56|0,n,r,0),i[n+20>>2]=0,i[n+24>>2]=0,I6(n+104|0,w,n+20|0,95568),r=i[n+104>>2];r:{if(r){if(e=i[n+108>>2],i[A>>2]=r,(e|0)==100){i[A+4>>2]=100,i[A+8>>2]=18739;break r}i[A+4>>2]=e,i[A+8>>2]=2369;break r}f:{if(e=i[n+20>>2],!e||(e=X0(e,86628,86992),!e))break f;t=i[n+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[n+44>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;A:{k:{if(o=i[e+112>>2],r=i[e+108>>2],(o|0)!=(r|0)){if(e=o-r|0,(e|0)<0)break k;o=E(e),i[n+36>>2]=o,h=e+o|0,i[n+44>>2]=h,e&&z(o,r,e),i[n+40>>2]=h}break A}G0(),H()}e=i[n+40>>2],r=i[n+36>>2],h=e-r|0,o=h>>2;A:{if(o>>>0>u0[23913]){i[A>>2]=6,i[A+4>>2]=1e3,i[A+8>>2]=23813;break A}_=f,f=p2(h),i[_>>2]=f,i[k>>2]=o;k:{if((e|0)==(r|0))break k;if(_=o>>>0<=1?1:o,h=_&3,k=0,e=0,o>>>0>=4)for(m=_&-4,_=0;o=e<<2,i[o+f>>2]=i[r+o>>2],B=o|4,i[B+f>>2]=i[r+B>>2],B=o|8,i[B+f>>2]=i[r+B>>2],o=o|12,i[o+f>>2]=i[r+o>>2],e=e+4|0,_=_+4|0,(m|0)!=(_|0););if(!h)break k;for(;o=e<<2,i[o+f>>2]=i[r+o>>2],e=e+1|0,k=k+1|0,(h|0)!=(k|0););}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(r&&(i[n+40>>2]=r,Z(r)),!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break r;X[i[i[t>>2]+8>>2]](t),p(t);break r}i[A>>2]=2,i[A+4>>2]=102,i[A+8>>2]=2392}u[n+123|0]<0&&Z(i[n+112>>2]),A=i[n+24>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[w+4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;X[i[i[s>>2]+8>>2]](s),p(s);break i}i[A+8>>2]=e,u[n+55|0]<0&&Z(i[n+44>>2]),i[t>>2]=86404,A=i[t+20>>2],A&&(i[t+24>>2]=A,Z(A)),A=i[o+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;X[i[i[s>>2]+8>>2]](s),p(s)}v=n+128|0}function d6(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;n=v-192|0,v=n,_=A+8|0,m=i[18063],V=m-12|0,y=i[18064]-12|0,R=i[18067]-12|0,W=i[18065],N=W-12|0,D=i[18072],x=i[18071],S=n+32|0,O=n+44|0,L=i[18069],a=i[18068],$=i[18066],g=n+24|0,I=n+20|0,f0=n+76|0,A0=(f|0)==-1;i:{e:{r:{f:{A:{for(;;){k:{n:{t:{u:{o:{if(o=l[r+20|0],!(!i[r+16>>2]|o&1)){i[n+184>>2]=0,i[n+188>>2]=0,I6(n+160|0,r,n+184|0,k);l:{if(i[n+160>>2]==i[26928]||(o=i[n+184>>2],o&&X[i[i[o>>2]+36>>2]](o)|0))break l;o=i[n+164>>2],i[A>>2]=i[n+160>>2],i[A+4>>2]=o,i[_+8>>2]=i[n+176>>2],o=i[n+172>>2],i[_>>2]=i[n+168>>2],i[_+4>>2]=o,i[n+168>>2]=0,i[n+172>>2]=0,i[n+176>>2]=0,o=1;break k}if(!A0){t=i[e+40>>2];break n}if(o=i[(i[e+16>>2]==1768517222?28:60)+k>>2],t=i[e+40>>2],!o|o>>>0>=t-i[e+36>>2]>>3>>>0)break n;i[n+104>>2]=0,i[n+12>>2]=W,i[n+76>>2]=72244,i[n+20>>2]=72224,t=n+12|0,i[t+i[N>>2]>>2]=$,i[n+16>>2]=0,s=t+i[i[n+12>>2]-12>>2]|0,J0(s,g),u[s+80|0]=0,i[s+72>>2]=0,i[i[R>>2]+I>>2]=a,i[t+i[y>>2]>>2]=L,i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,w=R0(g),i[w>>2]=71280,i[n+64>>2]=0,i[n+68>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,o=Y(I0(Y(I,27071,31),o),27376,6),ie(n,e),s=o,o=u[n+11|0],t=(o|0)<0,Y(Y(s,t?i[n>>2]:n,t?i[n+4>>2]:o),25995,15),u[n+11|0]<0&&Z(i[n>>2]),o=i[n+72>>2];l:{if(o&16){if(t=O,o=i[n+68>>2],s=i[n+48>>2],o>>>0>=s>>>0)break l;i[n+68>>2]=s,o=s;break l}if(!(o&8)){t=0,u[n+11|0]=0,o=n;break t}o=i[n+40>>2],t=S}if(s=i[t>>2],t=o-s|0,t>>>0>=2147483640)break o;if(t>>>0>=11){h=t|7,o=E(h+1|0),i[n+8>>2]=h-2147483647,i[n>>2]=o,i[n+4>>2]=t;break u}if(u[n+11|0]=t,o=n,t)break u;t=0;break t}if(o&1)break A;break f}g0(),H()}if(!t)break t;z(o,s,t)}u[t+o|0]=0,K(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),i[n+12>>2]=m,i[i[V>>2]+(n+12|0)>>2]=x,i[n+20>>2]=D,i[w>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(w),p0(f0),o=1;break k}w=i[e+44>>2];n:{if(w>>>0>t>>>0){i[t>>2]=i[n+184>>2],i[t+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,t=t+8|0;break n}if(s=i[e+36>>2],o=t-s|0,B=o>>3,t=B+1|0,t>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<h>>>0?h:t,w){if(w>>>0>=536870912)break i;t=E(w<<3)}else t=0;if(h=t+o|0,i[h>>2]=i[n+184>>2],i[h+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,B=h-(B<<3)|0,o&&z(B,s,o),i[e+44>>2]=t+(w<<3),t=h+8|0,i[e+40>>2]=t,i[e+36>>2]=B,!s)break n;Z(s)}i[e+40>>2]=t,C=C+1|0,o=(f|0)!=-1&&(C|0)==(f|0)?3:0}u[n+179|0]<0&&Z(i[n+168>>2]),t=i[n+188>>2];k:{if(!t||(s=i[t+4>>2],i[t+4>>2]=s-1,s))break k;X[i[i[t>>2]+8>>2]](t),p(t)}if(o)break}if((o|0)!=3)break r;if(!(u[r+20|0]&1))break f}if(u[n+12|0]=0,u[n+23|0]=0,K(A,2,100,n+12|0),u[n+23|0]>=0)break r;Z(i[n+12>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[_>>2]=i[26930],i[_+4>>2]=A,i[_+8>>2]=i[26932];break r}T(_,i[26930],i[26931])}v=n+192|0;return}G0(),H()}x0(),H()}function Jv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,2946);break i}i[e+120>>2]=0,i[e+124>>2]=0,Q[e+116>>1]=1,i[e+112>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=1072693248,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+176>>2]=0,k=i[e+100>>2],k&1&&(u[e+184|0]=1,_=e,B=F0(r),i[_+104>>2]=B,k=i[e+100>>2]),k&2&&(u[e+185|0]=1,_=e,B=F0(r),i[_+108>>2]=B,k=i[e+100>>2]),k&4&&(u[e+186|0]=1,_=e,B=F0(r),i[_+112>>2]=B,k=i[e+100>>2]);e:{if(!(k&8))break e;u[e+187|0]=1;r:{f:switch(l[e+97|0]){case 0:s=k&16;A:{if(s){k=F0(r),w=F0(r),h=F0(r);break A}k=wi(r),w=wi(r),h=wi(r)}if(u[e+116|0]=1,n=+(16384<<s>>>0),t=+(h|0)/n,t0[e+136>>3]=t,o=+(w|0)/n,t0[e+128>>3]=o,n=+(k|0)/n,t0[e+120>>3]=n,n=t*t+(n*n+o*o),!(n>1))break r;if(e=E(48),i[f+20>>2]=e,i[f+24>>2]=47,i[f+28>>2]=-2147483600,r=l[2849]|l[2850]<<8|(l[2851]<<16|l[2852]<<24),k=l[2845]|l[2846]<<8|(l[2847]<<16|l[2848]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+47|0]=0,r=l[2888]|l[2889]<<8|(l[2890]<<16|l[2891]<<24),k=l[2884]|l[2885]<<8|(l[2886]<<16|l[2887]<<24),u[e+39|0]=k,u[e+40|0]=k>>>8,u[e+41|0]=k>>>16,u[e+42|0]=k>>>24,u[e+43|0]=r,u[e+44|0]=r>>>8,u[e+45|0]=r>>>16,u[e+46|0]=r>>>24,r=l[2881]|l[2882]<<8|(l[2883]<<16|l[2884]<<24),k=l[2877]|l[2878]<<8|(l[2879]<<16|l[2880]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[2873]|l[2874]<<8|(l[2875]<<16|l[2876]<<24),k=l[2869]|l[2870]<<8|(l[2871]<<16|l[2872]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[2865]|l[2866]<<8|(l[2867]<<16|l[2868]<<24),k=l[2861]|l[2862]<<8|(l[2863]<<16|l[2864]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[2857]|l[2858]<<8|(l[2859]<<16|l[2860]<<24),k=l[2853]|l[2854]<<8|(l[2855]<<16|l[2856]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i;case 1:break f;default:break e}_=e,m=+(F0(r)|0)*152587890625e-16,t0[_+152>>3]=m,_=e,m=+(F0(r)|0)*152587890625e-16,t0[_+160>>3]=m,_=e,m=+(F0(r)|0)*152587890625e-16,t0[_+168>>3]=m;break e}t0[e+144>>3]=X_(1-n)}if(l[e+100|0]&32&&(u[e+188|0]=1,_=e,B=F0(r),i[_+176>>2]=B),l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Q9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,f=ei(o+16|0,e,r),e=i[f+12>>2],r=e>>31<<3|e>>>29,k=i[f+24>>2],e=k+(e<<3)|0,n=(k>>31)+r|0,n=e>>>0<k>>>0?n+1|0:n;i:{if(!e&(n|0)<=0|(n|0)<0)break i;e:{for(;;){if(I2(f,1),t=i2(f,4),e=i2(f,1),r=i2(f,1),I2(f,1),e&&I2(f,8),r){e=i2(f,8),r=e&127,k=0;r:{if(!(e&128)||(e=i2(f,8),r=r|e<<7&16256,!(e&128))||(e=i2(f,8),r=r|e<<14&2080768,!(e&128))||(e=i2(f,8),r=r|e<<21&266338304,!(e&128))||(e=i2(f,8),n=e>>>4|0,r=r|e<<28&-268435456,k=k|n&7,!(e&128))||(e=i2(f,8),k=k|e<<3&1016,!(e&128))||(e=i2(f,8),k=k|e<<10&130048,!(e&128)))break r;k=k|i2(f,8)<<17&16646144}if((t|0)==1)break e;if(!k&r>>>0>2147483647|k)break i;if(Jt(f,r),e=i[f+24>>2],r=e,k=e>>31,e=i[f+12>>2],n=e>>31<<3|e>>>29,t=e<<3,r=t+r|0,e=k+n|0,e=r>>>0<t>>>0?e+1|0:e,!!r&(e|0)>=0|(e|0)>0)continue;break i}break}if((t|0)!=1)break i}w=A,h=i2(f,3),u[w+1|0]=h,n=1,i2(f,1),s=i2(f,1);e:{if(s){e=i2(f,5),u[A+3|0]=0,u[A+2|0]=e;break e}e=0;r:{if(!i2(f,1)||(Jt(f,8),i2(f,1)&&$2(f,o+12|0),e=0,!i2(f,1)))break r;e=i2(f,5),I2(f,32),I2(f,10),n=e+1|0,e=1}if(k=i2(f,1),t=i2(f,5),(t|0)<0)break e;if(I2(f,12),r=i2(f,5),u[A+2|0]=r,r=r&248,!k){r&&(w=A,h=i2(f,1),u[w+3|0]=h);r:{if(!e||!i2(f,1))break r;I2(f,n),I2(f,n),I2(f,1)}if(!t)break e;for(r=1;;){I2(f,12),i2(f,5)&248&&i2(f,1),k=r;r:{if(!e||!i2(f,1))break r;I2(f,n),I2(f,n),I2(f,1)}if(r=k+1|0,(k|0)==(t|0))break}break e}if(!e){if(r&&(w=A,h=i2(f,1),u[w+3|0]=h),r=1,e=i2(f,1),u[A+10|0]=(e|0)!=0,e&&(w=A,h=i2(f,4),u[w+11|0]=h),!t)break e;for(;I2(f,12),i2(f,5)&248&&i2(f,1),i2(f,1)&&i2(f,4),e=(r|0)!=(t|0),r=r+1|0,!!e;);break e}if(r&&(w=A,h=i2(f,1),u[w+3|0]=h),i2(f,1)&&(I2(f,n),I2(f,n),I2(f,1)),e=i2(f,1),u[A+10|0]=(e|0)!=0,e&&(w=A,h=i2(f,4),u[w+11|0]=h),!t)break e;for(r=1;I2(f,12),i2(f,5)&248&&i2(f,1),i2(f,1)&&(I2(f,n),I2(f,n),I2(f,1)),i2(f,1)&&i2(f,4),e=(r|0)==(t|0),r=r+1|0,!e;);}e=i2(f,4),r=i2(f,4),i2(f,e+1|0),i2(f,r+1|0);e:{if(!s){i2(f,1)&&I2(f,7),I2(f,3),I2(f,4),e=i2(f,1),e&&I2(f,2);r:{if(!i2(f,1)&&(i2(f,1)|0)<=0||i2(f,1))break r;I2(f,1)}if(!e)break e}I2(f,3)}I2(f,3),k=i2(f,1),u[A+4|0]=k,e=l[A+1|0],r=0;e:{if(!(k&255)){n=0;break e}if(n=0,(e&255)!=2)break e;n=i2(f,1),e=l[A+1|0]}u[A+5|0]=n,(e&255)!=1?e=i2(f,1):e=0,u[A+6|0]=e;e:{if(!i2(f,1)){e=0,k=0;break e}e=(i2(f,8)|0)==1,r=(i2(f,8)|0)==13,k=!i2(f,8)}e:{r:{if(l[A+6|0]){I2(f,1),u[A+7|0]=1,u[A+8|0]=1,r=9,e=0;break r}f:{if((k&(e&r))==1)break f;I2(f,1);A:{k:{n:{t:switch(l[A+1|0]){default:if(l[A+5|0]){if(e=i2(f,1),u[A+7|0]=e,e&255)break n;break A}u[A+7|0]=1;break A;case 1:break f;case 0:break t}u[A+7|0]=1,u[A+8|0]=1;break k}if(e=i2(f,1),u[A+8|0]=e,!l[A+7|0]|!(e&255))break e}r=9,e=i2(f,2);break r}r=8,e=0;break r}u[A+7|0]=0,r=8,e=0}u[A+r|0]=e}I2(f,1)}v=o+48|0}function Nv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;h=v-32|0,v=h;i:{e:{if(n=i[e>>2],!n||(o=X0(n,106612,106840),!o))break e;s=i[e+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=h+12|0,f=v-80|0,v=f;r:{if(i[o+100>>2]!=i[o+104>>2])break r;n=E(120),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94092,W=n+16|0,k=W,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,u[n+112|0]=0,i[k>>2]=105628,i[n+32>>2]=1970432365,k=E(136),i[k>>2]=94132,i[k+4>>2]=0,i[k+8>>2]=0,w=k+16|0,t=w,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[t>>2]=105708,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1970432288,B=k+120|0;f:{A:{k:{n:{if(u[o+299|0]>=0){if(i[f+72>>2]=i[o+296>>2],t=i[o+292>>2],i[f+64>>2]=i[o+288>>2],i[f+68>>2]=t,u[f+75|0]>=0)break n;break A}if(T(f- -64|0,i[o+288>>2],i[o+292>>2]),m=u[f+75|0],u[k+131|0]<0)break k;if((m|0)<0)break A}t=i[f+68>>2],i[B>>2]=i[f+64>>2],i[B+4>>2]=t,i[B+8>>2]=i[f+72>>2];break f}t=(m|0)<0,O1(B,t?i[f+64>>2]:f- -64|0,t?i[f+68>>2]:m);break f}D1(B,i[f+64>>2],i[f+68>>2])}u[f+75|0]<0&&Z(i[f+64>>2]),i[f+36>>2]=k,i[f+32>>2]=w,i[k+4>>2]=i[k+4>>2]+1,r2(n+52|0,f+32|0),w=i[f+36>>2];f:{if(!w||(t=i[w+4>>2],i[w+4>>2]=t-1,t))break f;X[i[i[w>>2]+8>>2]](w),p(w)}if(B9(o,0),i[f+60>>2]=n,i[f+56>>2]=W,i[n+4>>2]=i[n+4>>2]+1,t=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=t,Zn(o,f+8|0),t=i[k+4>>2],i[k+4>>2]=t-1,t||(X[i[i[k>>2]+8>>2]](k),p(k)),k=i[n+4>>2],i[n+4>>2]=k-1,k)break r;X[i[i[n>>2]+8>>2]](n),p(n)}t=i[r+16>>2],k=i[r+12>>2];r:{if(u[r+31|0]>=0){i[f+24>>2]=i[r+28>>2],n=i[r+24>>2],i[f+16>>2]=i[r+20>>2],i[f+20>>2]=n;break r}T(f+16|0,i[r+20>>2],i[r+24>>2])}u[f+28|0]=1,$7(f+32|0,o,r,k,0,1,t,f+16|0),l[f+28|0]!=1|u[f+27|0]>=0||Z(i[f+16>>2]),n=_+8|0;r:{if(i[f+32>>2]){r=i[f+36>>2],i[_>>2]=i[f+32>>2],i[_+4>>2]=r,i[n+8>>2]=i[f+48>>2],r=i[f+44>>2],i[n>>2]=i[f+40>>2],i[n+4>>2]=r,i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0;break r}if(r=i[26929],i[_>>2]=i[26928],i[_+4>>2]=r,u[107731]>=0){r=i[26931],i[n>>2]=i[26930],i[n+4>>2]=r,i[n+8>>2]=i[26932];break r}T(n,i[26930],i[26931])}u[f+51|0]<0&&Z(i[f+40>>2]),v=f+80|0;r:{if(i[h+12>>2]){b0(A,_,i[e+8>>2]);break r}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}if(u[h+31|0]<0&&Z(i[h+20>>2]),!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24884}v=h+32|0}function Mv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=72548,o=i[18140],i[n+20>>2]=o,k=i[o-12>>2],o=n+20|0,i[k+o>>2]=i[18141],k=o+i[i[n+20>>2]-12>>2]|0,f=n+24|0,J0(k,f),u[k+80|0]=0,i[k+72>>2]=0,i[n+76>>2]=72548,i[n+20>>2]=72528,h=R0(f),i[h>>2]=71280,k=n- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=16,k=n+8|0,Y2(k,e,r),s=o,t=k,o=u[n+19|0],k=(o|0)<0,Y(s,k?i[n+8>>2]:t,k?i[n+12>>2]:o),u[n+19|0]<0&&Z(i[n+8>>2]),B=n+8|0,o=B,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],w=k+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(w,t),u[w+80|0]=0,i[w+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,w=R0(t),i[w>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,t=f+148|0,s0(t,r),_=k,s=t,k=u[f+159|0],t=(k|0)<0,Y(_,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),t=f+8|0,Y(t,29236,18),k=i[e+112>>2],s=i[e+116>>2];i:{if((k&s)==-1){Y(t,33221,8);break i}Y(K2(f+8|0,k,s),42713,1)}k=f+148|0,s0(k,r),s=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,30519,18),i[e+120>>2]),42713,1),t=f+148|0,s0(t,r),_=k,s=t,k=u[f+159|0],t=(k|0)<0,Y(_,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,31462,18),t=i[e+124>>2];i:{if((t|0)==2147483647){Y(k,33486,10);break i}Y(S0(f+8|0,t),42713,1)}k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,31714,12),l[e+128|0]),32851,1);i:{e:switch(l[e+128|0]){case 0:Y(f+8|0,42456,10);break i;case 2:Y(f+8|0,42548,32);break i;case 1:Y(f+8|0,42581,36);break i;default:break e}Y(f+8|0,42517,16)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[o+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[o+8>>2]=t-2147483647,i[o>>2]=r,i[o+4>>2]=e,o=r;break e}if(u[o+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(o,k,e)}u[e+o|0]=0,e=i[18139],i[f+8>>2]=e,i[i[e-12>>2]+(f+8|0)>>2]=i[18142],i[w>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(w),p0(f- -64|0),v=f+160|0,e=u[n+19|0],r=(e|0)<0,Y(n+20|0,r?i[n+8>>2]:B,r?i[n+12>>2]:e),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[n+72>>2];i:{e:{if(e&16){r=i[n+68>>2],e=i[n+48>>2],r>>>0<e>>>0&&(i[n+68>>2]=e,r=e),e=n+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[n+40>>2],e=n+32|0}e:{if(o=i[e>>2],r=r-o|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,o,r)}u[A+r|0]=0,A=i[18139],i[n+20>>2]=A,i[i[A-12>>2]+(n+20|0)>>2]=i[18142],i[h>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(h),p0(n+76|0),v=n+160|0}function Uv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]>=2){t1(A,e,18963);break i}if(_=F0(r),n=i[f+28>>2],!(n>>>0<_>>>0&&n)){e:{f=l[r+20|0];r:{if(!(!i[r+16>>2]|(!_|f&1))){I=e+104|0;f:{for(;;){i[k+36>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0;A:{if(!l[e+97|0]){f=o2(r);break A}f=F0(r)}i[k+24>>2]=f,B=0;A:{if(m=W2(r),!m)break A;k:{for(;;){n:{if(u[e+100|0]&1){n=o2(r),f=n&32767,t=n>>>15|0;break n}n=W2(r),f=n&127,t=n>>>7|0}n:{n=i[k+32>>2],s=i[k+36>>2];t:{if(n>>>0<s>>>0){f=t|f<<16,Q[n>>1]=f,Q[n+2>>1]=f>>>16,f=n+4|0;break t}if(w=i[k+28>>2],n=n-w|0,W=n>>2,o=W+1|0,o>>>0>=1073741824)break n;if(s=s-w|0,h=s>>1,s=s>>>0>=2147483644?1073741823:o>>>0<h>>>0?h:o,s){if(s>>>0>=1073741824)break k;o=E(s<<2)}else o=0;if(h=o+n|0,f=t|f<<16,Q[h>>1]=f,Q[h+2>>1]=f>>>16,t=h-(W<<2)|0,n&&z(t,w,n),i[k+36>>2]=o+(s<<2),f=h+4|0,i[k+32>>2]=f,i[k+28>>2]=t,!w)break t;Z(w)}if(i[k+32>>2]=f,B=B+1|0,(m|0)==(B|0))break A;continue}break}G0(),H()}x0(),H()}f=i[e+108>>2];A:{if(f>>>0<u0[e+112>>2]){if(n=i[k+24>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=n,n=i[k+32>>2],o=i[k+28>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break f;t=E(n),i[f+8>>2]=t,i[f+4>>2]=t,w=n+t|0,i[f+12>>2]=w,n&&z(t,o,n),i[f+8>>2]=w}f=f+16|0;break A}f=yr(I,k+24|0)}if(i[e+108>>2]=f,f=i[k+28>>2],f&&(i[k+32>>2]=f,Z(f)),f=l[r+20|0],g=g+1|0,!!(!i[r+16>>2]||f&1|_>>>0<=g>>>0))break}if(f&1)break r;break e}G0(),H()}if(!(f&1))break e}if(u[k+24|0]=0,u[k+35|0]=0,K(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}i[k+116>>2]=0,i[k+88>>2]=72244,i[k+32>>2]=72224,e=i[18065],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18066],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+32>>2]=r,t=k+32|0,i[t+i[r-12>>2]>>2]=i[18068],r=i[18064],i[k+24>>2]=r,i[e+i[r-12>>2]>>2]=i[18069],i[k+88>>2]=72244,i[k+24>>2]=72204,i[k+32>>2]=72224,r=R0(n),i[r>>2]=71280,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(I0(Y(I0(Y(t,27798,40),_),27946,47),i[f+28>>2]),5081,6),e=i[k+84>>2];e:{r:{if(e&16){f=i[k+80>>2],e=i[k+60>>2],f>>>0<e>>>0&&(i[k+80>>2]=e,f=e),e=k+56|0;break r}if(!(e&8)){f=0,u[k+23|0]=0,e=k+12|0;break e}f=i[k+52>>2],e=k+44|0}r:{if(n=i[e>>2],f=f-n|0,f>>>0<2147483640){if(f>>>0>=11){t=f|7,e=E(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=f;break r}if(u[k+23|0]=f,e=k+12|0,f)break r;f=0;break e}g0(),H()}if(!f)break e;z(e,n,f)}u[e+f|0]=0,K(A,2,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18063],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18071],i[k+32>>2]=i[18072],i[r>>2]=71280,u[k+79|0]<0&&Z(i[k+68>>2]),y0(r),p0(k+88|0)}v=k+192|0}function Dv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;g=e+4|0,o=r<<2,N=Q[g+o>>1],s=e+2|0,h=Q[s+o>>1],m=e+6|0,_=Q[m+o>>1],f=r<<1,I=Q[f+g>>1],w=G(r,6),r=Q[w+g>>1],B=Q[e+o>>1],g=Q[g>>1],o=Q[w+m>>1],V=Q[f+m>>1],m=Q[m>>1],k=G(o,-74)+G(V+m|0,74)>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,y=Q[s+w>>1],R=Q[f+s>>1],s=Q[s>>1],n=G(y,-74)+G(R+s|0,74)>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,w=Q[e+w>>1],f=Q[e+f>>1],e=Q[e>>1],t=G(w,-74)+G(f+e|0,74)>>1,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,Q[A+10>>1]=(G(k,16777142)+G(n+t|0,74)|0)+128>>>8,W=G(r,-74)+G(g+I|0,74)>>1,W=(W|0)>=32767?32767:W,W=(W|0)<=-32768?-32768:W,C=G(W,74),Q[A+14>>1]=((C+(G(n,-84)+G(t,55)|0)|0)+G(k,16777187)|0)+128>>>8,Q[A+12>>1]=(((G(n,-29)+G(t,84)|0)+G(W,16777142)|0)+G(k,55)|0)+128>>>8,Q[A+8>>1]=((C+(G(n,55)+G(t,29)|0)|0)+G(k,84)|0)+128>>>8,W=G(_,74),k=((W+(G(V,-84)+G(m,55)|0)|0)+G(o,-29)|0)+1>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,C=G(h,74),n=((C+(G(R,-84)+G(s,55)|0)|0)+G(y,-29)|0)+1>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,D=G(B,74),t=((D+(G(f,-84)+G(e,55)|0)|0)+G(w,-29)|0)+1>>1,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,Q[A+26>>1]=(G(k,16777142)+G(n+t|0,74)|0)+128>>>8,_=(((G(V,-29)+G(m,84)|0)+G(_,-74)|0)+G(o,55)|0)+1>>1,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,h=(((G(R,-29)+G(s,84)|0)+G(h,-74)|0)+G(y,55)|0)+1>>1,h=(h|0)>=32767?32767:h,h=(h|0)<=-32768?-32768:h,B=(((G(f,-29)+G(e,84)|0)+G(B,-74)|0)+G(w,55)|0)+1>>1,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,Q[A+18>>1]=(G(_,16777142)+G(h+B|0,74)|0)+128>>>8,o=((W+(G(V,55)+G(m,29)|0)|0)+G(o,84)|0)+1>>1,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,s=((C+(G(R,55)+G(s,29)|0)|0)+G(y,84)|0)+1>>1,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,e=(((G(f,55)+G(e,29)|0)+D|0)+G(w,84)|0)+1>>1,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,Q[A+2>>1]=(G(o,16777142)+G(s+e|0,74)|0)+128>>>8,m=G(N,74),f=((m+(G(I,-84)+G(g,55)|0)|0)+G(r,-29)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,w=G(f,74),Q[A+30>>1]=((w+(G(n,-84)+G(t,55)|0)|0)+G(k,16777187)|0)+128>>>8,Q[A+28>>1]=(((G(n,-29)+G(t,84)|0)+G(f,16777142)|0)+G(k,55)|0)+128>>>8,Q[A+24>>1]=((w+(G(n,55)+G(t,29)|0)|0)+G(k,84)|0)+128>>>8,f=(((G(I,-29)+G(g,84)|0)+G(N,-74)|0)+G(r,55)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,w=G(f,74),Q[A+22>>1]=((w+(G(h,-84)+G(B,55)|0)|0)+G(_,16777187)|0)+128>>>8,Q[A+20>>1]=(((G(h,-29)+G(B,84)|0)+G(f,16777142)|0)+G(_,55)|0)+128>>>8,Q[A+16>>1]=((w+(G(h,55)+G(B,29)|0)|0)+G(_,84)|0)+128>>>8,r=((m+(G(I,55)+G(g,29)|0)|0)+G(r,84)|0)+1>>1,r=(r|0)>=32767?32767:r,r=(r|0)<=-32768?-32768:r,I=G(r,74),Q[A+6>>1]=((I+(G(s,-84)+G(e,55)|0)|0)+G(o,16777187)|0)+128>>>8,Q[A+4>>1]=(((G(s,-29)+G(e,84)|0)+G(r,16777142)|0)+G(o,55)|0)+128>>>8,Q[A>>1]=((I+(G(s,55)+G(e,29)|0)|0)+G(o,84)|0)+128>>>8}function Hv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;n=v-48|0,v=n,B=n+24|0,w=v-16|0,v=w,k=i[r+16>>2],o=k>>>0>=6?6:k,k=i[r+8>>2],k&&c1(k,o),t=i[r>>2],k=X[i[i[t>>2]+8>>2]](t)|0,h=l0,k=k+o|0,h=k>>>0<o>>>0?h+1|0:h,X[i[i[t>>2]+20>>2]](t,k,h)|0,i[r+16>>2]=i[r+16>>2]-o,m=e,W=o2(r),Q[m+100>>1]=W,m=e,W=o2(r),Q[m+102>>1]=W,k=i[r+16>>2],h=k>>>0>=2?2:k,k=i[r+8>>2],k&&c1(k,h),t=i[r>>2],k=X[i[i[t>>2]+8>>2]](t)|0,o=l0,k=k+h|0,o=k>>>0<h>>>0?o+1|0:o,X[i[i[t>>2]+20>>2]](t,k,o)|0,i[r+16>>2]=i[r+16>>2]-h,m=e,W=F0(r),i[m+104>>2]=W,m=e,W=F0(r),i[m+108>>2]=W,m=e,W=F0(r),i[m+112>>2]=W,m=e,W=o2(r),Q[m+116>>1]=W,m=e,W=o2(r),Q[m+118>>1]=W,m=e,W=F0(r),i[m+120>>2]=W,m=e,W=F0(r),i[m+124>>2]=W,k=i[r+16>>2],h=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,h),t=i[r>>2],k=X[i[i[t>>2]+8>>2]](t)|0,o=l0,k=k+h|0,o=k>>>0<h>>>0?o+1|0:o,X[i[i[t>>2]+20>>2]](t,k,o)|0,i[r+16>>2]=i[r+16>>2]-h,m=e,W=o2(r),Q[m+128>>1]=W,s=v-32|0,v=s,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;i:{if(!f4(r,32)){i[w+4>>2]=0,i[w+8>>2]=0,i[w+12>>2]=0;break i}k=i[r>>2],_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);e:{r:{f:{A:{k:{if(!(X[i[i[k>>2]+16>>2]](k,s+15|0,1)|0)||(t=l[s+15|0],t>>>0>=32))break k;if(t)break A;t=-1;break f}i[w+4>>2]=0,i[w+8>>2]=0,i[w+12>>2]=0;break e}for(o=0;;){if(!(X[i[i[k>>2]+16>>2]](k,s+14|0,1)|0))break r;if(oi(s+16|0,u[s+14|0]),o=o+1|0,t=l[s+15|0],!(o>>>0<t>>>0))break}t=t^-1}t=t+32|0,o=(X[i[i[k>>2]+8>>2]](k)|0)+t|0,h=l0+(t>>31)|0,X[i[i[k>>2]+20>>2]](k,o,o>>>0<t>>>0?h+1|0:h)|0,i[w+12>>2]=i[s+24>>2],k=i[s+20>>2],i[w+4>>2]=i[s+16>>2],i[w+8>>2]=k,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;break e}i8(r),i[w+12>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0}if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break i;X[i[i[_>>2]+8>>2]](_),p(_)}u[s+27|0]<0&&Z(i[s+16>>2]),v=s+32|0,u[e+143|0]<0&&Z(i[e+132>>2]),k=i[w+8>>2],i[e+132>>2]=i[w+4>>2],i[e+136>>2]=k,i[e+140>>2]=i[w+12>>2],m=e,W=o2(r),Q[m+144>>1]=W,m=e,W=wi(r),Q[m+146>>1]=W,k=i[26929],i[B>>2]=i[26928],i[B+4>>2]=k,B=B+8|0;i:{if(u[107731]>=0){k=i[26931],i[B>>2]=i[26930],i[B+4>>2]=k,i[B+8>>2]=i[26932];break i}T(B,i[26930],i[26931])}v=w+16|0;i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}if(d6(n,e,r,-1,f),r=i[n+4>>2],e=i[n>>2],i[n+24>>2]=e,i[n+28>>2]=r,u[n+43|0]<0&&(Z(i[n+32>>2]),e=i[n+24>>2]),r=i[n+12>>2],i[n+32>>2]=i[n+8>>2],i[n+36>>2]=r,i[n+40>>2]=i[n+16>>2],r=A+8|0,e){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+40>>2],A=i[n+36>>2],i[r>>2]=i[n+32>>2],i[r+4>>2]=A,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,u[107731]>=0){A=i[26931],i[r>>2]=i[26930],i[r+4>>2]=A,i[r+8>>2]=i[26932];break i}T(r,i[26930],i[26931])}u[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function xv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0;$=Q[e+10>>1],W=Q[e+26>>1],D=Q[e+18>>1],x=Q[e+2>>1],y=Q[e+14>>1],R=Q[e+12>>1],N=Q[e+8>>1],w=1<<r-1,n=1<<f,f=0-n|0,_=Q[e+22>>1],k=Q[e+6>>1],V=Q[e+30>>1],t=((G(_,-74)+G(k,74)|0)+G(V,74)|0)- -64>>7,h=n+65535|0,t=((f|0)>(t|0)?f:(n|0)>(t|0)?t:h)<<16>>16,B=Q[e+20>>1],S=Q[e+4>>1],O=Q[e+28>>1],o=((G(B,-74)+G(S,74)|0)+G(O,74)|0)- -64>>7,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:h)<<16>>16,L=Q[e+16>>1],a=Q[e>>1],e=Q[e+24>>1],s=((G(L,-74)+G(a,74)|0)+G(e,74)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:h)<<16>>16,i[A+40>>2]=w+(G(t,74)+(G(o,-74)+G(s,74)|0)|0)>>r,g=(((G(R,-74)+G(S,84)|0)+G(B,55)|0)+G(O,-29)|0)- -64>>7,g=((f|0)>(g|0)?f:(n|0)>(g|0)?g:h)<<16>>16,I=(((G(N,-74)+G(a,84)|0)+G(L,55)|0)+G(e,-29)|0)- -64>>7,I=((f|0)>(I|0)?f:(n|0)>(I|0)?I:h)<<16>>16,C=(((G(y,-74)+G(k,84)|0)+G(_,55)|0)+G(V,-29)|0)- -64>>7,C=((f|0)>(C|0)?f:(n|0)>(C|0)?C:h)<<16>>16,i[A+56>>2]=((G(g,-74)+G(I,74)|0)+G(C,74)|0)+w>>r,m=((G(D,-74)+G(x,74)|0)+G(W,74)|0)- -64>>7,m=((f|0)>(m|0)?f:(n|0)>(m|0)?m:h)<<16>>16,i[A+44>>2]=(((G(m,-74)+G(s,84)|0)+G(o,55)|0)+G(t,-29)|0)+w>>r,m=G(m,74),i[A+36>>2]=(((m+G(s,55)|0)+G(o,-29)|0)+G(t,-84)|0)+w>>r,i[A+32>>2]=(((m+G(s,29)|0)+G(o,84)|0)+G(t,55)|0)+w>>r,R=G(R,74),t=(((R+G(S,55)|0)+G(B,-29)|0)+G(O,-84)|0)- -64>>7,t=((f|0)>(t|0)?f:(n|0)>(t|0)?t:h)<<16>>16,N=G(N,74),o=(((N+G(a,55)|0)+G(L,-29)|0)+G(e,-84)|0)- -64>>7,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:h)<<16>>16,y=G(y,74),s=(((y+G(k,55)|0)+G(_,-29)|0)+G(V,-84)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:h)<<16>>16,i[A+24>>2]=((G(t,-74)+G(o,74)|0)+G(s,74)|0)+w>>r,B=(((R+G(S,29)|0)+G(B,84)|0)+G(O,55)|0)- -64>>7,B=((f|0)>(B|0)?f:(n|0)>(B|0)?B:h)<<16>>16,e=(((N+G(a,29)|0)+G(L,84)|0)+G(e,55)|0)- -64>>7,e=((e|0)<(f|0)?f:(e|0)<(n|0)?e:h)<<16>>16,_=(((y+G(k,29)|0)+G(_,84)|0)+G(V,55)|0)- -64>>7,_=((f|0)>(_|0)?f:(n|0)>(_|0)?_:h)<<16>>16,i[A+8>>2]=((G(B,-74)+G(e,74)|0)+G(_,74)|0)+w>>r,k=(((G($,-74)+G(x,84)|0)+G(D,55)|0)+G(W,-29)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:h)<<16>>16,i[A+60>>2]=(((G(k,-74)+G(I,84)|0)+G(g,55)|0)+G(C,-29)|0)+w>>r,k=G(k,74),i[A+52>>2]=(((k+G(I,55)|0)+G(g,-29)|0)+G(C,-84)|0)+w>>r,i[A+48>>2]=(((k+G(I,29)|0)+G(g,84)|0)+G(C,55)|0)+w>>r,V=G($,74),k=(((V+G(x,55)|0)+G(D,-29)|0)+G(W,-84)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:h)<<16>>16,i[A+28>>2]=(((G(k,-74)+G(o,84)|0)+G(t,55)|0)+G(s,-29)|0)+w>>r,k=G(k,74),i[A+20>>2]=(((k+G(o,55)|0)+G(t,-29)|0)+G(s,-84)|0)+w>>r,i[A+16>>2]=(((k+G(o,29)|0)+G(t,84)|0)+G(s,55)|0)+w>>r,W=(((V+G(x,29)|0)+G(D,84)|0)+G(W,55)|0)- -64>>7,f=((f|0)>(W|0)?f:(n|0)>(W|0)?W:h)<<16>>16,i[A+12>>2]=(((G(f,-74)+G(e,84)|0)+G(B,55)|0)+G(_,-29)|0)+w>>r,f=G(f,74),i[A+4>>2]=(((f+G(e,55)|0)+G(B,-29)|0)+G(_,-84)|0)+w>>r,i[A>>2]=(((f+G(e,29)|0)+G(B,84)|0)+G(_,55)|0)+w>>r}function ur(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=A+e|0,r=i[A+4>>2];i:{e:{if(r&1)break e;if(!(r&2))break i;r=i[A>>2],e=r+e|0;r:{f:{A:{if(A=A-r|0,(A|0)!=i[31655]){if(f=i[A+12>>2],r>>>0<=255){if(k=i[A+8>>2],(k|0)!=(f|0))break A;w=126600,h=i[31650]&k2(-2,r>>>3|0),i[w>>2]=h;break e}if(t=i[A+24>>2],(A|0)!=(f|0)){r=i[A+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break r}if(k=i[A+20>>2],k)r=A+20|0;else{if(k=i[A+16>>2],!k)break f;r=A+16|0}for(;o=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[o>>2]=0;break r}if(r=i[n+4>>2],(r&3)!=3)break e;i[31652]=e,i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[n>>2]=e;return}i[k+12>>2]=f,i[f+8>>2]=k;break e}f=0}if(!t)break e;r=i[A+28>>2],k=(r<<2)+126904|0;r:{if(i[k>>2]==(A|0)){if(i[k>>2]=f,f)break r;w=126604,h=i[31651]&k2(-2,r),i[w>>2]=h;break e}f:{if(i[t+16>>2]==(A|0)){i[t+16>>2]=f;break f}i[t+20>>2]=f}if(!f)break e}if(i[f+24>>2]=t,r=i[A+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[A+20>>2],!r)break e;i[f+20>>2]=r,i[r+24>>2]=f}e:{r:{f:{A:{if(r=i[n+4>>2],!(r&2)){if(i[31656]==(n|0)){if(i[31656]=A,e=i[31653]+e|0,i[31653]=e,i[A+4>>2]=e|1,i[31655]!=(A|0))break i;i[31652]=0,i[31655]=0;return}if(s=i[31655],(s|0)==(n|0)){i[31655]=A,e=i[31652]+e|0,i[31652]=e,i[A+4>>2]=e|1,i[A+e>>2]=e;return}if(e=(r&-8)+e|0,f=i[n+12>>2],r>>>0<=255){if(k=i[n+8>>2],(k|0)==(f|0)){w=126600,h=i[31650]&k2(-2,r>>>3|0),i[w>>2]=h;break r}i[k+12>>2]=f,i[f+8>>2]=k;break r}if(t=i[n+24>>2],(f|0)!=(n|0)){r=i[n+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break f}if(k=i[n+20>>2],k)r=n+20|0;else{if(k=i[n+16>>2],!k)break A;r=n+16|0}for(;o=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[o>>2]=0;break f}i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[A+e>>2]=e;break e}f=0}if(!t)break r;r=i[n+28>>2],k=(r<<2)+126904|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=f,f)break f;w=126604,h=i[31651]&k2(-2,r),i[w>>2]=h;break r}A:{if(i[t+16>>2]==(n|0)){i[t+16>>2]=f;break A}i[t+20>>2]=f}if(!f)break r}if(i[f+24>>2]=t,r=i[n+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[n+20>>2],!r)break r;i[f+20>>2]=r,i[r+24>>2]=f}if(i[A+4>>2]=e|1,i[A+e>>2]=e,(A|0)!=(s|0))break e;i[31652]=e;return}if(e>>>0<=255){r=(e&-8)+126640|0,f=i[31650],e=1<<(e>>>3);e:{if(!(f&e)){i[31650]=e|f,e=r;break e}e=i[r+8>>2]}i[r+8>>2]=A,i[e+12>>2]=A,i[A+12>>2]=r,i[A+8>>2]=e;return}f=31,e>>>0<=16777215&&(r=k1(e>>>8|0),f=((e>>>38-r&1)-(r<<1)|0)+62|0),i[A+28>>2]=f,i[A+16>>2]=0,i[A+20>>2]=0,r=(f<<2)+126904|0;e:{k=i[31651],o=1<<f;r:{if(!(k&o)){i[31651]=k|o,i[r>>2]=A,i[A+24>>2]=r;break r}for(f=e<<((f|0)!=31?25-(f>>>1|0)|0:0),r=i[r>>2];;){if(k=r,(i[r+4>>2]&-8)==(e|0))break e;if(r=f>>>29|0,f=f<<1,o=k+(r&4)|0,r=i[o+16>>2],!r)break}i[o+16>>2]=A,i[A+24>>2]=k}i[A+12>>2]=A,i[A+8>>2]=A;return}e=i[k+8>>2],i[e+12>>2]=A,i[k+8>>2]=A,i[A+24>>2]=0,i[A+12>>2]=k,i[A+8>>2]=e}}function I9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=i[r>>2],s=i[t+116>>2],_=i[t+120>>2],i[e+120>>2]=_,i[e+116>>2]=s,i[e+112>>2]=k,i[e+108>>2]=f;i:{e:{r:{f:switch(s|0){case 2:h=255,o=i[t+128>>2];A:{if(!o)break A;for(w=t+128|0,t=w;s=i[o+16>>2],t=(s|0)<0?t:o,o=i[(s>>>29&4)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>0)break A;h=l[t+24|0]}if(T0(A,e,0,f,k,h,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e;case 0:h=255,o=i[t+128>>2];A:{if(!o)break A;for(w=t+128|0,t=w;s=i[o+16>>2],t=(s|0)<0?t:o,o=i[(s>>>29&4)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>0)break A;h=l[t+24|0]}if(T0(A,e,0,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=(_|0)==1?k+1>>>1|0:k,_=_-1>>>0<2?f+1>>>1|0:f,B=255,s=i[r>>2],o=i[s+128>>2];A:{if(!o)break A;for(w=s+128|0,t=w;s=i[o+16>>2]<=0,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>1)break A;B=l[t+24|0]}if(T0(A,e,1,_,h,B,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),B=255,s=i[r>>2],o=i[s+128>>2];A:{if(!o)break A;for(w=s+128|0,t=w;s=i[o+16>>2]<2,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>2)break A;B=l[t+24|0]}if(T0(A,e,2,_,h,B,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e;case 1:break f;default:break e}if(s=t+128|0,o=i[t+128>>2],(_|0)==3){h=255;f:{if(!o)break f;for(t=s;w=i[o+16>>2]<3,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>3)break f;h=l[t+24|0]}if(T0(A,e,3,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=255,s=i[r>>2],o=i[s+128>>2];f:{if(!o)break f;for(w=s+128|0,t=w;s=i[o+16>>2]<4,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>4)break f;h=l[t+24|0]}if(T0(A,e,4,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=255,s=i[r>>2],o=i[s+128>>2];f:{if(!o)break f;for(w=s+128|0,t=w;s=i[o+16>>2]<5,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>5)break f;h=l[t+24|0]}if(T0(A,e,5,f,k,h,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e}h=255;f:{if(!o)break f;for(t=s;w=i[o+16>>2]<10,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>10)break f;h=l[t+24|0]}if(T0(A,e,10,f,k,h,n),i[A>>2])break i;if(u[A+19|0]>=0)break e}Z(i[A+8>>2])}s=i[r>>2],r=i[s+128>>2];e:{if(!r)break e;for(s=s+128|0,t=s,o=r;w=i[o+16>>2]<6,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>6)break e;for(o=s;t=i[r+16>>2]<6,o=t?o:r,r=i[(t?4:0)+r>>2],!!r;);if(t=255,T0(A,e,6,f,k,(o|0)==(s|0)|i[o+16>>2]>6?t:l[o+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];return}T(e,i[26930],i[26931])}}function zv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72548,k=i[18140],i[f+24>>2]=k,n=i[k-12>>2],k=f+24|0,i[n+k>>2]=i[18141],s=k+i[i[f+24>>2]-12>>2]|0,n=f+28|0,J0(s,n),u[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=72548,i[f+24>>2]=72528,s=R0(n),i[s>>2]=71280,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,Y2(n,e,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(I0(Y(f+24|0,32548,9),i[e+104>>2]),42713,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(I0(Y(k,29419,23),F[e+108>>1]),42713,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(k,31685,11),n=f+12|0,P1(n,i[e+112>>2]),t=k,o=n,k=u[f+23|0],n=(k|0)<0,k=Y(Y(t,n?i[f+12>>2]:o,n?i[f+16>>2]:k),42713,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(k,31892,11),k=u[e+127|0],n=(k|0)<0,Y(Y(t,n?i[e+116>>2]:e+116|0,n?i[e+120>>2]:k),42713,1),u[f+23|0]<0&&Z(i[f+12>>2]),k=i[e+112>>2],(k|0)==1835625829&&(k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(f+24|0,31590,14),k=u[e+139|0],n=(k|0)<0,k=Y(Y(t,n?i[e+128>>2]:e+128|0,n?i[e+132>>2]:k),42713,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(k,31089,18),k=u[e+151|0],n=(k|0)<0,Y(Y(t,n?i[e+140>>2]:e+140|0,n?i[e+144>>2]:k),42713,1),k=i[e+112>>2]),(k|0)==1970432288&&(k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(f+24|0,31793,15),k=u[e+163|0],n=(k|0)<0,Y(Y(t,n?i[e+152>>2]:e+152|0,n?i[e+156>>2]:k),42713,1)),k=f+164|0,s0(k,r),n=k,r=u[f+175|0],k=(r|0)<0,Y(f+24|0,k?i[f+164>>2]:n,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),r=Y(f+24|0,30829,13),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]|1,Y(li(r,l[e+164|0]),42713,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18142],i[s>>2]=71280,u[f+71|0]<0&&Z(i[f+60>>2]),y0(s),p0(f+80|0),v=f+176|0}function Tv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;f=v-32|0,v=f,h=f+12|0,_=i[e>>2],s=v-32|0,v=s,n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94472,m=_,W=Zr(n+12|0),i[m+48>>2]=W,k=i[_+52>>2],i[_+52>>2]=n;i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;X[i[i[k>>2]+8>>2]](k),p(k)}w=i[_+48>>2],i[w+156>>2]=_- -64,n=v-176|0,v=n,k=E(192),i[k+108>>2]=72728,i[k+136>>2]=0,o=i[18185],i[k>>2]=o,i[k+i[o-12>>2]>>2]=i[18186],i[k+4>>2]=0,o=k+i[i[k>>2]-12>>2]|0,t=k+8|0,J0(o,t),u[o+80|0]=0,i[o+72>>2]=0,i[k+108>>2]=72728,i[k>>2]=72708,p9(Ot(t),r,12)||(r=k+i[i[k>>2]-12>>2]|0,H1(r,i[r+16>>2]|4)),o=s+8|0,i[n+172>>2]=k;i:{e:{r:{f:{if(i[(k+i[i[k>>2]-12>>2]|0)+16>>2]){i[n+116>>2]=0,i[n+88>>2]=72244,i[n+32>>2]=72224,r=i[18065],i[n+24>>2]=r,k=i[r-12>>2],r=n+24|0,i[k+r>>2]=i[18066],i[n+28>>2]=0,k=r+i[i[n+24>>2]-12>>2]|0,t=n+36|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[n+32>>2]=k,w=i[k-12>>2],k=n+32|0,i[w+k>>2]=i[18068],w=i[18064],i[n+24>>2]=w,i[r+i[w-12>>2]>>2]=i[18069],i[n+88>>2]=72244,i[n+24>>2]=72204,i[n+32>>2]=72224,t=R0(t),i[t>>2]=71280,i[n+76>>2]=0,i[n+80>>2]=0,i[n+68>>2]=0,i[n+72>>2]=0,i[n+84>>2]=24,k=Y(k,31936,20),r=i[31336],r=F[((r>>>0<=153?r:0)<<1)+69536>>1]+67608|0,Y(S0(Y(Y(k,r,h2(r)),27190,2),i[31336]),42712,2),r=i[n+84>>2];A:{if(r&16){r=i[n+80>>2],k=i[n+60>>2],r>>>0<k>>>0&&(i[n+80>>2]=k,r=k),k=n+56|0;break A}if(!(r&8)){r=0,u[n+23|0]=0,k=n+12|0;break e}r=i[n+52>>2],k=n+44|0}if(w=i[k>>2],r=r-w|0,r>>>0>=2147483640)break f;if(r>>>0>=11){B=r|7,k=E(B+1|0),i[n+20>>2]=B-2147483647,i[n+12>>2]=k,i[n+16>>2]=r;break r}if(u[n+23|0]=r,k=n+12|0,r)break r;r=0;break e}r=E(56),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95032,k=v-16|0,v=k,B=r+16|0,i[B>>2]=86360,i[r+20>>2]=0,i[r+24>>2]=0,i[r+36>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+16>>2]=86184,t=i[n+172>>2],i[n+172>>2]=0,i[r+40>>2]=t,RA(t,0,0,2),$u(k,i[r+40>>2]),t=i[k+12>>2],i[r+48>>2]=i[k+8>>2],i[r+52>>2]=t,RA(i[r+40>>2],0,0,0),v=k+16|0,i[n+28>>2]=r,i[n+24>>2]=B,i[r+4>>2]=i[r+4>>2]+1,wf(o,w,n+24|0),k=i[n+28>>2];A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;X[i[i[r>>2]+8>>2]](r),p(r);break i}g0(),H()}if(!r)break e;z(k,w,r)}u[r+k|0]=0,K(o,1,0,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),r=i[18063],i[n+24>>2]=r,i[i[r-12>>2]+(n+24|0)>>2]=i[18071],i[n+32>>2]=i[18072],i[t>>2]=71280,u[n+79|0]<0&&Z(i[n+68>>2]),y0(t),p0(n+88|0)}r=i[n+172>>2],i[n+172>>2]=0,r&&X[i[i[r>>2]+4>>2]](r),v=n+176|0;i:{if(i[s+8>>2]){r=i[s+12>>2],i[h>>2]=i[s+8>>2],i[h+4>>2]=r,r=i[s+20>>2],i[h+8>>2]=i[s+16>>2],i[h+12>>2]=r,i[h+16>>2]=i[s+24>>2];break i}if(sf(h,_),u[s+27|0]>=0)break i;Z(i[s+16>>2])}v=s+32|0,b0(A,h,i[e>>2]),u[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function Sv(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;t=v-48|0,v=t;i:{if(f){f=v-96|0,v=f,L9(f+24|0,e,k,n);e:{r:switch(l[f+72|0]){default:_2(),H();case 1:e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[f+43|0]>=0){r=i[f+36>>2],i[e>>2]=i[f+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+40>>2];break f}T(e,i[f+32>>2],i[f+36>>2])}u[A+20|0]=1;break e;case 0:break r}k=i[e+552>>2],i[f+16>>2]=i[f- -64>>2],n=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=n,n=i[f+52>>2],i[f>>2]=i[f+48>>2],i[f+4>>2]=n,o=i[f+28>>2],i[f+28>>2]=0,n=i[f+24>>2],i[f+24>>2]=0,s=i[f+36>>2],w=i[f+40>>2],i[f+36>>2]=0,i[f+40>>2]=0,h=i[f+44>>2],i[f+44>>2]=0,_=l[f+32|0],i[k+8>>2]=n,n=i[k+12>>2],i[k+12>>2]=o;r:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break r;X[i[i[n>>2]+8>>2]](n),p(n)}u[k+16|0]=_,n=i[k+20>>2],n&&(i[k+24>>2]=n,Z(n)),i[k+28>>2]=h,i[k+24>>2]=w,i[k+20>>2]=s,n=i[f+4>>2],i[k+32>>2]=i[f>>2],i[k+36>>2]=n,n=i[f+12>>2],i[k+40>>2]=i[f+8>>2],i[k+44>>2]=n,i[k+48>>2]=i[f+16>>2],k=A,A=i[e+552>>2],X[i[i[A>>2]+28>>2]](k,A,r,i[e+100>>2]- -64|0)}A=l[f+72|0],(A|0)!=255&&(e=i[25483],i[f+88>>2]=i[25482],i[f+92>>2]=e,X[i[(f+88|0)+(A<<2)>>2]](f+87|0,f+24|0)),v=f+96|0;break i}e=E(48),i[t+12>>2]=e,i[t+16>>2]=41,i[t+20>>2]=-2147483600,u[e+40|0]=l[13186],r=l[13182]|l[13183]<<8|(l[13184]<<16|l[13185]<<24),f=l[13178]|l[13179]<<8|(l[13180]<<16|l[13181]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[13174]|l[13175]<<8|(l[13176]<<16|l[13177]<<24),f=l[13170]|l[13171]<<8|(l[13172]<<16|l[13173]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[13166]|l[13167]<<8|(l[13168]<<16|l[13169]<<24),f=l[13162]|l[13163]<<8|(l[13164]<<16|l[13165]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13158]|l[13159]<<8|(l[13160]<<16|l[13161]<<24),f=l[13154]|l[13155]<<8|(l[13156]<<16|l[13157]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[13150]|l[13151]<<8|(l[13152]<<16|l[13153]<<24),f=l[13146]|l[13147]<<8|(l[13148]<<16|l[13149]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+41|0]=0,e=K(t+24|0,4,0,t+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[t+23|0]>=0)break i;Z(i[t+12>>2])}v=t+48|0}function C9(A,e,r,f,k){var n=0,t=0,o=0,s=0;n=v-160|0,v=n;i:{e:{r:{f:{A:{k:{n:{if(t=i[f>>2],f=i[t+104>>2],t=i[t+108>>2],(f|0)!=(t|0))for(;;){if(i[f>>2]==(r|0))break n;if(f=f+16|0,(t|0)==(f|0))break}i[n+104>>2]=0,i[n+76>>2]=72244,i[n+20>>2]=72224,e=i[18065],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[18066],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[n+20>>2]=f,t=i[f-12>>2],f=n+20|0,i[t+f>>2]=i[18068],t=i[18064],i[n+12>>2]=t,i[e+i[t-12>>2]>>2]=i[18069],i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,k=R0(k),i[k>>2]=71280,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y(I0(Y(f,21019,9),r),2459,46),e=i[n+72>>2];t:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break t}if(!(e&8)){f=0,u[n+11|0]=0,r=n;break e}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){t=f|7,r=E(t+1|0),i[n+8>>2]=t-2147483647,i[n>>2]=r,i[n+4>>2]=f;break r}if(u[n+11|0]=f,r=n,f)break r;f=0;break e}if(t=i[f+4>>2],o=i[f+8>>2],(t|0)!=(o|0))for(;;){if(f=F[t+2>>1],s=i[e+36>>2],f>>>0>i[e+40>>2]-s>>3>>>0){i[n+104>>2]=0,i[n+76>>2]=72244,i[n+20>>2]=72224,e=i[18065],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[18066],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[n+20>>2]=f,o=i[f-12>>2],f=n+20|0,i[o+f>>2]=i[18068],o=i[18064],i[n+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[n+76>>2]=72244,i[n+12>>2]=72204,i[n+20>>2]=72224,k=R0(k),i[k>>2]=71280,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y(I0(Y(Y(I0(Y(f,20891,28),F[t+2>>1]),28345,11),21039,4),r),2506,23),e=i[n+72>>2];n:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break n}if(!(e&8)){f=0,u[n+11|0]=0,r=n;break f}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){t=f|7,r=E(t+1|0),i[n+8>>2]=t-2147483647,i[n>>2]=r,i[n+4>>2]=f;break A}if(u[n+11|0]=f,r=n,f)break A;f=0;break f}if(f&&r2(k,((f<<3)+s|0)-8|0),t=t+4|0,(o|0)==(t|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!f)break f;z(r,e,f)}u[r+f|0]=0,K(A,2,115,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18063],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18071],i[n+20>>2]=i[18072],i[k>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(k),p0(n+76|0);break i}if(!f)break e;z(r,e,f)}u[r+f|0]=0,K(A,2,116,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18063],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18071],i[n+20>>2]=i[18072],i[k>>2]=71280,u[n+67|0]<0&&Z(i[n+56>>2]),y0(k),p0(n+76|0)}v=n+160|0}function jv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;g=v-80|0,v=g;i:{if(!(f&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(h=g+8|0,w=i[e>>2],X[i[i[w>>2]+108>>2]](h,w),z(f,h,72),r){t=f,f=0,n=v-48|0,v=n,bi(n+16|0,i[e>>2]);e:{r:switch(l[n+36|0]){default:_2(),H();case 1:if(r=i[n+20>>2],i[h>>2]=i[n+16>>2],i[h+4>>2]=r,r=h+8|0,u[n+35|0]>=0){f=i[n+28>>2],i[r>>2]=i[n+24>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+32>>2];break e}T(r,i[n+24>>2],i[n+28>>2]);break e;case 0:break r}w=i[t+12>>2],r=0;r:{if(!w||(s=i[t+16>>2],r=0,!s))break r;f=u0[t+20>>2]%(w>>>0)|0,r=u0[t+24>>2]%(s>>>0)|0}if(w=0,_=i[n+16>>2],I=i[n+20>>2],(_|0)!=(I|0))for(;;){s=r,B=f,k=m,o=i[_>>2];r:{if(!o)break r;if(W=X0(o,86628,87940),W){o=i[_+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);f:{A:{k:{r=i[W+100>>2],f=(r|0)==270;n:{if(!f){if((r|0)==180)break n;if((r|0)!=90)break A}if(V=t,y=Jk(i[t+12>>2],i[t+16>>2]),i[V+12>>2]=y,i[t+16>>2]=l0,V=t,y=Jk(i[t+20>>2],i[t+24>>2]),i[V+20>>2]=y,i[t+24>>2]=l0,V=t,y=Jk(i[t+4>>2],i[t+8>>2]),i[V+4>>2]=y,i[t+8>>2]=l0,(r|0)==90){r=w,f=s,m=B,w=k;break f}if(f)break k;if((r|0)!=180)break A}r=k,f=w,m=s,w=B;break f}r=B,f=k,m=w,w=s;break f}r=s,f=B,m=k}f:{if(!o||(s=i[o+4>>2],i[o+4>>2]=s-1,s))break f;X[i[i[o>>2]+8>>2]](o),p(o)}if(o=i[_>>2],!o)break r}o=X0(o,86628,88020);f:{if(!o){s=f,B=r;break f}k=i[_+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),B=r,s=f;A:{k:switch(i[o+100>>2]){case 1:s=w,w=f;break A;case 0:break k;default:break A}B=m,m=r}if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;X[i[i[k>>2]+8>>2]](k),p(k)}f:{if(r=i[_>>2],!r||(r=X0(r,86628,88100),!r))break f;k=i[_+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),f=$i(r,i[t+20>>2]),o=bf(r,i[t+20>>2]),W=Ki(r,i[t+24>>2]),r=iA(r,i[t+24>>2]);A:{if(C=(f|0)>0?f:0,f=i[t+20>>2],f=f>>>0>o>>>0?o:f-1|0,(C|0)<=(f|0)&&(o=(W|0)>0?W:0,W=i[t+24>>2],r=r>>>0<W>>>0?r:W-1|0,(o|0)<=(r|0)))break A;if(u[n|0]=0,u[n+11|0]=0,K(h,2,120,n),u[n+11|0]<0&&Z(i[n>>2]),!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break e;X[i[i[k>>2]+8>>2]](k),p(k);break e}if(r=r+B|0,m=o+m|0,f=f+s|0,w=w+C|0,!k||(s=i[k+4>>2],i[k+4>>2]=s-1,s))break r;X[i[i[k>>2]+8>>2]](k),p(k);break r}f=s,r=B}if(_=_+8|0,(I|0)==(_|0))break}if(i[t+28>>2]=m,i[t+32>>2]=w,r=i[26929],i[h>>2]=i[26928],i[h+4>>2]=r,r=h+8|0,u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break e}T(r,i[26930],i[26931])}if(r=l[n+36|0],(r|0)!=255&&(f=i[25191],i[n>>2]=i[25190],i[n+4>>2]=f,X[i[n+(r<<2)>>2]](n+47|0,n+16|0)),v=n+48|0,r=i[g+8>>2],r&&b0(A,h,i[e+8>>2]),u[g+27|0]<0&&Z(i[g+16>>2]),r)break i}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}v=g+80|0}function V9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;o=v-48|0,v=o,t=i[e+124>>2],I=e+128|0;i:{if((t|0)!=(I|0))for(C=A+8|0,V=e+136|0;;){LA(r,f,i[t+16>>2],i[e+120>>2],o+44|0,o+40|0),h=i[t+16>>2];e:{if((h|0)==10){if(_=31,s=i[e+120>>2]-10|0,s>>>0>=6)break e;s=s<<3,n=s&31,(s&63)>>>0>=32?_=2054>>>n|0:_=((1<<n)-1&2054)<<32-n|134611971>>>n;break e}if(_=0,n=I,s=i[n>>2],!s)break e;for(;w=(h|0)>i[s+16>>2],n=w?n:s,s=i[(w?4:0)+s>>2],!!s;);if((n|0)==(I|0)|(h|0)<i[n+16>>2])break e;_=(l[n+24|0]+7&248)>>>3|0}s=i[t+32>>2],g=i[t+28>>2],m=_&255;e:{r:{f:{A:{if(h=i[o+44>>2],w=i[o+40>>2],!(h>>>0<=u0[t+36>>2]&w>>>0<=u0[t+40>>2])){Q[o+4>>1]=256,i[o>>2]=1,i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,W=i[t+20>>2],B=l[t+24|0],n=1;k:{n:switch(i[e+120>>2]){case 10:case 12:case 14:n=3;break k;case 11:case 13:case 15:n=4;break k;case 0:case 1:case 2:case 3:case 99:break k;default:break n}n=0}if(kr(A,o,h,w,W,B,n,k,V),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),B=i[o+24>>2],!B)break A;if(i[t+32>>2])for(n=0,h=i[o+36>>2];w=G(m,i[t+28>>2]),w&&z(B+G(n,h)|0,i[t+44>>2]+G(i[t+56>>2],n)|0,w),n=n+1|0,n>>>0<u0[t+32>>2];);n=i[t+48>>2],n&&Z(n),n=i[o+4>>2],i[t+20>>2]=i[o>>2],i[t+24>>2]=n,n=i[o+36>>2],i[t+52>>2]=i[o+32>>2],i[t+56>>2]=n,n=i[o+28>>2],i[t+44>>2]=i[o+24>>2],i[t+48>>2]=n,n=i[o+20>>2],i[t+36>>2]=i[o+16>>2],i[t+40>>2]=n,n=i[o+12>>2],i[t+28>>2]=i[o+8>>2],i[t+32>>2]=n}W=0,(m|0)==1&&(W=i[t+16>>2]-1>>>0<2?-128:0);k:{if(!s|(g|0)==i[o+44>>2])break k;if(B=G(m,g),n=0,(s|0)!=1)for(h=s&-2,_=0;w=G(m,i[o+44>>2]-g|0),w&&o0(B+(i[t+44>>2]+G(i[t+56>>2],n)|0)|0,W,w),w=G(m,i[o+44>>2]-g|0),w&&o0(B+(i[t+44>>2]+G(i[t+56>>2],n|1)|0)|0,W,w),n=n+2|0,_=_+2|0,(h|0)!=(_|0););if(!(s&1)||(w=G(m,i[o+44>>2]-g|0),!w))break k;o0(B+(i[t+44>>2]+G(i[t+56>>2],n)|0)|0,W,w)}if(n=i[o+40>>2],s>>>0<n>>>0)break f;break e}if(e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,u[107751]<0)break r;A=i[26936],i[C>>2]=i[26935],i[C+4>>2]=A,i[C+8>>2]=i[26937];break i}for(;n=G(m,i[o+44>>2]),n&&o0(i[t+44>>2]+G(i[t+56>>2],s)|0,W,n),n=i[o+40>>2],s=s+1|0,n>>>0>s>>>0;);break e}T(C,i[26935],i[26936]);break i}s=i[o+44>>2],i[t+32>>2]=n,i[t+28>>2]=s,n=i[t+4>>2];e:{if(n){for(;;)if(s=n,n=i[n>>2],!n)break e}for(;s=i[t+8>>2],n=i[s>>2]!=(t|0),t=s,!!n;);}if(t=s,(I|0)==(t|0))break}if(i[e+112>>2]=f,i[e+108>>2]=r,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931])}v=o+48|0}function Ov(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=E(56),i[n+4>>2]=e,i[n+8>>2]=54,i[n+12>>2]=-2147483592,r=l[9010]|l[9011]<<8|(l[9012]<<16|l[9013]<<24),f=l[9006]|l[9007]<<8|(l[9008]<<16|l[9009]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[9056]|l[9057]<<8|(l[9058]<<16|l[9059]<<24),f=l[9052]|l[9053]<<8|(l[9054]<<16|l[9055]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[9050]|l[9051]<<8|(l[9052]<<16|l[9053]<<24),f=l[9046]|l[9047]<<8|(l[9048]<<16|l[9049]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[9042]|l[9043]<<8|(l[9044]<<16|l[9045]<<24),f=l[9038]|l[9039]<<8|(l[9040]<<16|l[9041]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9034]|l[9035]<<8|(l[9036]<<16|l[9037]<<24),f=l[9030]|l[9031]<<8|(l[9032]<<16|l[9033]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9026]|l[9027]<<8|(l[9028]<<16|l[9029]<<24),f=l[9022]|l[9023]<<8|(l[9024]<<16|l[9025]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9018]|l[9019]<<8|(l[9020]<<16|l[9021]<<24),f=l[9014]|l[9015]<<8|(l[9016]<<16|l[9017]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+16|0}function or(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-32|0,v=t;i:{e=i[A+16>>2];e:{if(e>>>0>=1024){i[A+16>>2]=e-1024,e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&z(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,o=E(k),w=k+o|0,k=o+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=w,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=o,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(e=i[A+8>>2],f=i[A+4>>2],n=e-f|0,r=i[A+12>>2],k=i[A>>2],o=r-k|0,n>>>0<o>>>0){if((e|0)!=(r|0)){h=t,_=E(4096),i[h+12>>2]=_;r:{f:{r=i[A+8>>2];A:{if((r|0)!=i[A+12>>2]){f=r;break A}if(e=i[A+4>>2],n=i[A>>2],e>>>0>n>>>0){f=r-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(r|0)&&(f&&z(k,e,f),e=i[A+4>>2]),i[A+4>>2]=e+n,f=f+k|0;break A}if(f=(r|0)==(n|0)?1:r-n>>1,f>>>0>=1073741824)break f;if(k=f<<2,o=E(k),s=k+o|0,k=o+(f&-4)|0,f=k,(e|0)!=(r|0))for(f=(r-e|0)+f|0,r=k;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,(r|0)!=(f|0););if(i[A+12>>2]=s,i[A+8>>2]=f,i[A+4>>2]=k,i[A>>2]=o,!n)break A;Z(n),f=i[A+8>>2]}i[f>>2]=i[t+12>>2],i[A+8>>2]=f+4;break r}x0(),H()}break e}h=t,_=E(4096),i[h+12>>2]=_,Qt(A,t+12|0),e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&z(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,o=E(k),w=k+o|0,k=o+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=w,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=o,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(i[t+28>>2]=A+12,r=(r|0)==(k|0)?1:o>>1,r>>>0>=1073741824)break i;s=r<<2,k=E(s),i[t+12>>2]=k,o=k+s|0,i[t+24>>2]=o,r=k+n|0,i[t+16>>2]=r,w=E(4096);r:{if((n|0)!=(s|0))break r;if((e|0)!=(f|0)){r=(((n>>2)+1|0)/-2<<2)+r|0,i[t+16>>2]=r;break r}r=E(4),i[t+16>>2]=r,i[t+12>>2]=r,o=r+4|0,i[t+24>>2]=o,Z(k),f=i[A+4>>2],e=i[A+8>>2],k=r}if(i[r>>2]=w,s=r+4|0,i[t+20>>2]=s,(e|0)!=(f|0)){for(;e=e-4|0,Qt(t+12|0,e),f=i[A+4>>2],(e|0)!=(f|0););o=i[t+24>>2],s=i[t+20>>2],k=i[t+12>>2],r=i[t+16>>2],e=i[A+8>>2]}if(n=i[A>>2],i[A>>2]=k,i[t+12>>2]=n,i[A+4>>2]=r,i[t+16>>2]=f,i[A+8>>2]=s,i[t+20>>2]=e,r=i[A+12>>2],i[A+12>>2]=o,i[t+24>>2]=r,(e|0)!=(f|0)&&(i[t+20>>2]=((f-e|0)+3&-4)+e),!n)break e;Z(n)}v=t+32|0;return}x0(),H()}function F9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;_=v-16|0,v=_,h=i[r>>2],f=(f|0)==99?i[h+116>>2]:f,t=i[h+116>>2],C=t,g=i[h+120>>2];i:{e:switch(t|0){case 2:if(B=255,s=i[h+128>>2],!s)break i;for(o=h+128|0,t=o;w=i[s+16>>2],t=(w|0)<0?t:s,s=i[(w>>>29&4)+s>>2],!!s;);if((t|0)==(o|0)|i[t+16>>2]>0)break i;B=l[t+24|0];break i;case 0:B=255,W=255,s=i[h+128>>2],o=255;r:{if(!s)break r;for(w=h+128|0,o=w,t=s;m=i[t+16>>2],o=(m|0)<0?o:t,t=i[(m>>>29&4)+t>>2],!!t;);for(W=(o|0)==(w|0)|i[o+16>>2]>0?W:l[o+24|0],o=w,t=s;m=i[t+16>>2]<=0,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(B=(o|0)==(w|0)|i[o+16>>2]>1?B:l[o+24|0],t=w;o=i[s+16>>2]<2,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>2)break r;o=l[t+24|0]}w=B&255,t=o&255,t=t>>>0<w>>>0?w:t,B=t>>>0<W>>>0?W:t;break i;case 1:break e;default:break i}if(w=h+128|0,s=i[h+128>>2],i[h+120>>2]==3){B=255,W=255,o=255;e:{if(!s)break e;for(o=w,t=s;m=i[t+16>>2]<3,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(W=(o|0)==(w|0)|i[o+16>>2]>3?W:l[o+24|0],o=w,t=s;m=i[t+16>>2]<4,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(B=(o|0)==(w|0)|i[o+16>>2]>4?B:l[o+24|0],t=w;o=i[s+16>>2]<5,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>5)break e;o=l[t+24|0]}w=B&255,t=o&255,t=t>>>0<w>>>0?w:t,B=t>>>0<W>>>0?W:t;break i}if(B=255,!s)break i;for(t=w;o=i[s+16>>2]<10,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if((t|0)==(w|0)|i[t+16>>2]>10)break i;B=l[t+24|0]}m=l[n+20|0],s=_+8|0;i:{e:{if(!(F[h+6>>1]!=2|F[h+8>>1]!=2|F[h+10>>1]!=2)&&l[h+12|0])break e;w=F[h+10>>1]|F[h+12>>1]<<16,t=F[h+6>>1]|F[h+8>>1]<<16,Q[s>>1]=t,Q[s+2>>1]=t>>>16,Q[s+4>>1]=w,Q[s+6>>1]=w>>>16;break i}u[s+6|0]=1,Q[s+4>>1]=2,Q[s>>1]=2,Q[s+2>>1]=2,u[s+6|0]=1,Q[s+4>>1]=6,Q[s>>1]=1,Q[s+2>>1]=13}t=i[_+8>>2],w=i[_+12>>2],o=i[n+56>>2],o||(o=B3(),I=o);i:{if(!(i[o+4>>2]!=(t&65535)|i[o+8>>2]!=(t>>>16|0)|i[o+12>>2]!=(w&65535))&&(t=0,l[o+16|0]==(w>>>16&255)))break i;t=1}I&&z2(I);i:{e:{r:{f:{if(w=(m|0)!=0&(B&255)>>>0>8,s=(k|0)==99?g:k,!((t|(w|((s|0)!=(g|0)|(f|0)!=(C|0))))&1)&&(!SA(h)||(k=i[n+48>>2],!k|!i[k+4>>2])))break f;if(u[_+6|0]=1,Q[_+4>>1]=2,Q[_>>1]=2,Q[_+2>>1]=2,k=i[n+56>>2],!k)break r;Q[_+4>>1]=i[k+12>>2],Q[_>>1]=i[k+4>>2],u[_+6|0]=l[k+16|0]!=0;break e}e=i[r+4>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=h;break i}u[_+6|0]=1,Q[_+4>>1]=6,Q[_>>1]=1,Q[_+2>>1]=13}if(r6(A,r,f,s,_,w?8:0,n+28|0,i[n+48>>2],e- -64|0),e=i[r+4>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=_+16|0}function Lv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;n=v-32|0,v=n,A=i[A>>2],k=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),t=i[k+108>>2],w=i[k+112>>2],w&&(i[w+4>>2]=i[w+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}i:{if(!t){i[f>>2]=0;break i}k=0,i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0;e:{r:{f:{if(A=i[t+36>>2],s=i[t+40>>2],(A|0)!=(s|0)){if(k=s-A|0,(k|0)<0)break f;for(t=E(k),i[n+20>>2]=t,i[n+28>>2]=k+t,k=t;i[k>>2]=i[A>>2],h=k,k=i[A+4>>2],i[h+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=h+8|0,A=A+8|0,(s|0)!=(A|0););for(i[n+24>>2]=k,i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0;;){A=i[t>>2];A:{k:{n:{t:{if(e){if(i[A+16>>2]==(e|0))break t;break A}if(!A)break n}if(k=X0(A,86628,88420),!k)break n;if(i[n>>2]=k,A=i[t+4>>2],i[n+4>>2]=A,!A)break k;i[A+4>>2]=i[A+4>>2]+1;break k}i[n>>2]=0,i[n+4>>2]=0,k=0}k:{n:{if(!r)break n;if(A=i[k+108>>2],k=i[k+112>>2],(A|0)==(k|0))break k;for(;;){if(i[A>>2]==(r|0))break n;if(A=A+4|0,(k|0)==(A|0))break}break k}Ct(n+8|0,n)}if(A=i[n+4>>2],!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break A;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=(t|0)==(h|0),t=t+8|0,!!A)break}break r}i[f>>2]=0;break e}G0(),H()}s=i[n+12>>2],t=i[n+8>>2],A=s-t|0,h=A>>3,W=E(h>>>0>268435455?-1:A<<1);r:{f:{if((t|0)!=(s|0)){for(I=h>>>0<=1?1:h;;){e=(B<<4)+W|0,A=i[t+(B<<3)>>2],i[e>>2]=i[A+104>>2],i[e+4>>2]=i[A+16>>2],r=i[A+108>>2],k=i[A+112>>2];A:{if((r|0)==(k|0)){k=0,A=r;break A}r=k-r|0,k=E((r|0)<0?-1:r),r=i[A+108>>2],A=i[A+112>>2]}i[e+8>>2]=k,o=e,e=A-r>>2,i[o+12>>2]=e;A:{if(!k|(A|0)==(r|0))break A;if(o=e>>>0<=1?1:e,g=o&3,m=0,A=0,e>>>0>=4)for(C=o&-4,e=0;o=A<<2,i[o+k>>2]=i[r+o>>2],_=o|4,i[_+k>>2]=i[r+_>>2],_=o|8,i[_+k>>2]=i[r+_>>2],o=o|12,i[o+k>>2]=i[r+o>>2],A=A+4|0,e=e+4|0,(C|0)!=(e|0););if(!g)break A;for(;e=A<<2,i[e+k>>2]=i[e+r>>2],A=A+1|0,m=m+1|0,(m|0)!=(g|0););}if(B=B+1|0,(I|0)==(B|0))break}for(i[f>>2]=h;;){A=i[s-4>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;X[i[i[A>>2]+8>>2]](A),p(A)}if(s=s-8|0,(t|0)==(s|0))break}A=i[n+8>>2];break f}if(i[f>>2]=h,A=t,!A)break r}i[n+12>>2]=t,Z(A)}k=i[n+20>>2]}if(!k)break i;if(r=k,A=i[n+24>>2],(k|0)!=(A|0)){for(;;){e=i[A-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(k|0)==(A|0))break}r=i[n+20>>2]}i[n+24>>2]=k,Z(r)}i:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break i;X[i[i[w>>2]+8>>2]](w),p(w)}return v=n+32|0,W|0}function Pv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]),W=e,g=F0(r),i[W+104>>2]=g,n=l[e+97|0],(n|0)==1&&(n=F0(r),u[e+112|0]=1,i[e+108>>2]=n,n=l[e+97|0]),n>>>0>=2&&(n=F0(r),u[e+120|0]=1,i[e+116>>2]=n),_=F0(r),n=i[f+76>>2];i:{if(!(n>>>0<_>>>0&&n)){e:{r:{f:{A:{if(_)for(;;){t=0;k:{if(l[e+97|0]!=1||(t=0,i[e+108>>2]))break k;t=F0(r)}B=0,f=0;k:{if(i[e+104>>2]!=1919247987)break k;if(f=E(32),i[f+16>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f>>2]=106476,i[f+12>>2]=105868,B=f+12|0,$n(A,B,r,e),i[A>>2])break A;if(u[A+19|0]>=0)break k;Z(i[A+8>>2])}n=i[e+128>>2],o=i[e+132>>2];k:{if(n>>>0<o>>>0){i[n+8>>2]=f,i[n+4>>2]=B,i[n>>2]=t,f=n+12|0;break k}if(h=i[e+124>>2],n=n-h|0,s=((n|0)/12|0)+1|0,s>>>0>=357913942)break r;if(o=(o-h|0)/12|0,w=o<<1,w=o>>>0>=178956970?357913941:w>>>0>s>>>0?w:s,w){if(w>>>0>=357913942)break e;s=E(G(w,12))}else s=0;if(o=s+n|0,i[o+8>>2]=f,i[o+4>>2]=B,i[o>>2]=t,t=o+G((n|0)/-12|0,12)|0,n&&z(t,h,n),i[e+132>>2]=s+G(w,12),f=o+12|0,i[e+128>>2]=f,i[e+124>>2]=t,!h)break k;Z(h)}if(i[e+128>>2]=f,m=m+1|0,(_|0)==(m|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break f;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f);break i}T(A,i[26930],i[26931]);break i}G0(),H()}x0(),H()}i[k+116>>2]=0,i[k+88>>2]=72244,i[k+32>>2]=72224,e=i[18065],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18066],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+32>>2]=r,t=i[r-12>>2],r=k+32|0,i[t+r>>2]=i[18068],t=i[18064],i[k+24>>2]=t,i[e+i[t-12>>2]>>2]=i[18069],i[k+88>>2]=72244,i[k+24>>2]=72204,i[k+32>>2]=72224,n=R0(n),i[n>>2]=71280,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(I0(Y(K2(Y(r,28419,11),_,0),28431,62),i[f+76>>2]),5081,6),e=i[k+84>>2];e:{r:{if(e&16){f=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break r}if(!(e&8)){e=0,u[k+23|0]=0,f=k+12|0;break e}f=k+44|0,e=i[k+52>>2]}r:{if(r=i[f>>2],e=e-r|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,f=E(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=f,i[k+16>>2]=e;break r}if(u[k+23|0]=e,f=k+12|0,e)break r;e=0;break e}g0(),H()}if(!e)break e;z(f,r,e)}u[e+f|0]=0,K(A,6,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18063],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18071],i[k+32>>2]=i[18072],i[n>>2]=71280,u[k+79|0]<0&&Z(i[k+68>>2]),y0(n),p0(k+88|0)}v=k+192|0}function qv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{if(l[e+97|0]){t1(A,e,17931);break i}if(n=F0(r),K4(A,e+116|0,G(n,12),f,13822),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),s=e+104|0,t=i[e+104>>2],o=(i[e+108>>2]-t|0)/12|0;e:{r:{if(o>>>0<n>>>0){Dt(s,n-o|0);break r}if(n>>>0<o>>>0&&(i[e+108>>2]=t+G(n,12)),!n)break e}for(e=0;;){if(h=F0(r),o=F0(r),w=F0(r),!w){if(e=E(56),i[k+20>>2]=e,i[k+24>>2]=51,i[k+28>>2]=-2147483592,r=l[26166]|l[26167]<<8|(l[26168]<<16|l[26169]<<24),f=l[26162]|l[26163]<<8|(l[26164]<<16|l[26165]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[26209]|l[26210]<<8|(l[26211]<<16|l[26212]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[26206]|l[26207]<<8|(l[26208]<<16|l[26209]<<24),f=l[26202]|l[26203]<<8|(l[26204]<<16|l[26205]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[26198]|l[26199]<<8|(l[26200]<<16|l[26201]<<24),f=l[26194]|l[26195]<<8|(l[26196]<<16|l[26197]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26190]|l[26191]<<8|(l[26192]<<16|l[26193]<<24),f=l[26186]|l[26187]<<8|(l[26188]<<16|l[26189]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26182]|l[26183]<<8|(l[26184]<<16|l[26185]<<24),f=l[26178]|l[26179]<<8|(l[26180]<<16|l[26181]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26174]|l[26175]<<8|(l[26176]<<16|l[26177]<<24),f=l[26170]|l[26171]<<8|(l[26172]<<16|l[26173]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(o>>>0>u0[f+80>>2]){if(e=E(96),i[k+20>>2]=e,i[k+24>>2]=90,i[k+28>>2]=-2147483552,z(e,23954,90),u[e+90|0]=0,K(A,2,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(t=i[s>>2]+G(e,12)|0,i[t+8>>2]=w,i[t+4>>2]=o,i[t>>2]=h,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Kv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;f=v-192|0,v=f,x2(f+168|0,e,r);i:{if(i[f+168>>2]!=i[26928]){e=i[f+172>>2],i[A>>2]=i[f+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+184>>2],e=i[f+180>>2],i[A+8>>2]=i[f+176>>2],i[A+12>>2]=e,i[f+184>>2]=0,i[f+176>>2]=0,i[f+180>>2]=0;break i}if(l[e+97|0]>=2){t1(A,e,4730);break i}B=F0(r),i[e+108>>2]=i[e+104>>2];e:{r:{f:{A:{k:{if(B)for(;;){if(!i[r+16>>2]){i[f+112>>2]=0,i[f+84>>2]=72244,i[f+28>>2]=72224,e=i[18065],i[f+20>>2]=e,r=i[e-12>>2],e=f+20|0,i[r+e>>2]=i[18066],i[f+24>>2]=0,r=e+i[i[f+20>>2]-12>>2]|0,k=f+32|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[f+28>>2]=r,m=i[r-12>>2],r=f+28|0,i[m+r>>2]=i[18068],o=i[18064],i[f+20>>2]=o,i[e+i[o-12>>2]>>2]=i[18069],i[f+84>>2]=72244,i[f+20>>2]=72204,i[f+28>>2]=72224,o=R0(k),i[o>>2]=71280,i[f+72>>2]=0,i[f+76>>2]=0,i[f+64>>2]=0,i[f+68>>2]=0,i[f+80>>2]=24,Y(K2(Y(I0(Y(r,28186,24),B),29139,31),_,s),24223,9),e=i[f+80>>2];n:{if(e&16){k=f+52|0,r=i[f+76>>2],e=i[f+56>>2],r>>>0<e>>>0?i[f+76>>2]=e:e=r;break n}if(!(e&8)){e=0,u[f+19|0]=0,k=f+8|0;break e}k=f+40|0,e=i[f+48>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break k;if(e>>>0>=11){s=e|7,k=E(s+1|0),i[f+16>>2]=s-2147483647,i[f+8>>2]=k,i[f+12>>2]=e;break r}if(u[f+19|0]=e,k=f+8|0,e)break r;e=0;break e}n:{if(l[e+97|0]==1){o=R4(r),W=l0,k=R4(r),g=l0;break n}o=F0(r),W=0,k=F0(r),g=k>>31}m=k,I=wi(r),C=wi(r),n=i[e+108>>2],t=i[e+112>>2];n:{if(n>>>0<t>>>0){Q[n+18>>1]=C,Q[n+16>>1]=I,i[n+8>>2]=k,i[n+12>>2]=g,i[n>>2]=o,i[n+4>>2]=W,k=n+24|0;break n}if(h=i[e+104>>2],k=n-h|0,n=((k|0)/24|0)+1|0,n>>>0>=178956971)break A;if(t=(t-h|0)/24|0,w=t<<1,w=t>>>0>=89478485?178956970:n>>>0<w>>>0?w:n,w){if(w>>>0>=178956971)break f;n=E(G(w,24))}else n=0;if(t=n+k|0,Q[t+18>>1]=C,Q[t+16>>1]=I,i[t+8>>2]=m,i[t+12>>2]=g,i[t>>2]=o,i[t+4>>2]=W,o=t+G((k|0)/-24|0,24)|0,k&&z(o,h,k),i[e+112>>2]=n+G(w,24),k=t+24|0,i[e+108>>2]=k,i[e+104>>2]=o,!h)break n;Z(h)}if(i[e+108>>2]=k,_=_+1|0,s=_?s:s+1|0,!((B|0)!=(_|0)|s))break}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}G0(),H()}x0(),H()}if(!e)break e;z(k,r,e)}u[e+k|0]=0,K(A,2,100,f+8|0),u[f+19|0]<0&&Z(i[f+8>>2]),A=i[18063],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18071],i[f+28>>2]=i[18072],i[o>>2]=71280,u[f+75|0]<0&&Z(i[f+64>>2]),y0(o),p0(f+84|0)}u[f+187|0]<0&&Z(i[f+176>>2]),v=f+192|0}function av(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;i[A+4>>2]=1,e=i[A+12>>2],i[e+324>>2]=i[e+324>>2]-1,i[e+328>>2]=i[e+328>>2]+1,e=i[A+12>>2],_=i[e+124>>2],h=i[_+16876>>2],r=e,B=i[_+16892>>2],e=B-1|0,F8(r,A,e,i[A+8>>2],i[A+24>>2]),r=i[A+8>>2],(r|0)>0&&(F8(i[A+12>>2],A,e,r-1|0,i[A+24>>2]),r=i[A+8>>2]),f=r+1|0,(f|0)<i[_+16900>>2]&&(F8(i[A+12>>2],A,e,f,i[A+24>>2]),r=i[A+8>>2],f=r+1|0),t=i[A+20>>2],k=i[A+16>>2],f=f<<h;i:{e:{if(e=r<<h,!(e&1)){if(r=i[k+28>>2],s=(r|0)>(f|0)?f:r,s&1)break e;r=i[t+124>>2],o=(i[r+16840>>2]+7|0)/8|0,w=(i[r+16832>>2]+7|0)/8|0,r=i[k+40>>2];r:{if((r|0)!=i[t+40>>2]){if((e|0)>=(s|0))break r;for(r=e;n=G(w,i[k+24>>2]),n&&(f=G(r,w),z(i[t+4>>2]+G(f,i[t+40>>2])|0,i[k+4>>2]+G(f,i[k+40>>2])|0,n)),r=r+1|0,(s|0)!=(r|0););break r}if(f=G(s-e|0,G(r,w)),!f)break r;r=G(r,G(e,w)),z(r+i[t+4>>2]|0,r+i[k+4>>2]|0,f)}r=l[k+51|0],f=(s|0)/(r|0)|0,r=(e|0)/(r|0)|0;r:{if(!i[k+20>>2])break r;if(e=i[k+44>>2],(e|0)!=i[t+44>>2]){if((r|0)>=(f|0))break r;for(;n=G(r,o),e=G(o,i[k+32>>2]),e&&z(i[t+8>>2]+G(n,i[t+44>>2])|0,i[k+8>>2]+G(n,i[k+44>>2])|0,e),e=G(o,i[k+32>>2]),e&&z(i[t+12>>2]+G(n,i[t+44>>2])|0,i[k+12>>2]+G(n,i[k+44>>2])|0,e),r=r+1|0,(f|0)!=(r|0););break r}if(n=G(r,o),f=G(o,f-r|0),r=G(f,e),r&&(e=G(e,n),z(e+i[t+8>>2]|0,e+i[k+8>>2]|0,r)),e=i[t+44>>2],r=G(e,f),!r)break r;e=G(e,n),z(e+i[t+12>>2]|0,e+i[k+12>>2]|0,r)}break i}M0(22167,18299,626,9354),H()}M0(22182,18299,627,9354),H()}i:{if(i[_+16892>>2]<=0)break i;for(k=1<<h,r=0;;){if(o=i[A+12>>2],f=i[o+52>>2],s=i[A+8>>2],e=F[((i[o+140>>2]+G(r,24)|0)+G(G(s,i[o+152>>2]),24)|0)+2>>1],e>>>0>=i[o+56>>2]-f>>2>>>0||(w=i[f+(e<<2)>>2],!w))break i;e:{if(!l[w+333|0])break e;if(e=i[A+20>>2],h=i[e+40>>2],n=i[e+4>>2],e=i[A+16>>2],f=i[e+40>>2],e=i[e+4>>2],i[i[o+124>>2]+16832>>2]>=9){Li(o,r,s,0,k,k,e,f,n,h);break e}qi(o,r,s,0,k,k,e,f,n,h)}e:{if(!l[w+334|0])break e;t=(k|0)/i[_+16856>>2]|0,o=(k|0)/i[_+16852>>2]|0,s=i[A+8>>2],e=i[A+20>>2],w=i[e+44>>2],h=i[e+8>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+8>>2],e=i[A+12>>2];r:{if(i[i[e+124>>2]+16840>>2]>=9){Li(e,r,s,1,o,t,f,n,h,w);break r}qi(e,r,s,1,o,t,f,n,h,w)}if(s=i[A+8>>2],e=i[A+20>>2],w=i[e+44>>2],h=i[e+12>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+12>>2],e=i[A+12>>2],i[i[e+124>>2]+16840>>2]>=9){Li(e,r,s,2,o,t,f,n,h,w);break e}qi(e,r,s,2,o,t,f,n,h,w)}if(r=r+1|0,!((r|0)<i[_+16892>>2]))break}}if(r=0,(B|0)>0)for(;e=(i[i[A+12>>2]+320>>2]+G(r,76)|0)+G(G(i[A+8>>2],i[_+16892>>2]),76)|0,i[e>>2]<4&&(i[e>>2]=4),r=r+1|0,(B|0)!=(r|0););i[A+4>>2]=3,h3(i[A+12>>2])}function E9(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0;h=v-96|0,v=h;i:{e:{W=i[e+20>>2];r:{if(!W)break r;for(I=h- -64|0,m=e+20|0,B=m,_=W;g=u0[_+16>>2]<r>>>0,B=g?B:_,_=i[(g?4:0)+_>>2],!!_;);if(_=0,(B|0)==(m|0)|u0[B+16>>2]>r>>>0)break r;for(_=m;B=u0[W+16>>2]<r>>>0,_=B?_:W,W=i[(B?4:0)+W>>2],!!W;);if(_=(_|0)!=(m|0)&u0[_+16>>2]<=r>>>0?_:m,m=i[_+20>>2],_=i[_+24>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),m)break e}u[h+16|0]=0,u[h+27|0]=0,e=K(h+56|0,2,2e3,h+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[h+27|0]>=0)break i;Z(i[h+16>>2]);break i}i[h+48>>2]=0,i[h+52>>2]=0,i[h+44>>2]=h+48,r=h+44|0,t8(r,i[w>>2],w+4|0),X[i[i[m>>2]+100>>2]](h+56|0,m,n,t,o,s,r),Y1(r,i[h+48>>2]);e:{r:{f:{A:{k:{n:switch(l[h+76|0]){case 1:e=i[h+60>>2],i[A>>2]=i[h+56>>2],i[A+4>>2]=e,r=A+8|0;t:{if(u[h+75|0]>=0){e=I,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break t}T(r,i[h+64>>2],i[h+68>>2])}u[A+20|0]=1;break e;case 0:break n;default:break k}switch(t=i[h+56>>2],r=i[h+60>>2],r&&(i[r+4>>2]=i[r+4>>2]+1,i[r+4>>2]=i[r+4>>2]+1),i[h+12>>2]=r,i[h+8>>2]=t,t=i[h+12>>2],i[h>>2]=i[h+8>>2],i[h+4>>2]=t,F9(h+16|0,e,h,f,k,n),n=l[h+36|0],n|0){case 0:break f;case 1:break A;default:break k}}_2(),H()}if(e=i[h+20>>2],i[A>>2]=i[h+16>>2],i[A+4>>2]=e,e=A+8|0,u[h+35|0]>=0){f=i[h+28>>2],i[e>>2]=i[h+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[h+32>>2];break r}T(e,i[h+24>>2],i[h+28>>2]);break r}k=i[h+20>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),e=i[h+16>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(r=i[m+424>>2],t=i[m+428>>2],(r|0)!=(t|0))for(o=e+148|0,B=i[e+152>>2];;){f:{if(u0[e+156>>2]>B>>>0){if(f=i[r+4>>2],i[B>>2]=i[r>>2],i[B+4>>2]=f,f=B+8|0,u[r+19|0]>=0){s=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=s,i[f+8>>2]=i[r+16>>2],B=B+20|0;break f}T(f,i[r+8>>2],i[r+12>>2]),B=B+20|0;break f}B=fi(o,r)}if(i[e+152>>2]=B,r=r+20|0,(t|0)==(r|0))break}i[A+4>>2]=k,i[A>>2]=e,r=0}if(u[A+20|0]=n,A=l[h+36|0],(A|0)!=255&&(e=i[23607],i[h+88>>2]=i[23606],i[h+92>>2]=e,X[i[(h+88|0)+(A<<2)>>2]](h+87|0,h+16|0)),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(A=l[h+76|0],(A|0)==255)break i;e=i[23607],i[h+16>>2]=i[23606],i[h+20>>2]=e,X[i[(h+16|0)+(A<<2)>>2]](h+88|0,h+56|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;X[i[i[_>>2]+8>>2]](_),p(_)}v=h+96|0}function $v(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;B=v-32|0,v=B,s=B+12|0,I=r,C=f,k=v-48|0,v=k;i:{e:{if(m=i[e>>2],f=i[m+124>>2],W=m+128|0,(f|0)!=(W|0))for(g=s+8|0,V=m+136|0;;){LA(I,C,i[f+16>>2],i[m+120>>2],k+44|0,k+40|0),h=i[f+32>>2],_=i[f+28>>2],t=i[f+16>>2];r:{if((t|0)==10){if(o=31,r=i[m+120>>2]-10|0,r>>>0>=6)break r;o=i[(r<<2)+50052>>2];break r}if(o=0,n=W,r=i[n>>2],!r)break r;for(;w=(t|0)>i[r+16>>2],n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((n|0)==(W|0)|(t|0)<i[n+16>>2])break r;o=(l[n+24|0]+7&248)>>>3|0}if(n=i[k+44>>2],r=i[k+40>>2],!(n>>>0<=u0[f+36>>2]&r>>>0<=u0[f+40>>2])){Q[k+4>>1]=256,i[k>>2]=1,i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,t=r,w=i[f+20>>2],y=l[f+24|0],r=1;r:{f:switch(i[m+120>>2]){case 10:case 12:case 14:r=3;break r;case 11:case 13:case 15:r=4;break r;case 0:case 1:case 2:case 3:case 99:break r;default:break f}r=0}if(kr(s,k,n,t,w,y,r,0,V),i[s>>2])break i;if(u[s+19|0]<0&&Z(i[s+8>>2]),n=i[k+24>>2],!n)break e;if(i[f+32>>2])for(r=0,t=i[k+36>>2];w=G(i[f+28>>2],o),w&&z(n+G(r,t)|0,i[f+44>>2]+G(i[f+56>>2],r)|0,w),r=r+1|0,r>>>0<u0[f+32>>2];);r=i[k+4>>2],i[f+20>>2]=i[k>>2],i[f+24>>2]=r,r=i[k+36>>2],i[f+52>>2]=i[k+32>>2],i[f+56>>2]=r,r=i[k+28>>2],i[f+44>>2]=i[k+24>>2],i[f+48>>2]=r,r=i[k+20>>2],i[f+36>>2]=i[k+16>>2],i[f+40>>2]=r,r=i[k+12>>2],i[f+28>>2]=i[k+8>>2],i[f+32>>2]=r,n=i[k+44>>2]}if(!(!h|(n|0)==(_|0)|n>>>0<=_>>>0))for(w=G(_-1|0,o),t=0;;){if(r=_,n>>>0>r>>>0)for(;o&&(n=i[f+44>>2]+G(i[f+56>>2],t)|0,z(n+G(r,o)|0,n+w|0,o)),r=r+1|0,n=i[k+44>>2],r>>>0<n>>>0;);if(t=t+1|0,(h|0)==(t|0))break}if(u0[k+40>>2]>h>>>0)for(r=h-1|0;n=G(i[k+44>>2],o),n&&(t=i[f+44>>2],_=i[f+56>>2],z(t+G(_,h)|0,t+G(r,_)|0,n)),h=h+1|0,h>>>0<u0[k+40>>2];);o=i[f+4>>2];r:{if(o){for(;;)if(r=o,o=i[r>>2],!o)break r}for(;r=i[f+8>>2],n=i[r>>2]!=(f|0),f=r,!!n;);}if(f=r,(W|0)==(r|0))break}if(r=i[26929],i[s>>2]=i[26928],i[s+4>>2]=r,r=s+8|0,u[107731]>=0){f=i[26931],i[r>>2]=i[26930],i[r+4>>2]=f,i[r+8>>2]=i[26932];break i}T(r,i[26930],i[26931]);break i}if(r=i[26934],i[s>>2]=i[26933],i[s+4>>2]=r,u[107751]>=0){r=i[26936],i[g>>2]=i[26935],i[g+4>>2]=r,i[g+8>>2]=i[26937];break i}T(g,i[26935],i[26936])}v=k+48|0;i:{if(i[B+12>>2]){r=A,A=i[e>>2],b0(r,s,A?A+92|0:0);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[B+31|0]<0&&Z(i[B+20>>2]),v=B+32|0}function dv(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(n=v-80|0,v=n,i[n+52>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,u[n+40|0]=0,i[n+36>>2]=9e4,w=i[e>>2],o=h2(r),o>>>0<2147483640){t=f||n+36|0;i:{e:{if(o>>>0>=11){s=o|7,f=E(s+1|0),i[n+8>>2]=s-2147483647,i[n>>2]=f,i[n+4>>2]=o;break e}if(u[n+11|0]=o,f=n,!o)break i}if(!o)break i;z(f,r,o)}u[f+o|0]=0,o=v-16|0,v=o,sr(i[w+48>>2]),s=E(320),i[s>>2]=94940,i[s+4>>2]=0,i[s+8>>2]=0,r=s+16|0;i:{if(u[n+11|0]>=0){i[o+8>>2]=i[n+8>>2],f=i[n+4>>2],i[o>>2]=i[n>>2],i[o+4>>2]=f;break i}T(o,i[n>>2],i[n+4>>2])}f=v-16|0,v=f,_=p7(r,w,t,1835365473),i[_>>2]=106816,i[_+296>>2]=i[o+8>>2],r=i[o+4>>2],i[_+288>>2]=i[o>>2],i[_+292>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,r=E(120),i[r>>2]=94172,i[r+4>>2]=0,i[r+8>>2]=0,t=r+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,Q[r+112>>1]=0,i[r+16>>2]=104748,i[r+116>>2]=1,i[r+32>>2]=1852663908,h=i[_+148>>2],i[f+12>>2]=r,i[f+8>>2]=t,i[r+4>>2]=i[r+4>>2]+1,r2(h+36|0,f+8|0),t=i[f+12>>2];i:{if(!t||(h=i[t+4>>2],i[t+4>>2]=h-1,h))break i;X[i[i[t>>2]+8>>2]](t),p(t)}t=i[r+4>>2],i[r+4>>2]=t-1,t||(X[i[i[r>>2]+8>>2]](r),p(r)),v=f+16|0,u[o+11|0]<0&&Z(i[o>>2]),i[s+4>>2]=i[s+4>>2]+1,h=i[s+40>>2];i:{e:{t=i[w+184>>2];r:{if(!t){f=w+184|0,r=f;break r}for(;;){if(r=t,f=i[r+16>>2],f>>>0>h>>>0){if(f=r,t=i[r>>2],t)continue;break r}if(f>>>0>=h>>>0)break e;if(t=i[r+4>>2],!t)break}f=r+4|0}t=E(28),i[t+24>>2]=s,i[t+20>>2]=_,i[t+16>>2]=h,i[t+8>>2]=r,i[t>>2]=0,i[t+4>>2]=0,i[f>>2]=t,r=i[i[w+180>>2]>>2],r&&(i[w+180>>2]=r),m1(i[w+184>>2],t),i[w+188>>2]=i[w+188>>2]+1;break i}if(r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;X[i[i[s>>2]+8>>2]](s),p(s)}u[n+32|0]=0,i[n+16>>2]=s,i[n+12>>2]=_,v=o+16|0,u[n+11|0]<0&&Z(i[n>>2]);i:{e:switch(l[n+32|0]){default:_2(),H();case 1:b0(A,n+12|0,i[e>>2]);break i;case 0:break e}k&&(r=E(16),t=i[n+12>>2],f=i[n+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=t,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[k>>2]=r),e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}A=l[n+32|0],(A|0)!=255&&(e=i[24211],i[n+72>>2]=i[24210],i[n+76>>2]=e,X[i[(n+72|0)+(A<<2)>>2]](n+71|0,n+12|0)),z2(i[n+48>>2]),u[n+67|0]<0&&Z(i[n+56>>2]),v=n+80|0;return}g0(),H()}function cv(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;s=v-32|0,v=s,w=s+12|0,B=i[e>>2],m=r,r=0,t=v-16|0,v=t;i:{if(k>>>0<5)break i;for(n=k-4|0;;){if(o=r+f|0,h=l[o+1|0]<<8,_=l[o+2|0]<<16|l[o+3|0]<<24,(l[o|0]|h|_)==704662861|(_|(h|l[o|0]))==2771273)break i;if(r=r+1|0,(n|0)==(r|0))break}r=n}i:{e:{r:{if(r>>>0>=k>>>0){if(r=E(64),i[t+4>>2]=r,i[t+8>>2]=56,i[t+12>>2]=-2147483584,f=l[26015]|l[26016]<<8|(l[26017]<<16|l[26018]<<24),k=l[26011]|l[26012]<<8|(l[26013]<<16|l[26014]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+56|0]=0,f=l[26063]|l[26064]<<8|(l[26065]<<16|l[26066]<<24),k=l[26059]|l[26060]<<8|(l[26061]<<16|l[26062]<<24),u[r+48|0]=k,u[r+49|0]=k>>>8,u[r+50|0]=k>>>16,u[r+51|0]=k>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[26055]|l[26056]<<8|(l[26057]<<16|l[26058]<<24),k=l[26051]|l[26052]<<8|(l[26053]<<16|l[26054]<<24),u[r+40|0]=k,u[r+41|0]=k>>>8,u[r+42|0]=k>>>16,u[r+43|0]=k>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[26047]|l[26048]<<8|(l[26049]<<16|l[26050]<<24),k=l[26043]|l[26044]<<8|(l[26045]<<16|l[26046]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[26039]|l[26040]<<8|(l[26041]<<16|l[26042]<<24),k=l[26035]|l[26036]<<8|(l[26037]<<16|l[26038]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[26031]|l[26032]<<8|(l[26033]<<16|l[26034]<<24),k=l[26027]|l[26028]<<8|(l[26029]<<16|l[26030]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[26023]|l[26024]<<8|(l[26025]<<16|l[26026]<<24),k=l[26019]|l[26020]<<8|(l[26021]<<16|l[26022]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(w,5,2006,t+4|0),u[t+15|0]>=0)break r;Z(i[t+4>>2]);break r}i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,o=k+4|0;f:{if(!o){n=0;break f}if((k|0)<=-5)break e;n=E(o),o&&o0(n,0,o),W=n+o|0}r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),u[n|0]=r,u[n+1|0]=r>>>8,u[n+2|0]=r>>>16,u[n+3|0]=r>>>24,k&&z(n+4|0,f,k),ci(w,B,m,n,W-n|0,1165519206,0,0,0),Z(n)}v=t+16|0;break i}G0(),H()}i:{if(i[s+12>>2]!=i[26928]){b0(A,w,i[e>>2]);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[s+31|0]<0&&Z(i[s+20>>2]),v=s+32|0}function bv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72548,k=i[18140],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18141],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=72548,i[f>>2]=72528,B=R0(n),i[B>>2]=71280,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,Y2(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+104>>2],m=i[e+108>>2],(s|0)!=(m|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=Y(f,27421,21),k=f+148|0,ie(k,s),t=e,n=k,e=u[f+159|0],k=(e|0)<0,Y(I0(Y(Y(Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:e),27462,1),32587,10),i[s+40>>2]),30303,9),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+44>>2],W=i[s+48>>2],(e|0)==(W|0))break i;for(;;){e:{h=I0(f,i[e>>2]),g=G1(f+140|0,h);r:{if(l[g|0]!=1)break r;n=i[i[h>>2]-12>>2]+h|0,_=i[n+4>>2],w=i[n+24>>2];f:{if(l[n+80|0]==1){k=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+148|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=k,u[n+77|0]=k>>>8,u[n+78|0]=k>>>16,u[n+79|0]=k>>>24,u[n+80|0]=1}f:{if(!w||(o=i[n+12>>2],_=(_&176)==32?32852:32851,t=_-32851|0,(t|0)>0&&(X[i[i[w>>2]+48>>2]](w,32851,t)|0)!=(t|0)))break f;if((o|0)>=2){if(o>>>0>=2147483641)break e;t=((o|0)<=1?1:o)-1|0;A:{if(o>>>0>=12){I=t|7,o=E(I+1|0),i[f+156>>2]=I-2147483647,i[f+148>>2]=o,i[f+152>>2]=t;break A}u[f+159|0]=t,o=f+148|0}if(t&&o0(o,k,t),u[t+o|0]=0,k=X[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32852-_|0,(k|0)>0&&(X[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(g),e=e+4|0,(W|0)!=(e|0))continue;break i}break}g0(),H()}if(Y(f,42713,1),s=s+56|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18142],i[B>>2]=71280,u[f+47|0]<0&&Z(i[f+36>>2]),y0(B),p0(f+56|0),v=f+160|0}function im(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72548,k=i[18140],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18141],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=72548,i[f>>2]=72528,B=R0(n),i[B>>2]=71280,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,Y2(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+100>>2],m=i[e+104>>2],(s|0)!=(m|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=Y(f,27421,21),k=f+148|0,P1(k,i[s>>2]),t=e,n=k,e=u[f+159|0],k=(e|0)<0,Y(Y(Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:e),27462,1),30313,15),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+4>>2],W=i[s+8>>2],(e|0)==(W|0))break i;for(;;){e:{h=I0(f,i[e>>2]),g=G1(f+140|0,h);r:{if(l[g|0]!=1)break r;n=i[i[h>>2]-12>>2]+h|0,_=i[n+4>>2],w=i[n+24>>2];f:{if(l[n+80|0]==1){k=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+148|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129808),k=X[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=k,u[n+77|0]=k>>>8,u[n+78|0]=k>>>16,u[n+79|0]=k>>>24,u[n+80|0]=1}f:{if(!w||(o=i[n+12>>2],_=(_&176)==32?32852:32851,t=_-32851|0,(t|0)>0&&(X[i[i[w>>2]+48>>2]](w,32851,t)|0)!=(t|0)))break f;if((o|0)>=2){if(o>>>0>=2147483641)break e;t=((o|0)<=1?1:o)-1|0;A:{if(o>>>0>=12){I=t|7,o=E(I+1|0),i[f+156>>2]=I-2147483647,i[f+148>>2]=o,i[f+152>>2]=t;break A}u[f+159|0]=t,o=f+148|0}if(t&&o0(o,k,t),u[t+o|0]=0,k=X[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32852-_|0,(k|0)>0&&(X[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(g),e=e+4|0,(W|0)!=(e|0))continue;break i}break}g0(),H()}if(Y(f,42713,1),s=s+16|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18142],i[B>>2]=71280,u[f+47|0]<0&&Z(i[f+36>>2]),y0(B),p0(f+56|0),v=f+160|0}function em(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;k=v-32|0,v=k,o=ir()|0;i:{if(!e){i[A+4>>2]=o,i[A>>2]=125416;break i}Tf(k+4|0,e,k+16|0,r,f,0);e:{if(!i[k+4>>2]){r=f8(15053)|0,i[k+24>>2]=i[k+16>>2],f=y1(96448,k+24|0)|0,U4(o|0,r|0,f|0),f>>>0>=9&&o1(f|0),r>>>0>=9&&o1(r|0),f=0;r:{if(!e||(r=i[e>>2],!r))break r;r=i[r+120>>2],f=(r|0)>0?r:0}r=f8(10833)|0,i[k+24>>2]=f,f=y1(85416,k+24|0)|0,U4(o|0,r|0,f|0),f>>>0>=9&&o1(f|0),r>>>0>=9&&o1(r|0),r=0;r:{if(!e||(e=i[e>>2],!e))break r;e=i[e+124>>2],r=(e|0)>0?e:0}for(e=f8(4109)|0,i[k+24>>2]=r,f=y1(85416,k+24|0)|0,U4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),f=i[i[i[k+16>>2]>>2]+120>>2],e=f8(18983)|0,i[k+24>>2]=f,f=y1(96440,k+24|0)|0,U4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),f=i[i[i[k+16>>2]>>2]+116>>2],e=f8(15525)|0,i[k+24>>2]=f,f=y1(96432,k+24|0)|0,U4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),e=r,w=E(32),r=w,f=i[12954],i[r>>2]=i[12953],i[r+4>>2]=f,r=i[12960],i[w+24>>2]=i[12959],i[w+28>>2]=r,r=i[12958],i[w+16>>2]=i[12957],i[w+20>>2]=r,r=i[12956],i[w+8>>2]=i[12955],i[w+12>>2]=r,h=nf()|0,r=0;;){f=i[r+w>>2];r:{if(!pk(i[k+16>>2],f))break r;s=ir()|0,n=f8(15905)|0,i[k+24>>2]=f,t=y1(96472,k+24|0)|0,U4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),_=hi(i[k+16>>2],f,k),n=f8(15192)|0,i[k+24>>2]=i[k>>2],t=y1(85452,k+24|0)|0,U4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),n=i[k>>2],i[k+28>>2]=_,i[k+24>>2]=G(e,n),n=y1(96480,k+24|0)|0,t=f8(18948)|0,U4(s|0,t|0,n|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),t=ns(i[k+16>>2],f),n=f8(10833)|0,i[k+24>>2]=t,t=y1(85416,k+24|0)|0,U4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),t=ts(i[k+16>>2],f),n=f8(4109)|0,i[k+24>>2]=t,t=y1(85416,k+24|0)|0,U4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),n=gs(i[k+16>>2],f),f=f8(9910)|0,i[k+24>>2]=n,n=y1(85416,k+24|0)|0,U4(s|0,f|0,n|0),n>>>0>=9&&o1(n|0),f>>>0>=9&&o1(f|0),n=s>>>0<9,n||T_(s|0),i[k+24>>2]=s,i[k+20>>2]=0;f:{if(u[107836]&1){f=i[26958];break f}f=z_(2,96488,0)|0,u[107836]=1,i[26958]=f}if(+x_(f|0,h|0,10839,k+20|0,k+24|0),f=i[k+20>>2],f&&H_(f|0),n)break r;o1(s|0)}if(r=r+4|0,(r|0)==32)break}break e}if(e=E(12),i[e+8>>2]=i[k+12>>2],r=i[k+8>>2],i[e>>2]=i[k+4>>2],i[e+4>>2]=r,i[k+24>>2]=e,B=A,m=y1(96308,k+24|0)|0,i[B+4>>2]=m,i[A>>2]=125416,o>>>0<9)break i;o1(o|0);break i}e=f8(5096)|0,U4(o|0,e|0,h|0),e>>>0>=9&&o1(e|0),i[A+4>>2]=o,i[A>>2]=125416,h>>>0>=9&&o1(h|0),Z(w)}v=k+32|0}function rm(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;n=v-32|0,v=n,k=E(172),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=94860,o0(k+16|0,0,80),e=i[k+4>>2],f=e+1|0,i[k+4>>2]=f,i[k+104>>2]=0,i[k+108>>2]=0,i[k+36>>2]=1,i[k+40>>2]=1,u[k+24|0]=1,Q[k+22>>1]=2,Q[k+18>>1]=2,Q[k+20>>1]=2,i[k+112>>2]=0,i[k+116>>2]=4740,i[k+140>>2]=0,i[k+144>>2]=0,i[k+128>>2]=99,i[k+132>>2]=99,i[k+120>>2]=0,i[k+124>>2]=0,i[k+12>>2]=95208,i[k+148>>2]=0,i[k+152>>2]=0,h=k+140|0,i[k+136>>2]=h,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+4>>2]=e,e=i[k+8>>2],_=k+12|0,i[k+96>>2]=_,i[k+8>>2]=e+1,i[k+100>>2]=k,f||(X[i[i[k>>2]+8>>2]](k),p(k));i:{e:{if(e=i[r>>2],t=i[e+120>>2]-12|0,t>>>0>=4){e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;r:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break r}T(e,i[26935],i[26936])}u[A+20|0]=1;break e}if(f=i[e+108>>2],W=i[e+112>>2],e=W,i[_+120>>2]=i[(t<<2)+58352>>2],i[_+116>>2]=1,i[_+112>>2]=e,i[_+108>>2]=f,T0(n+8|0,_,10,f,e,j0(i[r>>2],10),o),i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,e=A+8|0,u[n+27|0]>=0){r=i[n+20>>2],i[e>>2]=i[n+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(e,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}u[n+27|0]<0&&Z(i[n+16>>2]),t=0;r:{f:{if(e=i[r>>2],r=i[e+128>>2],!r)break f;for(f=e+128|0,e=f;o=i[r+16>>2]<10,e=o?e:r,r=i[(o?4:0)+r>>2],!!r;);if((e|0)==(f|0))break f;if(B=0,i[e+16>>2]>10)break r;I=i[e+44>>2],B=i[e+56>>2];break r}B=0}r=i[h>>2],f=0;r:{if(!r)break r;for(e=h;f=i[r+16>>2]<10,e=f?e:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)==(h|0)){f=0;break r}if(f=0,i[e+16>>2]>10)break r;t=i[e+56>>2],f=i[e+44>>2]}r:{if(!W||(e=t>>>0<B>>>0?t:B,!e))break r;for(e=e-1|0,r=(e>>>1|0)+1|0,C=r&-4,g=r&3,V=e>>>0<6;;){if(e=G(t,m)+f|0,h=G(B,m)+I|0,r=0,o=0,!V)for(;s=e+r|0,w=r+h|0,u[s|0]=l[w+1|0],u[s+1|0]=l[w|0],s=r|2,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],s=r|4,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],s=r|6,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],r=r+8|0,o=o+4|0,(C|0)!=(o|0););if(o=0,g)for(;s=e+r|0,w=r+h|0,u[s|0]=l[w+1|0],u[s+1|0]=l[w|0],r=r+2|0,o=o+1|0,(g|0)!=(o|0););if(m=m+1|0,(m|0)==(W|0))break}}u[A+20|0]=0,i[A+4>>2]=k,i[A>>2]=_;break i}if(A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;X[i[i[k>>2]+8>>2]](k),p(k)}v=n+32|0}function fm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;s=v-48|0,v=s,o=i[e>>2],m=i[o+48>>2],_=i[o+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{e:{r:{if(w=h2(f),w>>>0<2147483640){f:{A:{if(w>>>0>=11){h=w|7,o=E(h+1|0),i[s+8>>2]=h-2147483647,i[s>>2]=o,i[s+4>>2]=w;break A}if(u[s+11|0]=w,o=s,!w)break f}if(!w)break f;z(o,f,w)}u[o+w|0]=0,f=v+-64|0,v=f,Z8(f+56|0,m,1835625829),h=i[f+56>>2],o=h,u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1;f:{if(o=h2(r),o>>>0<2147483640){A:{k:{if(o>>>0>=11){B=o|7,w=E(B+1|0),i[f+52>>2]=B-2147483647,i[f+44>>2]=w,i[f+48>>2]=o;break k}if(u[f+55|0]=o,w=f+44|0,!o)break A}if(!o)break A;z(w,r,o)}u[o+w|0]=0,r=h+128|0;A:{if((r|0)==(f+44|0))break A;if(o=u[f+55|0],u[h+139|0]>=0){if((o|0)>=0){o=i[f+48>>2],i[r>>2]=i[f+44>>2],i[r+4>>2]=o,i[r+8>>2]=i[f+52>>2];break A}D1(r,i[f+44>>2],i[f+48>>2]);break A}h=r,r=(o|0)<0,O1(h,r?i[f+44>>2]:f+44|0,r?i[f+48>>2]:o)}u[f+55|0]<0&&Z(i[f+44>>2]),B=i[i[f+56>>2]+104>>2],i[f+16>>2]=i[s+8>>2],r=i[s+4>>2],i[f+8>>2]=i[s>>2],i[f+12>>2]=r,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,r=f+24|0,h=f+8|0,w=0,o=v-32|0,v=o,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0;A:{k:{if(n){if((n|0)<0)break k;w=E(n),n&&o0(w,0,n),W=n+w|0,i[o+8>>2]=W,i[o+4>>2]=W,i[o>>2]=w}n&&z(w,k,n),w=i[f+56>>2],k=w+140|0;n:{if((k|0)==(h|0))break n;if(n=u[h+11|0],u[w+151|0]>=0){if((n|0)>=0){n=i[h+4>>2],i[k>>2]=i[h>>2],i[k+4>>2]=n,i[k+8>>2]=i[h+8>>2];break n}D1(k,i[h>>2],i[h+4>>2]);break n}w=k,k=(n|0)<0,O1(w,k?i[h>>2]:h,k?i[h+4>>2]:n)}rr(o+12|0,i[m+68>>2],i[i[f+56>>2]+104>>2],o,0),u[o+31|0]<0&&Z(i[o+20>>2]),k=i[26929],i[r>>2]=i[26928],i[r+4>>2]=k,r=r+8|0;n:{if(u[107731]>=0){k=i[26931],i[r>>2]=i[26930],i[r+4>>2]=k,i[r+8>>2]=i[26932];break n}T(r,i[26930],i[26931])}r=i[o>>2],r&&(i[o+4>>2]=r,Z(r)),v=o+32|0;break A}G0(),H()}u[f+43|0]<0&&Z(i[f+32>>2]),u[f+19|0]<0&&Z(i[f+8>>2]),u[s+32|0]=0,i[s+12>>2]=B,r=i[f+60>>2];A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;X[i[i[r>>2]+8>>2]](r),p(r)}v=f- -64|0;break f}g0(),H()}u[s+11|0]<0&&Z(i[s>>2]);f:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break f;X[i[i[_>>2]+8>>2]](_),p(_)}if(r=l[s+32|0],!(r|!t)){i[t>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,s+12|0,i[e>>2]),A=l[s+32|0],(A|0)==255)break i;break e}g0(),H()}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=0}e=i[24199],i[s+40>>2]=i[24198],i[s+44>>2]=e,X[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function Am(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15908);break i}e:{if((k|0)==1){s=e,w=R4(r),i[s+104>>2]=w,i[e+108>>2]=l0,s=e,w=R4(r),i[s+112>>2]=w,i[e+116>>2]=l0,s=e,w=F0(r),i[s+120>>2]=w,k=R4(r),n=l0;break e}s=e,w=F0(r),i[s+104>>2]=w,i[e+108>>2]=0,s=e,w=F0(r),i[s+112>>2]=w,i[e+116>>2]=0,s=e,w=F0(r),i[s+120>>2]=w,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,s=e,w=F0(r),i[s+136>>2]=w,s=e,w=o2(r),Q[s+140>>1]=w,k=i[r+16>>2],n=k>>>0>=2?2:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=8?8:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,w=F0(r),i[s+144>>2]=w,s=e,w=F0(r),i[s+148>>2]=w,s=e,w=F0(r),i[s+152>>2]=w,s=e,w=F0(r),i[s+156>>2]=w,s=e,w=F0(r),i[s+160>>2]=w,s=e,w=F0(r),i[s+164>>2]=w,s=e,w=F0(r),i[s+168>>2]=w,s=e,w=F0(r),i[s+172>>2]=w,s=e,w=F0(r),i[s+176>>2]=w,k=i[r+16>>2],n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,X[i[i[t>>2]+20>>2]](t,o,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,w=F0(r),i[s+180>>2]=w,l[r+20|0]){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function lr(A,e,r){var f=0,k=0;f=v-656|0,v=f,e=e?10120:6895,l[A|0]&&(i[f+644>>2]=u[A+1|0],i[f+640>>2]=e,k0(r,38182,f+640|0),i[f+628>>2]=u[A+2|0],i[f+624>>2]=e,k0(r,39416,f+624|0),k=i[A+4>>2]-1|0,k>>>0<=3?k=i[(k<<2)+63928>>2]:k=26535,i[f+612>>2]=k,i[f+608>>2]=e,k0(r,33085,f+608|0),i[f+592>>2]=e,k0(r,29991,f+592|0),i[f+576>>2]=u[A+8|0],k0(r,17922,f+576|0),k0(r,26342,0),i[f+560>>2]=u[A+9|0],k0(r,17922,f+560|0),k0(r,26342,0),i[f+544>>2]=u[A+10|0],k0(r,17922,f+544|0),k0(r,26342,0),i[f+528>>2]=u[A+11|0],k0(r,17922,f+528|0),k0(r,26342,0),i[f+512>>2]=u[A+12|0],k0(r,17922,f+512|0),k0(r,26342,0),i[f+496>>2]=u[A+13|0],k0(r,17922,f+496|0),k0(r,26342,0),i[f+480>>2]=u[A+14|0],k0(r,17922,f+480|0),k0(r,26342,0),i[f+464>>2]=u[A+15|0],k0(r,17922,f+464|0),k0(r,26342,0),i[f+448>>2]=u[A+16|0],k0(r,17922,f+448|0),k0(r,26342,0),i[f+432>>2]=u[A+17|0],k0(r,17922,f+432|0),k0(r,26342,0),i[f+416>>2]=u[A+18|0],k0(r,17922,f+416|0),k0(r,26342,0),i[f+400>>2]=u[A+19|0],k0(r,17922,f+400|0),k0(r,26342,0),i[f+384>>2]=u[A+20|0],k0(r,17922,f+384|0),k0(r,26342,0),i[f+368>>2]=u[A+21|0],k0(r,17922,f+368|0),k0(r,26342,0),i[f+352>>2]=u[A+22|0],k0(r,17922,f+352|0),k0(r,26342,0),i[f+336>>2]=u[A+23|0],k0(r,17922,f+336|0),k0(r,26342,0),i[f+320>>2]=u[A+24|0],k0(r,17922,f+320|0),k0(r,26342,0),i[f+304>>2]=u[A+25|0],k0(r,17922,f+304|0),k0(r,26342,0),i[f+288>>2]=u[A+26|0],k0(r,17922,f+288|0),k0(r,26342,0),i[f+272>>2]=u[A+27|0],k0(r,17922,f+272|0),k0(r,26342,0),i[f+256>>2]=u[A+28|0],k0(r,17922,f+256|0),k0(r,26342,0),i[f+240>>2]=u[A+29|0],k0(r,17922,f+240|0),k0(r,26342,0),i[f+224>>2]=u[A+30|0],k0(r,17922,f+224|0),k0(r,26342,0),i[f+208>>2]=u[A+31|0],k0(r,17922,f+208|0),k0(r,26342,0),i[f+192>>2]=u[A+32|0],k0(r,17922,f+192|0),k0(r,26342,0),i[f+176>>2]=u[A+33|0],k0(r,17922,f+176|0),k0(r,26342,0),i[f+160>>2]=u[A+34|0],k0(r,17922,f+160|0),k0(r,26342,0),i[f+144>>2]=u[A+35|0],k0(r,17922,f+144|0),k0(r,26342,0),i[f+128>>2]=u[A+36|0],k0(r,17922,f+128|0),k0(r,26342,0),i[f+112>>2]=u[A+37|0],k0(r,17922,f+112|0),k0(r,26342,0),i[f+96>>2]=u[A+38|0],k0(r,17922,f+96|0),k0(r,26342,0),i[f+80>>2]=u[A+39|0],k0(r,17922,f+80|0),k0(r,42366,0),i[f+68>>2]=u[A+40|0],i[f+64>>2]=e,k0(r,35785,f- -64|0),i[f+52>>2]=u[A+41|0],i[f+48>>2]=e,k0(r,35822,f+48|0),i[f+36>>2]=u[A+42|0],i[f+32>>2]=e,k0(r,34949,f+32|0),i[f+20>>2]=u[A+43|0],i[f+16>>2]=e,k0(r,34909,f+16|0)),l[A+44|0]&&(A=i[A+48>>2],i[f+4>>2]=A,i[f>>2]=e,t0[f+8>>3]=M(M(A|0)/M(30)),k0(r,42480,f)),v=f+656|0}function p9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{if(i[A+64>>2])break i;f=3057;e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:switch(t=r&-3,t-1|0){case 0:case 16:break Z;case 23:break B;case 27:break o;case 1:case 2:case 3:case 5:case 6:case 9:case 10:case 13:case 14:case 17:case 18:case 21:case 22:case 25:case 26:break r;case 15:break e;case 4:case 20:break s;case 7:break v;case 8:case 24:break _;case 11:break l;case 12:case 28:break t;case 19:break w;default:break G}G:switch(t-48|0){case 1:case 2:case 3:break r;case 0:break e;case 4:break w;default:break G}G:switch(t-56|0){case 0:break h;case 4:break u;case 1:case 2:case 3:break r;default:break G}G:switch(t-80|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break G}G:switch(t-112|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break G}switch(t-120|0){case 0:break k;case 4:break f;default:break r}}f=19135;break e}f=7760;break e}f=26348;break e}f=26345;break e}f=26351;break e}f=18352;break e}f=18376;break e}f=18355;break e}f=18399;break e}f=18395;break e}f=18403;break e}f=1766;break e}f=2996;break e}f=2951;break e}f=2955;break e}f=0}if(t=f,!f)break i;o=v-16|0,v=o;e:{r:{if(!pi(18407,u[f|0])){i[31336]=28;break r}if(k=2,pi(t,43)||(k=l[t|0]!=114),f=pi(t,120)?k|128:k,f=pi(t,101)?f|524288:f,k=f,s=f|64,f=l[t|0],k=(f|0)==114?k:s,k=(f|0)==119?k|512:k,i[o>>2]=438,i[o+4>>2]=0,k=Y_(-100,e|0,((f|0)==97?k|1024:k)|32768,o|0)|0,k>>>0>=4294963201&&(i[31336]=0-k,k=-1),(k|0)<0)break e;n=v-32|0,v=n;f:{A:{k:{if(!pi(18407,u[t|0])){i[31336]=28;break k}if(f=p2(1176),f)break A}e=0;break f}Ae(f,0,144),pi(t,43)||(i[f>>2]=l[t|0]==114?8:4);A:{if(l[t|0]!=97){e=i[f>>2];break A}e=Q7(k|0,3,0)|0,e&1024||(e=e|1024,i[n+16>>2]=e,i[n+20>>2]=e>>31,Q7(k|0,4,n+16|0)|0),e=i[f>>2]|128,i[f>>2]=e}i[f+80>>2]=-1,i[f+48>>2]=1024,i[f+60>>2]=k,i[f+44>>2]=f+152;A:{if(e&8||(i[n>>2]=n+24,i[n+4>>2]=0,F_(k|0,21523,n|0)|0))break A;i[f+80>>2]=10}i[f+40>>2]=1950,i[f+36>>2]=1949,i[f+32>>2]=1956,i[f+12>>2]=1948,l[125361]||(i[f+76>>2]=-1),e=i[31339],i[f+56>>2]=e,e&&(i[e+52>>2]=f),i[31339]=f,e=f}if(v=n+32|0,n=e,n)break e;I7(k|0)|0}n=0}v=o+16|0,i[A+64>>2]=n,e=0;e:{if(!n)break e;i[A+88>>2]=r,i[A+92>>2]==34&&(i[n+80>>2]=-1,i[n+48>>2]=0,i[n>>2]=i[n>>2]|64,i[A+92>>2]=0);r:{if(!(r&2)||(i[A+92>>2]=0,!W3(i[A+64>>2],0,0,2)))break r;qA(i[A+64>>2]),i[A+64>>2]=0,e=0;break e}e=A}k=e}return k}function km(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=E(56),i[n+4>>2]=e,i[n+8>>2]=48,i[n+12>>2]=-2147483592,r=l[9112]|l[9113]<<8|(l[9114]<<16|l[9115]<<24),f=l[9108]|l[9109]<<8|(l[9110]<<16|l[9111]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+48|0]=0,r=l[9152]|l[9153]<<8|(l[9154]<<16|l[9155]<<24),f=l[9148]|l[9149]<<8|(l[9150]<<16|l[9151]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[9144]|l[9145]<<8|(l[9146]<<16|l[9147]<<24),f=l[9140]|l[9141]<<8|(l[9142]<<16|l[9143]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9136]|l[9137]<<8|(l[9138]<<16|l[9139]<<24),f=l[9132]|l[9133]<<8|(l[9134]<<16|l[9135]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9128]|l[9129]<<8|(l[9130]<<16|l[9131]<<24),f=l[9124]|l[9125]<<8|(l[9126]<<16|l[9127]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9120]|l[9121]<<8|(l[9122]<<16|l[9123]<<24),f=l[9116]|l[9117]<<8|(l[9118]<<16|l[9119]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+16|0}function nm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=E(48),i[n+4>>2]=e,i[n+8>>2]=46,i[n+12>>2]=-2147483600,r=l[9065]|l[9066]<<8|(l[9067]<<16|l[9068]<<24),f=l[9061]|l[9062]<<8|(l[9063]<<16|l[9064]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[9103]|l[9104]<<8|(l[9105]<<16|l[9106]<<24),f=l[9099]|l[9100]<<8|(l[9101]<<16|l[9102]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[9097]|l[9098]<<8|(l[9099]<<16|l[9100]<<24),f=l[9093]|l[9094]<<8|(l[9095]<<16|l[9096]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9089]|l[9090]<<8|(l[9091]<<16|l[9092]<<24),f=l[9085]|l[9086]<<8|(l[9087]<<16|l[9088]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9081]|l[9082]<<8|(l[9083]<<16|l[9084]<<24),f=l[9077]|l[9078]<<8|(l[9079]<<16|l[9080]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9073]|l[9074]<<8|(l[9075]<<16|l[9076]<<24),f=l[9069]|l[9070]<<8|(l[9071]<<16|l[9072]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+16|0}function tm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],k=n+i[i[f+8>>2]-12>>2]|0,o=f+12|0,J0(k,o),u[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,_=R0(o),i[_>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),s=n,t=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,29643,13),n=i[e+100>>2]&1,Y(Y(k,n?5217:7951,n|2),42713,1),n=i[e+104>>2],B=i[e+108>>2],(n|0)!=(B|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(K2(Y(e,30668,18),i[n>>2],i[n+4>>2]),42713,1),k=f+148|0,s0(k,r),s=e,t=k,e=u[f+159|0],k=(e|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),m=f+8|0,k=Y(m,31862,12),e=i[n+8>>2],s=i[n+12>>2],o=v-16|0,v=o,G1(o+8|0,k);i:{if(!l[o+8|0]||(h=o+4|0,w=i[(k+i[i[k>>2]-12>>2]|0)+28>>2],i[h>>2]=w,(w|0)!=129624&&(i[w+4>>2]=i[w+4>>2]+1),w=c0(h,129488),e2(h),i[o>>2]=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],W=k+i[i[k>>2]-12>>2]|0,t=t6(W),g=o,I=X[i[i[w>>2]+20>>2]](w,i[o>>2],W,t,e,s)|0,i[g+4>>2]=I,i[h>>2]))break i;m4(k+i[i[k>>2]-12>>2]|0,5)}if(_1(o+8|0),v=o+16|0,Y(k,42713,1),e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(m,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(Lt(Y(e,30435,20),Q[n+16>>1]),42713,1),k=f+148|0,s0(k,r),s=e,t=k,e=u[f+159|0],k=(e|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(Lt(Y(f+8|0,30635,21),Q[n+18>>1]),42713,1),n=n+24|0,(B|0)==(n|0))break}e=i[f+60>>2];i:{e:{if(e&16){n=i[f+56>>2],e=i[f+36>>2],n>>>0<e>>>0&&(i[f+56>>2]=e,n=e),e=f+32|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}g0(),H()}if(!n)break i;z(A,r,n)}u[A+n|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[_>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(_),p0(f- -64|0),v=f+160|0}function um(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],s=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(s,n),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,s=R0(n),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,32742,22),Y(S0(k,i[e+104>>2]),29232,3),Y(S0(k,i[e+108>>2]),29232,3),Y(S0(k,i[e+112>>2]),42713,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,28020,12);i:{if(l[e+116|0]==1){Y(k,42467,12),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(d1(Y(d1(Y(d1(Y(f+8|0,19195,7),t0[e+120>>3]),21063,1),t0[e+128>>3]),21063,1),t0[e+136>>3]),21063,1),t0[e+144>>3]),41737,2);break i}k=f+8|0,Y(k,42369,9),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,32810,9),t0[e+152>>3]),42713,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,31067,9),t0[e+160>>3]),42713,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(f+8|0,32779,9),t0[e+168>>3]),42713,1)}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,32174,28),i[e+176>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function pf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(f=e,t=i[f>>2],t){if(r=i[f+4>>2],!r)break e;for(;f=r,r=i[r>>2],!!r;);}if(t=i[f+4>>2],t)break e;n=i[f+8>>2],t=0,k=1;break i}n=i[f+8>>2],i[t+8>>2]=n,k=0}r=i[n>>2];i:{if((f|0)==(r|0)){if(i[n>>2]=t,(A|0)==(f|0)){r=0,A=t;break i}r=i[n+4>>2];break i}i[n+4>>2]=t}if(o=l[f+12|0],(e|0)!=(f|0)){n=i[e+8>>2],i[f+8>>2]=n;i:{if(i[n>>2]==(e|0)){i[n>>2]=f;break i}i[n+4>>2]=f}n=i[e>>2],i[f>>2]=n,i[n+8>>2]=f,n=i[e+4>>2],i[f+4>>2]=n,n&&(i[n+8>>2]=f),u[f+12|0]=l[e+12|0],A=(A|0)==(e|0)?f:A}if(!(!A|!(o&1))){if(k)for(;;){e=l[r+12|0];i:{if(k=i[r+8>>2],f=i[k>>2],(f|0)!=(r|0)){if(!(e&1)){u[r+12|0]=1,u[k+12|0]=0,f=i[k+4>>2],e=i[f>>2],i[k+4>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f>>2]=k,i[k+8>>2]=f,e=i[r>>2],A=(e|0)==(A|0)?r:A,r=i[e+4>>2]}e:{r:{f=i[r>>2];f:{if(!(l[f+12|0]!=1&&f)){if(e=i[r+4>>2],l[e+12|0]!=1&&e)break f;if(u[r+12|0]=0,r=i[r+8>>2],l[r+12|0]&&(r|0)!=(A|0))break i;u[r+12|0]=1;return}if(e=i[r+4>>2],!e)break r}if(l[e+12|0]==1)break r;f=r;break e}u[f+12|0]=1,u[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],u[f+12|0]=l[r+12|0],u[r+12|0]=1,u[e+12|0]=1,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e;return}if(!(e&1)){u[r+12|0]=1,u[k+12|0]=0,e=i[f+4>>2],i[k>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[r+4>>2],A=(e|0)==(A|0)?r:A,r=i[e>>2]}e=i[r>>2];e:{if(!(!e|l[e+12|0]==1)){f=r;break e}if(f=i[r+4>>2],!(l[f+12|0]!=1&&f)){if(u[r+12|0]=0,r=i[r+8>>2],l[r+12|0]==1&(A|0)!=(r|0))break i;u[r+12|0]=1;return}if(e){if(!(u[e+12|0]&1)){f=r;break e}f=i[r+4>>2]}u[f+12|0]=1,u[r+12|0]=0,A=i[f>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],u[f+12|0]=l[r+12|0],u[r+12|0]=1,u[e+12|0]=1,e=i[r>>2],A=i[e+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e+4>>2]=r,i[r+8>>2]=e;return}e=i[r+8>>2],r=i[(i[e>>2]==(r|0)?4:0)+e>>2]}u[t+12|0]=1}}function om(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;f=v-16|0,v=f,B=e,m=W2(r),u[B+100|0]=m,B=e,m=W2(r),u[B+101|0]=m,B=e,m=W2(r),u[B+102|0]=m,B=e,m=W2(r),u[B+103|0]=m,B=e,m=(W2(r)&3)+1|0,u[B+104|0]=m;i:{if(w=W2(r)&31,!w)break i;for(_=e+116|0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;e:{if(!t){n=0,k=0;break e}k=E(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0);e:{k=i[e+120>>2];r:{if(k>>>0<u0[e+124>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break e;t=E(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&z(t,o,n),i[k+4>>2]=h}k=k+12|0;break r}k=p6(_,f+4|0)}if(i[e+120>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)!=(s|0))continue;break i}break}G0(),H()}i:{e:{if(w=W2(r),w)for(_=e+128|0,s=0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;r:{if(!t){n=0,k=0;break r}k=E(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0),k=i[e+132>>2];r:{if(k>>>0<u0[e+136>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break e;t=E(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&z(t,o,n),i[k+4>>2]=h}k=k+12|0;break r}k=p6(_,f+4|0)}if(i[e+132>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)==(s|0))break}r:{if(!i[r+16>>2]||(k=l[e+101|0]-66|0,1<<k&4196353&&k>>>0<=22)||(B=e,m=W2(r)&3,i[B+108>>2]=m,B=e,m=W2(r)&7|8,u[B+112|0]=m,B=e,m=W2(r)&7|8,u[B+113|0]=m,w=W2(r),!w))break r;for(_=e+140|0,s=0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;f:{if(!t){n=0,k=0;break f}k=E(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0),k=i[e+144>>2];f:{if(k>>>0<u0[e+148>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break i;t=E(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&z(t,o,n),i[k+4>>2]=h}k=k+12|0;break f}k=p6(_,f+4|0)}if(i[e+144>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)==(s|0))break}}r:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break r;Z(i[f+4>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}v=f+16|0;return}G0(),H()}G0(),H()}function y9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=i[A+18588>>2],h=i[k+132>>2],f=-1<<i[h+8268>>2],t=f&r,B=i[A+18592>>2],w=i[k+124>>2],s=e&f,(s|0)==i[A+18524>>2]&(t|0)==i[A+18528>>2]||(i[A+18528>>2]=t,i[A+18524>>2]=s,i[A+18532>>2]=i[A+18520>>2]),o=i[B+808>>2],_=i[w+16892>>2],n=(o|0)/(_|0)|0,k=o-G(n,_)|0,o=i[w+16884>>2],o=(s|0)==(G(k,o)|0)&(t|0)==(G(n,o)|0),n=0,k=i[w+16876>>2],f=-1<<k^-1,!l[h+46|0]|f&(t|s)||(n=Su(h,s>>k,t>>k));i:{if(!(!l[h+45|0]|(s|f&t))||n|o){k=i[A+18592>>2]+800|0;break i}k=A+18532|0}f=i[k>>2];i:{e:{o=s-1|0;r:{if(!Et(i[A+18588>>2],s,t,o,t)){n=i[A+18588>>2],k=f;break r}if(n=i[A+18588>>2],_=i[w+16936>>2],k=f,i[A+4>>2]!=i[(i[h+8496>>2]+(o>>_<<2)|0)+(G(i[w+16924>>2],t>>_)<<2)>>2]>>(i[w+16876>>2]-_<<1))break r;if(k=o,o=i[n+168>>2],k=k>>o,(k|0)<0||(_=i[n+172>>2],(_|0)<=(k|0)))break e;if(o=t>>o,(o|0)<0|(o|0)>=i[n+176>>2])break i;k=u[((i[n+160>>2]+G(k,3)|0)+G(G(o,_),3)|0)+2|0]}o=n,n=t-1|0;r:{if(!Et(o,s,t,s,n)||(t=i[w+16936>>2],i[A+4>>2]!=i[(i[h+8496>>2]+(s>>t<<2)|0)+(G(i[w+16924>>2],n>>t)<<2)>>2]>>(i[w+16876>>2]-t<<1)))break r;if(o=s,f=i[A+18588>>2],s=i[f+168>>2],t=o>>s,(t|0)<0||(o=i[f+172>>2],(o|0)<=(t|0)))break e;if(n=n>>s,(n|0)<0|(n|0)>=i[f+176>>2])break i;f=u[((i[f+160>>2]+G(t,3)|0)+G(G(n,o),3)|0)+2|0]}k=i[A+18504>>2]+((f+k|0)+1>>1)|0,f=i[w+16836>>2],n=((k+(f<<1)|0)+52|0)%(f+52|0)|0,i[A+18536>>2]=(n|0)>0?n:0,s=i[w+16844>>2],k=0-s|0,t=n-f|0,f=i[A+18516>>2]+(i[B+756>>2]+(t+i[h+36>>2]|0)|0)|0,n=(f|0)<(k|0)?k:(f|0)>=57?57:f,f=i[A+18512>>2]+(i[B+752>>2]+(t+i[h+32>>2]|0)|0)|0,f=(f|0)<(k|0)?k:(f|0)>=57?57:f;r:{if(i[w+16848>>2]!=1)break r;f:{if((f|0)<30)break f;if(f>>>0>=43){f=f-6|0;break f}f=i[(f<<2)+63720>>2]}if((n|0)<30)break r;if(n>>>0>=43){n=n-6|0;break r}n=i[(n<<2)+63720>>2]}if(k=n+s|0,i[A+18544>>2]=(k|0)>0?k:0,k=f+s|0,i[A+18540>>2]=(k|0)>0?k:0,f=i[A+18588>>2],n=i[f+168>>2],k=e>>n,(k|0)<0||(w=i[f+172>>2],(w|0)<=(k|0)))break e;if(e=r>>n,(e|0)<0|i[f+176>>2]<=(e|0))break i;if(f=i[f+160>>2],r=(f+G(k,3)|0)+G(G(e,w),3)|0,r=(l[r|0]|l[r+1|0]<<8)&7,r=(r>>>0<=3?3:r)-n|0,(r|0)!=31)for(r=1<<r,n=r+e|0,s=r+k|0;;){for(h=(f+G(G(e,w),3)|0)+2|0,r=k;u[h+G(r,3)|0]=t,r=r+1|0,(s|0)>(r|0););if(e=e+1|0,!((n|0)>(e|0)))break}i[A+18520>>2]=t;return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function Ki(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=e-1|0,f=k,r=(k|0)/2|0,k=e+65535>>>0<131073,s=k?f:r,n=i[A+124>>2],t=n>>31,e=k?2:1,r=i[A+128>>2];i:{if((e|0)==(r|0)){if(f=(s>>31)+t|0,t=n+s|0,f=t>>>0<s>>>0?f+1|0:f,r=f,!(t- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,f=e,e=t+(e|1)|0,f=f+r|0,t=G2(e,e>>>0<t>>>0?f+1|0:f,2,0),e=1;break i}if(e=r,o=e>>31,r=O0(e,o,s,s>>31),w=l0,h=r,s=n,r=k&31,(k&63)>>>0>=32?(f=n<<r,n=0):(f=(1<<r)-1&s>>>32-r|t<<r,n=s<<r),t=h+n|0,r=f+w|0,r=n>>>0>t>>>0?r+1|0:r,w=0-(r+(t>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(f=e<<n,k=0):(f=(1<<n)-1&s>>>32-n|o<<n,k=s<<n),e=k,n=f,e=0-(f+(e>>>0>2147483647)|0)|w,(e|0)==1|e>>>0>1)for(;e=n>>31,f=e,e=k+(e|1)|0,f=f+n|0,k=G2(e,e>>>0<k>>>0?f+1|0:f,2,0),n=l0,e=r>>31,f=e,e=t+(e|1)|0,r=f+r|0,t=G2(e,e>>>0<t>>>0?r+1|0:r,2,0),e=l0,r=e,(e-(t>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+108>>2],r=n,k=i[A+112>>2],A=r-k|0,n=k>>31,r=(r>>31)-(n+(r>>>0<k>>>0)|0)|0,f=0-(r+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(f|0)==1|f>>>0>1){for(;f=n>>31,o=k+(f|1)|0,f=f+n|0,k=G2(o,k>>>0>o>>>0?f+1|0:f,2,0),n=l0,f=r>>31,o=A+(f|1)|0,r=f+r|0,A=G2(o,A>>>0>o>>>0?r+1|0:r,2,0),r=l0,(r-(A>>>0<2147483648)|0)!=-1;);n=k>>31}f=n<<1|k>>>31,k=k<<1,r=f,o=A>>31,f=0-(r+(k>>>0>2147483646)|0)|0-(o+(A>>>0>2147483647)|0),(f|0)==1|f>>>0>1&&(f=n>>31,n=k+(f|1)|0,r=f+r|0,k=G2(n,n>>>0<k>>>0?r+1|0:r,2,0),f=o>>31,n=A+(f|1)|0,f=f+o|0,A=G2(n,A>>>0>n>>>0?f+1|0:f,2,0)),n=t>>31;i:{if((e|0)==(k|0)){if(k=A,r=t-k|0,n=n-((k>>31)+(k>>>0>t>>>0)|0)|0,k=r,A=e,r=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(r+(e>>>0>2147483647)|0)))break i;for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=G2(e,A>>>0>e>>>0?f+1|0:f,2,0),r=l0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(r=k>>31,n=O0(k,r,t,n),f=l0,o=e>>31,A=O0(e,o,A,A>>31),t=n-A|0,n=f-(l0+(A>>>0>n>>>0)|0)|0,A=O0(k,r,e,o),k=t,r=l0,e=0-((k>>>0>2147483647)+n|0)|0-(r+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=G2(e,A>>>0>e>>>0?f+1|0:f,2,0),t=l0,r=t,f=r-(A>>>0<2147483648)|0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)&f)!=-1;);e=A}return n=(e|0)/2|0,A=k+n|0,r=(n>>31)+(k>>31)|0,G2(A,A>>>0<k>>>0?r+1|0:r,e,e>>31)}function sr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;t=v-16|0,v=t;i:{e:{r:{if(i[A+140>>2])break r;e=E(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92612,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1836019574,i[r>>2]=92652,i[A+140>>2]=r,r=i[A+144>>2],i[A+144>>2]=e;f:{A:{if(!r){k=A+16|0;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(X[i[i[r>>2]+8>>2]](r),p(r)),k=A+16|0,f=i[A+140>>2],e=i[A+144>>2],e)break A;e=0;break f}i[e+4>>2]=i[e+4>>2]+1}r=i[k+4>>2],n=i[k+8>>2];f:{if(r>>>0<n>>>0){i[r+4>>2]=e,i[r>>2]=f,e=r+8|0;break f}if(s=i[k>>2],w=r-s|0,h=w>>3,r=h+1|0,r>>>0>=536870912)break e;if(n=n-s|0,o=n>>2,n=n>>>0>=2147483640?536870911:r>>>0<o>>>0?o:r,n){if(n>>>0>=536870912)break i;r=E(n<<3)}else r=0;if(o=r+w|0,i[o+4>>2]=e,i[o>>2]=f,f=o-(h<<3)|0,w&&z(f,s,w),i[k+8>>2]=r+(n<<3),e=o+8|0,i[k+4>>2]=e,i[k>>2]=f,!s)break f;Z(s)}i[k+4>>2]=e,e=E(200),i[e>>2]=92732,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=104428,r=i[12448],i[e+160>>2]=i[12447],i[e+164>>2]=r,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,Q[e+156>>1]=256,i[e+152>>2]=65536,r=i[12450],i[e+168>>2]=i[12449],i[e+172>>2]=r,r=i[12452],i[e+176>>2]=i[12451],i[e+180>>2]=r,r=i[12454],i[e+184>>2]=i[12453],i[e+188>>2]=r,i[e+192>>2]=i[12455],i[e+196>>2]=0,i[e+32>>2]=1836476516,i[A+148>>2]=f,r=i[A+152>>2],i[A+152>>2]=e;f:{A:{if(!r){k=i[A+140>>2],i[t+12>>2]=e,i[t+8>>2]=f;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(X[i[i[r>>2]+8>>2]](r),p(r)),k=i[A+140>>2],r=i[A+148>>2],e=i[A+152>>2],i[t+12>>2]=e,i[t+8>>2]=r,!e)break f}i[e+4>>2]=i[e+4>>2]+1}if(r2(k+36|0,t+8|0),A=i[t+12>>2],!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+16|0;return}G0(),H()}x0(),H()}function lm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-32|0,v=t;i:{e:{r:{if(i[e+28>>2]!=1885954932||(s=i[f>>2],h=i[f+4>>2],(s|0)==(h|0)))break r;for(;;){k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);f:{if(i[k+24>>2]==i[e+24>>2])break f;P1(t+20|0,i[k+28>>2]);A:{if(i[k+28>>2]!=1635088502||(fo(k)|0)!=1)break A;w=i[k+244>>2],o=i[k+248>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);k:{if(!w){if(f=E(32),i[t+8>>2]=f,i[t+12>>2]=30,i[t+16>>2]=-2147483616,k=l[27257]|l[27258]<<8|(l[27259]<<16|l[27260]<<24),n=l[27253]|l[27254]<<8|(l[27255]<<16|l[27256]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+30|0]=0,k=l[27279]|l[27280]<<8|(l[27281]<<16|l[27282]<<24),n=l[27275]|l[27276]<<8|(l[27277]<<16|l[27278]<<24),u[f+22|0]=n,u[f+23|0]=n>>>8,u[f+24|0]=n>>>16,u[f+25|0]=n>>>24,u[f+26|0]=k,u[f+27|0]=k>>>8,u[f+28|0]=k>>>16,u[f+29|0]=k>>>24,k=l[27273]|l[27274]<<8|(l[27275]<<16|l[27276]<<24),n=l[27269]|l[27270]<<8|(l[27271]<<16|l[27272]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[27265]|l[27266]<<8|(l[27267]<<16|l[27268]<<24),n=l[27261]|l[27262]<<8|(l[27263]<<16|l[27264]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,K(A,2,0,t+8|0),u[t+19|0]>=0)break k;Z(i[t+8>>2]);break k}if(IA(t+8|0,w,1635088492),f=i[t+8>>2],n=i[t+12>>2],(f|0)!=(n|0)){_=i[e+24>>2];n:{for(;;){if(i[f>>2]!=(_|0)){if(f=f+4|0,(n|0)!=(f|0))continue;break n}break}if(f=0,k=X0(k,106612,106744),!r|!k||(i[r+4>>2]=i[r+4>>2]+1,f=r),i[e+320>>2]=k,k=i[e+324>>2],i[e+324>>2]=f,!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break n;X[i[i[k>>2]+8>>2]](k),p(k)}f=i[t+8>>2]}if(!f)break k;i[t+12>>2]=f,Z(f)}k:{if(!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break k;X[i[i[o>>2]+8>>2]](o),p(o)}if(!w)break e}if(u[t+31|0]>=0)break f;Z(i[t+20>>2])}f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}if(s=s+8|0,(h|0)==(s|0))break}}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}if(u[t+31|0]<0&&Z(i[t+20>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=t+32|0}function sm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v+-64|0,v=t,B=X[i[i[e>>2]+52>>2]](e,r,0)|0,w=t+40|0,o=v-16|0,v=o,C0(r,0),u2(r,0),u2(r,F[e+100>>1]),u2(r,F[e+102>>1]),u2(r,0),C0(r,i[e+104>>2]),C0(r,i[e+108>>2]),C0(r,i[e+112>>2]),u2(r,F[e+116>>1]),u2(r,F[e+118>>1]),C0(r,i[e+120>>2]),C0(r,i[e+124>>2]),C0(r,0),u2(r,F[e+128>>1]);i:{if(u[e+143|0]>=0){i[o+8>>2]=i[e+140>>2],f=i[e+136>>2],i[o>>2]=i[e+132>>2],i[o+4>>2]=f;break i}T(o,i[e+132>>2],i[e+136>>2])}i:{e:{f=i[r+12>>2]+32|0,k=i[r+4>>2],s=i[r>>2],h=k-s|0;r:{if(f>>>0<=h>>>0)break r;if(n=f-h|0,_=i[r+8>>2],n>>>0<=_-k>>>0){n&&o0(k,0,n),i[r+4>>2]=k+n;break r}if((f|0)<0)break e;if(k=_-s|0,_=k<<1,_=k>>>0>=1073741823?2147483647:f>>>0<_>>>0?_:f,k=E(_),n&&o0(k+h|0,0,n),h&&z(k,s,h),i[r+8>>2]=k+_,i[r+4>>2]=f+k,i[r>>2]=k,!s)break r;Z(s)}if(k=i[o+4>>2],f=u[o+11|0],s=i[r+12>>2],i[r+12>>2]=s+1,n=0,f=(f|0)<0?k:f,u[s+i[r>>2]|0]=f>>>0>31?31:f,k=u[o+11|0],f=(k|0)<0?i[o+4>>2]:k,!f)break i;for(k=k>>>31|0;;){if(f=l[(k?i[o>>2]:o)+n|0],k=i[r+12>>2],i[r+12>>2]=k+1,u[k+i[r>>2]|0]=f,k=u[o+11|0],f=(k|0)<0?i[o+4>>2]:k,n=n+1|0,n>>>0>=31)break i;if(k=k>>>31|0,!(f>>>0>n>>>0))break}break i}G0(),H()}i:{if(f>>>0>=31)break i;if(k=30-f|0,s=(f^-1)+32&3,s)for(n=0;h=i[r+12>>2],i[r+12>>2]=h+1,u[h+i[r>>2]|0]=0,f=f+1|0,n=n+1|0,(s|0)!=(n|0););if(k>>>0<3)break i;for(;n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,f=f+4|0,(f|0)!=31;);}u[o+11|0]<0&&Z(i[o>>2]),u2(r,F[e+144>>1]),u2(r,F[e+146>>1]),f=i[26929],i[w>>2]=i[26928],i[w+4>>2]=f,w=w+8|0;i:{if(u[107731]>=0){f=i[26931],i[w>>2]=i[26930],i[w+4>>2]=f,i[w+8>>2]=i[26932];break i}T(w,i[26930],i[26931])}v=o+16|0;i:{if(i[t+40>>2]){e=i[t+44>>2],i[A>>2]=i[t+40>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+56>>2],e=i[t+52>>2],i[A+8>>2]=i[t+48>>2],i[A+12>>2]=e,i[t+56>>2]=0,i[t+48>>2]=0,i[t+52>>2]=0;break i}if(Du(t+20|0,e,r),u[t+39|0]<0&&Z(i[t+28>>2]),f1(t,e,r,B),u[t+19|0]<0&&Z(i[t+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[t+59|0]<0&&Z(i[t+48>>2]),v=t- -64|0}function wm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,w=R0(n),i[w>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(o,31727,15),n=f+148|0,P1(n,i[e+104>>2]),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),42713,1),u[f+159|0]<0&&Z(i[f+148>>2]),l[e+112|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(o,31021,16),i[e+108>>2]),42713,1)),l[e+120|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(o,29384,34),i[e+116>>2]),42713,1)),i[e+128>>2]!=i[e+124>>2])for(k=0;;){n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(o,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=k+1|0,Y(I0(Y(o,19216,1),n),32765,4),t=G(k,12),k=i[(t+i[e+124>>2]|0)+4>>2];i:{if(k){if(t=f+148|0,X[i[i[k>>2]+8>>2]](t,k),s=t,k=u[f+159|0],t=(k|0)<0,Y(Y(o,t?i[f+148>>2]:s,t?i[f+152>>2]:k),42713,1),u[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}Y(I0(Y(o,20967,26),i[t+i[e+124>>2]>>2]),42712,2)}if(k=n,!(k>>>0<(i[e+128>>2]-i[e+124>>2]|0)/12>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[w>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(w),p0(f- -64|0),v=f+160|0}function Y9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{e:{r:{f:switch(e-A>>3){case 2:if(i[e-4>>2]<=i[A+4>>2])break r;return f=i[A>>2],r=i[A+4>>2],k=e-8|0,e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,i[k>>2]=f,i[k+4>>2]=r,1;case 3:if(n=e-8|0,k=e-4|0,f=i[k>>2],r=i[A+12>>2],(r|0)<=i[A+4>>2]){if((r|0)>=(f|0)||(f=i[A+8>>2],r=i[A+12>>2],e=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=e,i[n>>2]=f,i[n+4>>2]=r,i[A+12>>2]<=i[A+4>>2]))break r;e=i[A+8>>2],r=i[A+12>>2];break e}if(e=i[A>>2],t=i[A+4>>2],(r|0)<(f|0)){r=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=r;break i}if(f=i[A+8>>2],r=i[A+12>>2],i[A+8>>2]=e,i[A+12>>2]=t,i[A>>2]=f,i[A+4>>2]=r,(t|0)>=i[k>>2])break r;r=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=r;break i;case 4:return Er(A,A+8|0,A+16|0,e-8|0),1;case 5:if(Er(A,A+8|0,A+16|0,A+24|0),i[e-4>>2]<=i[A+28>>2]||(f=i[A+24>>2],r=i[A+28>>2],k=e-8|0,e=i[k+4>>2],i[A+24>>2]=i[k>>2],i[A+28>>2]=e,i[k>>2]=f,i[k+4>>2]=r,i[A+28>>2]<=i[A+20>>2])||(e=i[A+24>>2],r=i[A+28>>2],f=i[A+20>>2],i[A+24>>2]=i[A+16>>2],i[A+28>>2]=f,i[A+16>>2]=e,i[A+20>>2]=r,(r|0)<=i[A+12>>2])||(f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=e,i[A+12>>2]=r,(r|0)<=i[A+4>>2]))break r;break e;case 0:case 1:break r;default:break f}t=i[A+20>>2],f=i[A+12>>2],k=i[A+4>>2];f:{if((f|0)<=(k|0)){if((f|0)>=(t|0)||(r=i[A+16>>2],t=i[A+20>>2],f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=r,i[A+12>>2]=t,(k|0)>=(t|0)))break f;f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=r,i[A+4>>2]=t;break f}if(r=i[A>>2],n=i[A+4>>2],(f|0)<(t|0)){k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A>>2]=k,i[A+4>>2]=f;break f}if(k=i[A+8>>2],f=i[A+12>>2],i[A+8>>2]=r,i[A+12>>2]=n,i[A>>2]=k,i[A+4>>2]=f,(n|0)>=(t|0))break f;k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A+8>>2]=k,i[A+12>>2]=f}if(k=A+24|0,(k|0)==(e|0))break r;for(f=A+16|0;;){f:{if(i[k+4>>2]<=i[f+4>>2])break f;for(s=i[k>>2],n=i[k+4>>2],r=k;;){A:{if(t=r,r=f,f=i[r+4>>2],i[t>>2]=i[r>>2],i[t+4>>2]=f,(A|0)==(r|0)){r=A;break A}if(f=r-8|0,i[r-4>>2]<(n|0))continue}break}if(i[r>>2]=s,i[r+4>>2]=n,o=o+1|0,(o|0)!=8)break f;return(k+8|0)==(e|0)}if(f=k,k=k+8|0,(k|0)==(e|0))break}}return 1}return f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=e,i[A+4>>2]=r,1}return i[n>>2]=e,i[n+4>>2]=t,1}function R9(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,r=i[e+20>>2],f=i[r+48>>2],r=i[r+52>>2];i:{if(!r){n=Ve(f,e+112|0);break i}if(i[r+4>>2]=i[r+4>>2]+1,n=Ve(f,e+112|0),f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;X[i[i[r>>2]+8>>2]](r),p(r)}i[e+116>>2]=i[e+112>>2],f=i[e+264>>2];i:{if(!f||(r=i[e+20>>2],o=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|l[f+28|0]!=1||(o=Ve(o,f+16|0),wA(i[f+8>>2],o),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}f=i[e+268>>2];i:{if(!f||(r=i[e+20>>2],o=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|l[f+28|0]!=1||(o=Ve(o,f+16|0),wA(i[f+8>>2],o),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}Au(i[e+196>>2],n),n=i[e+264>>2];i:{if(!n)break i;i[k+8>>2]=i[e+172>>2],r=i[e+176>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){xr(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,xr(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}n=i[e+268>>2];i:{if(!n)break i;i[k+8>>2]=i[e+172>>2],r=i[e+176>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){xr(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,xr(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=i[e+204>>2],r=i[f+104>>2],f=i[f+108>>2],(r|0)!=(f|0))for(;n=O0(i[r+4>>2],0,i[r>>2],0),t=t+l0|0,o=s,s=n+s|0,t=o>>>0>s>>>0?t+1|0:t,r=r+8|0,(f|0)!=(r|0););r=i[e+156>>2],i[r+128>>2]=s,i[r+132>>2]=t,t=i[e+220>>2],u[t+124|0]=i[i[e+228>>2]+108>>2]==i[t+108>>2]-i[t+104>>2]>>2,t=i[e+212>>2],s=i[t+108>>2],r=i[t+104>>2];i:{if((s|0)==(r|0)|(s-r|0)==8||(s=i[e+172>>2],i[k+8>>2]=t,e=i[e+216>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(s+36|0,k+8|0),e=i[k+12>>2],!e)||(t=i[e+4>>2],i[e+4>>2]=t-1,t))break i;X[i[i[e>>2]+8>>2]](e),p(e)}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,v=k+16|0}function ai(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=106588,e=i[A+284>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}_i(A+276|0,0),_i(A+272|0,0),Bi(A+268|0,0),Bi(A+264|0,0),u[A+263|0]<0&&Z(i[A+252>>2]),e=i[A+248>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+240>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+232>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+224>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+216>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+208>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+200>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+192>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+184>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+176>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+168>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+160>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+152>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+144>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+136>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+128>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),e=i[A+100>>2],e){if(r=e,f=i[A+104>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+100>>2]}i[A+104>>2]=e,Z(r)}return e=i[A+68>>2],e&&(i[A+72>>2]=e,Z(e)),z2(i[A+44>>2]),u[A+63|0]<0&&Z(i[A+52>>2]),u[A+15|0]<0&&Z(i[A+4>>2]),A|0}function $i(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=e-1|0,r=k,f=(k|0)/2|0,k=e+65535>>>0<131073,s=k?r:f,n=i[A+116>>2],t=n>>31,e=k?2:1,f=i[A+120>>2];i:{if((e|0)==(f|0)){if(r=(s>>31)+t|0,t=n+s|0,r=t>>>0<s>>>0?r+1|0:r,f=r,!(t- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,r=e,e=t+(e|1)|0,r=r+f|0,t=G2(e,e>>>0<t>>>0?r+1|0:r,2,0),e=1;break i}if(e=f,o=e>>31,f=O0(e,o,s,s>>31),w=l0,h=f,s=n,f=k&31,(k&63)>>>0>=32?(r=n<<f,n=0):(r=(1<<f)-1&s>>>32-f|t<<f,n=s<<f),t=h+n|0,f=r+w|0,f=n>>>0>t>>>0?f+1|0:f,w=0-(f+(t>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(r=e<<n,k=0):(r=(1<<n)-1&s>>>32-n|o<<n,k=s<<n),e=k,n=r,e=0-(r+(e>>>0>2147483647)|0)|w,(e|0)==1|e>>>0>1)for(;e=n>>31,r=e,e=k+(e|1)|0,r=r+n|0,k=G2(e,e>>>0<k>>>0?r+1|0:r,2,0),n=l0,e=f>>31,r=e,e=t+(e|1)|0,f=r+f|0,t=G2(e,e>>>0<t>>>0?f+1|0:f,2,0),e=l0,f=e,(e-(t>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+100>>2],f=n,k=i[A+104>>2],A=f-k|0,n=k>>31,f=(f>>31)-(n+(f>>>0<k>>>0)|0)|0,r=0-(f+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(r|0)==1|r>>>0>1){for(;r=n>>31,o=k+(r|1)|0,r=r+n|0,k=G2(o,k>>>0>o>>>0?r+1|0:r,2,0),n=l0,r=f>>31,o=A+(r|1)|0,f=r+f|0,A=G2(o,A>>>0>o>>>0?f+1|0:f,2,0),f=l0,(f-(A>>>0<2147483648)|0)!=-1;);n=k>>31}r=n<<1|k>>>31,k=k<<1,f=r,o=A>>31,r=0-(r+(k>>>0>2147483646)|0)|0-(o+(A>>>0>2147483647)|0),(r|0)==1|r>>>0>1&&(r=n>>31,n=k+(r|1)|0,f=r+f|0,k=G2(n,n>>>0<k>>>0?f+1|0:f,2,0),r=o>>31,n=A+(r|1)|0,r=r+o|0,A=G2(n,A>>>0>n>>>0?r+1|0:r,2,0)),n=t>>31;i:{if((e|0)==(k|0)){if(k=A,f=t-k|0,n=n-((k>>31)+(k>>>0>t>>>0)|0)|0,k=f,A=e,f=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(f+(e>>>0>2147483647)|0)))break i;for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=G2(e,A>>>0>e>>>0?r+1|0:r,2,0),f=l0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(f=k>>31,n=O0(k,f,t,n),r=l0,o=e>>31,A=O0(e,o,A,A>>31),t=n-A|0,n=r-(l0+(A>>>0>n>>>0)|0)|0,A=O0(k,f,e,o),k=t,f=l0,e=0-((k>>>0>2147483647)+n|0)|0-(f+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=G2(e,A>>>0>e>>>0?r+1|0:r,2,0),t=l0,f=t,r=f-(A>>>0<2147483648)|0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)&r)!=-1;);e=A}return(k|0)/(e|0)|0}function hm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(k,s),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,t=f+8|0,i[t+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,s=R0(s),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31650,15),k=i[e+104>>2];i:{if(!k){Y(t,41848,2);break i}if(n=f+148|0,P1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42713,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,30383,25),k=i[e+108>>2];i:{if(!k){Y(t,41848,2);break i}if(n=f+148|0,P1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42713,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31301,21),k=l[e+112|0];i:{if(!k){Y(t,42534,13);break i}Y(S0(t,k),42713,1)}if(!(l[e+112|0]|i[e+124>>2]==i[e+120>>2]))for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:o,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(I0(Y(t,19216,1),k),32765,4),l[i[e+120>>2]+k|0]),42713,1),k=k+1|0,k>>>0<i[e+124>>2]-i[e+120>>2]>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function G8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{e:switch(r|0){case 1:for(r=0,k=i[i[15786]+12>>2];n=k+(r<<1)|0,u[((l[n+1|0]<<3)+A|0)+l[n|0]|0]=l[e+r|0],n=r|1,o=k+(n<<1)|0,u[((l[o+1|0]<<3)+A|0)+l[o|0]|0]=l[e+n|0],r=r+2|0,(r|0)!=64;);break i;case 2:for(n=A+1|0,o=i[i[15786]+12>>2];r=o+(k<<1)|0,t=e+k|0,s=l[t|0],u[((l[r|0]<<1)+A|0)+(l[r+1|0]<<5)|0]=s,u[(n+(l[r|0]<<1)|0)+(l[r+1|0]<<5)|0]=s,t=l[t|0],u[(((l[r|0]<<1)+A|0)+(l[r+1|0]<<5)|0)+16|0]=t,u[((n+(l[r|0]<<1)|0)+(l[r+1|0]<<5)|0)+16|0]=t,k=k+1|0,(k|0)!=64;);break i;case 3:for(n=A+3|0,o=A+2|0,t=A+1|0,w=i[i[15786]+12>>2];r=(s<<1)+w|0,k=e+s|0,f=l[k|0],u[((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0]=f,u[(t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,f=l[k|0],u[(o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,u[(n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+32|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,f=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+64|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,f=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+96|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=f,k=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=k,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=k,s=s+1|0,(s|0)!=64;);break i;default:M0(22224,18199,865,6314),H();case 0:break e}r=i[i[15786]+8>>2],u[((l[r+1|0]<<2)+A|0)+l[r|0]|0]=l[e|0],u[l[r+2|0]+((l[r+3|0]<<2)+A|0)|0]=l[e+1|0],u[l[r+4|0]+((l[r+5|0]<<2)+A|0)|0]=l[e+2|0],u[l[r+6|0]+((l[r+7|0]<<2)+A|0)|0]=l[e+3|0],u[l[r+8|0]+((l[r+9|0]<<2)+A|0)|0]=l[e+4|0],u[l[r+10|0]+((l[r+11|0]<<2)+A|0)|0]=l[e+5|0],u[l[r+12|0]+((l[r+13|0]<<2)+A|0)|0]=l[e+6|0],u[l[r+14|0]+((l[r+15|0]<<2)+A|0)|0]=l[e+7|0],u[l[r+16|0]+((l[r+17|0]<<2)+A|0)|0]=l[e+8|0],u[l[r+18|0]+((l[r+19|0]<<2)+A|0)|0]=l[e+9|0],u[l[r+20|0]+((l[r+21|0]<<2)+A|0)|0]=l[e+10|0],u[l[r+22|0]+((l[r+23|0]<<2)+A|0)|0]=l[e+11|0],u[l[r+24|0]+((l[r+25|0]<<2)+A|0)|0]=l[e+12|0],u[l[r+26|0]+((l[r+27|0]<<2)+A|0)|0]=l[e+13|0],u[l[r+28|0]+((l[r+29|0]<<2)+A|0)|0]=l[e+14|0],u[l[r+30|0]+((l[r+31|0]<<2)+A|0)|0]=l[e+15|0]}}function _m(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;s=v-32|0,v=s,n=E(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94860,o0(n+16|0,0,80),e=i[n+4>>2],t=e+1|0,i[n+4>>2]=t,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,Q[n+22>>1]=2,Q[n+18>>1]=2,Q[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95208,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],B=n+12|0,i[n+96>>2]=B,i[n+8>>2]=e+1,i[n+100>>2]=n,t||(X[i[i[n>>2]+8>>2]](n),p(n)),e=i[r>>2],t=i[e+108>>2],w=i[e+112>>2],_=i[e+116>>2],i[B+120>>2]=i[e+120>>2],i[B+116>>2]=_,i[B+112>>2]=w,i[B+108>>2]=t;i:{e:{for(;;){h=i[I+58412>>2];r:{if(!u1(i[r>>2],h))break r;if(g=o8(i[r>>2],h),C=l8(i[r>>2],h),T0(s+8|0,B,h,g,C,i[k+12>>2],o),i[s+8>>2]){if(e=i[s+12>>2],i[A>>2]=i[s+8>>2],i[A+4>>2]=e,e=A+8|0,u[s+27|0]>=0){r=i[s+20>>2],i[e>>2]=i[s+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+24>>2],u[A+20|0]=1;break e}if(T(e,i[s+16>>2],i[s+20>>2]),e=u[s+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+16>>2]);break e}u[s+27|0]<0&&Z(i[s+16>>2]),W=j0(i[r>>2],h),D=0,t=i[r>>2],w=t+128|0,e=w;f:{A:{if(t=i[t+128>>2],!t)break A;for(;_=(h|0)>i[t+16>>2],e=_?e:t,t=i[(_?4:0)+t>>2],!!t;);if((e|0)==(w|0))break A;if(V=0,_=0,(h|0)<i[e+16>>2])break f;V=i[e+44>>2],_=i[e+56>>2];break f}V=0,_=0}e=f,t=i[e>>2],w=0;f:{if(!t)break f;for(;w=(h|0)>i[t+16>>2],e=w?e:t,t=i[(w?4:0)+t>>2],!!t;);if((e|0)==(f|0)){w=0;break f}if(w=0,(h|0)<i[e+16>>2])break f;D=i[e+56>>2]>>>1|0,w=i[e+44>>2]}if(!C|!g)break r;for(e=i[k+12>>2],h=(W<<1)-e|0,W=e-W|0,S=g&-2,O=g&1,e=0;;){if(y=G(e,_)+V|0,R=(G(e,D)<<1)+w|0,t=0,N=0,(g|0)!=1)for(;m=l[t+y|0],Q[R+(t<<1)>>1]=m<<W|m>>>h,x=t|1,m=l[x+y|0],Q[R+(x<<1)>>1]=m<<W|m>>>h,t=t+2|0,N=N+2|0,(S|0)!=(N|0););if(O&&(m=R+(t<<1)|0,t=l[t+y|0],Q[m>>1]=t<<W|t>>>h),e=e+1|0,(C|0)==(e|0))break}}if(I=I+4|0,(I|0)==28)break}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=B;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=s+32|0}function Bm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;k=v-112|0,v=k,t=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+108>>2]=e,i[k+104>>2]=t,X[i[i[f>>2]+100>>2]](k+92|0,i[f+4>>2],k+104|0,n);i:{e:{r:{r=i[k+92>>2];f:{if(r){if(f=i[k+96>>2],t=i[k+100>>2],e=h2(t),e>>>0>=2147483640)break r;A:{k:{if(e>>>0>=11){o=e|7,n=E(o+1|0),i[k+68>>2]=o-2147483647,i[k+60>>2]=n,i[k+64>>2]=e;break k}if(u[k+71|0]=e,n=k+60|0,!e)break A}if(!e)break A;z(n,t,e)}u[e+n|0]=0,e=K(k+72|0,r,f,k+60|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}u[k+71|0]<0&&Z(i[k+60>>2]),r=0;break f}i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,X[i[i[f>>2]+104>>2]](k+60|0,i[f+4>>2],k+56|0,k+52|0,0);A:{if(!i[k+56>>2]){t=0,r=0;break A}for(n=0,t=0;;){r=t-n|0,o=i[k+52>>2],s=r+o|0;k:{if(s>>>0>r>>>0){if(e=i[k+80>>2],o>>>0<=e-t>>>0){o&&o0(t,0,o),t=t+o|0,i[k+76>>2]=t,n=i[k+72>>2];break k}if((s|0)<0)break e;if(e=e-n|0,t=e<<1,t=e>>>0>=1073741823?2147483647:t>>>0>s>>>0?t:s,e=E(t),o&&o0(e+r|0,0,o),r&&z(e,n,r),i[k+80>>2]=e+t,t=e+s|0,i[k+76>>2]=t,i[k+72>>2]=e,!n){n=e;break k}Z(n),n=e;break k}if(r>>>0<=s>>>0)break k;t=n+s|0,i[k+76>>2]=t}if(e=i[k+52>>2],e&&z(r+n|0,i[k+56>>2],e),X[i[i[f>>2]+104>>2]](k+60|0,i[f+4>>2],k+56|0,k+52|0,0),!i[k+56>>2])break}r=i[k+72>>2]}if(i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,n=0,(r|0)!=(t|0)){if(e=t-r|0,(e|0)<0)break i;n=E(e),e&&z(n,r,e),w=e+n|0}i[k+48>>2]=0,u[k+47|0]=l[k+62|0],u[k+44|0]=1,i[k+36>>2]=0,i[k+40>>2]=0,u[k+34|0]=0,Q[k+32>>1]=1,e=l[k+60|0]|l[k+61|0]<<8,u[k+45|0]=e,u[k+46|0]=e>>>8,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[A+20>>2]=w,i[A+16>>2]=w,i[A+12>>2]=n,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,e=i[k+40>>2],f=i[k+44>>2],n=i[k+48>>2],t=i[k+32>>2],o=i[k+36>>2],u[A+44|0]=0,i[A+40>>2]=n,i[A+32>>2]=e,i[A+36>>2]=f,i[A+24>>2]=t,i[A+28>>2]=o}A=i[k+108>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;X[i[i[A>>2]+8>>2]](A),p(A)}r&&Z(r),v=k+112|0;return}g0(),H()}G0(),H()}G0(),H()}function yf(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=v-48|0,v=k,n=i[e+48>>2],t=i[e+52>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,n,r,f+20|0);i:{if(i[f>>2]){i[k+40>>2]=0,i[k+44>>2]=0;break i}e:{if(n=i[f+20>>2],r=i[f+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(o=i[k+44>>2],e=X0(e,86628,89700),e))break e;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(o=0,e=X0(e,86628,89700),e))break e;if(n=n+8|0,(r|0)==(n|0))break}i[k+40>>2]=0,i[k+44>>2]=0}i[k+40>>2]=0,i[k+44>>2]=0;break i}if(i[k+44>>2]=o,i[k+40>>2]=e,e=i[n+4>>2],i[k+44>>2]=e,!e)break i;i[e+4>>2]=i[e+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),r=i[f+20>>2],r){if(e=r,n=i[f+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];i:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[f+20>>2]}i[f+24>>2]=r,Z(e)}v=f+32|0,e=i[k+40>>2];i:{if(!e){e=E(32),i[k+4>>2]=e,i[k+8>>2]=26,i[k+12>>2]=-2147483616,r=l[9611]|l[9612]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,e=K(k+16|0,2,116,k+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[k+15|0]<0&&Z(i[k+4>>2]),A=i[k+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A);break i}r=i[k+44>>2],u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}i:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t)}v=k+48|0}function vm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-160|0,v=f,n=o2(r);i:{e:{r:{f:{A:{k:{if(n>>>0>u0[r+16>>2]/5>>>0){i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,e=i[18065],i[f>>2]=e,i[i[e-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,e=i[i[f>>2]-12>>2]+f|0,k=f+12|0,J0(e,k),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[f+8>>2]=e,t=i[e-12>>2],e=f+8|0,i[t+e>>2]=i[18068],t=i[18064],i[f>>2]=t,i[i[t-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,Y(I0(Y(I0(Y(e,28854,25),n),27521,44),u0[r+16>>2]/5|0),5497,15),e=i[f+60>>2];n:{if(e&16){k=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break n}if(!(e&8)){r=0,u[f+159|0]=0,k=f+148|0;break e}k=f+20|0,e=i[f+28>>2]}if(r=e,e=i[k>>2],r=r-e|0,r>>>0>=2147483640)break k;if(r>>>0>=11){n=r|7,k=E(n+1|0),i[f+156>>2]=n-2147483647,i[f+148>>2]=k,i[f+152>>2]=r;break r}if(u[f+159|0]=r,k=f+148|0,r)break r;r=0;break e}t=e+104|0,o=i[e+104>>2],k=(i[e+108>>2]-o|0)/6|0;n:{if(k>>>0<n>>>0){xt(t,n-k|0);break n}if(k>>>0<=n>>>0)break n;i[e+108>>2]=o+G(n,6)}k=l[r+20|0];n:{if(!(!i[r+16>>2]|(!n|k&1))){for(k=0;;){t:{if(s=o2(r),w=W2(r),h=o2(r),o=i[t>>2]+G(k,6)|0,Q[o+4>>1]=h,u[o+2|0]=w,Q[o>>1]=s,o=l[r+20|0],k=k+1|0,o&1|n>>>0<=k>>>0)break t;if(i[r+16>>2])continue}break}if(o&1)break n;break A}if(!(k&1))break A}if(u[f+148|0]=0,u[f+159|0]=0,K(f,2,100,f+148|0),u[f+159|0]>=0)break f;Z(i[f+148>>2]);break f}g0(),H()}if(k=i[26929],i[f>>2]=i[26928],i[f+4>>2]=k,k=f+8|0,u[107731]>=0){n=i[26931],i[k>>2]=i[26930],i[k+4>>2]=n,i[k+8>>2]=i[26932];break f}T(k,i[26930],i[26931])}if(k=i[f>>2],u[f+19|0]<0&&Z(i[f+8>>2]),k&&(i[e+108>>2]=i[e+104>>2]),l[r+20|0]==1){if(u[f|0]=0,u[f+11|0]=0,K(A,2,100,f),u[f+11|0]>=0)break i;Z(i[f>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(!r)break e;z(k,e,r)}u[r+k|0]=0,K(A,2,100,f+148|0),u[f+159|0]<0&&Z(i[f+148>>2]),A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0)}v=f+160|0}function mm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0;s=v-32|0,v=s;i:{e:{r:{f:{if(o=i[e+16>>2],(X[i[i[o>>2]+8>>2]](o)|0)==5){A:{if(!(!k|(!r|!f))&&n)break A;e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(o=i[e+16>>2],!o||(w=X0(o,94804,96008),!w))break f;o=i[e+20>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[r>>2]=i[w+4>>2],i[f>>2]=i[w+8>>2],h=i[w+12>>2],i[k>>2]=h,e=n,n=i[w+16>>2],i[e>>2]=n,w=i[w+20>>2],Uf(s+16|0,h,n,2,0,t);A:{if(i[s+16>>2]){e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[s+24>>2];break A}if(oo(s+4|0,i[t>>2],0,h,n,8),i[s+24>>2]=i[s+12>>2],r=i[s+8>>2],e=i[s+4>>2],i[s+16>>2]=e,i[s+20>>2]=r,e){z4(i[t>>2]),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e;break A}if(r=0,t=hi(i[t>>2],0,s+4|0),!(!h|!n))for(k=0,f=0;;){for(e=0;u[(t+G(i[s+4>>2],r)|0)+e|0]=(l[((f&7)<<29|k>>>3)+w|0]<<(k&7)&128)>>>7|0?-1:0,k=k+1|0,f=k?f:f+1|0,e=e+1|0,(h|0)!=(e|0););if(r=r+1|0,(n|0)==(r|0))break}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o);break i}if(o=i[e+16>>2],(X[i[i[o>>2]+8>>2]](o)|0)==4){A:{if(!(!k|(!r|!f))&&n)break A;r=i[23582],i[A>>2]=i[23581],i[A+4>>2]=r,i[A+8>>2]=i[23583],r=0;break e}if(o=i[e+16>>2],!o||(w=X0(o,94804,95920),!w))break r;if(o=i[e+20>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[r>>2]=i[w+4>>2],i[f>>2]=i[w+8>>2],i[k>>2]=i[w+12>>2],i[n>>2]=i[w+16>>2],r=i[w+20>>2],i[A+8>>2]=i[24070],f=i[24069],i[A>>2]=i[24068],i[A+4>>2]=f,!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break e;X[i[i[o>>2]+8>>2]](o),p(o);break e}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183];break i}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183];break i}r=i[24182],i[A>>2]=i[24181],i[A+4>>2]=r,i[A+8>>2]=i[24183],r=0}if(i[A>>2]||(f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[s+8>>2]=e,i[s+4>>2]=f,af(A,s+4|0,r,s),i[A>>2]||(Tf(s+16|0,i[s>>2],t,2,0,0),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,M6(i[s>>2])),A=i[s+8>>2],!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=s+32|0}function Zm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72548,n=i[18140],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[18141],s=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=72548,i[f+24>>2]=72528,s=R0(k),i[s>>2]=71280,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,Wr(k,e,r),t=n,o=k,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(f+24|0,32138,13),k=f+12|0,P1(k,i[e+100>>2]),t=n,o=k,n=u[f+23|0],k=(n|0)<0,n=Y(Y(t,k?i[f+12>>2]:o,k?i[f+16>>2]:n),42713,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],o=(k|0)<0,Y(n,o?i[f+164>>2]:t,o?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(n,30813,15),u[f+23|0]<0&&Z(i[f+12>>2]),n=i[e+104>>2];i:{if(n>>>0<=1090519039){I0(f+24|0,n);break i}if(k=f+164|0,P1(k,n),t=k,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]>=0)break i;Z(i[f+164>>2])}n=Y(f+24|0,42713,1),k=f+164|0,s0(k,r),t=k,r=u[f+175|0],k=(r|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),Y(n,30243,19),r=i[e+108>>2],n=i[e+112>>2];i:{if((r|0)==(n|0)||(e=f+164|0,P1(e,i[r>>2]),t=e,e=u[f+175|0],k=(e|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=r+4|0,(n|0)==(e|0)))break i;for(;k=i[e>>2],u[f+164|0]=44,o=f+24|0,r=f+164|0,Y(o,r,1),P1(r,k),t=r,r=u[f+175|0],k=(r|0)<0,Y(o,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),e=e+4|0,(n|0)!=(e|0););}Y(f+24|0,42713,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18142],i[s>>2]=71280,u[f+71|0]<0&&Z(i[f+60>>2]),y0(s),p0(f+80|0),v=f+176|0}function Gm(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,e=i[e+64>>2],h=i[e+132>>2],B=i[e+136>>2],(h|0)!=(B|0))for(;;){i:{if(s=i[h+4>>2],m=i[h+8>>2],(s|0)==(m|0))break i;for(;;){e:{o=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+40>>2],f=i[k+44>>2];r:{if(e>>>0<f>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=E(f):r=0,t=r+e|0,u[t|0]=o,e&&z(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=E(f):r=0,t=r+e|0,u[t|0]=o,e&&z(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=E(f):r=0,t=r+e|0,u[t|0]=o,e&&z(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=E(f):r=0,t=r+e|0,u[t|0]=o,e&&z(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,r=i[s+4>>2],t=i[s>>2],o=r-t|0;r:{if((o|0)<=0)break r;if(w=i[k+44>>2],(o|0)<=(w-e|0)){!o|(r|0)==(t|0)||z(e,t,o),i[k+40>>2]=e+o;break r}if(f=i[k+36>>2],r=e-f|0,n=r+o|0,(n|0)<0)break e;if(w=w-f|0,_=w<<1,w=w>>>0>=1073741823?2147483647:n>>>0<_>>>0?_:n,w?n=E(w):n=0,_=n+r|0,o&&z(_,t,o),i[k+40>>2]=e,r&&z(n,f,r),i[k+44>>2]=n+w,i[k+40>>2]=o+_,i[k+36>>2]=n,!f)break r;Z(f)}if(s=s+12|0,(m|0)!=(s|0))continue;break i}break}G0(),H()}if(h=h+16|0,(B|0)==(h|0))break}e=i[k+40>>2],r=i[k+36>>2],n=i[k+44>>2],u[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=r,i[A+4>>2]=e,v=k+48|0}function Wm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,s=f+8|0,i[s+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,w=R0(n),i[w>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(s,31727,15),n=f+148|0,P1(n,i[e+104>>2]),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),42713,1),u[f+159|0]<0&&Z(i[f+148>>2]),l[e+112|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(s,30409,25),i[e+108>>2]),42713,1)),i[e+120>>2]!=i[e+116>>2])for(k=0;n=f+148|0,s0(n,r),t=n,n=u[f+159|0],o=(n|0)<0,Y(s,o?i[f+148>>2]:t,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(s,19216,1),i[(i[i[n>>2]-12>>2]+n|0)+12>>2]=2,t=n,n=k+1|0,o=Y(I0(t,n),32765,4),i[(i[i[o>>2]-12>>2]+o|0)+12>>2]=3,k=k<<3,Y(I0(Y(I0(o,i[k+i[e+116>>2]>>2]),27518,2),i[(k+i[e+116>>2]|0)+4>>2]),42713,1),o=i[e+116>>2],h=i[o+k>>2]+h|0,k=n,k>>>0<i[e+120>>2]-o>>3>>>0;);e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(s,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(s,30151,15),h),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[w>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(w),p0(f- -64|0),v=f+160|0}function di(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;k=v-160|0,v=k;i:{e:{r:{f:{A:{k:{n:{if(o=i[e+8>>2],e=i[e+12>>2],!(o|e))break n;if((r|f)>=0){if(!f)break k;if(t=d8(o,e,f,0),n=l0,!n&r>>>0<=t>>>0|n)break n}i[k+104>>2]=0,i[k+76>>2]=72244,i[k+20>>2]=72224,t=i[18065],i[k+12>>2]=t,n=i[t-12>>2],t=k+12|0,i[n+t>>2]=i[18066],i[k+16>>2]=0,n=t+i[i[k+12>>2]-12>>2]|0,s=k+24|0,J0(n,s),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[k+20>>2]=n,w=k+20|0,i[w+i[n-12>>2]>>2]=i[18068],n=i[18064],i[k+12>>2]=n,i[t+i[n-12>>2]>>2]=i[18069],i[k+76>>2]=72244,i[k+12>>2]=72204,i[k+20>>2]=72224,t=R0(s),i[t>>2]=71280,n=k- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(K2(Y(I0(Y(I0(Y(w,28816,11),r),2998,1),f),28783,32),o,e),42713,1),e=i[k+72>>2];t:{if(e&16){f=i[k+68>>2],e=i[k+48>>2],f>>>0<e>>>0&&(i[k+68>>2]=e,f=e),e=k+44|0;break t}if(!(e&8)){f=0,u[k+11|0]=0,r=k;break e}f=i[k+40>>2],e=k+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break f;if(f>>>0>=11){o=f|7,r=E(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=r,i[k+4>>2]=f;break r}if(u[k+11|0]=f,r=k,f)break r;f=0;break e}if(!r)break k;if(f)break A}if(e=E(24),i[k+12>>2]=e,i[k+16>>2]=20,i[k+20>>2]=-2147483624,r=l[4072]|l[4073]<<8|(l[4074]<<16|l[4075]<<24),f=l[4068]|l[4069]<<8|(l[4070]<<16|l[4071]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+20|0]=0,r=l[4084]|l[4085]<<8|(l[4086]<<16|l[4087]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,r=l[4080]|l[4081]<<8|(l[4082]<<16|l[4083]<<24),f=l[4076]|l[4077]<<8|(l[4078]<<16|l[4079]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,129,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!f)break e;z(r,e,f)}u[r+f|0]=0,K(A,6,1e3,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18063],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18071],i[k+20>>2]=i[18072],i[t>>2]=71280,u[k+67|0]<0&&Z(i[k+56>>2]),y0(t),p0(k+76|0)}v=k+160|0}function Yf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0);i:{e:{r:{if(k=i[f+44>>2],k){for(s=e+28|0,o=e+24|0,t=e+32|0;;){f:{A:{k:{n:{t:switch(n=l[k|0],w=n>>>1|0,w-32|0){case 0:break n;case 1:break t;case 2:break k;default:break A}n=i[e+12>>2];t:{if(!n||(K9(f,k,i[f+40>>2],n+100|0,o,s),u[f+19|0]>=0))break t;Z(i[f+8>>2])}k=i[e+12>>2],!k|u[e+7|0]&1||Gr(k,i[f+44>>2],i[f+40>>2]),u[e+7|0]=1;break f}n=i[e+12>>2],!n|u[e+6|0]&1||Gr(n,k,i[f+40>>2]),u[e+6|0]=1;break f}n=i[e+12>>2],!n|u[e+8|0]&1||Gr(n,k,i[f+40>>2]),u[e+8|0]=1;break f}if(l[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,u[t+23|0]=0,u[t+24|0]=0,u[t+25|0]=0,u[t+26|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t>>2]=0,i[t+4>>2]=0,u[e+76|0]=1,i[e+72>>2]=0,u[e+68|0]=1),Wi(t,k,i[f+40>>2]),n>>>0>63)break f;u[e+68|0]=(w-19&255)>>>0<3,i[e+72>>2]=i[f+36>>2]}if(!(i[f+32>>2]&&(i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],k)))break}f:{if(k=i[o>>2],k&&(r=i[s>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,K(A,8,129,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}f:{if(!(u[e+6|0]&1)|i[e+44>>2]==i[e+48>>2]|(!(u[e+7|0]&1)|!(u[e+8|0]&1))||l[e+20|0])break f;w=i[e+12>>2],s=i[e+16>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),r=i[e+36>>2],o=i[e+40>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=s,i[r>>2]=w,k=r+8|0;break A}if(t=i[t>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break r;if(o=o-t|0,n=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,o){if(o>>>0>=536870912)break e;k=E(o<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=w,s=n-(h<<3)|0,r&&z(s,t,r),i[e+40>>2]=k+(o<<3),k=n+8|0,i[e+36>>2]=k,i[e+32>>2]=s,!t)break A;Z(t)}i[e+36>>2]=k,r=i[e+16>>2],i[e+12>>2]=0,i[e+16>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;X[i[i[r>>2]+8>>2]](r),p(r)}u[e+20|0]=1,r=i[e+28>>2],k=i[e+24>>2]}i[e+64>>2]=r,i[e+60>>2]=k,Q[e+56>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}G0(),H()}x0(),H()}v=f+48|0}function Xm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-208|0,v=f,i[f+140>>2]=0,i[f+112>>2]=72548,k=i[18140],i[f+56>>2]=k,t=i[k-12>>2],k=f+56|0,i[t+k>>2]=i[18141],o=k+i[i[f+56>>2]-12>>2]|0,n=f+60|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+112>>2]=72548,i[f+56>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+100>>2]=0,i[f+104>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+108>>2]=16,n=f+196|0,Wr(n,e,r),s=k,t=n,k=u[f+207|0],n=(k|0)<0,Y(s,n?i[f+196>>2]:t,n?i[f+200>>2]:k),u[f+207|0]<0&&Z(i[f+196>>2]);i:{e:{r:{f:{if(s=i[e+12>>2],n=i[e+32>>2],k=i[e+8>>2],!s&n>>>0<=k>>>0|s){s=i[e+100>>2],e=f+28|0,s0(e,r),e=pA(e,32387,6),i[f+48>>2]=i[e+8>>2],t=i[e+4>>2],i[f+40>>2]=i[e>>2],i[f+44>>2]=t,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+4|0,s0(e,r),e=pA(e,32846,6),i[f+24>>2]=i[e+8>>2],r=i[e+4>>2],i[f+16>>2]=i[e>>2],i[f+20>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+196|0,j9(e,s,k-n|0,f+40|0,f+16|0),k=e,e=u[f+207|0],r=(e|0)<0,Y(f+56|0,r?i[f+196>>2]:k,r?i[f+200>>2]:e),u[f+207|0]<0&&Z(i[f+196>>2]),u[f+27|0]<0&&Z(i[f+16>>2]),u[f+15|0]<0&&Z(i[f+4>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+39|0]<0&&Z(i[f+28>>2]),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}k=f+196|0,s0(k,r),t=k,r=u[f+207|0],k=(r|0)<0,Y(f+56|0,k?i[f+196>>2]:t,k?i[f+200>>2]:r),u[f+207|0]<0&&Z(i[f+196>>2]),Y(K2(Y(f+56|0,28726,17),i[e+8>>2],i[e+12>>2]),42414,23),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(u[A+11|0]=e,e)break r;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e);break i}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+56>>2]=A,i[i[A-12>>2]+(f+56|0)>>2]=i[18142],i[o>>2]=71280,u[f+103|0]<0&&Z(i[f+92>>2]),y0(o),p0(f+112|0),v=f+208|0}function gm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-48|0,v=k,Ef(k+24|0,e,r,f);i:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break i}if((i[e+112>>2]-i[e+108>>2]|0)!=8){if(e=E(64),i[k+12>>2]=e,i[k+16>>2]=57,i[k+20>>2]=-2147483584,r=l[5683]|l[5684]<<8|(l[5685]<<16|l[5686]<<24),f=l[5679]|l[5680]<<8|(l[5681]<<16|l[5682]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+57|0]=0,u[e+56|0]=l[5735],r=l[5731]|l[5732]<<8|(l[5733]<<16|l[5734]<<24),f=l[5727]|l[5728]<<8|(l[5729]<<16|l[5730]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[5723]|l[5724]<<8|(l[5725]<<16|l[5726]<<24),f=l[5719]|l[5720]<<8|(l[5721]<<16|l[5722]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5715]|l[5716]<<8|(l[5717]<<16|l[5718]<<24),f=l[5711]|l[5712]<<8|(l[5713]<<16|l[5714]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5707]|l[5708]<<8|(l[5709]<<16|l[5710]<<24),f=l[5703]|l[5704]<<8|(l[5705]<<16|l[5706]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5699]|l[5700]<<8|(l[5701]<<16|l[5702]<<24),f=l[5695]|l[5696]<<8|(l[5697]<<16|l[5698]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5691]|l[5692]<<8|(l[5693]<<16|l[5694]<<24),f=l[5687]|l[5688]<<8|(l[5689]<<16|l[5690]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,101,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[k+43|0]<0&&Z(i[k+32>>2]),v=k+48|0}function Qm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,t=f+12|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,h=f+8|0,i[h+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,_=R0(t),i[_>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),n=k,k=u[f+159|0],t=(k|0)<0,Y(h,t?i[f+148>>2]:n,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;;){t=f+148|0,s0(t,r),n=t,t=u[f+159|0],o=(t|0)<0,Y(h,o?i[f+148>>2]:n,o?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(S0(Y(I0(Y(h,19216,1),k),20994,15),l[i[e+104>>2]+k|0]>>>6|0),42713,1),o=f+148|0,s0(o,r),n=o,o=u[f+159|0],s=(o|0)<0,Y(t,s?i[f+148>>2]:n,s?i[f+152>>2]:o),u[f+159|0]<0&&Z(i[f+148>>2]),n=-6;i:{if((k|0)<=9||(n=-7,k>>>0<100)||(n=-8,k>>>0<1e3)||(n=-9,k>>>0<1e4)||(n=-10,k>>>0<1e5))break i;n=k>>>0>999999?-12:-11}if(o=n+32852|0,s=h2(o),t=Y(S0(Y(Y(t,o,s),20939,11),l[i[e+104>>2]+k|0]>>>4&3),42713,1),n=f+148|0,s0(n,r),B=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:B,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(S0(Y(Y(t,o,s),20951,15),l[i[e+104>>2]+k|0]>>>2&3),42713,1),n=f+148|0,s0(n,r),B=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:B,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(Y(t,o,s),20867,15),l[i[e+104>>2]+k|0]&3),42713,1),k=k+1|0,!(k>>>0<i[e+108>>2]-i[e+104>>2]>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[_>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(_),p0(f- -64|0),v=f+160|0}function Im(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,n=v-48|0,v=n,h=i[e+8>>2],Z8(n+40|0,i[h+48>>2],1835625829),o=i[n+40>>2],u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1,s=i[n+40>>2];i:{e:{if(t=h2(r),t>>>0<2147483640){r:{f:{if(t>>>0>=11){w=t|7,o=E(w+1|0),i[n+36>>2]=w-2147483647,i[n+28>>2]=o,i[n+32>>2]=t;break f}if(u[n+39|0]=t,o=n+28|0,!t)break r}if(!t)break r;z(o,r,t)}u[o+t|0]=0,r=s+128|0;r:{if((r|0)==(n+28|0))break r;if(o=u[n+39|0],u[s+139|0]>=0){if((o|0)>=0){o=i[n+32>>2],i[r>>2]=i[n+28>>2],i[r+4>>2]=o,i[r+8>>2]=i[n+36>>2];break r}D1(r,i[n+28>>2],i[n+32>>2]);break r}t=r,r=(o|0)<0,O1(t,r?i[n+28>>2]:n+28|0,r?i[n+32>>2]:o)}if(u[n+39|0]<0&&Z(i[n+28>>2]),o=i[i[n+40>>2]+104>>2],r=E(28),i[r+12>>2]=o,i[r>>2]=94820,i[r+4>>2]=0,i[r+8>>2]=0,o=r+16|0,t=h2(f),t>>>0>=2147483640)break e;s=r+12|0;r:{f:{if(t>>>0>=11){w=t|7,o=E(w+1|0),i[r+24>>2]=w-2147483647,i[r+16>>2]=o,i[r+20>>2]=t;break f}if(u[r+27|0]=t,!t)break r}if(!t)break r;z(o,f,t)}u[o+t|0]=0,i[_+12>>2]=r,i[_+8>>2]=s,i[n+24>>2]=r,i[n+20>>2]=s,i[r+4>>2]=i[r+4>>2]+1,r=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=r;r:{if(r=i[h+172>>2],t=i[h+176>>2],r>>>0<t>>>0){i[r>>2]=i[n+8>>2],i[r+4>>2]=i[n+12>>2],i[h+172>>2]=r+8;break r}f:{if(o=i[h+168>>2],r=r-o|0,w=r>>3,f=w+1|0,f>>>0<536870912){if(t=t-o|0,s=t>>2,t=t>>>0>=2147483640?536870911:f>>>0<s>>>0?s:f,t){if(t>>>0>=536870912)break f;f=E(t<<3)}else f=0;s=f+r|0,i[s>>2]=i[n+8>>2],i[s+4>>2]=i[n+12>>2],w=s-(w<<3)|0,r&&z(w,o,r),i[h+176>>2]=f+(t<<3),r=s+8|0,i[h+172>>2]=r,i[h+168>>2]=w,o&&Z(o),i[h+172>>2]=r;break r}G0(),H()}x0(),H()}r=i[n+44>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}v=n+48|0;break i}g0(),H()}g0(),H()}nu(i[e>>2],i[i[_+8>>2]>>2]);i:{if(k){r=E(16),f=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,e=i[_+12>>2],i[r+8>>2]=i[_+8>>2],i[r+12>>2]=e,i[k>>2]=r,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;break i}if(e=i[_+12>>2],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r,i[A+8>>2]=i[24070],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=_+16|0}function f6(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;h=v-32|0,v=h,t=i[r>>2],o=i[t+128>>2];i:{if(o){for(w=t+128|0,s=w,t=o;_=i[t+16>>2]<(f|0),s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);m=0;e:{if((s|0)==(w|0)||(m=0,i[s+16>>2]>(f|0)))break e;m=i[s+28>>2]}for(s=w,t=o;_=i[t+16>>2]<(f|0),s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);t=0;e:{if((s|0)==(w|0)||(t=0,i[s+16>>2]>(f|0)))break e;t=i[s+32>>2]}for(_=t,s=w,t=o;B=i[t+16>>2]<(f|0),s=B?s:t,t=i[(B?4:0)+t>>2],!!t;);for(t=w,(s|0)!=(t|0)?s=i[s+16>>2]>(f|0)?t:s:s=t,s=i[s+20>>2];B=i[o+16>>2]<(f|0),t=B?t:o,o=i[(B?4:0)+o>>2],!!o;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>(f|0))break i;o=l[t+24|0];break i}s=i[t+148>>2],o=255}Sf(h+8|0,e,k,m,_,s,o,n);i:{if(i[h+8>>2]){e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[h+24>>2],e=i[h+20>>2],i[A+8>>2]=i[h+16>>2],i[A+12>>2]=e,i[h+24>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0;break i}W=i[r>>2],r=W+128|0;e:{r:{if(t=i[W+128>>2],!t)break r;for(s=r,o=t;n=i[o+16>>2]<(f|0),s=n?s:o,o=i[(n?4:0)+o>>2],!!o;);if((r|0)==(s|0))break r;if(o=0,n=0,i[s+16>>2]>(f|0))break e;o=i[s+56>>2],n=i[s+44>>2];break e}o=0,n=0}B=o,o=i[e+128>>2],w=0;e:{if(!o)break e;for(e=e+128|0,s=e;w=i[o+16>>2]<(k|0),s=w?s:o,o=i[(w?4:0)+o>>2],!!o;);if(w=0,(e|0)==(s|0)||(w=0,i[s+16>>2]>(k|0)))break e;g=i[s+56>>2],w=i[s+44>>2]}e:{r:{if((f|0)==10){if(e=i[W+120>>2]-10|0,e>>>0<6)break r;e=31;break e}if(e=0,!t)break e;for(o=r;e=i[t+16>>2]<(f|0),o=e?o:t,t=i[(e?4:0)+t>>2],!!t;);if(e=0,(r|0)==(o|0)|i[o+16>>2]>(f|0))break e;e=(l[o+24|0]+7&248)>>>3|0;break e}e=i[(e<<2)+50052>>2]}t=e;e:{if(!_)break e;if(e=G(t,m),f=0,(_|0)!=1)for(r=_&-2,t=0;k=!e,k||z(w+G(f,g)|0,G(f,B)+n|0,e),k||(k=f|1,z(w+G(k,g)|0,G(k,B)+n|0,e)),f=f+2|0,t=t+2|0,(r|0)!=(t|0););if(!(_&1)|!e)break e;z(w+G(f,g)|0,G(f,B)+n|0,e)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[h+27|0]<0&&Z(i[h+16>>2]),v=h+32|0}function Cm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,k=i[18065],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,w=f+12|0,J0(k,w),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+8>>2]=k,t=f+8|0,i[t+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,w=R0(w),i[w>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31650,15),k=i[e+104>>2];i:{if(!k){Y(t,41848,2);break i}if(n=f+148|0,P1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42713,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,30383,25),k=i[e+108>>2];i:{if(!k){Y(t,41848,2);break i}if(n=f+148|0,P1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42713,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}if(i[e+132>>2]!=i[e+128>>2])for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],s=(n|0)<0,Y(t,s?i[f+148>>2]:o,s?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(t,19216,1),k),2989,6),s=i[i[n>>2]-12>>2]+n|0,i[s+4>>2]=i[s+4>>2]&-75|8,s=i[e+128>>2]+(k<<3)|0,Y(K2(n,i[s>>2],i[s+4>>2]),42713,1),k=k+1|0,k>>>0<i[e+132>>2]-i[e+128>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[w>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(w),p0(f- -64|0),v=f+160|0}function Rf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2];i:{if(!k)break i;for(o=e+24|0,s=e+20|0,n=e+28|0;;){t=l[k|0]&31,w=t-1|0,u[e+76|0]=l[e+76|0]|w>>>0<5;e:{r:switch(t-7|0){case 0:t=i[e+8>>2];f:{if(!t||(A9(f,k,i[f+40>>2],t+100|0,s,o),u[f+19|0]>=0))break f;Z(i[f+8>>2])}k=i[e+8>>2],!k|u[e+6|0]&1||tt(k,i[f+44>>2],i[f+40>>2]),u[e+6|0]=1;break e;case 6:if(t=i[e+8>>2],!t)break e;ut(t,k,i[f+40>>2]);break e;case 1:t=i[e+8>>2],!t|u[e+7|0]&1||ot(t,k,i[f+40>>2]),u[e+7|0]=1;break e;default:break r}if(l[e+72|0]||(i[e+56>>2]=0,i[e+60>>2]=0,u[n+23|0]=0,u[n+24|0]=0,u[n+25|0]=0,u[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,u[e+72|0]=1,i[e+68>>2]=0,u[e+64|0]=1),Wi(n,k,i[f+40>>2]),w>>>0>4)break e;u[e+64|0]=(t|0)==5,i[e+68>>2]=i[f+36>>2]}if(!i[f+32>>2])break i;if(i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],!k)break}}i:{e:{r:{if(!l[e+76|0]){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break r}f:{if(k=i[e+20>>2],k&&(r=i[e+24>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,K(A,8,129,f+20|0),u[f+31|0]>=0)break r;Z(i[f+20>>2]);break r}f:{if(l[e+5|0]!=1||(w=i[e+8>>2],l[e+16|0]|!w))break f;n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),r=i[e+32>>2],o=i[e+36>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=n,i[r>>2]=w,k=r+8|0;break A}if(t=i[e+28>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break e;if(o=o-t|0,s=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<s>>>0?s:k,o){if(o>>>0>=536870912)break i;k=E(o<<3)}else k=0;if(s=k+r|0,i[s+4>>2]=n,i[s>>2]=w,n=s-(h<<3)|0,r&&z(n,t,r),i[e+36>>2]=k+(o<<3),k=s+8|0,i[e+32>>2]=k,i[e+28>>2]=n,!t)break A;Z(t)}i[e+32>>2]=k,r=i[e+12>>2],i[e+8>>2]=0,i[e+12>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;X[i[i[r>>2]+8>>2]](r),p(r)}u[e+16|0]=1,r=i[e+24>>2],k=i[e+20>>2]}i[e+60>>2]=r,i[e+56>>2]=k,Q[e+52>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=f+48|0;return}G0(),H()}x0(),H()}function wr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;h=v-2048|0,v=h;i:{e:{if((r|0)>=2){for(t=r;n=_,_=n+1|0,o=t>>>0>3,t=t>>>1|0,!!o;);_=4-n|0;break e}if(_=5,(r|0)!=1)break i}for(R=20-k|0,N=1<<19-k,V=r&-4,w=r&3,C=r-1|0;;){B=(s<<1)+f|0,t=0,o=r;e:{for(;;){if(W=t,n=o,(n|0)<=0){if(o=0,t=0,n=0,C>>>0>=3)for(;Q[(G(r,t)+s<<1)+h>>1]=0,Q[(G(t|1,r)+s<<1)+h>>1]=0,Q[(G(t|2,r)+s<<1)+h>>1]=0,Q[(G(t|3,r)+s<<1)+h>>1]=0,t=t+4|0,n=n+4|0,(V|0)!=(n|0););if(!w)break e;for(;Q[(G(r,t)+s<<1)+h>>1]=0,t=t+1|0,o=o+1|0,(w|0)!=(o|0););break e}if(t=W+1|0,o=n-1|0,!!F[B+(G(o,r)<<1)>>1])break}for(g=n&2147483646,y=n&1,o=0;;){if(t=0,n=0,m=0,(W|0)!=(C|0))for(;I=G(Q[B+(G(r,t)<<1)>>1],u[((t<<_<<5)+o|0)+61792|0])+n|0,n=t|1,n=I+G(Q[B+(G(n,r)<<1)>>1],u[((n<<_<<5)+o|0)+61792|0])|0,t=t+2|0,m=m+2|0,(g|0)!=(m|0););if(m=(G(r,o)+s<<1)+h|0,y&&(n=G(Q[B+(G(r,t)<<1)>>1],u[((t<<_<<5)+o|0)+61792|0])+n|0),n=n- -64>>7,n=(n|0)>=32767?32767:n,Q[m>>1]=(n|0)<=-32768?-32768:n,o=o+1|0,(o|0)==(r|0))break}}if(s=s+1|0,(s|0)==(r|0))break}for(m=r&-2,V=r&1,B=N>>R,s=-1<<k^-1,k=0;;){w=G(r,k),t=w-1|0,o=0,n=r;e:{r:{for(;;){if(W=o,f=n,(n|0)<=0)break r;if(o=o+1|0,n=n-1|0,!!F[(f+t<<1)+h>>1])break}for(g=f&2147483646,y=f&1,D=(G(e,k)<<1)+A|0,o=0;;){if(t=0,n=0,f=0,(W|0)!=(C|0))for(;I=G(Q[(t+w<<1)+h>>1],u[((t<<_<<5)+o|0)+61792|0])+n|0,n=t|1,n=I+G(Q[(n+w<<1)+h>>1],u[((n<<_<<5)+o|0)+61792|0])|0,t=t+2|0,f=f+2|0,(g|0)!=(f|0););if(f=(o<<1)+D|0,I=F[f>>1],y&&(n=G(Q[(t+w<<1)+h>>1],u[((t<<_<<5)+o|0)+61792|0])+n|0),t=f,f=(n+N>>R)+I|0,Q[t>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0,o=o+1|0,(o|0)==(r|0))break}break e}f=(G(e,k)<<1)+A|0;r:{if(!C){t=0;break r}for(W=f+2|0,t=0,n=0;w=t<<1,g=w+f|0,o=B+F[g>>1]|0,Q[g>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,w=w+W|0,o=B+F[w>>1]|0,Q[w>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,t=t+2|0,n=n+2|0,(m|0)!=(n|0););}if(!V)break e;n=f+(t<<1)|0,f=B+F[n>>1]|0,Q[n>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0}if(k=k+1|0,(k|0)==(r|0))break}}v=h+2048|0}function Jf(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0;i:{e:{if(s=A+548|0,!i[s+8>>2]){u[s+1|0]=0,A=7,t=i[s+44>>2];r:{if((t|0)!=i[s+40>>2]){o=t-4|0,t=i[o>>2],i[s+44>>2]=o,o=i[t+32>>2];break r}t=E(48),i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,u[t+2|0]=0,u[t|0]=0,u[t+1|0]=0,o=E(64),i[t+32>>2]=o,w=o- -64|0,i[t+40>>2]=w,i[o+56>>2]=0,i[o+60>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,i[o>>2]=0,i[o+4>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+36>>2]=w,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0}if(i[t+36>>2]=o,i[t+24>>2]=0,i[t+16>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,u[t+2|0]=0,Q[t>>1]=0,i[t+28>>2]<(r|0))r:{if(o=p2(r),o){w=i[t+20>>2],w&&Z(w),i[t+28>>2]=r,i[t+20>>2]=o;break r}F4(s,t),t=0}if(t){r:{if(i[t+28>>2]>=(r|0)){A=i[t+20>>2];break r}if(A=p2(r),!A)break e;o=i[t+20>>2],o&&(w=i[t+24>>2],w&&z(A,o,w),Z(o)),i[t+28>>2]=r,i[t+20>>2]=A}if(r&&z(A,e,r),i[t+16>>2]=n,i[t+8>>2]=f,i[t+12>>2]=k,i[t+24>>2]=r,(r|0)>=3)for(A=i[t+20>>2],n=0;;){e=A+2|0;r:{f:{A:switch(f=l[A+2|0],f|0){case 0:case 3:break f;default:break A}n=n+2|0;break r}if(l[A|0]){e=A;break r}if((f|0)!=3){e=A;break r}if(l[A+1|0]){e=A;break r}r=i[t+36>>2],w=((r-i[t+32>>2]>>2)+n|0)+2|0;f:{if(o=i[t+40>>2],o>>>0>r>>>0){i[r>>2]=w,i[t+36>>2]=r+4;break f}A:{if(k=i[t+32>>2],r=r-k|0,_=r>>2,f=_+1|0,f>>>0<1073741824){if(o=o-k|0,h=o>>1,o=o>>>0>=2147483644?1073741823:f>>>0<h>>>0?h:f,o){if(o>>>0>=1073741824)break A;f=E(o<<2)}else f=0;h=f+r|0,i[h>>2]=w,w=h-(_<<2)|0,r&&z(w,k,r),i[t+40>>2]=f+(o<<2),r=h+4|0,i[t+36>>2]=r,i[t+32>>2]=w,k&&Z(k),i[t+36>>2]=r;break f}G0(),H()}x0(),H()}r=(i[t+24>>2]-n|0)-3|0,r&&z(e,A+3|0,r),e=A+1|0,r=i[t+24>>2]-1|0,i[t+24>>2]=r,n=n+1|0}if(A=e+1|0,n=n+1|0,!((n|0)<(r-2|0)))break}A=0,o=i[s+32>>2],e=o+i[s+28>>2]|0,f=i[s+20>>2],n=i[s+16>>2],(e|0)==(((f|0)!=(n|0)?(f-n<<8)-1|0:0)|0)&&(or(s+12|0),r=i[t+24>>2],n=i[s+16>>2],o=i[s+32>>2],e=o+i[s+28>>2]|0),i[i[(e>>>8&16777212)+n>>2]+((e&1023)<<2)>>2]=t,i[s+32>>2]=o+1,i[s+36>>2]=i[s+36>>2]+r}break i}M0(19533,18213,376,19570),H()}F4(s,t),A=7}return A}function Nf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0);i:{e:{r:{if(k=i[f+44>>2],k){for(s=e+28|0,o=e+24|0,t=e+32|0;;){f:{A:{k:{n:{t:switch(n=l[k+1|0],w=n>>>3|0,w-14|0){case 0:break n;case 1:break t;case 2:break k;default:break A}n=i[e+12>>2];t:{if(!n||(d7(f,k,i[f+40>>2],n+104|0,o,s),u[f+19|0]>=0))break t;Z(i[f+8>>2])}k=i[e+12>>2],!k|u[e+7|0]&1||Ir(k,i[f+44>>2],i[f+40>>2]),u[e+7|0]=1;break f}n=i[e+12>>2],!n|u[e+6|0]&1||Ir(n,k,i[f+40>>2]),u[e+6|0]=1;break f}n=i[e+12>>2],!n|u[e+8|0]&1||Ir(n,k,i[f+40>>2]),u[e+8|0]=1;break f}if(l[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,u[t+23|0]=0,u[t+24|0]=0,u[t+25|0]=0,u[t+26|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t>>2]=0,i[t+4>>2]=0,u[e+76|0]=1,i[e+72>>2]=0,u[e+68|0]=1),Wi(t,k,i[f+40>>2]),n>>>0>95)break f;u[e+68|0]=w-7>>>0<3,i[e+72>>2]=i[f+36>>2]}if(!(i[f+32>>2]&&(i[f+36>>2]=0,i[f+32>>2]=1,X[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],k)))break}f:{if(k=i[o>>2],k&&(r=i[s>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,K(A,8,129,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}f:{if(l[e+5|0]!=1||(w=i[e+12>>2],l[e+20|0]|!w))break f;s=i[e+16>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),r=i[e+36>>2],o=i[e+40>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=s,i[r>>2]=w,k=r+8|0;break A}if(t=i[t>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break r;if(o=o-t|0,n=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,o){if(o>>>0>=536870912)break e;k=E(o<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=w,s=n-(h<<3)|0,r&&z(s,t,r),i[e+40>>2]=k+(o<<3),k=n+8|0,i[e+36>>2]=k,i[e+32>>2]=s,!t)break A;Z(t)}i[e+36>>2]=k,r=i[e+16>>2],i[e+12>>2]=0,i[e+16>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;X[i[i[r>>2]+8>>2]](r),p(r)}u[e+20|0]=1,r=i[e+28>>2],k=i[e+24>>2]}i[e+64>>2]=r,i[e+60>>2]=k,Q[e+56>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}G0(),H()}x0(),H()}v=f+48|0}function Vm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;f=v-16|0,v=f;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=E(32),i[f+4>>2]=e,i[f+8>>2]=30,i[f+12>>2]=-2147483616,r=l[11502]|l[11503]<<8|(l[11504]<<16|l[11505]<<24),k=l[11498]|l[11499]<<8|(l[11500]<<16|l[11501]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[11524]|l[11525]<<8|(l[11526]<<16|l[11527]<<24),k=l[11520]|l[11521]<<8|(l[11522]<<16|l[11523]<<24),u[e+22|0]=k,u[e+23|0]=k>>>8,u[e+24|0]=k>>>16,u[e+25|0]=k>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[11518]|l[11519]<<8|(l[11520]<<16|l[11521]<<24),k=l[11514]|l[11515]<<8|(l[11516]<<16|l[11517]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11510]|l[11511]<<8|(l[11512]<<16|l[11513]<<24),k=l[11506]|l[11507]<<8|(l[11508]<<16|l[11509]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,f+4|0),u[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}h=e,_=W2(r)&127,u[h+97|0]=_,k=W2(r),u[e+99|0]=k&31,u[e+98|0]=k>>>5,k=W2(r),u[e+106|0]=k&3,u[e+100|0]=k>>>7,u[e+105|0]=k>>>2&1,u[e+104|0]=k>>>3&1,u[e+103|0]=k>>>4&1,u[e+102|0]=k>>>5&1,u[e+101|0]=k>>>6&1,k=W2(r),t=k>>>4&1,u[e+107|0]=t,t&&(u[e+108|0]=k&15),n=i[e+116>>2],t=i[e+112>>2],s=n-t|0,k=i[r+16>>2];r:{if(s>>>0<k>>>0){if(w=k-s|0,o=i[e+120>>2],w>>>0<=o-n>>>0){w&&o0(n,0,w),i[e+116>>2]=n+w;break r}if((k|0)<0)break i;if(n=o-t|0,o=n<<1,o=n>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,n=E(o),w&&o0(n+s|0,0,w),s&&z(n,t,s),i[e+120>>2]=n+o,i[e+116>>2]=k+n,i[e+112>>2]=n,!t)break r;Z(t);break r}if(k>>>0>=s>>>0)break r;i[e+116>>2]=k+t}if(l6(r,i[e+112>>2],k),l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=f+16|0;return}G0(),H()}function hr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;w=v-2048|0,v=w;i:{e:{if((e|0)>=2){for(n=e;o=_,_=o+1|0,t=n>>>0>3,n=n>>>1|0,!!t;);_=4-o|0;break e}if(_=5,(e|0)!=1)break i}for(I=e&-4,V=e&3,y=e-1|0,m=1<<k,g=0-m|0,C=m+65535|0,D=1<<f-1;;){W=(s<<1)+r|0,n=0,t=e;e:{for(;;){if(h=n,k=t,(k|0)<=0){if(t=0,n=0,o=0,y>>>0>=3)for(;Q[(G(e,n)+s<<1)+w>>1]=0,Q[(G(n|1,e)+s<<1)+w>>1]=0,Q[(G(n|2,e)+s<<1)+w>>1]=0,Q[(G(n|3,e)+s<<1)+w>>1]=0,n=n+4|0,o=o+4|0,(I|0)!=(o|0););if(!V)break e;for(;Q[(G(e,n)+s<<1)+w>>1]=0,n=n+1|0,t=t+1|0,(V|0)!=(t|0););break e}if(n=h+1|0,t=k-1|0,!!F[W+(G(t,e)<<1)>>1])break}for(R=k&2147483646,N=k&1,t=0;;){if(n=0,o=0,B=0,(h|0)!=(y|0))for(;k=n|1,o=(G(Q[W+(G(e,n)<<1)>>1],u[((n<<_<<5)+t|0)+61792|0])+o|0)+G(Q[W+(G(k,e)<<1)>>1],u[((k<<_<<5)+t|0)+61792|0])|0,n=n+2|0,B=B+2|0,(R|0)!=(B|0););if(k=(G(e,t)+s<<1)+w|0,N&&(o=G(Q[W+(G(e,n)<<1)>>1],u[((n<<_<<5)+t|0)+61792|0])+o|0),n=k,k=o- -64>>7,Q[n>>1]=(k|0)<(g|0)?g:(k|0)<(m|0)?k:C,t=t+1|0,(t|0)==(e|0))break}}if(s=s+1|0,(s|0)==(e|0))break}for(V=e&-8,W=e&7,h=D>>f,r=0;;){s=G(e,r),n=s-1|0,t=0,o=e;e:{r:{for(;;){if(g=t,k=o,(k|0)<=0)break r;if(t=t+1|0,o=k-1|0,!!F[(k+n<<1)+w>>1])break}for(B=k&2147483646,m=k&1,I=(s<<2)+A|0,t=0;;){if(n=0,o=0,k=0,(g|0)!=(y|0))for(;C=G(Q[(n+s<<1)+w>>1],u[((n<<_<<5)+t|0)+61792|0])+o|0,o=n|1,o=C+G(Q[(o+s<<1)+w>>1],u[((o<<_<<5)+t|0)+61792|0])|0,n=n+2|0,k=k+2|0,(B|0)!=(k|0););if(k=I+(t<<2)|0,m&&(o=G(Q[(n+s<<1)+w>>1],u[((n<<_<<5)+t|0)+61792|0])+o|0),i[k>>2]=o+D>>f,t=t+1|0,(t|0)==(e|0))break}break e}if(k=(s<<2)+A|0,o=0,t=0,y>>>0>=7)for(g=k+28|0,s=k+24|0,m=k+20|0,I=k+16|0,C=k+12|0,R=k+8|0,N=k+4|0,B=0;n=t<<2,i[n+k>>2]=h,i[n+N>>2]=h,i[n+R>>2]=h,i[n+C>>2]=h,i[n+I>>2]=h,i[n+m>>2]=h,i[n+s>>2]=h,i[n+g>>2]=h,t=t+8|0,B=B+8|0,(V|0)!=(B|0););if(!W)break e;for(;i[k+(t<<2)>>2]=h,t=t+1|0,o=o+1|0,(W|0)!=(o|0););}if(r=r+1|0,(r|0)==(e|0))break}}v=w+2048|0}function J9(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0;g=v-16|0,v=g;i:{e:{r:{f:{A:{if(X[i[i[A>>2]+12>>2]](A,f)|0){if(_=X[i[i[A>>2]+8>>2]](A,f)|0,!(i[_+24>>2]>(k|0)&i[_+28>>2]>(n|0))){C2(A+4|0,1026,0),u[w|0]=0;break r}k:{if(h=i[_+168>>2],f=k>>h,(f|0)<0||(B=i[_+172>>2],(B|0)<=(f|0)))break k;if(h=n>>h,!((h|0)<0|(h|0)>=i[_+176>>2])){if(!(l[((i[_+160>>2]+G(f,3)|0)+G(G(h,B),3)|0)+1|0]&3)){Q[s>>1]=0,Q[s+2>>1]=0,u[w|0]=0;break r}if(l[_+312|0]==1){Q[s>>1]=0,Q[s+2>>1]=0,u[w|0]=0;break r}n:{if(h=i[_+188>>2],f=k>>h,(f|0)<0||(B=i[_+192>>2],(B|0)<=(f|0)))break n;if(h=n>>h,!((h|0)<0|(h|0)>=i[_+196>>2])){if(h=(i[_+180>>2]+G(f,12)|0)+G(G(h,B),12)|0,!l[h|0]){B=h+3|0,f=1,h=h+8|0;break f}if(!l[h+1|0]){B=h+2|0,f=0,h=h+4|0;break f}if(m=i[e+96>>2],B=1,i[r+340>>2]<=0)break A;for(W=r+988|0,f=0;;){if(I=i[(X[i[i[A>>2]+8>>2]](A,i[W+(f<<2)>>2])|0)+96>>2],B=(I|0)<=(m|0),f=f+1|0,(f|0)>=i[r+340>>2])break A;if(!((m|0)>=(I|0)))break}break A}break e}break i}break e}break i}M0(26594,18236,1136,4802),H()}A:{if(!B|i[r+336>>2]<=0)break A;for(W=r+924|0,f=0;;){if(I=i[(X[i[i[A>>2]+8>>2]](A,i[W+(f<<2)>>2])|0)+96>>2],B=(I|0)<=(m|0),f=f+1|0,(f|0)>=i[r+336>>2])break A;if(!((m|0)>=(I|0)))break}}if(B){B=(o+h|0)+2|0,f=o,h=(h+(f<<2)|0)+4|0;break f}f=u[r+380|0],B=(h+f|0)+2|0,h=(h+(f<<2)|0)+4|0}if(m=i[_+148>>2],k=k>>m,(k|0)<0||(W=i[_+152>>2],(W|0)<=(k|0)))break i;if(n=n>>m,(n|0)<0|(n|0)>=i[_+156>>2])break e;if(k=F[((i[_+140>>2]+G(k,24)|0)+G(G(n,W),24)|0)+2>>1],m=i[_+52>>2],k>>>0>=i[_+56>>2]-m>>2>>>0){C2(A+4|0,1033,0),u[w|0]=0,Q[s>>1]=0,Q[s+2>>1]=0;break r}if(n=(((o<<4)+r|0)+t|0)+1308|0,B=u[B|0],m=i[m+(k<<2)>>2],l[n|0]!=l[(B+(m+(f<<4)|0)|0)+1308|0]){u[w|0]=0,Q[s>>1]=0,Q[s+2>>1]=0;break r}k=F[h>>1]|F[h+2>>1]<<16,u[w|0]=1;f:{if(!l[n|0]&&(f=i[_+96>>2]-i[((m+(f<<6)|0)+(B<<2)|0)+1052>>2]|0,r=i[e+96>>2]-i[(((o<<6)+r|0)+(t<<2)|0)+1052>>2]|0,(f|0)!=(r|0)))break f;Q[s>>1]=k,Q[s+2>>1]=k>>>16;break r}if(i[g+8>>2]=k,i[g+12>>2]=k,Ut(s,g+8|0,f,r))break r;C2(A+4|0,1008,0),u[e+312|0]=3}v=g+16|0;return}M0(4618,10893,119,4231),H()}M0(4656,10893,118,4231),H()}function N9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v+-64|0,v=n,t=i[e>>2],o=i[t+128>>2];i:{e:{if(!o){s=t+128|0,k=s;break e}for(f=o;;){if(k=f,s=i[f+16>>2],(s|0)>(r|0)){if(s=f,f=i[f>>2],f)continue;break e}if((r|0)<=(s|0))break i;if(f=i[k+4>>2],!f)break}s=k+4|0}f=E(60),i[f+16>>2]=r,i[f+28>>2]=0,i[f+32>>2]=0,i[f+20>>2]=1,i[f+24>>2]=256,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[s>>2]=f,k=i[i[t+124>>2]>>2],k&&(i[t+124>>2]=k),m1(i[t+128>>2],f),i[t+132>>2]=i[t+132>>2]+1,t=i[e>>2],o=i[t+128>>2]}k=i[f+48>>2],i[n+56>>2]=i[f+44>>2],i[n+60>>2]=k,k=i[f+40>>2],i[n+48>>2]=i[f+36>>2],i[n+52>>2]=k,k=i[f+32>>2],i[n+40>>2]=i[f+28>>2],i[n+44>>2]=k,k=i[f+24>>2],i[n+32>>2]=i[f+20>>2],i[n+36>>2]=k,_=i[f+56>>2],s=i[f+52>>2];i:{if(!o)break i;for(w=t+128|0,f=w,k=o;h=i[k+16>>2]<(r|0),f=h?f:k,k=i[(h?4:0)+k>>2],!!k;);if((f|0)==(w|0)|i[f+16>>2]>(r|0))break i;r=i[f+4>>2];e:{if(!r){for(r=f;k=i[r+8>>2],w=i[k>>2]!=(r|0),r=k,!!w;);break e}for(;k=r,r=i[k>>2],!!r;);}i[t+124>>2]==(f|0)&&(i[t+124>>2]=k),i[t+132>>2]=i[t+132>>2]-1,pf(o,f),Z(f),t=i[e>>2]}if(i[t+136>>2]){l[107800]||(u[107800]=1),k=i[26952];i:{if(!k)break i;for(r=107808,f=i[t+136>>2];o=f>>>0>u0[k+16>>2],r=o?r:k,k=i[(o?4:0)+k>>2],!!k;);if((r|0)==107808|f>>>0<u0[r+16>>2])break i;i[r+20>>2]=i[r+20>>2]-s}i[t+140>>2]=i[t+140>>2]-s}f=i[A+128>>2];i:{e:{if(!f){r=A+128|0,k=r;break e}for(;;){if(k=f,r=i[f+16>>2],(r|0)>6){if(r=f,f=i[f>>2],f)continue;break e}if((r|0)>=6)break i;if(f=i[k+4>>2],!f)break}r=k+4|0}f=E(60),i[f+16>>2]=6,o=i[n+36>>2],i[f+20>>2]=i[n+32>>2],i[f+24>>2]=o,o=i[n+44>>2],i[f+28>>2]=i[n+40>>2],i[f+32>>2]=o,o=i[n+52>>2],i[f+36>>2]=i[n+48>>2],i[f+40>>2]=o,o=i[n+60>>2],i[f+44>>2]=i[n+56>>2],i[f+48>>2]=o,i[f+56>>2]=_,i[f+52>>2]=s,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,r=i[i[A+124>>2]>>2],r&&(i[A+124>>2]=r),m1(i[A+128>>2],f),i[A+132>>2]=i[A+132>>2]+1}K4(n+12|0,A+136|0,s,i[i[e>>2]+136>>2],18888),u[n+31|0]<0&&Z(i[n+20>>2]),v=n- -64|0}function Fm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(X[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),k=i[w+24>>2],k){if(f=i[w+28>>2],n=i[w+32>>2],r=h2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=e,i[w+48>>2]=r;break A}if(u[w+55|0]=r,e=w+44|0,!r)break f}if(!r)break f;z(e,n,r)}if(u[e+r|0]=0,K(A,k,f,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=E(208),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90732,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,Q[r+112>>1]=0,i[r+16>>2]=99864,i[r+136>>2]=0,i[r+140>>2]=0,Q[r+120>>1]=259,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+168>>2]=0,i[r+172>>2]=0,i[r+176>>2]=0,i[r+180>>2]=0,i[r+200>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+32>>2]=1987470147,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;X[i[i[k>>2]+8>>2]](k),p(k)}u[e+4|0]=1}if(Nf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}X[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),k=i[w+44>>2];f:{if(k){if(f=i[w+48>>2],n=i[w+52>>2],r=h2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break k}if(u[w+23|0]=r,e=w+12|0,!r)break A}if(!r)break A;z(e,n,r)}if(u[e+r|0]=0,K(A,k,f,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Nf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=w- -64|0;return}g0(),H()}g0(),H()}function M9(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[r+4>>2]-i[r>>2]|0;i:{if(f>>>0>=256){if(e=E(64),i[k+4>>2]=e,i[k+8>>2]=57,i[k+12>>2]=-2147483584,r=l[11533]|l[11534]<<8|(l[11535]<<16|l[11536]<<24),f=l[11529]|l[11530]<<8|(l[11531]<<16|l[11532]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+57|0]=0,u[e+56|0]=l[11585],r=l[11581]|l[11582]<<8|(l[11583]<<16|l[11584]<<24),f=l[11577]|l[11578]<<8|(l[11579]<<16|l[11580]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[11573]|l[11574]<<8|(l[11575]<<16|l[11576]<<24),f=l[11569]|l[11570]<<8|(l[11571]<<16|l[11572]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[11565]|l[11566]<<8|(l[11567]<<16|l[11568]<<24),f=l[11561]|l[11562]<<8|(l[11563]<<16|l[11564]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[11557]|l[11558]<<8|(l[11559]<<16|l[11560]<<24),f=l[11553]|l[11554]<<8|(l[11555]<<16|l[11556]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[11549]|l[11550]<<8|(l[11551]<<16|l[11552]<<24),f=l[11545]|l[11546]<<8|(l[11547]<<16|l[11548]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11541]|l[11542]<<8|(l[11543]<<16|l[11544]<<24),f=l[11537]|l[11538]<<8|(l[11539]<<16|l[11540]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,9,0,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(Kf(i[e>>2],f),f=e+16|0,n=i[e+20>>2],e=i[r>>2],r=i[r+4>>2],$4(f,n,e,r,r-e|0),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+16|0}function U9(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;w=v-128|0,v=w;i:{e:{r:{if(!E6(n,t,o,s,0,0,0,0))break r;h=s&65535,B=s>>>16&32767;f:A:{if((B|0)!=32767){if(m=4,B)break A;m=n|o|(t|h)?3:2;break f}m=!(n|o|(t|h))}if(!m)break r;if(V=k>>>16|0,g=V&32767,(g|0)!=32767)break e}n1(w+16|0,e,r,f,k,n,t,o,s),e=i[w+16>>2],f=i[w+20>>2],k=i[w+24>>2],r=i[w+28>>2],j7(w,e,f,k,r,e,f,k,r),f=i[w+8>>2],k=i[w+12>>2],o=i[w>>2],s=i[w+4>>2];break i}if(W=f,m=k&2147483647,h=m,B=o,_=s&2147483647,(E6(e,r,W,h,n,t,o,_)|0)<=0){if(E6(e,r,W,h,n,t,o,_)){o=e,s=r;break i}n1(w+112|0,e,r,f,k,0,0,0,0),f=i[w+120>>2],k=i[w+124>>2],o=i[w+112>>2],s=i[w+116>>2];break i}if(I=s>>>16&32767,g?(s=r,o=e):(n1(w+96|0,e,r,W,m,0,0,0,1081540608),W=i[w+104>>2],o=i[w+108>>2],m=o,g=(o>>>16|0)-120|0,s=i[w+100>>2],o=i[w+96>>2]),I||(n1(w+80|0,n,t,B,_,0,0,0,1081540608),B=i[w+88>>2],n=i[w+92>>2],_=n,I=(n>>>16|0)-120|0,t=i[w+84>>2],n=i[w+80>>2]),C=B,y=_&65535|65536,m=m&65535|65536,(g|0)>(I|0)){for(;;){_=W-C|0,h=(t|0)==(s|0)&n>>>0>o>>>0|t>>>0>s>>>0,B=_-h|0,h=(m-((W>>>0<C>>>0)+y|0)|0)-(h>>>0>_>>>0)|0;e:{if((h|0)>=0|(h|0)>0){if(W=o,o=o-n|0,s=s-((n>>>0>W>>>0)+t|0)|0,!(o|B|(s|h))){n1(w+32|0,e,r,f,k,0,0,0,0),f=i[w+40>>2],k=i[w+44>>2],o=i[w+32>>2],s=i[w+36>>2];break i}h=h<<1|B>>>31,W=B<<1|s>>>31;break e}h=m<<1|W>>>31,W=W<<1|s>>>31}if(m=h,h=s<<1|o>>>31,o=o<<1,s=h,g=g-1|0,!((I|0)<(g|0)))break}g=I}_=W-C|0,h=(t|0)==(s|0)&n>>>0>o>>>0|t>>>0>s>>>0,B=_-h|0,h=(m-((W>>>0<C>>>0)+y|0)|0)-(h>>>0>_>>>0)|0,_=h;e:{if((h|0)<0){B=W,_=m;break e}if(W=o,o=o-n|0,s=s-((n>>>0>W>>>0)+t|0)|0,o|B|(s|_))break e;n1(w+48|0,e,r,f,k,0,0,0,0),f=i[w+56>>2],k=i[w+60>>2],o=i[w+48>>2],s=i[w+52>>2];break i}if((_|0)==65535|_>>>0<65535)for(;e=s>>>31|0,g=g-1|0,m=s<<1|o>>>31,o=o<<1,s=m,r=e,e=_<<1|B>>>31,B=r|B<<1,_=e,e>>>0<65536;);if(e=V&32768,(g|0)<=0){n1(w- -64|0,o,s,B,_&65535|(e|g+120)<<16,0,0,0,1065811968),f=i[w+72>>2],k=i[w+76>>2],o=i[w+64>>2],s=i[w+68>>2];break i}f=B,k=_&65535|(e|g)<<16}i[A>>2]=o,i[A+4>>2]=s,i[A+8>>2]=f,i[A+12>>2]=k,v=w+128|0}function Mf(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;n=v+-64|0,v=n,i[r>>2]=0,t=i[26732],h=i[26733];i:{e:{for(;;){r:{if(i[n+44>>2]=0,F7(i[e>>2],n+44|0))break r;if(o=Do(i[e>>2]),o){if(t=i[r>>2],t&&z4(t),f&&(i[f>>2]=i[o+288>>2]),f=i[o+20>>2],g=f,Uf(n+52|0,i[i[14786]+o>>2],i[i[14789]+o>>2],f?0:2,f,r),f=i[n+52>>2],f){t=i[n+60>>2],s=i[n+56>>2];break e}for(m=i[i[o+124>>2]+i[14792]>>2],I=(m+7|0)/8|0;;){if(w>>>0<=2?f=i[i[o+124>>2]+i[(w<<2)+59168>>2]>>2]:f=0,(f|0)!=(m|0)){z4(i[r>>2]),t=16256,f=4,s=3003;break e}t=59128,W=No(o,w,n+48|0),s=129,f=7;f:{if(_=w>>>0<=2?i[i[(w<<2)+59144>>2]+o>>2]:0,h=w>>>0<=2?i[i[(w<<2)+59156>>2]+o>>2]:0,!((_|0)<=0|(h|0)<=0)){if(s=i[(w<<2)+59132>>2],Ao(n+52|0,i[r>>2],s,_,h,m,k),f=i[n+52>>2],!f)break f;s=i[n+56>>2],k=e+8|0,R2(k,i[n+60>>2]),t=u[e+19|0]<0?i[e+8>>2]:k}z4(i[r>>2]);break e}if(t=G(_,I),f=0,_=hi(i[r>>2],s,n+52|0),(h|0)!=1)for(C=h&2147483646,s=0;B=!t,B||z(_+G(i[n+52>>2],f)|0,G(i[n+48>>2],f)+W|0,t),B||(B=f|1,z(_+G(B,i[n+52>>2])|0,G(B,i[n+48>>2])+W|0,t)),f=f+2|0,s=s+2|0,(C|0)!=(s|0););if(!(h&1)|!t||z(_+G(i[n+52>>2],f)|0,G(i[n+48>>2],f)+W|0,t),!(g&&(f=w>>>0<2,w=w+1|0,f)))break}if(f=B3(),XA(A,f,l[i[o+124>>2]+9018|0]),i[A>>2]){if(l[e+4|0]==1){z2(f),z4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+40>>2]=i[A+8>>2],t=i[A+4>>2],i[n+32>>2]=i[A>>2],i[n+36>>2]=t,jr(k,n+32|0)}if(gA(A,f,l[i[o+124>>2]+9019|0]),i[A>>2]){if(l[e+4|0]==1){z2(f),z4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+24>>2]=i[A+8>>2],t=i[A+4>>2],i[n+16>>2]=i[A>>2],i[n+20>>2]=t,jr(k,n+16|0)}if(WA(A,f,l[i[o+124>>2]+9020|0]),i[A>>2]){if(l[e+4|0]==1){z2(f),z4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+8>>2]=i[A+8>>2],t=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=t,jr(k,n)}u[f+16|0]=l[i[o+124>>2]+9016|0]!=0,mo(n+52|0,i[r>>2],f),z2(f),ll(i[e>>2]),i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e;break i}if(i[n+44>>2])continue}break}i[A+4>>2]=t,i[A+8>>2]=h,i[A>>2]=0;break i}i[A>>2]=f,i[A+4>>2]=s,i[A+8>>2]=t}v=n- -64|0}function D9(A,e,r,f,k){var n=0,t=0,o=0;t=v-16|0,v=t,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:switch(f-1|0){case 0:case 3:break e;default:break i}e=i[e>>2],o=i[e+16>>2],n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);e:{if(o){e=E(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91212,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[f>>2]=95456,i[e+32>>2]=1668246642,i[t+12>>2]=e,i[t+8>>2]=f;r:{if(!n){i[e+120>>2]=n,i[e+116>>2]=o;break r}if(i[n+4>>2]=i[n+4>>2]+2,i[e+120>>2]=n,i[e+116>>2]=o,e=i[n+4>>2],i[n+4>>2]=e-1,e)break r;X[i[i[n>>2]+8>>2]](n),p(n)}r2(A,t+8|0),e=i[t+12>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;X[i[i[e>>2]+8>>2]](e),p(e)}f=l[r|0],e=l[r+3|0]!=0&i[r+4>>2]!=0&f>>>0>2;break e}f=l[r|0],e=i[r+4>>2]!=0}e:{if(!(!l[r+8|0]|(f&255)>>>0<4)|!e)break e;r=E(24),u[r+22|0]=1,Q[r+20>>1]=2,Q[r+16>>1]=2,Q[r+18>>1]=2,i[r+12>>2]=95416,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95336,e=r+16|0,u[e+6|0]=1,Q[e+4>>1]=6,Q[e>>1]=1,Q[e+2>>1]=13,xl(e,k),e=E(128),i[e>>2]=91212,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[f>>2]=95456,i[e+32>>2]=1668246642,i[t+12>>2]=e,i[t+8>>2]=f,i[r+4>>2]=i[r+4>>2]+2,i[e+120>>2]=r,i[e+116>>2]=r+12,e=i[r+4>>2],i[r+4>>2]=e-1,e||(X[i[i[r>>2]+8>>2]](r),p(r)),r2(A,t+8|0),A=i[t+12>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n)}v=t+16|0}function Em(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-128|0,v=t;i:{if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}n&&(i[n>>2]=0),u[t+85|0]=0,u[t+86|0]=0,u[t+87|0]=0,u[t+88|0]=0,Q[t+82>>1]=0,Q[t+84>>1]=0,Q[t+80>>1]=263,u[t+112|0]=1,u[t+108|0]=0,i[t+100>>2]=2,i[t+104>>2]=2,u[t+96|0]=1,i[t+92>>2]=1;e:{if(!k)break e;r:{f:{A:{k:{n:{t:{u:{o:switch(o=l[k|0],(o>>>0>=7?7:o)-1|0){case 0:break t;case 1:break u;case 2:break o;case 3:break f;case 4:break A;case 5:break k;case 6:break n;default:break r}u[t+83|0]=l[k+3|0],u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0];break r}u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0];break r}u[t+81|0]=l[k+1|0];break r}u[t+112|0]=l[k+32|0]}s=i[k+20>>2],o=t+96|0,i[o>>2]=i[k+16>>2],i[o+4>>2]=s,s=i[k+28>>2],i[o+8>>2]=i[k+24>>2],i[o+12>>2]=s}i[t+92>>2]=i[k+12>>2]}if(o=i[k+4>>2],i[t+84>>2]=o,u[t+88|0]=l[k+8|0],u[t+83|0]=l[k+3|0],u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0],o)break e}if(!S4(i[r>>2]))break e;o=i[r>>2],k=F[o+6>>1]|F[o+8>>1]<<16,o=F[o+10>>1]|F[o+12>>1]<<16,i[t+36>>2]=k>>>16,i[t+32>>2]=k&65535,u[t+28|0]=1,u[t+44|0]=o>>>16&1,i[t+40>>2]=o&65535,i[t+84>>2]=t+28}Oi(t+4|0,i[e>>2],r,f,t+80|0,1);e:{r:switch(l[t+24|0]){default:_2(),H();case 1:b0(A,t+4|0,i[e>>2]);break e;case 0:break r}i[t+120>>2]=i[t+4>>2],r=i[t+8>>2],i[t+124>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[e>>2],i[r+40>>2]||zf(r,t+120|0);r:{if(!n)break r;if(r=E(16),i[r+8>>2]=0,i[r+12>>2]=0,i[n>>2]=r,f=i[t+120>>2],k=i[t+124>>2],i[t+120>>2]=0,i[t+124>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[t+124>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=l[t+24|0],(A|0)==255)break i;e=i[24221],i[t+120>>2]=i[24220],i[t+124>>2]=e,X[i[(t+120|0)+(A<<2)>>2]](t+119|0,t+4|0)}v=t+128|0}function pm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(X[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),k=i[w+24>>2],k){if(f=i[w+28>>2],n=i[w+32>>2],r=h2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=e,i[w+48>>2]=r;break A}if(u[w+55|0]=r,e=w+44|0,!r)break f}if(!r)break f;z(e,n,r)}if(u[e+r|0]=0,K(A,k,f,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=E(168),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92332,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+16>>2]=100160,u[r+120|0]=0,i[r+116>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,Q[r+128>>1]=2056,i[r+124>>2]=1,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+32>>2]=1635148611,i[e+8>>2]=k,k=i[e+12>>2],i[e+12>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;X[i[i[k>>2]+8>>2]](k),p(k)}u[e+4|0]=1}if(Rf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}X[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),k=i[w+44>>2];f:{if(k){if(f=i[w+48>>2],n=i[w+52>>2],r=h2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break k}if(u[w+23|0]=r,e=w+12|0,!r)break A}if(!r)break A;z(e,n,r)}if(u[e+r|0]=0,K(A,k,f,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Rf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=w- -64|0;return}g0(),H()}g0(),H()}function ym(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,x2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]){t1(A,e,15567);break i}o=F0(r);e:{r:{f:{A:{k:{if(n=i[f+72>>2],!(n>>>0<o>>>0&&n)){if(o)for(t=e+104|0,n=0;;){if(i[k+24>>2]=0,i[k+28>>2]=0,e=k+24|0,I6(A,r,e,f),i[A>>2])break k;r2(t,e),u[A+19|0]<0&&Z(i[A+8>>2]),e=i[k+28>>2];n:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break n;X[i[i[e>>2]+8>>2]](e),p(e)}if(n=n+1|0,(o|0)==(n|0))break}if(l[r+20|0]!=1)break A;if(u[k+24|0]=0,u[k+35|0]=0,K(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}i[k+116>>2]=0,i[k+88>>2]=72244,i[k+32>>2]=72224,e=i[18065],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18066],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[k+32>>2]=r,t=i[r-12>>2],r=k+32|0,i[t+r>>2]=i[18068],t=i[18064],i[k+24>>2]=t,i[e+i[t-12>>2]>>2]=i[18069],i[k+88>>2]=72244,i[k+24>>2]=72204,i[k+32>>2]=72224,t=R0(n),i[t>>2]=71280,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(I0(Y(K2(Y(r,28419,11),o,0),28494,56),i[f+72>>2]),5081,6),e=i[k+84>>2];n:{if(e&16){n=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break n}if(!(e&8)){e=0,u[k+23|0]=0,n=k+12|0;break e}n=k+44|0,e=i[k+52>>2]}if(r=i[n>>2],e=e-r|0,e>>>0>=2147483640)break f;if(e>>>0>=11){f=e|7,n=E(f+1|0),i[k+20>>2]=f-2147483647,i[k+12>>2]=n,i[k+16>>2]=e;break r}if(u[k+23|0]=e,n=k+12|0,e)break r;e=0;break e}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}g0(),H()}if(!e)break e;z(n,r,e)}u[e+n|0]=0,K(A,6,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18063],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18071],i[k+32>>2]=i[18072],i[t>>2]=71280,u[k+79|0]<0&&Z(i[k+68>>2]),y0(t),p0(k+88|0)}v=k+192|0}function _r(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;w=v-2048|0,v=w;i:{e:{if((r|0)>=2){for(n=r;k=h,h=k+1|0,t=n>>>0>3,n=n>>>1|0,!!t;);h=4-k|0;break e}if(h=5,(r|0)!=1)break i}for(I=r&-4,W=r&3,g=r-1|0;;){s=(o<<1)+f|0,n=0,t=r;e:{for(;;){if(B=n,k=t,(k|0)<=0){if(t=0,n=0,k=0,g>>>0>=3)for(;Q[(G(r,n)+o<<1)+w>>1]=0,Q[(G(n|1,r)+o<<1)+w>>1]=0,Q[(G(n|2,r)+o<<1)+w>>1]=0,Q[(G(n|3,r)+o<<1)+w>>1]=0,n=n+4|0,k=k+4|0,(I|0)!=(k|0););if(!W)break e;for(;Q[(G(r,n)+o<<1)+w>>1]=0,n=n+1|0,t=t+1|0,(W|0)!=(t|0););break e}if(n=B+1|0,t=k-1|0,!!F[s+(G(t,r)<<1)>>1])break}for(C=k&2147483646,V=k&1,t=0;;){if(n=0,k=0,_=0,(B|0)!=(g|0))for(;m=G(Q[s+(G(r,n)<<1)>>1],u[((n<<h<<5)+t|0)+61792|0])+k|0,k=n|1,k=m+G(Q[s+(G(k,r)<<1)>>1],u[((k<<h<<5)+t|0)+61792|0])|0,n=n+2|0,_=_+2|0,(C|0)!=(_|0););if(_=(G(r,t)+o<<1)+w|0,V&&(k=G(Q[s+(G(r,n)<<1)>>1],u[((n<<h<<5)+t|0)+61792|0])+k|0),k=k- -64>>7,k=(k|0)>=32767?32767:k,Q[_>>1]=(k|0)<=-32768?-32768:k,t=t+1|0,(t|0)==(r|0))break}}if(o=o+1|0,(o|0)==(r|0))break}for(W=r&-2,_=r&1,o=0;;){s=G(r,o),n=s-1|0,t=0,k=r;e:{r:{for(;;){if(B=t,f=k,(k|0)<=0)break r;if(t=t+1|0,k=k-1|0,!!F[(f+n<<1)+w>>1])break}for(I=f&2147483646,C=f&1,V=G(e,o)+A|0,t=0;;){if(n=0,k=0,f=0,(B|0)!=(g|0))for(;m=G(Q[(n+s<<1)+w>>1],u[((n<<h<<5)+t|0)+61792|0])+k|0,k=n|1,k=m+G(Q[(k+s<<1)+w>>1],u[((k<<h<<5)+t|0)+61792|0])|0,n=n+2|0,f=f+2|0,(I|0)!=(f|0););if(f=t+V|0,m=l[f|0],C&&(k=G(Q[(n+s<<1)+w>>1],u[((n<<h<<5)+t|0)+61792|0])+k|0),n=f,f=(k+2048>>12)+m|0,u[n|0]=(f|0)>=0?(f|0)>=255?255:f:0,t=t+1|0,(t|0)==(r|0))break}break e}f=G(e,o)+A|0;r:{if(!g){n=0;break r}for(B=f+1|0,n=0,k=0;s=f+n|0,t=l[s|0],u[s|0]=t>>>0>=255?255:t,s=n+B|0,t=l[s|0],u[s|0]=t>>>0>=255?255:t,n=n+2|0,k=k+2|0,(W|0)!=(k|0););}if(!_)break e;k=f+n|0,f=l[k|0],u[k|0]=f>>>0>=255?255:f}if(o=o+1|0,(o|0)==(r|0))break}}v=w+2048|0}function Ym(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;n=v-16|0,v=n,t=i[r+4>>2],o=i[k>>2],s=i[r>>2],r=o+s|0;i:{if(t-r>>>0<(f|0)/8<<1>>>0){if(e=E(48),i[n+4>>2]=e,i[n+8>>2]=44,i[n+12>>2]=-2147483600,r=l[8836]|l[8837]<<8|(l[8838]<<16|l[8839]<<24),f=l[8832]|l[8833]<<8|(l[8834]<<16|l[8835]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[8872]|l[8873]<<8|(l[8874]<<16|l[8875]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[8868]|l[8869]<<8|(l[8870]<<16|l[8871]<<24),f=l[8864]|l[8865]<<8|(l[8866]<<16|l[8867]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[8860]|l[8861]<<8|(l[8862]<<16|l[8863]<<24),f=l[8856]|l[8857]<<8|(l[8858]<<16|l[8859]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8852]|l[8853]<<8|(l[8854]<<16|l[8855]<<24),f=l[8848]|l[8849]<<8|(l[8850]<<16|l[8851]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8844]|l[8845]<<8|(l[8846]<<16|l[8847]<<24),f=l[8840]|l[8841]<<8|(l[8842]<<16|l[8843]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}t=l[r|0],w=l[r+1|0];e:{if((f|0)==32){f=l[r+3|0],r=l[r+2|0],i[k>>2]=o+4,i[e+4>>2]=f|(w<<16|t<<24|r<<8),f=i[k>>2],r=f+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),f=f+4|0;break e}i[k>>2]=o+2,i[e+4>>2]=(w<<16|t<<24)>>16,f=i[k>>2],r=f+s|0,r=(l[r+1|0]<<16|l[r|0]<<24)>>16,f=f+2|0}if(i[k>>2]=f,i[e+8>>2]=r,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+16|0}function Rm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v-16|0,v=n,o=F0(r),s=F0(r),w=F0(r),_=F0(r),k=F0(r),f=F0(r),h=F0(r),t=F0(r);i:{if((t|(o|s|w|_|f))<0){if(e=E(32),i[n>>2]=e,i[n+4>>2]=31,i[n+8>>2]=-2147483616,r=l[25329]|l[25330]<<8|(l[25331]<<16|l[25332]<<24),f=l[25325]|l[25326]<<8|(l[25327]<<16|l[25328]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[25352]|l[25353]<<8|(l[25354]<<16|l[25355]<<24),f=l[25348]|l[25349]<<8|(l[25350]<<16|l[25351]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[25345]|l[25346]<<8|(l[25347]<<16|l[25348]<<24),f=l[25341]|l[25342]<<8|(l[25343]<<16|l[25344]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25337]|l[25338]<<8|(l[25339]<<16|l[25340]<<24),f=l[25333]|l[25334]<<8|(l[25335]<<16|l[25336]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,128,n),u[n+11|0]>=0)break i;Z(i[n>>2]);break i}if(s=no(n,o,s),o=i[s>>2],s=i[s+4>>2],i[e+100>>2]=o,i[e+104>>2]=s,w=no(n,w,_),o=i[w>>2],w=i[w+4>>2],i[e+108>>2]=o,i[e+112>>2]=w,f-65537>>>0<4294836223)for(;k=(k|0)/2|0,f=(f|0)/2|0,f-65537>>>0<4294836223;);e:{if((f|0)<=1)break e;for(;;){if(k-65537>>>0>4294836222)break e;if(k=(k|0)/2|0,o=f>>>0>3,f=f>>>1|0,!o)break}}if(i[e+116>>2]=k,i[e+120>>2]=f,t-65537>>>0<4294836223)for(;h=(h|0)/2|0,t=(t|0)/2|0,t-65537>>>0<4294836223;);e:{if((t|0)<=1){k=t;break e}for(;;){if(h-65537>>>0>4294836222){k=t;break e}if(h=(h|0)/2|0,o=t>>>0>3,k=t>>>1|0,t=k,!o)break}}i[e+124>>2]=h,i[e+128>>2]=k;e:{if(!(!f|(!s|!w))&&k)break e;if(e=A,A=d2(n,42716),K(e,2,128,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}cu(A,r)}v=n+16|0}function Jm(A){A=A|0;var e=0,r=0,f=0,k=0;r=A+12|0,A=i[r+152>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+144>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+136>>2],i[r+136>>2]=0,A&&X[i[i[A>>2]+4>>2]](A),n3(r+124|0,i[r+128>>2]),A=i[r+120>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+112>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+104>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+96>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+88>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+80>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+72>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+64>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+56>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+40>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[r+16>>2],A){if(e=A,f=i[r+20>>2],(A|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[r+16>>2]}i[r+20>>2]=A,Z(e)}A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function H9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(o=v-16|0,v=o,f=i[A+244>>2],!f){f=E(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=94212,n=f+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[f+16>>2]=106316,i[f+124>>2]=0,i[f+116>>2]=0,i[f+120>>2]=0,i[f+32>>2]=1953654118,i[A+244>>2]=k,k=i[A+248>>2],i[A+248>>2]=f;i:{e:{if(!k){k=i[A+132>>2],i[o+12>>2]=f,i[o+8>>2]=n;break e}if(f=i[k+4>>2],i[k+4>>2]=f-1,f||(X[i[i[k>>2]+8>>2]](k),p(k)),k=i[A+132>>2],n=i[A+244>>2],f=i[A+248>>2],i[o+12>>2]=f,i[o+8>>2]=n,!f)break i}i[f+4>>2]=i[f+4>>2]+1}r2(k+36|0,o+8|0),f=i[o+12>>2];i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[A+244>>2]}k=v-32|0,v=k;i:{e:{r:{f:{n=i[f+100>>2],A=i[f+104>>2];A:{if((n|0)!=(A|0))for(;;){if(i[n>>2]==(e|0)){if(A=i[n+8>>2],t=i[n+12>>2],A>>>0<t>>>0){i[A>>2]=r,i[n+8>>2]=A+4;break A}if(f=i[n+4>>2],A=A-f|0,w=A>>2,e=w+1|0,e>>>0>=1073741824)break f;if(t=t-f|0,s=t>>1,t=t>>>0>=2147483644?1073741823:e>>>0<s>>>0?s:e,t){if(t>>>0>=1073741824)break r;e=E(t<<2)}else e=0;s=e+A|0,i[s>>2]=r,r=s-(w<<2)|0,A&&z(r,f,A),i[n+12>>2]=e+(t<<2),A=s+4|0,i[n+8>>2]=A,i[n+4>>2]=r,f&&Z(f),i[n+8>>2]=A;break A}if(n=n+16|0,(A|0)==(n|0))break}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=e,i[k+12>>2]=r,k6(k+20|0,k+12|0,k+16|0,1),A=i[f+104>>2];k:{if(A>>>0<u0[f+108>>2]){if(e=i[k+16>>2],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=e,e=i[k+24>>2],n=i[k+20>>2],(e|0)!=(n|0)){if(e=e-n|0,(e|0)<0)break e;r=E(e),i[A+8>>2]=r,i[A+4>>2]=r,t=e+r|0,i[A+12>>2]=t,e&&z(r,n,e),i[A+8>>2]=t}A=A+16|0;break k}A=yr(f+100|0,k+16|0)}if(i[f+104>>2]=A,A=i[k+20>>2],!A)break A;i[k+24>>2]=A,Z(A)}v=k+32|0;break i}G0(),H()}x0(),H()}G0(),H()}v=o+16|0}function Br(A,e,r){var f=0,k=0,n=0,t=0;f=v-96|0,v=f,k=f- -64|0;i:{e:{r:{f:{A:{k:{n:{t:{u:{if(r){X[i[i[e>>2]+24>>2]](f+56|0,e);o:{l:switch(l[f+76|0]){case 1:e=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=e,e=A+8|0;s:{if(u[f+75|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2];break s}T(e,i[f+64>>2],i[f+68>>2])}u[A+20|0]=1;break o;case 0:break l;default:break u}if(i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,r=i[f+60>>2],k=i[f+56>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break A;n=E(r),i[f+44>>2]=n,t=r+n|0,i[f+52>>2]=t,r&&z(n,k,r),i[f+48>>2]=t}fA(f+16|0,e+8|0);l:{s:{w:switch(r=l[f+36|0],r|0){case 0:break s;case 1:break w;default:break u}if(e=i[f+20>>2],i[A>>2]=i[f+16>>2],i[A+4>>2]=e,e=A+8|0,u[f+35|0]>=0){k=i[f+28>>2],i[e>>2]=i[f+24>>2],i[e+4>>2]=k,i[e+8>>2]=i[f+32>>2];break l}T(e,i[f+24>>2],i[f+28>>2]);break l}e=i[f+16>>2],k=i[e>>2],e=i[e+4>>2],$4(f+44|0,i[f+48>>2],k,e,e-k|0),e=i[f+52>>2],i[f+52>>2]=0,k=i[f+44>>2],n=i[f+48>>2],i[f+44>>2]=0,i[f+48>>2]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=n}if(u[A+20|0]=r,A=l[f+36|0],(A|0)!=255&&(e=i[24271],i[f+88>>2]=i[24270],i[f+92>>2]=e,X[i[(f+88|0)+(A<<2)>>2]](f+87|0,f+16|0)),A=i[f+44>>2],!A)break o;i[f+48>>2]=A,Z(A)}if(A=l[f+76|0],(A|0)==255)break i;e=i[24273],i[f+16>>2]=i[24272],i[f+20>>2]=e,X[i[(f+16|0)+(A<<2)>>2]](f+44|0,f+56|0);break i}switch(fA(f+56|0,e+8|0),e=l[f+76|0],e|0){case 0:break n;case 1:break t;default:break u}}_2(),H()}if(r=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=r,r=A+8|0,u[f+75|0]<0)break r;n=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=n,i[r+8>>2]=i[k+8>>2];break k}if(r=0,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=0,n=i[f+56>>2],t=i[n+4>>2],n=i[n>>2],(t|0)!=(n|0)){if(r=t-n|0,(r|0)<0)break f;k=E(r),r&&z(k,n,r),r=r+k|0}i[A+8>>2]=r,i[A+4>>2]=r,i[A>>2]=k}u[A+20|0]=e;break e}G0(),H()}G0(),H()}if(T(r,i[f+64>>2],i[f+68>>2]),e=l[f+76|0],u[A+20|0]=1,(e|0)==255)break i}A=i[24271],i[f+16>>2]=i[24270],i[f+20>>2]=A,X[i[(f+16|0)+(e<<2)>>2]](f+44|0,f+56|0)}v=f+96|0}function x9(A,e,r,f,k,n,t,o,s,w,h,_,B){var m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0;m=v,x=m,m=m-19808&-32,v=m,g=i[e+16852>>2],I=G(2/(g|0)|0,r),r=((k|0)/(g|0)|0)+(I>>3)|0,k=f,f=i[e+16856>>2],W=G(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(W>>3)|0,V=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(g|0)|0;i:{if(g=I&7,f=W&7,!(g|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+h|0)|((n|0)<0|(V|0)<(n+_|0)))){if(e=((r<<1)+s|0)+(G(n,w)<<1)|0,(B|0)<=8){X[i[A+204>>2]](t,o,e,w,h,_,0,0,0);break i}X[i[A+284>>2]](t,o,e,w,h,_,0,0,0,B);break i}if((_|0)<=0|(h|0)<=0)break i;for(B=14-e|0,y=V-1|0,m=k-1|0,R=h&2147483646,N=h&1,A=0;;){if(e=A+n|0,g=(G((e|0)>=0?(e|0)<(V|0)?e:y:0,w)<<1)+s|0,I=(G(A,o)<<1)+t|0,e=0,f=0,(h|0)!=1)for(;W=e+r|0,Q[I+(e<<1)>>1]=F[g+(((W|0)>=0?(k|0)>(W|0)?W:m:0)<<1)>>1]<<B,C=e|1,W=C+r|0,Q[I+(C<<1)>>1]=F[g+(((W|0)>=0?(k|0)>(W|0)?W:m:0)<<1)>>1]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=I+(e<<1)|0,e=e+r|0,Q[f>>1]=F[g+(((e|0)>=0?(e|0)<(k|0)?e:m:0)<<1)>>1]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+h|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(V-2|0)))){e=((r<<1)+s|0)+(G(n,w)<<1)|0;break e}if(!((_|0)<-2|(h|0)<-2))for(I=-1,S=V-1|0,W=k-1|0,e=_+2|0,O=(e|0)>0?e:0,L=r+1|0,e=h+3|0,a=e&-2,$=e&1;;){if(e=n+I|0,y=(G((e|0)>=0?(e|0)<(V|0)?e:S:0,w)<<1)+s|0,R=G(I,80)+81|0,e=-1,(h|0)!=-2)for(D=R+1|0,N=0;C=e+r|0,Q[m+(e+R<<1)>>1]=F[y+(((C|0)>=0?(k|0)>(C|0)?C:W:0)<<1)>>1],C=e+L|0,Q[m+(e+D<<1)>>1]=F[y+(((C|0)>=0?(k|0)>(C|0)?C:W:0)<<1)>>1],e=e+2|0,N=N+2|0,(a|0)!=(N|0););if($&&(D=m+(e+R<<1)|0,e=e+r|0,Q[D>>1]=F[y+(((e|0)>=0?(e|0)<(k|0)?e:W:0)<<1)>>1]),I=I+1|0,(O|0)==(I|0))break}w=80,e=m+162|0}if(!(!g|!f)){X[i[(((B|0)<9?44:124)+A|0)+172>>2]](t,o,e,w,h,_,g,f,m+10720|0,B);break i}if(g){X[i[(((B|0)<9?36:116)+A|0)+172>>2]](t,o,e,w,h,_,g,f,m+10720|0,B);break i}if(f){X[i[(((B|0)<9?40:120)+A|0)+172>>2]](t,o,e,w,h,_,0,f,m+10720|0,B);break i}M0(12200,18236,269,18980),H()}v=x}function Nm(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;o=v-32|0,v=o;i:{if(!(f&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}n=i[e>>2],t=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!e3(t,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3550;break e}r4(o+24|0,i[e>>2],r,0),t=i[o+24>>2];r:{if(!t||(n=i[t+104>>2],t=i[t+108>>2],(n|0)==(t|0)))break r;for(;;){f:{if(w=i[n>>2],!w||!X0(w,86628,86672))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1404;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1404,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=i[o+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}if(n=n+8|0,(t|0)==(n|0))break}}n=i[o+28>>2];r:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break r;X[i[i[n>>2]+8>>2]](n),p(n)}if(n=E(152),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=92292,t=n+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,Q[n+112>>1]=0,i[t>>2]=89424,u[n+144|0]=0,i[n+136>>2]=0,i[n+140>>2]=2147483647,i[n+128>>2]=-1,i[n+132>>2]=-1,u[n+120|0]=1,i[n+32>>2]=1952541027,l[f|0]&&(w=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=w,i[n+136>>2]=i[f+16>>2],i[n+140>>2]=i[f+20>>2],u[n+144|0]=l[f+24|0]),e=i[e>>2],i[o+20>>2]=n,i[o+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,f=i[o+20>>2],i[o+8>>2]=i[o+16>>2],i[o+12>>2]=f,e=re(e,r,o+8|0,0),k&&(i[k>>2]=e),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;X[i[i[n>>2]+8>>2]](n),p(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}v=o+32|0}function Mm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(X[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),r=i[w+24>>2],r){if(k=i[w+28>>2],n=i[w+32>>2],e=h2(n),e>>>0>=2147483640)break e;f:{A:{if(e>>>0>=11){t=e|7,f=E(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=f,i[w+48>>2]=e;break A}if(u[w+55|0]=e,f=w+44|0,!e)break f}if(!e)break f;z(f,n,e)}if(u[e+f|0]=0,K(A,r,k,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=E(160),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90412,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+16>>2]=97552,i[r+156>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,u[r+145|0]=4,i[r+124>>2]=0,i[r+128>>2]=0,i[r+32>>2]=1752589123,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;X[i[i[k>>2]+8>>2]](k),p(k)}u[e+4|0]=1}if(Yf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}X[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),r=i[w+44>>2];f:{if(r){if(k=i[w+48>>2],n=i[w+52>>2],e=h2(n),e>>>0>=2147483640)break i;A:{k:{if(e>>>0>=11){t=e|7,f=E(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=f,i[w+16>>2]=e;break k}if(u[w+23|0]=e,f=w+12|0,!e)break A}if(!e)break A;z(f,n,e)}if(u[e+f|0]=0,K(A,r,k,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Yf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=w- -64|0;return}g0(),H()}g0(),H()}function Um(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;o=v-32|0,v=o;i:{if(!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}n=i[e>>2],t=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!e3(t,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3455;break e}r4(o+24|0,i[e>>2],r,0),t=i[o+24>>2];r:{if(!t||(n=i[t+104>>2],t=i[t+108>>2],(n|0)==(t|0)))break r;for(;;){f:{if(w=i[n>>2],!w||!X0(w,86628,86684))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1307;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1307,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=i[o+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A);break e}if(n=n+8|0,(t|0)==(n|0))break}}n=i[o+28>>2];r:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break r;X[i[i[n>>2]+8>>2]](n),p(n)}if(n=E(144),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=92252,t=n+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86404,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,Q[n+112>>1]=0,i[t>>2]=89492,i[n+128>>2]=0,i[n+132>>2]=0,u[n+120|0]=1,i[n+32>>2]=1769234793,u[n+135|0]=0,u[n+136|0]=0,u[n+137|0]=0,u[n+138|0]=0,l[f|0]&&(w=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=w,u[n+136|0]=l[f+16|0],u[n+138|0]=l[f+18|0],u[n+137|0]=l[f+17|0]),e=i[e>>2],i[o+20>>2]=n,i[o+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,f=i[o+20>>2],i[o+8>>2]=i[o+16>>2],i[o+12>>2]=f,e=re(e,r,o+8|0,0),k&&(i[k>>2]=e),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;X[i[i[n>>2]+8>>2]](n),p(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}v=o+32|0}function z9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(w=i[A+176>>2],_=i[A+180>>2],(w|0)!=(_|0))for(;;){i:{if(A=i[w+4>>2],B=i[w+8>>2],(A|0)==(B|0))break i;for(;;){e:{s=i[A>>2],o=i[A+4>>2],t=i[e+4>>2],r=i[e+8>>2];r:{if(t>>>0<r>>>0){u[t|0]=0,r=t+1|0;break r}if(k=i[e>>2],t=t-k|0,f=t+1|0,(f|0)<0)break e;if(r=r-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=E(r):f=0,n=f+t|0,u[n|0]=0,t&&z(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,n=i[e+8>>2];r:{if(n>>>0>r>>>0){u[r|0]=0,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=E(r):f=0,n=f+t|0,u[n|0]=0,t&&z(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,s=o-s|0,o=s>>>8|0,n=i[e+8>>2];r:{if(n>>>0>r>>>0){u[r|0]=o,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=E(r):f=0,n=f+t|0,u[n|0]=o,t&&z(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,o=i[e+8>>2];r:{if(o>>>0>r>>>0){u[r|0]=s,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=o-k|0,o=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<o>>>0?o:f,r?f=E(r):f=0,o=f+t|0,u[o|0]=s,t&&z(f,k,t),i[e+8>>2]=r+f,r=o+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,t=i[A+4>>2],o=i[A>>2],k=t-o|0;r:{if((k|0)<=0)break r;if(n=i[e+8>>2],(k|0)<=(n-r|0)){!k|(t|0)==(o|0)||z(r,o,k),i[e+4>>2]=r+k;break r}if(s=i[e>>2],t=r-s|0,f=t+k|0,(f|0)<0)break e;if(n=n-s|0,h=n<<1,n=n>>>0>=1073741823?2147483647:f>>>0<h>>>0?h:f,n?f=E(n):f=0,h=f+t|0,k&&z(h,o,k),i[e+4>>2]=r,t&&z(f,s,t),i[e+8>>2]=f+n,i[e+4>>2]=k+h,i[e>>2]=f,!s)break r;Z(s)}if(A=A+12|0,(B|0)!=(A|0))continue;break i}break}G0(),H()}if(w=w+16|0,(_|0)==(w|0))break}return 1}function vr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;if(!A)return p2(e);if(e>>>0>=4294967232)return i[31336]=48,0;t=e>>>0<11?16:e+11&-8,s=A-8|0,w=i[s+4>>2],k=w&-8;i:{if(!(w&3)){if(t>>>0<256||k>>>0>=t+4>>>0&&(r=s,k-t>>>0<=i[31770]<<1>>>0))break i;r=0;break i}o=k+s|0;e:{if(k>>>0>=t>>>0){if(f=k-t|0,f>>>0<16)break e;i[s+4>>2]=w&1|t|2,r=t+s|0,i[r+4>>2]=f|3,i[o+4>>2]=i[o+4>>2]|1,ur(r,f);break e}if(i[31656]==(o|0)){if(k=k+i[31653]|0,k>>>0<=t>>>0)break i;i[s+4>>2]=w&1|t|2,f=t+s|0,r=k-t|0,i[f+4>>2]=r|1,i[31653]=r,i[31656]=f;break e}if(i[31655]==(o|0)){if(k=k+i[31652]|0,k>>>0<t>>>0)break i;r=k-t|0;r:{if(r>>>0>=16){i[s+4>>2]=w&1|t|2,f=t+s|0,i[f+4>>2]=r|1,k=k+s|0,i[k>>2]=r,i[k+4>>2]=i[k+4>>2]&-2;break r}i[s+4>>2]=k|w&1|2,r=k+s|0,i[r+4>>2]=i[r+4>>2]|1,r=0}i[31655]=f,i[31652]=r;break e}if(f=i[o+4>>2],f&2||(h=k+(f&-8)|0,h>>>0<t>>>0))break i;B=h-t|0,n=i[o+12>>2];r:{if(f>>>0<=255){if(r=i[o+8>>2],(r|0)==(n|0)){m=126600,W=i[31650]&k2(-2,f>>>3|0),i[m>>2]=W;break r}i[r+12>>2]=n,i[n+8>>2]=r;break r}_=i[o+24>>2];f:{if((n|0)!=(o|0)){r=i[o+8>>2],i[r+12>>2]=n,i[n+8>>2]=r;break f}A:{if(r=i[o+20>>2],r)f=o+20|0;else{if(r=i[o+16>>2],!r)break A;f=o+16|0}for(;k=f,n=r,f=r+20|0,r=i[r+20>>2],!(!r&&(f=n+16|0,r=i[n+16>>2],!r)););i[k>>2]=0;break f}n=0}if(!_)break r;f=i[o+28>>2],r=(f<<2)+126904|0;f:{if(i[r>>2]==(o|0)){if(i[r>>2]=n,n)break f;m=126604,W=i[31651]&k2(-2,f),i[m>>2]=W;break r}A:{if(i[_+16>>2]==(o|0)){i[_+16>>2]=n;break A}i[_+20>>2]=n}if(!n)break r}if(i[n+24>>2]=_,r=i[o+16>>2],r&&(i[n+16>>2]=r,i[r+24>>2]=n),r=i[o+20>>2],!r)break r;i[n+20>>2]=r,i[r+24>>2]=n}if(B>>>0<=15){i[s+4>>2]=w&1|h|2,r=s+h|0,i[r+4>>2]=i[r+4>>2]|1;break e}i[s+4>>2]=w&1|t|2,f=t+s|0,i[f+4>>2]=B|3,r=s+h|0,i[r+4>>2]=i[r+4>>2]|1,ur(f,B)}r=s}return r?r+8|0:(f=p2(e),f?(r=i[A-4>>2],r=(r&3?-4:-8)+(r&-8)|0,A8(f,A,e>>>0>r>>>0?r:e),Z(A),f):0)}function T9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=i[e>>2];i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(!f||(t=i[f>>2],!t))break s;if(!A){f=r;break o}i[f>>2]=0,f=r;break l}s:{if(!i[i[31378]>>2]){if(!A)break s;if(!r)break i;for(t=r;;){if(f=u[k|0],f){if(i[A>>2]=f&57343,A=A+4|0,k=k+1|0,t=t-1|0,t)continue;break i}break}return i[A>>2]=0,i[e>>2]=0,r-t|0}if(f=r,!A)break u;break n}return h2(k)}n=1;break n}n=0;break t}n=1}for(;;){if(!n){if(n=l[k|0]>>>3|0,(n-16|n+(t>>26))>>>0>7)break k;n=k+1|0;t:{if(!(t&33554432))break t;if(u[n|0]>=-64){k=k-1|0;break f}if(n=k+2|0,!(t&524288))break t;if(u[n|0]>=-64){k=k-1|0;break f}n=k+3|0}k=n,f=f-1|0,n=1;continue}for(;;){t=u[k|0];t:{if(k&3|(t|0)<=0||(t=i[k>>2],(t|t-16843009)&-2139062144))break t;for(;f=f-4|0,t=i[k+4>>2],k=k+4|0,!((t-16843009|t)&-2139062144););}if(t<<24>>24>0){f=f-1|0,k=k+1|0;continue}break}if(n=(t&255)-194|0,n>>>0>50)break A;k=k+1|0,t=i[(n<<2)+73232>>2],n=0}}for(;;){if(!n){if(!f)break i;for(;;){n:{if(n=l[k|0],t=n<<24>>24,(t|0)<=0)break n;if(!(k&3|f>>>0<5)){t:{for(;;){if(t=i[k>>2],(t|t-16843009)&-2139062144)break t;if(i[A>>2]=t&255,i[A+4>>2]=l[k+1|0],i[A+8>>2]=l[k+2|0],i[A+12>>2]=l[k+3|0],A=A+16|0,k=k+4|0,f=f-4|0,!(f>>>0>4))break}t=l[k|0]}if(n=t&255,t<<24>>24<=0)break n}if(i[A>>2]=n,A=A+4|0,k=k+1|0,f=f-1|0,f)continue;break i}break}if(n=n-194|0,n>>>0>50)break A;k=k+1|0,t=i[(n<<2)+73232>>2],n=1;continue}if(n=l[k|0],o=n>>>3|0,(o-16|o+(t>>26))>>>0>7)break k;n:{t:{o=k+1|0,n=n-128|t<<6;u:{if((n|0)>=0)break u;if(o=l[o|0]-128|0,o>>>0>63)break t;if(s=n<<6,n=o|s,o=k+2|0,(s|0)>=0)break u;if(o=l[o|0]-128|0,o>>>0>63)break t;n=o|n<<6,o=k+3|0}k=o,i[A>>2]=n,f=f-1|0,A=A+4|0;break n}i[31336]=25,k=k-1|0;break r}n=0}}if(k=k-1|0,t)break f;t=l[k|0]}if(t&255)break f;return A&&(i[A>>2]=0,i[e>>2]=0),r-f|0}if(i[31336]=25,!A)break e}i[e>>2]=k}return-1}return i[e>>2]=k,r}function S9(A,e,r,f,k,n,t,o,s,w,h,_,B,m,W){var g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;for(R=v-16|0,v=R,i[r>>2]=A,D=o?4:0,x=f&512;;){if((N|0)==4)l[m+11|0]>>>7|0?k=i[m+4>>2]:k=l[m+11|0]&127,k>>>0>1&&(O=R,L=T4(m),i[O+12>>2]=L,O=r,L=Tt(tk(R+12|0,1),s6(m),i[r>>2]),i[O>>2]=L),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(l[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],I=X[i[i[t>>2]+44>>2]](t,32)|0,o=i[r>>2],i[r>>2]=o+4,i[o>>2]=I;break i;case 3:if(l[m+11|0]>>>7|0?o=i[m+4>>2]:o=l[m+11|0]&127,!o)break i;l[m+11|0]>>>7|0?o=i[m>>2]:o=m,I=i[o>>2],o=i[r>>2],i[r>>2]=o+4,i[o>>2]=I;break i;case 2:if(l[B+11|0]>>>7|0?o=i[B+4>>2]:o=l[B+11|0]&127,o=!o,o|!x)break i;O=r,L=Tt(T4(B),s6(B),i[r>>2]),i[O>>2]=L;break i;case 4:break e;default:break i}for(S=i[r>>2],k=k+D|0,o=k;;){e:{if(n>>>0<=o>>>0||!(X[i[i[t>>2]+12>>2]](t,64,i[o>>2])|0))break e;o=o+4|0;continue}break}if((W|0)>0){for(I=i[r>>2],C=W;;){if(!(!C|k>>>0>=o>>>0)){C=C-1|0,o=o-4|0,V=i[o>>2],g=I+4|0,i[r>>2]=g,i[I>>2]=V,I=g;continue}break}for(C?g=X[i[i[t>>2]+44>>2]](t,48)|0:g=0,V=g,I=i[r>>2];;){if((C|0)>0){g=I+4|0,i[r>>2]=g,i[I>>2]=V,C=C-1|0,I=g;continue}break}I=i[r>>2],i[r>>2]=I+4,i[I>>2]=w}e:{if((k|0)==(o|0)){I=X[i[i[t>>2]+44>>2]](t,48)|0,o=i[r>>2],i[r>>2]=o+4,i[o>>2]=I;break e}for(l[_+11|0]>>>7|0?g=i[_>>2]:g=_,g=u[g|0],l[_+11|0]>>>7|0?I=i[_+4>>2]:I=l[_+11|0]&127,g=I?g:-1,C=0,y=0;;){if((k|0)==(o|0))break e;r:{if((C|0)!=(g|0)){I=C;break r}if(I=i[r>>2],i[r>>2]=I+4,i[I>>2]=h,I=0,l[_+11|0]>>>7|0?g=i[_+4>>2]:g=l[_+11|0]&127,y=y+1|0,g>>>0<=y>>>0){g=C;break r}if(l[_+11|0]>>>7|0?g=i[_>>2]:g=_,l[g+y|0]==127){g=-1;break r}l[_+11|0]>>>7|0?g=i[_>>2]:g=_,g=u[g+y|0]}o=o-4|0,V=i[o>>2],C=i[r>>2],i[r>>2]=C+4,i[C>>2]=V,C=I+1|0}}cr(S,i[r>>2])}N=N+1|0;continue}break}}function j9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v-160|0,v=t,i[t+100>>2]=0,i[t+72>>2]=72244,i[t+16>>2]=72224,n=i[18065],i[t+8>>2]=n,B=i[n-12>>2],o=t+8|0,n=o,i[B+n>>2]=i[18066],i[t+12>>2]=0,n=n+i[i[t+8>>2]-12>>2]|0,h=t+20|0,J0(n,h),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[t+16>>2]=n,s=t+16|0,i[s+i[n-12>>2]>>2]=i[18068],n=i[18064],i[t+8>>2]=n,i[o+i[n-12>>2]>>2]=i[18069],i[t+72>>2]=72244,i[t+8>>2]=72204,i[t+16>>2]=72224,h=R0(h),i[h>>2]=71280,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+68>>2]=24,n=i[t+16>>2]-12|0,o=s+i[n>>2]|0,i[o+4>>2]=i[o+4>>2]&-75|8,o=s+i[n>>2]|0,l[o+80|0]||(w=t+156|0,n=i[o+28>>2],i[w>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(w,129808),X[i[i[n>>2]+28>>2]](n,32)|0,e2(w)),u[o+76|0]=48,u[o+77|0]=0,u[o+78|0]=0,u[o+79|0]=0,n=1,u[o+80|0]=1,o=t+28|0;i:{if(!r)break i;if(w=u[f+11|0],_=(w|0)<0,Y(s,_?i[f>>2]:f,_?i[f+4>>2]:w),i[i[i[t+16>>2]-12>>2]+o>>2]=4,Y(I0(s,0),32772,2),i[i[i[t+16>>2]-12>>2]+o>>2]=2,S0(s,l[e|0]),f=r-1|0,!f){Y(s,42713,1);break i}for(;;){e:{r:{f:{A:switch(w=n&15,w|0){case 0:break A;case 8:break f;default:break r}_=u[k+11|0],B=(_|0)<0,Y(s,B?i[k>>2]:k,B?i[k+4>>2]:_),i[i[i[t+16>>2]-12>>2]+o>>2]=4,Y(I0(s,n),32772,2);break e}Y(s,32850,2);break e}Y(s,32851,1)}if(i[i[i[t+16>>2]-12>>2]+o>>2]=2,S0(s,l[e+n|0]),(f|0)!=(n|0)&(w|0)!=15||Y(s,42713,1),n=n+1|0,(n|0)==(r|0))break}}e=i[t+68>>2];i:{e:{if(e&16){o=t+40|0,r=i[t+64>>2],e=i[t+44>>2],r>>>0<e>>>0?i[t+64>>2]=e:e=r;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}e=i[t+36>>2]}e:{if(r=i[o>>2],n=e-r|0,n>>>0<2147483640){if(n>>>0>=11){f=n|7,e=E(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}g0(),H()}if(!n)break i;z(A,r,n)}u[A+n|0]=0,A=i[18063],i[t+8>>2]=A,i[i[A-12>>2]+(t+8|0)>>2]=i[18071],i[t+16>>2]=i[18072],i[h>>2]=71280,u[t+63|0]<0&&Z(i[t+52>>2]),y0(h),p0(t+72|0),v=t+160|0}function Dm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-32|0,v=n;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(i[r>>2]=0,f=i[e>>2],t=u[f+247|0],k=(t|0)<0,t=p2((k?i[f+240>>2]:t)+1|0),!t){if(r=E(48),i[n>>2]=r,i[n+4>>2]=45,i[n+8>>2]=-2147483600,f=l[11139]|l[11140]<<8|(l[11141]<<16|l[11142]<<24),k=l[11135]|l[11136]<<8|(l[11137]<<16|l[11138]<<24),u[r+37|0]=k,u[r+38|0]=k>>>8,u[r+39|0]=k>>>16,u[r+40|0]=k>>>24,u[r+41|0]=f,u[r+42|0]=f>>>8,u[r+43|0]=f>>>16,u[r+44|0]=f>>>24,f=l[11134]|l[11135]<<8|(l[11136]<<16|l[11137]<<24),k=l[11130]|l[11131]<<8|(l[11132]<<16|l[11133]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[11126]|l[11127]<<8|(l[11128]<<16|l[11129]<<24),k=l[11122]|l[11123]<<8|(l[11124]<<16|l[11125]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[11118]|l[11119]<<8|(l[11120]<<16|l[11121]<<24),k=l[11114]|l[11115]<<8|(l[11116]<<16|l[11117]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[11110]|l[11111]<<8|(l[11112]<<16|l[11113]<<24),k=l[11106]|l[11107]<<8|(l[11108]<<16|l[11109]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[11102]|l[11103]<<8|(l[11104]<<16|l[11105]<<24),k=l[11098]|l[11099]<<8|(l[11100]<<16|l[11101]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+45|0]=0,r=A,A=K(n+12|0,6,0,n),e=i[e>>2],b0(r,A,e?e+84|0:0),u[A+19|0]<0&&Z(i[A+8>>2]),u[n+11|0]>=0)break i;Z(i[n>>2]);break i}o=r,s=c4(t,k?i[f+236>>2]:f+236|0),i[o>>2]=s,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}v=n+32|0}function Hm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(d1(Y(k,29686,17),t0[e+112>>3]),32776,2),t0[e+120>>3]),42713,1);i:{if(l[e+128|0]==1){n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(d1(Y(k,31038,14),t0[e+104>>3]),32776,2),t0[e+136>>3]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(f+8|0,29617,6),t0[e+144>>3]),42713,1);break i}k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,31038,14),t0[e+104>>3]),42713,1),e=f+148|0,s0(e,r),n=e,e=u[f+159|0],r=(e|0)<0,Y(k,r?i[f+148>>2]:n,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,32853,8)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function O9(A,e,r,f,k,n,t,o,s,w,h,_,B){var m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0;m=v,S=m,m=m-14464&-32,v=m,g=i[e+16852>>2],I=G(2/(g|0)|0,r),r=((k|0)/(g|0)|0)+(I>>3)|0,k=f,f=i[e+16856>>2],W=G(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(W>>3)|0,V=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(g|0)|0;i:{if(g=I&7,f=W&7,!(g|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+h|0)|((n|0)<0|(V|0)<(n+_|0)))){if(e=(r+s|0)+G(n,w)|0,(B|0)<=8){X[i[A+204>>2]](t,o,e,w,h,_,0,0,0);break i}X[i[A+284>>2]](t,o,e,w,h,_,0,0,0,B);break i}if((_|0)<=0|(h|0)<=0)break i;for(B=14-e|0,y=V-1|0,m=k-1|0,R=h&2147483646,N=h&1,A=0;;){if(e=A+n|0,g=G((e|0)>=0?(e|0)<(V|0)?e:y:0,w)+s|0,I=(G(A,o)<<1)+t|0,e=0,f=0,(h|0)!=1)for(;W=e+r|0,Q[I+(e<<1)>>1]=l[g+((W|0)>=0?(k|0)>(W|0)?W:m:0)|0]<<B,C=e|1,W=C+r|0,Q[I+(C<<1)>>1]=l[g+((W|0)>=0?(k|0)>(W|0)?W:m:0)|0]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=I+(e<<1)|0,e=e+r|0,Q[f>>1]=l[g+((e|0)>=0?(e|0)<(k|0)?e:m:0)|0]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+h|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(V-2|0)))){e=(r+s|0)+G(n,w)|0;break e}if(!((_|0)<-2|(h|0)<-2))for(I=-1,O=V-1|0,W=k-1|0,e=_+2|0,L=(e|0)>0?e:0,a=r+1|0,e=h+3|0,$=e&-2,f0=e&1;;){if(e=n+I|0,y=G((e|0)>=0?(e|0)<(V|0)?e:O:0,w)+s|0,R=G(I,80)+81|0,e=-1,(h|0)!=-2)for(D=R+1|0,N=0;x=m+16|0,C=e+r|0,u[x+(e+R|0)|0]=l[y+((C|0)>=0?(k|0)>(C|0)?C:W:0)|0],C=e+a|0,u[(e+D|0)+x|0]=l[y+((C|0)>=0?(k|0)>(C|0)?C:W:0)|0],e=e+2|0,N=N+2|0,($|0)!=(N|0););if(f0&&(D=m+16+(e+R)|0,e=e+r|0,u[D|0]=l[y+((e|0)>=0?(e|0)<(k|0)?e:W:0)|0]),I=I+1|0,(L|0)==(I|0))break}w=80,e=m+97|0}if(!(!g|!f)){X[i[(((B|0)<9?44:124)+A|0)+172>>2]](t,o,e,w,h,_,g,f,m+5376|0,B);break i}if(g){X[i[(((B|0)<9?36:116)+A|0)+172>>2]](t,o,e,w,h,_,g,f,m+5376|0,B);break i}if(f){X[i[(((B|0)<9?40:120)+A|0)+172>>2]](t,o,e,w,h,_,0,f,m+5376|0,B);break i}M0(12200,18236,269,18980),H()}v=S}function xm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v+-64|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+40>>2]-i[e+36>>2]>>3;i:{if(f>>>0>=65536){if(e=E(32),i[k+52>>2]=e,i[k+56>>2]=29,i[k+60>>2]=-2147483616,r=l[23928]|l[23929]<<8|(l[23930]<<16|l[23931]<<24),f=l[23924]|l[23925]<<8|(l[23926]<<16|l[23927]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[23949]|l[23950]<<8|(l[23951]<<16|l[23952]<<24),f=l[23945]|l[23946]<<8|(l[23947]<<16|l[23948]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[23944]|l[23945]<<8|(l[23946]<<16|l[23947]<<24),f=l[23940]|l[23941]<<8|(l[23942]<<16|l[23943]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23936]|l[23937]<<8|(l[23938]<<16|l[23939]<<24),f=l[23932]|l[23933]<<8|(l[23934]<<16|l[23935]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,5,0,k+52|0),u[k+63|0]>=0)break i;Z(i[k+52>>2]);break i}C0(r,f),f=i[e+36>>2],n=i[e+40>>2];e:{if((f|0)!=(n|0))for(;;){if(o=i[f>>2],X[i[i[o>>2]+20>>2]](k+32|0,o,r),i[k+32>>2])break e;if(u[k+51|0]<0&&Z(i[k+40>>2]),f=f+8|0,(n|0)==(f|0))break}if(f=i[26929],i[k+32>>2]=i[26928],i[k+36>>2]=f,f=k+40|0,u[107731]>=0){n=i[26931],i[f>>2]=i[26930],i[f+4>>2]=n,i[f+8>>2]=i[26932];break e}T(f,i[26930],i[26931])}if(u[k+51|0]<0&&Z(i[k+40>>2]),i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k- -64|0}function zm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],w=k+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(w,t),u[w+80|0]=0,i[w+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,w=R0(t),i[w>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,t=f+148|0,Y2(t,e,r),n=k,o=t,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),n=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:n,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,31130,6),t=e+104|0,n=u[e+115|0],o=(n|0)<0,Y(Y(s,o?i[e+104>>2]:t,o?i[e+108>>2]:n),42713,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,31897,6),n=u[e+127|0],o=(n|0)<0,Y(Y(s,o?i[e+116>>2]:e+116|0,o?i[e+120>>2]:n),42713,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,30577,13),n=u[e+139|0],o=(n|0)<0,Y(Y(s,o?i[e+128>>2]:e+128|0,o?i[e+132>>2]:n),42713,1),n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(f+8|0,29984,6),r=u[e+115|0],k=(r|0)<0,Y(Y(n,k?i[e+104>>2]:t,k?i[e+108>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[w>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(w),p0(f- -64|0),v=f+160|0}function Tm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,32716,25),Y(I0(Y(I0(Y(k,27191,1),F[e+100>>1]),21063,1),F[e+106>>1]),32775,3),Y(I0(Y(I0(Y(k,27191,1),F[e+102>>1]),21063,1),F[e+108>>1]),32775,3),Y(I0(Y(I0(Y(k,27191,1),F[e+104>>1]),21063,1),F[e+110>>1]),42712,2),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(I0(Y(k,27163,20),F[e+112>>1]),21063,1),F[e+114>>1]),42712,2),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,32022,33),i[e+116>>2]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,32056,33),i[e+120>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function mr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-160|0,v=k,i[k+92>>2]=0,i[k+64>>2]=72548,t=i[18140],i[k+8>>2]=t,n=i[t-12>>2],t=k+8|0,i[n+t>>2]=i[18141],t=t+i[i[k+8>>2]-12>>2]|0,w=k+12|0,J0(t,w),u[t+80|0]=0,i[t+72>>2]=0,i[k+64>>2]=72548,i[k+8>>2]=72528,w=R0(w),i[w>>2]=71280,i[k+52>>2]=0,i[k+56>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+60>>2]=16,t=1,n=i[r>>2]+1|0,i[r>>2]=n;i:{e:{r:{h=i[e+40>>2],e=i[e+36>>2];f:{if((h|0)==(e|0)){i[r>>2]=((n|0)<=1?1:n)-1;break f}if(f&&(t=k+148|0,s0(t,r),s=t,t=u[k+159|0],n=(t|0)<0,Y(k+8|0,n?i[k+148>>2]:s,n?i[k+152>>2]:t),u[k+159|0]<0&&Z(i[k+148>>2]),Y(S0(Y(k+8|0,29568,7),1),42713,1),t=2),n=k+148|0,o=i[e>>2],X[i[i[o>>2]+12>>2]](n,o,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(h|0)!=(e|0))for(;n=k+148|0,s0(n,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),n=k+8|0,Y(n,42713,1),f&&(o=k+148|0,s0(o,r),_=n,s=o,n=u[k+159|0],o=(n|0)<0,Y(_,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),Y(S0(Y(k+8|0,29568,7),t),42713,1),t=t+1|0),n=k+148|0,o=i[e>>2],X[i[i[o>>2]+12>>2]](n,o,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(h|0)!=(e|0););if(e=i[k+60>>2],f=r,r=i[r>>2],i[f>>2]=((r|0)<=1?1:r)-1,!(e&16))break r}e=i[k+56>>2],r=i[k+36>>2],e>>>0<r>>>0&&(i[k+56>>2]=r,e=r),r=k+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[k+28>>2],r=k+20|0}e:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,f,e)}u[A+e|0]=0,A=i[18139],i[k+8>>2]=A,i[i[A-12>>2]+(k+8|0)>>2]=i[18142],i[w>>2]=71280,u[k+55|0]<0&&Z(i[k+44>>2]),y0(w),p0(k- -64|0),v=k+160|0}function Uf(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;s=v-16|0,v=s;i:{if(!n){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}f|k||(Y(128500,41896,136),f=2);e:{r:{f:switch(f|0){case 0:o=E(12),i[s+4>>2]=o,t=o+12|0,i[s+12>>2]=t,i[o+8>>2]=3,i[o>>2]=1,i[o+4>>2]=2;break r;case 1:o=E(28),i[s+4>>2]=o,t=o+28|0,i[s+12>>2]=t,i[o+24>>2]=i[12469],w=i[12468],i[o+16>>2]=i[12467],i[o+20>>2]=w,w=i[12466],i[o+8>>2]=i[12465],i[o+12>>2]=w,w=i[12464],i[o>>2]=i[12463],i[o+4>>2]=w;break r;case 2:o=E(4),i[s+4>>2]=o,t=o+4|0,i[s+12>>2]=t,i[o>>2]=0;break r;case 3:o=E(4),i[s+4>>2]=o,t=o+4|0,i[s+12>>2]=t,i[o>>2]=99;break r;default:break f}i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0;break e}i[s+8>>2]=t}e:{r:{f:{A:{if(o=i[s+4>>2],t=o,w=i[s+8>>2],(t|0)==(w|0))break A;for(;;){if(i[t>>2]==(k|0))break A;if(t=t+4|0,(w|0)==(t|0))break}break f}if((t|0)!=(w|0))break r}i[n>>2]=0,i[A+8>>2]=24358,i[A>>2]=5,i[A+4>>2]=2006;break e}w=E(8),t=w,i[t>>2]=0,i[t+4>>2]=0,t=E(172),i[t>>2]=94860,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),o=i[t+4>>2],h=o+1|0,i[t+4>>2]=h,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,Q[t+22>>1]=2,Q[t+18>>1]=2,Q[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95208,i[t+148>>2]=0,i[t+152>>2]=0,i[t+136>>2]=t+140,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=o,o=i[t+8>>2],_=t+12|0,i[t+96>>2]=_,i[t+8>>2]=o+1,i[t+100>>2]=t,h||(X[i[i[t>>2]+8>>2]](t),p(t)),i[w>>2]=_,o=i[w+4>>2],i[w+4>>2]=t;r:{if(!o||(t=i[o+4>>2],i[o+4>>2]=t-1,t))break r;X[i[i[o>>2]+8>>2]](o),p(o)}t=i[w>>2],i[t+120>>2]=k,i[t+116>>2]=f,i[t+112>>2]=r,i[t+108>>2]=e,i[n>>2]=w,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,o=i[s+4>>2]}if(!o)break i;i[s+8>>2]=o,Z(o)}v=s+16|0}function L9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-112|0,v=k,n=i[e+544>>2],X[i[i[n>>2]+92>>2]](k+88|0,n);i:{if(i[k+88>>2]){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break e}T(e,i[k+96>>2],i[k+100>>2])}u[A+48|0]=1;break i}n=i[e+544>>2],X[i[i[n>>2]+60>>2]](k- -64|0,n);e:{r:switch(l[k+84|0]){default:_2(),H();case 1:e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2];break f}T(e,i[k+72>>2],i[k+76>>2])}u[A+48|0]=1;break e;case 0:break r}n=i[k+64>>2],i[k+64>>2]=0,i[k+52>>2]=n,n=i[k+68>>2],t=i[k+72>>2],i[k+68>>2]=0,i[k+72>>2]=0,i[k+56>>2]=n,i[k+60>>2]=t,Hf(k,e,k+52|0,r,f),r=i[k+4>>2],e=i[k>>2],i[k+88>>2]=e,i[k+92>>2]=r,u[k+107|0]<0&&(Z(i[k+96>>2]),e=i[k+88>>2]),r=i[k+12>>2],i[k+96>>2]=i[k+8>>2],i[k+100>>2]=r,i[k+104>>2]=i[k+16>>2];r:{if(e){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break f}T(e,i[k+96>>2],i[k+100>>2])}u[A+48|0]=1;break r}i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,u[k+8|0]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,e=i[k+52>>2],r=i[k+56>>2],d4(k+12|0,e,r,r-e|0),e=i[k+20>>2],i[k+20>>2]=0,r=i[k+12>>2],f=i[k+16>>2],i[k+12>>2]=0,i[k+16>>2]=0,n=i[k>>2],t=i[k+4>>2],i[k>>2]=0,i[k+4>>2]=0,o=l[k+8|0],s=i[k+32>>2],w=i[k+36>>2],h=i[k+40>>2],_=i[k+24>>2],B=i[k+28>>2],i[A+12>>2]=r,i[A+16>>2]=f,i[A>>2]=n,i[A+4>>2]=t,i[A+40>>2]=h,i[A+32>>2]=s,i[A+36>>2]=w,i[A+24>>2]=_,i[A+28>>2]=B,u[A+48|0]=0,i[A+20>>2]=e,u[A+8|0]=o}if(A=i[k+52>>2],!A)break e;i[k+56>>2]=A,Z(A)}if(A=l[k+84|0],(A|0)==255)break i;e=i[25481],i[k>>2]=i[25480],i[k+4>>2]=e,X[i[(A<<2)+k>>2]](k+52|0,k- -64|0)}u[k+107|0]<0&&Z(i[k+96>>2]),v=k+112|0}function P9(A,e,r,f,k,n,t,o,s,w,h,_,B,m,W){var g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0;for(R=v-16|0,v=R,i[r>>2]=A,x=f&512;;){if((N|0)==4)l[m+11|0]>>>7|0?k=i[m+4>>2]:k=l[m+11|0]&127,k>>>0>1&&(O=R,L=T4(m),i[O+12>>2]=L,O=r,L=Pt(lk(R+12|0,1),w6(m),i[r>>2]),i[O>>2]=L),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(l[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],g=X[i[i[t>>2]+28>>2]](t,32)|0,I=i[r>>2],i[r>>2]=I+1,u[I|0]=g;break i;case 3:if(l[m+11|0]>>>7|0?g=i[m+4>>2]:g=l[m+11|0]&127,!g)break i;l[m+11|0]>>>7|0?g=i[m>>2]:g=m,g=l[g|0],I=i[r>>2],i[r>>2]=I+1,u[I|0]=g;break i;case 2:if(l[B+11|0]>>>7|0?g=i[B+4>>2]:g=l[B+11|0]&127,g=!g,g|!x)break i;O=r,L=Pt(T4(B),w6(B),i[r>>2]),i[O>>2]=L;break i;case 4:break e;default:break i}for(S=i[r>>2],k=k+o|0,C=k;;){e:{if(n>>>0<=C>>>0||(g=u[C|0],(g|0)>=0?g=(i[i[t+8>>2]+(g<<2)>>2]&64)!=0:g=0,!g))break e;C=C+1|0;continue}break}if(g=W,(g|0)>0){for(;;){if(!(!g|k>>>0>=C>>>0)){g=g-1|0,C=C-1|0,I=l[C|0],V=i[r>>2],i[r>>2]=V+1,u[V|0]=I;continue}break}for(g?I=X[i[i[t>>2]+28>>2]](t,48)|0:I=0;;){if(V=i[r>>2],i[r>>2]=V+1,(g|0)>0){u[V|0]=I,g=g-1|0;continue}break}u[V|0]=w}e:{if((k|0)==(C|0)){g=X[i[i[t>>2]+28>>2]](t,48)|0,I=i[r>>2],i[r>>2]=I+1,u[I|0]=g;break e}for(l[_+11|0]>>>7|0?g=i[_>>2]:g=_,I=u[g|0],l[_+11|0]>>>7|0?g=i[_+4>>2]:g=l[_+11|0]&127,I=g?I:-1,g=0,y=0;;){if((k|0)==(C|0))break e;r:{if((g|0)!=(I|0)){V=g;break r}if(I=i[r>>2],i[r>>2]=I+1,u[I|0]=h,V=0,l[_+11|0]>>>7|0?I=i[_+4>>2]:I=l[_+11|0]&127,y=y+1|0,I>>>0<=y>>>0){I=g;break r}if(l[_+11|0]>>>7|0?g=i[_>>2]:g=_,l[g+y|0]==127){I=-1;break r}l[_+11|0]>>>7|0?g=i[_>>2]:g=_,I=u[g+y|0]}C=C-1|0,g=l[C|0],D=i[r>>2],i[r>>2]=D+1,u[D|0]=g,g=V+1|0}}N6(S,i[r>>2])}N=N+1|0;continue}break}}function Sm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,s=R0(k),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),t=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(t,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(f+8|0,32820,19),i[e+104>>2],i[e+108>>2]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(K2(Y(n,31842,19),i[e+112>>2],i[e+116>>2]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,31957,11),i[e+120>>2]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(K2(Y(n,30676,10),i[e+128>>2],i[e+132>>2]),42713,1),n=f+148|0,s0(n,r),k=n,r=u[f+159|0],n=(r|0)<0,Y(f+8|0,n?i[f+148>>2]:k,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),e=e+136|0,Y(Y(Y(f+8|0,31995,10),e,h2(e)),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function jm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(A=v-448|0,v=A,i[A+440>>2]=r,i[A+444>>2]=e,i[A+20>>2]=2072,w=A+20|0,h=g1(A+24|0,A+32|0,w),o=A+16|0,e=i[k+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129800),u[A+15|0]=0,q7(A+444|0,r,f,o,i[k+4>>2],n,A+15|0,e,h,w,A+432|0)){r=v-16|0,v=r;i:if(l[t+11|0]>>>7|0)break i;i:{if(l[t+11|0]>>>7|0){f=i[t>>2],i[r+12>>2]=0,i[f>>2]=i[r+12>>2],i[t+4>>2]=0;break i}i[r+8>>2]=0,i[t>>2]=i[r+8>>2],u[t+11|0]=l[t+11|0]&128,u[t+11|0]=l[t+11|0]&127}for(v=r+16|0,l[A+15|0]==1&&vA(t,X[i[i[e>>2]+44>>2]](e,45)|0),e=X[i[i[e>>2]+44>>2]](e,48)|0,r=i[h>>2],k=i[A+20>>2],f=k-4|0;;){if(!((e|0)!=i[r>>2]|r>>>0>=f>>>0)){r=r+4|0;continue}break}_=v-16|0,v=_,l[t+11|0]>>>7|0?f=i[t+4>>2]:f=l[t+11|0]&127,o=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:1,s=k-r>>2;i:{if(!s)break i;if(l[t+11|0]>>>7|0?e=i[t>>2]:e=t,w=e,l[t+11|0]>>>7|0?e=i[t>>2]:e=t,l[t+11|0]>>>7|0?B=i[t+4>>2]:B=l[t+11|0]&127,!Al(w,(e+(B<<2)|0)+4|0,r)){s>>>0>o-f>>>0&&wt(t,o,s+(f-o|0)|0,f,f),l[t+11|0]>>>7|0?e=i[t>>2]:e=t,e=zl(r,k,e+(f<<2)|0),i[_+4>>2]=0,i[e>>2]=i[_+4>>2],x6(t,f+s|0);break i}e=v-16|0,v=e,f=_+4|0,su(f,r,k),v=e+16|0,l[f+11|0]>>>7|0?e=i[f>>2]:e=f,o=e,w=v-16|0,v=w,l[f+11|0]>>>7|0?r=i[f+4>>2]:r=l[f+11|0]&127,e=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:1,l[t+11|0]>>>7|0?k=i[t+4>>2]:k=l[t+11|0]&127;e:{if(r>>>0<=e-k>>>0){if(s=!r,s)break e;l[t+11|0]>>>7|0?e=i[t>>2]:e=t,B=e+(k<<2)|0;r:{if(s||(s=r<<2,!s))break r;z(B,o,s)}r=r+k|0,x6(t,r),i[w+12>>2]=0,i[(r<<2)+e>>2]=i[w+12>>2];break e}xn(t,e,k+(r-e|0)|0,k,k,0,r,o)}v=w+16|0,R1(f)}v=_+16|0}return q2(A+444|0,A+440|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+444>>2],e2(A+16|0),e=i[h>>2],i[h>>2]=0,e&&X[i[h+4>>2]](e),v=A+448|0,r|0}function q9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,f=E(48),i[k+24>>2]=i[A>>2],A=i[A+4>>2],i[k+28>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+16>>2]=i[e>>2],A=i[e+4>>2],i[k+20>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[k+28>>2],i[k+8>>2]=i[k+24>>2],i[k+12>>2]=A,A=i[k+20>>2],i[k>>2]=i[k+16>>2],i[k+4>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,u[f+16|0]=0,i[f+8>>2]=0,i[f+12>>2]=0,h=f+32|0,A=h,i[A>>2]=0,i[A+4>>2]=0,i[f+40>>2]=0,A=i[k+8>>2],e=i[k+12>>2];i:{if(!e){i[f+4>>2]=e,i[f>>2]=A;break i}if(i[e+4>>2]=i[e+4>>2]+1,i[f>>2]=A,A=i[f+4>>2],i[f+4>>2]=e,!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[k>>2],e=i[k+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[f+8>>2]=A,A=i[f+12>>2],i[f+12>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}w=i[k>>2],n=i[w+128>>2],t=i[w+132>>2],A=i[w+128>>2],t-A>>3?(e=i[A>>2],A=i[A+4>>2]):(e=0,A=0),_=i[k+8>>2],s=i[_+116>>2],t=t-n|0;i:{e:{if((t|0)==8){if(n=l[i[f>>2]+112|0],u[f+16|0]=(n|0)!=0,!n)break e;i[f+24>>2]=e,i[f+28>>2]=A;break i}u[f+16|0]=0}o=i[f+32>>2],n=i[f+36>>2]-o>>3;e:{if(n>>>0<s>>>0){ui(h,s-n|0);break e}if(n>>>0>s>>>0&&(i[f+36>>2]=o+(s<<3)),!s)break i}if(n=0,(t|0)==8){for(;;)if(r=i[h>>2]+(n<<3)|0,i[r>>2]=e,i[r+4>>2]=A,r=o3(_,n),e=e+r|0,A=r>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)==(n|0))break i}for(t=0;u0[i[i[r>>2]+(t<<3)>>2]+20>>2]<n>>>0&&(t=t+1|0,A=i[w+128>>2],t>>>0<i[w+132>>2]-A>>3>>>0?(A=A+(t<<3)|0,e=i[A>>2],A=i[A+4>>2]):(e=0,A=0)),o=i[h>>2]+(n<<3)|0,i[o>>2]=e,i[o+4>>2]=A,o=o3(_,n),e=e+o|0,A=o>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)!=(n|0););}A=i[k+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[k+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=k+32|0,f}function K9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;if(o=v-80|0,v=o,jf(o+68|0,e,r),e=i[o+68>>2],t=ei(o+32|0,e,i[o+72>>2]-e|0),I2(t,16),I2(t,4),r=V1(t,3),W=f,g=V1(t,1),u[W+28|0]=g,W=f,g=V1(t,2),u[W+1|0]=g,W=f,g=(V1(t,1)|0)!=0,u[W+2|0]=g,W=f,g=V1(t,5),u[W+3|0]=g,W=f,g=i2(t,32),i[W+4>>2]=g,I2(t,16),I2(t,16),I2(t,16),W=f,g=V1(t,8),u[W+16|0]=g,r){w=r-1>>>5|0,h=w+1<<2,_=E(h);i:{e:{if(r>>>0>=33){i[(w<<2)+_>>2]=0,e=r>>>5|0;break e}if(i[_>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(s=e<<2,!s)break i;o0(_,0,s)}s=r&31,s&&(e=(e<<2)+_|0,i[e>>2]=i[e>>2]&(-1>>>32-s^-1)),h=E(h);i:{e:{if(r>>>0>=33){i[(w<<2)+h>>2]=0,e=r>>>5|0;break e}if(i[h>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(w=e<<2,!w)break i;o0(h,0,w)}for(s&&(e=(e<<2)+h|0,i[e>>2]=i[e>>2]&(-1>>>32-s^-1)),e=0;;){s=1<<e,B=e>>>5<<2,w=B+_|0;i:{if(i2(t,1)){m=s|i[w>>2];break i}m=i[w>>2]&(s^-1)}i[w>>2]=m,w=h+B|0;i:{if(i2(t,1)){s=s|i[w>>2];break i}s=i[w>>2]&(s^-1)}if(i[w>>2]=s,e=e+1|0,(r|0)==(e|0))break}if(r>>>0<8)for(e=r;I2(t,2),e=e+1|0,(e|0)!=8;);for(e=0;w=1<<e,s=e>>>5<<2,w&i[s+_>>2]&&(I2(t,8),I2(t,32),I2(t,16)),w&i[s+h>>2]&&I2(t,8),e=e+1|0,(r|0)!=(e|0););}$2(t,o+28|0),$2(t,o+24|0),e=i[o+24>>2],u[f+21|0]=e,(e&255)==3&&I2(t,1),$2(t,k),$2(t,n),i2(t,1)&&($2(t,o+20|0),$2(t,o+16|0),$2(t,o+12|0),$2(t,o+8|0),e=l[f+21|0],i[k>>2]=i[k>>2]-(i[o+16>>2]+i[o+20>>2]<<((e-1&255)>>>0<2)),i[n>>2]=i[n>>2]-(i[o+8>>2]+i[o+12>>2]<<((e|0)==1))),e=o+24|0,$2(t,e),u[f+22|0]=l[o+24|0]+8,$2(t,e),e=l[o+24|0],i[f+24>>2]=16777216,u[f+20|0]=0,Q[f+18>>1]=0,u[f|0]=1,u[f+23|0]=e+8,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}h&&Z(h),_&&Z(_),A=i[o+68>>2],A&&(i[o+72>>2]=A,Z(A)),v=o+80|0}function a9(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=i[i[A>>2]+116>>2],e=v-112|0,v=e,n=i[A+8>>2],k=i[n+20>>2];i:{if(!k){k=0;break i}for(o=n+20|0,A=o;t=f>>>0>u0[k+16>>2],A=t?A:k,k=i[(t?4:0)+k>>2],!!k;);if(k=0,(A|0)==(o|0)|f>>>0<u0[A+16>>2])break i;r=i[A+20>>2],t=i[A+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),k=1;e:{if(i[r+148>>2]||X[i[i[r>>2]+84>>2]](r)|0)break e;X[i[i[r>>2]+76>>2]](e+80|0,r,e+108|0,e+104|0),k=0;r:{if(i[e+80>>2]||(A=i[e+104>>2],A>>>0<=15&&(k=1,1<<A&43008))||(k=0,(J6(i[n+48>>2],f)|0)!=1735551332))break r;if(r=e+56|0,a6(r,i[n+48>>2],f),A=l[e+76|0],!A){if(i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,w9(e+16|0,e+40|0,r),r=i[e+20>>2],A=i[e+16>>2],i[e+80>>2]=A,i[e+84>>2]=r,u[e+99|0]<0&&(Z(i[e+88>>2]),A=i[e+80>>2]),r=i[e+28>>2],i[e+88>>2]=i[e+24>>2],i[e+92>>2]=r,i[e+96>>2]=i[e+32>>2],!A){A=i[n+48>>2],r=i[A+84>>2],i[e+8>>2]=r,A=i[A+88>>2],i[e+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1);f:{if(!r)break f;L8(e+16|0,r,f,1684630887),r=i[e+20>>2],f=i[e+16>>2];A:{if((G(F[e+42>>1],F[e+40>>1])|0)!=r-f>>2|(r|0)==(f|0))break A;for(A=f;;){if(!Io(n,i[A>>2]))break A;if(A=A+4|0,(r|0)==(A|0))break}for(;;){k:{if(A=i[o>>2],!A){k=0;break k}for(s=i[f>>2],n=o;w=s>>>0>u0[A+16>>2],n=w?n:A,A=i[(w?4:0)+A>>2],!!A;);if((n|0)==(o|0)){k=0;break k}if(s>>>0<u0[n+16>>2]){k=0;break k}if(s=i[n+20>>2],i[e>>2]=s,A=i[n+24>>2],i[e+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),k=i[s+148>>2]!=0|k,V2(e),f=f+4|0,(r|0)!=(f|0))continue}break}f=i[e+16>>2]}if(!f)break f;i[e+20>>2]=f,Z(f)}V2(e+8|0)}A=l[e+76|0]}if(A=A&255,(A|0)==255)break r;f=i[23603],i[e+16>>2]=i[23602],i[e+20>>2]=f,X[i[(e+16|0)+(A<<2)>>2]](e+40|0,e+56|0)}if(u[e+99|0]>=0)break e;Z(i[e+88>>2])}if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t)}return v=e+112|0,k&1}function Om(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15923);break i}e:{if((k|0)==1){s=e,w=R4(r),i[s+104>>2]=w,i[e+108>>2]=l0,s=e,w=R4(r),i[s+112>>2]=w,i[e+116>>2]=l0,s=e,w=F0(r),i[s+120>>2]=w,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=X[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,X[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,k=R4(r),n=l0;break e}s=e,w=F0(r),i[s+104>>2]=w,i[e+108>>2]=0,s=e,w=F0(r),i[s+112>>2]=w,i[e+116>>2]=0,s=e,w=F0(r),i[s+120>>2]=w,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=X[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,X[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=i[r+16>>2],k=k>>>0>=8?8:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=X[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,X[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,w=o2(r),Q[s+136>>1]=w,s=e,w=o2(r),Q[s+138>>1]=w,s=e,w=o2(r),Q[s+140>>1]=w,k=i[r+16>>2],k=k>>>0>=2?2:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=X[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,X[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,w=F0(r),i[s+144>>2]=w,s=e,w=F0(r),i[s+148>>2]=w,s=e,w=F0(r),i[s+152>>2]=w,s=e,w=F0(r),i[s+156>>2]=w,s=e,w=F0(r),i[s+160>>2]=w,s=e,w=F0(r),i[s+164>>2]=w,s=e,w=F0(r),i[s+168>>2]=w,s=e,w=F0(r),i[s+172>>2]=w,s=e,w=F0(r),i[s+176>>2]=w,s=e,w=F0(r),i[s+180>>2]=w,s=e,w=F0(r),i[s+184>>2]=w,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Lm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0;h=v-32|0,v=h;i:{e:{r:{if(!(!e|!n)&&(_=(f|0)!=1970628964,k|_))break r;e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break e}w=E(128),i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=92572,B=w+16|0,i[B+8>>2]=0,i[B+12>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0,i[B+32>>2]=0,i[B>>2]=86404,i[w+60>>2]=0,i[w+64>>2]=0,i[w+52>>2]=0,i[w+56>>2]=0,i[w+72>>2]=-1,i[w+76>>2]=-1,i[w+80>>2]=-1,i[w+84>>2]=-1,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+100>>2]=0,i[w+104>>2]=0,i[w+108>>2]=0,u[w+112|0]=0,i[B>>2]=86772,i[w+124>>2]=0,i[w+116>>2]=0,i[w+120>>2]=0,i[w+32>>2]=f;r:{if(_||(f=E(16),i[h+20>>2]=f,g=f+16|0,i[h+28>>2]=g,_=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),m=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),u[f+8|0]=m,u[f+9|0]=m>>>8,u[f+10|0]=m>>>16,u[f+11|0]=m>>>24,u[f+12|0]=_,u[f+13|0]=_>>>8,u[f+14|0]=_>>>16,u[f+15|0]=_>>>24,_=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),k=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),u[f|0]=k,u[f+1|0]=k>>>8,u[f+2|0]=k>>>16,u[f+3|0]=k>>>24,u[f+4|0]=_,u[f+5|0]=_>>>8,u[f+6|0]=_>>>16,u[f+7|0]=_>>>24,i[h+24>>2]=g,i[B+16>>2]=1970628964,f=B+20|0,(f|0)!=(h+20|0)&&(_=f,f=i[h+20>>2],k=i[h+24>>2],d4(_,f,k,k-f|0)),f=i[h+20>>2],!f))break r;i[h+24>>2]=f,Z(f)}if(i[h+28>>2]=0,i[h+20>>2]=0,i[h+24>>2]=0,f=0,t){if((t|0)<0)break i;f=E(t),i[h+20>>2]=f,W=f+t|0,i[h+28>>2]=W,t&&z(f,n,t),i[h+24>>2]=W}if(d4(w+116|0,f,W,W-f|0),e=i[e>>2],i[h+16>>2]=w,i[h+12>>2]=B,i[w+4>>2]=i[w+4>>2]+1,k=i[h+16>>2],i[h>>2]=i[h+12>>2],i[h+4>>2]=k,e=re(e,r,h,(o|0)!=0),s&&(i[s>>2]=e),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],f&&Z(f),A=i[w+4>>2],i[w+4>>2]=A-1,A)break e;X[i[i[w>>2]+8>>2]](w),p(w)}v=h+32|0;return}G0(),H()}function Pm(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(f=A+16|0,r=i[f+16>>2],k=f+20|0,(r|0)!=(k|0))for(;;){e=i[r+20>>2],A=i[r+24>>2];i:{if(!A){ft(e);break i}if(i[A+4>>2]=i[A+4>>2]+1,ft(e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+4>>2];i:{if(A){for(;;)if(e=A,A=i[A>>2],!A)break i}for(;e=i[r+8>>2],A=i[e>>2]!=(r|0),r=e,!!A;);}if(r=e,(k|0)==(e|0))break}if(k3(f+180|0,i[f+184>>2]),r=i[f+168>>2],r){if(A=r,e=i[f+172>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+168>>2]}i[f+172>>2]=r,Z(A)}if(r=i[f+156>>2],r){if(A=r,e=i[f+160>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+156>>2]}i[f+160>>2]=r,Z(A)}l[107800]||(u[107800]=1),k=i[26952];i:{if(!k)break i;for(r=107808,e=i[f+152>>2],A=k;n=e>>>0>u0[A+16>>2],r=n?r:A,A=i[(n?4:0)+A>>2],!!A;);if((r|0)==107808|e>>>0<u0[r+16>>2])break i;e=i[r+4>>2];e:{if(!e){for(e=r;A=i[e+8>>2],n=i[A>>2]!=(e|0),e=A,!!n;);break e}for(;A=e,e=i[A>>2],!!e;);}i[26951]==(r|0)&&(i[26951]=A),i[26953]=i[26953]-1,pf(k,r),Z(r)}A=i[f+52>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[f+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(r=i[f+28>>2],r){if(A=r,e=i[f+32>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+28>>2]}i[f+32>>2]=r,Z(A)}Fe(f+16|0,i[f+20>>2]),u[f+11|0]<0&&Z(i[f>>2])}function qm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,nn(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(f+8|0,31343,11),F[e+120>>1]),2998,1),F[e+122>>1]),42713,1),k=i[e+124>>2],h=i[e+128>>2],(k|0)!=(h|0))for(e=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(f+8|0,27839,6),e),41820,2),t=f+148|0,s0(t,r),s=t,t=u[f+159|0],w=(t|0)<0,Y(n,w?i[f+148>>2]:s,w?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,31077,11),F[k>>1]),42713,1),t=f+148|0,s0(t,r),s=t,t=u[f+159|0],w=(t|0)<0,Y(n,w?i[f+148>>2]:s,w?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(n,30167,9),F[k+2>>1]+1|0),2998,1),F[k+4>>1]+1|0),42713,1),e=e+1|0,k=k+6|0,(h|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function Km(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,t=i[18140],i[f+8>>2]=t,k=i[t-12>>2],t=f+8|0,i[k+t>>2]=i[18141],s=t+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,s=R0(k),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),n=t,o=k,t=u[f+159|0],k=(t|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(t=0;k=f+148|0,s0(k,r),n=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:n,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(I0(Y(f+8|0,19216,1),t),41737,2),o=f+148|0,s0(o,r),w=o,o=u[f+159|0],n=(o|0)<0,Y(k,n?i[f+148>>2]:w,n?i[f+152>>2]:o),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(k,30949,15),k=G(t,12),o=Y(I0(n,i[k+i[e+104>>2]>>2]),42713,1),n=f+148|0,s0(n,r),w=n,n=u[f+159|0],h=(n|0)<0,Y(o,h?i[f+148>>2]:w,h?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(I0(Y(o,30965,21),i[(k+i[e+104>>2]|0)+4>>2]),42713,1),n=f+148|0,s0(n,r),w=n,n=u[f+159|0],h=(n|0)<0,Y(o,h?i[f+148>>2]:w,h?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(o,29524,28),i[(k+i[e+104>>2]|0)+8>>2]),42713,1),t=t+1|0,t>>>0<(i[e+108>>2]-i[e+104>>2]|0)/12>>>0;);e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(t=i[r>>2],e=e-t|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,t,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function am(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;A=v-1056|0,v=A,i[A+16>>2]=n,i[A+20>>2]=t,i[A+24>>2]=o,i[A+28>>2]=s,w=A+944|0,i[A+940>>2]=w,w=a8(w,100,11378,A+16|0),i[A+528>>2]=2071,h=A+528|0,m=g1(A+520|0,0,h),i[A+528>>2]=2071,_=g1(A+512|0,0,h);i:{if(w>>>0>=100&&(w=a2(),i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,w=V8(A+940|0,w,11378,A),(w|0)==-1||(n=i[m>>2],i[m>>2]=i[A+940>>2],n&&X[i[m+4>>2]](n),t=p2(w<<2),n=i[_>>2],i[_>>2]=t,n&&X[i[_+4>>2]](n),h=i[_>>2],!h)))break i;t=A+508|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),C=c0(t,129800),n=C,t=i[A+940>>2],X[i[i[n>>2]+48>>2]](n,t,t+w|0,h)|0,I=(w|0)>0?l[i[A+940>>2]]==45:I,t=v-16|0,v=t,n=A+484|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=t+16|0,t=v-16|0,v=t,o=A+472|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+460|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,Gt(r,I,A+508|0,A+504|0,A+500|0,A+496|0,n,o,s,A+456|0),i[A+48>>2]=2071,r=A+48|0,B=g1(A+40|0,0,r),t=i[A+456>>2];e:{if((t|0)<(w|0)){l[o+11|0]>>>7|0?W=i[o+4>>2]:W=l[o+11|0]&127,l[s+11|0]>>>7|0?g=i[s+4>>2]:g=l[s+11|0]&127,t=(t+(W+(g+(w-t<<1)|0)|0)|0)+1|0;break e}g=i[A+456>>2],l[s+11|0]>>>7|0?t=i[s+4>>2]:t=l[s+11|0]&127,l[o+11|0]>>>7|0?W=i[o+4>>2]:W=l[o+11|0]&127,t=(g+(t+W|0)|0)+2|0}if(t>>>0>=101&&(t=p2(t<<2),r=i[B>>2],i[B>>2]=t,r&&X[i[B+4>>2]](r),r=i[B>>2],!r))break i;return S9(r,A+36|0,A+32|0,i[f+4>>2],h,(w<<2)+h|0,C,I,A+504|0,i[A+500>>2],i[A+496>>2],n,o,s,i[A+456>>2]),r=j8(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&X[i[B+4>>2]](e),R1(s),R1(o),s2(n),e2(A+508|0),e=i[_>>2],i[_>>2]=0,e&&X[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&X[i[m+4>>2]](e),v=A+1056|0,r|0}Q1(),H()}function $m(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,t=i[18140],i[f+8>>2]=t,n=f+8|0,i[n+i[t-12>>2]>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(f+8|0,31760,10),n=u[e+115|0],k=(n|0)<0,n=Y(Y(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:n),42713,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,30136,14),n=f+20|0,r=i[e+116>>2],s=i[e+120>>2],(r|0)!=(s|0))for(;w=l[r|0],e=i[f+8>>2]-12|0,k=t+i[e>>2]|0,i[k>>2]=i[k>>2]&-75|8,i[i[e>>2]+n>>2]=2,e=i[e>>2]+(f+8|0)|0,l[e+80|0]||(o=f+148|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129808),X[i[i[k>>2]+28>>2]](k,32)|0,e2(o)),u[e+76|0]=48,u[e+77|0]=0,u[e+78|0]=0,u[e+79|0]=0,u[e+80|0]=1,Y(S0(f+8|0,w),32851,1),r=r+1|0,(s|0)!=(r|0););Y(f+8|0,42713,1),e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function dm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-144|0,v=k,L9(k+80|0,e,0,0);i:{e:switch(l[k+128|0]){default:_2(),H();case 1:if(e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,e=A+8|0,u[k+99|0]>=0){A=i[k+92>>2],i[e>>2]=i[k+88>>2],i[e+4>>2]=A,i[e+8>>2]=i[k+96>>2];break i}T(e,i[k+88>>2],i[k+92>>2]);break i;case 0:break e}t=i[e+552>>2],i[k+72>>2]=i[k+120>>2],n=i[k+116>>2],o=k- -64|0,i[o>>2]=i[k+112>>2],i[o+4>>2]=n,n=i[k+108>>2],i[k+56>>2]=i[k+104>>2],i[k+60>>2]=n,w=i[k+84>>2],i[k+84>>2]=0,n=i[k+80>>2],i[k+80>>2]=0,h=i[k+92>>2],_=i[k+96>>2],i[k+92>>2]=0,i[k+96>>2]=0,B=i[k+100>>2],i[k+100>>2]=0,o=l[k+88|0],i[t+8>>2]=n,s=i[t+12>>2],i[t+12>>2]=w;e:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break e;X[i[i[s>>2]+8>>2]](s),p(s)}u[t+16|0]=o,n=i[t+20>>2],n&&(i[t+24>>2]=n,Z(n)),i[t+28>>2]=B,i[t+24>>2]=_,i[t+20>>2]=h,n=i[k+60>>2],i[t+32>>2]=i[k+56>>2],i[t+36>>2]=n,o=k- -64|0,n=i[o+4>>2],i[t+40>>2]=i[o>>2],i[t+44>>2]=n,i[t+48>>2]=i[k+72>>2],n=i[e+552>>2],X[i[i[n>>2]+20>>2]](k+32|0,n,r,f);e:{if(i[k+32>>2]){e=i[k+36>>2],i[A>>2]=i[k+32>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+48>>2],e=i[k+44>>2],i[A+8>>2]=i[k+40>>2],i[A+12>>2]=e,i[k+48>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0;break e}n=k+12|0,i[r>>2]|F[e+10>>1]||(i[r>>2]=1,i[f>>2]=3),e=i[26929],i[n>>2]=i[26928],i[n+4>>2]=e,r=n+8|0;r:{if(u[107731]>=0){e=i[26931],i[r>>2]=i[26930],i[r+4>>2]=e,i[r+8>>2]=i[26932];break r}T(r,i[26930],i[26931])}if(u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break e}T(e,i[26930],i[26931])}if(u[k+51|0]>=0)break i;Z(i[k+40>>2])}e=l[k+128|0],(e|0)!=255&&(A=i[25483],i[k+32>>2]=i[25482],i[k+36>>2]=A,X[i[(k+32|0)+(e<<2)>>2]](k+143|0,k+80|0)),v=k+144|0}function $9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,f=180,t=1;i:{e:{r:f:{A:switch(r-2|0){case 2:t=0;break e;case 3:f=270,o=1;break r;case 4:f=270;break f;case 5:f=270,t=0,o=1;break r;case 0:break e;case 1:break r;case 6:break A;default:break i}f=90}r=E(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90252,n=r+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[n>>2]=87880,i[r+116>>2]=f,i[r+32>>2]=1769107316,f=i[A+52>>2],i[k+28>>2]=r,i[k+24>>2]=n,i[r+4>>2]=i[r+4>>2]+1,n=R6(f,k+24|0),f=i[k+28>>2];r:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break r;X[i[i[f>>2]+8>>2]](f),p(f)}if(f=i[A+60>>2],u[k+20|0]=1,Q[k+22>>1]=n+1,i[k+12>>2]=F[k+20>>1]|F[k+22>>1]<<16,F6(f,e,k+12|0),f=i[r+4>>2],i[r+4>>2]=f-1,f||(X[i[i[r>>2]+8>>2]](r),p(r)),!o)break i}r=E(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90292,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=87960,i[r+116>>2]=t,i[r+32>>2]=1768778098,n=i[A+52>>2],i[k+28>>2]=r,i[k+24>>2]=f,i[r+4>>2]=i[r+4>>2]+1,n=R6(n,k+24|0),f=i[k+28>>2];e:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(A=i[A+60>>2],u[k+16|0]=1,Q[k+18>>1]=n+1,i[k+8>>2]=F[k+16>>1]|F[k+18>>1]<<16,F6(A,e,k+8|0),A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=k+32|0}function cm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;A=v-448|0,v=A,i[A+16>>2]=n,i[A+20>>2]=t,i[A+24>>2]=o,i[A+28>>2]=s,w=A+336|0,i[A+332>>2]=w,w=a8(w,100,11378,A+16|0),i[A+224>>2]=2071,h=A+224|0,m=g1(A+216|0,0,h),i[A+224>>2]=2071,_=g1(A+208|0,0,h);i:{if(w>>>0>=100&&(w=a2(),i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,w=V8(A+332|0,w,11378,A),(w|0)==-1||(n=i[m>>2],i[m>>2]=i[A+332>>2],n&&X[i[m+4>>2]](n),t=p2(w),n=i[_>>2],i[_>>2]=t,n&&X[i[_+4>>2]](n),h=i[_>>2],!h)))break i;t=A+204|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),C=c0(t,129808),n=C,t=i[A+332>>2],X[i[i[n>>2]+32>>2]](n,t,t+w|0,h)|0,I=(w|0)>0?l[i[A+332>>2]]==45:I,t=v-16|0,v=t,n=A+184|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=t+16|0,t=v-16|0,v=t,o=A+172|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+160|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,Wt(r,I,A+204|0,A+200|0,A+199|0,A+198|0,n,o,s,A+156|0),i[A+48>>2]=2071,r=A+48|0,B=g1(A+40|0,0,r),t=i[A+156>>2];e:{if((t|0)<(w|0)){l[o+11|0]>>>7|0?W=i[o+4>>2]:W=l[o+11|0]&127,l[s+11|0]>>>7|0?g=i[s+4>>2]:g=l[s+11|0]&127,t=(t+(W+(g+(w-t<<1)|0)|0)|0)+1|0;break e}g=i[A+156>>2],l[s+11|0]>>>7|0?t=i[s+4>>2]:t=l[s+11|0]&127,l[o+11|0]>>>7|0?W=i[o+4>>2]:W=l[o+11|0]&127,t=(g+(t+W|0)|0)+2|0}if(t>>>0>=101&&(t=p2(t),r=i[B>>2],i[B>>2]=t,r&&X[i[B+4>>2]](r),r=i[B>>2],!r))break i;return P9(r,A+36|0,A+32|0,i[f+4>>2],h,w+h|0,C,I,A+200|0,u[A+199|0],u[A+198|0],n,o,s,i[A+156>>2]),r=O8(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&X[i[B+4>>2]](e),s2(s),s2(o),s2(n),e2(A+204|0),e=i[_>>2],i[_>>2]=0,e&&X[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&X[i[m+4>>2]](e),v=A+448|0,r|0}Q1(),H()}function d9(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-48|0,v=k,r=i[e>>2];i:{if((i[e+4>>2]-r|0)!=9){e=E(40),i[k+12>>2]=e,i[k+16>>2]=32,i[k+20>>2]=-2147483608,r=l[18815]|l[18816]<<8|(l[18817]<<16|l[18818]<<24),f=l[18811]|l[18812]<<8|(l[18813]<<16|l[18814]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[18807]|l[18808]<<8|(l[18809]<<16|l[18810]<<24),f=l[18803]|l[18804]<<8|(l[18805]<<16|l[18806]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[18799]|l[18800]<<8|(l[18801]<<16|l[18802]<<24),f=l[18795]|l[18796]<<8|(l[18797]<<16|l[18798]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[18791]|l[18792]<<8|(l[18793]<<16|l[18794]<<24),f=l[18787]|l[18788]<<8|(l[18789]<<16|l[18790]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+32|0]=0,e=K(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+24|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+24|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}f=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),e=l[r+4|0]|l[r+5|0]<<8|(l[r+6|0]<<16|l[r+7|0]<<24),r=l[r+8|0],u[A+24|0]=0,u[A|0]=1,u[A+16|0]=r>>>7,u[A+18|0]=r>>>5&1,u[A+17|0]=r>>>6&1,r=f,n=r&16711680,f=n>>>8|0,t=n<<24,n=r&-16777216,i[A+8>>2]=t|n<<8|(((e&255)<<24|r>>>8)&-16777216|((e&16777215)<<8|r>>>24)&16711680|(e>>>8&65280|e>>>24)),e=f|n>>>24|(r<<24|(r&65280)<<8),f=0,i[A+12>>2]=e|(f|f)}v=k+48|0}function Df(A,e,r){var f=0,k=0,n=0,t=0;n=v-48|0,v=n;i:{if(r){e:{k=i[e+184>>2];r:{if(!k)break r;for(e=e+184|0,f=e;t=u0[k+16>>2]<r>>>0,f=t?f:k,k=i[(t?4:0)+k>>2],!!k;);if((e|0)==(f|0))break r;if(u0[f+16>>2]<=r>>>0)break e}e=E(24),i[n+12>>2]=e,i[n+16>>2]=16,i[n+20>>2]=-2147483624,r=l[15903]|l[15904]<<8|(l[15905]<<16|l[15906]<<24),f=l[15899]|l[15900]<<8|(l[15901]<<16|l[15902]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[15895]|l[15896]<<8|(l[15897]<<16|l[15898]<<24),f=l[15891]|l[15892]<<8|(l[15893]<<16|l[15894]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+16|0]=0,e=K(n+24|0,5,0,n+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}if(t=i[e+192>>2],t){f=i[e+184>>2];e:{r:{if(!f){r=e+184|0,k=r;break r}for(;;){if(k=f,r=i[f+16>>2],r>>>0>t>>>0){if(r=f,f=i[f>>2],f)continue;break r}if(r>>>0>=t>>>0)break e;if(f=i[k+4>>2],!f)break}r=k+4|0}f=E(28),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=t,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,r=i[i[e+180>>2]>>2],r&&(i[e+180>>2]=r),m1(i[e+184>>2],f),i[e+188>>2]=i[e+188>>2]+1}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}e=i[e+180>>2],r=i[e+20>>2],e=i[e+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}v=n+48|0}function bm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,HA(A+208|0,f,A+224|0,A+223|0,A+222|0),r=v-16|0,v=r,e=A+196|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,u[A+23|0]=1,u[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(P2(A+268|0,A+264|0))break f;o=i[A+192>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=t+r),t=i[A+268>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Lf(t<<24>>24,A+23|0,A+22|0,r,A+192|0,u[A+223|0],u[A+222|0],A+208|0,A+32|0,A+28|0,A+24|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+192>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+219|0]>>>7|0?f=i[A+212>>2]:f=l[A+219|0]&127;f:{if(!f|!(u[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}jn(A,r,i[A+192>>2],k),r=i[A>>2],f=i[A+4>>2],t=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=t,i[n>>2]=r,i[n+4>>2]=f,l4(A+208|0,A+32|0,i[A+28>>2],k),P2(A+268|0,A+264|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+268>>2],s2(e),s2(A+208|0),v=A+272|0;break i}f=1}K1(A+268|0);continue}break}return r|0}function iZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0;for(I=v-16|0,v=I,w=r;;){i:{if((f|0)==(w|0)){w=f;break i}if(!l[w|0])break i;w=w+1|0;continue}break}i[o>>2]=n,i[k>>2]=r;i:for(;;){e:{r:{f:{if((r|0)==(f|0)|(n|0)==(t|0))break f;s=i[e+4>>2],i[I+8>>2]=i[e>>2],i[I+12>>2]=s,C=v-16|0,v=C,i[C+12>>2]=i[A+8>>2],R=s8(C+8|0,C+12|0),W=w-r|0,_=0,m=v-1040|0,v=m,s=i[k>>2],i[m+12>>2]=s,g=n||m+16|0,B=n?t-n>>2:256;A:{k:{n:{if(!(!s|!B)){for(;;){if(h=W>>>2|0,!(W>>>0>131|h>>>0>=B>>>0)){h=s;break k}if(V=T9(g,m+12|0,h>>>0<B>>>0?h:B,e),h=i[m+12>>2],(V|0)==-1){B=0,_=-1;break n}if(y=(m+16|0)!=(g|0)?V:0,B=B-y|0,g=(y<<2)+g|0,W=h?(s+W|0)-h|0:0,_=_+V|0,!h)break n;if(s=h,!B)break}break n}h=s}if(!h)break A}if(!B|!W)break A;for(s=_;;){k:{_=ne(g,h,W,e);n:{if(_+2>>>0<=2){t:switch(_+1|0){case 1:i[m+12>>2]=0;break n;case 0:break A;default:break t}i[e>>2]=0;break n}if(h=i[m+12>>2]+_|0,i[m+12>>2]=h,s=s+1|0,B=B-1|0,B)break k}_=s;break A}if(g=g+4|0,W=W-_|0,_=s,!W)break}}n&&(i[k>>2]=i[m+12>>2]),v=m+1040|0,s=i[R>>2],s&&(i[31378]=(s|0)==-1?125392:s),v=C+16|0;A:{k:{n:{t:{if((_|0)==-1)for(;;){if(i[o>>2]=n,i[k>>2]==(r|0))break f;t=1;u:{o:{l:switch(e=fl(n,r,w-r|0,I+8|0,i[A+8>>2]),e+2|0){case 0:break k;case 1:break l;case 2:break u;default:break o}i[k>>2]=r;break t}t=e}r=r+t|0,n=i[o>>2]+4|0}if(n=i[o>>2]+(_<<2)|0,i[o>>2]=n,(n|0)==(t|0))break A;if(r=i[k>>2],(f|0)==(w|0))break e;if(!fl(n,r,1,e,i[A+8>>2]))break n}A=2;break r}for(n=i[o>>2]+4|0,i[o>>2]=n,r=i[k>>2]+1|0,i[k>>2]=r,w=r;;){if((f|0)==(w|0))break e;if(!l[w|0])continue i;w=w+1|0}}i[k>>2]=r,A=1;break r}r=i[k>>2]}A=(r|0)!=(f|0)}return v=I+16|0,A|0}w=f}}function b0(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,n=i[e>>2];i:{e:{r:{f:{A:{if(r){if(!n){k=48906,i[r+12>>2]=48906,r=0;break e}i[f+104>>2]=0,i[f+76>>2]=72244,i[f+20>>2]=72224,n=i[18065],i[f+12>>2]=n,k=i[n-12>>2],t=f+12|0,n=t,i[k+n>>2]=i[18066],i[f+16>>2]=0,n=n+i[i[f+12>>2]-12>>2]|0,o=f+24|0,J0(n,o),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18068],k=i[18064],i[f+12>>2]=k,i[t+i[k-12>>2]>>2]=i[18069],i[f+76>>2]=72244,i[f+12>>2]=72204,i[f+20>>2]=72224,s=R0(o),i[s>>2]=71280,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,k=i[e>>2],k>>>0>13?k=6623:k=i[(k<<2)+94340>>2],t=Y(Y(n,k,h2(k)),32772,2),k=t9(i[e+4>>2]),Y(t,k,h2(k)),k=u[e+19|0],((k|0)<0?i[e+12>>2]:k)&&(t=Y(n,32772,2),k=u[e+19|0],n=(k|0)<0,Y(t,n?i[e+8>>2]:e+8|0,n?i[e+12>>2]:k)),n=i[f+72>>2];k:{if(n&16){k=i[f+68>>2],n=i[f+48>>2],k>>>0<n>>>0&&(i[f+68>>2]=n,k=n),n=f+44|0;break k}if(!(n&8)){k=0,u[f+11|0]=0,n=f;break r}k=i[f+40>>2],n=f+32|0}if(t=i[n>>2],k=k-t|0,k>>>0>=2147483640)break A;if(k>>>0>=11){o=k|7,n=E(o+1|0),i[f+8>>2]=o-2147483647,i[f>>2]=n,i[f+4>>2]=k;break f}if(u[f+11|0]=k,n=f,k)break f;k=0;break r}i[A>>2]=n,i[A+4>>2]=i[e+4>>2],k=i[23584];break i}g0(),H()}if(!k)break r;z(n,t,k)}u[k+n|0]=0;r:{if((r|0)==(f|0))break r;if(k=u[f+11|0],u[r+11|0]>=0){if((k|0)>=0){n=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=n,i[r+8>>2]=i[f+8>>2];break r}D1(r,i[f>>2],i[f+4>>2]);break r}n=(k|0)<0,O1(r,n?i[f>>2]:f,n?i[f+4>>2]:k)}i[r+12>>2]=u[r+11|0]<0?i[r>>2]:r,u[f+11|0]<0&&Z(i[f>>2]),n=i[18063],i[f+12>>2]=n,i[i[n-12>>2]+(f+12|0)>>2]=i[18071],i[f+20>>2]=i[18072],i[s>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(s),p0(f+76|0),k=i[r+12>>2],r=i[e>>2]}i[A>>2]=r,i[A+4>>2]=i[e+4>>2]}i[A+8>>2]=k,v=f+160|0}function eZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-368|0,v=A,i[A+360>>2]=r,i[A+364>>2]=e,DA(A+220|0,f,A+240|0,A+236|0,A+232|0),r=v-16|0,v=r,e=A+208|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,u[A+23|0]=1,u[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(q2(A+364|0,A+360|0))break f;o=i[A+204>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=t+r),t=i[A+364>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(Of(t,A+23|0,A+22|0,r,A+204|0,i[A+236>>2],i[A+232>>2],A+220|0,A+32|0,A+28|0,A+24|0,A+240|0))break f;if(f)break r;if(f=0,o=i[A+204>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+231|0]>>>7|0?f=i[A+224>>2]:f=l[A+231|0]&127;f:{if(!f|!(u[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}jn(A,r,i[A+204>>2],k),r=i[A>>2],f=i[A+4>>2],t=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=t,i[n>>2]=r,i[n+4>>2]=f,l4(A+220|0,A+32|0,i[A+28>>2],k),q2(A+364|0,A+360|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+364>>2],s2(e),s2(A+220|0),v=A+368|0;break i}f=1}a1(A+364|0);continue}break}return r|0}function c9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0;if(!((k|0)<=0)){i:{if(n=i[A+8>>2],o=i[A+4>>2],n-o>>3>=(k|0)){if(n=o-e|0,s=n>>3,(s|0)>=(k|0)){w=(k<<3)+r|0,n=o;break i}w=r+n|0;e:{if((w|0)==(f|0)){n=o;break e}for(t=w,n=o;i[n>>2]=i[t>>2],h=i[t+4>>2],i[n+4>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),n=n+8|0,t=t+8|0,(t|0)!=(f|0););}if(i[A+4>>2]=n,(s|0)>0)break i;return}e:{if(w=i[A>>2],o=(o-w>>3)+k|0,o>>>0<536870912){if(n=n-w|0,f=n>>2,s=n>>>0>=2147483640?536870911:f>>>0>o>>>0?f:o,s){if(s>>>0>=536870912)break e;f=E(s<<3)}else f=0;if(t=k<<3,o=f+(e-w|0)|0,k&1?(i[o>>2]=i[r>>2],n=i[r+4>>2],i[o+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,n=o+8|0):n=o,t=t+o|0,(k&536870911)!=1)for(;i[n>>2]=i[r>>2],k=i[r+4>>2],i[n+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+8>>2]=i[r+8>>2],k=i[r+12>>2],i[n+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+16|0,n=n+16|0,(t|0)!=(n|0););k=i[A+4>>2]-e|0,k&&z(t,e,k),i[A+4>>2]=e,n=i[A>>2],r=e-n|0,e=o-r|0,r&&z(e,n,r),i[A+4>>2]=k+t,i[A>>2]=e,i[A+8>>2]=f+(s<<3),n&&Z(n);return}G0(),H()}x0(),H()}if(f=k<<3,s=f+e|0,k=n,t=n-f|0,o>>>0>t>>>0)for(f=t;i[k>>2]=i[f>>2],i[k+4>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,k=k+8|0,f=f+8|0,o>>>0>f>>>0;);if(i[A+4>>2]=k,(n|0)!=(s|0))for(;;){t=t-8|0,f=i[t>>2],A=i[t+4>>2],i[t>>2]=0,i[t+4>>2]=0,k=i[n-4>>2],n=n-8|0,i[n>>2]=f,i[n+4>>2]=A;i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}if((e|0)==(t|0))break}if((r|0)!=(w|0))for(n=e;;){A=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[n>>2]=A,f=i[n+4>>2],i[n+4>>2]=e;i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n+8|0,r=r+8|0,(w|0)==(r|0))break}}}function rZ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,k=v-96|0,v=k,i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,t=k- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,X[i[i[e>>2]+12>>2]](k,e,r,f,k+48|0,n);i:{e:{r:{f:{A:switch(l[k+44|0]){case 0:if(n=107712,!i[26928])break e;r=107724,f=107731,e=107720;break f;case 1:break A;default:break r}if(!i[k>>2])break r;r=k+12|0,f=k+19|0,n=k,e=k+8|0}if(t=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=t,A=A+8|0,u[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}_2(),H()}e:{if(l[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break r;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+36>>2],i[e+36>>2]=i[k+32>>2],i[e+40>>2]=r,r=i[k+28>>2],i[e+28>>2]=i[k+24>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+32>>2],f=i[k+36>>2],n=i[k+24>>2],t=i[k+28>>2],u[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=t}u[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=l[k+44|0],(A|0)!=255&&(e=i[24783],i[k+88>>2]=i[24782],i[k+92>>2]=e,X[i[(k+88|0)+(A<<2)>>2]](k+87|0,k)),v=k+96|0}function fZ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,k=v-96|0,v=k,i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,t=k- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,X[i[i[e>>2]+12>>2]](k,e,r,f,k+48|0,n);i:{e:{r:{f:{A:switch(l[k+44|0]){case 0:if(n=107712,!i[26928])break e;r=107724,f=107731,e=107720;break f;case 1:break A;default:break r}if(!i[k>>2])break r;r=k+12|0,f=k+19|0,n=k,e=k+8|0}if(t=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=t,A=A+8|0,u[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}_2(),H()}e:{if(l[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break r;X[i[i[f>>2]+8>>2]](f),p(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+36>>2],i[e+36>>2]=i[k+32>>2],i[e+40>>2]=r,r=i[k+28>>2],i[e+28>>2]=i[k+24>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+32>>2],f=i[k+36>>2],n=i[k+24>>2],t=i[k+28>>2],u[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=t}u[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=l[k+44|0],(A|0)!=255&&(e=i[24689],i[k+88>>2]=i[24688],i[k+92>>2]=e,X[i[(k+88|0)+(A<<2)>>2]](k+87|0,k)),v=k+96|0}function AZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;o=v-16|0,v=o;i:{if(!A)break i;_=o+4|0,s=_,A=i[i[A>>2]+48>>2],r=v-176|0,v=r,i[r+120>>2]=0,i[r+92>>2]=72244,i[r+36>>2]=72224,f=i[18065],i[r+28>>2]=f,w=r+28|0,i[w+i[f-12>>2]>>2]=i[18066],i[r+32>>2]=0,f=w+i[i[r+28>>2]-12>>2]|0,k=r+40|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[r+36>>2]=f,h=i[f-12>>2],f=r+36|0,i[h+f>>2]=i[18068],t=i[18064],i[r+28>>2]=t,i[w+i[t-12>>2]>>2]=i[18069],i[r+92>>2]=72244,i[r+28>>2]=72204,i[r+36>>2]=72224,w=R0(k),i[w>>2]=71280,i[r+80>>2]=0,i[r+84>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+88>>2]=24;e:{r:{f:{if(k=i[A+16>>2],t=i[A+20>>2],(k|0)!=(t|0)){if(A=i[k>>2],n=i[i[A>>2]+12>>2],i[r+24>>2]=0,h=r+12|0,X[n|0](h,A,r+24|0),A=u[r+23|0],n=(A|0)<0,Y(f,n?i[r+12>>2]:h,n?i[r+16>>2]:A),u[r+23|0]<0&&Z(i[r+12>>2]),A=k+8|0,(t|0)!=(A|0))for(;Y(f,42713,1),i[r+24>>2]=0,k=r+12|0,n=i[A>>2],X[i[i[n>>2]+12>>2]](k,n,r+24|0),h=k,k=u[r+23|0],n=(k|0)<0,Y(f,n?i[r+12>>2]:h,n?i[r+16>>2]:k),u[r+23|0]<0&&Z(i[r+12>>2]),A=A+8|0,(t|0)!=(A|0););if(A=i[r+88>>2],!(A&16))break f}A=i[r+84>>2],f=i[r+64>>2],A>>>0<f>>>0&&(i[r+84>>2]=f,A=f),f=r+60|0;break r}if(!(A&8)){A=0,u[s+11|0]=0;break e}A=i[r+56>>2],f=r+48|0}r:{if(k=i[f>>2],A=A-k|0,A>>>0<2147483640){if(A>>>0>=11){t=A|7,f=E(t+1|0),i[s+8>>2]=t-2147483647,i[s>>2]=f,i[s+4>>2]=A,s=f;break r}if(u[s+11|0]=A,A)break r;A=0;break e}g0(),H()}if(!A)break e;z(s,k,A)}if(u[A+s|0]=0,A=i[18063],i[r+28>>2]=A,i[i[A-12>>2]+(r+28|0)>>2]=i[18071],i[r+36>>2]=i[18072],i[w>>2]=71280,u[r+83|0]<0&&Z(i[r+72>>2]),y0(w),p0(r+92|0),v=r+176|0,f=e,A=u[o+15|0],e=(A|0)<0,rl(f,e?i[o+4>>2]:_,e?i[o+8>>2]:A),u[o+15|0]>=0)break i;Z(i[o+4>>2])}v=o+16|0}function kZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0;h=v-16|0,v=h;i:{if(!pk(t,0)){i[A>>2]=5,i[A+4>>2]=2002,i[A+8>>2]=10027;break i}if(s=E(52),i[s+32>>2]=0,i[s+36>>2]=0,i[s+12>>2]=95984,i[s+4>>2]=0,i[s+8>>2]=0,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s>>2]=96228,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,f=0,r=G(k,n)+7|0,r>>>0>=8&&(r=r>>>3|0,f=E(r),r&&o0(f,0,r),B=r+f|0,i[s+40>>2]=B,i[s+36>>2]=B,i[s+32>>2]=f),r=B-f|0,r&&o0(f,0,r),g=s+12|0,r=i[t>>2],m=i[r+108>>2],I=i[r+112>>2],C=hi(t,0,h+12|0),!(!I|!m))for(V=m&-2,y=m&1,k=0,R=i[h+12>>2];;){W=G(k,R)+C|0;e:{if((m|0)==1){t=0;break e}for(N=W+1|0,t=0,n=0;r=((_&7)<<29|w>>>3)+f|0,u[r|0]=l[r|0]|(l[t+W|0]&128)>>>(w&7),r=_,B=w+1|0,r=(((B?r:r+1|0)&7)<<29|B>>>3)+f|0,u[r|0]=l[r|0]|(l[t+N|0]&128)>>>(B&7),t=t+2|0,w=w+2|0,_=w>>>0<2?_+1|0:_,n=n+2|0,(V|0)!=(n|0););}if(y&&(r=((_&7)<<29|w>>>3)+f|0,u[r|0]=l[r|0]|(l[t+W|0]&128)>>>(w&7),w=w+1|0,_=w?_:_+1|0),k=k+1|0,(I|0)==(k|0))break}r=i[e+8>>2],i[h+8>>2]=s,i[h+4>>2]=g,i[s+4>>2]=i[s+4>>2]+1,r2(r+12|0,h+4|0),r=i[h+8>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;X[i[i[r>>2]+8>>2]](r),p(r)}e:{if(!o||(i[s+4>>2]=i[s+4>>2]+1,r=E(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=g,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[o>>2]=r,e=i[s+4>>2],i[s+4>>2]=e-1,e))break e;X[i[i[s>>2]+8>>2]](s),p(s)}if(e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;X[i[i[s>>2]+8>>2]](s),p(s)}v=h+16|0}function nZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=M(0);for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,HA(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(P2(A+252|0,A+248|0))break f;o=i[A+176>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=t+r),t=i[A+252>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Lf(t<<24>>24,A+7|0,A+6|0,r,A+176|0,u[A+207|0],u[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,o=i[A+176>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+203|0]>>>7|0?f=i[A+196>>2]:f=l[A+203|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Yu(r,i[A+176>>2],k),E0[w>>2]=h,l4(A+192|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+192|0),v=A+256|0;break i}f=1}K1(A+252|0);continue}break}return r|0}function tZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(K2(Y(k,30474,15),i[e+112>>2],i[e+116>>2]),42713,1),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(k,31410,23),l[e+120|0]),42713,1),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(k,31559,30),l[e+121|0]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,32272,23),l[e+122|0]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function uZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,HA(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(P2(A+252|0,A+248|0))break f;o=i[A+176>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=t+r),t=i[A+252>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Lf(t<<24>>24,A+7|0,A+6|0,r,A+176|0,u[A+207|0],u[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,o=i[A+176>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+203|0]>>>7|0?f=i[A+196>>2]:f=l[A+203|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Mu(r,i[A+176>>2],k),t0[w>>3]=h,l4(A+192|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+192|0),v=A+256|0;break i}f=1}K1(A+252|0);continue}break}return r|0}function oZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=M(0);for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,DA(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(q2(A+348|0,A+344|0))break f;o=i[A+188>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=t+r),t=i[A+348>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(Of(t,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+188>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+215|0]>>>7|0?f=i[A+208>>2]:f=l[A+215|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Yu(r,i[A+188>>2],k),E0[w>>2]=h,l4(A+204|0,A+16|0,i[A+12>>2],k),q2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],s2(e),s2(A+204|0),v=A+352|0;break i}f=1}a1(A+348|0);continue}break}return r|0}function lZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,DA(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(q2(A+348|0,A+344|0))break f;o=i[A+188>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,X2(e,t<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=t+r),t=i[A+348>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=X[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(Of(t,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+188>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+215|0]>>>7|0?f=i[A+208>>2]:f=l[A+215|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Mu(r,i[A+188>>2],k),t0[w>>3]=h,l4(A+204|0,A+16|0,i[A+12>>2],k),q2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],s2(e),s2(A+204|0),v=A+352|0;break i}f=1}a1(A+348|0);continue}break}return r|0}function v1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(n=v-16|0,v=n,i[A+4>>2]=i[A+4>>2]+1,r=v-16|0,v=r,i[r+12>>2]=A,i[n+12>>2]=i[r+12>>2],v=r+16|0,r=i[32408],i[32409]-r>>2>>>0<=e>>>0)i:{if(A=e+1|0,f=i[32409],r=f-r>>2,A>>>0>r>>>0){s=v-32|0,v=s,t=A-r|0;e:{if(t>>>0<=i[32410]-f>>2>>>0){Qo(t);break e}f=s+12|0,r=v-16|0,v=r,k=t+(i[32409]-i[32408]>>2)|0,i[r+12>>2]=k;r:{if(A=Po(),k>>>0<=A>>>0){k=i[32410]-i[32408]>>2,k>>>0<A>>>1>>>0&&(i[r+8>>2]=k<<1,A=v-16|0,v=A,v=A+16|0,A=r+12|0,k=r+8|0,A=i[(u0[k>>2]<u0[A>>2]?A:k)>>2]),v=r+16|0,r=A;break r}Z4(),H()}for(o=i[32409]-i[32408]>>2,A=0,k=v-16|0,v=k,i[k+12>>2]=0,i[f+12>>2]=0,i[f+16>>2]=129644,r?(hl(k+4|0,i[f+16>>2],r),A=i[k+4>>2],r=i[k+8>>2]):r=0,i[f>>2]=A,o=(o<<2)+A|0,i[f+8>>2]=o,i[f+4>>2]=o,i[f+12>>2]=(r<<2)+A,v=k+16|0,r=v-16|0,v=r,A=i[f+8>>2],i[r+12>>2]=f+8,i[r+4>>2]=A,i[r+8>>2]=A+(t<<2),A=i[r+4>>2];;){if(i[r+8>>2]!=(A|0)){i[i[r+4>>2]>>2]=0,A=i[r+4>>2]+4|0,i[r+4>>2]=A;continue}break}for(i[i[r+12>>2]>>2]=i[r+4>>2],v=r+16|0,A=i[32408],k=i[32409],r=i[f+4>>2]+(A-k|0)|0,k=k-A|0,k&&z(r,A,k),i[f+4>>2]=r,i[32409]=i[32408],A=i[32408],i[32408]=i[f+4>>2],i[f+4>>2]=A,A=i[32409],i[32409]=i[f+8>>2],i[f+8>>2]=A,A=i[32410],i[32410]=i[f+12>>2],i[f+12>>2]=A,i[f>>2]=i[f+4>>2],A=i[f+4>>2];;){if(r=i[f+8>>2],(r|0)!=(A|0)){i[f+8>>2]=r-4;continue}break}A=i[f>>2],A&&jl(i[f+16>>2],A)}v=s+32|0;break i}A>>>0<r>>>0&&Ol(129632,i[32408]+(A<<2)|0)}A=i[i[32408]+(e<<2)>>2],A&&(r=i[A+4>>2]-1|0,i[A+4>>2]=r,(r|0)==-1&&X[i[i[A>>2]+8>>2]](A)),A=i[n+12>>2],i[n+12>>2]=0,i[i[32408]+(e<<2)>>2]=A,A=i[n+12>>2],i[n+12>>2]=0,A&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&X[i[i[A>>2]+8>>2]](A)),v=n+16|0}function sZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,29671,14),i[e+108>>2]),42713,1);i:{if(!i[e+104>>2]){if(i[e+116>>2]==i[e+112>>2])break i;for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],s=(n|0)<0,Y(f+8|0,s?i[f+148>>2]:o,s?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(f+8|0,19216,1),k),32765,4),i[i[e+112>>2]+(k<<2)>>2]),42713,1),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>2>>>0;);break i}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,31323,19),i[e+104>>2]),42713,1)}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function wZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0;i:{if(!A){A=i[13095],i[k+24>>2]=i[13094],i[k+28>>2]=A,A=i[13093],i[k+16>>2]=i[13092],i[k+20>>2]=A,A=i[13091],i[k+8>>2]=i[13090],i[k+12>>2]=A,k6(k+36|0,k+8|0,k+32|0,6);break i}n=E(4),i[n>>2]=A,A=n+4|0,i[k+44>>2]=A,i[k+36>>2]=n,i[k+40>>2]=A}Je();i:{if(n=i[26938],(n|0)==107756|i[k+36>>2]==i[k+40>>2])break i;e:{for(;;){r:{A=i[k+36>>2],f=i[k+40>>2];f:{if((A|0)==(f|0))break f;for(h=i[n+16>>2];;){if(_=X[i[h+16>>2]](i[A>>2])|0,!_){if(A=A+4|0,(f|0)!=(A|0))continue;break f}break}if(o>>>0<t>>>0){i[o+4>>2]=_,i[o>>2]=h,o=o+8|0;break f}if(A=o-s|0,B=A>>3,f=B+1|0,f>>>0>=536870912)break r;if(t=t-s|0,o=t>>2,w=t>>>0>=2147483640?536870911:f>>>0<o>>>0?o:f,w){if(w>>>0>=536870912)break e;t=E(w<<3)}else t=0;o=A+t|0,i[o+4>>2]=_,i[o>>2]=h,f=o-(B<<3)|0,A&&z(f,s,A),o=o+8|0,t=(w<<3)+t|0,s&&Z(s),s=f}f=i[n+4>>2];f:{if(f){for(;;)if(A=f,f=i[A>>2],!f)break f}for(;A=i[n+8>>2],f=i[A>>2]!=(n|0),n=A,!!f;);}if(n=A,(A|0)!=107756)continue;break i}break}gk(6307),H()}x0(),H()}n=o-s>>3;i:{if(!e||(A=0,S7(s,o,(o|0)!=(s|0)?62-(k1(n)<<1)|0:0,1),n=(r|0)>(n|0)?n:r,(n|0)<=0))break i;if(n>>>0>=4)for(r=n&2147483644,f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],t=A|1,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],t=A|2,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],t=A|3,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],A=A+4|0,f=f+4|0,(r|0)!=(f|0););if(r=n&3,!r)break i;for(f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],A=A+1|0,f=f+1|0,(r|0)!=(f|0););}return A=i[k+36>>2],A&&(i[k+40>>2]=A,Z(A)),s&&Z(s),v=k+48|0,n|0}function b9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k;i:{if(n=i[A>>2],t=i[A+4>>2]-n|0,o=(t>>5)+1|0,o>>>0<134217728){if(f=i[A+8>>2],i[k+28>>2]=A+8,n=f-n|0,f=n>>4,f=n>>>0>=2147483616?134217727:f>>>0>o>>>0?f:o,f){if(f>>>0>=134217728)break i;r=E(f<<5)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<5)+r,f=r+t|0,i[k+16>>2]=f,r=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=r,r=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=r,i[f+24>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,r=i[e+16>>2],e=i[e+20>>2],lA(f+16|0,r,e,(e-r|0)/40|0),i[k+20>>2]=f+32,t=A,r=i[A>>2],o=i[A+4>>2],f=i[k+16>>2]+(r-o|0)|0,(r|0)!=(o|0)){for(e=r,A=f;n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,n=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=n,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],i[A+24>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,A=A+32|0,e=e+32|0,(o|0)!=(e|0););for(;;){if(n=i[r+16>>2],n){if(A=n,e=i[r+20>>2],(A|0)!=(e|0)){for(;A=i[e-16>>2],A&&(i[e-12>>2]=A,Z(A)),e=e-40|0,(n|0)!=(e|0););A=i[r+16>>2]}i[r+20>>2]=n,Z(A)}if(r=r+32|0,(o|0)==(r|0))break}r=i[t>>2]}if(i[k+16>>2]=f,i[t+4>>2]=r,i[t>>2]=i[k+16>>2],i[k+16>>2]=r,A=i[t+4>>2],i[t+4>>2]=i[k+20>>2],i[k+20>>2]=A,A=i[t+8>>2],i[t+8>>2]=i[k+24>>2],i[k+24>>2]=A,i[k+12>>2]=i[k+16>>2],o=i[t+4>>2],e=i[k+20>>2],f=i[k+16>>2],(e|0)!=(f|0))for(;;){if(A=e-32|0,i[k+20>>2]=A,t=e-16|0,n=i[t>>2],n){if(e=e-12|0,A=i[e>>2],r=n,(A|0)!=(r|0)){for(;r=i[A-16>>2],r&&(i[A-12>>2]=r,Z(r)),A=A-40|0,(n|0)!=(A|0););r=i[t>>2]}i[e>>2]=n,Z(r),A=i[k+20>>2]}if(e=A,(f|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}x0(),H()}function hZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72548,n=i[18140],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[18141],o=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(o,k),u[o+80|0]=0,i[o+72>>2]=0,i[f+80>>2]=72548,i[f+24>>2]=72528,o=R0(k),i[o>>2]=71280,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,Y2(k,e,r),s=n,t=k,n=u[f+175|0],k=(n|0)<0,Y(s,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(I0(Y(f+24|0,32242,13),i[e+104>>2]),42713,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],s=(k|0)<0,Y(n,s?i[f+164>>2]:t,s?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(n,31635,14),k=f+12|0,P1(k,i[e+108>>2]),s=n,t=k,n=u[f+23|0],k=(n|0)<0,n=Y(Y(s,k?i[f+12>>2]:t,k?i[f+16>>2]:n),42713,1),k=f+164|0,s0(k,r),t=k,r=u[f+175|0],k=(r|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(n,31897,6),r=u[e+135|0],n=(r|0)<0,Y(Y(k,n?i[e+124>>2]:e+124|0,n?i[e+128>>2]:r),42713,1),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18142],i[o>>2]=71280,u[f+71|0]<0&&Z(i[f+60>>2]),y0(o),p0(f+80|0),v=f+176|0}function en(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;B=v-16|0,v=B,w=c0(t,129800),W=c0(t,129872),t=W,X[i[i[t>>2]+20>>2]](B+4|0,t),i[n>>2]=f;i:{e:switch(s=A,t=l[s|0],t-43|0){case 0:case 2:break e;default:break i}t=X[i[i[w>>2]+44>>2]](w,t<<24>>24)|0,o=i[n>>2],i[n>>2]=o+4,i[o>>2]=t,s=A+1|0}i:{if(t=s,!((r-t|0)<=1|l[t|0]!=48|(l[t+1|0]|32)!=120))for(o=X[i[i[w>>2]+44>>2]](w,48)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=o,o=X[i[i[w>>2]+44>>2]](w,u[t+1|0])|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=o,s=t+2|0,t=s;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),!(o-48>>>0<10|(o|32)-97>>>0<6)))break i;t=t+1|0}for(;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),o-48>>>0>=10))break i;t=t+1|0}}l[B+15|0]>>>7|0?o=i[B+8>>2]:o=l[B+15|0]&127;i:{if(!o){X[i[i[w>>2]+48>>2]](w,s,t,i[n>>2])|0,i[n>>2]=i[n>>2]+(t-s<<2);break i}for(N6(s,t),I=X[i[i[W>>2]+16>>2]](W)|0,o=s;;){if(t>>>0<=o>>>0)cr((s-A<<2)+f|0,i[n>>2]);else{h=B+4|0;e:{if(l[h+11|0]>>>7|0){m=i[h>>2];break e}m=h}C=u[m+g|0]<=0,l[h+11|0]>>>7|0?m=i[h>>2]:m=h,C|u[m+g|0]!=(_|0)||(_=i[n>>2],i[n>>2]=_+4,i[_>>2]=I,l[h+11|0]>>>7|0?h=i[h+4>>2]:h=l[h+11|0]&127,g=(h-1>>>0>g>>>0)+g|0,_=0),h=X[i[i[w>>2]+44>>2]](w,u[o|0])|0,m=i[n>>2],i[n>>2]=m+4,i[m>>2]=h,o=o+1|0,_=_+1|0;continue}break}}i:{e:{for(;;){if(r>>>0<=t>>>0)break e;if(o=t+1|0,t=u[t|0],(t|0)!=46){t=X[i[i[w>>2]+44>>2]](w,t)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=t,t=o;continue}break}t=X[i[i[W>>2]+12>>2]](W)|0,s=i[n>>2],_=s+4|0,i[n>>2]=_,i[s>>2]=t;break i}_=i[n>>2],o=t}X[i[i[w>>2]+48>>2]](w,o,r,_)|0,t=n,n=i[n>>2]+(r-o<<2)|0,i[t>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A<<2)+f|0,s2(B+4|0),v=B+16|0}function Hf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;t=v-32|0,v=t,h=i[e+512>>2],n=f,f=i[e+460>>2],k=n+G(((f+i[e+452>>2]|0)-1>>>0)/(f>>>0)|0,k)|0,B=k<<4,f=h+B|0;i:{e:{if(i[f>>2]!=10|i[f+4>>2])break e;for(_=v-16|0,v=_,I=e+448|0,f=i[e+516>>2]-h>>4,s=u0[e+536>>2]/(l[e+473|0]+l[e+472|0]>>>3>>>0)|0,o=k;;){r:{if(o=o+1|0,m=o-k|0,f>>>0<=o>>>0|s>>>0<=m>>>0)break r;if(n=(o<<4)+h|0,w=i[n>>2],!i[n+4>>2]&(w|0)==10)continue}break}W=k>>>0>s>>>0?s:k,C=k-W|0,n=k;r:{for(;;){f:{if(f=n,!f||(w=k-f|0,w>>>0>=s>>>0))break f;if(n=f-1|0,g=(n<<4)+h|0,!i[g+4>>2]&i[g>>2]==10)continue;break r}break}f=C,w=W}r:{if(o-f>>>0<=s>>>0)break r;if(w>>>0<m>>>0){o=f+s|0;break r}f=o-s|0}n=_+8|0,k=i[e+100>>2],i[n>>2]=i[k+48>>2],k=i[k+52>>2],i[n+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),b7(A,I,n,i[e+116>>2],f,o,0),f=i[_+12>>2];r:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break r;X[i[i[f>>2]+8>>2]](f),p(f)}if(v=_+16|0,i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}n=i[e+512>>2]+B|0,f=i[n+8>>2],k=i[n>>2],o=i[n+4>>2],n=i[e+100>>2],i[t>>2]=i[n+48>>2],n=i[n+52>>2],i[t+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),Qr(t+8|0,i[t>>2],i[e+116>>2],r,k,o,f,0),e=i[t+4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;X[i[i[e>>2]+8>>2]](e),p(e)}e=A+8|0;e:{if(i[t+8>>2]){r=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=r,i[e+8>>2]=i[t+24>>2],A=i[t+20>>2],i[e>>2]=i[t+16>>2],i[e+4>>2]=A,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0;break e}if(r=i[26929],i[A>>2]=i[26928],i[A+4>>2]=r,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break e}T(e,i[26930],i[26931])}if(u[t+27|0]>=0)break i;Z(i[t+16>>2])}v=t+32|0}function _Z(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(i[e+100>>2]){if(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,31621,13),n=f+148|0,t=i[e+100>>2],P1(n,X[i[i[t>>2]+8>>2]](t)|0),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),42713,1),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,e=i[e+100>>2],X[i[i[e>>2]+12>>2]](k,e,r),e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(e,42348,17),Y(e,33411,17)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function Zr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+128>>2]=0,i[A+132>>2]=0,o0(A,0,124),i[A+136>>2]=0,i[A+140>>2]=0,i[A+124>>2]=A+128,i[A+144>>2]=0,i[A+148>>2]=0,i[A+152>>2]=0,i[A+156>>2]=0,s=E(96),i[s>>2]=94992,i[s+4>>2]=0,i[s+8>>2]=0,f=s+16|0,e=f,i[e+16>>2]=0,i[e+20>>2]=0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=1,i[e+56>>2]=0,i[e+60>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,e=e- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[f+72>>2]=0,i[f+76>>2]=0,e=E(136),i[e>>2]=89772,i[e+4>>2]=0,i[e+8>>2]=0,o=e+16|0,r=o,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[r>>2]=86932,i[e+132>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+116>>2]=0,i[e+120>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+32>>2]=1718909296,i[e+4>>2]=i[e+4>>2]+1;i:{e:{r:{r=i[f+20>>2],k=i[f+24>>2];f:{if(r>>>0<k>>>0){i[r+4>>2]=e,i[r>>2]=o,r=r+8|0;break f}if(w=i[f+16>>2],r=r-w|0,h=r>>3,n=h+1|0,n>>>0>=536870912)break r;if(k=k-w|0,t=k>>2,k=k>>>0>=2147483640?536870911:t>>>0>n>>>0?t:n,k){if(k>>>0>=536870912)break e;n=E(k<<3)}else n=0;if(t=n+r|0,i[t+4>>2]=e,i[t>>2]=o,o=t-(h<<3)|0,r&&z(o,w,r),i[f+24>>2]=n+(k<<3),r=t+8|0,i[f+20>>2]=r,i[f+16>>2]=o,!w)break f;Z(w)}i[f+20>>2]=r,r=i[e+4>>2],i[e+4>>2]=r-1,r||(X[i[i[e>>2]+8>>2]](e),p(e));break i}G0(),H()}x0(),H()}i[A>>2]=f,e=i[A+4>>2],i[A+4>>2]=s;i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A}function rn(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;_=v-16|0,v=_,w=c0(t,129808),W=c0(t,129864),t=W,X[i[i[t>>2]+20>>2]](_+4|0,t),i[n>>2]=f;i:{e:switch(s=A,t=l[s|0],t-43|0){case 0:case 2:break e;default:break i}t=X[i[i[w>>2]+28>>2]](w,t<<24>>24)|0,o=i[n>>2],i[n>>2]=o+1,u[o|0]=t,s=A+1|0}i:{if(t=s,!((r-t|0)<=1|l[t|0]!=48|(l[t+1|0]|32)!=120))for(o=X[i[i[w>>2]+28>>2]](w,48)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=o,o=X[i[i[w>>2]+28>>2]](w,u[t+1|0])|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=o,s=t+2|0,t=s;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),!(o-48>>>0<10|(o|32)-97>>>0<6)))break i;t=t+1|0}for(;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),o-48>>>0>=10))break i;t=t+1|0}}l[_+15|0]>>>7|0?o=i[_+8>>2]:o=l[_+15|0]&127;i:{if(!o){X[i[i[w>>2]+32>>2]](w,s,t,i[n>>2])|0,i[n>>2]=i[n>>2]+(t-s|0);break i}for(N6(s,t),I=X[i[i[W>>2]+16>>2]](W)|0,o=s;;){if(t>>>0<=o>>>0)N6((s-A|0)+f|0,i[n>>2]);else{h=_+4|0;e:{if(l[h+11|0]>>>7|0){B=i[h>>2];break e}B=h}C=u[B+g|0]<=0,l[h+11|0]>>>7|0?B=i[h>>2]:B=h,C|u[B+g|0]!=(m|0)||(m=i[n>>2],i[n>>2]=m+1,u[m|0]=I,l[h+11|0]>>>7|0?h=i[h+4>>2]:h=l[h+11|0]&127,g=(h-1>>>0>g>>>0)+g|0,m=0),h=X[i[i[w>>2]+28>>2]](w,u[o|0])|0,B=i[n>>2],i[n>>2]=B+1,u[B|0]=h,o=o+1|0,m=m+1|0;continue}break}}for(;;){i:{e:{if(r>>>0<=t>>>0){o=t;break e}if(o=t+1|0,t=u[t|0],(t|0)!=46)break i;t=X[i[i[W>>2]+12>>2]](W)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=t}X[i[i[w>>2]+32>>2]](w,o,r,i[n>>2])|0,t=n,n=i[n>>2]+(r-o|0)|0,i[t>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A|0)+f|0,s2(_+4|0),v=_+16|0;return}t=X[i[i[w>>2]+28>>2]](w,t)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=t,t=o}}function BZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=X0(k,86628,99524),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=E(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97248,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98952,!f|i[f+4>>2]!=-1||(X[i[i[f>>2]+8>>2]](f),p(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}if(r=r+8|0,(f|0)==(r|0))break}if(e=E(24),i[n+4>>2]=e,i[n+8>>2]=18,i[n+12>>2]=-2147483624,r=l[25713]|l[25714]<<8|(l[25715]<<16|l[25716]<<24),f=l[25709]|l[25710]<<8|(l[25711]<<16|l[25712]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[25725]|l[25726]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[25721]|l[25722]<<8|(l[25723]<<16|l[25724]<<24),f=l[25717]|l[25718]<<8|(l[25719]<<16|l[25720]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,0,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26930],i[26931])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function vZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=4){t1(A,e,15059);break i}e:{r:{if(k>>>0>=2){i[e+112>>2]=0;break r}if(n=e,t=o2(r),i[n+104>>2]=t,n=e,t=o2(r),Q[n+108>>1]=t,B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],i[e+112>>2]=0,k=l[e+97|0],k>>>0<2)break e}u[e+164|0]=u[e+100|0]&1;r:{if((k|0)==2){k=o2(r);break r}k=F0(r)}if(i[e+104>>2]=k,n=e,t=o2(r),Q[n+108>>1]=t,n=e,t=F0(r),i[n+112>>2]=t,B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],k=i[e+112>>2],(k|0)!=1970432288){if((k|0)!=1835625829)break e;B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2];break e}B4(f+20|0,r),u[e+163|0]<0&&Z(i[e+152>>2]),k=i[f+24>>2],i[e+152>>2]=i[f+20>>2],i[e+156>>2]=k,i[e+160>>2]=i[f+28>>2]}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function mZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,n=i[18065],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(n,s),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,s=R0(s),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,M1(k,e,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,32677,14),i[e+104>>2]),32945,7),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,31434,13),i[e+108>>2]),41579,10),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,31448,13),i[e+112>>2]),41579,10),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function ZZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;t=v-80|0,v=t;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}s=i[e>>2],o=i[e+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!i[s+84>>2]&u0[s+80>>2]<=u0[s+92>>2]){i[r>>2]=0,i[A+8>>2]=15286,i[A>>2]=13,i[A+4>>2]=0;break e}w=jA(),nA(w,n),n=X0(s,106612,106744);r:{if(n){o&&(i[o+4>>2]=i[o+4>>2]+1),H7(t+44|0,n,w);f:{A:{k:{n:{t:{u:switch(l[t+64|0]){case 1:b0(A,t+44|0,i[e+8>>2]);break f;case 0:break u;default:break t}h=i[t+44>>2],n=i[t+48>>2];u:{if(!n){s=i[e+8>>2];break u}i[n+4>>2]=i[n+4>>2]+1,s=i[e+8>>2],i[n+4>>2]=i[n+4>>2]+1}switch(i[t+12>>2]=n,i[t+8>>2]=h,h=i[t+12>>2],i[t>>2]=i[t+8>>2],i[t+4>>2]=h,F9(t+16|0,s,t,f,k,w),l[t+36|0]){case 0:break k;case 1:break n;default:break t}}_2(),H()}b0(A,t+16|0,i[e+8>>2]);break A}e=i[t+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),f=i[t+16>>2];k:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break k;X[i[i[n>>2]+8>>2]](n),p(n)}k=r,r=E(8),i[k>>2]=r,i[r+4>>2]=e,i[r>>2]=f,n=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}if(A=l[t+36|0],(A|0)!=255&&(e=i[24203],i[t+72>>2]=i[24202],i[t+76>>2]=e,X[i[(t+72|0)+(A<<2)>>2]](t+71|0,t+16|0)),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break f;X[i[i[n>>2]+8>>2]](n),p(n)}if(A=l[t+64|0],(A|0)!=255&&(e=i[24203],i[t+16>>2]=i[24202],i[t+20>>2]=e,X[i[(t+16|0)+(A<<2)>>2]](t+72|0,t+44|0)),!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break r;X[i[i[o>>2]+8>>2]](o),p(o);break r}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24740,!w)break e}z2(w)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=t+80|0}function ci(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0;w=v-32|0,v=w,Z8(w+24|0,i[e+48>>2],n),n=i[w+24>>2],u[n+164|0]=1,i[n+100>>2]=i[n+100>>2]&-2|1;i:{e:{r:{if(!t)break r;if(_=i[w+24>>2],n=h2(t),n>>>0>=2147483640)break e;f:{A:{if(n>>>0>=11){B=n|7,h=E(B+1|0),i[w+20>>2]=B-2147483647,i[w+12>>2]=h,i[w+16>>2]=n;break A}if(u[w+23|0]=n,h=w+12|0,!n)break f}if(!n)break f;z(h,t,n)}u[n+h|0]=0,n=_+128|0;f:{if((n|0)==(w+12|0))break f;if(t=u[w+23|0],u[_+139|0]>=0){if((t|0)>=0){t=i[w+16>>2],i[n>>2]=i[w+12>>2],i[n+4>>2]=t,i[n+8>>2]=i[w+20>>2];break f}D1(n,i[w+12>>2],i[w+16>>2]);break f}h=n,n=(t|0)<0,O1(h,n?i[w+12>>2]:w+12|0,n?i[w+16>>2]:t)}if(u[w+23|0]>=0)break r;Z(i[w+12>>2])}t=i[i[w+24>>2]+104>>2],s&&(i[s>>2]=t),n=i[e+48>>2],s=i[i[r>>2]+116>>2],r=E(4),i[w+12>>2]=r,h=r+4|0,i[w+20>>2]=h,i[r>>2]=s,i[w+16>>2]=h,a4(n,t,1667527523,w+12|0),r=i[w+12>>2],r&&(i[w+16>>2]=r,Z(r)),n=0,i[w+20>>2]=0,i[w+12>>2]=0,i[w+16>>2]=0;r:{f:switch(o-3|0){case 1:if(u[w|0]=0,u[w+11|0]=0,K(A,4,3005,w),u[w+11|0]>=0)break r;Z(i[w>>2]);break r;case 0:if(u[w|0]=0,u[w+11|0]=0,K(A,4,3005,w),u[w+11|0]>=0)break r;Z(i[w>>2]);break r;default:break f}if(k){if((k|0)<0)break i;n=E(k),k&&o0(n,0,k),r=k+n|0,i[w+20>>2]=r,i[w+16>>2]=r,i[w+12>>2]=n}if(k&&z(n,f,k),K8(i[e+48>>2],t,w+12|0,0),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}A=i[w+12>>2],A&&(i[w+16>>2]=A,Z(A)),A=i[w+28>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=w+32|0;return}g0(),H()}G0(),H()}function GZ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{if(!i[A+64>>2]){t=-1;break e}r=i[A+92>>2]&8,r||(i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,t=l[A+98|0],e=i[(t?32:56)+A>>2],t=e+i[(t?52:60)+A>>2]|0,i[A+16>>2]=t,i[A+12>>2]=t,i[A+8>>2]=e,i[A+92>>2]=8),i[A+12>>2]||(e=k+16|0,i[A+16>>2]=e,i[A+12>>2]=e,i[A+8>>2]=k+15),r&&(e=i[A+16>>2],r=i[A+8>>2],i[k+4>>2]=4,i[k+8>>2]=(e-r|0)/2,e=v-16|0,v=e,v=e+16|0,e=k+4|0,r=k+8|0,n=i[(u0[e>>2]<u0[r>>2]?e:r)>>2]),t=-1,e=i[A+16>>2];r:{if((e|0)==i[A+12>>2]){if(r=i[A+8>>2],n&&z(r,e-n|0,n),l[A+98|0]==1){if(e=i[A+8>>2],e=au(e+n|0,i[A+16>>2]-(e+n|0)|0,i[A+64>>2]),!e)break r;r=i[A+8>>2],f=e,e=i[A+8>>2]+n|0,i[A+16>>2]=f+e,i[A+12>>2]=e,i[A+8>>2]=r,t=l[i[A+12>>2]];break r}e=i[A+40>>2],r=i[A+36>>2];f:{if((e|0)==(r|0)){r=e;break f}e=e-r|0,e&&z(i[A+32>>2],r,e),e=i[A+36>>2],r=i[A+40>>2]}if(f=i[A+32>>2],e=r-e|0,i[A+36>>2]=f+e,r=(f|0)==(A+44|0)?8:i[A+52>>2],i[A+40>>2]=r+f,i[k+8>>2]=i[A+60>>2]-n,i[k+4>>2]=r-e,e=v-16|0,v=e,v=e+16|0,r=k+4|0,e=k+8|0,r=i[(u0[r>>2]<u0[e>>2]?r:e)>>2],f=i[A+76>>2],i[A+80>>2]=i[A+72>>2],i[A+84>>2]=f,f=au(i[A+36>>2],r,i[A+64>>2]),!f)break r;if(r=i[A+68>>2],!r)break i;f=f+i[A+36>>2]|0,i[A+40>>2]=f,o=f,f=i[A+8>>2];f:{if((X[i[i[r>>2]+16>>2]](r,A+72|0,i[A+32>>2],o,A+36|0,f+n|0,f+i[A+60>>2]|0,e)|0)==3){e=i[A+32>>2],i[A+16>>2]=i[A+40>>2],i[A+12>>2]=e,i[A+8>>2]=e;break f}if(e=i[k+8>>2],r=i[A+8>>2],n=r+n|0,(e|0)==(n|0))break r;i[A+16>>2]=e,i[A+12>>2]=n,i[A+8>>2]=r}t=l[i[A+12>>2]];break r}t=l[i[A+12>>2]]}if(i[A+8>>2]!=(k+15|0))break e;i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0}return v=k+16|0,t|0}Q1(),H()}function WZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-16|0,v=f,n=i[e+12>>2],s=n;i:{e:{r:{if(k=i[e+8>>2],n|k){if(n=i[e+32>>2],o=n>>>0>k>>>0,o&!s)break r;if(w=k-n|0,n=s-o|0,k=w,!n&k>>>0>=2147483648|n){if(e=E(24),i[f+4>>2]=e,i[f+8>>2]=18,i[f+12>>2]=-2147483624,r=l[13914]|l[13915]<<8|(l[13916]<<16|l[13917]<<24),k=l[13910]|l[13911]<<8|(l[13912]<<16|l[13913]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[13926]|l[13927]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),k=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,2,1e3,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}t=i[e+104>>2],n=i[e+100>>2],w=t-n|0;f:{if(k>>>0>w>>>0){if(s=k-w|0,o=i[e+108>>2],s>>>0<=o-t>>>0){s&&o0(t,0,s),i[e+104>>2]=t+s;break f}if(t=o-n|0,o=t<<1,o=t>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,t=E(o),s&&o0(t+w|0,0,s),w&&z(t,n,w),i[e+108>>2]=t+o,i[e+104>>2]=k+t,i[e+100>>2]=t,!n)break f;Z(n);break f}if(k>>>0>=w>>>0)break f;i[e+104>>2]=k+n}l6(r,i[e+100>>2],k)}if(l[r+20|0]!=1)break e;if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,101,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function XZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v+-64|0,v=n,h9(n+40|0,e,r);i:{if(i[n+40>>2]){e=i[n+44>>2],i[A>>2]=i[n+40>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[n+59|0]>=0){r=i[n+52>>2],i[e>>2]=i[n+48>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+56>>2];break e}T(e,i[n+48>>2],i[n+52>>2])}u[A+20|0]=1;break i}i[n+36>>2]=0;e:{r:{r=i[e+56>>2],t=i[r>>2];f:{if((t|0)>=5){if(t=i[r+68>>2],!t)break f;if(r=n+24|0,X[t|0](r,i[e+60>>2],n+36|0,f,k),!i[n+24>>2])break e;if(nr(n,r),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if((t|0)!=4)break r}if(f=i[r+44>>2],!f)break r;if(r=n+24|0,X[f|0](r,i[e+60>>2],n+36|0,k),!i[n+24>>2])break e;if(nr(n,r),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(f=n+24|0,X[i[r+32>>2]](f,i[e+60>>2],n+36|0),!i[n+24>>2])break e;if(nr(n,f),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(e=i[n+36>>2],!e){u[A+20|0]=0,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,z4(e),u[A+20|0]=0,i[A>>2]=r,i[A+4>>2]=f}u[n+59|0]<0&&Z(i[n+48>>2]),v=n- -64|0}function xf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;i:{e:{if((r|0)>=0){f=i[i[A+124>>2]+(e?16840:16832)>>2];r:{if(f-1>>>0<=7){if(!e){if(e=G(i[A+28>>2],i[A+40>>2]),!e)break r;o0(i[A+4>>2],r,e);return}if(f=G(i[A+36>>2],i[A+44>>2]),!f)break r;o0(i[(A+4|0)+(e<<2)>>2],r,f);return}if(f=f-9|0,(r&255)==(r>>>8|0)){if(f>>>0>=8)break e;if(!e){if(e=G(i[A+40>>2],i[A+28>>2])<<1,!e)break r;o0(i[A+4>>2],0,e);return}if(r=G(i[A+44>>2],i[A+36>>2])<<1,!r)break r;o0(i[(A+4|0)+(e<<2)>>2],0,r);return}if(f>>>0>=8)break i;if(e){n=i[A+32>>2];f:{if((n|0)<=0)break f;if(k=i[((e<<2)+A|0)+4>>2],f=0,n>>>0>=4)for(s=k+6|0,w=k+4|0,h=k+2|0,_=n&2147483644;t=f<<1,Q[t+k>>1]=r,Q[t+h>>1]=r,Q[t+w>>1]=r,Q[t+s>>1]=r,f=f+4|0,B=B+4|0,(_|0)!=(B|0););if(n=n&3,!n)break f;for(;Q[k+(f<<1)>>1]=r,f=f+1|0,o=o+1|0,(n|0)!=(o|0););}if(i[A+36>>2]<2)break r;for(e=(e<<2)+A|0,r=1;f=i[A+32>>2]<<1,f&&(k=i[e+4>>2],z(k+(G(i[A+44>>2],r)<<1)|0,k,f)),r=r+1|0,(r|0)<i[A+36>>2];);break r}n=i[A+24>>2];f:{if((n|0)<=0)break f;if(k=i[A+4>>2],f=0,n>>>0>=4)for(s=k+6|0,w=k+4|0,h=k+2|0,_=n&2147483644,e=0;t=f<<1,Q[t+k>>1]=r,Q[t+h>>1]=r,Q[t+w>>1]=r,Q[t+s>>1]=r,f=f+4|0,e=e+4|0,(_|0)!=(e|0););if(e=n&3,!e)break f;for(;Q[k+(f<<1)>>1]=r,f=f+1|0,o=o+1|0,(e|0)!=(o|0););}if(i[A+28>>2]<2)break r;for(r=1;e=i[A+32>>2]<<1,e&&(f=i[A+4>>2],z(f+(G(i[A+40>>2],r)<<1)|0,f,e)),r=r+1|0,(r|0)<i[A+28>>2];);}return}M0(22156,18299,534,12869),H()}M0(21624,18299,545,12869),H()}M0(21624,18299,556,12869),H()}function fn(A,e,r,f,k,n){var t=0,o=0;sr(i[e+48>>2]),t=E(352),i[t>>2]=94900,i[t+4>>2]=0,i[t+8>>2]=0,o=v-16|0,v=o,f=p7(t+16|0,e,r,f),r=f,i[r+308>>2]=0,i[r+312>>2]=0,u[r+300|0]=0,i[r+296>>2]=0,i[r+288>>2]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r>>2]=106720,i[r+304>>2]=r+308,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,r=i[r+140>>2],i[r+184>>2]=n<<16,i[r+180>>2]=k<<16,r=E(128),i[r>>2]=93212,i[r+4>>2]=0,i[r+8>>2]=0,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,Q[r+112>>1]=0,i[k>>2]=104668,i[r+116>>2]=1,i[r+32>>2]=1986881636,i[r+120>>2]=0,i[r+124>>2]=0,n=i[f+148>>2],i[o+12>>2]=r,i[o+8>>2]=k,i[r+4>>2]=i[r+4>>2]+1,r2(n+36|0,o+8|0),k=i[o+12>>2];i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;X[i[i[k>>2]+8>>2]](k),p(k)}k=i[r+4>>2],i[r+4>>2]=k-1,k||(X[i[i[r>>2]+8>>2]](r),p(r)),v=o+16|0,n=f,i[t+4>>2]=i[t+4>>2]+1,o=i[t+40>>2];i:{e:{r=i[e+184>>2];r:{if(!r){k=e+184|0,f=k;break r}for(;;){if(f=r,r=i[r+16>>2],r>>>0>o>>>0){if(k=f,r=i[k>>2],r)continue;break r}if(r>>>0>=o>>>0)break e;if(r=i[f+4>>2],!r)break}k=f+4|0}r=E(28),i[r+24>>2]=t,i[r+20>>2]=n,i[r+16>>2]=o,i[r+8>>2]=f,i[r>>2]=0,i[r+4>>2]=0,i[k>>2]=r,f=i[i[e+180>>2]>>2],f&&(i[e+180>>2]=f),m1(i[e+184>>2],r),i[e+188>>2]=i[e+188>>2]+1;break i}if(e=i[t+4>>2],i[t+4>>2]=e-1,e)break i;X[i[i[t>>2]+8>>2]](t),p(t)}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=n}function Y4(A,e,r){return i[A+84>>2]=0,i[A+88>>2]=0,u[A+80|0]=0,u[A+68|0]=0,i[A+64>>2]=0,u[A+60|0]=0,u[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,u[A+12|0]=1,Q[A+10>>1]=2,Q[A+6>>1]=2,Q[A+8>>1]=2,u[A+4|0]=0,i[A+100>>2]=e,u[A+232|0]=0,i[A+92>>2]=0,i[A+96>>2]=4740,i[A>>2]=100584,Q[A+128>>1]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,Q[A+138>>1]=0,Q[A+140>>1]=0,Q[A+142>>1]=0,Q[A+144>>1]=0,i[A+148>>2]=0,i[A+152>>2]=0,u[A+156|0]=0,i[A+160>>2]=0,i[A+164>>2]=0,u[A+168|0]=0,i[A+236>>2]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+248>>2]=0,i[A+252>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,u[A+272|0]=1,i[A+344>>2]=0,i[A+348>>2]=0,i[A+352>>2]=0,u[A+281|0]=0,u[A+282|0]=0,u[A+283|0]=0,u[A+284|0]=0,u[A+285|0]=0,u[A+286|0]=0,u[A+287|0]=0,u[A+288|0]=0,i[A+276>>2]=0,i[A+280>>2]=0,u[A+336|0]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+312>>2]=0,i[A+316>>2]=0,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,Q[A+356>>1]=1,i[A+368>>2]=0,i[A+372>>2]=0,i[A+360>>2]=0,i[A+364>>2]=0,i[A+384>>2]=0,i[A+388>>2]=1072693248,i[A+176>>2]=0,i[A+180>>2]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,i[A+208>>2]=0,i[A+212>>2]=0,i[A+216>>2]=0,i[A+220>>2]=0,i[A+224>>2]=0,i[A+228>>2]=0,i[A+416>>2]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+432>>2]=0,i[A+436>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,i[A+116>>2]=r,A}function gZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(!(f&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],o=i[k+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!e3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3572;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,e,r,k+20|0);r:{if(i[k>>2]){i[t+8>>2]=0,i[t+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[t+12>>2],e=X0(e,86628,86672),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=X0(e,86628,86672),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[t+8>>2]=0,i[t+12>>2]=0}i[t+8>>2]=0,i[t+12>>2]=0;break r}if(i[t+12>>2]=s,i[t+8>>2]=e,e=i[n+4>>2],i[t+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[t+8>>2],e&&(r=E(32),i[f>>2]=r,f=i[e+132>>2],i[r+24>>2]=i[e+128>>2],i[r+28>>2]=f,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[t+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=t+16|0}function QZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;A=v-480|0,v=A,t=A+476|0,o=i[f+28>>2],i[t>>2]=o,(o|0)!=129624&&(i[o+4>>2]=i[o+4>>2]+1),W=c0(t,129800),l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127,t&&(l[n+11|0]>>>7|0?t=i[n>>2]:t=n,g=i[t>>2]==(X[i[i[W>>2]+44>>2]](W,45)|0)),t=v-16|0,v=t,_=A+452|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+440|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,t=v-16|0,v=t,w=A+428|0,i[w>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0,v=t+16|0,Gt(r,g,A+476|0,A+472|0,A+468|0,A+464|0,_,s,w,A+424|0),i[A+16>>2]=2071,r=A+16|0,h=g1(A+8|0,0,r);i:{l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127;e:{if((t|0)>i[A+424>>2]){l[n+11|0]>>>7|0?o=i[n+4>>2]:o=l[n+11|0]&127,t=i[A+424>>2],l[s+11|0]>>>7|0?B=i[s+4>>2]:B=l[s+11|0]&127,l[w+11|0]>>>7|0?m=i[w+4>>2]:m=l[w+11|0]&127,t=(t+(B+(m+(o-t<<1)|0)|0)|0)+1|0;break e}B=i[A+424>>2],l[w+11|0]>>>7|0?t=i[w+4>>2]:t=l[w+11|0]&127,l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127,t=(B+(t+o|0)|0)+2|0}if(t>>>0<101||(r=p2(t<<2),t=i[h>>2],i[h>>2]=r,t&&X[i[h+4>>2]](t),r=i[h>>2],r))break i;Q1(),H()}return B=A+4|0,m=i[f+4>>2],l[n+11|0]>>>7|0?t=i[n>>2]:t=n,o=t,l[n+11|0]>>>7|0?t=i[n>>2]:t=n,l[n+11|0]>>>7|0?n=i[n+4>>2]:n=l[n+11|0]&127,S9(r,B,A,m,o,t+(n<<2)|0,W,g,A+472|0,i[A+468>>2],i[A+464>>2],_,s,w,i[A+424>>2]),e=j8(e,r,i[A+4>>2],i[A>>2],f,k),r=i[h>>2],i[h>>2]=0,r&&X[i[h+4>>2]](r),R1(w),R1(s),s2(_),e2(A+476|0),v=A+480|0,e|0}function c6(A,e){return i[A+84>>2]=0,i[A+88>>2]=0,u[A+80|0]=0,u[A+68|0]=0,i[A+64>>2]=0,u[A+60|0]=0,u[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,u[A+12|0]=1,Q[A+10>>1]=2,Q[A+6>>1]=2,Q[A+8>>1]=2,u[A+4|0]=0,i[A+100>>2]=e,u[A+232|0]=0,i[A+92>>2]=0,i[A+96>>2]=4740,i[A>>2]=100584,Q[A+128>>1]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,Q[A+138>>1]=0,Q[A+140>>1]=0,Q[A+142>>1]=0,Q[A+144>>1]=0,i[A+148>>2]=0,i[A+152>>2]=0,u[A+156|0]=0,i[A+160>>2]=0,i[A+164>>2]=0,u[A+168|0]=0,i[A+236>>2]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+248>>2]=0,i[A+252>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,u[A+272|0]=1,i[A+344>>2]=0,i[A+348>>2]=0,i[A+352>>2]=0,u[A+281|0]=0,u[A+282|0]=0,u[A+283|0]=0,u[A+284|0]=0,u[A+285|0]=0,u[A+286|0]=0,u[A+287|0]=0,u[A+288|0]=0,i[A+276>>2]=0,i[A+280>>2]=0,u[A+336|0]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+312>>2]=0,i[A+316>>2]=0,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,Q[A+356>>1]=1,i[A+368>>2]=0,i[A+372>>2]=0,i[A+360>>2]=0,i[A+364>>2]=0,i[A+384>>2]=0,i[A+388>>2]=1072693248,i[A+176>>2]=0,i[A+180>>2]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,i[A+208>>2]=0,i[A+212>>2]=0,i[A+216>>2]=0,i[A+220>>2]=0,i[A+224>>2]=0,i[A+228>>2]=0,i[A+416>>2]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+432>>2]=0,i[A+436>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,A}function IZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;A=v-176|0,v=A,t=A+172|0,o=i[f+28>>2],i[t>>2]=o,(o|0)!=129624&&(i[o+4>>2]=i[o+4>>2]+1),W=c0(t,129808),l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127,t&&(l[n+11|0]>>>7|0?t=i[n>>2]:t=n,g=l[t|0]==(X[i[i[W>>2]+28>>2]](W,45)&255)),t=v-16|0,v=t,_=A+152|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+140|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,t=v-16|0,v=t,w=A+128|0,i[w>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0,v=t+16|0,Wt(r,g,A+172|0,A+168|0,A+167|0,A+166|0,_,s,w,A+124|0),i[A+16>>2]=2071,r=A+16|0,h=g1(A+8|0,0,r);i:{l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127;e:{if((t|0)>i[A+124>>2]){l[n+11|0]>>>7|0?o=i[n+4>>2]:o=l[n+11|0]&127,t=i[A+124>>2],l[s+11|0]>>>7|0?B=i[s+4>>2]:B=l[s+11|0]&127,l[w+11|0]>>>7|0?m=i[w+4>>2]:m=l[w+11|0]&127,t=(t+(B+(m+(o-t<<1)|0)|0)|0)+1|0;break e}B=i[A+124>>2],l[w+11|0]>>>7|0?t=i[w+4>>2]:t=l[w+11|0]&127,l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127,t=(B+(t+o|0)|0)+2|0}if(t>>>0<101||(r=p2(t),t=i[h>>2],i[h>>2]=r,t&&X[i[h+4>>2]](t),r=i[h>>2],r))break i;Q1(),H()}return B=A+4|0,m=i[f+4>>2],l[n+11|0]>>>7|0?t=i[n>>2]:t=n,o=t,l[n+11|0]>>>7|0?t=i[n>>2]:t=n,l[n+11|0]>>>7|0?n=i[n+4>>2]:n=l[n+11|0]&127,P9(r,B,A,m,o,t+n|0,W,g,A+168|0,u[A+167|0],u[A+166|0],_,s,w,i[A+124>>2]),e=O8(e,r,i[A+4>>2],i[A>>2],f,k),r=i[h>>2],i[h>>2]=0,r&&X[i[h+4>>2]](r),s2(w),s2(s),s2(_),e2(A+172|0),v=A+176|0,e|0}function An(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;k=v-16|0,v=k;i:{f=i[A+4>>2];e:{if(f>>>0<e>>>0){t=e-f|0,n=i[A+8>>2],r=n<<5;r:{if(!(t>>>0>r>>>0|f>>>0>r-t>>>0)){i[A+4>>2]=e,r=f&31,e=i[A>>2]+(f>>>3&536870908)|0;break r}if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,(e|0)<0)break i;f:{if(r>>>0<=1073741822?(r=n<<6,e=e+31&-32,e=e>>>0<r>>>0?r:e):e=2147483647,e>>>0<=i[k+12>>2]<<5>>>0)break f;if((e|0)>=0){m=(e-1>>>5|0)+1|0,n=E(m<<2),r=i[k+4>>2],w=i[k+8>>2];A:{k:{if(w>>>0>=33){i[n+(w-1>>>3&536870908)>>2]=0;break k}if(i[n>>2]=0,!w)break A}for(W=w&31,g=r+(w>>>3&536870908)|0,e=n,o=r,f=r;s=1<<B,i[f>>2]>>>_&1?s=s|i[e>>2]:s=i[e>>2]&(s^-1),i[e>>2]=s,h=f+4|0,s=(_|0)==31,o=s?h:o,f=s?h:f,h=(B|0)==31,f=h?o:f,B=h?0:B+1|0,e=(h?4:0)+e|0,_=s?0:_+1|0,!!((W|0)!=(_|0)|(f|0)!=(g|0)););}if(i[k+12>>2]=m,i[k+8>>2]=w,i[k+4>>2]=n,!r)break f;Z(r);break f}G0(),H()}r=i[A+4>>2],i[k+8>>2]=r+t,f=i[A>>2],e=i[k+4>>2];f:{if((r|0)<=0){r=0;break f}n=r>>>5|0;A:{if(r>>>0<32||(o=n<<2,!o))break A;z(e,f,o)}n=n<<2,e=n+e|0,r=r&31,r&&(o=-1>>>32-r|0,i[e>>2]=i[e>>2]&(o^-1)|o&i[f+n>>2]),f=i[A>>2]}if(i[A>>2]=i[k+4>>2],i[k+4>>2]=f,n=i[A+4>>2],i[A+4>>2]=i[k+8>>2],i[k+8>>2]=n,n=i[A+8>>2],i[A+8>>2]=i[k+12>>2],i[k+12>>2]=n,!f)break r;Z(f)}r&&(A=32-r|0,f=A>>>0>t>>>0?t:A,i[e>>2]=i[e>>2]&(-1<<r&-1>>>A-f^-1),t=t-f|0,e=e+4|0),A=t>>>5|0;r:{if(t>>>0<32||(r=A<<2,!r))break r;o0(e,0,r)}if(r=t&31,!r)break e;A=(A<<2)+e|0,i[A>>2]=i[A>>2]&(-1>>>32-r^-1);break e}i[A+4>>2]=e}v=k+16|0;return}G0(),H()}function T1(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=100584,e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),r=i[A+424>>2],r){if(e=r,f=i[A+428>>2],(e|0)!=(f|0)){for(;u[f-1|0]<0&&Z(i[f-12>>2]),f=f-20|0,(r|0)!=(f|0););e=i[A+424>>2]}i[A+428>>2]=r,Z(e)}if(e=i[A+276>>2],e&&(i[A+280>>2]=e,Z(e)),r=i[A+260>>2],r){if(e=r,f=i[A+264>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+260>>2]}i[A+264>>2]=r,Z(e)}if(r=i[A+248>>2],r){if(e=r,f=i[A+252>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+248>>2]}i[A+252>>2]=r,Z(e)}u[A+247|0]<0&&Z(i[A+236>>2]),e=i[A+164>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+152>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=i[A+132>>2],r){if(e=r,f=i[A+136>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+132>>2]}i[A+136>>2]=r,Z(e)}if(r=i[A+104>>2],r){if(e=r,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=r,Z(e)}return u[A+95|0]<0&&Z(i[A+84>>2]),PA(A)|0}function zf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=i[A+40>>2],r&&(u[r+128|0]=0),r=i[e>>2],u[r+128|0]=1,f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+40>>2]=r,r=i[A+44>>2],i[A+44>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(o=i[i[e>>2]+116>>2],r=i[A+48>>2],A=i[r+92>>2],!A){k=r+92|0,A=E(128),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=89892,e=A+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[A+60>>2]=0,i[A+64>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+72>>2]=-1,i[A+76>>2]=-1,i[A+80>>2]=-1,i[A+84>>2]=-1,i[A+116>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,Q[A+112>>1]=0,i[e>>2]=87252,i[A+32>>2]=1885959277,i[A+120>>2]=0,i[r+92>>2]=e,e=i[r+96>>2],i[r+96>>2]=A;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}f=v-16|0,v=f,n=i[r+44>>2],e=i[n+36>>2],A=i[n+40>>2];i:{if((e|0)!=(A|0))for(;;){e:{if(t=i[e>>2],!t||!X0(t,86628,87312))break e;if(A=i[e+4>>2],!A|i[A+4>>2]!=-1||(X[i[i[A>>2]+8>>2]](A),p(A)),A=i[k>>2],k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e>>2]=A,A=i[e+4>>2],i[e+4>>2]=k,!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A);break i}if(e=e+8|0,(A|0)==(e|0))break}i[f+8>>2]=i[k>>2],A=i[k+4>>2],i[f+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),r2(n+36|0,f+8|0),A=i[f+12>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}}v=f+16|0,A=i[r+92>>2]}i[A+104>>2]=o}function kn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,bi(k+80|0,e);i:{e:{r:{f:switch(l[k+100|0]){case 1:if(e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,A=A+8|0,u[k+99|0]<0)break e;e=k+88|0,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i;case 0:break f;default:break r}if(X[i[i[e>>2]+108>>2]](k+8|0,e),l[k+100|0])break r;for(o=i[k+84>>2];;){if(t=o,(t|0)==i[k+80>>2]){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}o=t-8|0,e=i[o>>2];f:{if(!e)break f;if(n=X0(e,86628,87940),n){e=i[t-4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);A:{k:{if(n=i[n+100>>2],(n|0)!=270){if((n|0)==180)break k;if((n|0)!=90)break A;n=i[f>>2],s=i[k+12>>2],i[f>>2]=i[r>>2],i[r>>2]=(n^-1)+s;break A}n=i[f>>2],i[f>>2]=i[k+16>>2]+(i[r>>2]^-1),i[r>>2]=n;break A}i[r>>2]=i[k+12>>2]+(i[r>>2]^-1),i[f>>2]=i[k+16>>2]+(i[f>>2]^-1)}A:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break A;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[o>>2],!e)break f}if(e=X0(e,86628,88020),!e)break f;t=i[t-4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);A:{k:{n:switch(i[e+100>>2]){case 1:n=i[k+12>>2],e=r;break k;case 0:break n;default:break A}n=i[k+16>>2],e=f}i[e>>2]=(i[e>>2]^-1)+n}if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break f;X[i[i[t>>2]+8>>2]](t),p(t)}if(l[k+100|0])break}}_2(),H()}T(A,i[k+88>>2],i[k+92>>2])}A=l[k+100|0],(A|0)!=255&&(e=i[25191],i[k+8>>2]=i[25190],i[k+12>>2]=e,X[i[(k+8|0)+(A<<2)>>2]](k+111|0,k+80|0)),v=k+112|0}function CZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(f+8|0,32394,20),k=i[i[n>>2]-12>>2]+n|0,i[k+4>>2]=i[k+4>>2]|1,n=Y(li(n,l[e+104|0]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],s=(k|0)<0,Y(n,s?i[f+148>>2]:o,s?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(li(Y(n,32224,17),l[e+105|0]),42713,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(n,32296,17),l[e+106|0]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function VZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),u[f+148|0]=39,k=f+148|0,n=Y(f+8|0,k,1),P1(k,i[e+100>>2]),o=n,s=k,k=u[f+159|0],n=(k|0)<0,o=Y(Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),30348,15),k=u[e+123|0],n=(k|0)<0,Y(Y(o,n?i[e+112>>2]:e+112|0,n?i[e+116>>2]:k),42713,1),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,29279,10);i:{e:switch(i[e+124>>2]){case 0:Y(f+8|0,33242,6);break i;case 1:Y(f+8|0,33429,10);break i;case 2:break e;default:break i}Y(f+8|0,33249,9)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function nn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(I0(Y(f+8|0,32163,10),i[e+104>>2]),42713,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(k,30290,12),r=i[e+108>>2],k=i[e+112>>2];i:{if((r|0)==(k|0)||(I0(f+8|0,i[r>>2]),e=r+4|0,(k|0)==(e|0)))break i;for(;r=i[e>>2],u[f+148|0]=32,n=f+8|0,Y(n,f+148|0,1),I0(n,r),e=e+4|0,(k|0)!=(e|0););}Y(f+8|0,42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function Gr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=E(r),r&&o0(f,0,r),k=r+f|0,i[t+12>>2]=k,i[t+8>>2]=k,i[t+4>>2]=f}r&&z(f,e,r),f=v-16|0,v=f,k=t+4|0,s=i[k>>2],e=l[s|0]>>>1|0;e:{r:{f:{if(r=i[A+132>>2],n=i[A+136>>2],(r|0)!=(n|0))for(;;){if((e|0)==l[r+1|0]){if(n=i[r+4>>2],e=i[r+8>>2],(n|0)!=(e|0))for(h=i[k+4>>2],o=h-s|0;;){if(A=0,_=i[n>>2],w=i[n+4>>2]-_|0,B=o>>>0<w>>>0?o:w,!B)break r;for(;;){if(l[A+_|0]==l[A+s|0]){if(A=A+1|0,(B|0)!=(A|0))continue;break r}break}if(n=n+12|0,(e|0)==(n|0))break}if(e>>>0<u0[r+12>>2]){if(i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,A=i[k+4>>2],n=i[k>>2],(A|0)!=(n|0)){if(A=A-n|0,(A|0)<0)break f;k=E(A),i[e+4>>2]=k,i[e>>2]=k,o=A+k|0,i[e+8>>2]=o,A&&z(k,n,A),i[e+4>>2]=o}i[r+8>>2]=e+12;break e}m=r,W=p6(r+4|0,k),i[m+8>>2]=W;break e}if(r=r+16|0,(n|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,u[f+1|0]=e,u[f|0]=1,r=p6(f+4|0,k),e=i[A+136>>2],i[f+8>>2]=r;A:{if(e>>>0<u0[A+140>>2]){r=F[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,Q[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],mA(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=Hn(A+132|0,f)}if(i[A+136>>2]=e,e=i[f+4>>2],!e)break e;if(r=i[f+8>>2],A=e,(r|0)!=(e|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(r|0)!=(e|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A);break e}G0(),H()}if((k|0)==(n|0)|o>>>0>=w>>>0)break e;d4(n,s,h,o)}v=f+16|0,A=i[t+4>>2],A&&(i[t+8>>2]=A,Z(A)),v=t+16|0;return}G0(),H()}function Tf(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;t=v-128|0,v=t;i:{if(!(r&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}i[r>>2]=0,w=i[i[e>>2]+116>>2],i[t+60>>2]=0,i[t+64>>2]=0,Q[t+68>>1]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,i[t+112>>2]=0,i[t+72>>2]=0,Q[t+48>>1]=8,i[t+52>>2]=0,i[t+56>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,u[t+88|0]=0,i[t+80>>2]=2,i[t+84>>2]=2,u[t+76|0]=1;e:{if(!n)break e;r:{f:{A:{k:{n:{t:{u:{o:switch(o=l[n|0],(o>>>0>=8?8:o)-1|0){case 0:break r;case 1:break f;case 2:break A;case 3:break k;case 4:break n;case 5:break t;case 6:break u;case 7:break o;default:break e}i[t+108>>2]=i[n+60>>2],i[t+112>>2]=i[n+64>>2],i[t+104>>2]=i[n+56>>2],i[t+100>>2]=i[n+52>>2]}i[t+96>>2]=i[n+48>>2]}i[t+92>>2]=i[n+44>>2]}s=i[n+32>>2],o=t+76|0,i[o>>2]=i[n+28>>2],i[o+4>>2]=s,s=i[n+40>>2],i[o+8>>2]=i[n+36>>2],i[o+12>>2]=s}i[t+72>>2]=i[n+24>>2]}u[t+69|0]=l[n+21|0]}u[t+68|0]=l[n+20|0]}u[t+49|0]=l[n+1|0],i[t+52>>2]=i[n+4>>2],i[t+56>>2]=i[n+8>>2],i[t+60>>2]=i[n+12>>2],i[t+64>>2]=i[n+16>>2]}o=i[e+8>>2],i[t+12>>2]=t+16,i[t+16>>2]=0,i[t+20>>2]=0,n=t+24|0,s=f,f=t+12|0,E9(n,o,w,s,k,t+48|0,0,0,0,f),Y1(f,i[t+16>>2]);e:switch(l[t+44|0]){default:_2(),H();case 0:k=i[t+24>>2],f=i[t+28>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=E(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,n=107712;break;case 1:break e}if(r=A,A=i[e>>2],b0(r,n,A?A+84|0:0),A=l[t+44|0],(A|0)==255)break i;e=i[24225],i[t+120>>2]=i[24224],i[t+124>>2]=e,X[i[(t+120|0)+(A<<2)>>2]](t+119|0,t+24|0)}v=t+128|0}function FZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(!(f&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],o=i[k+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!e3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3455;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,e,r,k+20|0);r:{if(i[k>>2]){i[t+8>>2]=0,i[t+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[t+12>>2],e=X0(e,86628,86684),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=X0(e,86628,86684),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[t+8>>2]=0,i[t+12>>2]=0}i[t+8>>2]=0,i[t+12>>2]=0;break r}if(i[t+12>>2]=s,i[t+8>>2]=e,e=i[n+4>>2],i[t+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[t+8>>2],e&&(r=E(24),i[f>>2]=r,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[t+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=t+16|0}function EZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,s0(k,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(f+8|0,30177,18),F[e+4>>1]),42713,1),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,30263,26),F[e+6>>1]),42713,1),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,29845,21),F[e+8>>1]),42713,1),k=f+148|0,s0(k,r),s=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:s,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(li(Y(n,31157,17),l[e+10|0]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function pZ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(A=v-144|0,v=A,i[A+136>>2]=r,i[A+140>>2]=e,i[A+20>>2]=2072,s=A+20|0,w=g1(A+24|0,A+32|0,s),o=A+16|0,e=i[k+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129808),u[A+15|0]=0,P7(A+140|0,r,f,o,i[k+4>>2],n,A+15|0,e,w,s,A+132|0)){r=v-16|0,v=r;i:if(l[t+11|0]>>>7|0)break i;i:{if(l[t+11|0]>>>7|0){f=i[t>>2],u[r+15|0]=0,u[f|0]=l[r+15|0],i[t+4>>2]=0;break i}u[r+14|0]=0,u[t|0]=l[r+14|0],u[t+11|0]=l[t+11|0]&128,u[t+11|0]=l[t+11|0]&127}for(v=r+16|0,l[A+15|0]==1&&oi(t,X[i[i[e>>2]+28>>2]](e,45)|0),e=X[i[i[e>>2]+28>>2]](e,48)|0,r=i[w>>2],s=i[A+20>>2],f=s-1|0,e=e&255;;){if(!((e|0)!=l[r|0]|r>>>0>=f>>>0)){r=r+1|0;continue}break}f=v-16|0,v=f,l[t+11|0]>>>7|0?k=i[t+4>>2]:k=l[t+11|0]&127,o=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:10,h=s-r|0;i:{if(!h)break i;if(l[t+11|0]>>>7|0?e=i[t>>2]:e=t,B=e,l[t+11|0]>>>7|0?e=i[t>>2]:e=t,l[t+11|0]>>>7|0?_=i[t+4>>2]:_=l[t+11|0]&127,!Al(B,(e+_|0)+1|0,r)){h>>>0>o-k>>>0&&uA(t,o,h+(k-o|0)|0,k,k),l[t+11|0]>>>7|0?e=i[t>>2]:e=t,e=e+k|0,o=s-r|0,s=!o,s|s||z(e,r,o),u[f+15|0]=0,u[e+o|0]=l[f+15|0],x6(t,k+h|0);break i}e=v-16|0,v=e,fu(f,r,s),v=e+16|0,l[f+11|0]>>>7|0?e=i[f>>2]:e=f,l[f+11|0]>>>7|0?r=i[f+4>>2]:r=l[f+11|0]&127,pA(t,e,r),s2(f)}v=f+16|0}return P2(A+140|0,A+136|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+140>>2],e2(A+16|0),e=i[w>>2],i[w>>2]=0,e&&X[i[w+4>>2]](e),v=A+144|0,r|0}function yZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,30687,22),i[e+100>>2]),42713,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,29576,17),F[e+104>>1]),42713,1),n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,29319,17),F[e+106>>1]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function YZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(f+8|0,32163,10),i[e+104>>2]),42713,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],s=(k|0)<0,Y(n,s?i[f+148>>2]:o,s?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(n,32653,15),i[i[e+108>>2]>>2]),42713,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,32636,16),i[i[e+108>>2]+4>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function RZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(S0(Y(S0(Y(S0(Y(k,31542,16),i[e+100>>2]),22226,1),i[e+104>>2]),27517,3),i[e+108>>2]),22226,1),i[e+112>>2]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(S0(Y(S0(Y(f+8|0,29760,8),i[e+116>>2]),22226,1),i[e+120>>2]),29232,3),i[e+124>>2]),22226,1),i[e+128>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function JZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,s=R0(k),i[s>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),t=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(t,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,19216,1),n),41737,2),i[r>>2]=i[r>>2]+1,t=f+148|0,o=i[i[e+104>>2]+(n<<3)>>2],X[i[i[o>>2]+12>>2]](t,o,r),o=k,w=t,k=u[f+159|0],t=(k|0)<0,Y(o,t?i[f+148>>2]:w,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[r>>2],i[r>>2]=((k|0)<=1?1:k)-1,n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],r=e-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[s>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(s),p0(f- -64|0),v=f+160|0}function NZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;o=v-48|0,v=o;i:{e:{if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break e}i[f>>2]=0,k=i[e>>2],i[o+44>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,t=i[k+248>>2],s=i[k+252>>2];r:{if((t|0)!=(s|0)){if(k=s-t|0,(k|0)<0)break i;for(n=E(k),i[o+36>>2]=n,i[o+44>>2]=k+n,k=n;i[k>>2]=i[t>>2],w=k,k=i[t+4>>2],i[w+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=w+8|0,t=t+8|0,(s|0)!=(t|0););for(i[o+40>>2]=k,t=n;;){if(s=i[t>>2],i[s+116>>2]==(r|0)){r=E(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[t+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;X[i[i[n>>2]+8>>2]](n),p(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}r=A,A=i[e>>2],b0(r,107712,A?A+84|0:0),n=i[o+36>>2];break r}if(k=(t|0)!=(w|0),t=t+8|0,!k)break}}if(u[o+4|0]=0,u[o+15|0]=0,r=K(o+16|0,5,2e3,o+4|0),u[o+15|0]<0&&Z(i[o+4>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,t=i[o+40>>2],(t|0)!=(n|0)){for(;;){A=i[t-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(t=t-8|0,(t|0)==(n|0))break}A=i[o+36>>2]}i[o+40>>2]=n,Z(A)}v=o+48|0;return}G0(),H()}function MZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;w=v-16|0,v=w,t=v-32|0,v=t,s=i[e+8>>2],Z8(t+24|0,i[s+48>>2],1919377774),n=i[t+24>>2],u[n+164|0]=1,i[n+100>>2]=i[n+100>>2]&-2|1,o=i[i[t+24>>2]+104>>2],n=E(36),i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+20>>2]=f,i[n+16>>2]=r,i[n+12>>2]=o,i[n>>2]=94512,i[n+4>>2]=0,i[n+8>>2]=0,i[w+12>>2]=n,r=n+12|0,i[w+8>>2]=r,i[t+20>>2]=n,i[t+16>>2]=r,i[n+4>>2]=i[n+4>>2]+1,r=i[t+20>>2],i[t+8>>2]=i[t+16>>2],i[t+12>>2]=r;i:{if(r=i[s+160>>2],o=i[s+164>>2],r>>>0<o>>>0){i[r>>2]=i[t+8>>2],i[r+4>>2]=i[t+12>>2],i[s+160>>2]=r+8;break i}e:{if(n=i[s+156>>2],r=r-n|0,_=r>>3,f=_+1|0,f>>>0<536870912){if(o=o-n|0,h=o>>2,o=o>>>0>=2147483640?536870911:f>>>0<h>>>0?h:f,o){if(o>>>0>=536870912)break e;f=E(o<<3)}else f=0;h=f+r|0,i[h>>2]=i[t+8>>2],i[h+4>>2]=i[t+12>>2],_=h-(_<<3)|0,r&&z(_,n,r),i[s+164>>2]=f+(o<<3),r=h+8|0,i[s+160>>2]=r,i[s+156>>2]=_,n&&Z(n),i[s+160>>2]=r;break i}G0(),H()}x0(),H()}r=i[t+28>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=t+32|0,ku(i[e>>2],i[i[w+8>>2]>>2]);i:{if(k){r=E(16),f=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,e=i[w+12>>2],i[r+8>>2]=i[w+8>>2],i[r+12>>2]=e,i[k>>2]=r,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;break i}if(e=i[w+12>>2],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r,i[A+8>>2]=i[24070],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=w+16|0}function UZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;o=v-48|0,v=o;i:{e:{if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break e}k=i[e>>2],i[o+44>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,t=i[k+132>>2],s=i[k+136>>2];r:{if((t|0)!=(s|0)){if(k=s-t|0,(k|0)<0)break i;for(n=E(k),i[o+36>>2]=n,i[o+44>>2]=k+n,k=n;i[k>>2]=i[t>>2],w=k,k=i[t+4>>2],i[w+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=w+8|0,t=t+8|0,(s|0)!=(t|0););for(i[o+40>>2]=k,t=n;;){if(s=i[t>>2],i[s+116>>2]==(r|0)){r=E(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[t+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;X[i[i[n>>2]+8>>2]](n),p(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;X[i[i[r>>2]+8>>2]](r),p(r)}r=A,A=i[e>>2],b0(r,107712,A?A+84|0:0),n=i[o+36>>2];break r}if(k=(t|0)!=(w|0),t=t+8|0,!k)break}}if(u[o+4|0]=0,u[o+15|0]=0,r=K(o+16|0,5,2e3,o+4|0),u[o+15|0]<0&&Z(i[o+4>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,t=i[o+40>>2],(t|0)!=(n|0)){for(;;){A=i[t-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(t=t-8|0,(t|0)==(n|0))break}A=i[o+36>>2]}i[o+40>>2]=n,Z(A)}v=o+48|0;return}G0(),H()}function DZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0;for(m=v-16|0,v=m,s=r;;){i:{if((f|0)==(s|0)){s=f;break i}if(!i[s>>2])break i;s=s+4|0;continue}break}i[o>>2]=n,i[k>>2]=r;i:{for(;;){e:{r:{if(!((r|0)==(f|0)|(n|0)==(t|0))){w=i[e+4>>2],i[m+8>>2]=i[e>>2],i[m+12>>2]=w,V=1,W=v-16|0,v=W,i[W+12>>2]=i[A+8>>2],y=s8(W+8|0,W+12|0),w=n,h=t-w|0,g=0,I=v-16|0,v=I,_=i[k>>2],C=s-r>>2;f:{if(!_|!C)break f;for(h=w?h:0;;){if(B=Or(h>>>0<4?I+12|0:w,i[_>>2]),(B|0)==-1){g=-1;break f}if(w){if(h>>>0<=3){if(h>>>0<B>>>0)break f;A8(w,I+12|0,B)}h=h-B|0,w=w+B|0}else w=0;if(!i[_>>2]){_=0;break f}if(g=g+B|0,_=_+4|0,C=C-1|0,!C)break}}w&&(i[k>>2]=_),v=I+16|0,w=i[y>>2],w&&(i[31378]=(w|0)==-1?125392:w),v=W+16|0;f:{A:{k:switch(g+1|0){case 0:for(i[o>>2]=n;;){if(i[k>>2]==(r|0)||(e=ek(n,i[r>>2],i[A+8>>2]),(e|0)==-1))break A;n=e+i[o>>2]|0,i[o>>2]=n,r=r+4|0}case 1:break i;default:break k}if(n=i[o>>2]+g|0,i[o>>2]=n,(n|0)==(t|0))break f;if((f|0)==(s|0)){r=i[k>>2],s=f;continue}if(r=m+4|0,s=ek(r,0,i[A+8>>2]),(s|0)==-1)break e;if(t-i[o>>2]>>>0<s>>>0)break i;for(;;){if(s){n=l[r|0],w=i[o>>2],i[o>>2]=w+1,u[w|0]=n,s=s-1|0,r=r+1|0;continue}break}for(r=i[k>>2]+4|0,i[k>>2]=r,s=r;;){if((f|0)==(s|0)){s=f;break r}if(!i[s>>2])break r;s=s+4|0}}i[k>>2]=r;break e}r=i[k>>2]}V=(r|0)!=(f|0);break i}n=i[o>>2];continue}break}V=2}return v=m+16|0,V|0}function HZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92092,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92132,u[f+159|0]=5,i[f+32>>2]=1781689193,u[f+152|0]=l[19600],t=l[19596]|l[19597]<<8|(l[19598]<<16|l[19599]<<24),u[f+148|0]=t,u[f+149|0]=t>>>8,u[f+150|0]=t>>>16,u[f+151|0]=t>>>24,o=i[r>>2],s=i[r+4>>2];i:{if((o|0)!=(s|0))for(t=f+52|0;;){r=i[o>>2],i[n+8>>2]=r,k=i[o+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(r2(t,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;X[i[i[k>>2]+8>>2]](k),p(k)}if(o=o+8|0,(s|0)==(o|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function tn(A,e){var r=0;i[A>>2]=0,i[A+4>>2]=0,u[A+28|0]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,e=E(160),i[e>>2]=94012,i[e+4>>2]=0,i[e+8>>2]=0,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[r>>2]=106076,u[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+32>>2]=1935763834,i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;X[i[i[r>>2]+8>>2]](r),p(r)}e=E(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94052,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[r>>2]=106156,u[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+32>>2]=1935763823,i[A+8>>2]=r,r=i[A+12>>2],i[A+12>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;X[i[i[r>>2]+8>>2]](r),p(r)}return A}function un(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0;r=i[A+4>>2],t=i[r+124>>2],i[A+24>>2]=t,h=i[r+132>>2],i[A+28>>2]=h;i:{if(!i[A+12>>2]){_=1,f=1;break i}_=i[t+16852>>2],f=i[t+16856>>2]}i[A+300>>2]=f,i[A+296>>2]=_,I=G(i[A+20>>2],f),C=i[t+16892>>2],o=i[t+16876>>2],e=i[A+16>>2],V=G(e,_),V||(u[A+307|0]=0,u[A+304|0]=0),I||(u[A+307|0]=0,u[A+305|0]=0,u[A+306|0]=0),R=i[A+8>>2],k=G(e+R|0,_),(k|0)>=i[t+484>>2]&&(u[A+306|0]=0),s=i[r+152>>2],B=I>>o,x=G(G(s,B),24),W=V>>o,e=G(W,24),n=i[r+140>>2],N=-1,y=V-1>>o,D=-1,g=l[A+304|0],D=(g|0)==1?F[(n+G(y,24)|0)+x>>1]:D,w=e+n|0,m=I-1>>o,r=l[A+305|0],N=(r|0)==1?F[w+G(G(s,m),24)>>1]:N,S=k>>o,O=-1,o=-1,k=l[A+306|0],(k|0)==1&&(o=F[(n+G(S,24)|0)+G(G(s,m),24)>>1]),e=l[A+307|0],(e|0)==1&&(O=F[(n+G(y,24)|0)+G(G(s,m),24)>>1]),s=G(B,C)<<2,n=i[h+8484>>2],h=-1,B=-1,B=g?i[s+(n+(y<<2)|0)>>2]:B,W=n+(W<<2)|0,h=r?i[W+(G(m,C)<<2)>>2]:h,g=-1,r=-1,e&&(r=i[(n+(y<<2)|0)+(G(m,C)<<2)>>2]),w=F[w+x>>1],k&&(g=i[(n+(S<<2)|0)+(G(m,C)<<2)>>2]),e=i[s+W>>2],(w|0)==(D|0)&(e|0)==(B|0)||(u[A+304|0]=0),(w|0)==(N|0)&(e|0)==(h|0)||(u[A+305|0]=0),(w|0)==(O|0)&(e|0)==(r|0)||(u[A+307|0]=0),(o|0)==(w|0)&(e|0)==(g|0)||(u[A+306|0]=0),f=(i[t+488>>2]+((I^-1)+f|0)|0)/(f|0)|0,k=R<<1,i[A+308>>2]=(k|0)>(f|0)?f:k,e=i[t+484>>2],i[A+316>>2]=0,f=A+160|0,i[A+292>>2]=f,r=A,A=(e+((V^-1)+_|0)|0)/(_|0)|0,i[r+312>>2]=(A|0)<(k|0)?A:k,A=R<<2|1,A&&o0(f-k|0,0,A)}function xZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{if((e|0)>=12){if(f=l[A+8|0],!f||(e=l[A+9|0],!e)||(r=l[A+10|0],!r)||(k=l[A+11|0],!k))break u;if(e=e<<16|f<<24|r<<8|k,(e|0)<=1751479906){if(r=e-1751476579|0,r>>>0>21|!(1<<r&2163713))break o;return 18065}if((e|0)<=1781688690){if(e=e-1751479907|0,e>>>0>21)break u;if(1<<e&2163713)break l;break u}s:{if((e|0)<=1835623984){if((e|0)==1781688691)break s;if((e|0)!=1781689193)break u;return 10531}if((e|0)!=1836279345){if((e|0)!=1835623985)break u;return 11353}return 15246}return 5139}if((e|0)<8)break i;e=l[A|0];break e}return 15266}o:switch(e-1635148649|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:break u;case 0:break k;case 10:break A;default:break o}if(e=e-1635150182|0,!e)break t;if((e|0)==13)break n}if(e=l[A|0],(e|0)!=255)break e;if(l[A+1|0]!=216|l[A+2|0]!=255)break i;switch(l[A+3|0]-224|0){case 0:break f;case 1:break r;default:break i}}return 11342}return 15226}return 10562}return 5957}if(l[A+4|0]|l[A+5|0]!=16|(l[A+6|0]!=74|l[A+7|0]!=70)||(f|0)!=73|l[A+9|0]!=70|(l[A+10|0]|l[A+11|0]!=1))break i;return 11266}if(l[A+6|0]!=69|l[A+7|0]!=120|((f|0)!=105|l[A+9|0]!=102)||l[A+10|0]|l[A+11|0])break i;return 11266}if((e&255)!=137|l[A+1|0]!=80|(l[A+2|0]!=78|l[A+3|0]!=71)||l[A+4|0]!=13|l[A+5|0]!=10|(l[A+6|0]!=26|l[A+7|0]!=10))break i;return 10941}return 42716}function Wr(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,29360,5),n=f+148|0,ie(n,e),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=X[i[i[e>>2]+8>>2]](e)|0;i:{if(k){Y(Y(Y(f+8|0,27184,8),k,h2(k)),42712,2);break i}Y(f+8|0,42340,7)}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(K2(Y(f+8|0,31363,6),i[e+8>>2],i[e+12>>2]),31265,17),i[e+32>>2]),42712,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function zZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,f=i[A+8>>2],i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{n=i[f+12>>2],s=i[f+16>>2];f:{if((n|0)==(s|0)){f=0;break f}if(f=s-n|0,(f|0)<0)break r;for(k=E(f),i[t+4>>2]=k,i[t+12>>2]=f+k,f=k;i[f>>2]=i[n>>2],o=i[n+4>>2],i[f+4>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),f=f+8|0,n=n+8|0,(s|0)!=(n|0););i[t+8>>2]=f}if(f=f-k>>3,o=(r|0)>(f|0)?f:r,(o|0)<=0)break i;for(n=0;;){r=E(24),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,f=i[A>>2],k=i[A+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=f;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=f,f=i[r+4>>2],i[r+4>>2]=k,!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[A+8>>2],k=i[A+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+8>>2]=f,f=i[r+12>>2],i[r+12>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[t+4>>2]+(n<<3)|0,s=i[f>>2],k=i[f+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+16>>2]=s,f=i[r+20>>2],i[r+20>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;X[i[i[f>>2]+8>>2]](f),p(f)}if(i[(n<<2)+e>>2]=r,n=n+1|0,(o|0)==(n|0))break}break e}G0(),H()}k=i[t+4>>2]}if(k){if(f=i[t+8>>2],(k|0)!=(f|0)){for(;;){A=i[f-4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(f=f-8|0,(k|0)==(f|0))break}k=i[t+4>>2]}Z(k)}return v=t+16|0,o|0}function TZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;f=v-80|0,v=f,i[f+76>>2]=0,i[f+72>>2]=0,g9(f+60|0,e,r,f+76|0,f+72|0);i:{if(i[f+60>>2]){e=i[f+64>>2],i[A>>2]=i[f+60>>2],i[A+4>>2]=e,i[A+8>>2]=i[f+68>>2];break i}e:{if((r|0)<12||(r=l[e+8|0],!r)||(n=l[e+9|0],!n)||(o=l[e+10|0],!o)||(e=l[e+11|0],!e))break e;k=e|(n<<16|r<<24|o<<8)}e=i[13089],i[f+40>>2]=i[13088],i[f+44>>2]=e,e=i[13087],i[f+32>>2]=i[13086],i[f+36>>2]=e,e=i[13085],i[f+24>>2]=i[13084],i[f+28>>2]=e,e=i[13083],i[f+16>>2]=i[13082],i[f+20>>2]=e,e=i[13081],i[f+8>>2]=i[13080],i[f+12>>2]=e,i[f+52>>2]=0,i[f+56>>2]=0,n=f+52|0,i[f+48>>2]=n,e=i[13079],i[f>>2]=i[13078],i[f+4>>2]=e,e=f+48|0,fe(e,f,e);e:{r:{o=i[f+52>>2];f:{A:{k:{if(o){for(r=n,e=o;s=r,w=e,t=u0[e+16>>2]<k>>>0,r=t?r:e,e=i[(t?4:0)+e>>2],!!e;);if((r|0)!=(n|0)&u0[(t?s:w)+16>>2]<=k>>>0)break r;if(k=i[f+76>>2],_=i[f+72>>2],(_|0)<=0)break k;for(t=0;;){for(B=i[(t<<2)+k>>2],r=n,e=o;s=r,w=e,h=u0[e+16>>2]<B>>>0,r=h?r:e,e=i[(h?4:0)+e>>2],!!e;);if(!((r|0)==(n|0)|u0[(h?s:w)+16>>2]>B>>>0)){Z(k),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;break e}if(t=t+1|0,(_|0)==(t|0))break}break A}k=i[f+76>>2]}if(!k)break f}Z(k)}i[A>>2]=2,i[A+4>>2]=3001,i[A+8>>2]=25728;break e}e=i[f+76>>2],e&&Z(e),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}Y1(f+48|0,i[f+52>>2])}v=f+80|0}function _4(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;W=i[A+18592>>2],_=A+18548|0,h=v2(_,i[A+18572>>2]+147|0),B=h<<4&16|l[A+26|0]&-17,u[A+26|0]=B,g=A+16|0;i:{e:{if(h){h=0;r:{if(i[i[A+18592>>2]+812>>2]<2||!v2(_,i[A+18572>>2]+148|0)||(h=32,i[i[A+18592>>2]+812>>2]<3))break r;for(h=1;k4(_)&&(h=h+1|0,(h|0)<(i[i[A+18592>>2]+812>>2]-1|0)););h=h<<5}o=l[A+26|0]&31|h;break e}h=1;r:{f:{A:{if(!i[W+28>>2]){if(h=i[A+18572>>2],(n+t|0)==12||!v2(_,(o+h|0)+156|0))break A;B=l[A+26|0],h=3}u[A+26|0]=B&252|h;break f}if(h=v2(_,h+160|0)+1|0,u[A+26|0]=h&3|l[A+26|0]&252,B=2,(h|0)==2)break r}B=h,h=0,o=i[W+336>>2];f:{if((o|0)<2||!v2(_,i[A+18572>>2]+154|0))break f;if(m=o-2|0,!m){h=1;break f}if(h=1,!v2(_,i[A+18572>>2]+155|0))break f;for(o=o-1|0;;){if((h|0)==(m|0)){h=o;break f}if(h=h+1|0,!k4(_))break}}if(u[A+16|0]=h,ju(A,0),I=A,C=v2(_,i[A+18572>>2]+152|0)<<2&4|l[A+26|0]&251,u[I+26|0]=C,(B|0)==1)break i}h=0,o=i[W+340>>2];r:{if((o|0)<2||!v2(_,i[A+18572>>2]+154|0))break r;if(m=o-2|0,!m){h=1;break r}if(h=1,!v2(_,i[A+18572>>2]+155|0))break r;for(o=o-1|0;;){if((h|0)==(m|0)){h=o;break r}if(h=h+1|0,!k4(_))break}}u[A+17|0]=h;r:{if(!(!l[W+378|0]|(B|0)!=3)){Q[A+22>>1]=0,Q[A+24>>1]=0;break r}ju(A,1)}o=v2(_,i[A+18572>>2]+152|0)<<3&8|l[A+26|0]&-9}u[A+26|0]=o}Y7(i[A+18584>>2],i[A+18592>>2],i[A+18588>>2],g,e,r,f,k,s,n,t,w)}function T0(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0;o=v+-64|0,v=o,i[o+40>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,Q[o+28>>1]=256,i[o+24>>2]=1,w=o+24|0,h=k,s=i[e+120>>2],k=(n|0)==24&&(s|0)==10?8:n,n=(s|0)==11&&(k|0)==32?8:k,k=1;i:{e:switch(s|0){case 10:case 12:case 14:k=3;break i;case 11:case 13:case 15:k=4;break i;case 0:case 1:case 2:case 3:case 99:break i;default:break e}k=0}kr(o,w,f,h,1,n,k,t,e+136|0);i:{if(i[o>>2]){e=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+16>>2],e=i[o+12>>2],i[A+8>>2]=i[o+8>>2],i[A+12>>2]=e,i[o+16>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0;break i}f=i[e+128>>2];e:{r:{if(!f){t=e+128|0,n=t;break r}for(;;){if(n=f,f=i[f+16>>2],(f|0)>(r|0)){if(t=n,f=i[n>>2],f)continue;break r}if((r|0)<=(f|0))break e;if(f=i[n+4>>2],!f)break}t=n+4|0}f=E(60),i[f+16>>2]=r,r=i[o+28>>2],i[f+20>>2]=i[o+24>>2],i[f+24>>2]=r,r=i[o+36>>2],i[f+28>>2]=i[o+32>>2],i[f+32>>2]=r,r=i[o+44>>2],i[f+36>>2]=i[o+40>>2],i[f+40>>2]=r,r=i[o+52>>2],i[f+44>>2]=i[o+48>>2],i[f+48>>2]=r,r=i[o+60>>2],i[f+52>>2]=i[o+56>>2],i[f+56>>2]=r,i[f+8>>2]=n,i[f>>2]=0,i[f+4>>2]=0,i[t>>2]=f,r=i[i[e+124>>2]>>2],r&&(i[e+124>>2]=r),m1(i[e+128>>2],f),i[e+132>>2]=i[e+132>>2]+1}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[o+19|0]<0&&Z(i[o+8>>2]),v=o- -64|0}function SZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,I0(Y(k,32006,15),F[e+104>>1]),F[e+104>>1]||Y(k,26354,7),k=Y(f+8|0,42713,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(I0(Y(k,30364,10),F[e+106>>1]),29233,2),F[e+108>>1]),29233,2),F[e+110>>1]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function jZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72244,i[f+8>>2]=72224,n=i[18065],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18066],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,t=f+12|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,n=i[18067],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18068],k=i[18064],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18069],i[f+64>>2]=72244,i[f>>2]=72204,i[f+8>>2]=72224,t=R0(t),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,Y2(k,e,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,29553,22),F[e+98>>1]),42713,1),k=f+148|0,mr(k,e,r,0),e=u[f+159|0],r=(e|0)<0,Y(n,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18063],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18071],i[f+8>>2]=i[18072],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function OZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92092,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+156>>2]=0,i[f+160>>2]=-65512,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92132,u[f+159|0]=8,i[f+32>>2]=1781689193,u[f+148|0]=74,u[f+149|0]=80,u[f+150|0]=69,u[f+151|0]=71,u[f+152|0]=50,u[f+153|0]=48,u[f+154|0]=48,u[f+155|0]=48,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function a4(A,e,r,f){var k=0,n=0,t=0,o=0;if(o=v-16|0,v=o,k=i[A+84>>2],!k){k=E(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90372,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86404,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,Q[k+112>>1]=0,i[k+16>>2]=88120,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1769104742,i[A+84>>2]=n,t=i[A+88>>2],i[A+88>>2]=k;i:{e:{if(!t){t=i[A+44>>2],i[o+12>>2]=k,i[o+8>>2]=n;break e}if(k=i[t+4>>2],i[t+4>>2]=k-1,k||(X[i[i[t>>2]+8>>2]](t),p(t)),t=i[A+44>>2],n=i[A+84>>2],k=i[A+88>>2],i[o+12>>2]=k,i[o+8>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}r2(t+36|0,o+8|0),n=i[o+12>>2];i:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break i;X[i[i[n>>2]+8>>2]](n),p(n)}k=i[A+84>>2]}n=v+-64|0,v=n,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+24>>2]=r,i[n+16>>2]=0,i[n+20>>2]=0,i[n+60>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+48>>2]=e,i[n+8>>2]=86404,A=n+52|0,(A|0)!=(f|0)&&(r=A,e=i[f>>2],A=i[f+4>>2],k6(r,e,A,A-e>>2)),e=i[k+108>>2];i:{if(e>>>0<u0[k+112>>2]){te(e,n+8|0),A=e+56|0;break i}A=tA(k+104|0,n+8|0)}i[k+108>>2]=A,A=i[n+52>>2],A&&(i[n+56>>2]=A,Z(A)),i[n+8>>2]=86404,A=i[n+28>>2],A&&(i[n+32>>2]=A,Z(A)),v=n- -64|0,v=o+16|0}function LZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+12>>2];i:{if(!k&u0[e+8>>2]>=u0[e+32>>2]|k){k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=Y(f+8|0,30113,22),k=i[e+8>>2],n=i[e+32>>2],Y(K2(r,k-n|0,i[e+12>>2]-(k>>>0<n>>>0)|0),42713,1);break i}e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,33440,32)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function PZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(f+8|0,19216,1),k),2989,6),t=i[i[n>>2]-12>>2]+n|0,i[t+4>>2]=i[t+4>>2]&-75|8,n=I0(n,i[i[e+104>>2]+(k<<2)>>2]),t=i[i[n>>2]-12>>2]+n|0,i[t+4>>2]=i[t+4>>2]&-75|2,Y(n,42713,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function qZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92372,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92412,u[f+159|0]=3,i[f+32>>2]=1635148593,u[f+151|0]=0,u[f+150|0]=l[20053],k=l[20051]|l[20052]<<8,u[f+148|0]=k,u[f+149|0]=k>>>8,k=i[r>>2],o=i[r+4>>2];i:{if((k|0)!=(o|0))for(s=f+52|0;;){t=i[k>>2],i[n+8>>2]=t,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[t+16>>2]==1635148611)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[t+16>>2]!=1635148611)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A);break i}if(t=i[r+4>>2],i[r+4>>2]=t-1,t)break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=k+8|0,(o|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function KZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90772,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90812,u[f+159|0]=3,i[f+32>>2]=1987470129,u[f+151|0]=0,u[f+150|0]=l[19989],k=l[19987]|l[19988]<<8,u[f+148|0]=k,u[f+149|0]=k>>>8,k=i[r>>2],o=i[r+4>>2];i:{if((k|0)!=(o|0))for(s=f+52|0;;){t=i[k>>2],i[n+8>>2]=t,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[t+16>>2]==1987470147)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[t+16>>2]!=1987470147)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A);break i}if(t=i[r+4>>2],i[r+4>>2]=t-1,t)break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(k=k+8|0,(o|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function aZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=v-16|0,v=k,f=i[e+12>>2],A=i[e+4>>2],n=(f+A|0)-1|0,t=(n|0)%(f|0)|0,o=(f+((A|0)/l[r+50|0]|0)|0)-1|0,s=(o|0)%(f|0)|0,w=i[e+8>>2],h=(w|0)/l[r+51|0]|0;i:{e:{r:{f:{if(A=l[r+48|0],(A-8&255)>>>0<9){if(f=l[r+49|0],(f-8&255)>>>0>=9)break f;if(e=0,i[k+4>>2]=0,t=n-t|0,A=pr(k+4|0,16,G(G(t,w),(A+7&248)>>>3|0)),w=i[k+4>>2],n=A?0:w,!i[r+20>>2]){if(h=0,s=0,!n)break e;break r}if(i[k+8>>2]=0,s=o-s|0,A=G(G(h,s),(f+7&248)>>>3|0),f=pr(k+8|0,16,A),e=i[k+8>>2],i[k+12>>2]=0,A=pr(k+12|0,16,A),h=i[k+12>>2],o=A?0:h,A=f?0:e,!(!n||!A|!o))break r;if(n&&Z(n),A&&Z(A),e=0,!o)break e;Z(o);break e}M0(21191,18299,117,7204),H()}M0(21237,18299,118,7204),H()}if(i[r+292>>2]=0,i[r+4>>2]=n,i[r+40>>2]=t,i[r+8>>2]=e,i[r+296>>2]=0,i[r+300>>2]=0,i[r+12>>2]=h,i[r+44>>2]=s,A=i[i[r+124>>2]+16832>>2],A-1>>>0<=7)A=G(t,i[r+28>>2]);else{if(A-9>>>0>=8)break i;A=G(t,i[r+28>>2])<<1}A&&o0(w,0,A),e=i[r+8>>2];r:{if(!e)break r;if(A=i[i[r+124>>2]+16840>>2],A-1>>>0<=7)A=G(i[r+36>>2],i[r+44>>2]);else{if(A-9>>>0>=8)break i;A=G(i[r+44>>2],i[r+36>>2])<<1}if(!A)break r;o0(e,0,A)}if(e=1,f=i[r+12>>2],!f)break e;if(A=i[i[r+124>>2]+16840>>2],A-1>>>0<=7){if(A=G(i[r+36>>2],i[r+44>>2]),!A)break e;o0(f,0,A);break e}if(A-9>>>0>=8)break i;if(A=G(i[r+44>>2],i[r+36>>2])<<1,!A)break e;o0(f,0,A)}return v=k+16|0,e|0}M0(21624,18299,545,12869),H()}function on(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{r:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=t>>>0)){e=2,B=r,w=l[r|0];f:{if(w<<24>>24>=0){Q[n>>1]=w,e=1;break f}if(w>>>0<194)break e;if(w>>>0<=223){if(s=1,(f-r|0)<2)break i;if(s=l[r+1|0],(s&192)!=128)break r;Q[n>>1]=s&63|w<<6&1984,e=2;break f}if(w>>>0<=239){if(e=1,h=f-r|0,(h|0)<2)break r;s=u[r+1|0];A:{k:{if((w|0)!=237){if((w|0)!=224)break k;if((s&-32)!=-96)break e;break A}if((s|0)>=-96)break e;break A}if((s|0)>-65)break e}if((h|0)==2)break r;if(e=l[r+2|0],(e&192)!=128)break e;Q[n>>1]=e&63|((s&63)<<6|w<<12),e=3;break f}if(w>>>0>244)break e;if(e=1,h=f-r|0,(h|0)<2)break r;_=l[r+1|0],s=_<<24>>24;A:{k:switch(w-240|0){case 0:if((s+112&255)>>>0>=48)break e;break A;case 4:if((s|0)>=-112)break e;break A;default:break k}if((s|0)>-65)break e}if((h|0)==2)break r;if(s=l[r+2|0],(s&192)!=128)break e;if((h|0)==3)break r;if(h=l[r+3|0],(h&192)!=128)break e;if((t-n|0)<3||(e=2,h=h&63,r=s<<6,w=w&7,(h|(r&4032|(_<<12&258048|w<<18)))>>>0>1114111))break r;Q[n+2>>1]=h|r&960|56320,e=_<<2,Q[n>>1]=(s>>>4&3|(e&192|w<<8|e&60))+16320|55296,n=n+2|0,e=4}r=B+e|0,i[A+12>>2]=r,n=n+2|0,i[A+8>>2]=n;continue}break}e=r>>>0<f>>>0}s=e;break i}s=2}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,s|0}function $Z(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,Y(r,30916,18),k=i[e+104>>2];i:{if((k|0)==i[e+108>>2]||(S0(r,l[k|0]),r=1,i[e+108>>2]-i[e+104>>2]>>>0<=1))break i;for(;k=f+8|0,Y(k,26343,1),S0(k,l[i[e+104>>2]+r|0]),r=r+1|0,r>>>0<i[e+108>>2]-i[e+104>>2]>>>0;);}Y(f+8|0,42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function dZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,I0(Y(r,32543,4),(i[e+116>>2]-i[e+112>>2]|0)/12|0),S0(Y(r,32669,7),i[e+104>>2]-i[e+100>>2]&255),Y(r,32692,5),r=i[e+100>>2],e=i[e+104>>2],(r|0)!=(e|0))for(;Y(S0(f+8|0,l[r|0]),32776,2),r=r+1|0,(e|0)!=(r|0););Y(f+8|0,42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function cZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;n=v+-64|0,v=n;i:{if(S1(e,85332,0)){i[r>>2]=0,f=1;break i}e:{if(l[A+8|0]&24)k=1;else{if(!e||(t=X0(e,84936,85032),!t))break e;k=(l[t+8|0]&24)!=0}k=S1(A,e,k)}if(k){if(f=1,A=i[r>>2],!A)break i;i[r>>2]=i[A>>2];break i}e:{if(!e)break e;if(t=X0(e,84936,85080),!t||(e=i[r>>2],e&&(i[r>>2]=i[e>>2]),k=i[t+8>>2],e=i[A+8>>2],k&(e^-1)&7|e&(k^-1)&96)||(f=1,S1(i[A+12>>2],i[t+12>>2],0)))break i;if(S1(i[A+12>>2],85320,0)){if(A=i[t+12>>2],!A)break i;f=!X0(A,84936,85128);break i}if(k=i[A+12>>2],!k)break e;if(f=0,e=X0(k,84936,85080),e){if(!(u[A+8|0]&1))break i;A=i[t+12>>2],r=0;r:{f:{for(;;){if(f=0,!A)break r;if(A=X0(A,84936,85080),!A|i[A+8>>2]&(i[e+8>>2]^-1))break f;if(f=1,S1(i[e+12>>2],i[A+12>>2],0))break r;if(!(u[e+8|0]&1)||(f=i[e+12>>2],!f))break f;if(e=X0(f,84936,85080),e){A=i[A+12>>2];continue}break}if(e=X0(f,84936,85180),!e)break f;r=To(e,i[A+12>>2])}f=r}break i}if(e=X0(k,84936,85180),e){if(!(u[A+8|0]&1))break i;f=To(e,i[t+12>>2]);break i}if(k=X0(k,84936,84984),!k||(A=i[t+12>>2],!A)||(A=X0(A,84936,84984),!A))break i;e=i[r>>2],o0(n+8|0,0,56),u[n+59|0]=(e|0)!=0,i[n+16>>2]=-1,i[n+12>>2]=k,i[n+4>>2]=A,i[n+52>>2]=1,X[i[i[A>>2]+28>>2]](A,n+4|0,e,1),A=i[n+28>>2],(A|0)==1&&(i[r>>2]=e?i[n+20>>2]:0),f=(A|0)==1;break i}f=0}return v=n- -64|0,f|0}function Xr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2071,w=B+16|0,m=g1(B+8|0,0,w);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(w=p2(_),!w)break r;e=i[m>>2],i[m>>2]=w,e&&X[i[m+4>>2]](e)}for(o=w,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,V=P2(A,e),y=1,R=_,R?V:y)for(P2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(l[w|0]==2)break i;w=w+1|0,r=r+12|0}e=i[A>>2],o=i[e+12>>2];A:{if((o|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break A}e=u[o|0]}for(g=e<<24>>24,t||(g=X[i[i[k>>2]+12>>2]](k,g)|0),s=I+1|0,C=0,o=w,e=r;;)if((e|0)==(f|0)){if(I=s,!C||(K1(A),o=w,e=r,_+W>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,(s|0)==(I|0)|l[o|0]!=2||(u[o|0]=0,W=W-1|0),o=o+1|0,e=e+12|0}}else{A:{if(l[o|0]!=1)break A;l[e+11|0]>>>7|0?h=i[e>>2]:h=e,h=u[h+I|0],t||(h=X[i[i[k>>2]+12>>2]](k,h)|0);k:{if((g|0)==(h|0)){if(C=1,l[e+11|0]>>>7|0?h=i[e+4>>2]:h=l[e+11|0]&127,(h|0)!=(s|0))break A;u[o|0]=2,W=W+1|0;break k}u[o|0]=0}_=_-1|0}o=o+1|0,e=e+12|0;continue}}else{l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,s=!s,u[o|0]=s?2:1,o=o+1|0,e=e+12|0,W=W+s|0,_=_-s|0;continue}}Q1(),H()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&X[i[m+4>>2]](A),v=B+128|0,r}function bZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;f=v-32|0,v=f,e=i[r>>2],n=i[e+112>>2],t=i[e+108>>2],e=E(172),i[e>>2]=94860,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),k=i[e+4>>2],s=k+1|0,i[e+4>>2]=s,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,Q[e+22>>1]=2,Q[e+18>>1]=2,Q[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95208,i[e+148>>2]=0,i[e+152>>2]=0,i[e+136>>2]=e+140,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=k,w=i[e+8>>2],k=e+12|0,i[e+96>>2]=k,i[e+8>>2]=w+1,i[e+100>>2]=e,s||(X[i[i[e>>2]+8>>2]](e),p(e)),s=i[r>>2],w=i[s+116>>2],i[k+120>>2]=i[s+120>>2],i[k+116>>2]=w,i[k+112>>2]=n,i[k+108>>2]=t;i:{if(!u1(i[r>>2],0)||(f6(f+12|0,k,r,0,0,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],1)||(f6(f+12|0,k,r,1,1,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],2)||(f6(f+12|0,k,r,2,2,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],3)||(f6(f+12|0,k,r,3,3,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],4)||(f6(f+12|0,k,r,4,4,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],5)||(f6(f+12|0,k,r,5,5,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=k,v=f+32|0}function bi(A,e){var r=0,f=0,k=0,n=0,t=0;f=v-48|0,v=f,i[f+44>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,r=i[e+100>>2],k=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),t=i[k+52>>2],k=i[k+56>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[e+100>>2],n=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+28>>2]=i[n+60>>2],n=i[n+64>>2],i[f+32>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;X[i[i[r>>2]+8>>2]](r),p(r)}C9(f+8|0,t,i[e+116>>2],f+28|0,f+36|0);i:{if(i[f+8>>2]){if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,u[f+27|0]>=0){r=i[f+20>>2],i[e>>2]=i[f+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+24>>2],e=1;break i}T(e,i[f+16>>2],i[f+20>>2]),e=1;break i}e=i[f+44>>2],i[f+44>>2]=0,r=i[f+36>>2],n=i[f+40>>2],i[f+36>>2]=0,i[f+40>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=n,e=0}u[A+20|0]=e,u[f+27|0]<0&&Z(i[f+16>>2]),A=i[f+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}if(A=i[f+36>>2],A){if(r=i[f+40>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[f+36>>2]}i[f+40>>2]=A,Z(e)}v=f+48|0}function gr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2071,w=B+16|0,m=g1(B+8|0,0,w);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(w=p2(_),!w)break r;e=i[m>>2],i[m>>2]=w,e&&X[i[m+4>>2]](e)}for(o=w,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,V=q2(A,e),y=1,R=_,R?V:y)for(q2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(l[w|0]==2)break i;w=w+1|0,r=r+12|0}e=i[A>>2],o=i[e+12>>2];A:{if((o|0)==i[e+16>>2]){s=X[i[i[e>>2]+36>>2]](e)|0;break A}s=i[o>>2]}for(t||(s=X[i[i[k>>2]+28>>2]](k,s)|0),I=g+1|0,C=0,o=w,e=r;;)if((e|0)==(f|0)){if(g=I,!C||(a1(A),o=w,e=r,_+W>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,(s|0)==(g|0)|l[o|0]!=2||(u[o|0]=0,W=W-1|0),o=o+1|0,e=e+12|0}}else{A:{if(l[o|0]!=1)break A;l[e+11|0]>>>7|0?h=i[e>>2]:h=e,h=i[h+(g<<2)>>2],t||(h=X[i[i[k>>2]+28>>2]](k,h)|0);k:{if((s|0)==(h|0)){if(C=1,l[e+11|0]>>>7|0?h=i[e+4>>2]:h=l[e+11|0]&127,(h|0)!=(I|0))break A;u[o|0]=2,W=W+1|0;break k}u[o|0]=0}_=_-1|0}o=o+1|0,e=e+12|0;continue}}else{l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,s=!s,u[o|0]=s?2:1,o=o+1|0,e=e+12|0,W=s+W|0,_=_-s|0;continue}}Q1(),H()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&X[i[m+4>>2]](A),v=B+128|0,r}function iG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90612,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90652,u[f+159|0]=4,i[f+32>>2]=1635135537,u[f+148|0]=65,u[f+149|0]=86,u[f+150|0]=73,u[f+151|0]=70,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1635135811)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1635135811)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function eG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=E(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90452,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,Q[f+118>>1]=0,Q[f+120>>1]=0,Q[f+122>>1]=0,Q[f+124>>1]=0,Q[f+116>>1]=1,Q[f+126>>1]=0,Q[f+128>>1]=0,Q[f+130>>1]=0,Q[f+132>>1]=0,Q[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,Q[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90492,u[f+159|0]=4,i[f+32>>2]=1752589105,u[f+148|0]=72,u[f+149|0]=69,u[f+150|0]=86,u[f+151|0]=67,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1752589123)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1752589123)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;X[i[i[k>>2]+8>>2]](k),p(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function ie(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=v-144|0,v=r;i:{e:{if(k=i[e+16>>2],(k|0)==1970628964){for(k=0,i[r+84>>2]=0,i[r+56>>2]=72548,f=i[18140],i[r>>2]=f,i[i[f-12>>2]+r>>2]=i[18141],f=i[i[r>>2]-12>>2]+r|0,n=r+4|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,i[r+56>>2]=72548,i[r>>2]=72528,o=R0(n),i[o>>2]=71280,i[r+44>>2]=0,i[r+48>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+52>>2]=16,f=i[r>>2]-12|0,n=i[f>>2]+r|0,i[n+4>>2]=i[n+4>>2]&-75|8,f=i[f>>2]+r|0,l[f+80|0]||(t=r+140|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129808),X[i[i[n>>2]+28>>2]](n,32)|0,e2(t)),n=r+56|0,u[f+76|0]=48,u[f+77|0]=0,u[f+78|0]=0,u[f+79|0]=0,u[f+80|0]=1,f=r+12|0;;){r:switch((k&13)-4|0){case 0:case 4:u[r+140|0]=45,Y(r,r+140|0,1);break;default:break r}if(i[i[i[r>>2]-12>>2]+f>>2]=2,S0(r,l[i[e+20>>2]+k|0]),k=k+1|0,(k|0)==16)break}break e}P1(A,k);break i}e=i[r+52>>2];e:{r:{if(e&16){f=r+24|0,k=i[r+48>>2],e=i[r+28>>2],k>>>0<e>>>0?i[r+48>>2]=e:e=k;break r}if(!(e&8)){k=0,u[A+11|0]=0;break e}e=i[r+20>>2]}r:{if(f=i[f>>2],k=e-f|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(u[A+11|0]=k,k)break r;k=0;break e}g0(),H()}if(!k)break e;z(A,f,k)}u[A+k|0]=0,A=i[18139],i[r>>2]=A,i[i[A-12>>2]+r>>2]=i[18142],i[o>>2]=71280,u[r+47|0]<0&&Z(i[r+36>>2]),y0(o),p0(n)}v=r+144|0}function ln(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;B=v-16|0,v=B,s=-9,_=i[A+12>>2],w=i[A+8>>2];i:{if((_|0)==(w|0))break i;for(h=_-w>>2,W=h>>>0<=1?1:h;;){if(m=i[w+(o<<2)>>2],!(l[m+104|0]|i[m+100>>2])){sA(m),_=i[A+12>>2],h=_-i[A+8>>2]>>2,s=o;break i}if(o=o+1|0,(W|0)==(o|0))break}}i:{if((h-1|0)==(s|0)|u0[A+4>>2]>=h>>>0||(o=i[_-4>>2],l[o+104|0]|i[o+100>>2]))break i;Z(oA(o)),_=i[A+12>>2]-4|0,i[A+12>>2]=_}i:{e:{r:{if((s|0)==-9){I=i[A+8>>2],m=Kt(E(416)),o=i[A+12>>2],w=i[A+16>>2];f:{if(o>>>0<w>>>0){i[o>>2]=m,o=o+4|0;break f}if(h=i[A+8>>2],o=o-h|0,g=o>>2,s=g+1|0,s>>>0>=1073741824)break r;if(w=w-h|0,W=w>>1,w=w>>>0>=2147483644?1073741823:s>>>0<W>>>0?W:s,w){if(w>>>0>=1073741824)break e;s=E(w<<2)}else s=0;if(W=s+o|0,i[W>>2]=m,m=W-(g<<2)|0,o&&z(m,h,o),i[A+16>>2]=s+(w<<2),o=W+4|0,i[A+12>>2]=o,i[A+8>>2]=m,!h)break f;Z(h)}i[A+12>>2]=o,s=_-I>>2}f:{if((s|0)<0){o=i[e+4>>2];break f}if(o=i[e>>2],_=i[o+476>>2],_>>>0>=4)break i;if(A=i[i[A+8>>2]+(s<<2)>>2],h=i[o+488>>2],w=i[o+484>>2],i[B+8>>2]=o,o=i[e+4>>2],i[B+12>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[B+12>>2],i[B>>2]=i[B+8>>2],i[B+4>>2]=e,e=k9(A,w,h,_,B,1,r,f,k,n,t),e){s=0-e|0;break f}u[A+312|0]=0}f:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break f;X[i[i[o>>2]+8>>2]](o),p(o)}return v=B+16|0,s}G0(),H()}x0(),H()}M0(22224,18336,263,14234),H()}function rG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;k=v-32|0,v=k,e=i[A+104>>2],t=i[A+108>>2];i:{if((e|0)==(t|0))break i;e:{for(;;){r:{if(f=i[e>>2],!f||(w=X0(f,86628,97612),!w))break r;if(n=i[e+4>>2],!n)break e;i[n+4>>2]=i[n+4>>2]+1;break i}if(e=e+8|0,(t|0)==(e|0))break}w=0}n=0}i[k+24>>2]=0,i[k+28>>2]=0,i[k+12>>2]=1768778098,i[k+16>>2]=1668047216,i[k+4>>2]=1752589123,i[k+8>>2]=1769107316,i[k+20>>2]=k+24,s=k+20|0,fe(s,k+4|0,s),f=v-48|0,v=f,bi(f+12|0,A),r=l[f+32|0];i:{e:{if(!r){if(o=i[f+12>>2],h=i[f+16>>2],(o|0)==(h|0)){r=0;break e}t=s+4|0;r:{for(;;){if(r=i[o>>2],e=i[r+16>>2]==1769173093,r=e?A:r,X[i[i[r>>2]+(e?48:40)>>2]](r)|0){if(_=1,r=i[t>>2],!r)break r;for(B=i[i[o>>2]+16>>2],e=t;m=u0[r+16>>2]<B>>>0,e=m?e:r,r=i[(m?4:0)+r>>2],!!r;);if((e|0)==(t|0)|u0[e+16>>2]>B>>>0)break r}if(o=o+8|0,(h|0)==(o|0))break}_=0}r=l[f+32|0]}if((r&255)==255)break i}A=i[25191],i[f+40>>2]=i[25190],i[f+44>>2]=A,X[i[(f+40|0)+((r&255)<<2)>>2]](f+39|0,f+12|0)}v=f+48|0,Y1(s,i[k+24>>2]);i:if(_||(W=1751476579,e=w+100|0,A=i[e+4>>2],A&1073741824|l[e+3|0]==1)||(e=l[e+3|0],A&268435456|(e|0)==3)||(W=1751476600,A&536870912|(e|0)==2))break i;i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n)}return v=k+32|0,W|0}function M1(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(S0(Y(f+8|0,30819,9),l[e+97|0]),42713,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=Y(k,30093,7),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]&-75|8,Y(I0(r,i[e+100>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function fG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;s=v-32|0,v=s,o=i[e+104>>2],n=i[e+108>>2];i:{if((o|0)==(n|0))break i;for(;;){e:{if(l[o+4|0]!=1||(f=i[o+16>>2],t=i[o+20>>2],(f|0)==(t|0)))break e;for(;k=(i[f+28>>2]+k|0)-i[f+24>>2]|0,f=f+40|0,(t|0)!=(f|0););}if(o=o+32|0,(n|0)==(o|0))break}if(!k||(C0(r,k+8|0),C0(r,1768186228),k=i[e+104>>2],n=i[e+108>>2],(k|0)==(n|0)))break i;for(;;){e:{if(l[k+4|0]!=1||(f=i[k+16>>2],t=i[k+20>>2],(f|0)==(t|0)))break e;for(;V4(r,f+24|0),f=f+40|0,(t|0)!=(f|0););}if(k=k+32|0,(n|0)==(k|0))break}}if(w=X[i[i[e>>2]+52>>2]](e,r,0)|0,i[e+116>>2]=i[r+12>>2],n=l[e+97|0],t=n>>>0<2,k=t?4:6,f=i[e+104>>2],h=i[e+108>>2],(f|0)!=(h|0))for(_=l[e+122|0]+(l[e+121|0]+((n?l[e+124|0]:0)&255)|0)|0,B=l[e+123|0]+((t?6:8)+(n?2:0)|0)|0,o=_+B|0;n=i[f+16>>2],t=i[f+20>>2],(n|0)==(t|0)?k=k+B|0:k=(k+o|0)+G(((t-n|0)-40>>>0)/40|0,_)|0,f=f+32|0,(h|0)!=(f|0););Lr(r,k),i[r+12>>2]=w,X[i[i[e>>2]+56>>2]](s+12|0,e,r,i[r+4>>2]-(w+i[r>>2]|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[s+31|0]<0&&Z(i[s+20>>2]),an(e,r),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0;i:{if(u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931])}v=s+32|0}function AG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,Y(I0(Y(I0(Y(I0(Y(f+8|0,19216,1),n),20920,8),i[k+i[e+104>>2]>>2]),21010,8),i[(k+i[e+104>>2]|0)+4>>2]),42713,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function kG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,M1(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,Y(S0(Y(I0(Y(I0(Y(f+8|0,19216,1),n),20920,8),i[k+i[e+104>>2]>>2]),20929,9),i[(k+i[e+104>>2]|0)+4>>2]),42713,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function z8(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),w=c0(r,129808),e2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(t|0)==(o|0))break i;e:{if(P2(s+12|0,s+8|0))break e;r:{if((X[i[i[w>>2]+36>>2]](w,u[t|0],0)|0)==37){if((t+1|0)==(o|0))break e;r=0;f:{A:{if(e=X[i[i[w>>2]+36>>2]](w,u[t+1|0],0)|0,(e|0)==69||(h=1,(e&255)==48))break A;break f}if((t+2|0)==(o|0))break e;h=2,r=e,e=X[i[i[w>>2]+36>>2]](w,u[t+2|0],0)|0}_=s,B=X[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,t=(t+h|0)+1|0;break r}if(e=u[t|0],(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,e){for(;t=t+1|0,!!((o|0)!=(t|0)&&(e=u[t|0],(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,e)););for(;;){if(r=s+12|0,P2(r,s+8|0))break r;e=i[r>>2],h=i[e+12>>2];f:{if((h|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break f}e=u[h|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;K1(r)}}h=s+12|0,e=i[h>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break f}e=u[r|0]}if((X[i[i[w>>2]+12>>2]](w,e<<24>>24)|0)==(X[i[i[w>>2]+12>>2]](w,u[t|0])|0)){t=t+1|0,K1(h);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return P2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function nG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=E(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27218]|l[27219]<<8|(l[27220]<<16|l[27221]<<24),k=l[27214]|l[27215]<<8|(l[27216]<<16|l[27217]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27213]|l[27214]<<8|(l[27215]<<16|l[27216]<<24),k=l[27209]|l[27210]<<8|(l[27211]<<16|l[27212]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27205]|l[27206]<<8|(l[27207]<<16|l[27208]<<24),k=l[27201]|l[27202]<<8|(l[27203]<<16|l[27204]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27197]|l[27198]<<8|(l[27199]<<16|l[27200]<<24),k=l[27193]|l[27194]<<8|(l[27195]<<16|l[27196]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=K(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function tG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=E(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27309]|l[27310]<<8|(l[27311]<<16|l[27312]<<24),k=l[27305]|l[27306]<<8|(l[27307]<<16|l[27308]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27304]|l[27305]<<8|(l[27306]<<16|l[27307]<<24),k=l[27300]|l[27301]<<8|(l[27302]<<16|l[27303]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27296]|l[27297]<<8|(l[27298]<<16|l[27299]<<24),k=l[27292]|l[27293]<<8|(l[27294]<<16|l[27295]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27288]|l[27289]<<8|(l[27290]<<16|l[27291]<<24),k=l[27284]|l[27285]<<8|(l[27286]<<16|l[27287]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=K(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function uG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=E(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27339]|l[27340]<<8|(l[27341]<<16|l[27342]<<24),k=l[27335]|l[27336]<<8|(l[27337]<<16|l[27338]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27334]|l[27335]<<8|(l[27336]<<16|l[27337]<<24),k=l[27330]|l[27331]<<8|(l[27332]<<16|l[27333]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27326]|l[27327]<<8|(l[27328]<<16|l[27329]<<24),k=l[27322]|l[27323]<<8|(l[27324]<<16|l[27325]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27318]|l[27319]<<8|(l[27320]<<16|l[27321]<<24),k=l[27314]|l[27315]<<8|(l[27316]<<16|l[27317]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=K(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function oG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=E(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27248]|l[27249]<<8|(l[27250]<<16|l[27251]<<24),k=l[27244]|l[27245]<<8|(l[27246]<<16|l[27247]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27243]|l[27244]<<8|(l[27245]<<16|l[27246]<<24),k=l[27239]|l[27240]<<8|(l[27241]<<16|l[27242]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27235]|l[27236]<<8|(l[27237]<<16|l[27238]<<24),k=l[27231]|l[27232]<<8|(l[27233]<<16|l[27234]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27227]|l[27228]<<8|(l[27229]<<16|l[27230]<<24),k=l[27223]|l[27224]<<8|(l[27225]<<16|l[27226]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=K(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function lG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-16|0,v=k,r=i[A>>2],A=i[r+244>>2],o=i[r+248>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);i:{if(!A)break i;i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0;e:{r:{f:{if(f=i[A+100>>2],w=i[A+104>>2],(f|0)!=(w|0)){if(A=w-f|0,r=A>>4,r>>>0>=1073741824)break f;for(A=E(A>>2),i[k+8>>2]=A,i[k+4>>2]=A,i[k+12>>2]=(r<<2)+A;;){n=i[k+12>>2];A:{if(n>>>0>A>>>0){i[A>>2]=i[f>>2],A=A+4|0;break A}if(s=i[k+4>>2],A=A-s|0,h=A>>2,r=h+1|0,r>>>0>=1073741824)break f;if(n=n-s|0,t=n>>1,n=n>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,n){if(n>>>0>=1073741824)break r;r=E(n<<2)}else r=0;if(t=r+A|0,i[t>>2]=i[f>>2],h=t-(h<<2)|0,A&&z(h,s,A),i[k+12>>2]=r+(n<<2),A=t+4|0,i[k+8>>2]=A,i[k+4>>2]=h,!s)break A;Z(s)}if(i[k+8>>2]=A,f=f+16|0,(w|0)==(f|0))break}}break e}G0(),H()}x0(),H()}A=i[k+8>>2],r=i[k+4>>2];e:{if((A|0)!=(r|0)){if(f=A-r>>2,n=f>>>0<=1?1:f,s=n&3,A=0,f>>>0>=4)for(w=n&-4,n=0;f=A<<2,i[f+e>>2]=i[r+f>>2],t=f|4,i[t+e>>2]=i[r+t>>2],t=f|8,i[t+e>>2]=i[r+t>>2],f=f|12,i[f+e>>2]=i[r+f>>2],A=A+4|0,n=n+4|0,(w|0)!=(n|0););if(!s)break e;for(;f=A<<2,i[f+e>>2]=i[r+f>>2],A=A+1|0,_=_+1|0,(s|0)!=(_|0););break e}if(!r)break i}i[k+8>>2]=r,Z(r)}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;X[i[i[o>>2]+8>>2]](o),p(o)}v=k+16|0}function Qr(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;s=v-160|0,v=s;i:{e:{if(h=i[e+68>>2],w=i[h+104>>2],_=i[h+108>>2],(w|0)==(_|0))break e;for(;;){if(i[w>>2]!=(r|0)){if(w=w+32|0,(_|0)!=(w|0))continue;break e}break}K6(A,h,r,e+8|0,e+76|0,f,k,n,t,o,i[e+156>>2]);break i}i[s+104>>2]=0,i[s+76>>2]=72244,i[s+20>>2]=72224,e=i[18065],i[s+12>>2]=e,f=i[e-12>>2],e=s+12|0,i[f+e>>2]=i[18066],i[s+16>>2]=0,f=e+i[i[s+12>>2]-12>>2]|0,k=s+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18067],i[s+20>>2]=f,n=s+20|0,i[n+i[f-12>>2]>>2]=i[18068],f=i[18064],i[s+12>>2]=f,i[e+i[f-12>>2]>>2]=i[18069],i[s+76>>2]=72244,i[s+12>>2]=72204,i[s+20>>2]=72224,f=R0(k),i[f>>2]=71280,e=s- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[s+56>>2]=0,i[s+60>>2]=0,i[s+72>>2]=24,Y(I0(Y(n,29218,13),r),18929,23),e=i[s+72>>2];e:{r:{if(e&16){w=i[s+68>>2],e=i[s+48>>2],w>>>0<e>>>0&&(i[s+68>>2]=e,w=e),e=s+44|0;break r}if(!(e&8)){w=0,u[s+11|0]=0,r=s;break e}w=i[s+40>>2],e=s+32|0}r:{if(e=i[e>>2],w=w-e|0,w>>>0<2147483640){if(w>>>0>=11){k=w|7,r=E(k+1|0),i[s+8>>2]=k-2147483647,i[s>>2]=r,i[s+4>>2]=w;break r}if(u[s+11|0]=w,r=s,w)break r;w=0;break e}g0(),H()}if(!w)break e;z(r,e,w)}u[r+w|0]=0,K(A,2,117,s),u[s+11|0]<0&&Z(i[s>>2]),A=i[18063],i[s+12>>2]=A,i[i[A-12>>2]+(s+12|0)>>2]=i[18071],i[s+20>>2]=i[18072],i[f>>2]=71280,u[s+67|0]<0&&Z(i[s+56>>2]),y0(f),p0(s+76|0)}v=s+160|0}function sG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,31119,10),i[e+100>>2]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,31108,10),i[e+104>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function wG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(I0(Y(k,30860,25),F[e+98>>1]),42713,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,30886,29),F[e+100>>1]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function hG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,n=i[18140],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18141],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(k),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(I0(Y(f+8|0,31053,13),i[e+104>>2]),42713,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(n,29738,14),i[e+108>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function _G(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=v-16|0,v=f;i:{e:{if(!i[A+64>>2])break e;if(!(l[A+92|0]&16)){i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,r=i[A+52>>2];r:{if(r>>>0>=9){if(l[A+98|0]==1){n=r,r=i[A+32>>2],i[A+28>>2]=(n+r|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}r=i[A+56>>2],i[A+28>>2]=(r+i[A+60>>2]|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0}i[A+92>>2]=16}if(t=i[A+20>>2],o=i[A+28>>2],(e|0)!=-1&&(i[A+24>>2]||(i[A+28>>2]=f+16,r=f+15|0,i[A+20>>2]=r,i[A+24>>2]=r),u[i[A+24>>2]]=e<<24>>24,i[A+24>>2]=i[A+24>>2]+1),k=i[A+24>>2],r=i[A+20>>2],(k|0)!=(r|0)){r:{if(l[A+98|0]==1){if(n=r,r=k-r|0,(L1(n,1,r,i[A+64>>2])|0)!=(r|0))break e;break r}for(i[f+8>>2]=i[A+32>>2],s=A+72|0;;){if(r=i[A+68>>2],r){if(k=i[A+32>>2],r=X[i[i[r>>2]+12>>2]](r,s,i[A+20>>2],i[A+24>>2],f+4|0,k,k+i[A+52>>2]|0,f+8|0)|0,i[A+20>>2]==i[f+4>>2])break e;if((r|0)==3){if(r=i[A+24>>2]-i[A+20>>2]|0,(L1(i[A+20>>2],1,r,i[A+64>>2])|0)!=(r|0))break e;break r}if(r>>>0>1||(n=i[A+32>>2],k=i[f+8>>2]-n|0,(L1(n,1,k,i[A+64>>2])|0)!=(k|0)))break e;if((r|0)!=1)break r;r=i[f+4>>2],i[A+28>>2]=i[A+24>>2],i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(i[A+28>>2]-i[A+20>>2]|0);continue}break}Q1(),H()}i[A+28>>2]=o,i[A+20>>2]=t,i[A+24>>2]=t}A=(e|0)!=-1?e:0;break i}A=-1}return v=f+16|0,A|0}function BG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(I0(Y(f+8|0,29443,15),F[k>>1]),31697,16),F[k+2>>1]),30710,23),F[k+4>>1]),42713,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function vG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+104>>2],e=i[e+108>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(S0(Y(I0(Y(f+8|0,32152,10),F[k>>1]),29965,18),l[k+2|0]),29947,17),F[k+4>>1]),42713,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function mG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(I0(Y(f+8|0,29366,17),F[k>>1]),31743,16),l[k+2|0]),30329,18),l[k+3|0]),42713,1),k=k+4|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function ZG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;n=v-32|0,v=n,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,l[e+184|0]==1&&C0(r,i[e+104>>2]),l[e+185|0]==1&&C0(r,i[e+108>>2]),l[e+186|0]==1&&C0(r,i[e+112>>2]);i:{if(l[e+187|0]!=1)break i;if(l[e+116|0]==1){if(f=t0[e+120>>3],l[e+117|0]==1){f=f*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k),f=t0[e+128>>3]*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k),f=t0[e+136>>3]*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k);break i}f=f*16384,w2(f)<2147483647?k=~~f:k=-2147483648,De(r,k),f=t0[e+128>>3]*16384,w2(f)<2147483647?k=~~f:k=-2147483648,De(r,k),f=t0[e+136>>3]*16384,w2(f)<2147483647?k=~~f:k=-2147483648,De(r,k);break i}f=t0[e+152>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k),f=t0[e+160>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k),f=t0[e+168>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,C0(r,k)}l[e+188|0]==1&&C0(r,i[e+176>>2]),i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function GG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;e=v-48|0,v=e,r=E(40),i[e+12>>2]=r,i[e+16>>2]=32,i[e+20>>2]=-2147483608,f=l[4342]|l[4343]<<8|(l[4344]<<16|l[4345]<<24),k=l[4338]|l[4339]<<8|(l[4340]<<16|l[4341]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[4334]|l[4335]<<8|(l[4336]<<16|l[4337]<<24),k=l[4330]|l[4331]<<8|(l[4332]<<16|l[4333]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[4326]|l[4327]<<8|(l[4328]<<16|l[4329]<<24),k=l[4322]|l[4323]<<8|(l[4324]<<16|l[4325]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[4318]|l[4319]<<8|(l[4320]<<16|l[4321]<<24),k=l[4314]|l[4315]<<8|(l[4316]<<16|l[4317]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+32|0]=0,f=K(e+24|0,4,6003,e+12|0),r=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=r,k=A+8|0;i:{if(u[f+19|0]>=0){r=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+16>>2],u[A+20|0]=1;break i}if(T(k,i[f+8>>2],i[f+12>>2]),r=u[f+19|0],u[A+20|0]=1,(r|0)>=0)break i;Z(i[f+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function WG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(f+8|0,19216,1),k),32765,4),i[i[e+104>>2]+(k<<2)>>2]),42713,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}g0(),H()}if(!k)break i;z(A,r,k)}u[A+k|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function sn(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=t>>>0)){s=u[r|0],e=s&255;r:{if((s|0)>=0){if(e>>>0>1114111)break e;s=1;break r}if(s>>>0<4294967234)break e;if(s>>>0<=4294967263){if(s=1,(f-r|0)<2||(s=2,w=l[r+1|0],(w&192)!=128))break i;e=w&63|e<<6&1984,s=2;break r}if(s>>>0<=4294967279){if(s=1,h=f-r|0,(h|0)<2)break i;w=u[r+1|0];f:{A:{if((e|0)!=237){if((e|0)!=224)break A;if((w&-32)==-96)break f;break e}if((w|0)<-96)break f;break e}if((w|0)>-65)break e}if((h|0)==2)break i;if(s=l[r+2|0],(s&192)!=128)break e;e=s&63|(e<<12&61440|(w&63)<<6),s=3;break r}if(s>>>0>4294967284)break e;if(s=1,h=f-r|0,(h|0)<2)break i;w=u[r+1|0];f:{A:switch(e-240|0){case 0:if((w+112&255)>>>0>=48)break e;break f;case 4:if((w|0)>=-112)break e;break f;default:break A}if((w|0)>-65)break e}if((h|0)==2)break i;if(_=l[r+2|0],(_&192)!=128)break e;if((h|0)==3)break i;if(h=l[r+3|0],(h&192)!=128)break e;if(s=2,e=h&63|(_<<6&4032|(e<<18&1835008|(w&63)<<12)),e>>>0>1114111)break i;s=4}i[n>>2]=e,r=r+s|0,i[A+12>>2]=r,n=n+4|0,i[A+8>>2]=n;continue}break}s=r>>>0<f>>>0;break i}s=2}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,s|0}function XG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;w=v-16|0,v=w;i:{if((r|0)<0)break i;A=i[A>>2],n=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),o=i[n+84>>2],s=i[n+88>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break e;X[i[i[A>>2]+8>>2]](A),p(A)}e:{if(!o){n=0;break e}i3(w+4|0,o,e),A=i[w+8>>2],o=i[w+4>>2];r:{if(((A-o|0)/56|0)>(r|0)){r=o+G(r,56)|0,f&&(i[f>>2]=i[r+16>>2]);f:{if(!k){e=i[r+44>>2],n=i[r+48>>2];break f}if(e=i[r+48>>2]-i[r+44>>2]|0,h=E((e|0)<0?-1:e),i[k>>2]=h,e=i[r+44>>2],n=i[r+48>>2],(e|0)==(n|0)){e=n;break f}if(f=n-e>>2,t=f>>>0<=1?1:f,B=t&3,k=0,r=0,f>>>0>=4)for(m=t&-4,f=0;t=r<<2,i[t+h>>2]=i[e+t>>2],_=t|4,i[_+h>>2]=i[e+_>>2],_=t|8,i[_+h>>2]=i[e+_>>2],t=t|12,i[t+h>>2]=i[e+t>>2],r=r+4|0,f=f+4|0,(m|0)!=(f|0););if(!B)break f;for(;f=r<<2,i[f+h>>2]=i[e+f>>2],r=r+1|0,k=k+1|0,(B|0)!=(k|0););}n=n-e>>2;break r}if(n=0,!o)break e}if((A|0)==(o|0))A=o;else{for(;e=i[A-12>>2],e&&(i[A-8>>2]=e,Z(e)),e=A-56|0,i[e>>2]=86404,r=i[A-36>>2],r&&(i[A-32>>2]=r,Z(r)),A=e,(o|0)!=(A|0););A=i[w+4>>2]}i[w+8>>2]=o,Z(A)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}return v=w+16|0,n|0}function wn(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){if(r>>>0>=f>>>0){n=0;break i}n=2;r:{e=F[r>>1];f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(t-r|0)<=0)break i;i[A+8>>2]=r+1,u[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(t-r|0)<2)break e;i[A+8>>2]=r+1,u[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(e>>>0<=55295){if(r=i[A+8>>2],(t-r|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(e>>>0<=56319){if(n=1,(f-r|0)<3)break i;if(s=F[r+2>>1],(s&64512)!=56320)break r;if(w=i[A+8>>2],(t-w|0)<4)break i;if(n=e&960,(s&1023|(e<<10&64512|n<<10))>>>0>1048575)break r;i[A+12>>2]=r+2,i[A+8>>2]=w+1,r=(n>>>6|0)+1|0,u[w|0]=r>>>2|240,n=i[A+8>>2],i[A+8>>2]=n+1,u[n|0]=r<<4&48|e>>>2&15|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=s>>>6&15|e<<4&48|128,e=i[A+8>>2],i[A+8>>2]=e+1,u[e|0]=s&63|128;break f}if(e>>>0<57344)break i;if(r=i[A+8>>2],(t-r|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&191,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128}r=i[A+12>>2]+2|0,i[A+12>>2]=r;continue}break}n=2;break i}n=1}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,n|0}function gG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,e=v-16|0,v=e,o=A+196|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=e+16|0,t=A+16|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129808),X[i[i[e>>2]+32>>2]](e,77792,77818,A+208|0)|0,e2(t),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,X2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=t,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,(t|0)==(f+e|0)&&(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,X2(r,f<<1),X2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+252|0,f=i[s>>2],t=i[f+12>>2];e:{if((t|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[t|0]}if(Ai(f<<24>>24,16,e,A+180|0,A+8|0,0,o,A+16|0,A+12|0,A+208|0))break i;K1(s);continue}break}return X2(r,i[A+180>>2]-e|0),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=a2(),i[A>>2]=n,(Lo(e,f,A)|0)!=1&&(i[k>>2]=4),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+252>>2],s2(r),s2(o),v=A+256|0,e|0}function QG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]>=2){t1(A,e,7911);break r}if(W=e,g=F0(r),i[W+104>>2]=g,l[e+97|0]==1&&(n=F0(r),u[e+112|0]=1,i[e+108>>2]=n),_=F0(r),K4(A,e+128|0,_<<3,f,13760),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(_){for(;;){w=F0(r),f=F0(r),n=i[e+120>>2],t=i[e+124>>2];A:{if(n>>>0<t>>>0){i[n>>2]=w,i[n+4>>2]=f,f=n+8|0;break A}if(h=i[e+116>>2],n=n-h|0,B=n>>3,o=B+1|0,o>>>0>=536870912)break e;if(t=t-h|0,s=t>>2,t=t>>>0>=2147483640?536870911:s>>>0>o>>>0?s:o,t){if(t>>>0>=536870912)break i;o=E(t<<3)}else o=0;if(s=o+n|0,i[s>>2]=w,i[s+4>>2]=f,w=s-(B<<3)|0,n&&z(w,h,n),i[e+124>>2]=o+(t<<3),f=s+8|0,i[e+120>>2]=f,i[e+116>>2]=w,!h)break A;Z(h)}if(i[e+120>>2]=f,l[r+20|0]!=1){if(m=m+1|0,(m|0)==(_|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}v=k+32|0;return}G0(),H()}x0(),H()}function IG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,30616,18);i:{e:switch(i[e+100>>2]+1|0){case 1:Y(f+8|0,33259,9);break i;case 2:Y(f+8|0,33230,11);break i;case 0:break e;default:break i}Y(f+8|0,33464,8)}e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function hn(A,e){var r=0,f=0,k=0,n=0,t=0;f=v-16|0,v=f;i:{e:switch(k2(e-8|0,29)|0){case 0:if(!f4(A,1))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(X[i[i[k>>2]+16>>2]](k,f+6|0,1)|0)){i8(A),k=0;break r}k=l[f+6|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i;case 1:if(!f4(A,2))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(X[i[i[k>>2]+16>>2]](k,f+7|0,2)|0)){i8(A),k=0;break r}A=l[f+7|0],k=l[f+8|0]|A<<8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i;case 2:if(!f4(A,3))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(X[i[i[e>>2]+16>>2]](e,f+9|0,3)|0)){i8(A),n=0;break r}e=l[f+10|0],A=0,t=e<<8,e=l[f+9|0],k=l[f+11|0]|(e<<16|t),n=A|n}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r);break i;case 3:if(!f4(A,4))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(X[i[i[e>>2]+16>>2]](e,f+12|0,4)|0)){i8(A),n=0;break r}e=l[f+13|0],A=0,t=e<<16,e=l[f+12|0],e=e<<24|t,t=A|k,A=l[f+14|0],k=l[f+15|0]|(A<<8|e),n=n|t}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r);break i;case 7:break e;default:break i}k=R4(A),n=l0}return v=f+16|0,l0=n,k}function CG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-320|0,v=A,i[A+312>>2]=r,i[A+316>>2]=e,e=v-16|0,v=e,o=A+196|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=e+16|0,t=A+16|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129800),X[i[i[e>>2]+48>>2]](e,77792,77818,A+208|0)|0,e2(t),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,X2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=t,i[A+8>>2]=0;;){i:{if(q2(A+316|0,A+312|0))break i;t=i[A+180>>2],l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,(t|0)==(f+e|0)&&(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,X2(r,f<<1),X2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+316|0,f=i[s>>2],t=i[f+12>>2];e:{if((t|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[t>>2]}if(ki(f,16,e,A+180|0,A+8|0,0,o,A+16|0,A+12|0,A+208|0))break i;a1(s);continue}break}return X2(r,i[A+180>>2]-e|0),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=a2(),i[A>>2]=n,(Lo(e,f,A)|0)!=1&&(i[k>>2]=4),q2(A+316|0,A+312|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+316>>2],s2(r),s2(o),v=A+320|0,e|0}function VG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=p8(f),w=Ce(f,A+208|0),Qe(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(q2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=ct(r,i[A+180>>2],k,o),i[h>>2]=_,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),q2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function FG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=p8(f),w=Ce(f,A+208|0),Qe(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(q2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=Fu(r,i[A+180>>2],k,o),i[h>>2]=_,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),q2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function EG(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;s=v-256|0,v=s,i[s+248>>2]=37,i[s+252>>2]=0,h=s+248|0,_=qr(h|1,19577,i[r+4>>2]),w=s+208|0,i[s+204>>2]=w,A=a2();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=t,i[B+4>>2]=o,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=h4(w,30,A,h,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=t,i[s+92>>2]=o,A=h4(s+208|0,30,A,s+248|0,s+80|0)}i[s+128>>2]=2071,h=g1(s+196|0,0,s+128|0),w=s+208|0;i:{e:{if((A|0)>=30){A=a2();r:{if(_){w=i[r+8>>2],i[s+16>>2]=t,i[s+20>>2]=o,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=w,A=V8(s+204|0,A,s+248|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=t,i[s+44>>2]=o,A=V8(s+204|0,A,s+248|0,s+32|0)}if((A|0)==-1)break e;k=i[h>>2],i[h>>2]=i[s+204>>2],k&&X[i[h+4>>2]](k),w=i[s+204>>2]}k=w,w=A+w|0,_=x4(k,w,r),i[s+128>>2]=2071,k=s+128|0,n=g1(s+120|0,0,k),t=i[s+204>>2];r:{if((t|0)==(s+208|0)){A=k;break r}if(A=p2(A<<1),!A)break e;k=i[n>>2],i[n>>2]=A,k&&X[i[n+4>>2]](k),t=i[s+204>>2]}o=s+108|0,k=i[r+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),rn(t,_,w,A,s+116|0,s+112|0,o),e2(o),A=O8(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&X[i[n+4>>2]](e),e=i[h>>2],i[h>>2]=0,e&&X[i[h+4>>2]](e),v=s+256|0;break i}Q1(),H()}return A|0}function pG(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;s=v-416|0,v=s,i[s+408>>2]=37,i[s+412>>2]=0,h=s+408|0,_=qr(h|1,19577,i[r+4>>2]),w=s+368|0,i[s+364>>2]=w,A=a2();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=t,i[B+4>>2]=o,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=h4(w,30,A,h,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=t,i[s+92>>2]=o,A=h4(s+368|0,30,A,s+408|0,s+80|0)}i[s+128>>2]=2071,h=g1(s+356|0,0,s+128|0),w=s+368|0;i:{e:{if((A|0)>=30){A=a2();r:{if(_){w=i[r+8>>2],i[s+16>>2]=t,i[s+20>>2]=o,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=w,A=V8(s+364|0,A,s+408|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=t,i[s+44>>2]=o,A=V8(s+364|0,A,s+408|0,s+32|0)}if((A|0)==-1)break e;k=i[h>>2],i[h>>2]=i[s+364>>2],k&&X[i[h+4>>2]](k),w=i[s+364>>2]}k=w,w=A+w|0,_=x4(k,w,r),i[s+128>>2]=2071,k=s+128|0,n=g1(s+120|0,0,k),t=i[s+364>>2];r:{if((t|0)==(s+368|0)){A=k;break r}if(A=p2(A<<3),!A)break e;k=i[n>>2],i[n>>2]=A,k&&X[i[n+4>>2]](k),t=i[s+364>>2]}o=s+108|0,k=i[r+28>>2],i[o>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),en(t,_,w,A,s+116|0,s+112|0,o),e2(o),A=j8(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&X[i[n+4>>2]](e),e=i[h>>2],i[h>>2]=0,e&&X[i[h+4>>2]](e),v=s+416|0;break i}Q1(),H()}return A|0}function T8(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),w=c0(r,129800),e2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(t|0)==(o|0))break i;e:{if(q2(s+12|0,s+8|0))break e;r:{if((X[i[i[w>>2]+52>>2]](w,i[t>>2],0)|0)==37){if((t+4|0)==(o|0))break e;r=0;f:{A:{if(e=X[i[i[w>>2]+52>>2]](w,i[t+4>>2],0)|0,(e|0)==69||(h=4,(e&255)==48))break A;break f}if((t+8|0)==(o|0))break e;h=8,r=e,e=X[i[i[w>>2]+52>>2]](w,i[t+8>>2],0)|0}_=s,B=X[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,t=(t+h|0)+4|0;break r}if(X[i[i[w>>2]+12>>2]](w,1,i[t>>2])|0){for(;t=t+4|0,!!((o|0)!=(t|0)&&X[i[i[w>>2]+12>>2]](w,1,i[t>>2])|0););for(;;){if(r=s+12|0,q2(r,s+8|0))break r;e=i[r>>2],h=i[e+12>>2];f:{if((h|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break f}e=i[h>>2]}if(!(X[i[i[w>>2]+12>>2]](w,1,e)|0))break r;a1(r)}}h=s+12|0,e=i[h>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break f}e=i[r>>2]}if((X[i[i[w>>2]+28>>2]](w,e)|0)==(X[i[i[w>>2]+28>>2]](w,i[t>>2])|0)){t=t+4|0,a1(h);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return q2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function _n(A,e){var r=0,f=0,k=0,n=0,t=0;i:{e:{r:{f:{A:{r=i[A+4>>2];k:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break k}r=j2(A)}switch(r-43|0){case 0:case 2:break A;default:break f}}t=(r|0)==45,e=!e,r=i[A+4>>2];A:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break A}r=j2(A)}if(f=r-58|0,e|f>>>0>4294967285)break r;if(i[A+116>>2]<0)break e;i[A+4>>2]=i[A+4>>2]-1;break e}f=r-58|0}if(f>>>0<4294967286)break e;r:{if(r-48>>>0>=10)break r;for(;;){k=(G(k,10)+r|0)-48|0,n=(k|0)<214748364,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break f}r=j2(A)}if(e=r-48|0,!(n&e>>>0<=9))break}if(n=k>>31,e>>>0>=10)break r;for(;;){e=r,r=O0(k,n,10,0),f=e+r|0,e=l0,k=f-48|0,f=(r>>>0>f>>>0?e+1|0:e)-(f>>>0<48)|0,n=f,f=k>>>0<2061584302&(f|0)<=21474836|(f|0)<21474836,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break f}r=j2(A)}if(e=r-48|0,!(f&e>>>0<=9))break}if(e>>>0>=10)break r;for(;;){e=i[A+4>>2];f:{if((e|0)!=i[A+104>>2]){i[A+4>>2]=e+1,e=l[e|0];break f}e=j2(A)}if(!(e-48>>>0<10))break}}e=i[A+116>>2],(e|0)>0?e=1:e=(e|0)>=0,e&&(i[A+4>>2]=i[A+4>>2]-1),A=k,k=t?0-A|0:A,n=t?0-(((A|0)!=0)+n|0)|0:n;break i}if(n=-2147483648,i[A+116>>2]<0)break i;return i[A+4>>2]=i[A+4>>2]-1,l0=-2147483648,0}return l0=n,k}function yG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=p8(f),Ie(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77792))break i;K1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=Fu(r,i[A+180>>2],k,o),i[w>>2]=h,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function YG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=p8(f),Ie(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77792))break i;K1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=ct(r,i[A+180>>2],k,o),i[w>>2]=h,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function RG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=p8(f),w=Ce(f,A+208|0),Qe(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(q2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=eu(r,i[A+180>>2],k,o),Q[h>>1]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),q2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function JG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0;g=v-80|0,v=g;i:{if(!(r&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}f=g+8|0,i[f>>2]=0,i[f+4>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0;e:{if(l[e+12|0]==1){k=t0[e+24>>3],n=t0[e+32>>3],w=k*n,t=t0[e+16>>3],s=t0[e+40>>3],_=t*s,o=w-_,t0[f+40>>3]=o+o,o=t*k,B=n*s,h=o+B,t0[f+24>>3]=h+h,h=t*n,s=k*s,m=h+s,t0[f+16>>3]=m+m,o=o-B,t0[f+8>>3]=o+o,t=t*t,n=n*n,o=t+n,t0[f+32>>3]=1-(o+o),o=k*k,k=o+n,t0[f>>3]=1-(k+k),n=t+o,n=1-(n+n),t=w+_,t=t+t,k=h-s,k=k+k;break e}k=t0[e+56>>3]*.017453292519943295,t=VA(k),s=CA(k),n=t0[e+48>>3]*.017453292519943295,k=VA(n),n=CA(n),w=t0[e+64>>3],o=s*0,C=o+(0-t),_=C*0,B=t*0+(s+0),t0[f+24>>3]=_+(k*B+n*0),t0[f>>3]=_+(n*B+k*-0),w=w*.017453292519943295,_=CA(w),W=t*-0,w=VA(w),h=w*-0,V=s*_+(W+h),y=V*0,h=t*_+(o+h),m=_*0,I=m+(0-w),t0[f+40>>3]=y+(k*h+n*I),W=s*w+(W+m),R=W*0,t=t*w+(o+m),s=w*0+(_+0),t0[f+32>>3]=R+(k*t+n*s),t0[f+16>>3]=y+(n*h-I*k),t0[f+8>>3]=R+(n*t-s*k),n=V+(h*0+I*0),t=W+(t*0+s*0),k=C+(B*0+0)}t0[f+64>>3]=n,t0[f+56>>3]=t,t0[f+48>>3]=k,z(r,f,72),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}v=g+80|0}function NG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;s=v-16|0,v=s,n=E(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=95940,i[n>>2]=96148,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(ui(n+20|0,f),(f|0)<=0))break i;if(o=i[n+20>>2],(f|0)!=1)for(W=f&2147483646;t=h<<3,w=t+o|0,B=r+t|0,i[w>>2]=i[B>>2],i[w+4>>2]=i[B+4>>2],t=t|8,w=t+o|0,t=r+t|0,i[w>>2]=i[t>>2],i[w+4>>2]=i[t+4>>2],h=h+2|0,m=m+2|0,(W|0)!=(m|0););if(!(f&1))break i;f=h<<3,o=f+o|0,r=r+f|0,i[o>>2]=i[r>>2],i[o+4>>2]=i[r+4>>2]}u[n+16|0]=1,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=E(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;X[i[i[n>>2]+8>>2]](n),p(n)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[n+4>>2],i[n+4>>2]=A-1,A||(X[i[i[n>>2]+8>>2]](n),p(n)),v=s+16|0}function MG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;s=v-16|0,v=s,n=E(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=95940,i[n>>2]=96148,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(ui(n+20|0,f),(f|0)<=0))break i;if(o=i[n+20>>2],(f|0)!=1)for(W=f&2147483646;t=h<<3,w=t+o|0,B=r+t|0,i[w>>2]=i[B>>2],i[w+4>>2]=i[B+4>>2],t=t|8,w=t+o|0,t=r+t|0,i[w>>2]=i[t>>2],i[w+4>>2]=i[t+4>>2],h=h+2|0,m=m+2|0,(W|0)!=(m|0););if(!(f&1))break i;f=h<<3,o=f+o|0,r=r+f|0,i[o>>2]=i[r>>2],i[o+4>>2]=i[r+4>>2]}u[n+16|0]=0,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=E(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;X[i[i[n>>2]+8>>2]](n),p(n)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[n+4>>2],i[n+4>>2]=A-1,A||(X[i[i[n>>2]+8>>2]](n),p(n)),v=s+16|0}function Bn(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=p8(f),w=Ce(f,A+208|0),Qe(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(q2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=ou(r,i[A+180>>2],k,o),i[h>>2]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),q2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function UG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=p8(f),w=Ce(f,A+208|0),Qe(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(q2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=bt(r,i[A+180>>2],k,o),i[h>>2]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),q2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function DG(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;A=v-624|0,v=A,i[A+616>>2]=r,i[A+620>>2]=e,i[A+16>>2]=2072,e=A+16|0,s=g1(A+200|0,A+208|0,e),w=A+192|0,o=i[k+28>>2],i[w>>2]=o,(o|0)!=129624&&(i[o+4>>2]=i[o+4>>2]+1),o=c0(w,129800),u[A+191|0]=0;i:{if(!q7(A+620|0,r,f,w,i[k+4>>2],n,A+191|0,o,s,A+196|0,A+608|0))break i;r=l[21100]|l[21101]<<8|(l[21102]<<16|l[21103]<<24),u[A+183|0]=r,u[A+184|0]=r>>>8,u[A+185|0]=r>>>16,u[A+186|0]=r>>>24,r=l[21097]|l[21098]<<8|(l[21099]<<16|l[21100]<<24),i[A+176>>2]=l[21093]|l[21094]<<8|(l[21095]<<16|l[21096]<<24),i[A+180>>2]=r,X[i[i[o>>2]+48>>2]](o,A+176|0,A+186|0,A+128|0)|0,i[A+16>>2]=2071,f=g1(A+8|0,0,e),k=e;e:{if(e=i[A+196>>2]-i[s>>2]|0,(e|0)>=393&&(r=p2((e>>2)+2|0),e=i[f>>2],i[f>>2]=r,e&&X[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(l[A+191|0]==1&&(u[k|0]=45,k=k+1|0),r=i[s>>2];;){if(u0[A+196>>2]<=r>>>0)r:{if(u[k|0]=0,i[A>>2]=t,(bl(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&X[i[f+4>>2]](e);break i}else{e=A+128|0,h=k,_=l[(A+176|0)+(Bk(e,e+40|0,r)-e>>2)|0],u[h|0]=_,k=k+1|0,r=r+4|0;continue}break}Q1(),H()}Q1(),H()}return q2(A+620|0,A+616|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+620>>2],e2(A+192|0),e=i[s>>2],i[s>>2]=0,e&&X[i[s+4>>2]](e),v=A+624|0,r|0}function HG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+64>>2])break i;e:{if(f=i[A+68>>2],f){if(r=i[A+92>>2],r&16){if(i[A+24>>2]!=i[A+20>>2]&&(e=-1,(X[i[i[A>>2]+52>>2]](A,-1)|0)==-1))break i;for(f=A+72|0;;){if(e=i[A+68>>2],r=i[A+32>>2],r=X[i[i[e>>2]+20>>2]](e,f,r,r+i[A+52>>2]|0,k+12|0)|0,n=i[A+32>>2],e=i[k+12>>2]-n|0,(L1(n,1,e,i[A+64>>2])|0)!=(e|0))break e;r:switch(r-1|0){case 1:break e;case 0:continue;default:break r}break}if(e=0,!n6(i[A+64>>2]))break i;break e}if(!(r&8))break i;e=i[A+84>>2],i[k>>2]=i[A+80>>2],i[k+4>>2]=e;r:{f:{A:{if(l[A+98|0]==1){e=i[A+16>>2]-i[A+12>>2]|0,f=e>>31;break A}if(r=X[i[i[f>>2]+24>>2]](f)|0,e=i[A+40>>2]-i[A+36>>2]|0,f=e>>31,(r|0)>0){r=G(r,i[A+16>>2]-i[A+12>>2]|0),f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f;break A}if(i[A+12>>2]!=i[A+16>>2])break f}r=0;break r}r=i[A+68>>2],r=X[i[i[r>>2]+32>>2]](r,k,i[A+32>>2],i[A+36>>2],i[A+12>>2]-i[A+8>>2]|0)|0,r=i[A+36>>2]-(r+i[A+32>>2]|0)|0,f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f,r=1}if(W3(i[A+64>>2],0-e|0,0-(f+((e|0)!=0)|0)|0,1))break e;r&&(e=i[k+4>>2],i[A+72>>2]=i[k>>2],i[A+76>>2]=e),e=i[A+32>>2],i[A+40>>2]=e,i[A+36>>2]=e,e=0,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+92>>2]=0;break i}Q1(),H()}e=-1}return v=k+16|0,e|0}function xG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-80|0,v=k,X[i[i[e>>2]+112>>2]](k+48|0,e);i:{e:switch(l[k+68|0]){default:_2(),H();case 1:if(e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,A=A+8|0,u[k+67|0]>=0){e=i[k+60>>2],i[A>>2]=i[k+56>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+64>>2];break i}T(A,i[k+56>>2],i[k+60>>2]);break i;case 0:break e}t=i[k+48>>2],n=i[k+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),X[i[i[t>>2]+20>>2]](k+24|0,t,r,f);e:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break e}i[r>>2]|F[e+10>>1]||(i[r>>2]=1,i[f>>2]=3),e=i[26929],i[k>>2]=i[26928],i[k+4>>2]=e,e=k+8|0;r:{if(u[107731]>=0){r=i[26931],i[e>>2]=i[26930],i[e+4>>2]=r,i[e+8>>2]=i[26932];break r}T(e,i[26930],i[26931])}if(u[k+19|0]<0&&Z(i[k+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}if(u[k+43|0]<0&&Z(i[k+32>>2]),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n)}A=l[k+68|0],(A|0)!=255&&(e=i[25189],i[k+24>>2]=i[25188],i[k+28>>2]=e,X[i[(k+24|0)+(A<<2)>>2]](k+79|0,k+48|0)),v=k+80|0}function vn(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=p8(f),Ie(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77792))break i;K1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=ou(r,i[A+180>>2],k,o),i[w>>2]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function zG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=p8(f),Ie(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77792))break i;K1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=bt(r,i[A+180>>2],k,o),i[w>>2]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function TG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=p8(f),Ie(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(P2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,X2(e,f<<1),X2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=X[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77792))break i;K1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=eu(r,i[A+180>>2],k,o),Q[w>>1]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),P2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function SG(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,i[A+16>>2]=2072,e=A+16|0,s=g1(A+152|0,A+160|0,e),w=A+144|0,o=i[k+28>>2],i[w>>2]=o,(o|0)!=129624&&(i[o+4>>2]=i[o+4>>2]+1),o=c0(w,129808),u[A+143|0]=0;i:{if(!P7(A+268|0,r,f,w,i[k+4>>2],n,A+143|0,o,s,A+148|0,A+260|0))break i;r=l[21100]|l[21101]<<8|(l[21102]<<16|l[21103]<<24),u[A+135|0]=r,u[A+136|0]=r>>>8,u[A+137|0]=r>>>16,u[A+138|0]=r>>>24,r=l[21097]|l[21098]<<8|(l[21099]<<16|l[21100]<<24),i[A+128>>2]=l[21093]|l[21094]<<8|(l[21095]<<16|l[21096]<<24),i[A+132>>2]=r,X[i[i[o>>2]+32>>2]](o,A+128|0,A+138|0,A+118|0)|0,i[A+16>>2]=2071,f=g1(A+8|0,0,e),k=e;e:{if(e=i[A+148>>2]-i[s>>2]|0,(e|0)>=99&&(r=p2(e+2|0),e=i[f>>2],i[f>>2]=r,e&&X[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(l[A+143|0]==1&&(u[k|0]=45,k=k+1|0),r=i[s>>2];;){if(u0[A+148>>2]<=r>>>0)r:{if(u[k|0]=0,i[A>>2]=t,(bl(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&X[i[f+4>>2]](e);break i}else{e=A+118|0,h=k,_=l[((vk(e,e+10|0,r)-A|0)+A|0)+10|0],u[h|0]=_,k=k+1|0,r=r+1|0;continue}break}Q1(),H()}Q1(),H()}return P2(A+268|0,A+264|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+268>>2],e2(A+144|0),e=i[s>>2],i[s>>2]=0,e&&X[i[s+4>>2]](e),v=A+272|0,r|0}function jG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+100>>2]=0,i[f+72>>2]=72244,i[f+16>>2]=72224,r=i[18065],i[f+8>>2]=r,k=i[r-12>>2],t=f+8|0,r=t,i[k+r>>2]=i[18066],i[f+12>>2]=0,r=r+i[i[f+8>>2]-12>>2]|0,k=f+20|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18067],i[f+16>>2]=r,n=f+16|0,i[n+i[r-12>>2]>>2]=i[18068],r=i[18064],i[f+8>>2]=r,i[t+i[r-12>>2]>>2]=i[18069],i[f+72>>2]=72244,i[f+8>>2]=72204,i[f+16>>2]=72224,t=R0(k),i[t>>2]=71280,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+68>>2]=24,r=i[e+4>>2];i:{if(!r){Y(n,21044,18);break i}Y(I0(n,r),21055,7)}if(r=i[e+8>>2],e=i[e+12>>2],(r|0)!=(e|0))for(;k=i[r>>2],u[f+159|0]=32,I0(Y(n,f+159|0,1),k),r=r+4|0,(e|0)!=(r|0););e=i[f+68>>2];i:{e:{if(e&16){r=i[f+64>>2],e=i[f+44>>2],r>>>0<e>>>0&&(i[f+64>>2]=e,r=e),e=f+40|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+36>>2],e=f+28|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,n,r)}u[A+r|0]=0,A=i[18063],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18071],i[f+16>>2]=i[18072],i[t>>2]=71280,u[f+63|0]<0&&Z(i[f+52>>2]),y0(t),p0(f+72|0),v=f+160|0}function OG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]),u[e+100|0]&1&&(h=e,_=F0(r),i[h+104>>2]=_,h=e,_=F0(r),i[h+108>>2]=_),h=e,_=W2(r),u[h+112|0]=_,t=F0(r),i[e+116>>2]=t;i:{e:{if(!(!f|t>>>0<=u0[f+80>>2])){if(e=E(72),i[k+20>>2]=e,i[k+24>>2]=71,i[k+28>>2]=-2147483576,z(e,24116,71),u[e+71|0]=0,K(A,6,1e3,k+20|0),u[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(!l[e+112|0]){if(K4(A,e+132|0,t,f,13651),i[A>>2])break e;u[A+19|0]<0&&Z(i[A+8>>2]),n=i[e+124>>2],t=i[e+120>>2],s=n-t|0,f=i[e+116>>2];r:{if(s>>>0<f>>>0){if(w=f-s|0,o=i[e+128>>2],w>>>0<=o-n>>>0){w&&o0(n,0,w),i[e+124>>2]=n+w;break r}if((f|0)<0)break i;if(n=o-t|0,o=n<<1,o=n>>>0>=1073741823?2147483647:f>>>0<o>>>0?o:f,n=E(o),w&&o0(n+s|0,0,w),s&&z(n,t,s),i[e+128>>2]=n+o,i[e+124>>2]=f+n,i[e+120>>2]=n,!t)break r;Z(t);break r}if(f>>>0>=s>>>0)break r;i[e+124>>2]=f+t}l6(r,i[e+120>>2],i[e+116>>2])}if(l[r+20|0]==1){if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=k+32|0;return}G0(),H()}function $2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;n=i[A+16>>2],k=i[A+20>>2],f=i[A+4>>2],r=i[A+24>>2],_=i[A+12>>2],t=_;i:{for(;;){B=A;e:{if((r|0)>0){w=k;break e}r=64-r|0;r:{f:{if(!t)break f;W=0;A:{for(;;){if(o=f+1|0,i[A+4>>2]=o,w=l[f|0],t=t-1|0,i[A+12>>2]=t,m=r-8|0,f=m&31,(m&63)>>>0>=32?(s=w<<f,f=0):(s=(1<<f)-1&w>>>32-f,f=w<<f),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,(r|0)<=15)break A;if(W=W-(r>>>0<8)|0,r=r-8|0,f=o,!t)break}_=t;break f}_=t,f=o;break r}t=0,m=r}w=k,r=64-m|0}if(o=r,r=r-1|0,i[B+24>>2]=r,s=w<<1|n>>>31,n=n<<1,i[A+16>>2]=n,k=s,i[A+20>>2]=k,(w|0)>0|(w|0)>=0){if(h=h+1|0,(h|0)!=21)continue;break i}break}if(g=e,h){if(m=A,!((o|0)>(h|0)|(o|0)>57)){for(r=65-o|0,W=0;;){e:{if(t=r,!_){e=r;break e}if(o=f+1|0,i[A+4>>2]=o,f=l[f|0],_=_-1|0,i[A+12>>2]=_,e=t-8|0,B=e&31,(e&63)>>>0>=32?(s=f<<B,f=0):(s=(1<<B)-1&f>>>32-B,f=f<<B),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,f=r,r=r-8|0,W=W-(f>>>0<8)|0,f=o,(t|0)>15)continue}break}r=64-e|0}i[m+24>>2]=r-h,r=n,e=h&31,(h&63)>>>0>=32?(s=r<<e,e=0):(s=(1<<e)-1&r>>>32-e|k<<e,e=r<<e),i[A+16>>2]=e,i[A+20>>2]=s,e=64-h|0,A=e&31,(e&63)>>>0>=32?A=k>>>A|0:A=((1<<A)-1&k)<<32-A|r>>>A,A=A+(-1<<h^-1)|0}else A=0;i[g>>2]=A}return w>>>31|0}function LG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-48|0,v=f;i:{e:{r:{f:{A:{if(r=i[e+104>>2],e=i[e+108>>2],(r|0)!=(e|0))for(;;){k:{if(k=i[r>>2],!k||(k=X0(k,86628,99924),!k))break k;if(r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+20>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,z9(k,f+12|0))break r;if(u[f|0]=0,u[f+11|0]=0,e=K(f+24|0,2,117,f),k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,k=A+8|0,u[e+19|0]<0)break A;n=i[e+12>>2],i[k>>2]=i[e+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(r=r+8|0,(e|0)==(r|0))break}u[f+12|0]=0,u[f+23|0]=0,e=K(f+24|0,2,141,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(T(k,i[e+8>>2],i[e+12>>2]),k=u[e+19|0],u[A+20|0]=1,(k|0)>=0)break f;Z(i[e+8>>2])}if(u[f+11|0]<0&&Z(i[f>>2]),A=i[f+12>>2],!A)break e;i[f+16>>2]=A,Z(A);break e}e=i[f+16>>2],k=i[f+12>>2],n=i[f+20>>2],u[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=k,i[A+4>>2]=e}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}v=f+48|0}function PG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+4>>2]=1,f=i[A+8>>2],i[f+324>>2]=i[f+324>>2]-1,i[f+328>>2]=i[f+328>>2]+1,f=i[A+12>>2],n=f+1|0,r=i[A+8>>2],e=i[r+124>>2],s=i[e+16884>>2]/4|0,w=i[r+276>>2],o=i[e+16892>>2],k=o-1|0,t=i[r+272>>2],h=l[A+16|0];i:{if(h){e=i[e+16900>>2]-1|0,F8(r,A,k,(e|0)<(n|0)?e:n,1);break i}if((f|0)<=0?e=f:(F8(r,A,k,f-1|0,2),r=i[A+8>>2],e=i[A+12>>2]),F8(r,A,k,e,2),r=i[A+12>>2]+1|0,e=i[A+8>>2],(r|0)>=i[i[e+124>>2]+16900>>2])break i;F8(e,A,k,r,2)}e=i[A+12>>2],r=i[A+8>>2];i:{e:{if(l[A+16|0]==1){if(e=u9(r,e),r=i[A+8>>2],u[(i[r+140>>2]+G(G(i[r+152>>2],i[A+12>>2]),24)|0)+21|0]=e,!e)break i;k=l[A+16|0];break e}if(k=0,l[(i[r+140>>2]+G(G(e,i[r+152>>2]),24)|0)+21|0]!=1)break i}f=G(f,s),e=G(n,s),e=(e|0)<(w|0)?e:w,Qf(r,k&1,f,e,t),r=l[A+16|0],k=i[A+8>>2];e:{if(i[i[k+124>>2]+16832>>2]>=9){vf(k,r&1,f,e,t);break e}mf(k,r&1,f,e,t)}if(r=i[A+8>>2],n=i[r+124>>2],!i[n+16848>>2])break i;if(k=l[A+16|0],i[n+16840>>2]>=9){Xf(r,k&1,f,e,t);break i}gf(r,k&1,f,e,t)}if(r=0,(o|0)>0)for(f=h?2:3;e=i[A+8>>2],e=(i[e+320>>2]+G(r,76)|0)+G(G(i[A+12>>2],i[i[e+124>>2]+16892>>2]),76)|0,(f|0)>i[e>>2]&&(i[e>>2]=f),r=r+1|0,(o|0)!=(r|0););i[A+4>>2]=3,h3(i[A+8>>2])}function qG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,x2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(l[e+97|0]){t1(A,e,11373);break i}if(n=F0(r),(n|0)<0){if(e=E(32),i[k>>2]=e,i[k+4>>2]=30,i[k+8>>2]=-2147483616,r=l[22430]|l[22431]<<8|(l[22432]<<16|l[22433]<<24),f=l[22426]|l[22427]<<8|(l[22428]<<16|l[22429]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[22452]|l[22453]<<8|(l[22454]<<16|l[22455]<<24),f=l[22448]|l[22449]<<8|(l[22450]<<16|l[22451]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[22446]|l[22447]<<8|(l[22448]<<16|l[22449]<<24),f=l[22442]|l[22443]<<8|(l[22444]<<16|l[22445]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22438]|l[22439]<<8|(l[22440]<<16|l[22441]<<24),f=l[22434]|l[22435]<<8|(l[22436]<<16|l[22437]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,K(A,6,1e3,k),u[k+11|0]>=0)break i;Z(i[k>>2]);break i}d6(A,e,r,n,f)}v=k+32|0}function KG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(I0(Y(I0(Y(f+8|0,19203,14),i[e+100>>2]),26343,1),i[e+104>>2]),26343,1),i[e+108>>2]),41737,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function aG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,30734,10),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function $G(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,32574,12),r=u[e+111|0],k=(r|0)<0,Y(Y(t,k?i[e+100>>2]:e+100|0,k?i[e+104>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function dG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,31771,21),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function cG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,31986,19),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function bG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18141],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,o=R0(n),i[o>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,M1(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,30987,5),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[o>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(o),p0(f- -64|0),v=f+160|0}function f2(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=i[A+8>>2],r=i[A+12>>2],n=i[A+16>>2];i:{for(;;){e:{if((n|0)>0){e=r,f=n;break e}for(f=64-n|0,h=0,n=i[A+4>>2],e=r;;){r:{if(s=f,!n){t=f;break r}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],n=n-1|0,i[A+4>>2]=n,_=A,B=k,t=s-8|0,k=t&31,(t&63)>>>0>=32?(w=r<<k,r=0):(w=(1<<k)-1&r>>>32-k,r=r<<k),k=B|r,r=e|w,e=r,i[_+8>>2]=k,i[_+12>>2]=e,r=f,f=r-8|0,h=h-(r>>>0<8)|0,(s|0)>15)continue}break}f=64-t|0}if(n=f-1|0,i[A+16>>2]=n,w=e<<1|k>>>31,k=k<<1,i[A+8>>2]=k,r=w,i[A+12>>2]=r,(e|0)<0)break i;if(o=o+1|0,(o|0)==21)break}return-99999}if(!o)return 0;if(!((f|0)>(o|0)|(f|0)>57)){for(f=65-f|0,h=0,n=i[A+4>>2];;){i:{if(_=f,!n){t=f;break i}if(e=i[A>>2],i[A>>2]=e+1,e=l[e|0],n=n-1|0,i[A+4>>2]=n,w=A,B=k,t=_-8|0,k=t&31,(t&63)>>>0>=32?(s=e<<k,e=0):(s=(1<<k)-1&e>>>32-k,e=e<<k),k=B|e,i[w+8>>2]=k,r=r|s,i[A+12>>2]=r,e=f,f=e-8|0,h=h-(e>>>0<8)|0,(_|0)>15)continue}break}n=64-t|0}if(i[A+16>>2]=n-o,f=k,e=o&31,(o&63)>>>0>=32?(s=k<<e,f=0):(s=(1<<e)-1&f>>>32-e|r<<e,f=f<<e),i[A+8>>2]=f,i[A+12>>2]=s,A=k,f=64-o|0,e=f&31,(f&63)>>>0>=32?A=r>>>e|0:A=((1<<e)-1&r)<<32-e|A>>>e,A=A+(1<<o)|0,(A|0)>1)return A-1|0;M0(21954,18259,146,18051),H()}function iW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v+-64|0,v=r,C6(r+40|0,i[e+100>>2],i[e+116>>2],r+60|0);i:{if(i[r+40>>2]){e=i[r+44>>2],i[A>>2]=i[r+40>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[r+59|0]>=0){k=i[r+52>>2],i[e>>2]=i[r+48>>2],i[e+4>>2]=k,i[e+8>>2]=i[r+56>>2];break e}T(e,i[r+48>>2],i[r+52>>2])}u[A+20|0]=1;break i}f=r+16|0,r4(f,i[e+100>>2],i[r+60>>2],1),k=i[r+20>>2],e=i[r+16>>2];e:{if(!e){u[r+4|0]=0,u[r+15|0]=0,e=K(f,2,2e3,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;r:{if(u[e+19|0]>=0){n=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break r;Z(i[e+8>>2])}if(u[r+15|0]>=0)break e;Z(i[r+4>>2]);break e}if(X[i[i[e>>2]+52>>2]](r+16|0,e),i[r+16>>2]){if(e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,e=A+8|0,u[r+35|0]>=0){f=i[r+28>>2],i[e>>2]=i[r+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+32>>2],u[A+20|0]=1;break e}if(T(e,i[r+24>>2],i[r+28>>2]),e=u[r+35|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[r+24>>2]);break e}u[r+35|0]<0&&Z(i[r+24>>2]),X[i[i[e>>2]+112>>2]](A,e)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}u[r+59|0]<0&&Z(i[r+48>>2]),v=r- -64|0}function mn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(k=e,k){if(!r)break o;if(!f)break u;if(k=k1(f)-k1(k)|0,k>>>0<=31)break t;break e}if((f|0)==1|f>>>0>1)break e;return e=(A>>>0)/(r>>>0)|0,g6=A-G(e,r)|0,Q6=0,l0=0,e}if(!A)break n;if(!f||(n=f-1|0,n&f))break k;return g6=A,Q6=k&n,A=k>>>e8(f)|0,l0=0,A}if(n=r-1|0,!(n&r))break A;h=(k1(r)+33|0)-k1(k)|0,t=0-h|0;break r}h=k+1|0,t=63-k|0;break r}return g6=0,A=(k>>>0)/(f>>>0)|0,Q6=k-G(A,f)|0,l0=0,A}if(k=k1(f)-k1(k)|0,k>>>0<31)break f;break e}if(g6=A&n,Q6=0,(r|0)==1)break i;return r=e8(r),f=r&31,(r&63)>>>0>=32?(k=0,A=e>>>f|0):(k=e>>>f|0,A=((1<<f)-1&e)<<32-f|A>>>f),l0=k,A}h=k+1|0,t=63-k|0}if(n=A,k=h&63,o=k&31,(k&63)>>>0>=32?(k=0,n=e>>>o|0):(k=e>>>o|0,n=((1<<o)-1&e)<<32-o|n>>>o),o=t&63,t=A,s=o&31,(o&63)>>>0>=32?(w=A<<s,A=0):(w=(1<<s)-1&t>>>32-s|e<<s,A=t<<s),e=w,h)for(t=f-1|0,_=r-1|0,t=(_|0)!=-1?t+1|0:t,o=_;k=k<<1|n>>>31,n=n<<1|e>>>31,_=k,s=t-(k+(n>>>0>o>>>0)|0)|0,B=s>>31,w=B,k=n,s=r&w,n=k-s|0,k=_-((f&w)+(k>>>0<s>>>0)|0)|0,w=e<<1|A>>>31,A=m|A<<1,e=w|W,_=B&1,m=_,h=h-1|0,!!h;);return g6=n,Q6=k,w=e<<1|A>>>31,A=_|A<<1,l0=w|W,A}g6=A,Q6=e,A=0,e=0}return l0=e,A}function Ir(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-16|0,v=n,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=E(r),r&&o0(f,0,r),k=r+f|0,i[n+12>>2]=k,i[n+8>>2]=k,i[n+4>>2]=f}r&&z(f,e,r),f=v-16|0,v=f,e=n+4|0,k=l[i[e>>2]+1|0]>>>3|0;e:{r:{r=i[A+176>>2],t=i[A+180>>2];f:{if((r|0)!=(t|0))for(;;){if((k|0)==l[r+1|0]){if(A=i[r+8>>2],A>>>0<u0[r+12>>2]){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+4>>2],t=i[e>>2],(k|0)!=(t|0)){if(e=k-t|0,(e|0)<0)break r;k=E(e),i[A+4>>2]=k,i[A>>2]=k,o=e+k|0,i[A+8>>2]=o,e&&z(k,t,e),i[A+4>>2]=o}i[r+8>>2]=A+12;break f}s=r,w=p6(r+4|0,e),i[s+8>>2]=w;break f}if(r=r+16|0,(t|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,u[f+1|0]=k,u[f|0]=1,r=p6(f+4|0,e),e=i[A+180>>2],i[f+8>>2]=r;A:{if(e>>>0<u0[A+184>>2]){r=F[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,Q[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],mA(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=Hn(A+176|0,f)}if(i[A+180>>2]=e,e=i[f+4>>2],!e)break f;if(A=e,r=i[f+8>>2],(e|0)!=(r|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(e|0)!=(r|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A)}v=f+16|0;break e}G0(),H()}A=i[n+4>>2],A&&(i[n+8>>2]=A,Z(A)),v=n+16|0;return}G0(),H()}function Cr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0;for(m=v-2048|0,v=m,k=e;s=n,n=n+1|0,w=k>>>0>3,k=k>>>1|0,!!w;);for(k=e;w=t,t=t+1|0,n=k>>>0>3,k=k>>>1|0,!!n;);for(h=1<<s-1,t=0,k=e;n=t,t=n+1|0,o=k>>>0>3,k=k>>>1|0,!!o;);for(y=e&62,R=e&1,C=e-1|0,V=4-n|0,N=w+7|0,o=0;;){for(W=(o<<1)+r|0,_=0;;){if(g=_<<V,k=0,t=0,n=0,C)for(;B=k|1,D=Q[W+(G(B,f)<<1)>>1],I=B,B=(g<<5)+61792|0,t=G(D,u[I+B|0])+(G(Q[W+(G(f,k)<<1)>>1],u[k+B|0])+t|0)|0,k=k+2|0,n=n+2|0,(y|0)!=(n|0););if(n=(G(e,_)+o<<1)+m|0,R&&(t=G(Q[W+(G(f,k)<<1)>>1],u[((g<<5)+k|0)+61792|0])+t|0),Q[n>>1]=t+h>>s,_=_+1|0,(_|0)==(e|0))break}if(o=o+1|0,(o|0)==(e|0))break}for(o=e&62,_=e&1,W=64<<w,f=0;;){for(s=G(e,f),g=(s<<1)+A|0,r=0;;){if(w=r<<V,k=0,t=0,n=0,C)for(;h=k|1,B=Q[(h+s<<1)+m>>1],I=h,h=(w<<5)+61792|0,t=G(B,u[I+h|0])+(G(Q[(k+s<<1)+m>>1],u[k+h|0])+t|0)|0,k=k+2|0,n=n+2|0,(o|0)!=(n|0););if(n=g+(r<<1)|0,_&&(t=G(Q[(k+s<<1)+m>>1],u[((w<<5)+k|0)+61792|0])+t|0),Q[n>>1]=t+W>>N,r=r+1|0,(r|0)==(e|0))break}if(f=f+1|0,(f|0)==(e|0))break}v=m+2048|0}function eW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;if(S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{e:{if(S1(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}if(i[e+32>>2]=f,i[e+44>>2]==4)break e;for(n=A+16|0,t=n+(i[A+12>>2]<<3)|0,f=0;;){r:{f:{A:{k:{if(n>>>0>=t>>>0||(Q[e+52>>1]=0,fk(n,e,r,r,1,k),l[e+54|0]))break k;if(l[e+53|0]!=1)break r;if(l[e+52|0]==1){if(i[e+24>>2]==1||(f=1,o=1,!(l[A+8|0]&2)))break f;break r}if(f=1,u[A+8|0]&1)break r;A=3;break A}A=f?3:4}if(i[e+44>>2]=A,o)break i;break e}i[e+44>>2]=3;break i}n=n+8|0}}if(n=i[A+12>>2],t=A+16|0,s3(t,e,r,f,k),n>>>0<2)break i;if(t=t+(n<<3)|0,n=A+24|0,A=i[A+8>>2],!(!(A&2)&i[e+36>>2]!=1)){for(;;){if(l[e+54|0])break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break}break i}if(!(A&1))for(;;){if(l[e+54|0]|i[e+36>>2]==1)break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break i}for(;;){if(l[e+54|0]|i[e+36>>2]==1&i[e+24>>2]==1)break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break}break i}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;u[e+54|0]=1}}function rW(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,vt(w+44|0,e+6|0,r),u[w+63|0]<0&&Z(i[w+52>>2]),h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+40>>2]=r,i[w+36>>2]=h,r=i[f>>2];i:{e:{r:{if(!l[e+4|0]){if(X[i[r+120>>2]](w+24|0,i[f+4>>2],w+36|0,n,t,o,k),n=i[w+24>>2],n){if(f=i[w+28>>2],k=i[w+32>>2],r=h2(k),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break A}if(u[w+23|0]=r,e=w+12|0,!r)break f}if(!r)break f;z(e,k,r)}if(u[e+r|0]=0,K(A,n,f,w+12|0),u[w+23|0]>=0)break r;Z(i[w+12>>2]);break r}u[e+4|0]=1,r=i[f>>2]}if(X[i[r+124>>2]](w+24|0,i[f+4>>2],w+36|0,s),n=i[w+24>>2],n){if(f=i[w+28>>2],k=i[w+32>>2],r=h2(k),r>>>0>=2147483640)break i;f:{A:{if(r>>>0>=11){t=r|7,e=E(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break A}if(u[w+23|0]=r,e=w+12|0,!r)break f}if(!r)break f;z(e,k,r)}if(u[e+r|0]=0,K(A,n,f,w+12|0),u[w+23|0]>=0)break r;Z(i[w+12>>2]);break r}u[e+68|0]=!i[k+24>>2],s9(A,e,f)}A=i[w+40>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;X[i[i[A>>2]+8>>2]](A),p(A)}v=w- -64|0;return}g0(),H()}g0(),H()}function fW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;k=v-32|0,v=k,Ef(k+8|0,e,r,f);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}m=e,W=o2(r),Q[m+120>>1]=W,m=e,W=o2(r),Q[m+122>>1]=W;e:{if(i[e+112>>2]==i[e+108>>2])break e;r:{for(;;){f:{o=o2(r),h=o2(r),_=o2(r),f=i[e+128>>2],n=i[e+132>>2];A:{if(f>>>0<n>>>0){Q[f+4>>1]=_,Q[f+2>>1]=h,Q[f>>1]=o,f=f+6|0;break A}if(s=i[e+124>>2],w=f-s|0,f=((w|0)/6|0)+1|0,f>>>0>=715827883)break f;if(n=(n-s|0)/6|0,t=n<<1,t=n>>>0>=357913941?715827882:f>>>0<t>>>0?t:f,t){if(t>>>0>=715827883)break r;f=E(G(t,6))}else f=0;if(n=f+w|0,Q[n+4>>1]=_,Q[n+2>>1]=h,Q[n>>1]=o,o=n+G((w|0)/-6|0,6)|0,w&&z(o,s,w),i[e+132>>2]=f+G(t,6),f=n+6|0,i[e+128>>2]=f,i[e+124>>2]=o,!s)break A;Z(s)}if(i[e+128>>2]=f,B=B+1|0,B>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0)continue;break e}break}G0(),H()}x0(),H()}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function b6(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;_=v-16|0,v=_;i:{e:{r:{if((r|0)<=36){if(t=l[A|0],t)break r;n=A;break e}i[31336]=28,f=0,k=0;break i}n=A;r:{for(;;){if(o=t<<24>>24,!((o|0)==32|o-9>>>0<5))break r;if(t=l[n+1|0],n=n+1|0,!t)break}break e}r:switch(o=t&255,o-43|0){case 0:case 2:break r;default:break e}w=(o|0)==45?-1:0,n=n+1|0}e:{if(!((r|16)!=16|l[n|0]!=48)){if(m=1,(l[n+1|0]&223)==88){n=n+2|0,B=16;break e}n=n+1|0,B=r||8;break e}B=r||10}for(r=0;;){e:{o=l[n|0],t=o-48|0;r:{if((t&255)>>>0<10)break r;if((o-97&255)>>>0<=25){t=o-87|0;break r}if((o-65&255)>>>0>25)break e;t=o-55|0}if(t=t&255,(t|0)>=(B|0))break e;$1(_,B,0,0,0,h,s,0,0),o=1;r:{if(i[_+8>>2]|i[_+12>>2]||(W=O0(h,s,B,0),g=l0,(g|0)==-1&(t^-1)>>>0<W>>>0))break r;s=g,h=t+W|0,s=h>>>0<t>>>0?s+1|0:s,m=1,o=r}n=n+1|0,r=o;continue}break}e&&(i[e>>2]=m?n:A);e:{r:{if(r){i[31336]=68,A=f&1,w=A?0:w,h=f,s=k;break r}if((k|0)==(s|0)&f>>>0>h>>>0|k>>>0>s>>>0)break e;A=f&1}if(!(A|w)){i[31336]=68,A=f,f=A-1|0,k=k-!A|0;break i}if((k|0)==(s|0)&f>>>0>=h>>>0|k>>>0>s>>>0)break e;i[31336]=68;break i}A=w^h,f=A-w|0,e=w>>31,k=(e^s)-((A>>>0<w>>>0)+e|0)|0}return v=_+16|0,l0=k,f}function AW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,30101,11),i[e+104>>2]-i[e+100>>2]|0),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function Sf(A,e,r,f,k,n,t,o){var s=0;s=v+-64|0,v=s,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+60>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,Q[s+28>>1]=256,i[s+24>>2]=1,kr(s,s+24|0,f,k,n,t,1,o,e+136|0);i:{if(i[s>>2]){e=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=e,i[A+16>>2]=i[s+16>>2],e=i[s+12>>2],i[A+8>>2]=i[s+8>>2],i[A+12>>2]=e,i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0;break i}t=i[e+128>>2];e:{r:{if(!t){n=e+128|0,o=n;break r}for(;;){if(o=t,f=i[o+16>>2],(f|0)>(r|0)){if(n=o,t=i[o>>2],t)continue;break r}if((r|0)<=(f|0))break e;if(t=i[o+4>>2],!t)break}n=o+4|0}f=E(60),i[f+16>>2]=r,r=i[s+28>>2],i[f+20>>2]=i[s+24>>2],i[f+24>>2]=r,r=i[s+36>>2],i[f+28>>2]=i[s+32>>2],i[f+32>>2]=r,r=i[s+44>>2],i[f+36>>2]=i[s+40>>2],i[f+40>>2]=r,r=i[s+52>>2],i[f+44>>2]=i[s+48>>2],i[f+48>>2]=r,r=i[s+60>>2],i[f+52>>2]=i[s+56>>2],i[f+56>>2]=r,i[f+8>>2]=o,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,r=i[i[e+124>>2]>>2],r&&(i[e+124>>2]=r),m1(i[e+128>>2],f),i[e+132>>2]=i[e+132>>2]+1}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[s+19|0]<0&&Z(i[s+8>>2]),v=s- -64|0}function Zn(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+40>>2])break i;r=E(152),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92292,n=r+16|0,f=n,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,Q[r+112>>1]=0,i[f>>2]=89424,i[r+32>>2]=1952541027,f=r+120|0,u[f+24|0]=0,i[f+16>>2]=0,i[f+20>>2]=2147483647,i[f+8>>2]=-1,i[f+12>>2]=-1,u[f|0]=1,A3(f,i[A+44>>2]),f=i[e>>2],i[k+12>>2]=r,i[k+8>>2]=n,i[r+4>>2]=i[r+4>>2]+1,r2(f+36|0,k+8|0),f=i[k+12>>2];e:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break e;X[i[i[f>>2]+8>>2]](f),p(f)}if(f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[e>>2],f=i[A+180>>2],A=i[e+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+12>>2]=A,i[k+8>>2]=r,r2(f+104|0,k+8|0),A=i[k+12>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=k+16|0}function kW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,30657,10),i[e+100>>2]),42699,15),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function m1(A,e){var r=0,f=0,k=0,n=0;k=(A|0)==(e|0),u[e+12|0]=k;i:{if(k)break i;for(;;){if(k=i[e+8>>2],l[k+12|0])break i;e:{r=i[k+8>>2],f=i[r>>2];r:{if((k|0)==(f|0)){if(n=i[r+4>>2],!(!n|l[n+12|0])){u[k+12|0]=1,u[r+12|0]=(A|0)==(r|0),u[n+12|0]=1;break r}f:{if(i[k>>2]==(e|0)){e=k;break f}e=i[k+4>>2],A=i[e>>2],i[k+4>>2]=A;A:{if(!A){i[e+8>>2]=r,i[r>>2]=e;break A}if(i[A+8>>2]=k,f=i[k+8>>2],A=i[f>>2],i[e+8>>2]=f,(A|0)==(k|0)){i[f>>2]=e;break A}i[f+4>>2]=e}i[e>>2]=k,i[k+8>>2]=e,r=i[e+8>>2],f=i[r>>2]}u[e+12|0]=1,u[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;f:{if(i[A>>2]==(r|0)){i[A>>2]=f;break f}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f;return}if(l[f+12|0]|!f)break e;u[k+12|0]=1,u[r+12|0]=(A|0)==(r|0),u[f+12|0]=1}if(e=r,(A|0)!=(r|0))continue;break i}break}f=i[k>>2];e:{if((f|0)!=(e|0)){f=k;break e}A=i[f+4>>2],i[k>>2]=A,A&&(i[A+8>>2]=k,r=i[k+8>>2]),i[f+8>>2]=r;r:{if((k|0)==i[r>>2]){i[r>>2]=f;break r}i[r+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,r=i[f+8>>2]}u[f+12|0]=1,u[r+12|0]=0,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if(i[A>>2]==(r|0)){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e}}function nW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,32152,10),F[e+98>>1]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function tW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,7973);break r}if(h=F0(r),K4(A,e+116|0,h<<2,f,13805),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(h){for(;;){s=F0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+104>>2],f=f-w|0,_=f>>2,t=_+1|0,t>>>0>=1073741824)break e;if(n=n-w|0,o=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<o>>>0?o:t,n){if(n>>>0>=1073741824)break i;t=E(n<<2)}else t=0;if(o=t+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&z(s,w,f),i[e+112>>2]=t+(n<<2),f=o+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!w)break A;Z(w)}if(i[e+108>>2]=f,l[r+20|0]!=1){if(B=B+1|0,(B|0)==(h|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}v=k+32|0;return}G0(),H()}x0(),H()}function uW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,30843,16),l[e+104|0]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function oW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,4735);break r}if(h=F0(r),K4(A,e+116|0,h<<2,f,13743),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(h){for(;;){s=F0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+104>>2],f=f-w|0,_=f>>2,t=_+1|0,t>>>0>=1073741824)break e;if(n=n-w|0,o=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<o>>>0?o:t,n){if(n>>>0>=1073741824)break i;t=E(n<<2)}else t=0;if(o=t+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&z(s,w,f),i[e+112>>2]=t+(n<<2),f=o+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!w)break A;Z(w)}if(i[e+108>>2]=f,l[r+20|0]!=1){if(B=B+1|0,(B|0)==(h|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break r}T(A,i[26930],i[26931])}v=k+32|0;return}G0(),H()}x0(),H()}function lW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,32548,9),i[e+104>>2]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function sW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,29496,10),l[e+97|0]),42713,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function Y(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;o=v-16|0,v=o,_=G1(o+4|0,A);i:{if(l[_|0]!=1)break i;s=e+r|0,k=i[i[A>>2]-12>>2]+A|0,w=(i[k+4>>2]&176)==32?s:e,t=i[k+24>>2];e:{if(l[k+80|0]==1){r=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break e}f=o+12|0,r=i[k+28>>2],i[f>>2]=r,(r|0)!=129624&&(i[r+4>>2]=i[r+4>>2]+1),r=c0(f,129808),r=X[i[i[r>>2]+28>>2]](r,32)|0,e2(f),u[k+76|0]=r,u[k+77|0]=r>>>8,u[k+78|0]=r>>>16,u[k+79|0]=r>>>24,u[k+80|0]=1}B=r<<24>>24,r=0,f=v-16|0,v=f;e:{r:{f:{if(!t||(n=i[k+12>>2],h=w-e|0,(h|0)>0&&(X[i[i[t>>2]+48>>2]](t,e,h)|0)!=(h|0)))break f;if(e=s-e|0,e=(e|0)<(n|0)?n-e|0:0,(e|0)>0){if(e>>>0>=2147483640)break r;A:{if(e>>>0>=11){r=e|7,n=E(r+1|0),i[f+12>>2]=r-2147483647,i[f+4>>2]=n,i[f+8>>2]=e;break A}u[f+15|0]=e,n=f+4|0}if(e&&o0(n,B,e),r=0,u[e+n|0]=0,n=X[i[i[t>>2]+48>>2]](t,u[f+15|0]<0?i[f+4>>2]:f+4|0,e)|0,u[f+15|0]<0&&Z(i[f+4>>2]),(e|0)!=(n|0))break f}A:{if(e=s-w|0,(e|0)<=0||(X[i[i[t>>2]+48>>2]](t,w,e)|0)==(e|0))break A;break f}i[k+12>>2]=0,r=t}v=f+16|0;break e}g0(),H()}if(r)break i;e=i[i[A>>2]-12>>2]+A|0,H1(e,i[e+16>>2]|5)}return _1(_),v=o+16|0,A}function jf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r)for(;;){e:{r:{if(s=o+2|0,s>>>0>=r>>>0||(k=e+o|0,l[k|0]|l[k+1|0]|l[e+s|0]!=3))break r;n=i[A+8>>2];f:{if(n>>>0>f>>>0){u[f|0]=0,f=f+1|0;break f}if(t=i[A>>2],o=f-t|0,k=o+1|0,(k|0)<0)break i;if(f=n-t|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=E(f):k=0,n=k+o|0,u[n|0]=0,o&&z(k,t,o),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break f;Z(t)}if(i[A+4>>2]=f,n=i[A+8>>2],n>>>0>f>>>0){u[f|0]=0,f=f+1|0;break e}if(t=i[A>>2],o=f-t|0,k=o+1|0,(k|0)<0)break i;if(f=n-t|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=E(f):k=0,n=k+o|0,u[n|0]=0,o&&z(k,t,o),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break e;Z(t);break e}n=e+o|0,w=i[A+8>>2];r:{if(w>>>0>f>>>0){u[f|0]=l[n|0],f=f+1|0;break r}if(t=i[A>>2],s=f-t|0,k=s+1|0,(k|0)<0)break i;if(f=w-t|0,w=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,f?k=E(f):k=0,w=k+s|0,u[w|0]=l[n|0],s&&z(k,t,s),i[A+8>>2]=f+k,f=w+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break r;Z(t)}s=o}if(i[A+4>>2]=f,o=s+1|0,!(o>>>0<r>>>0))break}return}G0(),H()}function Gn(A,e,r){var f=0,k=0,n=0,t=0,o=M(0),s=M(0),w=M(0),h=M(0),_=M(0),B=M(0),m=M(0),W=M(0);f=v-16|0,v=f,i[r>>2]=0,k=B3();i:{if(!k){if(u[f+4|0]=0,u[f+15|0]=0,K(A,6,0,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[k|0]=1,n=f+4|0,XA(n,k,F[e>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],z2(k),u[f+4|0]=0,u[f+15|0]=0,K(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,gA(n,k,F[e+2>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],z2(k),u[f+4|0]=0,u[f+15|0]=0,K(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,WA(n,k,F[e+4>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],z2(k),u[f+4|0]=0,u[f+15|0]=0,K(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[k+16|0]=l[e+6|0],e=F[k+4>>1]-1|0,(e&65535)>>>0<=21&&(e=e<<2&262140,o=E0[e+50816>>2],s=E0[e+50464>>2],w=E0[e+50376>>2],h=E0[e+50288>>2],_=E0[e+50200>>2],B=E0[e+50728>>2],m=E0[e+50640>>2],W=E0[e+50552>>2]),E0[k+48>>2]=o,E0[k+44>>2]=B,E0[k+40>>2]=s,E0[k+36>>2]=w,E0[k+32>>2]=h,E0[k+28>>2]=_,E0[k+24>>2]=m,E0[k+20>>2]=W,i[r>>2]=k,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function t1(A,e,r){var f=0,k=0,n=0,t=0,o=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72244,i[f+20>>2]=72224,n=i[18065],i[f+12>>2]=n,k=i[n-12>>2],n=f+12|0,i[k+n>>2]=i[18066],i[f+16>>2]=0,k=n+i[i[f+12>>2]-12>>2]|0,t=f+24|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[f+20>>2]=k,o=f+20|0,i[o+i[k-12>>2]>>2]=i[18068],k=i[18064],i[f+12>>2]=k,i[n+i[k-12>>2]>>2]=i[18069],i[f+76>>2]=72244,i[f+12>>2]=72204,i[f+20>>2]=72224,n=R0(t),i[n>>2]=71280,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,Y(S0(Y(Y(o,r,h2(r)),28053,18),l[e+97|0]),4165,23),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[f+11|0]=0,r=f;break i}e=i[f+40>>2],r=f+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=E(t+1|0),i[f+8>>2]=t-2147483647,i[f>>2]=r,i[f+4>>2]=e;break e}if(u[f+11|0]=e,r=f,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(r,k,e)}u[e+r|0]=0,K(A,4,3002,f),u[f+11|0]<0&&Z(i[f>>2]),A=i[18063],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[18071],i[f+20>>2]=i[18072],i[n>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(n),p0(f+76|0),v=f+160|0}function wW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n;i:{e:{r:{if(!(i[e+104>>2]-i[e+100>>2]&255)){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}if(w=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+116>>2]-i[e+112>>2]|0)/12&255),l2(r,i[e+104>>2]-i[e+100>>2]&255),f=i[e+100>>2],k=i[e+104>>2],(f|0)!=(k|0))for(;l2(r,l[f|0]),f=f+1|0,(k|0)!=(f|0););if(k=i[e+112>>2],s=i[e+116>>2],(k|0)==(s|0))break e;for(;;){if(i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,f=i[k+4>>2],t=i[k>>2],(f|0)!=(t|0)){f:{if(f=f-t|0,(f|0)>=0){for(o=E(f),f&&z(o,t,f),f=f>>>1|0,h=f>>>0<=1?1:f,f=0;;){t=F[(f<<1)+o>>1];A:{if(l[i[e+100>>2]+f|0]<=8){l2(r,t&255);break A}u2(r,t)}if(f=f+1|0,(h|0)==(f|0))break}break f}G0(),H()}Z(o)}if(k=k+12|0,(s|0)==(k|0))break}break e}T(A,i[26930],i[26931]);break i}if(f1(n,e,r,w),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function s0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=v-160|0,v=r,i[r+104>>2]=0,i[r+76>>2]=72244,i[r+20>>2]=72224,n=i[18065],i[r+12>>2]=n,k=i[n-12>>2],n=r+12|0,i[k+n>>2]=i[18066],i[r+16>>2]=0,k=n+i[i[r+12>>2]-12>>2]|0,t=r+24|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18067],i[r+20>>2]=k,o=r+20|0,i[o+i[k-12>>2]>>2]=i[18068],k=i[18064],i[r+12>>2]=k,i[n+i[k-12>>2]>>2]=i[18069],i[r+76>>2]=72244,i[r+12>>2]=72204,i[r+20>>2]=72224,n=R0(t),i[n>>2]=71280,k=r- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+72>>2]=24;i:{e:{r:{if(i[e>>2]>0){for(;Y(o,27496,2),f=f+1|0,(f|0)<i[e>>2];);if(e=i[r+72>>2],!(e&16))break r}f=i[r+68>>2],e=i[r+48>>2],f>>>0<e>>>0&&(i[r+68>>2]=e,f=e),e=r+44|0;break e}if(!(e&8)){f=0,u[A+11|0]=0;break i}f=i[r+40>>2],e=r+32|0}e:{if(k=i[e>>2],f=f-k|0,f>>>0<2147483640){if(f>>>0>=11){t=f|7,e=E(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=f,A=e;break e}if(u[A+11|0]=f,f)break e;f=0;break i}g0(),H()}if(!f)break i;z(A,k,f)}u[A+f|0]=0,A=i[18063],i[r+12>>2]=A,i[i[A-12>>2]+(r+12|0)>>2]=i[18071],i[r+20>>2]=i[18072],i[n>>2]=71280,u[r+67|0]<0&&Z(i[r+56>>2]),y0(n),p0(r+76|0),v=r+160|0}function hW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-16|0,v=k,e=E(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91732,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,Q[e+118>>1]=0,Q[e+120>>1]=0,Q[e+122>>1]=0,Q[e+124>>1]=0,Q[e+116>>1]=1,Q[e+126>>1]=0,Q[e+128>>1]=0,Q[e+130>>1]=0,Q[e+132>>1]=0,Q[e+134>>1]=0,i[e+160>>2]=-65512,i[e+152>>2]=0,i[e+156>>2]=0,Q[e+144>>1]=1,i[e+136>>2]=4718592,i[e+140>>2]=4718592,i[f>>2]=91772,u[e+159|0]=4,i[e+32>>2]=1835692135,u[e+148|0]=74,u[e+149|0]=80,u[e+150|0]=69,u[e+151|0]=71,n=i[r>>2],o=i[r+4>>2],(n|0)!=(o|0))for(s=e+52|0;;){t=i[n>>2],i[k+8>>2]=t,r=i[n+4>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[t+16>>2]==1785751363&&r2(s,k+8|0),r=i[k+12>>2];i:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(n=n+8|0,(o|0)==(n|0))break}i[A+4>>2]=e,i[A>>2]=f,v=k+16|0}function Of(A,e,r,f,k,n,t,o,s,w,h,_){var B=0;B=v-16|0,v=B,i[B+12>>2]=A;i:{e:{if((A|0)==(n|0)){if(l[e|0]!=1)break e;if(A=0,u[e|0]=0,e=i[k>>2],i[k>>2]=e+1,u[e|0]=46,l[o+11|0]>>>7|0?e=i[o+4>>2]:e=l[o+11|0]&127,!e||(e=i[w>>2],(e-s|0)>159))break i;r=i[h>>2],i[w>>2]=e+4,i[e>>2]=r;break i}r:{if(l[o+11|0]>>>7|0?n=i[o+4>>2]:n=l[o+11|0]&127,!(!n|(A|0)!=(t|0))){if(l[e|0]!=1)break e;if(A=i[w>>2],(A-s|0)>159)break r;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e,A=0,i[h>>2]=0;break i}if(A=Bk(_,_+112|0,B+12|0)-_|0,t=A>>2,(t|0)>27)break e;n=u[t+77792|0];f:{A:{if(A=A&-5,(A|0)!=88){if((A|0)!=96)break A;if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=u[e-1|0],r=u[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,u[e|0]=n;break r}u[r|0]=80;break f}if(A=n-97>>>0<26?n&95:n,(A|0)!=u[r|0]||(u[r|0]=A-65>>>0<26?A|32:A,l[e|0]!=1)||(u[e|0]=0,l[o+11|0]>>>7|0?A=i[o+4>>2]:A=l[o+11|0]&127,!A)||(A=i[w>>2],(A-s|0)>159))break f;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,u[A|0]=n,A=0,(t|0)>21)break i;i[h>>2]=i[h>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function Lf(A,e,r,f,k,n,t,o,s,w,h,_){var B=0;B=v-16|0,v=B,u[B+15|0]=A;i:{e:{if((A|0)==(n|0)){if(l[e|0]!=1)break e;if(A=0,u[e|0]=0,e=i[k>>2],i[k>>2]=e+1,u[e|0]=46,l[o+11|0]>>>7|0?e=i[o+4>>2]:e=l[o+11|0]&127,!e||(e=i[w>>2],(e-s|0)>159))break i;r=i[h>>2],i[w>>2]=e+4,i[e>>2]=r;break i}r:{if(l[o+11|0]>>>7|0?n=i[o+4>>2]:n=l[o+11|0]&127,!(!n|(A|0)!=(t|0))){if(l[e|0]!=1)break e;if(A=i[w>>2],(A-s|0)>159)break r;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e,A=0,i[h>>2]=0;break i}if(t=vk(_,_+28|0,B+15|0)-_|0,(t|0)>27)break e;n=u[t+77792|0];f:{A:switch((t&-2)-22|0){case 2:if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=u[e-1|0],r=u[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,u[e|0]=n;break r;case 0:u[r|0]=80;break f;default:break A}if(A=n-97>>>0<26?n&95:n,(A|0)!=u[r|0]||(u[r|0]=A-65>>>0<26?A|32:A,l[e|0]!=1)||(u[e|0]=0,l[o+11|0]>>>7|0?A=i[o+4>>2]:A=l[o+11|0]&127,!A)||(A=i[w>>2],(A-s|0)>159))break f;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,u[A|0]=n,A=0,(t|0)>21)break i;i[h>>2]=i[h>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function V6(A,e,r,f,k,n,t){var o=0,s=0,w=0;i:{e:{s=i[A+248>>2],o=e>>s;r:{if((o|0)<0||(w=i[A+252>>2],(w|0)<=(o|0)))break r;if(s=r>>s,(s|0)<0|(s|0)>=i[A+256>>2])break e;if(!(l[(o+i[A+240>>2]|0)+G(s,w)|0]>>>k&1)){o=f,f=e;break i}if(o=f-1|0,s=k+1|0,V6(A,e,r,o,s,n,t),k=1<<f>>1,f=k+e|0,V6(A,f,r,o,s,16,t),r=r+k|0,V6(A,e,r,o,s,n,32),e=i[A+248>>2],k=f>>e,(k|0)<0)break r;for(e=r>>e;;){if(n=i[A+252>>2],(n|0)<=(k|0))break r;if((e|0)<0|i[A+256>>2]<=(e|0))break e;if(!(l[(i[A+240>>2]+k|0)+G(e,n)|0]>>>s&1)){n=16,t=32;break i}if(k=o-1|0,s=s+1|0,V6(A,f,r,k,s,16,32),e=1<<o>>1,n=e+f|0,V6(A,n,r,k,s,16,32),r=e+r|0,V6(A,f,r,k,s,16,32),t=i[A+248>>2],e=r>>t,o=k,f=n,k=n>>t,!((k|0)>=0))break}}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}if((o|0)!=31){for(e=1<<o,k=(f|0)/4|0,s=0;w=i[A+272>>2],o=(r+s|0)/4|0,(w|0)<=(k|0)|(o|0)>=i[A+276>>2]||(o=(k+i[A+260>>2]|0)+G(o,w)|0,u[o|0]=l[o|0]|n),s=s+4|0,(e|0)>(s|0););for(k=(r|0)/4|0,r=0;n=(r+f|0)/4|0,o=i[A+272>>2],(n|0)>=(o|0)|(k|0)>=i[A+276>>2]||(n=(n+i[A+260>>2]|0)+G(k,o)|0,u[n|0]=l[n|0]|t),r=r+4|0,(e|0)>(r|0););}}function Wn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-32|0,v=f;i:{if(l[A+52|0]==1){if(r=i[A+48>>2],!e)break i;u[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(l[A+53|0]==1){r=i[A+32>>2];r:{if(i[r+76>>2]<0){r=lt(r);break r}r=lt(r)}if((r|0)!=-1&&(i[f+24>>2]=r),(r|0)==-1)break e;r=i[f+24>>2];r:{if(!e){if(!Wu(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=i[f+24>>2];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(t=he(i[A+32>>2]),(t|0)==-1)break e;u[(f+24|0)+r|0]=t,r=r+1|0;continue}break}w=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],h=i[n+4>>2],o=f+24|0,t=o+k|0;A:switch(s=i[A+36>>2],(X[i[i[s>>2]+16>>2]](s,n,o,t,f+16|0,f+20|0,w,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=h,(k|0)==8||(r=he(i[A+32>>2]),(r|0)==-1))break e;u[t|0]=r,k=k+1|0;continue}break}i[f+20>>2]=u[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Zi(u[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=i[f+20>>2]}r=i[f+20>>2];break i}r=-1}return v=f+32|0,r}function Vr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;m=v-16|0,v=m,h=c0(t,129800),s=m+4|0,t=c0(t,129872),X[i[i[t>>2]+20>>2]](s,t),l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127;i:{if(!o){X[i[i[h>>2]+48>>2]](h,A,r,f)|0,t=(r-A<<2)+f|0,i[n>>2]=t;break i}i[n>>2]=f;e:{r:switch(s=A,o=l[s|0],o-43|0){case 0:case 2:break r;default:break e}s=X[i[i[h>>2]+44>>2]](h,o<<24>>24)|0,o=i[n>>2],i[n>>2]=o+4,i[o>>2]=s,s=A+1|0}for(l[s|0]!=48|(r-s|0)<2|(l[s+1|0]|32)!=120||(o=X[i[i[h>>2]+44>>2]](h,48)|0,w=i[n>>2],i[n>>2]=w+4,i[w>>2]=o,o=X[i[i[h>>2]+44>>2]](h,u[s+1|0])|0,w=i[n>>2],i[n>>2]=w+4,i[w>>2]=o,s=s+2|0),N6(s,r),W=X[i[i[t>>2]+16>>2]](t)|0,w=0,t=s;;){if(r>>>0<=t>>>0)cr((s-A<<2)+f|0,i[n>>2]),t=i[n>>2];else{o=m+4|0;e:{if(l[o+11|0]>>>7|0){_=i[o>>2];break e}_=o}g=!l[_+w|0],l[o+11|0]>>>7|0?_=i[o>>2]:_=o,g|u[_+w|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+4,i[B>>2]=W,l[o+11|0]>>>7|0?o=i[o+4>>2]:o=l[o+11|0]&127,w=(o-1>>>0>w>>>0)+w|0,B=0),o=X[i[i[h>>2]+44>>2]](h,u[t|0])|0,_=i[n>>2],i[n>>2]=_+4,i[_>>2]=o,t=t+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?t:(e-A<<2)+f|0,s2(m+4|0),v=m+16|0}function A8(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(r>>>0>=512)return r&&z(A,e,r),A|0;f=A+r|0;i:{if(!((A^e)&3)){e:{if(!(A&3)){r=A;break e}if(!r){r=A;break e}for(r=A;;){if(u[r|0]=l[e|0],e=e+1|0,r=r+1|0,!(r&3))break e;if(!(r>>>0<f>>>0))break}}k=f&-4;e:{if(f>>>0<64||(n=k+-64|0,n>>>0<r>>>0))break e;for(;i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=i[e+20>>2],i[r+24>>2]=i[e+24>>2],i[r+28>>2]=i[e+28>>2],i[r+32>>2]=i[e+32>>2],i[r+36>>2]=i[e+36>>2],i[r+40>>2]=i[e+40>>2],i[r+44>>2]=i[e+44>>2],i[r+48>>2]=i[e+48>>2],i[r+52>>2]=i[e+52>>2],i[r+56>>2]=i[e+56>>2],i[r+60>>2]=i[e+60>>2],e=e- -64|0,r=r- -64|0,n>>>0>=r>>>0;);}if(r>>>0>=k>>>0)break i;for(;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,k>>>0>r>>>0;);break i}if(f>>>0<4){r=A;break i}if(k=f-4|0,k>>>0<A>>>0){r=A;break i}for(r=A;u[r|0]=l[e|0],u[r+1|0]=l[e+1|0],u[r+2|0]=l[e+2|0],u[r+3|0]=l[e+3|0],e=e+4|0,r=r+4|0,k>>>0>=r>>>0;);}if(r>>>0<f>>>0)for(;u[r|0]=l[e|0],e=e+1|0,r=r+1|0,(f|0)!=(r|0););return A|0}function ii(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,r=i[A+100>>2],i[e+40>>2]=i[r+48>>2],r=i[r+52>>2],i[e+44>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[A+116>>2],f=i[e+44>>2],i[e+8>>2]=i[e+40>>2],i[e+12>>2]=f,Ku(e+48|0,e+8|0,r),A=i[A+448>>2],i[e+32>>2]=i[e+88>>2],r=i[e+84>>2],i[e+24>>2]=i[e+80>>2],i[e+28>>2]=r,r=i[e+76>>2],i[e+16>>2]=i[e+72>>2],i[e+20>>2]=r,f=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,k=i[e+60>>2],i[e+60>>2]=0,n=i[e+64>>2],i[e+64>>2]=0,t=i[e+68>>2],i[e+68>>2]=0,o=l[e+56|0],i[A+8>>2]=r,r=i[A+12>>2],i[A+12>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}u[A+16|0]=o,r=i[A+20>>2],r&&(i[A+24>>2]=r,Z(r)),i[A+28>>2]=t,i[A+24>>2]=n,i[A+20>>2]=k,i[A+48>>2]=i[e+32>>2],r=i[e+28>>2],i[A+40>>2]=i[e+24>>2],i[A+44>>2]=r,r=i[e+20>>2],i[A+32>>2]=i[e+16>>2],i[A+36>>2]=r,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=e+96|0}function Fr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;m=v-16|0,v=m,h=c0(t,129808),s=m+4|0,t=c0(t,129864),X[i[i[t>>2]+20>>2]](s,t),l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127;i:{if(!o){X[i[i[h>>2]+32>>2]](h,A,r,f)|0,t=(r-A|0)+f|0,i[n>>2]=t;break i}i[n>>2]=f;e:{r:switch(s=A,o=l[s|0],o-43|0){case 0:case 2:break r;default:break e}s=X[i[i[h>>2]+28>>2]](h,o<<24>>24)|0,o=i[n>>2],i[n>>2]=o+1,u[o|0]=s,s=A+1|0}for(l[s|0]!=48|(r-s|0)<2|(l[s+1|0]|32)!=120||(o=X[i[i[h>>2]+28>>2]](h,48)|0,w=i[n>>2],i[n>>2]=w+1,u[w|0]=o,o=X[i[i[h>>2]+28>>2]](h,u[s+1|0])|0,w=i[n>>2],i[n>>2]=w+1,u[w|0]=o,s=s+2|0),N6(s,r),W=X[i[i[t>>2]+16>>2]](t)|0,w=0,t=s;;){if(r>>>0<=t>>>0)N6((s-A|0)+f|0,i[n>>2]),t=i[n>>2];else{o=m+4|0;e:{if(l[o+11|0]>>>7|0){_=i[o>>2];break e}_=o}g=!l[_+w|0],l[o+11|0]>>>7|0?_=i[o>>2]:_=o,g|u[_+w|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+1,u[B|0]=W,l[o+11|0]>>>7|0?o=i[o+4>>2]:o=l[o+11|0]&127,w=(o-1>>>0>w>>>0)+w|0,B=0),o=X[i[i[h>>2]+28>>2]](h,u[t|0])|0,_=i[n>>2],i[n>>2]=_+1,u[_|0]=o,t=t+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?t:(e-A|0)+f|0,s2(m+4|0),v=m+16|0}function _W(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[r+12>>2];i:{if((n|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if((n|0)!=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&i[r+4>>2]==3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(F[f+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=i[f+4>>2],!((n|0)==3|(l[k+12|0]?i[k+4>>2]!=1:0))){i[e+12>>2]=n,i[e+8>>2]=0,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0);break i}i[e+8>>2]=0,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],r=E(28),f=i[e+28>>2],i[r+16>>2]=i[e+24>>2],i[r+20>>2]=f,f=i[e+20>>2],i[r+8>>2]=i[e+16>>2],i[r+12>>2]=f,f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+24>>2]=11,f=r+28|0,i[A+8>>2]=f,i[A>>2]=r,i[A+4>>2]=f}v=e+32|0}function F6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;o=v-16|0,v=o,n=i[A+108>>2],t=i[A+104>>2],s=n-t>>4;i:{if((t|0)==(n|0))break i;for(k=s>>>0<=1?1:s;;){if(i[t+(f<<4)>>2]==(e|0))break i;if(f=f+1|0,(k|0)==(f|0))break}f=k}if((f|0)==(s|0)){t=A+104|0,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=e;i:{if(n>>>0<u0[A+112>>2]){i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=e,i[A+108>>2]=n+16;break i}if(k=yr(t,o),e=i[o+4>>2],i[A+108>>2]=k,!e)break i;i[o+8>>2]=e,Z(e)}t=i[t>>2]}i:{e:{t=(f<<4)+t|0,A=i[t+4>>2],e=i[t+8>>2];r:{if((A|0)!=(e|0))for(k=F[r+2>>1],f=A;;){if((k|0)==F[f+2>>1])break r;if(f=f+4|0,(e|0)==(f|0))break}k=i[t+12>>2];f:{if(k>>>0>e>>>0){A=F[r>>1]|F[r+2>>1]<<16,Q[e>>1]=A,Q[e+2>>1]=A>>>16,r=e+4|0;break f}if(e=e-A|0,s=e>>2,f=s+1|0,f>>>0>=1073741824)break e;if(k=k-A|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=E(k<<2)}else f=0;if(n=f+e|0,r=F[r>>1]|F[r+2>>1]<<16,Q[n>>1]=r,Q[n+2>>1]=r>>>16,s=n-(s<<2)|0,e&&z(s,A,e),i[t+12>>2]=f+(k<<2),r=n+4|0,i[t+8>>2]=r,i[t+4>>2]=s,!A)break f;Z(A)}i[t+8>>2]=r}v=o+16|0;return}G0(),H()}x0(),H()}function Xn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{if((f|0)<=0)break e;if(t=i[A+8>>2],o=i[A+4>>2],(t-o|0)>=(f|0)){r:{if((f|0)<=(o|0)){t=e+f|0,n=o;break r}t=e+o|0;f:{if((t|0)==(r|0)){n=o;break f}for(k=t,n=o;u[n|0]=l[k|0],n=n+1|0,k=k+1|0,(k|0)!=(r|0););}if(i[A+4>>2]=n,(o|0)<=0)break e}s=f,k=n,r=k-f|0;r:{if(o>>>0<=r>>>0)break r;if(w=f+o|0,h=w-k&7,h)for(f=0;u[k|0]=l[r|0],k=k+1|0,r=r+1|0,f=f+1|0,(h|0)!=(f|0););if(n-w>>>0>=4294967289)break r;for(;u[k|0]=l[r|0],u[k+1|0]=l[r+1|0],u[k+2|0]=l[r+2|0],u[k+3|0]=l[r+3|0],u[k+4|0]=l[r+4|0],u[k+5|0]=l[r+5|0],u[k+6|0]=l[r+6|0],u[k+7|0]=l[r+7|0],k=k+8|0,r=r+8|0,(o|0)!=(r|0););}i[A+4>>2]=k;r:{if((n|0)==(s|0)||(A=n-s|0,!A))break r;z(n-A|0,0,A)}if((e|0)==(t|0)||(A=t-e|0,!A))break e;z(0,e,A);return}if(n=i[A>>2],r=(o-n|0)+f|0,(r|0)<0)break i;k=0-n|0,t=t-n|0,s=t<<1,t=t>>>0>=1073741823?2147483647:r>>>0<s>>>0?s:r,t?r=E(t):r=0,s=k+r|0,f&&z(s,e,f),e=f+s|0,o&&z(e,0,o),i[A+4>>2]=0,k&&z(r,n,k),i[A+8>>2]=r+t,i[A+4>>2]=e+o,i[A>>2]=r,n&&Z(n)}return}G0(),H()}function BW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;w=v-16|0,v=w,s=E(36),i[s+32>>2]=t,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s+12>>2]=95896,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=96188,r=i[e+8>>2],i[w+12>>2]=s,f=s+12|0,i[w+8>>2]=f,i[s+4>>2]=i[s+4>>2]+1,r2(r+12|0,w+8|0),r=i[w+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!o||(i[s+4>>2]=i[s+4>>2]+1,r=E(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,i[o>>2]=r,r=i[s+4>>2],i[s+4>>2]=r-1,r))break i;X[i[i[s>>2]+8>>2]](s),p(s)}f=i[e>>2],r=i[e+4>>2];i:{if(r){if(i[r+4>>2]=i[r+4>>2]+1,Uo(f,i[i[e+8>>2]>>2],t),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;X[i[i[r>>2]+8>>2]](r),p(r);break i}Uo(f,i[i[e+8>>2]>>2],t),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}A=i[s+4>>2],i[s+4>>2]=A-1,A||(X[i[i[s>>2]+8>>2]](s),p(s)),v=w+16|0}function vW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;if(k=v+-64|0,v=k,nt(k+48|0,i[A+8>>2]),o=i[k+48>>2],B=i[k+52>>2],(o|0)!=(B|0)){for(W=i[24200],g=i[24201];;){i:{e:{if(t=i[o>>2],(t|0)==i[i[A>>2]+24>>2])break e;if(Df(k+24|0,i[A+8>>2],t),t=3,n=l[k+44|0],!n){if(s=i[k+28>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[k+24>>2],t=i[_+244>>2],w=i[_+248>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),t){IA(k+8|0,t,e),m=i[k+12>>2],n=i[k+8>>2];r:{if((m|0)==(n|0)|f>>>0<=h>>>0)break r;for(I=i[i[A>>2]+24>>2],t=n;;){if(i[t>>2]!=(I|0)){if(t=t+4|0,(m|0)!=(t|0))continue;break r}break}i[(h<<2)+r>>2]=i[_+24>>2],h=h+1|0}n&&(i[k+12>>2]=n,Z(n)),t=(f|0)==(h|0)?2:0}else t=3;r:{if(!w||(n=i[w+4>>2],i[w+4>>2]=n-1,n))break r;X[i[i[w>>2]+8>>2]](w),p(w)}r:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break r;X[i[i[s>>2]+8>>2]](s),p(s)}n=l[k+44|0]}switch((n|0)!=255&&(i[k+8>>2]=W,i[k+12>>2]=g,X[i[(k+8|0)+(n<<2)>>2]](k+63|0,k+24|0)),t|0){case 0:case 3:break e;default:break i}}if(o=o+4|0,(B|0)!=(o|0))continue}break}o=i[k+48>>2]}return o&&(i[k+52>>2]=o,Z(o)),v=k- -64|0,h|0}function A6(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72548,k=i[18140],i[f+20>>2]=k,o=i[k-12>>2],k=f+20|0,i[o+k>>2]=i[18141],t=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72548,i[f+20>>2]=72528,t=R0(n),i[t>>2]=71280,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,Y2(n,e,r),s=k,o=n,k=u[f+19|0],n=(k|0)<0,Y(s,n?i[f+8>>2]:o,n?i[f+12>>2]:k),u[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,mr(k,e,r,0),e=u[f+19|0],r=(e|0)<0,Y(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18142],i[t>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(t),p0(f+76|0),v=f+160|0}function mW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72548,k=i[18140],i[f+20>>2]=k,o=i[k-12>>2],k=f+20|0,i[o+k>>2]=i[18141],t=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72548,i[f+20>>2]=72528,t=R0(n),i[t>>2]=71280,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,Y2(n,e,r),s=k,o=n,k=u[f+19|0],n=(k|0)<0,Y(s,n?i[f+8>>2]:o,n?i[f+12>>2]:k),u[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,mr(k,e,r,1),e=u[f+19|0],r=(e|0)<0,Y(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}g0(),H()}if(!r)break i;z(A,k,r)}u[A+r|0]=0,A=i[18139],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18142],i[t>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(t),p0(f+76|0),v=f+160|0}function gn(A,e){var r=0,f=0;l[A|0]&&(r=A,f=v0(e,2),u[r+1|0]=f,r=A,f=v0(e,1),u[r+2|0]=f,r=A,f=v0(e,5),i[r+4>>2]=f,r=A,f=v0(e,1),u[r+8|0]=f,r=A,f=v0(e,1),u[r+9|0]=f,r=A,f=v0(e,1),u[r+10|0]=f,r=A,f=v0(e,1),u[r+11|0]=f,r=A,f=v0(e,1),u[r+12|0]=f,r=A,f=v0(e,1),u[r+13|0]=f,r=A,f=v0(e,1),u[r+14|0]=f,r=A,f=v0(e,1),u[r+15|0]=f,r=A,f=v0(e,1),u[r+16|0]=f,r=A,f=v0(e,1),u[r+17|0]=f,r=A,f=v0(e,1),u[r+18|0]=f,r=A,f=v0(e,1),u[r+19|0]=f,r=A,f=v0(e,1),u[r+20|0]=f,r=A,f=v0(e,1),u[r+21|0]=f,r=A,f=v0(e,1),u[r+22|0]=f,r=A,f=v0(e,1),u[r+23|0]=f,r=A,f=v0(e,1),u[r+24|0]=f,r=A,f=v0(e,1),u[r+25|0]=f,r=A,f=v0(e,1),u[r+26|0]=f,r=A,f=v0(e,1),u[r+27|0]=f,r=A,f=v0(e,1),u[r+28|0]=f,r=A,f=v0(e,1),u[r+29|0]=f,r=A,f=v0(e,1),u[r+30|0]=f,r=A,f=v0(e,1),u[r+31|0]=f,r=A,f=v0(e,1),u[r+32|0]=f,r=A,f=v0(e,1),u[r+33|0]=f,r=A,f=v0(e,1),u[r+34|0]=f,r=A,f=v0(e,1),u[r+35|0]=f,r=A,f=v0(e,1),u[r+36|0]=f,r=A,f=v0(e,1),u[r+37|0]=f,r=A,f=v0(e,1),u[r+38|0]=f,r=A,f=v0(e,1),u[r+39|0]=f,r=A,f=v0(e,1),u[r+40|0]=f,r=A,f=v0(e,1),u[r+41|0]=f,r=A,f=v0(e,1),u[r+42|0]=f,r=A,f=v0(e,1),u[r+43|0]=f,y6(e,44)),l[A+44|0]&&(r=A,f=v0(e,8),i[r+48>>2]=f)}function ZW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10548);break i}if(o=W2(r),k=i[r>>2],n=X[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,n=o+n|0,k=n>>>0<o>>>0?k+1|0:k,X[i[i[s>>2]+12>>2]](s,n,k)|0){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}t=i[e+108>>2],k=i[e+104>>2],n=t-k|0;e:{if(n>>>0<o>>>0){if(s=o-n|0,w=i[e+112>>2],s>>>0<=w-t>>>0){s&&o0(t,0,s),i[e+108>>2]=t+s;break e}if(t=w-k|0,w=t<<1,w=t>>>0>=1073741823?2147483647:o>>>0<w>>>0?w:o,t=E(w),s&&o0(n+t|0,0,s),n&&z(t,k,n),i[e+112>>2]=t+w,i[e+108>>2]=o+t,i[e+104>>2]=t,!k)break e;Z(k);break e}if(o>>>0>=n>>>0)break e;i[e+108>>2]=k+o}if(o)for(k=0;n=W2(r),u[i[e+104>>2]+k|0]=n,k=k+1|0,(o|0)!=(k|0););if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function GW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=i[e+104>>2],f=i[e+108>>2];i:{e:{if((r|0)!=(f|0))for(;;){r:{if(k=i[r>>2],!k||(k=X0(k,86628,98612),!k))break r;if(r=i[r+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(r=r+8|0,(f|0)==(r|0))break}k=0}r=0}f=E(112),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=97328,r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+16|0,i[f+64>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+72>>2]=0,i[f+76>>2]=0,i[f+84>>2]=r,i[f+80>>2]=k,u[f+32|0]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=98632;i:{if(!r){u[f+104|0]=0,u[f+88|0]=0;break i}if(i[r+4>>2]=i[r+4>>2]+1,u[f+104|0]=0,u[f+88|0]=0,k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;X[i[i[r>>2]+8>>2]](r),p(r)}i[e+448>>2]=n,k=i[e+452>>2],i[e+452>>2]=f;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}}function WW(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;h=v-16|0,v=h,w=E(52),i[w+32>>2]=0,i[w+36>>2]=0,i[w+12>>2]=95984,i[w+4>>2]=0,i[w+8>>2]=0,i[w+28>>2]=n,i[w+24>>2]=k,i[w+20>>2]=f,i[w+16>>2]=r,i[w>>2]=96228,i[w+40>>2]=0,i[w+44>>2]=0,k=0,i[w+48>>2]=0;i:{e:{if(!o){n=0;break e}if((o|0)<0)break i;n=E(o),o&&o0(n,0,o),k=n+o|0,i[w+40>>2]=k,i[w+36>>2]=k,i[w+32>>2]=n}r=k-n|0,r&&z(n,t,r),r=i[e+8>>2],i[h+12>>2]=w,f=w+12|0,i[h+8>>2]=f,i[w+4>>2]=i[w+4>>2]+1,r2(r+12|0,h+8|0),r=i[h+12>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}e:{if(!s||(i[w+4>>2]=i[w+4>>2]+1,r=E(24),i[w+4>>2]=i[w+4>>2]+1,i[r+20>>2]=w,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[s>>2]=r,e=i[w+4>>2],i[w+4>>2]=e-1,e))break e;X[i[i[w>>2]+8>>2]](w),p(w)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[w+4>>2],i[w+4>>2]=A-1,A||(X[i[i[w>>2]+8>>2]](w),p(w)),v=h+16|0;return}G0(),H()}function Qn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!r){if(u[f+16|0]=0,u[f+27|0]=0,r=K(f+28|0,5,2001,f+16|0),u[f+27|0]<0&&Z(i[f+16>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}So(f+8|0,i[e>>2]),n=i[f+8>>2];e:{if(!n){if(u[f+16|0]=0,u[f+27|0]=0,r=K(f+28|0,2,124,f+16|0),u[f+27|0]<0&&Z(i[f+16>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}if(k=X0(n,100708,94396),k){if(r=i[f+12>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+28|0,X[i[i[k>>2]+52>>2]](n,k),b0(A,n,i[e>>2]),u[f+47|0]<0&&Z(i[f+36>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;X[i[i[r>>2]+8>>2]](r),p(r);break e}k=E(16),i[k+8>>2]=0,i[k+12>>2]=0,i[r>>2]=k,r=i[f+12>>2],i[f+8>>2]=0,i[f+12>>2]=0,i[k+4>>2]=r,i[k>>2]=n,r=i[e>>2],n=i[e+4>>2];r:{if(!n){i[k+12>>2]=n,i[k+8>>2]=r;break r}if(i[n+4>>2]=i[n+4>>2]+1,i[k+8>>2]=r,r=i[k+12>>2],i[k+12>>2]=n,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break r;X[i[i[r>>2]+8>>2]](r),p(r)}b0(A,107712,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f+48|0}function XW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-48|0,v=k;i:{e:{r:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=16746;break r}if(w=i[e>>2],n=i[i[e+8>>2]>>2],t=h2(r),t>>>0>=2147483640)break e;f:{A:{if(t>>>0>=11){s=t|7,o=E(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=o,i[k+4>>2]=t;break A}if(u[k+11|0]=t,o=k,!t)break f}if(!t)break f;z(o,r,t)}u[o+t|0]=0,G9(k+20|0,w,n,k),u[k+11|0]<0&&Z(i[k>>2]),n=107712,w=107724,o=107731,r=107720;f:switch(l[k+40|0]){case 1:w=k+32|0,o=k+39|0,r=k+28|0,n=k+20|0;break;case 0:break f;default:break i}s=i[n>>2],n=i[n+4>>2],i[k>>2]=s,i[k+4>>2]=n,n=k+8|0;f:{if(u[o|0]>=0){o=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=o,i[n+8>>2]=i[r+8>>2];break f}T(n,i[r>>2],i[w>>2]),s=i[k>>2]}f:{if(s){if(b0(A,k,i[e>>2]),u[k+19|0]>=0)break f;Z(i[k+8>>2]);break f}if(u[k+19|0]<0&&Z(i[k+8>>2]),f){if(l[k+40|0])break i;i[f>>2]=i[k+20>>2]}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(e=l[k+40|0],(e|0)==255)break r;A=i[24253],i[k>>2]=i[24252],i[k+4>>2]=A,X[i[(e<<2)+k>>2]](k+47|0,k+20|0)}v=k+48|0;return}g0(),H()}_2(),H()}function gW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=X0(k,86628,100220),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=E(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97208,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=100240,!f|i[f+4>>2]!=-1||(X[i[i[f>>2]+8>>2]](f),p(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,K(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26930],i[26931])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function QW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,A=i[A>>2],o=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,j1(n,o,e,n+20|0);i:{if(i[n>>2]||(A=i[n+20>>2],w=i[n+24>>2],(A|0)==(w|0)))break i;e=!f;e:{if(!r){if(e)break e;for(o=1;r=e,(k|0)>(t|0)&&(i[(t<<2)+f>>2]=o,r=1),o=o+1|0,t=r+t|0,A=A+8|0,(w|0)!=(A|0););break i}if(!f){for(;;)if(t=(e&i[i[A>>2]+16>>2]==(r|0))+t|0,A=A+8|0,(w|0)==(A|0))break i}for(o=1;;){r:{if(i[i[A>>2]+16>>2]!=(r|0))break r;if((k|0)>(t|0)){i[(t<<2)+f>>2]=o,t=t+1|0;break r}t=e+t|0}if(o=o+1|0,A=A+8|0,(w|0)==(A|0))break}break i}t=((w-A|0)-8>>>3|0)+1|0}if(u[n+19|0]<0&&Z(i[n+8>>2]),r=i[n+20>>2],r){if(A=i[n+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[n+20>>2]}i[n+24>>2]=r,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s)}return v=n+32|0,t|0}function IW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=X0(k,86628,97612),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=E(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97128,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=97696,!f|i[f+4>>2]!=-1||(X[i[i[f>>2]+8>>2]](f),p(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,K(A,2,106,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26930],i[26931])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function CW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=X0(k,86628,99924),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=E(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97288,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=99728,!f|i[f+4>>2]!=-1||(X[i[i[f>>2]+8>>2]](f),p(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,K(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26930],i[26931])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function VW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=X0(k,86628,98188),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=E(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97168,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98064,!f|i[f+4>>2]!=-1||(X[i[i[f>>2]+8>>2]](f),p(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;X[i[i[k>>2]+8>>2]](k),p(k)}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break r;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,K(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26930],i[26931])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=n+16|0}function In(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-32|0,v=f;i:{if(l[A+52|0]==1){if(r=i[A+48>>2],!e)break i;u[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(l[A+53|0]==1){if(r=he(i[A+32>>2]),(r|0)!=-1&&(u[f+24|0]=r),(r|0)==-1)break e;r=l[f+24|0];r:{if(!e){if(!zs(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=l[f+24|0];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(t=he(i[A+32>>2]),(t|0)==-1)break e;u[(f+24|0)+r|0]=t,r=r+1|0;continue}break}w=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],h=i[n+4>>2],o=f+24|0,t=o+k|0;A:switch(s=i[A+36>>2],(X[i[i[s>>2]+16>>2]](s,n,o,t,f+16|0,f+23|0,w,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=h,(k|0)==8||(r=he(i[A+32>>2]),(r|0)==-1))break e;u[t|0]=r,k=k+1|0;continue}break}u[f+23|0]=l[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Zi(l[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=l[f+23|0]}r=l[f+23|0];break i}r=-1}return v=f+32|0,r}function FW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;e=v-16|0,v=e,r=E(32),i[e+4>>2]=r,i[e+8>>2]=29,i[e+12>>2]=-2147483616,f=l[22400]|l[22401]<<8|(l[22402]<<16|l[22403]<<24),k=l[22396]|l[22397]<<8|(l[22398]<<16|l[22399]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,f=l[22421]|l[22422]<<8|(l[22423]<<16|l[22424]<<24),k=l[22417]|l[22418]<<8|(l[22419]<<16|l[22420]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[22416]|l[22417]<<8|(l[22418]<<16|l[22419]<<24),k=l[22412]|l[22413]<<8|(l[22414]<<16|l[22415]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[22408]|l[22409]<<8|(l[22410]<<16|l[22411]<<24),k=l[22404]|l[22405]<<8|(l[22406]<<16|l[22407]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,K(A,5,0,e+4|0),u[e+15|0]<0&&Z(i[e+4>>2]),v=e+16|0}function Pf(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;t=v-32|0,v=t,k=f&65535,n=f>>>16&32767,s=n;i:{if(n-15361>>>0<=2045){k=k<<4|r>>>28,r=r<<4,n=k,k=e>>>28|r,r=n,n=s-15360|0,e=e&268435455;e:{if((e|0)==134217728&(A|0)!=0|e>>>0>134217728){k=k+1|0,r=k?r:r+1|0;break e}if(A|(e|0)!=134217728)break e;A=k,k=k+(k&1)|0,r=A>>>0>k>>>0?r+1|0:r}o=r>>>0>1048575,A=o?0:k,e=o?0:r,k=0,r=n+o|0,n=r>>>0<n>>>0?1:k;break i}if(!(!(A|r|(e|k))|((n|0)!=32767|(o|0)!=0))){A=r,r=k<<4|r>>>28,A=A<<4|e>>>28,e=r|524288,r=2047,n=0;break i}if(s>>>0>17406){A=0,e=0,r=2047,n=0;break i}if(o=!(n|o),w=o?15360:15361,n=w-s|0,(n|0)>112){A=0,e=0,r=0,n=0;break i}k=o?k:k|65536,o4(t+16|0,A,e,r,k,128-n|0),Y6(t,A,e,r,k,n),A=i[t+8>>2],o=A<<4,e=i[t+12>>2]<<4|A>>>28,A=i[t+4>>2],n=A,A=A>>>28|o,n=n&268435455,r=i[t>>2]|(s|0)!=(w|0)&(i[t+16>>2]|i[t+24>>2]|(i[t+20>>2]|i[t+28>>2]))!=0;e:{if((n|0)==134217728&(r|0)!=0|n>>>0>134217728){A=A+1|0,e=A?e:e+1|0;break e}if(r|(n|0)!=134217728)break e;k=e,e=A,A=A+(A&1)|0,e=e>>>0>A>>>0?k+1|0:k}r=e>>>0>1048575,e=r?e^1048576:e,n=0}return v=t+32|0,U2(0,A|0),U2(1,e|(f&-2147483648|r<<20)),+r1()}function EW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-208|0,v=n,i[n+200>>2]=37,i[n+204>>2]=0,t=n+200|0,o=qr(t|1,42716,i[r+4>>2]),s=n+160|0,i[n+156>>2]=s,A=a2();i:{if(o){w=i[r+8>>2],t0[n+40>>3]=k,i[n+32>>2]=w,A=h4(s,30,A,t,n+32|0);break i}t0[n+48>>3]=k,A=h4(n+160|0,30,A,n+200|0,n+48|0)}i[n+80>>2]=2071,s=g1(n+148|0,0,n+80|0),t=n+160|0;i:{e:{if((A|0)>=30){A=a2();r:{if(o){t=i[r+8>>2],t0[n+8>>3]=k,i[n>>2]=t,A=V8(n+156|0,A,n+200|0,n);break r}t0[n+16>>3]=k,A=V8(n+156|0,A,n+200|0,n+16|0)}if((A|0)==-1)break e;t=i[s>>2],i[s>>2]=i[n+156>>2],t&&X[i[s+4>>2]](t),t=i[n+156>>2]}_=A+t|0,B=x4(t,_,r),i[n+80>>2]=2071,t=n+80|0,o=g1(n+72|0,0,t),w=i[n+156>>2];r:{if((w|0)==(n+160|0)){A=t;break r}if(A=p2(A<<1),!A)break e;t=i[o>>2],i[o>>2]=A,t&&X[i[o+4>>2]](t),w=i[n+156>>2]}h=n+60|0,t=i[r+28>>2],i[h>>2]=t,(t|0)!=129624&&(i[t+4>>2]=i[t+4>>2]+1),rn(w,B,_,A,n+68|0,n- -64|0,h),e2(h),A=O8(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[o>>2],i[o>>2]=0,e&&X[i[o+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&X[i[s+4>>2]](e),v=n+208|0;break i}Q1(),H()}return A|0}function pW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-368|0,v=n,i[n+360>>2]=37,i[n+364>>2]=0,t=n+360|0,o=qr(t|1,42716,i[r+4>>2]),s=n+320|0,i[n+316>>2]=s,A=a2();i:{if(o){w=i[r+8>>2],t0[n+40>>3]=k,i[n+32>>2]=w,A=h4(s,30,A,t,n+32|0);break i}t0[n+48>>3]=k,A=h4(n+320|0,30,A,n+360|0,n+48|0)}i[n+80>>2]=2071,s=g1(n+308|0,0,n+80|0),t=n+320|0;i:{e:{if((A|0)>=30){A=a2();r:{if(o){t=i[r+8>>2],t0[n+8>>3]=k,i[n>>2]=t,A=V8(n+316|0,A,n+360|0,n);break r}t0[n+16>>3]=k,A=V8(n+316|0,A,n+360|0,n+16|0)}if((A|0)==-1)break e;t=i[s>>2],i[s>>2]=i[n+316>>2],t&&X[i[s+4>>2]](t),t=i[n+316>>2]}_=A+t|0,B=x4(t,_,r),i[n+80>>2]=2071,t=n+80|0,o=g1(n+72|0,0,t),w=i[n+316>>2];r:{if((w|0)==(n+320|0)){A=t;break r}if(A=p2(A<<3),!A)break e;t=i[o>>2],i[o>>2]=A,t&&X[i[o+4>>2]](t),w=i[n+316>>2]}h=n+60|0,t=i[r+28>>2],i[h>>2]=t,(t|0)!=129624&&(i[t+4>>2]=i[t+4>>2]+1),en(w,B,_,A,n+68|0,n- -64|0,h),e2(h),A=j8(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[o>>2],i[o>>2]=0,e&&X[i[o+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&X[i[s+4>>2]](e),v=n+368|0;break i}Q1(),H()}return A|0}function yW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-48|0,v=n;i:{e:{r:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=16746;break r}if(t=i[e>>2],o=h2(f),o>>>0>=2147483640)break e;f:{A:{if(o>>>0>=11){w=o|7,s=E(w+1|0),i[n+8>>2]=w-2147483647,i[n>>2]=s,i[n+4>>2]=o;break A}if(u[n+11|0]=o,s=n,!o)break f}if(!o)break f;z(s,f,o)}u[o+s|0]=0,G9(n+20|0,t,r,n),u[n+11|0]<0&&Z(i[n>>2]),t=107712,s=107724,r=107731,f=107720;f:switch(l[n+40|0]){case 1:s=n+32|0,r=n+39|0,f=n+28|0,t=n+20|0;break;case 0:break f;default:break i}w=i[t>>2],t=i[t+4>>2],i[n>>2]=w,i[n+4>>2]=t,t=n+8|0;f:{if(u[r|0]>=0){r=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=r,i[t+8>>2]=i[f+8>>2];break f}T(t,i[f>>2],i[s>>2]),w=i[n>>2]}f:{if(w){if(b0(A,n,i[e>>2]),u[n+19|0]>=0)break f;Z(i[n+8>>2]);break f}if(u[n+19|0]<0&&Z(i[n+8>>2]),k){if(l[n+40|0])break i;i[k>>2]=i[n+20>>2]}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(e=l[n+40|0],(e|0)==255)break r;A=i[24199],i[n>>2]=i[24198],i[n+4>>2]=A,X[i[(e<<2)+n>>2]](n+47|0,n+20|0)}v=n+48|0;return}g0(),H()}_2(),H()}function $4(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0;i:{e:{if((k|0)<=0)break e;if(o=i[A+8>>2],s=i[A+4>>2],(o-s|0)>=(k|0)){n=s-e|0;r:{if((n|0)>=(k|0)){o=r+k|0,t=s;break r}if(o=r+n|0,t=f-o|0,!t|(f|0)==(o|0)||z(s,o,t),t=t+s|0,i[A+4>>2]=t,(n|0)<=0)break e}w=e+k|0,f=t,n=f-k|0;r:{if(s>>>0<=n>>>0)break r;if(h=k+s|0,_=h-f&7,_)for(k=0;u[f|0]=l[n|0],f=f+1|0,n=n+1|0,k=k+1|0,(_|0)!=(k|0););if(t-h>>>0>=4294967289)break r;for(;u[f|0]=l[n|0],u[f+1|0]=l[n+1|0],u[f+2|0]=l[n+2|0],u[f+3|0]=l[n+3|0],u[f+4|0]=l[n+4|0],u[f+5|0]=l[n+5|0],u[f+6|0]=l[n+6|0],u[f+7|0]=l[n+7|0],f=f+8|0,n=n+8|0,(s|0)!=(n|0););}i[A+4>>2]=f;r:{if((t|0)==(w|0)||(A=t-w|0,!A))break r;z(t-A|0,e,A)}if((r|0)==(o|0)||(A=o-r|0,!A))break e;z(e,r,A);return}if(t=i[A>>2],f=(s-t|0)+k|0,(f|0)<0)break i;n=e-t|0,o=o-t|0,w=o<<1,o=o>>>0>=1073741823?2147483647:f>>>0<w>>>0?w:f,o?f=E(o):f=0,w=n+f|0,k&&z(w,r,k),r=k+w|0,k=s-e|0,k&&z(r,e,k),i[A+4>>2]=e,n&&z(f,t,n),i[A+8>>2]=f+o,i[A+4>>2]=r+k,i[A>>2]=f,t&&Z(t)}return}G0(),H()}function qf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v+-64|0,v=f,t=i[i[e+104>>2]-8>>2],X[i[i[t>>2]+12>>2]](f+44|0,t),n=A+8|0,t=i[26698],s=i[26699];i:{for(;;){if(k=i[f+44>>2],X[i[i[k>>2]+24>>2]](f+24|0,k,r),i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[n+8>>2]=i[f+40>>2],A=i[f+36>>2],i[n>>2]=i[f+32>>2],i[n+4>>2]=A;break i}r9(f,e,r);e:{r:{f:{A:switch(l[f+20|0]){case 1:if(k=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=k,u[f+19|0]<0)break f;k=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=k,i[n+8>>2]=i[f+16>>2],k=1,o=1;break r;default:_2(),H();case 0:break A}o=0,k=l[f|0]?0:2;break r}if(T(n,i[f+8>>2],i[f+12>>2]),k=1,o=l[f+20|0],(o|0)==255)break e}i[f+56>>2]=t,i[f+60>>2]=s,X[i[(f+56|0)+(o<<2)>>2]](f+55|0,f)}if(u[f+43|0]<0&&Z(i[f+32>>2]),!!k)break}if((k|0)!=2)break i;r=i[e+320>>2];e:{if(!r)break e;if(qf(A,r,i[e+332>>2]),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=i[f+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f- -64|0}function YW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{e:{if(!e){r=0;break e}if(A=i[A>>2],i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,f=i[A+132>>2],k=i[A+136>>2],(f|0)!=(k|0)){if(A=k-f|0,(A|0)<0)break i;for(n=E(A),i[t+4>>2]=n,i[t+12>>2]=A+n,A=n;i[A>>2]=i[f>>2],o=i[f+4>>2],i[A+4>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),A=A+8|0,f=f+8|0,(k|0)!=(f|0););i[t+8>>2]=A,f=A-n>>3,r=(r|0)>(f|0)?f:r;r:{if((r|0)<=0)break r;if(o=0,f=0,r>>>0>=4)for(w=r&2147483644,k=0;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+116>>2],s=f|1,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],s=f|2,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],s=f|3,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],f=f+4|0,k=k+4|0,(w|0)!=(k|0););if(k=r&3,!k)break r;for(;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+116>>2],f=f+1|0,o=o+1|0,(k|0)!=(o|0););}for(;;){e=A-8|0,A=i[A-4>>2];r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=e,(n|0)==(A|0))break}Z(i[t+4>>2]);break e}r=r>>31&r}return v=t+16|0,r|0}G0(),H()}function RW(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,Hf(e+28|0,A,e+60|0,0,0),u[e+47|0]<0&&Z(i[e+36>>2]),f=i[A+552>>2],i[e+24>>2]=i[e+88>>2],r=i[e+84>>2],i[e+16>>2]=i[e+80>>2],i[e+20>>2]=r,r=i[e+76>>2],i[e+8>>2]=i[e+72>>2],i[e+12>>2]=r,k=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,n=i[e+60>>2],t=i[e+64>>2],i[e+60>>2]=0,i[e+64>>2]=0,o=i[e+68>>2],i[e+68>>2]=0,s=l[e+56|0],i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=k;i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}u[f+16|0]=s,r=i[f+20>>2],r&&(i[f+24>>2]=r,Z(r)),i[f+28>>2]=o,i[f+24>>2]=t,i[f+20>>2]=n,r=i[e+12>>2],i[f+32>>2]=i[e+8>>2],i[f+36>>2]=r,r=i[e+20>>2],i[f+40>>2]=i[e+16>>2],i[f+44>>2]=r,i[f+48>>2]=i[e+24>>2],A=i[A+552>>2],f=X[i[i[A>>2]+12>>2]](A)|0,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=e+96|0,f|0}function JW(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,Hf(e+28|0,A,e+60|0,0,0),u[e+47|0]<0&&Z(i[e+36>>2]),f=i[A+552>>2],i[e+24>>2]=i[e+88>>2],r=i[e+84>>2],i[e+16>>2]=i[e+80>>2],i[e+20>>2]=r,r=i[e+76>>2],i[e+8>>2]=i[e+72>>2],i[e+12>>2]=r,k=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,n=i[e+60>>2],t=i[e+64>>2],i[e+60>>2]=0,i[e+64>>2]=0,o=i[e+68>>2],i[e+68>>2]=0,s=l[e+56|0],i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=k;i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}u[f+16|0]=s,r=i[f+20>>2],r&&(i[f+24>>2]=r,Z(r)),i[f+28>>2]=o,i[f+24>>2]=t,i[f+20>>2]=n,r=i[e+12>>2],i[f+32>>2]=i[e+8>>2],i[f+36>>2]=r,r=i[e+20>>2],i[f+40>>2]=i[e+16>>2],i[f+44>>2]=r,i[f+48>>2]=i[e+24>>2],A=i[A+552>>2],f=X[i[i[A>>2]+16>>2]](A)|0,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=e+96|0,f|0}function NW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-80|0,v=f,n=-1;i:{if(!A|(e|0)<=0|(!r|!l[r|0])||!l[r+3|0]|(!l[r+1|0]|!l[r+2|0]))break i;k=E(72),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=95072,A=dr(k+16|0,A,e,0),i[f+52>>2]=k,i[f+48>>2]=A,i[k+4>>2]=i[k+4>>2]+1,A=i[f+52>>2],i[f+8>>2]=i[f+48>>2],i[f+12>>2]=A,t=Ee(f+56|0,f+8|0,e,0),i[f+40>>2]=0,i[f+44>>2]=0,I6(f+20|0,t,f+40|0,95568);e:{if(i[f+20>>2]){n=i[f+24>>2]==100?-1:-2;break e}if(n=-2,A=i[f+40>>2],!A||(e=X0(A,86628,86992),!e)||(A=i[f+44>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),n=e,e=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),n=J4(n,e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24)),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}u[f+39|0]<0&&Z(i[f+28>>2]),A=i[f+44>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[t+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;X[i[i[k>>2]+8>>2]](k),p(k)}return v=f+80|0,n|0}function MW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;t=v-48|0,v=t;i:{e:{if(r&&(h2(r)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26214;break i}o=i[e>>2],w=i[o+48>>2],o=i[o+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),s=v-32|0,v=s,h=s+24|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),Z8(h,w,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24)),r=i[s+24>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[r+104>>2],df(s+4|0,w,h,f,k,0),u[s+23|0]<0&&Z(i[s+12>>2]),u[t+32|0]=0,i[t+12>>2]=r,r=i[s+28>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;X[i[i[r>>2]+8>>2]](r),p(r)}v=s+32|0;e:{if(!o||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break e;X[i[i[o>>2]+8>>2]](o),p(o)}e:{r:{if(r=l[t+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,t+12|0,i[e>>2]),r=l[t+32|0],(r|0)==255)break i;break e}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],r=0}A=i[24199],i[t+40>>2]=i[24198],i[t+44>>2]=A,X[i[(t+40|0)+(r<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function Kf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{if(!e){t=A+112|0,r=l[A+112|0];break i}if(f=i[A+116>>2],!f){i[A+116>>2]=1,u[A+112|0]=e;return}if(t=A+112|0,r=l[t|0],(r|0)!=(e|0))break i;i[A+116>>2]=f+1;return}k=i[A+116>>2];i:{e:{r:{if(!(r&255)){f=k;break r}if(f=0,k)for(r=i[A+124>>2];;){o=i[A+128>>2];f:{if(o>>>0>r>>>0){u[r|0]=l[t|0],r=r+1|0;break f}if(n=i[A+120>>2],f=r-n|0,k=f+1|0,(k|0)<0)break e;if(r=o-n|0,o=r<<1,r=r>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,r?k=E(r):k=0,o=k+f|0,u[o|0]=l[A+112|0],f&&z(k,n,f),i[A+128>>2]=r+k,r=o+1|0,i[A+124>>2]=r,i[A+120>>2]=k,!n)break f;Z(n)}if(i[A+124>>2]=r,f=i[A+116>>2],s=s+1|0,!(f>>>0>s>>>0))break}u[t|0]=0}if(i[A+116>>2]=f+1,f=i[A+124>>2],n=i[A+128>>2],f>>>0<n>>>0){u[f|0]=e,i[A+124>>2]=f+1;return}if(r=i[A+120>>2],f=f-r|0,k=f+1|0,(k|0)<0)break i;n=n-r|0,t=n<<1,n=n>>>0>=1073741823?2147483647:k>>>0<t>>>0?t:k,n?k=E(n):k=0,t=k+f|0,u[t|0]=e,f&&z(k,r,f),i[A+128>>2]=k+n,e=t+1|0,i[A+124>>2]=e,i[A+120>>2]=k,r&&Z(r),i[A+124>>2]=e;return}G0(),H()}G0(),H()}function ei(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i[A+8>>2]=r,i[A>>2]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+12>>2]=r,i[A+4>>2]=e,s=-64;i:{if(!r||(i[A+4>>2]=e+1,f=l[e|0],k=r-1|0,i[A+12>>2]=k,f=f<<24,n=f,i[A+16>>2]=0,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+2,f=l[e+1|0],k=r-2|0,i[A+12>>2]=k,f=n|f<<16,t=f,i[A+16>>2]=o,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+3,f=l[e+2|0],k=r-3|0,i[A+12>>2]=k,f=t|f<<8,t=f,i[A+16>>2]=o,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+4,f=l[e+3|0],k=r-4|0,i[A+12>>2]=k,n=o,f=f|t,o=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+5,f=l[e+4|0],k=r-5|0,i[A+12>>2]=k,t=n,n=f>>>8|0,f=t|f<<24,n=n|o,o=n,i[A+16>>2]=f,i[A+20>>2]=n,!k)||(i[A+4>>2]=e+6,n=l[e+5|0],k=r-6|0,i[A+12>>2]=k,t=f,f=n>>>16|0,n=t|n<<16,f=f|o,o=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+7,f=l[e+6|0],k=r-7|0,i[A+12>>2]=k,t=n,n=f>>>24|0,f=t|f<<8,i[A+16>>2]=f,n=n|o,i[A+20>>2]=n,!k))break i;i[A+4>>2]=e+8,e=l[e+7|0],i[A+12>>2]=r-8,i[A+16>>2]=e|f,i[A+20>>2]=n,s=-56}return i[A+24>>2]=(((r>>>0>=7?7:r)<<3)+s|0)- -64,A}function UW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,x2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]),u[e+100|0]&1&&(h=e,_=F0(r),i[h+104>>2]=_,h=e,_=F0(r),i[h+108>>2]=_),n=F0(r);i:{if(!(!f|n>>>0<=u0[f+80>>2])){if(e=E(72),i[k+20>>2]=e,i[k+24>>2]=70,i[k+28>>2]=-2147483576,z(e,24045,70),u[e+70|0]=0,K(A,6,1e3,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(K4(A,e+140|0,n<<3,f,13788),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),o=e+128|0;e:{t=i[e+128>>2],f=i[e+132>>2]-t>>3;r:{if(f>>>0<n>>>0){ui(o,n-f|0);break r}if(f>>>0>n>>>0&&(i[e+132>>2]=(n<<3)+t),!n)break e}for(f=0;;){r:{if(l[e+97|0]==1){t=R4(r),s=l0;break r}t=F0(r),s=0}if(w=i[o>>2]+(f<<3)|0,i[w>>2]=t,i[w+4>>2]=s,l[r+20|0]!=1){if(f=f+1|0,(n|0)==(f|0))break e;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,K(A,2,100,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function DW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72548,k=i[18140],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18141],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72548,i[f+8>>2]=72528,t=R0(n),i[t>>2]=71280,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(I0(Y(f+8|0,31355,14),i[e+12>>2]-i[e+8>>2]|0),42713,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=E(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0,A=i[18139],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18142],i[t>>2]=71280,u[f+55|0]<0&&Z(i[f+44>>2]),y0(t),p0(f- -64|0),v=f+160|0}function HW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;o=v-160|0,v=o;i:{e:{if(s=i[e+16>>2],!s||(h=X0(s,94804,95832),!h))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),w=i[e>>2],i[o+104>>2]=i[w+48>>2],w=i[w+52>>2],i[o+108>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),e=i[e+8>>2],w=i[e+8>>2],_=i[e+4>>2],e=i[o+108>>2],i[o+32>>2]=i[o+104>>2],i[o+36>>2]=e,e=o+112|0,tr(e,o+32|0,r,_,w),t0[o+72>>3]=i[h+4>>2],t0[o+80>>3]=i[h+8>>2],r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,r=i[o+76>>2],i[o+16>>2]=i[o+72>>2],i[o+20>>2]=r,l3(o+88|0,e,o+16|0),t0[o+40>>3]=u0[h+12>>2],t0[o+48>>3]=u0[h+16>>2],r=i[o+52>>2],i[o+8>>2]=i[o+48>>2],i[o+12>>2]=r,r=i[o+44>>2],i[o>>2]=i[o+40>>2],i[o+4>>2]=r,Fl(o+56|0,e,o),t0[f>>3]=t0[o+88>>3],t0[k>>3]=t0[o+96>>3],t0[n>>3]=t0[o+56>>3],t0[t>>3]=t0[o+64>>3],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s);break i}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}v=o+160|0}function xW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;o=v-160|0,v=o;i:{e:{if(s=i[e+16>>2],!s||(h=X0(s,94804,95876),!h))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),w=i[e>>2],i[o+104>>2]=i[w+48>>2],w=i[w+52>>2],i[o+108>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),e=i[e+8>>2],w=i[e+8>>2],_=i[e+4>>2],e=i[o+108>>2],i[o+32>>2]=i[o+104>>2],i[o+36>>2]=e,e=o+112|0,tr(e,o+32|0,r,_,w),t0[o+72>>3]=i[h+4>>2],t0[o+80>>3]=i[h+8>>2],r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,r=i[o+76>>2],i[o+16>>2]=i[o+72>>2],i[o+20>>2]=r,l3(o+88|0,e,o+16|0),t0[o+40>>3]=u0[h+12>>2],t0[o+48>>3]=u0[h+16>>2],r=i[o+52>>2],i[o+8>>2]=i[o+48>>2],i[o+12>>2]=r,r=i[o+44>>2],i[o>>2]=i[o+40>>2],i[o+4>>2]=r,Fl(o+56|0,e,o),t0[f>>3]=t0[o+88>>3],t0[k>>3]=t0[o+96>>3],t0[n>>3]=t0[o+56>>3],t0[t>>3]=t0[o+64>>3],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;X[i[i[s>>2]+8>>2]](s),p(s);break i}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}v=o+160|0}function zW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,n=E(44),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96952,t=n+12|0,i[t>>2]=86360,i[n+16>>2]=0,i[n+20>>2]=0,i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+40>>2]=f,i[n+36>>2]=r,i[n+12>>2]=86272,f=i[e>>2],i[k+8>>2]=n,i[k+4>>2]=t,i[n+4>>2]=i[n+4>>2]+1,t=k+12|0,w=k+4|0,r=v-32|0,v=r,s=E(172),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=94472,h=f,_=Zr(s+12|0),i[h+48>>2]=_,o=i[f+52>>2],i[f+52>>2]=s;i:{if(!o||(s=i[o+4>>2],i[o+4>>2]=s-1,s))break i;X[i[i[o>>2]+8>>2]](o),p(o)}o=i[f+48>>2],i[o+156>>2]=f- -64,wf(r+8|0,o,w);i:{if(i[r+8>>2]){f=i[r+12>>2],i[t>>2]=i[r+8>>2],i[t+4>>2]=f,f=i[r+20>>2],i[t+8>>2]=i[r+16>>2],i[t+12>>2]=f,i[t+16>>2]=i[r+24>>2];break i}if(sf(t,f),u[r+27|0]>=0)break i;Z(i[r+16>>2])}v=r+32|0,r=i[k+8>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}b0(A,k+12|0,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),A=i[n+4>>2],i[n+4>>2]=A-1,A||(X[i[i[n>>2]+8>>2]](n),p(n)),v=k+32|0}function TW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-32|0,v=k,A=i[A>>2],o=i[A+48>>2],n=i[A+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,o,e,k+20|0);i:{if(i[k>>2]||(A=i[k+20>>2],o=i[k+24>>2],(A|0)==(o|0)))break i;if(e=!r,w=e,e){for(;;)if(e=i[i[A>>2]+16>>2],!((e|0)==1668047216|(e|0)==1769107316)&(e|0)!=1768778098||(t=t+w|0),A=A+8|0,(o|0)==(A|0))break i}for(e=1;;){s=i[i[A>>2]+16>>2];e:{if(!((s|0)==1668047216|(s|0)==1769107316)&(s|0)!=1768778098)break e;if((f|0)>(t|0)){i[(t<<2)+r>>2]=e,t=t+1|0;break e}t=t+w|0}if(e=e+1|0,A=A+8|0,(o|0)==(A|0))break}}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(A=i[k+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n)}return v=k+32|0,t|0}function Cn(A,e,r){var f=M(0),k=M(0),n=M(0),t=M(0),o=M(0),s=M(0),w=M(0),h=M(0),_=M(0),B=M(0),m=M(0),W=M(0),g=M(0),I=M(0),C=M(0);i[A>>2]=0,i[A+4>>2]=0;i:{e:{if((e&65534)==12){if(e=r-1&65535,e>>>0<=21&&(e=e<<2,o=E0[e+50816>>2],_=E0[e+50728>>2],k=E0[e+50640>>2],s=E0[e+50552>>2],n=E0[e+50464>>2],w=E0[e+50376>>2],t=E0[e+50288>>2],f=E0[e+50200>>2]),h=M(M(1)-M(f+t)),B=M(M(1)-M(s+k)),g=M(M(k*h)-M(t*B)),m=M(M(1)-M(w+n)),I=M(M(t*m)-M(n*h)),W=M(o*M(M(w*g)+M(M(s*I)+M(f*M(M(n*B)-M(k*m)))))),W==M(0))break i;C=M(M(1)-M(_+o)),E0[A>>2]=M(k*M(M(C*M(M(f*n)-M(w*t)))+M(M(_*I)+M(o*M(M(w*h)+M(f*M(-m)))))))/W,f=M(M(n*M(M(C*M(M(s*t)-M(f*k)))+M(M(_*g)+M(o*M(M(f*B)+M(s*M(-h)))))))/W);break e}r:switch(e-1|0){case 0:i[A>>2]=1046066128,f=M(.0722000002861023);break e;case 3:i[A>>2]=1050253722,f=M(.10999999940395355);break e;case 4:case 5:i[A>>2]=1050220167,f=M(.11400000005960464);break e;case 6:i[A>>2]=1046025863,f=M(.08699999749660492);break e;case 8:case 9:break r;default:break i}i[A>>2]=1049002141,f=M(.059300001710653305)}E0[A+4>>2]=f}}function Vn(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k;i:{if(!f){e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183];break i}e:{if(n=i[e+16>>2],!n||(o=X0(n,94804,95964),!o))break e;if(n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),t=i[e>>2],i[k+56>>2]=i[t+48>>2],t=i[t+52>>2],i[k+60>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),e=i[e+8>>2],t=i[e+8>>2],e=i[e+4>>2],s=i[k+60>>2],i[k+16>>2]=i[k+56>>2],i[k+20>>2]=s,tr(k- -64|0,k+16|0,r,e,t),r=i[o+8>>2],(i[o+12>>2]-r|0)>0)for(e=0;r=(e<<3)+r|0,t0[k+24>>3]=i[r>>2],t0[k+32>>3]=i[r+4>>2],r=i[k+36>>2],i[k+8>>2]=i[k+32>>2],i[k+12>>2]=r,r=i[k+28>>2],i[k>>2]=i[k+24>>2],i[k+4>>2]=r,l3(k+40|0,k- -64|0,k),r=(e<<4)+f|0,t0[r>>3]=t0[k+40>>3],t0[r+8>>3]=t0[k+48>>3],e=e+1|0,r=i[o+8>>2],(e|0)<i[o+12>>2]-r>>3;);if(e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;X[i[i[n>>2]+8>>2]](n),p(n);break i}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}v=k+112|0}function SW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;f=v-16|0,v=f;i:{e:{r:{f:{k=l[r+20|0];A:{if(!(!i[r+16>>2]|k&1)){for(;;){o=o2(r),h=W2(r),_=W2(r),k=i[e+104>>2],n=i[e+108>>2];k:{if(k>>>0<n>>>0){t=o|(_<<24|h<<16),Q[k>>1]=t,Q[k+2>>1]=t>>>16,k=k+4|0;break k}if(w=i[e+100>>2],k=k-w|0,B=k>>2,t=B+1|0,t>>>0>=1073741824)break f;if(n=n-w|0,s=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<s>>>0?s:t,n){if(n>>>0>=1073741824)break r;t=E(n<<2)}else t=0;if(s=t+k|0,o=o|(_<<24|h<<16),Q[s>>1]=o,Q[s+2>>1]=o>>>16,o=s-(B<<2)|0,k&&z(o,w,k),i[e+108>>2]=t+(n<<2),k=s+4|0,i[e+104>>2]=k,i[e+100>>2]=o,!w)break k;Z(w)}if(i[e+104>>2]=k,k=u[r+20|0]&1,!(!k&&i[r+16>>2]))break}if(k)break A;break e}if(!(k&1))break e}if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}G0(),H()}x0(),H()}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function jW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15928);break i}e:{if((k|0)==1){o=e,s=R4(r),i[o+104>>2]=s,i[e+108>>2]=l0,o=e,s=R4(r),i[o+112>>2]=s,i[e+116>>2]=l0,o=e,s=F0(r),i[o+120>>2]=s,k=R4(r),n=l0;break e}o=e,s=F0(r),i[o+104>>2]=s,i[e+108>>2]=0,o=e,s=F0(r),i[o+112>>2]=s,i[e+116>>2]=0,o=e,s=F0(r),i[o+120>>2]=s,k=F0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=o2(r),u[e+139|0]=0,u[e+138|0]=k&31|96,u[e+136|0]=k>>>10|96,u[e+137|0]=k>>>5&31|96,e=i[r+16>>2],e=e>>>0>=2?2:e,k=i[r+8>>2],k&&c1(k,e),k=i[r>>2],t=X[i[i[k>>2]+8>>2]](k)|0,n=l0,t=e+t|0,n=e>>>0>t>>>0?n+1|0:n,X[i[i[k>>2]+20>>2]](k,t,n)|0,i[r+16>>2]=i[r+16>>2]-e,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function OW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k,e=i[e>>2],n=i[e+48>>2],e=i[e+52>>2];i:{if(!e){s4(k+24|0,n,r);break i}if(i[e+4>>2]=i[e+4>>2]+1,s4(k+24|0,n,r),r=i[e+4>>2],i[e+4>>2]=r-1,r)break i;X[i[i[e>>2]+8>>2]](e),p(e)}i:{n=i[k+24>>2];e:{if(!n){i[A>>2]=1,i[A+4>>2]=2e3,i[A+8>>2]=3475;break e}if(e=h2(f),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){t=e|7,r=E(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=r,i[k+16>>2]=e;break f}if(u[k+23|0]=e,r=k+12|0,!e)break r}if(!e)break r;z(r,f,e)}u[e+r|0]=0,e=n+116|0;r:{if((e|0)==(k+12|0))break r;if(r=u[k+23|0],u[n+127|0]>=0){if((r|0)>=0){r=i[k+16>>2],i[e>>2]=i[k+12>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+20>>2];break r}D1(e,i[k+12>>2],i[k+16>>2]);break r}f=e,e=(r|0)<0,O1(f,e?i[k+12>>2]:k+12|0,e?i[k+16>>2]:r)}u[k+23|0]<0&&Z(i[k+12>>2]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}A=i[k+28>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;X[i[i[A>>2]+8>>2]](A),p(A)}v=k+32|0;return}g0(),H()}function LW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0,y=0,R=0,N=0,D=0,x=0,S=0,O=0,L=0,a=0,$=0,f0=0,A0=0;f=G(r,6)+e|0,B=F[f+6>>1],s=F[e+6>>1],w=F[e+2>>1],k=s+w|0,m=F[e+4>>1],h=F[e>>1],t=m+h|0,o=k+t|0,n=(r<<2)+e|0,W=F[n+6>>1],g=F[n+2>>1],I=W+g|0,V=F[n>>1],n=F[n+4>>1],C=V+n|0,_=I+C|0,y=o-_|0,e=(r<<1)+e|0,r=F[e+6>>1],R=F[e+2>>1],N=r+R|0,D=F[e+4>>1],e=F[e>>1],x=D+e|0,S=N+x|0,O=F[f+2>>1],L=B+O|0,a=F[f+4>>1],f=F[f>>1],$=a+f|0,f0=L+$|0,A0=S-f0|0,Q[A+24>>1]=y-A0,Q[A+16>>1]=y+A0,o=o+_|0,_=S+f0|0,Q[A+8>>1]=o-_,Q[A>>1]=o+_,k=t-k|0,t=C-I|0,o=k-t|0,I=x-N|0,C=$-L|0,_=I-C|0,Q[A+26>>1]=o-_,Q[A+18>>1]=o+_,k=k+t|0,t=I+C|0,Q[A+10>>1]=k-t,Q[A+2>>1]=k+t,s=w-s|0,w=h-m|0,k=s+w|0,m=g-W|0,n=V-n|0,h=m+n|0,t=k-h|0,r=R-r|0,e=e-D|0,o=r+e|0,B=O-B|0,f=f-a|0,W=B+f|0,g=o-W|0,Q[A+28>>1]=t-g,Q[A+20>>1]=t+g,k=k+h|0,h=o+W|0,Q[A+12>>1]=k-h,Q[A+4>>1]=k+h,s=w-s|0,n=n-m|0,w=s-n|0,e=e-r|0,r=f-B|0,f=e-r|0,Q[A+30>>1]=w-f,Q[A+22>>1]=f+w,f=n+s|0,e=e+r|0,Q[A+14>>1]=f-e,Q[A+6>>1]=e+f}function W8(A,e,r,f,k,n,t,o,s,w,h){var _=0;i:{e:{r:{f:{A:{if(!((e+f|0)<=(w|0)|(e|0)>(w|0)|(r|0)>(h|0))&&(r+f|0)>(h|0))break A;if(f=0,(w|h)<0||(e=i[A+124>>2],i[e+484>>2]<=(w|0)|i[e+488>>2]<=(h|0))||(t=i[A+132>>2],o=i[t+8496>>2],r=i[e+16936>>2],s=i[e+16924>>2],i[(o+(w>>>r<<2)|0)+(G(s,h>>>r|0)<<2)>>2]>i[(o+(k>>r<<2)|0)+(G(s,n>>r)<<2)>>2])||(o=i[A+140>>2],r=i[e+16876>>2],k=k>>r,s=i[A+152>>2],n=n>>r,_=w>>>r|0,r=h>>>r|0,F[(o+G(k,24)|0)+G(G(s,n),24)>>1]!=F[(o+G(_,24)|0)+G(G(r,s),24)>>1]))break r;if(o=k<<2,k=i[t+8484>>2],e=i[e+16892>>2],i[(o+k|0)+(G(e,n)<<2)>>2]==i[(k+(_<<2)|0)+(G(e,r)<<2)>>2])break f;break r}if(t<<1!=(f|0)|o<<1!=(f|0)|((s|0)!=1|(r+o|0)>(h|0)))break f;if(f=0,(e+t|0)>(w|0))break r}if(r=i[A+168>>2],e=w>>r,(e|0)<0||(f=i[A+172>>2],(f|0)<=(e|0)))break e;if(r=h>>r,(r|0)<0|(r|0)>=i[A+176>>2])break i;f=(l[((i[A+160>>2]+G(e,3)|0)+G(G(r,f),3)|0)+1|0]&3)!=0}return f}M0(4656,10913,118,4231),H()}M0(4618,10913,119,4231),H()}function PW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72548,n=i[18140],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18141],t=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72548,i[f+20>>2]=72528,t=R0(k),i[t>>2]=71280,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,M1(k,e,r),e=u[f+19|0],r=(e|0)<0,Y(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18142],i[t>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(t),p0(f+76|0),v=f+160|0}function Y2(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72548,n=i[18140],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18141],t=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72548,i[f+20>>2]=72528,t=R0(k),i[t>>2]=71280,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,Wr(k,e,r),e=u[f+19|0],r=(e|0)<0,Y(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,n,e)}u[A+e|0]=0,A=i[18139],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18142],i[t>>2]=71280,u[f+67|0]<0&&Z(i[f+56>>2]),y0(t),p0(f+76|0),v=f+160|0}function af(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!f){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=42716;break i}r4(k+24|0,i[e>>2],r,1);e:{r:{if(n=i[k+24>>2],n){if(t=X0(n,100708,94396),!t)break r;if(r=i[k+28>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f=k+4|0,X[i[i[t>>2]+52>>2]](f,t),b0(A,f,i[e>>2]),u[k+23|0]<0&&Z(i[k+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;X[i[i[r>>2]+8>>2]](r),p(r);break e}i[f>>2]=0,i[A+8>>2]=42716,i[A>>2]=5,i[A+4>>2]=2e3;break e}r=E(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,f=i[k+28>>2],i[k+24>>2]=0,i[k+28>>2]=0,i[r+4>>2]=f,i[r>>2]=n,n=i[e>>2],f=i[e+4>>2];r:{if(!f){i[r+12>>2]=f,i[r+8>>2]=n;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=n,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=k+32|0}function qW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{e:{if(l[e+97|0]){t1(A,e,19861);break e}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],i[r+16>>2])for(;;){w=W2(r),k=i[e+120>>2],n=i[e+124>>2];r:{if(k>>>0<n>>>0){u[k|0]=w,k=k+1|0;break r}if(o=i[e+116>>2],k=k-o|0,t=k+1|0,(t|0)<0)break i;if(n=n-o|0,s=n<<1,n=n>>>0>=1073741823?2147483647:t>>>0<s>>>0?s:t,n?t=E(n):t=0,s=t+k|0,u[s|0]=w,k&&z(t,o,k),i[e+124>>2]=n+t,k=s+1|0,i[e+120>>2]=k,i[e+116>>2]=t,!o)break r;Z(o)}if(i[e+120>>2]=k,!i[r+16>>2])break}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break e;Z(i[f+20>>2]);break e}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=f+32|0;return}G0(),H()}function KW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n;i:{e:{if((h2(r)|0)!=4){e=i[24173],i[A>>2]=i[24172],i[A+4>>2]=e,i[A+8>>2]=i[24174];break e}if(t=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,$4(n+20|0,0,f,f+k|0,k),r=E(32),i[r+28>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+16>>2]=t<<24|(t&65280)<<8|(t>>>8&65280|t>>>24),i[r+12>>2]=95376,i[r>>2]=95536,i[r+4>>2]=0,i[r+8>>2]=0,f=i[n+24>>2],k=i[n+20>>2],(f|0)!=(k|0)){if(f=f-k|0,(f|0)<0)break i;t=E(f),i[r+20>>2]=t,o=f+t|0,i[r+28>>2]=o,f&&z(t,k,f),i[r+24>>2]=o}e=i[e>>2],i[n+16>>2]=r,i[n+12>>2]=r+12,i[r+4>>2]=i[r+4>>2]+1,X[i[i[e>>2]+12>>2]](e,n+12|0),e=i[n+16>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[r+4>>2],i[r+4>>2]=A-1,A||(X[i[i[r>>2]+8>>2]](r),p(r)),A=i[n+20>>2],!A)break e;i[n+24>>2]=A,Z(A)}v=n+32|0;return}G0(),H()}function ri(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;k=v-32|0,v=k,o=i[e>>2];i:{e:{r:{f:{if(!l[e+16|0]){if(t=o3(o,f),n=0,!t)break r;if(n=i[e+36>>2],e=i[e+32>>2],n-e>>3>>>0<=f>>>0){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}e=e+(f<<3)|0,f=i[e>>2],e=i[e+4>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0;break f}if(t=o3(o,0),o=i[e+24>>2],e=i[e+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,n=0,!t)break r;f=G(f,t),n=f,f=f+o|0,e=n>>>0>f>>>0?e+1|0:e}if(yt(k,r,k+20|0,f,e,t),i[k>>2]){if(e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,r=A+8|0,u[k+19|0]>=0){e=i[k+12>>2],i[r>>2]=i[k+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+16>>2],u[A+20|0]=1;break e}if(T(r,i[k+8>>2],i[k+12>>2]),e=u[k+19|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[k+8>>2]);break e}u[k+19|0]<0&&Z(i[k+8>>2]),s=i[k+28>>2],w=i[k+20>>2],n=i[k+24>>2]}e=n,i[k+24>>2]=0,i[k+28>>2]=0,u[A+20|0]=0,i[A+8>>2]=s,i[A+4>>2]=e,i[A>>2]=w;break i}if(A=i[k+20>>2],!A)break i;i[k+24>>2]=A,Z(A)}v=k+32|0}function $f(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+18592>>2];e:{r:{if(l[r+20|0]){if(e=i[A+18588>>2],n=i[e+52>>2],k=i[e+132>>2],r=i[r+24>>2],f=F[(i[e+140>>2]+G(i[(i[k+8460>>2]+(i[i[k+8448>>2]+(r<<2)>>2]<<2)|0)-4>>2],24)|0)+2>>1],f>>>0>=i[e+56>>2]-n>>2>>>0)break e;if(n=i[n+(f<<2)>>2],f=i[i[e+124>>2]+16892>>2],e=(r|0)/(f|0)|0,Su(k,r-G(e,f)|0,e)){if(e=i[A+18592>>2],r=i[e+804>>2],r>>>0>=3)break i;ji(A+18572|0,r,i[e+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0;break r}if(e=i[A+18596>>2],r=i[e+424>>2],k=i[e+428>>2]-r>>2,k>>>0<2)break e;for(f=i[A+18600>>2],e=1;;){if(t=r+(e<<2)|0,(f|0)!=i[t>>2]){if(e=e+1|0,(k|0)!=(e|0))continue;break e}break}if(e=i[t-4>>2],!e||(es(e+44|0,i[e+120>>2]),l[n+1348|0]!=1))break e;e=A+18572|0,A=n+1340|0,ni(e,A),Zo(A);break r}if(e=i[r+804>>2],e>>>0>=3)break i;ji(A+18572|0,e,i[r+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0}o=1}return o}M0(21701,18308,1520,5105),H()}function Er(A,e,r,f){var k=0,n=0,t=0,o=0;k=i[r+4>>2],o=i[e+4>>2];i:{if((o|0)<=i[A+4>>2]){if((k|0)<=(o|0)||(n=i[e>>2],k=i[e+4>>2],t=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=t,i[r>>2]=n,i[r+4>>2]=k,i[e+4>>2]<=i[A+4>>2]))break i;n=i[A>>2],k=i[A+4>>2],t=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=t,i[e>>2]=n,i[e+4>>2]=k,k=i[r+4>>2];break i}if(t=i[A>>2],n=i[A+4>>2],(k|0)>(o|0)){k=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=k,i[r>>2]=t,i[r+4>>2]=n,k=n;break i}if(k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,i[e>>2]=t,i[e+4>>2]=n,k=i[r+4>>2],(n|0)>=(k|0))break i;k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=t,i[r+4>>2]=n,k=n}i:{if(i[f+4>>2]<=(k|0)||(n=i[r>>2],k=i[r+4>>2],t=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=t,i[f>>2]=n,i[f+4>>2]=k,i[r+4>>2]<=i[e+4>>2])||(f=i[e>>2],n=i[e+4>>2],k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=f,i[r+4>>2]=n,i[e+4>>2]<=i[A+4>>2]))break i;r=i[A>>2],f=i[A+4>>2],n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,i[e>>2]=r,i[e+4>>2]=f}}function aW(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=i[A+16>>2],k=i[r+18588>>2],t=i[k+124>>2],o=i[t+16892>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,f=i[r+18588>>2],n=i[f+124>>2],e=i[n+16908>>2],s=i[r+4>>2],(e|0)>(s|0)&&(e=i[i[i[f+132>>2]+8460>>2]+(s<<2)>>2]),f=i[n+16892>>2],i[r>>2]=e,n=(e|0)/(f|0)|0,i[r+12>>2]=n,i[r+8>>2]=e-G(f,n),f=(e|0)/(o|0)|0;i:{e:{if(l[A+8|0]!=1||$f(r))break e;if((o|0)<=0)break i;for(e=0,f=G(G(f,o),76);t=(f+i[k+320>>2]|0)+G(e,76)|0,i[t>>2]<=0&&(i[t>>2]=1),e=e+1|0,(o|0)!=(e|0););break i}if(Ze(r+18548|0),fr(r,1,!(l[A+8|0]!=1||l[i[r+18592>>2]+20|0])),(f|0)!=i[r+12>>2]||(e=i[r+8>>2],n=i[t+16892>>2],(e|0)>=(n|0)))break i;for(o=G(G(f,o),76);i[t+16892>>2]<=(e|0)|(f|0)>=i[t+16900>>2]||(s=(o+i[k+320>>2]|0)+G(e,76)|0,i[s>>2]<=0&&(i[s>>2]=1)),e=e+1|0,(n|0)!=(e|0););}i[A+4>>2]=3,A=i[r+18600>>2],i[A+44>>2]=i[A+44>>2]+1,h3(k)}function $W(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!(r&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}e=i[e>>2],n=l[r|0],f=l[95568];i:{if(n>>>0>=f>>>0||(k=i[23895],i[e+72>>2]=i[23894],i[e+76>>2]=k,k=i[23897],i[e+80>>2]=i[23896],i[e+84>>2]=k,i[e+88>>2]=i[23898],i[e+92>>2]=i[23899],i[e+96>>2]=i[23900],k=i[23903],i[e+104>>2]=i[23902],i[e+108>>2]=k,i[e+112>>2]=i[23904],i[e+116>>2]=i[23905],i[e+120>>2]=i[23906],i[e+124>>2]=i[23907],f>>>0<2))break i;i[e+136>>2]=i[23910],i[e+140>>2]=i[23911]}f=i[r+12>>2],i[e+72>>2]=i[r+8>>2],i[e+76>>2]=f,f=i[r+20>>2],i[e+80>>2]=i[r+16>>2],i[e+84>>2]=f,i[e+88>>2]=i[r+24>>2],i[e+92>>2]=i[r+28>>2],i[e+96>>2]=i[r+32>>2],f=i[r+44>>2],i[e+104>>2]=i[r+40>>2],i[e+108>>2]=f,i[e+112>>2]=i[r+48>>2],i[e+116>>2]=i[r+52>>2],i[e+120>>2]=i[r+56>>2],i[e+124>>2]=i[r+60>>2],n>>>0>=2&&(i[e+136>>2]=i[r+72>>2],i[e+140>>2]=i[r+76>>2]),i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function dW(){var A=0,e=0,r=0,f=0;i:{e:{r:switch(A=i[26954],A|0){case 0:break i;case 1:break r;default:break e}if(A=i[26938],(A|0)!=107756)for(;;){e=i[i[A+16>>2]+12>>2],e&&X[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==107756)break}if(I3(107752,i[26939]),i[26938]=107756,i[26939]=0,i[26940]=0,A=i[26941],(A|0)!=107768)for(;;){e=i[i[i[A+16>>2]>>2]+32>>2],e&&X[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==107768)break}if(m3(107764,i[26942]),i[26941]=107768,i[26942]=0,i[26943]=0,u[107820]=1,A=i[26983],r=i[26982],(A|0)!=(r|0))for(;;){e=i[A-4>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(r|0)==(A|0))break}i[26983]=r,A=i[26954]}i[26954]=A-1}}function X0(A,e,r){var f=0,k=0,n=0,t=0,o=0;t=v-16|0,v=t,k=i[A>>2],n=i[k-8>>2],i[t+12>>2]=n,i[t+4>>2]=A+n,i[t+8>>2]=i[k-4>>2],n=i[t+8>>2],k=S1(n,r,0),o=i[t+4>>2];i:{if(k){A=v+-64|0,v=A,v=A- -64|0,f=i[t+12>>2]?0:o;break i}if(k=v+-64|0,v=k,(A|0)>=(o|0)&&(i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=0,i[k+12>>2]=r,i[k+4>>2]=n,i[k+60>>2]=0,i[k+52>>2]=1,i[k+56>>2]=16777216,i[k+8>>2]=A,X[i[i[n>>2]+20>>2]](n,k+4|0,o,o,1,0),f=i[k+28>>2]?A:0),v=k- -64|0,f)break i;f=v+-64|0,v=f,i[f+16>>2]=0,i[f+12>>2]=e,i[f+8>>2]=A,i[f+4>>2]=r,A=0,o0(f+20|0,0,39),i[f+60>>2]=0,u[f+59|0]=1,X[i[i[n>>2]+24>>2]](n,f+4|0,o,1,0);e:{r:switch(i[f+40>>2]){case 0:A=i[f+44>>2]==1&&i[f+32>>2]==1&&i[f+36>>2]==1?i[f+24>>2]:0;break e;case 1:break r;default:break e}if(i[f+28>>2]!=1&&i[f+44>>2]|i[f+32>>2]!=1|i[f+36>>2]!=1)break e;A=i[f+20>>2]}v=f- -64|0,f=A}return v=t+16|0,f}function cW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-16|0,v=f,k=i[e+12>>2],o=k,n=i[e+8>>2];i:{e:{if(!(k|n)){for(e=r;i[e+16>>2]=0,e=i[e+8>>2],!!e;);break e}if(t=i[e+32>>2],k=n-t|0,n=o-(n>>>0<t>>>0)|0,!n&k>>>0>=2147483648|n){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,101,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(!f4(r,k)||(n=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),o=i[e+8>>2],t=i[e+32>>2],s=o-t|0,e=i[e+12>>2]-(o>>>0<t>>>0)|0,t=X[i[i[n>>2]+8>>2]](n)|0,o=t+s|0,e=l0+e|0,X[i[i[n>>2]+20>>2]](n,o,o>>>0<t>>>0?e+1|0:e)|0,!k)||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break e;X[i[i[k>>2]+8>>2]](k),p(k)}if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function Fn(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){r:{if(r>>>0>=f>>>0){n=0;break r}if(n=2,e=i[r>>2],e>>>0>1114111|(e&-2048)==55296)break r;f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(t-r|0)<=0)break r;i[A+8>>2]=r+1,u[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(t-r|0)<2)break e;i[A+8>>2]=r+1,u[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(r=i[A+8>>2],n=t-r|0,e>>>0<=65535){if((n|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if((n|0)<4)break e;i[A+8>>2]=r+1,u[r|0]=e>>>18|240,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>12&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128}r=i[A+12>>2]+4|0,i[A+12>>2]=r;continue}break}break i}n=1}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,n|0}function bW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(i[r>>2]==1&&(f=12,n=i[r+4>>2],(n&-4)==12))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0;i:switch(n-12|0){case 0:f=14;case 2:k=i[r+12>>2],e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=k,u[e+8|0]=0,i[e+4>>2]=f,i[e>>2]=1,k=e+28|0,i[A+8>>2]=k,i[A>>2]=e,i[A+4>>2]=k;break;default:break i}t=13;i:{e:{r:switch(n-13|0){case 0:t=15;case 2:if(f=k-e|0,k=(f|0)/28|0,n=k+1|0,n>>>0>=153391690)break e;if(o=i[r+12>>2],r=k<<1,n=k>>>0>=76695844?153391689:r>>>0>n>>>0?r:n,n){if(n>>>0>=153391690)break i;r=E(G(n,28))}else r=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,Q[k+20>>1]=2,i[k+16>>2]=131074,i[k+12>>2]=o,u[k+8|0]=1,i[k+4>>2]=t,i[k>>2]=1,t=k+G((f|0)/-28|0,28)|0,f&&z(t,e,f),i[A+8>>2]=r+G(n,28),i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28;break;default:break r}return}G0(),H()}x0(),H()}function iX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;m=n+7|0,W=n+4|0;i:{if((W|0)>=-2){if((k|0)<=0)break i;for(I=t+6|0,C=k&2147483644,g=k&3,B=-3,V=k>>>0<4;;){if(w=(B<<1)+I|0,s=(G(f,B)<<1)+r|0,h=0,!V)for(;Q[w>>1]=F[s>>1],_=w,w=m<<1,_=_+w|0,Q[_>>1]=F[s+2>>1],_=w+_|0,Q[_>>1]=F[s+4>>1],_=w+_|0,Q[_>>1]=F[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(C|0)!=(h|0););if(h=0,g)for(;Q[w>>1]=F[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(g|0)!=(h|0););if(B=B+1|0,(W|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;Q[w>>1]=(((((Q[s+2>>1]<<2)-Q[s>>1]|0)+G(Q[s+8>>1]+Q[s+6>>1]|0,40)|0)+(Q[s+12>>1]<<2)|0)-Q[s+14>>1]|0)+G(Q[s+10>>1]+Q[s+4>>1]|0,-11)>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function eX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;m=n+6|0,W=n+3|0;i:{if((W|0)>=-2){if((k|0)<=0)break i;for(I=t+6|0,C=k&2147483644,g=k&3,B=-3,V=k>>>0<4;;){if(w=(B<<1)+I|0,s=(G(f,B)<<1)+r|0,h=0,!V)for(;Q[w>>1]=F[s>>1],_=w,w=m<<1,_=_+w|0,Q[_>>1]=F[s+2>>1],_=w+_|0,Q[_>>1]=F[s+4>>1],_=w+_|0,Q[_>>1]=F[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(C|0)!=(h|0););if(h=0,g)for(;Q[w>>1]=F[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(g|0)!=(h|0););if(B=B+1|0,(W|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;Q[w>>1]=Q[s+12>>1]+((((((Q[s+2>>1]<<2)-Q[s>>1]|0)+G(Q[s+4>>1],-10)|0)+G(Q[s+6>>1],58)|0)+G(Q[s+8>>1],17)|0)+G(Q[s+10>>1],-5)|0)>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function rX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0,V=0;m=n+6|0,W=n+4|0;i:{if((W|0)>=-1){if((k|0)<=0)break i;for(I=t+4|0,C=k&2147483644,g=k&3,B=-2,V=k>>>0<4;;){if(w=(B<<1)+I|0,s=(G(f,B)<<1)+r|0,h=0,!V)for(;Q[w>>1]=F[s>>1],_=w,w=m<<1,_=_+w|0,Q[_>>1]=F[s+2>>1],_=w+_|0,Q[_>>1]=F[s+4>>1],_=w+_|0,Q[_>>1]=F[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(C|0)!=(h|0););if(h=0,g)for(;Q[w>>1]=F[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(g|0)!=(h|0););if(B=B+1|0,(W|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;Q[w>>1]=(((((Q[s>>1]+G(Q[s+2>>1],-5)|0)+G(Q[s+4>>1],17)|0)+G(Q[s+6>>1],58)|0)+G(Q[s+8>>1],-10)|0)+(Q[s+10>>1]<<2)|0)-Q[s+12>>1]>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function En(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;t=v-32|0,v=t,n=f&65535,o=f>>>16&32767;i:{if(o-16257>>>0<=253){k=(n&33554431)<<7|r>>>25,n=0,r=r&33554431;e:{if(!(!n&(r|0)==16777216?!(A|e):!n&r>>>0<16777216)){k=k+1|0;break e}if(r^16777216|A|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?0:k,A=o+(A?-16255:-16256)|0;break i}if(!(!(A|r|(e|n))|((o|0)!=32767|(k|0)!=0))){k=(n&33554431)<<7|r>>>25|4194304,A=255;break i}if(o>>>0>16510){A=255;break i}if(k=!(k|o),w=k?16256:16257,s=w-o|0,(s|0)>112){k=0,A=0;break i}n=k?n:n|65536,o4(t+16|0,A,e,r,n,128-s|0),Y6(t,A,e,r,n,s),A=i[t+8>>2],k=(i[t+12>>2]&33554431)<<7|A>>>25,r=i[t>>2]|(o|0)!=(w|0)&(i[t+16>>2]|i[t+24>>2]|(i[t+20>>2]|i[t+28>>2]))!=0,n=i[t+4>>2],e=0,A=A&33554431;e:{if(!(!e&(A|0)==16777216?!(r|n):!e&A>>>0<16777216)){k=k+1|0;break e}if(A^16777216|r|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?k^8388608:k}return v=t+32|0,U2(2,f&-2147483648|A<<23|k),q4()}function pn(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=o>>>0|A>>>0>=f>>>0)break i;e=u[A|0],t=e&255,n=1;e:{if((e|0)>=0)break e;if(e>>>0<4294967234)break i;if(e>>>0<=4294967263){if((l[A+1|0]&192)!=128|(f-A|0)<2)break i;n=2;break e}if(e>>>0<=4294967279){if((f-A|0)<3)break i;n=l[A+2|0],e=u[A+1|0];r:{f:{if((t|0)!=237){if((t|0)!=224)break f;if((e&-32)==-96)break r;break i}if((e|0)>=-96)break i;break r}if((e|0)>-65)break i}if((n&192)!=128)break i;n=3;break e}if((f-A|0)<4|e>>>0>4294967284)break i;n=l[A+3|0],s=l[A+2|0],e=u[A+1|0];r:{f:switch(t-240|0){case 0:if((e+112&255)>>>0>=48)break i;break r;case 4:if((e|0)>=-112)break i;break r;default:break f}if((e|0)>-65)break i}if((s&192)!=128|(n&192)!=128|(n&63|(s<<6&4032|(t<<18&1835008|(e&63)<<12)))>>>0>1114111)break i;n=4}o=o+1|0,A=A+n|0;continue}break}return A-r|0}function yn(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=t>>>0|A>>>0>=f>>>0)break i;e=l[A|0],n=A+1|0;e:{if(e<<24>>24>=0)break e;if(e>>>0<194)break i;if(e>>>0<=223){if((l[A+1|0]&192)!=128|(f-A|0)<2)break i;n=A+2|0;break e}if(e>>>0<=239){if((f-A|0)<3)break i;o=l[A+2|0],n=u[A+1|0];r:{f:{if((e|0)!=237){if((e|0)!=224)break f;if((n&-32)==-96)break r;break i}if((n|0)>=-96)break i;break r}if((n|0)>-65)break i}if((o&192)!=128)break i;n=A+3|0;break e}if((f-A|0)<4|e>>>0>244|k-t>>>0<2)break i;o=l[A+3|0],s=l[A+2|0],n=u[A+1|0];r:{f:switch(e-240|0){case 0:if((n+112&255)>>>0>=48)break i;break r;case 4:if((n|0)>=-112)break i;break r;default:break f}if((n|0)>-65)break i}if((s&192)!=128|(o&192)!=128|(o&63|(s<<6&4032|(e<<18&1835008|(n&63)<<12)))>>>0>1114111)break i;t=t+1|0,n=A+4|0}A=n,t=t+1|0;continue}break}return A-r|0}function fX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,5795);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function pr(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{e:{if((e|0)==8){e=p2(r);break e}if(f=28,e&3|e>>>0<4||(n=e>>>2|0,n-1&n))break i;if(-64-e>>>0<r>>>0)return 48;n=16,e=e>>>0<=16?16:e,f=e>>>0<=16?16:e;r:{if(!(f-1&f)){e=f;break r}for(;e=n,n=e<<1,e>>>0<f>>>0;);}r:{if(-64-e>>>0<=r>>>0){i[31336]=48,r=0;break r}if(n=r>>>0<11?16:r+11&-8,k=p2((n+e|0)+12|0),r=0,!k)break r;r=k-8|0;f:{if(!(k&e-1)){e=r;break f}if(t=k-4|0,o=i[t>>2],f=e,e=((e+k|0)-1&0-e)-8|0,e=(e-r>>>0<=15?f:0)+e|0,f=e-r|0,k=(o&-8)-f|0,!(o&3)){r=i[r>>2],i[e+4>>2]=k,i[e>>2]=r+f;break f}i[e+4>>2]=k|i[e+4>>2]&1|2,k=e+k|0,i[k+4>>2]=i[k+4>>2]|1,i[t>>2]=f|i[t>>2]&1|2,k=r+f|0,i[k+4>>2]=i[k+4>>2]|1,ur(r,f)}r=i[e+4>>2];f:{if(!(r&3)||(f=r&-8,f>>>0<=n+16>>>0))break f;i[e+4>>2]=n|r&1|2,r=e+n|0,n=f-n|0,i[r+4>>2]=n|3,f=e+f|0,i[f+4>>2]=i[f+4>>2]|1,ur(r,n)}r=e+8|0}e=r}if(!e)return 48;i[A>>2]=e,f=0}return f}function AX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-112|0,v=n;i:{if(!(k&&f)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}e:{if(t=i[e+16>>2],!t||(w=X0(t,94804,95788),!w))break e;if(t=i[e+20>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),o=i[e>>2],i[n+56>>2]=i[o+48>>2],o=i[o+52>>2],i[n+60>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[e+8>>2],o=i[e+8>>2],e=i[e+4>>2],s=i[n+60>>2],i[n+16>>2]=i[n+56>>2],i[n+20>>2]=s,s=n- -64|0,tr(s,n+16|0,r,e,o),t0[n+24>>3]=i[w+4>>2],t0[n+32>>3]=i[w+8>>2],e=i[n+36>>2],i[n+8>>2]=i[n+32>>2],i[n+12>>2]=e,e=i[n+28>>2],i[n>>2]=i[n+24>>2],i[n+4>>2]=e,l3(n+40|0,s,n),t0[f>>3]=t0[n+40>>3],t0[k>>3]=t0[n+48>>3],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t);break i}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}v=n+112|0}function kX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;B=n+7|0,m=n+4|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(g=t+6|0,I=k&2147483644,W=k&3,_=-3,C=k>>>0<4;;){if(s=(_<<1)+g|0,o=G(f,_)+r|0,w=0,!C)for(;Q[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,Q[h>>1]=l[o+1|0],h=s+h|0,Q[h>>1]=l[o+2|0],h=s+h|0,Q[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(I|0)!=(w|0););if(w=0,W)for(;Q[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(W|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;Q[s>>1]=(((((F[o+2>>1]<<2)-F[o>>1]|0)+G(F[o+8>>1]+F[o+6>>1]|0,40)|0)+(F[o+12>>1]<<2)|0)-F[o+14>>1]|0)+G(F[o+10>>1]+F[o+4>>1]|0,-11),o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function nX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;B=n+6|0,m=n+3|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(g=t+6|0,I=k&2147483644,W=k&3,_=-3,C=k>>>0<4;;){if(s=(_<<1)+g|0,o=G(f,_)+r|0,w=0,!C)for(;Q[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,Q[h>>1]=l[o+1|0],h=s+h|0,Q[h>>1]=l[o+2|0],h=s+h|0,Q[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(I|0)!=(w|0););if(w=0,W)for(;Q[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(W|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;Q[s>>1]=F[o+12>>1]+((((((F[o+2>>1]<<2)-F[o>>1]|0)+G(F[o+4>>1],-10)|0)+G(F[o+6>>1],58)|0)+G(F[o+8>>1],17)|0)+G(F[o+10>>1],-5)|0),o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function tX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;B=n+6|0,m=n+4|0;i:{if((m|0)>=-1){if((k|0)<=0)break i;for(g=t+4|0,I=k&2147483644,W=k&3,_=-2,C=k>>>0<4;;){if(s=(_<<1)+g|0,o=G(f,_)+r|0,w=0,!C)for(;Q[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,Q[h>>1]=l[o+1|0],h=s+h|0,Q[h>>1]=l[o+2|0],h=s+h|0,Q[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(I|0)!=(w|0););if(w=0,W)for(;Q[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(W|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;Q[s>>1]=(((((F[o>>1]+G(F[o+2>>1],-5)|0)+G(F[o+4>>1],17)|0)+G(F[o+6>>1],58)|0)+G(F[o+8>>1],-10)|0)+(F[o+10>>1]<<2)|0)-F[o+12>>1],o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function uX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;if(n=v-16|0,v=n,t=i[e+68>>2],t){t=X[i[i[t>>2]+24>>2]](t)|0;i:{e:{if(!(!i[e+64>>2]|(r|f)!=0&(t|0)<=0)&&!(X[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(k>>>0>=3){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(o=i[e+64>>2],f=O0(r,f,t,0),r=(t|0)>0,W3(o,r?f:0,r?l0:0,k)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e+64>>2],f=X[i[r+40>>2]](r,0,0,l[r|0]&128?i[r+20>>2]==i[r+28>>2]?1:2:1)|0,k=l0;e:{if((k|0)<0)break e;if(t=i[r+8>>2],t)o=4;else{if(t=i[r+28>>2],!t)break e;o=20}r=i[o+r>>2]-t|0,f=r+f|0,k=(r>>31)+k|0,k=r>>>0>f>>>0?k+1|0:k}l0=k,i[A+8>>2]=f,i[A+12>>2]=l0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+76>>2],e=i[e+72>>2],i[n>>2]=e,i[n+4>>2]=r,i[n+8>>2]=e,i[n+12>>2]=r,e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e}v=n+16|0;return}Q1(),H()}function fi(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{if(t=i[A+4>>2],f=i[A>>2],k=t-f|0,r=((k|0)/20|0)+1|0,r>>>0<214748365){if(o=(i[A+8>>2]-f|0)/20|0,s=o<<1,r=o>>>0>=107374182?214748364:r>>>0<s>>>0?s:r,r>>>0>=214748365)break i;s=G(r,20),w=E(s),o=w+k|0,r=o,n=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=n,r=r+8|0;e:{if(u[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2];break e}T(r,i[e+8>>2],i[e+12>>2]),t=i[A+4>>2],f=i[A>>2],k=t-f|0}if(r=o+G((k|0)/-20|0,20)|0,(f|0)!=(t|0)){for(e=f,k=r;n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+16>>2]=i[e+16>>2],n=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=n,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,k=k+20|0,e=e+20|0,(t|0)!=(e|0););for(;u[f+19|0]<0&&Z(i[f+8>>2]),f=f+20|0,(t|0)!=(f|0););f=i[A>>2]}return e=o+20|0,i[A+4>>2]=e,i[A>>2]=r,i[A+8>>2]=s+w,f&&Z(f),e}G0(),H()}x0(),H()}function Yn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){if(e){for(e=(e<<3)+r|0;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(e|0)!=(r|0););r=e}i[A+4>>2]=r;return}i:{if(k=i[A>>2],r=r-k|0,n=(r>>3)+e|0,n>>>0<536870912){if(f=f-k|0,k=f>>2,o=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,o){if(o>>>0>=536870912)break i;k=E(o<<3)}else k=0;for(f=k+r|0,h=f+(e<<3)|0,r=f;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(h|0)!=(r|0););if(e=i[A>>2],s=i[A+4>>2],f=f+(e-s|0)|0,(e|0)!=(s|0)){for(r=e,n=f;t=v-16|0,v=t,l[108685]==1&&(i[t+4>>2]=r,i[t>>2]=n,y8(33190,t)),w=i[r+4>>2],w&&(i[w>>2]=i[w>>2]+1),i[n+4>>2]=w,i[n>>2]=i[r>>2],v=t+16|0,n=n+8|0,r=r+8|0,(s|0)!=(r|0););for(;e=P8(e)+8|0,(s|0)!=(e|0););e=i[A>>2]}i[A+4>>2]=h,i[A>>2]=f,i[A+8>>2]=k+(o<<3),e&&Z(e);return}G0(),H()}x0(),H()}function t8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((e|0)!=(r|0))for(o=A+4|0;;){n=i[A+4>>2];i:{e:{r:{if(f=o,w=i[A>>2],(f|0)==(w|0))break r;t=f;f:{if(k=n,k){for(;f=k,k=i[f+4>>2],!!k;);if(s=i[e+16>>2],s>>>0<=u0[f+16>>2])break f;break r}for(;f=i[t+8>>2],k=i[f>>2]==(t|0),t=f,!!k;);if(t=o,k=t,u0[f+16>>2]<u0[e+16>>2])break r;break e}for(;;){if(k=n,f=i[k+16>>2],f>>>0>s>>>0){if(t=k,n=i[k>>2],n)continue;break e}if(f>>>0>=s>>>0)break i;if(n=i[k+4>>2],!n)break}t=k+4|0;break e}if(t=n?f+4|0:o,i[t>>2])break i;k=n?f:o}f=E(20),n=i[e+16>>2],i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=n,i[t>>2]=f,k=i[w>>2],k&&(i[A>>2]=k),m1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}k=i[e+4>>2];i:{if(k){for(;;)if(f=k,k=i[f>>2],!k)break i}for(;f=i[e+8>>2],k=i[f>>2]!=(e|0),e=f,!!k;);}if(e=f,(r|0)==(f|0))break}}function oX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!(!e|!r)){f=F[e>>1],E0[r>>2]=(f+28535&65535)>>>0<28540?M(0):M(+(f>>>0)*2e-5),f=F[e+6>>1],E0[r+12>>2]=(f+23535&65535)>>>0<23540?M(0):M(+(f>>>0)*2e-5),f=F[e+2>>1],E0[r+4>>2]=(f+28535&65535)>>>0<28540?M(0):M(+(f>>>0)*2e-5),f=F[e+8>>1],E0[r+16>>2]=(f+23535&65535)>>>0<23540?M(0):M(+(f>>>0)*2e-5),f=F[e+4>>1],E0[r+8>>2]=(f+28535&65535)>>>0<28540?M(0):M(+(f>>>0)*2e-5),f=F[e+10>>1],E0[r+20>>2]=(f+23535&65535)>>>0<23540?M(0):M(+(f>>>0)*2e-5),f=F[e+12>>1],E0[r+24>>2]=(f+28535&65535)>>>0<28540?M(0):M(+(f>>>0)*2e-5),f=F[e+14>>1],E0[r+28>>2]=(f+23535&65535)>>>0<23540?M(0):M(+(f>>>0)*2e-5),f=i[e+16>>2],t0[r+32>>3]=f-100000001>>>0<4195017295?0:+(f>>>0)*1e-4,e=i[e+20>>2],t0[r+40>>3]=e-50001>>>0<4294917296?0:+(e>>>0)*1e-4,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;return}e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583]}function df(A,e,r,f,k,n){var t=0,o=0,s=0;t=v-32|0,v=t,i[t+8>>2]=0,i[t>>2]=0,i[t+4>>2]=0;i:{e:{r:{if(n>>>0<2)break r;f:switch(n-3|0){case 1:if(u[t+12|0]=0,u[t+23|0]=0,K(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e;case 0:if(u[t+12|0]=0,u[t+23|0]=0,K(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e;case 2:break f;default:break r}if(u[t+12|0]=0,u[t+23|0]=0,K(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e}o=!k;r:{if(o)break r;if((k|0)<0)break i;if(n=E(k),i[t>>2]=n,s=k+n|0,i[t+8>>2]=s,i[t+4>>2]=s,o)break r;z(n,f,k)}if(rr(t+12|0,i[e+68>>2],i[i[r>>2]+104>>2],t,0),u[t+31|0]<0&&Z(i[t+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}A=i[t>>2],A&&(i[t+4>>2]=A,Z(A)),v=t+32|0;return}G0(),H()}function cf(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0;o=v-16|0,v=o,e=X[i[i[e>>2]+8>>2]](e)|0,s=i[r>>2],i[o+12>>2]=i[s+116>>2],i[o+8>>2]=i[s+120>>2],k=e||k,e=i[f>>2];i:{if(i[e>>2]>=2){X[i[e+108>>2]](i[f+4>>2],o+12|0,o+8|0);break i}X[i[e+96>>2]](o+12|0,o+8|0)}u[o+6|0]=1,Q[o+4>>1]=2,i[o>>2]=131074;i:{if(k){xl(o,k);break i}if(S4(i[r>>2])){f=i[r>>2],e=F[f+6>>1]|F[f+8>>1]<<16,f=F[f+10>>1]|F[f+12>>1]<<16,i[o>>2]=e,u[o+6|0]=f>>>16,Q[o+4>>1]=f;break i}u[o+6|0]=1,Q[o+4>>1]=2,Q[o>>1]=2,Q[o+2>>1]=2}Sl(o);i:{e:{if(w=i[o+12>>2],s=i[r>>2],h=i[o+8>>2],(w|0)!=i[s+116>>2]|(h|0)!=i[s+120>>2]||!(w|!k)&&(f=F[s+6>>1]|F[s+8>>1]<<16,e=F[s+10>>1]|F[s+12>>1]<<16,(!l[k+16|0]|0)==((e&65536)>>>16|0)|(i[k+12>>2]!=(e&65535)|i[k+4>>2]!=(f&65535))))break e;e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=s;break i}r6(A,r,w,h,o,0,n,0,t)}v=o+16|0}function lX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-96|0,v=r;i:{e:{r:{if(i[A+16>>2]!=i[e+16>>2])break r;i[r+88>>2]=0,i[r+92>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,X[i[i[A>>2]+20>>2]](r+44|0,A,r+80|0),u[r+63|0]<0&&Z(i[r+52>>2]),X[i[i[e>>2]+20>>2]](r+24|0,e,r- -64|0),u[r+43|0]<0&&Z(i[r+32>>2]),i[r+20>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,A=i[r+84>>2],f=i[r+80>>2];f:{if((A|0)==(f|0)){e=0,f=0;break f}if(A=A-f|0,(A|0)<0)break e;e=E(A),A&&z(e,f,A),f=A+e|0}i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,A=i[r+68>>2],n=i[r+64>>2];f:{if((A|0)==(n|0)){A=0;break f}if(k=A-n|0,(k|0)<0)break i;A=E(k),k&&z(A,n,k),k=A+k|0}if(n=0,f=f-e|0,(f|0)==(k-A|0)&&(n=!N2(e,A,f)),A&&Z(A),e&&Z(e),A=i[r+64>>2],A&&(i[r+68>>2]=A,Z(A)),A=i[r+80>>2],!A)break r;i[r+84>>2]=A,Z(A)}return v=r+96|0,n|0}G0(),H()}G0(),H()}function sX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;s=v-16|0,v=s,o=E(32),i[o+28>>2]=n,i[o+24>>2]=k,i[o+20>>2]=f,i[o+16>>2]=r,i[o+12>>2]=95808,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=96068,r=i[e+8>>2],i[s+12>>2]=o,f=o+12|0,i[s+8>>2]=f,i[o+4>>2]=i[o+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!t||(i[o+4>>2]=i[o+4>>2]+1,r=E(24),i[o+4>>2]=i[o+4>>2]+1,i[r+20>>2]=o,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[t>>2]=r,e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;X[i[i[o>>2]+8>>2]](o),p(o)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[o+4>>2],i[o+4>>2]=A-1,A||(X[i[i[o>>2]+8>>2]](o),p(o)),v=s+16|0}function wX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;s=v-16|0,v=s,o=E(32),i[o+28>>2]=n,i[o+24>>2]=k,i[o+20>>2]=f,i[o+16>>2]=r,i[o+12>>2]=95852,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=96108,r=i[e+8>>2],i[s+12>>2]=o,f=o+12|0,i[s+8>>2]=f,i[o+4>>2]=i[o+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!t||(i[o+4>>2]=i[o+4>>2]+1,r=E(24),i[o+4>>2]=i[o+4>>2]+1,i[r+20>>2]=o,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[t>>2]=r,e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;X[i[i[o>>2]+8>>2]](o),p(o)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[o+4>>2],i[o+4>>2]=A-1,A||(X[i[i[o>>2]+8>>2]](o),p(o)),v=s+16|0}function ee(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{if(f=i[A>>2],n=i[A+4>>2]-f|0,r=((n|0)/20|0)+1|0,r>>>0<214748365){if(f=(i[A+8>>2]-f|0)/20|0,k=f<<1,r=f>>>0>=107374182?214748364:r>>>0<k>>>0?k:r,r>>>0>=214748365)break i;if(s=G(r,20),w=E(s),k=n+w|0,r=k,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+16>>2]=i[e+16>>2],r=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,t=i[A+4>>2],r=i[A>>2],n=k+G((t-r|0)/-20|0,20)|0,(r|0)!=(t|0)){for(e=r,f=n;o=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=o,i[f+16>>2]=i[e+16>>2],o=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=o,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,f=f+20|0,e=e+20|0,(t|0)!=(e|0););for(;u[r+19|0]<0&&Z(i[r+8>>2]),r=r+20|0,(t|0)!=(r|0););r=i[A>>2]}return e=k+20|0,i[A+4>>2]=e,i[A>>2]=n,i[A+8>>2]=s+w,r&&Z(r),e}G0(),H()}x0(),H()}function hX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0;s=i[e+24>>2],s>>>0>u0[e+44>>2]&&(i[e+44>>2]=s),s=-1,B=-1,w=n&24;i:{if(!w|(k|0)==1&(w|0)==24)break i;w=i[e+44>>2],w&&(t=e+32|0,l[t+11|0]>>>7|0&&(t=i[t>>2]),t=w-t|0,h=t>>31);e:{r:switch(k|0){case 1:if(n&8){o=i[e+12>>2]-i[e+8>>2]|0,_=o>>31;break e}o=i[e+24>>2]-i[e+20>>2]|0,_=o>>31;break e;case 0:break e;case 2:break r;default:break i}o=t,_=h}if(f=f+_|0,r=r+o|0,f=o>>>0>r>>>0?f+1|0:f,(f|0)<0|(r>>>0>t>>>0&(f|0)>=(h|0)|(f|0)>(h|0)))break i;k=n&8;e:{if(!(r|f))break e;if(!i[e+12>>2]&&k)break i;if(!(n&16))break e;if(!i[e+24>>2])break i}k&&(k=i[e+8>>2],i[e+16>>2]=i[e+44>>2],i[e+12>>2]=r+k,i[e+8>>2]=k),n&16&&(k=i[e+20>>2],i[e+28>>2]=i[e+28>>2],i[e+20>>2]=k,i[e+24>>2]=k,i[e+24>>2]=r+i[e+24>>2]),s=r,B=f}i[A+8>>2]=s,i[A+12>>2]=B,i[A>>2]=0,i[A+4>>2]=0}function Rn(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0;if(t=v-48|0,v=t,Z8(t+40|0,e,1835625829),s=i[t+40>>2],o=s,u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1,o=h2(r),o>>>0<2147483640){i:{e:{if(o>>>0>=11){h=o|7,w=E(h+1|0),i[t+36>>2]=h-2147483647,i[t+28>>2]=w,i[t+32>>2]=o;break e}if(u[t+39|0]=o,w=t+28|0,!o)break i}if(!o)break i;z(w,r,o)}u[o+w|0]=0,r=s+128|0;i:{if((r|0)==(t+28|0))break i;if(o=u[t+39|0],u[s+139|0]>=0){if((o|0)>=0){o=i[t+32>>2],i[r>>2]=i[t+28>>2],i[r+4>>2]=o,i[r+8>>2]=i[t+36>>2];break i}D1(r,i[t+28>>2],i[t+32>>2]);break i}s=r,r=(o|0)<0,O1(s,r?i[t+28>>2]:t+28|0,r?i[t+32>>2]:o)}u[t+39|0]<0&&Z(i[t+28>>2]),r=i[i[t+40>>2]+104>>2],df(t+8|0,e,t+40|0,k,n,f),u[t+27|0]<0&&Z(i[t+16>>2]),u[A+20|0]=0,i[A>>2]=r,A=i[t+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+48|0;return}g0(),H()}function Jn(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;if(n=v-48|0,v=n,Z8(n+40|0,e,1970432288),o=i[n+40>>2],t=o,u[t+164|0]=1,i[t+100>>2]=i[t+100>>2]&-2|1,t=h2(r),t>>>0<2147483640){i:{e:{if(t>>>0>=11){w=t|7,s=E(w+1|0),i[n+36>>2]=w-2147483647,i[n+28>>2]=s,i[n+32>>2]=t;break e}if(u[n+39|0]=t,s=n+28|0,!t)break i}if(!t)break i;z(s,r,t)}u[t+s|0]=0,r=o+152|0;i:{if((r|0)==(n+28|0))break i;if(t=u[n+39|0],u[o+163|0]>=0){if((t|0)>=0){t=i[n+32>>2],i[r>>2]=i[n+28>>2],i[r+4>>2]=t,i[r+8>>2]=i[n+36>>2];break i}D1(r,i[n+28>>2],i[n+32>>2]);break i}o=r,r=(t|0)<0,O1(o,r?i[n+28>>2]:n+28|0,r?i[n+32>>2]:t)}u[n+39|0]<0&&Z(i[n+28>>2]),r=i[i[n+40>>2]+104>>2],df(n+8|0,e,n+40|0,f,k,0),u[n+27|0]<0&&Z(i[n+16>>2]),u[A+20|0]=0,i[A>>2]=r,A=i[n+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=n+48|0;return}g0(),H()}function yr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{if(o=i[A+4>>2],f=i[A>>2],k=o-f|0,s=k>>4,r=s+1|0,r>>>0<268435456){if(n=i[A+8>>2]-f|0,t=n>>3,r=n>>>0>=2147483632?268435455:r>>>0<t>>>0?t:r,r>>>0>=268435456)break e;if(w=r<<4,t=E(w),r=i[e>>2],n=k+t|0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=r,k=i[e+8>>2],r=i[e+4>>2],(k|0)!=(r|0)){if(e=k-r|0,(e|0)<0)break i;k=E(e),i[n+4>>2]=k,h=e+k|0,i[n+12>>2]=h,e&&z(k,r,e),i[n+8>>2]=h}if(k=n-(s<<4)|0,(f|0)!=(o|0)){for(r=f,e=k;i[e>>2]=i[r>>2],i[e+4>>2]=i[r+4>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=e+16|0,r=r+16|0,(o|0)!=(r|0););for(;e=i[f+4>>2],e&&(i[f+8>>2]=e,Z(e)),f=f+16|0,(o|0)!=(f|0););f=i[A>>2]}return i[A+8>>2]=t+w,e=n+16|0,i[A+4>>2]=e,i[A>>2]=k,f&&Z(f),e}G0(),H()}x0(),H()}G0(),H()}function Yr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;if(o=v-16|0,v=o,s=A+2140|0,lo(s,1)){if(k=(u[i[A+1384>>2]+13|0]<<3)+A|0,n=i[k+728>>2],t=i[k+732>>2],t&&(i[t+4>>2]=i[t+4>>2]+2),i[o+12>>2]=t,i[o+8>>2]=n,k=i[o+12>>2],i[o>>2]=i[o+8>>2],i[o+4>>2]=k,k=0,s=ln(s,o,A,0,0,0,0),(s|0)>=0){if(n=i[A+2152>>2],A=i[A+2148>>2],s>>>0<n-A>>2>>>0&&(k=i[A+(s<<2)>>2]),n=1<<i[e+16832>>2]-1,A=1<<i[e+16840>>2]-1,i[k+4>>2]&&xf(k,0,n),i[k+8>>2]&&xf(k,1,A),i[k+12>>2]&&xf(k,2,A),i[k+164>>2]>0)for(A=0;n=i[k+160>>2]+G(A,3)|0,w=(l[n|0]|l[n+1|0]<<8)&64767,u[n|0]=w,u[n+1|0]=w>>>8,A=A+1|0,(A|0)<i[k+164>>2];);i[k+96>>2]=r,A=i[e+16868>>2],u[k+104|0]=0,u[k+312|0]=1,i[k+100>>2]=f?2:1,i[k+92>>2]=A-1&r}i:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t)}return v=o+16|0,s}M0(26552,18166,1428,12303),H()}function _X(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;k=v-16|0,v=k,i[k+12>>2]=r,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e|r|i[A+92>>2]!=32||(f=i[A+64>>2],f?(i[f+80>>2]=-1,i[f+48>>2]=0,i[f>>2]=i[f>>2]|64,f=0):f=34,i[A+92>>2]=f);i:{if(l[A+96|0]!=1||(f=i[A+32>>2],!f))break i;Z(f)}i:{if(l[A+97|0]!=1||(f=i[A+56>>2],!f))break i;Z(f)}i[A+52>>2]=r;i:{e:{r:{f:{if(r>>>0>=9){if(f=l[A+98|0],!e|!(f&1))break f;u[A+96|0]=0,i[A+32>>2]=e;break r}if(u[A+96|0]=0,i[A+52>>2]=8,i[A+32>>2]=A+44,u[A+98|0]&1)break r;break e}if(r=E(r),u[A+96|0]=1,i[A+32>>2]=r,!(f&1))break e}e=0,i[A+60>>2]=0,r=0;break i}if(i[k+8>>2]=8,r=v-16|0,v=r,v=r+16|0,r=k+8|0,f=k+12|0,f=i[(i[f>>2]<i[r>>2]?r:f)>>2],i[A+60>>2]=f,e&&(r=0,f>>>0>8))break i;e=E(f),r=1}return u[A+97|0]=r,i[A+56>>2]=e,v=k+16|0,A|0}function bf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=i[A+100>>2],n=f,k=i[A+104>>2],r=k,o=f-r|0,t=f>>31,f=r>>31,t=t-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(t+(o>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=G2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=l0,k=t>>31,n=o+(k|1)|0,k=t+k|0,o=G2(n,n>>>0<o>>>0?k+1|0:k,2,0),t=l0,(t-(o>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(t=r,A=$i(A,e),A=O0(r,n,A,A>>31),r=A+o|0,e=l0+(o>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=t+(A|1)|0,A=n+A|0,t=G2(e,e>>>0<t>>>0?A+1|0:A,2,0),n=l0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=G2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=l0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=t,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,G2(e,e>>>0<r>>>0?A+1|0:A,t,n)}function iA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=i[A+108>>2],n=f,k=i[A+112>>2],r=k,o=f-r|0,t=f>>31,f=r>>31,t=t-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(t+(o>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=G2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=l0,k=t>>31,n=o+(k|1)|0,k=t+k|0,o=G2(n,n>>>0<o>>>0?k+1|0:k,2,0),t=l0,(t-(o>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(t=r,A=Ki(A,e),A=O0(r,n,A,A>>31),r=A+o|0,e=l0+(o>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=t+(A|1)|0,A=n+A|0,t=G2(e,e>>>0<t>>>0?A+1|0:A,2,0),n=l0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=G2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=l0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=t,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,G2(e,e>>>0<r>>>0?A+1|0:A,t,n)}function BX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;i:{if(n=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2],!k)break i;for(;;){if(n4(i[k+4>>2],r)){if(k=i[n+4>>2],n=n+4|0,k)continue;break i}break}e:switch(i[k+8>>2]-1|0){case 0:for(k=A,n=e,t=r;A=f,f=f+1|0,e=u[A|0],!!((e|0)==32|e-9>>>0<5););r=1;r:switch((e&255)-43|0){case 2:r=0;case 0:e=u[f|0],A=f;break;default:break r}if(f=0,e=e-48|0,e>>>0<=9)for(;f=G(f,10)-e|0,e=u[A+1|0],A=A+1|0,e=e-48|0,e>>>0<10;);Dn(k,n,t,r?0-f|0:f);return;case 1:k=1;r:{if(!n4(f,11885)||(k=0,!n4(f,12200)|l[f|0]!=49))break r;k=!l[f+1|0]}X[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,k);return;case 2:X[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f);return;default:break e}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];return}X[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function Nn(A){var e=0,r=0,f=0,k=0,n=0;if(r=i[A+8>>2],!!r){if(e=i[A+4>>2],(e|0)==6){e=i[r+24>>2];i:{if((e|0)<i[r+28>>2]){f=i[r+20>>2];break i}if(n=e+1|0,f=p2(n),!f)return;k=i[r+20>>2],k&&(e&&z(f,k,e),Z(k),e=i[r+24>>2]),i[r+28>>2]=n,i[r+20>>2]=f}u[e+f|0]=0,i[r+24>>2]=i[r+24>>2]+1,e=i[A+4>>2]}if((e|0)==7){e=i[r+24>>2],k=e+2|0;i:{if((k|0)<=i[r+28>>2]){f=i[r+20>>2];break i}if(f=p2(k),!f)return;n=i[r+20>>2],n&&(e&&z(f,n,e),Z(n),e=i[r+24>>2]),i[r+28>>2]=k,i[r+20>>2]=f}e=e+f|0,u[e|0]=0,u[e+1|0]=0,i[r+24>>2]=i[r+24>>2]+2,e=i[A+4>>2]}(e|0)>=5&&(k=i[A+32>>2],f=k+i[A+28>>2]|0,n=i[A+20>>2],e=i[A+16>>2],(f|0)==(((e|0)!=(n|0)?(n-e<<8)-1|0:0)|0)&&(or(A+12|0),k=i[A+32>>2],f=k+i[A+28>>2]|0,e=i[A+16>>2]),i[i[e+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2]=r,i[A+32>>2]=k+1,e=i[r+24>>2],i[A+8>>2]=0,i[A+36>>2]=e+i[A+36>>2]),i[A+4>>2]=0}}function vX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n,v9(A,e);i:{if(i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),t=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+104>>2],o=i[e+108>>2],(f|0)!=(o|0))for(k=l[e+97|0],s=k?4:2,h=k?2:1;;){if(C0(r,((i[f+48>>2]-i[f+44>>2]>>2)+1<<h)+10|0),C0(r,i[f+16>>2]),Z1(r,s,i[f+40>>2],0),u2(r,i[f+48>>2]-i[f+44>>2]>>>2&65535),k=i[f+44>>2],w=i[f+48>>2],(k|0)!=(w|0))for(;Z1(r,s,i[k>>2],0),k=k+4|0,(w|0)!=(k|0););if(f=f+56|0,(o|0)==(f|0))break}if(i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function Mn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],o=i[A+4>>2]-n|0,f=(o>>4)+1|0,f>>>0<268435456){if(t=i[A+8>>2],i[k+28>>2]=A+8,n=t-n|0,t=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<t>>>0?t:f,f){if(f>>>0>=268435456)break i;r=E(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+o|0,i[k+16>>2]=r,Q[r>>1]=F[e>>1],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[k+20>>2]=r+16,rt(A,k+12|0),o=i[A+4>>2],r=i[k+20>>2],n=i[k+16>>2],(r|0)!=(n|0))for(;;){if(A=r-16|0,i[k+20>>2]=A,t=r-12|0,f=i[t>>2],f){if(s=r-8|0,A=i[s>>2],e=f,(A|0)!=(f|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(f|0)!=(A|0););e=i[t>>2]}i[s>>2]=f,Z(e),A=i[k+20>>2]}if(r=A,(n|0)==(r|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}x0(),H()}function mX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,t=v-80|0,v=t;i:{if(!((k|0)==1885954932|(k|0)==1986618469)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=15302;break i}i[t+52>>2]=0,i[t+56>>2]=0,i[t+60>>2]=0,i[t+64>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,u[t+40|0]=0,i[t+36>>2]=9e4,fn(t+12|0,i[e>>2],n||t+36|0,k,r,f);e:{r:switch(l[t+32|0]){default:_2(),H();case 1:b0(A,t+12|0,i[e>>2]);break e;case 0:break r}o&&(r=E(16),k=i[t+12>>2],f=i[t+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[o>>2]=r),e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}if(A=l[t+32|0],(A|0)!=255&&(e=i[24209],i[t+72>>2]=i[24208],i[t+76>>2]=e,X[i[(t+72|0)+(A<<2)>>2]](t+71|0,t+12|0)),z2(i[t+48>>2]),u[t+67|0]>=0)break i;Z(i[t+56>>2])}v=t+80|0}function ZX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(n=v-32|0,v=n,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+108>>2]-i[e+104>>2]>>4),k=i[e+104>>2],o=i[e+108>>2],(k|0)!=(o|0))for(;;){f=i[k>>2];i:{if(!l[e+97|0]){u2(r,f&65535);break i}C0(r,f)}if(l2(r,i[k+8>>2]-i[k+4>>2]>>>2&255),f=i[k+4>>2],s=i[k+8>>2],(f|0)!=(s|0))for(;;){w=l[f|0];i:{if(u[e+100|0]&1){u2(r,w<<15&32768|F[f+2>>1]&32767);break i}l2(r,l[f+2|0]&127|w<<7&128)}if(f=f+4|0,(s|0)==(f|0))break}if(k=k+16|0,(o|0)==(k|0))break}i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function e4(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{k=i[A+4>>2],o=i[A>>2],s=k-o|0,f=i[A+12>>2]+8|0;e:{if(s>>>0>=f>>>0)break e;if(t=f-s|0,n=i[A+8>>2],t>>>0<=n-k>>>0){t&&o0(k,0,t),i[A+4>>2]=k+t;break e}if((f|0)<0)break i;if(k=n-o|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=E(n),t&&o0(k+s|0,0,t),s&&z(k,o,s),i[A+8>>2]=k+n,i[A+4>>2]=f+k,i[A>>2]=k,!o)break e;Z(o)}f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&16777215)<<8|e>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&65535)<<16|e>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&255)<<24|e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e;return}G0(),H()}function GX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;for(o=v-416|0,v=o,f=o+416|0,i[o+12>>2]=f,r=v-144|0,v=r,i[r+28>>2]=r+132,s=r+32|0,Eo(A+8|0,s,r+28|0,k,n,t),i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=s,n=o+16|0,t=i[o+12>>2]-n>>2,k=v-16|0,v=k,i[k+12>>2]=i[A+8>>2],A=s8(k+8|0,k+12|0),t=T9(n,r+12|0,t,r+16|0),A=i[A>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=k+16|0,(t|0)==-1&&(Q1(),H()),i[o+12>>2]=n+(t<<2),v=r+144|0,t=v-16|0,v=t,A=v-32|0,v=A,yl(A+24|0,n,i[o+12>>2]),o=i[A+28>>2],k=v-16|0,v=k,r=i[A+24>>2],i[k+8>>2]=r,i[k+12>>2]=e;;){if((r|0)!=(o|0)){Ho(k+12|0,i[r>>2]),r=r+4|0,i[k+8>>2]=r;continue}break}return i[A+16>>2]=i[k+8>>2],i[A+20>>2]=i[k+12>>2],v=k+16|0,i[A+12>>2]=n+(i[A+16>>2]-n|0),i[A+8>>2]=i[A+20>>2],i[t+8>>2]=i[A+12>>2],i[t+12>>2]=i[A+8>>2],v=A+32|0,v=t+16|0,v=f,i[t+12>>2]}function Un(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-16|0,v=n;i:{if(!r|(!A|!e))break i;EA(n+4|0,i[A>>2]),t=i[n+8>>2],A=i[n+4>>2],f=t-A>>3,f=(r|0)>(f|0)?f:r;e:{if((f|0)>0){if(r=0,f>>>0>=4)for(o=f&2147483644;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+116>>2],k=r|1,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],k=r|2,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],k=r|3,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],r=r+4|0,s=s+4|0,(o|0)!=(s|0););if(o=f&3,!o)break e;for(;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+116>>2],r=r+1|0,w=w+1|0,(o|0)!=(w|0););break e}if(!A)break i}if((A|0)==(t|0))e=A;else{for(;;){e=i[t-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[n+4>>2]}i[n+8>>2]=A,Z(e)}return v=n+16|0,f|0}function WX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{if(!r)break i;On(t+4|0,i[A>>2],e),A=i[t+8>>2],e=i[t+4>>2],k=A-e>>3,k=(f|0)>(k|0)?k:f;e:{if((k|0)>0){if(f=0,k>>>0>=4)for(o=k&2147483644;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+116>>2],n=f|1,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],n=f|2,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],n=f|3,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],f=f+4|0,s=s+4|0,(o|0)!=(s|0););if(o=k&3,!o)break e;for(;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+116>>2],f=f+1|0,w=w+1|0,(o|0)!=(w|0););break e}if(!e)break i}if((A|0)==(e|0))A=e;else{for(;;){r=i[A-4>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(A=A-8|0,(e|0)==(A|0))break}A=i[t+4>>2]}i[t+8>>2]=e,Z(A)}return v=t+16|0,k|0}function Dn(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{r:{n=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2];f:{if(!k)break f;if(t=i[24068],!t)for(;;){o=n;A:{if(n4(i[k+4>>2],r))break A;if(i[k+8>>2]!=1)break r;if(n=0,t=0,s=0,h=l[k+16|0],h&&(s=i[k+24>>2],t=i[k+20>>2]),w=i[k+32>>2],n=(w|0)>0?i[k+28>>2]:n,(f|0)<(t|0)|(f|0)>(s|0)&&h)break i;if(k=0,(w|0)<=0)break A;for(;;){if(i[(k<<2)+n>>2]==(f|0))break A;if(k=k+1|0,(w|0)==(k|0))break}break i}if(n=o+4|0,k=i[o+4>>2],!k)break f}for(o=i[24069],s=i[24070];;){if(!n4(i[k+4>>2],r)){if(i[k+8>>2]==1)break e;break r}if(k=i[n+4>>2],n=n+4|0,!k)break}}X[i[i[e>>2]+72>>2]](A,i[e+4>>2],r,f);return}o=i[24215],s=i[24216],t=5}i[A+4>>2]=o,i[A+8>>2]=s,i[A>>2]=t;return}e=i[24218],i[A>>2]=i[24217],i[A+4>>2]=e,i[A+8>>2]=i[24219]}function XX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-6|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;Q[r>>1]=(((((F[o+2>>1]<<2)-F[o>>1]|0)+G(F[o+8>>1]+F[o+6>>1]|0,40)|0)+(F[o+12>>1]<<2)|0)-F[o+14>>1]|0)+G(F[o+10>>1]+F[o+4>>1]|0,-11)>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;Q[r>>1]=F[o>>1],w=r,r=e<<1,w=w+r|0,Q[w>>1]=F[o+2>>1],w=r+w|0,Q[w>>1]=F[o+4>>1],w=r+w|0,Q[w>>1]=F[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;Q[r>>1]=F[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function Hn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],o=i[A+4>>2]-n|0,f=(o>>4)+1|0,f>>>0<268435456){if(t=i[A+8>>2],i[k+28>>2]=A+8,n=t-n|0,t=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<t>>>0?t:f,f){if(f>>>0>=268435456)break i;r=E(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+o|0,i[k+16>>2]=r,f=F[e>>1],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,Q[r>>1]=f,f=i[e+4>>2],e=i[e+8>>2],mA(r+4|0,f,e,(e-f|0)/12|0),i[k+20>>2]=r+16,rt(A,k+12|0),o=i[A+4>>2],e=i[k+20>>2],n=i[k+16>>2],(e|0)!=(n|0))for(;;){if(A=e-16|0,i[k+20>>2]=A,t=e-12|0,f=i[t>>2],f){if(s=e-8|0,A=i[s>>2],r=f,(A|0)!=(r|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(A|0)!=(f|0););r=i[t>>2]}i[s>>2]=f,Z(r),A=i[k+20>>2]}if(e=A,(n|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}x0(),H()}function xn(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;if(w=v-16|0,v=w,(e^-1)+1073741815>>>0>=r>>>0){if(l[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=w+4|0,e>>>0<536870899?(i[w+12>>2]=e<<1,i[w+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=w+12|0,r=i[(u0[s>>2]<u0[r>>2]?r:s)>>2],r>>>0>=2?(h=r+2&-2,r=h-1|0,r=(r|0)==2?h:r):r=1,r=r+1|0):r=1073741815,Ei(s,r),r=i[w+4>>2],k)i:{if(!k||(s=k<<2,!s))break i;z(r,_,s)}if(t){s=r+(k<<2)|0;i:{if(!t||(h=t<<2,!h))break i;z(s,o,h)}}if(s=k+n|0,o=f-s|0,(f|0)!=(s|0)){f=k<<2,s=(f+r|0)+(t<<2)|0,f=(f+_|0)+(n<<2)|0;i:{if(!o||(n=o<<2,!n))break i;z(s,f,n)}}(e|0)!=1&&$8(_,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[w+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=o+(k+t|0)|0,i[e+4>>2]=A,i[w+12>>2]=0,i[r+(A<<2)>>2]=i[w+12>>2],v=w+16|0;return}Z4(),H()}function gX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;f=v-32|0,v=f,i[A+32>>2]=F[e>>1]|F[e+2>>1]<<16,e=0,F[A+32>>1]|F[A+34>>1]&&(r=E(120),e=r,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91452,e=e+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[e>>2]=89080,i[r+32>>2]=1668050025,k=i[A+32>>2],Q[r+114>>1]=k,Q[r+116>>1]=k>>>16),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,D4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=f+32|0}function QX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-4|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;Q[r>>1]=(((((F[o>>1]+G(F[o+2>>1],-5)|0)+G(F[o+4>>1],17)|0)+G(F[o+6>>1],58)|0)+G(F[o+8>>1],-10)|0)+(F[o+10>>1]<<2)|0)-F[o+12>>1]>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;Q[r>>1]=F[o>>1],w=r,r=e<<1,w=w+r|0,Q[w>>1]=F[o+2>>1],w=r+w|0,Q[w>>1]=F[o+4>>1],w=r+w|0,Q[w>>1]=F[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;Q[r>>1]=F[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function IX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-6|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;Q[r>>1]=F[o+12>>1]+((((((F[o+2>>1]<<2)-F[o>>1]|0)+G(F[o+4>>1],-10)|0)+G(F[o+6>>1],58)|0)+G(F[o+8>>1],17)|0)+G(F[o+10>>1],-5)|0)>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;Q[r>>1]=F[o>>1],w=r,r=e<<1,w=w+r|0,Q[w>>1]=F[o+2>>1],w=r+w|0,Q[w>>1]=F[o+4>>1],w=r+w|0,Q[w>>1]=F[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;Q[r>>1]=F[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function zn(){D_(85320,15886),U_(85344,9837,1,0),N8(85356,7667,1,-128,127),N8(85380,7660,1,-128,127),N8(85368,7658,1,0,255),N8(85392,3701,2,-32768,32767),N8(85404,3692,2,0,65535),N8(85416,3716,4,-2147483648,2147483647),N8(85428,3707,4,0,-1),N8(85440,10960,4,-2147483648,2147483647),N8(85452,10951,4,0,-1),Qs(85464,4383,-2147483648,2147483647),Qs(85476,4382,0,-1),V7(85488,4239,4),V7(85500,13621,8),M_(96288,11056),lf(64044,4,11030),lf(64116,2,11068),lf(64192,4,11083),N_(96364),i4(64268,0,20660),i4(64308,0,20729),i4(96480,1,20690),i4(64348,2,20225),i4(64388,3,20256),i4(64428,4,20296),i4(64468,5,20325),i4(64508,4,20766),i4(64548,5,20796),i4(64308,0,20427),i4(96480,1,20394),i4(64348,2,20493),i4(64388,3,20459),i4(64428,4,20627),i4(64468,5,20593),i4(64588,8,20560),i4(64628,9,20526),i4(64668,6,20363),i4(64708,7,20835)}function CX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=v-32|0,v=n;i:{if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}k=i[e>>2],t=i[k+160>>2],k=i[k+164>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);e:{if(i[t+116>>2]!=(r|0)){if(i[f>>2]=0,u[n|0]=0,u[n+11|0]=0,r=K(n+12|0,5,2e3,n),u[n+11|0]<0&&Z(i[n>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}r=E(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+4>>2]=k,i[r>>2]=t,r=i[e+8>>2],f=i[f>>2],t=i[e+12>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=t;r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;X[i[i[r>>2]+8>>2]](r),p(r)}r=A,A=i[e>>2],b0(r,107712,A?A+84|0:0)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}v=n+32|0}function VX(){var A=0,e=0,r=0;return A=l[7288]|l[7289]<<8|(l[7290]<<16|l[7291]<<24),i[26988]=l[7284]|l[7285]<<8|(l[7286]<<16|l[7287]<<24),i[26989]=A,A=l[7302]|l[7303]<<8|(l[7304]<<16|l[7305]<<24),e=l[7298]|l[7299]<<8|(l[7300]<<16|l[7301]<<24),Q[53983]=e,Q[53984]=e>>>16,Q[53985]=A,Q[53986]=A>>>16,A=l[7296]|l[7297]<<8|(l[7298]<<16|l[7299]<<24),i[26990]=l[7292]|l[7293]<<8|(l[7294]<<16|l[7295]<<24),i[26991]=A,h2(21118)+10>>>0<=79&&(A=h2(107952)+107952|0,e=l[28104]|l[28105]<<8|(l[28106]<<16|l[28107]<<24),r=l[28100]|l[28101]<<8|(l[28102]<<16|l[28103]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,e=l[28107]|l[28108]<<8|(l[28109]<<16|l[28110]<<24),u[A+7|0]=e,u[A+8|0]=e>>>8,u[A+9|0]=e>>>16,u[A+10|0]=e>>>24,c4(h2(107952)+107952|0,21118)),107952}function FX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,i[A+28>>2]=r,i[A+24>>2]=e,r=0,e=0,i[A+24>>2]!=i[A+28>>2]&&(r=E(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91292,e=r+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[e>>2]=88920,i[r+32>>2]=1885434736,i[r+116>>2]=i[A+24>>2],i[r+120>>2]=i[A+28>>2]),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,D4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=f+32|0}function Tn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(!r){e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183];return}i:{if(f=i[e+16>>2],!f||(n=X0(f,94804,95964),!n))break i;f=i[e+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),e=i[n+12>>2],n=i[n+8>>2],s=e-n|0,t=s>>3;e:{if((t|0)<=0)break e;if(e=0,(s|0)!=8)for(h=t&2147483646,t=0;k=e<<3,o=k+r|0,w=n+k|0,i[o>>2]=i[w>>2],i[o+4>>2]=i[w+4>>2],k=k|8,o=k+r|0,k=n+k|0,i[o>>2]=i[k>>2],i[o+4>>2]=i[k+4>>2],e=e+2|0,t=t+2|0,(h|0)!=(t|0););if(!(s&8))break e;e=e<<3,r=e+r|0,e=e+n|0,i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2]}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;X[i[i[f>>2]+8>>2]](f),p(f)}return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}function EX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;t=v-32|0,v=t,o=X[i[i[e>>2]+52>>2]](e,r,0)|0,k=+(1<<i[e+152>>2]>>>0),n=t0[e+104>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,C0(r,f),n=t0[e+112>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,C0(r,f),n=t0[e+120>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,C0(r,f),u[e+100|0]&1&&(k=t0[e+136>>3]*k,w2(k)<2147483647?f=~~k:f=-2147483648,C0(r,f),k=t0[e+144>>3]*+(1<<i[e+156>>2]>>>0),w2(k)<2147483647?f=~~k:f=-2147483648,C0(r,f)),i[r+12>>2]=o,X[i[i[e>>2]+56>>2]](t+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[t+31|0]<0&&Z(i[t+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=t+32|0}function pX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;t=v-16|0,v=t,n=E(24),i[n+20>>2]=f,i[n+16>>2]=r,i[n+12>>2]=95764,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96028,r=i[e+8>>2],i[t+12>>2]=n,f=n+12|0,i[t+8>>2]=f,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,t+8|0),r=i[t+12>>2];i:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=E(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=f,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;X[i[i[n>>2]+8>>2]](n),p(n)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[n+4>>2],i[n+4>>2]=A-1,A||(X[i[i[n>>2]+8>>2]](n),p(n)),v=t+16|0}function yX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-32|0,v=k,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=l[e+97|0];i:{if(f>>>0<=1&&(u2(r,F[e+104>>1]),u2(r,F[e+108>>1]),C4(r,e+116|0,1),C4(r,e+128|0,1),C4(r,e+140|0,1),f=l[e+97|0],f>>>0<2))break i;e:{r:switch(f-2|0){case 0:u2(r,F[e+104>>1]);break e;case 1:break r;default:break e}C0(r,i[e+104>>2])}if(u2(r,F[e+108>>1]),C0(r,i[e+112>>2]),C4(r,e+116|0,1),f=i[e+112>>2],(f|0)==1970432288)f=152;else{if((f|0)!=1835625829)break i;C4(r,e+128|0,1),f=140}C4(r,f+e|0,1)}i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Sn(A){var e=0,r=0,f=0,k=0,n=0;if(e=i[A+428>>2],r=i[A+424>>2],(e|0)!=(r|0))for(;;){if(k=i[(f<<2)+r>>2],k){if(F4(i[k+140>>2]+548|0,i[k>>2]),e=i[k+132>>2],e){if(n=e-4|0,r=i[n>>2],r)for(r=e+G(r,18608)|0;P8(r-36|0),r=r-18608|0,(e|0)!=(r|0););Z(n)}Z(k),r=i[A+424>>2],e=i[A+428>>2]}if(f=f+1|0,!(f>>>0<e-r>>2>>>0))break}if(e=i[A+456>>2],f=i[A+460>>2],(e|0)!=(f|0))for(r=0;k=i[(r<<2)+e>>2],k&&(X[i[i[k>>2]+4>>2]](k),f=i[A+460>>2],e=i[A+456>>2]),r=r+1|0,r>>>0<f-e>>2>>>0;);if(f=i[A+468>>2],f){if(e=f,r=i[A+472>>2],(e|0)!=(r|0)){for(;r=P8(r-8|0),(f|0)!=(r|0););e=i[A+468>>2]}i[A+472>>2]=f,Z(e),e=i[A+456>>2]}return e&&(i[A+460>>2]=e,Z(e)),e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),e=i[A+424>>2],e&&(i[A+428>>2]=e,Z(e)),oA(A+8|0),A}function YX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),C0(r,i[e+120>>2]),C0(r,0),e4(r,i[e+128>>2],i[e+132>>2]);break i}C0(r,k),C0(r,i[e+112>>2]),C0(r,i[e+120>>2]),C0(r,0),C0(r,i[e+128>>2])}e4(r,0,0),u2(r,F[e+136>>1]),u2(r,F[e+138>>1]),u2(r,F[e+140>>1]),u2(r,0),C0(r,i[e+144>>2]),C0(r,i[e+148>>2]),C0(r,i[e+152>>2]),C0(r,i[e+156>>2]),C0(r,i[e+160>>2]),C0(r,i[e+164>>2]),C0(r,i[e+168>>2]),C0(r,i[e+172>>2]),C0(r,i[e+176>>2]),C0(r,i[e+180>>2]),C0(r,i[e+184>>2]),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function RX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,A=i[A>>2],n=i[A+48>>2],k=i[A+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,n,e,f+20|0);i:{if(i[f>>2]|!r||(e=r-1|0,A=i[f+20>>2],e>>>0>=i[f+24>>2]-A>>3>>>0))break i;if(A=A+(e<<3)|0,e=i[A>>2],A=i[A+4>>2],!A){t=i[e+16>>2];break i}if(r=i[A+4>>2],n=r+1|0,i[A+4>>2]=n,t=i[e+16>>2],i[A+4>>2]=r,n)break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+20>>2],e){if(A=e,r=i[f+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break i;X[i[i[A>>2]+8>>2]](A),p(A)}if(r=r-8|0,(e|0)==(r|0))break}A=i[f+20>>2]}i[f+24>>2]=e,Z(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}return v=f+32|0,t|0}function jn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;s=v-32|0,v=s;i:{e:{r:{if((e|0)!=(r|0)){if(h=i[31336],i[31336]=0,t=v-16|0,v=t,a2(),n=v-16|0,v=n,k=v-16|0,v=k,zA(k,e,s+28|0,2),o=i[k>>2],w=i[k+4>>2],e=n,n=i[k+12>>2],i[e+8>>2]=i[k+8>>2],i[e+12>>2]=n,i[e>>2]=o,i[e+4>>2]=w,v=k+16|0,n=i[e>>2],o=i[e+4>>2],k=t,t=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=t,i[k>>2]=n,i[k+4>>2]=o,v=e+16|0,t=i[k>>2],n=i[k+4>>2],o=i[k+12>>2],e=s,i[e+16>>2]=i[k+8>>2],i[e+20>>2]=o,i[e+8>>2]=t,i[e+12>>2]=n,v=k+16|0,k=i[e+16>>2],n=i[e+20>>2],t=i[e+8>>2],o=i[e+12>>2],w=i[31336],!w)break r;if(i[e+28>>2]!=(r|0))break e;if(_=t,B=o,m=k,W=n,(w|0)!=68)break i;break e}i[f>>2]=4;break i}if(i[31336]=h,i[s+28>>2]==(r|0))break i}i[f>>2]=4,t=_,o=B,k=m,n=W}i[A>>2]=t,i[A+4>>2]=o,i[A+8>>2]=k,i[A+12>>2]=n,v=s+32|0}function JX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),C0(r,i[e+120>>2]),e4(r,i[e+128>>2],i[e+132>>2]);break i}C0(r,k),C0(r,i[e+112>>2]),C0(r,i[e+120>>2]),C0(r,i[e+128>>2])}C0(r,i[e+136>>2]),u2(r,F[e+140>>1]),u2(r,0),e4(r,0,0),C0(r,i[e+144>>2]),C0(r,i[e+148>>2]),C0(r,i[e+152>>2]),C0(r,i[e+156>>2]),C0(r,i[e+160>>2]),C0(r,i[e+164>>2]),C0(r,i[e+168>>2]),C0(r,i[e+172>>2]),C0(r,i[e+176>>2]),C0(r,0),C0(r,0),C0(r,0),C0(r,0),C0(r,0),C0(r,0),C0(r,i[e+180>>2]),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function On(A,e,r){var f=0,k=0;i:{e:{if(!r){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+252>>2],e=i[e+248>>2],(r|0)==(e|0))break e;if(k=r-e|0,(k|0)<0)break i;for(f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k;i[f>>2]=i[e>>2],k=i[e+4>>2],i[f+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),f=f+8|0,e=e+8|0,(r|0)!=(e|0););i[A+4>>2]=f;return}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+248>>2],e=i[e+252>>2],(f|0)==(e|0))break e;if(k=r&4,!(r&2)){if(!k){for(;;)if(r2(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;l[i[f>>2]+156|0]||r2(A,f),f=f+8|0,(e|0)!=(f|0););break e}if(!k){for(;;)if(l[i[f>>2]+144|0]||r2(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;r=i[f>>2],l[r+144|0]|l[r+156|0]||r2(A,f),f=f+8|0,(e|0)!=(f|0););}return}G0(),H()}function Ln(A,e){var r=0,f=0;if(!(F[e+6>>1]!=2|F[e+8>>1]!=2|(!l[e+12|0]|F[e+10>>1]!=2))){i[A>>2]=0,i[A+4>>2]=0;return}r=E(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91212,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=95456,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,f=F[e+10>>1]|F[e+12>>1]<<16,A=F[e+6>>1]|F[e+8>>1]<<16,e=E(24),i[e+16>>2]=A,i[e+20>>2]=f,i[e+12>>2]=95416,i[e>>2]=95336,i[e+4>>2]=1,i[e+8>>2]=0,i[r+120>>2]=e,i[r+116>>2]=e+12,A=i[e+4>>2],i[e+4>>2]=A-1,A||(X[i[i[e>>2]+8>>2]](e),p(e))}function Pn(A,e){var r=0,f=0;if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0;return}if(r=E(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91212,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86404,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=95456,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,A=i[e+16>>2],f=i[e+20>>2],f){i[f+4>>2]=i[f+4>>2]+2,i[r+116>>2]=A,e=i[r+120>>2],i[r+120>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}A=i[f+4>>2],i[f+4>>2]=A-1,A||(X[i[i[f>>2]+8>>2]](f),p(f));return}i[r+120>>2]=f,i[r+116>>2]=A}function qn(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0;o=v-32|0,v=o,t=E(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94472,w=e,h=Zr(t+12|0),i[w+48>>2]=h,n=i[e+52>>2],i[e+52>>2]=t;i:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break i;X[i[i[n>>2]+8>>2]](n),p(n)}s=i[e+48>>2],i[s+156>>2]=e- -64,t=v-16|0,v=t,n=E(72),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=95072,r=dr(n+16|0,r,f,k),i[t+12>>2]=n,i[t+8>>2]=r,i[n+4>>2]=i[n+4>>2]+1,wf(o+8|0,s,t+8|0),r=i[t+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[n+4>>2],i[n+4>>2]=r-1,r||(X[i[i[n>>2]+8>>2]](n),p(n)),v=t+16|0;i:{if(i[o+8>>2]){e=i[o+12>>2],i[A>>2]=i[o+8>>2],i[A+4>>2]=e,e=i[o+20>>2],i[A+8>>2]=i[o+16>>2],i[A+12>>2]=e,i[A+16>>2]=i[o+24>>2];break i}if(sf(A,e),u[o+27|0]>=0)break i;Z(i[o+16>>2])}v=o+32|0}function NX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if((e|0)<12||(e=l[A+8|0],!e)||(k=l[A+9|0],!k)||(n=l[A+10|0],!n)||(A=l[A+11|0],!A))break i;if(u[r+15|0]=0,u[r+14|0]=A,u[r+13|0]=n,u[r+12|0]=k,u[r+11|0]=e,!N2(r+11|0,18071,5)){f=1;break i}if(!N2(r+11|0,2941,5)){f=2;break i}if(!N2(r+11|0,17926,5)){f=3;break i}if(!N2(r+11|0,1769,5)){f=4;break i}if(f=5,A=r+11|0,!N2(A,9370,5))break i;if(!N2(A,5134,5)){f=6;break i}if(!N2(r+11|0,9344,5)){f=7;break i}if(!N2(r+11|0,4391,5)){f=8;break i}if(!N2(r+11|0,21737,5)){f=9;break i}if(!N2(r+11|0,21732,5)){f=10;break i}if(!N2(r+11|0,11348,5)){f=11;break i}if(!N2(r+11|0,5129,5)){f=12;break i}if(!N2(r+11|0,18060,5)){f=13;break i}if(!N2(r+11|0,10557,5)){f=17;break i}f=N2(r+11|0,5145,5)?0:18}return v=r+16|0,f|0}function Kn(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;i:{e:{if(s=i[A+24>>2],r=i[A+20>>2],(s|0)!=(r|0)){if(k=s-r|0,e=k>>2,e>>>0<2)break i;if(f=1,t=e-1|0,_=t&1,e=i[i[r>>2]+96>>2],(k|0)==8){t=0;break e}for(B=t&-2,t=0,k=0;n=i[i[r+(f<<2)>>2]+96>>2],o=(n|0)<(e|0),w=f+1|0,h=i[i[r+(w<<2)>>2]+96>>2],e=o?n:e,n=(h|0)<(e|0),e=n?h:e,t=n?w:o?f:t,f=f+2|0,k=k+2|0,(B|0)!=(k|0););break e}M0(26880,18336,147,7227),H()}if(!_)break i;t=i[i[r+(f<<2)>>2]+96>>2]<(e|0)?f:t}k=r,o=i[A+52>>2],e=o+i[A+48>>2]|0,n=i[A+40>>2],f=i[A+36>>2],(e|0)==(((f|0)!=(n|0)?(n-f<<8)-1|0:0)|0)&&(or(A+32|0),o=i[A+52>>2],e=o+i[A+48>>2]|0,s=i[A+24>>2],f=i[A+36>>2],k=i[A+20>>2]),n=r,r=t<<2,i[i[(e>>>8&16777212)+f>>2]+((e&1023)<<2)>>2]=i[n+r>>2],i[A+52>>2]=o+1,k=r+k|0,r=s-4|0,i[k>>2]=i[r>>2],i[A+24>>2]=r}function MX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-3|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;Q[s>>1]=(((((l[r+1|0]<<2)-l[r|0]|0)+G(l[r+4|0]+l[r+3|0]|0,40)|0)+(l[r+6|0]<<2)|0)-l[r+7|0]|0)+G(l[r+5|0]+l[r+2|0]|0,-11),r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;Q[s>>1]=F[r>>1],o=s,s=e<<1,o=o+s|0,Q[o>>1]=F[r+2>>1],o=s+o|0,Q[o>>1]=F[r+4>>1],o=s+o|0,Q[o>>1]=F[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;Q[s>>1]=F[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function UX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-3|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;Q[s>>1]=l[r+6|0]+((((((l[r+1|0]<<2)-l[r|0]|0)+G(l[r+2|0],-10)|0)+G(l[r+3|0],58)|0)+G(l[r+4|0],17)|0)+G(l[r+5|0],-5)|0),r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;Q[s>>1]=F[r>>1],o=s,s=e<<1,o=o+s|0,Q[o>>1]=F[r+2>>1],o=s+o|0,Q[o>>1]=F[r+4>>1],o=s+o|0,Q[o>>1]=F[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;Q[s>>1]=F[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function DX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-2|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;Q[s>>1]=(((((l[r|0]+G(l[r+1|0],-5)|0)+G(l[r+2|0],17)|0)+G(l[r+3|0],58)|0)+G(l[r+4|0],-10)|0)+(l[r+5|0]<<2)|0)-l[r+6|0],r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;Q[s>>1]=F[r>>1],o=s,s=e<<1,o=o+s|0,Q[o>>1]=F[r+2>>1],o=s+o|0,Q[o>>1]=F[r+4>>1],o=s+o|0,Q[o>>1]=F[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;Q[s>>1]=F[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function an(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;o=i[e+12>>2],i[e+12>>2]=i[A+116>>2],l2(e,l[A+122|0]|l[A+121|0]<<4&240),l2(e,l[A+124|0]|l[A+123|0]<<4&240),r=i[A+108>>2]-i[A+104>>2]|0;i:{if(l[A+97|0]<=1){u2(e,r>>>5&65535);break i}C0(e,r>>5)}if(r=i[A+104>>2],k=i[A+108>>2],(r|0)!=(k|0))for(;;){f=i[r>>2];i:{if(l[A+97|0]<=1){u2(e,f&65535);break i}C0(e,f)}if(l[A+97|0]&&u2(e,l[r+4|0]),u2(e,F[r+6>>1]),f=l[A+123|0],f&&Z1(e,f,i[r+8>>2],i[r+12>>2]),u2(e,(i[r+20>>2]-i[r+16>>2]|0)/40&65535),f=i[r+16>>2],n=i[r+20>>2],(f|0)!=(n|0))for(;;){i:{if(!l[A+97|0]||(t=l[A+124|0],!t))break i;Z1(e,t,i[f>>2],i[f+4>>2])}if(Z1(e,l[A+121|0],i[f+8>>2],i[f+12>>2]),Z1(e,l[A+122|0],i[f+16>>2],i[f+20>>2]),f=f+40|0,(n|0)==(f|0))break}if(r=r+32|0,(k|0)==(r|0))break}i[e+12>>2]=o}function HX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,f=i[A+28>>2],i[n+16>>2]=f,t=i[A+20>>2],i[n+28>>2]=r,i[n+24>>2]=e,e=t-f|0,i[n+20>>2]=e,t=e+r|0,s=2;i:{e:{e=n+16|0,f=of(i[A+60>>2],e|0,2,n+12|0)|0,f?(i[31336]=f,f=-1):f=0;r:{f:{if(f){f=e;break f}for(;;){if(k=i[n+12>>2],(k|0)==(t|0))break r;if((k|0)<0){f=e;break e}if(o=i[e+4>>2],w=o>>>0<k>>>0,f=(w?8:0)+e|0,o=k-(w?o:0)|0,i[f>>2]=o+i[f>>2],e=(w?12:4)+e|0,i[e>>2]=i[e>>2]-o,t=t-k|0,e=f,s=s-w|0,k=of(i[A+60>>2],e|0,s|0,n+12|0)|0,k?(i[31336]=k,k=-1):k=0,!!k)break}}if((t|0)!=-1)break e}e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],A=r;break i}if(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A>>2]=i[A>>2]|32,A=0,(s|0)==2)break i;A=r-i[f+4>>2]|0}return v=n+32|0,A|0}function S8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{e:{f=i[A+4>>2],k=i[A+8>>2];r:{if(f>>>0<k>>>0){n=i[e+8>>2],t=i[e+12>>2],s=i[r>>2],o=i[e>>2],k=i[e+4>>2],r=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=r,i[f+8>>2]=n,i[f+12>>2]=t,i[f>>2]=o,i[f+4>>2]=k,i[f+24>>2]=s,e=f+28|0;break r}if(n=i[A>>2],t=f-n|0,o=((t|0)/28|0)+1|0,o>>>0>=153391690)break e;if(k=(k-n|0)/28|0,f=k<<1,s=k>>>0>=76695844?153391689:f>>>0>o>>>0?f:o,s){if(s>>>0>=153391690)break i;f=E(G(s,28))}else f=0;if(o=i[r>>2],r=f,k=f+t|0,f=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=f,f=i[e+20>>2],i[k+16>>2]=i[e+16>>2],i[k+20>>2]=f,f=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=f,i[k+24>>2]=o,f=k+G((t|0)/-28|0,28)|0,t&&z(f,n,t),i[A+8>>2]=r+G(s,28),e=k+28|0,i[A+4>>2]=e,i[A>>2]=f,!n)break r;Z(n)}i[A+4>>2]=e;return}G0(),H()}x0(),H()}function xX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(!(i[r>>2]!=1|i[r+4>>2]!=3)&&(t=i[r+12>>2],(t|0)>8))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=0,l[r+8|0]||(e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=t,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f);i:{if(r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0<153391690){if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=E(G(n,28))}else f=0;k=f+r|0,i[k+24>>2]=11,u[k+22|0]=1,Q[k+20>>1]=2,i[k+16>>2]=131074,i[k+12>>2]=t,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=13,t=k+G((r|0)/-28|0,28)|0,r&&z(t,e,r),i[A+8>>2]=f+G(n,28),i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28;return}G0(),H()}x0(),H()}function j2(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;e=i[A+112>>2],f=i[A+116>>2],s=(e|f)!=0,o=e,k=i[A+4>>2],n=i[A+44>>2],e=k-n|0,t=e,r=e+i[A+120>>2]|0,e=i[A+124>>2]+(e>>31)|0;i:{if(e=r>>>0<t>>>0?e+1|0:e,!(((e|0)>=(f|0)&r>>>0>=o>>>0|(e|0)>(f|0))&s)){if(s=u3(A),(s|0)>=0)break i;k=i[A+4>>2],n=i[A+44>>2]}return i[A+112>>2]=-1,i[A+116>>2]=-1,i[A+104>>2]=k,t=r,r=n-k|0,f=t+r|0,e=(r>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=r>>>0>f>>>0?e+1|0:e,-1}f=r+1|0,e=f?e:e+1|0,o=i[A+4>>2],n=i[A+8>>2],r=i[A+116>>2],t=r,k=i[A+112>>2];i:{if(!(r|k)||(r=k-f|0,k=t-(e+(f>>>0>k>>>0)|0)|0,w=n-o|0,t=w>>31,(k|0)>=(t|0)&r>>>0>=w>>>0|(k|0)>(t|0)))break i;n=r+o|0}return i[A+104>>2]=n,r=i[A+44>>2],n=r-o|0,f=n+f|0,e=(n>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=f>>>0<n>>>0?e+1|0:e,r>>>0>=o>>>0&&(u[o-1|0]=s),s}function zX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-48|0,v=n;i:{e:{if(!(k&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break e}Zf(n+20|0,i[e>>2],r,f);r:{f:switch(l[n+40|0]){default:_2(),H();case 1:b0(A,n+20|0,i[e>>2]);break r;case 0:break f}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304;break r}if(i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,r=i[e+104>>2],f=i[e+100>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=E(e),t=!e,t||z(r,f,e),t||z(k,r,e),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,Z(r);break r}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(A=l[n+40|0],(A|0)==255)break e;e=i[24193],i[n+8>>2]=i[24192],i[n+12>>2]=e,X[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0;return}G0(),H()}function TX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(n=v-32|0,v=n,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+112>>2]-i[e+108>>2]>>2),f=i[e+108>>2],k=i[e+112>>2],(f|0)!=(k|0))for(;C0(r,i[f>>2]),f=f+4|0,(k|0)!=(f|0););if(u2(r,F[e+120>>1]),u2(r,F[e+122>>1]),i[e+112>>2]!=i[e+108>>2])for(f=0;k=i[e+124>>2]+G(f,6)|0,u2(r,F[k>>1]),u2(r,F[k+2>>1]),u2(r,F[k+4>>1]),f=f+1|0,f>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0;);i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function SX(A){A=A|0;var e=0,r=0,f=0,k=0;e=i[A+92>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+84>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+64>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+56>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+48>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[A+32>>2],e){if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}}function $n(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;B=e,m=F0(r),i[B+4>>2]=m;i:{if(w=W2(r),!w)break i;e:{for(;;){r:{o=F0(r),f=i[e+12>>2],k=i[e+16>>2];f:{if(f>>>0<k>>>0){i[f>>2]=o,f=f+4|0;break f}if(s=i[e+8>>2],f=f-s|0,h=f>>2,n=h+1|0,n>>>0>=1073741824)break r;if(k=k-s|0,t=k>>1,k=k>>>0>=2147483644?1073741823:n>>>0<t>>>0?t:n,k){if(k>>>0>=1073741824)break e;n=E(k<<2)}else n=0;if(t=n+f|0,i[t>>2]=o,o=t-(h<<2)|0,f&&z(o,s,f),i[e+16>>2]=n+(k<<2),f=t+4|0,i[e+12>>2]=f,i[e+8>>2]=o,!s)break f;Z(s)}if(i[e+12>>2]=f,_=_+1|0,(_&255)>>>0<w>>>0)continue;break i}break}G0(),H()}x0(),H()}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function Ai(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h,u[h+15|0]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(B=A&255,(B|0)==l[w+24|0])A=43;else{if(l[w+25|0]!=(B|0))break r;A=45}i[f>>2]=_+1,u[_|0]=A;break e}if(l[t+11|0]>>>7|0?t=i[t+4>>2]:t=l[t+11|0]&127,!(!t|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-o|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=vk(w,w+26|0,h+15|0)-w|0,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|l[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,u[e|0]=l[n+77792|0];break i}A=i[f>>2],i[f>>2]=A+1,u[A|0]=l[n+77792|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=h+16|0,A}function re(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;n=v-48|0,v=n;i:{e:{if(k=i[A+20>>2],!k){k=0;break e}for(t=A+20|0,o=t;s=u0[k+16>>2]<e>>>0,o=s?o:k,k=i[(s?4:0)+k>>2],!!k;);if(k=0,(t|0)==(o|0)|u0[o+16>>2]>e>>>0||(t=i[o+20>>2],X[i[i[t>>2]+52>>2]](n+28|0,t),t=i[n+28>>2],u[n+47|0]<0&&Z(i[n+36>>2]),t)||(t=i[o+20>>2],k=i[o+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),!t))break e;i[n+20>>2]=i[r>>2],A=i[r+4>>2],i[n+24>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=A,A=D4(t,n+8|0,f);break i}A=f3(i[A+48>>2],e,r,f)}i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;X[i[i[k>>2]+8>>2]](k),p(k)}e=i[r+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=n+48|0,A}function dn(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-16|0,v=k,t=i[31378],i[e+72>>2]<=0&&_k(e),i[31378]=i[e+136>>2];i:{e:{r:{if(A>>>0<=127){f:{if(i[e+80>>2]==(A|0)||(r=i[e+20>>2],(r|0)==i[e+16>>2]))break f;i[e+20>>2]=r+1,u[r|0]=A;break i}f=v-16|0,v=f,u[f+15|0]=A,r=i[e+16>>2];f:{if(!r){if(cA(e)){r=-1;break f}r=i[e+16>>2]}A:{if(n=i[e+20>>2],(r|0)==(n|0)||(r=A&255,(r|0)==i[e+80>>2]))break A;i[e+20>>2]=n+1,u[n|0]=A;break f}if((X[i[e+36>>2]](e,f+15|0,1)|0)!=1){r=-1;break f}r=l[f+15|0]}v=f+16|0,A=r;break r}if(r=i[e+20>>2],u0[e+16>>2]>r+4>>>0){if(r=E3(r,A),(r|0)<0)break e;i[e+20>>2]=r+i[e+20>>2];break r}if(f=k+12|0,r=E3(f,A),(r|0)<0||Pr(f,r,e)>>>0<r>>>0)break e}if((A|0)!=-1)break i}i[e>>2]=i[e>>2]|32,A=-1}return i[31378]=t,v=k+16|0,A}function eA(){var A=0,e=0,r=0,f=0,k=0;A=i[26715],A&&X[A|0](),e=i[26939];i:{e:{if(!e){r=107756,A=107756;break e}for(;;){if(A=e,e=i[A+16>>2],e>>>0>106852){if(r=A,e=i[A>>2],e)continue;break e}if(e>>>0>=106852)break i;if(e=i[A+4>>2],!e)break}r=A+4|0}e=E(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=106852,i[r>>2]=e,A=i[i[26938]>>2],A&&(i[26938]=A),m1(i[26939],e),i[26940]=i[26940]+1}A=i[26741],A&&X[A|0](),A=E(4),i[A>>2]=106936,f=E(20),i[f+16>>2]=A,e=i[26942];i:{if(!e){A=107768,r=107768;break i}for(k=i[26737];;){if(A=e,i[i[i[A+16>>2]>>2]+12>>2]<(k|0)){if(r=A,e=i[A>>2],e)continue;break i}if(e=i[A+4>>2],!e)break}r=A+4|0}i[f+8>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,A=i[i[26941]>>2],A&&(i[26941]=A),m1(i[26942],f),i[26943]=i[26943]+1}function jX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,9216);break i}k=i[e+100>>2]>>>8|0,i[e+152>>2]=k&31,t=1,n=+(1<<k>>>0),o=e,s=+(F0(r)|0)/n,t0[o+104>>3]=s,o=e,s=+(F0(r)|0)/n,t0[o+112>>3]=s,o=e,s=+(F0(r)|0)/n,t0[o+120>>3]=s,k=i[e+100>>2];e:{if(k&1){k=k>>>16|0,i[e+156>>2]=k&31,o=e,s=+(F0(r)|0)/n,t0[o+136>>3]=s,n=+(F0(r)|0)/+(1<<k>>>0);break e}i[e+136>>2]=0,i[e+140>>2]=0,t=0,n=0}if(t0[e+144>>3]=n,u[e+128|0]=t,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function ki(A,e,r,f,k,n,t,o,s,w){var h=0,_=0;h=v-16|0,v=h,i[h+12>>2]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(i[w+96>>2]==(A|0))A=43;else{if(i[w+100>>2]!=(A|0))break r;A=45}i[f>>2]=_+1,u[_|0]=A;break e}if(l[t+11|0]>>>7|0?t=i[t+4>>2]:t=l[t+11|0]&127,!(!t|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-o|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=Bk(w,w+104|0,h+12|0)-w>>2,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|l[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,u[e|0]=l[n+77792|0];break i}A=i[f>>2],i[f>>2]=A+1,u[A|0]=l[n+77792|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=h+16|0,A}function Rr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;Je(),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(t=i[26941],(t|0)!=107768)for(;;){w=i[t+16>>2],f=i[w>>2];r:{if(i[f+4>>2]!=(e|0)&&e||r&&n4(r,i[f+8>>2]))break r;f:{if(k>>>0<n>>>0){i[k>>2]=w,k=k+4|0;break f}if(f=k-s|0,_=f>>2,o=_+1|0,o>>>0>=1073741824)break e;if(k=n-s|0,n=k>>1,n=k>>>0>=2147483644?1073741823:n>>>0>o>>>0?n:o,n){if(n>>>0>=1073741824)break i;k=E(n<<2)}else k=0;h=k+f|0,i[h>>2]=w,o=h-(_<<2)|0,f&&z(o,s,f),n=k+(n<<2)|0,i[A+8>>2]=n,k=h+4|0,i[A+4>>2]=k,i[A>>2]=o,s&&Z(s),s=o}i[A+4>>2]=k}f=i[t+4>>2];r:{if(f){for(;;)if(t=f,f=i[f>>2],!f)break r}for(;f=t,t=i[t+8>>2],(f|0)!=i[t>>2];);}if((t|0)==107768)break}return}G0(),H()}x0(),H()}function OX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;f=v-16|0,v=f,t=i[r+16>>2],f4(r,t),k=f+4|0,i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,t&&du(k,t),o=i[r>>2],n=i[r+4>>2];i:{if(n){if(i[n+4>>2]=i[n+4>>2]+1,X[i[i[o>>2]+16>>2]](o,u[k+11|0]<0?i[k>>2]:k,t)|0,k=i[n+4>>2],i[n+4>>2]=k-1,k)break i;X[i[i[n>>2]+8>>2]](n),p(n);break i}X[i[i[o>>2]+16>>2]](o,u[k+11|0]<0?i[k>>2]:k,t)|0}u[e+111|0]<0&&Z(i[e+100>>2]),k=i[f+8>>2],i[e+100>>2]=i[f+4>>2],i[e+104>>2]=k,i[e+108>>2]=i[f+12>>2];i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function LX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-48|0,v=t;i:{if(!(n|!k)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=19489;break i}o=i[e>>2],s=i[o+48>>2],o=i[o+52>>2];e:{if(!o){o9(t+12|0,s,r,f);break e}if(i[o+4>>2]=i[o+4>>2]+1,o9(t+12|0,s,r,f),r=i[o+4>>2],i[o+4>>2]=r-1,r)break e;X[i[i[o>>2]+8>>2]](o),p(o)}e:{r:{if(r=l[t+32|0],r){if(i[n>>2]=0,k&&(i[k>>2]=0),(r|0)==1)break r;_2(),H()}n&&(i[n>>2]=i[t+16>>2]-i[t+12>>2]);f:{if(!k||(r=i[t+12>>2],e=i[t+16>>2]-r|0,f=E(e),i[k>>2]=f,!e))break f;z(f,r,e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],k=0;break e}if(b0(A,t+12|0,i[e>>2]),k=l[t+32|0],(k|0)==255)break i}A=i[24195],i[t+40>>2]=i[24194],i[t+44>>2]=A,X[i[(t+40|0)+(k<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function rA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;o=e+31|0,n=i[A+12>>2]<<7,f=F[A+20>>1],r=i[A+16>>2];i:{for(;;){f=f+1|0,Q[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,Q[A+20>>1]=65528,k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break e;i[A+4>>2]=k+1,r=l[k|0]|r,i[A+16>>2]=r}if(r>>>0<n>>>0)break i;if(r=r-n|0,i[A+16>>2]=r,t=(1<<e)+t|0,k=(e|0)==(o|0),e=e+1|0,!!k)break}return 0}if((e|0)<=8){if(!e)return t;f=e+f|0,Q[A+20>>1]=f,r=r<<e,i[A+16>>2]=r,f=f<<16>>16;i:{if((f|0)<0||(k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=k+1,k=l[k|0],Q[A+20>>1]=f-8,r=k<<f|r}return f=(r>>>0)/(n>>>0)|0,e=1<<e,(f|0)>=(e|0)&&(f=e-1|0),i[A+16>>2]=r-G(f,n),f+t|0}for(r=e-8|0,e=eo(A);e=k4(A)|e<<1,r=r-1|0,!!r;);return e+t|0}function PX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;f=v-32|0,v=f,o0(A,0,72),i[A+4>>2]=F[e+450>>1],i[A+8>>2]=F[e+448>>1],i[A+20>>2]=i[e+452>>2],i[A+24>>2]=i[e+456>>2],i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0;i:{e:{r:{f:{if(n=i[e+460>>2],r=i[e+464>>2],(n|0)==(r|0))break f;if(r=r-n|0,(r|0)<0)break i;if(k=E(r),i[f+20>>2]=k,t=r+k|0,i[f+28>>2]=t,r&&z(k,n,r),i[f+24>>2]=t,r=i[k>>2],!r)break f;if(r4(f,i[e+100>>2],r,1),e=i[f+4>>2],r=i[f>>2],!r||(X[i[i[r>>2]+52>>2]](f,r),k=i[f>>2],u[f+19|0]<0&&Z(i[f+8>>2]),k))break r;i[A+12>>2]=i[r+120>>2],i[A+16>>2]=i[r+124>>2];break r}i[A+12>>2]=0,i[A+16>>2]=0;break e}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}A=i[f+20>>2],A&&Z(A),v=f+32|0;return}G0(),H()}function qX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;k=v-16|0,v=k;i:{if((e|0)!=-1){if(o=i[A+12>>2],s=i[A+8>>2],n=i[A+24>>2],(n|0)==i[A+28>>2]){if(r=-1,!(l[A+48|0]&16))break i;t=i[A+20>>2],w=i[A+44>>2],f=A+32|0,oi(f,0),X2(f,l[f+11|0]>>>7|0?(i[f+8>>2]&2147483647)-1|0:10),l[f+11|0]>>>7|0?r=i[f>>2]:r=f,l[f+11|0]>>>7|0?f=i[f+4>>2]:f=l[f+11|0]&127,i[A+28>>2]=f+r,i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(n-t|0),i[A+44>>2]=i[A+20>>2]+(w-t|0)}i[k+12>>2]=i[A+24>>2]+1,r=v-16|0,v=r,v=r+16|0,f=A+44|0,r=k+12|0,i[A+44>>2]=i[(u0[r>>2]<u0[f>>2]?f:r)>>2],l[A+48|0]&8&&(r=A+32|0,l[r+11|0]>>>7|0&&(r=i[r>>2]),i[A+16>>2]=i[A+44>>2],i[A+12>>2]=r+(o-s|0),i[A+8>>2]=r),r=sl(A,e<<24>>24);break i}r=(e|0)!=-1?e:0}return v=k+16|0,r|0}function KX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=i[r+12>>2],f=i[r+4>>2],k=i[r>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(!((k|0)!=1|(f|0)!=3|(e|0)!=8)){if(e=0,f=0,l[r+8|0]||(e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f),r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0>=153391690)break e;if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=E(G(n,28))}else f=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,Q[k+20>>1]=2,i[k+12>>2]=8,i[k+16>>2]=131074,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=13,t=k+G((r|0)/-28|0,28)|0,r&&z(t,e,r),i[A+8>>2]=G(n,28)+f,i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28}return}G0(),H()}x0(),H()}function aX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,i[t+24>>2]=k,i[t+28>>2]=f;i:{if(!(n&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}e:{if(o=i[e>>2],!o||(o=X0(o,100708,101348),!o))break e;e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(F[o+450>>1]>f>>>0&F[o+448>>1]>k>>>0)){i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=13957;break r}f:{if(!r||(kn(t+4|0,o,t+28|0,t+24|0),u[t+23|0]>=0))break f;Z(i[t+12>>2])}i[n>>2]=i[(i[o+460>>2]+(G(i[t+24>>2],F[o+450>>1])<<2)|0)+(i[t+28>>2]<<2)>>2],i[A+8>>2]=i[24177],r=i[24176],i[A>>2]=i[24175],i[A+4>>2]=r}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=14940}v=t+32|0}function $X(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=i[r+12>>2],f=i[r+4>>2],k=i[r>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(!(f|(k|0)!=2|(e|0)!=8)){if(e=0,f=0,l[r+8|0]||(e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f),r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0>=153391690)break e;if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=E(G(n,28))}else f=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,Q[k+20>>1]=2,i[k+12>>2]=8,i[k+16>>2]=131074,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=11,t=k+G((r|0)/-28|0,28)|0,r&&z(t,e,r),i[A+8>>2]=G(n,28)+f,i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28}return}G0(),H()}x0(),H()}function cn(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=95208,r=i[A+124>>2],k=A+128|0,(r|0)!=(k|0))for(;;){e=i[r+48>>2],e&&Z(e),f=i[r+4>>2];i:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break i}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(k|0)==(e|0))break}if(f=i[A+148>>2],f){if(r=f,e=i[A+152>>2],(r|0)!=(e|0)){for(;u[e-1|0]<0&&Z(i[e-12>>2]),e=e-20|0,(f|0)!=(e|0););r=i[A+148>>2]}i[A+152>>2]=f,Z(r)}U1(A+136|0),Ck(A+124|0,i[A+128>>2]),u[A+103|0]<0&&Z(i[A+92>>2]),i[A>>2]=95160,z2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),r=i[A+20>>2];i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;X[i[i[r>>2]+8>>2]](r),p(r)}return e=i[A+88>>2],e&&p(e),A|0}function fA(A,e){var r=0,f=0,k=0,n=0;r=v-32|0,v=r,k=e+12|0;i:{e:{if(i[e+12>>2]!=i[e+16>>2])break e;if(l[e+8|0]==1){if(Qr(r+8|0,i[e>>2],i[e+24>>2],k,0,0,-1,-1),f=i[r+8>>2],f){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[r+27|0]>=0){n=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=n,i[e+8>>2]=i[r+24>>2];break r}T(e,i[r+16>>2],i[r+20>>2])}u[A+20|0]=1}if(u[r+27|0]<0&&Z(i[r+16>>2]),!f)break e;break i}if(yt(r+8|0,i[e>>2],k,i[e+32>>2],i[e+36>>2],i[e+40>>2]),f=i[r+8>>2],f){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[r+27|0]>=0){n=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=n,i[e+8>>2]=i[r+24>>2];break r}T(e,i[r+16>>2],i[r+20>>2])}u[A+20|0]=1}if(u[r+27|0]<0&&Z(i[r+16>>2]),f)break i}u[A+20|0]=0,i[A>>2]=k}v=r+32|0}function bn(A){var e=0;e=E(208),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,Q[e+132>>1]=1,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=91612,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=89264,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=1072693248,i[e+192>>2]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+176>>2]=0,i[e+180>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,u[e+204|0]=0,i[e+200>>2]=0,i[e+32>>2]=1668113784,i[A+4>>2]=e,i[A>>2]=e+16}function fe(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((e|0)!=(r|0))for(o=A+4|0;;){k=i[A+4>>2];i:{e:{r:{if(f=o,w=i[A>>2],(f|0)==(w|0))break r;n=f,t=k;f:{if(k){for(;f=t,t=i[f+4>>2],!!t;);if(s=i[e>>2],s>>>0<=u0[f+16>>2])break f;break r}for(;f=i[n+8>>2],t=i[f>>2]==(n|0),n=f,!!t;);if(n=o,t=n,u0[f+16>>2]<u0[e>>2])break r;break e}for(;;){if(t=k,f=i[k+16>>2],f>>>0>s>>>0){if(n=k,k=i[k>>2],k)continue;break e}if(f>>>0>=s>>>0)break i;if(k=i[t+4>>2],!k)break}n=t+4|0;break e}if(n=k?f+4|0:o,i[n>>2])break i;t=k?f:o}f=E(20),k=i[e>>2],i[f+8>>2]=t,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=k,i[n>>2]=f,n=i[w>>2],n&&(i[A>>2]=n),m1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}if(e=e+4|0,(r|0)==(e|0))break}}function dX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1||(k=i[r+12>>2],(k|0)<=8)||(e=F[r+20>>1],!(e>>>0>14|!(1<<e&18689))))break i;f=l[r+8|0],r=E(28),u[r+22|0]=1,Q[r+20>>1]=2,i[r+12>>2]=k,i[r+4>>2]=f?15:14,i[r>>2]=1,i[r+24>>2]=11,i[r+16>>2]=131074,u[r+8|0]=f,e=E(56),i[e+52>>2]=11,u[e+50|0]=1,Q[e+48>>1]=2,i[e+44>>2]=131074,i[e+40>>2]=k,u[e+36|0]=f,i[e+32>>2]=f?13:12,i[e+28>>2]=1,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,f=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=f,f=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=f,i[e+24>>2]=i[r+24>>2],f=e+56|0,i[A+8>>2]=f,i[A>>2]=e,Z(r),i[A+4>>2]=f;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function cX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!l[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(!(i[r>>2]!=1|(i[r+4>>2]&-4)!=12)&&(k=i[r+12>>2],(k|0)>8))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(t=F[f+20>>1],!(t>>>0>14|!(1<<t&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!l[f+22|0]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(n|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,r=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function bX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;t=v-48|0,v=t;i:{e:{if(o=i[e>>2],s=i[o+108>>2],(s|0)>0&&(w=i[o+112>>2],(w|0)>0))break e;i[A>>2]=5,i[A+4>>2]=129,i[A+8>>2]=11660;break i}Cf(t+12|0,o,r,(f^-1)+s|0,k,(n^-1)+w|0,0);e:{r:switch(l[t+32|0]){default:_2(),H();case 1:r=A,A=i[e>>2],b0(r,t+12|0,A?A+92|0:0);break e;case 0:break r}r=i[t+12>>2],f=i[t+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e>>2]=r,r=i[e+4>>2],i[e+4>>2]=f;r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;X[i[i[r>>2]+8>>2]](r),p(r)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(A=l[t+32|0],(A|0)==255)break i;e=i[24171],i[t+40>>2]=i[24170],i[t+44>>2]=e,X[i[(t+40|0)+(A<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function it(A,e,r,f){i:switch(e-9|0){case 0:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2];return;case 6:e=i[r>>2],i[r>>2]=e+4,e=Q[e>>1],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 7:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=F[e>>1],i[A+4>>2]=0;return;case 8:e=i[r>>2],i[r>>2]=e+4,e=u[e|0],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 9:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=l[e|0],i[A+4>>2]=0;return;case 16:e=i[r>>2]+7&-8,i[r>>2]=e+8,t0[A>>3]=t0[e>>3];return;case 17:X[f|0](A,r);default:return;case 1:case 4:case 14:e=i[r>>2],i[r>>2]=e+4,e=i[e>>2],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 2:case 5:case 11:case 15:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2],i[A+4>>2]=0;return;case 3:case 10:case 12:case 13:break i}e=i[r>>2]+7&-8,i[r>>2]=e+8,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r}function ig(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;w=v-32|0,v=w,x2(w+12|0,e,r),u[w+31|0]<0&&Z(i[w+20>>2]);i:{f=i[r+16>>2],k=i[e+108>>2],t=i[e+104>>2],o=k-t|0;e:{if(f>>>0>o>>>0){if(s=f-o|0,n=i[e+112>>2],s>>>0<=n-k>>>0){s&&o0(k,0,s),i[e+108>>2]=k+s;break e}if((f|0)<0)break i;if(k=n-t|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=E(n),s&&o0(k+o|0,0,s),o&&z(k,t,o),i[e+112>>2]=k+n,i[e+108>>2]=f+k,i[e+104>>2]=k,!t)break e;Z(t);break e}if(f>>>0>=o>>>0)break e;i[e+108>>2]=f+t}l6(r,i[e+104>>2],f),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;e:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=w+32|0;return}G0(),H()}function a2(){var A=0,e=0,r=0,f=0,k=0,n=0;if(l[129620])return i[32404];r=v-32|0,v=r;i:{e:{for(;;){if(e=r+8|0,f=At(A,1<<A&2147483647?20062:42716),i[e+(A<<2)>>2]=f,(f|0)==-1)break e;if(A=A+1|0,(A|0)==6)break}if(A=73176,!N2(e,73176,24)||(A=73200,!N2(e,73200,24)))break i;if(A=0,!l[129268]){for(;k=(A<<2)+129220|0,n=At(A,42716),i[k>>2]=n,A=A+1|0,(A|0)!=6;);u[129268]=1,i[32311]=i[32305]}if(A=129220,e=r+8|0,!N2(e,129220,24)||(A=129244,!N2(e,129244,24)))break i;if(A=p2(24),!A)break e;e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=i[r+28>>2],i[A+16>>2]=i[r+24>>2],i[A+20>>2]=e,e=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=e;break i}A=0}return v=r+32|0,u[129620]=1,i[32404]=A,A}function Jr(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;if(w=v-16|0,v=w,(e^-1)+2147483639>>>0>=r>>>0){l[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=w+4|0,e>>>0<1073741811?(i[w+12>>2]=e<<1,i[w+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=w+12|0,r=i[(u0[s>>2]<u0[r>>2]?r:s)>>2],r>>>0>=11?(h=r+8&-8,r=h-1|0,r=(r|0)==11?h:r):r=10,r=r+1|0):r=2147483639,Fi(s,r),r=i[w+4>>2],k&&(s=!k,s|s||z(r,_,k)),t&&(s=r+k|0,h=!t,h|h||z(s,o,t)),s=k+n|0,o=f-s|0,(f|0)!=(s|0)&&(f=(r+k|0)+t|0,n=(k+_|0)+n|0,s=!o,s|s||z(f,n,o)),(e|0)!=10&&$8(_,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[w+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=o+(k+t|0)|0,i[e+4>>2]=A,u[w+12|0]=0,u[A+r|0]=l[w+12|0],v=w+16|0;return}Z4(),H()}function et(A,e,r,f,k,n){var t=0;t=v-80|0,v=t;i:{if((n|0)>=16384){if(n1(t+32|0,e,r,f,k,0,0,0,2147352576),f=i[t+40>>2],k=i[t+44>>2],e=i[t+32>>2],r=i[t+36>>2],n>>>0<32767){n=n-16383|0;break i}n1(t+16|0,e,r,f,k,0,0,0,2147352576),n=(n>>>0>=49149?49149:n)-32766|0,f=i[t+24>>2],k=i[t+28>>2],e=i[t+16>>2],r=i[t+20>>2];break i}if((n|0)>-16383)break i;if(n1(t- -64|0,e,r,f,k,0,0,0,7471104),f=i[t+72>>2],k=i[t+76>>2],e=i[t+64>>2],r=i[t+68>>2],n>>>0>4294934644){n=n+16269|0;break i}n1(t+48|0,e,r,f,k,0,0,0,7471104),n=(n>>>0<=4294918376?-48920:n)+32538|0,f=i[t+56>>2],k=i[t+60>>2],e=i[t+48>>2],r=i[t+52>>2]}n1(t,e,r,f,k,0,0,0,n+16383<<16),e=i[t+12>>2],i[A+8>>2]=i[t+8>>2],i[A+12>>2]=e,e=i[t+4>>2],i[A>>2]=i[t>>2],i[A+4>>2]=e,v=t+80|0}function v2(A,e){var r=0,f=0,k=0,n=0;f=i[A+12>>2],r=l[((l[e|0]<<1&508)+(f>>>6|0)|0)+60876|0],f=f-r|0,i[A+12>>2]=f,k=i[A+16>>2],f=f<<7;i:{if(k>>>0<f>>>0){if(k=e,r=l[e|0],e=r&1,u[k|0]=e|l[(r>>>1|0)+61136|0]<<1,f>>>0>32767||(i[A+12>>2]=f>>>6,f=i[A+16>>2]<<1,i[A+16>>2]=f,r=F[A+20>>1]+1|0,Q[A+20>>1]=r,(r|0)==(r&65535))||(Q[A+20>>1]=65528,r=i[A+4>>2],r>>>0>=u0[A+8>>2]))break i;return i[A+4>>2]=r+1,i[A+16>>2]=f|l[r|0],e}if(n=l[(r>>>3|0)+61200|0],i[A+12>>2]=r<<n,i[A+16>>2]=k-f<<n,r=e,f=l[r|0],k=f&1,e=!k,u[r|0]=l[(f>>>1|0)+61232|0]<<1|(f>>>0<2?e:k),r=n+F[A+20>>1]|0,Q[A+20>>1]=r,r=r<<16>>16,(r|0)<0)break i;f=i[A+4>>2],f>>>0<u0[A+8>>2]&&(i[A+4>>2]=f+1,i[A+16>>2]=i[A+16>>2]|l[f|0]<<r),Q[A+20>>1]=r-8}return e}function rt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(k=i[A>>2],t=i[A+4>>2],s=i[e+4>>2]+(k-t|0)|0,(k|0)!=(t|0)){for(r=k,f=s;n=F[r>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,Q[f>>1]=n,i[f+4>>2]=i[r+4>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,f=f+16|0,r=r+16|0,(t|0)!=(r|0););for(;;){if(n=i[k+4>>2],n){if(f=n,r=i[k+8>>2],(f|0)!=(r|0)){for(;f=r-12|0,o=i[f>>2],o&&(i[r-8>>2]=o,Z(o)),r=f,(r|0)!=(n|0););f=i[k+4>>2]}i[k+8>>2]=n,Z(f)}if(k=k+16|0,(t|0)==(k|0))break}k=i[A>>2]}i[e+4>>2]=s,i[A+4>>2]=k,i[A>>2]=i[e+4>>2],i[e+4>>2]=k,r=i[A+4>>2],i[A+4>>2]=i[e+8>>2],i[e+8>>2]=r,r=i[A+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=r,i[e>>2]=i[e+4>>2]}function eg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n;i:{e:{if(o=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,t=i[o>>2],!t)break e;for(;;){if(n4(i[t+4>>2],r)){if(t=i[o+4>>2],o=o+4|0,t)continue;break e}break}r:{f:switch(i[t+8>>2]-1|0){case 0:if(X[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n>>2]=i[n+28>>2],a8(f,k,17923,n);break r;case 1:if(X[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n+16>>2]=i[n+28>>2],a8(f,k,17923,n+16|0);break r;case 2:break f;default:break r}if(X[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k),i[A>>2])break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];break i}e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216]}v=n+32|0}function rg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=16746;break i}yf(f+20|0,i[e>>2],i[i[e+8>>2]>>2]);e:{r:switch(l[f+40|0]){default:_2(),H();case 1:b0(A,f+20|0,i[e>>2]);break e;case 0:break r}e=i[f+20>>2];r:{if(u[e+115|0]>=0){i[f+16>>2]=i[e+112>>2],k=i[e+108>>2],i[f+8>>2]=i[e+104>>2],i[f+12>>2]=k;break r}T(f+8|0,i[e+104>>2],i[e+108>>2])}if(e=u[f+19|0],k=(e|0)<0,n=r,r=E((k?i[f+12>>2]:e)+1|0),i[n>>2]=r,n=r,r=i[f+8>>2],c4(n,k?r:f+8|0),i[A+8>>2]=i[24070],k=i[24069],i[A>>2]=i[24068],i[A+4>>2]=k,(e|0)>=0)break e;Z(r)}if(A=l[f+40|0],(A|0)==255)break i;e=i[24251],i[f+8>>2]=i[24250],i[f+12>>2]=e,X[i[(f+8|0)+(A<<2)>>2]](f+47|0,f+20|0)}v=f+48|0}function fg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=f,f=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=f,f=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=f,l[A+60|0]||(u[A+60|0]=1),e=0,l[A+60|0]==1&&(e=E(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91492,k=uu(e+16|0),f=i[A+56>>2],i[e+132>>2]=i[A+52>>2],i[e+136>>2]=f,f=i[A+48>>2],i[e+124>>2]=i[A+44>>2],i[e+128>>2]=f,f=i[A+40>>2],i[e+116>>2]=i[A+36>>2],i[e+120>>2]=f),i[r+20>>2]=e,i[r+16>>2]=k,f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,D4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=r+32|0}function ft(A){var e=0,r=0,f=0,k=0;if(e=i[A+136>>2],f=i[A+132>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+136>>2]=f,e=i[A+152>>2],i[A+148>>2]=0,i[A+152>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+164>>2],i[A+160>>2]=0,i[A+164>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(e=i[A+252>>2],f=i[A+248>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+252>>2]=f}function AA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+124>>2],s=e+128|0,(n|0)!=(s|0))for(;;){w=i[i[n+20>>2]+104>>2];r:{if(r>>>0<k>>>0){i[r>>2]=w,r=r+4|0;break r}if(e=r-t|0,h=e>>2,f=h+1|0,f>>>0>=1073741824)break e;if(r=k-t|0,k=r>>1,k=r>>>0>=2147483644?1073741823:f>>>0<k>>>0?k:f,k){if(k>>>0>=1073741824)break i;r=E(k<<2)}else r=0;o=r+e|0,i[o>>2]=w,f=o-(h<<2)|0,e&&z(f,t,e),k=r+(k<<2)|0,i[A+8>>2]=k,r=o+4|0,i[A+4>>2]=r,i[A>>2]=f,t&&Z(t),t=f}i[A+4>>2]=r,f=i[n+4>>2];r:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break r}for(;e=i[n+8>>2],f=i[e>>2]!=(n|0),n=e,!!f;);}if(n=e,(e|0)==(s|0))break}return}G0(),H()}x0(),H()}function Ag(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-48|0,v=k;i:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=16746;break i}yf(k+20|0,i[e>>2],r);e:{r:switch(l[k+40|0]){default:_2(),H();case 1:b0(A,k+20|0,i[e>>2]);break e;case 0:break r}e=i[k+20>>2];r:{if(u[e+115|0]>=0){i[k+16>>2]=i[e+112>>2],r=i[e+108>>2],i[k+8>>2]=i[e+104>>2],i[k+12>>2]=r;break r}T(k+8|0,i[e+104>>2],i[e+108>>2])}if(e=u[k+19|0],r=(e|0)<0,n=f,f=E((r?i[k+12>>2]:e)+1|0),i[n>>2]=f,n=f,f=i[k+8>>2],c4(n,r?f:k+8|0),i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r,(e|0)>=0)break e;Z(f)}if(A=l[k+40|0],(A|0)==255)break i;e=i[24197],i[k+8>>2]=i[24196],i[k+12>>2]=e,X[i[(k+8|0)+(A<<2)>>2]](k+47|0,k+20|0)}v=k+48|0}function kg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;o=v-16|0,v=o,It(o+4|0,i[A>>2]),k=i[o+4>>2],A=i[o+8>>2];i:{e:{if((k|0)!=(A|0)){if(r=A-k>>3,t=r>>>0<=1?1:r,h=t&3,A=0,r>>>0>=4)for(w=t&-4,t=0;r=A<<3,f=r+e|0,n=r+k|0,s=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=s,f=r|8,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,f=r|16,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,r=r|24,f=r+e|0,r=r+k|0,n=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=n,A=A+4|0,t=t+4|0,(w|0)!=(t|0););if(!h)break e;for(;r=A<<3,t=r+e|0,r=r+k|0,w=i[r+4>>2],i[t>>2]=i[r>>2],i[t+4>>2]=w,A=A+1|0,_=_+1|0,(_|0)!=(h|0););break e}if(!k)break i}i[o+8>>2]=k,Z(k)}v=o+16|0}function At(A,e){var r=0,f=0,k=0;i:{if(l[e|0]||(e=Tr(19559),l[e|0]&&e)||(e=Tr(G(A,12)+74208|0),l[e|0]&&e)||(e=Tr(19638),l[e|0]&&e))break i;e=21104}i:{for(;;){if(f=l[e+r|0],!(!f|(f|0)==47)){if(f=23,r=r+1|0,(r|0)!=23)continue;break i}break}f=r}k=21104;i:{e:{r=l[e|0];r:{f:{if(!(l[e+f|0]|(r|0)==46)&&(k=e,(r|0)!=67))break f;if(!l[k+1|0])break r}if(!n4(k,21104))break r;if(n4(k,19254))break e}if(!A&&(r=73140,l[k+1|0]==46))break i;return 0}if(r=i[32304],r)for(;;){if(!n4(k,r+8|0))break i;if(r=i[r+32>>2],!r)break}r=p2(36),r&&(e=i[18286],i[r>>2]=i[18285],i[r+4>>2]=e,e=r+8|0,A8(e,k,f),u[e+f|0]=0,i[r+32>>2]=i[32304],i[32304]=r),r=A|r?r:73140}return r}function kA(A,e,r,f,k,n,t,o){var s=0;s=v-48|0,v=s,i[s+28>>2]=i[e>>2],e=i[e+4>>2],i[s+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r6(s,s+28|0,r,3,f,k,n,t,o);i:{e:{r:{f:switch(f=l[s+20|0],f|0){case 0:break e;case 1:break r;default:break f}_2(),H()}if(r=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=r,r=A+8|0,u[s+19|0]>=0){k=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+16>>2];break i}T(r,i[s+8>>2],i[s+12>>2]);break i}k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[A+4>>2]=r,i[A>>2]=k}u[A+20|0]=f,A=l[s+20|0],(A|0)!=255&&(r=i[25485],i[s+40>>2]=i[25484],i[s+44>>2]=r,X[i[(s+40|0)+(A<<2)>>2]](s+39|0,s));i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=s+48|0}function kt(A,e,r){var f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[A+12>>2]=0,i[A+16>>2]=0,u[A+8|0]=0,i[A+20>>2]=0,i[A+24>>2]=0,k=i[e+4>>2],i[f+8>>2]=i[k+48>>2],k=i[k+52>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=i[e+28>>2]+(r-i[e+16>>2]<<4)|0,k=i[r+8>>2],e=i[r>>2],t=i[r+4>>2],r=i[f+12>>2],i[f>>2]=i[f+8>>2],i[f+4>>2]=r,n=i[f>>2],o=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,r=i[A+4>>2],i[A>>2]=n,i[A+4>>2]=o;i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;X[i[i[r>>2]+8>>2]](r),p(r)}i[A+40>>2]=k,i[A+32>>2]=e,i[A+36>>2]=t,u[A+8|0]=2,A=i[f+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f+16|0}function ng(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v-16|0,v=n,k=i[A>>2],A=i[k+244>>2],k=i[k+248>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!A)break i;IA(n+4|0,A,e),A=i[n+8>>2],e=i[n+4>>2],o=A-e>>2;e:{if((A|0)!=(e|0)){if(f=o>>>0<=1?1:o,s=f&3,A=0,o>>>0>=4)for(_=f&-4;f=A<<2,i[f+r>>2]=i[e+f>>2],t=f|4,i[t+r>>2]=i[e+t>>2],t=f|8,i[t+r>>2]=i[e+t>>2],f=f|12,i[f+r>>2]=i[e+f>>2],A=A+4|0,w=w+4|0,(w|0)!=(_|0););if(!s)break e;for(;f=A<<2,i[f+r>>2]=i[e+f>>2],A=A+1|0,h=h+1|0,(h|0)!=(s|0););break e}if(!e)break i}i[n+8>>2]=e,Z(e)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}return v=n+16|0,o|0}function C4(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{k=i[A+4>>2],o=i[A>>2],s=k-o|0,f=u[e+11|0],f=(i[A+12>>2]+r|0)+((f|0)<0?i[e+4>>2]:f)|0;e:{if(s>>>0>=f>>>0)break e;if(n=f-s|0,t=i[A+8>>2],n>>>0<=t-k>>>0){n&&o0(k,0,n),i[A+4>>2]=k+n;break e}if((f|0)<0)break i;if(k=t-o|0,t=k<<1,t=k>>>0>=1073741823?2147483647:f>>>0<t>>>0?t:f,k=E(t),n&&o0(k+s|0,0,n),s&&z(k,o,s),i[A+8>>2]=k+t,i[A+4>>2]=f+k,i[A>>2]=k,!o)break e;Z(o)}if(f=u[e+11|0],(f|0)<0?i[e+4>>2]:f)for(f=f>>>31|0;f=l[(f?i[e>>2]:e)+w|0],n=i[A+12>>2],i[A+12>>2]=n+1,u[n+i[A>>2]|0]=f,n=u[e+11|0],f=n>>>31|0,w=w+1|0,w>>>0<((n|0)<0?i[e+4>>2]:n)>>>0;);r&&(e=i[A+12>>2],i[A+12>>2]=e+1,u[e+i[A>>2]|0]=0);return}G0(),H()}function nt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+180>>2],s=e+184|0,(n|0)!=(s|0))for(;;){r:{if(f>>>0<k>>>0){i[f>>2]=i[n+16>>2],f=f+4|0;break r}if(e=f-t|0,w=e>>2,r=w+1|0,r>>>0>=1073741824)break e;if(f=k-t|0,k=f>>1,k=f>>>0>=2147483644?1073741823:r>>>0<k>>>0?k:r,k){if(k>>>0>=1073741824)break i;f=E(k<<2)}else f=0;o=f+e|0,i[o>>2]=i[n+16>>2],r=o-(w<<2)|0,e&&z(r,t,e),k=f+(k<<2)|0,i[A+8>>2]=k,f=o+4|0,i[A+4>>2]=f,i[A>>2]=r,t&&Z(t),t=r}i[A+4>>2]=f,r=i[n+4>>2];r:{if(r){for(;;)if(e=r,r=i[r>>2],!r)break r}for(;e=i[n+8>>2],r=i[e>>2]!=(n|0),n=e,!!r;);}if(n=e,(s|0)==(e|0))break}return}G0(),H()}x0(),H()}function tg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(!r)return 0;i:{e:{if(e=i[A>>2],l[e+156|0]==1){if(A=i[A+4>>2],A)break e;A=0;break i}if(A=i[e+164>>2],e=i[e+160>>2],A)break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}l[e+168|0]==1&&(f=E(56),k=i[e+228>>2],i[f+48>>2]=i[e+224>>2],i[f+52>>2]=k,k=i[e+220>>2],i[f+40>>2]=i[e+216>>2],i[f+44>>2]=k,k=i[e+212>>2],i[f+32>>2]=i[e+208>>2],i[f+36>>2]=k,k=i[e+204>>2],i[f+24>>2]=i[e+200>>2],i[f+28>>2]=k,k=i[e+196>>2],i[f+16>>2]=i[e+192>>2],i[f+20>>2]=k,k=i[e+188>>2],i[f+8>>2]=i[e+184>>2],i[f+12>>2]=k,k=i[e+180>>2],i[f>>2]=i[e+176>>2],i[f+4>>2]=k,k=1),i[r>>2]=f;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return k|0}function Ae(A,e,r){var f=0,k=0;i:{if(!r||(u[A|0]=e,f=A+r|0,u[f-1|0]=e,r>>>0<3)||(u[A+2|0]=e,u[A+1|0]=e,u[f-3|0]=e,u[f-2|0]=e,r>>>0<7)||(u[A+3|0]=e,u[f-4|0]=e,r>>>0<9)||(f=0-A&3,k=f+A|0,A=G(e&255,16843009),i[k>>2]=A,r=r-f&-4,e=r+k|0,i[e-4>>2]=A,r>>>0<9)||(i[k+8>>2]=A,i[k+4>>2]=A,i[e-8>>2]=A,i[e-12>>2]=A,r>>>0<25)||(i[k+24>>2]=A,i[k+20>>2]=A,i[k+16>>2]=A,i[k+12>>2]=A,i[e-16>>2]=A,i[e-20>>2]=A,i[e-24>>2]=A,i[e-28>>2]=A,e=k&4|24,r=r-e|0,r>>>0<32))break i;for(A=O0(A,0,1,1),f=l0,e=e+k|0;i[e+24>>2]=A,i[e+28>>2]=f,i[e+16>>2]=A,i[e+20>>2]=f,i[e+8>>2]=A,i[e+12>>2]=f,i[e>>2]=A,i[e+4>>2]=f,e=e+32|0,r=r-32|0,r>>>0>31;);}}function ug(A,e,r,f,k,n,t,o,s,w,h,_,B){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0,h=h|0,_=_|0,B=B|0;var m=0,W=0,g=0,I=0,C=0,V=0,y=0;if((_|0)>0){if(!((t|0)<=0|(n|0)<=0))for(g=(s+h|0)+1<<_,I=_+1|0,s=-1<<B^-1,V=n&2147483646,y=n&1;;){if(_=(G(e,W)<<1)+A|0,h=G(k,W)<<1,B=h+f|0,h=r+h|0,C=0,(n|0)!=1)for(;m=(G(Q[h>>1],o)+g|0)+G(Q[B>>1],w)>>I,Q[_>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,m=(G(Q[h+2>>1],o)+g|0)+G(Q[B+2>>1],w)>>I,Q[_+2>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,B=B+4|0,h=h+4|0,_=_+4|0,C=C+2|0,(V|0)!=(C|0););if(y&&(h=(G(Q[h>>1],o)+g|0)+G(Q[B>>1],w)>>I,Q[_>>1]=(h|0)>=0?(s|0)>(h|0)?h:s:0),W=W+1|0,(W|0)==(t|0))break}return}M0(21792,18227,213,10423),H()}function X8(A,e,r,f,k){var n=0,t=0,o=0,s=0;s=v-16|0,v=s,i[s+12>>2]=e,e=0,o=6;i:{e:{if(P2(A,s+12|0))break e;n=i[A>>2],t=i[n+12>>2];r:{if((t|0)==i[n+16>>2]){n=X[i[i[n>>2]+36>>2]](n)|0;break r}n=u[t|0]}if(t=n<<24>>24,(t|0)>=0?n=(i[i[f+8>>2]+(t<<2)>>2]&64)!=0:n=0,o=4,!n)break e;for(e=X[i[i[f>>2]+36>>2]](f,t,0)|0;;){r:{if(K1(A),e=e-48|0,P2(A,s+12|0)|(k|0)<2)break r;n=i[A>>2],t=i[n+12>>2];f:{if((t|0)==i[n+16>>2]){n=X[i[i[n>>2]+36>>2]](n)|0;break f}n=u[t|0]}if(n=n<<24>>24,(n|0)>=0?o=(i[i[f+8>>2]+(n<<2)>>2]&64)!=0:o=0,!o)break i;k=k-1|0,e=(X[i[i[f>>2]+36>>2]](f,n,0)|0)+G(e,10)|0;continue}break}if(!P2(A,s+12|0))break i;o=2}i[r>>2]=o|i[r>>2]}return v=s+16|0,e}function V1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],h=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(t=f,!k){s=f;break i}if(o=r+1|0,i[A+4>>2]=o,r=l[r|0],k=k-1|0,i[A+12>>2]=k,s=t-8|0,w=s&31,(s&63)>>>0>=32?(_=r<<w,r=0):(_=(1<<w)-1&r>>>32-w,r=r<<w),n=r|n,r=h|_,h=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=o,(t|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],t=r,n=e&31,(e&63)>>>0>=32?(o=r<<n,t=0):(o=(1<<n)-1&t>>>32-n|A<<n,t=t<<n),i[f+16>>2]=t,i[f+20>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A&255}function og(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!F[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function lg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!F[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function sg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!F[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+8>>2]=0,i[e+12>>2]=2,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function wg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!F[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+8>>2]=0,i[e+12>>2]=2,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function hg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=v-32|0,v=k,n=i[r+16>>2],n=n>>>0>=6?6:n,t=i[r+8>>2],t&&c1(t,n),t=i[r>>2],o=X[i[i[t>>2]+8>>2]](t)|0,s=l0,o=n+o|0,s=n>>>0>o>>>0?s+1|0:s,X[i[i[t>>2]+20>>2]](t,o,s)|0,i[r+16>>2]=i[r+16>>2]-n,w=e,h=o2(r),Q[w+98>>1]=h,d6(k+8|0,e,r,-1,f),e=A+8|0;i:{if(i[k+8>>2]){r=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=r,i[e+8>>2]=i[k+24>>2],A=i[k+20>>2],i[e>>2]=i[k+16>>2],i[e+4>>2]=A,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(r=i[26929],i[A>>2]=i[26928],i[A+4>>2]=r,u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function i2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],h=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(t=f,!k){s=f;break i}if(o=r+1|0,i[A+4>>2]=o,r=l[r|0],k=k-1|0,i[A+12>>2]=k,s=t-8|0,w=s&31,(s&63)>>>0>=32?(_=r<<w,r=0):(_=(1<<w)-1&r>>>32-w,r=r<<w),n=r|n,r=h|_,h=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=o,(t|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],t=r,n=e&31,(e&63)>>>0>=32?(o=r<<n,t=0):(o=(1<<n)-1&t>>>32-n|A<<n,t=t<<n),i[f+16>>2]=t,i[f+20>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function _g(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,w=X[i[i[e>>2]+52>>2]](e,r,0)|0;i:{if(l[e+97|0]){k=i[e+104>>2],t=i[e+108>>2];break i}if(o=2147483647,k=i[e+104>>2],t=i[e+108>>2],(k|0)==(t|0)){t=k;break i}for(f=k;s=i[f+4>>2],o=(o|0)>(s|0)?s:o,f=f+8|0,(t|0)!=(f|0););}if(C0(r,t-k>>3),f=i[e+104>>2],k=i[e+108>>2],(f|0)!=(k|0))for(;C0(r,i[f>>2]),C0(r,i[f+4>>2]-o|0),f=f+8|0,(k|0)!=(f|0););f1(n+12|0,e,r,w),u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=n+32|0}function B4(A,e){var r=0,f=0,k=0,n=0;r=v-32|0,v=r,i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;i:{if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0;break i}k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{r:{if(!f4(e,1))break r;for(;;){if(!(X[i[i[k>>2]+16>>2]](k,r+15|0,1)|0)){i8(e),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}if(n=u[r+15|0],!(!n|!i[e+16>>2])){if(oi(r+16|0,n),!f4(e,1))break r;continue}break}e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2],i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;break e}i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}u[r+27|0]<0&&Z(i[r+16>>2]),v=r+32|0}function Bg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,6878);break i}if(n=e,t=F0(r),i[n+104>>2]=t,n=e,t=F0(r),i[n+108>>2]=t,n=e,t=F0(r),i[n+112>>2]=t,n=e,t=F0(r),i[n+116>>2]=t,n=e,t=F0(r),i[n+120>>2]=t,B4(f+20|0,r),u[e+135|0]<0&&Z(i[e+124>>2]),k=i[f+24>>2],i[e+124>>2]=i[f+20>>2],i[e+128>>2]=k,i[e+132>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function tt(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=E(r),r&&z(k,e,r),s=r+k|0}e=i[A+120>>2],f=i[A+124>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+116>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=E(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&z(k,o,e),i[A+124>>2]=r+G(n,12),r=f+12|0,i[A+120>>2]=r,i[A+116>>2]=k,!o)break f;Z(o)}i[A+120>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}x0(),H()}function ut(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=E(r),r&&z(k,e,r),s=r+k|0}e=i[A+144>>2],f=i[A+148>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+140>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=E(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&z(k,o,e),i[A+148>>2]=r+G(n,12),r=f+12|0,i[A+144>>2]=r,i[A+140>>2]=k,!o)break f;Z(o)}i[A+144>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}x0(),H()}function ot(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=E(r),r&&z(k,e,r),s=r+k|0}e=i[A+132>>2],f=i[A+136>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+128>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=E(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&z(k,o,e),i[A+136>>2]=r+G(n,12),r=f+12|0,i[A+132>>2]=r,i[A+128>>2]=k,!o)break f;Z(o)}i[A+132>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}x0(),H()}function vg(A,e,r,f,k,n,t,o,s,w,h,_){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0,h=h|0,_=_|0;var B=0,m=0,W=0,g=0,I=0,C=0,V=0;if((_|0)>0){if(!((t|0)<=0|(n|0)<=0))for(W=(s+h|0)+1<<_,g=_+1|0,C=n&2147483646,V=n&1;;){if(_=G(e,m)+A|0,s=G(k,m)<<1,h=s+f|0,s=r+s|0,I=0,(n|0)!=1)for(;B=(G(Q[s>>1],o)+W|0)+G(Q[h>>1],w)>>g,B=(B|0)>=255?255:B,u[_|0]=(B|0)>0?B:0,B=(G(Q[s+2>>1],o)+W|0)+G(Q[h+2>>1],w)>>g,B=(B|0)>=255?255:B,u[_+1|0]=(B|0)>0?B:0,h=h+4|0,s=s+4|0,_=_+2|0,I=I+2|0,(C|0)!=(I|0););if(V&&(s=(G(Q[s>>1],o)+W|0)+G(Q[h>>1],w)>>g,s=(s|0)>=255?255:s,u[_|0]=(s|0)>0?s:0),m=m+1|0,(m|0)==(t|0))break}return}M0(21792,18227,80,10271),H()}function mg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(l[A+52|0])break i;e=i[A+48>>2],u[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=l[A+52|0],!(!(f&1)|l[A+53|0]!=1)){if(zs(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;u[r+19|0]=i[A+48>>2]<<24>>24;f:{A:switch(f=i[A+36>>2],k=r+20|0,(X[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+19|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,u[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Zi(u[f|0],i[A+32>>2])|0)==-1)break}break e}u[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function Zg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!l[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&(i[r+4>>2]&-2)==10)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(n-1>>>0>=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(r=F[f+20>>1],!(r>>>0>14|!(1<<r&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[e+12>>2]=n,i[e+8>>2]=0,r=l[f+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function lt(A){var e=0,r=0,f=0,k=0,n=0;n=i[31378],i[A+72>>2]<=0&&_k(A),i[31378]=i[A+136>>2],r=v-32|0,v=r;i:{e:{r:{if(e=i[A+4>>2],f=i[A+8>>2],(e|0)==(f|0)||(e=Zt(r+28|0,e,f-e|0),(e|0)==-1))break r;i[A+4>>2]=i[A+4>>2]+(e>>>0<=1?1:e);break e}for(i[r+16>>2]=0,i[r+20>>2]=0,e=0;;){f=e;r:{if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,u[r+15|0]=l[e|0];break r}if(e=u3(A),u[r+15|0]=e,(e|0)>=0)break r;if(e=-1,!(f&1))break i;i[A>>2]=i[A>>2]|32,i[31336]=25;break i}if(e=1,k=ne(r+28|0,r+15|0,1,r+16|0),(k|0)!=-2)break}if(e=-1,(k|0)!=-1)break e;if(!(f&1))break i;i[A>>2]=i[A>>2]|32,Zi(l[r+15|0],A);break i}e=i[r+28>>2]}return v=r+32|0,i[31378]=n,e}function Gg(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;s=v-48|0,v=s;i:{if(!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}h=i[i[e>>2]+116>>2],w=jA(),nA(w,n),_=i[e+8>>2],i[s>>2]=s+4,i[s+4>>2]=0,i[s+8>>2]=0,n=s+12|0,E9(n,_,h,f,k,w,1,t,o,s),Y1(s,i[s+4>>2]),z2(w),f=n;e:switch(l[s+32|0]){default:_2(),H();case 0:k=i[s+12>>2],f=i[s+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=E(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,f=107712;break;case 1:break e}if(r=A,A=i[e>>2],b0(r,f,A?A+84|0:0),A=l[s+32|0],(A|0)==255)break i;e=i[24247],i[s+40>>2]=i[24246],i[s+44>>2]=e,X[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function st(A,e){var r=0,f=0,k=0;f=v-16|0,v=f;i:{e:{if(r=i[e>>2],!r||(r=X0(r,94416,95396),!r))break e;i[f+8>>2]=r,r=i[e+4>>2],i[f+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),X[i[i[A>>2]+12>>2]](A,f+8|0);break i}i[f+8>>2]=0,i[f+12>>2]=0}r=i[e>>2];i:{if(!r||(r=X0(r,94416,95436),!r))break i;if(e=i[e+4>>2],e){if(i[e+4>>2]=i[e+4>>2]+1,k=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=k,X[i[i[A>>2]+8>>2]](A,f),A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}e=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=e,X[i[i[A>>2]+8>>2]](A,f)}A=i[f+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f+16|0}function Wg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(l[A+52|0])break i;e=i[A+48>>2],u[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=l[A+52|0],!(!(f&1)|l[A+53|0]!=1)){if(Wu(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;i[r+16>>2]=i[A+48>>2];f:{A:switch(f=i[A+36>>2],k=r+20|0,(X[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+16|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,u[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Zi(u[f|0],i[A+32>>2])|0)==-1)break}break e}u[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function wt(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(1073741815-e>>>0>=r>>>0){if(l[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=t+4|0,e>>>0<536870899?(i[t+12>>2]=e<<1,i[t+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=t+12|0,r=i[(u0[n>>2]<u0[r>>2]?r:n)>>2],r>>>0>=2?(o=r+2&-2,r=o-1|0,r=(r|0)==2?o:r):r=1,r=r+1|0):r=1073741815,Ei(n,r),r=i[t+4>>2],k)e:{if(!k||(n=k<<2,!n))break e;z(r,s,n)}if((f|0)!=(k|0)){n=k<<2,o=n+r|0,n=n+s|0,k=f-k|0;e:{if(!k||(k=k<<2,!k))break e;z(o,n,k)}}(e|0)!=1&&$8(s,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[t+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=t+16|0;break i}Z4(),H()}i[A+4>>2]=f}function ht(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(Je(),r=i[26938],(r|0)==107756)return 0;i:{if(!e){for(;;){k=i[r+16>>2],n=X[i[k+16>>2]](A)|0,e=(n|0)>(t|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(t=e?n:t,o=e?k:o,(r|0)==107756)break}break i}for(;;){e:{if(k=i[r+16>>2],n=X[i[k+16>>2]](A)|0,(n|0)<=0|i[k>>2]<3||n4(e,i[k+40>>2]))break e;return k}s=(t|0)<(n|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(t=s?n:t,o=s?k:o,(r|0)==107756)break}}return o}function Xg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}Zf(n+20|0,i[e>>2],r,f);e:{r:switch(l[n+40|0]){default:_2(),H();case 1:b0(A,n+20|0,i[e>>2]);break e;case 0:break r}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304;break e}$r(n+8|0,e),r=i[n+12>>2],e=i[n+8>>2];r:{if((r|0)==(e|0)||(r=r-e|0,!r))break r;z(k,e,r)}if(r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r,i[A+8>>2]=i[24070],!e)break e;i[n+12>>2]=e,Z(e)}if(A=l[n+40|0],(A|0)==255)break i;e=i[24193],i[n+8>>2]=i[24192],i[n+12>>2]=e,X[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0}function nA(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:{u:switch(r=l[e|0],f=l[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;case 7:break u;default:break i}i[A+60>>2]=i[e+60>>2],i[A+64>>2]=i[e+64>>2],i[A+56>>2]=i[e+56>>2],i[A+52>>2]=i[e+52>>2]}i[A+48>>2]=i[e+48>>2]}i[A+44>>2]=i[e+44>>2]}r=i[e+32>>2],i[A+28>>2]=i[e+28>>2],i[A+32>>2]=r,r=i[e+40>>2],i[A+36>>2]=i[e+36>>2],i[A+40>>2]=r}i[A+24>>2]=i[e+24>>2]}u[A+21|0]=l[e+21|0]}u[A+20|0]=l[e+20|0]}u[A+1|0]=l[e+1|0],i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2]}}function gg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;f=v-16|0,v=f,n=i[r>>2],k=i[r+4>>2];i:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,t=e,o=X[i[i[n>>2]+8>>2]](n)|0,i[t+112>>2]=o,i[e+116>>2]=l0,i[e+104>>2]=0,i[e+108>>2]=0,e=i[k+4>>2],i[k+4>>2]=e-1,e)break i;X[i[i[k>>2]+8>>2]](k),p(k);break i}t=e,o=X[i[i[n>>2]+8>>2]](n)|0,i[t+112>>2]=o,i[e+116>>2]=l0,i[e+104>>2]=0,i[e+108>>2]=0}i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function Qg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-32|0,v=t,i[t+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[t>>2]=-1,e=X[i[i[A>>2]+16>>2]](A,e,r,f,k,t)|0;e:switch(i[t>>2]){case 0:u[n|0]=0;break i;case 1:u[n|0]=1;break i;default:break e}u[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[t>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),e=c0(t,129808),e2(t),A=i[f+28>>2],i[t>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(t,129864),e2(t),X[i[i[A>>2]+24>>2]](t,A),X[i[i[A>>2]+28>>2]](t|12,A),f=t+24|0,o=n,s=(Xr(t+28|0,r,t,f,e,k,1)|0)==(t|0),u[o|0]=s,e=i[t+28>>2];f=s2(f-12|0),(t|0)!=(f|0););}return v=t+32|0,e|0}function Ig(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-32|0,v=t,i[t+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[t>>2]=-1,e=X[i[i[A>>2]+16>>2]](A,e,r,f,k,t)|0;e:switch(i[t>>2]){case 0:u[n|0]=0;break i;case 1:u[n|0]=1;break i;default:break e}u[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[t>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),e=c0(t,129800),e2(t),A=i[f+28>>2],i[t>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(t,129872),e2(t),X[i[i[A>>2]+24>>2]](t,A),X[i[i[A>>2]+28>>2]](t|12,A),f=t+24|0,o=n,s=(gr(t+28|0,r,t,f,e,k,1)|0)==(t|0),u[o|0]=s,e=i[t+28>>2];f=R1(f-12|0),(t|0)!=(f|0););}return v=t+32|0,e|0}function Cg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(l[e+124|0]==1){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]<0)break e;e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}if(t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+108>>2]-i[e+104>>2]>>2),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;C0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););if(f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}T(A,i[26930],i[26931])}v=f+32|0}function _t(A,e){var r=0,f=0,k=0,n=0,t=0;n=e+24|0,f=i[e>>2],k=f&63,u[n+k|0]=128,r=k+1|0,t=k^63;i:{if(t>>>0>7){k=r;break i}k=0,t&&o0(r+n|0,0,t),t=64,Ar(e,n,64),f=i[e>>2]}r=t-8|0,r&&o0(k+n|0,0,r),u[e+83|0]=f>>>21,u[e+82|0]=f>>>13,u[e+81|0]=f>>>5,r=f<<3,u[e+80|0]=r,i[e>>2]=r,i[e+84>>2]=i[e+4>>2],Ar(e,n,64),u[A|0]=i[e+8>>2],u[A+1|0]=i[e+8>>2]>>>8,u[A+2|0]=F[e+10>>1],u[A+3|0]=l[e+11|0],u[A+4|0]=i[e+12>>2],u[A+5|0]=i[e+12>>2]>>>8,u[A+6|0]=F[e+14>>1],u[A+7|0]=l[e+15|0],u[A+8|0]=i[e+16>>2],u[A+9|0]=i[e+16>>2]>>>8,u[A+10|0]=F[e+18>>1],u[A+11|0]=l[e+19|0],u[A+12|0]=i[e+20>>2],u[A+13|0]=i[e+20>>2]>>>8,u[A+14|0]=F[e+22>>1],u[A+15|0]=l[e+23|0],o0(e,0,152)}function Bt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(r=v-48|0,k=r,v=r,t=r-48|0,v=t,u[t+33|0]=0,o0(t,46,33),s=t+16|0,u[s|0]=124,r=l[A+96|0],r)for(w=A- -64|0;;){n=r,r=r-1|0,o=l[w+r|0],f=Q[(r<<1)+A>>1];i:{if(!((f|0)>=-16&(f|0)<=16)){i[k+32>>2]=f,i[k+36>>2]=o?88:111,k0(e,29211,k+32|0);break i}if(f=f+s|0,o){u[f|0]=88;break i}u[f|0]=111}if(!(n>>>0>1))break}if(r=l[A+97|0],r)for(o=A+80|0,w=A+32|0;;){A=r,r=r-1|0,f=l[o+r|0],n=Q[w+(r<<1)>>1];i:{if(!((n|0)>=-16&(n|0)<=16)){i[k+16>>2]=n,i[k+20>>2]=f?88:111,k0(e,29211,k+16|0);break i}if(n=n+s|0,f){u[n|0]=88;break i}u[n|0]=111}if(!(A>>>0>1))break}i[k>>2]=t,k0(e,32953,k),v=k+48|0}function Vg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,9813);break i}e:{if(u[e+100|0]&1){if(u[e+115|0]<0){u[i[e+104>>2]]=0,i[e+108>>2]=0;break e}u[e+115|0]=0,u[e+104|0]=0;break e}B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2]}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function v0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,k=i[A+4>>2];;){i:{if(o=f,!k){n=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],k=k-1|0,i[A+4>>2]=k,t=i[A+12>>2],n=o-8|0,s=n&31,h=A,(n&63)>>>0>=32?(w=r<<s,r=0):(w=(1<<s)-1&r>>>32-s,r=r<<s),i[h+8>>2]=r|i[A+8>>2],i[A+12>>2]=t|w,r=f,f=r-8|0,_=_-(r>>>0<8)|0,(o|0)>15)continue}break}k=64-n|0}return i[A+16>>2]=k-e,r=i[A+8>>2],f=A,f=A,A=i[A+12>>2],n=r,t=e&31,(e&63)>>>0>=32?(o=r<<t,n=0):(o=(1<<t)-1&n>>>32-t|A<<t,n=n<<t),i[f+8>>2]=n,i[f+12>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function Fg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;n=v-192|0,v=n,i[n+136>>2]=0,i[n+108>>2]=72884,t=i[18224],i[n+4>>2]=t,o=i[t-12>>2],t=n+4|0,i[o+t>>2]=i[18225],o=t+i[i[n+4>>2]-12>>2]|0,s=n+8|0,J0(o,s),u[o+80|0]=0,i[o+72>>2]=0,i[n+108>>2]=72884,i[n+4>>2]=72864,o=Ot(s),p9(o,k,20)||(k=t+i[i[n+4>>2]-12>>2]|0,H1(k,i[k+16>>2]|4)),t=v-16|0,v=t,k=n+4|0,G1(t+8|0,k);i:{if(!f|!l[t+8|0]||(s=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],(X[i[i[s>>2]+48>>2]](s,r,f)|0)==(f|0)))break i;m4(k+i[i[k>>2]-12>>2]|0,1)}_1(t+8|0),v=t+16|0,b0(A,107712,i[e>>2]),A=i[18223],i[n+4>>2]=A,i[k+i[A-12>>2]>>2]=i[18226],se(o),p0(n+108|0),v=n+192|0}function tA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{if(k=i[A>>2],n=i[A+4>>2]-k|0,f=((n|0)/56|0)+1|0,f>>>0<76695845){if(r=(i[A+8>>2]-k|0)/56|0,k=r<<1,t=r>>>0>=38347922?76695844:f>>>0<k>>>0?k:f,t){if(t>>>0>=76695845)break i;f=E(G(t,56))}else f=0;if(k=f,s=n+k|0,te(s,e),o=i[A+4>>2],e=i[A>>2],n=G((o-e|0)/-56|0,56)+s|0,(e|0)!=(o|0)){for(f=e,r=n;te(r,f),r=r+56|0,f=f+56|0,(o|0)!=(f|0););for(;r=i[e+44>>2],r&&(i[e+48>>2]=r,Z(r)),i[e>>2]=86404,r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),e=e+56|0,(o|0)!=(e|0););e=i[A>>2]}return r=s+56|0,i[A+4>>2]=r,i[A>>2]=n,i[A+8>>2]=G(t,56)+k,e&&Z(e),r}G0(),H()}x0(),H()}function Eg(A,e){A=A|0,e=e|0;var r=0;if(X[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129816),i[A+68>>2]=e,r=l[A+98|0],e=X[i[i[e>>2]+28>>2]](e)|0,u[A+98|0]=e,(e|0)!=(r|0)){if(i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e=l[A+96|0],l[A+98|0]==1){i:{if(!(e&1)||(e=i[A+32>>2],!e))break i;Z(e)}u[A+96|0]=l[A+97|0],i[A+52>>2]=i[A+60>>2],e=i[A+56>>2],i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=e,u[A+97|0]=0;return}i:{if(e&1||(e=i[A+32>>2],(e|0)==(A+44|0)))break i;u[A+97|0]=0,i[A+56>>2]=e,e=i[A+52>>2],i[A+60>>2]=e,e=E(e),u[A+96|0]=1,i[A+32>>2]=e;return}e=i[A+52>>2],i[A+60>>2]=e,e=E(e),u[A+97|0]=1,i[A+56>>2]=e}}function ke(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;o0(A+38|0,0,2064),i[A+18524>>2]=-1,i[A+18528>>2]=-1;i:{e:{if(f=i[i[A+18592>>2]+24>>2],(f|0)>0){if(t=i[A+18588>>2],e=i[t+124>>2],k=i[e+484>>2],n=i[t+132>>2],n=i[(i[n+8460>>2]+(i[i[n+8448>>2]+(f<<2)>>2]<<2)|0)-4>>2],r=i[e+16892>>2],f=(n|0)/(r|0)|0,r=(n-G(f,r)|0)+1|0,n=i[e+16876>>2],r=r<<n,k=((k|0)<(r|0)?k:r)-1|0,r=i[t+168>>2],k=k>>r,(k|0)<0||(o=i[t+172>>2],(k|0)>=(o|0)))break e;if(e=i[e+488>>2],f=f+1<<n,e=((e|0)<(f|0)?e:f)-1>>r,(e|0)<0|(e|0)>=i[t+176>>2])break i;i[A+18520>>2]=u[((i[t+160>>2]+G(k,3)|0)+G(G(e,o),3)|0)+2|0]}return}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function pg(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;e=i[A+20>>2],k=i[e+18588>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,r=i[e+18588>>2],n=i[r+124>>2],f=i[n+16908>>2],t=i[e+4>>2],(f|0)>(t|0)&&(f=i[i[i[r+132>>2]+8460>>2]+(t<<2)>>2]),r=i[n+16892>>2],i[e>>2]=f,n=(f|0)/(r|0)|0,i[e+12>>2]=n,i[e+8>>2]=f-G(r,n);i:{e:{r:{if(l[A+8|0]==1){if($f(e))break r;break e}if(f=i[e+18592>>2],r=i[f+804>>2],r>>>0>=3)break i;ji(e+18572|0,r,i[f+800>>2]),u[e+18580|0]=0,u[e+18581|0]=0,u[e+18582|0]=0,u[e+18583|0]=0}Ze(e+18548|0),fr(e,0,l[A+8|0])}i[A+4>>2]=3,A=i[e+18600>>2],i[A+44>>2]=i[A+44>>2]+1,h3(k);return}M0(21701,18308,1520,5105),H()}function yg(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0;i:{if(w=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[w>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[w+4>>2],w=w+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}e:{if(!l[e+16|0]||(n&&(i[n>>2]=i[e+20>>2]),!t))break e;i[t>>2]=i[e+24>>2]}f&&(i[f>>2]=l[e+16|0]),k&&(i[k>>2]=l[e+16|0]),!s|i[e+32>>2]<=0||(i[s>>2]=i[e+28>>2]),o&&(i[o>>2]=i[e+32>>2]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];return}e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216]}function Yg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(f=e<<24>>24,u[r+23|0]=f,l[A+44|0]==1){if(k=i[A+32>>2],A=v-16|0,v=A,u[A+15|0]=f,f=L1(A+15|0,1,1,k),v=A+16|0,(f|0)!=1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,o=r+32|0,f=r+23|0;;){if(k=i[A+36>>2],k=X[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,o,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((L1(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(t=r+24|0,f=i[r+16>>2]-t|0,(L1(t,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function Rg(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;if(!((n|0)<=0|(k|0)<=0))for(t=k-1|0,B=t&4,m=(t>>>2|0)+1&2147483646,W=k>>>0<5;;){if(k=G(f,h)+r|0,t=(G(e,h)<<1)+A|0,o=0,!W)for(;s=l[k|0],w=l[k+1|0],_=l[k+2|0],Q[t+6>>1]=l[k+3|0]<<6,Q[t+4>>1]=_<<6,Q[t+2>>1]=w<<6,Q[t>>1]=s<<6,s=l[k+4|0],w=l[k+5|0],_=l[k+6|0],Q[t+14>>1]=l[k+7|0]<<6,Q[t+12>>1]=_<<6,Q[t+10>>1]=w<<6,Q[t+8>>1]=s<<6,k=k+8|0,t=t+16|0,o=o+2|0,(m|0)!=(o|0););if(B||(o=l[k|0],s=l[k+1|0],w=l[k+2|0],Q[t+6>>1]=l[k+3|0]<<6,Q[t+4>>1]=w<<6,Q[t+2>>1]=s<<6,Q[t>>1]=o<<6),h=h+1|0,(h|0)==(n|0))break}}function Jg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,Z1(r,l[e+97|0]?4:2,i[e+40>>2]-i[e+36>>2]>>3,0),f=i[e+36>>2],t=i[e+40>>2];i:{if((f|0)!=(t|0))for(;;){if(o=i[f>>2],X[i[i[o>>2]+20>>2]](A,o,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(t|0)==(f|0))break}if(f=i[26929],i[A>>2]=i[26928],i[A+4>>2]=f,A=A+8|0,u[107731]>=0){f=i[26931],i[A>>2]=i[26930],i[A+4>>2]=f,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function Ng(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,s=X[i[i[e>>2]+52>>2]](e,r,0)|0,u[e+100|0]&1&&(C0(r,i[e+104>>2]),C0(r,i[e+108>>2])),l2(r,l[e+112|0]);i:{e:{if(!l[e+112|0]){for(t=i[e+120>>2],f=i[e+124>>2]-t|0;;){if(o=f,n=0,!f)break e;if(f=f-1|0,!!l[t+f|0])break}for(C0(r,o),f=0;l2(r,l[i[e+120>>2]+f|0]),f=f+1|0,o>>>0>f>>>0;);break i}n=i[e+116>>2]}C0(r,n)}f1(k+12|0,e,r,s),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,e=A+8|0;i:{if(u[107731]>=0){A=i[26931],i[e>>2]=i[26930],i[e+4>>2]=A,i[e+8>>2]=i[26932];break i}T(e,i[26930],i[26931])}v=k+32|0}function Mg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,m9(A,e);i:{if(i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),s=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],t=i[e+104>>2],(f|0)!=(t|0))for(;;){if(C0(r,(i[f+8>>2]-i[f+4>>2]|0)+8|0),C0(r,i[f>>2]),n=i[f+4>>2],o=i[f+8>>2],(n|0)!=(o|0))for(;C0(r,i[n>>2]),n=n+4|0,(o|0)!=(n|0););if(f=f+16|0,(t|0)==(f|0))break}if(f1(k+12|0,e,r,s),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Ug(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0;o=v-48|0,v=o,s=i[e>>2],w=i[s+48>>2],s=i[s+52>>2];i:{if(!s){Rn(o+12|0,w,r,f,k,n);break i}if(i[s+4>>2]=i[s+4>>2]+1,Rn(o+12|0,w,r,f,k,n),r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;X[i[i[s>>2]+8>>2]](s),p(s)}i:{e:{r:{if(r=l[o+32|0],!(r|!t)){i[t>>2]=i[o+12>>2];break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,o+12|0,i[e>>2]),A=l[o+32|0],(A|0)==255)break i;break e}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=0}e=i[24199],i[o+40>>2]=i[24198],i[o+44>>2]=e,X[i[(o+40|0)+(A<<2)>>2]](o+39|0,o+12|0)}v=o+48|0}function Dg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(i[e>>2]>=5){e=i[24167],i[A>>2]=i[24166],i[A+4>>2]=e,i[A+8>>2]=i[24168];return}r=i[e+28>>2],r&&X[r|0](),r=E(4),i[r>>2]=e,f=E(20),i[f+16>>2]=r,r=i[26942];i:{if(!r){e=107768,k=107768;break i}for(n=i[e+12>>2];;){if(e=r,i[i[i[e+16>>2]>>2]+12>>2]<(n|0)){if(k=e,r=i[e>>2],r)continue;break i}if(r=i[e+4>>2],!r)break}k=e+4|0}i[f+8>>2]=e,i[f>>2]=0,i[f+4>>2]=0,i[k>>2]=f,e=i[i[26941]>>2],e&&(i[26941]=e),m1(i[26942],f),i[26943]=i[26943]+1,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}function vt(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=j0(i[r>>2],0),k=i[i[r>>2]+120>>2],n=(f|0)<11,t=n&&(k|0)==3?1:2,s=n?k>>>0>=2?t:0:t,n=o8(i[r>>2],0),r=l8(i[r>>2],0),t=G(n,r);i:{if(!((n|0)>8192|(r|0)>4352)&&(o=13,(t|0)<8912897))break i;o=(n|0)>=16385||(r|0)>=8705?31:(t|0)<35651585?17:31}if(u[e+2|0]=o,u[e+1|0]=s,u[e+6|0]=!k,u[e+5|0]=f>>>0>11,u[e+4|0]=f>>>0>8,r=k<<3,f=k>>>0<4,u[e+7|0]=((f?16908801>>>r|0:0)&3)>>>1,u[e+9|0]=(k|0)!=1?2:0,u[e+8|0]=((f?16843265>>>r|0:0)&3)>>>1,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function mt(A){var e=0;e=E(176),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=91572,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=89184,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,u[e+144|0]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+32>>2]=1668114798,i[A+4>>2]=e,i[A>>2]=e+16}function Hg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(i[r+20>>2]=e,l[A+44|0]==1){A=i[A+32>>2];f:{if(i[A+76>>2]<0){A=dn(e,A);break f}A=dn(e,A)}if((A|0)==-1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,o=r+32|0,f=r+20|0;;){if(k=i[A+36>>2],k=X[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,o,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((L1(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(t=r+24|0,f=i[r+16>>2]-t|0,(L1(t,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function xg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;f=v-16|0,v=f;i:{if(!(l[n+11|0]>>>7|0)){i[A+8>>2]=i[n+8>>2],e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e;break i}r=i[n>>2],k=v-16|0,v=k;e:{r:{n=i[n+4>>2];f:{if(n>>>0<2){e=A,u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127;break f}if(n>>>0>1073741815)break r;o=k+8|0,n>>>0>=2?(t=n+2&-2,e=t-1|0,e=(e|0)==2?t:e):e=1,Ei(o,e+1|0),e=i[k+8>>2],i[A>>2]=e,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=n+1|0;f:{if(!A||(A=A<<2,!A))break f;z(e,r,A)}v=k+16|0;break e}Z4(),H()}}v=f+16|0}function Zt(A,e,r){var f=0,k=0;if(!e)return 0;i:{e:{if(!r)break e;if(f=l[e|0],k=f<<24>>24,(k|0)>=0)return A&&(i[A>>2]=f),(k|0)!=0;if(!i[i[31378]>>2]){if(e=1,!A)break i;return i[A>>2]=k&57343,1}if(f=f-194|0,f>>>0>50||(f=i[(f<<2)+73232>>2],r>>>0<=3&&f<<G(r,6)-6<0)||(r=l[e+1|0],k=r>>>3|0,(k-16|k+(f>>26))>>>0>7))break e;if(r=r-128|f<<6,(r|0)>=0){if(e=2,!A)break i;return i[A>>2]=r,2}if(f=l[e+2|0]-128|0,f>>>0>63)break e;if(k=f,f=r<<6,r=k|f,(f|0)>=0){if(e=3,!A)break i;return i[A>>2]=r,3}if(f=l[e+3|0]-128|0,f>>>0>63)break e;if(e=4,!A)break i;return i[A>>2]=f|r<<6,4}i[31336]=25,e=-1}return e}function Gt(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h;i:{if(A){A=c0(r,129560);break i}A=c0(r,129552)}i:{if(e){e=h+4|0,X[i[i[A>>2]+44>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,X[i[i[A>>2]+32>>2]](e,A);break i}e=h+4|0,X[i[i[A>>2]+40>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,X[i[i[A>>2]+28>>2]](e,A)}me(s,e),R1(e),_=k,B=X[i[i[A>>2]+12>>2]](A)|0,i[_>>2]=B,_=n,B=X[i[i[A>>2]+16>>2]](A)|0,i[_>>2]=B,e=h+4|0,X[i[i[A>>2]+20>>2]](e,A),q8(t,e),s2(e),X[i[i[A>>2]+24>>2]](e,A),me(o,e),R1(e),_=w,B=X[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=h+16|0}function R4(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-16|0,v=e;i:{if(!f4(A,8))break i;k=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!(X[i[i[k>>2]+16>>2]](k,e+8|0,8)|0)){i8(A),k=0;break e}A=0,f=l[e+8|0]|l[e+9|0]<<8|(l[e+10|0]<<16|l[e+11|0]<<24),o=f<<24|(f&65280)<<8,n=f&16711680,k=n>>>8|0,n=n<<24,t=A,s=n,A=f&-16777216,n=A>>>24|0,t=t|(s|A<<8),A=l[e+12|0]|l[e+13|0]<<8|(l[e+14|0]<<16|l[e+15|0]<<24),f=t|(((A&255)<<24|f>>>8)&-16777216|((A&16777215)<<8|f>>>24)&16711680|(A>>>8&65280|A>>>24)),k=o|(k|n)}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}return v=e+16|0,l0=k,f}function Wt(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h;i:{if(A){A=c0(r,129544);break i}A=c0(r,129536)}i:{if(e){e=h+4|0,X[i[i[A>>2]+44>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,X[i[i[A>>2]+32>>2]](e,A);break i}e=h+4|0,X[i[i[A>>2]+40>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,X[i[i[A>>2]+28>>2]](e,A)}q8(s,e),s2(e),_=k,B=X[i[i[A>>2]+12>>2]](A)|0,u[_|0]=B,_=n,B=X[i[i[A>>2]+16>>2]](A)|0,u[_|0]=B,e=h+4|0,X[i[i[A>>2]+20>>2]](e,A),q8(t,e),s2(e),X[i[i[A>>2]+24>>2]](e,A),q8(o,e),s2(e),_=w,B=X[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=h+16|0}function uA(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{if(2147483639-e>>>0>=r>>>0){l[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=t+4|0,e>>>0<1073741811?(i[t+12>>2]=e<<1,i[t+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=t+12|0,r=i[(u0[n>>2]<u0[r>>2]?r:n)>>2],r>>>0>=11?(o=r+8&-8,r=o-1|0,r=(r|0)==11?o:r):r=10,r=r+1|0):r=2147483639,Fi(n,r),r=i[t+4>>2],k&&(n=!k,n|n||z(r,s,k)),(f|0)!=(k|0)&&(n=r+k|0,o=k+s|0,k=f-k|0,w=!k,w|w||z(n,o,k)),(e|0)!=10&&$8(s,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[t+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=t+16|0;break i}Z4(),H()}i[A+4>>2]=f}function zg(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;i:{if(!(!k|(!r|!f))&&n)break i;e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}i:{if(o=i[e+16>>2],!o||(o=X0(o,94804,96008),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],r=i[o+20>>2],f=i[o+24>>2]-r|0,f&&z(t,r,f),i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}function Tg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-48|0,v=n;i:{e:{if(t=i[e>>2],!t||(o=X0(t,106612,106744),!o))break e;t=i[e+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[n+20>>2]=i[r>>2],r=i[r+4>>2],i[n+24>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=r,r=n+28|0,M7(r,o,n+8|0,f,k,1);r:{if(i[n+28>>2]){b0(A,r,i[e+8>>2]);break r}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}if(u[n+47|0]<0&&Z(i[n+36>>2]),!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;X[i[i[t>>2]+8>>2]](t),p(t);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24698}v=n+48|0}function Sg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-32|0,v=k,o=X[i[i[e>>2]+52>>2]](e,r,0)|0,u[e+100|0]&1&&(C0(r,i[e+104>>2]),C0(r,i[e+108>>2])),C0(r,i[e+132>>2]-i[e+128>>2]>>3),i[e+120>>2]=i[r+12>>2],i[e+124>>2]=0,f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){t=i[f>>2],s=i[f+4>>2];i:{if(l[e+112|0]==1){e4(r,t,s);break i}C0(r,t)}if(f=f+8|0,(n|0)==(f|0))break}f1(k+12|0,e,r,o),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function g8(A,e,r,f,k){var n=0,t=0,o=0;o=v-16|0,v=o,i[o+12>>2]=e,e=0,n=6;i:{e:{if(q2(A,o+12|0))break e;n=i[A>>2],t=i[n+12>>2];r:{if((t|0)==i[n+16>>2]){t=X[i[i[n>>2]+36>>2]](n)|0;break r}t=i[t>>2]}if(n=4,!(X[i[i[f>>2]+12>>2]](f,64,t)|0))break e;for(e=X[i[i[f>>2]+52>>2]](f,t,0)|0;;){r:{if(a1(A),e=e-48|0,q2(A,o+12|0)|(k|0)<2)break r;n=i[A>>2],t=i[n+12>>2];f:{if((t|0)==i[n+16>>2]){n=X[i[i[n>>2]+36>>2]](n)|0;break f}n=i[t>>2]}if(!(X[i[i[f>>2]+12>>2]](f,64,n)|0))break i;k=k-1|0,e=(X[i[i[f>>2]+52>>2]](f,n,0)|0)+G(e,10)|0;continue}break}if(!q2(A,o+12|0))break i;n=2}i[r>>2]=n|i[r>>2]}return v=o+16|0,e}function ne(A,e,r,f){var k=0,n=0,t=0,o=0;t=f||128136,f=i[t>>2];i:{e:{r:{if(!e){if(f)break r;return 0}if(k=-2,!r)break e;f:{if(f){k=r;break f}if(f=l[e|0],n=f<<24>>24,(n|0)>=0)return A&&(i[A>>2]=f),(n|0)!=0;if(!i[i[31378]>>2]){if(k=1,!A)break e;return i[A>>2]=n&57343,1}if(f=f-194|0,f>>>0>50)break r;if(f=i[(f<<2)+73232>>2],k=r-1|0,!k)break i;e=e+1|0}if(n=l[e|0],o=n>>>3|0,(o-16|(f>>26)+o)>>>0>7)break r;for(;;){if(k=k-1|0,f=(n&255)-128|f<<6,(f|0)>=0)return i[t>>2]=0,A&&(i[A>>2]=f),r-k|0;if(!k)break i;if(e=e+1|0,n=u[e|0],!((n|0)<-64))break}}i[t>>2]=0,i[31336]=25,k=-1}return k}return i[t>>2]=f,-2}function jg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+100>>2],C0(r,X[i[i[k>>2]+8>>2]](k)|0),k=i[e+100>>2],X[i[i[k>>2]+16>>2]](f+24|0,k,r);i:{if(i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+40>>2],e=i[f+36>>2],i[A+8>>2]=i[f+32>>2],i[A+12>>2]=e,i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0;break i}if(f1(f+4|0,e,r,n),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[f+43|0]<0&&Z(i[f+32>>2]),v=f+48|0}function oA(A){var e=0,r=0,f=0;if(sA(A),e=i[A+320>>2],e){if(f=e-4|0,r=i[f>>2],r)for(r=e+G(r,76)|0;r=r-76|0,(e|0)!=(r|0););Z(f)}Z(i[A+260>>2]),Z(i[A+240>>2]),Z(i[A+220>>2]),Z(i[A+200>>2]),Z(i[A+180>>2]),Z(i[A+160>>2]),Z(i[A+140>>2]),e=i[A+136>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+128>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+120>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),A}function Xt(A,e,r,f){var k=0,n=0,t=0;if(n=i[A+8>>2],k=i[A>>2],(n-k|0)/48>>>0>=f>>>0){if(t=f,n=i[A+4>>2],f=n-k|0,t>>>0>(f|0)/48>>>0){(k|0)!=(n|0)&&(f&&z(k,e,f),n=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(n,f,e),i[A+4>>2]=e+n;return}f=r-e|0,!f|(e|0)==(r|0)||z(k,e,f),i[A+4>>2]=f+k;return}k&&(i[A+4>>2]=k,Z(k),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=0);i:{if(f>>>0>=89478486||(k=(n|0)/48|0,n=k<<1,f=k>>>0>=44739242?89478485:f>>>0<n>>>0?n:f,f>>>0>=89478486))break i;k=G(f,48),f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function Og(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-48|0,v=k,C6(k+24|0,i[e+100>>2],i[e+116>>2],k+44|0);i:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break i}t=k+12|0,r4(t,i[e+100>>2],i[k+44>>2],1),e=i[k+16>>2],n=i[k+12>>2];e:{if(!n){if(u[k+12|0]=0,u[k+23|0]=0,K(A,2,2e3,t),u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}X[i[i[n>>2]+76>>2]](A,n,r,f)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}u[k+43|0]<0&&Z(i[k+32>>2]),v=k+48|0}function ni(A,e){var r=0,f=0,k=0;f=v-48|0,v=f,l[108685]==1&&(i[f+36>>2]=e,i[f+32>>2]=A,y8(33205,f+32|0)),r=i[e+4>>2];i:{if(!r){if(l[108685]==1&&(i[f+4>>2]=i[A+4>>2],i[f>>2]=A,y8(33165,f)),e=i[A+4>>2],!e)break i;r=i[e>>2]-1|0,i[e>>2]=r;e:{if(r||(r=i[A>>2],r&&(Z(r),e=i[A+4>>2],!e)))break e;Z(e)}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r>>2]=i[r>>2]+1,l[108685]==1&&(i[f+20>>2]=i[A+4>>2],i[f+16>>2]=A,y8(33165,f+16|0)),r=i[A+4>>2],r){k=i[r>>2]-1|0,i[r>>2]=k;e:{if(k||(k=i[A>>2],k&&(Z(k),r=i[A+4>>2],!r)))break e;Z(r)}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2]}v=f+48|0}function Lg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!l[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(F[r+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=8)break i;u[e+30|0]=1,Q[e+28>>1]=2,i[e+24>>2]=131074,i[e+8>>2]=1,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function Pg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!l[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(F[r+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f>>>0>14)break i;u[e+30|0]=1,Q[e+28>>1]=2,i[e+24>>2]=131074,i[e+8>>2]=1,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=f,u[e+16|0]=r,i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function qg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-48|0,v=t,o=i[e>>2],s=i[o+48>>2],o=i[o+52>>2];i:{if(!o){Jn(t+12|0,s,r,f,k);break i}if(i[o+4>>2]=i[o+4>>2]+1,Jn(t+12|0,s,r,f,k),r=i[o+4>>2],i[o+4>>2]=r-1,r)break i;X[i[i[o>>2]+8>>2]](o),p(o)}i:{e:{r:{if(r=l[t+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,t+12|0,i[e>>2]),A=l[t+32|0],(A|0)==255)break i;break e}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=0}e=i[24199],i[t+40>>2]=i[24198],i[t+44>>2]=e,X[i[(t+40|0)+(A<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function E6(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;h=1,s=f&2147483647,w=s,_=(s|0)==2147418112;i:{if((_&!r?A|e:_&(r|0)!=0|s>>>0>2147418112)||(s=o&2147483647,!t&(s|0)==2147418112?k|n:(s|0)==2147418112&(t|0)!=0|s>>>0>2147418112))break i;if(!(A|k|(r|t)|(e|n|(s|w))))return 0;if(s=f&o,(s|0)>0?w=1:w=(s|0)>=0,w)return((r|0)==(t|0)&(f|0)==(o|0)?(e|0)==(n|0)&A>>>0<k>>>0|e>>>0<n>>>0:r>>>0<t>>>0&(f|0)<=(o|0)|(f|0)<(o|0))?-1:(A^k|r^t|(e^n|f^o))!=0;if((r|0)==(t|0)&(f|0)==(o|0)?(e|0)==(n|0)&A>>>0>k>>>0|e>>>0>n>>>0:r>>>0>t>>>0&(f|0)>=(o|0)|(f|0)>(o|0))return-1;h=(A^k|r^t|(e^n|f^o))!=0}return h}function Kg(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,W=0,g=0,I=0,C=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(W=1<<s-1,_=-1<<w^-1,I=k&2147483646,C=k&1;;){if(w=(G(e,m)<<1)+A|0,B=(G(f,m)<<1)+r|0,g=0,(k|0)!=1)for(;h=(G(Q[B>>1],t)+W>>s)+o|0,Q[w>>1]=(h|0)>=0?(_|0)>(h|0)?h:_:0,h=(G(Q[B+2>>1],t)+W>>s)+o|0,Q[w+2>>1]=(h|0)>=0?(_|0)>(h|0)?h:_:0,B=B+4|0,w=w+4|0,g=g+2|0,(I|0)!=(g|0););if(C&&(h=w,w=(G(Q[B>>1],t)+W>>s)+o|0,Q[h>>1]=(w|0)>=0?(w|0)<(_|0)?w:_:0),m=m+1|0,(m|0)==(n|0))break}return}M0(21792,18227,193,10487),H()}function ag(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-32|0,v=k,o=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,(i[e+108>>2]-i[e+104>>2]|0)/24|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;;){t=i[f>>2],s=i[f+4>>2];i:{if(l[e+97|0]==1){e4(r,t,s),e4(r,i[f+8>>2],i[f+12>>2]);break i}C0(r,t),C0(r,i[f+8>>2])}if(De(r,Q[f+16>>1]),De(r,Q[f+18>>1]),f=f+24|0,(n|0)==(f|0))break}f1(k+12|0,e,r,o),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Nr(A,e,r){var f=M(0),k=M(0),n=0,t=M(0),o=M(0),s=M(0),w=M(0),h=M(0);n=v-16|0,v=n,Cn(n+8|0,e,r),f=E0[n+12>>2],t=E0[n+8>>2];i:{if(!(f!=M(0)|t!=M(0))){h=M(-.41868799924850464),o=M(-.3312639892101288),f=M(.11400000005960464),w=M(.5870000123977661),t=M(.29899999499320984),k=M(-.08131200075149536),s=M(-.16873499751091003);break i}k=M(M(1)-t),w=M(k-f),o=M(-w),h=M(M(o/k)*M(.5)),s=M(M(1)-f),o=M(M(o/s)*M(.5)),k=M(M(M(-f)/k)*M(.5)),s=M(M(M(-t)/s)*M(.5))}E0[A+36>>2]=k,E0[A+32>>2]=h,i[A+24>>2]=1056964608,i[A+28>>2]=1056964608,E0[A+20>>2]=o,E0[A+16>>2]=s,E0[A+12>>2]=f,E0[A+8>>2]=w,E0[A+4>>2]=t,u[A|0]=1,v=n+16|0}function $g(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),Q[k+100>>1]=n,k=e,n=o2(r),Q[k+106>>1]=n,k=e,n=o2(r),Q[k+102>>1]=n,k=e,n=o2(r),Q[k+108>>1]=n,k=e,n=o2(r),Q[k+104>>1]=n,k=e,n=o2(r),Q[k+110>>1]=n,k=e,n=o2(r),Q[k+112>>1]=n,k=e,n=o2(r),Q[k+114>>1]=n,k=e,n=F0(r),i[k+116>>2]=n,k=e,n=F0(r),i[k+120>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function gt(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=100160,e=i[A+140>>2],e){if(r=e,f=i[A+144>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+140>>2]}i[A+144>>2]=e,Z(r)}if(e=i[A+128>>2],e){if(r=e,f=i[A+132>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+128>>2]}i[A+132>>2]=e,Z(r)}if(e=i[A+116>>2],e){if(r=e,f=i[A+120>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+116>>2]}i[A+120>>2]=e,Z(r)}return A2(A)|0}function Qt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{k=i[A+4>>2],w=i[A>>2];e:{if((k|0)!=(w|0)){r=k;break e}if(f=i[A+8>>2],r=i[A+12>>2],f>>>0<r>>>0){n=((r-f>>2)+1|0)/2<<2,t=f-k|0,r=(n+f|0)-t|0,(f|0)!=(k|0)&&(t&&z(r,k,t),f=i[A+8>>2]),i[A+8>>2]=f+n;break e}if(n=(r|0)==(k|0)?1:r-k>>1,n>>>0>=1073741824)break i;if(r=n<<2,o=E(r),t=o+r|0,r=(n+3&-4)+o|0,s=r,(f|0)!=(k|0))for(s=(f-k|0)+r|0,n=r,f=k;i[n>>2]=i[f>>2],f=f+4|0,n=n+4|0,(s|0)!=(n|0););if(i[A+12>>2]=t,i[A+8>>2]=s,i[A+4>>2]=r,i[A>>2]=o,!k)break e;Z(w),r=i[A+4>>2]}r=r-4|0,i[r>>2]=i[e>>2],i[A+4>>2]=r;return}x0(),H()}function Mr(A,e,r,f,k){var n=0,t=0,o=0,s=0;n=v-208|0,v=n,i[n+204>>2]=r,r=n+160|0,o0(r,0,40),i[n+200>>2]=i[n+204>>2];i:{if((c7(0,e,n+200|0,n+80|0,r,f,k)|0)<0){k=-1;break i}s=i[A+76>>2]<0,t=i[A>>2],i[A>>2]=t&-33;e:{r:{f:{if(!i[A+48>>2]){i[A+48>>2]=80,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,o=i[A+44>>2],i[A+44>>2]=n;break f}if(i[A+16>>2])break r}if(r=-1,cA(A))break e}r=c7(A,e,n+200|0,n+80|0,n+160|0,f,k)}if(o&&(X[i[A+36>>2]](A,0,0)|0,i[A+48>>2]=0,i[A+44>>2]=o,i[A+28>>2]=0,e=i[A+20>>2],i[A+16>>2]=0,i[A+20>>2]=0,r=e?r:-1),e=A,A=i[A>>2],i[e>>2]=A|t&32,k=A&32?-1:r,s)break i}return v=n+208|0,k}function k6(A,e,r,f){var k=0,n=0,t=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>2>>>0>=f>>>0){if(t=f,k=i[A+4>>2],f=k-n|0,t>>>0>f>>2>>>0){(k|0)!=(n|0)&&(f&&z(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||z(n,e,f),i[A+4>>2]=f+n;return}n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0);i:{if(f>>>0>=1073741824||(n=k>>1,f=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,f>>>0>=1073741824))break i;k=f<<2,f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function dg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),C0(r,i[e+120>>2]),e4(r,i[e+128>>2],i[e+132>>2]);break i}C0(r,k),C0(r,i[e+112>>2]),C0(r,i[e+120>>2]),C0(r,i[e+128>>2])}u2(r,l[e+138|0]&31|((l[e+137|0]&31)<<5|(l[e+136|0]&31)<<10)),u2(r,0),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function cg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,i[r+44>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0;i:{if(!z9(i[e+64>>2],r+36|0)){u[r+4|0]=0,u[r+15|0]=0,e=K(r+16|0,2,117,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;e:{if(u[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break e;Z(i[e+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+36>>2],!A)break i;i[r+40>>2]=A,Z(A);break i}e=i[r+40>>2],f=i[r+36>>2],k=i[r+44>>2],u[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=f,i[A+4>>2]=e}v=r+48|0}function It(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+272>>2];i:{if(!r){r=0;break i}r=i[r>>2],k=i[r+104>>2],r=i[r+108>>2],f=E(8),i[f>>2]=k,i[f+4>>2]=r,r=f+8|0,i[A+8>>2]=r,i[A>>2]=f,i[A+4>>2]=r}i:{e:{if(e=i[e+276>>2],e){if(k=r-f|0,o=k>>3,n=o+1|0,n>>>0>=536870912)break e;if(r=i[e>>2],e=i[r+108>>2],s=i[r+104>>2],r=k>>>2|0,t=k>>>0>=2147483640?536870911:r>>>0>n>>>0?r:n,t){if(t>>>0>=536870912)break i;r=E(t<<3)}else r=0;n=k+r|0,i[n>>2]=s,i[n+4>>2]=e,e=n-(o<<3)|0,k&&z(e,f,k),i[A+8>>2]=(t<<3)+r,i[A>>2]=e,f&&Z(f),i[A+4>>2]=n+8}return}G0(),H()}x0(),H()}function bg(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;i:{if(!(!r|!f|(!k|!n))&&t)break i;e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}i:{if(o=i[e+16>>2],!o||(o=X0(o,94804,95920),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],i[t>>2]=i[o+20>>2],i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}function iQ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,W=0,g=0,I=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(W=1<<s-1,g=k&2147483646,I=k&1;;){if(w=G(e,m)+A|0,_=(G(f,m)<<1)+r|0,B=0,(k|0)!=1)for(;h=(G(Q[_>>1],t)+W>>s)+o|0,h=(h|0)>=255?255:h,u[w|0]=(h|0)>0?h:0,h=(G(Q[_+2>>1],t)+W>>s)+o|0,h=(h|0)>=255?255:h,u[w+1|0]=(h|0)>0?h:0,_=_+4|0,w=w+2|0,B=B+2|0,(g|0)!=(B|0););if(I&&(B=w,w=(G(Q[_>>1],t)+W>>s)+o|0,w=(w|0)>=255?255:w,u[B|0]=(w|0)>0?w:0),m=m+1|0,(m|0)==(n|0))break}return}M0(21792,18227,60,10333),H()}function eQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+36>>2],t=i[e+40>>2];i:{if((f|0)!=(t|0))for(;;){if(o=i[f>>2],X[i[i[o>>2]+20>>2]](A,o,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(t|0)==(f|0))break}if(f=i[26929],i[A>>2]=i[26928],i[A+4>>2]=f,A=A+8|0,u[107731]>=0){f=i[26931],i[A>>2]=i[26930],i[A+4>>2]=f,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function C0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{f=i[A+4>>2],t=i[A>>2],o=f-t|0,r=i[A+12>>2]+4|0;e:{if(o>>>0>=r>>>0)break e;if(n=r-o|0,k=i[A+8>>2],n>>>0<=k-f>>>0){n&&o0(f,0,n),i[A+4>>2]=f+n;break e}if((r|0)<0)break i;if(f=k-t|0,k=f<<1,k=f>>>0>=1073741823?2147483647:r>>>0<k>>>0?k:r,f=E(k),n&&o0(f+o|0,0,n),o&&z(f,t,o),i[A+8>>2]=f+k,i[A+4>>2]=r+f,i[A>>2]=f,!t)break e;Z(t)}r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>24,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>16,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e;return}G0(),H()}function te(A,e){var r=0,f=0,k=0,n=0;i[A>>2]=86404,r=i[e+12>>2],f=i[e+8>>2],i[A+8>>2]=f,i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0;i:{e:{if(r=i[e+24>>2],k=i[e+20>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=E(r),i[A+24>>2]=f,i[A+20>>2]=f,n=r+f|0,i[A+28>>2]=n,r&&z(f,k,r),i[A+24>>2]=n}if(i[A+32>>2]=i[e+32>>2],r=i[e+40>>2],i[A+52>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+40>>2]=r,r=i[e+48>>2],f=i[e+44>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=E(e),i[A+48>>2]=r,i[A+44>>2]=r,k=e+r|0,i[A+52>>2]=k,e&&z(r,f,e),i[A+48>>2]=k}return}G0(),H()}G0(),H()}function I2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],(k|0)>=(e|0)|(k|0)>56)r=k;else{for(r=64-k|0,t=i[A+16>>2],s=i[A+20>>2],f=i[A+4>>2],k=i[A+12>>2];;){i:{if(w=r,!k){n=r;break i}if(h=f+1|0,i[A+4>>2]=h,f=l[f|0],k=k-1|0,i[A+12>>2]=k,n=w-8|0,o=n&31,(n&63)>>>0>=32?(_=f<<o,f=0):(_=(1<<o)-1&f>>>32-o,f=f<<o),t=f|t,f=s|_,s=f,i[A+16>>2]=t,i[A+20>>2]=f,f=r,r=f-8|0,B=B-(f>>>0<8)|0,f=h,(w|0)>15)continue}break}r=64-n|0}i[A+24>>2]=r-e,t=i[A+20>>2],n=i[A+16>>2],r=e&31,(e&63)>>>0>=32?(e=n<<r,r=0):(e=(1<<r)-1&n>>>32-r|t<<r,r=n<<r),i[A+16>>2]=r,i[A+20>>2]=e}function rQ(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!(i[r>>2]!=1|i[r+4>>2]!=3)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}r=E(28),u[r+22|0]=1,Q[r+20>>1]=2,i[r+12>>2]=8,i[r+16>>2]=131074,i[r>>2]=1,i[r+4>>2]=11,i[r+24>>2]=11,u[r+8|0]=1,e=E(56),i[e+52>>2]=11,u[e+50|0]=1,Q[e+48>>1]=2,i[e+40>>2]=8,i[e+44>>2]=131074,u[e+36|0]=0,i[e+28>>2]=1,i[e+32>>2]=10,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,f=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=f,f=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=f,i[e+24>>2]=i[r+24>>2],f=e+56|0,i[A+8>>2]=f,i[A>>2]=e,Z(r),i[A+4>>2]=f}function Ct(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{r=i[A+4>>2],k=i[A+8>>2];r:{if(r>>>0<k>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f=r+8|0;break r}if(n=i[A>>2],f=r-n|0,o=f>>3,r=o+1|0,r>>>0>=536870912)break e;if(k=k-n|0,t=k>>2,r=k>>>0>=2147483640?536870911:r>>>0<t>>>0?t:r,r>>>0>=536870912)break i;if(k=r<<3,t=E(k),r=t+f|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,n=i[A>>2],f=i[A+4>>2]-n|0,o=f>>3),e=r-(o<<3)|0,f&&z(e,n,f),i[A+8>>2]=k+t,f=r+8|0,i[A+4>>2]=f,i[A>>2]=e,!n)break r;Z(n)}i[A+4>>2]=f;return}G0(),H()}x0(),H()}function fQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;if(S1(A,i[e+8>>2],n)){NA(e,r,f,k);return}o=l[e+53|0],t=i[A+12>>2],u[e+53|0]=0,s=l[e+52|0],u[e+52|0]=0,w=A+16|0,fk(w,e,r,f,k,n),h=l[e+52|0],s=s|h,_=l[e+53|0],o=o|_;i:{if(t>>>0<2)break i;for(w=w+(t<<3)|0,t=A+24|0;;){if(l[e+54|0])break i;e:{if(h&1){if(i[e+24>>2]==1)break i;if(l[A+8|0]&2)break e;break i}if(!(_&1))break e;if(!(u[A+8|0]&1))break i}if(Q[e+52>>1]=0,fk(t,e,r,f,k,n),_=l[e+53|0],o=(_|o)&1,h=l[e+52|0],s=(h|s)&1,t=t+8|0,!(w>>>0>t>>>0))break}}u[e+53|0]=o&1,u[e+52|0]=s&1}function Vt(A,e,r,f,k){var n=0,t=0,o=0;if(n=E(24),i[n+20>>2]=e,u[n+8|0]=r,i[n>>2]=63676,i[n+4>>2]=0,i[n+16>>2]=k,i[n+12>>2]=f,i[e+18604>>2]=n,Be(A+1392|0,n),r=i[e+18596>>2],A=i[r+460>>2],k=i[r+464>>2],A>>>0<k>>>0){i[A>>2]=n,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,o=A>>2,e=o+1|0,e>>>0<1073741824){if(k=k-f|0,t=k>>1,k=k>>>0>=2147483644?1073741823:e>>>0<t>>>0?t:e,k){if(k>>>0>=1073741824)break i;e=E(k<<2)}else e=0;t=e+A|0,i[t>>2]=n,n=t-(o<<2)|0,A&&z(n,f,A),i[r+464>>2]=e+(k<<2),A=t+4|0,i[r+460>>2]=A,i[r+456>>2]=n,f&&Z(f),i[r+460>>2]=A;return}G0(),H()}x0(),H()}function AQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,F[e+100>>1]),u2(r,F[e+106>>1]),u2(r,F[e+102>>1]),u2(r,F[e+108>>1]),u2(r,F[e+104>>1]),u2(r,F[e+110>>1]),u2(r,F[e+112>>1]),u2(r,F[e+114>>1]),C0(r,i[e+116>>2]),C0(r,i[e+120>>2]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Ft(A){var e=0;return i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+136>>2]=0,i[A+128>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,Q[A+96>>1]=0,i[A+112>>2]=0,i[A+116>>2]=0,u[A+117|0]=0,u[A+118|0]=0,u[A+119|0]=0,u[A+120|0]=0,u[A+121|0]=0,u[A+122|0]=0,u[A+123|0]=0,u[A+124|0]=0,i[A>>2]=86432,u[A+132|0]=0,i[A+16>>2]=1768714083,A}function lA(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(f){if(f>>>0>=107374183)break e;if(k=G(f,40),f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(k=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=k,k=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=k,k=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=k,i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,t=i[e+24>>2],k=i[e+28>>2],(t|0)!=(k|0)){if(k=k-t|0,(k|0)<0)break i;n=E(k),i[f+28>>2]=n,i[f+24>>2]=n,o=k+n|0,i[f+32>>2]=o,k&&z(n,t,k),i[f+28>>2]=o}if(f=f+40|0,e=e+40|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}G0(),H()}G0(),H()}function kQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;if(!(f&&r)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}i:{e:{if(k=i[e+16>>2],!k||(k=X0(k,94804,95788),!k))break e;if(e=i[e+20>>2],e)break i;i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183];return}i[e+4>>2]=i[e+4>>2]+1,i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r,A=i[e+4>>2],i[e+4>>2]=A-1,A||(X[i[i[e>>2]+8>>2]](e),p(e))}function Et(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0;i:{if((f|k)<0||(t=i[A+124>>2],i[t+484>>2]<=(f|0)|i[t+488>>2]<=(k|0))||(w=i[A+132>>2],s=i[w+8496>>2],n=i[t+16936>>2],o=i[t+16924>>2],i[(s+(f>>>n<<2)|0)+(G(o,k>>>n|0)<<2)>>2]>i[(s+(e>>n<<2)|0)+(G(r>>n,o)<<2)>>2])||(s=i[A+140>>2],o=e,e=i[t+16876>>2],n=o>>e,A=i[A+152>>2],r=r>>e,h=F[(s+G(n,24)|0)+G(G(A,r),24)>>1],f=f>>>e|0,o=A,A=k>>>e|0,(h|0)!=F[(s+G(f,24)|0)+G(G(o,A),24)>>1]))break i;e=i[w+8484>>2],k=r,r=i[t+16892>>2],_=i[(e+(n<<2)|0)+(G(k,r)<<2)>>2]==i[(e+(f<<2)|0)+(G(A,r)<<2)>>2]}return _}function nQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}Zf(n+12|0,i[e>>2],r,f);e:{r:switch(l[n+32|0]){default:_2(),H();case 0:if(e=i[n+12>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304,e=0;break e}i[k>>2]=i[e+104>>2]-i[e+100>>2],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,e=0;break e;case 1:break r}if(b0(A,n+12|0,i[e>>2]),e=l[n+32|0],(e|0)==255)break i}A=i[24193],i[n+40>>2]=i[24192],i[n+44>>2]=A,X[i[(n+40|0)+(e<<2)>>2]](n+39|0,n+12|0)}v=n+48|0}function tQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{e:{if(n=i[e>>2],t=i[n+260>>2],s=i[n+264>>2],(t|0)==(s|0))break e;for(;;){if(o=i[t>>2],i[o>>2]!=(r|0)){if(t=t+8|0,(s|0)!=(t|0))continue;break e}break}if(r=i[o+40>>2],t=i[o+44>>2],(r|0)!=(t|0)){if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}n=t-r|0,n&&z(f,r,n),n=i[e>>2]}b0(A,107712,n?n+84|0:0);break i}if(u[k|0]=0,u[k+11|0]=0,r=K(k+12|0,5,2e3,k),u[k+11|0]<0&&Z(i[k>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2])}v=k+32|0}function pt(A,e,r,f){var k=0,n=0,t=0,o=0;if(k=E(20),i[k+16>>2]=e,u[k+8|0]=r,i[k>>2]=63740,i[k+4>>2]=0,i[k+12>>2]=f,i[e+18604>>2]=k,Be(A+1392|0,k),r=i[e+18596>>2],A=i[r+460>>2],n=i[r+464>>2],A>>>0<n>>>0){i[A>>2]=k,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,o=A>>2,e=o+1|0,e>>>0<1073741824){if(n=n-f|0,t=n>>1,n=n>>>0>=2147483644?1073741823:e>>>0<t>>>0?t:e,n){if(n>>>0>=1073741824)break i;e=E(n<<2)}else e=0;t=e+A|0,i[t>>2]=k,k=t-(o<<2)|0,A&&z(k,f,A),i[r+464>>2]=e+(n<<2),A=t+4|0,i[r+460>>2]=A,i[r+456>>2]=k,f&&Z(f),i[r+460>>2]=A;return}G0(),H()}x0(),H()}function yt(A,e,r,f,k,n){var t=0,o=0,s=0;o=i[e+8>>2],X[i[i[o>>2]+20>>2]](o,f,k)|0;i:{t=i[r+4>>2],o=i[r>>2],f=t-o|0,k=f+n|0;e:{if(k>>>0>f>>>0){if(s=i[r+8>>2],s-t>>>0>=n>>>0){n&&o0(t,0,n),i[r+4>>2]=n+t;break e}if((k|0)<0)break i;if(t=s-o|0,s=t<<1,s=t>>>0>=1073741823?2147483647:k>>>0<s>>>0?s:k,t=E(s),n&&o0(f+t|0,0,n),f&&z(t,o,f),i[r+8>>2]=t+s,i[r+4>>2]=k+t,i[r>>2]=t,!o)break e;Z(o);break e}if(f>>>0<=k>>>0)break e;i[r+4>>2]=k+o}e=i[e+8>>2],X[i[i[e>>2]+16>>2]](e,f+i[r>>2]|0,n)|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;return}G0(),H()}function uQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,i[e+108>>2]-i[e+104>>2]&255),k=i[e+104>>2],(k|0)!=i[e+108>>2])for(;l2(r,l[k+n|0]),n=n+1|0,k=i[e+104>>2],n>>>0<i[e+108>>2]-k>>>0;);i[r+12>>2]=t,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function oQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+112>>2]-i[e+108>>2]>>2),k=i[e+108>>2],t=i[e+112>>2],(k|0)!=(t|0))for(;C0(r,i[k>>2]),k=k+4|0,(t|0)!=(k|0););i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Yt(A,e,r){var f=0,k=0,n=0,t=0,o=0;o=v-16|0,v=o,k=v-16|0,v=k,f=A;i:{if(e>>>0<=1073741815){e:{if(e>>>0<2){u[f+11|0]=l[f+11|0]&128|e&127,u[f+11|0]=l[f+11|0]&127;break e}t=k+8|0,e>>>0>=2?(n=e+2&-2,A=n-1|0,A=(A|0)==2?n:A):A=1,Ei(t,A+1|0),A=i[k+8>>2],i[f>>2]=A,i[f+8>>2]=i[f+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[f+8>>2]=i[f+8>>2]|-2147483648,i[f+4>>2]=e}for(n=v-16|0,v=n,i[n+12>>2]=r,r=A,t=e;;){if(t){i[r>>2]=i[n+12>>2],t=t-1|0,r=r+4|0;continue}break}v=n+16|0,i[k+4>>2]=0,i[(e<<2)+A>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}return v=o+16|0,f}function Ur(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,W=0;if(!l[r+332|0]){Q[w>>1]=0,Q[w+2>>1]=0,u[h|0]=0;return}if(B=i[i[e+124>>2]+16876>>2],i[r+28>>2]|l[r+380|0]?_=924:_=988,_=i[(_+r|0)+(i[r+384>>2]<<2)>>2],!(X[i[i[A>>2]+12>>2]](A,_)|0)){Q[w>>1]=0,Q[w+2>>1]=0,u[h|0]=0,C2(A+4|0,1012,0);return}i:{e:{r:{m=k+t|0;f:{if(k>>B!=m>>B||(W=f+n|0,B=i[e+124>>2],(W|0)>=i[B+484>>2]))break f;if(i[B+488>>2]>(m|0))break r}Q[w>>1]=0,Q[w+2>>1]=0,u[h|0]=0;break e}if(J9(A,e,r,_,W&-16,m&-16,o,s,w,h),l[h|0])break i}J9(A,e,r,_,(n>>1)+f&-16,(t>>1)+k&-16,o,s,w,h)}}function r2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+4>>2],f=i[A+8>>2],r>>>0<f>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+4>>2]=r+8;return}i:{if(k=i[A>>2],n=r-k|0,o=n>>3,r=o+1|0,r>>>0<536870912){if(f=f-k|0,t=f>>2,r=f>>>0>=2147483640?536870911:r>>>0<t>>>0?t:r,r>>>0>=536870912)break i;f=r<<3,t=E(f),r=t+n|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,k=i[A>>2],n=i[A+4>>2]-k|0,o=n>>3),e=r-(o<<3)|0,n&&z(e,k,n),i[A+8>>2]=f+t,r=r+8|0,i[A+4>>2]=r,i[A>>2]=e,k&&Z(k),i[A+4>>2]=r;return}G0(),H()}x0(),H()}function Rt(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;k=v-16|0,v=k,C0(r,f),C0(r,i[e+16>>2]);i:{e:{if(i[e+16>>2]!=1970628964)break e;if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,n=i[e+24>>2],f=i[e+20>>2],(n|0)!=(f|0)){if(e=n-f|0,(e|0)<0)break i;n=E(e),i[k+4>>2]=n,t=e+n|0,i[k+12>>2]=t,e&&z(n,f,e),i[k+8>>2]=t}if(V4(r,k+4|0),e=i[k+4>>2],!e)break e;i[k+8>>2]=e,Z(e)}e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;e:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break e}T(A,i[26930],i[26931])}v=k+16|0;return}G0(),H()}function lQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(_=r&2147483644,w=r&3,B=r>>>0<4;;){if(h=G(r,s),o=0,f=0,t=0,!B)for(;n=f,f=o+h|0,k=n+Q[(f<<1)+e>>1]|0,i[(f<<2)+A>>2]=k,n=f+1|0,k=k+Q[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+2|0,k=k+Q[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+3|0,f=k+Q[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=f,o=o+4|0,t=t+4|0,(_|0)!=(t|0););if(t=0,w)for(;k=o+h|0,f=Q[(k<<1)+e>>1]+f|0,i[(k<<2)+A>>2]=f,o=o+1|0,t=t+1|0,(w|0)!=(t|0););if(s=s+1|0,(s|0)==(r|0))break}}function sQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(o|0))break i;f=i[A+12>>2],t=i[A+16>>2];e:{if(f>>>0<t>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=t-f>>2,i[k+4>>2]=r-o,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,t=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2];r:{if(!f||(n=f<<2,!n))break r;z(e,t,n)}t=f<<2,i[A+12>>2]=t+i[A+12>>2],e=e+t|0;break e}if(f=X[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;i[e>>2]=f,f=1,e=e+4|0}o=f+o|0;continue}break}return v=k+16|0,o|0}function Jt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(e)for(f=i[A+16>>2],k=i[A+20>>2],n=i[A+4>>2],t=i[A+12>>2],r=i[A+24>>2];;){if((r|0)<=7){for(o=64-r|0,_=0,r=n;;){i:{if(B=o,!t){t=0,n=r,s=o;break i}if(n=r+1|0,i[A+4>>2]=n,r=l[r|0],t=t-1|0,i[A+12>>2]=t,s=B-8|0,w=s&31,(s&63)>>>0>=32?(h=r<<w,r=0):(h=(1<<w)-1&r>>>32-w,r=r<<w),f=r|f,r=k|h,k=r,i[A+16>>2]=f,i[A+20>>2]=r,r=o,o=r-8|0,_=_-(r>>>0<8)|0,r=n,(B|0)>15)continue}break}r=64-s|0}if(r=r-8|0,i[A+24>>2]=r,h=k<<8|f>>>24,f=f<<8,i[A+16>>2]=f,k=h,i[A+20>>2]=k,e=e-1|0,!e)break}}function wQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f;i:{if(!r){if(u[f+16|0]=0,u[f+27|0]=0,r=A,A=K(f+28|0,5,2001,f+16|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}So(f+8|0,i[e>>2]),k=i[f+8>>2];e:{if(!k){if(u[f+16|0]=0,u[f+27|0]=0,r=A,A=K(f+28|0,2,124,f+16|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}i[r>>2]=i[k+116>>2],b0(A,107712,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f+48|0}function Nt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(t=i[A+104>>2],r=i[A+108>>2],!((t|0)!=(r|0)&i[r-4>>2]==(e|0))){if(f=i[A+112>>2],f>>>0>r>>>0){i[r>>2]=1,i[r+4>>2]=e,i[A+108>>2]=r+8;return}if(r=r-t|0,o=r>>3,k=o+1|0,k>>>0>=536870912)break e;if(f=f-t|0,n=f>>2,f=f>>>0>=2147483640?536870911:n>>>0>k>>>0?n:k,f){if(f>>>0>=536870912)break i;k=E(f<<3)}else k=0;n=k+r|0,i[n>>2]=1,i[n+4>>2]=e,e=n-(o<<3)|0,r&&z(e,t,r),i[A+112>>2]=k+(f<<3),r=n+8|0,i[A+108>>2]=r,i[A+104>>2]=e,t&&Z(t),i[A+108>>2]=r;return}A=r-8|0,i[A>>2]=i[A>>2]+1;return}G0(),H()}x0(),H()}function hQ(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(S1(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+32>>2]=f;e:{if(i[e+44>>2]==4)break e;if(Q[e+52>>1]=0,A=i[A+8>>2],X[i[i[A>>2]+20>>2]](A,e,r,r,1,k),l[e+53|0]==1){if(i[e+44>>2]=3,!l[e+52|0])break e;break i}i[e+44>>2]=4}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;u[e+54|0]=1;return}A=i[A+8>>2],X[i[i[A>>2]+24>>2]](A,e,r,f,k)}}function Mt(A,e,r,f,k){var n=0,t=0,o=0;i:{e:{if(n=i[f>>2],f=i[n+104>>2],n=i[n+108>>2],(f|0)!=(n|0))for(;;){if(i[f>>2]==(r|0))break e;if(f=f+16|0,(n|0)==(f|0))break}break i}e:{r:{if(r=i[f+4>>2],f=i[f+8>>2],(r|0)==(f|0))break r;for(n=i[e+36>>2],o=i[e+40>>2]-n>>3;;){if(e=F[r+2>>1],!(e>>>0<=o>>>0&&e))break i;if(e=n+(e<<3)|0,t=i[e-8>>2],i[t+16>>2]!=(k|0)){if(r=r+4|0,(f|0)==(r|0))break r;continue}break}if(i[A>>2]=t,r=A,A=i[e-4>>2],i[r+4>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1;return}i[A>>2]=0,i[A+4>>2]=0}return}i[A>>2]=0,i[A+4>>2]=0}function Ut(A,e,r,f){var k=0,n=0;i:{if(!r){e=F[e>>1]|F[e+2>>1]<<16,Q[A>>1]=e,Q[A+2>>1]=e>>>16;break i}k=(r|0)>=127?127:r,k=(k|0)<=-128?-128:k,n=k>>31,f=(f|0)>=127?127:f,f=G(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(f|0)<=-128?-128:f)+32>>6,f=(f|0)>=4095?4095:f,n=(f|0)<=-4096?-4096:f,f=G(n,Q[e>>1]),k=f>>31,f=G(((f|0)>0)-((f|0)<0)|0,((f^k)-k|0)+127>>>8|0),f=(f|0)>=32767?32767:f,Q[A>>1]=(f|0)<=-32768?-32768:f,e=G(n,Q[e+2>>1]),f=e>>31,k=A,A=G(((e|0)>0)-((e|0)<0)|0,((e^f)-f|0)+127>>>8|0),A=(A|0)>=32767?32767:A,Q[k+2>>1]=(A|0)<=-32768?-32768:A}return(r|0)!=0}function _Q(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+100>>2]),C0(r,i[e+104>>2]),k=i[e+108>>2],t=i[e+112>>2],(k|0)!=(t|0))for(;C0(r,i[k>>2]),k=k+4|0,(t|0)!=(k|0););i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Dt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/12>>>0>=e>>>0){e&&(e=G(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],t=n-r|0,k=((t|0)/12|0)+e|0,k>>>0<357913942){if(f=(f-r|0)/12|0,n=f<<1,k=f>>>0>=178956970?357913941:k>>>0<n>>>0?n:k,k){if(k>>>0>=357913942)break i;o=E(G(k,12))}f=t+o|0,e=G(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&o0(f,0,e),n=f+G((t|0)/-12|0,12)|0,t&&z(n,r,t),i[A+8>>2]=G(k,12)+o,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}x0(),H()}function p6(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{e:{if(n=i[A>>2],t=i[A+4>>2]-n|0,r=((t|0)/12|0)+1|0,r>>>0<357913942){if(k=(i[A+8>>2]-n|0)/12|0,f=k<<1,r=k>>>0>=178956970?357913941:r>>>0<f>>>0?f:r,r>>>0>=357913942)break e;if(o=G(r,12),s=E(o),r=s+t|0,i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,f=i[e+4>>2],k=i[e>>2],(f|0)!=(k|0)){if(e=f-k|0,(e|0)<0)break i;f=E(e),i[r>>2]=f,w=e+f|0,i[r+8>>2]=w,e&&z(f,k,e),i[r+4>>2]=w}return e=r+G((t|0)/-12|0,12)|0,t&&z(e,n,t),i[A+8>>2]=o+s,r=r+12|0,i[A+4>>2]=r,i[A>>2]=e,n&&Z(n),r}G0(),H()}x0(),H()}G0(),H()}function sA(A){var e=0,r=0,f=0,k=0;if(i[A+4>>2]&&(e=i[A+308>>2],r=i[A+112>>2],r&&(f=i[r+544>>2]),X[e|0](r,A,f),i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A+72>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0),e=i[A+52>>2],k=i[A+56>>2],(e|0)!=(k|0))for(f=0;;){if(r=i[(f<<2)+e>>2],r){e=i[r+1352>>2],e&&(i[r+1356>>2]=e,Z(e)),P8(r+1340|0),e=i[r+784>>2],e&&(i[r+788>>2]=e,Z(e)),e=i[r+8>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(r),k=i[A+56>>2],e=i[A+52>>2]}if(f=f+1|0,!(f>>>0<k-e>>2>>>0))break}i[A+56>>2]=e}function BQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){t=i[n+12>>2],n=i[n+8>>2],t=t-n|0,t&&z(r,n,t),r=A,A=i[e>>2],b0(r,107712,A?A+84|0:0);break e}if(u[k|0]=0,u[k+11|0]=0,r=K(k+12|0,10,0,k),u[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],b0(n,r,A?A+84|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=k+32|0}function vQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){t=i[n+12>>2],n=i[n+8>>2],t=t-n|0,t&&z(r,n,t),r=A,A=i[e>>2],b0(r,107712,A?A+92|0:0);break e}if(u[k|0]=0,u[k+11|0]=0,r=K(k+12|0,10,0,k),u[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],b0(n,r,A?A+92|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}v=k+32|0}function Ht(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=99864,n=i[A+176>>2],n){if(e=n,r=i[A+180>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+176>>2]}i[A+180>>2]=n,Z(e)}return e=i[A+156>>2],e&&(i[A+160>>2]=e,Z(e)),e=i[A+144>>2],e&&(i[A+148>>2]=e,Z(e)),e=i[A+132>>2],e&&Z(e),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function mQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A>>2],n=l[f+20|0];i:{if((n|0)!=255){if((n|0)==1){A=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=A,u[e+19|0]<0&&Z(i[e+8>>2]),A=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=A,i[e+16>>2]=i[r+16>>2],u[r+19|0]=0,u[r+8|0]=0;break i}A=i[23607],i[k+8>>2]=i[23606],i[k+12>>2]=A,X[i[(k+8|0)+(n<<2)>>2]](k+7|0,f)}u[f+20|0]=255,A=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=A,i[f+16>>2]=i[r+16>>2],A=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=A,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,u[f+20|0]=1}v=k+16|0}function Dr(A,e,r){var f=0,k=0,n=0,t=0;t=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{f=i[A+20>>2];e:{if(!f){n=A+20|0,r=n;break e}for(;;){if(r=f,f=i[f+16>>2],f>>>0>e>>>0){if(n=r,f=i[r>>2],f)continue;break e}if(e>>>0<=f>>>0)break i;if(f=i[r+4>>2],!f)break}n=r+4|0}f=E(28),i[f+24>>2]=k,i[f+20>>2]=t,i[f+16>>2]=e,i[f+8>>2]=r,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,e=i[i[A+16>>2]>>2],e&&(i[A+16>>2]=e),m1(i[A+20>>2],f),i[A+24>>2]=i[A+24>>2]+1;return}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;X[i[i[k>>2]+8>>2]](k),p(k)}}function y6(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(n=64-k|0,k=i[A+4>>2];;){i:{if(f=n,!k){t=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],k=k-1|0,i[A+4>>2]=k,w=i[A+12>>2],t=f-8|0,o=t&31,h=A,(t&63)>>>0>=32?(s=r<<o,r=0):(s=(1<<o)-1&r>>>32-o,r=r<<o),i[h+8>>2]=r|i[A+8>>2],i[A+12>>2]=s|w,r=n,n=r-8|0,_=_-(r>>>0<8)|0,(f|0)>15)continue}break}k=64-t|0}i[A+16>>2]=k-e,n=i[A+12>>2],r=i[A+8>>2],f=e&31,(e&63)>>>0>=32?(e=r<<f,f=0):(e=(1<<f)-1&r>>>32-f|n<<f,f=r<<f),i[A+8>>2]=f,i[A+12>>2]=e}function ZQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,t=-1<<k^-1;;){if(o=(G(f,w)<<2)+r|0,h=(G(e,w)<<1)+A|0,k=0,_=0,(f|0)!=1)for(;s=h+(k<<1)|0,n=i[(k<<2)+o>>2]+F[s>>1]|0,Q[s>>1]=(n|0)>=0?(n|0)<(t|0)?n:t:0,n=k|1,s=h+(n<<1)|0,n=i[(n<<2)+o>>2]+F[s>>1]|0,Q[s>>1]=(n|0)>=0?(n|0)<(t|0)?n:t:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(n=i[(k<<2)+o>>2],o=h+(k<<1)|0,k=n+F[o>>1]|0,Q[o>>1]=(k|0)>=0?(k|0)<(t|0)?k:t:0),w=w+1|0,(w|0)==(f|0))break}}function GQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+100>>2]),C0(r,i[e+104>>2]),C0(r,i[e+108>>2]),C0(r,i[e+112>>2]),C0(r,i[e+116>>2]),C0(r,i[e+120>>2]),C0(r,i[e+124>>2]),C0(r,i[e+128>>2]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Hr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(r=i[A+108>>2],f=i[A+112>>2],r=_3(r,e,f-r>>2),r=r||f,f=i[A+112>>2],(r|0)==(f|0)){k=i[A+116>>2];r:{if(k>>>0>r>>>0){i[f>>2]=e,e=f+4|0;break r}if(t=i[A+108>>2],r=r-t|0,o=r>>2,f=o+1|0,f>>>0>=1073741824)break e;if(k=k-t|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=E(k<<2)}else f=0;if(n=f+r|0,i[n>>2]=e,o=n-(o<<2)|0,r&&z(o,t,r),i[A+116>>2]=f+(k<<2),e=n+4|0,i[A+112>>2]=e,i[A+108>>2]=o,!t)break r;Z(t)}i[A+112>>2]=e}return}G0(),H()}x0(),H()}function WQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=X[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(e,129872),e2(e);e:{if(k){X[i[i[A>>2]+24>>2]](e,A);break e}X[i[i[A>>2]+28>>2]](n+16|0,A)}for(t=n,o=T4(n+16|0),i[t+12>>2]=o;;){if(A=n+16|0,t=n,o=s6(A),i[t+8>>2]=o,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],R1(A);else{Ho(n+28|0,i[i[n+12>>2]>>2]),i[n+12>>2]=i[n+12>>2]+4;continue}break}}return v=n+32|0,r|0}function XQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+12>>2];i:{if(!n&u0[e+8>>2]>=u0[e+32>>2]|n){if(V4(r,e+100|0),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}if(u[f|0]=0,u[f+11|0]=0,K(A,2,101,f),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function gQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,28369);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function QQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10543);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function IQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10965);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function CQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=X[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(e,129864),e2(e);e:{if(k){X[i[i[A>>2]+24>>2]](e,A);break e}X[i[i[A>>2]+28>>2]](n+16|0,A)}for(t=n,o=T4(n+16|0),i[t+12>>2]=o;;){if(A=n+16|0,t=n,o=w6(A),i[t+8>>2]=o,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],s2(A);else{Zk(n+28|0,u[i[n+12>>2]]),i[n+12>>2]=i[n+12>>2]+1;continue}break}}return v=n+32|0,r|0}function VQ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;for(r=v-128|0,v=r,i[r+12>>2]=r+116,f=r+16|0,Eo(A+8|0,f,r+12|0,k,n,t),t=v-16|0,v=t,A=v-32|0,v=A,yl(A+24|0,f,i[r+12>>2]),o=i[A+28>>2],n=v-16|0,v=n,k=i[A+24>>2],i[n+8>>2]=k,i[n+12>>2]=e;;){if((k|0)!=(o|0)){Zk(n+12|0,u[k|0]),k=k+1|0,i[n+8>>2]=k;continue}break}return i[A+16>>2]=i[n+8>>2],i[A+20>>2]=i[n+12>>2],v=n+16|0,i[A+12>>2]=(i[A+16>>2]-f|0)+f,i[A+8>>2]=i[A+20>>2],i[t+8>>2]=i[A+12>>2],i[t+12>>2]=i[A+8>>2],v=A+32|0,v=t+16|0,v=r+128|0,i[t+12>>2]}function xt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/6>>>0>=e>>>0){e&&(e=G(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],t=n-r|0,k=((t|0)/6|0)+e|0,k>>>0<715827883){if(f=(f-r|0)/6|0,n=f<<1,k=f>>>0>=357913941?715827882:k>>>0<n>>>0?n:k,k){if(k>>>0>=715827883)break i;o=E(G(k,6))}f=t+o|0,e=G(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&o0(f,0,e),n=f+G((t|0)/-6|0,6)|0,t&&z(n,r,t),i[A+8>>2]=G(k,6)+o,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}x0(),H()}function d4(A,e,r,f){var k=0,n=0,t=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>>0>=f>>>0){if(t=f,k=i[A+4>>2],f=k-n|0,t>>>0>f>>>0){(k|0)!=(n|0)&&(f&&z(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||z(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||z(n,e,f),i[A+4>>2]=f+n;return}if(n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0),(f|0)>=0){n=k<<1,k=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||z(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function FQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),l[e+112|0]==1&&C0(r,i[e+108>>2]),C0(r,i[e+120>>2]-i[e+116>>2]>>3),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;C0(r,i[f>>2]),C0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function EQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0;i:{e:{if(!(u0[e+100>>2]>65535|u0[e+104>>2]>65535)){if(k=u0[e+108>>2]>65535,l2(r,k),k)break e;u2(r,F[e+100>>1]),u2(r,F[e+104>>1]),u2(r,F[e+108>>1]);break i}l2(r,1)}C0(r,i[e+100>>2]),C0(r,i[e+104>>2]),C0(r,i[e+108>>2])}f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function pQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{if(n){if((n|0)<0)break i;n=n<<2,o=E(n),i[t+4>>2]=o,s=n+o|0,i[t+12>>2]=s,n&&z(o,k,n),i[t+8>>2]=s}e=i[e>>2],k=i[e+48>>2],e=i[e+52>>2];e:{if(!e){a4(k,f,r,t+4|0);break e}if(i[e+4>>2]=i[e+4>>2]+1,a4(k,f,r,t+4|0),r=i[e+4>>2],i[e+4>>2]=r-1,r)break e;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],A=i[t+4>>2],A&&(i[t+8>>2]=A,Z(A)),v=t+16|0;return}G0(),H()}function yQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;e=v-16|0,v=e,f=i[r+16>>2],f&&(k=i[r+8>>2],k&&(c1(k,f),f=i[r+16>>2]),k=i[r>>2],t=X[i[i[k>>2]+8>>2]](k)|0,n=l0,o=f,f=f+t|0,n=o>>>0>f>>>0?n+1|0:n,X[i[i[k>>2]+20>>2]](k,f,n)|0,i[r+16>>2]=0);i:{if(l[r+20|0]==1){if(u[e+4|0]=0,u[e+15|0]=0,K(A,2,100,e+4|0),u[e+15|0]>=0)break i;Z(i[e+4>>2]);break i}if(r=i[26929],i[A>>2]=i[26928],i[A+4>>2]=r,A=A+8|0,u[107731]>=0){r=i[26931],i[A>>2]=i[26930],i[A+4>>2]=r,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=e+16|0}function YQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=X[i[i[e>>2]+52>>2]](e,r,0)|0,C4(r,e+104|0,1),k=i[e+116>>2],t=i[e+120>>2],(k|0)!=(t|0))for(;l2(r,l[k|0]),k=k+1|0,(t|0)!=(k|0););i[r+12>>2]=n,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function zt(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106720,e=i[A+304>>2],f=A+308|0,(e|0)!=(f|0))for(;;){z2(i[e+40>>2]),i[e+40>>2]=0,r=i[e+4>>2];i:{if(r){for(;;)if(e=r,r=i[e>>2],!r)break i}for(;r=e,e=i[e+8>>2],(r|0)!=i[e>>2];);}if((e|0)==(f|0))break}e=i[A+332>>2],i[A+332>>2]=0,e&&(r=i[e+4>>2],r&&(X[i[i[e>>2]+40>>2]](r),i[e+4>>2]=0),Z(e)),r=A+304|0,e=i[A+324>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return wk(r,i[A+308>>2]),ai(A)|0}function RQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,15913);break i}if(k=e,n=o2(r),Q[k+104>>1]=n,k=e,n=o2(r),Q[k+106>>1]=n,k=e,n=o2(r),Q[k+108>>1]=n,k=e,n=o2(r),Q[k+110>>1]=n,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function JQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(n=i[e>>2],k=i[n+156>>2],n=i[n+160>>2],(k|0)!=(n|0))for(;;){if(t=i[k>>2],i[t>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=E(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=t,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3448}function NQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(n=i[e>>2],k=i[n+168>>2],n=i[n+172>>2],(k|0)!=(n|0))for(;;){if(t=i[k>>2],i[t>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=E(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=t,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3423}function MQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(t|0))break i;f=i[A+12>>2],o=i[A+16>>2];e:{if(f>>>0<o>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=o-f,i[k+4>>2]=r-t,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,o=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2],n=!f,n|n||z(e,o,f),i[A+12>>2]=i[A+12>>2]+f;break e}if(f=X[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;u[e|0]=f<<24>>24,f=1}e=e+f|0,t=f+t|0;continue}break}return v=k+16|0,t|0}function UQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[t>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[t+4>>2],t=t+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}e:{if(!l[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break e;i[n>>2]=i[e+24>>2]}f&&(i[f>>2]=l[e+16|0]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];return}e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216]}function DQ(A){return A=A|0,l[129908]?i[32476]:(l[130976]||(u[130976]=1),L2(130688,84096),L2(130700,84128),L2(130712,84164),L2(130724,84188),L2(130736,84212),L2(130748,84228),L2(130760,84248),L2(130772,84268),L2(130784,84296),L2(130796,84336),L2(130808,84368),L2(130820,84404),L2(130832,84440),L2(130844,84456),L2(130856,84472),L2(130868,84488),L2(130880,84212),L2(130892,84504),L2(130904,84520),L2(130916,84536),L2(130928,84552),L2(130940,84568),L2(130952,84584),L2(130964,84600),u[129908]=1,i[32476]=130688,130688)}function HQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;if(f=v-48|0,v=f,o=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+108>>2]-i[e+104>>2]>>3),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;t=i[k>>2],X[i[i[t>>2]+20>>2]](f+28|0,t,r),u[f+47|0]<0&&Z(i[f+36>>2]),k=k+8|0,(n|0)!=(k|0););f1(f+8|0,e,r,o),u[f+27|0]<0&&Z(i[f+16>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+48|0}function xQ(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(t=14-w|0,_=k&2147483644,h=k&3,s=0,B=k>>>0<4;;){if(k=(G(f,s)<<1)+r|0,w=(G(e,s)<<1)+A|0,o=0,!B)for(;Q[w>>1]=F[k>>1]<<t,Q[w+2>>1]=F[k+2>>1]<<t,Q[w+4>>1]=F[k+4>>1]<<t,Q[w+6>>1]=F[k+6>>1]<<t,k=k+8|0,w=w+8|0,o=o+4|0,(_|0)!=(o|0););if(o=0,h)for(;Q[w>>1]=F[k>>1]<<t,k=k+2|0,w=w+2|0,o=o+1|0,(h|0)!=(o|0););if(s=s+1|0,(s|0)==(n|0))break}}function Tt(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=v-32|0,v=f,tl(f+24|0,A,e),o=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-o|0,t=k>>2;i:{if(!t||(t=t<<2,!t))break i;z(r,o,t)}return i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,o=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=tk(k,o-i[A+12>>2]>>2),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function xr(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=i[e>>2],i[k+8>>2]=i[A>>2],f=i[A+4>>2],i[k+12>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),r2(n+36|0,k+8|0),f=i[k+12>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;X[i[i[f>>2]+8>>2]](f),p(f)}f=i[e>>2],i[k+8>>2]=i[A+8>>2],e=i[A+12>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,k+8|0),e=i[k+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}i[A+16>>2]!=i[A+20>>2]&&(e=Ve(i[r>>2],A+16|0),wA(i[A+8>>2],e)),v=k+16|0}function V4(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+4>>2],t=i[A>>2],o=r-t|0,f=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0)|0;e:{if(o>>>0>=f>>>0)break e;if(k=f-o|0,n=i[A+8>>2],k>>>0<=n-r>>>0){k&&o0(r,0,k),i[A+4>>2]=r+k;break e}if((f|0)<0)break i;if(r=n-t|0,n=r<<1,n=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r=E(n),k&&o0(r+o|0,0,k),o&&z(r,t,o),i[A+8>>2]=r+n,i[A+4>>2]=r+f,i[A>>2]=r,!t)break e;Z(t)}f=i[e>>2],k=i[e+4>>2]-f|0,k&&z(i[A>>2]+i[A+12>>2]|0,f,k),i[A+12>>2]=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0);return}G0(),H()}function zQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{e:{r:{if(!k||(k=X0(k,106612,106744),!k))break r;if(e&&(i[e+4>>2]=i[e+4>>2]+1),r&&(Q[r>>1]=F[k+288>>1]),f&&(Q[f>>1]=F[k+290>>1]),r=i[24176],i[A>>2]=i[24175],i[A+4>>2]=r,i[A+8>>2]=i[24177],!e)break i;if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break e;X[i[i[e>>2]+8>>2]](e),p(e);break e}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24780,!e)break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;X[i[i[e>>2]+8>>2]](e),p(e)}}function zr(A,e){var r=0,f=0,k=0,n=0;if(f=v-16|0,v=f,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,r=i[A+28>>2],k=i[A+32>>2],(r|0)!=(k|0)){for(;i[r>>2]!=i[e>>2]&&r2(f+4|0,r),r=r+8|0,(k|0)!=(r|0););r=i[A+28>>2]}if(r){if(k=r,e=i[A+32>>2],(r|0)!=(e|0)){for(;;){n=i[e-4>>2];i:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break i;X[i[i[n>>2]+8>>2]](n),p(n)}if(e=e-8|0,(r|0)==(e|0))break}k=i[A+28>>2]}i[A+32>>2]=r,Z(k)}i[A+28>>2]=i[f+4>>2],i[A+32>>2]=i[f+8>>2],i[A+36>>2]=i[f+12>>2],v=f+16|0}function St(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;if(k=i[A+24>>2],n=i[A+28>>2],k>>>0<n>>>0){i[k+8>>2]=f,i[k+4>>2]=r,i[k>>2]=e,i[A+24>>2]=k+12;return}i:{if(s=i[A+20>>2],k=k-s|0,t=((k|0)/12|0)+1|0,t>>>0<357913942){if(n=(n-s|0)/12|0,o=n<<1,o=n>>>0>=178956970?357913941:o>>>0>t>>>0?o:t,o){if(o>>>0>=357913942)break i;t=E(G(o,12))}else t=0;n=t+k|0,i[n+8>>2]=f,i[n+4>>2]=r,i[n>>2]=e,e=n+G((k|0)/-12|0,12)|0,k&&z(e,s,k),i[A+28>>2]=t+G(o,12),r=n+12|0,i[A+24>>2]=r,i[A+20>>2]=e,s&&Z(s),i[A+24>>2]=r;return}G0(),H()}x0(),H()}function TQ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,W=0,g=0;if(!(n&1)){if(!((t|0)<=0|(n|0)<=0))for(W=15-o|0,g=1<<14-o,h=-1<<o^-1;;){for(o=(G(e,_)<<1)+A|0,s=G(k,_)<<1,B=s+f|0,s=r+s|0,m=0;w=Q[B>>1]+(Q[s>>1]+g|0)>>W,Q[o>>1]=(w|0)>=0?(w|0)<(h|0)?w:h:0,w=Q[B+2>>1]+(Q[s+2>>1]+g|0)>>W,Q[o+2>>1]=(w|0)>=0?(w|0)<(h|0)?w:h:0,B=B+4|0,s=s+4|0,o=o+4|0,m=m+2|0,(m|0)<(n|0););if(_=_+1|0,(_|0)==(t|0))break}return}M0(22018,18227,238,10389),H()}function SQ(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+104>>2],r=i[r+108>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=X0(f,86628,89152),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=i[f+104>>2],i[e>>2]=i[f+100>>2],i[e+4>>2]=A,A=i[f+120>>2],i[e+16>>2]=i[f+116>>2],i[e+20>>2]=A,A=i[f+112>>2],i[e+8>>2]=i[f+108>>2],i[e+12>>2]=A),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return X[i[i[r>>2]+8>>2]](r),p(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function jQ(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,Br(f,A,1),A=-1,r=l[e+124|0],!r){Q[e+24>>1]=0,o0(e+28|0,0,72),N7(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,i[e+64>>2]-r>>>0<5))break i;A=l[r+6|0]}u[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=l[e+124|0]}return(r|0)!=255&&(f=i[24753],i[e+24>>2]=i[24752],i[e+28>>2]=f,X[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function OQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,W=0;if((e|0)>=2)for(h=(e|0)/2|0,_=e&2147483646,B=e&1;;){for(n=(G(e,o)<<1)+A|0,m=n+2|0,s=(G(e-o|0,e)<<1)+A|0,r=0,t=0;f=r<<1,k=f+n|0,W=F[k>>1],w=k,k=((r^-1)<<1)+s|0,Q[w>>1]=F[k>>1],Q[k>>1]=W,f=f+m|0,k=F[f>>1],w=f,f=((r^2147483646)<<1)+s|0,Q[w>>1]=F[f>>1],Q[f>>1]=k,r=r+2|0,t=t+2|0,(_|0)!=(t|0););if(B&&(n=n+(r<<1)|0,t=F[n>>1],r=((r^-1)<<1)+s|0,Q[n>>1]=F[r>>1],Q[r>>1]=t),o=o+1|0,(h|0)==(o|0))break}}function LQ(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,Br(f,A,1),A=-1,r=l[e+124|0],!r){Q[e+24>>1]=0,o0(e+28|0,0,72),N7(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,(r|0)==i[e+64>>2]))break i;A=l[r+2|0]}u[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=l[e+124|0]}return(r|0)!=255&&(f=i[24753],i[e+24>>2]=i[24752],i[e+28>>2]=f,X[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function PQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,t=-1<<k^-1;;){if(o=G(e,w)+A|0,h=(G(f,w)<<2)+r|0,k=0,_=0,(f|0)!=1)for(;s=k+o|0,n=i[(k<<2)+h>>2]+l[s|0]|0,u[s|0]=(n|0)>=0?(n|0)<(t|0)?n:t:0,n=k|1,s=n+o|0,n=i[(n<<2)+h>>2]+l[s|0]|0,u[s|0]=(n|0)>=0?(n|0)<(t|0)?n:t:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(o=k+o|0,k=i[(k<<2)+h>>2]+l[o|0]|0,u[o|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),w=w+1|0,(w|0)==(f|0))break}}function qQ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(t=14-o|0,_=k&2147483644,h=k&3,B=k>>>0<4;;){if(k=(G(e,w)<<1)+A|0,o=(G(f,w)<<1)+r|0,s=0,!B)for(;Q[k>>1]=F[o>>1]<<t,Q[k+2>>1]=F[o+2>>1]<<t,Q[k+4>>1]=F[o+4>>1]<<t,Q[k+6>>1]=F[o+6>>1]<<t,k=k+8|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;Q[k>>1]=F[o>>1]<<t,k=k+2|0,o=o+2|0,s=s+1|0,(h|0)!=(s|0););if(w=w+1|0,(w|0)==(n|0))break}}function KQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+97|0]|128),l2(r,l[e+99|0]&31|l[e+98|0]<<5&224),l2(r,(l[e+106|0]&3|((l[e+101|0]?64:0)|(l[e+100|0]?-128:0)|(l[e+102|0]?32:0)|(l[e+103|0]?16:0)|(l[e+104|0]?8:0)|(l[e+105|0]?4:0)))&255),l2(r,0),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function aQ(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,X[i[i[A>>2]+112>>2]](e+12|0,A);i:{e:{r:switch(l[e+32|0]){default:_2(),H();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=X[i[i[r>>2]+12>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=X[i[i[r>>2]+12>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=l[e+32|0],(A|0)==255)break i}f=i[25189],i[e+40>>2]=i[25188],i[e+44>>2]=f,X[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function $Q(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,X[i[i[A>>2]+112>>2]](e+12|0,A);i:{e:{r:switch(l[e+32|0]){default:_2(),H();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=X[i[i[r>>2]+16>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=X[i[i[r>>2]+16>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=l[e+32|0],(A|0)==255)break i}f=i[25189],i[e+40>>2]=i[25188],i[e+44>>2]=f,X[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function dQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if((r|0)>0)for(h=r&2147483644,s=r&3,_=r>>>0<4;;){if(w=G(r,o),k=0,n=0,!_)for(;f=k+w|0,i[(f<<2)+A>>2]=Q[(f<<1)+e>>1],t=f+1|0,i[(t<<2)+A>>2]=Q[(t<<1)+e>>1],t=f+2|0,i[(t<<2)+A>>2]=Q[(t<<1)+e>>1],f=f+3|0,i[(f<<2)+A>>2]=Q[(f<<1)+e>>1],k=k+4|0,n=n+4|0,(h|0)!=(n|0););if(f=0,s)for(;n=k+w|0,i[(n<<2)+A>>2]=Q[(n<<1)+e>>1],k=k+1|0,f=f+1|0,(s|0)!=(f|0););if(o=o+1|0,(o|0)==(r|0))break}}function cQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),u[e+104|0]=1,n=e,t=R4(r),i[n+112>>2]=t,i[e+116>>2]=l0,k=W2(r),u[e+120|0]=k>>>7,u[e+122|0]=k>>>5&1,u[e+121|0]=k>>>6&1;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function bQ(A){return A=A|0,l[129900]?i[32474]:(l[130672]||(u[130672]=1),R2(130384,1619),R2(130396,1610),R2(130408,10876),R2(130420,9865),R2(130432,1753),R2(130444,12843),R2(130456,1627),R2(130468,3344),R2(130480,7604),R2(130492,7497),R2(130504,7595),R2(130516,7614),R2(130528,9340),R2(130540,18372),R2(130552,7720),R2(130564,6303),R2(130576,1753),R2(130588,7998),R2(130600,9809),R2(130612,10937),R2(130624,7916),R2(130636,4235),R2(130648,3094),R2(130660,18162),u[129900]=1,i[32474]=130384,130384)}function iI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=R4(r),i[k+112>>2]=n,i[e+116>>2]=l0,k=e,n=F0(r),i[k+120>>2]=n,k=e,n=F0(r),i[k+124>>2]=n,k=e,n=W2(r),u[k+128|0]=n;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function eI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-16|0,v=f;i:{if(W2(r)&1){n=e,t=F0(r),i[n+100>>2]=t,n=e,t=F0(r),i[n+104>>2]=t,k=F0(r);break i}n=e,t=o2(r),i[n+100>>2]=t,n=e,t=o2(r),i[n+104>>2]=t,k=o2(r)}i[e+108>>2]=k;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function rI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=i[A>>2],A=i[k+260>>2],o=i[k+264>>2];i:{if((A|0)==(o|0))break i;if(e)for(;;){k=i[A>>2],t=u[k+15|0],s=(t|0)<0,t=s?i[k+8>>2]:t;e:{if((t|0)!=(h2(e)|0)||N2(s?i[k+4>>2]:k+4|0,e,t))break e;if((f|0)<=(n|0))break i;i[(n<<2)+r>>2]=i[k>>2],n=n+1|0}if(A=A+8|0,(o|0)==(A|0))break i}for(e=(f|0)>0?f:0;;){if((e|0)==(n|0))return e|0;if(i[(n<<2)+r>>2]=i[i[A>>2]>>2],n=n+1|0,A=A+8|0,(o|0)==(A|0))break}}return n|0}function ti(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=al(e),k=v-16|0,v=k;i:{if(f>>>0<=1073741815){e:{if(f>>>0<2){u[A+11|0]=l[A+11|0]&128|f&127,u[A+11|0]=l[A+11|0]&127,r=A;break e}o=k+8|0,f>>>0>=2?(t=f+2&-2,r=t-1|0,r=(r|0)==2?t:r):r=1,Ei(o,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}e:{if(!f||(A=f<<2,!A))break e;z(r,e,A)}i[k+4>>2]=0,i[(f<<2)+r>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}v=n+16|0}function fI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+108>>2]),C0(r,i[e+112>>2]),C0(r,i[e+116>>2]),C0(r,i[e+120>>2]),C4(r,e+124|0,1),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function AI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+104>>2]-i[e+100>>2]|0)/6&65535),f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,F[f>>1]),u2(r,F[f+2>>1]),u2(r,F[f+4>>1]),f=f+6|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Q8(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t,D2(+e),r=t2(1)|0,k=t2(0)|0,w=r,n=r&1048575,f=k,r=r>>>20&2047,k=0;i:{if(r|k){if((r|0)!=2047|k){o=(n&15)<<28|f>>>4,s=n>>>4|0,r=r+15360|0,k=f<<28,f=0;break i}o=(n&15)<<28|f>>>4,s=n>>>4|0,r=32767,k=f<<28,f=0;break i}if(!(n|f)){r=0,f=0;break i}k=n,n=k1(n),r=(n|0)==32?k1(f)+32|0:n,o4(t,f,k,0,0,r+49|0),o=i[t+8>>2],s=i[t+12>>2]^65536,r=15372-r|0,k=i[t+4>>2],f=i[t>>2]}i[A>>2]=f,i[A+4>>2]=k,i[A+8>>2]=o,i[A+12>>2]=s|(w&-2147483648|r<<16),v=t+16|0}function kI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+108>>2]-i[e+104>>2]|0)/6&65535),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;u2(r,F[f>>1]),l2(r,l[f+2|0]),u2(r,F[f+4>>1]),f=f+6|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function nI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;i:{if(l[e+76|0]==1){if(u[e+76|0]=0,u[A+44|0]=0,u[A|0]=0,l[e+72|0]!=1)break i;i[A>>2]=i[e+28>>2],i[A+4>>2]=i[e+32>>2],i[A+8>>2]=i[e+36>>2],i[e+36>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[A+12>>2]=i[e+40>>2],i[A+16>>2]=i[e+44>>2],i[A+20>>2]=i[e+48>>2],i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,r=i[e+60>>2],f=i[e+64>>2],k=i[e+68>>2],n=i[e+52>>2],e=i[e+56>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e;return}u[A+44|0]=0,u[A|0]=0}}function tI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(k=i[e>>2],!l[k+288|0]){if(u[f|0]=0,u[f+11|0]=0,r=K(f+12|0,5,138,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}t0[r>>3]=t0[k+296>>3],t0[r+8>>3]=t0[k+304>>3],t0[r+16>>3]=t0[k+312>>3],t0[r+24>>3]=t0[k+320>>3],t0[r+32>>3]=t0[k+328>>3],i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}v=f+32|0}function uI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,(i[e+108>>2]-i[e+104>>2]|0)/12|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;C0(r,i[f>>2]),C0(r,i[f+4>>2]),C0(r,i[f+8>>2]),f=f+12|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function Y6(A,e,r,f,k,n){var t=0,o=0,s=0,w=0;i:{if(n&64){r=n+-64|0,e=r&31,(r&63)>>>0>=32?(r=0,e=k>>>e|0):(r=k>>>e|0,e=((1<<e)-1&k)<<32-e|f>>>e),f=0,k=0;break i}if(!n)break i;s=f,o=64-n|0,t=o&31,(o&63)>>>0>=32?(o=f<<t,w=0):(o=(1<<t)-1&s>>>32-t|k<<t,w=s<<t),s=e,e=n&31,(n&63)>>>0>=32?(t=0,e=r>>>e|0):(t=r>>>e|0,e=((1<<e)-1&r)<<32-e|s>>>e),e=w|e,r=t|o,t=f,f=n&31,(n&63)>>>0>=32?(o=0,f=k>>>f|0):(o=k>>>f|0,f=((1<<f)-1&k)<<32-f|t>>>f),k=o}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function oI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+108>>2]);i:{if(i[e+104>>2]||(k=i[e+112>>2],n=i[e+116>>2],(k|0)==(n|0)))break i;for(;C0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););}f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function lI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-32|0,v=r,f=i[A>>2];i:{e:{r:{if(e){if(A=h2(e),A>>>0>=2147483640)break i;f:{A:{if(A>>>0>=11){n=A|7,k=E(n+1|0),i[r+28>>2]=n-2147483647,i[r+20>>2]=k,i[r+24>>2]=A;break A}if(u[r+31|0]=A,k=r+20|0,!A)break f}if(!A)break f;z(k,e,A)}if(u[A+k|0]=0,A=r+20|0,X[i[i[f>>2]+36>>2]](f,A),u[r+31|0]>=0)break e;break r}if(i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,A=r+8|0,X[i[i[f>>2]+36>>2]](f,A),u[r+19|0]>=0)break e}Z(i[A>>2])}v=r+32|0;return}g0(),H()}function ue(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(!f){k=i[A+12>>2],f=i[A+8>>2],A=k-f>>2;break e}if(f=i[A+8>>2],k=i[A+12>>2],(f|0)==(k|0)){A=0;break e}for(A=k-f>>2,o=A>>>0<=1?1:A;;){if(t=i[(n<<2)+f>>2],!(i[t+96>>2]!=(e|0)|i[t+108>>2]<=(r|0))&i[t+100>>2]==2)break i;if(n=n+1|0,(o|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(t=A>>>0<=1?1:A,A=0;;){if(k=i[(A<<2)+f>>2],!(i[k+96>>2]!=(e|0)|i[k+108>>2]<=(r|0)|!i[k+100>>2]))return A;if(A=A+1|0,(t|0)==(A|0))break}}return n}function sI(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0;if(!((n|0)<=0|(k|0)<=0))for(h=k&2147483644,w=k&3,s=0,_=k>>>0<4;;){if(k=G(f,s)+r|0,t=(G(e,s)<<1)+A|0,o=0,!_)for(;Q[t>>1]=l[k|0]<<6,Q[t+2>>1]=l[k+1|0]<<6,Q[t+4>>1]=l[k+2|0]<<6,Q[t+6>>1]=l[k+3|0]<<6,k=k+4|0,t=t+8|0,o=o+4|0,(h|0)!=(o|0););if(o=0,w)for(;Q[t>>1]=l[k|0]<<6,k=k+1|0,t=t+2|0,o=o+1|0,(w|0)!=(o|0););if(s=s+1|0,(s|0)==(n|0))break}}function wI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(!S4(i[e>>2])){if(u[f|0]=0,u[f+11|0]=0,r=K(f+12|0,10,0,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=F[k+10>>1]|F[k+12>>1]<<16,i[f>>2]=F[k+6>>1]|F[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Gn(k,f,r),r=A,A=i[e>>2],b0(r,k,A?A+84|0:0),u[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function hI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(!S4(i[e>>2])){if(u[f|0]=0,u[f+11|0]=0,r=K(f+12|0,10,0,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+92|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=F[k+10>>1]|F[k+12>>1]<<16,i[f>>2]=F[k+6>>1]|F[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Gn(k,f,r),r=A,A=i[e>>2],b0(r,k,A?A+92|0:0),u[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function jt(A,e){var r=0,f=0,k=0;i:{e:{r:{if(f=e&255,f){if(A&3)for(;;){if(r=l[A|0],!r|(r|0)==(f|0))break i;if(A=A+1|0,!(A&3))break}if(r=i[A>>2],((r|16843008-r)&-2139062144)!=-2139062144)break r;for(k=G(f,16843009);;){if(f=r^k,((16843008-f|f)&-2139062144)!=-2139062144)break r;if(r=i[A+4>>2],f=A+4|0,A=f,((16843008-r|r)&-2139062144)!=-2139062144)break}break e}return h2(A)+A|0}f=A}for(;;){if(A=f,r=l[A|0],!r)break i;if(f=A+1|0,(r|0)==(e&255))break}}return A}function Ot(A){var e=0,r=0,f=0,k=0,n=0;return f=v-16|0,v=f,A=R0(A),i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A>>2]=71344,o0(A+52|0,0,40),u[A+98|0]=0,Q[A+96>>1]=0,i[A+92>>2]=32,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=Kl(i[r>>2],l1(129816)),e2(r),e&&(r=f+8|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),k=A,n=c0(r,129816),i[k+68>>2]=n,e2(r),e=i[A+68>>2],k=A,n=X[i[i[e>>2]+28>>2]](e)|0,u[k+98|0]=n),X[i[i[A>>2]+12>>2]](A,0,4096)|0,v=f+16|0,A}function Lt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;f=v-16|0,v=f,G1(f+8|0,A);i:{if(!l[f+8|0]||(r=i[i[A>>2]-12>>2]+A|0,t=i[r+4>>2],n=f+4|0,r=i[r+28>>2],i[n>>2]=r,(r|0)!=129624&&(i[r+4>>2]=i[r+4>>2]+1),r=c0(n,129488),e2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],k=i[i[A>>2]-12>>2]+A|0,o=t6(k),s=k,k=e&65535,w=e,e=t&74,h=f,_=X[i[i[r>>2]+16>>2]](r,i[f>>2],s,o,(e|0)==64||(e|0)==8?k:w)|0,i[h+4>>2]=_,i[n>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(f+8|0),v=f+16|0,A}function _I(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(t=i[r+12>>2],!(i[r>>2]==1&i[r+4>>2]==3)|(t|0)<=8)break i;e:switch(o=F[f+20>>1],o-11|0){case 0:case 3:break i;default:break e}n=i[f+4>>2],(!l[k+12|0]|i[k+4>>2]==1)&(n|0)!=3||(n=3),r=l[r+8|0],k=i[f+16>>2],f=l[f+22|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=f,Q[e+20>>1]=o,i[e+16>>2]=k,i[e+12>>2]=t,u[e+8|0]=r,i[e+4>>2]=n,i[e>>2]=0,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function u2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+4>>2],t=i[A>>2],o=r-t|0,f=i[A+12>>2]+2|0;e:{if(o>>>0>=f>>>0)break e;if(n=f-o|0,k=i[A+8>>2],n>>>0<=k-r>>>0){n&&o0(r,0,n),i[A+4>>2]=r+n;break e}if((f|0)<0)break i;if(r=k-t|0,k=r<<1,k=r>>>0>=1073741823?2147483647:f>>>0<k>>>0?k:f,r=E(k),n&&o0(r+o|0,0,n),o&&z(r,t,o),i[A+8>>2]=r+k,i[A+4>>2]=r+f,i[A>>2]=r,!t)break e;Z(t)}f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=e>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=e;return}G0(),H()}function Pt(A,e,r){var f=0,k=0,n=0,t=0,o=0;return n=v-16|0,v=n,f=v-32|0,v=f,tl(f+24|0,A,e),t=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-t|0,o=!k,o|o||z(r,t,k),i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,t=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=lk(k,t-i[A+12>>2]|0),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function BI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,k=v-32|0,v=k,Rt(k+8|0,e,r,f,0);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(C0(r,i[e+100>>2]|l[e+97|0]<<24),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function r4(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-32|0,v=k;i:{e:{n=i[e+20>>2];r:{if(!n)break r;for(t=e+20|0,e=t;o=u0[n+16>>2]<r>>>0,e=o?e:n,n=i[(o?4:0)+n>>2],!!n;);if((e|0)==(t|0))break r;if(u0[e+16>>2]<=r>>>0)break e}i[A>>2]=0,i[A+4>>2]=0;break i}if(r=i[e+20>>2],X[i[i[r>>2]+52>>2]](k+12|0,r),r=!i[k+12>>2]|f,u[k+31|0]<0&&Z(i[k+20>>2]),!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=k+32|0}function vI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,l9(k+8|0,e);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(e=i[e+76>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function F4(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{if(e){if(r=i[A+44>>2],k=i[A+40>>2],t=r-k|0,o=t>>2,o>>>0<=15){if(f=i[A+48>>2],f>>>0>r>>>0){i[r>>2]=e,i[A+44>>2]=r+4;return}if(r=f-k|0,f=r>>1,n=o+1|0,r=r>>>0>=2147483644?1073741823:f>>>0>n>>>0?f:n,r>>>0>=1073741824)break i;f=r<<2,n=E(f),r=n+t|0,i[r>>2]=e,e=r-(o<<2)|0,t&&z(e,k,t),i[A+48>>2]=f+n,r=r+4|0,i[A+44>>2]=r,i[A+40>>2]=e,k&&Z(k),i[A+44>>2]=r;return}Z(i[e+20>>2]),A=i[e+32>>2],A&&(i[e+36>>2]=A,Z(A)),Z(e)}return}x0(),H()}function qt(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{if(!e)break i;A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];e:{if(!A){AA(k+4|0,f);break e}if(i[A+4>>2]=i[A+4>>2]+1,AA(k+4|0,f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;X[i[i[A>>2]+8>>2]](A),p(A)}e:{r:{if(n=i[k+4>>2],f=i[k+8>>2]-n>>2,(f|0)<=0)break r;for(A=0;;){if((A|0)==(r|0)){f=r;break r}if(t=A<<2,i[t+e>>2]=i[n+t>>2],A=A+1|0,(f|0)==(A|0))break}break e}if(!n)break i}i[k+8>>2]=n,Z(n)}return v=k+16|0,f|0}function mI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,3635);break i}if(k=F0(r),u[e+104|0]=k>>>31,u[e+106|0]=k>>>26&15,u[e+105|0]=k>>>30&1,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Tr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(e=jt(A,61),(e|0)==(A|0))return 0;k=e-A|0;i:{if(l[k+A|0]||(f=i[31337],!f)||(r=i[f>>2],!r))break i;for(;;){e:{n=A,t=k,e=0;r:{if(!k)break r;if(e=l[A|0],e)f:{for(;;){if(o=l[r|0],(o|0)!=(e|0)|!o||(t=t-1|0,!t))break f;if(r=r+1|0,e=l[n+1|0],n=n+1|0,!e)break}e=0}else e=0;e=e-l[r|0]|0}if(!e&&(e=i[f>>2]+k|0,l[e|0]==61))break e;if(r=i[f+4>>2],f=f+4|0,r)continue;break i}break}s=e+1|0}return s}function o4(A,e,r,f,k,n){var t=0,o=0,s=0;i:{if(n&64){k=n+-64|0,n=e,f=k&31,(k&63)>>>0>=32?(k=n<<f,f=0):(k=(1<<f)-1&n>>>32-f|r<<f,f=n<<f),e=0,r=0;break i}if(!n)break i;o=f,t=n&31,(n&63)>>>0>=32?(s=f<<t,o=0):(s=(1<<t)-1&o>>>32-t|k<<t,o=o<<t),t=e,k=64-n|0,f=k&31,(k&63)>>>0>=32?(k=0,f=r>>>f|0):(k=r>>>f|0,f=((1<<f)-1&r)<<32-f|t>>>f),f=o|f,k=k|s,o=e,t=n&31,(n&63)>>>0>=32?(s=e<<t,e=0):(s=(1<<t)-1&o>>>32-t|r<<t,e=o<<t),r=s}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function ZI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+108>>2]-i[e+104>>2]>>2),i[e+124>>2]=i[r+12>>2],k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;C0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Kt(A){return u[A+316|0]=0,Q[A+314>>1]=0,i[A+60>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,o0(A+116|0,0,164),i[A+108>>2]=0,i[A+112>>2]=0,i[A>>2]=-1,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0,i[A+72>>2]=0,i[A+320>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+280>>2]=0,i[A+284>>2]=0,i[A+288>>2]=0,i[A+292>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,u[A+312|0]=2,u[A+104|0]=0,i[A+100>>2]=0,i[A+92>>2]=-1,i[A+96>>2]=-1,i[A+340>>2]=0,i[A+332>>2]=0,i[A+336>>2]=0,i[A+324>>2]=0,i[A+328>>2]=0,A}function n6(A){var e=0,r=0,f=0;if(!A){if(A=i[26884],A&&(e=n6(A)),A=i[26846],A&&(e=n6(A)|e),A=i[31339],A)for(;i[A+20>>2]!=i[A+28>>2]&&(e=n6(A)|e),A=i[A+56>>2],!!A;);return e}f=i[A+76>>2]<0;i:{e:{if(i[A+20>>2]==i[A+28>>2]||(X[i[A+36>>2]](A,0,0)|0,i[A+20>>2]))break e;e=-1;break i}if(e=i[A+8>>2],r=i[A+4>>2],(e|0)!=(r|0)&&(e=r-e|0,X[i[A+40>>2]](A,e,e>>31,1)|0),e=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,f)break i}return e}function GI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,EA(r+4|0,i[A>>2]),A=i[r+8>>2],k=i[r+4>>2];i:{e:{if((A|0)!=(k|0)){f=k;r:{f:{for(;;){if(i[i[f>>2]+116>>2]==(e|0))break f;if(f=f+8|0,(f|0)==(A|0))break}f=0;break r}f=1}if(!k)break i;for(;;){e=i[A-4>>2];r:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break r;X[i[i[e>>2]+8>>2]](e),p(e)}if(A=A-8|0,(k|0)==(A|0))break}A=i[r+4>>2];break e}if(A=k,!A)break i}i[r+8>>2]=k,Z(A)}return v=r+16|0,f|0}function at(A){var e=0,r=0;e=E(128),r=e+32|0,i[r>>2]=0,i[r+4>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=90172,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,Q[e+112>>1]=0,i[e+16>>2]=87652,i[e+32>>2]=1769173093,i[A+4>>2]=e,i[A>>2]=e+16}function WI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,e4(r,i[e+112>>2],i[e+116>>2]),C0(r,i[e+120>>2]),C0(r,i[e+124>>2]),l2(r,l[e+128|0]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function XI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k,i[k+16>>2]=e,f=i[A+48>>2],i[k+20>>2]=r-((f|0)!=0),t=i[A+44>>2],i[k+28>>2]=f,i[k+24>>2]=t;i:{e:{if(f=C7(i[A+60>>2],k+16|0,2,k+12|0)|0,f?(i[31336]=f,f=-1):f=0,f)e=32;else{if(f=i[k+12>>2],(f|0)>0)break e;e=f?32:16}i[A>>2]=e|i[A>>2];break i}if(n=f,t=i[k+20>>2],t>>>0>=f>>>0)break i;n=i[A+44>>2],i[A+4>>2]=n,i[A+8>>2]=n+(f-t|0),i[A+48>>2]&&(i[A+4>>2]=n+1,u[(e+r|0)-1|0]=l[n|0]),n=r}return v=k+32|0,n|0}function Sr(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:switch(r=l[e|0],f=l[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;default:break i}u[A+32|0]=l[e+32|0]}r=i[e+20>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=r,r=i[e+28>>2],i[A+24>>2]=i[e+24>>2],i[A+28>>2]=r}i[A+12>>2]=i[e+12>>2]}i[A+4>>2]=i[e+4>>2],u[A+8|0]=l[e+8|0]}u[A+3|0]=l[e+3|0]}u[A+2|0]=l[e+2|0]}u[A+1|0]=l[e+1|0]}}function wA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+132>>2],f=i[A+136>>2],r>>>0<f>>>0){i[r>>2]=e,i[r+4>>2]=0,i[A+132>>2]=r+8;return}i:{if(k=r,r=i[A+128>>2],t=k-r|0,o=t>>3,n=o+1|0,n>>>0<536870912){if(f=f-r|0,k=f>>2,n=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,n){if(n>>>0>=536870912)break i;k=E(n<<3)}else k=0;f=k+t|0,i[f>>2]=e,i[f+4>>2]=0,e=f-(o<<3)|0,t&&z(e,r,t),i[A+136>>2]=k+(n<<3),t=f+8|0,i[A+132>>2]=t,i[A+128>>2]=e,r&&Z(r),i[A+132>>2]=t;return}G0(),H()}x0(),H()}function gI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+108>>2]-i[e+104>>2]>>3),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;C0(r,i[f>>2]),C0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function QI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,9349);break i}e:{if(!k){k=o2(r);break e}k=F0(r)}if(i[e+104>>2]=k,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function II(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(u[A+121|0]=0,u[A+122|0]=0,u[A+123|0]=0,u[A+124|0]=0,e=l[A+120|0],r=e>>>0<=2?2:e,n=e,t=i[A+108>>2],e=i[A+104>>2],r=t-e>>>0>2097120?r:n,(e|0)==(t|0))f=4;else{for(;r=u0[e>>2]>65535&&(r|0)<=2?2:r,r=l[e+4|0]&&(r|0)<=1?1:r,o=i[e+16>>2],f=f+i[o+20>>2]|0,n=k,k=k+i[o+16>>2]|0,f=n>>>0>k>>>0?f+1|0:f,e=e+32|0,(t|0)!=(e|0););f=(f-(k>>>0<4026531840)|0)!=-1?8:4}u[A+121|0]=4,u[A+122|0]=4,u[A+123|0]=f,u[A+97|0]=r}function CI(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!(n&1)){if(!((t|0)<=0|(n|0)<=0))for(;;){for(h=G(e,w)+A|0,s=G(k,w)<<1,_=s+f|0,s=r+s|0,B=0;o=(Q[s>>1]+Q[_>>1]|0)- -64>>7,o=(o|0)>=255?255:o,u[h|0]=(o|0)>0?o:0,o=(Q[s+2>>1]+Q[_+2>>1]|0)- -64>>7,o=(o|0)>=255?255:o,u[h+1|0]=(o|0)>0?o:0,_=_+4|0,s=s+4|0,h=h+2|0,B=B+2|0,(B|0)<(n|0););if(w=w+1|0,(w|0)==(t|0))break}return}M0(22018,18227,105,10238),H()}function oe(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=h2(e),k=v-16|0,v=k;i:{if(f>>>0<=2147483639){e:{if(f>>>0<11){u[A+11|0]=l[A+11|0]&128|f&127,u[A+11|0]=l[A+11|0]&127,r=A;break e}o=k+8|0,f>>>0>=11?(t=f+8&-8,r=t-1|0,r=(r|0)==11?t:r):r=10,Fi(o,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}A=!f,A|A||z(r,e,f),u[k+7|0]=0,u[f+r|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}v=n+16|0}function VI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(n=v-16|0,v=n;;){i:{if((r|0)<=(t|0))break i;if(f=i[A+24>>2],k=i[A+28>>2],f>>>0>=k>>>0){if((X[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)break i;t=t+1|0,e=e+4|0}else{i[n+12>>2]=k-f>>2,i[n+8>>2]=r-t,f=v-16|0,v=f,v=f+16|0,k=i[A+24>>2],f=n+8|0,o=n+12|0,f=i[(i[f>>2]<i[o>>2]?f:o)>>2];e:{if(!f||(o=f<<2,!o))break e;z(k,e,o)}k=f<<2,i[A+24>>2]=k+i[A+24>>2],t=f+t|0,e=e+k|0}continue}break}return v=n+16|0,t|0}function hA(A,e,r){var f=0,k=0;f=(r|0)!=0;i:{e:{r:{if(!(A&3)|!r)break r;for(k=e&255;;){if((k|0)==l[A|0])break e;if(r=r-1|0,f=(r|0)!=0,A=A+1|0,!(A&3))break r;if(!r)break}}if(!f)break i;if(f=e&255,!((f|0)==l[A|0]|r>>>0<4))for(f=G(f,16843009);;){if(k=f^i[A>>2],((16843008-k|k)&-2139062144)!=-2139062144)break e;if(A=A+4|0,r=r-4|0,!(r>>>0>3))break}if(!r)break i}for(e=e&255;;){if((e|0)==l[A|0])return A;if(A=A+1|0,r=r-1|0,!r)break}}return 0}function $t(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(i[A>>2]=86432,l[A+132|0]==1&&(e=y_(-100,A+140|0,0)|0,e>>>0>=4294963201&&(i[31336]=0-e)),k=i[A+104>>2],k){if(e=k,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){if(t=f-16|0,n=i[t>>2],n){if(o=f-12|0,e=i[o>>2],r=n,(e|0)!=(r|0)){for(;r=i[e-16>>2],r&&(i[e-12>>2]=r,Z(r)),e=e-40|0,(n|0)!=(e|0););r=i[t>>2]}i[o>>2]=n,Z(r)}if(f=f-32|0,(k|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=k,Z(e)}return A2(A)|0}function FI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,12838);break i}if(k=e,n=F0(r),i[k+104>>2]=n,k=e,n=F0(r),i[k+108>>2]=n,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function EI(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0;o=v-32|0,v=o;i:{e:{if(n&&(h2(n)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26271;break i}s=o+12|0,w=r,r=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),ci(s,i[e>>2],w,f,k,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),t,0,0);e:{if(i[o+12>>2]!=i[26928]){b0(A,s,i[e>>2]);break e}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}if(u[o+31|0]>=0)break i;Z(i[o+20>>2])}v=o+32|0}function dt(A,e){var r=0;r=E(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92572,e=i[e>>2],i[r+32>>2]=0,i[r+36>>2]=0,i[r- -64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+124>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,i[r+16>>2]=86772,i[r+32>>2]=e,i[A+4>>2]=r,i[A>>2]=r+16}function pI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=100304;i:{if(l[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function yI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99792;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function YI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97760;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function RI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+12>>2],(k|0)>=9||(t=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|t>>>0>3))||!i[n+4>>2])break i;f=i[r+20>>2],n=i[r+16>>2],o=i[r>>2],e=E(28),u[e+8|0]=0,i[e+4>>2]=t,i[e>>2]=o,t=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=t,u[e+10|0]=t>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=n,i[e+20>>2]=f,i[e+12>>2]=k,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function JI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+12>>2],(k|0)<=8||(t=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|t>>>0>3))||!i[n+4>>2])break i;f=i[r+20>>2],n=i[r+16>>2],o=i[r>>2],e=E(28),u[e+8|0]=0,i[e+4>>2]=t,i[e>>2]=o,t=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=t,u[e+10|0]=t>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=n,i[e+20>>2]=f,i[e+12>>2]=k,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function NI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-16|0,v=f;i:{e:{if(i[e+64>>2]&&!(X[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(W3(i[e+64>>2],i[r+8>>2],i[r+12>>2],0)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}k=i[r+4>>2],i[f+8>>2]=i[r>>2],i[f+12>>2]=k,k=i[f+12>>2],i[e+72>>2]=i[f+8>>2],i[e+76>>2]=k,e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e}v=f+16|0}function MI(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(B=(t|0)<14?1<<13-t:0,m=14-t|0,s=-1<<t^-1;;){for(t=(G(e,w)<<1)+A|0,h=(G(f,w)<<1)+r|0,_=0;o=Q[h>>1]+B>>m,Q[t>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,o=Q[h+2>>1]+B>>m,Q[t+2>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,h=h+4|0,t=t+4|0,_=_+2|0,(_|0)<(k|0););if(w=w+1|0,(w|0)==(n|0))break}return}M0(22018,18227,172,10455),H()}function UI(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=f,f=i[A+20>>2],i[A+20>>2]=e;i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;X[i[i[f>>2]+8>>2]](f),p(f)}Pn(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,D4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=r+32|0}function ct(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0))f:{A:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break A;break f}o=i[31336],i[31336]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31336];A:{if(t){if(i[k+12>>2]!=(e|0))break A;if((t|0)==68)break r;break e}if(i[31336]=o,i[k+12>>2]==(e|0))break e}}i[r>>2]=4,A=0,e=0;break i}i[r>>2]=4,A=-1,e=-1;break i}e=A,r=(n|0)==45,A=r?0-e|0:e,e=r?0-(f+((e|0)!=0)|0)|0:f}return v=k+16|0,l0=e,A}function DI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=100304;i:{if(l[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}function HI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99792;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}function bt(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31336],i[31336]=0,a2(),f=b6(A,k+12|0,f,0,-2147483648),A=l0,n=i[31336];f:{if(n){if(i[k+12>>2]!=(e|0))break f;if((n|0)==68)break e;break r}if(i[31336]=t,i[k+12>>2]==(e|0))break r}}i[r>>2]=4,e=0;break i}if((A|0)<0&f>>>0<2147483648|(A|0)<-1|(f>>>0>2147483647&(A|0)>=0|(A|0)>0))break e;e=f;break i}if(i[r>>2]=4,e=2147483647,!!f&(A|0)>=0|(A|0)>0)break i;e=-2147483648}return v=k+16|0,e}function xI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97760;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}function jr(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,f=i[A>>2],A=i[e+4>>2],e=i[e>>2],u[r+12|0]=0,u[r+23|0]=0,A=K(r+24|0,e,A,r+12|0),e=i[f+152>>2];i:{if(e>>>0<u0[f+156>>2]){k=i[A+4>>2],i[e>>2]=i[A>>2],i[e+4>>2]=k,i[e+16>>2]=i[A+16>>2],k=i[A+12>>2],i[e+8>>2]=i[A+8>>2],i[e+12>>2]=k,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[f+152>>2]=e+20;break i}if(e=ee(f+148|0,A),k=u[A+19|0],i[f+152>>2]=e,(k|0)>=0)break i;Z(i[A+8>>2])}u[r+23|0]<0&&Z(i[r+12>>2]),v=r+48|0}function zI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,n=f+20|0,Iu(n,e+104|0),V4(r,n),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+19|0]<0&&Z(i[f+8>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}A=i[f+20>>2],A&&(i[f+24>>2]=A,Z(A)),v=f+32|0}function TI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+104>>2];i:{if(!l[e+97|0]){u2(r,n&65535);break i}C0(r,n)}i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function iu(A,e){var r=0,f=0;i:{if(r=l[A+12|0],(r|0)==l[e+12|0]){if(!r|(A|0)==(e|0))break i;if(r=u[e+11|0],u[A+11|0]>=0){if((r|0)>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}D1(A,i[e>>2],i[e+4>>2]);return}f=A,A=(r|0)<0,O1(f,A?i[e>>2]:e,A?i[e+4>>2]:r);return}if(r){u[A+11|0]<0&&Z(i[A>>2]),u[A+12|0]=0;return}e:{if(u[e+11|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break e}T(A,i[e>>2],i[e+4>>2])}u[A+12|0]=1}}function eu(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}o=i[31336],i[31336]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31336];k:{if(t){if(i[k+12>>2]!=(e|0))break k;if((t|0)==68)break r;break f}if(i[31336]=o,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f&A>>>0<=65535)break e}i[r>>2]=4,A=65535;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A&65535}function SI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C4(r,e+104|0,1),C4(r,e+116|0,1),C4(r,e+128|0,1),C4(r,e+140|0,1),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function jI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=i[e+16>>2],!t||(t=X0(t,94804,95832),!t))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[t+4>>2],i[f>>2]=i[t+8>>2],i[k>>2]=i[t+12>>2],i[n>>2]=i[t+16>>2],i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}function OI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=i[e+16>>2],!t||(t=X0(t,94804,95876),!t))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[t+4>>2],i[f>>2]=i[t+8>>2],i[k>>2]=i[t+12>>2],i[n>>2]=i[t+16>>2],i[A+8>>2]=i[24070],r=i[24069],i[A>>2]=i[24068],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;X[i[i[e>>2]+8>>2]](e),p(e)}return}e=i[24182],i[A>>2]=i[24181],i[A+4>>2]=e,i[A+8>>2]=i[24183]}function ru(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,k=v-16|0,v=k;i:{if(e>>>0<=2147483639){e:{if(e>>>0<11){u[A+11|0]=l[A+11|0]&128|e&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,e>>>0>=11?(t=e+8&-8,f=t-1|0,f=(f|0)==11?t:f):f=10,Fi(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=e}vl(f,e,r),u[k+7|0]=0,u[e+f|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}return v=n+16|0,A}function _A(A){var e=0,r=0,f=0,k=0;return i[A+92>>2]=0,i[A+64>>2]=72244,i[A+8>>2]=72224,e=i[18065],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18066],i[A+4>>2]=0,e=i[i[A>>2]-12>>2]+A|0,r=A+12|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=i[18067],i[A+8>>2]=e,i[i[e-12>>2]+(A+8|0)>>2]=i[18068],e=i[18064],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18069],i[A+64>>2]=72244,i[A>>2]=72204,i[A+8>>2]=72224,f=R0(r),k=71280,i[f>>2]=k,i[A+52>>2]=0,i[A+56>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+60>>2]=24,A}function LI(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=F[e>>1]|F[e+2>>1]<<16,Q[A+6>>1]=f,Q[A+8>>1]=f>>>16,e=l[e+3|0]|l[e+4|0]<<8|(l[e+5|0]<<16|l[e+6|0]<<24),u[A+9|0]=e,u[A+10|0]=e>>>8,u[A+11|0]=e>>>16,u[A+12|0]=e>>>24,Ln(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,D4(A,r+8|0,0),A=i[r+20>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=r+32|0}function PI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=X[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,F[f>>1]),l2(r,l[f+2|0]),l2(r,l[f+3|0]),f=f+4|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+32|0}function BA(A){var e=0,r=0,f=0,k=0;if(i[A+20>>2]=0,r=i[A+8>>2],e=i[A+4>>2],f=r-e>>2,f>>>0>=3)for(;Z(i[e>>2]),e=i[A+4>>2]+4|0,i[A+4>>2]=e,r=i[A+8>>2],f=r-e>>2,f>>>0>2;);k=512;i:switch(f-1|0){case 1:k=1024;case 0:i[A+16>>2]=k;break;default:break i}i:{if((e|0)==(r|0))break i;for(;Z(i[e>>2]),e=e+4|0,(r|0)!=(e|0););if(r=i[A+4>>2],e=i[A+8>>2],(r|0)==(e|0))break i;i[A+8>>2]=e+((r-e|0)+3&-4)}A=i[A>>2],A&&Z(A)}function fu(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{if(k=v-16|0,v=k,n=r-e|0,n>>>0<=2147483639){e:{if(n>>>0<11){u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,n>>>0>=11?(t=n+8&-8,f=t-1|0,f=(f|0)==11?t:f):f=10,Fi(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=r-e|0,r=!A,r|r||z(f,e,A),u[k+7|0]=0,u[A+f|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}}function qI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,n=u[e+115|0],((n|0)<0?i[e+108>>2]:n)&&C4(r,e+104|0,1),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function I8(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>2>>>0>=e>>>0){e&&(e=e<<2,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(t=r,r=i[A>>2],o=t-r|0,n=o>>2,k=n+e|0,k>>>0<1073741824){if(f=f-r|0,t=f>>1,k=f>>>0>=2147483644?1073741823:k>>>0<t>>>0?t:k,k){if(k>>>0>=1073741824)break i;s=E(k<<2)}f=o+s|0,e=e<<2,e&&o0(f,0,e),n=f-(n<<2)|0,o&&z(n,r,o),i[A+8>>2]=(k<<2)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}x0(),H()}function KI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{if(f=i[A>>2],A=i[f+104>>2],k=i[f+108>>2],(A|0)!=(k|0))for(;;){e:{if(f=i[A>>2],!f||(f=X0(f,86628,88980),!f))break e;if(A=i[A+4>>2],A)break i;return i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],1}if(A=A+8|0,(k|0)==(A|0))break}return i[e>>2]=1,i[r>>2]=1,0}return i[A+4>>2]=i[A+4>>2]+1,i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],e=i[A+4>>2],i[A+4>>2]=e-1,e||(X[i[i[A>>2]+8>>2]](A),p(A)),1}function aI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(w=1<<k-1,_=r&2147483646,B=r&1;;){if(n=0,t=0,h=0,(r|0)!=1)for(;s=G(r,n)+o|0,t=((Q[(s<<1)+e>>1]<<f)+w>>k)+t|0,i[(s<<2)+A>>2]=t,s=G(n|1,r)+o|0,t=t+((Q[(s<<1)+e>>1]<<f)+w>>k)|0,i[(s<<2)+A>>2]=t,n=n+2|0,h=h+2|0,(_|0)!=(h|0););if(B&&(n=G(r,n)+o|0,i[(n<<2)+A>>2]=((Q[(n<<1)+e>>1]<<f)+w>>k)+t),o=o+1|0,(o|0)==(r|0))break}}function Au(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+108>>2],f=i[A+112>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+108>>2]=r+4;return}i:{if(t=i[A+104>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=E(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&z(e,t,r),i[A+112>>2]=k+(f<<2),r=n+4|0,i[A+108>>2]=r,i[A+104>>2]=e,t&&Z(t),i[A+108>>2]=r;return}G0(),H()}x0(),H()}function ku(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+280>>2],f=i[A+284>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+280>>2]=r+4;return}i:{if(t=i[A+276>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=E(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&z(e,t,r),i[A+284>>2]=k+(f<<2),r=n+4|0,i[A+280>>2]=r,i[A+276>>2]=e,t&&Z(t),i[A+280>>2]=r;return}G0(),H()}x0(),H()}function nu(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+440>>2],f=i[A+444>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+440>>2]=r+4;return}i:{if(t=i[A+436>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=E(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&z(e,t,r),i[A+444>>2]=k+(f<<2),r=n+4|0,i[A+440>>2]=r,i[A+436>>2]=e,t&&Z(t),i[A+440>>2]=r;return}G0(),H()}x0(),H()}function ui(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){e&&(e=e<<3,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(t=r,r=i[A>>2],o=t-r|0,n=o>>3,k=n+e|0,k>>>0<536870912){if(f=f-r|0,t=f>>2,k=f>>>0>=2147483640?536870911:k>>>0<t>>>0?t:k,k){if(k>>>0>=536870912)break i;s=E(k<<3)}f=o+s|0,e=e<<3,e&&o0(f,0,e),n=f-(n<<3)|0,o&&z(n,r,o),i[A+8>>2]=(k<<3)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}x0(),H()}function $I(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+100>>2]),u2(r,F[e+104>>1]),u2(r,F[e+106>>1]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function dI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((r|0)>0)for(s=1<<k-1,B=r&2147483646,m=r&1;;){if(_=G(r,w),o=0,t=0,h=0,(r|0)!=1)for(;n=o+_|0,t=((Q[(n<<1)+e>>1]<<f)+s>>k)+t|0,i[(n<<2)+A>>2]=t,n=n+1|0,t=t+((Q[(n<<1)+e>>1]<<f)+s>>k)|0,i[(n<<2)+A>>2]=t,o=o+2|0,h=h+2|0,(B|0)!=(h|0););if(m&&(n=o+_|0,i[(n<<2)+A>>2]=((Q[(n<<1)+e>>1]<<f)+s>>k)+t),w=w+1|0,(w|0)==(r|0))break}}function tu(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=i[A+8>>2],f=i[A+12>>2];i:{e:{if((k|0)==(f|0)){A=0;break e}for(A=f-k>>2,o=A>>>0<=1?1:A;;){if(t=i[(n<<2)+k>>2],!(i[t+92>>2]!=(e|0)|i[t+108>>2]<=(r|0))&i[t+100>>2]==2)break i;if(n=n+1|0,(o|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(t=A>>>0<=1?1:A,A=0;;){if(f=i[(A<<2)+k>>2],!(i[f+92>>2]!=(e|0)|i[f+108>>2]<=(r|0)|!i[f+100>>2]))return A;if(A=A+1|0,(t|0)==(A|0))break}}return n}function cI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1|i[r+12>>2]!=8||u[r+8|0]&1||(e=F[r+20>>1],!(e>>>0>14|!(1<<e&18689))|!l[r+22|0]))break i;e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function bI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|k>>>0>3)||i[n+4>>2])break i;f=i[r+12>>2],n=i[r+20>>2],t=i[r+16>>2],o=i[r>>2],e=E(28),u[e+8|0]=0,i[e+4>>2]=k,i[e>>2]=o,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=t,i[e+20>>2]=n,i[e+12>>2]=f,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function iC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;o=v-16|0,v=o,s=i[A>>2],k=i[s+148>>2],n=(i[s+152>>2]-k|0)/20|0;i:{if(!f){t=n;break i}if((f|0)<=0|(e|0)>=(n|0))break i;for(;;){if(n=i[A>>2],b0(o+4|0,(G(t,20)+k|0)+G(e,20)|0,n?n+92|0:0),k=G(t,12)+r|0,i[k+8>>2]=i[o+12>>2],n=i[o+8>>2],i[k>>2]=i[o+4>>2],i[k+4>>2]=n,k=i[s+148>>2],t=t+1|0,(t|0)>=(f|0))break i;if(!((e+t|0)<((i[s+152>>2]-k|0)/20|0)))break}}return v=o+16|0,t|0}function l2(A,e){var r=0,f=0,k=0,n=0,t=0;i:{if(k=i[A+12>>2],f=i[A+4>>2],t=i[A>>2],(k|0)==(f-t|0)){r=i[A+8>>2];e:{if(r>>>0>f>>>0){u[f|0]=e,e=f+1|0;break e}if(n=k+1|0,(n|0)<0)break i;if(f=r-t|0,r=f<<1,n=f>>>0>=1073741823?2147483647:r>>>0>n>>>0?r:n,n?r=E(n):r=0,f=r+k|0,u[f|0]=e,k&&z(r,t,k),i[A+8>>2]=r+n,e=f+1|0,i[A+4>>2]=e,i[A>>2]=r,!t)break e;Z(t)}i[A+4>>2]=e,i[A+12>>2]=i[A+12>>2]+1;return}i[A+12>>2]=k+1,u[k+t|0]=e;return}G0(),H()}function j8(A,e,r,f,k,n){var t=0,o=0,s=0;o=v-16|0,v=o;i:{e:{if(!A||(t=i[k+12>>2],s=r-e>>2,(s|0)>0&&(X[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e>>2,t=(e|0)<(t|0)?t-e|0:0,(t|0)>0){e=Yt(o+4|0,t,n);r:{if(l[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=X[i[i[A>>2]+48>>2]](A,n,t)|0,R1(e),(n|0)!=(t|0))break e}if(e=f-r>>2,(e|0)>0&&(X[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=o+16|0,A}function eC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;return t=X[i[i[A>>2]+8>>2]](A)|0,f=l0,o=r+t|0,f=o>>>0<r>>>0?f+1|0:f,s=i[A+36>>2],k=s,t=i[A+32>>2],(f|0)==(k|0)&o>>>0<=t>>>0|f>>>0<k>>>0&&(k=v-16|0,v=k,A=i[A+24>>2],i[A+4>>2]=0,dA(k+15|0,A),n=4,l[k+15|0]&&(n=i[(A+i[i[A>>2]-12>>2]|0)+24>>2],e=X[i[i[n>>2]+32>>2]](n,e,r)|0,i[A+4>>2]=e,n=(e|0)!=(r|0)?6:0),m4(A+i[i[A>>2]-12>>2]|0,n),v=k+16|0),(f|0)==(s|0)&t>>>0>=o>>>0|f>>>0<s>>>0}function uu(A){var e=0;return i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A+108>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+16>>2]=1835295606,i[A>>2]=86500,A}function O8(A,e,r,f,k,n){var t=0,o=0,s=0;o=v-16|0,v=o;i:{e:{if(!A||(t=i[k+12>>2],s=r-e|0,(s|0)>0&&(X[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e|0,t=(e|0)<(t|0)?t-e|0:0,(t|0)>0){e=ru(o+4|0,t,n);r:{if(l[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=X[i[i[A>>2]+48>>2]](A,n,t)|0,s2(e),(n|0)!=(t|0))break e}if(e=f-r|0,(e|0)>0&&(X[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=o+16|0,A}function rC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(n|0))break i;if(f=i[A+24>>2],o=i[A+28>>2],f>>>0>=o>>>0){if((X[i[i[A>>2]+52>>2]](A,l[e|0])|0)==-1)break i;n=n+1|0,e=e+1|0}else i[k+12>>2]=o-f,i[k+8>>2]=r-n,f=v-16|0,v=f,v=f+16|0,o=i[A+24>>2],f=k+8|0,t=k+12|0,f=i[(i[f>>2]<i[t>>2]?f:t)>>2],t=!f,t|t||z(o,e,f),i[A+24>>2]=f+i[A+24>>2],n=f+n|0,e=e+f|0;continue}break}return v=k+16|0,n|0}function vA(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,i[f+12>>2]=e;i:{e:{r=l[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=1;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){wt(A,e,1,e,e);r:if(l[A+11|0]>>>7|0)break r;break e}r:if(l[A+11|0]>>>7|0)break r;if(k)break e;e=A,u[A+11|0]=l[A+11|0]&128|r+1&127,u[A+11|0]=l[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=(r<<2)+e|0,i[A>>2]=i[f+12>>2],i[f+8>>2]=0,i[A+4>>2]=i[f+8>>2],v=f+16|0}function ou(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}o=i[31336],i[31336]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31336];k:{if(t){if(i[k+12>>2]!=(e|0))break k;if((t|0)==68)break r;break f}if(i[31336]=o,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f)break e}i[r>>2]=4,A=-1;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A}function fC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-16|0,v=f,k=i[A>>2],n=l[k+20|0];i:{if((n|0)!=255){if(!n){if(n=i[r>>2],A=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,r=i[e+4>>2],i[e>>2]=n,i[e+4>>2]=A,!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r);break i}A=i[23607],i[f+8>>2]=i[23606],i[f+12>>2]=A,X[i[(f+8|0)+(n<<2)>>2]](f+7|0,k)}i[k>>2]=i[r>>2],i[k+4>>2]=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,u[k+20|0]=0}v=f+16|0}function lu(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+76|0]==1&&(i[A>>2]=i[e+32>>2],i[A+4>>2]=i[e+36>>2],i[A+8>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[A+12>>2]=i[e+44>>2],i[A+16>>2]=i[e+48>>2],i[A+20>>2]=i[e+52>>2],i[e+52>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,r=e- -64|0,f=i[r>>2],r=i[r+4>>2],k=i[e+72>>2],n=i[e+56>>2],e=i[e+60>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=f,i[A+36>>2]=r,i[A+24>>2]=n,i[A+28>>2]=e)}function Or(A,e){i:{if(A){if(e>>>0<=127)break i;e:{if(!i[i[31378]>>2]){if((e&-128)==57216)break i;break e}if(e>>>0<=2047)return u[A+1|0]=e&63|128,u[A|0]=e>>>6|192,2;if(!((e&-8192)!=57344&e>>>0>=55296))return u[A+2|0]=e&63|128,u[A|0]=e>>>12|224,u[A+1|0]=e>>>6&63|128,3;if(e-65536>>>0<=1048575)return u[A+3|0]=e&63|128,u[A|0]=e>>>18|240,u[A+2|0]=e>>>6&63|128,u[A+1|0]=e>>>12&63|128,4}i[31336]=25,A=-1}else A=1;return A}return u[A|0]=e,1}function AC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if((e|0)>0)for(;;){if(k=i[(n<<2)+A>>2],k){r=i[k+20>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[k+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}r=i[k+4>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;X[i[i[r>>2]+8>>2]](r),p(r)}Z(k)}if(n=n+1|0,(n|0)==(e|0))break}}function c4(A,e){var r=0,f=0;f=A;i:{e:{if((f^e)&3){r=l[e|0];break e}if(e&3)for(;;){if(r=l[e|0],u[f|0]=r,!r)break i;if(f=f+1|0,e=e+1|0,!(e&3))break}if(r=i[e>>2],((r|16843008-r)&-2139062144)!=-2139062144)break e;for(;i[f>>2]=r,f=f+4|0,r=i[e+4>>2],e=e+4|0,((16843008-r|r)&-2139062144)==-2139062144;);}if(u[f|0]=r,!(r&255))break i;for(;r=l[e+1|0],u[f+1|0]=r,f=f+1|0,e=e+1|0,!!r;);}return A}function Lr(A,e){var r=0,f=0,k=0,n=0,t=0;i:{r=i[A+4>>2],n=i[A>>2],t=r-n|0,k=t+e|0;e:{if(k>>>0>t>>>0){if(f=i[A+8>>2],f-r>>>0>=e>>>0){e&&o0(r,0,e),i[A+4>>2]=e+r;break e}if((k|0)<0)break i;if(r=f-n|0,f=r<<1,f=r>>>0>=1073741823?2147483647:k>>>0<f>>>0?f:k,r=E(f),e&&o0(r+t|0,0,e),t&&z(r,n,t),i[A+8>>2]=r+f,i[A+4>>2]=r+k,i[A>>2]=r,!n)break e;Z(n);break e}if(k>>>0>=t>>>0)break e;i[A+4>>2]=k+n}i[A+12>>2]=i[A+12>>2]+e;return}G0(),H()}function kC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,o=nf()|0;i:{if(!e||(r=UA(e),(r|0)<=0))break i;if(n=f-((r<<2)+15&-16)|0,v=n,t=Un(e,n,r),t){if(e=0,(t|0)<=0)break i;for(;i[f+8>>2]=e,k=f+8|0,r=y1(85416,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=y1(85428,k|0)|0,U4(o|0,r|0,k|0),k>>>0>=9&&o1(k|0),r>>>0>=9&&o1(r|0),e=e+1|0,(t|0)!=(e|0););break i}Z(n)}i[A+4>>2]=o,i[A>>2]=125416,v=f+16|0}function su(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{if(k=v-16|0,v=k,n=r-e>>2,n>>>0<=1073741815){e:{if(n>>>0<2){u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,n>>>0>=2?(t=n+2&-2,f=t-1|0,f=(f|0)==2?t:f):f=1,Ei(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=zl(e,r,f),i[k+4>>2]=0,i[A>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}}function nC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(i[r>>2]=0,e=i[i[e>>2]+64>>2],!e){e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];return}f=r,r=E(24),i[f>>2]=r,f=i[e+20>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=f,f=i[e+12>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=f,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}function tC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+64|0]==1&&(i[A>>2]=i[e+20>>2],i[A+4>>2]=i[e+24>>2],i[A+8>>2]=i[e+28>>2],i[e+28>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[A+12>>2]=i[e+32>>2],i[A+16>>2]=i[e+36>>2],i[A+20>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,r=i[e+52>>2],f=i[e+56>>2],k=i[e+60>>2],n=i[e+44>>2],e=i[e+48>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function uC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+108>>2]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function oi(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,u[f+15|0]=e;i:{e:{r=l[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=10;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){uA(A,e,1,e,e);r:if(l[A+11|0]>>>7|0)break r;break e}r:if(l[A+11|0]>>>7|0)break r;if(k)break e;e=A,u[A+11|0]=l[A+11|0]&128|r+1&127,u[A+11|0]=l[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=e+r|0,u[A|0]=l[f+15|0],u[f+14|0]=0,u[A+1|0]=l[f+14|0],v=f+16|0}function oC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;n=v-32|0,v=n,i[n+24>>2]=0,i[n+28>>2]=0,t=n+4|0,Bf(t,i[e>>2],n+24|0,f,k,0),i[n+4>>2]||(k=E(8),i[r>>2]=k,f=i[n+24>>2],r=i[n+28>>2],i[n+24>>2]=0,i[n+28>>2]=0,i[k>>2]=f,i[k+4>>2]=r,t=107712),r=A,A=i[e>>2],b0(r,t,A?A+92|0:0),u[n+23|0]<0&&Z(i[n+12>>2]),e=i[n+28>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}v=n+32|0}function wu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=u[A+139|0]<0?i[A+128>>2]:A+128|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,e|0}function hu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=u[A+151|0]<0?i[A+140>>2]:A+140|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,e|0}function _u(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1970432288||(e=u[A+163|0]<0?i[A+152>>2]:A+152|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,e|0}function lC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+100>>2]),C0(r,i[e+104>>2]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function sC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,F[e+98>>1]),u2(r,F[e+100>>1]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function l4(A,e,r,f){var k=0,n=0;i:{if(l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,!k|(r-e|0)<5)break i;cr(e,r),n=r-4|0,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,l[A+11|0]>>>7|0&&(A=i[A>>2]),r=A,A=k+A|0;e:{for(;;){r:{if(k=u[r|0],e>>>0>=n>>>0)break r;if(!((k|0)<=0|(k|0)>=127)&(k|0)!=i[e>>2])break e;e=e+4|0,r=((A-r|0)>1)+r|0;continue}break}if((k|0)<=0|(k|0)>=127|u[r|0]>>>0>i[n>>2]-1>>>0)break i}i[f>>2]=4}}function wC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k;i:{if(!f){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}Rr(k+12|0,r,0),n=i[k+12>>2];e:{if((n|0)!=i[k+16>>2]){e=E(8),r=i[i[n>>2]>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,hk(A,e);break e}if(i[f>>2]=0,u[k|0]=0,u[k+11|0]=0,r=K(k+12|0,3,0,k),u[k+11|0]<0&&Z(i[k>>2]),b0(A,r,e?i[e>>2]:0),u[r+19|0]<0&&Z(i[r+8>>2]),!n)break i}Z(n)}v=k+32|0}function Bu(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+48|0]==1&&(i[A>>2]=i[e+4>>2],i[A+4>>2]=i[e+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[A+12>>2]=i[e+16>>2],i[A+16>>2]=i[e+20>>2],i[A+20>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,r=i[e+36>>2],f=i[e+40>>2],k=i[e+44>>2],n=i[e+28>>2],e=i[e+32>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function hC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,k=i[r>>2],k>>>0<2147483640){i:{e:{if(k>>>0>=11){t=k|7,n=E(t+1|0),i[f+16>>2]=t-2147483647,i[f+8>>2]=n,i[f+12>>2]=k;break e}if(u[f+19|0]=k,n=f+8|0,!k)break i}if(!k)break i;z(n,r+4|0,k)}return u[k+n|0]=0,X[A|0](f+20|0,e,f+8|0),A=E(12),i[A+8>>2]=i[f+28>>2],e=i[f+24>>2],i[A>>2]=i[f+20>>2],i[A+4>>2]=e,u[f+19|0]<0&&Z(i[f+8>>2]),v=f+32|0,A|0}g0(),H()}function vu(A,e,r,f,k){var n=0,t=0,o=0;o=-1,t=f&2147483647,n=(t|0)==2147418112;i:{if((n&!r?A|e:n&(r|0)!=0|t>>>0>2147418112)||(n=k&2147483647,n>>>0>2147418112&(n|0)!=2147418112))break i;if(!(A|r|(n|t|e)))return 0;if(n=f&k,(n|0)>0?n=1:n=(n|0)>=0,n){if(((r|0)!=0|(f|0)!=(k|0))&(f|0)<(k|0))break i;return(A|r|(f^k|e))!=0}if(!r&(f|0)==(k|0)?A|e:(r|0)!=0&(f|0)>=(k|0)|(f|0)>(k|0))break i;o=(A|r|(f^k|e))!=0}return o}function _C(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;f=i[A>>2];i:{e:{if((e|0)==10){if(A=i[f+120>>2]-10|0,A>>>0<6)break e;r=255;break i}if(A=i[f+128>>2],r=0,!A)break i;for(k=f+128|0,f=k;r=i[A+16>>2]<(e|0),f=r?f:A,A=i[(r?4:0)+A>>2],!!A;);if(r=0,(f|0)==(k|0)|i[f+16>>2]>(e|0))break i;r=l[f+24|0]+7&-8;break i}e=A<<3,A=e&31,(e&63)>>>0>=32?A=16432>>>A|0:A=((1<<A)-1&16432)<<32-A|1076895768>>>A,r=A}return r&255}function BC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;if(k=i[r+4>>2],!(i[r+12>>2]==8&k>>>0<=3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=i[f+12>>2],t=i[r+20>>2],o=i[r+16>>2],n=i[r>>2],s=l[r+8|0],e=E(28),u[e+8|0]=s,i[e+4>>2]=k,i[e>>2]=n,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=11,i[e+16>>2]=o,i[e+20>>2]=t,i[e+12>>2]=f,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function vC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;if(k=i[r+4>>2],!(!(i[r+12>>2]!=8&k>>>0<=3)|i[f+12>>2]!=8)){f=i[r+20>>2],t=i[r+16>>2],o=i[r>>2],n=l[r+8|0],e=E(28),u[e+8|0]=n,i[e+4>>2]=k,i[e>>2]=o,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=11,i[e+16>>2]=t,i[e+20>>2]=f,i[e+12>>2]=8,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function mC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1|i[r+12>>2]!=8||(e=F[r+20>>1],!(e>>>0>14|!(1<<e&18689))|!l[r+22|0]))break i;e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=1,i[e>>2]=1,i[e+4>>2]=11,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function mA(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(f){if(f>>>0>=357913942)break e;if(k=G(f,12),f=E(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0,t=i[e>>2],k=i[e+4>>2],(t|0)!=(k|0)){if(k=k-t|0,(k|0)<0)break i;n=E(k),i[f+4>>2]=n,i[f>>2]=n,o=k+n|0,i[f+8>>2]=o,k&&z(n,t,k),i[f+4>>2]=o}if(f=f+12|0,e=e+12|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}G0(),H()}G0(),H()}function mu(A,e){var r=0,f=0;if((A|0)==14)return i[e>>2]?21106:19610;if(r=A&65535,f=A>>16,!((r|0)!=65535|(f|0)>5))return A=i[(f<<2)+e>>2],A?A+8|0:20062;A=42716;i:{e:{r:switch(f-1|0){case 0:if(r>>>0>1)break i;A=74336;break e;case 1:if(r>>>0>49)break i;A=74352;break e;case 4:break r;default:break i}if(r>>>0>3)break i;A=74672}if(!r)return A;for(;e=l[A|0],A=A+1|0,!(!e&&(r=r-1|0,!r)););}return A}function $1(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0;s=O0(e,r,o,s),o=l0,k=O0(f,k,n,t),s=k+s|0,f=l0+o|0,o=k>>>0>s>>>0?f+1|0:f,w=t,k=0,h=r,f=0,r=O0(t,k,r,f),t=r+s|0,s=l0+o|0,_=t,r=r>>>0>t>>>0?s+1|0:s,t=O0(n,0,e,0),o=l0,s=0,f=O0(n,s,h,f),o=o+f|0,n=l0+s|0,n=f>>>0>o>>>0?n+1|0:n,s=n+_|0,f=r,n=n>>>0>s>>>0?f+1|0:f,e=O0(e,B,w,k)+o|0,k=l0,k=e>>>0<o>>>0?k+1|0:k,o=k+s|0,s=n,i[A+8>>2]=o,i[A+12>>2]=k>>>0>o>>>0?s+1|0:s,i[A>>2]=t,i[A+4>>2]=e}function ZC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;i:{if(k=X[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[k>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[k+4>>2],k=k+4|0,e)continue;break i}break}if(i[e+8>>2]!=3){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}f&&(i[f>>2]=i[e+16>>2]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070];return}e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216]}function GC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];break i}if(k=i[e>>2],!l[k+336|0]){if(u[f|0]=0,u[f+11|0]=0,r=K(f+12|0,5,139,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}e=E(80),i[r>>2]=e,z(e,k+344|0,76),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}v=f+32|0}function WC(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+104>>2],r=i[r+108>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=X0(f,86628,89140),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=F[f+98>>1]|F[f+100>>1]<<16,Q[e>>1]=A,Q[e+2>>1]=A>>>16),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return X[i[i[r>>2]+8>>2]](r),p(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function Zu(A,e){var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+36>>2],k=i[e+40>>2],(f|0)!=(k|0))for(;;){e=i[f>>2];i:{if(!e||(e=X0(e,86628,87392),!e)||(i[r+8>>2]=e,e=i[f+4>>2],i[r+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(A,r+8|0),e=i[r+12>>2],!e)||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f+8|0,(k|0)==(f|0))break}v=r+16|0}function T(A,e,r){var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{if(r>>>0<11){f=A,u[A+11|0]=l[A+11|0]&128|r&127,u[A+11|0]=l[A+11|0]&127;break e}if(r>>>0>2147483639)break i;t=k+8|0,r>>>0>=11?(n=r+8&-8,f=n-1|0,f=(f|0)==11?n:f):f=10,Fi(t,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=r}A=r+1|0,r=!A,r|r||z(f,e,A),v=k+16|0;return}Z4(),H()}function XC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,i[e+100>>2]/90&255),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function gC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=F0(r),i[k+100>>2]=n,k=e,n=o2(r),Q[k+104>>1]=n,k=e,n=o2(r),Q[k+106>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function QC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;n=v-16|0,v=n,e=i[e>>2],s=i[e+48>>2],e=i[e+52>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t=E(4),i[n+4>>2]=t,o=t+4|0,i[n+12>>2]=o,i[t>>2]=k,i[n+8>>2]=o,a4(s,f,r,n+4|0),r=i[n+4>>2],r&&(i[n+8>>2]=r,Z(r));i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070],v=n+16|0}function K2(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-16|0,v=f,G1(f+8|0,A);i:{if(!l[f+8|0]||(n=f+4|0,k=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[n>>2]=k,(k|0)!=129624&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129488),e2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],t=i[i[A>>2]-12>>2]+A|0,o=t6(t),s=f,w=X[i[i[k>>2]+28>>2]](k,i[f>>2],t,o,e,r)|0,i[s+4>>2]=w,i[n>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(f+8|0),v=f+16|0,A}function IC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-80|0,v=f;i:{k=1;e:{if(S1(A,e,0)||(k=0,!e)||(e=X0(e,84936,84984),k=0,!e))break e;if(k=i[r>>2],!k)break i;o0(f+24|0,0,56),u[f+75|0]=1,i[f+32>>2]=-1,i[f+28>>2]=A,i[f+20>>2]=e,i[f+68>>2]=1,X[i[i[e>>2]+28>>2]](e,f+20|0,k,1),A=i[f+44>>2],(A|0)==1&&(i[r>>2]=i[f+36>>2]),k=(A|0)==1}return v=f+80|0,k|0}i[f+8>>2]=20189,i[f+4>>2]=485,i[f>>2]=7828,Q1(),H()}function CC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(o=1<<k-1,_=r&2147483646,B=r&1;;){if(h=G(r,s),n=0,w=0,(r|0)!=1)for(;t=n+h|0,i[(t<<2)+A>>2]=(Q[(t<<1)+e>>1]<<f)+o>>k,t=t+1|0,i[(t<<2)+A>>2]=(Q[(t<<1)+e>>1]<<f)+o>>k,n=n+2|0,w=w+2|0,(_|0)!=(w|0););if(B&&(n=n+h|0,i[(n<<2)+A>>2]=(Q[(n<<1)+e>>1]<<f)+o>>k),s=s+1|0,(s|0)==(r|0))break}}function ZA(A){var e=0,r=0,f=0,k=0;r=53,k=i[A+24>>2],e=i[A+28>>2],f=k-e|0,e=(((e-((k+6>>>0)%7|0)|0)+7>>>0)/7|0)+((f+369>>>0)%7>>>0<3)|0;i:{if((e|0)!=53){if(r=e,e)break i;r=52;e:switch(((f+6>>>0)%7|0)-4|0){case 1:if(!El((i[A+20>>2]%400|0)-1|0))break i;break;case 0:break e;default:break i}return 53}e:switch(((f+371>>>0)%7|0)-3|0){case 0:if(El(i[A+20>>2]))break i;break;case 1:break i;default:break e}r=1}return r}function Gu(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129488),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=X[i[i[f>>2]+32>>2]](f,i[r>>2],n,t,+e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function VC(A,e,r,f,k,n,t,o){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,i[e+8>>2]!=1){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}i:{if(!l[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break i;i[n>>2]=i[e+24>>2]}r&&(i[r>>2]=l[e+16|0]),f&&(i[f>>2]=l[e+16|0]),!o|i[e+32>>2]<=0||(i[o>>2]=i[e+28>>2]),t&&(i[t>>2]=i[e+32>>2]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}function A2(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=86704,u[A+95|0]<0&&Z(i[A+84>>2]),e=i[A+72>>2],e&&(i[A+76>>2]=e,Z(e)),e=i[A+36>>2],e){if(r=e,f=i[A+40>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+36>>2]}i[A+40>>2]=e,Z(r)}return i[A>>2]=86404,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function FC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{e:{if(k=i[e>>2],!k||(k=X0(k,106612,106744),!k))break e;if(e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),qf(f+12|0,k,r),u[f+31|0]<0&&Z(i[f+20>>2]),r=i[24176],i[A>>2]=i[24175],i[A+4>>2]=r,i[A+8>>2]=i[24177],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24698}v=f+32|0}function I0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129488),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=X[i[i[f>>2]+24>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function li(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129488),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=X[i[i[f>>2]+12>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function d1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129488),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=X[i[i[f>>2]+32>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function S0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129624&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129488),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=X[i[i[f>>2]+16>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function EC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,t=nf()|0;i:{if(!e||(r=aA(e),(r|0)<=0)||(n=f-((r<<2)+15&-16)|0,v=n,o=qt(e,n,r),(o|0)<=0))break i;for(e=0;i[f+8>>2]=e,k=f+8|0,r=y1(85416,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=y1(85428,k|0)|0,U4(t|0,r|0,k|0),k>>>0>=9&&o1(k|0),r>>>0>=9&&o1(r|0),e=e+1|0,(o|0)!=(e|0););}i[A+4>>2]=t,i[A>>2]=125416,v=f+16|0}function pC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(;;){for(s=G(e,o)+A|0,w=(G(f,o)<<1)+r|0,h=0;t=Q[w>>1]+32>>6,t=(t|0)>=255?255:t,u[s|0]=(t|0)>0?t:0,t=Q[w+2>>1]+32>>6,t=(t|0)>=255?255:t,u[s+1|0]=(t|0)>0?t:0,w=w+4|0,s=s+2|0,h=h+2|0,(h|0)<(k|0););if(o=o+1|0,(o|0)==(n|0))break}return}M0(22018,18227,40,10302),H()}function Wu(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-16|0,v=k,t=i[31378],i[e+72>>2]<=0&&_k(e),i[31378]=i[e+136>>2],r=-1,i[e+4>>2]||(Ge(e),f=!i[e+4>>2]);i:{if(f|(A|0)==-1||(f=Or(k+12|0,A),(f|0)<0)||(n=i[e+4>>2],n>>>0<(f+i[e+44>>2]|0)-8>>>0))break i;e:{if(A>>>0<=127){r=n-1|0,i[e+4>>2]=r,u[r|0]=A;break e}r=n-f|0,i[e+4>>2]=r,A8(r,k+12|0,f)}i[e>>2]=i[e>>2]&-17,r=A}return i[31378]=t,v=k+16|0,(r|0)!=-1}function C8(A,e){var r=0,f=0,k=0;if((e|0)<=8){if(!e)return 0;f=i[A+16>>2]<<e,i[A+16>>2]=f,r=F[A+20>>1]+e|0,Q[A+20>>1]=r,r=r<<16>>16;i:{if((r|0)<0||(k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=k+1,k=l[k|0],Q[A+20>>1]=r-8,f=k<<r|f}return k=i[A+12>>2]<<7,r=(f>>>0)/(k>>>0)|0,e=1<<e,(r|0)>=(e|0)&&(r=e-1|0),i[A+16>>2]=f-G(r,k),r}for(f=e-8|0,e=eo(A);e=k4(A)|e<<1,f=f-1|0,!!f;);return e}function yC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,F[e+98>>1]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function YC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+100|0]),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function RC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C4(r,e+104|0,1),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function JC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C4(r,e+100|0,0),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function GA(A,e){var r=0,f=0,k=0;i:{e:{if(r=i[e+36>>2],f=i[e+40>>2],(r|0)!=(f|0)){if(e=i[r>>2],e&&(k=i[A+4>>2],e=X0(e,86628,87472),e))break e;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(e=i[r>>2],e&&(k=0,e=X0(e,86628,87472),e))break e;if(r=r+8|0,(f|0)==(r|0))break}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+4>>2]=k,i[A>>2]=e,e=A,A=i[r+4>>2],i[e+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}}function NC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=W2(r),u[k+104|0]=n;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function MC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=i[A>>2],f=i[k+156>>2],k=i[k+160>>2];i:{if((f|0)!=(k|0))for(n=i[i[A+8>>2]>>2];;){if(A=i[f>>2],i[A>>2]==(n|0)){if(f=i[f+4>>2],!f){f=0;break i}i[f+4>>2]=i[f+4>>2]+1;break i}if(f=f+8|0,(k|0)==(f|0))break}f=0,A=0}e&&(i[e>>2]=i[A+4>>2]),r&&(i[r>>2]=i[A+8>>2]);i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}}function UC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,f=v-32|0,v=f,x2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,15918);break i}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,K(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Xu(A,e){var r=0,f=0,k=0;i:{if((A|0)!=(e|0)){r=i[e+4>>2];e:{if(!r){r=0;break e}if(i[A+8>>2]<<5>>>0<r>>>0){if(f=i[A>>2],f&&(Z(f),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+4>>2]),(r|0)<0)break i;r=(r-1>>>5|0)+1|0,f=E(r<<2),i[A+8>>2]=r,i[A+4>>2]=0,i[A>>2]=f,r=i[e+4>>2]}if(f=i[e>>2],k=(f+(r-1>>>3&536870908)|0)+4|0,(k|0)==(f|0))break e;r=k-f|0,r&&z(i[A>>2],f,r),r=i[e+4>>2]}i[A+4>>2]=r}return}G0(),H()}function WA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26967],!k)break e;for(n=107868;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107868|u0[n+16>>2]>r>>>0)break e;i[e+12>>2]=r,b0(A,107712,0);break i}if(i[e+12>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=K(f+12|0,2,135,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function DC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,V4(r,e+120|0),i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function gu(A,e){var r=0,f=0,k=0,n=0,t=0;i:{r=i[A+4>>2],k=i[A>>2],n=r-k|0;e:{if(n>>>0<e>>>0){if(t=e-n|0,f=i[A+8>>2],t>>>0<=f-r>>>0){t&&o0(r,0,t),i[A+4>>2]=r+t;return}if((e|0)<0)break i;if(r=f-k|0,f=r<<1,f=r>>>0>=1073741823?2147483647:e>>>0<f>>>0?f:e,r=E(f),t&&o0(r+n|0,0,t),n&&z(r,k,n),i[A+8>>2]=r+f,i[A+4>>2]=e+r,i[A>>2]=r,!k)break e;Z(k);return}if(e>>>0>=n>>>0)break e;i[A+4>>2]=e+k}return}G0(),H()}function le(A,e,r){var f=M(0),k=M(0),n=M(0),t=M(0),o=0,s=M(0);o=v-16|0,v=o,Cn(o+8|0,e,r),f=E0[o+12>>2],k=E0[o+8>>2];i:{if(!(f!=M(0)|k!=M(0))){k=M(-.714136004447937),f=M(-.34413599967956543),n=M(1.7719999551773071),t=M(1.4019999504089355);break i}t=M(M(1)-k),s=M(M(f+k)+M(-1)),k=M(M(M(k+k)*t)/s),n=M(M(1)-f),f=M(M(M(f+f)*n)/s),n=M(n+n),t=M(t+t)}E0[A+16>>2]=n,E0[A+12>>2]=k,E0[A+8>>2]=f,E0[A+4>>2]=t,u[A|0]=1,v=o+16|0}function Qu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+8>>2],A?A=u[A+127|0]<0?i[A+116>>2]:A+116|0:A=0,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=r+16|0,A|0}function XA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26961],!k)break e;for(n=107844;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107844|u0[n+16>>2]>r>>>0)break e;i[e+4>>2]=r,b0(A,107712,0);break i}if(i[e+4>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=K(f+12|0,2,133,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function gA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26964],!k)break e;for(n=107856;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107856|u0[n+16>>2]>r>>>0)break e;i[e+8>>2]=r,b0(A,107712,0);break i}if(i[e+8>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=K(f+12|0,2,134,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function Iu(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+8>>2]=0,i[r+12>>2]=0,i[r>>2]=0,i[r+4>>2]=0,e4(r,i[e+8>>2],i[e+12>>2]),l2(r,((l[e+17|0]?64:0)|(l[e+16|0]?-128:0)|(l[e+18|0]?32:0))&224),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(f=i[r+4>>2],e=i[r>>2],(f|0)!=(e|0)){if(f=f-e|0,(f|0)<0)break i;k=E(f),i[A>>2]=k,n=f+k|0,i[A+8>>2]=n,f&&z(k,e,f),i[A+4>>2]=n}e&&(i[r+4>>2]=e,Z(e)),v=r+16|0;return}G0(),H()}function se(A){A=A|0;var e=0,r=0,f=0;i[A>>2]=71344,r=v-16|0,v=r,e=i[A+64>>2],e&&(i[r+4>>2]=1957,e=g1(r+8|0,e,r+4|0),X[i[i[A>>2]+24>>2]](A)|0,f=i[e>>2],i[e>>2]=0,qA(f),i[A+64>>2]=0,X[i[i[A>>2]+12>>2]](A,0,0)|0,f=i[e>>2],i[e>>2]=0,f&&X[i[e+4>>2]](f)|0),v=r+16|0;i:{if(l[A+96|0]!=1||(e=i[A+32>>2],!e))break i;Z(e)}i:{if(l[A+97|0]!=1||(e=i[A+56>>2],!e))break i;Z(e)}return y0(A)|0}function HC(A,e){A=A|0,e=e|0;var r=0,f=0;r=A+68|0;i:{if(l[A+80|0]==1){if((e|0)==(r|0))break i;if(f=u[e+11|0],u[A+79|0]>=0){if((f|0)>=0){A=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=A,i[r+8>>2]=i[e+8>>2];return}D1(r,i[e>>2],i[e+4>>2]);return}A=(f|0)<0,O1(r,A?i[e>>2]:e,A?i[e+4>>2]:f);return}e:{if(u[e+11|0]>=0){f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break e}T(r,i[e>>2],i[e+4>>2])}u[A+80|0]=1}}function L8(A,e,r,f){var k=0;i:{k=i[e+104>>2],e=i[e+108>>2];e:{if((k|0)!=(e|0))for(;;){if(!(i[k+40>>2]!=(r|0)|i[k+16>>2]!=(f|0))){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[k+48>>2],r=i[k+44>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=E(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k;return}if(k=k+56|0,(e|0)==(k|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}G0(),H()}function xC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=F[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=r,Q[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function we(A,e){var r=0,f=0,k=0,n=0,t=0;i:{if((e|0)<=0)break i;for(t=i[A+12>>2]<<7,f=F[A+20>>1],r=i[A+16>>2];;){f=f+1|0,Q[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,Q[A+20>>1]=65528,n=i[A+4>>2],n>>>0>=u0[A+8>>2]))break e;i[A+4>>2]=n+1,r=l[n|0]|r,i[A+16>>2]=r}if(r>>>0<t>>>0)break i;if(r=r-t|0,i[A+16>>2]=r,k=k+1|0,(k|0)==(e|0))break}k=e}return(e|0)>(k|0)?k:e}function zC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=F[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=r,Q[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function TC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=F[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=r,Q[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function SC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=F[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=r,Q[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function QA(A,e){var r=0,f=0,k=0;r=i[e+60>>2];i:{e:{if(r&16){f=i[e+56>>2],r=i[e+36>>2],f>>>0<r>>>0&&(i[e+56>>2]=r,f=r),e=e+32|0;break e}if(!(r&8)){e=0,u[A+11|0]=0;break i}f=i[e+28>>2],e=e+20|0}e:{if(k=i[e>>2],e=f-k|0,e>>>0<2147483640){if(e>>>0>=11){f=e|7,r=E(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}g0(),H()}if(!e)break i;z(A,k,e)}u[A+e|0]=0}function jC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,t=A+248|0,o6(t|1,9862,1,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,t=h4(k,24,o,t,A)+k|0,s=x4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Vr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=j8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function OC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,t=A+248|0,o6(t|1,9862,0,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,t=h4(k,24,o,t,A)+k|0,s=x4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Vr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=j8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function LC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,t=A+104|0,o6(t|1,9862,1,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,t=h4(k,24,o,t,A)+k|0,s=x4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Fr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=O8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function PC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,t=A+104|0,o6(t|1,9862,0,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,t=h4(k,24,o,t,A)+k|0,s=x4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Fr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=O8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function qC(A,e){A=A|0,e=e|0;var r=0,f=0;f=i[e+104>>2],e=i[e+108>>2];i:{if((f|0)==(e|0))break i;for(;;){e:{r:{if(r=i[f>>2],!r||!X0(r,86628,99524))break r;if(r=i[f+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(f=f+8|0,(e|0)!=(f|0))continue}break}r=0}i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}}function Cu(A,e,r,f){var k=0,n=0;i:{if(f>>>0>=3){i[31336]=28;break i}e:{if((f|0)!=1||(k=i[A+8>>2],!k))break e;n=e,k=k-i[A+4>>2]|0,e=e-k|0,r=r-((k>>31)+(k>>>0>n>>>0)|0)|0}if(i[A+20>>2]!=i[A+28>>2]&&(X[i[A+36>>2]](A,0,0)|0,!i[A+20>>2])||(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,X[i[A+40>>2]](A,e,r,f)|0,(l0|0)<0))break i;return i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=i[A>>2]&-17,0}return-1}function KC(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=97552,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}return A2(A)|0}function aC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,i[r+12>>2]=k,X[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function Pr(A,e,r){var f=0,k=0,n=0;f=i[r+16>>2];i:{if(!f){if(cA(r))break i;f=i[r+16>>2]}if(k=i[r+20>>2],f-k>>>0<e>>>0)return X[i[r+36>>2]](r,A,e)|0;e:{r:{if(!e|i[r+80>>2]<0)break r;for(f=e;;){if(n=A+f|0,l[n-1|0]!=10){if(f=f-1|0,f)continue;break r}break}if(k=X[i[r+36>>2]](r,A,f)|0,k>>>0<f>>>0)break i;e=e-f|0,k=i[r+20>>2];break e}n=A,f=0}A8(k,n,e),i[r+20>>2]=i[r+20>>2]+e,k=e+f|0}return k}function Vu(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k,t=i[e+48>>2],f=i[i[f>>2]+116>>2],r=i[i[r>>2]+116>>2],e=E(4),i[k+4>>2]=e,n=e+4|0,i[k+12>>2]=n,i[e>>2]=r,i[k+8>>2]=n,a4(t,f,1953000802,k+4|0),e=i[k+4>>2],e&&(i[k+8>>2]=e,Z(e)),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=k+16|0}function $C(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=F0(r),i[k+100>>2]=n,k=e,n=F0(r),i[k+104>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function dC(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=97552,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}Z(A2(A))}function cC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return r=v-48|0,v=r,Df(r+12|0,i[A>>2],e),e=0,f=l[r+32|0],f||(e=E(16),k=i[r+12>>2],f=i[r+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+4>>2]=f,i[e>>2]=k,f=i[A>>2],A=i[A+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+12>>2]=A,i[e+8>>2]=f,f=l[r+32|0]),(f|0)!=255&&(A=i[24201],i[r+40>>2]=i[24200],i[r+44>>2]=A,X[i[(r+40|0)+(f<<2)>>2]](r+39|0,r+12|0)),v=r+48|0,e|0}function bC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),Q[k+98>>1]=n,k=e,n=o2(r),Q[k+100>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function iV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=59120;i:{if(!f)break i;for(;;){if(t=100,f-k>>>0<4){k=7,n=59128;break i}if(n=k+4|0,k=r+k|0,k=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=k<<24|(k&65280)<<8|(k>>>8&65280|k>>>24),f-n>>>0<k>>>0){k=7,n=59128;break i}if(t=0,Jf(i[e>>2],r+n|0,k,0,0,0),k=k+n|0,!(k>>>0<f>>>0))break}k=0,n=59120}i[A+8>>2]=n,i[A+4>>2]=t,i[A>>2]=k}function eV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;for(var n=0,t=0,o=0,s=0,w=0,h=0;;){i:{if((r|0)==(f|0)|k>>>0<=s>>>0)break i;o=1,n=v-16|0,v=n,i[n+12>>2]=i[A+8>>2],t=s8(n+8|0,n+12|0),w=ne(0,r,f-r|0,e||129452),t=i[t>>2],t&&(i[31378]=(t|0)==-1?125392:t),v=n+16|0;e:switch(w+2|0){default:o=w;break;case 0:case 1:break i;case 2:break e}s=s+1|0,h=o+h|0,r=r+o|0;continue}break}return h|0}function rV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;i:{if(f)for(;;){if(s=100,w=7,t=59128,f-n>>>0<4||(o=n+4|0,n=r+n|0,n=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),n=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24),t=59128,f-o>>>0<n>>>0))break i;if(Jf(i[e>>2],r+o|0,n,0,0,k),n=n+o|0,!(n>>>0<f>>>0))break}w=0,s=0,t=59120}i[A+8>>2]=t,i[A+4>>2]=s,i[A>>2]=w}function x2(A,e,r){var f=0,k=0;f=v-16|0,v=f,k=F0(r),i[e+100>>2]=k&16777215,u[e+97|0]=k>>>24,i[e+32>>2]=i[e+32>>2]+4;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function fV(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A+24>>2],r>>>0>u0[A+44>>2]&&(i[A+44>>2]=r);i:{if(r=i[A+8>>2],f=i[A+12>>2],r>>>0>=f>>>0)break i;if((e|0)==-1)return i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f-1,i[A+8>>2]=r,((e|0)!=-1?e:0)|0;if(f=i[A+12>>2]-1|0,!(l[A+48|0]&16)&l[f|0]!=(e&255))break i;return r=i[A+8>>2],i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f,i[A+8>>2]=r,u[i[A+12>>2]]=e<<24>>24,e|0}return-1}function AV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((r|0)>0)for(s=r&2147483646,w=r&1;;){if(f=0,k=0,o=0,(r|0)!=1)for(;t=G(r,f)+n|0,k=Q[(t<<1)+e>>1]+k|0,i[(t<<2)+A>>2]=k,t=G(f|1,r)+n|0,k=k+Q[(t<<1)+e>>1]|0,i[(t<<2)+A>>2]=k,f=f+2|0,o=o+2|0,(s|0)!=(o|0););if(w&&(f=G(r,f)+n|0,i[(f<<2)+A>>2]=Q[(f<<1)+e>>1]+k),n=n+1|0,(n|0)==(r|0))break}}function kV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,0),u2(r,0),u2(r,F[e+98>>1]),Du(f+28|0,e,r),u[f+47|0]<0&&Z(i[f+36>>2]),f1(f+8|0,e,r,k),u[f+27|0]<0&&Z(i[f+16>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+48|0}function Fu(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{if((A|0)!=(e|0)){t=i[31336],i[31336]=0,a2(),A=b6(A,k+12|0,f,0,-2147483648),f=l0,n=i[31336];r:{if(n){if(i[k+12>>2]!=(e|0))break r;if((n|0)==68)break e;break i}if(i[31336]=t,i[k+12>>2]==(e|0))break i}}i[r>>2]=4,A=0,f=0;break i}if(i[r>>2]=4,!!A&(f|0)>=0|(f|0)>0){A=-1,f=2147483647;break i}A=0,f=-2147483648}return v=k+16|0,l0=f,A}function Eu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+8>>2],A?A=l[A+164|0]:A=1,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=r+16|0,A|0}function pu(A){var e=0,r=0,f=0;r=i[A+8>>2],r&&X[r|0](),e=i[26939];i:{e:{if(!e){f=107756,r=107756;break e}for(;;){if(r=e,e=i[e+16>>2],e>>>0>A>>>0){if(f=r,e=i[r>>2],e)continue;break e}if(A>>>0<=e>>>0)break i;if(e=i[r+4>>2],!e)break}f=r+4|0}e=E(20),i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=A,i[f>>2]=e,A=i[i[26938]>>2],A&&(i[26938]=A),m1(i[26939],e),i[26940]=i[26940]+1}}function yu(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(t=f>>>0<=1?1:f,o=i[e>>2],s=i[A>>2],f=vr((n|0)!=2072?i[A>>2]:0,t),f){(n|0)!=2072&&(i[A>>2]=0),i[k+4>>2]=2071,f=g1(k+8|0,f,k+4|0),Yl(A,f),n=i[f>>2],i[f>>2]=0,n&&X[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(o-s|0),i[r>>2]=t+i[A>>2],v=k+16|0;return}Q1(),H()}function nV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=f,e=i[e+64>>2];i:{if(l[e+103|0]){t=2,k=0;break i}if(f=l[e+104|0],e=l[e+105|0],k=1,(f|0)==1&(e|0)==1||(k=2,!(e|(f|0)!=1)))break i;k=e|f?99:3}if(i[n>>2]=k,i[r>>2]=t,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function tV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,o6(n|1,10154,1,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+123|0,t=h4(k,13,t,n,A)+k|0,s=x4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Vr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=j8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function uV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,o6(n|1,10154,0,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+123|0,t=h4(k,13,t,n,A)+k|0,s=x4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Vr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=j8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function f4(A,e){var r=0,f=0,k=0;if(r=i[A+16>>2],r>>>0<e>>>0){if(r){if(e=i[A+8>>2],e){for(;i[e+16>>2]=i[e+16>>2]-r,e=i[e+8>>2],!!e;);r=i[A+16>>2]}f=i[A>>2],e=X[i[i[f>>2]+8>>2]](f)|0,k=l0,e=e+r|0,k=e>>>0<r>>>0?k+1|0:k,X[i[i[f>>2]+20>>2]](f,e,k)|0,i[A+16>>2]=0}return u[A+20|0]=1,0}f=i[A+8>>2];i:{if(f){if(r=0,!f4(f,e))break i;r=i[A+16>>2]}i[A+16>>2]=r-e,r=1}return r}function Yu(A,e,r){var f=0,k=0,n=M(0),t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31336],i[31336]=0,a2(),f=v-16|0,v=f,zA(f,A,k+12|0,0),n=En(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[31336],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[31336]=t,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=M(0)}i[r>>2]=4}return v=k+16|0,n}function si(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(t=f||4,o=i[e>>2],s=i[A>>2],f=vr((n|0)!=2072?i[A>>2]:0,t),f){(n|0)!=2072&&(i[A>>2]=0),i[k+4>>2]=2071,f=g1(k+8|0,f,k+4|0),Yl(A,f),n=i[f>>2],i[f>>2]=0,n&&X[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(o-s|0),i[r>>2]=i[A>>2]+(t&-4),v=k+16|0;return}Q1(),H()}function L2(A,e){var r=0,f=0,k=0;i:{if(r=al(e),f=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:1,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,r>>>0<=f>>>0){l[A+11|0]>>>7|0?f=i[A>>2]:f=A;e:{if(!r||(k=r<<2,!k))break e;z(f,e,k)}e=v-16|0,v=e;e:if(l[A+11|0]>>>7|0)break e;x6(A,r),i[e+12>>2]=0,i[f+(r<<2)>>2]=i[e+12>>2],v=e+16|0;break i}xn(A,f,r-f|0,k,0,k,r,e)}}function Ru(A,e){var r=0;return i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,u[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+12>>2]=0,i[A+16>>2]=4740,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,r=A- -64|0,i[r>>2]=0,i[r+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A>>2]=106588,o0(A+100|0,0,188),i[A+20>>2]=e,A}function oV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,o6(n|1,10154,1,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+43|0,t=h4(k,13,t,n,A)+k|0,s=x4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Fr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=O8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function lV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,F[e+104>>1]),u2(r,F[e+106>>1]),u2(r,F[e+108>>1]),u2(r,F[e+110>>1]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function sV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,o6(n|1,10154,0,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+43|0,t=h4(k,13,t,n,A)+k|0,s=x4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Fr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=O8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function Ju(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!r)return 0;i:{e:{r:{if(!A||(f=i[A>>2],!f)||(A=i[f+128>>2],!A))break r;for(k=f+128|0,f=k;n=i[A+16>>2]<(e|0),f=n?f:A,A=i[(n?4:0)+A>>2],!!A;);if((f|0)==(k|0))break r;if(k=0,A=0,i[f+16>>2]>(e|0))break e;if(A=0,k=i[f+56>>2],(k|0)<0)break i;A=i[f+44>>2];break e}k=0,A=0}i[r>>2]=k}return A|0}function Nu(A,e){A=A|0,e=e|0;var r=0;if((e|0)<8)return 3;i:{e:{if(l[A+4|0]!=102|l[A+5|0]!=116|(l[A+6|0]!=121|l[A+7|0]!=112))break e;if(e>>>0<12)return 3;r=1,A=Ro(A,e);r:{if((A|0)<=1781689192){if((A|0)==1635150182|(A|0)==1751476579)break e;if((A|0)!=1751476600)break r;break e}if(A-1835623985>>>0<2)break i;if((A|0)==1781689193|(A|0)==1785750887)break e}r=2}return r|0}return 3}function IA(A,e,r){var f=0,k=0;i:{f=i[e+100>>2],e=i[e+104>>2];e:{if((f|0)!=(e|0))for(;;){if(i[f>>2]==(r|0)){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[f+8>>2],r=i[f+4>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=E(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k;return}if(f=f+16|0,(e|0)==(f|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}G0(),H()}function F0(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,4))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(X[i[i[f>>2]+16>>2]](f,r+12|0,4)|0)){i8(A),f=0;break e}A=l[r+12|0]|l[r+13|0]<<8|(l[r+14|0]<<16|l[r+15|0]<<24),f=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=r+16|0,f}function wV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[A>>2],f=i[A+244>>2],r=i[A+248>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f){A=i[f+100>>2],f=i[f+104>>2];i:{if((A|0)!=(f|0))for(;;){if(k=i[A+8>>2]-i[A+4>>2]>>2,i[A>>2]==(e|0))break i;if(A=A+16|0,(f|0)==(A|0))break}k=0}A=k}else A=0;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;X[i[i[r>>2]+8>>2]](r),p(r)}return A|0}function Mu(A,e,r){var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31336],i[31336]=0,a2(),f=v-16|0,v=f,zA(f,A,k+12|0,1),n=Pf(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[31336],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[31336]=t,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=0}i[r>>2]=4}return v=k+16|0,n}function hV(A){A=A|0;var e=0,r=0,f=0,k=0;f=-1,e=i[A+104>>2],A=i[A+108>>2];i:{if((e|0)==(A|0))break i;for(;;){e:{r:{if(r=i[e>>2],!r||(r=X0(r,86628,100420),!r))break r;if(A=i[e+4>>2],A)break e;return l[r+104|0]}if(e=e+8|0,(A|0)!=(e|0))continue;break i}break}if(e=i[A+4>>2],k=e+1|0,i[A+4>>2]=k,f=l[r+104|0],i[A+4>>2]=e,k)break i;X[i[i[A>>2]+8>>2]](A),p(A)}return f|0}function _V(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=G(W2(r)&3,90),i[k+100>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function BV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=ir()|0;i:{if(!e){i[A+4>>2]=k,i[A>>2]=125416;break i}af(f+8|0,e,r,f+20|0);e:{if(i[f+8>>2]){e=E(12),i[e+8>>2]=i[f+16>>2],r=i[f+12>>2],i[e>>2]=i[f+8>>2],i[e+4>>2]=r,i[f+24>>2]=e,e=y1(96308,f+24|0)|0;break e}i[f+24>>2]=i[f+20>>2],e=y1(96384,f+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=125416,k>>>0<9)break i;o1(k|0)}v=f+32|0}function vV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=f+12|0,r4(k,i[A+100>>2],i[i[A+460>>2]>>2],1),A=i[f+16>>2],n=k,k=i[f+12>>2],X[i[i[k>>2]+52>>2]](n,k),n=i[f+12>>2],u[f+31|0]<0&&Z(i[f+20>>2]),n&&(i[r>>2]=0,i[e>>2]=0),i[e>>2]=i[k+120>>2],i[r>>2]=i[k+124>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=f+32|0}function mV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-16|0,v=n;i:{if(f&&(A=0,(k|0)<=0))break i;Rr(n+4|0,e,r),t=i[n+8>>2],r=i[n+4>>2],e=t-r>>2;e:{r:{if(!f){A=e;break r}if(A=0,(r|0)==(t|0)|(k|0)<=0)break r;for(;;){if(t=A<<2,i[t+f>>2]=i[r+t>>2],A=A+1|0,(k|0)<=(A|0))break e;if(!(A>>>0<e>>>0))break}break e}if(!r)break i}Z(r)}return v=n+16|0,A|0}function ZV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;return A=v-208|0,v=A,n=a2(),i[A>>2]=k,t=A+176|0,s=h4(t,20,n,7929,A),o=t+s|0,w=x4(t,o,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(k,129800),e2(k),X[i[i[n>>2]+48>>2]](n,t,o,k)|0,n=e,e=k+(s<<2)|0,e=j8(n,k,(o|0)==(w|0)?e:((w-A<<2)+A|0)-688|0,e,r,f),v=A+208|0,e|0}function D4(A,e,r){var f=0,k=0;i:{if(!i[e>>2]){A=0;break i}if(r2(A+104|0,e),f=i[A+100>>2],k=i[f+48>>2],f=i[f+52>>2],!f){A=f3(k,i[A+116>>2],e,r);break i}if(i[f+4>>2]=i[f+4>>2]+1,A=f3(k,i[A+116>>2],e,r),r=i[f+4>>2],i[f+4>>2]=r-1,r)break i;X[i[i[f>>2]+8>>2]](f),p(f)}e=i[e+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A}function CA(A){var e=0,r=0,f=0;f=v-16|0,v=f,D2(+A),r=t2(1)|0,t2(0)|0,r=r&2147483647;i:{if(r>>>0<=1072243195){if(e=1,r>>>0<1044816030)break i;e=We(A,0);break i}if(e=A-A,r>>>0>=2146435072)break i;r=a7(A,f),A=t0[f+8>>3],e=t0[f>>3];e:switch((r&3)-1|0){default:e=We(e,A);break i;case 0:e=-_e(e,A,1);break i;case 1:e=-We(e,A);break i;case 2:break e}e=_e(e,A,1)}return v=f+16|0,e}function GV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98008;i:{if(l[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}return A|0}function WV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=W2(r)&1,i[k+100>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function XV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=ir()|0;i:{if(!e){i[A+4>>2]=f,i[A>>2]=125416;break i}Qn(r+8|0,e,r+20|0);e:{if(i[r+8>>2]){e=E(12),i[e+8>>2]=i[r+16>>2],k=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=k,i[r+24>>2]=e,e=y1(96308,r+24|0)|0;break e}i[r+24>>2]=i[r+20>>2],e=y1(96384,r+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=125416,f>>>0<9)break i;o1(f|0)}v=r+32|0}function VA(A){var e=0,r=0,f=0;r=v-16|0,v=r,D2(+A),e=t2(1)|0,t2(0)|0,e=e&2147483647;i:{if(e>>>0<=1072243195){if(e>>>0<1045430272)break i;A=_e(A,0,0);break i}if(e>>>0>=2146435072){A=A-A;break i}e=a7(A,r),A=t0[r+8>>3],f=t0[r>>3];e:switch((e&3)-1|0){default:A=_e(f,A,1);break i;case 0:A=We(f,A);break i;case 1:A=-_e(f,A,1);break i;case 2:break e}A=-We(f,A)}return v=r+16|0,A}function Uu(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;if(u[A+44|0]=1,u[A|0]=1,gn(A,e),(r|0)>=2){for(k=r-1|0,t=A+52|0;n=G(f,52)+t|0,o=n,s=v0(e,1),u[o|0]=s,o=n,s=v0(e,1),u[o+44|0]=s,f=f+1|0,(k|0)!=(f|0););if(r-2>>>0<7)for(f=k;y6(e,2),f=f+1|0,(f|0)!=8;);for(A=A+52|0,f=0;gn(A+G(f,52)|0,e),f=f+1|0,(k|0)!=(f|0););}}function gV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),Q[k+98>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function FA(A,e){var r=0,f=0,k=0,n=0,t=0;if(r=i[A+108>>2],f=i[A+112>>2],r>>>0<f>>>0){u[r|0]=e,i[A+108>>2]=r+1;return}if(n=i[A+104>>2],r=r-n|0,k=r+1|0,(k|0)>=0){f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<t>>>0?t:k,f?k=E(f):k=0,t=k+r|0,u[t|0]=e,r&&z(k,n,r),i[A+112>>2]=f+k,e=t+1|0,i[A+108>>2]=e,i[A+104>>2]=k,n&&Z(n),i[A+108>>2]=e;return}G0(),H()}function Du(A,e,r){var f=0,k=0;i:{if(f=i[e+36>>2],e=i[e+40>>2],(f|0)!=(e|0))for(;;){if(k=i[f>>2],X[i[i[k>>2]+20>>2]](A,k,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(e|0)==(f|0))break}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}}function QV(A,e){A=A|0,e=e|0;var r=0,f=0;i:{r=i[A>>2],f=i[r+48>>2],A=i[r+52>>2];e:{if(!A){sr(f);break e}if(i[A+4>>2]=i[A+4>>2]+1,sr(f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;X[i[i[A>>2]+8>>2]](A),p(A)}if(A=i[r+48>>2],r=i[A+148>>2],A=i[A+152>>2],!A){i[r+120>>2]=e;break i}i[A+4>>2]=i[A+4>>2]+1,i[r+120>>2]=e,e=i[A+4>>2],i[A+4>>2]=e-1,e||(X[i[i[A>>2]+8>>2]](A),p(A))}}function IV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99024;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function CV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=W2(r),u[k+97|0]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,K(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+16|0}function VV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98704;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function FV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98008;i:{if(l[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}Z(A)}function EV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;return A=v-96|0,v=A,n=a2(),i[A>>2]=k,t=A- -64|0,s=h4(t,20,n,7929,A),o=t+s|0,w=x4(t,o,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=129624&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(k,129808),e2(k),X[i[i[n>>2]+32>>2]](n,t,o,k)|0,n=e,e=k+s|0,e=O8(n,k,(o|0)==(w|0)?e:((w-A|0)+A|0)-48|0,e,r,f),v=A+96|0,e|0}function R6(A,e){var r=0,f=0,k=0,n=0,t=0;k=i[A+36>>2],t=i[A+40>>2];i:{if((k|0)!=(t|0))for(;;){f=i[(r<<3)+k>>2];e:{if(!f||(n=i[e>>2],!n|i[f+36>>2]!=i[f+40>>2]|i[n+36>>2]!=i[n+40>>2]))break e;if(X[i[i[f>>2]+32>>2]](f,n)|0)break i;k=i[A+36>>2],t=i[A+40>>2]}if(r=r+1|0,!(r>>>0<t-k>>3>>>0))break}r2(A+36|0,e),r=(i[A+40>>2]-i[A+36>>2]>>3)-1|0}return r}function EA(A,e){var r=0,f=0,k=0,n=0;n=v-32|0,v=n,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+32>>2];i:{if(e=i[e+28>>2],(k|0)!=(e|0)){if(r=k-e|0,(r|0)<0)break i;for(f=E(r),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+r;i[f>>2]=i[e>>2],r=i[e+4>>2],i[f+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=f+8|0,e=e+8|0,(k|0)!=(e|0););i[A+4>>2]=f}v=n+32|0;return}G0(),H()}function pV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,i[e+104>>2]),C0(r,i[e+108>>2]),C0(r,i[e+112>>2]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function pA(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127;i:{if(f-k>>>0>=r>>>0){if(t=!r,t)break i;l[A+11|0]>>>7|0?f=i[A>>2]:f=A,o=f+k|0,t||z(o,e,r),e=r+k|0,x6(A,e),u[n+15|0]=0,u[e+f|0]=l[n+15|0];break i}Jr(A,f,(r-f|0)+k|0,k,k,0,r,e)}return v=n+16|0,A}function qr(A,e,r){var f=0,k=0;for(r&2048&&(u[A|0]=43,A=A+1|0),r&1024&&(u[A|0]=35,A=A+1|0),f=r&260,(f|0)!=260&&(u[A|0]=46,u[A+1|0]=42,A=A+2|0),r=r&16384;;){if(k=l[e|0],k){u[A|0]=k,A=A+1|0,e=e+1|0;continue}break}i:{e:{if((f|0)!=256){if((f|0)!=4)break e;e=r?70:102;break i}e=r?69:101;break i}if(e=r?65:97,(f|0)==260)break i;e=r?71:103}return u[A|0]=e,(f|0)!=260}function J6(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=u0[r+16>>2]<e>>>0,A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);r=0;i:{if((A|0)==(f|0)|u0[A+16>>2]>e>>>0||(e=i[A+20>>2],A=i[A+24>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),r=e?i[e+112>>2]:0,!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return r}function Hu(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99024;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function yV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98704;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;X[i[i[e>>2]+8>>2]](e),p(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function YV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C0(r,l[e+105|0]<<30|l[e+104|0]<<31|l[e+106|0]<<26),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function xu(A){var e=0;i:{e:{r:{f:{A:{if((A|0)<=1785750886){if((A|0)==1635135537)break f;if((A|0)==1752589105)break A;if((A|0)!=1781689137)break e;return 7}if((A|0)<=1970168680){if(e=3,(A|0)==1785750887)break i;if((A|0)!=1836280681)break e;return 9}if((A|0)==1970168681)break r;if((A|0)!=1987470129)break e;return 5}return 1}return 4}return 8}e=0}return e}function RV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(F[f+20>>1]|!(i[r>>2]==1&(i[r+4>>2]&-2)==10)||(r=l[f+22|0],!r))break i;k=l[f+8|0],f=i[f+16>>2],e=E(28),i[e+24>>2]=11,u[e+22|0]=r,Q[e+20>>1]=0,i[e+16>>2]=f,i[e+12>>2]=8,u[e+8|0]=k,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function JV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=v-16|0,v=n;i:{if((f|0)<=0&&r)break i;Rr(n+4|0,A,e),t=i[n+8>>2],e=i[n+4>>2],A=t-e>>2;e:{r:{if(!r){k=A;break r}if((e|0)==(t|0)|(f|0)<=0)break r;for(;;){if(t=k<<2,i[t+r>>2]=i[e+t>>2],k=k+1|0,(k|0)>=(f|0))break e;if(!(A>>>0>k>>>0))break}break e}if(!e)break i}Z(e)}return v=n+16|0,k|0}function NV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;X[i[i[A>>2]+8>>2]](A),p(A)}i[f+100>>2]=e,Hr(f,e);i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}}function MV(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(!S1(A,i[e>>2],k))break i;if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+20>>2]=r,i[e+32>>2]=f,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2||(u[e+54|0]=1),i[e+44>>2]=4}}function UV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{r=i[e+64>>2];e:{if(r){if(i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,e=0,n=i[r+104>>2],r=i[r+100>>2],(n|0)!=(r|0)){if(e=n-r|0,(e|0)<0)break i;k=E(e),e&&z(k,r,e),e=e+k|0}u[A+20|0]=0,i[A+8>>2]=e,i[A+4>>2]=e,i[A>>2]=k;break e}i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0}v=f+16|0;return}G0(),H()}function DV(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,C6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r?r=X[i[i[r>>2]+68>>2]](r)|0:r=-1,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function HV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,x2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(!l[e+97|0]){n=o2(r);break i}n=F0(r)}i:{if(!n){if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931]);break i}d6(A,e,r,n,f)}v=k+32|0}function zu(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,C6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r?r=X[i[i[r>>2]+64>>2]](r)|0:r=-1,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function yA(A){var e=0,r=0,f=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=X0(r,86628,86648),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+104>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+104>>2],i[A+4>>2]=e,f||(X[i[i[A>>2]+8>>2]](A),p(A)),r}function YA(A){var e=0,r=0,f=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=X0(r,86628,86648),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+108>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+108>>2],i[A+4>>2]=e,f||(X[i[i[A>>2]+8>>2]](A),p(A)),r}function xV(A){return A=A|0,l[129892]?i[32472]:(l[130376]||(u[130376]=1),L2(130208,83756),L2(130220,83784),L2(130232,83812),L2(130244,83844),L2(130256,83884),L2(130268,83920),L2(130280,83948),L2(130292,83984),L2(130304,84e3),L2(130316,84016),L2(130328,84032),L2(130340,84048),L2(130352,84064),L2(130364,84080),u[129892]=1,i[32472]=130208,130208)}function zV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-16|0,v=f,k=i[r>>2],k>>>0<2147483640){t=i[A>>2];i:{e:{if(k>>>0>=11){n=k|7,A=E(n+1|0),i[f+12>>2]=n-2147483647,i[f+4>>2]=A,i[f+8>>2]=k;break e}if(u[f+15|0]=k,A=f+4|0,!k)break i}if(!k)break i;z(A,r+4|0,k)}u[A+k|0]=0,X[t|0](e,f+4|0),u[f+15|0]<0&&Z(i[f+4>>2]),v=f+16|0;return}g0(),H()}function Tu(A){A=A|0;var e=0,r=0,f=0,k=0;for(i[A>>2]=78040,k=A+8|0;;){if(e=i[A+8>>2],i[A+12>>2]-e>>2>>>0>r>>>0){e=i[e+(r<<2)>>2],e&&(f=i[e+4>>2]-1|0,i[e+4>>2]=f,(f|0)==-1&&X[i[i[e>>2]+8>>2]](e)),r=r+1|0;continue}break}return s2(A+144|0),e=v-16|0,v=e,i[e+12>>2]=k,r=i[e+12>>2],i[r>>2]&&(Aw(r),jl(i[e+12>>2]+12|0,i[i[e+12>>2]>>2])),v=e+16|0,A|0}function TV(A){A=A|0;var e=0,r=0;r=A+12|0,e=i[r+8496>>2],e&&(i[r+8500>>2]=e,Z(e)),e=i[r+8484>>2],e&&(i[r+8488>>2]=e,Z(e)),e=i[r+8472>>2],e&&(i[r+8476>>2]=e,Z(e)),e=i[r+8460>>2],e&&(i[r+8464>>2]=e,Z(e)),e=i[r+8448>>2],e&&(i[r+8452>>2]=e,Z(e)),A=i[A+20>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function Su(A,e,r){var f=0,k=0,n=0;i:{e:{if(l[A+46|0]){if(k=i[A+48>>2],(k|0)>0)break e;break i}return!(e|r)}for(n=A+8360|0;;){if(i[(f<<2)+n>>2]!=(e|0)){if(f=f+1|0,(k|0)!=(f|0))continue;break i}break}if(f=0,e=i[A+52>>2],(e|0)<=0)return 0;for(A=A+8404|0;k=i[A+(f<<2)>>2]==(r|0),!k&&(f=f+1|0,(e|0)!=(f|0)););return k}return 0}function SV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;return k=i[A+84>>2],n=i[k>>2],f=i[k+4>>2],o=i[A+28>>2],t=i[A+20>>2]-o|0,t=f>>>0<t>>>0?f:t,t&&(A8(n,o,t),n=t+i[k>>2]|0,i[k>>2]=n,f=i[k+4>>2]-t|0,i[k+4>>2]=f),f=r>>>0>f>>>0?f:r,f&&(A8(n,e,f),n=f+i[k>>2]|0,i[k>>2]=n,i[k+4>>2]=i[k+4>>2]-f),u[n|0]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,r|0}function RA(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-48|0,v=k,n=i[i[A>>2]-12>>2]+A|0,t=i[n+16>>2]&-3,H1(n,t),dA(k+47|0,A),l[k+47|0]&&(n=k+24|0,o=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],X[i[i[o>>2]+16>>2]](n,o,e,r,f,8),e=k+8|0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=0,i[e+4>>2]=0,m4(i[i[A>>2]-12>>2]+A|0,i[e+8>>2]==i[n+8>>2]&i[n+12>>2]==i[e+12>>2]?t|4:t)),v=k+48|0}function jV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)!=31)for(h=r+5|0,s=1<<r;;){for(_=A+t|0,B=(t<<1)+e|0,k=0,o=0;o=((Q[(k<<r<<1)+B>>1]<<h)+2048>>12)+o|0,w=G(f,k)+_|0,n=o+l[w|0]|0,n=(n|0)>=255?255:n,u[w|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(t=t+1|0,(s|0)==(t|0))break}}function OV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)!=31)for(h=r+5|0,s=1<<r;;){for(_=G(f,t)+A|0,B=(t<<r<<1)+e|0,k=0,o=0;o=((Q[(k<<1)+B>>1]<<h)+2048>>12)+o|0,w=k+_|0,n=o+l[w|0]|0,n=(n|0)>=255?255:n,u[w|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(t=t+1|0,(s|0)==(t|0))break}}function LV(A){return A=A|0,l[129884]?i[32470]:(l[130200]||(u[130200]=1),R2(130032,1732),R2(130044,1739),R2(130056,1705),R2(130068,1713),R2(130080,1696),R2(130092,1746),R2(130104,1723),R2(130116,7994),R2(130128,9212),R2(130140,12072),R2(130152,17832),R2(130164,3098),R2(130176,10553),R2(130188,4378),u[129884]=1,i[32470]=130032,130032)}function PV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,r=i[e+16>>2],i[f>>2]=i[e+12>>2],i[f+4>>2]=r,e=f+16|0,Kr(e,17864,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}g0(),H()}function JA(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){i[e+12>>2]=A,u[e+8|0]=0,i[(i[i[A>>2]-12>>2]+A|0)+16>>2]||(r=i[(i[i[A>>2]-12>>2]+A|0)+72>>2],r&&JA(r),u[e+8|0]=1);i:{if(!l[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(X[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;m4(i[i[A>>2]-12>>2]+A|0,1)}_1(e+8|0)}v=e+16|0}function qV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(s=i[e+12>>2],i[e+12>>2]=i[A+120>>2],f=i[A+128>>2],n=i[A+132>>2],(f|0)!=(n|0))for(;;){k=i[f+4>>2],t=i[f>>2],o=r+t|0,k=r>>>0>o>>>0?k+1|0:k;i:{if(!l[A+97|0]){if((k|0)==1|k>>>0>1){C0(e,0);break i}C0(e,r+t|0);break i}e4(e,o,k)}if(f=f+8|0,(n|0)==(f|0))break}i[e+12>>2]=s}function NA(A,e,r,f){u[A+53|0]=1;i:{if(i[A+4>>2]!=(r|0))break i;u[A+52|0]=1,r=i[A+16>>2];e:{if(!r){if(i[A+36>>2]=1,i[A+24>>2]=f,i[A+16>>2]=e,(f|0)!=1)break i;if(i[A+48>>2]==1)break e;break i}if((e|0)==(r|0)){if(r=i[A+24>>2],(r|0)==2&&(i[A+24>>2]=f,r=f),i[A+48>>2]!=1)break i;if((r|0)==1)break e;break i}i[A+36>>2]=i[A+36>>2]+1}u[A+54|0]=1}}function KV(A){A=A|0;var e=0,r=0;if(A){e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}}function A4(A,e){i:{if((e|0)>=1024){if(A=A*898846567431158e293,e>>>0<2047){e=e-1023|0;break i}A=A*898846567431158e293,e=(e>>>0>=3069?3069:e)-2046|0;break i}if((e|0)>-1023)break i;if(A=A*2004168360008973e-307,e>>>0>4294965304){e=e+969|0;break i}A=A*2004168360008973e-307,e=(e>>>0<=4294964336?-2960:e)+1938|0}return U2(0,0),U2(1,e+1023<<20),A*+r1()}function aV(A,e){A=A|0,e=e|0;var r=0,f=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2];i:{if(!r){Hr(f,e);break i}if(i[r+4>>2]=i[r+4>>2]+1,Hr(f,e),e=i[r+4>>2],i[r+4>>2]=e-1,e)break i;X[i[i[r>>2]+8>>2]](r),p(r)}i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function $V(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,f=i[e>>2],f>>>0<2147483640){i:{e:{if(f>>>0>=11){n=f|7,k=E(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break e}if(u[r+15|0]=f,k=r+4|0,!f)break i}if(!f)break i;z(k,e+4|0,f)}return u[f+k|0]=0,A=X[A|0](r+4|0)|0,u[r+15|0]<0&&Z(i[r+4>>2]),v=r+16|0,A|0}g0(),H()}function ju(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;f=A+18548|0,r=v2(f,i[A+18572>>2]+150|0),k=1,n=v2(f,i[A+18572>>2]+150|0),t=1,r&&(t=!v2(f,i[A+18572>>2]+151|0)),n&&(k=!v2(f,i[A+18572>>2]+151|0)),r&&(r=-1,t||(r=rA(f,1)),o=k4(f)?65534-r|0:r+2|0),e=(e<<2)+A|0,n?(r=-1,k||(r=rA(f,1)),A=k4(f)?65534-r|0:r+2|0):A=0,Q[e+20>>1]=A,Q[e+18>>1]=o}function dV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=12)&&(r=i[r+12>>2],(r|0)>8))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=l[f+8|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=r,u[e+8|0]=f,i[e>>2]=1,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function Ou(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,C6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r=X[i[i[r>>2]+68>>2]](r)|0,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function cV(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,C6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r=X[i[i[r>>2]+64>>2]](r)|0,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function bV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,On(r+4|0,i[A>>2],e),k=i[r+8>>2],e=i[r+4>>2],e){if(A=e,(e|0)!=(k|0)){for(A=k;;){f=i[A-4>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;X[i[i[f>>2]+8>>2]](f),p(f)}if(A=A-8|0,(e|0)==(A|0))break}A=i[r+4>>2]}i[r+8>>2]=e,Z(A)}return v=r+16|0,k-e>>3}function t6(A){var e=0,r=0,f=0;return l[A+80|0]||(r=v-16|0,v=r,f=r+12|0,e=i[A+28>>2],i[f>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(f,129808),e=X[i[i[e>>2]+28>>2]](e,32)|0,e2(f),v=r+16|0,u[A+76|0]=e,u[A+77|0]=e>>>8,u[A+78|0]=e>>>16,u[A+79|0]=e>>>24,u[A+80|0]=1),(l[A+76|0]|l[A+77|0]<<8|(l[A+78|0]<<16|l[A+79|0]<<24))<<24>>24}function Lu(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;e=v-16|0,v=e,k=e+16|0;i:{for(;;){if(f=i[A+36>>2],r=e+8|0,n=X[i[i[f>>2]+20>>2]](f,i[A+40>>2],r,k,e+4|0)|0,f=-1,t=r,r=i[e+4>>2]-r|0,(L1(t,1,r,i[A+32>>2])|0)!=(r|0))break i;e:switch(n-1|0){case 1:break i;case 0:continue;default:break e}break}f=n6(i[A+32>>2])?-1:0}return v=e+16|0,f|0}function MA(A){var e=0,r=0,f=0;e=i[A+12>>2]-2|0,i[A+12>>2]=e,f=1,r=i[A+16>>2],e=e<<7;i:{if(r>>>0>=e>>>0||(f=0,e>>>0>32767)||(r=r<<1,i[A+16>>2]=r,i[A+12>>2]=e>>>6,e=F[A+20>>1]+1|0,Q[A+20>>1]=e,(e|0)==(e&65535))||(Q[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=e+1,i[A+16>>2]=r+l[e|0]}return f}function iF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;return f=i[A+44>>2],k=i[A+40>>2],t=r+k|0,f=t>>>0<r>>>0?f+1|0:f,n=i[A+36>>2],o=i[A+32>>2],(f|0)==(n|0)&o>>>0>=t>>>0|f>>>0<n>>>0&&(r&&z(e,i[A+24>>2]+k|0,r),k=i[A+44>>2],e=r+i[A+40>>2]|0,k=e>>>0<r>>>0?k+1|0:k,i[A+40>>2]=e,i[A+44>>2]=k),(f|0)==(n|0)&t>>>0<=o>>>0|f>>>0<n>>>0}function V8(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k,i[k+12>>2]=e,i[k+8>>2]=f,t=s8(k+4|0,k+12|0),e=v-16|0,v=e,f=i[k+8>>2],i[e+12>>2]=f,i[e+8>>2]=f,n=-1,f=br(0,0,r,f);i:{if((f|0)<0||(o=A,f=f+1|0,A=p2(f),i[o>>2]=A,!A))break i;n=br(A,f,r,i[e+12>>2])}return v=e+16|0,A=i[t>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=k+16|0,n}function Pu(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(l[A+80|0]!=1)break i;e:{if(u[A+79|0]>=0){i[e+8>>2]=i[A+76>>2],r=i[A+72>>2],i[e>>2]=i[A+68>>2],i[e+4>>2]=r;break e}T(e,i[A+68>>2],i[A+72>>2])}if(A=u[e+11|0],r=(A|0)<0,k=E((r?i[e+4>>2]:A)+1|0),f=i[e>>2],r=c4(k,r?f:e),(A|0)>=0)break i;Z(f)}return v=e+16|0,r|0}function UA(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=v-16|0,v=e,EA(e+4|0,i[A>>2]),k=i[e+8>>2],f=i[e+4>>2],f){if(A=f,(k|0)!=(A|0)){for(A=k;;){r=i[A-4>>2];i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(A=A-8|0,(f|0)==(A|0))break}A=i[e+4>>2]}i[e+8>>2]=f,Z(A)}return v=e+16|0,k-f>>3}function eF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;o0(A,0,72),f=i[e+460>>2],k=i[e+452>>2],i[A+4>>2]=((f+k|0)-1>>>0)/(f>>>0),r=i[e+464>>2],n=i[e+456>>2],i[A+24>>2]=n,i[A+20>>2]=k,i[A+16>>2]=r,i[A+12>>2]=f,i[A+8>>2]=((r+n|0)-1>>>0)/(r>>>0),r=l[e+474|0],u[A+36|0]=r;i:{if(!r||(r=(r>>>0>=8?8:r)<<2,!r))break i;z(A+40|0,e+476|0,r)}}function wi(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(X[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){i8(A),f=0;break e}A=l[r+14|0]|l[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=r+16|0,f<<16>>16}function rF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A>>2],A=i[r+260>>2],k=i[r+264>>2],(A|0)==(k|0))return 0;i:{if(!e){r=((k-A|0)-8>>>3|0)+1|0;break i}for(n=h2(e),r=0;f=i[A>>2],t=u[f+15|0],o=(t|0)<0,((o?i[f+8>>2]:t)|0)==(n|0)&&(r=!N2(o?i[f+4>>2]:f+4|0,e,n)+r|0),A=A+8|0,(k|0)!=(A|0););}return r|0}function fF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+104|0]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function o2(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(X[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){i8(A),f=0;break e}A=l[r+14|0]|l[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=r+16|0,f&65535}function AF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=wu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=p2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=y1(96288,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125416,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function kF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=hu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=p2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=y1(96288,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125416,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function nF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=_u(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=p2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=y1(96288,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125416,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function tF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=Qu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=p2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=y1(96288,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125416,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function uF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+97|0]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function qu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,C4(r,e+104|0,1),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function hi(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!r)return 0;i:{if(!A||(f=i[A>>2],!f)||(A=i[f+128>>2],!A))break i;for(k=f+128|0,f=k;n=i[A+16>>2]<(e|0),f=n?f:A,A=i[(n?4:0)+A>>2],!!A;);if((f|0)==(k|0)|i[f+16>>2]>(e|0))break i;return i[r>>2]=i[f+56>>2],i[f+44>>2]}return i[r>>2]=0,0}function oF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(n=v-16|0,v=n,e=i[A+652>>2],e&&(i[A+656>>2]=e,Z(e)),e=i[A+640>>2],e&&(i[A+644>>2]=e,Z(e)),e=i[A+604>>2],e){if(r=e,f=i[A+608>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+604>>2]}i[A+608>>2]=e,Z(r)}v=n+16|0}function lF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=X[i[i[e>>2]+52>>2]](e,r,0)|0,V4(r,e+100|0),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function sF(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e;i:{if(!A){A=0;break i}A=i[A+8>>2];e:{if(u[A+15|0]>=0){i[e+8>>2]=i[A+12>>2],r=i[A+8>>2],i[e>>2]=i[A+4>>2],i[e+4>>2]=r;break e}T(e,i[A+4>>2],i[A+8>>2])}if(r=u[e+11|0],A=(r|0)<0,k=E((A?i[e+4>>2]:r)+1|0),f=i[e>>2],A=c4(k,A?f:e),(r|0)>=0)break i;Z(f)}return v=e+16|0,A|0}function wF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+280>>2],k=i[k+276>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=E(f),f&&z(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&z(e,A,r),A&&Z(A),v=n+16|0,f|0}G0(),H()}function hF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)!=(f|0))for(;;){if(u0[e+40>>2]>65535){u[A+97|0]=1;return}r=i[e+44>>2],k=i[e+48>>2];i:{if((r|0)==(k|0))break i;for(;;){if(u0[r>>2]<65536){if(r=r+4|0,(k|0)!=(r|0))continue;break i}break}n=1}if(e=e+56|0,(f|0)==(e|0))break}u[A+97|0]=n}function DA(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t,n=t+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129800),X[i[i[e>>2]+48>>2]](e,77792,77820,r)|0,e=c0(n,129872),o=f,s=X[i[i[e>>2]+12>>2]](e)|0,i[o>>2]=s,o=k,s=X[i[i[e>>2]+16>>2]](e)|0,i[o>>2]=s,X[i[i[e>>2]+20>>2]](A,e),e2(n),v=t+16|0}function _F(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+440>>2],k=i[k+436>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=E(f),f&&z(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&z(e,A,r),A&&Z(A),v=n+16|0,f|0}G0(),H()}function HA(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t,n=t+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129808),X[i[i[e>>2]+32>>2]](e,77792,77820,r)|0,e=c0(n,129864),o=f,s=X[i[i[e>>2]+12>>2]](e)|0,u[o|0]=s,o=k,s=X[i[i[e>>2]+16>>2]](e)|0,u[o|0]=s,X[i[i[e>>2]+20>>2]](A,e),e2(n),v=t+16|0}function Ku(A,e,r){var f=0,k=0,n=0;k=i[e>>2],n=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,f=i[A+4>>2],i[A>>2]=k,i[A+4>>2]=n;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;X[i[i[f>>2]+8>>2]](f),p(f)}u[A+8|0]=1,i[A+24>>2]=r,A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function au(A,e,r){var f=0,k=0,n=0;if(f=i[r+72>>2],i[r+72>>2]=f-1|f,f=i[r+4>>2],k=i[r+8>>2],(f|0)==(k|0)?f=e:(n=f,f=k-f|0,f=e>>>0>f>>>0?f:e,A8(A,n,f),i[r+4>>2]=f+i[r+4>>2],A=A+f|0,f=e-f|0),f)for(;;){i:{if(!Ge(r)&&(k=X[i[r+32>>2]](r,A,f)|0,k))break i;return e-f|0}if(A=A+k|0,f=f-k|0,!f)break}return e}function BF(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=10)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}r=l[f+8|0],e=E(28),i[e+24>>2]=11,u[e+22|0]=1,Q[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=r,i[e>>2]=1,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function vF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,Kr(e,17911,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}g0(),H()}function mF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,Kr(e,17884,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}g0(),H()}function s4(A,e,r){var f=0,k=0,n=0;i:{f=i[e+128>>2];e:{if(!f)break e;for(k=e+128|0,e=k;n=u0[f+16>>2]<r>>>0,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if((e|0)==(k|0))break e;if(u0[e+16>>2]<=r>>>0)break i}i[A>>2]=0,i[A+4>>2]=0;return}i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function ZF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+8>>2],e=f+16|0,Kr(e,17895,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;z(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}g0(),H()}function GF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+168>>2],e=e>>f,(e|0)<0||(k=i[A+172>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+176>>2])break i;return A=(i[A+160>>2]+G(e,3)|0)+G(G(r,k),3)|0,(l[A|0]|l[A+1|0]<<8)>>>3&7}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function C2(A,e,r){var f=0,k=0;i:{e:{if(!r)break e;if(f=i[A+164>>2],(f|0)>0){for(k=A+84|0,r=0;;){if(i[(r<<2)+k>>2]==(e|0))break i;if(r=r+1|0,(f|0)==(r|0))break}if((f|0)>19)break e}i[A+164>>2]=f+1,i[((f<<2)+A|0)+84>>2]=e}if(r=i[A+80>>2],(r|0)==20){i[A+76>>2]=1001;return}i[A+80>>2]=r+1,i[(r<<2)+A>>2]=e}}function $u(A,e){var r=0,f=0;r=v-32|0,v=r,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0,dA(r+31|0,e),l[r+31|0]&&(f=i[(i[i[e>>2]-12>>2]+e|0)+24>>2],X[i[i[f>>2]+16>>2]](r+8|0,f,0,0,1,8),f=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=f,f=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=f,m4(i[i[e>>2]-12>>2]+e|0,0)),v=r+32|0}function WF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(e=i[A+104>>2],k=i[A+108>>2],(e|0)!=(k|0)){for(;;){if(o=u0[e>>2]>65535,r=i[e+4>>2],n=i[e+8>>2],(r|0)!=(n|0))for(;t=F[r+2>>1]>127|t,r=r+4|0,(n|0)!=(r|0););if(f=o?1:f,e=e+16|0,(k|0)==(e|0))break}r=f,f=t&1}i[A+100>>2]=f,u[A+97|0]=r}function du(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k,e&&(r=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?f=i[A+4>>2]:f=l[A+11|0]&127,r-f>>>0<e>>>0&&uA(A,r,(e-r|0)+f|0,f,f),l[A+11|0]>>>7|0?r=i[A>>2]:r=A,vl(r+f|0,e,0),n=A,A=e+f|0,x6(n,A),u[k+15|0]=0,u[A+r|0]=l[k+15|0]),v=k+16|0}function H4(A,e){var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{if(!e){e=0;break i}r=e>>31,k=(r^e)-r|0,r=k1(k),o4(f,k,0,0,0,r+81|0),k=0+i[f+8>>2]|0,r=(i[f+12>>2]^65536)+(16414-r<<16)|0,r=k>>>0<n>>>0?r+1|0:r,e=(e|0)<0,k=0|k,n=(e?-2147483648:0)|r,r=i[f+4>>2],e=i[f>>2]}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=k,i[A+12>>2]=n,v=f+16|0}function cu(A,e){var r=0;r=v-16|0,v=r;i:{if(l[e+20|0]==1){if(u[r+4|0]=0,u[r+15|0]=0,K(A,2,100,r+4|0),u[r+15|0]>=0)break i;Z(i[r+4>>2]);break i}if(e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=r+16|0}function XF(A,e){A=A|0,e=e|0;var r=0;i[A+8>>2]=1,i[A>>2]=1,i[A+4>>2]=1,i[A+36>>2]=0,r=i[e+120>>2],i[A+12>>2]=r,e=i[e+124>>2],i[A+40>>2]=0,i[A+44>>2]=0,i[A+24>>2]=e,i[A+20>>2]=r,i[A+16>>2]=e,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,e=A- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,u[A+36|0]=0}function xA(A,e,r){var f=0,k=0,n=0;f=i[A>>2],k=f+r&536870911,i[A>>2]=k,i[A+4>>2]=i[A+4>>2]+(f>>>0>k>>>0)+(r>>>29),f=f&63;i:{if(f){if(n=A+24|0,k=f+n|0,f=64-f|0,f>>>0>r>>>0){if(!r)break i;z(k,e,r);return}f&&z(k,e,f),Ar(A,n,64),r=r-f|0,e=e+f|0}if(r>>>0>=64&&(e=Ar(A,e,r&-64),r=r&63),!r)break i;z(A+24|0,e,r)}}function gF(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(u[A+263|0]>=0){i[e+8>>2]=i[A+260>>2],r=i[A+256>>2],i[e>>2]=i[A+252>>2],i[e+4>>2]=r;break i}T(e,i[A+252>>2],i[A+256>>2])}return A=u[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=c4(E(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function QF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-32|0,v=t,o=i[19507],i[t+24>>2]=i[19506],i[t+28>>2]=o,o=i[19505],i[t+16>>2]=i[19504],i[t+20>>2]=o,o=i[19503],i[t+8>>2]=i[19502],i[t+12>>2]=o,o=i[19501],i[t>>2]=i[19500],i[t+4>>2]=o,o=A,A=t+32|0,e=T8(o,e,r,f,k,n,t,A),v=A,e|0}function bu(A,e){var r=0,f=0,k=0;if(e>>>0>8){for(e=e>>>0<=4?4:e,f=A>>>0<=1?1:A;;){i:{if(A=0,r=(e+f|0)-1&0-e,k=r>>>0<f>>>0?f:r,r=v-16|0,v=r,(k>>>0)%(e>>>0)|e&3||(A=pr(r+12|0,e,k),A=A?0:i[r+12>>2]),v=r+16|0,A||(r=i[32839],!r))break i;X[r|0]();continue}break}return A||Z4(),A}return E(A)}function IF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105916,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}return A2(A)|0}function CF(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!i[r+4>>2]&i[r>>2]==2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=l[r+8|0],r=i[r+12>>2],e=E(28),i[e+24>>2]=6,u[e+22|0]=1,Q[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=r,u[e+8|0]=f,i[e>>2]=0,i[e+4>>2]=1,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function VF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e+12>>2],A&&(i[e+16>>2]=A,Z(A)),A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function FF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=104828,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function Kr(A,e,r){var f=0,k=0,n=0,t=0;n=v-16|0,v=n,i[n+12>>2]=r,f=v-160|0,v=f,t=f+8|0,z(t,70336,144),i[f+52>>2]=A,i[f+28>>2]=A,k=-2-A|0,k=k>>>0>2147483647?2147483647:k,i[f+56>>2]=k,k=A+k|0,i[f+36>>2]=k,i[f+24>>2]=k,qs(t,e,r),(A|0)!=-2&&(A=i[f+28>>2],u[A-((A|0)==i[f+24>>2])|0]=0),v=f+160|0,v=n+16|0}function u6(A){var e=M(0),r=0,f=0;if(r=(N1(A),t2(2)),f=r>>>23&255,f>>>0<=149)if(f>>>0<=125)A=M(A*M(0));else{A=M(w2(A)),e=M(M(M(A+M(8388608))+M(-8388608))-A);i:{if(e>M(.5)){A=M(M(A+e)+M(-1));break i}if(A=M(A+e),!(e<=M(-.5)))break i;A=M(A+M(1))}A=(r|0)<0?M(-A):A}return M(w2(A))<M(2147483648)?~~A:-2147483648}function EF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,f1(f+12|0,e,r,X[i[i[e>>2]+52>>2]](e,r,0)|0),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0;i:{if(u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];break i}T(A,i[26930],i[26931])}v=f+32|0}function pF(A){A=A|0;var e=0,r=0;i[A>>2]=101736,e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+548>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return e=i[A+512>>2],e&&(i[A+516>>2]=e,Z(e)),T1(A)|0}function he(A){var e=0,r=0;e=i[A+76>>2];i:{if(!((e|0)>=0&(!e|i[31360]!=(e&1073741823)))){if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,A=l[e|0];break i}A=u3(A);break i}e=A+76|0,r=i[e>>2],i[e>>2]=r||1073741823,r=i[A+4>>2];e:{if((r|0)!=i[A+8>>2]){i[A+4>>2]=r+1,A=l[r|0];break e}A=u3(A)}i[e>>2]=0}return A}function yF(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(u[A+63|0]>=0){i[e+8>>2]=i[A+60>>2],r=i[A+56>>2],i[e>>2]=i[A+52>>2],i[e+4>>2]=r;break i}T(e,i[A+52>>2],i[A+56>>2])}return A=u[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=c4(E(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function YF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105916,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}Z(A2(A))}function h2(A){var e=0,r=0,f=0;i:{e:{if(e=A,!(e&3))break e;if(!l[e|0])return 0;for(;;){if(e=e+1|0,!(e&3))break e;if(!l[e|0])break}break i}for(;r=e,e=e+4|0,f=i[r>>2],((f|16843008-f)&-2139062144)==-2139062144;);for(;e=r,r=e+1|0,!!l[e|0];);}return e-A|0}function RF(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[e+8>>2]!=1){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}i:{if(!l[e+16|0]||(f&&(i[f>>2]=i[e+20>>2]),!k))break i;i[k>>2]=i[e+24>>2]}r&&(i[r>>2]=l[e+16|0]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}function io(A,e,r){var f=0,k=0,n=0;i:{e:{f=i[A+128>>2];r:{if(!f)break r;for(k=A+128|0,A=k;n=i[f+16>>2]<(e|0),A=n?A:f,f=i[(n?4:0)+f>>2],!!f;);if((A|0)==(k|0))break r;if(i[A+16>>2]<=(e|0))break e}if(A=0,!r)break i;return i[r>>2]=0,0}r&&(i[r>>2]=i[A+56>>2]),A=i[A+44>>2]}return A}function JF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=104828,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function NF(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;t=v-16|0,v=t,i[k>>2]=r,n=t+12|0,A=ek(n,0,i[A+8>>2]),e=2;i:{if(A+1>>>0<2||(r=A-1|0,e=1,r>>>0>f-i[k>>2]>>>0))break i;for(;;){if(r){A=l[n|0],e=i[k>>2],i[k>>2]=e+1,u[e|0]=A,r=r-1|0,n=n+1|0;continue}break}e=0}return v=t+16|0,e|0}function o6(A,e,r,f){var k=0;i:{if(!(f&2048)|!r||(k=f&74,(k|0)==8|(k|0)==64))break i;u[A|0]=43,A=A+1|0}for(f&512&&(u[A|0]=35,A=A+1|0);;){if(k=l[e|0],k){u[A|0]=k,A=A+1|0,e=e+1|0;continue}break}k=f&74,e=111;i:{if((k|0)==64||(e=f&16384?88:120,(k|0)==8))break i;e=r?100:117}u[A|0]=e}function MF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=88120,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=86404,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function UF(A){A=A|0;var e=0,r=0;i[A>>2]=101736,e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+548>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+512>>2],e&&(i[A+516>>2]=e,Z(e)),Z(T1(A))}function DF(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)==(f|0)){u[A+97|0]=0;return}i:{for(;;){if(i[e+4>>2]||(k=i[e+8>>2],r=i[e+12>>2],(r|0)>0?r=1:r=(r|0)>=0&k>>>0>=2147483648,r))break i;if(e=e+24|0,(f|0)==(e|0))break}u[A+97|0]=0;return}u[A+97|0]=1}function eo(A){var e=0,r=0,f=0;f=i[A+16>>2]<<8,i[A+16>>2]=f,e=F[A+20>>1]+8|0,Q[A+20>>1]=e,e=e<<16>>16;i:{if((e|0)<0||(r=i[A+4>>2],r>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=r+1,r=l[r|0],Q[A+20>>1]=e-8,f=r<<e|f}return r=i[A+12>>2]<<7,e=(f>>>0)/(r>>>0)|0,(e|0)>=256&&(e=255),i[A+16>>2]=f-G(e,r),e}function ar(A,e){var r=0,f=0,k=0;r=i[A+128>>2];i:{if(!r)break i;for(k=A+128|0,A=k;f=u0[r+16>>2]<e>>>0,A=f?A:r,r=i[(f?4:0)+r>>2],!!r;);if(f=0,(A|0)==(k|0)|u0[A+16>>2]>e>>>0||(f=i[A+20>>2],A=i[A+24>>2],!A|i[A+4>>2]!=-1))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return(f|0)!=0}function HF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;f=v-32|0,v=f,n=f+12|0,P1(n,Jo(e,r)),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=p2(e+4|0),i[k>>2]=e,e&&z(k+4|0,r?i[f+12>>2]:n,e),i[f+24>>2]=k,t=A,o=y1(96288,f+24|0)|0,i[t+4>>2]=o,i[A>>2]=125416,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function xF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=A,o=e,A=X[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(l[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?A=i[A+4>>2]:A=l[A+11|0]&127,T8(t,o,r,f,k,n,s,e+(A<<2)|0)|0}function W2(A){var e=0,r=0,f=0;f=v-16|0,v=f;i:{if(!f4(A,1))break i;r=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(X[i[i[r>>2]+16>>2]](r,f+15|0,1)|0)){i8(A),r=0;break e}r=l[f+15|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return v=f+16|0,r}function zF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=88120,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=86404,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function TF(A){A=A|0;var e=0,r=0;i[A>>2]=106516,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),A|0}function SF(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+460>>2];i:{if((e|0)==i[A+464>>2]||(r4(r+8|0,i[A+100>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=X[i[i[e>>2]+88>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,f|0}function jF(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+480>>2];i:{if((e|0)==i[A+484>>2]||(r4(r+8|0,i[A+100>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=X[i[i[e>>2]+88>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,f|0}function _i(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+32>>2],A&&(i[r+36>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}Z(r)}}function Bi(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+16>>2],A&&(i[r+20>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}Z(r)}}function N2(A,e,r){var f=0,k=0;i:{e:{if(r>>>0>=4){if((A|e)&3)break e;for(;;){if(i[A>>2]!=i[e>>2])break e;if(e=e+4|0,A=A+4|0,r=r-4|0,!(r>>>0>3))break}}if(!r)break i}for(;;){if(f=l[A|0],k=l[e|0],(f|0)==(k|0)){if(e=e+1|0,A=A+1|0,r=r-1|0,r)continue;break i}break}return f-k|0}return 0}function U1(A){var e=0,r=0,f=0,k=0;if(i[A>>2]){l[107800]||(u[107800]=1),e=i[26952];i:{if(!e)break i;for(r=107808,f=i[A>>2];k=u0[e+16>>2]<f>>>0,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if((r|0)==107808|u0[r+16>>2]>f>>>0)break i;i[r+20>>2]=i[r+20>>2]-i[A+4>>2]}i[A>>2]=0,i[A+4>>2]=0}}function OF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+188>>2],e=e>>f,(e|0)<0||(k=i[A+192>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+196>>2])break i;return(i[A+180>>2]+G(e,12)|0)+G(G(r,k),12)|0}M0(4656,10893,118,4231),H()}M0(4618,10893,119,4231),H()}function LF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=A,o=e,A=X[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(l[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?A=i[A+4>>2]:A=l[A+11|0]&127,z8(t,o,r,f,k,n,s,e+A|0)|0}function PF(A){A=A|0;var e=0,r=0;i[A>>2]=106516,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),Z(A)}function j1(A,e,r,f){var k=0,n=0;k=v-16|0,v=k,n=i[e+52>>2];i:{if(!n){if(u[k+4|0]=0,u[k+15|0]=0,K(A,2,108,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(!i[e+60>>2]){if(u[k+4|0]=0,u[k+15|0]=0,K(A,2,109,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}C9(A,n,r,e+60|0,f)}v=k+16|0}function zA(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-160|0,v=k,i[k+60>>2]=e,i[k+20>>2]=e,i[k+24>>2]=-1,n=k+16|0,u8(n,0,0),R7(k,n,f,1),f=i[k+8>>2],t=i[k+12>>2],n=i[k>>2],o=i[k+4>>2],r&&(i[r>>2]=i[k+136>>2]+((i[k+20>>2]-i[k+60>>2]|0)+e|0)),i[A+8>>2]=f,i[A+12>>2]=t,i[A>>2]=n,i[A+4>>2]=o,v=k+160|0}function qF(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=X0(e,94804,96008);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+24>>2]-i[e+20>>2]|0;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+20>>2],e=i[e+24>>2],i[A+4>>2]=r,r=e-k|0,f)break i;X[i[i[A>>2]+8>>2]](A),p(A)}return r|0}function ro(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=X0(e,94804,95964);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+12>>2]-i[e+8>>2]>>3;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+8>>2],e=i[e+12>>2],i[A+4>>2]=r,r=e-k>>3,f)break i;X[i[i[A>>2]+8>>2]](A),p(A)}return r|0}function KF(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;n=v-32|0,v=n,o=n+12|0,ci(o,i[e>>2],r,f,k,1970432288,0,0,t);i:{if(i[n+12>>2]!=i[26928]){b0(A,o,i[e>>2]);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function aF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(k=e,n=F0(r),i[k+104>>2]=n,k=e,n=F0(r),i[k+108>>2]=n,k=e,n=F0(r),i[k+112>>2]=n,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function $r(A,e){var r=0,f=0,k=0;if(i[e+16>>2]!=1970628964){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+20>>2],e=i[e+24>>2],(r|0)!=(e|0)){if(e=e-r|0,(e|0)<0)break i;f=E(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&z(f,r,e),i[A+4>>2]=k}return}G0(),H()}function $F(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,o=t+12|0,ci(o,i[e>>2],r,f,k,1835625829,9842,n,0);i:{if(i[t+12>>2]!=i[26928]){b0(A,o,i[e>>2]);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[t+31|0]<0&&Z(i[t+20>>2]),v=t+32|0}function fo(A){var e=0,r=0,f=0;e=A+252|0;i:{e:{r:{f:switch(r=i[A+256>>2],A=u[A+263|0],r=(A|0)<0?r:A,r-25|0){case 0:break e;case 1:break r;case 18:break f;default:break i}return!N2((A|0)<0?i[e>>2]:e,19037,43)}return!N2((A|0)<0?i[e>>2]:e,21802,r)}f=!N2((A|0)<0?i[e>>2]:e,21829,r)}return f}function Ao(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;o=v-32|0,v=o,s=o+12|0,T0(s,i[e>>2],r,f,k,n,t);i:{if(i[o+12>>2]){r=A,A=i[e>>2],b0(r,s,A?A+92|0:0);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[o+31|0]<0&&Z(i[o+20>>2]),v=o+32|0}function ko(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e||(r=l[e|0],f=l[A|0],((r>>>0<f>>>0?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],Q[A+8>>1]=F[e+8>>1],Q[A+10>>1]=F[e+10>>1],Q[A+12>>1]=F[e+12>>1],Q[A+14>>1]=F[e+14>>1],Q[A+16>>1]=F[e+16>>1],Q[A+18>>1]=F[e+18>>1],Q[A+20>>1]=F[e+20>>1]}}function dF(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=99304,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}return e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function cF(A){A=A|0;var e=0,r=0,f=0;e=i[A+24>>2],e>>>0>u0[A+44>>2]&&(i[A+44>>2]=e);i:{if(!(l[A+48|0]&8)||(e=i[A+44>>2],e>>>0>u0[A+16>>2]&&(r=i[A+8>>2],f=i[A+12>>2],i[A+16>>2]=e,i[A+12>>2]=f,i[A+8>>2]=r),e=i[A+16>>2],A=i[A+12>>2],e>>>0<=A>>>0))break i;return l[A|0]}return-1}function P8(A){var e=0,r=0,f=0;r=v-32|0,v=r,l[108685]==1&&(i[r+16>>2]=A,y8(33150,r+16|0)),e=i[A+4>>2];i:{if(!e||(f=e,e=i[e>>2]-1|0,i[f>>2]=e,e)||(l[108685]==1&&(i[r>>2]=i[A>>2],y8(33180,r)),e=i[A>>2],e&&Z(e),e=i[A+4>>2],!e))break i;Z(e)}return v=r+32|0,A}function bF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k,n=k+12|0,t=i[e>>2],X[i[i[t>>2]+76>>2]](n,t,r,f);i:{if(i[k+12>>2]){r=A,A=i[e>>2],b0(r,n,A?A+84|0:0);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function TA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=i[A+104>>2],A=i[A+108>>2];i:{if((r|0)!=(A|0))for(n=r+12|0,A=(A-r|0)/12|0,t=A>>>0<=1?1:A,o=A-1|0,A=0;;){if(k=G(A,12),f=k+r|0,u0[f>>2]<=e>>>0&((A|0)==(o|0)|u0[n+k>>2]>e>>>0))break i;if(A=A+1|0,(t|0)==(A|0))break}f=0}return f}function no(A,e,r){var f=0;if(r-65537>>>0<4294836223)for(;e=(e|0)/2|0,r=(r|0)/2|0,r-65537>>>0<4294836223;);i:{if((r|0)<=1)break i;for(;;){if(e-65537>>>0>4294836222)break i;if(e=(e|0)/2|0,f=r>>>0>3,r=r>>>1|0,!f)break}}return i[A>>2]=e,i[A+4>>2]=r,A}function to(A){var e=0,r=0,f=0,k=0;if(e=v-16|0,v=e,l[108685]==1&&(i[e+4>>2]=i[A+4>>2],i[e>>2]=A,y8(42438,e)),r=i[A+4>>2],r){f=i[r>>2],(f|0)>=2&&(i[r>>2]=f-1,r=i[A>>2],f=E(172),i[A>>2]=f,k=A,A=E(4),i[k+4>>2]=A,i[A>>2]=1,z(f,r,172)),v=e+16|0;return}M0(3794,18272,95,13074),H()}function iE(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=99304,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function eE(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-32|0,v=n,t=n+12|0,ci(t,i[e>>2],r,f,k,1835625829,9842,0,0);i:{if(i[n+12>>2]!=i[26928]){b0(A,t,i[e>>2]);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function uo(A,e){var r=0,f=0;r=l[A|0];i:{if((r|0)!=l[e|0]||r&&F[A+4>>1]!=F[e+4>>1]|F[A+6>>1]!=F[e+6>>1]|l[A+2|0]!=l[e+2|0]||(r=l[A+1|0],(r|0)!=l[e+1|0])||r&&F[A+8>>1]!=F[e+8>>1]|F[A+10>>1]!=F[e+10>>1]|l[A+3|0]!=l[e+3|0])break i;f=1}return f}function oo(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,o=t+12|0,T0(o,i[e>>2],r,f,k,n,0);i:{if(i[t+12>>2]){r=A,A=i[e>>2],b0(r,o,A?A+92|0:0);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[t+31|0]<0&&Z(i[t+20>>2]),v=t+32|0}function k4(A){var e=0,r=0;r=i[A+16>>2]<<1,i[A+16>>2]=r,e=F[A+20>>1]+1|0,Q[A+20>>1]=e;i:{if(e<<16>>16<0||(Q[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=e+1,r=l[e|0]|r,i[A+16>>2]=r}return e=i[A+12>>2]<<7,e>>>0<=r>>>0?(i[A+16>>2]=r-e,A=1):A=0,A}function dr(A,e,r,f){var k=0;return i[A>>2]=86360,k=A+4|0,i[k>>2]=0,i[k+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=r,i[A+36>>2]=0,i[A>>2]=86228,f?(f=E(r),i[A+48>>2]=f,r&&z(f,e,r),i[A+24>>2]=f,A):(i[A+24>>2]=e,A)}function lo(A,e){var r=0,f=0,k=0;f=1;i:{if(e||(k=i[A>>2],r=i[A+12>>2],e=i[A+8>>2],A=r-e>>2,k>>>0>A>>>0))break i;if((e|0)!=(r|0))for(f=A>>>0<=1?1:A,A=0;;){if(r=i[e+(A<<2)>>2],!(l[r+104|0]|i[r+100>>2]))return 1;if(A=A+1|0,(f|0)==(A|0))break}f=0}return f}function rE(A,e){A=A|0,e=e|0;var r=0;i:{if(!i[A+64>>2]||(r=i[A+12>>2],r>>>0<=u0[A+8>>2]))break i;if((e|0)==-1)return i[A+12>>2]=r-1,((e|0)!=-1?e:0)|0;if(r=i[A+12>>2]-1|0,!(l[A+88|0]&16)&l[r|0]!=(e&255))break i;return i[A+12>>2]=r,u[i[A+12>>2]]=e<<24>>24,e|0}return-1}function fE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=i[e+64>>2],(e+108|0)!=(r|0)&&(f=i[e+112>>2],e=i[e+116>>2],d4(r+4|0,f,e,e-f|0),k=i[r+4>>2],n=i[r+12>>2],f=i[r+8>>2]),u[A+20|0]=0,i[A+8>>2]=n,i[A+4>>2]=f,i[A>>2]=k,v=r+16|0}function vi(A,e,r){var f=0,k=0,n=0,t=0;i:{if(!e){f=e;break i}for(;r=r-1|0,k=A,A=d8(A,e,10,0),f=l0,n=r,t=k-O0(A,f,10,0)|48,u[n|0]=t,k=e>>>0>9,e=f,!!k;);}if(A|f)for(;r=r-1|0,e=(A>>>0)/10|0,u[r|0]=A-G(e,10)|48,f=A>>>0>9,A=e,!!f;);return r}function AE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;t=v-16|0,v=t,X[i[i[e>>2]+116>>2]](t+8|0,e),e=A,A=i[t+8>>2],X[i[i[A>>2]+12>>2]](e,A,r,f,k,n),A=i[t+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}v=t+16|0}function kE(A){A=A|0;var e=0,r=0,f=0,k=0;if(f=i[A+24>>2],f){if(e=f,r=i[A+28>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+24>>2]}i[A+28>>2]=f,Z(e)}}function so(A,e,r){var f=0,k=0,n=0,t=0;for(n=v-16|0,v=n,u[n+14|0]=0,f=e-A>>2,e=v-16|0,v=e;;){if(f){i[e+12>>2]=A,k=f>>>1|0,i[e+12>>2]=i[e+12>>2]+(k<<2),t=(k^-1)+f|0,f=k,k=u0[i[e+12>>2]>>2]<u0[r>>2],f=k?t:f,A=k?i[e+12>>2]+4|0:A;continue}break}return v=e+16|0,v=n+16|0,A}function nE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=f+12|0,n=i[e>>2],X[i[i[n>>2]+32>>2]](k,n,r);i:{if(i[f+12>>2]){r=A,A=i[e>>2],b0(r,k,A?A+92|0:0);break i}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}u[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function tE(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;o=(k-f|0)+e|0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=u[e|0],t=u[f|0],(n|0)<(t|0)))break i;if((n|0)>(t|0))return 1;f=f+1|0,e=e+1|0;continue}break}A=(r|0)!=(o|0)}return A|0}function uE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;X[i[i[r>>2]+8>>2]](r),p(r)}if(f=f-8|0,(f|0)==(A|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function SA(A){var e=0,r=0,f=0,k=0;i:{e:{if(r=i[A+128>>2],!r)break e;for(f=A+128|0,e=f;k=i[r+16>>2]<6,e=k?e:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)==(f|0)|i[e+16>>2]>=7)break e;e=1;break i}if(A=i[A+120>>2],e=0,A>>>0>15)break i;e=43008>>>A|0}return e&1}function wo(A){A=A|0;var e=0,r=0;if(i[A+1884>>2]>0&&(e=A+1392|0,u[e|0]=1,i[e+156>>2]>0))for(;r=r+1|0,(r|0)<i[e+156>>2];);return X[i[i[A>>2]+4>>2]](A),l[108684]||(u[108684]=1),A=i[27164],(A|0)<=0?12:(A=A-1|0,i[27164]=A,A||js(),0)}function R2(A,e){var r=0,f=0,k=0;i:{if(f=h2(e),r=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,f>>>0<=r>>>0){l[A+11|0]>>>7|0?r=i[A>>2]:r=A,k=!f,k|k||z(r,e,f),Xl(A,r,f);break i}Jr(A,r,f-r|0,k,0,k,f,e)}}function _e(A,e,r){var f=0,k=0,n=0;return f=A*A,n=f*(f*f)*(f*158969099521155e-24+-25050760253406863e-24)+(f*(f*27557313707070068e-22+-.0001984126982985795)+.00833333333332249),k=A*f,r?A-(f*(e*.5-k*n)-e+k*.16666666666666632):k*(f*n+-.16666666666666632)+A}function mi(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if(!e){e=0;break i}f=e,e=k1(e),o4(r,f,0,0,0,112-(e^31)|0),f=0+i[r+8>>2]|0,e=(i[r+12>>2]^65536)+(16414-e<<16)|0,n=k>>>0>f>>>0?e+1|0:e,k=i[r+4>>2],e=i[r>>2]}i[A>>2]=e,i[A+4>>2]=k,i[A+8>>2]=f,i[A+12>>2]=n,v=r+16|0}function cr(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-4|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=i[A>>2],f=A,A=i[r+8>>2],i[f>>2]=i[A>>2],i[A>>2]=e,A=i[r+12>>2]+4|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function ho(A){A=A|0;var e=0,r=0;e=i[A>>2],r=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{if(r){A=X[i[i[r>>2]+8>>2]](r)|0;break i}A=S4(i[A>>2])?1852009592:0}i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function oE(A){A=A|0;var e=0,r=0;i[A>>2]=99976,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function lE(A){A=A|0;var e=0,r=0;i[A>>2]=97368,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function Be(A,e){var r=0,f=0,k=0,n=0;l[A|0]||(r=i[A+24>>2],f=r+i[A+20>>2]|0,n=i[A+12>>2],k=i[A+8>>2],(f|0)==(((k|0)!=(n|0)?(n-k<<8)-1|0:0)|0)&&(or(A+4|0),k=i[A+8>>2],r=i[A+24>>2],f=r+i[A+20>>2]|0),i[i[(f>>>8&16777212)+k>>2]+((f&1023)<<2)>>2]=e,i[A+24>>2]=r+1)}function sE(A){A=A|0;var e=0,r=0,f=0;r=i[i[A>>2]+180>>2],e=i[r+104>>2],A=0;i:{if((e|0)==i[r+108>>2])break i;if(A=i[e>>2],e=i[e+4>>2],!e){A=i[A+16>>2];break i}r=i[e+4>>2],f=r+1|0,i[e+4>>2]=f,A=i[A+16>>2],i[e+4>>2]=r,f||(X[i[i[e>>2]+8>>2]](e),p(e))}return A|0}function wE(A){A=A|0;var e=0,r=0;i[A>>2]=98368,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function _o(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,r=i[e+456>>2],i[A>>2]=i[e+452>>2],i[A+4>>2]=r,r=A+8|0;i:{if(u[e+471|0]>=0){e=e+460|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break i}T(r,i[e+460>>2],i[e+464>>2])}u[A+20|0]=1}function F8(A,e,r,f,k){r=G(i[i[A+124>>2]+16892>>2],f)+r|0;i:{if(!e||(r=i[A+320>>2]+G(r,76)|0,i[r>>2]>=(k|0)))break i;i[A+328>>2]=i[A+328>>2]-1,i[A+332>>2]=i[A+332>>2]+1,i[e+4>>2]=2,es(r,k),i[e+4>>2]=1,i[A+332>>2]=i[A+332>>2]-1,i[A+328>>2]=i[A+328>>2]+1}}function hE(A){A=A|0;var e=0,r=0;i[A>>2]=99544,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function _E(A){A=A|0;var e=0,r=0;i[A>>2]=97824,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function BE(A){A=A|0;var e=0,r=0;i[A>>2]=98768,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return T1(A)|0}function vE(A,e,r){if(A=A|0,e=e|0,r=r|0,u2(r,F[e+4>>1]),u2(r,F[e+6>>1]),u2(r,F[e+8>>1]),l2(r,l[e+10|0]<<7&128),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function mE(A){A=A|0;var e=0,r=0,f=0;if(A=i[26982],A){if(e=A,r=i[26983],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(r|0)==(A|0))break}e=i[26982]}i[26983]=A,Z(e)}}function Zi(A,e){var r=0,f=0,k=0;f=-1;i:{if((A|0)==-1)break i;k=i[e+76>>2]<0;e:{r=i[e+4>>2];r:{if(!r&&(Ge(e),r=i[e+4>>2],!r))break r;if(i[e+44>>2]-8>>>0<r>>>0)break e}if(k)break i;return-1}r=r-1|0,i[e+4>>2]=r,u[r|0]=A,i[e>>2]=i[e>>2]&-17,f=A&255}return f}function N6(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-1|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=l[A|0],f=A,A=i[r+8>>2],u[f|0]=l[A|0],u[A|0]=e,A=i[r+12>>2]+1|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function Bo(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,A=R0(A),i[A+32>>2]=e,i[A>>2]=73544,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129816),e2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,t=X[i[i[e>>2]+28>>2]](e)|0,u[n+44|0]=t,v=f+16|0}function vo(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,A=ml(A),i[A+32>>2]=e,i[A>>2]=73748,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129824),e2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,t=X[i[i[e>>2]+28>>2]](e)|0,u[n+44|0]=t,v=f+16|0}function ve(A){var e=0,r=0,f=0,k=0;if(f=i[A>>2],f){if(e=f,r=i[A+4>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;X[i[i[e>>2]+8>>2]](e),p(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A>>2]}i[A+4>>2]=f,Z(e)}}function ZE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=i[e+8>>2],r=h2(f),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;z(A,f,r)}u[A+r|0]=0;return}g0(),H()}function GE(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,V9(n,i[e>>2],r,f,0);i:{if(i[k+12>>2]){r=A,A=i[e>>2],b0(r,n,A?A+92|0:0);break i}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function me(A,e){var r=0,f=0;r=v-16|0,v=r,l[A+11|0]>>>7|0&&$8(i[A>>2],4);i:if(l[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,u[e+11|0]=l[e+11|0]&128,u[e+11|0]=l[e+11|0]&127,i[r+12>>2]=0,i[e>>2]=i[r+12>>2],v=r+16|0}function WE(A){A=A|0;var e=0,r=0;i[A>>2]=98768,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function XE(A){A=A|0;var e=0,r=0;i[A>>2]=99976,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function Ze(A){var e=0,r=0,f=0;Q[A+20>>1]=8,i[A+12>>2]=510,i[A+16>>2]=0,e=i[A+4>>2],f=i[A+8>>2]-e|0;i:{if((f|0)<=0||(i[A+4>>2]=e+1,r=l[e|0],Q[A+20>>1]=0,r=r<<8,i[A+16>>2]=r,(f|0)==1))break i;i[A+4>>2]=e+2,e=l[e+1|0],Q[A+20>>1]=65528,i[A+16>>2]=e|r}}function gE(A){A=A|0;var e=0,r=0;i[A>>2]=97368,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function QE(A){A=A|0;var e=0,r=0;i[A>>2]=98368,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function IE(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(S1(A,i[e+8>>2],0)){OA(e,r,f);return}k=i[A+12>>2],n=A+16|0,go(n,e,r,f);i:{if(k>>>0<2)break i;for(k=(k<<3)+n|0,A=A+24|0;;){if(go(A,e,r,f),l[e+54|0])break i;if(A=A+8|0,!(k>>>0>A>>>0))break}}}function CE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(!f|r)){i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=4843;return}i[e+8>>2]=f,f=i[e+12>>2],f&&Z(f);i:{if(r){f=e,e=Ak(),i[f+12>>2]=e,A3(e,r);break i}i[e+12>>2]=0}e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}function VE(A){A=A|0;var e=0,r=0;i[A>>2]=99544,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function FE(A){A=A|0;var e=0,r=0;i[A>>2]=97824,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(T1(A))}function EE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(f=i[e+64>>2],f&&Z(f),f=e,e=pe(),i[f+64>>2]=e,gi(e,r),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function l1(A){var e=0,r=0,f=0,k=0;if(r=v-16|0,v=r,i[r+12>>2]=A,f=v-16|0,v=f,i[A>>2]!=-1){for(e=f+12|0,i[e>>2]=r+12,k=f+8|0,i[k>>2]=e;e=i[A>>2],(e|0)==1;);e||(i[A>>2]=1,dl(k),i[A>>2]=-1)}return v=f+16|0,v=r+16|0,i[A+4>>2]-1|0}function q8(A,e){var r=0,f=0;r=v-16|0,v=r,l[A+11|0]>>>7|0&&$8(i[A>>2],1);i:if(l[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,u[e+11|0]=l[e+11|0]&128,u[e+11|0]=l[e+11|0]&127,u[r+15|0]=0,u[e|0]=l[r+15|0],v=r+16|0}function pE(A,e,r){if(A=A|0,e=e|0,r=r|0,!r){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(i[r>>2]>=6){e=i[24167],i[A>>2]=i[24166],i[A+4>>2]=e,i[A+8>>2]=i[24168];return}pu(r),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}function yE(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=i[e>>2],t=i[f>>2],(n|0)<(t|0)))break i;if((n|0)>(t|0))return 1;f=f+4|0,e=e+4|0;continue}break}A=(e|0)!=(r|0)}return A|0}function jA(){var A=0;return A=E(68),i[A+24>>2]=0,Q[A>>1]=8,i[A+4>>2]=0,i[A+8>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,u[A+40|0]=0,i[A+32>>2]=2,i[A+36>>2]=2,u[A+28|0]=1,i[A+12>>2]=0,i[A+16>>2]=0,Q[A+20>>1]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+64>>2]=0,A|0}function br(A,e,r,f){var k=0,n=0;return k=v-160|0,v=k,A=e?A:k+158|0,i[k+148>>2]=A,n=e-1|0,i[k+152>>2]=e>>>0>=n>>>0?n:0,o0(k,0,144),i[k+76>>2]=-1,i[k+36>>2]=1955,i[k+80>>2]=-1,i[k+44>>2]=k+159,i[k+84>>2]=k+148,u[A|0]=0,A=Mr(k,r,f,1953,1954),v=k+160|0,A}function mo(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,Q[f+8>>1]=i[r+4>>2],Q[f+10>>1]=i[r+8>>2],Q[f+12>>1]=i[r+12>>2],u[f+14|0]=l[r+16|0]!=0,e=i[e>>2],X[i[i[e>>2]+8>>2]](e,f+8|0),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,v=f+16|0}function Ge(A){var e=0,r=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,i[A+20>>2]!=i[A+28>>2]&&X[i[A+36>>2]](A,0,0)|0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=i[A>>2],e&4?(i[A>>2]=e|32,-1):(r=i[A+44>>2]+i[A+48>>2]|0,i[A+8>>2]=r,i[A+4>>2]=r,e<<27>>31)}function u8(A,e,r){var f=0,k=0,n=0,t=0;i[A+112>>2]=e,i[A+116>>2]=r,n=i[A+4>>2],f=i[A+44>>2]-n|0,i[A+120>>2]=f,i[A+124>>2]=f>>31,f=i[A+8>>2];i:{if(!(e|r)||(k=f-n|0,t=e>>>0>=k>>>0,k=k>>31,t&(k|0)<=(r|0)|(r|0)>(k|0)))break i;f=e+n|0}i[A+104>>2]=f}function i3(A,e,r){var f=0,k=0;if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+104>>2],e=i[e+108>>2],(f|0)!=(e|0))for(;;){if(i[f+40>>2]==(r|0)){i:{if(u0[A+8>>2]>k>>>0){te(k,f),k=k+56|0;break i}k=tA(A,f)}i[A+4>>2]=k}if(f=f+56|0,(e|0)==(f|0))break}}function OA(A,e,r){var f=0;if(f=i[A+36>>2],!f){i[A+24>>2]=r,i[A+16>>2]=e,i[A+36>>2]=1,i[A+20>>2]=i[A+56>>2];return}i:{if(!(i[A+20>>2]!=i[A+56>>2]|i[A+16>>2]!=(e|0))){if(i[A+24>>2]!=2)break i;i[A+24>>2]=r;return}u[A+54|0]=1,i[A+24>>2]=2,i[A+36>>2]=f+1}}function Zo(A){var e=0,r=0,f=0;if(r=v-16|0,v=r,l[108685]==1&&(i[r+4>>2]=i[A+4>>2],i[r>>2]=A,y8(33165,r)),e=i[A+4>>2],e){f=i[e>>2]-1|0,i[e>>2]=f;i:{if(f||(f=i[A>>2],f&&(Z(f),e=i[A+4>>2],!e)))break i;Z(e)}i[A>>2]=0,i[A+4>>2]=0}v=r+16|0}function Gi(A){var e=0,r=0,f=0,k=0,n=0;for(e=v-16|0,v=e,f=A+4|0,r=i[f>>2],i[e+12>>2]=r;;){i:{if((r|0)==-1){A=0;break i}if(k=i[f>>2],n=(k|0)==i[e+12>>2],i[f>>2]=n?r+1|0:k,n||(i[e+12>>2]=k),n)break i;r=i[e+12>>2];continue}break}return v=e+16|0,A}function YE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;A=i[A>>2],f=i[A+160>>2],A=i[A+164>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),!r|!f||(i[e>>2]=i[f+116>>2],k=1);i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return k|0}function RE(A){A=A|0;var e=0;i:{if(e=i[A+12>>2],A=i[A+8>>2],e-A>>>0>524280)break i;if((A|0)==(e|0))return 0;for(;;){if(i[A>>2]-32768>>>0<4294901760|i[A+4>>2]-32768>>>0<=4294901759)break i;if(A=A+8|0,(e|0)==(A|0))break}return 0}return 1}function p0(A){A=A|0;var e=0,r=0;if(i[A>>2]=73076,i[A+28>>2]){for(e=i[A+40>>2];;){if(e){e=e-1|0,r=e<<2,X[i[i[A+32>>2]+r>>2]](0,A,i[r+i[A+36>>2]>>2]);continue}break}e2(A+28|0),Z(i[A+32>>2]),Z(i[A+36>>2]),Z(i[A+48>>2]),Z(i[A+60>>2])}return A|0}function JE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(l2(e,l[A+4|0]?3:6),Z1(e,r,i[A+12>>2]-i[A+8>>2]>>3,0),f=i[A+8>>2],k=i[A+12>>2],(f|0)!=(k|0))for(;A=i[f>>2],Z1(e,r,A,A>>31),A=i[f+4>>2],Z1(e,r,A,A>>31),f=f+8|0,(k|0)!=(f|0););}function Go(A){var e=0,r=0,f=0,k=0,n=0;if(f=i[A>>2],e=u[f|0]-48|0,e>>>0>9)return 0;for(;k=-1,r>>>0<=214748364&&(r=G(r,10),k=(r^2147483647)>>>0<e>>>0?-1:r+e|0),e=f+1|0,i[A>>2]=e,n=u[f+1|0],r=k,f=e,e=n-48|0,e>>>0<10;);return r}function NE(A,e){A=A|0,e=e|0;var r=0;e=X0(e,86628,86672);i:{if(!e|l[A+104|0]!=l[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|i[A+120>>2]!=i[e+120>>2])||i[A+124>>2]!=i[e+124>>2])break i;r=l[A+128|0]==l[e+128|0]}return r|0}function Wo(A){var e=0,r=0,f=0;A=i[A+48>>2],r=i[A+148>>2],e=i[A+152>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),r?(A=i[r+128>>2],r=i[r+132>>2]):(A=0,r=0);i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return l0=r,A}function ME(A,e){if(A=A|0,e=e|0,!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(i[e>>2]>=6){e=i[24167],i[A>>2]=i[24166],i[A+4>>2]=e,i[A+8>>2]=i[24168];return}pu(e),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}function UE(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,e=i[26934],i[A>>2]=i[26933],i[A+4>>2]=e,e=A+8|0;i:{if(u[107751]>=0){r=i[26936],i[e>>2]=i[26935],i[e+4>>2]=r,i[e+8>>2]=i[26937];break i}T(e,i[26935],i[26936])}u[A+20|0]=1}function DE(A){A=A|0;var e=0,r=0,f=0;if(e=h2(21617),e>>>0<2147483640){i:{e:{if(e>>>0>=11){r=e|7,f=E(r+1|0),i[A+8>>2]=r-2147483647,i[A>>2]=f,i[A+4>>2]=e,A=f;break e}if(u[A+11|0]=e,!e)break i}if(!e)break i;z(A,21617,e)}u[A+e|0]=0;return}g0(),H()}function j0(A,e){var r=0,f=0,k=0;f=i[A+128>>2],r=255;i:{if(!f)break i;for(k=A+128|0,A=k;r=i[f+16>>2]<(e|0),A=r?A:f,f=i[(r?4:0)+f>>2],!!f;);if(r=255,(A|0)==(k|0)||(r=255,i[A+16>>2]>(e|0)))break i;r=l[A+24|0]}return r}function Xo(A,e){var r=0,f=0,k=0;if(D2(+A),f=t2(1)|0,k=t2(0)|0,r=f>>>20&2047,(r|0)!=2047){if(!r)return A==0?r=0:(A=Xo(A*18446744073709552e3,e),r=i[e>>2]+-64|0),i[e>>2]=r,A;i[e>>2]=r-1022,U2(0,k|0),U2(1,f&-2146435073|1071644672),A=+r1()}return A}function HE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[i[e+64>>2]+108>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function xE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129808),e2(o),Zl(A,n+24|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function zE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129808),e2(o),_l(A,n+16|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function TE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129800),e2(o),Gl(A,n+24|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function SE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129800),e2(o),Bl(A,n+16|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function M6(A){A=A|0;var e=0,r=0;if(A){e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}}function jE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=E(20),i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[A+8>>2]=i[26733],k=i[26732],i[A>>2]=i[26731],i[A+4>>2]=k,A=If(),i[f>>2]=A,ge(A,7,1),ge(A,8,1),u[f+4|0]=i[r+4>>2]!=0,i[e>>2]=f}function OE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=l[i[e+64>>2]+121|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function LE(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=l[i[e+64>>2]+110|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function PE(A,e){A=A|0,e=e|0;var r=0;e=X0(e,86628,86684);i:{if(!e|l[A+104|0]!=l[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|l[A+120|0]!=l[e+120|0])||l[A+121|0]!=l[e+121|0])break i;r=l[A+122|0]==l[e+122|0]}return r|0}function qE(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106316,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}return A2(A)|0}function go(A,e,r,f){var k=0,n=0,t=0;n=i[A+4>>2],t=n&1;i:{if(l[e+55|0]==1){if(k=n>>8,!t)break i;k=i[i[r>>2]+k>>2];break i}if(k=n>>8,!t)break i;i[e+56>>2]=i[i[A>>2]+4>>2],n=i[A+4>>2],r=0,k=0}A=i[A>>2],X[i[i[A>>2]+28>>2]](A,e,r+k|0,n&2?f:2)}function KE(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=87720,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function _1(A){var e=0,r=0;i:{if(e=i[A+4>>2],r=i[i[e>>2]-12>>2],r=e+r|0,!i[r+24>>2]|(i[r+16>>2]|!(i[r+4>>2]&8192))||(e=i[(e+i[i[e>>2]-12>>2]|0)+24>>2],(X[i[i[e>>2]+24>>2]](e)|0)!=-1))break i;A=i[A+4>>2],m4(i[i[A>>2]-12>>2]+A|0,1)}}function Qo(A){var e=0,r=0;for(e=v-16|0,v=e,i[e+4>>2]=129632,r=i[32409],i[e+8>>2]=r,i[e+12>>2]=r+(A<<2),A=i[e+8>>2],r=i[e+12>>2];;){if((A|0)==(r|0))i[i[e+4>>2]+4>>2]=i[e+8>>2],v=e+16|0;else{i[A>>2]=0,A=A+4|0,i[e+8>>2]=A;continue}break}}function b4(A){A=A|0;var e=0,r=0;i[A>>2]=97024,e=i[A+60>>2],e&&X[i[i[A+56>>2]+24>>2]](e),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function We(A,e){var r=0,f=0,k=0,n=0;return r=A*A,f=r*.5,k=1-f,n=1-k-f,f=r*r,k+(n+(r*(r*(r*(r*2480158728947673e-20+-.001388888888887411)+.0416666666666666)+f*f*(r*(r*-11359647557788195e-27+2087572321298175e-24)+-27557314351390663e-23))-A*e))}function aE(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return A=v-16|0,v=A,i[A+12>>2]=e,t=A+8|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129808),e2(t),Ml(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function $E(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return A=v-16|0,v=A,i[A+12>>2]=e,t=A+8|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129800),e2(t),Ul(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function Xe(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){G1(e+8|0,A);i:{if(!l[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(X[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;m4(i[i[A>>2]-12>>2]+A|0,1)}_1(e+8|0)}v=e+16|0}function dE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+27|0]<0?i[r+16>>2]:r+16|0}return k|0}function cE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+39|0]<0?i[r+28>>2]:r+28|0}return k|0}function d2(A,e){var r=0,f=0,k=0;if(r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,f=E(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=f,i[A+4>>2]=r;break e}if(u[A+11|0]=r,f=A,!r)break i}if(!r)break i;z(f,e,r)}return u[r+f|0]=0,A}g0(),H()}function bE(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106316,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}Z(A2(A))}function ip(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+15|0]<0?i[r+4>>2]:r+4|0}return k|0}function ep(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=87720,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function Wi(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=A+12|0,n=f+12|0,f=f+16|0,$4(k,i[A+16>>2],n,f,4),$4(k,i[A+16>>2],e,e+r|0,r),v=f}function u1(A,e){var r=0,f=0,k=0;f=A+128|0,A=i[A+128>>2];i:{e:{if(!A)break e;for(r=f;k=i[A+16>>2]<(e|0),r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(i[r+16>>2]<=(e|0))break i}r=f}return(r|0)!=(f|0)}function e3(A,e){var r=0,f=0,k=0;f=A+128|0,A=i[A+128>>2];i:{e:{if(!A)break e;for(r=f;k=u0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(u0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function Io(A,e){var r=0,f=0,k=0;f=A+20|0,A=i[A+20>>2];i:{e:{if(!A)break e;for(r=f;k=u0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(u0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function O1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A+4>>2],n=i[A+8>>2]&2147483647;i:{if(n>>>0>r>>>0){f=i[A>>2],i[A+4>>2]=r,A=!r,A|A||z(f,e,r),u[k+15|0]=0,u[r+f|0]=l[k+15|0];break i}Jr(A,n-1|0,(r-n|0)+1|0,f,0,f,r,e)}v=k+16|0}function rp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=i[r+44>>2]-i[r+40>>2]|0}return k|0}function fp(A,e){A=A|0,e=e|0;var r=0,f=0;r=X[i[i[A>>2]+68>>2]](i[A+4>>2])|0,A=i[r>>2];i:{if(!A)break i;for(;;){if(n4(i[A+4>>2],e)){if(A=i[r+4>>2],r=r+4|0,A)continue;break i}break}if(f=1,i[A>>2]<2)break i;f=i[A+36>>2]}return f|0}function x4(A,e,r){if(r=i[r+4>>2]&176,(r|0)==32)return e;i:{if((r|0)!=16)break i;e:{r:switch(r=l[A|0],r-43|0){case 0:case 2:break r;default:break e}return A+1|0}if((r|0)!=48|(e-A|0)<2|(l[A+1|0]|32)!=120)break i;A=A+2|0}return A}function l6(A,e,r){var f=0,k=0;i:{if(!f4(A,r)||(k=i[A>>2],f=i[A+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),X[i[i[k>>2]+16>>2]](k,e,r)|0||i8(A),!f)||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;X[i[i[f>>2]+8>>2]](f),p(f)}}function Co(A,e){var r=0,f=0;if((A|0)!=(e|0)){if(r=u[e+11|0],u[A+11|0]>=0){if((r|0)>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}D1(A,i[e>>2],i[e+4>>2]);return}f=A,A=(r|0)<0,O1(f,A?i[e>>2]:e,A?i[e+4>>2]:r)}}function D1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=l[A+11|0],f=n&127;i:{if(r>>>0<=10){u[A+11|0]=n&128|r&127,u[A+11|0]=l[A+11|0]&127,f=!r,f|f||z(A,e,r),u[k+15|0]=0,u[A+r|0]=l[k+15|0];break i}Jr(A,10,r-10|0,f,0,f,r,e)}v=k+16|0}function Ap(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!l[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((X[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)return f|0;e=e+4|0,f=f+1|0}r=L1(e,4,r,i[A+32>>2])}return r|0}function kp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}if(f=i[i[e>>2]+60>>2],f){X[f|0](A,i[e+4>>2],r);return}e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}function np(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!l[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((X[i[i[A>>2]+52>>2]](A,l[e|0])|0)==-1)return f|0;e=e+1|0,f=f+1|0}r=L1(e,1,r,i[A+32>>2])}return r|0}function tp(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+244>>2],e=i[e+248>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+104>>2]-i[A+100>>2]>>4:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function ge(A,e,r){A=A|0,e=e|0,r=r|0;i:switch(e|0){case 6:u[A+514|0]=(r|0)!=0;return;case 7:u[A+532|0]=(r|0)!=0;return;case 8:u[A+533|0]=(r|0)!=0;return;default:M0(12200,18343,535,9817),H();case 0:break i}u[A+512|0]=(r|0)!=0}function up(A,e){A=A|0,e=e|0;var r=0,f=0;r=E(20),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[A+8>>2]=i[26733],f=i[26732],i[A>>2]=i[26731],i[A+4>>2]=f,A=If(),i[r>>2]=A,ge(A,7,1),ge(A,8,1),u[r+4|0]=0,i[e>>2]=r}function op(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;return r=v-16|0,v=r,k=r+4|0,X[i[A>>2]](k,e),e=u[r+15|0],n=(e|0)<0,A=n?i[r+8>>2]:e,f=p2(A+4|0),i[f>>2]=A,t=i[r+4>>2],A&&z(f+4|0,n?t:k,A),(e|0)<0&&Z(t),v=r+16|0,f|0}function Vo(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if(r>>>0>=1073741824)break i;r=r<<2,f=E(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&z(f,i[e>>2],r),i[A+4>>2]=k}return A}G0(),H()}function lp(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A|!e||(r=i[A>>2],f=i[e>>2],(((r|0)<(f|0)?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2]}}function Qe(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129872),n=r,t=X[i[i[e>>2]+16>>2]](e)|0,i[n>>2]=t,X[i[i[e>>2]+20>>2]](A,e),e2(k),v=f+16|0}function G2(A,e,r,f){var k=0,n=0,t=0,o=0;return n=e^f,t=n>>31,k=e>>31,A=A^k,o=A-k|0,k=(e^k)-((A>>>0<k>>>0)+k|0)|0,A=f>>31,e=r^A,n=n>>31,A=d8(o,k,e-A|0,(A^f)-((A>>>0>e>>>0)+A|0)|0)^n,e=A-n|0,l0=(t^l0)-((A>>>0<n>>>0)+t|0)|0,e}function Fo(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+12>>2]-i[A+8>>2]|0:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function Ie(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=129624&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129864),n=r,t=X[i[i[e>>2]+16>>2]](e)|0,u[n|0]=t,X[i[i[e>>2]+20>>2]](A,e),e2(k),v=f+16|0}function LA(A,e,r,f,k,n){var t=0,o=0,s=0;if(r-1>>>0<=1){r=0,t=f>>>0<4?i[(f<<2)+50904>>2]:t,o=k,s=(t+A|0)-1>>>e8(t)|0,i[o>>2]=s,r=f>>>0<=3?i[(f<<2)+50920>>2]:r,o=n,s=(r+e|0)-1>>>e8(r)|0,i[o>>2]=s;return}i[k>>2]=A,i[n>>2]=e}function sp(A){A=A|0;var e=0,r=0,f=0;return e=v-16|0,v=e,i[e+12>>2]=i[A+8>>2],r=s8(e+8|0,e+12|0),f=Zt(0,0,4),r=i[r>>2],r&&(i[31378]=(r|0)==-1?125392:r),v=e+16|0,f?-1:(A=i[A+8>>2],A?(el(A)|0)==1|0:1)}function PA(A){A=A|0;var e=0,r=0;i[A>>2]=95160,z2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A|0}function Eo(A,e,r,f,k,n){var t=0,o=0,s=0;t=v-16|0,v=t,u[t+15|0]=0,u[t+14|0]=n,u[t+13|0]=k,u[t+12|0]=37,n&&(k=l[t+13|0],u[t+13|0]=l[t+14|0],u[t+14|0]=k),o=r,s=L7(e,i[r>>2]-e|0,t+12|0,f,i[A>>2])+e|0,i[o>>2]=s,v=t+16|0}function wp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=0,i[f>>2]=3,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function hp(A){A=A|0;var e=0,r=0,f=0;if(e=i[A+12>>2],e){if(r=i[e>>2],r){if(f=r,A=i[e+4>>2],(r|0)!=(A|0)){for(;u[A-1|0]<0&&Z(i[A-12>>2]),A=A-20|0,(r|0)!=(A|0););f=i[e>>2]}i[e+4>>2]=r,Z(f)}Z(e)}}function _p(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=1,i[f>>2]=3,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function Bp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(r=v-16|0,v=r,nt(r+4|0,i[A>>2]),f=i[r+4>>2],k=i[r+8>>2],(f|0)!=(k|0))for(A=f;i[e>>2]=i[A>>2],e=e+4|0,A=A+4|0,(k|0)!=(A|0););f&&Z(f),v=r+16|0}function vp(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;return e=v-16|0,v=e,k=e+4|0,X[A|0](k),r=u[e+15|0],n=(r|0)<0,A=n?i[e+8>>2]:r,f=p2(A+4|0),i[f>>2]=A,t=i[e+4>>2],A&&z(f+4|0,n?t:k,A),(r|0)<0&&Z(t),v=e+16|0,f|0}function mp(A,e){A=A|0,e=e|0;var r=0;if(r=i[e+456>>2],i[A>>2]=i[e+452>>2],i[A+4>>2]=r,A=A+8|0,u[e+471|0]>=0){e=e+460|0,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}T(A,i[e+460>>2],i[e+464>>2])}function O0(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;return k=r>>>16|0,n=A>>>16|0,w=G(k,n),t=r&65535,o=A&65535,s=G(t,o),n=(s>>>16|0)+G(n,t)|0,k=(n&65535)+G(k,o)|0,l0=(G(e,r)+w|0)+G(A,f)+(n>>>16)+(k>>>16)|0,s&65535|k<<16}function Zp(A){A=A|0;var e=0,r=0;i[A>>2]=95160,z2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}function po(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+50904>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>e8(e)|0;case 0:return A>>>e8(e)|0;case 2:k=A>>>e8(e)|0;break;default:break i}return k}function yo(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+50920>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>e8(e)|0;case 0:return A>>>e8(e)|0;case 2:k=A>>>e8(e)|0;break;default:break i}return k}function qA(A){A=A|0;var e=0,r=0,f=0,k=0;return f=n6(A),k=X[i[A+12>>2]](A)|0,u[A|0]&1||(e=i[A+56>>2],r=i[A+52>>2],r&&(i[r+56>>2]=e),e&&(i[e+52>>2]=r),i[31339]==(A|0)&&(i[31339]=e),Z(i[A+96>>2]),Z(A)),f|k}function Gp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-16|0,v=r,f=i[e+56>>2];i:{if(i[f>>2]>=5){k=r+4|0,X[i[f+64>>2]](k,i[e+60>>2]),nr(A,k);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=r+16|0}function Wp(A,e){A=A|0,e=e|0;var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=r,r=i[A+20>>2],i[A+20>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}}function Xp(){var A=0;return A=E(40),i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+32>>2]=0,i[A+36>>2]=1,i[A+24>>2]=1,i[A+28>>2]=0,u[A|0]=2,i[A+16>>2]=2,i[A+12>>2]=2,u[A+8|0]=1,A|0}function gp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(k=i[e+12>>2],i[e+12>>2]=i[A+124>>2],f=i[A+104>>2],A=i[A+108>>2],(f|0)!=(A|0))for(;C0(e,i[f>>2]+r|0),f=f+4|0,(A|0)!=(f|0););i[e+12>>2]=k}function Qp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<16||(e=l[A+12|0],!e)||(r=l[A+13|0],!r)||(f=l[A+14|0],!f)||(A=l[A+15|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function Ip(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;A=i[A>>2],r=i[A+44>>2],f=i[A+48>>2],k=i[A+36>>2],n=i[A+40>>2],t=i[A+56>>2],i[e+16>>2]=i[A+52>>2],i[e+20>>2]=t,i[e+8>>2]=r,i[e+12>>2]=f,i[e>>2]=k,i[e+4>>2]=n}function Yo(A){var e=0,r=0;e=i[A+48>>2],A=i[e+148>>2],e=i[e+152>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+120>>2]:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A}function KA(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if((r|0)<0)break i;f=E(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&z(f,i[e>>2],r),i[A+4>>2]=k}return A}G0(),H()}function Ro(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<12||(e=l[A+8|0],!e)||(r=l[A+9|0],!r)||(f=l[A+10|0],!f)||(A=l[A+11|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function U6(A,e){var r=0,f=0;r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;i:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2];break i}T(r,i[e+8>>2],i[e+12>>2])}u[A+20|0]=1}function k8(A,e){var r=0,f=0;return r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0?(e=e+8|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2],A):(T(r,i[e+8>>2],i[e+12>>2]),A)}function o8(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=i[r+16>>2]<(e|0),A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);return r=0,(A|0)==(f|0)|i[A+16>>2]>(e|0)?r:i[A+28>>2]}function l8(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=i[r+16>>2]<(e|0),A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);return r=0,(A|0)==(f|0)|i[A+16>>2]>(e|0)?r:i[A+32>>2]}function Cp(A,e,r){if(A=A|0,e=e|0,r=r|0,V4(r,e+8|0),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function aA(A){A=A|0;var e=0,r=0,f=0;return A=i[A>>2],e=i[A+48>>2],A=i[A+52>>2],A?(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,e=i[e+132>>2],i[A+4>>2]=r,f||(X[i[i[A>>2]+8>>2]](A),p(A)),e|0):i[e+132>>2]}function Vp(A,e,r){if(A=A|0,e=e|0,r=r|0,V4(r,e+4|0),e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function Fp(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=r,r=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=r,r=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=r,l[A+60|0]||(u[A+60|0]=1)}function Ep(A,e,r){if(A=A|0,e=e|0,r=r|0,i[e+8>>2]!=3){e=i[24215],i[A>>2]=i[24214],i[A+4>>2]=e,i[A+8>>2]=i[24216];return}r&&(i[r>>2]=i[e+16>>2]),e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e,i[A+8>>2]=i[24070]}function pp(A,e){A=A|0,e=e|0;var r=0;r=F[e>>1]|F[e+2>>1]<<16,Q[A+6>>1]=r,Q[A+8>>1]=r>>>16,e=l[e+3|0]|l[e+4|0]<<8|(l[e+5|0]<<16|l[e+6|0]<<24),u[A+9|0]=e,u[A+10|0]=e>>>8,u[A+11|0]=e>>>16,u[A+12|0]=e>>>24}function Jo(A,e){A=A|0,e=e|0;var r=0;return A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A?(i[A+4>>2]=i[A+4>>2]+1,e=J6(r,e),r=i[A+4>>2],i[A+4>>2]=r-1,r||(X[i[i[A>>2]+8>>2]](A),p(A)),e|0):J6(r,e)|0}function No(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(e>>>0<3)return f=i[((e<<2)+A|0)+64>>2],r&&(i[r>>2]=G(i[(e?44:40)+A>>2],(i[i[A+124>>2]+(e?16840:16832)>>2]+7|0)/8|0)),f|0;M0(21674,18343,671,12880),H()}function yp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function w4(A,e,r,f,k){var n=0;if(n=v-256|0,v=n,!(k&73728|(r|0)<=(f|0))){if(f=r-f|0,r=f>>>0<256,Ae(n,e,r?f:256),!r)for(;t4(A,n,256),f=f-256|0,f>>>0>255;);t4(A,n,f)}v=n+256|0}function Yp(A,e){A=A|0,e=e|0;var r=0,f=0;e=c0(e,129816),i[A+36>>2]=e,r=A,f=X[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=X[i[i[e>>2]+28>>2]](e)|0,u[r+53|0]=f,i[A+44>>2]>=9&&(Q1(),H())}function Rp(A,e){A=A|0,e=e|0;var r=0,f=0;e=c0(e,129824),i[A+36>>2]=e,r=A,f=X[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=X[i[i[e>>2]+28>>2]](e)|0,u[r+53|0]=f,i[A+44>>2]>=9&&(Q1(),H())}function Mo(A,e){var r=0,f=0;if(r=i[A+8>>2],A=i[A+12>>2],(r|0)!=(A|0))for(A=A-r>>2,f=A>>>0<=1?1:A,A=0;;){if(i[i[(A<<2)+r>>2]>>2]==(e|0))return A;if(A=A+1|0,(f|0)==(A|0))break}return-1}function $A(A,e){var r=0,f=0;r=v-16|0,v=r,Z8(r+8|0,A,e),e=i[i[r+8>>2]+104>>2],A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;X[i[i[A>>2]+8>>2]](A),p(A)}return v=r+16|0,e}function Jp(A){A=A|0;var e=0,r=0,f=0;e=v-16|0,v=e,Rr(e+4|0,A,0),r=i[e+8>>2],A=i[e+4>>2];i:{e:{if((r|0)!=(A|0)){f=i[i[A>>2]>>2];break e}if(!r)break i}i[e+8>>2]=A,Z(A)}return v=e+16|0,(f|0)!=0|0}function Uo(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,n=i[A+48>>2],A=E(4),i[f+4>>2]=A,k=A+4|0,i[f+12>>2]=k,i[A>>2]=r,i[f+8>>2]=k,a4(n,e,1835103083,f+4|0),A=i[f+4>>2],A&&(i[f+8>>2]=A,Z(A)),v=f+16|0}function r3(A,e){var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;X[i[i[r>>2]+8>>2]](r),p(r)}}function D6(){var A=0;return A=E(36),Q[A+2>>1]=0,Q[A+4>>1]=0,Q[A>>1]=263,u[A+32|0]=1,u[A+28|0]=0,i[A+20>>2]=2,i[A+24>>2]=2,u[A+16|0]=1,i[A+12>>2]=1,u[A+5|0]=0,u[A+6|0]=0,u[A+7|0]=0,u[A+8|0]=0,A|0}function Ce(A,e){var r=0,f=0;return r=v-16|0,v=r,f=r+12|0,A=i[A+28>>2],i[f>>2]=A,(A|0)!=129624&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(f,129800),X[i[i[A>>2]+48>>2]](A,77792,77818,e)|0,e2(f),v=r+16|0,e}function Np(A){A=A|0;var e=0,r=0,f=0,k=0;i:{if(!A||(e=l[A|0],!e)||(r=l[A+1|0],!r)||(f=l[A+2|0],!f)||(A=l[A+3|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function E8(A,e){var r=0,f=0;r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,e=i[A+4>>2],i[A>>2]=r,i[A+4>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;X[i[i[e>>2]+8>>2]](e),p(e)}}function Mp(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+16>>2]=i[e+16>>2],r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0}function Do(A){A=A|0;var e=0,r=0;i:{if(i[A+2192>>2]<=0||(e=i[A+2188>>2],e=i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2],!e))break i;u[e+104|0]=0,qo(A+2140|0),r=e}return r|0}function dA(A,e){var r=0,f=0;f=v-16|0,v=f,u[A|0]=0,r=i[i[e>>2]-12>>2]+e|0;i:{if(!i[r+16>>2]){i[r+72>>2]&&Xe(i[r+72>>2]),u[A|0]=!i[(i[i[e>>2]-12>>2]+e|0)+16>>2];break i}m4(r,4)}v=f+16|0}function Ho(A,e){var r=0,f=0;i:{if(r=i[A>>2],!r)break i;f=i[r+24>>2];e:{if((f|0)==i[r+28>>2]){e=X[i[i[r>>2]+52>>2]](r,e)|0;break e}i[r+24>>2]=f+4,i[f>>2]=e}if((e|0)!=-1)break i;i[A>>2]=0}}function xo(A,e,r,f){i:{if(!A)break i;e:switch(e+2|0){case 0:u[A|0]=r;return;case 1:Q[A>>1]=r;return;case 2:case 3:i[A>>2]=r;return;case 5:break e;default:break i}i[A>>2]=r,i[A+4>>2]=f}}function cA(A){var e=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,e=i[A>>2],e&8?(i[A>>2]=e|32,-1):(i[A+4>>2]=0,i[A+8>>2]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],0)}function bA(A,e,r,f,k,n,t,o,s){var w=0;w=v-16|0,v=w,y4(w,e,r,f,k,n,t,o,s^-2147483648),f=i[w>>2],r=i[w+4>>2],e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,v=w+16|0}function Up(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&(i[A+40>>2]=e,i[A+44>>2]=r),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function Dp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;return k=i[A+84>>2],f=r+256|0,n=hA(k,0,f),f=n?n-k|0:f,r=r>>>0>f>>>0?f:r,A8(e,k,r),e=k+f|0,i[A+84>>2]=e,i[A+8>>2]=e,i[A+4>>2]=r+k,r|0}function n4(A,e){var r=0,f=0;r=l[A|0],f=l[e|0];i:{if(!r|(r|0)!=(f|0))break i;for(;;){if(f=l[e+1|0],r=l[A+1|0],!r)break i;if(e=e+1|0,A=A+1|0,(r|0)!=(f|0))break}}return r-f|0}function Hp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+8>>2]=624576549,i[t+12>>2]=1394948685,o=A,A=t+16|0,e=z8(o,e,r,f,k,n,t+8|0,A),v=A,e|0}function zo(A,e){if(A=A|0,e=e|0,e=i[26929],i[A>>2]=i[26928],i[A+4>>2]=e,A=A+8|0,u[107731]>=0){e=i[26931],i[A>>2]=i[26930],i[A+4>>2]=e,i[A+8>>2]=i[26932];return}T(A,i[26930],i[26931])}function To(A,e){var r=0;i:{if(!e||(e=X0(e,84936,85180),!e|i[e+8>>2]&(i[A+8>>2]^-1))||!S1(i[A+12>>2],i[e+12>>2],0))break i;r=S1(i[A+16>>2],i[e+16>>2],0)}return r}function So(A,e){var r=0,f=0;f=v-32|0,v=f,r=i[e+40>>2];i:{if(!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=r,r=A,A=i[e+44>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=f+32|0}function s6(A){var e=0,r=0;return l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=(r<<2)+e,v=A+16|0,i[A+12>>2]}function xp(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,A=v-16|0,v=A,i[A+12>>2]=k,i[A+8>>2]=f-r,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(u0[e>>2]<u0[A>>2]?e:A)>>2]}function zp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&RA(i[A+24>>2],e,r,0),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function Tp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(f&&r)){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}e=E(8),r=i[r>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,hk(A,e)}function Sp(A){return A=A|0,i[A>>2]=89344,u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function jp(A){return A=A|0,i[A>>2]=87332,u[A+163|0]<0&&Z(i[A+152>>2]),u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),A2(A)|0}function H6(A){A=A|0;var e=0;return e=i[18063],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18071],i[A+12>>2]=71280,i[A+8>>2]=i[18072],u[A+55|0]<0&&Z(i[A+44>>2]),y0(A+12|0),p0(A- -64|0),A|0}function Op(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127?A=i[(A<<2)+78112>>2]:A=0,i[f>>2]=A,f=f+4|0,e=e+4|0;continue}break}return e|0}function Xi(A){var e=0,r=0;e=i[26885],r=A+7&-8,A=e+r|0;i:{if(!(A>>>0<=e>>>0&&r)&&(A>>>0<=kw()<<16>>>0||p_(A|0)|0))break i;return i[31336]=48,-1}return i[26885]=A,e}function Lp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,x2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(l[e+97|0]){t1(A,e,18411);break i}d6(A,e,r,-1,f)}v=k+32|0}function f3(A,e,r,f){var k=0;return k=v-16|0,v=k,r=R6(i[A+52>>2],r),A=i[A+60>>2],r=r+1|0,Q[k+14>>1]=r,u[k+12|0]=f,i[k+8>>2]=F[k+12>>1]|F[k+14>>1]<<16,F6(A,e,k+8|0),v=k+16|0,r}function Pp(A){A=A|0,i[A>>2]=87332,u[A+163|0]<0&&Z(i[A+152>>2]),u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),Z(A2(A))}function w6(A){var e=0,r=0;return l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=e+r,v=A+16|0,i[A+12>>2]}function qp(A){A=A|0,i[A>>2]=89344,u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function Ve(A,e){var r=0;r=i[A+136>>2];i:{if(r){A=i[r>>2];break i}r=E(16),i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95112,i[A+136>>2]=r,A=95112}return X[i[A+8>>2]](r,e)|0}function h4(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=r,i[n+8>>2]=k,r=s8(n+4|0,n+12|0),e=br(A,e,f,i[n+8>>2]),A=i[r>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=n+16|0,e}function jo(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break i}e=i[r>>2]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function Oo(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=X[i[i[e>>2]+36>>2]](e)|0;break i}e=l[r|0]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function Kp(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],i[(A<<2)+78112>>2]&e&&A>>>0<=127))break i;r=r+4|0;continue}break}return r|0}function ap(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],A>>>0>127|!(i[(A<<2)+78112>>2]&e)))break i;r=r+4|0;continue}break}return r|0}function $p(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,5),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0),l2(e,0),V4(e,A+20|0)}function Lo(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,e=s8(f+4|0,f+12|0),r=U7(A,7929,i[f+8>>2]),A=i[e>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=f+16|0,r}function ik(A,e){var r=0,f=0;r=v-16|0,v=r;i:{if(!(l[e+11|0]>>>7|0)){i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;break i}T(A,i[e>>2],i[e+4>>2])}v=r+16|0}function A3(A,e){A=A|0,e=e|0;var r=0;!l[A|0]|!l[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],u[A+24|0]=l[e+24|0])}function Po(){var A=0,e=0;return A=v-16|0,v=A,i[A+12>>2]=1073741823,i[A+8>>2]=2147483647,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(u0[e>>2]<u0[A>>2]?e:A)>>2]}function K(A,e,r,f){return i[A+4>>2]=r,i[A>>2]=e,e=A+8|0,u[f+11|0]>=0?(r=i[f+4>>2],i[e>>2]=i[f>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+8>>2],A):(T(e,i[f>>2],i[f+4>>2]),A)}function dp(A,e){A=A|0,e=e|0;var r=0,f=0;i:{e:{if((e|0)>0){for(;;)if(f=i[((r<<4)+A|0)+8>>2],f&&Z(f),r=r+1|0,(r|0)==(e|0))break e}if(!A)break i}Z(A)}}function k3(A,e){var r=0;if(e){k3(A,i[e>>2]),k3(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}Z(e)}}function n3(A,e){var r=0;if(e){n3(A,i[e>>2]),n3(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}Z(e)}}function Fe(A,e){var r=0;if(e){Fe(A,i[e>>2]),Fe(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;X[i[i[A>>2]+8>>2]](A),p(A)}Z(e)}}function gi(A,e){A=A|0,e=e|0;var r=0;!l[A|0]|!l[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,u[A+16|0]=l[e+16|0],u[A+18|0]=l[e+18|0],u[A+17|0]=l[e+17|0])}function cp(A,e){A=A|0,e=e|0,A=i[e+12>>2],A&&(i[e+16>>2]=A,Z(A)),A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function qo(A){var e=0;i[A+52>>2]=i[A+52>>2]-1,e=i[A+48>>2]+1|0,i[A+48>>2]=e,e>>>0>=2048&&(Z(i[i[A+36>>2]>>2]),i[A+36>>2]=i[A+36>>2]+4,i[A+48>>2]=i[A+48>>2]-1024)}function Ko(A,e,r){var f=0;if(X[i[i[A>>2]+28>>2]](A,e,r),f=i[A+36>>2],A=i[A+40>>2],(f|0)!=(A|0))for(;Ko(i[f>>2],e,r),f=f+8|0,(A|0)!=(f|0););}function ao(A,e){var r=0,f=0;return i[A>>2]=85888,i[A>>2]=86e3,r=h2(e),f=E(r+13|0),i[f+8>>2]=0,i[f+4>>2]=r,i[f>>2]=r,f=f+12|0,r=r+1|0,r&&z(f,e,r),i[A+4>>2]=f,A}function bp(A){A=A|0;var e=0,r=0;i[A>>2]=95456,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return A2(A)|0}function iy(A){A=A|0;var e=0,r=0;i[A>>2]=100240,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function ey(A){A=A|0;var e=0,r=0;i[A>>2]=98952,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function ry(A){A=A|0;var e=0,r=0;i[A>>2]=98064,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function fy(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,qn(n,i[e>>2],r,f,0),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function t3(A,e,r,f){var k=0;return k=i[e>>2],i[A>>2]=k,e=i[e+4>>2],u[A+20|0]=0,i[A+16>>2]=f,i[A+8>>2]=0,i[A+12>>2]=0,i[A+4>>2]=e,X[i[i[k>>2]+20>>2]](k,r,0)|0,A}function X2(A,e){var r=0;i:{if(l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,r>>>0<e>>>0){du(A,e-r|0);break i}r=A,l[A+11|0]>>>7|0&&(A=i[A>>2]),Xl(r,A,e)}}function $o(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,qn(n,i[e>>2],r,f,1),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function Ay(A){A=A|0;var e=0,r=0;i[A>>2]=98632,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function ky(A){A=A|0;var e=0,r=0;i[A>>2]=97696,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function ny(A){A=A|0;var e=0,r=0;i[A>>2]=99728,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}return b4(A)|0}function ty(A){A=A|0;var e=0;e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),u[A+51|0]<0&&Z(i[A+40>>2]),u[A+39|0]<0&&Z(i[A+28>>2]),u[A+27|0]<0&&Z(i[A+16>>2])}function co(){var A=0,e=0;l[108684]||(u[108684]=1),A=i[27164],i[27164]=A+1;i:{if((A|0)>0||(x7(),O7()))break i;i[27164]=i[27164]-1,e=11}return e|0}function uy(A){A=A|0;var e=0,r=0;i[A>>2]=95456,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A2(A))}function bo(A,e,r,f){var k=0;return k=v-16|0,v=k,A=I_(A|0,e|0,r|0,f&255,k+8|0)|0,A?(i[31336]=A,A=-1):A=0,v=k+16|0,l0=A?-1:i[k+12>>2],A?-1:i[k+8>>2]}function il(){var A=0;return A=E(24),Q[A+12>>1]=65535,u[A|0]=1,i[A+4>>2]=0,i[A+8>>2]=-1,Q[A+14>>1]=52428,Q[A+16>>1]=52428,Q[A+18>>1]=52428,Q[A+20>>1]=16,A|0}function el(A){var e=0,r=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=s8(e+8|0,e+12|0),r=i[i[31378]>>2]?4:1,A=i[A>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=e+16|0,r}function oy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=i[e>>2]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+4|0;continue}break}return A|0}function ly(A){A=A|0;var e=0,r=0;i[A>>2]=100240,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function sy(A){A=A|0;var e=0,r=0;i[A>>2]=98952,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function wy(A){A=A|0;var e=0,r=0;i[A>>2]=98064,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function hy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=u[e|0]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+1|0;continue}break}return A|0}function _y(A){A=A|0;var e=0,r=0;i[A>>2]=98632,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function By(A){A=A|0;var e=0,r=0;i[A>>2]=97696,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function vy(A,e){A=A|0,e=e|0;var r=0;r=-1;i:{if(!A|(e|0)<4||(r=0,l[A|0]!=255|l[A+1|0]!=216|l[A+2|0]!=255))break i;r=(l[A+3|0]&240)==224}return r|0}function my(A){A=A|0;var e=0,r=0;i[A>>2]=99728,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(b4(A))}function Zy(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[18673]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function Gy(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[19060]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function Wy(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,Vu(n,i[e>>2],f,r),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function rl(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,i[f+8>>2]=e,A=of(A|0,f+8|0,1,f+4|0)|0,A?(i[31336]=A,A=-1):A=0,v=f+16|0,A?-1:i[f+4>>2]}function Z1(A,e,r,f){i:switch(e-1|0){case 0:l2(A,r&255);return;case 1:u2(A,r&65535);return;case 3:C0(A,r);return;case 7:e4(A,r,f);break;default:break i}}function fl(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=k,k=s8(n+8|0,n+12|0),e=ne(A,e,r,f),A=i[k>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=n+16|0,e}function Xy(A){return A=A|0,l[129924]?i[32480]:(l[131048]||(u[131048]=1),L2(131024,84616),L2(131036,84628),u[129924]=1,i[32480]=131024,131024)}function gy(A){A=A|0;var e=0;return e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=86184,e&&X[i[i[e>>2]+4>>2]](e),i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function Al(A,e,r){var f=0;return f=v-16|0,v=f,i[f+8>>2]=e,i[f+12>>2]=A,i[f+4>>2]=r,e=0,v=f+16|0,A=f+4|0,u0[A>>2]>=u0[f+12>>2]&&(e=u0[A>>2]<u0[f+8>>2]),e}function Qy(A){return A=A|0,l[129916]?i[32478]:(l[131016]||(u[131016]=1),R2(130992,19443),R2(131004,19437),u[129916]=1,i[32478]=130992,130992)}function kl(A){var e=0;if(X[i[i[A>>2]+24>>2]](A),e=i[A+36>>2],A=i[A+40>>2],(e|0)!=(A|0))for(;kl(i[e>>2]),e=e+8|0,(A|0)!=(e|0););}function Iy(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=i[e>>2],u[k|0]=A>>>0<128?A:f,k=k+1|0,e=e+4|0;continue}break}return e|0}function Cy(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=u[e|0],(A|0)>=0&&(A=i[i[18673]+(A<<2)>>2]),u[e|0]=A,e=e+1|0;continue}break}return e|0}function Vy(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=u[e|0],(A|0)>=0&&(A=i[i[19060]+(A<<2)>>2]),u[e|0]=A,e=e+1|0;continue}break}return e|0}function Fy(A){A=A|0;var e=0;return i[A>>2]=88520,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=88360,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function Ey(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],i[e+4>>2]=k,$4(e,k,r,r+f|0,f),i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function py(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,1),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function yy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,2),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function Yy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,4),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function Ry(A,e){A=A|0,e=e|0;var r=0;i:{r=i[e+328>>2];e:{if(!r)break e;if(qf(A,e,r),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}R9(A,e)}}function Ee(A,e,r,f){return i[A>>2]=i[e>>2],e=i[e+4>>2],u[A+20|0]=0,i[A+16>>2]=r,i[A+12>>2]=0,i[A+8>>2]=f,i[A+4>>2]=e,f&&(i[A+12>>2]=i[f+12>>2]+1),A}function k0(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=i[16901],n=l[e|0]==42,n||L1(32536,6,1,k),i[f+12>>2]=r,Mr(A,e+n|0,r,1953,1954),n6(k),v=f+16|0}function nl(A){A=A|0;var e=0;return e=1,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760|u0[A+12>>2]>65535||(e=u0[A+16>>2]>65535),e|0}function Jy(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=u[e|0],u[k|0]=(A|0)<0?f:A,k=k+1|0,e=e+1|0;continue}break}return e|0}function Ny(A){A=A|0;var e=0;e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=86184,e&&X[i[i[e>>2]+4>>2]](e),i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function My(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0;return h=e,e=0,X[A|0](h,r,f,k,n,e|t,o,e|s,w)|0}function Uy(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,S1(A,i[e+8>>2],n)){NA(e,r,f,k);return}A=i[A+8>>2],X[i[i[A>>2]+20>>2]](A,e,r,f,k,n)}function tl(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=f,n=h6(e),i[k+12>>2]=n,k=f,n=h6(r),i[k+8>>2]=n,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function Dy(A){A=A|0;var e=0;i[A>>2]=88520,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=88360,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function ek(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,r=s8(f+8|0,f+12|0),e=Or(A,e),A=i[r>>2],A&&(i[31378]=(A|0)==-1?125392:A),v=f+16|0,e}function Hy(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[A+32>>2],r=e,A=i[A+36>>2],e=(k|0)==(A|0)&e>>>0<f>>>0|A>>>0<k>>>0,l0=e?A:k,(e?r:f)|0}function xy(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}X[i[i[e>>2]+44>>2]](A,i[e+4>>2],r)}function zy(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[23582],i[A>>2]=i[23581],i[A+4>>2]=e,i[A+8>>2]=i[23583];return}X[i[i[e>>2]+52>>2]](A,i[e+4>>2],r)}function z4(A){A=A|0;var e=0,r=0;if(A){e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;X[i[i[e>>2]+8>>2]](e),p(e)}Z(A)}}function u3(A){var e=0,r=0;e=v-16|0,v=e,r=-1;i:{if(Ge(A)||(X[i[A+32>>2]](A,e+15|0,1)|0)!=1)break i;r=l[e+15|0]}return v=e+16|0,r}function ul(A,e){var r=0;return r=e>>31,A=A^r,mn(A-r|0,(e^r)-((A>>>0<r>>>0)+r|0)|0,100,0),l0=Q6,A=r^g6,e=A-r|0,l0=(r^l0)-((A>>>0<r>>>0)+r|0)|0,e}function ol(A){var e=0,r=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)!=(A|0))for(;r=i[e>>2]+r|0,e=e+8|0,(A|0)!=(e|0););return r}function Ty(A,e){A=A|0,e=e|0;i:{if(i[26954]||(_f(),!l[107820]))break i;eA()}i[26954]=i[26954]+1,i[A+8>>2]=48906,i[A>>2]=0,i[A+4>>2]=0}function Sy(A){A=A|0;var e=0,r=0;return e=v-32|0,v=e,l9(e+12|0,A),A=l[A+72|0],r=i[e+12>>2],u[e+31|0]<0&&Z(i[e+20>>2]),v=e+32|0,(r?-1:A)|0}function L1(A,e,r,f){var k=0;k=G(e,r);i:{if(i[f+76>>2]<0){A=Pr(A,k,f);break i}A=Pr(A,k,f)}return(k|0)==(A|0)?e?r:0:(A>>>0)/(e>>>0)|0}function rk(A,e,r,f,k,n,t,o,s,w,h,_,B,m){if((m|0)<=8){X[i[A+12>>2]](e,r,f,k,n,t,o,s,w,h,_,B);return}X[i[A+28>>2]](e,r,f,k,n,t,o,s,w,h,_,B,m)}function jy(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+280>>2],A=i[A+284>>2],!A|i[A+4>>2]!=-1||(X[i[i[A>>2]+8>>2]](A),p(A)),(e?e+104|0:0)|0}function ll(A){A=A|0;var e=0;i[A+2192>>2]&&(e=i[A+2188>>2],u[i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2]+104|0]=0,qo(A+2140|0))}function Oy(){var A=0;return A=E(32),i[A+8>>2]=0,i[A+12>>2]=0,u[A+4|0]=0,i[A>>2]=9e4,i[A+16>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,A|0}function Ly(){var A=0;return A=E(32),i[A>>2]=0,i[A+4>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A|0}function Py(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&Z(e),e=i[A+8>>2],e&&Z(e),e=i[A+12>>2],e&&Z(e),e=i[A+16>>2],e&&Z(e),Z(A))}function qy(A,e){A=A|0,e=e|0;var r=0,f=0;X[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129816),i[A+36>>2]=e,r=A,f=X[i[i[e>>2]+28>>2]](e)|0,u[r+44|0]=f}function Ky(A){A=A|0;var e=0;return i[A>>2]=101432,e=i[A+480>>2],e&&(i[A+484>>2]=e,Z(e)),e=i[A+468>>2],e&&(i[A+472>>2]=e,Z(e)),T1(A)|0}function ay(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0;return w=e,e=0,X[A|0](w,r,f,k,e|n,t,e|o,s)|0}function $y(A,e){A=A|0,e=e|0;var r=0,f=0;X[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129824),i[A+36>>2]=e,r=A,f=X[i[i[e>>2]+28>>2]](e)|0,u[r+44|0]=f}function dy(A){A=A|0;var e=0,r=0;return e=v-16|0,v=e,It(e+4|0,i[A>>2]),r=i[e+8>>2],A=i[e+4>>2],A&&(i[e+8>>2]=A,Z(A)),v=e+16|0,r-A>>3}function o3(A,e){var r=0,f=0;r=l[A+112|0];i:{if(r||(r=0,f=i[A+124>>2],A=i[A+120>>2],f-A>>>0<=e>>>0))break i;r=l[A+e|0]}return r}function l3(A,e,r){var f=0;f=t0[r>>3],t0[A>>3]=t0[e+32>>3]+(f*t0[e>>3]+f*t0[e+8>>3]),t0[A+8>>3]=t0[e+40>>3]+(f*t0[e+16>>3]+t0[r+8>>3]*t0[e+24>>3])}function cy(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+160>>2],A=i[A+164>>2],!A|i[A+4>>2]!=-1||(X[i[i[A>>2]+8>>2]](A),p(A)),(e|0)!=0|0}function by(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=e,e=i[e>>2]+7&-8,i[r>>2]=e+16,f=A,k=Pf(i[e>>2],i[e+4>>2],i[e+8>>2],i[e+12>>2]),t0[f>>3]=k}function sl(A,e){var r=0;return r=i[A+24>>2],(r|0)==i[A+28>>2]?X[i[i[A>>2]+52>>2]](A,e&255)|0:(i[A+24>>2]=r+1,u[r|0]=e,e&255)}function fk(A,e,r,f,k,n){var t=0,o=0;t=i[A+4>>2],o=t>>8,A=i[A>>2],t&1&&(o=i[i[f>>2]+o>>2]),X[i[i[A>>2]+20>>2]](A,e,r,f+o|0,t&2?k:2,n)}function wl(A){var e=0,r=0;for(A=A>>>0<=1?1:A;;){i:{if(e=p2(A),e||(r=i[32839],!r))break i;X[r|0]();continue}break}return e}function hl(A,e,r){var f=0;f=v-16|0,v=f;i:{if(!(u[e+120|0]&1|r>>>0>30)){u[e+120|0]=1;break i}e=ws(r)}v=f+16|0,i[A+4>>2]=r,i[A>>2]=e}function iY(A,e){A=A|0,e=e|0,e&&(A=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24),u[e|0]=A,u[e+1|0]=A>>>8,u[e+2|0]=A>>>16,u[e+3|0]=A>>>24)}function eY(A){A=A|0;var e=0;i[A>>2]=101432,e=i[A+480>>2],e&&(i[A+484>>2]=e,Z(e)),e=i[A+468>>2],e&&(i[A+472>>2]=e,Z(e)),Z(T1(A))}function rY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,X[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),Q[e+4>>1]=256,Nf(A,e,r),v=f+16|0}function fY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,X[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),Q[e+4>>1]=256,s9(A,e,r),v=f+16|0}function AY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,X[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),Q[e+4>>1]=256,Rf(A,e,r),v=f+16|0}function kY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,X[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),Q[e+4>>1]=256,Yf(A,e,r),v=f+16|0}function s3(A,e,r,f,k){var n=0,t=0;n=i[A+4>>2],t=n>>8,A=i[A>>2],n&1&&(t=i[i[r>>2]+t>>2]),X[i[i[A>>2]+24>>2]](A,e,r+t|0,n&2?f:2,k)}function nY(A,e){if(A=A|0,e=e|0,!e){if(u[A+31|0]<0){u[i[A+20>>2]]=0,i[A+24>>2]=0;return}u[A+31|0]=0,u[A+20|0]=0;return}R2(A+20|0,e)}function tY(A,e){if(A=A|0,e=e|0,e){R2(A+20|0,e);return}if(u[A+31|0]<0){u[i[A+20>>2]]=0,i[A+24>>2]=0;return}u[A+31|0]=0,u[A+20|0]=0}function uY(A){A=A|0;var e=0;return i[A>>2]=87800,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function oY(A,e){A=A|0,e=e|0;var r=0;return e=X0(e,86628,86648),!e|i[A+104>>2]!=i[e+104>>2]||(r=i[A+108>>2]==i[e+108>>2]),r|0}function lY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return f=i[A+4>>2],k=A+4|0,A=i[A+8>>2],r=i[e>>2],e=i[e+4>>2],$4(k,A,r,e,e-r|0),A-f|0}function v4(A,e){A=A|0,e=e|0;i:{if(A=i[e+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function w3(A,e){var r=0;r=v-16|0,v=r,$2(A,r+12|0)&&(A=i[r+12>>2],A?A=A&1?A+1>>1:0-(A>>1)|0:A=0,i[e>>2]=A),v=r+16|0}function sY(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){i[f>>2]=u[e|0],f=f+4|0,e=e+1|0;continue}break}return e|0}function wY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,f&&(i[f>>2]=0),e=i[23937],i[A>>2]=i[23936],i[A+4>>2]=e,i[A+8>>2]=i[23938]}function _l(A,e,r,f,k,n){A=X[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=Xr(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function Bl(A,e,r,f,k,n){A=X[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=gr(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function Qi(A,e){A=A|0,e=e|0;var r=0;r=i[e+448>>2],e=i[e+452>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}function hY(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){u[f|0]=l[e|0],f=f+1|0,e=e+1|0;continue}break}return e|0}function _Y(A){A=A|0;var e=0,r=0;return e=E(8),r=i[A+8>>2],A=i[A+12>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+4>>2]=A,i[e>>2]=r,e|0}function h3(A){var e=0;e=i[A+328>>2],i[A+328>>2]=e-1,i[A+336>>2]=i[A+336>>2]+1,!((e|0)>0)&&(M0(22135,18299,733,5585),H())}function vl(A,e,r){var f=0;for(f=v-16|0,v=f,u[f+15|0]=r;;){if(e){u[A|0]=l[f+15|0],e=e-1|0,A=A+1|0;continue}break}v=f+16|0}function BY(A){A=A|0;var e=0;i[A>>2]=87800,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function h6(A){var e=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,i[A+12>>2]=i[e+12>>2],v=A+16|0,v=e+16|0,i[A+12>>2]}function p(A){var e=0,r=0;i:{if(e=A+8|0,i[e>>2]&&(r=e,e=i[e>>2]-1|0,i[r>>2]=e,(e|0)!=-1))break i;X[i[i[A>>2]+16>>2]](A)}}function vY(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,S1(A,i[e+8>>2],0)){OA(e,r,f);return}A=i[A+8>>2],X[i[i[A>>2]+28>>2]](A,e,r,f)}function R0(A){return i[A>>2]=70872,Ff(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function mY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&X[i[n+28>>2]](e,r,f,k,i[A+28>>2])}function Ak(){var A=0;return A=E(32),u[A+24|0]=0,i[A+16>>2]=0,i[A+20>>2]=2147483647,i[A+8>>2]=-1,i[A+12>>2]=-1,u[A|0]=1,A|0}function ZY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&X[i[n+24>>2]](e,r,f,k,i[A+28>>2])}function ml(A){return i[A>>2]=71120,Ff(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function Zl(A,e,r,f,k,n){A=X[i[i[A+8>>2]>>2]](A+8|0)|0,A=Xr(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function GY(A,e){A=A|0,e=e|0;var r=0;return r=i[A+2152>>2],A=i[A+2148>>2],r-A>>2>>>0>e>>>0?A=i[A+(e<<2)>>2]:A=0,A|0}function Gl(A,e,r,f,k,n){A=X[i[i[A+8>>2]>>2]](A+8|0)|0,A=gr(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function pe(){var A=0;return A=E(24),i[A+8>>2]=0,i[A+12>>2]=0,u[A|0]=1,u[A+15|0]=0,u[A+16|0]=0,u[A+17|0]=0,u[A+18|0]=0,A|0}function WY(A){A=A|0;var e=0;return i[A>>2]=86228,e=i[A+48>>2],e&&Z(e),i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function J0(A,e){i[A+20>>2]=0,i[A+24>>2]=e,i[A+12>>2]=0,i[A+4>>2]=4098,i[A+8>>2]=6,i[A+16>>2]=!e,o0(A+32|0,0,40),Ff(A+28|0)}function Wl(){var A=0;return l[108684]||(u[108684]=1),A=i[27164],(A|0)<=0?12:(A=A-1|0,i[27164]=A,A||js(),0)}function V2(A){var e=0;i:{if(A=i[A+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;X[i[i[A>>2]+8>>2]](A),p(A)}}function Xl(A,e,r){var f=0;f=v-16|0,v=f;i:if(l[A+11|0]>>>7|0)break i;x6(A,r),u[f+15|0]=0,u[e+r|0]=l[f+15|0],v=f+16|0}function XY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,Lr(e,r?A+8|0:A),Lr(e,4),f|0}function gY(A){A=A|0;var e=0;A&&(z2(i[A+16>>2]),u[A+31|0]<0&&Z(i[A+20>>2]),e=i[A>>2],e&&(i[A+4>>2]=e,Z(e)),Z(A))}function gl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[A+32>>2],A=i[A+36>>2],((A|0)==(r|0)&e>>>0>f>>>0|A>>>0<r>>>0?2:0)|0}function kk(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=73076,i[r>>2]=71408,i[A>>2]=70988,i[r>>2]=71008,V3(i[17744]+A|0,e)}function nk(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=73076,i[r>>2]=71844,i[A>>2]=71236,i[r>>2]=71256,V3(i[17806]+A|0,e)}function Ql(A){var e=0;i[A+8>>2]=0,i[A+12>>2]=0,e=i[A+16>>2],i[A+16>>2]=0,e=e>>3,i[A>>2]=i[A>>2]-e,i[A+4>>2]=e+i[A+4>>2]}function QY(A){A=A|0;var e=0;return(X[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+4,i[A>>2])}function Il(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?X[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+4,i[e>>2])}function Cl(A){A=A|0;var e=0,r=0;return i[A>>2]=86e3,e=i[A+4>>2]-12|0,r=i[e+8>>2]-1|0,i[e+8>>2]=r,(r|0)<0&&Z(e),A|0}function G1(A,e){return i[A+4>>2]=e,u[A|0]=0,e=i[i[e>>2]-12>>2]+e|0,i[e+16>>2]||(e=i[e+72>>2],e&&Xe(e),u[A|0]=1),A}function IY(A){A=A|0;var e=0;return(X[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+1,l[A|0])}function Vl(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?X[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+1,l[e|0])}function Fl(A,e,r){var f=0,k=0;f=t0[r>>3],k=t0[r+8>>3],t0[A>>3]=f*t0[e>>3]+k*t0[e+8>>3],t0[A+8>>3]=f*t0[e+16>>3]+k*t0[e+24>>3]}function f1(A,e,r,f){i[r+12>>2]=f,X[i[i[e>>2]+56>>2]](A,e,r,i[r+4>>2]-(i[r>>2]+f|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2]}function CY(A){A=A|0;var e=0;i[A>>2]=86228,e=i[A+48>>2],e&&Z(e),i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function VY(A,e){A=A|0,e=e|0;var r=0,f=0;r=E(1),i[A+8>>2]=i[24177],f=i[24176],i[A>>2]=i[24175],i[A+4>>2]=f,i[e>>2]=r}function El(A){return A=(A|0)>2147481747?A-2e3|0:A,A&3?0:(A=A+1900|0,(A|0)%100|0?1:!((A|0)%400|0))}function FY(A){A=A|0;var e=0;return A=i[A>>2],i[A+116>>2]==1&&(e=i[A+120>>2]==3?4:10),A=o8(A,e),(A?(A|0)<0?-1:A:-1)|0}function EY(A){A=A|0;var e=0;return A=i[A>>2],i[A+116>>2]==1&&(e=i[A+120>>2]==3?4:10),A=l8(A,e),(A?(A|0)<0?-1:A:-1)|0}function e2(A){var e=0;A=i[A>>2],(A|0)!=129624&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&X[i[i[A>>2]+8>>2]](A))}function pY(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;return k=v-16|0,v=k,X[A|0](k+8|0,e,r,f),v=k+16|0,i[k+12>>2]}function pl(A,e,r,f,k,n){i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k&65535|(n>>>16&32768|(k&2147418112)>>>16)<<16}function yY(A){A=A|0;var e=0,r=0;if(e=i[A>>2],e)for(;Z(e),r=r+1|0,e=i[(r<<2)+A>>2],!!e;);Z(A)}function Ii(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+456>>2],r=A,A=i[e+460>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function tk(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+(e<<2),v=r+16|0,i[r+12>>2]}function yl(A,e,r){var f=0;f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function YY(){var A=0;return A=E(24),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=1,i[A+12>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,A|0}function s8(A,e){var r=0;return r=i[31378],e=i[e>>2],e&&(i[31378]=(e|0)==-1?125392:e),i[A>>2]=(r|0)==125392?-1:r,A}function RY(A){A=A|0;var e=0;return i[A>>2]=101224,z2(i[A+472>>2]),e=i[A+460>>2],e&&(i[A+464>>2]=e,Z(e)),T1(A)|0}function JY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,Lr(e,r?A+8|0:A),f|0}function NY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=A,k=e,A=u[r+11|0],e=(A|0)<0,$o(f,k,e?i[r>>2]:r,e?i[r+4>>2]:A,0)}function MY(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+40>>2],r=A,A=i[e+44>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function UY(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+48>>2],r=A,A=i[e+52>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function DY(A){A=A|0;var e=0,r=0;return e=u[A+31|0],r=(e|0)<0,c4(E((r?i[A+24>>2]:e)+1|0),r?i[A+20>>2]:A+20|0)|0}function K8(A,e,r,f){var k=0;k=v-32|0,v=k,rr(k+12|0,i[A+68>>2],e,r,f),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function HY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,i[f+8>>2]=1,i[f+12>>2]=964,E7(A,e,f+8|0,r),v=f+16|0}function Yl(A,e){var r=0,f=0;f=i[e>>2],i[e>>2]=0,r=i[A>>2],i[A>>2]=f,r&&X[i[A+4>>2]](r),i[A+4>>2]=i[e+4>>2]}function xY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[24179],i[A>>2]=i[24178],i[A+4>>2]=e,i[A+8>>2]=i[24180]}function zY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}function p8(A){i:{if(A=i[A+4>>2]&74,A){if((A|0)==64)return 8;if((A|0)!=8)break i;return 16}return 0}return 10}function TY(A){A=A|0;var e=0;return i[A>>2]=105308,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function g1(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[r>>2],v=f+16|0,A}function uk(A){A=A|0;var e=0;return e=i[18184],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18187],se(A+8|0),p0(A+108|0),A|0}function SY(A){A=A|0;var e=0;return i[A>>2]=105788,U1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),A2(A)|0}function ok(A){A=A|0;var e=0;return e=i[18223],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18226],se(A+4|0),p0(A+104|0),A|0}function jY(A){A=A|0;var e=0;return i[A>>2]=106076,U1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function OY(A){A=A|0;var e=0;return i[A>>2]=106156,U1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),A2(A)|0}function lk(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+e,v=r+16|0,i[r+12>>2]}function Rl(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+120>>2],e=(A|0)>0?A:0}return e|0}function Jl(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+124>>2],e=(A|0)>0?A:0}return e|0}function LY(A){A=A|0;var e=0;return i[A>>2]=104908,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function PY(A){A=A|0;var e=0;return i[A>>2]=104988,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function qY(A,e,r){A=A|0,e=e|0,r=r|0,A=i[e+4>>2],A&&Z(A),A=i[e+8>>2],A&&Z(A),A=i[e+12>>2],A&&Z(A)}function KY(A){A=A|0;var e=0;return i[A>>2]=105068,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function aY(A){A=A|0;var e=0;return i[A>>2]=105148,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function S1(A,e,r){return r?(A|0)==(e|0)?1:!n4(i[A+4>>2],i[e+4>>2]):i[A+4>>2]==i[e+4>>2]}function $Y(A){A=A|0;var e=0;return i[A>>2]=105228,U1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),A2(A)|0}function dY(A,e,r){A=A|0,e=e|0,r=r|0,zf(i[e>>2],r),i[A+8>>2]=i[24070],e=i[24069],i[A>>2]=i[24068],i[A+4>>2]=e}function sk(A){A=A|0;var e=0;return e=i[18139],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18142],Ik(A+4|0),p0(A+56|0),A|0}function Nl(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function cY(A){A=A|0;var e=0;i[A>>2]=101224,z2(i[A+472>>2]),e=i[A+460>>2],e&&(i[A+464>>2]=e,Z(e)),Z(T1(A))}function x6(A,e){if(l[A+11|0]>>>7|0){i[A+4>>2]=e;return}u[A+11|0]=l[A+11|0]&128|e&127,u[A+11|0]=l[A+11|0]&127}function _3(A,e,r){if(r)for(;;){if(i[A>>2]==(e|0))return A;if(A=A+4|0,r=r-1|0,!r)break}return 0}function T4(A){var e=0;return l[A+11|0]>>>7|0&&(A=i[A>>2]),e=v-16|0,v=e,i[e+12>>2]=A,v=e+16|0,i[e+12>>2]}function J4(A,e){var r=0,f=0;return r=i[A+108>>2],f=e,e=i[A+112>>2],r=_3(r,f,e-r>>2),((r||e)|0)!=i[A+112>>2]}function bY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,0),f=i[A+4>>2],Z1(e,r,f,f>>31),A=i[A+8>>2],Z1(e,r,A,A>>31)}function iR(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return t=e,e=0,X[A|0](t,e|r,f,e|k,n)|0}function Ml(A,e,r,f,k){e=X8(e,r,f,k,4),l[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function Ul(A,e,r,f,k){e=g8(e,r,f,k,4),l[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function eR(A,e,r){return A=A|0,e=e|0,r=r|0,A=X[i[i[A+24>>2]+16>>2]](e,r,i[A+28>>2])|0,(A?(A|0)==1?1:2:0)|0}function wk(A,e){e&&(wk(A,i[e>>2]),wk(A,i[e+4>>2]),l[e+36|0]!=1|u[e+35|0]>=0||Z(i[e+24>>2]),Z(e))}function rR(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=e>>31,f=A,k=O0(e,r,e,r),i[f+72>>2]=k,i[A+76>>2]=l0}function fR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=100,i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function AR(A){if(A=A|0,l[A+112|0]==1){u[A+97|0]=1;return}if(l[A+120|0]==1){u[A+97|0]=2;return}u[A+97|0]=0}function Dl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=v-16|0,v=f,X[A|0](f+8|0,e,r),v=f+16|0,i[f+12>>2]}function hk(A,e){if(!i[e+4>>2]){X[i[i[e>>2]+36>>2]](A,e+4|0);return}i[A+8>>2]=48906,i[A>>2]=0,i[A+4>>2]=0}function kR(A){A=A|0;var e=0;i[A>>2]=105308,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function nR(A){A=A|0;var e=0;i[A>>2]=105788,U1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),Z(A2(A))}function tR(A){A=A|0;var e=0;i[A>>2]=106076,U1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(A2(A))}function Hl(A,e,r,f,k,n,t,o){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,i[k>>2]=r,i[o>>2]=n,3}function uR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=1,i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function oR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=0,i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function lR(A){A=A|0;var e=0;i[A>>2]=104908,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function sR(A){A=A|0;var e=0;i[A>>2]=104988,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function wR(A){A=A|0;var e=0;i[A>>2]=105068,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function hR(A){A=A|0;var e=0;i[A>>2]=105148,U1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function _R(A){A=A|0;var e=0;i[A>>2]=105228,U1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(A2(A))}function BR(A){A=A|0;var e=0;i[A>>2]=106156,U1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),Z(A2(A))}function vR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function xl(A,e){e&&(Q[A>>1]=i[e+4>>2],Q[A+2>>1]=i[e+8>>2],Q[A+4>>1]=i[e+12>>2],u[A+6|0]=l[e+16|0]!=0)}function zl(A,e,r){var f=0;e=e-A|0,f=e>>2;i:{if(!f||(f=f<<2,!f))break i;z(r,A,f)}return e+r|0}function ye(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[24179],i[A>>2]=i[24178],i[A+4>>2]=e,i[A+8>>2]=i[24180]}function mR(A){A=A|0;var e=0;e=u0[A+104>>2]>65535?3:l[A+164|0]<<1&2,u[A+97|0]=i[A+112>>2]&&e>>>0<=2?2:e}function ZR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}function GR(){i[27033]=1,i[27027]=7626,i[27026]=3,i[27025]=11874,i[27024]=2,i[27009]=0,i[27008]=108096}function WR(A){A=A|0;var e=0;return i[A>>2]=95984,U1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function XR(A){A=A|0;var e=0,r=0;return A=i[A+4>>2],e=h2(A)+1|0,r=p2(e),r?A=A8(r,A,e):A=0,A|0}function gR(A){A=A|0;var e=0;return e=v-16|0,v=e,$u(e,i[A+24>>2]),v=e+16|0,l0=i[e+12>>2],i[e+8>>2]}function QR(A){A=A|0;var e=0;return i[A>>2]=95940,U1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function B3(){var A=0;return A=E(52),u[A+16|0]=1,i[A+12>>2]=6,i[A+4>>2]=1,i[A+8>>2]=13,u[A|0]=1,A|0}function _k(A){i[A+136>>2]||(i[A+136>>2]=i[i[31378]>>2]?73200:73176),i[A+72>>2]||(i[A+72>>2]=1)}function IR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,1,o)}function CR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,2,o)}function VR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,3,o)}function FR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,1,o)}function ER(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,2,o)}function pR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,3,o)}function yR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,1,o)}function Tl(A){if(i[A+20>>2]!=i[A+24>>2])for(;Kn(A),i[A+20>>2]!=i[A+24>>2];);}function YR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,2,o)}function RR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,3,o)}function JR(A,e){return A=A|0,e=e|0,e>>>0<=2?A=i[i[A+124>>2]+i[(e<<2)+59168>>2]>>2]:A=0,A|0}function NR(A,e,r){return A=A|0,e=e|0,r=r|0,r>>>0<=127?A=(i[(r<<2)+78112>>2]&e)!=0:A=0,A|0}function MR(A,e){A=A|0,e=e|0,ks(i[e>>2]),i[A+8>>2]=i[24177],e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e}function UR(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;t=e,e=0,X[A|0](t,e|r,f,e|k,n)}function Sl(A){F[A+4>>1]==2&&(Q[A+4>>1]=6),F[A>>1]==2&&(Q[A>>1]=1),F[A+2>>1]==2&&(Q[A+2>>1]=13)}function Bk(A,e,r){var f=0;return f=v-16|0,v=f,r=_3(A,i[r>>2],e-A>>2),v=f+16|0,((r||e)-A|0)+A|0}function DR(A){A=A|0;var e=0;return i[A>>2]=106236,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function HR(A){A=A|0;var e=0;return i[A>>2]=106396,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function xR(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A>>2]=4,i[A+4>>2]=0,i[A+8>>2]=25930}function jl(A,e){var r=0;r=v-16|0,v=r;i:{if((A|0)==(e|0)){u[A+120|0]=0;break i}$8(e,4)}v=r+16|0}function v3(A){if(i[A+336>>2]!=i[A+340>>2])for(;i[A+336>>2]!=i[A+340>>2];);}function zR(A,e,r,f,k,n,t){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,X[A|0](e,r,f,k,n,t)|0}function TR(A){A=A|0;var e=0;return i[A>>2]=86932,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function SR(A){A=A|0;var e=0;return i[A>>2]=86772,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function jR(A){A=A|0;var e=0;return i[A>>2]=88200,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function OR(A){A=A|0;var e=0;return i[A>>2]=88360,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function LR(A){A=A|0;var e=0;return i[A>>2]=98128,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),A2(A)|0}function PR(A){A=A|0;var e=0;return i[A>>2]=99144,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function qR(A){A=A|0;var e=0;return i[A>>2]=99224,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function KR(A){A=A|0;var e=0;return i[A>>2]=88840,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function aR(A){A=A|0;var e=0;return i[A>>2]=98552,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function $R(A){A=A|0;var e=0;return i[A>>2]=99384,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function dR(A){A=A|0;var e=0;i[A>>2]=95984,U1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function Ol(A,e){var r=0;for(r=i[A+4>>2];;){if((e|0)!=(r|0)){r=r-4|0;continue}break}i[A+4>>2]=e}function m3(A,e){e&&(m3(A,i[e>>2]),m3(A,i[e+4>>2]),A=i[e+16>>2],i[e+16>>2]=0,A&&Z(A),Z(e))}function cR(A,e){A=A|0,e=e|0;var r=0;return r=v-16|0,v=r,X[A|0](r+8|0,e),v=r+16|0,i[r+12>>2]}function bR(A,e){A=A|0,e=e|0,A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0}function vk(A,e,r){var f=0;return f=v-16|0,v=f,r=hA(A,u[r|0],e-A|0),v=f+16|0,((r||e)-A|0)+A|0}function Z3(A,e,r){A=A|0,e=e|0,r=r|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function iJ(A){A=A|0;var e=0;i[A>>2]=95940,U1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function Ll(A){A=A|0;var e=0;return i[A>>2]=78060,e=i[A+8>>2],!e|!(u[A+12|0]&1)||Z(e),A|0}function S4(A){var e=0;return e=1,F[A+6>>1]!=2|F[A+8>>1]!=2|F[A+10>>1]!=2||(e=!l[A+12|0]),e}function eJ(A,e,r){A=A|0,e=e|0,r=r|0,e=i[23937],i[A>>2]=i[23936],i[A+4>>2]=e,i[A+8>>2]=i[23938]}function Ye(A,e,r){(r|0)<0&&(M0(22123,18327,138,7265),H()),i[A+4>>2]=e,i[A>>2]=e,i[A+8>>2]=e+r}function mk(A,e,r){A=A|0,e=e|0,r=r|0,e=i[24176],i[A>>2]=i[24175],i[A+4>>2]=e,i[A+8>>2]=i[24177]}function rJ(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&(X[i[i[A>>2]+40>>2]](e),i[A+4>>2]=0),Z(A))}function fJ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,S1(A,i[e+8>>2],n)&&NA(e,r,f,k)}function P1(A,e){u[A+4|0]=0,u[A+11|0]=4,u[A+3|0]=e,u[A+2|0]=e>>>8,u[A+1|0]=e>>>16,u[A|0]=e>>>24}function AJ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,X[i[i[e>>2]+16>>2]](A,e,i[r+8>>2],i[r+12>>2],0,f)}function kJ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function nJ(A){A=A|0;var e=0,r=0;return e=u[A+11|0],r=(e|0)<0,Nu(r?i[A>>2]:A,r?i[A+4>>2]:e)|0}function tJ(A){A=A|0;var e=0;i[A>>2]=106236,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function Pl(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function uJ(A){A=A|0;var e=0;i[A>>2]=106396,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function x0(){var A=0;A=Ue(4),i[A>>2]=85888,i[A>>2]=85848,i[A>>2]=85868,Si(A|0,85952,32),H()}function ql(A){A=A|0;var e=0;i[A>>2]=88360,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function oJ(A){A=A|0;var e=0;i[A>>2]=86932,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function lJ(A){A=A|0;var e=0;i[A>>2]=88200,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(A2(A))}function sJ(A){A=A|0;var e=0;i[A>>2]=86772,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function Kl(A,e){var r=0;return r=A+8|0,A=i[r>>2],i[A+(e<<2)>>2]!=0&i[r+4>>2]-A>>2>>>0>e>>>0}function wJ(A){A=A|0;var e=0;i[A>>2]=99144,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function hJ(A){A=A|0;var e=0;i[A>>2]=99224,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function _J(A){A=A|0;var e=0;i[A>>2]=88840,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function BJ(A){A=A|0;var e=0;i[A>>2]=98552,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function vJ(A){A=A|0;var e=0;i[A>>2]=99384,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function al(A){var e=0,r=0;for(r=A;e=r,r=e+4|0,!!i[e>>2];);return e-A>>2}function mJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,X[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k)}function ZJ(A){A=A|0;var e=0;i[A>>2]=98128,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(A2(A))}function Zk(A,e){var r=0;i:{if(r=i[A>>2],!r||(sl(r,e)|0)!=-1)break i;i[A>>2]=0}}function GJ(A){A=A|0;var e=0;return i[A>>2]=105868,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function WJ(A){return A=A|0,i[26972]=6,u[107876]=1,u[107892]=1,i[26970]=6,i[26971]=6,107876}function XJ(A){A=A|0;var e=0;return i[A>>2]=86404,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function G3(A,e){var r=0;return F[A+4>>1]!=F[e+4>>1]|F[A>>1]!=F[e>>1]?r:l[A+6|0]==l[e+6|0]}function gJ(A){A=A|0;var e=0;return i[A>>2]=95376,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function QJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,1,1)}function IJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,1,2)}function CJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,1,3)}function VJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,2,1)}function FJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,2,2)}function EJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,2,3)}function pJ(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=yA(A)}return e|0}function yJ(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=YA(A)}return e|0}function YJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,3,1)}function RJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,3,2)}function JJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,x8(A,e,r,f,k,n,t,3,3)}function NJ(A){return A=A|0,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760}function a8(A,e,r,f){var k=0;return k=v-16|0,v=k,i[k+12>>2]=f,A=br(A,e,r,f),v=k+16|0,A}function MJ(A){A=A|0;var e=0;return i[A>>2]=95112,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),A|0}function UJ(A,e,r){return A=A|0,e=e|0,r=r|0,!(X[i[i[A+24>>2]+12>>2]](e,r,i[A+28>>2])|0)|0}function DJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,X[A|0](e,r,f,k,n,t)}function HJ(A,e,r){return A=A|0,e=e|0,r=r|0,!(X[i[i[A+24>>2]+8>>2]](e,r,i[A+28>>2])|0)|0}function $l(A,e){A=A|0,e=e|0;i:{if(!e||(A=i[e>>2],!A))break i;Z(A),i[e>>2]=0}}function dl(A){A=A|0;var e=0;A=i[i[i[A>>2]>>2]>>2],e=i[32449]+1|0,i[32449]=e,i[A+4>>2]=e}function cl(A){(A|0)!=0&(A|0)!=73176&(A|0)!=73200&(A|0)!=129220&(A|0)!=129244&&Z(A)}function xJ(A,e){A=A|0,e=e|0,e=i[23937],i[A>>2]=i[23936],i[A+4>>2]=e,i[A+8>>2]=i[23938]}function k2(A,e){var r=0,f=0;return r=e&31,f=(-1>>>r&A)<<r,r=A,A=0-e&31,f|(r&-1<<A)>>>A}function bl(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=e,A=U7(A,11384,e),v=r+16|0,A}function n8(A,e){A=A|0,e=e|0,e=v-16|0,v=e,i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,v=e+16|0}function zJ(A){A=A|0;var e=0;i[A>>2]=105868,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function TJ(A){A=A|0;var e=0;i[A>>2]=86404,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function c0(A,e){return A=i[A>>2],e=l1(e),Kl(A,e)||(Q1(),H()),i[i[A+8>>2]+(e<<2)>>2]}function SJ(A){for(A=A|0,A=131048;A=R1(A-12|0),(A|0)!=131024;);}function jJ(A){A=A|0;var e=0;i[A>>2]=95376,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function OJ(A,e,r,f,k,n){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,Jf(A,e,r,f,k,n)|0}function LJ(A){for(A=A|0,A=130200;A=s2(A-12|0),(A|0)!=130032;);}function PJ(A){for(A=A|0,A=130376;A=R1(A-12|0),(A|0)!=130208;);}function qJ(A){for(A=A|0,A=130672;A=s2(A-12|0),(A|0)!=130384;);}function KJ(A){for(A=A|0,A=130976;A=R1(A-12|0),(A|0)!=130688;);}function aJ(A){for(A=A|0,A=131016;A=s2(A-12|0),(A|0)!=130992;);}function $J(A){A=A|0;var e=0;i[A>>2]=95112,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),Z(A)}function dJ(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],i[e>>2]=i[A+24>>2],i[r>>2]=i[A+28>>2]}function cJ(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,l0=i[A+36>>2],i[A+32>>2]}function bJ(A){return A=A|0,i[A>>2]=105468,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function iN(A){return A=A|0,i[A>>2]=106816,u[A+299|0]<0&&Z(i[A+288>>2]),ai(A)|0}function eN(A){return A=A|0,i[A>>2]=105708,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function rN(A,e){A=A|0,e=e|0;var r=0;z2(i[A+16>>2]),r=A,A=pe(),i[r+16>>2]=A,gi(A,e)}function fN(A){return A=A|0,i[A>>2]=105548,u[A+143|0]<0&&Z(i[A+132>>2]),A2(A)|0}function is(A){return A=A|0,i[A>>2]=79144,i[A+8>>2]!=(a2()|0)&&cl(i[A+8>>2]),A|0}function AN(A,e){A=A|0,e=e|0;var r=0;return r=i[A>>2],e&&(i[e>>2]=i[A+4>>2]-r),r|0}function c1(A,e){for(;i[A+16>>2]=i[A+16>>2]-e,A=i[A+8>>2],!!A;);}function kN(A){return A=A|0,i[A>>2]=94592,u[A+471|0]<0&&Z(i[A+460>>2]),T1(A)|0}function nN(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[18673]+(e<<2)>>2]),e<<24>>24}function tN(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[19060]+(e<<2)>>2]),e<<24>>24}function uN(A){return A=A|0,i[A>>2]=86852,u[A+123|0]<0&&Z(i[A+112>>2]),A2(A)|0}function oN(A){return A=A|0,i[A>>2]=88760,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function lN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,X[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,f)}function sN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,X[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,f)}function wN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,X[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,f)}function hN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,X[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function _N(A){return A=A|0,i[A>>2]=89560,u[A+111|0]<0&&Z(i[A+100>>2]),A2(A)|0}function BN(A){return A=A|0,i[A>>2]=89640,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function vN(A){return A=A|0,i[A>>2]=87172,u[A+135|0]<0&&Z(i[A+124>>2]),A2(A)|0}function mN(A,e){A=A|0,e=e|0,e&&(A=i[i[A>>2]+32>>2],Q[e>>1]=A,Q[e+2>>1]=A>>>16)}function ZN(A){return A=A|0,A=I7(i[A+60>>2])|0,A?(i[31336]=A,A=-1):A=0,A|0}function Gk(A,e){A=A|0,e=e|0;var r=0;r=A,A=i[e+448>>2],X[i[i[A>>2]+24>>2]](r,A)}function GN(A){A=A|0;var e=0;e=A+12|0,A=i[e+8816>>2],A&&(i[e+8820>>2]=A,Z(A))}function WN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,fu(A,r,f),v=e+16|0}function XN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,su(A,r,f),v=e+16|0}function gN(A){A=A|0,A&&(z2(i[A+12>>2]),u[A+31|0]<0&&Z(i[A+20>>2]),Z(A))}function q1(A){return A=f2(A),(A|0)==-99999|!A||(A=A&1?A+1>>1:0-(A>>1)|0),A}function QN(A,e){return A=A|0,e=e|0,i[A+2152>>2]-i[A+2148>>2]>>2>(e|0)&(e|0)>=0}function IN(A){return A=A|0,l[129940]||(ti(129928,79308),u[129940]=1),129928}function CN(A){A=A|0,i[A>>2]=105468,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function VN(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,A=bo(i[A+60>>2],e,r,f),A|0}function FN(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[18673]+(e<<2)>>2]),e|0}function EN(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[19060]+(e<<2)>>2]),e|0}function pN(A){A=A|0,i[A>>2]=106816,u[A+299|0]<0&&Z(i[A+288>>2]),Z(ai(A))}function es(A,e){if(i[A>>2]<(e|0))for(;i[A>>2]<(e|0););}function yN(A){return A=A|0,l[129956]||(ti(129944,79344),u[129956]=1),129944}function YN(A){A=A|0,i[A>>2]=105708,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function RN(A){return A=A|0,l[129972]||(oe(129960,19233),u[129972]=1),129960}function JN(A){return A=A|0,l[129988]||(ti(129976,79380),u[129988]=1),129976}function NN(A){return A=A|0,l[130020]||(ti(130008,79464),u[130020]=1),130008}function MN(A,e){A=A|0,e=e|0,A&&(A=i[A>>2],X[i[i[A>>2]+16>>2]](A,(e|0)!=0))}function z6(A){A=A|0,i[A>>2]=105548,u[A+143|0]<0&&Z(i[A+132>>2]),Z(A2(A))}function UN(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,X[A|0](e,r,f,k)|0}function DN(A){A=A|0,i[A>>2]=94592,u[A+471|0]<0&&Z(i[A+460>>2]),Z(T1(A))}function HN(A){return A=A|0,l[130004]||(oe(129992,7920),u[130004]=1),129992}function Re(A){for(var e=0;;){if(A){A=A-1&A,e=e+1|0;continue}break}return e}function xN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,S1(A,i[e+8>>2],0)&&OA(e,r,f)}function zN(A){A=A|0,i[A>>2]=88760,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function TN(A){A=A|0,i[A>>2]=86852,u[A+123|0]<0&&Z(i[A+112>>2]),Z(A2(A))}function SN(A){A=A|0,i[A>>2]=87172,u[A+135|0]<0&&Z(i[A+124>>2]),Z(A2(A))}function y8(A,e){var r=0;r=v-16|0,v=r,i[r+12>>2]=e,qs(107392,A,e),v=r+16|0}function jN(A){A=A|0,i[A>>2]=89560,u[A+111|0]<0&&Z(i[A+100>>2]),Z(A2(A))}function ON(A){A=A|0,i[A>>2]=89640,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function LN(A,e,r){A=A|0,e=e|0,r=r|0,i[e>>2]=i[A+460>>2],i[r>>2]=i[A+464>>2]}function PN(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+59144>>2]+A>>2]:0)|0}function qN(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+59156>>2]+A>>2]:0)|0}function KN(A){return A=A|0,i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function aN(A,e,r){A=A|0,e=e|0,r=r|0,i[e>>2]=i[A+120>>2],i[r>>2]=i[A+124>>2]}function W3(A,e,r,f){return i[A+76>>2]<0,Cu(A,e,r,f)}function $N(){var A=0;return A=E(12),i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,A|0}function rs(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],X[i[i[A>>2]+20>>2]](A,e,r)}function fs(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0}function As(A,e){var r=0;r=Vl(i[e>>2]),i[A+4>>2]=i[e>>2],u[A|0]=r<<24>>24}function dN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,M0(22224,18176,68,10362),H()}function cN(A){return A=A|0,A=i[A+64>>2],(l[A+101|0]?l[A+102|0]?12:10:8)|0}function X3(){var A=0;A=ao(Ue(8),11043),i[A>>2]=86100,Si(A|0,86112,1),H()}function ks(A){A=A|0;var e=0;return e=A+548|0,Nn(e),Nn(e),u[A+548|0]=1,0}function ns(A,e){return A=A|0,e=e|0,A=o8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function ts(A,e){return A=A|0,e=e|0,A=l8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function H1(A,e){e=!i[A+24>>2]|e,i[A+16>>2]=e,e&i[A+20>>2]&&(Q1(),H())}function Je(){i[26954]||(_f(),l[107820]&&eA(),i[26954]=i[26954]+1)}function bN(A){A=A|0,i[A>>2]=86360,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function i8(A){var e=0;i[A+16>>2]=0,e=i[A+8>>2],e&&i8(e),u[A+20|0]=1}function Wk(A){A=A|0,u[A+97|0]=(i[A+108>>2]|i[A+116>>2]|i[A+132>>2])!=0}function us(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],X[i[i[A>>2]+24>>2]](A,e))}function os(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],X[i[i[A>>2]+28>>2]](A,e))}function Ne(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[k>>2]=r,3}function iM(A){return A=A|0,A=i[A+64>>2],(l[A+105|0]?l[A+111|0]+8|0:8)|0}function eM(A){return A=A|0,A=X[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,A|0}function _6(A,e){A=A|0,e=e|0,u[A|0]=2,u[A+1|0]=3,u[A+2|0]=0,u[A+3|0]=4}function Xk(A){return A=A|0,i[A+8>>2]!=(a2()|0)&&cl(i[A+8>>2]),A|0}function rM(A){A=A|0,wo(i[A>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),Z(A)}function fM(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,X[A|0](e,r,f)|0}function AM(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,ik(A,n)}function kM(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,l0=-1,-1}function nM(A,e,r){A=A|0,e=e|0,r=r|0,H9(i[A>>2],e,i[i[r>>2]+24>>2])}function ls(A,e){A=A|0,e=e|0,e&&(A=i[e>>2],A&&Z(A),i[e>>2]=0)}function ss(A,e){var r=0;r=Il(i[e>>2]),i[A+4>>2]=i[e>>2],i[A>>2]=r}function tM(A,e,r){return A=A|0,e=e|0,r=r|0,(e>>>0<128?e:r)<<24>>24}function uM(A){return A=A|0,A=i[A>>2],(F[A+32>>1]|F[A+34>>1])!=0|0}function oM(A,e,r){A=A|0,e=e|0,r=r|0,M0(22224,18176,51,10212),H()}function lM(A){return A=A|0,A=i[A+16>>2],X[i[i[A>>2]+8>>2]](A)|0}function sM(A){A=A|0,u[A+12|0]=1,i[A+4>>2]=2,i[A+8>>2]=2,u[A|0]=1}function g3(){var A=0;A=Ue(4),i[A>>2]=84832,Si(A|0,84844,783),H()}function wM(A){return A=A|0,A=i[A>>2],i[A+280>>2]-i[A+276>>2]>>2}function hM(A){return A=A|0,A=i[A>>2],i[A+136>>2]-i[A+132>>2]>>3}function _M(A){return A=A|0,A=i[A+8>>2],i[A+16>>2]-i[A+12>>2]>>3}function BM(A){A=A|0,Xe(128324),Xe(128676),JA(128412),JA(128764)}function vM(A){A=A|0,u[A+97|0]=i[A+40>>2]-i[A+36>>2]>>>0>524280}function _2(){var A=0;A=Ue(4),i[A>>2]=84888,Si(A|0,84900,32),H()}function mM(A,e){return A=A|0,e=e|0,(i[e+4>>2]==54865?A+12|0:0)|0}function ZM(A){return A=A|0,A=i[A>>2],i[A+440>>2]-i[A+436>>2]>>2}function GM(A){return A=A|0,A=i[A>>2],X[i[i[A>>2]+64>>2]](A)|0}function WM(A){return A=A|0,A=i[A>>2],X[i[i[A>>2]+68>>2]](A)|0}function XM(A){return A=A|0,A=i[A>>2],X[i[i[A>>2]+16>>2]](A)|0}function gM(A){return A=A|0,A=i[A+8>>2],A?el(A)|0:1}function QM(A,e){A=A|0,e=e|0,A=i[e>>2],A&&(i[e+4>>2]=A,Z(A))}function IM(A,e,r){A=A|0,e=e|0,r=r|0,i[A+28>>2]=r,i[A+24>>2]=e}function ws(A){return A>>>0>1073741823&&(Q1(),H()),bu(A<<2,4)}function gk(A){A=ao(Ue(8),A),i[A>>2]=86048,Si(A|0,86060,1),H()}function CM(A){return A=A|0,l[129925]||(u[129925]=1),107688}function VM(A){return A=A|0,l[129941]||(u[129941]=1),107700}function FM(A){return A=A|0,X[i[i[A>>2]+68>>2]](i[A+4>>2])|0}function EM(A,e){A=A|0,e=e|0,i[A+32>>2]=F[e>>1]|F[e+2>>1]<<16}function Qk(A){z2(i[A+12>>2]),u[A+31|0]<0&&Z(i[A+20>>2])}function Ci(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,d6(A,e,r,-1,f)}function Ik(A){return A=A|0,i[A>>2]=71280,s2(A+32|0),y0(A)|0}function pM(A,e){A=A|0,e=e|0,i[A+8>>2]=u[e+11|0]<0?i[e>>2]:e}function yM(A){return A=A|0,A?l[i[A>>2]+288|0]:0}function YM(A){return A=A|0,A?l[i[A>>2]+336|0]:0}function Y1(A,e){e&&(Y1(A,i[e>>2]),Y1(A,i[e+4>>2]),Z(e))}function Ck(A,e){e&&(Ck(A,i[e>>2]),Ck(A,i[e+4>>2]),Z(e))}function F1(A,e){A=A|0,e=e|0,u[e+19|0]<0&&Z(i[e+8>>2])}function Vk(A,e){e&&(Vk(A,i[e>>2]),Vk(A,i[e+4>>2]),Z(e))}function RM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,16,e,r,f)}function JM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,32,e,r,f)}function hs(A){return A=A|0,A?i[i[A+8>>2]>>2]:0}function Vi(A,e){e&&(Vi(A,i[e>>2]),Vi(A,i[e+4>>2]),Z(e))}function Q3(A,e){e&&(Q3(A,i[e>>2]),Q3(A,i[e+4>>2]),Z(e))}function NM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,16,e,f)}function MM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,32,e,f)}function I3(A,e){e&&(I3(A,i[e>>2]),I3(A,i[e+4>>2]),Z(e))}function UM(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,l0=0,0}function DM(A,e,r){return A=A|0,e=e|0,r=r|0,X[A|0](e,r)|0}function HM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,Mf(A,e,r,0,f)}function xM(A,e,r){return A=A|0,e=e|0,r=r|0,((e|0)<0?r:e)|0}function zM(A){return A=A|0,A?i[A>>2]- -64|0:0}function TM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,4,e,r,f)}function SM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,4,e,f)}function jM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,8,e,f)}function OM(A){return A=A|0,A?l[i[A>>2]+4|0]:0}function LM(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,8,e,r,f)}function R1(A){return l[A+11|0]>>>7|0&&$8(i[A>>2],4),A}function PM(A,e){A=A|0,e=e|0,u[e+11|0]<0&&Z(i[e>>2])}function s2(A){return l[A+11|0]>>>7|0&&$8(i[A>>2],1),A}function _s(A,e,r){return A=A|0,e=e|0,r=r|0,S1(A,e,0)|0}function Fi(A,e){var r=0;r=bu(e,1),i[A+4>>2]=e,i[A>>2]=r}function Bs(A){return A=A|0,i[A>>2]=79192,s2(A+12|0),A|0}function vs(A){return A=A|0,i[A>>2]=79232,s2(A+16|0),A|0}function y0(A){return A=A|0,i[A>>2]=70872,e2(A+4|0),A|0}function Fk(A){return A=A|0,i[A>>2]=71120,e2(A+4|0),A|0}function qM(A){return A=A|0,i[i[i[A>>2]+156>>2]+120>>2]}function KM(A){return A=A|0,sk(i[i[A>>2]-12>>2]+A|0)|0}function aM(A){return A=A|0,uk(i[i[A>>2]-12>>2]+A|0)|0}function $M(A){return A=A|0,ok(i[i[A>>2]-12>>2]+A|0)|0}function ms(A,e,r){A=A|0,e=e|0,r=r|0,i[i[A>>2]+e>>2]=r}function dM(A){return A=A|0,(i[A>>2]>=3?i[A+40>>2]:0)|0}function cM(A,e,r){A=A|0,e=e|0,r=r|0,Mf(A,e,r,0,95568)}function bM(A){return A=A|0,p3(i[i[A>>2]-12>>2]+A|0)|0}function Ei(A,e){var r=0;r=ws(e),i[A+4>>2]=e,i[A>>2]=r}function Zs(A){return A=A|0,y3(i[i[A>>2]-12>>2]+A|0)|0}function Gs(A){return A=A|0,Y3(i[i[A>>2]-12>>2]+A|0)|0}function iU(A){return A=A|0,H6(i[i[A>>2]-12>>2]+A|0)|0}function Ek(A){return A=A|0,X[i[i[A>>2]+12>>2]](A)|0}function pi(A,e){return A=jt(A,e),l[A|0]==(e&255)?A:0}function eU(A){A=A|0,u[A+27|0]<0&&Z(i[A+16>>2])}function rU(A){return A=A|0,l0=i[A+44>>2],i[A+40>>2]}function Ws(A){return A=A|0,X[i[i[A>>2]+24>>2]]()|0}function C3(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0}function z0(A){A=A|0,X[i[i[A+16>>2]>>2]](A+16|0)|0}function Xs(A,e){return A=A|0,e=e|0,i[i[A>>2]+e>>2]}function pk(A,e){return A=A|0,e=e|0,u1(i[A>>2],e)|0}function gs(A,e){return A=A|0,e=e|0,j0(i[A>>2],e)|0}function e8(A){return A?31-k1(A-1^A)|0:32}function y2(A){A=A|0,X[i[i[A+12>>2]>>2]](A+12|0)|0}function fU(A){return A=A|0,i[i[A>>2]+160>>2]!=0|0}function Me(A,e,r){$4(A+12|0,i[A+16>>2],e,e+r|0,r)}function AU(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0}function kU(A){return A=A|0,i[i[A>>2]+188>>2]!=0|0}function nU(){var A=0;return A=E(4),i[A>>2]=0,A|0}function tU(A){A=A|0,u[107731]<0&&Z(i[26930])}function uU(A){A=A|0,u[107751]<0&&Z(i[26935])}function oU(A,e,r){A=A|0,e=e|0,r=r|0,_9(A,16,e,r)}function V3(A,e){J0(A,e),i[A+72>>2]=0,u[A+80|0]=0}function lU(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,16,e)}function sU(A){return A=A|0,i[A+8>>2]-i[A+4>>2]|0}function wU(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,32,e)}function hU(A,e,r){A=A|0,e=e|0,r=r|0,Cr(A,16,e,r)}function _U(A){return A=A|0,l[i[A+124>>2]+9016|0]}function BU(A,e,r){A=A|0,e=e|0,r=r|0,Cr(A,32,e,r)}function vU(A){return A=A|0,l[i[A+124>>2]+9018|0]}function mU(A){return A=A|0,l[i[A+124>>2]+9019|0]}function ZU(A){return A=A|0,l[i[A+124>>2]+9020|0]}function GU(A,e,r){A=A|0,e=e|0,r=r|0,_9(A,32,e,r)}function F3(A,e){return A=A|0,e=e|0,X[A|0](e)|0}function WU(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,4,e)}function XU(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,8,e)}function gU(A,e){A=A|0,e=e|0,i[i[A>>2]+196>>2]=e}function QU(A,e,r){A=A|0,e=e|0,r=r|0,Cr(A,4,e,r)}function IU(A,e,r){A=A|0,e=e|0,r=r|0,Cr(A,8,e,r)}function CU(A,e){A=A|0,e=e|0,i[i[A>>2]+144>>2]=e}function VU(A){A=A|0,u[A+97|0]=u0[A+104>>2]>65535}function Qs(A,e,r,f){C_(A|0,e|0,8,0,r|0,-1,f|0)}function E3(A,e){return A?Or(A,e):0}function FU(A,e){A=A|0,e=e|0,i[i[A>>2]+56>>2]=e}function EU(A){return A=A|0,(i[A>>2]==1?100:0)|0}function pU(A){return A=A|0,l[i[A+64>>2]+112|0]}function yU(A){return A=A|0,l[i[A+64>>2]+113|0]}function $8(A,e){if(e>>>0>8){Z(A);return}Z(A)}function Is(A,e,r){return A=A|0,e=e|0,r=r|0,A|0}function YU(A){return A=A|0,i[A+4>>2]-i[A>>2]|0}function RU(A){return A=A|0,l[i[A+64>>2]+122|0]}function JU(A){return A=A|0,l[i[A+64>>2]+123|0]}function Cs(A){var e=0,r=0;e=A,r=a2(),i[e>>2]=r}function NU(A){return A=A|0,i[A>>2]=102668,A|0}function MU(A){return A=A|0,i[A>>2]=102744,A|0}function UU(A){return A=A|0,i[A>>2]=100784,A|0}function DU(A){return A=A|0,i[A>>2]=102784,A|0}function HU(A){return A=A|0,i[A>>2]=100824,A|0}function xU(A){return A=A|0,i[A>>2]=102824,A|0}function zU(A){return A=A|0,i[A>>2]=102864,A|0}function TU(A){return A=A|0,i[A>>2]=100864,A|0}function SU(A){return A=A|0,i[A>>2]=102940,A|0}function jU(A){return A=A|0,i[A>>2]=100904,A|0}function OU(A){return A=A|0,i[A>>2]=103016,A|0}function LU(A){return A=A|0,i[A>>2]=100120,A|0}function PU(A){return A=A|0,i[A>>2]=100944,A|0}function qU(A){return A=A|0,i[A>>2]=103056,A|0}function KU(A){return A=A|0,i[A>>2]=100984,A|0}function aU(A){return A=A|0,i[A>>2]=103096,A|0}function $U(A){return A=A|0,i[A>>2]=101024,A|0}function dU(A){return A=A|0,i[A>>2]=103172,A|0}function cU(A){return A=A|0,i[A>>2]=101064,A|0}function bU(A){return A=A|0,i[A>>2]=101952,A|0}function iD(A){return A=A|0,i[A>>2]=103248,A|0}function eD(A){return A=A|0,i[A>>2]=101104,A|0}function rD(A){return A=A|0,i[A>>2]=103324,A|0}function fD(A){return A=A|0,i[A>>2]=101144,A|0}function AD(A){return A=A|0,i[A>>2]=101184,A|0}function kD(A){return A=A|0,i[A>>2]=102116,A|0}function nD(A){return A=A|0,i[A>>2]=103476,A|0}function tD(A){return A=A|0,i[A>>2]=102192,A|0}function uD(A){return A=A|0,i[A>>2]=103552,A|0}function oD(A){return A=A|0,i[A>>2]=102232,A|0}function lD(A){return A=A|0,i[A>>2]=103628,A|0}function t4(A,e,r){l[A|0]&32||Pr(e,r,A)}function sD(A){return A=A|0,i[A>>2]=102272,A|0}function wD(A){return A=A|0,i[A>>2]=103704,A|0}function hD(A){return A=A|0,i[A>>2]=102312,A|0}function _D(A){return A=A|0,i[A>>2]=106476,A|0}function BD(A){return A=A|0,i[A>>2]=102352,A|0}function vD(A){return A=A|0,i[A>>2]=102392,A|0}function mD(A){return A=A|0,i[A>>2]=102432,A|0}function ZD(A){return A=A|0,i[A>>2]=106548,A|0}function GD(A){return A=A|0,i[A>>2]=102472,A|0}function Vs(A,e){A=A|0,e=e|0,u[A+4|0]=(e|0)!=0}function WD(A){return A=A|0,i[A>>2]=102512,A|0}function XD(A){return A=A|0,i[A>>2]=94512,A|0}function gD(A){return A=A|0,i[A>>2]=102552,A|0}function QD(A){return A=A|0,i[A>>2]=106680,A|0}function ID(A){return A=A|0,i[A>>2]=102592,A|0}function CD(A){return A=A|0,i[A>>2]=102040,A|0}function VD(A){return A=A|0,i[A>>2]=103400,A|0}function FD(A){return A=A|0,i[A>>2]=93572,A|0}function ED(A){return A=A|0,i[A>>2]=97968,A|0}function pD(A){A=A|0,Hk(i[i[A>>2]-12>>2]+A|0)}function yD(A){return A=A|0,i[A>>2]=61564,A|0}function YD(A){return A=A|0,i[A>>2]=89732,A|0}function RD(A){return A=A|0,i[A>>2]=91052,A|0}function JD(A){return A=A|0,i[A>>2]=92252,A|0}function ND(A){return A=A|0,i[A>>2]=93612,A|0}function MD(A){return A=A|0,i[A>>2]=98912,A|0}function UD(A){A=A|0,cs(i[i[A>>2]-12>>2]+A|0)}function DD(A){return A=A|0,i[A>>2]=89772,A|0}function HD(A){return A=A|0,i[A>>2]=91092,A|0}function xD(A){return A=A|0,i[A>>2]=92292,A|0}function zD(A){return A=A|0,i[A>>2]=93652,A|0}function TD(A){return A=A|0,i[A>>2]=61676,A|0}function SD(A){return A=A|0,xu(i[A+468>>2])|0}function jD(A){A=A|0,bs(i[i[A>>2]-12>>2]+A|0)}function OD(A){return A=A|0,i[A>>2]=89812,A|0}function LD(A){return A=A|0,i[A>>2]=91132,A|0}function PD(A){return A=A|0,i[A>>2]=92332,A|0}function qD(A){return A=A|0,i[A>>2]=93692,A|0}function KD(A){return A=A|0,i[A>>2]=89852,A|0}function aD(A){return A=A|0,i[A>>2]=91172,A|0}function $D(A){return A=A|0,i[A>>2]=92372,A|0}function dD(A){return A=A|0,i[A>>2]=93732,A|0}function cD(A){return A=A|0,i[A>>2]=95536,A|0}function bD(A){return A=A|0,i[A>>2]=97128,A|0}function iH(A){A=A|0,iw(i[i[A>>2]-12>>2]+A|0)}function eH(A){return A=A|0,i[A>>2]=89892,A|0}function rH(A){return A=A|0,i[A>>2]=91212,A|0}function fH(A){return A=A|0,i[A>>2]=94772,A|0}function AH(A){return A=A|0,i[A>>2]=97168,A|0}function kH(A){return A=A|0,i[A>>2]=93852,A|0}function nH(A){return A=A|0,i[A>>2]=89932,A|0}function tH(A){return A=A|0,i[A>>2]=91252,A|0}function uH(A){return A=A|0,i[A>>2]=92492,A|0}function oH(A){return A=A|0,X[i[A+4>>2]]()|0}function lH(A){return A=A|0,i[A>>2]=97208,A|0}function sH(A){return A=A|0,i[A>>2]=93892,A|0}function wH(A){return A=A|0,i[A>>2]=94820,A|0}function hH(A){return A=A|0,i[A>>2]=89972,A|0}function _H(A){return A=A|0,i[A>>2]=91292,A|0}function BH(A){return A=A|0,i[A>>2]=92532,A|0}function vH(A){return A=A|0,((A|0)==1?100:0)|0}function mH(A){return A=A|0,i[A>>2]=93932,A|0}function ZH(A){return A=A|0,i[i[A>>2]+188>>2]}function Fs(A){return A=A|0,i[i[A>>2]+116>>2]}function GH(A){return A=A|0,i[A>>2]=97248,A|0}function WH(A){return A=A|0,i[A>>2]=90012,A|0}function XH(A){return A=A|0,i[A>>2]=91332,A|0}function gH(A){return A=A|0,i[A>>2]=92572,A|0}function QH(A){return A=A|0,i[A>>2]=94860,A|0}function IH(A){return A=A|0,i[A>>2]=93972,A|0}function CH(A){return A=A|0,i[A>>2]=97288,A|0}function VH(A){return A=A|0,i[A>>2]=90052,A|0}function FH(A){return A=A|0,i[A>>2]=91372,A|0}function EH(A){return A=A|0,i[A>>2]=92612,A|0}function pH(A){return A=A|0,i[A>>2]=94900,A|0}function yH(A){return A=A|0,i[A>>2]=94012,A|0}function Es(A,e,r){return A=A|0,e=e|0,r=r|0,-1}function YH(A){return A=A|0,i[A>>2]=97328,A|0}function RH(A){return A=A|0,i[A>>2]=90092,A|0}function JH(A){return A=A|0,i[A>>2]=91412,A|0}function NH(A){return A=A|0,i[A>>2]=92732,A|0}function MH(A){return A=A|0,i[A>>2]=94940,A|0}function UH(A){return A=A|0,i[A>>2]=90132,A|0}function DH(A){return A=A|0,i[A>>2]=91452,A|0}function HH(A){return A=A|0,i[A>>2]=94052,A|0}function xH(A){return A=A|0,i[A>>2]=94992,A|0}function zH(A){return A=A|0,i[A>>2]=90172,A|0}function TH(A){return A=A|0,i[A>>2]=92772,A|0}function SH(A){return A=A|0,i[A>>2]=94092,A|0}function jH(A){return A=A|0,i[A>>2]=102e3,A|0}function OH(A){return A=A|0,i[A>>2]=91492,A|0}function LH(A){return A=A|0,i[A>>2]=90212,A|0}function PH(A){return A=A|0,i[A>>2]=92892,A|0}function qH(A){return A=A|0,i[i[A>>2]+144>>2]}function KH(A){return A=A|0,i[A>>2]=97512,A|0}function aH(A){A=A|0,Uk(i[i[A>>2]-12>>2]+A|0)}function $H(A){return A=A|0,i[A>>2]=90252,A|0}function dH(A){return A=A|0,i[A>>2]=91572,A|0}function cH(A){return A=A|0,i[A>>2]=94172,A|0}function bH(A){return A=A|0,i[A>>2]=95072,A|0}function ix(A){return A=A|0,i[A>>2]=92932,A|0}function ex(A){return A=A|0,i[A>>2]=90292,A|0}function rx(A){return A=A|0,i[A>>2]=91612,A|0}function fx(A){return A=A|0,i[A>>2]=94212,A|0}function Ax(A){return A=A|0,i[A>>2]=98512,A|0}function kx(A){return A=A|0,i[i[A>>2]+120>>2]}function nx(A){return A=A|0,i[A>>2]=90332,A|0}function tx(A){return A=A|0,i[A>>2]=91652,A|0}function ux(A){return A=A|0,i[A>>2]=93052,A|0}function ox(A){return A=A|0,i[A>>2]=96912,A|0}function lx(A){return A=A|0,i[A>>2]=94252,A|0}function sx(A){return A=A|0,i[A>>2]=90372,A|0}function wx(A){return A=A|0,i[A>>2]=91692,A|0}function ps(A){A=A|0,Nk(i[i[A>>2]-12>>2]+A|0)}function hx(A){return A=A|0,i[A>>2]=93092,A|0}function _x(A){return A=A|0,i[A>>2]=94292,A|0}function Bx(A){return A=A|0,i[A>>2]=96952,A|0}function vx(A){return A=A|0,i[A>>2]=97632,A|0}function mx(A){return A=A|0,i[A>>2]=90412,A|0}function Zx(A){return A=A|0,i[A>>2]=91732,A|0}function Gx(A,e){return A=A|0,e=e|0,F7(A,e)|0}function Wx(A){return A=A|0,i[A>>2]=90452,A|0}function Xx(A){return A=A|0,i[A>>2]=91852,A|0}function gx(A){return A=A|0,i[A>>2]=93212,A|0}function Qx(A){return A=A|0,i[A>>2]=96028,A|0}function ys(A){A=A|0,Mk(i[i[A>>2]-12>>2]+A|0)}function Ix(A){return A=A|0,i[A>>2]=90572,A|0}function Cx(A){return A=A|0,i[A>>2]=91892,A|0}function Vx(A){return A=A|0,i[A>>2]=93252,A|0}function Fx(A){return A=A|0,i[A>>2]=96068,A|0}function Ex(A){return A=A|0,i[A>>2]=90612,A|0}function px(A){return A=A|0,i[A>>2]=91932,A|0}function yx(A){return A=A|0,i[A>>2]=96108,A|0}function Yx(A){return A=A|0,i[A>>2]=93372,A|0}function Rx(A){return A=A|0,i[A>>2]=95336,A|0}function Jx(A){return A=A|0,i[A>>2]=90732,A|0}function Nx(A){return A=A|0,i[A>>2]=96148,A|0}function Mx(A){return A=A|0,i[A>>2]=99688,A|0}function Ux(A){return A=A|0,i[A>>2]=91972,A|0}function Dx(A){return A=A|0,i[A>>2]=90772,A|0}function Hx(A){return A=A|0,i[A>>2]=93412,A|0}function xx(A){return A=A|0,i[A>>2]=94472,A|0}function zx(A){return A=A|0,i[A>>2]=96188,A|0}function Tx(A){return A=A|0,i[A>>2]=92012,A|0}function Sx(A){return A=A|0,i[A>>2]=90892,A|0}function jx(A){return A=A|0,i[A>>2]=93452,A|0}function Ox(A){return A=A|0,i[A>>2]=96228,A|0}function Lx(A){return A=A|0,i[A>>2]=92052,A|0}function Px(A){return A=A|0,i[A>>2]=90932,A|0}function qx(A){return A=A|0,i[A>>2]=93492,A|0}function Kx(A){return A=A|0,i[A>>2]=92092,A|0}function ax(A){return A=A|0,i[A>>2]=90972,A|0}function $x(A){return A=A|0,i[A>>2]=93532,A|0}function dx(A){return A=A|0,i[A>>2]=94552,A|0}function cx(A){return A=A|0,i[A>>2]=61448,A|0}function bx(A){return A=A|0,i[A>>2]=92212,A|0}function iz(A){return A=A|0,i[A>>2]=91012,A|0}function ez(A){return A=A|0,i[A>>2]=91532,A|0}function rz(A){return A=A|0,i[A>>2]=94132,A|0}function fz(A){return A=A|0,i[A>>2]=95032,A|0}function Az(A){return A=A|0,i[A+320>>2]!=0|0}function kz(A){return A=A|0,i[i[A>>2]+24>>2]}function nz(A){return A=A|0,i[i[A>>2]+28>>2]}function Ys(A){return A=A|0,i[i[A>>2]+20>>2]}function Rs(A){return A=A|0,l[i[A>>2]+128|0]}function Js(A){return A=A|0,l[i[A>>2]+145|0]}function Ns(A){return A=A|0,i[i[A>>2]+16>>2]}function tz(A){return A=A|0,l[i[A>>2]+60|0]}function uz(A){return A=A|0,i[A+16>>2]!=0|0}function oz(A){return A=A|0,(ht(A,0)|0)!=0|0}function d8(A,e,r,f){return A=mn(A,e,r,f),A}function E(A){return A=wl(A),A||Z4(),A}function lz(A){return A=A|0,i[i[A>>2]+8>>2]}function sz(A){return A=A|0,i[i[A>>2]+4>>2]}function wz(A){return A=A|0,(l[A+4|0]?3:6)|0}function hz(A){A=A|0,X[i[i[A>>2]+4>>2]](A)}function _z(A){A=A|0,i[A>>2]=102744,Z(A)}function p3(A){return A=A|0,p0(A+12|0),A|0}function Bz(A){A=A|0,u[A+97|0]=l[A+112|0]}function vz(A){A=A|0,i[A>>2]=102668,Z(A)}function mz(A){A=A|0,i[A>>2]=100784,Z(A)}function Zz(A){A=A|0,i[A>>2]=102784,Z(A)}function Gz(A){A=A|0,i[A>>2]=100824,Z(A)}function Wz(A){A=A|0,i[A>>2]=102824,Z(A)}function Xz(A){A=A|0,i[A>>2]=102864,Z(A)}function gz(A){A=A|0,i[A>>2]=100864,Z(A)}function Qz(A){A=A|0,i[A>>2]=102940,Z(A)}function y3(A){return A=A|0,p0(A+8|0),A|0}function Iz(A){A=A|0,i[A>>2]=100904,Z(A)}function Cz(A){return A=A|0,Yo(i[A>>2])|0}function Y3(A){return A=A|0,p0(A+4|0),A|0}function Vz(A){A=A|0,i[A>>2]=103016,Z(A)}function Fz(A){A=A|0,i[A>>2]=100120,Z(A)}function Ez(A){A=A|0,i[A>>2]=100944,Z(A)}function pz(A){A=A|0,i[A>>2]=103056,Z(A)}function yz(A){A=A|0,i[A>>2]=100984,Z(A)}function Yz(A){A=A|0,i[A>>2]=103096,Z(A)}function Rz(A){A=A|0,i[A>>2]=101024,Z(A)}function Jz(A){return A=A|0,fo(i[A>>2])|0}function Nz(A){A=A|0,i[A>>2]=103172,Z(A)}function Mz(A){A=A|0,i[A>>2]=101064,Z(A)}function Uz(A){A=A|0,i[A>>2]=101952,Z(A)}function Dz(A){A=A|0,i[A>>2]=103248,Z(A)}function Hz(A){A=A|0,i[A>>2]=101104,Z(A)}function xz(A){A=A|0,i[A>>2]=103324,Z(A)}function zz(A){A=A|0,i[A>>2]=102040,Z(A)}function Tz(A){A=A|0,i[A>>2]=103400,Z(A)}function Sz(A){A=A|0,i[A>>2]=101184,Z(A)}function jz(A){A=A|0,i[A>>2]=102116,Z(A)}function Oz(A){A=A|0,i[A>>2]=103476,Z(A)}function Lz(A){A=A|0,i[A>>2]=102192,Z(A)}function Pz(A){A=A|0,i[A>>2]=103552,Z(A)}function qz(A){A=A|0,i[A>>2]=102232,Z(A)}function Kz(A){A=A|0,i[A>>2]=103628,Z(A)}function az(A){A=A|0,i[A>>2]=102272,Z(A)}function $z(A){A=A|0,i[A>>2]=103704,Z(A)}function dz(A,e){A=A|0,e=e|0,ik(A,e+12|0)}function cz(A,e){A=A|0,e=e|0,ik(A,e+16|0)}function bz(A){A=A|0,i[A>>2]=102312,Z(A)}function iT(A){A=A|0,i[A>>2]=106476,Z(A)}function eT(A){A=A|0,i[A>>2]=102352,Z(A)}function rT(A,e){A=A|0,e=e|0,i[A+16>>2]=e}function fT(A){A=A|0,i[A>>2]=102392,Z(A)}function AT(A){return A=A|0,Wo(i[A>>2])|0}function kT(A){A=A|0,i[A>>2]=102432,Z(A)}function nT(A){A=A|0,i[A>>2]=106548,Z(A)}function tT(A){A=A|0,i[A>>2]=102472,Z(A)}function uT(A){A=A|0,i[A>>2]=102512,Z(A)}function oT(A){A=A|0,i[A>>2]=102552,Z(A)}function lT(A,e){A=A|0,e=e|0,i[A+12>>2]=e}function sT(A){A=A|0,i[A>>2]=102592,Z(A)}function wT(A){A=A|0,i[A>>2]=106680,Z(A)}function hT(A){A=A|0,i[A>>2]=101144,Z(A)}function _T(A){A=A|0,i[A>>2]=91012,Z(A)}function BT(A){A=A|0,i[A>>2]=92212,Z(A)}function vT(A){A=A|0,i[A>>2]=93572,Z(A)}function mT(A){A=A|0,i[A>>2]=97968,Z(A)}function ZT(A){A=A|0,i[A>>2]=61564,Z(A)}function GT(A){A=A|0,i[A>>2]=89732,Z(A)}function WT(A){A=A|0,i[A>>2]=91052,Z(A)}function XT(A){A=A|0,i[A>>2]=92252,Z(A)}function gT(A){A=A|0,i[A>>2]=93612,Z(A)}function QT(A){A=A|0,i[A>>2]=98912,Z(A)}function IT(A){A=A|0,i[A>>2]=89772,Z(A)}function CT(A){A=A|0,i[A>>2]=91092,Z(A)}function VT(A){A=A|0,i[A>>2]=92292,Z(A)}function FT(A){A=A|0,i[A>>2]=93652,Z(A)}function ET(A){A=A|0,i[A>>2]=61676,Z(A)}function pT(A){A=A|0,i[A>>2]=89812,Z(A)}function yT(A){A=A|0,i[A>>2]=91132,Z(A)}function YT(A){A=A|0,i[A>>2]=92332,Z(A)}function RT(A){A=A|0,i[A>>2]=93692,Z(A)}function JT(A){A=A|0,i[A>>2]=89852,Z(A)}function NT(A){A=A|0,i[A>>2]=91172,Z(A)}function MT(A){A=A|0,i[A>>2]=92372,Z(A)}function UT(A){A=A|0,i[A>>2]=93732,Z(A)}function DT(A){A=A|0,i[A>>2]=95536,Z(A)}function HT(A){A=A|0,i[A>>2]=97128,Z(A)}function xT(A){A=A|0,Vk(107804,i[26952])}function zT(A){A=A|0,i[A>>2]=89892,Z(A)}function TT(A){A=A|0,i[A>>2]=91212,Z(A)}function ST(A){A=A|0,i[A>>2]=94772,Z(A)}function jT(A){A=A|0,i[A>>2]=97168,Z(A)}function OT(A){A=A|0,i[A>>2]=93852,Z(A)}function LT(A){A=A|0,i[A>>2]=89932,Z(A)}function PT(A){A=A|0,i[A>>2]=91252,Z(A)}function qT(A){A=A|0,i[A>>2]=92492,Z(A)}function KT(A){A=A|0,i[A>>2]=93892,Z(A)}function aT(A){A=A|0,i[A>>2]=94820,Z(A)}function $T(A){A=A|0,i[A>>2]=97208,Z(A)}function dT(A){A=A|0,i[A>>2]=89972,Z(A)}function cT(A){A=A|0,i[A>>2]=91292,Z(A)}function bT(A){A=A|0,i[A>>2]=92532,Z(A)}function iS(A){A=A|0,i[A>>2]=93932,Z(A)}function eS(A){A=A|0,i[A>>2]=97248,Z(A)}function rS(A){A=A|0,i[A>>2]=90012,Z(A)}function fS(A){A=A|0,i[A>>2]=91332,Z(A)}function AS(A){A=A|0,i[A>>2]=92572,Z(A)}function kS(A){A=A|0,i[A>>2]=94860,Z(A)}function nS(A){A=A|0,i[A>>2]=93972,Z(A)}function tS(A){A=A|0,i[A>>2]=97288,Z(A)}function uS(A){A=A|0,i[A>>2]=90052,Z(A)}function oS(A){A=A|0,i[A>>2]=91372,Z(A)}function lS(A){A=A|0,i[A>>2]=92612,Z(A)}function sS(A){A=A|0,i[A>>2]=94012,Z(A)}function wS(A){A=A|0,i[A>>2]=94900,Z(A)}function hS(A){A=A|0,i[A>>2]=97328,Z(A)}function _S(A){A=A|0,i[A>>2]=90092,Z(A)}function BS(A){A=A|0,i[A>>2]=91412,Z(A)}function vS(A){A=A|0,i[A>>2]=94940,Z(A)}function mS(A){A=A|0,i[A>>2]=90132,Z(A)}function ZS(A){A=A|0,i[A>>2]=92732,Z(A)}function GS(A){A=A|0,i[A>>2]=94052,Z(A)}function WS(A){A=A|0,i[A>>2]=91452,Z(A)}function XS(A){A=A|0,i[A>>2]=94992,Z(A)}function gS(A){A=A|0,i[A>>2]=90172,Z(A)}function QS(A){A=A|0,i[A>>2]=92772,Z(A)}function IS(A){A=A|0,i[A>>2]=94092,Z(A)}function CS(A){A=A|0,i[A>>2]=102e3,Z(A)}function VS(A){A=A|0,i[A>>2]=91492,Z(A)}function FS(A){A=A|0,i[A>>2]=91532,Z(A)}function ES(A){A=A|0,i[A>>2]=94132,Z(A)}function pS(A){A=A|0,i[A>>2]=95032,Z(A)}function yS(A){A=A|0,i[A>>2]=92892,Z(A)}function YS(A){A=A|0,i[A>>2]=97512,Z(A)}function RS(A){A=A|0,i[A>>2]=90252,Z(A)}function JS(A){A=A|0,i[A>>2]=91572,Z(A)}function NS(A){A=A|0,i[A>>2]=94172,Z(A)}function MS(A){A=A|0,i[A>>2]=95072,Z(A)}function US(A){A=A|0,i[A>>2]=92932,Z(A)}function DS(A){A=A|0,i[A>>2]=90292,Z(A)}function HS(A){A=A|0,i[A>>2]=91612,Z(A)}function xS(A){A=A|0,i[A>>2]=94212,Z(A)}function zS(A){A=A|0,i[A>>2]=98512,Z(A)}function TS(A){A=A|0,i[A>>2]=90332,Z(A)}function SS(A){A=A|0,i[A>>2]=91652,Z(A)}function jS(A){A=A|0,i[A>>2]=96912,Z(A)}function OS(A){A=A|0,i[A>>2]=93052,Z(A)}function LS(A){A=A|0,i[A>>2]=94252,Z(A)}function PS(A){A=A|0,i[A>>2]=90372,Z(A)}function qS(A){A=A|0,i[A>>2]=91692,Z(A)}function KS(A){A=A|0,i[A>>2]=93092,Z(A)}function aS(A){A=A|0,i[A>>2]=94292,Z(A)}function $S(A){A=A|0,i[A>>2]=96952,Z(A)}function dS(A){A=A|0,i[A>>2]=97632,Z(A)}function cS(A){A=A|0,i[A>>2]=90412,Z(A)}function bS(A){A=A|0,i[A>>2]=91732,Z(A)}function ij(A,e){A=A|0,e=e|0,oe(A,11885)}function ej(A){A=A|0,i[A>>2]=90452,Z(A)}function rj(A){A=A|0,i[A>>2]=91852,Z(A)}function fj(A){A=A|0,i[A>>2]=93212,Z(A)}function Aj(A){A=A|0,i[A>>2]=96028,Z(A)}function kj(A,e){A=A|0,e=e|0,ti(A,79264)}function nj(A){A=A|0,i[A>>2]=90572,Z(A)}function tj(A){A=A|0,i[A>>2]=91892,Z(A)}function uj(A){A=A|0,i[A>>2]=93252,Z(A)}function oj(A){A=A|0,i[A>>2]=96068,Z(A)}function lj(A,e){A=A|0,e=e|0,oe(A,12200)}function sj(A,e){A=A|0,e=e|0,ti(A,79284)}function wj(A){A=A|0,i[A>>2]=90612,Z(A)}function hj(A){A=A|0,i[A>>2]=96108,Z(A)}function _j(A){A=A|0,i[A>>2]=91932,Z(A)}function Bj(A){A=A|0,i[A>>2]=95336,Z(A)}function vj(A){A=A|0,i[A>>2]=90732,Z(A)}function mj(A){A=A|0,i[A>>2]=93372,Z(A)}function Zj(A){A=A|0,I3(107752,i[26939])}function Gj(A){A=A|0,i[A>>2]=96148,Z(A)}function Wj(A){A=A|0,i[A>>2]=99688,Z(A)}function Xj(A){A=A|0,i[A>>2]=91972,Z(A)}function gj(A){A=A|0,m3(107764,i[26942])}function Qj(A){A=A|0,i[A>>2]=90772,Z(A)}function Ij(A){A=A|0,i[A>>2]=93412,Z(A)}function Cj(A){A=A|0,i[A>>2]=94472,Z(A)}function Vj(A){A=A|0,i[A>>2]=96188,Z(A)}function Fj(A){A=A|0,Y1(107840,i[26961])}function Ej(A){A=A|0,i[A>>2]=92012,Z(A)}function pj(A){A=A|0,Y1(107852,i[26964])}function yj(A){A=A|0,i[A>>2]=90892,Z(A)}function Yj(A){A=A|0,i[A>>2]=93452,Z(A)}function Rj(A){A=A|0,i[A>>2]=96228,Z(A)}function Jj(A){A=A|0,Y1(107864,i[26967])}function Nj(A){A=A|0,i[A>>2]=92052,Z(A)}function Mj(A){A=A|0,i[A>>2]=94512,Z(A)}function Uj(A){A=A|0,i[A>>2]=90932,Z(A)}function Dj(A){A=A|0,i[A>>2]=93492,Z(A)}function Hj(A){A=A|0,i[A>>2]=92092,Z(A)}function xj(A){A=A|0,i[A>>2]=90972,Z(A)}function zj(A){A=A|0,i[A>>2]=93532,Z(A)}function Tj(A){A=A|0,i[A>>2]=94552,Z(A)}function Sj(A){A=A|0,i[A>>2]=61448,Z(A)}function jj(A){A=A|0,i[A>>2]=90212,Z(A)}function Ms(A,e){A=A|0,e=e|0,ru(A,1,45)}function Oj(A,e){A=A|0,e=e|0,u[A+4|0]=e}function Us(A,e){A=A|0,e=e|0,Yt(A,1,45)}function Lj(A){return A=A|0,i[A+448>>2]}function Ds(A){return A=A|0,X[A|0]()|0}function Pj(A){return A=A|0,i[A+124>>2]}function yk(A,e){A=A|0,e=e|0,X[A|0](e)}function qj(A){return A=A|0,p3(A-8|0)|0}function Hs(A,e){return A=A|0,e=e|0,e|0}function Kj(A){return A=A|0,i[A+288>>2]}function aj(A){return A=A|0,H6(A-8|0)|0}function xs(A){return A=A|0,1785750887}function $j(A){return A=A|0,1781689137}function dj(A){return A=A|0,1768187246}function cj(A){return A=A|0,1852009592}function zs(A,e){return(Zi(A,e)|0)!=-1}function bj(A){return A=A|0,i[A+16>>2]}function iO(A){return A=A|0,1635148593}function eO(A){return A=A|0,1635148649}function rO(A){return A=A|0,1953066089}function R3(A){return A=A|0,2147483647}function fO(A){return A=A|0,1752589105}function AO(A,e){A=A|0,e=e|0,i[A>>2]=e}function kO(A){return A=A|0,1987471715}function nO(A){return A=A|0,1735551332}function tO(A){return A=A|0,i[A+20>>2]}function uO(A){return A=A|0,1836280681}function oO(A){return A=A|0,1987470129}function Ts(A){return A=A|0,i[A+12>>2]}function lO(A){return A=A|0,1768912492}function sO(A){return A=A|0,1635135537}function wO(A){return A=A|0,1781689193}function hO(A){return A=A|0,1635150182}function _O(A,e){return A=A|0,e=e|0,0}function Ss(A){return A=A|0,l[A+48|0]}function js(){Z(i[31264]),i[31264]=0}function Yk(A){return A=A|0,i[A+4>>2]}function J3(A,e){return A=A|0,e=e|0,-1}function BO(A){return A=A|0,In(A,0)|0}function vO(A){return A=A|0,In(A,1)|0}function P2(A,e){return Oo(A)^Oo(e)^1}function mO(A){return A=A|0,Wn(A,0)|0}function q2(A,e){return jo(A)^jo(e)^1}function ZO(A){return A=A|0,Wn(A,1)|0}function Os(A){return A=A|0,i[A+8>>2]}function Ue(A){return p2(A+80|0)+80|0}function GO(A){return A=A|0,l[A+96|0]}function WO(A){return A=A|0,A>>>0<2|0}function Ls(A,e,r){A=A|0,e=e|0,r=r|0}function N3(A){return A=A|0,l[A+4|0]}function XO(A){return A=A|0,u[A+8|0]}function gO(A){return A=A|0,u[A+9|0]}function m4(A,e){H1(A,i[A+16>>2]|e)}function Ps(A){return A=A|0,p0(A)|0}function K1(A){return Vl(i[A>>2]),A}function a1(A){return Il(i[A>>2]),A}function QO(A){return A=A|0,108032}function IO(A){return A=A|0,13134}function CO(A){return A=A|0,12808}function VO(A){return A=A|0,19602}function FO(A){return A=A|0,11144}function EO(A){return A=A|0,12288}function pO(A){return A=A|0,96332}function yO(A){return A=A|0,96400}function YO(A){return A=A|0,96464}function RO(A){return A=A|0,15474}function JO(A){return A=A|0,13904}function NO(A){return A=A|0,12828}function MO(A){return A=A|0,18953}function UO(A){return A=A|0,12184}function DO(A){return A=A|0,15536}function HO(A){return A=A|0,18416}function z2(A){A=A|0,A&&Z(A)}function xO(A){return A=A|0,15505}function zO(A){return A=A|0,18990}function TO(A){return A=A|0,19452}function SO(A){return A=A|0,15489}function M3(A){return A=A|0,19037}function jO(A){return A=A|0,13110}function OO(A){return A=A|0,17955}function LO(A){return A=A|0,12971}function PO(A){return A=A|0,10790}function qO(A){return A=A|0,15456}function KO(A){return A=A|0,13891}function aO(A){return A=A|0,13083}function $O(A){return A=A|0,10190}function dO(A){return A=A|0,19845}function cO(A){return A=A|0,11833}function bO(A){return A=A|0,14111}function iL(A){return A=A|0,10206}function eL(A){return A=A|0,21802}function rL(A){A=A|0,u[A+97|0]=0}function fL(A){return A=A|0,8519}function AL(A){return A=A|0,1499}function kL(A){return A=A|0,8323}function nL(A){return A=A|0,4485}function tL(A){return A=A|0,5481}function uL(A){return A=A|0,7053}function oL(A){return A=A|0,4504}function lL(A){return A=A|0,1515}function sL(A){return A=A|0,8493}function wL(A){return A=A|0,7077}function hL(A){return A=A|0,5757}function _L(A){return A=A|0,8280}function BL(A){return A=A|0,7782}function vL(A){A=A|0,y0(A),Z(A)}function mL(A){return A=A|0,8096}function qs(A,e,r){Mr(A,e,r,0,0)}function ZL(A){return A=A|0,6290}function GL(A){return A=A|0,3623}function WL(A){return A=A|0,6883}function XL(A){A=A|0,u[A+97|0]=1}function gL(A){return A=A|0,5182}function QL(A){return A=A|0,4748}function IL(A){return A=A|0,4693}function CL(A){return A=A|0,8412}function VL(A){return A=A|0,7447}function Ks(A){A=A|0,p0(A),Z(A)}function FL(A){return A=A|0,7434}function EL(A){A=A|0,Fk(A),Z(A)}function pL(A){return A=A|0,5422}function yL(A){return A=A|0,7484}function YL(A){return A=A|0,7460}function RL(A){return A=A|0,7479}function JL(A){return A=A|0,9663}function NL(A){return A=A|0,8340}function ML(A){return A=A|0,8121}function UL(A){return A=A|0,7954}function DL(A){return A=A|0,8429}function HL(A){return A=A|0,3613}function xL(A){return A=A|0,8227}function Rk(A){A=A|0,Cl(A),Z(A)}function zL(A){return A=A|0,8140}function TL(A){return A=A|0,8358}function SL(A){A=A|0,se(A),Z(A)}function jL(A){return A=A|0,3766}function OL(A){return A=A|0,2917}function LL(A){return A=A|0,2893}function PL(A){return A=A|0,8079}function qL(A){return A=A|0,9650}function KL(A){return A=A|0,8390}function aL(A){return A=A|0,7892}function $L(A){return A=A|0,4189}function dL(A){return A=A|0,7762}function cL(A){A=A|0,s2(107688)}function bL(A){A=A|0,R1(129928)}function iP(A){A=A|0,s2(107700)}function eP(A){A=A|0,R1(129944)}function rP(A){A=A|0,s2(129960)}function fP(A){A=A|0,R1(129976)}function AP(A){A=A|0,s2(129992)}function N4(A){return A=A|0,A|0}function Jk(A,e){return l0=A,e}function kP(A){A=A|0,R1(130008)}function U3(A){return A=A|0,127}function nP(A){A=A|0,Z(zt(A))}function Nk(A){A=A|0,Z(y3(A))}function tP(A){A=A|0,Z($t(A))}function Mk(A){A=A|0,Z(Y3(A))}function as(A){A=A|0,Z(y0(A))}function Uk(A){A=A|0,Z(p3(A))}function uP(A){A=A|0,Z(Ht(A))}function $s(A){A=A|0,Z(Fk(A))}function Dk(A){A=A|0,Z(T1(A))}function Hk(A){A=A|0,Z(H6(A))}function oP(A){A=A|0,Z(p0(A))}function xk(A){return A=A|0,5}function lP(A){A=A|0,Z(Ll(A))}function sP(A){A=A|0,Z(gt(A))}function wP(A){A=A|0,Z(is(A))}function hP(A){A=A|0,Z(Bs(A))}function _P(A){A=A|0,Z(vs(A))}function BP(A){A=A|0,Z(cn(A))}function ds(A){A=A|0,Z(Xk(A))}function De(A,e){u2(A,e&65535)}function cs(A){A=A|0,Z(sk(A))}function bs(A){A=A|0,Z(uk(A))}function vP(A){A=A|0,Z(ai(A))}function mP(A){A=A|0,Z(i9(A))}function ZP(A){A=A|0,Z(Ik(A))}function iw(A){A=A|0,Z(ok(A))}function GP(A){A=A|0,Hk(A-8|0)}function WP(A){A=A|0,Z(Tu(A))}function O2(A){A=A|0,Z(A2(A))}function XP(A){A=A|0,Uk(A-8|0)}function p1(A){return A=A|0,1}function ew(A){return A=A|0,3}function rw(A){return A=A|0,7}function fw(){return 18153984}function M4(A){return A=A|0,2}function c2(A){return A=A|0,0}function D3(A){return A=A|0,-1}function gP(A){return A=A|0,9}function T6(A){return A=A|0,4}function Aw(A){Ol(A,i[A>>2])}function w8(A,e){A=A|0,e=e|0}function g0(){gk(11043),H()}function G0(){gk(6307),H()}function w0(A){A=A|0,Z(A)}function QP(){return 95568}function IP(){return 21617}function CP(){return 95656}function VP(){return 10185}function FP(){return 21118}function H3(A){A=A|0,H()}function EP(){return 21}function Q1(){E_(),H()}function Z4(){Q1(),H()}function pP(){return 1}function yP(){return 2}function B6(A){A=A|0}function YP(){co()}function RP(){Wl()}function JP(){}c=l,K0(h1);var X=i0([null,Cl,gy,Ny,gR,gl,eC,zp,Hy,C3,C3,WY,CY,rU,gl,iF,Up,cJ,C3,C3,KN,bN,eM,eR,HJ,UJ,GB,mY,ZY,H3,Z4,kM,N4,XJ,TJ,c2,Wr,c2,$t,tP,fL,DB,p1,fG,II,Ls,lX,c2,GO,c2,iB,XY,BI,A2,O2,LO,Tm,AQ,B6,M4,$g,JY,Rt,O2,jL,yZ,$I,M4,gC,O2,Y2,eQ,cW,SR,sJ,Xm,XQ,WZ,uN,TN,VZ,FW,Pj,yp,TR,oJ,NO,Zm,_Q,rv,O2,DO,Y2,aC,yQ,O2,HO,A6,rL,Lp,vN,SN,qO,hZ,fI,Bg,O2,qL,lW,TI,VU,QI,jp,Pp,AL,zv,yX,mR,vZ,O2,kL,A6,Jg,vM,HV,O2,tL,A6,Ci,O2,uL,mW,Ci,O2,oL,hG,uC,oY,c2,FI,KE,ep,sL,VB,ZX,WF,Uv,uY,BY,hL,$m,YQ,p1,qW,O2,_L,kW,XC,p1,p1,p1,_V,O2,FO,IG,YC,p1,p1,p1,WV,O2,EO,RZ,GQ,p1,p1,p1,Rm,MF,zF,RO,bv,vX,hF,pB,jR,lJ,MO,LZ,DC,gg,O2,GL,A6,Ci,OR,ql,nn,oQ,Ef,ql,WL,YZ,gm,Fy,Dy,dL,qm,TX,p1,fW,O2,CL,A6,Ci,O2,xO,A6,xm,qG,oN,zN,TO,aG,qI,Vg,KR,_J,NL,$Z,uQ,M4,ZW,O2,UL,sG,lC,M4,$C,O2,xL,nW,yC,M4,gV,O2,TL,wG,sC,M4,bC,O2,OL,Hm,EX,M4,jX,O2,LL,um,ZG,M4,Jv,Sp,qp,PL,zm,SI,M4,fX,O2,KL,Mv,WI,NE,iI,O2,aL,tZ,zI,PE,cQ,_N,jN,dO,$G,JC,p1,c2,c2,OX,BN,ON,bO,cG,RC,M4,IQ,YD,GT,z0,_O,w0,DD,IT,z0,w0,OD,pT,z0,w0,KD,JT,z0,w0,eH,zT,z0,w0,nH,LT,z0,w0,hH,dT,z0,w0,WH,rS,z0,w0,VH,uS,z0,w0,RH,_S,z0,w0,UH,mS,z0,w0,zH,gS,z0,w0,LH,jj,z0,w0,$H,RS,z0,w0,ex,DS,z0,w0,nx,TS,z0,w0,sx,PS,z0,w0,mx,cS,z0,w0,Wx,ej,z0,w0,fN,z6,mv,sm,Hv,Ix,nj,z0,w0,Ex,wj,z0,w0,z6,Jx,vj,z0,w0,Dx,Qj,z0,w0,z6,Sx,yj,z0,w0,Px,Uj,z0,w0,ax,xj,z0,w0,iz,_T,z0,w0,RD,WT,z0,w0,HD,CT,z0,w0,LD,yT,z0,w0,aD,NT,z0,w0,rH,TT,z0,w0,tH,PT,z0,w0,_H,cT,z0,w0,XH,fS,z0,w0,FH,oS,z0,w0,JH,BS,z0,w0,DH,WS,z0,w0,OH,VS,z0,w0,ez,FS,z0,w0,dH,JS,z0,w0,rx,HS,z0,w0,tx,SS,z0,w0,wx,qS,z0,w0,Zx,bS,z0,w0,z6,Xx,rj,z0,w0,Cx,tj,z0,w0,px,_j,z0,w0,Ux,Xj,z0,w0,Tx,Ej,z0,w0,Lx,Nj,z0,w0,Kx,Hj,z0,w0,z6,bx,BT,z0,w0,JD,XT,z0,w0,xD,VT,z0,w0,PD,YT,z0,w0,$D,MT,z0,w0,z6,uH,qT,z0,w0,BH,bT,z0,w0,gH,AS,z0,w0,EH,lS,z0,w0,O2,JO,A6,Ci,NH,ZS,z0,w0,TH,QS,z0,w0,O2,iL,PH,yS,z0,w0,ix,US,z0,w0,O2,zO,ux,OS,z0,w0,hx,KS,z0,w0,O2,DL,gx,fj,z0,w0,Vx,uj,z0,w0,O2,KO,Yx,mj,z0,w0,Hx,Ij,z0,w0,jx,Yj,z0,w0,qx,Dj,z0,w0,$x,zj,z0,w0,FD,vT,z0,w0,ND,gT,z0,w0,zD,FT,z0,w0,qD,RT,z0,w0,dD,UT,z0,w0,O2,wL,kH,OT,z0,w0,sH,KT,z0,w0,mH,iS,z0,w0,IH,nS,z0,w0,yH,sS,z0,w0,HH,GS,z0,w0,SH,IS,z0,w0,rz,ES,z0,w0,cH,NS,z0,w0,fx,xS,z0,w0,lx,LS,z0,w0,_x,aS,z0,w0,tU,uU,QM,F1,v4,F1,fC,mQ,v4,F1,v4,F1,v4,F1,xx,Cj,Jm,w0,XD,Mj,kE,w0,dx,Tj,z0,w0,kN,DN,LI,UI,Oj,FX,gX,fg,EE,HC,Lj,M3,c2,mp,c2,fs,D3,D3,aN,xG,B6,c2,c2,zo,B6,_o,_o,XF,GG,AU,AE,fH,ST,ty,w0,wH,aT,eU,w0,QH,kS,y2,w0,pH,wS,z0,w0,MH,vS,z0,w0,w8,F1,xH,XS,SX,w0,fz,pS,z0,w0,bH,MS,z0,w0,MJ,$J,lY,sU,Vp,N4,PA,Zp,pp,Wp,IM,EM,Fp,cn,BP,v4,F1,Rx,Bj,y2,w0,Zj,gj,gJ,jJ,Yk,DW,Cp,N4,w0,cj,EZ,vE,bp,uy,_Z,jg,_B,cD,DT,y2,w0,B6,xT,N4,w0,c2,Ym,NJ,bY,w0,p1,km,nl,py,w0,M4,nm,nl,yy,w0,T6,Ov,c2,Yy,QR,iJ,wz,fB,RE,JE,WR,dR,xk,wB,$p,Qx,Aj,y2,w0,Fx,oj,y2,w0,yx,hj,y2,w0,Nx,Gj,y2,w0,zx,Vj,y2,w0,Ox,Rj,y2,w0,v4,F1,vp,DE,hC,NY,$V,nJ,cR,kC,Dl,BV,XV,pY,em,Ds,fw,Ds,W9,yk,z4,F3,UA,yk,M6,F3,Rl,Jl,Rs,yk,z4,a9,Js,EC,Dl,HF,AF,kF,nF,tF,F3,aA,DM,Eu,pO,z4,yO,M6,YO,z4,$N,z2,Xs,ms,Xs,ms,ZE,pM,op,zV,f9,Fj,pj,Jj,v4,F1,v4,F1,v4,F1,v4,F1,v4,F1,w8,F1,PM,F1,w8,F1,v4,F1,v4,F1,v4,F1,Fg,ox,jS,Pm,w0,Bx,$S,y2,w0,v4,F1,b4,H3,Gv,aB,Gp,XZ,w8,F1,bR,Mp,bD,HT,z0,w0,AH,jT,z0,w0,lH,$T,z0,w0,GH,eS,z0,w0,CH,tS,z0,w0,YH,hS,z0,w0,lE,gE,fO,eL,zo,p1,Gk,aQ,$Q,rG,IW,ii,L_,gv,Qi,Ii,KH,YS,y2,w0,KC,dC,JL,eB,ev,p1,_v,vx,dS,z0,w0,N4,w0,v4,F1,ky,By,p1,RU,JU,OE,Gm,YI,xI,c2,hv,N3,Mm,kY,lu,eG,_E,FE,sO,M3,T6,Gk,hO,VW,ii,Qi,Ii,ED,mT,y2,w0,GV,FV,Wv,N3,rW,fY,tC,iG,ry,wy,T6,cN,Ek,nV,fE,LR,ZJ,Qv,KQ,p1,Vm,O2,sW,uF,CV,O2,KG,EQ,eI,wE,QE,xs,ew,Gk,xs,GW,ii,Qi,Ii,Ax,zS,y2,w0,aR,BJ,AW,lF,Cv,Ay,_y,ew,Sy,Ek,vI,UV,VV,yV,WJ,Bm,Ss,fZ,Z3,Bu,hW,VF,F1,BE,WE,$j,rw,qC,wO,BZ,ii,Qi,Ii,MD,QT,y2,w0,ey,sy,rw,LQ,jQ,wp,fs,IV,Hu,mB,Ss,rZ,Z3,Bu,OZ,Hu,HZ,PR,wJ,BG,AI,Rv,qR,hJ,mG,PI,SW,dF,iE,dZ,wW,xB,$R,vJ,vG,kI,vm,O2,A6,p1,Ci,hE,VE,oO,M3,xk,LG,kO,CW,ii,Qi,Ii,Mx,Wj,y2,w0,ny,my,xk,iM,Ek,LE,cg,yI,HI,lv,N3,Fm,rY,lu,KZ,Ht,uP,FB,Av,p1,uB,oE,XE,iO,M3,M4,eO,gW,ii,Qi,Ii,LU,Fz,y2,w0,gt,sP,P_,$_,p1,om,iy,ly,M4,pU,yU,HE,qB,pI,DI,ov,N3,pm,AY,nI,qZ,O2,uW,fF,p1,NC,T1,Dk,uO,p1,gP,hV,c2,sB,EB,Dk,c2,v4,F1,uE,F1,UU,mz,z0,w0,HU,Gz,z0,w0,TU,gz,z0,w0,jU,Iz,z0,w0,PU,Ez,z0,w0,KU,yz,z0,w0,$U,Rz,z0,w0,cU,Mz,z0,w0,eD,Hz,z0,w0,fD,hT,z0,w0,AD,Sz,z0,w0,RY,cY,nO,zu,Ou,vV,SF,$B,S_,PX,iW,uG,N4,w0,hp,mM,w0,Ky,eY,lO,cV,Ou,_p,jF,d_,O_,oG,Dk,dj,zu,DV,Og,c2,a_,nG,pF,UF,rO,SD,RW,JW,LN,dm,pv,c2,j_,Sv,eF,tG,cp,F1,mE,bU,Uz,y2,w0,jH,CS,y2,w0,CD,zz,y2,w0,N4,w0,Pg,AB,kD,jz,y2,w0,w0,Lg,oB,tD,Lz,y2,w0,oD,qz,y2,w0,sD,az,y2,w0,hD,bz,y2,w0,BD,eT,y2,w0,vD,fT,y2,w0,mD,kT,y2,w0,GD,tT,y2,w0,WD,uT,y2,w0,gD,oT,y2,w0,ID,sT,y2,w0,w0,_W,rB,NU,vz,y2,w0,w0,_I,b_,MU,_z,y2,w0,DU,Zz,y2,w0,xU,Wz,y2,w0,zU,Xz,y2,w0,w0,RI,KB,SU,Qz,y2,w0,w0,JI,OB,OU,Vz,y2,w0,qU,pz,y2,w0,aU,Yz,y2,w0,w0,zC,tB,dU,Nz,y2,w0,w0,TC,kB,iD,Dz,y2,w0,w0,SC,IB,rD,xz,y2,w0,w0,xC,WB,VD,Tz,y2,w0,w0,og,gB,nD,Oz,y2,w0,w0,lg,ZB,uD,Pz,y2,w0,w0,sg,YB,lD,Kz,y2,w0,w0,wg,CB,wD,$z,y2,w0,w0,cX,hB,w0,Zg,q_,w0,RV,SB,w0,kJ,UE,w0,cI,Vv,w0,mC,uv,w0,dX,HB,w0,rQ,tv,w0,xX,cB,w0,KX,Bv,w0,dV,LB,w0,BF,PB,w0,bW,rm,w0,CF,XB,w0,$X,Fv,w0,BC,_m,w0,vC,vv,w0,bI,bZ,O2,VL,Zv,JX,Wk,Am,O2,FL,TB,YX,Wk,Om,O2,yL,Sm,dg,Wk,jW,O2,YL,SZ,lV,RQ,O2,RL,PW,EF,UC,FF,JF,ML,JZ,HQ,ym,LY,lR,jO,AG,gI,wv,PY,sR,aO,kG,_g,XL,nv,KY,wR,$O,Km,uI,qv,aY,hR,$L,PZ,ZI,gp,tW,$Y,_R,cO,sZ,oI,Iv,TY,kR,IO,WG,Cg,oW,O2,nL,CZ,YV,mI,bJ,CN,CO,dG,qu,QQ,z6,O2,lL,jZ,kV,hg,eN,YN,VO,bG,qu,gQ,SY,nR,BL,Wm,FQ,Bz,QG,GJ,zJ,jG,Z3,$n,IF,YF,mL,wm,Z3,AR,Pv,O2,UO,mZ,pV,aF,jY,tR,gL,hm,Ng,OG,OY,BR,IL,Cm,Sg,qV,UW,DR,tJ,pL,Qm,ig,qE,bE,SO,im,Mg,nB,HR,uJ,HL,tm,ag,DF,Kv,_D,iT,y2,w0,TF,PF,MY,UY,ZD,nT,y2,w0,ai,vP,hf,vR,c2,R9,w8,F1,QD,wT,y2,w0,zt,nP,zB,lm,Az,Ry,w8,F1,iN,pN,yv,VX,YP,RP,vH,up,rM,iV,cM,Vs,HM,EU,jE,rV,MR,Mf,VP,GR,JP,VY,z2,mk,fR,mk,uR,mk,oR,QO,ye,ye,ye,ye,ye,xY,w8,ZR,zY,Ls,B6,N4,w0,PG,vF,N4,H3,i9,mP,GY,QN,cx,Sj,oF,w0,yD,ZT,GN,w0,TD,ET,TV,w0,OV,oM,RR,YR,yR,QX,pR,ER,FR,XX,VR,CR,IR,IX,rX,iX,eX,qQ,iv,xQ,JJ,RJ,YJ,DX,EJ,FJ,VJ,MX,CJ,IJ,QJ,UX,tX,kX,nX,Rg,fv,sI,ug,Kg,MI,TQ,vg,iQ,pC,CI,lQ,jV,dQ,AV,MB,WU,XU,lU,wU,dN,Xv,SM,jM,NM,MM,OQ,PQ,ZQ,dI,CC,aI,GU,oU,UB,LW,BU,hU,IU,QU,Dv,JM,RM,LM,TM,xv,aZ,qY,w0,av,ZF,GF,OF,w0,pg,PV,w0,aW,mF,zn,ZN,HX,VN,c2,UM,yB,by,SV,XI,qA,y0,vL,w8,Is,Nl,Pl,c2,c2,MQ,D3,IY,J3,rC,J3,y3,Nk,Zs,ps,Y3,Mk,Gs,ys,p3,Uk,qj,XP,bM,aH,Fk,EL,w8,Is,Nl,Pl,c2,c2,sQ,D3,QY,J3,VI,J3,y3,Nk,Zs,ps,Y3,Mk,Gs,ys,Ik,ZP,hX,AJ,cF,fV,qX,se,SL,Eg,_X,uX,NI,HG,GZ,rE,_G,Ps,Ks,Ps,Ks,H6,Hk,aj,GP,iU,pD,sk,cs,KM,UD,uk,bs,aM,jD,ok,iw,$M,iH,p0,oP,BM,as,Yp,BO,vO,mg,as,qy,Lu,np,Yg,$s,Rp,mO,ZO,Wg,$s,$y,Lu,Ap,Hg,Dp,Z,B6,dl,LJ,PJ,qJ,KJ,aJ,SJ,cL,bL,iP,eP,rP,fP,AP,kP,Tu,WP,hz,Ll,lP,nN,Cy,tN,Vy,Hs,hY,xM,Jy,is,wP,DZ,iZ,NF,sp,c2,eV,gM,Bs,hP,XO,gO,dz,ij,lj,vs,_P,Os,Ts,cz,kj,sj,N4,w0,w0,NR,Op,Kp,ap,FN,Zy,EN,Gy,Hs,sY,tM,Iy,w0,Hl,Hl,Ne,p1,p1,xp,p1,w0,wn,on,Ne,c2,c2,yn,T6,w0,wn,on,Ne,c2,c2,yn,T6,w0,Fn,sn,Ne,c2,c2,pn,T6,w0,Fn,sn,Ne,c2,c2,pn,T6,N4,w0,tE,WN,hy,N4,w0,yE,XN,oy,w0,Qg,zG,yG,TG,vn,vn,YG,nZ,uZ,bm,gG,w0,Ig,UG,FG,RG,Bn,Bn,VG,oZ,lZ,eZ,CG,w0,CQ,oV,LC,sV,PC,EW,EG,EV,w0,WQ,tV,jC,uV,OC,pW,pG,ZV,N4,w0,M4,Hp,LF,xE,zE,aE,sv,LV,bQ,Qy,RN,HN,CM,VM,N4,w0,M4,QF,xF,TE,SE,$E,kv,xV,DQ,Xy,JN,NN,IN,yN,Xk,ds,VQ,Xk,ds,GX,w0,U3,U3,n8,n8,n8,Ms,c2,_6,_6,w0,U3,U3,n8,n8,n8,Ms,c2,_6,_6,w0,R3,R3,n8,n8,n8,Us,c2,_6,_6,w0,R3,R3,n8,n8,n8,Us,c2,_6,_6,w0,SG,pZ,w0,DG,jm,w0,cm,IZ,w0,am,QZ,w0,Es,AM,w8,w0,Es,xg,w8,H3,w0,ZL,w0,QL,N4,w0,B6,B6,_s,w0,_s,w0,IC,fJ,MV,xN,w0,Uy,hQ,vY,w0,fQ,eW,IE,w0,cZ,w0,OO,w0,PO,w0,zL,Rk,Yk,Rk,Rk]);function kw(){return X1.byteLength/65536|0}function NP(A){A=A|0;var e=kw()|0,r=e+A|0;if(e<r&&r<65536){var f=new ArrayBuffer(G(r,65536)),k=new Int8Array(f);k.set(u),u=new Int8Array(f),Q=new Int16Array(f),i=new Int32Array(f),l=new Uint8Array(f),F=new Uint16Array(f),u0=new Uint32Array(f),E0=new Float32Array(f),t0=new Float64Array(f),X1=f,c=l}return e}return{P:Object.create(Object.prototype,{grow:{value:NP},buffer:{get:function(){return X1}}}),Q:Ev,R:X,S:B3,T:z2,U:pe,V:gi,W:z2,X:sM,Y:XA,Z:gA,_:WA,$:Ty,aa:dW,ba:eJ,ca:xJ,da:wY,ea:nU,fa:yY,ga:fw,ha:W9,ia:z4,ja:UA,ka:M6,la:Rl,ma:Jl,na:Rs,oa:z4,pa:a9,qa:Js,ra:aA,sa:Eu,ta:IP,ua:$o,va:Nu,wa:Un,xa:Z,ya:af,za:Qn,Aa:Tf,Ba:kx,Ca:Fs,Da:pk,Ea:hi,Fa:ns,Ga:ts,Ha:gs,Ia:qt,Ja:Jo,Ka:p2,La:wu,Ma:hu,Na:_u,Oa:Qu,Pa:pP,Qa:EP,Ra:yP,Sa:ME,Ta:Dg,Ua:z2,Va:pE,Wa:FY,Xa:EY,Ya:bX,Za:RB,_a:_C,$a:Ju,ab:Ju,bb:hi,cb:oC,db:GE,eb:iC,fb:jr,gb:dJ,hb:rs,ib:rs,jb:Uf,kb:oo,lb:Ao,mb:MN,nb:OM,ob:$v,pb:il,qb:ko,rb:z2,sb:ho,tb:Fo,ub:BQ,vb:wI,wb:ho,xb:Fo,yb:vQ,zb:hI,Ab:KW,Bb:mo,Cb:uM,Db:mN,Eb:WC,Fb:us,Gb:us,Hb:tz,Ib:Ip,Jb:SQ,Kb:os,Lb:os,Mb:oX,Nb:wM,Ob:wF,Pb:JQ,Qb:hs,Rb:M6,Sb:MC,Tb:_M,Ub:zZ,Vb:KV,Wb:AC,Xb:lM,Yb:kQ,Zb:AX,_b:jI,$b:HW,ac:OI,bc:xW,cc:ro,dc:Tn,ec:Vn,fc:ro,gc:Tn,hc:Vn,ic:bg,jc:qF,kc:WW,lc:mm,mc:MZ,nc:pX,oc:sX,pc:wX,qc:NG,rc:MG,sc:BW,tc:zg,uc:kZ,vc:QW,wc:TW,xc:RX,yc:lB,zc:Yv,Ac:Py,Bc:JB,Cc:NB,Dc:QB,Ec:Lm,Fc:nQ,Gc:zX,Hc:Xg,Ic:yM,Jc:tI,Kc:YM,Lc:GC,Mc:z2,Nc:JG,Oc:OW,Pc:LX,Qc:ls,Rc:Ag,Sc:yW,Tc:XG,Uc:ls,Vc:QC,Wc:pQ,Xc:MW,Yc:Ug,Zc:fm,_c:qg,$c:kU,ad:Cz,bd:AT,cd:M6,dd:ZH,ed:Bp,fd:kz,gd:cC,hd:nz,id:Jz,jd:gF,kd:XM,ld:qM,md:zQ,nd:ZZ,od:jA,pd:nA,qd:z2,rd:qH,sd:sE,td:BB,ud:dB,vd:gY,wd:AN,xd:YU,yd:Ts,zd:QV,Ad:gU,Bd:Oy,Cd:gN,Dd:z2,Ed:AO,Fd:Vs,Gd:CE,Hd:Ak,Id:A3,Jd:rT,Kd:nY,Ld:Xp,Md:z2,Nd:mX,Od:CU,Pd:FC,Qd:Tg,Rd:dv,Sd:Ly,Td:Ey,Ud:lT,Vd:Nv,Wd:dy,Xd:kg,Yd:yF,Zd:Pu,_d:DY,$d:lI,ae:tY,be:uz,ce:bj,de:rN,ee:jy,fe:nM,ge:tp,he:lG,ie:wV,je:ng,ke:vW,le:Nm,me:gZ,ne:Um,oe:FZ,pe:nE,qe:nC,re:Ro,se:Np,te:Qp,ue:iY,ve:NW,we:QP,xe:g9,ye:z2,ze:xZ,Ae:TZ,Be:vy,Ce:NX,De:WO,Ee:rF,Fe:rI,Ge:ip,He:dE,Ie:rp,Je:tQ,Ke:cE,Le:cv,Me:eE,Ne:$F,Oe:EI,Pe:KF,Qe:fU,Re:cy,Se:YE,Te:CX,Ue:z2,Ve:tg,We:hM,Xe:YW,Ye:UZ,Ze:bB,_e:D6,$e:Sr,af:z2,bf:Wy,cf:bV,df:WX,ef:Dm,ff:$l,gf:NZ,hf:$l,jf:Lv,kf:dp,lf:CP,mf:zM,nf:$W,of:rR,pf:Jp,qf:JV,rf:Ws,sf:lz,tf:sz,uf:Ns,vf:Ys,wf:Tp,xf:wC,yf:rJ,zf:Ws,Af:xy,Bf:zy,Cf:kp,Df:FM,Ef:Yk,Ff:Os,Gf:RF,Hf:VC,If:Ep,Jf:Dn,Kf:lN,Lf:UQ,Mf:sN,Nf:wN,Of:hN,Pf:mJ,Qf:ZC,Rf:yg,Sf:BX,Tf:eg,Uf:fp,Vf:Em,Wf:K_,Xf:dY,Yf:NV,Zf:aV,_f:Ns,$f:Ys,ag:mV,bg:FU,cg:oz,dg:wZ,eg:oH,fg:dM,gg:Fs,hg:GM,ig:WM,jg:bF,kg:pJ,lg:yJ,mg:KI,ng:_Y,og:Pu,pg:Tv,qg:fy,rg:zW,sg:GI,tg:wQ,ug:AZ,vg:HY,wg:E7,xg:jv,yg:aX,zg:Gg,Ag:vB,Bg:jB,Cg:c_,Dg:YY,Eg:lp,Fg:z2,Gg:xR,Hg:Im,Ig:M6,Jg:ZM,Kg:_F,Lg:NQ,Mg:hs,Ng:sF,Og:rg,Pg:XW,Qg:If,Rg:ge,Sg:FP,Tg:co,Ug:Wl,Vg:wo,Wg:OJ,Xg:ks,Yg:Gx,Zg:Do,_g:Kj,$g:tO,ah:PN,bh:qN,ch:JR,dh:No,eh:vU,fh:mU,gh:ZU,hh:_U,ih:ll,jh:XR,kh:A8,lh:F3,mh:fM,nh:iR,oh:UR,ph:UN,qh:DJ,rh:zR,sh:ay,th:My}}return z1(q)})(U)},instantiate:function(J,U){return{then:function(j){var q=new S6.Module(J);j({instance:new S6.Instance(q,U)})}}},RuntimeError:Error,isWasm2js:!0};S6.isWasm2js&&(ze=[]);var Te,L5=!1,g4,p4,Y8,Mi,J2,A1,P5,q5,sw=!1,S3=J=>J.startsWith("file://");function K5(){var J=Te.buffer;g4=new Int8Array(J),Y8=new Int16Array(J),p4=new Uint8Array(J),Mi=new Uint16Array(J),J2=new Int32Array(J),A1=new Uint32Array(J),P5=new Float32Array(J),q5=new Float64Array(J)}function ww(){if(P.preRun)for(typeof P.preRun=="function"&&(P.preRun=[P.preRun]);P.preRun.length;)Xw(P.preRun.shift());$5(c5)}function hw(){sw=!0,!P.noFSInit&&!b.initialized&&b.init(),i6.init(),d.Q(),b.ignorePermissions=!1}function _w(){if(P.postRun)for(typeof P.postRun=="function"&&(P.postRun=[P.postRun]);P.postRun.length;)Ww(P.postRun.shift());$5(d5)}var W6=0,Ui=null;function jP(J){return J}function a5(J){var U;W6++,(U=P.monitorRunDependencies)==null||U.call(P,W6)}function j3(J){var j;if(W6--,(j=P.monitorRunDependencies)==null||j.call(P,W6),W6==0&&Ui){var U=Ui;Ui=null,U()}}function Se(J){var j;(j=P.onAbort)==null||j.call(P,J),J="Aborted("+J+")",Ni(J),L5=!0,J+=". Build with -sASSERTIONS for more info.";var U=new S6.RuntimeError(J);throw Z6(U),U}var Di;function Bw(){return lw("libheif.wasm")}function vw(J){if(J==Di&&ze)return new Uint8Array(ze);if(Ji)return Ji(J);throw\'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)\'}function mw(J,U){var j,q=vw(J);j=new S6.Module(q);var i0=new S6.Instance(j,U);return[i0,j]}function Zw(){return{a:B_}}function Gw(){function J(q,i0){return d=q.exports,Te=d.P,K5(),h7=d.R,j3("wasm-instantiate"),d}a5("wasm-instantiate");var U=Zw();if(P.instantiateWasm)return new Promise((q,i0)=>{P.instantiateWasm(U,(c,_0)=>{q(J(c,_0))})});Di!=null||(Di=Bw());var j=mw(Di,U);return J(j[0])}var i1,u4;class OP{constructor(U){h8(this,"name","ExitStatus");this.message=`Program terminated with exit(${U})`,this.status=U}}var $5=J=>{for(;J.length>0;)J.shift()(P)},d5=[],Ww=J=>d5.push(J),c5=[],Xw=J=>c5.push(J),gw=!0,b5=typeof TextDecoder!="undefined"?new TextDecoder:void 0,j6=(J,U=0,j=NaN)=>{for(var q=U+j,i0=U;J[i0]&&!(i0>=q);)++i0;if(i0-U>16&&J.buffer&&b5)return b5.decode(J.subarray(U,i0));for(var c="";U<i0;){var _0=J[U++];if(!(_0&128)){c+=String.fromCharCode(_0);continue}var Z0=J[U++]&63;if((_0&224)==192){c+=String.fromCharCode((_0&31)<<6|Z0);continue}var B0=J[U++]&63;if((_0&240)==224?_0=(_0&15)<<12|Z0<<6|B0:_0=(_0&7)<<18|Z0<<12|B0<<6|J[U++]&63,_0<65536)c+=String.fromCharCode(_0);else{var K0=_0-65536;c+=String.fromCharCode(55296|K0>>10,56320|K0&1023)}}return c},Hi=(J,U)=>J?j6(p4,J,U):"",Qw=(J,U,j,q)=>Se(`Assertion failed: ${Hi(J)}, at: `+[U?Hi(U):"unknown filename",j,q?Hi(q):"unknown function"]);class Iw{constructor(U){this.excPtr=U,this.ptr=U-24}set_type(U){A1[this.ptr+4>>2]=U}get_type(){return A1[this.ptr+4>>2]}set_destructor(U){A1[this.ptr+8>>2]=U}get_destructor(){return A1[this.ptr+8>>2]}set_caught(U){U=U?1:0,g4[this.ptr+12]=U}get_caught(){return g4[this.ptr+12]!=0}set_rethrown(U){U=U?1:0,g4[this.ptr+13]=U}get_rethrown(){return g4[this.ptr+13]!=0}init(U,j){this.set_adjusted_ptr(0),this.set_type(U),this.set_destructor(j)}set_adjusted_ptr(U){A1[this.ptr+16>>2]=U}get_adjusted_ptr(){return A1[this.ptr+16>>2]}}var i7=0,Cw=0,Vw=(J,U,j)=>{var q=new Iw(J);throw q.init(U,j),i7=J,Cw++,i7},je=()=>{var J=J2[+Q4.varargs>>2];return Q4.varargs+=4,J},O6=je,C1={isAbs:J=>J.charAt(0)==="/",splitPath:J=>{var U=/^(\\/?|)([\\s\\S]*?)((?:\\.{1,2}|[^\\/]+?|)(\\.[^.\\/]*|))(?:[\\/]*)$/;return U.exec(J).slice(1)},normalizeArray:(J,U)=>{for(var j=0,q=J.length-1;q>=0;q--){var i0=J[q];i0==="."?J.splice(q,1):i0===".."?(J.splice(q,1),j++):j&&(J.splice(q,1),j--)}if(U)for(;j;j--)J.unshift("..");return J},normalize:J=>{var U=C1.isAbs(J),j=J.slice(-1)==="/";return J=C1.normalizeArray(J.split("/").filter(q=>!!q),!U).join("/"),!J&&!U&&(J="."),J&&j&&(J+="/"),(U?"/":"")+J},dirname:J=>{var U=C1.splitPath(J),j=U[0],q=U[1];return!j&&!q?".":(q&&(q=q.slice(0,-1)),j+q)},basename:J=>J&&J.match(/([^\\/]+|\\/)\\/*$/)[1],join:(...J)=>C1.normalize(J.join("/")),join2:(J,U)=>C1.normalize(J+"/"+U)},Fw=()=>{if(G6){var J=S5("crypto");return U=>J.randomFillSync(U)}return U=>crypto.getRandomValues(U)},e7=J=>{(e7=Fw())(J)},L6={resolve:(...J)=>{for(var U="",j=!1,q=J.length-1;q>=-1&&!j;q--){var i0=q>=0?J[q]:b.cwd();if(typeof i0!="string")throw new TypeError("Arguments to path.resolve must be strings");if(!i0)return"";U=i0+"/"+U,j=C1.isAbs(i0)}return U=C1.normalizeArray(U.split("/").filter(c=>!!c),!j).join("/"),(j?"/":"")+U||"."},relative:(J,U)=>{J=L6.resolve(J).slice(1),U=L6.resolve(U).slice(1);function j(K0){for(var a0=0;a0<K0.length&&K0[a0]==="";a0++);for(var m2=K0.length-1;m2>=0&&K0[m2]==="";m2--);return a0>m2?[]:K0.slice(a0,m2-a0+1)}for(var q=j(J.split("/")),i0=j(U.split("/")),c=Math.min(q.length,i0.length),_0=c,Z0=0;Z0<c;Z0++)if(q[Z0]!==i0[Z0]){_0=Z0;break}for(var B0=[],Z0=_0;Z0<q.length;Z0++)B0.push("..");return B0=B0.concat(i0.slice(_0)),B0.join("/")}},O3=[],Oe=J=>{for(var U=0,j=0;j<J.length;++j){var q=J.charCodeAt(j);q<=127?U++:q<=2047?U+=2:q>=55296&&q<=57343?(U+=4,++j):U+=3}return U},L3=(J,U,j,q)=>{if(!(q>0))return 0;for(var i0=j,c=j+q-1,_0=0;_0<J.length;++_0){var Z0=J.charCodeAt(_0);if(Z0>=55296&&Z0<=57343){var B0=J.charCodeAt(++_0);Z0=65536+((Z0&1023)<<10)|B0&1023}if(Z0<=127){if(j>=c)break;U[j++]=Z0}else if(Z0<=2047){if(j+1>=c)break;U[j++]=192|Z0>>6,U[j++]=128|Z0&63}else if(Z0<=65535){if(j+2>=c)break;U[j++]=224|Z0>>12,U[j++]=128|Z0>>6&63,U[j++]=128|Z0&63}else{if(j+3>=c)break;U[j++]=240|Z0>>18,U[j++]=128|Z0>>12&63,U[j++]=128|Z0>>6&63,U[j++]=128|Z0&63}}return U[j]=0,j-i0},r7=(J,U,j)=>{var q=j>0?j:Oe(J)+1,i0=new Array(q),c=L3(J,i0,0,i0.length);return U&&(i0.length=c),i0},Ew=()=>{if(!O3.length){var J=null;if(G6){var U=256,j=Buffer.alloc(U),q=0,i0=process.stdin.fd;try{q=T3.readSync(i0,j,0,U)}catch(c){if(c.toString().includes("EOF"))q=0;else throw c}q>0&&(J=j.slice(0,q).toString("utf-8"))}else typeof window!="undefined"&&typeof window.prompt=="function"&&(J=window.prompt("Input: "),J!==null&&(J+=`\n`));if(!J)return null;O3=r7(J,!0)}return O3.shift()},i6={ttys:[],init(){},shutdown(){},register(J,U){i6.ttys[J]={input:[],output:[],ops:U},b.registerDevice(J,i6.stream_ops)},stream_ops:{open(J){var U=i6.ttys[J.node.rdev];if(!U)throw new b.ErrnoError(43);J.tty=U,J.seekable=!1},close(J){J.tty.ops.fsync(J.tty)},fsync(J){J.tty.ops.fsync(J.tty)},read(J,U,j,q,i0){if(!J.tty||!J.tty.ops.get_char)throw new b.ErrnoError(60);for(var c=0,_0=0;_0<q;_0++){var Z0;try{Z0=J.tty.ops.get_char(J.tty)}catch(B0){throw new b.ErrnoError(29)}if(Z0===void 0&&c===0)throw new b.ErrnoError(6);if(Z0==null)break;c++,U[j+_0]=Z0}return c&&(J.node.atime=Date.now()),c},write(J,U,j,q,i0){if(!J.tty||!J.tty.ops.put_char)throw new b.ErrnoError(60);try{for(var c=0;c<q;c++)J.tty.ops.put_char(J.tty,U[j+c])}catch(_0){throw new b.ErrnoError(29)}return q&&(J.node.mtime=J.node.ctime=Date.now()),c}},default_tty_ops:{get_char(J){return Ew()},put_char(J,U){U===null||U===10?(xe(j6(J.output)),J.output=[]):U!=0&&J.output.push(U)},fsync(J){var U;((U=J.output)==null?void 0:U.length)>0&&(xe(j6(J.output)),J.output=[])},ioctl_tcgets(J){return{c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}},ioctl_tcsets(J,U,j){return 0},ioctl_tiocgwinsz(J){return[24,80]}},default_tty1_ops:{put_char(J,U){U===null||U===10?(Ni(j6(J.output)),J.output=[]):U!=0&&J.output.push(U)},fsync(J){var U;((U=J.output)==null?void 0:U.length)>0&&(Ni(j6(J.output)),J.output=[])}}},f7=J=>{Se()},M2={ops_table:null,mount(J){return M2.createNode(null,"/",16895,0)},createNode(J,U,j,q){if(b.isBlkdev(j)||b.isFIFO(j))throw new b.ErrnoError(63);M2.ops_table||(M2.ops_table={dir:{node:{getattr:M2.node_ops.getattr,setattr:M2.node_ops.setattr,lookup:M2.node_ops.lookup,mknod:M2.node_ops.mknod,rename:M2.node_ops.rename,unlink:M2.node_ops.unlink,rmdir:M2.node_ops.rmdir,readdir:M2.node_ops.readdir,symlink:M2.node_ops.symlink},stream:{llseek:M2.stream_ops.llseek}},file:{node:{getattr:M2.node_ops.getattr,setattr:M2.node_ops.setattr},stream:{llseek:M2.stream_ops.llseek,read:M2.stream_ops.read,write:M2.stream_ops.write,mmap:M2.stream_ops.mmap,msync:M2.stream_ops.msync}},link:{node:{getattr:M2.node_ops.getattr,setattr:M2.node_ops.setattr,readlink:M2.node_ops.readlink},stream:{}},chrdev:{node:{getattr:M2.node_ops.getattr,setattr:M2.node_ops.setattr},stream:b.chrdev_stream_ops}});var i0=b.createNode(J,U,j,q);return b.isDir(i0.mode)?(i0.node_ops=M2.ops_table.dir.node,i0.stream_ops=M2.ops_table.dir.stream,i0.contents={}):b.isFile(i0.mode)?(i0.node_ops=M2.ops_table.file.node,i0.stream_ops=M2.ops_table.file.stream,i0.usedBytes=0,i0.contents=null):b.isLink(i0.mode)?(i0.node_ops=M2.ops_table.link.node,i0.stream_ops=M2.ops_table.link.stream):b.isChrdev(i0.mode)&&(i0.node_ops=M2.ops_table.chrdev.node,i0.stream_ops=M2.ops_table.chrdev.stream),i0.atime=i0.mtime=i0.ctime=Date.now(),J&&(J.contents[U]=i0,J.atime=J.mtime=J.ctime=i0.atime),i0},getFileDataAsTypedArray(J){return J.contents?J.contents.subarray?J.contents.subarray(0,J.usedBytes):new Uint8Array(J.contents):new Uint8Array(0)},expandFileStorage(J,U){var j=J.contents?J.contents.length:0;if(!(j>=U)){var q=1024*1024;U=Math.max(U,j*(j<q?2:1.125)>>>0),j!=0&&(U=Math.max(U,256));var i0=J.contents;J.contents=new Uint8Array(U),J.usedBytes>0&&J.contents.set(i0.subarray(0,J.usedBytes),0)}},resizeFileStorage(J,U){if(J.usedBytes!=U)if(U==0)J.contents=null,J.usedBytes=0;else{var j=J.contents;J.contents=new Uint8Array(U),j&&J.contents.set(j.subarray(0,Math.min(U,J.usedBytes))),J.usedBytes=U}},node_ops:{getattr(J){var U={};return U.dev=b.isChrdev(J.mode)?J.id:1,U.ino=J.id,U.mode=J.mode,U.nlink=1,U.uid=0,U.gid=0,U.rdev=J.rdev,b.isDir(J.mode)?U.size=4096:b.isFile(J.mode)?U.size=J.usedBytes:b.isLink(J.mode)?U.size=J.link.length:U.size=0,U.atime=new Date(J.atime),U.mtime=new Date(J.mtime),U.ctime=new Date(J.ctime),U.blksize=4096,U.blocks=Math.ceil(U.size/U.blksize),U},setattr(J,U){for(let j of["mode","atime","mtime","ctime"])U[j]!=null&&(J[j]=U[j]);U.size!==void 0&&M2.resizeFileStorage(J,U.size)},lookup(J,U){throw M2.doesNotExistError},mknod(J,U,j,q){return M2.createNode(J,U,j,q)},rename(J,U,j){var q;try{q=b.lookupNode(U,j)}catch(c){}if(q){if(b.isDir(J.mode))for(var i0 in q.contents)throw new b.ErrnoError(55);b.hashRemoveNode(q)}delete J.parent.contents[J.name],U.contents[j]=J,J.name=j,U.ctime=U.mtime=J.parent.ctime=J.parent.mtime=Date.now()},unlink(J,U){delete J.contents[U],J.ctime=J.mtime=Date.now()},rmdir(J,U){var j=b.lookupNode(J,U);for(var q in j.contents)throw new b.ErrnoError(55);delete J.contents[U],J.ctime=J.mtime=Date.now()},readdir(J){return[".","..",...Object.keys(J.contents)]},symlink(J,U,j){var q=M2.createNode(J,U,41471,0);return q.link=j,q},readlink(J){if(!b.isLink(J.mode))throw new b.ErrnoError(28);return J.link}},stream_ops:{read(J,U,j,q,i0){var c=J.node.contents;if(i0>=J.node.usedBytes)return 0;var _0=Math.min(J.node.usedBytes-i0,q);if(_0>8&&c.subarray)U.set(c.subarray(i0,i0+_0),j);else for(var Z0=0;Z0<_0;Z0++)U[j+Z0]=c[i0+Z0];return _0},write(J,U,j,q,i0,c){if(U.buffer===g4.buffer&&(c=!1),!q)return 0;var _0=J.node;if(_0.mtime=_0.ctime=Date.now(),U.subarray&&(!_0.contents||_0.contents.subarray)){if(c)return _0.contents=U.subarray(j,j+q),_0.usedBytes=q,q;if(_0.usedBytes===0&&i0===0)return _0.contents=U.slice(j,j+q),_0.usedBytes=q,q;if(i0+q<=_0.usedBytes)return _0.contents.set(U.subarray(j,j+q),i0),q}if(M2.expandFileStorage(_0,i0+q),_0.contents.subarray&&U.subarray)_0.contents.set(U.subarray(j,j+q),i0);else for(var Z0=0;Z0<q;Z0++)_0.contents[i0+Z0]=U[j+Z0];return _0.usedBytes=Math.max(_0.usedBytes,i0+q),q},llseek(J,U,j){var q=U;if(j===1?q+=J.position:j===2&&b.isFile(J.node.mode)&&(q+=J.node.usedBytes),q<0)throw new b.ErrnoError(28);return q},mmap(J,U,j,q,i0){if(!b.isFile(J.node.mode))throw new b.ErrnoError(43);var c,_0,Z0=J.node.contents;if(!(i0&2)&&Z0&&Z0.buffer===g4.buffer)_0=!1,c=Z0.byteOffset;else{if(_0=!0,c=f7(U),!c)throw new b.ErrnoError(48);Z0&&((j>0||j+U<Z0.length)&&(Z0.subarray?Z0=Z0.subarray(j,j+U):Z0=Array.prototype.slice.call(Z0,j,j+U)),g4.set(Z0,c))}return{ptr:c,allocated:_0}},msync(J,U,j,q,i0){return M2.stream_ops.write(J,U,0,q,j,!1),0}}},pw=J=>v6(null,null,function*(){var U=yield z3(J);return new Uint8Array(U)}),yw=(...J)=>b.createDataFile(...J),A7=[],Yw=(J,U,j,q)=>{typeof Browser!="undefined"&&Browser.init();var i0=!1;return A7.forEach(c=>{i0||c.canHandle(U)&&(c.handle(J,U,j,q),i0=!0)}),i0},Rw=(J,U,j,q,i0,c,_0,Z0,B0,K0)=>{var a0=U?L6.resolve(C1.join2(J,U)):J,m2=`cp ${a0}`;function F2(B2){function t2(U2){K0==null||K0(),Z0||yw(J,U,U2,q,i0,B0),c==null||c(),j3(m2)}Yw(B2,a0,t2,()=>{_0==null||_0(),j3(m2)})||t2(B2)}a5(m2),typeof j=="string"?pw(j).then(F2,_0):F2(j)},Jw=J=>{var U={r:0,"r+":2,w:577,"w+":578,a:1089,"a+":1090},j=U[J];if(typeof j=="undefined")throw new Error(`Unknown file open mode: ${J}`);return j},P3=(J,U)=>{var j=0;return J&&(j|=365),U&&(j|=146),j},b={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:!1,ignorePermissions:!0,filesystems:null,syncFSRequests:0,readFiles:{},ErrnoError:class{constructor(J){h8(this,"name","ErrnoError");this.errno=J}},FSStream:class{constructor(){h8(this,"shared",{})}get object(){return this.node}set object(J){this.node=J}get isRead(){return(this.flags&2097155)!==1}get isWrite(){return(this.flags&2097155)!==0}get isAppend(){return this.flags&1024}get flags(){return this.shared.flags}set flags(J){this.shared.flags=J}get position(){return this.shared.position}set position(J){this.shared.position=J}},FSNode:class{constructor(J,U,j,q){h8(this,"node_ops",{});h8(this,"stream_ops",{});h8(this,"readMode",365);h8(this,"writeMode",146);h8(this,"mounted",null);J||(J=this),this.parent=J,this.mount=J.mount,this.id=b.nextInode++,this.name=U,this.mode=j,this.rdev=q,this.atime=this.mtime=this.ctime=Date.now()}get read(){return(this.mode&this.readMode)===this.readMode}set read(J){J?this.mode|=this.readMode:this.mode&=~this.readMode}get write(){return(this.mode&this.writeMode)===this.writeMode}set write(J){J?this.mode|=this.writeMode:this.mode&=~this.writeMode}get isFolder(){return b.isDir(this.mode)}get isDevice(){return b.isChrdev(this.mode)}},lookupPath(J,U={}){var K0;if(!J)throw new b.ErrnoError(44);(K0=U.follow_mount)!=null||(U.follow_mount=!0),C1.isAbs(J)||(J=b.cwd()+"/"+J);i:for(var j=0;j<40;j++){for(var q=J.split("/").filter(a0=>!!a0),i0=b.root,c="/",_0=0;_0<q.length;_0++){var Z0=_0===q.length-1;if(Z0&&U.parent)break;if(q[_0]!=="."){if(q[_0]===".."){if(c=C1.dirname(c),b.isRoot(i0)){J=c+"/"+q.slice(_0+1).join("/");continue i}else i0=i0.parent;continue}c=C1.join2(c,q[_0]);try{i0=b.lookupNode(i0,q[_0])}catch(a0){if((a0==null?void 0:a0.errno)===44&&Z0&&U.noent_okay)return{path:c};throw a0}if(b.isMountpoint(i0)&&(!Z0||U.follow_mount)&&(i0=i0.mounted.root),b.isLink(i0.mode)&&(!Z0||U.follow)){if(!i0.node_ops.readlink)throw new b.ErrnoError(52);var B0=i0.node_ops.readlink(i0);C1.isAbs(B0)||(B0=C1.dirname(c)+"/"+B0),J=B0+"/"+q.slice(_0+1).join("/");continue i}}}return{path:c,node:i0}}throw new b.ErrnoError(32)},getPath(J){for(var U;;){if(b.isRoot(J)){var j=J.mount.mountpoint;return U?j[j.length-1]!=="/"?`${j}/${U}`:j+U:j}U=U?`${J.name}/${U}`:J.name,J=J.parent}},hashName(J,U){for(var j=0,q=0;q<U.length;q++)j=(j<<5)-j+U.charCodeAt(q)|0;return(J+j>>>0)%b.nameTable.length},hashAddNode(J){var U=b.hashName(J.parent.id,J.name);J.name_next=b.nameTable[U],b.nameTable[U]=J},hashRemoveNode(J){var U=b.hashName(J.parent.id,J.name);if(b.nameTable[U]===J)b.nameTable[U]=J.name_next;else for(var j=b.nameTable[U];j;){if(j.name_next===J){j.name_next=J.name_next;break}j=j.name_next}},lookupNode(J,U){var j=b.mayLookup(J);if(j)throw new b.ErrnoError(j);for(var q=b.hashName(J.id,U),i0=b.nameTable[q];i0;i0=i0.name_next){var c=i0.name;if(i0.parent.id===J.id&&c===U)return i0}return b.lookup(J,U)},createNode(J,U,j,q){var i0=new b.FSNode(J,U,j,q);return b.hashAddNode(i0),i0},destroyNode(J){b.hashRemoveNode(J)},isRoot(J){return J===J.parent},isMountpoint(J){return!!J.mounted},isFile(J){return(J&61440)===32768},isDir(J){return(J&61440)===16384},isLink(J){return(J&61440)===40960},isChrdev(J){return(J&61440)===8192},isBlkdev(J){return(J&61440)===24576},isFIFO(J){return(J&61440)===4096},isSocket(J){return(J&49152)===49152},flagsToPermissionString(J){var U=["r","w","rw"][J&3];return J&512&&(U+="w"),U},nodePermissions(J,U){return b.ignorePermissions?0:U.includes("r")&&!(J.mode&292)||U.includes("w")&&!(J.mode&146)||U.includes("x")&&!(J.mode&73)?2:0},mayLookup(J){if(!b.isDir(J.mode))return 54;var U=b.nodePermissions(J,"x");return U||(J.node_ops.lookup?0:2)},mayCreate(J,U){if(!b.isDir(J.mode))return 54;try{var j=b.lookupNode(J,U);return 20}catch(q){}return b.nodePermissions(J,"wx")},mayDelete(J,U,j){var q;try{q=b.lookupNode(J,U)}catch(c){return c.errno}var i0=b.nodePermissions(J,"wx");if(i0)return i0;if(j){if(!b.isDir(q.mode))return 54;if(b.isRoot(q)||b.getPath(q)===b.cwd())return 10}else if(b.isDir(q.mode))return 31;return 0},mayOpen(J,U){return J?b.isLink(J.mode)?32:b.isDir(J.mode)&&(b.flagsToPermissionString(U)!=="r"||U&576)?31:b.nodePermissions(J,b.flagsToPermissionString(U)):44},checkOpExists(J,U){if(!J)throw new b.ErrnoError(U);return J},MAX_OPEN_FDS:4096,nextfd(){for(var J=0;J<=b.MAX_OPEN_FDS;J++)if(!b.streams[J])return J;throw new b.ErrnoError(33)},getStreamChecked(J){var U=b.getStream(J);if(!U)throw new b.ErrnoError(8);return U},getStream:J=>b.streams[J],createStream(J,U=-1){return J=Object.assign(new b.FSStream,J),U==-1&&(U=b.nextfd()),J.fd=U,b.streams[U]=J,J},closeStream(J){b.streams[J]=null},dupStream(J,U=-1){var q,i0;var j=b.createStream(J,U);return(i0=(q=j.stream_ops)==null?void 0:q.dup)==null||i0.call(q,j),j},doSetAttr(J,U,j){var q=J==null?void 0:J.stream_ops.setattr,i0=q?J:U;q!=null||(q=U.node_ops.setattr),b.checkOpExists(q,63),q(i0,j)},chrdev_stream_ops:{open(J){var j,q;var U=b.getDevice(J.node.rdev);J.stream_ops=U.stream_ops,(q=(j=J.stream_ops).open)==null||q.call(j,J)},llseek(){throw new b.ErrnoError(70)}},major:J=>J>>8,minor:J=>J&255,makedev:(J,U)=>J<<8|U,registerDevice(J,U){b.devices[J]={stream_ops:U}},getDevice:J=>b.devices[J],getMounts(J){for(var U=[],j=[J];j.length;){var q=j.pop();U.push(q),j.push(...q.mounts)}return U},syncfs(J,U){typeof J=="function"&&(U=J,J=!1),b.syncFSRequests++,b.syncFSRequests>1&&Ni(`warning: ${b.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);var j=b.getMounts(b.root.mount),q=0;function i0(_0){return b.syncFSRequests--,U(_0)}function c(_0){if(_0)return c.errored?void 0:(c.errored=!0,i0(_0));++q>=j.length&&i0(null)}j.forEach(_0=>{if(!_0.type.syncfs)return c(null);_0.type.syncfs(_0,J,c)})},mount(J,U,j){var q=j==="/",i0=!j,c;if(q&&b.root)throw new b.ErrnoError(10);if(!q&&!i0){var _0=b.lookupPath(j,{follow_mount:!1});if(j=_0.path,c=_0.node,b.isMountpoint(c))throw new b.ErrnoError(10);if(!b.isDir(c.mode))throw new b.ErrnoError(54)}var Z0={type:J,opts:U,mountpoint:j,mounts:[]},B0=J.mount(Z0);return B0.mount=Z0,Z0.root=B0,q?b.root=B0:c&&(c.mounted=Z0,c.mount&&c.mount.mounts.push(Z0)),B0},unmount(J){var U=b.lookupPath(J,{follow_mount:!1});if(!b.isMountpoint(U.node))throw new b.ErrnoError(28);var j=U.node,q=j.mounted,i0=b.getMounts(q);Object.keys(b.nameTable).forEach(_0=>{for(var Z0=b.nameTable[_0];Z0;){var B0=Z0.name_next;i0.includes(Z0.mount)&&b.destroyNode(Z0),Z0=B0}}),j.mounted=null;var c=j.mount.mounts.indexOf(q);j.mount.mounts.splice(c,1)},lookup(J,U){return J.node_ops.lookup(J,U)},mknod(J,U,j){var q=b.lookupPath(J,{parent:!0}),i0=q.node,c=C1.basename(J);if(!c)throw new b.ErrnoError(28);if(c==="."||c==="..")throw new b.ErrnoError(20);var _0=b.mayCreate(i0,c);if(_0)throw new b.ErrnoError(_0);if(!i0.node_ops.mknod)throw new b.ErrnoError(63);return i0.node_ops.mknod(i0,c,U,j)},statfs(J){return b.statfsNode(b.lookupPath(J,{follow:!0}).node)},statfsStream(J){return b.statfsNode(J.node)},statfsNode(J){var U={bsize:4096,frsize:4096,blocks:1e6,bfree:5e5,bavail:5e5,files:b.nextInode,ffree:b.nextInode-1,fsid:42,flags:2,namelen:255};return J.node_ops.statfs&&Object.assign(U,J.node_ops.statfs(J.mount.opts.root)),U},create(J,U=438){return U&=4095,U|=32768,b.mknod(J,U,0)},mkdir(J,U=511){return U&=1023,U|=16384,b.mknod(J,U,0)},mkdirTree(J,U){var j=J.split("/"),q="";for(var i0 of j)if(i0){(q||C1.isAbs(J))&&(q+="/"),q+=i0;try{b.mkdir(q,U)}catch(c){if(c.errno!=20)throw c}}},mkdev(J,U,j){return typeof j=="undefined"&&(j=U,U=438),U|=8192,b.mknod(J,U,j)},symlink(J,U){if(!L6.resolve(J))throw new b.ErrnoError(44);var j=b.lookupPath(U,{parent:!0}),q=j.node;if(!q)throw new b.ErrnoError(44);var i0=C1.basename(U),c=b.mayCreate(q,i0);if(c)throw new b.ErrnoError(c);if(!q.node_ops.symlink)throw new b.ErrnoError(63);return q.node_ops.symlink(q,i0,J)},rename(J,U){var j=C1.dirname(J),q=C1.dirname(U),i0=C1.basename(J),c=C1.basename(U),_0,Z0,B0;if(_0=b.lookupPath(J,{parent:!0}),Z0=_0.node,_0=b.lookupPath(U,{parent:!0}),B0=_0.node,!Z0||!B0)throw new b.ErrnoError(44);if(Z0.mount!==B0.mount)throw new b.ErrnoError(75);var K0=b.lookupNode(Z0,i0),a0=L6.relative(J,q);if(a0.charAt(0)!==".")throw new b.ErrnoError(28);if(a0=L6.relative(U,j),a0.charAt(0)!==".")throw new b.ErrnoError(55);var m2;try{m2=b.lookupNode(B0,c)}catch(t2){}if(K0!==m2){var F2=b.isDir(K0.mode),B2=b.mayDelete(Z0,i0,F2);if(B2)throw new b.ErrnoError(B2);if(B2=m2?b.mayDelete(B0,c,F2):b.mayCreate(B0,c),B2)throw new b.ErrnoError(B2);if(!Z0.node_ops.rename)throw new b.ErrnoError(63);if(b.isMountpoint(K0)||m2&&b.isMountpoint(m2))throw new b.ErrnoError(10);if(B0!==Z0&&(B2=b.nodePermissions(Z0,"w"),B2))throw new b.ErrnoError(B2);b.hashRemoveNode(K0);try{Z0.node_ops.rename(K0,B0,c),K0.parent=B0}catch(t2){throw t2}finally{b.hashAddNode(K0)}}},rmdir(J){var U=b.lookupPath(J,{parent:!0}),j=U.node,q=C1.basename(J),i0=b.lookupNode(j,q),c=b.mayDelete(j,q,!0);if(c)throw new b.ErrnoError(c);if(!j.node_ops.rmdir)throw new b.ErrnoError(63);if(b.isMountpoint(i0))throw new b.ErrnoError(10);j.node_ops.rmdir(j,q),b.destroyNode(i0)},readdir(J){var U=b.lookupPath(J,{follow:!0}),j=U.node,q=b.checkOpExists(j.node_ops.readdir,54);return q(j)},unlink(J){var U=b.lookupPath(J,{parent:!0}),j=U.node;if(!j)throw new b.ErrnoError(44);var q=C1.basename(J),i0=b.lookupNode(j,q),c=b.mayDelete(j,q,!1);if(c)throw new b.ErrnoError(c);if(!j.node_ops.unlink)throw new b.ErrnoError(63);if(b.isMountpoint(i0))throw new b.ErrnoError(10);j.node_ops.unlink(j,q),b.destroyNode(i0)},readlink(J){var U=b.lookupPath(J),j=U.node;if(!j)throw new b.ErrnoError(44);if(!j.node_ops.readlink)throw new b.ErrnoError(28);return j.node_ops.readlink(j)},stat(J,U){var j=b.lookupPath(J,{follow:!U}),q=j.node,i0=b.checkOpExists(q.node_ops.getattr,63);return i0(q)},fstat(J){var U=b.getStreamChecked(J),j=U.node,q=U.stream_ops.getattr,i0=q?U:j;return q!=null||(q=j.node_ops.getattr),b.checkOpExists(q,63),q(i0)},lstat(J){return b.stat(J,!0)},doChmod(J,U,j,q){b.doSetAttr(J,U,{mode:j&4095|U.mode&-4096,ctime:Date.now(),dontFollow:q})},chmod(J,U,j){var q;if(typeof J=="string"){var i0=b.lookupPath(J,{follow:!j});q=i0.node}else q=J;b.doChmod(null,q,U,j)},lchmod(J,U){b.chmod(J,U,!0)},fchmod(J,U){var j=b.getStreamChecked(J);b.doChmod(j,j.node,U,!1)},doChown(J,U,j){b.doSetAttr(J,U,{timestamp:Date.now(),dontFollow:j})},chown(J,U,j,q){var i0;if(typeof J=="string"){var c=b.lookupPath(J,{follow:!q});i0=c.node}else i0=J;b.doChown(null,i0,q)},lchown(J,U,j){b.chown(J,U,j,!0)},fchown(J,U,j){var q=b.getStreamChecked(J);b.doChown(q,q.node,!1)},doTruncate(J,U,j){if(b.isDir(U.mode))throw new b.ErrnoError(31);if(!b.isFile(U.mode))throw new b.ErrnoError(28);var q=b.nodePermissions(U,"w");if(q)throw new b.ErrnoError(q);b.doSetAttr(J,U,{size:j,timestamp:Date.now()})},truncate(J,U){if(U<0)throw new b.ErrnoError(28);var j;if(typeof J=="string"){var q=b.lookupPath(J,{follow:!0});j=q.node}else j=J;b.doTruncate(null,j,U)},ftruncate(J,U){var j=b.getStreamChecked(J);if(U<0||(j.flags&2097155)===0)throw new b.ErrnoError(28);b.doTruncate(j,j.node,U)},utime(J,U,j){var q=b.lookupPath(J,{follow:!0}),i0=q.node,c=b.checkOpExists(i0.node_ops.setattr,63);c(i0,{atime:U,mtime:j})},open(J,U,j=438){if(J==="")throw new b.ErrnoError(44);U=typeof U=="string"?Jw(U):U,U&64?j=j&4095|32768:j=0;var q,i0;if(typeof J=="object")q=J;else{i0=J.endsWith("/");var c=b.lookupPath(J,{follow:!(U&131072),noent_okay:!0});q=c.node,J=c.path}var _0=!1;if(U&64)if(q){if(U&128)throw new b.ErrnoError(20)}else{if(i0)throw new b.ErrnoError(31);q=b.mknod(J,j|511,0),_0=!0}if(!q)throw new b.ErrnoError(44);if(b.isChrdev(q.mode)&&(U&=-513),U&65536&&!b.isDir(q.mode))throw new b.ErrnoError(54);if(!_0){var Z0=b.mayOpen(q,U);if(Z0)throw new b.ErrnoError(Z0)}U&512&&!_0&&b.truncate(q,0),U&=-131713;var B0=b.createStream({node:q,path:b.getPath(q),flags:U,seekable:!0,position:0,stream_ops:q.stream_ops,ungotten:[],error:!1});return B0.stream_ops.open&&B0.stream_ops.open(B0),_0&&b.chmod(q,j&511),P.logReadFiles&&!(U&1)&&(J in b.readFiles||(b.readFiles[J]=1)),B0},close(J){if(b.isClosed(J))throw new b.ErrnoError(8);J.getdents&&(J.getdents=null);try{J.stream_ops.close&&J.stream_ops.close(J)}catch(U){throw U}finally{b.closeStream(J.fd)}J.fd=null},isClosed(J){return J.fd===null},llseek(J,U,j){if(b.isClosed(J))throw new b.ErrnoError(8);if(!J.seekable||!J.stream_ops.llseek)throw new b.ErrnoError(70);if(j!=0&&j!=1&&j!=2)throw new b.ErrnoError(28);return J.position=J.stream_ops.llseek(J,U,j),J.ungotten=[],J.position},read(J,U,j,q,i0){if(q<0||i0<0)throw new b.ErrnoError(28);if(b.isClosed(J))throw new b.ErrnoError(8);if((J.flags&2097155)===1)throw new b.ErrnoError(8);if(b.isDir(J.node.mode))throw new b.ErrnoError(31);if(!J.stream_ops.read)throw new b.ErrnoError(28);var c=typeof i0!="undefined";if(!c)i0=J.position;else if(!J.seekable)throw new b.ErrnoError(70);var _0=J.stream_ops.read(J,U,j,q,i0);return c||(J.position+=_0),_0},write(J,U,j,q,i0,c){if(q<0||i0<0)throw new b.ErrnoError(28);if(b.isClosed(J))throw new b.ErrnoError(8);if((J.flags&2097155)===0)throw new b.ErrnoError(8);if(b.isDir(J.node.mode))throw new b.ErrnoError(31);if(!J.stream_ops.write)throw new b.ErrnoError(28);J.seekable&&J.flags&1024&&b.llseek(J,0,2);var _0=typeof i0!="undefined";if(!_0)i0=J.position;else if(!J.seekable)throw new b.ErrnoError(70);var Z0=J.stream_ops.write(J,U,j,q,i0,c);return _0||(J.position+=Z0),Z0},mmap(J,U,j,q,i0){if((q&2)!==0&&(i0&2)===0&&(J.flags&2097155)!==2)throw new b.ErrnoError(2);if((J.flags&2097155)===1)throw new b.ErrnoError(2);if(!J.stream_ops.mmap)throw new b.ErrnoError(43);if(!U)throw new b.ErrnoError(28);return J.stream_ops.mmap(J,U,j,q,i0)},msync(J,U,j,q,i0){return J.stream_ops.msync?J.stream_ops.msync(J,U,j,q,i0):0},ioctl(J,U,j){if(!J.stream_ops.ioctl)throw new b.ErrnoError(59);return J.stream_ops.ioctl(J,U,j)},readFile(J,U={}){if(U.flags=U.flags||0,U.encoding=U.encoding||"binary",U.encoding!=="utf8"&&U.encoding!=="binary")throw new Error(`Invalid encoding type "${U.encoding}"`);var j,q=b.open(J,U.flags),i0=b.stat(J),c=i0.size,_0=new Uint8Array(c);return b.read(q,_0,0,c,0),U.encoding==="utf8"?j=j6(_0):U.encoding==="binary"&&(j=_0),b.close(q),j},writeFile(J,U,j={}){j.flags=j.flags||577;var q=b.open(J,j.flags,j.mode);if(typeof U=="string"){var i0=new Uint8Array(Oe(U)+1),c=L3(U,i0,0,i0.length);b.write(q,i0,0,c,void 0,j.canOwn)}else if(ArrayBuffer.isView(U))b.write(q,U,0,U.byteLength,void 0,j.canOwn);else throw new Error("Unsupported data type");b.close(q)},cwd:()=>b.currentPath,chdir(J){var U=b.lookupPath(J,{follow:!0});if(U.node===null)throw new b.ErrnoError(44);if(!b.isDir(U.node.mode))throw new b.ErrnoError(54);var j=b.nodePermissions(U.node,"x");if(j)throw new b.ErrnoError(j);b.currentPath=U.path},createDefaultDirectories(){b.mkdir("/tmp"),b.mkdir("/home"),b.mkdir("/home/web_user")},createDefaultDevices(){b.mkdir("/dev"),b.registerDevice(b.makedev(1,3),{read:()=>0,write:(q,i0,c,_0,Z0)=>_0,llseek:()=>0}),b.mkdev("/dev/null",b.makedev(1,3)),i6.register(b.makedev(5,0),i6.default_tty_ops),i6.register(b.makedev(6,0),i6.default_tty1_ops),b.mkdev("/dev/tty",b.makedev(5,0)),b.mkdev("/dev/tty1",b.makedev(6,0));var J=new Uint8Array(1024),U=0,j=()=>(U===0&&(e7(J),U=J.byteLength),J[--U]);b.createDevice("/dev","random",j),b.createDevice("/dev","urandom",j),b.mkdir("/dev/shm"),b.mkdir("/dev/shm/tmp")},createSpecialDirectories(){b.mkdir("/proc");var J=b.mkdir("/proc/self");b.mkdir("/proc/self/fd"),b.mount({mount(){var U=b.createNode(J,"fd",16895,73);return U.stream_ops={llseek:M2.stream_ops.llseek},U.node_ops={lookup(j,q){var i0=+q,c=b.getStreamChecked(i0),_0={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>c.path},id:i0+1};return _0.parent=_0,_0},readdir(){return Array.from(b.streams.entries()).filter(([j,q])=>q).map(([j,q])=>j.toString())}},U}},{},"/proc/self/fd")},createStandardStreams(J,U,j){J?b.createDevice("/dev","stdin",J):b.symlink("/dev/tty","/dev/stdin"),U?b.createDevice("/dev","stdout",null,U):b.symlink("/dev/tty","/dev/stdout"),j?b.createDevice("/dev","stderr",null,j):b.symlink("/dev/tty1","/dev/stderr");var q=b.open("/dev/stdin",0),i0=b.open("/dev/stdout",1),c=b.open("/dev/stderr",1)},staticInit(){b.nameTable=new Array(4096),b.mount(M2,{},"/"),b.createDefaultDirectories(),b.createDefaultDevices(),b.createSpecialDirectories(),b.filesystems={MEMFS:M2}},init(J,U,j){b.initialized=!0,J!=null||(J=P.stdin),U!=null||(U=P.stdout),j!=null||(j=P.stderr),b.createStandardStreams(J,U,j)},quit(){b.initialized=!1;for(var J of b.streams)J&&b.close(J)},findObject(J,U){var j=b.analyzePath(J,U);return j.exists?j.object:null},analyzePath(J,U){try{var j=b.lookupPath(J,{follow:!U});J=j.path}catch(i0){}var q={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};try{var j=b.lookupPath(J,{parent:!0});q.parentExists=!0,q.parentPath=j.path,q.parentObject=j.node,q.name=C1.basename(J),j=b.lookupPath(J,{follow:!U}),q.exists=!0,q.path=j.path,q.object=j.node,q.name=j.node.name,q.isRoot=j.path==="/"}catch(i0){q.error=i0.errno}return q},createPath(J,U,j,q){J=typeof J=="string"?J:b.getPath(J);for(var i0=U.split("/").reverse();i0.length;){var c=i0.pop();if(c){var _0=C1.join2(J,c);try{b.mkdir(_0)}catch(Z0){if(Z0.errno!=20)throw Z0}J=_0}}return _0},createFile(J,U,j,q,i0){var c=C1.join2(typeof J=="string"?J:b.getPath(J),U),_0=P3(q,i0);return b.create(c,_0)},createDataFile(J,U,j,q,i0,c){var _0=U;J&&(J=typeof J=="string"?J:b.getPath(J),_0=U?C1.join2(J,U):J);var Z0=P3(q,i0),B0=b.create(_0,Z0);if(j){if(typeof j=="string"){for(var K0=new Array(j.length),a0=0,m2=j.length;a0<m2;++a0)K0[a0]=j.charCodeAt(a0);j=K0}b.chmod(B0,Z0|146);var F2=b.open(B0,577);b.write(F2,j,0,j.length,0,c),b.close(F2),b.chmod(B0,Z0)}},createDevice(J,U,j,q){var Z0,B0;var i0=C1.join2(typeof J=="string"?J:b.getPath(J),U),c=P3(!!j,!!q);(B0=(Z0=b.createDevice).major)!=null||(Z0.major=64);var _0=b.makedev(b.createDevice.major++,0);return b.registerDevice(_0,{open(K0){K0.seekable=!1},close(K0){var a0;(a0=q==null?void 0:q.buffer)!=null&&a0.length&&q(10)},read(K0,a0,m2,F2,B2){for(var t2=0,U2=0;U2<F2;U2++){var r1;try{r1=j()}catch(D2){throw new b.ErrnoError(29)}if(r1===void 0&&t2===0)throw new b.ErrnoError(6);if(r1==null)break;t2++,a0[m2+U2]=r1}return t2&&(K0.node.atime=Date.now()),t2},write(K0,a0,m2,F2,B2){for(var t2=0;t2<F2;t2++)try{q(a0[m2+t2])}catch(U2){throw new b.ErrnoError(29)}return F2&&(K0.node.mtime=K0.node.ctime=Date.now()),t2}}),b.mkdev(i0,c,_0)},forceLoadFile(J){if(J.isDevice||J.isFolder||J.link||J.contents)return!0;if(typeof XMLHttpRequest!="undefined")throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");try{J.contents=Ji(J.url),J.usedBytes=J.contents.length}catch(U){throw new b.ErrnoError(29)}},createLazyFile(J,U,j,q,i0){class c{constructor(){h8(this,"lengthKnown",!1);h8(this,"chunks",[])}get(B2){if(!(B2>this.length-1||B2<0)){var t2=B2%this.chunkSize,U2=B2/this.chunkSize|0;return this.getter(U2)[t2]}}setDataGetter(B2){this.getter=B2}cacheLength(){var B2=new XMLHttpRequest;if(B2.open("HEAD",j,!1),B2.send(null),!(B2.status>=200&&B2.status<300||B2.status===304))throw new Error("Couldn\'t load "+j+". Status: "+B2.status);var t2=Number(B2.getResponseHeader("Content-length")),U2,r1=(U2=B2.getResponseHeader("Accept-Ranges"))&&U2==="bytes",D2=(U2=B2.getResponseHeader("Content-Encoding"))&&U2==="gzip",o0=1024*1024;r1||(o0=t2);var H=(N1,q4)=>{if(N1>q4)throw new Error("invalid range ("+N1+", "+q4+") or no bytes requested!");if(q4>t2-1)throw new Error("only "+t2+" bytes available! programmer error!");var z1=new XMLHttpRequest;if(z1.open("GET",j,!1),t2!==o0&&z1.setRequestHeader("Range","bytes="+N1+"-"+q4),z1.responseType="arraybuffer",z1.overrideMimeType&&z1.overrideMimeType("text/plain; charset=x-user-defined"),z1.send(null),!(z1.status>=200&&z1.status<300||z1.status===304))throw new Error("Couldn\'t load "+j+". Status: "+z1.status);return z1.response!==void 0?new Uint8Array(z1.response||[]):r7(z1.responseText||"",!0)},z=this;z.setDataGetter(N1=>{var q4=N1*o0,z1=(N1+1)*o0-1;if(z1=Math.min(z1,t2-1),typeof z.chunks[N1]=="undefined"&&(z.chunks[N1]=H(q4,z1)),typeof z.chunks[N1]=="undefined")throw new Error("doXHR failed!");return z.chunks[N1]}),(D2||!t2)&&(o0=t2=1,t2=this.getter(0).length,o0=t2,xe("LazyFiles on gzip forces download of the whole file when length is accessed")),this._length=t2,this._chunkSize=o0,this.lengthKnown=!0}get length(){return this.lengthKnown||this.cacheLength(),this._length}get chunkSize(){return this.lengthKnown||this.cacheLength(),this._chunkSize}}if(typeof XMLHttpRequest!="undefined"){if(!_8)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var _0=new c,Z0={isDevice:!1,contents:_0}}else var Z0={isDevice:!1,url:j};var B0=b.createFile(J,U,Z0,q,i0);Z0.contents?B0.contents=Z0.contents:Z0.url&&(B0.contents=null,B0.url=Z0.url),Object.defineProperties(B0,{usedBytes:{get:function(){return this.contents.length}}});var K0={},a0=Object.keys(B0.stream_ops);a0.forEach(F2=>{var B2=B0.stream_ops[F2];K0[F2]=(...t2)=>(b.forceLoadFile(B0),B2(...t2))});function m2(F2,B2,t2,U2,r1){var D2=F2.node.contents;if(r1>=D2.length)return 0;var o0=Math.min(D2.length-r1,U2);if(D2.slice)for(var H=0;H<o0;H++)B2[t2+H]=D2[r1+H];else for(var H=0;H<o0;H++)B2[t2+H]=D2.get(r1+H);return o0}return K0.read=(F2,B2,t2,U2,r1)=>(b.forceLoadFile(B0),m2(F2,B2,t2,U2,r1)),K0.mmap=(F2,B2,t2,U2,r1)=>{b.forceLoadFile(B0);var D2=f7(B2);if(!D2)throw new b.ErrnoError(48);return m2(F2,g4,D2,B2,t2),{ptr:D2,allocated:!0}},B0.stream_ops=K0,B0}},Q4={DEFAULT_POLLMASK:5,calculateAt(J,U,j){if(C1.isAbs(U))return U;var q;if(J===-100)q=b.cwd();else{var i0=Q4.getStreamFromFD(J);q=i0.path}if(U.length==0){if(!j)throw new b.ErrnoError(44);return q}return q+"/"+U},writeStat(J,U){J2[J>>2]=U.dev,J2[J+4>>2]=U.mode,A1[J+8>>2]=U.nlink,J2[J+12>>2]=U.uid,J2[J+16>>2]=U.gid,J2[J+20>>2]=U.rdev,u4=[U.size>>>0,(i1=U.size,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+24>>2]=u4[0],J2[J+28>>2]=u4[1],J2[J+32>>2]=4096,J2[J+36>>2]=U.blocks;var j=U.atime.getTime(),q=U.mtime.getTime(),i0=U.ctime.getTime();return u4=[Math.floor(j/1e3)>>>0,(i1=Math.floor(j/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+40>>2]=u4[0],J2[J+44>>2]=u4[1],A1[J+48>>2]=j%1e3*1e3*1e3,u4=[Math.floor(q/1e3)>>>0,(i1=Math.floor(q/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+56>>2]=u4[0],J2[J+60>>2]=u4[1],A1[J+64>>2]=q%1e3*1e3*1e3,u4=[Math.floor(i0/1e3)>>>0,(i1=Math.floor(i0/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+72>>2]=u4[0],J2[J+76>>2]=u4[1],A1[J+80>>2]=i0%1e3*1e3*1e3,u4=[U.ino>>>0,(i1=U.ino,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+88>>2]=u4[0],J2[J+92>>2]=u4[1],0},writeStatFs(J,U){J2[J+4>>2]=U.bsize,J2[J+40>>2]=U.bsize,J2[J+8>>2]=U.blocks,J2[J+12>>2]=U.bfree,J2[J+16>>2]=U.bavail,J2[J+20>>2]=U.files,J2[J+24>>2]=U.ffree,J2[J+28>>2]=U.fsid,J2[J+44>>2]=U.flags,J2[J+36>>2]=U.namelen},doMsync(J,U,j,q,i0){if(!b.isFile(U.node.mode))throw new b.ErrnoError(43);if(q&2)return 0;var c=p4.slice(J,J+j);b.msync(U,c,i0,j,q)},getStreamFromFD(J){var U=b.getStreamChecked(J);return U},varargs:void 0,getStr(J){var U=Hi(J);return U}};function Nw(J,U,j){Q4.varargs=j;try{var q=Q4.getStreamFromFD(J);switch(U){case 0:{var i0=je();if(i0<0)return-28;for(;b.streams[i0];)i0++;var c;return c=b.dupStream(q,i0),c.fd}case 1:case 2:return 0;case 3:return q.flags;case 4:{var i0=je();return q.flags|=i0,0}case 12:{var i0=O6(),_0=0;return Y8[i0+_0>>1]=2,0}case 13:case 14:return 0}return-28}catch(Z0){if(typeof b=="undefined"||Z0.name!=="ErrnoError")throw Z0;return-Z0.errno}}function Mw(J,U,j){Q4.varargs=j;try{var q=Q4.getStreamFromFD(J);switch(U){case 21509:return q.tty?0:-59;case 21505:{if(!q.tty)return-59;if(q.tty.ops.ioctl_tcgets){var i0=q.tty.ops.ioctl_tcgets(q),c=O6();J2[c>>2]=i0.c_iflag||0,J2[c+4>>2]=i0.c_oflag||0,J2[c+8>>2]=i0.c_cflag||0,J2[c+12>>2]=i0.c_lflag||0;for(var _0=0;_0<32;_0++)g4[c+_0+17]=i0.c_cc[_0]||0;return 0}return 0}case 21510:case 21511:case 21512:return q.tty?0:-59;case 21506:case 21507:case 21508:{if(!q.tty)return-59;if(q.tty.ops.ioctl_tcsets){for(var c=O6(),Z0=J2[c>>2],B0=J2[c+4>>2],K0=J2[c+8>>2],a0=J2[c+12>>2],m2=[],_0=0;_0<32;_0++)m2.push(g4[c+_0+17]);return q.tty.ops.ioctl_tcsets(q.tty,U,{c_iflag:Z0,c_oflag:B0,c_cflag:K0,c_lflag:a0,c_cc:m2})}return 0}case 21519:{if(!q.tty)return-59;var c=O6();return J2[c>>2]=0,0}case 21520:return q.tty?-28:-59;case 21531:{var c=O6();return b.ioctl(q,U,c)}case 21523:{if(!q.tty)return-59;if(q.tty.ops.ioctl_tiocgwinsz){var F2=q.tty.ops.ioctl_tiocgwinsz(q.tty),c=O6();Y8[c>>1]=F2[0],Y8[c+2>>1]=F2[1]}return 0}case 21524:return q.tty?0:-59;case 21515:return q.tty?0:-59;default:return-28}}catch(B2){if(typeof b=="undefined"||B2.name!=="ErrnoError")throw B2;return-B2.errno}}function Uw(J,U,j,q){Q4.varargs=q;try{U=Q4.getStr(U),U=Q4.calculateAt(J,U);var i0=q?je():0;return b.open(U,j,i0).fd}catch(c){if(typeof b=="undefined"||c.name!=="ErrnoError")throw c;return-c.errno}}function Dw(J,U,j){try{return U=Q4.getStr(U),U=Q4.calculateAt(J,U),j===0?b.unlink(U):j===512?b.rmdir(U):Se("Invalid flags passed to unlinkat"),0}catch(q){if(typeof b=="undefined"||q.name!=="ErrnoError")throw q;return-q.errno}}var Hw=()=>Se(""),Le={},q3=J=>{for(;J.length;){var U=J.pop(),j=J.pop();j(U)}};function xi(J){return this.fromWireType(A1[J>>2])}var P6={},X6={},Pe={},xw=P.InternalError=class extends Error{constructor(U){super(U),this.name="InternalError"}},qe=J=>{throw new xw(J)},K3=(J,U,j)=>{J.forEach(Z0=>Pe[Z0]=U);function q(Z0){var B0=j(Z0);B0.length!==J.length&&qe("Mismatched type converter count");for(var K0=0;K0<J.length;++K0)B8(J[K0],B0[K0])}var i0=new Array(U.length),c=[],_0=0;U.forEach((Z0,B0)=>{X6.hasOwnProperty(Z0)?i0[B0]=X6[Z0]:(c.push(Z0),P6.hasOwnProperty(Z0)||(P6[Z0]=[]),P6[Z0].push(()=>{i0[B0]=X6[Z0],++_0,_0===c.length&&q(i0)}))}),c.length===0&&q(i0)},zw=J=>{var U=Le[J];delete Le[J];var j=U.rawConstructor,q=U.rawDestructor,i0=U.fields,c=i0.map(_0=>_0.getterReturnType).concat(i0.map(_0=>_0.setterArgumentType));K3([J],c,_0=>{var Z0={};return i0.forEach((B0,K0)=>{var a0=B0.fieldName,m2=_0[K0],F2=_0[K0].optional,B2=B0.getter,t2=B0.getterContext,U2=_0[K0+i0.length],r1=B0.setter,D2=B0.setterContext;Z0[a0]={read:o0=>m2.fromWireType(B2(t2,o0)),write:(o0,H)=>{var z=[];r1(D2,o0,U2.toWireType(z,H)),q3(z)},optional:F2}}),[{name:U.name,fromWireType:B0=>{var K0={};for(var a0 in Z0)K0[a0]=Z0[a0].read(B0);return q(B0),K0},toWireType:(B0,K0)=>{for(var a0 in Z0)if(!(a0 in K0)&&!Z0[a0].optional)throw new TypeError(`Missing field: "${a0}"`);var m2=j();for(a0 in Z0)Z0[a0].write(m2,K0[a0]);return B0!==null&&B0.push(q,m2),m2},argPackAdvance:v8,readValueFromPointer:xi,destructorFunction:q}]})},Tw=(J,U,j,q,i0)=>{},Sw=()=>{for(var J=new Array(256),U=0;U<256;++U)J[U]=String.fromCharCode(U);k7=J},k7,I4=J=>{for(var U="",j=J;p4[j];)U+=k7[p4[j++]];return U},Ke=P.BindingError=class extends Error{constructor(U){super(U),this.name="BindingError"}},w1=J=>{throw new Ke(J)};function jw(J,U,j={}){var q=U.name;if(J||w1(`type "${q}" must have a positive integer typeid pointer`),X6.hasOwnProperty(J)){if(j.ignoreDuplicateRegistrations)return;w1(`Cannot register type \'${q}\' twice`)}if(X6[J]=U,delete Pe[J],P6.hasOwnProperty(J)){var i0=P6[J];delete P6[J],i0.forEach(c=>c())}}function B8(J,U,j={}){return jw(J,U,j)}var v8=8,Ow=(J,U,j,q)=>{U=I4(U),B8(J,{name:U,fromWireType:function(i0){return!!i0},toWireType:function(i0,c){return c?j:q},argPackAdvance:v8,readValueFromPointer:function(i0){return this.fromWireType(p4[i0])},destructorFunction:null})},Lw=J=>({count:J.count,deleteScheduled:J.deleteScheduled,preservePointerOnDelete:J.preservePointerOnDelete,ptr:J.ptr,ptrType:J.ptrType,smartPtr:J.smartPtr,smartPtrType:J.smartPtrType}),a3=J=>{function U(j){return j.$$.ptrType.registeredClass.name}w1(U(J)+" instance already deleted")},$3=!1,n7=J=>{},Pw=J=>{J.smartPtr?J.smartPtrType.rawDestructor(J.smartPtr):J.ptrType.registeredClass.rawDestructor(J.ptr)},t7=J=>{J.count.value-=1;var U=J.count.value===0;U&&Pw(J)},zi=J=>typeof FinalizationRegistry=="undefined"?(zi=U=>U,J):($3=new FinalizationRegistry(U=>{t7(U.$$)}),zi=U=>{var j=U.$$,q=!!j.smartPtr;if(q){var i0={$$:j};$3.register(U,i0,U)}return U},n7=U=>$3.unregister(U),zi(J)),ae=[],qw=()=>{for(;ae.length;){var J=ae.pop();J.$$.deleteScheduled=!1,J.delete()}},u7,Kw=()=>{let J=$e.prototype;Object.assign(J,{isAliasOf(j){if(!(this instanceof $e)||!(j instanceof $e))return!1;var q=this.$$.ptrType.registeredClass,i0=this.$$.ptr;j.$$=j.$$;for(var c=j.$$.ptrType.registeredClass,_0=j.$$.ptr;q.baseClass;)i0=q.upcast(i0),q=q.baseClass;for(;c.baseClass;)_0=c.upcast(_0),c=c.baseClass;return q===c&&i0===_0},clone(){if(this.$$.ptr||a3(this),this.$$.preservePointerOnDelete)return this.$$.count.value+=1,this;var j=zi(Object.create(Object.getPrototypeOf(this),{$$:{value:Lw(this.$$)}}));return j.$$.count.value+=1,j.$$.deleteScheduled=!1,j},delete(){this.$$.ptr||a3(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&w1("Object already scheduled for deletion"),n7(this),t7(this.$$),this.$$.preservePointerOnDelete||(this.$$.smartPtr=void 0,this.$$.ptr=void 0)},isDeleted(){return!this.$$.ptr},deleteLater(){return this.$$.ptr||a3(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&w1("Object already scheduled for deletion"),ae.push(this),ae.length===1&&u7&&u7(qw),this.$$.deleteScheduled=!0,this}});let U=Symbol.dispose;U&&(J[U]=J.delete)};function $e(){}var de=(J,U)=>Object.defineProperty(U,"name",{value:J}),o7={},aw=(J,U,j)=>{if(J[U].overloadTable===void 0){var q=J[U];J[U]=function(...i0){return J[U].overloadTable.hasOwnProperty(i0.length)||w1(`Function \'${j}\' called with an invalid number of arguments (${i0.length}) - expects one of (${J[U].overloadTable})!`),J[U].overloadTable[i0.length].apply(this,i0)},J[U].overloadTable=[],J[U].overloadTable[q.argCount]=q}},d3=(J,U,j)=>{P.hasOwnProperty(J)?((j===void 0||P[J].overloadTable!==void 0&&P[J].overloadTable[j]!==void 0)&&w1(`Cannot register public name \'${J}\' twice`),aw(P,J,J),P[J].overloadTable.hasOwnProperty(j)&&w1(`Cannot register multiple overloads of a function with the same number of arguments (${j})!`),P[J].overloadTable[j]=U):(P[J]=U,P[J].argCount=j)},$w=48,dw=57,cw=J=>{J=J.replace(/[^a-zA-Z0-9_]/g,"$");var U=J.charCodeAt(0);return U>=$w&&U<=dw?`_${J}`:J};function bw(J,U,j,q,i0,c,_0,Z0){this.name=J,this.constructor=U,this.instancePrototype=j,this.rawDestructor=q,this.baseClass=i0,this.getActualType=c,this.upcast=_0,this.downcast=Z0,this.pureVirtualFunctions=[]}var c3=(J,U,j)=>{for(;U!==j;)U.upcast||w1(`Expected null or instance of ${j.name}, got an instance of ${U.name}`),J=U.upcast(J),U=U.baseClass;return J};function ih(J,U){if(U===null)return this.isReference&&w1(`null is not a valid ${this.name}`),0;U.$$||w1(`Cannot pass "${embindRepr(U)}" as a ${this.name}`),U.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`);var j=U.$$.ptrType.registeredClass,q=c3(U.$$.ptr,j,this.registeredClass);return q}function eh(J,U){var j;if(U===null)return this.isReference&&w1(`null is not a valid ${this.name}`),this.isSmartPointer?(j=this.rawConstructor(),J!==null&&J.push(this.rawDestructor,j),j):0;(!U||!U.$$)&&w1(`Cannot pass "${embindRepr(U)}" as a ${this.name}`),U.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`),!this.isConst&&U.$$.ptrType.isConst&&w1(`Cannot convert argument of type ${U.$$.smartPtrType?U.$$.smartPtrType.name:U.$$.ptrType.name} to parameter type ${this.name}`);var q=U.$$.ptrType.registeredClass;if(j=c3(U.$$.ptr,q,this.registeredClass),this.isSmartPointer)switch(U.$$.smartPtr===void 0&&w1("Passing raw pointer to smart pointer is illegal"),this.sharingPolicy){case 0:U.$$.smartPtrType===this?j=U.$$.smartPtr:w1(`Cannot convert argument of type ${U.$$.smartPtrType?U.$$.smartPtrType.name:U.$$.ptrType.name} to parameter type ${this.name}`);break;case 1:j=U.$$.smartPtr;break;case 2:if(U.$$.smartPtrType===this)j=U.$$.smartPtr;else{var i0=U.clone();j=this.rawShare(j,P4.toHandle(()=>i0.delete())),J!==null&&J.push(this.rawDestructor,j)}break;default:w1("Unsupporting sharing policy")}return j}function rh(J,U){if(U===null)return this.isReference&&w1(`null is not a valid ${this.name}`),0;U.$$||w1(`Cannot pass "${embindRepr(U)}" as a ${this.name}`),U.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`),U.$$.ptrType.isConst&&w1(`Cannot convert argument of type ${U.$$.ptrType.name} to parameter type ${this.name}`);var j=U.$$.ptrType.registeredClass,q=c3(U.$$.ptr,j,this.registeredClass);return q}var l7=(J,U,j)=>{if(U===j)return J;if(j.baseClass===void 0)return null;var q=l7(J,U,j.baseClass);return q===null?null:j.downcast(q)},fh={},Ah=(J,U)=>{for(U===void 0&&w1("ptr should not be undefined");J.baseClass;)U=J.upcast(U),J=J.baseClass;return U},kh=(J,U)=>(U=Ah(J,U),fh[U]),ce=(J,U)=>{(!U.ptrType||!U.ptr)&&qe("makeClassHandle requires ptr and ptrType");var j=!!U.smartPtrType,q=!!U.smartPtr;return j!==q&&qe("Both smartPtrType and smartPtr must be specified"),U.count={value:1},zi(Object.create(J,{$$:{value:U,writable:!0}}))};function nh(J){var U=this.getPointee(J);if(!U)return this.destructor(J),null;var j=kh(this.registeredClass,U);if(j!==void 0){if(j.$$.count.value===0)return j.$$.ptr=U,j.$$.smartPtr=J,j.clone();var q=j.clone();return this.destructor(J),q}function i0(){return this.isSmartPointer?ce(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:U,smartPtrType:this,smartPtr:J}):ce(this.registeredClass.instancePrototype,{ptrType:this,ptr:J})}var c=this.registeredClass.getActualType(U),_0=o7[c];if(!_0)return i0.call(this);var Z0;this.isConst?Z0=_0.constPointerType:Z0=_0.pointerType;var B0=l7(U,this.registeredClass,Z0.registeredClass);return B0===null?i0.call(this):this.isSmartPointer?ce(Z0.registeredClass.instancePrototype,{ptrType:Z0,ptr:B0,smartPtrType:this,smartPtr:J}):ce(Z0.registeredClass.instancePrototype,{ptrType:Z0,ptr:B0})}var th=()=>{Object.assign(be.prototype,{getPointee(J){return this.rawGetPointee&&(J=this.rawGetPointee(J)),J},destructor(J){var U;(U=this.rawDestructor)==null||U.call(this,J)},argPackAdvance:v8,readValueFromPointer:xi,fromWireType:nh})};function be(J,U,j,q,i0,c,_0,Z0,B0,K0,a0){this.name=J,this.registeredClass=U,this.isReference=j,this.isConst=q,this.isSmartPointer=i0,this.pointeeType=c,this.sharingPolicy=_0,this.rawGetPointee=Z0,this.rawConstructor=B0,this.rawShare=K0,this.rawDestructor=a0,!i0&&U.baseClass===void 0?q?(this.toWireType=ih,this.destructorFunction=null):(this.toWireType=rh,this.destructorFunction=null):this.toWireType=eh}var s7=(J,U,j)=>{P.hasOwnProperty(J)||qe("Replacing nonexistent public symbol"),P[J].overloadTable!==void 0&&j!==void 0?P[J].overloadTable[j]=U:(P[J]=U,P[J].argCount=j)},w7=[],h7,_7=J=>{var U=w7[J];return U||(w7[J]=U=h7.get(J)),U},uh=(J,U,j=[],q=!1)=>{if(J.includes("j"))return dynCallLegacy(J,U,j);var i0=_7(U),c=i0(...j);return c},oh=(J,U,j=!1)=>(...q)=>uh(J,U,q,j),R8=(J,U,j=!1)=>{J=I4(J);function q(){if(J.includes("j"))return oh(J,U);var c=_7(U);return c}var i0=q();return typeof i0!="function"&&w1(`unknown function pointer with signature ${J}: ${U}`),i0};class lh extends Error{}var B7=J=>{var U=v_(J),j=I4(U);return e6(U),j},v7=(J,U)=>{var j=[],q={};function i0(c){if(!q[c]&&!X6[c]){if(Pe[c]){Pe[c].forEach(i0);return}j.push(c),q[c]=!0}}throw U.forEach(i0),new lh(`${J}: `+j.map(B7).join([", "]))},sh=(J,U,j,q,i0,c,_0,Z0,B0,K0,a0,m2,F2)=>{a0=I4(a0),c=R8(i0,c),Z0&&(Z0=R8(_0,Z0)),K0&&(K0=R8(B0,K0)),F2=R8(m2,F2);var B2=cw(a0);d3(B2,function(){v7(`Cannot construct ${a0} due to unbound types`,[q])}),K3([J,U,j],q?[q]:[],t2=>{var z1,h1;t2=t2[0];var U2,r1;q?(U2=t2.registeredClass,r1=U2.instancePrototype):r1=$e.prototype;var D2=de(a0,function(...X1){if(Object.getPrototypeOf(this)!==o0)throw new Ke(`Use \'new\' to construct ${a0}`);if(H.constructor_body===void 0)throw new Ke(`${a0} has no accessible constructor`);var u=H.constructor_body[X1.length];if(u===void 0)throw new Ke(`Tried to invoke ctor of ${a0} with invalid number of parameters (${X1.length}) - expected (${Object.keys(H.constructor_body).toString()}) parameters instead!`);return u.apply(this,X1)}),o0=Object.create(r1,{constructor:{value:D2}});D2.prototype=o0;var H=new bw(a0,D2,o0,F2,U2,c,Z0,K0);H.baseClass&&((h1=(z1=H.baseClass).__derivedClasses)!=null||(z1.__derivedClasses=[]),H.baseClass.__derivedClasses.push(H));var z=new be(a0,H,!0,!1,!1),N1=new be(a0+"*",H,!1,!1,!1),q4=new be(a0+" const*",H,!1,!0,!1);return o7[J]={pointerType:N1,constPointerType:q4},s7(B2,D2),[z,N1,q4]})},b3=[],J8=[],ef=J=>{J>9&&--J8[J+1]===0&&(J8[J]=void 0,b3.push(J))},wh=()=>J8.length/2-5-b3.length,hh=()=>{J8.push(0,1,void 0,1,null,1,!0,1,!1,1),P.count_emval_handles=wh},P4={toValue:J=>(J||w1(`Cannot use deleted val. handle = ${J}`),J8[J]),toHandle:J=>{switch(J){case void 0:return 2;case null:return 4;case!0:return 6;case!1:return 8;default:{let U=b3.pop()||J8.length;return J8[U]=J,J8[U+1]=1,U}}}},_h={name:"emscripten::val",fromWireType:J=>{var U=P4.toValue(J);return ef(J),U},toWireType:(J,U)=>P4.toHandle(U),argPackAdvance:v8,readValueFromPointer:xi,destructorFunction:null},Bh=J=>B8(J,_h),vh=(J,U,j)=>{switch(U){case 1:return j?function(q){return this.fromWireType(g4[q])}:function(q){return this.fromWireType(p4[q])};case 2:return j?function(q){return this.fromWireType(Y8[q>>1])}:function(q){return this.fromWireType(Mi[q>>1])};case 4:return j?function(q){return this.fromWireType(J2[q>>2])}:function(q){return this.fromWireType(A1[q>>2])};default:throw new TypeError(`invalid integer width (${U}): ${J}`)}},mh=(J,U,j,q)=>{U=I4(U);function i0(){}i0.values={},B8(J,{name:U,constructor:i0,fromWireType:function(c){return this.constructor.values[c]},toWireType:(c,_0)=>_0.value,argPackAdvance:v8,readValueFromPointer:vh(U,j,q),destructorFunction:null}),d3(U,i0)},rf=(J,U)=>{var j=X6[J];return j===void 0&&w1(`${U} has unknown type ${B7(J)}`),j},Zh=(J,U,j)=>{var q=rf(J,"enum");U=I4(U);var i0=q.constructor,c=Object.create(q.constructor.prototype,{value:{value:j},constructor:{value:de(`${q.name}_${U}`,function(){})}});i0.values[j]=c,i0[U]=c},Gh=(J,U)=>{switch(U){case 4:return function(j){return this.fromWireType(P5[j>>2])};case 8:return function(j){return this.fromWireType(q5[j>>3])};default:throw new TypeError(`invalid float width (${U}): ${J}`)}},Wh=(J,U,j)=>{U=I4(U),B8(J,{name:U,fromWireType:q=>q,toWireType:(q,i0)=>i0,argPackAdvance:v8,readValueFromPointer:Gh(U,j),destructorFunction:null})};function Xh(J){for(var U=1;U<J.length;++U)if(J[U]!==null&&J[U].destructorFunction===void 0)return!0;return!1}function gh(J,U,j,q,i0,c){var _0=U.length;_0<2&&w1("argTypes array size mismatch! Must at least get return value and \'this\' types!");var Z0=U[1]!==null&&j!==null,B0=Xh(U),K0=U[0].name!=="void",a0=_0-2,m2=new Array(a0),F2=[],B2=[],t2=function(...U2){B2.length=0;var r1;F2.length=Z0?2:1,F2[0]=i0,Z0&&(r1=U[1].toWireType(B2,this),F2[1]=r1);for(var D2=0;D2<a0;++D2)m2[D2]=U[D2+2].toWireType(B2,U2[D2]),F2.push(m2[D2]);var o0=q(...F2);function H(z){if(B0)q3(B2);else for(var N1=Z0?1:2;N1<U.length;N1++){var q4=N1===1?r1:m2[N1-2];U[N1].destructorFunction!==null&&U[N1].destructorFunction(q4)}if(K0)return U[0].fromWireType(z)}return H(o0)};return de(J,t2)}var Qh=(J,U)=>{for(var j=[],q=0;q<J;q++)j.push(A1[U+q*4>>2]);return j},Ih=J=>{J=J.trim();let U=J.indexOf("(");return U===-1?J:J.slice(0,U)},Ch=(J,U,j,q,i0,c,_0,Z0)=>{var B0=Qh(U,j);J=I4(J),J=Ih(J),i0=R8(q,i0,_0),d3(J,function(){v7(`Cannot call ${J} due to unbound types`,B0)},U-1),K3([],B0,K0=>{var a0=[K0[0],null].concat(K0.slice(1));return s7(J,gh(J,a0,null,i0,c,_0),U-1),[]})},Vh=(J,U,j)=>{switch(U){case 1:return j?q=>g4[q]:q=>p4[q];case 2:return j?q=>Y8[q>>1]:q=>Mi[q>>1];case 4:return j?q=>J2[q>>2]:q=>A1[q>>2];default:throw new TypeError(`invalid integer width (${U}): ${J}`)}},Fh=(J,U,j,q,i0)=>{U=I4(U),i0===-1&&(i0=4294967295);var c=a0=>a0;if(q===0){var _0=32-8*j;c=a0=>a0<<_0>>>_0}var Z0=U.includes("unsigned"),B0=(a0,m2)=>{},K0;Z0?K0=function(a0,m2){return B0(m2,this.name),m2>>>0}:K0=function(a0,m2){return B0(m2,this.name),m2},B8(J,{name:U,fromWireType:c,toWireType:K0,argPackAdvance:v8,readValueFromPointer:Vh(U,j,q!==0),destructorFunction:null})},Eh=(J,U,j)=>{var q=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array],i0=q[U];function c(_0){var Z0=A1[_0>>2],B0=A1[_0+4>>2];return new i0(g4.buffer,B0,Z0)}j=I4(j),B8(J,{name:j,fromWireType:c,argPackAdvance:v8,readValueFromPointer:c},{ignoreDuplicateRegistrations:!0})},q6=(J,U,j)=>L3(J,p4,U,j),ph=(J,U)=>{U=I4(U);var j=!0;B8(J,{name:U,fromWireType(q){var i0=A1[q>>2],c=q+4,_0;if(j)for(var Z0=c,B0=0;B0<=i0;++B0){var K0=c+B0;if(B0==i0||p4[K0]==0){var a0=K0-Z0,m2=Hi(Z0,a0);_0===void 0?_0=m2:(_0+="\\0",_0+=m2),Z0=K0+1}}else{for(var F2=new Array(i0),B0=0;B0<i0;++B0)F2[B0]=String.fromCharCode(p4[c+B0]);_0=F2.join("")}return e6(q),_0},toWireType(q,i0){i0 instanceof ArrayBuffer&&(i0=new Uint8Array(i0));var c,_0=typeof i0=="string";_0||ArrayBuffer.isView(i0)&&i0.BYTES_PER_ELEMENT==1||w1("Cannot pass non-string to std::string"),j&&_0?c=Oe(i0):c=i0.length;var Z0=G7(4+c+1),B0=Z0+4;if(A1[Z0>>2]=c,_0)if(j)q6(i0,B0,c+1);else for(var K0=0;K0<c;++K0){var a0=i0.charCodeAt(K0);a0>255&&(e6(Z0),w1("String has UTF-16 code units that do not fit in 8 bits")),p4[B0+K0]=a0}else p4.set(i0,B0);return q!==null&&q.push(e6,Z0),Z0},argPackAdvance:v8,readValueFromPointer:xi,destructorFunction(q){e6(q)}})},m7=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):void 0,yh=(J,U)=>{for(var j=J,q=j>>1,i0=q+U/2;!(q>=i0)&&Mi[q];)++q;if(j=q<<1,j-J>32&&m7)return m7.decode(p4.subarray(J,j));for(var c="",_0=0;!(_0>=U/2);++_0){var Z0=Y8[J+_0*2>>1];if(Z0==0)break;c+=String.fromCharCode(Z0)}return c},Yh=(J,U,j)=>{if(j!=null||(j=2147483647),j<2)return 0;j-=2;for(var q=U,i0=j<J.length*2?j/2:J.length,c=0;c<i0;++c){var _0=J.charCodeAt(c);Y8[U>>1]=_0,U+=2}return Y8[U>>1]=0,U-q},Rh=J=>J.length*2,Jh=(J,U)=>{for(var j=0,q="";!(j>=U/4);){var i0=J2[J+j*4>>2];if(i0==0)break;if(++j,i0>=65536){var c=i0-65536;q+=String.fromCharCode(55296|c>>10,56320|c&1023)}else q+=String.fromCharCode(i0)}return q},Nh=(J,U,j)=>{if(j!=null||(j=2147483647),j<4)return 0;for(var q=U,i0=q+j-4,c=0;c<J.length;++c){var _0=J.charCodeAt(c);if(_0>=55296&&_0<=57343){var Z0=J.charCodeAt(++c);_0=65536+((_0&1023)<<10)|Z0&1023}if(J2[U>>2]=_0,U+=4,U+4>i0)break}return J2[U>>2]=0,U-q},Mh=J=>{for(var U=0,j=0;j<J.length;++j){var q=J.charCodeAt(j);q>=55296&&q<=57343&&++j,U+=4}return U},Uh=(J,U,j)=>{j=I4(j);var q,i0,c,_0;U===2?(q=yh,i0=Yh,_0=Rh,c=Z0=>Mi[Z0>>1]):U===4&&(q=Jh,i0=Nh,_0=Mh,c=Z0=>A1[Z0>>2]),B8(J,{name:j,fromWireType:Z0=>{for(var B0=A1[Z0>>2],K0,a0=Z0+4,m2=0;m2<=B0;++m2){var F2=Z0+4+m2*U;if(m2==B0||c(F2)==0){var B2=F2-a0,t2=q(a0,B2);K0===void 0?K0=t2:(K0+="\\0",K0+=t2),a0=F2+U}}return e6(Z0),K0},toWireType:(Z0,B0)=>{typeof B0!="string"&&w1(`Cannot pass non-string to C++ string type ${j}`);var K0=_0(B0),a0=G7(4+K0+U);return A1[a0>>2]=K0/U,i0(B0,a0+4,K0+U),Z0!==null&&Z0.push(e6,a0),a0},argPackAdvance:v8,readValueFromPointer:xi,destructorFunction(Z0){e6(Z0)}})},Dh=(J,U,j,q,i0,c)=>{Le[J]={name:I4(U),rawConstructor:R8(j,q),rawDestructor:R8(i0,c),fields:[]}},Hh=(J,U,j,q,i0,c,_0,Z0,B0,K0)=>{Le[J].fields.push({fieldName:I4(U),getterReturnType:j,getter:R8(q,i0),getterContext:c,setterArgumentType:_0,setter:R8(Z0,B0),setterContext:K0})},xh=(J,U)=>{U=I4(U),B8(J,{isVoid:!0,name:U,argPackAdvance:0,fromWireType:()=>{},toWireType:(j,q)=>{}})},zh={},Z7=J=>{var U=zh[J];return U===void 0?I4(J):U},ff=[],Th=(J,U,j,q,i0)=>(J=ff[J],U=P4.toValue(U),j=Z7(j),J(U,U[j],q,i0)),Sh=J=>{var U=ff.length;return ff.push(J),U},jh=(J,U)=>{for(var j=new Array(J),q=0;q<J;++q)j[q]=rf(A1[U+q*4>>2],`parameter ${q}`);return j},Oh=(J,U,j)=>{var q=[],i0=J.toWireType(q,j);return q.length&&(A1[U>>2]=P4.toHandle(q)),i0},Lh=Reflect.construct,Ph=(J,U,j)=>{var q=jh(J,U),i0=q.shift();J--;var c=new Array(J),_0=(B0,K0,a0,m2)=>{for(var F2=0,B2=0;B2<J;++B2)c[B2]=q[B2].readValueFromPointer(m2+F2),F2+=q[B2].argPackAdvance;var t2=j===1?Lh(K0,c):K0.apply(B0,c);return Oh(i0,a0,t2)},Z0=`methodCaller<(${q.map(B0=>B0.name).join(", ")}) => ${i0.name}>`;return Sh(de(Z0,_0))},qh=J=>{J>9&&(J8[J+1]+=1)},Kh=()=>P4.toHandle([]),ah=J=>P4.toHandle(Z7(J)),$h=()=>P4.toHandle({}),dh=J=>{var U=P4.toValue(J);q3(U),ef(J)},ch=(J,U,j)=>{J=P4.toValue(J),U=P4.toValue(U),j=P4.toValue(j),J[U]=j},bh=(J,U)=>{J=rf(J,"_emval_take_value");var j=J.readValueFromPointer(U);return P4.toHandle(j)},i_=(J,U,j,q)=>{var i0=new Date().getFullYear(),c=new Date(i0,0,1),_0=new Date(i0,6,1),Z0=c.getTimezoneOffset(),B0=_0.getTimezoneOffset(),K0=Math.max(Z0,B0);A1[J>>2]=K0*60,J2[U>>2]=+(Z0!=B0);var a0=B2=>{var t2=B2>=0?"-":"+",U2=Math.abs(B2),r1=String(Math.floor(U2/60)).padStart(2,"0"),D2=String(U2%60).padStart(2,"0");return`UTC${t2}${r1}${D2}`},m2=a0(Z0),F2=a0(B0);B0<Z0?(q6(m2,j,17),q6(F2,q,17)):(q6(m2,q,17),q6(F2,j,17))},e_=()=>2147483648,r_=(J,U)=>Math.ceil(J/U)*U,f_=J=>{var U=Te.buffer,j=(J-U.byteLength+65535)/65536|0;try{return Te.grow(j),K5(),1}catch(q){}},A_=J=>{var U=p4.length;J>>>=0;var j=e_();if(J>j)return!1;for(var q=1;q<=4;q*=2){var i0=U*(1+.2/q);i0=Math.min(i0,J+100663296);var c=Math.min(j,r_(Math.max(J,i0),65536)),_0=f_(c);if(_0)return!0}return!1},Af={},k_=()=>x3||"./this.program",Ti=()=>{if(!Ti.strings){var J=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",U={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:J,_:k_()};for(var j in Af)Af[j]===void 0?delete U[j]:U[j]=Af[j];var q=[];for(var j in U)q.push(`${j}=${U[j]}`);Ti.strings=q}return Ti.strings},n_=(J,U)=>{var j=0,q=0;for(var i0 of Ti()){var c=U+j;A1[J+q>>2]=c,j+=q6(i0,c,1/0)+1,q+=4}return 0},t_=(J,U)=>{var j=Ti();A1[J>>2]=j.length;var q=0;for(var i0 of j)q+=Oe(i0)+1;return A1[U>>2]=q,0};function u_(J){try{var U=Q4.getStreamFromFD(J);return b.close(U),0}catch(j){if(typeof b=="undefined"||j.name!=="ErrnoError")throw j;return j.errno}}var o_=(J,U,j,q)=>{for(var i0=0,c=0;c<j;c++){var _0=A1[U>>2],Z0=A1[U+4>>2];U+=8;var B0=b.read(J,g4,_0,Z0,q);if(B0<0)return-1;if(i0+=B0,B0<Z0)break;typeof q!="undefined"&&(q+=B0)}return i0};function l_(J,U,j,q){try{var i0=Q4.getStreamFromFD(J),c=o_(i0,U,j);return A1[q>>2]=c,0}catch(_0){if(typeof b=="undefined"||_0.name!=="ErrnoError")throw _0;return _0.errno}}var s_=(J,U)=>U+2097152>>>0<4194305-!!J?(J>>>0)+U*4294967296:NaN;function w_(J,U,j,q,i0){var c=s_(U,j);try{if(isNaN(c))return 61;var _0=Q4.getStreamFromFD(J);return b.llseek(_0,c,q),u4=[_0.position>>>0,(i1=_0.position,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[i0>>2]=u4[0],J2[i0+4>>2]=u4[1],_0.getdents&&c===0&&q===0&&(_0.getdents=null),0}catch(Z0){if(typeof b=="undefined"||Z0.name!=="ErrnoError")throw Z0;return Z0.errno}}var h_=(J,U,j,q)=>{for(var i0=0,c=0;c<j;c++){var _0=A1[U>>2],Z0=A1[U+4>>2];U+=8;var B0=b.write(J,g4,_0,Z0,q);if(B0<0)return-1;if(i0+=B0,B0<Z0)break;typeof q!="undefined"&&(q+=B0)}return i0};function __(J,U,j,q){try{var i0=Q4.getStreamFromFD(J),c=h_(i0,U,j);return A1[q>>2]=c,0}catch(_0){if(typeof b=="undefined"||_0.name!=="ErrnoError")throw _0;return _0.errno}}b.createPreloadedFile=Rw,b.staticInit(),M2.doesNotExistError=new b.ErrnoError(44),M2.doesNotExistError.stack="<generic error, no stack>",Sw(),Kw(),th(),hh(),P.noExitRuntime&&(gw=P.noExitRuntime),P.preloadPlugins&&(A7=P.preloadPlugins),P.print&&(xe=P.print),P.printErr&&(Ni=P.printErr),P.wasmBinary&&(ze=P.wasmBinary),P.arguments&&(O5=P.arguments),P.thisProgram&&(x3=P.thisProgram);var B_={b:Qw,k:Vw,r:Nw,A:Mw,E:Uw,D:Dw,B:Hw,v:zw,y:Tw,J:Ow,o:sh,H:Bh,j:mh,a:Zh,u:Wh,d:Ch,i:Fh,f:Eh,I:ph,q:Uh,w:Dh,n:Hh,K:xh,M:Th,c:ef,N:Ph,O:qh,m:Kh,h:ah,l:$h,L:dh,g:ch,e:bh,z:i_,C:A_,F:n_,G:t_,s:u_,t:l_,x:w_,p:__},d=Gw(),LP=d.Q,PP=P._heif_nclx_color_profile_alloc=d.S,qP=P._heif_nclx_color_profile_free=d.T,KP=P._heif_tai_timestamp_packet_alloc=d.U,aP=P._heif_tai_timestamp_packet_copy=d.V,$P=P._heif_tai_timestamp_packet_release=d.W,dP=P._heif_color_conversion_options_set_defaults=d.X,cP=P._heif_nclx_color_profile_set_color_primaries=d.Y,bP=P._heif_nclx_color_profile_set_transfer_characteristics=d.Z,iq=P._heif_nclx_color_profile_set_matrix_coefficients=d._,eq=P._heif_init=d.$,rq=P._heif_deinit=d.aa,fq=P._heif_load_plugin=d.ba,Aq=P._heif_unload_plugin=d.ca,kq=P._heif_load_plugins=d.da,nq=P._heif_get_plugin_directories=d.ea,tq=P._heif_free_plugin_directories=d.fa,uq=P._heif_get_version_number=d.ga,oq=P._heif_context_alloc=d.ha,lq=P._heif_context_free=d.ia,sq=P._heif_context_get_number_of_top_level_images=d.ja,wq=P._heif_image_handle_release=d.ka,hq=P._heif_image_handle_get_width=d.la,_q=P._heif_image_handle_get_height=d.ma,Bq=P._heif_image_handle_is_primary_image=d.na,vq=P._heif_image_release=d.oa,mq=P._heif_image_handle_has_alpha_channel=d.pa,Zq=P._heif_image_handle_is_premultiplied_alpha=d.qa,Gq=P._heif_context_get_number_of_items=d.ra,Wq=P._heif_item_is_item_hidden=d.sa,Xq=P._heif_get_version=d.ta,gq=P._heif_context_read_from_memory=d.ua,Qq=P._heif_check_filetype=d.va,Iq=P._heif_context_get_list_of_top_level_image_IDs=d.wa,e6=P._free=d.xa,Cq=P._heif_context_get_image_handle=d.ya,Vq=P._heif_context_get_primary_image_handle=d.za,Fq=P._heif_decode_image=d.Aa,Eq=P._heif_image_get_chroma_format=d.Ba,pq=P._heif_image_get_colorspace=d.Ca,yq=P._heif_image_has_channel=d.Da,Yq=P._heif_image_get_plane_readonly2=d.Ea,Rq=P._heif_image_get_width=d.Fa,Jq=P._heif_image_get_height=d.Ga,Nq=P._heif_image_get_bits_per_pixel_range=d.Ha,Mq=P._heif_context_get_list_of_item_IDs=d.Ia,Uq=P._heif_item_get_item_type=d.Ja,G7=P._malloc=d.Ka,Dq=P._heif_item_get_mime_item_content_type=d.La,Hq=P._heif_item_get_mime_item_content_encoding=d.Ma,xq=P._heif_item_get_uri_item_uri_type=d.Na,zq=P._heif_item_get_item_name=d.Oa,Tq=P._heif_get_version_number_major=d.Pa,Sq=P._heif_get_version_number_minor=d.Qa,jq=P._heif_get_version_number_maintenance=d.Ra,Oq=P._heif_register_decoder_plugin=d.Sa,Lq=P._heif_register_encoder_plugin=d.Ta,Pq=P._heif_string_release=d.Ua,qq=P._heif_register_decoder=d.Va,Kq=P._heif_image_get_primary_width=d.Wa,aq=P._heif_image_get_primary_height=d.Xa,$q=P._heif_image_crop=d.Ya,dq=P._heif_image_extract_area=d.Za,cq=P._heif_image_get_bits_per_pixel=d._a,bq=P._heif_image_get_plane_readonly=d.$a,iK=P._heif_image_get_plane=d.ab,eK=P._heif_image_get_plane2=d.bb,rK=P._heif_image_scale_image=d.cb,fK=P._heif_image_extend_to_size_fill_with_zero=d.db,AK=P._heif_image_get_decoding_warnings=d.eb,kK=P._heif_image_add_decoding_warning=d.fb,nK=P._heif_image_get_pixel_aspect_ratio=d.gb,tK=P._heif_image_set_pixel_aspect_ratio=d.hb,uK=P._heif_image_handle_set_pixel_aspect_ratio=d.ib,oK=P._heif_image_create=d.jb,lK=P._heif_image_add_plane=d.kb,sK=P._heif_image_add_plane_safe=d.lb,wK=P._heif_image_set_premultiplied_alpha=d.mb,hK=P._heif_image_is_premultiplied_alpha=d.nb,_K=P._heif_image_extend_padding_to_size=d.ob,BK=P._heif_color_conversion_options_ext_alloc=d.pb,vK=P._heif_color_conversion_options_ext_copy=d.qb,mK=P._heif_color_conversion_options_ext_free=d.rb,ZK=P._heif_image_handle_get_color_profile_type=d.sb,GK=P._heif_image_handle_get_raw_color_profile_size=d.tb,WK=P._heif_image_handle_get_raw_color_profile=d.ub,XK=P._heif_image_handle_get_nclx_color_profile=d.vb,gK=P._heif_image_get_color_profile_type=d.wb,QK=P._heif_image_get_raw_color_profile_size=d.xb,IK=P._heif_image_get_raw_color_profile=d.yb,CK=P._heif_image_get_nclx_color_profile=d.zb,VK=P._heif_image_set_raw_color_profile=d.Ab,FK=P._heif_image_set_nclx_color_profile=d.Bb,EK=P._heif_image_has_content_light_level=d.Cb,pK=P._heif_image_get_content_light_level=d.Db,yK=P._heif_image_handle_get_content_light_level=d.Eb,YK=P._heif_image_set_content_light_level=d.Fb,RK=P._heif_image_handle_set_content_light_level=d.Gb,JK=P._heif_image_has_mastering_display_colour_volume=d.Hb,NK=P._heif_image_get_mastering_display_colour_volume=d.Ib,MK=P._heif_image_handle_get_mastering_display_colour_volume=d.Jb,UK=P._heif_image_set_mastering_display_colour_volume=d.Kb,DK=P._heif_image_handle_set_mastering_display_colour_volume=d.Lb,HK=P._heif_mastering_display_colour_volume_decode=d.Mb,xK=P._heif_image_handle_get_number_of_region_items=d.Nb,zK=P._heif_image_handle_get_list_of_region_item_ids=d.Ob,TK=P._heif_context_get_region_item=d.Pb,SK=P._heif_region_item_get_id=d.Qb,jK=P._heif_region_item_release=d.Rb,OK=P._heif_region_item_get_reference_size=d.Sb,LK=P._heif_region_item_get_number_of_regions=d.Tb,PK=P._heif_region_item_get_list_of_regions=d.Ub,qK=P._heif_region_release=d.Vb,KK=P._heif_region_release_many=d.Wb,aK=P._heif_region_get_type=d.Xb,$K=P._heif_region_get_point=d.Yb,dK=P._heif_region_get_point_transformed=d.Zb,cK=P._heif_region_get_rectangle=d._b,bK=P._heif_region_get_rectangle_transformed=d.$b,ia=P._heif_region_get_ellipse=d.ac,ea=P._heif_region_get_ellipse_transformed=d.bc,ra=P._heif_region_get_polygon_num_points=d.cc,fa=P._heif_region_get_polygon_points=d.dc,Aa=P._heif_region_get_polygon_points_transformed=d.ec,ka=P._heif_region_get_polyline_num_points=d.fc,na=P._heif_region_get_polyline_points=d.gc,ta=P._heif_region_get_polyline_points_transformed=d.hc,ua=P._heif_region_get_referenced_mask_ID=d.ic,oa=P._heif_region_get_inline_mask_data_len=d.jc,la=P._heif_region_item_add_region_inline_mask_data=d.kc,sa=P._heif_region_get_mask_image=d.lc,wa=P._heif_image_handle_add_region_item=d.mc,ha=P._heif_region_item_add_region_point=d.nc,_a=P._heif_region_item_add_region_rectangle=d.oc,Ba=P._heif_region_item_add_region_ellipse=d.pc,va=P._heif_region_item_add_region_polygon=d.qc,ma=P._heif_region_item_add_region_polyline=d.rc,Za=P._heif_region_item_add_region_referenced_mask=d.sc,Ga=P._heif_region_get_inline_mask_data=d.tc,Wa=P._heif_region_item_add_region_inline_mask=d.uc,Xa=P._heif_item_get_properties_of_type=d.vc,ga=P._heif_item_get_transformation_properties=d.wc,Qa=P._heif_item_get_property_type=d.xc,Ia=P._heif_item_get_property_user_description=d.yc,Ca=P._heif_item_add_property_user_description=d.zc,Va=P._heif_property_user_description_release=d.Ac,Fa=P._heif_item_get_property_transform_mirror=d.Bc,Ea=P._heif_item_get_property_transform_rotation_ccw=d.Cc,pa=P._heif_item_get_property_transform_crop_borders=d.Dc,ya=P._heif_item_add_raw_property=d.Ec,Ya=P._heif_item_get_property_raw_size=d.Fc,Ra=P._heif_item_get_property_raw_data=d.Gc,Ja=P._heif_item_get_property_uuid_type=d.Hc,Na=P._heif_image_handle_has_camera_intrinsic_matrix=d.Ic,Ma=P._heif_image_handle_get_camera_intrinsic_matrix=d.Jc,Ua=P._heif_image_handle_has_camera_extrinsic_matrix=d.Kc,Da=P._heif_image_handle_get_camera_extrinsic_matrix=d.Lc,Ha=P._heif_camera_extrinsic_matrix_release=d.Mc,xa=P._heif_camera_extrinsic_matrix_get_rotation_matrix=d.Nc,za=P._heif_item_set_item_name=d.Oc,Ta=P._heif_item_get_item_data=d.Pc,Sa=P._heif_release_item_data=d.Qc,ja=P._heif_item_get_property_extended_language=d.Rc,Oa=P._heif_item_set_property_extended_language=d.Sc,La=P._heif_context_get_item_references=d.Tc,Pa=P._heif_release_item_references=d.Uc,qa=P._heif_context_add_item_reference=d.Vc,Ka=P._heif_context_add_item_references=d.Wc,aa=P._heif_context_add_item=d.Xc,$a=P._heif_context_add_mime_item=d.Yc,da=P._heif_context_add_precompressed_mime_item=d.Zc,ca=P._heif_context_add_uri_item=d._c,ba=P._heif_context_has_sequence=d.$c,i$=P._heif_context_get_sequence_timescale=d.ad,e$=P._heif_context_get_sequence_duration=d.bd,r$=P._heif_track_release=d.cd,f$=P._heif_context_number_of_sequence_tracks=d.dd,A$=P._heif_context_get_track_ids=d.ed,k$=P._heif_track_get_id=d.fd,n$=P._heif_context_get_track=d.gd,t$=P._heif_track_get_track_handler_type=d.hd,u$=P._heif_track_get_auxiliary_info_type=d.id,o$=P._heif_track_get_auxiliary_info_type_urn=d.jd,l$=P._heif_track_has_alpha_channel=d.kd,s$=P._heif_track_get_timescale=d.ld,w$=P._heif_track_get_image_resolution=d.md,h$=P._heif_track_decode_next_image=d.nd,_$=P._heif_decoding_options_alloc=d.od,B$=P._heif_decoding_options_copy=d.pd,v$=P._heif_decoding_options_free=d.qd,m$=P._heif_image_get_duration=d.rd,Z$=P._heif_track_get_sample_entry_type_of_first_cluster=d.sd,G$=P._heif_track_get_urim_sample_entry_uri_of_first_cluster=d.td,W$=P._heif_track_get_next_raw_sequence_sample=d.ud,X$=P._heif_raw_sequence_sample_release=d.vd,g$=P._heif_raw_sequence_sample_get_data=d.wd,Q$=P._heif_raw_sequence_sample_get_data_size=d.xd,I$=P._heif_raw_sequence_sample_get_duration=d.yd,C$=P._heif_context_set_sequence_timescale=d.zd,V$=P._heif_context_set_number_of_sequence_repetitions=d.Ad,F$=P._heif_track_options_alloc=d.Bd,E$=P._heif_track_options_release=d.Cd,p$=P._heif_tai_clock_info_release=d.Dd,y$=P._heif_track_options_set_timescale=d.Ed,Y$=P._heif_track_options_set_interleaved_sample_aux_infos=d.Fd,R$=P._heif_track_options_enable_sample_tai_timestamps=d.Gd,J$=P._heif_tai_clock_info_alloc=d.Hd,N$=P._heif_tai_clock_info_copy=d.Id,M$=P._heif_track_options_enable_sample_gimi_content_ids=d.Jd,U$=P._heif_track_options_set_gimi_track_id=d.Kd,D$=P._heif_sequence_encoding_options_alloc=d.Ld,H$=P._heif_sequence_encoding_options_release=d.Md,x$=P._heif_context_add_visual_sequence_track=d.Nd,z$=P._heif_image_set_duration=d.Od,T$=P._heif_track_encode_end_of_sequence=d.Pd,S$=P._heif_track_encode_sequence_image=d.Qd,j$=P._heif_context_add_uri_metadata_sequence_track=d.Rd,O$=P._heif_raw_sequence_sample_alloc=d.Sd,L$=P._heif_raw_sequence_sample_set_data=d.Td,P$=P._heif_raw_sequence_sample_set_duration=d.Ud,q$=P._heif_track_add_raw_sequence_sample=d.Vd,K$=P._heif_track_get_number_of_sample_aux_infos=d.Wd,a$=P._heif_track_get_sample_aux_info_types=d.Xd,$$=P._heif_track_get_gimi_track_content_id=d.Yd,d$=P._heif_image_get_gimi_sample_content_id=d.Zd,c$=P._heif_raw_sequence_sample_get_gimi_sample_content_id=d._d,b$=P._heif_image_set_gimi_sample_content_id=d.$d,id=P._heif_raw_sequence_sample_set_gimi_sample_content_id=d.ae,ed=P._heif_raw_sequence_sample_has_tai_timestamp=d.be,rd=P._heif_raw_sequence_sample_get_tai_timestamp=d.ce,fd=P._heif_raw_sequence_sample_set_tai_timestamp=d.de,Ad=P._heif_track_get_tai_clock_info_of_first_cluster=d.ee,kd=P._heif_track_add_reference_to_track=d.fe,nd=P._heif_track_get_number_of_track_reference_types=d.ge,td=P._heif_track_get_track_reference_types=d.he,ud=P._heif_track_get_number_of_track_reference_of_type=d.ie,od=P._heif_track_get_references_from_track=d.je,ld=P._heif_track_find_referring_tracks=d.ke,sd=P._heif_item_set_property_tai_clock_info=d.le,wd=P._heif_item_get_property_tai_clock_info=d.me,hd=P._heif_item_set_property_tai_timestamp=d.ne,_d=P._heif_item_get_property_tai_timestamp=d.oe,Bd=P._heif_image_set_tai_timestamp=d.pe,vd=P._heif_image_get_tai_timestamp=d.qe,md=P._heif_read_main_brand=d.re,Zd=P._heif_fourcc_to_brand=d.se,Gd=P._heif_read_minor_version_brand=d.te,Wd=P._heif_brand_to_fourcc=d.ue,Xd=P._heif_has_compatible_brand=d.ve,gd=P._heif_get_global_security_limits=d.we,Qd=P._heif_list_compatible_brands=d.xe,Id=P._heif_free_list_of_compatible_brands=d.ye,Cd=P._heif_get_file_mime_type=d.ze,Vd=P._heif_has_compatible_filetype=d.Ae,Fd=P._heif_check_jpeg_filetype=d.Be,Ed=P._heif_main_brand=d.Ce,pd=P._heif_metadata_compression_method_supported=d.De,yd=P._heif_image_handle_get_number_of_metadata_blocks=d.Ee,Yd=P._heif_image_handle_get_list_of_metadata_block_IDs=d.Fe,Rd=P._heif_image_handle_get_metadata_type=d.Ge,Jd=P._heif_image_handle_get_metadata_content_type=d.He,Nd=P._heif_image_handle_get_metadata_size=d.Ie,Md=P._heif_image_handle_get_metadata=d.Je,Ud=P._heif_image_handle_get_metadata_item_uri_type=d.Ke,Dd=P._heif_context_add_exif_metadata=d.Le,Hd=P._heif_context_add_XMP_metadata=d.Me,xd=P._heif_context_add_XMP_metadata2=d.Ne,zd=P._heif_context_add_generic_metadata=d.Oe,Td=P._heif_context_add_generic_uri_metadata=d.Pe,Sd=P._heif_image_handle_has_depth_image=d.Qe,jd=P._heif_image_handle_get_number_of_depth_images=d.Re,Od=P._heif_image_handle_get_list_of_depth_image_IDs=d.Se,Ld=P._heif_image_handle_get_depth_image_handle=d.Te,Pd=P._heif_depth_representation_info_free=d.Ue,qd=P._heif_image_handle_get_depth_image_representation_info=d.Ve,Kd=P._heif_image_handle_get_number_of_thumbnails=d.We,ad=P._heif_image_handle_get_list_of_thumbnail_IDs=d.Xe,$d=P._heif_image_handle_get_thumbnail=d.Ye,dd=P._heif_context_encode_thumbnail=d.Ze,cd=P._heif_encoding_options_alloc=d._e,bd=P._heif_encoding_options_copy=d.$e,ic=P._heif_encoding_options_free=d.af,ec=P._heif_context_assign_thumbnail=d.bf,rc=P._heif_image_handle_get_number_of_auxiliary_images=d.cf,fc=P._heif_image_handle_get_list_of_auxiliary_image_IDs=d.df,Ac=P._heif_image_handle_get_auxiliary_type=d.ef,kc=P._heif_image_handle_release_auxiliary_type=d.ff,nc=P._heif_image_handle_get_auxiliary_image_handle=d.gf,tc=P._heif_image_handle_free_auxiliary_types=d.hf,uc=P._heif_context_get_entity_groups=d.jf,oc=P._heif_entity_groups_release=d.kf,lc=P._heif_get_disabled_security_limits=d.lf,sc=P._heif_context_get_security_limits=d.mf,wc=P._heif_context_set_security_limits=d.nf,hc=P._heif_context_set_maximum_image_size_limit=d.of,_c=P._heif_have_encoder_for_format=d.pf,Bc=P._heif_get_encoder_descriptors=d.qf,vc=P._heif_encoder_descriptor_get_name=d.rf,mc=P._heif_encoder_descriptor_get_id_name=d.sf,Zc=P._heif_encoder_descriptor_get_compression_format=d.tf,Gc=P._heif_encoder_descriptor_supports_lossy_compression=d.uf,Wc=P._heif_encoder_descriptor_supports_lossless_compression=d.vf,Xc=P._heif_context_get_encoder=d.wf,gc=P._heif_context_get_encoder_for_format=d.xf,Qc=P._heif_encoder_release=d.yf,Ic=P._heif_encoder_get_name=d.zf,Cc=P._heif_encoder_set_lossy_quality=d.Af,Vc=P._heif_encoder_set_lossless=d.Bf,Fc=P._heif_encoder_set_logging_level=d.Cf,Ec=P._heif_encoder_list_parameters=d.Df,pc=P._heif_encoder_parameter_get_name=d.Ef,yc=P._heif_encoder_parameter_get_type=d.Ff,Yc=P._heif_encoder_parameter_get_valid_integer_range=d.Gf,Rc=P._heif_encoder_parameter_get_valid_integer_values=d.Hf,Jc=P._heif_encoder_parameter_get_valid_string_values=d.If,Nc=P._heif_encoder_set_parameter_integer=d.Jf,Mc=P._heif_encoder_get_parameter_integer=d.Kf,Uc=P._heif_encoder_parameter_integer_valid_range=d.Lf,Dc=P._heif_encoder_set_parameter_boolean=d.Mf,Hc=P._heif_encoder_get_parameter_boolean=d.Nf,xc=P._heif_encoder_set_parameter_string=d.Of,zc=P._heif_encoder_get_parameter_string=d.Pf,Tc=P._heif_encoder_parameter_string_valid_values=d.Qf,Sc=P._heif_encoder_parameter_integer_valid_values=d.Rf,jc=P._heif_encoder_set_parameter=d.Sf,Oc=P._heif_encoder_get_parameter=d.Tf,Lc=P._heif_encoder_has_default=d.Uf,Pc=P._heif_context_encode_image=d.Vf,qc=P._heif_context_add_overlay_image=d.Wf,Kc=P._heif_context_set_primary_image=d.Xf,ac=P._heif_context_set_major_brand=d.Yf,$c=P._heif_context_add_compatible_brand=d.Zf,dc=P._heif_encoder_descriptor_supportes_lossy_compression=d._f,cc=P._heif_encoder_descriptor_supportes_lossless_compression=d.$f,bc=P._heif_context_get_encoder_descriptors=d.ag,ib=P._heif_context_set_max_decoding_threads=d.bg,eb=P._heif_have_decoder_for_format=d.cg,rb=P._heif_get_decoder_descriptors=d.dg,fb=P._heif_decoder_descriptor_get_name=d.eg,Ab=P._heif_decoder_descriptor_get_id_name=d.fg,kb=P._heif_image_handle_get_item_id=d.gg,nb=P._heif_image_handle_get_luma_bits_per_pixel=d.hg,tb=P._heif_image_handle_get_chroma_bits_per_pixel=d.ig,ub=P._heif_image_handle_get_preferred_decoding_colorspace=d.jg,ob=P._heif_image_handle_get_ispe_width=d.kg,lb=P._heif_image_handle_get_ispe_height=d.lg,sb=P._heif_image_handle_get_pixel_aspect_ratio=d.mg,wb=P._heif_image_handle_get_context=d.ng,hb=P._heif_image_handle_get_gimi_content_id=d.og,_b=P._heif_context_read_from_file=d.pg,Bb=P._heif_context_read_from_memory_without_copy=d.qg,vb=P._heif_context_read_from_reader=d.rg,mb=P._heif_context_is_top_level_image_ID=d.sg,Zb=P._heif_context_get_primary_image_ID=d.tg,Gb=P._heif_context_debug_dump_boxes_to_file=d.ug,Wb=P._heif_context_write_to_file=d.vg,Xb=P._heif_context_write=d.wg,gb=P._heif_image_handle_get_image_tiling=d.xg,Qb=P._heif_image_handle_get_grid_image_tile_id=d.yg,Ib=P._heif_image_handle_decode_image_tile=d.zg,Cb=P._heif_context_encode_grid=d.Ag,Vb=P._heif_context_add_grid_image=d.Bg,Fb=P._heif_context_add_image_tile=d.Cg,Eb=P._heif_unci_image_parameters_alloc=d.Dg,pb=P._heif_unci_image_parameters_copy=d.Eg,yb=P._heif_unci_image_parameters_release=d.Fg,Yb=P._heif_context_add_empty_unci_image=d.Gg,Rb=P._heif_image_handle_add_text_item=d.Hg,Jb=P._heif_text_item_release=d.Ig,Nb=P._heif_image_handle_get_number_of_text_items=d.Jg,Mb=P._heif_image_handle_get_list_of_text_item_ids=d.Kg,Ub=P._heif_context_get_text_item=d.Lg,Db=P._heif_text_item_get_id=d.Mg,Hb=P._heif_text_item_get_content=d.Ng,xb=P._heif_text_item_get_property_extended_language=d.Og,zb=P._heif_text_item_set_extended_language=d.Pg,Tb=P._de265_new_decoder=d.Qg,Sb=P._de265_set_parameter_bool=d.Rg,jb=P._de265_get_version=d.Sg,Ob=P._de265_init=d.Tg,Lb=P._de265_free=d.Ug,Pb=P._de265_free_decoder=d.Vg,qb=P._de265_push_NAL=d.Wg,Kb=P._de265_flush_data=d.Xg,ab=P._de265_decode=d.Yg,$b=P._de265_get_next_picture=d.Zg,db=P._de265_get_image_user_data=d._g,cb=P._de265_get_chroma_format=d.$g,bb=P._de265_get_image_width=d.ah,i00=P._de265_get_image_height=d.bh,e00=P._de265_get_bits_per_pixel=d.ch,r00=P._de265_get_image_plane=d.dh,f00=P._de265_get_image_colour_primaries=d.eh,A00=P._de265_get_image_transfer_characteristics=d.fh,k00=P._de265_get_image_matrix_coefficients=d.gh,n00=P._de265_get_image_full_range_flag=d.hh,t00=P._de265_release_next_picture=d.ih,v_=d.jh,u00=P._memcpy=d.kh,o00=P.dynCall_ji=d.lh,l00=P.dynCall_iij=d.mh,s00=P.dynCall_jijj=d.nh,w00=P.dynCall_vijj=d.oh,h00=P.dynCall_jiji=d.ph,_00=P.dynCall_viijii=d.qh,B00=P.dynCall_iiiiij=d.rh,v00=P.dynCall_iiiiijj=d.sh,m00=P.dynCall_iiiiiijj=d.th,Z00=P._heif_error_null_pointer_argument=94324,G00=P._heif_error_success=96272,W00=P._heif_error_ok=96700,X00=P._heif_error_invalid_parameter_value=96724,g00=P._heif_error_unsupported_parameter=96712;function kf(){if(W6>0){Ui=kf;return}if(ww(),W6>0){Ui=kf;return}function J(){var U;P.calledRun=!0,!L5&&(hw(),m6(P),(U=P.onRuntimeInitialized)==null||U.call(P),_w())}P.setStatus?(P.setStatus("Running..."),setTimeout(()=>{setTimeout(()=>P.setStatus(""),1),J()},1)):J()}function m_(){if(P.preInit)for(typeof P.preInit=="function"&&(P.preInit=[P.preInit]);P.preInit.length>0;)P.preInit.shift()()}m_(),kf();function W7(J){for(var U=new ArrayBuffer(J.length),j=new Uint8Array(U),q=0,i0=J.length;q<i0;q++)j[q]=J.charCodeAt(q);return U}var m8=function(J){this.handle=J,this.img=null};m8.prototype.free=function(){this.handle&&(P.heif_image_handle_release(this.handle),this.handle=null)},m8.prototype._ensureImage=function(){if(!this.img){var J=P.heif_js_decode_image(this.handle,P.heif_colorspace.heif_colorspace_YCbCr,P.heif_chroma.heif_chroma_420);if(!J||J.code){console.log("Decoding image failed",this.handle,J);return}this.data=new Uint8Array(W7(J.data)),delete J.data,this.img=J,J.alpha!==void 0&&(this.alpha=new Uint8Array(W7(J.alpha)),delete J.alpha)}},m8.prototype.get_width=function(){return P.heif_image_handle_get_width(this.handle)},m8.prototype.get_height=function(){return P.heif_image_handle_get_height(this.handle)},m8.prototype.is_primary=function(){return!!P.heif_image_handle_is_primary_image(this.handle)},m8.prototype.has_alpha_channel=function(){return!!P.heif_image_handle_has_alpha_channel(this.handle)},m8.prototype.is_premultiplied_alpha=function(){return!!P.heif_image_handle_is_premultiplied_alpha(this.handle)},m8.prototype.display=function(J,U){var j=this.get_width(),q=this.get_height();setTimeout(function(){return v6(this,null,function*(){if(!this.img){var i0=yield P.heif_js_decode_image2(this.handle,P.heif_colorspace.heif_colorspace_RGB,P.heif_chroma.heif_chroma_interleaved_RGBA);if(!i0||i0.code){console.log("Decoding image failed",this.handle,i0),U(null);return}for(let c of i0.channels)if(c.id==P.heif_channel.heif_channel_interleaved)if(c.stride==c.width*4)J.data.set(c.data);else for(let _0=0;_0<c.height;_0++){let Z0=c.data.slice(_0*c.stride,_0*c.stride+c.width*4),B0=_0*c.width*4;J.data.set(Z0,B0)}P.heif_image_release(i0.image)}U(J)})}.bind(this),0)};var X7=function(){this.decoder=null};X7.prototype.decode=function(J){if(this.decoder&&P.heif_context_free(this.decoder),this.decoder=P.heif_context_alloc(),!this.decoder)return console.log("Could not create HEIF context"),[];var U=P.heif_context_read_from_memory(this.decoder,J);if(U.code!==P.heif_error_code.heif_error_Ok)return console.log("Could not parse HEIF file",U.message),[];var j=P.heif_js_context_get_list_of_top_level_image_IDs(this.decoder);if(!j||j.code)return console.log("Error loading image ids",j),[];if(!j.length)return console.log("No images found"),[];for(var q=[],i0=0;i0<j.length;i0++){var c=P.heif_js_context_get_image_handle(this.decoder,j[i0]);if(!c||c.code){console.log("Could not get image data for id",j[i0],c);continue}q.push(new m8(c))}return q};var Z_=function(J){return J.charCodeAt(0)<<24|J.charCodeAt(1)<<16|J.charCodeAt(2)<<8|J.charCodeAt(3)};P.HeifImage=m8,P.HeifDecoder=X7,P.fourcc=Z_;let G_=["heif_error_code","heif_suberror_code","heif_compression_format","heif_chroma","heif_colorspace","heif_channel"];for(let J of G_)for(let U in P[J])!P[J].hasOwnProperty(U)||U==="values"||(P[U]=P[J][U]);for(let J in P)J.indexOf("_heif_")!==0||P[J.slice(1)]!==void 0||(P[J.slice(1)]=P[J]);return r8=P,r8})})(),nw=xP});var TP=HP(j5=>{tw();var uw=nw(),zP=E1=>v6(null,null,function*(){let s1,I1;try{if(s1=new uw.HeifDecoder,I1=s1.decode(E1),!I1.length)throw new Error("HEIF image not found");let r8=I1[0],P=r8.get_width(),m6=r8.get_height(),Z6=new ImageData(P,m6);for(let E4=0;E4<P*m6;E4++)Z6.data[E4*4+3]=255;return yield new Promise((E4,_8)=>{r8.display(Z6,G6=>{if(!G6)return _8(new Error("HEIF processing error"));E4(G6)})})}finally{if(I1&&I1.length)for(let r8=0;r8<I1.length;r8++)I1[r8].free();s1&&s1.decoder&&uw.heif_context_free(s1.decoder)}});onmessage=E1=>v6(null,null,function*(){let s1=E1.data.id;try{let I1=yield zP(E1.data.buffer);postMessage({id:s1,imageData:I1,error:""})}catch(I1){postMessage({id:s1,imageData:null,error:I1&&I1.toString?I1.toString():I1})}})});TP();})();\n', t = new Blob([
            r
        ], {
            type: "application/javascript"
        });
        $c513f619e4da868b$var$i = new Worker(URL.createObjectURL(t)), $c513f619e4da868b$var$i.onerror = (e)=>console.error("Worker error:", e);
    }
    return $c513f619e4da868b$var$i;
}, $c513f619e4da868b$var$m = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        return new Promise((t, e)=>{
            $c513f619e4da868b$var$g();
            let c = (Math.random() * new Date().getTime()).toString(), f = {
                id: c,
                buffer: r
            };
            $c513f619e4da868b$var$i.postMessage(f);
            let o = (a)=>{
                if (a.data.id === c) return a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), a.data.error ? e(a.data.error) : t(a.data.imageData);
            }, n = (a)=>(a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), e(a.data));
            $c513f619e4da868b$var$i.addEventListener("message", o), $c513f619e4da868b$var$i.addEventListener("error", n);
        });
    }), $c513f619e4da868b$var$l = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        let t = yield $c513f619e4da868b$var$m(r), e = document.createElement("canvas");
        return e.width = t.width, e.height = t.height, e.getContext("2d").putImageData(t, 0, 0), e;
    }), $c513f619e4da868b$var$w = (r)=>{
    r.width = 1, r.height = 1;
    let t = r.getContext("2d");
    t && t.clearRect(0, 0, 1, 1);
}, $c513f619e4da868b$export$abdd76339270e372 = (f)=>$c513f619e4da868b$var$d(null, [
        f
    ], function*({ blob: r, type: t, quality: e, options: c }) {
        if (t == "bitmap") {
            let o = yield r.arrayBuffer(), n = yield $c513f619e4da868b$var$m(o);
            return createImageBitmap(n, c);
        } else {
            let o = yield r.arrayBuffer(), n;
            try {
                return n = yield $c513f619e4da868b$var$l(o), yield new Promise((a, s)=>n.toBlob((u)=>{
                        u != null ? a(u) : s("Can't convert canvas to blob.");
                    }, t, e));
            } finally{
                n && $c513f619e4da868b$var$w(n);
            }
        }
    });


var $5ce5aeca99e3b2a2$require$heicTo = $c513f619e4da868b$export$abdd76339270e372;
const $5ce5aeca99e3b2a2$var$FilePreviewMediaPort = {
    add: function(app) {
        const layoutObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const requestId = entry.target.getAttribute("data-fp-request-id");
                if (!requestId || !app.ports.previewLayoutSized) continue;
                const cr = entry.contentRect;
                app.ports.previewLayoutSized.send({
                    requestId: requestId,
                    width: cr.width,
                    height: cr.height
                });
            }
        });
        const observedLayoutElements = new Map();
        if (app.ports.convertHeicFromUrl) app.ports.convertHeicFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error("fetch failed");
                const blob = await res.blob();
                const outBlob = await $5ce5aeca99e3b2a2$require$heicTo({
                    blob: blob,
                    type: "image/jpeg",
                    quality: 0.9
                });
                const objectUrl = URL.createObjectURL(outBlob);
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: objectUrl
                });
            } catch  {
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: null
                });
            }
        });
        if (app.ports.observePreviewLayout) app.ports.observePreviewLayout.subscribe(({ elementId: elementId, requestId: requestId })=>{
            const el = document.getElementById(elementId);
            if (!el) return;
            const prev = observedLayoutElements.get(elementId);
            if (prev) layoutObserver.unobserve(prev);
            el.setAttribute("data-fp-request-id", requestId);
            layoutObserver.observe(el);
            observedLayoutElements.set(elementId, el);
            const r = el.getBoundingClientRect();
            if (app.ports.previewLayoutSized) app.ports.previewLayoutSized.send({
                requestId: requestId,
                width: r.width,
                height: r.height
            });
        });
        if (app.ports.revokePreviewObjectUrl) app.ports.revokePreviewObjectUrl.subscribe((u)=>{
            try {
                if (u && String(u).startsWith("blob:")) URL.revokeObjectURL(u);
            } catch  {}
        });
        if (app.ports.mediaPlay) app.ports.mediaPlay.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (el && (el.tagName === "AUDIO" || el.tagName === "VIDEO")) el.play().catch(()=>{});
        });
        if (app.ports.mediaTogglePlayPause) app.ports.mediaTogglePlayPause.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO" && el.tagName !== "VIDEO") return;
            if (el.paused) el.play().catch(()=>{});
            else el.pause();
        });
        if (app.ports.mediaSetCurrentTime) app.ports.mediaSetCurrentTime.subscribe(({ elementId: elementId, seconds: seconds })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO") return;
            const t = Number.isFinite(seconds) ? seconds : 0;
            el.currentTime = Math.max(0, t);
        });
        if (app.ports.videoSeekPreview) app.ports.videoSeekPreview.subscribe(({ videoElementId: videoElementId })=>{
            const v = document.getElementById(videoElementId);
            if (!v || v.tagName !== "VIDEO") return;
            const run = ()=>{
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const d = v.duration;
                        if (d && !Number.isNaN(d) && d > 0) {
                            const t = Math.min(0.5, d * 0.1);
                            v.currentTime = t > 0 ? t : 0;
                        }
                    });
                });
            };
            if (v.readyState >= 1 && Number.isFinite(v.duration) && v.duration > 0) run();
            else v.addEventListener("loadedmetadata", run, {
                once: true
            });
        });
        return function cleanup() {
            observedLayoutElements.forEach((element)=>{
                layoutObserver.unobserve(element);
            });
            observedLayoutElements.clear();
            layoutObserver.disconnect();
        };
    }
};
$5ce5aeca99e3b2a2$exports = $5ce5aeca99e3b2a2$var$FilePreviewMediaPort;


var $73cbf435bf470aed$exports = {};
var $f489ff3da7c10b03$export$7b82ddf1ba8788ff;
var $f489ff3da7c10b03$export$16c74263c98473fb;
var $f489ff3da7c10b03$export$9c68d69a4c5bbcf9;
var $f489ff3da7c10b03$export$a1ba744cb18565b5;
var $f489ff3da7c10b03$export$6c746a5570b8b35c;
var $f489ff3da7c10b03$export$63e4f03d302d3e40;
var $f489ff3da7c10b03$export$425327af25286e5e;
var $f489ff3da7c10b03$export$7d85d7e73199d20c;
var $f489ff3da7c10b03$export$3d6d846391b5780c;
var $f489ff3da7c10b03$export$65b53a1b2f72fd4c;

var $f489ff3da7c10b03$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $bae7c73ea3cda3cb$export$aafa59e2e03f2942;
var $bae7c73ea3cda3cb$export$2404ec9a8c74f37d;
$bae7c73ea3cda3cb$export$aafa59e2e03f2942 = $bae7c73ea3cda3cb$var$read;
$bae7c73ea3cda3cb$export$2404ec9a8c74f37d = $bae7c73ea3cda3cb$var$findPartPaths;

var $d93yU = parcelRequire("d93yU");
var $fcf129b7bd4ce72f$export$b14ad400b1d09e0f;
var $fcf129b7bd4ce72f$export$5a7bfc01df82fcd1;
var $fcf129b7bd4ce72f$export$b34a105447964f9f;
var $fcf129b7bd4ce72f$export$9c206ddddb32a9b;
var $fcf129b7bd4ce72f$export$358a232cca1ab2ac;
var $fcf129b7bd4ce72f$export$889ea624f2cb2c57;
var $fcf129b7bd4ce72f$export$ddae37e51c7979e2;
var $fcf129b7bd4ce72f$export$6f093cfa640b7166;
var $fcf129b7bd4ce72f$export$5f1af8db9871e1d6;
var $fcf129b7bd4ce72f$export$62d58b1c91e8e902;
var $fcf129b7bd4ce72f$export$3e41faf802a29e71;
var $fcf129b7bd4ce72f$export$b07e517d22efa1ca;
var $fcf129b7bd4ce72f$export$48513f6b9f8ce62d;
var $fcf129b7bd4ce72f$export$de48447bf377cd47;
var $fcf129b7bd4ce72f$export$bc6e927f6446fee8;
var $fcf129b7bd4ce72f$export$e67f182a50c27e10;
var $fcf129b7bd4ce72f$export$aa31b211d2f4c3af;
var $fcf129b7bd4ce72f$export$6c88bf799aca3d2b;
var $fcf129b7bd4ce72f$export$841d4c6db70c1a65;
var $fcf129b7bd4ce72f$export$4a34f930e789283c;
var $fcf129b7bd4ce72f$export$3e431a229df88919;
var $fcf129b7bd4ce72f$export$54ec01a60f47d33d;
var $fcf129b7bd4ce72f$export$b05581f4e764e162;
var $fcf129b7bd4ce72f$export$1e4baea7053fc0e3;
var $fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6;
var $fcf129b7bd4ce72f$export$1b438cdd7ed26c35;
var $fcf129b7bd4ce72f$export$5a38f5b463e49b91;
var $fcf129b7bd4ce72f$export$ad0c5cb04e0f1440;
var $fcf129b7bd4ce72f$export$983b95e2e3722091;

var $fcf129b7bd4ce72f$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
parcelRequire("9jAvV");
var $bJcvr = parcelRequire("bJcvr");
var $fcf129b7bd4ce72f$var$types = $fcf129b7bd4ce72f$export$b14ad400b1d09e0f = {
    document: "document",
    paragraph: "paragraph",
    run: "run",
    text: "text",
    tab: "tab",
    checkbox: "checkbox",
    hyperlink: "hyperlink",
    noteReference: "noteReference",
    image: "image",
    note: "note",
    commentReference: "commentReference",
    comment: "comment",
    table: "table",
    tableRow: "tableRow",
    tableCell: "tableCell",
    "break": "break",
    bookmarkStart: "bookmarkStart"
};
function $fcf129b7bd4ce72f$var$Document(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.document,
        children: children,
        notes: options.notes || new $fcf129b7bd4ce72f$var$Notes({}),
        comments: options.comments || []
    };
}
function $fcf129b7bd4ce72f$var$Paragraph(children, properties) {
    properties = properties || {};
    var indent = properties.indent || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.paragraph,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        numbering: properties.numbering || null,
        alignment: properties.alignment || null,
        indent: {
            start: indent.start || null,
            end: indent.end || null,
            firstLine: indent.firstLine || null,
            hanging: indent.hanging || null
        }
    };
}
function $fcf129b7bd4ce72f$var$Run(children, properties) {
    properties = properties || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.run,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        isBold: !!properties.isBold,
        isUnderline: !!properties.isUnderline,
        isItalic: !!properties.isItalic,
        isStrikethrough: !!properties.isStrikethrough,
        isAllCaps: !!properties.isAllCaps,
        isSmallCaps: !!properties.isSmallCaps,
        verticalAlignment: properties.verticalAlignment || $fcf129b7bd4ce72f$var$verticalAlignment.baseline,
        font: properties.font || null,
        fontSize: properties.fontSize || null,
        highlight: properties.highlight || null
    };
}
var $fcf129b7bd4ce72f$var$verticalAlignment = {
    baseline: "baseline",
    superscript: "superscript",
    subscript: "subscript"
};
function $fcf129b7bd4ce72f$var$Text(value) {
    return {
        type: $fcf129b7bd4ce72f$var$types.text,
        value: value
    };
}
function $fcf129b7bd4ce72f$var$Tab() {
    return {
        type: $fcf129b7bd4ce72f$var$types.tab
    };
}
function $fcf129b7bd4ce72f$var$Checkbox(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.checkbox,
        checked: options.checked
    };
}
function $fcf129b7bd4ce72f$var$Hyperlink(children, options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.hyperlink,
        children: children,
        href: options.href,
        anchor: options.anchor,
        targetFrame: options.targetFrame
    };
}
function $fcf129b7bd4ce72f$var$NoteReference(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.noteReference,
        noteType: options.noteType,
        noteId: options.noteId
    };
}
function $fcf129b7bd4ce72f$var$Notes(notes) {
    this._notes = $bJcvr.default(notes, function(note) {
        return $fcf129b7bd4ce72f$var$noteKey(note.noteType, note.noteId);
    });
}
$fcf129b7bd4ce72f$var$Notes.prototype.resolve = function(reference) {
    return this.findNoteByKey($fcf129b7bd4ce72f$var$noteKey(reference.noteType, reference.noteId));
};
$fcf129b7bd4ce72f$var$Notes.prototype.findNoteByKey = function(key) {
    return this._notes[key] || null;
};
function $fcf129b7bd4ce72f$var$Note(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.note,
        noteType: options.noteType,
        noteId: options.noteId,
        body: options.body
    };
}
function $fcf129b7bd4ce72f$var$commentReference(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.commentReference,
        commentId: options.commentId
    };
}
function $fcf129b7bd4ce72f$var$comment(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.comment,
        commentId: options.commentId,
        body: options.body,
        authorName: options.authorName,
        authorInitials: options.authorInitials
    };
}
function $fcf129b7bd4ce72f$var$noteKey(noteType, id) {
    return noteType + "-" + id;
}
function $fcf129b7bd4ce72f$var$Image(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.image,
        // `read` is retained for backwards compatibility, but other read
        // methods should be preferred.
        read: function(encoding) {
            if (encoding) return options.readImage(encoding);
            else return options.readImage().then(function(arrayBuffer) {
                return $fcf129b7bd4ce72f$require$Buffer.from(arrayBuffer);
            });
        },
        readAsArrayBuffer: function() {
            return options.readImage();
        },
        readAsBase64String: function() {
            return options.readImage("base64");
        },
        readAsBuffer: function() {
            return options.readImage().then(function(arrayBuffer) {
                return $fcf129b7bd4ce72f$require$Buffer.from(arrayBuffer);
            });
        },
        altText: options.altText,
        contentType: options.contentType
    };
}
function $fcf129b7bd4ce72f$var$Table(children, properties) {
    properties = properties || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.table,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null
    };
}
function $fcf129b7bd4ce72f$var$TableRow(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.tableRow,
        children: children,
        isHeader: options.isHeader || false
    };
}
function $fcf129b7bd4ce72f$var$TableCell(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.tableCell,
        children: children,
        colSpan: options.colSpan == null ? 1 : options.colSpan,
        rowSpan: options.rowSpan == null ? 1 : options.rowSpan
    };
}
function $fcf129b7bd4ce72f$var$Break(breakType) {
    return {
        type: $fcf129b7bd4ce72f$var$types["break"],
        breakType: breakType
    };
}
function $fcf129b7bd4ce72f$var$BookmarkStart(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.bookmarkStart,
        name: options.name
    };
}
$fcf129b7bd4ce72f$export$5a7bfc01df82fcd1 = $fcf129b7bd4ce72f$export$b34a105447964f9f = $fcf129b7bd4ce72f$var$Document;
$fcf129b7bd4ce72f$export$9c206ddddb32a9b = $fcf129b7bd4ce72f$export$358a232cca1ab2ac = $fcf129b7bd4ce72f$var$Paragraph;
$fcf129b7bd4ce72f$export$889ea624f2cb2c57 = $fcf129b7bd4ce72f$export$ddae37e51c7979e2 = $fcf129b7bd4ce72f$var$Run;
$fcf129b7bd4ce72f$export$6f093cfa640b7166 = $fcf129b7bd4ce72f$export$5f1af8db9871e1d6 = $fcf129b7bd4ce72f$var$Text;
$fcf129b7bd4ce72f$export$62d58b1c91e8e902 = $fcf129b7bd4ce72f$export$3e41faf802a29e71 = $fcf129b7bd4ce72f$var$Tab;
$fcf129b7bd4ce72f$export$b07e517d22efa1ca = $fcf129b7bd4ce72f$export$48513f6b9f8ce62d = $fcf129b7bd4ce72f$var$Checkbox;
$fcf129b7bd4ce72f$export$de48447bf377cd47 = $fcf129b7bd4ce72f$var$Hyperlink;
$fcf129b7bd4ce72f$export$bc6e927f6446fee8 = $fcf129b7bd4ce72f$export$e67f182a50c27e10 = $fcf129b7bd4ce72f$var$NoteReference;
$fcf129b7bd4ce72f$export$aa31b211d2f4c3af = $fcf129b7bd4ce72f$var$Notes;
$fcf129b7bd4ce72f$export$6c88bf799aca3d2b = $fcf129b7bd4ce72f$var$Note;
$fcf129b7bd4ce72f$export$841d4c6db70c1a65 = $fcf129b7bd4ce72f$var$commentReference;
$fcf129b7bd4ce72f$export$4a34f930e789283c = $fcf129b7bd4ce72f$var$comment;
$fcf129b7bd4ce72f$export$3e431a229df88919 = $fcf129b7bd4ce72f$var$Image;
$fcf129b7bd4ce72f$export$54ec01a60f47d33d = $fcf129b7bd4ce72f$var$Table;
$fcf129b7bd4ce72f$export$b05581f4e764e162 = $fcf129b7bd4ce72f$var$TableRow;
$fcf129b7bd4ce72f$export$1e4baea7053fc0e3 = $fcf129b7bd4ce72f$var$TableCell;
$fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6 = $fcf129b7bd4ce72f$var$Break("line");
$fcf129b7bd4ce72f$export$1b438cdd7ed26c35 = $fcf129b7bd4ce72f$var$Break("page");
$fcf129b7bd4ce72f$export$5a38f5b463e49b91 = $fcf129b7bd4ce72f$var$Break("column");
$fcf129b7bd4ce72f$export$ad0c5cb04e0f1440 = $fcf129b7bd4ce72f$var$BookmarkStart;
$fcf129b7bd4ce72f$export$983b95e2e3722091 = $fcf129b7bd4ce72f$var$verticalAlignment;


var $11d28a8fc8838027$export$8fdcabde73f49165;
var $11d28a8fc8838027$export$fe7c49d056ea1d88;
var $11d28a8fc8838027$export$491112666e282270;
var $11d28a8fc8838027$export$a3bc9b8ed74fc;
parcelRequire("9jAvV");
var $bss2W = parcelRequire("bss2W");
var $1TwZj = parcelRequire("1TwZj");
var $gS9W9 = parcelRequire("gS9W9");
$11d28a8fc8838027$export$8fdcabde73f49165 = $11d28a8fc8838027$var$Result;
$11d28a8fc8838027$export$fe7c49d056ea1d88 = $11d28a8fc8838027$var$success;
$11d28a8fc8838027$export$491112666e282270 = $11d28a8fc8838027$var$warning;
$11d28a8fc8838027$export$a3bc9b8ed74fc = $11d28a8fc8838027$var$error;
function $11d28a8fc8838027$var$Result(value, messages) {
    this.value = value;
    this.messages = messages || [];
}
$11d28a8fc8838027$var$Result.prototype.map = function(func) {
    return new $11d28a8fc8838027$var$Result(func(this.value), this.messages);
};
$11d28a8fc8838027$var$Result.prototype.flatMap = function(func) {
    var funcResult = func(this.value);
    return new $11d28a8fc8838027$var$Result(funcResult.value, $11d28a8fc8838027$var$combineMessages([
        this,
        funcResult
    ]));
};
$11d28a8fc8838027$var$Result.prototype.flatMapThen = function(func) {
    var that = this;
    return func(this.value).then(function(otherResult) {
        return new $11d28a8fc8838027$var$Result(otherResult.value, $11d28a8fc8838027$var$combineMessages([
            that,
            otherResult
        ]));
    });
};
$11d28a8fc8838027$var$Result.combine = function(results) {
    var values = $1TwZj.default($gS9W9.default(results, "value"));
    var messages = $11d28a8fc8838027$var$combineMessages(results);
    return new $11d28a8fc8838027$var$Result(values, messages);
};
function $11d28a8fc8838027$var$success(value) {
    return new $11d28a8fc8838027$var$Result(value, []);
}
function $11d28a8fc8838027$var$warning(message) {
    return {
        type: "warning",
        message: message
    };
}
function $11d28a8fc8838027$var$error(exception) {
    return {
        type: "error",
        message: exception.message,
        error: exception
    };
}
function $11d28a8fc8838027$var$combineMessages(results) {
    var messages = [];
    $1TwZj.default($gS9W9.default(results, "messages"), true).forEach(function(message) {
        if (!$11d28a8fc8838027$var$containsMessage(messages, message)) messages.push(message);
    });
    return messages;
}
function $11d28a8fc8838027$var$containsMessage(messages, message) {
    return $bss2W.default(messages, $11d28a8fc8838027$var$isSameMessage.bind(null, message)) !== undefined;
}
function $11d28a8fc8838027$var$isSameMessage(first, second) {
    return first.type === second.type && first.message === second.message;
}


var $bae7c73ea3cda3cb$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
var $3e56e634a929bca6$export$94ea64f322e5a37c;
var $3e56e634a929bca6$export$824c337f43f2b64d;
var $3e56e634a929bca6$export$b891921babc70093;

var $921d13038eff58c9$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $921d13038eff58c9$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;

var $4TZ3D = parcelRequire("4TZ3D");
!function(e) {
    $921d13038eff58c9$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $921d13038eff58c9$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($921d13038eff58c9$require$Buffer.from && $921d13038eff58c9$require$Buffer.from !== Uint8Array.from) return $921d13038eff58c9$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $921d13038eff58c9$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($921d13038eff58c9$require$Buffer.alloc) return $921d13038eff58c9$require$Buffer.alloc(e);
                        var t = new $921d13038eff58c9$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $921d13038eff58c9$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $921d13038eff58c9$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $921d13038eff58c9$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4TZ3D.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


$3e56e634a929bca6$export$94ea64f322e5a37c = $3e56e634a929bca6$var$openArrayBuffer;
$3e56e634a929bca6$export$824c337f43f2b64d = $3e56e634a929bca6$var$splitPath;
$3e56e634a929bca6$export$b891921babc70093 = $3e56e634a929bca6$var$joinPath;
function $3e56e634a929bca6$var$openArrayBuffer(arrayBuffer) {
    return $921d13038eff58c9$exports.loadAsync(arrayBuffer).then(function(zipFile) {
        function exists(name) {
            return zipFile.file(name) !== null;
        }
        function read(name, encoding) {
            return zipFile.file(name).async("uint8array").then(function(array) {
                if (encoding === "base64") return $441c3b20dbacff63$export$6100ba28696e12de(array);
                else if (encoding) {
                    var decoder = new TextDecoder(encoding);
                    return decoder.decode(array);
                } else return array;
            });
        }
        function write(name, contents) {
            zipFile.file(name, contents);
        }
        function toArrayBuffer() {
            return zipFile.generateAsync({
                type: "arraybuffer"
            });
        }
        return {
            exists: exists,
            read: read,
            write: write,
            toArrayBuffer: toArrayBuffer
        };
    });
}
function $3e56e634a929bca6$var$splitPath(path) {
    var lastIndex = path.lastIndexOf("/");
    if (lastIndex === -1) return {
        dirname: "",
        basename: path
    };
    else return {
        dirname: path.substring(0, lastIndex),
        basename: path.substring(lastIndex + 1)
    };
}
function $3e56e634a929bca6$var$joinPath() {
    var nonEmptyPaths = Array.prototype.filter.call(arguments, function(path) {
        return path;
    });
    var relevantPaths = [];
    nonEmptyPaths.forEach(function(path) {
        if (/^\//.test(path)) relevantPaths = [
            path
        ];
        else relevantPaths.push(path);
    });
    return relevantPaths.join("/");
}


var $78a3b14bfaef3ebb$export$aafa59e2e03f2942;
var $78a3b14bfaef3ebb$export$27eef0075cdf2763;
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");

var $d93yU = parcelRequire("d93yU");
var $aea06b742aa725d8$export$db77ccec0bb4ccac;
var $aea06b742aa725d8$export$8454457683f90105;
var $aea06b742aa725d8$export$ae6de35c16b306df;
var $aea06b742aa725d8$export$6f093cfa640b7166;
var $aea06b742aa725d8$export$dda73877cb166cd3;
var $aea06b742aa725d8$export$48a3ce3d8cfe0ce1;

var $doJbW = parcelRequire("doJbW");
$aea06b742aa725d8$export$db77ccec0bb4ccac = $doJbW.Element;
$aea06b742aa725d8$export$8454457683f90105 = $doJbW.element;
$aea06b742aa725d8$export$ae6de35c16b306df = $doJbW.emptyElement;
$aea06b742aa725d8$export$6f093cfa640b7166 = $doJbW.text;

$aea06b742aa725d8$export$dda73877cb166cd3 = (parcelRequire("jxEQL")).readString;

$aea06b742aa725d8$export$48a3ce3d8cfe0ce1 = (parcelRequire("42JRH")).writeString;


$78a3b14bfaef3ebb$export$aafa59e2e03f2942 = $78a3b14bfaef3ebb$var$read;
$78a3b14bfaef3ebb$export$27eef0075cdf2763 = $78a3b14bfaef3ebb$var$readXmlFromZipFile;
var $78a3b14bfaef3ebb$var$xmlNamespaceMap = {
    // Transitional format
    "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
    "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
    "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
    "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",
    // Strict format
    "http://purl.oclc.org/ooxml/wordprocessingml/main": "w",
    "http://purl.oclc.org/ooxml/officeDocument/relationships": "r",
    "http://purl.oclc.org/ooxml/drawingml/wordprocessingDrawing": "wp",
    "http://purl.oclc.org/ooxml/drawingml/main": "a",
    "http://purl.oclc.org/ooxml/drawingml/picture": "pic",
    // Common
    "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
    "http://schemas.openxmlformats.org/package/2006/relationships": "relationships",
    "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
    "urn:schemas-microsoft-com:vml": "v",
    "urn:schemas-microsoft-com:office:word": "office-word",
    // [MS-DOCX]: Word Extensions to the Office Open XML (.docx) File Format
    // https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/b839fe1f-e1ca-4fa6-8c26-5954d0abbccd
    "http://schemas.microsoft.com/office/word/2010/wordml": "wordml"
};
function $78a3b14bfaef3ebb$var$read(xmlString) {
    return $aea06b742aa725d8$export$dda73877cb166cd3(xmlString, $78a3b14bfaef3ebb$var$xmlNamespaceMap).then(function(document) {
        return $78a3b14bfaef3ebb$var$collapseAlternateContent(document)[0];
    });
}
function $78a3b14bfaef3ebb$var$readXmlFromZipFile(docxFile, path) {
    if (docxFile.exists(path)) return docxFile.read(path, "utf-8").then($78a3b14bfaef3ebb$var$stripUtf8Bom).then($78a3b14bfaef3ebb$var$read);
    else return $d93yU.resolve(null);
}
function $78a3b14bfaef3ebb$var$stripUtf8Bom(xmlString) {
    return xmlString.replace(/^\uFEFF/g, '');
}
function $78a3b14bfaef3ebb$var$collapseAlternateContent(node) {
    if (node.type === "element") {
        if (node.name === "mc:AlternateContent") return node.firstOrEmpty("mc:Fallback").children;
        else {
            node.children = $1TwZj.default(node.children.map($78a3b14bfaef3ebb$var$collapseAlternateContent, true));
            return [
                node
            ];
        }
    } else return [
        node
    ];
}


var $bae7c73ea3cda3cb$require$readXmlFromZipFile = $78a3b14bfaef3ebb$export$27eef0075cdf2763;
var $5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f;
var $5347e5b2a03f8fdd$export$fbfda8999a345a11;
$5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f = $5347e5b2a03f8fdd$var$createBodyReader;
$5347e5b2a03f8fdd$export$fbfda8999a345a11 = $5347e5b2a03f8fdd$var$readNumberingProperties;
var $b5f977ccce5a84c6$exports = {};
"use strict";
var $b5f977ccce5a84c6$var$__importDefault = $b5f977ccce5a84c6$exports && $b5f977ccce5a84c6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b5f977ccce5a84c6$exports, "__esModule", {
    value: true
});
$b5f977ccce5a84c6$exports.hex = $b5f977ccce5a84c6$exports.dec = $b5f977ccce5a84c6$exports.codePoint = void 0;

var $b5f977ccce5a84c6$var$dingbats_1 = $b5f977ccce5a84c6$var$__importDefault((parcelRequire("jKsvD")));
var $b5f977ccce5a84c6$var$dingbatsByCodePoint = {};
var $b5f977ccce5a84c6$var$fromCodePoint = String.fromCodePoint ? String.fromCodePoint : $b5f977ccce5a84c6$var$fromCodePointPolyfill;
for(var $b5f977ccce5a84c6$var$_i = 0, $b5f977ccce5a84c6$var$dingbats_2 = $b5f977ccce5a84c6$var$dingbats_1.default; $b5f977ccce5a84c6$var$_i < $b5f977ccce5a84c6$var$dingbats_2.length; $b5f977ccce5a84c6$var$_i++){
    var $b5f977ccce5a84c6$var$dingbat = $b5f977ccce5a84c6$var$dingbats_2[$b5f977ccce5a84c6$var$_i];
    var $b5f977ccce5a84c6$var$codePoint_1 = parseInt($b5f977ccce5a84c6$var$dingbat["Unicode dec"], 10);
    var $b5f977ccce5a84c6$var$scalarValue = {
        codePoint: $b5f977ccce5a84c6$var$codePoint_1,
        string: $b5f977ccce5a84c6$var$fromCodePoint($b5f977ccce5a84c6$var$codePoint_1)
    };
    $b5f977ccce5a84c6$var$dingbatsByCodePoint[$b5f977ccce5a84c6$var$dingbat["Typeface name"].toUpperCase() + "_" + $b5f977ccce5a84c6$var$dingbat["Dingbat dec"]] = $b5f977ccce5a84c6$var$scalarValue;
}
function $b5f977ccce5a84c6$var$codePoint(typeface, codePoint) {
    return $b5f977ccce5a84c6$var$dingbatsByCodePoint[typeface.toUpperCase() + "_" + codePoint];
}
$b5f977ccce5a84c6$exports.codePoint = $b5f977ccce5a84c6$var$codePoint;
function $b5f977ccce5a84c6$var$dec(typeface, dec) {
    return $b5f977ccce5a84c6$var$codePoint(typeface, parseInt(dec, 10));
}
$b5f977ccce5a84c6$exports.dec = $b5f977ccce5a84c6$var$dec;
function $b5f977ccce5a84c6$var$hex(typeface, hex) {
    return $b5f977ccce5a84c6$var$codePoint(typeface, parseInt(hex, 16));
}
$b5f977ccce5a84c6$exports.hex = $b5f977ccce5a84c6$var$hex;
function $b5f977ccce5a84c6$var$fromCodePointPolyfill(codePoint) {
    if (codePoint <= 0xFFFF) // BMP
    return String.fromCharCode(codePoint);
    else {
        // Astral
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        var highSurrogate = Math.floor((codePoint - 0x10000) / 0x400) + 0xD800;
        var lowSurrogate = (codePoint - 0x10000) % 0x400 + 0xDC00;
        return String.fromCharCode(highSurrogate, lowSurrogate);
    }
}


parcelRequire("9jAvV");
var $ctpBH = parcelRequire("ctpBH");
var $5yjjJ = parcelRequire("5yjjJ");
var $efEt3 = parcelRequire("efEt3");
var $1TwZj = parcelRequire("1TwZj");
var $hB3Xt = parcelRequire("hB3Xt");
var $gS9W9 = parcelRequire("gS9W9");


var $5347e5b2a03f8fdd$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;

var $5347e5b2a03f8fdd$require$warning = $11d28a8fc8838027$export$491112666e282270;


var $kUMgi = parcelRequire("kUMgi");
var $bff8c0b142852ddd$export$483b6ae7cde9cd77;
var $bff8c0b142852ddd$export$75a2182ba6144c1c;
$bff8c0b142852ddd$export$483b6ae7cde9cd77 = $bff8c0b142852ddd$var$uriToZipEntryName;
$bff8c0b142852ddd$export$75a2182ba6144c1c = $bff8c0b142852ddd$var$replaceFragment;
function $bff8c0b142852ddd$var$uriToZipEntryName(base, uri) {
    if (uri.charAt(0) === "/") return uri.substr(1);
    else // In general, we should check first and second for trailing and leading slashes,
    // but in our specific case this seems to be sufficient
    return base + "/" + uri;
}
function $bff8c0b142852ddd$var$replaceFragment(uri, fragment) {
    var hashIndex = uri.indexOf("#");
    if (hashIndex !== -1) uri = uri.substring(0, hashIndex);
    return uri + "#" + fragment;
}


function $5347e5b2a03f8fdd$var$createBodyReader(options) {
    return {
        readXmlElement: function(element) {
            return new $5347e5b2a03f8fdd$var$BodyReader(options).readXmlElement(element);
        },
        readXmlElements: function(elements) {
            return new $5347e5b2a03f8fdd$var$BodyReader(options).readXmlElements(elements);
        }
    };
}
function $5347e5b2a03f8fdd$var$BodyReader(options) {
    var complexFieldStack = [];
    var currentInstrText = [];
    // When a paragraph is marked as deleted, its contents should be combined
    // with the following paragraph. See 17.13.5.15 del (Deleted Paragraph) of
    // ECMA-376 4th edition Part 1.
    var deletedParagraphContents = [];
    var relationships = options.relationships;
    var contentTypes = options.contentTypes;
    var docxFile = options.docxFile;
    var files = options.files;
    var numbering = options.numbering;
    var styles = options.styles;
    function readXmlElements(elements) {
        var results = elements.map(readXmlElement);
        return $5347e5b2a03f8fdd$var$combineResults(results);
    }
    function readXmlElement(element) {
        if (element.type === "element") {
            var handler = xmlElementReaders[element.name];
            if (handler) return handler(element);
            else if (!Object.prototype.hasOwnProperty.call($5347e5b2a03f8fdd$var$ignoreElements, element.name)) {
                var message = $5347e5b2a03f8fdd$require$warning("An unrecognised element was ignored: " + element.name);
                return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
                    message
                ]);
            }
        }
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function readParagraphProperties(element) {
        return readParagraphStyle(element).map(function(style) {
            return {
                type: "paragraphProperties",
                styleId: style.styleId,
                styleName: style.name,
                alignment: element.firstOrEmpty("w:jc").attributes["w:val"],
                numbering: $5347e5b2a03f8fdd$var$readNumberingProperties(style.styleId, element.firstOrEmpty("w:numPr"), numbering),
                indent: readParagraphIndent(element.firstOrEmpty("w:ind"))
            };
        });
    }
    function readParagraphIndent(element) {
        return {
            start: element.attributes["w:start"] || element.attributes["w:left"],
            end: element.attributes["w:end"] || element.attributes["w:right"],
            firstLine: element.attributes["w:firstLine"],
            hanging: element.attributes["w:hanging"]
        };
    }
    function readRunProperties(element) {
        return readRunStyle(element).map(function(style) {
            var fontSizeString = element.firstOrEmpty("w:sz").attributes["w:val"];
            // w:sz gives the font size in half points, so halve the value to get the size in points
            var fontSize = /^[0-9]+$/.test(fontSizeString) ? parseInt(fontSizeString, 10) / 2 : null;
            return {
                type: "runProperties",
                styleId: style.styleId,
                styleName: style.name,
                verticalAlignment: element.firstOrEmpty("w:vertAlign").attributes["w:val"],
                font: element.firstOrEmpty("w:rFonts").attributes["w:ascii"],
                fontSize: fontSize,
                isBold: readBooleanElement(element.first("w:b")),
                isUnderline: readUnderline(element.first("w:u")),
                isItalic: readBooleanElement(element.first("w:i")),
                isStrikethrough: readBooleanElement(element.first("w:strike")),
                isAllCaps: readBooleanElement(element.first("w:caps")),
                isSmallCaps: readBooleanElement(element.first("w:smallCaps")),
                highlight: readHighlightValue(element.firstOrEmpty("w:highlight").attributes["w:val"])
            };
        });
    }
    function readUnderline(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== undefined && value !== "false" && value !== "0" && value !== "none";
        } else return false;
    }
    function readBooleanElement(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== "false" && value !== "0";
        } else return false;
    }
    function readBooleanAttributeValue(value) {
        return value !== "false" && value !== "0";
    }
    function readHighlightValue(value) {
        if (!value || value === "none") return null;
        else return value;
    }
    function readParagraphStyle(element) {
        return readStyle(element, "w:pStyle", "Paragraph", styles.findParagraphStyleById);
    }
    function readRunStyle(element) {
        return readStyle(element, "w:rStyle", "Run", styles.findCharacterStyleById);
    }
    function readTableStyle(element) {
        return readStyle(element, "w:tblStyle", "Table", styles.findTableStyleById);
    }
    function readStyle(element, styleTagName, styleType, findStyleById) {
        var messages = [];
        var styleElement = element.first(styleTagName);
        var styleId = null;
        var name = null;
        if (styleElement) {
            styleId = styleElement.attributes["w:val"];
            if (styleId) {
                var style = findStyleById(styleId);
                if (style) name = style.name;
                else messages.push(undefinedStyleWarning(styleType, styleId));
            }
        }
        return $5347e5b2a03f8fdd$var$elementResultWithMessages({
            styleId: styleId,
            name: name
        }, messages);
    }
    function readFldChar(element) {
        var type = element.attributes["w:fldCharType"];
        if (type === "begin") {
            complexFieldStack.push({
                type: "begin",
                fldChar: element
            });
            currentInstrText = [];
        } else if (type === "end") {
            var complexFieldEnd = complexFieldStack.pop();
            if (complexFieldEnd.type === "begin") complexFieldEnd = parseCurrentInstrText(complexFieldEnd);
            if (complexFieldEnd.type === "checkbox") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$b07e517d22efa1ca({
                checked: complexFieldEnd.checked
            }));
        } else if (type === "separate") {
            var complexFieldSeparate = complexFieldStack.pop();
            var complexField = parseCurrentInstrText(complexFieldSeparate);
            complexFieldStack.push(complexField);
        }
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function currentHyperlinkOptions() {
        var topHyperlink = $hB3Xt.default(complexFieldStack.filter(function(complexField) {
            return complexField.type === "hyperlink";
        }));
        return topHyperlink ? topHyperlink.options : null;
    }
    function parseCurrentInstrText(complexField) {
        return parseInstrText(currentInstrText.join(''), complexField.type === "begin" ? complexField.fldChar : $aea06b742aa725d8$export$ae6de35c16b306df);
    }
    function parseInstrText(instrText, fldChar) {
        var linkResult = /^\s*HYPERLINK\s+(\\l\s+)?(?:"(.*)"|([^\\]\S*))/.exec(instrText);
        if (linkResult) {
            var location = linkResult[2] === undefined ? linkResult[3] : linkResult[2];
            var options = linkResult[1] === undefined ? {
                href: location
            } : {
                anchor: location
            };
            return {
                type: "hyperlink",
                options: options
            };
        }
        var checkboxResult = /\s*FORMCHECKBOX\s*/.exec(instrText);
        if (checkboxResult) {
            var checkboxElement = fldChar.firstOrEmpty("w:ffData").firstOrEmpty("w:checkBox");
            var checkedElement = checkboxElement.first("w:checked");
            var checked = checkedElement == null ? readBooleanElement(checkboxElement.first("w:default")) : readBooleanElement(checkedElement);
            return {
                type: "checkbox",
                checked: checked
            };
        }
        return {
            type: "unknown"
        };
    }
    function readInstrText(element) {
        currentInstrText.push(element.text());
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function readSymbol(element) {
        // See 17.3.3.30 sym (Symbol Character) of ECMA-376 4th edition Part 1
        var font = element.attributes["w:font"];
        var char = element.attributes["w:char"];
        var unicodeCharacter = $b5f977ccce5a84c6$exports.hex(font, char);
        if (unicodeCharacter == null && /^F0..$/.test(char)) unicodeCharacter = $b5f977ccce5a84c6$exports.hex(font, char.substring(2));
        if (unicodeCharacter == null) return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("A w:sym element with an unsupported character was ignored: char " + char + " in font " + font)
        ]);
        else return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6(unicodeCharacter.string));
    }
    function noteReferenceReader(noteType) {
        return function(element) {
            var noteId = element.attributes["w:id"];
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$e67f182a50c27e10({
                noteType: noteType,
                noteId: noteId
            }));
        };
    }
    function readCommentReference(element) {
        return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$841d4c6db70c1a65({
            commentId: element.attributes["w:id"]
        }));
    }
    function readChildElements(element) {
        return readXmlElements(element.children);
    }
    var xmlElementReaders = {
        "w:p": function(element) {
            var paragraphPropertiesElement = element.firstOrEmpty("w:pPr");
            var isDeleted = !!paragraphPropertiesElement.firstOrEmpty("w:rPr").first("w:del");
            if (isDeleted) {
                element.children.forEach(function(child) {
                    deletedParagraphContents.push(child);
                });
                return $5347e5b2a03f8fdd$var$emptyResult();
            } else {
                var childrenXml = element.children;
                if (deletedParagraphContents.length > 0) {
                    childrenXml = deletedParagraphContents.concat(childrenXml);
                    deletedParagraphContents = [];
                }
                return $5347e5b2a03f8fdd$var$ReadResult.map(readParagraphProperties(paragraphPropertiesElement), readXmlElements(childrenXml), function(properties, children) {
                    return new $fcf129b7bd4ce72f$export$358a232cca1ab2ac(children, properties);
                }).insertExtra();
            }
        },
        "w:r": function(element) {
            return $5347e5b2a03f8fdd$var$ReadResult.map(readRunProperties(element.firstOrEmpty("w:rPr")), readXmlElements(element.children), function(properties, children) {
                var hyperlinkOptions = currentHyperlinkOptions();
                if (hyperlinkOptions !== null) children = [
                    new $fcf129b7bd4ce72f$export$de48447bf377cd47(children, hyperlinkOptions)
                ];
                return new $fcf129b7bd4ce72f$export$ddae37e51c7979e2(children, properties);
            });
        },
        "w:fldChar": readFldChar,
        "w:instrText": readInstrText,
        "w:t": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6(element.text()));
        },
        "w:tab": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$3e41faf802a29e71());
        },
        "w:noBreakHyphen": function() {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6("\u2011"));
        },
        "w:softHyphen": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6("\u00AD"));
        },
        "w:sym": readSymbol,
        "w:hyperlink": function(element) {
            var relationshipId = element.attributes["r:id"];
            var anchor = element.attributes["w:anchor"];
            return readXmlElements(element.children).map(function(children) {
                function create(options) {
                    var targetFrame = element.attributes["w:tgtFrame"] || null;
                    return new $fcf129b7bd4ce72f$export$de48447bf377cd47(children, $5yjjJ.default({
                        targetFrame: targetFrame
                    }, options));
                }
                if (relationshipId) {
                    var href = relationships.findTargetByRelationshipId(relationshipId);
                    if (anchor) href = $bff8c0b142852ddd$export$75a2182ba6144c1c(href, anchor);
                    return create({
                        href: href
                    });
                } else if (anchor) return create({
                    anchor: anchor
                });
                else return children;
            });
        },
        "w:tbl": readTable,
        "w:tr": readTableRow,
        "w:tc": readTableCell,
        "w:footnoteReference": noteReferenceReader("footnote"),
        "w:endnoteReference": noteReferenceReader("endnote"),
        "w:commentReference": readCommentReference,
        "w:br": function(element) {
            var breakType = element.attributes["w:type"];
            if (breakType == null || breakType === "textWrapping") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6);
            else if (breakType === "page") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$1b438cdd7ed26c35);
            else if (breakType === "column") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$5a38f5b463e49b91);
            else return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
                $5347e5b2a03f8fdd$require$warning("Unsupported break type: " + breakType)
            ]);
        },
        "w:bookmarkStart": function(element) {
            var name = element.attributes["w:name"];
            if (name === "_GoBack") return $5347e5b2a03f8fdd$var$emptyResult();
            else return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$ad0c5cb04e0f1440({
                name: name
            }));
        },
        "mc:AlternateContent": function(element) {
            return readChildElements(element.firstOrEmpty("mc:Fallback"));
        },
        "w:sdt": function(element) {
            var contentResult = readXmlElements(element.firstOrEmpty("w:sdtContent").children);
            return contentResult.map(function(content) {
                // From the WordML standard: https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/3350cb64-931f-41f7-8824-f18b2568ce66
                //
                // > A CT_SdtCheckbox element that specifies that the parent
                // > structured document tag is a checkbox when displayed in the
                // > document. The parent structured document tag contents MUST
                // > contain a single character and optionally an additional
                // > character in a deleted run.
                var checkbox = element.firstOrEmpty("w:sdtPr").first("wordml:checkbox");
                if (checkbox) {
                    var checkedElement = checkbox.first("wordml:checked");
                    var isChecked = !!checkedElement && readBooleanAttributeValue(checkedElement.attributes["wordml:val"]);
                    var documentCheckbox = $fcf129b7bd4ce72f$export$b07e517d22efa1ca({
                        checked: isChecked
                    });
                    var hasCheckbox = false;
                    var replacedContent = content.map($kUMgi._elementsOfType($fcf129b7bd4ce72f$export$b14ad400b1d09e0f.text, function(text) {
                        if (text.value.length > 0 && !hasCheckbox) {
                            hasCheckbox = true;
                            return documentCheckbox;
                        } else return text;
                    }));
                    if (hasCheckbox) return replacedContent;
                    else return documentCheckbox;
                } else return content;
            });
        },
        "w:ins": readChildElements,
        "w:object": readChildElements,
        "w:smartTag": readChildElements,
        "w:drawing": readChildElements,
        "w:pict": function(element) {
            return readChildElements(element).toExtra();
        },
        "v:roundrect": readChildElements,
        "v:shape": readChildElements,
        "v:textbox": readChildElements,
        "w:txbxContent": readChildElements,
        "wp:inline": readDrawingElement,
        "wp:anchor": readDrawingElement,
        "v:imagedata": readImageData,
        "v:group": readChildElements,
        "v:rect": readChildElements
    };
    return {
        readXmlElement: readXmlElement,
        readXmlElements: readXmlElements
    };
    function readTable(element) {
        var propertiesResult = readTableProperties(element.firstOrEmpty("w:tblPr"));
        return readXmlElements(element.children).flatMap(calculateRowSpans).flatMap(function(children) {
            return propertiesResult.map(function(properties) {
                return $fcf129b7bd4ce72f$export$54ec01a60f47d33d(children, properties);
            });
        });
    }
    function readTableProperties(element) {
        return readTableStyle(element).map(function(style) {
            return {
                styleId: style.styleId,
                styleName: style.name
            };
        });
    }
    function readTableRow(element) {
        var properties = element.firstOrEmpty("w:trPr");
        // See 17.13.5.12 del (Deleted Table Row) of ECMA-376 4th edition Part 1
        var isDeleted = !!properties.first("w:del");
        if (isDeleted) return $5347e5b2a03f8fdd$var$emptyResult();
        var isHeader = !!properties.first("w:tblHeader");
        return readXmlElements(element.children).map(function(children) {
            return $fcf129b7bd4ce72f$export$b05581f4e764e162(children, {
                isHeader: isHeader
            });
        });
    }
    function readTableCell(element) {
        return readXmlElements(element.children).map(function(children) {
            var properties = element.firstOrEmpty("w:tcPr");
            var gridSpan = properties.firstOrEmpty("w:gridSpan").attributes["w:val"];
            var colSpan = gridSpan ? parseInt(gridSpan, 10) : 1;
            var cell = $fcf129b7bd4ce72f$export$1e4baea7053fc0e3(children, {
                colSpan: colSpan
            });
            cell._vMerge = readVMerge(properties);
            return cell;
        });
    }
    function readVMerge(properties) {
        var element = properties.first("w:vMerge");
        if (element) {
            var val = element.attributes["w:val"];
            return val === "continue" || !val;
        } else return null;
    }
    function calculateRowSpans(rows) {
        var unexpectedNonRows = $ctpBH.default(rows, function(row) {
            return row.type !== $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableRow;
        });
        if (unexpectedNonRows) {
            removeVMergeProperties(rows);
            return $5347e5b2a03f8fdd$var$elementResultWithMessages(rows, [
                $5347e5b2a03f8fdd$require$warning("unexpected non-row element in table, cell merging may be incorrect")
            ]);
        }
        var unexpectedNonCells = $ctpBH.default(rows, function(row) {
            return $ctpBH.default(row.children, function(cell) {
                return cell.type !== $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableCell;
            });
        });
        if (unexpectedNonCells) {
            removeVMergeProperties(rows);
            return $5347e5b2a03f8fdd$var$elementResultWithMessages(rows, [
                $5347e5b2a03f8fdd$require$warning("unexpected non-cell element in table row, cell merging may be incorrect")
            ]);
        }
        var columns = {};
        rows.forEach(function(row) {
            var cellIndex = 0;
            row.children.forEach(function(cell) {
                if (cell._vMerge && columns[cellIndex]) columns[cellIndex].rowSpan++;
                else {
                    columns[cellIndex] = cell;
                    cell._vMerge = false;
                }
                cellIndex += cell.colSpan;
            });
        });
        rows.forEach(function(row) {
            row.children = row.children.filter(function(cell) {
                return !cell._vMerge;
            });
            row.children.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
        return $5347e5b2a03f8fdd$var$elementResult(rows);
    }
    function removeVMergeProperties(rows) {
        rows.forEach(function(row) {
            var cells = $kUMgi.getDescendantsOfType(row, $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableCell);
            cells.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
    }
    function readDrawingElement(element) {
        var blips = element.getElementsByTagName("a:graphic").getElementsByTagName("a:graphicData").getElementsByTagName("pic:pic").getElementsByTagName("pic:blipFill").getElementsByTagName("a:blip");
        return $5347e5b2a03f8fdd$var$combineResults(blips.map(readBlip.bind(null, element)));
    }
    function readBlip(element, blip) {
        var propertiesElement = element.firstOrEmpty("wp:docPr");
        var properties = propertiesElement.attributes;
        var altText = isBlank(properties.descr) ? properties.title : properties.descr;
        var blipImageFile = findBlipImageFile(blip);
        if (blipImageFile === null) return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("Could not find image file for a:blip element")
        ]);
        return readImage(blipImageFile, altText).map(function(imageElement) {
            var hlinkClickElement = propertiesElement.firstOrEmpty("a:hlinkClick");
            var relationshipId = hlinkClickElement.attributes["r:id"];
            if (relationshipId) {
                var href = relationships.findTargetByRelationshipId(relationshipId);
                return new $fcf129b7bd4ce72f$export$de48447bf377cd47([
                    imageElement
                ], {
                    href: href
                });
            } else return imageElement;
        });
    }
    function isBlank(value) {
        return value == null || /^\s*$/.test(value);
    }
    function findBlipImageFile(blip) {
        var embedRelationshipId = blip.attributes["r:embed"];
        var linkRelationshipId = blip.attributes["r:link"];
        if (embedRelationshipId) return findEmbeddedImageFile(embedRelationshipId);
        else if (linkRelationshipId) {
            var imagePath = relationships.findTargetByRelationshipId(linkRelationshipId);
            return {
                path: imagePath,
                read: files.read.bind(files, imagePath)
            };
        } else return null;
    }
    function readImageData(element) {
        var relationshipId = element.attributes['r:id'];
        if (relationshipId) return readImage(findEmbeddedImageFile(relationshipId), element.attributes["o:title"]);
        else return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("A v:imagedata element without a relationship ID was ignored")
        ]);
    }
    function findEmbeddedImageFile(relationshipId) {
        var path = $bff8c0b142852ddd$export$483b6ae7cde9cd77("word", relationships.findTargetByRelationshipId(relationshipId));
        return {
            path: path,
            read: docxFile.read.bind(docxFile, path)
        };
    }
    function readImage(imageFile, altText) {
        var contentType = contentTypes.findContentType(imageFile.path);
        var image = $fcf129b7bd4ce72f$export$3e431a229df88919({
            readImage: imageFile.read,
            altText: altText,
            contentType: contentType
        });
        var warnings = $5347e5b2a03f8fdd$var$supportedImageTypes[contentType] ? [] : $5347e5b2a03f8fdd$require$warning("Image of type " + contentType + " is unlikely to display in web browsers");
        return $5347e5b2a03f8fdd$var$elementResultWithMessages(image, warnings);
    }
    function undefinedStyleWarning(type, styleId) {
        return $5347e5b2a03f8fdd$require$warning(type + " style with ID " + styleId + " was referenced but not defined in the document");
    }
}
function $5347e5b2a03f8fdd$var$readNumberingProperties(styleId, element, numbering) {
    var level = element.firstOrEmpty("w:ilvl").attributes["w:val"];
    var numId = element.firstOrEmpty("w:numId").attributes["w:val"];
    if (level !== undefined && numId !== undefined) return numbering.findLevel(numId, level);
    if (styleId != null) {
        var levelByStyleId = numbering.findLevelByParagraphStyleId(styleId);
        if (levelByStyleId != null) return levelByStyleId;
    }
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    if (numId !== undefined) return numbering.findLevel(numId, "0");
    return null;
}
var $5347e5b2a03f8fdd$var$supportedImageTypes = {
    "image/png": true,
    "image/gif": true,
    "image/jpeg": true,
    "image/svg+xml": true,
    "image/tiff": true
};
var $5347e5b2a03f8fdd$var$ignoreElements = {
    "office-word:wrap": true,
    "v:shadow": true,
    "v:shapetype": true,
    "w:annotationRef": true,
    "w:bookmarkEnd": true,
    "w:sectPr": true,
    "w:proofErr": true,
    "w:lastRenderedPageBreak": true,
    "w:commentRangeStart": true,
    "w:commentRangeEnd": true,
    "w:del": true,
    "w:footnoteRef": true,
    "w:endnoteRef": true,
    "w:pPr": true,
    "w:rPr": true,
    "w:tblPr": true,
    "w:tblGrid": true,
    "w:trPr": true,
    "w:tcPr": true
};
function $5347e5b2a03f8fdd$var$emptyResultWithMessages(messages) {
    return new $5347e5b2a03f8fdd$var$ReadResult(null, null, messages);
}
function $5347e5b2a03f8fdd$var$emptyResult() {
    return new $5347e5b2a03f8fdd$var$ReadResult(null);
}
function $5347e5b2a03f8fdd$var$elementResult(element) {
    return new $5347e5b2a03f8fdd$var$ReadResult(element);
}
function $5347e5b2a03f8fdd$var$elementResultWithMessages(element, messages) {
    return new $5347e5b2a03f8fdd$var$ReadResult(element, null, messages);
}
function $5347e5b2a03f8fdd$var$ReadResult(element, extra, messages) {
    this.value = element || [];
    this.extra = extra || [];
    this._result = new $5347e5b2a03f8fdd$require$Result({
        element: this.value,
        extra: extra
    }, messages);
    this.messages = this._result.messages;
}
$5347e5b2a03f8fdd$var$ReadResult.prototype.toExtra = function() {
    return new $5347e5b2a03f8fdd$var$ReadResult(null, $5347e5b2a03f8fdd$var$joinElements(this.extra, this.value), this.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.insertExtra = function() {
    var extra = this.extra;
    if (extra && extra.length) return new $5347e5b2a03f8fdd$var$ReadResult($5347e5b2a03f8fdd$var$joinElements(this.value, extra), null, this.messages);
    else return this;
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.map = function(func) {
    var result = this._result.map(function(value) {
        return func(value.element);
    });
    return new $5347e5b2a03f8fdd$var$ReadResult(result.value, this.extra, result.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.flatMap = function(func) {
    var result = this._result.flatMap(function(value) {
        return func(value.element)._result;
    });
    return new $5347e5b2a03f8fdd$var$ReadResult(result.value.element, $5347e5b2a03f8fdd$var$joinElements(this.extra, result.value.extra), result.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.map = function(first, second, func) {
    return new $5347e5b2a03f8fdd$var$ReadResult(func(first.value, second.value), $5347e5b2a03f8fdd$var$joinElements(first.extra, second.extra), first.messages.concat(second.messages));
};
function $5347e5b2a03f8fdd$var$combineResults(results) {
    var result = $5347e5b2a03f8fdd$require$Result.combine($gS9W9.default(results, "_result"));
    return new $5347e5b2a03f8fdd$var$ReadResult($1TwZj.default($gS9W9.default(result.value, "element")), $efEt3.default($1TwZj.default($gS9W9.default(result.value, "extra")), $5347e5b2a03f8fdd$var$identity), result.messages);
}
function $5347e5b2a03f8fdd$var$joinElements(first, second) {
    return $1TwZj.default([
        first,
        second
    ]);
}
function $5347e5b2a03f8fdd$var$identity(value) {
    return value;
}


var $bae7c73ea3cda3cb$require$createBodyReader = $5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f;
var $a83ff935f6e84a85$export$ff28ea179c35f727;
$a83ff935f6e84a85$export$ff28ea179c35f727 = $a83ff935f6e84a85$var$DocumentXmlReader;


var $a83ff935f6e84a85$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
function $a83ff935f6e84a85$var$DocumentXmlReader(options) {
    var bodyReader = options.bodyReader;
    function convertXmlToDocument(element) {
        var body = element.first("w:body");
        if (body == null) throw new Error("Could not find the body element: are you sure this is a docx file?");
        var result = bodyReader.readXmlElements(body.children).map(function(children) {
            return new $fcf129b7bd4ce72f$export$b34a105447964f9f(children, {
                notes: options.notes,
                comments: options.comments
            });
        });
        return new $a83ff935f6e84a85$require$Result(result.value, result.messages);
    }
    return {
        convertXmlToDocument: convertXmlToDocument
    };
}


var $bae7c73ea3cda3cb$require$DocumentXmlReader = $a83ff935f6e84a85$export$ff28ea179c35f727;
var $b695b801102bb06f$export$caf6d0f1ae2fd4d5;
var $b695b801102bb06f$export$1a01ae0705bafd37;
var $b695b801102bb06f$export$ddbf7887bc0aa836;
$b695b801102bb06f$export$caf6d0f1ae2fd4d5 = $b695b801102bb06f$var$readRelationships;
$b695b801102bb06f$export$1a01ae0705bafd37 = new $b695b801102bb06f$var$Relationships([]);
$b695b801102bb06f$export$ddbf7887bc0aa836 = $b695b801102bb06f$var$Relationships;
function $b695b801102bb06f$var$readRelationships(element) {
    var relationships = [];
    element.children.forEach(function(child) {
        if (child.name === "relationships:Relationship") {
            var relationship = {
                relationshipId: child.attributes.Id,
                target: child.attributes.Target,
                type: child.attributes.Type
            };
            relationships.push(relationship);
        }
    });
    return new $b695b801102bb06f$var$Relationships(relationships);
}
function $b695b801102bb06f$var$Relationships(relationships) {
    var targetsByRelationshipId = {};
    relationships.forEach(function(relationship) {
        targetsByRelationshipId[relationship.relationshipId] = relationship.target;
    });
    var targetsByType = {};
    relationships.forEach(function(relationship) {
        if (!targetsByType[relationship.type]) targetsByType[relationship.type] = [];
        targetsByType[relationship.type].push(relationship.target);
    });
    return {
        findTargetByRelationshipId: function(relationshipId) {
            return targetsByRelationshipId[relationshipId];
        },
        findTargetsByType: function(type) {
            return targetsByType[type] || [];
        }
    };
}


var $db8eecfa38181f3c$export$c97a5c0bc99ab2ff;
var $db8eecfa38181f3c$export$dcc72562f777bfbb;
$db8eecfa38181f3c$export$c97a5c0bc99ab2ff = $db8eecfa38181f3c$var$readContentTypesFromXml;
var $db8eecfa38181f3c$var$fallbackContentTypes = {
    "png": "png",
    "gif": "gif",
    "jpeg": "jpeg",
    "jpg": "jpeg",
    "tif": "tiff",
    "tiff": "tiff",
    "bmp": "bmp"
};
$db8eecfa38181f3c$export$dcc72562f777bfbb = $db8eecfa38181f3c$var$contentTypes({}, {});
function $db8eecfa38181f3c$var$readContentTypesFromXml(element) {
    var extensionDefaults = {};
    var overrides = {};
    element.children.forEach(function(child) {
        if (child.name === "content-types:Default") extensionDefaults[child.attributes.Extension] = child.attributes.ContentType;
        if (child.name === "content-types:Override") {
            var name = child.attributes.PartName;
            if (name.charAt(0) === "/") name = name.substring(1);
            overrides[name] = child.attributes.ContentType;
        }
    });
    return $db8eecfa38181f3c$var$contentTypes(overrides, extensionDefaults);
}
function $db8eecfa38181f3c$var$contentTypes(overrides, extensionDefaults) {
    return {
        findContentType: function(path) {
            var overrideContentType = overrides[path];
            if (overrideContentType) return overrideContentType;
            else {
                var pathParts = path.split(".");
                var extension = pathParts[pathParts.length - 1];
                if (extensionDefaults.hasOwnProperty(extension)) return extensionDefaults[extension];
                else {
                    var fallback = $db8eecfa38181f3c$var$fallbackContentTypes[extension.toLowerCase()];
                    if (fallback) return "image/" + fallback;
                    else return null;
                }
            }
        }
    };
}


var $51193c930ee97617$export$740149d4d5c5888e;
var $51193c930ee97617$export$521a466b2293b1d9;
var $51193c930ee97617$export$4a4adb64dd5d0f9b;
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");
var $bJcvr = parcelRequire("bJcvr");
var $gNJrf = parcelRequire("gNJrf");
$51193c930ee97617$export$740149d4d5c5888e = $51193c930ee97617$var$readNumberingXml;
$51193c930ee97617$export$521a466b2293b1d9 = $51193c930ee97617$var$Numbering;
$51193c930ee97617$export$4a4adb64dd5d0f9b = new $51193c930ee97617$var$Numbering({}, {});
function $51193c930ee97617$var$Numbering(nums, abstractNums, styles) {
    var allLevels = $1TwZj.default($gNJrf.default(abstractNums).map(function(abstractNum) {
        return $gNJrf.default(abstractNum.levels);
    }));
    var levelsByParagraphStyleId = $bJcvr.default(allLevels.filter(function(level) {
        return level.paragraphStyleId != null;
    }), "paragraphStyleId");
    function findLevel(numId, level) {
        var num = nums[numId];
        if (num) {
            var abstractNum = abstractNums[num.abstractNumId];
            if (!abstractNum) return null;
            else if (abstractNum.numStyleLink == null) return abstractNums[num.abstractNumId].levels[level];
            else {
                var style = styles.findNumberingStyleById(abstractNum.numStyleLink);
                return findLevel(style.numId, level);
            }
        } else return null;
    }
    function findLevelByParagraphStyleId(styleId) {
        return levelsByParagraphStyleId[styleId] || null;
    }
    return {
        findLevel: findLevel,
        findLevelByParagraphStyleId: findLevelByParagraphStyleId
    };
}
function $51193c930ee97617$var$readNumberingXml(root, options) {
    if (!options || !options.styles) throw new Error("styles is missing");
    var abstractNums = $51193c930ee97617$var$readAbstractNums(root);
    var nums = $51193c930ee97617$var$readNums(root, abstractNums);
    return new $51193c930ee97617$var$Numbering(nums, abstractNums, options.styles);
}
function $51193c930ee97617$var$readAbstractNums(root) {
    var abstractNums = {};
    root.getElementsByTagName("w:abstractNum").forEach(function(element) {
        var id = element.attributes["w:abstractNumId"];
        abstractNums[id] = $51193c930ee97617$var$readAbstractNum(element);
    });
    return abstractNums;
}
function $51193c930ee97617$var$readAbstractNum(element) {
    var levels = {};
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    var levelWithoutIndex = null;
    element.getElementsByTagName("w:lvl").forEach(function(levelElement) {
        var levelIndex = levelElement.attributes["w:ilvl"];
        var numFmt = levelElement.firstOrEmpty("w:numFmt").attributes["w:val"];
        var isOrdered = numFmt !== "bullet";
        var paragraphStyleId = levelElement.firstOrEmpty("w:pStyle").attributes["w:val"];
        if (levelIndex === undefined) levelWithoutIndex = {
            isOrdered: isOrdered,
            level: "0",
            paragraphStyleId: paragraphStyleId
        };
        else levels[levelIndex] = {
            isOrdered: isOrdered,
            level: levelIndex,
            paragraphStyleId: paragraphStyleId
        };
    });
    if (levelWithoutIndex !== null && levels[levelWithoutIndex.level] === undefined) levels[levelWithoutIndex.level] = levelWithoutIndex;
    var numStyleLink = element.firstOrEmpty("w:numStyleLink").attributes["w:val"];
    return {
        levels: levels,
        numStyleLink: numStyleLink
    };
}
function $51193c930ee97617$var$readNums(root) {
    var nums = {};
    root.getElementsByTagName("w:num").forEach(function(element) {
        var numId = element.attributes["w:numId"];
        var abstractNumId = element.first("w:abstractNumId").attributes["w:val"];
        nums[numId] = {
            abstractNumId: abstractNumId
        };
    });
    return nums;
}


var $b032473a280dcb14$export$b4a897ae7d66dcc8;
var $b032473a280dcb14$export$e155666bf54a9f18;
var $b032473a280dcb14$export$214b055320e0bf32;
$b032473a280dcb14$export$b4a897ae7d66dcc8 = $b032473a280dcb14$var$readStylesXml;
$b032473a280dcb14$export$e155666bf54a9f18 = $b032473a280dcb14$var$Styles;
$b032473a280dcb14$export$214b055320e0bf32 = new $b032473a280dcb14$var$Styles({}, {});
function $b032473a280dcb14$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles) {
    return {
        findParagraphStyleById: function(styleId) {
            return paragraphStyles[styleId];
        },
        findCharacterStyleById: function(styleId) {
            return characterStyles[styleId];
        },
        findTableStyleById: function(styleId) {
            return tableStyles[styleId];
        },
        findNumberingStyleById: function(styleId) {
            return numberingStyles[styleId];
        }
    };
}
$b032473a280dcb14$var$Styles.EMPTY = new $b032473a280dcb14$var$Styles({}, {}, {}, {});
function $b032473a280dcb14$var$readStylesXml(root) {
    var paragraphStyles = {};
    var characterStyles = {};
    var tableStyles = {};
    var numberingStyles = {};
    var styles = {
        "paragraph": paragraphStyles,
        "character": characterStyles,
        "table": tableStyles,
        "numbering": numberingStyles
    };
    root.getElementsByTagName("w:style").forEach(function(styleElement) {
        var style = $b032473a280dcb14$var$readStyleElement(styleElement);
        var styleSet = styles[style.type];
        // Per 17.7.4.17 style (Style Definition) of ECMA-376 4th edition Part 1:
        //
        // > If multiple style definitions each declare the same value for their
        // > styleId, then the first such instance shall keep its current
        // > identifier with all other instances being reassigned in any manner
        // > desired.
        //
        // For the purpose of conversion, there's no point holding onto styles
        // with reassigned style IDs, so we ignore such style definitions.
        if (styleSet && styleSet[style.styleId] === undefined) styleSet[style.styleId] = style;
    });
    return new $b032473a280dcb14$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles);
}
function $b032473a280dcb14$var$readStyleElement(styleElement) {
    var type = styleElement.attributes["w:type"];
    if (type === "numbering") return $b032473a280dcb14$var$readNumberingStyleElement(type, styleElement);
    else {
        var styleId = $b032473a280dcb14$var$readStyleId(styleElement);
        var name = $b032473a280dcb14$var$styleName(styleElement);
        return {
            type: type,
            styleId: styleId,
            name: name
        };
    }
}
function $b032473a280dcb14$var$styleName(styleElement) {
    var nameElement = styleElement.first("w:name");
    return nameElement ? nameElement.attributes["w:val"] : null;
}
function $b032473a280dcb14$var$readNumberingStyleElement(type, styleElement) {
    var styleId = $b032473a280dcb14$var$readStyleId(styleElement);
    var numId = styleElement.firstOrEmpty("w:pPr").firstOrEmpty("w:numPr").firstOrEmpty("w:numId").attributes["w:val"];
    return {
        type: type,
        numId: numId,
        styleId: styleId
    };
}
function $b032473a280dcb14$var$readStyleId(styleElement) {
    return styleElement.attributes["w:styleId"];
}


var $1c34a1a3e6be79f6$exports = {};


var $1c34a1a3e6be79f6$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
$1c34a1a3e6be79f6$exports.createFootnotesReader = $1c34a1a3e6be79f6$var$createReader.bind($1c34a1a3e6be79f6$exports, "footnote");
$1c34a1a3e6be79f6$exports.createEndnotesReader = $1c34a1a3e6be79f6$var$createReader.bind($1c34a1a3e6be79f6$exports, "endnote");
function $1c34a1a3e6be79f6$var$createReader(noteType, bodyReader) {
    function readNotesXml(element) {
        return $1c34a1a3e6be79f6$require$Result.combine(element.getElementsByTagName("w:" + noteType).filter(isFootnoteElement).map(readFootnoteElement));
    }
    function isFootnoteElement(element) {
        var type = element.attributes["w:type"];
        return type !== "continuationSeparator" && type !== "separator";
    }
    function readFootnoteElement(footnoteElement) {
        var id = footnoteElement.attributes["w:id"];
        return bodyReader.readXmlElements(footnoteElement.children).map(function(body) {
            return $fcf129b7bd4ce72f$export$6c88bf799aca3d2b({
                noteType: noteType,
                noteId: id,
                body: body
            });
        });
    }
    return readNotesXml;
}


var $e810972ec6083c30$export$b170a9283c83e921;


var $e810972ec6083c30$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
function $e810972ec6083c30$var$createCommentsReader(bodyReader) {
    function readCommentsXml(element) {
        return $e810972ec6083c30$require$Result.combine(element.getElementsByTagName("w:comment").map(readCommentElement));
    }
    function readCommentElement(element) {
        var id = element.attributes["w:id"];
        function readOptionalAttribute(name) {
            return (element.attributes[name] || "").trim() || null;
        }
        return bodyReader.readXmlElements(element.children).map(function(body) {
            return $fcf129b7bd4ce72f$export$4a34f930e789283c({
                commentId: id,
                body: body,
                authorName: readOptionalAttribute("w:author"),
                authorInitials: readOptionalAttribute("w:initials")
            });
        });
    }
    return readCommentsXml;
}
$e810972ec6083c30$export$b170a9283c83e921 = $e810972ec6083c30$var$createCommentsReader;


var $9dc11ffa63e79aa5$export$9330ab61a7e5c11b;

var $d93yU = parcelRequire("d93yU");
$9dc11ffa63e79aa5$export$9330ab61a7e5c11b = $9dc11ffa63e79aa5$var$Files;
function $9dc11ffa63e79aa5$var$Files() {
    function read(uri) {
        return $d93yU.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
    }
    return {
        read: read
    };
}


var $bae7c73ea3cda3cb$require$Files = $9dc11ffa63e79aa5$export$9330ab61a7e5c11b;
function $bae7c73ea3cda3cb$var$read(docxFile, input, options) {
    input = input || {};
    options = options || {};
    var files = new $bae7c73ea3cda3cb$require$Files({
        externalFileAccess: options.externalFileAccess,
        relativeToFile: input.path
    });
    return $d93yU.props({
        contentTypes: $bae7c73ea3cda3cb$var$readContentTypesFromZipFile(docxFile),
        partPaths: $bae7c73ea3cda3cb$var$findPartPaths(docxFile),
        docxFile: docxFile,
        files: files
    }).also(function(result) {
        return {
            styles: $bae7c73ea3cda3cb$var$readStylesFromZipFile(docxFile, result.partPaths.styles)
        };
    }).also(function(result) {
        return {
            numbering: $bae7c73ea3cda3cb$var$readNumberingFromZipFile(docxFile, result.partPaths.numbering, result.styles)
        };
    }).also(function(result) {
        return {
            footnotes: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.footnotes, result, function(bodyReader, xml) {
                if (xml) return $1c34a1a3e6be79f6$exports.createFootnotesReader(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            }),
            endnotes: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.endnotes, result, function(bodyReader, xml) {
                if (xml) return $1c34a1a3e6be79f6$exports.createEndnotesReader(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            }),
            comments: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.comments, result, function(bodyReader, xml) {
                if (xml) return $e810972ec6083c30$export$b170a9283c83e921(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            })
        };
    }).also(function(result) {
        return {
            notes: result.footnotes.flatMap(function(footnotes) {
                return result.endnotes.map(function(endnotes) {
                    return new $fcf129b7bd4ce72f$export$aa31b211d2f4c3af(footnotes.concat(endnotes));
                });
            })
        };
    }).then(function(result) {
        return $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.mainDocument, result, function(bodyReader, xml) {
            return result.notes.flatMap(function(notes) {
                return result.comments.flatMap(function(comments) {
                    var reader = new $bae7c73ea3cda3cb$require$DocumentXmlReader({
                        bodyReader: bodyReader,
                        notes: notes,
                        comments: comments
                    });
                    return reader.convertXmlToDocument(xml);
                });
            });
        });
    });
}
function $bae7c73ea3cda3cb$var$findPartPaths(docxFile) {
    return $bae7c73ea3cda3cb$var$readPackageRelationships(docxFile).then(function(packageRelationships) {
        var mainDocumentPath = $bae7c73ea3cda3cb$var$findPartPath({
            docxFile: docxFile,
            relationships: packageRelationships,
            relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            basePath: "",
            fallbackPath: "word/document.xml"
        });
        if (!docxFile.exists(mainDocumentPath)) throw new Error("Could not find main document part. Are you sure this is a valid .docx file?");
        return $bae7c73ea3cda3cb$var$xmlFileReader({
            filename: $bae7c73ea3cda3cb$var$relationshipsFilename(mainDocumentPath),
            readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
            defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
        })(docxFile).then(function(documentRelationships) {
            function findPartRelatedToMainDocument(name) {
                return $bae7c73ea3cda3cb$var$findPartPath({
                    docxFile: docxFile,
                    relationships: documentRelationships,
                    relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/" + name,
                    basePath: $3e56e634a929bca6$export$824c337f43f2b64d(mainDocumentPath).dirname,
                    fallbackPath: "word/" + name + ".xml"
                });
            }
            return {
                mainDocument: mainDocumentPath,
                comments: findPartRelatedToMainDocument("comments"),
                endnotes: findPartRelatedToMainDocument("endnotes"),
                footnotes: findPartRelatedToMainDocument("footnotes"),
                numbering: findPartRelatedToMainDocument("numbering"),
                styles: findPartRelatedToMainDocument("styles")
            };
        });
    });
}
function $bae7c73ea3cda3cb$var$findPartPath(options) {
    var docxFile = options.docxFile;
    var relationships = options.relationships;
    var relationshipType = options.relationshipType;
    var basePath = options.basePath;
    var fallbackPath = options.fallbackPath;
    var targets = relationships.findTargetsByType(relationshipType);
    var normalisedTargets = targets.map(function(target) {
        return $bae7c73ea3cda3cb$var$stripPrefix($3e56e634a929bca6$export$b891921babc70093(basePath, target), "/");
    });
    var validTargets = normalisedTargets.filter(function(target) {
        return docxFile.exists(target);
    });
    if (validTargets.length === 0) return fallbackPath;
    else return validTargets[0];
}
function $bae7c73ea3cda3cb$var$stripPrefix(value, prefix) {
    if (value.substring(0, prefix.length) === prefix) return value.substring(prefix.length);
    else return value;
}
function $bae7c73ea3cda3cb$var$xmlFileReader(options) {
    return function(zipFile) {
        return $bae7c73ea3cda3cb$require$readXmlFromZipFile(zipFile, options.filename).then(function(element) {
            return element ? options.readElement(element) : options.defaultValue;
        });
    };
}
function $bae7c73ea3cda3cb$var$readXmlFileWithBody(filename, options, func) {
    var readRelationshipsFromZipFile = $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: $bae7c73ea3cda3cb$var$relationshipsFilename(filename),
        readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
        defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
    });
    return readRelationshipsFromZipFile(options.docxFile).then(function(relationships) {
        var bodyReader = new $bae7c73ea3cda3cb$require$createBodyReader({
            relationships: relationships,
            contentTypes: options.contentTypes,
            docxFile: options.docxFile,
            numbering: options.numbering,
            styles: options.styles,
            files: options.files
        });
        return $bae7c73ea3cda3cb$require$readXmlFromZipFile(options.docxFile, filename).then(function(xml) {
            return func(bodyReader, xml);
        });
    });
}
function $bae7c73ea3cda3cb$var$relationshipsFilename(filename) {
    var split = $3e56e634a929bca6$export$824c337f43f2b64d(filename);
    return $3e56e634a929bca6$export$b891921babc70093(split.dirname, "_rels", split.basename + ".rels");
}
var $bae7c73ea3cda3cb$var$readContentTypesFromZipFile = $bae7c73ea3cda3cb$var$xmlFileReader({
    filename: "[Content_Types].xml",
    readElement: $db8eecfa38181f3c$export$c97a5c0bc99ab2ff,
    defaultValue: $db8eecfa38181f3c$export$dcc72562f777bfbb
});
function $bae7c73ea3cda3cb$var$readNumberingFromZipFile(zipFile, path, styles) {
    return $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: path,
        readElement: function(element) {
            return $51193c930ee97617$export$740149d4d5c5888e(element, {
                styles: styles
            });
        },
        defaultValue: $51193c930ee97617$export$4a4adb64dd5d0f9b
    })(zipFile);
}
function $bae7c73ea3cda3cb$var$readStylesFromZipFile(zipFile, path) {
    return $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: path,
        readElement: $b032473a280dcb14$export$b4a897ae7d66dcc8,
        defaultValue: $b032473a280dcb14$export$214b055320e0bf32
    })(zipFile);
}
var $bae7c73ea3cda3cb$var$readPackageRelationships = $bae7c73ea3cda3cb$var$xmlFileReader({
    filename: "_rels/.rels",
    readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
    defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
});


var $8adee3ad65dc46ae$export$f183c412da6b1c0;
var $8adee3ad65dc46ae$export$98fd944a2c837b93;
parcelRequire("9jAvV");
var $bss2W = parcelRequire("bss2W");

var $d93yU = parcelRequire("d93yU");

$8adee3ad65dc46ae$export$f183c412da6b1c0 = $8adee3ad65dc46ae$var$writeStyleMap;
$8adee3ad65dc46ae$export$98fd944a2c837b93 = $8adee3ad65dc46ae$var$readStyleMap;
var $8adee3ad65dc46ae$var$schema = "http://schemas.zwobble.org/mammoth/style-map";
var $8adee3ad65dc46ae$var$styleMapPath = "mammoth/style-map";
var $8adee3ad65dc46ae$var$styleMapAbsolutePath = "/" + $8adee3ad65dc46ae$var$styleMapPath;
function $8adee3ad65dc46ae$var$writeStyleMap(docxFile, styleMap) {
    docxFile.write($8adee3ad65dc46ae$var$styleMapPath, styleMap);
    return $8adee3ad65dc46ae$var$updateRelationships(docxFile).then(function() {
        return $8adee3ad65dc46ae$var$updateContentTypes(docxFile);
    });
}
function $8adee3ad65dc46ae$var$updateRelationships(docxFile) {
    var path = "word/_rels/document.xml.rels";
    var relationshipsUri = "http://schemas.openxmlformats.org/package/2006/relationships";
    var relationshipElementName = "{" + relationshipsUri + "}Relationship";
    return docxFile.read(path, "utf8").then($aea06b742aa725d8$export$dda73877cb166cd3).then(function(relationshipsContainer) {
        var relationships = relationshipsContainer.children;
        $8adee3ad65dc46ae$var$addOrUpdateElement(relationships, relationshipElementName, "Id", {
            "Id": "rMammothStyleMap",
            "Type": $8adee3ad65dc46ae$var$schema,
            "Target": $8adee3ad65dc46ae$var$styleMapAbsolutePath
        });
        var namespaces = {
            "": relationshipsUri
        };
        return docxFile.write(path, $aea06b742aa725d8$export$48a3ce3d8cfe0ce1(relationshipsContainer, namespaces));
    });
}
function $8adee3ad65dc46ae$var$updateContentTypes(docxFile) {
    var path = "[Content_Types].xml";
    var contentTypesUri = "http://schemas.openxmlformats.org/package/2006/content-types";
    var overrideName = "{" + contentTypesUri + "}Override";
    return docxFile.read(path, "utf8").then($aea06b742aa725d8$export$dda73877cb166cd3).then(function(typesElement) {
        var children = typesElement.children;
        $8adee3ad65dc46ae$var$addOrUpdateElement(children, overrideName, "PartName", {
            "PartName": $8adee3ad65dc46ae$var$styleMapAbsolutePath,
            "ContentType": "text/prs.mammoth.style-map"
        });
        var namespaces = {
            "": contentTypesUri
        };
        return docxFile.write(path, $aea06b742aa725d8$export$48a3ce3d8cfe0ce1(typesElement, namespaces));
    });
}
function $8adee3ad65dc46ae$var$addOrUpdateElement(elements, name, identifyingAttribute, attributes) {
    var existingElement = $bss2W.default(elements, function(element) {
        return element.name === name && element.attributes[identifyingAttribute] === attributes[identifyingAttribute];
    });
    if (existingElement) existingElement.attributes = attributes;
    else elements.push($aea06b742aa725d8$export$8454457683f90105(name, attributes));
}
function $8adee3ad65dc46ae$var$readStyleMap(docxFile) {
    if (docxFile.exists($8adee3ad65dc46ae$var$styleMapPath)) return docxFile.read($8adee3ad65dc46ae$var$styleMapPath, "utf8");
    else return $d93yU.resolve(null);
}


var $67e37fd9055aa0c3$export$d10d7ab91c778d60;
var $67e37fd9055aa0c3$export$6e29e379a5b99e3b;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $e2Yic = parcelRequire("e2Yic");
var $1TwZj = parcelRequire("1TwZj");
var $bJcvr = parcelRequire("bJcvr");

var $d93yU = parcelRequire("d93yU");


var $hEvL6 = parcelRequire("hEvL6");


var $gOpjt = parcelRequire("gOpjt");

var $8eobO = parcelRequire("8eobO");
var $748ebd993e5bc6b9$export$47a3d634abc09f70;
var $6c31025a874fb8d1$export$47a3d634abc09f70;
parcelRequire("9jAvV");
var $gfTwJ = parcelRequire("gfTwJ");
var $ctpBH = parcelRequire("ctpBH");
$6c31025a874fb8d1$export$47a3d634abc09f70 = $6c31025a874fb8d1$var$writer;
function $6c31025a874fb8d1$var$writer(options) {
    options = options || {};
    if (options.prettyPrint) return $6c31025a874fb8d1$var$prettyWriter();
    else return $6c31025a874fb8d1$var$simpleWriter();
}
var $6c31025a874fb8d1$var$indentedElements = {
    div: true,
    p: true,
    ul: true,
    li: true
};
function $6c31025a874fb8d1$var$prettyWriter() {
    var indentationLevel = 0;
    var indentation = "  ";
    var stack = [];
    var start = true;
    var inText = false;
    var writer = $6c31025a874fb8d1$var$simpleWriter();
    function open(tagName, attributes) {
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) indent();
        stack.push(tagName);
        writer.open(tagName, attributes);
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) indentationLevel++;
        start = false;
    }
    function close(tagName) {
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) {
            indentationLevel--;
            indent();
        }
        stack.pop();
        writer.close(tagName);
    }
    function text(value) {
        startText();
        var text = isInPre() ? value : value.replace("\n", "\n" + indentation);
        writer.text(text);
    }
    function selfClosing(tagName, attributes) {
        indent();
        writer.selfClosing(tagName, attributes);
    }
    function insideIndentedElement() {
        return stack.length === 0 || $6c31025a874fb8d1$var$indentedElements[stack[stack.length - 1]];
    }
    function startText() {
        if (!inText) {
            indent();
            inText = true;
        }
    }
    function indent() {
        inText = false;
        if (!start && insideIndentedElement() && !isInPre()) {
            writer._append("\n");
            for(var i = 0; i < indentationLevel; i++)writer._append(indentation);
        }
    }
    function isInPre() {
        return $ctpBH.default(stack, function(tagName) {
            return tagName === "pre";
        });
    }
    return {
        asString: writer.asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
function $6c31025a874fb8d1$var$simpleWriter() {
    var fragments = [];
    function open(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + ">");
    }
    function close(tagName) {
        fragments.push("</" + tagName + ">");
    }
    function selfClosing(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + " />");
    }
    function generateAttributeString(attributes) {
        return $gfTwJ.default(attributes, function(value, key) {
            return " " + key + '="' + $6c31025a874fb8d1$var$escapeHtmlAttribute(value) + '"';
        }).join("");
    }
    function text(value) {
        fragments.push($6c31025a874fb8d1$var$escapeHtmlText(value));
    }
    function append(html) {
        fragments.push(html);
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing,
        _append: append
    };
}
function $6c31025a874fb8d1$var$escapeHtmlText(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $6c31025a874fb8d1$var$escapeHtmlAttribute(value) {
    return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


var $8b2cdf0352c3ba1f$export$47a3d634abc09f70;
parcelRequire("9jAvV");
var $ciHuQ = parcelRequire("ciHuQ");
function $8b2cdf0352c3ba1f$var$symmetricMarkdownElement(end) {
    return $8b2cdf0352c3ba1f$var$markdownElement(end, end);
}
function $8b2cdf0352c3ba1f$var$markdownElement(start, end) {
    return function() {
        return {
            start: start,
            end: end
        };
    };
}
function $8b2cdf0352c3ba1f$var$markdownLink(attributes) {
    var href = attributes.href || "";
    if (href) return {
        start: "[",
        end: "](" + href + ")",
        anchorPosition: "before"
    };
    else return {};
}
function $8b2cdf0352c3ba1f$var$markdownImage(attributes) {
    var src = attributes.src || "";
    var altText = attributes.alt || "";
    if (src || altText) return {
        start: "![" + altText + "](" + src + ")"
    };
    else return {};
}
function $8b2cdf0352c3ba1f$var$markdownList(options) {
    return function(attributes, list) {
        return {
            start: list ? "\n" : "",
            end: list ? "" : "\n",
            list: {
                isOrdered: options.isOrdered,
                indent: list ? list.indent + 1 : 0,
                count: 0
            }
        };
    };
}
function $8b2cdf0352c3ba1f$var$markdownListItem(attributes, list, listItem) {
    list = list || {
        indent: 0,
        isOrdered: false,
        count: 0
    };
    list.count++;
    listItem.hasClosed = false;
    var bullet = list.isOrdered ? list.count + "." : "-";
    var start = $8b2cdf0352c3ba1f$var$repeatString("\t", list.indent) + bullet + " ";
    return {
        start: start,
        end: function() {
            if (!listItem.hasClosed) {
                listItem.hasClosed = true;
                return "\n";
            }
        }
    };
}
var $8b2cdf0352c3ba1f$var$htmlToMarkdown = {
    "p": $8b2cdf0352c3ba1f$var$markdownElement("", "\n\n"),
    "br": $8b2cdf0352c3ba1f$var$markdownElement("", "  \n"),
    "ul": $8b2cdf0352c3ba1f$var$markdownList({
        isOrdered: false
    }),
    "ol": $8b2cdf0352c3ba1f$var$markdownList({
        isOrdered: true
    }),
    "li": $8b2cdf0352c3ba1f$var$markdownListItem,
    "strong": $8b2cdf0352c3ba1f$var$symmetricMarkdownElement("__"),
    "em": $8b2cdf0352c3ba1f$var$symmetricMarkdownElement("*"),
    "a": $8b2cdf0352c3ba1f$var$markdownLink,
    "img": $8b2cdf0352c3ba1f$var$markdownImage
};
(function() {
    for(var i = 1; i <= 6; i++)$8b2cdf0352c3ba1f$var$htmlToMarkdown["h" + i] = $8b2cdf0352c3ba1f$var$markdownElement($8b2cdf0352c3ba1f$var$repeatString("#", i) + " ", "\n\n");
})();
function $8b2cdf0352c3ba1f$var$repeatString(value, count) {
    return new Array(count + 1).join(value);
}
function $8b2cdf0352c3ba1f$var$markdownWriter() {
    var fragments = [];
    var elementStack = [];
    var list = null;
    var listItem = {};
    function open(tagName, attributes) {
        attributes = attributes || {};
        var createElement = $8b2cdf0352c3ba1f$var$htmlToMarkdown[tagName] || function() {
            return {};
        };
        var element = createElement(attributes, list, listItem);
        elementStack.push({
            end: element.end,
            list: list
        });
        if (element.list) list = element.list;
        var anchorBeforeStart = element.anchorPosition === "before";
        if (anchorBeforeStart) writeAnchor(attributes);
        fragments.push(element.start || "");
        if (!anchorBeforeStart) writeAnchor(attributes);
    }
    function writeAnchor(attributes) {
        if (attributes.id) fragments.push('<a id="' + attributes.id + '"></a>');
    }
    function close(tagName) {
        var element = elementStack.pop();
        list = element.list;
        var end = $ciHuQ.default(element.end) ? element.end() : element.end;
        fragments.push(end || "");
    }
    function selfClosing(tagName, attributes) {
        open(tagName, attributes);
        close(tagName);
    }
    function text(value) {
        fragments.push($8b2cdf0352c3ba1f$var$escapeMarkdown(value));
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
$8b2cdf0352c3ba1f$export$47a3d634abc09f70 = $8b2cdf0352c3ba1f$var$markdownWriter;
function $8b2cdf0352c3ba1f$var$escapeMarkdown(value) {
    return value.replace(/\\/g, '\\\\').replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, '\\$1');
}


$748ebd993e5bc6b9$export$47a3d634abc09f70 = $748ebd993e5bc6b9$var$writer;
function $748ebd993e5bc6b9$var$writer(options) {
    options = options || {};
    if (options.outputFormat === "markdown") return $8b2cdf0352c3ba1f$export$47a3d634abc09f70();
    else return $6c31025a874fb8d1$export$47a3d634abc09f70(options);
}


$67e37fd9055aa0c3$export$d10d7ab91c778d60 = $67e37fd9055aa0c3$var$DocumentConverter;
function $67e37fd9055aa0c3$var$DocumentConverter(options) {
    return {
        convertToHtml: function(element) {
            var comments = $bJcvr.default(element.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.document ? element.comments : [], "commentId");
            var conversion = new $67e37fd9055aa0c3$var$DocumentConversion(options, comments);
            return conversion.convertToHtml(element);
        }
    };
}
function $67e37fd9055aa0c3$var$DocumentConversion(options, comments) {
    var noteNumber = 1;
    var noteReferences = [];
    var referencedComments = [];
    options = $5yjjJ.default({
        ignoreEmptyParagraphs: true
    }, options);
    var idPrefix = options.idPrefix === undefined ? "" : options.idPrefix;
    var ignoreEmptyParagraphs = options.ignoreEmptyParagraphs;
    var defaultParagraphStyle = $hEvL6.topLevelElement("p");
    var styleMap = options.styleMap || [];
    function convertToHtml(document) {
        var messages = [];
        var html = elementToHtml(document, messages, {});
        var deferredNodes = [];
        $67e37fd9055aa0c3$var$walkHtml(html, function(node) {
            if (node.type === "deferred") deferredNodes.push(node);
        });
        var deferredValues = {};
        return $d93yU.mapSeries(deferredNodes, function(deferred) {
            return deferred.value().then(function(value) {
                deferredValues[deferred.id] = value;
            });
        }).then(function() {
            function replaceDeferred(nodes) {
                return $67e37fd9055aa0c3$var$flatMap(nodes, function(node) {
                    if (node.type === "deferred") return deferredValues[node.id];
                    else if (node.children) return [
                        $5yjjJ.default({}, node, {
                            children: replaceDeferred(node.children)
                        })
                    ];
                    else return [
                        node
                    ];
                });
            }
            var writer = $748ebd993e5bc6b9$export$47a3d634abc09f70({
                prettyPrint: options.prettyPrint,
                outputFormat: options.outputFormat
            });
            $8eobO.write(writer, $8eobO.simplify(replaceDeferred(html)));
            return new $11d28a8fc8838027$export$8fdcabde73f49165(writer.asString(), messages);
        });
    }
    function convertElements(elements, messages, options) {
        return $67e37fd9055aa0c3$var$flatMap(elements, function(element) {
            return elementToHtml(element, messages, options);
        });
    }
    function elementToHtml(element, messages, options) {
        if (!options) throw new Error("options not set");
        var handler = elementConverters[element.type];
        if (handler) return handler(element, messages, options);
        else return [];
    }
    function convertParagraph(element, messages, options) {
        return htmlPathForParagraph(element, messages).wrap(function() {
            var content = convertElements(element.children, messages, options);
            if (ignoreEmptyParagraphs) return content;
            else return [
                $8eobO.forceWrite
            ].concat(content);
        });
    }
    function htmlPathForParagraph(element, messages) {
        var style = findStyle(element);
        if (style) return style.to;
        else {
            if (element.styleId) messages.push($67e37fd9055aa0c3$var$unrecognisedStyleWarning("paragraph", element));
            return defaultParagraphStyle;
        }
    }
    function convertRun(run, messages, options) {
        var nodes = function() {
            return convertElements(run.children, messages, options);
        };
        var paths = [];
        if (run.highlight !== null) {
            var path = findHtmlPath({
                type: "highlight",
                color: run.highlight
            });
            if (path) paths.push(path);
        }
        if (run.isSmallCaps) paths.push(findHtmlPathForRunProperty("smallCaps"));
        if (run.isAllCaps) paths.push(findHtmlPathForRunProperty("allCaps"));
        if (run.isStrikethrough) paths.push(findHtmlPathForRunProperty("strikethrough", "s"));
        if (run.isUnderline) paths.push(findHtmlPathForRunProperty("underline"));
        if (run.verticalAlignment === $fcf129b7bd4ce72f$export$983b95e2e3722091.subscript) paths.push($hEvL6.element("sub", {}, {
            fresh: false
        }));
        if (run.verticalAlignment === $fcf129b7bd4ce72f$export$983b95e2e3722091.superscript) paths.push($hEvL6.element("sup", {}, {
            fresh: false
        }));
        if (run.isItalic) paths.push(findHtmlPathForRunProperty("italic", "em"));
        if (run.isBold) paths.push(findHtmlPathForRunProperty("bold", "strong"));
        var stylePath = $hEvL6.empty;
        var style = findStyle(run);
        if (style) stylePath = style.to;
        else if (run.styleId) messages.push($67e37fd9055aa0c3$var$unrecognisedStyleWarning("run", run));
        paths.push(stylePath);
        paths.forEach(function(path) {
            nodes = path.wrap.bind(path, nodes);
        });
        return nodes();
    }
    function findHtmlPathForRunProperty(elementType, defaultTagName) {
        var path = findHtmlPath({
            type: elementType
        });
        if (path) return path;
        else if (defaultTagName) return $hEvL6.element(defaultTagName, {}, {
            fresh: false
        });
        else return $hEvL6.empty;
    }
    function findHtmlPath(element, defaultPath) {
        var style = findStyle(element);
        return style ? style.to : defaultPath;
    }
    function findStyle(element) {
        for(var i = 0; i < styleMap.length; i++){
            if (styleMap[i].from.matches(element)) return styleMap[i];
        }
    }
    function recoveringConvertImage(convertImage) {
        return function(image, messages) {
            return $d93yU.attempt(function() {
                return convertImage(image, messages);
            }).caught(function(error) {
                messages.push($11d28a8fc8838027$export$a3bc9b8ed74fc(error));
                return [];
            });
        };
    }
    function noteHtmlId(note) {
        return referentHtmlId(note.noteType, note.noteId);
    }
    function noteRefHtmlId(note) {
        return referenceHtmlId(note.noteType, note.noteId);
    }
    function referentHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-" + referenceId);
    }
    function referenceHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-ref-" + referenceId);
    }
    function htmlId(suffix) {
        return idPrefix + suffix;
    }
    var defaultTablePath = $hEvL6.elements([
        $hEvL6.element("table", {}, {
            fresh: true
        })
    ]);
    function convertTable(element, messages, options) {
        return findHtmlPath(element, defaultTablePath).wrap(function() {
            return convertTableChildren(element, messages, options);
        });
    }
    function convertTableChildren(element, messages, options) {
        var bodyIndex = $e2Yic.default(element.children, function(child) {
            return !child.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableRow || !child.isHeader;
        });
        if (bodyIndex === -1) bodyIndex = element.children.length;
        var children;
        if (bodyIndex === 0) children = convertElements(element.children, messages, $5yjjJ.default({}, options, {
            isTableHeader: false
        }));
        else {
            var headRows = convertElements(element.children.slice(0, bodyIndex), messages, $5yjjJ.default({}, options, {
                isTableHeader: true
            }));
            var bodyRows = convertElements(element.children.slice(bodyIndex), messages, $5yjjJ.default({}, options, {
                isTableHeader: false
            }));
            children = [
                $8eobO.freshElement("thead", {}, headRows),
                $8eobO.freshElement("tbody", {}, bodyRows)
            ];
        }
        return [
            $8eobO.forceWrite
        ].concat(children);
    }
    function convertTableRow(element, messages, options) {
        var children = convertElements(element.children, messages, options);
        return [
            $8eobO.freshElement("tr", {}, [
                $8eobO.forceWrite
            ].concat(children))
        ];
    }
    function convertTableCell(element, messages, options) {
        var tagName = options.isTableHeader ? "th" : "td";
        var children = convertElements(element.children, messages, options);
        var attributes = {};
        if (element.colSpan !== 1) attributes.colspan = element.colSpan.toString();
        if (element.rowSpan !== 1) attributes.rowspan = element.rowSpan.toString();
        return [
            $8eobO.freshElement(tagName, attributes, [
                $8eobO.forceWrite
            ].concat(children))
        ];
    }
    function convertCommentReference(reference, messages, options) {
        return findHtmlPath(reference, $hEvL6.ignore).wrap(function() {
            var comment = comments[reference.commentId];
            var count = referencedComments.length + 1;
            var label = "[" + $67e37fd9055aa0c3$var$commentAuthorLabel(comment) + count + "]";
            referencedComments.push({
                label: label,
                comment: comment
            });
            // TODO: remove duplication with note references
            return [
                $8eobO.freshElement("a", {
                    href: "#" + referentHtmlId("comment", reference.commentId),
                    id: referenceHtmlId("comment", reference.commentId)
                }, [
                    $8eobO.text(label)
                ])
            ];
        });
    }
    function convertComment(referencedComment, messages, options) {
        // TODO: remove duplication with note references
        var label = referencedComment.label;
        var comment = referencedComment.comment;
        var body = convertElements(comment.body, messages, options).concat([
            $8eobO.nonFreshElement("p", {}, [
                $8eobO.text(" "),
                $8eobO.freshElement("a", {
                    "href": "#" + referenceHtmlId("comment", comment.commentId)
                }, [
                    $8eobO.text("\u2191")
                ])
            ])
        ]);
        return [
            $8eobO.freshElement("dt", {
                "id": referentHtmlId("comment", comment.commentId)
            }, [
                $8eobO.text("Comment " + label)
            ]),
            $8eobO.freshElement("dd", {}, body)
        ];
    }
    function convertBreak(element, messages, options) {
        return htmlPathForBreak(element).wrap(function() {
            return [];
        });
    }
    function htmlPathForBreak(element) {
        var style = findStyle(element);
        if (style) return style.to;
        else if (element.breakType === "line") return $hEvL6.topLevelElement("br");
        else return $hEvL6.empty;
    }
    var elementConverters = {
        "document": function(document, messages, options) {
            var children = convertElements(document.children, messages, options);
            var notes = noteReferences.map(function(noteReference) {
                return document.notes.resolve(noteReference);
            });
            var notesNodes = convertElements(notes, messages, options);
            return children.concat([
                $8eobO.freshElement("ol", {}, notesNodes),
                $8eobO.freshElement("dl", {}, $67e37fd9055aa0c3$var$flatMap(referencedComments, function(referencedComment) {
                    return convertComment(referencedComment, messages, options);
                }))
            ]);
        },
        "paragraph": convertParagraph,
        "run": convertRun,
        "text": function(element, messages, options) {
            return [
                $8eobO.text(element.value)
            ];
        },
        "tab": function(element, messages, options) {
            return [
                $8eobO.text("\t")
            ];
        },
        "hyperlink": function(element, messages, options) {
            var href = element.anchor ? "#" + htmlId(element.anchor) : element.href;
            var attributes = {
                href: href
            };
            if (element.targetFrame != null) attributes.target = element.targetFrame;
            var children = convertElements(element.children, messages, options);
            return [
                $8eobO.nonFreshElement("a", attributes, children)
            ];
        },
        "checkbox": function(element) {
            var attributes = {
                type: "checkbox"
            };
            if (element.checked) attributes["checked"] = "checked";
            return [
                $8eobO.freshElement("input", attributes)
            ];
        },
        "bookmarkStart": function(element, messages, options) {
            var anchor = $8eobO.freshElement("a", {
                id: htmlId(element.name)
            }, [
                $8eobO.forceWrite
            ]);
            return [
                anchor
            ];
        },
        "noteReference": function(element, messages, options) {
            noteReferences.push(element);
            var anchor = $8eobO.freshElement("a", {
                href: "#" + noteHtmlId(element),
                id: noteRefHtmlId(element)
            }, [
                $8eobO.text("[" + noteNumber++ + "]")
            ]);
            return [
                $8eobO.freshElement("sup", {}, [
                    anchor
                ])
            ];
        },
        "note": function(element, messages, options) {
            var children = convertElements(element.body, messages, options);
            var backLink = $8eobO.elementWithTag($hEvL6.element("p", {}, {
                fresh: false
            }), [
                $8eobO.text(" "),
                $8eobO.freshElement("a", {
                    href: "#" + noteRefHtmlId(element)
                }, [
                    $8eobO.text("\u2191")
                ])
            ]);
            var body = children.concat([
                backLink
            ]);
            return $8eobO.freshElement("li", {
                id: noteHtmlId(element)
            }, body);
        },
        "commentReference": convertCommentReference,
        "comment": convertComment,
        "image": $67e37fd9055aa0c3$var$deferredConversion(recoveringConvertImage(options.convertImage || $gOpjt.dataUri)),
        "table": convertTable,
        "tableRow": convertTableRow,
        "tableCell": convertTableCell,
        "break": convertBreak
    };
    return {
        convertToHtml: convertToHtml
    };
}
var $67e37fd9055aa0c3$var$deferredId = 1;
function $67e37fd9055aa0c3$var$deferredConversion(func) {
    return function(element, messages, options) {
        return [
            {
                type: "deferred",
                id: $67e37fd9055aa0c3$var$deferredId++,
                value: function() {
                    return func(element, messages, options);
                }
            }
        ];
    };
}
function $67e37fd9055aa0c3$var$unrecognisedStyleWarning(type, element) {
    return $11d28a8fc8838027$export$491112666e282270("Unrecognised " + type + " style: '" + element.styleName + "'" + " (Style ID: " + element.styleId + ")");
}
function $67e37fd9055aa0c3$var$flatMap(values, func) {
    return $1TwZj.default(values.map(func), true);
}
function $67e37fd9055aa0c3$var$walkHtml(nodes, callback) {
    nodes.forEach(function(node) {
        callback(node);
        if (node.children) $67e37fd9055aa0c3$var$walkHtml(node.children, callback);
    });
}
var $67e37fd9055aa0c3$var$commentAuthorLabel = $67e37fd9055aa0c3$export$6e29e379a5b99e3b = function commentAuthorLabel(comment) {
    return comment.authorInitials || "";
};


var $f489ff3da7c10b03$require$DocumentConverter = $67e37fd9055aa0c3$export$d10d7ab91c778d60;
var $7f9c344ce0507ba2$export$f04031f791975cf1;

function $7f9c344ce0507ba2$var$convertElementToRawText(element) {
    if (element.type === "text") return element.value;
    else if (element.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tab) return "\t";
    else {
        var tail = element.type === "paragraph" ? "\n\n" : "";
        return (element.children || []).map($7f9c344ce0507ba2$var$convertElementToRawText).join("") + tail;
    }
}
$7f9c344ce0507ba2$export$f04031f791975cf1 = $7f9c344ce0507ba2$var$convertElementToRawText;


var $f489ff3da7c10b03$require$convertElementToRawText = $7f9c344ce0507ba2$export$f04031f791975cf1;
var $185ecd02a4e67434$export$c013b05e5703966c;
var $185ecd02a4e67434$export$8355e188a552b07e;
var $185ecd02a4e67434$export$433ccb34ac23a8e9;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $7a863c37b872de91$export$7acfa6ed01010e37;
var $7a863c37b872de91$export$354076178bdef094;
var $7a863c37b872de91$export$30f3b02011db23c0;
var $7a863c37b872de91$export$5be82eb8d376fece;
var $7a863c37b872de91$export$7799bd957249d7a0;
var $7a863c37b872de91$export$50792b0e93539fde;
var $7a863c37b872de91$export$66e1bcdf7cde41a0;
var $7a863c37b872de91$export$74d15b5d79bf9ea;
var $7a863c37b872de91$export$fbeb3a3956e8a3c7;

$7a863c37b872de91$export$7acfa6ed01010e37 = (parcelRequire("17glP")).Parser;

$7a863c37b872de91$export$354076178bdef094 = (parcelRequire("moeVv"));

$7a863c37b872de91$export$30f3b02011db23c0 = (parcelRequire("5wxOh"));

$7a863c37b872de91$export$5be82eb8d376fece = (parcelRequire("cB0qU"));

$7a863c37b872de91$export$7799bd957249d7a0 = (parcelRequire("8kl1m"));

$7a863c37b872de91$export$50792b0e93539fde = (parcelRequire("7f4pG"));

$7a863c37b872de91$export$66e1bcdf7cde41a0 = (parcelRequire("fqgYr"));

$7a863c37b872de91$export$74d15b5d79bf9ea = (parcelRequire("FZqT4")).RegexTokeniser;
$7a863c37b872de91$export$fbeb3a3956e8a3c7 = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};


var $70d33b994ac62e43$export$9c206ddddb32a9b;
var $70d33b994ac62e43$export$889ea624f2cb2c57;
var $70d33b994ac62e43$export$9852986a3ec5f6a0;
var $70d33b994ac62e43$export$73ba5813cda80a49;
var $70d33b994ac62e43$export$5540da1282cbf565;
var $70d33b994ac62e43$export$425327af25286e5e;
var $70d33b994ac62e43$export$19426ff118fe8be;
var $70d33b994ac62e43$export$dc07c1d187ec2934;
var $70d33b994ac62e43$export$394ff16a4cefe989;
var $70d33b994ac62e43$export$e4043f67d36cbb26;
var $70d33b994ac62e43$export$841d4c6db70c1a65;
var $70d33b994ac62e43$export$a1aa2dd4ad0d3f6;
var $70d33b994ac62e43$export$1b438cdd7ed26c35;
var $70d33b994ac62e43$export$5a38f5b463e49b91;
var $70d33b994ac62e43$export$bdcdec1f91f16dff;
var $70d33b994ac62e43$export$68326237475e9a7d;
$70d33b994ac62e43$export$9c206ddddb32a9b = $70d33b994ac62e43$var$paragraph;
$70d33b994ac62e43$export$889ea624f2cb2c57 = $70d33b994ac62e43$var$run;
$70d33b994ac62e43$export$9852986a3ec5f6a0 = $70d33b994ac62e43$var$table;
$70d33b994ac62e43$export$73ba5813cda80a49 = new $70d33b994ac62e43$var$Matcher("bold");
$70d33b994ac62e43$export$5540da1282cbf565 = new $70d33b994ac62e43$var$Matcher("italic");
$70d33b994ac62e43$export$425327af25286e5e = new $70d33b994ac62e43$var$Matcher("underline");
$70d33b994ac62e43$export$19426ff118fe8be = new $70d33b994ac62e43$var$Matcher("strikethrough");
$70d33b994ac62e43$export$dc07c1d187ec2934 = new $70d33b994ac62e43$var$Matcher("allCaps");
$70d33b994ac62e43$export$394ff16a4cefe989 = new $70d33b994ac62e43$var$Matcher("smallCaps");
$70d33b994ac62e43$export$e4043f67d36cbb26 = $70d33b994ac62e43$var$highlight;
$70d33b994ac62e43$export$841d4c6db70c1a65 = new $70d33b994ac62e43$var$Matcher("commentReference");
$70d33b994ac62e43$export$a1aa2dd4ad0d3f6 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "line"
});
$70d33b994ac62e43$export$1b438cdd7ed26c35 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "page"
});
$70d33b994ac62e43$export$5a38f5b463e49b91 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "column"
});
$70d33b994ac62e43$export$bdcdec1f91f16dff = $70d33b994ac62e43$var$equalTo;
$70d33b994ac62e43$export$68326237475e9a7d = $70d33b994ac62e43$var$startsWith;
function $70d33b994ac62e43$var$paragraph(options) {
    return new $70d33b994ac62e43$var$Matcher("paragraph", options);
}
function $70d33b994ac62e43$var$run(options) {
    return new $70d33b994ac62e43$var$Matcher("run", options);
}
function $70d33b994ac62e43$var$table(options) {
    return new $70d33b994ac62e43$var$Matcher("table", options);
}
function $70d33b994ac62e43$var$highlight(options) {
    return new $70d33b994ac62e43$var$HighlightMatcher(options);
}
function $70d33b994ac62e43$var$Matcher(elementType, options) {
    options = options || {};
    this._elementType = elementType;
    this._styleId = options.styleId;
    this._styleName = options.styleName;
    if (options.list) {
        this._listIndex = options.list.levelIndex;
        this._listIsOrdered = options.list.isOrdered;
    }
}
$70d33b994ac62e43$var$Matcher.prototype.matches = function(element) {
    return element.type === this._elementType && (this._styleId === undefined || element.styleId === this._styleId) && (this._styleName === undefined || element.styleName && this._styleName.operator(this._styleName.operand, element.styleName)) && (this._listIndex === undefined || $70d33b994ac62e43$var$isList(element, this._listIndex, this._listIsOrdered)) && (this._breakType === undefined || this._breakType === element.breakType);
};
function $70d33b994ac62e43$var$HighlightMatcher(options) {
    options = options || {};
    this._color = options.color;
}
$70d33b994ac62e43$var$HighlightMatcher.prototype.matches = function(element) {
    return element.type === "highlight" && (this._color === undefined || element.color === this._color);
};
function $70d33b994ac62e43$var$BreakMatcher(options) {
    options = options || {};
    this._breakType = options.breakType;
}
$70d33b994ac62e43$var$BreakMatcher.prototype.matches = function(element) {
    return element.type === "break" && (this._breakType === undefined || element.breakType === this._breakType);
};
function $70d33b994ac62e43$var$isList(element, levelIndex, isOrdered) {
    return element.numbering && element.numbering.level == levelIndex && element.numbering.isOrdered == isOrdered;
}
function $70d33b994ac62e43$var$equalTo(value) {
    return {
        operator: $70d33b994ac62e43$var$operatorEqualTo,
        operand: value
    };
}
function $70d33b994ac62e43$var$startsWith(value) {
    return {
        operator: $70d33b994ac62e43$var$operatorStartsWith,
        operand: value
    };
}
function $70d33b994ac62e43$var$operatorEqualTo(first, second) {
    return first.toUpperCase() === second.toUpperCase();
}
function $70d33b994ac62e43$var$operatorStartsWith(first, second) {
    return second.toUpperCase().indexOf(first.toUpperCase()) === 0;
}



var $hEvL6 = parcelRequire("hEvL6");
var $95d4e788901bc43b$export$3e101593fe008f79;

var $95d4e788901bc43b$var$RegexTokeniser = $7a863c37b872de91$export$74d15b5d79bf9ea;
$95d4e788901bc43b$export$3e101593fe008f79 = $95d4e788901bc43b$var$tokenise;
var $95d4e788901bc43b$var$stringPrefix = "'((?:\\\\.|[^'])*)";
function $95d4e788901bc43b$var$tokenise(string) {
    var identifierCharacter = "(?:[a-zA-Z\\-_]|\\\\.)";
    var tokeniser = new $95d4e788901bc43b$var$RegexTokeniser([
        {
            name: "identifier",
            regex: new RegExp("(" + identifierCharacter + "(?:" + identifierCharacter + "|[0-9])*)")
        },
        {
            name: "dot",
            regex: /\./
        },
        {
            name: "colon",
            regex: /:/
        },
        {
            name: "gt",
            regex: />/
        },
        {
            name: "whitespace",
            regex: /\s+/
        },
        {
            name: "arrow",
            regex: /=>/
        },
        {
            name: "equals",
            regex: /=/
        },
        {
            name: "startsWith",
            regex: /\^=/
        },
        {
            name: "open-paren",
            regex: /\(/
        },
        {
            name: "close-paren",
            regex: /\)/
        },
        {
            name: "open-square-bracket",
            regex: /\[/
        },
        {
            name: "close-square-bracket",
            regex: /\]/
        },
        {
            name: "string",
            regex: new RegExp($95d4e788901bc43b$var$stringPrefix + "'")
        },
        {
            name: "unterminated-string",
            regex: new RegExp($95d4e788901bc43b$var$stringPrefix)
        },
        {
            name: "integer",
            regex: /([0-9]+)/
        },
        {
            name: "choice",
            regex: /\|/
        },
        {
            name: "bang",
            regex: /(!)/
        }
    ]);
    return tokeniser.tokenise(string);
}


var $185ecd02a4e67434$require$tokenise = $95d4e788901bc43b$export$3e101593fe008f79;

$185ecd02a4e67434$export$c013b05e5703966c = $185ecd02a4e67434$var$readHtmlPath;
$185ecd02a4e67434$export$8355e188a552b07e = $185ecd02a4e67434$var$readDocumentMatcher;
$185ecd02a4e67434$export$433ccb34ac23a8e9 = $185ecd02a4e67434$var$readStyle;
function $185ecd02a4e67434$var$readStyle(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$styleRule, string);
}
function $185ecd02a4e67434$var$createStyleRule() {
    return $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$documentMatcherRule()), $7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("arrow"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$htmlPathRule())).head())), $7a863c37b872de91$export$354076178bdef094.tokenOfType("end")).map(function(documentMatcher, htmlPath) {
        return {
            from: documentMatcher,
            to: htmlPath.valueOrElse($hEvL6.empty)
        };
    });
}
function $185ecd02a4e67434$var$readDocumentMatcher(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$documentMatcherRule(), string);
}
function $185ecd02a4e67434$var$documentMatcherRule() {
    var sequence = $7a863c37b872de91$export$354076178bdef094.sequence;
    var identifierToConstant = function(identifier, constant) {
        return $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.token("identifier", identifier), function() {
            return constant;
        });
    };
    var paragraphRule = identifierToConstant("p", $70d33b994ac62e43$export$9c206ddddb32a9b);
    var runRule = identifierToConstant("r", $70d33b994ac62e43$export$889ea624f2cb2c57);
    var elementTypeRule = $7a863c37b872de91$export$354076178bdef094.firstOf("p or r or table", paragraphRule, runRule);
    var styleIdRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("dot"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule)).map(function(styleId) {
        return {
            styleId: styleId
        };
    });
    var styleNameMatcherRule = $7a863c37b872de91$export$354076178bdef094.firstOf("style name matcher", $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $70d33b994ac62e43$export$bdcdec1f91f16dff(styleName)
        };
    }), $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("startsWith"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $70d33b994ac62e43$export$68326237475e9a7d(styleName)
        };
    }));
    var styleNameRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.token("identifier", "style-name"), $7a863c37b872de91$export$354076178bdef094.sequence.capture(styleNameMatcherRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).head();
    var listTypeRule = $7a863c37b872de91$export$354076178bdef094.firstOf("list type", identifierToConstant("ordered-list", {
        isOrdered: true
    }), identifierToConstant("unordered-list", {
        isOrdered: false
    }));
    var listRule = sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), sequence.capture(listTypeRule), sequence.cut(), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-paren"), sequence.capture($185ecd02a4e67434$var$integerRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-paren")).map(function(listType, levelNumber) {
        return {
            list: {
                isOrdered: listType.isOrdered,
                levelIndex: levelNumber - 1
            }
        };
    });
    function createMatcherSuffixesRule(rules) {
        var matcherSuffix = $7a863c37b872de91$export$354076178bdef094.firstOf.apply($7a863c37b872de91$export$354076178bdef094.firstOf, [
            "matcher suffix"
        ].concat(rules));
        var matcherSuffixes = $7a863c37b872de91$export$354076178bdef094.zeroOrMore(matcherSuffix);
        return $7a863c37b872de91$export$354076178bdef094.then(matcherSuffixes, function(suffixes) {
            var matcherOptions = {};
            suffixes.forEach(function(suffix) {
                $5yjjJ.default(matcherOptions, suffix);
            });
            return matcherOptions;
        });
    }
    var paragraphOrRun = sequence(sequence.capture(elementTypeRule), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule,
        listRule
    ]))).map(function(createMatcher, matcherOptions) {
        return createMatcher(matcherOptions);
    });
    var table = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "table"), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule
    ]))).map(function(options) {
        return $70d33b994ac62e43$export$9852986a3ec5f6a0(options);
    });
    var bold = identifierToConstant("b", $70d33b994ac62e43$export$73ba5813cda80a49);
    var italic = identifierToConstant("i", $70d33b994ac62e43$export$5540da1282cbf565);
    var underline = identifierToConstant("u", $70d33b994ac62e43$export$425327af25286e5e);
    var strikethrough = identifierToConstant("strike", $70d33b994ac62e43$export$19426ff118fe8be);
    var allCaps = identifierToConstant("all-caps", $70d33b994ac62e43$export$dc07c1d187ec2934);
    var smallCaps = identifierToConstant("small-caps", $70d33b994ac62e43$export$394ff16a4cefe989);
    var highlight = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "highlight"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.token("identifier", "color"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).head()))).map(function(color) {
        return $70d33b994ac62e43$export$e4043f67d36cbb26({
            color: color.valueOrElse(undefined)
        });
    });
    var commentReference = identifierToConstant("comment-reference", $70d33b994ac62e43$export$841d4c6db70c1a65);
    var breakMatcher = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "br"), sequence.cut(), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "type"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(breakType) {
        switch(breakType){
            case "line":
                return $70d33b994ac62e43$export$a1aa2dd4ad0d3f6;
            case "page":
                return $70d33b994ac62e43$export$1b438cdd7ed26c35;
            case "column":
                return $70d33b994ac62e43$export$5a38f5b463e49b91;
            default:
        }
    });
    return $7a863c37b872de91$export$354076178bdef094.firstOf("element type", paragraphOrRun, table, bold, italic, underline, strikethrough, allCaps, smallCaps, highlight, commentReference, breakMatcher);
}
function $185ecd02a4e67434$var$readHtmlPath(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$htmlPathRule(), string);
}
function $185ecd02a4e67434$var$htmlPathRule() {
    var capture = $7a863c37b872de91$export$354076178bdef094.sequence.capture;
    var whitespaceRule = $7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace");
    var freshRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "fresh"))), function(option) {
        return option.map(function() {
            return true;
        }).valueOrElse(false);
    });
    var separatorRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "separator"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-paren"), capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-paren")).head()), function(option) {
        return option.valueOrElse("");
    });
    var tagNamesRule = $7a863c37b872de91$export$354076178bdef094.oneOrMoreWithSeparator($185ecd02a4e67434$var$identifierRule, $7a863c37b872de91$export$354076178bdef094.tokenOfType("choice"));
    var styleElementRule = $7a863c37b872de91$export$354076178bdef094.sequence(capture(tagNamesRule), capture($7a863c37b872de91$export$354076178bdef094.zeroOrMore($185ecd02a4e67434$var$attributeOrClassRule)), capture(freshRule), capture(separatorRule)).map(function(tagName, attributesList, fresh, separator) {
        var attributes = {};
        var options = {};
        attributesList.forEach(function(attribute) {
            if (attribute.append && attributes[attribute.name]) attributes[attribute.name] += " " + attribute.value;
            else attributes[attribute.name] = attribute.value;
        });
        if (fresh) options.fresh = true;
        if (separator) options.separator = separator;
        return $hEvL6.element(tagName, attributes, options);
    });
    return $7a863c37b872de91$export$354076178bdef094.firstOf("html path", $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("bang"), function() {
        return $hEvL6.ignore;
    }), $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.zeroOrMoreWithSeparator(styleElementRule, $7a863c37b872de91$export$354076178bdef094.sequence(whitespaceRule, $7a863c37b872de91$export$354076178bdef094.tokenOfType("gt"), whitespaceRule)), $hEvL6.elements));
}
var $185ecd02a4e67434$var$identifierRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("identifier"), $185ecd02a4e67434$var$decodeEscapeSequences);
var $185ecd02a4e67434$var$integerRule = $7a863c37b872de91$export$354076178bdef094.tokenOfType("integer");
var $185ecd02a4e67434$var$stringRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("string"), $185ecd02a4e67434$var$decodeEscapeSequences);
var $185ecd02a4e67434$var$escapeSequences = {
    "n": "\n",
    "r": "\r",
    "t": "\t"
};
function $185ecd02a4e67434$var$decodeEscapeSequences(value) {
    return value.replace(/\\(.)/g, function(match, code) {
        return $185ecd02a4e67434$var$escapeSequences[code] || code;
    });
}
var $185ecd02a4e67434$var$attributeRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(name, value) {
    return {
        name: name,
        value: value,
        append: false
    };
});
var $185ecd02a4e67434$var$classRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("dot"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule)).map(function(className) {
    return {
        name: "class",
        value: className,
        append: true
    };
});
var $185ecd02a4e67434$var$attributeOrClassRule = $7a863c37b872de91$export$354076178bdef094.firstOf("attribute or class", $185ecd02a4e67434$var$attributeRule, $185ecd02a4e67434$var$classRule);
function $185ecd02a4e67434$var$parseString(rule, string) {
    var tokens = $185ecd02a4e67434$require$tokenise(string);
    var parser = $7a863c37b872de91$export$7acfa6ed01010e37();
    var parseResult = parser.parseTokens(rule, tokens);
    if (parseResult.isSuccess()) return $11d28a8fc8838027$export$fe7c49d056ea1d88(parseResult.value());
    else return new $11d28a8fc8838027$export$8fdcabde73f49165(null, [
        $11d28a8fc8838027$export$491112666e282270($185ecd02a4e67434$var$describeFailure(string, parseResult))
    ]);
}
function $185ecd02a4e67434$var$describeFailure(input, parseResult) {
    return "Did not understand this style mapping, so ignored it: " + input + "\n" + parseResult.errors().map($185ecd02a4e67434$var$describeError).join("\n");
}
function $185ecd02a4e67434$var$describeError(error) {
    return "Error was at character number " + error.characterNumber() + ": " + "Expected " + error.expected + " but got " + error.actual;
}
var $185ecd02a4e67434$var$styleRule = $185ecd02a4e67434$var$createStyleRule();


var $f489ff3da7c10b03$require$readStyle = $185ecd02a4e67434$export$433ccb34ac23a8e9;
var $85dd06109b9e0944$export$78af9b5fc65e58de;
var $85dd06109b9e0944$export$eb9991766a046a21;
var $85dd06109b9e0944$export$635424202fde079c;
$85dd06109b9e0944$export$78af9b5fc65e58de = $85dd06109b9e0944$var$readOptions;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $jmGFg = parcelRequire("jmGFg");
var $85dd06109b9e0944$var$defaultStyleMap = $85dd06109b9e0944$export$eb9991766a046a21 = [
    "p.Heading1 => h1:fresh",
    "p.Heading2 => h2:fresh",
    "p.Heading3 => h3:fresh",
    "p.Heading4 => h4:fresh",
    "p.Heading5 => h5:fresh",
    "p.Heading6 => h6:fresh",
    "p[style-name='Heading 1'] => h1:fresh",
    "p[style-name='Heading 2'] => h2:fresh",
    "p[style-name='Heading 3'] => h3:fresh",
    "p[style-name='Heading 4'] => h4:fresh",
    "p[style-name='Heading 5'] => h5:fresh",
    "p[style-name='Heading 6'] => h6:fresh",
    "p[style-name='heading 1'] => h1:fresh",
    "p[style-name='heading 2'] => h2:fresh",
    "p[style-name='heading 3'] => h3:fresh",
    "p[style-name='heading 4'] => h4:fresh",
    "p[style-name='heading 5'] => h5:fresh",
    "p[style-name='heading 6'] => h6:fresh",
    // Apple Pages
    "p.Heading => h1:fresh",
    "p[style-name='Heading'] => h1:fresh",
    "r[style-name='Strong'] => strong",
    "p[style-name='footnote text'] => p:fresh",
    "r[style-name='footnote reference'] =>",
    "p[style-name='endnote text'] => p:fresh",
    "r[style-name='endnote reference'] =>",
    "p[style-name='annotation text'] => p:fresh",
    "r[style-name='annotation reference'] =>",
    // LibreOffice
    "p[style-name='Footnote'] => p:fresh",
    "r[style-name='Footnote anchor'] =>",
    "p[style-name='Endnote'] => p:fresh",
    "r[style-name='Endnote anchor'] =>",
    "p:unordered-list(1) => ul > li:fresh",
    "p:unordered-list(2) => ul|ol > li > ul > li:fresh",
    "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:ordered-list(1) => ol > li:fresh",
    "p:ordered-list(2) => ul|ol > li > ol > li:fresh",
    "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "r[style-name='Hyperlink'] =>",
    "p[style-name='Normal'] => p:fresh",
    // Apple Pages
    "p.Body => p:fresh",
    "p[style-name='Body'] => p:fresh"
];
var $85dd06109b9e0944$var$standardOptions = $85dd06109b9e0944$export$635424202fde079c = {
    externalFileAccess: false,
    transformDocument: $85dd06109b9e0944$var$identity,
    includeDefaultStyleMap: true,
    includeEmbeddedStyleMap: true
};
function $85dd06109b9e0944$var$readOptions(options) {
    options = options || {};
    return $5yjjJ.default({}, $85dd06109b9e0944$var$standardOptions, options, {
        customStyleMap: $85dd06109b9e0944$var$readStyleMap(options.styleMap),
        readStyleMap: function() {
            var styleMap = this.customStyleMap;
            if (this.includeEmbeddedStyleMap) styleMap = styleMap.concat($85dd06109b9e0944$var$readStyleMap(this.embeddedStyleMap));
            if (this.includeDefaultStyleMap) styleMap = styleMap.concat($85dd06109b9e0944$var$defaultStyleMap);
            return styleMap;
        }
    });
}
function $85dd06109b9e0944$var$readStyleMap(styleMap) {
    if (!styleMap) return [];
    else if ($jmGFg.default(styleMap)) return styleMap.split("\n").map(function(line) {
        return line.trim();
    }).filter(function(line) {
        return line !== "" && line.charAt(0) !== "#";
    });
    else return styleMap;
}
function $85dd06109b9e0944$var$identity(value) {
    return value;
}


var $f489ff3da7c10b03$require$readOptions = $85dd06109b9e0944$export$78af9b5fc65e58de;
var $06ba6368d49e55c3$export$dabc29ca0a11e3cc;

var $d93yU = parcelRequire("d93yU");

$06ba6368d49e55c3$export$dabc29ca0a11e3cc = $06ba6368d49e55c3$var$openZip;
function $06ba6368d49e55c3$var$openZip(options) {
    if (options.arrayBuffer) return $d93yU.resolve($3e56e634a929bca6$export$94ea64f322e5a37c(options.arrayBuffer));
    else return $d93yU.reject(new Error("Could not find file in options"));
}



var $f489ff3da7c10b03$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
$f489ff3da7c10b03$export$7b82ddf1ba8788ff = $f489ff3da7c10b03$var$convertToHtml;
$f489ff3da7c10b03$export$16c74263c98473fb = $f489ff3da7c10b03$var$convertToMarkdown;
$f489ff3da7c10b03$export$9c68d69a4c5bbcf9 = $f489ff3da7c10b03$var$convert;
$f489ff3da7c10b03$export$a1ba744cb18565b5 = $f489ff3da7c10b03$var$extractRawText;

$f489ff3da7c10b03$export$6c746a5570b8b35c = (parcelRequire("gOpjt"));

$f489ff3da7c10b03$export$63e4f03d302d3e40 = (parcelRequire("kUMgi"));

$f489ff3da7c10b03$export$425327af25286e5e = (parcelRequire("1OnEJ"));
$f489ff3da7c10b03$export$7d85d7e73199d20c = $f489ff3da7c10b03$var$embedStyleMap;
$f489ff3da7c10b03$export$3d6d846391b5780c = $f489ff3da7c10b03$var$readEmbeddedStyleMap;
function $f489ff3da7c10b03$var$convertToHtml(input, options) {
    return $f489ff3da7c10b03$var$convert(input, options);
}
function $f489ff3da7c10b03$var$convertToMarkdown(input, options) {
    var markdownOptions = Object.create(options || {});
    markdownOptions.outputFormat = "markdown";
    return $f489ff3da7c10b03$var$convert(input, markdownOptions);
}
function $f489ff3da7c10b03$var$convert(input, options) {
    options = $f489ff3da7c10b03$require$readOptions(options);
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $8adee3ad65dc46ae$export$98fd944a2c837b93(docxFile).then(function(styleMap) {
            options.embeddedStyleMap = styleMap;
        });
    }).then(function(docxFile) {
        return $bae7c73ea3cda3cb$export$aafa59e2e03f2942(docxFile, input, options).then(function(documentResult) {
            return documentResult.map(options.transformDocument);
        }).then(function(documentResult) {
            return $f489ff3da7c10b03$var$convertDocumentToHtml(documentResult, options);
        });
    });
}
function $f489ff3da7c10b03$var$readEmbeddedStyleMap(input) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).then($8adee3ad65dc46ae$export$98fd944a2c837b93);
}
function $f489ff3da7c10b03$var$convertDocumentToHtml(documentResult, options) {
    var styleMapResult = $f489ff3da7c10b03$var$parseStyleMap(options.readStyleMap());
    var parsedOptions = $5yjjJ.default({}, options, {
        styleMap: styleMapResult.value
    });
    var documentConverter = new $f489ff3da7c10b03$require$DocumentConverter(parsedOptions);
    return documentResult.flatMapThen(function(document) {
        return styleMapResult.flatMapThen(function(styleMap) {
            return documentConverter.convertToHtml(document);
        });
    });
}
function $f489ff3da7c10b03$var$parseStyleMap(styleMap) {
    return $f489ff3da7c10b03$require$Result.combine((styleMap || []).map($f489ff3da7c10b03$require$readStyle)).map(function(styleMap) {
        return styleMap.filter(function(styleMapping) {
            return !!styleMapping;
        });
    });
}
function $f489ff3da7c10b03$var$extractRawText(input) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).then($bae7c73ea3cda3cb$export$aafa59e2e03f2942).then(function(documentResult) {
        return documentResult.map($f489ff3da7c10b03$require$convertElementToRawText);
    });
}
function $f489ff3da7c10b03$var$embedStyleMap(input, styleMap) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $8adee3ad65dc46ae$export$f183c412da6b1c0(docxFile, styleMap);
    }).then(function(docxFile) {
        return docxFile.toArrayBuffer();
    }).then(function(arrayBuffer) {
        return {
            toArrayBuffer: function() {
                return arrayBuffer;
            },
            toBuffer: function() {
                return $f489ff3da7c10b03$require$Buffer.from(arrayBuffer);
            }
        };
    });
}
$f489ff3da7c10b03$export$65b53a1b2f72fd4c = function() {
    throw new Error('Use a raw string instead of mammoth.styleMapping e.g. "p[style-name=\'Title\'] => h1" instead of mammoth.styleMapping("p[style-name=\'Title\'] => h1")');
};


var $9fbb89d62e8a72ae$exports = {};
/*! @license DOMPurify 3.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.5/LICENSE */ (function(global, factory) {
    $9fbb89d62e8a72ae$exports = factory();
})($9fbb89d62e8a72ae$exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    const entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    let _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * Convert non-node values into strings without depending on direct property access.
   *
   * @param value - The value to stringify.
   * @returns A string representation of the provided value.
   */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'command',
        'commandfor',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        text: 3,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.5';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && arrayIsArray(cfg.ALLOWED_TAGS) ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && arrayIsArray(cfg.ALLOWED_ATTR) ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && arrayIsArray(cfg.ALLOWED_NAMESPACES) ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS) ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') && arrayIsArray(cfg.FORBID_TAGS) ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') && arrayIsArray(cfg.FORBID_ATTR) ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, [
                'mi',
                'mo',
                'mn',
                'ms',
                'mtext'
            ]); // Default built-in map
            HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, [
                'annotation-xml'
            ]); // Default built-in map
            const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
       * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
     * character data of an element subtree. Used as the final safety net for
     * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
     * which only form after text-node normalization (e.g. fragments split across
     * stripped elements) cannot survive into a template-evaluating framework.
     *
     * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
     * in place rather than round-tripping through innerHTML. This preserves
     * descendant node references (important for IN_PLACE callers), avoids a
     * serialize/reparse cycle, and reads literal character data — which means
     * `<%...%>` in text content matches the ERB regex against its real bytes
     * instead of the HTML-entity-escaped form innerHTML would produce.
     *
     * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
     * attributes is performed during the per-node `_sanitizeAttributes` pass.
     *
     * @param node The root element whose character data should be scrubbed.
     */ const _scrubTemplateExpressions = function _scrubTemplateExpressions(node) {
            node.normalize();
            const walker = createNodeIterator.call(node.ownerDocument || node, node, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                let data = currentNode.data;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    data = stringReplace(data, expr, ' ');
                });
                currentNode.data = data;
                currentNode = walker.nextNode();
            }
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node, including nodes that
     * originate from a different window/realm (e.g. an iframe's
     * contentDocument). The previous `value instanceof Node` check was
     * realm-bound: nodes from a different window failed it, causing
     * sanitize() to silently stringify them and reset IN_PLACE to false,
     * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
     *
     * Implementation: call the cached `nodeType` getter from Node.prototype
     * directly on the value. This bypasses any clobbered instance property
     * (e.g. a child element named "nodeType") and works across realms
     * because the WebIDL `nodeType` getter reads an internal slot that
     * every real Node has, regardless of which window minted it.
     *
     * @param value object to check whether it's a DOM node
     * @return true if value is a DOM node from any realm
     */ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return typeof getNodeType(value) === 'number';
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!nameIsPermitted || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
     * never be treated as basic custom elements even when a permissive
     * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR$1,
                    ERB_EXPR$1,
                    TMPLIT_EXPR$1
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
     * _sanitizeAttachedShadowRoots
     *
     * Walks `root` and feeds every attached shadow root we encounter into
     * the existing _sanitizeShadowDOM pipeline. The default node iterator
     * does not descend into shadow trees, so nodes inside an attached
     * shadow root would otherwise be skipped entirely.
     *
     * Two real input paths put attached shadow roots in front of us:
     *   1. IN_PLACE on a DOM node that already has shadow roots attached.
     *   2. DOM-node input where importNode(dirty, true) deep-clones the
     *      shadow root because it was created with `clonable: true`.
     *
     * This pass runs once, up front, so the main iteration loop (and the
     * existing _sanitizeShadowDOM template-content recursion) stay
     * untouched — string-input paths are not affected.
     *
     * @param root the subtree root to walk for attached shadow roots
     */ const _sanitizeAttachedShadowRoots2 = function _sanitizeAttachedShadowRoots(root) {
            if (root.nodeType === NODE_TYPE.element && root.shadowRoot instanceof DocumentFragment) {
                const sr = root.shadowRoot;
                // Recurse first so that nested shadow roots are reached even if
                // _sanitizeShadowDOM removes hosts at this level.
                _sanitizeAttachedShadowRoots2(sr);
                _sanitizeShadowDOM2(sr);
            }
            // Snapshot children before recursing. Sanitization of one subtree
            // (e.g. via an uponSanitizeShadowNode hook) may detach siblings,
            // and naive nextSibling traversal would silently skip the rest of
            // the list once a node is detached.
            const childNodes = root.childNodes;
            if (!childNodes) return;
            const snapshot = [];
            arrayForEach(childNodes, (child)=>{
                arrayPush(snapshot, child);
            });
            for (const child of snapshot)_sanitizeAttachedShadowRoots2(child);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) {
                /* Do some early pre-sanitization to avoid unsafe root nodes */ const nn = dirty.nodeName;
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
                /* Sanitize attached shadow roots before the main iterator runs.
           The iterator does not descend into shadow trees. */ _sanitizeAttachedShadowRoots2(dirty);
            } else if (_isNode(dirty)) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
                /* Clonable shadow roots are deep-cloned by importNode(); sanitize
           them before the main iterator runs, since the iterator does not
           descend into shadow trees. */ _sanitizeAttachedShadowRoots2(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions(dirty);
                return dirty;
            }
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR$1,
                ERB_EXPR$1,
                TMPLIT_EXPR$1
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


function $73cbf435bf470aed$var$sanitizeDocxHtml(html) {
    if (typeof html !== "string") return "";
    if (!$9fbb89d62e8a72ae$exports.isSupported) return "";
    return $9fbb89d62e8a72ae$exports.sanitize(html);
}
function $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html) {
    const safeHtml = $73cbf435bf470aed$var$sanitizeDocxHtml(html);
    const paint = ()=>{
        const el = document.getElementById(elementId);
        if (el) el.innerHTML = safeHtml;
    };
    requestAnimationFrame(()=>{
        requestAnimationFrame(paint);
    });
}
const $73cbf435bf470aed$var$DocxPreviewPort = {
    add: function(app) {
        if (app.ports.mountDocxHtml) app.ports.mountDocxHtml.subscribe(({ elementId: elementId, html: html })=>{
            if (elementId && typeof html === "string") $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html);
        });
        if (app.ports.clearDocxMount) app.ports.clearDocxMount.subscribe((elementId)=>{
            if (!elementId) return;
            const el = document.getElementById(elementId);
            if (el) el.replaceChildren();
        });
        if (app.ports.convertDocxFromUrl) app.ports.convertDocxFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            if (!app.ports.docxPreviewHtmlResult) return;
            const fail = ()=>app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: false,
                    html: null
                });
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    fail();
                    return;
                }
                const arrayBuffer = await res.arrayBuffer();
                const result = await $f489ff3da7c10b03$export$7b82ddf1ba8788ff({
                    arrayBuffer: arrayBuffer
                });
                const rawHtml = result.value || "";
                app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: true,
                    html: $73cbf435bf470aed$var$sanitizeDocxHtml(rawHtml)
                });
            } catch  {
                fail();
            }
        });
    }
};
$73cbf435bf470aed$exports = $73cbf435bf470aed$var$DocxPreviewPort;


var $78b00d0027f221e5$exports = {};
var $8f784678e653c95f$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $8f784678e653c95f$exports = t();
})($8f784678e653c95f$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


var $c5a62d48f5fefafb$exports = {};
/*! ExcelJS 19-10-2023 */ !function(e) {
    $c5a62d48f5fefafb$exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(e) {
                    return i(t[o][1][e] || e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "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"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


function $78b00d0027f221e5$var$parseDelimitedText(text) {
    const result = $8f784678e653c95f$exports.parse(text, {
        header: true,
        skipEmptyLines: "greedy",
        transform: (value)=>value == null ? "" : value
    });
    const fields = result.meta.fields;
    if (!fields || fields.length === 0) return {
        headers: [],
        rows: []
    };
    const headers = fields.map((field)=>String(field ?? "").trim());
    const rows = result.data.map((row)=>fields.map((field)=>String(row[field] ?? "")));
    return {
        headers: headers,
        rows: rows
    };
}
async function $78b00d0027f221e5$var$parseXlsxWorkbook(buffer) {
    const workbook = new $c5a62d48f5fefafb$exports.Workbook();
    await workbook.xlsx.load(buffer);
    const sheets = [];
    workbook.eachSheet((worksheet)=>{
        const matrix = [];
        let maxCols = 0;
        worksheet.eachRow((row)=>{
            const cells = [];
            row.eachCell({
                includeEmpty: true
            }, (cell)=>{
                cells.push(cell.text ?? "");
            });
            matrix.push(cells);
            maxCols = Math.max(maxCols, cells.length);
        });
        if (matrix.length === 0) {
            sheets.push({
                name: worksheet.name,
                headers: [],
                rows: []
            });
            return;
        }
        const padRow = (r)=>{
            const result = r.map((c)=>String(c ?? ""));
            while(result.length < maxCols)result.push("");
            return result;
        };
        const headers = padRow(matrix[0]).map((h)=>h.trim());
        const rows = matrix.slice(1).map(padRow);
        sheets.push({
            name: worksheet.name,
            headers: headers,
            rows: rows
        });
    });
    return sheets;
}
const $78b00d0027f221e5$var$SpreadsheetPreviewPort = {
    add: function(app) {
        if (!app.ports.requestSpreadsheetPreview || !app.ports.spreadsheetPreviewResult) return;
        app.ports.requestSpreadsheetPreview.subscribe(async ({ requestId: requestId, url: url, kind: kind })=>{
            const sendFail = ()=>{
                app.ports.spreadsheetPreviewResult.send({
                    requestId: requestId,
                    ok: false,
                    kind: kind
                });
            };
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                if (kind === "csv") {
                    const text = await res.text();
                    const grid = $78b00d0027f221e5$var$parseDelimitedText(text);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "csv",
                        grid: grid
                    });
                } else if (kind === "xlsx") {
                    const buffer = await res.arrayBuffer();
                    const sheets = await $78b00d0027f221e5$var$parseXlsxWorkbook(buffer);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "xlsx",
                        sheets: sheets
                    });
                } else sendFail();
            } catch  {
                sendFail();
            }
        });
    }
};
$78b00d0027f221e5$exports = $78b00d0027f221e5$var$SpreadsheetPreviewPort;


const $736c28728eccce35$var$sentryDsn = `https://${CONFIGURATION.sentryKey}@${CONFIGURATION.sentryOrganizationId}.ingest.sentry.io/${CONFIGURATION.sentryProjectId}`;
$776bdb0abf297828$export$2cd8252107eb640b({
    dsn: $736c28728eccce35$var$sentryDsn,
    environment: CONFIGURATION.sentryEnvironment,
    release: CONFIGURATION.sentryReleaseVersion,
    maxValueLength: 1000,
    ignoreErrors: [
        "Cannot resolve iframe with unknown index"
    ],
    denyUrls: [
        /extensions\//i
    ]
});
$6cb5f8bff4d365d9$exports.setExtra("api_version", CONFIGURATION.apiVersion);
// Initial data passed to Elm (should match `Flags` defined in `Shared.elm`)
// https://guide.elm-lang.org/interop/flags.html
var $736c28728eccce35$var$flags = {
    locationHref: location.href,
    accountToken: $36331f456e6baed0$exports.getItem("accountToken") || null,
    bustCacheRandom: Math.random().toString(36).slice(2),
    accountPracticeId: $f2086779cc7dd10e$exports.getItem("accountPracticeId"),
    apiUrl: CONFIGURATION.apiUrl,
    apiVersion: CONFIGURATION.apiVersion || null,
    emrNotesUrl: CONFIGURATION.emrNotesUrl,
    emrNotesVersion: CONFIGURATION.emrNotesVersion || null,
    emrCalendarsUrl: CONFIGURATION.emrCalendarsUrl,
    emrCalendarsVersion: CONFIGURATION.emrCalendarsVersion || null,
    emrMessagingUrl: CONFIGURATION.emrMessagingUrl,
    emrMessagingVersion: CONFIGURATION.emrMessagingVersion || null,
    release: CONFIGURATION.release || null,
    currentTime: new Date().getTime(),
    language: $f2086779cc7dd10e$exports.getItem("hint-language") || navigator.language,
    hintEnv: CONFIGURATION.hintEnv || null
};
// Start our Elm application
const $736c28728eccce35$var$app = (0, $b9e750d20bbc1f0f$exports.Elm).Main.init({
    node: document.getElementById("elm-main"),
    flags: $736c28728eccce35$var$flags
});
// Ports go here
// https://guide.elm-lang.org/interop/ports.html
$397bcf58b99e38b9$exports.add($736c28728eccce35$var$app);
$085e3b96bb7da772$exports.add($736c28728eccce35$var$app, CONFIGURATION.fullStoryOrgId);
$0d34a6c94bf1f37e$exports.add($736c28728eccce35$var$app, CONFIGURATION.googleMapsKey);
$44d2ba25a7bfecb2$exports.add($736c28728eccce35$var$app);
$f2086779cc7dd10e$exports.add($736c28728eccce35$var$app);
$1e586fe0a96f962b$exports.add($736c28728eccce35$var$app);
$3cef90824005e2d6$exports.add($736c28728eccce35$var$app, CONFIGURATION.env);
$d5d5137484b98c41$exports.add($736c28728eccce35$var$app, CONFIGURATION.stripePublishableKey);
$b78de99e3cb6b90b$exports.add($736c28728eccce35$var$app);
$72eb1b7e8424fce8$exports.add($736c28728eccce35$var$app);
$f4b7f13ee09e6363$exports.add($736c28728eccce35$var$app);
$53030c4d0d659628$exports.add($736c28728eccce35$var$app);
$88841e90a30ba512$exports.add($736c28728eccce35$var$app);
$13a1730e1cbf1cc4$exports.add($736c28728eccce35$var$app);
$b28e419d9143a3c3$exports.add($736c28728eccce35$var$app);
$f2c7c3c854a3894f$exports.add($736c28728eccce35$var$app, CONFIGURATION.intercomAppId);
$15ca76013f461cc0$exports.add($736c28728eccce35$var$app);
$d13a3aa875c41ca7$exports.add($736c28728eccce35$var$app);
$d2be32b72d8b955d$exports.add($736c28728eccce35$var$app);
$a8ede6276a337434$exports.initFileSelection($736c28728eccce35$var$app);
$70bed06a98643566$exports.add($736c28728eccce35$var$app);
$ba7a6a20ab3b4d24$exports.add($736c28728eccce35$var$app);
$36331f456e6baed0$exports.add($736c28728eccce35$var$app);
$3b9526d384f0dd3d$exports.add($736c28728eccce35$var$app);
$8e7e1145409c40a4$exports.add($736c28728eccce35$var$app);
$5ce5aeca99e3b2a2$exports.add($736c28728eccce35$var$app);
$73cbf435bf470aed$exports.add($736c28728eccce35$var$app);
$78b00d0027f221e5$exports.add($736c28728eccce35$var$app);
(0, $5b09ccb12fff0951$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
(0, $b25dfe2ee2c25921$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
if (CONFIGURATION.statuspageEmbedCode) window.setupStatusPage(CONFIGURATION.statuspageEmbedCode);
if (CONFIGURATION.newRelicAccountId && CONFIGURATION.newRelicLicenseKey && CONFIGURATION.newRelicApplicationId && typeof setupNewRelic !== "undefined") setupNewRelic(CONFIGURATION.newRelicAccountId, CONFIGURATION.newRelicLicenseKey, CONFIGURATION.newRelicApplicationId);
// detect if device is an iOS device and disable auto-zoom when clicking into elements
// https://stackoverflow.com/a/57527009
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    const el = document.querySelector("meta[name=viewport]");
    if (el !== null) {
        let content = el.getAttribute("content");
        let re = /maximum-scale=[0-9.]+/g;
        if (re.test(content)) content = content.replace(re, "maximum-scale=1.0");
        else content = [
            content,
            "maximum-scale=1.0"
        ].join(", ");
        el.setAttribute("content", content);
    }
}


//# sourceMappingURL=member-portal-elm.0265450a.js.map
